'use strict';

//DATE OBJECT
Date.prototype.getStartOfQuarter = function() {
    return new Date((Math.floor(this.getMonth( )/3)*3)+1 + "/1/" + this.getFullYear( ));
};

Date.prototype.getPriorWorkday = function() {
    return new Date(this.rewind({day: 1}).isWeekend() ? this.rewind({week: 1}).setWeekday(5) : this);
};

Date.prototype.formatted = function(includeTime) {
    return includeTime ? this.format('{MM}/{dd}/{yyyy} {12hr}:{mm}:{ss} {TT}') : this.format('{MM}/{dd}/{yyyy}');
};

Date.prototype.serverFormatted = function() {
    return this.getHours() + this.getMinutes() + this.getSeconds() > 0 ? this.format('{MM}/{dd}/{yyyy} {HH}:{mm}:{ss}') : this.format('{MM}/{dd}/{yyyy}')
};

//NUMBER OBJECT
//TODO: will be Sugar.extend(number, methods) in future release
Number.extend({
    'almostEquals': function(val) {
        if (this == val) return true;
        var diff = Math.abs(this - val);
        if (diff < 4.94065645841247E-320) return true;
        var a = Math.abs(this);
        var b = Math.abs(val);
        var smallest = (b < a) ? b : a;
        return diff < smallest * 1e-12;
    }
});

//ARRAY OBJECT
//TODO: will be Sugar.extend(array, methods) in future release
Array.extend({
    fnFind: function(predicate) {
        if (this == null) {
            throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        var len = o.length >>> 0;

        if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
        }

        var thisArg = arguments[1];

        var k = 0;

        while (k < len) {
            var kValue = o[k];
            if (predicate.call(thisArg, kValue, k, o)) {
                return kValue;
            }
            k++;
        }

        return undefined;
    },
    groupOn: function(groupingField, sortGroups) {
        var groups = [];

        this.forEach(function (item) {
            var existingGroup = groups.find({name: item[groupingField]});
            if (existingGroup) {
                existingGroup.items.push(item);
            } else {
                groups.push({name: item[groupingField], items: [item]});
            }
        });

        return sortGroups ? groups.sortBy("name") : groups;
    },
    isModified: function() {
        return this.any(function(item){
            return angular.isFunction(item.isModified) && item.isModified() == true;
        })
    },
    updateAll: function(data) {
        this.each(function(i){angular.extend(i, data)});
        return this;
    }
});

// OBJECT OBJECT
Object.extend({
    setValue: function(object, path, value) {
        var a = path.split('.');
        var o = object;
        for (var i = 0; i < a.length - 1; i++) {
            var n = a[i];
            if (n in o) {
                o = o[n];
            } else {
                o[n] = {};
                o = o[n];
            }
        }
        o[a[a.length - 1]] = value;
        return object;
    },
    getValue: function(object, path) {
        var o = object;
        path = path.replace(/\[(\w+)\]/g, '.$1');
        path = path.replace(/^\./, '');
        var a = path.split('.');
        while (a.length) {
            var n = a.shift();
            if (n in o) {
                o = o[n];
            } else {
                return;
            }
        }
        return o;
    }
});

//STRING OBJECT
//TODO: will be Sugar.extend(string, methods) in future release
String.extend({
    'stripResolves': function() {
        return this.replace(/\[@{.*?"name":"(.+?)".*?}@]/gi, '$1');
    }
});

//  Updated Sugar accounts for this, remove when updating.
Object.fromQueryString = function(str) {
    var pairs = {};
    str.split('&').each(function (item) {
        var kv = item.split('=');
        if (kv[1] !== undefined) {
            if (!pairs[kv[0]])
                pairs[kv[0]] = [];
            pairs[kv[0]].add(kv[1]);
        }
    });
    return pairs;
};

//This fixes a conflict between sugar.js and Angular 8
Object.toQueryString = function(obj, namespace) {
    //prevent nulls for obj
    obj = obj === null ? {} : obj;

    return objectToQueryString(namespace, obj);

    // isDate
    // Returns true if the object passed is a date object
    function isDate(obj){
        return  Object.prototype.toString.call(obj) === '[object Date]';
    }

    // sanitizeURIComponent
    // undefined, null, and NaN are represented as a blank string,
    // while false and 0 are stringified. "+" is allowed in query string
    function sanitizeURIComponent(obj) {
        return !obj && obj !== false && obj !== 0 ? '' : encodeURIComponent(obj).replace(/%20/g, '+');
    }

    function objectToQueryString(base, obj){
        if(Array.isArray(obj) || (typeof obj === 'object' && obj.toString() === Object.prototype.toString())){
            var tmp = [];
            Object.keys(obj, function(key){
                let value =  obj[key];
                if(base) key = base + '['+key+']';
                tmp.push(objectToQueryString(key,value));
            });
            return tmp.join('&');
        }
        return !base? '' : sanitizeURIComponent(base)+'='+ (isDate(obj) ? obj.getTime() : sanitizeURIComponent(obj));
    }
};

Object.appendToQueryString = function (uri, params) {
    return `${uri}${uri.has('?') ? '&' : '?'}${Object.toQueryString(params)}`;                
};

//WINDOW OBJECT
window.oas = {
    utils: {
        isMobileOrTablet: function checkDevice() {
            var check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
            return check;
        },
        generateGuid: function uuidv4() {
            var crypto = window.crypto || window.msCrypto;
            if (crypto && crypto.randomUUID) {
                return crypto.randomUUID();
            }
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = crypto.getRandomValues(new Uint8Array(1))[0] % 16, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        openSupportArticle: function showArticle(a){
            let token = sessionStorage.oas_token;
            if(token && token !== ""){
                window.open(window.location.protocol + "//" + window.location.host + "/orionconnectapp/sso.html?s=support&p=" + encodeURIComponent("/s/article/" + a) + "&t=" + token)
            } else {
                console && console.error("Can't open support article: Token not found")
            }

        }
    }
};
//requires sugar.js
function HotKeys(actions){
    var self = this;
    this.element = document.body;
    this.actions = Array.isArray(actions) ? actions : [];
    this.character = '';
    this.comboKeys = [8,16,17,18,91,93,112,113,114,115,116,117,118,119,120,121,122,123,224];
    this.ignoreKeys = [9,20,27,33,34,35,36,37,38,39,40,45,46,144];

    this.handleEvent = function(e) {
        if (typeof e.which !== 'number')
            e.which = e.keyCode;
        if (self.comboKeys.some(e.which) || self.ignoreKeys.some(e.which))//ignore when just the combo key or a special key to ignore
            return;
        if (self.character !== String.fromCharCode(e.which).toLocaleLowerCase()) {
            self.character = String.fromCharCode(e.which).toLocaleLowerCase();
            var filteredActions = self.actions.findAll(self.matchAction(e));
            if (filteredActions && filteredActions.length > 0) {
                e.preventDefault(); //stop event from bubbling up
                filteredActions.each(function(action){ action.command(); });
            }
            else return;
        } else { e.preventDefault(); }
    };

    this.clearEvent = function(e) { self.character = ''; };

    this.matchAction = function(e){
        return function(action) {
            var comboParts = action.combo.toLocaleLowerCase().split('+');
            var partCount = 0;
            partCount += (e.shiftKey && comboParts.some('shift')) ? 1 : 0;
            partCount += (e.altKey && comboParts.some('alt')) ? 1 : 0;
            partCount += (e.ctrlKey && comboParts.some('ctrl')) ? 1 : 0;
            partCount += (e.which === 13 && comboParts.some('enter')) ? 1 : 0;
            partCount += comboParts.some(self.character.toLocaleLowerCase()) ? 1 : 0;
            return comboParts.length === partCount;
        }
    };

    if (this.element.addEventListener) {
        this.element.addEventListener("keydown", this.handleEvent, false);
        this.element.addEventListener("keyup", this.clearEvent, false);
    } else { //attachevent code is for legacy browsers
        this.element.attachEvent("onkeydown", this.handleEvent);
        this.element.attachEvent("onkeyup", this.clearEvent);
    }
}

HotKeys.prototype.addActions = function(action) {
    this.actions.add(action);
};
HotKeys.prototype.removeAction = function(action) {
    this.actions.remove(action);
};
HotKeys.prototype.clearActions = function() {
    this.actions = [];
};
HotKeys.prototype.destroy = function(){
    if (this.element.addEventListener) {
        this.element.removeEventListener("keydown", this.handleEvent, false);
        this.element.removeEventListener("keyup", this.clearEvent, false);
    } else { //detachevent code is for legacy browsers
        this.element.detachEvent("onkeydown", this.handleEvent);
        this.element.detachEvent("onkeyup", this.clearEvent);
    }
    this.clearActions();
};
//JBT - added toUpperCase() to the toHex() method
'use strict';

angular.module('colorpicker.module', [])
    .factory('helper', function () {
        return {
            closest: function (elem, selector) {
                var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
                while (elem) {
                    if (matchesSelector.bind(elem)(selector)) {
                        return elem;
                    } else {
                        elem = elem.parentNode;
                    }
                }
                return false;
            },
            getOffset: function (el) {
                return $(el).offset();
                /* The original code does not correctly calculate offset
                var
                    _x = 0,
                    _y = 0;
                while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
                    _x += el.offsetLeft + el.scrollLeft;
                    _y += el.offsetTop + el.scrollTop;
                    el = el.offsetParent;
                }
                return {
                    top: _y,
                    left: _x
                };*/
            },
            extend: function () {
                for (var i = 1; i < arguments.length; i++) {
                    for (var key in arguments[i]) {
                        if (arguments[i].hasOwnProperty(key)) {
                            arguments[0][key] = arguments[i][key];
                        }
                    }
                }
                return arguments[0];
            },
            // a set of RE's that can match strings and generate color tuples. https://github.com/jquery/jquery-color/
            stringParsers: [
                {
                    re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
                    parse: function (execResult) {
                        return [
                            execResult[1],
                            execResult[2],
                            execResult[3],
                            execResult[4]
                        ];
                    }
                },
                {
                    re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
                    parse: function (execResult) {
                        return [
                            2.55 * execResult[1],
                            2.55 * execResult[2],
                            2.55 * execResult[3],
                            execResult[4]
                        ];
                    }
                },
                {
                    re: /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
                    parse: function (execResult) {
                        return [
                            parseInt(execResult[1], 16),
                            parseInt(execResult[2], 16),
                            parseInt(execResult[3], 16)
                        ];
                    }
                },
                {
                    re: /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,
                    parse: function (execResult) {
                        return [
                            parseInt(execResult[1] + execResult[1], 16),
                            parseInt(execResult[2] + execResult[2], 16),
                            parseInt(execResult[3] + execResult[3], 16)
                        ];
                    }
                }
            ]
        }
    })
    .factory('Color', ['helper', function (helper) {
        return {
            value: {
                h: 1,
                s: 1,
                b: 1,
                a: 1
            },
            // translate a format from Color object to a string
            'rgb': function () {
                var rgb = this.toRGB();
                return 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')';
            },
            'rgba': function () {
                var rgb = this.toRGB();
                return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')';
            },
            'hex': function () {
                return  this.toHex();
            },

            // HSBtoRGB from RaphaelJS
            RGBtoHSB: function (r, g, b, a) {
                r /= 255;
                g /= 255;
                b /= 255;

                var H, S, V, C;
                V = Math.max(r, g, b);
                C = V - Math.min(r, g, b);
                H = (C === 0 ? null :
                    V == r ? (g - b) / C :
                        V == g ? (b - r) / C + 2 :
                            (r - g) / C + 4
                    );
                H = ((H + 360) % 6) * 60 / 360;
                S = C === 0 ? 0 : C / V;
                return {h: H || 1, s: S, b: V, a: a || 1};
            },

            HueToRGB: function (p, q, h) {
                if (h < 0)
                    h += 1;
                else if (h > 1)
                    h -= 1;

                if ((h * 6) < 1)
                    return p + (q - p) * h * 6;
                else if ((h * 2) < 1)
                    return q;
                else if ((h * 3) < 2)
                    return p + (q - p) * ((2 / 3) - h) * 6;
                else
                    return p;
            },

            //parse a string to HSB
            setColor: function (val) {
                if (!val) return false;
                val = val.toLowerCase();

                for (var key in helper.stringParsers) {
                    var parser = helper.stringParsers[key];
                    var match = parser.re.exec(val),
                        values = match && parser.parse(match),
                        space = parser.space || 'rgba';
                    if (values) {
                        this.value = this.RGBtoHSB.apply(null, values);
                        return false;
                    }
                }
            },

            setHue: function (h) {
                this.value.h = 1 - h;
            },

            setSaturation: function (s) {
                this.value.s = s;
            },

            setLightness: function (b) {
                this.value.b = 1 - b;
            },

            setAlpha: function (a) {
                this.value.a = parseInt((1 - a) * 100, 10) / 100;
            },

            // HSBtoRGB from RaphaelJS
            // https://github.com/DmitryBaranovskiy/raphael/
            toRGB: function (h, s, b, a) {
                if (!h) {
                    h = this.value.h;
                    s = this.value.s;
                    b = this.value.b;
                }
                h *= 360;
                var R, G, B, X, C;
                h = (h % 360) / 60;
                C = b * s;
                X = C * (1 - Math.abs(h % 2 - 1));
                R = G = B = b - C;

                h = ~~h;
                R += [C, X, 0, 0, X, C][h];
                G += [X, C, C, X, 0, 0][h];
                B += [0, 0, X, C, C, X][h];
                return {
                    r: Math.round(R * 255),
                    g: Math.round(G * 255),
                    b: Math.round(B * 255),
                    a: a || this.value.a
                };
            },

            toHex: function (h, s, b, a) {
                var rgb = this.toRGB(h, s, b, a);
                return '#' + ((1 << 24) | (parseInt(rgb.r) << 16) | (parseInt(rgb.g) << 8) | parseInt(rgb.b)).toString(16).substr(1).toUpperCase();
            }
        }
    }])
    .directive('colorpicker', ['$document', '$compile', 'Color', 'helper', 'ZIndexCalculationService', function ($document, $compile, Color, helper, ZIndexCalculationService) {
        return {
            require: '?ngModel',
            restrict: 'A',
            link: function ($scope, elem, attrs, ngModel) {

                var
                    template = '<div class="colorpicker dropdown-menu">' +
                        '<div class="colorpicker-saturation"><i><b></b></i></div>' +
                        '<div class="colorpicker-hue"><i></i></div>' +
                        '<div class="colorpicker-alpha"><i></i></div>' +
                        '<div class="colorpicker-color"><div /></div>' +
                        '</div>',
                    colorpickerTemplate = angular.element(template),
                    pickerColor = Color,
                    pickerColorPreview,
                    pickerColorAlpha,
                    pickerColorBase,
                    pickerColorPointers,
                    pointer = null,
                    slider = null;

                var thisFormat = attrs.colorpicker ? attrs.colorpicker : 'hex';

                $compile(colorpickerTemplate)($scope);

                pickerColorAlpha = {
                    enabled: thisFormat === 'rgba',
                    css: null
                };

                if (pickerColorAlpha.enabled === true) {
                    colorpickerTemplate.addClass('alpha');
                    pickerColorAlpha.css = colorpickerTemplate.find('div')[2].style;
                }

                angular.element(document.body).append(colorpickerTemplate);

                if(ngModel) {
                    ngModel.$render = function () {
                        elem.val(ngModel.$viewValue);
                    };
                    $scope.$watch(attrs.ngModel, function() {
                        update();
                    });
                }

                elem.on('$destroy', function() {
                    colorpickerTemplate.remove();
                });

                pickerColorBase = colorpickerTemplate.find('div')[0].style;
                pickerColorPreview = colorpickerTemplate.find('div')[4].style;
                pickerColorPointers = colorpickerTemplate.find('i');

                var previewColor = function () {
                    try {
                        pickerColorPreview.backgroundColor = pickerColor[thisFormat]();
                    } catch (e) {
                        pickerColorPreview.backgroundColor = pickerColor.toHex();
                    }
                    pickerColorBase.backgroundColor = pickerColor.toHex(pickerColor.value.h, 1, 1, 1);
                    if (pickerColorAlpha.enabled === true) {
                        pickerColorAlpha.css.backgroundColor = pickerColor.toHex();
                    }
                };

                var slidersUpdate = function (event) {
                    event.stopPropagation();
                    event.preventDefault();

                    var zone = helper.closest(event.target, 'div');

                    if (zone.className === 'colorpicker-saturation') {
                        slider = helper.extend({}, {
                            maxLeft: 100,
                            maxTop: 100,
                            callLeft: 'setSaturation',
                            callTop: 'setLightness'
                        });
                    }
                    else if (zone.className === 'colorpicker-hue') {
                        slider = helper.extend({}, {
                            maxLeft: 0,
                            maxTop: 100,
                            callLeft: false,
                            callTop: 'setHue'
                        });
                    }
                    else if (zone.className === 'colorpicker-alpha') {
                        slider = helper.extend({}, {
                            maxLeft: 0,
                            maxTop: 100,
                            callLeft: false,
                            callTop: 'setAlpha'
                        });
                    } else {
                        return false;
                    }
                    slider.knob = zone.children[0].style;
                    slider.left = event.pageX - helper.getOffset(zone).left;
                    slider.top = event.pageY - helper.getOffset(zone).top;
                    pointer = {
                        left: event.pageX,
                        top: event.pageY
                    };
                };

                var mousemove = function (event) {
                    var left = Math.max(
                        0,
                        Math.min(
                            slider.maxLeft,
                            slider.left + ((event.pageX || pointer.left) - pointer.left)
                        )
                    );

                    var top = Math.max(
                        0,
                        Math.min(
                            slider.maxTop,
                            slider.top + ((event.pageY || pointer.top) - pointer.top)
                        )
                    );

                    slider.knob.left = left + 'px';
                    slider.knob.top = top + 'px';
                    if (slider.callLeft) {
                        pickerColor[slider.callLeft].call(pickerColor, left / 100);
                    }
                    if (slider.callTop) {
                        pickerColor[slider.callTop].call(pickerColor, top / 100);
                    }
                    previewColor();
                    var newColor = pickerColor[thisFormat]();
                    elem.val(newColor);
                    if(ngModel) {
                        $scope.$apply(ngModel.$setViewValue(newColor));
                    }
                    return false;
                };

                var mouseup = function () {
                    $document.off('mousemove', mousemove);
                    $document.off('mouseup', mouseup);
                };

                var update = function () {
                    pickerColor.setColor(elem.val());
                    pickerColorPointers.eq(0).css({
                        left: pickerColor.value.s * 100 + 'px',
                        top: 100 - pickerColor.value.b * 100 + 'px'
                    });
                    pickerColorPointers.eq(1).css('top', 100 * (1 - pickerColor.value.h) + 'px');
                    pickerColorPointers.eq(2).css('top', 100 * (1 - pickerColor.value.a) + 'px');
                    previewColor();
                };

                elem.on('click', function () {
                    update();
                    colorpickerTemplate
                        .addClass('colorpicker-visible')
                        .css({
                            'top': helper.getOffset(elem[0]).top + elem[0].offsetHeight - document.body.scrollTop + 'px',
                            'left': helper.getOffset(elem[0]).left - document.body.scrollLeft + 'px',
                            'z-index': angular.isDefined(attrs.colorpickerZindexFromParent) ?  ZIndexCalculationService.getFirstSetZIndex(elem[0]) : 1100
                        });
                });

                colorpickerTemplate.on('mousedown', function (event) {
                    event.stopPropagation();
                    event.preventDefault();
                });

                colorpickerTemplate.find('div').on('click', function (event) {
                    slidersUpdate(event);
                    mousemove(event);
                });

                colorpickerTemplate.find('div').on('mousedown', function (event) {
                    slidersUpdate(event);
                    $document.on('mousemove', mousemove);
                    $document.on('mouseup', mouseup);
                });

                $document.on('mousedown', function () {
                    if (colorpickerTemplate.hasClass('colorpicker-visible')) {
                        colorpickerTemplate.removeClass('colorpicker-visible');
                    }
                });
            }
        };
    }]);

/*
 * NOTE THIS IS A HIGHLY MODIFIED VERSION OF THE REPO LISTED BELOW - Josh
 *
 * angular-table-resize
 * https://github.com/tympanix/angular-table-resize
 */
angular.module("rzTable", []);

angular.module("rzTable").directive('rzTable', ['$injector', '$parse', function ($injector, $parse) {

    function getMinWidth(column) {
        // "25px" -> 25
        return parseInt($(column).css('min-width')) || 0;
    }

    function getColumns(table) {
        var t = $(table);
        var th = t.find('>thead>tr:first>th,>thead>tr:first>td');

        if (!th.length) {
            th = t.find('>tbody>tr:first>th,>tr:first>th,>tbody>tr:first>td,>tr:first>td');
        }

        return th;
    }

    return {
        restrict: 'A',
        scope: {
            mode: '=rzMode',
            options: '=?rzOptions',
            api: '=rzApi',
            container: '@rzContainer'
        },
        link: function rzTableLinkFn(scope, element, attr) {
            //PRIVATE VARIABLES
            var table = element;
            var container = scope.container ? $(scope.container) : $(table).parent();
            var columns = null;
            var listener = null;
            var handles = [];
            var resizer = null;
            var isFirstDrag = true;


            //PRIVATE METHODS
            function initializeAll() {
                // Get all column headers
                columns = getColumns(table);

                columns.addClass('rz-cell');

                var ResizeModel = $injector.get(scope.mode || 'BasicResizer');
                resizer = new ResizeModel(table, columns, container, scope.options);

                resizer.setup();

                // Initialise all handlers for every column
                resizer.handleColumns.each(function(index, column) {
                    // Prepend a new handle div to the column
                    var handle = $('<div>', {
                        class: scope.options.handleClass || 'rz-handle'
                    });
                    $(column).prepend(handle);

                    // Add handles to handles for later removal
                    handles.push(handle);

                    // Use the middleware to decide which columns this handle controls
                    var controlledColumn = resizer.handleMiddleware(handle, column);

                    // Bind mousedown, mousemove & mouseup events
                    bindEventToHandle(handle, controlledColumn);
                })
            }

            function bindEventToHandle(handle, column) {

                // This event starts the dragging
                $(handle).on("mousedown", function(event) {
                    if (isFirstDrag) {
                        resizer.onFirstDrag(column, handle);
                        resizer.onTableReady();
                        isFirstDrag = false;
                    }

                    scope.options.onResizeStarted && scope.options.onResizeStarted(column);

                    var optional = {};
                    if (resizer.intervene) {
                        optional = resizer.intervene.selector(column);
                        optional.column = optional;
                        optional.orgWidth = $(optional).width();
                    }

                    // Prevent text-selection, object dragging ect.
                    event.preventDefault();

                    // Change css styles for the handle
                    $(handle).addClass(scope.options.handleClassActive || 'rz-handle-active');

                    // Get mouse and column origin measurements
                    var orgX = event.clientX;
                    var orgWidth = $(column).width();

                    // On every mouse move, calculate the new width
                    listener = calculateWidthEvent(column, orgX, orgWidth, optional);
                    $(window).on("mousemove", listener);

                    // Stop dragging as soon as the mouse is released
                    $(window).one('mouseup', unbindEvent(column, handle));
                })
            }

            function calculateWidthEvent(column, orgX, orgWidth, optional) {
                return function(event) {
                    // Get current mouse position
                    var newX = event.clientX;

                    // Use calculator function to calculate new width
                    var diffX = newX - orgX;
                    var newWidth = resizer.calculate(orgWidth, diffX);

                    if (newWidth < getMinWidth(column)) return;
                    if (resizer.restrict(newWidth, diffX)) return;

                    // Extra optional column
                    if (resizer.intervene){
                        var optWidth = resizer.intervene.calculator(optional.orgWidth, diffX);
                        if (optWidth < getMinWidth(optional.column)) return;
                        if (resizer.intervene.restrict(optWidth, diffX)) return;
                        $(optional.column).width(optWidth)
                    }

                    scope.options.onResizeInProgress && scope.options.onResizeInProgress(column, newWidth, diffX);

                    // Set size
                    $(column).width(newWidth);
                }
            }

            function unbindEvent(column, handle) {
                // Event called at end of drag
                return function( /*event*/ ) {
                    $(handle).removeClass(scope.options.handleClassActive || 'rz-handle-active');

                    if (listener) {
                        $(window).off('mousemove', listener);
                    }

                    resizer.onEndDrag(column);

                    scope.options.onResizeEnded && scope.options.onResizeEnded(column);
                }
            }

            function bindUtilityFunctions() {
                if (!attr.rzApi) return;

                var model = $parse(attr.rzApi);
                model.assign(scope.$parent, {
                    update: function() {
                        cleanUpAll();
                        initializeAll();
                    },
                    reset: function() {
                        $(table).outerWidth('100%');
                        getColumns(table).width('auto');

                        this.update();
                    },
                    getWidths: function () {
                        this.update();

                        var widths = [];
                        $(columns).each(function (index, column) {
                            widths.push(resizer.saveAttr(column));
                        });

                        return widths;
                    }
                });
            }

            function cleanUpAll() {
                if (!columns) return;

                columns.removeClass('rz-cell');
                isFirstDrag = true;

                handles.map(function(h) { h.remove() });
                handles = [];
            }


            //INITIALIZE
            scope.options = scope.options || {};

            // Add css styling/properties to table
            $(table).addClass(scope.options.tableClass || 'rz-table');

            if (!scope.options.manualInit) {
                initializeAll();
            }

            bindUtilityFunctions();


            //SCOPE WATCHERS
            // scope.$watch(function () {return getColumns(table).length;}, function (oldVal, newVal) {
            //     if (newVal === undefined || newVal === oldVal) return;
            //
            //     cleanUpAll();
            //     initializeAll();
            // });
        }
    };
}]);

angular.module("rzTable").factory("ResizerModel", [function() {

    function ResizerModel(table, columns, container, options){
        this.table = table;
        this.columns = columns;
        this.container = container;
        this.options = options;

        this.handleColumns = this.handles();
        this.ctrlColumns = this.ctrlColumns();
    }

    ResizerModel.prototype.roundToPrecision = function(num){
        if(this.options && this.options.precision !== undefined) {
            const adj = Math.pow(10, this.options.precision);
            return Math.round(num * adj) / adj;
        }
        return num;
    };

    ResizerModel.prototype.setup = function() {
        // Hide overflow by default
        $(this.container).css({
            //overflowX: 'hidden'
        })
    };

    ResizerModel.prototype.onTableReady = function () {
        // Table is by default 100% width
        $(this.table).outerWidth('100%');
    };

    ResizerModel.prototype.getMinWidth = function(column) {
        // "25px" -> 25
        return parseInt($(column).css('min-width')) || 0;
    };

    ResizerModel.prototype.handles = function () {
        // By default all columns should be assigned a handle
        return this.columns;
    };

    ResizerModel.prototype.ctrlColumns = function () {
        // By default all columns assigned a handle are resized
        return this.handleColumns;
    };

    ResizerModel.prototype.onFirstDrag = function () {
        // By default, set all columns to absolute widths
        $(this.ctrlColumns).each(function(index, column) {
            $(column).width($(column).width());
        })
    };

    ResizerModel.prototype.handleMiddleware = function (handle, column) {
        // By default, every handle controls the column it is placed in
        return column;
    };

    ResizerModel.prototype.restrict = function (newWidth) {
        return false;
    };

    ResizerModel.prototype.calculate = function (orgWidth, diffX) {
        // By default, simply add the width difference to the original
        return orgWidth + diffX;
    };

    ResizerModel.prototype.onEndDrag = function () {
        // By default, do nothing when dragging a column ends
        return;
    };

    ResizerModel.prototype.saveAttr = function (column) {
        return $(column).outerWidth();
    };

    return ResizerModel;
}]);

angular.module("rzTable").factory("BasicResizer", ["ResizerModel", function(ResizerModel) {

    function BasicResizer(table, columns, container, options) {
        // Call super constructor
        ResizerModel.call(this, table, columns, container, options);

        // All columns are controlled in basic mode
        this.ctrlColumns = this.columns;

        this.intervene = {
            selector: interveneSelector,
            calculator: interveneCalculator,
            restrict: interveneRestrict
        }
    }

    // Inherit by prototypal inheritance
    BasicResizer.prototype = Object.create(ResizerModel.prototype);

    function interveneSelector(column) {
        return $(column).next()
    }

    function interveneCalculator(orgWidth, diffX) {
        return orgWidth - diffX;
    }

    function interveneRestrict(newWidth){
        return newWidth < 25;
    }

    BasicResizer.prototype.setup = function() {
        // Hide overflow in mode fixed
        $(this.container).css({
            //overflowX: 'hidden'
        });

        $(this.table).css({
            width: '100%'
        })
    };

    BasicResizer.prototype.handles = function() {
        // Mode fixed does not require handler on last column
        return $(this.columns).not(':last')
    };

    BasicResizer.prototype.onFirstDrag = function(column, handle) {
        // Replace all column's width with absolute measurements
        this.onEndDrag(column);
    };

    BasicResizer.prototype.onEndDrag = function (column) {
        // Calculates the percent width of each column
        var resizer = this;
        var totWidth = $(this.table).outerWidth();
        var totWidthPercent = 0;

        var callbacks = [];
        // Calculate the width of every column
        $(this.columns).each(function (index, column) {
            var colWidth = $(column).outerWidth();

            var percentWidth = resizer.roundToPrecision(colWidth / totWidth * 100);
            totWidthPercent += percentWidth;

            callbacks.push({
                column: column,
                width: percentWidth
            });
        });

        const cellIndex = column === undefined ? 0 : column.cellIndex;
        //the column total isn't exactly 100, so adjust the column being dragged (or the first column) to make up the difference
        if (totWidthPercent !== 100) {
            callbacks[cellIndex].width = resizer.roundToPrecision(100 - totWidthPercent + callbacks[cellIndex].width);
            //console.log('adjusted '+ cellIndex + ' by ' + (100 - totWidthPercent));
        }

        if (column === undefined) {
            // Apply the calculated width of every column
            callbacks.map(function (cb) {
                $(cb.column).css({width: cb.width + '%'});
            });
        } else {
            //only adjust the 2 columns around the column being dragged
            for (let i = cellIndex; i <= cellIndex + 1; i++) {
                const cb = callbacks[i];
                $(cb.column).css({width: cb.width + '%'});
            }
        }
    };

    BasicResizer.prototype.saveAttr = function (column) {
        return $(column)[0].style.width;
    };

    // Return constructor
    return BasicResizer;

}]);

angular.module("rzTable").factory("FixedResizer", ["ResizerModel", function(ResizerModel) {

    function FixedResizer(table, columns, container) {
        // Call super constructor
        ResizerModel.call(this, table, columns, container);

        this.fixedColumn = $(table).find('th').first();
        this.bound = false;
    }

    // Inherit by prototypal inheritance
    FixedResizer.prototype = Object.create(ResizerModel.prototype);

    FixedResizer.prototype.setup = function() {
        // Hide overflow in mode fixed
        $(this.container).css({
            //overflowX: 'hidden'
        });

        $(this.table).css({
            width: '100%'
        });

        // First column is auto to compensate for 100% table width
        $(this.columns).first().css({
            width: 'auto'
        });
    };

    FixedResizer.prototype.handles = function() {
        // Mode fixed does not require handler on last column
        return $(this.columns).not(':last')
    };

    FixedResizer.prototype.ctrlColumns = function() {
        // In mode fixed, all but the first column should be resized
        return $(this.columns).not(':first');
    };

    FixedResizer.prototype.onFirstDrag = function() {
        // Replace each column's width with absolute measurements
        $(this.ctrlColumns).each(function(index, column) {
            $(column).width($(column).width());
        })
    };

    FixedResizer.prototype.handleMiddleware = function (handle, column) {
        // Fixed mode handles always controll next neightbour column
        return $(column).next();
    };

    FixedResizer.prototype.restrict = function (newWidth, diffX) {
        if (this.bound && this.bound < diffX) {
            this.bound = false;
            return false;
        } if (this.bound && this.bound > diffX) {
            return true;
        } else if (this.fixedColumn.width() <= this.getMinWidth(this.fixedColumn)) {
            this.bound = diffX;
            $(this.fixedColumn).width(this.minWidth);
            return true;
        }
    };

    FixedResizer.prototype.onEndDrag = function () {
        this.bound = false;
    };

    FixedResizer.prototype.calculate = function (orgWidth, diffX) {
        // Subtract difference - neightbour grows
        return orgWidth - diffX;
    };

    // Return constructor
    return FixedResizer;

}]);

angular.module("rzTable").factory("OverflowResizer", ["ResizerModel", function(ResizerModel) {

    function OverflowResizer(table, columns, container) {
        // Call super constructor
        ResizerModel.call(this, table, columns, container)
    }

    // Inherit by prototypal inheritance
    OverflowResizer.prototype = Object.create(ResizerModel.prototype);


    OverflowResizer.prototype.setup = function() {
        // Allow overflow in this mode
        $(this.container).css({
            overflow: 'auto'
        });
    };

    OverflowResizer.prototype.onTableReady = function() {
        // For mode overflow, make table as small as possible
        $(this.table).width(1);
    };

    // Return constructor
    return OverflowResizer;

}]);

/**
 * @license Angular UI Tree v2.15.0
 * (c) 2010-2016. https://github.com/angular-ui-tree/angular-ui-tree
 * License: MIT
 */
(function () {
    'use strict';

    angular.module('ui.tree', [])
        .constant('treeConfig', {
            treeClass: 'angular-ui-tree',
            emptyTreeClass: 'angular-ui-tree-empty',
            hiddenClass: 'angular-ui-tree-hidden',
            nodesClass: 'angular-ui-tree-nodes',
            nodeClass: 'angular-ui-tree-node',
            handleClass: 'angular-ui-tree-handle',
            placeholderClass: 'angular-ui-tree-placeholder',
            dragClass: 'angular-ui-tree-drag',
            dragThreshold: 3,
            levelThreshold: 30,
            defaultCollapsed: false
        });

})();

(function () {
    'use strict';

    angular.module('ui.tree')

        .controller('TreeHandleController', ['$scope', '$element',
            function ($scope, $element) {
                this.scope = $scope;

                $scope.$element = $element;
                $scope.$nodeScope = null;
                $scope.$type = 'uiTreeHandle';

            }
        ]);
})();

(function () {
    'use strict';

    angular.module('ui.tree')
        .controller('TreeNodeController', ['$scope', '$element',
            function ($scope, $element) {
                this.scope = $scope;

                $scope.$element = $element;
                $scope.$modelValue = null; // Model value for node;
                $scope.$parentNodeScope = null; // uiTreeNode Scope of parent node;
                $scope.$childNodesScope = null; // uiTreeNodes Scope of child nodes.
                $scope.$parentNodesScope = null; // uiTreeNodes Scope of parent nodes.
                $scope.$treeScope = null; // uiTree scope
                $scope.$handleScope = null; // it's handle scope
                $scope.$type = 'uiTreeNode';
                $scope.$$allowNodeDrop = false;
                $scope.collapsed = false;

                $scope.init = function (controllersArr) {
                    var treeNodesCtrl = controllersArr[0];
                    $scope.$treeScope = controllersArr[1] ? controllersArr[1].scope : null;

                    // find the scope of it's parent node
                    $scope.$parentNodeScope = treeNodesCtrl.scope.$nodeScope;
                    // modelValue for current node
                    $scope.$modelValue = treeNodesCtrl.scope.$modelValue[$scope.$index];
                    $scope.$parentNodesScope = treeNodesCtrl.scope;
                    treeNodesCtrl.scope.initSubNode($scope); // init sub nodes

                    $element.on('$destroy', function () {
                        treeNodesCtrl.scope.destroySubNode($scope); // destroy sub nodes
                    });
                };

                $scope.index = function () {
                    return $scope.$parentNodesScope.$modelValue.indexOf($scope.$modelValue);
                };

                $scope.dragEnabled = function () {
                    return !($scope.$treeScope && !$scope.$treeScope.dragEnabled);
                };

                $scope.isSibling = function (targetNode) {
                    return $scope.$parentNodesScope == targetNode.$parentNodesScope;
                };

                $scope.isChild = function (targetNode) {
                    var nodes = $scope.childNodes();
                    return nodes && nodes.indexOf(targetNode) > -1;
                };

                $scope.prev = function () {
                    var index = $scope.index();
                    if (index > 0) {
                        return $scope.siblings()[index - 1];
                    }
                    return null;
                };

                $scope.siblings = function () {
                    return $scope.$parentNodesScope.childNodes();
                };

                $scope.childNodesCount = function () {
                    return $scope.childNodes() ? $scope.childNodes().length : 0;
                };

                $scope.hasChild = function () {
                    return $scope.childNodesCount() > 0;
                };

                $scope.childNodes = function () {
                    return $scope.$childNodesScope && $scope.$childNodesScope.$modelValue ?
                        $scope.$childNodesScope.childNodes() :
                        null;
                };

                $scope.accept = function (sourceNode, destIndex) {
                    return $scope.$childNodesScope &&
                        $scope.$childNodesScope.$modelValue &&
                        $scope.$childNodesScope.accept(sourceNode, destIndex);
                };

                $scope.remove = function () {
                    return $scope.$parentNodesScope.removeNode($scope);
                };

                $scope.toggle = function () {
                    $scope.collapsed = !$scope.collapsed;
                };

                $scope.collapse = function () {
                    $scope.collapsed = true;
                };

                $scope.expand = function () {
                    $scope.collapsed = false;
                };

                $scope.depth = function () {
                    var parentNode = $scope.$parentNodeScope;
                    if (parentNode) {
                        return parentNode.depth() + 1;
                    }
                    return 1;
                };

                /**
                 * Returns the depth of the deepest subtree under this node
                 * @param scope a TreeNodesController scope object
                 * @returns Depth of all nodes *beneath* this node. If scope belongs to a leaf node, the
                 *   result is 0 (it has no subtree).
                 */
                function countSubTreeDepth(scope) {
                    var thisLevelDepth = 0,
                        childNodes = scope.childNodes(),
                        childNode,
                        childDepth,
                        i;
                    if (!childNodes || childNodes.length === 0) {
                        return 0;
                    }
                    for (i = childNodes.length - 1; i >= 0 ; i--) {
                        childNode = childNodes[i],
                            childDepth = 1 + countSubTreeDepth(childNode);
                        thisLevelDepth = Math.max(thisLevelDepth, childDepth);
                    }
                    return thisLevelDepth;
                }

                $scope.maxSubDepth = function () {
                    return $scope.$childNodesScope ? countSubTreeDepth($scope.$childNodesScope) : 0;
                };
            }
        ]);
})();

(function () {
    'use strict';

    angular.module('ui.tree')

        .controller('TreeNodesController', ['$scope', '$element',
            function ($scope, $element) {
                this.scope = $scope;

                $scope.$element = $element;
                $scope.$modelValue = null;
                $scope.$nodeScope = null; // the scope of node which the nodes belongs to
                $scope.$treeScope = null;
                $scope.$type = 'uiTreeNodes';
                $scope.$nodesMap = {};

                $scope.nodropEnabled = false;
                $scope.maxDepth = 0;
                $scope.cloneEnabled = false;

                $scope.initSubNode = function (subNode) {
                    if (!subNode.$modelValue) {
                        return null;
                    }
                    $scope.$nodesMap[subNode.$modelValue.$$hashKey] = subNode;
                };

                $scope.destroySubNode = function (subNode) {
                    if (!subNode.$modelValue) {
                        return null;
                    }
                    $scope.$nodesMap[subNode.$modelValue.$$hashKey] = null;
                };

                $scope.accept = function (sourceNode, destIndex) {
                    return $scope.$treeScope.$callbacks.accept(sourceNode, $scope, destIndex);
                };

                $scope.beforeDrag = function (sourceNode) {
                    return $scope.$treeScope.$callbacks.beforeDrag(sourceNode);
                };

                $scope.isParent = function (node) {
                    return node.$parentNodesScope == $scope;
                };

                $scope.hasChild = function () {
                    return $scope.$modelValue.length > 0;
                };

                $scope.safeApply = function (fn) {
                    var phase = this.$root.$$phase;
                    if (phase == '$apply' || phase == '$digest') {
                        if (fn && (typeof (fn) === 'function')) {
                            fn();
                        }
                    } else {
                        this.$apply(fn);
                    }
                };

                $scope.removeNode = function (node) {
                    var index = $scope.$modelValue.indexOf(node.$modelValue);
                    if (index > -1) {
                        $scope.safeApply(function () {
                            $scope.$modelValue.splice(index, 1)[0];
                        });
                        return $scope.$treeScope.$callbacks.removed(node);
                    }
                    return null;
                };

                $scope.insertNode = function (index, nodeData) {
                    $scope.safeApply(function () {
                        $scope.$modelValue.splice(index, 0, nodeData);
                    });
                };

                $scope.childNodes = function () {
                    var i, nodes = [];
                    if ($scope.$modelValue) {
                        for (i = 0; i < $scope.$modelValue.length; i++) {
                            nodes.push($scope.$nodesMap[$scope.$modelValue[i].$$hashKey]);
                        }
                    }
                    return nodes;
                };

                $scope.depth = function () {
                    if ($scope.$nodeScope) {
                        return $scope.$nodeScope.depth();
                    }
                    return 0; // if it has no $nodeScope, it's root
                };

                // check if depth limit has reached
                $scope.outOfDepth = function (sourceNode) {
                    var maxDepth = $scope.maxDepth || $scope.$treeScope.maxDepth;
                    if (maxDepth > 0) {
                        return $scope.depth() + sourceNode.maxSubDepth() + 1 > maxDepth;
                    }
                    return false;
                };

            }
        ]);
})();

(function () {
    'use strict';

    angular.module('ui.tree')

        .controller('TreeController', ['$scope', '$element',
            function ($scope, $element) {
                this.scope = $scope;

                $scope.$element = $element;
                $scope.$nodesScope = null; // root nodes
                $scope.$type = 'uiTree';
                $scope.$emptyElm = null;
                $scope.$callbacks = null;

                $scope.dragEnabled = true;
                $scope.emptyPlaceholderEnabled = true;
                $scope.maxDepth = 0;
                $scope.dragDelay = 0;
                $scope.cloneEnabled = false;
                $scope.nodropEnabled = false;

                // Check if it's a empty tree
                $scope.isEmpty = function () {
                    return ($scope.$nodesScope && $scope.$nodesScope.$modelValue
                    && $scope.$nodesScope.$modelValue.length === 0);
                };

                // add placeholder to empty tree
                $scope.place = function (placeElm) {
                    $scope.$nodesScope.$element.append(placeElm);
                    $scope.$emptyElm.remove();
                };

                this.resetEmptyElement = function () {
                    if ((!$scope.$nodesScope.$modelValue || $scope.$nodesScope.$modelValue.length === 0) &&
                        $scope.emptyPlaceholderEnabled) {
                        $element.append($scope.$emptyElm);
                    } else {
                        $scope.$emptyElm.remove();
                    }
                };

                $scope.resetEmptyElement = this.resetEmptyElement;
            }
        ]);
})();

(function () {
    'use strict';

    angular.module('ui.tree')
        .directive('uiTree', ['treeConfig', '$window',
            function (treeConfig, $window) {
                return {
                    restrict: 'A',
                    scope: true,
                    controller: 'TreeController',
                    link: function (scope, element, attrs, ctrl) {
                        var callbacks = {
                                accept: null,
                                beforeDrag: null
                            },
                            config = {},
                            tdElm,
                            $trElm,
                            emptyElmColspan;

                        angular.extend(config, treeConfig);
                        if (config.treeClass) {
                            element.addClass(config.treeClass);
                        }

                        if (element.prop('tagName').toLowerCase() === 'table') {
                            scope.$emptyElm = angular.element($window.document.createElement('tr'));
                            $trElm = element.find('tr');
                            // If we can find a tr, then we can use its td children as the empty element colspan.
                            if ($trElm.length > 0) {
                                emptyElmColspan = angular.element($trElm).children().length;
                            } else {
                                // If not, by setting a huge colspan we make sure it takes full width.
                                emptyElmColspan = 1000000;
                            }
                            tdElm = angular.element($window.document.createElement('td'))
                                .attr('colspan', emptyElmColspan);
                            scope.$emptyElm.append(tdElm);
                        } else {
                            scope.$emptyElm = angular.element($window.document.createElement('div'));
                        }

                        if (config.emptyTreeClass) {
                            scope.$emptyElm.addClass(config.emptyTreeClass);
                        }

                        scope.$watch('$nodesScope.$modelValue.length', function (val) {
                            if (!angular.isNumber(val)) {
                                return;
                            }

                            ctrl.resetEmptyElement();
                        }, true);

                        scope.$watch(attrs.dragEnabled, function (val) {
                            if ((typeof val) == 'boolean') {
                                scope.dragEnabled = val;
                            }
                        });

                        scope.$watch(attrs.emptyPlaceholderEnabled, function (val) {
                            if ((typeof val) == 'boolean') {
                                scope.emptyPlaceholderEnabled = val;
                                ctrl.resetEmptyElement();
                            }
                        });

                        scope.$watch(attrs.nodropEnabled, function (val) {
                            if ((typeof val) == 'boolean') {
                                scope.nodropEnabled = val;
                            }
                        });

                        scope.$watch(attrs.cloneEnabled, function (val) {
                            if ((typeof val) == 'boolean') {
                                scope.cloneEnabled = val;
                            }
                        });

                        scope.$watch(attrs.maxDepth, function (val) {
                            if ((typeof val) == 'number') {
                                scope.maxDepth = val;
                            }
                        });

                        scope.$watch(attrs.dragDelay, function (val) {
                            if ((typeof val) == 'number') {
                                scope.dragDelay = val;
                            }
                        });

                        /**
                         * Callback checks if the destination node can accept the dragged node.
                         * By default, ui-tree will check that 'data-nodrop-enabled' is not set for the
                         * destination ui-tree-nodes, and that the 'max-depth' attribute will not be exceeded
                         * if it is set on the ui-tree or ui-tree-nodes.
                         * This callback can be overridden, but callers must manually enforce nodrop and max-depth
                         * themselves if they need those to be enforced.
                         * @param sourceNodeScope Scope of the ui-tree-node being dragged
                         * @param destNodesScope Scope of the ui-tree-nodes where the node is hovering
                         * @param destIndex Index in the destination nodes array where the source node will drop
                         * @returns {boolean} True if the node is permitted to be dropped here
                         */
                        callbacks.accept = function (sourceNodeScope, destNodesScope, destIndex) {
                            return !(destNodesScope.nodropEnabled || destNodesScope.$treeScope.nodropEnabled || destNodesScope.outOfDepth(sourceNodeScope));
                        };

                        callbacks.beforeDrag = function (sourceNodeScope) {
                            return true;
                        };

                        callbacks.removed = function (node) {

                        };

                        /**
                         * Callback is fired when a node is successfully dropped in a new location
                         * @param event
                         */
                        callbacks.dropped = function (event) {

                        };

                        /**
                         * Callback is fired each time the user starts dragging a node
                         * @param event
                         */
                        callbacks.dragStart = function (event) {

                        };

                        /**
                         * Callback is fired each time a dragged node is moved with the mouse/touch.
                         * @param event
                         */
                        callbacks.dragMove = function (event) {

                        };

                        /**
                         * Callback is fired when the tree exits drag mode. If the user dropped a node, the drop may have been
                         * accepted or reverted.
                         * @param event
                         */
                        callbacks.dragStop = function (event) {

                        };

                        /**
                         * Callback is fired when a user drops a node (but prior to processing the drop action)
                         * beforeDrop can return a Promise, truthy, or falsy (returning nothing is falsy).
                         * If it returns falsy, or a resolve Promise, the node move is accepted
                         * If it returns truthy, or a rejected Promise, the node move is reverted
                         * @param event
                         * @returns {Boolean|Promise} Truthy (or rejected Promise) to cancel node move; falsy (or resolved promise)
                         */
                        callbacks.beforeDrop = function (event) {

                        };

                        scope.$watch(attrs.uiTree, function (newVal, oldVal) {
                            angular.forEach(newVal, function (value, key) {
                                if (callbacks[key]) {
                                    if (typeof value === 'function') {
                                        callbacks[key] = value;
                                    }
                                }
                            });

                            scope.$callbacks = callbacks;
                        }, true);


                    }
                };
            }
        ]);
})();

(function () {
    'use strict';

    angular.module('ui.tree')
        .directive('uiTreeHandle', ['treeConfig',
            function (treeConfig) {
                return {
                    require: '^uiTreeNode',
                    restrict: 'A',
                    scope: true,
                    controller: 'TreeHandleController',
                    link: function (scope, element, attrs, treeNodeCtrl) {
                        var config = {};
                        angular.extend(config, treeConfig);
                        if (config.handleClass) {
                            element.addClass(config.handleClass);
                        }
                        // connect with the tree node.
                        if (scope != treeNodeCtrl.scope) {
                            scope.$nodeScope = treeNodeCtrl.scope;
                            treeNodeCtrl.scope.$handleScope = scope;
                        }
                    }
                };
            }
        ]);
})();

(function () {
    'use strict';

    angular.module('ui.tree')

        .directive('uiTreeNode', ['treeConfig', 'UiTreeHelper', '$window', '$document', '$timeout', '$q', '$rootElement',
            function (treeConfig, UiTreeHelper, $window, $document, $timeout, $q, $rootElement) {
                return {
                    require: ['^uiTreeNodes', '^uiTree'],
                    restrict: 'A',
                    controller: 'TreeNodeController',
                    link: function (scope, element, attrs, controllersArr) {
                        // todo startPos is unused
                        var config = {},
                            hasTouch = 'ontouchstart' in window,
                            startPos, firstMoving, dragInfo, pos,
                            placeElm, hiddenPlaceElm, dragElm,
                            treeScope = null,
                            elements, // As a parameter for callbacks
                            dragDelaying = true,
                            dragStarted = false,
                            dragTimer = null,
                            body = document.body,
                            html = document.documentElement,
                            document_height,
                            document_width,
                            dragStart,
                            tagName,
                            dragMove,
                            dragEnd,
                            dragStartEvent,
                            dragMoveEvent,
                            dragEndEvent,
                            dragCancelEvent,
                            dragDelay,
                            bindDragStartEvents,
                            bindDragMoveEvents,
                            unbindDragMoveEvents,
                            keydownHandler,
                            outOfBounds,
                            isHandleChild,
                            el;

                        angular.extend(config, treeConfig);
                        if (config.nodeClass) {
                            element.addClass(config.nodeClass);
                        }
                        scope.init(controllersArr);

                        scope.collapsed = !!UiTreeHelper.getNodeAttribute(scope, 'collapsed') || treeConfig.defaultCollapsed;
                        scope.sourceOnly = scope.nodropEnabled || scope.$treeScope.nodropEnabled;

                        scope.$watch(attrs.collapsed, function (val) {
                            if ((typeof val) == 'boolean') {
                                scope.collapsed = val;
                            }
                        });

                        scope.$watch('collapsed', function (val) {
                            UiTreeHelper.setNodeAttribute(scope, 'collapsed', val);
                            attrs.$set('collapsed', val);
                        });

                        scope.$on('angular-ui-tree:collapse-all', function () {
                            scope.collapsed = true;
                        });

                        scope.$on('angular-ui-tree:expand-all', function () {
                            scope.collapsed = false;
                        });

                        /**
                         * Called when the user has grabbed a node and started dragging it
                         * @param e
                         */
                        dragStart = function (e) {
                            // disable right click
                            if (!hasTouch && (e.button === 2 || e.which === 3)) {
                                return;
                            }

                            // event has already fired in other scope
                            if (e.uiTreeDragging || (e.originalEvent && e.originalEvent.uiTreeDragging)) {
                                return;
                            }

                            // the node being dragged
                            var eventElm = angular.element(e.target),
                                isHandleChild, cloneElm, eventElmTagName, tagName,
                                eventObj, tdElm, hStyle,
                                isTreeNode,
                                isTreeNodeHandle;

                            // if the target element is a child element of a ui-tree-handle,
                            // use the containing handle element as target element
                            isHandleChild = UiTreeHelper.treeNodeHandlerContainerOfElement(eventElm);
                            if (isHandleChild) {
                                eventElm = angular.element(isHandleChild);
                            }

                            cloneElm = element.clone();
                            isTreeNode = UiTreeHelper.elementIsTreeNode(eventElm);
                            isTreeNodeHandle = UiTreeHelper.elementIsTreeNodeHandle(eventElm);

                            if (!isTreeNode && !isTreeNodeHandle) {
                                return;
                            }

                            if (isTreeNode && UiTreeHelper.elementContainsTreeNodeHandler(eventElm)) {
                                return;
                            }

                            eventElmTagName = eventElm.prop('tagName').toLowerCase();
                            if (eventElmTagName == 'input' ||
                                eventElmTagName == 'textarea' ||
                                eventElmTagName == 'button' ||
                                eventElmTagName == 'select') { // if it's a input or button, ignore it
                                return;
                            }

                            // check if it or it's parents has a 'data-nodrag' attribute
                            el = angular.element(e.target);
                            while (el && el[0] && el[0] !== element) {
                                if (UiTreeHelper.nodrag(el)) { // if the node mark as `nodrag`, DONOT drag it.
                                    return;
                                }
                                el = el.parent();
                            }

                            if (!scope.beforeDrag(scope)) {
                                return;
                            }

                            e.uiTreeDragging = true; // stop event bubbling
                            if (e.originalEvent) {
                                e.originalEvent.uiTreeDragging = true;
                            }
                            e.preventDefault();
                            eventObj = UiTreeHelper.eventObj(e);

                            firstMoving = true;
                            dragInfo = UiTreeHelper.dragInfo(scope);

                            tagName = element.prop('tagName');

                            if (tagName.toLowerCase() === 'tr') {
                                placeElm = angular.element($window.document.createElement(tagName));
                                tdElm = angular.element($window.document.createElement('td'))
                                    .addClass(config.placeholderClass)
                                    .attr('colspan', element[0].children.length);
                                placeElm.append(tdElm);
                            } else {
                                placeElm = angular.element($window.document.createElement(tagName))
                                    .addClass(config.placeholderClass);
                            }
                            hiddenPlaceElm = angular.element($window.document.createElement(tagName));
                            if (config.hiddenClass) {
                                hiddenPlaceElm.addClass(config.hiddenClass);
                            }

                            pos = UiTreeHelper.positionStarted(eventObj, element);
                            placeElm.css('height', UiTreeHelper.height(element) + 'px');

                            dragElm = angular.element($window.document.createElement(scope.$parentNodesScope.$element.prop('tagName')))
                                .addClass(scope.$parentNodesScope.$element.attr('class')).addClass(config.dragClass);
                            dragElm.css('width', UiTreeHelper.width(element) + 'px');
                            dragElm.css('z-index', 9999);

                            // Prevents cursor to change rapidly in Opera 12.16 and IE when dragging an element
                            hStyle = (element[0].querySelector('.angular-ui-tree-handle') || element[0]).currentStyle;
                            if (hStyle) {
                                document.body.setAttribute('ui-tree-cursor', $document.find('body').css('cursor') || '');
                                $document.find('body').css({'cursor': hStyle.cursor + '!important'});
                            }

                            if (scope.sourceOnly) {
                                placeElm.css('display', 'none');
                            }
                            element.after(placeElm);
                            element.after(hiddenPlaceElm);
                            if (dragInfo.isClone() && scope.sourceOnly) {
                                dragElm.append(cloneElm);
                            } else {
                                dragElm.append(element);
                            }

                            $rootElement.append(dragElm);

                            dragElm.css({
                                'left': eventObj.pageX - pos.offsetX + 'px',
                                'top': eventObj.pageY - pos.offsetY + 'px'
                            });
                            elements = {
                                placeholder: placeElm,
                                dragging: dragElm
                            };

                            bindDragMoveEvents();
                            // Fire dragStart callback
                            scope.$apply(function () {
                                scope.$treeScope.$callbacks.dragStart(dragInfo.eventArgs(elements, pos));
                            });

                            document_height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
                            document_width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
                        };

                        dragMove = function (e) {
                            var eventObj = UiTreeHelper.eventObj(e),
                                prev,
                                next,
                                leftElmPos,
                                topElmPos,
                                top_scroll,
                                bottom_scroll,
                                target,
                                decrease,
                                targetX,
                                targetY,
                                displayElm,
                                targetNode,
                                targetElm,
                                isEmpty,
                                targetOffset,
                                targetBefore;

                            if (dragElm) {
                                e.preventDefault();

                                if ($window.getSelection) {
                                    $window.getSelection().removeAllRanges();
                                } else if ($window.document.selection) {
                                    $window.document.selection.empty();
                                }

                                leftElmPos = eventObj.pageX - pos.offsetX;
                                topElmPos = eventObj.pageY - pos.offsetY;

                                //dragElm can't leave the screen on the left
                                if (leftElmPos < 0) {
                                    leftElmPos = 0;
                                }

                                //dragElm can't leave the screen on the top
                                if (topElmPos < 0) {
                                    topElmPos = 0;
                                }

                                //dragElm can't leave the screen on the bottom
                                if ((topElmPos + 10) > document_height) {
                                    topElmPos = document_height - 10;
                                }

                                //dragElm can't leave the screen on the right
                                if ((leftElmPos + 10) > document_width) {
                                    leftElmPos = document_width - 10;
                                }

                                dragElm.css({
                                    'left': leftElmPos + 'px',
                                    'top': topElmPos + 'px'
                                });

                                top_scroll = window.pageYOffset || $window.document.documentElement.scrollTop;
                                bottom_scroll = top_scroll + (window.innerHeight || $window.document.clientHeight || $window.document.clientHeight);

                                // to scroll down if cursor y-position is greater than the bottom position the vertical scroll
                                if (bottom_scroll < eventObj.pageY && bottom_scroll <= document_height) {
                                    window.scrollBy(0, 10);
                                }

                                // to scroll top if cursor y-position is less than the top position the vertical scroll
                                if (top_scroll > eventObj.pageY) {
                                    window.scrollBy(0, -10);
                                }

                                UiTreeHelper.positionMoved(e, pos, firstMoving);
                                if (firstMoving) {
                                    firstMoving = false;
                                    return;
                                }

                                // check if add it as a child node first
                                // todo decrease is unused
                                decrease = (UiTreeHelper.offset(dragElm).left - UiTreeHelper.offset(placeElm).left) >= config.threshold;

                                targetX = eventObj.pageX - ($window.pageXOffset ||
                                    $window.document.body.scrollLeft ||
                                    $window.document.documentElement.scrollLeft) -
                                    ($window.document.documentElement.clientLeft || 0);

                                targetY = eventObj.pageY - ($window.pageYOffset ||
                                    $window.document.body.scrollTop ||
                                    $window.document.documentElement.scrollTop) -
                                    ($window.document.documentElement.clientTop || 0);

                                // Select the drag target. Because IE does not support CSS 'pointer-events: none', it will always
                                // pick the drag element itself as the target. To prevent this, we hide the drag element while
                                // selecting the target.
                                if (angular.isFunction(dragElm.hide)) {
                                    dragElm.hide();
                                } else {
                                    displayElm = dragElm[0].style.display;
                                    dragElm[0].style.display = 'none';
                                }

                                // when using elementFromPoint() inside an iframe, you have to call
                                // elementFromPoint() twice to make sure IE8 returns the correct value
                                $window.document.elementFromPoint(targetX, targetY);

                                targetElm = angular.element($window.document.elementFromPoint(targetX, targetY));

                                // if the target element is a child element of a ui-tree-handle,
                                // use the containing handle element as target element
                                isHandleChild = UiTreeHelper.treeNodeHandlerContainerOfElement(targetElm);
                                if (isHandleChild) {
                                    targetElm = angular.element(isHandleChild);
                                }

                                if (angular.isFunction(dragElm.show)) {
                                    dragElm.show();
                                } else {
                                    dragElm[0].style.display = displayElm;
                                }

                                outOfBounds = !UiTreeHelper.elementIsTreeNodeHandle(targetElm) &&
                                    !UiTreeHelper.elementIsTreeNode(targetElm) &&
                                    !UiTreeHelper.elementIsTreeNodes(targetElm) &&
                                    !UiTreeHelper.elementIsTree(targetElm) &&
                                    !UiTreeHelper.elementIsPlaceholder(targetElm);

                                // Detect out of bounds condition, update drop target display, and prevent drop
                                if (outOfBounds) {

                                    // Remove the placeholder
                                    placeElm.remove();

                                    // If the target was an empty tree, replace the empty element placeholder
                                    if (treeScope) {
                                        treeScope.resetEmptyElement();
                                        treeScope = null;
                                    }
                                }

                                // move horizontal
                                if (pos.dirAx && pos.distAxX >= config.levelThreshold) {
                                    pos.distAxX = 0;

                                    // increase horizontal level if previous sibling exists and is not collapsed
                                    if (pos.distX > 0) {
                                        prev = dragInfo.prev();
                                        if (prev && !prev.collapsed
                                            && prev.accept(scope, prev.childNodesCount())) {
                                            prev.$childNodesScope.$element.append(placeElm);
                                            dragInfo.moveTo(prev.$childNodesScope, prev.childNodes(), prev.childNodesCount());
                                        }
                                    }

                                    // decrease horizontal level
                                    if (pos.distX < 0) {
                                        // we can't decrease a level if an item preceeds the current one
                                        next = dragInfo.next();
                                        if (!next) {
                                            target = dragInfo.parentNode(); // As a sibling of it's parent node
                                            if (target
                                                && target.$parentNodesScope.accept(scope, target.index() + 1)) {
                                                target.$element.after(placeElm);
                                                dragInfo.moveTo(target.$parentNodesScope, target.siblings(), target.index() + 1);
                                            }
                                        }
                                    }
                                }

                                // move vertical
                                if (!pos.dirAx) {
                                    if (UiTreeHelper.elementIsTree(targetElm)) {
                                        targetNode = targetElm.controller('uiTree').scope;
                                    } else if (UiTreeHelper.elementIsTreeNodeHandle(targetElm)) {
                                        targetNode = targetElm.controller('uiTreeHandle').scope;
                                    } else if (UiTreeHelper.elementIsTreeNode(targetElm)) {
                                        targetNode = targetElm.controller('uiTreeNode').scope;
                                    } else if (UiTreeHelper.elementIsTreeNodes(targetElm)) {
                                        targetNode = targetElm.controller('uiTreeNodes').scope;
                                    } else if (UiTreeHelper.elementIsPlaceholder(targetElm)) {
                                        targetNode = targetElm.controller('uiTreeNodes').scope;
                                    } else if (targetElm.controller('uiTreeNode')) {
                                        // is a child element of a node
                                        targetNode = targetElm.controller('uiTreeNode').scope;
                                    }

                                    // check it's new position
                                    isEmpty = false;
                                    if (!targetNode) {
                                        return;
                                    }

                                    // Show the placeholder if it was hidden for nodrop-enabled and this is a new tree
                                    if (targetNode.$treeScope && !targetNode.$parent.nodropEnabled && !targetNode.$treeScope.nodropEnabled) {
                                        placeElm.css('display', '');
                                    }

                                    if (targetNode.$type == 'uiTree' && targetNode.dragEnabled) {
                                        isEmpty = targetNode.isEmpty(); // Check if it's empty tree
                                    }

                                    if (targetNode.$type == 'uiTreeHandle') {
                                        targetNode = targetNode.$nodeScope;
                                    }

                                    if (targetNode.$type != 'uiTreeNode'
                                        && !isEmpty) { // Check if it is a uiTreeNode or it's an empty tree
                                        return;
                                    }

                                    // if placeholder move from empty tree, reset it.
                                    if (treeScope && placeElm.parent()[0] != treeScope.$element[0]) {
                                        treeScope.resetEmptyElement();
                                        treeScope = null;
                                    }

                                    if (isEmpty) { // it's an empty tree
                                        treeScope = targetNode;
                                        if (targetNode.$nodesScope.accept(scope, 0)) {
                                            targetNode.place(placeElm);
                                            dragInfo.moveTo(targetNode.$nodesScope, targetNode.$nodesScope.childNodes(), 0);
                                        }
                                    } else if (targetNode.dragEnabled()) { // drag enabled
                                        targetElm = targetNode.$element; // Get the element of ui-tree-node
                                        targetOffset = UiTreeHelper.offset(targetElm);
                                        targetBefore = targetNode.horizontal ? eventObj.pageX < (targetOffset.left + UiTreeHelper.width(targetElm) / 2)
                                            : eventObj.pageY < (targetOffset.top + UiTreeHelper.height(targetElm) / 2);

                                        if (targetNode.$parentNodesScope.accept(scope, targetNode.index())) {
                                            if (targetBefore) {
                                                targetElm[0].parentNode.insertBefore(placeElm[0], targetElm[0]);
                                                dragInfo.moveTo(targetNode.$parentNodesScope, targetNode.siblings(), targetNode.index());
                                            } else {
                                                targetElm.after(placeElm);
                                                dragInfo.moveTo(targetNode.$parentNodesScope, targetNode.siblings(), targetNode.index() + 1);
                                            }
                                        } else if (!targetBefore && targetNode.accept(scope, targetNode.childNodesCount())) { // we have to check if it can add the dragging node as a child
                                            targetNode.$childNodesScope.$element.append(placeElm);
                                            dragInfo.moveTo(targetNode.$childNodesScope, targetNode.childNodes(), targetNode.childNodesCount());
                                        } else {
                                            outOfBounds = true;
                                        }
                                    }
                                }

                                scope.$apply(function () {
                                    scope.$treeScope.$callbacks.dragMove(dragInfo.eventArgs(elements, pos));
                                });
                            }
                        };

                        dragEnd = function (e) {
                            var dragEventArgs = dragInfo.eventArgs(elements, pos);
                            e.preventDefault();
                            unbindDragMoveEvents();

                            scope.$treeScope.$apply(function () {
                                $q.when(scope.$treeScope.$callbacks.beforeDrop(dragEventArgs))
                                    // promise resolved (or callback didn't return false)
                                    .then(function (allowDrop) {
                                        if (allowDrop !== false && scope.$$allowNodeDrop && !outOfBounds) { // node drop accepted)
                                            dragInfo.apply();
                                            // fire the dropped callback only if the move was successful
                                            scope.$treeScope.$callbacks.dropped(dragEventArgs);
                                        } else { // drop canceled - revert the node to its original position
                                            bindDragStartEvents();
                                        }
                                    })
                                    // promise rejected - revert the node to its original position
                                    .catch(function () {
                                        bindDragStartEvents();
                                    })
                                    .finally(function () {
                                        hiddenPlaceElm.replaceWith(scope.$element);
                                        placeElm.remove();

                                        if (dragElm) { // drag element is attached to the mouse pointer
                                            dragElm.remove();
                                            dragElm = null;
                                        }
                                        scope.$treeScope.$callbacks.dragStop(dragEventArgs);
                                        scope.$$allowNodeDrop = false;
                                        dragInfo = null;

                                        // Restore cursor in Opera 12.16 and IE
                                        var oldCur = document.body.getAttribute('ui-tree-cursor');
                                        if (oldCur !== null) {
                                            $document.find('body').css({'cursor': oldCur});
                                            document.body.removeAttribute('ui-tree-cursor');
                                        }
                                    });
                            });
                        };

                        dragStartEvent = function (e) {
                            if (scope.dragEnabled()) {
                                dragStart(e);
                            }
                        };

                        dragMoveEvent = function (e) {
                            dragMove(e);
                        };

                        dragEndEvent = function (e) {
                            scope.$$allowNodeDrop = true;
                            dragEnd(e);
                        };

                        dragCancelEvent = function (e) {
                            dragEnd(e);
                        };

                        dragDelay = (function () {
                            var to;

                            return {
                                exec: function (fn, ms) {
                                    if (!ms) {
                                        ms = 0;
                                    }
                                    this.cancel();
                                    to = $timeout(fn, ms);
                                },
                                cancel: function () {
                                    $timeout.cancel(to);
                                }
                            };
                        })();

                        /**
                         * Binds the mouse/touch events to enable drag start for this node
                         */
                        bindDragStartEvents = function () {
                            element.bind('touchstart mousedown', function (e) {
                                dragDelay.exec(function () {
                                    dragStartEvent(e);
                                }, scope.dragDelay || 0);
                            });
                            element.bind('touchend touchcancel mouseup', function () {
                                dragDelay.cancel();
                            });
                        };
                        bindDragStartEvents();

                        /**
                         * Binds mouse/touch events that handle moving/dropping this dragged node
                         */
                        bindDragMoveEvents = function () {
                            angular.element($document).bind('touchend', dragEndEvent);
                            angular.element($document).bind('touchcancel', dragEndEvent);
                            angular.element($document).bind('touchmove', dragMoveEvent);
                            angular.element($document).bind('mouseup', dragEndEvent);
                            angular.element($document).bind('mousemove', dragMoveEvent);
                            angular.element($document).bind('mouseleave', dragCancelEvent);
                        };

                        /**
                         * Unbinds mouse/touch events that handle moving/dropping this dragged node
                         */
                        unbindDragMoveEvents = function () {
                            angular.element($document).unbind('touchend', dragEndEvent);
                            angular.element($document).unbind('touchcancel', dragEndEvent);
                            angular.element($document).unbind('touchmove', dragMoveEvent);
                            angular.element($document).unbind('mouseup', dragEndEvent);
                            angular.element($document).unbind('mousemove', dragMoveEvent);
                            angular.element($document).unbind('mouseleave', dragCancelEvent);
                        };

                        keydownHandler = function (e) {
                            if (e.keyCode == 27) {
                                scope.$$allowNodeDrop = false;
                                dragEnd(e);
                            }
                        };

                        angular.element($window.document).bind('keydown', keydownHandler);

                        //unbind handler that retains scope
                        scope.$on('$destroy', function () {
                            angular.element($window.document).unbind('keydown', keydownHandler);
                        });
                    }
                };
            }
        ]);

})();

(function () {
    'use strict';

    angular.module('ui.tree')
        .directive('uiTreeNodes', ['treeConfig', '$window',
            function (treeConfig) {
                return {
                    require: ['ngModel', '?^uiTreeNode', '^uiTree'],
                    restrict: 'A',
                    scope: true,
                    controller: 'TreeNodesController',
                    link: function (scope, element, attrs, controllersArr) {

                        var config = {},
                            ngModel = controllersArr[0],
                            treeNodeCtrl = controllersArr[1],
                            treeCtrl = controllersArr[2];

                        angular.extend(config, treeConfig);
                        if (config.nodesClass) {
                            element.addClass(config.nodesClass);
                        }

                        if (treeNodeCtrl) {
                            treeNodeCtrl.scope.$childNodesScope = scope;
                            scope.$nodeScope = treeNodeCtrl.scope;
                        } else {
                            // find the root nodes if there is no parent node and have a parent ui-tree
                            treeCtrl.scope.$nodesScope = scope;
                        }
                        scope.$treeScope = treeCtrl.scope;

                        if (ngModel) {
                            ngModel.$render = function () {
                                scope.$modelValue = ngModel.$modelValue;
                            };
                        }

                        scope.$watch(function () {
                            return attrs.maxDepth;
                        }, function (val) {
                            if ((typeof val) == 'number') {
                                scope.maxDepth = val;
                            }
                        });

                        scope.$watch(function () {
                            return attrs.nodropEnabled;
                        }, function (newVal) {
                            if ((typeof newVal) != 'undefined') {
                                scope.nodropEnabled = true;
                            }
                        }, true);

                        attrs.$observe('horizontal', function (val) {
                            scope.horizontal = ((typeof val) != 'undefined');
                        });

                    }
                };
            }
        ]);
})();

(function () {
    'use strict';

    angular.module('ui.tree')

        /**
         * @ngdoc service
         * @name ui.tree.service:UiTreeHelper
         * @requires ng.$document
         * @requires ng.$window
         *
         * @description
         * angular-ui-tree.
         */
        .factory('UiTreeHelper', ['$document', '$window', 'treeConfig',
            function ($document, $window, treeConfig) {
                return {

                    /**
                     * A hashtable used to storage data of nodes
                     * @type {Object}
                     */
                    nodesData: {},

                    setNodeAttribute: function (scope, attrName, val) {
                        if (!scope.$modelValue) {
                            return null;
                        }
                        var data = this.nodesData[scope.$modelValue.$$hashKey];
                        if (!data) {
                            data = {};
                            this.nodesData[scope.$modelValue.$$hashKey] = data;
                        }
                        data[attrName] = val;
                    },

                    getNodeAttribute: function (scope, attrName) {
                        if (!scope.$modelValue) {
                            return null;
                        }
                        var data = this.nodesData[scope.$modelValue.$$hashKey];
                        if (data) {
                            return data[attrName];
                        }
                        return null;
                    },

                    /**
                     * @ngdoc method
                     * @methodOf ui.tree.service:$nodrag
                     * @param  {Object} targetElm angular element
                     * @return {Bool} check if the node can be dragged.
                     */
                    nodrag: function (targetElm) {
                        if (typeof targetElm.attr('data-nodrag') != 'undefined') {
                            return targetElm.attr('data-nodrag') !== 'false';
                        }
                        return false;
                    },

                    /**
                     * get the event object for touches
                     * @param  {[type]} e [description]
                     * @return {[type]}   [description]
                     */
                    eventObj: function (e) {
                        var obj = e;
                        if (e.targetTouches !== undefined) {
                            obj = e.targetTouches.item(0);
                        } else if (e.originalEvent !== undefined && e.originalEvent.targetTouches !== undefined) {
                            obj = e.originalEvent.targetTouches.item(0);
                        }
                        return obj;
                    },

                    dragInfo: function (node) {
                        return {
                            source: node,
                            sourceInfo: {
                                cloneModel: node.$treeScope.cloneEnabled === true ? angular.copy(node.$modelValue) : undefined,
                                nodeScope: node,
                                index: node.index(),
                                nodesScope: node.$parentNodesScope
                            },
                            index: node.index(),
                            siblings: node.siblings().slice(0),
                            parent: node.$parentNodesScope,

                            // Move the node to a new position
                            moveTo: function (parent, siblings, index) {
                                this.parent = parent;
                                this.siblings = siblings.slice(0);

                                // If source node is in the target nodes
                                var i = this.siblings.indexOf(this.source);
                                if (i > -1) {
                                    this.siblings.splice(i, 1);
                                    if (this.source.index() < index) {
                                        index--;
                                    }
                                }

                                this.siblings.splice(index, 0, this.source);
                                this.index = index;
                            },

                            parentNode: function () {
                                return this.parent.$nodeScope;
                            },

                            prev: function () {
                                if (this.index > 0) {
                                    return this.siblings[this.index - 1];
                                }

                                return null;
                            },

                            next: function () {
                                if (this.index < this.siblings.length - 1) {
                                    return this.siblings[this.index + 1];
                                }

                                return null;
                            },

                            isClone: function () {
                                return this.source.$treeScope.cloneEnabled === true;
                            },

                            clonedNode: function (node) {
                                return angular.copy(node);
                            },

                            isDirty: function () {
                                return this.source.$parentNodesScope != this.parent ||
                                    this.source.index() != this.index;
                            },

                            isForeign: function () {
                                return this.source.$treeScope !== this.parent.$treeScope;
                            },

                            eventArgs: function (elements, pos) {
                                return {
                                    source: this.sourceInfo,
                                    dest: {
                                        index: this.index,
                                        nodesScope: this.parent
                                    },
                                    elements: elements,
                                    pos: pos
                                };
                            },

                            apply: function () {

                                var nodeData = this.source.$modelValue;

                                // nodrop enabled on tree or parent
                                if (this.parent.nodropEnabled || this.parent.$treeScope.nodropEnabled) {
                                    return;
                                }

                                // node was dropped in the same place - do nothing
                                if (!this.isDirty()) {
                                    return;
                                }

                                // cloneEnabled and cross-tree so copy and do not remove from source
                                if (this.isClone() && this.isForeign()) {
                                    this.parent.insertNode(this.index, this.sourceInfo.cloneModel);
                                } else { // Any other case, remove and reinsert
                                    this.source.remove();
                                    this.parent.insertNode(this.index, nodeData);
                                }
                            }
                        };
                    },

                    /**
                     * @ngdoc method
                     * @name ui.tree#height
                     * @methodOf ui.tree.service:UiTreeHelper
                     *
                     * @description
                     * Get the height of an element.
                     *
                     * @param {Object} element Angular element.
                     * @returns {String} Height
                     */
                    height: function (element) {
                        return element.prop('scrollHeight');
                    },

                    /**
                     * @ngdoc method
                     * @name ui.tree#width
                     * @methodOf ui.tree.service:UiTreeHelper
                     *
                     * @description
                     * Get the width of an element.
                     *
                     * @param {Object} element Angular element.
                     * @returns {String} Width
                     */
                    width: function (element) {
                        return element.prop('scrollWidth');
                    },

                    /**
                     * @ngdoc method
                     * @name ui.tree#offset
                     * @methodOf ui.nestedSortable.service:UiTreeHelper
                     *
                     * @description
                     * Get the offset values of an element.
                     *
                     * @param {Object} element Angular element.
                     * @returns {Object} Object with properties width, height, top and left
                     */
                    offset: function (element) {
                        var boundingClientRect = element[0].getBoundingClientRect();

                        return {
                            width: element.prop('offsetWidth'),
                            height: element.prop('offsetHeight'),
                            top: boundingClientRect.top + ($window.pageYOffset || $document[0].body.scrollTop || $document[0].documentElement.scrollTop),
                            left: boundingClientRect.left + ($window.pageXOffset || $document[0].body.scrollLeft || $document[0].documentElement.scrollLeft)
                        };
                    },

                    /**
                     * @ngdoc method
                     * @name ui.tree#positionStarted
                     * @methodOf ui.tree.service:UiTreeHelper
                     *
                     * @description
                     * Get the start position of the target element according to the provided event properties.
                     *
                     * @param {Object} e Event
                     * @param {Object} target Target element
                     * @returns {Object} Object with properties offsetX, offsetY, startX, startY, nowX and dirX.
                     */
                    positionStarted: function (e, target) {
                        var pos = {},
                            pageX = e.pageX,
                            pageY = e.pageY;

                        if (e.originalEvent && e.originalEvent.touches && (e.originalEvent.touches.length > 0)) {
                            pageX = e.originalEvent.touches[0].pageX;
                            pageY = e.originalEvent.touches[0].pageY;
                        }
                        pos.offsetX = pageX - this.offset(target).left;
                        pos.offsetY = pageY - this.offset(target).top;
                        pos.startX = pos.lastX = pageX;
                        pos.startY = pos.lastY = pageY;
                        pos.nowX = pos.nowY = pos.distX = pos.distY = pos.dirAx = 0;
                        pos.dirX = pos.dirY = pos.lastDirX = pos.lastDirY = pos.distAxX = pos.distAxY = 0;
                        return pos;
                    },

                    positionMoved: function (e, pos, firstMoving) {
                        var pageX = e.pageX,
                            pageY = e.pageY,
                            newAx;
                        if (e.originalEvent && e.originalEvent.touches && (e.originalEvent.touches.length > 0)) {
                            pageX = e.originalEvent.touches[0].pageX;
                            pageY = e.originalEvent.touches[0].pageY;
                        }
                        // mouse position last events
                        pos.lastX = pos.nowX;
                        pos.lastY = pos.nowY;

                        // mouse position this events
                        pos.nowX = pageX;
                        pos.nowY = pageY;

                        // distance mouse moved between events
                        pos.distX = pos.nowX - pos.lastX;
                        pos.distY = pos.nowY - pos.lastY;

                        // direction mouse was moving
                        pos.lastDirX = pos.dirX;
                        pos.lastDirY = pos.dirY;

                        // direction mouse is now moving (on both axis)
                        pos.dirX = pos.distX === 0 ? 0 : pos.distX > 0 ? 1 : -1;
                        pos.dirY = pos.distY === 0 ? 0 : pos.distY > 0 ? 1 : -1;

                        // axis mouse is now moving on
                        newAx = Math.abs(pos.distX) > Math.abs(pos.distY) ? 1 : 0;

                        // do nothing on first move
                        if (firstMoving) {
                            pos.dirAx = newAx;
                            pos.moving = true;
                            return;
                        }

                        // calc distance moved on this axis (and direction)
                        if (pos.dirAx !== newAx) {
                            pos.distAxX = 0;
                            pos.distAxY = 0;
                        } else {
                            pos.distAxX += Math.abs(pos.distX);
                            if (pos.dirX !== 0 && pos.dirX !== pos.lastDirX) {
                                pos.distAxX = 0;
                            }

                            pos.distAxY += Math.abs(pos.distY);
                            if (pos.dirY !== 0 && pos.dirY !== pos.lastDirY) {
                                pos.distAxY = 0;
                            }
                        }

                        pos.dirAx = newAx;
                    },

                    elementIsTreeNode: function (element) {
                        return typeof element.attr('ui-tree-node') !== 'undefined';
                    },

                    elementIsTreeNodeHandle: function (element) {
                        return typeof element.attr('ui-tree-handle') !== 'undefined';
                    },
                    elementIsTree: function (element) {
                        return typeof element.attr('ui-tree') !== 'undefined';
                    },
                    elementIsTreeNodes: function (element) {
                        return typeof element.attr('ui-tree-nodes') !== 'undefined';
                    },
                    elementIsPlaceholder: function (element) {
                        return element.hasClass(treeConfig.placeholderClass);
                    },
                    elementContainsTreeNodeHandler: function (element) {
                        return element[0].querySelectorAll('[ui-tree-handle]').length >= 1;
                    },
                    treeNodeHandlerContainerOfElement: function (element) {
                        return findFirstParentElementWithAttribute('ui-tree-handle', element[0]);
                    }
                };
            }
        ]);

    // TODO: optimize this loop
    function findFirstParentElementWithAttribute(attributeName, childObj) {
        // undefined if the mouse leaves the browser window
        if (childObj === undefined) {
            return null;
        }
        var testObj = childObj.parentNode,
            count = 1,
        // check for setAttribute due to exception thrown by Firefox when a node is dragged outside the browser window
            res = (typeof testObj.setAttribute === 'function' && testObj.hasAttribute(attributeName)) ? testObj : null;
        while (testObj && typeof testObj.setAttribute === 'function' && !testObj.hasAttribute(attributeName)) {
            testObj = testObj.parentNode;
            res = testObj;
            if (testObj === document.documentElement) {
                res = null;
                break;
            }
            count++;
        }

        return res;
    }

})();
angular.module('ui', ['ui.sortable', 'ui.tinymce']);
/*
 jQuery UI Sortable plugin wrapper
 @param [ui-sortable] {object} Options to pass to $.fn.sortable() merged onto ui.config
 */
angular.module('ui.sortable', [])
    .value('uiSortableConfig',{})
    .directive('uiSortable', [
        'uiSortableConfig', '$timeout', '$log',
        function(uiSortableConfig, $timeout, $log) {
            return {
                require: '?ngModel',
                scope: {
                    ngModel: '=',
                    uiSortable: '='
                },
                link: function(scope, element, attrs, ngModel) {
                    var savedNodes;

                    function combineCallbacks(first,second){
                        if(second && (typeof second === 'function')) {
                            return function() {
                                first.apply(this, arguments);
                                second.apply(this, arguments);
                            };
                        }
                        return first;
                    }

                    function getSortableWidgetInstance(element) {
                        // this is a fix to support jquery-ui prior to v1.11.x
                        // otherwise we should be using `element.sortable('instance')`
                        var data = element.data('ui-sortable');
                        if (data && typeof data === 'object' && data.widgetFullName === 'ui-sortable') {
                            return data;
                        }
                        return null;
                    }

                    function hasSortingHelper (element, ui) {
                        var helperOption = element.sortable('option','helper');
                        return helperOption === 'clone' || (typeof helperOption === 'function' && ui.item.sortable.isCustomHelperUsed());
                    }

                    // thanks jquery-ui
                    function isFloating (item) {
                        return (/left|right/).test(item.css('float')) || (/inline|table-cell/).test(item.css('display'));
                    }

                    function getElementScope(elementScopes, element) {
                        var result = null;
                        for (var i = 0; i < elementScopes.length; i++) {
                            var x = elementScopes[i];
                            if (x.element[0] === element[0]) {
                                result = x.scope;
                                break;
                            }
                        }
                        return result;
                    }

                    function afterStop(e, ui) {
                        ui.item.sortable._destroy();
                    }

                    var opts = {};

                    // directive specific options
                    var directiveOpts = {
                        'ui-floating': undefined
                    };

                    var callbacks = {
                        receive: null,
                        remove:null,
                        start:null,
                        stop:null,
                        update:null
                    };

                    var wrappers = {
                        helper: null
                    };

                    angular.extend(opts, directiveOpts, uiSortableConfig, scope.uiSortable);

                    if (!angular.element.fn || !angular.element.fn.jquery) {
                        $log.error('ui.sortable: jQuery should be included before AngularJS!');
                        return;
                    }

                    if (ngModel) {

                        // When we add or remove elements, we need the sortable to 'refresh'
                        // so it can find the new/removed elements.
                        scope.$watch('ngModel.length', function() {
                            // Timeout to let ng-repeat modify the DOM
                            $timeout(function() {
                                // ensure that the jquery-ui-sortable widget instance
                                // is still bound to the directive's element
                                if (!!getSortableWidgetInstance(element)) {
                                    element.sortable('refresh');
                                }
                            }, 0, false);
                        });

                        callbacks.start = function(e, ui) {
                            if (opts['ui-floating'] === 'auto') {
                                // since the drag has started, the element will be
                                // absolutely positioned, so we check its siblings
                                var siblings = ui.item.siblings();
                                var sortableWidgetInstance = getSortableWidgetInstance(angular.element(e.target));
                                sortableWidgetInstance.floating = isFloating(siblings);
                            }

                            // Save the starting position of dragged item
                            ui.item.sortable = {
                                model: ngModel.$modelValue[ui.item.index()],
                                index: ui.item.index(),
                                source: ui.item.parent(),
                                sourceModel: ngModel.$modelValue,
                                cancel: function () {
                                    ui.item.sortable._isCanceled = true;
                                },
                                isCanceled: function () {
                                    return ui.item.sortable._isCanceled;
                                },
                                isCustomHelperUsed: function () {
                                    return !!ui.item.sortable._isCustomHelperUsed;
                                },
                                _isCanceled: false,
                                _isCustomHelperUsed: ui.item.sortable._isCustomHelperUsed,
                                _destroy: function () {
                                    angular.forEach(ui.item.sortable, function(value, key) {
                                        ui.item.sortable[key] = undefined;
                                    });
                                }
                            };
                        };

                        callbacks.activate = function(e, ui) {
                            // We need to make a copy of the current element's contents so
                            // we can restore it after sortable has messed it up.
                            // This is inside activate (instead of start) in order to save
                            // both lists when dragging between connected lists.
                            savedNodes = element.contents();

                            // If this list has a placeholder (the connected lists won't),
                            // don't inlcude it in saved nodes.
                            var placeholder = element.sortable('option','placeholder');

                            // placeholder.element will be a function if the placeholder, has
                            // been created (placeholder will be an object).  If it hasn't
                            // been created, either placeholder will be false if no
                            // placeholder class was given or placeholder.element will be
                            // undefined if a class was given (placeholder will be a string)
                            if (placeholder && placeholder.element && typeof placeholder.element === 'function') {
                                var phElement = placeholder.element();
                                // workaround for jquery ui 1.9.x,
                                // not returning jquery collection
                                phElement = angular.element(phElement);

                                // exact match with the placeholder's class attribute to handle
                                // the case that multiple connected sortables exist and
                                // the placehoilder option equals the class of sortable items
                                var excludes = element.find('[class="' + phElement.attr('class') + '"]:not([ng-repeat], [data-ng-repeat])');

                                savedNodes = savedNodes.not(excludes);
                            }

                            // save the directive's scope so that it is accessible from ui.item.sortable
                            var connectedSortables = ui.item.sortable._connectedSortables || [];

                            connectedSortables.push({
                                element: element,
                                scope: scope
                            });

                            ui.item.sortable._connectedSortables = connectedSortables;
                        };

                        callbacks.update = function(e, ui) {
                            // Save current drop position but only if this is not a second
                            // update that happens when moving between lists because then
                            // the value will be overwritten with the old value
                            if(!ui.item.sortable.received) {
                                ui.item.sortable.dropindex = ui.item.index();
                                var droptarget = ui.item.parent();
                                ui.item.sortable.droptarget = droptarget;

                                var droptargetScope = getElementScope(ui.item.sortable._connectedSortables, droptarget);
                                ui.item.sortable.droptargetModel = droptargetScope.ngModel;

                                // Cancel the sort (let ng-repeat do the sort for us)
                                // Don't cancel if this is the received list because it has
                                // already been canceled in the other list, and trying to cancel
                                // here will mess up the DOM.
                                element.sortable('cancel');
                            }

                            // Put the nodes back exactly the way they started (this is very
                            // important because ng-repeat uses comment elements to delineate
                            // the start and stop of repeat sections and sortable doesn't
                            // respect their order (even if we cancel, the order of the
                            // comments are still messed up).
                            if (hasSortingHelper(element, ui) && !ui.item.sortable.received &&
                                element.sortable( 'option', 'appendTo' ) === 'parent') {
                                // restore all the savedNodes except .ui-sortable-helper element
                                // (which is placed last). That way it will be garbage collected.
                                savedNodes = savedNodes.not(savedNodes.last());
                            }
                            savedNodes.appendTo(element);

                            // If this is the target connected list then
                            // it's safe to clear the restored nodes since:
                            // update is currently running and
                            // stop is not called for the target list.
                            if(ui.item.sortable.received) {
                                savedNodes = null;
                            }

                            // If received is true (an item was dropped in from another list)
                            // then we add the new item to this list otherwise wait until the
                            // stop event where we will know if it was a sort or item was
                            // moved here from another list
                            if(ui.item.sortable.received && !ui.item.sortable.isCanceled()) {
                                scope.$apply(function () {
                                    ngModel.$modelValue.splice(ui.item.sortable.dropindex, 0,
                                        ui.item.sortable.moved);
                                });
                            }
                        };

                        callbacks.stop = function(e, ui) {
                            // If the received flag hasn't be set on the item, this is a
                            // normal sort, if dropindex is set, the item was moved, so move
                            // the items in the list.
                            if(!ui.item.sortable.received &&
                                ('dropindex' in ui.item.sortable) &&
                                !ui.item.sortable.isCanceled()) {

                                scope.$apply(function () {
                                    ngModel.$modelValue.splice(
                                        ui.item.sortable.dropindex, 0,
                                        ngModel.$modelValue.splice(ui.item.sortable.index, 1)[0]);
                                });
                            } else {
                                // if the item was not moved, then restore the elements
                                // so that the ngRepeat's comment are correct.
                                if ((!('dropindex' in ui.item.sortable) || ui.item.sortable.isCanceled()) &&
                                    !hasSortingHelper(element, ui)) {
                                    savedNodes.appendTo(element);
                                }
                            }

                            // It's now safe to clear the savedNodes
                            // since stop is the last callback.
                            savedNodes = null;
                        };

                        callbacks.receive = function(e, ui) {
                            // An item was dropped here from another list, set a flag on the
                            // item.
                            ui.item.sortable.received = true;
                        };

                        callbacks.remove = function(e, ui) {
                            // Workaround for a problem observed in nested connected lists.
                            // There should be an 'update' event before 'remove' when moving
                            // elements. If the event did not fire, cancel sorting.
                            if (!('dropindex' in ui.item.sortable)) {
                                element.sortable('cancel');
                                ui.item.sortable.cancel();
                            }

                            // Remove the item from this list's model and copy data into item,
                            // so the next list can retrive it
                            if (!ui.item.sortable.isCanceled()) {
                                scope.$apply(function () {
                                    ui.item.sortable.moved = ngModel.$modelValue.splice(
                                        ui.item.sortable.index, 1)[0];
                                });
                            }
                        };

                        wrappers.helper = function (inner) {
                            if (inner && typeof inner === 'function') {
                                return function (e, item) {
                                    var innerResult = inner.apply(this, arguments);
                                    item.sortable._isCustomHelperUsed = item !== innerResult;
                                    return innerResult;
                                };
                            }
                            return inner;
                        };

                        scope.$watch('uiSortable', function(newVal /*, oldVal*/) {
                            // ensure that the jquery-ui-sortable widget instance
                            // is still bound to the directive's element
                            var sortableWidgetInstance = getSortableWidgetInstance(element);
                            if (!!sortableWidgetInstance) {
                                angular.forEach(newVal, function(value, key) {
                                    // if it's a custom option of the directive,
                                    // handle it approprietly
                                    if (key in directiveOpts) {
                                        if (key === 'ui-floating' && (value === false || value === true)) {
                                            sortableWidgetInstance.floating = value;
                                        }

                                        opts[key] = value;
                                        return;
                                    }

                                    if (callbacks[key]) {
                                        if( key === 'stop' ){
                                            // call apply after stop
                                            value = combineCallbacks(
                                                value, function() { scope.$apply(); });

                                            value = combineCallbacks(value, afterStop);
                                        }
                                        // wrap the callback
                                        value = combineCallbacks(callbacks[key], value);
                                    } else if (wrappers[key]) {
                                        value = wrappers[key](value);
                                    }

                                    opts[key] = value;
                                    element.sortable('option', key, value);
                                });
                            }
                        }, true);

                        angular.forEach(callbacks, function(value, key) {
                            opts[key] = combineCallbacks(value, opts[key]);
                            if( key === 'stop' ){
                                opts[key] = combineCallbacks(opts[key], afterStop);
                            }
                        });

                    } else {
                        $log.info('ui.sortable: ngModel not provided!', element);
                    }

                    // Create sortable
                    element.sortable(opts);
                }
            };
        }
    ]);
/**
 * Binds a TinyMCE widget to <textarea> elements.
 */
angular.module('ui.tinymce', [])
    .value('uiTinymceConfig', {})
    .directive('uiTinymce', ['$rootScope', '$compile', '$timeout', '$window', '$sce', 'uiTinymceConfig', 'uiTinymceService', function($rootScope, $compile, $timeout, $window, $sce, uiTinymceConfig, uiTinymceService) {
        uiTinymceConfig = uiTinymceConfig || {};

        if (uiTinymceConfig.baseUrl) {
            tinymce.baseURL = uiTinymceConfig.baseUrl;
        }

        return {
            require: ['ngModel', '^?form'],
            priority: 599,
            link: function(scope, element, attrs, ctrls) {
                if (!$window.tinymce) {
                    return;
                }

                var ngModel = ctrls[0],
                    form = ctrls[1] || null;

                var expression, options = {
                        debounce: true
                    }, tinyInstance,
                    updateView = function(editor) {
                        var content = editor.getContent({format: options.format}).trim();
                        content = $sce.trustAsHtml(content);

                        ngModel.$setViewValue(content);
                        if (!$rootScope.$$phase) {
                            scope.$digest();
                        }
                    };

                function toggleDisable(disabled) {
                    if (disabled) {
                        ensureInstance();

                        if (tinyInstance) {
                            tinyInstance.getBody().setAttribute('contenteditable', false);
                        }
                    } else {
                        ensureInstance();

                        if (tinyInstance && !tinyInstance.readonly && tinyInstance.getDoc()) {
                            tinyInstance.getBody().setAttribute('contenteditable', true);
                        }
                    }
                }

                // fetch a unique ID from the service
                var uniqueId = uiTinymceService.getUniqueId();
                attrs.$set('id', uniqueId);

                expression = {};

                angular.extend(expression, scope.$eval(attrs.uiTinymce));

                //Debounce update and save action
                var debouncedUpdate = (function(debouncedUpdateDelay) {
                    var debouncedUpdateTimer;
                    return function(ed) {
                        $timeout.cancel(debouncedUpdateTimer);
                        debouncedUpdateTimer = $timeout(function() {
                            return (function(ed) {
                                if (ed.isDirty()) {
                                    ed.save();
                                    updateView(ed);
                                }
                            })(ed);
                        }, debouncedUpdateDelay);
                    };
                })(400);

                var setupOptions = {
                    // Update model when calling setContent
                    // (such as from the source editor popup)
                    setup: function(ed) {
                        ed.on('init', function() {
                            ngModel.$render();
                            ngModel.$setPristine();
                            ngModel.$setUntouched();
                            if (form) {
                                form.$setPristine();
                            }
                        });

                        // Update model when:
                        // - a button has been clicked [ExecCommand]
                        // - the editor content has been modified [change]
                        // - the node has changed [NodeChange]
                        // - an object has been resized (table, image) [ObjectResized]
                        ed.on('ExecCommand change NodeChange ObjectResized', function() {
                            if (!options.debounce) {
                                ed.save();
                                updateView(ed);
                                return;
                            }
                            debouncedUpdate(ed);
                        });

                        ed.on('blur', function() {
                            element[0].blur();
                            ngModel.$setTouched();
                            if (!$rootScope.$$phase) {
                                scope.$digest();
                            }
                        });

                        ed.on('remove', function() {
                            element.remove();
                        });

                        if (uiTinymceConfig.setup) {
                            uiTinymceConfig.setup(ed, {
                                updateView: updateView
                            });
                        }

                        if (expression.setup) {
                            expression.setup(ed, {
                                updateView: updateView
                            });
                        }
                    },
                    format: expression.format || 'html',
                    selector: '#' + attrs.id
                };
                // extend options with initial uiTinymceConfig and
                // options from directive attribute value
                angular.extend(options, uiTinymceConfig, expression, setupOptions);
                // Wrapped in $timeout due to $tinymce:refresh implementation, requires
                // element to be present in DOM before instantiating editor when
                // re-rendering directive
                $timeout(function() {
                    if (options.baseURL){
                        tinymce.baseURL = options.baseURL;
                    }
                    var maybeInitPromise = tinymce.init(options);
                    if(maybeInitPromise && typeof maybeInitPromise.then === 'function') {
                        maybeInitPromise.then(function() {
                            toggleDisable(scope.$eval(attrs.ngDisabled));
                        });
                    } else {
                        toggleDisable(scope.$eval(attrs.ngDisabled));
                    }
                });

                ngModel.$formatters.unshift(function(modelValue) {
                    return modelValue ? $sce.trustAsHtml(modelValue) : '';
                });

                ngModel.$parsers.unshift(function(viewValue) {
                    return viewValue ? $sce.getTrustedHtml(viewValue) : '';
                });

                ngModel.$render = function() {
                    ensureInstance();

                    var viewValue = ngModel.$viewValue ?
                        $sce.getTrustedHtml(ngModel.$viewValue) : '';

                    // instance.getDoc() check is a guard against null value
                    // when destruction & recreation of instances happen
                    if (tinyInstance &&
                        tinyInstance.getDoc()
                    ) {
                        tinyInstance.setContent(viewValue);
                        // Triggering change event due to TinyMCE not firing event &
                        // becoming out of sync for change callbacks
                        tinyInstance.fire('change');
                    }
                };

                attrs.$observe('disabled', toggleDisable);

                // This block is because of TinyMCE not playing well with removal and
                // recreation of instances, requiring instances to have different
                // selectors in order to render new instances properly
                var unbindEventListener = scope.$on('$tinymce:refresh', function(e, id) {
                    var eid = attrs.id;
                    if (angular.isUndefined(id) || id === eid) {
                        var parentElement = element.parent();
                        var clonedElement = element.clone();
                        clonedElement.removeAttr('id');
                        clonedElement.removeAttr('style');
                        clonedElement.removeAttr('aria-hidden');
                        tinymce.execCommand('mceRemoveEditor', false, eid);
                        parentElement.append($compile(clonedElement)(scope));
                        unbindEventListener();
                    }
                });

                scope.$on('$destroy', function() {
                    ensureInstance();

                    if (tinyInstance) {
                        tinyInstance.remove();
                        tinyInstance = null;
                    }
                });

                function ensureInstance() {
                    if (!tinyInstance) {
                        tinyInstance = tinymce.get(attrs.id);
                    }
                }
            }
        };
    }])
    .service('uiTinymceService', [
        /**
         * A service is used to create unique ID's, this prevents duplicate ID's if there are multiple editors on screen.
         */
        function() {
            var UITinymceService = function() {
                var ID_ATTR = 'ui-tinymce';
                // uniqueId keeps track of the latest assigned ID
                var uniqueId = 0;
                // getUniqueId returns a unique ID
                var getUniqueId = function() {
                    uniqueId ++;
                    return ID_ATTR + '-' + uniqueId;
                };
                // return the function as a public method of the service
                return {
                    getUniqueId: getUniqueId
                };
            };
            // return a new instance of the service
            return new UITinymceService();
        }
    ]);

'use strict';

angular.module('ui.bootstrap', [
    'ui.bootstrap.accordion',
    'ui.bootstrap.alert',
    'ui.bootstrap.buttons',
    'ui.bootstrap.carousel',
    'ui.bootstrap.dateparser',
    'ui.bootstrap.datepicker',
    'ui.bootstrap.dialog',
    'ui.bootstrap.dropdown',
    'ui.bootstrap.pager',
    'ui.bootstrap.pagination',
    'ui.bootstrap.popover',
    'ui.bootstrap.progressbar',
    'ui.bootstrap.slider',
    'ui.bootstrap.tabs',
    'ui.bootstrap.timepicker',
    'ui.bootstrap.tooltip',
    'ui.bootstrap.typeahead'
]);
'use strict';

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse'])

.constant('accordionConfig', {
    closeOthers: true
})

.controller('AccordionController', ['$scope', '$attrs', 'accordionConfig', function ($scope, $attrs, accordionConfig) {

    // This array keeps track of the accordion groups
    this.groups = [];

    // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
    this.closeOthers = function (openGroup) {
        var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
        if (closeOthers) {
            angular.forEach(this.groups, function (group) {
                if (group !== openGroup) {
                    group.isOpen = false;
                }
            });
        }
    };

    // This is called from the accordion-group directive to add itself to the accordion
    this.addGroup = function (groupScope) {
        var that = this;
        this.groups.push(groupScope);

        groupScope.$on('$destroy', function (event) {
            that.removeGroup(groupScope);
        });
    };

    // This is called from the accordion-group directive when to remove itself
    this.removeGroup = function (group) {
        var index = this.groups.indexOf(group);
        if (index !== -1) {
            this.groups.splice(this.groups.indexOf(group), 1);
        }
    };

}])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive('accordion', function () {
    return {
        restrict: 'EA',
        controller: 'AccordionController',
        transclude: true,
        replace: false,
        template: '<div class="accordion" ng-transclude></div>'
    };
})

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive('accordionGroup', ['$parse', '$transition', '$timeout', function ($parse, $transition, $timeout) {
    return {
        require: '^accordion',         // We need this directive to be inside an accordion
        restrict: 'EA',
        transclude: true,              // It transcludes the contents of the directive into the template
        replace: true,                // The element containing the directive will be replaced with the template
        template:'<div class="accordion-group">' +
                    '<div class="accordion-heading"><a class="accordion-toggle" ng-click="toggleIsOpen()" accordion-transclude="heading"><span class="pull-right"><i ng-class="{\'fa fa-chevron-up\': isOpen, \'fa fa-chevron-down\': !isOpen}"></i></span>{{heading}}</a></div>' +
                    '<div class="accordion-body" collapse="!isOpen">' +
                        '<div class="accordion-inner" ng-transclude></div>' +
                    '</div>' +
                 '</div>',
        scope: {
            heading: '@',       // Create an isolated scope and interpolate the heading attribute onto this scope
            beforeOpen: '&',    // Use this if you need to change the content before the opening transition calculates the required height
            afterClose: '&'     // Use this to change the content back after the collapsing transition is complete
        },
        controller: ['$scope', function ($scope) {
            this.setHeading = function (element) {
                this.heading = element;
            };
        }],
        link: function (scope, element, attrs, accordionCtrl) {
            var getIsOpen, setIsOpen;

            accordionCtrl.addGroup(scope);

            scope.isOpen = false;

            if (attrs.isOpen) {
                getIsOpen = $parse(attrs.isOpen);
                setIsOpen = getIsOpen.assign;

                scope.$watch(
                  function watchIsOpen() { return getIsOpen(scope.$parent); },
                  function updateOpen(value) { scope.isOpen = value; }
                );

                scope.isOpen = getIsOpen ? getIsOpen(scope.$parent) : false;
            }

            scope.toggleIsOpen = function () {
                if (!scope.isOpen) {
                    scope.beforeOpen();
                }
                //wrapped in timeout to allow beforeOpen method to rerender accordion body's html content first
                $timeout(function () {
                    scope.isOpen = !scope.isOpen;

                    if (!scope.isOpen) {
                        //wrapped in 1 sec timeout to allow collapse transition to happen before afterClose is executed
                        $timeout(function () {
                            scope.afterClose();
                        });
                    }
                });
            };

            scope.$watch('isOpen', function (value) {
                if (value) {
                    accordionCtrl.closeOthers(scope);
                }
                if (setIsOpen) {
                    setIsOpen(scope.$parent, value);
                }
            });
        }
    };
}])

// Use accordion-heading below an accordion-group to provide a heading containing HTML
// <accordion-group>
//   <accordion-heading>Heading containing HTML - <img src="..."></accordion-heading>
// </accordion-group>
.directive('accordionHeading', function () {
    return {
        restrict: 'E',
        transclude: true,   // Grab the contents to be used as the heading
        template: '',       // In effect remove this element!
        replace: true,
        require: '^accordionGroup',
        compile: function (element, attr, transclude) {
            return function link(scope, element, attr, accordionGroupCtrl) {
                // Pass the heading to the accordion-group controller
                // so that it can be transcluded into the right place in the template
                // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
                accordionGroupCtrl.setHeading(transclude(scope, function () { }));
            };
        }
    };
})

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
// <div class="accordion-group">
//   <div class="accordion-heading" ><a ... accordion-transclude="heading">...</a></div>
//   ...
// </div>
.directive('accordionTransclude', function () {
    return {
        require: '^accordionGroup',
        link: function (scope, element, attr, controller) {
            scope.$watch(function () { return controller[attr.accordionTransclude]; }, function (heading) {
                if (heading) {
                    element.html('');
                    element.append(heading);
                }
            });
        }
    };
});

angular.module("ui.bootstrap.alert", []).directive('alert', function () {
    return {
        restrict: 'EA',
        template:   '<div class="alert" ng-class=\'type && "alert-" + type\'>' + 
                        '<button ng-show="closeable" type="button" class="close" ng-click="close()">&times;</button>' +
                        '<div ng-transclude></div>' + 
                    '</div>',
        transclude: true,
        replace: true,
        scope: {
            type: '=',
            close: '&'
        },
        link: function(scope, iElement, iAttrs) {
            scope.closeable = "close" in iAttrs;
        }
    };
});
angular.module('ui.bootstrap.bindHtml', [])

.directive('bindHtmlUnsafe', function () {
    return function (scope, element, attr) {
        element.addClass('ng-binding').data('$binding', attr.bindHtmlUnsafe);
        scope.$watch(attr.bindHtmlUnsafe, function bindHtmlUnsafeWatchAction(value) {
            element.html(value || '');
        });
    };
});
'use strict';

angular.module('ui.bootstrap.buttons', [])

    .constant('buttonConfig', {
        activeClass: 'active',
        toggleEvent: 'click'
    })

    .directive('btnRadio', ['buttonConfig', function (buttonConfig) {
        var activeClass = buttonConfig.activeClass || 'active';
        var toggleEvent = buttonConfig.toggleEvent || 'click';

        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {

                //model -> UI
                ngModelCtrl.$render = function () {
                    element.toggleClass(activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.btnRadio)));
                };

                //ui->model
                element.on(toggleEvent, function () {
                    if (!element.hasClass(activeClass)) {
                        scope.$apply(function () {
                            ngModelCtrl.$setViewValue(scope.$eval(attrs.btnRadio));
                            ngModelCtrl.$render();
                        });
                    }
                });
            }
        };
    }])

    .directive('btnCheckbox', ['buttonConfig', function (buttonConfig) {
        var activeClass = buttonConfig.activeClass || 'active';
        var toggleEvent = buttonConfig.toggleEvent || 'click';

        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {

                function getTrueValue() {
                    var trueValue = scope.$eval(attrs.btnCheckboxTrue);
                    return angular.isDefined(trueValue) ? trueValue : true;
                }

                function getFalseValue() {
                    var falseValue = scope.$eval(attrs.btnCheckboxFalse);
                    return angular.isDefined(falseValue) ? falseValue : false;
                }

                //model -> UI
                ngModelCtrl.$render = function () {
                    element.toggleClass(activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
                };

                //ui->model
                element.on(toggleEvent, function () {
                    scope.$apply(function () {
                        ngModelCtrl.$setViewValue(element.hasClass(activeClass) ? getFalseValue() : getTrueValue());
                        ngModelCtrl.$render();
                    });
                });
            }
        };
    }]);

angular.module('ui.bootstrap.carousel', ['ui.bootstrap.transition'])
    .controller('CarouselController', ['$scope', '$timeout', '$transition', function ($scope, $timeout, $transition) {
        var self = this,
            slides = self.slides = [],
            currentIndex = -1,
            currentTimeout, isPlaying;
        self.currentSlide = null;

        var destroyed = false;
        /* direction: "prev" or "next" */
        self.select = function(nextSlide, direction) {
            var nextIndex = slides.indexOf(nextSlide);
            //Decide direction if it's not given
            if (direction === undefined) {
                direction = nextIndex > currentIndex ? 'next' : 'prev';
            }
            if (nextSlide && nextSlide !== self.currentSlide) {
                if ($scope.$currentTransition) {
                    $scope.$currentTransition.cancel();
                    //Timeout so ng-class in template has time to fix classes for finished slide
                    $timeout(goNext);
                } else {
                    goNext();
                }
            }
            function goNext() {
                // Scope has been destroyed, stop here.
                if (destroyed) { return; }
                //If we have a slide to transition from and we have a transition type and we're allowed, go
                if (self.currentSlide && angular.isString(direction) && !$scope.noTransition && nextSlide.$element) {
                    //We shouldn't do class manip in here, but it's the same weird thing bootstrap does. need to fix sometime
                    nextSlide.$element.addClass(direction);
                    var reflow = nextSlide.$element[0].offsetWidth; //force reflow

                    //Set all other slides to stop doing their stuff for the new transition
                    angular.forEach(slides, function(slide) {
                        angular.extend(slide, {direction: '', entering: false, leaving: false, active: false});
                    });
                    angular.extend(nextSlide, {direction: direction, active: true, entering: true});
                    angular.extend(self.currentSlide||{}, {direction: direction, leaving: true});

                    $scope.$currentTransition = $transition(nextSlide.$element, {});
                    //We have to create new pointers inside a closure since next & current will change
                    (function(next,current) {
                        $scope.$currentTransition.then(
                            function(){ transitionDone(next, current); },
                            function(){ transitionDone(next, current); }
                        );
                    }(nextSlide, self.currentSlide));
                } else {
                    transitionDone(nextSlide, self.currentSlide);
                }
                self.currentSlide = nextSlide;
                currentIndex = nextIndex;
                //every time you change slides, reset the timer
                restartTimer();
            }
            function transitionDone(next, current) {
                angular.extend(next, {direction: '', active: true, leaving: false, entering: false});
                angular.extend(current||{}, {direction: '', active: false, leaving: false, entering: false});
                $scope.$currentTransition = null;
            }
        };
        $scope.$on('$destroy', function () {
            destroyed = true;
        });

        /* Allow outside people to call indexOf on slides array */
        self.indexOfSlide = function(slide) {
            return slides.indexOf(slide);
        };

        $scope.next = function() {
            var newIndex = (currentIndex + 1) % slides.length;

            //Prevent this user-triggered transition from occurring if there is already one in progress
            if (!$scope.$currentTransition) {
                return self.select(slides[newIndex], 'next');
            }
        };

        $scope.prev = function() {
            var newIndex = currentIndex - 1 < 0 ? slides.length - 1 : currentIndex - 1;

            //Prevent this user-triggered transition from occurring if there is already one in progress
            if (!$scope.$currentTransition) {
                return self.select(slides[newIndex], 'prev');
            }
        };

        $scope.select = function(slide) {
            self.select(slide);
        };

        $scope.isActive = function(slide) {
            return self.currentSlide === slide;
        };

        $scope.slides = function() {
            return slides;
        };

        $scope.$watch('interval', restartTimer);
        $scope.$on('$destroy', resetTimer);

        function restartTimer() {
            resetTimer();
            var interval = +$scope.interval;
            if (!isNaN(interval) && interval>=0) {
                currentTimeout = $timeout(timerFn, interval);
            }
        }

        function resetTimer() {
            if (currentTimeout) {
                $timeout.cancel(currentTimeout);
                currentTimeout = null;
            }
        }

        function timerFn() {
            if (isPlaying) {
                $scope.next();
                restartTimer();
            } else {
                $scope.pause();
            }
        }

        $scope.play = function() {
            if (!isPlaying) {
                isPlaying = true;
                restartTimer();
            }
        };
        $scope.pause = function() {
            if (!$scope.noPause) {
                isPlaying = false;
                resetTimer();
            }
        };

        self.addSlide = function(slide, element) {
            slide.$element = element;
            slides.push(slide);
            //if this is the first slide or the slide is set to active, select it
            if(slides.length === 1 || slide.active) {
                self.select(slides[slides.length-1]);
                if (slides.length == 1) {
                    $scope.play();
                }
            } else {
                slide.active = false;
            }
        };

        self.removeSlide = function(slide) {
            //get the index of the slide inside the carousel
            var index = slides.indexOf(slide);
            slides.splice(index, 1);
            if (slides.length > 0 && slide.active) {
                if (index >= slides.length) {
                    self.select(slides[index-1]);
                } else {
                    self.select(slides[index]);
                }
            } else if (currentIndex > index) {
                currentIndex--;
            }
        };

    }])

    .directive('carousel', [function() {
        return {
            restrict: 'EA',
            transclude: true,
            replace: true,
            controller: 'CarouselController',
            require: 'carousel',
            template:   '<div ng-mouseenter="pause()" ng-mouseleave="play()" class="carousel" ng-swipe-right="prev()" ng-swipe-left="next()">' +
                            '<ol class="carousel-indicators" ng-hide="slides().length < 2">' +
                                '<li ng-repeat="slide in slides()" ng-class="{active: isActive(slide)}" ng-click="select(slide)"></li>' +
                            '</ol>' +
                            '<div class="carousel-inner" ng-transclude></div>' +
                            '<a ng-click="prev()" class="carousel-control left" ng-hide="slides().length < 2 || (noWrap && isActive(slides()[0])) ">&lsaquo;</a>' +
                            '<a ng-click="next()" class="carousel-control right" ng-hide="slides().length < 2 || (noWrap && isActive(slides()[slides().length - 1]))">&rsaquo;</a>' +
                        '</div>',
            scope: {
                interval: '=',
                noTransition: '=',
                noPause: '=',
                noWrap: '='
            }
        };
    }])


    .directive('slide', function() {
        return {
            require: '^carousel',
            restrict: 'EA',
            transclude: true,
            replace: true,
            template: '<div ng-class="{\'active\': leaving || (active && !entering),\'prev\': (next || active) && direction==\'prev\',\'next\': (next || active) && direction==\'next\',\'right\': direction==\'prev\',\'left\': direction==\'next\'}" class="item text-center" ng-transclude></div>',
            scope: {
                active: '=?'
            },
            link: function (scope, element, attrs, carouselCtrl) {
                carouselCtrl.addSlide(scope, element);
                //when the scope is destroyed then remove the slide from the current slides array
                scope.$on('$destroy', function() {
                    carouselCtrl.removeSlide(scope);
                });

                scope.$watch('active', function(active) {
                    if (active) {
                        carouselCtrl.select(scope);
                    }
                });
            }
        };
    });
angular.module('ui.bootstrap.collapse', ['ui.bootstrap.transition'])

// The collapsible directive indicates a block of html that will expand and collapse
.directive('collapse', ['$transition', function ($transition) {
    // CSS transitions don't work with height: auto, so we have to manually change the height to a
    // specific value and then once the animation completes, we can reset the height to auto.
    // Unfortunately if you do this while the CSS transitions are specified (i.e. in the CSS class
    // "collapse") then you trigger a change to height 0 in between.
    // The fix is to remove the "collapse" CSS class while changing the height back to auto - phew!
    var fixUpHeight = function (scope, element, height) {
        // We remove the collapse CSS class to prevent a transition when we change to height: auto
        element.removeClass('collapse');
        element.css({ height: height });
        // It appears that  reading offsetWidth makes the browser realise that we have changed the
        // height already :-/
        var x = element[0].offsetWidth;
        element.addClass('collapse');
    };

    return {
        link: function (scope, element, attrs) {

            var isCollapsed;
            var initialAnimSkip = true;
            scope.$watch(function () { return element[0].scrollHeight; }, function (value) {
                //The listener is called when scollHeight changes
                //It actually does on 2 scenarios: 
                // 1. Parent is set to display none
                // 2. angular bindings inside are resolved
                //When we have a change of scrollHeight we are setting again the correct height if the group is opened
                if (element[0].scrollHeight !== 0) {
                    if (!isCollapsed) {
                        if (initialAnimSkip) {
                            fixUpHeight(scope, element, element[0].scrollHeight + 'px');
                        } else {
                            fixUpHeight(scope, element, 'auto');
                        }
                    }
                }
            });

            scope.$watch(attrs.collapse, function (value) {
                if (value) {
                    collapse();
                } else {
                    expand();
                }
                //$(element[0]).toggleClass("in");
                //element.toggleClass("in");
            });


            var currentTransition;
            var doTransition = function (change) {
                if (currentTransition) {
                    currentTransition.cancel();
                }
                currentTransition = $transition(element, change);
                currentTransition.then(
                  function () { currentTransition = undefined; },
                  function () { currentTransition = undefined; }
                );
                return currentTransition;
            };

            var expand = function () {
                if (initialAnimSkip) {
                    initialAnimSkip = false;
                    if (!isCollapsed) {
                        fixUpHeight(scope, element, 'auto');
                        element.addClass('in');
                    }
                } else {
                    doTransition({ height: element[0].scrollHeight + 'px' })
                    .then(function () {
                        // This check ensures that we don't accidentally update the height if the user has closed
                        // the group while the animation was still running
                        if (!isCollapsed) {
                            fixUpHeight(scope, element, 'auto');
                            element.addClass('in');
                        }
                    });
                }
                isCollapsed = false;
            };

            var collapse = function () {
                isCollapsed = true;
                element.removeClass('in');

                if (initialAnimSkip) {
                    initialAnimSkip = false;
                    fixUpHeight(scope, element, 0);
                } else {
                    fixUpHeight(scope, element, element[0].scrollHeight + 'px');
                    doTransition({ 'height': '0' });
                }
            };
        }
    };
}]);
angular.module('ui.bootstrap.dateparser', [])

    .service('dateParser', ['$locale', 'orderByFilter', function($locale, orderByFilter) {
        // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
        var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

        this.parsers = {};

        var formatCodeToRegex = {
            'yyyy': {
                regex: '\\d{4}',
                apply: function(value) { this.year = +value; }
            },
            'yy': {
                regex: '\\d{2}',
                apply: function(value) { this.year = +value + 2000; }
            },
            'y': {
                regex: '\\d{1,4}',
                apply: function(value) { this.year = +value; }
            },
            'MMMM': {
                regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
                apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); }
            },
            'MMM': {
                regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
                apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); }
            },
            'MM': {
                regex: '0[1-9]|1[0-2]',
                apply: function(value) { this.month = value - 1; }
            },
            'M': {
                regex: '[1-9]|1[0-2]',
                apply: function(value) { this.month = value - 1; }
            },
            'dd': {
                regex: '[0-2][0-9]{1}|3[0-1]{1}',
                apply: function(value) { this.date = +value; }
            },
            'd': {
                regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
                apply: function(value) { this.date = +value; }
            },
            'EEEE': {
                regex: $locale.DATETIME_FORMATS.DAY.join('|')
            },
            'EEE': {
                regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|')
            },
            'HH': {
                regex: '(?:0|1)[0-9]|2[0-3]',
                apply: function(value) { this.hours = +value; }
            },
            'H': {
                regex: '1?[0-9]|2[0-3]',
                apply: function(value) { this.hours = +value; }
            },
            'mm': {
                regex: '[0-5][0-9]',
                apply: function(value) { this.minutes = +value; }
            },
            'm': {
                regex: '[0-9]|[1-5][0-9]',
                apply: function(value) { this.minutes = +value; }
            },
            'sss': {
                regex: '[0-9][0-9][0-9]',
                apply: function(value) { this.milliseconds = +value; }
            },
            'ss': {
                regex: '[0-5][0-9]',
                apply: function(value) { this.seconds = +value; }
            },
            's': {
                regex: '[0-9]|[1-5][0-9]',
                apply: function(value) { this.seconds = +value; }
            }
        };

        function createParser(format) {
            var map = [], regex = format.split('');

            angular.forEach(formatCodeToRegex, function(data, code) {
                var index = format.indexOf(code);

                if (index > -1) {
                    format = format.split('');

                    regex[index] = '(' + data.regex + ')';
                    format[index] = '$'; // Custom symbol to define consumed part of format
                    for (var i = index + 1, n = index + code.length; i < n; i++) {
                        regex[i] = '';
                        format[i] = '$';
                    }
                    format = format.join('');

                    map.push({ index: index, apply: data.apply });
                }
            });

            return {
                regex: new RegExp('^' + regex.join('') + '$'),
                map: orderByFilter(map, 'index')
            };
        }

        this.parse = function(input, format, baseDate) {
            if ( !angular.isString(input) || !format ) {
                return input;
            }

            format = $locale.DATETIME_FORMATS[format] || format;
            format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

            if ( !this.parsers[format] ) {
                this.parsers[format] = createParser(format);
            }

            var parser = this.parsers[format],
                regex = parser.regex,
                map = parser.map,
                results = input.match(regex);

            if ( results && results.length ) {
                var fields, dt;

                if( angular.isString(baseDate) ) {
                    baseDate = Date.create( baseDate );
                }

                if (baseDate) {
                    fields = {
                        year: baseDate.getFullYear(),
                        month: baseDate.getMonth(),
                        date: baseDate.getDate(),
                        hours: baseDate.getHours(),
                        minutes: baseDate.getMinutes(),
                        seconds: baseDate.getSeconds(),
                        milliseconds: baseDate.getMilliseconds()
                    };
                } else {
                    fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
                }

                for( var i = 1, n = results.length; i < n; i++ ) {
                    var mapper = map[i-1];
                    if ( mapper.apply ) {
                        mapper.apply.call(fields, results[i]);
                    }
                }

                if ( isValid(fields.year, fields.month, fields.date) ) {
                    dt = new Date(fields.year, fields.month, fields.date, fields.hours, fields.minutes, fields.seconds,
                        fields.milliseconds || 0);
                }

                return dt;
            }
        };

        // Check if date is valid for specific month (and year for February).
        // Month: 0 = Jan, 1 = Feb, etc
        function isValid(year, month, date) {
            if (date < 1) {
                return false;
            }

            if ( month === 1 && date > 28) {
                return date === 29 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
            }

            if ( month === 3 || month === 5 || month === 8 || month === 10) {
                return date < 31;
            }

            return true;
        }
    }]);

/* JBT - revert BS3 classes to BS2 in all datepicker templates */
/* JBT - bump z-index in datepicker popup.html so it shows up in modals */
/* JBT - add openOnFocus option so this directive isn't dumb anymore */
/* JBT - replace all instances of new Date() with Date.create to properly parse yyyy-MM-dd format */
/* JBT - add keydown handler for tab (code 9) to close popup */
/* JBT - don't focus calendar automatically when it opens */
/* NT - bugfix for unparseable null date value - https://github.com/angular-ui/bootstrap/issues/3701#issuecomment-105704751 */

angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.position'])

    .constant('datepickerConfig', {
        formatDay: 'dd',
        formatMonth: 'MMMM',
        formatYear: 'yyyy',
        formatDayHeader: 'EEE',
        formatDayTitle: 'MMMM yyyy',
        formatMonthTitle: 'yyyy',
        datepickerMode: 'day',
        minMode: 'day',
        maxMode: 'year',
        showWeeks: true,
        startingDay: 0,
        yearRange: 20,
        minDate: null,
        maxDate: null,
        shortcutPropagation: false
    })

    .controller('DatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$timeout', '$log', 'dateFilter', 'datepickerConfig', function($scope, $attrs, $parse, $interpolate, $timeout, $log, dateFilter, datepickerConfig) {
        var self = this,
            ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl;

        // Modes chain
        this.modes = ['day', 'month', 'year'];

        // Configuration attributes
        angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
            'minMode', 'maxMode', 'showWeeks', 'startingDay', 'yearRange', 'shortcutPropagation'], function( key, index ) {
            self[key] = angular.isDefined($attrs[key]) ? (index < 8 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : datepickerConfig[key];
        });

        // Watchable date attributes
        angular.forEach(['minDate', 'maxDate'], function( key ) {
            if ( $attrs[key] ) {
                $scope.$parent.$watch($parse($attrs[key]), function(value) {
                    self[key] = value ? Date.create(value) : null;
                    self.refreshView();
                });
            } else {
                self[key] = datepickerConfig[key] ? Date.create(datepickerConfig[key]) : null;
            }
        });

        $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
        $scope.maxMode = self.maxMode;
        $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

        if(angular.isDefined($attrs.initDate)) {
            this.activeDate = $scope.$parent.$eval($attrs.initDate) || Date.create();
            $scope.$parent.$watch($attrs.initDate, function(initDate){
                if(initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)){
                    self.activeDate = initDate;
                    self.refreshView();
                }
            });
        } else {
            this.activeDate =  Date.create();
        }

        $scope.isActive = function(dateObject) {
            if (self.compare(dateObject.date, self.activeDate) === 0) {
                $scope.activeDateId = dateObject.uid;
                return true;
            }
            return false;
        };

        this.init = function( ngModelCtrl_ ) {
            ngModelCtrl = ngModelCtrl_;

            this.setActiveDate();

            ngModelCtrl.$render = function() {
                self.render();
            };
        };

        this.setActiveDate = function(){
            if ( ngModelCtrl.$viewValue ) {
                var date = Date.create( ngModelCtrl.$viewValue ),
                    isValid = !isNaN(date);

                if ( isValid ) {
                    this.activeDate = date;
                } else {
                    $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
                }
                ngModelCtrl.$setValidity('date', isValid);
            }
        };
        this.render = function() {
            this.setActiveDate();
            this.refreshView();
        };

        this.refreshView = function() {
            if ( this.element ) {
                this._refreshView();

                var date = ngModelCtrl.$viewValue ? Date.create(ngModelCtrl.$viewValue) : null;
                ngModelCtrl.$setValidity('date-disabled', !date || (this.element && !this.isDisabled(date)));
            }
        };

        this.createDateObject = function(date, format) {
            var model = ngModelCtrl.$viewValue ? Date.create(ngModelCtrl.$viewValue) : null;
            return {
                date: date,
                label: dateFilter(date, format),
                selected: model && this.compare(date, model) === 0,
                disabled: this.isDisabled(date),
                current: this.compare(date, Date.create()) === 0,
                customClass: this.customClass(date)
            };
        };

        this.isDisabled = function( date ) {
            return ((this.minDate && this.compare(date, this.minDate) < 0) || (this.maxDate && this.compare(date, this.maxDate) > 0) || ($attrs.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode})));
        };

        this.customClass = function( date ) {
            return $scope.customClass({date: date, mode: $scope.datepickerMode});
        };

        // Split array into smaller arrays
        this.split = function(arr, size) {
            var arrays = [];
            while (arr.length > 0) {
                arrays.push(arr.splice(0, size));
            }
            return arrays;
        };

        $scope.select = function( date ) {
            if ( $scope.datepickerMode === self.minMode ) {
                var dt = ngModelCtrl.$viewValue ? Date.create( ngModelCtrl.$viewValue ) : Date.create(0, 0, 0, 0, 0, 0, 0);
                dt.setFullYear( date.getFullYear(), date.getMonth(), date.getDate() );
                ngModelCtrl.$setViewValue( dt );
                ngModelCtrl.$render();
            } else {
                self.activeDate = date;
                $scope.datepickerMode = self.modes[ self.modes.indexOf( $scope.datepickerMode ) - 1 ];
            }
        };

        $scope.move = function( direction ) {
            var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
                month = self.activeDate.getMonth() + direction * (self.step.months || 0);
            self.activeDate.setFullYear(year, month, 1);
            self.refreshView();
        };

        $scope.toggleMode = function( direction ) {
            direction = direction || 1;

            if (($scope.datepickerMode === self.maxMode && direction === 1) || ($scope.datepickerMode === self.minMode && direction === -1)) {
                return;
            }

            $scope.datepickerMode = self.modes[ self.modes.indexOf( $scope.datepickerMode ) + direction ];
        };

        // Key event mapper
        $scope.keys = { 13:'enter', 32:'space', 33:'pageup', 34:'pagedown', 35:'end', 36:'home', 37:'left', 38:'up', 39:'right', 40:'down' };

        var focusElement = function() {
            $timeout(function() {
                self.element[0].focus();
            }, 0 , false);
        };

        // Listen for focus requests from popup directive
        $scope.$on('datepicker.focus', focusElement);

        $scope.keydown = function( evt ) {
            var key = $scope.keys[evt.which];

            if ( !key || evt.shiftKey || evt.altKey ) {
                return;
            }

            evt.preventDefault();
            if(!self.shortcutPropagation){
                evt.stopPropagation();
            }

            if (key === 'enter' || key === 'space') {
                if ( self.isDisabled(self.activeDate)) {
                    return; // do nothing
                }
                $scope.select(self.activeDate);
                focusElement();
            } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
                $scope.toggleMode(key === 'up' ? 1 : -1);
                focusElement();
            } else {
                self.handleKeyDown(key, evt);
                self.refreshView();
            }
        };
    }])

    .directive( 'datepicker', function () {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: '_lib/angular-ui-bootstrap/template/datepicker/datepicker.html',
            scope: {
                datepickerMode: '=?',
                dateDisabled: '&',
                customClass: '&',
                shortcutPropagation: '&?'
            },
            require: ['datepicker', '?^ngModel'],
            controller: 'DatepickerController',
            link: function(scope, element, attrs, ctrls) {
                var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                if ( ngModelCtrl ) {
                    datepickerCtrl.init( ngModelCtrl );
                }
            }
        };
    })

    .directive('daypicker', ['dateFilter', function (dateFilter) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: '_lib/angular-ui-bootstrap/template/datepicker/day.html',
            require: '^datepicker',
            link: function(scope, element, attrs, ctrl) {
                scope.showWeeks = ctrl.showWeeks;

                ctrl.step = { months: 1 };
                ctrl.element = element;

                var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
                function getDaysInMonth( year, month ) {
                    return ((month === 1) && (year % 4 === 0) && ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
                }

                function getDates(startDate, n) {
                    var dates = new Array(n), current = Date.create(startDate), i = 0;
                    current.setHours(12); // Prevent repeated dates because of timezone bug
                    while ( i < n ) {
                        dates[i++] = Date.create(current);
                        current.setDate( current.getDate() + 1 );
                    }
                    return dates;
                }

                ctrl._refreshView = function() {
                    var year = ctrl.activeDate.getFullYear(),
                        month = ctrl.activeDate.getMonth(),
                        firstDayOfMonth = Date.create(year, month, 1),
                        difference = ctrl.startingDay - firstDayOfMonth.getDay(),
                        numDisplayedFromPreviousMonth = (difference > 0) ? 7 - difference : - difference,
                        firstDate = Date.create(firstDayOfMonth);

                    if ( numDisplayedFromPreviousMonth > 0 ) {
                        firstDate.setDate( - numDisplayedFromPreviousMonth + 1 );
                    }

                    // 42 is the number of days on a six-month calendar
                    var days = getDates(firstDate, 42);
                    for (var i = 0; i < 42; i ++) {
                        days[i] = angular.extend(ctrl.createDateObject(days[i], ctrl.formatDay), {
                            secondary: days[i].getMonth() !== month,
                            uid: scope.uniqueId + '-' + i
                        });
                    }

                    scope.labels = new Array(7);
                    for (var j = 0; j < 7; j++) {
                        scope.labels[j] = {
                            abbr: dateFilter(days[j].date, ctrl.formatDayHeader),
                            full: dateFilter(days[j].date, 'EEEE')
                        };
                    }

                    scope.title = dateFilter(ctrl.activeDate, ctrl.formatDayTitle);
                    scope.rows = ctrl.split(days, 7);

                    if ( scope.showWeeks ) {
                        scope.weekNumbers = [];
                        var thursdayIndex = (4 + 7 - ctrl.startingDay) % 7,
                            numWeeks = scope.rows.length;
                        for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
                            scope.weekNumbers.push(
                                getISO8601WeekNumber( scope.rows[curWeek][thursdayIndex].date ));
                        }
                    }
                };

                ctrl.compare = function(date1, date2) {
                    return (Date.create( date1.getFullYear(), date1.getMonth(), date1.getDate() ) - Date.create( date2.getFullYear(), date2.getMonth(), date2.getDate() ) );
                };

                function getISO8601WeekNumber(date) {
                    var checkDate = Date.create(date);
                    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
                    var time = checkDate.getTime();
                    checkDate.setMonth(0); // Compare with Jan 1
                    checkDate.setDate(1);
                    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
                }

                ctrl.handleKeyDown = function( key, evt ) {
                    var date = ctrl.activeDate.getDate();

                    if (key === 'left') {
                        date = date - 1;   // up
                    } else if (key === 'up') {
                        date = date - 7;   // down
                    } else if (key === 'right') {
                        date = date + 1;   // down
                    } else if (key === 'down') {
                        date = date + 7;
                    } else if (key === 'pageup' || key === 'pagedown') {
                        var month = ctrl.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
                        ctrl.activeDate.setMonth(month, 1);
                        date = Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth()), date);
                    } else if (key === 'home') {
                        date = 1;
                    } else if (key === 'end') {
                        date = getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth());
                    }
                    ctrl.activeDate.setDate(date);
                };

                ctrl.refreshView();
            }
        };
    }])

    .directive('monthpicker', ['dateFilter', function (dateFilter) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: '_lib/angular-ui-bootstrap/template/datepicker/month.html',
            require: '^datepicker',
            link: function(scope, element, attrs, ctrl) {
                ctrl.step = { years: 1 };
                ctrl.element = element;

                ctrl._refreshView = function() {
                    var months = new Array(12),
                        year = ctrl.activeDate.getFullYear();

                    for ( var i = 0; i < 12; i++ ) {
                        months[i] = angular.extend(ctrl.createDateObject(Date.create(year, i, 1), ctrl.formatMonth), {
                            uid: scope.uniqueId + '-' + i
                        });
                    }

                    scope.title = dateFilter(ctrl.activeDate, ctrl.formatMonthTitle);
                    scope.rows = ctrl.split(months, 3);
                };

                ctrl.compare = function(date1, date2) {
                    return Date.create( date1.getFullYear(), date1.getMonth() ) - Date.create( date2.getFullYear(), date2.getMonth() );
                };

                ctrl.handleKeyDown = function( key, evt ) {
                    var date = ctrl.activeDate.getMonth();

                    if (key === 'left') {
                        date = date - 1;   // up
                    } else if (key === 'up') {
                        date = date - 3;   // down
                    } else if (key === 'right') {
                        date = date + 1;   // down
                    } else if (key === 'down') {
                        date = date + 3;
                    } else if (key === 'pageup' || key === 'pagedown') {
                        var year = ctrl.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
                        ctrl.activeDate.setFullYear(year);
                    } else if (key === 'home') {
                        date = 0;
                    } else if (key === 'end') {
                        date = 11;
                    }
                    ctrl.activeDate.setMonth(date);
                };

                ctrl.refreshView();
            }
        };
    }])

    .directive('yearpicker', ['dateFilter', function (dateFilter) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: '_lib/angular-ui-bootstrap/template/datepicker/year.html',
            require: '^datepicker',
            link: function(scope, element, attrs, ctrl) {
                var range = ctrl.yearRange;

                ctrl.step = { years: range };
                ctrl.element = element;

                function getStartingYear( year ) {
                    return parseInt((year - 1) / range, 10) * range + 1;
                }

                ctrl._refreshView = function() {
                    var years = new Array(range);

                    for ( var i = 0, start = getStartingYear(ctrl.activeDate.getFullYear()); i < range; i++ ) {
                        years[i] = angular.extend(ctrl.createDateObject(Date.create(start + i, 0, 1), ctrl.formatYear), {
                            uid: scope.uniqueId + '-' + i
                        });
                    }

                    scope.title = [years[0].label, years[range - 1].label].join(' - ');
                    scope.rows = ctrl.split(years, 5);
                };

                ctrl.compare = function(date1, date2) {
                    return date1.getFullYear() - date2.getFullYear();
                };

                ctrl.handleKeyDown = function( key, evt ) {
                    var date = ctrl.activeDate.getFullYear();

                    if (key === 'left') {
                        date = date - 1;   // up
                    } else if (key === 'up') {
                        date = date - 5;   // down
                    } else if (key === 'right') {
                        date = date + 1;   // down
                    } else if (key === 'down') {
                        date = date + 5;
                    } else if (key === 'pageup' || key === 'pagedown') {
                        date += (key === 'pageup' ? - 1 : 1) * ctrl.step.years;
                    } else if (key === 'home') {
                        date = getStartingYear( ctrl.activeDate.getFullYear() );
                    } else if (key === 'end') {
                        date = getStartingYear( ctrl.activeDate.getFullYear() ) + range - 1;
                    }
                    ctrl.activeDate.setFullYear(date);
                };

                ctrl.refreshView();
            }
        };
    }])

    .constant('datepickerPopupConfig', {
        datepickerPopup: 'yyyy-MM-dd',
        html5Types: {
            date: 'yyyy-MM-dd',
            'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
            'month': 'yyyy-MM'
        },
        currentText: 'Today',
        clearText: 'Clear',
        closeText: 'Done',
        closeOnDateSelection: true,
        appendToBody: false,
        openOnFocus: false,
        showButtonBar: true,
        placement: 'bottom-left',
        datepickerPopupTemplateUrl: '_lib/angular-ui-bootstrap/template/datepicker/popup.html',
        datepickerTemplateUrl: '_lib/angular-ui-bootstrap/template/datepicker/datepicker.html'
    })

    .directive('datepickerPopup', ['$compile', '$parse', '$document', '$window', '$timeout', '$position', 'dateFilter', 'dateParser', 'datepickerPopupConfig', 'ZIndexCalculationService',
        function ($compile, $parse, $document, $window, $timeout, $position, dateFilter, dateParser, datepickerPopupConfig, ZIndexCalculationService) {
            return {
                restrict: 'EA',
                require: 'ngModel',
                scope: {
                    isOpen: '=?',
                    currentText: '@',
                    clearText: '@',
                    closeText: '@',
                    dateDisabled: '&',
                    customClass: '&'
                },
                link: function(scope, element, attrs, ngModel) {
                    var dateFormat, scrollParentEl, $popup, frame,
                        closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection,
                        appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody,
                        openOnFocus = angular.isDefined(attrs.datepickerOpenOnFocus) ? scope.$parent.$eval(attrs.datepickerOpenOnFocus) : datepickerPopupConfig.openOnFocus,
                        placement = angular.isDefined(attrs.popupPlacement) ? scope.$parent.$eval(attrs.popupPlacement) : datepickerPopupConfig.placement,
                        datepickerPopupTemplateUrl = angular.isDefined(attrs.datepickerPopupTemplateUrl) ? attrs.datepickerPopupTemplateUrl : datepickerPopupConfig.datepickerPopupTemplateUrl,
                        datepickerTemplateUrl = angular.isDefined(attrs.datepickerTemplateUrl) ? attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;

                    scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;

                    scope.getText = function( key ) {
                        return scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
                    };

                    var isHtml5DateInput = false;
                    if (datepickerPopupConfig.html5Types[attrs.type]) {
                        dateFormat = datepickerPopupConfig.html5Types[attrs.type];
                        isHtml5DateInput = true;
                    } else {
                        dateFormat = attrs.datepickerPopup || datepickerPopupConfig.datepickerPopup;
                        attrs.$observe('datepickerPopup', function(value, oldValue) {
                            var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
                            // Invalidate the $modelValue to ensure that formatters re-run
                            // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
                            if (newDateFormat !== dateFormat) {
                                dateFormat = newDateFormat;
                                ngModel.$modelValue = null;

                                if (!dateFormat) {
                                    throw new Error('datepickerPopup must have a date format specified.');
                                }
                            }
                        });
                    }

                    if (!dateFormat) {
                        throw new Error('datepickerPopup must have a date format specified.');
                    }

                    if (isHtml5DateInput && attrs.datepickerPopup) {
                        throw new Error('HTML5 date input types do not support custom formats.');
                    }

                    // popup element used to display calendar
                    var popupEl = angular.element('<div datepicker-popup-wrap><div datepicker></div></div>');
                    popupEl.attr({
                        'ng-model': 'date',
                        'ng-change': 'dateSelection(date)',
                        'template-url': datepickerPopupTemplateUrl
                    });

                    function cameltoDash( string ){
                        return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
                    }

                    // datepicker element
                    var datepickerEl = angular.element(popupEl.children()[0]);
                    datepickerEl.attr('template-url', datepickerTemplateUrl);
                    if (isHtml5DateInput) {
                        if (attrs.type == 'month') {
                            datepickerEl.attr('datepicker-mode', '"month"');
                            datepickerEl.attr('min-mode', 'month');
                        }
                    }

                    if ( attrs.datepickerOptions ) {
                        var options = scope.$parent.$eval(attrs.datepickerOptions);
                        if(options.initDate) {
                            scope.initDate = options.initDate;
                            datepickerEl.attr( 'init-date', 'initDate' );
                            delete options.initDate;
                        }
                        angular.forEach(options, function( value, option ) {
                            datepickerEl.attr( cameltoDash(option), value );
                        });
                    }

                    scope.watchData = {};
                    angular.forEach(['minDate', 'maxDate', 'datepickerMode', 'initDate', 'shortcutPropagation'], function( key ) {
                        if ( attrs[key] ) {
                            var getAttribute = $parse(attrs[key]);
                            scope.$parent.$watch(getAttribute, function(value){
                                scope.watchData[key] = value;
                            });
                            datepickerEl.attr(cameltoDash(key), 'watchData.' + key);

                            // Propagate changes from datepicker to outside
                            if ( key === 'datepickerMode' ) {
                                var setAttribute = getAttribute.assign;
                                scope.$watch('watchData.' + key, function(value, oldvalue) {
                                    if ( angular.isFunction(setAttribute) && value !== oldvalue ) {
                                        setAttribute(scope.$parent, value);
                                    }
                                });
                            }
                        }
                    });
                    if (attrs.dateDisabled) {
                        datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
                    }

                    if (attrs.showWeeks) {
                        datepickerEl.attr('show-weeks', attrs.showWeeks);
                    }

                    if (attrs.customClass){
                        datepickerEl.attr('custom-class', 'customClass({ date: date, mode: mode })');
                    }

                    if (attrs.datepickerOverParent){
                        scope.popupZindex = ZIndexCalculationService.getFirstSetZIndex(element[0]);
                    }else{
                        scope.popupZindex = 1051;
                    }

                    function parseDate(viewValue) {
                        if (angular.isNumber(viewValue)) {
                            // presumably timestamp to date object
                            viewValue = Date.create(viewValue);
                        }

                        if (!viewValue) {
                            return null;
                        } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
                            return viewValue;
                        } else if (angular.isString(viewValue)) {
                            var date = dateParser.parse(viewValue, dateFormat, scope.date) || Date.create(viewValue);
                            if (isNaN(date)) {
                                return undefined;
                            } else {
                                return date;
                            }
                        } else {
                            return undefined;
                        }
                    }

                    function validator(modelValue, viewValue) {
                        var value = modelValue || viewValue;
                        if (angular.isNumber(value)) {
                            value = Date.create(value);
                        }
                        if (!value) {
                            return true;
                        } else if (angular.isDate(value) && !isNaN(value)) {
                            return true;
                        } else if (angular.isString(value)) {
                            var date = dateParser.parse(value, dateFormat) || Date.create(value);
                            return !isNaN(date);
                        } else {
                            return false;
                        }
                    }

                    function positionPopup() {
                        cancelAnimationFrame(frame);
                        if (scope.isOpen) {
                            var dpElement = angular.element($popup[0].querySelector('.datepicker-popup'));
                            var placement = attrs.popupPlacement ? attrs.popupPlacement : datepickerPopupConfig.placement;
                            var position = $position.positionElements(element, dpElement, placement, appendToBody);
                            var hpos = placement.split('-')[1];
                            var dpWidth = dpElement.prop('offsetWidth');
                            if(hpos === 'right')
                                position.left -= dpWidth;

                            dpElement.css({top: position.top + 'px', left: position.left + 'px', 'z-index': scope.popupZindex});
                            if (dpElement.hasClass('position-measure')) {
                                dpElement.removeClass('position-measure');
                            }

                            scope.$evalAsync();
                            frame = requestAnimationFrame(positionPopup);
                        }

                    }

                    if (!isHtml5DateInput) {
                        // Internal API to maintain the correct ng-invalid-[key] class
                        ngModel.$$parserName = 'date';
                        ngModel.$validators.date = validator;
                        ngModel.$parsers.unshift(parseDate);
                        ngModel.$formatters.push(function (value) {
                            scope.date = value;
                            return ngModel.$isEmpty(value) ? value : dateFilter(value, dateFormat);
                        });
                    }
                    else {
                        ngModel.$formatters.push(function (value) {
                            scope.date = value;
                            return value;
                        });
                    }

                    // Inner change
                    scope.dateSelection = function(dt) {
                        if (angular.isDefined(dt)) {
                            scope.date = dt;
                        }
                        var date = scope.date ? dateFilter(scope.date, dateFormat) : '';
                        element.val(date);
                        ngModel.$setViewValue(date);

                        if (closeOnDateSelection) {
                            scope.isOpen = false;
                            if (!openOnFocus) {
                                element[0].focus();
                            }
                        }
                    };

                    // Detect changes in the view from the text box
                    ngModel.$viewChangeListeners.push(function () {
                        scope.date = !ngModel.$viewValue ? null : dateParser.parse(ngModel.$viewValue, dateFormat, scope.date) || Date.create(ngModel.$viewValue);
                    });

                    var documentClickBind = function(event) {
                        if (scope.isOpen && event.target !== element[0]) {
                            scope.$apply(function() {
                                scope.isOpen = false;
                            });
                        }
                    };

                    var keydown = function(evt, noApply) {
                        scope.keydown(evt);
                    };
                    element.on('keydown', keydown);

                    scope.keydown = function(evt) {
                        if (evt.which === 9) {
                            scope.isOpen = false;
                        } else if (evt.which === 27) {
                            evt.preventDefault();
                            if (scope.isOpen) {
                                evt.stopPropagation();
                            }
                            scope.close();
                        } else if (evt.which === 40 && !scope.isOpen) {
                            scope.isOpen = true;
                        }
                    };

                    var focus = function() {
                        scope.$apply(function () {
                            scope.isOpen = true;
                        });
                    };

                    if (openOnFocus) {
                        element.on('focus', focus);
                    }

                    scope.$watch('isOpen', function(value) {
                        if (value) {
                            if(!$popup) {
                                $popup = $compile(popupEl)(scope);
                                // Prevent jQuery cache memory leak (template is now redundant after linking)
                                popupEl.remove();

                                if ( appendToBody ) $($document[0].body).append($popup);
                                else element.after($popup);
                            }
                            positionPopup();

                            $document.on('click', documentClickBind);

                            if (appendToBody || $position.parsePlacement(placement)[2]) {
                                scrollParentEl = scrollParentEl || angular.element($position.scrollParent(element));
                                if (scrollParentEl) {
                                    scrollParentEl.on('scroll', positionPopup);
                                }
                            } else {
                                scrollParentEl = null;
                            }

                            angular.element($window).on('resize', positionPopup);
                        } else {
                            $document.off('click', documentClickBind);

                            if (scrollParentEl) {
                                scrollParentEl.off('scroll', positionPopup);
                            }
                            angular.element($window).off('resize', positionPopup);
                        }
                    });

                    scope.select = function( date ) {
                        if (date === 'today') {
                            var today = Date.create();
                            if (angular.isDate(scope.date)) {
                                date = Date.create(scope.date);
                                date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
                            } else {
                                date = Date.create(today.setHours(0, 0, 0, 0));
                            }
                        }
                        scope.dateSelection( date );
                    };

                    scope.close = function() {
                        scope.isOpen = false;
                        element[0].focus();
                    };

                    scope.$on('$destroy', function() {
                        if($popup) $popup.remove();
                        element.off('keydown', keydown);
                        element.off('focus', focus);
                        $document.off('click', documentClickBind);
                        if (scrollParentEl) {
                            scrollParentEl.off('scroll', positionPopup);
                        }
                        angular.element($window).off('resize', positionPopup);
                    });
                }
            };
        }])

    .directive('datepickerPopupWrap', function() {
        return {
            restrict:'EA',
            //replace: true,
            transclude: true,
            templateUrl: '_lib/angular-ui-bootstrap/template/datepicker/popup.html',
            link:function (scope, element, attrs) {
                element.on('click', function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                });
            }
        };
    });

/* JBT - Added confirmAction (shorthand message box) */
/* JBT - Added reportPrompt */
/* JBT - Added editor */
/* NMT - Added createCustomImport */

// The `$dialogProvider` can be used to configure global defaults for your
// `$dialog` service.
'use strict';

var dialogModule = angular.module('ui.bootstrap.dialog', ['ui.bootstrap.transition']);

dialogModule.controller('MessageBoxController', ['$scope', 'dialog', 'model', function ($scope, dialog, model) {
    $scope.title = model.title;
    $scope.message = model.message;
    $scope.buttons = model.buttons;
    $scope.close = function (res) {
        dialog.close(res);
    };
}]);

dialogModule.provider("$dialog", function () {

    // The default options for all dialogs.
    var defaults = {
        backdrop: true,
        dialogClass: 'modal',
        backdropClass: 'modal-backdrop',
        transitionClass: 'fade',
        triggerClass: 'in',
        dialogOpenClass: 'modal-open',
        resolve: {},
        backdropFade: false,
        dialogFade: false,
        keyboard: true, // close with esc key
        backdropClick: true // only in conjunction with backdrop=true
        /* other options: template, templateUrl, controller */
    };

    var globalOptions = {};

    var activeBackdrops = { value: 0 };

    // The `options({})` allows global configuration of all dialogs in the application.
    //
    //      var app = angular.module('App', ['ui.bootstrap.dialog'], function($dialogProvider){
    //        // don't close dialog when backdrop is clicked by default
    //        $dialogProvider.options({backdropClick: false});
    //      });
    this.options = function (value) {
        globalOptions = value;
    };

    // Returns the actual `$dialog` service that is injected in controllers
    this.$get = ["$http", "$location", "$document", "$compile", "$rootScope", "$controller", "$templateCache", "$q", "$transition", "$injector",
  function ($http, $location, $document, $compile, $rootScope, $controller, $templateCache, $q, $transition, $injector) {

      var body = $document.find('body');

      function createElement(clazz) {
          var el = angular.element("<div>");
          el.addClass(clazz);
          return el;
      }

      // The `Dialog` class represents a modal dialog. The dialog class can be invoked by providing an options object
      // containing at lest template or templateUrl and controller:
      //
      //     var d = new Dialog({templateUrl: 'foo.html', controller: 'BarController'});
      //
      // Dialogs can also be created using templateUrl and controller as distinct arguments:
      //
      //     var d = new Dialog('path/to/dialog.html', MyDialogController);
      function Dialog(opts) {

          var self = this, options = this.options = angular.extend({}, defaults, globalOptions, opts);
          this._open = false;

          this.backdropEl = createElement(options.backdropClass);
          if (options.backdropFade) {
              this.backdropEl.addClass(options.transitionClass);
              this.backdropEl.removeClass(options.triggerClass);
          }

          this.modalEl = createElement(options.dialogClass);
          if (options.dialogFade) {
              this.modalEl.addClass(options.transitionClass);
              this.modalEl.removeClass(options.triggerClass);
          }

          if (options.dialogId || options.templateUrl) {
              const id = options.dialogId || options.templateUrl && options.templateUrl.split('/').last().dasherize().replace('.html', '') + '-modal';
              this.modalEl.attr('id', id);
          }

          this.handledEscapeKey = function (e) {
              if (e.which === 27) {
                  self.close();
                  e.preventDefault();
                  self.$scope.$apply();
              }
          };

          this.handleBackDropClick = function (e) {
              self.close();
              e.preventDefault();
              self.$scope.$apply();
          };
      }

      Dialog.prototype.isMaximized = function () {
          if(this._isMaximized === undefined) {
              this._isMaximized = this.modalEl.hasClass('full');
          }
          return this._isMaximized;
      };

      Dialog.prototype.maximize = function (value) {
          if(value === false && !/full/i.test(this.options.dialogClass)) {
              this.modalEl.removeClass('full');
              this._isMaximized = false;
          } else {
              this.modalEl.addClass('full');
              this._isMaximized = true;
          }
      };

      // The `isOpen()` method returns wether the dialog is currently visible.
      Dialog.prototype.isOpen = function () {
          return this._open;
      };

      // The `open(templateUrl, controller)` method opens the dialog.
      // Use the `templateUrl` and `controller` arguments if specifying them at dialog creation time is not desired.
      Dialog.prototype.open = function (templateUrl, controller) {
          var self = this, options = this.options;

          if (templateUrl) {
              options.templateUrl = templateUrl;
          }
          if (controller) {
              options.controller = controller;
          }

          if (!(options.template || options.templateUrl)) {
              throw new Error('Dialog.open expected template or templateUrl, neither found. Use options or open method to specify them.');
          }

          this._loadResolves().then(function (locals) {
			  var $scope = locals.$scope = self.$scope = locals.$scope ? locals.$scope : $rootScope.$new();

              if (self.options.dialogClass !== 'edit-pane') {
                  $scope.disableModalEditing = true;
              } else {
                  $scope.disableModalEditing = false;
              }

              self.modalEl.html(locals.$template);

              if (self.options.controller) {
                  var ctrl = $controller(self.options.controller, locals);
                  self.modalEl.contents().data('ngControllerController', ctrl);
              }

              $compile(self.modalEl)($scope);
              self._addElementsToDom();
              body.addClass(self.options.dialogOpenClass);

              // trigger tranisitions
              setTimeout(function () {
                  if (self.options.dialogFade) { self.modalEl.addClass(self.options.triggerClass); }
                  if (self.options.backdropFade) { self.backdropEl.addClass(self.options.triggerClass); }
              });

              self._bindEvents();
          });

          this.deferred = $q.defer();
          return this.deferred.promise;
      };

      // closes the dialog and resolves the promise returned by the `open` method with the specified result.
      Dialog.prototype.close = function (result) {
          var self = this;
          var fadingElements = this._getFadingElements();

          body.removeClass(self.options.dialogOpenClass);
          if (fadingElements.length > 0) {
              for (var i = fadingElements.length - 1; i >= 0; i--) {
                  $transition(fadingElements[i], removeTriggerClass).then(onCloseComplete);
              }
              return;
          }

          this._onCloseComplete(result);

          function removeTriggerClass(el) {
              el.removeClass(self.options.triggerClass);
          }

          function onCloseComplete() {
              if (self._open) {
                  self._onCloseComplete(result);
              }
          }
      };

      Dialog.prototype._getFadingElements = function () {
          var elements = [];
          if (this.options.dialogFade) {
              elements.push(this.modalEl);
          }
          if (this.options.backdropFade) {
              elements.push(this.backdropEl);
          }

          return elements;
      };

      Dialog.prototype._bindEvents = function () {
          if (this.options.keyboard) { body.on('keydown', this.handledEscapeKey); }
          if (this.options.backdrop && this.options.backdropClick) { this.backdropEl.on('click', this.handleBackDropClick); }
      };

      Dialog.prototype._unbindEvents = function () {
          if (this.options.keyboard) { body.off('keydown', this.handledEscapeKey); }
          if (this.options.backdrop && this.options.backdropClick) { this.backdropEl.off('click', this.handleBackDropClick); }
      };

      Dialog.prototype._onCloseComplete = function (result) {
          this._removeElementsFromDom();
          this._unbindEvents();

          this.deferred.resolve(result);
      };

      Dialog.prototype._addElementsToDom = function () {
          body.append(this.modalEl);

          if (this.options.backdrop) {
              if (activeBackdrops.value === 0) {
                  body.append(this.backdropEl);
              }
              activeBackdrops.value++;
          }

          this._open = true;
      };

      Dialog.prototype._removeElementsFromDom = function () {
          this.modalEl.remove();

          if (this.options.backdrop) {
              activeBackdrops.value--;
              if (activeBackdrops.value === 0) {
                  this.backdropEl.remove();
              }
          }
          this._open = false;
      };

      // Loads all `options.resolve` members to be used as locals for the controller associated with the dialog.
      Dialog.prototype._loadResolves = function () {
          var values = [], keys = [], templatePromise, self = this;

          if (self.options.template) {
              templatePromise = $q.when(self.options.template);
          } else if (self.options.templateUrl) {
              templatePromise = $http.get(self.options.templateUrl, { cache: $templateCache })
              .then(function (response) {
                  return self.options.dialogClass === 'edit-pane' ? '<fieldset ng-disabled="disableModalEditing" ng-class="{disabled: disableModalEditing}">' + response.data + '</fieldset>' : response.data;
              });
          }

          angular.forEach(self.options.resolve || [], function (value, key) {
              keys.push(key);
              values.push(angular.isString(value) ? $injector.get(value) : $injector.invoke(value));
          });

          keys.push('$template');
          values.push(templatePromise);

          return $q.all(values).then(function (values) {
              var locals = {};
              angular.forEach(values, function (value, index) {
                  locals[keys[index]] = value;
              });
              locals.dialog = self;
              return locals;
          });
      };

      // The actual `$dialog` service that is injected in controllers.
      return {
          // Creates a new `Dialog` with the specified options.
          dialog: function (opts) {
              return new Dialog(opts);
          },
          // creates a new `Dialog` tied to the default message box template and controller.
          //
          // Arguments `title` and `message` are rendered in the modal header and body sections respectively.
          // The `buttons` array holds an object with the following members for each button to include in the
          // modal footer section:
          //
          // * `result`: the result to pass to the `close` method of the dialog when the button is clicked
          // * `label`: the label of the button
          // * `cssClass`: additional css class(es) to apply to the button for styling
          messageBox: function (title, message, buttons) {
              const dialogId = angular.element('<div>' + title +'</div>').text().trim().dasherize() + '-modal';

              // convert button classes to OPL
              if (buttons && buttons.length) {
                  buttons.forEach(function (button) {
                      if (!button.cssClass) {
                          button.cssClass = '';
                      }

                      button.cssClass = button.cssClass.split(' ').map(function (cssClass) {
                          switch (cssClass) {
                              case 'btn-danger':
                                  return 'oat-btn-danger';
                              case 'btn-primary':
                              case 'btn-success':
                              case 'btn-info':
                              case 'btn-link':
                                  return 'oat-btn-primary';
                              case 'btn-warning':
                                  return 'oat-btn-secondary-danger';
                              case '':
                                  return 'oat-btn-subtle-gray';
                              default:
                                  return cssClass;
                          }
                      }).join(' ');

                      if (button !== buttons.last()) {
                          button.cssClass += ' oat-mr-2';
                      }
                  });
              }

              return new Dialog({
                  dialogClass: 'opl modal',
                  backdropClass: 'opl modal-backdrop',
                  template: '<div class="modal-header">' +
                                '<h4 ng-bind-html="title"></h4>' +
                            '</div>' +
                            '<div class="modal-body">' +
                                '<p ng-bind-html="message"></p>' +
                            '</div>' +
                            '<div class="modal-footer">' +
                                '<button ng-repeat="btn in buttons" ng-click="close(btn.result)" class="oat-btn" ng-class="btn.cssClass" oas-focus="{{btn.focus}}">{{ btn.label }}</button>' +
                            '</div>',
                  dialogId: dialogId,
                  controller: 'MessageBoxController', resolve:
                    {
                        model: function () {
                            return {
                                title: title,
                                message: message,
                                buttons: buttons || [{result: 'ok', label: 'OK', cssClass: 'oat-btn-primary', focus: true}]
                            };
                        }
                    }
              });
          },
          confirmAction: function (message) {
              return this.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Confirm Action", message, [{result:'no', label: 'No'}, {result:'yes', label: 'Yes', cssClass: 'oat-btn-primary', focus: true}]);
          },
          saveSuccessful: function (message) {
              return this.messageBox("<i class='fa fa-floppy-o fa-lg text-info' aria-hidden='true'></i> Save Successful", message, [{result:'ok', label: 'OK', cssClass: 'oat-btn-primary', focus: true}]);
          },
          actionComplete: function (message, buttons) {
              return this.messageBox("<i class='fa fa-check-square fa-lg text-success' aria-hidden='true'></i> Complete", message, buttons || [{result:'ok', label: 'OK', cssClass: 'oat-btn-primary', focus: true}]);
          },
          actionFailed: function (message) {
              return this.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-error' aria-hidden='true'></i> Action Failed", message, [{result:'ok', label: 'OK', cssClass: 'oat-btn-primary', focus: true}]);
          },

          inputBox: function (title, inputLabel, type, options) {
              var opts = {
                  templateUrl: "app/modals/inputBox.html",
                  controller: "InputBoxCtrl",
                  inputType: angular.isArray(type) ? "select" : (type || "text"),
                  title: title,
                  inputCaption: inputLabel || "Enter",
                  required: true,
                  availableList: angular.isArray(type) ? type : null
              };

              if (options) {
                  angular.extend(opts, options);
              }

              return new Dialog(opts);
          },
          search: function (type, title, inputLabel, searchParameters) {
              var opts = {
                  templateUrl: "app/modals/inputBox.html",
                  controller: "InputBoxCtrl",
                  inputType: "oas-search",
                  dialogId: type.toLowerCase() + '-search-modal',
                  searchEntity: type.toLowerCase(),
                  title: title || "Search",
                  inputCaption: inputLabel || type.titleize(),
                  required: true,
                  searchParameters: Object.toQueryString(searchParameters)
              };

              return new Dialog(opts);
          },
          reportPrompt: function(reportId, reportArgs) {
              var deferred = $q.defer();

              return {
                  open: function() {
                      var reportRunPrompterService = $injector.get('reportRunPrompterService');
                      reportRunPrompterService.openReportPrompt(reportId, reportArgs || {});
                      deferred.resolve();
                      return deferred.promise;
                  },
                  close: function(result) {
                      deferred.resolve(result);
                      return deferred.promise;
                  },
                  isOpen: function() {
                      return false;
                  }
              };
          },
          legacyReportPrompt: function(reportId, reportArgs) {
              reportArgs = reportArgs || {};

              var opts = {
                  templateUrl: "reporting/modals/report-prompter.html",
                  controller: "ReportPrompterCtrl",
                  resolve: {reportId: function() { return reportId; }, reportArgs: function() { return reportArgs; } },
                  dialogClass: 'modal report'
              };

              return new Dialog(opts);
          },
          compositeReportPrompt: function(reportId, reportArgs) {
              reportArgs = reportArgs || {};

              var opts = {
                  templateUrl: "reporting/composites/modals/composite-report-prompter.html",
                  controller: "CompositeReportPrompterCtrl",
                  resolve: {reportId: function() { return reportId; }, reportArgs: function() { return reportArgs; } },
                  dialogClass: 'modal report'
              };

              return new Dialog(opts);
          },
          dataQueryPrompt: function(dataQuery, promptMode, hideToScreen, hideInbox, tokenOverrideForDownloads, blobParentForAuditRequest) {
              var guidMatch = /^(\{{0,1}([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}\}{0,1})$/;
              var isNew = angular.isObject(dataQuery) ? guidMatch.test(dataQuery.id) : guidMatch.test(dataQuery);
              var opts;

              opts = {
                  templateUrl: "reporting/modals/" + (isNew ? "queryBuilder" : "dataQuery") + "ViewParams.html",
                  controller: (isNew ? "QueryBuilder" : "DataQuery") + "ViewParamsCtrl",
                  dataQueryId: (isNew ? (angular.isObject(dataQuery) ? dataQuery.id : dataQuery ) : parseInt(dataQuery)) || null,
                  dataQueryName: angular.isString(dataQuery) && !parseInt(dataQuery) && !isNew ? dataQuery : null,
                  dataQuery: angular.isObject(dataQuery) ? dataQuery : null,
                  promptMode: promptMode || "run",
                  hideToScreen: hideToScreen || false,
                  hideInbox: hideInbox || false,
                  tokenOverrideForDownloads: tokenOverrideForDownloads || null,
                  blobParentForAuditRequest: blobParentForAuditRequest || null
              };

              return new Dialog(opts);
          },
          editor: function(templateUrl, controller, resolve, dialogClass) {
                var opts = {
                    templateUrl: templateUrl,
                    controller: controller,
                    resolve: resolve,
                    dialogClass: dialogClass ? dialogClass : 'edit-pane'
                };

                return new Dialog(opts);
          },
          confirmNavigation: function(message, noCancel) {
              var options = [
                  {result:'yes', label: 'Yes', cssClass: 'btn-primary', focus: true},
                  {result:'no', cssClass: 'btn-warning', label: 'No'}
              ];
              if(!noCancel) options.push({result:'cancel', label: 'Cancel'});
              return this.messageBox("<i class='fa fa-external-link fa-lg text-info' aria-hidden='true'></i> Confirm Navigation", message, options);
          },
          createCustomImport : function(importTypeID, title, isMultiDb, requiredFields){
              let $d = this;
              return new Dialog({
                  templateUrl: 'CustomImportsV2/views/modalCreateImport.html',
                  controller: ['$scope', '$upload', '$timeout', 'civ2Service', 'dialog', 'id', 'postUrl', 'httpGlobalInterceptor', dialogCtrl],
                  resolve:{
                      id: function(){return importTypeID},
                      postUrl: function () { return '/Utility/Import/' + (!!isMultiDb ? 'Common/' : '') + 'CreateFromFile' }
                  }
              })
                  .open()
                  .then(function(res){
                      if(res) {
                        if (!!isMultiDb) {
                            $location.path(`/customImports2/history/multidb/${res.id}`);
                        } else {
                            if (res.workingData && title && title.toLowerCase().indexOf('trade block') >= 0) {
                                var civ2Svc = $injector.get('civ2Service');
                                civ2Svc.setPendingWorkingData(res.workingData);
                            }
                            $location.path('/customImports2/Validate/'+res.importTypeId+'/'+res.importId);
                        }
                      }
                      if($(".modal-backdrop")){$(".modal-backdrop").remove();}
                  })
              ;

              function dialogCtrl($scope, $upload, $timeout, civ2Service, dialog, id, postUrl, httpGlobalInterceptor) {
                  $scope.title = title || "Create New Import";
                  $scope.requiredFields = parseRequiredFields();
                  $scope.showRequiredFieldsSection = showRequiredFields()
                  $scope.importTypeId = id;
                  $scope.isMultiDb = !!isMultiDb;
                  $scope.loading = false;
                  $scope.controls = {
                      close: close,
                      cancel:cancel,
                      triggerFileSelect: triggerFileSelect,
                      onFileSelect: onFileSelect,
                      generateTemplate : generateTemplate
                  };

                  function parseRequiredFields() {
                    if (requiredFields) {
                        return requiredFields.split(',');
                    }
                  }

                  function showRequiredFields() {
                    return !!$scope.requiredFields && $scope.requiredFields.length > 0;
                  }

                  function generateTemplate(id, isMultiDB){
                      civ2Service.generateTemplate(id, isMultiDB);
                  }

                  function onFileSelect(file) {
                      close({importTypeId: id, importName: $scope.importName, file: file[0]});
                  }

                  function triggerFileSelect() {
                      $timeout(function () {
                          angular.element('#fileSelect').trigger('click');
                      }, 0);
                  }

                  function cancel(){
                      if($scope.fileUpload){
                          if($scope.fileUpload.cancel)$scope.fileUpload.cancel();
                      }else{
                          dialog.close(false);
                      }
                  }

                  function close(data) {
                      let canceller = $q.defer();
                      $scope.loading=true;
                      if (data && !data.file) {
                          civ2Service.createImport({
                              ImportId: null,
                              ImportTypeId: id,
                              ImportMetadata: {},
                              WorkingData: [],
                              ImportName: $scope.importName
                          }).then(function (res) {
                              dialog.close(res.data);
                          });
                          return;
                      }
                      $scope.fileUpload = $upload.upload({
                          url: postUrl,
                          timeout: canceller.promise,
                          data: {importTypeId: data.importTypeId, importName: data.importName},
                          file: data.file,
                          method: 'POST',
                          headers: {Authorization: 'Session ' + sessionStorage.oas_token}
                      });
                      $scope.fileUpload.cancel = function(){
                          canceller.resolve();
                      };
                      $scope.fileUpload
                          .then(function(res){
                              dialog.close(res.data);
                          })
                          .catch(function(res){
                              if(res.status >= 400){
                                  if(!res.data.Message){
                                      res.config.timeout = false; //disable the timeout so the Global Interceptor doesnt reject the error.
                                      $scope.fileUpload = false;
                                      cancel();
                                      httpGlobalInterceptor
                                          .responseError(res);
                                  }else{
                                      $d.actionFailed(res.data.Message)
                                          .open()
                                          .then(function(){
                                              $scope.fileUpload = null;
                                              $scope.loading = false;
                                          })
                                      ;
                                  }
                              }else{
                                  $scope.fileUpload = null;
                                  $scope.loading = false;
                              }
                          })
                      ;
                  }
              }
          }
      };
  }];
});

/*JBT - add context menu option */
/*JBT - manually patched in fix from #3792 since it's not in the master branch yet */
/*JBT - manually patch in fix from #1317 since it's not in master branch yet */
/*JBT - add code to handle right aligned dropdown menus */
/*JBT - add code to handle submenu dropdowns */

angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.position'])

    .constant('dropdownConfig', {
        openClass: 'open'
    })

    .service('dropdownService', ['$document', '$rootScope', function ($document, $rootScope) {
        var openScope = null;

        this.open = function (dropdownScope) {
            if (!openScope) {
                $document.on('click', closeDropdown);
                $document.on('keydown', escapeKeyBind);
            }

            if (openScope && openScope !== dropdownScope) {
                openScope.isOpen = false;
            }

            openScope = dropdownScope;
        };

        this.close = function (dropdownScope) {
            if (openScope === dropdownScope) {
                openScope = null;
                $document.off('click', closeDropdown);
                $document.off('keydown', escapeKeyBind);
            }
        };

        var closeDropdown = function (evt) {
            // This method may still be called during the same mouse event that
            // unbound this event handler. So check openScope before proceeding.
            if (!openScope) {
                return;
            }

            if (evt && openScope.getAutoClose() === 'disabled') {
                return;
            }

            var toggleElement = openScope.getToggleElement();
            if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
                return;
            }

            var dropdownElement = openScope.getDropdownElement();
            if (evt && openScope.getAutoClose() === 'outsideClick' && dropdownElement && dropdownElement[0].contains(evt.target)) {
                return;
            }

            openScope.isOpen = false;

            if (!$rootScope.$$phase) {
                openScope.$apply();
            }
        };

        var escapeKeyBind = function (evt) {
            if (evt.which === 27) {
                openScope.focusToggleElement();
                closeDropdown();
            }
        };
    }])

    .controller('DropdownController', ['$scope', '$attrs', '$parse', 'dropdownConfig', 'dropdownService', '$animate', '$position', '$document', '$compile', '$templateRequest', 'ZIndexCalculationService', function ($scope, $attrs, $parse, dropdownConfig, dropdownService, $animate, $position, $document, $compile, $templateRequest, ZIndexCalculationService) {
        var self = this,
            scope = $scope.$new(), // create a child scope so we are not polluting original one
            templateScope,
            openClass = dropdownConfig.openClass,
            getIsOpen,
            setIsOpen = angular.noop,
            toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
            appendToBody = false;

        this.init = function (element) {
            self.$element = element;

            if ($attrs.isOpen) {
                getIsOpen = $parse($attrs.isOpen);
                setIsOpen = getIsOpen.assign;

                $scope.$watch(getIsOpen, function (value) {
                    scope.isOpen = !!value;
                });
            }

            appendToBody = angular.isDefined($attrs.dropdownAppendToBody);

            if (appendToBody && self.dropdownMenu) {
                $($document[0].body).append(self.dropdownMenu);
                element.on('$destroy', function handleDestroyEvent() {
                    self.dropdownMenu.remove();
                });
            }
        };

        this.toggle = function (open) {
            if (angular.isDefined($attrs.dropdownZindexFromParent)){
                self.dropdownMenu.css('z-index', ZIndexCalculationService.getFirstSetZIndex(self.$element[0]) + 1);
            }

            return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
        };

        // Allow other directives to watch status
        this.isOpen = function () {
            return scope.isOpen;
        };

        scope.getToggleElement = function () {
            return self.toggleElement;
        };

        scope.getAutoClose = function () {
            return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
        };

        scope.getElement = function () {
            return self.$element;
        };

        scope.getDropdownElement = function () {
            return self.dropdownMenu;
        };

        scope.focusToggleElement = function () {
            if (self.toggleElement) {
                self.toggleElement[0].focus();
            }
        };

        scope.$watch('isOpen', function (isOpen, wasOpen) {
            //if ( appendToBody && self.dropdownMenu ) {
            //    var pos = $position.positionElements(self.$element, self.dropdownMenu, 'bottom-left', true);
            //    self.dropdownMenu.css({
            //        top: pos.top + 'px',
            //        left: pos.left + 'px',
            //        display: isOpen ? 'block' : 'none'
            //    });
            //}

            $animate[isOpen ? 'addClass' : 'removeClass'](self.$element, openClass);

            if (isOpen) {
                if (self.dropdownMenuTemplateUrl) {
                    $templateRequest(self.dropdownMenuTemplateUrl).then(function (tplContent) {
                        templateScope = scope.$new();
                        $compile(tplContent.trim())(templateScope, function (dropdownElement) {
                            var newEl = dropdownElement;
                            self.dropdownMenu.replaceWith(newEl);
                            self.dropdownMenu = newEl;
                        });
                    });
                }

                scope.focusToggleElement();
                dropdownService.open(scope);
            } else {
                if (self.dropdownMenuTemplateUrl) {
                    if (templateScope) {
                        templateScope.$destroy();
                    }
                    var newEl = angular.element('<ul class="dropdown-menu"></ul>');
                    self.dropdownMenu.replaceWith(newEl);
                    self.dropdownMenu = newEl;
                }

                dropdownService.close(scope);
            }

            setIsOpen($scope, isOpen);
            if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
                toggleInvoker($scope, {open: !!isOpen});
            }
        });

        $scope.$on('$locationChangeSuccess', function () {
            if (scope.getAutoClose() !== 'disabled') {
                scope.isOpen = false;
            }
        });

        $scope.$on('$destroy', function () {
            scope.$destroy();
        });
    }])

    .directive('dropdown', function () {
        return {
            controller: 'DropdownController',
            link: function (scope, element, attrs, dropdownCtrl) {
                dropdownCtrl.init(element);
            }
        };
    })

    .directive('dropdownMenu', ['$window', '$position', function ($window, $position) {
        return {
            restrict: 'AC',
            require: '?^dropdown',
            link: function (scope, element, attrs, dropdownCtrl) {
                if (!dropdownCtrl || element.parent().hasClass("dropdown-submenu")) {
                    return;
                }
                var tplUrl = attrs.templateUrl;
                if (tplUrl) {
                    dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
                }
                if (!dropdownCtrl.dropdownMenu) {
                    dropdownCtrl.dropdownMenu = element;
                }

                var dropdownMenu = element,
                    dropdown = element.parent(),
                    appendToBody = dropdown.attr('dropdown-append-to-body');

                scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
                    if (isOpen) {

                        // Add invisible dropdownMenu to DOM to calculate its height
                        dropdownMenu.css({
                            visibility: 'hidden',
                            display: 'block'
                        });

                        var windowBottom = $window.innerHeight + $window.pageYOffset,
                            dropdownOffset = $position.offset(dropdown).top,
                            dropdownHeight = $position.position(dropdown).height,
                            dropdownMenuHeight = $position.position(dropdownMenu).height,
                            dropdownMenuBottom = dropdownOffset + dropdownHeight + dropdownMenuHeight;

                        if (appendToBody !== undefined) {
                            var horizontalAlign = dropdownMenu.hasClass("dropdown-menu-right") ? "right" : "left",
                                pos = $position.positionElements(dropdownCtrl.trackByToggle? dropdownCtrl.toggleElement : dropdown, dropdownMenu, 'bottom-' + horizontalAlign, true);
                            dropdownMenu.css({
                                top: dropdownMenuBottom > windowBottom ? dropdownOffset - dropdownMenuHeight - 3 + 'px' : pos.top + 'px',
                                left: pos.left - (horizontalAlign === "right" ? $position.position(dropdownMenu).width : 0) + "px"
                            });
                        } else {
                            dropdown[dropdownMenuBottom > windowBottom ? 'addClass' : 'removeClass']('dropup');
                        }

                        // Now, display dropdownMenu
                        dropdownMenu.css('visibility', 'visible');

                    } else {
                        // When dropdownMenu is closed, remove inline styling
                        dropdownMenu.css({
                            visibility: '',
                            display: ''
                        });
                    }
                });
            }
        };
    }])

    .directive('dropdownToggle', function () {
        return {
            scope:{
                update:'&',
            },
            require: '?^dropdown',
            link: function (scope, element, attrs, dropdownCtrl) {
                var openTrigger = attrs.dropdownContextMenu && scope.$eval(attrs.dropdownContextMenu) ? 'contextmenu' : 'click';
                if (!dropdownCtrl) {
                    return;
                }

                dropdownCtrl.toggleElement = element;

                var toggleDropdown = function (event) {
                    event.preventDefault();
                    if(attrs.update){
                        scope.update();
                    }
                    if(attrs.trackByToggle){
                        dropdownCtrl.trackByToggle = true;
                        dropdownCtrl.toggleElement = element;
                    }
                    if (!element.hasClass('disabled') && !attrs.disabled) {
                        scope.$apply(function () {
                            dropdownCtrl.toggle();
                        });
                    }
                };

                element.on(openTrigger, toggleDropdown);

                // WAI-ARIA
                element.attr({'aria-haspopup': true, 'aria-expanded': false});
                scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
                    element.attr('aria-expanded', !!isOpen);
                });

                scope.$on('$destroy', function () {
                    element.off(openTrigger, toggleDropdown);
                });
            }
        };
    });

angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])

    .controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function($scope, $attrs, uibPaging, uibPagerConfig) {
        $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;

        uibPaging.create(this, $scope, $attrs);
    }])

    .constant('uibPagerConfig', {
        itemsPerPage: 10,
        previousText: '« Previous',
        nextText: 'Next »',
        align: true
    })

    .directive('uibPager', ['uibPagerConfig', function(uibPagerConfig) {
        return {
            scope: {
                totalItems: '=',
                previousText: '@',
                nextText: '@',
                ngDisabled: '='
            },
            require: ['uibPager', '?ngModel'],
            restrict: 'A',
            controller: 'UibPagerController',
            controllerAs: 'pager',
            templateUrl: function(element, attrs) {
                return attrs.templateUrl || '_lib/angular-ui-bootstrap/template/pager/pager.html';
            },
            link: function(scope, element, attrs, ctrls) {
                element.addClass('pager');
                var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                if (!ngModelCtrl) {
                    return; // do nothing if no ng-model
                }

                paginationCtrl.init(ngModelCtrl, uibPagerConfig);
            }
        };
    }]);

angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
    .controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
        var ctrl = this;
        // Setup configuration parameters
        var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
            rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
            forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
            boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
            pageLabel = angular.isDefined($attrs.pageLabel) ? function(idx) { return $scope.$parent.$eval($attrs.pageLabel, {$page: idx}); } : angular.identity;
        $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
        $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;

        uibPaging.create(this, $scope, $attrs);

        if ($attrs.maxSize) {
            ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function(value) {
                maxSize = parseInt(value, 10);
                ctrl.render();
            }));
        }

        // Create page object used in template
        function makePage(number, text, isActive) {
            return {
                number: number,
                text: text,
                active: isActive
            };
        }

        function getPages(currentPage, totalPages) {
            var pages = [];

            // Default page limits
            var startPage = 1, endPage = totalPages;
            var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

            // recompute if maxSize
            if (isMaxSized) {
                if (rotate) {
                    // Current page is displayed in the middle of the visible ones
                    startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
                    endPage = startPage + maxSize - 1;

                    // Adjust if limit is exceeded
                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = endPage - maxSize + 1;
                    }
                } else {
                    // Visible pages are paginated with maxSize
                    startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

                    // Adjust last page if limit is exceeded
                    endPage = Math.min(startPage + maxSize - 1, totalPages);
                }
            }

            // Add page number links
            for (var number = startPage; number <= endPage; number++) {
                var page = makePage(number, pageLabel(number), number === currentPage);
                pages.push(page);
            }

            // Add links to move between page sets
            if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
                if (startPage > 1) {
                    if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
                        var previousPageSet = makePage(startPage - 1, '...', false);
                        pages.unshift(previousPageSet);
                    }
                    if (boundaryLinkNumbers) {
                        if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
                            var secondPageLink = makePage(2, '2', false);
                            pages.unshift(secondPageLink);
                        }
                        //add the first page
                        var firstPageLink = makePage(1, '1', false);
                        pages.unshift(firstPageLink);
                    }
                }

                if (endPage < totalPages) {
                    if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
                        var nextPageSet = makePage(endPage + 1, '...', false);
                        pages.push(nextPageSet);
                    }
                    if (boundaryLinkNumbers) {
                        if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
                            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
                            pages.push(secondToLastPageLink);
                        }
                        //add the last page
                        var lastPageLink = makePage(totalPages, totalPages, false);
                        pages.push(lastPageLink);
                    }
                }
            }
            return pages;
        }

        var originalRender = this.render;
        this.render = function() {
            originalRender();
            if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
                $scope.pages = getPages($scope.page, $scope.totalPages);
            }
        };
    }])

    .constant('uibPaginationConfig', {
        itemsPerPage: 10,
        boundaryLinks: false,
        boundaryLinkNumbers: false,
        directionLinks: true,
        firstText: 'First',
        previousText: 'Previous',
        nextText: 'Next',
        lastText: 'Last',
        rotate: true,
        forceEllipses: false
    })

    .directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, uibPaginationConfig) {
        return {
            scope: {
                totalItems: '=',
                firstText: '@',
                previousText: '@',
                nextText: '@',
                lastText: '@',
                ngDisabled:'='
            },
            require: ['uibPagination', '?ngModel'],
            restrict: 'E',
            controller: 'UibPaginationController',
            controllerAs: 'pagination',
            templateUrl: function(element, attrs) {
                return attrs.templateUrl || '_lib/angular-ui-bootstrap/template/pagination/pagination.html';
            },
            link: function(scope, element, attrs, ctrls) {
                element.addClass('pagination');
                var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                if (!ngModelCtrl) {
                    return; // do nothing if no ng-model
                }

                paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
            }
        };
    }]);

angular.module('ui.bootstrap.paging', [])
/**
 * Helper internal service for generating common controller code between the
 * pager and pagination components
 */
    .factory('uibPaging', ['$parse', function($parse) {
        return {
            create: function(ctrl, $scope, $attrs) {
                ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
                ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
                ctrl._watchers = [];

                ctrl.init = function(ngModelCtrl, config) {
                    ctrl.ngModelCtrl = ngModelCtrl;
                    ctrl.config = config;

                    ngModelCtrl.$render = function() {
                        ctrl.render();
                    };

                    if ($attrs.itemsPerPage) {
                        ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function(value) {
                            ctrl.itemsPerPage = parseInt(value, 10);
                            $scope.totalPages = ctrl.calculateTotalPages();
                            ctrl.updatePage();
                        }));
                    } else {
                        ctrl.itemsPerPage = config.itemsPerPage;
                    }

                    $scope.$watch('totalItems', function(newTotal, oldTotal) {
                        if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
                            $scope.totalPages = ctrl.calculateTotalPages();
                            ctrl.updatePage();
                        }
                    });
                };

                ctrl.calculateTotalPages = function() {
                    var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
                    return Math.max(totalPages || 0, 1);
                };

                ctrl.render = function() {
                    $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
                };

                $scope.selectPage = function(page, evt) {
                    if (evt) {
                        evt.preventDefault();
                    }

                    var clickAllowed = !$scope.ngDisabled || !evt;
                    if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
                        if (evt && evt.target) {
                            evt.target.blur();
                        }
                        ctrl.ngModelCtrl.$setViewValue(page);
                        ctrl.ngModelCtrl.$render();
                    }
                };

                $scope.getText = function(key) {
                    return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
                };

                $scope.noPrevious = function() {
                    return $scope.page === 1;
                };

                $scope.noNext = function() {
                    return $scope.page === $scope.totalPages;
                };

                ctrl.updatePage = function() {
                    ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

                    if ($scope.page > $scope.totalPages) {
                        $scope.selectPage($scope.totalPages);
                    } else {
                        ctrl.ngModelCtrl.$render();
                    }
                };

                $scope.$on('$destroy', function() {
                    while (ctrl._watchers.length) {
                        ctrl._watchers.shift()();
                    }
                });
            }
        };
    }]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */
angular.module( 'ui.bootstrap.popover', ['ui.bootstrap.tooltip'])

    .directive('popoverTemplatePopup', function() {
        return {
            restrict: 'EA',
            replace: true,
            scope: { title: '@', contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
                originScope: '&' },
            templateUrl: '_lib/angular-ui-bootstrap/template/popover/popover-template.html'
        };
    })

    .directive('popoverTemplate', ['$tooltip', function($tooltip) {
        return $tooltip('popoverTemplate', 'popover', 'click', {
            useContentExp: true
        });
    }])

    .directive('popoverHtmlPopup', function() {
        return {
            restrict: 'EA',
            replace: true,
            scope: { contentExp: '&', title: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
            templateUrl: '_lib/angular-ui-bootstrap/template/popover/popover-html.html'
        };
    })

    .directive('popoverHtml', ['$tooltip', function($tooltip) {
        return $tooltip( 'popoverHtml', 'popover', 'click', {
            useContentExp: true
        });
    }])

    .directive('popoverPopup', function() {
        return {
            restrict: 'EA',
            replace: true,
            scope: { title: '@', content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
            templateUrl: '_lib/angular-ui-bootstrap/template/popover/popover.html'
        };
    })

    .directive('popover', ['$tooltip', function($tooltip) {
        return $tooltip( 'popover', 'popover', 'click' );
    }])

    .directive('popoverBs4Popup', function() {
        return {
            restrict: 'EA',
            replace: true,
            scope: { title: '@', content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
            templateUrl: '_lib/angular-ui-bootstrap/template/popover/popover.bs4.html'
        };
    })

    .directive('popoverBs4', ['$tooltip', function($tooltip) {
        return $tooltip( 'popoverBs4', 'popover', 'click' );
    }]);
angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods that can be use to retrieve position of DOM elements.
 * It is meant to be used where we need to absolute-position DOM elements in
 * relation to other, existing elements (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
    .factory('$position', ['$document', '$window', function($document, $window) {
        var OVERFLOW_REGEX = {
            normal: /(auto|scroll)/,
            hidden: /(auto|scroll|hidden)/
        };

        function getStyle(el, cssprop) {
            if (el.currentStyle) { //IE
                return el.currentStyle[cssprop];
            } else if ($window.getComputedStyle) {
                return $window.getComputedStyle(el)[cssprop];
            }
            // finally try and get inline style
            return el.style[cssprop];
        }

        /**
         * Checks if a given element is statically positioned
         * @param element - raw DOM element
         */
        function isStaticPositioned(element) {
            return (getStyle(element, 'position') || 'static' ) === 'static';
        }

        /**
         * returns the closest, non-statically positioned parentOffset of a given element
         * @param element
         */
        var parentOffsetEl = function(element) {
            var docDomEl = $document[0];
            var offsetParent = element.offsetParent || docDomEl;
            while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent) ) {
                offsetParent = offsetParent.offsetParent;
            }
            return offsetParent || docDomEl;
        };

        return {
            /**
             * Provides a raw DOM element from a jQuery/jQLite element.
             *
             * @param {element} elem - The element to convert.
             *
             * @returns {element} A HTML element.
             */
            getRawNode: function(elem) {
                return elem.nodeName ? elem : elem[0] || elem;
            },

            /**
             * Provides read-only equivalent of jQuery's position function:
             * http://api.jquery.com/position/
             */
            position: function(element) {
                var elBCR = this.offset(element);
                var offsetParentBCR = { top: 0, left: 0 };
                var offsetParentEl = parentOffsetEl(element[0]);
                if (offsetParentEl != $document[0]) {
                    offsetParentBCR = this.offset(angular.element(offsetParentEl));
                    offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
                    offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
                }

                var boundingClientRect = element[0].getBoundingClientRect();
                return {
                    width: boundingClientRect.width || element.prop('offsetWidth'),
                    height: boundingClientRect.height || element.prop('offsetHeight'),
                    top: elBCR.top - offsetParentBCR.top,
                    left: elBCR.left - offsetParentBCR.left
                };
            },

            /**
             * Provides read-only equivalent of jQuery's offset function:
             * http://api.jquery.com/offset/
             */
            offset: function(element) {
                var boundingClientRect = element[0].getBoundingClientRect();
                return {
                    width: boundingClientRect.width || element.prop('offsetWidth'),
                    height: boundingClientRect.height || element.prop('offsetHeight'),
                    top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
                    left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
                };
            },

            /**
             * Provides coordinates for the targetEl in relation to hostEl
             */
            positionElements: function(hostEl, targetEl, positionStr, appendToBody) {
                var positionStrParts = positionStr.split('-');
                var pos0 = positionStrParts[0], pos1 = positionStrParts[1] || 'center';

                var hostElPos,
                    targetElWidth,
                    targetElHeight,
                    targetElPos;

                hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);

                targetElWidth = targetEl.prop('offsetWidth');
                targetElHeight = targetEl.prop('offsetHeight');

                var shiftWidth = {
                    center: function() {
                        return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
                    },
                    left: function() {
                        return hostElPos.left;
                    },
                    right: function() {
                        return hostElPos.left + hostElPos.width;
                    }
                };

                var shiftHeight = {
                    center: function() {
                        return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
                    },
                    top: function() {
                        return hostElPos.top;
                    },
                    bottom: function() {
                        return hostElPos.top + hostElPos.height;
                    }
                };

                switch (pos0) {
                    case 'right':
                        targetElPos = {
                            top: shiftHeight[pos1](),
                            left: shiftWidth[pos0]()
                        };
                        break;
                    case 'left':
                        targetElPos = {
                            top: shiftHeight[pos1](),
                            left: hostElPos.left - targetElWidth
                        };
                        break;
                    case 'bottom':
                        targetElPos = {
                            top: shiftHeight[pos0](),
                            left: shiftWidth[pos1]()
                        };
                        break;
                    default:
                        targetElPos = {
                            top: hostElPos.top - targetElHeight,
                            left: shiftWidth[pos1]()
                        };
                        break;
                }

                return targetElPos;
            },


            /**
             * Provides the closest scrollable ancestor.
             * A port of the jQuery UI scrollParent method:
             * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
             *
             * @param {element} elem - The element to find the scroll parent of.
             * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
             *   default is false.
             * @param {boolean=} [includeSelf=false] - Should the element being passed be
             * included in the scrollable llokup.
             *
             * @returns {element} A HTML element.
             */
            scrollParent: function(elem, includeHidden, includeSelf) {
                elem = this.getRawNode(elem);

                var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
                var documentEl = $document[0].documentElement;
                var elemStyle = $window.getComputedStyle(elem);
                if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
                    return elem;
                }
                var excludeStatic = elemStyle.position === 'absolute';
                var scrollParent = elem.parentElement || documentEl;

                if (scrollParent === documentEl || elemStyle.position === 'fixed') {
                    return documentEl;
                }

                while (scrollParent.parentElement && scrollParent !== documentEl) {
                    var spStyle = $window.getComputedStyle(scrollParent);
                    if (excludeStatic && spStyle.position !== 'static') {
                        excludeStatic = false;
                    }

                    if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
                        break;
                    }
                    scrollParent = scrollParent.parentElement;
                }

                return scrollParent;
            }
        };
    }]);

angular.module('ui.bootstrap.progressbar', [])

    .constant('progressConfig', {
        animate: true,
        max: 100
    })

    .controller('ProgressController', ['$scope', '$attrs', 'progressConfig', function($scope, $attrs, progressConfig) {
        var self = this,
            animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;

        this.bars = [];
        $scope.max = angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : progressConfig.max;

        this.addBar = function(bar, element) {
            if ( !animate ) {
                element.css({'transition': 'none'});
            }

            this.bars.push(bar);

            bar.$watch('value', function( value ) {
                bar.percent = +(100 * value / $scope.max).toFixed(2);
            });

            bar.$on('$destroy', function() {
                element = null;
                self.removeBar(bar);
            });
        };

        this.removeBar = function(bar) {
            this.bars.splice(this.bars.indexOf(bar), 1);
        };
    }])

    .directive('progress', function() {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            controller: 'ProgressController',
            require: 'progress',
            scope: {},
            template: '<div class="progress" ng-transclude></div>'
        };
    })

    .directive('bar', function() {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            require: '^progress',
            scope: {
                value: '=',
                type: '@'
            },
            template: '<div class="bar" ng-class="type && \'bar-\' + type" ng-style="{width: percent + \'%\'}" ng-transclude></div>',
            link: function(scope, element, attrs, progressCtrl) {
                progressCtrl.addBar(scope, element);
            }
        };
    })

    .directive('progressbar', function() {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            controller: 'ProgressController',
            scope: {
                value: '=',
                type: '@'
            },
            template: '<div class="progress"><div class="bar" ng-class="type && \'bar-\' + type" ng-style="{width: percent + \'%\'}" ng-transclude></div></div>',
            link: function(scope, element, attrs, progressCtrl) {
                progressCtrl.addBar(scope, angular.element(element.children()[0]));
            }
        };
    });
angular.module('ui.bootstrap.slider', ['ui.bootstrap.position'])

    .constant('sliderConfig', {
        updateOnDrag: false,
        max: 100,
        min: 0
    })

    .directive('slider', ['$document', '$position', 'sliderConfig', function($document, $position, sliderConfig) {
        return {
            restrict: 'EA',
            replace: true,
            require: '?ngModel',
            transclude: true,
            scope: {
                transition: '@',
                progressClass: '@',
                barClass: '@',
                btnClass: '@',
                disabled: '<'
            },
            template:   `<div class="progress-slider" style="position: relative; margin-top: 15px;">
                            <button ng-class="btnClass" class="btn" style="margin:-15px; display:inline; position: relative; z-index: 1" ng-transclude></button>
                            <div class="progress" ng-class="progressClass" style="position: absolute;top: 0;left: 0;right: 0;bottom: 0;z-index: 0;margin: auto;">
                                <div class="bar" ng-class="barClass"></div>
                            </div>
                        </div>`,
            link: function(scope, element, attrs, ngModel) {

                angular.forEach(sliderConfig, function(value, key) {
                    if(key !== 'ngModel') {
                        scope[key] = angular.isDefined(attrs[key]) ? scope.$parent.$eval(attrs[key]) : value;
                    }
                });

                scope.btn = element.find('button');
                scope.bar = element.children().eq(1).children().eq(0);
                scope.range = scope.max - scope.min;

                scope.hasAnimation = (scope.transition) && (scope.transition !== 'none');

                scope.setAnimation = function(doanimate) {
                    if(doanimate)
                    {
                        scope.btn.css({'transition-property': 'left'});
                        scope.bar.css({'transition-property': 'width'});
                    } else {
                        scope.btn.css({'transition-property': 'none'});
                        scope.bar.css({'transition-property': 'none'});
                    }
                };

                scope.init = function() {
                    if(scope.hasAnimation)
                    {
                        scope.btn.css({'transition': 'left ' + scope.transition});
                        scope.bar.css({'transition': 'width ' + scope.transition});
                    }
                    scope.setAnimation(scope.hasAnimation);
                };

                scope.getPercentage = function(value) {
                    return angular.isNumber(value) ? Math.max(0, Math.min(100, Math.round(100 * (value - scope.min) / scope.range))) : 0;
                };

                scope.percentageToValue = function(perc) {
                    return Math.round(scope.min + (scope.range * perc / 100))
                };

                scope.setValid = function(value) {
                    var v = parseInt(value);
                    ngModel.$setValidity('slider', (scope.max >= v) && (v >= scope.min));
                    return v;
                };

                ngModel.$formatters.push(scope.setValid);
                ngModel.$parsers.push(scope.setValid);

                scope.update = function() {
                    ngModel.$setViewValue(scope.percentageToValue(scope.percent));
                    scope.$apply();
                };

                ngModel.$render = function() {
                    scope.percent = scope.getPercentage(ngModel.$viewValue);
                    scope.redraw();
                };

                scope.redraw = function() {
                    scope.btn.css({'display': ngModel.$isEmpty(ngModel.$viewValue) ? 'none' : 'block'});
                    scope.btn.css({'left': scope.percent + '%'});
                    scope.bar.css({'width': scope.percent + '%'});
                };

                element.on('mousedown', function(event) {
                    if (scope.disabled) {
                        event.preventDefault();
                        return;
                    }
                    //updating for window change
                    scope.w = $position.position(element).width;
                    scope.l = $position.offset(element).left;
                });

                element.on('click', function(event) {
                    if (scope.disabled) {
                        event.preventDefault();
                        return;
                    }

                    scope.percent = Math.max(0, Math.min((event.clientX - scope.l) / scope.w * 100, 100));
                    scope.update();
                    scope.redraw();
                });

                scope.btn.on('mousedown', function(event) {
                    if(scope.hasAnimation)
                    {
                        scope.setAnimation(false);
                    }
                    event.preventDefault();
                    $document.on('mousemove', mousemove);
                    $document.on('mouseup', mouseup);
                });

                function mousemove(event) {
                    scope.percent = Math.max(0, Math.min((event.clientX - scope.l) / scope.w * 100, 100));
                    if(scope.updateOnDrag)
                    {
                        scope.update();
                    }
                    scope.redraw();
                }

                function mouseup() {
                    $document.off('mousemove', mousemove);
                    $document.off('mouseup', mouseup);
                    if(scope.hasAnimation)
                    {
                        scope.setAnimation(true);
                    }
                    if(!scope.updateOnDrag)
                    {
                        scope.update();
                    }
                }

                scope.init();
            }
        };
    }]);

angular.module('ui.bootstrap.tabindex', [])

    .directive('uibTabindexToggle', function() {
        return {
            restrict: 'A',
            link: function(scope, elem, attrs) {
                attrs.$observe('disabled', function(disabled) {
                    attrs.$set('tabindex', disabled ? -1 : null);
                });
            }
        };
    });

/*
* MODIFICATIONS:
* JBT - Added option to use nav-pills instead of nav-tabs class
* JBT - Added option to hide the tab bar (the active pane will still be visible)
* JBT - Added direction attribute for left/right/below tabs
* JSM - Added pane-index to keep order of tab panes in order.
*/

'use strict';

angular.module('ui.bootstrap.tabs', [])
.controller('TabsController', ['$scope', '$element', function($scope, $element) {
    var panes = $scope.panes = [];

    this.select = $scope.select = function selectPane(pane) {
        angular.forEach(panes, function(pane) {
            pane.selected = false;
        });
        pane.selected = true;
    };

    this.addPane = function addPane(pane) {
        if (!panes.length) {
            $scope.select(pane);
        }
        panes.push(pane);
    };

    this.removePane = function removePane(pane) {
        var index = panes.indexOf(pane);
        panes.splice(index, 1);
        //Select a new pane if removed pane was selected
        if (pane.selected && panes.length > 0) {
            $scope.select(panes[index < panes.length ? index : index-1]);
        }
    };
}])
.directive('tabs', function($parse) {
    return {
        restrict: 'EA',
        transclude: true,
        scope: { tabBarVisible: '=?' },
        controller: 'TabsController',
        template:   '<div class="tabbable {{directionClass}}">' +
                        '<ul class="nav {{navClass}}" ng-show="tabBarVisible">' +
                            '<li ng-repeat="pane in panes | orderBy: \'paneIndex\'" ng-class="{active:pane.selected}"><a ng-click="select(pane)" ng-bind-html="pane.heading" data-test-id="btnOasTab_{{ pane.section ? pane.section : pane.heading }}"></a></li>' +
                        '</ul>' +
                        '<div class="tab-content" ng-transclude></div>' +
                    '</div>',
        replace: true,
        link: function(scope, element, attrs) {
            scope.tabIds = (attrs.id && attrs.id.trim().length > 0) ? ("lnk" + attrs.id.trim().charAt(0).toLocaleUpperCase() + attrs.id.trim().slice(1)) : "";
            scope.navClass = attrs.usePills && $parse(attrs.usePills) ? 'nav-pills' : 'nav-tabs';

            if (attrs.direction) {
                scope.directionClass = "tabs-" + attrs.direction;
            }

            scope.tabBarVisible = angular.isDefined(scope.tabBarVisible) ? scope.tabBarVisible : true;
        }
    };
})
.directive('pane', ['$parse', function($parse) {
    return {
        require: '^tabs',
        restrict: 'EA',
        transclude: true,
        scope:{
            heading:'@',
            tooltip:'@',
            onSelect: '&select',
            paneIndex: '@'
        },
        link: function(scope, element, attrs, tabsCtrl) {
            var getSelected, setSelected;
            scope.selected = false;
            if (attrs.paneSection) {
                scope.section = attrs.paneSection.trim().charAt(0).toLocaleUpperCase() + attrs.paneSection.trim().slice(1);
            }
            if (attrs.active) {
                getSelected = $parse(attrs.active);
                setSelected = getSelected.assign;
                scope.$watch(
                    function watchSelected() {return getSelected(scope.$parent);},
                    function updateSelected(value) {scope.selected = value;}
                );
                scope.selected = getSelected ? getSelected(scope.$parent) : false;
            }
            scope.$watch('selected', function(selected) {
                if(selected) {
                    tabsCtrl.select(scope);
                    scope.onSelect();
                }
                if(setSelected) {
                    setSelected(scope.$parent, selected);
                }
            });

            tabsCtrl.addPane(scope);
            scope.$on('$destroy', function() {
                tabsCtrl.removePane(scope);
            });
        },
        template: '<div class="tab-pane" ng-class="{active: selected}" ng-show="selected" ng-transclude></div>',
        replace: true
    };
}]);


angular.module('ui.bootstrap.timepicker', [])

    .constant('uibTimepickerConfig', {
        hourStep: 1,
        minuteStep: 1,
        secondStep: 1,
        showMeridian: true,
        showSeconds: false,
        meridians: null,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true,
        showSpinners: true,
        templateUrl: '_lib/angular-ui-bootstrap/template/timepicker/timepicker.html'
    })

    .controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
        var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
        var selected = new Date(),
            watchers = [],
            ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
            meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
            padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;

        $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
        $element.removeAttr('tabindex');

        this.init = function(ngModelCtrl_, inputs) {
            ngModelCtrl = ngModelCtrl_;
            ngModelCtrl.$render = this.render;

            ngModelCtrl.$formatters.unshift(function(modelValue) {
                return modelValue ? new Date(modelValue) : null;
            });

            var hoursInputEl = inputs.eq(0),
                minutesInputEl = inputs.eq(1),
                secondsInputEl = inputs.eq(2);

            hoursModelCtrl = hoursInputEl.controller('ngModel');
            minutesModelCtrl = minutesInputEl.controller('ngModel');
            secondsModelCtrl = secondsInputEl.controller('ngModel');

            var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;

            if (mousewheel) {
                this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
            }

            var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
            if (arrowkeys) {
                this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
            }

            $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
            this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
        };

        var hourStep = timepickerConfig.hourStep;
        if ($attrs.hourStep) {
            watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function(value) {
                hourStep = +value;
            }));
        }

        var minuteStep = timepickerConfig.minuteStep;
        if ($attrs.minuteStep) {
            watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
                minuteStep = +value;
            }));
        }

        var min;
        watchers.push($scope.$parent.$watch($parse($attrs.min), function(value) {
            var dt = new Date(value);
            min = isNaN(dt) ? undefined : dt;
        }));

        var max;
        watchers.push($scope.$parent.$watch($parse($attrs.max), function(value) {
            var dt = new Date(value);
            max = isNaN(dt) ? undefined : dt;
        }));

        var disabled = false;
        if ($attrs.ngDisabled) {
            watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(value) {
                disabled = value;
            }));
        }

        $scope.noIncrementHours = function() {
            var incrementedSelected = addMinutes(selected, hourStep * 60);
            return disabled || incrementedSelected > max ||
                incrementedSelected < selected && incrementedSelected < min;
        };

        $scope.noDecrementHours = function() {
            var decrementedSelected = addMinutes(selected, -hourStep * 60);
            return disabled || decrementedSelected < min ||
                decrementedSelected > selected && decrementedSelected > max;
        };

        $scope.noIncrementMinutes = function() {
            var incrementedSelected = addMinutes(selected, minuteStep);
            return disabled || incrementedSelected > max ||
                incrementedSelected < selected && incrementedSelected < min;
        };

        $scope.noDecrementMinutes = function() {
            var decrementedSelected = addMinutes(selected, -minuteStep);
            return disabled || decrementedSelected < min ||
                decrementedSelected > selected && decrementedSelected > max;
        };

        $scope.noIncrementSeconds = function() {
            var incrementedSelected = addSeconds(selected, secondStep);
            return disabled || incrementedSelected > max ||
                incrementedSelected < selected && incrementedSelected < min;
        };

        $scope.noDecrementSeconds = function() {
            var decrementedSelected = addSeconds(selected, -secondStep);
            return disabled || decrementedSelected < min ||
                decrementedSelected > selected && decrementedSelected > max;
        };

        $scope.noToggleMeridian = function() {
            if (selected.getHours() < 12) {
                return disabled || addMinutes(selected, 12 * 60) > max;
            }

            return disabled || addMinutes(selected, -12 * 60) < min;
        };

        var secondStep = timepickerConfig.secondStep;
        if ($attrs.secondStep) {
            watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function(value) {
                secondStep = +value;
            }));
        }

        $scope.showSeconds = timepickerConfig.showSeconds;
        if ($attrs.showSeconds) {
            watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function(value) {
                $scope.showSeconds = !!value;
            }));
        }

        // 12H / 24H mode
        $scope.showMeridian = timepickerConfig.showMeridian;
        if ($attrs.showMeridian) {
            watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
                $scope.showMeridian = !!value;

                if (ngModelCtrl.$error.time) {
                    // Evaluate from template
                    var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
                    if (angular.isDefined(hours) && angular.isDefined(minutes)) {
                        selected.setHours(hours);
                        refresh();
                    }
                } else {
                    updateTemplate();
                }
            }));
        }

        // Get $scope.hours in 24H mode if valid
        function getHoursFromTemplate() {
            var hours = +$scope.hours;
            var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
                hours >= 0 && hours < 24;
            if (!valid || $scope.hours === '') {
                return undefined;
            }

            if ($scope.showMeridian) {
                if (hours === 12) {
                    hours = 0;
                }
                if ($scope.meridian === meridians[1]) {
                    hours = hours + 12;
                }
            }
            return hours;
        }

        function getMinutesFromTemplate() {
            var minutes = +$scope.minutes;
            var valid = minutes >= 0 && minutes < 60;
            if (!valid || $scope.minutes === '') {
                return undefined;
            }
            return minutes;
        }

        function getSecondsFromTemplate() {
            var seconds = +$scope.seconds;
            return seconds >= 0 && seconds < 60 ? seconds : undefined;
        }

        function pad(value, noPad) {
            if (value === null) {
                return '';
            }

            return angular.isDefined(value) && value.toString().length < 2 && !noPad ?
                '0' + value : value.toString();
        }

        // Respond on mousewheel spin
        this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
            var isScrollingUp = function(e) {
                if (e.originalEvent) {
                    e = e.originalEvent;
                }
                //pick correct delta variable depending on event
                var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
                return e.detail || delta > 0;
            };

            hoursInputEl.on('mousewheel wheel', function(e) {
                if (!disabled) {
                    $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
                }
                e.preventDefault();
            });

            minutesInputEl.on('mousewheel wheel', function(e) {
                if (!disabled) {
                    $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
                }
                e.preventDefault();
            });

            secondsInputEl.on('mousewheel wheel', function(e) {
                if (!disabled) {
                    $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
                }
                e.preventDefault();
            });
        };

        // Respond on up/down arrowkeys
        this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
            hoursInputEl.on('keydown', function(e) {
                if (!disabled) {
                    if (e.which === 38) { // up
                        e.preventDefault();
                        $scope.incrementHours();
                        $scope.$apply();
                    } else if (e.which === 40) { // down
                        e.preventDefault();
                        $scope.decrementHours();
                        $scope.$apply();
                    }
                }
            });

            minutesInputEl.on('keydown', function(e) {
                if (!disabled) {
                    if (e.which === 38) { // up
                        e.preventDefault();
                        $scope.incrementMinutes();
                        $scope.$apply();
                    } else if (e.which === 40) { // down
                        e.preventDefault();
                        $scope.decrementMinutes();
                        $scope.$apply();
                    }
                }
            });

            secondsInputEl.on('keydown', function(e) {
                if (!disabled) {
                    if (e.which === 38) { // up
                        e.preventDefault();
                        $scope.incrementSeconds();
                        $scope.$apply();
                    } else if (e.which === 40) { // down
                        e.preventDefault();
                        $scope.decrementSeconds();
                        $scope.$apply();
                    }
                }
            });
        };

        this.setupInputEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
            if ($scope.readonlyInput) {
                $scope.updateHours = angular.noop;
                $scope.updateMinutes = angular.noop;
                $scope.updateSeconds = angular.noop;
                return;
            }

            var invalidate = function(invalidHours, invalidMinutes, invalidSeconds) {
                ngModelCtrl.$setViewValue(null);
                ngModelCtrl.$setValidity('time', false);
                if (angular.isDefined(invalidHours)) {
                    $scope.invalidHours = invalidHours;
                    if (hoursModelCtrl) {
                        hoursModelCtrl.$setValidity('hours', false);
                    }
                }

                if (angular.isDefined(invalidMinutes)) {
                    $scope.invalidMinutes = invalidMinutes;
                    if (minutesModelCtrl) {
                        minutesModelCtrl.$setValidity('minutes', false);
                    }
                }

                if (angular.isDefined(invalidSeconds)) {
                    $scope.invalidSeconds = invalidSeconds;
                    if (secondsModelCtrl) {
                        secondsModelCtrl.$setValidity('seconds', false);
                    }
                }
            };

            $scope.updateHours = function() {
                var hours = getHoursFromTemplate(),
                    minutes = getMinutesFromTemplate();

                ngModelCtrl.$setDirty();

                if (angular.isDefined(hours) && angular.isDefined(minutes)) {
                    selected.setHours(hours);
                    selected.setMinutes(minutes);
                    if (selected < min || selected > max) {
                        invalidate(true);
                    } else {
                        refresh('h');
                    }
                } else {
                    invalidate(true);
                }
            };

            hoursInputEl.on('blur', function(e) {
                ngModelCtrl.$setTouched();
                if (modelIsEmpty()) {
                    makeValid();
                } else if ($scope.hours === null || $scope.hours === '') {
                    invalidate(true);
                } else if (!$scope.invalidHours && $scope.hours < 10) {
                    $scope.$apply(function() {
                        $scope.hours = pad($scope.hours, !padHours);
                    });
                }
            });

            $scope.updateMinutes = function() {
                var minutes = getMinutesFromTemplate(),
                    hours = getHoursFromTemplate();

                ngModelCtrl.$setDirty();

                if (angular.isDefined(minutes) && angular.isDefined(hours)) {
                    selected.setHours(hours);
                    selected.setMinutes(minutes);
                    if (selected < min || selected > max) {
                        invalidate(undefined, true);
                    } else {
                        refresh('m');
                    }
                } else {
                    invalidate(undefined, true);
                }
            };

            minutesInputEl.on('blur', function(e) {
                ngModelCtrl.$setTouched();
                if (modelIsEmpty()) {
                    makeValid();
                } else if ($scope.minutes === null) {
                    invalidate(undefined, true);
                } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
                    $scope.$apply(function() {
                        $scope.minutes = pad($scope.minutes);
                    });
                }
            });

            $scope.updateSeconds = function() {
                var seconds = getSecondsFromTemplate();

                ngModelCtrl.$setDirty();

                if (angular.isDefined(seconds)) {
                    selected.setSeconds(seconds);
                    refresh('s');
                } else {
                    invalidate(undefined, undefined, true);
                }
            };

            secondsInputEl.on('blur', function(e) {
                if (modelIsEmpty()) {
                    makeValid();
                } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
                    $scope.$apply( function() {
                        $scope.seconds = pad($scope.seconds);
                    });
                }
            });

        };

        this.render = function() {
            var date = ngModelCtrl.$viewValue;

            if (isNaN(date)) {
                ngModelCtrl.$setValidity('time', false);
                $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
            } else {
                if (date) {
                    selected = date;
                }

                if (selected < min || selected > max) {
                    ngModelCtrl.$setValidity('time', false);
                    $scope.invalidHours = true;
                    $scope.invalidMinutes = true;
                } else {
                    makeValid();
                }
                updateTemplate();
            }
        };

        // Call internally when we know that model is valid.
        function refresh(keyboardChange) {
            makeValid();
            ngModelCtrl.$setViewValue(new Date(selected));
            updateTemplate(keyboardChange);
        }

        function makeValid() {
            if (hoursModelCtrl) {
                hoursModelCtrl.$setValidity('hours', true);
            }

            if (minutesModelCtrl) {
                minutesModelCtrl.$setValidity('minutes', true);
            }

            if (secondsModelCtrl) {
                secondsModelCtrl.$setValidity('seconds', true);
            }

            ngModelCtrl.$setValidity('time', true);
            $scope.invalidHours = false;
            $scope.invalidMinutes = false;
            $scope.invalidSeconds = false;
        }

        function updateTemplate(keyboardChange) {
            if (!ngModelCtrl.$modelValue) {
                $scope.hours = null;
                $scope.minutes = null;
                $scope.seconds = null;
                $scope.meridian = meridians[0];
            } else {
                var hours = selected.getHours(),
                    minutes = selected.getMinutes(),
                    seconds = selected.getSeconds();

                if ($scope.showMeridian) {
                    hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
                }

                $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
                if (keyboardChange !== 'm') {
                    $scope.minutes = pad(minutes);
                }
                $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];

                if (keyboardChange !== 's') {
                    $scope.seconds = pad(seconds);
                }
                $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
            }
        }

        function addSecondsToSelected(seconds) {
            selected = addSeconds(selected, seconds);
            refresh();
        }

        function addMinutes(selected, minutes) {
            return addSeconds(selected, minutes*60);
        }

        function addSeconds(date, seconds) {
            var dt = new Date(date.getTime() + seconds * 1000);
            var newDate = new Date(date);
            newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
            return newDate;
        }

        function modelIsEmpty() {
            return ($scope.hours === null || $scope.hours === '') &&
                ($scope.minutes === null || $scope.minutes === '') &&
                (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
        }

        $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
            $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;

        $scope.incrementHours = function() {
            if (!$scope.noIncrementHours()) {
                addSecondsToSelected(hourStep * 60 * 60);
            }
        };

        $scope.decrementHours = function() {
            if (!$scope.noDecrementHours()) {
                addSecondsToSelected(-hourStep * 60 * 60);
            }
        };

        $scope.incrementMinutes = function() {
            if (!$scope.noIncrementMinutes()) {
                addSecondsToSelected(minuteStep * 60);
            }
        };

        $scope.decrementMinutes = function() {
            if (!$scope.noDecrementMinutes()) {
                addSecondsToSelected(-minuteStep * 60);
            }
        };

        $scope.incrementSeconds = function() {
            if (!$scope.noIncrementSeconds()) {
                addSecondsToSelected(secondStep);
            }
        };

        $scope.decrementSeconds = function() {
            if (!$scope.noDecrementSeconds()) {
                addSecondsToSelected(-secondStep);
            }
        };

        $scope.toggleMeridian = function() {
            var minutes = getMinutesFromTemplate(),
                hours = getHoursFromTemplate();

            if (!$scope.noToggleMeridian()) {
                if (angular.isDefined(minutes) && angular.isDefined(hours)) {
                    addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
                } else {
                    $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
                }
            }
        };

        $scope.blur = function() {
            ngModelCtrl.$setTouched();
        };

        $scope.$on('$destroy', function() {
            while (watchers.length) {
                watchers.shift()();
            }
        });
    }])

    .directive('timepicker', ['uibTimepickerConfig', function(uibTimepickerConfig) {
        return {
            require: ['timepicker', '?^ngModel'],
            restrict: 'A',
            controller: 'UibTimepickerController',
            controllerAs: 'timepicker',
            scope: {},
            templateUrl: function(element, attrs) {
                return attrs.templateUrl || uibTimepickerConfig.templateUrl;
            },
            link: function(scope, element, attrs, ctrls) {
                var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                if (ngModelCtrl) {
                    timepickerCtrl.init(ngModelCtrl, element.find('input'));
                }
            }
        };
    }]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.bindHtml'])

/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */
    .provider('$tooltip', function() {
        // The default options tooltip and popover.
        var defaultOptions = {
            placement: 'top',
            animation: true,
            popupDelay: 0,
            useContentExp: false
        };

        // Default hide triggers for each show trigger
        var triggerMap = {
            'mouseenter': 'mouseleave',
            'click': 'click',
            'focus': 'blur',
            'none': ''
        };

        // The options specified to the provider globally.
        var globalOptions = {};

        /**
         * `options({})` allows global configuration of all tooltips in the
         * application.
         *
         *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
   *     // place tooltips left instead of top by default
   *     $tooltipProvider.options( { placement: 'left' } );
   *   });
         */
        this.options = function(value) {
            angular.extend(globalOptions, value);
        };

        /**
         * This allows you to extend the set of trigger mappings available. E.g.:
         *
         *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
         */
        this.setTriggers = function setTriggers(triggers) {
            angular.extend(triggerMap, triggers);
        };

        /**
         * This is a helper function for translating camel-case to snake-case.
         */
        function snake_case(name) {
            var regexp = /[A-Z]/g;
            var separator = '-';
            return name.replace(regexp, function(letter, pos) {
                return (pos ? separator : '') + letter.toLowerCase();
            });
        }

        /**
         * Returns the actual instance of the $tooltip service.
         * TODO support multiple triggers
         */
        this.$get = ['$window', '$compile', '$timeout', '$document', '$position', '$interpolate', '$rootScope', '$parse', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse) {
            return function $tooltip(type, prefix, defaultTriggerShow, options) {
                options = angular.extend({}, defaultOptions, globalOptions, options);

                /**
                 * Returns an object of show and hide triggers.
                 *
                 * If a trigger is supplied,
                 * it is used to show the tooltip; otherwise, it will use the `trigger`
                 * option passed to the `$tooltipProvider.options` method; else it will
                 * default to the trigger supplied to this directive factory.
                 *
                 * The hide trigger is based on the show trigger. If the `trigger` option
                 * was passed to the `$tooltipProvider.options` method, it will use the
                 * mapped trigger from `triggerMap` or the passed trigger if the map is
                 * undefined; otherwise, it uses the `triggerMap` value of the show
                 * trigger; else it will just use the show trigger.
                 */
                function getTriggers(trigger) {
                    var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
                    var hide = show.map(function(trigger) {
                        return triggerMap[trigger] || trigger;
                    });
                    return {
                        show: show,
                        hide: hide
                    };
                }

                var directiveName = snake_case(type);

                var startSym = $interpolate.startSymbol();
                var endSym = $interpolate.endSymbol();
                var template =
                    '<div '+ directiveName +'-popup '+
                    'title="'+startSym+'title'+endSym+'" '+
                    (options.useContentExp ?
                        'content-exp="contentExp()" ' :
                    'content="'+startSym+'content'+endSym+'" ') +
                    'placement="'+startSym+'placement'+endSym+'" '+
                    'popup-class="'+startSym+'popupClass'+endSym+'" '+
                    'animation="animation" '+
                    'is-open="isOpen"'+
                    'origin-scope="origScope" '+
                    '>'+
                    '</div>';

                return {
                    restrict: 'EA',
                    compile: function(tElem, tAttrs) {
                        var tooltipLinker = $compile( template );

                        return function link(scope, element, attrs, tooltipCtrl) {
                            var tooltip;
                            var tooltipLinkedScope;
                            var transitionTimeout;
                            var popupTimeout;
                            var positionTimeout;
                            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
                            var triggers = getTriggers(undefined);
                            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
                            var ttScope = scope.$new(true);
                            var repositionScheduled = false;
                            var isOpenExp = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;

                            var positionTooltip = function() {
                                if (!tooltip) { return; }

                                if (!positionTimeout) {
                                    positionTimeout = $timeout(function() {
                                        // Reset the positioning and box size for correct width and height values.
                                        tooltip.css({ top: 0, left: 0, width: 'auto', height: 'auto' });

                                        var ttBox = $position.position(tooltip);
                                        var ttCss = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                                        ttCss.top += 'px';
                                        ttCss.left += 'px';

                                        ttCss.width = ttBox.width + 'px';
                                        ttCss.height = ttBox.height + 'px';

                                        // Now set the calculated positioning and size.
                                        tooltip.css(ttCss);

                                        positionTimeout = null;

                                    }, 0, false);
                                }
                            };

                            // Set up the correct scope to allow transclusion later
                            ttScope.origScope = scope;

                            // By default, the tooltip is not open.
                            // TODO add ability to start tooltip opened
                            ttScope.isOpen = false;

                            function toggleTooltipBind() {
                                if (!ttScope.isOpen) {
                                    showTooltipBind();
                                } else {
                                    hideTooltipBind();
                                }
                            }

                            // Show the tooltip with delay if specified, otherwise show it immediately
                            function showTooltipBind() {
                                if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                                    return;
                                }

                                prepareTooltip();

                                if (ttScope.popupDelay) {
                                    // Do nothing if the tooltip was already scheduled to pop-up.
                                    // This happens if show is triggered multiple times before any hide is triggered.
                                    if (!popupTimeout) {
                                        popupTimeout = $timeout(show, ttScope.popupDelay, false);
                                    }
                                } else {
                                    show();
                                }
                            }

                            function hideTooltipBind () {
                                hide();
                                if (!$rootScope.$$phase) {
                                    $rootScope.$digest();
                                }
                            }

                            // Show the tooltip popup element.
                            function show() {
                                popupTimeout = null;

                                // If there is a pending remove transition, we must cancel it, lest the
                                // tooltip be mysteriously removed.
                                if (transitionTimeout) {
                                    $timeout.cancel(transitionTimeout);
                                    transitionTimeout = null;
                                }

                                // Don't show empty tooltips.
                                if (!(options.useContentExp ? ttScope.contentExp() : ttScope.content)) {
                                    return angular.noop;
                                }

                                createTooltip();

                                // And show the tooltip.
                                ttScope.isOpen = true;
                                if (isOpenExp) {
                                    isOpenExp.assign(ttScope.origScope, ttScope.isOpen);
                                }

                                if (!$rootScope.$$phase) {
                                    ttScope.$apply(); // digest required as $apply is not called
                                }

                                tooltip.css({ display: 'block' });

                                positionTooltip();
                            }

                            // Hide the tooltip popup element.
                            function hide() {
                                // First things first: we don't show it anymore.
                                ttScope.isOpen = false;
                                if (isOpenExp) {
                                    isOpenExp.assign(ttScope.origScope, ttScope.isOpen);
                                }

                                //if tooltip is going to be shown after delay, we must cancel this
                                $timeout.cancel(popupTimeout);
                                popupTimeout = null;

                                $timeout.cancel(positionTimeout);
                                positionTimeout = null;

                                // And now we remove it from the DOM. However, if we have animation, we
                                // need to wait for it to expire beforehand.
                                // FIXME: this is a placeholder for a port of the transitions library.
                                if (ttScope.animation) {
                                    if (!transitionTimeout) {
                                        transitionTimeout = $timeout(removeTooltip, 500);
                                    }
                                } else {
                                    removeTooltip();
                                }
                            }

                            function createTooltip() {
                                // There can only be one tooltip element per directive shown at once.
                                if (tooltip) {
                                    removeTooltip();
                                }
                                tooltipLinkedScope = ttScope.$new();
                                tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
                                    if (appendToBody) {
                                        $document.find('body').append(tooltip);
                                    } else {
                                        element.after(tooltip);
                                    }
                                });

                                if (options.useContentExp) {
                                    tooltipLinkedScope.$watch('contentExp()', function(val) {
                                        if (!val && ttScope.isOpen) {
                                            hide();
                                        }
                                    });

                                    tooltipLinkedScope.$watch(function() {
                                        if (!repositionScheduled) {
                                            repositionScheduled = true;
                                            tooltipLinkedScope.$$postDigest(function() {
                                                repositionScheduled = false;
                                                if (ttScope.isOpen) {
                                                    positionTooltip();
                                                }
                                            });
                                        }
                                    });

                                }
                            }

                            function removeTooltip() {
                                transitionTimeout = null;
                                if (tooltip) {
                                    tooltip.remove();
                                    tooltip = null;
                                }
                                if (tooltipLinkedScope) {
                                    tooltipLinkedScope.$destroy();
                                    tooltipLinkedScope = null;
                                }
                            }

                            function prepareTooltip() {
                                prepPopupClass();
                                prepPlacement();
                                prepPopupDelay();
                            }

                            ttScope.contentExp = function() {
                                return scope.$eval(attrs[type]);
                            };

                            /**
                             * Observe the relevant attributes.
                             */
                            if (!options.useContentExp) {
                                attrs.$observe(type, function(val) {
                                    ttScope.content = val;

                                    if (!val && ttScope.isOpen) {
                                        hide();
                                    } else {
                                        positionTooltip();
                                    }
                                });
                            }

                            attrs.$observe('disabled', function(val) {
                                if (popupTimeout && val) {
                                    $timeout.cancel(popupTimeout);
                                    popupTimeout = null;
                                }

                                if (val && ttScope.isOpen) {
                                    hide();
                                }
                            });

                            attrs.$observe(prefix + 'Title', function(val) {
                                ttScope.title = val;
                                positionTooltip();
                            });

                            attrs.$observe(prefix + 'Placement', function() {
                                if (ttScope.isOpen) {
                                    prepPlacement();
                                    positionTooltip();
                                }
                            });

                            if (isOpenExp) {
                                scope.$watch(isOpenExp, function(val) {
                                    if (val !== ttScope.isOpen) {
                                        toggleTooltipBind();
                                    }
                                });
                            }

                            function prepPopupClass() {
                                ttScope.popupClass = attrs[prefix + 'Class'];
                            }

                            function prepPlacement() {
                                var val = attrs[prefix + 'Placement'];
                                ttScope.placement = angular.isDefined(val) ? val : options.placement;
                            }

                            function prepPopupDelay() {
                                var val = attrs[prefix + 'PopupDelay'];
                                var delay = parseInt(val, 10);
                                ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
                            }

                            var unregisterTriggers = function() {
                                triggers.show.forEach(function(trigger) {
                                    element.off(trigger, showTooltipBind);
                                });
                                triggers.hide.forEach(function(trigger) {
                                    element.off(trigger, hideTooltipBind);
                                });
                            };

                            function prepTriggers() {
                                var val = attrs[prefix + 'Trigger'];
                                unregisterTriggers();

                                triggers = getTriggers(val);

                                if (triggers.show !== 'none') {
                                    triggers.show.forEach(function(trigger, idx) {
                                        // Using raw addEventListener due to jqLite/jQuery bug - #4060
                                        if (trigger === triggers.hide[idx]) {
                                            element[0].addEventListener(trigger, toggleTooltipBind);
                                        } else if (trigger) {
                                            element[0].addEventListener(trigger, showTooltipBind);
                                            element[0].addEventListener(triggers.hide[idx], hideTooltipBind);
                                        }
                                    });
                                }
                            }
                            prepTriggers();

                            var animation = scope.$eval(attrs[prefix + 'Animation']);
                            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

                            var appendToBodyVal = scope.$eval(attrs[prefix + 'AppendToBody']);
                            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

                            // if a tooltip is attached to <body> we need to remove it on
                            // location change as its parent scope will probably not be destroyed
                            // by the change.
                            if (appendToBody) {
                                scope.$on('$locationChangeSuccess', function closeTooltipOnLocationChangeSuccess() {
                                    if (ttScope.isOpen) {
                                        hide();
                                    }
                                });
                            }

                            // Make sure tooltip is destroyed and removed.
                            scope.$on('$destroy', function onDestroyTooltip() {
                                $timeout.cancel(transitionTimeout);
                                $timeout.cancel(popupTimeout);
                                $timeout.cancel(positionTimeout);
                                unregisterTriggers();
                                removeTooltip();
                                ttScope = null;
                            });
                        };
                    }
                };
            };
        }];
    })

// This is mostly ngInclude code but with a custom scope
    .directive('tooltipTemplateTransclude', [
        '$animate', '$sce', '$compile', '$templateRequest',
        function ($animate ,  $sce ,  $compile ,  $templateRequest) {
            return {
                link: function(scope, elem, attrs) {
                    var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

                    var changeCounter = 0,
                        currentScope,
                        previousElement,
                        currentElement;

                    var cleanupLastIncludeContent = function() {
                        if (previousElement) {
                            previousElement.remove();
                            previousElement = null;
                        }
                        if (currentScope) {
                            currentScope.$destroy();
                            currentScope = null;
                        }
                        if (currentElement) {
                            $animate.leave(currentElement).then(function() {
                                previousElement = null;
                            });
                            previousElement = currentElement;
                            currentElement = null;
                        }
                    };

                    scope.$watch($sce.parseAsResourceUrl(attrs.tooltipTemplateTransclude), function(src) {
                        var thisChangeId = ++changeCounter;

                        if (src) {
                            //set the 2nd param to true to ignore the template request error so that the inner
                            //contents and scope can be cleaned up.
                            $templateRequest(src, true).then(function(response) {
                                if (thisChangeId !== changeCounter) { return; }
                                var newScope = origScope.$new();
                                var template = response;

                                var clone = $compile(template)(newScope, function(clone) {
                                    cleanupLastIncludeContent();
                                    $animate.enter(clone, elem);
                                });

                                currentScope = newScope;
                                currentElement = clone;

                                currentScope.$emit('$includeContentLoaded', src);
                            }, function() {
                                if (thisChangeId === changeCounter) {
                                    cleanupLastIncludeContent();
                                    scope.$emit('$includeContentError', src);
                                }
                            });
                            scope.$emit('$includeContentRequested', src);
                        } else {
                            cleanupLastIncludeContent();
                        }
                    });

                    scope.$on('$destroy', cleanupLastIncludeContent);
                }
            };
        }])

/**
 * Note that it's intentional that these classes are *not* applied through $animate.
 * They must not be animated as they're expected to be present on the tooltip on
 * initialization.
 */
    .directive('tooltipClasses', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                if (scope.placement) {
                    element.addClass(scope.placement);
                }
                if (scope.popupClass) {
                    element.addClass(scope.popupClass);
                }
                if (scope.animation()) {
                    element.addClass(attrs.tooltipAnimationClass);
                }
            }
        };
    })

    .directive('tooltipPopup', function() {
        return {
            restrict: 'EA',
            replace: true,
            scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
            templateUrl: '_lib/angular-ui-bootstrap/template/tooltip/tooltip-popup.html'
        };
    })

    .directive('tooltip', [ '$tooltip', function($tooltip) {
        return $tooltip('tooltip', 'tooltip', 'mouseenter');
    }])

    .directive('tooltipTemplatePopup', function() {
        return {
            restrict: 'EA',
            replace: true,
            scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
                originScope: '&' },
            templateUrl: '_lib/angular-ui-bootstrap/template/tooltip/tooltip-template-popup.html'
        };
    })

    .directive('tooltipTemplate', ['$tooltip', function($tooltip) {
        return $tooltip('tooltipTemplate', 'tooltip', 'mouseenter', {
            useContentExp: true
        });
    }])

    .directive('tooltipHtmlPopup', function() {
        return {
            restrict: 'EA',
            replace: true,
            scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
            templateUrl: '_lib/angular-ui-bootstrap/template/tooltip/tooltip-html-popup.html'
        };
    })

    .directive('tooltipHtml', ['$tooltip', function($tooltip) {
        return $tooltip('tooltipHtml', 'tooltip', 'mouseenter', {
            useContentExp: true
        });
    }])

    /*
     Deprecated
     */
    .directive('tooltipHtmlUnsafePopup', function() {
        return {
            restrict: 'EA',
            replace: true,
            scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
            templateUrl: '_lib/angular-ui-bootstrap/template/tooltip/tooltip-html-unsafe-popup.html'
        };
    })

    .value('tooltipHtmlUnsafeSuppressDeprecated', false)
    .directive('tooltipHtmlUnsafe', [
        '$tooltip', 'tooltipHtmlUnsafeSuppressDeprecated', '$log',
        function($tooltip ,  tooltipHtmlUnsafeSuppressDeprecated ,  $log) {
            if (!tooltipHtmlUnsafeSuppressDeprecated) {
                $log.warn('tooltip-html-unsafe is now deprecated. Use tooltip-html or tooltip-template instead.');
            }
            return $tooltip('tooltipHtmlUnsafe', 'tooltip', 'mouseenter');
        }]);

/* JBT - commented out MSTransitionEnd - it breaks IE10 after a modal is displayed */

angular.module('ui.bootstrap.transition', [])

/**
 * $transition service provides a consistent interface to trigger CSS 3 transitions and to be informed when they complete.
 * @param  {DOMElement} element  The DOMElement that will be animated.
 * @param  {string|object|function} trigger  The thing that will cause the transition to start:
 *   - As a string, it represents the css class to be added to the element.
 *   - As an object, it represents a hash of style attributes to be applied to the element.
 *   - As a function, it represents a function to be called that will cause the transition to occur.
 * @return {Promise}  A promise that is resolved when the transition finishes.
 */
.factory('$transition', ['$q', '$timeout', '$rootScope', function ($q, $timeout, $rootScope) {

    var $transition = function (element, trigger, options) {
        options = options || {};
        var deferred = $q.defer();
        var endEventName = $transition[options.animation ? "animationEndEventName" : "transitionEndEventName"];

        var transitionEndHandler = function (event) {
            $rootScope.$apply(function () {
                element.off(endEventName, transitionEndHandler);
                deferred.resolve(element);
            });
        };

        if (endEventName) {
            element.on(endEventName, transitionEndHandler);
        }

        // Wrap in a timeout to allow the browser time to update the DOM before the transition is to occur
        $timeout(function () {
            if (angular.isString(trigger)) {
                element.addClass(trigger);
            } else if (angular.isFunction(trigger)) {
                trigger(element);
            } else if (angular.isObject(trigger)) {
                element.css(trigger);
            }
            //If browser does not support transitions, instantly resolve
            if (!endEventName) {
                deferred.resolve(element);
            }
        });

        // Add our custom cancel function to the promise that is returned
        // We can call this if we are about to run a new transition, which we know will prevent this transition from ending,
        // i.e. it will therefore never raise a transitionEnd event for that transition
        deferred.promise.cancel = function () {
            if (endEventName) {
                element.off(endEventName, transitionEndHandler);
            }
            deferred.reject('Transition cancelled');
        };

        return deferred.promise;
    };

    // Work out the name of the transitionEnd event
    var transElement = document.createElement('trans');
    var transitionEndEventNames = {
        'WebkitTransition': 'webkitTransitionEnd',
        'MozTransition': 'transitionend',
        'OTransition': 'oTransitionEnd',
        //'msTransition': 'MSTransitionEnd',
        'transition': 'transitionend'
    };
    var animationEndEventNames = {
        'WebkitTransition': 'webkitAnimationEnd',
        'MozTransition': 'animationend',
        'OTransition': 'oAnimationEnd',
        'msTransition': 'MSAnimationEnd',
        'transition': 'animationend'
    };
    function findEndEventName(endEventNames) {
        for (var name in endEventNames) {
            if (transElement.style[name] !== undefined) {
                return endEventNames[name];
            }
        }
    }
    $transition.transitionEndEventName = findEndEventName(transitionEndEventNames);
    $transition.animationEndEventName = findEndEventName(animationEndEventNames);
    return $transition;
}]);

/* JBT - added 'typeahead' css class to typeahead-popup.html for z-index issue when inside modal window */
/* JBT - changed ng-click to ng-mousedown on typeahead-popup.html so it fires before ng-blur on a sibling control */
/* JBT - removed requirement for typeahead to have focus in order to display search results */

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.position', 'ui.bootstrap.bindHtml'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
    .factory('typeaheadParser', ['$parse', function ($parse) {

        //                      00000111000000000000022200000000000000003333333333333330000000000044000
        var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;

        return {
            parse:function (input) {

                var match = input.match(TYPEAHEAD_REGEXP);
                if (!match) {
                    throw new Error(
                        'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
                        ' but got "' + input + '".');
                }

                return {
                    itemName:match[3],
                    source:$parse(match[4]),
                    viewMapper:$parse(match[2] || match[1]),
                    modelMapper:$parse(match[1])
                };
            }
        };
    }])

    .directive('typeahead', ['$compile', '$parse', '$q', '$timeout', '$document', '$position', '$window', 'typeaheadParser', 'ZIndexCalculationService',
        function ($compile, $parse, $q, $timeout, $document, $position, $window, typeaheadParser, ZIndexCalculationService) {

            var HOT_KEYS = [9, 13, 27, 38, 40];

            return {
                require:'ngModel',
                link:function (originalScope, element, attrs, modelCtrl) {
                    //SUPPORTED ATTRIBUTES (OPTIONS)

                    //tells typeahead to render open when the user clicks
                    var clickOpen = originalScope.$eval(attrs.typeaheadClickOpen);

                    //minimal no of characters that needs to be entered before typeahead kicks-in
                    var minSearch = originalScope.$eval(attrs.typeaheadMinLength);
                    if(!(parseFloat(minSearch) > -1)) minSearch = 1;

                    //minimal wait time after last character typed before typeahead kicks-in
                    var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

                    //should it restrict model values to the ones selected from the popup only?
                    var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;

                    //binding to a variable that indicates if matches are being retrieved asynchronously
                    var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

                    //a callback executed when a match is selected
                    var onSelectCallback = $parse(attrs.typeaheadOnSelect);

                    var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

                    var appendToBody =  attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

                    var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

                    var window = $window.window;

                    //INTERNAL VARIABLES

                    //model setter executed upon match selection
                    var $setModelValue = $parse(attrs.ngModel).assign;

                    //expressions used by typeahead
                    var parserResult = typeaheadParser.parse(attrs.typeahead);

                    var hasFocus;

                    //create a child scope for the typeahead directive so we are not polluting original scope
                    //with typeahead-specific data (matches, query etc.)
                    var scope = originalScope.$new();
                    originalScope.$on('$destroy', function(){
                        scope.$destroy();
                    });

                    // WAI-ARIA
                    var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
                    element.attr({
                        'aria-autocomplete': 'list',
                        'aria-expanded': false,
                        'aria-owns': popupId
                    });

                    //pop-up element used to display matches
                    var popUpEl = angular.element('<div typeahead-popup></div>');
                    popUpEl.attr({
                        id: popupId,
                        matches: 'matches',
                        active: 'activeIdx',
                        select: 'select(activeIdx)',
                        query: 'query',
                        position: 'position'
                    });
                    //custom item template
                    if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
                        popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
                    }

                    if (angular.isDefined(attrs.typeaheadOverParent)) {
                        popUpEl.css('z-index', ZIndexCalculationService.getFirstSetZIndex(element[0]));
                    }

                    var resetMatches = function() {
                        scope.matches = [];
                        scope.activeIdx = -1;
                        element.attr('aria-expanded', false);
                    };

                    var getMatchId = function(index) {
                        return popupId + '-option-' + index;
                    };

                    // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
                    // This attribute is added or removed automatically when the `activeIdx` changes.
                    scope.$watch('activeIdx', function(index) {
                        if (index < 0) {
                            element.removeAttr('aria-activedescendant');
                        } else {
                            element.attr('aria-activedescendant', getMatchId(index));
                        }
                    });

                    var getMatchesAsync = function(inputValue) {

                        var locals = {$viewValue: inputValue};
                        isLoadingSetter(originalScope, true);
                        $q.when(parserResult.source(originalScope, locals)).then(function(matches) {

                            //it might happen that several async queries were in progress if a user were typing fast
                            //but we are interested only in responses that correspond to the current view value
                            var onCurrentRequest = (inputValue === modelCtrl.$viewValue);
                            if (onCurrentRequest) {
                                if (matches && matches.length > 0) {

                                    scope.activeIdx = focusFirst ? 0 : -1;
                                    scope.matches.length = 0;

                                    //transform labels
                                    for(var i=0; i<matches.length; i++) {
                                        locals[parserResult.itemName] = matches[i];
                                        scope.matches.push({
                                            id: getMatchId(i),
                                            label: parserResult.viewMapper(scope, locals),
                                            model: matches[i]
                                        });
                                    }

                                    scope.query = inputValue;
                                    //position pop-up with matches - we need to re-calculate its position each time we are opening a window
                                    //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
                                    //due to other elements being rendered
                                    scope.position = appendToBody ? $position.offset(element) : $position.position(element);
                                    scope.position.top = scope.position.top + element.prop('offsetHeight');


                                    var dropDownWidth = 0;
                                    var maxCharacters = 0;
                                    //loop to find the longest label in the dropdown and set a dropdown width
                                    for( var i=0; i<matches.length; i++){
                                        if( scope.matches[i].label.length > maxCharacters ) {
                                            maxCharacters = scope.matches[i].label.length;  // find the length of characters
                                            dropDownWidth =  maxCharacters  * ( maxCharacters > 66 ? 8.5 : 8 )// converting characters to pixels ( settled on 7.6 after trial and error )
                                        }
                                    }

                                    // check if the drop down is going off the page and move the left to accomidate the drop down width
                                    if ( ( scope.position.left + ( dropDownWidth ) > window.innerWidth ) ){
                                        scope.position.left = window.innerWidth - ( dropDownWidth );
                                    }

                                    element.attr('aria-expanded', true);
                                } else {
                                    resetMatches();
                                }
                            }
                            if (onCurrentRequest) {
                                isLoadingSetter(originalScope, false);
                            }
                        }, function(){
                            resetMatches();
                            isLoadingSetter(originalScope, false);
                        });
                    };

                    resetMatches();

                    //we need to propagate user's query so we can higlight matches
                    scope.query = undefined;

                    //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
                    var timeoutPromise;

                    var scheduleSearchWithTimeout = function(inputValue) {
                        timeoutPromise = $timeout(function () {
                            getMatchesAsync(inputValue);
                        }, waitTime);
                    };

                    var cancelPreviousTimeout = function() {
                        if (timeoutPromise) {
                            $timeout.cancel(timeoutPromise);
                        }
                    };

                    //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
                    //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
                    modelCtrl.$parsers.unshift(function (inputValue) {

                        hasFocus = true;

                        if (angular.isString(inputValue) && inputValue.length >= minSearch) {
                            if (waitTime > 0) {
                                cancelPreviousTimeout();
                                scheduleSearchWithTimeout(inputValue);
                            } else {
                                getMatchesAsync(inputValue);
                            }
                        } else {
                            isLoadingSetter(originalScope, false);
                            cancelPreviousTimeout();
                            resetMatches();
                        }

                        if (isEditable) {
                            return inputValue;
                        } else {
                            if (!inputValue) {
                                // Reset in case user had typed something previously.
                                modelCtrl.$setValidity('editable', true);
                                return inputValue;
                            } else {
                                modelCtrl.$setValidity('editable', false);
                                return undefined;
                            }
                        }
                    });

                    modelCtrl.$formatters.push(function (modelValue) {

                        var candidateViewValue, emptyViewValue;
                        var locals = {};

                        // The validity may be set to false via $parsers (see above) if
                        // the model is restricted to selected values. If the model
                        // is set manually it is considered to be valid.
                        if (!isEditable) {
                            modelCtrl.$setValidity('editable', true);
                        }

                        if (inputFormatter) {

                            locals.$model = modelValue;
                            return inputFormatter(originalScope, locals);

                        } else {

                            //it might happen that we don't have enough info to properly render input value
                            //we need to check for this situation and simply return model value if we can't apply custom formatting
                            locals[parserResult.itemName] = modelValue;
                            candidateViewValue = parserResult.viewMapper(originalScope, locals);
                            locals[parserResult.itemName] = undefined;
                            emptyViewValue = parserResult.viewMapper(originalScope, locals);

                            return candidateViewValue!== emptyViewValue ? candidateViewValue : modelValue;
                        }
                    });

                    scope.select = function (activeIdx) {
                        //called from within the $digest() cycle
                        var locals = {};
                        var model, item;

                        locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
                        model = parserResult.modelMapper(originalScope, locals);
                        $setModelValue(originalScope, model);
                        modelCtrl.$setValidity('editable', true);
                        modelCtrl.$setValidity('parse', true);

                        onSelectCallback(originalScope, {
                            $item: item,
                            $model: model,
                            $label: parserResult.viewMapper(originalScope, locals)
                        });

                        resetMatches();

                        //return focus to the input element if a match was selected via a mouse click event
                        // use timeout to avoid $rootScope:inprog error
                        $timeout(function() { element[0].focus(); }, 0, false);
                    };

                    //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
                    element.on('keydown', function (evt) {

                        //typeahead is open and an "interesting" key was pressed
                        if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
                            return;
                        }

                        // if there's nothing selected (i.e. focusFirst) and enter is hit, don't do anything
                        if (scope.activeIdx == -1 && (evt.which === 13 || evt.which === 9)) {
                            return;
                        }

                        evt.preventDefault();

                        if (evt.which === 40) {
                            scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
                            scope.$digest();

                        } else if (evt.which === 38) {
                            scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
                            scope.$digest();

                        } else if (evt.which === 13 || evt.which === 9) {
                            scope.$apply(function () {
                                scope.select(scope.activeIdx);
                            });

                        } else if (evt.which === 27) {
                            evt.stopPropagation();

                            resetMatches();
                            scope.$digest();
                        }
                    });

                    element.on('blur', function (evt) {
                        hasFocus = false;
                    });

                    // Keep reference to click handler to unbind it.
                    var dismissClickHandler = function (evt) {
                        if (element[0] !== evt.target) {
                            resetMatches();
                            scope.$digest();
                        } else if(clickOpen) {
                            angular.forEach(modelCtrl.$parsers, function (parser) {
                                parser(modelCtrl.$viewValue);
                            });
                        }
                    };

                    $document.on('click', dismissClickHandler);

                    originalScope.$on('$destroy', function(){
                        $document.off('click', dismissClickHandler);
                        if (appendToBody) {
                            $popup.remove();
                        }
                        // Prevent jQuery cache memory leak
                        popUpEl.remove();
                    });

                    var $popup = $compile(popUpEl)(scope);

                    if (appendToBody) {
                        $document.find('body').append($popup);
                    } else {
                        element.after($popup);
                    }
                }
            };

        }])

    .directive('typeaheadPopup', function () {
        return {
            restrict:'EA',
            scope:{
                matches:'=',
                query:'=',
                active:'=',
                position:'=',
                select:'&'
            },
            replace:true,
            templateUrl:'_lib/angular-ui-bootstrap/template/typeahead/typeahead-popup.html',
            link:function (scope, element, attrs) {

                scope.templateUrl = attrs.templateUrl;

                scope.isOpen = function () {
                    return scope.matches.length > 0;
                };

                scope.isActive = function (matchIdx) {
                    return scope.active == matchIdx;
                };

                scope.selectActive = function (matchIdx) {
                    scope.active = matchIdx;
                };

                scope.selectMatch = function (activeIdx) {
                    scope.select({activeIdx:activeIdx});
                };
            }
        };
    })

    .directive('typeaheadMatch', ['$templateRequest', '$compile', '$parse', function ($templateRequest, $compile, $parse) {
        return {
            restrict:'EA',
            scope:{
                index:'=',
                match:'=',
                query:'='
            },
            link:function (scope, element, attrs) {
                var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || '_lib/angular-ui-bootstrap/template/typeahead/typeahead-match.html';
                $templateRequest(tplUrl).then(function(tplContent) {
                    $compile(tplContent.trim())(scope, function(clonedElement){
                        element.replaceWith(clonedElement);
                    });
                });
            }
        };
    }])

    .filter('typeaheadHighlight', function() {

        function escapeRegexp(queryToEscape) {
            return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
        }

        return function(matchItem, query) {
            return query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem;
        };
    });

/**
 * angular-drag-and-drop-lists v2.1.0
 *
 * Copyright (c) 2014 Marcel Juenemann marcel@juenemann.cc
 * Copyright (c) 2014-2017 Google Inc.
 * https://github.com/marceljuenemann/angular-drag-and-drop-lists
 *
 * License: MIT
 */
(function(dndLists) {

  // In standard-compliant browsers we use a custom mime type and also encode the dnd-type in it.
  // However, IE and Edge only support a limited number of mime types. The workarounds are described
  // in https://github.com/marceljuenemann/angular-drag-and-drop-lists/wiki/Data-Transfer-Design
  var MIME_TYPE = 'application/x-dnd';
  var EDGE_MIME_TYPE = 'application/json';
  var MSIE_MIME_TYPE = 'Text';

  // All valid HTML5 drop effects, in the order in which we prefer to use them.
  var ALL_EFFECTS = ['move', 'copy', 'link'];

  /**
   * Use the dnd-draggable attribute to make your element draggable
   *
   * Attributes:
   * - dnd-draggable      Required attribute. The value has to be an object that represents the data
   *                      of the element. In case of a drag and drop operation the object will be
   *                      serialized and unserialized on the receiving end.
   * - dnd-effect-allowed Use this attribute to limit the operations that can be performed. Valid
   *                      options are "move", "copy" and "link", as well as "all", "copyMove",
   *                      "copyLink" and "linkMove". The semantics of these operations are up to you
   *                      and have to be implemented using the callbacks described below. If you
   *                      allow multiple options, the user can choose between them by using the
   *                      modifier keys (OS specific). The cursor will be changed accordingly,
   *                      expect for IE and Edge, where this is not supported.
   * - dnd-type           Use this attribute if you have different kinds of items in your
   *                      application and you want to limit which items can be dropped into which
   *                      lists. Combine with dnd-allowed-types on the dnd-list(s). This attribute
   *                      must be a lower case string. Upper case characters can be used, but will
   *                      be converted to lower case automatically.
   * - dnd-disable-if     You can use this attribute to dynamically disable the draggability of the
   *                      element. This is useful if you have certain list items that you don't want
   *                      to be draggable, or if you want to disable drag & drop completely without
   *                      having two different code branches (e.g. only allow for admins).
   *
   * Callbacks:
   * - dnd-dragstart      Callback that is invoked when the element was dragged. The original
   *                      dragstart event will be provided in the local event variable.
   * - dnd-moved          Callback that is invoked when the element was moved. Usually you will
   *                      remove your element from the original list in this callback, since the
   *                      directive is not doing that for you automatically. The original dragend
   *                      event will be provided in the local event variable.
   * - dnd-copied         Same as dnd-moved, just that it is called when the element was copied
   *                      instead of moved, so you probably want to implement a different logic.
   * - dnd-linked         Same as dnd-moved, just that it is called when the element was linked
   *                      instead of moved, so you probably want to implement a different logic.
   * - dnd-canceled       Callback that is invoked if the element was dragged, but the operation was
   *                      canceled and the element was not dropped. The original dragend event will
   *                      be provided in the local event variable.
   * - dnd-dragend        Callback that is invoked when the drag operation ended. Available local
   *                      variables are event and dropEffect.
   * - dnd-selected       Callback that is invoked when the element was clicked but not dragged.
   *                      The original click event will be provided in the local event variable.
   * - dnd-callback       Custom callback that is passed to dropzone callbacks and can be used to
   *                      communicate between source and target scopes. The dropzone can pass user
   *                      defined variables to this callback.
   *
   * CSS classes:
   * - dndDragging        This class will be added to the element while the element is being
   *                      dragged. It will affect both the element you see while dragging and the
   *                      source element that stays at it's position. Do not try to hide the source
   *                      element with this class, because that will abort the drag operation.
   * - dndDraggingSource  This class will be added to the element after the drag operation was
   *                      started, meaning it only affects the original element that is still at
   *                      it's source position, and not the "element" that the user is dragging with
   *                      his mouse pointer.
   */
  dndLists.directive('dndDraggable', ['$parse', '$timeout','ngZone', function($parse, $timeout, ngZone) {
    return function(scope, element, attr) {
      // Set the HTML5 draggable attribute on the element.
      //element.attr("draggable", "true");

      // If the dnd-disable-if attribute is set, we have to watch that.
      if (attr.dndDisableIf) {
        /*scope.$watch(attr.dndDisableIf, function(disabled) {
          //element.attr("draggable", !disabled);
        });*/
      }

      /**
       * When the drag operation is started we have to prepare the dataTransfer object,
       * which is the primary way we communicate with the target element
       */
      ngZone.runOutsideAngular(() => {
        element.on('dragstart', function(event) {
          event = event.originalEvent || event;

          // Check whether the element is draggable, since dragstart might be triggered on a child.
          if (element.attr('draggable') == 'false' || isTargetPrimeNgElement(event.target)) return true;

          // Initialize global state.
          dndState.isDragging = true;
          dndState.itemType = attr.dndType && scope.$eval(attr.dndType).toLowerCase();

          // Set the allowed drop effects. See below for special IE handling.
          dndState.dropEffect = "none";
          dndState.effectAllowed = attr.dndEffectAllowed || ALL_EFFECTS[0];
          event.dataTransfer.effectAllowed = dndState.effectAllowed;

          // Internet Explorer and Microsoft Edge don't support custom mime types, see design doc:
          // https://github.com/marceljuenemann/angular-drag-and-drop-lists/wiki/Data-Transfer-Design
          var item = scope.$eval(attr.dndDraggable);
          var mimeType = MIME_TYPE + (dndState.itemType ? ('-' + dndState.itemType) : '');
          try {
            event.dataTransfer.setData(mimeType, angular.toJson(item));
          } catch (e) {
            // Setting a custom MIME type did not work, we are probably in IE or Edge.
            var data = angular.toJson({item: item, type: dndState.itemType});
            try {
              event.dataTransfer.setData(EDGE_MIME_TYPE, data);
            } catch (e) {
              // We are in Internet Explorer and can only use the Text MIME type. Also note that IE
              // does not allow changing the cursor in the dragover event, therefore we have to choose
              // the one we want to display now by setting effectAllowed.
              var effectsAllowed = filterEffects(ALL_EFFECTS, dndState.effectAllowed);
              event.dataTransfer.effectAllowed = effectsAllowed[0];
              event.dataTransfer.setData(MSIE_MIME_TYPE, data);
            }
          }

          // Add CSS classes. See documentation above.
          element.addClass("dndDragging");
          $timeout(function() { element.addClass("dndDraggingSource"); }, 0);

          // Try setting a proper drag image if triggered on a dnd-handle (won't work in IE).
          if (event._dndHandle && event.dataTransfer.setDragImage) {
            event.dataTransfer.setDragImage(element[0], 0, 0);
          }

          // Invoke dragstart callback and prepare extra callback for dropzone.
          $parse(attr.dndDragstart)(scope, {event: event});
          if (attr.dndCallback) {
            var callback = $parse(attr.dndCallback);
            dndState.callback = function(params) { return callback(scope, params || {}); };
          }

          event.stopPropagation();
        });
      });


      /**
       * The dragend event is triggered when the element was dropped or when the drag
       * operation was aborted (e.g. hit escape button). Depending on the executed action
       * we will invoke the callbacks specified with the dnd-moved or dnd-copied attribute.
       */
      ngZone.runOutsideAngular(() => {
        element.on('dragend', function(event) {
          event = event.originalEvent || event;

          if(isTargetPrimeNgElement(event.targetElement)){
              return true;
          }
          // Invoke callbacks. Usually we would use event.dataTransfer.dropEffect to determine
          // the used effect, but Chrome has not implemented that field correctly. On Windows
          // it always sets it to 'none', while Chrome on Linux sometimes sets it to something
          // else when it's supposed to send 'none' (drag operation aborted).
          scope.$applyAsync(function() {
            var dropEffect = dndState.dropEffect;
            var cb = {copy: 'dndCopied', link: 'dndLinked', move: 'dndMoved', none: 'dndCanceled'};
            $parse(attr[cb[dropEffect]])(scope, {event: event});
            $parse(attr.dndDragend)(scope, {event: event, dropEffect: dropEffect});
          });

          // Clean up
          dndState.isDragging = false;
          dndState.callback = undefined;
          element.removeClass("dndDragging");
          element.removeClass("dndDraggingSource");
          event.stopPropagation();

          // In IE9 it is possible that the timeout from dragstart triggers after the dragend handler.
          $timeout(function() { element.removeClass("dndDraggingSource"); }, 0);
        });
      });


      /**
       * When the element is clicked we invoke the callback function
       * specified with the dnd-selected attribute.
       */
      ngZone.runOutsideAngular(() => {
        element.on('click', function(event) {
          if (!attr.dndSelected) return;

          event = event.originalEvent || event;
          scope.$applyAsync(function() {
            $parse(attr.dndSelected)(scope, {event: event});
          });

          // Prevent triggering dndSelected in parent elements.
          event.stopPropagation();
        });
      });



      /**
       * Workaround to make element draggable in IE9
       */
      /*element.on('selectstart', function() {
        if (this.dragDrop) this.dragDrop();
      });*/
    };
  }]);

  /**
   * Use the dnd-list attribute to make your list element a dropzone. Usually you will add a single
   * li element as child with the ng-repeat directive. If you don't do that, we will not be able to
   * position the dropped element correctly. If you want your list to be sortable, also add the
   * dnd-draggable directive to your li element(s).
   *
   * Attributes:
   * - dnd-list             Required attribute. The value has to be the array in which the data of
   *                        the dropped element should be inserted. The value can be blank if used
   *                        with a custom dnd-drop handler that always returns true.
   * - dnd-allowed-types    Optional array of allowed item types. When used, only items that had a
   *                        matching dnd-type attribute will be dropable. Upper case characters will
   *                        automatically be converted to lower case.
   * - dnd-effect-allowed   Optional string expression that limits the drop effects that can be
   *                        performed in the list. See dnd-effect-allowed on dnd-draggable for more
   *                        details on allowed options. The default value is all.
   * - dnd-disable-if       Optional boolean expresssion. When it evaluates to true, no dropping
   *                        into the list is possible. Note that this also disables rearranging
   *                        items inside the list.
   * - dnd-horizontal-list  Optional boolean expresssion. When it evaluates to true, the positioning
   *                        algorithm will use the left and right halfs of the list items instead of
   *                        the upper and lower halfs.
   * - dnd-external-sources Optional boolean expression. When it evaluates to true, the list accepts
   *                        drops from sources outside of the current browser tab. This allows to
   *                        drag and drop accross different browser tabs. The only major browser
   *                        that does not support this is currently Microsoft Edge.
   *
   * Callbacks:
   * - dnd-dragover         Optional expression that is invoked when an element is dragged over the
   *                        list. If the expression is set, but does not return true, the element is
   *                        not allowed to be dropped. The following variables will be available:
   *                        - event: The original dragover event sent by the browser.
   *                        - index: The position in the list at which the element would be dropped.
   *                        - type: The dnd-type set on the dnd-draggable, or undefined if non was
   *                          set. Will be null for drops from external sources in IE and Edge,
   *                          since we don't know the type in those cases.
   *                        - dropEffect: One of move, copy or link, see dnd-effect-allowed.
   *                        - external: Whether the element was dragged from an external source.
   *                        - callback: If dnd-callback was set on the source element, this is a
   *                          function reference to the callback. The callback can be invoked with
   *                          custom variables like this: callback({var1: value1, var2: value2}).
   *                          The callback will be executed on the scope of the source element. If
   *                          dnd-external-sources was set and external is true, this callback will
   *                          not be available.
   * - dnd-drop             Optional expression that is invoked when an element is dropped on the
   *                        list. The same variables as for dnd-dragover will be available, with the
   *                        exception that type is always known and therefore never null. There
   *                        will also be an item variable, which is the transferred object. The
   *                        return value determines the further handling of the drop:
   *                        - falsy: The drop will be canceled and the element won't be inserted.
   *                        - true: Signalises that the drop is allowed, but the dnd-drop
   *                          callback already took care of inserting the element.
   *                        - otherwise: All other return values will be treated as the object to
   *                          insert into the array. In most cases you want to simply return the
   *                          item parameter, but there are no restrictions on what you can return.
   * - dnd-inserted         Optional expression that is invoked after a drop if the element was
   *                        actually inserted into the list. The same local variables as for
   *                        dnd-drop will be available. Note that for reorderings inside the same
   *                        list the old element will still be in the list due to the fact that
   *                        dnd-moved was not called yet.
   *
   * CSS classes:
   * - dndPlaceholder       When an element is dragged over the list, a new placeholder child
   *                        element will be added. This element is of type li and has the class
   *                        dndPlaceholder set. Alternatively, you can define your own placeholder
   *                        by creating a child element with dndPlaceholder class.
   * - dndDragover          Will be added to the list while an element is dragged over the list.
   */
  dndLists.directive('dndList', ['$parse','ngZone', function($parse, ngZone) {
    return function(scope, element, attr) {
      // While an element is dragged over the list, this placeholder element is inserted
      // at the location where the element would be inserted after dropping.
      var placeholder = getPlaceholderElement();
      placeholder.remove();

      var placeholderNode = placeholder[0];
      var listNode = element[0];
      var listSettings = {};

      /**
       * The dragenter event is fired when a dragged element or text selection enters a valid drop
       * target. According to the spec, we either need to have a dropzone attribute or listen on
       * dragenter events and call preventDefault(). It should be noted though that no browser seems
       * to enforce this behaviour.
       */
      ngZone.runOutsideAngular(() => {
        element.on('dragenter', function (event) {
        event = event.originalEvent || event;

        // Calculate list properties, so that we don't have to repeat this on every dragover event.
        var types = attr.dndAllowedTypes && scope.$eval(attr.dndAllowedTypes);
        listSettings = {
          allowedTypes: angular.isArray(types) && types.join('|').toLowerCase().split('|'),
          disabled: attr.dndDisableIf && scope.$eval(attr.dndDisableIf),
          externalSources: attr.dndExternalSources && scope.$eval(attr.dndExternalSources),
          horizontal: attr.dndHorizontalList && scope.$eval(attr.dndHorizontalList)
        };

        var mimeType = getMimeType(event.dataTransfer.types);
        if (!mimeType || !isDropAllowed(getItemType(mimeType))) return true;
        event.preventDefault();
      });
      });
      /**
       * The dragover event is triggered "every few hundred milliseconds" while an element
       * is being dragged over our list, or over an child element.
       */
      ngZone.runOutsideAngular(() => {
        element.on('dragover', function(event) {
        event = event.originalEvent || event;

        // Check whether the drop is allowed and determine mime type.
        var mimeType = getMimeType(event.dataTransfer.types);
        var itemType = getItemType(mimeType);
        if (!mimeType || !isDropAllowed(itemType)) return true;

        // Make sure the placeholder is shown, which is especially important if the list is empty.
        if (placeholderNode.parentNode != listNode) {
          element.append(placeholder);
        }

        if (event.target != listNode) {
          // Try to find the node direct directly below the list node.
          var listItemNode = event.target;
          while (listItemNode.parentNode != listNode && listItemNode.parentNode) {
            listItemNode = listItemNode.parentNode;
          }

          if (listItemNode.parentNode == listNode && listItemNode != placeholderNode) {
            // If the mouse pointer is in the upper half of the list item element,
            // we position the placeholder before the list item, otherwise after it.
            var rect = listItemNode.getBoundingClientRect();
            if (listSettings.horizontal) {
              var isFirstHalf = event.clientX < rect.left + rect.width / 2;
            } else {
              var isFirstHalf = event.clientY < rect.top + rect.height / 2;
            }
            listNode.insertBefore(placeholderNode,
                isFirstHalf ? listItemNode : listItemNode.nextSibling);
          }
        }

        // In IE we set a fake effectAllowed in dragstart to get the correct cursor, we therefore
        // ignore the effectAllowed passed in dataTransfer. We must also not access dataTransfer for
        // drops from external sources, as that throws an exception.
        var ignoreDataTransfer = mimeType == MSIE_MIME_TYPE;
        var dropEffect = getDropEffect(event, ignoreDataTransfer);
        if (dropEffect == 'none') return stopDragover();

        // At this point we invoke the callback, which still can disallow the drop.
        // We can't do this earlier because we want to pass the index of the placeholder.
        if (attr.dndDragover && !invokeCallback(attr.dndDragover, event, dropEffect, itemType)) {
          return stopDragover();
        }

        // Set dropEffect to modify the cursor shown by the browser, unless we're in IE, where this
        // is not supported. This must be done after preventDefault in Firefox.
        event.preventDefault();
        if (!ignoreDataTransfer) {
          event.dataTransfer.dropEffect = dropEffect;
        }

        element.addClass("dndDragover");
        event.stopPropagation();
        return false;
      });
      });

      /**
       * When the element is dropped, we use the position of the placeholder element as the
       * position where we insert the transferred data. This assumes that the list has exactly
       * one child element per array element.
       */
      ngZone.runOutsideAngular(() => {
        element.on('drop', function(event) {
          event = event.originalEvent || event;

          // Check whether the drop is allowed and determine mime type.
          var mimeType = getMimeType(event.dataTransfer.types);
          var itemType = getItemType(mimeType);
          if (!mimeType || !isDropAllowed(itemType)) return true;

          // The default behavior in Firefox is to interpret the dropped element as URL and
          // forward to it. We want to prevent that even if our drop is aborted.
          event.preventDefault();

          // Unserialize the data that was serialized in dragstart.
          try {
            var data = JSON.parse(event.dataTransfer.getData(mimeType));
          } catch(e) {
            return stopDragover();
          }

          // Drops with invalid types from external sources might not have been filtered out yet.
          if (mimeType == MSIE_MIME_TYPE || mimeType == EDGE_MIME_TYPE) {
            itemType = data.type || undefined;
            data = data.item;
            if (!isDropAllowed(itemType)) return stopDragover();
          }

          // Special handling for internal IE drops, see dragover handler.
          var ignoreDataTransfer = mimeType == MSIE_MIME_TYPE;
          var dropEffect = getDropEffect(event, ignoreDataTransfer);
          if (dropEffect == 'none') return stopDragover();

          // Invoke the callback, which can transform the transferredObject and even abort the drop.
          var index = getPlaceholderIndex();
          if (attr.dndDrop) {
            data = invokeCallback(attr.dndDrop, event, dropEffect, itemType, index, data);
            if (!data) return stopDragover();
          }

          // The drop is definitely going to happen now, store the dropEffect.
          dndState.dropEffect = dropEffect;
          if (!ignoreDataTransfer) {
            event.dataTransfer.dropEffect = dropEffect;
          }

          // Insert the object into the array, unless dnd-drop took care of that (returned true).
          if (data !== true) {
            scope.$apply(function() {
              scope.$eval(attr.dndList).splice(index, 0, data);
            });
          }
          invokeCallback(attr.dndInserted, event, dropEffect, itemType, index, data);

          // Clean up
          stopDragover();
          event.stopPropagation();
          return false;
        });
      });

      /**
       * We have to remove the placeholder when the element is no longer dragged over our list. The
       * problem is that the dragleave event is not only fired when the element leaves our list,
       * but also when it leaves a child element. Therefore, we determine whether the mouse cursor
       * is still pointing to an element inside the list or not.
       */
      ngZone.runOutsideAngular(() => {
        element.on('dragleave', function(event) {
        event = event.originalEvent || event;

        var newTarget = document.elementFromPoint(event.clientX, event.clientY);
        if (listNode.contains(newTarget) && !event._dndPhShown) {
          // Signalize to potential parent lists that a placeholder is already shown.
          event._dndPhShown = true;
        } else {
          stopDragover();
        }
      });
      });

      /**
       * Given the types array from the DataTransfer object, returns the first valid mime type.
       * A type is valid if it starts with MIME_TYPE, or it equals MSIE_MIME_TYPE or EDGE_MIME_TYPE.
       */
      function getMimeType(types) {
        if (!types) return MSIE_MIME_TYPE; // IE 9 workaround.
        for (var i = 0; i < types.length; i++) {
          if (types[i] == MSIE_MIME_TYPE || types[i] == EDGE_MIME_TYPE ||
              types[i].substr(0, MIME_TYPE.length) == MIME_TYPE) {
            return types[i];
          }
        }
        return null;
      }

      /**
       * Determines the type of the item from the dndState, or from the mime type for items from
       * external sources. Returns undefined if no item type was set and null if the item type could
       * not be determined.
       */
      function getItemType(mimeType) {
        if (dndState.isDragging) return dndState.itemType || undefined;
        if (mimeType == MSIE_MIME_TYPE || mimeType == EDGE_MIME_TYPE) return null;
        return (mimeType && mimeType.substr(MIME_TYPE.length + 1)) || undefined;
      }

      /**
       * Checks various conditions that must be fulfilled for a drop to be allowed, including the
       * dnd-allowed-types attribute. If the item Type is unknown (null), the drop will be allowed.
       */
      function isDropAllowed(itemType) {
        if (listSettings.disabled) return false;
        if (!listSettings.externalSources && !dndState.isDragging) return false;
        if (!listSettings.allowedTypes || itemType === null) return true;
        return itemType && listSettings.allowedTypes.indexOf(itemType) != -1;
      }

      /**
       * Determines which drop effect to use for the given event. In Internet Explorer we have to
       * ignore the effectAllowed field on dataTransfer, since we set a fake value in dragstart.
       * In those cases we rely on dndState to filter effects. Read the design doc for more details:
       * https://github.com/marceljuenemann/angular-drag-and-drop-lists/wiki/Data-Transfer-Design
       */
      function getDropEffect(event, ignoreDataTransfer) {
        var effects = ALL_EFFECTS;
        if (!ignoreDataTransfer) {
          effects = filterEffects(effects, event.dataTransfer.effectAllowed);
        }
        if (dndState.isDragging) {
          effects = filterEffects(effects, dndState.effectAllowed);
        }
        if (attr.dndEffectAllowed) {
          effects = filterEffects(effects, attr.dndEffectAllowed);
        }
        // MacOS automatically filters dataTransfer.effectAllowed depending on the modifier keys,
        // therefore the following modifier keys will only affect other operating systems.
        if (!effects.length) {
          return 'none';
        } else if (event.ctrlKey && effects.indexOf('copy') != -1) {
          return 'copy';
        } else if (event.altKey && effects.indexOf('link') != -1) {
          return 'link';
        } else {
          return effects[0];
        }
      }

      /**
       * Small helper function that cleans up if we aborted a drop.
       */
      function stopDragover() {
        placeholder.remove();
        element.removeClass("dndDragover");
        return true;
      }

      /**
       * Invokes a callback with some interesting parameters and returns the callbacks return value.
       */
      function invokeCallback(expression, event, dropEffect, itemType, index, item) {
        return $parse(expression)(scope, {
          callback: dndState.callback,
          dropEffect: dropEffect,
          event: event,
          external: !dndState.isDragging,
          index: index !== undefined ? index : getPlaceholderIndex(),
          item: item || undefined,
          type: itemType
        });
      }

      /**
       * We use the position of the placeholder node to determine at which position of the array the
       * object needs to be inserted
       */
      function getPlaceholderIndex() {
        return Array.prototype.indexOf.call(listNode.children, placeholderNode);
      }

      /**
       * Tries to find a child element that has the dndPlaceholder class set. If none was found, a
       * new li element is created.
       */
      function getPlaceholderElement() {
        var placeholder;
        angular.forEach(element.children(), function(childNode) {
          var child = angular.element(childNode);
          if (child.hasClass('dndPlaceholder')) {
            placeholder = child;
          }
        });
        return placeholder || angular.element("<li class='dndPlaceholder'></li>");
      }
    };
  }]);

  /**
   * Use the dnd-nodrag attribute inside of dnd-draggable elements to prevent them from starting
   * drag operations. This is especially useful if you want to use input elements inside of
   * dnd-draggable elements or create specific handle elements. Note: This directive does not work
   * in Internet Explorer 9.
   */
  dndLists.directive('dndNodrag', ['ngZone', function(ngZone) {
    return function(scope, element, attr) {
      // Set as draggable so that we can cancel the events explicitly
      //element.attr("draggable", "true");

      /**
       * Since the element is draggable, the browser's default operation is to drag it on dragstart.
       * We will prevent that and also stop the event from bubbling up.
       */
      ngZone.runOutsideAngular(() => {
        element.on('dragstart', function(event) {
          event = event.originalEvent || event;

          if (!event._dndHandle) {
            // If a child element already reacted to dragstart and set a dataTransfer object, we will
            // allow that. For example, this is the case for user selections inside of input elements.
            if (!(event.dataTransfer.types && event.dataTransfer.types.length)) {
              event.preventDefault();
            }
            event.stopPropagation();
          }
        });
      });


      /**
       * Stop propagation of dragend events, otherwise dnd-moved might be triggered and the element
       * would be removed.
       */
      ngZone.runOutsideAngular(() => {
        element.on('dragend', function(event) {
          event = event.originalEvent || event;
          if (!event._dndHandle) {
            event.stopPropagation();
          }
        });
      });

    };
  }]);

  /**
   * Use the dnd-handle directive within a dnd-nodrag element in order to allow dragging with that
   * element after all. Therefore, by combining dnd-nodrag and dnd-handle you can allow
   * dnd-draggable elements to only be dragged via specific "handle" elements. Note that Internet
   * Explorer will show the handle element as drag image instead of the dnd-draggable element. You
   * can work around this by styling the handle element differently when it is being dragged. Use
   * the CSS selector .dndDragging:not(.dndDraggingSource) [dnd-handle] for that.
   */
  dndLists.directive('dndHandle', ['ngZone', function(ngZone) {
    return function(scope, element, attr) {
        element.attr("draggable", "true");

      ngZone.runOutsideAngular(() => {
        element.on('dragstart dragend', function(event) {
          event = event.originalEvent || event;
          event._dndHandle = true;
        });
      });
    };
  }]);

    dndLists.directive('dndNodragIf', function ($parse, $timeout) {
        return function (scope, element, attr) {
            if ($parse(attr.dndNodragIf)(scope)){
                $timeout(()=>{
                    element.attr("draggable", "false");
                    element.off('dragstart dragend');
                });
            }
        };
    });

  /**
   * Filters an array of drop effects using a HTML5 effectAllowed string.
   */
  function filterEffects(effects, effectAllowed) {
    if (effectAllowed == 'all') return effects;
    return effects.filter(function(effect) {
      return effectAllowed.toLowerCase().indexOf(effect) != -1;
    });
  }

  /**
   * For some features we need to maintain global state. This is done here, with these fields:
   * - callback: A callback function set at dragstart that is passed to internal dropzone handlers.
   * - dropEffect: Set in dragstart to "none" and to the actual value in the drop handler. We don't
   *   rely on the dropEffect passed by the browser, since there are various bugs in Chrome and
   *   Safari, and Internet Explorer defaults to copy if effectAllowed is copyMove.
   * - effectAllowed: Set in dragstart based on dnd-effect-allowed. This is needed for IE because
   *   setting effectAllowed on dataTransfer might result in an undesired cursor.
   * - isDragging: True between dragstart and dragend. Falsy for drops from external sources.
   * - itemType: The item type of the dragged element set via dnd-type. This is needed because IE
   *   and Edge don't support custom mime types that we can use to transfer this information.
   */
  var dndState = {};

    /**
     * This function will check to see if the drag event's target element is part of primeNg, and return true if it is.
     * The intention for this is to bypass all drag functionality in this library file for any primeNg control.
     * @param targetElement HtmlElement (drag event's target html element)     *
     */
  function isTargetPrimeNgElement(targetElement) {
        if (!targetElement instanceof HTMLElement || targetElement === null || targetElement === undefined) {
            return false;
        }

        return targetElement.className?.has('p-element');
  }

})(angular.module('dndLists', []));

/**!
 * AngularJS file upload/drop directive with http post and progress
 * @author  Danial  <danial.farid@gmail.com>
 * @version 1.2.8
 */
(function() {

var angularFileUpload = angular.module('angularFileUpload', []);

angularFileUpload.service('$upload', ['$http', '$rootScope', '$timeout', function($http, $rootScope, $timeout) {
	function sendHttp(config) {
		config.method = config.method || 'POST';
		config.headers = config.headers || {};
		config.transformRequest = config.transformRequest || function(data) {
			if (window.ArrayBuffer && data instanceof ArrayBuffer) {
				return data;
			}
			return $http.defaults.transformRequest[0](data);
		};

		if (window.XMLHttpRequest.__isShim) {
			config.headers['__setXHR_'] = function() {
				return function(xhr) {
					config.__XHR = xhr;
					xhr.upload.addEventListener('progress', function(e) {
						if (config.progress) {
							$timeout(function() {
								if(config.progress) config.progress(e);
							});
						}
					}, false);
					//fix for firefox not firing upload progress end, also IE8-9
					xhr.upload.addEventListener('load', function(e) {
						if (e.lengthComputable) {
							$timeout(function() {
								if(config.progress) config.progress(e);
							});
						}
					}, false);
				}
			};
		}

		var promise = $http(config);

		promise.progress = function(fn) {
			config.progress = fn;
			return promise;
		};
		promise.abort = function() {
			if (config.__XHR) {
				$timeout(function() {
					config.__XHR.abort();
				});
			}
			return promise;
		};
		promise.then = (function(promise, origThen) {
			return function(s, e, p) {
				config.progress = p || config.progress;
				var result = origThen.apply(promise, [s, e, p]);
				result.abort = promise.abort;
				result.progress = promise.progress;
				return result;
			};
		})(promise, promise.then);

		return promise;
	};
	this.upload = function(config) {
		config.headers = config.headers || {};
		config.headers['Content-Type'] = undefined;
		config.transformRequest = config.transformRequest || $http.defaults.transformRequest;
		var formData = new FormData();
		if (config.data) {
			for (var key in config.data) {
				var val = config.data[key];
				if (!config.formDataAppender) {
					if (typeof config.transformRequest == 'function') {
						val = config.transformRequest(val);
					} else {
						for (var i = 0; i < config.transformRequest.length; i++) {
							var fn = config.transformRequest[i];
							if (typeof fn == 'function') {
								val = fn(val);
							}
						}
					}
					formData.append(key, val);
				} else {
					config.formDataAppender(formData, key, val);
				}
			}
		}
		config.transformRequest =  angular.identity;

		var fileFormName = config.fileFormDataName || 'file';

		if (Object.prototype.toString.call(config.file) === '[object Array]') {
			var isFileFormNameString = Object.prototype.toString.call(fileFormName) === '[object String]';
			for (var i = 0; i < config.file.length; i++) {
				formData.append(isFileFormNameString ? fileFormName + i : fileFormName[i], config.file[i], config.file[i].name);
			}
		} else {
			formData.append(fileFormName, config.file, config.file.name);
		}

		config.data = formData;

		return sendHttp(config);
	};
	this.http = function(config) {
		return sendHttp(config);
	}
}]);

angularFileUpload.directive('ngFileSelect', [ '$parse', '$http', '$timeout', function($parse, $http, $timeout) {
	return function(scope, elem, attr) {
		var fn = $parse(attr['ngFileSelect']);
		elem.on('change', function(evt) {
			var files = [], fileList, i;
			fileList = evt.target.files;
			if (fileList != null) {
				for (i = 0; i < fileList.length; i++) {
					files.push(fileList.item(i));
				}
			}
			$timeout(function() {
				fn(scope, {
					$files : files,
					$event : evt
				});
			});
		});
		elem.on('click', function(){
			this.value = null;
		});
	};
} ]);

angularFileUpload.directive('ngFileDropAvailable', [ '$parse', '$http', '$timeout', function($parse, $http, $timeout) {
	return function(scope, elem, attr) {
		if ('draggable' in document.createElement('span')) {
			var fn = $parse(attr['ngFileDropAvailable']);
			$timeout(function() {
				fn(scope);
			});
		}
	};
} ]);

angularFileUpload.directive('ngFileDrop', [ '$parse', '$http', '$timeout', function($parse, $http, $timeout) {
	return function(scope, elem, attr) {
		if ('draggable' in document.createElement('span')) {
			var cancel = null;
			var fn = $parse(attr['ngFileDrop']);
			elem[0].addEventListener("dragover", function(evt) {
				$timeout.cancel(cancel);
				evt.stopPropagation();
				evt.preventDefault();
				elem.addClass(attr['ngFileDragOverClass'] || "dragover");
			}, false);
			elem[0].addEventListener("dragleave", function(evt) {
				cancel = $timeout(function() {
					elem.removeClass(attr['ngFileDragOverClass'] || "dragover");
				});
			}, false);
			elem[0].addEventListener("drop", function(evt) {
				evt.stopPropagation();
				evt.preventDefault();
				elem.removeClass(attr['ngFileDragOverClass'] || "dragover");
				var files = [], fileList = evt.dataTransfer.files, i;
				if (fileList != null) {
					for (i = 0; i < fileList.length; i++) {
						files.push(fileList.item(i));
					}
				}
				$timeout(function() {
					fn(scope, {
						$files : files,
						$event : evt
					});
				});
			}, false);
		}
	};
} ]);

})();

/*global angular:true, browser:true */

/**
 * @license HTTP Auth Interceptor Module for AngularJS
 * (c) 2012 Witold Szczerba
 * License: MIT
 */
(function () {
    'use strict';

    angular.module('http-auth-interceptor', ['http-auth-interceptor-buffer'])

        .factory('authService', ['$rootScope','httpBuffer', function($rootScope, httpBuffer) {
            return {
                /**
                 * Call this function to indicate that authentication was successfull and trigger a
                 * retry of all deferred requests.
                 * @param data an optional argument to pass on to $broadcast which may be useful for
                 * example if you need to pass through details of the user that was logged in
                 * @param configUpdater an optional transformation function that can modify the
                 * requests that are retried after having logged in.  This can be used for example
                 * to add an authentication token.  It must return the request.
                 */
                loginConfirmed: function(data, configUpdater) {
                    var updater = configUpdater || function(config) {return config;};
                    $rootScope.$broadcast('event:auth-loginConfirmed', data);
                    httpBuffer.retryAll(updater);
                },

                /**
                 * Call this function to indicate that authentication should not proceed.
                 * All deferred requests will be abandoned or rejected (if reason is provided).
                 * @param data an optional argument to pass on to $broadcast.
                 * @param reason if provided, the requests are rejected; abandoned otherwise.
                 */
                loginCancelled: function(data, reason) {
                    httpBuffer.rejectAll(reason);
                    $rootScope.$broadcast('event:auth-loginCancelled', data);
                }
            };
        }])

    /**
     * $http interceptor.
     * On 401 response (without 'ignoreAuthModule' option) stores the request
     * and broadcasts 'event:auth-loginRequired'.
     * On 403 response (without 'ignoreAuthModule' option) discards the request
     * and broadcasts 'event:auth-forbidden'.
     */
        .config(['$httpProvider', function($httpProvider) {
            $httpProvider.interceptors.push(['$rootScope', '$q', 'httpBuffer', function($rootScope, $q, httpBuffer) {
                return {
                    responseError: function(rejection) {
                        if (!rejection.config.ignoreAuthModule) {
                            switch (rejection.status) {
                                case 401:
                                    var deferred = $q.defer();
                                    httpBuffer.append(rejection.config, deferred);
                                    $rootScope.$broadcast('event:auth-loginRequired', rejection);
                                    return deferred.promise;
                                case 403:
                                    $rootScope.$broadcast('event:auth-forbidden', rejection);
                                    break;
                            }
                        }
                        // otherwise, default behaviour
                        return $q.reject(rejection);
                    }
                };
            }]);
        }]);

    /**
     * Private module, a utility, required internally by 'http-auth-interceptor'.
     */
    angular.module('http-auth-interceptor-buffer', [])

        .factory('httpBuffer', ['$injector', function($injector) {
            /** Holds all the requests, so they can be re-requested in future. */
            var buffer = [];

            /** Service initialized later because of circular dependency problem. */
            var $http;

            function retryHttpRequest(config, deferred) {
                function successCallback(response) {
                    deferred.resolve(response);
                }
                function errorCallback(response) {
                    deferred.reject(response);
                }
                $http = $http || $injector.get('$http');
                $http(config).then(successCallback, errorCallback);
            }

            return {
                /**
                 * Appends HTTP request configuration object with deferred response attached to buffer.
                 */
                append: function(config, deferred) {
                    buffer.push({
                        config: config,
                        deferred: deferred
                    });
                },

                /**
                 * Abandon or reject (if reason provided) all the buffered requests.
                 */
                rejectAll: function(reason) {
                    if (reason) {
                        for (var i = 0; i < buffer.length; ++i) {
                            buffer[i].deferred.reject(reason);
                        }
                    }
                    buffer = [];
                },

                /**
                 * Retries all the buffered requests clears the buffer.
                 */
                retryAll: function(updater) {
                    for (var i = 0; i < buffer.length; ++i) {
                        retryHttpRequest(updater(buffer[i].config), buffer[i].deferred);
                    }
                    buffer = [];
                }
            };
        }]);
})();
/*! angular-fcsa-number (version 1.5.3) 2014-10-17 */
(function() {
    var fcsaNumberModule,
        __hasProp = {}.hasOwnProperty;

    fcsaNumberModule = angular.module('fcsa-number', []);

    fcsaNumberModule.directive('fcsaNumber', [
        'fcsaNumberConfig', function(fcsaNumberConfig) {
            var addCommasToInteger, controlKeys, defaultOptions, getOptions, hasMultipleDecimals, isNotControlKey, isNotDigit, isNumber, makeIsValid, makeMaxDecimals, makeMaxDigits, makeMaxNumber, makeMinNumber;
            defaultOptions = fcsaNumberConfig.defaultOptions;
            getOptions = function(scope) {
                var option, options, value, _ref;
                options = angular.copy(defaultOptions);
                if (scope.options != null) {
                    _ref = scope.$eval(scope.options);
                    for (option in _ref) {
                        if (!__hasProp.call(_ref, option)) continue;
                        value = _ref[option];
                        options[option] = value;
                    }
                }
                return options;
            };
            isNumber = function(val) {
                return !isNaN(parseFloat(val)) && isFinite(val);
            };
            isNotDigit = function(which) {
                return which < 44 || which > 57 || which === 47;
            };
            controlKeys = [0, 8, 13];
            isNotControlKey = function(which) {
                return controlKeys.indexOf(which) === -1;
            };
            hasMultipleDecimals = function(val) {
                return (val != null) && val.toString().split('.').length > 2;
            };
            makeMaxDecimals = function(maxDecimals) {
                var regexString, validRegex;
                if (maxDecimals > 0) {
                    regexString = "^-?\\d*\\.?\\d{0," + maxDecimals + "}$";
                } else {
                    regexString = "^-?\\d*$";
                }
                validRegex = new RegExp(regexString);
                return function(val) {
                    return validRegex.test(val);
                };
            };
            makeMaxNumber = function(maxNumber) {
                return function(val, number) {
                    return number <= maxNumber;
                };
            };
            makeMinNumber = function(minNumber) {
                return function(val, number) {
                    return number >= minNumber;
                };
            };
            makeMaxDigits = function(maxDigits) {
                var validRegex;
                validRegex = new RegExp("^-?\\d{0," + maxDigits + "}(\\.\\d*)?$");
                return function(val) {
                    return validRegex.test(val);
                };
            };
            makeIsValid = function(options) {
                var validations;
                validations = [];
                if (options.maxDecimals != null) {
                    validations.push(makeMaxDecimals(options.maxDecimals));
                }
                if (options.max != null) {
                    validations.push(makeMaxNumber(options.max));
                }
                if (options.min != null) {
                    validations.push(makeMinNumber(options.min));
                }
                if (options.maxDigits != null) {
                    validations.push(makeMaxDigits(options.maxDigits));
                }
                return function(val) {
                    var i, number, _i, _ref;
                    if (!isNumber(val)) {
                        return false;
                    }
                    if (hasMultipleDecimals(val)) {
                        return false;
                    }
                    number = Number(val);
                    for (i = _i = 0, _ref = validations.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
                        if (!validations[i](val, number)) {
                            return false;
                        }
                    }
                    return true;
                };
            };
            addCommasToInteger = function(val) {
                var commas, decimals, wholeNumbers;
                decimals = val.indexOf('.') == -1 ? '' : val.replace(/^-?\d+(?=\.)/, '');
                wholeNumbers = val.replace(/(\.\d+)$/, '');
                commas = wholeNumbers.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
                return "" + commas + decimals;
            };
            return {
                restrict: 'A',
                require: 'ngModel',
                scope: {
                    options: '@fcsaNumber'
                },
                link: function(scope, elem, attrs, ngModelCtrl) {
                    var isValid, options, previousValue;
                    options = getOptions(scope);
                    isValid = makeIsValid(options);
                    ngModelCtrl.$parsers.unshift(function(viewVal) {
                        var noCommasVal;
                        noCommasVal = viewVal.replace(/,/g, '');
                        if (isValid(noCommasVal) || !noCommasVal) {
                            ngModelCtrl.$setValidity('fcsaNumber', true);
                            return noCommasVal;
                        } else {
                            if (options.preventInvalidInput === true) {
                                ngModelCtrl.$setViewValue(previousValue);
                                ngModelCtrl.$render();
                            } else {
                                ngModelCtrl.$setValidity('fcsaNumber', false);
                            }

                            return void 0;
                        }
                    });
                    ngModelCtrl.$formatters.push(function(val) {
                        if ((options.nullDisplay != null) && (!val || val === '')) {
                            return options.nullDisplay;
                        }
                        if ((val == null) || !isValid(val)) {
                            return val;
                        }
                        ngModelCtrl.$setValidity('fcsaNumber', true);
                        val = addCommasToInteger(val.toString());
                        if (options.prepend != null) {
                            val = "" + options.prepend + val;
                        }
                        if (options.append != null) {
                            val = "" + val + options.append;
                        }
                        return val;
                    });
                    elem.on('blur', function() {
                        var formatter, viewValue, _i, _len, _ref;
                        viewValue = ngModelCtrl.$modelValue;
                        if ((viewValue == null) || !isValid(viewValue)) {
                            return;
                        }
                        _ref = ngModelCtrl.$formatters;
                        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                            formatter = _ref[_i];
                            viewValue = formatter(viewValue);
                        }
                        ngModelCtrl.$viewValue = viewValue;
                        return ngModelCtrl.$render();
                    });
                    elem.on('focus', function() {
                        var val;
                        val = elem.val();
                        if (options.prepend != null) {
                            val = val.replace(options.prepend, '');
                        }
                        if (options.append != null) {
                            val = val.replace(options.append, '');
                        }
                        elem.val(val.replace(/,/g, ''));
                        return elem[0].select();
                    });
                    if (options.preventInvalidInput === true) {
                        return elem.on('keypress', function(e) {
                            // Check for decimal after period
                            if (elem.val().indexOf('.') != -1){
                                var digitAfterDecimal = elem.val().substring(elem.val().indexOf('.') + 1, elem.val().length);
                                if (digitAfterDecimal && digitAfterDecimal.length >= options.maxDecimals)
                                    return e.preventDefault();

                            }

                            previousValue = elem.val();


                            if (isNotDigit(e.which) && isNotControlKey(e.which)) {
                                return e.preventDefault();
                            }
                        });
                    }
                }
            };
        }
    ]);

    fcsaNumberModule.provider('fcsaNumberConfig', function() {
        var _defaultOptions;
        _defaultOptions = {};
        this.setDefaultOptions = function(defaultOptions) {
            return _defaultOptions = defaultOptions;
        };
        this.$get = function() {
            return {
                defaultOptions: _defaultOptions
            };
        };
    });

}).call(this);

/**
 * highcharts-ng
 * @version v0.0.14-dev - 2016-11-18
 * @link https://github.com/pablojim/highcharts-ng
 * @author Barry Fitzgerald <>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 *
 *
 * Using highcharts in styled mode.  Copy of highcharts-ng-20161118.js.  This is gross.
 *
 */

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports){
    module.exports = 'highcharts-styled-ng';
}

(function () {
    'use strict';
    /*global angular: false, Highcharts: false */


    angular.module('highcharts-styled-ng', [])
        .factory('highchartsStyledNG', ['$q', '$window', highchartsStyledNG])
        .directive('highchartStyled', ['highchartsStyledNG', '$timeout', highchartStyled]);

    //IE8 support
    function indexOf(arr, find, i /*opt*/) {
        if (i === undefined) i = 0;
        if (i < 0) i += arr.length;
        if (i < 0) i = 0;
        for (var n = arr.length; i < n; i++)
            if (i in arr && arr[i] === find)
                return i;
        return -1;
    }

    function prependMethod(obj, method, func) {
        var original = obj[method];
        obj[method] = function () {
            var args = Array.prototype.slice.call(arguments);
            func.apply(this, args);
            if (original) {
                return original.apply(this, args);
            } else {
                return;
            }

        };
    }

    function deepExtend(destination, source) {
        //Slightly strange behaviour in edge cases (e.g. passing in non objects)
        //But does the job for current use cases.
        if (angular.isArray(source)) {
            destination = angular.isArray(destination) ? destination : [];
            for (var i = 0; i < source.length; i++) {
                destination[i] = deepExtend(destination[i] || {}, source[i]);
            }
        } else if (angular.isObject(source)) {
            destination = angular.isObject(destination) ? destination : {};
            for (var property in source) {
                destination[property] = deepExtend(destination[property] || {}, source[property]);
            }
        } else {
            destination = source;
        }
        return destination;
    }

    function highchartsStyledNG($q, $window) {
        var highchartsProm = $q.when($window.HighchartsStyled);

        function getHighchartsOnce() {
            return highchartsProm;
        }

        return {
            getHighcharts: getHighchartsOnce,
            ready: function ready(callback, thisArg) {
                getHighchartsOnce().then(function() {
                    callback.call(thisArg);
                });
            }
        };
    }

    function highchartStyled(highchartsNGUtils, $timeout) {

        // acceptable shared state
        var seriesId = 0;
        var ensureIds = function (series) {
            var changed = false;
            angular.forEach(series, function(s) {
                if (!angular.isDefined(s.id)) {
                    s.id = 'series-' + seriesId++;
                    changed = true;
                }
            });
            return changed;
        };

        // immutable
        var axisNames = [ 'xAxis', 'yAxis' ];
        var chartTypeMap = {
            'stock': 'StockChart',
            'map':   'Map',
            'chart': 'Chart'
        };

        var getMergedOptions = function (scope, element, config) {
            var mergedOptions = {};

            var defaultOptions = {
                chart: {
                    events: {}
                },
                title: {},
                subtitle: {},
                series: [],
                credits: {},
                plotOptions: {},
                navigator: {enabled: false},
                xAxis: {
                    events: {}
                },
                yAxis: {
                    events: {}
                }
            };

            if (config.options) {
                mergedOptions = deepExtend(defaultOptions, config.options);
            } else {
                mergedOptions = defaultOptions;
            }
            mergedOptions.chart.renderTo = element[0];

            angular.forEach(axisNames, function(axisName) {
                if(angular.isDefined(config[axisName])) {
                    mergedOptions[axisName] = deepExtend(mergedOptions[axisName] || {}, config[axisName]);

                    if(angular.isDefined(config[axisName].currentMin) ||
                        angular.isDefined(config[axisName].currentMax)) {

                        prependMethod(mergedOptions.chart.events, 'selection', function(e){
                            var thisChart = this;
                            if (e[axisName]) {
                                scope.$apply(function () {
                                    scope.config[axisName].currentMin = e[axisName][0].min;
                                    scope.config[axisName].currentMax = e[axisName][0].max;
                                });
                            } else {
                                //handle reset button - zoom out to all
                                scope.$apply(function () {
                                    scope.config[axisName].currentMin = thisChart[axisName][0].dataMin;
                                    scope.config[axisName].currentMax = thisChart[axisName][0].dataMax;
                                });
                            }
                        });

                        prependMethod(mergedOptions.chart.events, 'addSeries', function(e){
                            scope.config[axisName].currentMin = this[axisName][0].min || scope.config[axisName].currentMin;
                            scope.config[axisName].currentMax = this[axisName][0].max || scope.config[axisName].currentMax;
                        });
                        prependMethod(mergedOptions[axisName].events, 'setExtremes', function (e) {
                            if (e.trigger && e.trigger !== 'zoom') { // zoom trigger is handled by selection event
                                $timeout(function () {
                                    scope.config[axisName].currentMin = e.min;
                                    scope.config[axisName].currentMax = e.max;
                                    scope.config[axisName].min = e.min; // set min and max to adjust scrollbar/navigator
                                    scope.config[axisName].max = e.max;
                                }, 0);
                            }
                        });
                    }
                }
            });
            if(config.chart && config.chart.inverted) {
                mergedOptions.chart.inverted = config.chart.inverted;
            }
            if(config.title) {
                mergedOptions.title = config.title;
            }
            if (config.subtitle) {
                mergedOptions.subtitle = config.subtitle;
            }
            if (config.credits) {
                mergedOptions.credits = config.credits;
            }
            if(config.size) {
                if (config.size.width) {
                    mergedOptions.chart.width = config.size.width;
                }
                if (config.size.height) {
                    mergedOptions.chart.height = config.size.height;
                }
            }
            return mergedOptions;
        };

        var updateZoom = function (axis, modelAxis) {
            var extremes = axis.getExtremes();
            if(modelAxis.currentMin !== extremes.dataMin || modelAxis.currentMax !== extremes.dataMax) {
                if (axis.setExtremes) {
                    axis.setExtremes(modelAxis.currentMin, modelAxis.currentMax, false);
                } else {
                    axis.detachedsetExtremes(modelAxis.currentMin, modelAxis.currentMax, false);
                }
            }
        };

        var processExtremes = function(chart, axis, axisName) {
            if(axis.currentMin || axis.currentMax) {
                chart[axisName][0].setExtremes(axis.currentMin, axis.currentMax, true);
            }
        };

        var chartOptionsWithoutEasyOptions = function (options) {
            return angular.extend(
                deepExtend({}, options),
                { data: null, visible: null }
            );
        };

        var getChartType = function(scope) {
            if (scope.config === undefined) return 'Chart';
            return chartTypeMap[('' + scope.config.chartType).toLowerCase()] ||
                (scope.config.useHighStocks ? 'StockChart' : 'Chart');
        };

        function linkWithHighcharts(HighchartsStyled, scope, element, attrs) {
            // We keep some chart-specific variables here as a closure
            // instead of storing them on 'scope'.

            // prevSeriesOptions is maintained by processSeries
            var prevSeriesOptions = {};
            // chart is maintained by initChart
            var chart = false;

            var processSeries = function(series, seriesOld) {
                var i;
                var ids = [];

                if(series) {
                    var setIds = ensureIds(series);
                    if(setIds && !scope.disableDataWatch) {
                        //If we have set some ids this will trigger another digest cycle.
                        //In this scenario just return early and let the next cycle take care of changes
                        return false;
                    }

                    //Find series to add or update
                    angular.forEach(series, function(s, idx) {
                        ids.push(s.id);
                        var chartSeries = chart.get(s.id);
                        if (chartSeries) {
                            if (!angular.equals(prevSeriesOptions[s.id], chartOptionsWithoutEasyOptions(s))) {
                                chartSeries.update(angular.copy(s), false);
                            } else {
                                if (s.visible !== undefined && chartSeries.visible !== s.visible) {
                                    chartSeries.setVisible(s.visible, false);
                                }

                                // Make sure the current series index can be accessed in seriesOld
                                if (!scope.disableDataWatch && idx < seriesOld.length) {
                                    var sOld = seriesOld[idx];
                                    var sCopy = angular.copy(sOld);

                                    // Get the latest data point from the new series
                                    var ptNew = s.data[s.data.length - 1];

                                    // Check if the new and old series are identical with the latest data point added
                                    // If so, call addPoint without shifting
                                    sCopy.data.push(ptNew);
                                    if (angular.equals(sCopy, s)) {
                                        chartSeries.addPoint(ptNew, false);
                                    }

                                    // Check if the data change was a push and shift operation
                                    // If so, call addPoint WITH shifting
                                    else {
                                        sCopy.data.shift();
                                        if (angular.equals(sCopy, s)) {
                                            chartSeries.addPoint(ptNew, false, true);
                                        }
                                        else {
                                            chartSeries.setData(angular.copy(s.data), false);
                                        }
                                    }
                                }
                                else {
                                    chartSeries.setData(angular.copy(s.data), false);
                                }
                            }
                        } else {
                            chart.addSeries(angular.copy(s), false);
                        }
                        prevSeriesOptions[s.id] = chartOptionsWithoutEasyOptions(s);
                    });

                    //  Shows no data text if all series are empty
                    if(scope.config.noData) {
                        var chartContainsData = false;

                        for(i = 0; i < series.length; i++) {
                            if (series[i].data && series[i].data.length > 0) {
                                chartContainsData = true;

                                break;
                            }
                        }

                        if (!chartContainsData) {
                            chart.showLoading(scope.config.noData);
                        } else {
                            chart.hideLoading();
                        }
                    }
                }

                //Now remove any missing series
                for(i = chart.series.length - 1; i >= 0; i--) {
                    var s = chart.series[i];
                    if (s.options.id !== 'highcharts-navigator-series' && indexOf(ids, s.options.id) < 0) {
                        s.remove(false);
                    }
                }

                return true;
            };

            var initChart = function() {
                if (chart) chart.destroy();
                prevSeriesOptions = {};
                var config = scope.config || {};
                var mergedOptions = getMergedOptions(scope, element, config);
                var func = config.func || undefined;
                var chartType = getChartType(scope);

                chart = new HighchartsStyled[chartType](mergedOptions, func);

                for (var i = 0; i < axisNames.length; i++) {
                    if (config[axisNames[i]]) {
                        processExtremes(chart, config[axisNames[i]], axisNames[i]);
                    }
                }
                if(config.loading) {
                    chart.showLoading();
                }
                config.getHighcharts = function() {
                    return chart;
                };

            };
            initChart();


            if(scope.disableDataWatch){
                scope.$watchCollection('config.series', function (newSeries, oldSeries) {
                    processSeries(newSeries, oldSeries);
                    chart.redraw();
                });
            } else {
                scope.$watch('config.series', function (newSeries, oldSeries) {
                    var needsRedraw = processSeries(newSeries, oldSeries);
                    if(needsRedraw) {
                        chart.redraw();
                    }
                }, true);
            }

            scope.$watch('config.title', function (newTitle) {
                chart.setTitle(newTitle, true);
            }, true);

            scope.$watch('config.subtitle', function (newSubtitle) {
                chart.setTitle(true, newSubtitle);
            }, true);

            scope.$watch('config.loading', function (loading) {
                if(loading) {
                    chart.showLoading(loading === true ? null : loading);
                } else {
                    chart.hideLoading();
                }
            });
            scope.$watch('config.noData', function (noData) {
                if(scope.config && scope.config.loading) {
                    chart.showLoading(noData);
                }
            }, true);

            scope.$watch('config.credits.enabled', function (enabled) {
                if (enabled) {
                    chart.credits.show();
                } else if (chart.credits) {
                    chart.credits.hide();
                }
            });

            scope.$watch(getChartType, function (chartType, oldChartType) {
                if (chartType === oldChartType) return;
                initChart();
            });

            angular.forEach(axisNames, function(axisName) {
                scope.$watch('config.' + axisName, function(newAxes) {
                    if (!newAxes) {
                        return;
                    }

                    if (angular.isArray(newAxes)) {

                        for (var axisIndex = 0; axisIndex < newAxes.length; axisIndex++) {
                            var axis = newAxes[axisIndex];

                            if (axisIndex < chart[axisName].length) {
                                chart[axisName][axisIndex].update(axis, false);
                                updateZoom(chart[axisName][axisIndex], angular.copy(axis));
                            }

                        }

                    } else {
                        // update single axis
                        chart[axisName][0].update(newAxes, false);
                        updateZoom(chart[axisName][0], angular.copy(newAxes));
                    }

                    chart.redraw();
                }, true);
            });
            scope.$watch('config.options', function (newOptions, oldOptions, scope) {
                //do nothing when called on registration
                if (newOptions === oldOptions) return;
                initChart();
                processSeries(scope.config.series);
                chart.redraw();
            }, true);

            scope.$watch('config.size', function (newSize, oldSize) {
                if(newSize === oldSize) return;
                if(newSize) {
                    chart.setSize(newSize.width || chart.chartWidth, newSize.height || chart.chartHeight);
                }
            }, true);

            scope.$on('highchartsstyledng.reflow', function () {
                chart.reflow();
            });

            scope.$on('$destroy', function() {
                if (chart) {
                    try{
                        chart.destroy();
                    }catch(ex){
                        // fail silently as highcharts will throw exception if element doesn't exist
                    }

                    $timeout(function(){
                        element.remove();
                    }, 0);
                }
            });
        }

        function link(scope, element, attrs) {
            function highchartsCb(HighchartsStyled) {
                linkWithHighcharts(HighchartsStyled, scope, element, attrs);
            }
            highchartsNGUtils
                .getHighcharts()
                .then(highchartsCb);
        }
        return {
            restrict: 'EAC',
            replace: true,
            template: '<div></div>',
            scope: {
                config: '=',
                disableDataWatch: '='
            },
            link: link
        };
    }
}());
/**
 * highcharts-ng
 * @version v0.0.14-dev - 2016-11-18
 * @link https://github.com/pablojim/highcharts-ng
 * @author Barry Fitzgerald <>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports){
    module.exports = 'highcharts-ng';
}

(function () {
    'use strict';
    /*global angular: false, Highcharts: false */


    angular.module('highcharts-ng', [])
        .factory('highchartsNG', ['$q', '$window', highchartsNG])
        .directive('highchart', ['highchartsNG', '$timeout', highchart]);

    //IE8 support
    function indexOf(arr, find, i /*opt*/) {
        if (i === undefined) i = 0;
        if (i < 0) i += arr.length;
        if (i < 0) i = 0;
        for (var n = arr.length; i < n; i++)
            if (i in arr && arr[i] === find)
                return i;
        return -1;
    }

    function prependMethod(obj, method, func) {
        var original = obj[method];
        obj[method] = function () {
            var args = Array.prototype.slice.call(arguments);
            func.apply(this, args);
            if (original) {
                return original.apply(this, args);
            } else {
                return;
            }

        };
    }

    function deepExtend(destination, source) {
        //Slightly strange behaviour in edge cases (e.g. passing in non objects)
        //But does the job for current use cases.
        if (angular.isArray(source)) {
            destination = angular.isArray(destination) ? destination : [];
            for (var i = 0; i < source.length; i++) {
                destination[i] = deepExtend(destination[i] || {}, source[i]);
            }
        } else if (angular.isObject(source)) {
            destination = angular.isObject(destination) ? destination : {};
            for (var property in source) {
                destination[property] = deepExtend(destination[property] || {}, source[property]);
            }
        } else {
            destination = source;
        }
        return destination;
    }

    function highchartsNG($q, $window) {
        var highchartsProm = $q.when($window.Highcharts);

        function getHighchartsOnce() {
            return highchartsProm;
        }

        return {
            getHighcharts: getHighchartsOnce,
            ready: function ready(callback, thisArg) {
                getHighchartsOnce().then(function() {
                    callback.call(thisArg);
                });
            }
        };
    }

    function highchart(highchartsNGUtils, $timeout) {

        // acceptable shared state
        var seriesId = 0;
        var ensureIds = function (series) {
            var changed = false;
            angular.forEach(series, function(s) {
                if (!angular.isDefined(s.id)) {
                    s.id = 'series-' + seriesId++;
                    changed = true;
                }
            });
            return changed;
        };

        // immutable
        var axisNames = [ 'xAxis', 'yAxis' ];
        var chartTypeMap = {
            'stock': 'StockChart',
            'map':   'Map',
            'chart': 'Chart'
        };

        var getMergedOptions = function (scope, element, config) {
            var mergedOptions = {};

            var defaultOptions = {
                chart: {
                    events: {}
                },
                title: {},
                subtitle: {},
                series: [],
                credits: {},
                plotOptions: {},
                navigator: {enabled: false},
                xAxis: {
                    events: {}
                },
                yAxis: {
                    events: {}
                }
            };

            if (config.options) {
                mergedOptions = deepExtend(defaultOptions, config.options);
            } else {
                mergedOptions = defaultOptions;
            }
            mergedOptions.chart.renderTo = element[0];

            angular.forEach(axisNames, function(axisName) {
                if(angular.isDefined(config[axisName])) {
                    mergedOptions[axisName] = deepExtend(mergedOptions[axisName] || {}, config[axisName]);

                    if(angular.isDefined(config[axisName].currentMin) ||
                        angular.isDefined(config[axisName].currentMax)) {

                        prependMethod(mergedOptions.chart.events, 'selection', function(e){
                            var thisChart = this;
                            if (e[axisName]) {
                                scope.$apply(function () {
                                    scope.config[axisName].currentMin = e[axisName][0].min;
                                    scope.config[axisName].currentMax = e[axisName][0].max;
                                });
                            } else {
                                //handle reset button - zoom out to all
                                scope.$apply(function () {
                                    scope.config[axisName].currentMin = thisChart[axisName][0].dataMin;
                                    scope.config[axisName].currentMax = thisChart[axisName][0].dataMax;
                                });
                            }
                        });

                        prependMethod(mergedOptions.chart.events, 'addSeries', function(e){
                            scope.config[axisName].currentMin = this[axisName][0].min || scope.config[axisName].currentMin;
                            scope.config[axisName].currentMax = this[axisName][0].max || scope.config[axisName].currentMax;
                        });
                        prependMethod(mergedOptions[axisName].events, 'setExtremes', function (e) {
                            if (e.trigger && e.trigger !== 'zoom') { // zoom trigger is handled by selection event
                                $timeout(function () {
                                    scope.config[axisName].currentMin = e.min;
                                    scope.config[axisName].currentMax = e.max;
                                    scope.config[axisName].min = e.min; // set min and max to adjust scrollbar/navigator
                                    scope.config[axisName].max = e.max;
                                }, 0);
                            }
                        });
                    }
                }
            });
            if(config.chart && config.chart.inverted) {
                mergedOptions.chart.inverted = config.chart.inverted;
            }
            if(config.title) {
                mergedOptions.title = config.title;
            }
            if (config.subtitle) {
                mergedOptions.subtitle = config.subtitle;
            }
            if (config.credits) {
                mergedOptions.credits = config.credits;
            }
            if(config.size) {
                if (config.size.width) {
                    mergedOptions.chart.width = config.size.width;
                }
                if (config.size.height) {
                    mergedOptions.chart.height = config.size.height;
                }
            }
            return mergedOptions;
        };

        var updateZoom = function (axis, modelAxis) {
            var extremes = axis.getExtremes();
            if(modelAxis.currentMin !== extremes.dataMin || modelAxis.currentMax !== extremes.dataMax) {
                if (axis.setExtremes) {
                    axis.setExtremes(modelAxis.currentMin, modelAxis.currentMax, false);
                } else {
                    axis.detachedsetExtremes(modelAxis.currentMin, modelAxis.currentMax, false);
                }
            }
        };

        var processExtremes = function(chart, axis, axisName) {
            if(axis.currentMin || axis.currentMax) {
                chart[axisName][0].setExtremes(axis.currentMin, axis.currentMax, true);
            }
        };

        var chartOptionsWithoutEasyOptions = function (options) {
            return angular.extend(
                deepExtend({}, options),
                { data: null, visible: null }
            );
        };

        var getChartType = function(scope) {
            if (scope.config === undefined) return 'Chart';
            return chartTypeMap[('' + scope.config.chartType).toLowerCase()] ||
                (scope.config.useHighStocks ? 'StockChart' : 'Chart');
        };

        function linkWithHighcharts(Highcharts, scope, element, attrs) {
            // We keep some chart-specific variables here as a closure
            // instead of storing them on 'scope'.

            // prevSeriesOptions is maintained by processSeries
            var prevSeriesOptions = {};
            // chart is maintained by initChart
            var chart = false;

            var processSeries = function(series, seriesOld) {
                var i;
                var ids = [];

                if(series) {
                    var setIds = ensureIds(series);
                    if(setIds && !scope.disableDataWatch) {
                        //If we have set some ids this will trigger another digest cycle.
                        //In this scenario just return early and let the next cycle take care of changes
                        return false;
                    }

                    //Find series to add or update
                    angular.forEach(series, function(s, idx) {
                        ids.push(s.id);
                        var chartSeries = chart.get(s.id);
                        if (chartSeries) {
                            if (!angular.equals(prevSeriesOptions[s.id], chartOptionsWithoutEasyOptions(s))) {
                                chartSeries.update(angular.copy(s), false);
                            } else {
                                if (s.visible !== undefined && chartSeries.visible !== s.visible) {
                                    chartSeries.setVisible(s.visible, false);
                                }

                                // Make sure the current series index can be accessed in seriesOld
                                if (!scope.disableDataWatch && idx < seriesOld.length) {
                                    var sOld = seriesOld[idx];
                                    var sCopy = angular.copy(sOld);

                                    // Get the latest data point from the new series
                                    var ptNew = s.data[s.data.length - 1];

                                    // Check if the new and old series are identical with the latest data point added
                                    // If so, call addPoint without shifting
                                    sCopy.data.push(ptNew);
                                    if (angular.equals(sCopy, s)) {
                                        chartSeries.addPoint(ptNew, false);
                                    }

                                    // Check if the data change was a push and shift operation
                                    // If so, call addPoint WITH shifting
                                    else {
                                        sCopy.data.shift();
                                        if (angular.equals(sCopy, s)) {
                                            chartSeries.addPoint(ptNew, false, true);
                                        }
                                        else {
                                            chartSeries.setData(angular.copy(s.data), false);
                                        }
                                    }
                                }
                                else {
                                    chartSeries.setData(angular.copy(s.data), false);
                                }
                            }
                        } else {
                            chart.addSeries(angular.copy(s), false);
                        }
                        prevSeriesOptions[s.id] = chartOptionsWithoutEasyOptions(s);
                    });

                    //  Shows no data text if all series are empty
                    if(scope.config.noData) {
                        var chartContainsData = false;

                        for(i = 0; i < series.length; i++) {
                            if (series[i].data && series[i].data.length > 0) {
                                chartContainsData = true;

                                break;
                            }
                        }

                        if (!chartContainsData) {
                            chart.showLoading(scope.config.noData);
                        } else {
                            chart.hideLoading();
                        }
                    }
                }

                //Now remove any missing series
                for(i = chart.series.length - 1; i >= 0; i--) {
                    var s = chart.series[i];
                    if (s.options.id !== 'highcharts-navigator-series' && indexOf(ids, s.options.id) < 0) {
                        s.remove(false);
                    }
                }

                return true;
            };

            var initChart = function() {
                if (chart) chart.destroy();
                prevSeriesOptions = {};
                var config = scope.config || {};
                var mergedOptions = getMergedOptions(scope, element, config);
                var func = config.func || undefined;
                var chartType = getChartType(scope);

                chart = new Highcharts[chartType](mergedOptions, func);

                for (var i = 0; i < axisNames.length; i++) {
                    if (config[axisNames[i]]) {
                        processExtremes(chart, config[axisNames[i]], axisNames[i]);
                    }
                }
                if(config.loading) {
                    chart.showLoading();
                }
                config.getHighcharts = function() {
                    return chart;
                };

            };
            initChart();


            if(scope.disableDataWatch){
                scope.$watchCollection('config.series', function (newSeries, oldSeries) {
                    processSeries(newSeries, oldSeries);
                    chart.redraw();
                });
            } else {
                scope.$watch('config.series', function (newSeries, oldSeries) {
                    var needsRedraw = processSeries(newSeries, oldSeries);
                    if(needsRedraw) {
                        chart.redraw();
                    }
                }, true);
            }

            scope.$watch('config.title', function (newTitle) {
                chart.setTitle(newTitle, true);
            }, true);

            scope.$watch('config.subtitle', function (newSubtitle) {
                chart.setTitle(true, newSubtitle);
            }, true);

            scope.$watch('config.loading', function (loading) {
                if(loading) {
                    chart.showLoading(loading === true ? null : loading);
                } else {
                    chart.hideLoading();
                }
            });
            scope.$watch('config.noData', function (noData) {
                if(scope.config && scope.config.loading) {
                    chart.showLoading(noData);
                }
            }, true);

            scope.$watch('config.credits.enabled', function (enabled) {
                if (enabled) {
                    chart.credits.show();
                } else if (chart.credits) {
                    chart.credits.hide();
                }
            });

            scope.$watch(getChartType, function (chartType, oldChartType) {
                if (chartType === oldChartType) return;
                initChart();
            });

            angular.forEach(axisNames, function(axisName) {
                scope.$watch('config.' + axisName, function(newAxes) {
                    if (!newAxes) {
                        return;
                    }

                    if (angular.isArray(newAxes)) {

                        for (var axisIndex = 0; axisIndex < newAxes.length; axisIndex++) {
                            var axis = newAxes[axisIndex];

                            if (axisIndex < chart[axisName].length) {
                                chart[axisName][axisIndex].update(axis, false);
                                updateZoom(chart[axisName][axisIndex], angular.copy(axis));
                            }

                        }

                    } else {
                        // update single axis
                        chart[axisName][0].update(newAxes, false);
                        updateZoom(chart[axisName][0], angular.copy(newAxes));
                    }

                    chart.redraw();
                }, true);
            });
            scope.$watch('config.options', function (newOptions, oldOptions, scope) {
                //do nothing when called on registration
                if (newOptions === oldOptions) return;
                initChart();
                processSeries(scope.config.series);
                chart.redraw();
            }, true);

            scope.$watch('config.size', function (newSize, oldSize) {
                if(newSize === oldSize) return;
                if(newSize) {
                    chart.setSize(newSize.width || chart.chartWidth, newSize.height || chart.chartHeight);
                }
            }, true);

            scope.$on('highchartsng.reflow', function () {
                chart.reflow();
            });

            scope.$on('$destroy', function() {
                if (chart) {
                    try{
                        chart.destroy();
                    }catch(ex){
                        // fail silently as highcharts will throw exception if element doesn't exist
                    }

                    $timeout(function(){
                        element.remove();
                    }, 0);
                }
            });
        }

        function link(scope, element, attrs) {
            function highchartsCb(Highcharts) {
                linkWithHighcharts(Highcharts, scope, element, attrs);
            }
            highchartsNGUtils
                .getHighcharts()
                .then(highchartsCb);
        }

        return {
            restrict: 'EAC',
            replace: true,
            template: '<div></div>',
            scope: {
                config: '=',
                disableDataWatch: '='
            },
            link: link
        };
    }
}());

(function(factory){if(typeof module==='object'&&module.exports){module.exports=factory;}else{factory(Highcharts);}}(function(HC){'use strict';var UNDEFINED,DBLCLICK='dblclick',TOUCHSTART='touchstart',CLICK='click',each=HC.each,pick=HC.pick,wrap=HC.wrap,merge=HC.merge,addEvent=HC.addEvent,isTouchDevice=HC.isTouchDevice,defaultOptions=HC.getOptions().plotOptions,plotLineOrBandProto=HC.PlotLineOrBand&&HC.PlotLineOrBand.prototype,seriesTypes=HC.seriesTypes,seriesProto=HC.Series&&HC.Series.prototype,customEvents,proto,methods;function isArray(obj){return Object.prototype.toString.call(obj)==='[object Array]';}
if(plotLineOrBandProto){wrap(plotLineOrBandProto,'render',function(proceed){var defaultEvents=this.options&&this.options.events;if(defaultEvents){defaultEvents=false;}
proceed.apply(this,Array.prototype.slice.call(arguments,1));});}
if(seriesProto){wrap(seriesProto,'init',function(proceed,chart,options){var chartOptions=chart.options,plotOptions=chartOptions.plotOptions,seriesOptions=chartOptions.plotOptions.series,userOptions=merge(seriesOptions,plotOptions[this.type]);options.events=false;options.point={events:false};options.customEvents={series:userOptions&&userOptions.events,point:userOptions&&userOptions.point&&userOptions.point.events};proceed.apply(this,Array.prototype.slice.call(arguments,1));});}
HC.Chart.prototype.customEvent={getEventsProtoMethods:function(){return[[HC.Tick,['addLabel']],[HC.Axis,['render']],[HC.Chart,['setTitle']],[HC.Legend,['renderItem']],[HC.PlotLineOrBand,['render']],[HC.Series,['drawPoints','drawDataLabels']],[seriesTypes.column,['drawPoints','drawDataLabels']],[seriesTypes.bar,['drawPoints','drawDataLabels']],[seriesTypes.pie,['drawPoints','drawDataLabels']],[seriesTypes.bubble,['drawPoints','drawDataLabels']],[seriesTypes.columnrange,['drawPoints','drawDataLabels']],[seriesTypes.arearange,['drawPoints','drawDataLabels']],[seriesTypes.areasplinerange,['drawPoints','drawDataLabels']],[seriesTypes.errorbar,['drawPoints','drawDataLabels']],[seriesTypes.boxplot,['drawPoints','drawDataLabels']],[seriesTypes.flags,['drawPoints','drawDataLabels']]];},init:function(){var eventsProtoMethods=this.getEventsProtoMethods();each(eventsProtoMethods,function(protoMethod){proto=protoMethod[0]&&protoMethod[0].prototype;methods=protoMethod[1];if(proto){each(methods,function(method){customEvents.attach(proto,method);});}});},attach:function(proto,hcMethod){wrap(proto,hcMethod,function(proceed){var eventElement={events:UNDEFINED,element:UNDEFINED},len,j;proceed.apply(this,Array.prototype.slice.call(arguments,1));eventElement=customEvents.eventElement[hcMethod].call(this);if(!eventElement.events&&!eventElement.eventsPoint){return false;}
if(eventElement.eventsPoint){len=eventElement.elementPoint.length;for(j=0;j<len;j++){var elemPoint=pick(eventElement.elementPoint[j].graphic,eventElement.elementPoint[j]);if(elemPoint&&elemPoint!==UNDEFINED){customEvents.add(elemPoint,eventElement.eventsPoint,eventElement.elementPoint[j],this);}}}
if(eventElement.eventsSubtitle){customEvents.add(eventElement.elementSubtitle,eventElement.eventsSubtitle,this);}
if(eventElement.eventsStackLabel){customEvents.add(eventElement.elementStackLabel,eventElement.eventsStackLabel,this);}
customEvents.add(eventElement.element,eventElement.events,this);});},add:function(SVGelem,events,elemObj,series){if(!SVGelem||!SVGelem.element){return false;}
for(var action in events){(function(event){if(events.hasOwnProperty(event)&&!SVGelem[event]){if(isTouchDevice&&event===DBLCLICK){var tapped=false;addEvent(SVGelem.element,TOUCHSTART,function(e){e.stopPropagation();e.preventDefault();if(!tapped){tapped=setTimeout(function(){tapped=null;events[CLICK].call(elemObj,e);},300);}else{clearTimeout(tapped);tapped=null;events[event].call(elemObj,e);}
return false;});}else{addEvent(SVGelem.element,event,function(e){if(elemObj&&elemObj.textStr){elemObj.value=elemObj.textStr;}
if(series&&defaultOptions[series.type]&&defaultOptions[series.type].marker){var chart=series.chart,normalizedEvent=chart.pointer.normalize(e);elemObj=series.searchPoint(normalizedEvent,true);}
events[event].call(elemObj,e);return false;});}
SVGelem[event]=function(){return true;};}})(action);}},eventElement:{addLabel:function(){var parent=this.parent,axisOptions=this.axis.options,eventsPoint=axisOptions.labels&&axisOptions.labels.events,elementPoint=[this.label],len,i;if(parent){var step=this;while(step){if(isArray(step)){len=step.length;for(i=0;i<len;i++){elementPoint.push(step[i].label);}}else{elementPoint.push(step.label);}
step=step.parent;}}
return{eventsPoint:eventsPoint,elementPoint:elementPoint};},setTitle:function(){var events=this.options.title&&this.options.title.events,element=this.title,eventsSubtitle=this.options.subtitle&&this.options.subtitle.events,elementSubtitle=this.subtitle;return{events:events,element:element,eventsSubtitle:eventsSubtitle,elementSubtitle:elementSubtitle};},drawDataLabels:function(){var dataLabelsGroup=this.dataLabelsGroup;return{events:dataLabelsGroup?this.options.dataLabels.events:UNDEFINED,element:dataLabelsGroup?this.dataLabelsGroup:UNDEFINED};},render:function(){var stackLabels=this.options.stackLabels,events,element,eventsPoint,elementPoint,eventsStackLabel,elementStackLabel;if(this.axisTitle){events=this.options.title.events;element=this.axisTitle;}
if(stackLabels&&stackLabels.enabled){eventsPoint=stackLabels.events;elementPoint=this.stacks;eventsStackLabel=stackLabels.events;elementStackLabel=this.stackTotalGroup;}
return{events:events,element:element,eventsPoint:eventsPoint,elementPoint:elementPoint,eventsStackLabel:eventsStackLabel,elementStackLabel:elementStackLabel};},drawPoints:function(){var op=this.options,type=this.type,events=op.customEvents?op.customEvents.series:op.events,element=this.group,eventsPoint=op.customEvents?op.customEvents.point:op.point.events,elementPoint;if(defaultOptions[type]&&defaultOptions[type].marker){elementPoint=[this.markerGroup];}else{elementPoint=this.points;}
return{events:events,element:element,eventsPoint:eventsPoint,elementPoint:elementPoint};},renderItem:function(){return{events:this.options.itemEvents,element:this.group};}}};customEvents=HC.Chart.prototype.customEvent;customEvents.init();}));
/* added fix to self.addPromise for Angular 1.3.x - JBT */

/*
 * promise-tracker - v1.2.0 - 2013-04-25
 * http://github.com/ajoslin/angular-promise-tracker
 * Created by Andy Joslin; Licensed under Public Domain
 */
angular.module('ajoslin.promise-tracker', [])

    .config(function($httpProvider) {
        if ($httpProvider.interceptors) {
            //Support angularJS 1.1.4: interceptors
            $httpProvider.interceptors.push('trackerHttpInterceptor');
        } else {
            //Support angularJS pre 1.1.4: responseInterceptors
            $httpProvider.responseInterceptors.push('trackerResponseInterceptor');
        }
    })
;


angular.module('ajoslin.promise-tracker')

    /*
     * Intercept all http requests that have a `tracker` option in their config,
     * and add that http promise to the specified `tracker`
     */

//angular versions before 1.1.4 use responseInterceptor format
    .factory('trackerResponseInterceptor', function($q, promiseTracker, $injector) {
        //We use $injector get around circular dependency problem for $http
        var $http;
        return function spinnerResponseInterceptor(promise) {
            if (!$http) $http = $injector.get('$http'); //lazy-load http
            //We know the latest request is always going to be last in the list
            var config = $http.pendingRequests[$http.pendingRequests.length-1];
            if (config.tracker || config.trackerMsg) {
                promiseTracker(config.tracker || 'main').addPromise(promise, config);
            }
            return promise;
        };
    })

    .factory('trackerHttpInterceptor', function($q, promiseTracker, $injector) {
        return {
            request: function(config) {
                if (config.tracker || config.trackerMsg) {
                    var deferred = promiseTracker(config.tracker || 'main').createPromise(config);
                    config.$promiseTrackerDeferred = deferred;
                }
                return $q.when(config);
            },
            response: function(response) {
                if (response.config.$promiseTrackerDeferred) {
                    response.config.$promiseTrackerDeferred.resolve(response);
                }
                return $q.when(response);
            },
            responseError: function(response) {
                if (response.config.$promiseTrackerDeferred) {
                    response.config.$promiseTrackerDeferred.reject(response);
                }
                return $q.reject(response);
            }
        };
    })

;


angular.module('ajoslin.promise-tracker')

    .provider('promiseTracker', function() {

        /**
         * uid(), from angularjs source
         *
         * A consistent way of creating unique IDs in angular. The ID is a sequence of alpha numeric
         * characters such as '012ABC'. The reason why we are not using simply a number counter is that
         * the number string gets longer over time, and it can also overflow, where as the nextId
         * will grow much slower, it is a string, and it will never overflow.
         *
         * @returns string unique alpha-numeric string
         */
        var uid = ['0','0','0'];
        function nextUid() {
            var index = uid.length;
            var digit;

            while(index) {
                index--;
                digit = uid[index].charCodeAt(0);
                if (digit === 57 /*'9'*/) {
                    uid[index] = 'A';
                    return uid.join('');
                }
                if (digit === 90  /*'Z'*/) {
                    uid[index] = '0';
                } else {
                    uid[index] = String.fromCharCode(digit + 1);
                    return uid.join('');
                }
            }
            uid.unshift('0');
            return uid.join('');
        }
        var trackers = {};

        this.$get = function($q, $timeout) {
            var self = this;

            function Tracker(options) {
                options = options || {};
                var self = this,
                //Define our callback types.  The user can catch when a promise starts,
                //has an error, is successful, or just is done with error or success.
                    callbacks = {
                        start: [], //Start is called when a new promise is added
                        done: [], //Called when a promise is resolved (error or success)
                        error: [], //Called on error.
                        success: [] //Called on success.
                    },
                    trackedPromises = [];

                //Allow an optional "minimum duration" that the tracker has to stay
                //active for. For example, if minimum duration is 1000ms and the user
                //adds three promises that all resolve after 650ms, the tracker will
                //still count itself as active until 1000ms have passed.
                self.setMinDuration = function(minimum) {
                    self._minDuration = minimum;
                };
                self.setMinDuration(options.minDuration);

                //Allow an option "maximum duration" that the tracker can stay active.
                //Ideally, the user would resolve his promises after a certain time to
                //achieve this 'maximum duration' option, but there are a few cases
                //where it is necessary anyway.
                self.setMaxDuration = function(maximum) {
                    self._maxDuration = maximum;
                };
                self.setMaxDuration(options.maxDuration);

                //## active()
                //Returns whether the promiseTracker is active - detect if we're
                //currently tracking any promises.
                self.active = function() {
                    return trackedPromises.length > 0;
                };

                //## cancel()
                //Resolves all the current promises, immediately ending the tracker.
                self.cancel = function() {
                    angular.forEach(trackedPromises, function(deferred) {
                        deferred.resolve();
                    });
                };

                //Fire an event bound with #on().
                //@param options: {id: uniqueId, event: string, value: someValue}
                //Calls registered callbacks for `event` with params (`value`, `id`)
                function fireEvent(options) {
                    angular.forEach(callbacks[options.event], function(cb) {
                        cb.call(self, options.value, options.id);
                    });
                }

                //Create a promise that will make our tracker active until it is resolved.
                //@param startArg: params to pass to 'start' event
                //@return deferred - our deferred object that is being tracked
                function createPromise(startArg) {
                    //We create our own promise to track. This usually piggybacks on a given
                    //promise, or we give it back and someone else can resolve it (like
                    //with the httpResponseInterceptor).
                    //Using our own promise also lets us do things like cancel early or add
                    //a minimum duration.
                    var deferred = $q.defer();
                    var promiseId = nextUid();

                    trackedPromises.push(deferred);
                    fireEvent({
                        event: 'start',
                        id: promiseId,
                        value: startArg
                    });

                    //If the tracker was just inactive and this the first in the list of
                    //promises, we reset our 'minimum duration' and 'maximum duration'
                    //again.
                    if (trackedPromises.length === 1) {
                        if (self._minDuration) {
                            self.minPromise = $timeout(angular.noop, self._minDuration);
                        } else {
                            //No minDuration means we just instantly resolve for our 'wait'
                            //promise.
                            self.minPromise = $q.when(true);
                        }
                        if (self._maxDuration) {
                            self.maxPromise = $timeout(deferred.resolve, self._maxDuration);
                        }
                    }

                    //Create a callback for when this promise is done. It will remove our
                    //tracked promise from the array and call the appropriate event
                    //callbacks depending on whether there was an error or not.
                    function onDone(isError) {
                        return function(value) {
                            //Before resolving our promise, make sure the minDuration timeout
                            //has finished.
                            self.minPromise.then(function() {
                                fireEvent({
                                    event: isError ? 'error' : 'success',
                                    id: promiseId,
                                    value: value
                                });
                                fireEvent({
                                    event: 'done',
                                    id: promiseId,
                                    value: value
                                });

                                var index = trackedPromises.indexOf(deferred);
                                trackedPromises.splice(index, 1);

                                //If this is the last promise, cleanup the timeout
                                //for maxDuration so it doesn't stick around.
                                if (trackedPromises.length === 0 && self.maxPromise) {
                                    $timeout.cancel(self.maxPromise);
                                }
                            });
                        };
                    }

                    deferred.promise.then(onDone(false), onDone(true));

                    return deferred;
                }

                //## addPromise()
                //Adds a given promise to our tracking
                self.addPromise = function(promise, startArg) {
                    promise = promise && (promise.$promise || promise) || {};
                    if (!promise.then) {
                        throw new Error("promiseTracker#addPromise expects a promise object!");
                    }

                    var deferred = createPromise(startArg);

                    //When given promise is done, resolve our created promise
                    //Allow $then for angular-resource objects
                    promise.then(function success(value) {
                        deferred.resolve(value);
                        return value;
                    }, function error(value) {
                        deferred.reject(value);
                        return $q.reject(value);
                    });

                    return deferred;
                };

                //## createPromise()
                //Create a new promise and return it, and let the user resolve it how
                //they see fit.
                self.createPromise = function(startArg) {
                    return createPromise(startArg);
                };

                //## on(), bind()
                self.on = self.bind = function(event, cb) {
                    if (!callbacks[event]) {
                        throw "Cannot create callback for event '" + event +
                            "'. Allowed types: 'start', 'done', 'error', 'success'";
                    }
                    callbacks[event].push(cb);
                    return self;
                };
                self.off = self.unbind = function(event, cb) {
                    if (!callbacks[event]) {
                        throw "Cannot create callback for event '" + event +
                            "'. Allowed types: 'start', 'done', 'error', 'success'";
                    }
                    if (cb) {
                        var index = callbacks[event].indexOf(cb);
                        callbacks[event].splice(index, 1);
                    } else {
                        //Erase all events of this type if no cb specified to remvoe
                        callbacks[event].length = 0;
                    }
                    return self;
                };
            }
            return function promiseTracker(trackerName, options) {
                if (!trackers[trackerName])  {
                    trackers[trackerName] = new Tracker(options);
                }
                return trackers[trackerName];
            };
        };
    })
;

// Version 0.3.4
// AngularJS simple file upload directive
// this directive uses an iframe as a target
// to enable the uploading of files without
// losing focus in the ng-app.
//
// <div ng-app="app">
//   <div ng-controller="mainCtrl">
//    <form action="/uploads" ng-upload>
//      <input type="file" name="avatar"></input>
//      <input type="submit" value="Upload"
//         upload-submit="submited(content, completed)"></input>
//    </form>
//  </div>
// </div>
//
//  angular.module('app', ['ngUpload'])
//    .controller('mainCtrl', function($scope) {
//      $scope.submited = function(content, completed) {
//        if (completed) {
//          console.log(content);
//        }
//      }
//  });
//
angular.module('ngUpload', [])
    .directive('uploadSubmit', ['$parse', function($parse) {
        return {
            restrict: 'AC',
            link: function(scope, element, attrs) {
                // Options (just 1 for now)
                // Each option should be prefixed with 'upload-options-' or 'uploadOptions'
                // {
                //    // specify whether to enable the submit button when uploading forms
                //    enableControls: bool
                // }
                var options = {};
                options.enableControls = attrs.uploadOptionsEnableControls;

                // submit the form - requires jQuery
                var form = angular.element(element).parents('form');

                // Retrieve the callback function
                var fn = $parse(attrs.uploadSubmit);

                if (!angular.isFunction(fn)) {
                    var message = "The expression on the ngUpload directive does not point to a valid function.";
                    throw message + "\n";
                }

                element.bind('click', function($event) {
                    // prevent default behavior of click
                    if ($event) {
                        $event.preventDefault = true;
                    }
                    // create a new iframe
                    var iframe = angular.element("<iframe id='upload_iframe' name='upload_iframe' border='0' width='0' height='0' style='width: 0px; height: 0px; border: none; display: none' />");

                    // attach function to load event of the iframe
                    iframe.bind('load', function () {
                        // get content - requires jQuery
                        var content = iframe.contents().find('body').text();
                        // execute the upload response function in the active scope
                        scope.$apply(function () {
                            fn(scope, { content: content, completed: true});
                        });
                        // remove iframe
                        if (content !== "") { // Fixes a bug in Google Chrome that dispose the iframe before content is ready.
                            setTimeout(function () { iframe.remove(); }, 250);
                        }
                        element.attr('disabled', null);
                        element.attr('title', 'Click to start upload.');
                    });

                    // add the new iframe to application
                    form.parent().append(iframe);

                    scope.$apply(function () {
                        fn(scope, {content: "Please wait...", completed: false });
                    });

                    var enabled = true;
                    if (!options.enableControls) {
                        // disable the submit control on click
                        element.attr('disabled', 'disabled');
                        enabled = false;
                    }
                    // why do we need this???
                    element.attr('title', (enabled ? '[ENABLED]: ' : '[DISABLED]: ') + 'Uploading, please wait...');

                    form.submit();

                }).attr('title', 'Click to start upload.');
            }
        };
    }])
    .directive('ngUpload', ['$parse', function ($parse) {
        return {
            restrict: 'AC',
            link: function (scope, element, attrs) {
                element.attr("target", "upload_iframe");
                element.attr("method", "post");
                // Append a timestamp field to the url to prevent browser caching results
                element.attr("action", element.attr("action") + "?_t=" + new Date().getTime());
                element.attr("enctype", "multipart/form-data");
                element.attr("encoding", "multipart/form-data");
            }
        };
    }]);
/**!
 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
 * progress, resize, thumbnail, preview, validation and CORS
 * @author  Danial  <danial.farid@gmail.com>
 * @version 12.2.13
 */

if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
    window.XMLHttpRequest.prototype.setRequestHeader = (function (orig) {
        return function (header, value) {
            if (header === '__setXHR_') {
                var val = value(this);
                // fix for angular < 1.2.0
                if (val instanceof Function) {
                    val(this);
                }
            } else {
                orig.apply(this, arguments);
            }
        };
    })(window.XMLHttpRequest.prototype.setRequestHeader);
}

var ngFileUpload = angular.module('ngFileUpload', []);

ngFileUpload.version = '12.2.13';

ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
    var upload = this;
    upload.promisesCount = 0;

    this.isResumeSupported = function () {
        return window.Blob && window.Blob.prototype.slice;
    };

    var resumeSupported = this.isResumeSupported();

    function sendHttp(config) {
        config.method = config.method || 'POST';
        config.headers = config.headers || {};

        var deferred = config._deferred = config._deferred || $q.defer();
        var promise = deferred.promise;

        function notifyProgress(e) {
            if (deferred.notify) {
                deferred.notify(e);
            }
            if (promise.progressFunc) {
                $timeout(function () {
                    promise.progressFunc(e);
                });
            }
        }

        function getNotifyEvent(n) {
            if (config._start != null && resumeSupported) {
                return {
                    loaded: n.loaded + config._start,
                    total: (config._file && config._file.size) || n.total,
                    type: n.type, config: config,
                    lengthComputable: true, target: n.target
                };
            } else {
                return n;
            }
        }

        if (!config.disableProgress) {
            config.headers.__setXHR_ = function () {
                return function (xhr) {
                    if (!xhr || !xhr.upload || !xhr.upload.addEventListener) return;
                    config.__XHR = xhr;
                    if (config.xhrFn) config.xhrFn(xhr);
                    xhr.upload.addEventListener('progress', function (e) {
                        e.config = config;
                        notifyProgress(getNotifyEvent(e));
                    }, false);
                    //fix for firefox not firing upload progress end, also IE8-9
                    xhr.upload.addEventListener('load', function (e) {
                        if (e.lengthComputable) {
                            e.config = config;
                            notifyProgress(getNotifyEvent(e));
                        }
                    }, false);
                };
            };
        }

        function uploadWithAngular() {
            console.log(config);
            $http(config).then(function (r) {
                    if (resumeSupported && config._chunkSize && !config._finished && config._file) {
                        var fileSize = config._file && config._file.size || 0;
                        notifyProgress({
                                loaded: Math.min(config._end, fileSize),
                                total: fileSize,
                                config: config,
                                type: 'progress'
                            }
                        );
                        upload.upload(config, true);
                    } else {
                        if (config._finished) delete config._finished;
                        deferred.resolve(r);
                    }
                }, function (e) {
                    deferred.reject(e);
                }, function (n) {
                    deferred.notify(n);
                }
            );
        }

        if (!resumeSupported) {
            uploadWithAngular();
        } else if (config._chunkSize && config._end && !config._finished) {
            config._start = config._end;
            config._end += config._chunkSize;
            uploadWithAngular();
        } else if (config.resumeSizeUrl) {
            $http.get(config.resumeSizeUrl).then(function (resp) {
                if (config.resumeSizeResponseReader) {
                    config._start = config.resumeSizeResponseReader(resp.data);
                } else {
                    config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
                }
                if (config._chunkSize) {
                    config._end = config._start + config._chunkSize;
                }
                uploadWithAngular();
            }, function (e) {
                throw e;
            });
        } else if (config.resumeSize) {
            config.resumeSize().then(function (size) {
                config._start = size;
                if (config._chunkSize) {
                    config._end = config._start + config._chunkSize;
                }
                uploadWithAngular();
            }, function (e) {
                throw e;
            });
        } else {
            if (config._chunkSize) {
                config._start = 0;
                config._end = config._start + config._chunkSize;
            }
            uploadWithAngular();
        }


        promise.success = function (fn) {
            promise.then(function (response) {
                fn(response.data, response.status, response.headers, config);
            });
            return promise;
        };

        promise.error = function (fn) {
            promise.then(null, function (response) {
                fn(response.data, response.status, response.headers, config);
            });
            return promise;
        };

        promise.progress = function (fn) {
            promise.progressFunc = fn;
            promise.then(null, null, function (n) {
                fn(n);
            });
            return promise;
        };
        promise.abort = promise.pause = function () {
            if (config.__XHR) {
                $timeout(function () {
                    config.__XHR.abort();
                });
            }
            return promise;
        };
        promise.xhr = function (fn) {
            config.xhrFn = (function (origXhrFn) {
                return function () {
                    if (origXhrFn) origXhrFn.apply(promise, arguments);
                    fn.apply(promise, arguments);
                };
            })(config.xhrFn);
            return promise;
        };

        upload.promisesCount++;
        if (promise['finally'] && promise['finally'] instanceof Function) {
            promise['finally'](function () {
                upload.promisesCount--;
            });
        }
        return promise;
    }

    this.isUploadInProgress = function () {
        return upload.promisesCount > 0;
    };

    this.rename = function (file, name) {
        file.ngfName = name;
        return file;
    };

    this.jsonBlob = function (val) {
        if (val != null && !angular.isString(val)) {
            val = JSON.stringify(val);
        }
        var blob = new window.Blob([val], {type: 'application/json'});
        blob._ngfBlob = true;
        return blob;
    };

    this.json = function (val) {
        return angular.toJson(val);
    };

    function copy(obj) {
        var clone = {};
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                clone[key] = obj[key];
            }
        }
        return clone;
    }

    this.isFile = function (file) {
        return file != null && (file instanceof window.Blob || (file.flashId && file.name && file.size));
    };

    this.upload = function (config, internal) {
        console.log("Upload.upload - ", config, internal);
        function toResumeFile(file, formData) {
            if (file._ngfBlob) return file;
            config._file = config._file || file;
            if (config._start != null && resumeSupported) {
                if (config._end && config._end >= file.size) {
                    config._finished = true;
                    config._end = file.size;
                }
                var slice = file.slice(config._start, config._end || file.size);
                slice.name = file.name;
                slice.ngfName = file.ngfName;
                if (config._chunkSize) {
                    formData.append('_chunkSize', config._chunkSize);
                    formData.append('_currentChunkSize', config._end - config._start);
                    formData.append('_chunkNumber', Math.floor(config._start / config._chunkSize));
                    formData.append('_totalSize', config._file.size);
                }
                return slice;
            }
            return file;
        }

        function addFieldToFormData(formData, val, key) {
            if (val !== undefined) {
                if (angular.isDate(val)) {
                    val = val.toISOString();
                }
                if (angular.isString(val)) {
                    formData.append(key, val);
                } else if (upload.isFile(val)) {
                    var file = toResumeFile(val, formData);
                    var split = key.split(',');
                    if (split[1]) {
                        file.ngfName = split[1].replace(/^\s+|\s+$/g, '');
                        key = split[0];
                    }
                    config._fileKey = config._fileKey || key;
                    formData.append(key, file, file.ngfName || file.name);
                } else {
                    if (angular.isObject(val)) {
                        if (val.$$ngfCircularDetection) throw 'ngFileUpload: Circular reference in config.data. Make sure specified data for Upload.upload() has no circular reference: ' + key;

                        val.$$ngfCircularDetection = true;
                        try {
                            for (var k in val) {
                                if (val.hasOwnProperty(k) && k !== '$$ngfCircularDetection') {
                                    var objectKey = config.objectKey == null ? '[i]' : config.objectKey;
                                    if (val.length && parseInt(k) > -1) {
                                        objectKey = config.arrayKey == null ? objectKey : config.arrayKey;
                                    }
                                    addFieldToFormData(formData, val[k], key + objectKey.replace(/[ik]/g, k));
                                }
                            }
                        } finally {
                            delete val.$$ngfCircularDetection;
                        }
                    } else {
                        formData.append(key, val);
                    }
                }
            }
        }

        function digestConfig() {
            config._chunkSize = upload.translateScalars(config.resumeChunkSize);
            config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;

            config.headers = config.headers || {};
            config.headers['Content-Type'] = undefined;
            config.transformRequest = config.transformRequest ?
                (angular.isArray(config.transformRequest) ?
                    config.transformRequest : [config.transformRequest]) : [];
            config.transformRequest.push(function (data) {
                var formData = new window.FormData(), key;
                data = data || config.fields || {};
                if (config.file) {
                    data.file = config.file;
                }
                for (key in data) {
                    if (data.hasOwnProperty(key)) {
                        var val = data[key];
                        if (config.formDataAppender) {
                            config.formDataAppender(formData, key, val);
                        } else {
                            addFieldToFormData(formData, val, key);
                        }
                    }
                }

                return formData;
            });
        }

        if (!internal) config = copy(config);
        if (!config._isDigested) {
            config._isDigested = true;
            digestConfig();
        }

        return sendHttp(config);
    };

    this.http = function (config) {
        config = copy(config);
        config.transformRequest = config.transformRequest || function (data) {
            if ((window.ArrayBuffer && data instanceof window.ArrayBuffer) || data instanceof window.Blob) {
                return data;
            }
            return $http.defaults.transformRequest[0].apply(this, arguments);
        };
        config._chunkSize = upload.translateScalars(config.resumeChunkSize);
        config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;

        return sendHttp(config);
    };

    this.translateScalars = function (str) {
        if (angular.isString(str)) {
            if (str.search(/kb/i) === str.length - 2) {
                return parseFloat(str.substring(0, str.length - 2) * 1024);
            } else if (str.search(/mb/i) === str.length - 2) {
                return parseFloat(str.substring(0, str.length - 2) * 1048576);
            } else if (str.search(/gb/i) === str.length - 2) {
                return parseFloat(str.substring(0, str.length - 2) * 1073741824);
            } else if (str.search(/b/i) === str.length - 1) {
                return parseFloat(str.substring(0, str.length - 1));
            } else if (str.search(/s/i) === str.length - 1) {
                return parseFloat(str.substring(0, str.length - 1));
            } else if (str.search(/m/i) === str.length - 1) {
                return parseFloat(str.substring(0, str.length - 1) * 60);
            } else if (str.search(/h/i) === str.length - 1) {
                return parseFloat(str.substring(0, str.length - 1) * 3600);
            }
        }
        return str;
    };

    this.urlToBlob = function(url) {
        var defer = $q.defer();
        $http({url: url, method: 'get', responseType: 'arraybuffer'}).then(function (resp) {
            var arrayBufferView = new Uint8Array(resp.data);
            var type = resp.headers('content-type') || 'image/WebP';
            var blob = new window.Blob([arrayBufferView], {type: type});
            var matches = url.match(/.*\/(.+?)(\?.*)?$/);
            if (matches.length > 1) {
                blob.name = matches[1];
            }
            defer.resolve(blob);
        }, function (e) {
            defer.reject(e);
        });
        return defer.promise;
    };

    this.setDefaults = function (defaults) {
        this.defaults = defaults || {};
    };

    this.defaults = {};
    this.version = ngFileUpload.version;
}

]);

ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', '$q', 'UploadExif', function ($parse, $timeout, $compile, $q, UploadExif) {
    var upload = UploadExif;
    upload.getAttrWithDefaults = function (attr, name) {
        if (attr[name] != null) return attr[name];
        var def = upload.defaults[name];
        return (def == null ? def : (angular.isString(def) ? def : JSON.stringify(def)));
    };

    upload.attrGetter = function (name, attr, scope, params) {
        var attrVal = this.getAttrWithDefaults(attr, name);
        if (scope) {
            try {
                if (params) {
                    return $parse(attrVal)(scope, params);
                } else {
                    return $parse(attrVal)(scope);
                }
            } catch (e) {
                // hangle string value without single qoute
                if (name.search(/min|max|pattern/i)) {
                    return attrVal;
                } else {
                    throw e;
                }
            }
        } else {
            return attrVal;
        }
    };

    upload.shouldUpdateOn = function (type, attr, scope) {
        var modelOptions = upload.attrGetter('ngfModelOptions', attr, scope);
        if (modelOptions && modelOptions.updateOn) {
            return modelOptions.updateOn.split(' ').indexOf(type) > -1;
        }
        return true;
    };

    upload.emptyPromise = function () {
        var d = $q.defer();
        var args = arguments;
        $timeout(function () {
            d.resolve.apply(d, args);
        });
        return d.promise;
    };

    upload.rejectPromise = function () {
        var d = $q.defer();
        var args = arguments;
        $timeout(function () {
            d.reject.apply(d, args);
        });
        return d.promise;
    };

    upload.happyPromise = function (promise, data) {
        var d = $q.defer();
        promise.then(function (result) {
            d.resolve(result);
        }, function (error) {
            $timeout(function () {
                throw error;
            });
            d.resolve(data);
        });
        return d.promise;
    };

    function applyExifRotations(files, attr, scope) {
        var promises = [upload.emptyPromise()];
        angular.forEach(files, function (f, i) {
            if (f.type.indexOf('image/jpeg') === 0 && upload.attrGetter('ngfFixOrientation', attr, scope, {$file: f})) {
                promises.push(upload.happyPromise(upload.applyExifRotation(f), f).then(function (fixedFile) {
                    files.splice(i, 1, fixedFile);
                }));
            }
        });
        return $q.all(promises);
    }

    function resizeFile(files, attr, scope, ngModel) {
        var resizeVal = upload.attrGetter('ngfResize', attr, scope);
        if (!resizeVal || !upload.isResizeSupported() || !files.length) return upload.emptyPromise();
        if (resizeVal instanceof Function) {
            var defer = $q.defer();
            return resizeVal(files).then(function (p) {
                resizeWithParams(p, files, attr, scope, ngModel).then(function (r) {
                    defer.resolve(r);
                }, function (e) {
                    defer.reject(e);
                });
            }, function (e) {
                defer.reject(e);
            });
        } else {
            return resizeWithParams(resizeVal, files, attr, scope, ngModel);
        }
    }

    function resizeWithParams(params, files, attr, scope, ngModel) {
        var promises = [upload.emptyPromise()];

        function handleFile(f, i) {
            if (f.type.indexOf('image') === 0) {
                if (params.pattern && !upload.validatePattern(f, params.pattern)) return;
                params.resizeIf = function (width, height) {
                    return upload.attrGetter('ngfResizeIf', attr, scope,
                        {$width: width, $height: height, $file: f});
                };
                var promise = upload.resize(f, params);
                promises.push(promise);
                promise.then(function (resizedFile) {
                    files.splice(i, 1, resizedFile);
                }, function (e) {
                    f.$error = 'resize';
                    (f.$errorMessages = (f.$errorMessages || {})).resize = true;
                    f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
                    ngModel.$ngfValidations.push({name: 'resize', valid: false});
                    upload.applyModelValidation(ngModel, files);
                });
            }
        }

        for (var i = 0; i < files.length; i++) {
            handleFile(files[i], i);
        }
        return $q.all(promises);
    }

    upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
        function update(files, invalidFiles, newFiles, dupFiles, isSingleModel) {
            attr.$$ngfPrevValidFiles = files;
            attr.$$ngfPrevInvalidFiles = invalidFiles;
            var file = files && files.length ? files[0] : null;
            var invalidFile = invalidFiles && invalidFiles.length ? invalidFiles[0] : null;

            if (ngModel) {
                upload.applyModelValidation(ngModel, files);
                ngModel.$setViewValue(isSingleModel ? file : files);
            }

            if (fileChange) {
                $parse(fileChange)(scope, {
                    $files: files,
                    $file: file,
                    $newFiles: newFiles,
                    $duplicateFiles: dupFiles,
                    $invalidFiles: invalidFiles,
                    $invalidFile: invalidFile,
                    $event: evt
                });
            }

            var invalidModel = upload.attrGetter('ngfModelInvalid', attr);
            if (invalidModel) {
                $timeout(function () {
                    $parse(invalidModel).assign(scope, isSingleModel ? invalidFile : invalidFiles);
                });
            }
            $timeout(function () {
                // scope apply changes
            });
        }

        var allNewFiles, dupFiles = [], prevValidFiles, prevInvalidFiles,
            invalids = [], valids = [];

        function removeDuplicates() {
            function equals(f1, f2) {
                return f1.name === f2.name && (f1.$ngfOrigSize || f1.size) === (f2.$ngfOrigSize || f2.size) &&
                    f1.type === f2.type;
            }

            function isInPrevFiles(f) {
                var j;
                for (j = 0; j < prevValidFiles.length; j++) {
                    if (equals(f, prevValidFiles[j])) {
                        return true;
                    }
                }
                for (j = 0; j < prevInvalidFiles.length; j++) {
                    if (equals(f, prevInvalidFiles[j])) {
                        return true;
                    }
                }
                return false;
            }

            if (files) {
                allNewFiles = [];
                dupFiles = [];
                for (var i = 0; i < files.length; i++) {
                    if (isInPrevFiles(files[i])) {
                        dupFiles.push(files[i]);
                    } else {
                        allNewFiles.push(files[i]);
                    }
                }
            }
        }

        function toArray(v) {
            return angular.isArray(v) ? v : [v];
        }

        function resizeAndUpdate() {
            function updateModel() {
                $timeout(function () {
                    update(keep ? prevValidFiles.concat(valids) : valids,
                        keep ? prevInvalidFiles.concat(invalids) : invalids,
                        files, dupFiles, isSingleModel);
                }, options && options.debounce ? options.debounce.change || options.debounce : 0);
            }

            var resizingFiles = validateAfterResize ? allNewFiles : valids;
            resizeFile(resizingFiles, attr, scope, ngModel).then(function () {
                if (validateAfterResize) {
                    upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
                        .then(function (validationResult) {
                            valids = validationResult.validsFiles;
                            invalids = validationResult.invalidsFiles;
                            updateModel();
                        });
                } else {
                    updateModel();
                }
            }, function () {
                for (var i = 0; i < resizingFiles.length; i++) {
                    var f = resizingFiles[i];
                    if (f.$error === 'resize') {
                        var index = valids.indexOf(f);
                        if (index > -1) {
                            valids.splice(index, 1);
                            invalids.push(f);
                        }
                        updateModel();
                    }
                }
            });
        }

        prevValidFiles = attr.$$ngfPrevValidFiles || [];
        prevInvalidFiles = attr.$$ngfPrevInvalidFiles || [];
        if (ngModel && ngModel.$modelValue) {
            prevValidFiles = toArray(ngModel.$modelValue);
        }

        var keep = upload.attrGetter('ngfKeep', attr, scope);
        allNewFiles = (files || []).slice(0);
        if (keep === 'distinct' || upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
            removeDuplicates(attr, scope);
        }

        var isSingleModel = !keep && !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr);

        if (keep && !allNewFiles.length) return;

        upload.attrGetter('ngfBeforeModelChange', attr, scope, {
            $files: files,
            $file: files && files.length ? files[0] : null,
            $newFiles: allNewFiles,
            $duplicateFiles: dupFiles,
            $event: evt
        });

        var validateAfterResize = upload.attrGetter('ngfValidateAfterResize', attr, scope);

        var options = upload.attrGetter('ngfModelOptions', attr, scope);
        upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
            .then(function (validationResult) {
                if (noDelay) {
                    update(allNewFiles, [], files, dupFiles, isSingleModel);
                } else {
                    if ((!options || !options.allowInvalid) && !validateAfterResize) {
                        valids = validationResult.validFiles;
                        invalids = validationResult.invalidFiles;
                    } else {
                        valids = allNewFiles;
                    }
                    if (upload.attrGetter('ngfFixOrientation', attr, scope) && upload.isExifSupported()) {
                        applyExifRotations(valids, attr, scope).then(function () {
                            resizeAndUpdate();
                        });
                    } else {
                        resizeAndUpdate();
                    }
                }
            });
    };

    return upload;
}]);

ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
    var generatedElems = [];

    function isDelayedClickSupported(ua) {
        // fix for android native browser < 4.4 and safari windows
        var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
        if (m && m.length > 2) {
            var v = Upload.defaults.androidFixMinorVersion || 4;
            return parseInt(m[1]) < 4 || (parseInt(m[1]) === v && parseInt(m[2]) < v);
        }

        // safari on windows
        return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
    }

    function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
        /** @namespace attr.ngfSelect */
        /** @namespace attr.ngfChange */
        /** @namespace attr.ngModel */
        /** @namespace attr.ngfModelOptions */
        /** @namespace attr.ngfMultiple */
        /** @namespace attr.ngfCapture */
        /** @namespace attr.ngfValidate */
        /** @namespace attr.ngfKeep */
        var attrGetter = function (name, scope) {
            return upload.attrGetter(name, attr, scope);
        };

        function isInputTypeFile() {
            return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
        }

        function fileChangeAttr() {
            return attrGetter('ngfChange') || attrGetter('ngfSelect');
        }

        function changeFn(evt) {
            if (upload.shouldUpdateOn('change', attr, scope)) {
                var fileList = evt.__files_ || (evt.target && evt.target.files), files = [];
                /* Handle duplicate call in  IE11 */
                if (!fileList) return;
                for (var i = 0; i < fileList.length; i++) {
                    files.push(fileList[i]);
                }
                upload.updateModel(ngModel, attr, scope, fileChangeAttr(),
                    files.length ? files : null, evt);
            }
        }

        upload.registerModelChangeValidator(ngModel, attr, scope);

        var unwatches = [];
        if (attrGetter('ngfMultiple')) {
            unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
                fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
            }));
        }
        if (attrGetter('ngfCapture')) {
            unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
                fileElem.attr('capture', attrGetter('ngfCapture', scope));
            }));
        }
        if (attrGetter('ngfAccept')) {
            unwatches.push(scope.$watch(attrGetter('ngfAccept'), function () {
                fileElem.attr('accept', attrGetter('ngfAccept', scope));
            }));
        }
        unwatches.push(attr.$observe('accept', function () {
            fileElem.attr('accept', attrGetter('accept'));
        }));
        function bindAttrToFileInput(fileElem, label) {
            function updateId(val) {
                fileElem.attr('id', 'ngf-' + val);
                label.attr('id', 'ngf-label-' + val);
            }

            for (var i = 0; i < elem[0].attributes.length; i++) {
                var attribute = elem[0].attributes[i];
                if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'style') {
                    if (attribute.name === 'id') {
                        updateId(attribute.value);
                        unwatches.push(attr.$observe('id', updateId));
                    } else {
                        fileElem.attr(attribute.name, (!attribute.value && (attribute.name === 'required' ||
                            attribute.name === 'multiple')) ? attribute.name : attribute.value);
                    }
                }
            }
        }

        function createFileInput() {
            if (isInputTypeFile()) {
                return elem;
            }

            var fileElem = angular.element('<input type="file">');

            var label = angular.element('<label>upload</label>');
            label.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden')
                .css('width', '0px').css('height', '0px').css('border', 'none')
                .css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
            bindAttrToFileInput(fileElem, label);

            generatedElems.push({el: elem, ref: label});

            document.body.appendChild(label.append(fileElem)[0]);

            return fileElem;
        }

        function clickHandler(evt) {
            if (elem.attr('disabled')) return false;
            if (attrGetter('ngfSelectDisabled', scope)) return;

            var r = detectSwipe(evt);
            // prevent the click if it is a swipe
            if (r != null) return r;

            resetModel(evt);

            // fix for md when the element is removed from the DOM and added back #460
            try {
                if (!isInputTypeFile() && !document.body.contains(fileElem[0])) {
                    generatedElems.push({el: elem, ref: fileElem.parent()});
                    document.body.appendChild(fileElem.parent()[0]);
                    fileElem.bind('change', changeFn);
                }
            } catch (e) {/*ignore*/
            }

            if (isDelayedClickSupported(navigator.userAgent)) {
                setTimeout(function () {
                    fileElem[0].click();
                }, 0);
            } else {
                fileElem[0].click();
            }

            return false;
        }


        var initialTouchStartY = 0;
        var initialTouchStartX = 0;

        function detectSwipe(evt) {
            var touches = evt.changedTouches || (evt.originalEvent && evt.originalEvent.changedTouches);
            if (touches) {
                if (evt.type === 'touchstart') {
                    initialTouchStartX = touches[0].clientX;
                    initialTouchStartY = touches[0].clientY;
                    return true; // don't block event default
                } else {
                    // prevent scroll from triggering event
                    if (evt.type === 'touchend') {
                        var currentX = touches[0].clientX;
                        var currentY = touches[0].clientY;
                        if ((Math.abs(currentX - initialTouchStartX) > 20) ||
                            (Math.abs(currentY - initialTouchStartY) > 20)) {
                            evt.stopPropagation();
                            evt.preventDefault();
                            return false;
                        }
                    }
                    return true;
                }
            }
        }

        var fileElem = elem;

        function resetModel(evt) {
            if (upload.shouldUpdateOn('click', attr, scope) && fileElem.val()) {
                fileElem.val(null);
                upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
            }
        }

        if (!isInputTypeFile()) {
            fileElem = createFileInput();
        }
        fileElem.bind('change', changeFn);

        if (!isInputTypeFile()) {
            elem.bind('click touchstart touchend', clickHandler);
        } else {
            elem.bind('click', resetModel);
        }

        function ie10SameFileSelectFix(evt) {
            if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
                if (!fileElem[0].parentNode) {
                    fileElem = null;
                    return;
                }
                evt.preventDefault();
                evt.stopPropagation();
                fileElem.unbind('click');
                var clone = fileElem.clone();
                fileElem.replaceWith(clone);
                fileElem = clone;
                fileElem.attr('__ngf_ie10_Fix_', 'true');
                fileElem.bind('change', changeFn);
                fileElem.bind('click', ie10SameFileSelectFix);
                fileElem[0].click();
                return false;
            } else {
                fileElem.removeAttr('__ngf_ie10_Fix_');
            }
        }

        if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
            fileElem.bind('click', ie10SameFileSelectFix);
        }

        if (ngModel) ngModel.$formatters.push(function (val) {
            if (val == null || val.length === 0) {
                if (fileElem.val()) {
                    fileElem.val(null);
                }
            }
            return val;
        });

        scope.$on('$destroy', function () {
            if (!isInputTypeFile()) fileElem.parent().remove();
            angular.forEach(unwatches, function (unwatch) {
                unwatch();
            });
        });

        $timeout(function () {
            for (var i = 0; i < generatedElems.length; i++) {
                var g = generatedElems[i];
                if (!document.body.contains(g.el[0])) {
                    generatedElems.splice(i, 1);
                    g.ref.remove();
                }
            }
        });

        if (window.FileAPI && window.FileAPI.ngfFixIE) {
            window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
        }
    }

    return {
        restrict: 'AEC',
        require: '?ngModel',
        link: function (scope, elem, attr, ngModel) {
            linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
        }
    };
}]);

(function () {

    ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
        var upload = UploadBase;
        upload.base64DataUrl = function (file) {
            if (angular.isArray(file)) {
                var d = $q.defer(), count = 0;
                angular.forEach(file, function (f) {
                    upload.dataUrl(f, true)['finally'](function () {
                        count++;
                        if (count === file.length) {
                            var urls = [];
                            angular.forEach(file, function (ff) {
                                urls.push(ff.$ngfDataUrl);
                            });
                            d.resolve(urls, file);
                        }
                    });
                });
                return d.promise;
            } else {
                return upload.dataUrl(file, true);
            }
        };
        upload.dataUrl = function (file, disallowObjectUrl) {
            if (!file) return upload.emptyPromise(file, file);
            if ((disallowObjectUrl && file.$ngfDataUrl != null) || (!disallowObjectUrl && file.$ngfBlobUrl != null)) {
                return upload.emptyPromise(disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl, file);
            }
            var p = disallowObjectUrl ? file.$$ngfDataUrlPromise : file.$$ngfBlobUrlPromise;
            if (p) return p;

            var deferred = $q.defer();
            $timeout(function () {
                if (window.FileReader && file &&
                    (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) &&
                    (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
                    //prefer URL.createObjectURL for handling refrences to files of all sizes
                    //since it doesn´t build a large string in memory
                    var URL = window.URL || window.webkitURL;
                    if (URL && URL.createObjectURL && !disallowObjectUrl) {
                        var url;
                        try {
                            url = URL.createObjectURL(file);
                        } catch (e) {
                            $timeout(function () {
                                file.$ngfBlobUrl = '';
                                deferred.reject();
                            });
                            return;
                        }
                        $timeout(function () {
                            file.$ngfBlobUrl = url;
                            if (url) {
                                deferred.resolve(url, file);
                                upload.blobUrls = upload.blobUrls || [];
                                upload.blobUrlsTotalSize = upload.blobUrlsTotalSize || 0;
                                upload.blobUrls.push({url: url, size: file.size});
                                upload.blobUrlsTotalSize += file.size || 0;
                                var maxMemory = upload.defaults.blobUrlsMaxMemory || 268435456;
                                var maxLength = upload.defaults.blobUrlsMaxQueueSize || 200;
                                while ((upload.blobUrlsTotalSize > maxMemory || upload.blobUrls.length > maxLength) && upload.blobUrls.length > 1) {
                                    var obj = upload.blobUrls.splice(0, 1)[0];
                                    URL.revokeObjectURL(obj.url);
                                    upload.blobUrlsTotalSize -= obj.size;
                                }
                            }
                        });
                    } else {
                        var fileReader = new FileReader();
                        fileReader.onload = function (e) {
                            $timeout(function () {
                                file.$ngfDataUrl = e.target.result;
                                deferred.resolve(e.target.result, file);
                                $timeout(function () {
                                    delete file.$ngfDataUrl;
                                }, 1000);
                            });
                        };
                        fileReader.onerror = function () {
                            $timeout(function () {
                                file.$ngfDataUrl = '';
                                deferred.reject();
                            });
                        };
                        fileReader.readAsDataURL(file);
                    }
                } else {
                    $timeout(function () {
                        file[disallowObjectUrl ? '$ngfDataUrl' : '$ngfBlobUrl'] = '';
                        deferred.reject();
                    });
                }
            });

            if (disallowObjectUrl) {
                p = file.$$ngfDataUrlPromise = deferred.promise;
            } else {
                p = file.$$ngfBlobUrlPromise = deferred.promise;
            }
            p['finally'](function () {
                delete file[disallowObjectUrl ? '$$ngfDataUrlPromise' : '$$ngfBlobUrlPromise'];
            });
            return p;
        };
        return upload;
    }]);

    function getTagType(el) {
        if (el.tagName.toLowerCase() === 'img') return 'image';
        if (el.tagName.toLowerCase() === 'audio') return 'audio';
        if (el.tagName.toLowerCase() === 'video') return 'video';
        return /./;
    }

    function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
        function constructDataUrl(file) {
            var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
            Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
                $timeout(function () {
                    var src = (disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl;
                    if (isBackground) {
                        elem.css('background-image', 'url(\'' + (src || '') + '\')');
                    } else {
                        elem.attr('src', src);
                    }
                    if (src) {
                        elem.removeClass('ng-hide');
                    } else {
                        elem.addClass('ng-hide');
                    }
                });
            });
        }

        $timeout(function () {
            var unwatch = scope.$watch(attr[directiveName], function (file) {
                var size = resizeParams;
                if (directiveName === 'ngfThumbnail') {
                    if (!size) {
                        size = {
                            width: elem[0].naturalWidth || elem[0].clientWidth,
                            height: elem[0].naturalHeight || elem[0].clientHeight
                        };
                    }
                    if (size.width === 0 && window.getComputedStyle) {
                        var style = getComputedStyle(elem[0]);
                        if (style.width && style.width.indexOf('px') > -1 && style.height && style.height.indexOf('px') > -1) {
                            size = {
                                width: parseInt(style.width.slice(0, -2)),
                                height: parseInt(style.height.slice(0, -2))
                            };
                        }
                    }
                }

                if (angular.isString(file)) {
                    elem.removeClass('ng-hide');
                    if (isBackground) {
                        return elem.css('background-image', 'url(\'' + file + '\')');
                    } else {
                        return elem.attr('src', file);
                    }
                }
                if (file && file.type && file.type.search(getTagType(elem[0])) === 0 &&
                    (!isBackground || file.type.indexOf('image') === 0)) {
                    if (size && Upload.isResizeSupported()) {
                        size.resizeIf = function (width, height) {
                            return Upload.attrGetter('ngfResizeIf', attr, scope,
                                {$width: width, $height: height, $file: file});
                        };
                        Upload.resize(file, size).then(
                            function (f) {
                                constructDataUrl(f);
                            }, function (e) {
                                throw e;
                            }
                        );
                    } else {
                        constructDataUrl(file);
                    }
                } else {
                    elem.addClass('ng-hide');
                }
            });

            scope.$on('$destroy', function () {
                unwatch();
            });
        });
    }


    /** @namespace attr.ngfSrc */
    /** @namespace attr.ngfNoObjectUrl */
    ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
        return {
            restrict: 'AE',
            link: function (scope, elem, attr) {
                linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc',
                    Upload.attrGetter('ngfResize', attr, scope), false);
            }
        };
    }]);

    /** @namespace attr.ngfBackground */
    /** @namespace attr.ngfNoObjectUrl */
    ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
        return {
            restrict: 'AE',
            link: function (scope, elem, attr) {
                linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground',
                    Upload.attrGetter('ngfResize', attr, scope), true);
            }
        };
    }]);

    /** @namespace attr.ngfThumbnail */
    /** @namespace attr.ngfAsBackground */
    /** @namespace attr.ngfSize */
    /** @namespace attr.ngfNoObjectUrl */
    ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
        return {
            restrict: 'AE',
            link: function (scope, elem, attr) {
                var size = Upload.attrGetter('ngfSize', attr, scope);
                linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size,
                    Upload.attrGetter('ngfAsBackground', attr, scope));
            }
        };
    }]);

    ngFileUpload.config(['$compileProvider', function ($compileProvider) {
        if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
        if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
    }]);

    ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
        return function (file, disallowObjectUrl, trustedUrl) {
            if (angular.isString(file)) {
                return $sce.trustAsResourceUrl(file);
            }
            var src = file && ((disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl);
            if (file && !src) {
                if (!file.$ngfDataUrlFilterInProgress && angular.isObject(file)) {
                    file.$ngfDataUrlFilterInProgress = true;
                    UploadDataUrl.dataUrl(file, disallowObjectUrl);
                }
                return '';
            }
            if (file) delete file.$ngfDataUrlFilterInProgress;
            return (file && src ? (trustedUrl ? $sce.trustAsResourceUrl(src) : src) : file) || '';
        };
    }]);

})();

ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
    var upload = UploadDataUrl;

    function globStringToRegex(str) {
        var regexp = '', excludes = [];
        if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
            regexp = str.substring(1, str.length - 1);
        } else {
            var split = str.split(',');
            if (split.length > 1) {
                for (var i = 0; i < split.length; i++) {
                    var r = globStringToRegex(split[i]);
                    if (r.regexp) {
                        regexp += '(' + r.regexp + ')';
                        if (i < split.length - 1) {
                            regexp += '|';
                        }
                    } else {
                        excludes = excludes.concat(r.excludes);
                    }
                }
            } else {
                if (str.indexOf('!') === 0) {
                    excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
                } else {
                    if (str.indexOf('.') === 0) {
                        str = '*' + str;
                    }
                    regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
                    regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
                }
            }
        }
        return {regexp: regexp, excludes: excludes};
    }

    upload.validatePattern = function (file, val) {
        if (!val) {
            return true;
        }
        var pattern = globStringToRegex(val), valid = true;
        if (pattern.regexp && pattern.regexp.length) {
            var regexp = new RegExp(pattern.regexp, 'i');
            valid = (file.type != null && regexp.test(file.type)) ||
                (file.name != null && regexp.test(file.name));
        }
        var len = pattern.excludes.length;
        while (len--) {
            var exclude = new RegExp(pattern.excludes[len], 'i');
            valid = valid && (file.type == null || exclude.test(file.type)) &&
                (file.name == null || exclude.test(file.name));
        }
        return valid;
    };

    upload.ratioToFloat = function (val) {
        var r = val.toString(), xIndex = r.search(/[x:]/i);
        if (xIndex > -1) {
            r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
        } else {
            r = parseFloat(r);
        }
        return r;
    };

    upload.registerModelChangeValidator = function (ngModel, attr, scope) {
        if (ngModel) {
            ngModel.$formatters.push(function (files) {
                if (ngModel.$dirty) {
                    var filesArray = files;
                    if (files && !angular.isArray(files)) {
                        filesArray = [files];
                    }
                    upload.validate(filesArray, 0, ngModel, attr, scope).then(function () {
                        upload.applyModelValidation(ngModel, filesArray);
                    });
                }
                return files;
            });
        }
    };

    function markModelAsDirty(ngModel, files) {
        if (files != null && !ngModel.$dirty) {
            if (ngModel.$setDirty) {
                ngModel.$setDirty();
            } else {
                ngModel.$dirty = true;
            }
        }
    }

    upload.applyModelValidation = function (ngModel, files) {
        markModelAsDirty(ngModel, files);
        angular.forEach(ngModel.$ngfValidations, function (validation) {
            ngModel.$setValidity(validation.name, validation.valid);
        });
    };

    upload.getValidationAttr = function (attr, scope, name, validationName, file) {
        var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
        var val = upload.attrGetter(dName, attr, scope, {$file: file});
        if (val == null) {
            val = upload.attrGetter('ngfValidate', attr, scope, {$file: file});
            if (val) {
                var split = (validationName || name).split('.');
                val = val[split[0]];
                if (split.length > 1) {
                    val = val && val[split[1]];
                }
            }
        }
        return val;
    };

    upload.validate = function (files, prevLength, ngModel, attr, scope) {
        ngModel = ngModel || {};
        ngModel.$ngfValidations = ngModel.$ngfValidations || [];

        angular.forEach(ngModel.$ngfValidations, function (v) {
            v.valid = true;
        });

        var attrGetter = function (name, params) {
            return upload.attrGetter(name, attr, scope, params);
        };

        var ignoredErrors = (upload.attrGetter('ngfIgnoreInvalid', attr, scope) || '').split(' ');
        var runAllValidation = upload.attrGetter('ngfRunAllValidations', attr, scope);

        if (files == null || files.length === 0) {
            return upload.emptyPromise({'validFiles': files, 'invalidFiles': []});
        }

        files = files.length === undefined ? [files] : files.slice(0);
        var invalidFiles = [];

        function validateSync(name, validationName, fn) {
            if (files) {
                var i = files.length, valid = null;
                while (i--) {
                    var file = files[i];
                    if (file) {
                        var val = upload.getValidationAttr(attr, scope, name, validationName, file);
                        if (val != null) {
                            if (!fn(file, val, i)) {
                                if (ignoredErrors.indexOf(name) === -1) {
                                    file.$error = name;
                                    (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
                                    file.$errorParam = val;
                                    if (invalidFiles.indexOf(file) === -1) {
                                        invalidFiles.push(file);
                                    }
                                    if (!runAllValidation) {
                                        files.splice(i, 1);
                                    }
                                    valid = false;
                                } else {
                                    files.splice(i, 1);
                                }
                            }
                        }
                    }
                }
                if (valid !== null) {
                    ngModel.$ngfValidations.push({name: name, valid: valid});
                }
            }
        }

        validateSync('pattern', null, upload.validatePattern);
        validateSync('minSize', 'size.min', function (file, val) {
            return file.size + 0.1 >= upload.translateScalars(val);
        });
        validateSync('maxSize', 'size.max', function (file, val) {
            return file.size - 0.1 <= upload.translateScalars(val);
        });
        var totalSize = 0;
        validateSync('maxTotalSize', null, function (file, val) {
            totalSize += file.size;
            if (totalSize > upload.translateScalars(val)) {
                files.splice(0, files.length);
                return false;
            }
            return true;
        });

        validateSync('validateFn', null, function (file, r) {
            return r === true || r === null || r === '';
        });

        if (!files.length) {
            return upload.emptyPromise({'validFiles': [], 'invalidFiles': invalidFiles});
        }

        function validateAsync(name, validationName, type, asyncFn, fn) {
            function resolveResult(defer, file, val) {
                function resolveInternal(fn) {
                    if (fn()) {
                        if (ignoredErrors.indexOf(name) === -1) {
                            file.$error = name;
                            (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
                            file.$errorParam = val;
                            if (invalidFiles.indexOf(file) === -1) {
                                invalidFiles.push(file);
                            }
                            if (!runAllValidation) {
                                var i = files.indexOf(file);
                                if (i > -1) files.splice(i, 1);
                            }
                            defer.resolve(false);
                        } else {
                            var j = files.indexOf(file);
                            if (j > -1) files.splice(j, 1);
                            defer.resolve(true);
                        }
                    } else {
                        defer.resolve(true);
                    }
                }

                if (val != null) {
                    asyncFn(file, val).then(function (d) {
                        resolveInternal(function () {
                            return !fn(d, val);
                        });
                    }, function () {
                        resolveInternal(function () {
                            return attrGetter('ngfValidateForce', {$file: file});
                        });
                    });
                } else {
                    defer.resolve(true);
                }
            }

            var promises = [upload.emptyPromise(true)];
            if (files) {
                files = files.length === undefined ? [files] : files;
                angular.forEach(files, function (file) {
                    var defer = $q.defer();
                    promises.push(defer.promise);
                    if (type && (file.type == null || file.type.search(type) !== 0)) {
                        defer.resolve(true);
                        return;
                    }
                    if (name === 'dimensions' && upload.attrGetter('ngfDimensions', attr) != null) {
                        upload.imageDimensions(file).then(function (d) {
                            resolveResult(defer, file,
                                attrGetter('ngfDimensions', {$file: file, $width: d.width, $height: d.height}));
                        }, function () {
                            defer.resolve(false);
                        });
                    } else if (name === 'duration' && upload.attrGetter('ngfDuration', attr) != null) {
                        upload.mediaDuration(file).then(function (d) {
                            resolveResult(defer, file,
                                attrGetter('ngfDuration', {$file: file, $duration: d}));
                        }, function () {
                            defer.resolve(false);
                        });
                    } else {
                        resolveResult(defer, file,
                            upload.getValidationAttr(attr, scope, name, validationName, file));
                    }
                });
            }
            var deffer = $q.defer();
            $q.all(promises).then(function (values) {
                var isValid = true;
                for (var i = 0; i < values.length; i++) {
                    if (!values[i]) {
                        isValid = false;
                        break;
                    }
                }
                ngModel.$ngfValidations.push({name: name, valid: isValid});
                deffer.resolve(isValid);
            });
            return deffer.promise;
        }

        var deffer = $q.defer();
        var promises = [];

        promises.push(validateAsync('maxHeight', 'height.max', /image/,
            this.imageDimensions, function (d, val) {
                return d.height <= val;
            }));
        promises.push(validateAsync('minHeight', 'height.min', /image/,
            this.imageDimensions, function (d, val) {
                return d.height >= val;
            }));
        promises.push(validateAsync('maxWidth', 'width.max', /image/,
            this.imageDimensions, function (d, val) {
                return d.width <= val;
            }));
        promises.push(validateAsync('minWidth', 'width.min', /image/,
            this.imageDimensions, function (d, val) {
                return d.width >= val;
            }));
        promises.push(validateAsync('dimensions', null, /image/,
            function (file, val) {
                return upload.emptyPromise(val);
            }, function (r) {
                return r;
            }));
        promises.push(validateAsync('ratio', null, /image/,
            this.imageDimensions, function (d, val) {
                var split = val.toString().split(','), valid = false;
                for (var i = 0; i < split.length; i++) {
                    if (Math.abs((d.width / d.height) - upload.ratioToFloat(split[i])) < 0.01) {
                        valid = true;
                    }
                }
                return valid;
            }));
        promises.push(validateAsync('maxRatio', 'ratio.max', /image/,
            this.imageDimensions, function (d, val) {
                return (d.width / d.height) - upload.ratioToFloat(val) < 0.0001;
            }));
        promises.push(validateAsync('minRatio', 'ratio.min', /image/,
            this.imageDimensions, function (d, val) {
                return (d.width / d.height) - upload.ratioToFloat(val) > -0.0001;
            }));
        promises.push(validateAsync('maxDuration', 'duration.max', /audio|video/,
            this.mediaDuration, function (d, val) {
                return d <= upload.translateScalars(val);
            }));
        promises.push(validateAsync('minDuration', 'duration.min', /audio|video/,
            this.mediaDuration, function (d, val) {
                return d >= upload.translateScalars(val);
            }));
        promises.push(validateAsync('duration', null, /audio|video/,
            function (file, val) {
                return upload.emptyPromise(val);
            }, function (r) {
                return r;
            }));

        promises.push(validateAsync('validateAsyncFn', null, null,
            function (file, val) {
                return val;
            }, function (r) {
                return r === true || r === null || r === '';
            }));

        $q.all(promises).then(function () {

            if (runAllValidation) {
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    if (file.$error) {
                        files.splice(i--, 1);
                    }
                }
            }

            runAllValidation = false;
            validateSync('maxFiles', null, function (file, val, i) {
                return prevLength + i < val;
            });

            deffer.resolve({'validFiles': files, 'invalidFiles': invalidFiles});
        });
        return deffer.promise;
    };

    upload.imageDimensions = function (file) {
        if (file.$ngfWidth && file.$ngfHeight) {
            var d = $q.defer();
            $timeout(function () {
                d.resolve({width: file.$ngfWidth, height: file.$ngfHeight});
            });
            return d.promise;
        }
        if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;

        var deferred = $q.defer();
        $timeout(function () {
            if (file.type.indexOf('image') !== 0) {
                deferred.reject('not image');
                return;
            }
            upload.dataUrl(file).then(function (dataUrl) {
                var img = angular.element('<img>').attr('src', dataUrl)
                    .css('visibility', 'hidden').css('position', 'fixed')
                    .css('max-width', 'none !important').css('max-height', 'none !important');

                function success() {
                    var width = img[0].naturalWidth || img[0].clientWidth;
                    var height = img[0].naturalHeight || img[0].clientHeight;
                    img.remove();
                    file.$ngfWidth = width;
                    file.$ngfHeight = height;
                    deferred.resolve({width: width, height: height});
                }

                function error() {
                    img.remove();
                    deferred.reject('load error');
                }

                img.on('load', success);
                img.on('error', error);

                var secondsCounter = 0;
                function checkLoadErrorInCaseOfNoCallback() {
                    $timeout(function () {
                        if (img[0].parentNode) {
                            if (img[0].clientWidth) {
                                success();
                            } else if (secondsCounter++ > 10) {
                                error();
                            } else {
                                checkLoadErrorInCaseOfNoCallback();
                            }
                        }
                    }, 1000);
                }

                checkLoadErrorInCaseOfNoCallback();

                angular.element(document.getElementsByTagName('body')[0]).append(img);
            }, function () {
                deferred.reject('load error');
            });
        });

        file.$ngfDimensionPromise = deferred.promise;
        file.$ngfDimensionPromise['finally'](function () {
            delete file.$ngfDimensionPromise;
        });
        return file.$ngfDimensionPromise;
    };

    upload.mediaDuration = function (file) {
        if (file.$ngfDuration) {
            var d = $q.defer();
            $timeout(function () {
                d.resolve(file.$ngfDuration);
            });
            return d.promise;
        }
        if (file.$ngfDurationPromise) return file.$ngfDurationPromise;

        var deferred = $q.defer();
        $timeout(function () {
            if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
                deferred.reject('not media');
                return;
            }
            upload.dataUrl(file).then(function (dataUrl) {
                var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>')
                    .attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');

                function success() {
                    var duration = el[0].duration;
                    file.$ngfDuration = duration;
                    el.remove();
                    deferred.resolve(duration);
                }

                function error() {
                    el.remove();
                    deferred.reject('load error');
                }

                el.on('loadedmetadata', success);
                el.on('error', error);
                var count = 0;

                function checkLoadError() {
                    $timeout(function () {
                        if (el[0].parentNode) {
                            if (el[0].duration) {
                                success();
                            } else if (count > 10) {
                                error();
                            } else {
                                checkLoadError();
                            }
                        }
                    }, 1000);
                }

                checkLoadError();

                angular.element(document.body).append(el);
            }, function () {
                deferred.reject('load error');
            });
        });

        file.$ngfDurationPromise = deferred.promise;
        file.$ngfDurationPromise['finally'](function () {
            delete file.$ngfDurationPromise;
        });
        return file.$ngfDurationPromise;
    };
    return upload;
}
]);

ngFileUpload.service('UploadResize', ['UploadValidate', '$q', function (UploadValidate, $q) {
    var upload = UploadValidate;

    /**
     * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
     * images to fit into a certain area.
     * Source:  http://stackoverflow.com/a/14731922
     *
     * @param {Number} srcWidth Source area width
     * @param {Number} srcHeight Source area height
     * @param {Number} maxWidth Nestable area maximum available width
     * @param {Number} maxHeight Nestable area maximum available height
     * @return {Object} { width, height }
     */
    var calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight, centerCrop) {
        var ratio = centerCrop ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight) :
            Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
        return {
            width: srcWidth * ratio, height: srcHeight * ratio,
            marginX: srcWidth * ratio - maxWidth, marginY: srcHeight * ratio - maxHeight
        };
    };

    // Extracted from https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
    var resize = function (imagen, width, height, quality, type, ratio, centerCrop, resizeIf) {
        var deferred = $q.defer();
        var canvasElement = document.createElement('canvas');
        var imageElement = document.createElement('img');
        imageElement.setAttribute('style', 'visibility:hidden;position:fixed;z-index:-100000');
        document.body.appendChild(imageElement);

        imageElement.onload = function () {
            var imgWidth = imageElement.width, imgHeight = imageElement.height;
            imageElement.parentNode.removeChild(imageElement);
            if (resizeIf != null && resizeIf(imgWidth, imgHeight) === false) {
                deferred.reject('resizeIf');
                return;
            }
            try {
                if (ratio) {
                    var ratioFloat = upload.ratioToFloat(ratio);
                    var imgRatio = imgWidth / imgHeight;
                    if (imgRatio < ratioFloat) {
                        width = imgWidth;
                        height = width / ratioFloat;
                    } else {
                        height = imgHeight;
                        width = height * ratioFloat;
                    }
                }
                if (!width) {
                    width = imgWidth;
                }
                if (!height) {
                    height = imgHeight;
                }
                var dimensions = calculateAspectRatioFit(imgWidth, imgHeight, width, height, centerCrop);
                canvasElement.width = Math.min(dimensions.width, width);
                canvasElement.height = Math.min(dimensions.height, height);
                var context = canvasElement.getContext('2d');
                context.drawImage(imageElement,
                    Math.min(0, -dimensions.marginX / 2), Math.min(0, -dimensions.marginY / 2),
                    dimensions.width, dimensions.height);
                deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 0.934));
            } catch (e) {
                deferred.reject(e);
            }
        };
        imageElement.onerror = function () {
            imageElement.parentNode.removeChild(imageElement);
            deferred.reject();
        };
        imageElement.src = imagen;
        return deferred.promise;
    };

    upload.dataUrltoBlob = function (dataurl, name, origSize) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        var blob = new window.Blob([u8arr], {type: mime});
        blob.name = name;
        blob.$ngfOrigSize = origSize;
        return blob;
    };

    upload.isResizeSupported = function () {
        var elem = document.createElement('canvas');
        return window.atob && elem.getContext && elem.getContext('2d') && window.Blob;
    };

    if (upload.isResizeSupported()) {
        // add name getter to the blob constructor prototype
        Object.defineProperty(window.Blob.prototype, 'name', {
            get: function () {
                return this.$ngfName;
            },
            set: function (v) {
                this.$ngfName = v;
            },
            configurable: true
        });
    }

    upload.resize = function (file, options) {
        if (file.type.indexOf('image') !== 0) return upload.emptyPromise(file);

        var deferred = $q.defer();
        upload.dataUrl(file, true).then(function (url) {
            resize(url, options.width, options.height, options.quality, options.type || file.type,
                options.ratio, options.centerCrop, options.resizeIf)
                .then(function (dataUrl) {
                    if (file.type === 'image/jpeg' && options.restoreExif !== false) {
                        try {
                            dataUrl = upload.restoreExif(url, dataUrl);
                        } catch (e) {
                            setTimeout(function () {throw e;}, 1);
                        }
                    }
                    try {
                        var blob = upload.dataUrltoBlob(dataUrl, file.name, file.size);
                        deferred.resolve(blob);
                    } catch (e) {
                        deferred.reject(e);
                    }
                }, function (r) {
                    if (r === 'resizeIf') {
                        deferred.resolve(file);
                    }
                    deferred.reject(r);
                });
        }, function (e) {
            deferred.reject(e);
        });
        return deferred.promise;
    };

    return upload;
}]);

(function () {
    ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$window', 'Upload', '$http', '$q',
        function ($parse, $timeout, $window, Upload, $http, $q) {
            return {
                restrict: 'AEC',
                require: '?ngModel',
                link: function (scope, elem, attr, ngModel) {
                    linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, Upload, $http, $q);
                }
            };
        }]);

    ngFileUpload.directive('ngfNoFileDrop', function () {
        return function (scope, elem) {
            if (dropAvailable()) elem.css('display', 'none');
        };
    });

    ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
        return function (scope, elem, attr) {
            if (dropAvailable()) {
                var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
                $timeout(function () {
                    model(scope);
                    if (model.assign) {
                        model.assign(scope, true);
                    }
                });
            }
        };
    }]);

    function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, upload, $http, $q) {
        var available = dropAvailable();

        var attrGetter = function (name, scope, params) {
            return upload.attrGetter(name, attr, scope, params);
        };

        if (attrGetter('dropAvailable')) {
            $timeout(function () {
                if (scope[attrGetter('dropAvailable')]) {
                    scope[attrGetter('dropAvailable')].value = available;
                } else {
                    scope[attrGetter('dropAvailable')] = available;
                }
            });
        }
        if (!available) {
            if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
                elem.css('display', 'none');
            }
            return;
        }

        function isDisabled() {
            return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
        }

        if (attrGetter('ngfSelect') == null) {
            upload.registerModelChangeValidator(ngModel, attr, scope);
        }

        var leaveTimeout = null;
        var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
        var dragOverDelay = 1;
        var actualDragOverClass;

        elem[0].addEventListener('dragover', function (evt) {
            if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
            evt.preventDefault();
            if (stopPropagation(scope)) evt.stopPropagation();
            // handling dragover events from the Chrome download bar
            if (navigator.userAgent.indexOf('Chrome') > -1) {
                var b = evt.dataTransfer.effectAllowed;
                evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
            }
            $timeout.cancel(leaveTimeout);
            if (!actualDragOverClass) {
                actualDragOverClass = 'C';
                calculateDragOverClass(scope, attr, evt, function (clazz) {
                    actualDragOverClass = clazz;
                    elem.addClass(actualDragOverClass);
                    attrGetter('ngfDrag', scope, {$isDragging: true, $class: actualDragOverClass, $event: evt});
                });
            }
        }, false);
        elem[0].addEventListener('dragenter', function (evt) {
            if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
            evt.preventDefault();
            if (stopPropagation(scope)) evt.stopPropagation();
        }, false);
        elem[0].addEventListener('dragleave', function (evt) {
            if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
            evt.preventDefault();
            if (stopPropagation(scope)) evt.stopPropagation();
            leaveTimeout = $timeout(function () {
                if (actualDragOverClass) elem.removeClass(actualDragOverClass);
                actualDragOverClass = null;
                attrGetter('ngfDrag', scope, {$isDragging: false, $event: evt});
            }, dragOverDelay || 100);
        }, false);
        elem[0].addEventListener('drop', function (evt) {
            if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
            evt.preventDefault();
            if (stopPropagation(scope)) evt.stopPropagation();
            if (actualDragOverClass) elem.removeClass(actualDragOverClass);
            actualDragOverClass = null;
            extractFilesAndUpdateModel(evt.dataTransfer, evt, 'dropUrl');
        }, false);
        elem[0].addEventListener('paste', function (evt) {
            if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
                attrGetter('ngfEnableFirefoxPaste', scope)) {
                evt.preventDefault();
            }
            if (isDisabled() || !upload.shouldUpdateOn('paste', attr, scope)) return;
            extractFilesAndUpdateModel(evt.clipboardData || evt.originalEvent.clipboardData, evt, 'pasteUrl');
        }, false);

        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
            attrGetter('ngfEnableFirefoxPaste', scope)) {
            elem.attr('contenteditable', true);
            elem.on('keypress', function (e) {
                if (!e.metaKey && !e.ctrlKey) {
                    e.preventDefault();
                }
            });
        }

        function extractFilesAndUpdateModel(source, evt, updateOnType) {
            if (!source) return;
            // html needs to be calculated on the same process otherwise the data will be wiped
            // after promise resolve or setTimeout.
            var html;
            try {
                html = source && source.getData && source.getData('text/html');
            } catch (e) {/* Fix IE11 that throw error calling getData */
            }
            extractFiles(source.items, source.files, attrGetter('ngfAllowDir', scope) !== false,
                attrGetter('multiple') || attrGetter('ngfMultiple', scope)).then(function (files) {
                if (files.length) {
                    updateModel(files, evt);
                } else {
                    extractFilesFromHtml(updateOnType, html).then(function (files) {
                        updateModel(files, evt);
                    });
                }
            });
        }

        function updateModel(files, evt) {
            upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
        }

        function extractFilesFromHtml(updateOn, html) {
            if (!upload.shouldUpdateOn(updateOn, attr, scope) || typeof html !== 'string') return upload.rejectPromise([]);
            var urls = [];
            html.replace(/<(img src|img [^>]* src) *=\"([^\"]*)\"/gi, function (m, n, src) {
                urls.push(src);
            });
            var promises = [], files = [];
            if (urls.length) {
                angular.forEach(urls, function (url) {
                    promises.push(upload.urlToBlob(url).then(function (blob) {
                        files.push(blob);
                    }));
                });
                var defer = $q.defer();
                $q.all(promises).then(function () {
                    defer.resolve(files);
                }, function (e) {
                    defer.reject(e);
                });
                return defer.promise;
            }
            return upload.emptyPromise();
        }

        function calculateDragOverClass(scope, attr, evt, callback) {
            var obj = attrGetter('ngfDragOverClass', scope, {$event: evt}), dClass = 'dragover';
            if (angular.isString(obj)) {
                dClass = obj;
            } else if (obj) {
                if (obj.delay) dragOverDelay = obj.delay;
                if (obj.accept || obj.reject) {
                    var items = evt.dataTransfer.items;
                    if (items == null || !items.length) {
                        dClass = obj.accept;
                    } else {
                        var pattern = obj.pattern || attrGetter('ngfPattern', scope, {$event: evt});
                        var len = items.length;
                        while (len--) {
                            if (!upload.validatePattern(items[len], pattern)) {
                                dClass = obj.reject;
                                break;
                            } else {
                                dClass = obj.accept;
                            }
                        }
                    }
                }
            }
            callback(dClass);
        }

        function extractFiles(items, fileList, allowDir, multiple) {
            var maxFiles = upload.getValidationAttr(attr, scope, 'maxFiles');
            if (maxFiles == null) {
                maxFiles = Number.MAX_VALUE;
            }
            var maxTotalSize = upload.getValidationAttr(attr, scope, 'maxTotalSize');
            if (maxTotalSize == null) {
                maxTotalSize = Number.MAX_VALUE;
            }
            var includeDir = attrGetter('ngfIncludeDir', scope);
            var files = [], totalSize = 0;

            function traverseFileTree(entry, path) {
                var defer = $q.defer();
                if (entry != null) {
                    if (entry.isDirectory) {
                        var promises = [upload.emptyPromise()];
                        if (includeDir) {
                            var file = {type: 'directory'};
                            file.name = file.path = (path || '') + entry.name;
                            files.push(file);
                        }
                        var dirReader = entry.createReader();
                        var entries = [];
                        var readEntries = function () {
                            dirReader.readEntries(function (results) {
                                try {
                                    if (!results.length) {
                                        angular.forEach(entries.slice(0), function (e) {
                                            if (files.length <= maxFiles && totalSize <= maxTotalSize) {
                                                promises.push(traverseFileTree(e, (path ? path : '') + entry.name + '/'));
                                            }
                                        });
                                        $q.all(promises).then(function () {
                                            defer.resolve();
                                        }, function (e) {
                                            defer.reject(e);
                                        });
                                    } else {
                                        entries = entries.concat(Array.prototype.slice.call(results || [], 0));
                                        readEntries();
                                    }
                                } catch (e) {
                                    defer.reject(e);
                                }
                            }, function (e) {
                                defer.reject(e);
                            });
                        };
                        readEntries();
                    } else {
                        entry.file(function (file) {
                            try {
                                file.path = (path ? path : '') + file.name;
                                if (includeDir) {
                                    file = upload.rename(file, file.path);
                                }
                                files.push(file);
                                totalSize += file.size;
                                defer.resolve();
                            } catch (e) {
                                defer.reject(e);
                            }
                        }, function (e) {
                            defer.reject(e);
                        });
                    }
                }
                return defer.promise;
            }

            var promises = [upload.emptyPromise()];

            if (items && items.length > 0 && $window.location.protocol !== 'file:') {
                for (var i = 0; i < items.length; i++) {
                    if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
                        var entry = items[i].webkitGetAsEntry();
                        if (entry.isDirectory && !allowDir) {
                            continue;
                        }
                        if (entry != null) {
                            promises.push(traverseFileTree(entry));
                        }
                    } else {
                        var f = items[i].getAsFile();
                        if (f != null) {
                            files.push(f);
                            totalSize += f.size;
                        }
                    }
                    if (files.length > maxFiles || totalSize > maxTotalSize ||
                        (!multiple && files.length > 0)) break;
                }
            } else {
                if (fileList != null) {
                    for (var j = 0; j < fileList.length; j++) {
                        var file = fileList.item(j);
                        if (file.type || file.size > 0) {
                            files.push(file);
                            totalSize += file.size;
                        }
                        if (files.length > maxFiles || totalSize > maxTotalSize ||
                            (!multiple && files.length > 0)) break;
                    }
                }
            }

            var defer = $q.defer();
            $q.all(promises).then(function () {
                if (!multiple && !includeDir && files.length) {
                    var i = 0;
                    while (files[i] && files[i].type === 'directory') i++;
                    defer.resolve([files[i]]);
                } else {
                    defer.resolve(files);
                }
            }, function (e) {
                defer.reject(e);
            });

            return defer.promise;
        }
    }

    function dropAvailable() {
        var div = document.createElement('div');
        return ('draggable' in div) && ('ondrop' in div) && !/Edge\/12./i.test(navigator.userAgent);
    }

})();

// customized version of https://github.com/exif-js/exif-js
ngFileUpload.service('UploadExif', ['UploadResize', '$q', function (UploadResize, $q) {
    var upload = UploadResize;

    upload.isExifSupported = function () {
        return window.FileReader && new FileReader().readAsArrayBuffer && upload.isResizeSupported();
    };

    function applyTransform(ctx, orientation, width, height) {
        switch (orientation) {
            case 2:
                return ctx.transform(-1, 0, 0, 1, width, 0);
            case 3:
                return ctx.transform(-1, 0, 0, -1, width, height);
            case 4:
                return ctx.transform(1, 0, 0, -1, 0, height);
            case 5:
                return ctx.transform(0, 1, 1, 0, 0, 0);
            case 6:
                return ctx.transform(0, 1, -1, 0, height, 0);
            case 7:
                return ctx.transform(0, -1, -1, 0, height, width);
            case 8:
                return ctx.transform(0, -1, 1, 0, 0, width);
        }
    }

    upload.readOrientation = function (file) {
        var defer = $q.defer();
        var reader = new FileReader();
        var slicedFile = file.slice ? file.slice(0, 64 * 1024) : file;
        reader.readAsArrayBuffer(slicedFile);
        reader.onerror = function (e) {
            return defer.reject(e);
        };
        reader.onload = function (e) {
            var result = {orientation: 1};
            var view = new DataView(this.result);
            if (view.getUint16(0, false) !== 0xFFD8) return defer.resolve(result);

            var length = view.byteLength,
                offset = 2;
            while (offset < length) {
                var marker = view.getUint16(offset, false);
                offset += 2;
                if (marker === 0xFFE1) {
                    if (view.getUint32(offset += 2, false) !== 0x45786966) return defer.resolve(result);

                    var little = view.getUint16(offset += 6, false) === 0x4949;
                    offset += view.getUint32(offset + 4, little);
                    var tags = view.getUint16(offset, little);
                    offset += 2;
                    for (var i = 0; i < tags; i++)
                        if (view.getUint16(offset + (i * 12), little) === 0x0112) {
                            var orientation = view.getUint16(offset + (i * 12) + 8, little);
                            if (orientation >= 2 && orientation <= 8) {
                                view.setUint16(offset + (i * 12) + 8, 1, little);
                                result.fixedArrayBuffer = e.target.result;
                            }
                            result.orientation = orientation;
                            return defer.resolve(result);
                        }
                } else if ((marker & 0xFF00) !== 0xFF00) break;
                else offset += view.getUint16(offset, false);
            }
            return defer.resolve(result);
        };
        return defer.promise;
    };

    function arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    upload.applyExifRotation = function (file) {
        if (file.type.indexOf('image/jpeg') !== 0) {
            return upload.emptyPromise(file);
        }

        var deferred = $q.defer();
        upload.readOrientation(file).then(function (result) {
            if (result.orientation < 2 || result.orientation > 8) {
                return deferred.resolve(file);
            }
            upload.dataUrl(file, true).then(function (url) {
                var canvas = document.createElement('canvas');
                var img = document.createElement('img');

                img.onload = function () {
                    try {
                        canvas.width = result.orientation > 4 ? img.height : img.width;
                        canvas.height = result.orientation > 4 ? img.width : img.height;
                        var ctx = canvas.getContext('2d');
                        applyTransform(ctx, result.orientation, img.width, img.height);
                        ctx.drawImage(img, 0, 0);
                        var dataUrl = canvas.toDataURL(file.type || 'image/WebP', 0.934);
                        dataUrl = upload.restoreExif(arrayBufferToBase64(result.fixedArrayBuffer), dataUrl);
                        var blob = upload.dataUrltoBlob(dataUrl, file.name);
                        deferred.resolve(blob);
                    } catch (e) {
                        return deferred.reject(e);
                    }
                };
                img.onerror = function () {
                    deferred.reject();
                };
                img.src = url;
            }, function (e) {
                deferred.reject(e);
            });
        }, function (e) {
            deferred.reject(e);
        });
        return deferred.promise;
    };

    upload.restoreExif = function (orig, resized) {
        var ExifRestorer = {};

        ExifRestorer.KEY_STR = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        ExifRestorer.encode64 = function (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            do {
                chr1 = input[i++];
                chr2 = input[i++];
                chr3 = input[i++];

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    this.KEY_STR.charAt(enc1) +
                    this.KEY_STR.charAt(enc2) +
                    this.KEY_STR.charAt(enc3) +
                    this.KEY_STR.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            } while (i < input.length);

            return output;
        };

        ExifRestorer.restore = function (origFileBase64, resizedFileBase64) {
            if (origFileBase64.match('data:image/jpeg;base64,')) {
                origFileBase64 = origFileBase64.replace('data:image/jpeg;base64,', '');
            }

            var rawImage = this.decode64(origFileBase64);
            var segments = this.slice2Segments(rawImage);

            var image = this.exifManipulation(resizedFileBase64, segments);

            return 'data:image/jpeg;base64,' + this.encode64(image);
        };


        ExifRestorer.exifManipulation = function (resizedFileBase64, segments) {
            var exifArray = this.getExifArray(segments),
                newImageArray = this.insertExif(resizedFileBase64, exifArray);
            return new Uint8Array(newImageArray);
        };


        ExifRestorer.getExifArray = function (segments) {
            var seg;
            for (var x = 0; x < segments.length; x++) {
                seg = segments[x];
                if (seg[0] === 255 & seg[1] === 225) //(ff e1)
                {
                    return seg;
                }
            }
            return [];
        };


        ExifRestorer.insertExif = function (resizedFileBase64, exifArray) {
            var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', ''),
                buf = this.decode64(imageData),
                separatePoint = buf.indexOf(255, 3),
                mae = buf.slice(0, separatePoint),
                ato = buf.slice(separatePoint),
                array = mae;

            array = array.concat(exifArray);
            array = array.concat(ato);
            return array;
        };


        ExifRestorer.slice2Segments = function (rawImageArray) {
            var head = 0,
                segments = [];

            while (1) {
                if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
                    break;
                }
                if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
                    head += 2;
                }
                else {
                    var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3],
                        endPoint = head + length + 2,
                        seg = rawImageArray.slice(head, endPoint);
                    segments.push(seg);
                    head = endPoint;
                }
                if (head > rawImageArray.length) {
                    break;
                }
            }

            return segments;
        };


        ExifRestorer.decode64 = function (input) {
            var chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0,
                buf = [];

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            var base64test = /[^A-Za-z0-9\+\/\=]/g;
            if (base64test.exec(input)) {
                console.log('There were invalid base64 characters in the input text.\n' +
                    'Valid base64 characters are A-Z, a-z, 0-9, ' + ', ' / ',and "="\n' +
                    'Expect errors in decoding.');
            }
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            do {
                enc1 = this.KEY_STR.indexOf(input.charAt(i++));
                enc2 = this.KEY_STR.indexOf(input.charAt(i++));
                enc3 = this.KEY_STR.indexOf(input.charAt(i++));
                enc4 = this.KEY_STR.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                buf.push(chr1);

                if (enc3 !== 64) {
                    buf.push(chr2);
                }
                if (enc4 !== 64) {
                    buf.push(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';

            } while (i < input.length);

            return buf;
        };

        return ExifRestorer.restore(orig, resized);  //<= EXIF
    };

    return upload;
}]);


/**
 * Checklist-model
 * AngularJS directive for list of checkboxes
 */

angular.module('checklist-model', [])
    .directive('checklistModel', ['$parse', function($parse) {
        // contains
        function contains(arr, item) {
            if (angular.isArray(arr)) {
                for (var i = 0; i < arr.length; i++) {
                    if (angular.equals(arr[i], item)) {
                        return true;
                    }
                }
            }
            return false;
        }

        // add
        function add(arr, item) {
            arr = angular.isArray(arr) ? arr : [];
            for (var i = 0; i < arr.length; i++) {
                if (angular.equals(arr[i], item)) {
                    return arr;
                }
            }
            arr.push(item);
            return arr;
        }

        // remove
        function remove(arr, item) {
            if (angular.isArray(arr)) {
                for (var i = 0; i < arr.length; i++) {
                    if (angular.equals(arr[i], item)) {
                        arr.splice(i, 1);
                        break;
                    }
                }
            }
            return arr;
        }

        // http://stackoverflow.com/a/19228302/1458162
        function postLinkFn(scope, elem, attrs) {
            // bind checkbox <-> scope.checked directly (no recompilation)
            elem.on('change', function() {
                scope.$apply(function() {
                    scope.checked = elem[0].checked;
                });
            });
            scope.$watch('checked', function(val) {
                elem[0].checked = !!val;
            });

            // getter / setter for original model
            var getter = $parse(attrs.checklistModel);
            var setter = getter.assign;

            // value added to list
            var value = $parse(attrs.checklistValue)(scope.$parent);

            // watch UI checked change
            scope.$watch('checked', function(newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                var current = getter(scope.$parent);
                if (newValue === true) {
                    setter(scope.$parent, add(current, value));
                } else {
                    setter(scope.$parent, remove(current, value));
                }
            });

            // watch original model change
            scope.$parent.$watch(attrs.checklistModel, function(newArr, oldArr) {
                scope.checked = contains(newArr, value);
            }, true);
        }

        return {
            restrict: 'A',
            priority: 1000,
            terminal: true,
            scope: true,
            compile: function(tElement, tAttrs) {
                if (tElement[0].tagName !== 'INPUT' || !tElement.attr('type', 'checkbox')) {
                    throw 'checklist-model should be applied to `input[type="checkbox"]`.';
                }

                if (!tAttrs.checklistValue) {
                    throw 'You should provide `checklist-value`.';
                }

                // exclude recursion
                tElement.removeAttr('checklist-model');

                return postLinkFn;
            }
        };
    }]);

/* jquery.signalR.core.js */
/*global window:false */
/*!
 * ASP.NET SignalR JavaScript Library v2.2.2
 * http://signalr.net/
 *
 * Copyright (c) .NET Foundation. All rights reserved.
 * Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *
 */

/// <reference path="Scripts/jquery-1.6.4.js" />
/// <reference path="jquery.signalR.version.js" />
(function ($, window, undefined) {

    var resources = {
        nojQuery: "jQuery was not found. Please ensure jQuery is referenced before the SignalR client JavaScript file.",
        noTransportOnInit: "No transport could be initialized successfully. Try specifying a different transport or none at all for auto initialization.",
        errorOnNegotiate: "Error during negotiation request.",
        stoppedWhileLoading: "The connection was stopped during page load.",
        stoppedWhileNegotiating: "The connection was stopped during the negotiate request.",
        errorParsingNegotiateResponse: "Error parsing negotiate response.",
        errorDuringStartRequest: "Error during start request. Stopping the connection.",
        stoppedDuringStartRequest: "The connection was stopped during the start request.",
        errorParsingStartResponse: "Error parsing start response: '{0}'. Stopping the connection.",
        invalidStartResponse: "Invalid start response: '{0}'. Stopping the connection.",
        protocolIncompatible: "You are using a version of the client that isn't compatible with the server. Client version {0}, server version {1}.",
        sendFailed: "Send failed.",
        parseFailed: "Failed at parsing response: {0}",
        longPollFailed: "Long polling request failed.",
        eventSourceFailedToConnect: "EventSource failed to connect.",
        eventSourceError: "Error raised by EventSource",
        webSocketClosed: "WebSocket closed.",
        pingServerFailedInvalidResponse: "Invalid ping response when pinging server: '{0}'.",
        pingServerFailed: "Failed to ping server.",
        pingServerFailedStatusCode: "Failed to ping server.  Server responded with status code {0}, stopping the connection.",
        pingServerFailedParse: "Failed to parse ping server response, stopping the connection.",
        noConnectionTransport: "Connection is in an invalid state, there is no transport active.",
        webSocketsInvalidState: "The Web Socket transport is in an invalid state, transitioning into reconnecting.",
        reconnectTimeout: "Couldn't reconnect within the configured timeout of {0} ms, disconnecting.",
        reconnectWindowTimeout: "The client has been inactive since {0} and it has exceeded the inactivity timeout of {1} ms. Stopping the connection."
    };

    if (typeof ($) !== "function") {
        // no jQuery!
        throw new Error(resources.nojQuery);
    }

    var signalR,
        _connection,
        _pageLoaded = (window.document.readyState === "complete"),
        _pageWindow = $(window),
        _negotiateAbortText = "__Negotiate Aborted__",
        events = {
            onStart: "onStart",
            onStarting: "onStarting",
            onReceived: "onReceived",
            onError: "onError",
            onConnectionSlow: "onConnectionSlow",
            onReconnecting: "onReconnecting",
            onReconnect: "onReconnect",
            onStateChanged: "onStateChanged",
            onDisconnect: "onDisconnect"
        },
        ajaxDefaults = {
            processData: true,
            timeout: null,
            async: true,
            global: false,
            cache: false
        },
        log = function (msg, logging) {
            if (logging === false) {
                return;
            }
            var m;
            if (typeof (window.console) === "undefined") {
                return;
            }
            m = "[" + new Date().toTimeString() + "] SignalR: " + msg;
            if (window.console.debug) {
                window.console.debug(m);
            } else if (window.console.log) {
                window.console.log(m);
            }
        },

        changeState = function (connection, expectedState, newState) {
            if (expectedState === connection.state) {
                connection.state = newState;

                $(connection).triggerHandler(events.onStateChanged, [{ oldState: expectedState, newState: newState }]);
                return true;
            }

            return false;
        },

        isDisconnecting = function (connection) {
            return connection.state === signalR.connectionState.disconnected;
        },

        supportsKeepAlive = function (connection) {
            return connection._.keepAliveData.activated &&
                   connection.transport.supportsKeepAlive(connection);
        },

        configureStopReconnectingTimeout = function (connection) {
            var stopReconnectingTimeout,
                onReconnectTimeout;

            // Check if this connection has already been configured to stop reconnecting after a specified timeout.
            // Without this check if a connection is stopped then started events will be bound multiple times.
            if (!connection._.configuredStopReconnectingTimeout) {
                onReconnectTimeout = function (connection) {
                    var message = signalR._.format(signalR.resources.reconnectTimeout, connection.disconnectTimeout);
                    connection.log(message);
                    $(connection).triggerHandler(events.onError, [signalR._.error(message, /* source */ "TimeoutException")]);
                    connection.stop(/* async */ false, /* notifyServer */ false);
                };

                connection.reconnecting(function () {
                    var connection = this;

                    // Guard against state changing in a previous user defined even handler
                    if (connection.state === signalR.connectionState.reconnecting) {
                        stopReconnectingTimeout = window.setTimeout(function () { onReconnectTimeout(connection); }, connection.disconnectTimeout);
                    }
                });

                connection.stateChanged(function (data) {
                    if (data.oldState === signalR.connectionState.reconnecting) {
                        // Clear the pending reconnect timeout check
                        window.clearTimeout(stopReconnectingTimeout);
                    }
                });

                connection._.configuredStopReconnectingTimeout = true;
            }
        };

    signalR = function (url, qs, logging) {
        /// <summary>Creates a new SignalR connection for the given url</summary>
        /// <param name="url" type="String">The URL of the long polling endpoint</param>
        /// <param name="qs" type="Object">
        ///     [Optional] Custom querystring parameters to add to the connection URL.
        ///     If an object, every non-function member will be added to the querystring.
        ///     If a string, it's added to the QS as specified.
        /// </param>
        /// <param name="logging" type="Boolean">
        ///     [Optional] A flag indicating whether connection logging is enabled to the browser
        ///     console/log. Defaults to false.
        /// </param>

        return new signalR.fn.init(url, qs, logging);
    };

    signalR._ = {
        defaultContentType: "application/x-www-form-urlencoded; charset=UTF-8",

        ieVersion: (function () {
            var version,
                matches;

            if (window.navigator.appName === 'Microsoft Internet Explorer') {
                // Check if the user agent has the pattern "MSIE (one or more numbers).(one or more numbers)";
                matches = /MSIE ([0-9]+\.[0-9]+)/.exec(window.navigator.userAgent);

                if (matches) {
                    version = window.parseFloat(matches[1]);
                }
            }

            // undefined value means not IE
            return version;
        })(),

        error: function (message, source, context) {
            var e = new Error(message);
            e.source = source;

            if (typeof context !== "undefined") {
                e.context = context;
            }

            return e;
        },

        transportError: function (message, transport, source, context) {
            var e = this.error(message, source, context);
            e.transport = transport ? transport.name : undefined;
            return e;
        },

        format: function () {
            /// <summary>Usage: format("Hi {0}, you are {1}!", "Foo", 100) </summary>
            var s = arguments[0];
            for (var i = 0; i < arguments.length - 1; i++) {
                s = s.replace("{" + i + "}", arguments[i + 1]);
            }
            return s;
        },

        firefoxMajorVersion: function (userAgent) {
            // Firefox user agents: http://useragentstring.com/pages/Firefox/
            var matches = userAgent.match(/Firefox\/(\d+)/);
            if (!matches || !matches.length || matches.length < 2) {
                return 0;
            }
            return parseInt(matches[1], 10 /* radix */);
        },

        configurePingInterval: function (connection) {
            var config = connection._.config,
                onFail = function (error) {
                    $(connection).triggerHandler(events.onError, [error]);
                };

            if (config && !connection._.pingIntervalId && config.pingInterval) {
                connection._.pingIntervalId = window.setInterval(function () {
                    signalR.transports._logic.pingServer(connection).fail(onFail);
                }, config.pingInterval);
            }
        }
    };

    signalR.events = events;

    signalR.resources = resources;

    signalR.ajaxDefaults = ajaxDefaults;

    signalR.changeState = changeState;

    signalR.isDisconnecting = isDisconnecting;

    signalR.connectionState = {
        connecting: 0,
        connected: 1,
        reconnecting: 2,
        disconnected: 4
    };

    signalR.hub = {
        start: function () {
            // This will get replaced with the real hub connection start method when hubs is referenced correctly
            throw new Error("SignalR: Error loading hubs. Ensure your hubs reference is correct, e.g. <script src='/signalr/js'></script>.");
        }
    };

    // .on() was added in version 1.7.0, .load() was removed in version 3.0.0 so we fallback to .load() if .on() does
    // not exist to not break existing applications
    if (typeof _pageWindow.on == "function") {
        _pageWindow.on("load", function () { _pageLoaded = true; });
    }
    else {
        _pageWindow.load(function () { _pageLoaded = true; });
    }

    function validateTransport(requestedTransport, connection) {
        /// <summary>Validates the requested transport by cross checking it with the pre-defined signalR.transports</summary>
        /// <param name="requestedTransport" type="Object">The designated transports that the user has specified.</param>
        /// <param name="connection" type="signalR">The connection that will be using the requested transports.  Used for logging purposes.</param>
        /// <returns type="Object" />

        if (Array.isArray(requestedTransport)) {
            // Go through transport array and remove an "invalid" tranports
            for (var i = requestedTransport.length - 1; i >= 0; i--) {
                var transport = requestedTransport[i];
                if (typeof transport !== "string" || !signalR.transports[transport]) {
                    connection.log("Invalid transport: " + transport + ", removing it from the transports list.");
                    requestedTransport.splice(i, 1);
                }
            }

            // Verify we still have transports left, if we dont then we have invalid transports
            if (requestedTransport.length === 0) {
                connection.log("No transports remain within the specified transport array.");
                requestedTransport = null;
            }
        } else if (!signalR.transports[requestedTransport] && requestedTransport !== "auto") {
            connection.log("Invalid transport: " + requestedTransport.toString() + ".");
            requestedTransport = null;
        } else if (requestedTransport === "auto" && signalR._.ieVersion <= 8) {
            // If we're doing an auto transport and we're IE8 then force longPolling, #1764
            return ["longPolling"];

        }

        return requestedTransport;
    }

    function getDefaultPort(protocol) {
        if (protocol === "http:") {
            return 80;
        } else if (protocol === "https:") {
            return 443;
        }
    }

    function addDefaultPort(protocol, url) {
        // Remove ports  from url.  We have to check if there's a / or end of line
        // following the port in order to avoid removing ports such as 8080.
        if (url.match(/:\d+$/)) {
            return url;
        } else {
            return url + ":" + getDefaultPort(protocol);
        }
    }

    function ConnectingMessageBuffer(connection, drainCallback) {
        var that = this,
            buffer = [];

        that.tryBuffer = function (message) {
            if (connection.state === $.signalR.connectionState.connecting) {
                buffer.push(message);

                return true;
            }

            return false;
        };

        that.drain = function () {
            // Ensure that the connection is connected when we drain (do not want to drain while a connection is not active)
            if (connection.state === $.signalR.connectionState.connected) {
                while (buffer.length > 0) {
                    drainCallback(buffer.shift());
                }
            }
        };

        that.clear = function () {
            buffer = [];
        };
    }

    signalR.fn = signalR.prototype = {
        init: function (url, qs, logging) {
            var $connection = $(this);

            this.url = url;
            this.qs = qs;
            this.lastError = null;
            this._ = {
                keepAliveData: {},
                connectingMessageBuffer: new ConnectingMessageBuffer(this, function (message) {
                    $connection.triggerHandler(events.onReceived, [message]);
                }),
                lastMessageAt: new Date().getTime(),
                lastActiveAt: new Date().getTime(),
                beatInterval: 5000, // Default value, will only be overridden if keep alive is enabled,
                beatHandle: null,
                totalTransportConnectTimeout: 0 // This will be the sum of the TransportConnectTimeout sent in response to negotiate and connection.transportConnectTimeout
            };
            if (typeof (logging) === "boolean") {
                this.logging = logging;
            }
        },

        _parseResponse: function (response) {
            var that = this;

            if (!response) {
                return response;
            } else if (typeof response === "string") {
                return that.json.parse(response);
            } else {
                return response;
            }
        },

        _originalJson: window.JSON,

        json: window.JSON,

        isCrossDomain: function (url, against) {
            /// <summary>Checks if url is cross domain</summary>
            /// <param name="url" type="String">The base URL</param>
            /// <param name="against" type="Object">
            ///     An optional argument to compare the URL against, if not specified it will be set to window.location.
            ///     If specified it must contain a protocol and a host property.
            /// </param>
            var link;

            url = url.trim();

            against = against || window.location;

            if (url.indexOf("http") !== 0) {
                return false;
            }

            // Create an anchor tag.
            link = window.document.createElement("a");
            link.href = url;

            // When checking for cross domain we have to special case port 80 because the window.location will remove the
            return link.protocol + addDefaultPort(link.protocol, link.host) !== against.protocol + addDefaultPort(against.protocol, against.host);
        },

        ajaxDataType: "text",

        contentType: "application/json; charset=UTF-8",

        logging: false,

        state: signalR.connectionState.disconnected,

        clientProtocol: "1.5",

        reconnectDelay: 2000,

        transportConnectTimeout: 0,

        disconnectTimeout: 30000, // This should be set by the server in response to the negotiate request (30s default)

        reconnectWindow: 30000, // This should be set by the server in response to the negotiate request

        keepAliveWarnAt: 2 / 3, // Warn user of slow connection if we breach the X% mark of the keep alive timeout

        start: function (options, callback) {
            /// <summary>Starts the connection</summary>
            /// <param name="options" type="Object">Options map</param>
            /// <param name="callback" type="Function">A callback function to execute when the connection has started</param>
            var connection = this,
                config = {
                    pingInterval: 300000,
                    waitForPageLoad: true,
                    transport: "auto",
                    jsonp: false
                },
                initialize,
                deferred = connection._deferral || $.Deferred(), // Check to see if there is a pre-existing deferral that's being built on, if so we want to keep using it
                parser = window.document.createElement("a");

            connection.lastError = null;

            // Persist the deferral so that if start is called multiple times the same deferral is used.
            connection._deferral = deferred;

            if (!connection.json) {
                // no JSON!
                throw new Error("SignalR: No JSON parser found. Please ensure json2.js is referenced before the SignalR.js file if you need to support clients without native JSON parsing support, e.g. IE<8.");
            }

            if (typeof options === "function") {
                // Support calling with single callback parameter
                callback = options;
            } else if (typeof options === "object") {
                $.extend(config, options);
                if (typeof config.callback === "function") {
                    callback = config.callback;
                }
            }

            config.transport = validateTransport(config.transport, connection);

            // If the transport is invalid throw an error and abort start
            if (!config.transport) {
                throw new Error("SignalR: Invalid transport(s) specified, aborting start.");
            }

            connection._.config = config;

            // Check to see if start is being called prior to page load
            // If waitForPageLoad is true we then want to re-direct function call to the window load event
            if (!_pageLoaded && config.waitForPageLoad === true) {
                connection._.deferredStartHandler = function () {
                    connection.start(options, callback);
                };
                _pageWindow.on("load", connection._.deferredStartHandler);

                return deferred.promise();
            }

            // If we're already connecting just return the same deferral as the original connection start
            if (connection.state === signalR.connectionState.connecting) {
                return deferred.promise();
            } else if (changeState(connection,
                            signalR.connectionState.disconnected,
                            signalR.connectionState.connecting) === false) {
                // We're not connecting so try and transition into connecting.
                // If we fail to transition then we're either in connected or reconnecting.

                deferred.resolve(connection);
                return deferred.promise();
            }

            configureStopReconnectingTimeout(connection);

            // Resolve the full url
            parser.href = connection.url;
            if (!parser.protocol || parser.protocol === ":") {
                connection.protocol = window.document.location.protocol;
                connection.host = parser.host || window.document.location.host;
            } else {
                connection.protocol = parser.protocol;
                connection.host = parser.host;
            }

            connection.baseUrl = connection.protocol + "//" + connection.host;

            // Set the websocket protocol
            connection.wsProtocol = connection.protocol === "https:" ? "wss://" : "ws://";

            // If jsonp with no/auto transport is specified, then set the transport to long polling
            // since that is the only transport for which jsonp really makes sense.
            // Some developers might actually choose to specify jsonp for same origin requests
            // as demonstrated by Issue #623.
            if (config.transport === "auto" && config.jsonp === true) {
                config.transport = "longPolling";
            }

            // If the url is protocol relative, prepend the current windows protocol to the url.
            if (connection.url.indexOf("//") === 0) {
                connection.url = window.location.protocol + connection.url;
                connection.log("Protocol relative URL detected, normalizing it to '" + connection.url + "'.");
            }

            if (this.isCrossDomain(connection.url)) {
                connection.log("Auto detected cross domain url.");

                if (config.transport === "auto") {
                    // TODO: Support XDM with foreverFrame
                    config.transport = ["webSockets", "serverSentEvents", "longPolling"];
                }

                if (typeof (config.withCredentials) === "undefined") {
                    config.withCredentials = true;
                }

                // Determine if jsonp is the only choice for negotiation, ajaxSend and ajaxAbort.
                // i.e. if the browser doesn't supports CORS
                // If it is, ignore any preference to the contrary, and switch to jsonp.
                if (!config.jsonp) {
                    config.jsonp = !$.support.cors;

                    if (config.jsonp) {
                        connection.log("Using jsonp because this browser doesn't support CORS.");
                    }
                }

                connection.contentType = signalR._.defaultContentType;
            }

            connection.withCredentials = config.withCredentials;

            connection.ajaxDataType = config.jsonp ? "jsonp" : "text";

            $(connection).on(events.onStart, function (e, data) {
                if (typeof callback === "function") {
                    callback.call(connection);
                }
                deferred.resolve(connection);
            });

            connection._.initHandler = signalR.transports._logic.initHandler(connection);

            initialize = function (transports, index) {
                var noTransportError = signalR._.error(resources.noTransportOnInit);

                index = index || 0;
                if (index >= transports.length) {
                    if (index === 0) {
                        connection.log("No transports supported by the server were selected.");
                    } else if (index === 1) {
                        connection.log("No fallback transports were selected.");
                    } else {
                        connection.log("Fallback transports exhausted.");
                    }

                    // No transport initialized successfully
                    $(connection).triggerHandler(events.onError, [noTransportError]);
                    deferred.reject(noTransportError);
                    // Stop the connection if it has connected and move it into the disconnected state
                    connection.stop();
                    return;
                }

                // The connection was aborted
                if (connection.state === signalR.connectionState.disconnected) {
                    return;
                }

                var transportName = transports[index],
                    transport = signalR.transports[transportName],
                    onFallback = function () {
                        initialize(transports, index + 1);
                    };

                connection.transport = transport;

                try {
                    connection._.initHandler.start(transport, function () { // success
                        // Firefox 11+ doesn't allow sync XHR withCredentials: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#withCredentials
                        var isFirefox11OrGreater = signalR._.firefoxMajorVersion(window.navigator.userAgent) >= 11,
                            asyncAbort = !!connection.withCredentials && isFirefox11OrGreater;

                        connection.log("The start request succeeded. Transitioning to the connected state.");

                        if (supportsKeepAlive(connection)) {
                            signalR.transports._logic.monitorKeepAlive(connection);
                        }

                        signalR.transports._logic.startHeartbeat(connection);

                        // Used to ensure low activity clients maintain their authentication.
                        // Must be configured once a transport has been decided to perform valid ping requests.
                        signalR._.configurePingInterval(connection);

                        if (!changeState(connection,
                                            signalR.connectionState.connecting,
                                            signalR.connectionState.connected)) {
                            connection.log("WARNING! The connection was not in the connecting state.");
                        }

                        // Drain any incoming buffered messages (messages that came in prior to connect)
                        connection._.connectingMessageBuffer.drain();

                        $(connection).triggerHandler(events.onStart);

                        // wire the stop handler for when the user leaves the page
                        _pageWindow.on("unload", function () {
                            connection.log("Window unloading, stopping the connection.");

                            connection.stop(asyncAbort);
                        });

                        if (isFirefox11OrGreater) {
                            // Firefox does not fire cross-domain XHRs in the normal unload handler on tab close.
                            // #2400
                            _pageWindow.on("beforeunload", function () {
                                // If connection.stop() runs runs in beforeunload and fails, it will also fail
                                // in unload unless connection.stop() runs after a timeout.
                                window.setTimeout(function () {
                                    connection.stop(asyncAbort);
                                }, 0);
                            });
                        }
                    }, onFallback);
                }
                catch (error) {
                    connection.log(transport.name + " transport threw '" + error.message + "' when attempting to start.");
                    onFallback();
                }
            };

            var url = connection.url + "/negotiate",
                onFailed = function (error, connection) {
                    var err = signalR._.error(resources.errorOnNegotiate, error, connection._.negotiateRequest);

                    $(connection).triggerHandler(events.onError, err);
                    deferred.reject(err);
                    // Stop the connection if negotiate failed
                    connection.stop();
                };

            $(connection).triggerHandler(events.onStarting);

            url = signalR.transports._logic.prepareQueryString(connection, url);

            connection.log("Negotiating with '" + url + "'.");

            // Save the ajax negotiate request object so we can abort it if stop is called while the request is in flight.
            connection._.negotiateRequest = signalR.transports._logic.ajax(connection, {
                url: url,
                error: function (error, statusText) {
                    // We don't want to cause any errors if we're aborting our own negotiate request.
                    if (statusText !== _negotiateAbortText) {
                        onFailed(error, connection);
                    } else {
                        // This rejection will noop if the deferred has already been resolved or rejected.
                        deferred.reject(signalR._.error(resources.stoppedWhileNegotiating, null /* error */, connection._.negotiateRequest));
                    }
                },
                success: function (result) {
                    var res,
                        keepAliveData,
                        protocolError,
                        transports = [],
                        supportedTransports = [];

                    try {
                        res = connection._parseResponse(result);
                    } catch (error) {
                        onFailed(signalR._.error(resources.errorParsingNegotiateResponse, error), connection);
                        return;
                    }

                    keepAliveData = connection._.keepAliveData;
                    connection.appRelativeUrl = res.Url;
                    connection.id = res.ConnectionId;
                    connection.token = res.ConnectionToken;
                    connection.webSocketServerUrl = res.WebSocketServerUrl;

                    // The long poll timeout is the ConnectionTimeout plus 10 seconds
                    connection._.pollTimeout = res.ConnectionTimeout * 1000 + 10000; // in ms

                    // Once the server has labeled the PersistentConnection as Disconnected, we should stop attempting to reconnect
                    // after res.DisconnectTimeout seconds.
                    connection.disconnectTimeout = res.DisconnectTimeout * 1000; // in ms

                    // Add the TransportConnectTimeout from the response to the transportConnectTimeout from the client to calculate the total timeout
                    connection._.totalTransportConnectTimeout = connection.transportConnectTimeout + res.TransportConnectTimeout * 1000;

                    // If we have a keep alive
                    if (res.KeepAliveTimeout) {
                        // Register the keep alive data as activated
                        keepAliveData.activated = true;

                        // Timeout to designate when to force the connection into reconnecting converted to milliseconds
                        keepAliveData.timeout = res.KeepAliveTimeout * 1000;

                        // Timeout to designate when to warn the developer that the connection may be dead or is not responding.
                        keepAliveData.timeoutWarning = keepAliveData.timeout * connection.keepAliveWarnAt;

                        // Instantiate the frequency in which we check the keep alive.  It must be short in order to not miss/pick up any changes
                        connection._.beatInterval = (keepAliveData.timeout - keepAliveData.timeoutWarning) / 3;
                    } else {
                        keepAliveData.activated = false;
                    }

                    connection.reconnectWindow = connection.disconnectTimeout + (keepAliveData.timeout || 0);

                    if (!res.ProtocolVersion || res.ProtocolVersion !== connection.clientProtocol) {
                        protocolError = signalR._.error(signalR._.format(resources.protocolIncompatible, connection.clientProtocol, res.ProtocolVersion));
                        $(connection).triggerHandler(events.onError, [protocolError]);
                        deferred.reject(protocolError);

                        return;
                    }

                    $.each(signalR.transports, function (key) {
                        if ((key.indexOf("_") === 0) || (key === "webSockets" && !res.TryWebSockets)) {
                            return true;
                        }
                        supportedTransports.push(key);
                    });

                    if (Array.isArray(config.transport)) {
                        $.each(config.transport, function (_, transport) {
                            if ($.inArray(transport, supportedTransports) >= 0) {
                                transports.push(transport);
                            }
                        });
                    } else if (config.transport === "auto") {
                        transports = supportedTransports;
                    } else if ($.inArray(config.transport, supportedTransports) >= 0) {
                        transports.push(config.transport);
                    }

                    initialize(transports);
                }
            });

            return deferred.promise();
        },

        starting: function (callback) {
            /// <summary>Adds a callback that will be invoked before anything is sent over the connection</summary>
            /// <param name="callback" type="Function">A callback function to execute before the connection is fully instantiated.</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).on(events.onStarting, function (e, data) {
                callback.call(connection);
            });
            return connection;
        },

        send: function (data) {
            /// <summary>Sends data over the connection</summary>
            /// <param name="data" type="String">The data to send over the connection</param>
            /// <returns type="signalR" />
            var connection = this;

            if (connection.state === signalR.connectionState.disconnected) {
                // Connection hasn't been started yet
                throw new Error("SignalR: Connection must be started before data can be sent. Call .start() before .send()");
            }

            if (connection.state === signalR.connectionState.connecting) {
                // Connection hasn't been started yet
                throw new Error("SignalR: Connection has not been fully initialized. Use .start().done() or .start().fail() to run logic after the connection has started.");
            }

            connection.transport.send(connection, data);
            // REVIEW: Should we return deferred here?
            return connection;
        },

        received: function (callback) {
            /// <summary>Adds a callback that will be invoked after anything is received over the connection</summary>
            /// <param name="callback" type="Function">A callback function to execute when any data is received on the connection</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).on(events.onReceived, function (e, data) {
                callback.call(connection, data);
            });
            return connection;
        },

        stateChanged: function (callback) {
            /// <summary>Adds a callback that will be invoked when the connection state changes</summary>
            /// <param name="callback" type="Function">A callback function to execute when the connection state changes</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).on(events.onStateChanged, function (e, data) {
                callback.call(connection, data);
            });
            return connection;
        },

        error: function (callback) {
            /// <summary>Adds a callback that will be invoked after an error occurs with the connection</summary>
            /// <param name="callback" type="Function">A callback function to execute when an error occurs on the connection</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).on(events.onError, function (e, errorData, sendData) {
                connection.lastError = errorData;
                // In practice 'errorData' is the SignalR built error object.
                // In practice 'sendData' is undefined for all error events except those triggered by
                // 'ajaxSend' and 'webSockets.send'.'sendData' is the original send payload.
                callback.call(connection, errorData, sendData);
            });
            return connection;
        },

        disconnected: function (callback) {
            /// <summary>Adds a callback that will be invoked when the client disconnects</summary>
            /// <param name="callback" type="Function">A callback function to execute when the connection is broken</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).on(events.onDisconnect, function (e, data) {
                callback.call(connection);
            });
            return connection;
        },

        connectionSlow: function (callback) {
            /// <summary>Adds a callback that will be invoked when the client detects a slow connection</summary>
            /// <param name="callback" type="Function">A callback function to execute when the connection is slow</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).on(events.onConnectionSlow, function (e, data) {
                callback.call(connection);
            });

            return connection;
        },

        reconnecting: function (callback) {
            /// <summary>Adds a callback that will be invoked when the underlying transport begins reconnecting</summary>
            /// <param name="callback" type="Function">A callback function to execute when the connection enters a reconnecting state</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).on(events.onReconnecting, function (e, data) {
                callback.call(connection);
            });
            return connection;
        },

        reconnected: function (callback) {
            /// <summary>Adds a callback that will be invoked when the underlying transport reconnects</summary>
            /// <param name="callback" type="Function">A callback function to execute when the connection is restored</param>
            /// <returns type="signalR" />
            var connection = this;
            $(connection).on(events.onReconnect, function (e, data) {
                callback.call(connection);
            });
            return connection;
        },

        stop: function (async, notifyServer) {
            /// <summary>Stops listening</summary>
            /// <param name="async" type="Boolean">Whether or not to asynchronously abort the connection</param>
            /// <param name="notifyServer" type="Boolean">Whether we want to notify the server that we are aborting the connection</param>
            /// <returns type="signalR" />
            var connection = this,
                // Save deferral because this is always cleaned up
                deferral = connection._deferral;

            // Verify that we've bound a load event.
            if (connection._.deferredStartHandler) {
                // Unbind the event.
                _pageWindow.off("load", connection._.deferredStartHandler);
            }

            // Always clean up private non-timeout based state.
            delete connection._.config;
            delete connection._.deferredStartHandler;

            // This needs to be checked despite the connection state because a connection start can be deferred until page load.
            // If we've deferred the start due to a page load we need to unbind the "onLoad" -> start event.
            if (!_pageLoaded && (!connection._.config || connection._.config.waitForPageLoad === true)) {
                connection.log("Stopping connection prior to negotiate.");

                // If we have a deferral we should reject it
                if (deferral) {
                    deferral.reject(signalR._.error(resources.stoppedWhileLoading));
                }

                // Short-circuit because the start has not been fully started.
                return;
            }

            if (connection.state === signalR.connectionState.disconnected) {
                return;
            }

            connection.log("Stopping connection.");

            // Clear this no matter what
            window.clearTimeout(connection._.beatHandle);
            window.clearInterval(connection._.pingIntervalId);

            if (connection.transport) {
                connection.transport.stop(connection);

                if (notifyServer !== false) {
                    connection.transport.abort(connection, async);
                }

                if (supportsKeepAlive(connection)) {
                    signalR.transports._logic.stopMonitoringKeepAlive(connection);
                }

                connection.transport = null;
            }

            if (connection._.negotiateRequest) {
                // If the negotiation request has already completed this will noop.
                connection._.negotiateRequest.abort(_negotiateAbortText);
                delete connection._.negotiateRequest;
            }

            // Ensure that initHandler.stop() is called before connection._deferral is deleted
            if (connection._.initHandler) {
                connection._.initHandler.stop();
            }

            delete connection._deferral;
            delete connection.messageId;
            delete connection.groupsToken;
            delete connection.id;
            delete connection._.pingIntervalId;
            delete connection._.lastMessageAt;
            delete connection._.lastActiveAt;

            // Clear out our message buffer
            connection._.connectingMessageBuffer.clear();

            // Clean up this event
            $(connection).off(events.onStart);

            // Trigger the disconnect event
            changeState(connection, connection.state, signalR.connectionState.disconnected);
            $(connection).triggerHandler(events.onDisconnect);

            return connection;
        },

        log: function (msg) {
            log(msg, this.logging);
        }
    };

    signalR.fn.init.prototype = signalR.fn;

    signalR.noConflict = function () {
        /// <summary>Reinstates the original value of $.connection and returns the signalR object for manual assignment</summary>
        /// <returns type="signalR" />
        if ($.connection === signalR) {
            $.connection = _connection;
        }
        return signalR;
    };

    if ($.connection) {
        _connection = $.connection;
    }

    $.connection = $.signalR = signalR;

}(window.jQuery, window));
/* jquery.signalR.transports.common.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.

/*global window:false */
/// <reference path="jquery.signalR.core.js" />

(function ($, window, undefined) {

    var signalR = $.signalR,
        events = $.signalR.events,
        changeState = $.signalR.changeState,
        startAbortText = "__Start Aborted__",
        transportLogic;

    signalR.transports = {};

    function beat(connection) {
        if (connection._.keepAliveData.monitoring) {
            checkIfAlive(connection);
        }

        // Ensure that we successfully marked active before continuing the heartbeat.
        if (transportLogic.markActive(connection)) {
            connection._.beatHandle = window.setTimeout(function () {
                beat(connection);
            }, connection._.beatInterval);
        }
    }

    function checkIfAlive(connection) {
        var keepAliveData = connection._.keepAliveData,
            timeElapsed;

        // Only check if we're connected
        if (connection.state === signalR.connectionState.connected) {
            timeElapsed = new Date().getTime() - connection._.lastMessageAt;

            // Check if the keep alive has completely timed out
            if (timeElapsed >= keepAliveData.timeout) {
                connection.log("Keep alive timed out.  Notifying transport that connection has been lost.");

                // Notify transport that the connection has been lost
                connection.transport.lostConnection(connection);
            } else if (timeElapsed >= keepAliveData.timeoutWarning) {
                // This is to assure that the user only gets a single warning
                if (!keepAliveData.userNotified) {
                    connection.log("Keep alive has been missed, connection may be dead/slow.");
                    $(connection).triggerHandler(events.onConnectionSlow);
                    keepAliveData.userNotified = true;
                }
            } else {
                keepAliveData.userNotified = false;
            }
        }
    }

    function getAjaxUrl(connection, path) {
        var url = connection.url + path;

        if (connection.transport) {
            url += "?transport=" + connection.transport.name;
        }

        return transportLogic.prepareQueryString(connection, url);
    }

    function InitHandler(connection) {
        this.connection = connection;

        this.startRequested = false;
        this.startCompleted = false;
        this.connectionStopped = false;
    }

    InitHandler.prototype = {
        start: function (transport, onSuccess, onFallback) {
            var that = this,
                connection = that.connection,
                failCalled = false;

            if (that.startRequested || that.connectionStopped) {
                connection.log("WARNING! " + transport.name + " transport cannot be started. Initialization ongoing or completed.");
                return;
            }

            connection.log(transport.name + " transport starting.");

            transport.start(connection, function () {
                if (!failCalled) {
                    that.initReceived(transport, onSuccess);
                }
            }, function (error) {
                // Don't allow the same transport to cause onFallback to be called twice
                if (!failCalled) {
                    failCalled = true;
                    that.transportFailed(transport, error, onFallback);
                }

                // Returns true if the transport should stop;
                // false if it should attempt to reconnect
                return !that.startCompleted || that.connectionStopped;
            });

            that.transportTimeoutHandle = window.setTimeout(function () {
                if (!failCalled) {
                    failCalled = true;
                    connection.log(transport.name + " transport timed out when trying to connect.");
                    that.transportFailed(transport, undefined, onFallback);
                }
            }, connection._.totalTransportConnectTimeout);
        },

        stop: function () {
            this.connectionStopped = true;
            window.clearTimeout(this.transportTimeoutHandle);
            signalR.transports._logic.tryAbortStartRequest(this.connection);
        },

        initReceived: function (transport, onSuccess) {
            var that = this,
                connection = that.connection;

            if (that.startRequested) {
                connection.log("WARNING! The client received multiple init messages.");
                return;
            }

            if (that.connectionStopped) {
                return;
            }

            that.startRequested = true;
            window.clearTimeout(that.transportTimeoutHandle);

            connection.log(transport.name + " transport connected. Initiating start request.");
            signalR.transports._logic.ajaxStart(connection, function () {
                that.startCompleted = true;
                onSuccess();
            });
        },

        transportFailed: function (transport, error, onFallback) {
            var connection = this.connection,
                deferred = connection._deferral,
                wrappedError;

            if (this.connectionStopped) {
                return;
            }

            window.clearTimeout(this.transportTimeoutHandle);

            if (!this.startRequested) {
                transport.stop(connection);

                connection.log(transport.name + " transport failed to connect. Attempting to fall back.");
                onFallback();
            } else if (!this.startCompleted) {
                // Do not attempt to fall back if a start request is ongoing during a transport failure.
                // Instead, trigger an error and stop the connection.
                wrappedError = signalR._.error(signalR.resources.errorDuringStartRequest, error);

                connection.log(transport.name + " transport failed during the start request. Stopping the connection.");
                $(connection).triggerHandler(events.onError, [wrappedError]);
                if (deferred) {
                    deferred.reject(wrappedError);
                }

                connection.stop();
            } else {
                // The start request has completed, but the connection has not stopped.
                // No need to do anything here. The transport should attempt its normal reconnect logic.
            }
        }
    };

    transportLogic = signalR.transports._logic = {
        ajax: function (connection, options) {
            return $.ajax(
                $.extend(/*deep copy*/ true, {}, $.signalR.ajaxDefaults, {
                    type: "GET",
                    data: {},
                    xhrFields: { withCredentials: connection.withCredentials },
                    contentType: connection.contentType,
                    dataType: connection.ajaxDataType
                }, options));
        },

        pingServer: function (connection) {
            /// <summary>Pings the server</summary>
            /// <param name="connection" type="signalr">Connection associated with the server ping</param>
            /// <returns type="signalR" />
            var url,
                xhr,
                deferral = $.Deferred();

            if (connection.transport) {
                url = connection.url + "/ping";

                url = transportLogic.addQs(url, connection.qs);

                xhr = transportLogic.ajax(connection, {
                    url: url,
                    success: function (result) {
                        var data;

                        try {
                            data = connection._parseResponse(result);
                        }
                        catch (error) {
                            deferral.reject(
                                signalR._.transportError(
                                    signalR.resources.pingServerFailedParse,
                                    connection.transport,
                                    error,
                                    xhr
                                )
                            );
                            connection.stop();
                            return;
                        }

                        if (data.Response === "pong") {
                            deferral.resolve();
                        }
                        else {
                            deferral.reject(
                                signalR._.transportError(
                                    signalR._.format(signalR.resources.pingServerFailedInvalidResponse, result),
                                    connection.transport,
                                    null /* error */,
                                    xhr
                                )
                            );
                        }
                    },
                    error: function (error) {
                        if (error.status === 401 || error.status === 403) {
                            deferral.reject(
                                signalR._.transportError(
                                    signalR._.format(signalR.resources.pingServerFailedStatusCode, error.status),
                                    connection.transport,
                                    error,
                                    xhr
                                )
                            );
                            connection.stop();
                        }
                        else {
                            deferral.reject(
                                signalR._.transportError(
                                    signalR.resources.pingServerFailed,
                                    connection.transport,
                                    error,
                                    xhr
                                )
                            );
                        }
                    }
                });
            }
            else {
                deferral.reject(
                    signalR._.transportError(
                        signalR.resources.noConnectionTransport,
                        connection.transport
                    )
                );
            }

            return deferral.promise();
        },

        prepareQueryString: function (connection, url) {
            var preparedUrl;

            // Use addQs to start since it handles the ?/& prefix for us
            preparedUrl = transportLogic.addQs(url, "clientProtocol=" + connection.clientProtocol);

            // Add the user-specified query string params if any
            preparedUrl = transportLogic.addQs(preparedUrl, connection.qs);

            if (connection.token) {
                preparedUrl += "&connectionToken=" + window.encodeURIComponent(connection.token);
            }

            if (connection.data) {
                preparedUrl += "&connectionData=" + window.encodeURIComponent(connection.data);
            }

            return preparedUrl;
        },

        addQs: function (url, qs) {
            var appender = url.indexOf("?") !== -1 ? "&" : "?",
                firstChar;

            if (!qs) {
                return url;
            }

            if (typeof (qs) === "object") {
                return url + appender + $.param(qs);
            }

            if (typeof (qs) === "string") {
                firstChar = qs.charAt(0);

                if (firstChar === "?" || firstChar === "&") {
                    appender = "";
                }

                return url + appender + qs;
            }

            throw new Error("Query string property must be either a string or object.");
        },

        // BUG #2953: The url needs to be same otherwise it will cause a memory leak
        getUrl: function (connection, transport, reconnecting, poll, ajaxPost) {
            /// <summary>Gets the url for making a GET based connect request</summary>
            var baseUrl = transport === "webSockets" ? "" : connection.baseUrl,
                url = baseUrl + connection.appRelativeUrl,
                qs = "transport=" + transport;

            if (!ajaxPost && connection.groupsToken) {
                qs += "&groupsToken=" + window.encodeURIComponent(connection.groupsToken);
            }

            if (!reconnecting) {
                url += "/connect";
            } else {
                if (poll) {
                    // longPolling transport specific
                    url += "/poll";
                } else {
                    url += "/reconnect";
                }

                if (!ajaxPost && connection.messageId) {
                    qs += "&messageId=" + window.encodeURIComponent(connection.messageId);
                }
            }
            url += "?" + qs;
            url = transportLogic.prepareQueryString(connection, url);

            if (!ajaxPost) {
                url += "&tid=" + Math.floor(Math.random() * 11);
            }

            return url;
        },

        maximizePersistentResponse: function (minPersistentResponse) {
            return {
                MessageId: minPersistentResponse.C,
                Messages: minPersistentResponse.M,
                Initialized: typeof (minPersistentResponse.S) !== "undefined" ? true : false,
                ShouldReconnect: typeof (minPersistentResponse.T) !== "undefined" ? true : false,
                LongPollDelay: minPersistentResponse.L,
                GroupsToken: minPersistentResponse.G
            };
        },

        updateGroups: function (connection, groupsToken) {
            if (groupsToken) {
                connection.groupsToken = groupsToken;
            }
        },

        stringifySend: function (connection, message) {
            if (typeof (message) === "string" || typeof (message) === "undefined" || message === null) {
                return message;
            }
            return connection.json.stringify(message);
        },

        ajaxSend: function (connection, data) {
            var payload = transportLogic.stringifySend(connection, data),
                url = getAjaxUrl(connection, "/send"),
                xhr,
                onFail = function (error, connection) {
                    $(connection).triggerHandler(events.onError, [signalR._.transportError(signalR.resources.sendFailed, connection.transport, error, xhr), data]);
                };


            xhr = transportLogic.ajax(connection, {
                url: url,
                type: connection.ajaxDataType === "jsonp" ? "GET" : "POST",
                contentType: signalR._.defaultContentType,
                data: {
                    data: payload
                },
                success: function (result) {
                    var res;

                    if (result) {
                        try {
                            res = connection._parseResponse(result);
                        }
                        catch (error) {
                            onFail(error, connection);
                            connection.stop();
                            return;
                        }

                        transportLogic.triggerReceived(connection, res);
                    }
                },
                error: function (error, textStatus) {
                    if (textStatus === "abort" || textStatus === "parsererror") {
                        // The parsererror happens for sends that don't return any data, and hence
                        // don't write the jsonp callback to the response. This is harder to fix on the server
                        // so just hack around it on the client for now.
                        return;
                    }

                    onFail(error, connection);
                }
            });

            return xhr;
        },

        ajaxAbort: function (connection, async) {
            if (typeof (connection.transport) === "undefined") {
                return;
            }

            // Async by default unless explicitly overidden
            async = typeof async === "undefined" ? true : async;

            var url = getAjaxUrl(connection, "/abort");

            transportLogic.ajax(connection, {
                url: url,
                async: async,
                timeout: 1000,
                type: "POST"
            });

            connection.log("Fired ajax abort async = " + async + ".");
        },

        ajaxStart: function (connection, onSuccess) {
            var rejectDeferred = function (error) {
                    var deferred = connection._deferral;
                    if (deferred) {
                        deferred.reject(error);
                    }
                },
                triggerStartError = function (error) {
                    connection.log("The start request failed. Stopping the connection.");
                    $(connection).triggerHandler(events.onError, [error]);
                    rejectDeferred(error);
                    connection.stop();
                };

            connection._.startRequest = transportLogic.ajax(connection, {
                url: getAjaxUrl(connection, "/start"),
                success: function (result, statusText, xhr) {
                    var data;

                    try {
                        data = connection._parseResponse(result);
                    } catch (error) {
                        triggerStartError(signalR._.error(
                            signalR._.format(signalR.resources.errorParsingStartResponse, result),
                            error, xhr));
                        return;
                    }

                    if (data.Response === "started") {
                        onSuccess();
                    } else {
                        triggerStartError(signalR._.error(
                            signalR._.format(signalR.resources.invalidStartResponse, result),
                            null /* error */, xhr));
                    }
                },
                error: function (xhr, statusText, error) {
                    if (statusText !== startAbortText) {
                        triggerStartError(signalR._.error(
                            signalR.resources.errorDuringStartRequest,
                            error, xhr));
                    } else {
                        // Stop has been called, no need to trigger the error handler
                        // or stop the connection again with onStartError
                        connection.log("The start request aborted because connection.stop() was called.");
                        rejectDeferred(signalR._.error(
                            signalR.resources.stoppedDuringStartRequest,
                            null /* error */, xhr));
                    }
                }
            });
        },

        tryAbortStartRequest: function (connection) {
            if (connection._.startRequest) {
                // If the start request has already completed this will noop.
                connection._.startRequest.abort(startAbortText);
                delete connection._.startRequest;
            }
        },

        tryInitialize: function (connection, persistentResponse, onInitialized) {
            if (persistentResponse.Initialized && onInitialized) {
                onInitialized();
            } else if (persistentResponse.Initialized) {
                connection.log("WARNING! The client received an init message after reconnecting.");
            }

        },

        triggerReceived: function (connection, data) {
            if (!connection._.connectingMessageBuffer.tryBuffer(data)) {
                $(connection).triggerHandler(events.onReceived, [data]);
            }
        },

        processMessages: function (connection, minData, onInitialized) {
            var data;

            // Update the last message time stamp
            transportLogic.markLastMessage(connection);

            if (minData) {
                data = transportLogic.maximizePersistentResponse(minData);

                transportLogic.updateGroups(connection, data.GroupsToken);

                if (data.MessageId) {
                    connection.messageId = data.MessageId;
                }

                if (data.Messages) {
                    $.each(data.Messages, function (index, message) {
                        transportLogic.triggerReceived(connection, message);
                    });

                    transportLogic.tryInitialize(connection, data, onInitialized);
                }
            }
        },

        monitorKeepAlive: function (connection) {
            var keepAliveData = connection._.keepAliveData;

            // If we haven't initiated the keep alive timeouts then we need to
            if (!keepAliveData.monitoring) {
                keepAliveData.monitoring = true;

                transportLogic.markLastMessage(connection);

                // Save the function so we can unbind it on stop
                connection._.keepAliveData.reconnectKeepAliveUpdate = function () {
                    // Mark a new message so that keep alive doesn't time out connections
                    transportLogic.markLastMessage(connection);
                };

                // Update Keep alive on reconnect
                $(connection).on(events.onReconnect, connection._.keepAliveData.reconnectKeepAliveUpdate);

                connection.log("Now monitoring keep alive with a warning timeout of " + keepAliveData.timeoutWarning + ", keep alive timeout of " + keepAliveData.timeout + " and disconnecting timeout of " + connection.disconnectTimeout);
            } else {
                connection.log("Tried to monitor keep alive but it's already being monitored.");
            }
        },

        stopMonitoringKeepAlive: function (connection) {
            var keepAliveData = connection._.keepAliveData;

            // Only attempt to stop the keep alive monitoring if its being monitored
            if (keepAliveData.monitoring) {
                // Stop monitoring
                keepAliveData.monitoring = false;

                // Remove the updateKeepAlive function from the reconnect event
                $(connection).off(events.onReconnect, connection._.keepAliveData.reconnectKeepAliveUpdate);

                // Clear all the keep alive data
                connection._.keepAliveData = {};
                connection.log("Stopping the monitoring of the keep alive.");
            }
        },

        startHeartbeat: function (connection) {
            connection._.lastActiveAt = new Date().getTime();
            beat(connection);
        },

        markLastMessage: function (connection) {
            connection._.lastMessageAt = new Date().getTime();
        },

        markActive: function (connection) {
            if (transportLogic.verifyLastActive(connection)) {
                connection._.lastActiveAt = new Date().getTime();
                return true;
            }

            return false;
        },

        isConnectedOrReconnecting: function (connection) {
            return connection.state === signalR.connectionState.connected ||
                   connection.state === signalR.connectionState.reconnecting;
        },

        ensureReconnectingState: function (connection) {
            if (changeState(connection,
                        signalR.connectionState.connected,
                        signalR.connectionState.reconnecting) === true) {
                $(connection).triggerHandler(events.onReconnecting);
            }
            return connection.state === signalR.connectionState.reconnecting;
        },

        clearReconnectTimeout: function (connection) {
            if (connection && connection._.reconnectTimeout) {
                window.clearTimeout(connection._.reconnectTimeout);
                delete connection._.reconnectTimeout;
            }
        },

        verifyLastActive: function (connection) {
            if (new Date().getTime() - connection._.lastActiveAt >= connection.reconnectWindow) {
                var message = signalR._.format(signalR.resources.reconnectWindowTimeout, new Date(connection._.lastActiveAt), connection.reconnectWindow);
                connection.log(message);
                $(connection).triggerHandler(events.onError, [signalR._.error(message, /* source */ "TimeoutException")]);
                connection.stop(/* async */ false, /* notifyServer */ false);
                return false;
            }

            return true;
        },

        reconnect: function (connection, transportName) {
            var transport = signalR.transports[transportName];

            // We should only set a reconnectTimeout if we are currently connected
            // and a reconnectTimeout isn't already set.
            if (transportLogic.isConnectedOrReconnecting(connection) && !connection._.reconnectTimeout) {
                // Need to verify before the setTimeout occurs because an application sleep could occur during the setTimeout duration.
                if (!transportLogic.verifyLastActive(connection)) {
                    return;
                }

                connection._.reconnectTimeout = window.setTimeout(function () {
                    if (!transportLogic.verifyLastActive(connection)) {
                        return;
                    }

                    transport.stop(connection);

                    if (transportLogic.ensureReconnectingState(connection)) {
                        connection.log(transportName + " reconnecting.");
                        transport.start(connection);
                    }
                }, connection.reconnectDelay);
            }
        },

        handleParseFailure: function (connection, result, error, onFailed, context) {
            var wrappedError = signalR._.transportError(
                signalR._.format(signalR.resources.parseFailed, result),
                connection.transport,
                error,
                context);

            // If we're in the initialization phase trigger onFailed, otherwise stop the connection.
            if (onFailed && onFailed(wrappedError)) {
                connection.log("Failed to parse server response while attempting to connect.");
            } else {
                $(connection).triggerHandler(events.onError, [wrappedError]);
                connection.stop();
            }
        },

        initHandler: function (connection) {
            return new InitHandler(connection);
        },

        foreverFrame: {
            count: 0,
            connections: {}
        }
    };

}(window.jQuery, window));
/* jquery.signalR.transports.webSockets.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/*global window:false */
/// <reference path="jquery.signalR.transports.common.js" />

(function ($, window, undefined) {

    var signalR = $.signalR,
        events = $.signalR.events,
        changeState = $.signalR.changeState,
        transportLogic = signalR.transports._logic;

    signalR.transports.webSockets = {
        name: "webSockets",

        supportsKeepAlive: function () {
            return true;
        },

        send: function (connection, data) {
            var payload = transportLogic.stringifySend(connection, data);

            try {
                connection.socket.send(payload);
            } catch (ex) {
                $(connection).triggerHandler(events.onError,
                    [signalR._.transportError(
                        signalR.resources.webSocketsInvalidState,
                        connection.transport,
                        ex,
                        connection.socket
                    ),
                    data]);
            }
        },

        start: function (connection, onSuccess, onFailed) {
            var url,
                opened = false,
                that = this,
                reconnecting = !onSuccess,
                $connection = $(connection);

            if (!window.WebSocket) {
                onFailed();
                return;
            }

            if (!connection.socket) {
                if (connection.webSocketServerUrl) {
                    url = connection.webSocketServerUrl;
                } else {
                    url = connection.wsProtocol + connection.host;
                }

                url += transportLogic.getUrl(connection, this.name, reconnecting);

                connection.log("Connecting to websocket endpoint '" + url + "'.");
                connection.socket = new window.WebSocket(url);

                connection.socket.onopen = function () {
                    opened = true;
                    connection.log("Websocket opened.");

                    transportLogic.clearReconnectTimeout(connection);

                    if (changeState(connection,
                                    signalR.connectionState.reconnecting,
                                    signalR.connectionState.connected) === true) {
                        $connection.triggerHandler(events.onReconnect);
                    }
                };

                connection.socket.onclose = function (event) {
                    var error;

                    // Only handle a socket close if the close is from the current socket.
                    // Sometimes on disconnect the server will push down an onclose event
                    // to an expired socket.

                    if (this === connection.socket) {
                        if (opened && typeof event.wasClean !== "undefined" && event.wasClean === false) {
                            // Ideally this would use the websocket.onerror handler (rather than checking wasClean in onclose) but
                            // I found in some circumstances Chrome won't call onerror. This implementation seems to work on all browsers.
                            error = signalR._.transportError(
                                signalR.resources.webSocketClosed,
                                connection.transport,
                                event);

                            connection.log("Unclean disconnect from websocket: " + (event.reason || "[no reason given]."));
                        } else {
                            connection.log("Websocket closed.");
                        }

                        if (!onFailed || !onFailed(error)) {
                            if (error) {
                                $(connection).triggerHandler(events.onError, [error]);
                            }

                            that.reconnect(connection);
                        }
                    }
                };

                connection.socket.onmessage = function (event) {
                    var data;

                    try {
                        data = connection._parseResponse(event.data);
                    }
                    catch (error) {
                        transportLogic.handleParseFailure(connection, event.data, error, onFailed, event);
                        return;
                    }

                    if (data) {
                        // data.M is PersistentResponse.Messages
                        if ($.isEmptyObject(data) || data.M) {
                            transportLogic.processMessages(connection, data, onSuccess);
                        } else {
                            // For websockets we need to trigger onReceived
                            // for callbacks to outgoing hub calls.
                            transportLogic.triggerReceived(connection, data);
                        }
                    }
                };
            }
        },

        reconnect: function (connection) {
            transportLogic.reconnect(connection, this.name);
        },

        lostConnection: function (connection) {
            this.reconnect(connection);
        },

        stop: function (connection) {
            // Don't trigger a reconnect after stopping
            transportLogic.clearReconnectTimeout(connection);

            if (connection.socket) {
                connection.log("Closing the Websocket.");
                connection.socket.close();
                connection.socket = null;
            }
        },

        abort: function (connection, async) {
            transportLogic.ajaxAbort(connection, async);
        }
    };

}(window.jQuery, window));
/* jquery.signalR.transports.serverSentEvents.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/*global window:false */
/// <reference path="jquery.signalR.transports.common.js" />

(function ($, window, undefined) {

    var signalR = $.signalR,
        events = $.signalR.events,
        changeState = $.signalR.changeState,
        transportLogic = signalR.transports._logic,
        clearReconnectAttemptTimeout = function (connection) {
            window.clearTimeout(connection._.reconnectAttemptTimeoutHandle);
            delete connection._.reconnectAttemptTimeoutHandle;
        };

    signalR.transports.serverSentEvents = {
        name: "serverSentEvents",

        supportsKeepAlive: function () {
            return true;
        },

        timeOut: 3000,

        start: function (connection, onSuccess, onFailed) {
            var that = this,
                opened = false,
                $connection = $(connection),
                reconnecting = !onSuccess,
                url;

            if (connection.eventSource) {
                connection.log("The connection already has an event source. Stopping it.");
                connection.stop();
            }

            if (!window.EventSource) {
                if (onFailed) {
                    connection.log("This browser doesn't support SSE.");
                    onFailed();
                }
                return;
            }

            url = transportLogic.getUrl(connection, this.name, reconnecting);

            try {
                connection.log("Attempting to connect to SSE endpoint '" + url + "'.");
                connection.eventSource = new window.EventSource(url, { withCredentials: connection.withCredentials });
            }
            catch (e) {
                connection.log("EventSource failed trying to connect with error " + e.Message + ".");
                if (onFailed) {
                    // The connection failed, call the failed callback
                    onFailed();
                } else {
                    $connection.triggerHandler(events.onError, [signalR._.transportError(signalR.resources.eventSourceFailedToConnect, connection.transport, e)]);
                    if (reconnecting) {
                        // If we were reconnecting, rather than doing initial connect, then try reconnect again
                        that.reconnect(connection);
                    }
                }
                return;
            }

            if (reconnecting) {
                connection._.reconnectAttemptTimeoutHandle = window.setTimeout(function () {
                    if (opened === false) {
                        // If we're reconnecting and the event source is attempting to connect,
                        // don't keep retrying. This causes duplicate connections to spawn.
                        if (connection.eventSource.readyState !== window.EventSource.OPEN) {
                            // If we were reconnecting, rather than doing initial connect, then try reconnect again
                            that.reconnect(connection);
                        }
                    }
                },
                that.timeOut);
            }

            connection.eventSource.addEventListener("open", function (e) {
                connection.log("EventSource connected.");

                clearReconnectAttemptTimeout(connection);
                transportLogic.clearReconnectTimeout(connection);

                if (opened === false) {
                    opened = true;

                    if (changeState(connection,
                                         signalR.connectionState.reconnecting,
                                         signalR.connectionState.connected) === true) {
                        $connection.triggerHandler(events.onReconnect);
                    }
                }
            }, false);

            connection.eventSource.addEventListener("message", function (e) {
                var res;

                // process messages
                if (e.data === "initialized") {
                    return;
                }

                try {
                    res = connection._parseResponse(e.data);
                }
                catch (error) {
                    transportLogic.handleParseFailure(connection, e.data, error, onFailed, e);
                    return;
                }

                transportLogic.processMessages(connection, res, onSuccess);
            }, false);

            connection.eventSource.addEventListener("error", function (e) {
                var error = signalR._.transportError(
                    signalR.resources.eventSourceError,
                    connection.transport,
                    e);

                // Only handle an error if the error is from the current Event Source.
                // Sometimes on disconnect the server will push down an error event
                // to an expired Event Source.
                if (this !== connection.eventSource) {
                    return;
                }

                if (onFailed && onFailed(error)) {
                    return;
                }

                connection.log("EventSource readyState: " + connection.eventSource.readyState + ".");

                if (e.eventPhase === window.EventSource.CLOSED) {
                    // We don't use the EventSource's native reconnect function as it
                    // doesn't allow us to change the URL when reconnecting. We need
                    // to change the URL to not include the /connect suffix, and pass
                    // the last message id we received.
                    connection.log("EventSource reconnecting due to the server connection ending.");
                    that.reconnect(connection);
                } else {
                    // connection error
                    connection.log("EventSource error.");
                    $connection.triggerHandler(events.onError, [error]);
                }
            }, false);
        },

        reconnect: function (connection) {
            transportLogic.reconnect(connection, this.name);
        },

        lostConnection: function (connection) {
            this.reconnect(connection);
        },

        send: function (connection, data) {
            transportLogic.ajaxSend(connection, data);
        },

        stop: function (connection) {
            // Don't trigger a reconnect after stopping
            clearReconnectAttemptTimeout(connection);
            transportLogic.clearReconnectTimeout(connection);

            if (connection && connection.eventSource) {
                connection.log("EventSource calling close().");
                connection.eventSource.close();
                connection.eventSource = null;
                delete connection.eventSource;
            }
        },

        abort: function (connection, async) {
            transportLogic.ajaxAbort(connection, async);
        }
    };

}(window.jQuery, window));
/* jquery.signalR.transports.foreverFrame.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/*global window:false */
/// <reference path="jquery.signalR.transports.common.js" />

(function ($, window, undefined) {

    var signalR = $.signalR,
        events = $.signalR.events,
        changeState = $.signalR.changeState,
        transportLogic = signalR.transports._logic,
        createFrame = function () {
            var frame = window.document.createElement("iframe");
            frame.setAttribute("style", "position:absolute;top:0;left:0;width:0;height:0;visibility:hidden;");
            return frame;
        },
        // Used to prevent infinite loading icon spins in older versions of ie
        // We build this object inside a closure so we don't pollute the rest of
        // the foreverFrame transport with unnecessary functions/utilities.
        loadPreventer = (function () {
            var loadingFixIntervalId = null,
                loadingFixInterval = 1000,
                attachedTo = 0;

            return {
                prevent: function () {
                    // Prevent additional iframe removal procedures from newer browsers
                    if (signalR._.ieVersion <= 8) {
                        // We only ever want to set the interval one time, so on the first attachedTo
                        if (attachedTo === 0) {
                            // Create and destroy iframe every 3 seconds to prevent loading icon, super hacky
                            loadingFixIntervalId = window.setInterval(function () {
                                var tempFrame = createFrame();

                                window.document.body.appendChild(tempFrame);
                                window.document.body.removeChild(tempFrame);

                                tempFrame = null;
                            }, loadingFixInterval);
                        }

                        attachedTo++;
                    }
                },
                cancel: function () {
                    // Only clear the interval if there's only one more object that the loadPreventer is attachedTo
                    if (attachedTo === 1) {
                        window.clearInterval(loadingFixIntervalId);
                    }

                    if (attachedTo > 0) {
                        attachedTo--;
                    }
                }
            };
        })();

    signalR.transports.foreverFrame = {
        name: "foreverFrame",

        supportsKeepAlive: function () {
            return true;
        },

        // Added as a value here so we can create tests to verify functionality
        iframeClearThreshold: 50,

        start: function (connection, onSuccess, onFailed) {
            var that = this,
                frameId = (transportLogic.foreverFrame.count += 1),
                url,
                frame = createFrame(),
                frameLoadHandler = function () {
                    connection.log("Forever frame iframe finished loading and is no longer receiving messages.");
                    if (!onFailed || !onFailed()) {
                        that.reconnect(connection);
                    }
                };

            if (window.EventSource) {
                // If the browser supports SSE, don't use Forever Frame
                if (onFailed) {
                    connection.log("Forever Frame is not supported by SignalR on browsers with SSE support.");
                    onFailed();
                }
                return;
            }

            frame.setAttribute("data-signalr-connection-id", connection.id);

            // Start preventing loading icon
            // This will only perform work if the loadPreventer is not attached to another connection.
            loadPreventer.prevent();

            // Build the url
            url = transportLogic.getUrl(connection, this.name);
            url += "&frameId=" + frameId;

            // add frame to the document prior to setting URL to avoid caching issues.
            window.document.documentElement.appendChild(frame);

            connection.log("Binding to iframe's load event.");

            if (frame.addEventListener) {
                frame.addEventListener("load", frameLoadHandler, false);
            } else if (frame.attachEvent) {
                frame.attachEvent("onload", frameLoadHandler);
            }

            frame.src = url;
            transportLogic.foreverFrame.connections[frameId] = connection;

            connection.frame = frame;
            connection.frameId = frameId;

            if (onSuccess) {
                connection.onSuccess = function () {
                    connection.log("Iframe transport started.");
                    onSuccess();
                };
            }
        },

        reconnect: function (connection) {
            var that = this;

            // Need to verify connection state and verify before the setTimeout occurs because an application sleep could occur during the setTimeout duration.
            if (transportLogic.isConnectedOrReconnecting(connection) && transportLogic.verifyLastActive(connection)) {
                window.setTimeout(function () {
                    // Verify that we're ok to reconnect.
                    if (!transportLogic.verifyLastActive(connection)) {
                        return;
                    }

                    if (connection.frame && transportLogic.ensureReconnectingState(connection)) {
                        var frame = connection.frame,
                            src = transportLogic.getUrl(connection, that.name, true) + "&frameId=" + connection.frameId;
                        connection.log("Updating iframe src to '" + src + "'.");
                        frame.src = src;
                    }
                }, connection.reconnectDelay);
            }
        },

        lostConnection: function (connection) {
            this.reconnect(connection);
        },

        send: function (connection, data) {
            transportLogic.ajaxSend(connection, data);
        },

        receive: function (connection, data) {
            var cw,
                body,
                response;

            if (connection.json !== connection._originalJson) {
                // If there's a custom JSON parser configured then serialize the object
                // using the original (browser) JSON parser and then deserialize it using
                // the custom parser (connection._parseResponse does that). This is so we
                // can easily send the response from the server as "raw" JSON but still
                // support custom JSON deserialization in the browser.
                data = connection._originalJson.stringify(data);
            }

            response = connection._parseResponse(data);

            transportLogic.processMessages(connection, response, connection.onSuccess);

            // Protect against connection stopping from a callback trigger within the processMessages above.
            if (connection.state === $.signalR.connectionState.connected) {
                // Delete the script & div elements
                connection.frameMessageCount = (connection.frameMessageCount || 0) + 1;
                if (connection.frameMessageCount > signalR.transports.foreverFrame.iframeClearThreshold) {
                    connection.frameMessageCount = 0;
                    cw = connection.frame.contentWindow || connection.frame.contentDocument;
                    if (cw && cw.document && cw.document.body) {
                        body = cw.document.body;

                        // Remove all the child elements from the iframe's body to conserver memory
                        while (body.firstChild) {
                            body.removeChild(body.firstChild);
                        }
                    }
                }
            }
        },

        stop: function (connection) {
            var cw = null;

            // Stop attempting to prevent loading icon
            loadPreventer.cancel();

            if (connection.frame) {
                if (connection.frame.stop) {
                    connection.frame.stop();
                } else {
                    try {
                        cw = connection.frame.contentWindow || connection.frame.contentDocument;
                        if (cw.document && cw.document.execCommand) {
                            cw.document.execCommand("Stop");
                        }
                    }
                    catch (e) {
                        connection.log("Error occurred when stopping foreverFrame transport. Message = " + e.message + ".");
                    }
                }

                // Ensure the iframe is where we left it
                if (connection.frame.parentNode === window.document.documentElement) {
                    window.document.documentElement.removeChild(connection.frame);
                }

                delete transportLogic.foreverFrame.connections[connection.frameId];
                connection.frame = null;
                connection.frameId = null;
                delete connection.frame;
                delete connection.frameId;
                delete connection.onSuccess;
                delete connection.frameMessageCount;
                connection.log("Stopping forever frame.");
            }
        },

        abort: function (connection, async) {
            transportLogic.ajaxAbort(connection, async);
        },

        getConnection: function (id) {
            return transportLogic.foreverFrame.connections[id];
        },

        started: function (connection) {
            if (changeState(connection,
                signalR.connectionState.reconnecting,
                signalR.connectionState.connected) === true) {

                $(connection).triggerHandler(events.onReconnect);
            }
        }
    };

}(window.jQuery, window));
/* jquery.signalR.transports.longPolling.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/*global window:false */
/// <reference path="jquery.signalR.transports.common.js" />

(function ($, window, undefined) {

    var signalR = $.signalR,
        events = $.signalR.events,
        changeState = $.signalR.changeState,
        isDisconnecting = $.signalR.isDisconnecting,
        transportLogic = signalR.transports._logic;

    signalR.transports.longPolling = {
        name: "longPolling",

        supportsKeepAlive: function () {
            return false;
        },

        reconnectDelay: 3000,

        start: function (connection, onSuccess, onFailed) {
            /// <summary>Starts the long polling connection</summary>
            /// <param name="connection" type="signalR">The SignalR connection to start</param>
            var that = this,
                fireConnect = function () {
                    fireConnect = $.noop;

                    connection.log("LongPolling connected.");

                    if (onSuccess) {
                        onSuccess();
                    } else {
                        connection.log("WARNING! The client received an init message after reconnecting.");
                    }
                },
                tryFailConnect = function (error) {
                    if (onFailed(error)) {
                        connection.log("LongPolling failed to connect.");
                        return true;
                    }

                    return false;
                },
                privateData = connection._,
                reconnectErrors = 0,
                fireReconnected = function (instance) {
                    window.clearTimeout(privateData.reconnectTimeoutId);
                    privateData.reconnectTimeoutId = null;

                    if (changeState(instance,
                                    signalR.connectionState.reconnecting,
                                    signalR.connectionState.connected) === true) {
                        // Successfully reconnected!
                        instance.log("Raising the reconnect event");
                        $(instance).triggerHandler(events.onReconnect);
                    }
                },
                // 1 hour
                maxFireReconnectedTimeout = 3600000;

            if (connection.pollXhr) {
                connection.log("Polling xhr requests already exists, aborting.");
                connection.stop();
            }

            connection.messageId = null;

            privateData.reconnectTimeoutId = null;

            privateData.pollTimeoutId = window.setTimeout(function () {
                (function poll(instance, raiseReconnect) {
                    var messageId = instance.messageId,
                        connect = (messageId === null),
                        reconnecting = !connect,
                        polling = !raiseReconnect,
                        url = transportLogic.getUrl(instance, that.name, reconnecting, polling, true /* use Post for longPolling */),
                        postData = {};

                    if (instance.messageId) {
                        postData.messageId = instance.messageId;
                    }

                    if (instance.groupsToken) {
                        postData.groupsToken = instance.groupsToken;
                    }

                    // If we've disconnected during the time we've tried to re-instantiate the poll then stop.
                    if (isDisconnecting(instance) === true) {
                        return;
                    }

                    connection.log("Opening long polling request to '" + url + "'.");
                    instance.pollXhr = transportLogic.ajax(connection, {
                        xhrFields: {
                            onprogress: function () {
                                transportLogic.markLastMessage(connection);
                            }
                        },
                        url: url,
                        type: "POST",
                        contentType: signalR._.defaultContentType,
                        data: postData,
                        timeout: connection._.pollTimeout,
                        success: function (result) {
                            var minData,
                                delay = 0,
                                data,
                                shouldReconnect;

                            connection.log("Long poll complete.");

                            // Reset our reconnect errors so if we transition into a reconnecting state again we trigger
                            // reconnected quickly
                            reconnectErrors = 0;

                            try {
                                // Remove any keep-alives from the beginning of the result
                                minData = connection._parseResponse(result);
                            }
                            catch (error) {
                                transportLogic.handleParseFailure(instance, result, error, tryFailConnect, instance.pollXhr);
                                return;
                            }

                            // If there's currently a timeout to trigger reconnect, fire it now before processing messages
                            if (privateData.reconnectTimeoutId !== null) {
                                fireReconnected(instance);
                            }

                            if (minData) {
                                data = transportLogic.maximizePersistentResponse(minData);
                            }

                            transportLogic.processMessages(instance, minData, fireConnect);

                            if (data &&
                                typeof data.LongPollDelay === "number") {
                                delay = data.LongPollDelay;
                            }

                            if (isDisconnecting(instance) === true) {
                                return;
                            }

                            shouldReconnect = data && data.ShouldReconnect;
                            if (shouldReconnect) {
                                // Transition into the reconnecting state
                                // If this fails then that means that the user transitioned the connection into a invalid state in processMessages.
                                if (!transportLogic.ensureReconnectingState(instance)) {
                                    return;
                                }
                            }

                            // We never want to pass a raiseReconnect flag after a successful poll.  This is handled via the error function
                            if (delay > 0) {
                                privateData.pollTimeoutId = window.setTimeout(function () {
                                    poll(instance, shouldReconnect);
                                }, delay);
                            } else {
                                poll(instance, shouldReconnect);
                            }
                        },

                        error: function (data, textStatus) {
                            var error = signalR._.transportError(signalR.resources.longPollFailed, connection.transport, data, instance.pollXhr);

                            // Stop trying to trigger reconnect, connection is in an error state
                            // If we're not in the reconnect state this will noop
                            window.clearTimeout(privateData.reconnectTimeoutId);
                            privateData.reconnectTimeoutId = null;

                            if (textStatus === "abort") {
                                connection.log("Aborted xhr request.");
                                return;
                            }

                            if (!tryFailConnect(error)) {

                                // Increment our reconnect errors, we assume all errors to be reconnect errors
                                // In the case that it's our first error this will cause Reconnect to be fired
                                // after 1 second due to reconnectErrors being = 1.
                                reconnectErrors++;

                                if (connection.state !== signalR.connectionState.reconnecting) {
                                    connection.log("An error occurred using longPolling. Status = " + textStatus + ".  Response = " + data.responseText + ".");
                                    $(instance).triggerHandler(events.onError, [error]);
                                }

                                // We check the state here to verify that we're not in an invalid state prior to verifying Reconnect.
                                // If we're not in connected or reconnecting then the next ensureReconnectingState check will fail and will return.
                                // Therefore we don't want to change that failure code path.
                                if ((connection.state === signalR.connectionState.connected ||
                                    connection.state === signalR.connectionState.reconnecting) &&
                                    !transportLogic.verifyLastActive(connection)) {
                                    return;
                                }

                                // Transition into the reconnecting state
                                // If this fails then that means that the user transitioned the connection into the disconnected or connecting state within the above error handler trigger.
                                if (!transportLogic.ensureReconnectingState(instance)) {
                                    return;
                                }

                                // Call poll with the raiseReconnect flag as true after the reconnect delay
                                privateData.pollTimeoutId = window.setTimeout(function () {
                                    poll(instance, true);
                                }, that.reconnectDelay);
                            }
                        }
                    });

                    // This will only ever pass after an error has occurred via the poll ajax procedure.
                    if (reconnecting && raiseReconnect === true) {
                        // We wait to reconnect depending on how many times we've failed to reconnect.
                        // This is essentially a heuristic that will exponentially increase in wait time before
                        // triggering reconnected.  This depends on the "error" handler of Poll to cancel this
                        // timeout if it triggers before the Reconnected event fires.
                        // The Math.min at the end is to ensure that the reconnect timeout does not overflow.
                        privateData.reconnectTimeoutId = window.setTimeout(function () { fireReconnected(instance); }, Math.min(1000 * (Math.pow(2, reconnectErrors) - 1), maxFireReconnectedTimeout));
                    }
                }(connection));
            }, 250); // Have to delay initial poll so Chrome doesn't show loader spinner in tab
        },

        lostConnection: function (connection) {
            if (connection.pollXhr) {
                connection.pollXhr.abort("lostConnection");
            }
        },

        send: function (connection, data) {
            transportLogic.ajaxSend(connection, data);
        },

        stop: function (connection) {
            /// <summary>Stops the long polling connection</summary>
            /// <param name="connection" type="signalR">The SignalR connection to stop</param>

            window.clearTimeout(connection._.pollTimeoutId);
            window.clearTimeout(connection._.reconnectTimeoutId);

            delete connection._.pollTimeoutId;
            delete connection._.reconnectTimeoutId;

            if (connection.pollXhr) {
                connection.pollXhr.abort();
                connection.pollXhr = null;
                delete connection.pollXhr;
            }
        },

        abort: function (connection, async) {
            transportLogic.ajaxAbort(connection, async);
        }
    };

}(window.jQuery, window));
/* jquery.signalR.hubs.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.

/*global window:false */
/// <reference path="jquery.signalR.core.js" />

(function ($, window, undefined) {

    var eventNamespace = ".hubProxy",
        signalR = $.signalR;

    function makeEventName(event) {
        return event + eventNamespace;
    }

    // Equivalent to Array.prototype.map
    function map(arr, fun, thisp) {
        var i,
            length = arr.length,
            result = [];
        for (i = 0; i < length; i += 1) {
            if (arr.hasOwnProperty(i)) {
                result[i] = fun.call(thisp, arr[i], i, arr);
            }
        }
        return result;
    }

    function getArgValue(a) {
        return $.isFunction(a) ? null : (typeof a === "undefined" ? null : a);
    }

    function hasMembers(obj) {
        for (var key in obj) {
            // If we have any properties in our callback map then we have callbacks and can exit the loop via return
            if (obj.hasOwnProperty(key)) {
                return true;
            }
        }

        return false;
    }

    function clearInvocationCallbacks(connection, error) {
        /// <param name="connection" type="hubConnection" />
        var callbacks = connection._.invocationCallbacks,
            callback;

        if (hasMembers(callbacks)) {
            connection.log("Clearing hub invocation callbacks with error: " + error + ".");
        }

        // Reset the callback cache now as we have a local var referencing it
        connection._.invocationCallbackId = 0;
        delete connection._.invocationCallbacks;
        connection._.invocationCallbacks = {};

        // Loop over the callbacks and invoke them.
        // We do this using a local var reference and *after* we've cleared the cache
        // so that if a fail callback itself tries to invoke another method we don't
        // end up with its callback in the list we're looping over.
        for (var callbackId in callbacks) {
            callback = callbacks[callbackId];
            callback.method.call(callback.scope, { E: error });
        }
    }

    // hubProxy
    function hubProxy(hubConnection, hubName) {
        /// <summary>
        ///     Creates a new proxy object for the given hub connection that can be used to invoke
        ///     methods on server hubs and handle client method invocation requests from the server.
        /// </summary>
        return new hubProxy.fn.init(hubConnection, hubName);
    }

    hubProxy.fn = hubProxy.prototype = {
        init: function (connection, hubName) {
            this.state = {};
            this.connection = connection;
            this.hubName = hubName;
            this._ = {
                callbackMap: {}
            };
        },

        constructor: hubProxy,

        hasSubscriptions: function () {
            return hasMembers(this._.callbackMap);
        },

        on: function (eventName, callback) {
            /// <summary>Wires up a callback to be invoked when a invocation request is received from the server hub.</summary>
            /// <param name="eventName" type="String">The name of the hub event to register the callback for.</param>
            /// <param name="callback" type="Function">The callback to be invoked.</param>
            var that = this,
                callbackMap = that._.callbackMap;

            // Normalize the event name to lowercase
            eventName = eventName.toLowerCase();

            // If there is not an event registered for this callback yet we want to create its event space in the callback map.
            if (!callbackMap[eventName]) {
                callbackMap[eventName] = {};
            }

            // Map the callback to our encompassed function
            callbackMap[eventName][callback] = function (e, data) {
                callback.apply(that, data);
            };

            $(that).on(makeEventName(eventName), callbackMap[eventName][callback]);

            return that;
        },

        off: function (eventName, callback) {
            /// <summary>Removes the callback invocation request from the server hub for the given event name.</summary>
            /// <param name="eventName" type="String">The name of the hub event to unregister the callback for.</param>
            /// <param name="callback" type="Function">The callback to be invoked.</param>
            var that = this,
                callbackMap = that._.callbackMap,
                callbackSpace;

            // Normalize the event name to lowercase
            eventName = eventName.toLowerCase();

            callbackSpace = callbackMap[eventName];

            // Verify that there is an event space to unbind
            if (callbackSpace) {
                // Only unbind if there's an event bound with eventName and a callback with the specified callback
                if (callbackSpace[callback]) {
                    $(that).off(makeEventName(eventName), callbackSpace[callback]);

                    // Remove the callback from the callback map
                    delete callbackSpace[callback];

                    // Check if there are any members left on the event, if not we need to destroy it.
                    if (!hasMembers(callbackSpace)) {
                        delete callbackMap[eventName];
                    }
                } else if (!callback) { // Check if we're removing the whole event and we didn't error because of an invalid callback
                    $(that).off(makeEventName(eventName));

                    delete callbackMap[eventName];
                }
            }

            return that;
        },

        invoke: function (methodName) {
            /// <summary>Invokes a server hub method with the given arguments.</summary>
            /// <param name="methodName" type="String">The name of the server hub method.</param>

            var that = this,
                connection = that.connection,
                args = $.makeArray(arguments).slice(1),
                argValues = map(args, getArgValue),
                data = { H: that.hubName, M: methodName, A: argValues, I: connection._.invocationCallbackId },
                d = $.Deferred(),
                callback = function (minResult) {
                    var result = that._maximizeHubResponse(minResult),
                        source,
                        error;

                    // Update the hub state
                    $.extend(that.state, result.State);

                    if (result.Progress) {
                        if (d.notifyWith) {
                            // Progress is only supported in jQuery 1.7+
                            d.notifyWith(that, [result.Progress.Data]);
                        } else if(!connection._.progressjQueryVersionLogged) {
                            connection.log("A hub method invocation progress update was received but the version of jQuery in use (" + $.prototype.jquery + ") does not support progress updates. Upgrade to jQuery 1.7+ to receive progress notifications.");
                            connection._.progressjQueryVersionLogged = true;
                        }
                    } else if (result.Error) {
                        // Server hub method threw an exception, log it & reject the deferred
                        if (result.StackTrace) {
                            connection.log(result.Error + "\n" + result.StackTrace + ".");
                        }

                        // result.ErrorData is only set if a HubException was thrown
                        source = result.IsHubException ? "HubException" : "Exception";
                        error = signalR._.error(result.Error, source);
                        error.data = result.ErrorData;

                        connection.log(that.hubName + "." + methodName + " failed to execute. Error: " + error.message);
                        d.rejectWith(that, [error]);
                    } else {
                        // Server invocation succeeded, resolve the deferred
                        connection.log("Invoked " + that.hubName + "." + methodName);
                        d.resolveWith(that, [result.Result]);
                    }
                };

            connection._.invocationCallbacks[connection._.invocationCallbackId.toString()] = { scope: that, method: callback };
            connection._.invocationCallbackId += 1;

            if (!$.isEmptyObject(that.state)) {
                data.S = that.state;
            }

            connection.log("Invoking " + that.hubName + "." + methodName);
            connection.send(data);

            return d.promise();
        },

        _maximizeHubResponse: function (minHubResponse) {
            return {
                State: minHubResponse.S,
                Result: minHubResponse.R,
                Progress: minHubResponse.P ? {
                    Id: minHubResponse.P.I,
                    Data: minHubResponse.P.D
                } : null,
                Id: minHubResponse.I,
                IsHubException: minHubResponse.H,
                Error: minHubResponse.E,
                StackTrace: minHubResponse.T,
                ErrorData: minHubResponse.D
            };
        }
    };

    hubProxy.fn.init.prototype = hubProxy.fn;

    // hubConnection
    function hubConnection(url, options) {
        /// <summary>Creates a new hub connection.</summary>
        /// <param name="url" type="String">[Optional] The hub route url, defaults to "/signalr".</param>
        /// <param name="options" type="Object">[Optional] Settings to use when creating the hubConnection.</param>
        var settings = {
            qs: null,
            logging: false,
            useDefaultPath: true
        };

        $.extend(settings, options);

        if (!url || settings.useDefaultPath) {
            url = (url || "") + "/signalr";
        }
        return new hubConnection.fn.init(url, settings);
    }

    hubConnection.fn = hubConnection.prototype = $.connection();

    hubConnection.fn.init = function (url, options) {
        var settings = {
                qs: null,
                logging: false,
                useDefaultPath: true
            },
            connection = this;

        $.extend(settings, options);

        // Call the base constructor
        $.signalR.fn.init.call(connection, url, settings.qs, settings.logging);

        // Object to store hub proxies for this connection
        connection.proxies = {};

        connection._.invocationCallbackId = 0;
        connection._.invocationCallbacks = {};

        // Wire up the received handler
        connection.received(function (minData) {
            var data, proxy, dataCallbackId, callback, hubName, eventName;
            if (!minData) {
                return;
            }

            // We have to handle progress updates first in order to ensure old clients that receive
            // progress updates enter the return value branch and then no-op when they can't find
            // the callback in the map (because the minData.I value will not be a valid callback ID)
            if (typeof (minData.P) !== "undefined") {
                // Process progress notification
                dataCallbackId = minData.P.I.toString();
                callback = connection._.invocationCallbacks[dataCallbackId];
                if (callback) {
                    callback.method.call(callback.scope, minData);
                }
            } else if (typeof (minData.I) !== "undefined") {
                // We received the return value from a server method invocation, look up callback by id and call it
                dataCallbackId = minData.I.toString();
                callback = connection._.invocationCallbacks[dataCallbackId];
                if (callback) {
                    // Delete the callback from the proxy
                    connection._.invocationCallbacks[dataCallbackId] = null;
                    delete connection._.invocationCallbacks[dataCallbackId];

                    // Invoke the callback
                    callback.method.call(callback.scope, minData);
                }
            } else {
                data = this._maximizeClientHubInvocation(minData);

                // We received a client invocation request, i.e. broadcast from server hub
                connection.log("Triggering client hub event '" + data.Method + "' on hub '" + data.Hub + "'.");

                // Normalize the names to lowercase
                hubName = data.Hub.toLowerCase();
                eventName = data.Method.toLowerCase();

                // Trigger the local invocation event
                proxy = this.proxies[hubName];

                // Update the hub state
                $.extend(proxy.state, data.State);
                $(proxy).triggerHandler(makeEventName(eventName), [data.Args]);
            }
        });

        connection.error(function (errData, origData) {
            var callbackId, callback;

            if (!origData) {
                // No original data passed so this is not a send error
                return;
            }

            callbackId = origData.I;
            callback = connection._.invocationCallbacks[callbackId];

            // Verify that there is a callback bound (could have been cleared)
            if (callback) {
                // Delete the callback
                connection._.invocationCallbacks[callbackId] = null;
                delete connection._.invocationCallbacks[callbackId];

                // Invoke the callback with an error to reject the promise
                callback.method.call(callback.scope, { E: errData });
            }
        });

        connection.reconnecting(function () {
            if (connection.transport && connection.transport.name === "webSockets") {
                clearInvocationCallbacks(connection, "Connection started reconnecting before invocation result was received.");
            }
        });

        connection.disconnected(function () {
            clearInvocationCallbacks(connection, "Connection was disconnected before invocation result was received.");
        });
    };

    hubConnection.fn._maximizeClientHubInvocation = function (minClientHubInvocation) {
        return {
            Hub: minClientHubInvocation.H,
            Method: minClientHubInvocation.M,
            Args: minClientHubInvocation.A,
            State: minClientHubInvocation.S
        };
    };

    hubConnection.fn._registerSubscribedHubs = function () {
        /// <summary>
        ///     Sets the starting event to loop through the known hubs and register any new hubs
        ///     that have been added to the proxy.
        /// </summary>
        var connection = this;

        if (!connection._subscribedToHubs) {
            connection._subscribedToHubs = true;
            connection.starting(function () {
                // Set the connection's data object with all the hub proxies with active subscriptions.
                // These proxies will receive notifications from the server.
                var subscribedHubs = [];

                $.each(connection.proxies, function (key) {
                    if (this.hasSubscriptions()) {
                        subscribedHubs.push({ name: key });
                        connection.log("Client subscribed to hub '" + key + "'.");
                    }
                });

                if (subscribedHubs.length === 0) {
                    connection.log("No hubs have been subscribed to.  The client will not receive data from hubs.  To fix, declare at least one client side function prior to connection start for each hub you wish to subscribe to.");
                }

                connection.data = connection.json.stringify(subscribedHubs);
            });
        }
    };

    hubConnection.fn.createHubProxy = function (hubName) {
        /// <summary>
        ///     Creates a new proxy object for the given hub connection that can be used to invoke
        ///     methods on server hubs and handle client method invocation requests from the server.
        /// </summary>
        /// <param name="hubName" type="String">
        ///     The name of the hub on the server to create the proxy for.
        /// </param>

        // Normalize the name to lowercase
        hubName = hubName.toLowerCase();

        var proxy = this.proxies[hubName];
        if (!proxy) {
            proxy = hubProxy(this, hubName);
            this.proxies[hubName] = proxy;
        }

        this._registerSubscribedHubs();

        return proxy;
    };

    hubConnection.fn.init.prototype = hubConnection.fn;

    $.hubConnection = hubConnection;

}(window.jQuery, window));
/* jquery.signalR.version.js */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/*global window:false */
/// <reference path="jquery.signalR.core.js" />
(function ($, undefined) {
    $.signalR.version = "2.2.2";
}(window.jQuery));

/*!
 * ngToast v2.0.0 (http://tameraydin.github.io/ngToast)
 * Copyright 2016 Tamer Aydin (http://tamerayd.in)
 * Licensed under MIT (http://tameraydin.mit-license.org/)
 */

!function(a,b,c){"use strict";b.module("ngToast.provider",[]).provider("ngToast",[function(){function a(a){for(var d=Math.floor(1e3*Math.random());c.indexOf(d)>-1;)d=Math.floor(1e3*Math.random());this.id=d,this.count=0,this.animation=e.animation,this.className=e.className,this.additionalClasses=e.additionalClasses,this.dismissOnTimeout=e.dismissOnTimeout,this.timeout=e.timeout,this.dismissButton=e.dismissButton,this.dismissButtonHtml=e.dismissButtonHtml,this.dismissOnClick=e.dismissOnClick,this.onDismiss=e.onDismiss,this.compileContent=e.compileContent,b.extend(this,a)}var c=[],d=[],e={animation:!1,className:"success",additionalClasses:null,dismissOnTimeout:!0,timeout:4e3,dismissButton:!1,dismissButtonHtml:"&times;",dismissOnClick:!0,onDismiss:null,compileContent:!1,combineDuplications:!1,horizontalPosition:"right",verticalPosition:"top",maxNumber:0,newestOnTop:!0};this.configure=function(a){b.extend(e,a)},this.$get=[function(){var b=function(a,b){return b="object"==typeof b?b:{content:b},b.className=a,this.create(b)};return{settings:e,messages:c,dismiss:function(a){if(a){for(var b=c.length-1;b>=0;b--)if(c[b].id===a)return c.splice(b,1),void d.splice(d.indexOf(a),1)}else{for(;c.length>0;)c.pop();d=[]}},create:function(b){if(b="object"==typeof b?b:{content:b},e.combineDuplications)for(var f=d.length-1;f>=0;f--){var g=c[f],h=b.className||"success";if(g.content===b.content&&g.className===h)return void c[f].count++}e.maxNumber>0&&d.length>=e.maxNumber&&this.dismiss(d[0]);var i=new a(b);return c[e.newestOnTop?"unshift":"push"](i),d.push(i.id),i.id},success:function(a){return b.call(this,"success",a)},info:function(a){return b.call(this,"info",a)},warning:function(a){return b.call(this,"warning",a)},danger:function(a){return b.call(this,"danger",a)}}}]}])}(window,window.angular),function(a,b){"use strict";b.module("ngToast.directives",["ngToast.provider"]).run(["$templateCache",function(a){a.put("ngToast/toast.html",'<div class="ng-toast ng-toast--{{hPos}} ng-toast--{{vPos}} {{animation ? \'ng-toast--animate-\' + animation : \'\'}}"><ul class="ng-toast__list"><toast-message ng-repeat="message in messages" message="message" count="message.count"><span ng-bind-html="message.content"></span></toast-message></ul></div>'),a.put("ngToast/toastMessage.html",'<li class="ng-toast__message {{message.additionalClasses}}"ng-mouseenter="onMouseEnter()"ng-mouseleave="onMouseLeave()"><div class="alert alert-{{message.className}}" ng-class="{\'alert-dismissible\': message.dismissButton}"><button type="button" class="close" ng-if="message.dismissButton" ng-bind-html="message.dismissButtonHtml" ng-click="!message.dismissOnClick && dismiss()"></button><span ng-if="count" class="ng-toast__message__count">{{count + 1}}</span><span ng-if="!message.compileContent" ng-transclude></span></div></li>')}]).directive("toast",["ngToast","$templateCache","$log",function(a,b,c){return{replace:!0,restrict:"EA",templateUrl:"ngToast/toast.html",compile:function(d,e){if(e.template){var f=b.get(e.template);f?d.replaceWith(f):c.warn("ngToast: Provided template could not be loaded. Please be sure that it is populated before the <toast> element is represented.")}return function(b){b.hPos=a.settings.horizontalPosition,b.vPos=a.settings.verticalPosition,b.animation=a.settings.animation,b.messages=a.messages}}}}]).directive("toastMessage",["$timeout","$compile","ngToast",function(a,b,c){return{replace:!0,transclude:!0,restrict:"EA",scope:{message:"=",count:"="},controller:["$scope","ngToast",function(a,b){a.dismiss=function(){b.dismiss(a.message.id)}}],templateUrl:"ngToast/toastMessage.html",link:function(d,e,f,g,h){e.attr("data-message-id",d.message.id);var i,j=d.message.compileContent;if(d.cancelTimeout=function(){a.cancel(i)},d.startTimeout=function(){d.message.dismissOnTimeout&&(i=a(function(){c.dismiss(d.message.id)},d.message.timeout))},d.onMouseEnter=function(){d.cancelTimeout()},d.onMouseLeave=function(){d.startTimeout()},j){var k;h(d,function(a){k=a,e.children().append(k)}),a(function(){b(k.contents())("boolean"==typeof j?d.$parent:j,function(a){k.replaceWith(a)})},0)}d.startTimeout(),d.message.dismissOnClick&&e.bind("click",function(){c.dismiss(d.message.id),d.$apply()}),d.message.onDismiss&&d.$on("$destroy",d.message.onDismiss.bind(d.message))}}}])}(window,window.angular),function(a,b){"use strict";b.module("ngToast",["ngSanitize","ngToast.directives","ngToast.provider"])}(window,window.angular);
/**
 * I replaced <input type='date' /> with <input type='text'/> and added our datepicker-popup instead - JBT
 **/


/**
 * DynamicForms - Build Forms in AngularJS From Nothing But JSON
 * @version v0.0.2 - 2014-04-29
 * @link http://bitbucket.org/danhunsaker/angular-dynamic-forms
 * @license MIT, http://opensource.org/licenses/MIT
 */

/**
 * Dynamically build an HTML form using a JSON object as a template.
 *
 * @todo Properly describe this directive.
 * @param {Object} [template] - The form template itself, as an object.
 * @param {string} [templateUrl] - The URL to retrieve the form template from; template overrides.
 * @param {mixed} ngModel - An object in the current scope where the form data should be stored.
 * @example <dynamic-form template-url="form-template.js" ng-model="formData"></dynamic-form>
 */


angular.module('dynform', [])
//TODO: see if we can import modules (like dynform above) dynamically - JBT
.directive('dynamicForm', ['$q', '$parse', '$http', '$templateCache', '$compile', '$document', '$timeout', function ($q, $parse, $http, $templateCache, $compile, $document, $timeout) {
        var supported = {
            //  Text-based elements
            'text': {element: 'input', type: 'text', editable: true, textBased: true},
            'date': {element: 'input', type: 'text', editable: true, textBased: true},
            'datetime': {element: 'input', type: 'datetime', editable: true, textBased: true},
            'datetime-local': {element: 'input', type: 'datetime-local', editable: true, textBased: true},
            'email': {element: 'input', type: 'email', editable: true, textBased: true},
            'month': {element: 'input', type: 'month', editable: true, textBased: true},
            'number': {element: 'input', type: 'number', editable: true, textBased: true},
            'password': {element: 'input', type: 'password', editable: true, textBased: true},
            'search': {element: 'input', type: 'search', editable: true, textBased: true},
            'tel': {element: 'input', type: 'tel', editable: true, textBased: true},
            'textarea': {element: 'textarea', editable: true, textBased: true},
            'time': {element: 'input', type: 'time', editable: true, textBased: true},
            'url': {element: 'input', type: 'url', editable: true, textBased: true},
            'week': {element: 'input', type: 'week', editable: true, textBased: true},
            //  Specialized editables
            'checkbox': {element: 'input', type: 'checkbox', editable: true, textBased: false},
            'color': {element: 'input', type: 'color', editable: true, textBased: false},
            'file': {element: 'input', type: 'file', editable: true, textBased: false},
            'range': {element: 'input', type: 'range', editable: true, textBased: false},
            'select': {element: 'select', editable: true, textBased: false},
            //  Pseudo-non-editables (containers)
            'checklist': {element: 'div', editable: false, textBased: false},
            'fieldset': {element: 'fieldset', editable: false, textBased: false},
            'radio': {element: 'div', editable: false, textBased: false},
            //  Non-editables (mostly buttons)
            'button': {element: 'button', type: 'button', editable: false, textBased: false},
            'hidden': {element: 'input', type: 'hidden', editable: false, textBased: false},
            'image': {element: 'input', type: 'image', editable: false, textBased: false},
            'legend': {element: 'legend', editable: false, textBased: false},
            'reset': {element: 'button', type: 'reset', editable: false, textBased: false},
            'submit': {element: 'button', type: 'submit', editable: false, textBased: false}
        };

        return {
            restrict: 'E', // supports using directive as element only
            link: function ($scope, element, attrs) {
                //  Basic initialization
                var newElement = null,
                    newChild = null,
                    optGroups = {},
                    cbAtt = '',
                    foundOne = false,
                    iterElem = element,
                    model = null;

                //  Check that the required attributes are in place
                if (angular.isDefined(attrs.ngModel) && (angular.isDefined(attrs.template) || angular.isDefined(attrs.templateUrl)) && !element.hasClass('dynamic-form')) {
                    model = $parse(attrs.ngModel)($scope);
                    //  Grab the template. either from the template attribute, or from the URL in templateUrl
                    (attrs.template ? $q.when($parse(attrs.template)($scope)) :
                        $http.get(attrs.templateUrl, {cache: $templateCache}).then(function (result) {
                            return result.data;
                        })
                        ).then(function (template) {
                            var buildFields = function (field, id) {
                                if (!angular.isDefined(supported[field.type]) || supported[field.type] === false) {
                                    //  Unsupported.  Create SPAN with field.label as contents
                                    newElement = angular.element('<span></span>');
                                    if (angular.isDefined(field.label)) {angular.element(newElement).html(field.label);}
                                    angular.forEach(field, function (val, attr) {
                                        if (["label", "type"].indexOf(attr) > -1) {return;}
                                        newElement.attr(attr, val);
                                    });
                                    this.append(newElement);
                                    newElement = null;
                                }
                                else {
                                    //  Supported.  Create element (or container) according to type
                                    if (!angular.isDefined(field.model)) {
                                        field.model = id;
                                    }

                                    newElement = angular.element($document[0].createElement(supported[field.type].element));
                                    if (angular.isDefined(supported[field.type].type)) {
                                        newElement.attr('type', supported[field.type].type);
                                    }

                                    //  Editable fields (those that can feed models)
                                    if (angular.isDefined(supported[field.type].editable) && supported[field.type].editable) {
                                        newElement.attr('name', field.model);
                                        newElement.attr('ng-model', attrs.ngModel + "['" + field.model + "']");

                                        if (angular.isDefined(field.readonly)) {newElement.attr('ng-readonly', field.readonly);}
                                        if (angular.isDefined(field.required)) {newElement.attr('ng-required', field.required);}
                                        if (angular.isDefined(field.val)) {
                                            model[field.model] = angular.copy(field.val);
                                            newElement.attr('value', field.val);
                                        }
                                    }

                                    //  Fields based on input type=text
                                    if (angular.isDefined(supported[field.type].textBased) && supported[field.type].textBased) {
                                        if (angular.isDefined(field.minLength)) {newElement.attr('ng-minlength', field.minLength);}
                                        if (angular.isDefined(field.maxLength)) {newElement.attr('ng-maxlength', field.maxLength);}
                                        if (angular.isDefined(field.validate)) {newElement.attr('ng-pattern', field.validate);}
                                        if (angular.isDefined(field.placeholder)) {newElement.attr('placeholder', field.placeholder);}

                                        if (field.type === 'date') {newElement.attr('datepicker-popup', '').attr('is-open', 'isOpen').attr('ng-focus', 'isOpen = true').attr('max-date', 'null');}
                                    }

                                    //  Special cases
                                    if (field.type === 'number' || field.type === 'range') {
                                        if (angular.isDefined(field.minValue)) {newElement.attr('min', field.minValue);}
                                        if (angular.isDefined(field.maxValue)) {newElement.attr('max', field.maxValue);}
                                        if (angular.isDefined(field.step)) {newElement.attr('step', field.step);}
                                    }
                                    else if (['text', 'textarea'].indexOf(field.type) > -1) {
                                        if (angular.isDefined(field.splitBy)) {newElement.attr('ng-list', field.splitBy);}
                                    }
                                    else if (field.type === 'checkbox') {
                                        if (angular.isDefined(field.isOn)) {newElement.attr('ng-true-value', field.isOn);}
                                        if (angular.isDefined(field.isOff)) {newElement.attr('ng-false-value', field.isOff);}
                                        if (angular.isDefined(field.slaveTo)) {newElement.attr('ng-checked', field.slaveTo);}
                                    }
                                    else if (field.type === 'checklist') {
                                        if (angular.isDefined(field.val)) {model[field.model] = angular.copy(field.val);}
                                        if (angular.isDefined(field.options)) {
                                            if ( ! (angular.isDefined(model[field.model]) && angular.isObject(model[field.model]))) {model[field.model] = {};}
                                            angular.forEach(field.options, function (option, childId) {
                                                newChild = angular.element('<input type="checkbox" />');
                                                newChild.attr('name', field.model + '.' + childId);
                                                newChild.attr('ng-model', attrs.ngModel + "['" + field.model + "']" + "['" + childId + "']");
                                                if (angular.isDefined(option['class'])) {newChild.attr('ng-class', option['class']);}
                                                if (angular.isDefined(field.disabled)) {newChild.attr('ng-disabled', field.disabled);}
                                                if (angular.isDefined(field.readonly)) {newChild.attr('ng-readonly', field.readonly);}
                                                if (angular.isDefined(field.required)) {newChild.attr('ng-required', field.required);}
                                                if (angular.isDefined(field.callback)) {newChild.attr('ng-change', field.callback);}
                                                if (angular.isDefined(option.isOn)) {newChild.attr('ng-true-value', option.isOn);}
                                                if (angular.isDefined(option.isOff)) {newChild.attr('ng-false-value', option.isOff);}
                                                if (angular.isDefined(option.slaveTo)) {newChild.attr('ng-checked', option.slaveTo);}
                                                if (angular.isDefined(option.val)) {
                                                    model[field.model][childId] = angular.copy(option.val);
                                                    newChlid.attr('value', field.val);
                                                }

                                                if (angular.isDefined(option.label)) {
                                                    newChild = newChild.wrap('<label></label>').parent();
                                                    newChild.append(document.createTextNode(' ' + option.label));
                                                }
                                                newElement.append(newChild);
                                            });
                                        }
                                    }
                                    else if (field.type === 'radio') {
                                        if (angular.isDefined(field.val)) {model[field.model] = angular.copy(field.val);}
                                        if (angular.isDefined(field.values)) {
                                            angular.forEach(field.values, function (label, val) {
                                                newChild = angular.element('<input type="radio" />');
                                                newChild.attr('name', field.model);
                                                newChild.attr('ng-model', attrs.ngModel + "['" + field.model + "']");
                                                if (angular.isDefined(field['class'])) {newChild.attr('ng-class', field['class']);}
                                                if (angular.isDefined(field.disabled)) {newChild.attr('ng-disabled', field.disabled);}
                                                if (angular.isDefined(field.callback)) {newChild.attr('ng-change', field.callback);}
                                                if (angular.isDefined(field.readonly)) {newChild.attr('ng-readonly', field.readonly);}
                                                if (angular.isDefined(field.required)) {newChild.attr('ng-required', field.required);}
                                                newChild.attr('value', val);
                                                if (angular.isDefined(field.val) && field.val === val) {newChild.attr('checked', 'checked');}

                                                if (label) {
                                                    newChild = newChild.wrap('<label></label>').parent();
                                                    newChild.append(document.createTextNode(' ' + label));
                                                }
                                                newElement.append(newChild);
                                            });
                                        }
                                    }
                                    else if (field.type === 'select') {
                                        // add tooltip for multiple selections
                                        if (angular.isDefined(field.multiple) && field.multiple !== false) {
                                            newElement.attr('multiple', 'multiple');
                                        //    newElement.attr('tooltip', 'Hold CTRL to make multiple selections.');
                                        //    newElement.attr('tooltip-placement', 'top');
                                        //    newElement.attr('tooltip-trigger', 'focus');
                                        //    newElement.attr('tooltip-popup-delay', '500');
                                        }
                                        if (angular.isDefined(field.empty) && field.empty !== false) {newElement.append(angular.element($document[0].createElement('option')).attr('value', '').html(field.empty));}
                                        if (angular.isDefined(field.ngChange)) {
                                            newElement.attr('ng-change',field.ngChange); // added to monitor changes in controlling picklist values and to populate dependent lists based on this
                                        }
                                        if (angular.isDefined(field.autoOptions)) {
                                            newElement.attr('ng-options', field.autoOptions);
                                        }
                                        else if (angular.isDefined(field.options)) {
                                            angular.forEach(field.options, function (option, childId) {
                                                newChild = angular.element($document[0].createElement('option'));
                                                newChild.attr('value', childId);
                                                if (angular.isDefined(option.disabled)) {newChild.attr('ng-disabled', option.disabled);}
                                                if (angular.isDefined(option.slaveTo)) {newChild.attr('ng-selected', option.slaveTo);}
                                                if (angular.isDefined(option.label)) {newChild.html(option.label);}
                                                if (angular.isDefined(option.group)) {
                                                    if (!angular.isDefined(optGroups[option.group])) {
                                                        optGroups[option.group] = angular.element($document[0].createElement('optgroup'));
                                                        optGroups[option.group].attr('label', option.group);
                                                    }
                                                    optGroups[option.group].append(newChild);
                                                }
                                                else {
                                                    newElement.append(newChild);
                                                }
                                            });

                                            if (!angular.equals(optGroups, {})) {
                                                angular.forEach(optGroups, function (optGroup) {
                                                    newElement.append(optGroup);
                                                });
                                                optGroups = {};
                                            }
                                        }
                                    }
                                    else if (field.type === 'image') {
                                        if (angular.isDefined(field.label)) {newElement.attr('alt', field.label);}
                                        if (angular.isDefined(field.source)) {newElement.attr('src', field.source);}
                                    }
                                    else if (field.type === 'hidden') {
                                        newElement.attr('name', field.model);
                                        newElement.attr('ng-model', attrs.ngModel + "['" + field.model + "']");
                                        if (angular.isDefined(field.val)) {
                                            model[field.model] = angular.copy(field.val);
                                            newElement.attr('value', field.val);
                                        }
                                    }
                                    else if (field.type === 'file') {
                                        if (angular.isDefined(field.multiple)) {
                                            newElement.attr('multiple', field.multiple);
                                        }
                                    }
                                    else if (field.type === 'fieldset') {
                                        if (angular.isDefined(field.fields)) {
                                            var workingElement = newElement;
                                            angular.forEach(field.fields, buildFields, newElement);
                                            newElement = workingElement;
                                        }
                                    }

                                    //  Common attributes; radio already applied these...
                                    if (field.type !== "radio") {
                                        if (angular.isDefined(field['class'])) {newElement.attr('ng-class', field['class']);}
                                        //  ...and checklist has already applied these.
                                        if (field.type !== "checklist") {
                                            if (angular.isDefined(field.disabled)) {newElement.attr('ng-disabled', field.disabled);}
                                            if (angular.isDefined(field.callback)) {
                                                //  Some input types need listeners on click...
                                                if (["button", "fieldset", "image", "legend", "reset", "submit"].indexOf(field.type) > -1) {
                                                    cbAtt = 'ng-click';
                                                }
                                                //  ...the rest on change.
                                                else {
                                                    cbAtt = 'ng-change';
                                                }
                                                newElement.attr(cbAtt, field.callback);
                                            }
                                        }
                                    }

                                    //  If there's a label, add it.
                                    if (angular.isDefined(field.label)) {
                                        //  Some elements have already applied their labels.
                                        if (["image", "hidden"].indexOf(field.type) > -1) {
                                            angular.noop();
                                        }
                                        //  Fieldset elements put their labels in legend child elements.
                                        else if (["fieldset"].indexOf(field.type) > -1) {
                                            newElement.prepend(angular.element($document[0].createElement('legend')).html(field.label));
                                        }
                                        //  Button elements get their labels from their contents.
                                        else if (["button", "legend", "reset", "submit"].indexOf(field.type) > -1) {
                                            newElement.html(field.label);
                                        }
                                        //  Everything else should be wrapped in a label tag.
                                        else {
                                            newElement = newElement.wrap('<label></label>').parent();
                                            newElement.prepend(document.createTextNode(field.label + ' '));
                                        }
                                    }

                                    // Arbitrary attributes
                                    if (angular.isDefined(field.attributes)) {
                                        angular.forEach(field.attributes, function (val, attr) {
                                            newElement.attr(attr, val);
                                        });
                                    }

                                    // Add the element to the page
                                    this.append(newElement);
                                    newElement = null;
                                }
                            };

                            angular.forEach(template, buildFields, element);

                            //  Determine what tag name to use (ng-form if nested; form if outermost)
                            while (!angular.equals(iterElem.parent(), $document) && !angular.equals(iterElem.parent(), angular.element())) {
                                if (['form','ngForm','dynamicForm'].indexOf(attrs.$normalize(iterElem.parent()[0].nodeName.toLowerCase())) > -1) {
                                    foundOne = true;
                                    break;
                                }
                                iterElem = iterElem.parent();
                            }
                            if (foundOne) {
                                newElement = angular.element($document[0].createElement('ng-form'));
                            }
                            else {
                                newElement = angular.element("<form></form>");
                            }

                            //  Psuedo-transclusion
                            angular.forEach(attrs.$attr, function(attName, attIndex) {
                                newElement.attr(attName, attrs[attIndex]);
                            });
                            newElement.attr('model', attrs.ngModel);
                            newElement.removeAttr('ng-model');
                            angular.forEach(element[0].classList, function(clsName) {
                                newElement[0].classList.add(clsName);
                            });
                            newElement.addClass('dynamic-form');
                            // newElement.addClass('col-lg-6');
                            newElement.append(element.contents());

                            //  onReset logic
                            newElement.data('$_cleanModel', angular.copy(model));
                            newElement.bind('reset', function () {
                                $timeout(function () {
                                    $scope.$broadcast('reset', arguments);
                                }, 0);
                            });
                            $scope.$on('reset', function () {
                                $scope.$apply(function () {
                                    $scope[attrs.ngModel] = {};
                                });
                                $scope.$apply(function () {
                                    $scope[attrs.ngModel] = angular.copy(newElement.data('$_cleanModel'));
                                });
                            });

                            //  Compile and update DOM
                            $compile(newElement)($scope);
                            element.replaceWith(newElement);
                        });
                }
            }
        };
    }])
    //  Not a fan of how Angular's ngList is implemented, so here's a better one (IMO).  It will ONLY
    //  apply to <dynamic-form> child elements, and replaces the ngList that ships with Angular.
    .directive('ngList', [function () {
        return {
            require: '?ngModel',
            link: function (scope, element, attr, ctrl) {
                var match = /\/(.*)\//.exec(element.attr(attr.$attr.ngList)),
                    separator = match && new RegExp(match[1]) || element.attr(attr.$attr.ngList) || ',';

                if (element[0].form !== null && !angular.element(element[0].form).hasClass('dynamic-form')) {
                    return;
                }

                ctrl.$parsers.splice(0, 1);
                ctrl.$formatters.splice(0, 1);

                ctrl.$parsers.push(function(viewValue) {
                    var list = [];

                    if (angular.isString(viewValue)) {
                        //  Don't have Angular's trim() exposed, so let's simulate it:
                        if (String.prototype.trim) {
                            angular.forEach(viewValue.split(separator), function(value) {
                                if (value) list.push(value.trim());
                            });
                        }
                        else {
                            angular.forEach(viewValue.split(separator), function(value) {
                                if (value) list.push(value.replace(/^\s*/, '').replace(/\s*$/, ''));
                            });
                        }
                    }

                    return list;
                });

                ctrl.$formatters.push(function(val) {
                    var joinBy = angular.isString(separator) && separator || ', ';

                    if (angular.isArray(val)) {
                        return val.join(joinBy);
                    }

                    return undefined;
                });
            }
        };
    }])
    //  Following code was adapted from http://odetocode.com/blogs/scott/archive/2013/07/05/a-file-input-directive-for-angularjs.aspx
    .directive('dynamic-input', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, element, attrs, ctrl) {
                if (attrs.type === 'file') {
                    var modelGet = $parse(attrs.ngModel),
                        modelSet = modelGet.assign,
                        onChange = $parse(attrs.onChange),
                        updateModel = function () {
                            scope.$apply(function () {
                                modelSet(scope, element[0].files);
                                onChange(scope);
                            });
                        };

                    ctrl.$render = function () {
                        element[0].files = this.$viewValue;
                    };
                    element.bind('change', updateModel);
                }
                else if (attrs.type === 'range') {
                    ctrl.$parsers.push(function (val) {
                        if (val) {
                            return parseFloat(val);
                        }
                    });
                }
            }
        };
    }])
    //  Following code was adapted from http://odetocode.com/blogs/scott/archive/2013/07/03/building-a-filereader-service-for-angularjs-the-service.aspx
    .factory('fileReader', ['$q', function ($q) {
        var onLoad = function(reader, deferred, scope) {
                return function () {
                    scope.$apply(function () {
                        deferred.resolve(reader.result);
                    });
                };
            },
            onError = function (reader, deferred, scope) {
                return function () {
                    scope.$apply(function () {
                        deferred.reject(reader.error);
                    });
                };
            },
            onProgress = function(reader, scope) {
                return function (event) {
                    scope.$broadcast('fileProgress',
                        {
                            total: event.total,
                            loaded: event.loaded,
                            status: reader.readyState
                        });
                };
            },
            getReader = function(deferred, scope) {
                var reader = new FileReader();
                reader.onload = onLoad(reader, deferred, scope);
                reader.onerror = onError(reader, deferred, scope);
                reader.onprogress = onProgress(reader, scope);
                return reader;
            };

        return {
            readAsArrayBuffer: function (file, scope) {
                var deferred = $q.defer(),
                    reader = getReader(deferred, scope);
                reader.readAsArrayBuffer(file);
                return deferred.promise;
            },
            readAsBinaryString: function (file, scope) {
                var deferred = $q.defer(),
                    reader = getReader(deferred, scope);
                reader.readAsBinaryString(file);
                return deferred.promise;
            },
            readAsDataURL: function (file, scope) {
                var deferred = $q.defer(),
                    reader = getReader(deferred, scope);
                reader.readAsDataURL(file);
                return deferred.promise;
            },
            readAsText: function (file, scope) {
                var deferred = $q.defer(),
                    reader = getReader(deferred, scope);
                reader.readAsText(file);
                return deferred.promise;
            }
        };
    }]);

/*  End of dynamic-forms.js */

(function(w) {
    var Resolve = w.Resolve = function Resolve() {
        if(!(this instanceof Resolve)) return new Resolve();
    };

    Resolve.Color = w.ResolveColor = function ResolveColor(color) {
        if(!(this instanceof ResolveColor)) return new ResolveColor(color);
        if(color instanceof ResolveColor) return color;

        this.parse(color);
    };

    Resolve.Color.prototype = {
        set: function(r, g, b, a) {
            if(Array.isArray(r)) [r, g, b, a] = r;
            this.r = parseInt(r);
            this.g = parseInt(g);
            this.b = parseInt(b);
            this.a = a >= 0 ? parseFloat(a) : 1;
            return this;
        },
        parse: function(color) {
            color = (color || '').trim().toLowerCase();
            color = _colorsByName[color] || color;
            var hex3 = color.match(/^#([0-9a-f]{3})$/i);
            if (hex3) {
                hex3 = hex3[1];
                this.set(
                    parseInt(hex3.charAt(0),16)*0x11,
                    parseInt(hex3.charAt(1),16)*0x11,
                    parseInt(hex3.charAt(2),16)*0x11, 1
                );
            }
            var hex6 = color.match(/^#([0-9a-f]{6})$/i);
            if (hex6) {
                hex6 = hex6[1];
                this.set(
                    parseInt(hex6.substr(0,2),16),
                    parseInt(hex6.substr(2,2),16),
                    parseInt(hex6.substr(4,2),16), 1
                );
            }
            var rgba = color.match(/^rgb[a]?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*.*\d*)\s*)?\)$/i);
            if( rgba ) {
                return this.set(rgba[1],rgba[2],rgba[3], rgba[4]);
            }
            if(color.indexOf('hsl')== 0)
                return this.set(_hslToRgb(color));
        },
        isTransparent: function() {
            return !(parseFloat(this.a) > 0);
        },
        toString: function() {
            return (this.r && this.g && this.b && this.a) ?
                'rgba(' + (this.r || 0) + ',' + (this.g || 0) + ',' + (this.b || 0) + ',' + (this.a || 0) + ')'
                : '';
        },
        toHex: function() {
            var rgb = (this.b||0) | ((this.g||0) << 8) | ((this.r||0) << 16);
            return ('#' + (0x1000000 + rgb).toString(16).slice(1)).toUpperCase();
        }
    };

    function _hslToRgb(hsl){
        if(typeof hsl== 'string'){
            hsl= hsl.match(/(\d+(\.\d+)?)/g);
        }
        var sub, h= hsl[0]/360, s= hsl[1]/100, l= hsl[2]/100, a = hsl[3]===undefined?1:hsl[3], t1, t2, t3, rgb, val;
        if(s== 0){
            val= Math.round(l*255);
            rgb= [val, val, val, a];
        }
        else{
            if(l<0.5)
                t2= l*(1 + s);
            else
                t2= l + s - l*s;
            t1 = 2*l - t2;
            rgb = [0, 0, 0];
            for(var i=0; i<3; i++){
                t3 = h + 1/3 * -(i - 1);
                t3 < 0 && t3++;
                t3 > 1 && t3--;
                if (6 * t3 < 1)
                    val= t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1)
                    val= t2;
                else if (3*t3<2)
                    val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else
                    val= t1;
                rgb[i] = Math.round(val*255);
            }
        }
        rgb.push(a);
        return rgb;
    }
    var _colorsByName = {aliceblue:"#f0f8ff",antiquewhite:"#faebd7",aqua:"#00ffff",aquamarine:"#7fffd4",azure:"#f0ffff",beige:"#f5f5dc",bisque:"#ffe4c4",
        black:"#000000",blanchedalmond:"#ffebcd",blue:"#0000ff",blueviolet:"#8a2be2",brown:"#a52a2a",burlywood:"#deb887",cadetblue:"#5f9ea0",
        chartreuse:"#7fff00",chocolate:"#d2691e",coral:"#ff7f50",cornflowerblue:"#6495ed",cornsilk:"#fff8dc",crimson:"#dc143c",cyan:"#00ffff",
        darkblue:"#00008b",darkcyan:"#008b8b",darkgoldenrod:"#b8860b",darkgray:"#a9a9a9",darkgreen:"#006400",darkkhaki:"#bdb76b",
        darkmagenta:"#8b008b",darkolivegreen:"#556b2f",darkorange:"#ff8c00",darkorchid:"#9932cc",darkred:"#8b0000",darksalmon:"#e9967a",
        darkseagreen:"#8fbc8f",darkslateblue:"#483d8b",darkslategray:"#2f4f4f",darkturquoise:"#00ced1",darkviolet:"#9400d3",deeppink:"#ff1493",
        deepskyblue:"#00bfff",dimgray:"#696969",dodgerblue:"#1e90ff",firebrick:"#b22222",floralwhite:"#fffaf0",forestgreen:"#228b22",
        fuchsia:"#ff00ff",gainsboro:"#dcdcdc",ghostwhite:"#f8f8ff",gold:"#ffd700",goldenrod:"#daa520",gray:"#808080",green:"#008000",
        greenyellow:"#adff2f",honeydew:"#f0fff0",hotpink:"#ff69b4",indianred :"#cd5c5c",indigo :"#4b0082",ivory:"#fffff0",khaki:"#f0e68c",
        lavender:"#e6e6fa",lavenderblush:"#fff0f5",lawngreen:"#7cfc00",lemonchiffon:"#fffacd",lightblue:"#add8e6",lightcoral:"#f08080",
        lightcyan:"#e0ffff",lightgoldenrodyellow:"#fafad2",lightgray:"#d3d3d3",lightgreen:"#90ee90",lightpink:"#ffb6c1",lightsalmon:"#ffa07a",
        lightseagreen:"#20b2aa",lightskyblue:"#87cefa",lightslategray:"#778899",lightsteelblue:"#b0c4de",lightyellow:"#ffffe0",lime:"#00ff00",
        limegreen:"#32cd32",linen:"#faf0e6",magenta:"#ff00ff",maroon:"#800000",mediumaquamarine:"#66cdaa",mediumblue:"#0000cd",
        mediumorchid:"#ba55d3",mediumpurple:"#9370db",mediumseagreen:"#3cb371",mediumslateblue:"#7b68ee",mediumspringgreen:"#00fa9a",
        mediumturquoise:"#48d1cc",mediumvioletred:"#c71585",midnightblue:"#191970",mintcream:"#f5fffa",mistyrose:"#ffe4e1",moccasin:"#ffe4b5",
        navajowhite:"#ffdead",navy:"#000080",oldlace:"#fdf5e6",olive:"#808000",olivedrab:"#6b8e23",orange:"#ffa500",orangered:"#ff4500",
        orchid:"#da70d6",palegoldenrod:"#eee8aa",palegreen:"#98fb98",paleturquoise:"#afeeee",palevioletred:"#db7093",papayawhip:"#ffefd5",
        peachpuff:"#ffdab9",peru:"#cd853f",pink:"#ffc0cb",plum:"#dda0dd",powderblue:"#b0e0e6",purple:"#800080",red:"#ff0000",rosybrown:"#bc8f8f",
        royalblue:"#4169e1",saddlebrown:"#8b4513",salmon:"#fa8072",sandybrown:"#f4a460",seagreen:"#2e8b57",seashell:"#fff5ee",sienna:"#a0522d",
        silver:"#c0c0c0",skyblue:"#87ceeb",slateblue:"#6a5acd",slategray:"#708090",snow:"#fffafa",springgreen:"#00ff7f",steelblue:"#4682b4",
        tan:"#d2b48c",teal:"#008080",thistle:"#d8bfd8",tomato:"#ff6347",turquoise:"#40e0d0",violet:"#ee82ee",wheat:"#f5deb3",white:"#ffffff",
        whitesmoke:"#f5f5f5",yellow:"#ffff00",yellowgreen:"#9acd32"
    };

    // Extend Natives
    if(!DocumentFragment.prototype.innerHTML) {
        Object.defineProperty(DocumentFragment.prototype, 'innerHTML', {
            get: function() {
                var t = '', n = this.firstChild;
                while (n) { t += n.outerHTML || n.textContent; n = n.nextSibling; }
                return t;
            },
            set: function(value) {
                var range = document.createRange();
                range.selectNodeContents(this);
                range.deleteContents();
                range.insertNode(range.createContextualFragment(value));
            }
        })
    }
})(window);

(function(Resolve, w, d) {
    const commands = [];

    const ResolveCommand = w.ResolveCommand = Resolve.Command = function ResolveCommand(key) {
        if ( !(this instanceof ResolveCommand) )
            return new ResolveCommand(key);

        var config = commands.find(function(c){return c.key === key});
        if(!config) {
            throw "Not a valid command key";
        }

        this.key = config.key;
        this.image = config.image;
        this.control = config.control;
        this.type = config.type;
        this.header = config.header;
        this.options = config.options;
        this.units = config.units;
        this.value = undefined;
    };


    // INLINE
    ResolveCommand.BACK_COLOR               = 'backColor';
    ResolveCommand.BOLD                     = 'bold';
    ResolveCommand.ITALIC                   = 'italic';
    ResolveCommand.CREATE_LINK              = 'createLink';
    ResolveCommand.FONT_NAME                = 'fontName';
    ResolveCommand.FONT_SIZE                = 'fontSize';
    ResolveCommand.FORE_COLOR               = 'foreColor';
    ResolveCommand.STRIKETHROUGH            = 'strikethrough';
    ResolveCommand.SUBSCRIPT                = 'subscript';
    ResolveCommand.SUPERSCRIPT              = 'superscript';
    ResolveCommand.UNDERLINE                = 'underline';
    ResolveCommand.UNLINK                   = 'unlink';

    // BLOCK
    ResolveCommand.DELETE                   = 'delete';
    ResolveCommand.FORMAT_BLOCK             = 'formatBlock';
    ResolveCommand.FORWARD_DELETE           = 'forwardDelete';
    ResolveCommand.INSERT_HORIZONTAL_RULE   = 'insertHorizontalRule';
    ResolveCommand.INSERT_HTML              = 'insertHTML';
    ResolveCommand.INSERT_IMAGE             = 'insertImage';
    ResolveCommand.INSERT_LINE_BREAK        = 'insertLineBreak';
    ResolveCommand.INSERT_ORDERED_LIST      = 'insertOrderedList';
    ResolveCommand.INSERT_PARAGRAPH         = 'insertParagraph';
    ResolveCommand.INSERT_TEXT              = 'insertText';
    ResolveCommand.INSERT_UNORDERED_LIST    = 'insertUnorderedList';
    ResolveCommand.JUSTIFY_CENTER           = 'justifyCenter';
    ResolveCommand.JUSTIFY_FULL             = 'justifyFull';
    ResolveCommand.JUSTIFY_LEFT             = 'justifyLeft';
    ResolveCommand.JUSTIFY_RIGHT            = 'justifyRight';
    ResolveCommand.OUTDENT                  = 'outdent';
    ResolveCommand.REMOVE_FORMAT            = 'removeFormat';

    commands.push({
        "key": ResolveCommand.FONT_NAME,
        "control": "select",
        "type": "inline",
        "header": "- font -",
        "options": {
            "Arial": "Arial",
            "Arial Black": "Arial Black",
            "Cambria": "Cambria",
            "Courier New": "Courier New",
            "Tahoma": "Tahoma",
            "Times New Roman": "Times New Roman",
            "Verdana": "Verdana"
        }
    });

    commands.push({
        "key": ResolveCommand.FONT_SIZE,
        "control": "select",
        "type": "inline",
        "header": "- size -",
        "units": {
            'pt': "PT",
            'px': "PX",
        },
        "options": {
            "6": "6",
            "7": "7",
            "8": "8",
            "9": "9",
            "10": "10",
            "11": "11",
            "12": "12",
            "13": "13",
            "14": "14",
            "15": "15",
            "20": "20",
            "25": "25",
            "30": "30",
            "35": "35",
            "40": "40"
        }
    });

    commands.push({
        "label": "Bold",
        "key": ResolveCommand.BOLD,
        "control": "button",
        "type": "inline",
        "image": "bold"
    });

    commands.push({
        "label": "Italic",
        "key": ResolveCommand.ITALIC,
        "control": "button",
        "type": "inline",
        "image": "italic"
    });

    commands.push({
        "label": "Underline",
        "key": ResolveCommand.UNDERLINE,
        "control": "button",
        "type": "inline",
        "image": "underline"
    });

    commands.push({
        "label": "Left align",
        "key": ResolveCommand.JUSTIFY_LEFT,
        "control": "button",
        "type": "block",
        "image": "align-left"
    });

    commands.push({
        "label": "Center align",
        "key": ResolveCommand.JUSTIFY_CENTER,
        "control": "button",
        "type": "block",
        "image": "align-center"
    });

    commands.push({
        "label": "Right align",
        "key": ResolveCommand.JUSTIFY_RIGHT,
        "control": "button",
        "type": "block",
        "image": "align-right"
    });

    commands.push({
        "label": "Remove formatting",
        "key": ResolveCommand.REMOVE_FORMAT,
        "control": "button",
        "type": "block",
        "image": "eraser"
    });

    commands.push({
        "label": "Text Color",
        "key": ResolveCommand.FORE_COLOR,
        "control": "colorpicker",
        "type": "inline"
    });

    commands.push({
        "label": "Strikethrough",
        "key": ResolveCommand.STRIKETHROUGH,
        "control": "button",
        "type": "inline",
        "image": "strikethrough"
    });

    commands.push({
        "label": "Subscript",
        "key": ResolveCommand.SUBSCRIPT,
        "control": "button",
        "type": "inline",
        "image": "subscript"
    });

    commands.push({
        "label": "Superscript",
        "key": ResolveCommand.SUPERSCRIPT,
        "control": "button",
        "type": "inline",
        "image": "superscript"
    });

})(Resolve, window, document);

(function(Resolve, w, d) {
    var semantics = {
        flow:           ['a', 'abbr', 'address', 'map > area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo',
            'blockquote', 'br', 'button', 'canvas', 'cite', 'code', 'data', 'datalist', 'del', 'dfn', 'div',
            'dl', 'em', 'embed', 'fieldset', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
            'header', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'main', 'map',
            'mark', 'math', 'meter', 'nav', 'noscript', 'object', 'ol', 'output', 'p', 'pre', 'progress',
            'q', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'span', 'strong', 'sub',
            'sup', 'svg', 'table', 'template', 'textarea', 'time', 'u', 'ul', 'var', 'video', 'wbr', 'text'],
        sectioning:     ['article', 'aside', 'nav', 'section'],
        heading:        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
        phrasing:       ['a', 'abbr', 'map > area', 'audio', 'b', 'bdi', 'bdo', 'br', 'button', 'canvas', 'cite', 'code',
            'data', 'datalist', 'del', 'dfn', 'em', 'embed', 'i', 'iframe', 'img', 'input', 'ins', 'kbd',
            'keygen', 'label', 'map', 'mark', 'math', 'meter', 'noscript', 'object', 'ol', 'output', 'progress',
            'q', 'ruby', 's', 'samp', 'script', 'select', 'small', 'span', 'strong', 'sub', 'sup', 'svg',
            'template', 'textarea', 'time', 'u', 'ul', 'var', 'video', 'wbr', 'text'],
        text:           ['text'],
        embedded:       ['audio', 'canvas', 'embed', 'iframe', 'img', 'math', 'object', 'svg', 'video'],
        interactive:    ['a', 'audio[controls]', 'button', 'embed', 'iframe', 'img[usemap]', 'input', 'keygen', 'label',
            'object[usemap]', 'select', 'textarea', 'video[controls]']
    };

    semantics._block = semantics.flow.filter(function(name) { return semantics.phrasing.indexOf(name) === -1 } );

    var ResolveNode = Resolve.Node = w.ResolveNode = function ResolveNode(node) {
        if(!(this instanceof ResolveNode)) return new ResolveNode(node);
        if(node instanceof ResolveNode) return node;
        if(typeof(node) === "string") node = document.createElement(node);
        this.node = node;
    };

    ResolveNode.prototype = {
        walker: function(config) {
            if(!config) config = {};
            config.node = this.node;
            return ResolveNode.walker(config);
        },
        length: function() {
            if(this.node instanceof Node) return this.node.length || this.node.childNodes.length
        },
        next: function(config) {
            return ResolveNode(this.walker(config).nextNode());
        },
        previous: function(config) {
            return ResolveNode(this.walker(config).previousNode());
        },
        nextSibling: function() {
            return ResolveNode(this.node.nextSibling);
        },
        previousSibling: function() {
            return ResolveNode(this.node.previousSibling);
        },
        getParent: function() {
            return ResolveNode(this.node.parentNode);
        },
        descendants: function(config) {
            if(!config) config = {};
            config.root = this.node;

            var walker = this.walker(config),
                nodes = [];
            while (walker.nextNode()) {
                nodes.push(walker.currentNode);
            }
            return nodes;
        },
        rangeDetail: function(range) { return ResolveNode.rangeDetail(this.node, range); },
        getElement: function() { return ResolveNode(ResolveNode.getElement(this.node)); },
        getPropertyValue: function(name) { return ResolveNode.getPropertyValue(this.node, name); },
        getResolvedValue: function(name) { return ResolveNode.getResolvedValue(this.node, name); },
        hasProperty: function(name) { return ResolveNode.hasProperty(this.node, name); },
        isElement: function(name) { return ResolveNode.isElement(this.node, name); },
        isNode: function() { return ResolveNode.isNode(this.node); },
        isBlock: function() { return ResolveNode.isBlock(this.node); },
        isInline: function() { return ResolveNode.isInline(this.node); },
        isName: function() { return ResolveNode.isName(this.node, Array.isArray(arguments[0]) ? arguments[0] : Array.from(arguments)); },
        isText: function() { return ResolveNode.isText(this.node); },
        getSpecifiedValue: function(property) {
            return ResolveNode[property] ? ResolveNode[property].getSpecified(this.node) : null;
        },
        getEffectiveValue: function(property) {
            return ResolveNode[property] ? ResolveNode[property].getEffective(this.node) : null;
        }
    };

    ResolveNode.isBlock = function(node) {
        var rn = ResolveNode(node);
        //console.log(rn.isNode(), rn.isName(semantics._block), node);
        return rn.isNode() && rn.isName(semantics._block);
    };

    ResolveNode.isInline = function(ref) {
        return !ResolveNode.isBlock(ref);
    };

    ResolveNode.isElement = function(node, name) {
        return node instanceof Element && (name === undefined || ResolveNode.isName(node, name));
    };

    ResolveNode.isBreak = function(node) {
        var rn = ResolveNode(node);
        return rn.isElement() && rn.isName('br');
    };

    ResolveNode.isNode = function(node) {
        return node instanceof Node;
    };

    ResolveNode.isEmpty = function(node) {
        return ResolveNode.getLength(node) === 0;
    };

    ResolveNode.getText = function(node) {
        return node.textContent;
    };

    ResolveNode.isText = function(node) {
        return node instanceof Node && node.nodeType === Node.TEXT_NODE;
    };

    ResolveNode.isWhitespace = function() {
        // TODO
    };

    ResolveNode.isCollapsed = function() {
        // TODO
    };

    ResolveNode.isVisible = function(node) {
        // TODO;
        /*var rn = ResolveNode(node);
        return rn.isNode() && rn.getResolvedValue('display') !== 'none' && (
            rn.isBlock() ||
            rn.isName('img') ||
            (rn.isText() && !rn.isCollapsed()) ||
            (rn.isName('br') && !rn.isCollapsed()) || // !extraneous lb
            rn.descendants().some(function(dn){return ResolveNode(dn).isVisible()})
        );*/
    };

    ResolveNode.isInvisible = function(node) {
        return !ResolveNode.isVisible(node);
    };

    ResolveNode.isModifiable = function() {
        // TODO
    };

    ResolveNode.isEditable = function(node) {
        // TODO
    };

    ResolveNode.isSimpleModifiable = function() {
        // TODO
        return ResolveNode.isModifiable() === 1;
    };

    ResolveNode.isFormattable = function(node) {
        return ResolveNode.isVisible(node) && ResolveNode.isEditable(node) && (
            ResolveNode.isText(node) || ResolveNode.isName(node, 'img', 'br')
        );
    };

    ResolveNode.isName = function(node) {
        if(node instanceof Node) {
            var names = Array.isArray(arguments[1]) ? arguments[1] : Array.from(arguments).slice(1),
                nodeName = node.nodeName.toUpperCase();
            return names.some(function(name){ return String(name).toUpperCase() === nodeName; });
        }
    };

    ResolveNode.hasProperty = function(node, name) {
        return (
            node instanceof Element &&
            node.hasAttribute('style') &&
            (Array.from(node.style).any(name) || (new RegExp('text-decoration', 'i')).test(node.style.cssText))
        );
    };

    ResolveNode.getPropertyValue = function(node, name) {
        return ResolveNode.hasProperty(node, name) ? node.style.getPropertyValue(name) : null;
    };

    ResolveNode.getResolvedValue = function(node, name) {
        return w.getComputedStyle(node).getPropertyValue(name)
    };

    ResolveNode.getElement = function(node) {
        if(node instanceof Node) {
            if(node instanceof Element) return node;
            if(node.parentNode instanceof Element) return node.parentNode;
        }
        return null;
    };

    ResolveNode.firstDescendant = function(node) {
        var rw = ResolveNode.walker({root: node});
        while(rw.firstChild()) {}
        return rw.currentNode;
    };

    ResolveNode.lastDescendant = function(node) {
        var rw = ResolveNode.walker({root: node});
        while(rw.lastChild()) {}
        return rw.currentNode;
    };


    /********************
     *  HELPERS         *
     ********************/

    ResolveNode.getLength = function(node) {
        if(node instanceof Node) return node.length || node.childNodes.length
    };

    ResolveNode.rangeDetail = function(node, range) {
        var positions, item, effectiveRange;
        item = {
            node: node,
            selection: range,
            isFullyContained: false,
            isEffectivelyContained: false,
            isVisuallyContained: false
        };
        if(!(range.commonAncestorContainer.contains(item.node) && range.intersectsNode(item.node))) return item;
        else item.isVisuallyContained = true;

        effectiveRange = document.createRange();
        effectiveRange.selectNodeContents(item.node);

        positions = [
            item.selectStartToContentStart     = range.compareBoundaryPoints(Range.START_TO_START, effectiveRange),
            item.selectEndToContentStart       = range.compareBoundaryPoints(Range.START_TO_END, effectiveRange),
            item.selectStartToContentEnd       = range.compareBoundaryPoints(Range.END_TO_START, effectiveRange),
            item.selectEndToContentEnd         = range.compareBoundaryPoints(Range.END_TO_END, effectiveRange),
        ];

        item.selectEndAfterContent = (item.selectEndToContentEnd === 1 && item.selectEndToContentStart === 1);
        item.selectEndBeforeContent = (item.selectEndToContentEnd === -1 && item.selectEndToContentStart === -1);
        item.selectStartBeforeContent = (item.selectStartToContentEnd === -1 && item.selectStartToContentStart === -1);
        item.selectStartAfterContent = (item.selectStartToContentEnd === 1 && item.selectStartToContentStart === 1);

        item.isFullyContained = (item.selectStartBeforeContent && item.selectEndAfterContent);

        item.isEffectivelyContained = !(
            (item.node === range.startContainer && ResolveNode.getLength(item.node) === range.startOffset) ||
            (item.node === range.endContainer && ResolveNode.getLength(item.node) === 0)
        );

        return item;
    };

    ResolveNode.walker = function(config) {
        if(!config) config = {};
        else if(config instanceof Node) config = {node: config};

        if(!config.root) config.root = d.body;
        if(!config.filter) config.filter = null;
        if(!config.types) config.types = NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT;

        var walker = d.createTreeWalker(config.root, config.types, config.filter, null);

        if(config.node instanceof Node) walker.currentNode = config.node;

        return walker;
    };



    /********************
     *  FORMATTERS      *
     ********************/

    ResolveNode.bold = {
        activated: true,
        property: 'font-weight',
        getSpecified: function(node) {
            var rn = ResolveNode(node);
            if(rn.isElement()) {
                if(rn.hasProperty(this.property)) return rn.getPropertyValue(this.property);
                if(rn.isName('B', 'STRONG')) return 'bold';
            }
            return null;
        },
        getEffective: function(node) { return ResolveNode(node).getResolvedValue(this.property); }
    };

    ResolveNode.foreColor = {
        property: 'color',
        getSpecified: function(node) {
            var rn = ResolveNode(node);
            return rn.isElement() && rn.hasProperty(this.property)
                ? rn.getPropertyValue(this.property) : null;
        },
        getEffective: function(node) {
            return ResolveColor(ResolveNode(node).getResolvedValue(this.property));
        }
    };

    ResolveNode.font = {
        property: 'font-family',
        getSpecified: function(node) {
            var rn = ResolveNode(node);
            return rn.isElement() && rn.hasProperty(this.property)
                ? rn.getPropertyValue(this.property) : null;
        },
        getEffective: function(node) { return ResolveNode(node).getResolvedValue(this.property); }
    };

    ResolveNode.backColor = {
        property: 'background-color',
        getSpecified: function(node) {
            var rn = ResolveNode(node);
            return rn.isElement() && rn.hasProperty(this.property) && rn.getResolvedValue('display') !== 'inline'
                ? ResolveColor(rn.getPropertyValue(this.property)) : null;
        },
        getEffective: function(node) {
            var rn = ResolveNode(node).getElement();
            if(rn.isElement()) {
                while (
                    rn.isNode() &&
                    ResolveColor(rn.getResolvedValue(this.property)).isTransparent() &&
                    rn.getParent().isElement()
                ) { rn = rn.getParent(); }
            }
            return rn.isNode() ? ResolveColor(rn.getResolvedValue(this.property)) : null;
        }
    };

    ResolveNode.italic = {
        property: 'font-style',
        getSpecified: function(node) {
            var rn = ResolveNode(node);
            if(rn.isElement()) {
                if(rn.hasProperty(this.property)) return rn.getPropertyValue(this.property);
                if(rn.isName('I', 'EM')) return 'italic';
            }
            return null;
        },
        getEffective: function(node) { return ResolveNode(node).getResolvedValue(this.property); }
    };

    ResolveNode.link = {
        getSpecified: function(node) {
            var rn = ResolveNode(node);
            return rn.isElement() && (rn.isName('A') && rn.node.hasAttribute('href'))
                ? rn.node.getAttribute('href') : null;
        },
        getEffective: function(node) {
            var rn = ResolveNode(node).getElement();
            if(rn.isElement()) {
                while (rn.isNode() && !rn.isName('A')) { rn = rn.getParent(); }
            }
            return rn.isNode() ? rn.node.getAttribute('href') : null;
        }
    };

    ResolveNode.size = {
        property: 'font-size',
        getSpecified: function(node) {
            var rn = ResolveNode(node);
            return rn.isElement() && rn.hasProperty(this.property)
                ? rn.getPropertyValue(this.property) : null;
        },
        getEffective: function(node) { return ResolveNode(node).getResolvedValue(this.property); }
    };

    ResolveNode.strike = {
        activated: 'line-through',
        getSpecified: function(node) {
            var rn = ResolveNode(node);
            return rn.isElement() && (
                rn.isName('S', 'STRIKE') || (
                    rn.hasProperty('text-decoration') &&
                    rn.getPropertyValue('text-decoration').has('line-through')
                )
            ) ? 'line-through' : null;
        },
        getEffective: function(node) {
            var rn = ResolveNode(node).getElement();
            return rn.isNode()
                ? this.getSpecified(rn.node) || this.getEffective(rn.getParent())
                : null;
        }
    };

    ResolveNode.subscript = {
        activated: 'subscript',
        getSpecified: function(node) {
            var rn = ResolveNode(node);
            return rn.isElement() && rn.isName('SUB') ? 'subscript' : null;
        },
        getEffective: function(node) {
            var sup, sub, rn = ResolveNode(node).getElement();
            if(rn.isElement()) {
                while (rn.isInline()) {
                    if(rn.isName('sup')) sup = true;
                    if(rn.isName('sub')) sub = true;
                    rn = rn.getParent();
                }
            }
            return sup && sub ? 'mixed' : sup ? 'superscript' : sub ? 'subscript' : null;
        }
    };

    ResolveNode.superscript = {
        activated: 'superscript',
        getSpecified: function(node) {
            var rn = ResolveNode(node);
            return rn.isElement() && rn.isName('SUP') ? 'superscript' : null;
        },
        getEffective: function(node) {
            var sup, sub, rn = ResolveNode(node).getElement();
            if(rn.isElement()) {
                while (rn.isInline()) {
                    if(rn.isName('sup')) sup = true;
                    if(rn.isName('sub')) sub = true;
                    rn = rn.getParent();
                }
            }
            return sup && sub ? 'mixed' : sup ? 'superscript' : sub ? 'subscript' : null;
        }
    };

    ResolveNode.underline = {
        activated: 'underline',
        getSpecified: function(node) {
            var rn = ResolveNode(node);
            return rn.isElement() && (
                (rn.hasProperty('text-decoration') && rn.getPropertyValue('text-decoration').has('underline')) ||
                rn.isName('U')
            ) ? 'underline' : null;
        },
        getEffective: function(node) {
            var rn = ResolveNode(node).getElement();
            return rn.isNode()
                ? this.getSpecified(rn.node) || this.getEffective(rn.getParent())
                : null;
        }
    };

})(Resolve, window, document);
(function(Resolve, w, d) {
    var ResolveRange = Resolve.Range = function ResolveRange(range) {
        if ( !(this instanceof ResolveRange) ) return new ResolveRange(range);

        this.range = range;
    };

    ResolveRange.prototype = {
        compareRange: function(comparingRange) {
            return (
                this.range instanceof Range &&
                comparingRange instanceof Range &&
                this.range.compareBoundaryPoints(Range.START_TO_START, comparingRange) === 0 &&
                this.range.compareBoundaryPoints(Range.END_TO_END, comparingRange) === 0 &&
                this.range.startOffset === comparingRange.startOffset &&
                this.range.endOffset === comparingRange.endOffset &&
                this.range.startContainer.isSameNode(comparingRange.startContainer) &&
                this.range.endContainer.isSameNode(comparingRange.endContainer)
            )
        }
    };

    function recordValues(nodes) {
        var values = [];
        var commands = [
            'subscript',
            'bold',
            'font',
            'size',
            'foreColor',
            'backColor',
            'italic',
            'strike',
            'underline'
        ]

        nodes.forEach(function(node){
            commands.forEach(function(command){
                var ancestor = ResolveNode(node).getElement();
                while (ancestor.getParent().isElement() && ancestor.getSpecifiedValue(command) === null) {
                    ancestor = ancestor.getParent()
                }
            })
        });
    }


    /*
    getElementsInRange(range, "span").forEach(el => {
                $(el).css("font-size", argument+self.editor.unit.toLowerCase())
                //el.classList.add("funky");
            });

    exec(cmd) {
        document.execCommand(cmd, false, false);
    },
    element: "any",
        connectedCallback(el) {
        this.element = el;
    },
    copyAll() {
        const editBox = this.element.querySelector(".editbox");
        const editBoxRange = document.createRange();
        editBoxRange.selectNodeContents(editBox);

        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(editBoxRange);

        document.execCommand("copy");
    },
    funky() {
        const editBox = this.element.querySelector(".editbox");
        const editBoxRange = document.createRange();
        editBoxRange.selectNodeContents(editBox);

        const selection = window.getSelection();
        if (selection && selection.rangeCount) {
            const selectedRange = selection.getRangeAt(0);
            if (rangeContains(editBoxRange, selectedRange)) {
                getElementsInRange(selectedRange, "span").forEach(el => {
                    el.classList.add("funky");
                });
            }
        }
    }*/



    function getElementsInRange(range, wrapNodeName) {
        const elements = [];

        function addSiblingElement(element) {
            // We are going to wrap all text nodes with a span.
            if (element.nodeType === Node.TEXT_NODE) {
                // If there’s something other than a space:
                if (/[^\s\n]/.test(element.nodeValue)) {
                    const span = document.createElement(wrapNodeName);
                    element.parentNode.insertBefore(span, element);
                    span.appendChild(element);
                    elements.push(span);
                }
            } else {
                elements.push(element);
            }
        }

        const startContainer = range.startContainer,
            endContainer = range.endContainer,
            commonAncestor = range.commonAncestorContainer;

        if (startContainer === commonAncestor) {
            const wrapper = document.createElement(wrapNodeName);
            range.surroundContents(wrapper);
            elements.push(wrapper);
        } else {
            // Split the starting text node.
            const startWrap = splitRangeStart(range, wrapNodeName);
            addSiblingElement(startWrap);

            // Add nested siblings from startWrap up to the first line.
            const startLine = siblingThenParentUntil(
                "nextSibling",
                startWrap,
                commonAncestor,
                addSiblingElement
            );

            // Split the ending text node.
            const endWrap = splitRangeEnd(range, wrapNodeName);
            addSiblingElement(endWrap);

            // Add nested siblings from endWrap up to the last line.
            const endLine = siblingThenParentUntil(
                "previousSibling",
                endWrap,
                commonAncestor,
                addSiblingElement
            );

            // Add lines between start and end to elements.
            let cur = startLine.nextSibling;
            while (cur !== endLine) {
                addSiblingElement(cur);
                cur = cur.nextSibling;
            }

            // Update the ranges
            range.setStart(startWrap, 0);
            range.setEnd(endWrap.firstChild, endWrap.textContent.length);
        }

        commonAncestor.normalize();
        return elements;
    }

    function rangeContains(outer, inner) {
        return (
            outer.compareBoundaryPoints(Range.START_TO_START, inner) <= 0 &&
            outer.compareBoundaryPoints(Range.END_TO_END, inner) >= 0
        );
    }

    // from start, this will try `direction` (nextSibling or previousSibling)
    // and call `callback` with each sibling until there are no more siblings
    // it will then move up the parent.  It will end with the parent's parent is `parent`.
    function siblingThenParentUntil(direction, start, parent, callback) {
        var cur = start;
        while (cur.parentNode !== parent) {
            if (cur[direction]) {
                // move to sibling
                cur = cur[direction];
                callback(cur);
            } else {
                // move to parent
                cur = cur.parentNode;
            }
        }
        return cur;
    }

    function splitRangeStart(range, wrapNodeName) {
        var startContainer = range.startContainer;
        var startWrap = document.createElement(wrapNodeName);
        startWrap.textContent = startContainer.nodeValue.substr(range.startOffset);
        startContainer.nodeValue = startContainer.nodeValue.substr(0, range.startOffset);
        startContainer.parentNode.insertBefore(startWrap, startContainer.nextSibling);
        return startWrap;
    }

    function splitRangeEnd(range, wrapNodeName) {
        var endContainer = range.endContainer;
        var endWrap = document.createElement(wrapNodeName);
        endWrap.textContent = endContainer.nodeValue.substr(0, range.endOffset);
        endContainer.nodeValue = endContainer.nodeValue.substr(range.endOffset);
        endContainer.parentNode.insertBefore(endWrap, endContainer);
        return endWrap;
    }
})(Resolve, window, document);
/*!
 * ASP.NET SignalR JavaScript Library v2.2.2
 * http://signalr.net/
 *
 * Copyright (c) .NET Foundation. All rights reserved.
 * Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *
 */

/// <reference path="..\..\SignalR.Client.JS\Scripts\jquery-1.6.4.js" />
/// <reference path="jquery.signalR.js" />
(function ($, window, undefined) {
    /// <param name="$" type="jQuery" />
    "use strict";

    if (typeof ($.signalR) !== "function") {
        throw new Error("SignalR: SignalR is not loaded. Please ensure jquery.signalR-x.js is referenced before ~/signalr/js.");
    }

    var signalR = $.signalR;

    function makeProxyCallback(hub, callback) {
        return function () {
            // Call the client hub method
            callback.apply(hub, $.makeArray(arguments));
        };
    }

    function registerHubProxies(instance, shouldSubscribe) {
        var key, hub, memberKey, memberValue, subscriptionMethod;

        for (key in instance) {
            if (instance.hasOwnProperty(key)) {
                hub = instance[key];

                if (!(hub.hubName)) {
                    // Not a client hub
                    continue;
                }

                if (shouldSubscribe) {
                    // We want to subscribe to the hub events
                    subscriptionMethod = hub.on;
                } else {
                    // We want to unsubscribe from the hub events
                    subscriptionMethod = hub.off;
                }

                // Loop through all members on the hub and find client hub functions to subscribe/unsubscribe
                for (memberKey in hub.client) {
                    if (hub.client.hasOwnProperty(memberKey)) {
                        memberValue = hub.client[memberKey];

                        if (!$.isFunction(memberValue)) {
                            // Not a client hub function
                            continue;
                        }

                        subscriptionMethod.call(hub, memberKey, makeProxyCallback(hub, memberValue));
                    }
                }
            }
        }
    }

    $.hubConnection.prototype.createHubProxies = function () {
        var proxies = {};
        this.starting(function () {
            // Register the hub proxies as subscribed
            // (instance, shouldSubscribe)
            registerHubProxies(proxies, true);

            this._registerSubscribedHubs();
        }).disconnected(function () {
            // Unsubscribe all hub proxies when we "disconnect".  This is to ensure that we do not re-add functional call backs.
            // (instance, shouldSubscribe)
            registerHubProxies(proxies, false);
        });

        proxies['billInstanceClientHub'] = this.createHubProxy('billInstanceClientHub');
        proxies['billInstanceClientHub'].client = { };
        proxies['billInstanceClientHub'].server = {
        };

        proxies['billRecalcHub'] = this.createHubProxy('billRecalcHub');
        proxies['billRecalcHub'].client = { };
        proxies['billRecalcHub'].server = {
        };

        proxies['compositeInstanceHub'] = this.createHubProxy('compositeInstanceHub');
        proxies['compositeInstanceHub'].client = { };
        proxies['compositeInstanceHub'].server = {
        };

        proxies['downloadHub'] = this.createHubProxy('downloadHub');
        proxies['downloadHub'].client = { };
        proxies['downloadHub'].server = {
        };

        proxies['fuseHub'] = this.createHubProxy('fuseHub');
        proxies['fuseHub'].client = { };
        proxies['fuseHub'].server = {
            sendNotificationToAllClients: function (notificationId) {
                return proxies['fuseHub'].invoke.apply(proxies['fuseHub'], $.merge(["SendNotificationToAllClients"], $.makeArray(arguments)));
            }
        };

        proxies['performanceCompareDetailsHub'] = this.createHubProxy('performanceCompareDetailsHub');
        proxies['performanceCompareDetailsHub'].client = { };
        proxies['performanceCompareDetailsHub'].server = {
        };

        proxies['reportBatchEntitiesHub'] = this.createHubProxy('reportBatchEntitiesHub');
        proxies['reportBatchEntitiesHub'].client = { };
        proxies['reportBatchEntitiesHub'].server = {
        };

        proxies['deliverEmailsHub'] = this.createHubProxy('deliverEmailsHub');
        proxies['deliverEmailsHub'].client = { };
        proxies['deliverEmailsHub'].server = {
        };

        return proxies;
    };

    signalR.hub = $.hubConnection("/api/signalr", { useDefaultPath: false });
    $.extend(signalR, signalR.hub.createHubProxies());

}(window.jQuery, window));
/**
 * oclazyload - Load modules on demand (lazy load) with angularJS
 * @version v1.0.10
 * @link https://github.com/ocombe/ocLazyLoad
 * @license MIT
 * @author Olivier Combe <olivier.combe@gmail.com>
 */
!function(e,n){"use strict";var r=["ng","oc.lazyLoad"],o={},t=[],i=[],a=[],s=[],u=e.noop,c={},d=[],l=e.module("oc.lazyLoad",["ng"]);l.provider("$ocLazyLoad",["$controllerProvider","$provide","$compileProvider","$filterProvider","$injector","$animateProvider",function(l,f,p,m,v,y){function L(n,o,t){if(o){var i,s,l,f=[];for(i=o.length-1;i>=0;i--)if(s=o[i],e.isString(s)||(s=E(s)),s&&-1===d.indexOf(s)&&(!w[s]||-1!==a.indexOf(s))){var h=-1===r.indexOf(s);if(l=g(s),h&&(r.push(s),L(n,l.requires,t)),l._runBlocks.length>0)for(c[s]=[];l._runBlocks.length>0;)c[s].push(l._runBlocks.shift());e.isDefined(c[s])&&(h||t.rerun)&&(f=f.concat(c[s])),j(n,l._invokeQueue,s,t.reconfig),j(n,l._configBlocks,s,t.reconfig),u(h?"ocLazyLoad.moduleLoaded":"ocLazyLoad.moduleReloaded",s),o.pop(),d.push(s)}var p=n.getInstanceInjector();e.forEach(f,function(e){p.invoke(e)})}}function $(n,r){function t(n,r){var o,t=!0;return r.length&&(o=i(n),e.forEach(r,function(e){t=t&&i(e)!==o})),t}function i(n){return e.isArray(n)?M(n.toString()):e.isObject(n)?M(S(n)):e.isDefined(n)&&null!==n?M(n.toString()):n}var a=n[2][0],s=n[1],c=!1;e.isUndefined(o[r])&&(o[r]={}),e.isUndefined(o[r][s])&&(o[r][s]={});var d=function(e,n){o[r][s].hasOwnProperty(e)||(o[r][s][e]=[]),t(n,o[r][s][e])&&(c=!0,o[r][s][e].push(n),u("ocLazyLoad.componentLoaded",[r,s,e]))};if(e.isString(a))d(a,n[2][1]);else{if(!e.isObject(a))return!1;e.forEach(a,function(n,r){e.isString(n)?d(n,a[1]):d(r,n)})}return c}function j(n,r,o,i){if(r){var a,s,u,c;for(a=0,s=r.length;s>a;a++)if(u=r[a],e.isArray(u)){if(null!==n){if(!n.hasOwnProperty(u[0]))throw new Error("unsupported provider "+u[0]);c=n[u[0]]}var d=$(u,o);if("invoke"!==u[1])d&&e.isDefined(c)&&c[u[1]].apply(c,u[2]);else{var l=function(n){var r=t.indexOf(o+"-"+n);(-1===r||i)&&(-1===r&&t.push(o+"-"+n),e.isDefined(c)&&c[u[1]].apply(c,u[2]))};if(e.isFunction(u[2][0]))l(u[2][0]);else if(e.isArray(u[2][0]))for(var f=0,h=u[2][0].length;h>f;f++)e.isFunction(u[2][0][f])&&l(u[2][0][f])}}}}function E(n){var r=null;return e.isString(n)?r=n:e.isObject(n)&&n.hasOwnProperty("name")&&e.isString(n.name)&&(r=n.name),r}function _(n){if(!e.isString(n))return!1;try{return g(n)}catch(r){if(/No module/.test(r)||r.message.indexOf("$injector:nomod")>-1)return!1}}var w={},O={$controllerProvider:l,$compileProvider:p,$filterProvider:m,$provide:f,$injector:v,$animateProvider:y},x=!1,b=!1,z=[],D={};z.push=function(e){-1===this.indexOf(e)&&Array.prototype.push.apply(this,arguments)},this.config=function(n){e.isDefined(n.modules)&&(e.isArray(n.modules)?e.forEach(n.modules,function(e){w[e.name]=e}):w[n.modules.name]=n.modules),e.isDefined(n.debug)&&(x=n.debug),e.isDefined(n.events)&&(b=n.events)},this._init=function(o){if(0===i.length){var t=[o],a=["ng:app","ng-app","x-ng-app","data-ng-app"],u=/\sng[:\-]app(:\s*([\w\d_]+);?)?\s/,c=function(e){return e&&t.push(e)};e.forEach(a,function(n){a[n]=!0,c(document.getElementById(n)),n=n.replace(":","\\:"),"undefined"!=typeof o[0]&&o[0].querySelectorAll&&(e.forEach(o[0].querySelectorAll("."+n),c),e.forEach(o[0].querySelectorAll("."+n+"\\:"),c),e.forEach(o[0].querySelectorAll("["+n+"]"),c))}),e.forEach(t,function(n){if(0===i.length){var r=" "+o.className+" ",t=u.exec(r);t?i.push((t[2]||"").replace(/\s+/g,",")):e.forEach(n.attributes,function(e){0===i.length&&a[e.name]&&i.push(e.value)})}})}0!==i.length||(n.jasmine||n.mocha)&&e.isDefined(e.mock)||console.error("No module found during bootstrap, unable to init ocLazyLoad. You should always use the ng-app directive or angular.boostrap when you use ocLazyLoad.");var d=function l(n){if(-1===r.indexOf(n)){r.push(n);var o=e.module(n);j(null,o._invokeQueue,n),j(null,o._configBlocks,n),e.forEach(o.requires,l)}};e.forEach(i,function(e){d(e)}),i=[],s.pop()};var S=function(n){try{return JSON.stringify(n)}catch(r){var o=[];return JSON.stringify(n,function(n,r){if(e.isObject(r)&&null!==r){if(-1!==o.indexOf(r))return;o.push(r)}return r})}},M=function(e){var n,r,o,t=0;if(0==e.length)return t;for(n=0,o=e.length;o>n;n++)r=e.charCodeAt(n),t=(t<<5)-t+r,t|=0;return t};this.$get=["$log","$rootElement","$rootScope","$cacheFactory","$q",function(n,t,a,c,l){function f(e){var r=l.defer();return n.error(e.message),r.reject(e),r.promise}var p,m=c("ocLazyLoad");return x||(n={},n.error=e.noop,n.warn=e.noop,n.info=e.noop),O.getInstanceInjector=function(){return p?p:p=t.data("$injector")||e.injector()},u=function(e,r){b&&a.$broadcast(e,r),x&&n.info(e,r)},{_broadcast:u,_$log:n,_getFilesCache:function(){return m},toggleWatch:function(e){e?s.push(!0):s.pop()},getModuleConfig:function(n){if(!e.isString(n))throw new Error("You need to give the name of the module to get");return w[n]?e.copy(w[n]):null},setModuleConfig:function(n){if(!e.isObject(n))throw new Error("You need to give the module config object to set");return w[n.name]=n,n},getModules:function(){return r},isLoaded:function(n){var o=function(e){var n=r.indexOf(e)>-1;return n||(n=!!_(e)),n};if(e.isString(n)&&(n=[n]),e.isArray(n)){var t,i;for(t=0,i=n.length;i>t;t++)if(!o(n[t]))return!1;return!0}throw new Error("You need to define the module(s) name(s)")},_getModuleName:E,_getModule:function(e){try{return g(e)}catch(n){throw(/No module/.test(n)||n.message.indexOf("$injector:nomod")>-1)&&(n.message='The module "'+S(e)+'" that you are trying to load does not exist. '+n.message),n}},moduleExists:_,_loadDependencies:function(n,r){var o,t,i,a=[],s=this;if(n=s._getModuleName(n),null===n)return l.when();try{o=s._getModule(n)}catch(u){return f(u)}return t=s.getRequires(o),e.forEach(t,function(o){if(e.isString(o)){var t=s.getModuleConfig(o);if(null===t)return void z.push(o);o=t,t.name=void 0}if(s.moduleExists(o.name))return i=o.files.filter(function(e){return s.getModuleConfig(o.name).files.indexOf(e)<0}),0!==i.length&&s._$log.warn('Module "',n,'" attempted to redefine configuration for dependency. "',o.name,'"\n Additional Files Loaded:',i),e.isDefined(s.filesLoader)?void a.push(s.filesLoader(o,r).then(function(){return s._loadDependencies(o)})):f(new Error("Error: New dependencies need to be loaded from external files ("+o.files+"), but no loader has been defined."));if(e.isArray(o)){var u=[];e.forEach(o,function(e){var n=s.getModuleConfig(e);null===n?u.push(e):n.files&&(u=u.concat(n.files))}),u.length>0&&(o={files:u})}else e.isObject(o)&&o.hasOwnProperty("name")&&o.name&&(s.setModuleConfig(o),z.push(o.name));if(e.isDefined(o.files)&&0!==o.files.length){if(!e.isDefined(s.filesLoader))return f(new Error('Error: the module "'+o.name+'" is defined in external files ('+o.files+"), but no loader has been defined."));a.push(s.filesLoader(o,r).then(function(){return s._loadDependencies(o)}))}}),l.all(a)},inject:function(n){var r=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],o=arguments.length<=2||void 0===arguments[2]?!1:arguments[2],t=this,a=l.defer();if(e.isDefined(n)&&null!==n){if(e.isArray(n)){var s=[];return e.forEach(n,function(e){s.push(t.inject(e,r,o))}),l.all(s)}t._addToLoadList(t._getModuleName(n),!0,o)}if(i.length>0){var u=i.slice(),c=function f(e){z.push(e),D[e]=a.promise,t._loadDependencies(e,r).then(function(){try{d=[],L(O,z,r)}catch(e){return t._$log.error(e.message),void a.reject(e)}i.length>0?f(i.shift()):a.resolve(u)},function(e){a.reject(e)})};c(i.shift())}else{if(r&&r.name&&D[r.name])return D[r.name];a.resolve()}return a.promise},getRequires:function(n){var o=[];return e.forEach(n.requires,function(e){-1===r.indexOf(e)&&o.push(e)}),o},_invokeQueue:j,_registerInvokeList:$,_register:L,_addToLoadList:h,_unregister:function(n){e.isDefined(n)&&e.isArray(n)&&e.forEach(n,function(e){o[e]=void 0})}}}],this._init(e.element(n.document))}]);var f=e.bootstrap;e.bootstrap=function(n,l,g){return r=["ng","oc.lazyLoad"],o={},t=[],i=[],a=[],s=[],u=e.noop,c={},d=[],e.forEach(l.slice(),function(e){h(e,!0,!0)}),f(n,l,g)};var h=function(n,r,o){(s.length>0||r)&&e.isString(n)&&-1===i.indexOf(n)&&(i.push(n),o&&a.push(n))},g=e.module;e.module=function(e,n,r){return h(e,!1,!0),g(e,n,r)},"undefined"!=typeof module&&"undefined"!=typeof exports&&module.exports===exports&&(module.exports="oc.lazyLoad")}(angular,window),function(e){"use strict";e.module("oc.lazyLoad").directive("ocLazyLoad",["$ocLazyLoad","$compile","$animate","$parse","$timeout",function(n,r,o,t,i){return{restrict:"A",terminal:!0,priority:1e3,compile:function(i,a){var s=i[0].innerHTML;return i.html(""),function(i,a,u){var c=t(u.ocLazyLoad);i.$watch(function(){return c(i)||u.ocLazyLoad},function(t){e.isDefined(t)&&n.load(t).then(function(){o.enter(s,a),r(a.contents())(i)})},!0)}}}}])}(angular),function(e){"use strict";e.module("oc.lazyLoad").config(["$provide",function(n){n.decorator("$ocLazyLoad",["$delegate","$q","$window","$interval",function(n,r,o,t){var i=!1,a=!1,s=o.document.getElementsByTagName("head")[0]||o.document.getElementsByTagName("body")[0];return n.buildElement=function(u,c,d){var l,f,h=r.defer(),g=n._getFilesCache(),p=function(e){var n=(new Date).getTime();return e.indexOf("?")>=0?"&"===e.substring(0,e.length-1)?e+"_dc="+n:e+"&_dc="+n:e+"?_dc="+n};switch(e.isUndefined(g.get(c))&&g.put(c,h.promise),u){case"css":l=o.document.createElement("link"),l.type="text/css",l.rel="stylesheet",l.href=d.cache===!1?p(c):c;break;case"js":l=o.document.createElement("script"),l.src=d.cache===!1?p(c):c;break;default:g.remove(c),h.reject(new Error('Requested type "'+u+'" is not known. Could not inject "'+c+'"'))}l.onload=l.onreadystatechange=function(e){l.readyState&&!/^c|loade/.test(l.readyState)||f||(l.onload=l.onreadystatechange=null,f=1,n._broadcast("ocLazyLoad.fileLoaded",c),h.resolve(l))},l.onerror=function(){g.remove(c),h.reject(new Error("Unable to load "+c))},l.async=d.serie?0:1;var m=s.lastChild;if(d.insertBefore){var v=e.element(e.isDefined(window.jQuery)?d.insertBefore:document.querySelector(d.insertBefore));v&&v.length>0&&(m=v[0])}if(m.parentNode.insertBefore(l,m),"css"==u){if(!i){var y=o.navigator.userAgent.toLowerCase();if(y.indexOf("phantomjs/1.9")>-1)a=!0;else if(/iP(hone|od|ad)/.test(o.navigator.platform)){var L=o.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/),$=parseFloat([parseInt(L[1],10),parseInt(L[2],10),parseInt(L[3]||0,10)].join("."));a=6>$}else if(y.indexOf("android")>-1){var j=parseFloat(y.slice(y.indexOf("android")+8));a=4.4>j}else if(y.indexOf("safari")>-1){var E=y.match(/version\/([\.\d]+)/i);a=E&&E[1]&&parseFloat(E[1])<6}}if(a)var _=1e3,w=t(function(){try{l.sheet.cssRules,t.cancel(w),l.onload()}catch(e){--_<=0&&l.onerror()}},20)}return h.promise},n}])}])}(angular),function(e){"use strict";e.module("oc.lazyLoad").config(["$provide",function(n){n.decorator("$ocLazyLoad",["$delegate","$q",function(n,r){return n.filesLoader=function(o){var t=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],i=[],a=[],s=[],u=[],c=null,d=n._getFilesCache();n.toggleWatch(!0),e.extend(t,o);var l=function(r){var o,l=null;if(e.isObject(r)&&(l=r.type,r=r.path),c=d.get(r),e.isUndefined(c)||t.cache===!1){if(null!==(o=/^(css|less|html|htm|js)?(?=!)/.exec(r))&&(l=o[1],r=r.substr(o[1].length+1,r.length)),!l)if(null!==(o=/[.](css|less|html|htm|js)?((\?|#).*)?$/.exec(r)))l=o[1];else{if(n.jsLoader.hasOwnProperty("ocLazyLoadLoader")||!n.jsLoader.hasOwnProperty("requirejs"))return void n._$log.error("File type could not be determined. "+r);l="js"}"css"!==l&&"less"!==l||-1!==i.indexOf(r)?"html"!==l&&"htm"!==l||-1!==a.indexOf(r)?"js"===l||-1===s.indexOf(r)?s.push(r):n._$log.error("File type is not valid. "+r):a.push(r):i.push(r)}else c&&u.push(c)};if(t.serie?l(t.files.shift()):e.forEach(t.files,function(e){l(e)}),i.length>0){var f=r.defer();n.cssLoader(i,function(r){e.isDefined(r)&&n.cssLoader.hasOwnProperty("ocLazyLoadLoader")?(n._$log.error(r),f.reject(r)):f.resolve()},t),u.push(f.promise)}if(a.length>0){var h=r.defer();n.templatesLoader(a,function(r){e.isDefined(r)&&n.templatesLoader.hasOwnProperty("ocLazyLoadLoader")?(n._$log.error(r),h.reject(r)):h.resolve()},t),u.push(h.promise)}if(s.length>0){var g=r.defer();n.jsLoader(s,function(r){e.isDefined(r)&&(n.jsLoader.hasOwnProperty("ocLazyLoadLoader")||n.jsLoader.hasOwnProperty("requirejs"))?(n._$log.error(r),g.reject(r)):g.resolve()},t),u.push(g.promise)}if(0===u.length){var p=r.defer(),m="Error: no file to load has been found, if you're trying to load an existing module you should use the 'inject' method instead of 'load'.";return n._$log.error(m),p.reject(m),p.promise}return t.serie&&t.files.length>0?r.all(u).then(function(){return n.filesLoader(o,t)}):r.all(u)["finally"](function(e){return n.toggleWatch(!1),e})},n.load=function(o){var t,i=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],a=this,s=null,u=[],c=r.defer(),d=e.copy(o),l=e.copy(i);if(e.isArray(d))return e.forEach(d,function(e){u.push(a.load(e,l))}),r.all(u).then(function(e){c.resolve(e)},function(e){c.reject(e)}),c.promise;if(e.isString(d)?(s=a.getModuleConfig(d),s||(s={files:[d]})):e.isObject(d)&&(s=e.isDefined(d.path)&&e.isDefined(d.type)?{files:[d]}:a.setModuleConfig(d)),null===s){var f=a._getModuleName(d);return t='Module "'+(f||"unknown")+'" is not configured, cannot load.',n._$log.error(t),c.reject(new Error(t)),c.promise}e.isDefined(s.template)&&(e.isUndefined(s.files)&&(s.files=[]),e.isString(s.template)?s.files.push(s.template):e.isArray(s.template)&&s.files.concat(s.template));var h=e.extend({},l,s);return e.isUndefined(s.files)&&e.isDefined(s.name)&&n.moduleExists(s.name)?n.inject(s.name,h,!0):(n.filesLoader(s,h).then(function(){n.inject(null,h).then(function(e){c.resolve(e)},function(e){c.reject(e)})},function(e){c.reject(e)}),c.promise)},n}])}])}(angular),function(e){"use strict";e.module("oc.lazyLoad").config(["$provide",function(n){n.decorator("$ocLazyLoad",["$delegate","$q",function(n,r){return n.cssLoader=function(o,t,i){var a=[];e.forEach(o,function(e){a.push(n.buildElement("css",e,i))}),r.all(a).then(function(){t()},function(e){t(e)})},n.cssLoader.ocLazyLoadLoader=!0,n}])}])}(angular),function(e){"use strict";e.module("oc.lazyLoad").config(["$provide",function(n){n.decorator("$ocLazyLoad",["$delegate","$q",function(n,r){return n.jsLoader=function(o,t,i){var a=[];e.forEach(o,function(e){a.push(n.buildElement("js",e,i))}),r.all(a).then(function(){t()},function(e){t(e)})},n.jsLoader.ocLazyLoadLoader=!0,n}])}])}(angular),function(e){"use strict";e.module("oc.lazyLoad").config(["$provide",function(n){n.decorator("$ocLazyLoad",["$delegate","$templateCache","$q","$http",function(n,r,o,t){return n.templatesLoader=function(i,a,s){var u=[],c=n._getFilesCache();return e.forEach(i,function(n){var i=o.defer();u.push(i.promise),t.get(n,s).then(function(o){var t=o.data;e.isString(t)&&t.length>0&&e.forEach(e.element(t),function(e){"SCRIPT"===e.nodeName&&"text/ng-template"===e.type&&r.put(e.id,e.innerHTML)}),e.isUndefined(c.get(n))&&c.put(n,!0),i.resolve()})["catch"](function(e){i.reject(new Error('Unable to load template file "'+n+'": '+e.data))})}),o.all(u).then(function(){a()},function(e){a(e)})},n.templatesLoader.ocLazyLoadLoader=!0,n}])}])}(angular),Array.prototype.indexOf||(Array.prototype.indexOf=function(e,n){var r;if(null==this)throw new TypeError('"this" is null or not defined');var o=Object(this),t=o.length>>>0;if(0===t)return-1;var i=+n||0;if(Math.abs(i)===1/0&&(i=0),i>=t)return-1;for(r=Math.max(i>=0?i:t-Math.abs(i),0);t>r;){if(r in o&&o[r]===e)return r;r++}return-1});
/* pako 1.0.11 nodeca/pako */(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.pako = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';


var zlib_deflate = require('./zlib/deflate');
var utils        = require('./utils/common');
var strings      = require('./utils/strings');
var msg          = require('./zlib/messages');
var ZStream      = require('./zlib/zstream');

var toString = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

var Z_NO_FLUSH      = 0;
var Z_FINISH        = 4;

var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_SYNC_FLUSH    = 2;

var Z_DEFAULT_COMPRESSION = -1;

var Z_DEFAULT_STRATEGY    = 0;

var Z_DEFLATED  = 8;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/

/**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate(options) {
  if (!(this instanceof Deflate)) return new Deflate(options);

  this.options = utils.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ''
  }, options || {});

  var opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new ZStream();
  this.strm.avail_out = 0;

  var status = zlib_deflate.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK) {
    throw new Error(msg[status]);
  }

  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    var dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = zlib_deflate.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK) {
      throw new Error(msg[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;

  if (this.ended) { return false; }

  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */

    if (status !== Z_STREAM_END && status !== Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
      if (this.options.to === 'string') {
        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

  // Finalize on the last chunk.
  if (_mode === Z_FINISH) {
    status = zlib_deflate.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === Z_SYNC_FLUSH) {
    this.onEnd(Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate(input, options) {
  var deflator = new Deflate(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate(input, options);
}


exports.Deflate = Deflate;
exports.deflate = deflate;
exports.deflateRaw = deflateRaw;
exports.gzip = gzip;

},{"./utils/common":3,"./utils/strings":4,"./zlib/deflate":8,"./zlib/messages":13,"./zlib/zstream":15}],2:[function(require,module,exports){
'use strict';


var zlib_inflate = require('./zlib/inflate');
var utils        = require('./utils/common');
var strings      = require('./utils/strings');
var c            = require('./zlib/constants');
var msg          = require('./zlib/messages');
var ZStream      = require('./zlib/zstream');
var GZheader     = require('./zlib/gzheader');

var toString = Object.prototype.toString;

/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/

/**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
function Inflate(options) {
  if (!(this instanceof Inflate)) return new Inflate(options);

  this.options = utils.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ''
  }, options || {});

  var opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new ZStream();
  this.strm.avail_out = 0;

  var status  = zlib_inflate.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== c.Z_OK) {
    throw new Error(msg[status]);
  }

  this.header = new GZheader();

  zlib_inflate.inflateGetHeader(this.strm, this.header);

  // Setup dictionary
  if (opt.dictionary) {
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      opt.dictionary = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      opt.dictionary = new Uint8Array(opt.dictionary);
    }
    if (opt.raw) { //In raw mode we need to set the dictionary early
      status = zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
      if (status !== c.Z_OK) {
        throw new Error(msg[status]);
      }
    }
  }
}

/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var dictionary = this.options.dictionary;
  var status, _mode;
  var next_out_utf8, tail, utf8str;

  // Flag to properly process Z_BUF_ERROR on testing inflate call
  // when we check that all output data was flushed.
  var allowBufError = false;

  if (this.ended) { return false; }
  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // Only binary strings can be decompressed on practice
    strm.input = strings.binstring2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */

    if (status === c.Z_NEED_DICT && dictionary) {
      status = zlib_inflate.inflateSetDictionary(this.strm, dictionary);
    }

    if (status === c.Z_BUF_ERROR && allowBufError === true) {
      status = c.Z_OK;
      allowBufError = false;
    }

    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {

        if (this.options.to === 'string') {

          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          tail = strm.next_out - next_out_utf8;
          utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }

          this.onData(utf8str);

        } else {
          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
        }
      }
    }

    // When no more input data, we should check that internal inflate buffers
    // are flushed. The only way to do it when avail_out = 0 - run one more
    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
    // Here we set flag to process this error properly.
    //
    // NOTE. Deflate does not return error in this case and does not needs such
    // logic.
    if (strm.avail_in === 0 && strm.avail_out === 0) {
      allowBufError = true;
    }

  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);

  if (status === c.Z_STREAM_END) {
    _mode = c.Z_FINISH;
  }

  // Finalize on the last chunk.
  if (_mode === c.Z_FINISH) {
    status = zlib_inflate.inflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === c.Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === c.Z_SYNC_FLUSH) {
    this.onEnd(c.Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === c.Z_OK) {
    if (this.options.to === 'string') {
      // Glue & convert here, until we teach pako to send
      // utf8 aligned strings to onData
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/
function inflate(input, options) {
  var inflator = new Inflate(options);

  inflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return inflate(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


exports.Inflate = Inflate;
exports.inflate = inflate;
exports.inflateRaw = inflateRaw;
exports.ungzip  = inflate;

},{"./utils/common":3,"./utils/strings":4,"./zlib/constants":6,"./zlib/gzheader":9,"./zlib/inflate":11,"./zlib/messages":13,"./zlib/zstream":15}],3:[function(require,module,exports){
'use strict';


var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');

function _has(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);

},{}],4:[function(require,module,exports){
// String encode/decode helpers
'use strict';


var utils = require('./common');


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new utils.Buf8(256);
for (var q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
exports.string2buf = function (str) {
  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new utils.Buf8(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper (used in 2 places)
function buf2binstring(buf, len) {
  // On Chrome, the arguments in a function call that are allowed is `65534`.
  // If the length of the buffer is smaller than that, we can use this optimization,
  // otherwise we will take a slower path.
  if (len < 65534) {
    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
    }
  }

  var result = '';
  for (var i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}


// Convert byte array to binary string
exports.buf2binstring = function (buf) {
  return buf2binstring(buf, buf.length);
};


// Convert binary string (typed, when possible)
exports.binstring2buf = function (str) {
  var buf = new utils.Buf8(str.length);
  for (var i = 0, len = buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};


// convert array to string
exports.buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  var utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
exports.utf8border = function (buf, max) {
  var pos;

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means buffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

},{"./common":3}],5:[function(require,module,exports){
'use strict';

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;

},{}],6:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};

},{}],7:[function(require,module,exports){
'use strict';

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;

},{}],8:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils   = require('../utils/common');
var trees   = require('./trees');
var adler32 = require('./adler32');
var crc32   = require('./crc32');
var msg     = require('./messages');

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
        );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils.Buf8(s.w_size);
    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}


exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/

},{"../utils/common":3,"./adler32":5,"./crc32":7,"./messages":13,"./trees":14}],9:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function GZheader() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

module.exports = GZheader;

},{}],10:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  var s_window;               /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};

},{}],11:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils         = require('../utils/common');
var adler32       = require('./adler32');
var crc32         = require('./crc32');
var inflate_fast  = require('./inffast');
var inflate_table = require('./inftrees');

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function zswap32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
      case HEAD:
        if (state.wrap === 0) {
          state.mode = TYPEDO;
          break;
        }
        //=== NEEDBITS(16);
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//

          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          state.mode = FLAGS;
          break;
        }
        state.flags = 0;           /* expect zlib header */
        if (state.head) {
          state.head.done = false;
        }
        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
          strm.msg = 'incorrect header check';
          state.mode = BAD;
          break;
        }
        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
        len = (hold & 0x0f)/*BITS(4)*/ + 8;
        if (state.wbits === 0) {
          state.wbits = len;
        }
        else if (len > state.wbits) {
          strm.msg = 'invalid window size';
          state.mode = BAD;
          break;
        }
        state.dmax = 1 << len;
        //Tracev((stderr, "inflate:   zlib header ok\n"));
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = hold & 0x200 ? DICTID : TYPE;
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        break;
      case FLAGS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.flags = hold;
        if ((state.flags & 0xff) !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        if (state.flags & 0xe000) {
          strm.msg = 'unknown header flags set';
          state.mode = BAD;
          break;
        }
        if (state.head) {
          state.head.text = ((hold >> 8) & 1);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = TIME;
        /* falls through */
      case TIME:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.time = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC4(state.check, hold)
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          hbuf[2] = (hold >>> 16) & 0xff;
          hbuf[3] = (hold >>> 24) & 0xff;
          state.check = crc32(state.check, hbuf, 4, 0);
          //===
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = OS;
        /* falls through */
      case OS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.xflags = (hold & 0xff);
          state.head.os = (hold >> 8);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = EXLEN;
        /* falls through */
      case EXLEN:
        if (state.flags & 0x0400) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length = hold;
          if (state.head) {
            state.head.extra_len = hold;
          }
          if (state.flags & 0x0200) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = (hold >>> 8) & 0xff;
            state.check = crc32(state.check, hbuf, 2, 0);
            //===//
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        else if (state.head) {
          state.head.extra = null/*Z_NULL*/;
        }
        state.mode = EXTRA;
        /* falls through */
      case EXTRA:
        if (state.flags & 0x0400) {
          copy = state.length;
          if (copy > have) { copy = have; }
          if (copy) {
            if (state.head) {
              len = state.head.extra_len - state.length;
              if (!state.head.extra) {
                // Use untyped array for more convenient processing later
                state.head.extra = new Array(state.head.extra_len);
              }
              utils.arraySet(
                state.head.extra,
                input,
                next,
                // extra field is limited to 65536 bytes
                // - no need for additional size check
                copy,
                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                len
              );
              //zmemcpy(state.head.extra + len, next,
              //        len + copy > state.head.extra_max ?
              //        state.head.extra_max - len : copy);
            }
            if (state.flags & 0x0200) {
              state.check = crc32(state.check, input, copy, next);
            }
            have -= copy;
            next += copy;
            state.length -= copy;
          }
          if (state.length) { break inf_leave; }
        }
        state.length = 0;
        state.mode = NAME;
        /* falls through */
      case NAME:
        if (state.flags & 0x0800) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            // TODO: 2 or 1 bytes?
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.name_max*/)) {
              state.head.name += String.fromCharCode(len);
            }
          } while (len && copy < have);

          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.name = null;
        }
        state.length = 0;
        state.mode = COMMENT;
        /* falls through */
      case COMMENT:
        if (state.flags & 0x1000) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.comm_max*/)) {
              state.head.comment += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.comment = null;
        }
        state.mode = HCRC;
        /* falls through */
      case HCRC:
        if (state.flags & 0x0200) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.check & 0xffff)) {
            strm.msg = 'header crc mismatch';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        if (state.head) {
          state.head.hcrc = ((state.flags >> 9) & 1);
          state.head.done = true;
        }
        strm.adler = state.check = 0;
        state.mode = TYPE;
        break;
      case DICTID:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        strm.adler = state.check = zswap32(hold);
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = DICT;
        /* falls through */
      case DICT:
        if (state.havedict === 0) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          return Z_NEED_DICT;
        }
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = TYPE;
        /* falls through */
      case TYPE:
        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case TYPEDO:
        if (state.last) {
          //--- BYTEBITS() ---//
          hold >>>= bits & 7;
          bits -= bits & 7;
          //---//
          state.mode = CHECK;
          break;
        }
        //=== NEEDBITS(3); */
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.last = (hold & 0x01)/*BITS(1)*/;
        //--- DROPBITS(1) ---//
        hold >>>= 1;
        bits -= 1;
        //---//

        switch ((hold & 0x03)/*BITS(2)*/) {
          case 0:                             /* stored block */
            //Tracev((stderr, "inflate:     stored block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = STORED;
            break;
          case 1:                             /* fixed block */
            fixedtables(state);
            //Tracev((stderr, "inflate:     fixed codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = LEN_;             /* decode codes */
            if (flush === Z_TREES) {
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break inf_leave;
            }
            break;
          case 2:                             /* dynamic block */
            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = TABLE;
            break;
          case 3:
            strm.msg = 'invalid block type';
            state.mode = BAD;
        }
        //--- DROPBITS(2) ---//
        hold >>>= 2;
        bits -= 2;
        //---//
        break;
      case STORED:
        //--- BYTEBITS() ---// /* go to byte boundary */
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
          strm.msg = 'invalid stored block lengths';
          state.mode = BAD;
          break;
        }
        state.length = hold & 0xffff;
        //Tracev((stderr, "inflate:       stored length %u\n",
        //        state.length));
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = COPY_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case COPY_:
        state.mode = COPY;
        /* falls through */
      case COPY:
        copy = state.length;
        if (copy) {
          if (copy > have) { copy = have; }
          if (copy > left) { copy = left; }
          if (copy === 0) { break inf_leave; }
          //--- zmemcpy(put, next, copy); ---
          utils.arraySet(output, input, next, copy, put);
          //---//
          have -= copy;
          next += copy;
          left -= copy;
          put += copy;
          state.length -= copy;
          break;
        }
        //Tracev((stderr, "inflate:       stored end\n"));
        state.mode = TYPE;
        break;
      case TABLE:
        //=== NEEDBITS(14); */
        while (bits < 14) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
//#ifndef PKZIP_BUG_WORKAROUND
        if (state.nlen > 286 || state.ndist > 30) {
          strm.msg = 'too many length or distance symbols';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracev((stderr, "inflate:       table sizes ok\n"));
        state.have = 0;
        state.mode = LENLENS;
        /* falls through */
      case LENLENS:
        while (state.have < state.ncode) {
          //=== NEEDBITS(3);
          while (bits < 3) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
          //--- DROPBITS(3) ---//
          hold >>>= 3;
          bits -= 3;
          //---//
        }
        while (state.have < 19) {
          state.lens[order[state.have++]] = 0;
        }
        // We have separate tables & no pointers. 2 commented lines below not needed.
        //state.next = state.codes;
        //state.lencode = state.next;
        // Switch to use dynamic table
        state.lencode = state.lendyn;
        state.lenbits = 7;

        opts = { bits: state.lenbits };
        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;

        if (ret) {
          strm.msg = 'invalid code lengths set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, "inflate:       code lengths ok\n"));
        state.have = 0;
        state.mode = CODELENS;
        /* falls through */
      case CODELENS:
        while (state.have < state.nlen + state.ndist) {
          for (;;) {
            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          if (here_val < 16) {
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.lens[state.have++] = here_val;
          }
          else {
            if (here_val === 16) {
              //=== NEEDBITS(here.bits + 2);
              n = here_bits + 2;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              if (state.have === 0) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD;
                break;
              }
              len = state.lens[state.have - 1];
              copy = 3 + (hold & 0x03);//BITS(2);
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
            }
            else if (here_val === 17) {
              //=== NEEDBITS(here.bits + 3);
              n = here_bits + 3;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 3 + (hold & 0x07);//BITS(3);
              //--- DROPBITS(3) ---//
              hold >>>= 3;
              bits -= 3;
              //---//
            }
            else {
              //=== NEEDBITS(here.bits + 7);
              n = here_bits + 7;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 11 + (hold & 0x7f);//BITS(7);
              //--- DROPBITS(7) ---//
              hold >>>= 7;
              bits -= 7;
              //---//
            }
            if (state.have + copy > state.nlen + state.ndist) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            while (copy--) {
              state.lens[state.have++] = len;
            }
          }
        }

        /* handle error breaks in while */
        if (state.mode === BAD) { break; }

        /* check for end-of-block code (better have one) */
        if (state.lens[256] === 0) {
          strm.msg = 'invalid code -- missing end-of-block';
          state.mode = BAD;
          break;
        }

        /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */
        state.lenbits = 9;

        opts = { bits: state.lenbits };
        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.lenbits = opts.bits;
        // state.lencode = state.next;

        if (ret) {
          strm.msg = 'invalid literal/lengths set';
          state.mode = BAD;
          break;
        }

        state.distbits = 6;
        //state.distcode.copy(state.codes);
        // Switch to use dynamic table
        state.distcode = state.distdyn;
        opts = { bits: state.distbits };
        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.distbits = opts.bits;
        // state.distcode = state.next;

        if (ret) {
          strm.msg = 'invalid distances set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, 'inflate:       codes ok\n'));
        state.mode = LEN_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case LEN_:
        state.mode = LEN;
        /* falls through */
      case LEN:
        if (have >= 6 && left >= 258) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          inflate_fast(strm, _out);
          //--- LOAD() ---
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          //---

          if (state.mode === TYPE) {
            state.back = -1;
          }
          break;
        }
        state.back = 0;
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if (here_bits <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_op && (here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.lencode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        state.length = here_val;
        if (here_op === 0) {
          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
          //        "inflate:         literal '%c'\n" :
          //        "inflate:         literal 0x%02x\n", here.val));
          state.mode = LIT;
          break;
        }
        if (here_op & 32) {
          //Tracevv((stderr, "inflate:         end of block\n"));
          state.back = -1;
          state.mode = TYPE;
          break;
        }
        if (here_op & 64) {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD;
          break;
        }
        state.extra = here_op & 15;
        state.mode = LENEXT;
        /* falls through */
      case LENEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
        //Tracevv((stderr, "inflate:         length %u\n", state.length));
        state.was = state.length;
        state.mode = DIST;
        /* falls through */
      case DIST:
        for (;;) {
          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if ((here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.distcode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        if (here_op & 64) {
          strm.msg = 'invalid distance code';
          state.mode = BAD;
          break;
        }
        state.offset = here_val;
        state.extra = (here_op) & 15;
        state.mode = DISTEXT;
        /* falls through */
      case DISTEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
//#ifdef INFLATE_STRICT
        if (state.offset > state.dmax) {
          strm.msg = 'invalid distance too far back';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
        state.mode = MATCH;
        /* falls through */
      case MATCH:
        if (left === 0) { break inf_leave; }
        copy = _out - left;
        if (state.offset > copy) {         /* copy from window */
          copy = state.offset - copy;
          if (copy > state.whave) {
            if (state.sane) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break;
            }
// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
          }
          if (copy > state.wnext) {
            copy -= state.wnext;
            from = state.wsize - copy;
          }
          else {
            from = state.wnext - copy;
          }
          if (copy > state.length) { copy = state.length; }
          from_source = state.window;
        }
        else {                              /* copy from output */
          from_source = output;
          from = put - state.offset;
          copy = state.length;
        }
        if (copy > left) { copy = left; }
        left -= copy;
        state.length -= copy;
        do {
          output[put++] = from_source[from++];
        } while (--copy);
        if (state.length === 0) { state.mode = LEN; }
        break;
      case LIT:
        if (left === 0) { break inf_leave; }
        output[put++] = state.length;
        left--;
        state.mode = LEN;
        break;
      case CHECK:
        if (state.wrap) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            // Use '|' instead of '+' to make sure that result is signed
            hold |= input[next++] << bits;
            bits += 8;
          }
          //===//
          _out -= left;
          strm.total_out += _out;
          state.total += _out;
          if (_out) {
            strm.adler = state.check =
                /*UPDATE(state.check, put - _out, _out);*/
                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

          }
          _out = left;
          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
            strm.msg = 'incorrect data check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   check matches trailer\n"));
        }
        state.mode = LENGTH;
        /* falls through */
      case LENGTH:
        if (state.wrap && state.flags) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.total & 0xffffffff)) {
            strm.msg = 'incorrect length check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   length matches trailer\n"));
        }
        state.mode = DONE;
        /* falls through */
      case DONE:
        ret = Z_STREAM_END;
        break inf_leave;
      case BAD:
        ret = Z_DATA_ERROR;
        break inf_leave;
      case MEM:
        return Z_MEM_ERROR;
      case SYNC:
        /* falls through */
      default:
        return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}

function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var state;
  var dictid;
  var ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK;
}

exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/

},{"../utils/common":3,"./adler32":5,"./crc32":7,"./inffast":10,"./inftrees":12}],12:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils = require('../utils/common');

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};

},{"../utils/common":3}],13:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};

},{}],14:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

/* eslint-disable space-unary-ops */

var utils = require('../utils/common');

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;

},{"../utils/common":3}],15:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;

},{}],"/":[function(require,module,exports){
// Top level file is just a mixin of submodules & constants
'use strict';

var assign    = require('./lib/utils/common').assign;

var deflate   = require('./lib/deflate');
var inflate   = require('./lib/inflate');
var constants = require('./lib/zlib/constants');

var pako = {};

assign(pako, deflate, inflate, constants);

module.exports = pako;

},{"./lib/deflate":1,"./lib/inflate":2,"./lib/utils/common":3,"./lib/zlib/constants":6}]},{},[])("/")
});

'use strict';

var appModules = ['ngRoute', 'ngSanitize', 'ngTouch', 'ngAnimate', 'downgrade-deps', 'http-auth-interceptor', 'ui', 'ajoslin.promise-tracker', 'ui.bootstrap', 'colorpicker.module', 'highcharts-ng', 'highcharts-styled-ng', 'ngUpload', 'angularFileUpload', 'fcsa-number', 'checklist-model', 'ui.tree', 'ngToast', 'dynform', 'rzTable', 'angularPayments','popoverToggle', 'dndLists', 'oc.lazyLoad', 'ngFileUpload'];

if (agGrid) {
    agGrid.LicenseManager.setLicenseKey("Orion_Advisor_Services_MultiApp_5Devs11_November_2018__MTU0MTg5NDQwMDAwMA==87e575025c3f23270c07337150ec1006");
    agGrid.initialiseAgGridWithAngular1(angular);
    appModules.push('agGrid');
}
var app = angular.module('orionConnect', appModules);
const sessionId = oas.utils.generateGuid();

app.config(function appConfig($httpProvider, $dialogProvider, datepickerConfig, datepickerPopupConfig, uibPagerConfig, uibPaginationConfig, ngToastProvider, fcsaNumberConfigProvider, $logProvider, $provide, API_CONFIG, $locationProvider, $qProvider) {
    $locationProvider.hashPrefix('');

    $dialogProvider.options({ backdropFade: true, dialogFade: true, keyboard: false, backdropClick: false });

    datepickerConfig.showWeeks = false;
    datepickerConfig.maxDate = Date.create('today');
    datepickerPopupConfig.showButtonBar = false;
    datepickerPopupConfig.datepickerPopup = 'MM/dd/yyyy';
    datepickerPopupConfig.appendToBody = true;
    datepickerPopupConfig.openOnFocus = true;

    uibPagerConfig.align = false;
    uibPagerConfig.previousText = "« Back";

    uibPaginationConfig.previousText ="« Back";

    ngToastProvider.configure({
        animation: 'fade', //or slide
        verticalPosition: 'bottom',
        dismissButton: true,
        dismissOnClick: true
    });

    fcsaNumberConfigProvider.setDefaultOptions({maxDecimals: 2, preventInvalidInput: true, min: 0});

    $httpProvider.interceptors.push('httpGlobalInterceptor');
    $httpProvider.defaults.headers.common.Authorization = 'Session' + (sessionStorage.oas_token ? ' ' + sessionStorage.oas_token : '');
    $httpProvider.defaults.headers.common.BrowserSessionId = sessionId;
    $httpProvider.defaults.headers.get = {'Cache-Control': 'no-cache', Pragma: 'no-cache'};

    $provide.decorator('$http', function($delegate){
        $delegate.pages = function(config) {
            var responses = [];
            if(!config.params) config.params = {};
            if(!config.skip) config.skip = 0;
            if(!config.take) config.take = -1;
			config.useOData = [undefined, true, 'true'].any(config.useOData);
            config.ignoreExceptions = [504].union(config.ignoreExceptions);
            config.loadAllPages = [undefined, true, 'true'].any(config.loadAllPages);

            function page(pageConfig) {
                pageConfig.page = true;
                if(pageConfig.useOData){
                    pageConfig.params.$skip = pageConfig.skip;
                    pageConfig.params.$top = pageConfig.take;
                }else{
                    pageConfig.params.skip = pageConfig.skip;
                    pageConfig.params.top = pageConfig.take;
                }
                pageConfig.trackerMsg = config.trackerMsg + ': Rows ' + (pageConfig.take === -1 ? '' : (pageConfig.skip + 1) + ' to ' + (pageConfig.skip + pageConfig.take));
                return $delegate(pageConfig)
                    .then(function (response) {
                        if (!config.loadAllPages || !Array.isArray(response.data)) return response;
                        responses.push(response);
                        if (response.data.length === response.config.take) {
                            pageConfig.skip += pageConfig.take;
                            return page(pageConfig);
                        } else {
                            return responses;
                        }
                    });
            }

            return page(angular.copy(config)).then(function (calls) {
                if (!Array.isArray(calls)) return calls;

                var response = {data: []};
                response.calls = calls.forEach(function (call) {
                    call.data.forEach(function (item) {
                        response.data.push(item);
                    });
                });
                return response;
            });
        };

        return $delegate;
    });

    $provide.decorator('$q', function ($delegate) {
        function decoratePromise(promise) {
            promise._then = promise.then;
            promise.then = function(thenFn, errFn, notifyFn) {
                var p = promise._then(thenFn, errFn, notifyFn);
                return decoratePromise(p);
            };

            promise.thenSet = function (obj, varName) {
                return promise.then(function (value) {
                    obj[varName] = value;
                    return value;
                });
            };
            return promise;
        }

        var defer = $delegate.defer,
            when = $delegate.when,
            reject = $delegate.reject,
            all = $delegate.all;
        $delegate.defer = function() {
            var deferred = defer();
            decoratePromise(deferred.promise);
            return deferred;
        };
        $delegate.when = function() {
            var p = when.apply(this, arguments);
            return decoratePromise(p);
        };
        $delegate.reject = function() {
            var p = reject.apply(this, arguments);
            return decoratePromise(p);
        };
        $delegate.all = function() {
            var p = all.apply(this, arguments);
            return decoratePromise(p);
        };

        return $delegate;
    });
});

// Custom exception handler to suppress console errors for cancelled requests
app.config(['$provide', function($provide) {
    $provide.decorator('$exceptionHandler', ['$delegate', function($delegate) {
        return function(exception, cause) {
            // Convert exception to string for safe checking
            const exceptionString = typeof exception === 'string' ? exception : 
                                   exception && exception.toString ? exception.toString() : 
                                   String(exception);
            
            // Filter out "Possibly unhandled rejection" errors for cancelled requests
            if (exceptionString && exceptionString.includes('Possibly unhandled rejection')) {
                // Check if it's a cancelled request (status -1 or aborted)
                if (exceptionString.includes('status":-1') || 
                    exceptionString.includes('xhrStatus":"abort"') ||
                    (exception && exception.rejection && exception.rejection.status === -1)) {
                    // Silently ignore cancellation-related rejections
                    return;
                }
            }
            // Handle other exceptions normally
            $delegate(exception, cause);
        };
    }]);
}]);

app.run(function($oasRights, authenticationService) {
    authenticationService.sessionIdChanged(sessionId);    
});

app.config(function ngModelOverrideConfig($provide) {
    $provide.decorator('ngModelDirective', function($delegate) {
        var directive = $delegate[0],
            link = directive.link,
            shouldSetBlurUpdateEvent = function (element) {
                var nodeName = element.nodeName.toLowerCase();

                if (nodeName === "textarea" && !element.attributes['ui-tinymce']) {
                    return true;
                } else if (nodeName === "input" && !element.attributes.typeahead && !element.attributes.colorpicker && !element.attributes['datepicker-popup'] && !element.attributes['fcsa-number']) {
                    var type = element.type ? element.type.toLowerCase(): 'text';
                    return type !== 'checkbox' && type !== 'radio';
                }

                return false;
            };

        // save a reference to the original compile function
        var compileFn = directive.compile;

        directive.compile = function () {
            var link = compileFn.apply(this, arguments);

            return {
                pre: function ngModelPostLink(scope, element, attr, ctrls) {
                    if(ctrls[0] && shouldSetBlurUpdateEvent(element[0])) {
                        ctrls[0].$overrideModelOptions({
                            updateOn: 'blur',
                            updateOnDefault: false
                        })
                    }

                    link.pre.apply(this, arguments);
                },
                post: link.post
            };
        };

        return $delegate;
    });
});

'use strict';

(function () {
    const default_config = {
        baseUrl: '/api/v1',
        cacheTTL: 60 * 1000, // one minute,
        isTest: true,
        insightUrl: window.location.protocol + "//" + window.location.host + '/insight/sso.html',
        vestorlyApiUrl: 'https://www.vestorly.com/api',
        informOnlyRoleId: { user: 14470, admin: 14576 },
        icSocialUrl: 'https://social.orionadvisor.com/',
        socialUrl: 'https://orionadvisor.net/',
        ftjProposalToolUrl: 'http://ftjclone.advisoryworld.com:7080/#/',
        redirectForAuth: true,
    };

    let env_config;

    if (window.location.host.has("local")) {
        env_config = {
            redirectForAuth: false,
            clientPortalUrl: 'http://portal.orionadvisor.local/sso.html',
            repPortalUrl: 'http://localrep.orionadvisor.com/sso.html',
            orionElementWebCommunitiesUrl: 'https://test.communities.orion.com/webcommunities/#/?oas_token=',
            loginUrl: 'http://login.orionadvisor.local/login.html',
            gainsight: { key: null, bots: { default: null, Representative: null } }
        };
    } else if (window.location.host.has("test") || window.location.host.has("review.apps") || window.location.host.has("reviewapps.run")) {
        env_config = {
            clientPortalUrl: 'https://testportal.orionadvisor.com/sso.html',
            repPortalUrl: 'https://testrep.orionadvisor.com/sso.html',
            orionElementWebCommunitiesUrl: 'https://test.communities.orion.com/webcommunities/#/?oas_token=',
            loginUrl: 'https://testlogin.orionadvisor.com/login.html',
            gainsight: { key: 'AP-CWBHW3V1GJDI-2-3', bots: { default: '62c0046b-361e-41f6-a3a1-17e221fde9f8', Representative: '13ff954f-7fe2-4c37-a051-ebcfada8d3df' } }
        };
    } else if (window.location.host.has("staging") || window.location.host.has("rc.")) {
        env_config = {
            clientPortalUrl: 'https://stagingportal.orionadvisor.com/sso.html',
            repPortalUrl: 'https://stagingrep.orionadvisor.com/sso.html',
            orionElementWebCommunitiesUrl: 'https://stage.communities.orion.com/webcommunities/#/?oas_token=',
            loginUrl: 'https://staginglogin.orionadvisor.com/login.html',
            gainsight: { key: 'AP-CWBHW3V1GJDI-2-2', bots: { default: '97bd75ea-27d0-4829-8b04-8a36f81b9a25', Representative: '0987797c-f4d3-4c54-a657-366f250739d3' } }
        };
    } else if (window.location.host.has("uat")) {
        env_config = {
            clientPortalUrl: 'https://portal.uat.orionadvisor.com/sso.html',
            repPortalUrl: 'https://rep.uat.orionadvisor.com/sso.html',
            orionElementWebCommunitiesUrl: 'https://uat.communities.orion.com/webcommunities/#/?oas_token=',
            loginUrl: 'https://login.uat.orionadvisor.com/login.html',
            gainsight: { key: null, bots: { default: null, Representative: null } }
        };
    } else {
        env_config = {
            clientPortalUrl: 'https://portal.orionadvisor.com/sso.html',
            repPortalUrl: 'https://rep.orionadvisor.com/sso.html',
            orionElementWebCommunitiesUrl: 'https://communities.orion.com/webcommunities/#/?oas_token=',
            loginUrl: 'https://login.orionadvisor.com/login.html',
            gainsight: { key: 'AP-CWBHW3V1GJDI-2', bots: { default: '97bd75ea-27d0-4829-8b04-8a36f81b9a25', Representative: '0987797c-f4d3-4c54-a657-366f250739d3' } },
            //default overrides
            isTest: false,
            socialUrl: 'https://social.orionadvisor.com/',
            ftjProposalToolUrl: 'https://ftjfc.advisoryworld.com/#/'
        };
    }

    app.constant('API_CONFIG', angular.extend(default_config, env_config));
})();

app.value('uiTinymceConfig', {
    menubar: false,
    statusbar: false,
    plugins: "link code lists",
    toolbar: "fontfamily fontsize forecolor | bold italic underline strikethrough | alignleft aligncenter alignright | bullist numlist | link unlink code",
    toolbar_mode: "sliding",
    font_family_formats: "Arial=arial; Cambria=cambria; Tahoma=tahoma; Times New Roman=times new roman; Verdana=verdana",
    content_style: "body { font-family: Verdana; }",
    license_key: 'gpl'
});

'use strict';

app.config(function routeConfig($routeProvider, OC2_ROUTES) {
    var hasRouteAccess = ['$route', 'privilegeService', function ($route, privilegeService) {
        return privilegeService.isLoaded
            .then(function () {
                if (privilegeService.canRead($route.current.privilege || $route.current.appCode)) {
                    return true;
                } else {
                    throw "Access Denied";
                }
            });
    }];

    var viewLoader = ['$http', '$route', function ($http, $route) {
        return $http.get('/Settings/Views/' + $route.current.viewCode, {trackerMsg: 'Loading views'})
            .then(function (response) {
                return response.data;
            });
    }];

    var isInformOnlyAdmin = sessionStorage.oas_menu === 'inform-admin';

    var originalWhen = $routeProvider.when;

    function getDeliverSplit($q, splitIoService) {
        var deferred = $q.defer();
        splitIoService.getBoolTreatment('oc_reporting_deliver_newd_grids_oc27613').subscribe(function (isEnabled) {
            deferred.resolve(isEnabled);
        });
        return deferred.promise;
    }

    var compassLandingRedirect = ['$q', '$oasRights', 'mainMenuData', function ($q, $oasRights, mainMenuData) {
        return $q.all([$oasRights.isLoaded, mainMenuData.isLoaded])
            .then(function () {
                return $oasRights.canRead('COMPLIANCERISKDASHBOARD')
                    ? '/tools/compass/riskDashboard'
                    : '/tools/compass/disclose/adv';
            });
    }];

    $routeProvider.when = function (path, route) {
        route.resolve || (route.resolve = {});

        if (!route.public && !route.redirectTo && !route.resolveRedirectTo) {
            route.resolve.hasRouteAccess = hasRouteAccess;
        }

        if (route.viewCode) {
            route.resolve.views = viewLoader;
        }

        if (path && path.startsWith('/tools/compass') && isInformOnlyAdmin) {
            if (path.startsWith('/tools/compass/inform')) {
                route.appCode = 'informAdmin';  //flip appCode so they don't get full compass app
            } else {
                route = {redirectTo: '/main'};  //redirect all Home breadcrumbs in compass
            }
        }

        return originalWhen.call($routeProvider, path, route);
    };

    OC2_ROUTES.forEach(route => {
        $routeProvider.when('/' + route.path, {public: true, template: '', appCode: route.data.appCode, title: route.data.title});
    });

    $routeProvider.when('/', {
        redirectTo: '/main'
    }).when('/menu', {
        redirectTo: '/main'
    }).when('/main', {
        redirectTo: function () {
            if (sessionStorage.oas_menu === 'element') {
                window.close();
                return;
            }

            return '/orion/dashboard';
        }
    }).when('/loginas/prompt', {
        controller: 'LoginAsCtrl',
        templateUrl: 'app/modals/login-as.html',
        public: true,
        hideNav: true,
        resolve: {
            args: function ($route) {
                return {
                    loginDestination: $route.current.params.ld,
                    loginUrl: $route.current.params.lu,
                };
            },
            dialog: angular.noop
        }
    }).when('/glia/prompt', {
        controller: 'GliaModalCtrl',
        templateUrl: 'app/modals/GliaModal.html',
        public: true,
        hideNav: true,
        resolve: {
            dialog: angular.noop
        }
    }).when('/notificationdirect/:id', {
        controller: function ($http, $location, $routeParams) {
            $http.get('/Reporting/Fuse/Notifications/' + $routeParams.id)
                .then(function (response) {
                    var url = response.data.url;
                    if (!url) return;

                    var isTrustedDestination = url.startsWith('/') || url.startsWith('#/');

                    if (!isTrustedDestination) {
                        try {
                            var parsed = new URL(url);
                            isTrustedDestination = parsed.hostname === window.location.hostname ||
                                parsed.hostname.endsWith('.orionadvisor.com') ||
                                parsed.hostname.endsWith('.orionadvisor.local');
                        } catch (e) {
                            return;
                        }
                    }

                    if (url.startsWith('/') && !url.toLocaleLowerCase().startsWith('/api/v1')) {
                        url = '/api/v1' + url;
                    }

                    if (isTrustedDestination) {
                        window.location.href = url + (url.has('?') ? '&' : '?') + 'Authorization=' + sessionStorage.oas_token;
                    } else {
                        window.location.href = url;
                    }
                });

            $location.path('/main');
        },
        template: '<div></div>',
        public: true
    }).when('/Glia',{
        controller:'GliaCtrl',
        templateUrl:'app/components/Glia.html',
        appCode:'gliaCobrowse'
    }).//ADVISOR PAGES
        when('/advisor', {
            redirectTo: '/advisor/quarterend'
        }).when('/advisor/quarterend', {
        controller: 'ListCtrl',
        templateUrl: 'app/views/list.html',
        appCode: 'qpeDashboard',
        resolve: {config: quarterEndDashboardCtrl.getQPEListConfig}
    }).when('/advisor/qeprocessmgr/:dashboardId', {
        controller: 'QuarterEndProcessMgrCtrl',
        templateUrl: 'advisor/views/quarter-end-process-mgr.html',
        appCode: 'qpeDashboard'
    }).when('/advisor/quarterend/:dashboardId', {
        controller: 'QuarterEndDashboardCtrl',
        templateUrl: 'advisor/views/quarter-end-dashboard.html',
        appCode: 'qpeDashboard'
    }).when('/advisor/interfacesetup', {
        controller: 'ListCtrl',
        templateUrl: 'app/views/list.html',
        appCode: 'qpeDashboard',
        resolve: {config: interfaceSetupProcessCtrl.getInterfaceSetupProcessListConfig}
    }).when('/advisor/interfacesetup/:dashboardId', {
        controller: 'InterfaceSetupProcessCtrl',
        templateUrl: 'advisor/views/interface-setup-process.html',
        appCode: 'qpeDashboard'
    }).when('/advisor/implementation', {
        controller: 'ImplementationDashboardCtrl',
        templateUrl: 'advisor/views/implementation-dashboard.html',
        appCode: 'implementation'
    }).when('/advisor/rmd/accountimport', {
        redirectTo: '/advisor/rmd/import'
    }).when('/advisor/rmd/import-old', {
        redirectTo: '/advisor/rmd/import'
    }).when('/advisor/rmd/:status?', {
        resolveRedirectTo: ['dbeoService', '$route', function (dbeoService, $route) {
            const status = $route.current.params.status ?? '';
            return dbeoService.get('69USENEWRMDDASHBOARD')
                .then((useNewPage) => {
                    return useNewPage ? '/advisor/rmd/Accounts/' + status : '/advisor/rmd-old/' + status;
                });
        }]
    }).when('/advisor/rmd-old/:status?', {
        controller: 'RMDDashboardCtrl',
        templateUrl: 'advisor/views/rmd-dashboard.html',
        appCode: 'rmdDashboard',
        viewCode: 'RMDDashboardDto'
    }).when('/advisor/clientExperience',{
        resolveRedirectTo:clientTasksCtrl.getDefaultRoute
    }).when('/advisor/clientTasksList', {
        controller: 'ListCtrl',
        templateUrl: 'app/views/list.html',
        resolve: {config: clientTasksCtrl.getClientTasksConfig},
        appCode: 'clientExperience',
        privilege: 'newsfeedPosts'
    }).when('/advisor/clientTasks/:clientTaskId', {
        controller: 'clientTasksCtrl',
        templateUrl: 'advisor/views/clientTasks.html',
        appCode: 'clientExperience',
        privilege: 'newsfeedPosts'
    }).when('/advisor/newsFeedPosts', {
        controller: 'newsFeedPostsCtrl',
        templateUrl: 'advisor/views/newsFeedPosts.html',
        appCode: 'clientExperience',
        viewCode: 'NewsfeedPostGridDto',
        privilege: 'newsfeedPosts'
    }).when('/advisor/newsFeedPostEdit/:id', {
        controller: 'newsFeedPostEditCtrl',
        templateUrl: 'advisor/editors/views/newsfeed-post-edit.html',
        appCode: 'clientExperience',
        viewCode: 'NewsfeedPostGridDto',
        privilege: 'newsfeedPosts'
    }).when('/advisor/newsFeedRss', {
        controller: 'newsFeedRssCtrl',
        templateUrl: 'advisor/views/newsFeedRss.html',
        appCode: 'clientExperience',
        viewCode: 'NewsfeedRssGridDto',
        privilege: 'newsfeedPosts'
    }).when('/advisor/clientPortalSettings', {
        controller: function ($scope, $sce, API_CONFIG) {
            const urlParts = {token: sessionStorage.oas_token, baseUrl: API_CONFIG.clientPortalUrl};
            $scope.url = $sce.trustAsResourceUrl('{baseUrl}?t={token}'.assign(urlParts).replace('sso.html', 'settings-only.html#/settings'));
            $scope.resizeOptions = {
                enablePublicMethods: true,
                heightCalculationMethod: "grow"
            }
        },
        template: '<main-content><iframe id="portal-settings" iframe-resizer resize-options="resizeOptions" ng-src="{{ url }}" scrolling="no" seamless="seamless"></iframe></main-content>',
        appCode: 'clientExperience',
        privilege: 'clientPortalAdmin'
    }).when('/advisor/contactinfo', {
        resolveRedirectTo: ['$q', 'splitIoService', function($q, splitIoService) {
            const getSplit = function() {
                const deferred = $q.defer();
                splitIoService.getBoolTreatment('pi_firmprofile_contactinfo-usenewcomponent_oc14819').subscribe((isEnabled) => {
                    deferred.resolve(isEnabled);
                });
                return deferred.promise;
            }
            return getSplit().then(function(isEnabled) {
                return isEnabled ? '/firm-advisor/contactinfo' : '/advisor/contactinfo-old';
            });
        }]
    }).when('/advisor/contactinfo-old', {
        controller: 'AdvisorContactInfoCtrl',
        templateUrl: 'advisor/views/advisorContactInfo.html',
        appCode: 'firmProfile'
    }).when('/advisor/opsmaintenance', {
        controller: 'OpsMaintenanceListCtrl',
        templateUrl: 'advisor/views/ops-maintenance-list.html',
        appCode: 'firmProfile',
        viewCode: 'AlClientOpsDto'
    }).when('/advisor/optioninfo', {
        controller: 'AdvisorOptionInfoCtrl',
        templateUrl: 'advisor/views/advisorOptionInfo.html',
        appCode: 'firmProfile'
    }).when('/advisor/brokerdealers', {
        controller: 'BrokerDealersListCtrl',
        templateUrl: 'advisor/lists/views/brokerdealers-list.html',
        appCode: 'firmProfile',
        viewCode: 'BrokerDealerDto'
    }).when('/advisor/businesslines', {
        controller: 'BusinessLinesListCtrl',
        templateUrl: 'advisor/lists/views/business-lines-list.html',
        appCode: 'firmProfile',
        viewCode: 'BusinessLineDto'
    }).when('/advisor/representatives', {
        template: '',
        appCode: 'firmProfile',
        resolveRedirectTo: ['$q', 'splitIoService', function($q, splitIoService) {
            const getSplit = function() {
                const deferred = $q.defer();
                splitIoService.getBoolTreatment('pi_firmprofile_representative_oc14817').subscribe((isEnabled) => {
                    deferred.resolve(isEnabled);
                });
                return deferred.promise;
            }
            return getSplit().then(function(isEnabled) {
                return isEnabled ? '/advisor/representatives' : '/advisor/representatives-old';
            });
        }]
    }).when('/advisor/representatives-old', {
        controller: 'RepresentativesListCtrl',
        templateUrl: 'advisor/lists/views/representatives-list.html',
        appCode: 'firmProfile',
        viewCode: 'RepresentativeDto'
    }).when('/advisor/rias', {
        controller: 'RIAsListCtrl',
        templateUrl: 'advisor/lists/views/rias-list.html',
        appCode: 'firmProfile',
        viewCode: 'RIADto'
    }).when('/advisor/subadvisors', {
        controller: 'SubAdvisorsListCtrl',
        templateUrl: 'advisor/lists/views/subadvisors-list.html',
        appCode: 'firmProfile',
        viewCode: 'SubAdvisorDto'
    }).when('/advisor/wholesalers', {
        controller: 'WholesalersListCtrl',
        templateUrl: 'advisor/lists/views/wholesalers-list.html',
        appCode: 'firmProfile',
        viewCode: 'WholesalerDto'
    })
    
    .when('/advisor/planadministrators', {
        template: '',
        appCode: 'firmProfile',
        resolveRedirectTo: ['$q', 'splitIoService', function($q, splitIoService) {
            const getSplit = function() {
                const deferred = $q.defer();
                splitIoService.getBoolTreatment('oc_firmprofile_plan_administrators_usenewcomponent_oc15695').subscribe((isEnabled) => {
                    deferred.resolve(isEnabled);
                });
                return deferred.promise;
            }
            return getSplit().then(function(isEnabled) {
                return isEnabled ? '/advisor/planadministrators' : '/advisor/planadministrators-old';
            });
        }]
    }).when('/advisor/planadministrators-old', {
        controller: 'PlanAdministratorsListCtrl',
        templateUrl: 'advisor/lists/views/planadministrators-list.html',
        appCode: 'firmProfile',
        viewCode: 'PlanAdministratorDto'
    })

    .when('/advisor/payees', {
        redirectTo: '/firmprofile/payees'
    }).when('/advisor/geminifund', {
        controller: 'GeminiFundListCtrl',
        templateUrl: 'advisor/lists/views/gemini-fund-list.html',
        appCode: 'geminiFundApp',
        viewCode: 'GeminiFundDto'
    }).when('/advisor/geminifundperformance', {
        controller: 'GeminiFundPerformanceCtrl',
        templateUrl: 'advisor/views/gemini-fund-performance.html',
        appCode: 'geminiFundApp'
    }).when('/advisor/geminiimport', {
        controller: 'GeminiImportCtrl',
        templateUrl: 'advisor/views/gemini-import.html',
        appCode: 'geminiFundApp'
    }).when('/advisor/geminifund/:id', {
        controller: 'GeminiFundEditCtrl',
        templateUrl: 'advisor/editors/views/geminifund-edit.html',
        appCode: 'geminiFundApp'
    }).when('/advisor/geminifunddata', {
        controller: 'GeminiFundDataListCtrl',
        templateUrl: 'advisor/lists/views/gemini-funddata-list.html',
        appCode: 'geminiFundApp',
        viewCode: 'GeminiFundDataDto',
        resolve: {dates: geminiFundDataListCtrl.loadFundDataListDates}
    }).when('/advisor/geminifunddata/:id/:rateDate', {
        controller: 'GeminiFundDataEditCtrl',
        templateUrl: 'advisor/editors/views/geminifund-data-edit.html',
        appCode: 'geminiFundApp'
    }).when('/advisor/geminifunddivdetail', {
        controller: 'GeminiFundDivDetailListCtrl',
        templateUrl: 'advisor/lists/views/gemini-funddivdetail-list.html',
        appCode: 'geminiFundApp',
        viewCode: 'GeminiFundDivDetailDto',
        resolve: {dates: geminiFundDivDetailListCtrl.loadFundDivDetailListDates}
    }).when('/advisor/geminifunddivdetail/:id/:rateDate/:isNew', {
        controller: 'GeminiFundDivDetailEditCtrl',
        templateUrl: 'advisor/editors/views/geminifund-divdetail-edit.html',
        appCode: 'geminiFundApp'
    }).when('/advisor/geminifundbackload', {
        controller: 'GeminiFundBackLoadListCtrl',
        templateUrl: 'advisor/lists/views/gemini-fundbackload-list.html',
        appCode: 'geminiFundApp',
        viewCode: 'GeminiFundLoadDto',
        resolve: {forYear: geminiFundBackLoadListCtrl.loadFundBackLoadForYear}
    }).when('/advisor/geminifundbackload/:id', {
        controller: 'GeminiFundBackLoadEditCtrl',
        templateUrl: 'advisor/editors/views/geminifund-backload-edit.html',
        appCode: 'geminiFundApp'
    }).when('/advisor/geminifundfrontload/:id', {
        controller: 'GeminiFundFrontLoadEditCtrl',
        templateUrl: 'advisor/editors/views/geminifund-frontload-edit.html',
        appCode: 'geminiFundApp'
    }).when('/advisor/geminifunddiv', {
        controller: 'GeminiFundDivListCtrl',
        templateUrl: 'advisor/lists/views/gemini-funddiv-list.html',
        appCode: 'geminiFundApp',
        viewCode: 'GeminiFundDivDto',
        resolve: {divData: geminiFundDivListCtrl.loadFundDivYear}
    }).when('/advisor/geminifunddiv/:id/:divYear', {
        controller: 'GeminiFundDivRateEditCtrl',
        templateUrl: 'advisor/editors/views/geminifund-divrate-edit.html',
        appCode: 'geminiFundApp'
    }).when('/advisor/geminifundindexlink', {
        controller: 'GeminiFundIndexLinkListCtrl',
        templateUrl: 'advisor/lists/views/gemini-fundindexlink-list.html',
        appCode: 'geminiFundApp',
        viewCode: 'GeminiFundIndexLinkDto'
    }).when('/advisor/geminifundindexlink/:id/:indexNumber', {
        controller: 'GeminiFundIndexLinkEditCtrl',
        templateUrl: 'advisor/editors/views/geminifund-indexlink-edit.html',
        appCode: 'geminiFundApp'
    }).when('/advisor/geminifundgroup', {
        controller: 'GeminiFundGroupListCtrl',
        templateUrl: 'advisor/lists/views/gemini-fundgroup-list.html',
        appCode: 'geminiFundApp',
        viewCode: 'GeminiFundGroupDto'
    }).when('/advisor/geminifundgroup/:id', {
        controller: 'GeminiFundGroupEditCtrl',
        templateUrl: 'advisor/editors/views/geminifund-group-edit.html',
        appCode: 'geminiFundApp'
    }).when('/advisor/geminifundtax', {
        controller: 'GeminiFundTaxListCtrl',
        templateUrl: 'advisor/lists/views/gemini-fundtax-list.html',
        appCode: 'geminiFundApp',
        viewCode: 'GeminiFundTaxDto'
    }).when('/advisor/geminifundtax/:id', {
        controller: 'GeminiFundTaxRateEditCtrl',
        templateUrl: 'advisor/editors/views/geminifund-taxrate-edit.html',
        appCode: 'geminiFundApp'
    }).when('/advisor/geminifundcalendar', {
        controller: 'GeminiFundCalendarListCtrl',
        templateUrl: 'advisor/lists/views/gemini-fundcalendar-list.html',
        appCode: 'geminiFundApp',
        viewCode: 'GeminiFundCalendarDto'
    }).when('/advisor/geminifundcalendar/:id', {
        controller: 'GeminiFundCalendarEditCtrl',
        templateUrl: 'advisor/editors/views/geminifund-calendar-edit.html',
        appCode: 'geminiFundApp'
    }).when('/advisor/inflationrates', {
        controller: 'InflationRatesCtrl',
        templateUrl: 'advisor/views/inflation-rates.html',
        appCode: 'firmProfile'
    }).//BILLING PAGES
        when('/billing', {
            redirectTo: '/billing/audit/households'
        }).when('/billing/consolidation', { // Begin Consolidated Billing
        controller: 'BillGeneratorSummaryCtrl',
        templateUrl: 'billing/generator/views/billgenerator-summary.html',
        appCode: 'billing',
        privilege: 'consolidatedBilling'
    }).when('/billing/consolidation/billinstances', {
        controller: 'BillInstanceCtrl',
        templateUrl: 'billing/generator/lists/billinstance.html',
        appCode: 'billing',
        privilege: 'consolidatedBilling',
        viewCode: 'BillInstanceDto'
    }).when('/billing/consolidation/feecollection', {
        controller: 'FeeCollectionInstancesCtrl',
        templateUrl: 'billing/generator/lists/views/fee-collection-instances.html',
        appCode: 'billing',
        privilege: 'consolidatedBilling',
        viewCode: 'BillFeeCollectInstanceDto'
    }).when('/billing/consolidation/outstandingreceivables', {
        controller: 'PostPaymentsCtrl',
        templateUrl: 'billing/views/post-payments.html',
        appCode: 'billing',
        privilege: 'consolidatedBilling',
        viewCode: 'PostPaymentsDto'
    }).when('/billing/consolidation/paidreceivables', {
        controller: 'PostedPaymentsCtrl',
        templateUrl: 'billing/views/posted-payments.html',
        appCode: 'billing',
        privilege: 'consolidatedBilling',
        viewCode: 'PostedPaymentDto'
    }).when('/billing/consolidation/planningfees', {
        controller: 'BillGeneratorViewPlanFeesCtrl',
        templateUrl: 'billing/generator/views/billgenerator-viewplanningfees.html',
        appCode: 'billing',
        privilege: 'consolidatedBilling',
        viewCode: 'FinancialPlanningFeeDto'
    }).when('/billing/audit/households/:status?', {
        controller: 'BillingAuditHouseholdListCtrl',
        templateUrl: 'billing/views/billingaudit-household-list.html',
        appCode: 'billingAudit',
        viewCode: 'BillClientDto'
    }).when('/billing/audit/relatedhousehold', {
        controller: 'BillingAuditRelatedHouseholdCtrl',
        templateUrl: 'billing/views/billingaudit-relatedhousehold.html',
        appCode: 'billingAudit',
        viewCode: 'RelatedBillingClientDto'
    }).when('/billing/audit/accounts/recurringadjustments', {
        controller: 'BillingAuditRecurringAdjustmentsListCtrl',
        templateUrl: 'billing/views/billingaudit-recurring-adjustments-list.html',
        appCode: 'billingAudit',
        viewCode: 'BillAccountRecurringAdjustmentDto'
    }).when('/billing/audit/accounts/:status?', {
        controller: 'BillingAuditAccountListCtrl',
        templateUrl: 'billing/views/billingaudit-account-list.html',
        appCode: 'billingAudit',
        resolve: {
            views: billingAuditAccountListCtrl.loadBillingAccountViews,
            searchResult: billingAuditAccountListCtrl.loadAccountFilter
        }
    }).when('/billing/generator/billingcompare', {
        controller: 'BillingAuditBillingCompareCtrl',
        templateUrl: 'billing/views/billingaudit-billingcompare.html',
        appCode: 'billGenerator',
        viewCode: 'BillingCompareDto'
    }).when('/billing/generator/billingcomparedashboard', {
        controller: 'BillingAuditBillingCompareDashboardCtrl',
        templateUrl: 'billing/views/billingaudit-billingcompare-dashboard.html',
        appCode: 'billGenerator',
        viewCode: 'BillingCompareDto'
    }).when('/billing/generator/viewplanningfees', {
        controller: 'BillGeneratorViewPlanFeesCtrl',
        templateUrl: 'billing/generator/views/billgenerator-viewplanningfees.html',
        appCode: 'billGenerator',
        viewCode: 'FinancialPlanningFeeDto'
    }).when('/billing/audit/billingcompare', {
        controller: 'BillingAuditBillingCompareCtrl',
        templateUrl: 'billing/views/billingaudit-billingcompare.html',
        appCode: 'billingAudit',
        viewCode: 'BillingCompareDto'
    }).when('/billing/audit/billingcomparedashboard', {
        controller: 'BillingAuditBillingCompareDashboardCtrl',
        templateUrl: 'billing/views/billingaudit-billingcompare-dashboard.html',
        appCode: 'billingAudit',
        viewCode: 'BillingCompareDto'
    }).when('/billing/audit/assets/:status', {
        controller: 'BillingAuditAssetListCtrl',
        templateUrl: 'billing/views/billingaudit-asset-list.html',
        appCode: 'billingAudit',
        resolve: {views: billingAuditAssetListCtrl.loadBillingAssetViews}
    }).when('/billing/audit/products/feeexcluded', {
        controller: 'BillingAuditFeeExcludedProductsCtrl',
        templateUrl: 'billing/views/billingaudit-fee-excluded-product.html',
        appCode: 'billingAudit',
        viewCode: 'BillProductFeeExcludedDto'
    }).when('/billing/audit/products/householdfeeexcluded', {
        controller: 'BillingAuditHouseholdFeeExcludedProductsListCtrl',
        templateUrl: 'billing/views/billingaudit-household-fee-excluded-product-list.html',
        appCode: 'billingAudit',
        viewCode: 'HouseholdExclusionDto'
    }).when('/billing/audit/transactions/billeligible', {
        controller: 'BillingAuditTransactionListCtrl',
        templateUrl: 'billing/views/billingaudit-transaction-list.html',
        appCode: 'billingAudit',
        viewCode: 'BillTransactionDto',
        resolve: {searchResult: billingAuditTransactionListCtrl.loadTransactionFilter}
    }).when('/billing/audit/transactions/billsleeve', {
        controller: 'BillingAuditTransactionSleeveListCtrl',
        templateUrl: 'billing/views/billingaudit-transaction-sleeve-list.html',
        appCode: 'billingAudit',
        viewCode: 'BillTransactionDto'
    }).when('/billing/audit/transactions/feeexcludedassets', {
        controller: 'BillingAuditFeeExcludedAssetsCtrl',
        templateUrl: 'billing/views/billingaudit-fee-excluded-assets.html',
        appCode: 'billingAudit',
        viewCode: 'BillTransactionDto'
    }).when('/billing/audit/billdata', {
        controller: 'BillingAuditBillDataListCtrl',
        templateUrl: 'billing/views/billingaudit-billdata-list.html',
        appCode: 'billingAudit',
        viewCode: 'BillDataDto'
    }).when('/billing/audit/receivables', {
        controller: 'BillingAuditReceivablesListCtrl',
        templateUrl: 'billing/views/billingaudit-receivables-list.html',
        appCode: 'billingAudit',
        viewCode: 'ReceiveableSummaryDto'
    }).when('/billing/audit/payables', {
        controller: 'BillingAuditPayablesListCtrl',
        templateUrl: 'billing/views/billingaudit-payables-list.html',
        appCode: 'billingAudit',
        viewCode: 'PayableSummaryDto'
    }).when('/billing/referralpayments', {
        controller: 'ReferralPaymentsCtrl',
        templateUrl: 'billing/views/referralpayments-list.html',
        viewCode: 'ReferralPaymentDto',
        appCode: 'referralPayments',
        resolve: {config: referralPaymentsListCtrl.loadReferralPaymentConfig}
    }).when('/billing/referralschedules', {
        controller: 'ReferralScheduleListCtrl',
        templateUrl: 'billing/views/referral-schedules-list.html',
        appCode: 'firmProfile'
    }).when('/billing/referralschedules/:referralscheduleId', {
        controller: 'ReferralPaymentSchedulesCtrl',
        templateUrl: 'billing/views/referralSchedules.html',
        appCode: 'firmProfile'
    }).when('/billing/audit/files', {
        controller: 'BillingAuditFileListCtrl',
        templateUrl: 'billing/views/billingaudit-file-list.html',
        appCode: 'billingAudit'
    }).when('/billing/feecalculator', {
        controller: 'FeeCalculatorCtrl',
        templateUrl: 'billing/views/fee-calculator.html',
        appCode: 'feeCalculator'
    }).when('/billing/postpayments', {
        controller: 'PostPaymentsCtrl',
        templateUrl: 'billing/views/post-payments.html',
        appCode: 'postPayments',
        viewCode: 'PostPaymentsDto'
    }).when('/billing/postedpayments', {
        controller: 'PostedPaymentsCtrl',
        templateUrl: 'billing/views/posted-payments.html',
        appCode: 'postPayments',
        viewCode: 'PostedPaymentDto'
    }).when('/billing/related/import', {
        controller: 'RelatedHouseholdImportCtrl',
        templateUrl: 'billing/views/related-household-import.html',
        appCode: 'billingAudit'
    }).when('/billing/paysfor/import', {
        controller: 'PaysForImportCtrl',
        templateUrl: 'billing/views/pays-for-import.html',
        appCode: 'billingAudit'
    }).when('/billing/generator/billsummary', {
        controller: 'BillGeneratorSummaryCtrl',
        templateUrl: 'billing/generator/views/billgenerator-summary.html',
        appCode: 'billGenerator'
    }).when('/billing/generator/planningfee', {
        controller: 'BillGeneratorPlanFeeCtrl',
        templateUrl: 'billing/generator/views/billgenerator-planfee.html',
        appCode: 'billGenerator'
    }).when('/billing/generator/generatebill', {
        controller: 'BillGeneratorGenerateBillCtrl',
        templateUrl: 'billing/generator/views/billgenerator-generate-bill.html',
        appCode: 'billGenerator'
    }).when('/billing/generator/finalbills', {
        controller: 'BillGeneratorFinalBillsCtrl',
        templateUrl: 'billing/generator/views/billgenerator-finalbills.html',
        appCode: 'billGenerator'
    }).when('/billing/generator/ready', {
        controller: 'BillInstanceRunListCtrl',
        templateUrl: 'billing/generator/lists/billinstance_runList.html',
        appCode: 'billGenerator',
        viewCode: 'BillInstanceClientDto'
    }).when('/billing/generator/instances', {
        controller: 'BillInstanceCtrl',
        templateUrl: 'billing/generator/lists/billinstance.html',
        appCode: 'billGenerator',
        viewCode: 'BillInstanceDto'
    }).when('/billing/generator/feecollectioninstances', {
        controller: 'FeeCollectionInstancesCtrl',
        templateUrl: 'billing/generator/lists/views/fee-collection-instances.html',
        appCode: 'billGenerator',
        viewCode: 'BillFeeCollectInstanceDto'
    }).when('/billing/generator/createfinalbillswithdefaultadjustments/:status?', {
        controller: 'FinalBillsWithDefaultAdjustmentsCtrl',
        templateUrl: 'billing/generator/lists/views/final-bills-with-default-adjustments.html',
        appCode: 'billGenerator',
        viewCode: 'FinalBillInstanceItemAccountDto'
    }).when('/billing/generator/revenuepayouts', {
        controller: 'RevenuePayoutsCtrl',
        templateUrl: 'billing/generator/lists/views/revenue-payouts.html',
        appCode: 'billGenerator',
        viewCode: 'RevenuePayoutDto'
    }).when('/billing/generator/householdsummary/:id?', {
        controller: 'BillSummaryCtrl',
        templateUrl: 'billing/generator/views/billing-summary.html',
        appCode: 'billGenerator',
        resolve: {config: billSummaryCtrl.loadHousehold},
        viewCode: 'BillAccountSummaryDto'
    }).when('/billing/generator/revenuepayoutsedit/:id', {
        controller: 'RevenuePayoutsEditCtrl',
        templateUrl: 'billing/generator/editors/revenue-payouts-edit.html',
        appCode: 'billGenerator'
    }).when('/billing/generator/feecollectioninstances/:id', {
        controller: 'FeeCollectionDetailsCtrl',
        templateUrl: 'billing/generator/lists/views/fee-collection-details.html',
        appCode: 'billGenerator',
        viewCode: 'BillFeeCollectDetailDto'
    }).when('/billing/generator/feeinstancenew', {
        controller: 'FeeInstanceNewCtrl',
        templateUrl: 'billing/generator/views/fee-instance-new.html',
        appCode: 'billGenerator'
    }).when('/billing/generator/cashfunding', {
        controller: 'BillingAuditReceivablesListCtrl',
        templateUrl: 'billing/views/billingaudit-receivables-list.html',
        appCode: 'billGenerator',
        viewCode: 'ReceiveableSummaryDto'
    }).when('/billing/audit/cashfunding', {
        controller: 'BillingAuditReceivablesListCtrl',
        templateUrl: 'billing/views/billingaudit-receivables-list.html',
        appCode: 'billingAudit',
        viewCode: 'ReceiveableSummaryDto'
    }).when('/billing/generator/flatfee', {
        controller: 'BillGeneratorFeeCalculatorCtrl',
        templateUrl: 'billing/generator/editors/billgenerator-fee-calculator.html',
        appCode: 'billGenerator'
    }).when('/billing/audit/schedules/:sched', {
        controller: 'FeeScheduleListCtrl',
        templateUrl: 'billing/lists/views/feeSchedule-list.html',
        appCode: 'billingAudit',
        viewCode: 'BillScheduleDto'
    }).when('/billing/audit/payoutschedules', {
        controller: 'PayoutScheduleListCtrl',
        templateUrl: 'billing/lists/views/payoutSchedule-list.html',
        appCode: 'billingAudit',
        viewCode: 'MasterPayoutScheduleDto'
    }).when('/billing/audit/referralschedules', {
        controller: 'ReferralScheduleListCtrl',
        templateUrl: 'billing/views/referral-schedules-list.html',
        appCode: 'billingAudit'
    }).when('/billing/assignedSchedules', {
        controller: 'FeeScheduleAssignmentCtrl',
        templateUrl: 'billing/editors/fee-schedule-assignment.html',
        appCode: 'billingAudit'
    }).when('/billing/feetypes', {
        controller: 'FeeTypeListCtrl',
        templateUrl: 'billing/lists/views/fee-type-list.html',
        appCode: 'firmProfile',
        viewCode: 'FeeTypeDto'
    }).when('/billing/billentities', {
        redirectTo: '/firmprofile/billentities'
    }).when('/billing/cancellationfeeadjustmentdefaults', {
        redirectTo: '/firmprofile/finalbilladjustments'
    }).when('/billing/billpaymethods', {
        controller: 'BillPayMethodListCtrl',
        templateUrl: 'billing/lists/views/bill-pay-method-list.html',
        appCode: 'firmProfile',
        viewCode: 'BillPayMethodDto'
    }).when('/billing/adjustmenttypes', {
        redirectTo: '/firmprofile/adjustmenttypes'
    }).when('/billing/managementfeesnotposted', {
        controller: 'ManagementFeesNotPostedCtrl',
        templateUrl: 'billing/lists/views/management-fees-not-posted.html',
        appCode: 'postPayments',
        viewCode: 'managementFeesNotPostedDto'
    }).when('/billing/billinglog', {
        controller: 'BillingLogCtrl',
        templateUrl: 'billing/generator/views/billing-log.html',
        appCode: 'billGenerator'
    }).when('/billing/payout/dashboard/:status?', {
        controller: 'PayoutDashboardCtrl',
        templateUrl: 'billing/views/payout-dashboard.html',
        appCode: 'payoutDashboard',
        viewCode: 'PayoutDashboardDto'
    }).when('/billing/payout/dashboard2/:status?', {
        controller: 'PayoutDashboardCtrl',
        templateUrl: 'billing/views/payout-dashboard2.html',
        appCode: 'payoutDashboard',
        viewCode: 'PayoutDashboardDto'
    }).when('/billing/payout/entities', {
        controller: 'PayoutEntitiesCtrl',
        templateUrl: 'billing/views/payout-entities.html',
        appCode: 'payoutDashboard',
        viewCode: 'BillPayoutDashboardPaymentDto'
    }).when('/billing/payout/payoutadvisorfeereports', {
        controller: 'PayoutAdvisoryFeeReportsCtrl',
        templateUrl: 'billing/views/payout-advisory-fee-reports.html',
        appCode: 'payoutDashboard',
        viewCode: 'BillPayoutDashboardPaymentDto'
    }).when('/billing/feehierarchy', {
        controller: 'BillingFeeHierarchyListCtrl',
        templateUrl: 'billing/views/billing-fee-hierarchy-list.html',
        appCode: 'billingAudit'
    }).when("/billing/payoutdashboardlanding", {
        controller: 'PayoutDashboardLandingCtrl',
        templateUrl: 'billing/views/payout-dashboard-landing.html',
        appCode: 'payoutDashboard'
    }).// CONFIRMATION PAGES
        when('/confirmation/overview', {
            templateUrl: 'confirmation/views/confirmation-overview.html',
            controller: 'ConfirmationOverviewCtrl',
            appCode: 'confirmationOverview',
            viewCode: 'ConfirmOverviewDto',
            resolve: {defaults: confirmationOverviewCtrl.loadDefaults}
        }).when('/confirmation/analysis', {
        templateUrl: 'confirmation/views/confirmation-analysis.html',
        controller: 'ConfirmationAnalysisCtrl',
        appCode: 'confirmationOverview'
    }).when('/confirmation/groups', {
        templateUrl: 'confirmation/views/confirmation-group-list.html',
        controller: 'ConfirmationGroupListCtrl',
        appCode: 'confirmationOverview',
        viewCode: 'ConfirmGroupDto'
    }).when('/confirmation/audits/:audit', {
        templateUrl: 'confirmation/views/confirmation-audit-list.html',
        controller: 'ConfirmationAuditListCtrl',
        appCode: 'confirmationOverview',
        resolve: {
            views: confirmationAuditListCtrl.loadConfirmationAuditViews,
            defaults: confirmationOverviewCtrl.loadDefaults
        }
    }).when('/confirmation/audits/:audit/:customReport/:downloadSource', {
        controller: 'ReconciliationAlertsCtrl',
        templateUrl: 'confirmation/views/reconciliation-alerts.html',
        appCode: 'confirmationOverview',
        resolve: {config: reconciliationAlertsCtrl.loadDataQueryConfigForRecon},
        viewCode: 'DataAuditsConfirmOverviewDashboardDto'
    }).when('/confirmation/scrubs', {
        templateUrl: 'confirmation/views/confirmation-scrub-list.html',
        controller: 'ConfirmationScrubListCtrl',
        appCode: 'confirmationOverview'
    }).when('/confirmation/signoffs', {
        templateUrl: 'confirmation/views/confirmation-signoff-list.html',
        controller: 'ConfirmationSignOffListCtrl',
        appCode: 'confirmationOverview'
    }).when('/confirmation/formats', {
        templateUrl: 'confirmation/views/confirmation-format-list.html',
        controller: 'ConfirmationFormatListCtrl',
        appCode: 'confirmationOverview',
        viewCode: 'DownloadFormatDto'
    }).when('/confirmation/sources', {
        templateUrl: 'confirmation/views/confirmation-source-list.html',
        controller: 'ConfirmationSourceListCtrl',
        appCode: 'confirmationOverview',
        viewCode: 'DownloadSourceDto'
    }).when('/confirmation/sleevesettings', {
        templateUrl: 'confirmation/views/confirmation-sleeve-settings.html',
        controller: 'ConfirmationSleeveSettingListCtrl',
        appCode: 'confirmationOverview',
        viewCode: 'DownloadSourceDto'
    }).when('/confirmation/positionprocesses', {
        templateUrl: 'confirmation/views/confirmation-position-processes.html',
        controller: 'ConfirmationPositionProcessesListCtrl',
        appCode: 'confirmationOverview',
        viewCode: 'DownloadSourceDto'
    }).when('/confirmation/scrubautomations', {
        templateUrl: 'confirmation/views/confirmation-scrub-automation.html',
        controller: 'ConfirmationScrubAutomationListCtrl',
        appCode: 'confirmationOverview',
        viewCode: 'DownloadSourceDto'
    }).when('/confirmation/localexclusion', {
        templateUrl: 'confirmation/views/confirmation-download-local-exclusions.html',
        controller: 'ConfirmationDownloadLocalExclusionListCtrl',
        appCode: 'confirmationOverview',
        viewCode: 'DownloadExcludeDto'
    }).when('/confirmation/globalexclusions', {
        templateUrl: 'confirmation/views/global-exclusions-list.html',
        controller: 'GlobalExclusionsListCtrl',
        appCode: 'confirmationOverview',
        viewCode: 'DownloadExcludeCommonDto'
    }).when('/confirmation/sources/logs', {
        templateUrl: 'confirmation/views/confirmation-source-schedule-log-list.html',
        controller: 'ConfirmationSourceScheduleLogListCtrl',
        appCode: 'confirmationOverview',
        viewCode: 'DownloadSourceQueueLogMessageDetailDto'
    }).when('/confirmation/importedfiles', {
        templateUrl: 'confirmation/views/confirmation-imported-files.html',
        controller: 'ConfirmationImportedFilesCtrl',
        appCode: 'confirmationOverview',
        viewCode: 'BatchProcessingDto'
    }).when('/confirmation/inform', {
        templateUrl: 'confirmation/inform/views/inform-recon-list.html',
        controller: 'InformReconListCtrl',
        appCode: 'confirmationOverview',
        viewCode: 'InformReconciliationDto'
    }).when('/confirmation/inform/:id', {
        templateUrl: 'confirmation/inform/views/inform-recon-transactions.html',
        controller: 'InformReconTransactionsCtrl',
        appCode: 'confirmationOverview',
        viewCode: 'InformReconciliationTransactionDto'
    }).when('/confirmation/uploadtargets', {
        controller: 'UploadTargetsListCtrl',
        templateUrl: 'confirmation/views/upload-targets-list.html',
        appCode: 'confirmationOverview',
        viewCode: 'UploadTargetDto'
    }).when('/confirmation/files/:type', {
        templateUrl: 'confirmation/views/download-record-list.html',
        controller: 'DownloadRecordListCtrl',
        resolve: {views: downloadRecordListCtrl.loadRecordTypeView},
        public: true
    }).when('/confirmation/files/v2/:type', {
        templateUrl: 'confirmation/views/download-record-list.html',
        controller: 'DownloadRecordListV2Ctrl',
        resolve: {views: downloadRecordListV2Ctrl.loadRecordTypeView},
        public: true
    }).when('/confirmation/reconciliations', {
        controller: 'ReconciliationListCtrl',
        templateUrl: 'confirmation/views/reconciliation-list.html',
        appCode: 'interfaceRecon',
        viewCode: 'InterfaceReconciliationDto'
    }).when('/confirmation/reconciliations/accountsmissing', {
        controller: 'ReconciliationAccountsMissingListCtrl',
        templateUrl: 'confirmation/views/reconciliation-accounts-missing-list.html',
        appCode: 'interfaceRecon',
        viewCode: 'AccountNotInFileConfirmOverviewDashboardDto'
    }).when('/confirmation/reconciliations/audits/:id', {
        controller: 'ReconciliationAlertsCtrl',
        templateUrl: 'confirmation/views/reconciliation-alerts.html',
        appCode: 'interfaceRecon',
        resolve: {config: reconciliationAlertsCtrl.loadDataQueryConfigForRecon},
        viewCode: 'InterfaceReconciliationDto'
    }).when('/confirmation/reconciliations/files/:startDate/:endDate/:type/:id?', {
        templateUrl: 'confirmation/views/reconciliation-record-list.html',
        controller: 'ReconciliationRecordListCtrl',
        resolve: {views: downloadRecordListCtrl.loadRecordTypeView},
        public: true
    }).when('/confirmation/corporateactions', {
        controller: 'CorporateActionsListCtrl',
        templateUrl: 'confirmation/views/corporate-actions-list.html',
        appCode: 'corporateActions',
        viewCode: 'CorporateActionDto',
        resolve: {CorporateActionsListSettings: CorporateActionsListCtrl.loadCorporateActionsListSettings}
    }).when('/confirmation/corporateactions/processes', {
        controller: 'CorporateActionProcessingListCtrl',
        templateUrl: 'confirmation/views/corporate-action-processing-list.html',
        appCode: 'corporateActions',
        viewCode: 'CorporateActionProcessingDetailDto',
        resolve: {CorporateActionProcessingListSettings: CorporateActionProcessingListCtrl.loadCorporateActionProcessingListSettings}
    }).when('/confirmation/corporateactions/processes/:processingIds', {
        controller: 'CorporateActionProcessingStatusListCtrl',
        templateUrl: 'confirmation/views/corporate-action-processing-status-list.html',
        appCode: 'corporateActions',
        viewCode: 'CorpActionProcessingStatusDto',
    }).when('/confirmation/corporateactions/v2/transactions/:id?', {
        controller: 'CorporateActionV2TransactionsListCtrl',
        templateUrl: 'confirmation/views/corporate-action-v2-transactions-list.html',
        appCode: 'corporateActions',
        viewCode: 'CorpActionTransactionV2Dto'
    }).when('/confirmation/servicesstatus', {
        templateUrl: 'confirmation/views/services-status.html',
        appCode: 'confirmationOverview'
    }).when('/confirmation/signoff/oversight', {
        controller: 'SignOffOversightCtrl',
        templateUrl: 'confirmation/signoff/views/signoff-oversight.html',
        appCode: 'signOffs'
    }).when('/confirmation/signoff/daily', {
        controller: 'SignOffInterfaceListCtrl',
        templateUrl: 'confirmation/signoff/views/signoff-interface-list.html',
        appCode: 'signOffs',
        viewCode: 'InterfaceSyncDto',
        resolve: {
            syncType: function () {
                return 1
            }
        }
    }).when('/confirmation/signoff/weekly', {
        controller: 'SignOffInterfaceListCtrl',
        templateUrl: 'confirmation/signoff/views/signoff-interface-list.html',
        appCode: 'signOffs',
        viewCode: 'InterfaceSyncDto',
        resolve: {
            syncType: function () {
                return 2
            }
        }
    }).when('/confirmation/signoff/exclusion', {
        controller: 'SignOffExclusionListCtrl',
        templateUrl: 'confirmation/signoff/views/signoff-exclusion-list.html',
        appCode: 'signOffs',
        viewCode: 'ExclusionSyncDto'
    }).when('/confirmation/signoff/price', {
        controller: 'SignOffPriceListCtrl',
        templateUrl: 'confirmation/signoff/views/signoff-price-list.html',
        appCode: 'signOffs',
        viewCode: 'MissingPriceSyncDto'
    }).when('/confirmation/signoff/sync', {
        controller: 'SignOffSyncHistoryCtrl',
        templateUrl: 'confirmation/signoff/views/signoff-sync-history.html',
        appCode: 'signOffs',
        viewCode: 'ReconJobStatusDto'
    }).when('/confirmation/signoff/rules', {
        controller: 'SignOffRulesListCtrl',
        templateUrl: 'confirmation/signoff/views/signoff-rules-list.html',
        appCode: 'signOffs'
    }).when('/confirmation/signoff/file', {
        controller: 'SignOffInterfaceFileListCtrl',
        templateUrl: 'confirmation/signoff/views/signoff-interface-file-list.html',
        appCode: 'signOffs',
        viewCode: 'InterfaceSyncsByFileDto'
    }).when('/confirmation/stm', {
        redirectTo: '/confirmation/stm/teams'
    }).when('/confirmation/stm/:serviceTeamMemberId', {
        redirectTo: '/confirmation/stm/teams'
    }).when('/confirmation/heldaway/accounts', {
        controller: 'HeldAwayAccountListCtrl',
        templateUrl: 'confirmation/heldaway/views/held-away-account-list.html',
        appCode: 'accountComposer',
        viewCode: 'HeldAwayAccountDto',
        resolve: {settings: heldAwayAccountListCtrl.heldAwaySettings}
    }).when('/confirmation/heldaway/accounts/:errorType', {
        controller: 'HeldAwayAccountCtrl',
        templateUrl: 'confirmation/heldaway/views/held-away-account.html',
        appCode: 'accountComposer',
        resolve: {views: heldAwayAccountCtrl.loadHeldAwayAccountViews, setting: heldAwayAccountCtrl.setting}
    }).when('/confirmation/heldaway/audits/:id', {
        controller: 'ReconciliationAlertsCtrl',
        templateUrl: 'confirmation/views/reconciliation-alerts.html',
        appCode: 'accountComposer',
        resolve: {config: reconciliationAlertsCtrl.loadDataQueryConfigForRecon},
        viewCode: 'InterfaceReconciliationDto'
    }).when('/confirmation/alternatives/accounts', {
        controller: 'AlternativesAccountListCtrl',
        templateUrl: 'confirmation/alternatives/views/alternatives-account-list.html',
        appCode: 'accountComposer',
        viewCode: 'AccountDto'
    }).when('/confirmation/alternatives/assets', {
        controller: 'AlternativesAssetListCtrl',
        templateUrl: 'confirmation/alternatives/views/alternatives-asset-list.html',
        appCode: 'accountComposer',
        viewCode: 'AssetAlternativeDto'
    }).when('/confirmation/alternatives/assethistory', {
        controller: 'AlternativesAssetHistoryListCtrl',
        templateUrl: 'confirmation/alternatives/views/alternatives-asset-history-list.html',
        appCode: 'accountComposer',
        viewCode: 'InvestmentPlatformAssetHistoryDto'
    }).when('/confirmation/alternatives/globalvaluations', {
        controller: 'AlternativesGlobalValuationListCtrl',
        templateUrl: 'confirmation/alternatives/views/alternatives-global-valuation-list.html',
        appCode: 'accountComposer',
        viewCode: 'ProductValuationDto'
    }).when('/confirmation/alternatives/globalvaluation/preview', {
        controller: 'AlternativesGlobalValuationPreviewListCtrl',
        templateUrl: 'confirmation/alternatives/views/alternatives-global-valuation-preview-list.html',
        appCode: 'accountComposer',
        viewCode: 'ValuationPreviewDto'
    }).when('/confirmation/alternatives/valuations', {
        controller: 'AlternativesValuationListCtrl',
        templateUrl: 'confirmation/alternatives/views/alternatives-valuation-list.html',
        appCode: 'accountComposer',
        viewCode: 'AssetValuationDto'
    }).when('/confirmation/alternatives/globaltransactions', {
        controller: 'AlternativesGlobalTransactionListCtrl',
        templateUrl: 'confirmation/alternatives/views/alternatives-global-transaction-list.html',
        appCode: 'accountComposer',
        viewCode: 'ProductTransactionDto'
    }).when('/confirmation/alternatives/globaltransaction/preview', {
        controller: 'AlternativesGlobalTransactionPreviewListCtrl',
        templateUrl: 'confirmation/alternatives/views/alternatives-global-transaction-preview-list.html',
        appCode: 'accountComposer',
        viewCode: 'TransactionPreviewDto'
    }).when('/confirmation/alternatives/products', {
        controller: 'AlternativesProductListCtrl',
        templateUrl: 'confirmation/alternatives/views/alternatives-product-list.html',
        appCode: 'accountComposer',
        viewCode: 'LocalProductAlternativeDto'
    }).when('/confirmation/alternatives/transactions', {
        controller: 'AlternativesTransactionListCtrl',
        templateUrl: 'confirmation/alternatives/views/alternatives-transaction-list.html',
        appCode: 'accountComposer',
        viewCode: 'TransactionAlternativeDto'
    }).when('/confirmation/alternatives/audits/other', {
        redirectTo: '/reports/dataqueries/favorites'
    }).when('/confirmation/alternatives/audits/:id', {
        controller: 'AlternativesAuditListCtrl',
        templateUrl: 'confirmation/alternatives/views/alternatives-audit-list.html',
        appCode: 'accountComposer',
        resolve: {config: alternativesAuditListCtrl.loadDataQuery}
    }).when('/confirmation/mapping', {
        controller: 'DownloadMapListCtrl',
        templateUrl: 'confirmation/views/download-map-list.html',
        appCode: 'confirmationOverview',
        viewCode: 'DownloadMapDto'
    }).when('/confirmation/orionVision', {
        controller: 'VisionReconListCtrl',
        templateUrl: 'confirmation/vision/views/vision-recon-list.html',
        appCode: 'confirmationOverview',
        viewCode: 'OrionVisionConfirmDto'
    }).when('/confirmation/schedulerMaintenance', {
        controller: 'SchedulerMaintenanceCtrl',
        templateUrl: 'confirmation/views/scheduler-maintenance-list.html',
        appCode: 'confirmationOverview',
        viewCode: 'SchedulerMaintenanceDto'
    }).//PORTFOLIO PAGES
        when('/portfolio', {
            redirectTo: '/portfolio/dashboard'
        }).when('/portfolio/dashboard', {
        controller: 'PortfolioAuditDashboardCtrl',
        templateUrl: 'portfolio/views/portfolio-audit-dashboard.html',
        appCode: 'portfolioLists',
        resolve: {pageQueries: portfolioAuditDashboardCtrl.loadPageQueries}
    }).when('/portfolio/insight', {
        controller: 'PortfolioInsightCtrl',
        templateUrl: 'portfolio/views/portfolio-insight.html',
        public: true
    }).when('/portfolio/household/overview', {
        controller: 'PortfolioOverviewCtrl',
        templateUrl: 'portfolio/views/portfolio-overview.html',
        appCode: 'householdOverview',
        resolve: {portfolioOverviewSettings: portfolioOverviewCtrl.loadPortfolioOverviewSettings}
    }).when('/portfolio/household/householding', {
        controller: 'HouseholdingCtrl',
        templateUrl: 'portfolio/views/householding.html',
        appCode: 'householding'
    }).when('/portfolio/benchmarkassignment', {
        controller: 'BenchmarkAssignmentCtrl',
        templateUrl: 'portfolio/views/benchmarkAssignment.html',
        appCode: 'benchmarkAssign'
    }).when('/portfolio/blendedbenchmarks', {
        controller: 'BlendedBenchmarkListCtrl',
        templateUrl: 'portfolio/views/blended-benchmark-list.html',
        appCode: 'benchmarkAssign',
        viewCode: 'IndexBlendDto'
    }).when('/portfolio/blendedbenchmarks/:id', {
        controller: 'BlendedBenchmarkCtrl',
        templateUrl: 'portfolio/views/blended-benchmark.html',
        appCode: 'benchmarkAssign'
    }).when('/portfolio/attributiondetail', {
        controller: 'AttributionDetailListCtrl',
        templateUrl: 'reporting/performance/views/attribution-detail-list.html',
        appCode: 'benchmarkAssign'
    }).when('/portfolio/attributiondetail/:id', {
        controller: 'AttributionDetailCtrl',
        templateUrl: 'reporting/performance/views/attribution-detail.html',
        appCode: 'benchmarkAssign'
    }).when('/portfolio/attributionassignment', {
        controller: 'AttributionAssignmentCtrl',
        templateUrl: 'reporting/performance/views/attribution-assignment.html',
        appCode: 'benchmarkAssign'
    }).when('/portfolio/newaccounts/add/:mode', {
        controller: 'NewAccountsAddCtrl',
        templateUrl: 'portfolio/views/newaccounts-add.html',
        appCode: 'newAccountsCenter'
    }).when('/portfolio/newaccounts/excluded', {
        controller: 'NewAccountsExcludedListCtrl',
        templateUrl: 'portfolio/views/newaccounts-excluded-list.html',
        appCode: 'newAccountsCenter',
        viewCode: 'DownloadExcludeCurrentDto'
    }).when('/portfolio/newaccounts/mclWizard', {
        controller: 'MasterClientListWizardCtrl',
        controllerAs: 'vm',
        templateUrl: 'portfolio/mclWizard/views/master-client-list-wizard.html',
        appCode: 'newAccountsCenter'
    }).when('/portfolio/newaccounts/mclWizard/:id', {
        controller: 'MasterClientListWizardSummaryCtrl',
        templateUrl: 'portfolio/mclWizard/views/master-client-list-wizard-summary.html',
        appCode: 'newAccountsCenter',
        viewCode: 'ValidateImportMCLWizardSummaryDto'
    }).when('/portfolio/newaccounts/maintainpaperwork', {
        controller: 'MaintainPaperworkCtrl',
        templateUrl: 'portfolio/views/maintainpaperwork.html',
        appCode: 'newAccountsCenter'
    }).when('/portfolio/newaccounts/ofacnotreview', {
        controller: 'OfacImportCtrl',
        templateUrl: 'advisor/views/ofac-import.html',
        viewCode: 'OfacCheckDto',
        appCode: 'newAccountsCenter'
    }).when('/portfolio/newaccounts/prospects', {
        controller: 'HouseholdListCtrl',
        templateUrl: 'portfolio/lists/views/household-list.html',
        appCode: 'newAccountsCenter',
        viewCode: 'ClientProspectDto',
        entity: '5',
        resolve: { searchResult: angular.noop }
    }).when('/portfolio/newaccounts/matrixb50', {
        controller: 'MatrixB50Ctrl',
        templateUrl: 'portfolio/views/matrixb50.html',
        appCode: 'newAccountsCenter',
        viewCode: 'MatrixB50Dto'
    }).when('/portfolio/newaccounts/pendingClientInfo',{
        controller: 'pendingClientInfoCtrl',
        templateUrl:  'portfolio/views/pendingClientInfo.html',
        appCode: 'newAccountsCenter',
        viewCode: 'AccountCustodialInfoChangeDto'
    })./*when('/portfolio/newaccounts/restore' , {
        controller: 'AccountRestoreCtrl',
        templateUrl: 'portfolio/modals/account-restore.html',
        appCode: 'newAccountsCenter',
        //viewCode: 'NewPortfolioAccountDto',
        //resolve: { numberOfDays: newAccountsCtrl.loadNumberOfDays }
    }).*/
        when('/portfolio/newaccounts/:newAccountFilter?', {
            controller: 'NewAccountsCtrl',
            templateUrl: 'portfolio/views/newaccounts.html',
            appCode: 'newAccountsCenter',
            viewCode: 'NewPortfolioAccountDto',
            resolve: {numberOfDays: newAccountsCtrl.loadNumberOfDays}
        }).when('/portfolio/households/:householdFilter?', {
        controller: 'HouseholdListCtrl',
        templateUrl: 'portfolio/lists/views/household-list.html',
        appCode: 'portfolioLists',
        viewCode: 'ClientDto',
        entity: '5',
        resolve: {searchResult: householdListCtrl.loadPortfolioListConfig}
    }).when('/portfolio/edit/households/:householdId?', {
        controller: 'HouseholdEditCtrl',
        templateUrl: 'portfolio/editors/views/household-edit.html',
        public: true,
        hideNav: true,
        resolve: {
            args: function ($route) {
                return {
                    ids: [$route.current.params.householdId],
                    isNew: false,
                    app: null,
                    defaultTab: {code: $route.current.params.tabCode || 'householdGeneral'},
                    extraInfo: {createCopy: false},
                    isFullPage: $route.current.params.isFullPage ? ($route.current.params.isFullPage === 'true') : true,
                    showCancel: $route.current.params.showCancel ? ($route.current.params.showCancel === 'true') : false
                };
            },
            dialog: angular.noop
        }
    }).when('/portfolio/household/householdBills/:id?', {
        redirectTo: '/billing/householdbills'
    }).when('/portfolio/household/householdBills/accountBillDetail/:id?', {
        redirectTo: '/billing/billdetails'
    }).when('/portfolio/registrations/:registrationFilter?', {
        controller: 'RegistrationListCtrl',
        templateUrl: 'portfolio/lists/views/registration-list.html',
        appCode: 'portfolioLists',
        viewCode: 'RegistrationDto',
        entity: '6',
        resolve: {searchResult: householdListCtrl.loadPortfolioListConfig}
    }).when('/portfolio/edit/registrations/:registrationId?', {
        controller: 'RegistrationEditCtrl',
        templateUrl: 'portfolio/editors/views/registration-edit.html',
        public: true,
        hideNav: true,
        resolve: {
            args: function ($route) {
                return {
                    ids: [$route.current.params.registrationId],
                    isNew: false,
                    app: null,
                    defaultTab: {code: $route.current.params.tabCode || 'registrationGeneral'},
                    extraInfo: {accountId: $route.current.params.aid},
                    isFullPage: $route.current.params.isFullPage ? ($route.current.params.isFullPage === 'true') : true,
                    showCancel: $route.current.params.showCancel ? ($route.current.params.showCancel === 'true') : false
                };
            },
            dialog: angular.noop
        }
    }).when('/portfolio/registrationtypes', {
        controller: 'RegistrationTypesListCtrl',
        templateUrl: 'portfolio/views/registrationTypes-List.html',
        appCode: 'firmProfile',
        viewCode: 'RegistrationTypeDto'
    }).when('/portfolio/btlas', {
        controller: 'QPENonManagedListCtrl',
        templateUrl: 'portfolio/views/qpe-non-managed-list.html',
        appCode: 'portfolioLists',
        viewCode: 'QPENonManagedDto'
    }).when('/portfolio/accounts/:accountFilter?', {
        controller: 'AccountListCtrl',
        templateUrl: 'portfolio/lists/views/account-list.html',
        appCode: 'portfolioLists',
        entity: '7',
        resolve: {views: AccountListCtrl.loadAccountViews, searchResult: householdListCtrl.loadPortfolioListConfig}
    }).when('/portfolio/edit/accounts/:accountId?', {
        controller: 'AccountEditCtrl',
        templateUrl: 'portfolio/editors/views/account-edit.html',
        public: true,
        hideNav: true,
        resolve: {
            args: function ($route) {
                return {
                    ids: [$route.current.params.accountId],
                    isNew: false,
                    app: null,
                    defaultTab: {code: $route.current.params.tabCode || 'accountGeneral'},
                    extraInfo: Object.reject($route.current.params, "accountId", "tabCode"),
                    isFullPage: $route.current.params.isFullPage ? ($route.current.params.isFullPage === 'true') : true,
                    showCancel: $route.current.params.showCancel ? ($route.current.params.showCancel === 'true') : false
                };
            },
            dialog: angular.noop
        }
    }).when('/portfolio/edit/accounts/number/:accountNumber?', {
        public: true,
        resolve: {
            lookUp: function ($route, $location, $http) {
                return $http.get('/Portfolio/Accounts/Number/' + $route.current.params.accountNumber, {trackerMsg: 'Loading account number'})
                    .then(function (response) {
                        $location.path('/portfolio/edit/accounts/' + response.data.id);
                        $location.replace();
                    });
            }
        }
    }).when('/portfolio/assets', {
        controller: 'AssetListCtrl',
        templateUrl: 'portfolio/lists/views/asset-list.html',
        appCode: 'portfolioLists',
        viewCode: 'AssetDto'
    }).when('/portfolio/assets/historical', {
        controller: 'AssetHistoricalListCtrl',
        templateUrl: 'portfolio/lists/views/asset-historical-list.html',
        appCode: 'portfolioLists',
        viewCode: 'AssetDto'
    }).when('/portfolio/edit/assets/:assetId?', {
        controller: 'AssetEditCtrl',
        templateUrl: 'portfolio/editors/views/asset-edit.html',
        public: true,
        resolve: {
            args: function ($route) {
                return {
                    ids: [$route.current.params.assetId],
                    isNew: false,
                    app: null,
                    defaultTab: {code: $route.current.params.tabCode || 'assetGeneral'},
                    extraInfo: null,
                    isFullPage: true
                };
            },
            dialog: angular.noop
        }
    }).when('/portfolio/transactions', {
        controller: 'TransactionListCtrl',
        templateUrl: 'portfolio/lists/views/transaction-list.html',
        appCode: 'portfolioLists',
        viewCode: 'TransactionSortOrderUnitBalanceDto',
        resolve: {dates: transactionListCtrl.loadTransactionListDates}
    }).when('/portfolio/edit/transactions/:transactionId?', {
        controller: 'TransactionEditCtrl',
        templateUrl: 'portfolio/editors/views/transaction-edit.html',
        public: true,
        resolve: {
            args: function ($route) {
                return {
                    ids: [$route.current.params.transactionId],
                    isNew: false,
                    app: null,
                    defaultTab: {code: $route.current.params.tabCode || 'transactionGeneral'},
                    extraInfo: null,
                    isFullPage: true
                };
            },
            dialog: angular.noop
        }
    }).when('/portfolio/schedules/:sched', {
        redirectTo: function (routeParams, path, search) {
            var target = '/firmprofile/schedules/' + routeParams.sched;
            var keys = search && Object.keys(search);
            if (!keys || !keys.length) {
                return target;
            }
            var query = keys.map(function (k) {
                return encodeURIComponent(k) + '=' + encodeURIComponent(search[k]);
            }).join('&');
            return target + '?' + query;
        }
    }).when('/portfolio/payoutschedules', {
        redirectTo: '/firmprofile/payoutschedules'
    }).when('/portfolio/audithistory', {
        controller: 'AuditHistoryCtrl',
        templateUrl: 'portfolio/views/auditHistory.html',
        appCode: 'portfolioLists',
        viewCode: 'AccountAuditDto'
    }).when('/portfolio/managementstyles', {
        controller: 'ListCtrl',
        templateUrl: 'app/views/list.html',
        appCode: 'firmProfile',
        resolve: {config: platformCtrl.getPlatformListConfig}
    }).when('/portfolio/managementstyles/:id', {
        controller: 'PlatformCtrl',
        templateUrl: 'portfolio/views/platform.html',
        appCode: 'firmProfile'
    }).when('/portfolio/custodians', {
        controller: 'CustodianListCtrl',
        templateUrl: 'portfolio/views/custodianlist.html',
        appCode: 'firmProfile'
    }).when('/portfolio/custodians/:id', {
        controller: 'CustodianCtrl',
        templateUrl: 'portfolio/views/custodian.html',
        appCode: 'firmProfile'
    }).when('/portfolio/assetlevelstrategies', {
        controller: 'AssetLevelStrategyListCtrl',
        templateUrl: 'portfolio/views/asset-level-strategy-list.html',
        appCode: 'firmProfile'
    }).when('/portfolio/fundfamilies', {
        controller: 'FundFamilyCtrl',
        templateUrl: 'portfolio/views/fundfamily-list-item.html',
        appCode: 'firmProfile',
        viewCode: 'FundFamilyDto'
    }).when('/portfolio/fundfamilies/add', {
        controller: 'FundFamilyCtrl',
        templateUrl: 'portfolio/views/FundFamilyAdd.html',
        appCode: 'firmProfile',
        viewCode: 'FundFamilyDto'
    }).when('/portfolio/fundfamilies/:id', {
        controller: 'FundFamilyAddEditCtrl',
        templateUrl: 'portfolio/views/fundfamily-new.html',
        appCode: 'firmProfile'
    }).when('/advisor/goals', {
        controller: 'GoalListCtrl',
        templateUrl: 'advisor/views/goal-list-item.html',
        appCode: 'firmProfile'
    }).when('/portfolio/plans', {
        template: '',
        appCode: 'firmProfile',
        resolveRedirectTo: ['$q', 'splitIoService', function ($q, splitIoService) {
            var getSplit = function () {
                var deferred = $q.defer();
                splitIoService.getBoolTreatment('oc_firmprofile_qualifiedplans_usenewcomponent_oc14815').subscribe(function (isEnabled) {
                    deferred.resolve(isEnabled);
                });
                return deferred.promise;
            };
            return getSplit().then(function (isEnabled) {
                return isEnabled ? '/portfolio/plans' : '/portfolio/plans-old';
            });
        }]
    }).when('/portfolio/plans-old', {
        controller: 'PlanListCtrl',
        templateUrl: 'portfolio/views/planList.html',
        appCode: 'firmProfile',
        viewCode: 'PlanDto'
    }).when('/portfolio/transactions/import', {
        controller: 'BatchAddTransactionCtrl',
        templateUrl: 'portfolio/views/batch-add-transaction.html',
        appCode: 'portfolioLists'
    }).when('/portfolio/hypotheticalmonthlyperformance/import', {
        controller: 'HypotheticalMonthlyPerformanceImportCtrl',
        templateUrl: 'portfolio/views/hypothetical-monthly-performance-import.html',
        appCode: 'firmProfile',
        viewCode: 'ValidateHypotheticalMonthlyPerformanceValueDto'
    }).when('/portfolio/custodialintegrator/notemapping', {
        controller: 'CustodialIntegratorNoteMappingListCtrl',
        templateUrl: 'portfolio/custodialIntegrator/views/custodial-integrator-note-mapping-list.html',
        appCode: 'custodialIntegrator',
        viewCode: 'ByAllNoteMappingDto'
    }).when('/portfolio/custodialintegrator/offsetSymbolMapping', {
        controller: 'CustodialIntegratorOffsetSymbolMapping',
        templateUrl: 'portfolio/custodialintegrator/views/custodial-integrator-offset-symbol-mapping-list.html',
        appCode: 'custodialIntegrator',
        viewCode: 'ByAllOffsetSymbolDto'
    }).when('/portfolio/custodialintegrator/treatment', {
        controller: 'CustodialIntegratorTreatmentListCtrl',
        templateUrl: 'portfolio/custodialIntegrator/views/custodial-integrator-treatment-list.html',
        appCode: 'custodialIntegrator',
        viewCode: 'ByAllTreatmentDto'
    }).when('/portfolio/custodialintegrator/globalsymbol', {
        controller: 'CustodialIntegratorGlobalSymbolListCtrl',
        templateUrl: 'portfolio/custodialintegrator/views/custodial-integrator-global-symbol-list.html',
        appCode: 'custodialIntegrator',
        viewCode: 'ByAllGlobalSymbolDto'
    }).when('/portfolio/custodialintegrator/localsymbol', {
        controller: 'CustodialIntegratorLocalSymbolListCtrl',
        templateUrl: 'portfolio/custodialintegrator/views/custodial-integrator-local-symbol-list.html',
        appCode: 'custodialIntegrator',
        viewCode: 'ByAllLocalSymbolDto'
    }).when('/portfolio/custodialintegrator/account', {
        controller: 'CustodialIntegratorAccountListCtrl',
        templateUrl: 'portfolio/custodialintegrator/views/custodial-integrator-account-list.html',
        appCode: 'custodialIntegrator',
        viewCode: 'ByAllAccountDto'
    }).when('/portfolio/custodialintegrator/plaid/security', {
        controller: 'PlaidSecurityMappingListCtrl',
        templateUrl: 'portfolio/custodialintegrator/views/plaid-security-mapping-list.html',
        appCode: 'custodialIntegrator',
        viewCode: 'PlaidSecurityMappingDto'
    }).when('/portfolio/custodialintegrator/plaid/note', {
        controller: 'PlaidNoteMappingListCtrl',
        templateUrl: 'portfolio/custodialintegrator/views/plaid-note-mapping-list.html',
        appCode: 'custodialIntegrator',
        viewCode: 'PlaidNoteMappingDto'
    }).when('/portfolio/custodialintegrator/plaid/override', {
        controller: 'PlaidUnitBalanceOverrideListCtrl',
        templateUrl: 'portfolio/custodialintegrator/views/plaid-unit-balance-override-list.html',
        appCode: 'custodialIntegrator',
        viewCode: 'PlaidUnitBalanceOverrideDto'
    }).when('/portfolio/custodialintegrator/plaid/account', {
        controller: 'PlaidAccountListCtrl',
        templateUrl: 'portfolio/custodialintegrator/views/plaid-account-list.html',
        appCode: 'custodialIntegrator',
        viewCode: 'PlaidAccountDto'
    }).when('/portfolio/custodialintegrator/akoya/account', {
        controller: 'AkoyaAccountListCtrl',
        templateUrl: 'portfolio/custodialintegrator/views/akoya-account-list.html',
        appCode: 'custodialIntegrator',
        viewCode: 'AkoyaAccountDto'
    }).when('/portfolio/portfoliogroups', {
        controller: 'PortfolioGroupCtrl',
        templateUrl: 'portfolio/views/portfolio-group.html',
        appCode: 'portfolioLists',
        viewCode: 'PortfolioGroupDto',
        entity: '107',
        resolve: {searchResult: householdListCtrl.loadPortfolioListConfig}
    }). // PRODUCT PAGES
        when('/products/myproducts/:auditKey?', {
            controller: 'ProductListCtrl',
            templateUrl: 'products/views/product-list.html',
            appCode: 'productsAndPrices',
            resolve: {views: productListCtrl.loadProductViews}
        }).when('/products/local/:productId?', {
        controller: 'ProductListCtrl',
        templateUrl: 'products/views/product-list.html',
        appCode: 'productsAndPrices',
        viewCode: 'LocalProductDto'
    }).when('/products/global/:auditKey?', {
        controller: 'ProductGlobalListCtrl',
        templateUrl: 'products/views/product-global-list.html',
        appCode: 'productsAndPrices',
        viewCode: 'GlobalProductDto'
    }).when('/products/global', {
        controller: 'ProductGlobalListCtrl',
        templateUrl: 'products/views/product-global-list.html',
        appCode: 'productsAndPrices',
        viewCode: 'GlobalProductDto'
    }).when('/products/taxexemptions', {
        controller: 'TaxExemptionsListCtrl',
        templateUrl: 'products/views/tax-exemptions-list.html',
        appCode: 'productsAndPrices',
        viewCode: 'StateMunicipalBondTaxDto'
    }).when('/products/exports/:queryId', {
        templateUrl: 'products/views/product-query-export.html',
        controller: 'ProductQueryExportCtrl',
        appCode: 'productsAndPrices'
    }).when('/products/productCombine',{
        templateUrl: 'products/productCombine/views/ProductCombine.html',
        controller: 'productCombineCtrl',
        appCode: 'productsAndPrices'
    }).when('/products/productCombine/productHistoryCompare/:primaryProductId/:secondaryProductIdList',{
        templateUrl: 'products/productCombine/views/ProductHistoryCompare.html',
        controller: 'productHistoryCompareCtrl',
        appCode: 'productsAndPrices'
    }).when('/prices/local', {
        controller: 'PriceLocalListCtrl',
        templateUrl: 'products/views/pricelocal-list.html',
        viewCode: 'PriceLocalDto',
        appCode: 'productsAndPrices'
    }).when('/prices/global', {
        controller: 'PriceGlobalListCtrl',
        templateUrl: 'products/views/priceglobal-list.html',
        viewCode: 'PriceGlobalDto',
        appCode: 'productsAndPrices'
    }).when('/bondratings', {
        controller: 'BondRatingsListCtrl',
        appCode: 'productsAndPrices',
        templateUrl: 'products/views/bondratings-list.html'
    }).when('/bondratings/:id', {
        controller: 'BondRatingCtrl',
        appCode: 'productsAndPrices',
        templateUrl: 'products/views/bondrating.html'
    }).when('/assetcategories', {
        controller: 'ProductCategoryListCtrl',
        appCode: 'productsAndPrices',
        templateUrl: 'products/views/productcategory-list.html'
    }).when('/assetcategories/:id', {
        controller: 'ProductCategoryCtrl',
        appCode: 'productsAndPrices',
        templateUrl: 'products/views/productcategory.html'
    }).when('/parentcategories', {
        controller: 'ParentCategoryListCtrl',
        appCode: 'productsAndPrices',
        templateUrl: 'products/views/parentcategory-list.html'
    }).when('/riskcategories', {
        controller: 'ListCtrl',
        templateUrl: 'app/views/list.html',
        appCode: 'productsAndPrices',
        resolve: {config: riskCategoryCtrl.getRiskCategoryListConfig}
    }).when('/riskcategories/:id', {
        controller: 'RiskCategoryCtrl',
        appCode: 'productsAndPrices',
        templateUrl: 'products/views/riskcategory.html'
    }).when('/assetclasses', {
        controller: 'ListCtrl',
        templateUrl: 'app/views/list.html',
        appCode: 'productsAndPrices',
        resolve: {config: productClassCtrl.getProductClassListConfig}
    }).when('/assetclasses/:id', {
        controller: 'ProductClassCtrl',
        appCode: 'productsAndPrices',
        templateUrl: 'products/views/productclass.html'
    }).when('/products/regions', {
        controller: 'ListCtrl',
        templateUrl: 'app/views/list.html',
        appCode: 'productsAndPrices',
        resolve: {config: productRegionCtrl.getProductRegionListConfig}
    }).when('/products/regions/:id', {
        controller: 'ProductRegionCtrl',
        appCode: 'productsAndPrices',
        templateUrl: 'products/views/productregion.html'
    }).when('/products/managers', {
        controller: 'ListCtrl',
        templateUrl: 'app/views/list.html',
        appCode: 'productsAndPrices',
        resolve: {config: productManagerCtrl.getProductManagerListConfig}
    }).when('/products/managers/:id', {
        controller: 'ProductManagerCtrl',
        appCode: 'productsAndPrices',
        templateUrl: 'products/views/productmanager.html'
    }).when('/products/propertytypes', {
        controller: 'ListCtrl',
        templateUrl: 'app/views/list.html',
        appCode: 'productsAndPrices',
        resolve: {config: productPropertyTypeCtrl.getProductPropertyTypeListConfig}
    }).when('/products/propertytypes/:id', {
        controller: 'ProductPropertyTypeCtrl',
        appCode: 'productsAndPrices',
        templateUrl: 'products/views/productpropertytype.html'
    }).when('/providerassignments', {
        controller: 'ProductProviderAssignmentsCtrl',
        appCode: 'productsAndPrices',
        templateUrl: 'products/views/productprovider-assignments.html'
    }).when('/products/productexclusions', {
        controller: 'ProductExclusionsCtrl',
        appCode: 'productsAndPrices',
        viewCode: 'ProductEntityExclusionDto',
        templateUrl: 'products/views/product-exclusions.html'
    }).when('/products/nametranslation', {
        controller: 'ProductNameTranslationListCtrl',
        appCode: 'productsAndPrices',
        viewCode: 'ProductNameMappingDSTDto',
        templateUrl: 'products/views/name-translation-list.html'
    }).when('/providerAutoAssignments',{
        controller: 'autoAssignmentsCtrl',
        appCode: 'productsAndPrices',
        viewCode: 'ProductClassAutoAssignOverrideDto',
        templateUrl: 'products/views/auto-assignments.html',
        resolve:{
            settings:[function(){
                return { title: 'Product Class', id: 'productClassId'};
            }],
            assetList:['$http', function($http){
                return $http.get('/Portfolio/ProductClassAutoAssignOverride/ProductClass/Simple',{trackerMsg: 'Loading Product Classes'})
                    .then(function(res){
                        res.data.forEach(function(item,index){
                            if(item.name === '' || item.id === null){
                                res.data.splice(index,1);
                            }
                        });
                        return res.data;
                    });
            }],
            overrides:['$http', function($http){
                return $http.get('/Portfolio/ProductClassAutoAssignOverride',{trackerMsg: 'Loading Overrides'}).then(function(res){return res.data;});
            }]
        }
    }).when('/riskCategoryAutoAssignments',{
        controller: 'autoAssignmentsCtrl',
        appCode: 'productsAndPrices',
        viewCode: 'RiskCategoryAutoAssignOverrideDto',
        templateUrl: 'products/views/auto-assignments.html',
        resolve:{
            settings:[function(){
                return { title: 'Risk Category', id: 'riskCategoryId'};
            }],
            assetList:['$http', function($http){
                return $http.get('/Portfolio/RiskCategoryAutoAssignOverride/RiskCategory/Simple', {trackerMsg: 'Loading Risk Categories'})
                    .then(function(res){
                        res.data.forEach(function(item,index){
                            if(item.name === '' || item.id === null){
                                res.data.splice(index,1);
                            }
                        });
                        return res.data;
                    });
            }],
            overrides:['$http', function($http){
                return $http.get('/Portfolio/RiskCategoryAutoAssignOverride',{trackerMsg: 'Loading Overrides'}).then(function(res){return res.data;});
            }]
        }

    }).//REPORTING PAGES
        when('/reports', {
            redirectTo: '/reports/reportbuilder'
        }).when('/reports/advisoryfee', {
        controller: 'AdvisoryFeeListCtrl',
        templateUrl: 'reporting/views/advisory-fee-list.html',
        appCode: "advisoryFeeReports"
    }).when('/reports/reportbuilder', {
        controller: 'ReportBuilderListCtrl',
        templateUrl: 'reporting/views/reportbuilder-list.html',
        appCode: 'reports'
    }).when('/reports/reportbuilder/:reportId', {
        controller: 'ReportBuilderCtrl',
        templateUrl: 'reporting/views/reportbuilder.html',
        appCode: 'reports'
    }).when('/reports/prompt/:reportId?', {
        controller: 'ReportPrompterCtrl',
        templateUrl: 'reporting/modals/report-prompter.html',
        public: true,
        hideNav: true,
        resolve: {
            reportId: function ($route) {
                return $route.current.params.reportId;
            },
            reportArgs: function ($route) {
                return Object.reject($route.current.params, 'reportId');
            },
            dialog: angular.noop
        }
    }).when('/reports/themes', {
        controller: 'ThemeBuilderListCtrl',
        templateUrl: 'reporting/views/themebuilder-list.html',
        appCode: 'reports'
    }).when('/reports/themes/:themeId', {
        controller: 'ThemeBuilderCtrl',
        templateUrl: 'reporting/views/themebuilder.html',
        appCode: 'reports'
    }).when('/reports/composites/accounts', {
        resolveRedirectTo: ['dbeoService', function(dbeoService) {
            return dbeoService.get('69USENEWCOMPACCOUNTSPAGE')
                .then((useNewPage) => {
                    return useNewPage ? '/reports/composites/accounts-new' : '/reports/composites/accounts-old';
                });
        }]
    }).when('/reports/composites/accounts-old/:batchId?', {
        controller: 'CompositeAccountListCtrl',
        templateUrl: 'reporting/composites/views/compositeaccount-list.html',
        appCode: 'composites',
        viewCode: 'CompositeAccountDto',
        resolve: {summary: compositeAccountListCtrl.loadSummary}
    }).when('/reports/composites/missingaccounts', {
        controller: 'CompositeMissingAccountListCtrl',
        templateUrl: 'reporting/composites/views/compositemissingaccount-list.html',
        appCode: 'composites'
    }).when('/reports/composites/firmassets', {
        controller: 'CompositeFirmAssetListCtrl',
        templateUrl: 'reporting/composites/views/compositefirmasset-list.html',
        appCode: 'composites'
    }).when('/reports/composites/firmassets/:id', {
        controller: 'CompositeFirmAssetCtrl',
        templateUrl: 'reporting/composites/views/compositefirmasset.html',
        appCode: 'composites'
    }).when('/reports/composites/ranges', {
        controller: 'CompositeRangeListCtrl',
        templateUrl: 'reporting/composites/views/compositerange-list.html',
        appCode: 'composites'
    }).when('/reports/composites/ranges/:id', {
        controller: 'CompositeRangeCtrl',
        templateUrl: 'reporting/composites/views/compositerange.html',
        appCode: 'composites'
    }).when('/reports/composites/reports/', {
        controller: 'CompositeReportListCtrl',
        templateUrl: 'reporting/composites/views/compositereport-list.html',
        appCode: 'composites'
    }).when('/reports/composites/reports/:id', {
        controller: 'CompositeReportCtrl',
        templateUrl: 'reporting/composites/views/compositereport.html',
        appCode: 'composites'
    }).when('/reports/composites/new', {
        controller: 'CompositeNewCtrl',
        templateUrl: 'reporting/composites/views/compositenew.html',
        appCode: 'composites'
    }).when('/reports/composites/historical', {
        controller: 'CompositeImportCtrl',
        templateUrl: 'reporting/composites/views/composite-import.html',
        appCode: 'composites'
    }).when('/reports/composites/archivedreports', {
        controller: 'CompositeArchivedRptCtrl',
        templateUrl: 'reporting/composites/views/composite-archived-reports.html',
        appCode: 'composites',
        viewCode: 'CompositeArchivedReportDto'
    }).when('/reports/composites/compositewizard', {
        controller: 'CompositeWizardCtrl',
        templateUrl: 'reporting/composites/views/composite-wizard.html',
        appCode: 'composites'
    }).when('/reports/composites/supervision', {
        controller: 'CompositeSupervisionCtrl',
        templateUrl: 'reporting/composites/views/composite-supervision.html',
        appCode: 'composites'
    }).when('/reports/composites/rules', {
        controller: 'CompositeRulesCtrl',
        templateUrl: 'reporting/composites/views/composite-rules.html',
        appCode: 'composites'
    }).when('/reports/composites/adhoc', {
        controller: 'CompositeAdhocCtrl',
        templateUrl: 'reporting/composites/views/composite-adhoc.html',
        viewCode: 'CompositeAdHocInstanceDto',
        appCode: 'composites'
    }).when('/reports/composites/adhocaccounts', {
        controller: 'CompositeAdhocAccountListCtrl',
        templateUrl: 'reporting/composites/views/composite-adhoc-accounts.html',
        viewCode: 'CompositeAdHocAccountDto',
        appCode: 'composites'
    }).when('/reports/composites/disclosures', {
        controller: 'CompositeDisclosureListCtrl',
        templateUrl: 'reporting/composites/views/composite-disclosure-list.html',
        viewCode: 'CompositeTextViewDto',
        appCode: 'composites'
    }).when('/reports/performanceviewer', {
        redirectTo: '/reports/performanceviewer3'
    }).when('/reports/performanceviewer2', {
        redirectTo: '/reports/performanceviewer3'
    }).when('/reports/performancecomparison', {
        controller: 'PerformanceCompareCtrl',
        templateUrl: 'reporting/performance/views/performanceCompare.html',
        appCode: 'performanceCompare',
        viewCode: 'PerformanceCompareDto'
    }).when('/reports/performancecomparison/wizard', {
        controller: 'PerformanceCompareWizardCtrl',
        templateUrl: 'reporting/performance/views/performanceCompare-wizard.html',
        appCode: 'performanceCompare',
        viewCode: 'ValidatePerformanceCompareDetailDto'
    }).when('/reports/performancecomparison/:id', {
        controller: 'PerformanceCompareDetailsCtrl',
        templateUrl: 'reporting/performance/views/performanceCompareDetails.html',
        appCode: 'performanceCompare',
        resolve: {views: performanceCompareDetailsCtrl.loadPerformanceCompareView}
    }).when('/reporting/performance/batchperformance', {
        controller: 'BatchPerformanceListCtrl',
        templateUrl: 'reporting/performance/batchPerformanceTool/views/batchPerformanceList.html',
        appCode: 'batchPerformance',
        viewCode: 'PerformanceBatchDto'
    }).when('/reporting/performance/batchperformance/wizard', {
        controller: 'batchPerformanceToolWizardCtrl',
        controllerAs: 'vm',
        appCode: 'batchPerformance',
        templateUrl: 'reporting/performance/batchPerformanceTool/views/batchPerformanceToolWizard.html',
    }).when('/reporting/performance/batchperformance/:id', {
        controller: 'batchPerformanceEntitiesCtrl',
        templateUrl: 'reporting/performance/batchPerformanceTool/views/batchPerformanceEntities.html',
        appCode: 'batchPerformance',
        resolve: {views: batchPerformanceEntities.loadPerformanceEntitiesView}
    }).when('/reporting/performance/batchperformance/details/:id',{
        controller:'batchPerformanceDetailCtrl',
        templateUrl: 'reporting/performance/batchPerformanceTool/views/batchPerformanceDetail.html',
        appCode: 'batchPerformance',
        resolve: {views: batchPerformanceDetail.loadPerformanceDetailView}
    }).when('/reports/dataqueries/favorites', {
        controller: 'ReportingEnvisionQueryFavoriteListCtrl',
        templateUrl: 'reporting/envision/views/reporting-envision-query-favorite-list.html',
        appCode: 'dataQueries'
    }).when('/reports/dataqueries/querybuilder', {
        controller: 'ReportingEnvisionQueryBuilderListCtrl',
        templateUrl: 'reporting/envision/views/reporting-envision-query-builder-list.html',
        appCode: 'dataQueries'
    }).when('/reports/dataqueries/querybuilder/:id', {
        controller: 'DataQueryCtrl',
        templateUrl: 'reporting/views/dataquery.html',
        appCode: 'dataQueries',
        resolve: {config: dataQueryCtrl.loadDataQueryConfig}
    }).when('/reports/dataqueriesold', {
        controller: 'DataQueryListCtrl',
        templateUrl: 'reporting/views/dataquery-list.html',
        appCode: 'dataQueries'
    }).when('/reports/dataqueries', {
        controller: 'DataQueryList2Ctrl',
        templateUrl: 'reporting/views/dataquery-list2.html',
        appCode: 'dataQueries',
        viewCode: 'CustomReportDto'
    }).when('/reports/dataqueries/:id', {
        controller: 'DataQueryCtrl',
        templateUrl: 'reporting/views/dataquery.html',
        appCode: 'dataQueries',
        resolve: {config: dataQueryCtrl.loadDataQueryConfig}
    }).when('/reports/dataqueryexclusions', {
        controller: 'DataQueryEntityExclusionListCtrl',
        templateUrl: 'reporting/views/dataquery-entity-exclusion-list.html',
        appCode: 'confirmationOverview',
        viewCode: 'DataQueryEntityExcludeDto'
    }).when('/reports/cloudstorage', {
        controller: 'CloudStorageListCtrl',
        templateUrl: 'reporting/views/cloud-storage-list.html',
        appCode: 'reports'
    }).when('/reports/reporting-groups', {
        controller: 'ReportingGroupsCtrl',
        templateUrl: 'reporting/views/reporting-groups.html',
        appCode: 'reports'
    }).when('/reports/menu', {
        redirectTo: '/reports/reportbuilder3'
    }).when('/reports/reportpackages', {
        resolveRedirectTo: ['$q', 'splitIoService', function ($q, splitIoService) {
            let getSplit = function () {
                let deferred = $q.defer();
                splitIoService.getBoolTreatment('oc_reportusability_usedashboard_16451').subscribe((enabled) => {
                    deferred.resolve(enabled);
                });
                return deferred.promise;
            }

            return getSplit().then(function (enabled) {
                return enabled ? '/reports/reportpackages' : '/404';
            });
        }]
    }).when('/reports/templates', {
        resolveRedirectTo: ['$q', 'splitIoService', function ($q, splitIoService) {
            let getSplit = function () {
                let deferred = $q.defer();
                splitIoService.getBoolTreatment('oc_reportusability_usedashboard_16451').subscribe((enabled) => {
                    deferred.resolve(enabled);
                });
                return deferred.promise;
            }

            return getSplit().then(function (enabled) {
                return enabled ? '/reports/templates' : '/404';
            });
        }]
    }).when('/reports/legacyreports', {
        controller: 'MenuCtrl',
        templateUrl: 'reporting/views/menu.html',
        appCode: 'reports'
    }).when('/reports/versionassignment', {
        controller: 'ReportVersionAssignmentCtrl',
        templateUrl: 'reporting/views/report-version-assignment.html',
        appCode: 'reports'
    }).when('/reports/inbox', {
        controller: 'ReportInboxCtrl',
        templateUrl: 'reporting/views/report-inbox.html',
        appCode: 'reports'
    }).when('/reports/batches', {
        controller: 'ReportBatchListCtrl',
        templateUrl: 'reporting/views/report-batch-list.html',
        appCode: 'reports',
        viewCode: 'ReportBatchDto',
        resolveRedirectTo: ['$q', 'splitIoService', function ($q, splitIoService) {
            let getSplit = function () {
                let deferred = $q.defer();
                splitIoService.getBoolTreatment('oc_reportusability_usedashboard_16451').subscribe((enabled) => {
                    deferred.resolve(enabled);
                });
                return deferred.promise;
            }

            return getSplit().then(function (enabled) {
                return enabled ? '/reports/reportbatches' : '/reports/batches';
            });
        }]
    }).when('/reports/reportbatches', {
        resolveRedirectTo: ['$q', 'splitIoService', function ($q, splitIoService) {
            let getSplit = function () {
                let deferred = $q.defer();
                splitIoService.getBoolTreatment('oc_reportusability_usedashboard_16451').subscribe((enabled) => {
                    deferred.resolve(enabled);
                });
                return deferred.promise;
            }

            return getSplit().then(function (enabled) {
                return enabled ? '/reports/reportbatches' : '/404';
            });
        }]
    })
    .when('/reports/batches/entities', {
        controller: 'ReportBatchEntitiesCtrl',
        templateUrl: 'reporting/views/report-batch-entities.html',
        appCode: 'reports',
        resolve: {views: ReportBatchEntitiesCtrl.loadBatchEntityViews}
    }).when('/reports/batches/wizard', {
        controller: 'ReportBatchWizardCtrl',
        templateUrl: 'reporting/views/report-batch-wizard.html',
        appCode: 'reports'
    }).when('/reports/batches/quantum/jobs', {
        controller: 'QuantumJobStatusCtrl',
        templateUrl: 'reporting/views/quantum-job-status.html',
        appCode: 'reports',
        viewCode: 'QuantumJobDto'
    }).when('/reports/reportbuilder3/subreports', {
        controller: 'ReportingEnvisionSubReportListCtrl',
        templateUrl: 'reporting/envision/views/reporting-envision-sub-report-list.html',
        appCode: 'reports',
        resolveRedirectTo: ['$q', 'splitIoService', function ($q, splitIoService) {
            let getSplit = function () {
                let deferred = $q.defer();
                splitIoService.getBoolTreatment('oc_reportusability_usedashboard_16451').subscribe((enabled) => {
                    deferred.resolve(enabled);
                });
                return deferred.promise;
            }

            return getSplit().then(function (enabled) {
                return enabled ? '/reports/subreports' : '/reports/reportbuilder3/subreports';
            });
        }]
    }).when('/reports/subreports', {
        resolveRedirectTo: ['$q', 'splitIoService', function ($q, splitIoService) {
            let getSplit = function () {
                let deferred = $q.defer();
                splitIoService.getBoolTreatment('oc_reportusability_usedashboard_16451').subscribe((enabled) => {
                    deferred.resolve(enabled);
                });
                return deferred.promise;
            }

            return getSplit().then(function (enabled) {
                return enabled ? '/reports/subreports' : '/404';
            });
        }]
    }).when('/reports/reportbuilder3/themes', {
        controller: 'ReportingEnvisionThemeListCtrl',
        templateUrl: 'reporting/envision/views/reporting-envision-theme-list.html',
        appCode: 'reports',
        resolveRedirectTo: ['$q', 'splitIoService', function ($q, splitIoService) {
            let getSplit = function () {
                let deferred = $q.defer();
                splitIoService.getBoolTreatment('oc_reportusability_usedashboard_16451').subscribe((enabled) => {
                    deferred.resolve(enabled);
                });
                return deferred.promise;
            }

            return getSplit().then(function (enabled) {
                return enabled ? '/reports/reportthemes' : '/reports/reportbuilder3/themes';
            });
        }]
    }).when('/reports/reportthemes', {
        resolveRedirectTo: ['$q', 'splitIoService', function ($q, splitIoService) {
            let getSplit = function () {
                let deferred = $q.defer();
                splitIoService.getBoolTreatment('oc_reportusability_usedashboard_16451').subscribe((enabled) => {
                    deferred.resolve(enabled);
                });
                return deferred.promise;
            }

            return getSplit().then(function (enabled) {
                return enabled ? '/reports/reportthemes' : '/404';
            });
        }]
    }) .when('/reports/reportbuilder3/themes/:id', {
        controller: 'ReportingEnvisionThemeItemCtrl',
        templateUrl: 'reporting/envision/views/reporting-envision-theme-item.html',
        appCode: 'reports'
    }).when('/reports/reportbuilder3/coverpages', {
        controller: 'ReportingEnvisionCoverPageListCtrl',
        templateUrl: 'reporting/envision/views/reporting-envision-cover-page-list.html',
        appCode: 'reports',
        resolveRedirectTo: ['$q', 'splitIoService', function ($q, splitIoService) {
            let getSplit = function () {
                let deferred = $q.defer();
                splitIoService.getBoolTreatment('oc_reportusability_usedashboard_16451').subscribe((enabled) => {
                    deferred.resolve(enabled);
                });
                return deferred.promise;
            }

            return getSplit().then(function (enabled) {
                return enabled ? '/reports/coverpages' : '/reports/reportbuilder3/coverpages';
            });
        }]
    }).when('/reports/coverpages', {
        resolveRedirectTo: ['$q', 'splitIoService', function ($q, splitIoService) {
            let getSplit = function () {
                let deferred = $q.defer();
                splitIoService.getBoolTreatment('oc_reportusability_usedashboard_16451').subscribe((enabled) => {
                    deferred.resolve(enabled);
                });
                return deferred.promise;
            }

            return getSplit().then(function (enabled) {
                return enabled ? '/reports/coverpages' : '/404';
            });
        }]
    }).when('/reports/reportbuilder3/coverpages/:id', {
        controller: 'ReportingEnvisionCoverPageItemCtrl',
        templateUrl: 'reporting/envision/views/reporting-envision-cover-page-item.html',
        appCode: 'reports',
        resolve:{
            'reportHelperData': function(reportHelper) {
                return reportHelper.isReady;
            },
            'imageHelperData': function(imageHelper) {
                return imageHelper.isReady;
            }
        }
    }).when('/reports/reportbuilder3/:id', {
        controller: 'ReportEditorCtrl',
        templateUrl: 'reporting/envision/views/report-editor.html',
        appCode: 'reports',
        isTemplate: false
    }).when('/reports/reportbuilder3/subreports/:id', {
        controller: 'SubReportEditorCtrl',
        templateUrl: 'reporting/envision/views/sub-report-editor.html',
        appCode: 'reports',
    }).when('/reports/reportbuilder3/templates/:id', {
        controller: 'ReportEditorCtrl',
        templateUrl: 'reporting/envision/views/report-editor.html',
        appCode: 'reports',
        privilege: 'reportTemplates',
        isTemplate: true
    }).when('/reports/settings', {
        controller: 'ReportsGlobalSettingsCtrl',
        templateUrl: 'reporting/envision/views/reports-global-settings.html',
        appCode: 'reports',
        resolve: {
            dialog: angular.noop
        }
    }).when('/reports/rbdeliver', {
        appCode: 'reports',
        resolveRedirectTo: ['$q', 'splitIoService', function ($q, splitIoService) {
            return getDeliverSplit($q, splitIoService).then(function (isEnabled) {
                return isEnabled ? '/reports/rbdeliver' : '/reports/rbdeliver-old';
            });
        }]
    }).when('/reports/rbdeliver-old', {
        controller: 'DeliverInstanceListCtrl',
        templateUrl: 'reporting/rbdeliver/views/deliver-instance-list.html',
        appCode: 'reports',
        viewCode: 'DeliverInstanceDto'
    }).when('/reports/rbdeliver/emails', {
        appCode: 'reports',
        resolveRedirectTo: ['$q', 'splitIoService', '$location', function ($q, splitIoService, $location) {
            return getDeliverSplit($q, splitIoService).then(function (isEnabled) {
                var currentUrl = $location.url() || '';
                var queryIndex = currentUrl.indexOf('?');
                var query = queryIndex >= 0 ? currentUrl.substring(queryIndex) : '';

                return isEnabled
                    ? '/reports/rbdeliver/emails' + query
                    : '/reports/rbdeliver/emails-old' + query;
            });
        }]
    }).when('/reports/rbdeliver/emails-old', {        controller: 'DeliverEmailListCtrl',
        templateUrl: 'reporting/rbdeliver/views/deliver-email-list.html',
        appCode: 'reports',
        viewCode: 'DeliverEmailDto'
    }).when('/reports/rbdeliver/triggers', {
        appCode: 'reports',
        resolveRedirectTo: ['$q', 'splitIoService', function ($q, splitIoService) {
            return getDeliverSplit($q, splitIoService).then(function (isEnabled) {
                return isEnabled ? '/reports/rbdeliver/triggers' : '/reports/rbdeliver/triggers-old';
            });
        }]
    }).when('/reports/rbdeliver/triggers-old', {
        controller: 'DeliverTriggerListCtrl',
        templateUrl: 'reporting/rbdeliver/views/deliver-trigger-list.html',
        appCode: 'reports',
        viewCode: 'DeliverTriggersDisplayDto'
    }).// TOOLS PAGES
        when('/tools', {
            redirectTo: '/tools/groupingmanager'
        }).when('/tools/apps', {
        controller: 'OasAppListCtrl',
        templateUrl: 'tools/views/oasapp-list.html',
        public: true
    }).when('/tools/partnerappmanagement', {
        controller: 'PartnerAppManagementListCtrl',
        templateUrl: 'tools/integrations/appManagement/partner-app-management-list.html',
        public: true
    }).when('/tools/partnerappmanagement/:partnerAppId', {
        controller: 'PartnerAppManagementCtrl',
        templateUrl: 'tools/integrations/appManagement/partner-app-management.html',
        public: true
    }).when('/tools/compass/lexisnexis/:closed', {
        controller: 'LexisNexisCtrl',
        templateUrl: 'tools/compass/lexis-nexis/LexisNexis.html',
        viewCode: 'SearchResultDto',
        appCode: 'compassAudit'
    }).when('/tools/compass/archive', {
        controller: 'ArchiveCtrl',
        templateUrl: 'tools/compass/views/archive.html',
        appCode: 'compassAudit'
    }).when('/tools/compass/concur', {
        controller: 'ConcurUnlinkedGridCtrl',
        templateUrl: 'tools/compass/views/concur-unlinked-grid.html',
        appCode: 'compassAudit',
        viewCode: 'ConcurUnlinkedUserDto'
    }).when('/tools/compass', {
        resolveRedirectTo: compassLandingRedirect
    }).when('/tools/compass/dashboard', {
        redirectTo: '/tools/compass'
    }).when('/tools/compass/compliance', {
        resolveRedirectTo: compassLandingRedirect
    }).when('/tools/compass/riskDashboard', {
        controller: 'RiskDashboardCtrl',
        templateUrl: 'tools/compass/views/risk-dashboard.html',
        appCode: 'compassAudit'
    }).when('/tools/compass/riskDashboard/riskTileDetails/:type', {
        controller: 'RiskTileDetailsCtrl',
        templateUrl: 'tools/compass/views/risk-tile-details.html',
        appCode: 'compassAudit'
    }).when('/tools/compass/audit', {
        controller: 'AuditListCtrl',
        templateUrl: 'tools/compass/views/audit-list.html',
        appCode: 'compassAudit'
    }).when('/tools/compass/audit/:auditId', {
        controller: 'AuditItemsCtrl',
        templateUrl: 'tools/compass/views/audit-items.html',
        appCode: 'compassAudit'
    }).when('/tools/compass/test/:completed', {
        controller: 'TestResultListCtrl',
        templateUrl: 'tools/compass/views/test-result-list.html',
        appCode: 'compassAudit',
        resolve: {views: testResultListCtrl.loadViewCode}
    }).when('/tools/compass/test/:completed/:id', {
        controller: 'TestResultCtrl',
        templateUrl: 'tools/compass/views/test-result.html',
        appCode: 'compassAudit',
        resolve: {config: testResultCtrl.loadTestResultConfig}
    }).when('/tools/compass/testexceptions', {
        controller: 'TestResultExceptionItemsCtrl',
        templateUrl: 'tools/compass/views/test-result-exception-items.html',
        appCode: 'compassAudit',
        viewCode: 'AuditTestExceptionResultRowDto'
    }).when('/tools/compass/auditlibrary', {
        controller: 'AuditLibraryCtrl',
        templateUrl: 'tools/compass/views/audit-library.html',
        appCode: 'compassAudit'
    }).when('/tools/compass/testschedules', {
        controller: 'TestScheduleListCtrl',
        templateUrl: 'tools/compass/views/test-schedule-list.html',
        appCode: 'compassAudit'
    }).when('/tools/compass/testtemplates', {
        controller: 'TestTemplateCtrl',
        templateUrl: 'tools/compass/views/test-template.html',
        appCode: 'compassAudit'
    }).when('/tools/compass/disclose/adv', {
        controller: 'DiscloseADVDashboardCtrl',
        templateUrl: 'tools/compass/views/disclose-adv-dashboard.html',
        appCode: 'compassAudit'
    }).when('/tools/compass/disclose/13f', {
        controller: 'Disclose13FDashboardCtrl',
        templateUrl: 'tools/compass/views/disclose-13f-dashboard.html',
        appCode: 'compassAudit'
    }).when('/tools/compass/disclose/aua', {
        controller: 'DiscloseAUADashboardCtrl',
        templateUrl: 'tools/compass/views/disclose-aua-dashboard.html',
        appCode: 'compassAudit'
    }).when('/tools/compass/disclose/:type', {
        controller: 'DiscloseAumDetailCtrl',
        templateUrl: 'tools/compass/views/disclose-detail.html',
        appCode: 'compassAudit',
        resolve: {config: discloseAumDetailCtrl.loadDiscloseAumDetailConfig}
    }).when('/tools/compass/inform', {
        controller: 'AdminDashboardCtrl',
        templateUrl: 'tools/compass/inform/views/admin-dashboard.html',
        appCode: 'compassAudit'
    }).when('/tools/compass/inform/deactivateFirm', {
        controller: 'DeactivateFirmCtrl',
        templateUrl: 'tools/compass/Inform/views/deactivate-firm.html',
        appCode: 'compassAudit'
    }).when('/tools/compass/inform/policies', {
        controller: 'AdminPoliciesCtrl',
        templateUrl: 'tools/compass/inform/views/admin-policies.html',
        appCode: 'compassAudit',
        viewCode: 'InformPolicyDto'
    }).when('/tools/compass/inform/historicalDocuments', {
        controller: 'AdminHistoricalDocumentsCtrl',
        templateUrl: 'tools/compass/inform/views/admin-historical-documents.html',
        appCode: 'compassAudit',
        viewCode: 'InformHistoricalDocumentDto'
    }).when('/tools/compass/inform/affirmations', {
        controller: 'AdminAffirmationsCtrl',
        templateUrl: 'tools/compass/inform/views/admin-affirmations.html',
        appCode: 'compassAudit',
        viewCode: 'InformAffirmationDto'
    }).when('/tools/compass/inform/affirmation/responses', {
        controller: 'AdminAffirmationsDetailCtrl',
        templateUrl: 'tools/compass/inform/views/admin-affirmation-detail.html',
        appCode: 'compassAudit',
        viewCode: 'InformAffirmationResponseDto'
    }).when('/tools/compass/inform/brokerageaccounts', {
        controller: 'AdminBrokerageAccountDetailCtrl',
        templateUrl: 'tools/compass/inform/views/admin-brokerage-account-detail.html',
        appCode: 'compassAudit',
        viewCode: 'InformBrokerageAccountDto'
    }).when('/tools/compass/inform/staleholdings', {
        controller: 'AdminStaleHoldingsCtrl',
        templateUrl: 'tools/compass/inform/views/admin-stale-holdings.html',
        appCode: 'compassAudit',
        viewCode: 'InformBrokerageAccountDto'
    }).when('/tools/compass/inform/preclearance', {
        controller: 'AdminPreClearanceDetailCtrl',
        templateUrl: 'tools/compass/inform/views/admin-preclearance-detail.html',
        appCode: 'compassAudit',
        viewCode: 'InformPreClearanceDto'
    }).when('/tools/compass/inform/questionnaires', {
        controller: 'AdminQuestionnairesCtrl',
        templateUrl: 'tools/compass/inform/views/admin-questionnaires.html',
        appCode: 'compassAudit',
        viewCode: 'InformTemplateQuestionnaireGridDto'
    }).
    when('/tools/compass/inform/questionnaire/:templateId', {
        controller: 'AdminQuestionnaireDetailCtrl',
        templateUrl: 'tools/compass/inform/views/admin-questionnaire-detail.html',
        appCode: 'compassAudit',
        resolve: {config: adminQuestionnaireDetailCtrl.loadAdminQuestionnaireDetailCtrl}
    }).when('/tools/compass/inform/tasks', {
        controller: 'AdminTaskCtrl',
        templateUrl: 'tools/compass/inform/views/admin-task.html',
        appCode: 'compassAudit',
        viewCode: 'InformTemplateTaskGridDto'
    }).
    when('/tools/compass/inform/task/:templateId', {
        controller: 'AdminTaskDetailCtrl',
        templateUrl: 'tools/compass/inform/views/admin-task-detail.html',
        appCode: 'compassAudit',
        resolve: {config: adminTaskDetailCtrl.loadAdminTaskDetailCtrl}
    }).when('/tools/compass/inform/accesspersonlist', {
        redirectTo: '/tools/compass/inform/accesspersonlist/Access Person All'
    }).when('/tools/compass/inform/accesspersonlist/:type/:id', {
        controller: 'AccessPersonListCtrl',
        templateUrl: 'tools/compass/inform/views/access-person-list.html',
        appCode: 'compassAudit',
        viewCode: 'InformAccessPersonDto'
    }).when('/tools/compass/inform/accesspersonlist/:type', {
        controller: 'AccessPersonListCtrl',
        templateUrl: 'tools/compass/inform/views/access-person-list.html',
        appCode: 'compassAudit',
        viewCode: 'InformAccessPersonDto'
    }).when('/tools/compass/inform/accessPerson/:accessPersonId', {
        controller: 'AccessPersonDetailCtrl',
        templateUrl: 'tools/compass/inform/views/access-person-detail.html',
        appCode: 'compassAudit',
        viewCode: 'InformAccessPersonDto'
    }).when('/tools/compass/inform/accessPerson/tasks/:accessPersonId/:templateId/:accessPerson', {
        controller: 'AdminTaskDetailCtrl',
        templateUrl: 'tools/compass/inform/views/admin-task-detail.html',
        appCode: 'compassAudit',
        resolve: {config: adminTaskDetailCtrl.loadAdminTaskDetailCtrl}
    }).when('/tools/compass/inform/accessPerson/tradeHistory/:accessPersonId/:fullName?', {
        controller: 'AdminTradeHistoryCtrl',
        templateUrl: 'tools/compass/inform/views/admin-trade-history.html',
        appCode: 'compassAudit',
        viewCode: 'InformTradeHistoryDto'
    }).when('/tools/compass/inform/accessPerson/preclearances/:accessPersonId/:fullName?', {
        controller: 'AdminPreClearanceDetailCtrl',
        templateUrl: 'tools/compass/inform/views/admin-preclearance-detail.html',
        appCode: 'compassAudit',
        viewCode: 'InformPreClearanceDto'
    }).when('/tools/compass/inform/accessPerson/tradeViolation/:accessPersonId/:fullName?', {
        controller: 'TradeViolationDetailCtrl',
        templateUrl: 'tools/compass/inform/views/trade-violation-detail.html',
        appCode: 'compassAudit',
        viewCode: 'InformTradeViolationDto',
    }).when('/tools/compass/inform/accessPerson/holdings/:allAccessPersons', {
        controller: 'AccessPersonHoldingsCtrl',
        templateUrl: 'tools/compass/inform/views/access-person-holdings.html',
        appCode: 'compassAudit',
        viewCode: 'InformHoldingDto'
    }).when('/tools/compass/inform/accessPerson/holdings/:accessPersonId/:fullName?', {
        controller: 'AccessPersonHoldingsCtrl',
        templateUrl: 'tools/compass/inform/views/access-person-holdings.html',
        appCode: 'compassAudit',
        viewCode: 'InformHoldingDto'
    }).when('/tools/compass/inform/manageoptions', {
        controller: 'AdminManageOptionsCtrl',
        templateUrl: 'tools/compass/inform/views/admin-manage-options.html',
        appCode: 'compassAudit'
    }).when('/tools/compass/inform/manageoptions/licenses', {
        controller: 'PersonLicenseListCtrl',
        templateUrl: 'tools/compass/inform/views/person-license-list.html',
        appCode: 'compassAudit',
        viewCode: 'InformLicenseAccessPersonDto'
    }).when('/tools/compass/inform/transactions/:allTrades/:allAccessPersons?',{
        controller: 'AdminTradeHistoryCtrl',
        templateUrl: 'tools/compass/inform/views/admin-trade-history.html',
        appCode: 'compassAudit',
        viewCode: 'InformTradeHistoryDto',
    }).when('/tools/compass/inform/distribute/:templateId', {
        controller: 'DistributeQuestionnaireCtrl',
        templateUrl: 'tools/compass/inform/views/distribute-questionnaire.html',
        appCode: 'compassAudit',
        viewCode: 'InformAccessPersonDto'
    }).when('/tools/compass/inform/tradeviolation/:ruleType?', {
        controller: 'TradeViolationDetailCtrl',
        templateUrl: 'tools/compass/inform/views/trade-violation-detail.html',
        appCode: 'compassAudit',
        viewCode: 'InformTradeViolationDto'
    }).when('/tools/compass/inform/traderules', {
        controller: 'AdminTradeRulesCtrl',
        templateUrl: 'tools/compass/inform/views/admin-trade-rules.html',
        appCode: 'compassAudit',
    }).when('/tools/compass/inform/productMonitoringHistory', {
        controller: 'AdminProductMonitoringHistoryCtrl',
        templateUrl: 'tools/compass/inform/views/admin-product-monitoring-history.html',
        appCode: 'compassAudit',
    }).when('/tools/compass/inform/tradehistory/:allTrades', {
        controller: 'AdminTradeHistoryCtrl',
        templateUrl: 'tools/compass/inform/views/admin-trade-history.html',
        appCode: 'compassAudit',
        viewCode: 'InformTradeHistoryDto'
    }).when('/tools/compass/inform/brokenconnections', {
        controller: 'AdminConnectionDetailCtrl',
        templateUrl: 'tools/compass/inform/views/admin-connection-detail.html',
        appCode: 'compassAudit',
        viewCode: 'InformConnectionDto'
    }).when('/tools/inform', {
        redirectTo: '/tools/inform/dashboard'
    }).when('/tools/inform/dashboard', {
        controller: 'InformDashboardCtrl',
        templateUrl: 'tools/inform/views/inform-dashboard.html',
        appCode: 'inform'
    }).when('/tools/inform/tasks', {
        controller: 'InformTasksCtrl',
        templateUrl: 'tools/inform/views/inform-tasks.html',
        appCode: 'inform'
    }).when('/tools/inform/tasks/:templateId/:templateName', {
        controller: 'InformTaskDetailCtrl',
        templateUrl: 'tools/inform/views/inform-task-detail.html',
        appCode: 'inform',
        resolve: {config: informTaskDetail.loadInformTaskDetail}
    }).when('/tools/inform/questionnaires', {
        controller: 'InformQuestionnairesCtrl',
        templateUrl: 'tools/inform/views/inform-questionnaires.html',
        appCode: 'inform'
    }).when('/tools/inform/exceptions', {
        controller: 'InformTradeViolationsCtrl',
        templateUrl: 'tools/inform/views/inform-trade-violations.html',
        appCode: 'inform'
    }).when('/tools/inform/preclearances/:accessPersonId', {
        controller: 'InformPreclearanceCtrl',
        templateUrl: 'tools/inform/views/inform-preclearance.html',
        appCode: 'inform',
        viewCode: 'InformPreClearanceDto'
    }).when('/tools/inform/preclearances/:accessPersonId/:all', {
        controller: 'InformPreclearanceCtrl',
        templateUrl: 'tools/inform/views/inform-preclearance.html',
        appCode: 'inform',
        viewCode: 'InformPreClearanceDto'
    }).when('/tools/inform/trading', {
        controller: 'AdminTradeHistoryCtrl',
        templateUrl: 'tools/compass/inform/views/admin-trade-history.html',
        appCode: 'inform',
        viewCode: 'InformTradeHistoryDto'
    }).when('/tools/inform/historicalDocuments', {
        controller: 'InformHistoricalDocumentsCtrl',
        templateUrl: 'tools/inform/views/inform-historical-documents.html',
        appCode: 'inform',
        viewCode: 'InformHistoricalDocumentSimpleDto'
    }).when('/tools/compass/inform/historicalDocuments/accessPerson/:accessPersonId/:fullName?', {
        controller: 'AdminHistoricalDocumentsCtrl',
        templateUrl: 'tools/compass/inform/views/admin-historical-documents.html',
        appCode: 'compassAudit',
        viewCode: 'InformHistoricalDocumentDto'
    }).when('/tools/inform/holdings', {
        controller: 'AccessPersonHoldingsCtrl',
        templateUrl: 'tools/compass/inform/views/access-person-holdings.html',
        appCode: 'inform',
        viewCode: 'InformHoldingDto'
    }).when('/tools/apps/:appCode', {
        controller: 'OasAppCtrl',
        templateUrl: 'tools/views/oasapp.html',
        public: true
    }).when('/tools/email/new', {
        controller: 'EmailEditCtrl',
        templateUrl: 'tools/views/email-edit.html',
        appCode: 'secureExchange'
    }).when('/tools/email/:folder', {
        controller: 'EmailListCtrl',
        templateUrl: 'tools/views/email-list.html',
        appCode: 'secureExchange',
        resolve: {views: emailListCtrl.loadEmailViews}
    }).when('/tools/groupingmanager/database', {
        controller: 'DatabaseGroupingManagerCtrl',
        templateUrl: 'tools/views/database-grouping-manager.html',
        appCode: 'groupingManager',
        viewCode: 'DatabaseGroupDto'
    }).when('/tools/groupingmanager/database/:id', {
        controller: 'DatabaseGroupingEditorCtrl',
        templateUrl: 'tools/views/database-grouping-editor.html',
        appCode: 'groupingManager'
    }).when('/tools/groupingmanager/:entity', {
        controller: 'GroupingManagerCtrl',
        templateUrl: 'tools/views/grouping-manager.html',
        appCode: 'groupingManager',
        resolve: {views: groupingManagerCtrl.loadGroupingView}
    }).when('/tools/recordcompare', {
        controller: 'RecordCompareCtrl',
        templateUrl: 'tools/views/recordcompare.html',
        public: true
    }).when('/tools/selfservice', {
        controller: 'ServiceRequestCtrl',
        templateUrl: 'tools/selfservice/views/service-form.html',
        appCode: 'selfService'
    }).when('/tools/synchistory', {
        controller: 'SyncHistoryCtrl',
        templateUrl: 'tools/views/sync-history.html',
        appCode: 'sfSyncHistory'
    }).when('/tools/notifications', {
        controller: 'NotificationCtrl',
        templateUrl: 'tools/views/notifications.html',
        appCode: 'notifications',
        viewCode: 'NotificationDto'
    }).when('/tools/notifications/category/:category', {
        controller: 'NotificationCtrl',
        templateUrl: 'tools/views/notifications.html',
        appCode: 'notifications',
        viewCode: 'NotificationDto'
    }).when('/tools/notifications/subscriptions', {
        controller: 'NotificationSubscriptionsCtrl',
        templateUrl: 'tools/views/notification-subscriptions.html',
        appCode: 'notifications'
    }).when('/tools/notifications/smssettings', {
        controller: 'SMSSettingsCtrl',
        templateUrl: 'tools/views/sms-settings.html',
        appCode: 'notifications'
    }).when('/tools/integrations/partnerApps', {
        controller: 'IntegrationCenterCtrl',
        templateUrl: 'tools/integrations/integrationCenter/icContainer.html',
        appCode: 'integrationsSetup'
    }).when('/tools/integrations/integrationCenter', {
        controller: 'IntegrationCenterCtrl',
        templateUrl: 'tools/integrations/integrationCenter/icContainer.html',
        appCode: 'integrationsSetup'
    }).when('/tools/fileimport', {
        controller: 'ImportFilesCtrl',
        appCode: 'fileImportApp',
        templateUrl: 'tools/views/import-files.html',
        viewCode: 'FileImportInstanceDto'
    }).when('/tools/fileimportwizard', {
        controller: 'ImportFilesWizardCtrl',
        appCode: 'fileImportApp',
        templateUrl: 'tools/views/import-files-wizard.html'
    }).when('/tools/filelist/:instanceId', {
        controller: 'FileListCtrl',
        appCode: 'fileImportApp',
        templateUrl: 'tools/views/file-list.html'
    }).when('/tax/taxlotassignments', {
        controller: 'TaxLotAssignmentsCtrl',
        templateUrl: 'tools/tax/views/taxlotassignments.html',
        appCode: 'taxCenter',
        viewCode: 'AssetDto'
    }).when('/tax/interfaces', {
        controller: 'TaxInterfacesCtrl',
        templateUrl: 'tools/tax/views/tax-interfaces.html',
        appCode: 'taxCenter'
    }).when('/tax/:type', {
        controller: 'StoredCostBasisListCtrl',
        templateUrl: 'tools/tax/views/storedcostbasis-list.html',
        appCode: 'taxCenter',
        resolve: {
            views: storedCostBasisListCtrl.loadStoredCostView,
            dates: storedCostBasisListCtrl.loadStoredCostListDates
        }
    }).when('/tax/audit/:type', {
        controller: 'StoredCostBasisAuditListCtrl',
        templateUrl: 'tools/tax/views/storedcostbasisaudit-list.html',
        appCode: 'taxCenter',
        resolve: {views: storedCostBasisAuditListCtrl.loadStoredCostAuditView}
    }).when('/tax/audits/transactions', {
        controller: 'TaxTransactionErrorsCtrl',
        templateUrl: 'tools/tax/views/tax-transaction-errors.html',
        appCode: 'taxCenter',
        viewCode: 'TransactionDtoWithErrors'
    }).when('/tools/maintainlogins', {
        redirectTo: function () {
            return '/tools/maintainlogins/' + (isInformOnlyAdmin ? 'Advisor' : 'Household');
        }
    }).when('/tools/maintainlogins/:loginentity', {
        template: '',
        appCode: 'manageUserLogin',
        resolveRedirectTo: ['$q', '$route', 'splitIoService', function ($q, $route, splitIoService) {
            var getSplit = function () {
                var deferred = $q.defer();
                splitIoService.getBoolTreatment('oc_manageusers_newgrids_14811').subscribe(function (isEnabled) {
                    deferred.resolve(isEnabled);
                });
                return deferred.promise;
            };
            return getSplit().then(function (isEnabled) {
                var loginentity = $route.current.params.loginentity || 'Household';
                return isEnabled ? '/tools/maintainlogins/' + loginentity : '/tools/maintainlogins-old/' + loginentity;
            });
        }]
    }).when('/tools/maintainlogins-old/:loginentity', {
        templateUrl: 'tools/views/maintain-login-list.html',
        controller: 'MaintainLoginListCtrl',
        appCode: 'manageUserLogin',
        resolve: {loginEntities: maintainLoginListCtrl.loadLoginEntities, views: maintainLoginListCtrl.loadViews}
    }).when('/tools/newuserimport', {
        resolveRedirectTo: ['$q', 'splitIoService', function($q, splitIoService) {
            let getSplit = function() {
                let deferred = $q.defer();
                splitIoService.getBoolTreatment('pi_newuserimport_usenewcomponent_oc8414').subscribe((isEnabled) => {
                    deferred.resolve(isEnabled);
                });
                return deferred.promise;
            }

            return getSplit().then(function(isEnabled) {
                return isEnabled ? '/tools/newuserimport-new' : '/tools/newuserimport-old';
            });
        }]
    }).when('/tools/newuserimport-old', {
        templateUrl: 'tools/views/new-user-import.html',
        controller: 'NewUserImportCtrl',
        appCode: 'manageUserLogin'
    }).when('/tools/passwordemailtemplate', {
        templateUrl: 'tools/views/password-email-template.html',
        controller: 'PasswordEmailTemplateCtrl',
        appCode: 'manageUserLogin'
    }).when('/tools/rolesync', {
        templateUrl: 'tools/views/role-sync.html',
        controller: 'RoleSyncCtrl',
        appCode: 'manageUserLogin',
        resolve: {loginEntities: maintainLoginListCtrl.loadLoginEntities}
    }).when('/tools/roles', {
         appCode: 'manageUserLogin',
         resolveRedirectTo: ['$q', 'splitIoService', function ($q, splitIoService) {
            const getSplit = function () {
                const deferred = $q.defer();
                splitIoService.getBoolTreatment('oc_manageusers_newgrids_14811').subscribe((isEnabled) => {
                    deferred.resolve(isEnabled);
                });
                return deferred.promise;
            };
            return getSplit().then(function (isEnabled) {
                return isEnabled ? '/tools/roles' : '/tools/roles-old';
            });
        }]
    }).when('/tools/roles-old', {
        templateUrl: 'tools/views/roles-list.html',
        controller: 'RolesListCtrl',
        appCode: 'manageUserLogin',
        viewCode: 'RoleDto',
        resolve: {loginEntities: maintainLoginListCtrl.loadLoginEntities}
    }).when('/tools/privileges', {
        template: '',
        appCode: 'manageUserLogin',
        resolveRedirectTo: ['$q', 'splitIoService', function ($q, splitIoService) {
            var getSplit = function () {
                var deferred = $q.defer();
                splitIoService.getBoolTreatment('oc_manageusers_newgrids_14811').subscribe(function (isEnabled) {
                    deferred.resolve(isEnabled);
                });
                return deferred.promise;
            };
            return getSplit().then(function (isEnabled) {
                return isEnabled ? '/tools/privileges' : '/tools/privileges-old';
            });
        }],
    }).when('/tools/privileges-old', {
        templateUrl: 'tools/views/privileges-list.html',
        controller: 'PrivilegesListCtrl',
        appCode: 'manageUserLogin',
        viewCode: 'PrivilegeDto'
    }).when('/tools/process', {
        controller: 'ProcessDashboardCtrl',
        templateUrl: 'tools/processdashboard/views/process-dashboard.html',
        appCode: 'processDashboard',
        resolve: {config: processDashboardApp.processDashboardInitialized}
    }).when('/tools/process/tasks/:taskId?', {
        controller: 'ProcessTaskDashboardCtrl',
        templateUrl: 'tools/processdashboard/views/process-task-dashboard.html',
        appCode: 'processDashboard',
        resolve: {config: processDashboardApp.processDashboardInitialized}
    }).when('/tools/process/actions', {
        controller: 'ProcessActionListCtrl',
        templateUrl: 'tools/processdashboard/views/process-action-list.html',
        appCode: 'processDashboard',
        resolve: {config: processDashboardApp.processDashboardInitialized}
    }).when('/tools/process/instances', {
        controller: 'ProcessInstanceListCtrl',
        templateUrl: 'tools/processdashboard/views/process-instance-list.html',
        appCode: 'processDashboard',
        resolve: {config: processDashboardApp.processDashboardInitialized}
    }).when('/tools/process/instances/:id', {
        controller: 'ProcessInstanceCtrl',
        templateUrl: 'tools/processdashboard/views/process-instance.html',
        appCode: 'processDashboard',
        resolve: {config: processDashboardApp.processDashboardInitialized}
    }).when('/tools/process/definitions/:id', {
        controller: 'ProcessDefinitionCtrl',
        templateUrl: 'tools/processdashboard/views/process-definition.html',
        appCode: 'processDashboard',
        resolve: {config: processDashboardApp.processDashboardInitialized}
    }).when('/tools/process/types/:id', {
        controller: 'ProcessTypeCtrl',
        templateUrl: 'tools/processdashboard/views/process-type.html',
        appCode: 'processDashboard',
        resolve: {config: processDashboardApp.processDashboardInitialized}
    }).when('/tools/workflows/:processtypecode', {
        controller: 'WorkflowProcessListCtrl',
        templateUrl: 'tools/workflowprocess/views/workflow-process-list.html',
        appCode: 'interfaceSetup' //ToDo: Refactor out appCode
    }).when('/tools/workflows/:processtypecode/:id', {
        controller: 'WorkflowProcessCtrl',
        templateUrl: 'tools/workflowprocess/views/workflow-process.html',
        appCode: 'interfaceSetup' //ToDo: Refactor out appCode
    }).//TRADING PAGES
        when('/trading', {
            redirectTo: '/trading/tom/orders'
        }).when('/modeling/modelaggs', {
        controller: 'ModelListCtrl',
        templateUrl: 'trading/views/model-list.html',
        viewCode: 'ModelAggDto',
        appCode: 'models'
    }).when('/modeling/modelaggs/:modelAggId', {
        controller: 'ModelAggCtrl',
        templateUrl: 'trading/views/model-agg.html',
        appCode: 'models',
        resolve: {
            args: function ($route) {
                return {modelAggId: $route.current.params.modelAggId, isModalEdit: false};
            },
            dialog: angular.noop
        }
    }).when('/modeling/models', {
        controller: 'ModelListCtrl',
        templateUrl: 'trading/views/model-list.html',
        viewCode: 'ModelValueDto',
        appCode: 'models'
    }).when('/modeling/models/:modelId', {
        controller: 'ModelCtrl',
        templateUrl: 'trading/views/model.html',
        appCode: 'models'
    }).when('/modeling/strategistmodels', {
        controller: 'CommunityModelsListCtrl',
        templateUrl: 'trading/views/community-models-list.html',
        viewCode: 'CommunityModelDto',
        appCode: 'models'
    }).when('/modeling/strategistmodels/:communityModelId', {
        controller: 'CommunityModelCtrl',
        templateUrl: 'trading/views/community-model.html',
        appCode: 'models'
    }).when('/modeling/communitymodels', {
        redirectTo: '/modeling/strategistmodels'
    }).when('/modeling/communitymodels/:communityModelId', {
        redirectTo: '/modeling/strategistmodels/:communityModelId'
    }).when('/modeling/sleevestrategy', {
        controller: 'SleeveStrategyListCtrl',
        templateUrl: 'trading/views/sleeveStrategy-list.html',
        viewCode: 'SleeveStrategyDto',
        appCode: 'sleeveStrategy'
    }).when('/modeling/sleevestrategyagg', {
        controller: 'SleeveStrategyAggListCtrl',
        templateUrl: 'trading/views/sleeveStrategyAgg-list.html',
        viewCode: 'SleeveStrategyAggregateDto',
        appCode: 'sleeveStrategy'
    }).when('/modeling/sleevestrategy/import', {
        controller: 'SleeveStrategyImportCtrl',
        templateUrl: 'trading/views/sleeve-strategy-import.html',
        appCode: 'sleeveStrategy'
    }).when('/modeling/sleevestrategy/:sleeveStrategyId', {
        controller: 'SleeveStrategyCtrl',
        templateUrl: 'trading/views/sleeveStrategy.html',
        appCode: 'sleeveStrategy'
    }).when('/modeling/sleevestrategyagg/:sleeveStrategyAggId', {
        controller: 'SleeveStrategyAggCtrl',
        templateUrl: 'trading/views/sleeveStrategyAgg.html',
        appCode: 'sleeveStrategy'
    }).when('/trading/convexrebalanceaccount', {
        controller: 'ConvexRebalanceAccountListCtrl',
        templateUrl: 'trading/views/convex-rebalance-account-list.html',
        viewCode: 'ConvexRebalanceAccountDto',
        appCode: 'tom'
    }).when('/trading/systemtradequeue/:queueFilter?', {
        controller: 'SystemTradeQueueCtrl',
        templateUrl: 'trading/views/system-trade-queue-list.html',
        appCode: 'systemTradeQueue',
        resolve: {views: systemTradeQueueCtrl.loadSystemTradeView}
    }).when('/trading/tom/orders', {
        controller: 'TOMUnblockedOrdersCtrl',
        templateUrl: 'trading/views/tom-unblocked-orders.html',
        appCode: 'tom',
        viewCode: 'OrderDto',
        resolve: {
            defaultSettings: tomUnblockedOrdersCtrl.loadUnblockedOrderDefaults,
            searchResult: tomBlockedOrdersCtrl.loadSearchForOrders
        }
    }).when('/trading/tom/open', {
        controller: 'TOMBlocksCtrl',
        templateUrl: 'trading/views/tom-blocks.html',
        appCode: 'tom',
        viewCode: 'FixBlockOrderDto'
    }).when('/trading/tom/owa', {
        controller: 'TOMBlockedOrdersCtrl',
        templateUrl: 'trading/views/tom-blocked-orders.html',
        appCode: 'tom',
        viewCode: 'openOrder',
        resolve: {searchResult: angular.noop}
    }).when('/trading/tom/open/:blockId', {
        controller: 'TOMBlockedOrdersCtrl',
        templateUrl: 'trading/views/tom-blocked-orders.html',
        appCode: 'tom',
        viewCode: 'openOrder',
        resolve: {searchResult: angular.noop}
    }).when('/trading/tom/allocations', {
        controller: 'TOMBlocksCtrl',
        templateUrl: 'trading/views/tom-blocks.html',
        appCode: 'tom',
        viewCode: 'allocations'
    }).when('/trading/tom/allocations/:blockId', {
        controller: 'TOMUnallocatedOrdersCtrl',
        appCode: 'tom',
        templateUrl: 'trading/views/tom-unallocated-orders.html'
    }).when('/trading/tom/pending', {
        controller: 'TOMBlocksCtrl',
        templateUrl: 'trading/views/tom-blocks.html',
        appCode: 'tom',
        viewCode: 'pendingBlock'
    }).when('/trading/tom/pending/:blockId', {
        controller: 'TOMBlockedOrdersCtrl',
        templateUrl: 'trading/views/tom-blocked-orders.html',
        appCode: 'tom',
        viewCode: 'pendingTrans',
        resolve: {searchResult: tomBlockedOrdersCtrl.loadSearchForBlockedOrders}
    }).when('/trading/tom/closed', {
        controller: 'TOMBlocksCtrl',
        templateUrl: 'trading/views/tom-blocks.html',
        appCode: 'tom',
        viewCode: 'closedBlock'
    }).when('/trading/tom/closed/:blockId', {
        controller: 'TOMBlockedOrdersCtrl',
        templateUrl: 'trading/views/tom-blocked-orders.html',
        appCode: 'tom',
        viewCode: 'closedOrder',
        resolve: {searchResult: tomBlockedOrdersCtrl.loadSearchForBlockedOrders}
    }).when('/trading/tom/tradefiles', {
        controller: 'TOMTradeFilesCtrl',
        templateUrl: 'trading/views/tom-trade-files.html',
        appCode: 'tom'
    }).when('/trading/tom/deleted', {
        controller: 'TOMBlocksCtrl',
        templateUrl: 'trading/views/tom-blocks.html',
        appCode: 'tom',
        viewCode: 'FixTradeRequestHistoryDto'
    }).when('/trading/rebalance', {
        controller: 'RebalanceCtrl',
        templateUrl: 'trading/views/rebalance.html',
        appCode: 'tom'
    }).when('/trading/communitymodelrebalance', {
        redirectTo: '/trading/strategistmodelrebalance'
    }).when('/trading/globaltrades', {
        controller: 'GlobalTradesCtrl',
        templateUrl: 'trading/views/global-trades.html',
        appCode: 'tom'
    }).when('/trading/proratedcashtrades', {
        controller: 'ProratedCashTradesCtrl',
        templateUrl: 'trading/views/prorated-cash-trades.html',
        appCode: 'tom'
    }).when('/trading/targetpercent', {
        controller: 'TargetPercentCtrl',
        templateUrl: 'trading/views/target-percent.html',
        appCode: 'tom'
    }).when('/trading/taxtickerswap', {
        controller: 'GlobalTradesCtrl',
        templateUrl: 'trading/views/global-trades.html',
        appCode: 'tom'
    }).when('/trading/tacticaltrades', {
        controller: 'TacticalTradesCtrl',
        templateUrl: 'trading/views/tactical-trades.html',
        appCode: 'tom',
        viewCode: 'TacticalTradeDto'
    }).when('/modeling/sleeve/import', {
        controller: 'SleeveImportCtrl',
        templateUrl: 'trading/views/sleeve-import.html',
        appCode: 'sleeveStrategy'
    }).when('/trading/sleeve/transfer', {
        controller: 'SleeveTransferCtrl',
        templateUrl: 'trading/views/sleeve-transfer.html',
        resolve: {config: sleeveTransferCtrl.loadSleeveConfig},
        appCode: 'tom'
    }).when('/trading/distributions', {
        controller: 'DistributionsCtrl',
        templateUrl: 'trading/views/distributions.html',
        appCode: 'tom'
    }).when('/trading/tradeexecutelog', {
        controller: 'TradeExecuteLogCtrl',
        templateUrl: 'trading/views/trade-execute-log.html',
        appCode: 'systemTradeQueue'
    }).when('/trading/instances', {
        controller: 'TradeInstanceListCtrl',
        templateUrl: 'trading/views/trade-instance-list.html',
        appCode: 'tom',
        viewCode: 'TradeRequestInstanceDto'
    }).when('/trading/pendaccounts', {
        controller: 'PendAccountListCtrl',
        templateUrl: 'trading/views/pend-account-list.html',
        appCode: 'tom',
        viewCode: 'PendAccountDto'
    }).when('/trading/errorchecks', {
        controller: 'TradeErrorChecksCtrl',
        templateUrl: 'trading/views/trade-error-checks.html',
        viewCode: 'TradeRunErrorChecksAccountDto',
        appCode: 'systemTradeQueue'
    }).when('/trading/irebalexport', {
        controller: 'IRebalExportCtrl',
        templateUrl: 'trading/views/irebal-export.html',
        appCode: 'tom'
    }).when('/trading/portfoliotargets', {
        redirectTo: '/trading/portfoliotargets/registration'
    }).when('/trading/portfoliotargets/registration', {
        controller: 'PortfolioTargetRegistrationCtrl',
        templateUrl: 'trading/portfolioTargets/views/portfolio-targets-registration.html',
        resolve: {config: portfolioTargetRegistrationCtrl.chooseRep},
        appCode: 'portfolioTargets'
    }).when('/trading/portfoliotargets/households', {
        controller: 'PortfolioTargetHouseholdListCtrl',
        templateUrl: 'trading/portfolioTargets/views/portfolio-target-household-list.html',
        appCode: 'portfolioTargets',
        viewCode: 'BlendedModelManagementClientDto'
    }).when('/trading/portfoliotargets/bmm', {
        controller: 'PortfolioTargetBlendedModelManagementCtrl',
        templateUrl: 'trading/portfolioTargets/views/portfolio-target-blended-model-management.html',
        resolve: {config: portfolioTargetBlendedModelManagementCtrl.chooseRep},
        appCode: 'portfolioTargets'
    }).when('/trading/portfoliotargets/rtm', {
        controller: 'PortfolioTargetsRiskTypeManagementCtrl',
        templateUrl: 'trading/portfolioTargets/views/portfolio-target-risk-type-management.html',
        appCode: 'portfolioTargets'
    }).when('/trading/portfoliotargets/accountassignment', {
        controller: 'PortfolioTargetAccountAssignmentCtrl',
        templateUrl: 'trading/portfolioTargets/views/portfolio-targets-account-assignment.html',
        viewCode: 'AccountAssignmentDto',
        resolve: {configResolve: portfolioTargetAccountAssignmentCtrl.loadSearchAccountView},
        appCode: 'portfolioTargets'
    }).when('/trading/eclipsefirms', {
        controller: 'EclipseFirmsListCtrl',
        templateUrl: 'trading/eclipse/views/eclipse-firms-list.html',
        appCode: 'firmProfile',
		redirectTo: '/trading/eclipsefirms-new'
    }).when('/trading/eclipsefirms/:id', {
        controller: 'EclipseFirmsCtrl',
        templateUrl: 'trading/eclipse/views/eclipse-firms.html',
        appCode: 'firmProfile'
    }).when('/trading/orionconnectfirm', {
        controller: 'OrionConnectFirmCtrl',
        templateUrl: 'trading/eclipse/views/oc-firm-setup.html',
        appCode: 'firmProfile'
    }).when('/trading/batchprocessing', {
        controller: 'BatchProcessingListCtrl',
        templateUrl: 'trading/batchProcessing/views/batch-processing-list.html',
        appCode: 'firmProfile'
    }).when('/trading/risktolerances', {
        controller: 'RiskTolerancesCtrl',
        templateUrl: 'trading/riskTolerances/views/risk-tolerances.html',
        appCode: 'firmProfile'
    }).when('/trading/contributions', {
        controller: 'ContributionsCtrl',
        templateUrl: 'trading/views/contributions.html',
        appCode: 'tom'
    }).when('/trading/sleevesetup', {
        controller: 'SleeveSetupWizardCtrl',
        templateUrl: 'trading/views/sleeve-setup-wizard.html',
        appCode: 'sleeveStrategy'
    }).when('/astrolight', {
        controller: 'AstroLightWizardCtrl',
        templateUrl: 'trading/views/astro-light-wizard.html',
        appCode: 'astroLight'
    }).//EMBED PAGES
        when('/embed/portfoliotargets/registration', {
            controller: 'PortfolioTargetRegistrationCtrl',
            templateUrl: 'trading/portfolioTargets/views/portfolio-targets-registration.html',
            resolve: {config: portfolioTargetRegistrationCtrl.chooseRep},
            public: true
        }).when('/embed/portfoliotargets/households', {
        controller: 'PortfolioTargetHouseholdListCtrl',
        templateUrl: 'trading/portfolioTargets/views/portfolio-target-household-list.html',
        public: true,
        viewCode: 'BlendedModelManagementClientDto'
    }).when('/embed/portfoliotargets/bmm', {
        controller: 'PortfolioTargetBlendedModelManagementCtrl',
        templateUrl: 'trading/portfolioTargets/views/portfolio-target-blended-model-management.html',
        resolve: {config: portfolioTargetBlendedModelManagementCtrl.chooseRep},
        public: true
    }).when('/embed/portfoliotargets/accountassignment', {
        controller: 'PortfolioTargetAccountAssignmentCtrl',
        templateUrl: 'trading/portfolioTargets/views/portfolio-targets-account-assignment.html',
        viewCode: 'AccountAssignmentDto',
        resolve: {configResolve: portfolioTargetAccountAssignmentCtrl.loadSearchAccountView},
        public: true
    }).when('/embed/sleeve/transfer', {
        controller: 'SleeveTransferCtrl',
        templateUrl: 'trading/views/sleeve-transfer.html',
        resolve: {config: sleeveTransferCtrl.loadSleeveConfig},
        public: true
    }).when('/embed/portfolio/households/:householdFilter?', {
        controller: 'HouseholdListCtrl',
        templateUrl: 'portfolio/lists/views/household-list.html',
        public: true,
        viewCode: 'ClientDto',
        entity: '5',
        resolve: {searchResult: householdListCtrl.loadPortfolioListConfig}
    }).when('/embed/portfolio/registrations/:registrationFilter?', {
        controller: 'RegistrationListCtrl',
        templateUrl: 'portfolio/lists/views/registration-list.html',
        public: true,
        viewCode: 'RegistrationDto',
        entity: '6',
        resolve: {searchResult: householdListCtrl.loadPortfolioListConfig}
    }).when('/embed/portfolio/accounts/:accountFilter?', {
        controller: 'AccountListCtrl',
        templateUrl: 'portfolio/lists/views/account-list.html',
        public: true,
        entity: '7',
        resolve: {views: AccountListCtrl.loadAccountViews, searchResult: householdListCtrl.loadPortfolioListConfig}
    }).when('/embed/portfolio/assets', {
        controller: 'AssetListCtrl',
        templateUrl: 'portfolio/lists/views/asset-list.html',
        public: true,
        viewCode: 'AssetDto'
    }).when('/embed/portfolio/transactions', {
        controller: 'TransactionListCtrl',
        templateUrl: 'portfolio/lists/views/transaction-list.html',
        public: true,
        viewCode: 'TransactionSortOrderUnitBalanceDto',
        resolve: {dates: transactionListCtrl.loadTransactionListDates}
    }).when('/embed/trading/rebalance', {
        controller: 'RebalanceCtrl',
        templateUrl: 'trading/views/rebalance.html',
        public: true,
        resolve: {
            args: function ($route, $rebalance) {
                return $rebalance.start(6, [$route.current.params.accountId])
            }
        }
    }).when('/customImports2',{
        redirectTo: '/customImports2/templates'
    }).when('/customImports2/history',{
        controller:'customImportsV2HistoryCtrl',
        templateUrl:'CustomImportsV2/views/customImportsV2History.html',
        appCode:'customImports2',
        viewCode:'ImportWithoutDataDto'
    }).when('/customImports2/history/multidb',{
        controller:'CustomImportsV2MultiDbHistoryCtrl',
        templateUrl:'CustomImportsV2/views/customImportsV2MultiDbHistory.html',
        appCode:'customImports2',
        viewCode:'ImportCommonExtImportCommonDto'
    }).when('/customImports2/history/multidb/:importCommonId', {
        controller:'CustomImportsV2MultiDbSummaryCtrl',
        templateUrl:'CustomImportsV2/views/customImportsV2MultiDbSummary.html',
        appCode:'customImports2',
        viewCode:'ImportCommonExtDetailsDto'
    }).when('/customImports2/orionVisionHistory/:imported?',{
        controller:'customImportsV2OrionVisionHistoryCtrl',
        templateUrl:'CustomImportsV2/views/customImportsV2OrionVisionHistory.html',
        appCode:'customImports2',
        viewCode:'ImportOrionVisionDto'
    }).when('/customImports2/templates',{
        controller:'customImportsV2TemplatesCtrl',
        templateUrl:'CustomImportsV2/views/customImportsV2Templates.html',
        appCode:'customImports2',
        resolve:{
            importTypes(civ2Service){
                return civ2Service.getImportTypes().then(function(res){return res.data});
            },
            multiDbImportTypes: customImportsV2TemplatesCtrl.loadMultiDbImportTypes
        }
    }).when('/customImports2/maintenance/dbaccess', {
        controller:'CustomImportsV2DbAccessMaintenanceCtrl',
        templateUrl:'CustomImportsV2/views/customImportsV2DbAccessMaintenance.html',
        appCode:'customImports2',
        viewCode:'UserDatabasesDto'
    }).when('/customImports2/:state/:typeId/:id/:orionVision?',{
        controller:'customImportsV2ViewCtrl',
        templateUrl:'CustomImportsV2/views/customImportsV2View.html',
        appCode:'customImports2',
        resolve:{
            importTypes(civ2Service, $route){
                return civ2Service.getImportData($route.current.params.id,$route.current.params.typeId,$route.current.params.state);
            }
        }
    }).when('/customImports2StructureEdit/:id',{
        controller:'customImportsV2StructureEditCtrl',
        templateUrl:'CustomImportsV2/views/customImportsV2StructureEdit.html',
        appCode:'customImports2',
        resolve:{
            importType(civ2Service, $route){
                return civ2Service.getImportType($route.current.params.id).then(function(res){return res.data;});
            }
        }
    }).when('/ApexDashboard',{
        controller:'apexDashboardCtrl',
        templateUrl:'integrations/apex/views/ApexDashboard.html',
        appCode: 'newAccountsCenter',
        public: true
    }).when('/ApexACHFunding',{
        controller:'apexACHFundingCtrl',
        templateUrl:'integrations/apex/views/ApexACHFunding.html',
        appCode: 'newAccountsCenter',
        public: true
    }).
        //ERROR PAGES
        when('/404', {
            templateUrl: 'app/views/404.html',
            public: true
        }).when('/notauthorized', {
        templateUrl: 'app/views/notAuthorized.html',
        public: true
    }).otherwise({
        redirectTo: '/404'
    });
});

'use strict';

app.controller('AppCtrl', function AppCtrl($scope, $rootScope, $http, $q, $location, $timeout, $dialog, promiseTracker, $notifications, $oasRights, sessionReset, sidebarService, API_CONFIG, gliaService, authenticationService, breadcrumbsService, userOptionService, splitIoService) {
    //PRIVATE METHODS
    function init(userAuthData) {
        const routeParams = $location.search();
        const forPrint = routeParams.forPrint && routeParams.forPrint === 'true';

        if (userAuthData.alClientLockType === 1 && userAuthData.entity !== "Representative") {
            $scope.user.alerts.push({ type: 'warning', msg: 'You are in billing lockdown!!!' });
        }

        // Don't allow users without UI access and don't allow clients in ever unless its the report prompt (used in advisorlynx.com)
        if (!userAuthData.rights.canRead_UIACCESS || (userAuthData.entity === 'Household' && !$location.path().startsWith('/reports/prompt/'))) {
            sessionReset.logout();
        } else {
            $scope.user.authorization = userAuthData;

            sessionStorage.oas_authorization = JSON.stringify(userAuthData);
            $rootScope.$broadcast("user-auth-loaded", $scope.user.authorization.alClientId);
            switch (userAuthData.alClientId) {
                case 269:
                    $scope.user.isPFM = true;
                    break;
                case 377:
                    $scope.user.isFTJ = true;
                    break;
                case 2030:
                    $scope.user.isStephensGroupAssetManagement = true;
                    break;
            }
            $scope.user.isBAM = userAuthData.masterGroup === 'BAM';

            $scope.user.isImpersonating = !!userAuthData.actualUserId;

            $scope.user.repCobrowse = false;

            $scope.user.gliaRepChatSupport = false;
            $scope.user.isContactUsV2Enabled = false;

            $http.get('/Integrations/Support/IsContactUsV2Enabled', { allowCancellation: false })
                .then(function (response) {
                    $scope.user.isContactUsV2Enabled = response.data;
                });

            //signalR notifications
            if (!forPrint) {
                loadNotifications();
            }

            const isNonLocal = !window.location.host.has('local') && !forPrint;

            if (isNonLocal) {
                 //Glia
                 checkForRepCobrowse();
                 if (['Representative', 'BrokerDealer'].any(userAuthData.entity)) {
                     checkRepChat();
                     gliaService.loadGliaForReps(userAuthData);
                 } else {
                     gliaService.loadGliaForNonReps($scope);
                 }
            }

            $oasRights.isLoaded.then(() => {
                loadTwoFactorOptions();

                if (isNonLocal) {
                    loadFullStory();
                    loadGainsight();
                }
            });
        }

        const isCrm = sessionStorage.oas_menu === 'crm';

        $scope.enableTopNavBar = !isCrm  &&  $scope.user.session.menu !== 'none' && !forPrint;
        $scope.showAppDock = !isCrm && !forPrint;
        $scope.isFullStoryMaskingEnabled = false;

        $http.get('/Settings/Database/EntityOptions/Code/69FULLSTORYMASKINGCHECK', { allowCancellation: false })
            .then(response => {
                $scope.isFullStoryMaskingEnabled = response.data.value.toLowerCase() === 'true';
            });
    }

    function loadNotifications() {
        $notifications.loadAll();

        $.connection.hub.qs = { "Authorization": sessionStorage.oas_token };

        $.connection.hub.disconnected(function () {
            setTimeout(function () {
                if ($.connection.hub.lastError && $.connection.hub.lastError.message.length > 0) {
                    if ($.connection.hub.lastError.message !== 'Error during negotiation request.') {
                        $.connection.hub.start();
                    }
                }
            }, 5000);
        });

        $.connection.hub.error(function (error) {
            if (error.message === 'Error during negotiation request.') {
                $notifications.stopReceiving();
            }
        });

        $notifications.startReceiving();
    }

    function loadTwoFactorOptions() {
        if ($scope.user.isImpersonating || $oasRights.canRead('LOGINSAMLONLY')) {
            return;
        }

        const checkTwoFactorEntityOption = function (code) {
            $http.get("/Settings/EntityOptions/Database/Code/" + code, { trackerMsg: "Loading two factor settings", allowCancellation: false })
                .then(function (response) {
                    if (response.data[0].value === "True") {
                        requireTwoFactor();
                    }
                });
        };

        const requireTwoFactor = function () {
            $scope.user.authorization.twoFactorRequired = true;

            if (!$scope.user.authorization.twoFactor) {
                $dialog.dialog({ templateUrl: "app/modals/profile.html", controller: "ProfileCtrl", promptForTwoFactor: true }).open();
            }
        };

        switch ($scope.user.authorization.entity) {
            case "Administrator":
                if ($oasRights.canRead("REQTWOFACTOR")) {
                    requireTwoFactor();
                }
                break;
            case "Advisor":
                checkTwoFactorEntityOption("69ENABLEAD");
                break;
            case "Representative":
                checkTwoFactorEntityOption("69ENABLERE");
                break;
        }
    }

    function checkForRepCobrowse() {
        if ($scope.user.isImpersonating) {
            return false;
        }
        if (!['Administrator', 'Advisor'].any($scope.user.authorization.entity)) {
            return false;
        }
        $http.get('/Integrations/SaleMove/Cobrowse/Rep', { ignoreExceptions: true, allowCancellation: false })
            .then(function (response) {
                if (response && response.data) {
                    $scope.user.repCobrowse = response.data;
                }
            });
    }

    function checkRepChat() {
        $http.get('/Integrations/SaleMove/GliaRepChatSupport', { ignoreExceptions: true, allowCancellation: false })
            .then(function (response) {
                if (response && response.data) {
                    $scope.user.gliaRepChatSupport = response.data;
                }
            });
    }

    const ENABLE_FULLSTORY_IN_AFFECTED_APPS = 'oc_performanceViewer_enableFullStory_oc38801';
    let enableFullStoryInAffectedApps = true;

    splitIoService.getBoolTreatment(ENABLE_FULLSTORY_IN_AFFECTED_APPS)
        .subscribe((isEnabled) => {
            enableFullStoryInAffectedApps = isEnabled;
            if (!enableFullStoryInAffectedApps && window.FS && isFullStoryAffectedPath($location.path())) {
                window.FS.shutdown();
            }
        });

    const FULLSTORY_AFFECTED_PATHS = [
        '/reports/performanceviewer3',
        '/advisor/rmd',
        '/portfolio/households',
        '/orion/dashboard'
    ];

    function isFullStoryAffectedPath(path) {
        if (typeof path !== 'string') {
            return false;
        }

        return FULLSTORY_AFFECTED_PATHS.some(affectedPath => path.indexOf(affectedPath) === 0);
    }

    function toggleFullStoryRecording(newPath, previousPath) {
        if (enableFullStoryInAffectedApps) {
            return;
        }

        if (!window.FS) {
            return;
        }

        if (isFullStoryAffectedPath(newPath) && !isFullStoryAffectedPath(previousPath)) {
            window.FS.shutdown();
        } else if (!isFullStoryAffectedPath(newPath) && isFullStoryAffectedPath(previousPath)) {
            window.FS.restart();
        }
    }

    function getPrivilegeString(rightCode) {
        const list = [$oasRights.canRead(rightCode) ? 'Read' : null, $oasRights.canUpdate(rightCode) ? 'Edit' : null, $oasRights.canDelete(rightCode) ? 'Delete' : null];
        return list.compact().join(', ') || 'None';
    }

    function loadFullStory() {
        window._fs_debug = false;
        window._fs_host = 'fullstory.com';
        window._fs_script = 'edge.fullstory.com/s/fs.js';
        if (sessionStorage.fsid) {
            window._fs_org = sessionStorage.fsid;
            window._fs_run_in_iframe = true;
        } else {
            window._fs_org = '174G8N';
        }
        window._fs_namespace = 'FS';
        (function(m,n,e,t,l,o,g,y){
            if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
            g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];
            o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+window._fs_script;
            y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
            g.identify=function(i,v,s){g(l,{uid:i},s);if(v){g(l,v,s);}};g.setUserVars=function(v,s){g(l,v,s);};g.event=function(i,v,s){g('event',{n:i,p:v},s);};
            g.anonymize=function(){g.identify(!!0);};
            g.shutdown=function(){g("rec",!1);};g.restart=function(){g("rec",!0);};
            g.log = function(a,b){g("log",[a,b]);};
            g.consent=function(a){g("consent",!arguments.length||a);};
            g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v);};
            g.clearUserCookie=function(){};
            g.setVars=function(n, p){g('setVars',[n,p]);};
            g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];
            if(m[y]){m[y]=function(){return g._w[y].apply(this,arguments);};}
            g._v="1.3.0";
        })(window,document,window._fs_namespace,'script','user');

        window.FS.identify($scope.user.authorization.email, {
            displayName: $scope.user.authorization.firstName + ' ' + $scope.user.authorization.lastName,
            email: $scope.user.authorization.email,
            productName_str: 'Orion Connect',
            firmName_str: $scope.user.authorization.alClientName,
            firmId_int: $scope.user.authorization.alClientId,
            loginLevel_str: $scope.user.authorization.entity,
            privRb3Advanced_str: getPrivilegeString('REPORTBUILDERADVANCEDEDITOR'),
            privQueryStudio_str: getPrivilegeString('QUERYSTUDIOQUERIES'),
            privRoleMgmt_str: getPrivilegeString('MUL_ROLES')
        });

        if (!enableFullStoryInAffectedApps && isFullStoryAffectedPath($location.path())) {
            window.FS.shutdown();
        }
    }

    function loadGainsight() {
        if (!API_CONFIG.gainsight.key) {
            return;
        }

        (function (n, t, a, e) {
            var i = "aptrinsic"; n[i] = n[i] || function () {
                (n[i].q = n[i].q || []).push(arguments)
            }, n[i].p = e;
            var r = t.createElement("script"); r.async = !0, r.src = a + "?a=" + e;
            var c = t.getElementsByTagName("script")[0]; c.parentNode.insertBefore(r, c);
        })(window, document, "https://web-sdk.aptrinsic.com/api/aptrinsic.js", API_CONFIG.gainsight.key);

        window.gainsightBotId = API_CONFIG.gainsight.bots[$scope.user.authorization.entity] || API_CONFIG.gainsight.bots.default;

        $http.get("/Settings/Database/EntityOptions/Code/69ASTROENA", { allowCancellation: false })
            .then(function (response) {
                //any custom fields need to be added to aptrinsic via GainSight PX
                aptrinsic("identify",
                    {
                        //User Fields
                        "id": $scope.user.authorization.loginUserId, // Required for logged in app users
                        "email": $scope.user.authorization.email,
                        "firstName": $scope.user.authorization.firstName,
                        "lastName": $scope.user.authorization.lastName,
                        "loginEntity": $scope.user.authorization.entity, //Custom attributes - please create those custom attributes in Aptrinsic via Account Settings to be tracked.
                        "privEclipse": $oasRights.canRead("ECLIPSETRADING"),
                        "privComplianceInform": $oasRights.canRead("COMPASSINFORM")
                    },
                    {
                        //Account Fields
                        "id": $scope.user.authorization.alClientId,
                        "name": $scope.user.authorization.alClientName,
                        "advisorNumber": $scope.user.authorization.advisorNumber,
                        "astroOptimizedAccount": response.data.value.toLowerCase() === 'true'
                    });
            });
    }


    //VERY PUBLIC METHODS
    $rootScope.safeApply = function (fn) {       //JBT - DON'T USE THIS UNLESS ABSOLUTELY NECESSARY
        const phase = this.$root.$$phase;
        if (phase === '$apply' || phase === '$digest') {
            if (fn && (typeof (fn) === 'function')) {
                fn();
            }
        } else {
            this.$apply(fn);
        }
    };

    $rootScope.toggle = function (item, propertyName) {
        item[propertyName] = !item[propertyName];
    };


    //INITIALIZE
    // FIXME: httpGlobalInterceptor is tightly coupled to this line via changeset 210710 -- every test that makes http requests needs to set up this property
    $rootScope.user = {
        authorization: { entity: 0, databaseCount: 0, alClientId: 0 },
        session: {
            menu: sessionStorage.oas_menu ? sessionStorage.oas_menu.toLowerCase() : null,
            integration: sessionStorage.integration_src ? sessionStorage.integration_src.toLowerCase() : null
        },
        alerts: []
    };

    if (localStorage.oas_profile) {
        const parsedProfile = JSON.parse(localStorage.oas_profile);
        if (parsedProfile.search === 1) {   //1 = HouseholdOverview
            parsedProfile.search = 3;       //3 = Portfolio View
        }
        delete parsedProfile.zoom;          //don't need this anymore
        $scope.user.profile = parsedProfile;

        userOptionService.save('oas_profile', parsedProfile)
            .then(() => {
                delete localStorage.oas_profile; //now that it's moved to db, clean up localStorage
            });
    } else {
        userOptionService.get('oas_profile', {theme: 1, search: 3, allowCancellation: false})
            .then(value => {
                $scope.user.profile = value;
            });
    }

    $scope.rightSidebar = { exists: false, width: 250, isOpen: true };
    $scope.leftSidebar = { exists: false, width: 250, isOpen: true };
    sidebarService.left = $scope.leftSidebar;
    sidebarService.right = $scope.rightSidebar;

    if (sessionStorage.oas_authorization) {
        init(JSON.parse(sessionStorage.oas_authorization));
    } else if (sessionStorage.oas_token) {
        $http.get('/Authorization/User?forMobileApp=false', { trackerMsg: 'Loading user authorization data', allowCancellation: false })
            .then(function (response) {
                init(response.data);
            });
    }

    $http.get("/Settings/EntityOptions/Database/Code/69OCLOGO", { allowCancellation: false })
        .then(function (response) {
            $scope.user.session.logo = { "Report Image": "report", "Portal Image": "portal", "Orion Logo": "orion" }[response.data[0].value];
        });

    //TODO: Switch below to MainTrackerCtrl?
    $scope.trackerMsgs = [];
    $rootScope.mainTracker = promiseTracker('main')
    .on('start', function (args, promiseId) {
        $scope.trackerMsgs.push({ id: promiseId, msg: args.trackerMsg });
    })
    .on('done', function (args, promiseId) {
        $scope.trackerMsgs.remove({ id: promiseId });
    });


    //EVENT LISTENERS
    const browserTabMap = { portfolioLists: "Portfolio Audit", custodialIntegrator: "HAA Aggregator", customImports2: "Custom Imports", interfaceRecon: "Reconciliation Status", dataQueries: "Query", tom: "TOM", qpeDashboard: "QPE Dashboard", benchmarkAssign: "Benchmarking", rmdDashboard: "RMD Dashboard", geminiFundApp: "Gemini Fund", systemTradeQueue: "Trade Queue", compassAudit: "Compliance" };
    $scope.$on('$routeChangeStart', function (event, next) {
        $scope.user.session.hideNav = next.hideNav;
    });

    $scope.$on('$routeChangeSuccess', function (event, current) {
        $scope.rightSidebar.exists = false;
        $scope.rightSidebar.width = 250;
        $scope.transparentTopBar = current.$$route.originalPath === "/menu";
        const appCode = window.appCode = current.$$route.appCode; //window.appCode is for SaleMove
        const pageTitle = current.$$route.title;
        document.title = pageTitle ?? (appCode ? (browserTabMap[appCode] || appCode.titleize()) : "ORION");
    });

    $scope.$on('$routeChangeError', function (event, current, previous, error) {
        if (error === "Access Denied") {
            const appCode = current.$$route.appCode || current.$$route.privilege;
            const appName = appCode ? (browserTabMap[appCode] || appCode.titleize()) : "No App Code";
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Access Denied", "You do not have sufficient rights to view the <b>" + appName + "</b> app.").open();
        }
        $location.path(previous && previous.originalPath !== current.$$route.originalPath ? previous.originalPath : "/");
    });


    let oldPath;
    $scope.$on('$locationChangeSuccess', function (event, newUrl) {
        if (!newUrl.has("#")) {
            return;
        }

        let newPath = newUrl.split("#")[1].split("?")[0];
        if (newPath === "/") {
            newPath = "/main";
        }
        if (newPath !== oldPath) {
            toggleFullStoryRecording(newPath, oldPath);
            $http.post('/Utility/Logging/PageView' + newPath, null, { ignoreExceptions: true });
            oldPath = newPath;
        }
    });

    let loginIsOpen;
    $scope.$on('event:auth-loginRequired', function () {
        if (API_CONFIG.redirectForAuth) {
            const returnUrl = new URL("/orionconnectapp/sso.html", window.location.origin);
            returnUrl.searchParams.set('p', window.location.hash.slice(1));
            sessionReset.goToLoginPage({r: returnUrl.href});
        } else if (!loginIsOpen) {
            loginIsOpen = true;
            $dialog.dialog({ templateUrl: "app/modals/login.html", controller: "LoginCtrl" }).open();
        }
    });

    $scope.$on('event:auth-loginConfirmed', function (e, args) {
        if ([API_CONFIG.informOnlyRoleId.user, API_CONFIG.informOnlyRoleId.admin].any(args.roleId)) {
            sessionReset.logout(); //force them to go through login page
        } else {
            authenticationService.loginConfirmed(sessionStorage.oas_token);
            init(args);
            loginIsOpen = false;
            //JBT - I think the authService isn't resolving the queued up promises correctly in 1.1.4+, so the tracker doesn't know that they completed
            $scope.mainTracker.cancel();
        }
    });

    $rootScope.addBreadcrumb = function (name, path) {
        if (!path) {
            path = '#' + $location.path();
        } else if (!path.startsWith('#')) {
            path = '#' + path;
        }
        breadcrumbsService.add(name, path);
    };

    $rootScope.updateBreadcrumb = function (newName, oldName) {
        breadcrumbsService.update(oldName, newName);
    };

    $rootScope.deleteBreadcrumb = function (name) {
        breadcrumbsService.remove(name);
    };

    $rootScope.clearBreadcrumbs = function () {
        breadcrumbsService.clear();
    };

    $scope.showHelpText = function (link, e) {
        $dialog.messageBox(link.name, link.helpText).open();
        e.preventDefault();
    };
});

app.constant('sidebarService', {
    left: null,
    right: null
});

'use strict';

//MainMenuCtrl was used for the old homepage which no longer exists, but we're
// keeping this file because it also houses mainMenuData service which is still needed

app.service('mainMenuData', function ($rootScope, $q, $http, $dialog, API_CONFIG, entities, ssoTypes, $portfolio, $schwab, userOptionService, GoldmanSachsSsoService) {
    //PRIVATE VARIABLES
    const self = this;
    let savedSettings;
    const internal = { menu: { hiddenApps: [], visibleApps: [], apps: [], profileOptions: [] } };
    let appsArray;
    let isLoaded;

    //PRIVATE METHODS
    function init() {
        isLoaded = $q.all({
            apps: $http.get('/Settings/Apps', {trackerMsg: 'Loading apps', allowCancellation: false }),
            settings: userOptionService.get('main_menu_apps'),
            user: $http.get('/Authorization/User?forMobileApp=false', {trackerMsg: 'Loading app user', allowCancellation: false }) //this is needed to guarantee we have user info available
        }).then(function (responses) {
            appsArray = responses.apps.data;
            internal.menu.apps = angular.copy(responses.apps.data);

            appsArray.forEach(function (app) {
                app.isNew = Date.create(app.createdDate).daysAgo() < 30;
                self.cleanRouteUrl(app, responses.user.data);
                self.checkVestorly(app);
                self.checkSsoType(app);
            });

            savedSettings = responses.settings;

            if (savedSettings) {
                const value = angular.copy(savedSettings);
                self.parseDefaultAppAndAccessibility(value);
                ["visibleApps", "hiddenApps"].forEach(function (bucket) {
                    self.parseApps(bucket, value[bucket]);
                });

                internal.menu.visibleApps.insert(appsArray, 0);
                internal.menu.favoriteApps = value.favoriteApps || [];
                internal.menu.profileOptions = value.profileOptions || [];
            } else {
                internal.menu.visibleApps = appsArray;
            }

            // Load Accessibe
            if (internal.menu.accessibilityEnabled) {
                self.loadAccessibe();
            }
        });
    }


    //INITIALIZE
    init();


    //PUBLIC API
    self.isLoaded = isLoaded;

    self.menu = internal.menu;

    self.accessibeLoaded = false;

    self.save = function () {
        const visibleApps = [];

        internal.menu.visibleApps.forEach(function (app) {
            if (app.ssoType === 'Folder') {
                visibleApps.add({
                    folderName: app.name,
                    appCodes: app.appCodes,
                    imageNames: app.imageNames,
                    isFavorite: app.isFavorite || app.isFavorite === undefined}
                    );
            } else {
                visibleApps.add(app.appCode);
            }
        });

        const payload = self.createPayload(visibleApps);

        if (!angular.equals(payload, savedSettings)) {
            return userOptionService.save('main_menu_apps', payload)
                .then(function (updatedValue) {
                    savedSettings = updatedValue;

                    if (internal.menu.accessibilityEnabled && !self.accessibeLoaded) {
                        self.loadAccessibe();
                    }
                    else if (!internal.menu.accessibilityEnabled && self.accessibeLoaded) {
                        location.reload();
                    }
                });
        } else {
            return $q.resolve(false);
        }
    };

    self.moveToVisible = function (app) {
        internal.menu.hiddenApps.remove(app);
        internal.menu.visibleApps.push(app);
        self.save();
    };

    self.moveToHidden = function (app) {
        internal.menu.visibleApps.remove(app);
        internal.menu.hiddenApps.insert(app, 0);
        self.save();
    };

    self.makeNewFolder = function (app) {
        // remove app codes from folder from visible apps
        app.appCodes.forEach(function (appCode) {
            internal.menu.visibleApps.remove({ appCode: appCode });
        });

        internal.menu.visibleApps.insert(app, 0);
        self.save();
    };

    self.cleanRouteUrl = function (app, userAuthorization) {
        userAuthorization = userAuthorization || $rootScope.user.authorization;

        if (app.name === 'Insight') {
            app.routeUrl = API_CONFIG.insightUrl + '?p=dashboards&t=[TOKEN]';
        }

        app.routeUrl = app.routeUrl.replace('[TOKEN]', sessionStorage.oas_token)
            .replace('[BASEURL]', API_CONFIG.baseUrl)
            .replace('[USERDETAILID]', userAuthorization.loginUserId + "_" + userAuthorization.userDetailId);

        if (userAuthorization.entity === entities.representative.name) {
            if (app.ssoType === ssoTypes.advisoryWorld.name || app.appCode === "repPortal") {
                app.routeUrl += sessionStorage.oas_token;
                app.ssoType = ssoTypes.newTabRedirect.name;
            } else if (app.ssoType === ssoTypes.byAllRep.name) {
                app.ssoType = ssoTypes.newTabRedirect.name;
            }
        }
    };

    self.openUrlWithPost = function (url) {
        const urlParts = url.split("?");
        $portfolio.openUrlWithPost(urlParts[0], urlParts[1] ? Object.fromQueryString(urlParts[1]) : null);
    };

    self.openAdvisoryWorld = function (url) {
        return $dialog.dialog({ templateUrl: "app/modals/login-as.html", controller: "LoginAsCtrl", resolve:{args: function(){return {};}}, loginDestination: "AdvisoryWorld", loginUrl: url }).open();
    };

    self.openByAllForReps = function (url) {
        return $dialog.dialog({ templateUrl: "app/modals/login-as.html", controller: "LoginAsCtrl", resolve:{args: function(){return {};}}, loginDestination: "ByAllRep", loginUrl: url }).open();
    };

    self.openPortal = function (app) {
        if (app && app.appCode === "glia") {
            return $dialog.dialog({ templateUrl: "app/modals/GliaModal.html", controller: "GliaModalCtrl" }).open();
        }
        return $dialog.dialog({ templateUrl: "app/modals/login-as.html", controller: "LoginAsCtrl", resolve:{args: function(){return {};}}, loginDestination: app.name === "Advisor Portal" ? "RepPortal" : "ClientPortal" }).open();
    };

    self.openSchwab = function (app) {
        return $schwab.openEnrollmentModal(app);
    };

    self.openGoldmanSachs = function () {
        void GoldmanSachsSsoService.goldmanSachsSsoRequest('Home');
    };

    self.checkVestorly = function (app) {
        if (app.appCode === 'vestorly') {
            $http.get('/Integrations/Configuration/VESTORLY_INTEGRATION/Firm')
                .then(function (response) {
                    if (response.data.integrationInfo) {
                        const info = JSON.parse(response.data.integrationInfo);
                        if (info.authToken) {
                            app.routeUrl = app.routeUrl.replace('[SITEURL]', info.siteUrl).replace('[VESTORLYTOKEN]', info.authToken);
                            return;
                        }
                    }

                    app.routeUrl = 'http://www.vestorly.com/product/#apply';
                });
        }
    };

    self.checkSsoType = function (app) {
        if (app.ssoType === ssoTypes.none.name) {
            const pathname = window.location.pathname.replace("index.html", "integration.html");
            const integrationUrl = `${window.location.protocol}//${window.location.host}`;
            app.externalUrl = `${integrationUrl}${pathname}?t=${sessionStorage.oas_token}&p=${app.routeUrl.from(1)}`;
        }
    };

    self.parseDefaultAppAndAccessibility = function (value) {
        if (value.defaultApp) {
            internal.menu.defaultApp = value.defaultApp;
        }

        internal.menu.accessibilityEnabled = value.accessibilityEnabled;
        internal.menu.sidebarCollapsed = value.sidebarCollapsed !== undefined ? value.sidebarCollapsed : false;
    };

    self.removeAppCodeInFolderFromApps = function(appCodesArray, folder) {
        //  Remove appCode in folder from apps
        const appCodes = angular.copy(appCodesArray);
        appCodes.forEach(function (appCode) {
            const idx = appsArray.findIndex({ appCode: appCode });
            if (idx !== -1) {
                appsArray.splice(idx, 1);
            } else {
                folder.appCodes.remove(appCode);

                // Remove corresponding imageName
                const acIdx = appCodes.findIndex(appCode);
                if (acIdx !== -1) {
                    folder.imageNames.splice(acIdx, 1);
                }
            }
        });
    };

    self.parseApps = function(bucket, jsonApps) {

        jsonApps.forEach(function (appCode) {
            const index = appsArray.findIndex({ appCode: appCode });
            if (index !== -1) {
                internal.menu[bucket].push(appsArray[index]);
                appsArray.splice(index, 1);
            }

            // Check if it's a folder
            if (angular.isObject(appCode)) {
                const folder = {
                    "appCode": "folder",
                    "name": appCode.folderName,
                    "description": "New folder for a new group of apps",
                    "category": "Tools",
                    "imageName": "newfolder",
                    "ssoType": "Folder",
                    "isNew": false,
                    "appCodes": appCode.appCodes,
                    "imageNames": appCode.imageNames,
                    "isFavorite": appCode.isFavorite === undefined ? true : appCode.isFavorite
                };

                self.removeAppCodeInFolderFromApps(appCode.appCodes, folder);

                // Don't add folder if they don't have any apps in the folder.
                if (folder.imageNames.length > 0) {
                    internal.menu[bucket].push(folder);
                }
            }
        });
    };

    self.loadAccessibe = function() {
        var s = document.createElement('script'),
        e = ! document.body ? document.querySelector('head') : document.body;
        s.src = 'https://acsbapp.com/apps/app/assets/js/acsb.js';
        s.async = s.defer = true;
        s.onload = function(){
            window.acsbJS.init({
                statementLink    : '',
                feedbackLink     : 'https://testapi.orionadvisor.com/orionconnectapp/#/support',
                footerHtml       : '',
                hideMobile       : false,
                hideTrigger      : false,
                language         : 'en',
                position         : 'left',
                leadColor        : '#146ff8',
                triggerColor     : '#146ff8',
                triggerRadius    : '50%',
                triggerPositionX : 'left',
                triggerPositionY : 'bottom',
                triggerIcon      : 'default',
                triggerSize      : 'medium',
                triggerOffsetX   : 20,
                triggerOffsetY   : 50,
                mobile           : {
                    triggerSize      : 'small',
                    triggerPositionX : 'left',
                    triggerPositionY : 'center',
                    triggerOffsetX   : 0,
                    triggerOffsetY   : 0,
                    triggerRadius    : '0'
                }
            });
            self.accessibeLoaded = true;
        };
        e.appendChild(s);
    };

    self.createPayload = function (visibleAppsArray) {
        return {
            defaultApp: internal.menu.defaultApp ? Object.select(internal.menu.defaultApp, "appCode", "ssoType", "routeUrl") : null,
            hiddenApps: internal.menu.hiddenApps.map("appCode"),
            visibleApps: visibleAppsArray,
            favoriteApps: internal.menu.favoriteApps || ['firmProfile', 'manageUserLogin', 'clientPortal', 'newAccountsCenter', 'portfolioLists', 'productsAndPrices', 'reports', 'dataQueries', 'performanceViewer', 'benchmarkAssign', 'billingAudit', 'billGenerator'],
            sidebarCollapsed: internal.menu.sidebarCollapsed,
            profileOptions: internal.menu.profileOptions || [],
            accessibilityEnabled: internal.menu.accessibilityEnabled
        };
    };
});

'use strict';

app.controller('ProgressCtrl', function ProgressCtrl($scope, $timeout) {
    //INITIALIZE
    $scope.progressItems = [];
    $scope.statusItems = [];

    //EVENT LISTENERS
    $scope.$on('event:progress-update', function (event, status) {
        var value = status.isDone ? 100 : (status.completed / status.total) * 100;  //isDone overrides to 100
        var idString = "ID " + status.id + ": ";
        var msg = status.msg ? status.msg : (status.id ? idString : "") + status.completed + " of " + status.total + " completed";
        var item = $scope.progressItems.find({ id: status.id });

        if (typeof item === "undefined") {
            item = { id: status.id, value: value, type: status.type, msg: msg };
            $scope.progressItems.push(item);
        }
        else {
            if (item.value !== value)
                item.value = value;

            if (item.type !== status.type)
                item.type = status.type;

            if (item.msg !== msg)
                item.msg = msg;
        }

        if (value >= 100)
            $timeout(function () { $scope.progressItems.remove(item); }, 5000);
    });

    $scope.$on('event:status-update', function (event, status) {
        var msg = status.msg;
        $scope.statusItems = [];
        if (!status.isDone) {
            $scope.statusItems.push({ msg: msg, id: status.id, showClose: status.showClose });
        }
    });

    $scope.closeStatus = function (id) {
        const foundItem = $scope.statusItems.find(si => si.id === id);
        if (foundItem) {
            $scope.statusItems.remove(foundItem);
        }
    };
});
'use strict';

var ALLOWED_SALESFORCE_LOGOUT_HOST_SUFFIXES = ['salesforce.com'];

function isAllowedSalesforceLogoutHost(hostname) {
    if (!hostname) {
        return false;
    }

    hostname = hostname.toLowerCase();
    return ALLOWED_SALESFORCE_LOGOUT_HOST_SUFFIXES.some(function (suffix) {
        return hostname === suffix || hostname.endsWith('.' + suffix);
    });
}

function getAllowedSalesforceLogoutUrl(url) {
    if (!url) {
        return null;
    }

    var parsedUrl;

    try {
        parsedUrl = new URL(url, window.location.origin);
    } catch (e) {
        return null;
    }

    if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
        return null;
    }

    if (!isAllowedSalesforceLogoutHost(parsedUrl.hostname)) {
        return null;
    }

    return parsedUrl.href;
}

app.controller('UserOptionsCtrl', function UserOptionsCtrl($scope, $http, $location, $dialog, $timeout, $oasRights, $dataQuery, $notifications, ssoTypes, entities, $portfolio, mainMenuData, sessionReset, tokenFactory, API_CONFIG, $schwab, gliaService, splitIoService, advisoryFeeNotificationModalService) {
    //PRIVATE METHODS
    function init() {
        if (localStorage.oas_global_search) {
            const globalSearch = JSON.parse(angular.toJson(JSON.parse(localStorage.oas_global_search)));  //hack to remove $$hashkey properties from when we were just using JSON.stringify()
            $scope.search.options = angular.isArray(globalSearch) ? { list: globalSearch, activeOnly: true } : globalSearch;  //array => old version, object => new version
        } else {
            $scope.search.options = {
                list: [
                    { id: "application", name: "Applications", include: true },
                    { id: "client", name: "Households", include: true },
                    { id: "registration", name: "Registrations", include: false },
                    { id: "account", name: "Accounts", include: true },
                    { id: "applicationpage", name: "Application Pages", include: true },
                    { id: "report", name: "Reports", include: true },
                ],
                activeOnly: true
            };
        }

        // Removes Help Articles from list of options per DEVOPS WORK ITEM 74593
        $scope.search.options.list.remove({id: 'help'});

        if (!$scope.search.options.hasOwnProperty('useContains')) {
            $scope.search.options.useContains = true;
        }

        const assetOption = $scope.search.options.list.find({ id: "asset" });
        if (assetOption) {
            assetOption.name = "Assets";
        } else {
            $scope.search.options.list.insert({ id: "asset", name: "Assets", include: false }, 4);
        }

        if ($scope.search.options.list.none({ id: "portfoliogroup" })) {
            $scope.search.options.list.insert({ id: "portfoliogroup", name: "Portfolio Groups", include: false }, 2);
        }

        if ($scope.search.options.list.none({ id: "dataquery" })) {
            $scope.search.options.list.push({ id: "dataquery", name: "Query", include: false });
        }

        $oasRights.isLoaded
            .then(function () {
                $scope.contactUsPartners = [
                    { name: "Schwab Service Request", action: schwabServiceRequest, isEnabled: $oasRights.canRead("SCHWABSII") }
                ].findAll({ isEnabled: true });
            });
    }

    function schwabServiceRequest() {
        $schwab.sacCenter({ appCode: 'charlesSchwab', routeUrl: `${API_CONFIG.baseUrl}/Integrations/SchwabSII/SsoV2/11?Authorization=${sessionStorage.oas_token}` });
    }

    function cleanNotificationUrls(notifications) {
        notifications.each(function (n) {
            if (n.categoryName === "Data Query" && n.url) {
                if (n.url.startsWith("http")) {
                    n.url = n.url.replace("http://api.orionadvisor.local", "").replace("https://api.orionadvisor.com", "");
                } else if (!n.url.startsWith(API_CONFIG.baseUrl)) {
                    n.url = API_CONFIG.baseUrl + n.url;
                }
            }
        });

        return notifications;
    }

    function retryInitLexChat(delay, interval, maxAttempts, enablePopOut) {
        var attempts = 0;
        function tryInit() {
            attempts++;
            if (!initLexChatResizable(enablePopOut) && attempts < maxAttempts) {
                $timeout(tryInit, interval);
            }
        }
        $timeout(tryInit, delay);
    }

    function initLexChatResizable(enablePopOut) {
        enablePopOut = !!enablePopOut;
        var $panel = $('#salemove .sm-visitor-app-container .sm-visitor-app');
        if (!$panel.length || $panel.data('lex-resizable')) {
            return false;
        }

        var el = $panel[0];
        $panel.data('lex-resizable', true);

        var maxHeight = 1200;
        var maxHeightVh = window.innerHeight * 0.95;
        var effectiveMaxHeight = Math.min(maxHeight, maxHeightVh);
        var topSafeMargin = 50;
        var edgeMargin = 8;
        var minPanelWidth = 300;
        var maxPanelWidth = 900;
        var minPanelHeight = 400;

        var westHandle = document.createElement('div');
        westHandle.className = 'lex-resize-handle lex-resize-w';
        el.appendChild(westHandle);

        var southHandle = document.createElement('div');
        southHandle.className = 'lex-resize-handle lex-resize-s';
        el.appendChild(southHandle);

        if (enablePopOut) {
            var seHandle = document.createElement('div');
            seHandle.className = 'lex-resize-handle lex-resize-se';
            el.appendChild(seHandle);

            var swHandle = document.createElement('div');
            swHandle.className = 'lex-resize-handle lex-resize-sw';
            el.appendChild(swHandle);

            var neHandle = document.createElement('div');
            neHandle.className = 'lex-resize-handle lex-resize-ne';
            el.appendChild(neHandle);

            var nwHandle = document.createElement('div');
            nwHandle.className = 'lex-resize-handle lex-resize-nw';
            el.appendChild(nwHandle);
        }

        var dragHandle = null;
        if (enablePopOut) {
            dragHandle = document.createElement('div');
            dragHandle.className = 'lex-drag-handle';
            el.insertBefore(dragHandle, el.firstChild);
        }

        function attachResize(handle, direction) {
            handle.addEventListener('mousedown', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var startX = e.clientX;
                var startY = e.clientY;
                var startWidth = el.offsetWidth;
                var startHeight = el.offsetHeight;
                var rect = el.getBoundingClientRect();
                var startTop = rect.top;
                var startLeft = rect.left;

                el.style.setProperty('z-index', '999999', 'important');

                function calcNewTop(evt, maxBottom) {
                    var newTop = startTop + (evt.clientY - startY);
                    return Math.max(topSafeMargin, Math.min(newTop, maxBottom - minPanelHeight));
                }
                function calcNewHeightFromBottom(evt, maxBottom) {
                    var newHeight = startHeight + (evt.clientY - startY);
                    return Math.max(minPanelHeight, Math.min(newHeight, effectiveMaxHeight, maxBottom - startTop));
                }
                function calcNewHeightFromTop(newTop, maxBottom) {
                    var newHeight = (startTop + startHeight) - newTop;
                    return Math.max(minPanelHeight, Math.min(newHeight, effectiveMaxHeight, maxBottom - newTop));
                }
                function calcNewLeft(evt, maxRight) {
                    var newLeft = startLeft + (evt.clientX - startX);
                    return Math.max(edgeMargin, Math.min(newLeft, startLeft + startWidth - minPanelWidth, maxRight - minPanelWidth));
                }
                function calcNewWidthFromRight(evt, maxRight) {
                    var newWidth = startWidth + (evt.clientX - startX);
                    return Math.max(minPanelWidth, Math.min(newWidth, maxPanelWidth, window.innerWidth * 0.9, maxRight - startLeft));
                }
                function calcNewWidthFromLeft(newLeft) {
                    return (startLeft + startWidth) - newLeft;
                }

                function onMouseMove(evt) {
                    var newWidth, newHeight, newTop, newLeft;
                    var maxBottom = window.innerHeight - edgeMargin;
                    var maxRight = window.innerWidth - edgeMargin;

                    if (direction === 'w') {
                        newLeft = calcNewLeft(evt, maxRight);
                        newWidth = calcNewWidthFromLeft(newLeft);
                    } else if (direction === 's') {
                        newHeight = calcNewHeightFromBottom(evt, maxBottom);
                    } else if (direction === 'se') {
                        newWidth = calcNewWidthFromRight(evt, maxRight);
                        newHeight = calcNewHeightFromBottom(evt, maxBottom);
                    } else if (direction === 'sw') {
                        newLeft = calcNewLeft(evt, maxRight);
                        newWidth = calcNewWidthFromLeft(newLeft);
                        newHeight = calcNewHeightFromBottom(evt, maxBottom);
                    } else if (direction === 'ne') {
                        newTop = calcNewTop(evt, maxBottom);
                        newHeight = calcNewHeightFromTop(newTop, maxBottom);
                        newWidth = calcNewWidthFromRight(evt, maxRight);
                    } else if (direction === 'nw') {
                        newTop = calcNewTop(evt, maxBottom);
                        newHeight = calcNewHeightFromTop(newTop, maxBottom);
                        newLeft = calcNewLeft(evt, maxRight);
                        newWidth = calcNewWidthFromLeft(newLeft);
                    }

                    if (newLeft !== undefined) {
                        el.style.setProperty('right', 'auto', 'important');
                        el.style.setProperty('left', newLeft + 'px', 'important');
                    }
                    if (newWidth !== undefined) {
                        el.style.setProperty('width', newWidth + 'px', 'important');
                    }
                    if (newHeight !== undefined) {
                        el.style.setProperty('height', newHeight + 'px', 'important');
                    }
                    if (newTop !== undefined) {
                        el.style.setProperty('top', newTop + 'px', 'important');
                    }
                }

                function onMouseUp() {
                    document.removeEventListener('mousemove', onMouseMove);
                    document.removeEventListener('mouseup', onMouseUp);
                }

                document.addEventListener('mousemove', onMouseMove);
                document.addEventListener('mouseup', onMouseUp);
            });
        }

        function attachDrag(handleEl) {
            handleEl.addEventListener('mousedown', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var startX = e.clientX;
                var startY = e.clientY;
                var rect = el.getBoundingClientRect();
                var startLeft = rect.left;
                var startTop = rect.top;
                var computedStyle = getComputedStyle(el);
                if (computedStyle.position === 'static') {
                    el.style.setProperty('position', 'fixed', 'important');
                }
                el.style.setProperty('right', 'auto', 'important');
                el.style.setProperty('left', startLeft + 'px', 'important');
                el.style.setProperty('top', startTop + 'px', 'important');
                el.style.setProperty('z-index', '999999', 'important');

                function onMouseMove(evt) {
                    var newLeft = Math.max(edgeMargin, Math.min(startLeft + (evt.clientX - startX), window.innerWidth - el.offsetWidth - edgeMargin));
                    var newTop = Math.max(topSafeMargin, Math.min(startTop + (evt.clientY - startY), window.innerHeight - el.offsetHeight - edgeMargin));
                    el.style.setProperty('left', newLeft + 'px', 'important');
                    el.style.setProperty('top', newTop + 'px', 'important');
                }

                function onMouseUp() {
                    document.removeEventListener('mousemove', onMouseMove);
                    document.removeEventListener('mouseup', onMouseUp);
                }

                document.addEventListener('mousemove', onMouseMove);
                document.addEventListener('mouseup', onMouseUp);
            });
        }

        attachResize(westHandle, 'w');
        attachResize(southHandle, 's');
        if (enablePopOut) {
            attachResize(seHandle, 'se');
            attachResize(swHandle, 'sw');
            attachResize(neHandle, 'ne');
            attachResize(nwHandle, 'nw');
            attachDrag(dragHandle);
        }
        return true;
    }
    
    // Glia/Salemove visitor UI: these tag/class hooks are not a versioned public contract. If Glia ships
    // DOM or shadow-DOM changes, engagement styling may miss nodes until selectors are updated; verify
    // after SDK or visitor-app upgrades (visual QA on embedded Lex chat).
    const LEX_GLIA_HOST_TAGS = ['sm-engaged-operator', 'sm-engaged-visitor'];
    const LEX_GLIA_CHAT_SURFACE_SELECTORS = [
        '.sm-main', '.sm-messages', '.sm-messages-view', '.sm-messages-scrollable', '.sm-messages-container',
        '.sm-message-list', '.sm-conversation', '.sm-chat-body', '.sm-chat-messages', '.sm-scrollable',
        '.sm-visitor-app-container', '.sm-visitor-app', '.sm-engaged-main-container',
        '.sm-composer-container', '.sm-composer', '.sm-chat-footer', '.sm-footer', '.sm-chat-input', '.sm-input-container'
    ];
    const LEX_GLIA_HEADER_HEIGHT = '75px';
    const LEX_GLIA_CHAT_BG = '#ffffff';
    const LEX_GLIA_SALEMOVE_COLLECT_MAX_DEPTH = 8;

    function lexQuerySelectorAllDeep(start, selector) {
        var results = [];
        function searchIn(scope) {
            if (!scope || typeof scope.querySelectorAll !== 'function') {
                return;
            }
            var list = scope.querySelectorAll(selector);
            for (var i = 0; i < list.length; i++) {
                if (results.indexOf(list[i]) === -1) {
                    results.push(list[i]);
                }
            }
            var all = scope.querySelectorAll('*');
            for (var j = 0; j < all.length; j++) {
                if (all[j].shadowRoot) {
                    searchIn(all[j].shadowRoot);
                }
            }
        }
        searchIn(start);
        return results;
    }

    function lexCollectSalemoveRootsFromDocument(doc, out, depth) {
        depth = depth || 0;
        if (depth > LEX_GLIA_SALEMOVE_COLLECT_MAX_DEPTH || !doc || !doc.querySelector) {
            return;
        }
        var m = doc.querySelector('#salemove');
        if (m && out.indexOf(m) === -1) {
            out.push(m);
        }
        var frames = doc.querySelectorAll('iframe');
        for (var f = 0; f < frames.length; f++) {
            try {
                var fd = frames[f].contentDocument;
                if (fd) {
                    lexCollectSalemoveRootsFromDocument(fd, out, depth + 1);
                }
            } catch (ignoreCrossOrigin) {
                // contentDocument is not readable for cross-origin iframes
            }
        }
    }

    function lexSetStyleImportant(el, prop, value) {
        el.style.setProperty(prop, value, 'important');
    }

    function applyLexGliaChromeToRoot(container) {
        var h = LEX_GLIA_HEADER_HEIGHT;
        var bg = LEX_GLIA_CHAT_BG;
        LEX_GLIA_HOST_TAGS.forEach(function (tag) {
            lexQuerySelectorAllDeep(container, tag).forEach(function (host) {
                lexSetStyleImportant(host, 'height', h);
                lexSetStyleImportant(host, 'max-height', h);
                lexSetStyleImportant(host, 'min-height', '0');
                lexSetStyleImportant(host, 'overflow', 'hidden');
                lexSetStyleImportant(host, 'flex', '0 0 auto');
                lexSetStyleImportant(host, 'margin', '0');
                lexSetStyleImportant(host, 'box-sizing', 'border-box');
            });
        });
        lexQuerySelectorAllDeep(container, '.sm-media-view').forEach(function (mv) {
            lexSetStyleImportant(mv, 'height', h);
            lexSetStyleImportant(mv, 'max-height', h);
            lexSetStyleImportant(mv, 'min-height', '0');
            lexSetStyleImportant(mv, 'overflow', 'hidden');
            lexSetStyleImportant(mv, 'margin', '0');
            lexSetStyleImportant(mv, 'padding', '0');
            lexSetStyleImportant(mv, 'box-sizing', 'border-box');
            lexSetStyleImportant(mv, 'position', 'relative');
        });
        lexQuerySelectorAllDeep(container, '.sm-media-overlay').forEach(function (mo) {
            lexSetStyleImportant(mo, 'position', 'absolute');
            lexSetStyleImportant(mo, 'top', '0');
            lexSetStyleImportant(mo, 'left', '0');
            lexSetStyleImportant(mo, 'width', '100%');
            lexSetStyleImportant(mo, 'height', h);
            lexSetStyleImportant(mo, 'max-height', h);
            lexSetStyleImportant(mo, 'margin', '0');
            lexSetStyleImportant(mo, 'padding', '0');
            lexSetStyleImportant(mo, 'box-sizing', 'border-box');
        });
        lexQuerySelectorAllDeep(container, 'video').forEach(function (v) {
            lexSetStyleImportant(v, 'max-height', h);
            lexSetStyleImportant(v, 'height', h);
            lexSetStyleImportant(v, 'width', '100%');
            lexSetStyleImportant(v, 'object-fit', 'cover');
        });
        LEX_GLIA_CHAT_SURFACE_SELECTORS.forEach(function (sel) {
            lexQuerySelectorAllDeep(container, sel).forEach(function (el) {
                lexSetStyleImportant(el, 'background-color', bg);
                lexSetStyleImportant(el, 'background-image', 'none');
            });
        });
    }

    function applyLexGliaChromeLayout() {
        if (!$scope.lexDirectChatEnabled || document.body.classList.contains('lex-chat-post-engagement')) {
            return;
        }
        var roots = [];
        lexCollectSalemoveRootsFromDocument(document, roots, 0);
        if (!roots.length) {
            return;
        }
        roots.forEach(applyLexGliaChromeToRoot);
    }

   
    function retryApplyLexGliaChromeLayout(delay, interval, maxAttempts) {
        var n = 0;
        function tick() {
            n++;
            applyLexGliaChromeLayout();
            if (n < maxAttempts) {
                $timeout(tick, interval);
            }
        }
        $timeout(tick, delay);
    }

    var lexEngagementStartSubscribed = false;
    var lexEngagementEndModalCleared = false;
    var lexEndModalObserverInstance = null;

    function clearLexChatPanelStyles() {
        var el = document.querySelector('#salemove .sm-visitor-app-container .sm-visitor-app');
        if (el) {
            el.style.removeProperty('position');
            el.style.removeProperty('right');
            el.style.removeProperty('left');
            el.style.removeProperty('top');
            el.style.removeProperty('z-index');
            el.style.removeProperty('width');
            el.style.removeProperty('height');
        }
    }

    function removeLexChatResizable() {
        var $panel = $('#salemove .sm-visitor-app-container .sm-visitor-app');
        if ($panel.length && $panel.data('lex-resizable')) {
            var el = $panel[0];
            [].slice.call(el.querySelectorAll('.lex-resize-handle')).concat([].slice.call(el.querySelectorAll('.lex-drag-handle'))).forEach(function (handle) { handle.remove(); });
            $panel.data('lex-resizable', false);
            clearLexChatPanelStyles();
        }
    }

    function attachLexEngagementEndObserver(attempt) {
        attempt = attempt || 0;
        if (lexEndModalObserverInstance || !$scope.lexDirectChatEnabled) {
            return;
        }
        var container = document.querySelector('#salemove');
        if (!container) {
            if (attempt < 40) {
                $timeout(function () { attachLexEngagementEndObserver(attempt + 1); }, 400);
            }
            return;
        }
        lexEndModalObserverInstance = new MutationObserver(function () {
            if ($scope.lexDirectChatEnabled && !lexEngagementEndModalCleared && container.textContent.indexOf('Engagement Ended') !== -1) {
                lexEngagementEndModalCleared = true;
                document.body.classList.add('lex-chat-post-engagement');
                removeLexChatResizable();
                clearLexChatPanelStyles();
            }
        });
        lexEndModalObserverInstance.observe(container, { childList: true, subtree: true, characterData: true });
    }

    function subscribeToLexEngagementEvents(salemove) {
        if (!$scope.lexDirectChatEnabled || !salemove || !salemove.EVENTS.ENGAGEMENT_START) {
            return;
        }
        if (!lexEngagementStartSubscribed) {
            lexEngagementStartSubscribed = true;
            salemove.addEventListener(salemove.EVENTS.ENGAGEMENT_START, function () {
                if ($scope.lexDirectChatEnabled) {
                    lexEngagementEndModalCleared = false;
                    document.body.classList.remove('lex-chat-post-engagement');
                    clearLexChatPanelStyles();
                    retryApplyLexGliaChromeLayout(200, 350, 22);
                    retryInitLexChat(3000, 300, 10, $scope.gliaPopOutEnabled);
                }
            });
        }
        attachLexEngagementEndObserver(0);
    }

    function tryRegisterLexEngagementEventsFromSm(attempt) {
        attempt = attempt || 0;
        if (!$scope.lexDirectChatEnabled) {
            return;
        }
        if (!window.sm || typeof window.sm.getApi !== 'function') {
            if (attempt < 40) {
                $timeout(function () { tryRegisterLexEngagementEventsFromSm(attempt + 1); }, 1000);
            }
            return;
        }
        window.sm.getApi({ version: 'v1' }).then(function (salemove) {
            subscribeToLexEngagementEvents(salemove);
        });
    }

    //PUBLIC METHODS
    $scope.goToSearchItem = function (selectedItem) {
        let searchEntity;
        switch (selectedItem.icon) {
            case "fa-orion-household":
            case "fa-orion-registration":
            case "fa-orion-account":
                searchEntity = selectedItem.icon.split('-').last().capitalize();
                const entityEnum = entities[entities.find({ name: searchEntity })];

                if (selectedItem.alClientId) {
                    tokenFactory.getDatabaseToken(selectedItem.alClientId)
                        .then(function (token) {
                            const encodedPage = encodeURIComponent(`/portfolio/households?entity=${entityEnum.value}&entityId=${selectedItem.id}`);
                            window.open(`${window.location.protocol}//${window.location.host}${window.location.pathname.replace("index.html", "")}integration.html?t=${token}&p=${encodedPage}`);
                        });
                } else {
                    if ($scope.user.profile.search === 1 && $oasRights.canRead("HOUSEHOLDOVERVIEW") && $oasRights.canRead(entityEnum.securityCode)) {
                        $location.url('/portfolio/household/overview?entity=' + entityEnum.value + '&entityId=' + selectedItem.id);
                    } else if ($scope.user.profile.search === 2 && $oasRights.canRead("INSIGHTBUILDERAPP")) {
                        $location.url('/portfolio/insight?entityEnum=' + entityEnum.value + '&entityId=' + selectedItem.id);
                    } else if ($scope.user.profile.search === 3) {
                        $location.url('/orion/dashboard?entity=' + entityEnum.value + '&entityId=' + selectedItem.id);
                    } else {
                        $portfolio.goTo(entityEnum.name.pluralize().toLowerCase(), entityEnum.value, selectedItem.id);
                    }
                }
                break;
            case "fa-orion-asset":
                $portfolio.goTo("assets", "8", selectedItem.id);
                break;
            case "fa-file-o":
                searchEntity = "Application Page";
                if (selectedItem.routeUrl.substring(0, 4) === "http") {
                    mainMenuData.cleanRouteUrl(selectedItem);
                    window.open(selectedItem.routeUrl);
                } else {
                    $location.path(selectedItem.routeUrl.from(1));
                }
                break;
            case "fa-bolt":
                searchEntity = "Report";
                if (selectedItem.id === 'FEE') {
                    advisoryFeeNotificationModalService.open();
                } else {
                    $dialog.reportPrompt(selectedItem.id).open();
                }
                break;
            case "fa-database":
                searchEntity = "Data Query";
                $dialog.dataQueryPrompt(selectedItem.id)
                    .open()
                    .then(function (result) {
                        if (result && result.id) {
                            $dataQuery.setDataQuery(result);
                            $location.path(`/reports/dataqueries/${selectedItem.id}`);
                        }
                    });
                break;
            case "fa-orion-app":
                searchEntity = "Application";

                mainMenuData.cleanRouteUrl(selectedItem);

                switch (selectedItem.ssoType) {
                    case ssoTypes.none.name:
                        $location.path(selectedItem.routeUrl.from(1));
                        break;
                    case ssoTypes.sameTabRedirect.name:
                        window.location.href = selectedItem.routeUrl;
                        break;
                    case ssoTypes.portal.name:
                        mainMenuData.openPortal(selectedItem);
                        break;
                    case ssoTypes.formPost.name:
                        mainMenuData.openUrlWithPost(selectedItem.routeUrl);
                        break;
                    case ssoTypes.newTabRedirect.name:
                        window.open(selectedItem.routeUrl);
                        break;
                    case ssoTypes.advisoryWorld.name:
                        mainMenuData.openAdvisoryWorld(selectedItem.routeUrl);
                        break;
                    case ssoTypes.byAllRep.name:
                        mainMenuData.openByAllForReps(selectedItem.routeUrl);
                        break;
                    case ssoTypes.schwab.name:
                        mainMenuData.openSchwab(selectedItem.routeUrl);
                        break;
                    case ssoTypes.goldmanSachs.name:
                        mainMenuData.openGoldmanSachs();
                        break;
                }
                break;
            case "fa-play-circle":
                window.open(`${selectedItem.link}?action=sso&t=${sessionStorage.oas_token}`, '_blank');
                break;
            case "fa-question-circle":
                window.open(selectedItem.link, '_blank');
                break;
            case "fa-orion-portfolio-group":
                if ($scope.user.profile.search === 3) {
                    $location.url(`/orion/dashboard?entity=${entities.portfolioGroup.value}&entityId=${selectedItem.id}`);
                } else {
                    $portfolio.goTo("portfoliogroups", 107, selectedItem.id);
                }

                break;
        }

        $scope.search.global = null;
    };

    $scope.openDbSwitcher = function () {
        if ($scope.user.session.menu === 'connect' || $scope.user.isImpersonating) {
            return;
        }

        $http.get("/Authorization/Databases", { cache: true, trackerMsg: 'Loading databases', ignoreExceptions: true, allowCancellation: false })
            .then(function (response) {
                $scope.databases = { list: response.data };
                $scope.showDbSwitcher = true;
                setTimeout(function () {
                    document.getElementById("txtDatabases").focus();
                }, 10);
            });
    };

    $scope.closeDbSwitcher = function () {
        $scope.showDbSwitcher = false;
    };

    $scope.switchDatabase = function (item) {
        if ($scope.user.authorization.alClientId !== item.id) {
            $http.get('/security/token', { headers: { Authorization: "Switch " + sessionStorage.oas_token, AlClientId: item.id }, trackerMsg: 'Requesting new database token', allowCancellation: false })
                .then(function (response) {
                    const newDbToken = response.data.access_token;

                    if ($oasRights.canRead("REQADVNUMFORDB")) {
                        $http.get("/Settings/EntityOptions/Database/0/code/1:69ADVNUM", { headers: { Authorization: "Session " + newDbToken }, trackerMsg: 'Loading database info', allowCancellation: false })
                            .then(function (response) {
                                $dialog.inputBox("Advisor Number", "Enter Number", "compare", { compareValue: response.data.value })
                                    .open()
                                    .then(function (result) {
                                        if (result) {
                                            sessionReset.reset(newDbToken);
                                        }
                                    });
                            });
                    } else {
                        sessionReset.reset(newDbToken);
                    }
                });
        } else {
            $scope.closeDbSwitcher();
        }
    };

    $scope.openProfile = function () {
        $dialog.dialog({ templateUrl: "app/modals/profile.html", controller: "ProfileCtrl" }).open();
    };

    $scope.openLoginAs = function () {
        $dialog.dialog({ templateUrl: "app/modals/login-as.html", controller: "LoginAsCtrl", resolve: { args: function () { return {}; } }, loginDestination: "OrionConnect" }).open();
    };

    $scope.revertToOriginalUser = function () {
        sessionReset.reset(sessionStorage.oas_token_original);
    };

    $scope.letsChatClick = function () {
        if (!$scope.user.gliaRepChatSupport || $scope.glia.repInOrionSiteId) {
            return;
        }
        $scope.glia.repInOrionSiteId = true;
        window.sm = undefined;
        gliaService.loadGliaForNonReps($scope);
    };

    $scope.openChatWindow = function (chatTeam) {
        $scope.user.session.sm_intendedRecipient = chatTeam.chatRouteIntendedRecipient;

        window.sm.getApi({ version: 'v1' })
            .then(function (salemove) {
                subscribeToLexEngagementEvents(salemove);
                salemove.updateInformation({
                    externalId: $scope.user.authorization.userGuid,
                    email: $scope.user.authorization.email,
                    name: $scope.user.authorization.entityName,
                    phone: $scope.user.authorization.phoneNumber,
                    customAttributes: {
                        advisorNumber: $scope.user.authorization.advisorNumber,
                        advisorName: $scope.user.authorization.alClientName,
                        currentAppLocation: (window.appCode ? window.appCode : 'Orion Connect'),
                        intendedRecipient: chatTeam.chatRouteIntendedRecipient,
                        userType: $scope.user.authorization.entity,
                        userId: `${gliaService.getGliaId($scope.user.authorization)}`,
                        visibility: gliaService.getVisibility($scope.user.authorization.entity),
                        domain: gliaService.gliaDomain,
                        product: gliaService.gliaProduct
                    }
                })
                .then(function () {
                    try {
                        var useLexDirectChat = $scope.lexDirectChatEnabled && gliaService.isLexChatTeam(chatTeam) && !gliaService.isAdvantageChatTeam(chatTeam);
                        var queueId = (chatTeam.queue && chatTeam.queue.id) || chatTeam.chatUrl;

                        if (useLexDirectChat && queueId) {
                            salemove.queueForEngagement('text', { queueId: queueId });
                        } else {
                            salemove.visitorApp.triggerQueueMediaSelection(chatTeam.queue);
                        }
                    } catch (err) {
                        $notifications.add({ type: 'danger', msg: 'Unable to start chat. Please try again later.' });
                    }
                })
            })
    };

    $scope.RepresentativeCoBrowse = function () {
        return $dialog.dialog({ templateUrl: "app/modals/RepresentativeCoBrowse.html", controller: "RepresentativeCoBrowseCtrl" }).open();
    };

    $scope.changePassword = function () {
        $dialog.dialog({ templateUrl: "app/modals/change-password.html", controller: "ChangePasswordCtrl" }).open();
    };

    $scope.logout = function () {
        if ($scope.user.session.menu === 'connect') {
            var salesforceRedirectUrl = getAllowedSalesforceLogoutUrl($scope.user.session.integration);
            if (salesforceRedirectUrl) {
                $http.delete("/Authorization/User/Integrations/Salesforce", { trackerMsg: 'Remove integration link' })
                    .then(function () {
                        window.top.location.href = salesforceRedirectUrl;
                    });
            } else {
                const env = window.location.host.has('test') ? 'test' : window.location.host.has('staging') ? 'staging' : '';
                window.location.replace(`https://${env}apps.advisorlynx.com/integration/link.aspx?logout=true`);
            }
        } else {
            sessionReset.logout();
        }
    };

    $scope.openSettings = function () {
        $dialog.editor("app/modals/settings/settings.html", "SettingsCtrl", { args: function () { return {}; } }).open();
    };

    $scope.openIntegrations = function () {
        $location.path("/tools/integrations/integrationCenter");
    };

    $scope.toggleSearchListOption = function (option) {
        option.include = !option.include;
        localStorage.oas_global_search = angular.toJson($scope.search.options);
    };

    $scope.toggleSearchOption = function (optionName) {
        $scope.search.options[optionName] = !$scope.search.options[optionName];
        localStorage.oas_global_search = angular.toJson($scope.search.options);
    };

    $scope.toggleStatus = function () {
        $notifications.toggleStatus($notifications.notifications.currentItem);
    };

    $scope.setNotificationGrouping = function () {
        $notifications.setNotificationGrouping();
    };

    $scope.setNotificationFilter = function (status) {
        $notifications.setNotificationFilter(status);
    };

    $scope.getCategories = function () {
        // FIXME: Decouple ctrl and service
        return $notifications.getCategories();
    };

    $scope.getFilteredNotifications = function (notifications) {
        return cleanNotificationUrls($notifications.getFilteredNotifications(notifications));
    };

    $scope.countByFilter = function (notifications) {
        return $notifications.countByFilter(notifications);
    };

    $scope.filterNotificationGroupsByStatus = function (group) {
        if (!$scope.notifications.settings.filter) {
            return true;
        }
        // TODO: group.items needs to change according to new data model
        return group.items.any($scope.filterNotificationsByStatus);
    };

    $scope.filterNotificationsByStatus = function (notification) {
        if (!$scope.notifications.settings.filter) {
            return true;
        }

        return notification.status === $scope.notifications.settings.filter;
    };

    $scope.markNotificationAsRead = function (notificationOrId) {
        $notifications.markAsRead(notificationOrId);
    };

    $scope.markNotificationAsUnread = function (notificationOrId) {
        $notifications.markAsUnread(notificationOrId);
    };

    $scope.haveAllBeenRead = function (categoryNotifications) {
        return categoryNotifications.count({status: 'Read'}) === categoryNotifications.length;
    };

    $scope.deleteNotification = function (notification) {
        $notifications.markAsDeleted(notification).then(function () {
            $scope.notifications.currentItem = null;
        });
    };

    $scope.deleteNotificationsInCategory = function (categoryName) {
        $notifications.markAllAsDeleted(categoryName).then(function () {
            $scope.currentCategory = null;
            $scope.directions = null;
        });
    };

    $scope.isAggregated = function (categoryName) {
        return $notifications.isAggregated(categoryName);
    };

    $scope.viewCategoryInApp = function (categoryName) {
        $location.url(`/tools/notifications/category/${categoryName}`);
        $notifications.changeStatusOfNotificationsByCategory(categoryName, 'Read');
        $scope.notifications.isOpen = false;
    };

    $scope.viewNotificationInApp = function () {
        $location.url('/tools/notifications');
        $scope.notifications.isOpen = false;
    };

    $scope.viewNotification = function (notification) {
        $notifications.markAsRead(notification);
        $timeout(function () {
            $scope.notifications.currentItem = notification;
        }, $scope.notifications.currentItem || $scope.currentCategory ? 200 : 0);
        $scope.currentCategory = '';
        $scope.directions = '';
    };

    $scope.clearSelected = function () {
        $scope.currentCategory = '';
        $scope.directions = '';
        $scope.notifications.currentItem = null;
    };

    $scope.viewNotificationFromToast = function (notificationId) {
        const notification = $notifications.getNotificationById(notificationId);
        $scope.viewNotification(notification);
        $timeout(function () { $scope.notifications.isOpen = true; });
    };

    $scope.getToken = function () {
        return sessionStorage.oas_token;
    };

    $scope.OrionSupport = function () {
        return window.open(`${API_CONFIG.baseUrl}/Integrations/Salesforce/OrionConnect/Action/CommunitySAML?Authorization=${sessionStorage.oas_token}`, '_blank');
    };

    $scope.generateShareLink = function (notification) {
        $http.post(notification.url.replace('/Data//', '/Action/Share/'), null, { trackerMsg: 'Generating share link' })
            .then(function (response) {
                const data = response.data;

                $dialog.dialog({ templateUrl: 'tools/modals/generated-share-link.html', controller: 'GeneratedShareLinkCtrl', notification: notification, shareUri: data.shareUri, expirationDate: data.expirationDate }).open();
            });
    };

    $scope.displayDirectionsInTray = function (categoryName) {
        $timeout(function () {
            $scope.currentCategory = categoryName;
        }, $scope.currentCategory || $scope.notifications.currentItem ? 200 : 0);
        $scope.notifications.currentItem = undefined;
        // Used to smooth out transition if the currentCategory is already set.
        // Want to keep transition smooth if the tray is already open.

        $scope.directions = 'To view the messages in this category, click the Open link above.';
    };

    //INITIALIZE
    $scope.assistEnabled = $oasRights.canRead("ASSISTHELP");
    $scope.search = { global: null };
    $scope.notifications = $notifications.notifications;
    $scope.menu = mainMenuData.menu;
    $scope.glia = { repInOrionSiteId: false };
    $scope.lexDirectChatEnabled = false;
    $scope.gliaPopOutEnabled = false;

    function applyLexChatResizeState() {
        if ($scope.lexDirectChatEnabled) {
            removeLexChatResizable();
            if (!initLexChatResizable($scope.gliaPopOutEnabled)) {
                retryInitLexChat(1000, 500, 20, $scope.gliaPopOutEnabled);
            }
        } else {
            removeLexChatResizable();
        }
    }

    /** Lex flag: Orion chat chrome + west/south resize; PopOut flag adds corner handles + drag (see initLexChatResizable). */
    function applyLexGliaCustomizationState() {
        $timeout(function () {
            if ($scope.lexDirectChatEnabled) {
                document.body.classList.add('lex-chat-customized');
                applyLexChatResizeState();
                tryRegisterLexEngagementEventsFromSm(0);
            } else {
                document.body.classList.remove('lex-chat-customized', 'lex-chat-post-engagement');
                if (lexEndModalObserverInstance) {
                    lexEndModalObserverInstance.disconnect();
                    lexEndModalObserverInstance = null;
                }
                removeLexChatResizable();
            }
        });
    }

    splitIoService.getBoolTreatment('oc_LEX_CustomerSupport_DirectChat_30255').subscribe(function (isEnabled) {
        $scope.lexDirectChatEnabled = isEnabled;
        applyLexGliaCustomizationState();
    });

    splitIoService.getBoolTreatment('oc_integrations_enable_glia_popout_drag_resize').subscribe(function (isEnabled) {
        $scope.gliaPopOutEnabled = isEnabled;
        $timeout(function () {
            if (isEnabled) {
                document.body.classList.add('glia-popout-enhanced');
            } else {
                document.body.classList.remove('glia-popout-enhanced');
            }
            applyLexChatResizeState();
        });
    });

    init();
});

app.service('sessionReset', function ($rootScope, $http, $location, API_CONFIG) {
    const self = this;

    self.reset = function (newToken, storeOriginalToken) {
        let originalToken;
        if (storeOriginalToken) {
            originalToken = sessionStorage.oas_token;
        }
        sessionStorage.clear();
        sessionStorage.oas_token = newToken;
        if (storeOriginalToken) {
            sessionStorage.oas_token_original = originalToken;
        }

        window.history.pushState({}, '', '#/main');
        window.location.reload();
    };

    self.goToLoginPage = function (queryParams) {
        const loginUrl = new URL(API_CONFIG.loginUrl);
        if (queryParams) {
            for (const key in queryParams) {
                if (queryParams.hasOwnProperty(key)) {
                    loginUrl.searchParams.set(key, queryParams[key]);
                }
            }
        }

        sessionStorage.clear();
        window.location.replace(loginUrl);
    };

    self.logout = function () {
        $http.delete("/Security/Token", {trackerMsg: 'Logging out', ignoreAuthModule: true, ignoreExceptions: true})
            .finally(function () {
                self.goToLoginPage();
            });
    };

    self.expiredPassword = function (resetGuid) {
        self.goToLoginPage({s: 'orionConnect', p: $location.path(), reset: resetGuid});
    };
});

'use strict';

app.controller('ListCtrl', function ListCtrl($scope, $http, $location, $rebalance, $oasRights, config, $dialog, $routeParams, apps) {
    var fullList, filteredList, filterFn;

    //TODO: move these during the refactor of this ctrl
    $scope.rebalanceSelected = function() {
        var selectedIds = fullList.findAll({selected: true}).map("id");
        $rebalance.start(2, selectedIds);
    };

    $scope.assignColors = function( putUrl ) {
        $dialog.confirmAction( "Do you want to assign random colors to any asset class without a color?" )
            .open()
            .then( function( result ) {
                if( result == 'yes' ) {
                    $http.put(putUrl, [], {trackerMsg: 'Updating colors.'})
                        .then(function () {
                            loadItems( );
                            $dialog.messageBox("Update successful", "The unassigned colors have been updated.").open();
                        });
                }
            } );
    };

    $scope.newQPEDashboard = function () {
        $dialog.dialog({templateUrl: "new-qpe-dashboard.html", controller: "NewQpeDashboardCtrl"})
            .open()
            .then(function (result) {
                if (result) {
                    $location.path("/advisor/qeprocessmgr/" + result.id);
                }
            });
    };
    /////////////////////////////////////////////////////////////

    $scope.mapToFunction = function(delegate) {
        if(angular.isString(delegate)) {
            switch(delegate) {
                case "rebalanceSelected":
                    $scope.rebalanceSelected();
                    break;
                case "assignRiskColors":
                    $scope.assignColors('/Portfolio/RiskCategories/Action/EstablishColors');
                    break;
                case "assignProductClassColors":
                    $scope.assignColors('/Portfolio/ProductClasses/Action/EstablishColors');
                    break;
                case "newQPEDashboard":
                    $scope.newQPEDashboard();
                    break;
                default:
                    return true;
            }
        } else if(angular.isFunction(delegate)) return delegate();
    };

    $scope.showLink = function(linkItem){
       if(!linkItem.securityCode) return true;
       return $oasRights.canRead(linkItem.securityCode);
    };


    //PRIVATE METHODS
    function loadItems() {
        fullList = [];
        loadDataRecursive(0, config.takeInterval || 10000);

    }

    function loadDataRecursive(skip, take) {
        var url = config.getUrl + (config.getUrl.indexOf('?') == -1 ? "?" : "&") + "$skip=" + skip + "&$top=" + take;
        $http.get(url, {trackerMsg: 'Loading rows ' + (skip + 1) + ' to ' + (skip + take) + " for " + config.listName.toLowerCase()})
            .then(function (response) {
                fullList.add(response.data);
                filteredList = fullList;
                  $scope.sortItems();
                resetPagination();

                if (response.data.length === take) {
                    loadDataRecursive(skip + take, take);
                }
            });
    }

    function resetPagination() {
        $scope.current.totalItems = filteredList.length;
        $scope.setPageItems();
    }

    function buildFilterFn(filterFields) {
        var filterString = "(function(item, value) {return ";
        filterFields.forEach(function (field) {
            filterString += "(item." + field + " && item." + field + ".toString().toLowerCase().indexOf(value) !== -1) || ";
        });
        filterString = filterString.to(filterString.length - 4) + ";})";
        return eval(filterString);
    }


    //PUBLIC METHODS
    $scope.selectItem = function(item) {
        if (config.selectEnabled) {
            if (!config.multiSelectEnabled) {
                fullList.forEach(function(listItem) {listItem.selected = false;});
            }
            item.selected = !item.selected;
        }
    };
    $scope.deleteItem = function(item) {
        let location = $location.url();
        let methods = {
            '/assetclasses': function(){
                $dialog.dialog({
                    controller: ['$scope', '$http', '$q', 'dialog', '$timeout', function($scope, $http, $q, dialog, $timeout){
                        $scope.view = 'loading';
                        $scope.options = [];
                        $scope.data = {
                          answer:''
                        };
                        $scope.answer = '';
                        $scope.errorMessage = {
                            msg:[],
                            reassignAsset:false,
                            delete:false
                        };
                        $scope.close = function (d) {
                            $scope.view = 'updating';
                            if(d){
                                $http.delete('/Portfolio/ProductClasses/Verbose/'+item.id+'?reassignKey='+$scope.data.answer.id+'')
                                    .then(function(res){
                                        if(res.status !== 204){
                                            $scope.errorMessage.msg = res.data[0].errorMessage;
                                            $scope.errorMessage.reassignAsset = false;
                                            $scope.view = 'choice';
                                        }else{
                                            dialog.close(d);
                                        }
                                    })
                                ;
                            }else{
                                dialog.close(d);
                            }
                        };

                        //INIT
                        (function(){
                            $http.get('/Portfolio/ProductClasses/Verbose/CanDelete/'+item.id)
                                .then(function(res){
                                    if(res.data.length > 0 ){
                                        if(res.data.length > 1){
                                            res.data.forEach(function(i){
                                                if(i.propertyName !== "AssociatedProducts"){
                                                    $scope.errorMessage.msg.push({text:i.errorMessage});
                                                }
                                            });
                                            $scope.errorMessage.reassignAsset = false;
                                        }else{
                                            $scope.errorMessage.msg = [{text:res.data[0].errorMessage}];
                                            $scope.errorMessage.reassignAsset = (res.data.length === 1 && res.data[0].propertyName === "AssociatedProducts");
                                        }
                                    }else{
                                        $scope.errorMessage.msg=[{text:"Are you sure you want to delete this Asset Class?"}];
                                        $scope.errorMessage.delete = true;
                                    }

                                })
                                .then(function(){
                                    return ($scope.errorMessage.reassignAsset)? $http.get('/Portfolio/ProductClasses/Simple') : false;
                                })
                                .then(function(res){
                                    if(res) $scope.options = res.data;
                                    $scope.view = 'choice';
                                })
                            ;
                        })();
                    }],
                    template:   `   <div class='modal fade ng-scope in' ng-init='answer'>
                                       <div class='modal-header'>
                                           <h4>
                                               <i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Confirm Action
                                           </h4>
                                       </div>
                                       <div ng-if='view == "loading"' class='modal-body'>
                                           <i class='fa fa-pulse fa-spinner fa-spin fa-3x' aria-hidden='true'></i><span>Loading</span>
                                       </div>
                                       <div ng-if='view == "choice"' class='modal-body'>

                                           <ul style='list-style-type: none; margin:0; padding:0;'>
                                               <li ng-repeat='msg in errorMessage.msg' style='padding:10px 0px;'>{{msg.text}}</li>
                                           </ul>
                                           <div ng-if='errorMessage.reassignAsset' style='margin-top: 10px;'>
                                               <label style='float:left; margin:5px;'>Asset Class</label><select ng-options='option.name for option in options' ng-model='data.answer'></select>
                                           </div>
                                       </div>
                                       <div ng-if='view == "updating"' class='modal-body'>
                                           <i class='fa fa-pulse fa-spinner fa-spin fa-3x' aria-hidden='true'></i><span>Updating</span>
                                       </div>
                                       <div ng-if='view == "updating" || view == "loading"' class='modal-footer'></div>
                                       <div ng-if='view == "choice"' class='modal-footer'>
                                           <button ng-if='errorMessage.reassignAsset || errorMessage.delete' ng-click='close(true)' class='btn ng-binding ng-scope btn-primary' ng-class='btn.cssClass' oas-focus='true' style=''>Submit</button>
                                           <button ng-if='errorMessage.reassignAsset || errorMessage.delete' ng-click='close(false)' class='btn ng-binding ng-scope' ng-class='btn.cssClass' oas-focus='' style=''>Cancel</button>
                                           <button ng-if='!errorMessage.reassignAsset && !errorMessage.delete' ng-click='close(false)' class='btn ng-binding ng-scope' ng-class='btn.cssClass' oas-focus='' style=''>OK</button>
                                       </div>
                                   </div>`
                })
                    .open()
                    .then(function(res){
                        if(res)loadItems();
                    })
                ;
            },
            '/riskcategories': function(){
                $dialog.dialog({
                    controller: ['$scope', '$http', '$q', 'dialog', '$timeout', function($scope, $http, $q, dialog, $timeout){
                        $scope.view = 'loading';
                        $scope.options = [];
                        $scope.data = {
                            answer:''
                        };
                        $scope.answer = '';
                        $scope.errorMessage = {
                            msg:[],
                            reassignAsset:false,
                            delete:false
                        };
                        $scope.close = function (d) {
                            $scope.view = 'updating';
                            if(d){
                                $http.delete('/Portfolio/RiskCategories/Verbose/'+item.id+'?reassignKey='+$scope.data.answer.id+'')
                                    .then(function(res){
                                        if(res.status !== 204){
                                            $scope.errorMessage.msg = res.data[0].errorMessage;
                                            $scope.errorMessage.reassignAsset = false;
                                            $scope.view = 'choice';
                                        }else{
                                            dialog.close(d);
                                        }
                                    })
                                ;
                            }else{
                                dialog.close(d);
                            }
                        };

                        //INIT
                        (function(){
                            $http.get('/Portfolio/RiskCategories/Verbose/CanDelete/'+item.id)
                                .then(function(res){
                                    if(res.data.length > 0 ){
                                        if(res.data.length > 1){
                                            res.data.forEach(function(i){
                                                if(i.propertyName !== "AssociatedProducts"){
                                                    $scope.errorMessage.msg.push({text:i.errorMessage});
                                                }
                                            });
                                            $scope.errorMessage.reassignAsset = false;
                                        }else{
                                            $scope.errorMessage.msg = [{text:res.data[0].errorMessage}];
                                            $scope.errorMessage.reassignAsset = (res.data.length === 1 && res.data[0].propertyName === "AssociatedProducts");
                                        }
                                    }else{
                                        $scope.errorMessage.msg=[{text:"Are you sure you want to delete this Asset Class?"}];
                                        $scope.errorMessage.delete = true;
                                    }

                                })
                                .then(function(){
                                    return ($scope.errorMessage.reassignAsset)? $http.get('/Portfolio/RiskCategories/Simple') : false;
                                })
                                .then(function(res){
                                    if(res) $scope.options = res.data;
                                    $scope.view = 'choice';
                                })
                            ;
                        })();
                    }],
                    template:   `   <div class='modal fade ng-scope in' ng-init='answer'>
                               <div class='modal-header'>
                                   <h4>
                                       <i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Confirm Action
                                   </h4>
                               </div>
                               <div ng-if='view == "loading"' class='modal-body'>
                                   <i class='fa fa-pulse fa-spinner fa-spin fa-3x' aria-hidden='true'></i><span>Loading</span>
                               </div>
                               <div ng-if='view == "choice"' class='modal-body'>

                                   <ul style='list-style-type: none; margin:0; padding:0;'>
                                       <li ng-repeat='msg in errorMessage.msg' style='padding:10px 0px;'>{{msg.text}}</li>
                                   </ul>
                                   <div ng-if='errorMessage.reassignAsset' style='margin-top: 10px;'>
                                       <label style='float:left; margin:5px;'>Asset Class</label><select ng-options='option.name for option in options' ng-model='data.answer'></select>
                                   </div>
                               </div>
                               <div ng-if='view == "updating"' class='modal-body'>
                                   <i class='fa fa-pulse fa-spinner fa-spin fa-3x' aria-hidden=\"true\"></i><span>Updating</span>
                               </div>
                               <div ng-if='view == "updating" || view == "loading"' class='modal-footer'></div>
                               <div ng-if='view == "choice"' class='modal-footer'>
                                   <button ng-if='errorMessage.reassignAsset || errorMessage.delete' ng-click='close(true)' class='btn ng-binding ng-scope btn-primary' ng-class='btn.cssClass' oas-focus='true' style=''>Submit</button>
                                   <button ng-if='errorMessage.reassignAsset || errorMessage.delete' ng-click='close(false)' class='btn ng-binding ng-scope' ng-class='btn.cssClass' oas-focus='' style=''>Cancel</button>
                                   <button ng-if='!errorMessage.reassignAsset && !errorMessage.delete' ng-click='close(false)' class='btn ng-binding ng-scope' ng-class='btn.cssClass' oas-focus='' style=''>OK</button>
                               </div>
                           </div>`
                })
                    .open()
                    .then(function(res){
                        if(res)loadItems();
                    })
                ;
            },
            'default':function(){
                $dialog.confirmAction( "Are you sure you want to remove <b>" + item[config.nameProperty] + "</b>?" )
                    .open()
                    .then( function( result ) {
                        if( result === 'yes' ) {
                            $http.delete(config.deleteUrl + item.id, {trackerMsg: 'Deleting ' + item[config.nameProperty]})
                                .then(function () {
                                    $scope.deleteBreadcrumb(item[config.nameProperty]);
                                    fullList.splice(fullList.indexOf(item), 1);

                                    var value = ($scope.current.filterValue || "").toLowerCase();
                                    filteredList = value ? fullList.filter(function(item) {return filterFn(item, value);}) : fullList;

                                    resetPagination();
                                });
                        }
                    }
                );
            }
        };
        (typeof methods[location] === 'function')?methods[location]() : methods['default']();
    };
    $scope.setPageItems = function(page) {
        page = page || $scope.current.page;

        var begin = (page - 1) * $scope.current.itemsPerPage;
        var end = begin + $scope.current.itemsPerPage;

        $scope.pageItems = filteredList.slice(begin, end);
    };

    $scope.filterItems = function() {
        var value = $scope.current.filterValue.toLowerCase();
        filteredList = value ? fullList.filter(function(item) {return filterFn(item, value);}) : fullList;

        resetPagination();
        $scope.current.page = 1;
    };

    $scope.sortItems = function() {
        filteredList = filteredList.sortBy($scope.current.sort,$scope.current.sortAsc);

        $scope.setPageItems();
    };

    $scope.toggleSortAsc = function() {
        $scope.current.sortAsc = !$scope.current.sortAsc;
        $scope.sortItems();
    };

    $scope.goBack = function () {
        window.history.back();
    };

    //INITIALIZE
    $scope.current = {template: config.template, filterValue: null, sortFields: config.sortFields, sort: config.defaultSortItem ? config.defaultSortItem : 'name', sortAsc: !config.defaultSortDirection ? false: true, page: 1, pageSizes: [10, 50, 100], itemsPerPage: 100, totalItems: 0, numPages: 0, listName: config.listName, additionalLinks: config.additionalLinks };
    filterFn = angular.isFunction(config.listFilter) ? config.listFilter : buildFilterFn(config.listFilter);


    $scope.rights = null;
    if( config.securityCode ) {
        $scope.rights = $oasRights.forCode( config.securityCode );
    }

    if ($routeParams.source) {
        var key = apps.find({code: $routeParams.source});
        $scope.middleBreadcrumb = key ? apps[key].name : null;
    }

    loadItems();
});

app.controller('NewQpeDashboardCtrl', function NewQpeDashboardCtrl($scope, $http, dialog) {
    //PRIVATE METHODS
    function init() {
        $http.get('/Reporting/ProcessManager/Types', {cache: true})
            .then(function (response) {
                response.data.forEach(function (type) {
                    switch (type.name) {
                        case "Month End Dashboard":
                            $scope.periods.list.push({period: "Monthly", name: "Monthly", typeId: type.id});
                            break;
                        case "Quarter End Dashboard":
                            $scope.periods.list.push({period: "Quarterly", name: "Quarterly", typeId: type.id});
                            break;
                        case "Quarter End Dashboard 2":
                            $scope.periods.list.push({period: "Quarterly", name: "Quarterly 2", typeId: type.id});
                            break;
                        case "Tri-Annual End Dashboard":
                            $scope.periods.list.push({period: "Tri-Annually", name :"Tri-Annually", typeId : type.id});
                            break;
                    }
                });

                $scope.periods.selected = $scope.periods.list.find({name: "Quarterly"});
            });
    }


    //PUBLIC METHODS
    $scope.submit = function () {
        $scope.current.typeId = $scope.periods.selected.typeId;
        $scope.current.period = $scope.periods.selected.period;
        $scope.current.startDate = $scope.current.startDate.formatted(false);

        $http.post("/Reporting/ProcessManager/Dashboard", $scope.current, {trackerMsg: 'Creating new dashboard'})
            .then(function (response) {
                dialog.close(response.data);
            });
    };

    $scope.cancel = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.current = {};
    $scope.periods = {list: [], selected: null};

    init();
});
'use strict';
app.controller('SettingsCtrl', function SettingsCtrl($scope, $http, $q, $injector, $interval, dialog, args, $dialog, $oasRights, $sce, splitIoService) {
    //PRIVATE VARIABLES
    var newAppLoaded = false;
    var loadedOptions = [];
    var loadedServices = [];
    var dirtyServiceTimer;
    var types = [{ name: 'User', icon: 'fa fa-user', isCustom: false, selected: false }];
    const quodd = "QUODD Real-Time Snap Quotes";
    var custom = {
        "Integrations": {
            "Akoya": {
                "adminOnly": true,
                "isInclusion": true,
                "service": "$akoyacredservice",
                "inputs": [{
                    "name": AkoyaCredentialsCtrl, "displayName": "", "controlType": "inclusion"
                    , value: "portfolio/views/akoya-credentials.html"
                }],
                "image": "akoya",
            },
            "BizEquity Whitelist": {
                "adminOnly": false,
                "isInclusion": false,
                "allowRep": true,
                "endpoints": {
                    "read": "/Integrations/BizEquity/BizUser",
                    "update": "/Integrations/BizEquity/BizUser"
                },
                "inputs": [
                    { "name": "subDomain", "displayName": "Sub Domain", "controlType": "text" },
                    { "name": "affiliationId", "displayName": "Affiliation Id", "controlType": "text" }
                ],
                "image": "biz-equity",
                "description": ""
            },
            "By All Accounts Balance Only": {
                "adminOnly": false,
                "isInclusion": false,
                "endpoints": {
                    "read": "/Integrations/ByAllAccounts/Configuration?balanceOnly=true&firm=true",
                    "update": "/Integrations/ByAllAccounts/Configuration?balanceOnly=true&firm=true"
                },
                "inputs": [
                    { "name": "username", "displayName": "Balance Only Username", "controlType": "text" },
                    { "name": "password", "displayName": "Balance Only Password", "controlType": "password" }
                ],
                "image": "by-all-accounts"
            },
            "By All Accounts Recon": {
                "adminOnly": false,
                "allowRep": true,
                "isInclusion": false,
                "endpoints": {
                    "read": "/Integrations/ByAllAccounts/Configuration?balanceOnly=false&firm=false",
                    "update": "/Integrations/ByAllAccounts/Configuration?balanceOnly=false&firm=false"
                },
                "inputs": [
                    { "name": "username", "displayName": "AccountView Username", "controlType": "text" },
                    { "name": "password", "displayName": "AccountView Password", "controlType": "password" }
                ],
                "image": "by-all-accounts"
            },
            "By All Accounts Recon Firm": {
                "adminOnly": true,
                "isInclusion": false,
                "endpoints": {
                    "read": "/Integrations/ByAllAccounts/Configuration?balanceOnly=false&firm=true",
                    "update": "/Integrations/ByAllAccounts/Configuration?balanceOnly=false&firm=true"
                },
                "inputs": [
                    { "name": "username", "displayName": "AccountView Username", "controlType": "text" },
                    { "name": "password", "displayName": "AccountView Password", "controlType": "password" }
                ],
                "image": "by-all-accounts"
            },
            "Cheetah": {
                "adminOnly": false,
                "isInclusion": false,
                "endpoints": {
                    "read": "/Integrations/Cheetah/Configuration",
                    "update": "/Integrations/Cheetah/Configuration"
                },
                "inputs": [
                    { "name": "UserName", "displayName": "UserName", "controlType": "text" },
                    { "name": "Password", "displayName": "Password", "controlType": "password" },
                    { "name": "ApiKey", "displayName": "ApiKey", "controlType": "password" },
                    { "name": "BaseAddress", "displayName": "BaseAddress", "controlType": "text" }
                ],
                "image": "cheetah"
            },
            "LaserApp": {
                "adminOnly": true,
                "isInclusion": false,
                "endpoints": {
                    "read": "/Integrations/LaserApp/Configuration?custodianId=",
                    "update": "/Integrations/LaserApp/Configuration?custodianId="
                },
                "inputs": [
                    { "name": "partnerId", "displayName": "Partner ID", "controlType": "text", "disableOnCustodian": true },
                    { "name": "formsServiceUserName", "displayName": "Forms Service User Name", "controlType": "text", "disableOnCustodian": true },
                    { "name": "formsServiceAuthCode", "displayName": "Forms Service Auth Code", "controlType": "password", "disableOnCustodian": true },
                    { "name": "formsServiceURL", "displayName": "Forms Service URL", "controlType": "text", "disableOnCustodian": true },
                    { "name": "anywhereServiceAuthCode", "displayName": "Anywhere Service Auth Code", "controlType": "password", "disableOnCustodian": true },
                    { "name": "anywhereServiceURL", "displayName": "Anywhere Service URL", "controlType": "text", "disableOnCustodian": true },
                    { "name": "postUrl", "displayName": "Post URL", "controlType": "text", "disableOnCustodian": true },
                    { "name": "postFormat", "displayName": "Post Format", "controlType": "select", "options": "laserAppPostformat", "disableOnCustodian": true },
                    { "name": "theme", "displayName": "Theme", "controlType": "select", "options": "laserAppTheme", "disableOnCustodian": true },
                    { "name": "sigMethod", "displayName": "Sig Method", "controlType": "select", "options": "laserAppSigMethod" },
                    { "name": "remoteSigAuth", "displayName": "Remote Sig Auth", "controlType": "password" },
                    { "name": "remoteSigPass", "displayName": "Remote Sig Pass", "controlType": "password" },
                    { "name": "remoteSigId", "displayName": "Remote Sig ID", "controlType": "boolean" },
                    { "name": "postButtonCaption", "displayName": "Post Button Caption", "controlType": "text" },
                    { "name": "signIXClientId", "displayName": "Sign IX Client ID", "controlType": "password" },
                    { "name": "signIXSubmitterEmail", "displayName": "Sign IX Submitter Email", "controlType": "text" },
                    { "name": "printButtonState", "displayName": "Print Button State", "controlType": "select", "options": "laserAppPrintButton", "disabled": false },
                    { "name": "smartEnforce", "displayName": "Smart Enforce", "controlType": "select", "options": "laserAppSmartFields", "disabled": false }
                ],
                "image": "laserApp"
            },
            "LaserApp Mappings": {
                "adminOnly": false,
                "isInclusion": true,
                "service": "$paperwork",
                "inputs": [{ "name": MaintainPaperworkCtrl, "displayName": "", "controlType": "inclusion", value: "portfolio/views/maintainPaperwork.html" }],
                "image": "laserApp"
            },
            "MoneyGuide": {
                "adminOnly": false,
                "isInclusion": false,
                "endpoints": {
                    "read": "/Integrations/MoneyGuidePro/Configuration",
                    "update": "/Integrations/MoneyGuidePro/Configuration"
                },
                "inputs": [
                    { "name": "userId", "displayName": "SVC User ID", "controlType": "text" },
                    { "name": "password", "displayName": "SVC Password", "controlType": "password" }
                ],
                "image": "mgp",
                "disclaimer": $sce.trustAsHtml("<span style='color: red;'>If credentials have already been entered, do not overwrite these as it will break the preexisting integration for this database.</span>")
            },
            "NetX360": {
                "adminOnly": false,
                "isInclusion": false,
                "allowRep": true,
                "endpoints": {
                    "read": "/Integrations/Pershing/NetX360User",
                    "update": "/Integrations/Pershing/NetX360User"
                },
                "inputs": [
                    { "name": "username", "displayName": "Username", "controlType": "text" },
                ],
                "image": "netX360",
                "description": ""
            },
            "Plaid": {
                "adminOnly": false,
                "isInclusion": false,
                "endpoints": {
                    "read": "/Integrations/Plaid/Configuration",
                    "update": "/Integrations/Plaid/Configuration"
                },
                "inputs": [
                    { "name": "clientID", "displayName": "ClientID", "controlType": "password" },
                    { "name": "secret", "displayName": "Secret", "controlType": "password" },
                    { "name": "plaidEnvironment", "displayName": "Plaid Environment", "controlType": "select", "options": "plaidEnvironmentChoices" }


                ],
                "image": "plaid"
            },
            "Nitrogen": {
                "adminOnly": false,
                "isInclusion": false,
                "endpoints": {
                    "read": "/Integrations/RiskAlyze/Configuration",
                    "update": "/Integrations/RiskAlyze/Configuration"
                },
                "inputs": [
                    { "name": "orionUid", "displayName": "API User ID", "controlType": "text" },
                    { "name": "orionPwd", "displayName": "API Password", "controlType": "password" },
                    { "name": "client_id", "displayName": "Nitrogen ID", "controlType": "text", adminOnly: true },
                    { "name": "client_secret", "displayName": "Nitrogen Secret", "controlType": "password", adminOnly: true },
                    { "name": "redirect_uri", "displayName": "Redirect URI", "controlType": "text", adminOnly: true }
                ],
                "image": "Nitrogen",
                "disclaimer": $sce.trustAsHtml("<span style='color: red;'>If credentials have already been entered, do not overwrite these as it will break the preexisting integration for this database.</span>")
            },
            "SAP Concur": {
                "adminOnly": false,
                "isInclusion": false,
                "allowRep": false,
                "endpoints": {
                    "read": "/Integrations/Concur/Configuration",
                    "update": "/Integrations/Concur/Configuration"
                },
                "inputs": [
                    {
                        "name": "concurEntityID",
                        "displayName": " Concur Entity ID",
                        "controlType": "text",
                        "adminOnly": false,
                        "description": "Entity ID provided by Concur."
                    },
                    {
                        "name": "sftpUrl",
                        "displayName": "SFTP URL",
                        "controlType": "text",
                        "adminOnly": false,
                        "description": "st.concursolutions.com or mft-us.concursolutions.com"
                    }
                ],
                "image": "concur",
                "description": ""
            },
            "TD Advanced Alerts": {
                "adminOnly": false,
                "isInclusion": false,
                "endpoints": {
                    "read": "/Integrations/TDAmeritrade/AdvancedAlerts/Configuration",
                    "update": "/Integrations/TDAmeritrade/AdvancedAlerts/Configuration"
                },
                "inputs": [{ "name": "enabled", "displayName": "TD Advanced Alerts", "controlType": "boolean" }],
                "image": "tda",
                "description": "This integration, when enabled will allow you to subscribe to the notifications that are generated by the TD Veo platform.  These notifications will be displayed in the Orion Connect Notification Center.  After this has been enabled you can go to the Notification Subscription page to subscribe to these alerts."
            },
            "TD Veo One": {
                "adminOnly": false,
                "isInclusion": false,
                "allowRep": true,
                "endpoints": {
                    "read": "/Integrations/TDAmeritrade/VeoOneUser",
                    "update": "/Integrations/TDAmeritrade/VeoOneUser"
                },
                "inputs": [
                    { "name": "userId", "displayName": "Veo One User ID", "controlType": "text" },
                    { "name": "password", "displayName": "Veo One Password", "controlType": "password" }
                ],
                "image": "tda",
                "description": ""
            },
            "TRX Portal": {
                "adminOnly": true,
                "isInclusion": false,
                "endpoints": {
                    "read": "/Integrations/TRX/Configuration",
                    "update": "/Integrations/TRX/Configuration"
                },
                "inputs": [
                    { "name": "orionUserId", "displayName": "Orion User ID", "controlType": "text" },
                    { "name": "orionPassword", "displayName": "Orion Password", "controlType": "password" }
                ],
                "image": "trx"
            },
            "Vestorly": {
                "adminOnly": false,
                "service": "$vestorly",
                "isInclusion": true,
                "inputs": [{ "name": VestorlyCtrl, "displayName": "", "controlType": "inclusion", value: "app/modals/settings/vestorly.html" }],
                "image": "vestorly"
            },
            "Cash & Credit": {
                "adminOnly": false,
                "isInclusion": true,
                "inputs": [{ "name": "enabled", "displayName": "Signed up", "controlType": "boolean" }],
                "endpoints": {
                    "read": "/Integrations/FCS/FocusUser",
                    "update": "/Integrations/FCS/FocusUser"
                },
                "image": "Cash & Credit"
            },
            "QUODD Real-Time Snap Quotes": {
                "adminOnly": false,
                "allowRep": true,
                "isInclusion": false,
                "inputs": [
                    {
                        "name": "createUser",
                        "displayName": "",
                        "controlType": "qbutton"
                    }
                ],
                "endpoints": {
                    "read": "",
                    "update": ""
                },
                "image": "quodd"
            },
            "Axos": {
                "adminOnly": false,
                "isInclusion": false,
                "inputs": [
                    { "name": "axosUser", "displayName": "Axos Username", "controlType": "text" },
                    { "name": "axosWord", "displayName": "Axos Password", "controlType": "password" }
                ],
                "endpoints": {
                    "read": "",
                    "update": "/Integrations/Axos/GetToken"
                },
                "image": "axos"
            },
            "Schwab": {
                "adminOnly": false,
                "service": "$schwab",
                "isInclusion": true,
                "inputs": [{ "name": SchwabCtrl, "displayName": "", "controlType": "inclusion", value: "" }],
                "image": "schwab"
            },
            "Arch": {
                "adminOnly": false,
                "isInclusion": true,
                "service": "ArchCredentialsService",
                "inputs": [{
                    "name": ArchAngularCtrl,
                    "displayName": "",
                    "controlType": "inclusion",
                    value: ""
                }],
                "image": "arch-logo"
            },
            "Raymond James": {
                "adminOnly": false,
                "isInclusion": true,
                "inputs": [{
                    "name": RaymondJamesAngularCtrl,
                    "displayName": "",
                    "controlType": "inclusion",
                    value: ""
                }],
                "image": "raymond-james"
            }
        },
        "User": {
            "Apps": [
                {
                    appCode: "notifications",
                    category: "Reporting",
                    description: "Notifications Settings",
                    imageName: "notifications",
                    isActive: true,
                    name: "Notifications",
                    routeUrl: "",
                    securityCode: "NOTIFICATIONS",
                    ssoType: "None",
                    tags: "",
                    userOptionCount: 1
                }
            ]
        }
    };

    //PRIVATE METHODS
    function initialize() {
        loadTypes();
        loadApps();
    }

    async function loadTypes() {
        if ($scope.user.authorization.entity === "Administrator" || $scope.user.authorization.entity === "Advisor" || $scope.user.authorization.entity === "Representative") {
            if ($scope.user.authorization.entity !== "Representative") {
                types.add({ name: 'Database', icon: 'fa fa-building', isCustom: false, selected: false });
                if (!$oasRights.forCode("HIDEINTEGRATIONSTAB").canRead) {
                    types.add({ name: 'Integrations', icon: 'fa fa-puzzle-piece', isCustom: true, selected: false });
                }

                $http.get("/Trading/QUODD/check", { cache: false, allowCancellation: false  }).then(function (response) {
                    var realTimePriceCheck = response.data;
                    if (!realTimePriceCheck) {
                        delete custom.Integrations[quodd];
                    }
                });
            }
            else {
                if ($oasRights.forCode("BYALLSSOREP").canRead || $oasRights.forCode("TDAPP").canRead || $oasRights.forCode("ADVISORYWORLDPROPOSAL").canRead || $oasRights.forCode("ADVISORYWORLDRPTS").canRead || $oasRights.forCode("BIZEQUITY").canRead) {
                    types.add({ name: 'Integrations', icon: 'fa fa-puzzle-piece', isCustom: true, selected: false });
                    custom.Integrations = Object.each(custom.Integrations, function (key, value) {
                        if (!value.allowRep) {
                            delete custom.Integrations[key];
                        }
                        if (!$oasRights.forCode("TDAPP").canRead && key == 'TD Veo One') {
                            delete custom.Integrations[key];
                        }
                        if (!$oasRights.forCode("BYALLSSOREP").canRead && key == 'By All Accounts Recon') {
                            delete custom.Integrations[key];
                        }
                        if (!$oasRights.forCode("BIZEQUITY").canRead && key == 'BizEquity Whitelist') {
                            delete custom.Integrations[key];
                        }
                    })
                }
            }

            //remove integration apps that we don't want advisors to have access to
            if ($scope.user.authorization.entity === "Advisor") {
                custom.Integrations = Object.each(custom.Integrations, function (key, value) {
                    if (value.adminOnly) {
                        delete custom.Integrations[key];
                    }
                });
            }

            //remove MoneyGuide configuration if user doesn't have IntegrationsSetup and (UserManagement or ResetUser) privilege
            if (!$oasRights.forCode("INTEGRATIONSSETUP").canRead || (!$oasRights.forCode("MUL_USERS").canUpdate && !$oasRights.forCode("MUL_RESETUSER").canUpdate)) {
                if (custom.Integrations && custom.Integrations['MoneyGuide']) {
                    delete custom.Integrations['MoneyGuide'];
                }
            }
        }
    }

    function loadApps() {
        $http.get("/Settings/Apps?hasOptions=true", { cache: true, trackerMsg: 'Loading apps', allowCancellation: false  })
            .then(function (response) {
                $scope.apps = response.data.exclude({ appCode: 'notifications' }).sortBy('name');
                $scope.selectSettingType(0);
            });
    }

    function loadOptions(app) {
        $scope.current.selectedApp = app;
        var level = $scope.current.selectedType.name === "Database" ? "Advisor" : $scope.current.selectedType.name;

        var url = $scope.current.selectedApp.isCustom ? custom[$scope.current.selectedType.name][$scope.current.selectedApp.name].endpoints.read : "/Settings/Apps/" + app.appCode + "/Options?level=" + level;

        if ($scope.current.selectedApp.name == 'LaserApp Configuration') {
            url += $scope.current.selectedCustodian;
            //Load custodian list (simple)
            $http.get('/Portfolio/Custodians/Simple', { cache: true, trackerMsg: 'Loading custodian list', allowCancellation: false  })
                .then(function (response) {
                    $scope.custodianList = response.data;
                })
        }

        if (app.name === 'Notifications') {
            $scope.current.loadedOptions = [
                {
                    canUserOverride: true,
                    category: "Misc",
                    controlType: "Notifications",
                    description: "Edit notifications settings.",
                    displayName: "Notifications Settings",
                    id: 0,
                    name: "notifications",
                    parentAppOptionId: null,
                    value: ""
                }
            ];
            processOptions($scope.current.loadedOptions);
            storeLoadedOptions(app.name, app.appCode);
        } else {
            if (callServerOptions(app)) {
                $http.get(url, { trackerMsg: ('Loading options for ' + app.name), allowCancellation: false  })
                    .then(function (response) {
                        $scope.current.orderBy = null;
                        if ($scope.current.selectedApp.isCustom) {
                            loadCustomInputs(response.data);

                        }
                        else if (response.data) {
                            $scope.current.loadedOptions = response.data;
                            updateTypes($scope.current.loadedOptions);
                            processOptions($scope.current.loadedOptions);
                            $scope.current.loadedOptions.forEach(function (item) {
                                attachRevealMetadata(
                                    item,
                                    '/Settings/Apps/' + encodeURIComponent(app.appCode) + '/Options/' + encodeURIComponent(item.name) + '/Reveal?level=' + level,
                                    'value'
                                );
                            });
                            storeLoadedOptions(app.name, app.appCode);
                        }
                        setCustomOrder();
                    });
            } else {
                var selected = loadedOptions.find(function (item) {
                    return (item.appName === app.name) && (item.optionType === level);
                });
                $scope.current.loadedOptions = selected ? convertToType(angular.copy(selected.options)) : [];
                processOptions($scope.current.loadedOptions);
                applyIntegrationRevealMetadata(app);
                setCustomOrder();
            }
        }

        if (app.name === quodd) {
            $http.get("/Trading/QUODD/checkRealTimeStatus", { cache: false, allowCancellation: false  }).then(function (response) {
                switch (response.data) {
                    case 0:
                    case 1:
                        showHideForm(true, '', false);
                        break;
                    case 2:
                        showHideForm(false, 'Awaiting Quodd Integration Document Signing. One Moment Please.', true);
                        $scope.signAgreement();
                        break;
                    case 3:
                        showHideForm(false, 'Awaiting Quodd Integration Approval.', true);
                        break;
                    case 4:
                        showHideForm(false, "Quodd Real Time Price Approved.", true);
                        break;
                    default:
                        showHideForm(false, "Please contact the SME team for further assistance.", true);
                }
            });
        }
    }

    function setCustomOrder() {
        if ($scope.current.selectedApp.appCode == "custodialIntegrator") {
            $scope.current.orderBy = "id";
        }
    }

    function hasInclusion(loadedApp) {
        var inclusion = false;
        if (loadedApp.isCustom)
            inclusion = custom[$scope.current.selectedType.name][loadedApp.name].isInclusion;
        return inclusion;
    }

    function loadInclusionService() {
        var appName = $scope.current.selectedApp.name;
        var type = $scope.current.selectedType.name;
        loadedServices.push({ "appName": appName, "type": type, "serviceName": custom[type][appName].service });
    }

    function buildRevealUrlFromReadEndpoint(readUrl) {
        if (!readUrl) {
            return '';
        }
        if (readUrl.indexOf('VeoOneUser') >= 0) {
            return readUrl.replace('VeoOneUser', 'VeoOneUser/Reveal');
        }
        if (readUrl.indexOf('/Configuration') >= 0) {
            return readUrl.replace('/Configuration', '/Configuration/Reveal');
        }
        return '';
    }

    function getConfigField(config, fieldName) {
        if (!config || !fieldName) {
            return undefined;
        }
        if (config[fieldName] !== undefined && config[fieldName] !== null) {
            return config[fieldName];
        }
        var key = Object.keys(config).find(function (k) {
            return k.toLowerCase() === fieldName.toLowerCase();
        });
        return key ? config[key] : undefined;
    }

    function attachRevealMetadata(option, revealUrl, secretFieldName) {
        if (!option || !option.controlType || option.controlType.toLowerCase() !== 'password') {
            return;
        }
        option.revealUrl = revealUrl || '';
        option.secretFieldName = secretFieldName || option.name || 'value';
    }

    function applyIntegrationRevealMetadata(app) {
        if (!app || !app.isCustom) {
            return;
        }
        var typeName = $scope.current.selectedType.name;
        var customApp = custom[typeName] && custom[typeName][app.name];
        if (!customApp || customApp.isInclusion || !customApp.endpoints) {
            return;
        }
        var revealUrl = buildRevealUrlFromReadEndpoint(customApp.endpoints.read);
        if (app.name === 'LaserApp' && revealUrl) {
            revealUrl += ($scope.current.selectedCustodian || '');
        }
        $scope.current.loadedOptions.forEach(function (opt) {
            attachRevealMetadata(opt, revealUrl, opt.name);
        });
    }

    function loadCustomInputs(options) {
        $scope.current.loadedOptions = [];

        var customApp = custom[$scope.current.selectedType.name][$scope.current.selectedApp.name];
        customApp.inputs.forEach(function (option) {
            var customOption = angular.copy(option);
            if (!customApp.isInclusion)
                customOption.value = getConfigField(options, option.name);
            loadCustomOptions(customOption);
            $scope.current.loadedOptions.push(customOption);
        });
        applyIntegrationRevealMetadata($scope.current.selectedApp);

        storeLoadedOptions($scope.current.selectedApp.name, "custom");
    };

    function callServerOptions(app) {
        var level = $scope.current.selectedType.name === "Database" ? "Advisor" : $scope.current.selectedType.name;
        var selected = loadedOptions.find(function (item) {
            return (item.appName === app.name) && (item.optionType === level);
        });
        return !selected;
    }

    function storeLoadedOptions(appName, appCode) {
        var level = $scope.current.selectedType.name === "Database" ? "Advisor" : $scope.current.selectedType.name;
        var load = {
            "appName": appName,
            "appCode": appCode,
            "optionType": level,
            "options": formatOptionValue(angular.copy($scope.current.loadedOptions)),
            "isDirty": false
        };

        var selected = loadedOptions.find(function (item) {
            return (item.appName === load.appName) && (item.optionType === load.optionType);
        });

        if (selected) {
            selected.options = load.options;
        } else {
            loadedOptions.push(load);
        }
    }

    function formatOptionValue(options) {
        options.each(function (item) {
            if (typeof (item.value) !== 'string' && item.value !== null && item.value !== undefined) {
                item.value = item.value.toString();
            }
        });
        return options;
    }

    function convertToType(options) {
        options.each(function (item) {
            if (item.controlType === 'boolean') {
                item.value = item.value === 'true';
            }
        });
        return options;
    }

    function loadCustomOptions(option) {
        if (option.controlType === "select") {
            var enums = $injector.get(option.options);
            option.options = [];
            enums.keys().forEach(function (key) {
                option.options.push(enums[key]);
            });
        }
    }

    function processOptions(options) {
        options.each(function (item) {
            switch (item.name) {
                case "altDataRvwDefView":
                    item.options = "altDataRvwDefViewChoices";
                    loadCustomOptions(item);
                    if (item.value === true || item.value === 'true' || item.value === '1') {
                        item.value = 'differencesOnly';
                    } else if (item.value === false || item.value === 'false' || item.value === '0') {
                        item.value = 'allRecords';
                    } else if (!item.value) {
                        item.value = 'differencesOnly';
                    }
                    break;
                case "dataqueries":
                    item.queries = [];
                    $http.post('/Reporting/Custom/Simple/List', item.value.split(','), { trackerMsg: ('Loading data for ' + item.displayName), allowCancellation: false  })
                        .then(function (response) {
                            response.data.each(function (query) {
                                query.name = query.title;
                            });
                            item.queries = response.data.sortBy(function (n) {
                                return n.id;
                            });
                        });
                    break;
                case "notifications":
                    $scope.verboseUser = null;
                    item.subscriptions = {};
                    loadNotificationSubscriptions()
                        .then(function (data) {
                            item.subscriptions = data;
                        });
                    break;
                default:
                    break;
            }
        });
    }

    function loadNotificationSubscriptions() {
        return $http.get("/Authorization/User/Verbose?expand=personal", { trackerMsg: 'Loading authentication settings', allowCancellation: false  })
            .then(function (response) {
                $scope.verboseUser = response.data;
                return $http.get("/Reporting/Fuse/Notifications/Subscriptions", { trackerMsg: 'Loading notification subscriptions', allowCancellation: false  });
            })
            .then(function (response) {
                let subscriptions = checkCompliancePrivileges(response.data)
                return subscriptions.sortBy("categoryName").groupBy("categoryName");
            });
    }

    function checkCompliancePrivileges(subscriptions) {
        let rightsCompliance = $oasRights.forCode("COMPASSAUDIT");
        let rightsSupervise = $oasRights.forCode("COMPLIANCESUPERVISE");
        let rightsDisclose = $oasRights.forCode("COMPLIANCEDISCLOSE");
        let rightsInform = $oasRights.forCode("COMPASSINFORM");

        for (let i = subscriptions.length - 1; i >= 0; i--) {
            if (subscriptions[i].categoryName === 'Compliance') {
                switch (subscriptions[i].notificationName) {
                    case 'Compliance Inform':
                    case 'Compliance Inform Privilege Granted':
                    case 'New Compliance Inform Access Granted':
                        if (!rightsInform.canRead) {
                            subscriptions.splice(i, 1);
                        }
                        break;
                    case 'Compliance Disclose':
                        if (!rightsDisclose.canRead) {
                            subscriptions.splice(i, 1);
                        }
                        break;
                    case 'Compliance Supervise':
                        if (!rightsSupervise.canRead) {
                            subscriptions.splice(i, 1);
                        }
                        break;
                    case 'Compliance Application':
                        if (!rightsCompliance.canRead) {
                            subscriptions.splice(i, 1);
                        }
                    default: break;
                }
            }
        }
        return subscriptions;
    }

    function processQueriesToValues(item) {
        var queryIds = '';

        item.queries.sortBy("id").each(function (query, qIndex) {
            if (qIndex > 0) {
                queryIds += ',';
            }
            queryIds += query.id;
        });

        if (item.value.trim() != queryIds.trim()) {
            item.value = queryIds;
        }
    }

    function formatNumberSet(set) {
        var temp = set.split(',');
        var numbers = [];
        temp.each(function (n) {
            numbers.push(n.toNumber());
        });
        return numbers.sort(function (a, b) {
            return a - b;
        }).join();
    }

    function removeExtendedData(option) {
        switch (option.controlType.toLocaleLowerCase()) {
            case "dataqueries":
                delete option.queries;
                break;
            case "notifications":
                delete option.subscriptions;
                break;
        }
    }

    function updateTypes(options) {
        options.each(function (item) {
            switch (item.controlType) {
                case "boolean":
                    item.value = (item.value.toLocaleLowerCase() == "true");
                    break;
                default:
                    break;
            }
        });
    }

    function resetSelectedApps() {
        $scope.apps.forEach(function (app) {
            app.selected = false;
        });
    }

    function refreshAppList() {
        $scope.current.loadedApps = [];
        if ($scope.current.selectedType.isCustom) {
            for (var app in custom[$scope.current.selectedType.name]) {
                if (!args.filteredAppCode || app.camelize(false) === args.filteredAppCode) {
                    $scope.current.loadedApps.push({
                        "name": app,
                        "imageName": custom[$scope.current.selectedType.name][app].image,
                        "isCustom": true,
                        "selected": false,
                        "description": custom[$scope.current.selectedType.name][app].description,
                        "disclaimer": custom[$scope.current.selectedType.name][app].disclaimer
                    });
                }
            }
            $scope.current.selectedApp = null;
        } else if ($scope.current.selectedType.name != 'User') {
            $scope.current.loadedApps = args.filteredAppCode ? $scope.apps.findAll({ appCode: args.filteredAppCode }) : $scope.apps;
        } else {
            custom.User.Apps.forEach(function (userApp) {
                if (!args.filteredAppCode || app.appCode === args.filteredAppCode) {
                    userApp.selected = false;
                    $scope.current.loadedApps.push(userApp);
                }
            });

            $scope.apps.forEach(function (app) {
                if ((!args.filteredAppCode || app.appCode === args.filteredAppCode) && app.userOptionCount > 0) {
                    $scope.current.loadedApps.push(app);
                }
            });
        }
    }

    function isEditable(option) {
        return $scope.current.selectedType.name != 'User' || option.canUserOverride === true;
    }

    function validate() {
        return loadedOptions.any({ isDirty: true });
    }

    function isDirtyService() {
        loadedServices.each(function (serviceItem) {
            var selected = loadedOptions.find(function (item) {
                return (item.appName === serviceItem.appName) && (item.optionType === serviceItem.type);
            });
            var service = $injector.get(serviceItem.serviceName);
            selected.isDirty = service.isDirty;
        });
    }

    function showHideForm(isBaseCase, message, changeMessage) {
        var form = document.getElementById('q_form');
        var app = document.getElementById('completeReg');

        if (isBaseCase && form !== undefined && app !== undefined) {
            form.classList.remove('hideByDefault');
        }
        else if (form !== undefined && app !== undefined) {
            form.classList.remove('registrationComplete');
            form.classList.add('formSubmitted');
            app.classList.remove('formSubmitted');
            app.classList.add('registrationComplete');

            if (changeMessage) {
                var text = document.getElementById('textMessage');
                text.innerText = message;
            }
        }
    }

    //PUBLIC METHODS

    $scope.selectSettingType = function (index) {
        if ($scope.current.types[index].selected) return;
        $scope.current.types.each(function (type, i) {
            if (i === index) {
                type.selected = true;
                $scope.current.selectedType = type;
            } else {
                type.selected = false;
            }
        });
        resetSelectedApps();
        refreshAppList();
        $scope.selectSettingApp(0);
    };

    $scope.showDescription = function (sub) {
        $dialog.messageBox(sub.notificationName, sub.notificationDescription).open();
    };

    $scope.checkEnabled = function (sub) {
        if (!sub.enabled) {
            sub.email = false;
        }
    };

    $scope.openProfile = function () {
        $dialog.dialog({ templateUrl: "app/modals/profile.html", controller: "ProfileCtrl", tab: 'authentication' }).open()
            .then(function (result) {
                if (result && !angular.equals(result.personal.email, $scope.verboseUser.personal.email))
                    $scope.verboseUser.personal.email = result.personal.email;
            });
    };

    $scope.save = async function () {
        $http.post("/Trading/QUODD/update", $scope.qPricingSetup, { cache: false, trackerMsg: 'Saving User Data Now' }).then(function (response) {
            if (response.data == false) {
                $dialog.messageBox('Warning', 'User creation has failed, please contact the SME team for further assistance.').open();
            }
            else {
                $scope.signAgreement();
            }
        });
    };

    $scope.signAgreement = async function () {
        $http.get("/Trading/QUODD/signAgreement", { cache: false, allowCancellation: false  }).then(function (response) {
            if (response.data.canSign === true) {
                var signingUrl = 'https://vor.quodd.com/app/v2/agreements/index.html#/?token=' + encodeURIComponent(response.data.token);
                setTimeout(function () { window.open(signingUrl, '_blank'); }, 7000);
                $dialog.messageBox('Info',
                    'Redirecting to the signing page in 7 seconds. If you are not redirected, click Open Signing Page to continue.' +
                    '</br></br>Please note that you are now leaving the Orion website and/or platform and are being connected to the website of QUODD Financial Information Services (&quot;QUODD&quot;). ' +
                    'Orion is not responsible for the information, content, documentation, agreement(s), or the product(s) found on the QUODD website or via QUODD, or for actions taken by QUODD. ' +
                    'To discontinue your integration with QUODD, notify Orion to disable such integration.',
                    [{ result: 'open', label: 'Open Signing Page', cssClass: 'oat-btn-primary', focus: true }]
                ).open().then(function (result) {
                    if (result === 'open') {
                        window.open(signingUrl, '_blank');
                    }
                });
                showHideForm(false, 'Awaiting Quodd Integration Approval.', true);
            }
            else if (response.data.canSign === false && response.data.hasAlreadySigned === true) {
                showHideForm(false, "Quodd Real Time Price Approved.", true);
            }
            else {
                $dialog.messageBox('Warning', 'Signing process has failed, please contact the SME team for further assistance.').open();
            }
        });
    }

    $scope.selectSettingApp = function (index) {
        if ($scope.current.loadedApps.length > 0 && $scope.current.loadedApps[index].selected) return;

        if ($scope.current.loadedApps.length === 0) {
            $scope.current.loadedOptions = [];
            return;
        }
        newAppLoaded = true;

        /*if($scope.current.selectedApp)
         storeLoadedOptions($scope.current.selectedApp.name, $scope.current.selectedApp.appCode);*/

        $scope.current.loadedApps.each(function (app, i) {
            app.selected = i === index;
        });

        if ($scope.current.loadedApps[index]) {
            if (!hasInclusion($scope.current.loadedApps[index])) {
                loadOptions($scope.current.loadedApps[index]);
            } else {
                $scope.current.selectedApp = $scope.current.loadedApps[index];
                loadInclusionService();
                loadCustomInputs();
                if (loadedServices.length > 0) {
                    dirtyServiceTimer = $interval(isDirtyService, 500);
                }
            }
        }
    };

    $scope.saveChanges = function () {
        var loadPromises = [];
        var updates = [];

        storeLoadedOptions($scope.current.selectedApp.name, $scope.current.selectedApp.appCode);

        var dirtyApps = loadedOptions.findAll(function (n) {
            return n.isDirty;
        });

        dirtyApps.each(function (appOptions) {
            var url = (appOptions.appCode === "custom") ? (custom[appOptions.optionType][appOptions.appName].isInclusion ? custom[appOptions.optionType][appOptions.appName].service : custom[appOptions.optionType][appOptions.appName].endpoints.update) : "/Settings/Apps/{appCode}/Options/{optionName}?level={level}";

            if (appOptions.appName == 'LaserApp Configuration') {
                url += $scope.current.selectedCustodian;
            }

            if (appOptions.appCode === "custom") {
                var options = {};
                appOptions.options.each(function (option) {
                    options[option.name] = option.value;
                });
                if (custom[appOptions.optionType][appOptions.appName].isInclusion) {
                    var service = $injector.get(url);
                    loadPromises.add(service.save());
                } else {
                    loadPromises.push($http.put(url, options, { trackerMsg: ('Saving settings for ' + appOptions.appName) }));
                }
                updates.push(appOptions.appName);
                appOptions.isDirty = false;
            } else if (appOptions.appName === 'Notifications' && appOptions.optionType === "User") {
                appOptions.options.each(function (option) {
                    var subscriptions = [];
                    Object.keys(option.subscriptions).each(function (key) {
                        subscriptions.push(option.subscriptions[key]);
                    });
                    loadPromises.push($http({ method: 'PUT', url: "/Reporting/Fuse/Notifications/Subscriptions", data: subscriptions.flatten(), trackerMsg: 'Saving notification subscriptions' }));
                });
            }
            else {
                appOptions.options.each(function (option) {
                    if (isEditable(option)) {
                        removeExtendedData(option);
                        var level = appOptions.optionType === "Database" ? "Advisor" : appOptions.optionType;
                        var method = option.value === null || option.value.trim() === "" ? 'DELETE' : 'PUT';

                        loadPromises.push($http({
                            method: method,
                            url: url.assign({ appCode: appOptions.appCode, optionName: option.name, level: level }),
                            data: option,

                            trackerMsg: ('Saving settings for ' + option.displayName)
                        }));
                        updates.push(appOptions.appCode);
                        appOptions.isDirty = false;
                    }
                });
            }
        });

        if (loadPromises.length > 0) {
            $q.all(loadPromises).then(function () {
                $interval.cancel(dirtyServiceTimer);
                dialog.close(updates);
            });
        }
    };

    $scope.checkOptionLoad = function () {
        return function (option) {
            return isEditable(option);
        };
    };

    $scope.upload = function (uploadType) {
        $dialog.dialog({ dialogClass: "modal wide", templateUrl: 'advisor/modals/manage-downloads.html', controller: 'ManageDownloadsCtrl', uploadType: uploadType }).open();
    };

    $scope.close = function (checkIfDirty) {
        if (checkIfDirty) {
            if (validate()) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                $interval.cancel(dirtyServiceTimer);
                dialog.close(null);
            }
        } else {
            $interval.cancel(dirtyServiceTimer);
            dialog.close(null);
        }
    };

    $scope.levelSettingChange = function () {
        //force reset of LaserApp settings; with custodial ID
        loadedOptions.remove({ appName: 'LaserApp Configuration' });

        custom.Integrations['LaserApp Configuration'].inputs.forEach(function (item) {
            if (item.disableOnCustodian) {
                item.disabled = !!$scope.current.selectedCustodian;
            }
        });

        loadOptions($scope.current.selectedApp)
    };

    //WATCHES
    $scope.$watch("current.loadedOptions", function (newVal, oldVal) {
        if (newVal === oldVal || !newVal || newVal.length != oldVal.length || newAppLoaded) {
            newAppLoaded = false;
            return;
        }
        for (var i = 0; i < newVal.length; i++) {
            if (newVal[i].queries) {
                processQueriesToValues(newVal[i]);
                oldVal[i].value = formatNumberSet(oldVal[i].value);
                newVal[i].value = formatNumberSet(newVal[i].value);
            }
            if (newVal[i].subscriptions && Object.keys(oldVal[i].subscriptions).length > 0 && !angular.equals(newVal[i].subscriptions, oldVal[i].subscriptions)) {
                var level = $scope.current.selectedType.name === "Database" ? "Advisor" : $scope.current.selectedType.name;
                var selected = loadedOptions.find(function (item) {
                    return (item.appName === $scope.current.selectedApp.name) && (item.optionType === level);
                });
                selected.isDirty = true;
            }
            else if (newVal[i].value != oldVal[i].value) {
                switch (newVal[i].controlType.toLocaleLowerCase()) {
                    case "date":
                        newVal[i].value = Date.create(newVal[i].value).formatted(false);
                        break;
                    case "datetime":
                        newVal[i].value = Date.create(newVal[i].value).formatted(true);
                        break;
                }
                var level = $scope.current.selectedType.name === "Database" ? "Advisor" : $scope.current.selectedType.name;
                var selected = loadedOptions.find(function (item) {
                    return (item.appName === $scope.current.selectedApp.name) && (item.optionType === level);
                });
                selected.isDirty = true;
                break;
            }
        }
    }, true);

    //INITIALIZE
    $scope.current = { loadedApps: [], types: types, selectedType: {}, loadedOptions: [], selectedApp: null, selectedCustodian: null, orderBy: 'displayName' };
    $scope.qPricingSetup = {};
    $scope.apps = [];
    $scope.errors = [];
    $scope.rightsDownload = $oasRights.forCode("RMDDASHBOARDAPP");

    $scope.rightsNotifications = $oasRights.forCode("NOTIFICATIONS");

    initialize();
});


function VestorlyCtrl($scope, $vestorly) {

    $scope.signIn = function () {
        $vestorly.signIn($scope.user)
            .then(function (response) {
                if (response) {
                    $scope.current.errorMsg = response;
                }
                if ($vestorly.vestorlyData.authToken) {
                    $scope.current.errorMsg = null;
                    $scope.vestorlyData = $vestorly.vestorlyData;
                    getGroups($scope.vestorlyData.authToken);
                }
            });
    };

    $scope.signOut = function () {
        $vestorly.vestorlyData.authToken = null;
    };

    function getGroups(authToken) {
        $vestorly.getGroups(authToken)
            .then(function (response) {
                $scope.current.groups = response;
                if (response.message) {
                    $scope.current.errorMsg = response;
                }
                if (!$scope.vestorlyData.groupId) {
                    $scope.vestorlyData.groupId = response[0].id;
                }
            });
    }

    function init() {
        $vestorly.getUserInfo()
            .then(function () {
                if ($vestorly.vestorlyData.authToken) {
                    $scope.vestorlyData = $vestorly.vestorlyData;
                    getGroups($scope.vestorlyData.authToken);
                }
            });
    }

    $scope.limits = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 16, 18, 20];

    $scope.user = {username: '', password: ''};
    $scope.userInfo = {advisorId: null, authToken: null};
    $scope.current = {limit: 12, groups: [], selectedGroupId: null, errorMsg: null};
    $scope.vestorlyData = {id: null, apiUrl: null, advisorId: null, authToken: null, groupId: null, limit: 12};

    init();
}

app.controller('VestorlyCtrl', VestorlyCtrl);


app.service('$vestorly', ['$http', '$q', 'API_CONFIG', function ($http, $q, API_CONFIG) {
    var self = this;
    var internals = {id: null, vestorlyData: {apiUrl: '', advisorId: null, authToken: null, groupId: null, limit: 0}, errorMsg: ''};
    var userInfo = {advisorId: null, authToken: null, group: null, limit: null};
    var originalVestorly;
    var groups = {};

    var init = function () {
        internals = {id: 0, vestorlyData: {apiUrl: 'https://test.vestorly.com', advisorId: '', authToken: null, groupId: '', limit: 0}, errorMsg: ''};
    };

    init();

    self.vestorlyData = internals.vestorlyData;

    self.signIn = function (user) {
        var signInUrl = API_CONFIG.vestorlyApiUrl + '/session_management/sign_in?api_key=20b343a618f48f4319fe2a69a5e4661e5e2e2f88199c3850a2edc8f77a06d10a';
        return $http.post(signInUrl, user, {headers: {Authorization: undefined}, ignoreExceptions: [401], ignoreAuthModule: true, trackerMsg: 'Loading Vestorly data'})
            .then(function (response) {
                internals.vestorlyData.apiUrl = response.data.theme['api_url_ssl'];
                internals.vestorlyData.siteUrl = response.data.theme['site_url'];
                internals.vestorlyData.siteUrl = internals.vestorlyData.siteUrl.replace('http', 'https');
                internals.vestorlyData.advisorId = response.data.user['_slugs'][0];
                internals.vestorlyData.authToken = response.data['vestorly-auth'];
            }, function (response) {
                if (response.status == 401) {
                    return response.data.message;
                }
            });
    };

    self.getGroups = function (token) {
        var groupsUrl = API_CONFIG.vestorlyApiUrl + '/v2/groups?api_key=20b343a618f48f4319fe2a69a5e4661e5e2e2f88199c3850a2edc8f77a06d10a';

        return $http.get(groupsUrl, {headers: {Authorization: undefined, 'x-vestorly-auth': token}, ignoreExceptions: [401, 403], ignoreAuthModule: true, trackerMsg: 'Loading groups'})
            .then(function (respnse) {
                return respnse.data.groups.map(function (item) {
                    return {id: item["_id"], name: item.name}
                });
            }, function (response) {
                if (response.status == 403 || 401) {
                    return response.data.message;
                }
            })
    };

    self.save = function () {
        var promises = [];
        var saveData = {
            id: internals.id,
            integrationInfo: JSON.stringify(internals.vestorlyData),
            Level: 'Firm'
        };

        promises.push($http.put('/Integrations/Configuration/VESTORLY_INTEGRATION/Firm', saveData, {trackerMsg: 'Updating LaserApp paperwork assignment'}));
        return promises;
    };

    self.cacheChanges = function () {
        //vestorlyData.isDirty = true;
    };
    self.getUserInfo = function () {
        //Get authorization token, if one exists; otherwise force signin
        return $http.get('/Integrations/Configuration/VESTORLY_INTEGRATION/Firm', {trackerMsg: 'Getting Vestorly settings'})
            .then(function (response) {
                angular.extend(internals.vestorlyData, JSON.parse(response.data.integrationInfo));
                internals.id = response.data.id;
                originalVestorly = angular.copy(internals.vestorlyData);
            });
    };

    self.isDirty = function () {
        return !angular.equals(internals.vestorlyData, originalVestorly);
    };
}]);
function SchwabCtrl($scope, $compile, $element) {
    var template = '<orion-schwab-redirect></orion-schwab-redirect>';
    var linkFn = $compile(template);
    var content = linkFn($scope);
    $element.append(content);
}
app.controller('SchwabCtrl', SchwabCtrl);

function ArchAngularCtrl($scope, $compile, $element) {
    var template = '<orion-arch-integration></orion-arch-integration>';
    var linkFn = $compile(template);
    var content = linkFn($scope);
    $element.append(content);
}

app.controller('ArchAngularCtrl', ArchAngularCtrl);

function RaymondJamesAngularCtrl($scope, $compile, $element) {
    var template = '<orion-raymond-james-integration></orion-raymond-james-integration>';
    var linkFn = $compile(template);
    var content = linkFn($scope);
    $element.append(content);
}

app.controller('RaymondJamesAngularCtrl', RaymondJamesAngularCtrl);

'use strict';

app.directive('autoZoom', function autoZoom($window, $timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var threshold = parseInt(attrs.autoZoom);

            //PRIVATE METHODS
            function setZoom() {
                var leftSidebarWidth = scope.leftSidebar.exists && scope.leftSidebar.isOpen ? 250 : 0;
                var rightSidebarWidth = scope.rightSidebar.exists && scope.rightSidebar.isOpen ? scope.rightSidebar.width : 0;
                var windowWidth = $window.innerWidth - leftSidebarWidth - rightSidebarWidth;

                var scale = windowWidth >= threshold ? 1 : (windowWidth / threshold);

                element.css("zoom", (scale * 100) + "%");
                element.css("-moz-transform", "scale(" + scale + ")");
            }


            //INITIALIZE
            angular.element($window).bind('resize', setZoom);
            $timeout(setZoom, 0);


            //SCOPE WATCHERS
            scope.$watch("leftSidebar.isOpen", function (newValue, oldValue) {
                if (newValue === oldValue) return;
                setZoom();
            });

            scope.$watch("rightSidebar.isOpen", function (newValue, oldValue) {
                if (newValue === oldValue) return;
                setZoom();
            });
        }
    };
});

app.directive('autoSize', ['$window', function($window){
    return {
        restrict: 'C',
        link: function($scope, $element, $attrs){

            /**
             * Default settings
             */
            $scope.attrs = {
                rows: 1,
                maxLines: 999
            };

            /**
             * Merge defaults with user preferences
             */
            for(var i in $scope.attrs){
                if($attrs[i]){
                    $scope.attrs[i] = parseInt($attrs[i]);
                }
            }

            /**
             * Calculates the vertical padding of the element
             * @returns {number}
             */
            $scope.getOffset = function(){
                var style = $window.getComputedStyle($element[0], null),
                    props = ['paddingTop', 'paddingBottom'],
                    offset = 0;

                for(var i=0; i<props.length; i++){
                    offset += parseInt(style[props[i]]);
                }

                return style.boxSizing === 'border-box' ? 0 : offset;
            };

            /**
             * Sets textarea height as exact height of content
             * @returns {boolean}
             */
            $scope.autosizeFn = function(){
                $element[0].style.height = 0; // autoshrink - need accurate scrollHeight



                var newHeight = 0, hasGrown = false;
                if(($element[0].scrollHeight - $scope.offset) > $scope.maxAllowedHeight){
                    $element[0].style.overflowY = 'scroll';
                    newHeight = $scope.maxAllowedHeight;
                }
                else {
                    $element[0].style.overflowY = 'hidden';
                    $element[0].style.height = 'auto';
                    newHeight = $element[0].scrollHeight - $scope.offset;
                    hasGrown = true;
                }
                $element[0].style.height = newHeight + 'px';
                return hasGrown;
            };

            $scope.offset = $scope.getOffset();
            $scope.lineHeight = ($element[0].scrollHeight / $scope.attrs.rows) - ($scope.offset / $scope.attrs.rows);
            $scope.maxAllowedHeight = ($scope.lineHeight * $scope.attrs.maxLines) - $scope.offset;

            $scope.$watch($attrs.ngModel, $scope.autosizeFn);
            /**
             * Auto-resize when there's content on page load
             */
            if($element[0].value != ''){
                $scope.autosizeFn();
            }
        }
    }
}]);
'use strict';

app.directive('availableSelected', function availableSelected($http, $timeout) {
    var idProperty = "id";
    return {
        restrict: 'E',
        scope:{
            selectedEntity:'=',
            selItems:'=',
            enableTitles: '@',
            filter: '=?',
            id : '@?',
            name: '@?',
            items : '=?',
            isUsed: '=?',
            addBlank: '=?',
            excluded: '='
        },
        replace: true,
        template:   '<div class="clearfix">' +
            '<div class="as-list-container">' +
            '<h5>Available {{ ::selectionTypeName.capitalize(true) }} <button class="btn btn-link" ng-click="current.showFilterAvailable = !current.showFilterAvailable" data-test-id="btnAvailableItemsFilter" title="Toggle Available Filter"><i class="fa fa-filter" aria-hidden="true"></i></button><button ng-if="selectedEntity==\'1005\'" class="btn btn-small pull-right" ng-click="showUSStates()">US Only</button></h5>' +
            '<div ng-show="current.showFilterAvailable" style="margin-bottom:5px;"><i class="fa fa-search" style="position:absolute;margin-top:7px;margin-left:7px;"></i><input title="Items Available Filter" type="text" style="padding-left:28px;" ng-model="current.filterAvailable" ng-model-options="{updateOn: \'default\'}" data-test-id="txtFilterSearch"></div>' +
            '<select title="Available Multi Select" class="input-block-level" size="14" multiple="multiple" ng-dblclick="moveSome(availableSelected, availableItems, selectedItems)"  ng-model="availableSelected" ng-options="item.name for item in availableItems | filter:{name:current.filterAvailable}" style="width:100%;" data-test-id="selectAvailableItemsList"></select>' +
            '</div>' +
            '<div class="as-button-container">' +
            '<div class="btn-group btn-group-vertical">' +
            '<button class="btn" ng-disabled="availableItems.length == 0 || availableSelected.length == 0" title="Move highlighted to Selected {{ ::selectionTypeName.capitalize(true) }}" ng-click="moveSome(availableSelected, availableItems, selectedItems)" data-test-id="btnMoveSelectedRight"><i class="fa fa-angle-right" style="padding: 0 2px 0 1px;"></i></button>' +
            '<button class="btn" ng-disabled="availableItems.length == 0" ng-click="moveAll(availableItems, selectedItems, availableSelected)" title="Move all to Selected" data-test-id="btnMoveAllSelectedRight"><i class="fa fa-angle-double-right" aria-hidden="true"></i></button>' +
            '<button class="btn" ng-disabled="selectedItems.length == 0 || selected.length == 0" ng-click="moveSome(selected, selectedItems, availableItems)" title="Move highlighted to Available" data-test-id="btnMoveSelectedLeft"><i class="fa fa-angle-left" style="padding: 0 1px 0 2px;"></i></button>' +
            '<button class="btn" ng-disabled="selectedItems.length == 0" ng-click="moveAll(selectedItems, availableItems, selected)" data-test-id="btnMoveAllSelectedLeft"><i class="fa fa-angle-double-left" title="Move all to Available"></i></button>' +
            '</div>' +
            '</div>' +
            '<div class="as-list-container">' +
            '<h5>Selected {{ ::selectionTypeName.capitalize(true) }} <button class="btn btn-link" ng-click="current.showFilterSelected = !current.showFilterSelected"><i class="fa fa-filter" aria-hidden="true" data-test-id="btnShowFilterSelected" title="Toggle Selected Filter"></i></button></h5>' +
            '<div ng-show="current.showFilterSelected" style="margin-bottom:5px;"><i class="fa fa-search" style="position:absolute;margin-top:7px;margin-left:7px;"></i><input title="Items Selected Filter" type="text" style="padding-left:28px;" ng-model="current.filterSelected" ng-model-options="{updateOn: \'default\'}" data-test-id="txtFilterSelected"></div>' +
            '<select title="Selected Multi Select" class="input-block-level" ng-attr-size="{{sortable ? 12 : 14}}" ng-dblclick="moveSome(selected, selectedItems, availableItems)" multiple="multiple" ng-model="selected" ng-options="item.name for item in selectedItems | filter:{name:current.filterSelected}" style="width:100%;" data-test-id="selectListOfSelectedItems"></select>' +
            '<div class="btn-group" style="width:100%; margin-top: 5px;" ng-show="sortable">' +
            '<button class="btn" ng-click="moveUp()" title="Move Up" ng-disabled="selectedItems.length == 0 || selected.length == 0" style="width:50%" data-test-id="btnMoveUp"><i class="fa fa-chevron-up" aria-hidden="true"></i></button>' +
            '<button class="btn" ng-click="moveDown()" title="Move Down" ng-disabled="selectedItems.length == 0 || selected.length == 0" style="width:50%" data-test-id="btnMoveDown"><i class="fa fa-chevron-down" aria-hidden="true"></i></button>' +
            '</div>' +
            '</div>' +
            '</div>',
        link: function (scope, element, attrs) {

            scope.sortable = attrs.sortable ? scope.$eval(attrs.sortable) : false;
            scope.preSelected = [];
            scope.selectionTypeName = "";
            scope.availableItems = [];
            scope.availableSelected = [];
            scope.selectedItems = [];
            scope.tempAvailableItems = null;

            setAccountSelection(scope.selectedEntity, scope);

            if (attrs.selectionTypeName) scope.selectionTypeName = attrs.selectionTypeName;

            scope.moveUp = function() {
                var from = scope.selectedItems.indexOf(scope.selected[0]);
                var to = from - 1;
                arrayMove(scope.selectedItems,from,to);
                scope.selItems = scope.selectedItems;
                scope.$emit("event:selectlist-change", {action: 'move-up'});
            };

            scope.moveDown = function() {
                var from = scope.selectedItems.indexOf(scope.selected[0]);
                var to = from + 1;
                arrayMove(scope.selectedItems,from,to);
                scope.selItems = scope.selectedItems;
                scope.$emit("event:selectlist-change", {action: 'move-down'});
            };

            scope.showUSStates = function(){
                setAccountSelection(1006, scope);
            };


            scope.$watch("selectedEntity", function(newValue, oldValue){
                if (newValue != oldValue){
                    if (typeof scope.selItems != 'undefined'){
                        scope.preSelected = scope.selItems;
                    }

                    setAccountSelection(parseInt(newValue), scope);
                }
            });

            scope.$watch("filter", function(newValue, oldValue){
                if (scope.tempAvailableItems && newValue != oldValue){
                    scope.availableItems = scope.tempAvailableItems;

                    if (newValue != 'All'){
                        scope.availableItems = scope.availableItems.findAll(function(user) { return user.entity == newValue; })
                    }
                }
            });

            scope.$watch("selItems", function(newValue, oldValue){
                if (newValue != oldValue){
                    scope.preSelected = newValue;
                    loadPreselected(scope);
                    //scope.availableSelected  = newValue;
                }
            });

            scope.$watch("items", function(newValue, oldValue){
                if (!newValue) return;
                if (newValue != oldValue || scope.availableItems.length === 0){
                    if (newValue === oldValue && (scope.availableItems.length > 0)) return;

                    scope.availableItems = newValue;

                    if (scope.name){
                        scope.availableItems.each(function(n){
                            n["name"] = n[scope.name];
                        });
                    }

                    scope.availableItems.sortBy(function (item){ return item.name; });
                    loadPreselected(scope);
                }
            });

            scope.$watchCollection("[availableItems,current.filterAvailable]", function(newValue, oldValue){
                if(newValue != oldValue) {
                    $timeout(function(){
                        if(scope.enableTitles && scope.enableTitles == "true"){
                            angular.forEach(angular.element("select[ng-model='availableSelected'] option"), function(option){
                                var title = angular.element(option).text();
                                angular.element(option).attr("title", title);
                            });
                        }
                    },500,false);
                }
            });

            scope.$watchCollection("selectedItems", function(newValue, oldValue){
                if(newValue != oldValue) {
                    $timeout(function(){
                        if(scope.enableTitles && scope.enableTitles == "true"){
                            angular.forEach(angular.element("select[ng-model='selected'] option"), function(option){
                                var title = angular.element(option).text();
                                angular.element(option).attr("title", title);
                            });
                        }
                    },500,false);
                }
            });

            scope.moveSome = function(selectedItems, from, to) {
                angular.forEach(selectedItems, function(item) {
                    var index = from.indexOf(item);
                    if (index !== -1) {
                        from.splice(index, 1);
                        to.push(item);
                    }
                });

                scope.selItems = scope.selectedItems;
                scope.$emit("event:selectlist-change", {action: 'move-some'});
            };

            scope.moveAll = function(from, to) {
                angular.forEach(from, function(item) {
                    to.push(item);
                });
                from.length = 0;

                scope.selItems = scope.selectedItems;
                scope.$emit("event:selectlist-change", {action: 'move-all'});
            };
        }
    };

    function lookupCall(type, scope, lookUp, recursive, skip, take) {
        var url = lookUp.url;

        if (scope.isUsed){
            url += "?isUsed=true";
        }

        if(recursive)
            url += ("&$skip=" + skip + "&$top=" + take);

        $http.get(url, {cache: lookUp.entity !== "DataQuery", trackerMsg: 'Loading ' + lookUp.name})
            .then(function (response) {
                var data = response.data;
                if(lookUp.entity === "DataQuery") {
                    data.each(function(n){
                        n.name = n.title;
                    });
                }
                if(lookUp.entity === "Databases") {
                    data.each(function(n){
                        n.name = n.clientName;
                    });
                }
                if(lookUp.entity === "Users") {
                    data.each(function(n){
                        n.name = n.entity + " - " + n.entityName;
                    });
                }

                if (lookUp.entity === "Indexes" && scope.excluded) {
                    data = data.filter(d => scope.excluded.type !== d.type);
                }

                if (lookUp.entity === "Currency") {
                    data.each(function (n) {
                        n.id = n.id.toString();
                    });
                }

                scope.availableItems = recursive ? scope.availableItems.concat(data) : data;

                if (scope.addBlank){
                    scope.availableItems.unshift({name: '<Blank>', id: 0});
                }
                if (scope.tempAvailableItems === null) scope.tempAvailableItems = scope.availableItems;

                if(recursive && data.length === take) {
                    lookupCall(type, scope, lookUp, recursive, (skip + take), take);
                }
                else {
                    scope.selectedItems = [];
                    loadPreselected(scope);
                }
            });
    }

    function loadPreselected (scope) {
        if( scope.preSelected && scope.preSelected.length > 0 ) {
            if (scope.id) idProperty = scope.id;

            scope.preSelected.forEach(function(selectedItem) {
                if( selectedItem ) {
                    var availableItemIndex = scope.availableItems.findIndex(function(item) {return item[idProperty] === selectedItem[idProperty];});
                    if (availableItemIndex !== -1) {
                        angular.extend(selectedItem, scope.availableItems[availableItemIndex]);
                        scope.availableItems.splice(availableItemIndex, 1);
                    }
                }
            });

            scope.selectedItems = scope.preSelected;
        }
    }

    function arrayMove(arrayVar, from, to) {
        arrayVar.splice(to, 0, arrayVar.splice(from, 1)[0]);
    }

    function setAccountSelection(type, scope) {
        if ([4, 12, 16, 18, 27, 35, 58, 74, 997, 998, 999, 1000, 1001, 1002, 1003, 1004, 1005, 1006, 1979, 1980, 1981].none(type)) return;

        var selectionTypeLookUp = {
            4: {name: "reps", url: "/Portfolio/Representatives/Simple", entity: "Rep"},
            12: {name: "fund families", url: "/Portfolio/FundFamilies/Simple", entity: "FundFamily"},
            16: {name: "platforms", url: "/Portfolio/Platforms/Simple", entity: "Platform"},
            18: {name: "custodians ", url: "/Portfolio/Custodians/Simple?includeMasterAccountNumber=true", entity: "Custodian"},
            27: {name: "models ", url: "/Trading/Models/Simple", entity: "Model"},
            35: {name: "indexes", url:"/Portfolio/Benchmarks/Simple", entity:"Indexes", idProperty: "key"},
            58: {name: "plans", url: "/Portfolio/Plans/Simple", entity: "Plans"},
            74: {name: "models", url: "/Trading/ModelAggs/Simple", entity: "AggregateModel"},
            997: {name: "risk tolerances", url: "/Reporting/Composite/Ranges/Simple/RiskToleranceRange", entity: "RiskTolerance"},
            998: {name: "stock ranges", url: "/Reporting/Composite/Ranges/Simple/StockRange", entity: "StockRange"},
            999: {name: "risk budgets", url: "/Reporting/Composite/Ranges/Simple/RiskBudgetRange", entity: "RiskBudget"},
            1000: {name: "data queries", url: "/Reporting/Custom/Simple?reportType=Query&$orderby=Name", entity: "DataQuery"},
            1001: {name: "record types", url: "/Confirm/RecordTypes/Simple?", entity: "RecordType"},
            1002: {name: "download formats", url: "/Confirm/DownloadFormats/Simple", entity: "DownloadFormat"},
            1003: {name: "databases", url: "/Security/Databases", entity: "Databases"},
            1004: {name: "users", url: "/Security/Profiles", entity: "Users"},
            1005: {name: "states", url: "/Portfolio/States/Simple", entity: "states"},
            1006: {name: "us states", url: "/Portfolio/States/Simple?domesticOnly=true", entity: "UsStates"},
            1979: {name: "custom", url: null, entity: "Custom"},
            1980: {name: "custodians", url: "/Global/Custodians/Simple", entity: "Custodian"},
            1981: {name: "currencies", url: "/Portfolio/Locale/Simple", entity: "Currency"}
        };

        var lookUp = selectionTypeLookUp[type];
        if (!lookUp) throw "Invalid entity type passed to available-selected: " + type;

        idProperty = lookUp.idProperty ? lookUp.idProperty : "id";

        scope.selectionTypeName = lookUp.name;

        if (scope.selItems.length > 0 && scope.preSelected.length === 0)
            scope.preSelected = scope.selItems;

        scope.availableItems = [];

        if( lookUp.entity == 'DataQuery' ) {
            lookupCall(type, scope, lookUp, true, 0, 1000);
        }
        else if (lookUp.entity === 'Custom'){
            scope.selectionTypeName = "";
            return;
        }
        else {
            lookupCall(type, scope, lookUp);
        }

    }

});

'use strict';

app.directive('clientPortalSsoLink', function clientPortalSsoLink($oasRights, API_CONFIG, clientPortalLauncherService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            householdId: '=',
        },
        template: '<li ng-show="showLink && householdId"><a ng-click="launch($event)"><img src="_img/main-menu/client-portal2.png" class="app-icon-small"/> Client Portal</a></li>',
        link: function (scope) {
            scope.showLink = $oasRights.canRead("CLIENTPORTAL");
            scope.baseUrl = API_CONFIG.baseUrl;
            scope.token = sessionStorage.oas_token;
            scope.launch = function ($event){
                $event.preventDefault();
                clientPortalLauncherService.launchModal( scope.householdId )
            }

        }
    };
});
'use strict';

app.directive('advizrSsoLink', function advizrSsoLink($oasRights, API_CONFIG) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            householdId: '='
        },
        template: '<li ng-show="showLink && householdId"><a target="_blank" href="{{ ::baseUrl }}/Integrations/Advizr/Action/SAML?Authorization={{ ::token }}&HouseholdId={{ householdId }}"><img src="_img/main-menu/financial-planning.png" class="app-icon-small"/> Orion Planning </a></li>',
        link: function (scope) {
            scope.showLink = $oasRights.canRead("ADVIZR");
            scope.baseUrl = API_CONFIG.baseUrl;
            scope.token = sessionStorage.oas_token;
        }
    };
});
'use strict';

app.directive('ngClick', function (dataTestIdGenerator) {
    return {
        restrict: 'A',
        replace: false,
        link: function (scope, element, attrs) {
            const idPrefix = 'btn';
            const namingFn = function (element, attrs) {
                const elementText = attrs.ariaLabel || attrs.title || element.text();
                return elementText ? elementText.trim().camelize() : attrs.ngClick.titleize();
            };

            dataTestIdGenerator.generate(element, attrs, idPrefix, namingFn);
        }
    };
});

app.directive('a', function (dataTestIdGenerator) {
    return {
        restrict: 'E',
        replace: false,
        link: function (scope, element, attrs) {
            if (attrs.ngClick) {
                //it's already being handled by directive above
                return;
            }

            const idPrefix = 'link';
            const namingFn = function (element, attrs) {
                const elementText = attrs.ariaLabel || attrs.title || element.text();
                return elementText ? elementText.trim().camelize() : (attrs.href || 'FixMyUnknownName').titleize();
            };

            dataTestIdGenerator.generate(element, attrs, idPrefix, namingFn);
        }
    };
});

app.directive('ngModel', function (dataTestIdGenerator) {
    return {
        restrict: 'A',
        replace: false,
        link: function (scope, element, attrs) {
            const idPrefix = 'input';
            const namingFn = function (element, attrs) {
                const elementText = attrs.ariaLabel || attrs.title;
                return elementText ? elementText.trim().camelize() : attrs.ngModel.replace(/\./g, ' ').titleize();
            };

            dataTestIdGenerator.generate(element, attrs, idPrefix, namingFn);
        }
    };
});

app.directive('slickGrid', function (dataTestIdGenerator) {
    return {
        restrict: 'E',
        replace: false,
        link: function (scope, element, attrs) {
            const idPrefix = 'grid';
            const namingFn = function (element, attrs) {
                const elementText = attrs.ariaLabel || attrs.title;
                return elementText ? elementText.trim().camelize() : 'SlickGridContainer';
            };

            dataTestIdGenerator.generate(element, attrs, idPrefix, namingFn);
        }
    };
});

app.directive('contextMenu', function (dataTestIdGenerator) {
    return {
        restrict: 'C',
        replace: false,
        link: function (scope, element, attrs) {
            const idPrefix = 'menu';
            const namingFn = function (element, attrs) {
                const elementText = attrs.ariaLabel || attrs.title;
                return elementText ? elementText.trim().camelize() : 'SlickGridContextMenu';
            };

            dataTestIdGenerator.generate(element, attrs, idPrefix, namingFn);
        }
    };
});

app.service('dataTestIdGenerator', function (elementFinder) {
    const self = this;

    // PRIVATE METHODS
    function setDebugProps(element, title, borderColor) {
        const debugMode = false;
        if (!debugMode) {
            return;
        }

        element.css('border', `1px solid ${borderColor}`);
        element.attr('title', title);
    }

    // PUBLIC METHODS
    self.generate = function (element, attrs, idPrefix, namingFn) {
        if (attrs.id || attrs.testId) {
            setDebugProps(element, attrs.id || attrs.testId, 'red');
            return;
        }

        setTimeout(function () {
            const location = elementFinder.find(element[0]);
            const name = namingFn(element, attrs);

            if (!name) {
                setDebugProps(element,'Unable To Generate ID', 'yellow');
                return;
            }

            const dataTestId = `${idPrefix}-${location}-${elementFinder.removeSpacesAndLineBreaks(name)}`;

            setDebugProps(element, dataTestId, 'green');

            element.attr('data-test-id', dataTestId);
        }, 10);
    };
});

var dualListBox = function() {
    return {
        scope: {
            unselectedItems: '=',
            selectedItems: '=',
            disabled: '=?'
        },
        restrict: 'E',
        controller: 'dualListBoxCtrl',
        controllerAs: 'ctrl',
        replace: true,
        templateUrl: 'app/directives/dualListBox/dualListBox.html'
    };
};
app.directive('dualListBox', dualListBox);
var dualListBoxCtrl = function($scope) {
    var self = this;
    $scope.disabled = $scope.disabled || false;

    self.tempSelected = [];
    self.moveSome = function(tempSelected, from, to) {
        tempSelected.forEach(function(item) {
            from.splice(from.findIndex(item), 1);
            to.push(item);
        });
    };

    self.moveRight = function() {
        $scope.unselectedItems.splice(0, $scope.unselectedItems.length).forEach(function(item) { $scope.selectedItems.push(item) });
    };

    self.moveLeft = function() {
        $scope.selectedItems.splice(0, $scope.selectedItems.length).forEach(function(item) { $scope.unselectedItems.push(item) });
    };
};
dualListBoxCtrl.$inject = ['$scope'];
app.controller('dualListBoxCtrl', dualListBoxCtrl);

"use strict";

/**
 *  Would have loved to have used a state machine here instead of manually managing the navigation.
 */


/**
 * This is a constructor for steps in a multi step form.
 *
 * To use this, inject it into controllers or services and call new on it to create a new step object.
 *
 * Name is used in the multi step form as a header on the step. TemplateUrl is the contents of the form for that step.
 * Params is an object that allows clients to pass additional information down to the loaded template. See the example.
 *
 * @example <caption>Returns a step object with the provided name.</caption>
 * // in link or controller
 * scope.steps.push(new multiStepFormStep({name: 'TOS', templateUrl: 'some/path/to/tosForm.html', params: {param1: {}, param2: {}}))
 * 
 * // some/path/to/tosForm.html
 * <div>
 *      <my-directive param1="multiStepCtrl.currentStep.params.param1" param2="multiStepCtrl.currentStep.params.param2"></my-directive>
 * </div>
 * @constructor
 * @param {object} options
 */
var multiStepFormStep = function (options) {
    if(options == null) {
        throw new Error('Provided argument cannot be null');
    }
    if(options.name == null) {
        throw new Error('"name" is a required field.');
    }
    if(options.templateUrl == null) {
        throw new Error('"templateUrl" is a required field.');
    }
    if(typeof options.name !== 'string') {
        throw new Error('"name" must be of type string');
    }
    if(typeof options.templateUrl !== 'string') {
        throw new Error('"templateUrl" must of type string');
    }

    // required
    this.name = options.name;
    this.templateUrl = options.templateUrl;

    // optionals
    if(options.params != null) {
        if(typeof options.params !== 'object') {
            throw new Error('Optional parameter "params" must be an object.');
        }
        this.params = options.params;
    }
    this.onNext = function() { return true; };
    if(options.onNext != null) {
        if(typeof options.onNext !== 'function') {
            throw new Error('Optional parameter "onNext" must be a function.');
        }
        this.onNext = options.onNext;
    }
    this.onBack = function() { return true; };
    if(options.onBack != null) {
        if(typeof options.onBack !== 'function') {
            throw new Error('Optional parameter "onBack" must be a function');
        } else {
            this.onBack = options.onBack;
        }
    }
    this.onValidation = function() { return true; };
    if(options.onValidation != null) {
        if(typeof options.onValidation !== 'function') {
            throw new Error('Optional parameter "onValidation" must be a function');
        } else {
            this.onValidation = options.onValidation;
        }
    }
    this.onSave = function() { return true; };
    if(options.onSave != null) {
        if(typeof options.onSave !== 'function') {
            throw new Error('Optional parameter "onSave" must be a function');
        } else {
            this.onSave = options.onSave;
        }
    }

    // observable state
    this.executing = false;
    this.isValid = true;
    this.hasVisited = false;
};
app.value('MultiStepFormStep', multiStepFormStep);

/**
 * Convenience events that the calling code can use in onNext, onValidate, onSubmit code.
 * 
 * Useful if you need to observe the event in multiple children scopes.
 */
var multiStepFormEvents = {
    'validate': 'msf.validate',
    'next': 'msf.next',
    'save': 'msf.save',
    'submit': 'msf.submit'
};
app.constant('MultiStepFormEvents', multiStepFormEvents);

var multiStepFormCtrl = function($scope, $log, $q) {
    var self = this;
    $scope.stepsPromise.then(function(steps) {
        $scope.steps = steps;
        if(!!$scope.step || $scope.steps.length === 0) {
            $scope.showNoStepsMessage = true;
        } else {
            self.currentStep = $scope.steps[0];
            self.currentIndex = 0;
            self.submittingForm = false;
        }
        $scope.isLoadingView = false;
    });

    
    /**
     * Submit the form, runs the onValidation calling the onSave callbacks provided to the directive.
     */
    self.submit = function() {
        var currentStep = self.currentStep;
        if(currentStep.executing || self.submittingForm) {
            return;
        }
        self.submittingForm = true;
        
        $q.all($scope.steps.map(function(step) {
            return $q.when(step.onValidation(step.params));
        })).then(function(results) {
            // TODO: Set the step's isValid flag to false somewhere
            // TODO: Fixed reducer to account for promise instead of boolean
            var check = function(accumulator, currentValue) {
                return accumulator && currentValue;
            };
            var isValid = results.reduce(check, true);
            if(!isValid) {
                var error = new Error('');
                $log.warn('Validation of the multi step form failed.', error);
                return $q.reject(error);
            }
            $log.info('Calling onSave for all of the steps.');
            return $q.all($scope.steps.map(function(step) {
                return $q.when(step.onSave($scope.$broadcast.bind($scope)));
                })).then(function(results) {
                    $log.info('All steps succeeded in saving.');
                    var onSubmit = $scope.onSubmit();

                    if(typeof onSubmit !== 'function') {
                        throw Error("On submit is not a function. The type was " + typeof onSubmit);
                    }
                    $log.info('Calling this form\'s onSubmit.');
                    return $q.when(onSubmit()).then(function(result) {
                        $log.info('Saving the form was successful.');
                    }).catch(function(error) {
                        $log.error('There was an issue saving the form: ', error);
                        self.submittingForm = false;
                    });
                }).catch(function(error) {
                    $log.error('There was an issue saving the form: ', error);
                    return $q.reject(error);
                });
        }).catch(function(error) {
            $log.error('There was an issue saving the form: ', error);
        }).finally(function() {
            $log.info('Submission finished.');
            self.submittingForm = false;
        });
    };

    /**
     * Jump to the next step in the form. Runs onValidation for the step, if it is enabled.
     */
    self.next = function() {
        var currentStep = self.currentStep;
        if(self.currentStep.executing) {
            return;
        }
        currentStep.executing = true;

        var validationCb = currentStep.onValidation;
        var validationPromise = $q.when(true);
        if(validationCb != null) {
            $log.info('Validating step ' + (self.currentIndex + 1));
            validationPromise = $q.when(validationCb(currentStep.params)).then(function(result) {
                var actualResult = !!result;
                $log.info('Validation returned ' + actualResult + ' for the step ' + (self.currentIndex + 1));
                currentStep.isValid = actualResult;
                if(actualResult) {
                    currentStep.hasVisited = false;
                }
                $log.info('Current step: ', currentStep);
                return actualResult;
            }).catch(function(error) {
                $log.error('There was an error validating the form for step ' + (self.currentIndex + 1));
                return false;
            });
        }
        validationPromise.then(function(result) {
            currentStep.isValid = result;
            if(result) {
                $log.info('Navigating to next step', currentStep, self.currentIndex);
                if(currentStep.onNext == null) {
                    return self.jumpTo(self.currentIndex + 1).finally(function() {
                        currentStep.executing = false;
                    });
                } else {
                    return $q.when(currentStep.onNext())
                        .then(function() {
                            return self.jumpTo(self.currentIndex + 1);
                        }).catch(function(error) {
                            $log.error('There was an issue proceeding to the next step in the form: ', error);
                        }).finally(function() {
                            currentStep.executing = false;
                            $log.debug('No longer executing.');
                        });
                }
            } else {
                currentStep.executing = false;
            }
        });
    };

    self.back = function() {
        var currentStep = self.currentStep;
        if(currentStep.executing) {
            return;
        }
        currentStep.executing = true;
        $log.info('Navigating to previous step', currentStep, self.currentIndex);
        if($scope.steps[self.currentIndex - 1].onBack == null) {
            return self.jumpTo(self.currentIndex - 1).finally(function(){
                currentStep.executing = false;
            });
        } else {
            return $q.when($scope.steps[self.currentIndex - 1].onBack())
                .then(function() {
                    return self.jumpTo(self.currentIndex - 1);
                }).catch(function(error) {
                    $log.error('There was an issue proceeding to the previous step in the form: ', error);
                }).finally(function() {
                    currentStep.executing = false;
                });
        }
    };

    self.jumpTo = function(index) {
        if(index < 0 || index >= $scope.steps.length) {
            throw Error("Failure to jump to step due to index out of bounds. Parameter = {0}. Length = {1}".format(index, $scope.steps.length));
        }
        var direction = 1;
        if(index < self.currentIndex) {
            direction = -1;
        }
        return $scope.scrollHeader(direction).then(function() {
            self.currentStep = $scope.steps[index];
            self.currentStep.hasVisited = true;
            self.currentIndex = index;
            $log.info('Jumped into ', self.currentIndex);
        });
    };

    self.getCurrentTemplate = function() {
        if(self.currentStep) {
            return self.currentStep.templateUrl;
        }
        return undefined;
    }

    self.isFormInvalid = function() {
        for(var step in $scope.steps.values()) {
            if(!step.isValid) {
                $log.debug('Form has failed validation', step);
                return true;
            }
        }
        return false;
    }

    self.getTitle = function(stepIndex) {
        var title = '';
        if(stepIndex === self.currentIndex) {
            title = 'Current Step';
        } else if(stepIndex <= self.currentIndex) {
            title = 'Completed';
        } else {
            title = 'Upcoming Step';
        }
        return title;
    }

};
multiStepFormCtrl.$inject = ['$scope', '$log', '$q'];
app.controller('multiStepFormCtrl', multiStepFormCtrl);

var multiStepFormDirective = function($q) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/directives/multiStepForm/multiStepForm.html',
        controller: 'multiStepFormCtrl',
        controllerAs: 'multiStepCtrl',
        scope: {
            /**
             * A list of multi step form steps.
             *
             * @type {[MultiStepFormStep]}
             */
            stepsPromise: '=',

            /**
             * A function that the multi-step form will call for handling submission.
             *
             * @type {function}
             */
            onSubmit: '&',
        },
        link: function(scope, elem) {
            scope.showNoStepsMessage = false;
            scope.isLoadingView = true;
            scope.$on("$includeContentRequested", function() {
                scope.isLoadingView = true;
            });
            scope.$on("$includeContentLoaded", function() {
                scope.isLoadingView = false;
            });
            

            /**
             * Scrolls the header from the current position left.
             * 
             * If the amt is positive, scrolls the contents left.
             * If the amt is negative, scrolls the contents right.
             * @param {int} amt 
             */
            scope.scrollHeader = function(direction) {
                var defer = $q.defer();
                var header = elem.find('.wizard-header');
                var currentPosition = header.scrollLeft();
                var amt = getScrollDistance();
                if(direction < 0) {
                    amt *= -1;
                }
                header.animate({
                    scrollLeft: currentPosition + amt
                }, {
                    duration: 300,
                    queue: true,
                    complete: function() {
                        defer.resolve();
                    }
                });
    
                function getScrollDistance() {
                    var active = header.children().find('li.active');
                    var outerWidth = active.outerWidth(true);
                    var totalWidth = outerWidth;
                    return totalWidth;
                }
                return defer.promise;
            };
        }
    };
};
multiStepFormDirective.$inject = ['$q'];
app.directive('multiStepForm', multiStepFormDirective);
'use strict';

app.directive('disableAnimation', function ($animate) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            attrs.$observe('disableAnimation', function (value) {
                $animate.enabled(!value, element);
            });
        }
    }
});
'use strict';

app.directive('entityTreeSelector', function entityTreeSelector($http, entities) {
    return {
        restrict: 'E',
        scope: {
            values: '=',
            hideReset: '=',
            searchBy: '@',
            showCaretOnly: '=?'
        },
        replace: true,
        template:   '<div>' +
            '<oas-search ng-if="!values.searchEntity" entity="{{ searchBy }}" selected="values.searchEntity"></oas-search>' +
            '<div ng-if="values.searchEntity" dropdown class="dropdown">' +
            '<button ng-if="!showCaretOnly" class="btn btn-block" title="Portfolio Tree" dropdown-toggle><i class="{{ values.selectedEntity.icon }}"></i> {{ values.selectedEntity.name }} <b class="caret"></b></button>' +
            '<button ng-if="showCaretOnly" class="btn btn-link" title="Portfolio Tree" dropdown-toggle><i style="color:#666;" class="fa fa-caret-down fa-2x" aria-hidden="true"></i></button>' +
            '<div class="dropdown-menu" ng-class="{\'pull-right\': !showCaretOnly}" style="max-height: 200px; max-width: 395px; overflow: auto;">' +
            '<button class="btn btn-mini btn-link" ng-click="resetSearch()" ng-hide="hideReset" style="margin-left:15px;">Reset Search</button>' +
            '<div angular-treeview="true" tree-id="values" current-node="selectedEntity" tree-model="values.items" node-label="name" style="margin-right:10px;"></div>' +
            '<div ng-if="values.message" class="add-top-margin"><em>{{ values.message }}</em></div>' +
            '</div>' +
            '</div>' +
            '</div>',
        link: function (scope, element, attrs) {
            //PUBLIC METHODS
            scope.resetSearch = function() {
                scope.values.searchEntity = null;
                //the other value fields will be cleared out automatically in the $watch below
            };


            //INTIALIZE
            if (!angular.isObject(scope.values)) {
                scope.values = {searchEntity: null, selectedEntity: null, items: []};
            }


            //SCOPE WATCHERS
            scope.$watch("values.searchEntity", function (newValue, oldValue) {
                if (newValue === oldValue && scope.values.selectedEntity) {
                    return;
                }

                if (!newValue) {
                    scope.values.selectedEntity = null;
                    return;
                }

                let requestUrl = "/Portfolio/Clients/PortfolioTree?entity=" + scope.searchBy + "&entityId=" + newValue.id + "&skipInceptionDate=true";
                $http.get(requestUrl, {trackerMsg: 'Loading portfolio tree'})
                    .then(function (response) {
                        var data = response.data;
                        if(scope.searchBy === "portfolio group") {scope.searchBy = "portfolioGroup"};
                        var toggleSelected = function (node) {
                            node.selected = entities[scope.searchBy].value === node.type && node.id === newValue.id;
                            if (node.selected) {
                                scope.values.selectedEntity = node;
                            }
                        };

                        var tree = [];
                        tree.push({id: data.id, name: data.name, type: entities.client.value, icon: "fa fa-orion-household", collapsed: false, children: []});
                        toggleSelected(tree[0]);

                        data.registrations.forEach(function (registration) {
                            var node = {id: registration.id, name: registration.name, type: entities.registration.value, icon: "fa fa-orion-registration", collapsed: false, children: []};
                            toggleSelected(node);

                            registration.accounts.forEach(function (account) {
                                var childNode = {id: account.id, name: account.name, type: entities.account.value, icon: "fa fa-orion-account", collapsed: false};
                                toggleSelected(childNode);
                                node.children.push(childNode);
                            });

                            tree[0].children.push(node);
                        });

                        scope.values.items = tree;
                        scope.values.message = data.message;
                    });
            });
        }
    };
});

'use strict';

app.directive('fileUploader', function($upload, $rootScope, $injector, $q) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            returnData: '=',
            returnStatus: '=?',
            fileByteLimit: '=?',
            additionalData: '=?',
            postUrl: '@',
            fileName: '=?',
            tokenOverride: '=?',
            databaseOverride: '=?',
            allowMultiple: '=?',
            onDataUploaded: '&',
            fileTooLarge: '&',
            method: '=?',
            acceptedAttribute: '@',
        },
        template: `
            <div ng-file-drop="onFileSelect($files)" ng-file-drag-over-class="dragover" class="file-drop-target" data-test-id="file-draganddrop-target" aria-label="Drag and Drop upload file here.">
                <div ng-show="returnData" ng-repeat="filelist in returnData">
                    <i ng-click="deletefile()" class="fa fa-remove" style="cursor:pointer"></i>
                    {{ filelist.name }}
                </div>
                <span ng-hide="fileIsUploading"><i class="fa fa-fw fa-arrow-circle-o-up" style="color: #0078D4; font-size: 24px"></i></span>
                <span ng-hide="fileIsUploading" class="file-drop-message">Drag and drop {{ ::allowMultiple ? \'files\' : \'file\' }} here</span>
                <span ng-hide="fileIsUploading" class="file-drop-or">OR</span>
                <span ng-show="fileIsUploading"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Validating {{ ::allowMultiple ? \'files\' : \'file\' }}...</span>
                
                <div class="btn btn-primary">
                    <i class="fa fa-plus" style="padding-right: 8px"></i>
                    <span>Browse files</span>
                    <input ng-if="allowMultiple" multiple type="file" ng-file-select="onFileSelect($files)" data-test-id="multiple-file-upload-button" accept="{{acceptedAttribute}}" title="Browse Files" aria-label="Select File(s)" />
                    <input ng-if="!allowMultiple" type="file" ng-file-select="onFileSelect($files)" data-test-id="single-file-upload-button" accept="{{acceptedAttribute}}" title="Browse Files" aria-label="Select File" />
                </div>
            </div>`,
        link: function(scope, element, attrs) {

            //PRIVATE VARIABLES
            var isConvertToBase64 = scope.postUrl && scope.postUrl.length > 0 && scope.postUrl.toLowerCase() === '/utility/filetobase64';
            var tokenToUse = !scope.tokenOverride ? sessionStorage.oas_token : scope.tokenOverride;
            var file = null;
            var files = null;

            scope.deletefile = function() {
                scope.returnData = null;
            };

            //PUBLIC METHODS
            scope.onFileSelect = function($files) {
                file = $files[0];
                files = scope.allowMultiple ? $files : null;

                scope.fileName = files ? files.map('name') : file.name;

                if (isConvertToBase64 && window.File) {
                    convertFileToBase64();
                } else if (scope.postUrl && scope.postUrl.length > 0) {
                    uploadFile(scope.postUrl);
                } else {
                    scope.returnData = $files;
                }
            };


            //ANGULAR EVENT REGISTRATION
            if (attrs.uploadEvents) {
                var events = attrs.uploadEvents.split(',');
                var performAction = function(args) {
                    switch (args.action) {
                        case 'upload-file':
                            uploadFile(args.url);
                            break;
                        default:
                            alert('Invalid action passed to upload event!');
                    }
                };

                events.forEach(function(eventName) {
                    scope.$on(eventName, function(e, args) {
                        if (args.prompt) {
                            $dialog.confirmAction(args.prompt)
                                .open()
                                .then(function(result) {
                                    if (result === 'yes') {
                                        performAction(args);
                                    }
                                });
                        } else
                            performAction(args);
                    });
                });

            }


            // PRIVATE METHODS
            function convertFileToBase64() {
                var reader = new FileReader();
                reader.onload = function(e) {
                    scope.$apply(function() {
                        if(e.loaded > scope.fileByteLimit){
                            scope.fileTooLarge();
                            return;
                        }

                        scope.returnData = e.target.result;
                    });
                };
                reader.readAsDataURL(file);
            }

            function uploadFile(url) {
                scope.fileIsUploading = true;

                (scope.databaseOverride > 0 && scope.databaseOverride != $rootScope.user.authorization.alClientId
                        ? $injector.get('tokenFactory').getDatabaseToken(scope.databaseOverride)
                        : $q.resolve(tokenToUse)
                ).then(function(token) {
                    var config = {
                        url: url,
                        data: scope.additionalData,
                        method: scope.method || 'POST',
                        headers: { Authorization: 'Session ' + token },
                    };

                    if (scope.allowMultiple) {
                        config.file = files;
                        config.fileFormDataName = files.map(function(item, i) {
                            return 'files[' + i + ']';
                        });
                    } else {
                        if(scope.fileByteLimit && file.length > scope.fileByteLimit) {
                            scope.fileTooLarge();
                            return;
                        }
                        config.file = file;
                    }

                    $upload.upload(config).then(function(response) {
                        scope.fileIsUploading = false;
                        scope.returnData = response.data;
                        scope.returnStatus = response.status;
                        scope.onDataUploaded({ response: response });
                    });
                });

            }

        },
    };
});

'use strict';

app.directive('heightAsPercentOfWidth', function heightAsPercentOfWidth($window, $timeout) {
    return {
        restrict: 'A',
        //scope: { heightAsPercentOfWidth: '@' },
        link: function (scope, element, attrs) {
            function setHeight() { element.css("min-height", element.width() * parseInt(attrs.heightAsPercentOfWidth) / 100); }

            angular.element($window).on('resize', function () { setHeight(); });

            element.css({ overflow: 'hidden' });
            $timeout(setHeight, 0);

//            scope.$watch("attrs.heightAsPercentOfWidth", function (newValue, oldValue) {
//                if (newValue === oldValue) return;
//                setHeight();
//            });
        }
    };
});

//app.directive('heightAsPercentOfWidth', function heightAsPercentOfWidth($window) {
//    return {
//        restrict: 'A',
//        scope: { heightAsPercentOfWidth: '=' },
//        link: function (scope, element, attrs) {
//            function setHeight() {
//                element.css("min-height", element.width() * (scope.heightAsPercentOfWidth / 100));
//                console.log(scope.heightAsPercentOfWidth);
//            }
//
//            angular.element($window).bind('resize', function() { setHeight() });
//
//            element.css({ overflow: 'hidden' });
//            setHeight();
//
//            scope.$watch("heightAsPercentOfWidth", function (newValue, oldValue) {
//                if (newValue === oldValue) return;
//                setHeight();
//            });
//        }
//    };
//});

app.directive('autoHeight', function autoHeight($window, $timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            function setHeight() {
                element.height(function () {
                    var offset = attrs.autoHeightOffset ? parseInt(attrs.autoHeightOffset) : 0;

                    return $window.innerHeight - element.position().top - offset;
                });
            }

            angular.element($window).on('resize', setHeight);

            $timeout(setHeight, 300);
            element.css("overflow", "auto");

            scope.$on('$destroy', function cleanUpAutoHeight() {
                angular.element($window).off('resize', setHeight);
            });
        }
    };
});

app.directive('autoWidth', function ($window, $timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            function setWidth() {
                element.width(function () {
                    var scalingFactor = attrs.scalingFactor ? parseInt(attrs.scalingFactor) / 100 : 1;

                    return $window.innerWidth * scalingFactor;
                });
            }

            angular.element($window).on('resize', setWidth);

            $timeout(setWidth, 300);

            scope.$on('$destroy', function cleanUpAutoWidth() {
                angular.element($window).off('resize', setWidth);
            });
        }
    };

});

'use strict';

app.directive('iframeResizer', function iframeResizer() {
    return {
        scope:{
            resizeOptions: "=?"
        },
        link: function (scope, element, attrs) {
            var options = scope.resizeOptions ? scope.resizeOptions : {
                enablePublicMethods: true
            };
            setTimeout(function () {
                iFrameResize(options, '#' + attrs.id);
            }, 10);
        }
    };
});

'use strict';

app.value('listSectionData', {
    dataItems: []
});

app.directive('listSection', function listSection($http, $rebalance, listSectionData){
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/directives/listSection.html',
        scope: {config: '=', filterPaneOpen: '=', options: '='},
        link: function(scope){
            //PRIVATE VARIABLES
            var fullList, filteredList, filterFn;
            var count = 0;


            //PRIVATE METHODS
            function loadItems() {
                if (scope.config.addItemEvent) {
                    scope.$on(scope.config.addItemEvent, function(e, args) {
                        addItem(args);
                    });
                }

                if (scope.config.rebalanceItemEvent) {
                    scope.$on(scope.config.rebalanceItemEvent, function() {
                        rebalanceSelected();
                    });
                }

                if (scope.config.loadDataItemsEvent) {
                    scope.$on(scope.config.loadDataItemsEvent, function() {
                        getDataItems(listSectionData.dataItems);
                    });
                }

                if (scope.config.getUrl) {
                    $http.get(scope.config.getUrl, {trackerMsg: 'Loading ' + scope.config.listName.toLowerCase()})
                        .then(function (response) {
                            getDataItems(scope.config.dataProperty ? response.data[scope.config.dataProperty] : response.data);
                        });
                }
                else {
                    getDataItems(listSectionData.dataItems);
                }

            }

            function getDataItems(dataItems){
                fullList = dataItems;
                filteredList = fullList;
                scope.sortItems();
                resetPagination();
            }

            function addItem(newItem) {
                fullList.push(newItem);
                resetPagination();
            }

            function resetPagination() {
                scope.current.totalItems = filteredList.length;
                scope.setPageItems();
            }

            function buildFilterFn(filterFields) {
                var filterString = "(function(item, value) {return ";
                filterFields.forEach(function (field) {
                    filterString += "(item." + field + " && item." + field + ".toString().toLowerCase().indexOf(value) !== -1) || ";
                });
                filterString = filterString.to(filterString.length - 4) + ";})";
                return eval(filterString);
            }

            function rebalanceSelected() {
                var selectedIds = fullList.findAll({selected: true}).map(scope.current.selectId);
                $rebalance.start(6, selectedIds);
            }


            //PUBLIC METHODS
            scope.selectItem = function(item) {
                if (scope.config.selectEnabled) {
                    if (!scope.config.multiSelectEnabled) {
                        fullList.forEach(function(listItem) {listItem.selected = false;});
                    }
                    item.selected = !item.selected;
                    item.selected ? count++ : count--;

                    var selectedIds = fullList.findAll({selected: true});
                    var unSelectedIds = fullList.findAll({selected: false});
                    scope.$emit("selectedCount",selectedIds);
                    scope.$emit("unSelectedCount",unSelectedIds);
                }
            };

            scope.itemAction = function(item, action) {
                scope.$emit("item-action", {item: item, action: action});
            };

            scope.setPageItems = function(page) {
                page = page || scope.current.page;

                var begin = (page - 1) * scope.current.itemsPerPage;
                var end = begin + scope.current.itemsPerPage;

                scope.pageItems = filteredList.slice(begin, end);
            };

            scope.filterItems = function() {
                var value = scope.current.filterValue.toLowerCase();
                filteredList = value ? fullList.filter(function(item) {return filterFn(item, value);}) : fullList;

                resetPagination();
                scope.current.page = 1;
            };

            scope.sortItems = function() {
                var field = scope.current.sort;
                if (scope.current.sortAsc)
                    filteredList.sort(function(a, b) {return a[field] > b[field] ? 1 : b[field] > a[field] ? -1 : 0;});
                else
                    filteredList.sort(function(a, b) {return a[field] < b[field] ? 1 : b[field] < a[field] ? -1 : 0;});

                scope.setPageItems();
            };

            scope.toggleSortAsc = function() {
                scope.current.sortAsc = !scope.current.sortAsc;
                scope.sortItems();
            };

            scope.toggleFilter = function(showFilter){
                scope.current.showFilter = !showFilter;
            };

            scope.deleteItem = function (itemToRemove) {
                fullList.splice(fullList.indexOf(itemToRemove), 1);
                resetPagination();
            };


            //INITIALIZE
            scope.current = {headerTemplate: scope.config.headerTemplate, template: scope.config.template, filterValue: null, sortFields: scope.config.sortFields, sort: (scope.config.fieldToSort === undefined ? 'name' : scope.config.fieldToSort), sortAsc: (scope.config.sortAsc === undefined ? true : scope.config.sortAsc), showFilter: false, page: 1, pageSizes: [10, 50, 100], itemsPerPage: (scope.config.itemsPerPage ? scope.config.itemsPerPage : 100), totalItems: 0, numPages: 0, listName: scope.config.listName, additionalLinks: scope.config.additionalLinks, selectId: scope.config.selectProperty, rights : scope.config.rights };
            filterFn = angular.isFunction(scope.config.listFilter) ? scope.config.listFilter : buildFilterFn(scope.config.listFilter);
            loadItems();
        }
    };

});

'use strict';

app.directive('mainContent', function mainContent() {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template: '<div class="content" ng-style="{marginLeft: getMargin(\'left\'), marginRight: getMargin(\'right\')}">' +
            '<alert ng-repeat="alert in user.alerts" type="::alert.type" close="removeUserAlert(alert)" ' + 'class="alert-block no-bottom-margin">' +
                '<div>' +
                   '<i ng-class="{\'fas fa-exclamation-triangle\': alert.type === \'warning\', \'fa fa-times-octagon \': alert.type === \'error\'}"></i>&nbsp;' +
                '<span ng-bind-html="::alert.msg"></span></div> ' +
            '</alert>' +
            '<div ng-transclude></div></div>',
        link: function (scope) {
            scope.getMargin = function (side, padding) {
                if (!scope[side + 'Sidebar'] || !scope[side + 'Sidebar'].exists || !scope[side + 'Sidebar'].isOpen || side === 'left') {
                    return '0';
                }

                if (!padding) {
                    padding = 0;
                }

                return scope[side + 'Sidebar'].width + padding + 'px';
            };

            scope.removeUserAlert = function (alert) {
                scope.user.alerts.remove(alert);
            };
        }
    };
});
'use strict';

app.directive('moneyGuideProSsoLink', function moneyGuideProSsoLink($oasRights) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            householdId: '='
        },
        template: '<li ng-show="showLink && householdId"><a target="_blank" href="/api/v1/Integrations/MoneyGuidePro/SSO/AccessPlan/{{householdId}}?Authorization={{::token}}"><img src="_img/main-menu/mgp.png" class="app-icon-small"/> MoneyGuide</a></li>',
        link: function (scope) {
            scope.showLink = $oasRights.canRead("MONEYGUIDEPRO");
            scope.token = sessionStorage.oas_token;
            scope.subdomain = window.location.host.has("local") || window.location.host.has("test") ? {orion: "testapi", mgp: "qa"} : {orion: "api", mgp: "www"};
        }
    };
});



'use strict';

app.directive('ataRiskStationSsoLink', function ataRiskStationSsoLink($oasRights) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            householdId: '='
        },
        template: '<li ng-show="showLink && householdId"><a target="_blank" href="https://{{subdomain}}.atariskstation.com/ExternalClient/Orion/?houseHoldId={{householdId}}&token={{::token}}"><img src="_img/main-menu/ataRiskStation.png" class="app-icon-small"/> ATA RiskStation</a></li>',
        link: function (scope) {
            scope.showLink = $oasRights.canRead("ATARISKSTATION");
            scope.token = sessionStorage.oas_token;
            scope.subdomain = window.location.host.has("local") || window.location.host.has("test") ? "devred" : "reporting";
        }
    };
});


'use strict';

app.directive('riskalyzeSsoLink', function riskalyzeSsoLink($oasRights, API_CONFIG) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            householdId: '='
        },
        template: '<li ng-show="showLink && householdId"><a target="_blank" href="{{::baseUrl}}/Integrations/RiskAlyze/Clients/ProposalRedirect?clientId={{householdId}}&Authorization={{::token}}"><img src="_img/main-menu/Nitrogen.png" class="app-icon-small"/> Nitrogen </a></li>',
        link: function (scope) {
            scope.showLink = $oasRights.canRead("RISKALYZEAPP");
            scope.token = sessionStorage.oas_token;
            scope.baseUrl = API_CONFIG.baseUrl;
        }
    };
});


'use strict';

app.directive('blackrockAnalyzerSsoLink', function blackrockAnalyzerSsoLink($oasRights) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            modelId: '='
        },
        template: '<li ng-show="showLink && modelId"><a target="_blank" rel="noopener" href="{{baseUrl}}/api/v1/Integrations/BlackRock/Analyzer/{{modelId}}?Authorization={{token}}&Token={{token}}"><img src="_img/main-menu/blackrock.png" class="app-icon-small"/> Blackrock Analyzer</a></li>',
        link: function (scope) {
            scope.showLink = $oasRights.canRead("MODELS");
            scope.token = sessionStorage.oas_token;
            scope.baseUrl = window.location.origin;
        }
    };
});



'use strict';

app.directive('fidelitySsoLink', function fidelitySsoLink($oasRights) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            accountNumber: '=',
            site: '=',
            right: '='
        },
        template: '<li class="dropdown-submenu" ng-show="showLink"><a target="_blank" href="/api/v1/Integrations/Fidelity/{{::site}}/SSO?Authorization={{::token}}"><img src="_img/fidelity.png" alt="Fidelity Icon" class="app-icon-small"/> {{::linkName}}</a>' +
                    '<ul class="dropdown-menu">' +
                        '<li><a target="_blank" href="/api/v1/Integrations/Fidelity/{{::site}}/SSO?relayState=balance&accountNumber={{accountNumber}}&Authorization={{::token}}">Balance</a></li>' +
                        '<li><a target="_blank" href="/api/v1/Integrations/Fidelity/{{::site}}/SSO?relayState=confirm&accountNumber={{accountNumber}}&Authorization={{::token}}">Confirms</a></li>' +
                        '<li><a target="_blank" href="/api/v1/Integrations/Fidelity/{{::site}}/SSO?relayState=cashiering&accountNumber={{accountNumber}}&Authorization={{::token}}">Integrated Cashiering Platform</a></li>' +
                        '<li><a target="_blank" href="/api/v1/Integrations/Fidelity/{{::site}}/SSO?relayState=positions&accountNumber={{accountNumber}}&Authorization={{::token}}">Positions</a></li>' +
                        '<li><a target="_blank" href="/api/v1/Integrations/Fidelity/{{::site}}/SSO?relayState=service&accountNumber={{accountNumber}}&Authorization={{::token}}">Service Center</a></li>' +
                        '<li><a target="_blank" href="/api/v1/Integrations/Fidelity/{{::site}}/SSO?relayState=serviceRequest&accountNumber={{accountNumber}}&Authorization={{::token}}">Service Request</a></li>' +
                        '<li><a target="_blank" href="/api/v1/Integrations/Fidelity/{{::site}}/SSO?relayState=statements&accountNumber={{accountNumber}}&Authorization={{::token}}">Statements</a></li>' +
                        '<li><a target="_blank" href="/api/v1/Integrations/Fidelity/{{::site}}/SSO?relayState=transactionHistory&accountNumber={{accountNumber}}&Authorization={{::token}}">Transaction History</a></li>' +                        
                  '</ul></li>',
        link: function (scope) {
            scope.showLink = $oasRights.canRead('FIDELITYINTEGRATION');
            scope.linkName = scope.site === 'Streetscape' ? 'Wealthscape NFS' : 'Wealthscape FBS';
            scope.token = sessionStorage.oas_token;
        }
    };
});
'use strict';

/**
 * PershingDeepLink enum values
 * 
 * IMPORTANT: Must be kept in sync with:
 * - Backend: Common\OAS.Integrations.Pershing\DTOs\PershingDeepLink.cs
 * - Angular: oc2src\integrations\dtos\sso-dtos\pershing-deep-link.enum.ts
 */
var PershingDeepLink = {
    None: 0,
    Alerts: 1,
    Balances: 2,
    AccountServices: 3,
    OrderStatus: 4,
    AccountSummary: 5,
    ReportCenter: 6
};

app.directive('pershingSsoLink', function pershingSsoLink() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            accountNumber: '=',
        },
        template: '<li class="dropdown-submenu"><a data-test-id="Pershing-Primary-Link" target="_blank" href="/api/v1/Integrations/Pershing/Action/SAML?Authorization={{::token}}"><img src="_img/BNY_Mellon.png" alt="Pershing Icon" class="app-icon-small"/> Open in NetX360</a>' +
                    '<ul class="dropdown-menu">' +
                        '<li><a data-test-id="Pershing-Alerts" target="_blank" href="/api/v1/Integrations/Pershing/Action/SAML?Deeplink=' + PershingDeepLink.Alerts + '&Authorization={{::token}}">Alerts</a></li>' +
                        '<li><a data-test-id="Pershing-Balances" target="_blank" href="/api/v1/Integrations/Pershing/Action/SAML?Deeplink=' + PershingDeepLink.Balances + '&accountNumber={{accountNumber}}&Authorization={{::token}}">Balances</a></li>' +
                        '<li><a data-test-id="Pershing-Account-Services" target="_blank" href="/api/v1/Integrations/Pershing/Action/SAML?Deeplink=' + PershingDeepLink.AccountServices + '&Authorization={{::token}}">Account Services</a></li>' +
                        '<li><a data-test-id="Pershing-Order-Status" target="_blank" href="/api/v1/Integrations/Pershing/Action/SAML?Deeplink=' + PershingDeepLink.OrderStatus + '&accountNumber={{accountNumber}}&Authorization={{::token}}">Order Status</a></li>' +
                        '<li><a data-test-id="Pershing-Account-Summary" target="_blank" href="/api/v1/Integrations/Pershing/Action/SAML?Deeplink=' + PershingDeepLink.AccountSummary + '&accountNumber={{accountNumber}}&Authorization={{::token}}">Account Summary</a></li>' +
                        '<li><a data-test-id="Pershing-Report-Center" target="_blank" href="/api/v1/Integrations/Pershing/Action/SAML?Deeplink=' + PershingDeepLink.ReportCenter + '&Authorization={{::token}}">Report Center</a></li>' +                       
                  '</ul></li>',
        link: function (scope) {
            scope.token = sessionStorage.oas_token;
        }
    };
});
'use strict';

app.directive('everplansSsoLink', function everplansSsoLink($oasRights, $http, $dialog) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            householdId: '='
        },
        template: '<li ng-show="showLink && householdId"><a ng-click="postMessage()"><img src="_img/main-menu/everplans.png" class="app-icon-small"/> Everplans</a></li>',
        link: function (scope) {
            scope.showLink = $oasRights.canRead("EVERPLANS");

            scope.postMessage = function () {
                $http.get("/Portfolio/Clients/" + scope.householdId)
                    .then(function (response) {
                        return response.data;
                    })
                    .then(function (client) {
                        return $http.post('https://my.everplans' + (window.location.host.has("local") || window.location.host.has("test") ? 'dev2' : '') + '.com/api/v1/integrations/orion/clients?token=' + sessionStorage.oas_token, {client_id: scope.householdId, email: client.email, first_name: client.firstName, last_name: client.lastName}, {ignoreExceptions: true, headers: {Authorization: undefined}, trackerMsg: 'Loading Everplans'})
                    })
                    .then(function (response) {
                        var template =
                            '<div class="modal-header">' +
                                '<h4><i class="fa fa-check-square fa-lg text-success" aria-hidden="true"></i> Complete</h4>' +
                            '</div>' +
                            '<div class="modal-body">' +
                                '<p>' + response.data.client.message + '</p>' +
                            '</div>' +
                            '<div class="modal-footer">' +
                                '<a class="btn btn-primary" ng-click="close()" href="' + response.data.client.link + '&token=' + sessionStorage.oas_token + '" target="_blank">Launch</a>' +
                            '</div>';

                        $dialog.dialog({template: template, controller: "MessageBoxController", resolve: {model: function () {return {};}}}).open();
                    }, function (response) {
                        $dialog.actionFailed(response.data ? response.data.message : "Unable to connect to Everplans").open();
                    });
            };
        }
    };
});

'use strict';

app.directive('hiddenLeversSsoLink', function hiddenLeversSsoLink($oasRights, $http, $dialog, $portfolio, API_CONFIG, $rootScope) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            householdId: '=',
            isProposal: '='
        },
        template: '<li ng-show="((showLink && !isProposal) || (showLinkProposal && isProposal)) && householdId"><a target="_blank" rel="noopener noreferrer" href="{{ ::hiddenurl }}"><img ng-if="isProposal" src="_img/main-menu/hiddenLeversProposal.png" class="app-icon-small"/><img ng-if="!isProposal" src="_img/main-menu/hidden-levers.png" class="app-icon-small"/>  Orion Risk Intelligence <span ng-if="isProposal">- Proposal</span></a></li>',
        link: function (scope) {
            scope.showLink = $oasRights.canRead("ORIONRISKAPP");
            scope.showLinkProposal = $oasRights.canRead("ORIONRISKPROPOSAL");

            
                if (scope.isProposal){
                    scope.hiddenurl = API_CONFIG.baseUrl +'/Integrations/HiddenLevers/ProposalPayload?clientId' + scope.householdId+ '&Authorization='+ sessionStorage.oas_token;
                }
                else{
                    scope.hiddenurl = API_CONFIG.baseUrl +'/Integrations/HiddenLevers/SSOPayload?clientId=' + scope.householdId + '&Authorization='+ sessionStorage.oas_token;
                }
            
        }
    };
});


'use strict';

app.service('oasClipboard', function(){
    function setActiveElement(element) {
        element.focus();
        element.select();
    }

    /**
     * Copy a string to a temporary textarea, then copy the textarea's text
     * to the clipboard buffer.
     * @param content - a string to copy to the clipboard buffer.
     */
    this.copyContent = function(content){
        var textArea = document.createElement("textarea");
        textArea.value = content;
        document.body.appendChild(textArea);
        setActiveElement(textArea);
        document.execCommand('copy');
        document.body.removeChild(textArea);
    };

    /**
     * Paste the contents of the clipboard buffer to an element.
     * @param destinationElement - the element to paste into.
     */
    this.pasteTo = function(destinationElement){
        setActiveElement(destinationElement);
        document.execCommand('paste');
    };
});

'use strict';

app.directive('oasImgSrc', function oasImgSrc(API_CONFIG) {
    var attrName = "src";
    var normalized = "oasImgSrc";
    return {
        priority: 99,
        link: function (scope, element, attrs) {
            attrs.$observe(normalized, function(value) {
                //NOTE: Make sure to include a blank src attribute on the element or IE throws up.
                //      See ngSrc code for more information.

                if (!value) return;

                var requiresToken = attrs.requiresToken ? scope.$eval(attrs.requiresToken) : true;

                if (requiresToken && sessionStorage.oas_token)
                    attrs.$set(attrName, API_CONFIG.baseUrl + value + (value.indexOf("?") !== -1 ? "&" : "?") + "Authorization=" + sessionStorage.oas_token);
                else if (!requiresToken)
                    attrs.$set(attrName, API_CONFIG.baseUrl + value);

                element.prop(attrName, attrs[attrName]);

                //TODO: issue in IE, commenting out for now
//                element.one("error", function(e) {
//                    e.preventDefault();
//                    e.stopPropagation();
//
//                    attrs.$set(attrName, "");
//                    element.prop(attrName, attrs[attrName]);
//                    return true;
//                });
            });
        }
    };
});
'use strict';

app.directive('oasSearch', function oasSearch($http, oasProps, $q, $timeout, $templateCache, $dialog) {
    const props = oasProps.oasSearchProps;

    $http.get("/Settings/Database/EntityOptions/Code/69EXCLUDEI", { trackerMsg: 'Loading search settings' })
        .then(function (response) {
            if (response.data.value.toLowerCase() === "true") {
                props.client.url += "&isActive=true";
                props.registration.url += "&isActive=true";
                props.account.url += "&isActive=true";
            }
        });

    $templateCache.put("oasSearch-itemTemplate.html", '<a tabindex="-1" ng-class="{muted: match.model.isActive == false}"><i class="fa fa-fw {{ match.model.icon }}"></i> <span ng-bind-html="match.label | typeaheadHighlight:query"></span></a>');

    return {
        restrict: 'E',
        scope: {
            selected: '=?',
            required: '=',
            disabled: '=',
            globalOptions: '=?',
            onSelect: '&',
            disableAutoFocus: '=',
            appendToSearch: '=?'
        },
        replace: true,
        template: '<div class="oas-search">' +
            '<input id="{{entityType ? entityType + $id: $id}}" title="{{selected.name ? selected.name : \'Global Search\'}}" autocomplete="off" ng-attr-autofocus="{{search.autofocus}}" type="text" class="input-block-level {{entityType && entityType == \'Account\' ? \'fs-mask\' : \'\'}}" ng-required="required" ng-disabled="disabled" ng-model="selected" placeholder="{{ ::search.placeholder }}" typeahead="item as search.formatter(item) for item in getData($viewValue)" typeahead-append-to-body="{{::appendToBody}}" typeahead-loading="search.inProgress" typeahead-wait-ms="350" typeahead-editable="{{::isEditable}}" typeahead-template-url="oasSearch-itemTemplate.html" typeahead-on-select="onSelect({selected: $model})" typeahead-over-parent="true" data-test-id="txt{{ ::searchTestId}}" />' +
            '<i class="{{search.inProgress ? \'fa fa-spinner fa-spin\' : \'fa fa-search\'}}" aria-hidden="true"></i>' +
            '<button type="button" ng-if="::search.advancedSearch" class="btn btn-link" ng-click="advancedSearch()" data-test-id="btn-TopNavBar-AdvancedSearch">Advanced Search</button>' +
            '</div>',
        link: {
            pre: function (scope, element, attrs) {
                scope.isEditable = attrs.editable === "true";
                scope.appendToBody = typeof(attrs.appendToBody) === 'undefined' || attrs.appendToBody === null ? true : attrs.appendToBody;
            },
            post: function (scope, element, attrs) {
                //INITIALIZE
                if (attrs.testId) {
                    scope.searchTestId = attrs.testId.charAt(0).toLocaleUpperCase() + attrs.testId.slice(1);
                } else {
                    scope.searchTestId = "OasSearchInput";
                    // append the entity name to the searchTestId, if it exists
                    if (attrs.entity && attrs.entity.length) {
                        scope.searchTestId += attrs.entity;
                    }
                }

                if (!attrs.entity || !props[attrs.entity.toLowerCase()]) {
                    throw "Invalid entity `" + attrs.entity + "` passed to oas-search!";
                } else {
                    scope.entityType = attrs.entity;
                    scope.search = angular.extend({ inProgress: false, autofocus: scope.disableAutoFocus ? undefined : true }, props[attrs.entity.toLowerCase()], scope.$eval(attrs.options));
                    
                    // For global search (index.html), prevent request cancellation
                    if (attrs.entity.toLowerCase() === 'global') {
                        scope.search.allowCancellation = false;
                    }
                }

                if (scope.search.includeValue) {
                    scope.search.url = scope.search.url.replace('Simple', 'Value');
                }

                $timeout(function () {
                    element.find('[autofocus]').trigger("focus");
                });

                //PUBLIC METHODS
                scope.getData = function (searchText) {
                    const nameField = scope.search.nameField || 'name';

                    const appendedResults = (scope.appendToSearch && scope.appendToSearch.length > 0) ? scope.appendToSearch.filter((item) => item[nameField].toLocaleLowerCase().includes(searchText.toLocaleLowerCase())) : [];

                    const config = attrs.token ? { headers: { Authorization: "Session " + attrs.token } } : null;

                    if (scope.search.url === "global") {
                        const search = encodeURIComponent(searchText);
                        const selectedOptions = scope.globalOptions.list.findAll({ include: true }).map("id");
                        const top = (120 / selectedOptions.exclude("application", "applicationpage", "report", "dataquery").length).round();

                        const promises = selectedOptions.map(function (type) {
                            const requestConfig = angular.extend({}, config);
                            // For global search, prevent all requests from being cancelled
                            if (scope.search.allowCancellation === false) {
                                requestConfig.allowCancellation = false;
                            }
                            return $http.get(props[type].url.replace('{search}', search).replace('{top}', top) + (scope.globalOptions.activeOnly || type === 'application' ? '&isActive=true' : '') + (scope.globalOptions.useContains ? '' : '&useContain=false'), requestConfig)
                                .then(function (response) {
                                    response.data.forEach(function (item) {
                                        item.icon = props[type].icon;
                                    });
                                    return response.data;
                                });
                        });

                        return $q.all(promises).then(function (data) {
                            return data.flatten(0).concat(appendedResults);
                        });
                    } else {
                        let url = scope.search.url.replace('{search}', encodeURIComponent(searchText)).replace('{top}', '40');
                        if (attrs.parameters) {
                            url += (url.indexOf("?") !== -1 ? "&" : "?") + attrs.parameters;
                        }
                        if (attrs.isActive != null && attrs.isActive.length > 0) {
                            url += (url.indexOf("?") !== -1 ? "&" : "?") + 'isActive=' + attrs.isActive;
                        }

                        const requestConfig = angular.extend({}, config);
                        if (scope.search.allowCancellation === false) {
                            requestConfig.allowCancellation = false;
                        }

                        return $http.get(url, requestConfig)
                            .then(function (response) {
                                if (scope.search.icon) {
                                    response.data.forEach(function (item) {
                                        item.icon = scope.search.icon;
                                    });
                                }
                                return response.data.concat(appendedResults).sort((first, second) => { return first[nameField].localeCompare(second[nameField]); });
                            });
                    }
                };

                scope.advancedSearch = function () {
                    const doAdvancedSearch = function (options) {
                        $dialog.dialog({ dialogClass: "modal wide", templateUrl: "app/modals/advanced-search.html", controller: "AdvancedSearchCtrl", entity: !options.level ? options : options.level, isAllDatabases: !options.isAllDatabases ? false : options.isAllDatabases })
                            .open()
                            .then(function (result) {
                                if (result) {
                                    scope.selected = result;

                                    //wrapped in timeout because scope.selected hasn't actually been updated yet (in case the onSelect method is going to use it)
                                    $timeout(function () {
                                        scope.onSelect({ selected: result, isAllDatabases: options.isAllDatabases });
                                    });
                                }
                            });
                    };

                    if (attrs.entity === "global") {
                        $dialog.dialog({ templateUrl: "app/modals/advanced-search-options.html", controller: "AdvancedSearchOptionsCtrl" })
                            .open()
                            .then(function (options) {
                                if (options) {
                                    doAdvancedSearch(options);
                                }
                            });
                    } else {
                        doAdvancedSearch(attrs.entity.toLowerCase() === "household" ? "client" : attrs.entity);
                    }
                };
            }
        }
    };
});

'use strict';

app.directive('oasDropDown', function oasDropDown($http, oasProps) {
    const props = oasProps.oasDropdownProps;

    return {
        restrict: 'E',
        scope: {
            selected: '=',
            required: '=',
            disabled: '=',
            friendly: '=?',
            bindField: '@?',
            nameField: '@?',
            blankRowName: '@?',
            blankRowValue: '@?',
            isActive: '@?',
            changeFn: '&',
            groupRows:'=?'
        },
        replace: true,
        template:   `
                    <div style="display: inline-block;" ng-switch="dropdown.mode">
                        <select ng-switch-when="grouped" ng-model="dropdown.selectedItem" aria-label="{{::ariaLabel}}" ng-required="required" ng-disabled="disabled" ng-change="itemSelected(dropdown.selectedItem)" ng-options="record as record[dropdown.nameField] group by record.groupBy for record in records track by record[dropdown.bindField]"></select>
                        <div ng-switch-when="search" class="oas-search">
                            <input type="text" aria-label="{{::ariaLabel}}" ng-required="required" ng-disabled="disabled" style="width: 186px;" ng-click="highlightText($event)" placeholder="Search" ng-model="dropdown.selectedItem" typeahead-on-select="itemSelected($model)" typeahead="record as searchFormatter(record) for record in filteredRecords($viewValue)" typeahead-append-to-body="true" typeahead-editable="false" />
                            <i class="fa fa-search" aria-hidden="true"></i>
                        </div>
                        <select ng-switch-when="normal" ng-model="dropdown.selectedItem" aria-label="{{::ariaLabel}}" ng-required="required" ng-disabled="disabled" ng-change="itemSelected(dropdown.selectedItem)" ng-options="record as record[dropdown.nameField] for record in ::records track by record[dropdown.bindField]"></select>
                    </div>
                    `,
        link: function (scope, element, attrs) {
            //PRIVATE VARIABLES
            const defaultBlankRowName = '(none)';
            let blankRowName;
            let cancelWatcher;


            //PRIVATE METHODS
            function getId(item) {
                return item[scope.dropdown.bindField];
            }

            function getName(item) {
                return item[scope.dropdown.nameField] || defaultBlankRowName;
            }


            //INITIALIZE
            scope.ariaLabel = attrs.selected.replace(/\./g, ' ').titleize();

            attrs.$observe('idField', function () {
                if (cancelWatcher) {
                    cancelWatcher();
                }

                if (!attrs.idField) {
                    throw 'oasDropDown: id-field is required!';
                }

                const isUDF = attrs.idField.startsWith('udf');

                scope.dropdown = angular.copy(props[isUDF ? 'udf' : attrs.idField.toLowerCase()]);

                if (!scope.dropdown) {
                    throw `oasDropDown: ${attrs.idField} is an invalid value for id-field!`;
                }

                scope.dropdown.bindField = scope.bindField || scope.dropdown.bindField || 'id';
                scope.dropdown.nameField = scope.nameField || scope.dropdown.nameField || 'name';
                scope.dropdown.mode = null;

                if (isUDF) {
                    scope.dropdown.url = scope.dropdown.url.assign({entity: attrs.entity === 'Household' ? 'Client' : attrs.entity, code: attrs.idField.from(3)});
                }

                if (attrs.isActive != null && attrs.isActive.length > 0) {
                    scope.dropdown.url += (scope.dropdown.url.includes('?') ? '&' : '?') + 'isActive=' + attrs.isActive;
                }

                const getArgs = attrs.hideTracker === "true" ? {cache: true} : {cache: true, trackerMsg: 'Loading ' + scope.dropdown.trackerMsg};

                $http.get(scope.dropdown.url, getArgs)
                    .then(function (response) {
                        let data = isUDF ? response.data.options : response.data;

                        // attrs.filterIds must pass in as comma delimited list of number i.e "1,2,3"
                        if (attrs.filterIds) {
                            const ids = attrs.filterIds.split(',').map(id => parseInt(id));

                            data = data.filter(item => ids.any(getId(item)));
                        }

                        const sortBy = attrs.orderByField || data.length && data[0].hasOwnProperty('sequence') ? 'sequence' : scope.dropdown.nameField;
                        scope.records = data.sortBy(sortBy);

                        blankRowName = scope.blankRowName || scope.dropdown.blankRowName;
                        if (blankRowName) {
                            const blankRow = {};
                            blankRow[scope.dropdown.bindField] = ['','undefined', 'null'].none(String(scope.blankRowValue)) ? (isNaN(parseInt(scope.blankRowValue)) ? scope.blankRowValue : parseInt(scope.blankRowValue)) : null;
                            blankRow[scope.dropdown.nameField] = blankRowName;
                            scope.records.unshift(blankRow);
                        }

                        if (attrs.groupText) {
                            scope.dropdown.mode = 'grouped';

                            scope.$watch('groupRows', function (newValue) {
                                if (!angular.isDefined(newValue) || !newValue.length) {
                                    return;
                                }

                                scope.records.forEach(function (record) {
                                    record.groupBy = (newValue.any(getId(record)) ? 'Has ' : 'No ') + attrs.groupText;
                                });

                                scope.records = scope.records.sortBy('groupBy');
                            });
                        } else {
                            scope.dropdown.mode = scope.records.length > 50 ? 'search' : 'normal';
                        }

                        if (attrs.setDefault === "true" && scope.records.length && !scope.selected) {
                            scope.selected = getId(scope.records.find({isDefault: true}) || scope.records[0]);
                        }

                        cancelWatcher = scope.$watch('selected', function (newValue) {
                            if (!angular.isDefined(newValue) || (scope.dropdown.selectedItem && getId(scope.dropdown.selectedItem) === newValue)) {
                                return;
                            }

                            scope.dropdown.selectedItem = scope.records.find(item => getId(item) === newValue);

                            if (scope.dropdown.selectedItem) {
                                scope.itemSelected(scope.dropdown.selectedItem);
                            }
                        });
                    });
            });


            //PUBLIC METHODS
            scope.itemSelected = function (selected) {
                scope.selected = getId(selected);
                scope.friendly = getName(selected);

                scope.changeFn({selected: scope.selected, record: selected});
            };

            scope.filteredRecords = function (searchText) {
                searchText = searchText.toLowerCase();

                const topMatches = [];
                const bottomMatches = [];

                for (const item of scope.records) {
                    const name = getName(item);

                    if (String(getId(item)) === searchText || name === blankRowName || name === defaultBlankRowName) {
                        topMatches.push(item);
                    } else if (name.toLowerCase().includes(searchText)) {
                        bottomMatches.push(item);
                    }

                    if (topMatches.length + bottomMatches.length === 75) {
                        break;
                    }
                }

                return topMatches.concat(bottomMatches);
            };

            scope.searchFormatter = function (item) {
                if (!item) {
                    return '';
                }

                const id = getId(item);
                const name = getName(item);

                return id && id !== name ? `${id}: ${name}` : name;
            };

            scope.highlightText = function ($event) {
                $event.target.select();
            };
        }
    };
});

app.directive('editorHeader', function editorHeader($http, entities, $portfolio, apps) {
    const commonMap = {name: "name", value: "value"};

    const props = {};
    props[entities.billPayMethod.name]              = {url: "/Billing/BillPayMethods/{1}",                 map: { payInstruction: "name"},                                       base: {bgColor: "rgba(30, 120, 108, 1)",       icon: "fa fa-orion-broker-dealer"}};
    props[entities.brokerDealer.name]               = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 204, 153, 1)",        icon: "fa fa-orion-broker-dealer"}};
    props[entities.representative.name]             = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 135, 247, 1)",        icon: "fa fa-orion-representative"}};
    props[entities.plan401k.name]                   = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(35, 67, 124, 1)",        icon: "fa fa-orion-401k-plan"}};
    props[entities.client.name]                     = {url: "/Portfolio/Clients/{1}/Value",                map: commonMap,                                                       base: {bgColor: entities.client.bgColor,       icon: entities.client.icon,                 rightInfo: "Household Value"}};
    props[entities.registration.name]               = {url: "/Portfolio/Registrations/{1}/Value",          map: commonMap,                                                       base: {bgColor: entities.registration.bgColor, icon: entities.registration.icon,           rightInfo: "Registration Value"}};
    props[entities.account.name]                    = {url: "/Portfolio/Accounts/{1}/Value",               map: commonMap,                                                       base: {bgColor: entities.account.bgColor,      icon: entities.account.icon,                rightInfo: "Account Value"}};
    props[entities.asset.name]                      = {url: "/Portfolio/Assets/{1}",                       map: {name: "name", currentValue: "value", ticker: "leftInfo"},       base: {bgColor: entities.asset.bgColor,        icon: entities.asset.icon,                  rightInfo: "Asset Value",           leftTitle: "Ticker"}};
    props[entities.transaction.name]                = {url: "/Portfolio/Transactions/{1}",                 map: {productName: "name", transAmount: "value", ticker: "leftInfo"}, base: {bgColor: entities.transaction.bgColor,  icon: entities.transaction.icon,            rightInfo: "Transaction Amount",    leftTitle: "Ticker"}};
    props[entities.portfolioGroup.name]             = {url: "/Portfolio/PortfolioGroups/{1}",              map: commonMap,                                                       base: {bgColor: entities.portfolioGroup.bgColor,      icon: entities.portfolioGroup.icon,  rightInfo: "Portfolio Group Value"}};
    props[entities.feeSchedule.name]                = {url: "/Billing/Schedules/{1}",                      map: {name: "name", schedule: "leftInfo"},                            base: {bgColor: "rgba(19, 137, 50, 1)",        icon: "fa fa-orion-fee-schedule"}};
    props[entities.payoutSchedule.name]             = {url: "/Billing/Schedules/{1}",                      map: {name: "name", schedule: "leftInfo"},                            base: {bgColor: "rgba(19, 137, 50, 1)",        icon: "fa fa-orion-fee-schedule"}};
    props[entities.feeType.name]                   = {url: null,                                          map: {name: "name", schedule: "leftInfo"},                             base: {bgColor: "rgba(19, 137, 50, 1)",        icon: "fa fa-orion-fee-schedule"}};
    props[entities.billMasterPayout.name]           = {url: "/Billing/MasterPayoutSchedule/{1}",           map: {name: "name"},                                                  base: {bgColor: "rgba(19, 137, 50, 1)",        icon: "fa fa-orion-fee-schedule"}};
    props[entities.confirmationGroup.name]          = {url: "/Confirm/Groups/{1}",                         map: {name: "name"},                                                  base: {bgColor: "rgba(0, 51, 102, 1)",         icon: "fa fa-orion-confirmation-group"}};
    props[entities.confirmationScrub.name]          = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(122, 122, 82, 1)",       icon: "fa fa-orion-confirmation-scrub"}};
    props[entities.modelAgg.name]                   = {url: "/Trading/ModelAggs/Simple/{1}",               map: {name: "name"},                                                  base: {bgColor: "rgba(0, 153, 153, 1)",        icon: "fa fa-orion-modelagg"}};
    props[entities.product.name]                    = {url: null,                                          map: null,                                                            base: {bgColor: entities.product.bgColor,      icon: entities.product.icon}};
    props[entities.corporateAction.name]            = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-corporate-action"}};
    props[entities.dividend.name]                   = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(153, 153, 102, 1)",      icon: "fa fa-orion-dividend"}};
    props[entities.priceFactor.name]                = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(153, 51, 255, 1)",       icon: "fa fa-orion-price-factor"}};
    props[entities.businessLine.name]               = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(122, 122, 82, 1)",       icon: "fa fa-orion-business-line"}};
    props[entities.subAdvisor.name]                 = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 153, 153, 1)",        icon: "fa fa-orion-subadvisor"}};
    props[entities.wholesaler.name]                 = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 153, 46, 1)",         icon: "fa fa-orion-subadvisor"}};
    props[entities.ria.name]                        = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(247, 166, 35, 1)",       icon: "fa fa-orion-subadvisor"}};
    props[entities.thirdPartyAdministrator.name]    = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(35, 67, 124, 1)",        icon: "fa fa-orion-subadvisor"}};
    props[entities.registrationType.name]           = {url: "/Portfolio/Registrations/Types/{1}",          map: {sRegDesc: "name"},                                              base: {bgColor: "rgba(30, 120, 108, 1)",       icon: "fa fa-orion-registration"}};
    props[entities.corporateActionTransaction.name] = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-corporate-action"}};
    props[entities.billAdjustmentType.name]         = {url: "/Billing/AdjustmentTypes/{1}",                map: {name: "name"},                                                  base: {bgColor: "rgba(30, 120, 108, 1)",       icon: "fa fa-orion-fee-schedule"}};
    props[entities.cancellationFeeAdjustment.name]  = {url: "/Billing/CancellationFeeAdjDefault/{1}",      map: {adjustmentType: "name"},                                        base: {bgColor: "rgba(30, 120, 108, 1)",       icon: "fa fa-orion-fee-schedule"}};
    props[entities.billEntity.name]                 = {url: "/Billing/Entities/{1}",                       map: {name: "name"},                                                  base: {bgColor: "rgba(30, 120, 108, 1)",       icon: "fa fa-orion-fee-schedule"}};
    props[entities.payee.name]                      = {url: "/Billing/Payees/{1}",                         map: {name: "name"},                                                  base: {bgColor: "rgba(30, 120, 108, 1)",       icon: "fa fa-orion-fee-schedule"}};
    // All download headers match until they ask otherwise
    props[entities.downloadName.name]               = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-download-record"}};
    props[entities.downloadBeneficiary.name]        = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-download-record"}};
    props[entities.downloadPosition.name]           = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-download-record"}};
    props[entities.downloadTransaction.name]        = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-download-record"}};
    props[entities.downloadPrice.name]              = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-download-record"}};
    props[entities.downloadCostBasis.name]          = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-download-record"}};
    props[entities.downloadDividend.name]           = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-download-record"}};
    props[entities.downloadCorpAction.name]         = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-download-record"}};
    props[entities.downloadSecurity.name]           = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-download-record"}};
    props[entities.downloadBanking.name]            = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-download-record"}};
    props[entities.downloadRMD.name]                = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-download-record"}};
    props[entities.downloadSystematic.name]         = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-download-record"}};
    props[entities.downloadGeneric.name]            = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-download-record"}};
    props[entities.downloadSource.name]             = {url: "/Confirm/DownloadSources/{1}",                map: { downloadDescription: "name" },                                 base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-download-record"}};
    props[entities.downloadFormatSourceDefault.name] = { url: "/Confirm/DownloadFormats/{1}",              map: { formatName: "name"},                                           base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-download-record"}};
    props[entities.downloadFormat.name]             = {url: "/Confirm/DownloadFormats/{1}",                map: {formatName: "name"},                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-orion-download-record"}};
    props[entities.downloadSubFormatSchedulerDefault.name] = { url: null,                                  map: null,                                                            base: { bgColor: "rgba(0, 174, 239, 1)",       icon: "fa fa-orion-download-record" } };

    props[entities.storedCost.name] = { url: null, map: null, base: { bgColor: "rgba(255, 59, 13, 1)", icon: "fa fa-orion-stored-cost" } };
    props[entities.userManagement.name]             = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(112, 3, 120, 1)",        icon: "fa fa-orion-user-management"}};
    props[entities.roles.name]                      = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(112, 3, 120, 1)",        icon: "fa fa-orion-role"}};
    props[entities.privileges.name]                 = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(112, 3, 120, 1)",        icon: "fa fa-wrench"}};

    props[entities.processInstance.name]            = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(112, 3, 120, 1)",        icon: "fa fa-list-ol"}};
    props[entities.processTask.name]                = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(112, 3, 120, 1)",        icon: "fa fa-sticky-note-o"}};
    props[entities.processStatus.name]              = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(112, 3, 120, 1)",        icon: "fa fa-flag-o"}};
    props[entities.processType.name]                = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(112, 3, 120, 1)",        icon: "fa fa-book"}};
    props[entities.processAction.name]              = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(112, 3, 120, 1)",        icon: "fa fa-cube"}};
    props[entities.processInstance.name]            = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(112, 3, 120, 1)",        icon: "fa fa-object-group"}};
    props['Report Access']                          = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(202, 78, 68, 1)",        icon: "fa fa-lock"}};
    props['Report Package Access']                  = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(202, 78, 68, 1)",        icon: "fa fa-lock"}};
    props['Report Version Assignment']              = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(202, 78, 68, 1)",        icon: "fa fa-lock"}};
    props['Query Access']                           = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(202, 78, 68, 1)",        icon: "fa fa-lock"}};
    props['Batch Errors']                           = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(202, 78, 68, 1)",        icon: "fa fa-lock"}};
    props['Instance Parameters']                    = {url: null,                                          map: null,                                                            base: {bgColor: "rgba(0, 174, 239, 1)",        icon: "fa fa-cog"}};

    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        templateUrl: 'app/directives/editorHeader.html',
        scope: {entity: '=', entityId: '=?', canSave: '=?', disableCancel:'=?', disableSave: '=?', canDelete: '=?', saveFn: '&', deleteFn: '&', cancelFn: '&', hideSave:'=?', hideClose: '=?', hideDelete: '=?', showSearch: '=?', saveText: '=?', statusIcon: '=?', statusHeader: '=?', statusBody: '=?', statusFooter: '=?', nameOverride: '=?'},
        link: function (scope, element, attrs, ctrlArray, transcludeFn) {

            transcludeFn(scope.$parent, function (clone) {
                if (clone.length) {
                    angular.element(element.children().children()[1]).empty().append(clone);
                }
            });


            //PRIVATE VARIABLES
            let originalSelectedEntity;


            //PRIVATE METHODS
            function loadEntity() {
                const entity = props[scope.entity];
                scope.current = angular.copy(entity.base);

                if (scope.entityId) {
                    if (scope.showSearch) {
                        scope.entitySelector = {selectedEntity: null, items: [], searchEntity: {id: scope.entityId}};
                    }

                    if (entity.url) {
                        $http.get(entity.url.assign(scope.entityId))
                            .then(function (response) {
                                Object.each(entity.map, function (source, target) {
                                    scope.current[target] = response.data[source];
                                });
                            });
                    }

                    const entityEnum = entities[entities.find({name: scope.entity})];
                    if ([entities.client.value, entities.registration.value, entities.account.value].any(entityEnum.value)) {
                        $http.post(entityEnum.simpleUrl.replace('Simple', scope.entityId + '/Calculate/InceptionDate'))
                            .then(function (response) {
                                scope.current.leftInfo = response.data.inceptionDate ? Date.create(response.data.inceptionDate).format('{Month} {d}, {yyyy}') : 'None';
                                scope.current.leftTitle = "Inception Date";
                            });
                    }
                }
            }


            //SCOPE WATCHERS
            scope.$watch("entitySelector.selectedEntity", function (newValue, oldValue) {
                if (!originalSelectedEntity && newValue) {
                    originalSelectedEntity = newValue;
                }

                if (!newValue || !oldValue || newValue === originalSelectedEntity) return;

                $portfolio.openEditor(scope.entitySelector.selectedEntity.type, [scope.entitySelector.selectedEntity.id], null, null, apps.portfolioLists.name, null);

                scope.entitySelector.selectedEntity.selected = false;
                originalSelectedEntity.selected = true;
                scope.entitySelector.selectedEntity = originalSelectedEntity;
            });

            scope.$watch("entity", function () {
                loadEntity();
            });

            scope.$watch("entityId", function () {
                loadEntity();
            });

            scope.toggleStatusPopover = function () {
               
                let target = document.getElementById('editorHeaderStatusTarget');
                let popover = document.getElementById('editorHeaderStatusPopover');
                if (popover != null && target != null) {
                    popover.toggle(target);
                }
            };

        }
    };
});

'use strict';

app.directive('onEnter', function() {
    return function(scope, element, attrs) {
        element.on("keypress", function(event) {
            if(event.which === 13) {
                scope.$apply(function(){
                    scope.$eval(attrs.onEnter);
                });

                event.preventDefault();
            }
        });
    };
});

(function(angular){
    'use strict';

    var POPOVER_SHOW = 'popoverToggleShow';
    var POPOVER_HIDE = 'popoverToggleHide';

    var module = angular.module('popoverToggle', ['ui.bootstrap']);

    module.config(['$tooltipProvider', function($tooltipProvider) {
        var triggers = {};
        triggers[POPOVER_SHOW] = POPOVER_HIDE;

        $tooltipProvider.setTriggers(triggers);
    }]);

    module.directive('popoverToggle', ['$timeout', function($timeout) {
        return {
            restrict: 'A',
            link: link
        };

        function link($scope, $element, $attrs) {
            $attrs.popoverTrigger = POPOVER_SHOW;

            $scope.$watch($attrs.popoverToggle, function(newValue) {
                $timeout(function(){
                    if(newValue) {
                        dispatchEvent(POPOVER_SHOW, $element);
                    } else {
                        dispatchEvent(POPOVER_HIDE, $element);
                    }
                });

                function dispatchEvent(eventName, $element) {
                    var event = document.createEvent('Event');
                    event.initEvent(eventName, true, true);

                    $element[0].dispatchEvent(event);
                }
            })
        }
    }]);

})(angular);
app.directive("searchableMultiselect", function($timeout) {
	return {
		templateUrl: 'app/directives/searchableMultiselect.html',
		restrict: 'AE',
		scope: {
			displayAttr: '@',
			nonSelectedText: '@',
			selectedItems: '=',
			allItems: '=',
			readOnly: '=',
			addItem: '&',
			removeItem: '&'
		},
		link: function(scope, element, attrs) {
			element.bind('click', function (e) {
				e.stopPropagation();
			});

			scope.width = element[0].getBoundingClientRect();

			scope.updateSelectedItems = function(obj) {
				var selectedObj;
				for (var i = 0; typeof scope.selectedItems !== 'undefined' && i < scope.selectedItems.length; i++) {
					if (scope.selectedItems[i][scope.displayAttr].toUpperCase() === obj[scope.displayAttr].toUpperCase()) {
						selectedObj = scope.selectedItems[i];
						break;
					}
				}
				if ( typeof selectedObj === 'undefined' ) {
					scope.addItem({item: obj});
				} else {
					scope.removeItem({item: selectedObj});
				}
			};

			scope.unselectAll = function(){
				scope.selectedItems = [];
			}

			scope.selectAll = function(){
				scope.selectedItems = [];
				scope.allItems.each(function(obj){
					scope.selectedItems.push(obj);
				})
			}

			scope.isItemSelected = function(item) {
				if ( typeof scope.selectedItems === 'undefined' ) return false;

				var tmpItem;
				for (var i=0; i < scope.selectedItems.length; i++) {
					tmpItem = scope.selectedItems[i];
					if ( typeof tmpItem !== 'undefined'
					&&	typeof tmpItem[scope.displayAttr] !== 'undefined'
					&&	typeof item[scope.displayAttr] !== 'undefined'
					&&	tmpItem[scope.displayAttr].toUpperCase() === item[scope.displayAttr].toUpperCase() ) {
						return true;
					}
				}

				return false;
			};

			
			scope.commaDelimitedSelected = function() {
				var list = "";
				
				angular.forEach(scope.selectedItems, function (item, index) {
					list += item[scope.displayAttr];
					if (index < scope.selectedItems.length - 1) list += ', ';
				});
				/*
				scope.selectedItems.each(function(item){
					list += item[scope.displayAttr] + ",";
				})*/
				return (list !== "" ? list : scope.nonSelectedText);

			}
		}
	}
});
app.directive('oasAuditFields', function oasAuditFields(){
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/directives/oasAuditFields.html',
        scope: {data: '='}//,
//        link: function(scope){
//        }
    };

});

'use strict';

app.directive('oasEditorErrorList', function oasEditorErrorList( ) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            errorList: '=',
            closeModalFn: '&'
        },
        template:   '<div style="margin: 15px 15px 0 15px;"><alert ng-repeat="e in errorList" type="e.type" close="closeError($index)">' +
                    '<div style="display: flex; align-items: center;">' +
                    '<i class="{{e.type == \'warning\' ? \'fa fa-exclamation-triangle\' : \'fa fa-exclamation-circle\'}} fa-2x" style="margin-right:3px;"></i>'+
                    '<strong style="margin-right:3px;color:var(--red-600)">{{e.title}}</strong>'+
                    '<span style="margin-right:3px;color:var(--red-600)">{{e.msg}}</span>'+
                    '<button ng-show="e.showAllowClose" class="btn btn-link a-blue-600" ng-click="closeModalFn( )">Close Form Anyway</button>' +
                    '</alert></div></div>',
        link: function (scope) {

            scope.closeError = function( index ) {
                scope.errorList.splice( index, 1 );
            };

        }
    };
});

'use strict';

app.directive('rightSidebar', function rightSidebar() {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template:   '<div class="hidden-print">' +
                        '<div ng-show="rightSidebar.isOpen" class="sidebar right" ng-style="{width: rightSidebar.width + \'px\'}">' +
                            '<button class="btn btn-link sidebar-pushin right" ng-click="rightSidebar.isOpen = false" aria-label="Collapse Right Sidebar" data-test-id="hide-right-sidebar"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>' +
                            '<div ng-transclude></div>' +
                        '</div>' +
                        '<button ng-hide="rightSidebar.isOpen" class="sidebar-pullout right" ng-click="rightSidebar.isOpen = true" aria-label="Expand Right Sidebar" data-test-id="show-right-sidebar"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>' +
                    '</div>',
        link: function (scope) {
            scope.rightSidebar.exists = true;
        }
    };
});

'use strict';

/* Usage
 <select-to-text ng-if="payee.readOnly" text-size="input-large" key="payee.fkPayee" key-name="id" key-desc="payeeName"  collection="current.payees"></select-to-text>
 */
app.directive('selectToText', function readOnlySelect(){
    return {
        restrict : 'E',
        scope : {
            key : '=',
            keyName : '@',
            keyDesc : '@',
            collection : '=',
            textSize : '@'
        },
        template : '<label ng-class="textSize" style="cursor: default" >{{description}}</label>',
        replace : true,
        link : function(scope){
            scope.description = '';

            if (scope.collection){
                scope.collection.forEach(function(obj){
                    if (obj[scope.keyName] === scope.key)
                        scope.description = obj[scope.keyDesc];
                });
            }
        }
    }
});


'use strict';

/**
 * Structured Slick Grid filters: { key, operator, value } instead of eval'd JS predicates.
 * Exposed on window so slickGrid, slickGridViews, and OData sidebar sync can share it.
 */
(function (global) {
    var OPERATOR_TOKENS = [
        { token: ' is greater than or equal to ', operator: 'is greater than or equal to' },
        { token: ' is less than or equal to ', operator: 'is less than or equal to' },
        { token: ' does not start with ', operator: 'does not start with' },
        { token: ' does not end with ', operator: 'does not end with' },
        { token: ' does not contain ', operator: 'does not contain' },
        { token: ' does not equal ', operator: 'does not equal' },
        { token: ' is greater than ', operator: 'is greater than' },
        { token: ' is less than ', operator: 'is less than' },
        { token: ' starts with ', operator: 'starts with' },
        { token: ' ends with ', operator: 'ends with' },
        { token: ' contains ', operator: 'contains' },
        { token: ' is between ', operator: 'is between' },
        { token: ' is after (date) ', operator: 'is after (date)' },
        { token: ' is before (date) ', operator: 'is before (date)' },
        { token: ' is older than (days) ', operator: 'is older than (days)' },
        { token: ' is within (days) ', operator: 'is within (days)' },
        { token: ' is after T-', operator: 'is after T-' },
        { token: ' is before T-', operator: 'is before T-' },
        { token: ' is today', operator: 'is today' },
        { token: ' is true', operator: 'is true' },
        { token: ' is false', operator: 'is false' },
        { token: ' >= ', operator: 'is greater than or equal to' },
        { token: ' <= ', operator: 'is less than or equal to' },
        { token: ' ≠ ', operator: 'does not equal' },
        { token: ' > ', operator: 'is greater than' },
        { token: ' < ', operator: 'is less than' },
        { token: ' = ', operator: 'equals' }
    ];

    var NUMERIC_OPERATORS = {
        'is greater than': true,
        'is less than': true,
        'is greater than or equal to': true,
        'is less than or equal to': true,
        'is between': true
    };

    var DATE_OPERATORS = {
        'is today': true,
        'is after (date)': true,
        'is before (date)': true,
        'is older than (days)': true,
        'is within (days)': true,
        'is after T-': true,
        'is before T-': true
    };

    var BOOLEAN_OPERATORS = {
        'is true': true,
        'is false': true
    };

    function isBlankToken(value) {
        if (value == null) return true;
        var text = String(value).trim();
        return text === '' || text.toLowerCase() === '{blank}';
    }

    function asString(value) {
        if (value == null) return '';
        return String(value);
    }

    function asNumber(value) {
        if (typeof value === 'number' && !isNaN(value)) return value;
        var text = asString(value).replace(/[$,]/g, '').trim();
        if (text === '') return NaN;
        return Number(text);
    }

    function lower(value) {
        return asString(value).toLowerCase();
    }

    function toArray(filter) {
        if (Array.isArray(filter.filterValues) && filter.filterValues.length) {
            return filter.filterValues;
        }
        if (Array.isArray(filter.values) && filter.values.length) {
            return filter.values;
        }
        var primary = filter.filterValue;
        if (Array.isArray(primary)) {
            return primary;
        }
        if (typeof primary === 'string' && primary.indexOf(' or ') !== -1) {
            return primary.split(/\s+or\s+/i).map(function (part) { return part.trim(); }).filter(Boolean);
        }
        return primary == null || primary === '' ? [] : [primary];
    }

    function canonicalizeOperator(operator) {
        if (!operator) return operator;
        var trimmed = String(operator).trim();
        var key = trimmed.toLowerCase().replace(/[^a-z0-9]/g, '');
        if (ENUM_OPERATOR_KEYS[key]) {
            return ENUM_OPERATOR_KEYS[key];
        }
        return trimmed;
    }

    var ENUM_OPERATOR_KEYS = {
        equals: 'equals',
        is: 'equals',
        notequal: 'does not equal',
        doesnotequal: 'does not equal',
        greaterthan: 'is greater than',
        isgreaterthan: 'is greater than',
        lessthan: 'is less than',
        islessthan: 'is less than',
        greaterthanequalto: 'is greater than or equal to',
        isgreaterthanorequalto: 'is greater than or equal to',
        lessthanequalto: 'is less than or equal to',
        islessthanorequalto: 'is less than or equal to',
        between: 'is between',
        isbetween: 'is between',
        startswith: 'starts with',
        notstartswith: 'does not start with',
        doesnotstartwith: 'does not start with',
        endswith: 'ends with',
        notendswith: 'does not end with',
        doesnotendwith: 'does not end with',
        contains: 'contains',
        notcontain: 'does not contain',
        doesnotcontain: 'does not contain',
        notcontains: 'does not contain',
        istrue: 'is true',
        isfalse: 'is false',
        isafterdate: 'is after (date)',
        isafter: 'is after (date)',
        isbeforedate: 'is before (date)',
        isbefore: 'is before (date)',
        istoday: 'is today',
        iswithindays: 'is within (days)',
        isaftert: 'is after T-',
        isolderthandays: 'is older than (days)',
        isbeforet: 'is before T-'
    };

    function inferConditionType(filter) {
        if (filter.conditionType) return filter.conditionType;
        var op = canonicalizeOperator(filter.operator);
        if (BOOLEAN_OPERATORS[op]) return 'basicBoolean';
        if (DATE_OPERATORS[op]) return 'basicDate';
        if (NUMERIC_OPERATORS[op]) return 'basicNumber';
        return 'basicText';
    }

    function resolveCellValue(cellValue, conditionType) {
        if (conditionType === 'basicObject') {
            if (cellValue == null) return '';
            return cellValue.name != null ? cellValue.name : cellValue;
        }
        return cellValue;
    }

    function createDate(value) {
        if (value == null || value === '') return null;
        if (typeof Date.create === 'function') {
            return Date.create(value);
        }
        var parsed = new Date(value);
        return isNaN(parsed.getTime()) ? null : parsed;
    }

    function isToday(value) {
        var date = createDate(value);
        if (!date) return false;
        if (typeof date.isToday === 'function') return date.isToday();
        var now = new Date();
        return date.getFullYear() === now.getFullYear()
            && date.getMonth() === now.getMonth()
            && date.getDate() === now.getDate();
    }

    function dateEquals(value, expected) {
        var date = createDate(value);
        if (!date) return false;
        if (typeof date.is === 'function') return date.is(expected);
        var expectedDate = createDate(expected);
        if (!expectedDate) return false;
        return date.getFullYear() === expectedDate.getFullYear()
            && date.getMonth() === expectedDate.getMonth()
            && date.getDate() === expectedDate.getDate();
    }

    function dateIsAfter(value, expected) {
        var date = createDate(value);
        if (!date) return false;
        if (typeof date.isAfter === 'function') return date.isAfter(expected);
        var expectedDate = createDate(expected);
        return expectedDate ? date.getTime() > expectedDate.getTime() : false;
    }

    function dateIsBefore(value, expected) {
        var date = createDate(value);
        if (!date) return false;
        if (typeof date.isBefore === 'function') return date.isBefore(expected);
        var expectedDate = createDate(expected);
        return expectedDate ? date.getTime() < expectedDate.getTime() : false;
    }

    function daysBeforeToday(days) {
        var count = asNumber(days);
        if (isNaN(count)) return null;
        if (typeof Date.create === 'function') {
            return count + ' days before today';
        }
        var date = new Date();
        date.setDate(date.getDate() - count);
        return date;
    }

    function matchSingle(cellValue, operator, expected, expected2, conditionType) {
        var type = conditionType || 'basicText';
        var value = resolveCellValue(cellValue, type);

        if (operator === 'is true') {
            return typeof value === 'string' ? value.toLowerCase() === 'true' : value === true;
        }
        if (operator === 'is false') {
            return typeof value === 'string' ? value.toLowerCase() === 'false' : (value === false || value === null);
        }
        if (operator === 'is today') {
            return !!value && isToday(value);
        }

        if (type === 'basicDate' || DATE_OPERATORS[operator]) {
            if (operator === 'equals' && isBlankToken(expected)) {
                return value == null || value === '' || (typeof value === 'string' && value.trim() === '');
            }
            if (!value) return false;
            switch (operator) {
                case 'equals':
                    return dateEquals(value, expected);
                case 'is after (date)':
                    return dateIsAfter(value, expected);
                case 'is before (date)':
                    return dateIsBefore(value, expected);
                case 'is older than (days)':
                case 'is before T-':
                    return dateIsBefore(value, daysBeforeToday(expected));
                case 'is within (days)':
                case 'is after T-':
                    return dateIsAfter(value, daysBeforeToday(expected));
                default:
                    break;
            }
        }

        if (type === 'basicNumber' || NUMERIC_OPERATORS[operator]) {
            var numeric = asNumber(value);
            var compare = asNumber(expected);
            switch (operator) {
                case 'equals':
                    return numeric === compare;
                case 'does not equal':
                    return numeric !== compare;
                case 'is greater than':
                    return numeric > compare;
                case 'is less than':
                    return numeric < compare;
                case 'is greater than or equal to':
                    return numeric >= compare;
                case 'is less than or equal to':
                    return numeric <= compare;
                case 'is between':
                    return numeric >= compare && numeric <= asNumber(expected2);
                default:
                    break;
            }
        }

        var text = value == null ? '' : asString(value);
        var needle = isBlankToken(expected) ? '' : lower(expected);
        var haystack = lower(text);

        switch (operator) {
            case 'equals':
                return haystack == needle;
            case 'does not equal':
                return haystack !== needle;
            case 'starts with':
                return haystack.startsWith(needle);
            case 'does not start with':
                return !haystack.startsWith(needle);
            case 'ends with':
                return haystack.endsWith(needle);
            case 'does not end with':
                return !haystack.endsWith(needle);
            case 'contains':
                return haystack.indexOf(needle) !== -1;
            case 'does not contain':
                return haystack.indexOf(needle) === -1;
            default:
                return false;
        }
    }

    function isNegatedOperator(operator) {
        return operator === 'does not equal'
            || operator === 'does not start with'
            || operator === 'does not end with'
            || operator === 'does not contain';
    }

    var TEXT_COMPARERS = {
        'equals': function (haystack, needle) { return haystack === needle; },
        'does not equal': function (haystack, needle) { return haystack !== needle; },
        'starts with': function (haystack, needle) { return haystack.startsWith(needle); },
        'does not start with': function (haystack, needle) { return !haystack.startsWith(needle); },
        'ends with': function (haystack, needle) { return haystack.endsWith(needle); },
        'does not end with': function (haystack, needle) { return !haystack.endsWith(needle); },
        'contains': function (haystack, needle) { return haystack.indexOf(needle) !== -1; },
        'does not contain': function (haystack, needle) { return haystack.indexOf(needle) === -1; }
    };

    function compileTextFilter(conditionType, operator, values, requireAll) {
        var needles = values.map(function (expected) {
            return isBlankToken(expected) ? '' : lower(expected);
        });

        function toHaystack(cellValue) {
            var value = resolveCellValue(cellValue, conditionType);
            return value == null ? '' : lower(value);
        }

        if (operator === 'equals' || operator === 'does not equal') {
            var needleSet = new Set(needles);
            var negate = operator === 'does not equal';
            return function (cellValue) {
                return needleSet.has(toHaystack(cellValue)) !== negate;
            };
        }

        var compare = TEXT_COMPARERS[operator];
        return function (cellValue) {
            var haystack = toHaystack(cellValue);
            var i;
            if (requireAll) {
                for (i = 0; i < needles.length; i++) {
                    if (!compare(haystack, needles[i])) return false;
                }
                return true;
            }
            for (i = 0; i < needles.length; i++) {
                if (compare(haystack, needles[i])) return true;
            }
            return false;
        };
    }

    function compileNumberEqualsFilter(operator, values) {
        var numbers = new Set();
        values.forEach(function (expected) {
            var numeric = asNumber(expected);
            if (!isNaN(numeric)) numbers.add(numeric);
        });
        var negate = operator === 'does not equal';
        return function (cellValue) {
            var numeric = asNumber(cellValue);
            return (!isNaN(numeric) && numbers.has(numeric)) !== negate;
        };
    }

    // Resolves everything that does not depend on the cell once per filter instead of once per row and value,
    // so large multi-value filters (thousands of pasted account numbers) stay fast. Text and numeric equals use
    // precomputed lookups; everything else falls back to matchSingle with the operator and type resolved once.
    function compileFilter(filter) {
        if (!filter || !filter.operator) {
            return function () { return true; };
        }

        var conditionType = inferConditionType(filter);
        var operator = canonicalizeOperator(filter.operator);
        var value2 = filter.filterValue2 != null ? filter.filterValue2 : filter.value2;
        var values = toArray(filter);
        if (values.length <= 1) {
            values = [values.length === 1 ? values[0] : (filter.filterValue != null ? filter.filterValue : null)];
        }
        var requireAll = values.length > 1 && isNegatedOperator(operator);
        var isDateOrBoolean = BOOLEAN_OPERATORS[operator] || DATE_OPERATORS[operator] || conditionType === 'basicDate';

        if (!isDateOrBoolean && conditionType !== 'basicNumber' && !NUMERIC_OPERATORS[operator] && TEXT_COMPARERS[operator]) {
            return compileTextFilter(conditionType, operator, values, requireAll);
        }

        if (!isDateOrBoolean && conditionType === 'basicNumber' && (operator === 'equals' || operator === 'does not equal')) {
            return compileNumberEqualsFilter(operator, values);
        }

        return function (cellValue) {
            var test = function (expected) {
                return matchSingle(cellValue, operator, expected, value2, conditionType);
            };
            return requireAll ? values.every(test) : values.some(test);
        };
    }

    var FILTER_STATE_KEYS = ['operator', 'conditionType', 'filterValues', 'values', 'filterValue', 'filterValue2', 'value2'];

    function captureFilterState(filter) {
        return FILTER_STATE_KEYS.map(function (key) {
            var value = filter ? filter[key] : undefined;
            return { value: value, length: Array.isArray(value) ? value.length : -1 };
        });
    }

    function hasFilterChanged(filter, state) {
        if (!filter) return false;
        for (var i = 0; i < FILTER_STATE_KEYS.length; i++) {
            var value = filter[FILTER_STATE_KEYS[i]];
            if (value !== state[i].value || (Array.isArray(value) ? value.length : -1) !== state[i].length) {
                return true;
            }
        }
        return false;
    }

    function createFilterFn(filter) {
        var state = null;
        var compiled = null;
        // Recompile if the filter object is edited after creation, matching the previous lazy evaluation.
        return function (cellValue) {
            if (!state || hasFilterChanged(filter, state)) {
                state = captureFilterState(filter);
                compiled = compileFilter(filter);
            }
            return compiled(cellValue);
        };
    }

    function hasStructuredOperator(filter) {
        return !!(filter && filter.operator);
    }

    function parseLegacyName(filter) {
        if (!filter || !filter.name) return null;
        var name = filter.name;
        var lowerName = name.toLowerCase();
        var i;
        for (i = 0; i < OPERATOR_TOKENS.length; i++) {
            var token = OPERATOR_TOKENS[i].token;
            var tokenLower = token.toLowerCase();
            var idx = lowerName.indexOf(tokenLower);
            if (idx === -1) {
                tokenLower = token.trim().toLowerCase();
                idx = lowerName.indexOf(tokenLower);
                if (idx === -1) {
                    continue;
                }
            }
            var remainder = name.substring(idx + tokenLower.length).trim();
            var parsed = {
                operator: OPERATOR_TOKENS[i].operator,
                filterValue: remainder,
                filterValue2: null,
                filterValues: null
            };

            if (parsed.operator === 'is between' && /\sand\s/i.test(remainder)) {
                var parts = remainder.split(/\s+and\s+/i);
                parsed.filterValue = parts[0].trim();
                parsed.filterValue2 = (parts[1] || '').trim();
            } else if (/\s+or\s+/i.test(remainder)) {
                parsed.filterValues = remainder.split(/\s+or\s+/i).map(function (part) { return part.trim(); }).filter(Boolean);
                parsed.filterValue = parsed.filterValues[0];
            } else if (remainder.charAt(0) === '[' && remainder.charAt(remainder.length - 1) === ']') {
                parsed.filterValues = remainder.slice(1, -1).split(',').map(function (part) { return part.trim(); }).filter(Boolean);
                parsed.filterValue = parsed.filterValues[0];
            }

            if (NUMERIC_OPERATORS[parsed.operator] && parsed.filterValue != null && parsed.filterValue !== '') {
                var numeric = asNumber(parsed.filterValue);
                if (!isNaN(numeric)) parsed.filterValue = numeric;
                if (parsed.filterValue2 != null && parsed.filterValue2 !== '') {
                    var numeric2 = asNumber(parsed.filterValue2);
                    if (!isNaN(numeric2)) parsed.filterValue2 = numeric2;
                }
            }

            return parsed;
        }
        return null;
    }

    function translateLegacyFilter(filter, columnDefs) {
        if (!filter || hasStructuredOperator(filter)) {
            return false;
        }

        var parsed = parseLegacyName(filter);
        if (!parsed) {
            return false;
        }

        filter.operator = parsed.operator;
        filter.filterValue = parsed.filterValue;
        filter.filterValue2 = parsed.filterValue2;
        filter.filterValues = parsed.filterValues;

        if (!filter.conditionType && columnDefs && filter.key) {
            var column = null;
            for (var i = 0; i < columnDefs.length; i++) {
                if (columnDefs[i].field === filter.key || columnDefs[i].id === filter.key) {
                    column = columnDefs[i];
                    break;
                }
            }
            if (column && column.conditionType) {
                filter.conditionType = column.conditionType;
            }
        }

        if (!filter.conditionType) {
            filter.conditionType = inferConditionType(filter);
        }

        if (shouldCoerceNumeric(filter.conditionType, filter.operator)) {
            coerceNumericFields(filter);
        }

        return true;
    }

    function translateLegacyFilters(filters, columnDefs) {
        if (!filters || !filters.length) return false;
        var translatedAny = false;
        for (var i = 0; i < filters.length; i++) {
            if (translateLegacyFilter(filters[i], columnDefs)) {
                translatedAny = true;
            }
        }
        return translatedAny;
    }

    function coerceNumericToken(value) {
        var numeric = asNumber(value);
        return isNaN(numeric) ? value : numeric;
    }

    function coerceNumericFields(fields) {
        if (!fields) return fields;
        if (Array.isArray(fields.filterValues) && fields.filterValues.length) {
            fields.filterValues = fields.filterValues.map(coerceNumericToken);
            fields.filterValue = fields.filterValues[0];
        } else if (fields.filterValue != null && fields.filterValue !== '') {
            fields.filterValue = coerceNumericToken(fields.filterValue);
        }
        if (fields.filterValue2 != null && fields.filterValue2 !== '') {
            fields.filterValue2 = coerceNumericToken(fields.filterValue2);
        }
        return fields;
    }

    function shouldCoerceNumeric(conditionType, operator, condition) {
        if (conditionType === 'basicNumber') return true;
        if (condition && condition.isNumericType) return true;
        return !!(NUMERIC_OPERATORS[canonicalizeOperator(operator)]);
    }

    function buildStructuredFields(column, condition, value1, value2) {
        var fields = {
            operator: condition && condition.name,
            conditionType: column && column.conditionType,
            filterValue: value1,
            filterValue2: value2 == null || value2 === '' ? null : value2,
            filterValues: null
        };

        if (value1 != null && typeof value1 === 'string') {
            var orSeparated = value1.split(/\s+or\s+/i).map(function (part) { return part.trim(); }).filter(Boolean);
            if (orSeparated.length > 1) {
                fields.filterValues = orSeparated;
                fields.filterValue = orSeparated[0];
            } else if (value1.charAt(0) === '[' && value1.charAt(value1.length - 1) === ']') {
                fields.filterValues = value1.slice(1, -1).split(',').map(function (part) { return part.trim(); }).filter(Boolean);
                fields.filterValue = fields.filterValues[0];
            }
        }

        if (shouldCoerceNumeric(fields.conditionType, fields.operator, condition)) {
            coerceNumericFields(fields);
        }

        return fields;
    }

    global.slickGridFilterFormat = {
        createFilterFn: createFilterFn,
        hasStructuredOperator: hasStructuredOperator,
        translateLegacyFilter: translateLegacyFilter,
        translateLegacyFilters: translateLegacyFilters,
        buildStructuredFields: buildStructuredFields,
        inferConditionType: inferConditionType
    };
}(window));

'use strict';

app.directive('slickGrid', function slickGrid($http, $window, $timeout, $dialog, $q, $rootScope, splitIoService, loadingService, $location) {
    return {
        restrict: 'E',
        replace: true,
        template: '<div class="grid" style="width: 100%; height:2000px;"></div>',
        link: function (scope, element, attrs) {

            // Have to do this so that safeApply is available even when slickGrid is in a directive with isolate scope
            scope.safeApply = $rootScope.safeApply;

            //PRIVATE VARIABLES
            const dynamicFields = {
                isEnabled: attrs.dynamicFields ? scope.$eval(attrs.dynamicFields) : false,
                loaded: [],
                completeIds: []
            };
            var resolvedParameters = '';
            const gimp = new Slick.Data.GroupItemMetadataProvider();
            const dataView = new Slick.Data.DataView({groupItemMetadataProvider: gimp});
            const rowSelectionModel = new Slick.RowSelectionModel({selectActiveRow: true});
            const commandQueue = [];
            scope.columnFilters = {};
            const defaultTake = attrs.takeInterval ? parseInt(attrs.takeInterval) : -1;
            const defaultLoadAllPages = [undefined, true, 'true'].any(attrs.loadAllPages);
            const slickGridExportMaxBlobBytes = 400 * 1024 * 1024;
            const slickGridExportMaxEstimateSamples = 200;
            const slickGridExportEstimateSegments = 20;
            const slickGridLargeExportSplitFlag = 'opex_export_excel_multi_38249';
            // TODO : remove this when removing opex_rework_2026_orion_connect_pentest_cross_site_39440 feature flag
            const pentestCrossSiteFilterReworkFlag = 'opex_rework_2026_orion_connect_pentest_cross_site_39440';
            let isPentestCrossSiteFilterReworkEnabled = false;
            const slickGridExportLoadingKey = 'slickGridExport';
            const hasPager = [true, 'true'].any(attrs.hasPager);
            const defaultUseOData = [undefined, true, 'true'].any(attrs.useOData);
            const dblClickFn = scope.current && scope.current.gridDoubleClick ? scope.current.gridDoubleClick : null;
            const listHotKeys = scope.current && (scope.current.hotKeyActions && scope.current.hotKeyActions.length > 0) ? new HotKeys() : null;
            const options = {
                editable: attrs.isEditable ? scope.$eval(attrs.isEditable) : false,
                asyncEditorLoading: true,
                forceFitColumns: false,
                enableCellNavigation: true,
                enableColumnReorder: true,
                explicitInitialization: true,
                editCommandHandler: queueAndExecuteCommand,
                rowHeight: 30,
                defaultColumnWidth: 100,
                showHeaderRow: true,
                multiColumnSort: true,
                enableTextSelectionOnCells: attrs.enableTextSelection ? scope.$eval(attrs.enableTextSelection) : false
            };
            const grid = new Slick.Grid(element, dataView, [], options);
            let rows = [];
            let loadInProgress = false;
            let pendingGridLoadCancelDeferred = null;
            let gridLoadGeneration = 0;
            let initialGridLoadComplete = false;
            let autoRefreshInterval = 0;
            let lastRefreshedDate = null;

            function isCancelledGridLoadResponse(response) {
                if (!response) {
                    return false;
                }
                if (response.cancelled === true) {
                    return true;
                }
                return response.status === -1;
            }

            function cancelPendingGridLoad() {
                if (pendingGridLoadCancelDeferred) {
                    pendingGridLoadCancelDeferred.resolve('Grid load cancelled');
                    pendingGridLoadCancelDeferred = null;
                }
            }

            function beginGridLoadRequest() {
                cancelPendingGridLoad();
                gridLoadGeneration++;
                pendingGridLoadCancelDeferred = $q.defer();
                return {
                    timeout: pendingGridLoadCancelDeferred.promise,
                    generation: gridLoadGeneration
                };
            }

            function isStaleGridLoad(generation) {
                return generation !== gridLoadGeneration;
            }

            function isPortfolioRecordColumnLimitEnabled() {
                var sync = window.slickGridODataSidebarSync;
                return !!(sync && sync.isRecordColumnLimitFeatureEnabled
                    && sync.isRecordColumnLimitFeatureEnabled(scope));
            }

            //PRIVATE METHODS
            function isPortfolioSlickGridSsrmEnabled() {
                return isPortfolioRecordColumnLimitEnabled();
            }

            function isPortfolioODataSidebarList() {
                return isPortfolioRecordColumnLimitEnabled()
                    && !!(scope.current && scope.current.odataListProfileKey);
            }

            // -------------------------------------------------------------------------
            // Feature flag OFF: legacy slick-grid behavior (pre OC-39220 SSRM).
            // Feature flag ON:  portfolio SSRM / OData paths below.
            // -------------------------------------------------------------------------

            function initLegacy() {
                setFilters(scope.current.view.filters);
                setColumns(scope.current.view.slickGridColumnDefs);
                setGroupings(scope.current.view.groups);
                setSorts(scope.current.view.sorts);

                if (dynamicFields.isEnabled) {
                    const cancelListener = scope.$on('slickgrid-view-set', function () {
                        loadGridFromDynamicFields();
                        cancelListener();
                    });
                } else {
                    loadGridData(false);
                }
            }

            function loadGridFromDynamicFieldsLegacy(hint) {
                if (!dynamicFields.isEnabled) {
                    return $q.resolve();
                }

                const fieldsToLoad = !dynamicFields.loaded.length && attrs.dynamicFieldsRequired
                    ? attrs.dynamicFieldsRequired.split(',') : [];

                [
                    {list: 'slickGridColumnDefs', key: 'field', flag: 'visible'},
                    {list: 'slickGridColumnDefs', key: 'editorKeyField', flag: 'visible'},
                    {list: 'filters', key: 'key', flag: 'include'},
                    {list: 'groups', key: 'getter', flag: 'enabled'},
                    {list: 'sorts', key: 'field', flag: 'field'}
                ].forEach(function (collection) {
                    if (!hint || hint === collection.list) {
                        scope.current.view[collection.list].forEach(function (item) {
                            const field = item[collection.key];
                            if (field && item[collection.flag] && fieldsToLoad.none(field) && dynamicFields.loaded.none(field)) {
                                fieldsToLoad.push(field);
                            }
                        });
                    }
                });

                if (fieldsToLoad.length) {
                    const idFields = attrs.compositeKey ? attrs.compositeKey.split(',') : [getIdProperty()];
                    dynamicFields.loaded.add(fieldsToLoad);
                    idFields.forEach(function (idField) {
                        if (dynamicFields.loaded.none(idField)) {
                            dynamicFields.loaded.push(idField);
                        }
                    });
                    return loadGridData(!!hint, idFields.union(fieldsToLoad));
                }

                return $q.resolve();
            }

            function loadGridDataLegacy(forceRender, fieldsToLoad) {
                if (!dynamicFields.isEnabled && loadInProgress) {
                    if (autoRefreshInterval > 0) {
                        $timeout(function () { loadGridDataLegacy(true); }, autoRefreshInterval);
                    }
                    return $q.reject();
                }

                if (!dynamicFields.isEnabled || fieldsToLoad === dynamicFields.loaded) {
                    rows = [];
                }

                return loadData(null, fieldsToLoad)
                    .then(function (response) {
                        if (!response) {
                            return $q.reject({status: 'error', message: 'No response from loadData function (this should never happen)'});
                        }

                        lastRefreshedDate = response.headers && response.headers("X-OAS-LastRefreshDate")
                            ? response.headers("X-OAS-LastRefreshDate") : null;
                        return renderResponseData(response.data || response, forceRender)
                            .then(function () {
                                if (response.pages) {
                                    return loadData(response.pages(), fieldsToLoad)
                                        .then(function (pages) {
                                            if (pages) {
                                                return renderResponseData(pages.data, forceRender);
                                            }
                                        });
                                }
                            });
                    }).catch(function (response) {
                        if (!response.hasOwnProperty('status') || response.status === 'error') {
                            console.error(response);
                            return;
                        }

                        if (response.status === 504 && attrs.onTimeoutEvent) {
                            scope.$emit(attrs.onTimeoutEvent, {skip: skip, take: take, forceRender: forceRender});
                        }
                    });
            }

            function loadDataLegacy(call, fieldsToLoad) {
                loadInProgress = true;
                const take = scope.current && scope.current.takeInterval !== undefined
                    ? parseInt(scope.current.takeInterval) : defaultTake;
                const loadAllPages = scope.current && scope.current.loadAllPages !== undefined
                    ? [true, 'true'].any(scope.current.loadAllPages) : defaultLoadAllPages;

                if (!call) {
                    if (attrs.url) {
                        call = $http({
                            method: attrs.verb || 'GET',
                            url: attrs.url,
                            params: Object.fromQueryString(resolvedParameters),
                            data: attrs.data ? JSON.parse(attrs.data) : undefined,
                            take: take,
                            useOData: defaultUseOData,
                            trackerMsg: 'Loading grid data',
                            loadAllPages: loadAllPages,
                            headers: {'X-OAS-Select': fieldsToLoad}
                        });
                    } else if (scope.current.grid && scope.current.grid.load) {
                        if (angular.isString(scope.current.grid.load)) {
                            call = $http({
                                method: 'GET',
                                url: scope.current.grid.load,
                                params: scope.current.grid.param || Object.fromQueryString(resolvedParameters),
                                take: take,
                                useOData: defaultUseOData,
                                trackerMsg: 'Loading grid data',
                                loadAllPages: loadAllPages,
                                headers: {'X-OAS-Select': fieldsToLoad}
                            });
                        } else {
                            call = scope.current.grid.load({
                                params: scope.current.grid.param || Object.fromQueryString(resolvedParameters),
                                take: take,
                                useOData: defaultUseOData,
                                loadAllPages: loadAllPages
                            });
                        }
                    } else {
                        call = $q.reject({status: 'info', message: 'loadData.call() not available yet'});
                    }
                }

                return call
                    .finally(function () {
                        loadInProgress = false;
                    });
            }

            function shouldWaitForPortfolioListFilters() {
                if (!isPortfolioSlickGridSsrmEnabled()) {
                    return false;
                }
                if (scope.current && scope.current.entityRouteGetById && isPortfolioRecordColumnLimitEnabled()) {
                    return false;
                }
                return isPortfolioODataSidebarList();
            }

            function wipeGridRows() {
                rows = [];
                dataView.beginUpdate();
                dataView.setItems([], getIdProperty());
                dataView.endUpdate();
                grid.invalidate();
                if (scope.current && shouldLoadUntilRecordLimit()) {
                    scope.current.gridLoadedCount = 0;
                    var sync = window.slickGridODataSidebarSync;
                    if (sync && sync.resetPortfolioGridRowCountBanner) {
                        sync.resetPortfolioGridRowCountBanner(scope);
                    }
                }
            }

            function scheduleInitialGridDataLoad() {
                function runInitialLoad() {
                    if (isPortfolioODataSidebarList()) {
                        setFilters([]);
                    }
                    var loadPromise;
                    if (dynamicFields.isEnabled) {
                        loadPromise = loadGridFromDynamicFields();
                    } else {
                        loadPromise = loadGridData(false);
                    }
                    return (loadPromise || $q.resolve()).finally(function () {
                        initialGridLoadComplete = true;
                    });
                }

                if (!shouldWaitForPortfolioListFilters()) {
                    return runInitialLoad();
                }
                if (scope.current && scope.current.portfolioListFiltersReady) {
                    return runInitialLoad();
                }
                var unwatch = scope.$watch(function () {
                    return scope.current && scope.current.portfolioListFiltersReady;
                }, function (ready) {
                    if (ready) {
                        unwatch();
                        runInitialLoad();
                    }
                });
            }

            function applyCurrentViewToGrid() {
                if (!scope.current || !scope.current.view) {
                    return;
                }
                setFilters(scope.current.view.filters);
                setColumns(scope.current.view.slickGridColumnDefs);
                setGroupings(scope.current.view.groups);
                setSorts(scope.current.view.sorts);
            }

            function hasViewConfiguration() {
                return !!(scope.views && scope.views.length);
            }

            function shouldWaitForInitialViewSet() {
                return isPortfolioRecordColumnLimitEnabled()
                    && (dynamicFields.isEnabled || hasViewConfiguration());
            }

            function canRunInitialPortfolioViewSet() {
                if (!scope.current || !scope.current.portfolioListViewSelectionReady) {
                    return false;
                }
                if (isPortfolioRecordColumnLimitEnabled() && !scope.current.portfolioListInitReady) {
                    return false;
                }
                return true;
            }

            function shouldDeferGridReloadToViewsDirective() {
                return isPortfolioRecordColumnLimitEnabled()
                    && !!(scope.current && scope.current.odataListProfileKey);
            }

            function reloadGridAfterViewChange() {
                if (shouldDeferGridReloadToViewsDirective()) {
                    return;
                }
                if (dynamicFields.isEnabled) {
                    loadGridFromDynamicFields(null, { fullRefresh: true });
                    return;
                }
                loadGridData(true, undefined, { replaceRows: true });
            }

            function setupViewSetHandlers() {
                let initialLoadScheduled = false;
                let cancelListener = null;
                let unwatchReady = null;

                function onViewSet() {
                    if (!scope.current || !scope.current.view) {
                        return;
                    }

                    const isSubsequentViewChange = initialGridLoadComplete;

                    if (!isSubsequentViewChange && !canRunInitialPortfolioViewSet()) {
                        return;
                    }

                    applyCurrentViewToGrid();

                    if (isSubsequentViewChange) {
                        reloadGridAfterViewChange();
                        return;
                    }

                    if (!initialLoadScheduled) {
                        initialLoadScheduled = true;
                        if (unwatchReady) {
                            unwatchReady();
                            unwatchReady = null;
                        }
                        scheduleInitialGridDataLoad();
                    }
                }

                cancelListener = scope.$on('slickgrid-view-set', onViewSet);
                unwatchReady = scope.$watch(function () {
                    return canRunInitialPortfolioViewSet();
                }, function (ready) {
                    if (ready && !initialGridLoadComplete && !initialLoadScheduled) {
                        onViewSet();
                    }
                });
            }

            function init() {
                scope.contextOnGroup = false;
                scope.suppressCellChange = false;
                grid.registerPlugin(gimp);
                grid.registerPlugin(new Slick.AutoTooltips());
                grid.setSelectionModel(rowSelectionModel);

                if (!attrs.parameters) {
                    attrs.parameters = '';
                }
                resolvedParameters = String(attrs.parameters || '');
                attrs.$observe('parameters', function (value) {
                    resolvedParameters = String(value || '');
                });

                if (isPortfolioSlickGridSsrmEnabled()) {
                    if (shouldWaitForInitialViewSet()) {
                        setupViewSetHandlers();
                    } else {
                        applyCurrentViewToGrid();
                        scheduleInitialGridDataLoad();
                    }
                } else {
                    initLegacy();
                }

                dataView.syncGridSelection(grid, true);

                loadHotKeys();
            }

            function applyPortfolioClientSort() {
                if (isPortfolioSlickGridSsrmEnabled()) {
                    var sync = window.slickGridODataSidebarSync;
                    if (sync && sync.clearPortfolioClientSortOData) {
                        sync.clearPortfolioClientSortOData(scope);
                    }
                }
                dataView.sort(sortComparer, true);
            }

            function getDynamicIdFields() {
                return attrs.compositeKey ? attrs.compositeKey.split(',') : [getIdProperty()];
            }

            function findColumnDefByField(fieldName) {
                if (!scope.current || !scope.current.view || !scope.current.view.slickGridColumnDefs || !fieldName) {
                    return null;
                }
                return scope.current.view.slickGridColumnDefs.find({ field: fieldName })
                    || scope.current.view.slickGridColumnDefs.find({ id: fieldName })
                    || null;
            }

            function isDynamicFieldPresentOnRows(fieldName) {
                if (!rows.length || !fieldName) {
                    return false;
                }
                return rows.some(function (row) {
                    return Object.prototype.hasOwnProperty.call(row, fieldName);
                });
            }

            function needsDynamicFieldFetch(fieldName) {
                if (!fieldName) {
                    return false;
                }
                if (dynamicFields.loaded.none(fieldName)) {
                    return true;
                }
                return !isDynamicFieldPresentOnRows(fieldName);
            }

            function pushDynamicFieldIfNeeded(fieldName, fieldsToLoad) {
                if (!fieldName) {
                    return;
                }
                if (fieldsToLoad.none(fieldName) && needsDynamicFieldFetch(fieldName)) {
                    fieldsToLoad.push(fieldName);
                }
                var colDef = findColumnDefByField(fieldName);
                if (colDef && colDef.editorKeyField
                    && fieldsToLoad.none(colDef.editorKeyField)
                    && needsDynamicFieldFetch(colDef.editorKeyField)) {
                    fieldsToLoad.push(colDef.editorKeyField);
                }
            }

            function ensureDynamicIdFieldsTracked() {
                getDynamicIdFields().forEach(function (idField) {
                    if (dynamicFields.loaded.none(idField)) {
                        dynamicFields.loaded.push(idField);
                    }
                });
            }

            function resolveDynamicFieldsHeader(fieldsToLoad, fullRefresh) {
                if (fullRefresh) {
                    ensureDynamicIdFieldsTracked();
                    return dynamicFields.loaded.length ? dynamicFields.loaded.slice() : getDynamicIdFields().slice();
                }
                if (fieldsToLoad && fieldsToLoad.length) {
                    return getDynamicIdFields().union(fieldsToLoad);
                }
                if (dynamicFields.loaded.length) {
                    return dynamicFields.loaded.slice();
                }
                return getDynamicIdFields().slice();
            }

            function collectDynamicFieldsForHint(hint, skipFilterFieldLoads, options) {
                options = options || {};
                const includeAlreadyLoaded = !!options.includeAlreadyLoaded;
                const fieldsToLoad = (!dynamicFields.loaded.length || includeAlreadyLoaded) && attrs.dynamicFieldsRequired
                    ? attrs.dynamicFieldsRequired.split(',') : [];

                [
                    {list: 'slickGridColumnDefs', key: 'field', flag: 'visible'},
                    {list: 'slickGridColumnDefs', key: 'editorKeyField', flag: 'visible'},
                    {list: 'filters', key: 'key', flag: 'include'},
                    {list: 'groups', key: 'getter', flag: 'enabled'},
                    {list: 'sorts', key: 'field', flag: 'field'}
                ].forEach(function (collection) {
                    if (skipFilterFieldLoads && collection.list === 'filters') {
                        return;
                    }
                    if (!hint || hint === collection.list) {
                        scope.current.view[collection.list].forEach(function (item) {
                            const field = item[collection.key];
                            if (!field || !item[collection.flag]) {
                                return;
                            }
                            if (includeAlreadyLoaded) {
                                if (fieldsToLoad.none(field)) {
                                    fieldsToLoad.push(field);
                                }
                                return;
                            }
                            if (collection.list === 'sorts') {
                                pushDynamicFieldIfNeeded(field, fieldsToLoad);
                                return;
                            }
                            if (fieldsToLoad.none(field) && needsDynamicFieldFetch(field)) {
                                fieldsToLoad.push(field);
                            }
                        });
                    }
                });

                return fieldsToLoad;
            }

            function loadGridFromDynamicFields(hint, loadOptions) {
                if (!dynamicFields.isEnabled) {
                    return $q.resolve();
                }
                if (!isPortfolioSlickGridSsrmEnabled()) {
                    return loadGridFromDynamicFieldsLegacy(hint);
                }

                loadOptions = loadOptions || {};
                const fullRefresh = !!loadOptions.fullRefresh;
                const skipFilterFieldLoads = usesServerSideGridFiltering();
                const fieldsToLoad = collectDynamicFieldsForHint(hint, skipFilterFieldLoads, {
                    includeAlreadyLoaded: fullRefresh
                });

                if (!fieldsToLoad.length && hint === 'sorts' && isPortfolioSlickGridSsrmEnabled()) {
                    applyPortfolioClientSort();
                    return $q.resolve();
                }

                // Legacy (FF off): sidebar filters are client-side unless a new column must be loaded.
                if (!fieldsToLoad.length && (hint === 'filters' || hint === 'filterType')
                    && !usesServerSideGridFiltering()) {
                    return $q.resolve();
                }

                if (fieldsToLoad.length) {
                    if (fullRefresh) {
                        dynamicFields.loaded = fieldsToLoad.slice();
                    } else {
                        dynamicFields.loaded.add(fieldsToLoad);
                    }
                    ensureDynamicIdFieldsTracked();
                    return loadGridData(true, resolveDynamicFieldsHeader(fieldsToLoad, fullRefresh), {
                        replaceRows: fullRefresh
                    });
                }

                if (!fullRefresh && hint) {
                    return $q.resolve();
                }

                return loadGridData(!!hint || fullRefresh, resolveDynamicFieldsHeader(null, fullRefresh), {
                    replaceRows: fullRefresh || !dynamicFields.isEnabled
                });
            }

            /**
             * Portfolio SSRM: Grid first; Count only when loaded rows hit the request cap.
             * Clients Count uses SQL COUNT (see GetClientsCountAsync); Reg/Account already do.
             */
            function loadGridData(forceRender, fieldsToLoad, loadOptions) {
                if (!isPortfolioSlickGridSsrmEnabled()) {
                    return loadGridDataLegacy(forceRender, fieldsToLoad);
                }

                loadOptions = loadOptions || {};
                if (dynamicFields.isEnabled && (fieldsToLoad == null || fieldsToLoad === undefined)) {
                    fieldsToLoad = resolveDynamicFieldsHeader(null, false);
                }
                if (!dynamicFields.isEnabled && loadInProgress) {
                    cancelPendingGridLoad();
                }

                var replaceRows = loadOptions.replaceRows;
                if (replaceRows === undefined) {
                    replaceRows = !dynamicFields.isEnabled
                        || fieldsToLoad === dynamicFields.loaded
                        || !!(forceRender && (usesServerSideGridFiltering() || isPortfolioODataSidebarList()));
                }
                if (replaceRows) {
                    wipeGridRows();
                } else if (!dynamicFields.isEnabled) {
                    rows = [];
                }

                if (shouldLoadUntilRecordLimit() && scope.current) {
                    scope.current.gridLoadedCount = 0;
                    var sync = window.slickGridODataSidebarSync;
                    if (sync && sync.resetPortfolioGridRowCountBanner) {
                        sync.resetPortfolioGridRowCountBanner(scope);
                    }
                }

                if (shouldLoadUntilRecordLimit()) {
                    var requestTop = resolveRecordLimitGridTop();
                    scope.current.gridRequestTop = requestTop;
                    return loadData(null, fieldsToLoad, {
                        take: requestTop,
                        loadAllPages: false
                    }).then(function (response) {
                        if (!response) {
                            return $q.reject({status: 'error', message: 'No response from loadData function (this should never happen)'});
                        }

                        lastRefreshedDate = response.headers && response.headers("X-OAS-LastRefreshDate") ? response.headers("X-OAS-LastRefreshDate") : null;

                        return renderResponseData(response.data || response, forceRender)
                            .then(function () {
                                if (rows.length < requestTop) {
                                    scope.current.gridTotalCount = rows.length;
                                    var syncLoaded = window.slickGridODataSidebarSync;
                                    if (syncLoaded && syncLoaded.updatePortfolioGridRowCounts) {
                                        syncLoaded.updatePortfolioGridRowCounts(scope, rows.length);
                                    }
                                    return response;
                                }
                                return resolvePortfolioGridTotalCountAfterLoad().then(function () {
                                    var syncCount = window.slickGridODataSidebarSync;
                                    if (syncCount && syncCount.updatePortfolioGridRowCounts) {
                                        syncCount.updatePortfolioGridRowCounts(scope, rows.length);
                                    }
                                    return response;
                                });
                            });
                    }).catch(function (response) {
                        if (isCancelledGridLoadResponse(response)) {
                            return;
                        }
                        if (scope.current) {
                            var syncErr = window.slickGridODataSidebarSync;
                            if (syncErr && syncErr.isRecordColumnLimitFeatureEnabled
                                && syncErr.isRecordColumnLimitFeatureEnabled(scope)) {
                                scope.current.gridRowCountsReady = true;
                            }
                        }
                        if (!response.hasOwnProperty('status') || response.status === 'error') {
                            console.error(response);
                            return;
                        }

                        if (response.status === 504 && attrs.onTimeoutEvent) {
                            scope.$emit(attrs.onTimeoutEvent, {skip: skip, take: take, forceRender: forceRender});
                        }
                    });
                }

                return loadData(null, fieldsToLoad).then(function (response) {
                        if (!response) {
                            return $q.reject({status: 'error', message: 'No response from loadData function (this should never happen)'});
                        }

                        lastRefreshedDate = response.headers && response.headers("X-OAS-LastRefreshDate") ? response.headers("X-OAS-LastRefreshDate") : null;

                        return renderResponseData(response.data || response, forceRender)
                            .then(function () {
                                if (!shouldLoadUntilRecordLimit() && response.pages) {
                                    return loadData(response.pages(), fieldsToLoad)
                                        .then(function (pages) {
                                            if (pages) {
                                                return renderResponseData(pages.data, forceRender);
                                            }
                                        });
                                }
                            });
                    }).catch(function (response) {
                        if (isCancelledGridLoadResponse(response)) {
                            return;
                        }
                        if (scope.current) {
                            var syncErr = window.slickGridODataSidebarSync;
                            if (syncErr && syncErr.isRecordColumnLimitFeatureEnabled
                                && syncErr.isRecordColumnLimitFeatureEnabled(scope)) {
                                scope.current.gridRowCountsReady = true;
                            }
                        }
                        if (!response.hasOwnProperty('status') || response.status === 'error') {
                            //it wasn't an error from the $http call (came from slickgrid itself or our own error), so log it
                            console.error(response);
                            return;
                        }

                        if (response.status === 504 && attrs.onTimeoutEvent) {
                            scope.$emit(attrs.onTimeoutEvent, {skip: skip, take: take, forceRender: forceRender});
                        }
                    });
            }

            function resolveRecordLimitGridTop() {
                var sync = window.slickGridODataSidebarSync;
                if (sync && sync.resolveRecordLimitGridTop) {
                    return sync.resolveRecordLimitGridTop(scope);
                }
                var recordLimit = scope.current ? parseInt(scope.current.gridRecordLimit, 10) || 0 : 0;
                return recordLimit > 0 ? recordLimit : 50000;
            }

            function resolveUseOData() {
                if (scope.current && scope.current.odataFilter) {
                    return true;
                }
                if (isPortfolioSlickGridSsrmEnabled() && scope.current && scope.current.odataOrderBy) {
                    return true;
                }
                if (scope.current && scope.current.useOData !== undefined && scope.current.useOData !== null) {
                    return [true, 'true'].any(scope.current.useOData);
                }
                return defaultUseOData;
            }

            function usesServerSideRowModel() {
                if (!isPortfolioSlickGridSsrmEnabled()) {
                    return false;
                }
                var sync = window.slickGridODataSidebarSync;
                if (sync && sync.isServerSideRowModelActive) {
                    return sync.isServerSideRowModelActive(scope, $location);
                }
                if (!scope.current) {
                    return false;
                }
                return [true, 'true'].any(scope.current.useServerSideRowModel);
            }

            function usesDeferredODataSidebarFiltering() {
                if (!isPortfolioSlickGridSsrmEnabled()) {
                    return false;
                }
                var sync = window.slickGridODataSidebarSync;
                if (sync && sync.isDeferredODataSidebarSearchEnabled) {
                    return sync.isDeferredODataSidebarSearchEnabled(scope);
                }
                return false;
            }

            function usesServerSideGridFiltering() {
                return usesServerSideRowModel() || usesDeferredODataSidebarFiltering();
            }

            function shouldFetchPortfolioListCount() {
                return scope.current
                    && [true, 'true'].any(scope.current.loadUntilRecordLimit)
                    && parseInt(scope.current.gridRecordLimit, 10) > 0
                    && window.slickGridODataSidebarSync
                    && window.slickGridODataSidebarSync.isRecordColumnLimitFeatureEnabled(scope)
                    && resolvePortfolioODataProfile();
            }

            function shouldLoadUntilRecordLimit() {
                return shouldFetchPortfolioListCount();
            }

            function resolvePortfolioListProfileKey() {
                return scope.current && scope.current.odataListProfileKey;
            }

            function resolvePortfolioODataProfile() {
                if (!isPortfolioSlickGridSsrmEnabled()) {
                    return null;
                }
                var profileKey = resolvePortfolioListProfileKey();
                var portfolioSync = window.portfolioListODataSidebarSync;
                if (!profileKey || !portfolioSync || !portfolioSync.resolveProfile) {
                    return null;
                }
                return portfolioSync.resolveProfile(profileKey);
            }

            function resolvePortfolioGridTotalCountAfterLoad() {
                var sync = window.slickGridODataSidebarSync;
                if (sync && sync.isDeferredODataSidebarSearchEnabled
                    && sync.isDeferredODataSidebarSearchEnabled(scope)
                    && sync.resolvePortfolioGridTotalFromSidebarFilterCount) {
                    return sync.resolvePortfolioGridTotalFromSidebarFilterCount(scope, $q).then(function (usedCommittedCount) {
                        if (usedCommittedCount) {
                            return;
                        }
                        return fetchPortfolioListCount();
                    });
                }
                return fetchPortfolioListCount();
            }

            function fetchPortfolioListCount() {
                var sync = window.slickGridODataSidebarSync;
                var profile = resolvePortfolioODataProfile();
                if (!shouldFetchPortfolioListCount() || !sync || !profile) {
                    return $q.resolve();
                }
                var countGeneration = gridLoadGeneration;
                var countPromise = sync.fetchODataListCount(scope, $http, profile);
                return (countPromise || $q.resolve()).then(function () {
                    if (isStaleGridLoad(countGeneration)) {
                        return;
                    }
                });
            }

            function flattenQueryParams(parsed) {
                const params = {};
                Object.each(parsed || {}, function (name, value) {
                    if (value == null || value === '') {
                        return;
                    }
                    var resolved = value;
                    if (Object.isArray(value)) {
                        var unique = [];
                        value.forEach(function (item) {
                            if (item == null || item === '') {
                                return;
                            }
                            if (unique.indexOf(item) === -1) {
                                unique.push(item);
                            }
                        });
                        resolved = unique.length === 1 ? unique[0] : unique.join(',');
                    }
                    if (resolved == null || resolved === '') {
                        return;
                    }
                    params[name] = resolved;
                });
                return params;
            }

            function resolveGridUrl() {
                if (scope.current && scope.current.url) {
                    return scope.current.url;
                }
                return attrs.url;
            }

            function resolveGridParametersString() {
                return resolvedParameters;
            }

            function gridParamsImplyOData(params) {
                return !!(params && (params.$filter || params.$orderby || params.$skip || params.$top));
            }

            function resolveRequestUseOData(gridParams) {
                if (gridParamsImplyOData(gridParams)) {
                    return true;
                }
                return resolveUseOData();
            }

            function resolveGridRequestParams() {
                var params = {};
                var sync = window.slickGridODataSidebarSync;
                var profile = resolvePortfolioODataProfile();
                var portfolioSync = window.portfolioListODataSidebarSync;
                var legacyProfileKey = resolvePortfolioListProfileKey();

                if (scope.current && scope.current.entityRouteGetById && isPortfolioRecordColumnLimitEnabled()) {
                    if (scope.current.refreshCache) {
                        params.refreshCache = scope.current.refreshCache;
                    }
                    return params;
                }

                if (!isPortfolioSlickGridSsrmEnabled()
                    && legacyProfileKey
                    && portfolioSync
                    && portfolioSync.buildLegacyPortfolioGridParams) {
                    params = portfolioSync.buildLegacyPortfolioGridParams(scope, legacyProfileKey) || {};
                } else if (isPortfolioSlickGridSsrmEnabled() && profile && sync && sync.buildODataListQueryParams) {
                    // Same builder as Count: template-bound keys once, then gridParams only if unset.
                    params = sync.buildODataListQueryParams(scope, profile) || {};
                } else {
                    const paramStr = resolveGridParametersString().replace(/^&/, '');
                    params = flattenQueryParams(Object.fromQueryString(paramStr));
                }

                if (isPortfolioSlickGridSsrmEnabled() && profile && sync && sync.ensurePortfolioListQueryParams) {
                    sync.ensurePortfolioListQueryParams(scope, profile);
                }

                if (scope.current && isPortfolioSlickGridSsrmEnabled()) {
                    if (scope.current.odataFilter) {
                        params.$filter = scope.current.odataFilter;
                    }
                    if (legacyProfileKey && portfolioSync) {
                        var gridProfile = portfolioSync.resolveProfile(legacyProfileKey);
                        if (gridProfile && gridProfile.templateParamKeys && gridProfile.templateParamKeys.isActive) {
                            var activeStateForRequest = scope.current.activeState;
                            if (sync && sync.isDeferredODataSidebarSearchEnabled
                                && sync.isDeferredODataSidebarSearchEnabled(scope)
                                && scope.current.committedActiveState) {
                                activeStateForRequest = scope.current.committedActiveState;
                            }
                            if (activeStateForRequest) {
                                var activeQuery = activeStateForRequest.queryString;
                                if (activeQuery === 'true') {
                                    params.isActive = true;
                                } else if (activeQuery === 'false') {
                                    params.isActive = false;
                                } else {
                                    delete params.isActive;
                                }
                            }
                        }
                    }
                    if (scope.current.refreshCache) {
                        params.refreshCache = scope.current.refreshCache;
                    }
                    var includeODataGridParams = resolveUseOData()
                        || !!(scope.current.odataFilter || scope.current.odataOrderBy);
                    if (includeODataGridParams && sync && sync.parseGridParamParts && scope.current.gridParams) {
                        sync.parseGridParamParts(scope.current.gridParams, params, {
                            includeOrderBy: true
                        });
                    }
                    if (scope.current.odataOrderBy) {
                        params.$orderby = scope.current.odataOrderBy;
                    }
                }

                return params;
            }

            function resolveGridTake(pagingOptions) {
                if (pagingOptions && pagingOptions.take !== undefined) {
                    return parseInt(pagingOptions.take, 10);
                }

                var portfolioProfileKey = resolvePortfolioListProfileKey();
                var sync = window.slickGridODataSidebarSync;

                if (portfolioProfileKey && isPortfolioSlickGridSsrmEnabled()) {
                    if (sync && sync.resolvePortfolioGridRequestTop) {
                        var eoTop = sync.resolvePortfolioGridRequestTop(scope);
                        if (eoTop > 0) {
                            return eoTop;
                        }
                    }
                    var recordLimit = scope.current && parseInt(scope.current.gridRecordLimit, 10);
                    if (recordLimit > 0) {
                        return recordLimit;
                    }
                    return 0;
                }

                if (portfolioProfileKey && !isPortfolioSlickGridSsrmEnabled()) {
                    var legacyTop = window.portfolioListODataSidebarSync
                        && window.portfolioListODataSidebarSync.legacyPortfolioGridTop;
                    if (legacyTop > 0) {
                        return legacyTop;
                    }
                    return defaultTake > 0 ? defaultTake : 50000;
                }

                if (shouldLoadUntilRecordLimit()) {
                    return resolveRecordLimitGridTop();
                }
                if (scope.current && scope.current.takeInterval !== undefined) {
                    var configuredTake = parseInt(scope.current.takeInterval, 10);
                    if (configuredTake > 0) {
                        return configuredTake;
                    }
                }
                return defaultTake > 0 ? defaultTake : 50000;
            }

            function loadData(call, fieldsToLoad, pagingOptions) {
                if (!isPortfolioSlickGridSsrmEnabled()) {
                    return loadDataLegacy(call, fieldsToLoad);
                }

                pagingOptions = pagingOptions || {};
                loadInProgress = true;
                var loadToken = null;
                const take = resolveGridTake(pagingOptions);
                let loadAllPages = scope.current && scope.current.loadAllPages !== undefined ? [true, 'true'].any(scope.current.loadAllPages) : defaultLoadAllPages;
                if (pagingOptions.loadAllPages !== undefined) {
                    loadAllPages = [true, 'true'].any(pagingOptions.loadAllPages);
                } else if (shouldLoadUntilRecordLimit() && !call) {
                    loadAllPages = false;
                }
                const gridUrl = resolveGridUrl();
                const gridParams = resolveGridRequestParams();
                const useOData = resolveRequestUseOData(gridParams);

                if (pagingOptions.skip > 0) {
                    if (useOData) {
                        gridParams.$skip = pagingOptions.skip;
                    } else {
                        gridParams.skip = pagingOptions.skip;
                    }
                }

                if (!call) {
                    loadToken = beginGridLoadRequest();
                    if (gridUrl) {
                        call = $http({
                            method: attrs.verb || 'GET',
                            url: gridUrl,
                            params: gridParams,
                            data: attrs.data ? JSON.parse(attrs.data) : undefined,
                            take: take,
                            useOData: useOData,
                            trackerMsg: 'Loading grid data',
                            loadAllPages: loadAllPages,
                            headers: {'X-OAS-Select': fieldsToLoad},
                            timeout: loadToken.timeout,
                            allowCancellation: false,
                            gridLoadGeneration: loadToken.generation
                        });
                    } else if (scope.current.grid && scope.current.grid.load) {
                        if (angular.isString(scope.current.grid.load)) {
                            call = $http({
                                method: 'GET',
                                url: scope.current.grid.load,
                                params: scope.current.grid.param || gridParams,
                                take: take,
                                useOData: useOData,
                                trackerMsg: 'Loading grid data',
                                loadAllPages: loadAllPages,
                                headers: {'X-OAS-Select': fieldsToLoad},
                                timeout: loadToken.timeout,
                                allowCancellation: false,
                                gridLoadGeneration: loadToken.generation
                            });
                        } else {
                            call = scope.current.grid.load({
                                params: scope.current.grid.param || gridParams,
                                take: take,
                                useOData: useOData,
                                loadAllPages: loadAllPages
                            });
                        }
                    } else {
                        call = $q.reject({status: 'info', message: 'loadData.call() not available yet'});
                    }
                }

                var requestGeneration = loadToken ? loadToken.generation : null;

                return call
                    .then(function (response) {
                        if (response && response.config && response.config.gridLoadGeneration !== undefined
                            && isStaleGridLoad(response.config.gridLoadGeneration)) {
                            return $q.reject({ status: -1, cancelled: true });
                        }
                        return response;
                    }, function (error) {
                        // 410: a file filter's entity session is gone. The sidebar re-creates it from the saved values.
                        if (error && error.status === 410) {
                            $rootScope.$broadcast('event:slickgrid-file-filter-session-gone');
                        }
                        return $q.reject(error);
                    })
                    .finally(function () {
                        if (!requestGeneration || !isStaleGridLoad(requestGeneration)) {
                            loadInProgress = false;
                        }
                    });
            }

            function renderResponseData(data, forceRender) {
                cleanData(data);

                if (dynamicFields.isEnabled && rows.length && dataView.getItemById(data[0][getIdProperty()])) {  //if we find the first item already exists, then merge the new columns instead of adding as rows
                    data.forEach(function (updatedItem) {
                        const existingItem = dataView.getItemById(updatedItem[getIdProperty()]);
                        angular.extend(existingItem, updatedItem);
                    });
                } else {
                    rows = rows.concat(data);
                    setGridRows();
                }

                if (scope.current && isPortfolioSlickGridSsrmEnabled()) {
                    var sync = window.slickGridODataSidebarSync;
                    if (sync && sync.updatePortfolioGridRowCounts) {
                        sync.updatePortfolioGridRowCounts(scope, rows.length);
                    } else {
                        const take = resolveGridTake();
                        const loadAllPages = scope.current.loadAllPages !== undefined ? [true, 'true'].any(scope.current.loadAllPages) : defaultLoadAllPages;
                        var showRecordLimitBanner = sync && sync.isRecordColumnLimitFeatureEnabled
                            && sync.isRecordColumnLimitFeatureEnabled(scope);
                        scope.current.gridRecordLimitReached = showRecordLimitBanner
                            && !loadAllPages && take > 0 && rows.length >= take;
                    }
                }

                scope.$emit('slickgrid-data-loaded', dataView.getItems());
                scope.$emit('slickgrid-last-refresh', lastRefreshedDate );

                if (forceRender) {
                    grid.invalidate();
                }
                if (isPortfolioSlickGridSsrmEnabled() && !usesServerSideGridFiltering()) {
                    applyClientViewFiltersAfterLoad();
                }
                if (autoRefreshInterval > 0) {
                    $timeout(function () {loadGridData(true);}, autoRefreshInterval);
                }

                return $q.resolve();
            }

            function setGridRows() {
                dataView.beginUpdate();
                dataView.setItems(rows, getIdProperty());
                dataView.setFilter(myFilter);
                if (scope.current.view.sorts.length) {
                    dataView.sort(sortComparer, true);
                }
                dataView.endUpdate();
                dataView.onRowsChanged.notify({}, null, dataView); // also sync selection when items are replaced
            }

            function totalsFormatter(type, totals, columnDef) {
                const precision = columnDef.precision || 2;

                const val = totals[type] && totals[type][columnDef.field];
                if (val !== null && val !== undefined) {
                    return "<b><span style='font-size: 9px;'>" + type + "</span> " + val.format(precision) + "</b>";
                }

                return "";
            }

            function avgTotalsFormatter(totals, columnDef) {
                return totalsFormatter('avg', totals, columnDef);
            }

            function sumTotalsFormatter(totals, columnDef) {
                return totalsFormatter('sum', totals, columnDef);
            }

            function minTotalsFormatter(totals, columnDef) {
                return totalsFormatter('min', totals, columnDef);
            }

            function maxTotalsFormatter(totals, columnDef) {
                return totalsFormatter('max', totals, columnDef);
            }

            /** Read a row property; keys may differ by PascalCase vs camelCase (API vs JS). */
            function getItemProperty(item, key) {
                if (item == null || key == null) return undefined;
                key = String(key).trim();
                if (key === "") return undefined;
                if (Object.prototype.hasOwnProperty.call(item, key)) return item[key];
                const first = key.charAt(0);
                const alternateFieldKey = first === first.toLowerCase()
                    ? first.toUpperCase() + key.slice(1)
                    : first.toLowerCase() + key.slice(1);
                if (alternateFieldKey !== key && Object.prototype.hasOwnProperty.call(item, alternateFieldKey)) {
                    return item[alternateFieldKey];
                }
                return item[key];
            }

            function myFilter(item, args) {
                // Column header filters always run client-side on the rows currently loaded in the grid.
                for (const columnId in scope.columnFilters) {
                    if (typeof (columnId) !== 'undefined' && scope.columnFilters[columnId] !== "") {
                        const column = grid.getColumns()[grid.getColumnIndex(columnId)];
                        const cellVal = getItemProperty(item, column.field);
                        const headerNeedle = (scope.columnFilters[columnId] || "").trim().toLowerCase();
                        switch (column.formatter) {
                            case Slick.Formatters.DateTime:
                            case Slick.Formatters.Date:
                                if (headerNeedle === "{blank}" || headerNeedle === "blank") {
                                    const isBlankCell = cellVal === undefined || cellVal === null || cellVal === ""
                                        || (typeof cellVal === "string" && cellVal.trim() === "");
                                    if (!isBlankCell) return false;
                                    break;
                                }
                                if (cellVal === undefined || cellVal === null || column.formatter(null, null, cellVal, column).toLowerCase().indexOf(scope.columnFilters[columnId]) === -1) {
                                    return false;
                                }
                                break;
                            case Slick.Formatters.Object:
                            case Slick.Formatters.Percent:
                            case Slick.Formatters.Percent100:
                                if (cellVal === undefined || cellVal === null || column.formatter(null, null, cellVal, column).toLowerCase().indexOf(scope.columnFilters[columnId]) === -1) {
                                    return false;
                                }
                                break;
                            case Slick.Formatters.Float:
                            case Slick.Formatters.Currency:
                                if (cellVal === undefined
                                    || cellVal === null
                                    || (column.formatter(null, null, cellVal, column).toLowerCase().indexOf(scope.columnFilters[columnId]) === -1
                                    && String(cellVal).toLowerCase().indexOf(scope.columnFilters[columnId].toLowerCase().replace(/,/g, "")) === -1)
                                ) {
                                    return false;
                                }
                                break;
                            case Slick.Formatters.Checkmark:
                                if ((scope.columnFilters[columnId] === "True" && cellVal !== true) || (scope.columnFilters[columnId] === "False" && cellVal === true)) {
                                    return false;
                                }
                                break;
                            default:
                                if (String(cellVal).toLowerCase().indexOf(scope.columnFilters[columnId].toLowerCase()) === -1) {
                                    return false;
                                }
                        }
                    }
                }

                if (scope.current.gridQueries) {
                    const queries = scope.current.gridQueries.findAll({enabled: true});
                    for (let h = 0; h < queries.length; h++) {
                        if (!queries[h].filterFn(getItemProperty(item, queries[h].field))) return false;
                    }
                }

                // Sidebar view filters are server-side when OData/SSRM filtering is active.
                if (isPortfolioSlickGridSsrmEnabled() && usesServerSideGridFiltering()) {
                    return true;
                }

                if (scope.current.view.filterType === "Any" && args.filters.length) {  //operator === "any"
                    for (let i = 0; i < args.filters.length; i++) {
                        if (args.filters[i](getItemProperty(item, args.keys[i]))) return true;
                    }
                    return false;
                } else {                                                              //operator === "all"
                    for (let j = 0; j < args.filters.length; j++) {
                        if (!args.filters[j](getItemProperty(item, args.keys[j]))) return false;
                    }
                    return true;
                }
            }

            if (scope.current) {
                scope.current.setQuickFilters = function (filters) {
                    if (filters) {
                        $(grid.getHeaderRow()).find('input').each(function (index, element) {
                            const $element = $(element);
                            const columnId = $element.data("columnId");
                            if (columnId !== null && typeof (columnId) !== 'undefined' && columnId in filters && $element.val() !== filters[columnId]) {
                                scope.columnFilters[columnId] = filters[columnId];
                                $element.val(filters[columnId]);
                            }
                        });
                        dataView.refresh();
                    }
                };
            }

            scope.$watch('columnFilters', function (newVal, oldVal) {
                if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                    $rootScope.$broadcast('event:slickgrid-columnfilter-change', newVal);
                }
            }, true);

            /**
             * Quick-filter expressions are eval'd strings. Saved filters often compare to the literal "{blank}",
             * but date helpers like Date.create(a).is('{blank}') do not treat whitespace-only or '' like null.
             * Rewrite those fragments so blank matching matches header "{blank}" / blank filtering (null, '', trim).
             * Also repairs legacy multi-value arrays saved with manual quoting (e.g. ["smith "jr""]).
             * TODO : remove this when removing opex_rework_2026_orion_connect_pentest_cross_site_39440 feature flag
             */
            function rewriteBlankTokensInExpression(expr) {
                if (typeof expr !== "string") return expr;
                const blankDatePredicate = "(a == null || a === '' || (typeof a === 'string' && a.trim() === ''))";
                const dateIsBlankOrEmpty = /a && Date\.create\(a\)\.is\((['"])(?:\{blank\}|)\1\)/g;
                const lowerCompareBlank = /\(a \? a\.toLowerCase\(\) : ''\) == (['"])\{blank\}\1/g;
                const equalsBlankLiteral = /== (['"])\{blank\}\1/g;
                const unquotedCurrencyNumber = /\$(-?[\d,]+(?:\.\d+)?)/g;
                const legacyBrokenArray = /\[([^\]]+)\]/g;
                return expr
                    .replace(legacyBrokenArray, function (match, inner) {
                        if (!/"\s*[^"\\]+""/.test(inner)) {
                            return match;
                        }
                        const tokens = inner.split(",").map(function (part) {
                            let token = part.trim();
                            if (token.startsWith('"') && token.endsWith('"')) {
                                token = token.slice(1, -1);
                            }
                            return token.replace(/\\'/g, "'").replace(/\\\\/g, "\\");
                        }).filter(function (t) { return t.length > 0; });
                        return tokens.length
                            ? "[" + tokens.map(function (t) { return JSON.stringify(t); }).join(", ") + "]"
                            : match;
                    })
                    .replace(dateIsBlankOrEmpty, blankDatePredicate)
                    .replace(lowerCompareBlank, "(a ? a.toLowerCase() : '') == ''")
                    .replace(equalsBlankLiteral, "== ''")
                    .replace(unquotedCurrencyNumber, '$1');
            }
            function setFilters(filters) {
                if (isPortfolioSlickGridSsrmEnabled()
                    && (usesServerSideGridFiltering() || isPortfolioODataSidebarList())) {
                    dataView.setFilterArgs({
                        filters: [],
                        keys: []
                    });
                    return;
                }

                const functions = [];
                const keys = [];
                // TODO : remove this when removing opex_rework_2026_orion_connect_pentest_cross_site_39440 feature flag
                if (isPentestCrossSiteFilterReworkEnabled) {
                    const format = window.slickGridFilterFormat;
                    const view = scope.current && scope.current.view;
                    const alreadyNewFormat = !!(view && view.isNewSlickGridFilter);
                    if (alreadyNewFormat) {
                        (filters || []).forEach(function (filter) {
                            if (!filter.include || filter.odataSync) {
                                return;
                            }
                            if (format && format.hasStructuredOperator(filter)) {
                                functions.push(format.createFilterFn(filter));
                                keys.push(filter.key);
                            }
                        });
                    } else {
                        (filters || []).forEach(function (filter) {
                            if (filter.include && !filter.odataSync && filter.value) {
                                const fn = eval(rewriteBlankTokensInExpression(filter.value));
                                functions.push(fn);
                                keys.push(filter.key);
                            }
                        });
                    }
                } else {
                    (filters || []).forEach(function (filter) {
                        if (filter.include && !filter.odataSync && filter.value) {
                            const fn = eval(rewriteBlankTokensInExpression(filter.value));
                            functions.push(fn);
                            keys.push(filter.key);
                        }
                    });
                }
                (filters || []).forEach(function (filter) {
                    // File filters only run on the server; here they match nothing rather than show unfiltered rows.
                    if (filter && filter.include && filter.fileFilter) {
                        functions.push(function () { return false; });
                        keys.push('id');
                    }
                });
                dataView.setFilterArgs({
                    filters: functions,
                    keys: keys
                });
            }

            function refreshGridClientFilters() {
                if (!scope.current || !scope.current.view) {
                    return;
                }
                setFilters(scope.current.view.filters);
                dataView.refresh();
            }

            function applyClientViewFiltersAfterLoad() {
                if (!isPortfolioSlickGridSsrmEnabled()) {
                    return;
                }
                if (!scope.current || !scope.current.view || usesServerSideGridFiltering()) {
                    return;
                }

                var sync = window.slickGridODataSidebarSync;
                var portfolioSync = window.portfolioListODataSidebarSync;
                var profileKey = scope.current.odataListProfileKey;
                if (sync && sync.prepareViewFiltersForClientSide && profileKey && portfolioSync) {
                    var profile = portfolioSync.resolveProfile(profileKey);
                    sync.prepareViewFiltersForClientSide(
                        scope.current.view.filters,
                        scope.current.view.slickGridColumnDefs,
                        profile
                    );
                }

                setFilters(scope.current.view.filters);
                dataView.refresh();
            }

            function sortComparer(row1, row2) {
                const sorts = scope.current.view.sorts;

                for (let i = 0, l = sorts.length; i < l; i++) {
                    const field = sorts[i].field,
                        sign = sorts[i].sortAsc ? 1 : -1;
                    let x = row1[field] || "000",
                        y = row2[field] || "000";

                    if (typeof x === 'string') {
                        x = x.toLowerCase();
                    }
                    if (typeof y === 'string') {
                        y = y.toLowerCase();
                    }

                    const result = (x < y ? -1 : (x > y ? 1 : 0)) * sign;
                    if (result !== 0) {
                        return result;
                    }
                }

                return row1[getIdProperty()] > row2[getIdProperty()] ? 1 : -1;
            }

            function queueAndExecuteCommand(item, column, editCommand) {
                commandQueue.push(editCommand);
                editCommand.execute();
            }

            function convertStrToFns(columns) {
                columns.forEach(function (column) {
                    if (column.editor){
                        column.editor = eval(column.editor);
                    }

                    if (column.formatter) {
                        column.formatter = eval(column.formatter);
                    }

                    if (column.groupTotalsFormatter) {
                        column.groupTotalsFormatter = eval(column.groupTotalsFormatter);
                    }

                    if (column.enableEdit) {
                        column.enableEdit = eval(column.enableEdit);
                    }

                    if (column.comparer) {
                        column.comparer = eval(column.comparer);
                    }

                    if (column.aggregators) {
                        for (let i = 0; i < column.aggregators.length; i++) {
                            column.aggregators[i] = eval(column.aggregators[i]);
                        }
                    }
                });
            }

            function cleanData(data) {
                if (!attrs.compositeKey) return;

                const keys = attrs.compositeKey.split(',');
                const totalKeys = keys.length;

                const buildId = function (item) {
                    let id = "";
                    for (let j = 0; j < totalKeys; j++) {
                        id += item[keys[j]] + '/';
                    }
                    item.id = id.first(id.length - 1);
                };

                if (angular.isArray(data)) {
                    for (let i = data.length - 1; i >= 0; i--) {
                        buildId(data[i]);
                    }
                } else {
                    buildId(data);
                }
            }

            function setSlickGridExportLoadingMessage(message) {
                loadingService.start(slickGridExportLoadingKey, message);
            }

            function stopSlickGridExportLoading() {
                loadingService.stop(slickGridExportLoadingKey);
            }

            function measureExportRowJsonBytes(row) {
                return angular.toJson(row).length;
            }

            function getSlickGridExportJsonOverhead(columns, separatedFileColumns) {
                let overhead = angular.toJson(columns).length + 15;

                if (separatedFileColumns)
                {
                    overhead += angular.toJson(separatedFileColumns).length + 22;
                }

                return overhead;
            }

            function estimateSlickGridExportBytes(columns, rows, separatedFileColumns, start, end) {
                start = start || 0;
                end = end === undefined ? rows.length : end;
                const rowCount = end - start;

                if (rowCount <= 0)
                {
                    return 0;
                }

                const overhead = getSlickGridExportJsonOverhead(columns, separatedFileColumns);
                const maxSamples = Math.min(rowCount, slickGridExportMaxEstimateSamples);
                const segmentCount = Math.min(maxSamples, slickGridExportEstimateSegments);
                const samplesPerSegment = Math.max(1, Math.ceil(maxSamples / segmentCount));
                let totalSampleBytes = 0;
                let maxRowBytes = 0;
                let sampleCount = 0;

                for (let segment = 0; segment < segmentCount; segment++)
                {
                    const segmentStart = start + Math.floor(segment * rowCount / segmentCount);
                    const segmentEnd = start + Math.floor((segment + 1) * rowCount / segmentCount);
                    const segmentSize = segmentEnd - segmentStart;

                    if (segmentSize <= 0)
                    {
                        continue;
                    }

                    const step = Math.max(1, Math.floor(segmentSize / samplesPerSegment));

                    for (let i = segmentStart; i < segmentEnd && sampleCount < maxSamples; i += step)
                    {
                        const rowBytes = measureExportRowJsonBytes(rows[i]) + 1;
                        totalSampleBytes += rowBytes;

                        if (rowBytes > maxRowBytes)
                        {
                            maxRowBytes = rowBytes;
                        }

                        sampleCount++;
                    }
                }

                const avgRowBytes = totalSampleBytes / sampleCount;
                const conservativeRowBytes = avgRowBytes + ((maxRowBytes - avgRowBytes) * 0.85);
                return overhead + (conservativeRowBytes * rowCount);
            }

            function willRequireExportSplit(columns, rows, separatedFileColumns, maxBytes) {
                return estimateSlickGridExportBytes(columns, rows, separatedFileColumns) > maxBytes;
            }

            function buildSlickGridExportBlob(columns, rows, separatedFileColumns, start, end) {
                start = start || 0;
                end = end === undefined ? rows.length : end;

                const parts = [
                    '{"columns":',
                    angular.toJson(columns),
                    ',"data":[',
                ];

                for (let index = start; index < end; index++)
                {
                    if (index > start)
                    {
                        parts.push(',');
                    }
                    parts.push(angular.toJson(rows[index]));
                }

                parts.push(']');

                if (separatedFileColumns)
                {
                    parts.push(',"separatedFileColumns":');
                    parts.push(angular.toJson(separatedFileColumns));
                }

                parts.push('}');

                return new Blob(parts, { type: 'application/json' });
            }

            function downloadSlickGridExportViaNavigation(response) {
                return $timeout(function () {
                    const link = document.createElement('a');
                    link.href = response.headers("location") + "?Authorization=" + sessionStorage.oas_token;
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }, 0);
            }

            function postAndEnqueueGridExport(request) {
                setSlickGridExportLoadingMessage('Preparing your export.');

                return $http.post('/Utility/GridExport', request, {
                    tracker: slickGridExportLoadingKey,
                    trackerMsg: 'Preparing your export.'
                }).then(function () {
                    stopSlickGridExportLoading();
                    return $dialog.actionComplete(
                        'Your export is being prepared. You will receive a notification when it is ready.'
                    ).open();
                });
            }

            function executeServerGridExport(exportRequest) {
                setSlickGridExportLoadingMessage('Preparing your export.');

                return $http.post('/Utility/GridExport/Count', exportRequest, {
                    tracker: slickGridExportLoadingKey,
                    trackerMsg: 'Preparing your export.'
                }).then(function (response) {
                    var count = (response.data || {}).count || 0;

                    if (count === 0) {
                        stopSlickGridExportLoading();
                        return $dialog.messageBox('No rows match the current filters.').open();
                    }

                    return postAndEnqueueGridExport(exportRequest);
                }).finally(function () {
                    stopSlickGridExportLoading();
                });
            }

            function postAndDownloadSlickGridExport(exportBlob, args, utcOffsetMinutes, batchNumber, estimatedTotal) {
                const trackerMsg = estimatedTotal > 1
                    ? 'Exporting grid data (file ' + batchNumber + ')'
                    : 'Exporting grid data';

                setSlickGridExportLoadingMessage(trackerMsg);

                return postSlickGridExportBlob(exportBlob, args, utcOffsetMinutes, batchNumber, estimatedTotal)
                    .then(function (response) {
                        return downloadSlickGridExportViaNavigation(response);
                    });
            }

            function exportRowRange(columns, rows, args, utcOffsetMinutes, start, end, batchState) {
                const rowCount = end - start;

                if (rowCount <= 0)
                {
                    return $q.resolve();
                }

                if (rowCount === 1)
                {
                    const singleRowBlob = buildSlickGridExportBlob(columns, rows, args.separatedFileColumns, start, end);

                    if (singleRowBlob.size > slickGridExportMaxBlobBytes)
                    {
                        throw new Error('A single row exceeds the export size limit.');
                    }

                    batchState.current++;
                    return postAndDownloadSlickGridExport(singleRowBlob, args, utcOffsetMinutes, batchState.current, batchState.estimatedTotal);
                }

                const estimatedBytes = estimateSlickGridExportBytes(columns, rows, args.separatedFileColumns, start, end);

                if (estimatedBytes <= slickGridExportMaxBlobBytes)
                {
                    const exportBlob = buildSlickGridExportBlob(columns, rows, args.separatedFileColumns, start, end);

                    if (exportBlob.size <= slickGridExportMaxBlobBytes)
                    {
                        batchState.current++;
                        return postAndDownloadSlickGridExport(exportBlob, args, utcOffsetMinutes, batchState.current, batchState.estimatedTotal);
                    }
                }

                const mid = start + Math.floor(rowCount / 2);
                return exportRowRange(columns, rows, args, utcOffsetMinutes, start, mid, batchState)
                    .then(function () {
                        return exportRowRange(columns, rows, args, utcOffsetMinutes, mid, end, batchState);
                    });
            }

            function postSlickGridExportBlob(exportBlob, args, utcOffsetMinutes, batchNumber, estimatedTotal) {
                const exportUrl = '/Utility/SlickGridExport/' + (args.separatedFileColumns ? 'zip' : args.format || 'csv');
                const trackerMsg = estimatedTotal > 1
                    ? 'Exporting grid data (file ' + batchNumber + ')'
                    : 'Exporting grid data';

                return $http.post(exportUrl, exportBlob, {
                    params: { utcOffsetMinutes: utcOffsetMinutes },
                    tracker: slickGridExportLoadingKey,
                    trackerMsg: trackerMsg,
                    allowCancellation: false,
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': 'application/json;charset=utf-8' },
                });
            }

            function prepareAndExecuteSlickGridExport(columns, rows, args, utcOffsetMinutes) {
                setSlickGridExportLoadingMessage('Exporting grid data');

                const estimatedTotalBytes = estimateSlickGridExportBytes(columns, rows, args.separatedFileColumns);
                const batchState = {
                    current: 0,
                    estimatedTotal: Math.max(1, Math.ceil(estimatedTotalBytes / slickGridExportMaxBlobBytes)),
                };

                return $timeout(function () {
                    return exportRowRange(columns, rows, args, utcOffsetMinutes, 0, rows.length, batchState);
                }, 0).finally(function () {
                    stopSlickGridExportLoading();
                });
            }

            function postSlickGridLargeExport(columns, rows, args, utcOffsetMinutes) {
                if (!willRequireExportSplit(columns, rows, args.separatedFileColumns, slickGridExportMaxBlobBytes))
                {
                    return prepareAndExecuteSlickGridExport(columns, rows, args, utcOffsetMinutes);
                }

                const confirmMessage = 'The export data is too large for a single file and will be split into multiple separate files. Do you want to continue?';

                return $dialog.confirmAction(confirmMessage)
                    .open()
                    .then(function (result) {
                        if (result === 'yes')
                        {
                            return prepareAndExecuteSlickGridExport(columns, rows, args, utcOffsetMinutes);
                        }

                        return $q.resolve();
                    });
            }

            function extractIds(itemIds) {
                if (!attrs.compositeKey) return itemIds;

                const keys = attrs.compositeKey.split(',');
                const totalKeys = keys.length;
                const parsedIds = [];

                for (let i = itemIds.length - 1; i >= 0; i--) {
                    const values = itemIds[i].split('/');
                    const idObject = {};
                    for (let j = 0; j < totalKeys; j++) {
                        idObject[keys[j]] = values[j];
                    }
                    parsedIds[i] = idObject;
                }

                return parsedIds;
            }

            function extractItems(itemIds) {
                const items = [];
                itemIds.forEach(function (id) {
                    items.push(dataView.getItemById(id));
                });
                return items;
            }

            function clearNewRows() {
                rows.forEach(function (row) {
                    if (row.hasOwnProperty('isNewRow')) {
                        delete row.isNewRow;
                    }
                });
            }

            function loadHotKeys() {
                if (listHotKeys) {
                    listHotKeys.addActions(scope.current.hotKeyActions);
                }
            }

            function isAllAdjacent(indexes) {
                return indexes.length === (indexes.max() - indexes.min() + 1);
            }

            function setColumns(viewDefColumns) {
                const columns = angular.copy(viewDefColumns);
                convertStrToFns(columns);
                grid.setColumns(columns.filter({visible: true}));
            }

            function setGroupings(viewDefGroups) {
                const groups = angular.copy(viewDefGroups);
                convertStrToFns(groups);
                dataView.setGrouping(groups.filter({enabled: true}));
            }

            function setSorts(sorts) {
                grid.setSortColumns(sorts);
            }

            function getIdProperty() {
                return attrs.idProperty || "id";
            }

            splitIoService.getBoolTreatment(pentestCrossSiteFilterReworkFlag).subscribe(function (isEnabled) {
                // TODO : remove this when removing opex_rework_2026_orion_connect_pentest_cross_site_39440 feature flag
                isPentestCrossSiteFilterReworkEnabled = isEnabled === true;
                window.isPentestCrossSiteFilterReworkEnabled = isPentestCrossSiteFilterReworkEnabled;
                if (isPentestCrossSiteFilterReworkEnabled && scope.current && scope.current.view && scope.current.view.filters) {
                    setFilters(scope.current.view.filters);
                    dataView.refresh();
                }
            });

            //INITIALIZE
            init();


            //GRID EVENT REGISTRATIONS
            $(grid.getHeaderRow()).on("change input", ":input", (function () {
                const columnId = $(this).data("columnId");
                if (columnId !== null && typeof(columnId) !== 'undefined') {
                    scope.columnFilters[columnId] = ($(this).val()).trim();
                    dataView.refresh();
                }
            }).debounce(250));

            grid.onHeaderRowCellRendered.subscribe(function (e, args) {
                $(args.node).empty();
                let input;
                const id = `data-test-id='sgf-${args.column.id}'`;
                const title = `title='${args.column.id} Slick Grid ${args.column.conditions && args.column.conditions.length || args.column.conditionType === 'basicBoolean' || args.column.formatter === Slick.Formatters.Status ? 'Select' : 'Search'}'`;
                const elementAttributeInserts = id + ' ' + title;

                if (args.column.conditions && args.column.conditions.length) {
                    input = "<select " + elementAttributeInserts +"><option>" + args.column.conditions[0].select1.join("</option><option>") + "</option></select>";
                } else if (args.column.conditionType === 'basicBoolean') {
                    input = "<select " + elementAttributeInserts +"><option></option><option>True</option><option>False</option></select>";
                } else if (args.column.formatter === Slick.Formatters.Status) {
                    input = "<select " + elementAttributeInserts +"><option></option><option>Success</option><option>Warning</option><option>Error</option><option>Info</option></select>";
                } else {
                    input = "<input " + elementAttributeInserts +" type='text' />";
                }
                $(input)
                    .data("columnId", args.column.id)
                    .val(scope.columnFilters[args.column.id])
                    .appendTo(args.node);
            });

            grid.onColumnsResized.subscribe(function (e, args) {
                const updatedCols = args.grid.getColumns();
                updatedCols.forEach(function (updatedCol) {
                    scope.current.view.slickGridColumnDefs.find({id: updatedCol.id}).width = updatedCol.width;
                });
            });

            grid.onColumnsReordered.subscribe(function (e, args) {
                const updatedCols = args.grid.getColumns();
                scope.current.view.slickGridColumnDefs.forEach(function (col) {
                    const index = updatedCols.findIndex({id: col.id});
                    col.sortOrder = index === -1 ? 100 : index;
                });

                scope.current.view.slickGridColumnDefs.sort(function (a, b) {
                    if (a.sortOrder === b.sortOrder)
                        return (a.id > b.id ? 1 : -1);
                    else
                        return a.sortOrder > b.sortOrder ? 1 : -1;
                });

                scope.$apply();
            });

            grid.onActiveCellChanged.subscribe(function (e, args) {
                const column = grid.getColumns()[args.cell];
                if (!column) return;

                const field = dataView.getItem(args.row)[column.field];
                let arg, value;
                if (column.formatter === Slick.Formatters.Object) {
                    arg = "a." + (column.formatterField || "name");
                    value = field[column.formatterField || "name"];
                } else {
                    arg = "a";
                    value = field;
                }
                if (value === undefined) return;

                const isBlank = value === null || value === "" || (typeof value === "string" && value.trim() === "");
                const blankDateFilter = "(function (a) { return a == null || a === '' || (typeof a === 'string' && a.trim() === ''); })";
                const escapedValue = String(value)
                    .replace(/\\/g, "\\\\")
                    .replace(/'/g, "\\'")
                    .replace(/\r/g, "\\r")
                    .replace(/\n/g, "\\n")
                    .replace(/\u2028/g, "\\u2028")
                    .replace(/\u2029/g, "\\u2029");
                const escapedValueOrBlank = String(value || "")
                    .replace(/\\/g, "\\\\")
                    .replace(/'/g, "\\'")
                    .replace(/\r/g, "\\r")
                    .replace(/\n/g, "\\n")
                    .replace(/\u2028/g, "\\u2028")
                    .replace(/\u2029/g, "\\u2029");

                let filter;
                if (column.conditions) {
                    filter = "(function (a) { return " + arg + " === '" + escapedValue + "'; })";
                } else if (column.conditionType === "basicNumber" || column.conditionType === "basicBoolean") {
                    const compareValue = column.conditionType === "basicNumber"
                        ? String(value).replace(/\$/g, "")
                        : value;
                    filter = "(function (a) { return " + arg + " === " + compareValue + "; })";
                } else if (column.conditionType === "basicDate" && isBlank) {
                    filter = blankDateFilter;
                } else {
                    filter = "(function (a) { return (" + arg + " || '') == '" + escapedValueOrBlank + "'; })";
                }

                scope.safeApply(function () {
                    scope.current.view.quickFilter = {
                        name: column.name + " = " + (isBlank ? "{blank}" : value),
                        value: filter,
                        key: column.field,
                        include: true,
                        rawValue: value,
                        conditionType: column.conditionType,
                        isBlank: isBlank
                    };
                    scope.current.view.clipboardText = value == null ? "" : value;
                });
            });

            if (options.editable) {
                grid.onBeforeEditCell.subscribe(function (e, args) {
                    if (attrs.onBeforeEditCell != null) {
                        scope.$emit(attrs.onBeforeEditCell, args);
                    }
                    return args.column.enableEdit ? args.column.enableEdit(args) : true;
                });

                grid.onCellChange.subscribe(function (e, args) {
                    let updateCall;
                    if(scope.suppressCellChange) {
                        return; //skip the execution
                    }
                    if (scope.current.grid && scope.current.grid.update) {
                        updateCall = scope.current.grid.update({
                            params: {id: args.item[getIdProperty()]},
                            data: args.item
                        });
                    } else {
                        let updateEndpoint = (attrs.updateUrl || attrs.url) + '/' + encodeURIComponent(args.item[getIdProperty()]);
                        const itemId = args.item[getIdProperty()];

                        const makeUpdateCall = function () {
                            return $http.put(updateEndpoint + (attrs.updateParameters ? '?' + attrs.updateParameters : ''), args.item, {ignoreExceptions: [409], trackerMsg: 'Saving changes for ID ' + itemId + ', Cell ' + args.cell});
                        };

                        if (dynamicFields.isEnabled && dynamicFields.completeIds.none(itemId)) {
                            updateCall = $http.get(updateEndpoint + (resolvedParameters ? '?' + resolvedParameters : ''), {trackerMsg: 'Loading data for ID ' + itemId})
                                .then(function (response) {
                                    const data = response.data;

                                    cleanData(data);
                                    args.item = angular.extend(data, args.item);

                                    dynamicFields.completeIds.push(itemId);

                                    return makeUpdateCall();
                                });
                        } else {
                            updateCall = makeUpdateCall();
                        }
                    }

                    scope.safeApply(function () {
                            updateCall
                            .then(function (response) {
                                cleanData(response.data);
                                if (angular.isArray(response.data)) {
                                    dataView.updateItems(response.data);
                                } else {
                                    dataView.updateItem(args.item[getIdProperty()], response.data);
                                }

                                if (attrs.onEditEvent) {
                                    scope.$emit(attrs.onEditEvent, response.data);
                                }
                            })
                            .catch(function (response) {
                                if (response.status === 409) {
                                    cleanData(response.data);
                                    if (angular.isArray(response.data)) {
                                        dataView.updateItems(response.data);
                                    } else {
                                        dataView.updateItem(args.item[getIdProperty()], response.data);
                                    }

                                    if (attrs.onEditEvent) {
                                        scope.$emit(attrs.onEditEvent, response.data);
                                    }
                                    $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Stale Data", "The row has changed since your last refresh.  The update has been rolled back and the row has been refreshed with the current data.").open();
                                } else {
                                    scope.suppressCellChange = true;
                                    dynamicFields.completeIds = [];
                                    const command = commandQueue.pop();
                                    if (command && Slick.GlobalEditorLock.cancelCurrentEdit()) {
                                        command.undo();
                                        grid.gotoCell(command.row, command.cell, false);
                                    }
                                    scope.$evalAsync(()=> { // Suppress the cell change event when performing an undo operation
                                        scope.suppressCellChange = false;
                                    })
                                }
                            });
                    });
                });
            }

            grid.onKeyDown.subscribe(function (e) {
                if (e.ctrlKey) {
                    if (e.which === 65) { //ctrl-a, select all rows
                        grid.setSelectedRows((0).upto(dataView.getLength() - 1));

                        e.preventDefault();
                        return true;
                    } else if (e.which === 67) { //ctrl-c, copy cell text
                        const textArea = document.createElement("textarea");
                        textArea.value = scope.current.view.clipboardText;
                        document.body.appendChild(textArea);
                        textArea.focus();
                        textArea.select();
                        document.execCommand('copy');
                        document.body.removeChild(textArea);

                        e.preventDefault();
                        return true;
                    }
                }

                return false;
            });

            //this is wrapped in timeout because the context menu from the previous screen still exists momentarily resulting in 2 '.context-menu's being found
            setTimeout(function () {
                const contextMenu = $('.context-menu');

                if (contextMenu.length) {
                    grid.onContextMenu.subscribe(function (e) {
                        e.preventDefault();

                        const cell = grid.getCellFromEvent(e);
                        const dataItem = grid.getDataItem(cell.row);

                        if (scope.selectedIds.indexOf(dataItem[getIdProperty()]) === -1 || scope.contextOnGroup) {
                            grid.setSelectedRows([cell.row]);
                        }

                        scope.$apply(function () {
                            scope.contextOnGroup = dataItem.__group;
                        });

                        const x = e.pageX, y = e.pageY;
                        const windowHeight = $window.innerHeight, windowWidth = $window.innerWidth;
                        const menuHeight = contextMenu.outerHeight(), menuWidth = contextMenu.outerWidth();

                        contextMenu
                            .css("top", y + menuHeight > windowHeight ? y - menuHeight < 5 ? 5 : y - menuHeight : y)
                            .css("left", x + menuWidth > windowWidth ? x - menuWidth : x)
                            .css("z-index", 1031)
                            .show();

                        $("body").one("click", function () {
                            contextMenu.hide();
                        });
                    });

                    contextMenu.on("click" ,function (e) {
                        const clickedCtrl = $(e.target).is("a") ? $(e.target) : $(e.target).parent();  //use parent if they clicked the icon

                        if (!clickedCtrl.attr("url") || !grid.getEditorLock().commitCurrentEdit() || scope.selectedIds.length === 0) {
                            return;
                        }

                        let url = clickedCtrl.attr("url");

                        const doAction = function () {
                            const verb = clickedCtrl.attr("verb").toUpperCase();
                            const clientAction = (clickedCtrl.attr("client-action") || '').toLowerCase();
                            const selectedIds = angular.copy(scope.selectedIds);  //make a copy in case they change selected rows before the PUT request completes
                            const dataToSend = (clickedCtrl.attr("send-full-object") || 'false').toLowerCase() === "true" ? extractItems(selectedIds) : extractIds(selectedIds);

                            $http({method: verb, url: url, data: dataToSend, trackerMsg: 'Updating selected rows'})
                                .then(function (response) {
                                    let data = response.data;

                                    if (clientAction) {
                                        let processedIds;
                                        switch (clientAction) {
                                            case "update":
                                                cleanData(data);

                                                dataView.updateItems(data); //data = array of objects
                                                processedIds = data.map(getIdProperty());
                                                break;
                                            case "delete":
                                                if (attrs.compositeKey) {
                                                    cleanData(data);
                                                    data = data.map(getIdProperty());
                                                }
                                                dataView.deleteItems(data); //data = array of IDs
                                                processedIds = data;

                                                break;
                                            case 'refresh':
                                                processedIds = selectedIds;  // on refresh, setting selectedIds to processedIds will bypass grid message
                                                loadGridData(true, dynamicFields.isEnabled ? dynamicFields.loaded : undefined);
                                                break;
                                        }

                                        if (attrs.onActionEvent) {
                                            scope.$emit(attrs.onActionEvent, {action: clientAction, data: data});
                                        }

                                        const remainingIds = selectedIds.subtract(processedIds);
                                        if (remainingIds.length > 0) {
                                            const rows = [];
                                            remainingIds.forEach(function (id) {
                                                rows.push(dataView.getRowById(id));
                                            });
                                            grid.setSelectedRows(rows);

                                            let title, message;
                                            if (processedIds.length === 0) {
                                                title = "<i class='fa fa-exclamation-circle fa-lg text-error' aria-hidden='true'></i> Incomplete Action";
                                                message = "None of the selected rows";
                                            } else {
                                                title = "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Partial Completion";
                                                message = remainingIds.length + " of the " + selectedIds.length + " selected row(s) did not";
                                            }

                                            $dialog.messageBox(title, message + " meet the criteria for this action.  They remain highlighted in the grid.").open();
                                        } else {
                                            grid.setSelectedRows([]);
                                        }
                                    }
                                });
                        };

                        const confirmMsg = clickedCtrl.attr("confirm-msg");
                        if (confirmMsg) {
                            scope.$apply(function () {
                                $dialog.confirmAction(confirmMsg)
                                    .open()
                                    .then(function (result) {
                                        if (result === 'yes') {
                                            doAction();
                                        }
                                    });
                            });
                        } else {
                            const promptOptions = scope.$eval(clickedCtrl.attr("prompt-options"));
                            if (promptOptions) {
                                scope.$apply(function () {
                                    $dialog.dialog(angular.extend({templateUrl: "app/modals/inputBox.html", controller: "InputBoxCtrl"}, promptOptions))
                                        .open()
                                        .then(function (result) {
                                                if (result !== null && result !== undefined) {
                                                    url = url.replace("{0}", encodeURIComponent(result));
                                                    doAction();
                                                }
                                            }
                                        );
                                });
                            } else {
                                scope.$apply(function () {
                                    doAction();
                                });
                            }
                        }
                    });
                }
            });

            grid.onDblClick.subscribe(function (e) {
                if (!dblClickFn) return;

                scope.safeApply(function () {
                    dblClickFn();
                });
            });

            grid.onSort.subscribe(function (e, args) {
                scope.current.view.sorts = args.sortCols.map(function (sC) {
                    return {columnId: sC.sortCol.id, field: sC.sortCol.field, sortAsc: sC.sortAsc};
                });
                if (isPortfolioSlickGridSsrmEnabled()) {
                    if (dynamicFields.isEnabled) {
                        cancelPendingGridLoad();
                        loadGridFromDynamicFields('sorts').then(function () {
                            applyPortfolioClientSort();
                        });
                        return;
                    }
                    applyPortfolioClientSort();
                    return;
                }
                dataView.sort(sortComparer, true);
            });

            grid.onSelectedRowsChanged.subscribe(function (e, args) {
                const indexes = args.rows, selectedIds = [], selectedItems = [];
                if (isAllAdjacent(indexes)) { //If adjacent, assume use of shift key and order ascending
                    indexes.sort(function (a, b) { //sort is handled in Unicode code point order; must add compare function to sort in order to sort numerically
                        return a - b;
                    });
                }
                if (indexes.length === 1) {
                    const selectedRow = grid.getDataItem(indexes[0]);
                    if (selectedRow.__group) {
                        const rows = [];
                        selectedRow.rows.forEach(function (row) {
                            rows.push(dataView.getRowById(row[getIdProperty()]));
                        });
                        grid.setSelectedRows(rows);
                        return;
                    }
                }

                indexes.forEach(function (index) {
                    const dataItem = grid.getDataItem(index);
                    if (!dataItem.__nonDataRow) {
                        selectedItems.push(dataItem);
                        selectedIds.push(dataItem[getIdProperty()]);
                    }
                });

                if (attrs.onSelectEvent) {
                    scope.$emit(attrs.onSelectEvent, selectedItems);
                }
                scope.selectedIds.length = 0;
                scope.safeApply(function () {
                    scope.selectedIds.add(selectedIds);
                });
            });

            grid.init();


            //DATAVIEW EVENT REGISTRATIONS
            dataView.onRowCountChanged.subscribe(function () {
                grid.updateRowCount();
                grid.render();
            });

            dataView.onRowsChanged.subscribe(function (e, args) {
                grid.invalidateRows(args.rows);
                grid.render();
            });


            //ANGULAR EVENT REGISTRATION
            if (attrs.reloadEvents) {
                const events = attrs.reloadEvents.split(",").map(e => e.trim());
                const performAction = function (args) {
                    switch (args.action) {
                        case "new-data":
                            $http.get(args.newDataUrl, { trackerMsg: 'Fetching new rows' })
                                .then(function (response) {
                                    const data = response.data;

                                    clearNewRows();
                                    //grid.scrollRowIntoView(0, false);
                                    cleanData(data);

                                    dataView.beginUpdate();
                                    data.forEach(function (row) {
                                        row.isNewRow = true;
                                        if (dataView.getItemById(row[getIdProperty()])) {
                                            dataView.updateItem(row[getIdProperty()], row);
                                        } else {
                                            dataView.insertItem(0, row);
                                        }
                                    });
                                    dataView.endUpdate();
                                });
                            break;
                        case "set-data":
                            clearNewRows();
                            cleanData(args.newData);
                            dataView.beginUpdate();
                            const dvItems = dataView.getItems();
                            if (dvItems.length > 0) {
                                dataView.deleteItems(dvItems.map("id"));
                            }
                            args.newData.forEach(function (row) {
                                row.isNewRow = true;
                                if (dataView.getItemById(row[getIdProperty()])) {
                                    dataView.updateItem(row[getIdProperty()], row);
                                } else {
                                    dataView.insertItem(0, row);
                                }
                            });
                            dataView.endUpdate();
                            break;
                        case "send-data":
                            $http({ method: args.verb.toUpperCase(), url: args.url, data: dataView.getItems(), trackerMsg: args.trackerMsg ? args.trackerMsg : "Sending grid data" })
                                .then(function (response) {
                                    if (args.successCallback) {
                                        args.successCallback(response);
                                    }
                                });
                            break;
                        case "export-data":
                            var exportProfileKey = scope.current && scope.current.odataListProfileKey;
                            var exportProfile = exportProfileKey
                                && window.portfolioListODataSidebarSync
                                && window.portfolioListODataSidebarSync.resolveProfile(exportProfileKey);
                            if (exportProfile && exportProfile.gridExportKey && window.slickGridExportRequestBuilder
                                && window.slickGridODataSidebarSync
                                && window.slickGridODataSidebarSync.isRecordColumnLimitFeatureEnabled
                                && window.slickGridODataSidebarSync.isRecordColumnLimitFeatureEnabled(scope)) {
                                try {
                                    var exportRequest = window.slickGridExportRequestBuilder.buildSlickGridExportRequest(
                                        scope,
                                        $location,
                                        exportProfile
                                    );
                                    executeServerGridExport(exportRequest)
                                        .catch(function (exportErr) {
                                            if (exportErr && exportErr.cancelled) {
                                                return;
                                            }

                                            throw exportErr;
                                        });
                                    break;
                                } catch (exportError) {
                                    if (exportError && exportError.fallbackToLoadedRows) {
                                        $dialog.messageBox(
                                            (exportError.message || 'Server export unavailable.') + ' Exporting loaded rows only.'
                                        ).open();
                                    } else {
                                        throw exportError;
                                    }
                                }
                            }

                            const offsetDate = new Date();
                            const exportRows = dataView.getRows().exclude({ __nonDataRow: true });
                            const exportColumns = grid.getColumns();

                            splitIoService.getBoolTreatment(slickGridLargeExportSplitFlag).subscribe(function (isLargeExportSplitEnabled) {
                                if (isLargeExportSplitEnabled)
                                {
                                    postSlickGridLargeExport(exportColumns, exportRows, args, offsetDate.getTimezoneOffset());
                                }
                                else
                                {
                                    $http.post('/Utility/SlickGridExport/' + (args.separatedFileColumns ? 'zip' : args.format || 'csv'), { columns: grid.getColumns(), data: dataView.getRows().exclude({ __nonDataRow: true }), separatedFileColumns: args.separatedFileColumns }, { params: { utcOffsetMinutes: offsetDate.getTimezoneOffset() }, trackerMsg: 'Exporting grid data'})
                                    .then(function (response) {
                                        $window.location.href = response.headers("location") + "?Authorization=" + sessionStorage.oas_token;
                                    });
                                }
                            });
                            break;
                        case "add-item":
                            clearNewRows();
                            cleanData(args.item);
                            args.item.isNewRow = true;
                            dataView.addItem(args.item);
                            break;
                        case "add-items":
                            clearNewRows();
                            cleanData(args.items);
                            if (args.markAsNew !== false) {
                                args.items.forEach(function (item) {
                                    item.isNewRow = true;
                                });
                            }
                            dataView.addItems(args.items);
                            break;
                        case "upsert-items":
                            clearNewRows();
                            cleanData(args.items);
                            const newItems = [],
                                updatedItems = [];
                            args.items.forEach(function (item) {
                                if (dataView.getItemById(item[getIdProperty()])) {
                                    updatedItems.push(item);
                                } else {
                                    item.isNewRow = true;
                                    newItems.push(item);
                                }
                            });
                            dataView.updateItems(updatedItems);
                            dataView.addItems(newItems);
                            break;
                        case "delete-item":
                            cleanData(args.item);
                            dataView.deleteItem(args.item[getIdProperty()]);
                            break;
                        case "delete-items":
                            cleanData(args.items);
                            dataView.deleteItems(args.items);
                            break;
                        case "clear-items":
                            dataView.setItems([]);
                            break;
                        case "get-items":
                            const items = dataView.getItems();
                            if (args.callbackFn) {
                                args.callbackFn(items);
                            } else {
                                scope.$emit('slickgrid-getitems', items);
                            }
                            break;
                        case "get-filtered":
                            const rows = dataView.getRows();
                            if (args.callbackFn) {
                                args.callbackFn(rows);
                            } else {
                                scope.$emit('slickgrid-getfiltered', rows);
                            }
                            break;
                        case "update-item":
                            cleanData(args.item);
                            dataView.updateItem(args.item[getIdProperty()], args.item);
                            break;
                        case "update-items":
                            cleanData(args.items);
                            dataView.updateItems(args.items);
                            break;
                        case "refresh-grid":
                            if (isPortfolioSlickGridSsrmEnabled()) {
                                cancelPendingGridLoad();
                                applyCurrentViewToGrid();
                                if (dynamicFields.isEnabled) {
                                    loadGridFromDynamicFields(null, { fullRefresh: true });
                                } else {
                                    loadGridData(true, undefined, { replaceRows: true });
                                }
                            } else if (loadInProgress) {
                                const cancelWatcher = scope.$watch(function () {
                                    return loadInProgress;
                                }, function (newValue) {
                                    if (newValue === false) {
                                        loadGridData(true, dynamicFields.isEnabled ? dynamicFields.loaded : undefined);
                                        setHeight();
                                        cancelWatcher();
                                    }
                                });
                            } else {
                                loadGridData(true, dynamicFields.isEnabled ? dynamicFields.loaded : undefined);
                            }
                            setHeight();
                            break;
                        case "select-rows":
                            grid.setSelectedRows(args.rows || []);
                            break;
                        case "select-items":
                            const selectedRows = [];
                            args.items.forEach(function (item) {
                                selectedRows.push(dataView.getRowById(item[getIdProperty()]));
                            });
                            grid.setSelectedRows(selectedRows);
                            break;
                        case "continue-load":
                            loadGridDataRecursive(args.skip, args.take, args.forceRender);
                            break;
                        case "set-height":
                            setHeight();
                            break;
                        default:
                            alert("Invalid action passed to reload event!");
                    }
                };

                events.forEach(function (eventName) {
                    scope.$on(eventName, function (e, args) {
                        if (args.prompt) {
                            $dialog.confirmAction(args.prompt)
                                .open()
                                .then(function (result) {
                                    if (result === "yes") {
                                        performAction(args);
                                    }
                                });
                        } else {
                            performAction(args);
                        }
                    });
                });
            }


            //SCOPE WATCHERS
            const dynamicFieldChangeQueue = [];
            function addToDynamicFieldChangeQueue(source) {
                if (isPortfolioSlickGridSsrmEnabled()) {
                    // Deep $watch handlers fire once when registered; skip until the first grid load finishes
                    // so we do not cancel/restart the same Grid request (Accounts uses dynamic-fields).
                    if (!initialGridLoadComplete) {
                        return;
                    }
                    if (scope.current && scope.current._suppressDynamicFieldGridReload) {
                        return;
                    }
                }
                dynamicFieldChangeQueue.push(source);
                processDynamicFieldChangeQueue();
            }
            const processDynamicFieldChangeQueue = (function () {
                const items = dynamicFieldChangeQueue.unique();
                dynamicFieldChangeQueue.length = 0;

                loadGridFromDynamicFields(items.length === 1 ? items[0] : null)
                    .then(function () {
                        if (items.any('slickGridColumnDefs')) {
                            setColumns(scope.current.view.slickGridColumnDefs);
                            items.remove('slickGridColumnDefs');
                        }

                        if (!items.length) return;

                        dataView.beginUpdate();

                        if (items.any('filters') && !usesServerSideGridFiltering()) {
                            setFilters(scope.current.view.filters);
                        }

                        if (items.any('groups')) {
                            setGroupings(scope.current.view.groups);
                        }

                        if (items.any('sorts')) {
                            setSorts(scope.current.view.sorts);
                            if (isPortfolioSlickGridSsrmEnabled()) {
                                applyPortfolioClientSort();
                            } else {
                                dataView.sort(sortComparer, true);
                            }
                        }

                        dataView.endUpdate();
                    });
            }).debounce(100);

            scope.$watch("current.view.slickGridColumnDefs", function (newValue, oldValue) {
                if (newValue === oldValue) return;

                addToDynamicFieldChangeQueue('slickGridColumnDefs');
            }, true);

            scope.$watch("current.view.groups", function (newValue, oldValue) {
                if (newValue === oldValue) return;

                addToDynamicFieldChangeQueue('groups');
            }, true);

            scope.$watch("current.view.filters", function (newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                if (isPortfolioSlickGridSsrmEnabled() && usesServerSideGridFiltering()) {
                    refreshGridClientFilters();
                    return;
                }

                addToDynamicFieldChangeQueue('filters');
            }, true);

            scope.$watch("current.view.sorts", function (newValue, oldValue) {
                if (newValue === oldValue || (newValue.isEmpty() && oldValue.isEmpty())) return;
                if (isPortfolioSlickGridSsrmEnabled()) {
                    if (dynamicFields.isEnabled) {
                        return;
                    }
                    applyPortfolioClientSort();
                    return;
                }

                addToDynamicFieldChangeQueue('sorts');
            });

            scope.$watch("current.view.filterType", function (newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                if (isPortfolioSlickGridSsrmEnabled() && usesServerSideGridFiltering()) {
                    refreshGridClientFilters();
                    return;
                }

                addToDynamicFieldChangeQueue('filterType'); //doesn't actually load any new data, just want dataView to refresh
            });

            scope.$watch(function () {
                return isPortfolioSlickGridSsrmEnabled() && usesServerSideRowModel();
            }, function (newValue, oldValue) {
                if (!isPortfolioSlickGridSsrmEnabled()) {
                    return;
                }
                if (newValue === oldValue || !scope.current || !scope.current.view) {
                    return;
                }
                refreshGridClientFilters();
            });

            scope.$on('event:slickgrid-ssrm-sidebar-local-change', function () {
                if (!isPortfolioSlickGridSsrmEnabled()) {
                    return;
                }
                if (!usesServerSideGridFiltering()) {
                    return;
                }
                refreshGridClientFilters();
            });

            scope.$watch("current.gridQueries", function (newValue, oldValue) {
                if (newValue === oldValue) return;

                dataView.refresh();
            }, true);

            scope.$watch(attrs.autoRefresh, function (newValue, oldValue) {
                autoRefreshInterval = newValue;

                if (newValue > 0 && oldValue <= 0) {
                    loadGridData(false);
                }
            });


            //DESTROY EVENT
            scope.$on('$destroy', function () {
                if (isPortfolioSlickGridSsrmEnabled()) {
                    cancelPendingGridLoad();
                }
                angular.element($window).off('resize', setHeight);

                autoRefreshInterval = 0;

                if (listHotKeys) {
                    listHotKeys.destroy();
                }

                //grid.destroy();
                dataView.onRowCountChanged.unsubscribeAll();
                dataView.onRowsChanged.unsubscribeAll();

                grid.onHeaderRowCellRendered.unsubscribeAll();
                grid.onColumnsResized.unsubscribeAll();
                grid.onColumnsReordered.unsubscribeAll();
                grid.onActiveCellChanged.unsubscribeAll();
                grid.onBeforeEditCell.unsubscribeAll();
                grid.onCellChange.unsubscribeAll();
                grid.onKeyDown.unsubscribeAll();
                grid.onContextMenu.unsubscribeAll();
                grid.onSort.unsubscribeAll();
                grid.onSelectedRowsChanged.unsubscribeAll();
                grid.onDblClick.unsubscribeAll();

                delete window.grid;
                delete window.dataView;
                delete window.rows;
                delete window.options;
            });

            //AUTO HEIGHT -- TODO: should probably rework this into an option
            function setHeight() {
                document.querySelector('main').scrollTo(0,0);

                element.height(function () {
                    const winHeight = $window.innerHeight;
                    if (winHeight <= 480) return 200;
                    if ($window.innerWidth < 768) return 300;

                    const top = element.position().top;
                    const factor = 1;// / (scope.user.profile.zoom / 100);
                    var elemHeight = ((winHeight * factor) - top - 2);
                    if (hasPager) {
                        elemHeight -= 60;
                    }
                    return elemHeight;
                });
                grid.resizeCanvas();
            }

            function isRecordLimitBannerVisible() {
                if (!scope.current || !scope.current.portfolioSsrmEnabled) {
                    return false;
                }
                return !!(scope.current.gridRowCountsReady && scope.current.gridRecordLimitReached);
            }

            function scheduleSetHeight() {
                $timeout(setHeight, 0);
            }

            angular.element($window).on('resize', setHeight);
            $timeout(setHeight, 300);

            scope.$watch(isRecordLimitBannerVisible, scheduleSetHeight);
            scope.$watch(function () {
                return scope.current && scope.current.gridRowCountsReady;
            }, scheduleSetHeight);
        }
    };
});

'use strict';

app.directive('slickGridDataQueryFilter', function slickGridDataQueryFilter($http, $dialog, $oasRights) {
    var propertyMap = {
        client: ["clientid", "pkclient", "fkclient", "householdid"],
        registration: ["registrationid", "regid", "pkreg", "fkreg"],
        account: ["accountid", "acctid", "pkaccount", "fkaccount"],
        asset: ["assetid", "pkasset", "fkasset"],
        transaction: ["transactionid", "transid", "tranid", "pktransaction", "fktransaction", "recordid"]
    };

    return {
        restrict: 'E',
        replace: true,
        scope: {entity: '@', filterColumn: '@', gridQueries: '='},
        template: '<li ng-show="::canRunDataQueries"><a ng-click="applyDataQueryFilter()"><i class="fa fa-fw fa-filter" aria-hidden="true"></i> Filter by Data Query</a></li>',
        link: function (scope) {
            //PRIVATE VARIABLES
            var gridQueryId;


            //PUBLIC METHODS
            scope.canRunDataQueries = $oasRights.canRead("TM_DATAQUERY");

            scope.applyDataQueryFilter = function () {
                $dialog.search("dataQuery", "Filter by Data Query")
                    .open()
                    .then(function (dataQuery) {
                        if (!dataQuery) return;

                        $dialog.dataQueryPrompt(dataQuery.id, "grid-filter")
                            .open()
                            .then(function (result) {
                                if (!result) return;

                                var columnDef = result.views[0].slickGridColumnDefs.find(function (columnDef) {
                                    return propertyMap[scope.entity].any(columnDef.field.toLowerCase().replace(/ /g, ''));
                                });

                                if (columnDef) {
                                    $http.get('/Reporting/Custom/' + result.id +'/Generate/SlickGrid/' + result.views[0].dataQueryCacheKey, {trackerMsg: "Loading data query results"})
                                        .then(function (response) {
                                            var data = response.data.map(columnDef.field);

                                            gridQueryId = "DQ_" + result.id;

                                            scope.gridQueries.remove({id: gridQueryId, enabled: false});

                                            var filterFn;
                                            if (result.filterMethod === "include") {
                                                filterFn = function (x) {
                                                    for (var i = data.length - 1; i >= 0; i--) {
                                                        if (data[i] === x) return true;
                                                    }
                                                    return false;
                                                };
                                            } else {
                                                filterFn = function (x) {
                                                    for (var i = data.length - 1; i >= 0; i--) {
                                                        if (data[i] === x) return false;
                                                    }
                                                    return true;
                                                };
                                            }

                                            var description = result.prompts.map(function (prompt) {
                                                return prompt.prompt + ":" + prompt.defaultValue;
                                            }).join(" | ");

                                            scope.gridQueries.push({
                                                id: gridQueryId,
                                                name: result.title,
                                                description: description || "No parameters",
                                                field: scope.filterColumn || "id",
                                                filterFn: filterFn,
                                                itemCount: data.length,
                                                enabled: true
                                            });
                                        });
                                } else {
                                    $dialog.actionFailed("We're sorry!  We could not find any variations of the required <b>" + scope.entity.capitalize() + " ID</b> column in the <b>" + result.title + "</b> data query.").open();
                                }
                            });
                    });
            };
        }
    };
});

'use strict';

app.directive('slickGridViews', function slickGridViews($cacheFactory, $http, $q, $rootScope, $timeout, $dialog, $location, API_CONFIG, $oasRights, splitIoService) {
    const lastViewedCache = {};

    // TODO : remove this when removing opex_rework_2026_orion_connect_pentest_cross_site_39440 feature flag
    const standardConditions = [
        {
            type: "basicNumber", conditions:
            [
                {
                    name: "equals",
                    value: "(function (a) { return a === {value}; })",
                    multiValue: "(function(a) { return {value}.some(function(i){ return i === a; }); })",
                    isNumericType: true,
                    input1: "text"
                },
                {
                    name: "does not equal",
                    value: "(function (a) { return a !== {value}; })",
                    multiValue: "(function(a) { return !{value}.some(function(i){ return i === a; }); })",
                    isNumericType: true,
                    input1: "text"
                },
                {
                    name: "is greater than",
                    value: "(function (a) { return a > {value}; })",
                    input1: "number"
                },
                {
                    name: "is less than",
                    value: "(function (a) { return a < {value}; })",
                    input1: "number"
                },
                {
                    name: "is greater than or equal to",
                    value: "(function (a) { return a >= {value}; })",
                    input1: "number"
                },
                {
                    name: "is less than or equal to",
                    value: "(function (a) { return a <= {value}; })",
                    input1: "number"
                },
                {
                    name: "is between",
                    value: "(function (a) { return a >= {value} && a <= {value2}; })",
                    input1: "number",
                    input2: "number"
                }
            ]
        },
        {
            type: "basicText", conditions:
            [
                {
                    name: "equals",
                    value: "(function (a) { return (a ? a.toLowerCase() : '') == '{value}'; })",     //only '==' so null will match to empty string
                    multiValue: "(function(a) { return a ? {value}.some(function(i){ return a.toLowerCase() == i; }) : false; })",
                    input1: "text"
                },
                {
                    name: "does not equal",
                    value: "(function (a) { return (a ? a.toLowerCase() : '') !== '{value}'; })",
                    multiValue: "(function(a) { return !(a ? {value}.some(function(i){ return a.toLowerCase() == i; }) : false); })",
                    input1: "text"
                },
                {
                    name: "starts with",
                    value: "(function (a) { return (a ? a.toLowerCase() : '').startsWith('{value}'); })",
                    multiValue: "(function(a) {return a ? {value}.some(function(b) { return a.toLowerCase().startsWith(b); }) : false;})",
                    input1: "text"
                },
                {
                    name: "does not start with",
                    value: "(function (a) { return !(a ? a.toLowerCase() : '').startsWith('{value}'); })",
                    multiValue: "(function(a) {return !(a ? {value}.some(function(b) { return a.toLowerCase().startsWith(b); }) : false);})",
                    input1: "text"
                },
                {
                    name: "ends with",
                    value: "(function (a) { return (a ? a.toLowerCase() : '').endsWith('{value}'); })",
                    multiValue: "(function(a) {return a ? {value}.some(function(b) { return a.toLowerCase().endsWith(b); }) : false;})",
                    input1: "text"
                },
                {
                    name: "does not end with",
                    value: "(function (a) { return !(a ? a.toLowerCase() : '').endsWith('{value}'); })",
                    multiValue: "(function(a) {return !(a ? {value}.some(function(b) { return a.toLowerCase().endsWith(b); }) : false);})",
                    input1: "text"
                },
                {
                    name: "contains",
                    value: "(function (a) { return (a ? a.toLowerCase() : '').indexOf('{value}') !== -1; })",
                    multiValue: "(function(a) {return a ? {value}.some(function(b) { return a.toLowerCase().indexOf(b) !== -1; }) : false;})",
                    input1: "text"
                },
                {
                    name: "does not contain",
                    value: "(function (a) { return (a ? a.toLowerCase() : '').indexOf('{value}') === -1; })",
                    multiValue: "(function(a) {return !(a ? {value}.some(function(b) { return a.toLowerCase().indexOf(b) !== -1; }) : false);})",
                    input1: "text"
                }
            ]
        },
        {
            type: "basicObject", conditions:
            [
                {
                    name: "equals",
                    value: "(function (a) { return (a ? a.name.toLowerCase() : '') == '{value}'; })",     //only '==' so null will match to empty string
                    multiValue: "(function (a) { return a ? {value}.any(a.name.toLowerCase()) : false; })",
                    input1: "text"
                },
                {
                    name: "does not equal",
                    value: "(function (a) { return (a ? a.name.toLowerCase() : '') !== '{value}'; })",
                    multiValue: "(function (a) { return a ? {value}.none(a.name.toLowerCase()) : false; })",
                    input1: "text"
                },
                {
                    name: "starts with",
                    value: "(function (a) { return (a ? a.name.toLowerCase() : '').startsWith('{value}'); })",
                    multiValue: "(function(a) {return {value}.any(function(b) { return a.name.toLowerCase().startsWith(b); });})",
                    input1: "text"
                },
                {
                    name: "does not start with",
                    value: "(function (a) { return !(a ? a.name.toLowerCase() : '').startsWith('{value}'); })",
                    multiValue: "(function(a) {return {value}.none(function(b) { return a.name.toLowerCase().startsWith(b); });})",
                    input1: "text"
                },
                {
                    name: "ends with",
                    value: "(function (a) { return (a ? a.name.toLowerCase() : '').endsWith('{value}'); })",
                    multiValue: "(function(a) {return {value}.any(function(b) { return a.name.toLowerCase().endsWith(b); });})",
                    input1: "text"
                },
                {
                    name: "does not end with",
                    value: "(function (a) { return !(a ? a.name.toLowerCase() : '').endsWith('{value}'); })",
                    multiValue: "(function(a) {return {value}.none(function(b) { return a.name.toLowerCase().endsWith(b); });})",
                    input1: "text"
                },
                {
                    name: "contains",
                    value: "(function (a) { return (a ? a.name.toLowerCase() : '').indexOf('{value}') !== -1; })",
                    multiValue: "(function(a) {return {value}.any(function(b) { return a.name.toLowerCase().indexOf(b) !== -1; });})",
                    input1: "text"
                },
                {
                    name: "does not contain",
                    value: "(function (a) { return (a ? a.name.toLowerCase() : '').indexOf('{value}') === -1; })",
                    multiValue: "(function(a) {return {value}.none(function(b) { return a.name.toLowerCase().indexOf(b) !== -1; });})",
                    input1: "text"
                }
            ]
        },
        {
            type: "basicBoolean", conditions:
            [
                {
                    name: "is true",
                    value: "(function (a) { return angular.isString(a) ? a.toLowerCase() === 'true' : a === true; })"
                },
                {
                    name: "is false",
                    value: "(function (a) { return angular.isString(a) ? a.toLowerCase() === 'false' : (a === false || a === null); })"
                }
            ]
        },
        {
            type: "basicDate", conditions:
            [
                {
                    name: "is today",
                    value: "(function (a) { return a && Date.create(a).isToday(); })"
                },
                {
                    name: "equals",
                    value: "(function (a) { return a && Date.create(a).is('{value}'); })",
                    input1: "text"
                },
                {
                    name: "is after (date)",
                    value: "(function (a) { return a && Date.create(a).isAfter('{value}'); })",
                    input1: "text"
                },
                {
                    name: "is before (date)",
                    value: "(function (a) { return a && Date.create(a).isBefore('{value}'); })",
                    input1: "text"
                },
                {
                    name: "is older than (days)",
                    value: "(function (a) { return a && Date.create(a).isBefore('{value} days before today'); })",
                    input1: "number"
                },
                {
                    name: "is within (days)",
                    value: "(function (a) { return a && Date.create(a).isAfter('{value} days before today'); })",
                    input1: "number"
                }
            ]
        },
        {
            type: "tradingDate", conditions:
            [
                {
                    name: "is today",
                    value: "(function (a) { return a && Date.create(a).isToday(); })"
                },
                {
                    name: "is after T-",
                    value: "(function (a) { return a && Date.create(a).isAfter('{value} days before today'); })", input1: "number"
                },
                {
                    name: "is before T-",
                    value: "(function (a) { return a && Date.create(a).isBefore('{value} days before today'); })", input1: "number"
                }
            ]
        }
    ];
    /** Used by slickGridODataSidebarSync when OData route filters are synced to the sidebar. */
    window.slickGridStandardConditions = standardConditions;

    const aggregateTypes = ["None", "Sum", "Avg", "Min", "Max"];

    function shortConditionName(value) {
        switch (value) {
            case "equals":
                return "=";
            case "does not equal":
                return "≠";
            case "is greater than":
                return ">";
            case "is less than":
                return "<";
            case "is greater than or equal to":
                return ">=";
            case "is less than or equal to":
                return "<=";
            default:
                return value;
        }
    }

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/directives/slickGridViews.html',
        link: function (scope, element, attrs) {
            //PRIVATE VARIABLES
            let viewUrl;
            let oCopy;


            //PRIVATE METHODS
            function isRecordColumnLimitFeatureEnabled() {
                var sync = window.slickGridODataSidebarSync;
                return sync && sync.isRecordColumnLimitFeatureEnabled
                    && sync.isRecordColumnLimitFeatureEnabled(scope);
            }

            function finishLegacyViewInit() {
                resetAddFilter();
                resetAddGroup();
                applyODataSyncFilterFieldHint();
            }

            function runViewInit() {
                const viewSetEvent = 'slickgrid-view-set';
                const lastViewedId = lastViewedCache[scope.views[0].pageCode];

                if (isRecordColumnLimitFeatureEnabled()) {
                    if (lastViewedId && lastViewedId !== scope.current.view.id) {
                        scope.current.view = scope.views.find({id: lastViewedId});
                    } else {
                        const defaultView = scope.views.find({isUserDefault: true});
                        if (defaultView && defaultView.id !== scope.current.view.id) {
                            scope.current.view = defaultView;
                        }
                    }
                    scope.current.portfolioListViewSelectionReady = true;

                    $timeout(function () {
                        $rootScope.$broadcast(viewSetEvent);
                        finishViewSelection({ syncRouteFilters: true });
                    });
                    return;
                }

                if (lastViewedId && lastViewedId !== scope.current.view.id) {
                    $timeout(function () {
                        scope.current.view = scope.views.find({id: lastViewedId});
                        $rootScope.$broadcast(viewSetEvent);
                        finishLegacyViewInit();
                    });
                } else {
                    const defaultView = scope.views.find({isUserDefault: true});
                    if (defaultView && defaultView.id !== scope.current.view.id) {
                        $timeout(function () {
                            scope.current.view = defaultView;
                            $rootScope.$broadcast(viewSetEvent);
                            finishLegacyViewInit();
                        });
                    } else {
                        $rootScope.$broadcast(viewSetEvent);
                        finishLegacyViewInit();
                    }
                }
            }

            function init() {
                if (!scope.current) scope.current = {};
                // The list controllers sit on a parent scope and cannot see scope.searchSidebarFilters directly.
                scope.current.searchSidebarFilters = scope.searchSidebarFilters;

                scope.current.showAddFilter = false;
                scope.current.showAddGroup = false;
                scope.current.sortOptions = [{name: "item count (asc)", value: 0}, {name: "item count (desc)", value: 1}, {name: "item value", value: 2}];
                scope.current.groupManagerMode = attrs.groupManagerMode;

                viewUrl = "/Settings/Views/" + scope.views[0].pageCode;
                oCopy = angular.copy(scope.views);

                const columnDefs = scope.views[0].slickGridColumnDefs;
                scope.filterableColumns = [];
                scope.aggregatableColumns = [];
                for (let i = 0, j = columnDefs.length; i < j; i++) {
                    const column = {name: columnDefs[i].name, field: columnDefs[i].field, conditions: columnDefs[i].conditions, conditionType: columnDefs[i].conditionType};

                    if (columnDefs[i].conditionType) {
                        column.conditions = standardConditions.find({type: columnDefs[i].conditionType}).conditions;

                        if (columnDefs[i].conditionType === "basicNumber" && !columnDefs[i].field.toLowerCase().endsWith("id")) {
                            scope.aggregatableColumns.push({name: columnDefs[i].name, field: columnDefs[i].field, type: "None"});
                        }
                    }

                    if (angular.isArray(column.conditions) && column.conditions.length > 0) {
                        scope.filterableColumns.push(column);
                    }
                }

                scope.filterableColumns = scope.filterableColumns.sortBy('name');

                if (getODataListProfileKey() && scope.current.gridLimitsReady === false) {
                    var unwatchLimits = scope.$watch(function () {
                        return scope.current && scope.current.gridLimitsReady;
                    }, function (ready) {
                        if (ready) {
                            unwatchLimits();
                            runViewInit();
                        }
                    });
                } else {
                    runViewInit();
                }
            }

            function getODataListProfileKey() {
                return scope.current && scope.current.odataListProfileKey;
            }

            function applyServerSideFilters(options) {
                var profileKey = getODataListProfileKey();
                var sync = window.portfolioListODataSidebarSync;
                if (!profileKey || !sync || !sync.applySidebarFiltersToGrid) {
                    markPortfolioListFiltersReady();
                    return false;
                }
                var pendingSessions = ensureFileFilterSessions(!!(options && options.refreshFileFilters));
                if (pendingSessions) {
                    // Hold the grid until file filters have a live session so it never loads unfiltered rows.
                    scope.current.portfolioListFiltersReady = false;
                    // On failure the filter still compiles; the server then rejects it (410) rather than widening results.
                    var applyNow = function () {
                        if (!sync.applySidebarFiltersToGrid(scope, $location, profileKey, options)) {
                            markPortfolioListFiltersReady();
                        }
                    };
                    pendingSessions.then(applyNow, applyNow);
                    return true;
                }
                var applied = sync.applySidebarFiltersToGrid(scope, $location, profileKey, options);
                if (!applied) {
                    markPortfolioListFiltersReady();
                }
                return applied;
            }

            function getFileFilterProfile() {
                var profileKey = getODataListProfileKey();
                var portfolioSync = window.portfolioListODataSidebarSync;
                var profile = profileKey && portfolioSync ? portfolioSync.resolveProfile(profileKey) : null;
                return profile && profile.fileFilter ? profile.fileFilter : null;
            }

            function isFileFilterEnabled() {
                return !!(getFileFilterProfile()
                    && isRecordColumnLimitFeatureEnabled()
                    && scope.current
                    && !scope.current.groupManagerMode
                    && !scope.current.entityRouteGetById);
            }

            let fileFilterSessionRequest = null;

            /**
             * File filters keep their values; their server session is re-created from them when missing or about to
             * expire (e.g. a saved view loaded later), or for every enabled file filter when <paramref name="force"/> is
             * set (Refresh Grid re-matches against current data). Returns a promise while sessions are being created,
             * else null.
             */
            function ensureFileFilterSessions(force) {
                var sync = window.slickGridODataSidebarSync;
                var view = scope.current && scope.current.view;
                if (!sync || !sync.isFileFilter || !view || !view.filters) {
                    return null;
                }
                if (fileFilterSessionRequest) {
                    if (!force) {
                        return fileFilterSessionRequest;
                    }
                    var rerun = function () {
                        return ensureFileFilterSessions(true);
                    };
                    return fileFilterSessionRequest.then(rerun, rerun);
                }

                var unavailable = view.filters.filter(sync.isFileFilterUnavailable);
                if (unavailable.length) {
                    unavailable.forEach(function (filter) {
                        filter.include = false;
                    });
                    $dialog.messageBox(
                        '<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Import the file again',
                        'This view has a file filter that can no longer be applied: ' + unavailable.map(function (f) {
                            return escapeHtml(f.name);
                        }).join(', ') + '. It has been turned off. Import the file again to filter by it.',
                        [{ result: 'OK', label: 'OK', cssClass: 'btn-primary', focus: true }]
                    ).open();
                }

                var stale = view.filters.filter(function (filter) {
                    return sync.fileFilterNeedsSession(filter, null, force);
                });
                if (!stale.length) {
                    return null;
                }

                fileFilterSessionRequest = $q.all(stale.map(function (filter) {
                    var fileFilter = filter.fileFilter;
                    return $http.post(
                        '/Utility/EntitySession/FileFilter/' + encodeURIComponent(fileFilter.entity || 'Account') + '/Values',
                        { field: fileFilter.field, columnName: fileFilter.columnName, values: fileFilter.values },
                        { trackerMsg: 'Applying file filter' }
                    ).then(function (response) {
                        sync.applyFileFilterSession(filter, response.data);
                    });
                })).finally(function () {
                    fileFilterSessionRequest = null;
                });
                return fileFilterSessionRequest;
            }

            function escapeHtml(value) {
                return String(value ?? '')
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;');
            }

            function isWorkflowAssistantFilterActive() {
                return !!(scope.current && scope.current.odataFilterFromWorkflowAssistant);
            }

            function usesDeferredODataSidebarSearch() {
                if (!isRecordColumnLimitFeatureEnabled()) {
                    return false;
                }
                var sync = window.slickGridODataSidebarSync;
                if (sync && sync.isDeferredODataSidebarSearchEnabled) {
                    return sync.isDeferredODataSidebarSearchEnabled(scope);
                }
                return false;
            }

            function usesServerSideRowModel() {
                if (!isRecordColumnLimitFeatureEnabled()) {
                    return false;
                }
                var sync = window.slickGridODataSidebarSync;
                if (sync && sync.isServerSideRowModelActive) {
                    return sync.isServerSideRowModelActive(scope, $location);
                }
                return scope.current && [true, 'true'].any(scope.current.useServerSideRowModel);
            }

            function notifySlickGridSidebarFilterChange() {
                if (!isRecordColumnLimitFeatureEnabled()) {
                    return;
                }
                if (usesDeferredODataSidebarSearch()) {
                    $rootScope.$broadcast('event:slickgrid-ssrm-sidebar-local-change');
                    refreshSidebarFilterCount();
                } else if (usesServerSideRowModel()) {
                    $rootScope.$broadcast('event:slickgrid-ssrm-sidebar-local-change');
                }
            }

            function refreshSidebarFilterCount() {
                var sync = window.slickGridODataSidebarSync;
                if (!sync || !sync.refreshPortfolioSidebarFilterCount) {
                    return null;
                }
                var pendingSessions = ensureFileFilterSessions();
                if (pendingSessions) {
                    var countNow = function () {
                        return sync.refreshPortfolioSidebarFilterCount(scope, $http);
                    };
                    return pendingSessions.then(countNow, countNow);
                }
                return sync.refreshPortfolioSidebarFilterCount(scope, $http);
            }

            function visibleColumnCount() {
                return (scope.current.view.slickGridColumnDefs || []).filter(function (column) {
                    return column.visible;
                }).length;
            }
            scope.visibleColumnCount = visibleColumnCount;

            function applyODataSyncFilterFieldHint() {
                const field = scope.current && scope.current.odataSyncFilterField;
                if (!field || !scope.filterableColumns) {
                    return;
                }
                let column = scope.filterableColumns.find({ field: field });
                if (!column && scope.current.odataSyncFilterFieldLabel) {
                    column = scope.filterableColumns.find({ name: scope.current.odataSyncFilterFieldLabel });
                }
                if (column) {
                    scope.current.field = column;
                    scope.resetSelectedCondition();
                }
            }

            function applyPendingODataSidebarSync() {
                var profileKey = getODataListProfileKey();
                var sync = window.portfolioListODataSidebarSync;
                if (!profileKey || !sync || !sync.applyPendingODataSidebarSync) {
                    return;
                }
                sync.applyPendingODataSidebarSync(scope, profileKey);
                applyODataSyncFilterFieldHint();
            }

            function syncRouteFiltersToSidebarIfReady() {
                if (!isWorkflowAssistantFilterActive()) {
                    return;
                }
                if (!scope.filterableColumns || !scope.filterableColumns.length) {
                    return;
                }
                if (!scope.current || !scope.current.odataSidebarSyncFilter) {
                    return;
                }
                applyPendingODataSidebarSync();
            }

            function markPortfolioListFiltersReady() {
                var sync = window.slickGridODataSidebarSync;
                if (sync && sync.markPortfolioListFiltersReady) {
                    sync.markPortfolioListFiltersReady(scope);
                } else if (scope.current) {
                    scope.current.portfolioListFiltersReady = true;
                }
            }

            function isGridRecordLimitEnabled() {
                var sync = window.slickGridODataSidebarSync;
                return sync && sync.isGridRecordLimitEnabled
                    && sync.isGridRecordLimitEnabled(scope);
            }

            function prepareClientViewFiltersIfNeeded() {
                var sync = window.slickGridODataSidebarSync;
                var profileKey = getODataListProfileKey();
                var portfolioSync = window.portfolioListODataSidebarSync;
                if (!sync || !sync.prepareViewFiltersForClientSide || !profileKey || !portfolioSync
                    || !scope.current || !scope.current.view) {
                    return;
                }
                var profile = portfolioSync.resolveProfile(profileKey);
                sync.prepareViewFiltersForClientSide(
                    scope.current.view.filters,
                    scope.current.view.slickGridColumnDefs,
                    profile
                );
            }

            function applyViewFiltersToServerWhenReady(options) {
                options = angular.extend({ skipGridReload: true }, options || {});

                if (!scope.current || !scope.current.gridLimitsReady) {
                    var unwatchLimits = scope.$watch(function () {
                        return scope.current && scope.current.gridLimitsReady;
                    }, function (ready) {
                        if (ready) {
                            unwatchLimits();
                            applyViewFiltersToServerWhenReady(options);
                        }
                    });
                    return;
                }

                if (isRecordColumnLimitFeatureEnabled() && !scope.current.portfolioListInitReady) {
                    var unwatchInit = scope.$watch(function () {
                        return scope.current && scope.current.portfolioListInitReady;
                    }, function (ready) {
                        if (ready) {
                            unwatchInit();
                            applyViewFiltersToServerWhenReady(options);
                        }
                    });
                    return;
                }

                if (!isRecordColumnLimitFeatureEnabled()) {
                    prepareClientViewFiltersIfNeeded();
                    markPortfolioListFiltersReady();
                    return;
                }

                if (applyServerSideFilters({
                    skipGridReload: options.skipGridReload,
                    deferCommittedFilterRowCountSnapshot: options.skipGridReload === false
                })) {
                    var countPromise = refreshSidebarFilterCount();
                    if (!countPromise && scope.current && scope.current.awaitingCommittedFilterRowCountSnapshot) {
                        delete scope.current.awaitingCommittedFilterRowCountSnapshot;
                    }
                }
            }

            function finishViewSelection(options) {
                options = options || {};
                if (options.syncRouteFilters) {
                    syncRouteFiltersToSidebarIfReady();
                }
                resetAddFilter();
                resetAddGroup();
                if (!isRecordColumnLimitFeatureEnabled()) {
                    var portfolioSync = window.portfolioListODataSidebarSync;
                    if (portfolioSync && portfolioSync.markPortfolioListViewReady) {
                        portfolioSync.markPortfolioListViewReady(scope);
                    } else {
                        scope.current.gridLimitsReady = true;
                    }
                }
                applyViewFiltersToServerWhenReady(options);
            }

            scope.onViewSelected = function () {
                if (!isRecordColumnLimitFeatureEnabled()) {
                    return;
                }
                if (usesServerSideRowModel() || usesDeferredODataSidebarSearch()) {
                    scope.current._suppressDynamicFieldGridReload = true;
                    $timeout(function () {
                        if (scope.current) {
                            delete scope.current._suppressDynamicFieldGridReload;
                        }
                    }, 200);
                }
                $rootScope.$broadcast('slickgrid-view-set');
                finishViewSelection({ skipGridReload: false });
            };

            function resetAddFilter() {
                if (!scope.filterableColumns || !scope.filterableColumns.length) {
                    return;
                }
                scope.current.field = scope.filterableColumns[0];
                scope.resetSelectedCondition();
            }

            function resetAddGroup() {
                scope.current.grouping = {columnDef: scope.current.view.slickGridColumnDefs.sortBy('name')[0], sort: 0, collapsed: true, aggregateCollapsed: true};
            }

            function deleteHttpCache() {
                if (!scope.current.groupManagerMode) return;

                const cache = $cacheFactory.get('$http');
                cache.remove(API_CONFIG.baseUrl + '/Utility/Groupings?usedFor=Trading');
                cache.remove(API_CONFIG.baseUrl + '/Utility/Groupings?usedFor=Reporting');
                cache.remove(API_CONFIG.baseUrl + '/Utility/Groupings?usedFor=RepProfileAssignment');
            }


            let isPentestCrossSiteFilterReworkEnabled = false;
            // TODO : remove this when removing opex_rework_2026_orion_connect_pentest_cross_site_39440 feature flag
            splitIoService.getBoolTreatment('opex_rework_2026_orion_connect_pentest_cross_site_39440').subscribe(function (isEnabled) {
                isPentestCrossSiteFilterReworkEnabled = isEnabled === true;
                window.isPentestCrossSiteFilterReworkEnabled = isPentestCrossSiteFilterReworkEnabled;
            });

            //PUBLIC METHODS
            function isSplitRecordColumnLimitFeatureEnabled() {
                return !!(scope.current && scope.current.slickGridRecordColumnLimitEnabled);
            }

            function visibleColumnLimitExceeded() {
                if (!isSplitRecordColumnLimitFeatureEnabled()) {
                    return false;
                }
                var limit = scope.current.viewsColumnsLimit;
                return limit > 0 && visibleColumnCount() > limit;
            }

            function confirmViewSaveAllowed() {
                if (!visibleColumnLimitExceeded()) {
                    return true;
                }
                var limit = scope.current.viewsColumnsLimit;
                $dialog.messageBox(
                    '<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Too many columns',
                    'This firm limits saved views to ' + limit + ' columns. Hide columns before saving. Existing views still load all of their columns.',
                    [{ result: 'OK', label: 'OK', cssClass: 'btn-primary', focus: true }]
                ).open();
                return false;
            }

            scope.saveView = function () {
                if (!confirmViewSaveAllowed()) {
                    return;
                }
                // TODO : remove this when removing opex_rework_2026_orion_connect_pentest_cross_site_39440 feature flag
                if (isPentestCrossSiteFilterReworkEnabled) {
                    scope.current.view.isNewSlickGridFilter = true;
                    stripFilterJavascript(scope.current.view);
                }
                $http.put(viewUrl + '/' + scope.current.view.id, scope.current.view, {trackerMsg: 'Saving ' + scope.current.view.name})
                    .then(function (response) {
                        oCopy[oCopy.findIndex({id: response.data.id})] = response.data;
                    });
            };

            scope.saveViewAs = function() {
                if (!confirmViewSaveAllowed()) {
                    return;
                }
                $dialog.dialog({templateUrl: "new-slickgrid-view.html", controller: "NewSlickGridViewCtrl", resolve: {groupManagerMode: function () {return scope.current.groupManagerMode;}, canSetGlobalView: function () {return scope.rightsGlobalView.canUpdate;}}})
                    .open()
                    .then(function (result) {
                        if (!result) return;

                        const newView = angular.copy(scope.current.view);
                        newView.id = 0;
                        newView.name = result.name + (result.isPrivate ? '' : ' (Global)');
                        newView.isPrivate = result.isPrivate;
                        newView.isUserDefault = result.isUserDefault;
                        if (isPentestCrossSiteFilterReworkEnabled) {
                            // TODO : remove this when removing opex_rework_2026_orion_connect_pentest_cross_site_39440 feature flag
                            newView.isNewSlickGridFilter = true;
                            stripFilterJavascript(newView);
                        }
                        if (result.groupManager.mode) {
                            newView.dynamicGroupingInfo = result.groupManager.usedFor;
                        }

                        $http.post(viewUrl, newView, {trackerMsg: 'Saving ' + newView.name})
                            .then(function (response) {
                                //restore the base view to it's original state
                                scope.resetCurrentView();

                                //add in the new view and set it to current
                                scope.views.push(response.data);
                                scope.current.view = response.data;
                                oCopy.push(angular.copy(response.data));

                                deleteHttpCache();
                            });
                    });
            };

            scope.deleteView = function () {
                $dialog.confirmAction("Are you sure you want to delete this view?")
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            $http.delete(viewUrl + '/' + scope.current.view.id, {trackerMsg: 'Deleting ' + scope.current.view.name})
                                .then(function () {
                                    scope.views.splice(scope.views.indexOf(scope.current.view), 1);
                                    scope.current.view = scope.views[0];

                                    deleteHttpCache();
                                });
                        }
                    });
            };

            scope.setAsDefaultView = function () {
                const oldDefault = scope.views.find({isUserDefault: true});
                if (oldDefault) {
                    oldDefault.isUserDefault = false;
                }
                scope.current.view.isUserDefault = true;

                $http.put(viewUrl + '/' + scope.current.view.id + '/Actions/SetDefault', scope.current.view, {trackerMsg: 'Setting ' + scope.current.view.name + ' as default'})
                    .then(function (response) {
                        oCopy[oCopy.findIndex({id: response.data.id})] = response.data;
                    });
            };

            scope.resetCurrentView = function () {
                const index = scope.views.findIndex({id: scope.current.view.id});
                scope.views[index] = angular.copy(oCopy.find({id: scope.current.view.id}));
                scope.current.view = scope.views[index];
            };

            scope.resetSelectedCondition = function () {
                scope.current.condition = scope.current.field.conditions[0];
                scope.resetConditionValues();
            };

            scope.resetConditionValues = function () {
                scope.current.conditionValue1 = scope.current.condition.select1 ? scope.current.condition.select1[0] : "";
                scope.current.conditionValue2 = scope.current.condition.select2 ? scope.current.condition.select2[0] : "";
            };

            scope.cleanOption = function (value) {
                return value === "" ? "{blank}" : value;
            };

            function escapeForSingleQuotedJs(value) {
                return String(value ?? "")
                    .replace(/\\/g, "\\\\")
                    .replace(/'/g, "\\'")
                    .replace(/\r/g, "\\r")
                    .replace(/\n/g, "\\n")
                    .replace(/\u2028/g, "\\u2028")
                    .replace(/\u2029/g, "\\u2029");
            }

            function normalizeBasicNumberFilterValue(value) {
                return String(value ?? "").replace(/\$/g, "");
            }

            function stripWrappingQuotes(value) {
                return String(value ?? "")
                    .replace(/^"(.*)"$/, "$1")
                    .replace(/^'(.*)'$/, "$1");
            }

            function buildMultiValueStringArray(items) {
                return '[' + items.map(function (x) {
                    return JSON.stringify(stripWrappingQuotes(x).toLowerCase());
                }).join(', ') + ']';
            }

            function splitOrDelimitedValues(value) {
                return String(value ?? "")
                    .split(/\s+or\s+/i)
                    .map(function (x) { return x.trim(); })
                    .filter(function (x) { return x.length > 0; });
            }

            function stripFilterJavascript(view) {
                // TODO : remove this when removing opex_rework_2026_orion_connect_pentest_cross_site_39440 feature flag
                if (!view || !view.filters) {
                    return;
                }
                view.filters.forEach(function (filter) {
                    if (filter) {
                        delete filter.value;
                    }
                });
            }

            scope.addFilter = function () {
                let name = scope.current.field.name + ' ' + shortConditionName(scope.current.condition.name);
                // TODO : remove this when removing opex_rework_2026_orion_connect_pentest_cross_site_39440 feature flag
                let value = scope.current.condition.value;

                if (scope.current.condition.input1 || scope.current.condition.select1) {
                    const isBasicNumber = scope.current.field.conditionType === "basicNumber"
                        || scope.current.condition.isNumericType
                        || scope.current.condition.input1 === "number"
                        || scope.current.condition.input2 === "number";
                    let rawConditionValue1 = isBasicNumber
                        ? normalizeBasicNumberFilterValue(scope.current.conditionValue1)
                        : scope.current.conditionValue1;
                    let tempConditionValue1 = escapeForSingleQuotedJs(rawConditionValue1);

                    if (scope.current.condition.multiValue) {
                        const orSeparatedValues = splitOrDelimitedValues(scope.current.conditionValue1)
                            .map(function (x) { return isBasicNumber ? normalizeBasicNumberFilterValue(x) : x; });
                        if (orSeparatedValues.length > 1) {
                            value = scope.current.condition.multiValue;
                            if (scope.current.condition.isNumericType) {
                                tempConditionValue1 = '[' + orSeparatedValues.join(', ') + ']';
                            } else {
                                tempConditionValue1 = buildMultiValueStringArray(orSeparatedValues);
                            }

                        }
                        else if (scope.current.conditionValue1.startsWith("[") && scope.current.conditionValue1.endsWith("]")) {
                            value = scope.current.condition.multiValue;
                            const bracketItems = scope.current.conditionValue1
                                .replace('[', '')
                                .replace(']', '')
                                .replace(/, /g, ',')
                                .split(',')
                                .map(function (x) { return x.trim(); })
                                .filter(function (x) { return x.length > 0; });
                            if (scope.current.condition.isNumericType) {
                                tempConditionValue1 = '[' + bracketItems.map(function (x) {
                                    return isBasicNumber ? normalizeBasicNumberFilterValue(x) : x;
                                }).join(', ') + ']';
                            } else {
                                tempConditionValue1 = buildMultiValueStringArray(bracketItems);
                            }
                        }
                    }

                    name += ' ' + (scope.current.conditionValue1 === "" ? "{blank}" : scope.current.conditionValue1);
                    const substituteValue1 = scope.current.condition.isNumericType || isBasicNumber
                        ? tempConditionValue1
                        : (scope.current.condition.select1 ? tempConditionValue1
                            : (tempConditionValue1.charAt(0) === '[' ? tempConditionValue1
                                : (tempConditionValue1.length === 0 && value.indexOf("'{value}'") === -1 ? "''" : tempConditionValue1.toLowerCase())));
                    value = value.replace("{value}", substituteValue1);

                    if (scope.current.condition.input2 || scope.current.condition.select2) {
                        name += ' and ' + (scope.current.conditionValue2 === "" ? "{blank}" : scope.current.conditionValue2);
                        const rawConditionValue2 = isBasicNumber
                            ? normalizeBasicNumberFilterValue(scope.current.conditionValue2)
                            : scope.current.conditionValue2;
                        const tempConditionValue2 = escapeForSingleQuotedJs(rawConditionValue2);
                        const substituteValue2 = isBasicNumber
                            ? tempConditionValue2
                            : (scope.current.condition.select2 ? tempConditionValue2
                                : (tempConditionValue2.length === 0 && value.indexOf("'{value2}'") === -1 ? "''" : tempConditionValue2.toLowerCase()));
                        value = value.replace("{value2}", substituteValue2);
                    }
                }

                const cond1 = scope.current.conditionValue1;
                const isBlankDateInput = cond1 === "" || cond1 == null
                    || (typeof cond1 === "string" && (cond1.trim() === "" || cond1.trim().toLowerCase() === "{blank}"));
                if (scope.current.field.conditionType === "basicDate" && scope.current.condition.name === "equals" && isBlankDateInput) {
                    value = "(function (a) { return a == null || a === '' || (typeof a === 'string' && a.trim() === ''); })";
                }

                var odataValues = null;
                if (isRecordColumnLimitFeatureEnabled() && scope.current.condition.multiValue && scope.current.conditionValue1) {
                    var rawMulti = String(scope.current.conditionValue1);
                    if (rawMulti.startsWith('[') && rawMulti.endsWith(']')) {
                        odataValues = rawMulti.slice(1, -1).split(',')
                            .map(function (x) { return x.trim(); })
                            .filter(function (x) { return x.length > 0; });
                    } else {
                        var splitValues = splitOrDelimitedValues(rawMulti);
                        if (splitValues.length > 1) {
                            odataValues = splitValues;
                        }
                    }
                }

                var sync = window.portfolioListODataSidebarSync;
                var profile = sync && getODataListProfileKey() ? sync.resolveProfile(getODataListProfileKey()) : null;
                var odataProperty = (sync && sync.toODataPropertyName)
                    ? sync.toODataPropertyName(scope.current.field.field, profile)
                    : scope.current.field.field;

                if (isPentestCrossSiteFilterReworkEnabled) {
                    const structured = window.slickGridFilterFormat
                        ? window.slickGridFilterFormat.buildStructuredFields(
                            scope.current.field,
                            scope.current.condition,
                            scope.current.conditionValue1,
                            scope.current.conditionValue2
                        )
                        : {};

                    var structuredFilter = angular.extend({
                        name: name,
                        key: scope.current.field.field,
                        include: true
                    }, structured);
                    if (isRecordColumnLimitFeatureEnabled()) {
                        structuredFilter.odataSync = false;
                        structuredFilter.odataCondition = scope.current.condition.name;
                        structuredFilter.odataValue = scope.current.conditionValue1;
                        structuredFilter.odataValue2 = scope.current.conditionValue2;
                        structuredFilter.odataValues = odataValues;
                        structuredFilter.odataProperty = odataProperty;
                        if (!structuredFilter.conditionType) {
                            structuredFilter.conditionType = scope.current.field.conditionType;
                        }
                    }
                    scope.current.view.filters.push(structuredFilter);
                    scope.current.view.isNewSlickGridFilter = true;
                } else if (!isRecordColumnLimitFeatureEnabled()) {
                    // TODO : remove this when removing opex_rework_2026_orion_connect_pentest_cross_site_39440 feature flag
                    scope.current.view.filters.push({
                        name: name,
                        value: value,
                        key: scope.current.field.field,
                        include: true
                    });
                } else {
                    var filter = {
                        name: name,
                        key: scope.current.field.field,
                        include: true,
                        odataSync: false,
                        odataCondition: scope.current.condition.name,
                        odataValue: scope.current.conditionValue1,
                        odataValue2: scope.current.conditionValue2,
                        odataValues: odataValues,
                        odataProperty: odataProperty,
                        conditionType: scope.current.field.conditionType
                    };
                    if (!usesDeferredODataSidebarSearch()) {
                        filter.value = value;
                    }
                    scope.current.view.filters.push(filter);
                }
                resetAddFilter();
                notifySlickGridSidebarFilterChange();
            };

            scope.searchSidebarFilters = function () {
                var sync = window.slickGridODataSidebarSync;
                var view = scope.current && scope.current.view;
                var hasFileFilters = !!(sync && sync.isFileFilter && view && (view.filters || []).some(function (filter) {
                    return sync.isFileFilter(filter) && filter.include;
                }));
                if (!hasFileFilters) {
                    applyServerSideFilters();
                    return;
                }
                // Refresh Grid re-matches file values against current data, so the matches (and the count) may change.
                if (applyServerSideFilters({ refreshFileFilters: true, deferCommittedFilterRowCountSnapshot: true })) {
                    var countPromise = refreshSidebarFilterCount();
                    if (!countPromise && scope.current && scope.current.awaitingCommittedFilterRowCountSnapshot) {
                        delete scope.current.awaitingCommittedFilterRowCountSnapshot;
                    }
                }
            };

            scope.refreshSidebarFilterCount = refreshSidebarFilterCount;

            scope.usesDeferredODataSidebarSearch = usesDeferredODataSidebarSearch;

            scope.isFileFilterEnabled = isFileFilterEnabled;

            let lastFileFilterRecovery = 0;

            // The grid answered 410: a file filter's session was purged. Re-create it from the saved values and apply
            // again once; if that already happened in the last minute (or there are no values), ask for a re-import.
            scope.$on('event:slickgrid-file-filter-session-gone', function () {
                var sync = window.slickGridODataSidebarSync;
                var view = scope.current && scope.current.view;
                if (!sync || !sync.isFileFilter || !view || !view.filters) {
                    return;
                }
                var fileFilters = view.filters.filter(function (filter) {
                    return sync.isFileFilter(filter) && filter.include;
                });
                if (!fileFilters.length) {
                    return;
                }
                var canRecreate = fileFilters.every(function (filter) {
                    return filter.fileFilter.values && filter.fileFilter.values.length;
                });
                if (!canRecreate || Date.now() - lastFileFilterRecovery < 60000) {
                    $dialog.messageBox(
                        '<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Import the file again',
                        'A file filter could not be applied because its data on the server has expired. Import the file again to filter by it.',
                        [{ result: 'OK', label: 'OK', cssClass: 'btn-primary', focus: true }]
                    ).open();
                    return;
                }
                lastFileFilterRecovery = Date.now();
                fileFilters.forEach(function (filter) {
                    delete filter.fileFilter.entitySessionId;
                    delete filter.fileFilter.expiresAt;
                });
                if (applyServerSideFilters({ deferCommittedFilterRowCountSnapshot: true })) {
                    refreshSidebarFilterCount();
                }
            });

            scope.openFileFilterImport = function () {
                var fileFilterProfile = getFileFilterProfile();
                var sync = window.slickGridODataSidebarSync;
                scope.current.fileFilterEntity = fileFilterProfile ? fileFilterProfile.entity : 'Account';
                scope.current.fileFilterHeaderText = fileFilterProfile ? fileFilterProfile.headerText : '';
                scope.current.fileFilterColumns = sync && sync.getFileFilterColumns
                    ? sync.getFileFilterColumns(scope.filterableColumns)
                    : [];
                scope.current.fileFilterModalVisible = true;
            };

            scope.onFileFilterModalClosed = function () {
                scope.$evalAsync(function () {
                    scope.current.fileFilterModalVisible = false;
                });
            };

            // Downgraded Angular outputs run outside the AngularJS digest.
            scope.onFileFilterCreated = function (created) {
                scope.$evalAsync(function () {
                    var sync = window.slickGridODataSidebarSync;
                    if (!created || !sync || !sync.buildFileFilter || !scope.current || !scope.current.view) {
                        return;
                    }
                    scope.current.fileFilterModalVisible = false;
                    if (!scope.current.view.filters) {
                        scope.current.view.filters = [];
                    }
                    scope.current.view.filters.push(sync.buildFileFilter(created));
                    scope.current.showAddFilter = false;
                    $rootScope.$broadcast('event:slickgrid-ssrm-sidebar-local-change');
                    // The import is the user's search: apply it now rather than waiting for Search.
                    if (applyServerSideFilters({ deferCommittedFilterRowCountSnapshot: true })) {
                        var countPromise = refreshSidebarFilterCount();
                        if (!countPromise && scope.current.awaitingCommittedFilterRowCountSnapshot) {
                            delete scope.current.awaitingCommittedFilterRowCountSnapshot;
                        }
                    }
                });
            };

            scope.filterFromImport = function () {
                $dialog.inputBox("Upload File", "Excel File", "file", {postUrl: '/ValidateImport/Echo'})
                    .open()
                    .then(function (files) {
                        if (!files) return;

                        const values = Object.values(files[0].result)[0].map(function (x) {
                            return Object.values(x)[0];
                        });
                        scope.current.conditionValue1 = "[" + values.join(",") + "]";

                        scope.addFilter();
                    });
            };

            scope.deleteFilter = function (index) {
                scope.current.view.filters.splice(index, 1);
                if (isRecordColumnLimitFeatureEnabled()) {
                    notifySlickGridSidebarFilterChange();
                }
            };

            scope.onFilterIncludeChange = function () {
                if (!isRecordColumnLimitFeatureEnabled()) {
                    return;
                }
                if (usesDeferredODataSidebarSearch() || usesServerSideRowModel()) {
                    notifySlickGridSidebarFilterChange();
                    return;
                }
                applyServerSideFilters();
            };

            scope.convertQuickFilter = function () {
                if (!isRecordColumnLimitFeatureEnabled()) {
                    scope.current.view.filters.push(angular.copy(scope.current.view.quickFilter));
                    scope.current.view.quickFilter = null;
                    return;
                }

                var quick = angular.copy(scope.current.view.quickFilter);
                var sync = window.slickGridODataSidebarSync;
                var profileKey = getODataListProfileKey();
                var profile = profileKey && window.portfolioListODataSidebarSync
                    ? window.portfolioListODataSidebarSync.resolveProfile(profileKey)
                    : null;
                if (sync && sync.tryEnrichClientQuickFilterForOData) {
                    sync.tryEnrichClientQuickFilterForOData(quick, profile);
                }
                scope.current.view.filters.push(quick);
                scope.current.view.quickFilter = null;
                notifySlickGridSidebarFilterChange();
            };

            scope.copyToClipboard = function () {
                const textArea = document.createElement("textarea");
                textArea.value = scope.current.view.clipboardText;
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
            };

            scope.toggleAggregateType = function (index) {
                const column = scope.aggregatableColumns[index];
                const newIndex = aggregateTypes.indexOf(column.type) + 1;

                column.type = aggregateTypes[newIndex === aggregateTypes.length ? 0 : newIndex];
            };

            scope.addGroupBy = function () {
                const grouping = {getter: scope.current.grouping.columnDef.field, collapsed: scope.current.grouping.collapsed, enabled: true, aggregators: []};

                let valueFormatted;
                switch (scope.current.grouping.columnDef.formatter) {
                    case 'Slick.Formatters.DateTime':
                    case 'Slick.Formatters.Date':
                    case 'Slick.Formatters.Time':
                        valueFormatted = '(' + eval(scope.current.grouping.columnDef.formatter).toString() + ')(null,null,g.value,null,null)';
                        break;
                    case Slick.Formatters.Object:
                        valueFormatted = 'g.value' + (scope.current.grouping.columnDef.formatterField || "name");
                        break;
                    default:
                        valueFormatted = 'g.value';
                        break;
                }

                grouping.formatter = '(function (g) {return "' + scope.current.grouping.columnDef.name + ': " + ' + valueFormatted + ' + " (" + g.count + " items)";})';

                switch (scope.current.grouping.sort) {
                    case 0:
                        grouping.comparer = "(function (a, b) {return a.count - b.count;})";
                        grouping.name = scope.current.grouping.columnDef.name + " (count asc)";
                        break;
                    case 1:
                        grouping.comparer = "(function (a, b) {return b.count - a.count;})";
                        grouping.name = scope.current.grouping.columnDef.name + " (count desc)";
                        break;
                    case 2:
                        grouping.name = scope.current.grouping.columnDef.name + " (value)";
                        break;
                }

                scope.aggregatableColumns.forEach(function (col) {
                    if (col.type === "None") return;

                    grouping.aggregators.push("new Slick.Data.Aggregators." + col.type + "('" + col.field + "')");
                    scope.current.view.slickGridColumnDefs.find({field: col.field}).groupTotalsFormatter = "(" + col.type.toLowerCase() + "TotalsFormatter)";
                    col.type = "None";
                });
                grouping.aggregateCollapsed = scope.current.grouping.aggregateCollapsed; //still show aggregate row when group is collapsed

                scope.current.view.groups.push(grouping);
                resetAddGroup();
            };

            scope.toggleGroupsExpansion = function (expand) {
                if (!scope.current.view.groups) return;

                scope.current.view.groups.forEach(function (group) {
                    group.collapsed = !expand;
                });
            };

            scope.deleteGroupBy = function (index) {
                scope.current.view.groups.splice(index, 1);
            };

            scope.$watch('current.odataSyncFilterField', function (field) {
                if (!field) {
                    return;
                }
                applyODataSyncFilterFieldHint();
            });

            scope.$watch(
                function () {
                    if (!isRecordColumnLimitFeatureEnabled()) {
                        return false;
                    }
                    return isWorkflowAssistantFilterActive()
                        && scope.current
                        && scope.current.odataSidebarSyncFilter;
                },
                function (filter) {
                    if (!filter || !scope.filterableColumns || !scope.filterableColumns.length) {
                        return;
                    }
                    applyPendingODataSidebarSync();
                }
            );

            //INITIALIZE
            scope.rightsGlobalView = $oasRights.forCode("GLOBALVIEW");
            init();


            //DESTROY
            scope.$on('$destroy', function () {
                lastViewedCache[scope.current.view.pageCode] = scope.current.view.id;
            });
        }
    };
});


app.controller('NewSlickGridViewCtrl', function NewSlickGridViewCtrl($scope, dialog, groupManagerMode, canSetGlobalView) {
    //PUBLIC METHODS
    $scope.close = function () {
        dialog.close();
    };

    $scope.saveView = function () {
        if (groupManagerMode === "compass") {
            //Default values needed for Compass Inform Grouping Mgr
            $scope.current.isPrivate = false;
            $scope.current.groupManager.usedFor.compass = true;
        }

        dialog.close($scope.current);
    };

    //INITIALIZE
    $scope.current = {
        name: "",
        isUserDefault: false,
        isPrivate: true,
        groupManager: {
            mode: groupManagerMode,
            usedFor: {
                reporting: false,
                trading: false,
                repProfileAssignment: false,
                compass: groupManagerMode === "compass"
            }
        },
        canSetGlobalView: groupManagerMode === "compass" ? false : canSetGlobalView
    };//All Compass views are static
});

'use strict';

/**
 * Bidirectional OData $filter ↔ slick-grid view sidebar (Show Active + Filters accordion).
 * List-specific routing uses a profile object (see portfolioListODataSidebarSync.js).
 */
(function (global) {
    var ODATA_QUERY_KEY_REMAP = {
        odataFilter: '$filter',
        odataTop: '$top',
        odataSkip: '$skip',
        odataOrderBy: '$orderby'
    };

    var ODATA_OP_TO_CONDITION = {
        eq: 'equals',
        ne: 'does not equal',
        gt: 'is greater than',
        ge: 'is greater than or equal to',
        lt: 'is less than',
        le: 'is less than or equal to'
    };

    var ODATA_FUNC_TO_CONDITION = {
        startswith: 'starts with',
        endswith: 'ends with',
        contains: 'contains',
        substringof: 'contains'
    };

    var IS_ACTIVE_PROPERTY = /^isactive$/i;

    /**
     * WebApi OData v3 uses substringof('needle', Property), not v4 contains(Property, 'needle').
     * Workflow Assistant and other callers may still emit contains(...).
     */
    function normalizeODataV3Filter(filter) {
        if (!filter) {
            return filter;
        }
        var odataLiteral = "'(?:[^']|'')*'|true|false|-?\\d+(?:\\.\\d+)?";
        var property = '[a-zA-Z_][\\w.]*';
        var notContains = new RegExp(
            '\\bnot\\s+contains\\s*\\(\\s*(' + property + ')\\s*,\\s*(' + odataLiteral + ')\\s*\\)',
            'gi'
        );
        var contains = new RegExp(
            '\\bcontains\\s*\\(\\s*(' + property + ')\\s*,\\s*(' + odataLiteral + ')\\s*\\)',
            'gi'
        );
        return filter
            .replace(notContains, function (_match, prop, lit) {
                return 'not substringof(' + lit + ',' + prop + ')';
            })
            .replace(contains, function (_match, prop, lit) {
                return 'substringof(' + lit + ',' + prop + ')';
            });
    }

    function getODataFilterFromSearch(search) {
        var raw = search.$filter || search.odataFilter || null;
        return normalizeODataV3Filter(raw);
    }

    /**
     * Portfolio list deep links (Portfolio View, entity picker, page queries, etc.)
     * configure grid URL/params in list controllers — do not reset when leaving OData mode.
     */
    function hasPortfolioListRouteScope(search) {
        if (!search) {
            return false;
        }
        if (search.entity && search.entityId) {
            return true;
        }
        if (search.pageQueryId || search.entitySessionId || search.queryStudioId) {
            return true;
        }
        return false;
    }

    function trimOuterParens(text) {
        var s = (text || '').trim();
        while (s.charAt(0) === '(' && s.charAt(s.length - 1) === ')') {
            s = s.substring(1, s.length - 1).trim();
        }
        return s;
    }

    function splitODataOperator(filter, operator) {
        var clauses = [];
        var depth = 0;
        var start = 0;
        var inString = false;
        var opLower = operator.toLowerCase();

        for (var i = 0; i < filter.length; i++) {
            var ch = filter[i];
            if (ch === "'" && (i === 0 || filter[i - 1] !== '\\')) {
                inString = !inString;
                continue;
            }
            if (inString) {
                continue;
            }
            if (ch === '(') {
                depth++;
            } else if (ch === ')') {
                depth--;
            } else if (depth === 0 && filter.slice(i, i + operator.length).toLowerCase() === opLower) {
                var part = filter.slice(start, i).trim();
                if (part) {
                    clauses.push(trimOuterParens(part));
                }
                start = i + operator.length;
                i += operator.length - 1;
            }
        }

        var tail = filter.slice(start).trim();
        if (tail) {
            clauses.push(trimOuterParens(tail));
        }
        return clauses;
    }

    function splitODataAnd(filter) {
        return splitODataOperator(filter, ' and ');
    }

    function splitODataOr(filter) {
        return splitODataOperator(filter, ' or ');
    }

    function collectODataLeafClauses(filter) {
        if (!filter) {
            return [];
        }

        var trimmed = trimOuterParens(filter.trim());
        if (!trimmed) {
            return [];
        }

        var andParts = splitODataAnd(trimmed);
        if (andParts.length > 1) {
            var andLeaves = [];
            andParts.forEach(function (part) {
                andLeaves = andLeaves.concat(collectODataLeafClauses(part));
            });
            return andLeaves;
        }

        var orParts = splitODataOr(trimmed);
        if (orParts.length > 1) {
            var orLeaves = [];
            orParts.forEach(function (part) {
                orLeaves = orLeaves.concat(collectODataLeafClauses(part));
            });
            return orLeaves;
        }

        return [trimmed];
    }

    function detectODataFilterJoinType(filter) {
        if (!filter) {
            return 'All';
        }

        var trimmed = trimOuterParens(filter.trim());
        if (splitODataAnd(trimmed).length > 1) {
            return 'All';
        }
        if (splitODataOr(trimmed).length > 1) {
            return 'Any';
        }
        return 'All';
    }

    function parseClauseValue(raw) {
        var v = (raw || '').trim();
        if (/^true$/i.test(v)) {
            return { kind: 'bool', value: true };
        }
        if (/^false$/i.test(v)) {
            return { kind: 'bool', value: false };
        }
        if (/^'.*'$/.test(v)) {
            return { kind: 'string', value: v.slice(1, -1).replace(/''/g, "'") };
        }
        if (/^-?\d+(\.\d+)?$/.test(v)) {
            return { kind: 'number', value: v };
        }
        return { kind: 'string', value: v };
    }

    function parseComparisonClause(clause) {
        var match = trimOuterParens(clause).match(/^([a-zA-Z_][\w.]*)\s+(eq|ne|gt|ge|lt|le)\s+(.+)$/i);
        if (!match) {
            return null;
        }
        return {
            property: match[1],
            operator: match[2].toLowerCase(),
            value: parseClauseValue(match[3])
        };
    }

    function parseFunctionClause(clause) {
        var match = trimOuterParens(clause).match(/^([a-zA-Z_]\w*)\s*\(\s*([a-zA-Z_][\w.]*)\s*,\s*(.+)\)\s*$/i);
        if (!match) {
            return null;
        }
        var fn = match[1].toLowerCase();
        var conditionName = ODATA_FUNC_TO_CONDITION[fn];
        if (!conditionName) {
            return null;
        }
        return {
            property: match[2],
            operator: fn,
            conditionName: conditionName,
            value: parseClauseValue(match[3])
        };
    }

    /** OData v2/v3: substringof('needle', Property) — argument order is reversed vs startswith/contains. */
    function parseSubstringofClause(clause) {
        var match = trimOuterParens(clause).match(
            /^substringof\s*\(\s*('(?:[^']|'')*'|true|false|-?\d+(?:\.\d+)?)\s*,\s*([a-zA-Z_][\w.]*)\s*\)\s*$/i
        );
        if (!match) {
            return null;
        }
        return {
            property: match[2],
            operator: 'substringof',
            conditionName: 'contains',
            value: parseClauseValue(match[1])
        };
    }

    function parseNotSubstringofClause(clause) {
        var match = trimOuterParens(clause).match(
            /^not\s+substringof\s*\(\s*('(?:[^']|'')*'|true|false|-?\d+(?:\.\d+)?)\s*,\s*([a-zA-Z_][\w.]*)\s*\)\s*$/i
        );
        if (!match) {
            return null;
        }
        return {
            property: match[2],
            operator: 'substringof',
            conditionName: 'does not contain',
            value: parseClauseValue(match[1])
        };
    }

    function parseODataClause(clause) {
        return parseComparisonClause(clause)
            || parseNotSubstringofClause(clause)
            || parseFunctionClause(clause)
            || parseSubstringofClause(clause);
    }

    function getColumnHeaderLabel(column) {
        if (!column) {
            return '';
        }
        return column.name || column.Name || column.field || column.Field || '';
    }

    function resolvePropertyDisplayLabel(odataProperty, column, propertyDisplayLabels) {
        var key = (odataProperty || '').toLowerCase();
        if (propertyDisplayLabels && propertyDisplayLabels[key]) {
            return propertyDisplayLabels[key];
        }
        var header = getColumnHeaderLabel(column);
        if (header) {
            return header;
        }
        return odataProperty || '';
    }

    function findColumnForProperty(columnDefs, propertyName, propertyAliases, profile) {
        if (!columnDefs || !propertyName) {
            return null;
        }
        var lower = propertyName.toLowerCase();
        var i;
        var col;

        function matchColumnField(fieldKey) {
            var key = String(fieldKey || '').toLowerCase();
            if (!key) {
                return null;
            }
            for (i = 0; i < columnDefs.length; i++) {
                col = columnDefs[i];
                if (col.field && col.field.toLowerCase() === key) {
                    return col;
                }
                if (col.id && String(col.id).toLowerCase() === key) {
                    return col;
                }
            }
            return null;
        }

        col = matchColumnField(lower);
        if (col) {
            return col;
        }

        if (propertyAliases && propertyAliases[lower]) {
            col = matchColumnField(propertyAliases[lower]);
            if (col) {
                return col;
            }
        }

        if (profile && profile.odataPropertyNames) {
            Object.each(profile.odataPropertyNames, function (fieldKey, odataName) {
                if (col) {
                    return;
                }
                if (String(odataName).toLowerCase() === lower) {
                    col = matchColumnField(fieldKey);
                }
            });
        }

        return col || null;
    }

    function getColumnConditions(column) {
        if (!column) {
            return [];
        }
        if (column.conditions && column.conditions.length) {
            return column.conditions;
        }
        if (!column.conditionType) {
            return [];
        }
        var standardConditions = global.slickGridStandardConditions;
        if (!standardConditions) {
            return [];
        }
        var i;
        for (i = 0; i < standardConditions.length; i++) {
            if (standardConditions[i].type === column.conditionType) {
                return standardConditions[i].conditions || [];
            }
        }
        return [];
    }

    function findCondition(column, conditionName) {
        var conditions = getColumnConditions(column);
        if (!conditions.length) {
            return null;
        }
        var target = (conditionName || '').toLowerCase();
        for (var i = 0; i < conditions.length; i++) {
            if ((conditions[i].name || '').toLowerCase() === target) {
                return conditions[i];
            }
        }
        return null;
    }

    function shortConditionName(value) {
        switch (value) {
            case 'equals': return '=';
            case 'does not equal': return '≠';
            case 'is greater than': return '>';
            case 'is less than': return '<';
            case 'is greater than or equal to': return '>=';
            case 'is less than or equal to': return '<=';
            default: return value;
        }
    }

    function escapeForSingleQuotedJs(value) {
        return String(value ?? '')
            .replace(/\\/g, '\\\\')
            .replace(/'/g, "\\'")
            .replace(/\r/g, '\\r')
            .replace(/\n/g, '\\n')
            .replace(/\u2028/g, '\\u2028')
            .replace(/\u2029/g, '\\u2029');
    }

    function normalizeBasicNumberFilterValue(value) {
        return String(value ?? '').replace(/\$/g, '');
    }

    function buildViewFilter(column, condition, displayValue, displayLabel) {
        var label = displayLabel || getColumnHeaderLabel(column);
        var name = label + ' ' + shortConditionName(condition.name);
        var value = condition.value;
        var tempValue = displayValue;
        var substituteValue = column.conditionType === 'basicNumber'
            ? normalizeBasicNumberFilterValue(displayValue)
            : displayValue;

        if (condition.input1 || condition.select1) {
            if (column.conditionType === 'basicNumber' || condition.isNumericType) {
                value = value.replace('{value}', substituteValue);
            } else {
                var escapedValue = escapeForSingleQuotedJs(tempValue);
                value = value.replace('{value}', condition.select1 ? escapedValue
                    : (escapedValue.length === 0 && value.indexOf("'{value}'") === -1 ? "''" : escapedValue.toLowerCase()));
            }
            name += ' ' + (tempValue === '' ? '{blank}' : tempValue);
        }

        var filter = {
            name: name,
            key: column.field,
            include: true,
            odataSync: true,
            odataCondition: condition.name,
            odataValue: displayValue,
            odataProperty: column.odataProperty || null,
            conditionType: column.conditionType || null
        };
        // TODO : remove this when removing opex_rework_2026_orion_connect_pentest_cross_site_39440 feature flag
        if (window.isPentestCrossSiteFilterReworkEnabled && global.slickGridFilterFormat) {
            var structured = global.slickGridFilterFormat.buildStructuredFields(column, condition, displayValue);
            if (structured) {
                filter.operator = structured.operator;
                filter.conditionType = structured.conditionType;
                filter.filterValue = structured.filterValue;
                filter.filterValue2 = structured.filterValue2;
                filter.filterValues = structured.filterValues;
            }
        } else {
            // TODO : remove this when removing opex_rework_2026_orion_connect_pentest_cross_site_39440 feature flag
            filter.value = value;
        }
        return filter;
    }

    function buildIsActiveSidebarFilter(columnDefs, isActive, propertyAliases, profile) {
        var column = findColumnForProperty(columnDefs, 'isActive', propertyAliases, profile);
        if (!column) {
            return null;
        }
        var conditionName = isActive ? 'is true' : 'is false';
        var condition = findCondition(column, conditionName);
        if (!condition) {
            return null;
        }
        return buildViewFilter(column, condition, '');
    }

    function parseIsActiveValue(parsed) {
        if (!parsed || parsed.value.kind !== 'bool') {
            return null;
        }
        return parsed.value.value;
    }

    function removeIsActiveClauses(filter) {
        if (!filter) {
            return '';
        }
        var clauses = splitODataAnd(filter);
        var kept = [];
        clauses.forEach(function (clause) {
            var parsed = parseODataClause(clause);
            if (parsed && IS_ACTIVE_PROPERTY.test(parsed.property)) {
                return;
            }
            kept.push(clause);
        });
        return kept.length ? kept.join(' and ') : '';
    }

    function parseIsActiveFromODataFilter(filter) {
        if (!filter) {
            return null;
        }
        var clauses = splitODataAnd(filter);
        var found = null;
        clauses.forEach(function (clause) {
            var parsed = parseComparisonClause(clause);
            if (!parsed || !IS_ACTIVE_PROPERTY.test(parsed.property) || parsed.operator !== 'eq') {
                return;
            }
            var v = parseIsActiveValue(parsed);
            if (v !== null) {
                found = v;
            }
        });
        return found;
    }

    function buildSidebarFiltersFromOData(filter, columnDefs, profile) {
        var filters = [];
        var fieldHint = null;
        var propertyAliases = (profile && profile.propertyAliases) || {};
        var propertyDisplayLabels = (profile && profile.propertyDisplayLabels) || {};

        if (!filter) {
            return { filters: filters, fieldHint: fieldHint, filterType: 'All', cleanedFilter: '' };
        }

        var filterType = detectODataFilterJoinType(filter);
        var clauses = collectODataLeafClauses(filter);
        clauses.forEach(function (clause) {
            var parsed = parseODataClause(clause);
            if (!parsed || IS_ACTIVE_PROPERTY.test(parsed.property)) {
                return;
            }

            var column = findColumnForProperty(columnDefs, parsed.property, propertyAliases, profile);
            if (!column) {
                return;
            }

            var conditionName = parsed.conditionName || ODATA_OP_TO_CONDITION[parsed.operator];
            if (parsed.value.kind === 'bool') {
                conditionName = parsed.value.value ? 'is true' : 'is false';
            }
            if (!conditionName) {
                return;
            }

            var condition = findCondition(column, conditionName);
            if (!condition) {
                return;
            }

            var displayValue = parsed.value.kind === 'bool'
                ? ''
                : String(parsed.value.value);
            var displayLabel = resolvePropertyDisplayLabel(parsed.property, column, propertyDisplayLabels);
            if (column) {
                column.odataProperty = parsed.property;
            }

            filters.push(buildViewFilter(column, condition, displayValue, displayLabel));
            if (!fieldHint) {
                fieldHint = {
                    field: column.field || column.Field,
                    name: displayLabel
                };
            }
        });

        return {
            filters: filters,
            fieldHint: fieldHint,
            filterType: filterType,
            cleanedFilter: removeIsActiveClauses(filter)
        };
    }

    /**
     * Profile: { routeOnlyKeys, templateParamKeys, propertyAliases?, propertyDisplayLabels?, scopeSearchBindings? }
     */
    function buildODataGridParams(search, profile, options) {
        options = options || {};
        var parts = [];
        var odataFilter = getODataFilterFromSearch(search);

        if (odataFilter) {
            parts.push('$filter=' + odataFilter);
        }

        Object.each(search, function (key, value) {
            if (value === null || value === undefined || value === '') {
                return;
            }
            if (profile.routeOnlyKeys[key] || profile.templateParamKeys[key]) {
                return;
            }
            if (key === '$filter' || key === 'odataFilter') {
                return;
            }

            var paramKey = ODATA_QUERY_KEY_REMAP[key] || key;
            if (paramKey === '$top' || paramKey === '$skip') {
                return;
            }

            parts.push(paramKey + '=' + value);
        });

        applyDefaultOrderByWhenFiltered(search, parts, options.defaultOrderByWhenFiltered);

        return parts.length ? '&' + parts.join('&') : '';
    }

    function parseGridParamParts(gridParams, params, options) {
        options = options || {};
        String(gridParams || '').replace(/^&/, '').split('&').forEach(function (part) {
            if (!part) {
                return;
            }
            var eq = part.indexOf('=');
            if (eq === -1) {
                return;
            }
            var key = part.slice(0, eq);
            var value = decodeURIComponent(part.slice(eq + 1));
            if (value === '' || value === 'undefined' || value === 'null') {
                return;
            }
            if (key === '$top' || key === '$skip') {
                return;
            }
            if (!options.includeOrderBy && key === '$orderby') {
                return;
            }
            if (params[key] === undefined) {
                params[key] = value;
            }
        });
    }

    function mergeWithRouteScopeODataFilter(scope, filter) {
        if (!scope || !scope.current) {
            return filter || null;
        }
        var routeScope = scope.current.routeScopeODataFilter;
        if (!routeScope) {
            return filter || null;
        }
        if (!filter) {
            return routeScope;
        }
        return '(' + routeScope + ') and (' + filter + ')';
    }

    /**
     * Builds GET query params for OData list endpoints (template scope + $filter).
     */
    function buildODataListQueryParams(scope, profile, options) {
        options = options || {};
        var params = {};
        var current = scope && scope.current ? scope.current : {};

        if (profile.templateParamKeys.isActive && current.activeState) {
            var activeVal = current.activeState.queryString;
            if (activeVal === 'true') {
                params.isActive = true;
            } else if (activeVal === 'false') {
                params.isActive = false;
            }
        }

        Object.each(profile.templateParamKeys, function (key) {
            if (key === 'isActive' || key === 'refreshCache') {
                return;
            }
            var prop = (profile.scopeSearchBindings && profile.scopeSearchBindings[key]) || key;
            var camelProp = prop.charAt(0).toLowerCase() + prop.slice(1);
            var val = current[camelProp];
            if (val === undefined) {
                val = current[prop];
            }
            if (val === undefined || val === null || val === '') {
                return;
            }
            params[key] = val;
        });

        var odataFilter = options.odataFilterOverride;
        if (odataFilter === undefined && current.odataFilter) {
            odataFilter = current.odataFilter;
        }
        odataFilter = mergeWithRouteScopeODataFilter(scope, odataFilter);
        if (odataFilter) {
            params.$filter = odataFilter;
        }

        parseGridParamParts(current.gridParams, params);
        return params;
    }

    function compileSidebarFiltersForCount(scope, profile) {
        if (!scope || !scope.current) {
            return '';
        }
        var view = scope.current.view || {};
        prepareViewFiltersForOData(view.filters, profile);
        var compiled = compileFiltersToOData(view.filters, view.filterType, profile);
        return resolveCompiledODataFilter(compiled);
    }

    function refreshPortfolioSidebarFilterCount(scope, http) {
        if (!scope || !scope.current || !http) {
            return null;
        }
        if (!isDeferredODataSidebarSearchEnabled(scope)) {
            return null;
        }
        var profileKey = scope.current.odataListProfileKey;
        var portfolioSync = global.portfolioListODataSidebarSync;
        if (!profileKey || !portfolioSync || !portfolioSync.resolveProfile) {
            return null;
        }
        var profile = portfolioSync.resolveProfile(profileKey);
        return fetchSidebarFilterRowCount(scope, http, profile);
    }

    function fetchSidebarFilterRowCount(scope, http, profile) {
        if (!scope || !scope.current || !http || !profile || !profile.odataCountUrl) {
            return null;
        }
        if (!isDeferredODataSidebarSearchEnabled(scope)) {
            return null;
        }

        scope.current.sidebarFilterCountRequestId = (scope.current.sidebarFilterCountRequestId || 0) + 1;
        var requestId = scope.current.sidebarFilterCountRequestId;

        scope.current.gridFilterRowCountReady = false;
        scope.current.gridFilterRowCountLoading = true;
        delete scope.current.gridFilterRowCount;

        var compiledFilter = compileSidebarFiltersForCount(scope, profile);
        return http.get(profile.odataCountUrl, {
            params: buildODataListQueryParams(scope, profile, {
                odataFilterOverride: compiledFilter
            }),
            ignoreExceptions: true,
            trackerMsg: 'Loading filter row count'
        }).then(function (response) {
            if (!scope.current || requestId !== scope.current.sidebarFilterCountRequestId) {
                return;
            }
            if (response && response.data && response.data.count != null) {
                scope.current.gridFilterRowCount = response.data.count;
            }
            scope.current.gridFilterRowCountReady = true;
            scope.current.gridFilterRowCountLoading = false;
            completeCommittedFilterRowCountSnapshot(scope);
        }, function () {
            if (!scope.current || requestId !== scope.current.sidebarFilterCountRequestId) {
                return;
            }
            scope.current.gridFilterRowCountReady = true;
            scope.current.gridFilterRowCountLoading = false;
            completeCommittedFilterRowCountSnapshot(scope);
        });
    }

    function resolveRecordLimitGridTop(scope) {
        if (!scope || !scope.current) {
            return ODATA_LIST_PAGE_SIZE;
        }
        var recordLimit = parseInt(scope.current.gridRecordLimit, 10) || 0;
        if (recordLimit > 0) {
            return recordLimit;
        }
        return ODATA_LIST_PAGE_SIZE;
    }

    /**
     * Portfolio SSRM (FF on): request page size from entity options, not the legacy 50k cap.
     */
    function resolvePortfolioGridRequestTop(scope) {
        if (!scope || !scope.current || !isRecordColumnLimitFeatureEnabled(scope)) {
            return 0;
        }

        var requestTop = parseInt(scope.current.gridRequestTop, 10);
        if (requestTop > 0) {
            return requestTop;
        }

        var recordLimit = parseInt(scope.current.gridRecordLimit, 10) || 0;
        return recordLimit > 0 ? recordLimit : 0;
    }

    function resetPortfolioGridRowCountBanner(scope) {
        if (!scope || !scope.current) {
            return;
        }
        scope.current.gridRecordLimitReached = false;
        scope.current.gridRowCountsReady = false;
        delete scope.current.gridRequestTop;
    }

    function fetchODataListCount(scope, http, profile) {
        if (!scope || !scope.current || !http || !profile || !profile.odataCountUrl) {
            return null;
        }
        if (!isRecordColumnLimitFeatureEnabled(scope)) {
            return null;
        }

        scope.current.gridTotalCount = null;
        return http.get(profile.odataCountUrl, {
            params: buildODataListQueryParams(scope, profile),
            ignoreExceptions: true,
            trackerMsg: 'Loading row count'
        }).then(function (response) {
            if (response && response.data && response.data.count != null) {
                scope.current.gridTotalCount = response.data.count;
            }
        });
    }

    /**
     * Snapshot sidebar filter count when Refresh Grid commits filters.
     * gridFilterRowCount continues to track live sidebar edits; the grid banner must
     * stay tied to the count from refresh time even if filters change before load finishes.
     */
    function snapshotGridCommittedFilterRowCount(scope) {
        if (!scope || !scope.current || !isDeferredODataSidebarSearchEnabled(scope)) {
            return;
        }
        if (scope.current.gridFilterRowCountReady && scope.current.gridFilterRowCount != null) {
            scope.current.gridCommittedFilterRowCount = scope.current.gridFilterRowCount;
            return;
        }
        delete scope.current.gridCommittedFilterRowCount;
    }

    function completeCommittedFilterRowCountSnapshot(scope) {
        if (!scope || !scope.current || !scope.current.awaitingCommittedFilterRowCountSnapshot) {
            return;
        }
        snapshotGridCommittedFilterRowCount(scope);
        delete scope.current.awaitingCommittedFilterRowCountSnapshot;
    }

    function applyCommittedFilterRowCountSnapshot(scope, options) {
        if (!scope || !scope.current || !isDeferredODataSidebarSearchEnabled(scope)) {
            return;
        }
        if (options.deferCommittedFilterRowCountSnapshot) {
            scope.current.awaitingCommittedFilterRowCountSnapshot = true;
            delete scope.current.gridCommittedFilterRowCount;
            return;
        }
        snapshotGridCommittedFilterRowCount(scope);
    }

    /**
     * Deferred sidebar search already fetched Count while editing filters.
     * Reuse the refresh-time snapshot for the main grid banner instead of calling Count again.
     */
    function resolvePortfolioGridTotalFromSidebarFilterCount(scope, q) {
        if (!scope || !scope.current || !q) {
            return q ? q.resolve(false) : null;
        }
        if (!isDeferredODataSidebarSearchEnabled(scope)) {
            return q.resolve(false);
        }

        function applyCommittedCount() {
            if (scope.current.gridCommittedFilterRowCount != null) {
                scope.current.gridTotalCount = scope.current.gridCommittedFilterRowCount;
                return true;
            }
            return false;
        }

        if (applyCommittedCount()) {
            return q.resolve(true);
        }

        if (!scope.current.awaitingCommittedFilterRowCountSnapshot) {
            return q.resolve(false);
        }

        var deferred = q.defer();
        var unwatch = scope.$watch(function () {
            if (!scope.current) {
                return false;
            }
            if (scope.current.gridCommittedFilterRowCount != null) {
                return true;
            }
            return !scope.current.awaitingCommittedFilterRowCountSnapshot
                && scope.current.gridFilterRowCountReady;
        }, function (ready) {
            if (!ready || !scope.current) {
                return;
            }
            unwatch();
            deferred.resolve(applyCommittedCount());
        });
        scope.$on('$destroy', unwatch);
        return deferred.promise;
    }

    function updatePortfolioGridRowCounts(scope, loadedCount) {
        if (!scope || !scope.current) {
            return;
        }
        scope.current.gridLoadedCount = loadedCount;
        if (!isRecordColumnLimitFeatureEnabled(scope)) {
            return;
        }
        var requestTop = scope.current.gridRequestTop || 0;
        var total = scope.current.gridTotalCount;
        scope.current.gridRecordLimitReached = requestTop > 0
            && total != null
            && total > requestTop;
        scope.current.gridRowCountsReady = true;
    }

    function resolveIsActiveForSidebarSync(search, odataFilter) {
        if (search.isActive === true || search.isActive === 'true') {
            return true;
        }
        if (search.isActive === false || search.isActive === 'false') {
            return false;
        }
        if (odataFilter) {
            return parseIsActiveFromODataFilter(odataFilter);
        }
        return null;
    }

    function getActiveStateEnumValue(selection) {
        if (!selection || selection.value == null) {
            return null;
        }
        return String(selection.value);
    }

    function resolveIsActiveBoolFromSelection(selection, activeStateEnum) {
        if (!selection || !activeStateEnum) {
            return null;
        }
        var value = getActiveStateEnumValue(selection);
        if (value === activeStateEnum.active.value) {
            return true;
        }
        if (value === activeStateEnum.inActive.value) {
            return false;
        }
        return null;
    }

    /**
     * Writes Show Active / Not Active / Both to the route query as isActive=true|false (Both omits the param).
     */
    function syncActiveStateQueryToSearch(search, scope, activeStateEnum) {
        if (!search || !scope || !scope.current || !activeStateEnum) {
            return search;
        }
        var selection = scope.current.activeState;
        if (!selection) {
            return search;
        }
        var value = getActiveStateEnumValue(selection);
        if (value === activeStateEnum.active.value) {
            search.isActive = 'true';
        } else if (value === activeStateEnum.inActive.value) {
            search.isActive = 'false';
        } else {
            delete search.isActive;
        }
        return search;
    }

    function applyIsActiveFromSearch(search, odataFilter, scope, activeState) {
        var result = { filter: odataFilter, isActive: null };
        var hasDedicatedIsActive = search.isActive === true || search.isActive === 'true'
            || search.isActive === false || search.isActive === 'false';

        if (hasDedicatedIsActive) {
            result.isActive = (search.isActive === true || search.isActive === 'true');
            if (scope && activeState) {
                scope.current.activeState = result.isActive ? activeState.active : activeState.inActive;
            }
            result.filter = removeIsActiveClauses(odataFilter);
            return result;
        }

        if (odataFilter) {
            var fromOData = parseIsActiveFromODataFilter(odataFilter);
            if (fromOData === true || fromOData === false) {
                result.isActive = fromOData;
                if (scope && activeState) {
                    scope.current.activeState = fromOData ? activeState.active : activeState.inActive;
                }
            } else if (scope && scope.current && scope.current.activeState && activeState) {
                result.isActive = resolveIsActiveBoolFromSelection(scope.current.activeState, activeState);
            }
            result.filter = removeIsActiveClauses(odataFilter);
        }

        return result;
    }

    function applyScopeSearchBindings(scope, search, profile) {
        if (!profile.scopeSearchBindings) {
            return;
        }
        Object.each(profile.scopeSearchBindings, function (searchKey, scopeKey) {
            if (search[searchKey] !== null && search[searchKey] !== undefined && search[searchKey] !== '') {
                scope.current[scopeKey] = search[searchKey];
            }
        });
    }

    function cloneSearchForGrid(search, odataFilterForGrid, originalOdataFilter) {
        var searchForGrid = angular.extend({}, search);
        if (odataFilterForGrid !== originalOdataFilter) {
            if (searchForGrid.$filter) {
                searchForGrid.$filter = odataFilterForGrid;
            }
            if (searchForGrid.odataFilter) {
                searchForGrid.odataFilter = odataFilterForGrid;
            }
        }
        if (!odataFilterForGrid) {
            delete searchForGrid.$filter;
            delete searchForGrid.odataFilter;
        }
        return searchForGrid;
    }

    function odataValuesEquivalent(left, right) {
        var leftValues = left && left.length ? left : null;
        var rightValues = right && right.length ? right : null;
        if (!leftValues && !rightValues) {
            return true;
        }
        if (!leftValues || !rightValues || leftValues.length !== rightValues.length) {
            return false;
        }
        for (var i = 0; i < leftValues.length; i++) {
            if (String(leftValues[i]) !== String(rightValues[i])) {
                return false;
            }
        }
        return true;
    }

    function filterODataClause(filter, profile) {
        if (!filter) {
            return null;
        }
        var compiled = angular.extend({}, filter, { include: true });
        tryEnrichClientQuickFilterForOData(compiled, profile);
        return compileFilterToODataClause(compiled, profile);
    }

    function sidebarFiltersEquivalent(existing, incoming, profile) {
        if (isFileFilter(existing) || isFileFilter(incoming)) {
            return fileFiltersEquivalent(existing, incoming);
        }
        if (!existing || !incoming || existing.key !== incoming.key) {
            return false;
        }
        if (existing.name === incoming.name) {
            return true;
        }
        if (existing.odataCondition && incoming.odataCondition
            && existing.odataCondition === incoming.odataCondition) {
            if (!odataValuesEquivalent(existing.odataValues, incoming.odataValues)) {
                return false;
            }
            return String(existing.odataValue ?? '') === String(incoming.odataValue ?? '');
        }
        if (profile) {
            var existingClause = filterODataClause(existing, profile);
            var incomingClause = filterODataClause(incoming, profile);
            if (existingClause && incomingClause) {
                return normalizeODataV3Filter(existingClause) === normalizeODataV3Filter(incomingClause);
            }
        }
        return false;
    }

    function pruneDuplicateODataSyncFilters(filters, profile) {
        if (!filters || !filters.length) {
            return filters;
        }
        return filters.filter(function (filter, index, all) {
            if (!filter || !filter.odataSync) {
                return true;
            }
            for (var i = 0; i < all.length; i++) {
                if (i === index || !all[i] || all[i].odataSync) {
                    continue;
                }
                if (sidebarFiltersEquivalent(all[i], filter, profile)) {
                    all[i].include = true;
                    return false;
                }
            }
            return true;
        });
    }

    function syncSidebarToScope(scope, odataFilter, profile) {
        if (!scope.views || !scope.views.length) {
            return;
        }

        var columnDefs = scope.views[0].slickGridColumnDefs;
        var sidebar = buildSidebarFiltersFromOData(odataFilter || '', columnDefs, profile);
        var filtersToAdd = sidebar.filters.slice();

        if (!filtersToAdd.length) {
            return;
        }

        var view = scope.current.view || scope.views[0];
        if (!view.filters) {
            view.filters = [];
        }
        if (!view.filterType) {
            view.filterType = 'All';
        }

        if (sidebar.filterType) {
            view.filterType = sidebar.filterType;
        }

        // Saved view filters without OData metadata must not client-filter OData results.
        view.filters.forEach(function (f) {
            if (!f.odataSync && !f.odataCondition && !isFileFilter(f)) {
                f.include = false;
            }
        });

        filtersToAdd.forEach(function (filter) {
            var exists = false;
            view.filters.forEach(function (f) {
                if (sidebarFiltersEquivalent(f, filter, profile)) {
                    exists = true;
                    f.include = true;
                    if (!f.odataCondition && filter.odataCondition) {
                        f.odataCondition = filter.odataCondition;
                        f.odataValue = filter.odataValue;
                        f.odataValue2 = filter.odataValue2;
                        f.odataValues = filter.odataValues;
                        f.odataProperty = filter.odataProperty;
                        f.conditionType = filter.conditionType;
                    }
                }
            });
            if (!exists) {
                view.filters.push(filter);
            }
        });

        view.filters = pruneDuplicateODataSyncFilters(view.filters, profile);

        if (sidebar.fieldHint && sidebar.fieldHint.field) {
            scope.current.odataSyncFilterField = sidebar.fieldHint.field;
            scope.current.odataSyncFilterFieldLabel = sidebar.fieldHint.name || null;
        }
    }

    var CONDITION_TO_ODATA_COMPARE = {
        equals: 'eq',
        'does not equal': 'ne',
        'is greater than': 'gt',
        'is greater than or equal to': 'ge',
        'is less than': 'lt',
        'is less than or equal to': 'le',
        'is after (date)': 'gt',
        'is before (date)': 'lt'
    };

    var CONDITION_TO_ODATA_FUNC = {
        'starts with': 'startswith',
        'ends with': 'endswith',
        contains: 'contains'
    };

    var CONDITION_TO_ODATA_NOT_FUNC = {
        'does not start with': 'startswith',
        'does not end with': 'endswith',
        'does not contain': 'contains'
    };

    function isBlankODataValue(value) {
        if (value == null) {
            return true;
        }
        var s = String(value).trim();
        return s === '' || s.toLowerCase() === '{blank}';
    }

    /** Nullable enum / select dropdown columns have no basic* conditionType in column defs. */
    function isSelectEnumFilter(conditionType) {
        return conditionType == null || conditionType === '';
    }

    function buildNullCompareClause(property, op) {
        if (!property || !op) {
            return null;
        }
        return property + ' ' + op + ' null';
    }

    function toODataPropertyName(field, profile) {
        if (!field) {
            return null;
        }
        var lower = String(field).toLowerCase();
        if (profile && profile.odataPropertyNames && profile.odataPropertyNames[lower]) {
            return profile.odataPropertyNames[lower];
        }
        return field.charAt(0).toUpperCase() + field.slice(1);
    }

    function escapeODataString(value) {
        return String(value ?? '').replace(/'/g, "''");
    }

    function pad2(n) {
        return n < 10 ? '0' + n : String(n);
    }

    function toODataDateTimeLiteral(value) {
        if (value == null || value === '' || String(value).trim() === '' || String(value).trim().toLowerCase() === '{blank}') {
            return null;
        }
        var d = (typeof Date.create === 'function') ? Date.create(value) : new Date(value);
        if (!d || (typeof d.isValid === 'function' && !d.isValid()) || isNaN(d.valueOf())) {
            return null;
        }
        return "datetime'" + d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()) + "T00:00:00'";
    }

    function formatODataLiteral(value, conditionType, isNumericType) {
        if (value === true || value === 'true') {
            return 'true';
        }
        if (value === false || value === 'false') {
            return 'false';
        }
        if (conditionType === 'basicDate') {
            return toODataDateTimeLiteral(value);
        }
        if (conditionType === 'basicNumber' || isNumericType) {
            var n = normalizeBasicNumberFilterValue(value);
            if (n === '' || isNaN(Number(n))) {
                return null;
            }
            return n;
        }
        return "'" + escapeODataString(value) + "'";
    }

    function buildCompareClause(property, op, literal) {
        if (!property || !op || literal == null || literal === '') {
            return null;
        }
        return property + ' ' + op + ' ' + literal;
    }

    function buildFuncClause(fn, property, literal, negated) {
        if (!fn || !property || literal == null || literal === '') {
            return null;
        }
        var clause;
        if (fn === 'contains') {
            // OData v3 (System.Web.Http.OData): substringof('needle', Property)
            clause = 'substringof(' + literal + ',' + property + ')';
        } else {
            clause = fn + '(' + property + ',' + literal + ')';
        }
        return negated ? 'not ' + clause : clause;
    }

    function compileMultiValueClause(property, conditionName, values, conditionType, isNumericType) {
        if (!values || !values.length) {
            return null;
        }
        var parts = [];
        values.forEach(function (item) {
            var clause = null;
            if (isBlankODataValue(item) && isSelectEnumFilter(conditionType)) {
                if (conditionName === 'equals') {
                    clause = buildNullCompareClause(property, 'eq');
                } else if (conditionName === 'does not equal') {
                    clause = buildNullCompareClause(property, 'ne');
                }
            }
            if (clause) {
                parts.push(clause);
                return;
            }
            var literal = formatODataLiteral(item, conditionType, isNumericType);
            if (conditionName === 'equals') {
                clause = buildCompareClause(property, 'eq', literal);
            } else if (conditionName === 'does not equal') {
                clause = buildCompareClause(property, 'ne', literal);
            } else if (CONDITION_TO_ODATA_FUNC[conditionName]) {
                clause = buildFuncClause(CONDITION_TO_ODATA_FUNC[conditionName], property, literal, false);
            } else if (CONDITION_TO_ODATA_NOT_FUNC[conditionName]) {
                clause = buildFuncClause(CONDITION_TO_ODATA_NOT_FUNC[conditionName], property, literal, true);
            }
            if (clause) {
                parts.push(clause);
            }
        });
        if (!parts.length) {
            return null;
        }
        var joiner = conditionName === 'does not equal' || CONDITION_TO_ODATA_NOT_FUNC[conditionName] ? ' and ' : ' or ';
        return parts.length === 1 ? parts[0] : '(' + parts.join(joiner) + ')';
    }

    var DISPLAY_NAME_CONDITION_PATTERNS = [
        { suffix: ' does not start with ', condition: 'does not start with' },
        { suffix: ' does not end with ', condition: 'does not end with' },
        { suffix: ' does not contain ', condition: 'does not contain' },
        { suffix: ' does not equal ', condition: 'does not equal' },
        { suffix: ' starts with ', condition: 'starts with' },
        { suffix: ' ends with ', condition: 'ends with' },
        { suffix: ' contains ', condition: 'contains' },
        { suffix: ' is greater than or equal to ', condition: 'is greater than or equal to' },
        { suffix: ' is less than or equal to ', condition: 'is less than or equal to' },
        { suffix: ' is greater than ', condition: 'is greater than' },
        { suffix: ' is less than ', condition: 'is less than' },
        { suffix: ' ≠ ', condition: 'does not equal' },
        { suffix: ' >= ', condition: 'is greater than or equal to' },
        { suffix: ' <= ', condition: 'is less than or equal to' },
        { suffix: ' = ', condition: 'equals' },
        { suffix: ' > ', condition: 'is greater than' },
        { suffix: ' < ', condition: 'is less than' }
    ];

    function assignODataValueFromDisplayName(valuePart) {
        if (valuePart == null) {
            return null;
        }
        var trimmed = String(valuePart).trim();
        return trimmed === '{blank}' ? '' : trimmed;
    }

    function stripWrappingQuotes(value) {
        return String(value ?? '')
            .replace(/^"(.*)"$/, '$1')
            .replace(/^'(.*)'$/, '$1');
    }

    function parseODataMultiValueList(value) {
        if (value == null) {
            return null;
        }
        var raw = String(value).trim();
        if (!raw) {
            return null;
        }
        if (raw.startsWith('[') && raw.endsWith(']')) {
            try {
                var parsed = JSON.parse(raw);
                if (Array.isArray(parsed) && parsed.length > 1) {
                    return parsed.map(function (item) {
                        return item == null ? '' : String(item);
                    });
                }
            } catch (e) {
                // fall through to comma split
            }
            var inner = raw.slice(1, -1);
            if (!inner.trim()) {
                return null;
            }
            var bracketItems = inner.split(',').map(function (item) {
                return stripWrappingQuotes(item.trim());
            }).filter(function (item) {
                return item.length > 0;
            });
            return bracketItems.length > 1 ? bracketItems : null;
        }
        var orSeparated = raw.split(/\s+or\s+/i).map(function (item) {
            return stripWrappingQuotes(item.trim());
        }).filter(function (item) {
            return item.length > 0;
        });
        return orSeparated.length > 1 ? orSeparated : null;
    }

    function inferFilterConditionType(filter, values) {
        if (filter.conditionType) {
            return filter.conditionType;
        }
        if (values && values.length && values.every(function (item) {
            var normalized = normalizeBasicNumberFilterValue(item);
            return normalized !== '' && !isNaN(Number(normalized));
        })) {
            return 'basicNumber';
        }
        if (filter.key && /id$/i.test(filter.key)) {
            return 'basicNumber';
        }
        return null;
    }

    /**
     * Saved views often persist name/key/include only. Multi-value filters like "[1, 2]" must
     * become odataValues before compile, matching the path used when adding a filter in the UI.
     */
    function tryEnrichMultiValueODataFilter(filter) {
        if (!filter || !filter.include || !filter.odataCondition) {
            return;
        }
        if (filter.odataValues && filter.odataValues.length) {
            return;
        }
        var multiValueConditions = [
            'equals',
            'does not equal',
            'starts with',
            'ends with',
            'contains',
            'does not start with',
            'does not end with',
            'does not contain'
        ];
        if (multiValueConditions.indexOf(filter.odataCondition) === -1) {
            return;
        }

        var values = parseODataMultiValueList(filter.odataValue);
        if (!values || values.length < 2) {
            return;
        }

        filter.odataValues = values;
        filter.odataValue = null;
        filter.odataValue2 = null;
        filter.conditionType = inferFilterConditionType(filter, values);
    }

    /**
     * Saved views often persist filter.name/key/include only (or client-side .value without OData metadata).
     * Reconstruct odataCondition/value from the display name, e.g. "Last Name = test".
     */
    function enrichViewFilterFromDisplayName(filter, profile) {
        if (!filter || !filter.include || filter.odataCondition || !filter.key || !filter.name) {
            return;
        }

        var name = String(filter.name);
        var betweenIdx = name.indexOf(' is between ');
        if (betweenIdx !== -1) {
            var betweenRest = name.slice(betweenIdx + ' is between '.length);
            var andIdx = betweenRest.lastIndexOf(' and ');
            if (andIdx !== -1) {
                filter.odataCondition = 'is between';
                filter.odataProperty = filter.odataProperty || toODataPropertyName(filter.key, profile);
                filter.odataValue = assignODataValueFromDisplayName(betweenRest.slice(0, andIdx));
                filter.odataValue2 = assignODataValueFromDisplayName(betweenRest.slice(andIdx + ' and '.length));
            }
            return;
        }

        if (name.endsWith(' is true')) {
            filter.odataCondition = 'is true';
            filter.odataProperty = filter.odataProperty || toODataPropertyName(filter.key, profile);
            return;
        }
        if (name.endsWith(' is false')) {
            filter.odataCondition = 'is false';
            filter.odataProperty = filter.odataProperty || toODataPropertyName(filter.key, profile);
            return;
        }

        var i;
        for (i = 0; i < DISPLAY_NAME_CONDITION_PATTERNS.length; i++) {
            var pattern = DISPLAY_NAME_CONDITION_PATTERNS[i];
            var idx = name.indexOf(pattern.suffix);
            if (idx === -1) {
                continue;
            }
            filter.odataCondition = pattern.condition;
            filter.odataProperty = filter.odataProperty || toODataPropertyName(filter.key, profile);
            filter.odataValue = assignODataValueFromDisplayName(name.slice(idx + pattern.suffix.length));
            return;
        }
    }

    function resolveQuickFilterODataValue(filter) {
        if (filter.rawValue !== undefined && filter.rawValue !== null) {
            if (filter.conditionType === 'basicNumber') {
                return String(filter.rawValue).replace(/\$/g, '');
            }
            return filter.rawValue;
        }
        if (filter.isBlank) {
            return '';
        }
        if (filter.name) {
            var eqIdx = filter.name.lastIndexOf(' = ');
            if (eqIdx !== -1) {
                var parsed = filter.name.slice(eqIdx + 3);
                return parsed === '{blank}' ? '' : parsed;
            }
        }
        return null;
    }

    /**
     * Cell-click quick filters are created with a client-side predicate (.value) only.
     * SSRM Refresh Grid compiles sidebar filters to OData — enrich those before compile.
     */
    function tryEnrichClientQuickFilterForOData(filter, profile) {
        if (!filter || !filter.include || filter.odataCondition || !filter.key) {
            return;
        }
        var valueStr = filter.value != null ? String(filter.value) : '';
        if (valueStr.indexOf('function') === -1 && filter.rawValue === undefined) {
            return;
        }

        filter.odataCondition = 'equals';
        filter.odataProperty = filter.odataProperty || toODataPropertyName(filter.key, profile);
        filter.odataValue = resolveQuickFilterODataValue(filter);
    }

    /**
     * Filter by file (OC-41861): an uploaded file becomes an entity session of matching ids on the server and the sidebar
     * sends one clause per file filter — "InEntitySession eq {id}", or "not (...)" to exclude — so the request stays
     * small however many values the file holds. The values are kept on the filter so a saved view can re-create the
     * session after it expires.
     */
    var FILE_FILTER_PROPERTY = 'InEntitySession';
    var FILE_FILTER_REFRESH_BEFORE_EXPIRY_MS = 10 * 60 * 1000;

    function isFileFilter(filter) {
        return !!(filter && filter.fileFilter);
    }

    function fileFilterValueCount(fileFilter) {
        if (!fileFilter) {
            return 0;
        }
        if (fileFilter.values && fileFilter.values.length) {
            return fileFilter.values.length;
        }
        return parseInt(fileFilter.valueCount, 10) || 0;
    }

    function buildFileFilterName(fileFilter) {
        var count = fileFilterValueCount(fileFilter);
        return (fileFilter.columnName || 'File') + ' '
            + (fileFilter.filterType === 'Exclude' ? 'Exclude' : 'Include') + ': '
            + (fileFilter.fileName || 'file') + ' ('
            + count.toLocaleString('en-US') + ' value' + (count === 1 ? '' : 's') + ')';
    }

    /**
     * @param {object} created - POST /Utility/EntitySession/FileFilter/{entity} response plus filterType and fileName.
     */
    function buildFileFilter(created) {
        var fileFilter = {
            entity: created.entity || 'Account',
            field: created.field,
            columnName: created.columnName,
            filterType: created.filterType === 'Exclude' ? 'Exclude' : 'Include',
            fileName: created.fileName,
            values: (created.values || []).slice()
        };
        applyFileFilterSession({ fileFilter: fileFilter }, created);
        return {
            name: buildFileFilterName(fileFilter),
            key: FILE_FILTER_PROPERTY,
            include: true,
            odataSync: true,
            odataProperty: FILE_FILTER_PROPERTY,
            fileFilter: fileFilter
        };
    }

    function applyFileFilterSession(filter, session) {
        if (!isFileFilter(filter) || !session) {
            return;
        }
        filter.fileFilter.entitySessionId = session.entitySessionId;
        filter.fileFilter.expiresAt = session.expiresAt;
        filter.fileFilter.missingValueCount = session.missingValueCount;
        filter.fileFilter.matchedRecordCount = session.matchedRecordCount;
    }

    /**
     * True when an enabled file filter has values but no session, or its session expires soon. With
     * <paramref name="force"/> (Refresh Grid) every enabled file filter with values is re-matched against current data.
     */
    function fileFilterNeedsSession(filter, nowMs, force) {
        if (!isFileFilter(filter) || !filter.include) {
            return false;
        }
        var fileFilter = filter.fileFilter;
        if (!fileFilter.values || !fileFilter.values.length) {
            return false;
        }
        if (force || !fileFilter.entitySessionId || !fileFilter.expiresAt) {
            return true;
        }
        var expires = Date.parse(fileFilter.expiresAt);
        if (isNaN(expires)) {
            return true;
        }
        return expires - (nowMs == null ? Date.now() : nowMs) < FILE_FILTER_REFRESH_BEFORE_EXPIRY_MS;
    }

    /** True when an enabled file filter has neither a session nor values to re-create one (it must be imported again). */
    function isFileFilterUnavailable(filter) {
        return isFileFilter(filter) && !!filter.include
            && !filter.fileFilter.entitySessionId
            && !(filter.fileFilter.values && filter.fileFilter.values.length);
    }

    function compileFileFilterClause(filter) {
        if (!filter.include) {
            return null;
        }
        // Never drop an enabled file filter: without a session it still compiles (to id 0), and the server answers 410
        // instead of returning unfiltered rows.
        var sessionId = parseInt(filter.fileFilter.entitySessionId, 10);
        var clause = FILE_FILTER_PROPERTY + ' eq ' + (isNaN(sessionId) ? 0 : sessionId);
        return filter.fileFilter.filterType === 'Exclude' ? 'not (' + clause + ')' : clause;
    }

    /**
     * The sidebar's filterable columns that offer file import: those whose "equals" condition takes a typed value list
     * (text and number columns, including user-defined fields). Returns [{ name, field }].
     */
    function getFileFilterColumns(filterableColumns) {
        return (filterableColumns || []).filter(function (column) {
            return column && column.field && (column.conditions || []).some(function (condition) {
                return condition && condition.name === 'equals' && condition.multiValue && condition.input1;
            });
        }).map(function (column) {
            return { name: column.name, field: column.field };
        });
    }

    function fileFiltersEquivalent(existing, incoming) {
        if (!isFileFilter(existing) || !isFileFilter(incoming)) {
            return false;
        }
        var a = existing.fileFilter;
        var b = incoming.fileFilter;
        return a.field === b.field
            && a.columnName === b.columnName
            && a.filterType === b.filterType
            && a.fileName === b.fileName
            && odataValuesEquivalent(a.values, b.values);
    }

    function compileFilterToODataClause(filter, profile) {
        if (isFileFilter(filter)) {
            return compileFileFilterClause(filter);
        }
        if (!filter || !filter.include) {
            return null;
        }
        tryEnrichClientQuickFilterForOData(filter, profile);
        if (!filter.odataCondition) {
            enrichViewFilterFromDisplayName(filter, profile);
        }
        tryEnrichMultiValueODataFilter(filter);
        var conditionName = filter.odataCondition;
        if (!conditionName) {
            return null;
        }
        var property = filter.odataProperty || toODataPropertyName(filter.key, profile);
        if (!property || IS_ACTIVE_PROPERTY.test(property)) {
            return null;
        }

        var conditionType = filter.conditionType;
        var isNumericType = conditionType === 'basicNumber';

        if (filter.odataValues && filter.odataValues.length) {
            return compileMultiValueClause(property, conditionName, filter.odataValues, conditionType, isNumericType);
        }

        if (conditionName === 'is true') {
            return property + ' eq true';
        }
        if (conditionName === 'is false') {
            return property + ' eq false';
        }
        if (conditionName === 'is between') {
            var lower = formatODataLiteral(filter.odataValue, conditionType, true);
            var upper = formatODataLiteral(filter.odataValue2, conditionType, true);
            if (lower == null || upper == null) {
                return null;
            }
            return '(' + property + ' ge ' + lower + ' and ' + property + ' le ' + upper + ')';
        }

        if (isBlankODataValue(filter.odataValue)) {
            if (conditionType === 'basicDate') {
                if (conditionName === 'equals') {
                    return buildNullCompareClause(property, 'eq');
                }
                if (conditionName === 'does not equal') {
                    return buildNullCompareClause(property, 'ne');
                }
            }
            if (isSelectEnumFilter(conditionType)) {
                if (conditionName === 'equals') {
                    return buildNullCompareClause(property, 'eq');
                }
                if (conditionName === 'does not equal') {
                    return buildNullCompareClause(property, 'ne');
                }
            }
        }

        var literal = formatODataLiteral(filter.odataValue, conditionType, isNumericType);
        if (CONDITION_TO_ODATA_COMPARE[conditionName]) {
            return buildCompareClause(property, CONDITION_TO_ODATA_COMPARE[conditionName], literal);
        }
        if (CONDITION_TO_ODATA_FUNC[conditionName]) {
            return buildFuncClause(CONDITION_TO_ODATA_FUNC[conditionName], property, literal, false);
        }
        if (CONDITION_TO_ODATA_NOT_FUNC[conditionName]) {
            return buildFuncClause(CONDITION_TO_ODATA_NOT_FUNC[conditionName], property, literal, true);
        }
        return null;
    }

    function joinCompiledODataClauses(clauses, filterType) {
        if (!clauses || !clauses.length) {
            return '';
        }
        var joiner = (filterType === 'Any') ? ' or ' : ' and ';
        var joined = clauses.join(joiner);
        return clauses.length > 1 && filterType === 'Any' ? '(' + joined + ')' : joined;
    }

    function compileFiltersToOData(filters, filterType, profile) {
        var clauses = [];
        (filters || []).forEach(function (filter) {
            var clause = compileFilterToODataClause(filter, profile);
            if (clause) {
                filter.odataSync = true;
                clauses.push(clause);
            } else if (filter && filter.include) {
                filter.odataSync = false;
            }
        });
        return {
            odataFilter: normalizeODataV3Filter(joinCompiledODataClauses(clauses, filterType))
        };
    }

    function resolveCompiledODataFilter(compiled) {
        if (!compiled) {
            return '';
        }
        if (typeof compiled === 'string') {
            return compiled;
        }
        return compiled.odataFilter || '';
    }

    function upsertGridParam(gridParams, key, value) {
        var raw = String(gridParams || '').replace(/^&/, '');
        var parts = raw.split('&').filter(function (part) {
            if (!part) {
                return false;
            }
            var eq = part.indexOf('=');
            var name = eq === -1 ? part : part.slice(0, eq);
            return name !== key && name !== 'odataFilter';
        });
        if (value) {
            parts.push(key + '=' + value);
        }
        return parts.length ? '&' + parts.join('&') : '';
    }

    var SIDEBAR_FILTER_INFO = 'Filters';
    var WORKFLOW_ASSISTANT_FILTER_INFO = 'Workflow Assistant filter';
    var DEFAULT_FILTERED_LIST_ORDER_BY = 'EditedDate desc';

    var PORTFOLIO_ODATA_NON_SORTABLE_PROPERTIES = {
        isdatasharingentity: true,
        missinginformation: true,
        bondpercent: true
    };

    function normalizeODataSortPropertyKey(property) {
        return String(property || '').toLowerCase();
    }

    function isUdfODataSortField(field) {
        var lower = String(field || '').toLowerCase();
        return lower.indexOf('udf') === 0;
    }

    function isODataSortablePropertyName(property, profile) {
        var key = normalizeODataSortPropertyKey(property);
        if (!key) {
            return false;
        }
        if (isUdfODataSortField(key)) {
            return false;
        }
        if (PORTFOLIO_ODATA_NON_SORTABLE_PROPERTIES[key]) {
            return false;
        }
        if (profile && profile.odataNonSortableProperties && profile.odataNonSortableProperties[key]) {
            return false;
        }
        return true;
    }

    function isODataSortableField(field, profile) {
        if (isUdfODataSortField(field)) {
            return false;
        }
        var fieldKey = normalizeODataSortPropertyKey(field);
        if (profile && profile.odataNonSortableProperties && profile.odataNonSortableProperties[fieldKey]) {
            return false;
        }
        return isODataSortablePropertyName(toODataPropertyName(field, profile), profile);
    }

    function sanitizeODataOrderBy(orderBy, profile) {
        if (!orderBy) {
            return null;
        }

        var kept = orderBy.split(',').map(function (clause) {
            return clause.trim();
        }).filter(function (clause) {
            if (!clause) {
                return false;
            }
            var property = clause.split(/\s+/)[0];
            return isODataSortablePropertyName(property, profile);
        });

        return kept.length ? kept.join(',') : null;
    }

    function viewSortsRequireClientSideOnly(scope, profile) {
        var sorts = scope && scope.current && scope.current.view && scope.current.view.sorts;
        if (!sorts || !sorts.length) {
            return false;
        }
        return !sorts.some(function (sort) {
            return isODataSortableField(sort.field || sort.columnId || sort.id, profile);
        });
    }
    var ODATA_LIST_PAGE_SIZE = 50000;

    function resolveODataListPageSize(scope) {
        var profileKey = scope && scope.current && scope.current.odataListProfileKey;
        var profile = profileKey && global.portfolioListODataSidebarSync
            ? global.portfolioListODataSidebarSync.resolveProfile(profileKey)
            : null;
        if (profile && profile.odataPageSize > 0) {
            return profile.odataPageSize;
        }
        return ODATA_LIST_PAGE_SIZE;
    }

    function isWorkflowAssistantRouteFilter(search) {
        if (!search) {
            return false;
        }
        var info = search.info;
        if (!info) {
            return false;
        }
        return String(info).indexOf('Workflow Assistant') !== -1;
    }

    function stripODataQueryFromLocationSearch(location, search) {
        if (!location) {
            return;
        }
        search = search || location.search();
        var cleaned = angular.extend({}, search);
        var changed = false;

        if (cleaned.$filter || cleaned.odataFilter) {
            delete cleaned.$filter;
            delete cleaned.odataFilter;
            changed = true;
        }
        if (cleaned.$orderby || cleaned.odataOrderBy) {
            delete cleaned.$orderby;
            delete cleaned.odataOrderBy;
            changed = true;
        }
        if (cleaned.info === SIDEBAR_FILTER_INFO || isWorkflowAssistantRouteFilter(cleaned)) {
            delete cleaned.info;
            changed = true;
        }

        if (changed) {
            location.search(cleaned);
        }
    }

    function reloadPortfolioListGrid(scope, profile) {
        if (!profile || !profile.reloadEvent || !scope) {
            return;
        }
        var event = profile.reloadEvent;
        var payload = { action: 'refresh-grid' };
        var broadcast = function () {
            scope.$root.$broadcast(event, payload);
        };
        if (typeof scope.$evalAsync === 'function') {
            scope.$evalAsync(broadcast);
        } else {
            broadcast();
        }
    }

    function markPortfolioListFiltersReady(scope) {
        if (scope && scope.current) {
            scope.current.portfolioListFiltersReady = true;
        }
    }

    function paramsIncludeOrderBy(parts, search) {
        if (parts && parts.some(function (p) { return p.indexOf('$orderby=') === 0; })) {
            return true;
        }
        if (!search) {
            return false;
        }
        return !!(search.$orderby || search.odataOrderBy);
    }

    function applyDefaultOrderByWhenFiltered(search, parts, useDefaultOrderBy) {
        if (!useDefaultOrderBy) {
            return;
        }
        var odataFilter = getODataFilterFromSearch(search);
        if (!odataFilter || paramsIncludeOrderBy(parts, search)) {
            return;
        }
        parts.push('$orderby=' + DEFAULT_FILTERED_LIST_ORDER_BY);
        if (search && !search.odataOrderBy && !search.$orderby) {
            search.odataOrderBy = DEFAULT_FILTERED_LIST_ORDER_BY;
        }
    }

    function compileSortsToODataOrderBy(sorts, profile) {
        if (!sorts || !sorts.length) {
            return null;
        }

        var clauses = [];
        sorts.forEach(function (sort) {
            var field = sort.field || sort.columnId || sort.id;
            if (!isODataSortableField(field, profile)) {
                return;
            }
            var property = toODataPropertyName(field, profile);
            if (!property) {
                return;
            }
            clauses.push(property + (sort.sortAsc === false ? ' desc' : ' asc'));
        });

        return clauses.length ? clauses.join(',') : null;
    }

    function resolveODataOrderBy(scope, profile, search, options) {
        options = options || {};
        var orderBy = null;

        if (search) {
            orderBy = search.$orderby || search.odataOrderBy || null;
            orderBy = sanitizeODataOrderBy(orderBy, profile);
        }

        if (!orderBy && scope && scope.current && scope.current.view) {
            orderBy = compileSortsToODataOrderBy(scope.current.view.sorts, profile);
        }

        if (!orderBy && options.defaultOrderByWhenFiltered) {
            var odataFilter = search ? getODataFilterFromSearch(search) : null;
            if (!odataFilter && scope && scope.current && scope.current.odataFilter) {
                odataFilter = scope.current.odataFilter;
            }
            if (odataFilter) {
                orderBy = DEFAULT_FILTERED_LIST_ORDER_BY;
            }
        }

        return orderBy || null;
    }

    function applyODataOrderByToScope(scope, orderBy) {
        if (!scope || !scope.current) {
            return;
        }
        scope.current.odataOrderBy = orderBy || null;
        scope.current.gridParams = upsertGridParam(scope.current.gridParams || '', '$orderby', orderBy || '');
    }

    function applyODataSortFromView(scope, profile, search, options) {
        if (!isRecordColumnLimitFeatureEnabled(scope)) {
            return null;
        }
        clearPortfolioClientSortOData(scope);
        return null;
    }

    /**
     * Portfolio SSRM grids sort client-side only; strip view/route $orderby before Grid requests.
     */
    function ensurePortfolioListQueryParams(scope, profile) {
        if (!scope || !scope.current || !profile || !isRecordColumnLimitFeatureEnabled(scope)) {
            return;
        }

        if (scope.current.entityRouteGetById) {
            return;
        }

        clearPortfolioClientSortOData(scope);
    }

    function shouldApplyPortfolioServerSort(scope, profile) {
        if (!scope || !scope.current || !profile) {
            return false;
        }
        if (isRecordColumnLimitFeatureEnabled(scope)) {
            return false;
        }
        if (scope.current.entityRouteGetById) {
            return false;
        }
        if (viewSortsRequireClientSideOnly(scope, profile)) {
            return false;
        }
        if (hasFullPortfolioGridDataset(scope)) {
            return false;
        }
        if (scope.current.odataFilter || scope.current.odataOrderBy) {
            return true;
        }
        if ([true, 'true'].any(scope.current.useOData) || [true, 'true'].any(scope.current.useServerSideRowModel)) {
            return true;
        }
        return isGridRecordLimitEnabled(scope);
    }

    function clearOrderByFromSearch(search) {
        if (!search) {
            return;
        }
        delete search.odataOrderBy;
        delete search.$orderby;
    }

    function isSplitRecordColumnLimitFeatureEnabled(scope) {
        return !!(scope && scope.current && scope.current.slickGridRecordColumnLimitEnabled);
    }

    function isPortfolioGridLimitsSettingEnabled(scope) {
        return !!(scope && scope.current && scope.current.portfolioGridLimitsSettingEnabled);
    }

    function syncPortfolioSsrmEnabledFlag(scope) {
        if (!scope || !scope.current) {
            return;
        }
        scope.current.portfolioSsrmEnabled = isSplitRecordColumnLimitFeatureEnabled(scope)
            && isPortfolioGridLimitsSettingEnabled(scope)
            && (parseInt(scope.current.gridRecordLimit, 10) || 0) > 0;
    }

    function parseAppOptionBoolean(response) {
        if (!response || response.data == null || response.data.value == null || response.data.value === '') {
            return false;
        }
        var value = response.data.value;
        if (typeof value === 'boolean') {
            return value;
        }
        return String(value).toLowerCase() === 'true';
    }

    function resetPortfolioSsrmScopeState(scope) {
        if (!scope || !scope.current) {
            return;
        }
        syncPortfolioSsrmEnabledFlag(scope);
        delete scope.current.gridRequestTop;
        scope.current.loadUntilRecordLimit = false;
        // GridRecordLimit is 0: leave paging unset so the grid streams 50k pages like the feature flag off.
        delete scope.current.loadAllPages;
    }

    function applyLegacyPortfolioGridMode(scope, profile, location) {
        resetPortfolioSsrmScopeState(scope);
        if (profile && location) {
            clearODataListServerMode(scope, profile, location);
        }
    }

    function isRecordColumnLimitFeatureEnabled(scope) {
        if (!scope || !scope.current) {
            return false;
        }
        if (scope.current.portfolioSsrmEnabled === undefined) {
            syncPortfolioSsrmEnabledFlag(scope);
        }
        return !!scope.current.portfolioSsrmEnabled;
    }

    function isGridRecordLimitEnabled(scope) {
        return isRecordColumnLimitFeatureEnabled(scope);
    }

    /**
     * True when the grid already holds every row in the current result set and the
     * total is within the entity record-limit cap (no server paging/sort needed).
     */
    function hasFullPortfolioGridDataset(scope) {
        if (!scope || !scope.current || !isGridRecordLimitEnabled(scope)) {
            return false;
        }
        if (scope.current.gridRecordLimitReached) {
            return false;
        }

        var loaded = parseInt(scope.current.gridLoadedCount, 10) || 0;
        if (loaded <= 0) {
            return false;
        }

        var recordLimit = parseInt(scope.current.gridRecordLimit, 10) || 0;
        var total = scope.current.gridTotalCount;

        if (total != null) {
            return loaded >= total && (recordLimit <= 0 || total <= recordLimit);
        }

        if (!scope.current.gridRowCountsReady) {
            return false;
        }

        return recordLimit > 0 && loaded < recordLimit;
    }

    function clearPortfolioClientSortOData(scope) {
        if (!scope || !scope.current || !isRecordColumnLimitFeatureEnabled(scope)) {
            return;
        }
        scope.current.odataOrderBy = null;
        scope.current.gridParams = upsertGridParam(scope.current.gridParams || '', '$orderby', '');
    }

    function isDeferredODataSidebarSearchEnabled(scope) {
        if (scope && scope.current && scope.current.entityRouteGetById
            && isRecordColumnLimitFeatureEnabled(scope)) {
            return false;
        }
        return isRecordColumnLimitFeatureEnabled(scope)
            && !!(scope.current && scope.current.odataListProfileKey && isGridRecordLimitEnabled(scope));
    }

    function isServerSideRowModelActive(scope, location) {
        if (!scope || !scope.current) {
            return false;
        }
        if (!isGridRecordLimitEnabled(scope)) {
            return false;
        }
        if ([true, 'true'].any(scope.current.useServerSideRowModel)) {
            return true;
        }
        if (!scope.current.odataListProfileKey) {
            return false;
        }
        // Portfolio OData lists: useOData / odataFilter / hash $filter all mean SSRM — no client sidebar filtering.
        if ([true, 'true'].any(scope.current.useOData)) {
            return true;
        }
        if (scope.current.odataFilter) {
            return true;
        }
        if (location) {
            var search = location.search();
            if (search.$filter || search.odataFilter) {
                return true;
            }
        }
        return false;
    }

    function applyODataListServerMode(scope, search, profile, activeState, odataFilter) {
        var hasEntityRouteScope = hasPortfolioListRouteScope(search);
        var activeResult = applyIsActiveFromSearch(search, odataFilter, scope, activeState);
        var searchForGrid = cloneSearchForGrid(search, activeResult.filter, odataFilter);
        var filter = getODataFilterFromSearch(searchForGrid) || odataFilter;

        scope.current.detailInfo = search.info ? '(' + search.info + ')' : (filter ? '(Filtered)' : '');
        scope.current.odataSidebarSyncFilter = activeResult.filter || odataFilter;
        applyScopeSearchBindings(scope, search, profile);

        var portfolioSync = global.portfolioListODataSidebarSync;
        if (hasEntityRouteScope && portfolioSync && portfolioSync.normalizeEntityRouteScopeForODataList) {
            portfolioSync.normalizeEntityRouteScopeForODataList(
                scope,
                profile && profile.id,
                search.entity,
                search.entityId
            );
        }

        if (scope.current.entityRouteGetById && isRecordColumnLimitFeatureEnabled(scope)) {
            scope.current.useOData = false;
            scope.current.useServerSideRowModel = false;
            return;
        }

        var hasFilter = !!filter;
        if (!hasFilter && !isGridRecordLimitEnabled(scope)) {
            scope.current.useOData = false;
            scope.current.useServerSideRowModel = false;
            scope.current.odataFilter = scope.current.routeScopeODataFilter || null;
            if (!hasEntityRouteScope) {
                if (profile && profile.gridListUrl) {
                    scope.current.url = profile.gridListUrl;
                }
                scope.current.gridParams = '';
            }
            applyODataSortFromView(scope, profile, searchForGrid, {
                defaultOrderByWhenFiltered: false
            });
            return;
        }

        scope.current.useOData = true;
        scope.current.useServerSideRowModel = true;
        scope.current.odataFilter = mergeWithRouteScopeODataFilter(scope, filter || null);
        scope.current.gridTotalCount = null;
        scope.current.gridLoadedCount = 0;
        resetPortfolioGridRowCountBanner(scope);
        var builtGridParams = buildODataGridParams(searchForGrid, profile, {
            defaultOrderByWhenFiltered: false
        });
        if (hasEntityRouteScope) {
            // List controllers (finishInit) already mapped entity/entityId → clientId, registrationId, etc.
            scope.current.gridParams = (scope.current.gridParams || '') + builtGridParams;
        } else {
            scope.current.url = profile.gridListUrl;
            scope.current.gridParams = builtGridParams;
        }
        applyODataSortFromView(scope, profile, searchForGrid, {});
    }

    function clearODataListServerMode(scope, profile, location) {
        scope.current.useOData = false;
        scope.current.useServerSideRowModel = false;
        scope.current.odataFilter = scope.current.routeScopeODataFilter || null;
        scope.current.odataOrderBy = null;
        scope.current.gridTotalCount = null;
        scope.current.gridLoadedCount = 0;
        var search = location && location.search ? location.search() : null;
        if (!hasPortfolioListRouteScope(search)) {
            if (profile && profile.gridListUrl) {
                scope.current.url = profile.gridListUrl;
            }
            scope.current.gridParams = '';
        }
        delete scope.current.odataSidebarSyncFilter;
        delete scope.current.odataFilterFromWorkflowAssistant;
        resetPortfolioGridRowCountBanner(scope);
    }

    function prepareViewFiltersForOData(filters, profile) {
        (filters || []).forEach(function (filter) {
            if (!filter || !filter.include || isFileFilter(filter)) {
                return;
            }
            tryEnrichClientQuickFilterForOData(filter, profile);
            if (!filter.odataCondition) {
                enrichViewFilterFromDisplayName(filter, profile);
            }
            tryEnrichMultiValueODataFilter(filter);
        });
    }

    function rebuildClientViewFilterValue(filter, columnDefs, profile) {
        if (!filter || !filter.include || filter.odataSync || isFileFilter(filter)) {
            return;
        }
        if (filter.value && String(filter.value).indexOf('function') !== -1) {
            return;
        }

        tryEnrichClientQuickFilterForOData(filter, profile);
        if (!filter.odataCondition) {
            enrichViewFilterFromDisplayName(filter, profile);
        }
        tryEnrichMultiValueODataFilter(filter);
        if (!filter.key || !filter.odataCondition) {
            return;
        }

        var column = findColumnForProperty(columnDefs, filter.key, profile && profile.propertyAliases, profile);
        if (!column) {
            return;
        }
        var condition = findCondition(column, filter.odataCondition);
        if (!condition || !condition.value) {
            return;
        }

        var displayValue = filter.odataValue != null ? filter.odataValue : '';
        var built = buildViewFilter(column, condition, displayValue);
        var value = built.value;
        if (filter.odataCondition === 'is between' && filter.odataValue2 != null && condition.input2) {
            var substituteValue2 = column.conditionType === 'basicNumber' || condition.isNumericType
                ? normalizeBasicNumberFilterValue(filter.odataValue2)
                : escapeForSingleQuotedJs(filter.odataValue2);
            value = value.replace('{value2}', substituteValue2);
        }
        filter.value = value;
    }

    function prepareViewFiltersForClientSide(filters, columnDefs, profile) {
        (filters || []).forEach(function (filter) {
            rebuildClientViewFilterValue(filter, columnDefs, profile);
        });
    }

    /**
     * Compiles sidebar filters to in-memory OData state and reloads grid data.
     * $filter / $orderby are not written to the browser URL (Workflow Assistant deep links
     * are handled separately via applyODataRouteFilters).
     * @param {object} [options]
     * @param {boolean} [options.skipGridReload] when true, only updates scope (grid init will load).
     */
    function syncCommittedActiveState(scope) {
        if (scope && scope.current && scope.current.activeState) {
            scope.current.committedActiveState = scope.current.activeState;
        }
    }

    function onPortfolioListActiveStateChanged(scope, settings, timeout, refreshGridFn, http) {
        if (!scope || !scope.current) {
            return;
        }
        if (scope.current.entityRouteGetById && isRecordColumnLimitFeatureEnabled(scope)) {
            settings.setSetting('activeState', scope.current.activeState);
            return;
        }
        settings.setSetting('activeState', scope.current.activeState);
        timeout(function () {
            if (isDeferredODataSidebarSearchEnabled(scope)) {
                refreshPortfolioSidebarFilterCount(scope, http);
                return;
            }
            if (typeof refreshGridFn === 'function') {
                refreshGridFn();
            }
        });
    }

    function applySidebarFiltersToGrid(scope, location, profile, options) {
        options = options || {};
        if (!scope || !scope.current || !profile || !profile.gridListUrl || !location) {
            return false;
        }
        if (!isRecordColumnLimitFeatureEnabled(scope)) {
            return false;
        }
        if (isRecordColumnLimitFeatureEnabled(scope)) {
            syncCommittedActiveState(scope);
        }
        scope.current.portfolioListFiltersReady = false;
        resetPortfolioGridRowCountBanner(scope);
        var view = scope.current.view || {};
        prepareViewFiltersForOData(view.filters, profile);
        var compiled = compileFiltersToOData(view.filters, view.filterType, profile);
        var search = angular.extend({}, location.search());
        syncActiveStateQueryToSearch(search, scope, scope.current.activeStates);

        delete search.$filter;
        delete search.odataFilter;
        clearOrderByFromSearch(search);
        if (search.info === SIDEBAR_FILTER_INFO || isWorkflowAssistantRouteFilter(search)) {
            delete search.info;
        }

        delete scope.current.odataFilterFromWorkflowAssistant;

        if (compiled.odataFilter) {
            var filter = normalizeODataV3Filter(compiled.odataFilter);
            search.info = SIDEBAR_FILTER_INFO;
            if (isRecordColumnLimitFeatureEnabled(scope)) {
                applyDefaultOrderByWhenFiltered(search, [], true);
            }
            applyODataListServerMode(scope, search, profile, scope.current.activeStates, filter);
        } else {
            if (search.info === SIDEBAR_FILTER_INFO) {
                delete search.info;
            }
            clearODataListServerMode(scope, profile, location);
        }

        if (!options.skipGridReload) {
            applyCommittedFilterRowCountSnapshot(scope, options);
            reloadPortfolioListGrid(scope, profile);
        }
        markPortfolioListFiltersReady(scope);
        return true;
    }

    function parseEntityOptionInt(response) {
        if (!response || response.data == null || response.data.value == null || response.data.value === '') {
            return 0;
        }
        var n = parseInt(response.data.value, 10);
        return isNaN(n) || n < 0 ? 0 : n;
    }

    function applyGridLimitEntityOptions(scope, http, location, activeState) {
        if (!isSplitRecordColumnLimitFeatureEnabled(scope)) {
            if (scope && scope.current) {
                scope.current.portfolioGridLimitsSettingEnabled = false;
            }
            syncPortfolioSsrmEnabledFlag(scope);
            if (scope && scope.current) {
                scope.current.gridLimitsReady = true;
            }
            return;
        }

        if (!scope || !scope.current || !http) {
            return;
        }

        scope.current.portfolioGridLimitsSettingEnabled = false;

        function applyDigest() {
            if (typeof scope.$evalAsync === 'function') {
                scope.$evalAsync();
            }
        }

        function reconcileODataListMode() {
            var profileKey = scope.current.odataListProfileKey;
            var profile = profileKey && global.portfolioListODataSidebarSync
                ? global.portfolioListODataSidebarSync.resolveProfile(profileKey)
                : null;

            if (!profile || !location) {
                return;
            }

            var search = location.search();
            var portfolioSync = global.portfolioListODataSidebarSync;
            if (portfolioSync && portfolioSync.normalizeEntityRouteScopeForODataList
                && hasPortfolioListRouteScope(search)) {
                portfolioSync.normalizeEntityRouteScopeForODataList(
                    scope,
                    profileKey,
                    search.entity,
                    search.entityId
                );
            }

            if (scope.current.portfolioSsrmEnabled) {
                applyODataRouteFilters(scope, location, profile, activeState);
                return;
            }

            applyLegacyPortfolioGridMode(scope, profile, location);
        }

        var recordLimitReady = false;
        var gridLimitsSettingReady = false;

        function applyRecordLimitSideEffects() {
            var recordLimit = parseInt(scope.current.gridRecordLimit, 10) || 0;
            if (recordLimit > 0 && isPortfolioGridLimitsSettingEnabled(scope)) {
                var requestTop = resolveRecordLimitGridTop(scope);
                scope.current.gridRequestTop = requestTop;
                scope.current.loadAllPages = false;
                scope.current.loadUntilRecordLimit = true;
            } else {
                resetPortfolioSsrmScopeState(scope);
            }
        }

        function tryFinishGridLimitsInit() {
            if (!recordLimitReady || !gridLimitsSettingReady) {
                return;
            }
            applyRecordLimitSideEffects();
            syncPortfolioSsrmEnabledFlag(scope);
            reconcileODataListMode();
            scope.current.gridLimitsReady = true;
            applyDigest();
        }

        // ViewsColumnsLimit is save-only and must not delay grid load / X-OAS-Select.
        http.get('/Settings/Database/EntityOptions/Code/ViewsColumnsLimit', { cache: true, ignoreExceptions: true })
            .then(function (response) {
                scope.current.viewsColumnsLimit = parseEntityOptionInt(response);
                applyDigest();
            }, function () {
                scope.current.viewsColumnsLimit = 0;
                applyDigest();
            });

        // User-level App Option resolves User → Database → Default (false).
        http.get('/Settings/Apps/portfolioLists/Options/gridLimits', { cache: true, ignoreExceptions: true })
            .then(function (response) {
                scope.current.portfolioGridLimitsSettingEnabled = parseAppOptionBoolean(response);
                gridLimitsSettingReady = true;
                tryFinishGridLimitsInit();
            }, function () {
                scope.current.portfolioGridLimitsSettingEnabled = false;
                gridLimitsSettingReady = true;
                tryFinishGridLimitsInit();
            });

        http.get('/Settings/Database/EntityOptions/Code/GridRecordLimit', { cache: true, ignoreExceptions: true })
            .then(function (response) {
                scope.current.gridRecordLimit = parseEntityOptionInt(response);
                recordLimitReady = true;
                tryFinishGridLimitsInit();
            }, function () {
                scope.current.gridRecordLimit = 0;
                recordLimitReady = true;
                tryFinishGridLimitsInit();
            });
    }

    /**
     * Applies OData route query to list $scope (grid URL, gridParams, sidebar filters).
     * Profile must include gridListUrl, routeOnlyKeys, templateParamKeys.
     * @returns {boolean} true when $filter / odataFilter was present and applied
     */
    function applyODataRouteFilters(scope, location, profile, activeState) {
        if (!profile || !profile.gridListUrl || !location) {
            return false;
        }

        var search = location.search();
        var odataFilter = getODataFilterFromSearch(search);
        if (!odataFilter) {
            return false;
        }

        if (isRecordColumnLimitFeatureEnabled(scope)) {
            if (!isWorkflowAssistantRouteFilter(search)) {
                stripODataQueryFromLocationSearch(location, search);
                return false;
            }

            applyODataListServerMode(scope, search, profile, activeState, odataFilter);
            scope.current.odataFilterFromWorkflowAssistant = true;
            stripODataQueryFromLocationSearch(location, search);
            return true;
        }

        if (!isSplitRecordColumnLimitFeatureEnabled(scope)) {
            applyODataListServerMode(scope, search, profile, activeState, odataFilter);
            scope.current.odataFilterFromWorkflowAssistant = true;
            stripODataQueryFromLocationSearch(location, search);
            return true;
        }

        return false;
    }

    function applyPendingODataSidebarSync(scope, profile) {
        if (!isRecordColumnLimitFeatureEnabled(scope)) {
            return false;
        }
        if (!scope || !scope.current || !profile) {
            return false;
        }
        if (!scope.current.odataFilterFromWorkflowAssistant) {
            return false;
        }
        var filter = scope.current.odataSidebarSyncFilter;
        if (!filter) {
            return false;
        }
        syncSidebarToScope(scope, filter, profile);
        return true;
    }

    global.slickGridODataSidebarSync = {
        ODATA_QUERY_KEY_REMAP: ODATA_QUERY_KEY_REMAP,
        DEFAULT_FILTERED_LIST_ORDER_BY: DEFAULT_FILTERED_LIST_ORDER_BY,
        ODATA_LIST_PAGE_SIZE: ODATA_LIST_PAGE_SIZE,
        resolveRecordLimitGridTop: resolveRecordLimitGridTop,
        resolvePortfolioGridRequestTop: resolvePortfolioGridRequestTop,
        buildODataListQueryParams: buildODataListQueryParams,
        compileSidebarFiltersForCount: compileSidebarFiltersForCount,
        fetchODataListCount: fetchODataListCount,
        fetchSidebarFilterRowCount: fetchSidebarFilterRowCount,
        refreshPortfolioSidebarFilterCount: refreshPortfolioSidebarFilterCount,
        resolvePortfolioGridTotalFromSidebarFilterCount: resolvePortfolioGridTotalFromSidebarFilterCount,
        updatePortfolioGridRowCounts: updatePortfolioGridRowCounts,
        resetPortfolioGridRowCountBanner: resetPortfolioGridRowCountBanner,
        normalizeODataV3Filter: normalizeODataV3Filter,
        getODataFilterFromSearch: getODataFilterFromSearch,
        buildODataGridParams: buildODataGridParams,
        applyODataRouteFilters: applyODataRouteFilters,
        splitODataAnd: splitODataAnd,
        splitODataOr: splitODataOr,
        splitODataOperator: splitODataOperator,
        collectODataLeafClauses: collectODataLeafClauses,
        detectODataFilterJoinType: detectODataFilterJoinType,
        parseComparisonClause: parseComparisonClause,
        parseFunctionClause: parseFunctionClause,
        parseSubstringofClause: parseSubstringofClause,
        parseNotSubstringofClause: parseNotSubstringofClause,
        parseODataClause: parseODataClause,
        parseIsActiveFromODataFilter: parseIsActiveFromODataFilter,
        removeIsActiveClauses: removeIsActiveClauses,
        buildSidebarFiltersFromOData: buildSidebarFiltersFromOData,
        buildIsActiveSidebarFilter: buildIsActiveSidebarFilter,
        findColumnForProperty: findColumnForProperty,
        resolvePropertyDisplayLabel: resolvePropertyDisplayLabel,
        getColumnHeaderLabel: getColumnHeaderLabel,
        applyIsActiveFromSearch: applyIsActiveFromSearch,
        syncActiveStateQueryToSearch: syncActiveStateQueryToSearch,
        resolveIsActiveBoolFromSelection: resolveIsActiveBoolFromSelection,
        syncSidebarToScope: syncSidebarToScope,
        resolveIsActiveForSidebarSync: resolveIsActiveForSidebarSync,
        toODataPropertyName: toODataPropertyName,
        compileFilterToODataClause: compileFilterToODataClause,
        resolveCompiledODataFilter: resolveCompiledODataFilter,
        compileFiltersToOData: compileFiltersToOData,
        fileFilterProperty: FILE_FILTER_PROPERTY,
        isFileFilter: isFileFilter,
        buildFileFilter: buildFileFilter,
        buildFileFilterName: buildFileFilterName,
        applyFileFilterSession: applyFileFilterSession,
        fileFilterNeedsSession: fileFilterNeedsSession,
        isFileFilterUnavailable: isFileFilterUnavailable,
        getFileFilterColumns: getFileFilterColumns,
        compileSortsToODataOrderBy: compileSortsToODataOrderBy,
        resolveODataOrderBy: resolveODataOrderBy,
        applyODataOrderByToScope: applyODataOrderByToScope,
        applyODataSortFromView: applyODataSortFromView,
        ensurePortfolioListQueryParams: ensurePortfolioListQueryParams,
        shouldApplyPortfolioServerSort: shouldApplyPortfolioServerSort,
        hasFullPortfolioGridDataset: hasFullPortfolioGridDataset,
        clearPortfolioClientSortOData: clearPortfolioClientSortOData,
        tryEnrichClientQuickFilterForOData: tryEnrichClientQuickFilterForOData,
        prepareViewFiltersForClientSide: prepareViewFiltersForClientSide,
        upsertGridParam: upsertGridParam,
        applySidebarFiltersToGrid: applySidebarFiltersToGrid,
        isWorkflowAssistantRouteFilter: isWorkflowAssistantRouteFilter,
        stripODataQueryFromLocationSearch: stripODataQueryFromLocationSearch,
        reloadPortfolioListGrid: reloadPortfolioListGrid,
        markPortfolioListFiltersReady: markPortfolioListFiltersReady,
        parseGridParamParts: parseGridParamParts,
        SIDEBAR_FILTER_INFO: SIDEBAR_FILTER_INFO,
        applyPendingODataSidebarSync: applyPendingODataSidebarSync,
        sidebarFiltersEquivalent: sidebarFiltersEquivalent,
        isServerSideRowModelActive: isServerSideRowModelActive,
        isRecordColumnLimitFeatureEnabled: isRecordColumnLimitFeatureEnabled,
        isSplitRecordColumnLimitFeatureEnabled: isSplitRecordColumnLimitFeatureEnabled,
        isGridRecordLimitEnabled: isGridRecordLimitEnabled,
        isDeferredODataSidebarSearchEnabled: isDeferredODataSidebarSearchEnabled,
        applyODataListServerMode: applyODataListServerMode,
        clearODataListServerMode: clearODataListServerMode,
        applyGridLimitEntityOptions: applyGridLimitEntityOptions,
        parseEntityOptionInt: parseEntityOptionInt,
        syncCommittedActiveState: syncCommittedActiveState,
        onPortfolioListActiveStateChanged: onPortfolioListActiveStateChanged
    };
}(window));

'use strict';

/**
 * Builds /Utility/GridExport requests from a portfolio SlickGrid view (columns, filters, scope).
 */
(function (global) {
    var CONDITION_TYPE_TO_DATA_TYPE = {
        basicNumber: 'number',
        basicDate: 'date',
        basicBoolean: 'boolean',
        basicText: 'string'
    };

    function GridExportTranslationError(message) {
        this.message = message;
        this.name = 'GridExportTranslationError';
        this.fallbackToLoadedRows = true;
    }

    function resolveExportFilter(scope, location, profile, sync) {
        if (location && sync.getODataFilterFromSearch) {
            var fromRoute = sync.getODataFilterFromSearch(location.search());
            if (fromRoute) {
                return fromRoute;
            }
        }

        var view = scope.current.view || {};
        var compiled = sync.compileFiltersToOData(view.filters, view.filterType, profile);
        var odataFilter = sync.resolveCompiledODataFilter(compiled);
        if (odataFilter) {
            return odataFilter;
        }

        return null;
    }

    function buildOrderByFromSorts(sorts, profile, sync) {
        if (!sorts || !sorts.length) {
            return null;
        }

        return sorts.map(function (sort) {
            var field = sort.field || sort.columnId || sort.id;
            var property = sync.toODataPropertyName(field, profile);
            return property + (sort.sortAsc === false ? ' desc' : ' asc');
        }).join(',');
    }

    function parseGridParams(gridParams, out) {
        String(gridParams || '').replace(/^&/, '').split('&').forEach(function (part) {
            if (!part) {
                return;
            }
            var eq = part.indexOf('=');
            if (eq === -1) {
                return;
            }
            var key = part.slice(0, eq);
            var value = decodeURIComponent(part.slice(eq + 1));
            if (value === '' || value === 'undefined' || value === 'null') {
                return;
            }
            if (out[key] !== undefined) {
                return;
            }
            if (/^-?\d+$/.test(value)) {
                out[key] = parseInt(value, 10);
            } else if (value.indexOf(',') !== -1 && /^[\d,]+$/.test(value)) {
                out[key] = value.split(',').map(function (v) { return parseInt(v, 10); });
            } else if (value === 'true' || value === 'false') {
                out[key] = value === 'true';
            } else {
                out[key] = value;
            }
        });
    }

    /**
     * Export scopes that mirror [FromUri] int[] must send JSON arrays. Deep-link gridParams
     * often carry a single id (e.g. representativeId=23693); coerce those keys (OC-42354).
     */
    function coerceArrayScopeKeys(out, profile) {
        var keys = profile && profile.arrayScopeKeys;
        if (!keys) {
            return out;
        }

        for (var key in keys) {
            if (!Object.prototype.hasOwnProperty.call(keys, key) || !keys[key]) {
                continue;
            }
            var val = out[key];
            if (val === undefined || val === null || Array.isArray(val)) {
                continue;
            }
            if (typeof val === 'number' && isFinite(val)) {
                out[key] = [val];
            } else if (typeof val === 'string' && /^-?\d+$/.test(val)) {
                out[key] = [parseInt(val, 10)];
            }
        }

        return out;
    }

    function buildExportScope(scope, profile) {
        var out = {};
        var current = scope.current || {};

        if (profile.templateParamKeys.isActive && current.activeState) {
            var activeVal = current.activeState.queryString;
            if (activeVal === 'true') {
                out.isActive = true;
            } else if (activeVal === 'false') {
                out.isActive = false;
            }
        }

        Object.each(profile.templateParamKeys, function (key) {
            if (key === 'isActive' || key === 'refreshCache') {
                return;
            }

            var prop = (profile.scopeSearchBindings && profile.scopeSearchBindings[key]) || key;
            var camelProp = prop.charAt(0).toLowerCase() + prop.slice(1);
            var val = current[camelProp];
            if (val === undefined) {
                val = current[prop];
            }
            if (val === undefined || val === null || val === '') {
                return;
            }
            out[key] = val;
        });

        parseGridParams(current.gridParams, out);
        return coerceArrayScopeKeys(out, profile);
    }

    function buildExportColumns(view, profile, sync) {
        var columns = [];
        var seen = {};

        (view.slickGridColumnDefs || []).forEach(function (column) {
            if (!column.visible || !column.field || seen[column.field]) {
                return;
            }

            var serverField = sync.toODataPropertyName(column.field, profile);
            if (!serverField) {
                throw new GridExportTranslationError(
                    'The "' + (column.name || column.field) + '" column cannot be exported by the server.'
                );
            }

            seen[column.field] = true;
            columns.push({
                field: column.field,
                headerName: column.name || column.field,
                dataType: CONDITION_TYPE_TO_DATA_TYPE[column.conditionType] || 'string'
            });
        });

        if (!columns.length) {
            throw new GridExportTranslationError('Select at least one visible column before exporting.');
        }

        return columns;
    }

    /**
     * @param {object} scope - list controller $scope
     * @param {object} location - Angular $location
     * @param {object} profile - portfolioListODataSidebarSync profile
     */
    function buildSlickGridExportRequest(scope, location, profile) {
        var sync = global.slickGridODataSidebarSync;
        if (!sync || !profile || !profile.gridExportKey) {
            throw new Error('Server side export is not configured for this grid.');
        }

        var view = scope.current.view || {};
        var hasClientOnlyFilters = (view.filters || []).some(function (f) {
            return f.include && f.odataSync === false;
        });
        if (hasClientOnlyFilters) {
            throw new GridExportTranslationError(
                'Some enabled filters only run in the browser and cannot be replayed on the server.'
            );
        }

        var filter = resolveExportFilter(scope, location, profile, sync);
        var request = {
            gridKey: profile.gridExportKey,
            downloadName: profile.gridExportDownloadName || profile.gridExportKey,
            query: {
                filter: filter,
                orderBy: buildOrderByFromSorts(view.sorts, profile, sync),
                scope: buildExportScope(scope, profile)
            },
            columns: buildExportColumns(view, profile, sync),
            options: {
                sheetName: profile.gridExportSheetName || profile.gridExportDownloadName,
                utcOffsetMinutes: new Date().getTimezoneOffset()
            }
        };

        // Do not pass GridRecordLimit as maxRows — that entity option caps what the grid loads in
        // the browser, not what a server side export should return.

        return request;
    }

    global.slickGridExportRequestBuilder = {
        GridExportTranslationError: GridExportTranslationError,
        buildSlickGridExportRequest: buildSlickGridExportRequest,
        buildExportScope: buildExportScope,
        coerceArrayScopeKeys: coerceArrayScopeKeys,
        resolveExportFilter: resolveExportFilter
    };
}(window));

'use strict';

app.directive('scrollToBottom', function ($timeout) {
    return {
        scope: {
            scrollToBottom: "="
        },
        restrict: 'A',
        link: function (scope, element) {
            scope.$watchCollection('scrollToBottom', function (newVal) {
                if (newVal) {
                    $timeout(function () {
                        element[0].scrollTop = element[0].scrollHeight;
                    }, 0);
                }
            });
        }
    };
});

'use strict';

app.directive( 'treeModel', function( $compile ) {
    return {
        restrict: 'A',
        link: function ( scope, element, attrs ) {
            var treeId = attrs.treeId;
            var treeModel = attrs.treeModel;
            var nodeId = attrs.nodeId || 'id';
            var nodeLabel = attrs.nodeLabel || 'label';
            var nodeChildren = attrs.nodeChildren || 'children';
            var currentNode = attrs.currentNode || 'currentNode';

            if (!treeId || !treeModel) {
                throw "treeId and treeModel are required attributes!";
            }

            var template =
                '<ul>' +
                    '<li ng-repeat="node in ' + treeModel + '">' +
                        '<span ng-class="{selected: node.selected}" style="padding:1px 3px;" ng-click="' + treeId + '.selectNode(node)">' +
                            '<i class="{{ ' + treeId + '.getIcon(node) }}"></i>{{node.' + nodeLabel + '}}' +
                        '</span>' +
                        '<div ng-hide="node.collapsed" tree-id="' + treeId + '" tree-model="node.' + nodeChildren + '" node-id=' + nodeId + ' node-label=' + nodeLabel + ' node-children=' + nodeChildren + '></div>' +
                    '</li>' +
                '</ul>';

            if( attrs.angularTreeview ) {
                scope[treeId] = scope[treeId] || {};

                scope[treeId].selectNode = scope[treeId].selectNode || function( selectedNode ){
                    if (scope[treeId][currentNode]) {
                        scope[treeId][currentNode].selected = false;
                    }

                    selectedNode.selected = true;
                    if (selectedNode.children) {
                        selectedNode.collapsed = selectedNode === scope[treeId][currentNode] ? !selectedNode.collapsed : false;
                    }

                    scope[treeId][currentNode] = selectedNode;
                };

                scope[treeId].getIcon = scope[treeId].getIcon || function( node ){
                    if (node.icon)
                        return node.icon;
                    else if (!node.children)
                        return "fa fa-file-o";
                    else if (node.collapsed)
                        return "fa fa-folder-o";
                    else
                        return "fa fa-folder-open-o";
                };
            }

            element.html('').append( $compile( template )( scope ) );
        }
    }
});

app.directive('oasQuickDate', function oasQuickDate( ){
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/directives/oasQuickDate.html',
        scope: {
            startDate:'=',
            endDate:'=',
            isBilling:'@?',
            onDateSelected:'&?'
        },
        link: function( scope ){

            scope.setDates = function(rangeName) {
                var sDate = Date.create('today');
                var eDate = Date.create('today');

                switch (rangeName) {
                    case "last-month":
                        sDate.addMonths(-1).beginningOfMonth();
                        eDate.addMonths(-1).endOfMonth();
                        break;
                    case "last-year":
                        sDate.addYears(-1).beginningOfYear();
                        eDate.addYears(-1).endOfYear();
                        break;
                    case "last-quarter":
                        eDate = eDate.getStartOfQuarter().addDays(-1);
                        sDate = eDate.getStartOfQuarter();
                        break;
                    case "MTD":
                        sDate.beginningOfMonth();
                        break;
                    case "QTD":
                        sDate = sDate.getStartOfQuarter();
                        break;
                    case "YTD":
                        sDate.beginningOfYear();
                        break;
                    case "roll-1-year":
                        sDate.addYears(-1);
                        if (!scope.isBilling) eDate.addDays(-1);
                        break;
                    case "roll-3-year":
                        sDate.addYears(-3);
                        if (!scope.isBilling) eDate.addDays(-1);
                        break;
                }

                scope.startDate = sDate;
                scope.endDate = eDate;

                if (scope.onDateSelected){
                    scope.onDateSelected();
                }
            };

        }
    };
});
app.directive( 'oasInceptionDate', function oasInceptionDate( $http, entities ) {
    return {
        restrict: 'E',
        replace: true,
        scope: {entity:'=', entityId:'=', startDate:'='},
        template: '<div class="input-append">' +
                        '<input type="text" ng-model="startDate" style="width: 169px;" datepicker-popup data-test-id="txtStartDatepicker"/>' +
                        '<div class="btn-group">' +
                            '<button class="btn" title="Inception" ng-click="setDate( )" ng-disabled="!entityId || entity == 8" data-test-id="btnOasInceptionDate"><i class="fa fa-bolt" aria-hidden="true"></i></button>' +
                        '</div>' +
                   '</div>',
        link: function( scope, element, attrs ) {
            scope.setDate = function() {
                var e = (entities[entities.find({name: scope.entity})]);
                if( e == undefined ) {
                    e = (entities[entities.find({value: scope.entity})]);
                }
                var url = e.simpleUrl.replace('Simple', scope.entityId + '/Calculate/InceptionDate');
                url += '?' + $.param({
                    inclusionOption: attrs.inclusionOption ? attrs.inclusionOption.escapeURL(true) : undefined,
                    reportCategory: attrs.reportCategory ? attrs.reportCategory.escapeURL(true) : undefined
                });

                $http.post(url)
                    .then(function (response) {
                        if( response.data && response.data.inceptionDate ) {
                            scope.startDate = Date.create(response.data.inceptionDate);
                        }
                    });
            };

        }
    };
});
app.directive( 'oasEntityLabel', function oasEntityLabel( $oasRights, $portfolio, entities ) {
    return {
        restrict: 'E',
        replace: true,
        scope: {entity:'=', id:'=' },
        template: '<div><button type="button" class="btn btn-link" ng-click="openEntity( )" ng-disabled="!entityLabel.canRead || !id">{{::entityLabel.text}}</button></div>',
        link: function( scope, element, attrs ) {

            var entityEnum = entities.find({value: scope.entity});

            scope.entityLabel = { };

            if (attrs.customText) {
                scope.entityLabel.text = attrs.customText;
            }
            else if( attrs.showId && attrs.showId == 'true' ) {
                scope.entityLabel.text = scope.id;
            } else {
                scope.entityLabel.text = entities[entityEnum].name;
            }

            scope.entityLabel.canRead = $oasRights.canRead( entities[entityEnum].securityCode );
            scope.entityLabel.extraInfo = null;

            if( entities[entityEnum].value == entities.feeSchedule.value || entities[entityEnum].value == entities.billMasterPayout.value ) {
                scope.entityLabel.extraInfo = { isFeeSchedule: scope.entity == entities.feeSchedule.value };
            }

            scope.openEntity = function( ) {
                if( scope.id && scope.id > 0 ) {
                    $portfolio.openEditor(scope.entity, [scope.id], null, null, null, scope.entityLabel.extraInfo);
                }
            }

        }
    };
});

app.directive('oasEntityOptionList', function oasEntityOptionList( $oasRights, $dialog ){
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/directives/oasEntityOptionList.html',
        scope: { options: '=' },
        link: function( scope, element, attrs ) {

            // PUBLIC METHODS
            scope.categoryDisabled = function (category) {
                return attrs.categorySecurityPrefix && !$oasRights.canUpdate((attrs.categorySecurityPrefix + "_" + category.replace(/ /g, '').toUpperCase()).first(38));
            };

            scope.openBigMultiSelect = function (opt) {
                var selectedItems = [];
                var idProperty = "key";
                var entityType = 35; //indexes
                
                if (opt.code == "69AVAILCURRENCIES") {
                    entityType = 1981;
                    idProperty = "id";
                }

                var valueParts = opt.value ? opt.value.split(',') : [];
                for (var i = 0; i < valueParts.length; i++) {
                    var item = {};
                    item[idProperty] = valueParts[i];
                    if (item[idProperty].length > 0)
                        selectedItems.push(item);
                }

                $dialog.dialog({ templateUrl: "app/modals/available-select.html", controller: "AvailableSelectCtrl", resolve: {availableSelectedArgs: function() { return {selectionType: entityType, selectedSelected: selectedItems}; }}})
                    .open()
                    .then(function(result) {
                        if (result) {
                            opt.value = result.map(idProperty).join(',') || null;
                        }
                    });
            };

            scope.filterCategoriesByItemName = function (category) {
                if (!scope.current.searchText) return true;

                var searchText = scope.current.searchText.toLowerCase();

                return category.items.any(function (item) {return item.name.toLowerCase().has(searchText);});
            };
            
            scope.filterItemsByName = function (item) {
                return scope.current.searchText ? item.name.toLowerCase().has(scope.current.searchText.toLowerCase()) : true;
            };

            scope.invalidEmail = function (option, invalid) {
                option.invalidEmail = invalid;
            }
            
            scope.setOptionValue = function (option, value) {
                option.value = value;
            }

            //INITIALIZE
            scope.rightsEOs = $oasRights.forCode("ENTITYOPTION");
            scope.current = {searchText: ""};


            //SCOPE WATCHERS
            scope.$watch("options", function (newValue) {
                if (!newValue) {
                    return;
                }

                var data = newValue.sortBy("name"),
                    categories = [];

                data.forEach(function (item) {
                    var category = categories.find({name: item.category});
                    if (category) {
                        category.items.push(item);
                    } else {
                        categories.push({name: item.category, items: [item]});
                    }
                });

                scope.categories = categories.sortBy("name");
            });
        }
    };
});
app.directive('oasPortfolio', function oasPortfolio( $rootScope, $http, $portfolio, $settings, $oasRights, $timeout, apps, portfolioTreeTypes, entities){
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/directives/oasPortfolio.html',
        scope: {clientId: '=', entityLoaded: '=', highlightedEntityValue: '=', highlightedEntityType: '=', refreshEvent: '=?'},
        link: function(scope) {

            const yellowWarningIcon = 'fa fa-exclamation-triangle fa-lg text-warning';
            const grayWarningIcon = 'far fa-exclamation-triangle fa-lg muted';

            scope.portfolioTreeTypes = portfolioTreeTypes;
            scope.rightsRep = $oasRights.forCode( "REPS" );
            scope.rightsHH = $oasRights.forCode("CLIENTS");
            scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
            scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
            scope.rightsAst = $oasRights.forCode("ASSETS");
            scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");

            var lastTree = $settings.getSetting('portfolioListTreeLastData');
            if( lastTree ) {
                scope.headerTree = lastTree;
            }

            // WATCHERS
            scope.$watch("clientId", function (newValue, oldValue) {
                if (newValue === oldValue ) {
                    if (!newValue) scope.headerTree = null;
                    return;
                }
                loadPortfolioTree( scope.clientId );
            });

            // PRIVATE METHODS
            function init(){
                $http.get('/Settings/Database/EntityOptions?codeNames=69PORTFOLIOTREE&codeNames=EnableLastReconDate', {trackerMsg:'Getting Portolio Tree filter type'})
                    .then(function (response) {
                        var portfolioTreeSetting = null;
                        response.data.forEach((setting) => {
                            if (setting.code == '69PORTFOLIOTREE') {
                                portfolioTreeSetting = setting;
                            } else if (setting.code == 'EnableLastReconDate') {
                                scope.current.isLastReconDateEnabled = setting.value.toLocaleLowerCase() == 'true';
                                if(scope.current.isLastReconDateEnabled){
                                    getLastBusinessDate();
                                }
                            }
                        });

                        var type = null;
                        if (portfolioTreeSetting != null) {
                            type = portfolioTreeTypes.find({ name: portfolioTreeSetting.value });
                        }
                         
                        if (type){
                            scope.current.portfolioTreeType = portfolioTreeTypes[type].value;
                        }
                    });
            }

            function getLastBusinessDate(){
                $http.get('/Utility/PreviousBusinessDay/v2')
                .then(function(response){
                    if(response){
                        scope.current.lastBusinessDay = Date.create(response.data);
                    };
                } );
            }

            function loadPortfolioTree( pkClient ) {
                if( pkClient && pkClient > 0 ) {

                    let portfolioTreeTypeString = "";

                    if (scope.current.portfolioTreeType !== portfolioTreeTypes.portfolioTree.value){
                        portfolioTreeTypeString = '&portfolioTreeFilter=' + scope.current.portfolioTreeType;
                    }

                    let requestUrl = "/Portfolio/Clients/" + pkClient + "/PortfolioTree?includeAdditionalDetail=true&includeRepresentative=true" + portfolioTreeTypeString + "&skipInceptionDate=true";

                    $http.get(requestUrl, {trackerMsg: 'Loading portfolio tree'})
                        .then( function ( response ) {
                            scope.headerTree = response.data;
                            $settings.setSetting( 'portfolioListTreeLastData', response.data );
                            if (scope.current.portfolioTreeType === portfolioTreeTypes.registrationsOnly.value){
                                scope.current.registrationsOnly.registrations = scope.headerTree.registrations;
                            }
                            if (scope.current.portfolioTreeType === portfolioTreeTypes.accountsOnly.value){
                                scope.current.accountsOnly.accounts = scope.headerTree.registrations.map("accounts").flatten();
                            }

                            let accounts = 0;
                            let accountsOutOfBalance = 0;

                            const prevBusDt = scope.current.lastBusinessDay; 
                            let portfolioGroupList = [];

                            if (scope.current.portfolioTreeType === portfolioTreeTypes.portfolioGroups.value) {
                                portfolioGroupList = scope.headerTree.portfolioGroups;
                            } else if (scope.current.portfolioTreeType === portfolioTreeTypes.portfolioTree.value) {
                                portfolioGroupList = scope.headerTree.portfolioGroupsForTreeView;
                            } else if (scope.headerTree.portfolioGroups != null) {
                                portfolioGroupList = scope.headerTree.portfolioGroups;
                            } else {
                                portfolioGroupList = scope.headerTree.portfolioGroupsForTreeView;
                            }

                            angular.forEach(portfolioGroupList, function (portfolioGroup) {
                                let portfolioGroupAccounts = 0;
                                let portfolioGroupAccountsOutOfBalance = 0;
                                angular.forEach(portfolioGroup.registrations, function (registration) {
                                    let registrationAccounts = 0;
                                    let registrationAccountsOutOfBalance = 0;
                                    angular.forEach(registration.accounts, function (account) {
                                        registrationAccounts++;

                                        const lastPosDt = account.lastPositionDate ? Date.create(account.lastPositionDate.slice(0,10)) : null;
                                        if (account.inBalance != null && lastPosDt != null && (!account.inBalance || lastPosDt < prevBusDt)) {
                                            registrationAccountsOutOfBalance++;
                                            account.status_icon = yellowWarningIcon;
                                        }
                                    });
                                    registration.status_icon = getStatusIcon(registrationAccounts, registrationAccountsOutOfBalance);
                                    portfolioGroupAccounts += registrationAccounts;
                                    portfolioGroupAccountsOutOfBalance += registrationAccountsOutOfBalance;
                                });

                                portfolioGroup.status_icon = getStatusIcon(portfolioGroupAccounts, portfolioGroupAccountsOutOfBalance);
                                accounts += portfolioGroupAccounts;
                                accountsOutOfBalance += portfolioGroupAccountsOutOfBalance;
                            });


                            return getStatusIcon(accounts, accountsOutOfBalance);
                        });
                }
            }

            scope.openEditor = function( entity, id, isPortfolioGroup ) {
                let tabToOpen = null;

                if (isPortfolioGroup && entity === entities.client.value){
                    tabToOpen = 'portfolioGroups';
                }

                $portfolio.openEditor( entity, [id], null, tabToOpen, apps.portfolioLists.name, null ).then(function(rslt) {
                    if( rslt ) {
                        if( scope.refreshEvent && scope.entityLoaded == entity ) {
                            $rootScope.$broadcast( scope.refreshEvent, {action: 'update-item', item: rslt } );
                        }
                        loadPortfolioTree( scope.clientId );
                    }
                });
            };

            scope.goTo = function( urlLevel, entity, id ) {
                $portfolio.goTo( urlLevel, entity, id );
            };

            scope.goToPortfolioGroup = function(urlLevel, entity, id, entity2, id2){
                const additionalParams = {portfolioGroupId :id2};
                $portfolio.goTo( urlLevel, entity, id, additionalParams );
            };
            
            scope.runReport = function( entity, id ) {
                $portfolio.runReport( entity, id );
            };

            scope.portfolioTreeTypeChange = function(){
                loadPortfolioTree(scope.clientId);
            };
            
            scope.openPopover = function ($event, isAccount, lastPositionDate, inBalance, lastReconciledEffectiveDate) {
                let target = $event.target;
                let popover = document.getElementById('oasPortfolioStatusPopover');
                scope.current.statusHeader = '';
                scope.current.statusBody = '';

                if (!isAccount) {
                    scope.current.statusHeader = '';
                    scope.current.statusBody = 'Balance may not be accurate because an underlying account has not been reconciled.';
                } else if (inBalance != undefined && lastPositionDate != undefined) {
                    const prevBusDt = scope.current.lastBusinessDay; 
                    const lastPosDt = Date.create(lastPositionDate.slice(0,10));
                    if (!inBalance) {
                        const lastReconDt = lastReconciledEffectiveDate != undefined ? Date.create(lastReconciledEffectiveDate.slice(0, 10)) : null;
                        if (lastReconDt && lastPosDt >= lastReconDt) {
                            scope.current.statusHeader = 'Balance Changed';
                            scope.current.statusBody = 'Account was reconciled into balance effective <b>' + lastReconDt.formatted() + '</b>, but the balance on the account has since changed';
                        } else {
                            scope.current.statusHeader = 'Inaccurate Balance';
                            scope.current.statusBody = 'This account is not in balance as of <b>' + lastPosDt.formatted() + '</b>';
                        }
                    } else if (lastPosDt < prevBusDt) {
                        scope.current.statusHeader = 'Unconfirmed Balance';
                        scope.current.statusBody = 'Current account balance has not been confirmed.  Last in balance as of <b>' + lastPosDt.formatted() + '</b>';
                    }
                }

                popover.toggle(target);
            };

            scope.current = {
                portfolioTreeType : 0,
                registrationsOnly:{
                    registrations:[]
                },
                accountsOnly: {
                    accounts: []
                },
                statusHeader: '',
                statusBody: '',
                statusFooter: '',
                portfolioStatusIcon: '',
                isLastReconDateEnabled: false,
                lastBusinessDay: ''
            };

            function getStatusIcon(accounts, outOfBalance){
                
                if (outOfBalance === 0) {
                    return '';
                } else if (accounts === outOfBalance) {
                    return yellowWarningIcon;
                } else {
                    return grayWarningIcon;
                }
            };

            init();

        } // end link

    };
});

app.directive('selectPlus', function selectPlus($dialog) {
    return {
        restrict: 'E',
        scope: {
            selectModel: '=',
            selectOptions: '='
        },
        replace: true,
        template:   '<div class="input-append">' +
                        '<select ng-model="selectModel" ng-options="option for option in selectOptions"></select>' +
                        '<button title="Add New Item" ng-click="addNewItem()" class="btn"><i class="fa fa-plus" aria-hidden="true"></i></button>' +
                    '</div>',
        link: function (scope) {
            scope.addNewItem = function () {
                $dialog.inputBox('Add New Item', "Value")
                    .open()
                    .then(function (result) {
                        if (result) {
                            if (angular.isObject(scope.selectOptions)){
                                var idx = Object.find(scope.selectOptions, function(k,v){ return v === result });

                                if (!idx){
                                    scope.selectOptions[0] = result;
                                }
                            } else {
                                if (scope.selectOptions.none(result)) {
                                    scope.selectOptions.push(result);
                                }
                            }
                            scope.selectModel = result;
                        }
                    });
            };
        }
    };
});

app.directive('tabularDropdown', function tabularDropdown() {
    return {
        restrict: 'E',
        scope: {
            selectModel: '=',
            selectData: '=',
            fieldMap: '=',
            displayFormat: '@',
            allowClear: '=?',
            idField: '@',
            disabled: '=?',
            externalModelChange: '=?',
            ariaLabel: '@'
        },
        replace: true,
        template:   '<div class="input-append">' +
                        '<input ng-disabled="::disabled" type="text" ng-model="displayText" style="width: 181px;" aria-label="{{ariaLabel}}" />' +
                        '<div dropdown dropdown-append-to-body class="btn-group dropdown">' +
                            '<button ng-disabled="::disabled" class="btn" dropdown-toggle style="padding: 4px 8px;"><i class="fa fa-caret-down" aria-hidden="true"></i></button>' +
                            '<div class="dropdown-menu dropdown-menu-right" style="max-height: 300px; overflow-y: auto; overflow-x: auto; max-width: 600px; z-index: 1051;">' +
                                '<table class="table table-condensed table-hover no-bottom-margin">' +
                                    '<thead>' + 
                                    '<tr>' +
                                        '<th ng-repeat="field in ::fieldMap">{{ ::field.name }}</th>' +
                                    '</tr>' +
                                    '</thead>' +
                                    '<tbody>' +
                                    '<tr ng-if="!selectData.length"><td colspan="{{ ::fieldMap.length }}"><em>No options available</em></td></tr>' +
                                    '<tr ng-if="::allowClear" ng-click="clearSelection()" style="cursor: pointer;"><td colspan="{{ ::fieldMap.length }}"><button class="btn btn-link">Clear Selection</button></td></tr>' +
                                    '<tr ng-click="selectItem(item)" ng-repeat="item in selectData" style="cursor: pointer;">' +
                                        '<td ng-repeat="field in ::fieldMap">{{ ::item[field.value] }}</td>' +
                                    '</tr>' +
                                    '</tbody>' +
                                '</table>' +
                            '</div>' +
                        '</div>' +
                    '</div>',
        link: function (scope) {
            //PRIVATE METHODS
            function setDisplayText(selectedItem) {
                scope.displayText = selectedItem ? (selectedItem[scope.idField] ? scope.displayFormat.assign(selectedItem) : "(none)") : "Invalid Selection";
            }


            //PUBLIC METHODS
            scope.selectItem = function (item) {
                scope.selectModel = item[scope.idField];
                setDisplayText(item);
            };

            scope.clearSelection = function () {
                scope.selectModel = null;
                setDisplayText({});
            };


            //INITIALIZE
            scope.idField = scope.idField || "id";


            // SCOPE WATCHERS
            scope.$watch('selectData', function (newValue) {
                if (!newValue) return;
                if (scope.selectModel) {
                    var findParameters = {};
                    findParameters[scope.idField] = scope.selectModel;

                    setDisplayText(scope.selectData.find(findParameters));
                } else {
                    setDisplayText(scope.allowClear ? {} : null);
                }
            });

            scope.$watch('selectModel', function (newValue) {
                if (!newValue) return;
                if( scope.selectData && scope.externalModelChange && scope.selectModel ) {
                    var findParameters = {};
                    findParameters[scope.idField] = scope.selectModel;
                    setDisplayText(scope.selectData.find(findParameters));
                }
            });
        }
    };
});

app.directive('sortableTabularDropdown', function sortableTabularDropdown() {
    return {
        restrict: 'E',
        scope: {
            selectModel: '=',
            selectData: '=',
            fieldMap: '=',
            displayFormat: '@',
            allowClear: '=?',
            idField: '@',
            highlightModel: '=',
            disabled: '=?',
            externalModelChange: '=?',
            ariaLabel: '@'
        },
        replace: true,
        template: '<div class="input-append">' +
                    '<input ng-disabled="::disabled" type="text" ng-model="displayText" style="width: 181px;" aria-label="{{ariaLabel}}" />' +
                    '<div dropdown dropdown-append-to-body auto-close="outsideClick" is-open="isOpen" class="btn-group dropdown">' +
                        '<button ng-disabled="::disabled" class="btn" dropdown-toggle style="padding: 4px 8px;"><i class="fa fa-caret-down" aria-hidden="true"></i></button>' +
                        '<div class="dropdown-menu dropdown-menu-right" style="max-height: 300px; overflow-y: auto; overflow-x: auto; max-width: 600px; z-index: 1051;">' +
                            '<table class="table table-condensed table-hover no-bottom-margin">' +
                                '<thead>' +
                                    '<tr>' +
                                        '<th ng-repeat="field in ::fieldMap"><a ng-if="field.sortable" ng-click="sortData($event)">{{ field.name }}</a><span ng-if="!field.sortable">{{ field.name }}</span></th>' +
                                    '</tr>' +
                                '</thead>' +
                                '<tbody>' +
                                    '<tr ng-if="!selectData.length"><td colspan="{{ ::fieldMap.length }}"><em>No options available</em></td></tr>' +
                                    '<tr ng-if="::allowClear" ng-click="clearSelection()" style="cursor: pointer;"><td colspan="{{ ::fieldMap.length }}"><button class="btn btn-link">Clear Selection</button></td></tr>' +
                                    '<tr ng-click="selectItem(item)" ng-repeat="item in selectData" style="cursor: pointer;{{ highlightModel ? (item[highlightModel.field] === highlightModel.value ? \'background-color:\' + highlightModel.color : \'\') : \'\' }}">' +
                                        '<td ng-repeat="field in ::fieldMap">{{ ::item[field.value] }}</td>' +
                                    '</tr>' +
                                '</tbody>' +
                            '</table>' +
                        '</div>' +
                    '</div>' +
                '</div>',
        link: function (scope) {
            //PRIVATE METHODS
            function setDisplayText(selectedItem) {
                scope.displayText = selectedItem ? (selectedItem[scope.idField] ? scope.displayFormat.assign(selectedItem) : "(none)") : "Invalid Selection";
            }
            const getCellValue = (row, i) => row.children[i].innerText || row.children[i].textContent;
            const comparer = (i, asc) => (a, b) => ((v1, v2) =>
                v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ? v1 - v2 : v1.toString().localeCompare(v2)
            )(getCellValue(asc ? a : b, i), getCellValue(asc ? b : a, i));

            //PUBLIC METHODS
            scope.selectItem = function (item) {
                scope.selectModel = item[scope.idField];
                setDisplayText(item);
                scope.isOpen = false;
            };

            scope.clearSelection = function () {
                scope.selectModel = null;
                setDisplayText({});
            };

            scope.sortData = function (e) {
                const th = e.target.closest('th');
                const table = th.closest('table');
                const tbody = table.querySelector('tbody');
                Array.from(table.querySelectorAll('tbody tr'))
                    .sort(comparer(Array.from(th.parentNode.children).indexOf(th), th.asc = !th.asc))
                    .forEach(tr => tbody.appendChild(tr));
            };

            //INITIALIZE
            scope.idField = scope.idField || "id";
            scope.sortAsc = true;
            scope.sortColumn = null;

            // SCOPE WATCHERS
            scope.$watch('selectData', function (newValue) {
                if (!newValue) return;
                if (scope.selectModel) {
                    var findParameters = {};
                    findParameters[scope.idField] = scope.selectModel;

                    setDisplayText(scope.selectData.find(findParameters));
                } else {
                    setDisplayText(scope.allowClear ? {} : null);
                }
            });

            scope.$watch('selectModel', function (newValue) {
                if (!newValue) return;
                if (scope.selectData && scope.externalModelChange && scope.selectModel) {
                    var findParameters = {};
                    findParameters[scope.idField] = scope.selectModel;
                    setDisplayText(scope.selectData.find(findParameters));
                }
            });
        }
    };
});
'use strict'

app.directive('restrictDecimalInput', function restrictDecimalInput(){
    return function(scope,ele,attrs){
            ele.on('keypress',function(e){
                var numberOfDecimals = attrs.restrictDecimalInput ? scope.$eval(attrs.restrictDecimalInput) : 2;

                var parts = $(this).val().split(".");
                if (parts.length == 2 && parts[1].length == numberOfDecimals) {
                    e.preventDefault();
                }
            });
        }
});

'use strict';

app.directive('oasSwitch', function oasSwitch($compile) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            id: '=',
            selected: '=',
            disabled: '=?',
            onText: '@?',
            offText: '@?'
        },
        template:   '<div class="onoffswitch">' +
                        '<input ng-model="selected" type="checkbox" class="onoffswitch-checkbox" id="{{id}}" ng-disabled="disabled">' +
                            '<label class="onoffswitch-label" for="{{id}}">' +
                                '<div class="onoffswitch-inner"></div>' +
                                '<div class="onoffswitch-switch"></div>' +
                            '</label>' +
                    '</div>',
        link: function (scope, element) {
            var style = $compile('<style>\#'+ scope.id + ' + label .onoffswitch-inner:before { content: "' + (scope.onText || 'YES' ) + '"; } \#' + scope.id + ' + label .onoffswitch-inner:after { content: "' + (scope.offText || 'NO') + '"; }</style>')(scope);
            element.prepend( style );
        }
    };
});

'use strict';

app.directive('oasTripleStateToggle', function oasTripleStateToggle($compile) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            selected: '='
        },
        template:   '<button class="btn" style="width:74px;" ng-click="toggle();">{{stateText()}}</button>',
        link: function (scope, element, attrs) {
            scope.toggle = function() {
                if(attrs.isNullable) {
                    if(scope.selected === null)
                        scope.selected = true;
                    else if (scope.selected)
                        scope.selected = false;
                    else
                        scope.selected = null;
                } else {
                    scope.selected = !scope.selected;
                }
            };

            scope.stateText = function() {
                return scope.selected === null ? 'Not Set' : (scope.selected ? 'Yes' : 'No');
            };
        }
    };
});
app.directive('oasHeader', function oasHeader( $http, $rootScope, $timeout ){
    var headerData = {};

    return {
        restrict: 'E',
        replace: true,
        scope: {
          oasDataUrl : '@'
        },
        templateUrl: 'app/directives/oasHeader.html',
        link: function(scope, element, attrs){
            scope.columnConfig = scope.$eval(attrs.columnConfig);

            function init(){
                scope.columnConfig.forEach(function (config) {config.value = 0;});

                loadCounts();
            }

            function getProperty(obj, target) {
                var arr = target.split('.');
                for(var i = 0; i < arr.length; i++){
                    if(obj) obj = obj[arr[i]];
                }
                return obj;
            }

            function getData(data){
                scope.columnConfig.forEach(function(col) {
                    if (col.key.indexOf(".") > 0)
                        col.value = getProperty(data, col.key) || 0;
                    else
                        col.value = data[col.key] || 0;
                })
            }

            function loadCounts( ) {
                $rootScope.$on(scope.oasDataUrl,function(e,args){
                    $rootScope.countKickedOff = true;
                    return;
                });

                $rootScope.$on(scope.oasDataUrl + "-done",function(e,args){
                    headerData[scope.oasDataUrl] = args;
                    getData(args)
                    return;
                });

                if ($rootScope.countKickedOff){
                    getData(headerData[scope.oasDataUrl])
                } else {
                    $timeout(function(){
                        if (!$rootScope.countKickedOff){
                            $http.get(scope.oasDataUrl).then(function (response) {
                                getData(response.data);
                            });
                        }
                    }, 2000);
                }
            }


            init();
        }
    };

});
'use strict';

app.directive('notificationSettings', function notificationSettings($http, notificationDestination, $dialog){
    return {
        restrict : 'E',
        scope: {
            notificationSubscriptionWithDestination : '=',
            loggedInEntity : '='
        },
        replace : true,
        templateUrl : 'app/directives/notificationSettings.html',
        link : function($scope){

           function loadLookUps(){
                $http.get( "/Reporting/NotificationTypes/Simple", {trackerMsg: 'Loading notification types'} )
                    .then( function( response ) {
                        $scope.notificationTypes = response.data;
                    });

               $http.get( "/Reporting/NotificationGroups/Simple", {trackerMsg: 'Loading notification groups'} )
                   .then( function( response ) {
                       $scope.notificationGroups = response.data;
                   });
           }

            function init(){
                loadLookUps();
            }

            $scope.addGroup = function(){
                $dialog.dialog({dialogClass:'modal wide', templateUrl : 'notification-group.html', controller: 'NotificationGroupCtrl', groupId : 0}).open()
                    .then( function( result ) {
                        if( result ) {
                            loadLookUps();
                        }
                    } );
            };

            $scope.editGroup = function(Id){
                $dialog.dialog({dialogClass:'modal wide', templateUrl : 'notification-group.html', controller: 'NotificationGroupCtrl', groupId : Id}).open()
                    .then( function( result ) {
                        if( result ) {
                            loadLookUps();
                        }
                    } );
            };


            $scope.removeGroup = function(Id){
                $dialog.confirmAction("Are you sure you want to remove this group?")
                    .open()
                    .then(function(result){
                        if (result === 'yes') {
                            $scope.notificationGroups.remove(function(g) {
                                return g['id'] == Id;
                            });
                            $http.delete('/Reporting/NotificationGroups/' + Id, {trackerMsg: 'Deleting notification group'})
                                .then(function() {
                                    loadLookUps();
                                });
                        }
                    });
            };

            $scope.changeGroupType = function(type){
              $scope.notificationSubscriptionWithDestination.groupType = type;
            };

            $scope.changeDestination = function(notificationTypeId){
                $http.get( "/Reporting/Notifications/Destinations" + "?notificationTypeId=" + notificationTypeId, { cache: true, trackerMsg: 'Loading notification groups'} )
                    .then( function( response ) {
                        $scope.destinations = response.data;
                    });
            };

            $scope.destinations = null;
            $scope.notificationType = null;
            $scope.notificationTypes = null;
            $scope.notificationGroup = null;
            $scope.notificationGroups = null;
            $scope.availableUsers = null;

            init();

            $scope.$watch('notificationSubscriptionWithDestination', function(newVal, oldVal){
                if (newVal == oldVal) return;

                $scope.changeDestination(newVal.notificationTypeId)

            });
        }

    };
});


'use strict'

app.directive('oasReportAccountDisplayName', function oasReportAccountDisplayName(){
    return {
        restrict: 'E',
        replace: true,
        scope: {
            value: '=',
            disabled: '='
        },
        template:   '<div dropdown dropdown-append-to-body auto-close="outsideClick" class="dropdown">' +
                        '<button dropdown-toggle class="btn btn-block" style="font-size: 13px;" ng-disabled="disabled">{{ displayValue ? displayValue : value }} <b class="caret"></b></button>' +
                        '<div class="dropdown-menu" style="padding:10px; width:300px;">' +
                            '<label class="control-label">Editor Selection</label>' +
                            '<div class="controls">' +
                                '<select ng-model="selectedOption" ng-options="opt.key as opt.display for opt in ::displayOptions"></select> ' +
                            '</div>' +
                            '<label class="control-label">Editor</label>' +
                            '<div class="controls">' +
                                '<textarea ng-model="displayValue" rows="4" class="input-block-level"></textarea>' +
                            '</div>' +
                            '<input type="hidden" ng-model="value" />' +
                        '</div>' +
                    '</div>',
        link: function(scope, element) {
            scope.displayOptions = [
                { display: 'Account Number', key: '{Acct Num}' },
                { display: 'Account Type', key: '{Reg Type}' },
                { display: 'Account Type Code', key: '{Reg Type Code}' },
                { display: 'Custodian', key: '{Custodian Name:FF Name}' },
                { display: 'Fund Family', key: '{FF Name}' },
                { display: 'Management Strategy', key: '{Mgmt Strat}' },
                { display: 'Model', key: '{Model Name:FF Name}' },
                { display: 'Registration Name', key: '{Reg Name:FF Name}' },
                { display: 'Account Nickname', key: '{Acct Nickname}' }
            ];
            scope.comboMapping = [
                {display: 'Fund Family', key: '[Fund Family]'},
                {display: 'Custodian', key: '[Custodian]'},
                {display: 'Model', key: '[Model]'},
                {display: 'Registration Name', key: '[Registration Name]'},
                {display: 'Reg Name \\ Reg Type \\ FF', key: '[Registration Name] \\ [Account Type] \\ [Fund Family]'},
                {display: 'Reg Name \\ Reg Type \\ Custodian', key: '[Registration Name] \\ [Account Type] \\ [Custodian]'},
                {display: 'Reg Name - Reg Type', key: '[Registration Name] - [Account Type]'},
                {display: 'Fund Family - Account Number', key: '[Fund Family] - [Account Number]'},
                {display: 'Reg Name - Reg Type - Mgmt Strat', key: '[Registration Name] - [Account Type] - [Management Strategy]'},
                {display: 'Reg Name - Mgmt Strat', key: '[Registration Name] - [Management Strategy]'},
                {display: 'Model, Account Number', key: '[Model], [Account Number]'},
                {display: 'Reg Name - Reg Type - Acct Num', key: '[Registration Name] - [Account Type] - [Account Number]'}
            ];
            scope.displayValue = '';
            scope.selectedOption = '';
            initialize(scope);
            scope.$watch('displayValue', function(newValue, oldValue){
                if (newValue === oldValue) return;
                parseDisplayedValue(scope);
                scope.selectedOption = '';
            });
            scope.$watch('selectedOption', function(newValue, oldValue){
                if (newValue === oldValue || newValue.trim() === '') return;
                scope.displayValue += (' [' + scope.displayOptions.find(function(option){ return option.key === newValue; }).display + ']');
            });
        }
    };

    function initialize(scope) {
        if(scope.comboMapping.some(function(option){return option.display === scope.value})) {
            scope.displayValue = scope.comboMapping.find(function (option) {
                return option.display === scope.value;
            }).key;
            parseDisplayedValue(scope);
        }
        else {
            parseLoadedValue(scope);
        }
    }

    function parseDisplayedValue(scope) {
        var formattedValue = scope.displayValue;
        scope.displayValue.each(/\[(.*?)\]/,function(word){
            if(scope.displayOptions.some(function(option) {return ('[' + option.display + ']') === word; })) {
                var key = scope.displayOptions.find(function(option) {return ('[' + option.display + ']') === word; }).key;
                formattedValue = formattedValue.replace(word, key);
            }
        });
        scope.value = formattedValue;
    }

    function parseLoadedValue(scope) {
        var displayValue = scope.value;
        scope.value.each(/\{(.*?)\}/,function(tag){
            if(scope.displayOptions.some(function(option) {return option.key === tag; })) {
                var display = scope.displayOptions.find(function(option) {return option.key === tag; }).display;
                displayValue = displayValue.replace(tag, ('[' + display + ']'));
            }
        });
        scope.displayValue = displayValue;
    }
});
'use strict';

app.directive('oasReportRegistrationDisplayName', function oasReportRegistrationDisplayName(){
    return {
        restrict: 'E',
        replace: true,
        scope: {
            value: '=',
            disabled: '='
        },
        template:   '<div dropdown dropdown-append-to-body auto-close="outsideClick" class="dropdown">' +
                        '<button dropdown-toggle class="btn btn-block" style="font-size: 13px;" ng-disabled="disabled">{{ displayValue ? displayValue : value }} <b class="caret"></b></button>' +
                        '<div class="dropdown-menu" style="padding:10px; width:300px;">' +
                            '<label class="control-label">Editor Selection</label>' +
                            '<div class="controls">' +
                                '<select ng-model="selectedOption" ng-options="opt.key as opt.display for opt in ::displayOptions"></select> ' +
                            '</div>' +
                            '<label class="control-label">Editor</label>' +
                            '<div class="controls">' +
                                '<textarea ng-model="displayValue" rows="4" class="input-block-level"></textarea>' +
                            '</div>' +
                            '<input type="hidden" ng-model="value" />' +
                        '</div>' +
                    '</div>',
        link: function(scope, element) {
            scope.displayOptions = [
                { display: 'Account Number', key: '{Acct Num}' },
                { display: 'Registration Type', key: '{Reg Type}' },
                { display: 'Registration Type Code', key: '{Reg Type Code}' },
                { display: 'Registration Name', key: '{Reg Name}' },
                { display: 'Investment Objective', key: '{Inv Obj}' },
                { display: 'Trade Blocked', key: '{Trade Blocked}' },
                { display: 'Sleeve Custodial Account Number', key: '{Sleeve Custodial Account Number}' },
                { display: 'Sleeve Strategy Aggregate', key: '{Sleeve Strategy Aggregate}' }
            ];
            scope.comboMapping = [
            ];
            scope.displayValue = '';
            scope.selectedOption = '';
            initialize(scope);
            scope.$watch('displayValue', function(newValue, oldValue){
                if (newValue === oldValue) return;
                parseDisplayedValue(scope);
                scope.selectedOption = '';
            });
            scope.$watch('selectedOption', function(newValue, oldValue){
                if (newValue === oldValue || newValue.trim() === '') return;
                scope.displayValue += (' [' + scope.displayOptions.find(function(option){ return option.key === newValue; }).display + ']');
            });
        }
    };

    function initialize(scope) {
        if(scope.comboMapping.some(function(option){return option.display === scope.value})) {
            scope.displayValue = scope.comboMapping.find(function (option) {
                return option.display === scope.value;
            }).key;
            parseDisplayedValue(scope);
        }
        else {
            parseLoadedValue(scope);
        }
    }

    function parseDisplayedValue(scope) {
        var formattedValue = scope.displayValue;
        scope.displayValue.each(/\[(.*?)\]/,function(word){
            if(scope.displayOptions.some(function(option) {return ('[' + option.display + ']') === word; })) {
                var key = scope.displayOptions.find(function(option) {return ('[' + option.display + ']') === word; }).key;
                formattedValue = formattedValue.replace(word, key);
            }
        });
        scope.value = formattedValue;
    }

    function parseLoadedValue(scope) {
        var displayValue = scope.value;
        scope.value.each(/\{(.*?)\}/,function(tag){
            if(scope.displayOptions.some(function(option) {return option.key === tag; })) {
                var display = scope.displayOptions.find(function(option) {return option.key === tag; }).display;
                displayValue = displayValue.replace(tag, ('[' + display + ']'));
            }
        });
        scope.displayValue = displayValue;
    }
});
'use strict';

app.directive('oasReportCategoryInceptionDate', function oasReportCategoryInceptionDate(reportCategoryInceptionDateService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            value: '=',
            disabled: '='
        },
        template: `<div><input type="text" ng-model="selectedRCINDate" datepicker-popup max-date="null" data-test-id="txtRCINDatePicker" ng-change="updateSelectedDate()"/></div>`,
        link: function (scope) {
            initialize(scope);

            scope.updateSelectedDate = function () {
                scope.value = reportCategoryInceptionDateService.updateValue(scope.selectedRCINDate);
            };
        }
    };

    function initialize(scope) {
        const initial = JSON.parse(scope.value);

        if (initial && initial.mode === 'advanced') {
            scope.selectedRCINDate = initial.performance;
        } else {
            scope.selectedRCINDate = '';
        }
    }
});
'use strict'

app.directive('oasDailyInterestAccrual', function oasDailyInterestAccrual(){
    return {
        restrict: 'E',
        replace: true,
        scope: {
            value: '=',
            disabled: '='
        },
        templateUrl: 'app/directives/oasDailyInterestAccrual.html',
        link: function(scope, element) {
            function value2Current(value){
                var copy = JSON.parse(value);
                copy.dailyReturnThreshold = copy.dailyReturnThreshold * 100;
                return copy;
            }
            function current2Value(current){
                var copy = angular.copy(current);
                copy.dailyReturnThreshold = copy.dailyReturnThreshold / 100;
                copy.startDate = Date.create(copy.startDate).format('{yyyy}-{MM}-{dd}');
                return JSON.stringify(copy);
            }

            scope.current = value2Current(scope.value);

            scope.onChange = function(){
                if(scope.current.enabled && scope.current.startDate === null){
                    //if the start date isn't set, set it to today.
                    scope.current.startDate = Date.create('now').format('{yyyy}-{MM}-{dd}')
                }

                scope.value = current2Value(scope.current);
            };
        }
    };
});
'use strict'

app.directive('oasFeeAccrual', function oasFeeAccrual(){
    return {
        restrict: 'E',
        replace: true,
        scope: {
            value: '=',
            disabled: '='
        },
        templateUrl: 'app/directives/oasFeeAccrual.html',
        link: function(scope, element) {
            function value2Current(value){
                var copy = JSON.parse(value);
                copy.impactThreshold = copy.impactThreshold * 100;
                return copy;
            }
            function current2Value(current){
                var copy = angular.copy(current);
                copy.impactThreshold = copy.impactThreshold / 100;
                copy.startDate = Date.create(copy.startDate).format('{yyyy}-{MM}-{dd}');
                return JSON.stringify(copy);
            }

            scope.current = value2Current(scope.value);

            scope.onChange = function(){
                if(scope.current.enabled && scope.current.startDate === null){
                    //if the start date isn't set, set it to today.
                    scope.current.startDate = Date.create('now').format('{yyyy}-{MM}-{dd}')
                }

                scope.value = current2Value(scope.current);
            };
        }
    };
});
'use strict'

app.directive('oasRedshiftCostBasis', function oasRedshiftCostBasis()
{
    return {
        restrict: 'E',
        replace: true,
        scope:
        {
            value: '=',
            disabled: '='
        },
        templateUrl: 'app/directives/oasRedshiftCostBasis.html',
        link: function(scope, element) {
            function current2Value(current)
            {
                var copy = angular.copy(current);
                copy.startTime = Date.create(copy.startTime).format('{HH}:{mm}');
                copy.endTime = Date.create(copy.endTime).format('{HH}:{mm}');
                return JSON.stringify(copy);
            }

            function value2Current(value){
                var copy = JSON.parse(value);
                copy.startTime = Date.create(copy.startTime);
                copy.endTime = Date.create(copy.endTime);
                return copy;
            }

            scope.current = value2Current(scope.value);

            scope.onChange = function () {
                scope.value = current2Value(scope.current);
            };
        }
    };
});

'use strict'

app.directive('oasCompositeAutomationSettings', function oasCompositeAutomationSetings() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      value: '=',
      disabled: '=',
    },
    templateUrl: 'app/directives/oasCompositeAutomationSettings.html',
    link: function(scope, element) {
      function value2Current(value) {
        var copy = JSON.parse(value);
        return copy;
      }

      function current2Value(current) {
        var copy = angular.copy(current);
        copy.enabled = copy.enabled;
        copy.runDay = copy.runDay;
        return JSON.stringify(copy);
      }

      scope.current = value2Current(scope.value);
	  scope.current.minRunDay = 1;
	  scope.current.maxRunDay = 28;
	  scope.current.warnMinRunDay = 10;
	  scope.current.showWarning = scope.current.runDay < scope.current.warnMinRunDay;

      scope.onChange = function() {
        if (scope.current.runDay < scope.current.minRunDay) {
          scope.current.runDay = scope.current.minRunDay;
        }
        if (scope.current.runDay > scope.current.maxRunDay) {
          scope.current.runDay = scope.current.maxRunDay;
        }
        scope.value = current2Value(scope.current);
      };

      scope.Range = function(start, end) {
        var result = [];
        for (var i = start; i <= end; i++) {
          result.push(i);
        }
        return result;
      }
    }
  };
});

'use strict';

app.directive('oasSleeveSchedulesAssignmentsSettings', function oasSleeveSchedulesAssignmentsSettings(){
    return {
        restrict: 'E',
        replace: true,
        scope: {
            value: '=',
            disabled: '='
        },
        templateUrl: 'app/directives/oasSleeveSchedulesAssignmentsSettings.html',
        link: function(scope){
            function value2Current(value){
                var copy = JSON.parse(value);
                return copy;
            }

            function current2Value(current){
                var copy = angular.copy(current);
                return JSON.stringify(copy);
            }


            scope.onChange = function(){
                scope.value = current2Value(scope.current);
            };

            scope.current = value2Current(scope.value);

            scope.$watch('current.contributionFeeScheduleId', function(newVal, oldVal){
                if (newVal === oldVal) return;

                scope.value = current2Value(scope.current);
            });
            scope.$watch('current.contributionPayoutScheduleId', function(newVal, oldVal){
                if (newVal === oldVal) return;

                scope.value = current2Value(scope.current);
            });
            scope.$watch('current.distributionFeeScheduleId', function(newVal, oldVal){
                if (newVal === oldVal) return;

                scope.value = current2Value(scope.current);
            });
            scope.$watch('current.distributionPayoutScheduleId', function(newVal, oldVal){
                if (newVal === oldVal) return;

                scope.value = current2Value(scope.current);
            });
        }
    };
});
app.directive('oasFocus', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var dom;

            if (element.is('input') || element.is('select') || element.is('textarea')) {
                dom = element[0];
            } else {
                var inputChildren = element.find('input, select, textarea');
                if (inputChildren.length) {
                    dom = inputChildren[0];
                }
            }

            if (dom && scope.$eval(attrs.oasFocus)) {
                $timeout(function () {
                    dom.focus();
                }, 500); //250 to 1000 ms is responsive
            }
        }
    }
});
app.directive('oasMonthYear', function oasMonthYear() {
    return {
        restrict: 'E',
        scope: {
            oasModel: '=',
            showMonth: '=?'
        },
        replace: true,
        template:   '<div>' +
        '<div class="input-append">' +
        '<input type="text" readonly ng-model="displayText" style="width: 100px;" />' +
        '<div dropdown dropdown-append-to-body auto-close="outsideClick" class="btn-group dropdown">' +
        '<button class="btn" dropdown-toggle style="padding: 4px 8px;"><i class="fa fa-calendar" aria-hidden="true"></i></button>' +
        '<div class="dropdown-menu pull-right parameter" style="max-height: 300px; overflow-y: auto; overflow-x: auto; width: 250px;">' +
        '<table class="table table-condensed datepicker table-hover no-bottom-margin">' +
        '<thead>' +
        '<tr style="margin-bottom: 10px;">' +
        '<th>' +
        '<button class="btn btn-block"  ng-click="year(\'left\')"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>' +
        '</th>' +
        '<th colspan="2">' +
        '<button class="btn btn-block"  ng-click="year(\'middle\')">{{current.year}}</button>' +
        '</th>' +
        '<th>' +
        '<button class="btn btn-block"  ng-click="year(\'right\')"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>' +
        '</th>' +
        '</tr>' +
        '</thead>' +
        '<tbody ng-show="current.isMonth">' +
        '<tr ng-repeat="monthChunk in ::months" style="margin-bottom: 10px;">' +
        '<th ng-repeat="month in ::monthChunk" style="margin:5px;">' +
        '<button class="btn btn-link" ng-class="{\'active\': month.isSelected}" ng-click="selectMonth(month)">{{ ::month.name }}</button></td>' +
        '</th>' +
        '</tr>' +
        '</tbody>' +
        '<tbody ng-show="!current.isMonth">' +
        '<tr  ng-repeat="yearChunk in years" style="margin-bottom: 10px;">' +
        '<th ng-repeat="year in yearChunk" style="margin:5px;">' +
        '<button class="btn btn-link" ng-class="{\'active\': year.isSelected}" ng-click="selectYear(year)">{{ ::year.name }}</button></td>' +
        '</th>' +
        '</tr>' +
        '</tbody>' +
        '</table>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>',
        link: function (scope) {
            var months = [
                {name: 'Jan', value: 1, isSelected: false},
                {name: 'Feb', value: 2, isSelected: false},
                {name: 'Mar', value: 3, isSelected: false},
                {name: 'Apr', value: 4, isSelected: false},
                {name: 'May', value: 5, isSelected: false},
                {name: 'Jun', value: 6, isSelected: false},
                {name: 'Jul', value: 7, isSelected: false},
                {name: 'Aug', value: 8, isSelected: false},
                {name: 'Sep', value: 9, isSelected: false},
                {name: 'Oct', value: 10, isSelected: false},
                {name: 'Nov', value: 11, isSelected: false},
                {name: 'Dec', value: 12, isSelected: false}
            ];

            var years = [];

            function init() {
                if (scope.oasModel){
                    scope.oasModel = Date.create(scope.oasModel);

                    if (scope.showMonth){
                        scope.displayText = (scope.oasModel.getMonth() + 1) + ' - ' + scope.oasModel.getFullYear();
                    } else {
                        scope.displayText = scope.oasModel.getFullYear();
                    }

                    months.find({value: scope.oasModel.getMonth() + 1}).isSelected = true;
                } else {
                    months.find({value: scope.current.month}).isSelected = true;
                }

                scope.months = months.inGroupsOf(4);

                generateYear(scope.current.year);
            }

            function generateYear(yr) {
                years = [
                    {name: '', value: 1, isSelected: false},
                    {name: '0', value: 2, isSelected: false},
                    {name: '1', value: 3, isSelected: false},
                    {name: '2', value: 4, isSelected: false},
                    {name: '3', value: 5, isSelected: false},
                    {name: '4', value: 6, isSelected: false},
                    {name: '5', value: 7, isSelected: false},
                    {name: '6', value: 8, isSelected: false},
                    {name: '7', value: 9, isSelected: false},
                    {name: '8', value: 10, isSelected: false},
                    {name: '9', value: 11, isSelected: false},
                    {name: '', value: 12, isSelected: false}
                ];

                var yearString = yr.toString().substring(3);

                var rst = years.find({name : yearString});

                if (rst){
                    rst.name = yr;
                    var idx = years.findIndex(rst);
                    if (idx){
                        for(var i=idx + 1; i < years.length; i++){
                            years[i].name = years[i - 1].name + 1;
                        }
                        for(var i=idx - 1; i >= 0; i--){
                            years[i].name = years[i + 1].name - 1;
                        }
                    }
                }

                scope.years = years.inGroupsOf(4);
            }

            function getDisplayText() {
                if (scope.showMonth){
                    scope.displayText = scope.current.month + ' - ' + scope.current.year;
                } else {
                    scope.displayText = scope.current.year;
                }
            }

            scope.year = function(item){
                switch(item){
                    case 'left':
                        scope.current.year = scope.current.year - 1;
                        getDisplayText();
                        generateYear(scope.current.year);
                        scope.selectYear(scope.years.flatten().find({name: scope.current.year}));
                        break;
                    case 'middle':
                        scope.current.isMonth = false;
                        scope.selectYear(scope.years.flatten().find({name: scope.current.year}));
                        break;
                    case 'right':
                        scope.current.year = scope.current.year + 1;
                        getDisplayText();
                        generateYear(scope.current.year);
                        scope.selectYear(scope.years.flatten().find({name: scope.current.year}));
                        break;
                }
            };

            scope.selectMonth = function(month){
                months.forEach(function (m) {
                    m.isSelected = m === month;
                });

                scope.current.month = month.value;
                scope.displayText = getDisplayText();
                scope.oasModel = Date.create(scope.current.year, scope.current.month -1, Date.create(scope.oasModel).getDate());

            };

            scope.selectYear = function(year){
                years.forEach(function(y){
                    y.isSelected = y === year;
                });
                scope.current.year = year.name;
                scope.displayText = getDisplayText();
                scope.current.isMonth = scope.showMonth ? true : false;
                scope.oasModel = Date.create(scope.current.year, scope.current.month -1, Date.create(scope.oasModel).getDate());

            };

            scope.showMonth = scope.showMonth === undefined ? true : scope.showMonth;

            scope.current = {
                isMonth:  scope.showMonth ? true : false,
                month: Date.create('today').getMonth() + 1,
                year: Date.create('today').getFullYear()
            };

            scope.displayText = '';

            init();

            scope.$watch('oasModel', function(newValue, oldValue){
                if(newValue != oldValue && newValue != null ) {
                    if (scope.showMonth){
                        scope.displayText = (scope.oasModel.getMonth() + 1) + ' - ' + scope.oasModel.getFullYear();
                    } else {
                        scope.displayText =  scope.oasModel.getFullYear();
                    }


                    months.forEach(function(m){ m.isSelected = false;});
                    months.find({value: scope.oasModel.getMonth() + 1}).isSelected = true;

                    scope.months = months.inGroupsOf(4);

                    generateYear(scope.current.year);
                }
            });
        }
    };
});
'use strict';

/*
    This directive will scroll to a specific row in html table and transition all the <tr> tags.
    Giving the user the ability to go to a row or use it to show that a row exists.

   1/10/2017 - JSM - changed directive to search be id instead of row-index.  tables that have a sort routine will
                     cause the wrong row from being found.  Using id=  on each row solves this.
 */
app.directive('tableScroll', function tableScroll() {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {

            //PRIVATE METHODS
            function scrollTo(rowId) {
                if (rowId) {
                    var row = element.find('tr#' + rowId);
                    row.addClass('highlight-row');
                    row[0].scrollIntoView({
                        behavior: 'smooth',
                        block: 'top'
                    });

                    setTimeout(function () {
                        row.removeClass('highlight-row');
                    }, 1000);
                }
            }

            //INITIALIZE
            element.addClass('table-scroll');

            //SCOPE WATCHERS
            attrs.$observe("tableScroll", function (value) {
                scrollTo(parseInt(value));
            });
        }
    };
});


'use strict';
app.directive('invalidateFutureDates', function ($filter) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            const valuePath = ngModelCtrl?.$$attr?.ngModel;
            if (valuePath != null) {
                const selectedDate = scope.$parent.$eval(valuePath);
                const currentDate = new Date();
                if (selectedDate > currentDate) {
                    ngModelCtrl.$setValidity('validDate', false);
                    element.addClass('ng-invalid');
                    element.addClass('ng-dirty');
                }
            }
            ngModelCtrl.$parsers.push(function (value) {
                if (value == null) {
                    ngModelCtrl.$setValidity('validDate', true);
                    scope.$parent.current.disableSave = false;
                    return null;
                }

                const selectedDate = new Date(value);
                if (isNaN(selectedDate.getTime())) {
                    ngModelCtrl.$setValidity('validDate', false);
                    return undefined;
                }

                const currentDate = new Date();
                const valid = currentDate > selectedDate;

                ngModelCtrl.$setValidity('validDate', valid);
                return value;
            });
        }
    }
});

'use strict';

app.filter('trustHtml', function($sce) {
    return function(val) {
        return $sce.trustAsHtml(val);
    };
});

app.filter('relativeDate', function() {
    return function(val) {
        return val ? Date.create(val).relative() : null;
    };
});
app.filter('SleeveRuleFilter', function () {
    return function (sleeveRules, searchText) {
        var out = [];
        if (searchText === null || searchText === undefined || searchText === '')
        {
            return sleeveRules;
        }
        sleeveRules.forEach((userSleeveRule) => {
            if (userSleeveRule.RunOrder.toString().toLowerCase().includes(searchText.toLowerCase()) || (userSleeveRule.Name != undefined && userSleeveRule.Name.toLowerCase().includes(searchText.toLowerCase()))) {
                out.push(userSleeveRule);
            }
        });

        return out;
    }
});

app.filter('searchFilter', function () {
    return function (items, search) {
        

        if (!search || Object.keys(search).length <= 0) {
            return items;
        }


        var filtersWithValues = [];
        Object.keys(search).forEach((searchObj) => {
            var input = search[searchObj].input;
            if (input != null && input != '') {
                filtersWithValues.push(search[searchObj]);
            }
        }); 

        if (filtersWithValues.length <= 0)
        {
            return items;
        }

        var result = [];

        items.forEach((item) => {
            var matches = true;
            filtersWithValues.forEach((filter) => {
                if (item == null
                    || item[filter.propToFilter] == null
                    || !item[filter.propToFilter].toString()
                    || !item[filter.propToFilter].toString().toLowerCase().includes(filter.input.toLowerCase()))
                {
                    matches = false;
                }
            });
            if (matches) {
                result.push(item);
            }
        });

        return result;
    }
});

app.filter('TaskTypeFilter', function (CorporateAction) {
    function showTaskType(selected, tasktypevalue) {
        const processStatus = CorporateAction.statusDetail(selected.processStatus)
        const taskTypes = processStatus.taskTypes;
        const conditionalTypes = processStatus.conditionalTypes;

        if (taskTypes.length > 0 && taskTypes.indexOf(tasktypevalue) !== -1) { return true; }

        return conditionalTypes != null && conditionalTypes[tasktypevalue] != null && conditionalTypes[tasktypevalue].indexOf(selected.corpActionProcessingTypeId) !== -1;
    }

    return function (items, selectedRow) {
        var filtered = [];
        if (!selectedRow) { return filtered; }

        items.forEach(function (item) {
            if (showTaskType(selectedRow, item.value)) {
                filtered.push(item);
            }
        });

        return filtered;
    };
});

app.filter('socialize', function() {
    return function(val) {
        return val+'?t='+sessionStorage.oas_token+'&action=sso&m=noHeader';
    };
});
'use strict';

app.directive('scrollingContainer', function scrollingContainer($timeout) {
    return {
        restrict: 'A',
        transclude: true,
        template: '<div ng-transclude></div>',
        link: function (scope, element, attrs) {
            $timeout(function() {
                // After cloned, loaded, transformed by directives
                $timeout(function() {
                    //After properly rendered by browser
                    var contentPadding = 25;
                    var distance = 0;
                    var watchedElement = null;
                    var minTop = 0;

                    function getHeight() {
                        return watchedElement.height() + distance;
                    }

                    switch (attrs.scrollMax) {
                        case 'parent':
                            watchedElement = element.parent();
                            break;
                        case 'window':
                        case 'viewport':
                        case undefined:
                            watchedElement = $(window);
                            distance -= contentPadding; // Current Content Padding
                            distance -= element.offset().top; // Distance of element to top
                            distance += watchedElement.scrollTop();
                            minTop = contentPadding*2;
                            break;
                        default:
                            element.css('max-height', attrs.scrollMax);
                            return true;
                    }

                    element.ready(function() {
                        element.css('position', 'relative');
                        element.css('overflow', 'auto');
                        element.css('max-height', watchedElement.height() + distance);

                        $(window).resize(function(){
                            element.css('max-height', watchedElement.height() + distance);
                        });
                        $(window).scroll(function(){
                            var scrollDistance = watchedElement.scrollTop();

                            element.css('max-height', getHeight() + Math.min(scrollDistance, minTop));
                            element.css('top', Math.max(scrollDistance - minTop, 0));
                        });
                    });
                }, 0);
            }, 0);
        }
    };
});
'use strict';

app.directive('queryButton', function queryButton($dialog, $http, $q, $dataQuery, $location) {
    return {
        restrict: 'AEC',
        scope: {
            query: '=',
            id: '=?',
            iconOnly: '@',
            size: '@'
        },
        templateUrl: 'app/directives/dataQueryButton.html',
        replace: true,
        link: function(scope) {
            function init() {
                if(!scope.query) throw 'You must provide a valid query';
                else if(angular.isNumber(scope.query)) scope.loadQuery(scope.query);

                scope.iconOnly = !!scope.iconOnly;
                switch(scope.size) {
                    case 'large':
                        scope.sizeClass = 'btn-large';
                        break;
                    case 'default':
                    case undefined:
                        scope.sizeClass = 'btn-default';
                        break;
                    case 'small':
                        scope.sizeClass = 'btn-small';
                        break;
                    case 'mini':
                        scope.sizeClass = 'btn-mini';
                        break;
                    default:
                        throw scope.size + ' is not a valid size';
                }
            }

            scope.run = function(mode) {
                if (mode == 'download') var hideScreen = true;
                return $dialog.dataQueryPrompt(scope.query.id, mode, hideScreen).open( )
                    .then(function (result) {
                        if (result) {
                            $dataQuery.setDataQuery(result);
                            $location.path('/reports/dataqueries/' + scope.query.id);
                        }
                    });
            };

            scope.loadQuery = function(id) {
                return $http.get('/Reporting/Custom/' + id, {trackerMsg: 'Loading DataQuery #'+id}).then(function(query){
                    scope.query = query.data;
                    return scope.query;
                })
            };

            scope.schedule = function () {
                $dialog.dialog({id: scope.query.id, scheduleId: scope.query.scheduleId, templateUrl: "reporting/modals/dataqueryScheduler.html", controller: "DataQuerySchedulerCtrl", dialogClass: "modal wide"})
                    .open()
                    .then(function (result) {
                        if (result) {
                            //Add or Save schedule.
                            $http(result.id > 0
                                ? {
                                    method: "PUT",
                                    url: '/Reporting/Custom/Schedules/' + result.id,
                                    id: result.scheduleId,
                                    data: result,
                                    trackerMsg: "Saving query schedule: " + result.name}
                                : {
                                    method: "POST",
                                    id: 0,
                                    data: result,
                                    url: '/Reporting/Custom/Schedules/',
                                    trackerMsg: "Adding new query schedule"
                                })
                                .then(function (response) {
                                    return scope.loadQuery(response.data.customReportId);
                                });
                        }
                    });
            };

            init();
        }
    };
});
'use strict';


app.directive('gridCounts', function gridCounts($http, splitIoService){
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/directives/gridCounts.html',
        link: function(scope, element, attrs){
            let isPentestCrossSiteFilterReworkEnabled = false;
            // TODO : remove this when removing opex_rework_2026_orion_connect_pentest_cross_site_39440 feature flag
            splitIoService.getBoolTreatment('opex_rework_2026_orion_connect_pentest_cross_site_39440').subscribe(function (isEnabled) {
                isPentestCrossSiteFilterReworkEnabled = isEnabled === true;
                window.isPentestCrossSiteFilterReworkEnabled = isPentestCrossSiteFilterReworkEnabled;
            });

            function gridFilter(filter) {
                // TODO : remove this when removing opex_rework_2026_orion_connect_pentest_cross_site_39440 feature flag
                if (isPentestCrossSiteFilterReworkEnabled) {
                    var structured = window.slickGridFilterFormat
                        ? window.slickGridFilterFormat.buildStructuredFields(
                            { field: filter.key, conditionType: 'basicText' },
                            { name: 'equals' },
                            filter.value
                        )
                        : {};
                    return angular.extend({
                        name: filter.key.capitalize() + ' = ' + filter.value,
                        key: filter.key,
                        include: true
                    }, structured);
                }

                // TODO : remove this when removing opex_rework_2026_orion_connect_pentest_cross_site_39440 feature flag
                return { name: filter.key.capitalize() + ' = ' + filter.value, value: "(function(a) { return a == '{value}' })".assign(filter), key: filter.key, include: true };
            }

            scope.current.grid.counts.toggleFilter = function(filter) {
                if(scope.current.view.filters.find(gridFilter(filter))) {
                    scope.current.view.filters.remove(gridFilter(filter));
                    filter.selected = false;
                } else {
                    scope.current.view.filters.push(gridFilter(filter));
                    filter.selected = true;
                }
            };

            scope.current.grid.counts.filterSelected = function(filter) {
                return scope.current.view.filters.find(gridFilter(filter));
            };
        }
    };
});


app.directive('convertToNumber', function() {
    return {
        require: 'ngModel',
        link: function(scope, elem, attrs, ngModel) {
            ngModel.$parsers.push(function(val) {
                return parseInt(val, 10);
            });
            ngModel.$formatters.push(function(val) {
                return '' + val;
            });
        }
    };
});
app.directive('sanitizeInput', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attrs, ngModel) {
            ngModel.$parsers.push(function(val) {
                return String(val).length && isNaN(String(val)) ? val : parseInt(val, 10);
            });
        }
    };
});
'use strict';

app
    .directive('oasAccordion', function () {
        return {
            require: '^?oasAccordionGroup',
            restrict: 'E',
            transclude: true,
            template:
                '<div class="oas-accordion-heading" ng-click="toggle(!isOpen)" data-test-id="accordion-heading-{{::heading}}">' +
                '<span class="pull-right"><i class="{{headerIconClass}}"></i></span>' +
                '{{heading}}' +
                '</div>' +
                '<div class="oas-accordion-body" style="{{bodyStyle}}">' +
                '<div class="oas-accordion-body-inner" ng-transclude></div>' +
                '</div>',
            scope: { heading: '@', isOpen: '<' },
            link: function (scope, element, attrs, oasAccordionGroupCtrl) {

                function updateBodyStyle() {
                    var max = '0px';
                    if(scope.isOpen) {
                        // The commented code was used to determine the height of the content body.
                        // Unfortunately this does not work if the content is dynamic.
                        // The height may be determined before the content has fully loaded.
                        // var e = element[0].querySelector('.oas-accordion-body .oas-accordion-body-inner');
                        // var pixels = e.scrollHeight || 0;
                        // max = pixels > 0 ? `${pixels}px` : 'unset';
                        max = '10000px';
                    }
                    scope.bodyStyle = `max-height: ${max}`;
                }

                function updateHeaderIconClass() {
                    scope.headerIconClass = scope.isOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down';
                }

                scope.toggle = function(state) {
                    scope.$resume();
                    scope.$evalAsync(()=>{
                        scope.isOpen = state;
                        updateHeaderIconClass();
                        updateBodyStyle();
                        if(scope.isOpen && oasAccordionGroupCtrl) {
                            oasAccordionGroupCtrl.closeOthers(scope);
                        }
                        scope.$applyAsync(()=>{
                            if(!state){scope.$suspend();}
                        });
                    });
                };

                scope.toggle(scope.isOpen);
                if(oasAccordionGroupCtrl) {
                    oasAccordionGroupCtrl.addSection(scope);
                }
            }
        };
    })
    .directive('oasAccordionGroup', function () {
        return {
            restrict: 'E',
            transclude: true,
            replace: false,
            template: '<div class="oas-accordion-group" ng-transclude></div>',
            scope: { closeOthers: '@' },
            controller: ['$scope', function ($scope) {
                this.sections = [];
                if(!angular.isDefined($scope.closeOthers)) $scope.closeOthers = true;

                this.closeOthers = function (openSection) {
                    if ($scope.closeOthers) {
                        angular.forEach(this.sections, function (section) {
                            if (section !== openSection) {
                                section.toggle(false);
                            }
                        });
                    }
                };

                this.addSection = function (sectionScope) {
                    var that = this;
                    this.sections.push(sectionScope);

                    sectionScope.$on('$destroy', function (event) {
                        that.removeSection(sectionScope);
                    });
                };

                this.removeSection = function (section) {
                    var index = this.sections.indexOf(section);
                    if (index !== -1) {
                        this.sections.splice(this.sections.indexOf(section), 1);
                    }
                };
            }],
        };
    });

'use strict';

app.controller('ChangePasswordCtrl', function ChangePasswordCtrl($scope, dialog, $http) {
    //PUBLIC METHODS
    $scope.change = function () {
        $scope.current.errors = [];
        if ($scope.current.newPassword !== $scope.current.newPassword2) {
            $scope.current.errors.push({type: 'error', title: 'Uh oh!', msg: "The two 'New Password' fields don't match!"});
            return;
        }

        let basicAuth = "Basic " + ($scope.user.authorization.loginUserId + ":" + $scope.current.oldPassword).encodeBase64();
        let newPassword = $scope.current.newPassword.encodeBase64();

        $http.get('/security/token', {headers: {Authorization: basicAuth, ChangePassword: newPassword}, ignoreExceptions: true, ignoreAuthModule: true, trackerMsg: 'Changing password'})
            .then(function () {
                dialog.close();
            })
            .catch(function (response) {
                let msg;
                switch (response.status) {
                    case 400:{
                        let errors = response.data.split(";");
                        angular.forEach(errors, function(value){
                            $scope.current.errors.push({type: 'error', title: 'Uh oh!', msg: value});
                        });
                    }
                    return;
                    case 401:
                        msg = "You entered an invalid 'Old Password'.";
                        break;
                    case 500:
                        msg = "Please try again or contact Tech Support if the problem persists.";
                        break;
                    default:
                        msg = "Action failed, but I don't know why.";
                }
                $scope.current.errors.push({type: 'error', title: 'Uh oh!', msg: msg});
            });
    };

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.closeError = function (index) {
        $scope.current.errors.splice(index, 1);
    };

    //INITIALIZE
    $scope.current = {oldPassword: "", newPassword: "", newPassword2: "", errors: []};
    $scope.current.passwordRuleInfo = "Password must be a minimum of 10 characters, must have a number or special character, and cannot contain date-related words, your name, user ID, or email address, nor any variation of the words 'password', 'Orion' or 'advisor'.";
});

'use strict';

app.controller('LoginAsCtrl', function LoginAsCtrl($scope, $q, $http, $dialog, $sanitize, dialog, API_CONFIG, entities, sessionReset, $oasRights, args) {
    //PRIVATE VARIABLES
    let tempToken = sessionStorage.oas_token;
    const loginSettings = {loginDestination: args.loginDestination, loginUrl: args.loginUrl};


    //PRIVATE METHODS
    function init() {
        if (dialog && dialog.options) {
            loginSettings.loginDestination = dialog.options.loginDestination;
            loginSettings.loginUrl = dialog.options.loginUrl;
        }

        toggleCobrowseFeature();

        if ($scope.user.authorization.databaseCount > 1) {
            $http.get('/Authorization/Databases', {cache: true, trackerMsg: 'Loading databases', allowCancellation: false })
                .then(function(response) {
                    $scope.databases = response.data;
                });
        }

        switch (loginSettings.loginDestination) {
            case 'ClientPortal':
                $scope.loginLevel.list.push(entities.client);
                break;
            case 'OrionConnect':
                if ($scope.user.authorization.entity === entities.representative.name) {
                    const entity = $scope.user.authorization.parentEntity === 'Broker/Dealer' ? 'Broker/Dealer' : 'Representative';

                    $http.get(`/Security/Profiles?entity=${entity}&populateEntityName=true`, { trackerMsg: 'Loading profiles', allowCancellation: false })
                        .then(function (response) {
                            $scope.profileList = response.data;
                        });
                }

                if ($scope.user.authorization.entity === entities.administrator.name || ($scope.user.authorization.entity === entities.ria.name && $oasRights.canUpdate('MUL_SAMEENTITY'))) {
                    $scope.loginLevel.list.push(entities.ria);
                }

                $scope.loginLevel.list.push(entities.representative);

                const list = {
                    MUL_WHOLESALER: entities.wholesaler,
                    MUL_BROKERDEALER: entities.brokerDealer,
                    MUL_REPACCOUNTMGR: entities.repAccountManager,
                    MUL_PAYEE: entities.payee,
                    MUL_COTENANT: entities.cotenant
                };

                Object.each(list, function(key, value) {
                    if ($oasRights.canRead(key)) {
                        $scope.loginLevel.list.push(value);
                    }
                });
                break;
            case 'RepPortal':
            case 'AdvisoryWorld':
            case 'ByAllRep':
                $scope.loginLevel.list.push(entities.representative);
                break;
        }

        $scope.loginLevel.selected = $scope.loginLevel.list[0];
    }

    function getDifferentToken(tokenType, headerValue) {
        const headers = {Authorization: 'Switch ' + tempToken};

        headers[tokenType] = headerValue;

        return $http.get('/security/token?useCurrentProfile=' + ($scope.profileList ? 'true' : 'false'), {headers: headers, trackerMsg: 'Requesting new ' + tokenType + ' token', allowCancellation: false })
            .then(function(response) {
                return response.data.access_token;
            });
    }

    function toggleCobrowseFeature() {
        $scope.cobrowse.enabled = false;

        if (loginSettings.loginDestination === 'ClientPortal') {
            $http.get('/Authorization/User/Privileges/clientCobrowse', {headers: {Authorization: `Session ${tempToken}`}, allowCancellation: false })
                .then(response => {
                    $scope.cobrowse.enabled = response.data.readIsGranted;
                });
        }
    }


    //PUBLIC METHODS
    $scope.searchProfiles = function(searchText) {
        return $http.get('/Security/Profiles/Search?search=' + searchText + '&Entity=' + $scope.loginLevel.selected.value, {headers: {Authorization: 'Session ' + tempToken}, allowCancellation: false })
            .then(function(response) {
                return response.data;
            });
    };

    $scope.profileFormatter = function(profile) {
        return !profile ? '' : (profile.entityId || profile.userId) + ': ' + $sanitize(profile.entityName) + ' (' + profile.loginUserId + ')';
    };

    $scope.updateDbToken = function() {
        getDifferentToken('AlClientId', $scope.current.selectedDatabase.id)
            .then(function(token) {
                $scope.current.selectedProfile = null;
                tempToken = token;

                toggleCobrowseFeature();
            });
    };

    $scope.cancel = function() {
        setTimeout(function() {
            if (dialog) {
                dialog.close();
            } else {
                window.parent.postMessage('iframeclose');
            }
        }, 1000);
    };

    $scope.openForMobileOrTablet = function(url) {
        window.open(url);
        if (dialog) {
            dialog.close();
        } else {
            window.parent.postMessage('iframeclose');
        }
    };

    $scope.resetOrionConnect = function() {
        if ($scope.current.selectedDatabase.id !== $scope.user.authorization.alClientId && $oasRights.canRead('REQADVNUMFORDB')) {
            $http.get('/Settings/EntityOptions/Database/0/code/1:69ADVNUM', {headers: {Authorization: 'Session ' + $scope.current.orionConnectToken}, trackerMsg: 'Loading database info', allowCancellation: false })
                .then(function(response) {
                    $dialog.inputBox('Advisor Number', 'Enter Number', 'compare', {compareValue: response.data.value})
                        .open()
                        .then(function(result) {
                            if (result) {
                                sessionReset.reset($scope.current.orionConnectToken, true);
                            }
                        });
                });
        } else {
            sessionReset.reset($scope.current.orionConnectToken, true);
        }
    };

    $scope.formatLabel = function(selectedProfile) {
        return !selectedProfile ? '' : (selectedProfile.entityId || selectedProfile.userId) + ': ' + selectedProfile.entityName + ' (' + selectedProfile.loginUserId + ')';
    };

    //INITIALIZE
    $scope.current = {
        isMobileOrTablet: oas.utils.isMobileOrTablet(),
        selectedDatabase: {
            id: $scope.user.authorization.alClientId,
            clientName: $scope.user.authorization.alClientName,
        },
        searchInProgress: false,
    };
    $scope.cobrowse = {enabled: false, online: null, url: ''};
    $scope.loginLevel = {list: []};
    if (!dialog) {
        window.parent.postMessage('iframeload');
    }
    init();


    //SCOPE WATCHERS
    $scope.$watch('current.selectedProfile', function(newValue, oldValue) {
        $scope.current.destinationUrl = null;
        $scope.current.orionConnectToken = null;
        $scope.cobrowse.online = null;

        if (!newValue || newValue === oldValue) {
            return;
        }

        getDifferentToken('UserDetailId', $scope.current.selectedProfile.userDetailId)
            .then(function(token) {
                switch (loginSettings.loginDestination) {
                    case 'ClientPortal':
                        const promises = {
                            landingPage: $http.get('/Settings/CustomSettings/default-landing-page', {headers: {Authorization: `Session ${token}`}, trackerMsg: 'Retrieving default landing page', allowCancellation: false }),
                            // this will return a list, but since we're using the client's token, it will only have one rep's data (avoids extra call to look up rep ID first)
                            redirectToAdvizr: $http.get('/Settings/EntityOptions/Representative/Code/69RedirectAdvizr?includeName=false', {headers: {Authorization: `Session ${token}`}, trackerMsg: 'Loading redirect setting', allowCancellation: false })
                        };

                        const externalId = $scope.current.selectedProfile.userGuid;
                        if ($scope.cobrowse.enabled) {
                            promises.cobrowseStatus = $http.get(`/Integrations/SaleMove/Cobrowse/${externalId}/Online`, {headers: {Authorization: `Session ${tempToken}`}, trackerMsg: 'Checking cobrowse status', ignoreExceptions: true, allowCancellation: false });
                        }

                        //we may not use landingPage and cobrowseStatus depending on value of redirectToAdvizr, but it's still faster to just call them all at once
                        $q.all(promises)
                            .then(responses => {
                                if (responses.redirectToAdvizr.data[0].value === 'True') {
                                    $scope.current.destinationUrl = `${API_CONFIG.baseUrl}/Integrations/Advizr/Action/SAML?Authorization=${token}`;
                                    return;
                                }

                                $scope.current.destinationUrl = `${API_CONFIG.clientPortalUrl}?t=${token}&p=${responses.landingPage.data.value}`;

                                $scope.cobrowse.online = responses.cobrowseStatus && responses.cobrowseStatus.data;
                                $scope.cobrowse.url = `${API_CONFIG.baseUrl}/Integrations/SaleMove/Cobrowse/${externalId}/Launch?Authorization=${tempToken}`;
                            });
                        break;
                    case 'RepPortal':
                        $scope.current.destinationUrl = API_CONFIG.repPortalUrl + '?t=' + token;
                        break;
                    case 'OrionConnect':
                        $scope.current.orionConnectToken = token;
                        break;
                    case 'AdvisoryWorld':
                        $scope.current.destinationUrl = loginSettings.loginUrl + token;
                        break;
                    case 'ByAllRep':
                        $scope.current.destinationUrl = API_CONFIG.baseUrl + '/Integrations/ByAllAccounts/SSO?Authorization=' + token;
                        break;
                }
            });
    });
});

'use strict';

app.controller('UploadFileCtrl', function UploadFileCtrl($scope, $http, $dialog, dialog, API_CONFIG) {
    //PRIVATE VARIABLES
    const importedData = [];


    // PUBLIC METHODS
    $scope.processImport = function () {
        const postData = $scope.current.validItems;
        $scope.current.validItems = null;

        const promptForMore = function () {
            if($scope.current.cacheKey || postData.length > 100000) {
                if($scope.current.cacheKey)
                    dialog.close($scope.current.cacheKey);
                else
                    dialog.close(postData);
            }
            else {
                importedData.add(postData);

                const buttons = [
                    {result: 'import', label: 'Import Another File', cssClass: 'btn-primary'},
                    {result: 'finished', label: 'Finished'}
                ];

                $dialog.messageBox("<i class='fa fa-check-square fa-lg text-success' aria-hidden='true'></i> Import Successful", "Would you like to import another file?", buttons)
                    .open()
                    .then(function (result) {
                        if (result === "import") {
                            $scope.startImportOver();
                        } else {
                            dialog.close(importedData);
                        }
                    });
            }
        };

        if (dialog.options.commitUrl) {
            $http({method: dialog.options.commitVerb || 'POST', url: dialog.options.commitUrl, data: postData, trackerMsg: 'Processing import'})
                .then(function (result) {
                    if(dialog.options.returnNewModel){
                        dialog.close(result);
                    } else {
                        promptForMore();
                    }
                });
        } else {
            promptForMore();
        }
    };

    $scope.startImportOver = function () {
        $scope.current.selectedItems = null;
        $scope.current.validItems = null;
        $scope.current.importedItems = null;
        $scope.current.cacheKey = null;
    };

    $scope.downloadTemplate = function (fileType) {
        window.location.href = API_CONFIG.baseUrl + dialog.options.downloadUrl + fileType + '?Authorization=' + sessionStorage.oas_token;
    };

    $scope.export = function () {
        var payload = $scope.current.cacheKey ? $scope.current.selectedItems.data : $scope.current.selectedItems;
        $http.post(dialog.options.exportUrl, payload, {trackerMsg: 'Exporting'})
            .then(function (response) {
                window.location.href = response.headers("location") + (response.headers("location").indexOf("?") !== -1 ? "&" : "?") + "Authorization=" + sessionStorage.oas_token;
            });
    };

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.setOrderBy = function (property) {
        if (property === "idField") {
            property = $scope.current.idField;
        }

        $scope.current.orderBy = property;
        $scope.current.reverse = !$scope.current.reverse;
    };

    // WATCHES
    $scope.$watchCollection("current.selectedItems", function (newValue, oldValue) {
        if (newValue === oldValue || !newValue) return;

        if(angular.isArray(newValue)) {
            $scope.current.validItems = newValue.findAll({isValid: true});
            $scope.current.importedItems = $scope.current.errorsOnly ? newValue.findAll({isValid: false}).first(100): newValue;

            newValue.forEach(function (item, index) {
                item.row = index + 2;
            });
        } else {
            $scope.current.cacheKey = newValue.cacheKey;
            $scope.current.validItems = newValue.data.findAll({isValid: true});
            $scope.current.importedItems = $scope.current.errorsOnly ? newValue.data.findAll({isValid: false}).first(100): newValue.data;

            newValue.data.forEach(function (item, index) {
                item.row = index + 2;
            });
        }
    });


    // INITIALIZE
    $scope.current = Object.select(dialog.options, 'title', 'validateUrl', 'exportUrl', 'idField', 'downloadUrl', 'errorsOnly');
    $scope.current.orderBy = $scope.current.idField;
});
'use strict';

app.controller('LoginCtrl', function LoginCtrl($scope, $sce, $http, dialog, authService, promiseTracker, API_CONFIG, sessionReset, $timeout) {
    //PRIVATE VARIABLES
    var ALERT_MSGS = {
        expiredPassword: {
            type: 'warning',
            icon: 'fa-exclamation-circle',
            title: 'Expired Password',
            msg: "Your password has expired.  Please enter a new password."
        },
        userProfile: {
            type: 'warning',
            icon: 'fa-exclamation-circle',
            title: 'Uh oh!',
            msg: "We were unable to load your user information.  Please try again or contact your advisor if the problem persists."
        },
        inactiveUser: {
            type: 'warning',
            icon: 'fa-exclamation-circle',
            title: 'Uh oh!',
            msg: "This user account is inactive.  Please contact your advisor."
        },
        invalidLogin: {
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Uh oh!',
            msg: "You entered an invalid username and/or password.  Please try again."
        },
        internalServer: {
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Uh oh!',
            msg: "An internal server error occurred.  Please try again or contact your advisor if the problem persists."
        },
        unknownError: {
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Uh oh!',
            msg: "An unexpected error occurred.  Please try again or contact your advisor if the problem persists."
        },
        resetInstructions: {
            type: 'info',
            icon: 'fa-info-circle',
            title: 'Heads up!',
            msg: "You will receive an e-mail from portal@orionadvisor.com shortly.  Follow the link in the e-mail to set your password."
        },
        createUserError: {
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Uh oh!',
            msg: "The following error has occurred: Please address the error or contact your advisor if the problem persists."
        },
        mismatchPassword: {
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Uh oh!',
            msg: "The password fields must match."
        },
        passwordReset: {
            type: 'success',
            icon: 'fa-info-circle',
            title: 'Success!',
            msg: "Your password has been reset.  Please login."
        },
        invalidSecurityAnswer: {
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Uh oh!',
            msg: "The answer to your security question is incorrect or your new password does not meet the minimum criteria below."
        },
        invalidNewPassword: {
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Uh oh!',
            msg: "Your new password does not meet the minimum criteria below."
        },
        invalidTwoFactorCode: {
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Uh oh!',
            msg: "The code you entered is invalid or has expired. Please try again."
        },
        invalidInformEntityType: {
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Uh oh!',
            msg: "You must use client credentials to log in and connect Orion accounts."
        },
        invalidGeneric: {
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Uh oh!',
            msg: ""
        },
    };

    var twoFactorToken;


    //PRIVATE METHODS
    function messageReceiver(e) {
        if (e.origin === 'https://auth.orionadvisor.com' && !e.data.startsWith("[iFrameSizer]")) {
            $scope.hideSecureAuthFrame = true;
            assignToken(e.data);
        }
    }

    function init() {
        $scope.isInform = dialog.options.isInform;
        supportRedirect();

        if (!localStorage.oas_device_id) {
            localStorage.oas_device_id = randomString(255);
        }

        if ($scope.secureAuthUrl) {  //Register for messages from the SecureAuth iframe
            if (window.addEventListener) {
                window.addEventListener("message", messageReceiver, false);
            } else {
                window.attachEvent("onmessage", messageReceiver);
            }
        }
    }

    function assignToken(token) {
        let previousToken = sessionStorage.oas_token;
        let previousSession = 'Session ' + previousToken;

        sessionStorage.oas_token = token;
        $http.defaults.headers.common.Authorization = 'Session ' + token;
        supportRedirect();

        $http.get('/Authorization/User?forMobileApp=false', {tracker: 'login'})
            .then(function (response) {
                if ($scope.isInform) {
                    let userProfile = response.data;

                    if (userProfile.entity === "Household") {
                        sessionStorage.oas_token = previousToken;
                        $http.defaults.headers.common.Authorization = previousSession;
                        dialog.close();

                        //call out to create the user and connection using the appropriate source
                        $http.post('/Compliance/Inform/Connection/V2/Orion', userProfile,
                            {trackerMsg: 'Creating Orion Account Connection'});

                        return;
                    } else {
                        throw new Error(ALERT_MSGS.invalidInformEntityType);
                    }
                }

                dialog.close();
                authService.loginConfirmed(response.data, function (config) {
                    config.headers.Authorization = 'Session ' + token;
                    return config;
                });
            })
            .catch(function () {
                if(!$scope.isInform) {
                    $scope.current.loginMsgs.push(ALERT_MSGS.userProfile);
                }else{
                    sessionStorage.oas_token = previousToken;
                    $http.defaults.headers.common.Authorization = previousSession;
                    $scope.current.loginMsgs.push(ALERT_MSGS.invalidInformEntityType);
                }
            });
    }

    function randomString(len, charSet) {
        charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
        var randomString = '';
        for (var i = 0; i < len; i++) {
            var randomPoz = Math.floor(Math.random() * charSet.length);
            randomString += charSet.substring(randomPoz, randomPoz + 1);
        }
        return randomString;
    }

    function supportRedirect() {
        var r = document.location.href.match(/orionSupportRedirect=([^&#]+)/);
        if (r && sessionStorage.oas_token != undefined) {
            window.open("/api/v1/Integrations/Salesforce/OrionConnect/Action/CommunitySAML?relaystate=" + encodeURIComponent("?startURL=" + r[1]) + "&Authorization=" + sessionStorage.oas_token);
        }
    }

    //PUBLIC METHODS
    $scope.login = function () {
        if (!$scope.isInform) {
            localStorage.oas_username = $scope.current.username;
        }
        var headers = {Authorization: "Basic " + ($scope.current.username + ":" + $scope.current.password).encodeBase64()};
        if ($scope.current.rememberDevice) {
            headers.DeviceId = localStorage.oas_device_id;
        }

        $http.get('/security/token', {
            headers: headers,
            ignoreExceptions: true,
            ignoreAuthModule: true,
            tracker: 'login'
        })
            .then(function (response) {
                var twoFactorMethods = response.data.two_factor_opts;

                if (twoFactorMethods) {
                    twoFactorToken = response.data.access_token;

                    $scope.toggleTwoFactorPrompt();

                    $scope.twoFactorMethods = {
                        list: twoFactorMethods,
                        selected: twoFactorMethods.length ? twoFactorMethods[0].type : null
                    };
                } else {
                    assignToken(response.data.access_token);
                }
            })
            .catch(function (response) {
                //check for reset header (safari 8+ eats the custom status text)
                var statusText = response.headers().reset ? "password expired" : response.statusText.toLowerCase();

                if (statusText === "password expired") {
                    sessionReset.expiredPassword(response.headers("Reset"));
                } else {
                    var msg;
                    switch (response.status) {
                        case 401:
                            if (statusText == 'user inactive') {
                                msg = ALERT_MSGS.inactiveUser;
                            } else {
                                msg = ALERT_MSGS.invalidLogin;
                            }
                            break;
                        case 500:
                            msg = ALERT_MSGS.internalServer;
                            break;
                        default:
                            msg = ALERT_MSGS.unknownError;
                    }

                    $scope.current.loginMsgs.push(msg);
                    $scope.current.password = null;
                }
            });
    };

    $scope.close = function () {
        dialog.close();
    }

    $scope.sendTwoFactorCode = function () {
        var headers = {Authorization: "Session " + twoFactorToken};

        $http.post("/security/token/sendtwofactorcode?deliveryType=" + $scope.twoFactorMethods.selected, null, {
            headers: headers,
            ignoreExceptions: true,
            ignoreAuthModule: true,
            tracker: 'login'
        })
            .then(function () {
                $scope.current.mode = 'twoFactorCode';
            })
            .catch(function () {
                $scope.current.loginMsgs.push(ALERT_MSGS.unknownError);
            });
    };

    $scope.submitTwoFactorCode = function () {
        var headers = {Authorization: "2FA " + twoFactorToken + '|' + $scope.current.twoFactorCode};
        if ($scope.current.rememberDevice) {
            headers.DeviceId = localStorage.oas_device_id;
        }

        $http.get("/security/token", {
            headers: headers,
            ignoreExceptions: true,
            ignoreAuthModule: true,
            tracker: 'login'
        })
            .then(function (response) {
                assignToken(response.data.access_token);
            })
            .catch(function () {
                $scope.current.twoFactorCode = null;
                $scope.current.loginMsgs.push(ALERT_MSGS.invalidTwoFactorCode);
            });
    };

    $scope.deleteMsg = function (index) {
        $scope.current.loginMsgs.splice(index, 1);
    };

    $scope.toggleTwoFactorPrompt = function () {
        $scope.current.loginMsgs.length = 0;
        $scope.current.mode = 'twoFactorPrompt';
    };

    $scope.toggleForgotPassword = function () {
        $scope.current.loginMsgs.length = 0;
        $scope.current.password = null;
        $scope.current.mode = $scope.current.mode === 'login' ? 'forgot' : 'login';
    };


    //INITIALIZE
    $scope.loginTracker = promiseTracker('login');
    //$scope.secureAuthUrl = $sce.trustAsResourceUrl(API_CONFIG.secureAuthUrl);
    $scope.current = {
        username: localStorage.oas_username,
        password: "",
        rememberDevice: true,
        mode: 'login',
        loginMsgs: []
    };
    init();


    //CLEAN UP
    $scope.$on('$destroy', function () {
        if ($scope.secureAuthUrl) {  //de-register for messages from the SecureAuth iframe
            if (window.removeEventListener) {
                window.removeEventListener("message", messageReceiver, false);
            } else {
                window.detachEvent("onmessage", messageReceiver);
            }
        }
    });
});

'use strict';
app.controller('RepresentativeCoBrowseCtrl', function RepresentativeCoBrowsCtrl($scope, $http, $dialog, dialog, API_CONFIG, $sanitize) {
    //Init
    var tempToken = sessionStorage.oas_token;
    $scope.current = {
        selectedDatabase: {
            id: $scope.user.authorization.alClientId,
            clientName: $scope.user.authorization.alClientName,
        },
        searchInProgress: false,
        repOnLine: false,
        repOffLine: false
    };
    //scope level functions.
    $scope.searchProfiles = function (searchText) {
        return $http.get('/Security/Profiles/Search?search=' + searchText + '&Entity=4', { headers: { Authorization: 'Session ' + tempToken } })
            .then(function (response) {
                return response.data;
            });
    };
   
    $scope.profileFormatter = function (profile) {
        return !profile ? '' : (profile.entityId || profile.userId) + ': ' + $sanitize(profile.entityName) + ' (' + profile.loginUserId + ')';
    };
    
    $scope.cancel = function () {
        dialog.close();
    };
    $scope.onSelect = function ($item) {
        if ($item && $item.userGuid) {
            $scope.current.searchInProgress = true;
            $scope.cobrowseUserGuid = $item.userGuid;
            $http.get('/Integrations/SaleMove/Cobrowse/' + $item.userGuid + '/Online?siteId=' + $scope.siteId,
                { headers: { Authorization: "Session " + tempToken }, trackerMsg: 'Checking cobrowse status' })
                .then(function (response) {
                    $scope.current.repOnLine = response.data;
                    $scope.current.repOffLine = (!response.data);
                    $scope.current.searchInProgress = false;
                    if (response.data) {
                        $scope.cobrowseUrl = API_CONFIG.baseUrl + "/Integrations/SaleMove/Cobrowse/" + $scope.cobrowseUserGuid + "/Launch?siteId=" + $scope.siteId + "&Authorization=" + tempToken;
                    }
                });
        }
        else {
            $dialog.actionFailed('Unable to get this users GUID. Please contact support.').open();
        }
    };

    $scope.refreshUserOnline = function () {
        $http.get('/Integrations/SaleMove/Cobrowse/' + $scope.cobrowseUserGuid + '/Online?siteId=' + $scope.siteId,
            { headers: { Authorization: "Session " + tempToken }, trackerMsg: 'Checking cobrowse status' })
            .then(function (response) {
                $scope.current.repOnLine = response.data;
                $scope.current.repOffLine = (!response.data);
                $scope.current.searchInProgress = false;
                if (response.data) {
                    $scope.cobrowseUrl = API_CONFIG.baseUrl + '/Integrations/SaleMove/Cobrowse/' + $scope.cobrowseUserGuid + '/Launch?siteId=' + $scope.siteId + '&Authorization=' + tempToken;
                }
            });
    };
    function getSiteId() {
        $http.get('/Integrations/SaleMove/Cobrowse/SiteId?hostName=' + window.location.hostname, { headers: { Authorization: 'Session ' + tempToken }, trackerMsg: 'Getting Site Id' })
            .then(function (response) {
                if (response && response.data) {
                    $scope.siteId = response.data;
                } else {
                    $dialog.actionFailed("Unable to get Site ID. Please contact support.").open();
                }
            });
    }
    function init() {
        getSiteId();
    }
    init();
});

'use strict';

app.controller('ProfileCtrl', function ProfileCtrl($scope, $http, $q, $dialog, dialog, $oasRights, $route, mainMenuData, userOptionService, sessionReset, ssoTypes, entities, privilegeService, splitIoService) {
    //PRIVATE VARIABLES
    const forcedPrompt = dialog.options.promptForTwoFactor;
    const defaultTab = dialog.options.tab ? dialog.options.tab.toLocaleLowerCase() : '';
    let originalDefaultApp;
    let originalAccessibilityEnabled;
    let profileClosed = false;


    //PRIVATE METHODS
    function init() {
        $http.get('/Settings/Apps', { trackerMsg: 'Loading apps', allowCancellation: false  })
            .then(function (response) {
                $scope.apps = {
                    list: response.data.findAll(function (app) {
                        return app.ssoType === ssoTypes.none.name || app.appCode === "socialPlatform" || (app.appCode === "repPortal" && $scope.user.authorization.entity === entities.representative.name);
                    }).sortBy("name")
                };

                originalDefaultApp = $scope.apps.selected = mainMenuData.menu.defaultApp ? $scope.apps.list.find({ appCode: mainMenuData.menu.defaultApp.appCode }) : null;
                originalAccessibilityEnabled = $scope.apps.accessibilityEnabled = mainMenuData.menu.accessibilityEnabled ? 1 : 0;

            });

        $http.get("/Authorization/User/Verbose?expand=portfolio&expand=personal", { trackerMsg: 'Loading profile information', allowCancellation: false  })
            .then(function (response) {
                $scope.verboseUser = response.data;

                if ($scope.user.authorization.twoFactorRequired) {
                    $scope.verboseUser.portfolio.twoFactor = true;
                }
            });

        if ($scope.user.authorization.twoFactorRequired) {
            $http.get("/Settings/EntityOptions/Database/Code/69MESSAGER", { cache: true, trackerMsg: 'Loading two factor message', allowCancellation: false  })
                .then(function (response) {
                    $scope.current.twoFactorMsg = response.data[0].value;
                });
        }

        if ($scope.user.authorization.entity === entities.representative.name) {
            const subscription = splitIoService.getBoolTreatment('OC_DataPackageOptInOut_SMaC_18321').subscribe(function (isEnabled) {
                if (!isEnabled || profileClosed) {
                    return;
                }

                $http.get('/Authorization/User/OipDataSharing', { trackerMsg: 'Loading OIP rep data sharing', allowCancellation: false, ignoreExceptions: true })
                    .then(function (response) {
                        if (profileClosed || !response || !response.data) {
                            return;
                        }

                        $scope.repDataSharing = response.data;
                        $scope.repDataSharing.optedOut = !response.data.optedIn;
                        $scope.repDataSharingOriginalOptedOut = !response.data.optedIn;
                        $scope.current.showRepDataSharing = true;
                    })
                    .catch(function () {
                        // Leave the profile unchanged when the sharing choice cannot be loaded.
                    });
            });

            $scope.$on('$destroy', function () {
                profileClosed = true;
                if (subscription && subscription.unsubscribe) {
                    subscription.unsubscribe();
                }
            });
        }
    }


    //PUBLIC METHODS
    $scope.save = function () {
        if ($scope.emailInvalid) {
            $dialog.messageBox("Please use a valid email.").open();
            return;
        }

        userOptionService.save('oas_profile', $scope.user.profile);

        const saves = [
            $http.put("/Authorization/User/Verbose", $scope.verboseUser, { trackerMsg: 'Saving profile information' })
        ];

        if ($scope.current.showRepDataSharing
            && $scope.repDataSharing
            && $scope.repDataSharing.optedOut !== $scope.repDataSharingOriginalOptedOut) {
            saves.push($http.put('/Authorization/User/OipDataSharing', { optedIn: !$scope.repDataSharing.optedOut }, { trackerMsg: 'Saving OIP rep data sharing' }));
        }

        $q.all(saves)
            .then(function () {
                if (forcedPrompt) {
                    $dialog.messageBox("Please Reauthenticate", "Thank you for enabling two-factor authentication.  You will now be redirected to the login page.").open()
                        .then(function () {
                            sessionReset.logout();
                        });
                }
                dialog.close($scope.verboseUser);
            });

        if ($scope.apps.selected !== originalDefaultApp || $scope.apps.accessibilityEnabled !== originalAccessibilityEnabled) {
            mainMenuData.menu.defaultApp = $scope.apps.selected;
            mainMenuData.menu.accessibilityEnabled = $scope.apps.accessibilityEnabled === 1 ? true : false;
            mainMenuData.save();
        }

    };

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.invalidEmail = function (invalid) {
        $scope.emailInvalid = invalid;
    };

    $scope.setEmail = function (value) {
        $scope.verboseUser.personal.email = value;
    };

    $scope.resetPrivilegeCache = () =>
    {
        privilegeService.refreshAll().then((response) => {
            $dialog.confirmAction("Your privileges have been updated. Would you like to refresh the page now to apply these changes?")
                .open()
                .then(function (result) {
                    if (result == 'yes') {
                        // Hard refresh to get $oasRights to update
                        window.location.reload();
                    }
                });
        });
    }


    //INITIALIZE
    $scope.current = {
        showInsight: $oasRights.canRead("INSIGHTBUILDERAPP"),
        showPortfolioAudit: $oasRights.canRead("PORTFOLIOLISTSAPP"),       
        showHouseholdOverview: $oasRights.canRead("HOUSEHOLDOVERVIEW"),
        promptForTwoFactor: forcedPrompt,
        showRepDataSharing: false,
        tabs: {preferences: (!forcedPrompt || defaultTab === 'preferences'), authentication: (forcedPrompt || defaultTab === 'authentication')}
    };

    init();
});

'use strict';

app.controller('InputBoxCtrl', function InputBoxCtrl($scope, $http, dialog) {
    // PUBLIC METHODS
    $scope.submit = function () {
        switch ($scope.current.inputType) {
            case "date":
                dialog.close($scope.current.inputValue.formatted());
                break;
            case "dateRange":
                dialog.close({startDate: $scope.current.inputValue.formatted(), endDate: $scope.current.inputValue2.formatted()});
                break;
            case "compare":
                if (dialog.options.compareUrl) {
                    $http.post(dialog.options.compareUrl.assign($scope.current.inputValue), null, {trackerMsg: 'Validating value'})
                        .then(function (response) {
                            if (response.data.isValid) {
                                dialog.close($scope.current.inputValue);
                            } else {
                                $scope.errors.push("Incorrect value entered");
                            }
                        });
                } else {
                    if ($scope.current.inputValue === dialog.options.compareValue) {
                        dialog.close($scope.current.inputValue);
                    } else {
                        $scope.errors.push("Incorrect value entered");
                    }
                }
                break;
            case "findReplace":
                dialog.close({findString: $scope.current.findString, replaceString: $scope.current.replaceString});
                break;
            case "checkList":
                dialog.close({selected: $scope.current.checkList.findAll({isChecked: true})});
                break;
            default:
                dialog.close($scope.current.inputValue);
        }
    };

    $scope.submitBySearch = function (value) {
        dialog.close(value);
    };

    $scope.cancel = function () {
        (dialog.options.required)? dialog.close() : dialog.close(false); //if required is false then return false on cancel.
    };


    // INITIALIZE
    $scope.errors = [];
    $scope.current = dialog.options || {};
    $scope.current.inputType = dialog.options.availableList ? 'select' : dialog.options.inputType || "text";

    if (dialog.options.inputType === "file") {
        $scope.$watch('current.inputValue', function (newValue, oldValue) {
            if (newValue === oldValue || !newValue) return;

            dialog.close($scope.current.inputValue);
        });

        $scope.$watch('current.inputStatus', function (newValue, oldValue) {
            if (newValue === oldValue || !newValue) return;

            if (!$scope.current.inputValue) {
                dialog.close($scope.current.inputStatus);
            }
        });
    }
});
'use strict';

app.controller('SearchCtrl', function SearchCtrl($scope, dialog, $http, entities) {
    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close();
    };

    $scope.close = function () {
        var dateRange = $scope.dateRange ? {
            startDate: $scope.dateRange.startDate.formatted(),
            endDate: $scope.dateRange.endDate.formatted()
        } : null;

        const item = {
            entity: $scope.current.pane.value,
            item: $scope.current.selectedItem,
            dateRange: dateRange
        };

        if ( dialog.options.validate){
           $scope.current.errorMessage =  dialog.options.validate( item);
        }

        if ( $scope.current.errorMessage )
            return;

        dialog.close(item);
    };

    $scope.btnDisabled = function () {
        if ($scope.dateRange) {
            return !$scope.dateRange.startDate || !$scope.dateRange.endDate;
        } else {
            return !$scope.current.selectedItem || $scope.current.errorMessage;
        }
    };

    if (dialog.options.dateRange === true) {
        dialog.options.dateRange = {
            startDate: Date.create('yesterday'),
            endDate: Date.create('today')
        }
    }

    Object.defineProperty($scope, 'dateRange', {
        get: function(){
            return angular.isArray(dialog.options.dateRange.excludedEntities) && dialog.options.dateRange.excludedEntities.find($scope.current.pane.value)
                ? undefined
                : dialog.options.dateRange;
        }
    });


    //INITIALIZE

    $scope.panes = dialog.options.panes.map(function (entityValue) {
        return {name: entities[entities.find({value: entityValue})].name.replace(/\s/g, '').titleize(), value: entityValue, active: dialog.options.defaultPane == entityValue};
    });

    $scope.current = {
        pane: $scope.panes.find({active: true}),
        selectedItem: null,
        title: dialog.options.title || 'Find',
        errorMessage: null
    };
});

'use strict';

app.controller('MassUpdateCtrl', function MassUpdateCtrl($scope, dialog, $http, entities, $dialog, $oasRights, apps, args, $q, Repo, ConfirmationOverview, Entity, CorporateAction, splitIoService) {

    // PRIVATE VARIABLES
    const LOG_LEVEL = {
        LOG: 'log',
        DEBUG: 'debug',
        INFO: 'info',
        WARN: 'warn',
        ERROR: 'error'
    };

    var get = false,
        getURL = '',
        put = false,
        putURL = '',
        ret = false,
        retURL = '';

    var params = {};
    var validation = [];

    var usingVerbose = true;

    // PRIVATE METHODS
    function init() {
        switch ($scope.current.entity) {
            case entities.client.value:
                initForClient();
                break;
            case entities.registration.value:
                initForRegistration();
                break;
            case entities.account.value:
                initForAccount();
                break;
            case entities.asset.value:
                initForAsset();
                break;
            case entities.transaction.value:
                initForTransaction();
                break;
            case entities.downloadName.value:
                initForDownload(entities.downloadName.name, "DownloadNameDetailDto");
                break;
            case entities.downloadBeneficiary.value:
                initForDownload(entities.downloadBeneficiary.name, "DownloadBeneficiaryDetailDto");
                break;
            case entities.downloadPosition.value:
                initForDownload(entities.downloadPosition.name, "DownloadPositionDetailDto");
                break;
            case entities.downloadTransaction.value:
                initForDownload(entities.downloadTransaction.name, "DownloadTransactionDetailDto");
                break;
            case entities.downloadPrice.value:
                initForDownload(entities.downloadPrice.name, "DownloadPriceDetailDto");
                break;
            case entities.downloadCostBasis.value:
                initForDownload(entities.downloadCostBasis.name, "DownloadCostBasisDetailDto");
                break;
            case entities.downloadDividend.value:
                initForDownload(entities.downloadDividend.name, "DownloadDividendDetailDto");
                break;
            case entities.downloadCorpAction.value:
                initForDownload(entities.downloadCorpAction.name, "DownloadCorporateActionDetailDto");
                break;
            case entities.downloadSecurity.value:
                initForDownload(entities.downloadSecurity.name, "DownloadSecurityDetailDto");
                break;
            case entities.downloadBanking.value:
                initForDownload(entities.downloadBanking.name, "DownloadBankingDetailDto");
                break;
            case entities.downloadRMD.value:
                initForDownload(entities.downloadRMD.name, "DownloadRMDDetailDto");
                break;
            case entities.downloadSystematic.value:
                initForDownload(entities.downloadSystematic.name, "DownloadSystematicDetailDto");
                break;
            case entities.downloadGeneric.value:
                initForDownload(entities.downloadGeneric.name, "DownloadGenericDetailDto");
                break;
            case entities.product.value:
                if (args.extraInfo.isGlobalProductUpdate) {
                    initForProductGlobal();
                } else {
                    initForProductLocal();
                }
                break;
            //case entities.corporateAction.value:
            case entities.corporateActionTransaction.value:
                initCorporateActionTransactionsV2();
                break;
        }

        $scope.current.title += $scope.current.friendlyName + 's (' + $scope.current.ids.length + ' Selected)';
        if ($scope.current.entity === entities.client.value) {
            $scope.isSplitRepPaymentsMassUpdateEnabled = false;
            $http.get('/Settings/Database/EntityOptions/Code/RepPayoutPercent').then(function (response) {
                var repPayoutPercentEnabled = response.data && response.data.value === 'True';
                splitIoService.getBoolTreatment('opex_Rep_Split_5809').subscribe(function (isEnabled) {
                    $scope.isSplitRepPaymentsMassUpdateEnabled = repPayoutPercentEnabled && isEnabled;
                });
            });
        }

        $scope.loadAvailableFields();
    }

    // TYPE INITIALIZATIONS

    function initForClient() {
        $scope.rights = $oasRights.forCode("CLIENTS");
        $scope.current.friendlyName = entities.client.name;

        putURL = '/Portfolio/Clients/Verbose/';
        getURL = '/Portfolio/Clients/Verbose/List/Id';

        $scope.categories.push({friendlyName: 'Portfolio', verboseProperty: 'portfolio', code: 'portfolio', dto: "ClientDto"});
        $scope.categories.push({friendlyName: 'Billing', verboseProperty: 'billing', code: 'billing', dto: "BillClientDto"});
        $scope.categories.push({friendlyName: 'Custom Fields', verboseProperty: 'userDefinedFields', code: 'userDefinedFields', dto: "ClientDto"});

        if ($scope.current.app == apps.portfolioLists.name) {
            $scope.selectedCategory = $scope.categories[0];
            retURL = '/Portfolio/Clients/List/Id';
        } else if ($scope.current.app == apps.billingAudit.name || $scope.current.app == apps.billing.code) {
            $scope.selectedCategory = $scope.categories[1];
            retURL = '/Billing/Clients/List/Id';
        }
    }

    function initForRegistration() {
        $scope.rights = $oasRights.forCode("REGISTRATIONS");
        $scope.current.friendlyName = entities.registration.name;

        $scope.categories.push({friendlyName: 'Portfolio', verboseProperty: 'portfolio', code: 'portfolio', dto: "RegistrationDto"});
        $scope.categories.push({friendlyName: 'Suitability', verboseProperty: 'suitability', code: 'suitability', dto: "RegistrationDto", fields: ["investmentObjective", "returnObjective", "stockPercent", "timeHorizon"]});
        $scope.categories.push({friendlyName: 'Custom Fields', verboseProperty: 'userDefinedFields', code: 'userDefinedFields', dto: "RegistrationDto"});

        putURL = '/Portfolio/Registrations/Verbose/';
        getURL = '/Portfolio/Registrations/Verbose/List/Id';

        if ($scope.current.app == apps.portfolioLists.name) {
            $scope.selectedCategory = $scope.categories[0];
            retURL = '/Portfolio/Registrations/List/Id';
        }
    }

    function initForAccount() {
        $scope.rights = $oasRights.forCode("ACCOUNTS");
        $scope.current.friendlyName = entities.account.name;

        $scope.categories.push({friendlyName: 'Portfolio', verboseProperty: 'portfolio', code: 'portfolio', dto: "AccountDto"});
        $scope.categories.push({friendlyName: 'Compliance', verboseProperty: 'compliance', code: 'compliance', dto: "AccountDto", fields: ["advCustodyTypeId","isAdvReportable", "isAuaReportable", "isDiscretionary", "isWrapManaged", "isWrapSponsored", "is13FReportable"]});
        $scope.categories.push({friendlyName: 'Billing', verboseProperty: 'billing', code: 'billing', dto: "BillAccountDto"});
        $scope.categories.push({friendlyName: 'Recurring Adjustment', verboseProperty: 'recurringAdjustments', code: 'recurringAdjustments', dto: "BillRecurrentAdjustmentDto"});
        $scope.categories.push({friendlyName: 'Modeling', verboseProperty: 'modelingInfo', code: 'modelingInfo', dto: "AccountModelingInfoDto", fields: ["modelGroupNumber", "tradingInstructions", "isTradingBlocked", "aggregateModel"]});
        $scope.categories.push({friendlyName: 'Custom Fields', verboseProperty: 'userDefinedFields', code: 'userDefinedFields', dto: "AccountDto"});

        putURL = '/Portfolio/Accounts/Verbose/';
        getURL = '/Portfolio/Accounts/Verbose/List/Id';

        if ($scope.current.app == apps.portfolioLists.name) {
            $scope.selectedCategory = $scope.categories[0];
            retURL = '/Portfolio/Accounts/List/Id';
        } else if ($scope.current.app == apps.billingAudit.name) {
            $scope.selectedCategory = $scope.categories[1];
            retURL = '/Billing/Accounts/List/Id';
        } else if ($scope.current.app == apps.billing.code) {
            $scope.selectedCategory = $scope.categories[2];
            retURL = '/Billing/Accounts/List/AccountIds';
        } else if ($scope.current.app == apps.newAccount.name) {
            $scope.selectedCategory = $scope.categories[0];
            retURL = '/Portfolio/Accounts/NewPortfolio/List/Id';
        }

        validation.push(
            function(){
                const log = {
                    type: LOG_LEVEL.WARN,
                    message: "This will update the Model Aggregate for all Accounts selected.  Any sleeved Account will update the Model Aggregate assigned to the Sleeve, which will maintain any Performance information on that Sleeved Account."
                };

                const hasModelInfoChangesForSleevedAccount = $scope.changes.any(function(c) {
                    return c.apiName === 'aggregateModel' && c.verboseProperty === 'modelingInfo' && c.value !== null;
                });

                // model agg changes that include a sleeved account should confirm the changes with the user
                if (hasModelInfoChangesForSleevedAccount && $scope.current.items.any(a => a.modelingInfo.isSleeveAccount)) {
                   return log;
                }
            }
        );
    }

    function initForAsset() {
        $scope.rights = $oasRights.forCode("ASSETS");
        $scope.current.friendlyName = entities.asset.name;

        $scope.categories.push({friendlyName: 'Portfolio', verboseProperty: 'portfolio', code: 'portfolio', dto: "AssetDto"});
        splitIoService.getBoolTreatment('opex_Margin_Billing_18617')
            .subscribe((isEnabled) => {
                if (isEnabled) {
                    $scope.categories.push({friendlyName: 'Billing', verboseProperty: 'billing', code: 'billing', dto: "BillAssetDto", fields: ["excludeAmount", "excludeEndDate", "isFeeExcluded", "excludeStartDate", "isPayingFee", 'excludeFromMargin']});
                } else {
                    $scope.categories.push({friendlyName: 'Billing', verboseProperty: 'billing', code: 'billing', dto: "BillAssetDto", fields: ["excludeAmount", "excludeEndDate", "isFeeExcluded", "excludeStartDate", "isPayingFee"]});
                }
            });

        putURL = '/Portfolio/Assets/Verbose/';
        getURL = '/Portfolio/Assets/Verbose/List/Id';

        if ($scope.current.app == apps.portfolioLists.name) {
            $scope.selectedCategory = $scope.categories[0];
            retURL = '/Portfolio/Assets/List/Id';
        } else if ($scope.current.app == apps.billingAudit.name) {
            $scope.selectedCategory = $scope.categories[1];
            retURL = '/Billing/Assets/List/Id';
        }
    }

    function initForTransaction() {
        $scope.rights = $oasRights.forCode("TRANSACTIONS");
        $scope.rightsTransactionSuppression = $oasRights.forCode('TRANSACTIONTYPESUPPRESSION');
        $scope.current.friendlyName = entities.transaction.name;
        $scope.rightsManuallyManaged = {canAdd: false, canDelete: false, canRead: false, canUpdate: false}

        if (args.extraInfo && args.extraInfo.isManuallyManaged){
            $scope.rightsManuallyManaged = $oasRights.forCode('MANUALLYMANAGED');
            if ($scope.rightsManuallyManaged.canUpdate) $scope.rights.canUpdate = true;
        }
        $scope.categories.push({friendlyName: 'Portfolio', verboseProperty: 'portfolio', code: 'portfolio', dto: "PortfolioTransactionDto"});
        $scope.categories.push({friendlyName: 'Billing', verboseProperty: 'billing', code: 'billing', dto: "BillTransactionDto"});
        $scope.categories.push({friendlyName: 'Additional Information', verboseProperty: 'additionalInformation', code: 'additionalInformation', dto: "PortfolioTransactionAdditionalInformationDto"});

        putURL = '/Portfolio/Transactions/Verbose/';
        getURL = '/Portfolio/Transactions/Verbose/List/Id';

        if ($scope.current.app == apps.portfolioLists.name) {
            $scope.selectedCategory = $scope.categories[0];
            retURL = '/Portfolio/Transactions/List/Id';
        } else if ($scope.current.app == apps.billingAudit.name || $scope.current.app == apps.billing.code) {
            $scope.selectedCategory = $scope.categories[1];
            retURL = '/Billing/Transactions/List/Id';
        }

    }

    function initForDownload(friendlyName, dto) {
        $scope.rights = $oasRights.forCode("CONFIRM_CONFIRMMANAG");
        $scope.current.friendlyName = friendlyName;
        usingVerbose = false;

        $scope.categories.push({friendlyName: 'Download', verboseProperty: null, code: 'download', dto: dto});

        $scope.selectedCategory = $scope.categories[0];

        put = ConfirmationOverview.files.saveDetailed;
        get = ConfirmationOverview.files.getDetailedList;
        ret = ConfirmationOverview.files.getDetailedList;

        params = {
            downloadType: args.extraInfo.downloadType
        };
    }

    function initForProductGlobal() {
        $scope.rights = $oasRights.forCode("GLOBALPRODUCT");
        $scope.current.friendlyName = entities.product.name;

        putURL = '/Global/Products/Verbose/';
        getURL = '/Global/Products/Verbose/List/Id';

        $scope.categories.push({friendlyName: 'Portfolio', verboseProperty: 'portfolio', code: 'portfolio', dto: "GlobalProductDto"});

        if ($scope.current.app == apps.productsAndPrices.name) {
            $scope.selectedCategory = $scope.categories[0];
            retURL = '/Global/Products/List/Id';
        }

        validation.push(
            function(){
                var log = {
                    type: LOG_LEVEL.WARN,
                    message: "You are about to update the product type to Bond or CD.  The Orion platform automatically adjusts " +
                        "prices for these product types.  If you are positive this is the appropriate product type, you may commit " +
                        "your change.  However, if you are unsure this is the appropriate product type, please click Cancel and " +
                        "consult the Orion Products & Prices team."
                };

                if (
                    $scope.changes.any(function(c){
                        return c.apiName === 'productType' && c.verboseProperty === 'portfolio' && ['Bond', 'CD'].any(c.value);
                    })
                ) {
                    var items = $scope.current.items.filter(function(p){return !['Bond', 'CD'].any(p.productType); });
                    return $http.get('/Global/Products/Prices?$top=1&minPrice=2&minPriceInclusive=false&productId=' + items.map('id').join('&productId='), {trackerMsg: 'Testing product type changes'})
                        .then(function(response){
                            return response.data.length ? log : undefined;
                        });
                }
            }
        );
    }

    function initForProductLocal() {
        $scope.rights = $oasRights.forCode("PRODUCTS");
        $scope.current.friendlyName = entities.product.name;

        putURL = '/Portfolio/Products/Verbose/';
        getURL = '/Portfolio/Products/Verbose/List/Id';

        $scope.categories.push({friendlyName: 'Portfolio', verboseProperty: 'portfolio', code: 'portfolio', dto: "LocalProductExtDto"});
        $scope.categories.push({friendlyName: 'Billing', verboseProperty: 'billing', code: 'billing', dto: "BillProductDto"});
 
        if ($scope.current.app == apps.productsAndPrices.name) {
            $scope.selectedCategory = $scope.categories[0];
            retURL = '/Portfolio/Products/List/Id';
        }

        validation.push(
            function(){
                var log = {
                    type: LOG_LEVEL.WARN,
                    message: "You are about to update the product type to Bond or CD.  The Orion platform automatically adjusts " +
                            "prices for these product types.  If you are positive this is the appropriate product type, you may commit " +
                            "your change.  However, if you are unsure this is the appropriate product type, please click Cancel and " +
                            "consult the Orion Products & Prices team."
                };

                if (
                    $scope.changes.any(function(c){
                        return c.apiName === 'productType' && c.verboseProperty === 'portfolio' && ['Bond', 'CD'].any(c.value);
                    })
                ) {
                    var items = $scope.current.items.filter(function(p){return !['Bond', 'CD'].any(p.productType); });
                    return $http.get('/Global/Products/Prices?$top=1&minPrice=2&minPriceInclusive=false&productId=' + items.map('id').join('&productId='), {trackerMsg: 'Testing product type changes'})
                        .then(function(response){
                            return response.data.length ? log : undefined;
                        });
                }
            }
        );
    }

    function initCorporateActionTransactionsV2() {
        $scope.rights = $oasRights.forCode("CORPACTION");
        $scope.current.friendlyName = entities.corporateActionTransaction.name;
        usingVerbose = false;
        $scope.categories.push({
            friendlyName: 'Transaction',
            verboseProperty: null,
            code: 'transaction',
            dto: 'CorpActionTransactionV2Dto'
        });
        $scope.selectedCategory = $scope.categories[0];
        put = CorporateAction.transaction.massUpdate.put;
        get = CorporateAction.transaction.massUpdate.get;
        ret = CorporateAction.transaction.massUpdate.get;

    }

    // HELPERS

    function changeExists() {
        var found = false;
        for (var i = 0; i < $scope.changes.length; i++) {
            if ($scope.selectedField.apiName == $scope.changes[i].apiName) {
                found = true;
            }
        }

        if (found) {
            $scope.errors.push({type: 'error', title: 'Change Exists! ', msg: ' Change has already been added.'});
        }

        return found;
    }


    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close(null);
    };

    $scope.process = function () {
        return $dialog.confirmAction("Are you sure you want to process the updates?").open()
            .then(function (result) {
                if (result === 'yes') {
                    return $scope.getItems()
                        .then($scope.validateItems).then(function(isValid){
                            if(isValid) {
                                return $scope.putItems()
                                    .then($scope.returnItems);
                            }
                        });
                }
            });
    };

    $scope.putItems = function() {
        $scope.applyChanges();
        if(!put) return $http.put(putURL, $scope.current.items, {trackerMsg: 'Saving ' + $scope.current.friendlyName + 's'});
        else return Repo.merge(put.multi(
            $scope.current.items.groupBy('__database__'),
            function(database, items) {
                return {
                    database: database,
                    data: items,
                    params: angular.copy(params)
                }
            }
        ));
    };

    $scope.returnItems = function() {
        return $q.resolve(
            !ret
                ? $http.post(retURL, $scope.current.ids, {trackerMsg: 'Refreshing ' + $scope.current.friendlyName + 's'})
                : Repo.merge(ret.multi(
                    $scope.current.items.groupBy('__database__'),
                    function(database, items) {
                        return {
                            database: database,
                            data: items.map('id'),
                            params: angular.copy(params)
                        }
                    }
                ))
        ).then(function(response){
            return dialog.close(response.data);
        });
    };

    $scope.validateItems = function() {
        return $q.all(
            validation
                .map(function(v){return v instanceof Function ? v() : v; })
        ).then(function(log){
            var filtered = log.filter(l=>[LOG_LEVEL.WARN].any((l||{}).type));
            return filtered.length === 0 || $dialog.messageBox(
                "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Confirm Action",
                filtered.map('message').join(),
                [{result:'confirm', label: 'Confirm', cssClass: 'btn-primary'}, {result:'cancel', label: 'Cancel'}]
            ).open()
                .then(function (result) {
                    return result === 'confirm';
                });
        });
    };

    $scope.getItems = function() {
        if($scope.current.loaded) {
            return $q.resolve($scope.current.items);
        } else {
            if (usingVerbose) params.expand = $scope.changes.map("verboseProperty").unique();
            return $q.resolve(
                get
                    ? Repo.merge(get.multi(
                        $scope.current.items.groupBy('__database__'),
                        function(database, items) {
                            return {
                                database: database,
                                data: items.map('id'),
                                params: angular.copy(params)
                            }
                        }
                    ))
                    : $http.post(getURL, $scope.current.ids, {params: angular.copy(params), trackerMsg: 'Looking up ' + $scope.current.friendlyName + 's'})
            ).then(function (response) {
                $scope.current.items = response.data;
                $scope.current.loaded = true;
                return $scope.current.items
            });
        }

    };

    $scope.applyChanges = function() {
        $scope.changes.forEach(function(change) {
            $scope.current.items.forEach(function(item) {
                if (usingVerbose && item[change.verboseProperty]) {
                    if (change.verboseProperty == 'userDefinedFields') {
                        var udf = item.userDefinedFields.find(function (f) {
                            return f.code.toLowerCase() === change.apiName.toLowerCase();
                        });
                        if (udf) udf.value = change.value;
                    }
                    else if (change.verboseProperty === 'recurringAdjustments'){
                        item[change.verboseProperty].forEach(function(rec){
                           rec[change.apiName] = change.value;
                        });
                    }
                    else {
                        item[change.verboseProperty][change.apiName] = change.value;
                        if (change.verboseProperty === 'billing'
                            && (change.apiName === 'feeExcluded' || change.apiName === 'isFeeExcluded')) {
                            var billing = item.billing;
                            billing.feeBillExclusionMode = change.value ? 1 : 0;
                            billing.excludedBillEntityIds = [];
                        }
                    }
                } else if (!usingVerbose) item[change.apiName] = change.value;
            });
        });
        return $scope.current.items;
    };

    $scope.addChange = function () {
        var allowAdd = !changeExists();

        if ($scope.selectedField.controlType == 'OasSearchRep') {
            if ($scope.current.selectedRep == null) {
                allowAdd = false;
            } else {
                $scope.selectedField.value = $scope.current.selectedRep.id;
                $scope.selectedField.detail = $scope.current.selectedRep.name;
            }
        } else if ($scope.selectedField.controlType === 'OasSearchModelAgg') {
            if (!$scope.current.aggregateModel) {
                allowAdd = false;
            } else {
                $scope.selectedField.value = $scope.current.aggregateModel;
                $scope.selectedField.detail = $scope.current.aggregateModel.name;
            }
        } else if ($scope.selectedField.controlType == 'OasDropDown') {
            if ($scope.current.selectedName.length > 0 || $scope.current.selectedId.length > 0) {
                $scope.selectedField.value = $scope.current.selectedId;
                $scope.selectedField.detail = $scope.current.selectedName;

                if ($scope.current.selectedId.length > 0 && $scope.current.selectedName.length == 0) { // enum hack
                    $scope.selectedField.detail = $scope.current.selectedId;
                }
            } else {
                allowAdd = false;
            }
        } else {
            $scope.selectedField.detail = $scope.selectedField.value;
        }

        if (allowAdd) {
            var newChange = angular.copy($scope.selectedField);
            if ($scope.isSplitRepPaymentsMassUpdateEnabled && newChange.controlType === 'OasSearchRep') {
                newChange.showSplitRepMassUpdateWarning = true;
            }
            $scope.changes.push(newChange);
            $scope.current.selectedId = 0;
            $scope.current.selectedName = '';
        }
    };

    $scope.removeChange = function (change) {
        $scope.changes.remove(change);
    };

    $scope.loadAvailableFields = function () {
        $scope.selectedField = null;
        $scope.availableFields = [];

        var whiteList = $scope.selectedCategory.fields;
        var blackList = $scope.categories.exclude($scope.selectedCategory).map('fields').flatten().compact();
        if ($scope.selectedCategory.dto == 'AccountDto') blackList.push('isQualified');

        $http.get('/Settings/Views/' + $scope.selectedCategory.dto, {trackerMsg: 'Looking up ' + $scope.current.friendlyName.toLowerCase() + ' definition'})
            .then(function (response) {
                var data = response.data[0].slickGridColumnDefs;

                if ($oasRights.canUpdate("ACTIVESTATUS") && ["ClientDto", "RegistrationDto", "AccountDto", "AssetDto"].any($scope.selectedCategory.dto)) {
                    data.find({id: "IsActive"}).massEditor = "Slick.Editors.Checkbox";
                }

                var columnDefs = $scope.selectedCategory.code == 'userDefinedFields' ? data.findAll(function (u) {return u.field.first(3) == 'udf';}) : data.findAll(function (u) {return u.field.first(3) != 'udf';});

                columnDefs.forEach(function (col) {
                    if (!col.massEditor || (whiteList && whiteList.none(col.field)) || (blackList.any(col.field))) return;

                    var field = {
                        friendlyName: col.name.replace(' Id', '').replace(' ID', ''),
                        apiName: col.editorKeyField || (col.field.startsWith('udf') ? col.field.remove('udf') : col.field),
                        controlType: col.massEditor == 'Date' ? 'Slick.Editors.Date' : col.massEditor,
                        field: (col.editorKeyField || col.field).toLowerCase(),
                        value: '',
                        detail: '',
                        availableItems: [],
                        verboseProperty: $scope.selectedCategory.verboseProperty,
                        category: $scope.selectedCategory.friendlyName
                    };

                    switch (field.controlType) {
                        case 'Slick.Editors.Checkbox':
                            field.value = false;
                            break;
                        case 'Slick.Editors.Date':
                            field.value = Date.create('today');
                            break;
                        case 'Slick.Editors.Select':
                            field.availableItems = col.editorOptions.split(',');

                            if ($scope.current.entity == entities.downloadPosition.value) {
                                field.availableItems.remove("Confirmed");
                            }
                            break;
                    }

                    if ($scope.current.entity == entities.product.value && field.apiName == 'globalFundFamilyId') {
                        field.apiName = 'fundFamilyId';
                    }

                    $scope.availableFields.push(field);
                });
            });
    };


    //INITIALIZE
    $scope.current = {
        title: 'Edit Multiple ',
        friendlyName: '',
        entity: args.entity,
        items: args.items ? args.items : Entity.collection(args.ids),
        get ids() {return $scope.current.items.map('id');},
        loaded: !!args.items,
        app: args.app,
        selectedId: 0,
        selectedName: '',
        selectedRep: null,
        filterIds: '',
    };
    $scope.errors = [];
    $scope.changes = [];
    $scope.categories = [];

    init();

    //WATCHES

    $scope.$watch('selectedField', function(newValue, oldValue){
        if (newValue === oldValue) return;

        $scope.current.filterIds = "";

        if (newValue.field === "transtypeid"){
            if ($scope.rightsTransactionSuppression && $scope.rightsTransactionSuppression.canUpdate) {
                $scope.current.filterIds = "61,156,157";
            }
        }
    })
});

app.controller('AvailableSelectCtrl', function AvailableSelectCtrl($scope, $dialog, dialog, availableSelectedArgs) {
    //PUBLIC METHODS
    $scope.close = function(save) {
        dialog.close(save ? $scope.current.selectedSelected : null);
    };

    //INITIALIZE
    $scope.current = {
        selectionType: availableSelectedArgs.selectionType,
        selectedSelected: availableSelectedArgs.selectedSelected,
        sortable: availableSelectedArgs.sortable || false,
        availableItems: availableSelectedArgs.availableItems || [],
        maxSelect: availableSelectedArgs.maxSelect,
        disableSave: availableSelectedArgs.disableSave || false,
        excluded: availableSelectedArgs.excluded,
        id: availableSelectedArgs.id || undefined };

    //SCOPE WATCHERS
    $scope.$watch('current.selectedSelected', function (newValue, oldValue) {
        if (!newValue || newValue === oldValue) return;

        if ($scope.current.maxSelect){
            $scope.current.disableSave = (newValue.length > $scope.current.maxSelect);
        }

    }, true);


});

app.controller('PopupBlockerWarningCtrl', function PopupBlockerWarningCtrl($scope, dialog, popupBlockerWarningArgs) {
    //PUBLIC METHODS
    $scope.close = function(save) {
        dialog.close(save);
    };

    //INITIALIZE
    $scope.current = {
        url: popupBlockerWarningArgs.url,
        target: popupBlockerWarningArgs.target
    };
});
'use strict';
app.controller('LaserAppCtrl', function SettingsCtrl($scope, $http, $window, dialog, args) {

    //PRIVATE VARIABLES

    //PRIVATE METHODS
    function init() {
        isLaserAppConfigured()
            .then(function(canLoad){
                $scope.current.loadLaserApp = canLoad;
                if(canLoad)
                    loadLaserAppData();
            });
    }

    function isLaserAppConfigured() {
        return $http.get('/Integrations/LaserApp/Configuration/Test', {trackerMsg: 'Check for LaserApp integration', ignoreExceptions: true})
            .then(function(result){
                return (result.status >= 200 || result.status <= 299);
            });
    }

    function loadLaserAppData() {
        $http.get('/Integrations/LaserApp/Accounts/' + args.accountId + '/Forms?formType=' + args.formType, {trackerMsg: 'Loading distribution forms'})
            .then(function(response){
                response.data.each(function(formInfo){
                    formInfo.selected = formInfo.isRequired;
                });
                $scope.current.formsLibrary = response.data;
            });
    }

    //PUBLIC METHODS
    $scope.close = function() {
        dialog.close( null );
    };

    $scope.launchLaserApp = function(){
        var formSelection = angular.copy($scope.current.formsLibrary.findAll(function(form){ return form.selected === true; }));
        formSelection.each(function(form){ delete form.selected; });
        $http.post('/Integrations/LaserApp/Accounts/' + args.accountId + "/Submit", formSelection, {trackerMsg: 'Launching LaserApp'})
            .then(function(response){
                $window.open(response.headers("location"));
                dialog.close( null );
            });
    };

    $scope.isComplete = function(){
        var test = $scope.current.formsLibrary.length > 0;
        test = test && $scope.current.formsLibrary.any(function(form){ return form.selected === true; });
        return test;
    };

    //WATCHES

    //INITIALIZE
    $scope.current = { loadLaserApp: false, formsLibrary: [] };
    init();
});

'use strict';

app.controller('AdvancedSearchCtrl', function AdvancedSearchCtrl($scope, $q, $http, $dialog, dialog, $location, $portfolio, entities, tokenFactory, $oasRights) {
    //PRIVATE VARIABLES
    let allColumns;
    let searchSettings;
    const entityMap = {
        client: {
            userOption: 'advanced_search_client',
            url: '/Portfolio/Clients/Search/Advanced',
            dto: "ClientDto",
            defaultColumns: ["id", "lastName", "firstName", "representativeName", "representativeNumber", "representativeId"],
            getSimple: function (client) {return {id: client.id, name: client.lastName + ', ' + client.firstName, icon: "fa-orion-household"};}
        },
        registration: {
            userOption: 'advanced_search_registration',
            url: '/Portfolio/Registrations/Search/Advanced',
            dto: "RegistrationDto",
            defaultColumns: ["id", "lastName", "firstName", "name", "clientId"],
            getSimple: function (reg) {return {id: reg.id, name: reg.name + ', ' + reg.accountType, icon: "fa-orion-registration"};}
        },
        account: {
            userOption: 'advanced_search_account',
            url: '/Portfolio/Accounts/Search/Advanced',
            dto: "AccountDto",
            defaultColumns: ["id", "name", "number", "accountType", "fundFamily", "custodian", "currentValue"],
            getSimple: function (account) {return {id: account.id, number: account.number, name: account.name,registrationId: account.registrationId,  icon: "fa-orion-account"};}
        },
        allDatabases: {
            url: '/Utility/Search/AllDatabases',
            dto: "AllDatabaseSearchDto",
            defaultColumns: ["databaseName", "accountId", "acctCode", "accountType", "clientId", "householdFName", "householdLName", "householdSSN_TaxID", "isActive", "outsideId", "registrationFName", "registrationLName", "registrationId", "registrationSSN_TaxID", "repFName", "repLName"],
            getSimple: {
                client: function (client) {return {id: client.clientId, name: client.householdLName + ', ' + client.householdFName , alClientId : client.alClientId, icon: "fa-orion-household"};},
                registration: function (reg) {return {id: reg.registrationId, alClientId : reg.alClientId, icon: "fa-orion-registration"};},
                account: function (account) {return {id: account.accountId, alClientId: account.alClientId, icon: "fa-orion-account"};}
            }[dialog.options.entity.toLowerCase()]
        }
    }[dialog.options.isAllDatabases ? "allDatabases" : dialog.options.entity.toLowerCase()];


    //PRIVATE METHODS
    function init() {
        const promises = {dto: $http.get('/Settings/Views/' + entityMap.dto, {trackerMsg: 'Loading search settings'})};
        if (entityMap.userOption) {
            promises.userOption = $http.get('/Settings/UserOptions/' + entityMap.userOption, {trackerMsg: 'Loading search fields'});
        }

        $q.all(promises)
            .then(function (responses) {
                if (responses.userOption) {
                    searchSettings = responses.userOption.data;
                    searchSettings.value = JSON.parse(searchSettings.value) || {visibleColumns: []};
                } else {
                    searchSettings = {value: {visibleColumns: []}};
                }

                allColumns = responses.dto.data[0].slickGridColumnDefs.map(function (item) {
                    return {name: item.name, field: item.field};
                });

                setVisibleColumns();
            });
    }

    function setVisibleColumns() {
        const visibleColumns = searchSettings.value.visibleColumns.length ? searchSettings.value.visibleColumns : entityMap.defaultColumns;

        $scope.current.columnMap = visibleColumns.map(function (column) {
            return allColumns.find({field: column});
        });
    }

    function getSearchResults(getCountOnly) {
        const params = $scope.searchParams[$scope.current.entity];

        if (Object.any(params, function (k, v) {return !!v;})) {
            return $http.get(entityMap.url + (getCountOnly ? '/Count?' : '?$top=500&') + Object.toQueryString(params), getCountOnly ? null : {trackerMsg: 'Searching for results'})
                .then(function (response) {
                    return response.data;
                });
        } else {
            return $q.when(null);
        }
    }

    function formulateLaunchUrl(entityEnum, selectedItem, token){
        var urlPath = '';

        if ($scope.user.profile.search === 1 && $oasRights.canRead("HOUSEHOLDOVERVIEW") && $oasRights.canRead(entityEnum.securityCode)) {
            urlPath = '/portfolio/household/overview?entity=' + entityEnum.value + '&entityId=' + selectedItem.id;
        } else if ($scope.user.profile.search === 2 && $oasRights.canRead("INSIGHTBUILDERAPP")) {
            urlPath = '/portfolio/insight?entityEnum=' + entityEnum.value + '&entityId=' + selectedItem.id;
        } else if ($scope.user.profile.search === 3){
            urlPath = '/orion/dashboard?entity=' + entityEnum.value + '&entityId=' + selectedItem.id;
        }
        else {
            urlPath = "/portfolio/households?entity=" + entityEnum.value + "&entityId=" + selectedItem.id;
        }

        return window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html?t=" + token + "&p=" + encodeURIComponent(urlPath);
    }

    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close();
    };

    $scope.search = function () {
        $scope.searchResults = null;

        getSearchResults(false)
            .then(function (data) {
                $scope.searchResults = data;
            });
    };

    $scope.editColumns = function () {
        const args = {
            selectionType: 1979, //Custom
            availableItems: allColumns.clone(),
            selectedSelected: $scope.current.columnMap.clone(),
            sortable: true,
            id: "field"
        };

        $dialog.dialog({templateUrl: "app/modals/available-select.html", controller: "AvailableSelectCtrl", resolve: {availableSelectedArgs: function() { return args; }}})
            .open()
            .then(function (result) {
                if (!result) {
                    return;
                }

                searchSettings.value.visibleColumns = result.map("field");

                setVisibleColumns();

                const updatedSettings = angular.copy(searchSettings);
                updatedSettings.value = JSON.stringify(searchSettings.value);

                $http.post('/Settings/UserOptions/' + entityMap.userOption, updatedSettings)
                    .then(function (response) {
                        searchSettings.id = response.data.id;
                    });
            });
    };

    $scope.selectRow = function (row, index) {
        $scope.current.selectedRow = row;
        $scope.current.selectedIndex = index;

        if (!$scope.current.isAllDatabases){
            dialog.close(entityMap.getSimple(row));
        }
    };

    $scope.launch = function (row){
        var selectedItem = entityMap.getSimple(row);
        var searchEntity;

        searchEntity = selectedItem.icon.split('-').last().capitalize();
        var entityEnum = entities[entities.find({ name: searchEntity })];

        if (selectedItem.alClientId) {
            tokenFactory.getDatabaseToken(selectedItem.alClientId)
                .then(function (token) {
                    var redirectUrl = formulateLaunchUrl(entityEnum,selectedItem,token);
                    window.open(redirectUrl);
                });
        } 
    };

    $scope.clear = function () {
        $scope.searchParams[$scope.current.entity] = null;
        $scope.current.searchCount = null;
    };


    //INITIALIZE
    $scope.current = {
        entity: dialog.options.entity.toLowerCase(),
        isAllDatabases: dialog.options.isAllDatabases,
        masterGroup: $scope.user.authorization.masterGroup,
        tab: {
            parameters: true,
            results: false
        },
        selectedRow: null,
        selectedIndex: -1
    };

    $scope.statuses = [{name: "Active Only", value: "true"}, {name: "Inactive Only", value: "false"}];

    $scope.searchParams = {};

    init();


    //SCOPE WATCHERS
    $scope.$watchCollection('searchParams.' + $scope.current.entity, function (newValue, oldValue) {
        if (!newValue || newValue === oldValue) {
            return;
        }

        $scope.current.searchCount = null;

        getSearchResults(true)
            .then(function (data) {
                $scope.current.searchCount = data > 500 ? "500+" : data;
            });
    });

    $scope.$watchCollection('current.tab', function(newValue, oldValue){
        if (!newValue || newValue === oldValue) {
            return;
        }
        $scope.current.selectedRow = null;
        $scope.current.selectedIndex = -1;
    });
});

'use strict';

app.controller('AdvancedSearchOptionsCtrl', function AdvancedSearchOptionsCtrl($scope, dialog) {
    //PUBLIC METHODS
    $scope.close = function(){
        dialog.close();
    };
    
    $scope.save = function(){
        dialog.close({level: $scope.current.level, isAllDatabases: $scope.current.isAllDatabases});
    };


    //INITIALIZE
    const showAllDbOption = $scope.user.authorization.databaseCount > 1;

    $scope.current = {
        masterGroup: $scope.user.authorization.masterGroup,
        level : "client",
        levels: [{name: "Household", id: "client"}, {name: "Registration", id: "registration"}, {name: "Account", id: "account"}],
        showAllDbOption: showAllDbOption,
        isAllDatabases: showAllDbOption,  //default to true, if it's shown
    };
});

'use strict';

app.controller('ModalHtmlNoticeCtrl', ['$scope', '$dialog', 'dialog',
function ModalHtmlNoticeCtrl($scope, $dialog, dialog)
{
    $scope.titleText = "";
    $scope.htmlContent = "";
    // Private methods
    function init() {
        var htmlContent = dialog.options.htmlContent;
        var paragraphs = lineBreaksToParagraphs( htmlContent );

        $scope.titleText =  dialog.options.titleText;
        $scope.htmlContent =  "<p>" + paragraphs + "</p>";
    }

    function lineBreaksToParagraphs( sourceText ){
        return sourceText.replace(/(?:\r\n|\r|\n)/g, "</p><p>");
    }

    $scope.cancel = function() {
        dialog.close(null);
    };

    init();
}]);
'use strict';

app.controller('WordPressViewCtrl', ['$scope', '$dialog', 'dialog', '$sce',
function WordPressViewCtrl($scope, $dialog, dialog, $sce)
{
    $scope.titleText = "";
    $scope.viewUrl = "";
    // Private methods
    function init() {
        $scope.titleText =  dialog.options.titleText;
        $scope.viewUrl = $sce.trustAsResourceUrl( dialog.options.viewUrl );
    }

    $scope.close = function( checkIfDirty ) {
        dialog.close( null );
    };

    init();
}]);
'use strict';

app.controller('SchwabStatusCtrl', function SchwabOverviewCtrl($scope, dialog, $oasRights, $portfolio, availableSelectedArgs, entities, $schwab) {

    // PRIVATE VARIABLES
    let curEntity = null;
    let schwab = $schwab;

    //PRIVATE METHODS
    function init( ) {
        loadRights();
        $scope.loading = true;
        $scope.entityLoaded = availableSelectedArgs.entity;
        if(!$scope.schwab.checkEnrollmentStatus() ) {
            $scope.schwab.attributes.enrollmentErrors = [];
            $scope.schwab.getEnrollmentStatus().then(function(enrollment){
                $scope.loading = false;
                if(enrollment.data.enrollmentStatus === 'Enrolled' && enrollment.data.statusIndicator === 'Active'){
                    $scope.close();
                } else if(enrollment.data.enrollmentStatus === 'NoResponse'){
                    $scope.schwab.handleEnrollment(enrollment);
                } else {
                    $scope.schwab.handleEnrollment(enrollment);
                }

            });
        }

        $scope.loadBalances = availableSelectedArgs.loadBalances;

    }

    function loadRights( ) {
        $scope.rightsSchwabSII = $oasRights.forCode("SCHWABSII");
        $scope.rightsAccount = $oasRights.forCode("ACCOUNTS");
    }

    //PUBLIC METHODS

    $scope.searchForEntity = function( ) {
        $portfolio.search(entities.client.value)
            .then(function(rslt) {
                if( rslt ) {
                    $schwab.load( rslt.entity, rslt.item.id, true );
                }
            });
    };

    $scope.close = function( ) {
        dialog.close( );
    };

    //PUBLIC VARIABLES
    $scope.entityLoaded = {
        entity: 0,
        entityId: 0,
        entityFriendly: '',
        asOfValue: null,
        allowRead: false,
        data: null,
        icon: '',
        groupings: []
    };

    $scope.loading = true;
    $scope.enrolled = $schwab.attributes.enrolled;
    $scope.loadBalances = false;
    $scope.schwab = $schwab;

    $scope.entitySelector = {
        selectedEntity: null,
        items: [],
        searchEntity: null
    };

    // WATCHES
    $scope.$watch("schwab.attributes.useOtp", function (newValue, oldValue) {
        if (!newValue || newValue === oldValue) return;
        if($schwab.attributes.active && !$scope.schwab.attributes.otpErrors.length){
            $scope.close();
        }
    });

    $scope.$watch("schwab.attributes.enrolled", function (newValue, oldValue) {
        if (newValue === oldValue) return;
        $scope.enrolled = $schwab.attributes.enrolled;
    });

    $scope.$watch("schwab.attributes.otpToken", function (newValue, oldValue) {
        if (!newValue || newValue === oldValue) return;
        if(schwab.attributes.otpToken.length){
            //$scope.close();
        }
    });

    init( );
});

'use strict';

app.controller('SelectWithAddCtrl', function SelectWithAddCtrl($scope, dialog) {
    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close();
    };

    $scope.close = function () {
        dialog.close({selectedItem: $scope.current.selectedItem, items: $scope.current.items.sort()});
    };

    $scope.btnRemoveItem = function(item){
      $scope.current.items.remove(item);
      if($scope.current.selectedItem === item.name){
          $scope.current.selectedItem = $scope.current.items[0].name;
      }
    };

    $scope.btnAddItem = function (item) {
        $scope.current.items.unshift(item);
        $scope.current.newItem = { id: 0, name: '' };
    };


    //INITIALIZE

    $scope.current = {
        selectedItem: dialog.options.data.selectedItem,
        newItem: { id: 0, name: '' },
        items: dialog.options.data.items,
        title: dialog.options.title || 'Edit Subject'
    };
});

'use strict';

// region ACTIVE STATE
app.constant('syncStatus', Object.extended({
    none: {name: 'None', value: "0", queryString : 'none'},
    added: {name: 'Added', value: "1", queryString : 'added'},
    removed: {name: 'Removed', value: "2", queryString : 'removed'}
}));
// endregion

// region ACTIVE STATE
app.constant('activeState', Object.extended({
    active: {name: 'Active', value: "1", queryString : 'true'},
    inActive: {name: 'Not Active', value: "2", queryString : 'false'},
    activeAndInActive: {name: 'Both', value: "3", queryString : ''}
}));
// endregion

// region CONFIRM

app.constant('processStatus', Object.extended({
    new: { name: 'New', value: "0", icon: 'pencil-square-o', locked: false, toWhich: ["1", "6"], taskTypes: [1, 2, 10] },
    approved: {name: 'Approved', value: "1", icon: 'thumbs-up', locked: true, toWhich: ["0", "2", "6"], taskTypes: [2, 4, 10], conditionalTypes /* {tblCorpActionTaskType: [tblCorpActionProcessingType]} */: { 12: [9], 13: [10], 3: [1,2,3,4,6,7,8] } },
    createPendings: { name: 'Create Pendings', value: "2", icon: 'caret-square-o-right', locked: true, toWhich: ["6"], taskTypes: [] },
    processing: { name: 'Processing', value: "3", icon: 'tasks', locked: true, toWhich: [], taskTypes: [] },
    inProcess: { name: 'In Process', value: "4", icon: 'cogs', locked: false, toWhich: ["6", "7"], taskTypes: [7], conditionalTypes: { 5: [1, 2, 3, 4, 6, 7, 8], 6: [1, 2, 3, 4, 6, 7, 8], 8: [1, 2, 3, 4, 6, 7, 8], 9: [1, 2, 3, 4, 6, 7, 8] } },
    complete: { name: 'Complete', value: "5", icon: 'check-square-o', locked: true, toWhich: ["6"], taskTypes: [7, 10], conditionalTypes: { 5: [1, 2, 3, 4, 6, 7, 8], 6: [1, 2, 3, 4, 6, 7, 8], 8: [1, 2, 3, 4, 6, 7, 8], 9: [1, 2, 3, 4, 6, 7, 8] } },
    cancelled: { name: 'Cancelled', value: "6", icon: 'ban', locked: true, toWhich: ["0"], taskTypes: [4, 10] },
    recalculateUnits: { name: 'Recalculate Units', value: "7", icon: 'calculator', locked: true, toWhich: [], taskTypes: [] },
    notProcessed: { name: 'Not Processed', value: "8", icon: '', locked: false, toWhich: ["0"], taskTypes: [4] }
}));

app.constant('roundingType', Object.extended({
    normal: {name: 'Normal', value: "0"},
    up: {name: 'Up', value: "1"},
    down: {name: 'Down', value: "2"},
    nearest: {name: 'Nearest', value: "3"}
}));

app.constant('roundingTypeV2', Object.extended({
    normal: {name: 'Normal', value: "0"},
    up: {name: 'Up', value: "1"},
    down: {name: 'Down', value: "2"},
    nearest: {name: 'Nearest', value: "3"},
    noRounding: {name: 'No Rounding', value: "4"}
}));

app.constant('taskType', Object.extended({
    approveCorpAction: { name: 'Approve Corporate Action', value: 1, icon: 'thumbs-up', isStatusChange: true},
    disregardCorpAction: { name: 'Disregard Corporate Action', value: 2, icon: 'scissors', isStatusChange: true},
    createTransactions: { name: 'Create Transactions', value: 3, icon: 'tasks', isStatusChange: true},
    setBackToNew: { name: 'Set back to New', value: 4, icon: 'caret-square-o-up', isStatusChange: true},
    updateDate: { name: 'Update Date', value: 5, icon: 'calendar', isStatusChange: false},
    updatePriceAmounts: { name: 'Update Price/Amounts', value: 6, icon: 'refresh', isStatusChange: false},
    cancel: { name: 'Cancel', value: 7, icon: 'ban', isStatusChange: true},
    recalculateTransactions: { name: 'Recalculate Transactions', value: 8, icon: 'calculator', isStatusChange: false},
    removeUncoveredPendings: { name: 'Remove Uncovered Pendings', value: 9, icon: 'eraser', isStatusChange: false},
    copyProcessingRecord: { name: 'Copy Processing Record', value: 10, icon: 'clone', isStatusChange: false },
    nameChange: { name: "Update Name", value: 12, icon: 'refresh', isStatusChange: true },
    cusipChange: { name: "Update Cusip", value: 13, icon: 'refresh', isStatusChange: true}
}));

app.constant('corpActionTaskQueueStatus', Object.extended({
    pending: {name: 'Pending', value: "1"},
    skipped: {name: 'Skipped', value: "2"},
    complete: {name: 'Complete', value: "3"}
}));

app.constant('transactionSyncStatus', Object.extended({
    none: {id: -1, name: '(None)' },
    updatePending: {id: 0, name: 'Update Pending'},
    deletePending: {id: 1, name: 'Delete Pending'},
    complete: {id: 2, name: 'Complete'}
}));

// endregion

// region CONFIRM STATUS
app.constant('confirmRecordStatus', Object.extended({
    confirmed: { name: 'Confirmed', value: "1", queryString: 'confirmed' },
    notConfirmed: { name: 'Not Confirmed', value: "0", queryString: 'notConfirmed' },
    excluded: { name: 'Excluded', value: "2", queryString: 'excluded' },
    aggregationOnly: { name: 'Aggregation Only', value: "3", queryString: 'aggregationOnly' }
}));
// endregion

// region CONFIRM SOURCE TYPE
app.constant('confirmSourceType', Object.extended({
    missingFile: {value: "0", dataUrl: '/Confirm/Overview/MissingFiles'},
    accountNotInFile: {value: "1", dataUrl: '/Confirm/Overview/AccountsNotInFile'},
    scheduleJobs: {value: "5", dataUrl: '/Confirm/Overview/ScheduledJobs'},
    dataAudits: {value: "6", dataUrl: '/Confirm/Overview/DataAudits'},
    manualExclusions: {value: "7", dataUrl: '/Confirm/Overview/ManualExclusions'},
    exclusionTable: {value: "8", dataUrl: '/Confirm/Overview/ExclusionTable'},
    filesReceived: {value: "9", dataUrl: '/Confirm/Overview'}
}));
// endregion

// region SLEEVE TYPE
app.constant('sleeveType', Object.extended({
    normal: {name: 'Normal sleeve', value: "0"},
    custodial: {name: 'Custodial account', value: "1"},
    contribution: {name: 'Contribution sleeve', value: "2"},
    distribution: {name: 'Distribution sleeve', value: "3"},
    unmanaged: { name: 'Unmanaged sleeve', value: "4"}
}));
// endregion

// region StoredDataSource
app.constant('storedDataSource', Object.extended({
    orionStored: {name: 'Orion Stored', value: "0"},
    custodianStored: {name: 'Custodian Stored', value: "1"},
    //orionOnDemand: {name: 'Orion On Demand', value: "2"},
    default: {name: 'Orion Entered Custodian Override', value: "3"},
    //orionSupplement: {name: 'Orion Supplement', value: "4"}
    advisorProvided: {name: 'Advisor Provided', value: "5"}
}));
// endregion

// region PRODUCTS TO GET
app.constant('productsToGet', Object.extended({
    allProducts: {name: 'All Products', value: "1", queryString : 'LocalProducts'},
    currentlyOwnedProducts: {name: 'Currently Owned', value: "2", queryString : 'currentlyownedproducts'},
    hasEverOwnedProducts: {name: 'Owned As Of', value: "3", queryString : 'haseverownedproducts'},
    everOwnedProducts: {name: 'Ever Owned', value: "3", queryString : 'haseverownedproducts'},
    missingRiskCategories: {name: 'Missing Risk Category', value: "4", queryString : 'missingriskcategories'},
    missingAssetClasses: {name: 'Missing Asset Class', value: "5", queryString : 'missingassetclasses'}
}));
// endregion


// region BILLING
app.constant('additionalAnnualAmtType', Object.extended({
    percent:{name: '%' , value: "0"},
    dollarAmount:{name: '$' , value: "1"},
    billSchedule:{name: 'Schedule' , value: "2"}
}));

app.constant('billFrequency', Object.extended({
//    undefined:{name: 'Undefined' , value: "0"},
    monthly:{name: 'Monthly' , value: "1"},
    quarterly:{name: 'Quarterly' , value: "3"},
    triannual: {name: 'Tri-Annual', value: "4"},
    semiannually:{name: 'Semi-Annual' , value:"6"},
    annually:{name: 'Annual' , value: "12"},
    atMaturity:{name:'At Maturity' , value: "24"}
}));

app.constant('preferredRateFrequency', Object.extended({
    undefined:{name: 'None' , value: "0"},
    weekly:{name: 'Weekly' , value: "1"},
    monthly:{name: 'Monthly' , value: "2"},
    quarterly:{name: 'Quarterly' , value: "3"},
    semiannually:{name: 'Semi-Annually' , value:"4"},
    annually:{name: 'Annually' , value: "5"},
    atMaturity:{name:'At Maturity' , value: "6"}
}));

app.constant('cashflowFrequency', Object.extended({
    weekly:{name: 'Weekly' , value: "52"},
    monthly:{name: 'Monthly' , value: "12"},
    quarterly:{name: 'Quarterly' , value: "4"},
    semiannually:{name: 'Semi-Annually' , value:"2"},
    annually:{name: 'Annually' , value: "1"}
}));

app.constant('billingStyle', Object.extended({
    advance:{name: 'Advanced' , value: "0"},
    arrears:{name: 'Arrear' , value: "1"}
}));

app.constant('valuationMethod', Object.extended({
    periodEndValue:{name: 'Period End Value' , value: "0"},
    avgDailyBalance:{name: 'Avg Daily Balance' , value: "1"},
    avgMonthlyBalance: {name: 'Avg Monthly Balance', value: "2"}
}));

app.constant('excludeType', Object.extended({
    Percent : {name: 'Percent', value: "0"},
    Dollars: {name: 'Dollars', value: "1"},
    Shares: {name: 'Shares', value: "2"}
}));

app.constant('excludePercentOf', Object.extended({
    Asset : {name: 'Asset', value: "8"},
    Account: {name: 'Account', value: "7"}
}));
//endregion

//region CLOUD
app.constant('cloudStorageProviders', Object.extended({
    box: {name: "Box", value: "1", slogan: "Simple, Secure Sharing from Anywhere"},
    dropBox: {name: "Dropbox", value: "2", slogan: "Your stuff, anywhere"},
    egnyte: {name: "Egnyte", value: "3", slogan: "Enterprise File Sharing"},
    shareFile: {name: "ShareFile", value: "5", slogan: "Where Companies Connect"},
    netDocuments: {name: "NetDocuments", value: "6", slogan: "Content Elevated"}
}));
//endregion

//region COMPOSITE
app.constant('portfolioType', Object.extended({
    composite: {name: "Composite", value: "1"},
    reporting: {name: "Reporting", value: "2"},
    trading: {name: "Trading", value : "3"}
}));

app.constant('compositeFeeOptionType', Object.extended({
    gross: {name: "Gross", value: "0"},
    netActual: {name: "Net Actual", value: "1"},
    netAccrual: {name: "Net Accrual", value: "2"}
}));

//endregion

//region LASERAPP
app.constant('laserAppPostformat', Object.extended({
    raw: {name:"Raw/No Image", value:"Raw_no_image"},
    pdf: {name:"PDF", value:"PDF"},
    tiff: {name:"TIFF", value:"TIF"},
    fillPdf: {name:"Fillable PDF", value:"Fillable_PDF"}
}));

app.constant('laserAppTheme', Object.extended({
    brownChocolate: {name: "Brown Chocolate", value: "brown_chocolate"},
    blackStripes: {name: "Black Stripes", value: "black_stripes"},
    blueSpirit: {name: "Blue Spirit", value: "blue_spirit"},
    orangeOktoberfest: {name: "Orange Oktoberfest", value: "orange_oktoberfest"},
    redFirehouse: {name: "Red Firehouse", value: "red_firehouse"},
    greenFairway: {name: "Green Fairway", value: "green_fairway"},
    blueOvercast: {name: "Blue Overcast", value: "blue_overcast"}
}));

app.constant('laserAppSigMethod', Object.extended({
    method1: {name:"NoFormsSignable", value: 'NoFormsSignable'},
    method2: {name:"Basic", value: 'Basic'},
    method3: {name:"DocuSign", value: 'DocuSign'},
    method4: {name:"Silanis", value: 'Silanis'},
    method5: {name:"SIGNiX", value: 'SIGNiX'}
}));

app.constant('laserAppPrintButton', Object.extended({
    enabled: {name:"Print Button Enabled", value: "Print_button_enabled"},
    disabled: {name:"Print Button Disabled", value: "Print_button_disabled"},
    invisible: {name:"Print Button Invisible", value: "Print_button_invisible"}
}));

app.constant('laserAppSmartFields', Object.extended({
    optional: {name:"Smart Fields Optional", value: "Smart_fields_optional"},
    required: {name:"Smart Fields Required", value: "Smart_fields_required"}
}));
//endregion

// region COST BASIS
app.constant('costBasisMethods', Object.extended({
    useAssigned: {name: "Use Assigned", value: "0"},
    fifo: {name: "First In First Out", value: "1"},
    specificID: {name: "Specific ID", value: "2"},
    averageCost: {name: "Average Cost", value: "3"},
    highCost: {name: "High Cost", value: "4"},
    lowCost: {name: "Low Cost", value: "5"},
    lifo: {name: "Last In First Out", value: "7"}
}));
//endregion

// region ENTITY ENUM
// ENTITY ENUM
// This must match and also change  \Common\OAS.DataModel\Enums\Entity.cs
// This must match and also change  \Common\OAS.Utilities.Core\OAS.Main\EntityEnum.cs

app.constant('entities', Object.extended({
    billPayMethod: {
        name: "Bill Pay Method",
        abbr: "Bill Pay Method",
        securityCode: "BILLAUDIT",
        value: "28"
    },
    notDefined: {
        name: "Not Defined",
        abbr: "--",
        value: "0"
    },
    payee: {
        name: "Payee",
        abbr: "Payee",
        value: "1",
        simpleUrl: "/Billing/Payees/Simple",
        securityCode: "PAYEES"
    },
    brokerDealer: {
        name: "Broker/Dealer",
        abbr: "BD",
        value: "2",
        simpleUrl: "/Portfolio/BrokerDealers/Simple",
        securityCode: "BROKERDEALERS"
    },
    wholesaler: {
        name: "Wholesaler",
        abbr: "WS",
        value: "3",
        simpleUrl: "/Portfolio/Wholesalers/Simple"
    },
    representative: {
        name: "Representative",
        abbr: "Rep",
        value: "4",
        simpleUrl: "/Portfolio/Representatives/Simple",
        securityCode: "REPS"
    },
    client: {
        name: "Household",
        abbr: "HH",
        value: "5",
        simpleUrl: "/Portfolio/Clients/Simple",
        urlFrag: "households",
        securityCode: "CLIENTS",
        bgColor: "rgba(48, 5, 113, 1)",
        icon: "fa fa-orion-household"
    },
    registration: {
        name: "Registration",
        abbr: "Reg",
        value: "6",
        simpleUrl: "/Portfolio/Registrations/Simple",
        urlFrag: "registrations",
        securityCode: "REGISTRATIONS",
        bgColor: "rgba(30, 120, 108, 1)",
        icon: "fa fa-orion-registration"
    },
    account: {
        name: "Account",
        abbr: "Acct",
        value: "7",
        simpleUrl: "/Portfolio/Accounts/Simple",
        urlFrag: "accounts",
        securityCode: "ACCOUNTS",
        bgColor: "rgba(166, 69, 0, 1)",
        icon: "fa fa-orion-account"
    },
    asset: {
        name: "Asset",
        abbr: "Asset",
        value: "8",
        simpleUrl: "/Portfolio/Assets",
        urlFrag: "assets",
        securityCode: "ASSETS",
        bgColor: "rgba(255, 102, 0, 1)",
        icon: "fa fa-orion-asset"
    },
    product: {
        name: "Product",
        abbr: "Product",
        value: "9",
        simpleUrl: "/Portfolio/Products/Simple",
        securityCode: "PRODUCTS",
        bgColor: "rgba(153, 102, 0, 1)",
        icon: "fa fa-orion-product"
    },
    transaction: {
        name: "Transaction",
        abbr: "Transaction",
        value: "10",
        simpleUrl: "/Portfolio/Transactions",
        urlFrag: "transactions",
        securityCode: "TRANSACTIONS",
        bgColor: "rgba(170, 170, 170, 1)",
        icon: "fa fa-orion-transaction"
    },
    fundFamily: {
        name: "Fund Family",
        abbr: "FF",
        value: "12",
        simpleUrl: "/Portfolio/FundFamilies/Simple"
    },
    payoutSchedule: {
        name: "Payout Rate",
        abbr: "PR",
        value: "14",
        simpleUrl: "/Billing/Schedules/Simple?schedule=payout&schedule=bdoverride&schedule=remainder&schedule=performancepayout"
    },
    feeSchedule: {
        name: "Fee Schedule",
        abbr: "FS",
        value: "15",
        simpleUrl: "/Billing/Schedules/Simple?schedule=fee&schedule=performancefee",
        securityCode: "FEESCHEDULES"
    },
    managementStyle: {
        name: "Management Style",
        abbr: "MS",
        value: "16",
        simpleUrl: "/Portfolio/Platforms/Simple"
    },
    ria: {
        name: "Advisor",
        abbr: "RIA",
        value: "17",
        securityCode: "RIAS",
        simpleUrl: "/Portfolio/Rias/Simple",
    },
    custodian: {
        name: "Custodian",
        abbr: "Cust",
        value: "18",
        simpleUrl: "/Portfolio/Custodians/Simple"
    },
    bill: {
        name: "Invoice",
        abbr: "Inv",
        value: "24",
        simpleUrl: "/Billing/Invoices/Simple"
    },
    cancellationFeeAdjustment: {
        name: "Cancellation Fee Adjustment",
        abbr: "CFAD",
        value: "25",
        simpleUrl: "/Billing/CancellationFeeAdjustmentDefault/Simple",
        securityCode: "PAYOUTSCHEDULES"
    },
    billMasterPayout: {
        name: "Payout Schedule",
        abbr: "PS",
        value: "26",
        simpleUrl: "/Billing/MasterPayoutSchedule/Simple",
        securityCode: "PAYOUTSCHEDULES"
    },
    model: {
        name: "Model",
        abbr: "Model",
        value: "27",
        simpleUrl: "/Trading/Models/Simple"
    },
    owner: {
        name: "Owner",
        abbr: "DB",
        value: "39"
    },
    administrator: {
        name: "Administrator",
        abbr: "Admin",
        value: "50"
    },
    subAdvisor: {
        name: "Sub-advisor",
        abbr: "SA",
        value: "52",
        simpleUrl: "/Portfolio/SubAdvisors/Simple",
        securityCode: 'SUBADVISORS'
    },
    plan401k: {
        name: "Qualified Plan",
        abbr: "401K",
        value: "58",
        simpleUrl: "/Portfolio/Plans/Simple",
        securityCode: '401KPLAN'
    },
    thirdPartyAdministrator: {
        name: "Third-Party Administrator",
        abbr: "TPA",
        value: "60",
        simpleUrl: "/Portfolio/PlanAdministrators/Simple",
        securityCode: '401KPLAN'
    },
    participant: {
        name: "Participant",
        abbr: "Part",
        value: "62",
        simpleUrl: "/Portfolio/Participants/Simple"
    },
    planSponsor: {
        name: "Plan Sponsor",
        abbr: "PlanSpon",
        value: "63",
        simpleUrl: "/Portfolio/PlanSponsors/Simple"
    },
    thirdParty: {
        name: "Third Party",
        abbr: "TP",
        value: "65",
        simpleUrl: null
    },
    entityOption: {
        name: "Entity Option",
        abbr: "EO",
        value: "69"
    },
    modelAgg: {
        name: "Model",
        abbr: "Model",
        value: "74",
        simpleUrl: "/Trading/ModelAggs/Simple"
    },
    repAccountManager: {
        name: "Rep Account Manager",
        abbr: "RAM",
        value: "76"
    },
    businessLine: {
        name: "Business Line",
        abbr: "BL",
        value: "79",
        simpleUrl: "/Portfolio/BusinessLines/Simple",
        securityCode: 'BUSINESSLINE'
    },
    assetClass: {
        name: "Asset Class",
        abbr: "AC",
        value: "81",
        simpleUrl: "/Portfolio/ProductClasses/Simple"
    },
    assetLevelStrategy: {
        name: "Asset Level Strategy",
        abbr: "ALS",
        value: "85",
        simpleUrl: "/Portfolio/AssetLevelStrategies/Simple"
    },
    assetCategory: {
        name: "Asset Category",
        abbr: "AC",
        value: "90",
        simpleUrl: "/Portfolio/ProductCategories/Simple"
    },
    riskCategory: {
        name: "Risk Category",
        abbr: "RC",
        value: "91",
        simpleUrl: "/Portfolio/RiskCategories/Simple"
    },
    registrationType: {
        name: "Registration Type",
        abbr: "RT",
        value: "94",
        simpleUrl: "/Portfolio/Registrations/Types"
    },
    dynamicGroup: {
        name: "Dynamic Group",
        abbr: "DG",
        value: "103",
        simpleUrl: "/Utility/Groupings/Simple"
    },
    productType: {
        name: "Product Type",
        abbr: "PT",
        value: "104",
        simpleUrl: "/Portfolio/ProductTypes/Simple"
    },
    productSubType: {
        name: "Product Sub-Type",
        abbr: "PST",
        value: "105",
        simpleUrl: "/Global/Products/SubTypes/Simple"
    },
    investmentObjective: {
        name: "Investment Objective",
        abbr: "IO",
        value: "106",
        simpleUrl: "/Portfolio/InvestmentObjectives/Simple"
    },
    portfolioGroup: {
        name: "Portfolio Group",
        abbr: "PG",
        value: "107",
        simpleUrl: "/Portfolio/PortfolioGroups/Simple",
        urlFrag: 'portfoliogroups',
        bgColor: "rgba(51, 51, 51, 1)",
        icon: "fa fa-orion-portfolio-group"
    },
    billAdjustmentType: {
        name: "Bill Adjustment Type",
        abbr: "AT",
        value: "120",
        simpleUrl: "/Billing/AdjustmentTypes/Simple"
    },
    feeType: {
        name: "Fee Type",
        abbr: "FT",
        value: "121",
        simpleUrl: "/Billing/FeeTypes/Simple"
    },
    downloadSource: {
        name: "Download Source",
        abbr: "DWNS",
        value: "161",
        simpleUrl: "/Confirm/DownloadSources/Simple"
    },

    // Extended entities not in Desktop
    reportingGroup: {
        name: "Reporting Group",
        abbr: "RG",
        value: "RG",
        simpleUrl: "/Reporting/ReportGroups/Simple"
    },
    dynamicReportingGroup: {
        name: "Dynamic Reporting Group",
        abbr: "DRG",
        value: "Dynamic Grouping",
        simpleUrl: "/Utility/Groupings/Simple"
    },
    confirmationGroup: {
        name: "Confirmation Group",
        abbr: "CG",
        value: "CG",
        simpleUrl: "/Confirmation/Groups/Simple"
    },
    confirmationScrub: {
        name: "Confirmation Scrub",
        abbr: "CS",
        value: "CS",
        simpleUrl: ""
    },
    corporateAction: {
        name: "Corporate Action",
        abbr: "CA",
        value: "CA",
        simpleUrl: "",
        routePrefix: '/Global/CorporateActions/',
        pluralArticle: 's'
    },
    corporateActionTransaction: {
        name: "Corporate Action Transaction",
        abbr: "CAT",
        value: "CAT",
        simpleUrl: ""
    },
    dividend: {
        name: "Dividend",
        abbr: "DI",
        value: "DI",
        simpleUrl: ""
    },
    priceFactor: {
        name: "Price Factor",
        abbr: "PF",
        value: "PF",
        simpleUrl: ""
    },
    downloadFile: {
        name: "Download File",
        abbr: "DF",
        value: "DF",
        simpleUrl: ""
    },
    downloadFormat: {
        name: "Download Format",
        abbr: "DF",
        value: "DF",
        simpleUrl: ""
    },
    downloadRecord: {
        name: "Download Record",
        abbr: "DR",
        value: "DR",
        simpleUrl: ""
    },
    downloadName: {
        name: "Download Name",
        abbr: "DN",
        value: "DN",
        simpleUrl: "",
        confirmRecordType: "0"
    },
    downloadPosition: {
        name: "Download Position",
        abbr: "DP",
        value: "DP",
        simpleUrl: "",
        confirmRecordType: "1"
    },
    downloadTransaction: {
        name: "Download Transaction",
        abbr: "DT",
        value: "DT",
        simpleUrl: "",
        confirmRecordType: "2"
    },
    downloadPrice: {
        name: "Download Price",
        abbr: "DPR",
        value: "DPR",
        simpleUrl: "",
        confirmRecordType: "3"
    },
    downloadCostBasis: {
        name: "Download Cost Basis",
        abbr: "DC",
        value: "DC",
        simpleUrl: "",
        confirmRecordType: "12"
    },
    downloadDividend: {
        name: "Download Dividend",
        abbr: "DD",
        value: "DD",
        simpleUrl: "",
        confirmRecordType: "4"
    },
    downloadCorpAction: {
        name: "Download Corporate Action",
        abbr: "DCA",
        value: "DCA",
        simpleUrl: "",
        confirmRecordType: "9"
    },
    downloadSecurity: {
        name: "Download Security",
        abbr: "DS",
        value: "DS",
        simpleUrl: "",
        confirmRecordType: "8"
    },
    downloadBeneficiary: {
        name: "Download Beneficiary",
        abbr: "DB",
        value: "DB",
        simpleUrl: "",
        confirmRecordType: "13"
    },
    downloadRMD: {
        name: "Download RMD",
        abbr: "DRMD",
        value: "DRMD",
        simpleUrl: "",
        confirmRecordType: "17"
    },
    downloadSystematic: {
        name: "Download Systematic",
        abbr: "DSYS",
        value: "DSYS",
        simpleUrl: "",
        confirmRecordType: "16"
    },
    downloadBanking: {
        name: "Download Banking",
        abbr: "DBanking",
        value: "DBanking",
        simpleUrl: "",
        confirmRecordType: "18"
    },
    downloadGeneric: {
        name: "Download Generic",
        abbr: "DGeneric",
        value: "DGeneric",
        simpleUrl: "",
        confirmRecordType: "11"
    },
    billEntity: {
        name: "Bill Entity",
        abbr: "BE",
        value: "Bill Entity",
        simpleUrl: ""
    },
    productDescriptionProvider: {
        name: "Product Description Provider",
        abbr: "PD",
        value: "PD",
        simpleUrl: "/Portfolio/ProductDescriptionProvider/Simple"
    },
    storedCost: {
        name: "Stored Cost",
        abbr: "SC",
        value: "SC",
        simpleUrl: null
    },
    userManagement: {
        name: "User Management",
        abbr: "UM",
        value: "UM",
        simpleUrl: null
    },
    roles: {
        name: "Roles",
        abbr: "RO",
        value: "RO",
        simpleUrl: null
    },
    privileges: {
        name: "Privileges",
        abbr: "PV",
        value: "PV",
        simpleUrl: null
    },
    processInstance: {
        name: "Process Instance",
        abbr: "PI",
        value: "PI",
        simpleUrl: "",
    },
    processTask: {
        name: "Process Task",
        abbr: "PTK",
        value: "PTK",
        simpleUrl: "",
    },
    processAction: {
        name: "Process Action",
        abbr: "PA",
        value: "PA",
        simpleUrl: "",
    },
    processType: {
        name: "Process Type",
        abbr: "PTY",
        value: "PTY",
        simpleUrl: "",
    },
    processStatus: {
        name: "Process Status",
        abbr: "PS",
        value: "PS",
        simpleUrl: "",
    },
    dataQuery: {
        name: "Data Query",
        abbr: "DQ",
        value: "DQ",
        simpleUrl: '/Reporting/Custom/Simple'
    },
    downloadSource: {
        name: "Download Source",
        abbr: "DLS",
        value: "DLS",
        simpleUrl: '/Confirm/DownloadSource/Simple'
    },
    downloadFormatSourceDefault: {
        name: "Download Format Source Default",
        abbr: "DLFSD",
        value: "DLFSD",
        simpleUrl: "",
    },
    optionLevel: {
        name: "Option Level Agreement",
        abbr: "OLA",
        value: "OLA",
        simpleUrl: "/Trading/Models/Sma/AccountType/Restrictions/OptionLevel"
    },
    marginAgreement: {
        name: "Margin Agreement",
        abbr: "MA",
        value: "MA",
        simpleUrl: "/Trading/Models/Sma/AccountType/Restrictions/MarginAgreement"
    },
    primeBrokerage: {
        name: "Prime Brokerage",
        abbr: "PB",
        value: "PB",
        simpleUrl: "/Trading/Models/Sma/AccountType/Restrictions/PrimeBrokerage"
    },
    downloadSubFormatSchedulerDefault: {
    name: "Download SubFormat Scheduler Default",
    abbr: "DLFSSD",
    value: "DLFSSD",
    simpleUrl: ""
    },
    cotenant: {
        name: "Cotenant",
        abbr: "COT",
        value: "203",
        simpleUrl: "/Portfolio/Cotenant/Simple",
        securityCode: "COTENANT"
    },
    allocatedUnrealizedCostBasis: {
        name: "Allocated Unrealized Cost Basis",
        abbr: "AUCB",
        value: "204",
        simpleUrl: null
    },
    allocatedRealizedCostBasis: {
        name: "Allocated Realized Cost Basis",
        abbr: "ARCB",
        value: "205",
        simpleUrl: null
    },
    associatedHousehold: {
        name: "Associated Household",
        abbr: "EH",
        value: "207",
        simpleUrl: null
    },

}));
//endregion

// region PRODUCT TYPES
app.constant('productTypes', Object.extended({
    none: {name: 'None', value: "0"},
    mutualFund: {name: 'Mutual Fund', value: "1"},
    annuity: {name: 'Annuity', value: "2"},
    advisorOne: {name: 'Advisor One', value: "3"},
    stockOrETF: {name: 'Stock/ETF', value: "4"},
    option: {name: 'Option', value: "5"},
    bond: {name: 'Bond', value: "6"},
    unknown: {name: 'Miscellaneous', value: "7"},
    cd: {name: 'CD', value: "8"},
    index: {name: 'Index', value: "9"}
}));

app.constant('paymentFrequency', Object.extended({
    atMaturity:{name:'At Maturity' , value: "0"},
    monthly:{name: 'Monthly' , value: "1"},
    quarterly:{name: 'Quarterly' , value: "3"},
    triannually: {name: 'Triannually', value: "4"},
    semiannually:{name: 'Semi-Annually' , value:"6"},
    annually:{name: 'Annually' , value: "12"},
    biennially:{name:'Biennially' , value: "24"}
}));
//endregion

// region DAY COUNTS
app.constant('dayCounts', Object.extended({
    thirtyThreeSixty: {name: '30/360', value: "thirtyThreeSixty"},
    actualActual: {name: 'Actual/Actual', value: "actualActual"},
    actualThreeSixtyFive: {name: 'Actual/365', value: "actualThreeSixtyFive"},
    actualThreeSixty: { name: 'Actual/360', value: "actualThreeSixty" },
    actualActualIsda: { name: 'Actual/Actual ISDA', value: 'actualActualIsda' }
}));
//endregion

// region PAYMENT CYCLE DATE TYPES
app.constant('paymentCycleDateTypes', Object.extended({
    normal: {name: 'Normal', value: "0"},
    nextBusinessDay: {name: 'Accrue Next Business Day', value: "1"},
    previousBusinessDay: {name: 'Accrue Previous Business Day', value: "2"}
}));
//endregion

//region PRODUCT STATUS
app.constant('productStatuses', Object.extended({
    undefined: {name: 'Open', value: "0"},
    softClose: {name: 'Soft Close', value: "1"},
    hardClose: {name: 'Hard Close', value: "2"},
    sellOnly: {name: 'Sell Only', value: "3"},
    purchaseOnly: {name: 'Purchase Only', value: "4"},
    exclude: {name: 'Exclude', value: "5"}
}));
//endregion

//region PRICING STATUS
app.constant('pricingStatuses', Object.extended({
    normalDailyPricing: {name: 'Normal Daily Pricing', value: "0"},
    defaultPricedProduct: {name: 'Default Priced Product', value: "1"},
    manuallyMaintainedProduct: {name: 'Manually Maintained Product', value: "2"},
    pricingReceivedMoreThan1BusinessDayLater: {name: 'Pricing Received More Than 1 Business Day Later', value: "3"},
    infrequentPricingFromCustodian: {name: 'Infrequent Pricing From Custodian', value: "4"},
    securityIsWorthless: {name: 'Security Is Worthless', value: "5"},
    indeterminableValue: {name: 'Indeterminable Value', value: "6"},
    notActiveProduct: {name: 'Not Active Product', value: "7"}
}));
//endregion

// region REPRESENTATIVE
app.constant('repStatus', Object.extended({
    activeNoIssues : {name: 'Active/No Issues', value: "0"},
    //activeSentFax : {name: 'Active/Sent Fax', value: "1"}, Commented out in AD
    holdForCompliance : {name: 'Hold for Compliance', value: "2"},
    // holdForPaperwork : {name: 'Hold for Paperwork', value: "3"}, // no longer used W85389
    activeNoNewClients : {name: 'Active/No New Households', value: "4"},
    inActive : {name: 'InActive', value: "5"},
    pending : {name: 'Pending', value: "6"}
}));

//endregion

//region BROKERDEALER
app.constant('bdStatus', Object.extended({
    noIssues : {name: 'No Issues', value: "0"},
    limited : {name: 'Limited', value: "1"},
    pending : {name: 'Pending', value: "2"},
    prospect : {name: 'Prospect', value: "3"},
    rejected : {name: 'Rejected', value: "4"},
    inActive : {name: 'Inactive', value: "5"}
}));

app.constant('clearingFirm', Object.extended({
    selfClearing : {name: 'Self Clearing', value: "0"},
    pershing : {name: 'Pershing', value: "1"},
    nationalFinancial : {name: 'National Financial', value: "2"},
    unknown : {name: 'Unknown', value: "3"},
    tdAmeritrade : {name: 'TD Ameritrade', value: "4"},
    schwab : {name: 'Schwab', value: "5"},
    trustCompanyOfAmerica : {name: 'Trust Company of America', value: "6"},
    foliofn : {name: 'FOLIOfn', value: "7"},
    fidelity : {name: 'Fidelity', value: "8"},
    rbcCapitalMarkets : {name : 'RBC Capital Markets, LLC', value : "9"},
    southwestSecuritiesInc : {name: 'Southwest Securities, Inc.', value: "10"}
}));
app.constant('howIsAdvRegistered', Object.extended({
    unknown : {name: 'Unknown', value: "0"},
    secRegistered : {name: 'SEC Registered', value: "1"},
    stateRegistered : {name: 'State Registered', value: "2"},
    unRegistered : {name: 'Unregistered', value: "3"},
    other : {name: 'Other', value: "4"}
}));

//endregion

//region PLAN
app.constant('planStatus', Object.extended({
    pending : {name: 'Pending', value: "0"},
    active : {name: 'Active', value: "1"},
    rejected : {name: 'Rejected', value: "2"},
    canceled : {name: 'Canceled', value: "3"}
}));
//endregion

//region NOTIFICATION
app.constant('notificationDestination', Object.extended({
    clientPortal : {name: 'ClientPortal', value: '1'},
    orionApp : {name: 'OrionApp', value: '2'},
    email: {name: 'Email', value: '3'},
    rss : {name: 'Rss', value: '4'},
    advisorMail : {name : 'AdvisorMail', value : '5'},
    zapier : {name: 'Zapier', value: '6'},
    notificationInbox : {name: 'Notification Inbox', value: '7'}
}));

app.constant('notificationGroupType', Object.extended({
    me : {name:'Me', value: "0"},
    user : {name: 'User', value: "1"},
    //allHouseholds : {name: 'All Households', value: "2"},
    allReps : {name:'All Reps', value: "3"},
    allAdvisors : {name: 'All Advisors', value: "4"},  //(all advisor logins for a database, not all advisors in all databases – unless the parent table’s fkALClient is null)
    serviceTeam : {name: 'Service Team', value: "5"}, //only admins can select this
    customGroup : {name: 'Custom Group', value: "6"},
    allUsers : {name: 'All Users', value: "7"} //only admins can select this
}));

app.constant('notificationStatus', Object.extended({
    unread : {name:'Unread', value: "0"},
    read : {name: 'Read', value: "1"},
    deleted : {name: 'Deleted', value: "2"} 
}));

app.constant('notificationActions', Object.extended({
    undefined : {name:'Undefined', value: "0"},
    download : {name: 'Download', value: "1"},
    link : {name: 'Link', value: "2"}
}));
//endregion

app.constant('audienceExclusions', Object.extended({
    none: { name: 'None', value: 'None' },
    workflowAssistant: { name: 'Workflow Assistant', value: 'Workflow Assistant' }
}));

app.constant('ssoTypes', Object.extended({
    none: {name: 'None', value: "0"},
    sameTabRedirect: {name: 'SameTabRedirect', value: "1"},
    portal: {name: 'Portal', value: "2"},
    formPost: {name: 'FormPost', value: "3"},
    newTabRedirect: {name: 'NewTabRedirect', value: "4"},
    advisoryWorld: {name: 'AdvisoryWorld', value: "5"},
    byAllRep: {name: 'ByAllRep', value: "6"},
    schwab: {name: 'Schwab', value: "7"},
    pershing: {name: 'Pershing', value: "8"},
    goldmanSachs: {name: 'GoldmanSachs', value: "9"}
}));

//region custodian
app.constant('sweepLevel', Object.extended({
    none: {name: 'Not set', value: "0"},
    registration: {name: 'Registration', value: "1"},
    account: {name: 'Account', value: "2"}
}));

app.constant('feeRequestSource', Object.extended({
    none: {name: 'Not set', value: "0"},
    highValueFund: {name: 'High value fund', value: "1"},
    cashAccount: {name: 'Cash account', value: "2"},
    proRata: {name: 'Pro-Rata', value: "3"}
}));

app.constant('directTrading', Object.extended({
    none: {name: 'None', value: "0"},
    tda: {name: 'TD Ameritrade', value: "1"}
}));

app.constant('uploadFormatTypes', Object.extended({
    none: {name: 'Not used', value: "0"},
    fixAllocation: {name: 'FIX allocation', value: "1"},
    feeFile: {name: 'Fee File', value: "2"},
    tradeFile: {name: 'Trade File', value: "3"},
    nameFile: {name: 'Name File', value: "4"},
    taxFiles: {name: 'Tax Files', value: "5"}
}));

app.constant('custodianTypes', Object.extended({
    none: {name: 'None', value: "0"},
    ctc: {name: 'CTC', value: "1"},
    eas: {name: 'EAS', value: "2"}
}));
//endregion

app.constant('apps', Object.extended({
    none: { name: 'None', value: "0", code: 'none' },
    portfolioLists: { name: 'Portfolio Audit', value: "1", code: 'pl' },
    billingAudit: { name: 'Billing Audit', value: "2", code: 'ba' },
    newAccount: { name: 'New Accounts', value: "3", code: 'na' },
    productsAndPrices: { name: 'Products And Prices', value: "4", code: 'pp' },
    confirmation: { name: 'Confirmation', value: "5", code: 'co' },
    rmd: { name: 'RMD Dashboard', value: "6", code: 'rm' },
    qeProcessMgr: { name: "QE Process Manager", value: "7", code: "qepm" },
    billGenerator: { name: "Billing Generator", value: "8", code: "bg" },
    feeAssignment: { name: "Fee Schedules Assignment", value: "8", code: "fa" },
    firmProfile: { name: 'Firm Profile', value: "9", code: "fp" },
    payoutDashboard: { name: 'Payout Dashboard', value: "10", code: "pd" },
    billing: { name: 'Billing', value: "11", code: "billing" }
}));

// region HOUSEHOLD
app.constant('statementDeliveryMethod', Object.extended({
    notAssigned:{name: '{not assigned}', value: "0"},
    mail:{name: 'Mail' , value: "1"},
    email:{name: 'Email' , value: "2"},
    both:{name: 'Both' , value:"10"},
    websiteOnly:{name: 'Website Only' , value: "11"},
    noStatement:{name:'No Statement' , value: "12"}
}));
//endregion

// region REGISTRATION
app.constant('taxType', Object.extended({
    taxable:{name: 'Taxable', value: "0"},
    taxDeferred:{name: 'Tax Deferred' , value: "1"},
    taxFree:{name: 'Tax Free' , value: "2"}
}));
//endregion

// region ACCOUNT
app.constant('systematicTaxWithType', Object.extended({
    undefined:{name: 'Undefined', value: "0"},
    dollar:{name: 'Dollar' , value: "1"},
    percent:{name: 'Percent' , value: "2"},
    unknown:{name: 'Unknown' , value:"3"},
    none:{name: 'None' , value: "4"}
}));
//endregion

//region ASSET
app.constant('assetStatus', Object.extended({
    undefined: {name: 'Undefined', value: "0"},
    normalDownloading: {name: 'Normal Downloading', value: "1"},
    manuallyManaged: {name: 'Manually Managed', value: "2"},
    Alternative:{name: 'Alternative', value:"3"}
}));
//endregion

//region TRANSACTION
app.constant('commissionIndicator', Object.extended({
    none: {name: 'None', value: "0"},
    cps: {name: 'CPS', value: "1"},
    full: {name: 'Full', value: "2"},
    mtl : {name: 'Percent Discount',value: "3"},
    nc : {name: 'No Commission', value : "4"},
    pfg : {name: 'Prefigured', value : '5'}
}));

app.constant('orderType', Object.extended({
    none: {name: 'None', value: "0"},
    m: {name: 'Market', value: "1"},
    l: {name: 'Limit', value: "2"},
    d : {name: 'DOT',value: "3"},
    p : {name: 'PER', value : "4"},
    z : {name: 'Derived', value : '5'}
}));

app.constant('marketCode', Object.extended({
    none: {name: 'None', value: "0"},
    nyse: {name: 'New York Stock Exchange (NYSE)', value: "1"},
    nysealt: {name: 'NYSE ALT', value: "2"},
    philadelphia : {name: 'Philadelpia (PHLX)',value: "3"},
    overTheCounter : {name: 'Over The Counter (OTC)', value : "4"},
    bostonOther : {name: 'Boston/Other', value : '5'},
    chicagoExchange : {name: 'Chicago Exchange (CHX)', value : '6'},
    chicagoBoardOptionsExchange : {name: 'Chicago Board Options Exchange (CBOE)', value : '7'},
    otcNSCC : {name: 'Over The Counter/National Securities Clearing Corp. (OTC/NCSS)', value : '8'},
    pacificSecuritiesExchange : {name: 'Pacific Securities Exchange (PSE)', value : '9'},
    cincinnatiPrincipal : {name: 'Cincinnati Principal', value : '10'},
    cincinattiAgegcy : {name: 'Cincinnati Agency', value : '11'}
}));

app.constant('blotterCode', Object.extended({
    none: {name: 'None', value: "0"},
    averagePrice: {name: 'Average Price', value: "1"},
    agencyCustomerVsStreet: {name: 'Agency, Customer vs. the Street', value: "2"},
    option : {name: 'Option',value: "3"},
    agencyCashSpecialNextDay : {name: 'Agency, but used for Cash, Special Settlement, Next Day Trades', value : "4"},
    duplicateConfirm : {name: 'Duplicate Confirm', value : '5'},
    principalCrossTrade : {name: 'Principal Cross Trade', value : '6'},
    syndicateCrossTrade : {name: 'Syndicate Cross Trade', value : '7'},
    notUsed : {name: 'Not Used', value : '8'},
    pctOTC : {name: 'Principal Cross Trade/Over The Counter (PCT/OTC)', value : '9'},
    agencyCrossTrade : {name: 'Agency Cross Trade', value : '10'}
}));

app.constant('distributionIndicator', Object.extended({
    none: {name: 'None', value: "0"},
    regular: {name: 'Regular', value: "1"},
    directedTrade: {name: 'Directed Trade', value: "2"},
    splitTrade : {name: 'Split Trade',value: "3"}
}));

app.constant('revenueType', Object.extended({
    none: {name: 'None', value: "0"},
    commission: {name: 'Commission', value: "1"},
    saleCredit: {name: 'Sales Credit', value: "2"},
    fee : {name: 'Fee',value: "3"}
}));

app.constant('spreadStraddle', Object.extended({
    None : {name: 'None', value: "0"},
    noLoad: {name:'No-Load, non-FundServ, non-Exchange, non-SRS, non- NTF trade for eligible surcharge fund', value: '1'},
    specialPrice2Trade: {name:'Special Price 2 Trade', value: '2'},
    specialPric2eExchange: {name:'Special Price 2 Exchange', value: '3'},
    specialPrice2SRSTrade: {name:'Special Price 2 SRS Trade', value: '4'},
    specialPrice2SRSExchange: {name:'Special Price 2 SRS Exchange', value: '5'},
    specialPrice3Trade: {name:'Special Price 3 Trade', value: '6'},
    specialPrice3Exchange: {name:'Special Price 3 Exchange', value: '7'},
    specialPrice3SRSTrade: {name:'Special Price 3 SRS Trade', value: '8'},
    specialPrice3SRSExchange: {name:'Special Price 3 SRS Exchange', value: '9'},
    loadFundServSurcharge: {name:'Load, FundServ Surcharge', value: '10'},
    ntf: {name:'No Transaction Fee', value: '11'},
    srs: {name:'Systematic Reinvestment System', value: '12'},
    empty: {name:'Load or No Load, Networked, or non-Networked trade or Not Applicable if not a Mutual Fund', value: '13'},
    loadFundServNetworkedExchange: {name:'Load, FundServ, Networked Exchange', value: '14'},
    loadFundServNonNetworkedExchange: {name:'Load, FundServ, non-Networked Exchange', value: '15'},
    loadFundServNetworkedTrade: {name:'Load, FundServ, Networked Trade', value: '16'},
    loadFundServNonNetworkedTrade: {name:'Load, FundServ, non-Networked Trade', value: '17'},
    loadOrNoLoadNonFundServNetworkedOrNonNetworkedExchange: {name:'Load or No-Load, non-FundServ, Networked or non- Networked Exchange', value: '18'},
    loadNonFunServSurcharge: {name:'Load, non-FunServ Surcharge', value: '19'},
    noLoadFundServNetworkedExchange: {name:'No-Load, FundServ, Networked Exchange', value: '20'},
    noLoadFundServNonNetworkedExchange: {name:'No-Load, FundServ, non-Networked Exchange', value: '21'},
    noLoadFundServNetworkedTrade: {name:'No-Load, FundServ, Networked Trade', value: '22'},
    noLoadFundServNonNetworkedTrade: {name:'No-Load, FundServ, non-Networked Trade', value: '23'},
    ntfLoadOrNoLoadFundServOrNonFundServNetworkedOrNonNetworkedTrade: {name:'NTF, Load or No-Load, FundServ or non-FundServ, Networked or non-Networked Trade', value: '24'},
    ntfBelowMinimumLoadOrNoLoadFundServOrNonFundServNetworkedOrNonNetworkedTrade: {name:'NTF, Below Minimum Load or No-Load, FundServ or non-FundServ, Networked or non-Networked Trade', value: '25'},
    ntfShortTermRedemptionLoadOrNoLoadFundServOrNonFundServNetworkedOrNonNetworkedTrade: {name:'NTF, Short Term Redemption Load or No-Load, FundServ or non-FundServ, Networked or non- Networked Trade', value: '26'},
    ntfSRSLoadOrNoLoadFundServOrNonFundServNetworkedOrNonNetworkedTrade: {name:'NTF, SRS Load or No-Load, FundServ or non-FundServ, Networked or non-Networked Trade', value: '27'},
    ntfSRSLoadOrNoLoadFundServOrNonFundServNetworkedOrNonNetworkedExchange : {name:'NTF, SRS Load or No-Load, FundServ or non- FundServ, Networked or non-Networked Exchange', value: '28'},
    ntfSRSBelowMinimumLoadOrNoLoadFundServOrNonFundServNetworkedOrNonNetworkedTrade: {name:'NTF, SRS Below Minimum Load or No-Load, FundServ or non-FundServ, Networked or non-Networked Trade', value: '29'},
    ntfSRSShortTermRedemptionLoadOrNoLoadFundServOrNonFundServNetworkedOrNonNetworkedTrade: {name:'NTF, SRS Short Term Redemption Load or No-Load, FundServ or non-FundServ, Networked or non- Networked Trade', value: '30'},
    srsReinvestmentTrade: {name:'SRS Reinvestment Trade', value: '31'},
    srsTrade: {name:'SRS Trade', value: '32'},
    srsExchange: {name:'SRS Exchange', value: '33'},
    ntfsRSShortTermRedemptionLoadOrNoLoadFundServOrNonFundServNetworkedOrNonNetworkedExchange: {name:'NTF SRS Short Term Redemption Load or No-Load FundServ or non-FundServ Networked or non- Networked Exchange', value: '34'},
    specialPrice1Trade: {name:'Special Price 1 Trade', value: '35'},
    specialPrice1Exchange: {name:'Special Price 1 Exchange', value: '36'},
    specialPrice1SRSTrade: {name:'Special Price 1 SRS Trade', value: '37'},
    specialPrice1SRSExchange: {name:'Special Price 1 SRS Exchange', value: '38'},
    noLoadFundServNonExchangeNonSRSNonNTFTradeForEligibleSurchargeFund: {name:'No-Load, FundServ, non-Exchange, non-SRS, non-NTF trade for eligible surcharge fund', value: '39'}
}));

//endregion

//region FEE SCHEDULE
app.constant('howBilled', Object.extended({
    percent : {name: 'Percentage',value: "0"},
    dollarAmount: {name: 'Dollar Amount', value: "1"}
}));

app.constant('howBilledPayout', Object.extended({
    percent : {name: 'Percentage',value: "0"},
    basisPoints: {name: 'Basis Points', value: "1"},
    dollarAmount: {name: "Dollar Amount", value: "2"}
}));

app.constant('billScheduleTypes', Object.extended({
    flat : {name: 'Flat',value: "Flat"},
    linear : {name: 'Linear',value: "Linear"},
    tiered: {name: 'Tiered', value: "Tiered"}
}));

app.constant('billBasis', Object.extended({
    client : {name: 'Household',value: "5"},
    registration: {name: 'Registration', value: "6"},
    account : {name: 'Account',value: "7"},
    subAdvisor: {name: 'Sub-advisor', value: "52"}
}));

app.constant('billScheduleFees', Object.extended({
    feeSchedule : {name: 'Fee Schedule',value: "1"},
    performanceFee: {name: 'Performance Fee', value: "6"}
}));

app.constant('billSchedulePayoutRates', Object.extended({
    payoutSchedule: {name: 'Payout Schedule', value: "2"},
    bdOverrideSchedule: {name: 'BD Override Schedule', value: "4"},
    remainder: {name: 'Remainder', value: "5"},
    performancePayout: {name: 'Performance Payout', value: "7"}
}));
//endregion

//region custodian
app.constant('fundTypes', Object.extended({
    unassigned: {name: 'Unassigned', value: "-1"},
    equity: {name: 'Equity', value: "0"},
    fixedIncome: {name: 'Fixed Income', value: "1"},
    fiveTwentyNine: {name: '529', value: "2"},
    index: {name: 'Index', value: "3"}
}));
//endregion

//region userDefinedDefinition
app.constant('userDefineControlMask', Object.extended({
    multiLineEditor: {name: 'Multi-line editor', value: "-2"},
    dropDownList: {name: 'List', value: "0"},
    checkBox: {name: 'Check box', value: "1"},
    currency: {name: 'Currency', value: "2"},
    date: {name: 'Date', value: "3"},
    dateTime: {name: 'Date/Time', value: "4"},
    integer: {name: 'Integer', value: "5"},
    string: {name: 'String', value: "6"},
    double: {name: 'Double', value: "7"},
    time: {name: 'Time', value: "8"},
    long: {name: 'Long', value: "11"}
}));
//endregion


//region Process Dashboard
app.constant('processFieldType', Object.extended({
    text: {name: 'Text', value: "0"},
    textArea: {name: 'TextArea', value: "1"},
    date: {name: 'Date', value: "2"},
    dateTime: {name: 'DateTime', value: "3"},
    radioList: {name: 'RadioList', value: "4"},
    checkList: {name: 'CheckList', value: "5"},
    selectList: {name: 'SelectList', value: "6"},
    number: {name: 'Number', value: "7"},
    email: {name: 'Email', value: "8"},
    entity: {name: 'Entity', value: "9"}
}));

app.constant('processActionType', Object.extended({
    standard: {name: 'Standard', value: "1"},
    custom: {name: 'Custom', value: "2"},
    service: {name: 'Service', value: "3"},
    link: {name: 'Link', value: "4"},
    form: {name: 'Form', value: "5"},
    report: {name: 'Report', value: "6"},
    endpoint: {name: 'Endpoint', value: "7"}
}));
//endregion

//region ALTERNATIVE
app.constant('alternativeCommitmentType', Object.extended({
    committedCapital: {name: 'Committed Capital', value: "1"},
    unFundedAdjustment: { name: 'UnFunded Adjustment', value: "2" },
    contributedCapital: { name:'Contributed Capital', value: "3"},
    distribution: { name: 'Distribution', value: "4"}
}));
//endregion


//region DOWNLOAD SOURCE
app.constant('accountCreation', Object.extended({
    default: {name: 'Default', value: "-1"},
    doNotCreate: {name: 'Don\'t Create', value: "0"},
    create: {name: 'Create', value: "1"},
    autoExclude: {name: 'AutoExclude', value: "3"}
}));

app.constant('confirmTransmitMethod', Object.extended({
    empty: {name: 'Zero', value: "0"},
    none: {name: 'None', value: "1"},
    ftp: {name: 'FTP', value: "2"},
    dsthttp: {name: 'DSTHTTP', value: "3"},
    network: {name: 'Network', value: "4"},
    sftp: {name: 'SFTP', value: "5"},
    ftps: {name: 'FTPS', value: "6"},
    s3: {name: 'S3', value: "9"},
}));

app.constant('patternMatchType', Object.extended({
    included: {name: 'Included', value: "0"},
    excluded: {name: 'Excluded', value: "1"}
}));

app.constant('positionOnlyReconcile', Object.extended({
    no: {name: 'No', value: "0"},
    yes: {name: 'AIP', value: "1"},
    enabledAccountsOnlyAIP: { name: 'Enabled Accounts Only AIP', value: "2" },
    enabledAccountsOnlyHAA: { name: 'Enabled Accounts Only HAA', value: "3" },
    hAA: { name: 'HAA', value: "4" }
}));

//endregion

//region INFORM COMPLIANCE
app.constant('informWorkflowStatus',Object.extended({
    new: {name: 'New', value: 0},
    notSubmitted: {name: 'Not Submitted', value: 1},
    submitted: {name: 'Submitted', value: 2},
    approved: {name: 'Approved', value: 3},
    denied: {name: 'Denied', value: 4},

    //used for brokerage accounts only
    closePending: {name: 'Close Pending', value: 6},
    closed: {name: 'Closed', value: 7},
    active: {name: 'Active', value: 8},

    //used for sending followup email to access person
    followUp: {name: 'Follow-up', value: 9},
    canceled: {name: 'Canceled', value: 10},

    brokenConnection: {name: 'Broken Connection', value: 16},
}));
//endregion


//region Plaid
app.constant('plaidEnvironmentChoices', Object.extended({
    sandbox: { name: "Sandbox", value: "Sandbox" },
    production: { name: "Production", value: "Production" }
}));

//endregion

//region Account Composer
app.constant('altDataRvwDefViewChoices', Object.extended({
    differencesOnly: { name: 'Differences only', value: 'differencesOnly' },
    allRecords: { name: 'All records', value: 'allRecords' }
}));
//endregion

// region PORTFOLIO TREE
app.constant('portfolioTreeTypes', Object.extended({
    portfolioTree: {name: "Portfolio Tree", value: 0},
    portfolioGroups: {name: "Portfolio Groups", value: 1},
    registrationsOnly: {name: "Registrations Only", value: 2},
    accountsOnly: {name: "Accounts Only", value: 3}
}));
//endregion

// region FIRM PROFILE
app.constant('collectionMethods', Object.extended({
    electronicFile: {name: "Electronic File", value: 1},
    feeList: {name: "Fee List", value: 2},
    copyofFeeForm: {name: "Copy of Fee Form", value: 3},
    originalFeeForm: {name: "Original Fee Form", value: 4},
    feeFormToCustodian: {name: "Fee Form to Custodian", value: 5}
}));
//endregion

// region Scheduler
app.constant('intervalType', Object.extended({
    minute: { name: 'Minute', value: "0" },
    hour: { name: 'Hour', value: "1" },
    day: { name: 'Day', value: "2" },
    week: { name: 'Week', value: "3" },
    month: { name: 'Month', value: "4" },
    quarter: { name: 'Quarter', value: "5" },
    year: { name: 'Year', value: "6" }
}));

app.constant('scheduleDaysOfWeek', Object.extended({
    monday: { name: 'Monday', value: "0x00000001" },
    tuesday: { name: 'Tuesday', value: "0x00000002" },
    wednesday: { name: 'Wednesday', value: "0x00000004" },
    thursday: { name: 'Thursday', value: "0x00000008" },
    friday: { name: 'Friday', value: "0x00000010" },
    saturday: { name: 'Saturday', value: "0x00000020" },
    sunday: { name: 'Sunday', value: "0x00000040" },
    everyday: { name: 'Everyday', value: "Monday | Tuesday | Wednesday | Thursday | Friday | Saturday | Sunday" },
    weekdays: { name: 'Weekdays', value: "Monday | Tuesday | Wednesday | Thursday | Friday" },
    weekends: { name: 'Weekends', value: "Saturday | Sunday" },
    tuesdayToSaturday: { name: 'TuesdayToSaturday', value: 'Tuesday | Wednesday | Thursday | Friday | Saturday' }
}));

app.constant('searchOption', Object.extended({
    topDirectoryOnly: { name: 'TopDirectoryOnly', value: "0" },
    allDirectories: { name: 'AllDirectories', value: "1" },
}));

//endregion Scheduler


'use strict';

app.service('$settings', ['activeState', function (activeState) {
    const self = this;

    const settings = {
        activeState : activeState.active,
        newAccountDays : null,
        confirmStartDate : Date.create((new Date()).isMonday() ? 'two days ago' : 'today'),
        confirmEndDate : Date.create('today'),
        portfolioListTreeLastData : null,
        pageQueryNames: {}
    };

    self.resetSettings = function( ) {
        settings.activeState = activeState.active;
    };

    self.setSetting = function( setting, value ) {
        settings[setting] = value;
    };

    self.clearSetting = function (setting) {
        settings[setting] = undefined;
    };

    self.getSetting = function( setting ) {
        return settings[setting];
    };

    self.getSettings = function( ) {
        return settings;
    };
}]);

'use strict';

app.factory('httpGlobalInterceptor', function($rootScope, $q, $injector, $location, $userMessages, API_CONFIG, loadingService) {
    let $dialog, $http, deferred, cancelPromise;
    const autoCompressionMarker = 5000000;
    
    function setupCancelPromise() {
        deferred = $q.defer();
        cancelPromise = deferred.promise;
    }

    // Cancel all pending requests when navigating away from a page
    $rootScope.$on('$locationChangeSuccess', function() {
        if (deferred) {
            deferred.resolve('Route changed - cancelling pending requests');
        }
        setupCancelPromise();
    });
    
    // Initialize the cancel promise
    setupCancelPromise();
    
    // Determine if a request should be cancelled on route change
    function shouldCancelRequest(config) {
        
        if (config.allowCancellation !== undefined) {
            return config.allowCancellation;
        }

        // GET requests are cancelled by default unless allowCancellation is explicitly set to false
        if (config.method === 'GET') {
            return true;
        }

        // (POST, PUT, DELETE, etc.) requests are only cancelled if allowCancellation is explicitly true
        return false;
    }
    //COMPRESSION HANDLER
    function estObjSize(obj){
        const typeSizes = {
            "undefined"(){return 0;},
            "boolean"(){return 4;},
            "number"(){return 8;},
            "string"(item){return 2 * item.length;},
            "object"(item){return !item ? 0 : Object.keys(item).reduce((total, key) => typeSizes[typeof key](key) + typeSizes[typeof item[key]](item[key]) + total, 0);}
        };

        return typeSizes[typeof obj](obj);
    }
    function setupGzip(config){
        config.transformRequest = function (data) {
            return window.pako.gzip(angular.toJson(data));
        };
        config.headers['Content-Encoding']='gzip';
        return config;
    }
    function compress(obj){
        switch(obj.encoding){
            case "gzip":
            default:
                return setupGzip(obj);
        }
    }
    //-------------------

    // Error responses can carry circular references (e.g. the promise-tracker
    // $promiseTrackerDeferred attached to config), which makes a plain
    // JSON.stringify throw and masks the real failure. Drop circular refs.
    function safeJsonStringify(value){
        const seen = new WeakSet();
        return JSON.stringify(value, function(key, val){
            if (val !== null && typeof val === 'object') {
                if (seen.has(val)) { return '[Circular]'; }
                seen.add(val);
            }
            return val;
        });
    }

    return {
        request: function (config) {

            config.requestStartTime = new Date();

            //COMPRESSION HANDLER
            if(config.compression === 'auto' && estObjSize(config.data) > autoCompressionMarker){ config = compress(config); }
            else if(config.compression === 'true'){ config = compress(config); }
            //-------------------


            if (!$dialog) {
                $dialog = $injector.get('$dialog');
            }
            if(!config.params) {
                config.params = {};
            }
			config.useOData = [undefined, true, 'true'].any(config.useOData);
            if(config.take > 0) {
                if(config.useOData){
                    config.params.$top = config.take;
                }else{
                    config.params.top = config.take;
                }
            }

            Object.each(config.params, function(name, param) {
                if(angular.isDate(param)) {
                    config.params[name] = param.serverFormatted();
                }
            });

            if ((!config.tracker || config.tracker === 'main') && config.trackerMsg) {
                loadingService.start(config.url, config.trackerMsg);
            }

            return $q.resolve(
                config.confirm ? $dialog.confirmAction(config.confirm.length ? config.confirm : "Are you sure you want to complete this action?").open() : $q.resolve('yes')
            ).then(function(confirm) {
                if (confirm !== 'yes') {
                    config.timeout = $q.resolve();
                    return config;
                }

                const url = config.url;
                if (url.startsWith("/") && !url.startsWith(API_CONFIG.baseUrl) && !url.startsWith("//")) {
                    config.url = API_CONFIG.baseUrl + url;
                    config.headers.App = "OrionConnect";
                    config.headers.AppPath = $location.path();

                    // Apply cancellation logic
                    if (shouldCancelRequest(config)) {
                        config.timeout = cancelPromise;
                    }
                }

                // FIXME: AppCtrl is tightly coupled to this line via changeset 210710
                // Every test that makes http requests needs to set up this property
                if (config.database == $rootScope.user.authorization.alClientId || !(config.database > 0)) {
                    config.database = $rootScope.user.authorization.alClientId;
                    return config;
                }

                return $injector.get('tokenFactory').getDatabaseToken(config.database).then(function (token) {
                    config.params.Authorization = token;
                    return config;
                });
            });



        },
        response: function (response) {
            const loadAllPages = [undefined, true, 'true'].any(response.config.loadAllPages);

            if (loadAllPages && Object.isArray(response.data) && !response.config.page && response.config.take > 0 && response.config.take === response.data.length) {
                const $http = $injector.get('$http');
                response.config.skip = response.data.length;
                response.pages = function (override) {
                    return $http.pages(angular.merge(response.config, override || {}));
                };
            }

            if ((!response.config.tracker || response.config.tracker === 'main') && response.config.trackerMsg) {
                loadingService.stop(response.config.url);
            }

            return response;
        },
        responseError: function(response) {
            if (response.config.trackerMsg) {
                loadingService.stop(response.config.url);
            }

            const ignore = response.config.ignoreExceptions;
            if (response.status === 401 || ignore === true || (angular.isArray(ignore) && ignore.any(response.status))) {
                return $q.reject(response);
            } else if (response.config.timeout) {
                return $q.reject(response);
            }

            let body;
            let message;
            const correlationId = response.headers('X-OAS-CorrelationId');
            const requestTotalTime = response.config.requestStartTime ? new Date(new Date() - response.config.requestStartTime).toISOString().substr(11, 12) : '00:00:00.000';

            if (angular.isObject(response.data)) {
                body = safeJsonStringify(response.data);

                if (response.data.userException) {
                    const ex = response.data.userException;
                    switch (ex.type) {
                        case "DetailedException":
                            message = "<ul><li>" + ex.detail.map(function(item) {return "<b>" + item.key.spacify().capitalize(true) + "</b>: " + item.value;}).join("</li><li>") + "</li></ul>";
                            break;
                        case "ListException":
                            message = "<ul><li>" + ex.detail.join("</li><li>") + "</li></ul>";
                            break;
                        default: //SimpleException
                            message = "<p>" + ex.detail + "</p>";
                    }
                } else {
                    message = '<pre class="pre-scrollable">' + body + '</pre>';
                }
            } else {
                body = angular.isString(response.data) ? response.data.escapeHTML() : "No Data";
                message = '<pre class="pre-scrollable">' + body + '</pre>';
            }

            let subject = response.status + " ERROR";
            let title = '<i class="fa fa-exclamation-circle fa-lg" aria-hidden="true"></i> ' + response.status + ' - Unknown Error';

            switch (response.status) {
                case 400:
                    title = '<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> 400 - Bad Request';
                    break;
                case 403:
                    title = '<i class="fa fa-lock fa-lg" aria-hidden="true"></i> 403 - Forbidden';
                    break;
                case 404:
                    title = '<i class="fa fa-question-circle fa-lg" aria-hidden="true"></i> 404 - Not Found';
                    break;
                case 409:
                    title = '<i class="fa fa-ban fa-lg" aria-hidden="true"></i> 409 - Conflict';
                    message = response.data.userException.detail;
                    break;
                case 500:
                    title = '<i class="fa fa-exclamation-circle fa-lg text-error" aria-hidden="true"></i> 500 - Internal Server Error';
                    break;
                case 504:
                    title = '<i class="fa fa-frown-o fa-lg" aria-hidden="true"></i> 504 - Timeout';
                    message = "Unfortunately the requested operation timed out.  You may need to try the action again.";
                    break;
                case -1:
                    title = '<i class="fa fa-exclamation-circle fa-lg" aria-hidden="true"></i> Connection Interrupted or Request aborted';
                    message = "Unfortunately the requested operation was interrupted.  The connection was open for " + requestTotalTime + ".";
                    break;
            }

            if (correlationId){
                message += '<p class="add-top-margin"><em>If you believe you have received this message in error, please include Reference ID <b>' + correlationId + '</b> in any correspondence.</em></p>';
            }

            if (response.config.trackerMsg) {
                message = "<h5>Failed Action: " + response.config.trackerMsg + '</h5>' + message;
                subject += ": " + response.config.trackerMsg;
            }

            if (!$dialog) {
                $dialog = $injector.get('$dialog');
            }

            if (response.status === 504 && response.config.method === "GET") {
                return $dialog.messageBox(title, "Hmm....we just wanted you to know things are fine, however this page is responding slowly.")
                    .open()
                    .then(function() {
                        if (!$http) {
                            $http = $injector.get('$http');
                        }

                        return $http(response.config);
                    });
            } else {
                $dialog.messageBox(title, message).open();
                response.errorDialogShown = true;

                //log a user message
                const rootNode = $location.path().split('/')[1].toLowerCase(); //attempt to pick the right app
                $userMessages.addMsg(rootNode, subject, body, "danger");
            }

            return $q.reject(response);
        }
    };
});

'use strict';

app.service('$oasRights', function (privilegeService) {
    //PRIVATE VARIABLES
    const self = this;
    let oas_rights = {};
    let isLoaded;


    //PRIVATE METHODS
    function convertPrivilegesToRights(privileges) {
        const privilegeToRightMap = {
            //Apps
            orionRiskProposal: ["ORIONRISKPROPOSAL"],
            wealthscapeFBSInsight: ["WEALTHSCAPE_FBS_INSIGHT"],
            wealthscapeNFSInsight: ["WEALTHSCAPE_NFS_INSIGHT"],
            fidelityStreetscape: ["FIDELITYSTREETAPP"],
            fidelityWealthscape: ["FIDELITYWEALTHAPP"],
            fidelityIntegration: ["FIDELITYINTEGRATION"],
            tDAmeritrade: ["TDAPP"],
            charlesSchwab: ["SCHWABAPP"],
            allegisApps: ["ALLEGISAPPS"],
            aTARiskStation: ["ATARISKSTATION"],
            portfolioLists: ["PORTFOLIOLISTSAPP"],
            signOffs: ["SIGNOFFAPP"],
            firmProfile: ["FIRMPROFILEAPP"],
            advisoryFeeReports: ["ADVFEERPTAPP"],
            advisoryWorldSso: ["ADVISORYWORLDRPTS"],
            advisoryWorldProposal: ["ADVISORYWORLDPROPOSAL"],
            assistMeHelp: ["ASSISTHELP"],
            accountBondTrade: ["ACCOUNTBONDTRADE"],
            analystDatabaseAssignment: ['ANALYSTDATABASEASSIGNMENT'],
            basisCode: ["BASISCODE"],
            benchmarkAssign: ["BENCHMARKASSIGN"],
            benchmark: ["BENCHMARK"],
            benchmark_7: ["BENCHMARK_7"],
            benchmark_6: ["BENCHMARK_6"],
            benchmark_5: ["BENCHMARK_5"],
            benchmark_39: ["BENCHMARK_39"],
            billGenerator: ["BILLGENERATOR"],
            consolidatedBilling: ["CONSOLIDATEDBILLING"],
            billingAudit: ["BILLAUDIT", "MOCKBILLS", "AUDITFILES"],
            blendedBenchmarks: ["INDEXBLEND"],
            clientPortal: ["CLIENTPORTAL"],
            clientExperience: ["CLIENTEXPERIENCE"],
            convexRebalanceManag: ["CONVEXREBALANCE"],
            confirmationOverview: ["CONFIRMOVERVIEWAPP", "CONFIRM_CONFIRMMANAG", "SS_SCRUBS", "CONFIRM_DWNLDFILEOC", "CONFIRMDASHSIGNOFF", "CONFIRMGROUPS", "CONFIRMSIGNOFF", "CONFIRMOVERVIEW"],
            newConfirmReprocessHandling: ["NEWCONFIRMREPROCESSHANDLING"],
            reImportConfirmFilesBySource: ["REIMPORTCONFIRMFILESBYSOURCE"],
            allowReconfirm: ["ALLOWRECONFIRM"],
            testFileExport:["TESTFILEEXPORT"],
            newAccountCenterExcl: ["DOWNLOADEXCLUSION"],
            corporateActions: ["CORPACTIONDASH", "CORPACTION"],
            databaseBackupFileRestore: ["DATABASEBACKUPFILERESTORE"],
            dataQueries: ["TM_DATAQUERY"],
            dataQueryAdmin: ["DATAQUERY_ADMIN"],
            dataQueryDescr: ["DATAQUERY_EDITDESCR"],
            dataQueryFtp: ["DATAQUERYFTP"],
            dataQueryToCustomImportAdmin: ["DATAQUERYTOCUSTOMIMPORTADMIN"],
            everplans: ["EVERPLANS"],
            feeCalculator: ["FEECALCULATORAPP"],
            finametrica: ["FINAMETRICA"],
            geminiFundApp: ["GEMINIFUNDAPP"],
            groupingManager: ["GROUPINGMANAGER"],
            orionRiskApp: ["ORIONRISKAPP"],
            householdOverview: ["HOUSEHOLDOVERVIEW"],
            householding: ["HOUSEHOLDINGAPP", "MOVEACCOUNT", "MOVEREGISTRATION"],
            implementation2: ["IMPLEMENTATION2"],
            insightBuilder: ["INSIGHTBUILDERAPP"],
            interfaceRecon: ["INTERFACERECON"],
            models: ["MODELS", "MODELACCT"],
            communityModels: ["COMMUNITYMODELS"],
            modelRestrictions: ["MODELRESTRICTIONS"],
            modelRanges: ["MODELRANGES"],
            moneyGuidePro: ["MONEYGUIDEPRO"],
            newAccountsCenter: ["NEWACCOUNT"],
            masterClientListImport: ["NEWACCOUNTCENTERMCLIMPORT"],
            notifications: ["NOTIFICATIONS", "NOTIFICATIONSGROUP"],
            onboardingAdmin: ['ONBOARDINGADMIN'],
            parentCategories: ['PARENTCATEGORIES'],
            performanceViewer: ["PERFVIEWER"],
            performanceViewer3: ["PERFVIEWERIII"],
            performanceCompare: ["PERFCOMPARE"],
            portfolioViewAdmin: ["PORTFOLIOVIEWADMIN"],
            postPayments: ["POSTPAYMENTS"],
            prairiesmart: ["PRAIRIESMARTS"],
            useLocalPricesOnly: ["USELOCALPRICESONLY"],
            performanceAdmin: ["PERFORMANCEADMIN"],
            productsAndPrices: ["PRODSANDPRICESAPP", "SUBHOLDING", "TAXEXEMPTIONS", "PREFERREDRATES", "PRICEFACTORS", "PRODUCTBONDCALL", "DIVIDENDS"],
            qpeDashboard: ["QPEDASHBOARD", "ESTATEMENTEMAILTEXT"],
            queryStudioQueries: ["QUERYSTUDIOQUERIES"],
            processManager: ["PROCESSMANAGER"],
            referralPayments: ["REFERRALSCHEDULE"],
            reportBatches: ["REPORTBATCH", "REPORTBATCHNEW"],
            reportBuilder: ["REPORTBUILDERNEW"],
            reportInbox: ["REPORTINBOXAPP"],
            legacyReports: ["LEGACYREPORTS"],
            restoreAccounts: ["RESTOREACCOUNTS"],
            riskAlyze: ["RISKALYZEAPP"],
            rmdDashboard: ["RMDDASHBOARDAPP"],
            reports: ["REPORTMENU"],
            schwabsii: ["SCHWABSII"],
            sfSyncHistory: ["SFSYNCHISTORY", "SALESFORCEUSER"],
            secureExchange: ["SECUREXCHNGAPP"],
            selfService: ["REPSELFSERVICE"],
            sleeves: ["SLEEVESETUP", "HASSUBADVISORS", "SLEEVES"],
            sleeveTransferPortfolio: ["SLEEVETRANSFERPORTFOLIO"],
            sleeveStrategy: ["SLEEVE_STRATEGY"],
            subreportBuilder: ["SUBREPORTBUILDER"],
            systemTradeQueue: ["SYSTEMTRADEQUEUE"],
            taxCenter: ["TAXCENTERAPP"],
            taxCenterMaintenance: ["TAXCENTERMAINTAIN"],
            taxFormDownloads: ["TAXFORMDOWNLOADS"],
            tom: ["TRADEORDERMGMT", "TRADEINSTANCES"],
            tRXExport: ["TRXEXPORT"],
            emailPasswordTemplates: ["EMAILPASSWORDTEMPLATES"],
            accountAssignments: ["ACCOUNTASSIGNMENTS"],
            deliver3: ["RB3DELIVER"],
            byAllSsoRep: ["BYALLSSOREP"],
            hypotheticalMonthlyPerformance: ["HYPOTHETICAL_MTHLY_PERF"],
            cusipAdmin: ["CUSIPADMIN"],
            cusipAccess: ["CUSIPACCESS"],
            custodialIntegrator: ["CUSTODIALINTEGRATOR"],
            astroLight: ["ASTROLIGHT"],
            orionEnterpriseProposal: ["ORIONENTERPRISEPROPOSAL"],
            blackRock: ['BLACKROCK'],
            businessIntelligence: ["TRENDS"],
            batchPerformance: ["BATCHPERFORMANCE"],
            advizr: ["ADVIZR"],
            customImports2: ['CUSTOMIMPORTS2'],
            customImportsColumnConfiguration: ['CUSTOMIMPORTSCOLUMNCONFIGURATION'],
            multiDbCustomImport: ['MULTIDBCUSTOMIMPORT'],
            accountComposer: ['ACCOUNTCOMPOSER'],
            fCSLending: ["FCSLENDING"],
            orionVision: ["ORIONVISION"],
            dataMaintenance: ["DATAMAINTENANCE"],
            //Records
            assets: ["ASSETS", "ASSLEVELSTRATASSIGN", "MOVEASSET"],
            bondRates: ["BONDRATES"],
            brokerDealers: ["BROKERDEALERS"],
            brokerDealerRevenueShares: ["BROKERDEALERREVENUESHARES"],
            businessLines: ["BUSINESSLINE"],
            complianceRiskDashboard: ["COMPLIANCERISKDASHBOARD"],
            complianceRiskDashboardSettings: ["COMPLIANCERISKDASHBOARDSETTINGS"],
            compositeAccounts: ["COMPOSITEACCOUNT"],
            costBasis: ["COSTBASIS"],
            custodians: ["CUSTODIAN"],
            custodianPriceHierarchy: ["CUSTODIANPRICEHIERARCHY"],
            feeSchedules: ["FEESCHEDULES"],
            fundFamilies: ["FUNDFAMILIES"],
            fundFamilyCollectionMethod: ["FUNDFAMILYCOLLECTIONMETHOD"],
            globalFundFamilies: ["GLOBALFUNDFAMILIES"],
            globalPrices: ["PRICES"],
            globalProducts: ["GLOBALPRODUCT"],
            globalPriceReview: ["GLOBALPRICEREVIEW"],
            managementStyles: ["MGMTSTYLES"],
            payeeRecords: ["PAYEE"],
            payoutSchedules: ["MASTERPAYOUTSCHEDULE"],
            payoutDashboard: ["PAYOUTDASHBOARD"],
            payoutRates: ["PAYOUTSCHEDULES"],
            plans: ["401KPLAN"],
            portfolioClientAccount: ["CLIENTS", "REGISTRATIONS", "ACCOUNTS", "ENTITYOPTION", "ACCTSTATUSCHG"],
            portfolioConvertAccount: ["PORTFOLIOCONVERTACCOUNT"],
            customFields: ["CUSTOMFIELDS"],
            ftjPendAccounts: ['FTJPENDACCOUNTS'],
            pricesLocal: ["LOCALPRICES"],
            localPriceImport: ["LOCALPRICEIMPORT"],
            products: ["PRODUCTS"],
            securityClassificationSetup: ["SECURITYCLASSIFICATIONSETUP"],
            securityClassAssignment: ["SECURITYCLASSASSIGNMENT"],
            riskCat: ["RISKCAT"],
            receivables: ["RECEIVABLES"],
            referralSchedules: ["REFERRALSCHEDULE"],
            regTypes: ["REGTYPES"],
            representative: ["REPS"],
            rias: ["RIAS"],
            subadvisors: ["SUBADVISORS"],
            transactions: ["TRANSACTIONS"],
            manuallyManaged: ['MANUALLYMANAGED'],
            wholesaler: ["WHOLESALERS"],
            roleManagement: ["MUL_ROLES"],
            userManagement: ["MUL_USERS"],
            privilegeManagement: ["MUL_PRIVILEGES"],
            matrixb50records: ["MATRIXB50RECORDS"],
            mulWholesaler: ["MUL_WHOLESALER"],
            mulBrokerDealer: ["MUL_BROKERDEALER"],
            mulCotenant: ["MUL_COTENANT"],
            mulRepAcctManager: ["MUL_REPACCOUNTMGR"],
            mulPayee: ["MUL_PAYEE"],
            downloadFormats: ["DOWNLOADFORMATS"],
            formatXmlVersions: ["FORMATXMLVERSIONS"],
            FormatRecTypeEditor: ["FORMATRECTYPEEDITOR"],
            downloadSources: ["DOWNLOADSOURCES"],
            downloadSourceNotes: ["DOWNLOADSOURCENOTES"],
            localexclusions: ["LOCALEXCLUSIONS"],
            sleeveSettings: ["SLEEVESETTINGS"],
            positionProcesses: ["POSITIONPROCESSES"],
            AUTOSCRUBRULES: ["AUTOSCRUBRULES"],
            globalExclusions: ["GLOBALEXCLUSIONS"],
            uploadTargets: ["UPLOADTARGETS"],
            uploadTargetsPasswords: ["UPLOADTARGETSPASSWORDS"],
            schedulerMaintenance: ["SCHEDULERMAINTENANCE"],
            portfolioBilling: ["ACCTBILLING", "ASSETBILLING", "CLIENTBILLING", "ACCTFEEANDPAYOUTCBO", "CREDITCARDVIEWING", "HOUSEHOLDINGAPP"],
            billAppFeePayout: ['BILLAPPFEEPAYOUT'],
            fileImportApp: ['BLOBIMPORT'],
            separatelyManagedAccount: ["SMA"],
            targetAllocation: ["TARGETALLOCATION"],
            suitability: ["INVESTMENTOBJ", "INVOBJATCLIENTLEVEL"],
            futureCashFlows: ["FUTURECASHFLOWS"],
            goals: ["GOALS"],
            growthRates: ["GROWTHRATES"],
            inflationRates: ["INFLATIONRATES"],
            creditCardInfo: ["CREDITCARDINFO"],
            eclipseTrading: ["ECLIPSETRADING"],
            eclipseOrionAdmin: ['ECLIPSEORIONADMIN'],
            changeDoNotTrade: ['CHANGEDONOTTRADE'],
            integrationsSetup: ['INTEGRATIONSSETUP'],
            integrationCredentials: ['INTEGRATIONCREDENTIALS'],
            advisorProducts: ['ADVISORPRODUCTS'],
            portfolioGroups: ['PORTFOLIOGROUPS'],
            billingLockdownOverride: ['BILLINGLOCKDOWNOVERRIDE'],
            includeInAggregate: ['INCLUDEINAGGREGATE'],
            belowtheLineAssets: ['BELOWTHELINEASSETS'],
            useFeeHierarchyAccountEdit: ['USEFEEHIERARCHYACCOUNTEDIT'],
            compassAudit: ['COMPASSAUDIT'],
            complianceAdminOnly: ['COMPLIANCEADMINONLY'],
            compassInform: ['COMPASSINFORM'],
            complianceSupervise: ['COMPLIANCESUPERVISE'],
            complianceDisclose: ['COMPLIANCEDISCLOSE'],
            complianceVerify: ['COMPLIANCEVERIFY'],
            complianceArchive: ['COMPLIANCEARCHIVE'],
            informAudit: ['INFORMAUDIT'],
            inform: ['INFORM'],
            informConcur: ['INFORMCONCUR'],
            resetAssetClasses: ['RESETASSETCLASS'],
            productNameTranslation: ['PRODUCTNAMETRANSLATION'],
            portfolioBillingPayees: ['PORTFOLIOBILLINGPAYEES'],
            portfolioBillingGeneralAccount: ['PORTFOLIOBILLINGGENERALACCOUNT'],
            portfolioBillingRecurringAdjustments: ['PORTFOLIOBILLINGRECURRINGADJUSTMENTS'],
            householdBillingRecurringAdjustments: ['HOUSEHOLDBILLINGRECURRINGADJUSTMENTS'],
            orionEnterpriseMaintenance: ['ORIONENTERPRISEMAINTENANCE'],
            transactionTypeSuppression: ['TRANSACTIONTYPESUPPRESSION'],
            downloadFormatMarkup: ['DOWNLOADFORMATMARKUP'],
            formatSubtype: ['FORMATSUBTYPE'],
            downloadSourcesPasswords: ['DOWNLOADSOURCESPASSWORDS'],
            unmanagedAssetsInclusion: ['UNMANAGEDASSETSINCLUSION'],
            excludeAssetFromRebalance: ['EXCLUDEASSETFROMREBALANCE'],
            downloadFiles: ['DOWNLOADFILES'],
            assetClassAbbreviation: ['ASSETCLASSABBREVIATION'],
            homepageDashboard: ['HOMEPAGEDASHBOARD'],
            taxRates: ['TAXRATES'],
            reportThemes: ['REPORTTHEMERIGHTS'],
            reportThemeCustomStyles: ['REPORTTHEMECUSTOMSTYLES'],
            coverPages: ['REPORTCOVERPAGERIGHTS'],
            localProductNameOverride: ['LOCALPRODUCTNAMEOVERRIDE'],
            mappingTables: ['MAPPINGTABLES'],
            newAccountsCenterMatrixb50AccountSetup: ["MATRIXB50"],
            editOCISync: ["EDITOCISYNC"],
            accountAssetPriceHierarchy: ["ACCOUNTASSETPRICEHIERARCHY"],
            dataSharing: ["DATASHARING"],
            portfolioRepresentativePayouts: ['PORTFOLIOREPRESENTATIVEPAYOUTS'],

            //Actions
            assetClassAutoAssign: ["PRODDESCMAIN"],
            assetClassAutoAssignRun: ["ASSETCLASSAUTOASSIGNRUN"],
            assetClasses: ["ASSETCLASSES"],
            productCategory: ["PRODUCTCATEGORY"],
            cancellation: ["UNDOACCTCANCEL", "CANCELACCOUNT"],
            decryptedSSN: ["SSNVIEW", "SSNCHANGE"],
            execTrades: ["EXECTRADES"],
            systematics: ["SYSTEMATICS"],
            accountChange: ["ACCOUNTCHANGE"],
            prodEntityExclude: ["PRODENTITYEXCLUDE"],
            bondRating: ["BONDRATING"],
            historicalAssets: ["HISTORICALASSETS"],
            clientSmsSettings: ["CLIENTSMSSETTINGS"],
            advisorInfo: ["ADVISORINFO", "SERVICETEAMASSIGN"],
            modelaggs: ["MODELAGGS", "MODELAGGPERMS"],
            associatedModelAgg: ["ASSOCIATEDMODELAGG"],
            tradeTactical: ["TRADETACTICAL"],
            tradeActions: ["CREATEFEEFROMDIST", "ENABLEALLORDERS", "FIXALLOC", "FIXEXEC", "FIXORDERNOTES", "FIXTRADING", "MSCSREINVESTASSET", "REBALANCEMODEL"],
            deleteAllOrders: ["DELETEALLORDERS"],
            completePendings: ["COMPLETEPENDINGS"],
            changeTradingPortfolioGroups: ["CHANGETRADINGPORTFOLIOGROUPS"],
            changeSentStatus: ["CHANGESENTSTATUS"],
            changeActiveStatus: ["ACTIVESTATUS"],
            changeManagedStatus: ["MANAGEDSTATUS"],
            editApprovedTrades: ["EDITAPPROVEDTRADES"],
            resetUser: ["MUL_RESETUSER"],
            createSameEntity: ["MUL_SAMEENTITY"],
            newUserImport: ["MUL_NEWUSERIMPORT"],
            newAccountWizard: ["NEWACCOUNTWIZ"],
            documentsAndNotes: ["DOCUMENTS", "NOTES"],
            deleteSysGenDocuments: ["DOCDELSYSGEN"],
            accountModelMaint: ["ACCTMODELMAINT"],
            reportGroupHousehold: ["REPORTGROUPHOUSEHOLD"],
            externalRegistrations: ["EXTERNALREGISTRATIONS"],
            reportBatchAdmin: ["REPORTBATCH_ADMIN"],
            reportBatchInternalSettings: ["REPORTBATCH_INTERNAL"],
            portfolioTargets: ["PORTFOLIOTARGETS"],
            portfolioViewCompare: ["PORTFOLIOVIEWCOMPARE"],
            bluePay: ["BLUEPAY"],
            flagForDAZL: ["FLAGFORDAZL"],
            dailyAnnuityValue: ["DAILYANNUITYVALUE"],
            laserApp: ["LASERAPP"],
            reportBuilderAdmin: ["EDITALLRPTS"],
            reportBuilderAdvancedEditor: ["REPORTBUILDERADVANCEDEDITOR"],
            reportSettings: ["REPORTSETTINGS"],
            rB3IntegrationsMenu: ["RB3INTEGRATIONSMENU"],
            restoreReports: ["RESTOREREPORTS"],
            riskalyzeProposal: ["RISKALYZEPROPOSAL"],
            databaseGroup: ["DB_GROUPING"],
            sleeveSetup: ["SLEEVESETUP"],
            sleeveTransfer: ["SLEEVETRANSFER"],
            schwabManagementFeeUpload: ["SCHWABMANAGEMENTFEEUPLOAD"],
            schwabServiceRequestBETA: ["SCHWABSERVICEREQUESTBETA"],
            schwabAddressChange: ["SCHWABADDRESSCHANGE"],
            tDAManagementFeeUpload: ["TDAMANAGEMENTFEEUPLOAD"],
            storedPerformance: ["STOREDPERFORMANCE"],
            communities: ["COMMUNITIES"],
            multipleDatabaseRecon: ["MULTIPLEDATABASERECON"],
            schwabDigitalAccountOpening: ["SCHWABDIGITALACCOUNTOPENING"],
            tDADigitalAccountOpening: ["TDADIGITALACCOUNTOPENING"],
            wealthscapeDigitalAccountOpening: ["WEALTHSCAPEDIGITALACCOUNTOPENING"],
            streetscapeDigitalAccountOpening: ["STREETSCAPEDIGITALACCOUNTOPENING"],
            blackrockAnalyzer: ["BLACKROCKANALYZER"],
            communityUrlBeta: ["COMMUNITYURLBETA"],
            financialPlanningFee: ['FINANCIALPLANNINGFEE'],
            bizEquity: ["BIZEQUITY"],
            manualPriceConfirm: ["MANUALPRICECONFIRM"],
            aSTROEclipseAssetRestrictions: ["ASTROASSETRESTRICTIONS"],
            aSTROEclipseSectorIndustryConstraints: ["ASTROSECTORINDUSTRYCONSTRAINTS"],
            aSTROEclipseESGConstraints: ["ASTROESGCONSTRAINTS"],
            pershingIntegration: ["PERSHINGINTEGRATION"],
            aDVClientCategory: ["ADVCLIENTCATEGORY"],
            homepageAdmin: ["HOMEPAGEADMIN"],
            corpActionV2Skip: ["CORPACTIONV2SKIP"],
            corpActionProcessingDelete: ["CORPACTIONPROCESSINGDELETE"],
            deleteCustomImports: ["DELETECUSTOMIMPORTS"],
            indexProductSearch: ["INDEXPRODUCTSEARCH"],
            addMissingTickerCusip: ["ADDMISSINGTICKERCUSIP"],
            orionStoredCostBasisManualCalc: ["ORIONSTOREDCOSTBASISMANUALCALC"],
            orionStoredCostBasisManualCalcOverride: ["ORIONSTOREDCOSTBASISMANUALCALCOVERRIDE"],
            feeHierarchy: ["FEEHIERARCHY"],
            hideIntegrationsTab: ["HIDEINTEGRATIONSTAB"],
            globalMapping: ["GLOBALMAPPING"],
            rmd: ['RMD'],
            beneficiaryTrust: ['BENEFICIARYTRUST'],

            //Advanced
            noFeeAggregate: ["NOFEEAGGREGATE"],
            realtimePrices: ["REALTIMEPRICING"],
            adminSettings: ["GLOBALREPORTADMIN"],
            appsSetup: ["APPS"],
            equityTrust: ["EQUITYTRUSTAPP"],
            requireTwoFactor: ["REQTWOFACTOR"],
            loginSamlOnly: ["LOGINSAMLONLY"],
            createGlobalViews: ["GLOBALVIEW"],
            clientPortalDownload: ["CLIENTPORTALAVDWNLDS"],
            requireAdvisorNum: ["REQADVNUMFORDB"],
            reportParamsDefaults: ["STNDRDRPTSECURITYBTN", "RPTSVC_PARAMS", "RPTSVC_PARAMS_ENTITY"],
            portfolioBillingAllow: ["BILLINGEXCEPTION"],
            entityOptionsOwner: ["ENTITYOPTIONSOWNER"],
            transactionsAdvisorNotes: ["TRANSACTIONNOTES"],
            editClosedOrderPrice: ["EDITCLOSEDORDERPRICE"],
            compassAuditLibrary: ["COMPASSAUDITLIBRARY"],
            compassAuditAdmin: ["COMPASSAUDITADMIN"],
            lexisNexis: ["LEXISNEXIS"],
            createOCDatabases: ["CREATEOCDATABASES"],
            databaseActions: ["DATABASEACTIONS"],
            dbeo_Administration: ["DBEO_ADMINISTRATION"],
            dbeo_AdvisorMaintained: ["DBEO_ADVISORMAINTAINED"],
            dbeo_BenchmarkIndexes: ["DBEO_BENCHMARKINDEXES"],
            dbeo_Billing: ["DBEO_BILLING"],
            dbeo_Compliance: ["DBEO_COMPLIANCE"],
            dbeo_Composites: ["DBEO_COMPOSITES"],
            dbeo_Communities: ["DBEO_COMMUNITIES"],
            dbeo_Confirmation: ["DBEO_CONFIRMATION"],
            dbeo_Crm: ["DBEO_CRM"],
            dbeo_Exports: ["DBEO_EXPORTS"],
            dbeo_FixTrading: ["DBEO_FIXTRADING"],
            dbeo_Integration: ["DBEO_INTEGRATION"],
            dbeo_Maintenance: ["DBEO_MAINTENANCE"],
            dbeo_Model: ["DBEO_MODEL"],
            dbeo_NewAccounts: ["DBEO_NEWACCOUNTS"],
            dbeo_NFSFeeFile: ["DBEO_NFSFEEFILE"],
            dbeo_PageSetup: ["DBEO_PAGESETUP"],
            dbeo_Performance: ["DBEO_PERFORMANCE"],
            dbeo_PerformanceCalculator: ["DBEO_PERFORMANCECALCULATOR"],
            dbeo_Portfolio: ["DBEO_PORTFOLIO"],
            dbeo_Pricing: ["DBEO_PRICING"],
            dbeo_Reports: ["DBEO_REPORTS"],
            dbeo_SalesForceIntegration: ["DBEO_SALESFORCEINTEGRATION"],
            dbeo_Security: ["DBEO_SECURITY"],
            dbeo_SleeveTrading: ["DBEO_SLEEVETRADING"],
            dbeo_TaxCalculations: ["DBEO_TAXCALCULATIONS"],
            dbeo_Trading: ["DBEO_TRADING"],
            dbeo_TwoFactor: ["DBEO_TWOFACTOR"],
            dbeo_OrionEnterprise: ["DBEO_ORIONENTERPRISE"],
            afterTaxBenchmarkAssumedRates: ["ASSUMEDRATES"],
            sFSyncSetup: ["SFSYNCSETUP"],

            //Feature Flags
            assetPriceHistory: ["ASSETPRICEHISTORY"]
        };

        if (!privileges) {
            privileges = Object.keys(privilegeToRightMap).reduce((map, code) => {
                const privilege = privilegeService.get(code);
                const accessAsString = (privilege.canRead ? 'R' : '') + (privilege.canEdit ? 'E' : '') + (privilege.canDelete ? 'D' : '');
                if (accessAsString) {
                    map[code] = accessAsString;
                }
                return map;
            }, {});

            localStorage.oas_privileges = JSON.stringify(privileges);
        }

        oas_rights = {};
        Object.each(privileges, function (privilegeCode, privilegeAccess) {
            const rightList = privilegeToRightMap[privilegeCode];
            if (rightList && privilegeAccess) {
                rightList.forEach(function (right) {
                    oas_rights[right] = privilegeAccess.replace('E', 'CU');
                });
            }
        });
    }

    function init() {
        if (localStorage.oas_privileges) {
            convertPrivilegesToRights(JSON.parse(localStorage.oas_privileges));
        }

        isLoaded = privilegeService.isLoaded
            .then(function () {
                convertPrivilegesToRights();
            });
    }

    function checkRights(code, crudLetter) {
        return (oas_rights[code.toUpperCase()] || '').has(crudLetter);
    }


    //INITIALIZE
    init();


    //PUBLIC METHODS
    self.isLoaded = isLoaded;

    self.canAdd = function (code) {
        return checkRights(code, 'C');
    };

    self.canRead = function (code) {
        return checkRights(code, 'R');
    };

    self.canUpdate = function (code) {
        return checkRights(code, 'U');
    };

    self.canDelete = function (code) {
        return checkRights(code, 'D');
    };

    self.forCode = function (code) {
        return { canAdd: self.canAdd(code), canRead: self.canRead(code), canUpdate: self.canUpdate(code), canDelete: self.canDelete(code) };
    };
});

'use strict';

app.service('$userMessages', function() {
    //PRIVATE VARIABLES
    var unreadCount = {success: 0, warning: 0, error: 0, info: 0};
    var messages = [];
    var self = this;

    //PRIVATE METHODS
    var add = function (app, subject, body, type) {
        type = type || "info";
        var msgType;
        switch (type.toLowerCase()) {
            case "success":
                msgType = "success";
                break;
            case "warning":
                msgType = "warning";
                break;
            case "error":
            case "danger":
                msgType = "error";
                break;
            default:
                msgType = "info";
        }

        var time = Date.create().format('{M}/{d}/{yyyy} {12hr}:{mm}:{ss} {TT}');
        if (messages.unshift({app: app, subject: subject, body: body, type: msgType, received: time, read: false}) > 20) {
            var lastMsg = messages.last();
            if (!lastMsg.read) unreadCount[lastMsg.type] -= 1;
            messages.pop();
        }

        unreadCount[msgType] += 1;
    };

    var markRead = function(msg) {
        if (!msg.read) {
            msg.read = true;
            unreadCount[msg.type] -= 1;
        }
    };

    //PUBLIC OBJECTS
    self.messages = messages;
    self.unreadCount = unreadCount;

    //PUBLIC METHODS
    self.addMsg = function(app, subject, body, type) {
        switch (app.toLowerCase()) {
            case "trading":
                self.addTradingMsg(subject, body, type);
                break;
            case "reports":
                self.addReportsMsg(subject, body, type);
                break;
            case "general":
                self.addGeneralMsg(subject, body, type);
                break;
            default:
                add("Unknown", subject, body, type);
                break;
        }
    };

    self.addGeneralMsg = function(subject, body, type) {
        add("General", subject, body, type);
    };

    self.addTradingMsg = function(subject, body, type) {
        add("Trading", subject, body, type);
    };

    self.addConfirmationMsg = function(subject, body, type) {
        add("Confirmation", subject, body, type);
    };

    self.addReportsMsg = function(subject, body, type) {
        add("Reports", subject, body, type);
    };

    self.markRead = function(index) {
        var msg = messages[index];
        markRead(msg);
    };

    self.markAllRead = function() {
        messages.forEach(function (msg) {markRead(msg);});
    };

    self.delete = function(index) {
        var msg = messages[index];
        markRead(msg);
        messages.splice(index, 1);
    };

    self.deleteAll = function() {
        messages.length = 0;
        unreadCount.success = 0;
        unreadCount.warning = 0;
        unreadCount.error = 0;
        unreadCount.info = 0;
    };
});
'use strict';

app.service('$signalRManager', function ($rootScope) {

    // PRIVATE VARIABLES
    var isListening = false;
    var subscribedHubs = [];
    var resultCache = {};

    var self = this;


    // PRIVATE METHODS
    function stopListeningToHub(hub, hubMethod, restartHubs) {
        var foundHub = subscribedHubs.find({name: hub, method: hubMethod});

        if (foundHub) {
            $.connection[hub].off(hubMethod);

            if (restartHubs) {
                restartAllHubs();
            }

            subscribedHubs.remove(foundHub);
        } else {
        }
    }

    function restartAllHubs() {
        $.connection.hub.stop();
        $.connection.hub.start();
    }

    function restartAllHubsV2(hub) {
        $.connection.hub.stop();
        $.connection.hub.start().done(() => {
            $rootScope.connectedToSignalRHub = hub;
            $rootScope.$broadcast('$connectedToSignalR')       
        });
    }

    // PUBLIC METHODS
    self.subscribeToHub = function (hub, hubMethod, cacheKey, fnCallBack) {
        if (subscribedHubs.none({name: hub, method: hubMethod})) {
            subscribedHubs.push({name: hub, method: hubMethod});

            $.connection[hub].on(hubMethod, function (result) {
                if (cacheKey) {
                    if (resultCache[hub + hubMethod] == result[cacheKey]) {
                        return;
                    }

                    resultCache[hub + hubMethod] = result[cacheKey];
                }

                $rootScope.$apply(function () {
                    fnCallBack(result);
                });
            });

            if (isListening) {
                restartAllHubs();
            } else {
                $.connection.hub.start();
                isListening = true;
            }
        } else {
        }
    };

    self.subscribeToHubV2 = function (hub, hubMethod, cacheKey, fnCallBack) {
        if (subscribedHubs.none({name: hub, method: hubMethod})) {
            subscribedHubs.push({name: hub, method: hubMethod});

            $.connection[hub].on(hubMethod, function (result) {
                if (cacheKey) {
                    if (resultCache[hub + hubMethod] == result[cacheKey]) {
                        return;
                    }

                    resultCache[hub + hubMethod] = result[cacheKey];
                }

                $rootScope.$apply(function () {
                    fnCallBack(result);
                });
            });

            if (isListening) {
                restartAllHubsV2(hub);
            } else {
                $.connection.hub.start();
                isListening = true;
            }
        } else {
        }
    };

    self.unSubscribeToHub = function (hub, hubMethod) {
        stopListeningToHub(hub, hubMethod, false);
    };

    self.stopAllHubs = function () {
        if (!subscribedHubs.length) return;

        subscribedHubs.forEach(function (hub) {
            if (hub.name !== 'fuseHub') {
                stopListeningToHub(hub.name, hub.method, false);
            }
        });

        restartAllHubs();
    };

    /**
     * Calls a method on the server hub (browser -> server), starting the shared connection first if needed.
     * Returns a jQuery promise.
     *
     * Why this exists:
     * Most hubs know what to listen for when the connection starts (a query string id, or the user/firm).
     * Some pages only learn what to listen for later, from an API response. Example: the bill instance
     * list page gets the bill instance ids back from Recalculate Payables/Payees, then calls
     * billRecalcHub.watchBillInstances(ids) so the server starts forwarding those instances' completions.
     *
     * Usage: invokeHubMethod('billRecalcHub', 'watchBillInstances', [1, 2, 3]);
     */
    self.invokeHubMethod = function (hub, serverMethod) {
        var args = Array.prototype.slice.call(arguments, 2);
        var proxy = $.connection[hub];
        var call = function () {
            return proxy.server[serverMethod].apply(proxy.server, args);
        };

        if ($.connection.hub.state === $.signalR.connectionState.connected) {
            return call();
        }

        return $.connection.hub.start().then(call);
    };

    self.setQueryStringParam = function (key, value) {
        $.connection.hub.qs[key] = value;
    };
    self.deleteQueryStringParam = function (key) {
        delete $.connection.hub.qs[key];
    };
});


app.service('$notifications', function ($signalRManager, $q, $http, $sce, ngToast, notificationStatus, notificationActions, $timeout, API_CONFIG, $log) {

    // LOCAL CONSTANTS
    var MIN_FOR_AGGREGATE_VIEW = 10;

    // PRIVATE VARIABLES
    var self = this;
    var internal = {
        // Use an ordered map here so we can do some fancy stuff for a better api and
        // keeping categories ordered by most recent notification
        data: [],
        lastUpdate: null,
        settings: {
            filter: 'Unread'
        },
        counts: {read: 0, unread: 0}
    };

    var userSettings;


    // PRIVATE METHODS
    function addNewNotification(item, sendNotification) {
        item.body = item.body.replace(new RegExp('\n', 'g'), '<br />');
        setDateGroup(item);
        addNotificationToCategoryInPartnerApp(item);
        internal.lastUpdate = Date.create();

        // If the user agreed to get notified
        // Let's try to send ten notifications
        if (sendNotification && window.Notification && Notification.permission === "granted") {
            var img = '_img/main-menu/orion-mail.png';
            var notificationId = item.id;
            var n = new Notification(item.subject, { body: item.body.stripTags(), icon: img, tag: "notification:" + notificationId });

            var dlInfo = createDownloadLink(item);
            if( dlInfo.success ){
                n.onclick = function (event) {
                    event.preventDefault(); // prevent the browser from focusing the Notification's tab
                    self.markAsRead(notificationId);
                    window.open(dlInfo.src, dlInfo.target);
                };
            }
        }
    }

    function addNotificationToCategoryInPartnerApp(notification) {

        var justTheCategory = internal.data.filter(function(category) {
            return category[0] === notification.categoryName;
        });
        if(!justTheCategory.length) {
            var tuple = [notification.categoryName, []];
            internal.data.splice(0, 0, tuple);
        }
        justTheCategory = internal.data.filter(function(category) {
            return category[0] === notification.categoryName;
        });

        if(!justTheCategory[0][1].length) {
            justTheCategory[0][1].push(notification);
        } else {
            justTheCategory[0][1].splice(0, 0, notification);
        }
    }

    function setDateGroup(item) {
        var date = Date.create(item.createdDate);
        if (date.isToday()) {
            item.dateGroup = "Today";
        } else if (date.isYesterday()) {
            item.dateGroup = "Yesterday";
        } else if (date.isThisWeek()) {
            item.dateGroup = date.format('{Weekday}');
        } else if (date.isLastWeek()) {
            item.dateGroup = "Last Week";
        } else {
            item.dateGroup = Date.create(item.createdDate).relative();
        }
    }

    function changeAllStatus(notifications, newStatus) {
        // TODO: Remove duplication between this function and changeStatus
        if(!angular.isArray(notifications)) {
            return $q.reject('Notifications is not an array');
        } else {
            var ids = notifications.reduce(function(arr, notification) {
                arr.push(notification.id);
                return arr;
            }, []);
            return sendStatusUpdate(ids, newStatus)
                .then(function(response) {
                    for(var i = notifications.length - 1; i != -1; i--) {
                        var notification = notifications[i];
                        if(newStatus === notificationStatus.deleted) {
                            self.deleteNotification(notification);
                        } else {
                            notification.status = newStatus.name;
                        }
                        updateCount();
                    }

                    return response.data;
                });
        }
    }

    function sendStatusUpdate(ids, newStatus) {
        return $http.put('/Integrations/Notifications/Action/UpdateStatus?status=' + newStatus.name, ids, {trackerMsg: 'Updating status...'})
    }

    function changeStatus(notificationOrId, newStatus) {
        // TODO: Remove duplication between this function and changeAllStatus
        var notification = notificationOrId;
        if(angular.isNumber(notificationOrId)) {
            notification = self.getNotificationById(notificationOrId);
        }
        if(notification == null) return $q.resolve('Status is Undefined');
        if (notification.status === newStatus.name) return $q.resolve('Status is already the same');
        return sendStatusUpdate([notification.id], newStatus)
            .then(function (response) {
                if (newStatus === notificationStatus.deleted) {
                    self.deleteNotification(notification);
                } else {
                    notification.status = newStatus.name;
                }
                updateCount();
                return response.data;
            });
    }

    function saveUserSettings() {
        userSettings.value = angular.toJson(internal.settings);

        $http.post('/Settings/UserOptions/notification_settings', userSettings)
            .then(function (response) {
                userSettings.id = response.data.id;
            });
    }

    function updateCount(){
        internal.counts = { read: 0, unread: 0};
        internal.data.forEach(categoryData => {
            internal.counts.unread += categoryData[1].filter(cd => cd.status === notificationStatus.unread.name).length;
            internal.counts.read += categoryData[1].filter(cd => cd.status === notificationStatus.read.name).length;
        });
    }

    function filterByStatus(notifications) {
        return notifications.filter(function(notification) {
            return internal.settings.filter === null || notification.status === internal.settings.filter;
        });
    }

    function createDownloadLink(item){
        var targetNewTab = item.actionName === 'LinkToRedtail' ? 'blank' : null;
        if(item.categoryName === "Data Query" && item.url != null) {
            if(item.url.startsWith("http")) {
                item.url = item.url.replace("http://api.orionadvisor.local", "").replace("https://api.orionadvisor.com", "");
            } else if(!item.url.startsWith(API_CONFIG.baseUrl)) {
                item.url = API_CONFIG.baseUrl + item.url;
            }
        }

        var shouldAppendToken = false;
        if (item.url) {
            if (item.url.startsWith('/') || item.url.startsWith('#/')) {
                shouldAppendToken = true;
            } else {
                try {
                    var parsed = new URL(item.url);
                    shouldAppendToken = parsed.hostname === window.location.hostname ||
                        parsed.hostname.endsWith('.orionadvisor.com') ||
                        parsed.hostname.endsWith('.orionadvisor.local');
                } catch (e) {
                    shouldAppendToken = false;
                }
            }
        }

        var linkSrc = item.url;
        if (shouldAppendToken && linkSrc) {
            linkSrc = linkSrc + (linkSrc.indexOf('?') !== -1 ? '&' : '?') + 'Authorization=' + sessionStorage.oas_token;
        }

        return {
            success: item.url ? true : false,
            src: linkSrc,
            target: targetNewTab
        };
    }

    function encodeHTML(str) {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    }

    // PUBLIC API
    self.notifications = internal;

    self.countByFilter = function(notifications) {
        return this.getFilteredNotifications(notifications).length;
    };

    self.getCategories = function() {
        return internal.data;
    };

    self.getFilteredNotifications = function(notifications) {
        return notifications.filter(function(notification) {
            return internal.settings.filter === null || notification.status === internal.settings.filter;
        });
    };

    self.deleteNotification = function(notification) {
        var category = internal.data.filter(function(category) {
            return category[0] === notification.categoryName;
        });

        if (category[0]?.length === undefined) return;


        category[0][1].splice(category[0][1].findIndex(function(c) { return c.id === notification.id && c.subject === notification.subject;}), 1);
        if(!category[0][1].length) {
            internal.data.splice(internal.data.findIndex(category[0]), 1);
        }
    };

    /**
     * Test to determine if notifications in a given category and partner app should be displayed in an aggregate view.
     *
     * @param partnerAppName the name of the partner app
     * @param categoryName the name of the category
     * @returns {boolean} if the category for the given partnerApp should be in an aggregate view.
     */
    self.isAggregated = function (categoryNotifications) {
        return categoryNotifications && filterByStatus(categoryNotifications).length >= MIN_FOR_AGGREGATE_VIEW;
    };

    self.startReceiving = function () {
        $signalRManager.subscribeToHub('fuseHub', 'fuseNotification', null, function (item) {
                addNewNotification(item, true);
                updateCount();
            // TODO: Update order of messages and partners based on most recent received

                var amount = internal.data.filter(function (partner) {
                    return partner[0] === item.categoryName;
                })[0][1];
                // Only toast about received notifications, not when retrieving existing notifications on service init.
                if (amount.length < MIN_FOR_AGGREGATE_VIEW) {
                    var dlInfo = createDownloadLink(item);
                    ngToast.create({
                        className: 'info',
                        content: $sce.trustAsHtml(
                            '<div class="toast-width">' +
                            '<div class="pull-left">' +
                            '<div class="clearfix">' +
                            '<img oas-img-src="/Fuse/Config/Integrations/' + item.integrationId + '/SmallImage" class="logo-size" />' +
                            '</div>' +
                            '<div class="clearfix">' +
                            '<span class="toast-action"><a ng-click="deleteNotification(' + item.id + ')"><i class="fa fa-trash-o" aria-hidden="true"></i></a></span>' +
                            '</div>' +
                            '</div>' +
                            '<div class="pull-left">' +
                            '<a ng-click="viewNotificationFromToast(' + item.id + ')">' +
                            '<div class="pull-left bold toast-msg">' + encodeHTML(item.subject) + '</div>' +
                            '<div class="clearfix"></div>' +
                            '<div class="pull-left toast-msg">' + encodeHTML(item.categoryName) + '</div>' +
                            '</a>' +
                            '<div class="clearfix"></div>' +
                            (dlInfo.success ? '<div class="toast-msg"><a href="' + dlInfo.src + '"' + (dlInfo.target ? ' target="' + dlInfo.target+'"' : '') + '>Click here</a></div>' : '') +
                            '</div>' +
                            '</div>'
                        ),
                        timeout: 10000,
                        dismissOnTimeout: true,
                        compileContent: true
                    });
                }
            }
        );
    };

    self.stopReceiving = function () {
        $signalRManager.unSubscribeToHub('fuseHub', 'fuseNotification');
    };

    self.loadAll = function () {
        $q.all([
            $http.get('/Settings/UserOptions/notification_settings', {
                trackerMsg: 'Loading notification settings',
                allowCancellation: false
            }),
            $http.get("/Reporting/Fuse/Notifications?status=Unread&status=Read&$orderby=Id desc", {
                trackerMsg: 'Loading notification list',
                allowCancellation: false
            })
        ]).then(function (responses) {
            userSettings = responses[0].data;
            internal.settings = (userSettings && userSettings.value ? JSON.parse(userSettings.value) : null) || {grouping: 'dateGroup', filter: null};
            angular.forEach(responses[1].data.sortBy('createdDate', true), function (notification) {
                // Replace newlines with page breaks for view functions
                addNewNotification(notification);
            });
            updateCount();

            // Sort the list in place
            internal.data.sortBy(function (categories) {
                categories[0];
            });
        });
    };

    /**
     * Gets the notification with the given id if it exists. Otherwise, returns undefined.
     *
     * @param notificationOrId the id or the notification object
     */
    self.getNotificationById = function(notificationOrId) {
        if(angular.isObject(notificationOrId)) {
            return notificationOrId;
        } else if(angular.isNumber(notificationOrId)) {
            var notificationsWithId = undefined;
            internal.data.forEach(function(category) {
                if (notificationsWithId) return;
                notificationsWithId = category[1].find(function (notification) {
                    return notification.id === notificationOrId;
                });
            });
            return notificationsWithId
        } else {
            return undefined;
        }

    };

    self.toggleStatus = function(notification) {
        notification.status === 'Read' ? self.markAsUnread(notification) : self.markAsRead(notification);
    };

    /**
     * Toggle the status of every notification in a category asynchronously.
     *
     *
     * @param categoryName
     * @param newStatus
     * @return {Promise} a promise that will resolve once all statuses are updated
     */
    self.changeStatusOfNotificationsByCategory = function(categoryName, newStatus) {
        var notifications = internal.data.filter(function(category) {
            return category[0] === categoryName;
        });
        return changeAllStatus(notifications[0][1], notificationStatus.read);
    };

    self.markAsRead = function (notificationOrId) {
        return changeStatus(notificationOrId, notificationStatus.read);
    };

    self.markAsUnread = function (notificationOrId) {
        return changeStatus(notificationOrId, notificationStatus.unread);
    };

    self.markAsDeleted = function (notificationOrId) {
        return changeStatus(notificationOrId, notificationStatus.deleted);
    };

    self.markAllAsDeleted = function(categoryName) {
        var results = internal.data.filter(function(category) {
            return category[0] === categoryName;
        });
        return changeAllStatus(results[0][1], notificationStatus.deleted);
    };

    self.setNotificationGrouping = function () {
        internal.settings.grouping = internal.settings.grouping === 'categoryName' ? 'dateGroup' : 'categoryName';
        saveUserSettings();
    };

    self.setNotificationFilter = function (status) {
        internal.settings.filter = status;
        saveUserSettings();
    };

    self.loadNotification = function (){};

    self.updateCounter = function (){
        updateCount();
    };

    // At first, let's check if we have permission for notification
    // If not, let's ask for it
    if (window.Notification && Notification.permission !== "granted") {
        Notification.requestPermission();
    }
});

'use strict';

app.service('tokenFactory', function tokenFactory($rootScope, $http, $q) {
    //PRIVATE VARIABLES
    var tokenCache = {database: {}, user: {}};
    var self = this;


    //INITIALIZE
    function init() {
        var cancelWatch = $rootScope.$watch('user.authorization.alClientId', function (newValue) {
            if (!newValue) return;

            tokenCache.database[newValue] = sessionStorage.oas_token;
            cancelWatch();
        });
    }

    function getDifferentToken(tokenType, headerValue) {
        var existingToken = tokenCache[tokenType][headerValue];
        if (existingToken) {
            return $q.resolve(existingToken);
        } else {
            var headers = {Authorization: "Switch " + sessionStorage.oas_token};

            if (tokenType === "user")
                headers.UserDetailId = headerValue;
            else if (tokenType === "database")
                headers.AlClientId = headerValue;

            return $http.get('/security/token', {headers: headers, trackerMsg: 'Requesting new ' + tokenType + ' token', allowCancellation: false })
                .then(function (response) {
                    tokenCache[tokenType][headerValue] = response.data.access_token;
                    return response.data.access_token;
                });
        }
    }

    init();


    //PUBLIC API
    self.getDatabaseToken = function (alClientId) {
        return getDifferentToken("database", alClientId);
    };

    self.getUserDetailToken = function (userDetailId) {
        return getDifferentToken("user", userDetailId);
    };
});


app.service('$schwab', function ($oasRights, $dialog, $http, entities, $portfolio, $location, API_CONFIG, $window, $q) {
    /* THIS SERVICE IS A WORK IN PROGRESS - BUT SHOULD MAKE THINGS MUCH CLEANER WHEN FINISHED */

    //PRIVATE VARIABLES
    let self = this;

    //PRIVATE METHODS
    function init() {

    }

    function setEntity( entity, id ) {
        self.entityLoaded.entityId = id;
        self.entityLoaded.entity = entity.toString( );
        self.entityLoaded.entityFriendly = entities[ entities.find( { value: self.entityLoaded.entity } ) ].name;
        self.entityLoaded.asOfValue = null;
        self.entityLoaded.data = null;
        self.entityLoaded.allowRead = false;
        self.entityLoaded.icon = '';

        if( self.entityLoaded.entityFriendly === entities.client.name ) {
            self.entityLoaded.allowRead = self.rightsHH.canRead;
            self.entityLoaded.icon = 'household';
        } else if( self.entityLoaded.entityFriendly === entities.registration.name ) {
            self.entityLoaded.allowRead = self.rightsReg.canRead;
            self.entityLoaded.icon = 'registration';
        } else if( self.entityLoaded.entityFriendly === entities.account.name ) {
            self.entityLoaded.allowRead = self.rightsAccount.canRead;
            self.entityLoaded.icon = 'account';
        }
    }

    function checkEntityBeforeLoad(){
        if( self.entityLoaded.entity.entityId ) {
            $schwab.load( self.entityLoaded.entity.entity, parseInt(self.entityLoaded.entity.entityId), true );
        } else {
            $scope.searchForEntity( );
        }
        if(self.entityLoaded.entity.entity){
            let curEntity = self.entityLoaded.entity.entity;
            $schwab.load(self.entityLoaded.entity.entity, self.entityLoaded.entity.entityId);
        }
    }

    function loadDetails( ) {
        // Note: EnrollmentStatus endpoint has been deprecated and removed
        // Schwab integration now uses OAuth/SSOv2 flow only
        self.attributes.enrolled = true;
        self.attributes.otpErrors = [];
        self.attributes.active = true;
        
        // Validate OAuth authorization (UserAuthorization endpoint is still valid)
        validateOTP('');
    }

    function validateOTP(otp){
        // Note: UserAuthorization endpoint returns SchwabUserAuthorizationsResponseDto
        // Structure: { data: { id, type, attributes: { isUserFsa, authorizations } } }
        // There is NO serviceMessages or serviceStatus in this response
        $http.get('/Integrations/SchwabSII/UserAuthorization'+otp, {trackerMsg: 'Validating with Schwab', allowCancellation: false }).then(response => {
            // Check if we got valid authorization data
            if(response.data && response.data.data && response.data.data.attributes){
                // Valid response - close modal if open
                if(self.enrollmentModal && self.enrollmentModal.isOpen()){
                    self.enrollmentModal.close();
                }
            } else {
                // Invalid/empty response - update state
                self.attributes.active = false;
                self.attributes.otpErrors.push('Unable to verify Schwab authorization. Please contact support.');
            }
        }).catch(function() {
            self.attributes.active = false;
            self.attributes.otpErrors.push('Failed to validate Schwab authorization');
        });
    }

    //PUBLIC API
    //PUBLIC Methods
    self.load = function( entity, id ) {
        setEntity(entity, id);
        if( self.rightsSII.canRead ) {
            if( self.checkEntity() ) {
                $http.get('/Portfolio/Accounts/' + self.entityLoaded.entityId + '/Simple', {trackerMsg: '', allowCancellation: false}).then(function (responseAcc) {
                    if( responseAcc.data.custodian.has( "Schwab" ) ) {
                        self.attributes.hideAccess = false;
                        // Note: Enrollment status check removed - using OAuth/SSOv2 only
                        loadDetails();
                    } else {
                        self.attributes.hideAccess = true;
                    }
                });
            } else {
                self.attributes.hideAccess = true;
            }
        }
    };

    self.checkEnrollmentStatus = function(){
        // Note: EnrollmentStatus endpoint has been deprecated
        // Schwab integration now uses OAuth/SSOv2 flow only
        self.attributes.enrolled = true;
        self.attributes.active = true;
        self.attributes.otpErrors = [];
        return true;
    };

    self.getEnrollmentStatus = function(){
        // Note: EnrollmentStatus endpoint has been deprecated
        // Return empty promise for backward compatibility
        return $q.resolve({data: {enrollmentStatus: 'Enrolled', statusIndicator: 'Active', serviceMessages: []}});
    };

    self.handleEnrollment = function(enrollment){
        // Note: EnrollmentStatus endpoint has been deprecated
        // This function is kept for backward compatibility but does nothing
        self.enrollmentInfo = enrollment.data;
    };

    self.loadNoEntity = function(){
        if( self.rightsSII.canRead ) {
            self.attributes.hideAccess = false;
            // Note: EnrollmentStatus check removed - using OAuth/SSOv2 only
        }
    };

    self.searchForEntity = function( ) {
        $portfolio.search(entities.client.value)
            .then(function(rslt) {
                if( rslt ) {
                    setEntity( rslt.entity, rslt.item.id );
                }
            });
    };

    self.refreshEnrollment = function( ) {
        // Note: EnrollmentStatus endpoint has been deprecated
        location.reload();
    };

    self.sortAlerts = function( field ) {
        self.attributes.alertsSortField = field;
        self.attributes.alertsSortReverse = !self.attributes.alertsSortReverse;
    };

    self.sortReports = function( field ) {
        self.attributes.reportsSortField = field;
        self.attributes.reportsSortReverse = !self.attributes.reportsSortReverse;
    };

    self.sortPositions = function( field ) {
        self.attributes.positionsSortField = field;
        self.attributes.positionsSortReverse = !self.attributes.positionsSortReverse;
    };

    self.sortProfiles = function( field ) {
        self.attributes.profilesSortField = field;
        self.attributes.profilesSortReverse = !self.attributes.profilesSortReverse;
    };

    self.sortTransactions = function( field ) {
        self.attributes.transactionsSortField = field;
        self.attributes.transactionsSortReverse = !self.attributes.transactionsSortReverse;
    };

    self.openEnrollment = function( ) {
        // Note: Enrollment flow is deprecated - redirect to Schwab SSO v2 instead
        let ssoUrl = API_CONFIG.baseUrl + '/Integrations/SchwabSII/SsoV2/0?Authorization=' + sessionStorage.oas_token;
        $window.open(ssoUrl, '_blank');
    };

    self.setEntity = function(entity, id){
        setEntity(entity, id);
    };

    self.setOtpTokenMode = function( ) {
        self.enrollmentInfo.statusIndicator = 'Active';
        self.attributes.active = true;
        self.attributes.useOtp = true;
    };

    self.refreshData = function( ) {
        loadDetails( );
    };

    self.showTransactionDetail = function( execDate, publishTimeStamp ) {
        // Note: TransactionDetail endpoint has been deprecated
        $dialog.actionFailed('Transaction detail view is no longer available. Please use the Schwab portal directly via SSO.').open();
    };

    self.openReport = function( report ) {
        // Note: Report/PDF endpoints have been deprecated
        $dialog.actionFailed('Report PDF download is no longer available. Please access reports directly through the Schwab portal via SSO.').open();
    };

    self.openUnrealizedLotDetail = function (position){
        // Note: UnrealizedGainLoss/Lots endpoint has been deprecated
        return $q.reject('Unrealized lot detail is no longer available. Please use the Schwab portal directly via SSO.');
    };

    self.openMoneyMove = function( ) {
        // Note: UserAuthorization/Token endpoint has been deprecated
        $dialog.actionFailed('Money Move feature is no longer available through this interface. Please use the Schwab portal directly via SSO.').open();
    };

    self.signOutMoneyMove = function( ) {
        // Note: UserAuthorization/Action/LogOut endpoint has been deprecated
        console.warn('signOutMoneyMove is no longer available - endpoint has been deprecated');
    };

    self.openEnrollmentModal = function(source=null){
        // Note: Enrollment modal removed - redirect directly to Schwab SSO v2
        // Enrollment endpoints are deprecated, users authenticate via SSO v2 directly
        
        let ssoUrl;
        
        // Handle different source formats
        if(source && typeof source === 'object' && source.routeUrl) {
            // Object with routeUrl property (from AccountListCtrl, MainMenuCtrl)
            ssoUrl = source.routeUrl;
        } else if(source && typeof source === 'string') {
            // Plain string URL
            ssoUrl = source;
        } else {
            // No source or invalid - use default SSO v2 home page
            ssoUrl = API_CONFIG.baseUrl + '/Integrations/SchwabSII/SsoV2/0?Authorization=' + sessionStorage.oas_token;
        }
        
        $window.open(ssoUrl, '_blank');
    };

    self.SchwabNewAccount = function (selectedIds) {
        const schwabSSOUrl = API_CONFIG.baseUrl + '/Integrations/SchwabSII/SsoV2/14?Authorization=' + sessionStorage.oas_token;
         $http.post('/Integrations/NewAccount/Schwab', selectedIds).then(function () {
            $window.open(schwabSSOUrl, '_blank');
        }).catch(function (error) {
             console.log("error occurred", error);
        });
    };

    self.checkEntity = function(){
        return self.entityLoaded.entity === entities.account.value;
    };

    /**
     * Redirect to Schwab SAC without Enrollment check (SSO v2)
     * @param {any} source SsoV2. See ScwhabSsoService.scwhabSsoV2Request
     */
    self.sacCenter = function(source = null){
         if(source && source.appCode === 'charlesSchwab'){
             $window.open(source.routeUrl, '_blank');
         }
    };

    //PUBLIC VARIABLES
    // Initialize enrollmentInfo with default "Active" status since EnrollmentStatus endpoint is deprecated
    self.enrollmentInfo = {
        enrollmentStatus: 'Enrolled',
        statusIndicator: 'Active',
        serviceMessages: [],
        enrollmentRequestData: null
    };
    self.rightsSII = $oasRights.forCode("SCHWABSII");
    self.rightsAccount = $oasRights.forCode("ACCOUNTS");
    self.rightsHH = $oasRights.forCode("CLIENTS");
    self.rightsReg = $oasRights.forCode("REGISTRATIONS");

    self.loadBalances = false;

    self.enrollmentModal = null;

    self.groupings = [
        { name: "(None)", key: 0 },
        { name: "Account", key: 7 },
        { name: "Asset Category", key: 15 },
        { name: "Asset Class", key: 9 },
        { name: "Asset Level Strategy", key: 16 },
        { name: "Management Style", key: 11 },
        { name: "Model", key: 74 },
        { name: "Registration", key: 6 },
        { name: "Risk Category", key: 12 }
    ];

    self.attributes = {
        settings: {
            startDate: Date.create( 'beginning of this year' ),
            endDate: Date.create( 'today' )
        },
        enrolled: true,
        active: true,
        // Initialize with empty structures to prevent null errors in UI
        // Note: Data endpoints are deprecated, these remain empty
        balances: [
            {name: 'Total Account Balance', value: null},
            {name: 'Account Net Worth', value: null},
            {name: 'Total Market Value', value: null},
            {name: 'Cash', value: null},
            {name: 'Margin Balance', value: null},
            {name: 'Money Market Fund', value: null}
        ],
        positions: [],
        profiles: [],
        transactions: [],
        alerts: { alerts: [] },
        preferences: { accountPreferences: null },
        realized: { summary: { totalKnownTotalRealizedGainLossDollar: null, totalKnownLongTermRealizedGainLoss: null, totalKnownShortTermRealizedGainLoss: null } },
        unrealized: { summary: { totalKnownUnrealizedGainLossDollar: null, totalKnownMarketValue: null, totalKnownCostBasis: null }, cacheId: null },
        reports: [],
        hideAccess: false,
        isMoneyMoveAuthorized: null,
        moneyMoveToken: null,
        positionsSortField: 'securityName',
        positionsSortReverse: false,
        profilesSortField: '',
        profilesSortReverse: false,
        transactionsSortField: 'date',
        transactionsSortReverse: true,
        alertsSortField: 'msgCreateDate',
        alertsSortReverse: true,
        reportsSortField: 'preparedByDate',
        reportsSortReverse: true,
        refreshDate: null,
        searchSchwabReports: '',
        useOtp: false,
        otpToken: '',
        otpErrors: [],
        enrollmentErrors: [],
        costBasisErrors: [],
        dataDeprecationMessage: 'Schwab account data is no longer available in Orion. Please use the Schwab portal via SSO to access account details.'
    };

    self.entityLoaded = {
        entity: 0,
        entityId: 0,
        entityFriendly: '',
        asOfValue: null,
        allowRead: false,
        data: null,
        icon: '',
        groupings: []
    };

    init();

});

//Copy of oas properties defined in the oasDropdown and oasSearch directives. At some point the oas directives
// need to be setup to reference this service so that all oas elements use the same properties.
(function () {
    'use strict';
    app.service('oasProps', ['API_CONFIG', oasProps]);

    function oasProps(API_CONFIG) {
        const commonFormatter = function (item) {
            return !item ? '' : (angular.isNumber(item.id) ? item.id : item.id.first(8)) + ': ' + item.name;
        };

        const oasDropdownProps = {
            // Misc
            gender: {url: "/Portfolio/Genders/Simple", trackerMsg: 'genders', bindField: 'abbreviation', blankRowName: ' '},

            // RIA
            riaid: {url: '/Portfolio/Rias/Simple', trackerMsg: 'rias'},

            // Wholesaler
            wholesalerid: {url: '/Portfolio/Wholesalers/Simple', trackerMsg: 'wholesalers'},

            // BrokerDealer
            brokerdealerid: {url: '/Portfolio/BrokerDealers/Simple', trackerMsg: 'broker/dealers'},

            // Representative
            representativeid: {url: '/Portfolio/Representatives/Simple', trackerMsg: 'representatives'},

            // Client
            categoryid: {url: "/Portfolio/ClientCategories/Simple", trackerMsg: 'client categories'},
            statementdeliverymethodid: {
                url: "/Billing/BillTransmitMethods/Simple?statementDelivery=true",
                trackerMsg: 'delivery methods'
            },

            // Matrix B50
            matrixb50status: { url: '/Portfolio/MatrixB50/Status?includeAll=true', trackerMsg: 'matrixb50status' },

            // Reg
            investmentobjective: {
                url: "/Portfolio/InvestmentObjectives/Simple",
                trackerMsg: 'investment objectives',
                bindField: 'name'
            },
            returnobjective: {
                url: "/Portfolio/ReturnObjectives/Simple",
                trackerMsg: 'return objectives',
                bindField: 'name'
            },
            timehorizon: {url: "/Portfolio/TimeHorizons/Simple", trackerMsg: 'time horizon', bindField: 'name'},
            typeid: {url: "/Portfolio/Registrations/Types", trackerMsg: 'account types'},
            registrationtypeid: {url: "/Portfolio/Registrations/Types", trackerMsg: 'account types'},

            // Account
            accountstatusid: {url: "/Portfolio/AccountStatuses", trackerMsg: 'account statuses'},
            businessline: {url: "/Portfolio/BusinessLines/Simple", trackerMsg: 'business lines'},
            custodianid: {
                url: "/Portfolio/Custodians/Simple?includeMasterAccountNumber=true",
                trackerMsg: 'custodians'
            },
            custodianidplain: {
                url: "/Portfolio/Custodians/Simple",
                trackerMsg: 'custodians'
            },
            serviceteamrecon: { url: "/Global/ServiceTeams?teamType=ReconTeam", trackerMsg: 'service team recon' },
            serviceteammembers: { url: "/Global/ServiceTeamMembers", trackerMsg: 'service team members' },
            downloadformatid: { url: "/Confirm/DownloadFormats/Simple", trackerMsg: 'download formats' },
            downloadsourceid: { url: "/Confirm/DownloadSources/Simple", trackerMsg: 'download sources' },
            fundfamilyid: {url: "/Portfolio/FundFamilies/Simple", trackerMsg: 'fund families'},
            jobschedules: { url: "/Scheduler/JobSchedules", trackerMsg: 'job schedules'},
            notificationgroup: { url: "/Scheduler/NotificationGroup", trackerMsg: 'notification group' },
            managementstyleid: {url: "/Portfolio/Platforms/Simple", trackerMsg: 'management style'},
            modelid: {url: "/Trading/Models/Simple", trackerMsg: 'models'},
            modelaggid: {url: "/Trading/ModelAggs/Simple", trackerMsg: 'model aggs'},
            modelType: {url: "/Trading/Models/ModelTypes", trackerMsg: 'Model Types'},
            plan: {url: "/Portfolio/Plans/Simple", trackerMsg: 'plans'},
            shareclassid: {url: "/Portfolio/ShareClasses/Simple", trackerMsg: 'share classes'},
            subadvisorid: {url: "/Portfolio/SubAdvisors/Simple", trackerMsg: 'sub-advisors'},
            planadministratorid: {url: "/Portfolio/PlanAdministrators/Simple", trackerMsg: 'plan administrator'},
            plansponsororid: {url: "/Portfolio/PlanSponsors/Simple", trackerMsg: 'plan sponsor'},
            participantid: {url: "/Portfolio/Participants/Simple", trackerMsg: 'participant'},
            advcustodytypeid: {
                url: "/Compliance/Disclose/AdvCustodyTypes",
                trackerMsg: 'load custody type'
            },
            collectfmtid: {url: "/Portfolio/FundFamilies/CollectFmtSimple", trackerMsg: 'Collection formats'},
            collectmethodid: {url: "/Portfolio/FundFamilies/CollectMethodSimple", trackerMsg: 'Collection methods'},
            tradeformatid: {url: "/Portfolio/FundFamilies/TradeFormats/Simple", trackerMsg: 'Trade formats'},
            endresulttradeformatid: {url: "/Portfolio/FundFamilies/EndResultTradeFormats/Simple", trackerMsg: 'End result trade formats'},

            // Billing
            billentities: {url: "/Billing/BillingEntities?isActive=true", trackerMsg: 'bill entities'},
            feescheduleid: {url: "/Billing/Schedules/Simple?schedule=fee", trackerMsg: 'fee schedules'},
            feeschedulefeecalculatorapp: {
                url: "/Billing/Schedules/Simple?schedule=fee&forShowInFeeCalculator=true",
                trackerMsg: 'fee schedules'
            },
            masterpayoutscheduleid: {
                url: "/Billing/MasterPayoutSchedule/Simple?schedule=fee",
                trackerMsg: 'payout schedules'
            },
            payees: {url: "/Billing/Payees", trackerMsg: 'payees'},
            paymethodid: {url: "/Billing/PayMethods", trackerMsg: 'pay methods'},
            performancefeescheduleid: {
                url: "/Billing/Schedules/Simple?schedule=performanceFee",
                trackerMsg: 'performance fee schedules'
            },
            performancemasterpayoutscheduleid: {
                url: "/Billing/MasterPayoutSchedule/Simple?schedule=performanceFee",
                trackerMsg: 'payout schedules'
            },
            statustype: {url: "/Billing/ClientStatuses/Simple", trackerMsg: 'bill statuses', bindField: 'name'},

            // Asset
            assetlevelstrategyid: { url: "/Portfolio/AssetLevelStrategies", trackerMsg: 'asset level strategies' },
            valuationstatus: { url: "/Confirm/Alternative/Equity/ValuationStatuses", trackerMsg: 'valuation statuses', bindField: 'description' },

            // Composite
            compositereportid: {
                url: "/Reporting/Composite/Reports/Simple",
                trackerMsg: 'composite reports',
                bindField: 'name'
            },
            stockrangeid: {
                url: "/Reporting/Composite/Ranges/Simple?rangeType=stockRange",
                trackerMsg: 'Stock Range',
                bindField: 'name'
            },
            riskbudgetrangeid: {
                url: "/Reporting/Composite/Ranges/Simple?rangeType=riskBudgetRange",
                trackerMsg: 'Risk Budget Range',
                bindField: 'name'
            },
            risktolerancerangeid: {
                url: "/Reporting/Composite/Ranges/Simple?rangeType=RiskToleranceRange",
                trackerMsg: 'Risk Tolerance Range',
                bindField: 'name'
            },

            // Transaction
            contributioncodeid: {url: "/Trading/ContributionCodes/Simple", trackerMsg: 'contribution codes'},
            contributioncodeextid: {url: "/Trading/ContributionCodeExts/Simple", trackerMsg: 'contribution codes where isira/isqual = true'},
            distributioncodeid: {url: "/Trading/DistributionCodes/Simple", trackerMsg: 'distribution codes'},
            transtypeid: {url: "/Trading/TransactionTypes?IsValid=True", trackerMsg: 'transaction types'},
            transactionsubtypeid: {url: "/Trading/TransactionSubTypes", trackerMsg: 'transaction subtypes', nameField: 'description' },
            state: { url: "/Portfolio/States/Simple?returnFullName=false", trackerMsg: 'states' },
            statefullname: { url: "/Portfolio/States/Simple?returnFullName=true", trackerMsg: 'fullname states'},
            status: {url: "/Trading/TradeStatuses", trackerMsg: 'trade status', bindField: 'name'},
            alternativeequityfundingtypeid: {
                url: "/Confirm/Alternative/Equity/FundingTypes",
                trackerMsg: 'funding types',
                nameField: 'description'
            },
            alternativeequityactivitytypeid: {
                url: "/Confirm/Alternative/Equity/ActivityTypes",
                trackerMsg: 'activity types',
                nameField: 'description'
            },

            //Trade Blocks
            tradeblockreason: {
                url: "/Trading/TradeBlocks/Reasons/Simple",
                trackerMsg: 'trade block reasons',
                nameField: 'name'
            },

            // Product
            bondratingid: {url: "/Portfolio/BondRatings/Simple", trackerMsg: 'bond ratings'},
            bondratingidmoodys: {url: "/Portfolio/BondRatings/Simple?source=moody", trackerMsg: 'bond ratings'},
            bondratingidsandp: {url: "/Portfolio/BondRatings/Simple?source=s%26p", trackerMsg: 'bond ratings'},
            globalfundfamilyid: {url: "/Global/FundFamilies/Simple", trackerMsg: 'global fund families'},
            productcategoryid: {url: "/Portfolio/ProductCategories/Simple", trackerMsg: 'asset categories'},
            assetclassid: {url: "/Portfolio/ProductClasses/Simple", trackerMsg: 'asset classes'},
            autoassignmentassetclassid: {url: "/Portfolio/ProductClassAutoAssignOverride/ProductClass/Simple", trackerMsg: 'asset classes'},
            riskcategoryid: {url: "/Portfolio/RiskCategories/Simple", trackerMsg: 'risk categories'},
            autoassignmentriskcategoryid: {url: "/Portfolio/RiskCategoryAutoAssignOverride/RiskCategory/Simple", trackerMsg: 'risk categories'},
            productsubtypeid: {url: "/Global/Products/SubTypes/Simple", trackerMsg: 'sub types'},
            alternativeproductsubtypeid: {
                url: "/Global/Products/SubTypes/Simple?alternativeOnly=true",
                trackerMsg: 'sub types'
            },
            productsubholdingid: {url: "/Global/SubHoldings/Simple", trackerMsg: 'sub holdings'},
            dividendtypeid: {url: "/Global/Products/DividendTypes/Simple", trackerMsg: 'dividend types'},
            custodiancommonid: {url: "/Global/Custodians/Simple", trackerMsg: 'common custodians'},
            productmanagerid: {url: "/Portfolio/Managers/Simple", trackerMsg: 'product managers'},
            propertytypeid: {url: "/Portfolio/PropertyTypes/Simple", trackerMsg: 'property types'},
            regionid: {url: "/Portfolio/Regions/Simple", trackerMsg: 'product regions'},
            advassetcategoryid: {url: "/Compliance/Disclose/AdvCategories/AssetCategories", trackerMsg: 'adv asset categories', bindField: 'id', nameField: 'description', selected:"id"},
            advclientcategoryid: {url: "/Compliance/Disclose/AdvCategories/ClientCategories", trackerMsg: 'adv client categories', bindField: 'id', nameField: 'description', selected:"id"},
            custodiancommon: { url: "/Global/Custodians/Simple", trackerMsg: "custodian common" },

            //User Defined Fields
            // /Settings/UserDefinedFields/Definitions/account/Code/7TRADINGGR
            udf: {
                url: '/Settings/UserDefinedFields/Definitions/{entity}/Code/{code}',
                trackingMsg: 'user defined field',
                bindField: 'listValue',
                nameField: 'listValue'
            },

            // Databases
            alclientid: {url: "/Authorization/Databases", placeholder: "Database ID or name", bindField: 'id', nameField: 'clientName', selected:"id"},

            //Conversion Sources
            conversionsourcetypeid:{url:"/Integrations/Onboarding/ConversionSources/Types", placeholder:"Conversion Source Type", bindField:'id', nameField:"name", selected:"name"}
        };
        const oasSearchProps = {
            client: {
                url: "/Portfolio/Clients/Simple/Search?search={search}&top={top}",
                icon: "fa-orion-household",
                placeholder: "household ID or name",
                advancedSearch: true,
                formatter: function (item) {
                    return !item ? '' : item.id + ': ' + item.name + (!item.repCode ? '' : ' (' + item.repCode + ')');
                }
            },
            registration: {
                url: "/Portfolio/Registrations/Simple/Search?search={search}&top={top}",
                icon: "fa-orion-registration",
                placeholder: "registration ID or name",
                advancedSearch: true,
                formatter: commonFormatter
            },
            account: {
                url: "/Portfolio/Accounts/Simple/Search?search={search}&top={top}",
                icon: "fa-orion-account",
                placeholder: "account ID or number",
                advancedSearch: true,
                formatter: function (item) {
                    return !item ? '' : item.id + ': ' + item.number + ' (' + item.name.replace('\n','') + ')';
                }
            },
            asset: {
                url: "/Portfolio/Assets/Simple/Search?search={search}&top={top}",
                icon: "fa-orion-asset",
                placeholder: "asset ID or name",
                formatter: function (item) {
                    return !item ? '' : item.id + ': ' + item.ticker + ' - ' + item.name + ' (' + item.accountNumber + ')';
                }
            },
            productclasses: {
                url: "/Portfolio/ProductClasses/Simple/Search?search={search}",
                placeholder: "Product Class ID, name or description",
                formatter: function (item) {
                    return !item ? '' : item.id + ' | ' + item.name + ' | ' + item.description + ' | ' + item.category;
                }
            },
            riskcategories: {
                url: "/Portfolio/RiskCategories/Simple/Search?search={search}",
                placeholder: "Risk Category ID, Full Name or abbrevation",
                nameField: 'riskFullName',
                formatter: function (item) {
                    return !item ? '' : item.id + ' | ' + item.riskAbbrev + ' | ' + item.riskFullName;
                }
            },
            representative: {
                url: "/Portfolio/Representatives/Simple/Search?search={search}",
                placeholder: "rep ID or name",
                formatter: function (item) {
                    return !item ? '' : item.id + ': ' + item.name + ' (' + item.number + ')';
                }
            },
            brokerdealer: {
                url: "/Portfolio/BrokerDealers/Simple/Search?search={search}",
                placeholder: "broker/dealer ID or name",
                formatter: commonFormatter
            },
            subadvisor: {
                url: "/Portfolio/SubAdvisors/Search?search={search}&top=20",
                placeholder: "sub-advisor ID or name",
                formatter: commonFormatter
            },
            model: {
                url: "/Trading/Models/Search?search={search}&$top=15",
                placeholder: "model ID or name",
                formatter: commonFormatter
            },
            modelagg: {
                url: "/Trading/ModelAggs/Search?Search={search}&activeOnly=true&top=20",
                placeholder: "model agg ID or name",
                formatter: commonFormatter
            },
            dataquery: {
                url: "/Reporting/Custom/Simple/Search?search={search}&$top=20",
                icon: "fa-database",
                placeholder: "query ID or name",
                formatter: commonFormatter
            },
            laserappforms: {
                url: "/Integrations/LaserApp/Forms/Search?Search={search}",
                icon: "fa-table",
                placeholder: "laser app title",
                nameField: 'title',
                formatter: function (item) {
                    return !item ? '' : item.title;
                }
            },
            product: {
                url: "/Trading/Products/Search?Top=20&Search={search}",
                placeholder: "name or ticker",
                nameField: 'ticker',
                formatter: function (item) {
                    return !item ? '' : item.ticker + ' (' + item.productName + ')';
                }
            },
            productidglobal: {
                url: "/Global/Products?$top=20&partialId={search}",
                placeholder: "Product ID",
                nameField: 'productName',
                formatter: function(item){
                    return !item ? '' : item.id + ' - ' + item.ticker + ' (' + item.productName + ')';
                }
            },           
            alternativeproduct: {
                url: "/Portfolio/Products/Search?top=20&productType=7&Search={search}",
                placeholder: "name or ticker",
                nameField: 'productName',
                formatter: function (item) {
                    return !item ? '' : item.ticker + ' (' + item.productName + ')';
                }
            },
            productall: {
                url: "/Portfolio/Products/Search?Top=20&Search={search}",
                placeholder: "name or ticker",
                nameField: 'productName',
                formatter: function (item) {
                    return !item ? '' : item.ticker + ' (' + item.productName + ')';
                }
            },
            benchmark: {
                url: "/Portfolio/Benchmarks/Simple/Search?top=20&search={search}",
                placeholder: "benchmark name",
                formatter: function (item) {
                    return !item ? '' : item.name;
                }
            },
            index: {
                url: "/Portfolio/Products/Search?Top=20&ProductType=Index&Search={search}",
                placeholder: "name or ticker",
                nameField: 'productName',
                formatter: function (item) {
                    return !item ? '' : item.ticker + ' (' + item.productName + ')';
                }
            },
            videochat: {
                url: "/Authorization/Users/AvailableToConnect?search={search}&forMobileApp=false",
                placeholder: "Who you gonna call?",
                nameField: 'lastName',
                formatter: function (item) {
                    return !item ? '' : item.firstName + ' ' + item.lastName;
                }
            },
            application: {
                url: "/Settings/Apps/Search?search={search}&top=10",
                icon: "fa-orion-app",
                placeholder: "app category or name",
                formatter: function (item) {
                    return !item ? '' : item.category + ': ' + item.name;
                }
            },
            global: {
                url: "global", placeholder: "looking for something?", advancedSearch: true
            },
            globalfundfamily: {
                url: "/Global/FundFamilies/Simple/Search?search={search}&$top=15",
                placeholder: "fund family ID or name",
                formatter: commonFormatter
            },
            applicationpage: {
                url: "/Settings/Apps/Pages/Search?search={search}&top=10",
                icon: "fa-file-o",
                formatter: function (item) {
                    return !item ? '' : item.category + ': ' + item.name;
                }
            },
            report: {
                url: "/Reporting/Reports/Simple/Search?search={search}&top=15&orionConnectMenu=true",
                icon: "fa-bolt",
                placeholder: "report ID or name",
                formatter: commonFormatter
            },
            geminifunds: {
                url: "/Reporting/FundPerformance/GeminiFund/Simple/Search/{search}",
                placeholder: "fund key or fund name",
                formatter: commonFormatter
            },
            geminiindices: {
                url: "/Reporting/FundPerformance/GeminiFund/Index/Simple/Search/{search}",
                placeholder: "index number or index name",
                formatter: function (item) {
                    return !item ? '' : (item.id + ': ' + item.name + (item.productId ? ' (' + item.productId + ')' : ''));
                }
            },
            profile: {
                url: "/Security/Profiles/Search?search={search}",
                icon: "fa-user",
                placeholder: "user ID or name",
                nameField: 'entityName',
                formatter: function (item) {
                    return !item ? '' : (item.entityId || item.userId) + ': ' + item.entityName + ' (' + item.loginUserId + ')';
                }
            },
            secureexchangerecipient: {
                url: "/Blogging/Emails/Recipients/Search?search={search}&$top=20",
                icon: "fa-user",
                placeholder: "user ID or name",
                nameField: 'profileName',
                formatter: function (item) {
                    return !item ? '' : item.userId + ': ' + item.profileName + ' (' + item.loginUserId + ')';
                }
            },
            managementstyle: {
                url: "/Portfolio/Platforms/Search?Search={search}&top=20",
                placeholder: "management style ID or name",
                formatter: commonFormatter
            },
            corporateaction: {
                url: "/Global/CorporateActions/Search?search={search}&$top=15",
                placeholder: "corporate action ID or name",
                formatter: commonFormatter
            },
            transaction: {
                url: "/Portfolio/Transactions/Simple/Search?search={search}&$top=15",
                placeholder: "transaction ID or description",
                formatter: function (item) {
                    return !item ? '' : '{1}: {2}, {3}, {4} ({5})'.assign(item.id, new Date(item.transDate).format('{M}/{d}/{yyyy}'), item.name, item.ticker, item.productName ? item.productName.truncate(30) : item.productName);
                }
            },
            sleevestrategy: {
                url: "/Trading/SleeveStrategy/Search/?search={search}",
                placeholder: "sleeve strategy ID or name",
                formatter: commonFormatter
            },
            sleevestrategyaggregate: {
                url: "/Trading/SleeveStrategyAggregate/Search/?search={search}",
                placeholder: "sleeve strategy aggregate ID or name",
                formatter: commonFormatter
            },
            portfoliogroup: {
                url: "/Portfolio/PortfolioGroups/Simple/Search?search={search}&top={top}",
                icon: "fa-orion-portfolio-group",
                placeholder: "portfolio group ID or name",
                formatter: function (item) {
                    return !item ? '' : (angular.isNumber(item.id) ? item.id : item.id.first(8)) + ': ' + item.name + ', ' + item.clientName + ' (' + item.clientId + ')';
                }
            },
            plan: {
                url: "/Portfolio/Plans/Search?search={search}&top=20",
                placeholder: 'plan ID or name',
                formatter: commonFormatter
            },
            help: {
                url: API_CONFIG.socialUrl + "wp-json/orion/v1/helpdocs?search={search}",
                icon: "fa-question-circle",
                placeholder: "help search term",
                nameField: 'title',
                formatter: function (item) {
                    return !item ? '' : 'Help: ' + item.title.truncate(30);
                }
            },
            ria: {
                url: "/Portfolio/Rias/Simple/Search?search={search}",
                placeholder: "RIA ID or name",
                formatter: commonFormatter
            },
            database: {
                url: "/Authorization/User/Databases?searchText={search}",
                icon: "far fa-database",
                placeholder: "Database Name",
                advancedSearch: false,
                nameField: 'clientName',
                formatter: function (item) {
                    return !item ? '' : item.id + ': ' + item.clientName;
                }
            },
            prospect: {
                url: "/Reporting/Element/Prospects/Search/{search}",
                placeholder: "prospect ID or name",
                formatter: (item) => {
                    return !item ? '' : item.prospectId + ': ' + item.name + (!item.repId ? '' : ' (' + item.repId + ')');
                }
            },
            globalsecurityclass: {
                url: "/Portfolio/SecurityClassification/Global/SecurityClasses/Simple?searchText={search}&$top=15",
                placeholder: "Global Security Class Name or Code",
                formatter: commonFormatter
            },
            globalsecurityclassificationmethod: {
                url: "/Portfolio/SecurityClassification/Global/Methods/Simple?searchText={search}&$top=15",
                placeholder: "Global Method Name",
                formatter: commonFormatter
            },
            localsecurityclass: {
                url: "/Portfolio/SecurityClassification/Local/SecurityClasses/Simple?searchText={search}&$top=15",
                placeholder: "Security Class Name or Code",
                formatter: commonFormatter
            },
            localsecurityclassificationmethod: {
                url: "/Portfolio/SecurityClassification/Local/Methods/Simple?searchText={search}&$top=15",
                placeholder: "Method Name",
                formatter: commonFormatter
            }
        };
        oasSearchProps.household = oasSearchProps.client;
        oasSearchProps.repaccountmanager = oasSearchProps.representative;

        oasSearchProps.global.formatter = function (item) {
            if (!item) {
                return;
            }

            for (const value of Object.values(oasSearchProps)) {
                if (value.icon === item.icon) {
                    return value.formatter(item);
                }
            }

            return commonFormatter(item);
        };
        return {oasDropdownProps: oasDropdownProps, oasSearchProps: oasSearchProps};
    }

})();

//Modified version of this:
//https://gist.github.com/nicbell/6081098
//This will compare two angular JSON objects and return an array containing the keys that have values between the two objects that do not match.
Object.compare = function (obj1, obj2, parentProperty = null) {
    //convert to json
    obj1 = JSON.parse(angular.toJson(obj1));
    obj2 = JSON.parse(angular.toJson(obj2));
    let results = [];

    // if obj1 or obj2 are null but the other is not,
    // pass back either the parent property or the first property of the non-null object as the property that's different
    if((obj1 === null && obj2 !== null) || (obj1 !== null && obj2 === null)) {      
        return [parentProperty || Object.keys(obj1 || obj2)[0]];
    }
    
    //Loop through properties in object 1
    for (var p in obj1) {
        //Check property exists on both objects
        if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) {
            results.push(p);
        }

        switch (typeof (obj1[p])) {
            //Deep compare objects
            case 'object':
                if (obj2[p] !== undefined) {
                    results = results.concat(Object.compare(obj1[p], obj2[p], p));
                }
                break;
            //Compare function code
            case 'function':
                if (typeof (obj2[p]) == 'undefined' || (p != 'compare' && obj1[p].toString() != obj2[p].toString())) {
                    results.push(p);
                }
                break;
            //Compare values
            default:
                if (obj1[p] != obj2[p]) {
                    results.push(p);
                }
        }
    }

    //Check object 2 for any extra properties
    for (var p in obj2) {
        if (typeof (obj1[p]) == 'undefined') {
            results.push(p);
        }
    }
    return results;
};

'use strict';

/**
 * Date helpers aligned with server business rules that use US Central calendar dates
 */
app.service('oasDates', function oasDates() {
    var centralTimeZone = 'America/Chicago';

    /**
     * Calendar "today" in US Central Time (CST/CDT) as a Sugar date at local midnight.
     */
    this.getTodayCentral = function () {
        return Date.create(new Intl.DateTimeFormat('en-CA', { timeZone: centralTimeZone }).format(new Date()));
    };

    /**
     * True when the given date is strictly after the Central calendar today.
     */
    this.isAfterTodayCentral = function (dateValue) {
        return Date.create(dateValue).beginningOfDay().isAfter(this.getTodayCentral().beginningOfDay());
    };
});

'use strict';

app.controller('AdvisorContactInfoCtrl', function AdvisorContactInfoCtrl($scope, $http, $q, $upload, $oasRights, $dialog, billingStyle, valuationMethod) {

    //region PRIVATE VARIABLES
    let ownerReportImageOriginal = null;

    //endregion

    //region PUBLIC METHODS
    $scope.saveOwner = function() {
        if($scope.emailInvalid) {
            $dialog.actionFailed('Email is invalid.').open();
            return;
        }

        const promises = [];
        let message = 'Advisor contact information saved.';

        if ($scope.ownerInfo.ownerImage && $scope.ownerInfo.ownerImage.image && !angular.equals(ownerReportImageOriginal, $scope.ownerInfo.ownerImage)) {
            $scope.ownerInfo.ownerImage.image = $scope.ownerInfo.ownerImage.image.remove('data:image/jpeg;base64,');
            $scope.ownerInfo.ownerImage.image = $scope.ownerInfo.ownerImage.image.remove('data:image/png;base64,');
        }

        promises.push($http.put('/Settings/Owner', $scope.ownerInfo, {trackerMsg: 'Saving contact information'}));

        if ($scope.rightsServiceTeam.canUpdate) {
            promises.push($http.put('/Security/Databases/' + $scope.user.authorization.alClientId, $scope.dbInfo, {trackerMsg: 'Saving service team information'}));
        }

        $q.all(promises)
            .then(function(results) {
                if (results.length === 2) {
                    $scope.dbInfo = results[1].data;
                    message += '<br>' + 'Service Team saved.';
                }
                $dialog.saveSuccessful(message).open();
            });
    };

    $scope.fileTooLarge = function () {
       $dialog.actionFailed('Image too large! Image must be 1MB or less.').open();
    }

    $scope.invalidEmail = function (invalid) {
        $scope.emailInvalid = invalid;
    };

    $scope.setEmail = function (value) {
        $scope.ownerInfo.email = value;
    };

    //endregion

    //region PRIVATE METHODS

    function init() {
        $scope.rightsOwner = $oasRights.forCode('ADVISORINFO');
        $scope.rightsServiceTeam = $oasRights.forCode('SERVICETEAMASSIGN');

        loadCurrentValues();
        loadBillingLookUps();
        loadServiceTeams();
    }

    function loadServiceTeams() {
        $http.get('/Global/ServiceTeams/Simple?TeamType=1', {trackerMsg: 'Loading service teams'})
            .then(function(response) {
                $scope.serviceTeamList = response.data;
            });

        $http.get('/Security/Databases/' + $scope.user.authorization.alClientId, {trackerMsg: 'Loading database information'})
            .then(function(response) {
                $scope.dbInfo = response.data;
            });
    }

    function loadCurrentValues() {
        $http.get('/Settings/Owner/', {trackerMsg: 'Loading owner current values'})
            .then(function(response) {
                $scope.ownerInfo = response.data;
                ownerReportImageOriginal = angular.copy($scope.ownerInfo.ownerImage);
            });

        $http.get('/Settings/EntityOptions/Database/0/code/1:69ADVNUM', {cache: true, trackerMsg: 'Loading advisor number'})
            .then(function(response) {
                $scope.advisorNumber = response.data;
            });
    }

    function loadBillingLookUps() {
        if ($scope.current.billStyles === null) {
            $scope.current.billStyles = [];
            billingStyle.keys().forEach(function(key) {
                $scope.current.billStyles.push({ id: parseInt(billingStyle[key].value), name: billingStyle[key].name });
            });
        }

        if ($scope.current.valuationMethods === null) {
            $scope.current.valuationMethods = [];
            valuationMethod.keys().forEach(function(key) {
                $scope.current.valuationMethods.push({ id: parseInt(valuationMethod[key].value), name: valuationMethod[key].name });
            });
        }
    }

    //endregion

    //region INITIALIZE

    $scope.current = {
        billStyles: null,
        valuationMethods: null,
        selectedServiceTeamId: 0,
        selectedReconTeamId: 0,
    };

    $scope.dbInfo = null;
    $scope.serviceTeamList = null;
    $scope.reconTeamsList = null;
    $scope.ownerInfo = null;
    $scope.advisorNumber = null;

    init();

    //endregion
});


'use strict';

app.controller('AdvisorOptionInfoCtrl', function AdvisorOptionInfoCtrl($scope, $http, $oasRights, $portfolio, $dialog) {
    //PRIVATE METHODS
    var originalEOs;


    //PRIVATE METHODS
    function init() {
        $http.get("/Settings/EntityOptions/Database/0", {trackerMsg: 'Loading options'})
            .then(function (response) {
                originalEOs = angular.copy(response.data);

                $portfolio.cleanCustomFields(response.data);
                $scope.entityOptions = response.data;
            });
    }

    //PUBLIC METHODS
    $scope.saveEntityOptions = function () {
        var changedEOs = $portfolio.restoreEntityOptions($scope.entityOptions);
        originalEOs.forEach(function (option) {
            changedEOs.remove({code: option.code, value: option.value});
        });

        //in case the cleanCustomFields process changed some values in a category that the user doesn't have rights to
        if (!$scope.rightsEOsOwner.canUpdate) {
            changedEOs.remove(function (option) {
                return !$oasRights.canUpdate(("DBEO_" + option.category.replace(/ /g, '').toUpperCase()).first(38));
            });
        }

        if (changedEOs.length) {
            const abortMessages = [];
            changedEOs.forEach(eo => {
                if (eo.type === 'Email' && (eo.value === undefined || eo.invalidEmail)) {
                    abortMessages.push(`${eo.name} has an invalid email address`);
                }
            });

            if (abortMessages.length) {
                $dialog.messageBox('<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Invalid Data', `<ul class="unstyled"><li>${abortMessages.join("</li><li>")}</li></ul>`).open();
                return;
            }

            $http.put("/Settings/EntityOptions/Database", changedEOs, {trackerMsg: "Saving options"})
                .then(function () {
                    changedEOs.forEach(function (option) {
                        originalEOs.find({code: option.code}).value = option.value;    
                    });
                    
                    $dialog.saveSuccessful("Advisor option information saved.").open();
                });
        } else {
            $dialog.messageBox("No Changes", "There are no changes to save.").open();
        }
    };

    //INITIALIZE
    $scope.rightsEOsOwner = $oasRights.forCode("ENTITYOPTIONSOWNER");
    init();
});


app.controller('BDAdditionalContactCtrl', function BDAdditionalContactCtrl($scope, $http, $dialog, $oasRights, args, dialog){


    //PUBLIC
    $scope.viewSSNInfo = function(allowEdit){
        if($scope.additionalContact.id > 0 && ($scope.additionalContact.ssN_TaxID && $scope.additionalContact.ssN_TaxID.indexOf('X') != -1) || allowEdit){
            $dialog.inputBox('Reason to View the SSN or Tax ID', "Reason", "textarea")
                .open()
                .then(function(rslt){
                    if ( rslt && rslt.trim().length > 0){
                        var updateSSN = {ssN: null, reason : rslt};
                        $http.put('/Portfolio/BrokerDealers/' + $scope.additionalContact.id + '/SSNTaxId', updateSSN, {trackerMsg: 'Getting SSN/Tax ID information'})
                            .then(function(response){
                                $scope.additionalContact.ssN_TaxID = response.data;
                                $scope.current.allowEditSSN = allowEdit;
                            });
                    }
                });
        }
    };

    $scope.close = function(isCancel) {
        if($scope.emailInvalid) {
            $dialog.actionFailed('Email is invalid.').open();
            return;
        }

        if (isCancel)
            dialog.close(null);
        else
            dialog.close($scope.additionalContact);
    };

    $scope.invalidEmail = function (invalid) {
        $scope.emailInvalid = invalid;
    };

    $scope.setEmail = function (value) {
        $scope.additionalContact.email = value;
    };

    $scope.additionalContact = args.additionalContact;
    $scope.contactTypes = args.contactTypes;

    $scope.current = { addAlternateAddressName : '', allowEditSSN : $scope.additionalContact.ssN_TaxID && $scope.additionalContact.ssN_TaxID.length === 0 ? true : false};

    $scope.rightsHH = $oasRights.forCode("BROKERDEALERS");
});

app.controller('BrokerDealerRevenueShareCtrl', function BDRevenueShareCtrl($scope, $http, $dialog, $oasRights, dialog){    
    //load dropdown
    function loadPayee() {        
        $http.get('/Billing/Schedules?billEntityId=4', { trackerMsg: 'Loading payout rates' })
                .then(function (response) {
                    $scope.payeeList = response.data;                    
                });
    }

    function init() {
        $scope.current.revenueshare = Object.select(dialog.options, 'revenueshare').revenueshare;
        $scope.current.revenueshareOriginal = angular.copy($scope.current.revenueshare); 
        $scope.current.revenueshares = Object.select(dialog.options, 'revenueshares').revenueshares;          
        loadPayee();   
    }

    function  verifyentry()
    { //can't have overlapped period
        var bNOTOK=false;         
        const csd = Date.create($scope.current.revenueshare.startDate);
        const ced = Date.create($scope.current.revenueshare.endDate);
        if (csd.isAfter(ced)) {
            alert ("end date has to be after start date");
            $scope.current.revenueshare.startDate = $scope.current.revenueshareOriginal.startDate;
            $scope.current.revenueshare.endDate = $scope.current.revenueshareOriginal.endDate;
            bNOTOK=true;
        }
        else {
        var payrateitems = $scope.current.revenueshares?.filter(r=>r.id !== $scope.current.revenueshare.id || r.id == 0); 
        if (payrateitems?.length>0)
        {          
            for(var i=0; i<payrateitems.length; i++)      
            {                
                    var sd = Date.create(payrateitems[i].startDate);
                    var ed = Date.create(payrateitems[i].endDate);
                    bNOTOK = !csd.isAfter(ed) && !sd.isAfter(ced);
                    if(bNOTOK && $scope.current.revenueshare.$$hashKey !== payrateitems[i].$$hashKey)
                    {
                        alert("overlapping period is not allowed for current selected payout rate " + $scope.current.revenueshare.payoutRate);
                        $scope.current.revenueshare.startDate = $scope.current.revenueshareOriginal.startDate;
                        $scope.current.revenueshare.endDate = $scope.current.revenueshareOriginal.endDate;
                        break;
                    }
            }
        }
        }
        return bNOTOK;
    }

    $scope.close = function(isCancel) {
        if (isCancel)
            dialog.close(null);
        else
        { 
            var i = $scope.payeeList.find(a=>a.id == $scope.current.revenueshare.billScheduleId );
            if (i)
            {
                $scope.current.revenueshare.payoutRate = i.name;
            }  
            
            if (verifyentry())            
                return;
            else     
                dialog.close($scope.current);
        }
    };    
    
    $scope.rightsRS = $oasRights.forCode("BROKERDEALERREVENUESHARES");
    $scope.current = {   
        revenueshare: null 
    };
    init();
});
app.controller('BrokerDealerAccountTypeCtrl', function BrokerDealerAccountTypeCtrl($scope, $http, $dialog, $oasRights, dialog){    
    //load dropdown    
    function loadAccountTypes() {        
        $http.get("/Portfolio/Registrations/Types", {trackerMsg:'Loading account types'})
            .then(function(response){
                $scope.typeList = response.data;
            });
    }    

    function init() {
        $scope.current.bdaccounttypes = Object.select(dialog.options, 'bdaccounttypes').bdaccounttypes;
        $scope.current.bdaccounttype = Object.select(dialog.options, 'bdaccounttype').bdaccounttype;        
        
        $scope.current.selectedAccountTypeIdOriginal = $scope.current.bdaccounttype.id;      //pkAccounttypeId             
        loadAccountTypes();         
    }

    $scope.close = function(isCancel) {
        if (isCancel)
            dialog.close(null);
        else
        { 
            var dup = $scope.current.bdaccounttypes?.filter(r=>r.accountType == $scope.current.selectedaccounttype.accountType)  
            if (dup.length>0) {
                alert ($scope.current.selectedaccounttype.accountType + " has already been added!");            
            }
            else  
            {         
                dialog.close($scope.current);
            }
        }
    };    
    
    $scope.rightsRS = $oasRights.forCode("BROKERDEALERREVENUESHARES");

    $scope.accountTypeChange= function() {
        if ($scope.current.bdaccounttype.accountTypeId)
        {  
            $scope.current.selectedaccounttype = {id:$scope.current.selectedAccountTypeIdOriginal, brokerDealerId: $scope.current.bdaccounttype.brokerDealerId, accountTypeId: $scope.current.bdaccounttype.accountTypeId, accountType:$scope.typeList.find(x=>x.id == $scope.current.bdaccounttype.accountTypeId)?.name};  
        }
    };

    $scope.current = {   
        selectedAccountTypeId: null, 
        bdaccounttypes: null
    };

    init();
});

app.controller('BrokerDealerRepresentativeCtrl', function BrokerDealerRepresentativeCtrl($scope, $http, $dialog, $oasRights, dialog){    
    

    function init() {
        $scope.current.bdrep = Object.select(dialog.options, 'bdrep').bdrep;        
        $scope.current.bdreps = Object.select(dialog.options, 'bdreps').bdreps;        
        $scope.current.selectedRep = null;           
    }

    $scope.close = function(isCancel) {
        if (isCancel)
            dialog.close(null);
        else
        { 
            $http.get("/Portfolio/Representatives/" + $scope.current.selectedRep?.id, { trackerMsg: 'Loading representative' })
                    .then(function (response) {
                        //$scope.current.representativeName = response.data.name;
                        if($scope.current.bdrep.brokerDealerId !== response.data.brokerDealerId)
                        {
                            alert ($scope.current.selectedRep?.name + " doesn't belong to current broker dealer!");
                            $scope.current.selectedRep = null;     
                            return;
                        }
                        else {
                        var dup = $scope.current.bdreps?.filter(r=>r.repId == $scope.current.selectedRep?.id)  
                        if (dup.length>0) {
                            alert ($scope.current.selectedRep?.name + " has already been added!");            
                        }
                        else {
                            dialog.close($scope.current);}
                        }
                    }); 
        }
    };  
    
    $scope.rightsRS = $oasRights.forCode("BROKERDEALERREVENUESHARES");  
    
    $scope.current = {        
        selectedRep: null,  
        bdreps: null
    };
    init();
});

app.controller('BrokerDealerBusinessLineCtrl', function BrokerDealerBusinessLineCtrl($scope, $http, $dialog, $oasRights, dialog){    
    

    function init() {
        $scope.current.bdBussLine = Object.select(dialog.options, 'bdBussLine').bdBussLine;        
        $scope.current.bdBussLines = Object.select(dialog.options, 'bdBussLines').bdBussLines;
    }

    $scope.close = function(isCancel) {
        if (isCancel)
            dialog.close(null);
        else
        { 
            let dup = $scope.current.bdBussLines?.filter(r=>r.bussLineId == $scope.current.bdBussLine.businessLineId);
            if (dup && dup.length > 0) {
                alert ($scope.current.selectedEntity + " has already been added!");            
            }
            else {
                dialog.close($scope.current);
            }
        }
    };  
    
    $scope.rightsRS = $oasRights.forCode("BROKERDEALERREVENUESHARES");  
    
    $scope.current = {        
        selectedbl: null,  
        bdBussLines: null
    };
    init();
});

'use strict';

var clientTasksCtrl = app.controller('clientTasksCtrl', function clientTasksCtrl($scope, $http, $routeParams, $location, $dialog) {
    //PRIVATE METHODS
    function init() {
        $http.get('/Reporting/PortalTask/' + $routeParams.clientTaskId, {trackerMsg: 'Loading tasks'})
            .then(function (response) {
                $scope.task = response.data;
            });
    }


    //PUBLIC METHODS
    $scope.saveTask = function(){
        $http.put('/Reporting/PortalTask/' + $scope.task.id, $scope.task, {trackerMsg: "Saving task"})
            .then(function() {
                $location.path('/advisor/clientTasks');
            });
    };

    $scope.deleteTask = function() {
        $dialog.confirmAction("Are you sure you want to delete this task?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete('/Reporting/PortalTask/' + $scope.task.id, {trackerMsg: 'Deleting task'})
                        .then(function() {
                            $location.path('/advisor/clientTasks').replace();
                        });
                }
            });
    };


    //INITIALIZE
    init();
});

clientTasksCtrl.getClientTasksConfig = function () {
    return {
        getUrl: '/Reporting/PortalTask',
        listName: 'Client Tasks',
        template: 'advisor/views/client-task-list-item.html',
        icon: 'fa fa-users',
        selectEnabled: false,
        multiSelectEnabled: false,
        nameProperty: 'title',
        defaultSortItem: 'clientName',
        sortFields: {clientName: "Household", assignedTo: "Assigned To", status: "Status"},
        listFilter: ['clientName', 'createdBy', 'editedBy', 'title', 'assignedTo', 'status'],
        additionalLinks: []
    };
};

clientTasksCtrl.getDefaultRoute = ['$http', '$q', function($http) {
    return $http.get('/Settings/Apps/clientExperience', {trackerMsg: 'Loading Client Experience'})
        .then(function(response) {
            return response.data.categories[0].pages[0].routeUrl.from(1);
        });
}];

'use strict';

app.controller('newsFeedPostEditCtrl', function newsFeedPostEditCtrl($scope, $http, $routeParams, $location, $dialog, $oasRights) {
    //PRIVATE VARIABLES
    let onRouteChangeOff;

    //PRIVATE METHODS
    function init() {
        if ($scope.currentId === '0') {
            $http.get('/Blogging/Newsfeed/Admin/New?feedType=Post', {trackerMsg: 'Fetching new post'})
                .then(function (response) {
                    $scope.currentPost = response.data;
                    updateRouteChangeValues(response.data);
                    $scope.current.currentPostStatus = $scope.currentPost.feedStatus;
                });
        } else {
            $http.get(`/Blogging/Newsfeed/Admin/${$routeParams.id}`, {trackerMsg: 'Fetching post'})
                .then(function (response) {
                    $scope.currentPost = response.data;
                    $scope.selectedClients = $scope.currentPost.audience.clients;
                    if (!$scope.currentPost.audience.includeAllClients) {
                        $scope.current.audienceType = 'partialClients';
                    }

                    updateRouteChangeValues(response.data);

                    $scope.current.currentPostStatus = $scope.currentPost.feedStatus;
                    let publishDate = new Date($scope.currentPost.publishDate);

                    if (publishDate <= new Date()) {
                        $scope.current.currentPostStatus = $scope.postStatuses.published;
                    }
                    if (publishDate > new Date()) {
                        $scope.current.currentPostStatus = $scope.postStatuses.scheduled;
                    }
                });
        }
        //this turns on/off the watch for listening for route change.
        onRouteChangeOff = $scope.$on("$routeChangeStart", routeChange);
    }
    function updateRouteChangeValues(data){
        $scope.currentPost = data;
        $scope.originalPost = angular.copy($scope.currentPost);
    }

    function routeChange(event, newUrl) {
        if (angular.equals($scope.currentPost, $scope.originalPost)) return;

        $dialog.messageBox("<i class='fa fa-floppy-o fa-lg' aria-hidden='true'></i>&nbsp;Save Draft", "You are about to leave this update. Would you like to save a draft?", [{
            result: true,
            label: 'Save Draft',
            focus: true,
            cssClass: "btn-primary"
        }, {result: false, label: 'Discard Update', focus: false, cssClass: ""}])
            .open()
            .then((msgBoxAnswer) => {
                onRouteChangeOff(); //Stop listening for location changes
                if(msgBoxAnswer){
                    $scope.saveDraftPost(newUrl);
                }
                else {
                    $location.path(newUrl.originalPath); //Go to page they're interested in
                }
            });

        event.preventDefault();
    }

    function canSave() {
        if (!$scope.currentPost.title && $scope.currentPost.title === '') {
            return {canSave: false, header: "Missing title", msg: "You must have at least a title before you can save a post."};
        }
        if ($scope.current.currentPostStatus === $scope.postStatuses.scheduled &&
            !$scope.currentPost.publishDate) {
            return {canSave: false, header: "Missing publishing date", msg: "Please enter a date."};
        }

        if ($scope.current.audienceType !== 'allClients' && $scope.selectedClients.length === 0) {
            return {
                canSave: false,
                header: "Missing Clients",
                msg: "You have not selected any client(s) please select at least one client or update your post to all clients. "
            };
        }
        return {canSave: true, header:"", msg: ""};
    }

    function savePostAction(url) {
        onRouteChangeOff();

        if ($scope.currentPost.id < 1) {
            $http.post("/Blogging/Newsfeed/Admin", $scope.currentPost, {trackerMsg: "Adding newsfeed post."})
                .then(function (response) {
                        $scope.currentPost = response.data;
                        $location.path(url.originalPath); //Go to page they're interested in
                    });
        } else {
            $http.put(`/Blogging/Newsfeed/Admin/${$scope.currentPost.id}`, $scope.currentPost, {trackerMsg: "Saving newsfeed post."})
                .then(function (response) {
                    $scope.currentPost = response.data;
                    $location.path(url.originalPath); //Go to page they're interested in
                });
        }
    }

    //PUBLIC METHODS
    $scope.addSelectedClient = function (selected) {
        $scope.selectedClients.push(selected);
        $scope.current.selectedEntity = null;
    };

    $scope.removeClient = function (client) {
        $scope.selectedClients.remove(client);
    };

    $scope.onPublishTypeChange = function(status){
        $scope.current.currentPostStatus = status;
    };

    $scope.saveDraftPost = function(url){
        let canPostBeSaved = canSave();
        let newUrl = url?url:{originalPath:`/advisor/newsFeedPosts`};

        if (!canPostBeSaved.canSave) {
            $dialog.messageBox(canPostBeSaved.header, canPostBeSaved.msg).open();
            return;
        }

        if ($scope.current.audienceType === 'allClients') {
            $scope.currentPost.audience.includeAllClients = true;
        } else {
            $scope.currentPost.audience.includeAllClients = false;
            $scope.currentPost.audience.clients = $scope.selectedClients;
        }

        $scope.currentPost.feedStatus = $scope.postStatuses.draft;

        //Immediately published posts have a null publish date when its a draft.
        if($scope.current.currentPostStatus === $scope.postStatuses.published){
            $scope.currentPost.publishDate = null;
        }
        savePostAction(newUrl);
    };

    $scope.savePost = function (url) {
        let canPostBeSaved = canSave();
        let newUrl = url;

        $scope.currentPost.feedStatus = $scope.current.currentPostStatus;

        //you can't post immediately a draft
        if($scope.currentPost.feedStatus === $scope.postStatuses.draft){
            $scope.currentPost.feedStatus = $scope.postStatuses.published;
        }

        if(!newUrl){
            newUrl ={originalPath:`/advisor/newsFeedPosts`};
        }

        if (!canPostBeSaved.canSave) {
            $dialog.messageBox(canPostBeSaved.header, canPostBeSaved.msg).open();
            return;
        }

        if ($scope.current.audienceType === 'allClients') {
            $scope.currentPost.audience.includeAllClients = true;
        } else {
            $scope.currentPost.audience.includeAllClients = false;
            $scope.currentPost.audience.clients = $scope.selectedClients;
        }

        var dateFormatted = $scope.currentPost.publishDate ?
            new Date($scope.currentPost.publishDate).format('{M}/{d}/{yyyy}')
            : new Date().format('{M}/{d}/{yyyy}');


            const heading = "<i class='fa fa-calendar fa-lg' aria-hidden='true'></i>&nbsp;Scheduled Post";
            let buttons = [
                {result: 'yes', label: 'Post Immediately', cssClass: 'btn-primary newsfeed-btn-primary'},
                {result: 'ok', label: 'Ok'},
                {result: 'cancel', label: 'Cancel'}
            ];

            if ($scope.currentPost.feedStatus === $scope.postStatuses.published) {
                buttons = [
                    {result: 'yes', label: 'Ok', cssClass: 'btn-primary newsfeed-btn-primary'},
                    {result: 'cancel', label: 'Cancel'}
                ];
                dateFormatted = new Date().format('{M}/{d}/{yyyy}');
                $scope.currentPost.publishDate = dateFormatted;
            }

            $dialog.messageBox(heading, "This update is scheduled to post on <strong>" + dateFormatted + "</strong>.", buttons)
                .open()
                .then(function (rslt) {

                    switch (rslt) {
                        case 'cancel':
                            return;
                        case 'yes':
                            $scope.currentPost.publishDate = new Date().format('{M}/{d}/{yyyy}');
                            break;
                        case 'ok':
                            break;
                    }
                    savePostAction(newUrl);
                });

    };

    $scope.deletePost = function () {
        $dialog.confirmAction("Are you sure you want to delete the news feed post(s)? This cannot be undone.")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    onRouteChangeOff();
                    if ($scope.currentPost.id < 1) {
                        window.location.replace($scope.current.url);
                    }
                    $http.put('/Blogging/Newsfeed/Admin/Action/Delete/', [$scope.currentPost.id], {trackerMsg: 'Deleting News feed post(s)'})
                        .then(function () {
                            window.location.replace($scope.current.url);
                        });
                }
            });
    };

    $scope.postStatuses = {draft: 'Draft', scheduled:'Scheduled', published: 'Published'};
    $scope.current = {
        url: "#/advisor/newsFeedPosts",
        audienceType: 'allClients',
        scheduleType: 'Immediately',
        currentPostStatus:$scope.postStatuses.draft,
    };
    $scope.rightsClientExperience = $oasRights.forCode("CLIENTEXPERIENCE");
    $scope.showNew = $scope.rightsClientExperience.canAdd;
    $scope.showEdit = $scope.rightsClientExperience.canUpdate;
    $scope.showDelete = $scope.rightsClientExperience.canDelete;
    $scope.currentPost = {};
    $scope.currentId = $routeParams.id;
    $scope.selectedClients = [];

    //INITIALIZE
    init();
});

'use strict';

 app.controller('newsFeedPostsCtrl', function newsFeedPostsCtrl($scope, $http, $routeParams, $location, $dialog, views, $oasRights) {
    //PRIVATE VARIABLES
    let selectedRows;

    //PRIVATE METHODS
    function init() {
        $http.get('/Blogging/Newsfeed/Admin/New?feedType=Post', {trackerMsg: 'Fetching new post'})
            .then(function (response) {
                $scope.current.selected = response.data;
            });
    }


    //PUBLIC METHODS
    $scope.editPost = function (id) {
        let url = `${$scope.current.editUrl}/${id}`;

        window.location.replace(url);
    };

    $scope.deletePost = function(){
        $dialog.confirmAction("Are you sure you want to delete the news feed post(s)? This cannot be undone.")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $http.put('/Blogging/Newsfeed/Admin/Action/Delete', selectedRows.map('id'), {trackerMsg: 'Deleting News feed post(s)'})
                        .then(function() {
                            refreshGrid();
                        });
                }
            });
    };

    function refreshGrid () {
        $scope.$broadcast('event:newsfeed-posts-refresh', {action: 'refresh-grid'});
    }

    $scope.slickGridDoubleClick = function () {
        if ($scope.showEdit === true) {
            $scope.editPost(selectedRows[0].id);
        }
    };

    $scope.$on('event:newsfeed-posts-select', function (e, args) {
        $scope.showEdit = false;
        $scope.showDelete = false;

        if (args.length === 0) {
            return;
        }

        selectedRows = args;

        $scope.showDelete = $scope.rightsClientExperience.canDelete;

        if($scope.rightsClientExperience.canUpdate) {
            if (args.length === 1 && ['EBN', 'Statement'].none(args[0].feedStatus) ) {
                $scope.current.selected = args[0];

                $scope.showEdit = $scope.rightsClientExperience.canUpdate;
            } else {
                $scope.selectedIds = args.map(item => item.id);
            }
        }
    });

    $scope.views = views;
    $scope.current = {
        url: '/Blogging/Newsfeed/Admin/Grid/Post',
        view: $scope.views[0],
        method: "GET",
        editUrl: '#/advisor/newsFeedPostEdit',
        selected: {id: null},
        gridDoubleClick: $scope.slickGridDoubleClick
    };
    $scope.filterType = ["Active", "Ended"];
    $scope.selectedIds = [];
    $scope.rightsClientExperience = $oasRights.forCode("CLIENTEXPERIENCE");
    $scope.showNew = $scope.rightsClientExperience.canAdd;
    $scope.showEdit = false;
    $scope.showDelete = false;


    //INITIALIZE
    init();
});


'use strict';

app.controller('newsFeedRssCtrl', function newsFeedRssCtrl($scope, $http, $routeParams, $location, $dialog, $oasRights, $timeout, views) {
    //PRIVATE VARIABLES
    let selectedRows;

    //PRIVATE METHODS
    function init() {
    }

    function refreshGrid( ) {
        $scope.$broadcast('event:newsfeed-rss-event', {action: 'refresh-grid'});
    }

    $scope.slickGridDoubleClick = function () {
        if (selectedRows.length === 1) {
            $scope.editFeed('Edit');
        }
    };


    //PUBLIC METHODS
    $scope.editFeed = function (  title ) {
        var currentId = 0;
        if(title === 'Edit'){
            if(selectedRows.length === 1){
                currentId = selectedRows[0].id;
            }else {
                return;
            }
        }

        var dialogOpts = {
            templateUrl : 'advisor/modals/NewsFeed-Rss-Dialog.html',
            controller : 'NewsFeedRssDialogCtrl',
            dialogClass: "modal wide",
            title : title,
            id : currentId,

        };

        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function () {
            refreshGrid();
        });
    };

    $scope.setActive = function ( isActive ) {
            $http.put('/Blogging/Newsfeed/Admin/Action/Active?isActive=' + isActive, selectedRows.map('id'), {trackerMsg: 'Deleting RSS Feed'})
                .then(function() {
                    refreshGrid();
                });
    };

    $scope.deleteFeed = function ( ) {
        $dialog.confirmAction("Are you sure you want to delete RSS Feed(s)? This cannot be undone.")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $http.put('/Blogging/Newsfeed/Admin/Action/Delete', selectedRows.map('id'), {trackerMsg: 'Deleting RSS Feed'})
                        .then(function() {
                            refreshGrid();
                        });
                }
            });
    };

    $scope.$on('event:newsfeed-rss-select', function (e, args) {
        $scope.showEdit = false;
        $scope.showDelete = false;
        $scope.showActive = false;
        $scope.showInactive =false;

        if (args.length === 0) {
            return;
        }

        selectedRows = args;

        $scope.showDelete = $scope.rightsClientExperience.canDelete;

        if($scope.rightsClientExperience.canUpdate) {
            if(args.length === 1) {
                $scope.showEdit = $scope.rightsClientExperience.canUpdate;
            }

            const activeCount = selectedRows.count({"isActive": true});
            const allRowsAreActive = selectedRows.length === activeCount;
            const allRowsAreInActive = activeCount === 0;
            $scope.showActive = !allRowsAreActive;
            $scope.showInactive = !allRowsAreInActive;
        }

    });

    $scope.views = views;
    $scope.current = {
        url: "/Blogging/Newsfeed/Admin/Grid/Rss",
        view: $scope.views[0],
        method: "GET",
        gridDoubleClick: $scope.slickGridDoubleClick,
    };
    $scope.filterType = ["Active", "Ended"];
    $scope.selectedIds = [];

    //INITIALIZE
    $scope.rightsClientExperience = $oasRights.forCode("CLIENTEXPERIENCE");
    $scope.showNew = $scope.rightsClientExperience.canAdd;
    $scope.showEdit = false;
    $scope.showDelete = false;
    $scope.showActive = false;
    $scope.showInactive =false;

    init();
});

'use strict';

app.controller('NewsFeedRssDialogCtrl', function NewsFeedRssDialogCtrl($scope, dialog, $http) {
    //PRIVATE VARIABLES
    // let rssFeed;

    //PRIVATE METHODS
    function init(){
        getRssFeed();
    }

    function getRssFeed(){
        if($scope.current.id === 0){
            $http.get('/Blogging/Newsfeed/Admin/New?feedType=2', {cache: false})
                .then(function (response) {
                    $scope.feedData = response.data;
                });
        }
        else{
            $http.get('/Blogging/Newsfeed/Admin/' + $scope.current.id, {cache: false})
                .then(function (response) {
                    $scope.feedData = response.data;
                });
        }


    }
    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close();
    };

    $scope.submit = function (){
        var url = "/Blogging/Newsfeed/Admin";

        if($scope.feedData.id){
            $http.put(url + '/' + $scope.feedData.id, $scope.feedData, {trackerMsg: 'Saving RSS Feed'})
                .then(function (response) {
                    dialog.close(response.data);
                });
        } else{
            $http.post(url, $scope.feedData, {trackerMsg: 'Saving RSS Feed'})
                .then(function (response) {
                    dialog.close(response.data);
                });
        }
    }

//INITIALIZE
    $scope.current = {
        title : dialog.options.title ? dialog.options.title : 'New',
        id : dialog.options.id ? dialog.options.id : 0

    };
    init();
});
'use strict';
var quarterEndDashboardCtrl = app.controller('QuarterEndDashboardCtrl', function QuarterEndDashboardCtrl($scope, $http, $q, $dialog, $routeParams, $location, $oasRights, API_CONFIG, $dataQuery) {

    //PRIVATE VARIABLES
    var dashboardID = $routeParams.dashboardId;


    //PRIVATE METHODS
    function initialize() {
        if (dashboardID <= 0) {
            $scope.addBreadcrumb("New Dashboard");
            $scope.dashBoard = {
                id: 0,
                title: "",
                period: 0,
                startDate: null,
                targetDate: null,
                signedOffBy: '',
                signedOffDate: null,
                workflowItemId: 0,
                workflowItem: null,
                friendlyName: ""
            };
            $scope.updateProcessMsg($scope.dashBoard.period);
            $scope.current.workflowProgress = 0;
            $scope.current.addNew = true;
            $scope.current.expandWidget = false;
            $scope.dashBoardList = null;
        }
        else {
            $http.get('/Reporting/QPE/' + dashboardID, {trackerMsg: 'Retrieving QPE dashboard details'})
                .then(function (response) {
                    var data = response.data;

                    data.targetDate = Date.create(data.targetDate);
                    data.startDate = Date.create(data.startDate);
                    if (data.signedOffDate) {
                        data.signedOffDate = Date.create(data.signedOffDate);
                        $scope.current.workflowSignedOff = true;
                    }
                    if (data.newsletter) {
                        $scope.current.hasNewsletter = true;
                    }
                    $scope.addBreadcrumb(data.friendlyName);
                    $scope.dashBoard = data;

                    data.period == 0 ? $scope.current.processStatusMsg = 'Quarter' : $scope.current.processStatusMsg = 'Month';
                    setWorkflowProgress();
                    $scope.current.expandWidget = true;
                });

            loadDashboardData(false);

            $http.get('/Settings/Apps/qpedashboard/options/dataqueries', {trackerMsg: 'Getting queries'})
                .then(function (response) {
                    var dataQueryIds = response.data.value.split(',');

                    $http.post('/Reporting/Custom/Simple/List', dataQueryIds, {trackerMsg: ''})
                        .then(function (response) {
                            $scope.dataQueries = response.data;
                        });
                });

            $http.get('/Settings/Apps/customImports', {trackerMsg: ''})
                .then(function (response) {
                    $scope.current.customImportUrl = response.data.routeUrl.replace('[TOKEN]', sessionStorage.oas_token);
                });
        }
    }

    function loadDashboardData(isReset) {
        /* if the requested dashboard is signed off then the query string parameters will be overridden in the webAPI */
        /* a signed off dashboard will pull data from the tblQPEDashboardDtl table */
        $q.all({
                helpText: $http.get("advisor/QuarterEndProcessMgrHelpText.json"),
                dashboard: $http.get('/Reporting/QPE/' + dashboardID + '/Dashboard?storeSnapshotData={1}&getStoredData={1}&resetCache={1}'.assign(isReset), {trackerMsg: 'Loading QPE dashboard widgets'})
            })
            .then(function (responses) {
                $scope.current.reportListId = 0;

                var data = responses.dashboard.data;
                data.forEach(function (category) {
                    var categoryName = {EntityOptionBilling: "Billing Options", EntityOptionPerformance: "Performance Options"}[category.category];
                    
                    var helpText = responses.helpText.data[categoryName];
                    if (helpText) {
                        category.items.forEach(function (subCategory) {
                            subCategory.items.forEach(function (item) {
                                item.helpText = helpText[item.name] || null;
                            });
                        });
                    }

                    if (category.category === "ReportName") {
                        $scope.current.reportListId = category.items[0].items[0].reportListId;
                    }
                });

                $scope.dashBoardWidgets = data;
            });
    }

    function saveDashboardWorkflowItem() {
        var args = {method: "PUT", url: '/Reporting/QPE/', id: dashboardID, trackerMsg: "Saving dashboard " + dashboardID};
        $http({method: args.method, url: args.url + args.id, data: $scope.dashBoard, trackerMsg: args.trackerMsg})
            .then(function () {
                setWorkflowProgress();
                //updateWorkFlowProgress();
            });
    }

    function setWorkflowProgress() {
        var progressCount = 0.0;
        var totalCount = 0.0;
        var percentCompleted = 0.0;
        $scope.dashBoard.workflowItem.actions.forEach(function (item) {
            totalCount += 1.0;
            if (item.completedDate != null) {
                progressCount += 1.0;
            }
            percentCompleted = (progressCount / totalCount) * 100.0;
        });
        $scope.current.workflowProgress = percentCompleted;
    }


    //PUBLIC METHODS
    $scope.refreshData = function () {
        $http.get('/Reporting/QPE/' + dashboardID, {trackerMsg: 'Retrieving dashboard details'})
            .then(function (response) {
                $scope.dashBoard = response.data;
                setWorkflowProgress();
            });

        loadDashboardData(true);
    };

    $scope.updateProcessMsg = function (value) {
        value == 0 ? $scope.current.processStatusMsg = 'Quarter' : $scope.current.processStatusMsg = 'Month';
    };

    $scope.setWorkFlowStatus = function (actionItem) {
        if (actionItem.completedDate == null) {
            actionItem.completedDate = Date.create('today').formatted();
        } else {
            actionItem.completedDate = null;
        }
        saveDashboardWorkflowItem();
    };

    $scope.resetDashboard = function (form, signOff) {
        var args = {method: "PUT", url: '/reporting/qpe/' + dashboardID + '?signOff=' + signOff, id: dashboardID, trackerMsg: "Saving dashboard " + $scope.dashBoard.friendlyName};
        $scope.dashBoard.signedOffBy = '';
        $scope.dashBoard.signedOffDate = null;
        if (form.$valid) {
            $http({method: args.method, url: args.url, data: $scope.dashBoard, trackerMsg: args.trackerMsg})
                .then(function (response) {
                    if (dashboardID > 0) {
                        $scope.updateBreadcrumb(response.data.friendlyName); //in case it changed
                        $location.path('/advisor');
                    } else {
                        $scope.deleteBreadcrumb();
                        $scope.addBreadcrumb(response.data.friendlyName, '/advisor/quarterend/' + response.data.id);
                        $scope.dashBoard.id = response.data.id;
                        dashboardID = response.data.id;
                        $location.path('/advisor/quarterend/' + response.data.id);
                    }
                });
        }
    };

    $scope.saveDashboard = function (form, signOff) {
        var args = dashboardID > 0 ? {method: "PUT", url: '/reporting/qpe/' + dashboardID + '?signOff=' + signOff, id: dashboardID, trackerMsg: "Saving dashboard " + $scope.dashBoard.friendlyName} : {
            method: "POST",
            url: '/reporting/qpe/',
            id: "",
            trackerMsg: "Adding new dashboard"
        };
        
        if (form.$valid) {
            $http({method: args.method, url: args.url, data: $scope.dashBoard, trackerMsg: args.trackerMsg})
                .then(function (response) {
                    if (dashboardID > 0) {
                        $scope.updateBreadcrumb(response.data.friendlyName); //in case it changed
                        $location.path('/advisor');
                    }
                    else {
                        $scope.deleteBreadcrumb();
                        $scope.addBreadcrumb(response.data.friendlyName, '/advisor/quarterend/' + response.data.id);
                        $scope.dashBoard.id = response.data.id;
                        dashboardID = response.data.id;
                        $location.path('/advisor/quarterend/' + response.data.id);
                    }

                });
        } else {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> New dashboard is invalid", "One or more required fields on the new dashboard page are invalid or required, please correct and try saving again.").open();
        }
    };

    $scope.cancelNew = function () {
        if (dashboardID <= 0) {
            $scope.dashBoard = null;
            $scope.deleteBreadcrumb();
        }
        $location.path('/advisor');
    };

    $scope.deleteDashboard = function () {
        if (dashboardID > 0) {
            var dashboardName = $scope.dashBoard.friendlyName;
            $dialog.confirmAction("<span style='font-size: 18px;font-weight: bold'>Delete dashboard:  " + dashboardName + "?</span>")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $http.delete('/reporting/qpe/' + dashboardID, {trackerMsg: 'Deleting dashboard ' + dashboardName})
                            .then(function () {
                                $scope.deleteBreadcrumb();
                                $location.path('/advisor');
                            });
                    }
                });
        }
    };

    $scope.dashboardDetailFeeSchedules = function (linkCode, scheduleName) {
        $http.get('/Reporting/QPE/' + dashboardID + '/DrillDown?linkCode=' + linkCode, {trackerMsg: 'Loading QPE dashboard widgets'})
            .then(function (response) {
                var msg = '<div class="row-fluid">' +
                    '<div class="span12">' +
                    '<div class="section-list">' +
                    '<table class="table table-condensed table-striped no-bottom-margin">' +
                    '<tr><th style="background-color: #f8f8f8;">Schedule Name</th><th style="background-color: #f8f8f8;">Assigned Count</th></tr>';
                response.data.forEach(function (item) {
                    msg += '<tr><td style="width: 60%;">' + item.scheduleName + '</td><td style="width: 40%;white-space: normal;">' + item.assignedCount + '</td></tr>';
                });
                msg += '</table></div></div></div>';

                $dialog.messageBox('Fee Schedules ' + '(' + scheduleName + ')', msg).open();
            });
    };

    $scope.upLoadNewsLetter = function () {
        $dialog.inputBox("Upload Newsletter", "File", "file", {postUrl: '/Reporting/QPE/' + dashboardID + '/DashboardNewsletter'})
            .open()
            .then(function (result) {
                if (result) {
                    $scope.current.hasNewsletter = true;
                }
            });
    };

    $scope.downloadNewsLetter = function () {
        window.location.href = API_CONFIG.baseUrl + '/Reporting/QPE/' + dashboardID + '/DashboardNewsletter' + '?Authorization=' + sessionStorage.oas_token
    };

    $scope.launchDataQuery = function (dataQuery) {
        $dialog.dataQueryPrompt(dataQuery.id)
            .open()
            .then(function (result) {
                if (result && result.id) {
                    $dataQuery.setDataQuery(result);
                    $location.path('/reports/dataqueries/' + dataQuery.id);
                }
            });
    };

    $scope.showHelpText = function (link) {
        $dialog.messageBox(link.name, link.helpText).open();
    };

    $scope.saveOption = function (es) {
        /* Video Statement Options */
        if (es.description == 'Video Statement Text') {
            var eStatementText = {
                fieldName: "VideoStatementText",
                fieldValue: '',
                notes: "Body of the video statement email.  The link will be appended to the end of this text.",
                systemGroup: "EStatement"
            };
            eStatementText.fieldValue = es.value;
            $http({method: 'Put', url: '/Settings/Options/VideoStatementText', data: eStatementText, trackerMsg: 'Saving video statement text'});
        }
        if (es.description == 'Video Statement Subject') {
            var eStatementText = {
                fieldName: "VideoStatementSubjectLine",
                fieldValue: '',
                notes: "Video Email Subject.",
                systemGroup: "EStatement"
            };
            eStatementText.fieldValue = es.value;
            $http({method: 'Put', url: '/Settings/Options/VideoStatementSubjectLine', data: eStatementText, trackerMsg: 'Saving video statement subject'});
        }

        /* Video And Statement Options */
        if (es.description == 'Video And Statement Text') {
            var eStatementText = {
                fieldName: "VideoAndStatementText",
                fieldValue: '',
                notes: "Body of the video and statement email.  The link will be appended to the end of this text.",
                systemGroup: "EStatement"
            };
            eStatementText.fieldValue = es.value;
            $http({method: 'Put', url: '/Settings/Options/VideoAndStatementText', data: eStatementText, trackerMsg: 'Saving video statement text'});
        }
        if (es.description == 'Video And Statement Subject') {
            var eStatementText = {
                fieldName: "VideoAndStatementSubjectLine",
                fieldValue: '',
                notes: "Video And Statement Email Subject.",
                systemGroup: "EStatement"
            };
            eStatementText.fieldValue = es.value;
            $http({method: 'Put', url: '/Settings/Options/VideoAndStatementSubjectLine', data: eStatementText, trackerMsg: 'Saving video statement subject'});
        }


        es.isEditMode = false;
    };

    //INITIALIZE
    $scope.current = {workflowProgress: 0.00, workflowSignedOff: false, addNew: false, processStatusMsg: "", isCollapsed: false, expandWidget: true, hasNewsletter: false, isEditMode: false};
    $scope.rights = $oasRights.forCode("QPEDASHBOARD");
    // $scope.current.canUpdateEStatement = $oasRights.canUpdate("DBOPTIONS");

    //TODO: replace this line with the one above when security is finished in webApi
    $scope.current.canUpdateEStatement = $oasRights.canUpdate("ESTATEMENTEMAILTEXT");

    $scope.isCollapsed = true;
    $scope.isEditMode = false;

    initialize();
});

quarterEndDashboardCtrl.getQPEListConfig = function () {
    return {
        getUrl: '/Reporting/ProcessManager/Dashboard',
        listName: 'Dashboards',
        template: 'advisor/views/dashboard-list-item.html',
        icon: 'fa fa-users',
        defaultSortItem: 'targetDate',
        defaultSortDirection: 'DESC',
        nameProperty: 'friendlyName',
        selectEnabled: true,
        multiSelectEnabled: false,
        sortFields: {completedPercent: "percent complete", friendlyName: "name", id: "id", title: "title", signedOffBy: "signed off by", startDate: "start date", targetDate: "target date"},
        //listFilter: function(item, value) {return (item.name && item.name.toLowerCase().indexOf(value) !== -1) || (item.fundName && item.fundName.toLowerCase().indexOf(value) !== -1);}
        listFilter: ['startDate', 'targetDate', 'signedOffBy', 'id', 'completedPercent', 'friendlyName'],
        additionalLinks: [{name: "New Dashboard", url: "", clickEvent: "newQPEDashboard", icon: "fa fa-pencil"}]
    };
};
'use strict';

app.controller('QuarterEndProcessMgrCtrl', function QuarterEndProcessMgrCtrl($scope, $sce, $q, $http, $routeParams, $location, $dialog, $dataQuery, $oasRights) {
    //PRIVATE VARIABLES
    var dashboardId = $routeParams.dashboardId;
    var actionTypes = [];
    var reportBatches;
    var helpText = [];
    var modalTask;
    var customLinkMap = [
        {type: "CustomLinkPortfolioAudit", name: "Portfolio Audit", url: "#/portfolio/households"},
        {type: "CustomLinkBillingAudit", name: "Billing Audit", url: "#/billing/audit/households"},
        {type: "CustomLinkProductsPrices", name: "Products & Prices", url: "#/products/myproducts/currentlyownedproducts"}
    ];


    //PRIVATE METHODS
    function init() {
        $http.get('/Reporting/Batch?qpeItemId=' + dashboardId, {trackerMsg: 'Loading report batches'})
            .then(function (response) {
                reportBatches = [{id: null, name: "Create New Batch"}].add(response.data);
            });

        $q.all({
            helpText: $http.get("advisor/QuarterEndProcessMgrHelpText.json"),
            dashboard: $http.get('/Reporting/ProcessManager/Dashboard/' + dashboardId, {trackerMsg: 'Loading quarter-end dashboard'})
        })
            .then(function (responses) {
                $scope.dashboard = responses.dashboard.data;

                $scope.dashboard.reviewTasks.find({name: "Options & Settings"}).tasks.forEach(function (task) {
                    if (task.entity === "Entity Option") {
                        helpText = responses.helpText.data[task.name];
                        task.data.totalDifferent = 0;

                        task.data.EntityOptions.forEach(function (category) {
                            category.Options.forEach(function (item) {
                                if (helpText) {
                                    item.helpText = helpText[item.Name] || null;
                                }
                                if (item.Current !== item.Previous) {
                                    ++task.data.totalDifferent;
                                }
                            });
                        });
                    }
                });

                getActionTypes($scope.dashboard.typeId);
            });
    }

    function getActionTypes(typeId) {
        $http.get("/Reporting/ProcessManager/ActionTypes?typeId=" + typeId, {cache: true, trackerMsg: 'Loading action types'})
            .then(function (response) {
                actionTypes = response.data;
            });
    }

    function addCustomTask(category, name, type, id, url) {
        var actionType = actionTypes.find({code: type});

        var customEntity = null;
        var dataValue = id;
        var lockdownOptionValue = "Prerequisite";
        if (!dataValue && type !== "CustomText") {
            if (type === "CustomLinkExternal") {
                dataValue = url;
            } else {
                dataValue = customLinkMap.find({type: type}).url;
                customEntity = type === "CustomLinkProductsPrices" ? "Product" : "Household";
            }
        } else if (dataValue === -1) {
            lockdownOptionValue = "NoEffect";
        }

        category.tasks.push({
            workflowActionId: 0,
            name: name,
            typeId: actionType.id,
            type: type,
            couldBeAlteredByUser: true,
            taskOffsetInDays: 0,
            lockdownOption: lockdownOptionValue,
            canSignOff: true,
            signedOffDate: null,
            entity: customEntity,
            data: {Data: dataValue},
            redirectUrl: url,
            actionSequence: category.tasks.length + 1,
            phaseSequence: category.tasks[0].phaseSequence
        });

        orderActionSequence(category);
    }

    function orderActionSequence(category) {
        var sequence = 0;
        category.tasks.forEach(function (task) {
            task.actionSequence = ++sequence;
        });
    }

    function runDataQuery(id) {
        $dialog.dataQueryPrompt(id)
            .open()
            .then(function (result) {
                if (result && result.id) {
                    $dataQuery.setDataQuery(result);
                    $location.path('/reports/dataqueries/' + result.id);
                }
            });
    }


    //PUBLIC METHODS
    $scope.runDashboardAudit = function () {
        runDataQuery(9821);  //9821 = Dashboard Sign Off Audit
    };

    $scope.reviewOptions = function (task) {
        $dialog.dialog({templateUrl: "qed-option-review.html", controller: "QedOptionReviewCtrl", dialogClass: "modal wide", task: task}).open();
    };

    $scope.runDataQuery = function (task) {
        runDataQuery(task.data.Data);
    };

    $scope.runReport = function (task) {
        $dialog.reportPrompt(task.data.Data).open();
    };

    $scope.addBasicTask = function (category) {
        $dialog.inputBox('Basic Task', 'Task Description', 'textarea')
            .open()
            .then(function (result) {
                if (result) {
                    addCustomTask(category, result, "CustomText");
                }
            });
    };

    $scope.addNoteTask = function (category) {
        $dialog.inputBox('Note', 'Description', 'textarea')
            .open()
            .then(function (result) {
                if (result) {
                    addCustomTask(category, result, "CustomText", -1);
                }
            });
    };

    $scope.addDataQueryTask = function (category) {
        $dialog.search("dataQuery", "Data Query Task")
            .open()
            .then(function (dataQuery) {
                if (dataQuery) {
                    addCustomTask(category, dataQuery.name, "CustomDataQuery", dataQuery.id);
                }
            });
    };

    $scope.addReportTask = function (category) {
        $dialog.search("report", "Report Task")
            .open()
            .then(function (report) {
                if (report) {
                    addCustomTask(category, report.name, "CustomReport", report.id);
                }
            });
    };

    $scope.addLinkTask = function (category) {
        $dialog.dialog({templateUrl: "add-link-task.html", controller: "AddLinkTaskCtrl", internalLinks: customLinkMap})
            .open()
            .then(function (result) {
                if (result) {
                    addCustomTask(category, result.name, result.type, null, result.redirectUrl);
                }
            });
    };

    $scope.editTask = function (task) {
        switch (task.type) {
            case "CustomText":
                var isBasicTask = task.lockdownOption === "Prerequisite";
                $dialog.inputBox(isBasicTask ? 'Basic Task' : 'Note', isBasicTask ? 'Task Description' : 'Description', 'textarea', {inputValue: task.name})
                    .open()
                    .then(function (result) {
                        if (result) {
                            task.name = result;
                        }
                    });
                break;
            case "CustomReport":
                $dialog.search("report", "Report Task")
                    .open()
                    .then(function (report) {
                        if (report) {
                            task.name = report.name;
                            task.data = {Data: report.id};
                        }
                    });
                break;
            case "CustomDataQuery":
                $dialog.search("dataQuery", "Data Query Task")
                    .open()
                    .then(function (dataQuery) {
                        if (dataQuery) {
                            task.name = dataQuery.name;
                            task.data = {Data: dataQuery.id};
                        }
                    });
                break;
            default:
                if (task.type.startsWith("CustomLink")) {
                    $dialog.dialog({templateUrl: "add-link-task.html", controller: "AddLinkTaskCtrl", internalLinks: customLinkMap, task: task})
                        .open()
                        .then(function (result) {
                            if (result) {
                                var actionType = actionTypes.find({code: result.type});
                                var dataValue = null;

                                if (result.type === "CustomLinkExternal") {
                                    dataValue = result.redirectUrl;
                                } else {
                                    dataValue = customLinkMap.find({type: result.type}).url;
                                }

                                task.name = result.name;
                                task.type = result.type;
                                task.typeId = actionType.id;
                                task.data = {Data: dataValue};
                            }
                        });
                }
        }
    };

    $scope.deleteTask = function (category, task) {
        category.tasks.remove(task);
    };

    $scope.moveTask = function (category, task, indexChange) {
        var index = category.tasks.indexOf(task),
            newPos = index + indexChange;

        category.tasks.splice(index, 1);
        category.tasks.splice(newPos, 0, task);

        orderActionSequence(category);
    };

    $scope.signOffTask = function (task) {
        switch (task.type) {
            case 'OrionReconDST':
                return $scope.orionReconDstTaskLogic(task);
            default:
                return $scope.runSignOffTask(task);
        }
    };

    $scope.orionReconDstTaskLogic = function (task) {
        if ($scope.userEntity !== "Administrator") {
            if (!task.data.hasOwnProperty('isLocked')) {
                modalTask = task;
                document.querySelector('#qpe-legal-modal').open();
            } else if (!task.data.isLocked) {
                return $scope.runSignOffTask(task);
            }
        } else {
            return $scope.runSignOffTask(task);
        }
    };

    $scope.getHtmlData = function(category) {
        const style = category.name === 'Orion Contact Review' ? `white-space: pre-wrap` : '';
        let newDescription = `<small style="${style}">${category.description}</small>`
        return $sce.trustAsHtml(newDescription);
    }

    $scope.closeQpeLegalModal = function () {
        document.querySelector('#qpe-legal-modal').close();
    };

    $scope.setQpeLegal = function (isLocked) {
        $scope.closeQpeLegalModal();
        let task = modalTask;
        if (isLocked) {
            task.data.isLocked = true;
        }
        return $http.put('/Reporting/ProcessManager/Dashboard/' + dashboardId + '/WorkflowAction/' + task.workflowActionId + '/Action/SignOff/Lock?isLocked=' + isLocked, null, {trackerMsg: "Saving dashboard data"})
            .then(function (response) {
                task.data = response.data.data;
                if (!isLocked) {
                    return $scope.runSignOffTask(task);
                } else {
                    return task;
                }
            });
    };

    $scope.runSignOffTask = function (task) {
        return $http.put('/Reporting/ProcessManager/Dashboard/' + dashboardId + '/WorkflowAction/' + task.workflowActionId + '/Action/SignOff', null, {trackerMsg: "Saving dashboard data"})
            .then(function (response) {
                task.signedOffBy = response.data.signedOffBy;
                task.signedOffDate = response.data.signedOffDate;

                return task;
            });
    };

    $scope.revisitTask = function (task) {
        return $http.put('/Reporting/ProcessManager/Dashboard/' + dashboardId + '/WorkflowAction/' + task.workflowActionId + '/Action/SignOff/Revoke', null, {trackerMsg: "Saving dashboard data"})
            .then(function (response) {
                task.signedOffBy = response.data.signedOffBy;
                task.signedOffDate = response.data.signedOffDate;

                return task;
            });
    };

    $scope.reviewTasksPercentComplete = function () {
        if (!$scope.dashboard) return 0;

        var totalTasks = $scope.dashboard.reviewTasks.sum(function (category) {
            return category.tasks.count({lockdownOption: 'Prerequisite'});
        });

        return ((totalTasks - $scope.reviewTasksRemaining()) / totalTasks) * 100;
    };

    $scope.reviewTasksRemaining = function () {
        return $scope.dashboard.reviewTasks.sum(function (category) {
            return category.tasks.count({signedOffDate: null, lockdownOption: 'Prerequisite'});
        });
    };

    $scope.lockdownDashboard = function () {
        var title = 'Dashboard Lockdown';
        var msg = 'By clicking "Sign Off" you are confirming to Orion Advisors Services that all necessary audits and scrubs have been completed and no further adjustments are needed prior to the generation of billing and statements. '
                + 'You will have the ability to lockdown your database by proceeding to the Billing Wizard after signing off. We highly recommend locking down the database so that other users are limited in making changes that can affect bills and statements.<br/>'
                + 'Please note this signoff cannot be undone.';
        var buttons = [{result: 'yes', label: 'Sign Off', cssClass: 'btn-primary'}, {result: 'no', label: 'Cancel'}];

        $dialog.messageBox(title, msg, buttons)
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.put('/Reporting/ProcessManager/Dashboard/' + dashboardId + '/Action/Lockdown', null, {trackerMsg: "Locking down dashboard"})
                        .then(function (response) {
                            $scope.dashboard.isLockedDown = true;
                            $scope.dashboard.signedOffBy = response.data.signedOffBy;
                            $scope.dashboard.signedOffDate = response.data.signedOffDate;
                        });
                }
            });
    };

    $scope.launchProcessTask = function (task) {
        if (task.signedOffDate) {
            $scope.revisitTask(task)
                .then(function (task) {
                    $scope.signOffTask(task);
                });
        } else {
            $scope.signOffTask(task);
        }

        if (task.type === "ProcessStatementBatchWizard") {
            if (reportBatches.length > 1) {
                $dialog.inputBox("Report Batches", "Select Batch", reportBatches, {inputValue: reportBatches[0]})
                    .open()
                    .then(function (result) {
                        if (!result) return;

                        if (result.id) {
                            $location.url("/reports/batches/entities?batchId=" + result.id);
                        } else {
                            $location.url(task.redirectUrl.from(1) + "?qpeId=" + dashboardId);
                        }
                    });
            } else {
                $location.url(task.redirectUrl.from(1) + "?qpeId=" + dashboardId);
            }
        } else {
            $location.url(task.redirectUrl.from(1));
        }
    };

    $scope.saveDashboard = function () {
        var dashboardToSave = angular.copy($scope.dashboard);
        dashboardToSave.reviewTasks.find({name: "Options & Settings"}).tasks.forEach(function (task) {
            if (task.entity === "Entity Option") {
                delete task.data.totalDifferent;

                task.data.EntityOptions.forEach(function (category) {
                    category.Options.forEach(function (item) {
                        delete item.helpText;
                    });
                });
            }
        });

        $http.put('/Reporting/ProcessManager/Dashboard/' + dashboardId, dashboardToSave, {trackerMsg: "Saving dashboard data"})
            .then(function (responses) {
                $scope.dashboard = responses.data;

                $scope.dashboard.reviewTasks.find({name: "Options & Settings"}).tasks.forEach(function (task) {
                    if (task.entity === "Entity Option") {
                        task.data.totalDifferent = 0;

                        task.data.EntityOptions.forEach(function (category) {
                            category.Options.forEach(function (item) {
                                if (helpText) {
                                    item.helpText = helpText[item.Name] || null
                                }
                                if (item.Current !== item.Previous) {
                                    ++task.data.totalDifferent
                                }
                            });
                        });
                    }
                });
            });
    };

    $scope.deleteDashboard = function () {
        $dialog.confirmAction("Are you sure you want to delete this dashboard?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete('/Reporting/ProcessManager/Dashboard/' + dashboardId, {trackerMsg: 'Deleting ' + $scope.dashboard.title})
                        .then(function () {
                            $location.path('/advisor/quarterend');
                        });
                }
            });
    };


    //INITIALIZE
    $scope.current = {
        canEditMode: ["Administrator", "Advisor"].any($scope.user.authorization.entity), //TODO: use entity level or create a privilege for this?
        isEditMode: false
    };
    $scope.userEntity = $scope.user.authorization.entity;
    $scope.rights = $oasRights.forCode("QPEDASHBOARD");

    init();
});


app.controller('AddLinkTaskCtrl', function AddLinkTaskCtrl($scope, dialog) {
    //PUBLIC METHODS
    $scope.submit = function () {
        var internalLink = $scope.internalLinks.find({type: $scope.task.type});
        if (internalLink) {
            $scope.task.redirectUrl = internalLink.url;
        }

        dialog.close($scope.task);
    };

    $scope.cancel = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.internalLinks = dialog.options.internalLinks;
    $scope.task = dialog.options.task ? Object.select(dialog.options.task, ["name", "type"]) : {name: '', type: $scope.internalLinks[0].type};

    if ($scope.task.type === "CustomLinkExternal") {
        $scope.task.redirectUrl = dialog.options.task.data.Data;
    }
});


app.controller('QedOptionReviewCtrl', function QedOptionReviewCtrl($scope, $dialog, dialog) {
    //PUBLIC METHODS
    $scope.showHelpText = function (option) {
        $dialog.messageBox(option.name, option.helpText).open();
    };

    $scope.prettifyOptionValue = function (rawText) {
        return rawText ? rawText.replace(/,/g, ', ') : rawText;
    };

    $scope.close = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.task = dialog.options.task;
});
'use strict';

var interfaceSetupProcessCtrl = app.controller('InterfaceSetupProcessCtrl', function InterfaceSetupProcessCtrl($scope, $q, $http, $routeParams, $location, $dialog, $dataQuery, $oasRights) {
    //PRIVATE VARIABLES
    var dashboardId = $routeParams.dashboardId;
    var actionTypes = [];
    var reportBatches;
    var helpText = [];

    var customLinkMap = [
        {type: "CustomLinkPortfolioAudit", name: "Portfolio Audit", url: "#/portfolio/households"},
        {type: "CustomLinkBillingAudit", name: "Billing Audit", url: "#/billing/audit/households"},
        {type: "CustomLinkProductsPrices", name: "Products & Prices", url: "#/products/myproducts/currentlyownedproducts"}
    ];


    //PRIVATE METHODS
    function init() {
        $http.get('/Reporting/Batch?qpeItemId=' + dashboardId, {trackerMsg: 'Loading report batches'})
            .then(function (response) {
                reportBatches = [{id: null, name: "Create New Batch"}].add(response.data);
            });

        $q.all({
            helpText: $http.get("advisor/QuarterEndProcessMgrHelpText.json"),
            dashboard: $http.get('/Reporting/ProcessManager/Dashboard/' + dashboardId, {trackerMsg: 'Loading interface setup dashboard'})
        })
            .then(function (responses) {
                $scope.dashboard = responses.dashboard.data;

                ($scope.dashboard.reviewTasks.find({name: "Options & Settings"}) || {tasks:[]}).tasks.forEach(function (task) {
                    if (task.entity === "Entity Option") {
                        helpText = responses.helpText.data[task.name];
                        task.data.totalDifferent = 0;

                        task.data.EntityOptions.forEach(function (category) {
                            category.Options.forEach(function (item) {
                                if (helpText) {
                                    item.helpText = helpText[item.Name] || null;
                                }
                                if (item.Current !== item.Previous) {
                                    ++task.data.totalDifferent;
                                }
                            });
                        });
                    }
                });

                getActionTypes($scope.dashboard.typeId);
            });
    }

    function getActionTypes(typeId) {
        $http.get("/Reporting/ProcessManager/ActionTypes?typeId=" + typeId, {cache: true, trackerMsg: 'Loading action types'})
            .then(function (response) {
                actionTypes = response.data;
            });
    }

    function addCustomTask(category, name, type, id, url) {
        var actionType = actionTypes.find({code: type});

        var customEntity = null;
        var dataValue = id;
        var lockdownOptionValue = "Prerequisite";
        if (!dataValue && type !== "CustomText") {
            if (type === "CustomLinkExternal") {
                dataValue = url;
            } else {
                dataValue = customLinkMap.find({type: type}).url;
                customEntity = type === "CustomLinkProductsPrices" ? "Product" : "Household";
            }
        } else if (dataValue === -1) {
            lockdownOptionValue = "NoEffect";
        }

        category.tasks.push({
            workflowActionId: 0,
            name: name,
            typeId: actionType.id,
            type: type,
            couldBeAlteredByUser: true,
            taskOffsetInDays: 0,
            lockdownOption: lockdownOptionValue,
            canSignOff: true,
            signedOffDate: null,
            entity: customEntity,
            data: {Data: dataValue},
            redirectUrl: url,
            actionSequence: category.tasks.length + 1,
            phaseSequence: category.tasks[0].phaseSequence
        });

        orderActionSequence(category);
    }

    function orderActionSequence(category) {
        var sequence = 0;
        category.tasks.forEach(function (task) {
            task.actionSequence = ++sequence;
        });
    }

    function runDataQuery(id) {
        $dialog.dataQueryPrompt(id)
            .open()
            .then(function (result) {
                if (result && result.id) {
                    $dataQuery.setDataQuery(result);
                    $location.path('/reports/dataqueries/' + result.id);
                }
            });
    }


    //PUBLIC METHODS
    $scope.runDashboardAudit = function () {
        runDataQuery(9821);  //9821 = Dashboard Sign Off Audit
    };

    $scope.reviewOptions = function (task) {
        $dialog.dialog({templateUrl: "qed-option-review.html", controller: "QedOptionReviewCtrl", dialogClass: "modal wide", task: task}).open();
    };

    $scope.runDataQuery = function (task) {
        runDataQuery(task.data.Data);
    };

    $scope.runReport = function (task) {
        $dialog.reportPrompt(task.data.Data).open();
    };

    $scope.addBasicTask = function (category) {
        $dialog.inputBox('Basic Task', 'Task Description', 'textarea')
            .open()
            .then(function (result) {
                if (result) {
                    addCustomTask(category, result, "CustomText");
                }
            });
    };

    $scope.addNoteTask = function (category) {
        $dialog.inputBox('Note', 'Description', 'textarea')
            .open()
            .then(function (result) {
                if (result) {
                    addCustomTask(category, result, "CustomText", -1);
                }
            });
    };

    $scope.addDataQueryTask = function (category) {
        $dialog.search("dataQuery", "Data Query Task")
            .open()
            .then(function (dataQuery) {
                if (dataQuery) {
                    addCustomTask(category, dataQuery.name, "CustomDataQuery", dataQuery.id);
                }
            });
    };

    $scope.addReportTask = function (category) {
        $dialog.search("report", "Report Task")
            .open()
            .then(function (report) {
                if (report) {
                    addCustomTask(category, report.name, "CustomReport", report.id);
                }
            });
    };

    $scope.addLinkTask = function (category) {
        $dialog.dialog({templateUrl: "add-link-task.html", controller: "AddLinkTaskCtrl", internalLinks: customLinkMap})
            .open()
            .then(function (result) {
                if (result) {
                    addCustomTask(category, result.name, result.type, null, result.redirectUrl);
                }
            });
    };

    $scope.editTask = function (task) {
        switch (task.type) {
            case "CustomText":
                var isBasicTask = task.lockdownOption === "Prerequisite";
                $dialog.inputBox(isBasicTask ? 'Basic Task' : 'Note', isBasicTask ? 'Task Description' : 'Description', 'textarea', {inputValue: task.name})
                    .open()
                    .then(function (result) {
                        if (result) {
                            task.name = result;
                        }
                    });
                break;
            case "CustomReport":
                $dialog.search("report", "Report Task")
                    .open()
                    .then(function (report) {
                        if (report) {
                            task.name = report.name;
                            task.data = {Data: report.id};
                        }
                    });
                break;
            case "CustomDataQuery":
                $dialog.search("dataQuery", "Data Query Task")
                    .open()
                    .then(function (dataQuery) {
                        if (dataQuery) {
                            task.name = dataQuery.name;
                            task.data = {Data: dataQuery.id};
                        }
                    });
                break;
            default:
                if (task.type.startsWith("CustomLink")) {
                    $dialog.dialog({templateUrl: "add-link-task.html", controller: "AddLinkTaskCtrl", internalLinks: customLinkMap, task: task})
                        .open()
                        .then(function (result) {
                            if (result) {
                                var actionType = actionTypes.find({code: result.type});
                                var dataValue = null;

                                if (result.type === "CustomLinkExternal") {
                                    dataValue = result.redirectUrl;
                                } else {
                                    dataValue = customLinkMap.find({type: result.type}).url;
                                }

                                task.name = result.name;
                                task.type = result.type;
                                task.typeId = actionType.id;
                                task.data = {Data: dataValue};
                            }
                        });
                }
        }
    };

    $scope.deleteTask = function (category, task) {
        category.tasks.remove(task);
    };

    $scope.moveTask = function (category, task, indexChange) {
        var index = category.tasks.indexOf(task),
            newPos = index + indexChange;

        category.tasks.splice(index, 1);
        category.tasks.splice(newPos, 0, task);

        orderActionSequence(category);
    };

    $scope.signOffTask = function (task) {
        return $http.put('/Reporting/ProcessManager/Dashboard/' + dashboardId + '/WorkflowAction/' + task.workflowActionId + '/Action/SignOff', null, {trackerMsg: "Saving dashboard data"})
            .then(function (response) {
                task.signedOffBy = response.data.signedOffBy;
                task.signedOffDate = response.data.signedOffDate;

                return task;
            });
    };

    $scope.revisitTask = function (task) {
        return $http.put('/Reporting/ProcessManager/Dashboard/' + dashboardId + '/WorkflowAction/' + task.workflowActionId + '/Action/SignOff/Revoke', null, {trackerMsg: "Saving dashboard data"})
            .then(function (response) {
                task.signedOffBy = response.data.signedOffBy;
                task.signedOffDate = response.data.signedOffDate;

                return task;
            });
    };

    $scope.reviewTasksPercentComplete = function () {
        if (!$scope.dashboard) return 0;

        var totalTasks = $scope.dashboard.reviewTasks.sum(function (category) {
            return category.tasks.count({lockdownOption: 'Prerequisite'});
        });

        return ((totalTasks - $scope.reviewTasksRemaining()) / totalTasks) * 100;
    };

    $scope.reviewTasksRemaining = function () {
        if (!$scope.dashboard) return 0;

        return $scope.dashboard.reviewTasks.sum(function (category) {
            return category.tasks.count({signedOffDate: null, lockdownOption: 'Prerequisite'});
        });
    };

    $scope.lockdownDashboard = function () {
        var title = 'Dashboard Lockdown';
        var msg = 'By clicking "Sign Off" you are confirming to Orion Advisors Services that all necessary audits and scrubs have been completed and no further adjustments are needed prior to the generation of billing and statements. '
                + 'You will have the ability to lockdown your database by proceeding to the Billing Wizard after signing off. We highly recommend locking down the database so that other users are limited in making changes that can affect bills and statements.<br/>'
                + 'Please note this signoff cannot be undone.';
        var buttons = [{result: 'yes', label: 'Sign Off', cssClass: 'btn-primary'}, {result: 'no', label: 'Cancel'}];

        $dialog.messageBox(title, msg, buttons)
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.put('/Reporting/ProcessManager/Dashboard/' + dashboardId + '/Action/Lockdown', null, {trackerMsg: "Locking down dashboard"})
                        .then(function (response) {
                            $scope.dashboard.isLockedDown = true;
                            $scope.dashboard.signedOffBy = response.data.signedOffBy;
                            $scope.dashboard.signedOffDate = response.data.signedOffDate;
                        });
                }
            });
    };

    $scope.launchProcessTask = function (task) {
        if (task.signedOffDate) {
            $scope.revisitTask(task)
                .then(function (task) {
                    $scope.signOffTask(task);
                });
        } else {
            $scope.signOffTask(task);
        }

        if (task.type === "ProcessStatementBatchWizard") {
            if (reportBatches.length > 1) {
                $dialog.inputBox("Report Batches", "Select Batch", reportBatches, {inputValue: reportBatches[0]})
                    .open()
                    .then(function (result) {
                        if (!result) return;

                        if (result.id) {
                            $location.url("/reports/batches/entities?batchId=" + result.id);
                        } else {
                            $location.url(task.redirectUrl.from(1) + "?qpeId=" + dashboardId);
                        }
                    });
            } else {
                $location.url(task.redirectUrl.from(1) + "?qpeId=" + dashboardId);
            }
        } else {
            $location.url(task.redirectUrl.from(1));
        }
    };

    $scope.saveDashboard = function () {
        var dashboardToSave = angular.copy($scope.dashboard);
        (dashboardToSave.reviewTasks.find({name: "Options & Settings"}) || {tasks:[]}).tasks.forEach(function (task) {
            if (task.entity === "Entity Option") {
                delete task.data.totalDifferent;

                task.data.EntityOptions.forEach(function (category) {
                    category.Options.forEach(function (item) {
                        delete item.helpText;
                    });
                });
            }
        });

        $http.put('/Reporting/ProcessManager/Dashboard/' + dashboardId, dashboardToSave, {trackerMsg: "Saving dashboard data"})
            .then(function (responses) {
                $scope.dashboard = responses.data;

                ($scope.dashboard.reviewTasks.find({name: "Options & Settings"}) || {tasks:[]}).tasks.forEach(function (task) {
                    if (task.entity === "Entity Option") {
                        task.data.totalDifferent = 0;

                        task.data.EntityOptions.forEach(function (category) {
                            category.Options.forEach(function (item) {
                                if (helpText) {
                                    item.helpText = helpText[item.Name] || null
                                }
                                if (item.Current !== item.Previous) {
                                    ++task.data.totalDifferent
                                }
                            });
                        });
                    }
                });
            });
    };

    $scope.deleteDashboard = function () {
        $dialog.confirmAction("Are you sure you want to delete this dashboard?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete('/Reporting/ProcessManager/Dashboard/' + dashboardId, {trackerMsg: 'Deleting ' + $scope.dashboard.title})
                        .then(function () {
                            $location.path('/advisor/quarterend');
                        });
                }
            });
    };


    //INITIALIZE
    $scope.current = {
        canEditMode: ["Administrator", "Advisor"].any($scope.user.authorization.entity), //TODO: use entity level or create a privilege for this?
        isEditMode: false
    };

    $scope.rights = $oasRights.forCode("QPEDASHBOARD");

    init();
});


app.controller('AddLinkTaskCtrl', function AddLinkTaskCtrl($scope, dialog) {
    //PUBLIC METHODS
    $scope.submit = function () {
        var internalLink = $scope.internalLinks.find({type: $scope.task.type});
        if (internalLink) {
            $scope.task.redirectUrl = internalLink.url;
        }

        dialog.close($scope.task);
    };

    $scope.cancel = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.internalLinks = dialog.options.internalLinks;
    $scope.task = dialog.options.task ? Object.select(dialog.options.task, ["name", "type"]) : {name: '', type: $scope.internalLinks[0].type};

    if ($scope.task.type === "CustomLinkExternal") {
        $scope.task.redirectUrl = dialog.options.task.data.Data;
    }
});

interfaceSetupProcessCtrl.getInterfaceSetupProcessListConfig = ["$dialog", "$location", function( $dialog, $location ) {
    var newSetup = function () {
        $dialog.dialog({templateUrl: "advisor/modals/new-interface-setup.html", controller: "NewInterfaceSetupCtrl"})
            .open()
            .then(function (result) {
                if (result) {
                    $location.path("/advisor/interfacesetup/" + result.id);
                }
            });
    };

    return {
        getUrl: '/Reporting/ProcessManager/Dashboard?workflowTypeId=18',
        listName: 'Dashboards',
        template: 'advisor/views/interface-list-item.html',
        icon: 'fa fa-users',
        defaultSortItem: 'targetDate',
        defaultSortDirection: 'DESC',
        nameProperty: 'friendlyName',
        selectEnabled: true,
        multiSelectEnabled: false,
        sortFields: {completedPercent: "percent complete", friendlyName: "name", id: "id", title: "title", signedOffBy: "signed off by", startDate: "start date", targetDate: "target date"},
        //listFilter: function(item, value) {return (item.name && item.name.toLowerCase().indexOf(value) !== -1) || (item.fundName && item.fundName.toLowerCase().indexOf(value) !== -1);}
        listFilter: ['startDate', 'targetDate', 'signedOffBy', 'id', 'completedPercent', 'friendlyName'],
        additionalLinks: [{name: "New Interface Setup", url: "", clickEvent:newSetup, icon: "fa fa-leaf"}]
    };
}];

app.controller('QedOptionReviewCtrl', function QedOptionReviewCtrl($scope, $dialog, dialog) {
    //PUBLIC METHODS
    $scope.showHelpText = function (option) {
        $dialog.messageBox(option.name, option.helpText).open();
    };

    $scope.prettifyOptionValue = function (rawText) {
        const json = isJsonObject(rawText);

        if (json.isJson) {
            return prettifyObjectTree(json.data);
        }

        return rawText ? rawText.replace(/,/g, ', ') : rawText;
    };

    function isJsonObject(str) {
      let obj;
      try {
          obj = JSON.parse(str);
      } catch (e) {
          return {isJson: false};
      }
      return {isJson: typeof(obj) === 'object', data: obj};
    };

    function prettifyObjectTree(data) {
        if (typeof(data) === 'object' && data !== null) {
            let newValue = '';
            const props = Object.keys(data);

            if (props.length > 0) {
                newValue += '<ul class="content-clean-list">';
                props.forEach(i => {
                    newValue += '<li>' + camelCaseToWords(i) + ': ';
                    newValue += prettifyObjectTree(data[i]);
                    newValue += '</li>';
                });
                newValue += '</ul>';
            }

            return newValue;
        }

        return data !== null ? data : '';
    };

    function camelCaseToWords(s) {
        const result = s.replace(/([A-Z])/g, ' $1');
        return result.charAt(0).toUpperCase() + result.slice(1);
    };

    $scope.close = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.task = dialog.options.task;
});
app.controller('NewInterfaceSetupCtrl', function NewInterfaceSetupCtrl($scope, $http, dialog) {
    //PRIVATE METHODS
    function init() {
        $http.get('/Reporting/ProcessManager/Types', {cache: true})
            .then(function (response) {
                $scope.current.types = response.data;
            });
    }


    //PUBLIC METHODS
    $scope.submit = function () {
        $http.post("/Reporting/ProcessManager/Dashboard", $scope.current.item, {trackerMsg: 'Creating new setup'})
            .then(function (response) {
                dialog.close(response.data);
            });
    };

    $scope.cancel = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.current = {
        types: null,
        item: {}
    };

    init();
});
'use strict';

app.controller('ImplementationDashboardCtrl', function ImplementationDashboardCtrl( $scope, $http, $oasRights, $dialog ) {

    // PRIVATE VARIABLES
    var signOff = false;


    // PRIVATE METHODS
    function init( ) {
        $http.get('/Reporting/Implementation', {trackerMsg: 'Loading implementation dashboard' })
            .then(function (response) {
                if( response && response.data ) {
                    $scope.implementationPlan = response.data;
                    $scope.current.initiallySignedOff = $scope.implementationPlan.signedOffBy;
                    setPercentComplete( true );
                }
            });
    }

    function setPercentComplete( setTargetDate ) {
        if( $scope.implementationPlan && $scope.implementationPlan.implementationSteps && $scope.implementationPlan.implementationSteps.length > 0 ) {
            var completedSteps = 0;
            $scope.implementationPlan.implementationSteps.each( function( s ) {
                if( setTargetDate ) {
                    var startDate = new Date( $scope.implementationPlan.startDate );
                    s.targetDate = startDate.addDays( s.offsetDays );
                }

                if( s.completedDate != null ) {
                    completedSteps += 1;
                } else {
                    if( Date.create(s.targetDate).isBefore( 'today' ) ) {
                        s.isLate = true;
                    }
                }
            });
            $scope.current.percentComplete = parseInt( (completedSteps / $scope.implementationPlan.implementationSteps.length) * 100);
        }
    }


    // PUBLIC METHODS
    $scope.createNew = function( ) {
        $dialog.confirmAction( "Are you sure you want to create a new implementation dashboard?" )
            .open()
            .then( function( result ) {
                if( result == 'yes' ) {
                    $dialog.inputBox('New Implementation Dashboard', "As Of", 'date')
                        .open()
                        .then(function(rslt) {
                            if( rslt ) {
                                $http.post("/Reporting/Implementation/GenerateNew?asOfDate=" + Date.create(rslt).format('{yyyy}-{MM}-{dd}'), {}, {trackerMsg: 'Creating implementation dashboard'})
                                    .then(function( response ) {
                                        $scope.implementationPlan = response.data;
                                        setPercentComplete( true );
                                    });
                            }
                    } );
                }
            } );
    };

    $scope.save = function( ) {
        $http.put("/Reporting/Implementation/" + $scope.implementationPlan.id + "?signOff=" + signOff, $scope.implementationPlan, {trackerMsg: 'Saving implementation dashboard'})
            .then(function ( ) {
                if( signOff ) {
                    $scope.current.initiallySignedOff = $scope.implementationPlan.signedOffBy;
                }
                $dialog.saveSuccessful( "Implementation dashboard saved.").open();
            });
    };

    $scope.editStep = function (step, isTitle) {
        var valueToEdit;
        var modalText;
        if( isTitle ) {
            valueToEdit = step.title;
            modalText = "Title";
        } else {
            valueToEdit = step.description;
            modalText = "Description";
        }

        $dialog.inputBox('Edit ' + modalText, modalText, "textarea", {inputValue: valueToEdit})
            .open()
            .then(function (rslt) {
                if (rslt) {
                    step[isTitle ? "title" : "description"] = rslt;
                }
            }
        );
    };

    $scope.editDate = function(step) {
        $dialog.inputBox("Edit Due Date", "Due", "date", {inputValue: step.targetDate})
            .open()
            .then(function (rslt) {
                if (rslt) {
                    step.offsetDays += step.targetDate.daysUntil(new Date(rslt));
                    step.targetDate = null;
                    step.completedDate = null;
                    step.isLate = false;
                    setPercentComplete(true);
                }
            });
    };

    $scope.signOff = function( ) {
        $scope.implementationPlan.signedOffDate = Date.create('today');
        $scope.implementationPlan.signedOffBy =  $scope.user.authorization.loginUserId.substring( 0, 50 );
        signOff = true;
    };

    $scope.markComplete = function( step, markComplete ) {
        if( markComplete ) {
            step.completedDate = Date.create('today');
        }
        else {
            step.completedDate = null;
        }
        setPercentComplete( false );
    };


    // INITIALIZE
    $scope.rightsApp = $oasRights.forCode("IMPLEMENTATIONAPP");
    $scope.current = { percentComplete : 0, hideCompleted : false, initiallySignedOff: false };

    init( );
});
'use strict';

app.controller('GoalListCtrl', function GoalListCtrl($scope, $http, $dialog, $oasRights) {
    //PRIVATE METHODS
    function init() {
        $scope.rightsGoal = $oasRights.forCode('TRENDS');
        $http.get('/Portfolio/Goals', {trackerMsg: 'Loading goals'})
            .then(function (response) {
                $scope.goals = response.data;
            });
    };

    function openEditor (goal) {

        $dialog.dialog({templateUrl: "goal-edit.html", controller: 'GoalEditCtrl', goal: goal ? angular.copy(goal) : null})
            .open()
            .then(function (result) {
                if (!result) return;

                if (goal) {
                    angular.merge(goal, result);
                } else {
                    var existing = $scope.goals.find( function (item){
                       return item.name === result.name && item.startDate === result.startDate && item.endDate === result.endDate;
                    });
                    if ( existing){
                        result.id = existing.id;
                        angular.merge( existing, result);
                    }else{
                        $scope.goals.push( result);
                    }
                }
            });
    };


    //PUBLIC METHODS
    $scope.addGoal = function () {
        openEditor();
    };

    $scope.editGoal = function (goal) {
        openEditor(goal);
    };

    $scope.deleteGoal = function (goal) {
        $dialog.confirmAction("Are you sure you want to remove goal <b>" + goal.name + "</b>?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete('/Portfolio/Goals/' + goal.id, {

                        trackerMsg: 'Deleting goal ' + goal.name
                    })
                        .then(function () {
                            $scope.goals.remove({id: goal.id});
                        });
                }
            });
    };
    //INITIALIZE
    init();
});

app.controller('GoalEditCtrl', function GoalEditCtrl($scope, $http, dialog, $dialog) {
    //PRIVATE METHODS
    function init() {
        $http.get('/Portfolio/Goals/Types', {cache: true, trackerMsg: 'Loading goal types'})
            .then(function (response) {
                $scope.goalTypes = response.data;
            });
    };

    function getDefaultDateRange(){
        var today = new Date();
        var startDate = new Date(today.getFullYear(), today.getMonth() , 1);
        var endDate =  new Date( startDate.getFullYear(), startDate.getMonth() + 1, 0);
        var dateRange  = { "startDate": startDate, "endDate": endDate};

        if ( $scope.goal.id > 0){
            dateRange.startDate = $scope.goal.startDate;
            dateRange.endDate = $scope.goal.endDate;
        }else{
            $scope.goal.startDate = startDate;
            $scope.goal.endDate = endDate;
        }
        return dateRange;
    }

    //PUBLIC METHODS
    $scope.onStartDateChange = function () {
        if ($scope.goal.startDate.getDate() !== 1) {
            $scope.goal.startDate = originalDateRange.startDate;
            $dialog.actionFailed("Invalid start date. Must be first day of the month. Example : 01/01/2018").open();
            return;
        };
        $scope.goal.endDate = new Date($scope.goal.startDate.getFullYear(), $scope.goal.startDate.getMonth() + 1, 0);
    };

    $scope.cancel = function(){
        dialog.close();
    };
    $scope.isValidGoalName = function(){
        if ( $scope.goal.name === ""){
            return false;
        };
        return true;
    };

    $scope.submit = function () {
        var args = $scope.goal.id > 0 ? {method: "PUT", id: $scope.goal.id, trackerMsg: "Saving goal " + $scope.goal.name} : {
            method: "POST",
            id: "",
            trackerMsg: "Adding new goal"
        };

        $scope.goal.timeFrame = "Monthly";
        $http({
            method: args.method,
            url: '/Portfolio/Goals/' + args.id,
            data: $scope.goal,

            trackerMsg: args.trackerMsg
        })
            .then(function (response) {
                dialog.close(response.data);
            });
    };

    $scope.cancel = function () {
        dialog.close();
    };

    //INITIALIZE
    $scope.goal = dialog.options.goal || {  "id": 0, "name": "", "startDate" : null, "endDate" : null, "timeFrame":"Monthly" };
    var originalDateRange = getDefaultDateRange();

    init();
});
'use strict';

var RMDDashboardCtrl = app.controller('RMDDashboardCtrl', function RMDDashboardCtrl($scope,  $http, $oasRights, $dialog, $routeParams, views, $portfolio, apps, entities, $rebalance, $proratedCashTrades, rmdMailMergeData, rmdMailMergeTemplateData, $location) {

    // PRIVATE VARIABLES
    var registrationId = 0;
    var representativeId = 0;


    // PRIVATE METHODS
    function init( ) {

        getRMDDisclaimerText();

        $scope.mergeLetters = rmdMailMergeData.files;
        $scope.mergeLettersTemplate = rmdMailMergeTemplateData.files;
        isLaserAppConfigured()
            .then(function(canLoad){
                $scope.current.loadLaserApp = canLoad;
            });

        updateRmdHeader(false);

        tryAutoLaunchEditor(); 
    }

    function getRMDDisclaimerText() {
        $http.get('/Settings/Database/EntityOptions/Code/69RMDDISCL', {trackerMsg:'Getting RMD Disclaimer text'})
            .then(function (response) {
                $scope.rmdAlert = response.data.value;
            });
    }

    function tryAutoLaunchEditor(){

        var editor = $location.search().editor;
        registrationId = $location.search().registrationId;
        $scope.current.accountId = $location.search().accountId;

        switch(editor)
        {
            case "registration" :
                if($scope.rightsReg.canRead){
                     $portfolio.openEditor(entities.registration.value, [registrationId], 'Registration', 'registrationGeneral', apps.rmd.name, null)
                    .then(function (rslt) {
                        if (rslt) {
                            $scope.$broadcast( 'event:rmd-calculation-action', {action: 'update-item', item: rslt } );
                        }
                    });
                }
                break;
            case "account" :
                if($scope.rightsAcc.canRead){
                    $scope.selectedIds.push($scope.current.accountId);
                    $portfolio.openEditor(entities.account.value, $scope.selectedIds, 'Accounts', 'accountGeneral', apps.rmd.name, null)
                    .then(function (rslt) {
                        if (rslt) {
                            $scope.$broadcast( 'event:rmd-calculation-action', {action: 'update-item', item: rslt } );
                        }
                    });
                    
                }
                break;          
        }     
    }

    function updateRmdHeader(performReset){
        $http.get('/Portfolio/Accounts/RMDCalculationCounts?resetCache=' + performReset, {trackerMsg: 'Getting RMD Dashboard Counts'})
            .then(function (response) {
                $scope.current.rmdDashboardHeader = response.data;
            })
    }


    function isLaserAppConfigured() {
        return $http.get('/Integrations/LaserApp/Configuration/Test', {trackerMsg: 'Check for LaserApp integration', ignoreExceptions: true})
            .then(function(result){
                return (result.status >= 200 || result.status <= 299);
            });
    }

    $scope.removeRmdAlert = function (alert) {
        $scope.rmdAlert = null;
    };

    $scope.openEditor = function(entity){
        if( entity === entities.account.value ) {
            $portfolio.openEditor( entity, $scope.selectedIds, null, null, apps.rmd.name, null ).then(function(rslt) {
                if( rslt ) {
                   $scope.$broadcast( 'event:rmd-calculation-action', {action: 'update-item', item: rslt } );
                }
            });
        } else if( entity === entities.registration.value ) {
            var extraInfo = null;

            extraInfo = {
                fkAccount : $scope.current.accountId
            };

            $portfolio.openEditor( entity, [registrationId], null, null, apps.rmd.name, extraInfo ).then(function(rslt) {
                if( rslt ) {
                    $scope.$broadcast( 'event:rmd-calculation-action', {action: 'update-item', item: rslt } );
                }
            });
        } else if( entity === entities.transaction.value ) {
            $portfolio.goTo('transactions', entities.account.value, $scope.selectedIds[0]);
        }
    };

    $scope.openLaserAppForms = function() {
        $dialog.dialog({templateUrl: "app/modals/laserapp.html", controller: "LaserAppCtrl", resolve: {args:function(){ return { accountId: $scope.selectedIds[0], formType: 2 }; }}}).open();
    };

    $scope.openRebalance = function() {
        $rebalance.start(6, [$scope.selectedIds[0]], $scope.current.rmdAmount);
    };

    $scope.openProratedCashTrade = function() {
        $proratedCashTrades.start([$scope.selectedIds[0]],$scope.current.rmdAmount);
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:rmd-calculation-action', {action: 'export-data'});
    };

    $scope.search = function( ) {
        $portfolio.search(entities.account.value)
            .then(function(rslt) {
                if (!rslt) return;

                var entity = entities.find({value: rslt.entity});
                $scope.current.view.filters.length = 0;
                $scope.current.view.filters.push({ name: entities[entity].name + " ID = " + rslt.item.id, value: "(function (a) { return a === " + rslt.item.id + "; })", key: entity + "Id", include: true });
            });
    };

    $scope.openRMDReport = function(){
        $http.get('/Reporting/Reports', {cache: true, trackerMsg: 'Loading reports'})
            .then(function (response) {
                $scope.current.rmdReport = response.data.find({reportName: 'Required Minimum Distribution For Rep'});

                var reportArgs = {EntityEnum: parseInt(entities.representative.value).toString(), PkEntity: representativeId};
                $dialog.reportPrompt($scope.current.rmdReport.id, reportArgs).open();

            });
    };

    $scope.generateLetter = function(letterId){
        var letter = $scope.mergeLetters.list.find({id: letterId});

        if (letter === undefined){
            letter = $scope.mergeLettersTemplate.list.find({id: letterId});
        }

        if (letter){
            $http.post('/Portfolio/Accounts/RMDCalculation/Actions/MailMerge', {FileId : letter.id, AccountIds : $scope.current.accountList})
                .then(function(response){
                    window.location.href = response.headers("location") + (response.headers("location").indexOf("?") !== -1 ? "&" : "?") + "Authorization=" + sessionStorage.oas_token;
            });
        }

    };

    $scope.editYearEndValue = function(){

        $http.get('/Portfolio/Accounts/' + $scope.current.accountId + '/RMDCalculation', {trackerMsg: 'Loading account'})
            .then(function(response){


                var dialogOpts = {
                    templateUrl : "rmd-yearend-value.html",
                    controller : "RMDYearEndValueCtrl",
                    rmdData : response.data
                };

                var d = $dialog.dialog(dialogOpts);
                d.open()
                    .then(function(rslt){
                        if (rslt){
                            $scope.$broadcast(  'event:rmd-calculation-action', {action: 'update-item', item: rslt } );
                        }
                    });
            });
    };

    $scope.editRmdIsSatisfied = function(){
        $http.get('/Portfolio/Accounts/' + $scope.current.accountId + '/RMDCalculation', {trackerMsg: 'Loading account'})
                .then(function(response){

                    var dialogOpts = {
                        templateUrl : "rmd-is-satisfied.html",
                        controller : "RMDIsSatisfiedCtrl",
                        rmdData : response.data
                    };

                    var d = $dialog.dialog(dialogOpts);
                    d.open()
                            .then(function(rslt){
                                if (rslt){
                                    $scope.$broadcast(  'event:rmd-calculation-action', {action: 'update-item', item: rslt } );
                                    updateRmdHeader(true);
                                }
                            });
                });
    };

    $scope.recalc = function() {
        $http.post('/Portfolio/Accounts/RMDCalculation/Actions/Recalc', $scope.current.accountList)
                .then(function(response){
                    var results = response.data;
                    var isError = results.any(function(n){ return n.isError; });
                    if(results && !isError) {
                        //$scope.$broadcast( 'event:rmd-calculation-action', {action: 'update-items', items: results.map(function(o){return o.accountId; }) } );
                        $scope.$broadcast( 'event:rmd-calculation-action', {action: 'refresh-grid'});
                    }
                    else {
                        var msg = '';
                        results.forEach(function(item){
                            msg += '<div><strong>Account {accountId}</strong>: {errorMessage}</div>'.assign(item);
                        });
                        $dialog.messageBox("<i class='fa fa-exclamation-circle fa-lg text-error' aria-hidden='true'></i> Recalculate Error", msg).open();
                    }
                })
    };

    $scope.rmdCalcUpdate = function () {
        $dialog.confirmAction('RMD Calculation Update - this will start an update process for all accounts.  Do you wish to continue?')
            .open()
            .then(function (action) {
                if(action === 'yes'){
                    var dialogOpts = {
                        templateUrl : "rmd-calculation-update.html",
                        controller : "RMDCalculationUpdateCtrl"
                    };
                    var d = $dialog.dialog(dialogOpts);
                    d.open()
                        .then(function(rslt) {
                            if (rslt.isSuccess) {
                                $scope.$broadcast('event:rmd-calculation-action', {action: 'refresh-grid'});
                            }else{
                                $dialog.actionFailed('RMD update failed.' + '<br>' + rslt.msg).open();
                            }
                        });
                }
            })

    };

    //EVENT LISTENERS
    $scope.$on("event:rmd-calculation-select", function(e, args){
        if (args.length === 0) return;
        $scope.current.rmdAmount = args[0].rmdRemaining;
        $scope.current.accountId = args[0].accountId;
        representativeId = args.map('representativeId').unique()[0];
        registrationId = args.map('registrationId').unique()[0];
        $scope.current.accountList = args.map(function(a){ return a.accountId});
        $scope.current.recalc = args[0].recalc ? args[0].recalc : false;
    });


    //INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {
        view: views[0],
        URL : '/Portfolio/Accounts/RMDCalculation' ,
        status: $routeParams.status,
        rmdAmount : 0,
        rmdData : 0,
        accountId : 0,
        accountList : [],
        loadLaserApp: false,
        recalc: false,
        isAdmin: $scope.user.authorization.entity === entities.administrator.name || $scope.user.authorization.entity === entities.ria.name,
        rmdDashboardHeader:null
    };

    $scope.rightsRMDDashboard = $oasRights.forCode("RMDDASHBOARDAPP");
    $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
    $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
    $scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");
    $scope.rightsTrade = $oasRights.forCode("TRADEORDERMGMT");

    init( );


});

app.controller ('RMDYearEndValueCtrl', function RMDYearEndValueCtrl( $scope, $http, $oasRights, dialog ){
    // PUBLIC METHODS
    $scope.cancel = function( ) {
        dialog.close( null );
    };

    $scope.close = function( ) {

        var update = $scope.current.rmdData.yearOverrides.find({year: (new Date()).getFullYear() - 1});
        update = $scope.yearOverrides;


        $http.put('/Portfolio/Accounts/' + $scope.current.rmdData.accountId + '/RMDCalculation?returnstyle=standard', $scope.current.rmdData, {trackerMsg: 'Updating year-end value'})
            .then(function (response) {
                dialog.close(response.data);
            });
    };

    $scope.removeOverrideAmount = function( ) {
        $scope.yearOverrides.value = null;

        var update = $scope.current.rmdData.yearOverrides.find({year: (new Date()).getFullYear() - 1});
        update = $scope.yearOverrides;

        $http.put('/Portfolio/Accounts/' + $scope.current.rmdData.accountId + '/RMDCalculation?returnstyle=standard', $scope.current.rmdData, {trackerMsg: 'Updating year-end value'})
            .then(function (response) {
                dialog.close(response.data);
            });
    };

    var init = function(){
        var yearOverrides = $scope.current.rmdData.yearOverrides.find({year: (new Date()).getFullYear() - 1});

        if (!yearOverrides){
            $scope.yearOverrides=  {
                isSatisfied: null,
                value: null,
                year: new Date().getFullYear() - 1
            };
            $scope.current.rmdData.yearOverrides.add($scope.yearOverrides);
        }
        else {
            $scope.yearOverrides = yearOverrides;
            $scope.current.auditData = yearOverrides;
        }

    };


    // INITIALIZE
    $scope.current = {
        rmdData : dialog.options.rmdData,
        endOfPreviousYearAccountValueIsCalculated : dialog.options.rmdData.endOfPreviousYearAccountValueIsCalculated,
        originalAmount : dialog.options.rmdData.calculatedEndOfPreviousYearAccountValue,
        overrideAmount : dialog.options.rmdData.endOfPreviousYearAccountValueIsCalculated ? 0 : dialog.options.rmdData.endOfPreviousYearAccountValue,
        auditData : []
    };

    $scope.rightsRMD = $oasRights.forCode( "RMDDASHBOARDAPP" );

    init();
});

app.controller ('RMDIsSatisfiedCtrl', function RMDIsSatisfiedCtrl( $scope, $http, $oasRights, dialog ){
    // PUBLIC METHODS
    $scope.cancel = function( ) {
        dialog.close( null );
    };

    $scope.close = function( ) {

        if ($scope.yearOverrides.isSatisfied === false)
            $scope.yearOverrides.isSatisfied = null;

        var update = $scope.current.rmdData.yearOverrides.find({year: (new Date()).getFullYear()});

        update = $scope.yearOverrides;

        $http.put('/Portfolio/Accounts/' + $scope.current.rmdData.accountId + '/RmdCalculation?returnstyle=standard' , $scope.current.rmdData, {trackerMsg: 'Updating RMD Is Satisfied'})
                .then(function (response) {
                    dialog.close(response.data);
                });
    };


    var init = function(){
        var yearOverrides = $scope.current.rmdData.yearOverrides.find({year: (new Date()).getFullYear()});

        if (!yearOverrides){
            $scope.yearOverrides=  {
                isSatisfied: null,
                value: null,
                year: new Date().getFullYear()
            };
            $scope.current.rmdData.yearOverrides.add($scope.yearOverrides);
        }
        else {
            $scope.yearOverrides = yearOverrides;
            $scope.current.auditData = yearOverrides;
        }

    };

    // INITIALIZE
    $scope.current = {
        rmdData : dialog.options.rmdData,
        auditData : {}
    };

    $scope.c = [];

    $scope.rightsRMD = $oasRights.forCode( "RMDDASHBOARDAPP" );

    init();
});

app.controller('RMDCalculationUpdateCtrl', function RMDCalculationUpdateCtrl($scope, $http, $timeout, dialog){

    function init(){
        startUpdate();
    }

    function startUpdate(){
        $http.get('/Portfolio/Accounts/RmdCalculation/Update', {trackerMsg:'Please wait... Updating RMD Accounts'})
            .then(function(response) {
                $scope.close(true, response.statusText)
            }, function(response) {
                $scope.close(false, response.statusText)
            });
    }
    $scope.close = function( successful, message){
        var response = {isSuccess: successful, msg: message};
        dialog.close(response);
    };

    init()
});

'use strict'

app.controller ('InflationRatesCtrl', function InflationRatesCtrl( $scope, $http, $oasRights, $dialog ) {
    //PRIVATE METHODS
    function init() {
        $http.get('/Theoretical/InflationRates', {trackerMsg: 'Loading inflation rates' })
            .then(function (response) {
                if( response.data ) {
                    $scope.current.inflationRates = response.data;
                }
            });
    }

    //PUBLIC METHODS
    $scope.openInflationRateEditor = function(inflationRate){
        var dialogOpts = {
            templateUrl: "inflationRateEditor.html",
            controller: "InflationRateEditCtrl",
            inflationRate: (inflationRate === 'new') ? null : inflationRate
        };
        $dialog.dialog(dialogOpts)
            .open()
            .then(function(rslt){
                if(rslt) {
                    rslt.asOfDate = angular.isString(rslt.asOfDate) ? rslt.asOfDate : rslt.asOfDate.format('{yyyy}-{MM}-{dd}');
                    rslt.annualInflationRate /= 100;
                    if($scope.current.inflationRates.some({asOfDate: rslt.asOfDate}) && inflationRate === 'new') {
                        $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Data", 'All inflation rates must have a different as of date.').open();
                    } else {
                        var args = (inflationRate === 'new') ? {method: "POST", id: "", trackerMsg: "Adding new inflation rate"} : {method: "PUT", id: inflationRate.asOfDate, trackerMsg: "Saving inflation rate " + inflationRate.asOfDate};

                        $http( { method: args.method, url: '/Theoretical/InflationRates/' + args.id, data: rslt, trackerMsg: args.trackerMsg } )
                            .then(function(response) {
                                if(response.data) {
                                    var inflationRate = response.data;
                                    if($scope.current.inflationRates.some({asOfDate: inflationRate.asOfDate})) {
                                        $scope.current.inflationRates.find({asOfDate: inflationRate.asOfDate}).annualInflationRate = inflationRate.annualInflationRate;
                                    }
                                    else {
                                        $scope.current.inflationRates.add(inflationRate);
                                    }
                                }
                            });
                    }
                }
            });
    };

    $scope.deleteInflationRate = function(inflationRate) {
        $dialog.confirmAction("Are you sure you want to remove the inflation rate for " + inflationRate.asOfDate + "?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete('/Theoretical/InflationRates/' + inflationRate.asOfDate, {trackerMsg: 'Removing inflation rate ' + inflationRate.asOfDate })
                        .then(function () {
                            $scope.current.inflationRates.remove({asOfDate: inflationRate.asOfDate});
                        });
                }
            });
    };


    //INITIALIZE
    $scope.rightsApp = $oasRights.forCode("INFLATIONRATES");
    $scope.current = { inflationRates: [] };

    init();
});

app.controller('InflationRateEditCtrl', function InflationRateEditCtrl( $scope, $dialog, dialog ){
    //PUBLIC METHODS
    $scope.submit = function() {
        dialog.close($scope.inflationRate);
    };

    $scope.cancel = function() {
        dialog.close(null);
    };

    //INITIALIZE
    $scope.current = { isNew: dialog.options.inflationRate === null };
    $scope.inflationRate = { asOfDate: $scope.current.isNew ? Date.create() : dialog.options.inflationRate.asOfDate, annualInflationRate: $scope.current.isNew ? 0.00 : dialog.options.inflationRate.annualInflationRate * 100 };
});
'use strict';

app.controller( 'BrokerDealerEditCtrl', function BrokerDealerEditCtrl( API_CONFIG, $scope, $http, $oasRights, $dialog, $portfolio, $timeout, dialog, args, entities, statementDeliveryMethod, additionalAnnualAmtType, apps, $q, bdStatus, clearingFirm, howIsAdvRegistered ) {

    // PRIVATE VARIABLES
    var brokerDealerGeneralOriginal = null;
    var brokerDealerNotesOriginal = null;
    var brokerDealerDocumentsOriginal = null;
    var additionalContactsOriginal = null;
    var brokerDealerReportImageOriginal = null;
    var brokerDealerRevenueShareOriginal = null;
    var brokerDealerBusinessLineOriginal = null;
    var brokerDealerAccountTypeOriginal = null;
    var brokerDealerRepresentativeOriginal = null;
    var customFieldsOriginal = null;
    var entityOptionsOriginal = null;
    var brokerdealerID = null;

    var editorHotKeys;


    // PRIVATE METHODS - INIT
    function init() {
        loadRights();
        buildMenu();
        loadHotKeys();
        $scope.loadTab( args.defaultTab );
        brokerdealerID = args.ids[0];
    }

    function loadRights() {
        $scope.rightsBD = $oasRights.forCode( "BROKERDEALERS" );
        $scope.rightsNotes = $oasRights.forCode( "NOTES" );
        $scope.rightsDocuments = $oasRights.forCode( "DOCUMENTS" );
        $scope.rightsEOs = $oasRights.forCode( "ENTITYOPTION" );
        $scope.rightsSSNView = $oasRights.forCode( "SSNVIEW" );
        $scope.rightsSSNChange = $oasRights.forCode( "SSNCHANGE" );
        $scope.rightsOpsMaintenance = $oasRights.forCode('ORIONENTERPRISEMAINTENANCE');
        $scope.rightsRS = $oasRights.forCode('BROKERDEALERREVENUESHARES');
    }

    function buildMenu() {
        var i = 0;
        $scope.menu = { categories: [ ] };

        $scope.menu.categories.push( {name: 'Broker/Dealer', children: [] } );

        $scope.menu.categories[i].children.push( {name: 'General', active: false, code: 'brokerdealerGeneral', show: true} );

        $scope.menu.categories[i].children.push( {name: 'Additional Contacts', active: false, code: 'additionalContacts', show: true} );

        $scope.menu.categories[i].children.push( {name: 'Adv/Payee', active: false, code: 'advPayee', show: true} );

        $scope.menu.categories[i].children.push( {name: 'Image', active: false, code: 'reportImage', show: true} );

        if( $scope.rightsNotes.canRead || $scope.rightsDocuments.canRead ) {
            $scope.menu.categories[i].children.push( {name: 'Notes & Documents', active: false, code: 'notesAndDocuments', show: true} );
        }

        $scope.menu.categories[i].children.push( {name: 'Revenue Share', active: false, code: 'revenueShare', show: $scope.rightsRS.canRead} );

        if( $scope.user.authorization.entity == "Administrator" || $scope.user.authorization.entity == "Advisor" ) {
            if (!args.isNew) {
                i++;
                $scope.menu.categories.push({name: 'Settings', children: [] });

                $scope.menu.categories[i].children.push({ name: 'Custom Fields', active: false, code: 'customFields', show: true });
                $scope.menu.categories[i].children.push({ name: 'Options', active: false, code: 'entityOptions', show: $scope.rightsEOs.canRead });
            }
        }
    }

    function loadDataForSelectedTab() {

        switch( $scope.current.selectedTab ) {
            case "brokerdealerGeneral":
                if( $scope.rightsBD.canRead ) {
                    loadBD();
                    loadBDLookUps();
                }
                if( $scope.rightsOpsMaintenance.canRead ) {
                    loadOpsDatabases();
                }
                break;
            case "reportImage":
                loadReportImage();
                break;
            case "notesAndDocuments":
                if( $scope.rightsNotes.canRead ) {
                    loadNotes();
                }
                if( $scope.rightsDocuments.canRead ) {
                    loadDocuments();
                }
                break;
            case "additionalContacts":
                loadAdditionalContacts();
                break;
            case "revenueShare":
                if( $scope.rightsRS.canRead )
                {
                    loadBDRevenueShare();
                }
                break;
            case "customFields":
                if( $scope.rightsBD.canRead ) {
                    loadCustomFields();
                }
                break;
            case "entityOptions":
                if ($scope.rightsEOs.canRead) {
                    loadEntityOptions();
                }
                break;
        }

    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: function() { $scope.close(true); } }
            ]);
        });
    }


    // PRIVATE METHODS - LOAD BD
    function loadBD() {
        if( $scope.brokerDealerGeneral == null ) {
            if (args.isNew){
                $http.get( "/Portfolio/BrokerDealers/Verbose/New", {trackerMsg: 'Loading broker/dealer'} )
                    .then( function( response ) {
                        $scope.brokerDealerGeneral = response.data.portfolio;
                        brokerDealerGeneralOriginal = angular.copy($scope.brokerDealerGeneral);
                    });
            } else {
                $http.get("/Portfolio/BrokerDealers/Verbose/" + args.ids[0], {trackerMsg: 'Loading broker/dealer'})
                    .then(function (response) {
                        $scope.brokerDealerGeneral = response.data.portfolio;
                        brokerDealerGeneralOriginal = angular.copy($scope.brokerDealerGeneral);
                        $scope.current.brokerDealerName = response.data.name;
                    });
            }
        }
    }

    function loadBDLookUps(){
        if ($scope.bdStatus === null){
            $scope.bdStatus = [];
            bdStatus.keys().forEach(function(key) {
                $scope.bdStatus.push({id: parseInt(bdStatus[key].value), name: bdStatus[key].name})
            });
        }

        if ($scope.clearingFirm === null){
            $scope.clearingFirm = [];
            clearingFirm.keys().forEach(function(key) {
                $scope.clearingFirm.push({id: parseInt(clearingFirm[key].value), name: clearingFirm[key].name})
            });
        }

        if ($scope.howIsAdvRegistered === null){
            $scope.howIsAdvRegistered = [];
            howIsAdvRegistered.keys().forEach(function(key) {
                $scope.howIsAdvRegistered.push({id: parseInt(howIsAdvRegistered[key].value), name: howIsAdvRegistered[key].name})
            });
        }

        $http.get("/Billing/Payees", {cache: true, trackerMsg: 'Loading payees'})
            .then(function (response) {
                response.data.unshift({id: 0, name : '(None)'});
                $scope.payees = response.data;
            });

        $http.get( "/Billing/Schedules?billEntityId=4", {trackerMsg: 'Loading payout schedule'} )
            .then( function( response ) {
                $scope.payoutSchedules = response.data;
            } );
    }

    function loadOpsDatabases() {
        return $http.get("/Portfolio/ALClientOps", {cache: true, trackerMsg: 'Loading OPS Databases'})
            .then( function( response ) {
                response.data.sortBy('clientName');
                response.data.unshift({id: 0, clientName: "Global"});
                $scope.opsDatabases = response.data;
            } );
    }


    // PRIVATE METHODS - LOAD ADDITIONAL CONTACTS
    function loadAdditionalContacts() {
        if( $scope.additionalContacts == null ) {
            if (args.isNew){
                $http.get( "/Portfolio/BrokerDealers/Verbose/New", {trackerMsg: 'Loading broker/dealer additional contacts'} )
                    .then( function( response ) {
                        $scope.additionalContacts = response.data.additionalContacts;
                        additionalContactsOriginal = angular.copy($scope.additionalContacts);
                    });
            } else {
                $http.get("/Portfolio/BrokerDealers/Verbose/" + args.ids[0] + "?expand=additionalContacts", {trackerMsg: 'Loading broker/dealer additional contacts.'})
                    .then(function (response) {
                        $scope.additionalContacts = response.data.additionalContacts;
                        additionalContactsOriginal = angular.copy($scope.additionalContacts);
                    });
            }
        }
    }

    function loadBDRevenueShare() {
        if( $scope.revenueShares == null ) {
            if (args.isNew){
                $http.get( "/Portfolio/BrokerDealers/Verbose/New", {trackerMsg: 'Loading broker/dealer revenue shares.'} )
                    .then(
                        function( response ) {
                        $scope.revenueShares = response.data.brokerDealerRevenueShares;
                        $scope.bdaccounttypes = response.data.brokerDealerRevenueShareAccountTypeExclusions;
                        $scope.bdreps = response.data.brokerDealerRevenueShareRepresentativeExclusions;
                        $scope.bdBussLines = response.data.brokerDealerRevenueShareBusinessLineExclusions;
                        brokerDealerRevenueShareOriginal = angular.copy($scope.revenueShares);
                        brokerDealerAccountTypeOriginal = angular.copy($scope.bdaccounttypes);
                        brokerDealerRepresentativeOriginal = angular.copy($scope.bdreps);
                        brokerDealerBusinessLineOriginal = angular.copy($scope.bdBussLines);
                        $scope.revenueShares.forEach(function(r) {
                            r.startDate = Date.create(r.startDate).formatted();
                            r.endDate = Date.create(r.endDate).formatted();
                        })
                    });
            } else
            {
                $http.get("/Portfolio/BrokerDealers/Verbose/" + args.ids[0] + "?expand=BrokerDealerRevenueShare", {trackerMsg: 'Loading broker/dealer revenue shares.'})
                    .then(function (response) {
                        $scope.revenueShares = response.data.brokerDealerRevenueShares;
                        $scope.bdaccounttypes = response.data.brokerDealerRevenueShareAccountTypeExclusions;
                        $scope.bdreps = response.data.brokerDealerRevenueShareRepresentativeExclusions;
                        $scope.bdBussLines = response.data.brokerDealerRevenueShareBusinessLineExclusions;
                        brokerDealerRevenueShareOriginal = angular.copy($scope.revenueShares);
                        brokerDealerAccountTypeOriginal = angular.copy($scope.bdaccounttypes);
                        brokerDealerRepresentativeOriginal = angular.copy($scope.bdreps);
                        brokerDealerBusinessLineOriginal = angular.copy($scope.bdBussLines);
                        $scope.revenueShares.forEach(function(r) {
                            r.startDate = Date.create(r.startDate).formatted();
                            r.endDate = Date.create(r.endDate).formatted();
                        })
                    });
            }
        }
    }
    // PRIVATE METHODS - LOAD REP REPORT IMAGE
    function loadReportImage(){
        $http.get( "/Portfolio/BrokerDealers/Verbose/" +  (args.isNew ? "New" : args.ids[0]) + "?expand=ReportImage", {trackerMsg: 'Loading report image'} )
            .then( function( response ) {
                $scope.brokerDealerReportImage = response.data.reportImage;
                    brokerDealerReportImageOriginal = angular.copy( $scope.brokerDealerReportImage );
            } );
    }

    // PRIVATE METHODS - LOAD DOCUMENTS AND NOTES
    function loadNotes() {
        if( $scope.brokerdealerNotes == null ) {
            $http.get( "/Portfolio/BrokerDealers/Verbose/" +  (args.isNew ? "New" : args.ids[0]) + "?expand=notes", {trackerMsg: 'Loading notes'} )
                .then( function( response ) {
                    $scope.brokerdealerNotes = response.data.notes;
                    brokerDealerNotesOriginal = angular.copy( $scope.brokerdealerNotes );
                } );
        }
    }

    function loadDocuments() {
        if( $scope.brokerdealerDocuments == null ) {
            $http.get( "/Portfolio/BrokerDealers/Verbose/" +  (args.isNew ? "New" : args.ids[0])  + "?expand=documents", {trackerMsg: 'Loading documents'} )
                .then( function( response ) {
                    $scope.brokerdealerDocuments = response.data.documents;
                    brokerDealerDocumentsOriginal = angular.copy( $scope.brokerdealerDocuments );
                } );
        }
    }

    // PRIVATE METHODS - LOAD CUSTOM FIELDS
    function loadCustomFields() {
        if( $scope.customFields == null ) {
            $http.get( '/Portfolio/BrokerDealers/' + args.ids[0] + '/UserDefinedFields', {trackerMsg: 'Loading custom fields'} )
                .then( function( response ) {
                    $scope.customFields = response.data.sortBy("name");
                    $portfolio.cleanCustomFields($scope.customFields);
                    customFieldsOriginal = angular.copy($scope.customFields);
                } );
        }
    }

    function loadEntityOptions() {
        if ($scope.entityOptions) return;

        $http.get("/Settings/EntityOptions/BrokerDealer/" + args.ids[0], { trackerMsg: 'Loading options' })
            .then(function (response) {
                $portfolio.cleanCustomFields(response.data);
                $scope.entityOptions = response.data;
                entityOptionsOriginal = angular.copy(response.data);
            });
    }

    // PUBLIC METHODS
    $scope.loadTab = function( child ) {
        $scope.menu.categories.each( function( c ) {
            c.children.each( function( ch ) {
                ch.active = ch.code == child.code;
            } );
        } );

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab();
    };

     // PUBLIC METHODS - SSN
     $scope.unlockSSNField = function( forEdit ) {
        if( args.ids[0] > 0 && ( $scope.brokerDealerGeneral.ssN_TaxID && $scope.brokerDealerGeneral.ssN_TaxID.indexOf( 'X' ) != -1) || forEdit ) {
            $dialog.inputBox('Reason to ' + (forEdit ? 'Edit' : 'View') + ' the SSN or Tax ID', "Reason", "textarea")
                .open()
                .then( function( rslt ) {
                    if( rslt && rslt.trim().length > 0 ) {
                        var updateSSN = {ssN: null, reason: rslt};
                        $http.put( '/Portfolio/BrokerDealers/Verbose/' + args.ids[0] + '/SSNTaxId', updateSSN, {trackerMsg: 'Getting SSN/Tax ID information'} )
                            .then( function( response ) {
                                $scope.brokerDealerGeneral.ssN_TaxID = response.data;

                                if( forEdit && $scope.current.updateSSN == false ) {
                                    $scope.current.viewSSNReason = rslt;
                                    $scope.current.updateSSN = true;
                                }
                            } );
                    }
                } );
        }
    }

    $scope.save = function() {

        var verboseBD = {};
        var promises = [];

        if ($scope.emailInvalid) {
            $scope.errors.push( { type: 'error', title: 'Unsaved Changes! ', msg: ' Email address is invalid.', showAllowClose: true } );
            return;
        }

        if( $scope.brokerDealerGeneral && (!angular.equals( brokerDealerGeneralOriginal, $scope.brokerDealerGeneral ) ) ) {
            if ($scope.brokerDealerGeneral.dob)
                $scope.brokerDealerGeneral.dob =  Date.create( $scope.brokerDealerGeneral.dob ).formatted();

            verboseBD["portfolio"] = $scope.brokerDealerGeneral;
        }

        if( $scope.revenueShares && !angular.equals( brokerDealerRevenueShareOriginal, $scope.revenueShares ) ) verboseBD["brokerDealerRevenueShares"] = $scope.revenueShares;
        if( $scope.bdaccounttypes && !angular.equals( brokerDealerAccountTypeOriginal, $scope.bdaccounttypes ) ) verboseBD["brokerDealerRevenueShareAccountTypeExclusions"] = $scope.bdaccounttypes;
        if( $scope.bdreps && !angular.equals( brokerDealerRepresentativeOriginal, $scope.bdreps ) ) verboseBD["brokerDealerRevenueShareRepresentativeExclusions"] = $scope.bdreps;
        if( $scope.bdBussLines && !angular.equals( brokerDealerBusinessLineOriginal, $scope.bdBussLines ) ) verboseBD["brokerDealerRevenueShareBusinessLineExclusions"] = $scope.bdBussLines;

        if( $scope.brokerdealerNotes && !angular.equals( brokerDealerNotesOriginal, $scope.brokerdealerNotes ) ) verboseBD["notes"] = $scope.brokerdealerNotes;

        if( $scope.brokerdealerDocuments && !angular.equals( brokerDealerDocumentsOriginal, $scope.brokerdealerDocuments ) ) verboseBD["documents"] = $scope.brokerdealerDocuments;

        if( $scope.additionalContacts && !angular.equals( additionalContactsOriginal, $scope.additionalContacts ) ) verboseBD["additionalContacts"] = $scope.additionalContacts;

        if( $scope.brokerDealerReportImage && (!angular.equals( brokerDealerReportImageOriginal, $scope.brokerDealerReportImage ) ) ) {
            if ($scope.brokerDealerReportImage.image != null )
                $scope.brokerDealerReportImage.image = $scope.brokerDealerReportImage.image.remove('data:image/jpeg;base64,').remove('data:image/jpg;base64,').remove('data:image/png;base64,');
            verboseBD["reportImage"] = $scope.brokerDealerReportImage;
        }

        if( $scope.customFields && !angular.equals( customFieldsOriginal, $scope.customFields ) ) {
            var udfs =  $scope.customFields.findAll({entity: entities.brokerDealer.name});
            if (udfs) verboseBD["userDefinedFields"] = udfs;
        }

        if ($scope.entityOptions && !angular.equals(entityOptionsOriginal, $scope.entityOptions)) verboseBD["entityOptions"] = $portfolio.restoreEntityOptions($scope.entityOptions);

        verboseBD["id"] = args.isNew ? 0 : args.ids[0];

        var msg = args.isNew ? 'Adding ' : 'Saving ';
        var verb = args.isNew ? 'POST' : 'PUT';
        var urlSave = args.isNew ? '/Portfolio/BrokerDealers/Verbose/' : '/Portfolio/BrokerDealers/Verbose/' + args.ids[0];

        promises.push($http( { method: verb, url: urlSave, data: verboseBD, trackerMsg: msg + 'broker/dealer' } ));

        if( $scope.current.viewSSNReason || $scope.current.updateSSN ) {
            promises.push( $http.put( "/Portfolio/BrokerDealers/Verbose/" + verboseBD["id"] + "/SSNTaxId", {SSN: $scope.brokerDealerGeneral.ssN_TaxID, Reason: $scope.current.viewSSNReason}, {trackerMsg: 'Saving SSN/Tax ID'} ) );
        }

        $q.all( promises ).then( function( results ) {
            var savedData= results[0].data ;
            if( args.app ) {
                var retUrl = '';
                if (args.app == apps.portfolioLists.name) {
                    retUrl = '/Portfolio/BrokerDealers/' + savedData.id;
                }
                $http.get(retUrl, {trackerMsg: 'Refreshing broker/dealer'})
                    .then(function (response) {
                        editorHotKeys.destroy();
                        dialog.close(response.data);
                    });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        } );
    };

    $scope.close = function( validate ) {
        if( validate ) {
            if(
                !angular.equals( brokerDealerGeneralOriginal, $scope.brokerDealerGeneral ) ||
                !angular.equals( brokerDealerNotesOriginal, $scope.brokerdealerNotes ) ||
                !angular.equals( brokerDealerDocumentsOriginal, $scope.brokerdealerDocuments ) ||
                !angular.equals( additionalContactsOriginal, $scope.additionalContacts ) ||
                !angular.equals( customFieldsOriginal, $scope.customFields ) ||
                !angular.equals( brokerDealerRevenueShareOriginal, $scope.revenueShares ) ||
                !angular.equals( brokerDealerAccountTypeOriginal, $scope.bdaccounttypes ) ||
                !angular.equals( brokerDealerRepresentativeOriginal, $scope.bdreps ) ||
                !angular.equals( brokerDealerBusinessLineOriginal, $scope.bdBussLines ) ||
                !angular.equals( entityOptionsOriginal, $scope.entityOptions )
                ) {
                $scope.errors.push( { type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true } );
            } else {
                editorHotKeys.destroy();
                dialog.close( null );
            }

        } else {
            editorHotKeys.destroy();
            dialog.close( null );
        }
    };

    // PUBLIC METHODS - BROKERDEALER REVENUE SHARE
    $scope.addBDRep = function() {
        var rep = {
            id:0,
            brokerDealerId:args.ids[0],
            repId: 0,
            repName:"",
            repNumber:""
        };
        $scope.editRep( rep, true );
    };
    $scope.editRep = function( a, isAdd ) {
        $dialog.dialog( { dialogClass: "modal wide", templateUrl: 'advisor/views/BrokerDealerRepresentative.html', controller: 'BrokerDealerRepresentativeCtrl', bdrep: a, bdreps: $scope.bdreps})
            .open()
            .then( function( result ) {
                if( result ) {
                    if( isAdd ) {
                        var r = {
                            id:0,
                            brokerDealerId:args.ids[0],
                            repId: result.selectedRep.id,
                            repName: result.selectedRep.name,
                            repNumber: result.selectedRep.number
                        };
                        $scope.bdreps.push(r);
                    }
                    else {
                        a=result.selectedrep;
                        var i = $scope.bdreps.find(a=>a.id == result.selectedRep.id );
                        if (i)
                        {
                            i.repId=result.selectedRep.id;
                            i.repName=result.selectedRep.name;
                            i.repNumber = result.selectedRep.number;
                        }
                    }
                }
            } );
    };

    $scope.addAccountType = function() {
        var at = {
            id:0,
            brokerDealerId:args.ids[0],
            accountTypeId: 0,
            accountType: ""
        };
        $scope.editAccountType( at, true );
    };
    $scope.editAccountType = function( a, isAdd ) {
        $dialog.dialog( { dialogClass: "modal wide", templateUrl: 'advisor/views/BrokerDealerAccountType.html', controller: 'BrokerDealerAccountTypeCtrl', bdaccounttype: a, bdaccounttypes: $scope.bdaccounttypes})
            .open()
            .then( function( result ) {
                if( result ) {
                    if( isAdd ) {
                        $scope.bdaccounttypes.push(result.selectedaccounttype);
                    }
                    else {
                        a=result.selectedaccounttype;
                        var i = $scope.bdaccounttypes.find(a=>a.id == result.selectedaccounttype.id );
                        if (i)
                        {
                            i.accountType=result.selectedaccounttype.accountType;
                            i.accountTypeId=result.selectedaccounttype.accountTypeId;
                        }
                    }
                }
            } );
    };

    $scope.addRS = function() {
        var rs = {
            id:0,
            brokerDealerId:args.ids[0],
            billScheduleId: 0,
            payoutRate:"",
            startDate: "",
            endDate:""
        };
        $scope.editRS( rs, true );
    };

    $scope.editRS = function( rs, isAdd ) {
        $dialog.dialog( { dialogClass: "modal wide", templateUrl: 'advisor/views/BrokerDealerRevenueShare.html', controller: 'BrokerDealerRevenueShareCtrl', revenueshare: rs, revenueshares: $scope.revenueShares})
            .open()
            .then( function( result ) {
                if( result ) {
                    if( isAdd ) {
                        result.revenueshare.startDate=Date.create(result.revenueshare.startDate).formatted();
                        result.revenueshare.endDate=Date.create(result.revenueshare.endDate).formatted();
                        rs=result.revenueshare;
                        $scope.revenueShares.push(result.revenueshare);
                    }
                    else {
                        result.revenueshare.startDate=Date.create(result.revenueshare.startDate).formatted();
                        result.revenueshare.endDate=Date.create(result.revenueshare.endDate).formatted();
                        rs=result.revenueshare;
                    }
                }
            } );
    };
    $scope.removeRS = function( rs ) {
        $dialog.confirmAction( "Are you sure you want to remove revenue share with payout rate <b>" + rs.payoutRate + "</b>?" )
            .open()
            .then( function( result ) {
                if( result == 'yes' ) {
                    var idx = $scope.revenueShares.indexOf( rs );
                    $scope.revenueShares.splice( idx, 1 );
                }
            } );
    };

    $scope.removeAccountType = function( ac ) {
        $dialog.confirmAction( "Are you sure you want to remove account type <b>" + ac.accountType + "</b>?" )
            .open()
            .then( function( result ) {
                if( result == 'yes' ) {
                    var idx = $scope.bdaccounttypes.indexOf( ac );
                    $scope.bdaccounttypes.splice( idx, 1 );
                }
            } );
    };

    $scope.removeBDRep = function( r ) {
        $dialog.confirmAction( "Are you sure you want to remove representative <b>" + r.repName + "</b>?" )
            .open()
            .then( function( result ) {
                if( result == 'yes' ) {
                    var idx = $scope.bdreps.indexOf( r );
                    $scope.bdreps.splice( idx, 1 );
                }
            } );
    };

    $scope.addBusinessLine = function() {
        var rs = {
            id:0,
            brokerDealerId:args.ids[0],
            businessLineId: 0,
            businessLine:""
        };
        $scope.editBusinessLine( rs, true );
    };

    $scope.editBusinessLine = function( a, isAdd ) {
        $dialog.dialog( { dialogClass: "modal wide", templateUrl: 'advisor/views/BrokerDealerBusinessLine.html', controller: 'BrokerDealerBusinessLineCtrl', bdbussLine: a, bdbussLines: $scope.bdbussLines})
            .open()
            .then( function( result ) {
                if( result ) {
                    if( isAdd ) {
                        let res = {
                            id:0,
                            brokerDealerId:args.ids[0],
                            businessLineId:result.bdBussLine.businessLineId,
                            businessLine:result.selectedEntity.name
                        };

                        $scope.bdBussLines.push(res);
                    }
                }
            } );
    };

    $scope.removeBusinessLine = function( ac ) {
        $dialog.confirmAction( "Are you sure you want to remove business line <b>" + ac.businessLine + "</b>?" )
            .open()
            .then( function( result ) {
                if( result == 'yes' ) {
                    var idx = $scope.bdBussLines.indexOf( ac );
                    $scope.bdBussLines.splice( idx, 1 );
                }
            } );
    };

    // PUBLIC METHODS - BROKERDEALER MEMBERS
    $scope.addAdditionalContact = function() {
        var addlContacts = {
            "id": 0,
            "type": "",
            "salutation": "",
            "firstName": "",
            "lastName": "",
            "name": "",
            "homePhone": "",
            "homePhoneExt": "",
            "fax": "",
            "faxExt": "",
            "pager": "",
            "pagerExt": "",
            "mobilePhone": "",
            "businessPhone": "",
            "businessPhoneExt": "",
            "otherPhone": "",
            "otherPhoneExt": "",
            "email": "",
            "ssN_TaxID": "",
            "gender": null,
            "dob": "",
            "webAddress": "",
            "contacttype": "",
            address1: "",
            address2: "",
            address3: "",
            city : "",
            state : "",
            zip : "",
            parentId : $scope.current.brokerDealerId ? $scope.current.brokerDealerId : 0
        };
        $scope.editAdditionalContact( addlContacts, true );
    };

    $scope.editAdditionalContact = function( addlContacts, isAdd ) {
        $dialog.dialog( { dialogClass: "modal wide", templateUrl: 'advisor/views/bdAdditionalContact.html', controller: 'BDAdditionalContactCtrl', resolve: { args: function() {
            return {additionalContact : addlContacts, contactTypes : $scope.additionalContacts.map("type").unique()};
        }} } )
            .open()
            .then( function( result ) {
                if( result ) {
                    if( isAdd ) {
                        $scope.additionalContacts.push( result );
                    }
                }
            } );
    };

    $scope.removeAdditionalContact = function( ac ) {
        $dialog.confirmAction( "Are you sure you want to remove additional contact <b>" + ac.name + "</b>?" )
            .open()
            .then( function( result ) {
                if( result == 'yes' ) {
                    var idx = $scope.additionalContacts.indexOf( ac );
                    $scope.additionalContacts.splice( idx, 1 );
                }
            } );
    };



    // REPORT IMAGE
    $scope.saveImage = function(){
        window.location.href = API_CONFIG.baseUrl +  '/Portfolio/BrokerDealers/' + $scope.current.brokerDealerId + '/ReportImage?Authorization=' + sessionStorage.oas_token
    };

    $scope.clearImage = function(){
        $scope.brokerDealerReportImage.image = null;
    };

    $scope.fileTooLarge = function () {
        $scope.errors.push( { type: 'error', title: 'Image too large! ', msg: ' Image must be 1MB or less.', showAllowClose: true } );
    }

    $scope.invalidEmail = function (invalid) {
        $scope.emailInvalid = invalid;
    }

    $scope.setEmail = function (value) {
        $scope.brokerDealerGeneral.email = value;
    }

    // PUBLIC METHODS - NOTES AND DOCUMENTS
    $scope.syncNewDocument = function (newDocument) {
        brokerDealerDocumentsOriginal.push(newDocument);
    };


    // PUBLIC METHODS - USER DEFINED
    $scope.openEditor = function() {
        $portfolio.openEditor( entities.brokerDealer.value, [], null, null, apps.portfolioLists.name, null );
    };

    // INITIALIZE
    $scope.current = {
        isNew : args.isNew,
        selectedTab: args.defaultTab,
        brokerDealerId: args.ids.length > 1 ? 0 : parseInt( args.ids[0] ),
        brokerDealerName : null,
        updateSSN: false,
        viewSSNReason: null
    };


    $scope.brokerDealerGeneral = null;
    $scope.brokerdealerNotes = null;
    $scope.brokerdealerDocuments = null;
    $scope.additionalContacts = null;
    $scope.revenueShares = null;
    $scope.bdreps = null;
    $scope.bdBussLines = null;
    $scope.bdaccounttypes = null;
    $scope.customFields = null;
    $scope.entityOptions = null;

    $scope.bdStatus = null;
    $scope.clearingFirm = null;
    $scope.howIsAdvRegistered = null;
    $scope.payees = null;
    $scope.payoutSchedules = null;

    $scope.errors = [];

    init();
} );
'use strict';

app.controller('BusinessLineEditCtrl', function BusinessLineEditCtrl($scope, $http, $oasRights, $portfolio, $timeout, entities, apps, dialog, args) {
    // PRIVATE VARIABLES
    var businessLineOriginal = null;
    var editorHotKeys;


    //PRIVATE METHODS
    function init() {
        $scope.rightsBL = $oasRights.forCode("BUSINESSLINE");

        var i = 0;
        $scope.menu = { categories: [ ] };
        $scope.menu.categories.push( {name: 'Business Line', children: [] } );
        $scope.menu.categories[i].children.push( {name: 'General', active: false, code: 'businessLineGeneral'} );
        $scope.menu.categories[i].children.push( {name: 'Address', active: false, code: 'address'} );

        $scope.loadTab( args.defaultTab );

        if ($scope.current.businessLineId > 0) {
            $http.get("/Portfolio/BusinessLines/" + $scope.current.businessLineId, {trackerMsg: 'Loading business line'})
                .then(function (response) {
                    $scope.businessLine = response.data;
                    businessLineOriginal = angular.copy($scope.businessLine);

                    $scope.current.businessLineName = response.data.name;
                });
        } else {
            $scope.businessLine = {id: 0, name: "New Business Line", gender: null, employeeCount: 0, startDate: Date.create('today')};
            businessLineOriginal = angular.copy($scope.businessLine);
        }
        loadHotKeys();
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: function() { $scope.close(true); } }
            ]);
        });
    }


    // PUBLIC METHODS
    $scope.loadTab = function( child ) {
        $scope.menu.categories.each( function( c ) {
            c.children.each( function( ch ) {
                ch.active = ch.code == child.code;
            } );
        } );

        $scope.current.selectedTab = child.code;
    };

    $scope.openEditor = function() {
        $portfolio.openEditor( entities.businessLine.value, [], null, null, apps.portfolioLists.name, null );
    };

    $scope.save = function() {
        if ($scope.emailInvalid) {
            $scope.errors.push( { type: 'error', title: 'Unsaved Changes! ', msg: ' Email address is invalid.', showAllowClose: true } );
            return;
        }

        if ($scope.businessLine.dob) {
            $scope.businessLine.dob = Date.create($scope.businessLine.dob).formatted();
        }

        if ($scope.businessLine.startDate) {
            $scope.businessLine.startDate = Date.create($scope.businessLine.startDate).formatted();
        }

        var args = $scope.businessLine.id > 0 ? {method: "PUT", id: $scope.businessLine.id, trackerMsg: "Saving business line " + $scope.businessLine.id} : {method: "POST", id: "", trackerMsg: "Adding new business line"};

        $http({ method: args.method, url: '/Portfolio/BusinessLines/' + args.id, data: $scope.businessLine, trackerMsg: args.trackerMsg })
            .then(function (response) {
                $http.get('/Portfolio/BusinessLines/' + response.data.id, {trackerMsg: 'Refreshing business line'})
                    .then(function (response) {
                        editorHotKeys.destroy();
                        dialog.close(response.data);
                    });
            });
    };

    $scope.close = function( validate ) {
        if( validate ) {
            if (!angular.equals( businessLineOriginal, $scope.businessLine )) {
                $scope.errors.push( { type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true } );
            } else {
                editorHotKeys.destroy();
                dialog.close( null );
            }
        } else {
            editorHotKeys.destroy();
            dialog.close( null );
        }
    };

    $scope.invalidEmail = function (invalid) {
        $scope.emailInvalid = invalid;
    }

    $scope.setEmail = function (value) {
        $scope.businessLine.email = value;
    }

    //INITIALIZE
    $scope.current = {
        isNew : args.isNew,
        selectedTab: args.defaultTab,
        businessLineId: args.ids.length > 1 ? 0 : parseInt( args.ids[0] ),
        businessLineName : null,
        updateSSN: false,
        viewSSNReason: null
    };

    $scope.errors = [];

    init();
});

'use strict';

app.controller('RepresentativeEditCtrl', function RepresentativeEditCtrl(API_CONFIG, $scope, $http, $oasRights, $dialog, $portfolio, $timeout, dialog, args, entities, apps, $q, repStatus, clearingFirm, howIsAdvRegistered) {

    // PRIVATE VARIABLES
    var representativeGeneralOriginal = null;
    var representativeNotesOriginal = null;
    var representativeDocumentsOriginal = null;
    var billRepresentativePlatformsOriginal = null;
    var representativeReportImageOriginal = null;
    var changeHistoryOriginal;

    var customFieldsOriginal = null;
    var entityOptionsOriginal = null;
    var changeHistoryFirstItem = null;
    var editorHotKeys;


    // PRIVATE METHODS - INIT
    function init() {
        loadRights();
        buildMenu();
        loadHotKeys();
        $scope.loadTab(args.defaultTab);
    }

    function loadRights() {
        $scope.rightsRep = $oasRights.forCode("REPS");
        $scope.rightsNotes = $oasRights.forCode("NOTES");
        $scope.rightsDocuments = $oasRights.forCode("DOCUMENTS");
        $scope.rightsEOs = $oasRights.forCode("ENTITYOPTION");
        $scope.rightsSSNView = $oasRights.forCode("SSNVIEW");
        $scope.rightsSSNChange = $oasRights.forCode("SSNCHANGE");
    }

    function buildMenu() {
        var i = 0;
        $scope.menu = { categories: [] };

        $scope.menu.categories.push({ name: 'Representative', children: [] });

        $scope.menu.categories[i].children.push({ name: 'General', active: false, code: 'representativeGeneral' });

        $http.get("/Settings/Database/EntityOptions/Code/69USEREPCHANGEHISTORY", { trackerMsg: 'Checking Billing Representative Change History' })
            .then(function (response) {
                $scope.rightsRepChangeHistory = response.data.value === "True";

                if ($scope.rightsRepChangeHistory && $scope.rightsRep.canRead) {
                    $scope.menu.categories[0].children.splice(1,0,{name: 'Change History',active: false, code:'changeHistory', children: []});
                }
            });

        $scope.menu.categories[i].children.push({ name: 'Licenses', active: false, code: 'representativeLicenses' });

        $scope.menu.categories[i].children.push({ name: 'Image', active: false, code: 'reportImage' });


        if ($scope.rightsNotes.canRead || $scope.rightsDocuments.canRead) {
            $scope.menu.categories[i].children.push({ name: 'Notes & Documents', active: false, code: 'notesAndDocuments' });
        }

        if (["Administrator", "Advisor"].any($scope.user.authorization.entity)) {
            i++;
            $scope.menu.categories.push({ name: 'Billing', children: [] });

            $scope.menu.categories[i].children.push({ name: 'General', active: false, code: 'billingGeneral' });

            if (!args.isNew) {
                i++;
                $scope.menu.categories.push({ name: 'Settings', children: [] });

                $scope.menu.categories[i].children.push({ name: 'Custom Fields', active: false, code: 'customFields' });

                if ($scope.rightsEOs.canRead) {
                    $scope.menu.categories[i].children.push({ name: 'Options', active: false, code: 'entityOptions' });
                }
            }
        }
    }

    function loadDataForSelectedTab() {

        switch ($scope.current.selectedTab) {
            case "representativeGeneral":
            case "representativeLicenses":
                if ($scope.rightsRep.canRead) {
                    loadRep(function () { loadRepLookUps(); });
                }
                break;
            case "billingGeneral":
                if ($scope.rightsRep.canRead) {
                    loadBillRepresentativePlatform();
                }
                break;
            case "changeHistory":
                if ($scope.rightsRepChangeHistory) {
                    loadChangeHistory();
                }
                break;
            case "reportImage":
                loadRepresentativeReportImage();
                break;
            case "notesAndDocuments":
                if ($scope.rightsNotes.canRead) {
                    loadNotes();
                }
                if ($scope.rightsDocuments.canRead) {
                    loadDocuments();
                }
                break;
            case "customFields":
                if ($scope.rightsRep.canRead) {
                    loadCustomFields();
                }
                break;
            case "entityOptions":
                if ($scope.rightsEOs.canRead) {
                    loadEntityOptions();
                }
                break;
        }

    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                { combo: 'ALT+S', command: $scope.save },
                { combo: 'ALT+X', command: function () { $scope.close(true); } }
            ]);
        });
    }

    //PRIVATE METHODS - LOAD BILL REP PLATFORM
    function loadBillRepresentativePlatform() {
        if ($scope.billRepresentativePlatforms == null) {
            $http.get("/Portfolio/Representatives/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=BillRepresentativePlatforms", { trackerMsg: 'Loading billing' })
                .then(function (response) {
                    $scope.billRepresentativePlatforms = response.data.billRepresentativePlatforms;
                    billRepresentativePlatformsOriginal = angular.copy($scope.billRepresentativePlatforms);
                });
        }
    }
    // CHANGEHISTORY
    function loadChangeHistory(){
        if ($scope.chsts) return;

        if (!$scope.rightsRepChangeHistory) {
            $http.get("/Portfolio/RepresentativeChanges/" + args.ids[0], {trackerMsg: 'Loading change history'})
                .then(function (response) {
                    const data = response.data;
                    data.forEach(function (chghst) {
                        chghst.asOfDate = Date.create(chghst.asOfDate);
                        chghst.editedDate = Date.create(chghst.editedDate);
                        chghst.isUncommitted = false;
                    });

                    $scope.chsts = data;
                    $scope.changesFullSet = [];

                    $scope.chsts.forEach(chst => {
                        chst.changes.forEach(change => {
                            change.isUncommitted = false;
                            $scope.changesFullSet.push({
                                id: chst.id,
                                representativeId: chst.representativeId,
                                asOfDate: chst.asOfDate,
                                entityType: change.entityType,
                                oldEntityName: change.oldEntityName,
                                oldEntityId: change.oldEntityId,
                                newEntityName: change.newEntityName,
                                newEntityId: change.newEntityId,
                                editedBy: change.editedBy,
                                editedDate: change.editedDate,
                                isDeleted: change.isDeleted,
                                isUncommitted: change.isUncommitted,
                                actionType: change.actionType
                            });
                        });
                    });

                    changeHistoryOriginal = angular.copy($scope.chsts);
                });
        } else {
            $http.get(`/Portfolio/Representatives/Verbose/${(args.isNew ? "New" : args.ids[0])}?expand=RepBrokerDealers`, { trackerMsg: 'Loading change history' }).then(function (response) {
                setupRepBrokerDealerData(response)
            });
        }
    }

    function setupRepBrokerDealerData(response) {
        let data = formatRepBrokerDealerData(response.data.repBrokerDealers);
        if (data) {
            data.forEach((repBrokerDealer) => {
                repBrokerDealer.isUncommitted = false;
                repBrokerDealer.isActive = true;
            });
        }

        if (!data || data.length === 0) {
            // we need to automatically stage up a "current" change history item if no change history items exist
            var requiredFirstRow = {
                representativeId: $scope.current.representativeId,
                startDate: $scope.representativeGeneral.startDate ? Date.create($scope.representativeGeneral.startDate) : Date.create('1-1-1900'),
                brokerDealerId: $scope.representativeGeneral.brokerDealerId,
                isActive: true,
                isSystemGenerated: !args.isNew,
                entityType: 'Broker/Dealer'
            };
            $scope.changeHistoryCreatedForEdit = !args.isNew;
            changeHistoryFirstItem = angular.copy(requiredFirstRow);

            data.push(requiredFirstRow);
        }

        $scope.chsts = data;
        changeHistoryOriginal = angular.copy($scope.chsts);
    }

    $scope.addChangeHistoryItem = function() {
        $scope.chsts.unshift({
            startDate: new Date(),
            representativeId: $scope.current.representativeId,
            entityType: 'Broker/Dealer',
            isUncommitted: true,
            isActive: true,
        })
    }

    $scope.addChangeHistory = function(chst){
        if (checkPendingChange()) {
            return;
        }

        if (chst){
            $scope.chsts.insert(chst, 0);
            chst.changes.forEach(change => {
                $scope.changesFullSet.push({
                    id: chst.id,
                    representativeId: chst.representativeId,
                    asOfDate: chst.asOfDate,
                    entityType: change.entityType,
                    oldEntityId: change.oldEntityId,
                    oldEntityName: change.oldEntityName,
                    newEntityId: change.newEntityId,
                    newEntityName: change.newEntityName,
                    editedBy: change.editedBy,
                    editedDate: change.editedDate,
                    isDeleted: change.isDeleted,
                    isUncommitted: change.isUncommitted,
                    actionType: change.actionType
                });
            });
        }
        $scope.current.showChangeHistory = !$scope.current.showChangeHistory;
    };

    $scope.validateChangeHistory = function() {
        if (!$scope.chsts) {
            return;
        }

        $http.post(`/Portfolio/Representatives/Action/ValidateChangeHistory/${$scope.current.representativeId}`, $scope.chsts, { trackerMsg: 'Validating change history' }).then((response) => {
            let data = formatRepBrokerDealerData(response.data);
            $scope.chsts = data;
        })
    }

    $scope.resetChangeHistory = function() {
        if (changeHistoryOriginal && changeHistoryOriginal.length > 0) {
            $scope.chsts = JSON.parse(JSON.stringify(changeHistoryOriginal));
            if ($scope.chsts && $scope.chsts.length > 0) {
                $scope.chsts.forEach((changeItem) => {
                    changeItem.startDate = Date.create(changeItem.startDate);
                })
            }

        }
    }

    function formatRepBrokerDealerData(data) {
        if (data) {
            data.forEach((repBrokerDealer) => {
                repBrokerDealer.startDate = repBrokerDealer.startDate ? Date.create(repBrokerDealer.startDate) : null;
                repBrokerDealer.endDate = repBrokerDealer.endDate ? Date.create(repBrokerDealer.endDate) : null;
                repBrokerDealer.editedDate = Date.create(repBrokerDealer.editedDate);
                repBrokerDealer.entityType = 'Broker/Dealer';
                if (repBrokerDealer.startDate) {
                    repBrokerDealer.isStartRecord = Date.create('1/1/1900').getTime() === repBrokerDealer.startDate.getTime();
                }
                if (repBrokerDealer.endDate) {
                    repBrokerDealer.isCurrentRecord = Date.create('12-31-9999').getTime() === repBrokerDealer.endDate.getTime();
                }

                if (repBrokerDealer.id < 0) {
                    repBrokerDealer.createdBy = null;
                    repBrokerDealer.createdDate = null;
                    repBrokerDealer.editedBy = null;
                    repBrokerDealer.editedDate = null;
                }
            });
        }

        return data;
    }

    $scope.undoDeleteChangeHistoryItem = function(chst) {
        chst.isActive = true;
    }

    $scope.deleteChangeHistoryItem = function (chst) {
        $dialog.confirmAction("<span> Are you sure you want to delete this record?</span>")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    chst.isActive = false;
                }
            });
    }

    $scope.deleteChangeHistory = function (chst) {
        if (checkPendingChange()) {
            return;
        }
        $dialog.confirmAction("<span> Are you sure you want to delete this record?</span>")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    if (!chst.isUncommitted) {
                        chst.isDeleted = true;
                        const changeSet = $scope.chsts.find(ch => ch.id === chst.id && ch.asOfDate === chst.asOfDate);
                        if (changeSet) {
                            let change = changeSet.changes.find(chg => chg.entityType === chst.entityType && (chg.newEntityId ? chg.newEntityId : 0) === (chst.newEntityId ? chst.newEntityId : 0) && (chg.oldEntityId ? chg.oldEntityId : 0) === (chst.oldEntityId ? chst.oldEntityId : 0));
                            if (change) {
                                change.isDeleted = true;
                            }

                            let pending = $scope.changesFullSet?.find(chg => chg.entityType === chst.entityType && (chg.newEntityId ? chg.newEntityId : 0) === (chst.newEntityId ? chst.newEntityId : 0) && (chg.oldEntityId ? chg.oldEntityId : 0) === (chst.oldEntityId ? chst.oldEntityId : 0));
                            if (pending){
                                pending.isDeleted = true;
                                pending.isUncommitted = true;
                            }
                        }
                    }
                }
            });
    };

    function checkPendingChange(){
        if ($scope.changesFullSet?.filter(ch => ch.isUncommitted === true)?.length > 0){
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Pending Changes",
                "There's a pending change.  Please save before continuing.")
                .open();

            return true;
        }

        return false;
    }

    // PRIVATE METHODS - LOAD REP
    function loadRep(loadRepLookUps) {
        if ($scope.representativeGeneral == null) {
            if (args.isNew) {
                var url = $scope.rightsRepChangeHistory
                    ? "/Portfolio/Representatives/Verbose/New?expand=RepBrokerDealers&expand=Portfolio"
                    : "/Portfolio/Representatives/Verbose/New";

                $http.get(url, { trackerMsg: 'Loading representative' })
                    .then(function (response) {
                        $scope.representativeGeneral = response.data.portfolio;
                        $scope.representativeGeneral.startDate = Date.create('today');
                        representativeGeneralOriginal = angular.copy($scope.representativeGeneral);
                        loadRepLookUps();

                        if ($scope.rightsRepChangeHistory) {
                            setupRepBrokerDealerData(response);
                        }
                    });
            } else {
                $http.get("/Portfolio/Representatives/Verbose/" + args.ids[0], { trackerMsg: 'Loading representative' })
                    .then(function (response) {
                        $scope.representativeGeneral = response.data.portfolio;
                        $scope.repNASDs = response.data.portfolio.repNasds;
                        $scope.repOnHolds = response.data.portfolio.repOnHolds;
                        $scope.repStates = response.data.portfolio.repStates;
                        $scope.payoutDashNotCompliant = response.data.portfolio.payoutDashNotCompliance;
                        representativeGeneralOriginal = angular.copy($scope.representativeGeneral);
                        $scope.current.representativeName = response.data.name;
                        loadRepLookUps();
                    });
            }
        }
    }

    function loadRepLookUps() {
        if ($scope.repStatuses === null) {
            $scope.repStatuses = [];
            repStatus.keys().forEach(function (key) {
                $scope.repStatuses.push({ id: parseInt(repStatus[key].value), name: repStatus[key].name })
            });
        }

        if ($scope.clearingFirm === null) {
            $scope.clearingFirm = [];
            clearingFirm.keys().forEach(function (key) {
                $scope.clearingFirm.push({ id: parseInt(clearingFirm[key].value), name: clearingFirm[key].name })
            });
        }

        if ($scope.howIsAdvRegistered === null) {
            $scope.howIsAdvRegistered = [];
            howIsAdvRegistered.keys().forEach(function (key) {
                $scope.howIsAdvRegistered.push({
                    id: parseInt(howIsAdvRegistered[key].value),
                    name: howIsAdvRegistered[key].name
                })
            });
        }

        $http.get("/Billing/Payees?isActive=true" + (args.isNew ? "&isCreate=true" : ""), {
            cache: false,
            trackerMsg: 'Loading payees'
        })
            .then(function (response) {
                $scope.payees = response.data;
                if (response.data[0].id < 0) {
                    $scope.representativeGeneral.payeeId = response.data[0].id;
                    representativeGeneralOriginal.payeeId = response.data[0].id;
                }
            });

        $http.get("/Billing/Schedules?billEntityId=4", { trackerMsg: 'Loading payout schedule' })
            .then(function (response) {
                $scope.payoutSchedules = response.data;
            });

    }

    // PRIVATE METHODS - LOAD REP REPORT IMAGE
    function loadRepresentativeReportImage() {
        $http.get("/Portfolio/Representatives/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=ReportImage", { trackerMsg: 'Loading representative report image' })
            .then(function (response) {
                $scope.representativeReportImage = response.data.reportImage;
                representativeReportImageOriginal = angular.copy($scope.representativeReportImage);
            });
    }

    // PRIVATE METHODS - LOAD DOCUMENTS AND NOTES
    function loadNotes() {
        if ($scope.representativeNotes == null) {
            $http.get("/Portfolio/Representatives/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=notes", { trackerMsg: 'Loading notes' })
                .then(function (response) {
                    $scope.representativeNotes = response.data.notes;
                    representativeNotesOriginal = angular.copy($scope.representativeNotes);
                });
        }
    }

    function loadDocuments() {
        if ($scope.representativeDocuments == null) {
            $http.get("/Portfolio/Representatives/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=documents", { trackerMsg: 'Loading documents' })
                .then(function (response) {
                    $scope.representativeDocuments = response.data.documents;
                    representativeDocumentsOriginal = angular.copy($scope.representativeDocuments);
                });
        }
    }

    // PRIVATE METHODS - LOAD CUSTOM FIELDS
    function loadCustomFields() {
        if ($scope.customFields == null) {
            $http.get('/Portfolio/Representatives/Verbose/' + (args.isNew ? "New" : args.ids[0]) + "?expand=UserDefinedFields", { trackerMsg: 'Loading custom fields' })
                .then(function (response) {
                    $scope.customFields = response.data.userDefinedFields.sortBy("name");
                    $portfolio.cleanCustomFields($scope.customFields);
                    customFieldsOriginal = angular.copy($scope.customFields);
                });
        }
    }

    function loadEntityOptions() {
        if ($scope.entityOptions) return;

        $http.get("/Settings/EntityOptions/Representatives/" + args.ids[0], { trackerMsg: 'Loading options' })
            .then(function (response) {
                $portfolio.cleanCustomFields(response.data);
                $scope.entityOptions = response.data;
                entityOptionsOriginal = angular.copy(response.data);
            });
    }


    // PUBLIC METHODS

    $scope.loadTab = function (child) {
        $scope.menu.categories.each(function (c) {
            c.children.each(function (ch) {
                ch.active = ch.code == child.code;
            });
        });

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab();
    };


    $scope.defaultRepresentativeDialogConfirm = function (event){
        if (event.target.checked){
            $scope.canSave = false;
            $http.get('/Portfolio/Representatives/GetDefault', {}, { trackerMsg: 'Getting the current default representative' })
                .then(function (rslt) {
                    if (rslt.data != null) {
                        $dialog.confirmAction($scope.current.representativeName + " will now be the database default representative in place of " + rslt.data.fullName + " <b>" + 'Are you sure?' + "</b>")
                            .open()
                            .then(function (result) {
                                if (result === 'yes') {
                                    $scope.canSave = true;
                                    $scope.representativeGeneral.isDefault = true;
                                } else {
                                    $scope.canSave = true;
                                    $scope.representativeGeneral.isDefault = false;
                                }
                            });
                    }
                    else{
                        //No default rep (Shouldn't happen in practice, but if one is deleted, go ahead and allow checking the box)
                        $dialog.confirmAction($scope.current.representativeName + " will now be the database default representative " + " <b>" + 'Are you sure?' + "</b>")
                            .open()
                            .then(function (result) {
                                if (result === 'yes') {
                                    $scope.canSave = true;
                                    $scope.representativeGeneral.isDefault = true;
                                } else {
                                    $scope.canSave = true;
                                    $scope.representativeGeneral.isDefault = false;
                                }
                            });
                    }
                });
        }
    }
    $scope.save = function () {
        if ($scope.emailInvalid) {
            $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' Email address is invalid.', showAllowClose: true });
            return;
        }

        if ($scope.rightsRepChangeHistory && $scope.chsts && $scope.chsts.length > 0) {
            var changeSetsToSave = JSON.parse(JSON.stringify($scope.chsts));
            if (changeSetsToSave && changeSetsToSave.length === 1) {
                if ($scope.changeHistoryCreatedForEdit) {
                    changeSetsToSave[0].startDate = Date.create(changeSetsToSave[0].startDate);
                    if (changeHistoryFirstItem.brokerDealerId === changeSetsToSave[0].brokerDealerId && changeHistoryFirstItem.isActive === changeSetsToSave[0].isActive) {
                        changeSetsToSave.splice(0, 1);
                    }
                }
            }

            if (changeSetsToSave && changeSetsToSave.length > 0) {
                changeSetsToSave.forEach((change) => {
                    if (change.startDate) {
                        if (typeof change.startDate === 'string') {
                            change.startDate = change.startDate.split('T')[0];
                        } else if (typeof change.startDate === 'object') {
                            change.startDate = change.startDate.toISOString().split('T')[0];
                        }
                    }
                })
                $http.post(`/Portfolio/Representatives/Action/ValidateChangeHistory/${$scope.current.representativeId}`, changeSetsToSave, { trackerMsg: 'Validating change history' }).then((response) => {
                    let data = formatRepBrokerDealerData(response.data);
                    $scope.chsts = data;
                    changeSetsToSave = JSON.parse(JSON.stringify($scope.chsts));

                    const changeHistoryHasInvalid = $scope.chsts.filter((change) => change.isValid === false);
                    if (changeHistoryHasInvalid && changeHistoryHasInvalid.length > 0) {
                        $scope.errors.push({ type: 'error', title: 'Unsaved Changes!', msg: 'Change History configuration is invalid', showAllowClose: true })
                        return;
                    } else {
                        changeSetsToSave.forEach((change) => {
                            if (change.startDate) {
                                change.startDate = change.startDate.split('T')[0];
                            }
                        })
                        saveRepresentative(changeSetsToSave);
                    }
                })
            } else {
                saveRepresentative();
            }
        } else {
            saveRepresentative();
        }


    };

    function saveRepresentative(changeSetsToSave) {
        var verboseRep = {};
        var promises = [];
        if ($scope.representativeGeneral && (!angular.equals(representativeGeneralOriginal, $scope.representativeGeneral))) {
            if ($scope.representativeGeneral.dob)
                $scope.representativeGeneral.dob = Date.create($scope.representativeGeneral.dob).formatted();

            verboseRep["portfolio"] = $scope.representativeGeneral;
        }

        if ($scope.representativeReportImage && (!angular.equals(representativeReportImageOriginal, $scope.representativeReportImage))) {
            if ($scope.representativeReportImage.image != null)
                $scope.representativeReportImage.image = $scope.representativeReportImage.image.remove('data:image/jpeg;base64,').remove('data:image/jpg;base64,').remove('data:image/png;base64,');
            verboseRep["reportImage"] = $scope.representativeReportImage;
        }

        if ($scope.billRepresentativePlatforms && (!angular.equals(billRepresentativePlatformsOriginal, $scope.billRepresentativePlatforms))) {
            verboseRep["billRepresentativePlatforms"] = $scope.billRepresentativePlatforms;
        }

        if ($scope.representativeNotes && !angular.equals(representativeNotesOriginal, $scope.representativeNotes)) verboseRep["notes"] = $scope.representativeNotes;

        if ($scope.representativeDocuments && !angular.equals(representativeDocumentsOriginal, $scope.representativeDocuments)) verboseRep["documents"] = $scope.representativeDocuments;

        if ($scope.customFields && !angular.equals(customFieldsOriginal, $scope.customFields)) {
            var udfs = $scope.customFields.findAll({ entity: entities.representative.name });
            if (udfs) verboseRep["userDefinedFields"] = udfs;
        }

        if ($scope.entityOptions && !angular.equals(entityOptionsOriginal, $scope.entityOptions)) verboseRep["entityOptions"] = $portfolio.restoreEntityOptions($scope.entityOptions);

        if ($scope.rightsRepChangeHistory) {
            if (changeSetsToSave && changeSetsToSave.length > 0) {
                var formattedchangeSetsToSave = JSON.parse(JSON.stringify(changeSetsToSave))
                formattedchangeSetsToSave.forEach((rep) => {
                    if (rep.startDate) {
                        rep.startDate = Date.create(rep.startDate);
                    }
                    if (rep.endDate) {
                        rep.endDate = Date.create(rep.endDate);
                    }
                    if(rep.editedDate) {
                        rep.editedDate = Date.create(rep.editedDate);
                    }
                    delete rep.simpleRep
                })

                if (changeHistoryOriginal && changeHistoryOriginal.length > 0) {
                    changeHistoryOriginal.forEach((rep) => {
                        rep.isValid = true;
                        delete rep.isUncommitted;
                        delete rep.simpleRep;
                    })
                }

                if (!angular.equals(changeHistoryOriginal, formattedchangeSetsToSave)) {
                    verboseRep['repBrokerDealers'] = changeSetsToSave
                }
            }
        }

        verboseRep["id"] = args.isNew ? 0 : args.ids[0];

        var msg = args.isNew ? 'Adding ' : 'Saving ';
        var verb = args.isNew ? 'POST' : 'PUT';
        var urlSave = args.isNew ? '/Portfolio/Representatives/Verbose/' : '/Portfolio/Representatives/Verbose/' + args.ids[0];

        promises.push($http({ method: verb, url: urlSave, data: verboseRep, trackerMsg: msg + 'representative' }));

        if ($scope.current.viewSSNReason || $scope.current.updateSSN) {
            promises.push($http.put("/Portfolio/Representatives/" + verboseRep["id"] + "/SSNTaxId", { SSN: $scope.representativeGeneral.ssN_TaxID, Reason: $scope.current.viewSSNReason }, { trackerMsg: 'Saving SSN/Tax ID' }));
        }

        if ($scope.chsts && !angular.equals(changeHistoryOriginal, $scope.chsts)){
            if (!$scope.rightsRepChangeHistory) {
                promises.push($http.put('/Portfolio/RepresentativeChanges/' + $scope.current.representativeId, $scope.chsts, {trackerMsg: 'Saving representative change history'}));
            }
        }

        $q.all(promises).then(function (results) {
            var savedData = results[0].data;
            // Check for default rep change once we have the correct id back from the request.
            if (!angular.equals(representativeGeneralOriginal.isDefault === null ?
                false :
                representativeGeneralOriginal.isDefault,
                $scope.representativeGeneral.isDefault))
                $scope.makeDefaultRep(savedData.id);

            if (args.app) {
                var retUrl = '';
                if (args.app == apps.portfolioLists.name) {
                    retUrl = '/Portfolio/Representatives/' + savedData.id;
                }
                $http.get(retUrl, { trackerMsg: 'Refreshing representative' })
                    .then(function (response) {
                        editorHotKeys.destroy();
                        dialog.close(response.data);
                    });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        });
    }

    $scope.close = function (validate) {
        if (validate) {
            if (
                !angular.equals(representativeGeneralOriginal, $scope.representativeGeneral) ||
                !angular.equals(billRepresentativePlatformsOriginal, $scope.billRepresentativePlatforms) ||
                !angular.equals(representativeReportImageOriginal, $scope.representativeReportImage) ||
                !angular.equals(representativeNotesOriginal, $scope.representativeNotes) ||
                !angular.equals(representativeDocumentsOriginal, $scope.representativeDocuments) ||
                !angular.equals(customFieldsOriginal, $scope.customFields) ||
                !angular.equals(changeHistoryOriginal, $scope.chsts) ||
                !angular.equals(entityOptionsOriginal, $scope.entityOptions)
            ) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }

        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };


    $scope.makeDefaultRep = function (repId) {
        $http.put('/Portfolio/Representatives/' + repId + '/MakeDefault', {}, { trackerMsg: 'Updating representative to default' })
            .then(function () {
                refreshGrid();
            });
    };

    $scope.isDefault = function () {
       return representativeGeneralOriginal?.isDefault;
    };

    function refreshGrid() {
        $scope.$broadcast('event:portfoliolist-representatives-action', { action: 'refresh-grid' });
    }

    $scope.openEditor = function () {
        $portfolio.openEditor(entities.representative.value, [], null, null, apps.portfolioLists.name, null);
    };

    $scope.setFullName = function () {
        if (!$scope.representativeGeneral.firstName) $scope.representativeGeneral.firstName = '';
        if (!$scope.representativeGeneral.lastName) $scope.representativeGeneral.lastName = '';

        $scope.representativeGeneral.name = $scope.representativeGeneral.firstName + ' ' + $scope.representativeGeneral.lastName;
    };

    // PUBLIC METHODS - NOTES AND DOCUMENTS
    $scope.syncNewDocument = function (newDocument) {
        representativeDocumentsOriginal.push(newDocument);
    };


    // LICENSES
    $scope.addLicense = function () {
        $dialog.inputBox("Add License", "License Number")
            .open()
            .then(function (result) {
                if (result && $scope.repNASDs.none({ number: result })) {
                    $scope.repNASDs.push({ repNasdId: 0, number: result });
                }
            });
    };

    $scope.removeRepNASD = function (license) {
        $dialog.confirmAction("Are you sure you want to remove license <b>" + license.number + "</b>?")
            .open()
            .then(function (result) {
                if (result == 'yes') {
                    $scope.repNASDs.remove(license);
                }
            });
    };

    $scope.addState = function () {
        var list = $scope.repStates ? $scope.repStates.map(function (state) { return { id: state.stateId }; }) : null;

        $dialog.dialog({ templateUrl: "app/modals/available-select.html", controller: "AvailableSelectCtrl", resolve: { availableSelectedArgs: function () { return { selectionType: 1005, selectedSelected: list }; } } })
            .open()
            .then(function (rslt) {
                if (!rslt) return;

                rslt.each(function (state) {
                    state.stateName = state.name;
                    state.stateId = state.id;

                    if ($scope.repStates === null) {
                        $scope.repStates = [];
                    }

                    if ($scope.repStates.none({ stateId: state.id })) {
                        state.id = 0;
                        $scope.repStates.push(state);
                    }
                });

                $scope.repStates.each(function (state) {
                    if (rslt.none({ stateId: state.stateId })) {
                        $scope.repStates.remove(state);
                    }
                });
            });
    };

    $scope.removeState = function (state) {
        $dialog.confirmAction("Are you sure you want to remove <b>" + state.stateName + "</b>?")
            .open()
            .then(function (result) {
                if (result == 'yes') {
                    $scope.repStates.remove(state);
                }
            });
    };

    // PUBLIC METHODS - BILL REP PLATFORMS
    $scope.addPlatform = function () {
        var billRepPlatform = {
            id: 0,
            billRepId: null,
            billFeeScheduleId: null,
            platformId: null,
            billPayoutScheduleId: null,
            billMasterPayoutScheduleId: null
        };

        $scope.billRepresentativePlatforms.push(billRepPlatform);
    };

    $scope.removePlatform = function (platform) {
        $dialog.confirmAction("Are you sure you want to remove this platform?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.billRepresentativePlatforms.remove(platform);
                }
            });
    };

    // REPORT IMAGE
    $scope.saveImage = function () {
        window.location.href = API_CONFIG.baseUrl + '/Portfolio/Representatives/' + $scope.current.representativeId + '/ReportImage?Authorization=' + sessionStorage.oas_token

    };

    $scope.clearImage = function () {
        $scope.representativeReportImage.image = null;
    };

    $scope.fileTooLarge = function () {
        $scope.errors.push( { type: 'error', title: 'Image too large! ', msg: ' Image must be 1MB or less.', showAllowClose: true } );
    }

    $scope.invalidEmail = function (invalid) {
        $scope.emailInvalid = invalid;
    }

    $scope.setEmail = function (value) {
        $scope.representativeGeneral.email = value;
    }

    // PUBLIC METHODS - SSN
    $scope.unlockSSNField = function (forEdit) {
        if (args.ids[0] > 0 && ($scope.representativeGeneral.ssN_TaxID && $scope.representativeGeneral.ssN_TaxID.indexOf('X') != -1) || forEdit) {
            $dialog.inputBox('Reason to ' + (forEdit ? 'Edit' : 'View') + ' the SSN or Tax ID', "Reason", "textarea")
                .open()
                .then(function (rslt) {
                    if (rslt && rslt.trim().length > 0) {
                        var updateSSN = { ssN: null, reason: rslt };
                        $http.put('/Portfolio/Representatives/' + args.ids[0] + '/SSNTaxId', updateSSN, { trackerMsg: 'Getting SSN/Tax ID information' })
                            .then(function (response) {
                                $scope.representativeGeneral.ssN_TaxID = response.data;

                                if (forEdit && $scope.current.updateSSN == false) {
                                    $scope.current.viewSSNReason = rslt;
                                    $scope.current.updateSSN = true;
                                }
                            });
                    }
                });
        }
    };

    $scope.brokerDealerEditClicked = function() {
        let changeHistoryMenuItem = $scope.menu.categories.map((category) => category.children).flatten().find((children) => children.code === 'changeHistory');
        $scope.loadTab(changeHistoryMenuItem);
    }

    // INITIALIZE
    $scope.today = Date.now();
    $scope.changeHistoryCreatedForEdit = false;
    $scope.current = {
        isNew: args.isNew,
        showChangeHistory: false,
        selectedTab: args.defaultTab,
        representativeId: args.ids.length > 0 ? parseInt(args.ids[0]) : 0,
        representativeName: null,
        updateSSN: false,
        viewSSNReason: null
    };

    $scope.representativeGeneral = null;
    $scope.representativeNotes = null;
    $scope.representativeDocuments = null;
    $scope.billRepresentativePlatforms = null;
    $scope.representativeReportImage = null;
    $scope.customFields = null;

    $scope.repStatuses = null;
    $scope.payees = null;
    $scope.repNASDs = null;
    $scope.repOnHolds = null;
    $scope.repStates = null;
    $scope.entityOptions = null;
    $scope.payoutDashNotCompliant = null;
    $scope.canSave = true;

    $scope.errors = [];

    init();
});
'use strict';

var subAdvisorEditCtrl = app.controller( 'SubAdvisorEditCtrl', function SubAdvisorEditCtrl( $scope, $http, $q, $oasRights, $dialog, $portfolio, $timeout, dialog, args, entities, apps) {

    // PRIVATE VARIABLES
    var subAdvisorGeneralOriginal = null;
    var subAdvisorNotesOriginal = null;
    var subAdvisorDocumentsOriginal = null;
    var subAdvisorLogoOriginal = null;
    var subAdvisorEntitiesOriginal = null;
    var editorHotKeys;


    // PRIVATE METHODS - INIT
    function init() {
        loadRights();
        checkIsSelfDirected();
        loadHotKeys();
        if($scope.rightsEclipseAdmin.canRead) {
            loadEclipseFirms();
        }
    }

    function loadRights() {
        $scope.rightsSA = $oasRights.forCode( "SUBADVISORS" );
        $scope.rightsNotes = $oasRights.forCode( "NOTES" );
        $scope.rightsDocuments = $oasRights.forCode( "DOCUMENTS" );
        $scope.rightsEclipseAdmin = $oasRights.forCode("ECLIPSEORIONADMIN");
        $scope.rightsEditOciSync = $oasRights.forCode("EDITOCISYNC");
    }

    function checkIsSelfDirected(){
        $http.get("/Settings/Database/EntityOptions/Code/SELFDIRECTEDSUBADVID", {cache: true, trackerMsg: 'Loading model setting'})
            .then(function(response){
                $scope.current.isSelfDirected = response.data.value !== "0";
                buildMenu();
                $scope.loadTab( args.defaultTab );
            });
    }

    function loadEclipseFirms() {
        $http.get('/Integrations/Eclipse/Firms/ByAlClientId/' + $scope.user.authorization.alClientId , {trackerMsg:'Loading Eclipse Firms'})
            .then(function (response) {
                $scope.eclipseFirmList = response.data;
            });
    }

    function buildMenu() {
        var i = 0;
        $scope.menu = { categories: [ ] };

        $scope.menu.categories.push( {name: 'Sub-Advisor', children: [] } );

        $scope.menu.categories[i].children.push( {name: 'General', active: false, code: 'subAdvisorGeneral'} );
        if ($scope.current.isSelfDirected){
            $scope.menu.categories[i].children.push( {name: 'Entities Assigned', active: false, code: 'entities'} );
        }
        $scope.menu.categories[i].children.push( {name: 'Description', active: false, code: 'description'} );
        $scope.menu.categories[i].children.push( {name: 'Logo', active: false, code: 'logo'} );

        if( $scope.rightsNotes.canRead || $scope.rightsDocuments.canRead ) {
            $scope.menu.categories[i].children.push( {name: 'Notes & Documents', active: false, code: 'notesAndDocuments'} );
        }
    }

    function loadDataForSelectedTab() {

        switch( $scope.current.selectedTab ) {
            case "subAdvisorGeneral":
            case "description":
                if( $scope.rightsSA.canRead ) {
                    loadSA();
                    loadSALookUps();
                }
                break;
            case "notesAndDocuments":
                if( $scope.rightsNotes.canRead ) {
                    loadNotes();
                }
                if( $scope.rightsDocuments.canRead ) {
                    loadDocuments();
                }
                break;
            case "entities":
                if( $scope.rightsSA.canRead ) {
                    loadEntities();
                }
                break;
            case "logo":
                if( $scope.rightsSA.canRead ) {
                    loadLogo();
                }
                break;
        }

    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: function() { $scope.close(true); } }
            ]);
        });
    }


    // PRIVATE METHODS - LOAD SA
    function loadSA() {
        if( $scope.subAdvisorGeneral == null ) {
            if (args.isNew){
                $http.get( "/Portfolio/SubAdvisors/Verbose/New", {trackerMsg: 'Loading sub-advisor'} )
                    .then( function( response ) {
                        response.data.portfolio.payeeId = 0;
                        $scope.subAdvisorGeneral = response.data.portfolio;
                        subAdvisorGeneralOriginal = angular.copy($scope.subAdvisorGeneral);
                        $scope.current.totalEmailsAssignedForTargetAllocReport = $scope.subAdvisorGeneral.targetAllocEmails ? $scope.subAdvisorGeneral.targetAllocEmails.split(';').length : 0;
                    });
            } else {
                $http.get("/Portfolio/SubAdvisors/Verbose/" + args.ids[0], {trackerMsg: 'Loading sub-advisor'})
                    .then(function (response) {
                        $scope.subAdvisorGeneral = response.data.portfolio;
                        subAdvisorGeneralOriginal = angular.copy($scope.subAdvisorGeneral);
                        $scope.current.subAdvisorName = response.data.name;
                        $scope.current.totalEmailsAssignedForTargetAllocReport = $scope.subAdvisorGeneral.targetAllocEmails ? $scope.subAdvisorGeneral.targetAllocEmails.split(';').length : 0;
                    });
            }
        }
    }

    function loadSALookUps(){
        $http.get("/Billing/Payees", {cache: true, trackerMsg: 'Loading payees'})
            .then(function (response) {
                response.data.unshift({id: 0, name : '(None)'});
                $scope.payees = response.data;
            });
    }

    // PRIVATE METHODS - LOAD DOCUMENTS AND NOTES
    function loadNotes() {
        if( $scope.subAdvisorNotes == null ) {
            $http.get( "/Portfolio/SubAdvisors/Verbose/" +  (args.isNew ? "New" : args.ids[0]) + "?expand=notes", {trackerMsg: 'Loading notes'} )
                .then( function( response ) {
                    $scope.subAdvisorNotes = response.data.notes;
                    subAdvisorNotesOriginal = angular.copy( $scope.subAdvisorNotes );
                } );
        }
    }

    function loadDocuments() {
        if( $scope.subAdvisorDocuments == null ) {
            $http.get( "/Portfolio/SubAdvisors/Verbose/" +  (args.isNew ? "New" : args.ids[0])  + "?expand=documents", {trackerMsg: 'Loading documents'} )
                .then( function( response ) {
                    $scope.subAdvisorDocuments = response.data.documents;
                    subAdvisorDocumentsOriginal = angular.copy( $scope.subAdvisorDocuments );
                } );
        }
    }

    // PRIVATE METHODS - LOAD ENTITIES
    function loadEntities() {
        if( $scope.subAdvisorEntities == null ) {
            $http.get( "/Portfolio/SubAdvisors/Verbose/" +  (args.isNew ? "New" : args.ids[0]) + "?expand=entities", {trackerMsg: 'Loading entities'} )
                .then( function( response ) {
                    var first = response.data.entities[0];

                    $scope.current.entityType = first
                        ? (first.entityId === 0 && first.entity === "Advisor" ? "Global" : response.data.entities[0].entity)
                        : "NotSet";

                    $scope.subAdvisorEntities = response.data.entities;

                    if (["Representative", "Broker/Dealer", "Advisor"].any($scope.current.entityType)) {
                        $http.post(entities[entities.find({name: $scope.current.entityType})].simpleUrl + '/List/Id', response.data.entities.map("entityId"), {trackerMsg: 'Building entity list'})
                            .then(function(innerResponse) {
                                innerResponse.data.forEach(function (entity) {
                                   $scope.subAdvisorEntities.find({entityId: entity.id}).name = entity.name;
                                });

                                subAdvisorEntitiesOriginal = angular.copy( $scope.subAdvisorEntities );
                            });
                    } else {
                        subAdvisorEntitiesOriginal = angular.copy( $scope.subAdvisorEntities );
                    }
                } );
        }
    }

    // PRIVATE METHODS - LOAD LOGO
    function loadLogo() {
        if( $scope.subAdvisorLogo == null ) {
            $http.get( "/Portfolio/SubAdvisors/Verbose/" +  (args.isNew ? "New" : args.ids[0]) + "?expand=logo", {trackerMsg: 'Loading logo'} )
                .then( function( response ) {
                    $scope.subAdvisorLogo = response.data.logo;
                    subAdvisorLogoOriginal = angular.copy( $scope.subAdvisorLogo );
                } );
        }
    }


    // PUBLIC METHODS

    $scope.viewEmailList = function () {
        var emailArrayList = $scope.subAdvisorGeneral.targetAllocEmails ? $scope.subAdvisorGeneral.targetAllocEmails.split(';') : [];
        var dialogOpts = {
            templateUrl : "subAdvisor-email-distribution-list.html",
            controller : "SubAdvisorEmailDistributionListCtrl",
            emailList: emailArrayList
        };

        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function(rslt) {
                if(rslt) {
                    $scope.subAdvisorGeneral.targetAllocEmails = rslt.join(';');
                    $scope.current.totalEmailsAssignedForTargetAllocReport = rslt.length;
                }
            });
    };

    $scope.loadTab = function( child ) {
        $scope.menu.categories.each( function( c ) {
            c.children.each( function( ch ) {
                ch.active = ch.code === child.code;
            } );
        } );

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab();
    };

    $scope.clearLogo = function () {
        $scope.subAdvisorLogo.image = null;
    };

    $scope.entitiesForType = function() {
        return $scope.current.entityType === 'Global'
            ? [{entity: "Advisor", entityId: 0}]
            : ($scope.subAdvisorEntities||[]).filter(function(e) {
                return e.entity === $scope.current.entityType && e.entityId > 0;
            })
    };

    $scope.addEntity = function () {
        var entityTypeName = entities.find({name: $scope.current.entityType});
        $dialog.search(entityTypeName, "Add New", $scope.current.entityType)
            .open()
            .then(function (result) {
                if (result && $scope.subAdvisorEntities.none({entityId: result.id, entity: $scope.current.entityType})) {
                    $scope.subAdvisorEntities.push({entityId: result.id, name: result.name, entity: $scope.current.entityType});
                }
            });
    };

    $scope.removeEntity = function (entity) {
        $scope.subAdvisorEntities.remove(entity);
    };
    
    $scope.save = function() {
        if ($scope.emailInvalid) {
            $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' Email address is invalid.', showAllowClose: true });
            return;
        }

        var verboseSA = {};
        var promises = [];

        if( $scope.subAdvisorGeneral && (!angular.equals( subAdvisorGeneralOriginal, $scope.subAdvisorGeneral ) ) ) {
            if ($scope.subAdvisorGeneral.dob)
                $scope.subAdvisorGeneral.dob =  Date.create( $scope.subAdvisorGeneral.dob ).formatted();

            $scope.subAdvisorGeneral.lastName = $scope.subAdvisorGeneral.name;

            verboseSA["portfolio"] = $scope.subAdvisorGeneral;
        }

        if( $scope.subAdvisorNotes && !angular.equals( subAdvisorNotesOriginal, $scope.subAdvisorNotes ) ) verboseSA["notes"] = $scope.subAdvisorNotes;

        if( $scope.subAdvisorDocuments && !angular.equals( subAdvisorDocumentsOriginal, $scope.subAdvisorDocuments ) ) verboseSA["documents"] = $scope.subAdvisorDocuments;

        if( $scope.subAdvisorEntities ) {
            verboseSA["entities"] = $scope.entitiesForType();
        }

        if( $scope.subAdvisorLogo && !angular.equals( subAdvisorLogoOriginal, $scope.subAdvisorLogo ) ) {
            if ($scope.subAdvisorLogo.image) {
                $scope.subAdvisorLogo.image = $scope.subAdvisorLogo.image.remove('data:image/jpeg;base64,').remove('data:image/jpg;base64,').remove('data:image/png;base64,');
            }

            verboseSA["logo"] = $scope.subAdvisorLogo;
        }

        verboseSA["id"] = args.isNew ? 0 : args.ids[0];

        var msg = args.isNew ? 'Adding ' : 'Saving ';
        var verb = args.isNew ? 'POST' : 'PUT';
        var urlSave = args.isNew ? '/Portfolio/SubAdvisors/Verbose/' : '/Portfolio/SubAdvisors/Verbose/' + args.ids[0];

        promises.push($http( { method: verb, url: urlSave, data: verboseSA, trackerMsg: msg + 'sub-advisor' } ));

        $q.all( promises ).then( function( results ) {
            var savedData= results[0].data ;
            if( args.app ) {
                var retUrl = '';
                if (args.app === apps.portfolioLists.name) {
                    retUrl = '/Portfolio/SubAdvisors/' + savedData.id;
                }
                $http.get(retUrl, {trackerMsg: 'Refreshing sub-advisor'})
                    .then(function (response) {
                        editorHotKeys.destroy();
                        dialog.close(response.data);
                    });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        } );
    };

    $scope.close = function( validate ) {
        if( validate ) {

            if(
                !angular.equals( subAdvisorGeneralOriginal, $scope.subAdvisorGeneral ) ||
                !angular.equals( subAdvisorNotesOriginal, $scope.subAdvisorNotes ) ||
                !angular.equals( subAdvisorDocumentsOriginal, $scope.subAdvisorDocuments ) ||
                !angular.equals( subAdvisorEntitiesOriginal, $scope.subAdvisorEntities ) ||
                !angular.equals( subAdvisorLogoOriginal, $scope.subAdvisorLogo )
            ) {
                $scope.errors.push( { type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true } );
            } else {
                editorHotKeys.destroy();
                dialog.close( null );
            }

        } else {
            editorHotKeys.destroy();
            dialog.close( null );
        }
    };

    $scope.invalidEmail = function (invalid) {
        $scope.emailInvalid = invalid;
    }

    $scope.setEmail = function (value) {
        $scope.subAdvisorGeneral.email = value;
    }


    // PUBLIC METHODS - NOTES AND DOCUMENTS
    $scope.syncNewDocument = function (newDocument) {
        subAdvisorDocumentsOriginal.push(newDocument);
    };

    $scope.openEditor = function() {
        $portfolio.openEditor( entities.subAdvisor.value, [], 'General', 'subAdvisorGeneral', apps.portfolioLists.name, null );
    };

    $scope.fileTooLarge = function() {
        $scope.errors.push( { type: 'error', title: 'Image too large! ', msg: ' Image must be 1MB or less.', showAllowClose: true } );
    }


    // INITIALIZE
    $scope.current = {
        isNew : args.isNew,
        selectedTab: args.defaultTab,
        subAdvisorId: args.ids.length > 1 ? 0 : parseInt( args.ids[0] ),
        isSelfDirected : null,
        subAdvisorName : null,
        updateSSN: false,
        viewSSNReason: null,
        entityType: 0,
        totalEmailsAssignedForTargetAllocReport: 0
    };


    $scope.subAdvisorGeneral = null;
    $scope.subAdvisorNotes = null;
    $scope.subAdvisorDocuments = null;
    $scope.subAdvisorLogo = null;
    $scope.subAdvisorEntities = null;

    $scope.payees = null;

    $scope.errors = [];

    init();
} );

app.controller('SubAdvisorEmailDistributionListCtrl', function SubAdvisorEmailDistributionListCtrl ($scope, $http, dialog){
    $scope.distributionEmailList = [];

    $scope.distributionEmailList = dialog.options.emailList;

    $scope.close = function (isCancel) {
        if(isCancel){
            dialog.close(null);
        }else{
            dialog.close($scope.distributionEmailList);
        }
    };

    $scope.addEmail = function (){
        $scope.distributionEmailList.add($scope.current.emailAddress);
        $scope.current.emailAddress = null;
    }

    $scope.removeEmailFromList = function (e){
        $scope.distributionEmailList.remove(e);
    }

    $scope.invalidEmail = function (invalid) {
        $scope.current.emailInvalid = invalid;
    };

    $scope.setEmail = function (value) {
        $scope.current.emailAddress = value;
    };

    $scope.current = {emailAddress: null};
})

'use strict';

app.controller('WholesalerEditCtrl', function WholesalerEditCtrl($scope, $http, $q, $oasRights, $dialog, $portfolio, $timeout, dialog, args, entities, apps) {

    // PRIVATE VARIABLES
    var wholesalerGeneralOriginal = null;
    var wholesalerNotesOriginal = null;
    var wholesalerDocumentsOriginal = null;
    var customFieldsOriginal = null;
    var editorHotKeys;


    // PRIVATE METHODS - INIT
    function init() {
        loadRights();
        buildMenu();
        loadHotKeys();
        $scope.loadTab( args.defaultTab );
    }

    function loadRights() {
        $scope.rightsWholesaler = $oasRights.forCode("WHOLESALERS");
        $scope.rightsNotes = $oasRights.forCode("NOTES");
        $scope.rightsDocuments = $oasRights.forCode("DOCUMENTS");
        $scope.rightsSSNView = $oasRights.forCode("SSNVIEW");
        $scope.rightsSSNChange = $oasRights.forCode("SSNCHANGE");
    }

    function buildMenu() {
        var i = 0;
        $scope.menu = {categories: []};

        $scope.menu.categories.push({name: 'Wholesaler', children: []});

        $scope.menu.categories[i].children.push({name: 'General', active: false, code: 'wholesalerGeneral'});

        $scope.menu.categories[i].children.push( {name: 'States', active: false, code: 'wholesalerStates'} );

        if ($scope.rightsNotes.canRead || $scope.rightsDocuments.canRead) {
            $scope.menu.categories[i].children.push({name: 'Notes & Documents', active: false, code: 'notesAndDocuments'});
        }

        if (["Administrator", "Advisor"].any($scope.user.authorization.entity)) {
            if (!args.isNew) {
                i++;
                $scope.menu.categories.push({name: 'Settings', children: []});

                $scope.menu.categories[i].children.push({name: 'Custom Fields', active: false, code: 'customFields'});
            }
        }
    }

    function loadDataForSelectedTab() {
        switch ($scope.current.selectedTab) {
            case "wholesalerGeneral":
            case "wholesalerStates":
                if ($scope.rightsWholesaler.canRead) {
                    loadWholesaler();
                }
                break;
            case "notesAndDocuments":
                if ($scope.rightsNotes.canRead) {
                    loadNotes();
                }
                if ($scope.rightsDocuments.canRead) {
                    loadDocuments();
                }
                break;
            case "customFields":
                if ($scope.rightsWholesaler.canRead) {
                    loadCustomFields();
                }
                break;
        }
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                {combo: 'ALT+S', command: $scope.save},
                {combo: 'ALT+X', command: function () {$scope.close(true);}}
            ]);
        });
    }


    // PRIVATE METHODS - LOAD SA
    function loadWholesaler() {
        if ($scope.wholesalerGeneral) return;

        $http.get("/Portfolio/Wholesalers/Verbose/" + (args.isNew ? 'New' : args.ids[0]), {trackerMsg: 'Loading wholesaler'})
            .then(function (response) {
                var data = response.data;
                $scope.wholesalerGeneral = data.portfolio;
                $scope.wholesalerStates = data.portfolio.wholesalerStates;
                wholesalerGeneralOriginal = angular.copy($scope.wholesalerGeneral);
            });
    }


    // PRIVATE METHODS - LOAD DOCUMENTS AND NOTES
    function loadNotes() {
        if ($scope.wholesalerNotes) return;

        $http.get("/Portfolio/Wholesalers/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=notes", {trackerMsg: 'Loading notes'})
            .then(function (response) {
                $scope.wholesalerNotes = response.data.notes;
                wholesalerNotesOriginal = angular.copy($scope.wholesalerNotes);
            });
    }

    function loadDocuments() {
        if ($scope.wholesalerDocuments) return;

        $http.get("/Portfolio/Wholesalers/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=documents", {trackerMsg: 'Loading documents'})
            .then(function (response) {
                $scope.wholesalerDocuments = response.data.documents;
                wholesalerDocumentsOriginal = angular.copy($scope.wholesalerDocuments);
            });
    }

    function loadCustomFields() {
        if ($scope.customFields) return;

        $http.get('/Portfolio/Wholesalers/' + args.ids[0] + '/UserDefinedFields', {trackerMsg: 'Loading custom fields'})
            .then(function (response) {
                var data = response.data;
                $scope.customFields = data.sortBy("name");
                $portfolio.cleanCustomFields($scope.customFields);
                customFieldsOriginal = angular.copy($scope.customFields);
            });
    }


    // PUBLIC METHODS
    $scope.loadTab = function (child) {
        $scope.menu.categories.each(function (c) {
            c.children.each(function (ch) {
                ch.active = ch.code === child.code;
            });
        });

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab();
    };

    $scope.setFullName = function(){
        if (!$scope.wholesalerGeneral.firstName) $scope.wholesalerGeneral.firstName =  '';
        if (!$scope.wholesalerGeneral.lastName) $scope.wholesalerGeneral.lastName = '';

        $scope.wholesalerGeneral.name = $scope.wholesalerGeneral.firstName  + ' ' + $scope.wholesalerGeneral.lastName;
    };

    $scope.save = function () {
        if ($scope.emailInvalid) {
            $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' Email is invalid.', showAllowClose: true });
            return;
        }

        var verboseWholesaler = {};
        var promises = [];

        if ($scope.wholesalerGeneral && (!angular.equals(wholesalerGeneralOriginal, $scope.wholesalerGeneral) )) {
            if ($scope.wholesalerGeneral.dob) {
                $scope.wholesalerGeneral.dob = Date.create($scope.wholesalerGeneral.dob).formatted();
            }

            verboseWholesaler["portfolio"] = $scope.wholesalerGeneral;
        }

        if ($scope.wholesalerNotes && !angular.equals(wholesalerNotesOriginal, $scope.wholesalerNotes)) verboseWholesaler["notes"] = $scope.wholesalerNotes;

        if ($scope.wholesalerDocuments && !angular.equals(wholesalerDocumentsOriginal, $scope.wholesalerDocuments)) verboseWholesaler["documents"] = $scope.wholesalerDocuments;

        if ($scope.customFields && !angular.equals(customFieldsOriginal, $scope.customFields)) {
            var udfs = $scope.customFields.findAll({entity: entities.wholesaler.name});
            if (udfs) {
                verboseWholesaler["userDefinedFields"] = udfs;
            }
        }

        verboseWholesaler["id"] = args.isNew ? 0 : args.ids[0];

        var msg = args.isNew ? 'Adding ' : 'Saving ';
        var verb = args.isNew ? 'POST' : 'PUT';
        var urlSave = args.isNew ? '/Portfolio/Wholesalers/Verbose/' : '/Portfolio/Wholesalers/Verbose/' + args.ids[0];

        promises.push($http({method: verb, url: urlSave, data: verboseWholesaler, trackerMsg: msg + 'wholesaler'}));

        if ($scope.current.viewSSNReason || $scope.current.updateSSN) {
            promises.push($http.put("/Portfolio/Wholesalers/Verbose/" + verboseWholesaler["id"] + "/SSNTaxId", {SSN: $scope.wholesalerGeneral.ssN_TaxID, Reason: $scope.current.viewSSNReason}, {

                trackerMsg: 'Saving SSN/Tax ID'
            }));
        }

        $q.all(promises).then(function (results) {
            var savedData = results[0].data;
            if (args.app) {
                var retUrl = '';
                if (args.app === apps.portfolioLists.name) {
                    retUrl = '/Portfolio/Wholesalers/' + savedData.id;
                }
                $http.get(retUrl, {trackerMsg: 'Refreshing wholesaler'})
                    .then(function (response) {
                        editorHotKeys.destroy();
                        dialog.close(response.data);
                    });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        });
    };

    $scope.close = function (validate) {
        if (validate) {
            if (
                !angular.equals(wholesalerGeneralOriginal, $scope.wholesalerGeneral) ||
                !angular.equals(wholesalerNotesOriginal, $scope.wholesalerNotes) ||
                !angular.equals(wholesalerDocumentsOriginal, $scope.wholesalerDocuments) ||
                !angular.equals(customFieldsOriginal, $scope.customFields)
            ) {
                $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true});
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };

    $scope.unlockSSNField = function (forEdit) {
        if (args.ids[0] > 0 && ( $scope.wholesalerGeneral.ssN_TaxID && $scope.wholesalerGeneral.ssN_TaxID.has('X')) || forEdit) {
            $dialog.inputBox('Reason to ' + (forEdit ? 'Edit' : 'View') + ' the SSN or Tax ID', "Reason", "textarea")
                .open()
                .then(function (rslt) {
                    if (rslt && rslt.trim().length > 0) {
                        var updateSSN = {ssN: null, reason: rslt};
                        $http.put('/Portfolio/Wholesalers/Verbose/' + args.ids[0] + '/SSNTaxId', updateSSN, {trackerMsg: 'Getting SSN/Tax ID information'})
                            .then(function (response) {
                                $scope.wholesalerGeneral.ssN_TaxID = response.data;

                                if (forEdit && !$scope.current.updateSSN) {
                                    $scope.current.viewSSNReason = rslt;
                                    $scope.current.updateSSN = true;
                                }
                            });
                    }
                });
        }
    };

    $scope.addState = function () {
        var list = $scope.wholesalerStates ? $scope.wholesalerStates.map(function (state) {return {id: state.stateId};}) : null;

        $dialog.dialog({templateUrl: "app/modals/available-select.html", controller: "AvailableSelectCtrl", resolve: {availableSelectedArgs: function () {return {selectionType: 1005, selectedSelected: list};}}})
            .open()
            .then(function (rslt) {
                if (!rslt) return;

                rslt.each(function (state) {
                    state.stateName = state.name;
                    state.stateId = state.id;

                    if ($scope.wholesalerStates === null) {
                        $scope.wholesalerStates = [];
                    }

                    if ($scope.wholesalerStates.none({stateId: state.id})) {
                        state.id = 0;
                        $scope.wholesalerStates.push(state);
                    }
                });

                $scope.wholesalerStates.each(function (state) {
                    if (rslt.none({stateId: state.stateId})) {
                        $scope.wholesalerStates.remove(state);
                    }
                });
            });
    };

    $scope.removeState = function (state) {
        $dialog.confirmAction("Are you sure you want to remove <b>" + state.stateName + "</b>?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.wholesalerStates.remove(state);
                }
            });
    };

    $scope.invalidEmail = function (invalid) {
        $scope.emailInvalid = invalid;
    }

    $scope.setEmail = function (value) {
        $scope.wholesalerGeneral.email = value;
    }


    // PUBLIC METHODS - NOTES AND DOCUMENTS
    $scope.syncNewDocument = function (newDocument) {
        wholesalerDocumentsOriginal.push(newDocument);
    };

    $scope.openEditor = function () {
        $portfolio.openEditor(entities.wholesaler.value, [], 'General', 'wholesalerGeneral', apps.portfolioLists.name, null);
    };

    // INITIALIZE
    $scope.current = {
        isNew: args.isNew,
        selectedTab: args.defaultTab,
        wholesalerId: args.ids.length > 1 ? 0 : parseInt(args.ids[0]),
        updateSSN: false,
        viewSSNReason: null,
    };

    $scope.wholesalerGeneral = null;
    $scope.wholesalerNotes = null;
    $scope.wholesalerDocuments = null;
    $scope.customFields = null;

    $scope.errors = [];

    init();
});

'use strict';

app.controller('BusinessLinesListCtrl', function BusinessLinesListCtrl($scope, $http, $oasRights, $portfolio, $dialog, $routeParams, entities, views, apps) {

    //PRIVATE VARIABLES

    // PRIVATE METHODS

    function doAction(actionUrl, msgVerb, confirmMsg) {
        $dialog.confirmAction(confirmMsg)
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.put(actionUrl, $scope.selectedIds, {trackerMsg: msgVerb + ' business line(s)'})
                        .then(function () {
                            refreshGrid();
                        });
                }
            });
    }

    function refreshGrid() {
        $scope.$broadcast('event:portfoliolist-business-lines-action', {action: 'refresh-grid'});
    }


    // PUBLIC METHODS
    $scope.openEditor = function (isNew) {
        if ($scope.selectedIds.length == 1 || isNew) {
            $portfolio.openEditor(entities.businessLine.value, isNew ? [] : $scope.selectedIds, 'General', 'businessLineGeneral', apps.portfolioLists.name)
                .then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:portfoliolist-business-lines-action', {action: isNew ? 'add-item' : 'update-item', item: rslt});
                    }
                });
        }
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:portfoliolist-business-lines-action', {action: 'export-data'});
    };

    $scope.deleteBusinessLine = function () {
        doAction('/portfolio/BusinessLines/action/delete', 'Deleting', 'Delete business line(s).  Are you sure you want to proceed?');
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    };


    // INITIALIZE
    $scope.rightsBL = $oasRights.forCode("BUSINESSLINE");
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {view: views[0], gridDoubleClick: $scope.slickGridDoubleClick};

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    }}];
});

'use strict';

app.controller('BrokerDealersListCtrl', function BrokerDealersListCtrl($scope, $http, $oasRights, $portfolio, $dialog, $routeParams, entities, views, apps){

    //PRIVATE VARIABLES

    // PRIVATE METHODS
    function doAction(actionUrl, msgVerb, confirmMsg) {
        $dialog.confirmAction(confirmMsg )
            .open()
            .then(function(result){
                if (result === 'yes') {
                    $http.put(actionUrl, $scope.selectedIds, {trackerMsg: msgVerb + ' broker/dealer(s)' })
                        .then(function () {
                            refreshGrid();
                        });
                }
            });
    }
    function refreshGrid( ) {
        $scope.$broadcast('event:portfoliolist-brokerdealers-action', {action: 'refresh-grid'});
    }

    // METHODS
    $scope.openEditor = function(isNew) {
        if( $scope.selectedIds.length == 1 || isNew ) {
            $portfolio.openEditor(entities.brokerDealer.value, isNew ? [] : $scope.selectedIds, 'General', 'brokerdealerGeneral', apps.portfolioLists.name).then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast( 'event:portfoliolist-brokerdealers-action', {action: isNew ? 'add-item' : 'update-item', item: rslt } );
                }
            });
        }
    };

    $scope.deleteBrokerDealer = function() {
        doAction('/portfolio/BrokerDealers/action/delete', 'Deleting', 'Delete broker/dealer(s).  Are you sure you want to proceed?');
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:portfoliolist-brokerdealers-action', {action: 'export-data'});
    };


    $scope.recalculateAUM = function() {
        $http.put('/portfolio/brokerdealers/action/recalculateaumdata',{},{trackerMsg: 'Update representative AUM'})
            .then(function(){
                refreshGrid();
            })
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    };


    // INTIALIZE
    $scope.rightsBD = $oasRights.forCode( "BROKERDEALERS" );
    $scope.rightsRS = $oasRights.forCode( "BROKERDEALERREVENUESHARES" );
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: '/Portfolio/BrokerDealers'
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    }}];

});

'use strict';

app.controller('RepresentativesListCtrl', function RepresentativesListCtrl($scope, $http, $oasRights, $portfolio, $dialog, $routeParams, entities, views, apps){

    //PRIVATE VARIABLES

    // PRIVATE METHODS

    function init() {
        $scope.current.url = `/Portfolio/Representatives?brokerDealerId=${$routeParams.brokerDealerId}&riaId=${$routeParams.riaId}`
    }

    function doAction(actionUrl, msgVerb, confirmMsg) {
        $dialog.confirmAction(confirmMsg )
            .open()
            .then(function(result){
                if (result === 'yes') {
                    $http.post(actionUrl, $scope.selectedIds, {trackerMsg: msgVerb + ' representative(s)' })
                        .then(function(response){
                            $scope.selectedIds = response.data;
                            repValidation();
                        })
                        .then(function () {
                            refreshGrid();
                        });
                }
            });
    }

    function repValidation() {
        if ($scope.selectedIds.indexOf(parseInt("-9")) !== -1) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Unable to delete Representative(s)", "One or more reps cannot be deleted due to having at least one household assigned to it. Please assign all households to another rep before deleting.")
            .open();
        }
    }

    function refreshGrid( ) {
        $scope.$broadcast('event:portfoliolist-representatives-action', {action: 'refresh-grid'});
    }

    // METHODS
    $scope.openEditor = function(isNew) {
        if( $scope.selectedIds.length == 1 || isNew ) {
            $portfolio.openEditor(entities.representative.value, isNew ? [] : $scope.selectedIds, 'General', 'representativeGeneral', apps.portfolioLists.name).then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast( 'event:portfoliolist-representatives-action', {action: isNew ? 'add-item' : 'update-item', item: rslt } );
                }
            });
        }
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:portfoliolist-representatives-action', {action: 'export-data'});
    };

    $scope.deleteRep = function() {
        doAction('/portfolio/Representatives/action/delete', 'Deleting', 'Delete representative(s).  Are you sure you want to proceed?');
    };

    $scope.goToEntities = function( urlLevel ) {
        $portfolio.goTo( urlLevel, entities.representative.value, $scope.selectedIds[0] );
    };

    $scope.recalculateAUM = function() {
        $http.put('/portfolio/representatives/action/recalculateaumdata',{},{trackerMsg: 'Update representative AUM'})
            .then(function(){
                refreshGrid();
            })
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    };


    // INITIALIZE
    $scope.rightsRep = $oasRights.forCode( "REPS" );
    $scope.rightsPortfolioAudit = $oasRights.forCode("PORTFOLIOLISTSAPP");
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: '/Portfolio/Representatives'
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    }}];

    init();
});
'use strict';

app.controller('SubAdvisorsListCtrl', function SubAdvisorsListCtrl($scope, $http, $oasRights, $portfolio, $dialog, $routeParams, entities, views, apps) {

    //PRIVATE VARIABLES

    // PRIVATE METHODS
    function doAction(actionUrl, msgVerb, confirmMsg) {
        $dialog.confirmAction(confirmMsg)
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.put(actionUrl, $scope.selectedIds, {trackerMsg: msgVerb + ' sub-advisor(s)'})
                        .then(function () {
                            refreshGrid();
                        });
                }
            });
    }

    function refreshGrid() {
        $scope.$broadcast('event:portfoliolist-subadvisors-action', {action: 'refresh-grid'});
    }


    // PUBLIC METHODS
    $scope.openEditor = function (isNew) {
        if ($scope.selectedIds.length == 1 || isNew) {
            $portfolio.openEditor(entities.subAdvisor.value, isNew ? [] : $scope.selectedIds, 'General', 'subAdvisorGeneral', apps.portfolioLists.name)
                .then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:portfoliolist-subadvisors-action', {action: isNew ? 'add-item' : 'update-item', item: rslt});
                    }
                });
        }
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:portfoliolist-subadvisors-action', {action: 'export-data'});
    };

    $scope.deleteSubAdvisor = function () {
        doAction('/portfolio/SubAdvisors/action/delete', 'Deleting', 'Delete sub-advisor(s).  Are you sure you want to proceed?');
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    };


    // INITIALIZE
    $scope.rightsSA = $oasRights.forCode("SUBADVISORS");
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {view: views[0], gridDoubleClick: $scope.slickGridDoubleClick};

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    }}];
});
'use strict';

app.controller('WholesalersListCtrl', function WholesalersListCtrl($scope, $http, $oasRights, $portfolio, $dialog, $routeParams, entities, views, apps) {

    //PRIVATE VARIABLES

    // PRIVATE METHODS
    function doAction(actionUrl, msgVerb, confirmMsg) {
        $dialog.confirmAction(confirmMsg)
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.put(actionUrl, $scope.selectedIds, {trackerMsg: msgVerb + ' wholesaler(s)'})
                        .then(function () {
                            refreshGrid();
                        });
                }
            });
    }

    function refreshGrid() {
        $scope.$broadcast('event:portfoliolist-wholesaler-action', {action: 'refresh-grid'});
    }


    // PUBLIC METHODS
    $scope.openEditor = function (isNew) {
        if ($scope.selectedIds.length === 1 || isNew) {
            $portfolio.openEditor(entities.wholesaler.value, isNew ? [] : $scope.selectedIds, 'General', 'wholesalerGeneral', apps.portfolioLists.name)
                .then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:portfoliolist-wholesaler-action', {action: isNew ? 'add-item' : 'update-item', item: rslt});
                    }
                });
        }
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:portfoliolist-wholesaler-action', {action: 'export-data'});
    };

    $scope.deleteWholesaler = function () {
        doAction('/portfolio/Wholesalers/action/delete', 'Deleting', 'Delete wholesaler(s).  Are you sure you want to proceed?');
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    };


    // INITIALIZE
    $scope.rightsWholesaler = $oasRights.forCode("WHOLESALERS");
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {view: views[0], gridDoubleClick: $scope.slickGridDoubleClick};

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    }}];
});

'use strict';

app.controller('RIAsListCtrl', function RIAsListCtrl($scope, $http, $oasRights, $portfolio, $dialog, entities, views, apps) {

    //PRIVATE VARIABLES

    // PRIVATE METHODS

    function doAction( actionUrl, msgVerb, confirmMsg ) {
        $dialog.confirmAction(confirmMsg)
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.put(actionUrl, $scope.selectedIds, {trackerMsg: msgVerb + ' RIA(s)'})
                        .then(function () {
                            refreshGrid();
                        });
                }
            });
    }

    function refreshGrid( ) {
        $scope.$broadcast('event:portfoliolist-rias-action', {action: 'refresh-grid'});
    }


    // PUBLIC METHODS
    $scope.openEditor = function( isNew ) {
        if($scope.selectedIds.length == 1 || isNew) {
            $portfolio.openEditor(entities.ria.value, isNew ? [] : $scope.selectedIds, 'General', 'riaGeneral', apps.portfolioLists.name)
                .then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:portfoliolist-rias-action', {action: isNew ? 'add-item' : 'update-item', item: rslt});
                    }
                });
        }
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast('event:portfoliolist-rias-action', {action: 'export-data'});
    };

    $scope.deleteRIA = function( ) {
        doAction('/portfolio/rias/action/delete', 'Deleting', 'Delete RIA(s).  Are you sure you want to proceed?');
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    };


    // INITIALIZE
    $scope.rightsRia = $oasRights.forCode("RIAS");
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {view: views[0], gridDoubleClick: $scope.slickGridDoubleClick};

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    }}];
});
'use strict';

app.controller( 'RIAEditCtrl', function RIAEditCtrl( $scope, $http, $oasRights, $dialog, $timeout, dialog, args, apps, billingStyle) {

    // PRIVATE VARIABLES
    var riaGeneralOriginal = null;
    var editorHotKeys;


    // PRIVATE METHODS - INIT
    function init() {
        loadRights();
        buildMenu();
        loadHotKeys();
        $scope.loadTab( args.defaultTab );
    }

    function loadRights() {
        $scope.rightsRia = $oasRights.forCode( "RIAS" );
    }

    function buildMenu() {
        var i = 0;
        $scope.menu = { categories: [ ] };
        $scope.menu.categories.push( {name: 'RIA', children: [] } );
        $scope.menu.categories[i].children.push( {name: 'General', active: false, code: 'riaGeneral'} );
    }

    function loadDataForSelectedTab() {
        switch( $scope.current.selectedTab ) {
            case "riaGeneral":
                if( $scope.rightsRia.canRead ) {
                    loadRIA( );
                    loadRIALookups( );
                }
                break;
        }
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: function() { $scope.close(true); } }
            ]);
        });
    }


    // PRIVATE METHODS - LOAD RIA
    function loadRIA() {
        if( $scope.riaGeneral == null ) {
            if (args.isNew){
                $scope.riaGeneral = {
                    "id": 0,
                    "name": null,
                    "isActive": true,
                    "description": null,
                    "fiscalStartDate": "1/1",
                    "fiscalEndDate": "12/31",
                    "payeeId": 0,
                    "billingStyle": 0,
                    "isSolicitor": true,
                    "isDefault": true,
                    "importKey": null,
                    "createdBy": null,
                    "createdDate": null,
                    "editedBy": null,
                    "editedDate": null,
                    "firstName": null,
                    "lastName": null,
                    "entityName": null,
                    "email": null,
                    "city": null,
                    "state": null,
                    "salutation": null,
                    "address1": null,
                    "address2": null,
                    "address3": null,
                    "zip": null,
                    "fax": null,
                    "faxExt": null,
                    "mobilePhone": null,
                    "businessPhone": null,
                    "businessPhoneExt": null,
                    "otherPhone": null,
                    "otherPhoneExt": null,
                    "company": null,
                    "jobTitle": null,
                    "webAddress": null
                };
                riaGeneralOriginal = angular.copy($scope.riaGeneral);
            } else {
                $http.get( "/Portfolio/Rias/" + args.ids[0], {trackerMsg: 'Loading RIA'} )
                    .then( function( response ) {
                        $scope.riaGeneral = response.data;
                        riaGeneralOriginal = angular.copy($scope.riaGeneral);
                    });
            }
        }
    }

    function loadRIALookups( ){
        $http.get("/Billing/Payees", {cache: true, trackerMsg: 'Loading payees'})
            .then(function (response) {
                response.data.unshift({id: 0, name : '(None)'});
                $scope.payees = response.data;
            });

        if ($scope.billStyle === null){
            $scope.billStyle = [];
            billingStyle.keys().forEach(function(key) {
                $scope.billStyle.push({id: parseInt(billingStyle[key].value), name: billingStyle[key].name})
            });
        }
    }


    // PUBLIC METHODS
    $scope.loadTab = function( child ) {
        $scope.menu.categories.each( function( c ) {
            c.children.each( function( ch ) {
                ch.active = ch.code == child.code;
            } );
        } );

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab();
    };

    $scope.save = function() {
        if ($scope.emailInvalid) {
            $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' Email address is invalid.', showAllowClose: true });
            return;
        }

        var msg = args.isNew ? 'Adding ' : 'Saving ';
        var verb = args.isNew ? 'POST' : 'PUT';
        var urlSave = args.isNew ? '/Portfolio/Rias' : '/Portfolio/Rias/' + args.ids[0];

        $http( { method: verb, url: urlSave, data: $scope.riaGeneral, trackerMsg: msg + 'RIA' } ).then( function( response ) {
            if( args.app ) {
                var retUrl = '';
                if (args.app == apps.portfolioLists.name) {
                    retUrl = '/Portfolio/Rias/' + response.data.id;
                }
                $http.get(retUrl, {trackerMsg: 'Refreshing RIA'})
                    .then(function (innerResponse) {
                        editorHotKeys.destroy();
                        dialog.close(innerResponse.data);
                    });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        });
    };

    $scope.close = function( validate ) {
        if( validate ) {
            if(
                !angular.equals( riaGeneralOriginal, $scope.riaGeneral )
            ) {
                $scope.errors.push( { type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true } );
            } else {
                editorHotKeys.destroy();
                dialog.close( null );
            }

        } else {
            editorHotKeys.destroy();
            dialog.close( null );
        }
    };

    $scope.invalidEmail = function (invalid) {
        $scope.emailInvalid = invalid;
    }

    $scope.setEmail = function (value) {
        $scope.riaGeneral.email = value;
    }

    $scope.current = {
        isNew : args.isNew,
        selectedTab: args.defaultTab
    };


    $scope.riaGeneral = null;
    $scope.payees = null;
    $scope.billStyle = null;
    $scope.errors = [];

    init();
} );
'use strict';

app.controller('PlanAdministratorsListCtrl', function PlanAdministratorsListCtrl($scope, $http, $oasRights, $portfolio, $dialog, entities, views, apps) {

    //PRIVATE VARIABLES

    // PRIVATE METHODS
    function refreshGrid( ) {
        $scope.$broadcast('event:portfoliolist-pas-action', {action: 'refresh-grid'});
    }


    // PUBLIC METHODS
    $scope.openEditor = function( isNew ) {
        if($scope.selectedIds.length == 1 || isNew) {
            $portfolio.openEditor(entities.thirdPartyAdministrator.value, isNew ? [] : $scope.selectedIds, 'General', 'paGeneral', apps.portfolioLists.name)
                .then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:portfoliolist-pa-action', {action: isNew ? 'add-item' : 'update-item', item: rslt});
                    }
                });
        }
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast('event:portfoliolist-pa-action', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    };


    // INITIALIZE
    $scope.rightsPlan = $oasRights.forCode("401KPLAN");
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view: views[0],
        url: "/portfolio/planadministrators",
        gridDoubleClick: $scope.slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
            if($scope.selectedIds.length === 1)
                $scope.openEditor(false);
        }}];
});
'use strict';

app.controller( 'PlanAdministratorEditCtrl', function PlanAdministratorEditCtrl( $scope, $http, $oasRights, $dialog, $timeout, dialog, args, apps) {

    // PRIVATE VARIABLES
    var paGeneralOriginal = null;
    var editorHotKeys;


    // PRIVATE METHODS - INIT
    function init() {
        loadRights();
        buildMenu();
        loadHotKeys();
        $scope.loadTab( args.defaultTab );
    }

    function loadRights() {
        $scope.rightsPlan = $oasRights.forCode( "401KPLAN" );
    }

    function buildMenu() {
        var i = 0;
        $scope.menu = { categories: [ ] };
        $scope.menu.categories.push( {name: 'Plan Administrator', children: [] } );
        $scope.menu.categories[i].children.push( {name: 'General', active: false, code: 'paGeneral'} );
    }

    function loadDataForSelectedTab() {
        switch( $scope.current.selectedTab ) {
            case "paGeneral":
                if( $scope.rightsPlan.canRead ) {
                    loadPlanAdministrator( );
                    //loadPaLookups( );
                }
                break;
        }
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: function() { $scope.close(true); } }
            ]);
        });
    }


    // PRIVATE METHODS - LOAD RIA
    function loadPlanAdministrator() {
        if( $scope.paGeneral == null ) {
            if (args.isNew){
                $scope.paGeneral = {
                    "id": 0,
                    "entityName": null,
                    "adminNumber": null,
                    "contact": null,
                    "agreementSigned": null,
                    "importKey": null,
                    "firstName": null,
                    "lastName": null,
                    "email": null,
                    "city": null,
                    "state": null,
                    "salutation": null,
                    "address1": null,
                    "address2": null,
                    "address3": null,
                    "zip": null,
                    "fax": null,
                    "faxExt": null,
                    "mobilePhone": null,
                    "businessPhone": null,
                    "businessPhoneExt": null,
                    "otherPhone": null,
                    "otherPhoneExt": null,
                    "company": null,
                    "jobTitle": null,
                    "webAddress": null
                };
                paGeneralOriginal = angular.copy($scope.paGeneral);
            } else {
                $http.get( "/Portfolio/PlanAdministrators/" + args.ids[0], {trackerMsg: 'Loading Plan Administrator'} )
                    .then( function( response ) {
                        $scope.paGeneral = response.data;
                        paGeneralOriginal = angular.copy($scope.paGeneral);
                    });
            }
        }
    }

    // PUBLIC METHODS
    $scope.loadTab = function( child ) {
        $scope.menu.categories.each( function( c ) {
            c.children.each( function( ch ) {
                ch.active = ch.code == child.code;
            } );
        } );

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab();
    };

    $scope.save = function() {
        if ($scope.emailInvalid) {
            $scope.errors.push( { type: 'error', title: 'Unsaved Changes! ', msg: ' Email is invalid.', showAllowClose: true } );
            return;
        }

        var msg = args.isNew ? 'Adding ' : 'Saving ';
        var verb = args.isNew ? 'POST' : 'PUT';
        var urlSave = args.isNew ? '/portfolio/planadministrators' : '/portfolio/planadministrators/' + args.ids[0];

        $http( { method: verb, url: urlSave, data: $scope.paGeneral, trackerMsg: msg + 'Plan Administrator' } )
            .then( function( response ) {
            if( args.app ) {
                var retUrl = '';
                if (args.app == apps.portfolioLists.name) {
                    retUrl = '/portfolio/planadministrators/' + response.data.id;
                }
                $http.get(retUrl, {trackerMsg: 'Refreshing Plan Administrator'})
                    .then(function (response2) {
                        editorHotKeys.destroy();
                        dialog.close(response2.data);
                    });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        });
    };

    $scope.close = function( validate ) {
        if( validate ) {
            if(
                !angular.equals( paGeneralOriginal, $scope.paGeneral )
            ) {
                $scope.errors.push( { type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true } );
            } else {
                editorHotKeys.destroy();
                dialog.close( null );
            }

        } else {
            editorHotKeys.destroy();
            dialog.close( null );
        }
    };

    $scope.invalidEmail = function (invalid) {
        $scope.emailInvalid = invalid;
    }

    $scope.setEmail = function (value) {
        $scope.paGeneral.email = value;
    }

    $scope.current = {
        isNew : args.isNew,
        selectedTab: args.defaultTab
    };


    $scope.paGeneral = null;
    //$scope.payees = null;
    //$scope.billStyle = null;
    $scope.errors = [];

    init();
} );
'use strict';

app.controller('ManageDownloadsCtrl', function ManageDownloadsCtrl($scope, dialog, reportLinksData, rmdMailMergeData,rmdMailMergeTemplateData) {
    // PUBLIC METHODS
    $scope.close = function() {
        dialog.close();
    };

    $scope.downloadMergeTemplate = function(fileId) {
        rmdMailMergeTemplateData.downloadFile(fileId);
    };

    $scope.downloadFile = function(fileId) {
        if ($scope.current.isMailMerge){
            rmdMailMergeData.downloadFile(fileId);
        }
        else {
            reportLinksData.downloadFile(fileId);
        }
    };

    $scope.deleteFile = function( fileId ) {
        if ($scope.current.isMailMerge){
            rmdMailMergeData.deleteFile(fileId);
        } else {
            reportLinksData.deleteFile(fileId);
        }

    };

    function init(){
        if ($scope.current.isMailMerge){
            $scope.current.additionalData.blobType = 'RMDMailMerge';
            $scope.myTemplates =  rmdMailMergeData.files;
            $scope.standardTemplates =  rmdMailMergeTemplateData.files;
        }else{
            $scope.downloads = reportLinksData.files;
        }
    }

    //INITIALIZE
    $scope.current = {
        returnData : null,
        categories : [],
        additionalData : { blobDesc : null, category : 'Report Links', blobType : 'RMDDashboard', openWith : null},
        isForm : dialog.options.uploadType === "Forms" ? true : false,
        isMailMerge : dialog.options.uploadType === "MailMerge" ? true : false
    };

    init();



    //SCOPE WATCHERS
    $scope.$watch('current.returnData', function(newValue, oldValue) {
        if (newValue == oldValue || $scope.current.returnData === null) return;

        if ($scope.current.isMailMerge){
            rmdMailMergeData.loadList();
            rmdMailMergeTemplateData.loadList();
        }else {
          reportLinksData.loadList();
        }
        $scope.current.returnData = null;
    });
});

'use strict';

app.service('reportLinksData', function reportLinksData($http, API_CONFIG, $q) {
    var self = this;
    var internal = {files: {list: []}};

    //PRIVATE METHODS
    function init() {
        self.loadList();
    }


    //PUBLIC API
    self.files = internal.files;

    self.downloadFile = function(fileId) {
        window.location.href = API_CONFIG.baseUrl + '/Reporting/StaticFiles/RMDDashboard/' + fileId + '?Authorization=' + sessionStorage.oas_token;
    };

    self.loadList = function() {
        $http.get('/Reporting/StaticFiles/RMDDashboard', {trackerMsg: 'Loading available downloads'})
            .then(function(response) {
                internal.files.list = response.data;
            });
    };

    self.deleteFile = function(fileId) {
        $http.delete('/Reporting/StaticFiles/RMDDashboard/' + fileId, {trackerMsg: 'Deleting file', headers: {Unmasquerade: "true"}})
            .then(function() {
                internal.files.list.remove({id: fileId});
            });
    };


    //INITIALIZE
    init();
});

app.service('rmdMailMergeData', function rmdMailMergeData($http, API_CONFIG) {
    var self = this;
    var internal = {files: {list: []}};

    //PRIVATE METHODS
    function init() {
        self.loadList();
    }


    //PUBLIC API
    self.files = internal.files;

    self.downloadFile = function(fileId) {
        window.location.href = API_CONFIG.baseUrl + '/Reporting/StaticFiles/RMDMailMerge/' + fileId + '?Authorization=' + sessionStorage.oas_token;
    };


    self.loadList = function() {
        $http.get('/Reporting/StaticFiles/RMDMailMerge', {trackerMsg: 'Loading available merge documents'})
            .then(function(response) {
                internal.files.list = response.data;
            });
    };

    self.deleteFile = function(fileId) {
        $http.delete('/Reporting/StaticFiles/RMDMailMerge/' + fileId, {trackerMsg: 'Deleting file', headers: {Unmasquerade: "true"}})
            .then(function() {
                internal.files.list.remove({id: fileId});
            });
    };


    //INITIALIZE
    init();
});

app.service('rmdMailMergeTemplateData', function rmdMailMergeData($http, API_CONFIG) {
    var self = this;
    var internal = {files: {list: []}};

    //PRIVATE METHODS
    function init() {
        self.loadList();
    }


    //PUBLIC API
    self.files = internal.files;

    self.downloadFile = function(fileId) {
        window.location.href = API_CONFIG.baseUrl + '/Reporting/StaticFiles/RMDMailMergeTemplate/' + fileId + '?Authorization=' + sessionStorage.oas_token;
    };


    self.loadList = function() {
        $http.get('/Reporting/StaticFiles/RMDMailMergeTemplate', {trackerMsg: 'Loading available merge template documents'})
            .then(function(response) {
                internal.files.list = response.data;
            });
    };

    //INITIALIZE
    init();
});
'use strict';

app.controller('OfacImportCtrl', function OfacImportCtrl($scope, $http, privilegeService, views, $timeout, $dialog) {
    // PRIVATE VARIABLES
    let newStatusForAll;


    // PUBLIC METHODS
    $scope.markAll = function (newStatus) {
        $dialog.confirmAction("This will affect all rows in the grid.  Are you sure you want to proceed?").open()
            .then(function (result) {
                if (result !== 'yes') {
                    return;
                }

                newStatusForAll = newStatus;
                $scope.$broadcast('event:ofac-check-action', {action: 'get-items'});
            });
    };

    $scope.delayedRefreshGrid = function () {
        $timeout(function () {
            $scope.refreshGrid();
        });
    };

    $scope.refreshGrid = function () {
        $scope.$broadcast('event:ofac-check-action', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:ofac-check-action', {action: 'export-data'});
    };

    $scope.importData = function () {
        $http.get('/Portfolio/OfacFiles/DownloadOfacFiles', {trackerMsg: 'Importing OFAC data'})
            .then(function () {
                $dialog.messageBox("Import successful", "The OFAC data has been updated from treasury.gov.  Your registrations will be rescanned for possible matches this evening.  Check back tomorrow to review.").open();
            });
    };


    // EVENT LISTENERS
    $scope.$on('slickgrid-getitems', function (event, data) {
        const allIds = data.map('id');

        $http.put(`/Portfolio/OfacChecks/Actions/SetStatus?status=${newStatusForAll}`, allIds, {trackerMsg: 'Updating all rows'})
            .then(function () {
                $scope.$broadcast('event:ofac-check-action', {action: 'refresh-grid'});
            });
    });


    // INITIALIZE
    $scope.ofacPrivilege = privilegeService.get('oFAC');
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {
        view: views[0],
        status: 'NeedsReview'
    };
});


'use strict';

app.controller('GeminiFundListCtrl', function GeminiFundListCtrl($scope, $http, $oasRights, $portfolio, $dialog, $routeParams, entities, views, $location){

    // PRIVATE METHODS
    function refreshGrid( ) {
        $scope.$broadcast('event:advisor-geminifund-action', {action: 'refresh-grid'});
    }

    // METHODS
    $scope.openEditor = function(isNew) {
        if (isNew){
            $location.path("/advisor/geminifund/0");
        } else {
            $location.path("/advisor/geminifund/" + $scope.selectedIds[0]);
        }
    };


    $scope.exportToExcel = function() {
        $scope.$broadcast('event:advisor-geminifund-action', {action: 'export-data'});
    };

    $scope.deleteFund = function(id){
        $dialog.confirmAction("Are you sure you want to remove this fund record?")
            .open()
            .then(function(result){
                if (result === 'yes') {
                    $http.delete('/Reporting/FundPerformance/GeminiFund/' + id, {trackerMsg: 'Deleting fund ' + id})
                        .then(function(){
                            $scope.current.view.filters = [];
                            $scope.$broadcast('event:advisor-geminifund-action', {action: 'refresh-grid'});
                        });
                }
            });
    };

    // INTIALIZE
    $scope.selectedIds = [];
    $scope.rightsGeminiFund = $oasRights.forCode( "GEMINIFUNDAPP" );
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        url: '/Reporting/FundPerformance/GeminiFund'
    };


});

'use strict';

var geminiFundDataListCtrl = app.controller('GeminiFundDataListCtrl', function GeminiFundDataListCtrl($scope, $http, $timeout, $oasRights, $dialog, $routeParams,  views, dates, $location, $advisor){

    // PRIVATE METHODS
    function init(){
        search('Select Fund');
    }

    function search (  title ) {
        var dialogOpts = {
            backdrop : true,
            keyboard : true,
            backdropClick : true,
            templateUrl : 'advisor/modals/select-fund.html',
            controller : 'SelectFundCtrl',
            title : title ? title : null
        };

        var d = $dialog.dialog(dialogOpts);
        return d.open().then(function(rslt) {
            if( rslt ) {
                $scope.current.fundKey = rslt.fundKey;
                $scope.current.url = '/Reporting/FundPerformance/GeminiFund/Data';

                $timeout(function () {
                    $scope.refreshGrid();
                });
            }
        });
    };


    $scope.refreshGrid = function( ) {
        dates.startDate.value = $scope.current.filterStartDate;
        dates.endDate.value = $scope.current.filterEndDate;

        $http.post('/Settings/UserOptions/funddata_list_start_date', dates.startDate ).then(function( response ) {
            dates.startDate.id = response.data.id;
        });
        $http.post('/Settings/UserOptions/funddata_list_end_date', dates.endDate ).then(function( response ) {
            dates.endDate.id = response.data.id;
        });

        $timeout(function(){
            $scope.$broadcast('event:advisor-geminifunddata-action', {action: 'refresh-grid'});
        });

    };

    // METHODS
    $scope.openEditor = function(isNew) {
        if (isNew){
            $location.path("/advisor/geminifunddata/"+ ($scope.current.fundKey ? $scope.current.fundKey : $scope.current.id) + "/0");
        } else {
            $location.path("/advisor/geminifunddata/" + $scope.current.id + "/" +   $scope.current.rateDate);
        }
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:advisor-geminifunddata-action', {action: 'export-data'});
    };

    $scope.selectFund = function(){
        $advisor.searchFund().then(function(rslt){
            $scope.current.fundKey = rslt.fundKey;
            $timeout(function () {
                $scope.refreshGrid();
            });
        })

    };

    //EVENT LISTENERS
    $scope.$on("event:advisor-geminifunddata-select", function(e, args){
        if (args.length === 0) return;
        $scope.current.id = args[0].fundKey;
        $scope.current.rateDate = args[0].rateDate;
    });

    // INTIALIZE
    $scope.rightsGeminiFund = $oasRights.forCode( "GEMINIFUNDAPP" );
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        filterStartDate: Date.create(Date.create('today').getFullYear(), 0,1),
        filterEndDate :  Date.create('today'),
        fundKey : null
    };

    init();

});

geminiFundDataListCtrl.loadFundDataListDates = ["$http","$q", function( $http, $q ) {

    var loadPromises = [];
    loadPromises.push( $http.get('/Settings/UserOptions/funddata_list_start_date?defaultValue=last year', {trackerMsg: 'Loading default start date' } ) );
    loadPromises.push( $http.get('/Settings/UserOptions/funddata_list_end_date?defaultValue=last year', {trackerMsg: 'Loading default end date' } ) );

    return $q.all(loadPromises).then(function(results) {
        return { startDate : results[0].data, endDate : results[1].data };
    });

}];

'use strict';

var geminiFundDivDetailListCtrl = app.controller('GeminiFundDivDetailListCtrl', function GeminiFundDivDetailListCtrl($scope, $http, $timeout, $oasRights, $portfolio, $dialog, $routeParams, entities, views,  dates, $location,$advisor){

    // PRIVATE METHODS
    function init(){
        search('Select Fund');
    }

    function search (  title ) {
        var dialogOpts = {
            backdrop : true,
            keyboard : true,
            backdropClick : true,
            templateUrl : 'advisor/modals/select-fund.html',
            controller : 'SelectFundCtrl',
            title : title ? title : null
        };

        var d = $dialog.dialog(dialogOpts);
        return d.open().then(function(rslt) {
            if( rslt ) {
                $scope.current.fundKey = rslt.fundKey;
                $scope.current.url = '/Reporting/FundPerformance/GeminiFund/DivDetail';

                $timeout(function () {
                    $scope.refreshGrid();
                });
            }
        });
    };


    $scope.refreshGrid = function( ) {
        dates.startDate.value = Date.create('1/1/1900').formatted();
        dates.endDate.value = Date.create('today').formatted();


        $timeout(function(){
            $scope.$broadcast('event:advisor-geminifunddivdetail-action', {action: 'refresh-grid'});
        });

    };

    // METHODS
    $scope.openEditor = function(isNew) {
        if (isNew){
            $location.path("/advisor/geminifunddivdetail/" + ($scope.current.fundKey ? $scope.current.fundKey : $scope.current.id) + "/0/" + isNew);
        } else {
            $location.path("/advisor/geminifunddivdetail/" + $scope.current.id + "/" + $scope.current.rateDate + "/" + isNew);
        }
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:advisor-geminifunddivdetail-action', {action: 'export-data'});
    };

    $scope.selectFund = function(){
        $advisor.searchFund().then(function(rslt){
            $scope.current.fundKey = rslt.fundKey;
            $timeout(function () {
                $scope.refreshGrid();
            });
        })

    };

    //EVENT LISTENERS
    $scope.$on("event:advisor-geminifunddivdetail-select", function(e, args){
        if (args.length === 0) return;
        $scope.current.id = args[0].fundKey;
        $scope.current.rateDate = args[0].rateDate;
    });

    // INTIALIZE
    $scope.rightsGeminiFund = $oasRights.forCode( "GEMINIFUNDAPP" );
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        filterStartDate: Date.create('1/1/1900'),
        filterEndDate :  Date.create('today'),
        fundKey : null
    };

    init();

});

geminiFundDivDetailListCtrl.loadFundDivDetailListDates = ["$http","$q", function( $http, $q ) {

    var loadPromises = [];
    loadPromises.push( $http.get('/Settings/UserOptions/funddivdetail_list_start_date?defaultValue=last year', {trackerMsg: 'Loading default start date' } ) );
    loadPromises.push( $http.get('/Settings/UserOptions/funddivdetail_list_end_date?defaultValue=last year', {trackerMsg: 'Loading default end date' } ) );

    return $q.all(loadPromises).then(function(results) {
        return { startDate : results[0].data, endDate : results[1].data };
    });

}];

'use strict';

app.controller('SelectFundCtrl', function SelectFundCtrl($scope, dialog, $http, entities, $dialog, $settings) {
    // PRIVATE METHODS
    function init(){
        $scope.current.selectedFund = $settings.getSetting('selectedGeminiFundKey');
    }


    // PUBLIC METHODS
    $scope.cancel = function( ) {
        dialog.close( null );
    };

    $scope.close = function( ) {
        if ($scope.current.selectedFund){
            $settings.setSetting( 'selectedGeminiFundKey', $scope.current.selectedFund );

            dialog.close
            ({
                fundKey: $scope.current.selectedFund.id,
                indexNumber : $scope.current.indexNumber,
                forYear : $scope.current.forYear,
                divYear : $scope.current.divYear,
                asOfDate : $scope.current.asOfDate
            });
        }
    };

    $scope.searchFund = function(search){
        $dialog.search("geminifunds", "Search Funds")
            .open()
            .then(function (result) {
                if (result) {
                    $scope.funds = result;
                }
            });
    };

    //INITIALIZE
    $scope.current = {
        title : dialog.options.title ? dialog.options.title : 'Find',
        indexNumber : dialog.options.indexNumber ? dialog.options.indexNumber : '',
        hasIndexNumber : dialog.options.hasIndexNumber ? true : false,
        hasForYear : dialog.options.hasForYear ? true : false,
        hasDivYear : dialog.options.hasDivYear ? true: false,
        hasAsOfDate : dialog.options.hasAsOfDate ? true: false,
        forYear : 1,
        divYear : 2000,
        asOfDate : null,
        selectOptions : null,
        fundKey: null,
        selectedFund : null
    };

    $scope.funds = null;

   init();

});

'use strict';

app.controller('ImportFilesCtrl', function ImportFilesCtrl( $scope, $oasRights, views, $location, $timeout ) {

    //PRIVATE FUNCTIONS
    function init(){
        $scope.rightsImportFiles = $oasRights.forCode("BLOBIMPORT");
    }

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:import-files-action', {action: 'export-data'});
    };

    $scope.openWizard = function(){
        $location.url('/tools/fileimportwizard');
    };

    $scope.slickGridDoubleClick = function(){
        if($scope.selectedIds.length === 1){
            $timeout(function () {
                $location.url('/tools/filelist/' + $scope.current.instanceId);
            });
        }
    };

    //INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        url : '/FileImport/Instance/List',
        gridDoubleClick: $scope.slickGridDoubleClick,
        instanceId: 0
    };
    init();

    //EVENT LISTENERS
    $scope.$on("event:import-files-select", function(e, args){
       if (args.length === 0) return;

       $scope.current.instanceId = args[0].id;
    });
});
'use strict';

app.controller('ImportFilesWizardCtrl', function ImportFilesWizardCtrl($scope, $http, $dialog, $oasRights, $upload, $q, $timeout, API_CONFIG, $window, entities, splitIoService){
    // PRIVATE VARIABLES
    var fileImportMethod = {
        onlyImportExistingFiles : 1, // mapped to isSkipExisting = false, isOverwrite = true
        importAllOverwritingExisting: 2, // mapped to isSkipExisting = false, isOverwrite = false
        importAllSkipExisting: 3 // mapped to isSkipExisting = true, isOverwrite = false
    };

    var successCount = 0;
    var failedCount = 0;
    var emailSent = 0;
    var customFields;
    var fileImportResponse = null;
    var fileLogResults = [];

    // PRIVATE METHODS
    function init(){
        if (!$oasRights.canRead('BLOBIMPORT')) return;
        $scope.current.fileType = $scope.fileTypes[0];
        loadRights();

        $http.get('/Settings/UserOptions/file_upload_custom_fields', {trackerMsg: 'Loading custom fields'})
            .then(function(res){
                customFields = res.data;
                customFields.value = JSON.parse(customFields.value) || [];

                $scope.current.customFields = customFields.value;
                $scope.current.customFields.unshift({name: 'Select Custom ...', field: 'None'});
            });
    }

    function loadRights() {
        $scope.rightsBlobImport = $oasRights.forCode("BLOBIMPORT");
    }

    function getFilePiecesForIndicator(columnIndicator, onlyGetInUsePiecesByNamingConv){
        var filePieces = [];

        Object.each( $scope.namingConventions, function (key, value) {
            if (angular.equals(columnIndicator, key)){
                Object.each(value, function(k,v){
                    filePieces.push(v.piece);
                })
            }
        });

        if (columnIndicator === 'Separators')
            filePieces.push('.');

        if (onlyGetInUsePiecesByNamingConv){
            var fp = angular.copy(filePieces);

            fp.forEach(function(piece, idx){
                if (!$scope.importFilesAdditionalData.namingConvention.has(piece)){
                    filePieces.remove(piece);
                    $scope.current.namingConvention.remove(piece);
                }
            });
        }


        return filePieces;
    }

    function checkValidForImport(){
        var message = "";

        var predefinedPiecesInUse = getFilePiecesForIndicator('Predefined', true);
        var isCustomParseNeeded = checkForCustomParseNeed(predefinedPiecesInUse);

        if (($scope.current.fileType && $scope.current.fileType.name === 'Rep Summary') || $scope.importFilesAdditionalData.namingConvention.has('{RepSummary}')){
            if (!($scope.current.fileType && $scope.current.fileType.name === 'Rep Summary') && $scope.importFilesAdditionalData.namingConvention.has('{RepSummary}')){
                message += "Both the file type and naming convention must be set for rep summaries.<br/>";
            }
        }

        if ($scope.current.overwriteExisting && $scope.current.skipExisting){
            message += "Overwrite existing and skip existing both checked.<br/>"
        }
        if (!$scope.current.fileType){
            message += "Select a file type.<br/>"
        }

        if ($scope.importFilesAdditionalData.namingConvention.length < 1){
            message += "Enter file naming convention.<br/>"
        }

        if ($scope.importFilesAdditionalData.blobDescription.length < 1){
            message += "Enter description information.<br/>";
        }

        if ($scope.importFilesAdditionalData.blobText.length < 1){
            message += "Enter text information.<br/>";
        }

        if (isCustomParseNeeded){
            if ($scope.importFilesAdditionalData.namingConvention.has('{LegacyQPE}') && !$scope.current.entityLevel === parseInt(entities.client.value)){
                message += 'Legacy QPEs can only be posted at the client level.<br/>'
            }
        } else {
            if ( $scope.current.entityLevel === parseInt(entities.client.value) ){
                if (!($scope.importFilesAdditionalData.namingConvention.has('{pkClient') || $scope.importFilesAdditionalData.namingConvention.has('{pkRegistration}') || $scope.importFilesAdditionalData.namingConvention.has('{pkAccount}') || $scope.importFilesAdditionalData.namingConvention.has('{AcctNumber}'))){
                    message += 'No valid look up token for client level.<br/>';
                }
            } else if ($scope.current.entityLevel === parseInt(entities.registration.value)){
                if (!($scope.importFilesAdditionalData.namingConvention.has('{pkRegistration}') || $scope.importFilesAdditionalData.namingConvention.has('{pkAccount}') || $scope.importFilesAdditionalData.namingConvention.has('{AcctNumber}'))){
                    message += 'No valid look up token for registration level.<br/>';
                }
            } else if ($scope.current.entityLevel === parseInt(entities.account.value)){
                if (!($scope.importFilesAdditionalData.namingConvention.has('{pkAccount}') || $scope.importFilesAdditionalData.namingConvention.has('{AcctNumber}'))){
                    message += 'No valid look up token for account level.<br/>';
                }
            }
        }

        if (message.length > 0){
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Validation Failed", message).open();
        } else {
            $dialog.messageBox("<i class='fa fa-lg text-success' aria-hidden='true'></i> Validation Successful", "Please proceed to import.").open();
        }

        $scope.current.isValid = message.length === 0;
    }

    function checkForCustomParseNeed(predefinedPiecesInUse){
        var isCustomParseNeeded = false;

        predefinedPiecesInUse.forEach(function(piece){
            if (angular.equals(piece, '{ReportBuilder}') || angular.equals(piece, '{RepSummary}') || angular.equals(piece,'LegacyQPE}')) {
                isCustomParseNeeded = true;
            }
        });
        return isCustomParseNeeded;
    }

    // PUBLIC METHODS
    $scope.selectPiece = function(piece){
        if (piece.has('None')) return;

        $scope.importFilesAdditionalData.namingConvention += piece;

        if (piece.has('MCH*_SHR_SMT')){
            $scope.current.namingConvention.push('MCH*');
            $scope.current.namingConvention.push('SHR');
            $scope.current.namingConvention.push('SMT');
            $scope.current.namingConvention.push('{AcctNumber}');
            $scope.current.namingConvention.push('00000000');
        } else{
            $scope.current.namingConvention.push(piece);
        }

        $scope.setBlobInformationFields($scope.current.fileType);

        $scope.current.tempField = 'None';
        $scope.current.tempPredefined = 'None';
        $scope.current.tempCustom = 'None';
    };

    $scope.validate = function(){
        checkValidForImport();
    };

    $scope.setBlobInformationFields = function(fileType){
        if ($scope.importFilesAdditionalData.namingConvention.length === 0) $scope.current.namingConvention = [];

        var isAcctCodeInNamingConv = $scope.importFilesAdditionalData.namingConvention.has('{AcctNumber}');
        var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        var startDate = $scope.importFilesAdditionalData.startDate;
        var endDate = $scope.importFilesAdditionalData.endDate;
        var predefinedPiecesInUse = getFilePiecesForIndicator('Predefined', true);

        if (predefinedPiecesInUse.length > 0){
            if (angular.equals(fileType.value, "Qrtly Statement") || angular.equals(fileType.value, "CustodialStatement")){
                if(angular.equals(fileType.name, "Monthly Statement")){
                    $scope.importFilesAdditionalData.blobText = "{startDate} to {endDate}".assign({startDate: startDate.formatted(), endDate: endDate.formatted()});
                    $scope.importFilesAdditionalData.blobDescription = "{year} - {month} Statement".assign({year: endDate.getFullYear(), month: monthNames[startDate.getMonth()]});
                } else {
                    $scope.importFilesAdditionalData.blobText = "{startDate} to {endDate}".assign({startDate: startDate.formatted(), endDate: endDate.formatted()});
                    var quarter = "";

                    if (startDate.getMonth() <= 11)
                        quarter = "4th";
                    if (startDate.getMonth() <= 8){
                        quarter = "3rd";
                    }
                    if (startDate.getMonth() <=5)
                        quarter = "2nd";
                    if (startDate.getMonth() <=2)
                        quarter = "1st";

                    $scope.importFilesAdditionalData.blobDescription = "{endDate} - {qt} Quarter Statement".assign({endDate: endDate.getFullYear(),qt: quarter});

                    predefinedPiecesInUse.forEach(function(piece){
                        if (piece.has('{AcctNumber')){
                            $scope.importFilesAdditionalData.blobDescription += ' - {' +
                                'AcctNumber}';
                        }
                    });
                }
            }
        } else{
            if (angular.equals(fileType.value, 'Rpt_1099')){
                $scope.importFilesAdditionalData.blobText = "{year} 1099 - {regType} - {acctCode}".assign({year: endDate.getFullYear(), regType: '{RegType}', acctCode: '{AcctNumber}'});
                $scope.importFilesAdditionalData.blobDescription = $scope.importFilesAdditionalData.blobText;
            }
            if (isAcctCodeInNamingConv && (!$scope.importFilesAdditionalData.blobText.has('{AcctNumber'))){
                $scope.importFilesAdditionalData.blobText += ' - {AcctNumber}';
            }
        }

        if (angular.equals(fileType.name, "Rep Summary")){
            $scope.current.levelWarningText = '* This file type will be posted at the rep level.';
        }

    };

    $scope.newImport = function () {
        var successCount = 0;
        var failedCount = 0;
        var emailSent = 0;

        $scope.current.animation = 'slide-right';
        $scope.current.wizardStep += 1;


        var payLoad = {
            fileNameConvention: $scope.importFilesAdditionalData.namingConvention,
            method: $scope.importFilesAdditionalData.method,
            sendEmail: $scope.current.sendEStatement,
            ignoreDash: $scope.current.ignoreDashes,
            ignoreLeadingZero: $scope.current.ignoreLeadingZeroes,
            startDate: $scope.importFilesAdditionalData.startDate,
            endDate: $scope.importFilesAdditionalData.endDate,
            blobDescription: $scope.importFilesAdditionalData.blobDescription,
            blobText: $scope.importFilesAdditionalData.blobText,
            fileExtension: $scope.importFilesAdditionalData.fileExtension,
            postLevel: $scope.current.entityLevel,
            fileType: $scope.current.fileType.value,
            totalNumberOfFile: $scope.current.files.length,
            instanceName: $scope.current.instanceName
        };


        $scope.current.filesCompleted = 0;

        fileImportResponse = null;
        fileLogResults = [];

        createNewImportCacheless(payLoad,successCount, failedCount, emailSent);        
    };

    function createNewImportCacheless(payLoad, successCount, failedCount, emailSent) {
        $http.post('/FileImport/Upload/New', payLoad, { trackerMsg: 'Setting up upload session' })
            .then(function (response) {
                if (!response.data) return;

                var queue = [].add($scope.current.fileList);
                var numberOfProcessors = 6;

                var d = new Date();
                var date = d.toDateString();
                var time = d.toLocaleTimeString();
                fileImportResponse = response.data;

                $scope.current.tabFiles = true;
                $scope.current.logInfo = "Import Start: " + date + " " + time + "\r\n";
                $scope.current.executing = true;

                var processQueueItem = function () {
                    if (!queue.length) {
                        if (successCount + failedCount === $scope.current.files.length) {
                            var d = new Date();
                            date = d.toDateString();
                            time = d.toLocaleTimeString();

                            $scope.current.logInfo += $scope.current.errInfo;
                            $scope.current.logInfo += "Import complete: " + $scope.current.filesCompleted + " of " + $scope.current.files.length + " imported." + "\r\n";
                            $scope.current.logInfo += "Failed: " + failedCount + ", Succeeded: " + successCount + "  Emailed: " + emailSent + "\r\n";
                            $scope.current.logInfo += "Import end: " + date + " " + time + "\r\n";

                            $scope.downloadLogFile();
                            $scope.current.executing = false;
                        }

                        return;
                    }

                    if (!$scope.current.executing) return;

                    var file = queue.shift();

                    $upload.upload({ url: '/FileImport/Upload/File', file: file, data: fileImportResponse })
                        .then(function (rst) {
                            fileLogResults.push(rst.data);
                            var fileItem = $scope.current.files.find({ name: rst.data.fileName });
                            if (rst.data && rst.data.pkBlob) {
                                fileItem.status = "Uploaded";
                                $scope.current.logInfo += fileItem.name + ' - ' + fileItem.status + ".  Parent: " + rst.data.fkParent + "\r\n";
                                successCount++;
                            } else {
                                fileItem.status = "Failed: " + rst.data.message;
                                failedCount++;
                                $scope.current.errInfo += fileItem.name + ' - ' + fileItem.status + ".  Parent: " + rst.data.fkParent + "\r\n";
                            }
                            if (rst.data.emailsSent) emailSent++;


                            $scope.current.failedSuccessCount = "Failed: " + failedCount + " Success: " + successCount;

                            if ($scope.current.returnFile.length === 5) $scope.current.returnFile = [];
                            $scope.current.returnFile.push(fileItem);
                            $scope.current.filesCompleted++;

                            $scope.current.completedPercent = ($scope.current.filesCompleted / $scope.current.files.length) * 100;

                            processQueueItem();
                        });
                };

                (1).upto(numberOfProcessors).forEach(function () {
                    processQueueItem();
                });
            });
    }

    $scope.toggleControls = function(item){
        switch(item){
            case 'namingConvention':
                $scope.current.isNamingConventionLock = !$scope.current.isNamingConventionLock;
                break;
            case 'description':
                $scope.current.isDescriptionLock = !$scope.current.isDescriptionLock;
                break;
            case 'text':
                $scope.current.isTextLock = !$scope.current.isTextLock;
                break;
        }
    };

    $scope.next = function() {
        switch ($scope.current.wizardStep) {
            default:
                $scope.current.animation = 'slide-right';
                $scope.current.wizardStep += 1;
                break;
        }
    };

    $scope.back = function() {
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep -= 1;
    };

    $scope.isStepIncomplete = function(form) {
        switch ($scope.current.wizardStep) {
            case 0:
                return false;
            case 1:
                if ($scope.current.files.length === 0)
                    return true;
                else
                    return false;
            case 2:
            case 3:
                if (form && !form.$valid) { return true;}
            case 4:
                return false;
            default:
                return true;
        }
    };

    $scope.jumpBackTo = function(index) {
        if ($scope.current.executing || $scope.current.wizardStep < index) return;

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };

    $scope.onFileSelect = function($files) {
        $scope.current.returnData = $files;
    };

    $scope.cancel = function(){
        $dialog.confirmAction("Are you sure you want to cancel the file(s) upload?")
            .open()
            .then(function (result) {
                if (result === "yes") {
                    $scope.current.executing = false;
                }
            });
    };

    $scope.addToCustom = function(){
        $dialog.inputBox("Add Custom Field", "Enter Name")
            .open()
            .then(function (result) {
                if (result) {
                    customFields.value.remove({field: 'None'});
                    customFields.value.push({name: result, field: $scope.current.namingConvention});
                    customFields.value = JSON.stringify(customFields.value);

                    $http.post('/Settings/UserOptions/file_upload_custom_fields', customFields, {trackerMsg: 'Loading custom fields'})
                        .then(function(res){
                            customFields = res.data;
                            customFields.value = JSON.parse(customFields.value) || [];

                            $scope.current.customFields = customFields.value;
                            $scope.current.customFields.unshift({name: 'Select Custom ...', field: 'None'})
                        });
                }
            });
    };

    $scope.customPiece = function(item){
        $scope.current.namingConvention = [];
        $scope.importFilesAdditionalData.namingConvention = "";

        item.forEach(function(piece){
            $scope.selectPiece(piece);
        });
    };

    $scope.downloadLogFile = function () {
        generateCachelessLogFile()
    };

    function generateCachelessLogFile() {
        var payLoad = {
            files: fileLogResults,
            settings: fileImportResponse
        }
        $http.post('/FileImport/Upload/GenerateLog', payLoad, { trackerMsg: 'Getting log file' })
            .then(function (response) {
                $window.location.href = response.headers("location") + "?Authorization=" + sessionStorage.oas_token;
            })
    }



    //INITIALIZE
    $scope.current = {
        wizardStep: 0,
        animation: 'slide-right',
        validateUrl: '',
        fileType: null,
        isNamingConventionLock: true,
        isDescriptionLock: true,
        isTextLock: true,
        entityLevel : parseInt(entities.client.value),
        isValid: false,
        overwriteExisting: false,
        skipExisting: false,
        ignoreDashes: false,
        ignoreLeadingZeroes: false,
        returnData : null,
        levelWarningText: '',
        tempField: 'None',
        tempPredefined: 'None',
        tempCustom: 'None',
        namingConvention: [],
        sendEStatement: false,
        fileList: [],
        isProcessing: false,
        tabLevel: true,
        importMethods : [
            {name: 'Only Import Existing Files', value: 1},
            {name: 'Import All Overwriting Existing', value: 2},
            {name: 'Import All Skip Existing', value: 3}
        ],
        automaticActions: [
            {name: 'None', value: true, id: 1},
            {name: 'Append underscore (_)', value: false, id: 2},
            {name: 'Append dash (-)', value: false, id: 3}
        ],
        action: 1,
        fieldType: 'Fields',
        files: [],
        filesCompleted: 0,
        returnFile: [],
        failedSuccessCount: '',
        logInfo: '',
        errInfo: '',
        executing: false,
        logFile: null,
    };

    $scope.wizardSteps = ["Settings", "Choose Files","Naming Convention","Review","Import"];

    $scope.importFilesAdditionalData = {
        startDate : Date.create('today').getStartOfQuarter().addMonths(-3),
        endDate: Date.create('today').getStartOfQuarter().addDays(-1),
        namingConvention: '',
        blobDescription: '',
        blobText: '',
        fileExtension: '.pdf',
        postLevel: 5,
        method:  2
    };

    $scope.files = [];

    $scope.namingConventions = {
        Data: [
            {friendlyName: 'Select Field ...', piece: 'None'},
            {friendlyName: 'AccountNumber', piece: '{AcctNumber}'},
            {friendlyName: 'Account ID', piece: '{pkAccount}'},
            {friendlyName: 'Registration ID', piece: '{pkRegistration}'},
            {friendlyName: 'Client ID', piece: '{pkClient}'},
            {friendlyName: 'Other', piece: '{Other}'},
            {friendlyName: 'Underscore', piece: '_'},
            {friendlyName: 'Dash', piece: '-'},
            {friendlyName: 'Dot', piece: '.'}
        ],
        Predefined: [
            {friendlyName: 'Select Field ...', piece: 'None'},
            {friendlyName: 'Legacy QPE', piece: '{LegacyQPE}'},
            {friendlyName: 'Report Builder', piece: '{ReportBuilder}'},
            {friendlyName: 'Rep Summary', piece: '{RepSummary}'},
            {friendlyName: 'MIG Long', piece: 'MCH*_SHR_SMT_{AcctNumber}_00000000'}
        ]
    };

    $scope.fileTypes = [
        {name: 'Quarterly Statement', value: 'Qrtly Statement', id: 1},
        {name: 'Monthly Statement', value: 'Qrtly Statement', id: 2},
        {name: 'Rep Summary', value: 'Rep Summary', id: 3},
        {name: 'Custodial Statement', value: 'CustodialStatement', id: 4},
        {name: '1099 Report', value: 'Rpt_1099', id: 5},
        {name: 'Year End Statement', value: 'YearEndStmt', id: 6},
        {name: '5498 Report', value: 'Form_5498', id: 7}

    ];


    init();

    // WATCH
    $scope.$watchCollection( "current.returnData", function( newValue, oldValue ) {
        if(newValue != oldValue && newValue != null ) {
            $scope.current.fileList = [];
            $scope.current.files = [];
            $scope.current.returnFile = [];

            if (newValue && (newValue.importedFiles || newValue.messages)){
                if (newValue.importedFiles && newValue.importedFiles.length == 0){
                    $dialog.messageBox("<i class='fa fa-lg fa-exclamation-triangle text-error' aria-hidden='true'></i> File(s) upload failed", 'No files has been uploaded.').open();
                }

                if (newValue.messages){
                    $dialog.messageBox("<i class='fa fa-lg text-info' aria-hidden='true'></i> Log Information", newValue.messages).open();
                }

            } else {

                newValue.forEach(function(file){
                    if (file.name.match(new RegExp($scope.importFilesAdditionalData.fileExtension, 'i'))) {
                        $scope.current.fileList.push(file);
                        $scope.current.files.push({name: file.name, status: 'Pending'});
                        if ($scope.current.returnFile.length < 5){
                            $scope.current.returnFile.push({name: file.name, status: 'Pending'});
                        }
                    }
                });
            }
        }
    });


});

'use strict';

app.controller('FileListCtrl', function FileListCtrl( $scope, $oasRights, $http, $routeParams, listSectionData , API_CONFIG) {
    // PRIVATE VARIABLES
    var dataItemsEvent = "event: data-items";
    let originalFileList;

    //PRIVATE FUNCTIONS
    function init(){

        $scope.rightsImportFiles = $oasRights.forCode("BLOBIMPORT");

        $http.get($scope.current.url, {trackerMsg: 'Loading file list'})
            .then(function(response){
                listSectionData.dataItems = response.data;
                listSectionData.dataItems.forEach(function(item){ item.isOnHold = item.isViewable === false ? true : false;});

                originalFileList = angular.copy(listSectionData.dataItems);

                $scope.$broadcast(dataItemsEvent);
            });
    }

    function downloadAuditFile(fileId) {
        window.location.href = API_CONFIG.baseUrl + '/FileImport/' + fileId + '/File?Authorization=' + sessionStorage.oas_token;
    }

    function deleteFile(fileId) {
        $http.delete('/Billing/Audit/' + fileId + '/File', {trackerMsg: 'Deleting file', headers: {Unmasquerade: "true"}})
            .then(function () {
                listSectionData.dataItems.remove({id: fileId});
                $scope.$broadcast(dataItemsEvent);
            });
    }

    function setOnHold(item) {
        $scope.current.fileListIsDirty = false;
        // selected is add by listsection remove it before comparison
        delete item.selected;

        item.isViewable = item.isOnHold ? false: true;

        listSectionData.dataItems.forEach(function(item){
           var originalItem = originalFileList.find({id: item.id});
           if (!angular.equals(originalItem, item)){
               $scope.current.fileListIsDirty = true;
               return;
           }

        });
    };


    $scope.exportToExcel = function() {
        $scope.$broadcast('event:file-list-action', {action: 'export-data'});
    };


    $scope.save = function(){
        $http.post('/FileImport/Instance/Files/UpdateViewStatus', listSectionData.dataItems, {trackerMsg: 'Updating hold status'})
            .then(function(){
                init();
            });
    };

    //INITIALIZE
    $scope.selectedIds = [];

    $scope.current = {
        url :  '/FileImport/Instance/' + $routeParams.instanceId + '/Files',
        selectedItems: [],
        fileListIsDirty: false
    };

    // INITIALIZE
    $scope.configAudit = {
        getUrl: null,
        listName: 'Files',
        template: 'file-list-item.html',
        icon: 'fa fa-users',
        selectEnabled: true,
        multiSelectEnabled: true,
        loadDataItemsEvent: dataItemsEvent,
        sortFields: {createdDate: "Date", blobDesc: "Description", fileName: "File Name", isViewable: "On Hold"},
        fieldToSort: 'createdDate',
        sortAsc: false,
        listFilter: ['blobDesc', 'createdDate', 'fileName', "isViewable"],
        additionalLinks: [],
        rights: $oasRights.forCode("BLOBIMPORT")

    };

    init();

    //EVENT REGISTRATIONS
    $scope.$on("item-action", function (e, args) {
        if (args.action === 'download-file') {
            downloadAuditFile(args.item.id);
        } else if (args.action === 'delete-file') {
            deleteFile(args.item.id);
        } else if (args.action === 'set-on-hold'){
            setOnHold(args.item);
        }
    });

});
'use strict';

app.controller('OpsMaintenanceListCtrl', function OpsMaintenanceListCtrl($scope, $http, $oasRights, views, $dialog) {
    //PRIVATE VARIABLES

    //PRIVATE METHODS

    // PUBLIC METHODS
    $scope.addOpsRecord = function( isNew ) {
        $dialog.dialog({templateUrl: "ops-maintenance-edit.html", controller: "OpsMaintenanceEdit", opsRecord: null})
            .open()
            .then(function( rslt ) {
                if( rslt ) {
                    $scope.$broadcast( 'event:ops-maintenance-list-action', {action: isNew ? 'add-item' : 'update-item', item: rslt } );
                }
            });
    };

    // INITIALIZE
    $scope.rightsOpsMaintenance = $oasRights.forCode('ORIONENTERPRISEMAINTENANCE');
    $scope.views = views;
    $scope.current = {view: views[0]};
    $scope.selectedIds = [];
});

app.controller('OpsMaintenanceEdit', function OpsMaintenanceEdit($scope, $http, $oasRights, dialog, $q) {

    // PRIVATE METHODS
    function init() {
        $scope.current = {isNew: !dialog.options.opsRecord, headerVerb: dialog.options.opsRecord ? "Edit" : "Add"};
        $scope.rightsOpsMaintenance = $oasRights.forCode("ORIONENTERPRISEMAINTENANCE");

        if (!dialog.options.opsRecord) {
            $scope.opsRecord = {
                id: null,
                alClientId: null,
                isBilling: false,
                isComposites: false,
                isFullOps: false,
                isStatements: false,
                isTrading: false
            };
        } else {
            $scope.opsRecord = angular.copy( dialog.options.opsRecord );
        }

        loadDatabases( );
    }

    function loadDatabases( ) {
        var loadPromises = [];

        loadPromises.push($http.get("/Authorization/Databases", {cache: true, trackerMsg: 'Loading databases'}));
        loadPromises.push($http.get("/Portfolio/ALClientOps", {ignoreExceptions: true}));

        $q.all(loadPromises).then(function (results) {
            if( results[0].data && results[0].data.length > 0 && results[1].data && results[1].data.length > 0 ) {
                for( var i = 0; i < results[1].data.length; i++ ) {
                    var existingDbIdx = results[0].data.findIndex({id: results[1].data[i].id});
                    if( existingDbIdx && existingDbIdx >= 0 ) {
                        results[0].data.splice( existingDbIdx, 1 );
                    }
                }
            }

            $scope.databases = results[0].data
        });

    }


    // PUBLIC METHODS
    $scope.setServices = function () {
        if( $scope.opsRecord.isFullOps ) {
            $scope.opsRecord.isBilling = false;
            $scope.opsRecord.isComposites = false;
            $scope.opsRecord.isStatements = false;
            $scope.opsRecord.isTrading = false;
        }
    };

    $scope.cancel = function () {
        dialog.close(null);
    };


    $scope.saveOpsRecord = function () {
        if ($scope.current.isNew) {
            $http.post("/Portfolio/ALClientOps", $scope.opsRecord, {trackerMsg: 'Adding record'})
                .then(function ( r ) {
                    dialog.close( r.data );
                });
        } else {
            $http.put("/Portfolio/ALClientOps/" + $scope.opsRecord.id, $scope.opsRecord, {trackerMsg: 'Updating record'})
                .then(function ( r ) {
                    dialog.close( r.data );
                });
        }
    };


    // INITIALIZE
    init();

});

'use strict';

var geminiFundBackLoadListCtrl = app.controller('GeminiFundBackLoadListCtrl', function GeminiFundBackLoadListCtrl($scope, $http, $timeout, $oasRights, $portfolio, $dialog, $routeParams, entities, views, forYear, $location, $advisor){
    var selectedLoad = null;

    // PRIVATE METHODS
    function init(){
        search('Select Fund');
    }

    function search (  title ) {
        var dialogOpts = {
            backdrop : true,
            keyboard : true,
            backdropClick : true,
            templateUrl : 'advisor/modals/select-fund.html',
            controller : 'SelectFundCtrl',
            hasForYear : false,
            title : title ? title : null
        };

        var d = $dialog.dialog(dialogOpts);
        return d.open().then(function(rslt) {
            if( rslt ) {
                $scope.current.fundKey = rslt.fundKey;
                $scope.current.forYear = null;

                $scope.current.url = '/Reporting/FundPerformance/GeminiFund/Loads';

                $timeout(function () {
                    $scope.refreshGrid();
                });
            }
        });
    };


    $scope.refreshGrid = function( ) {
        forYear.yearNumber.value = $scope.current.forYear;

        $http.post('/Settings/UserOptions/fundbackload_list_forYear', forYear.yearNumber ).then(function( response ) {
            forYear.yearNumber.id = response.data.id;
        });

        $timeout(function(){
            $scope.$broadcast('event:advisor-geminifundbackload-action', {action: 'refresh-grid'});
        });

    };

    // METHODS
    $scope.openEditor = function(isNew, isBackLoad) {
        if (!isNew){
            var params = "&load=" + selectedLoad.load + "&forYear=" + selectedLoad.forYear + "&starting=" + selectedLoad.starting + "&effectiveDate=" + selectedLoad.effectiveDate;
        }

        if (isBackLoad){
            if (isNew){
                $location.url("/advisor/geminifundbackload/" + ($scope.current.fundKey ? $scope.current.fundKey : $scope.current.id) + "/?isNew=true");
            } else {
                $location.url("/advisor/geminifundbackload/" + $scope.current.id  + "?isNew=false" + params);
            }
        } else {
            if (isNew){
                $location.url("/advisor/geminifundfrontload/" + ($scope.current.fundKey || $scope.current.id) + "?isNew=true");
            } else {
                $location.url("/advisor/geminifundfrontload/" + $scope.current.id + "?isNew=false" + params);
            }
        }

    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:advisor-geminifundbackload-action', {action: 'export-data'});
    };

    $scope.selectFund = function(){
        $advisor.searchFund().then(function(rslt){
            $scope.current.fundKey = rslt.fundKey;
            $timeout(function () {
                $scope.refreshGrid();
            });
        })

    };
    //EVENT LISTENERS
    $scope.$on("event:advisor-geminifundbackload-select", function(e, args){
        if (args.length === 0) return;
        $scope.current.id = args[0].fundKey;
        $scope.current.forYear = args[0].forYear;
        $scope.current.isBackEnd = args[0].isBackEnd;
        selectedLoad = args[0];

        $scope.current.deleteUrl = args[0].isBackEnd ? '/Reporting/FundPerformance/GeminiFund/BackLoad/action/delete' : '/Reporting/FundPerformance/GeminiFund/FrontLoad/action/delete';
    });

    // INTIALIZE
    $scope.rightsGeminiFund = $oasRights.forCode( "GEMINIFUNDAPP" );
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        forYear: forYear.yearNumber ? parseInt(forYear.yearNumber.value) : 1,
        fundKey : null,
        isBackEnd: null,
        deleteUrl: null,
        selectedLoad: null
    };

    init();

});

geminiFundBackLoadListCtrl.loadFundBackLoadForYear = ["$http","$q", function( $http, $q ) {

    var loadPromises = [];
    loadPromises.push( $http.get('/Settings/UserOptions/fundbackload_list_forYear?defaultValue=1', {trackerMsg: 'Loading default for year' } ) );

    return $q.all(loadPromises).then(function(results) {
        results[0].data.value = results[0].data.value ? results[0].data.value : 1;

        return { yearNumber : results[0].data  };
    });

}];

'use strict';

app.controller('GeminiFundFrontLoadListCtrl', function GeminiFundFrontLoadListCtrl($scope, $http, $timeout, $oasRights, $portfolio, $dialog, $routeParams, entities, views, $location, $advisor){

    // PRIVATE METHODS
    function init(){
        search('Select Fund');
    }

    function search (  title ) {
        var dialogOpts = {
            backdrop : true,
            keyboard : true,
            backdropClick : true,
            templateUrl : 'advisor/modals/select-fund.html',
            controller : 'SelectFundCtrl',
            title : title ? title : null
        };

        var d = $dialog.dialog(dialogOpts);
        return d.open().then(function(rslt) {
            if( rslt ) {
                $scope.current.fundKey = rslt.fundKey;
                $scope.current.url = '/Reporting/FundPerformance/GeminiFund/FrontLoad';

                $timeout(function () {
                    $scope.refreshGrid();
                });
            }
        });
    };


    $scope.refreshGrid = function( ) {
        $timeout(function(){
            $scope.$broadcast('event:advisor-geminifundfrontload-action', {action: 'refresh-grid'});
        });

    };

    // METHODS
    $scope.openEditor = function(isNew) {
        if (isNew){
            $location.path("/advisor/geminifundfrontload/" + ($scope.current.fundKey ? $scope.current.fundKey : $scope.current.id));
        } else {
            $location.path("/advisor/geminifundfrontload/" + $scope.current.id);
        }
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:advisor-geminifundfrontload-action', {action: 'export-data'});
    };

    $scope.selectFund = function(){
        $advisor.searchFund().then(function(rslt){
            $scope.current.fundKey = rslt.fundKey;
            $timeout(function () {
                $scope.refreshGrid();
            });
        })

    };
    //EVENT LISTENERS
    $scope.$on("event:advisor-geminifundfrontload-select", function(e, args){
        if (args.length === 0) return;
        $scope.current.id = args[0].fundKey;
        $scope.current.effectiveDate = args[0].effectiveDate;
    });

    // INTIALIZE
    $scope.rightsGeminiFund = $oasRights.forCode( "GEMINIFUNDAPP" );
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        fundKey : null,
        effectiveDate: null
    };

    init();

});


'use strict';

var geminiFundDivListCtrl = app.controller('GeminiFundDivListCtrl', function GeminiFundDivListCtrl($scope, $http, $timeout, $oasRights, $portfolio, $dialog, $routeParams, entities, views, divData, $location, $advisor){

    // PRIVATE METHODS
    function init(){
        search('Select Fund');
    }

    function search (  title ) {
        var dialogOpts = {
            backdrop : true,
            keyboard : true,
            backdropClick : true,
            templateUrl : 'advisor/modals/select-fund.html',
            controller : 'SelectFundCtrl',
            hasDivYear : false,
            title : title ? title : null
        };

        var d = $dialog.dialog(dialogOpts);
        return d.open().then(function(rslt) {
            if( rslt ) {
                $scope.current.fundKey = rslt.fundKey;
                $scope.current.divYear = -1;
                
                $scope.current.url = '/Reporting/FundPerformance/GeminiFund/Div';

                $timeout(function () {
                    $scope.refreshGrid();
                });
            }
        });
    };


    $scope.refreshGrid = function( ) {
        divData.divYear.value = $scope.current.divYear;

        $http.post('/Settings/UserOptions/funddiv_list_divYear', divData.divYear ).then(function( response ) {
            divData.divYear.id = response.data.id;
        });

        $timeout(function(){
            $scope.$broadcast('event:advisor-geminifunddiv-action', {action: 'refresh-grid'});
        });

    };

    // METHODS
    $scope.openEditor = function(isNew) {
        if (isNew){
            $location.path("/advisor/geminifunddiv/" + ($scope.current.fundKey ? $scope.current.fundKey : $scope.current.id) + "/0");
        } else {
            $location.path("/advisor/geminifunddiv/" + $scope.current.id + "/" + $scope.current.divYear);
        }
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:advisor-geminifunddiv-action', {action: 'export-data'});
    };

    $scope.selectFund = function(){
        $advisor.searchFund().then(function(rslt){
            $scope.current.fundKey = rslt.fundKey;
            $timeout(function () {
                $scope.refreshGrid();
            });
        })

    };

    //EVENT LISTENERS
    $scope.$on("event:advisor-geminifunddiv-select", function(e, args){
        if (args.length === 0) return;
        $scope.current.id = args[0].fundKey;
        $scope.current.divYear = args[0].divYear;
    });

    // INTIALIZE
    $scope.rightsGeminiFund = $oasRights.forCode( "GEMINIFUNDAPP" );
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        divYear: divData.divYear ? parseInt(divData.divYear.value) : 2000,
        fundKey : null
    };

    init();

});

geminiFundDivListCtrl.loadFundDivYear = ["$http","$q", function( $http, $q ) {

    var loadPromises = [];
    loadPromises.push( $http.get('/Settings/UserOptions/funddiv_list_divYear?defaultValue=1', {trackerMsg: 'Loading default div year' } ) );

    return $q.all(loadPromises).then(function(results) {
        results[0].data.value = results[0].data.value ? results[0].data.value : 2000;

        return { divYear : results[0].data  };
    });

}];

'use strict';

var geminiFundIndexLinkListCtrl = app.controller('GeminiFundIndexLinkListCtrl', function GeminiFundIndexLinkListCtrl($scope, $http, $timeout, $oasRights, $portfolio, $dialog, $routeParams, entities, views, $location, $advisor){

    // PRIVATE METHODS
    function init(){
        search('Select Fund');
        if ($scope.user.authorization.entity === "Administrator"){
            $scope.current.canAddIndex = true;
        } else {
            $scope.current.canAddIndex = false;
        }
    }

    function search (  title ) {
        var dialogOpts = {
            backdrop : true,
            keyboard : true,
            backdropClick : true,
            templateUrl : 'advisor/modals/select-fund.html',
            controller : 'SelectFundCtrl',
            title : title ? title : null,
            hasIndexNumber : false
        };

        var d = $dialog.dialog(dialogOpts);
        return d.open().then(function(rslt) {
            if( rslt ) {
                $scope.current.fundKey = rslt.fundKey;
                $scope.current.indexNumber = "-1";

                $scope.current.url = '/Reporting/FundPerformance/GeminiFund/IndexLink';

                $timeout(function () {
                    $scope.refreshGrid();
                });
            }
        });
    };


    $scope.refreshGrid = function( ) {
        $timeout(function(){
            $scope.$broadcast('event:advisor-geminifundindexlink-action', {action: 'refresh-grid'});
        });

    };
    
    $scope.addNewIndex = function(){
        $dialog.dialog({dialogClass: "modal wide", templateUrl: "add-new-index.html", controller: "AddNewIndexCtrl"}).open();
    };

    // METHODS
    $scope.openEditor = function(isNew) {
        if (isNew){
            $location.path("/advisor/geminifundindexlink/" + ($scope.current.fundKey ? $scope.current.fundKey : $scope.current.id) + "/0");
        } else {
            $location.path("/advisor/geminifundindexlink/" + $scope.current.id + "/" + $scope.current.indexNumber);
        }
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:advisor-geminifundindexlink-action', {action: 'export-data'});
    };

    $scope.selectFund = function(){
        $advisor.searchFund().then(function(rslt){
            $scope.current.fundKey = rslt.fundKey;
            $scope.current.indexNumber = "-1";
            $timeout(function () {
                $scope.refreshGrid();
            });
        })

    };

    //EVENT LISTENERS
    $scope.$on("event:advisor-geminifundindexlink-select", function(e, args){
        if (args.length === 0) return;
        $scope.current.id = args[0].fundKey;
        $scope.current.indexNumber = args[0].indexNumber;
    });

    // INTIALIZE
    $scope.rightsGeminiFund = $oasRights.forCode( "GEMINIFUNDAPP" );
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        indexNumber: null,
        fundKey : null,
        canAddIndex: false
    };

    init();

});

app.controller('AddNewIndexCtrl', function AddNewIndexCtrl($scope, $http, dialog){
   $scope.close = function(){
       dialog.close(null);
   };
    
   $scope.save = function(){
       $http.post('/Reporting/FundPerformance/GeminiFund/Index', $scope.fundIndex, {trackerMsg: 'Saving new Index '})
           .then(function(response) {
               dialog.close(response.data);
           });
   };
    
    $scope.fundIndex = {
        indexNumber: '',
        indexName: '',
        productId: null,
        isPrimary: false
    }
});
'use strict';

app.controller('GeminiFundGroupListCtrl', function GeminiFundGroupListCtrl($scope, $http, $oasRights,  $dialog, $routeParams,  views, $location){

    // PRIVATE METHODS
    function refreshGrid( ) {
        $scope.$broadcast('event:advisor-geminifundgroup-action', {action: 'refresh-grid'});
    }

    // METHODS
    $scope.openEditor = function(isNew) {
        if (isNew){
            $location.path("/advisor/geminifundgroup/0");
        } else {
            $location.path("/advisor/geminifundgroup/" + $scope.current.id);
        }
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:advisor-geminifundgroup-action', {action: 'export-data'});
    };

    //EVENT LISTENERS
    $scope.$on("event:advisor-geminifundgroup-select", function(e, args){
        if (args.length === 0) return;
        $scope.current.id = args[0].id;
    });

    // INTIALIZE
    $scope.rightsGeminiFund = $oasRights.forCode( "GEMINIFUNDAPP" );
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        url: '/Reporting/FundPerformance/GeminiFundGroup'
    };


});

'use strict';

app.controller('GeminiFundTaxListCtrl', function GeminiFundTaxListCtrl($scope, $http, $oasRights, $dialog, $routeParams, views, $location){

    // PRIVATE METHODS
    function refreshGrid( ) {
        $scope.$broadcast('event:advisor-geminifundtax-action', {action: 'refresh-grid'});
    }

    // METHODS
    $scope.openEditor = function(isNew) {
        if (isNew){
            $location.path("/advisor/geminifundtax/0");
        } else {
            $location.path("/advisor/geminifundtax/" + $scope.current.id);
        }
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:advisor-geminifundtax-action', {action: 'export-data'});
    };

    //EVENT LISTENERS
    $scope.$on("event:advisor-geminifundtax-select", function(e, args){
        if (args.length === 0) return;
        $scope.current.id = args[0].id;
    });


    // INTIALIZE
    $scope.rightsGeminiFund = $oasRights.forCode( "GEMINIFUNDAPP" );
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        url: '/Reporting/FundPerformance/GeminiFundTax'
    };


});

'use strict';

app.controller('GeminiFundCalendarListCtrl', function GeminiFundCalendarListCtrl($scope, $http, $oasRights, $portfolio, $dialog, $routeParams, entities, views, apps, $location, $timeout){

    // PRIVATE METHODS
    $scope.refreshGrid = function( ) {
        $timeout( $scope.$broadcast('event:advisor-geminifundcalendar-action', {action: 'refresh-grid'}));
    };

    // METHODS
    $scope.openEditor = function(isNew) {
        if (isNew){
            $location.path("/advisor/geminifundcalendar/0");
        } else {
            $location.path("/advisor/geminifundcalendar/" + $scope.current.id);
        }
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:advisor-geminifundcalendar-action', {action: 'export-data'});
    };

    //EVENT LISTENERS
    $scope.$on("event:advisor-geminifundcalendar-select", function(e, args){
        if (args.length === 0) return;
        $scope.current.id = args[0].id;
    });

    // INTIALIZE
    $scope.rightsGeminiFund = $oasRights.forCode( "GEMINIFUNDAPP" );
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        url: '/Reporting/FundPerformance/GeminiFundCalendar',
        forYear: Date.create('today').getFullYear()
    };


});

'use strict';

app.controller('GeminiFundEditCtrl', function GeminiFundEditCtrl($scope, $http, $location, $dialog, $oasRights, $routeParams, $cacheFactory, API_CONFIG, fundTypes) {
    // PRIVATE VARIABLES
    var fundId = $routeParams.id;


    // PRIVATE METHODS
    function loadFund( ) {
        loadFundTypes();
        if( fundId != 0 ) {
            $http.get('/Reporting/FundPerformance/GeminiFund/' + fundId, {trackerMsg: 'Loading fund ' + fundId})
                .then(function (response) {
                    $scope.fund = response.data;
                    parseFiscalYearEnd($scope.fund.fiscalYearEnd);
                });
        }
        else {
            $scope.current.isNew = true;

            $scope.fund = {
                "id": "",
                "fundName": "",
                "frontLoad": null,
                "backLoad": null,
                "ticker": null,
                "inceptionDate": null,
                "fiscalYearEnd": null,
                "advisorInceptionDate": null,
                "navPrecision": null,
                "sharePrecision": null,
                "isClosed": null,
                "closedDate": null,
                "isLiquidated": null,
                "liquidatedDate": null,
                "class": null,
                "fundType": null,
                "cusip": null
            }
        }
    }
    function loadFundTypes( ) {
        if( $scope.fundTypes == null ) {
            $scope.fundTypes = [];
            fundTypes.keys().forEach( function( key ) {
                $scope.fundTypes.push( {id: parseInt( fundTypes[key].value ), name: fundTypes[key].name} )
            } );
        }
    }
    function parseFiscalYearEnd(value){
        var fiscalYearEnd = Date.create(value);
        $scope.current.fiscalMonth = fiscalYearEnd.getMonth() + 1;
        $scope.current.fiscalDate = fiscalYearEnd.getDate();
    }

    // PUBLIC METHODS
    $scope.saveFund = function( form ) {
        if (!form.$valid) return;
        var args;

        if (!$scope.current.isNew){
            args = {
                method: "PUT",
                trackerMsg: "Saving fund " + $scope.fund.id ? $scope.fund.id : fundId,
                url :  '/Reporting/FundPerformance/GeminiFund/' + ($scope.fund.id ? $scope.fund.id : fundId)
            }
        } else {
            args = {
                method: "POST",
                trackerMsg: "Adding fund ",
                url :  '/Reporting/FundPerformance/GeminiFund/'
            }
        }

        $http( { method: args.method , url: args.url, data: $scope.fund, trackerMsg: args.trackerMsg} )
            .then(function() {
                $location.path( '/advisor/geminifund' );
            });
    };

    $scope.deleteFund = function(id) {
        $http.delete('/Reporting/FundPerformance/GeminiFund/' + id, {trackerMsg: 'Deleting fund ' + id})
            .then(function(){
                $location.path( '/advisor/geminifund' );
            });
    };

    $scope.processFiscalYearEnd = function(){
        $scope.fund.fiscalYearEnd = Date.create(1900, $scope.current.fiscalMonth - 1, $scope.current.fiscalDate).formatted();
    };

    //region Fund Identifer
    $scope.addFundIdentifer = function() {
        var dialogOpts = {
            templateUrl : "fund-identifier.html",
            controller : "FundIdentifierCtrl"
        };

        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function(rslt){
                if (rslt){
                    if ($scope.fund.identifiers && $scope.fund.identifiers.find({identifier : rslt.identifier})){
                        $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Already Exist", "That identifier is already assigned to this fund.").open();
                    } else {
                        if ($scope.fund.identifiers === null) $scope.fund.identifiers = [];

                        $scope.fund.identifiers.push({fundKey: null, identifier: rslt.identifier});
                    }
                }
            });

    };

    $scope.removeFundIdentifier = function(identifier){
        $dialog.confirmAction("Are you sure you want to remove this identifier?")
            .open()
            .then(function(result){
                if (result === 'yes') {
                    $scope.fund.identifiers.remove(identifier);
                }
            });
    };

    //endregion

    // INIT
    $scope.rightsGeminiFund = $oasRights.forCode('GEMINIFUNDAPP');
    $scope.current = {
        isNew : false,
        fiscalMonth: 1,
        fiscalDate : 1
    };

    $scope.fundTypes = null;

    loadFund( );

    // WATCHES
    $scope.$watch('fund.fiscalYearEnd', function(newVal, oldVal){
        if (newVal != oldVal){
            parseFiscalYearEnd(newVal);
        }
    })

});

app.controller ('FundIdentifierCtrl', function FundIdentifierCtrl( $scope, $http, $oasRights, dialog){
    // PUBLIC METHODS
    $scope.cancel = function( ) {
        dialog.close( null );
    };

    $scope.close = function( ) {
        dialog.close( { identifier : $scope.current.selectedIdentifier} );
    };

    // INITIALIZE
    $scope.current = {
        selectedIdentifier : null
    };

    $scope.rightsGeminiFund = $oasRights.forCode( "GEMINIFUNDAPP" );
});
'use strict';

app.controller('GeminiFundDataEditCtrl', function GeminiFundDataEditCtrl($scope, $http, $location, $dialog, $oasRights, $routeParams,$advisor) {
    // PRIVATE VARIABLES
    var fundId = $routeParams.id;
    var rateDate = $routeParams.rateDate;

    // PRIVATE METHODS
    function loadFundData( ) {
        if( rateDate != 0 ) {
            $http.get('/Reporting/FundPerformance/GeminiFund/Data/' + fundId + '/' + rateDate, {trackerMsg: 'Loading fund ' + fundId})
                .then(function (response) {
                    $scope.fundData = response.data;
                });
        }
        else {
            $scope.current.isNew = true;

            $http.get('/Reporting/FundPerformance/GeminiFund/' + fundId, {trackerMsg: 'Loading fund ' + fundId})
                .then(function(response) {
                    $scope.fundData = {
                        "fundKey": fundId,
                        "fundName" : response.data.fundName,
                        "rateDate": null,
                        "netAssetValue": null,
                        "offeringPrice": null,
                        "netAssets": null,
                        "sharesOutstanding": null,
                        "distributionFactor": null,
                        "capGainsFactorShort": null,
                        "capGainsFactorLong": null,
						"returnOfCapital": null,
                        "expensesGross": null,
                        "expensesWaived": null,
                        "userDefinedFields": null
                    }
                });
        }
    }


    // PUBLIC METHODS
    $scope.saveFundData = function( form ) {
        if (!form.$valid) return;
        var args;

        if (rateDate != 0){
            //$scope.fundData.rateDate = $scope.fundData.rateDate.formatted();

            args = {
                    method: "PUT",
                    trackerMsg: "Saving fund " + fundId,
                    url :  '/Reporting/FundPerformance/GeminiFund/Data/' + fundId + '/' + rateDate
            }
        } else {
            args = {
                method: "POST",
                id: "",
                rateDate : "",
                trackerMsg: "Adding fund ",
                url :  '/Reporting/FundPerformance/GeminiFund/Data/'
            }
        }

        $http( { method: args.method, url: args.url, data: $scope.fundData, trackerMsg: args.trackerMsg } )
            .then(function() {
                $location.path( '/advisor/geminifunddata' );
            });

    };

    $scope.newDivDetail = function(){
        $location.path("/advisor/geminifunddivdetail/" + fundId + "/" + rateDate + "/true");
    };

    // INIT
    $scope.rightsGeminiFund = $oasRights.forCode('GEMINIFUNDAPP');
    $scope.current = {isNew : false};

    loadFundData( );
});
'use strict';

app.controller('GeminiFundDivDetailEditCtrl', function GeminiFundDivDetailEditCtrl($scope, $http, $location, $dialog, $oasRights, $routeParams) {
    // PRIVATE VARIABLES
    var fundId = $routeParams.id;
    var rateDate = $routeParams.rateDate;
    var isNew = $routeParams.isNew === 'true' ? true : false;

    // PRIVATE METHODS
    function loadFundDivDetail( ) {
        if( !isNew ) {
            $http.get('/Reporting/FundPerformance/GeminiFund/DivDetail/' + fundId + '/' + rateDate , {trackerMsg: 'Loading div ' + fundId})
                .then(function (response) {
                    $scope.fundDiv = response.data;
                });
        }
        else {
            $http.get('/Reporting/FundPerformance/GeminiFund/' + fundId, {trackerMsg: 'Loading fund ' + fundId})
                .then(function(response){
                    $scope.fundDiv = {
                        "fundKey": fundId,
                        "fundName" : response.data.fundName,
                        "rateDate":  rateDate,
                        "reinvestPrice": null,
                        "dividendRate": null,
                        "ordinaryDividend": null,
                        "qualifiedDividend": null,
                        "taxFreeDiv": null,
                        "shortRate": null,
                        "shortOrdinary": null,
                        "shortQualified": null,
                        "longRate": null,
                        "exDate": null,
                        "recordDate": null,
                        "reinvestDate" : null,
                        "payDate" : null,
						"returnOfCapital": null,
                    }
                });
        }
    }


    // PUBLIC METHODS
    $scope.saveFundDivDetail = function( form ) {
        if (!form.$valid) return;
        var args;

       if (!isNew){
            args = {
                method: "PUT",
                trackerMsg: "Saving div " + fundId,
                url :  '/Reporting/FundPerformance/GeminiFund/DivDetail/' + fundId + '/' + rateDate
            }
        } else {
          //rateDate = rateDate == 0 ? $scope.fundDiv.rateDate.formatted() : rateDate.formatted();

           if ($scope.fundDiv.exDate != null) $scope.fundDiv.exDate.formatted();
           if ($scope.fundDiv.recordDate != null) $scope.fundDiv.recordDate.formatted();
           if ($scope.fundDiv.reinvestDate != null) $scope.fundDiv.reinvestDate.formatted();
           if ($scope.fundDiv.payDate != null) $scope.fundDiv.payDate.formatted();


           args = {
                method: "POST",
                id: "",
                rateDate : "",
                trackerMsg: "Adding div ",
                url :  '/Reporting/FundPerformance/GeminiFund/DivDetail/'
            }
        }

        $http( { method: args.method, url : args.url , data: $scope.fundDiv, trackerMsg: args.trackerMsg } )
            .then(function() {
                $location.path( '/advisor/geminifunddivdetail' );
            });
    };

    // INIT
    $scope.rightsGeminiFund = $oasRights.forCode('GEMINIFUNDAPP');

    loadFundDivDetail( );
});

'use strict';

app.controller('GeminiFundDivRateEditCtrl', function GeminiFundDivRateEditCtrl($scope, $http, $location, $dialog, $oasRights, $routeParams) {
    // PRIVATE VARIABLES
    var fundId = $routeParams.id;
    var divYear = $routeParams.divYear;

    // PRIVATE METHODS
    function loadFundDivRate( ) {
        if( divYear != 0 ) {
            $http.get('/Reporting/FundPerformance/GeminiFund/Div/' + fundId + '/' + divYear , {trackerMsg: 'Loading qual div rate ' + fundId})
                .then(function (response) {
                    $scope.fundDivRate = response.data;
                });
        }
        else {
            $scope.current.isNew = true;

            $http.get('/Reporting/FundPerformance/GeminiFund/' + fundId, {trackerMsg: 'Loading qual div rate ' + fundId})
                .then(function(response) {
                    $scope.fundDivRate = {
                        "fundKey": fundId,
                        "fundName" : response.data.fundName,
                        "divYear": null,
                        "qualifiedRate": null,
                        "taxFreeRate": null
                    }
            });
        }
    }


    // PUBLIC METHODS
    $scope.saveFundDivRate = function( form ) {
        if (!form.$valid) return;
        var args;

        if (divYear != 0){
            args = {
                method: "PUT",
                trackerMsg: "Saving div rate " + fundId,
                url :  '/Reporting/FundPerformance/GeminiFund/Div/' + fundId + '/' + divYear
            }
        } else {
            args = {
                method: "POST",
                trackerMsg: "Adding div rate ",
                url :  '/Reporting/FundPerformance/GeminiFund/Div/'
            }
        }

        $http( { method: args.method, url: args.url, data: $scope.fundDivRate, trackerMsg: args.trackerMsg } )
            .then(function() {
                $location.path( '/advisor/geminifunddiv' );
            });
    };

    // INIT
    $scope.rightsGeminiFund = $oasRights.forCode('GEMINIFUNDAPP');
    $scope.current = {isNew : false};

    loadFundDivRate( );
});

'use strict';

app.controller('GeminiFundBackLoadEditCtrl', function GeminiFundBackLoadEditCtrl($scope, $http, $location, $dialog, $oasRights, $routeParams) {
    // PRIVATE VARIABLES
    var fundId = $routeParams.id;
    var isNew = $routeParams.isNew == 'true' ? true : false;
    var load = $routeParams.load;
    var forYear = $routeParams.forYear;
    var starting = $routeParams.starting;
    var effectiveDate = $routeParams.effectiveDate;

    // PRIVATE METHODS
    function loadFundLoad( ) {
        if( fundId != 0 && isNew == 0 ) {
            $http.get('/Reporting/FundPerformance/GeminiFund/BackLoad/' + fundId + '/' + forYear + "/" + effectiveDate , {trackerMsg: 'Loading load detail ' + fundId})
                .then(function (response) {
                    $scope.fundLoad = response.data;
                });
        }
        else {
            $scope.current.isNew = true;

            $http.get('/Reporting/FundPerformance/GeminiFund/' + fundId, {trackerMsg: 'Loading load detail ' + fundId})
                .then(function(response) {
                    $scope.fundLoad = {
                        "fundKey": fundId,
                        "fundName": response.data.fundName,
                        "effectiveDate": null,
                        "forYear": null,
                        "backLoad": null,
                        "isBackEnd" : true
                    }
                });
        }
    }


    // PUBLIC METHODS
    $scope.saveFundLoad = function( form ) {
        if (!form.$valid) return;
        var args;

        if (!$scope.current.isNew){
            args = {
                method: "PUT",
                trackerMsg: "Saving load " + fundId,
                url :  '/Reporting/FundPerformance/GeminiFund/BackLoad/' + fundId + '/' + forYear + '/' + effectiveDate
            }
        } else {
            if ($scope.fundLoad.effectiveDate != null) $scope.fundLoad.effectiveDate.formatted();

            args = {
                method: "POST",
                trackerMsg: "Adding load ",
                url :  '/Reporting/FundPerformance/GeminiFund/BackLoad/'
            }
        }

        $http( { method: args.method, url: args.url, data: $scope.fundLoad, trackerMsg: args.trackerMsg } )
            .then(function() {
                $location.path( '/advisor/geminifundbackload' );
            });
    };

    // INIT
    $scope.rightsGeminiFund = $oasRights.forCode('GEMINIFUNDAPP');
    $scope.current = {isNew : false};

    loadFundLoad( );
});

'use strict';

app.controller('GeminiFundFrontLoadEditCtrl', function GeminiFundFrontLoadEditCtrl($scope, $http, $location, $dialog, $oasRights, $routeParams) {
    // PRIVATE VARIABLES
    var fundId = $routeParams.id;
    var isNew = $routeParams.isNew == 'true' ? true : false;
    var load = $routeParams.load;
    var forYear = $routeParams.forYear;
    var starting = $routeParams.starting;
    var effectiveDate = $routeParams.effectiveDate;

    // PRIVATE METHODS
    function loadFrontLoad( ) {

        if( fundId != 0 && isNew == 0 ) {
            $http.get('/Reporting/FundPerformance/GeminiFund/FrontLoad/' + fundId + '/' + effectiveDate + "/" + starting , {trackerMsg: 'Loading front load detail ' + fundId})
                .then(function (response) {
                    $scope.frontLoad = response.data;
                });
        }
        else {
            $scope.current.isNew = true;

            $http.get('/Reporting/FundPerformance/GeminiFund/' + fundId, {trackerMsg: 'Loading load detail ' + fundId})
                .then(function(response) {
                    $scope.frontLoad = {
                        "fundKey": fundId,
                        "fundName": response.data.fundName,
                        "effectiveDate": null,
                        "frontLoad": null,
                        "starting": null,
                        "isBackEnd" : false
                    }
                });
        }
    }


    // PUBLIC METHODS
    $scope.saveFrontLoad = function( form ) {
        if (!form.$valid) return;
        var args;

        if (!$scope.current.isNew){
            args = {
                method: "PUT",
                trackerMsg: "Saving load " + fundId,
                url :  '/Reporting/FundPerformance/GeminiFund/FrontLoad/' + fundId + "/" + effectiveDate + "/" + starting
            }
        } else {
            if ($scope.frontLoad.effectiveDate != null) $scope.frontLoad.effectiveDate.formatted();

            args = {
                method: "POST",
                trackerMsg: "Adding load ",
                url :  '/Reporting/FundPerformance/GeminiFund/FrontLoad/'
            }
        }

        $http( { method: args.method, url: args.url, data: $scope.frontLoad, trackerMsg: args.trackerMsg } )
            .then(function() {
                $location.path( '/advisor/geminifundbackload' );
            });
    };

    // INIT
    $scope.rightsGeminiFund = $oasRights.forCode('GEMINIFUNDAPP');
    $scope.current = {isNew : false};

    loadFrontLoad( );
});

'use strict';

app.controller('GeminiFundIndexLinkEditCtrl', function GeminiFundIndexLinkEditCtrl($scope, $http, $location, $dialog, $oasRights, $routeParams) {
    // PRIVATE VARIABLES
    var fundId = $routeParams.id;
    var indexNumber = $routeParams.indexNumber;

    // PRIVATE METHODS
    function loadIndexLink( ) {
        if( indexNumber != 0 ) {
            $http.get('/Reporting/FundPerformance/GeminiFund/IndexLink/' + fundId + '/' + indexNumber , {trackerMsg: 'Loading load index link ' + fundId})
                .then(function (response) {
                    $scope.fundIndexLink = response.data;
                });
        }
        else {
            $scope.current.isNew = true;
            $http.get('/Reporting/FundPerformance/GeminiFund/' + fundId, {trackerMsg: 'Loading load index link ' + fundId})
                .then(function(response) {
                    $scope.fundIndexLink = {
                        "fundKey": fundId,
                        "fundName" : response.data.fundName,
                        "indexNumber": "",
                        "indexName": "",
                        "productId": null,
                        "isPrimary": false,
                        "isBlend": false
                    }
            });
        }
    }


    // PUBLIC METHODS
    $scope.saveIndexLink = function( form ) {
        if (!form.$valid) return;
        var args;

        if (indexNumber != 0){
            args = {
                method: "PUT",
                trackerMsg: "Saving index link " + fundId,
                url :  '/Reporting/FundPerformance/GeminiFund/IndexLink/' + fundId + '/' + indexNumber
            }
        } else {
            args = {
                method: "POST",
                id: "",
                trackerMsg: "Adding index link ",
                url :  '/Reporting/FundPerformance/GeminiFund/IndexLink/'
            }
        }

        $http( { method: args.method, url: args.url, data: $scope.fundIndexLink, trackerMsg: args.trackerMsg } )
            .then(function() {
                $location.path( '/advisor/geminifundindexlink' );
            });
    };

    $scope.findIndex = function(){
        $dialog.search("geminiindices", "Select Index", "Index")
            .open()
            .then(function (result) {
                $http.get('/Reporting/FundPerformance/GeminiFund/Index/' + result.id, {trackerMsg: 'Loading Index ' + result.id})
                    .then(function(response) {
                        $scope.fundIndexLink.indexNumber = response.data.indexNumber;
                        $scope.fundIndexLink.indexName = response.data.indexName;
                        $scope.fundIndexLink.productId = response.data.productId;
                        $scope.fundIndexLink.isBlend = response.data.isBlend;
                    }
                );
            });
    };

    // INIT
    $scope.rightsGeminiFund = $oasRights.forCode('GEMINIFUNDAPP');
    $scope.current = {selectedIndex : null, isNew : false};

    loadIndexLink( );

    $scope.$watch('current.selectedIndex', function(newVal, oldVal){
        if (newVal === oldVal || !newVal) return;

        $scope.fundIndexLink.indexNumber = newVal.indexNumber;
        $scope.fundIndexLink.indexName = newVal.indexName;
        $scope.fundIndexLink.productId = newVal.productId;
    });

});

'use strict';

app.controller('GeminiFundGroupEditCtrl', function GeminiFundGroupEditCtrl($scope, $http, $location, $dialog, $oasRights, $routeParams) {
    // PRIVATE VARIABLES
    var groupId = $routeParams.id;

    // PRIVATE METHODS
    function loadGroup( ) {
        if( groupId != 0 ) {
            $http.get('/Reporting/FundPerformance/GeminiFundGroup/' + groupId , {trackerMsg: 'Loading fund group ' + groupId})
                .then(function (res) {
                    $scope.fundGroup = res.data;

                    $http.get('/Reporting/FundPerformance/GeminiFundGroup/GetByGroupName?groupName=' + $scope.fundGroup.groupName, {trackerMsg:'Loading fund group by name'})
                        .then(function(response){
                            var items = [];

                            response.data.forEach(function(item){
                                items.push({id: item.fundKey, name: item.fundName});
                            });


                            $scope.current.selectedItems = items;

                            $http.get('/Reporting/FundPerformance/GeminiFund/Simple/' , {trackerMsg: 'Loading fund group ' + groupId})
                                .then(function (res) {
                                    $scope.funds = res.data;
                            });
                        });

                });
        }
        else {
            $scope.fundGroup = {
                "id": null,
                "groupName" : null,
                "fundKey" : null,
                "funds": []
            };

            $http.get('/Reporting/FundPerformance/GeminiFund/Simple/' , {trackerMsg: 'Loading load fund group ' + groupId})
                .then(function (res) {
                    $scope.funds = res.data;
                });
        }
    }


    // PUBLIC METHODS
    $scope.saveGroup = function( form ) {
        if (!form.$valid) return;

        $scope.fundGroup.funds = $scope.current.selectedItems.map("id");

        var args = groupId > 0 ? {method: "PUT", id: groupId, trackerMsg: "Saving group " + groupId} : {method: "POST", id: "", trackerMsg: "Adding fund group"};

        $http( { method: args.method, url: '/Reporting/FundPerformance/GeminiFundGroup/' + args.id , data: $scope.fundGroup, trackerMsg: args.trackerMsg } )
            .then(function() {
                $location.path( '/advisor/geminifundgroup' );
            });
    };

    $scope.findFund = function(){
        $dialog.search("geminifunds", "Select Fund", "Fund")
            .open()
            .then(function (result) {
                $scope.fundGroup.fundKey = result.id;
                $scope.fundGroup.fundName = result.name;
            });
    };

    // INIT
    $scope.current = {
        selectedItems :[]
    };

    $scope.rightsGeminiFund = $oasRights.forCode('GEMINIFUNDAPP');

    loadGroup( );
});

'use strict';

app.controller('GeminiFundTaxRateEditCtrl', function GeminiFundTaxRateEditCtrl($scope, $http, $location, $dialog, $oasRights, $routeParams) {
    // PRIVATE VARIABLES
    var taxId = $routeParams.id;

    // PRIVATE METHODS
    function loadTaxRate( ) {
        if( taxId != 0 ) {
            $http.get('/Reporting/FundPerformance/GeminiFundTax/' + taxId , {trackerMsg: 'Loading load tax rate ' + taxId})
                .then(function (response) {
                    $scope.fundTaxRate = response.data;
                });
        }
        else {
            $scope.current.isNew = true;

            $scope.fundTaxRate = {
                "id": 0,
                "longTermRate": null,
                "shortTermRate": null
            }
        }
    }


    // PUBLIC METHODS
    $scope.saveTaxRate = function( form ) {
        if (!form.$valid) return;

        var args = taxId != 0 ? {method: "PUT", id: taxId, trackerMsg: "Saving tax rate " + taxId} : {method: "POST", id: "", trackerMsg: "Adding tax rate"};

        $http( { method: args.method, url: '/Reporting/FundPerformance/GeminiFundTax/' + args.id , data: $scope.fundTaxRate, trackerMsg: args.trackerMsg } )
            .then(function() {
                $location.path( '/advisor/geminifundtax' );
            });
    };

    // INIT
    $scope.rightsGeminiFund = $oasRights.forCode('GEMINIFUNDAPP');
    $scope.current = {isNew : false};
    loadTaxRate( );
});

'use strict';

app.controller('GeminiFundCalendarEditCtrl', function GeminiFundCalendarEditCtrl($scope, $http, $location, $dialog, $oasRights, $routeParams) {
    // PRIVATE VARIABLES
    var date = $routeParams.id;
    var isNew = false;

    // PRIVATE METHODS
    function loadDate( ) {
        if( date != 0 ) {
            isNew = false;
            $http.get('/Reporting/FundPerformance/GeminiFundCalendar/' + date , {trackerMsg: 'Loading load calendar ' + date})
                .then(function (response) {
                    $scope.fundCalendar = response.data;
                });
        }
        else {
            isNew = true;
            $scope.fundCalendar = {
                "id": Date.create('today').formatted(),
                "isWeekend": null,
                "isHoliday": null
            }
        }
    }


    // PUBLIC METHODS
    $scope.saveDate = function( form ) {
        if (!form.$valid) return;

        var args = !isNew ? {method: "PUT", id: Date.create($scope.fundCalendar.id).format('{yyyy}-{MM}-{dd}'), trackerMsg: "Saving date " + Date.create($scope.fundCalendar.id).formatted()} : {method: "POST", id: "", trackerMsg: "Adding date"};
        var url = args.method === "PUT" ? '/Reporting/FundPerformance/GeminiFundCalendar/' + args.id : '/Reporting/FundPerformance/GeminiFundCalendar/Add';

        $http( { method: args.method, url: url , data: $scope.fundCalendar, trackerMsg: args.trackerMsg } )
            .then(function() {
                $location.path( '/advisor/geminifundcalendar' );
            });
    };

    // INIT
    $scope.rightsGeminiFund = $oasRights.forCode('GEMINIFUNDAPP');

    loadDate( );
});

'use strict';

app.controller('GeminiFundPerformanceCtrl', function GeminiFundPerformanceCtrl($scope, $http, $timeout, $oasRights, $portfolio, $dialog, $routeParams, entities, apps, $location){
    var settings = null;

    // PRIVATE METHODS
    function init(){
        $scope.getPerformance('Performance Viewer');
        if (settings != null) getPerformance(settings);
    }

    function getPerformanceData(settings){
        settings.startDate = Date.create(settings.startDate).formatted();
        settings.endDate = Date.create(settings.endDate).formatted();

        $http.post('/Reporting/FundPerformance/GeminiFund/Performance', settings, {trackerMsg: 'Loading performance data'} )
            .then(function (response) {
                $scope.performanceData = response.data;
            });
    }

    $scope.print = function(){
      window.print();
    };

    $scope.exportToExcel = function() {

        var details = $scope.performanceData.details.forEach(function(item){
            item.fundName = $scope.performanceData.fundName;
            item.fundKey = $scope.performanceData.fundKey;
        });

        var dataDetails = {
            columns: [
                {name: "Fund Name", field: "fundName"},
                {name: "Fund Key", field: "fundKey"},
                {name: "Date", field: "date"},
                {name: "Starting Value", field: "startValue"},
                {name: "Ending Value", field: "endValue"},
                {name: "Fund Price", field: "fundPrice"},
                {name: "Div Rate", field: "divRate"},
                {name: "ST Rate", field: "stRate"},
                {name: "LT Rate", field: "ltRate"},
                {name: "QDivRate", field: "qDivRate"},
                {name: "QSTRate", field: "qstRate"},
                {name: "Back End Load", field: "backLoad"},
                {name: "Perf Factor", field: "factor"},
                {name: "Performance", field: "performance"}
            ],
            data: $scope.performanceData.details
        };

        $http.post('/Utility/SlickGridExport/csv', dataDetails, {trackerMsg: 'Exporting grid'})
            .then(function (response) {
                window.location.href = response.headers("location") + "?Authorization=" + sessionStorage.oas_token;
            });


    };

    $scope.getPerformance = function(title ) {
        var dialogOpts = {
            backdrop : true,
            keyboard : true,
            backdropClick : true,
            templateUrl : 'advisor/modals/gemini-performance-params.html',
            controller : 'GeminiPerformanceParamsCtrl',
            hasAsOfDate : true,
            title : title ? title : null
        };

        var d = $dialog.dialog(dialogOpts);
        return d.open().then(function(rslt) {
            if( rslt ) {
                // Disable column if performance data is return and not growth of
                $scope.current.isGrowth = rslt.initialInvestment > 1;

                switch(rslt.details){
                    case 1:
                        $scope.current.details = "Period End";
                        break;
                    case 2:
                        $scope.current.details = "Daily";
                        break;
                    case 3:
                        $scope.current.details = "Monthly";
                        break;
                    case 4:
                        $scope.current.details = "Weekly";
                        break;
                }

                switch(rslt.includeTaxes){
                    case 0:
                        $scope.current.tax = 'None';
                        break;
                    case 1:
                        $scope.current.tax = 'Pre-Liquidation';
                        break;
                    case 2:
                        $scope.current.tax = 'Post-Liquidation';
                        break;
                }

                getPerformanceData(rslt);
            }
        });
    };


    // INTIALIZE
    $scope.rightsGeminiFund = $oasRights.forCode( "GEMINIFUNDAPP" );
    $scope.selectedIds = [];
    $scope.performanceData = null;

    $scope.current = {
        fundKey : null,
        isGrowth : false,
        details : 'Period End',
        tax: null
    };

    init();

});


'use strict';

app.controller('GeminiImportCtrl', function GeminiImportCtrl($scope, $oasRights){
    var settings = null;

    // PRIVATE METHODS
    function init(){
    }

    // INTIALIZE
    $scope.rightsGeminiFund = $oasRights.forCode( "GEMINIFUNDAPP" );

    $scope.current = {
        selectedItems : null
    };

    init();

});


'use strict';

app.service('$advisor',['$http','$location','$dialog', function($http, $location, $dialog){
    var self = this;

    self.searchFund = function(){
        return search('Select Fund');
    };

    // PRIVATE METHODS
    function search (  title ) {
        var dialogOpts = {
            backdrop : true,
            keyboard : true,
            backdropClick : true,
            templateUrl : 'advisor/modals/select-fund.html',
            controller : 'SelectFundCtrl',
            title : title ? title : null
        };

        var d = $dialog.dialog(dialogOpts);
        return d
            .open();
    }
}]);

'use strict';

app.controller('GeminiPerformanceParamsCtrl', function GeminiPerformanceParamsCtrl($scope, dialog, $http, $dialog, $settings) {
    // PRIVATE METHODS
    function init(){
        $scope.current.selectedFund = $settings.getSetting('selectedGeminiFundKey');
    }
    $scope.setDates = function(rangeName) {
        var startDate = Date.create('today');
        var endDate = Date.create('today');

        switch (rangeName) {
            case "last-month":
                startDate.addMonths(-1).beginningOfMonth();
                endDate.addMonths(-1).endOfMonth();
                break;
            case "last-year":
                startDate.addYears(-1).beginningOfYear();
                endDate.addYears(-1).endOfYear();
                break;
            case "last-quarter":
                endDate = endDate.getStartOfQuarter().addDays(-1);
                startDate = endDate.getStartOfQuarter();
                break;
            case "MTD":
                startDate.beginningOfMonth();
                break;
            case "QTD":
                startDate = startDate.getStartOfQuarter();
                break;
            case "YTD":
                startDate.beginningOfYear();
                break;
            case "roll-1-year":
                startDate.addYears(-1);
                endDate.addDays(-1);
                break;
            case "roll-3-year":
                startDate.addYears(-3);
                endDate.addDays(-1);
                break;
        }

        $scope.current.params.startDate = startDate;
        $scope.current.params.endDate = endDate;
    };

    // PUBLIC METHODS
    $scope.cancel = function( ) {
        dialog.close( null );
    };

    $scope.close = function( ) {
        if ($scope.current.selectedFund){
            $scope.current.params.fundKey = $scope.current.selectedFund.id;
            //$scope.current.params.initialInvestment = $scope.current.type === 'Return' ? 1 : $scope.current.params.initialInvestment;

            $scope.current.params.additionalPeriods = $scope.current.additionalPeriods.map(function(period){ return parseInt(period.split(',')[1])}).sum();

            $settings.setSetting( 'selectedGeminiFundKey', $scope.current.selectedFund );

            dialog.close
            ($scope.current.params);
        }
    };

    $scope.getInception = function(){
        $http.get('/Reporting/FundPerformance/GeminiFund/Inception/' + $scope.current.selectedFund.id, {trackerMsg: 'Get inception date'})
            .then(function(response){
               $scope.current.params.startDate = Date.create(response.data[0].inceptionDate).formatted();
            });
    };

    $scope.getStartingPrice = function(){
        var startDate = $scope.current.params.startDate;
        startDate = startDate instanceof Date && !isNaN(startDate.valueOf()) ?  startDate : Date.create(startDate);

        $http.get('/Reporting/FundPerformance/GeminiFund/StartPrice/' + $scope.current.selectedFund.id + "?asOfDate=" + startDate.format('{yyyy}-{MM}-{dd}'), {trackerMsg: 'Get starting price'})
            .then(function(response){
                $scope.current.params.initialInvestment = response.data.startPrice ? response.data.startPrice : 0;
            });
    };

    //INITIALIZE
    $scope.current = {
        // The name has commas so I can split it out later. Also the number in front is for ordering the item when viewing
        options : {'1,1': 'MTD', '2,2': 'QTD', '3,4': 'YTD', '4,8': '1 Yr', '5,16' : '3 Yr', '6,32' : '5 Yr', '7,64' : '10 Yr', '8,128' : 'Inception'},
        additionalPeriods: [],
        title : dialog.options.title ? dialog.options.title : 'Performance Viewer',
        type : 'Return',
        selectedFund : null,
        params : {
            fundKey : null,
            initialInvestment : 10000,
            startDate : Date.create('today'),
            endDate : Date.create('today'),
            includeLoad : false,
            annualize : false,
            additionalPeriods: 0,
            details: 1,
            includeTaxes : 0,
			useCurrentLoad : false
        }
    };

    init();

});

'use strict';

var productListCtrl = app.controller('ProductListCtrl', function ProductListCtrl( $scope, $http, $oasRights, $dialog, $timeout, $location, $window, apps, views, productsToGet, entities, productTypes, $portfolio, $route, $routeParams, API_CONFIG, splitIoService ) {

    // PRIVATE VARIABLES
    let sym = undefined;
    let initialDataLoaded = false;
    const recon_productsprices_myproductsoptimize_12258 = 'recon_productsprices_myproductsoptimize_12258';

    // PRIVATE METHODS
    function init() {
        splitIoService.getBoolTreatment(recon_productsprices_myproductsoptimize_12258).subscribe((isEnabled) => {
            $scope.isProductsPricesOptimizeEnabled = isEnabled;

            if( $routeParams.auditKey && $routeParams.auditKey ) {
                switch( $routeParams.auditKey ) {
                    case productsToGet.currentlyOwnedProducts.queryString:
                        $scope.current.selectedProductToGet = productsToGet.currentlyOwnedProducts;
                        break;
                    case productsToGet.hasEverOwnedProducts.queryString:
                        $scope.current.selectedProductToGet = productsToGet.hasEverOwnedProducts;
                        break;
                    case productsToGet.missingRiskCategories.queryString:
                        $scope.current.selectedProductToGet = productsToGet.missingRiskCategories;
                        $scope.current.showMissingAssetClassAuditControls = true;
                        break;
                    case productsToGet.missingAssetClasses.queryString:
                        $scope.current.selectedProductToGet = productsToGet.missingAssetClasses;
                        $scope.current.showMissingAssetClassAuditControls = true;
                        break;
                    case "bondproduct":
                        $scope.current.selectedProductToGet = productsToGet.hasEverOwnedProducts;
                        $scope.current.showMissingAssetClassAuditControls = true;
                        $scope.current.returnStyle = 'Bond Product Audit';
                        $scope.search.productType = 'Bond&productType=CD';
                        
                        if ($scope.isProductsPricesOptimizeEnabled) {
                            $scope.current.url = '/Portfolio/Products/Grid/Bond/New'
                        }

                        break;
                    case "productdescription":
                        $scope.current.selectedProductToGet = productsToGet.hasEverOwnedProducts;
                        $scope.current.showMissingAssetClassAuditControls = true;
                        $scope.current.returnStyle = 'Audit';
                        break;
                }
        
                if ($routeParams.auditKey != 'productdescription'){
                    if (!$scope.current.url) {
                        if ($scope.isProductsPricesOptimizeEnabled) {
                            $scope.current.url = '/Portfolio/Products/Grid/New';
                        } else {
                            $scope.current.url = '/Portfolio/Products';
                        }
                    }
                }
            } else {
                $scope.current.showSearchControls = true;
        
                if ($routeParams.productId){
                    $scope.current.selectedProductToGet = productsToGet.everOwnedProducts;
                    $scope.search.asOfDate = null;
        
                    $scope.search.id = parseInt( $routeParams.productId );
        
                    $scope.refreshGrid();
                }
            }

            $scope.loadGridReady = true;
        });        
    }

    // PUBLIC METHODS
    $scope.openEditor = function(isAdvisorProduct, tabCode) {
        if( $scope.selectedIds.length == 1 || isAdvisorProduct) {
            var d = $dialog.editor("products/editors/product-edit.html", "ProductEditCtrl", {
                args: function () {
                    return {
                        id: isAdvisorProduct ? 0 : $scope.selectedIds[0],
                        app: apps.productsAndPrices,
                        defaultTab: { code: tabCode ?? "productGeneral" },
                        extraInfo: null,
                        isNewGlobal: false,
                        isNewLocal: isAdvisorProduct,
                        isAdvisorProduct: isAdvisorProduct,
                        advisorPrefix: $scope.current.selected?.advisorPrefix,
                        isReturnGlobal: isAdvisorProduct ? true : false
                    };

                }
            });

            d.open().then(function (rslt) {
                if( rslt ) {
                    $scope.refreshGrid( );
                    //$scope.$broadcast('event:productlist-product-action', {action: 'refresh-grid'});
                    //$scope.$broadcast( 'event:productlist-product-action', {action: 'update-item', item: rslt } );
                }
            });
        } else {
            $portfolio.openMassEditor( entities.product.value, $scope.selectedIds, apps.productsAndPrices.name, {isGlobalProductUpdate: false} ).then(function(rslt) {
                if( rslt ) {
                    $scope.$broadcast('event:productlist-product-action', {action: 'update-items', items: rslt } );
                }
            });
        }
    };

    $scope.refreshGrid = function( ) {
        if( !$scope.current.url ) {
            if ($scope.isProductsPricesOptimizeEnabled) {
                $scope.current.url = '/Portfolio/Products/Grid/New';
            } else {
                $scope.current.url = '/Portfolio/Products';
            }
        }
        $timeout(function() { $scope.$broadcast('event:productlist-product-action', {action: 'refresh-grid'}); }, 0);
    };

    $scope.goToAssets = function( ) {
        $location.url('/portfolio/assets?entity=' + entities.product.value + '&entityId=' + $scope.selectedIds[0] );
    };

    $scope.goToPricesGlobal = function () {
        $location.url('/prices/global?productId=' + $scope.selectedIds[0]);
    };

    $scope.goToGlobalPriceReview = function () {
        $window.open(`#/products/prices/globalpricereview/${$scope.selectedIds[0]}`, '_blank');
    }

    $scope.goToPricesLocal = function () {
        $location.url('/prices/local?productId=' + $scope.selectedIds[0]);
    };

    $scope.goBack = function () {
        window.history.back();
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor();
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:productlist-product-action', {action: 'export-data'});
    };

    $scope.importProductClassWeighted = function () {
        $dialog.dialog({
            dialogClass: "modal medium",
            templateUrl: "app/modals/upload-file.html",
            controller: "UploadFileCtrl",
            title: "Product Class Weighted Import",
            idField: "recordId",
            downloadUrl: '/Portfolio/ValidateImport/ProductClassWeighted/Templates/',
            validateUrl: '/Portfolio/ValidateImport/ProductClassWeighted',
            commitVerb: 'PUT',
            commitUrl: '/Portfolio/ValidateImport/ProductClassWeighted/Import'})
            .open();
    };

    $scope.importProductCategoryWeighted = function () {
        $dialog.dialog({
            dialogClass: "modal medium",
            templateUrl: "app/modals/upload-file.html",
            controller: "UploadFileCtrl",
            title: "Product Category Weighted Import",
            idField: "recordId",
            downloadUrl: '/Portfolio/ValidateImport/ProductCategoryWeighted/Templates/',
            validateUrl: '/Portfolio/ValidateImport/ProductCategoryWeighted',
            commitVerb: 'PUT',
            commitUrl: '/Portfolio/ValidateImport/ProductCategoryWeighted/Import'})
            .open();
    };

    $scope.deleteProductWeightings = function () {
        $dialog.dialog({templateUrl: "product-weightings-delete.html", controller: "ProductWeightingsDeleteCtrl"}).open();
    };

    $scope.openSchwabResearchCenter = function() {
        let symbol = '';
        if (sym && sym !== '') {
            symbol = `&symbol=${sym}`;
        }
        //$window.open(API_CONFIG.baseUrl + '/Integrations/SchwabSII/SSO?pageId=4&Authorization=' + sessionStorage.oas_token);
        $window.open(API_CONFIG.baseUrl + '/Integrations/SchwabSII/SsoV2/4?Authorization=' + sessionStorage.oas_token + symbol);
    };

    $scope.canResetAssetClass = function(){
        var assetClassResetRights = $oasRights.forCode("RESETASSETCLASS");
        return assetClassResetRights.canRead | assetClassResetRights.canDelete | assetClassResetRights.canUpdate;
    };

    $scope.resetAssetClass = function() {
        $dialog.confirmAction("Are you sure you want to reset asset classes? <br><br>This process will perform the following actions." +
            "<ul>" +
            "<li>All products will be assigned to the default asset class.</li>" +
            "<li>Remove all asset class/category weightings from all products.</li>"+
            "<li>Update sweep asset class for any custodians to the default asset class.</li>"+
            "<li>Delete all asset classes except the default asset class and (SCRTY,CASH,B).</li>"+
            "<li>Delete all asset categories except Bond, Equity, and Money Market.</li>"+
            "</ul>"+
            "<b>WARNING!!! The above actions can not be undone!")
            .open()
            .then ( function (result){
                if ( result == "yes"){
                    $http({
                        method: 'PUT',
                        url: '/Portfolio/ProductClasses/Reset',
                        trackerMsg: 'Resetting asset classes.'
                    }).then(function (response) {
                            if ( response.status === 200){
                                $dialog.messageBox("", "Asset classes have been reset.").open();
                            }
                        });
                }
            });
    };

    // INITIALIZE
    $scope.rightsProductsAndPrices = $oasRights.forCode("PRODSANDPRICESAPP");
    $scope.rightsProducts = $oasRights.forCode("PRODUCTS");
    $scope.rightsAssets = $oasRights.forCode("ASSETS");
    $scope.rightsSchwabSII = $oasRights.forCode("SCHWABSII");
    $scope.rightsAdvisorProduct = $oasRights.forCode("ADVISORPRODUCTS");
    $scope.rightsPrices = $oasRights.forCode("PRICES");
    $scope.rightsLocalPrices = $oasRights.forCode("LOCALPRICES");
    $scope.rightsGlobalProducts = $oasRights.forCode("GLOBALPRODUCT");
    $scope.rightsCorporateAction = $oasRights.forCode("CORPACTION"),
    $scope.rightsGlobalPriceReview = $oasRights.forCode("GLOBALPRICEREVIEW");

    $scope.views = views;

    $scope.selectedIds = [];
    $scope.search = { name: '', symbol: '', id: '', productType: null, matchingType: 'Like', asOfDate: null, fundFamilyId: null };
    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        selectedProductToGet: productsToGet.everOwnedProducts,
        url: null,
        isMyCurrentProductLink: false,
        productsToGet: productsToGet,
        showSearchControls: false,
        showMissingAssetClassAuditControls: false,
        assetClassAuditUseDate: false,
        returnStyle: 'Standard',
        selected: null
    };

    $scope.matchingTypes = [ 'Like', 'Exact' ];

    $scope.current.isMyCurrentProductLink = $location.path().has('currentlyownedproducts');

    $scope.productTypes = [];
    $scope.productTypes.push( {id: null, name: '(all)'} );
    $scope.isProductsPricesOptimizeEnabled = false; 
    $scope.loadGridReady = false;

    productTypes.keys( ).forEach( function( key ) {
        $scope.productTypes.push( {id: parseInt( productTypes[key].value ), name: productTypes[key].name} )
    } );

    if ($routeParams.source) {
        var key = apps.find({code: $routeParams.source});
        $scope.middleBreadcrumb = key ? apps[key].name : null;
    }   

    $scope.$watch('current.selectedProductToGet', function(newVal, oldVa){
        if(newVal != oldVa ) {
            if (newVal === productsToGet.everOwnedProducts)
                $scope.search.asOfDate = null;
        }
    });

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            $scope.openEditor();
    }}];


    $scope.$on('slickgrid-data-loaded', function (event, data) {
        if (!initialDataLoaded) {
            initialDataLoaded = true;

            // open editor on first data load
            if ($routeParams.openEditor && $scope.rightsProducts.canRead && $routeParams.productId) {
                $scope.selectedIds.push($routeParams.productId);
                $scope.openEditor(false);
            }
        }
    })

    /**
     * Set symbol value from selected row
     */
    $scope.$on("event:row-select-evt",
        function (e, args) {
            if (args.length === 0) return;
            $scope.current.selected = args[0];
            sym = args[0].ticker;
        });

    init();
});

productListCtrl.loadProductViews = ["$http", "$route", function($http, $route){
    var dto;
    switch ($route.current.params.auditKey ? $route.current.params.auditKey.toLowerCase() : "") {
        case "bondproduct":
            dto = "LocalProductBondAuditDto";
            break;
        case "bondrate":
            dto = "GlobalProductDto";
            break;
        case "productdescription":
            dto = "LocalProductWithProviderColumnsDto";
            break;
        default:
            dto = "LocalProductDto";
            break;
    }

    return $http.get('/Settings/Views/' + dto, {trackerMsg : 'Loading product views'}).then(function(response) {return response.data});
}];

app.controller('ProductWeightingsDeleteCtrl', function ProductWeightingsDeleteCtrl( $scope, dialog, $http, $dialog, $oasRights ) {
    //PRIVATE VARIABLES

    //PRIVATE METHODS

    //PUBLIC METHODS
    $scope.deleteProductWeightings = function( ) {
        $dialog.confirmAction( "Are you sure you want to remove product weightings for all products?" )
            .open()
            .then( function( result ) {
                if( result === 'yes' ) {
                    $http.post("/Portfolio/Products/Weightings/Remove?" + Object.toQueryString($scope.current), null, {trackerMsg: "Removing product weightings"})
                        .then(function () {
                            $dialog.actionComplete("Product Weightings Removed.").open().then(function () {
                                dialog.close(null);
                            });
                        });
                }
            } );
    };

    $scope.cancel = function( ) {
        dialog.close(null);
    };

    //INITIALIZE
    $scope.rightsProducts = $oasRights.forCode("PRODUCTS");
    $scope.current = { removeAssetClassWeightings: true, removeAssetCategoryWeightings: true };

});
'use strict';

app.controller('ProductGlobalListCtrl', function ProductGlobalListCtrl( $scope, $http, $oasRights, $dialog, $timeout, $location, $window, apps, views, entities, productTypes, $portfolio, $routeParams, splitIoService ) {
    // PRIVATE VARIABLES

    // PRIVATE METHODS
    function init() {
    }

    // PUBLIC METHODS
    $scope.openEditor = function( isNewGlobal, isNewLocal, isAdvisorProduct, tabCode) {
        if( $scope.selectedIds.length == 1 || isNewGlobal || isNewLocal || isAdvisorProduct ) {
            var d = $dialog.editor("products/editors/product-edit.html", "ProductEditCtrl", {
                args: function () {
                    return {
                        id: isNewGlobal || isAdvisorProduct ? null : $scope.selectedIds[0],
                        app: apps.productsAndPrices,
                        defaultTab: { code: tabCode ?? "productGlobal" },
                        extraInfo: null,
                        isNewGlobal: isNewGlobal,
                        isNewLocal: isNewLocal,
                        isAdvisorProduct: isAdvisorProduct,
                        advisorPrefix: $scope.current.selected?.advisorPrefix,
                        isReturnGlobal: true
                    };

                }
            });

            d.open().then(function (rslt) {
                if( rslt ) {
                    //$scope.$broadcast( 'event:productgloballist-product-action', {action: isNewGlobal || isNewLocal ? 'add-item' : 'update-item', item: rslt } );
                    //$scope.$broadcast('event:productgloballist-product-action', {action: 'refresh-grid'});
                }
            });
        } else {
            $portfolio.openMassEditor( entities.product.value, $scope.selectedIds, apps.productsAndPrices.name, {isGlobalProductUpdate: true} ).then(function(rslt) {
                if( rslt ) {
                    $scope.$broadcast( 'event:productlist-product-action', {action: 'update-items', items: rslt } );
                }
            });
        }
    };

    $scope.addProductToLocal = function () {
        if ($scope.selectedIds.length == 1) {
            var id = $scope.selectedIds[0];
            $http.get("/Portfolio/Products/Verbose/New/" + id)
                .then(function (r) {
                    const verboseLocalProduct = r.data;
                    $http.post('/Portfolio/Products/Verbose/', verboseLocalProduct, { trackerMsg: 'adding local product' })
                        .then(function (response) {
                            $dialog.saveSuccessful("Product added to local database.").open();
                        });
                });
        }
    }

    $scope.refreshGrid = function( ) {
        if( !$scope.current.url ) {
            $scope.current.url = '/Global/Products';
            $timeout(function() { $scope.$broadcast('event:productgloballist-product-action', {action: 'refresh-grid'}); }, 0);
        }
        $scope.$broadcast('event:productgloballist-product-action', {action: 'refresh-grid'});
    };

    $scope.goToAssets = function( ) {
        $location.url('/portfolio/assets?entity=' + entities.product.value + '&entityId=' + $scope.selectedIds[0] );
    };

    $scope.goToPricesGlobal = function () {
        $location.url('/prices/global?productId=' + $scope.selectedIds[0]);
    };

    $scope.goToGlobalPriceReview = function () {
        $window.open(`#/products/prices/globalpricereview/${$scope.selectedIds[0]}`, '_blank');
    }

    $scope.goToPricesLocal = function () {
        $location.url('/prices/local?productId=' + $scope.selectedIds[0]);
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false, false);
    };


    // INITIALIZE
    $scope.rightsProductsAndPrices = $oasRights.forCode("PRODSANDPRICESAPP");
    $scope.rightsGlobalProducts = $oasRights.forCode("GLOBALPRODUCT");
    $scope.rightsAssets = $oasRights.forCode("ASSETS");
    $scope.rightsPrices = $oasRights.forCode("PRICES");
    $scope.rightsLocalPrices = $oasRights.forCode("LOCALPRICES");
    $scope.rightsCorporateAction = $oasRights.forCode("CORPACTION"),
    $scope.rightsGlobalPriceReview = $oasRights.forCode("GLOBALPRICEREVIEW");

    $scope.views = views;

    $scope.selectedIds = [];
    $scope.search = { name: '', ticker: '', cusip: '', id: '', productType: '', matchingType: 'Like', fundFamily: null };
    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        filterType: '',
        url: null,
        selected: null
    };

    $scope.matchingTypes = [ 'Like', 'Exact' ];

    $scope.productTypes = [];
    $scope.productTypes.push( {id: null, name: '(all)'} );

    productTypes.keys( ).forEach( function( key ) {
        $scope.productTypes.push( {id: parseInt( productTypes[key].value ), name: productTypes[key].name} )
    } );

    if ($routeParams.auditKey){
        if ($routeParams.auditKey === 'bondrate'){
            $scope.current.filterType = 'Bond without Bond Rates';
            $scope.refreshGrid();
        }
    }

    if ($routeParams.productId) {
        $scope.search.id = parseInt($routeParams.productId);
        $scope.refreshGrid();
    }

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        $scope.openEditor(false, false);
    }}];

    $scope.$on("event:row-select-evt",
        function (e, args) {
            if (args.length === 0) return;
            $scope.current.selected = args[0];
        });
    
    init();
});
'use strict';

app.controller('ProductEditCtrl', ['$scope', 'ProductsAndPrices', '$http', '$oasRights', '$dialog', '$q', '$location', '$portfolio', '$timeout', 'dialog', 'args', 'productStatuses', 'productTypes', 'pricingStatuses', 'entities', 'preferredRateFrequency', 'apps', 'paymentFrequency', 'paymentCycleDateTypes', '$window', 'splitIoService', function ProductEditCtrl($scope, ProductsAndPrices, $http, $oasRights, $dialog, $q, $location, $portfolio, $timeout, dialog, args, productStatuses, productTypes, pricingStatuses, entities, preferredRateFrequency, apps, paymentFrequency, paymentCycleDateTypes, $window, splitIoService) {

    //region PRIVATE VARIABLES
    var productGeneralOriginal,
        productGlobalOriginal,
        downloadSymbolsOriginal,
        fundFamiliesOriginal,
        fundFamilyOverrideOriginal,
        assetCategoryWeightingsOriginal,
        assetClassWeightingsOriginal,
        propertyRegionWeightingsOriginal,
        propertyTypeWeightingsOriginal,
        advisorProductsAlClientsOriginal=[],
        bondRatesOriginal,
        corporateActionsOriginal,
        dividendsOriginal,
        assumedRatesOriginal,
        preferredRatesOriginal,
        priceFactorsOriginal,
        productSubstitutionOriginal,
        bondCallsOriginal,
        entityOptionsOriginal,
        customFieldsOriginal,
        customTSFieldsOriginal,
        billingGeneralOriginal,
        alternativeExpectedReturnsOriginal,
        editorHotKeys,
        globalAlClients;

    //endregion

    //region PRIVATE METHODS
    function init() {

        loadEnumLookUps();
        loadRights();
        buildMenu();
        loadHotKeys();
        loadProductManagers();

        canViewDatabaseAssignment();

        loadDatabases();

        if (args.defaultTab.code) {
            if (args.defaultTab.code !== 'productGeneral' && args.defaultTab.code !== 'productGlobal') {
                //Always load the local product tab to ensure the modal title bar is populated
                $scope.loadTab({ code: 'productGeneral' });
            }

            $scope.loadTab(args.defaultTab);
        } else {
            //Always load the local product tab to ensure the modal title bar is populated
            $scope.loadTab({ code: 'productGeneral' });
        }

        backgroundLoadOtherGlobalTabs();
        backgroundLoadOtherLocalTabs();

        $scope.current.masterGroup = args.advisorPrefix;
        if (args.isNewGlobal || args.isNewLocal) {
            loadMasterGroup();
        }

        splitIoService.getBoolTreatment('opex_Exclude_Assets_by_Bill_Entity_on_editors_31734')
            .subscribe(function (isEnabled) {
                $scope.excludeByBillEntitySplitEnabled = isEnabled;
            });

        $http.get("/Settings/Database/EntityOptions/Code/BILLUSEFEHI", { trackerMsg: 'Checking Use Fee Hierarchy options' })
            .then(function (response) {
                $scope.current.entityUseFeeHierarchy = response.data.value === "True";
            });

        $scope.feeBillExclusionModes = [
            { value: 0, label: 'No' },
            { value: 1, label: 'Yes' },
            { value: 2, label: 'Select Bill Entities' }
        ];
        $scope.selectBillEntitiesModalOpen = false;
        $scope.billEntityExclusionListExpanded = false;
        $scope.billEntityPickerSource = null;
    }

    function backgroundLoadOtherGlobalTabs() {
        if (args.isNewGlobal || args.isNewLocal) return;

        if ($scope.rightsBondRates.canRead || $scope.rightsGlobalProducts.canRead || $scope.rightsPreferredRates.canRead) {
            var globalProductsUrl = `/Global/Products/Verbose/${args.id}`;
            var params = { expand: [] };

            if ($scope.rightsBondRates.canRead && !$scope.assumedRates) {
                params.expand.push('bondRates');
            }
    
            if ($scope.rightsGlobalProducts.canRead) {
                if (!$scope.downloadSymbols) {
                    params.expand.push('downloadSymbols');
                }
                if (!$scope.fundFamilies) {
                    params.expand.push('fundFamilies');
                }
            }
    
            if ($scope.rightsPreferredRates.canRead && !$scope.preferredRates) {
                params.expand.push('preferredRates');
            }

            // dont show a tracker message as this gets called in the background to help speed up clicking on other tabs
            $http.get(globalProductsUrl, { params: params }).then(function (response) {
                if ($scope.rightsBondRates.canRead) {
                    loadBondRates(response);
                }

                if ($scope.rightsGlobalProducts.canRead) {
                    loadDownloadSymbols(response);
                    loadFundFamilies(response);
                }

                if ($scope.rightsPreferredRates.canRead) {
                    loadPreferredRates(response);
                }
            });
        }
    }

    function backgroundLoadOtherLocalTabs() {
        if (args.isNewGlobal || args.isNewLocal) return;

        if ($scope.rightsAssumedRates.canRead || $scope.rightsEOs.canRead || $scope.rightsProducts.canRead) {
            var localProductsUrl = `/Portfolio/Products/Verbose/${args.id}`;
            var params = { expand: [] };

            if ($scope.rightsAssumedRates.canRead && !$scope.assumedRates) {
                params.expand.push('assumedRates');
            }
    
            if ($scope.rightsEOs.canRead && !$scope.entityOptions) { 
                params.expand.push('entityOptions');
            }
    
            if ($scope.rightsProducts.canRead) {
                if (!$scope.productSubstitution) {
                    params.expand.push('productGroup');
                }
                if (!$scope.customFields) {
                    params.expand.push('userDefinedFields');
                }
                if (!$scope.customTSFields) {
                    params.expand.push('userDefinedTimeFields');
                }
            }

            // dont show a tracker message as this gets called in the background to help speed up clicking on other tabs
            $http.get(localProductsUrl, { params: params }).then(function (response) {
                if ($scope.rightsAssumedRates.canRead) {
                    loadAssumedRates(response);
                }
        
                if ($scope.rightsEOs.canRead) { 
                    loadEntityOptions(response);
                }
        
                if ($scope.rightsProducts.canRead) {
                    loadProductSubstitution(response);
                    loadCustomFields(response);
                    loadCustomTSFields(response);
                }
            });
        }        
    }

    function checkBillingLockdown(){
        $http.get("/Authorization/User/Databases/LockDown", { trackerMsg: 'Checking Billing Lockdown' })
        .then(function (response) {
            let isBillingLockdownOverridePrivilege = $oasRights.forCode("billingLockdownOverride").canRead;
            $scope.isBillingLockdown = isBillingLockdownOverridePrivilege ? false : response.data === 'Billing';
        });
    }

    function loadRights() {
        $scope.rightsProducts = $oasRights.forCode("PRODUCTS");
        $scope.rightsGlobalProducts = $oasRights.forCode("GLOBALPRODUCT");
        $scope.rightsAssetCategory = $oasRights.forCode("PRODUCTCATEGORY");
        $scope.rightsAssetClass = $oasRights.forCode("ASSETCLASSES");
        $scope.rightsPropertyRegion = $oasRights.forCode("PRODUCTS");
        $scope.rightsPropertyType = $oasRights.forCode("PRODUCTS");
        $scope.rightsAlternativeExpectedReturns = $oasRights.forCode("ACCOUNTCOMPOSER");
        $scope.rightsBilling = $oasRights.forCode("ACCTBILLING");
        $scope.rightsSubHolding = $oasRights.forCode("SUBHOLDING");
        $scope.rightsBondRates = $oasRights.forCode("BONDRATES");
        $scope.rightsCorporateActions = $oasRights.forCode("CORPACTION");        
        $scope.rightsDividends = $oasRights.forCode("DIVIDENDS");
        $scope.rightsAssumedRates = $oasRights.forCode("ASSUMEDRATES");
        $scope.rightsPriceFactors = $oasRights.forCode("PRICEFACTORS");
        $scope.rightsPreferredRates = $oasRights.forCode("PREFERREDRATES");
        $scope.rightsBondCall = $oasRights.forCode("PRODUCTBONDCALL");
        $scope.rightsEOs = $oasRights.forCode("ENTITYOPTION");
        $scope.rightsUseLocalPricesOnly = $oasRights.forCode("USELOCALPRICESONLY");
        $scope.rightsPerformanceAdmin = $oasRights.forCode("PERFORMANCEADMIN");
        $scope.rightsAdvisorProduct = $oasRights.forCode("ADVISORPRODUCTS");
        $scope.rightsManagedStatus = $oasRights.forCode("MANAGEDSTATUS");
        $scope.rightsOrionVisionApp = $oasRights.forCode("ORIONVISION");
        $scope.rightsLocalProductNameOverride = $oasRights.forCode("LOCALPRODUCTNAMEOVERRIDE");
        $scope.rightsPrices = $oasRights.forCode("PRICES");
        $scope.rightsLocalPrices = $oasRights.forCode("LOCALPRICES");
        $scope.rightsCusipAccess = $oasRights.forCode("CUSIPACCESS");
        $scope.rightsCusipAdmin = $oasRights.forCode("CUSIPADMIN");
        $scope.isAdvisor = $scope.user.authorization.entity === 'Advisor';
        $scope.rightsGlobalPriceReview = $oasRights.forCode("GLOBALPRICEREVIEW");
        $scope.rightsSecurityClassificationSetup = $oasRights.forCode("securityClassificationSetup");
        $scope.rightsSecurityClassAssignment = $oasRights.forCode("securityClassAssignment");
    }

    //  Check if the global CShareClassExclusion entity option is true, and then if this is a C Share (c1,c2,c3)
    function CShareCheck(){
        $http.get("/Settings/Database/EntityOptions/Code/CSHAREEXCLUSION", {trackerMsg: 'Checking For C Share Exclusion'})
        .then(function (response) {
            $scope.current.cShareExclusionEO = response.data.value === "True";

            if (response.data.value === "True" && 
                ($scope.productGlobal.shareClassId == '18' 
                || $scope.productGlobal.shareClassId == '2015' 
                || $scope.productGlobal.shareClassId == '2016' )){

                    $scope.current.cShareExclusion = true;
                    $scope.billingGeneral.isFeeExcluded = true;
                
            }
        });
    }


    function buildMenu() {
        var i = 0;
        $scope.menu = {categories: []};

        $scope.menu.categories.push({name: 'Product', children: []});

        //the isAdvisor will only be taken into consideration when Advisor Product is clicked.  Since this menu item
        //is only available under local Products tab, the advisor won't have access to global products.
        if (!args.isNewGlobal || $scope.isAdvisor) {
            $scope.menu.categories[i].children.push({name: 'Local', active: false, code: 'productGeneral'});
        }

        if ($scope.rightsGlobalProducts.canRead || ($scope.rightsAdvisorProduct.canRead && args.isAdvisorProduct) || args.isNewLocal) {
            $scope.menu.categories[i].children.push({name: 'Global', active: false, code: 'productGlobal'});
        }

        if (!$scope.current.isNew && $scope.rightsSecurityClassificationSetup.canRead && $scope.rightsSecurityClassAssignment.canRead) {
            $scope.menu.categories[i].children.push({
                name: 'Security Class Assignment',
                active: false,
                isLink: true,
                link: '#/securityclassification/products/' + $scope.current.productId
            });
        }

        if (!( args.isNewGlobal || args.isAdvisorProduct)) {
            if (
                $scope.rightsAssetCategory.canRead ||
                $scope.rightsAssetClass.canRead ||
                $scope.rightsPropertyRegion.canRead ||
                $scope.rightsPropertyType.canRead
            ) {
                $scope.menu.categories[i].children.push({name: 'Product Weightings', active: false, code: 'productWeightings'});
            }
        }

        if ($scope.rightsAlternativeExpectedReturns.canRead && !args.isAdvisorProduct) {
            $scope.menu.categories[i].children.push({name: 'Alt/PE Expected Returns', active: false, code: 'alternativeExpectedReturns'});
        }

        if ($scope.rightsGlobalProducts.canRead && !args.isAdvisorProduct) {
            $scope.menu.categories[i].children.push({name: 'Download Symbols', active: false, code: 'downloadSymbols'});
        }

        if ($scope.rightsGlobalProducts.canRead && !args.isAdvisorProduct) {
            $scope.menu.categories[i].children.push({name: 'Fund Families', active: false, code: 'fundFamilies'});
        }

        i++;

        if (!$scope.current.isNew) {
            $scope.menu.categories.push({ name: 'Prices', children: [] });
            var startDate, endDate = Date.create().formatted();

            if ($scope.rightsPrices.canRead) {
                startDate = Date.create().addMonths(-3).formatted();
                $scope.menu.categories[i].children.push({ name: 'Global', active: false, isLink: true, link: '#/prices/global?productId=' + $scope.current.productId + '&startDate=' + startDate + '&endDate=' + endDate });
            }

            if ($scope.rightsGlobalPriceReview.canRead) {
                $scope.menu.categories[i].children.push({ name: 'Global Review', active: false, isLink: true, link: `#/products/prices/globalpricereview/${$scope.current.productId}` });
            }

            if ($scope.rightsLocalPrices.canRead) {
                startDate = Date.create().addMonths(-6).formatted();
                $scope.menu.categories[i].children.push({ name: 'Local', active: false, isLink: true, link: '#/prices/local?productId=' + $scope.current.productId + '&startDate=' + startDate + '&endDate=' + endDate });
            }

            i++;
        }

        if (!args.isAdvisorProduct) {
            $scope.menu.categories.push({name: 'Market Data', children: []});
        }

        if(!args.isAdvisorProduct){
            if ($scope.rightsBondRates.canRead) {
                $scope.menu.categories[i].children.push({name: 'Bond Rates', active: false, code: 'bondRates'});
            }
        }

        if (!(args.isNewGlobal || args.isAdvisorProduct)) {
            if ($scope.rightsCorporateActions.canRead) {
                $scope.menu.categories[i].children.push({name: 'Corporate Actions', active: false, code: 'corporateActions'});
            }

            if ($scope.rightsDividends.canRead) {
                $scope.menu.categories[i].children.push({name: 'Dividends', active: false, code: 'dividends'});
            }

            if ($scope.rightsAssumedRates.canRead) {
                $scope.menu.categories[i].children.push({name: 'Assumed Rates', active: false, code: 'assumedRates'});
            }
        }

        if(!args.isAdvisorProduct){
            if ($scope.rightsPreferredRates.canRead) {
                $scope.menu.categories[i].children.push({name: 'Preferred Rates', active: false, code: 'preferredRates'});
            }
        }

        if (!(args.isNewGlobal || args.isAdvisorProduct)) {
            if ($scope.rightsPriceFactors.canRead && $scope.user.authorization.entity === 'Administrator' ) {
                $scope.menu.categories[i].children.push({name: 'Price Factors', active: false, code: 'priceFactors'});
            }
        }

        i++;

        if (!(args.isNewGlobal || args.isAdvisorProduct)) {
            $scope.menu.categories.push({ name: 'Trading', children: [] });

            $scope.menu.categories[i].children.push({ name: 'Product Substitution', active: false, code: 'productSubstitution' });
            if (!args.isReturnGlobal) {
                $scope.menu.categories[i].children.push({ name: 'Fund Family Overrides', active: false, code: 'fundFamilyOverride' });
                $scope.executionSymbol = "Add execution symbols for fund families that use different symbols than the product symbol during trade execution.";
                $scope.alternativeSymbol = "Add an alternative security to be used instead of the product for a fund family.";
            }
            i++;
        }

        if ( (!args.isNewGlobal) && $scope.rightsBondCall.canRead ) {
            $scope.menu.categories.push({name: 'Pricing', children: [{name: 'Bond Call', active: false, code: 'bondCall'}]});
            i++;
        }

        if (!( args.isNewGlobal || args.isAdvisorProduct )) {
            $scope.menu.categories.push({name: 'Settings', children: []});

            $scope.menu.categories[i].children.push({name: 'Custom Fields', active: false, code: 'customFields'});

            $scope.menu.categories[i].children.push({name: 'Time Based Custom Fields', active: false, code: 'customTSFields'});

            if ($scope.rightsEOs.canRead) {
                $scope.menu.categories[i].children.push({name: 'Options', active: false, code: 'entityOptions'});
            }
        }

        if (!( args.isNewGlobal || args.isAdvisorProduct )){
            i++;
            $scope.menu.categories.push({name: 'Billing', children:[]});
            $scope.menu.categories[i].children.push({name: 'General', active: false, code:'billingGeneral'})
        }
    }

    function checkTabForDirty() {
        if ($scope.current.selectedTab && $scope.current.selectedTab.length > 0) {
            var tabDirty = false;
            switch ($scope.current.selectedTab) {
                case "productGeneral":
                    tabDirty = !angular.equals(productGeneralOriginal, $scope.productGeneral);
                    break;
                case "productGlobal":
                    tabDirty = !angular.equals(productGlobalOriginal, $scope.productGlobal);
                    break;
                case "downloadSymbols":
                    tabDirty = !angular.equals(downloadSymbolsOriginal, $scope.downloadSymbols);
                    break;
                case "fundFamilies":
                    tabDirty = !angular.equals(fundFamiliesOriginal, $scope.fundFamilies);
                    break;
                case "fundFamiliesOverride":
                    tabDirty = !angular.equals(fundFamiliesOriginal, $scope.fundFamiliesOverriden);
                    break;
                case "productWeightings":
                    tabDirty = (
                        !angular.equals(assetCategoryWeightingsOriginal, $scope.assetCategoryWeightings) ||
                        !angular.equals(assetClassWeightingsOriginal, $scope.assetClassWeightings) ||
                        !angular.equals(propertyRegionWeightingsOriginal, $scope.propertyRegionWeightings) ||
                        !angular.equals(propertyTypeWeightingsOriginal, $scope.propertyTypeWeightings)
                    );
                    break;
                case "bondRates":
                    tabDirty = !angular.equals(bondRatesOriginal, $scope.bondRates);
                    break;
                case "corporateActions":
                    tabDirty = !angular.equals(corporateActionsOriginal, $scope.corporateActions);
                    break;
                case "dividends":
                    tabDirty = !angular.equals(dividendsOriginal, $scope.dividends);
                    break;
                case "assumedRates":
                    tabDirty = !angular.equals(assumedRatesOriginal, $scope.assumedRates);
                    break;
                case "preferredRates":
                    tabDirty = !angular.equals(preferredRatesOriginal, $scope.preferredRates);
                    break;
                case "priceFactors":
                    tabDirty = !angular.equals(priceFactorsOriginal, $scope.priceFactors);
                    break;
                case "productSubstitution":
                    tabDirty = !angular.equals(productSubstitutionOriginal, $scope.productSubstitution);
                    break;
                case "bondCall":
                    tabDirty = !angular.equals(bondCallsOriginal, $scope.bondCalls);
                    break;
                case "entityOptions":
                    tabDirty = !angular.equals(entityOptionsOriginal, $scope.entityOptions);
                    break;
                case "customFields":
                    if ($scope.customFields) {
                        tabDirty = !angular.equals(customFieldsOriginal, $scope.customFields);
                    }
                    break;
                case "customTSFields":
                    if ($scope.customTSFields) {
                        tabDirty = !angular.equals(customTSFieldsOriginal, $scope.customTSFields);
                    }
                    break;
            }

            $scope.menu.categories.each(function (c) {
                c.children.each(function (ch) {
                    if (ch.code == $scope.current.selectedTab) {
                        ch.isDirty = tabDirty;
                    }
                });
            });
        }
    }

    function loadDataForSelectedTab() {
        switch ($scope.current.selectedTab) {
            case "productGeneral":
            case "productGlobal":
                if ($scope.rightsProducts.canRead) {
                    loadProductGeneral();
                }
                if ($scope.rightsGlobalProducts.canRead ||  ($scope.rightsAdvisorProduct.canRead && args.isAdvisorProduct))  {
                    loadProductGlobal();
                }
                break;
            case "downloadSymbols":
                if ($scope.rightsGlobalProducts.canRead) {
                    loadDownloadSymbols();
                }
                break;
            case "fundFamilies":
                if ($scope.rightsGlobalProducts.canRead) {
                    loadFundFamilies();
                }
                break;
            case "fundFamilyOverride":
                if ($scope.rightsGlobalProducts.canRead) {
                    loadFundFamilyOverrides();
                }
                break;
            case "productWeightings":
                if ($scope.rightsAssetCategory.canRead || $scope.rightsAssetClass.canRead) {
                    loadProductWeightings();
                }
                break;
            case "alternativeExpectedReturns":
                if ($scope.rightsAlternativeExpectedReturns.canRead) {
                    checkForExpectedReturnWarning();
                    loadAlternativeExpectedReturns();
                }
                break;
            case "bondRates":
                if ($scope.rightsBondRates.canRead) {
                    checkForBondRateWarning();
                    loadBondRates();
                }
                break;
            case "corporateActions":
                if ($scope.rightsCorporateActions.canRead) {
                    loadCorporateActions(false);
                }
                break;
            case "dividends":
                if ($scope.rightsDividends.canRead) {
                    loadDividends(false);
                }
                break;
            case "assumedRates":
                if($scope.rightsAssumedRates.canRead) {
                    loadAssumedRates();
                }
                break;
            case "preferredRates":
                if ($scope.rightsPreferredRates.canRead) {
                    checkForPreferredRateWarning();
                    loadPreferredRates();
                }
                break;
            case "priceFactors":
                if ($scope.rightsPriceFactors.canRead) {
                    checkForPriceFactorWarning();
                    loadPriceFactors(false);
                }
                break;
            case "productSubstitution":
                if ($scope.rightsProducts.canRead) {
                    loadProductSubstitution();
                }
                break;
            case "bondCall":
                if ($scope.rightsBondCall.canRead) {
                    loadBondCallPrices();
                }
                break;
            case "entityOptions":
                if ($scope.rightsEOs.canRead) {
                    loadEntityOptions();
                }
                break;
            case "customFields":
                if ($scope.rightsProducts.canRead) {
                    loadCustomFields();
                }
                break;
            case "customTSFields":
                if ($scope.rightsProducts.canRead) {
                    loadCustomTSFields();
                }
                break;
            case "billingGeneral":
                if ($scope.rightsBilling.canRead) {
                    loadBillingGeneral();
                    if ($scope.rightsProducts.canRead) {
                        loadProductGeneral();
                    }
                    if ($scope.rightsGlobalProducts.canRead || args.isAdvisorProduct) {
                        loadProductGlobal();
                    }
                }
                break;
        }
    }

    function loadEnumLookUps() {
        var list = {
            productStatusTypes: productStatuses,
            productTypes: productTypes,
            pricingStatusTypes: pricingStatuses,
            preferredRatesFrequency: preferredRateFrequency,
            paymentFrequency: paymentFrequency,
            paymentCycleDateTypes: paymentCycleDateTypes
        };

        Object.each(list, function (key, value) {
            $scope[key] = $portfolio.enumToSimpleList(value);
        });
    }

    function loadProductGeneral() {
        if (args.isNewGlobal || $scope.productGeneral) return;

        if(args.isAdvisorProduct && !$scope.productGeneral ){
            $scope.productGeneral = {
                id: 0,
                name: '',
                productType: '',
                portfolio: {
                    assetClassId:1,
                    riskCategoryId: null,
                    isDisabled: false,
                    productStatus: '',
                    snPRatingId: null,
                    moodyRatingId: null,
                    isAutoAssign: true,
                    isUsed: '',
                    isCustodialCash: false,
                    isManaged: true,
                    useDailyInterestAccrual: false,
                    ExcludeBondAccrualFromValuations: false,
                    allowIntraDayPerformance: false,
                    hasFees: false,
                    useGlobalSetting: true,
                    isFederallyTaxable: true,
                    isStateTaxable: true,
                    useLocalPricesOnly: true,
                    color: null,
                    advAssetCategoryId: null,
                    productNameOverride: null,
                    paymentCycleDateType: 0,
                    is13fReportable: true,
                    isAdvReportable: true
                },
                productGroup: null,
                userDefinedFields: null,
                entityOptions: null,
                billing: null,
                advAssetCategories:null
            };

            loadAssetClasses();
            loadRiskCategories();
            setAssetCategory();

            return;
        }

        if (args.isNewLocal) {
            $http.get("/Portfolio/Products/Verbose/New/" + args.id, {trackerMsg: 'Loading product general definition'})
                .then(function (r) {
                    $scope.productGeneral = r.data;
                    productGeneralOriginal = angular.copy($scope.productGeneral);
                });
        } else {
            $http.get("/Portfolio/Products/Verbose/" + args.id + "?expand=portfolio,alternative", {trackerMsg: 'Loading product'})
                .then(function (r) {
                    $scope.productGeneral = r.data;

                    if($scope.productGeneral.alternative){
                        formatK1Dates($scope.productGeneral.alternative.k1DeliveryDate, $scope.productGeneral.alternative.k1EstimatedDeliveryDate);
                    }
                    
                    productGeneralOriginal = angular.copy($scope.productGeneral);
                    loadAssetClasses();
                    loadRiskCategories();
                    setAssetCategory();
                });
        }
    }

    function loadProductGlobal() {
        if ($scope.productGlobal) return;

        if (args.isNewGlobal || args.isAdvisorProduct) {
            $http.get("/Global/Products/Verbose/New", {trackerMsg: 'Loading product common definition'})
                .then(function (response) {

                    $scope.productGlobal = response.data;

                    $scope.current.isAdvisorProduct = args.isAdvisorProduct;

                    $scope.productGlobal.isActive = !!$scope.current.isAdvisorProduct;

                    //set some defaults if this a advisor product
                    if($scope.current.isAdvisorProduct){
                        $scope.productGlobal.productType = 'Miscellaneous';
                        $scope.productGlobal.shareClassId = 1;
                        if(!$scope.productGeneral){
                            $scope.productGeneral = {portfolio: {useLocalPricesOnly:false, isManaged:true}};
                            $scope.productGeneral.portfolio.useLocalPricesOnly = true;
                        }
                        loadFundFamilies();
                        loadFundFamilyOverrides();
                        loadDownloadSymbols();
                        loadAssetClasses();
                        loadRiskCategories();
                        setAssetCategory();
                        setAdvAssetCategory(response.data);
                    }
                    productGlobalOriginal = angular.copy($scope.productGlobal);

                    if($scope.current.isAdvisorProduct){
                        loadAdvisorProductAlClients();
                    }
                });
        } else {
            const url = buildGlobalProductsUrl();
            $http.get(url, {trackerMsg: 'Loading global product'})
                .then(function (response) {
                    var data = response.data;
                    $scope.productGlobal = data.portfolio;
                    
                    //If productType is option, then get the data for the parent product and instantiate the gics object
                    //If productType is 'Stock/ETF', 'Bond', or 'CD' then instantiate the gics object for the current product
                    // The GICS section will only display if this object exists
                    if($scope.productGlobal.productType === 'Option'){
                        $http.get("/Global/Products/Verbose/" + data.portfolio.productParentId + "?expand=gics", {trackerMsg: 'Loading parent'})
                            .then(function(res){
                                $scope.productGlobalGICS = res.data.gics;
                            });
                    }else(['Stock/ETF', 'Bond', 'CD'].indexOf($scope.productGlobal.productType) !== -1)? $scope.productGlobalGICS = data.gics : null ;


                        $scope.current.isAdvisorProduct = data.portfolio.ticker.has(args.advisorPrefix + '_');
                        loadAdvisorProductAlClients(response);
                    //check master group on ticker to see if this was a advisor product
                    //if($scope.productGlobal.ticker.has($scope.current.masterGroup)){
                    //}

                    //This will get saved back on later.
                    var tempTicker = $scope.current.masterGroup + '_';
                    if ($scope.user.authorization.entity !== 'Administrator') $scope.productGlobal.ticker = $scope.productGlobal.ticker.remove(tempTicker);

                    $scope.productGlobal.id = data.id;

                    productGlobalOriginal = angular.copy($scope.productGlobal);

                    loadAssetClasses();
                    loadRiskCategories();

                    if (data.portfolio.productParentId && data.portfolio.productParentId > 0) {
                        $http.get("/Global/Products/Verbose/" + data.portfolio.productParentId, {trackerMsg: 'Loading parent product'})
                            .then(function (response) {
                                var parentProd =response.data;
                                if (parentProd) {
                                    $scope.current.parentProduct = {productId: parentProd.id, ticker: parentProd.portfolio.ticker, productName: parentProd.name};
                                }
                            });
                    }
                });
        }
    }

    function buildGlobalProductsUrl() {
        return "/Global/Products/Verbose/" + args.id + "?expand=portfolio&expand=gics&expand=AlClients";
    }

    function loadAssetClasses() {
        if ($scope.assetClasses) return;

        // We have already queued this request 
        if ($scope.assetClassesPromise) return;

        $scope.assetClassesPromise = $http.get("/Portfolio/ProductClasses", { trackerMsg: 'Loading asset classes' })
            .then(function (response) {
                $scope.assetClasses = response.data.sortBy("description");
                setAssetCategory();
            });

    }

    function loadProductManagers() {
        if ($scope.productManagers) return;
        return ProductsAndPrices.managers.getAllSimple().then(function(response){
            $scope.productManagers = response.data.sortBy("name");
        });
    }

    function setAssetCategory() {
        if ($scope.assetClasses && $scope.productGeneral && $scope.productGeneral.portfolio) {
            var ac = $scope.assetClasses.find({id: $scope.productGeneral.portfolio.assetClassId});
            if (ac) {
                $scope.current.assetClassCategory = ac.category + ' (' + ac.categoryAbbreviation + ')';
            }
        }
    }

    function setAdvAssetCategory(data){
        if (data) {
            $scope.productGeneral.portfolio.advAssetCategoryId = data.portfolio.advAssetCategoryId;
        }
    }

    function loadRiskCategories() {
        if ($scope.riskCategories) return;
        // We have already queued this request
        if ($scope.riskCategoriesPromise) return;

        $scope.riskCategoriesPromise = $http.get("/Portfolio/RiskCategories", { trackerMsg: 'Loading risk categories' })
            .then(function (response) {
                $scope.riskCategories = response.data.sortBy("fullName");
            });

    }

    function loadDownloadSymbols(res = null) {
        if ($scope.downloadSymbols) return;

        if (args.isNewGlobal || args.isAdvisorProduct) {
            $scope.downloadSymbols = [];
            downloadSymbolsOriginal = angular.copy($scope.downloadSymbols);
        } else if (res && res.data && res.data.downloadSymbols) {
            setDownloadSymbols(res)
        } else {
            $http.get("/Global/Products/Verbose/" + args.id + "?expand=downloadSymbols", {trackerMsg: 'Loading download symbols'})
                .then(function (response) {
                    setDownloadSymbols(response);
                });
        }
    }

    function setDownloadSymbols(response) {
        $scope.downloadSymbols = response.data.downloadSymbols;
        downloadSymbolsOriginal = angular.copy($scope.downloadSymbols);
    }

    //  1. if adivsor new product
    //  2. if editing
    //  3. admin

    function loadAdvisorProductAlClients(res = null) {
        if ($scope.advisorProductsAlClients) return;

        $scope.alClients.selected = [];
        $scope.advisorProductsAlClients = [];
        if (args.isAdvisorProduct) {
            advisorProductsAlClientsOriginal = angular.copy($scope.alClients.selected);
            $scope.alClients.selected.add({id:$scope.user.authorization.alClientId, clientName:$scope.user.authorization.alClientName});
        } else if (res && res.data && res.data.alClients) {
            setAlClients(res);
        } else {
            $http.get("/Global/Products/Verbose/" + args.id + "?expand=AlClients", {trackerMsg: 'Loading download symbols'})
                .then(function (response) {
                    setAlClients(response);
                });
        }
    }

    function setAlClients(response) {
        globalAlClients = response.data.alClients;

        // add any items here into the selected area
        $scope.alClients.selected = response.data.alClients.map(function (obj) {
            return $scope.alClients.list.find({id: obj});
        }).compact().sortBy('clientName');
        // setup starting list so we can track changes properly
        advisorProductsAlClientsOriginal = angular.copy($scope.alClients.selected );
    }

    $scope.$watch('alClients.list', function(newVal, oldVa) {
        if(newVal != oldVa ) {
            if (globalAlClients) {
                // add any items here into the selected area
                $scope.alClients.selected = globalAlClients.map(function (obj) {
                    return $scope.alClients.list.find({id: obj});
                }).compact().sortBy('clientName');
                // setup starting list so we can track changes properly
                advisorProductsAlClientsOriginal = angular.copy($scope.alClients.selected );
            }
        }
    });

    function loadFundFamilies(res = null) {
        if ($scope.fundFamilies) return;

        if (args.isNewGlobal || args.isAdvisorProduct) {
            $scope.fundFamilies = [];
            fundFamiliesOriginal = angular.copy($scope.fundFamilies);
        } else if (res && res.data && res.data.fundFamilies) {
            setFundFamilies(res);
        } else {
            $http.get("/Global/Products/Verbose/" + args.id + "?expand=fundFamilies", {trackerMsg: 'Loading fund families'})
                .then(function (response) {
                    setFundFamilies(response);
                });
        }
    }

    function setFundFamilies(response) {
        $scope.fundFamilies = response.data.fundFamilies;
        fundFamiliesOriginal = angular.copy($scope.fundFamilies);
    }

    function loadFundFamilyOverrides() {
        //ffo = fund family override
        if ($scope.fundFamiliesOverride) return;

        if (args.isNewGlobal || args.isAdvisorProduct) {
            $scope.fundFamiliesOverride = [];
            fundFamilyOverrideOriginal = angular.copy($scope.fundFamiliesOverride);
        } else {
            args.isFundFamilyOverride = true;
            args.isNewLocal = false;
            $http.get("/Trading/Products/FundFamilyOverride/" + args.id, { trackerMsg: 'Loading fund family overrides'})
                .then(function (response) {
                    $scope.ffo = response.data;
                    $scope.ffo.fundFamiliesOverriden.forEach(function (detail) {
                        if ((typeof (detail.altTicker) != undefined && detail.altTicker != "") || detail.altProductId !== 0) {
                            detail.altProductOverrideAgg = { productId: detail.altProductId, ticker: detail.altTicker, productName: detail.altProductName };
                            args.isNewLocal = false;
                        }
                        else {
                            args.isNewLocal = true;
                        }
                    });
                    fundFamilyOverrideOriginal = angular.copy($scope.ffo);
                });
        }
    }
    function loadProductWeightings() {
        if ($scope.rightsAssetCategory.canRead && !$scope.assetCategoryWeightings) {
            $scope.assetCategoryWeightings = {};
            $http.get("/Portfolio/ProductCategories/Weighted/Products/" + args.id, {trackerMsg: 'Loading asset category weightings'})
                .then(function (response) {
                    angular.extend($scope.assetCategoryWeightings, response.data);
                    assetCategoryWeightingsOriginal = angular.copy($scope.assetCategoryWeightings);
                });
        }

        if ($scope.rightsAssetClass.canRead && !$scope.assetClassWeightings) {
            $scope.assetClassWeightings = {};
            $http.get("/Portfolio/ProductClasses/Weighted/Products/" + args.id, {trackerMsg: 'Loading asset class weightings'})
                .then(function (response) {
                    angular.extend($scope.assetClassWeightings, response.data);
                    assetClassWeightingsOriginal = angular.copy($scope.assetClassWeightings);
                });
        }

        if ($scope.rightsPropertyRegion.canRead && !$scope.propertyRegionWeightings) {
            $scope.propertyRegionWeightings = {};
            $http.get("/Portfolio/Regions/Weighted/Products/" + args.id, {trackerMsg: 'Loading region weightings'})
                .then(function (response) {
                    angular.extend($scope.propertyRegionWeightings, response.data);
                    propertyRegionWeightingsOriginal = angular.copy($scope.propertyRegionWeightings);
                });
        }

        if ($scope.rightsPropertyType.canRead && !$scope.propertyTypeWeightings) {
            $scope.propertyTypeWeightings = {};
            $http.get("/Portfolio/PropertyTypes/Weighted/Products/" + args.id, {trackerMsg: 'Loading property type weightings'})
                .then(function (response) {
                    angular.extend($scope.propertyTypeWeightings, response.data);
                    propertyTypeWeightingsOriginal = angular.copy($scope.propertyTypeWeightings);
                });
        }
    }

    function checkForExpectedReturnWarning() {
        if ($scope.productGlobal && ![23, 35, 7].any($scope.productGlobal.productSubTypeId)) {
            $scope.errors.push({type: 'warning', title: 'Invalid For Alternative Expected Returns! ', msg: 'Alternative Expected Returns should only exist on Fixed Annuities, Private Equities, or Limited Partnerships.'});
        }
    }

    function loadAlternativeExpectedReturns() {
        if ($scope.rightsAlternativeExpectedReturns.canRead && !$scope.alternativeExpectedReturns) {
            $scope.alternativeExpectedReturns = [];
            ProductsAndPrices.alternativeReturns.getAllProduct({params: {id: args.id}})
                .then(function (response) {
                    angular.extend($scope.alternativeExpectedReturns, response.data);
                    alternativeExpectedReturnsOriginal = angular.copy($scope.propertyTypeWeightings);
                });
        }
    }

    function checkForBondRateWarning() {
        if ($scope.productGlobal && $scope.productGlobal.productType !== productTypes.bond.name && $scope.productGlobal.productType !== productTypes.cd.name) {
            $scope.errors.push({type: 'warning', title: 'Invalid For Bond Rates! ', msg: 'Bond rates should only exist on bonds and CDs.'});
        }
    }

    function loadBondRates(res = null) {
        if ($scope.bondRates) return;

        if (args.isNewGlobal) {
            $scope.bondRates = [];
            bondRatesOriginal = angular.copy($scope.bondRates);
        } else if (res && res.data && res.data.bondRates) {
            setBondRates(res);
        } else {
            $http.get("/Global/Products/Verbose/" + args.id + "?expand=bondRates", {trackerMsg: 'Loading bond rates'})
                .then(function (response) {
                    setBondRates(response);
                });
        }
    }

    function setBondRates(response) {
        $scope.bondRates = response.data.bondRates;
        bondRatesOriginal = angular.copy($scope.bondRates);
    }

    function loadCorporateActions(forceReload) {
        if ($scope.corporateActions && !forceReload) return;

        if (args.isNewGlobal && !forceReload) {

        } else {
            $http.get("/Global/CorporateActions?productId=" + args.id, {trackerMsg: 'Loading corporate actions'})
                .then(function (response) {
                    $scope.corporateActions = response.data;
                    corporateActionsOriginal = angular.copy($scope.corporateActions);
                });
        }
    }

    function loadDividends(forceReload) {
        if ($scope.dividends && !forceReload) return;

        if (args.isNewGlobal && !forceReload) {

        } else {
            $http.get("/Global/Dividends?productId=" + args.id + '&startDate=' + $scope.current.dividendStartDate.formatted() + '&endDate=' + $scope.current.dividendEndDate.formatted(), {trackerMsg: 'Loading dividends'})
                .then(function (response) {
                    $scope.dividends = response.data;
                    dividendsOriginal = angular.copy($scope.dividends);
                });
        }
    }

    function loadAssumedRates(res = null) {
        if($scope.assumedRates) return;

        if (args.isNewGlobal && !forceReload) {
            $scope.assumedRates = [];
            assumedRatesOriginal = angular.copy($scope.assumedRates);
        } else if (res && res.data && res.data.assumedRates) {
            setAssumedRates(res);
        } else {
             $http.get("/Portfolio/Products/Verbose/" + args.id + "?expand=assumedRates", {trackerMsg: 'Loading assumed rates'})
                .then(function (response) {
                    setAssumedRates(response);
                });
        }
    }

    function setAssumedRates(response) {
        $scope.assumedRates = response.data.assumedRates;
        assumedRatesOriginal = angular.copy($scope.assumedRates);

        $scope.assumedDividendRates = $scope.assumedRates.filter(r => r.rateType === 'Assumed Dividend Rate');
        $scope.assumedTurnoverRates = $scope.assumedRates.filter(r => r.rateType === 'Assumed Turnover Rate');
    }

    function checkForPreferredRateWarning() {
        if ($scope.productGlobal) {
            if ($scope.productGlobal.productSubTypeId !== 10 && $scope.productGlobal.productSubTypeId !== 11) {
                $scope.errors.push({type: 'warning', title: 'Invalid For Preferred Rates! ', msg: 'Preferred rates should only exist on Preferred ADS and Preferred Stock.'});
            }
        }
    }

    function loadPreferredRates(res = null) {
        if ($scope.preferredRates) return;

        if (args.isNewGlobal) {
            $scope.preferredRates = [];
            preferredRatesOriginal = angular.copy($scope.preferredRates);
        } else if (res && res.data && res.data.preferredRates) {
            setPreferredRates(res);
        } else {
            $http.get("/Global/Products/Verbose/" + args.id + "?expand=preferredRates", {trackerMsg: 'Loading preferred rates'})
                .then(function (response) {
                    setPreferredRates(response);
                });
        }
    }

    function setPreferredRates(response) {
        $scope.preferredRates = response.data.preferredRates;
        preferredRatesOriginal = angular.copy($scope.preferredRates);
    }

    function loadPriceFactors(forceReload) {
        if ($scope.priceFactors && !forceReload) return;

        if (args.isNewGlobal && !forceReload) {

        } else {
            $http.get("/Global/Products/PriceFactors?productId=" + args.id + '&startDate=' + $scope.current.priceFactorStartDate.formatted() + '&endDate=' + $scope.current.priceFactorEndDate.formatted(), {trackerMsg: 'Loading price factors'})
                .then(function (response) {
                    $scope.priceFactors = response.data;
                    priceFactorsOriginal = angular.copy($scope.priceFactors);
                });
        }
    }

    function checkForPriceFactorWarning() {
        if ($scope.productGlobal && $scope.productGlobal.productSubTypeId !== 33) {
            $scope.errors.push({type: 'warning', title: 'Invalid For Price Factors! ', msg: 'Price factors should only exist on Principal Paydown.'});
        }
    }

    function loadProductSubstitution(res = null) {
        if ($scope.productSubstitution) return;

        if (res && res.data && res.data.productGroup) {
            setProductSubstitution(res);
        } else {
            $http.get("/Portfolio/Products/Verbose/" + args.id + "?expand=productGroup", {trackerMsg: 'Loading product substitution'})
                .then(function (response) {
                    setProductSubstitution(response);
                });
        }
    }

    function setProductSubstitution(response) {
        $scope.productSubstitution = response.data.productGroup;
        productSubstitutionOriginal = angular.copy($scope.productSubstitution);
    }

    function loadBondCallPrices(forceReload) {
        if ($scope.bondCalls && !forceReload) return;

        if (args.isNewGlobal && !forceReload) {

        } else {
            $http.get("/Portfolio/Products/BondCalls?productId=" + args.id, {trackerMsg: 'Loading bond call prices'})
                .then(function (response) {
                    $scope.bondCalls = response.data;
                    bondCallsOriginal = angular.copy($scope.bondCalls);
                });
        }
    }

    function loadCustomFields(res = null) {
        if ($scope.customFields) return;

        if (res && res.data && res.data.userDefinedFields) {
            setCustomFields(res);
        } else {
            $http.get("/Portfolio/Products/Verbose/" + args.id + "?expand=userDefinedFields", {trackerMsg: 'Loading custom fields'})
                .then(function (response) {
                    setCustomFields(response);
                });
        }
    }

    function setCustomFields(response) {
        $scope.customFields = response.data.userDefinedFields.sortBy("name");
        $portfolio.cleanCustomFields($scope.customFields);
        customFieldsOriginal = angular.copy($scope.customFields);
    }

    function loadCustomTSFields(res = null) {
        if ($scope.customTSFields) return;

        if (res && res.data && res.data.userDefinedTimeFields) {
            setCustomTSFields(res);
        } else {
            $http.get("/Portfolio/Products/Verbose/" + args.id + "?expand=userDefinedTimeFields", {trackerMsg: 'Loading custom time fields'})
                .then(function (response) {
                    setCustomTSFields(response);
                });
        }
    }

    function setCustomTSFields(response) {
        $scope.customTSFields = response.data.userDefinedTimeFields.sortBy("name");
        $portfolio.cleanCustomFields($scope.customTSFields);
        customTSFieldsOriginal = angular.copy($scope.customTSFields);
    }

    function loadEntityOptions(res = null) {
        if ($scope.entityOptions) return;

        if (res && res.data && res.data.entityOptions) {
            setEntityOptions(res);
        } else {
            $http.get("/Portfolio/Products/Verbose/" + args.id + "?expand=entityOptions", {trackerMsg: 'Loading options'})
                .then(function (response) {
                    setEntityOptions(response);
                });
        }
    }

    function setEntityOptions(response) {
        $portfolio.cleanCustomFields(response.data.entityOptions);
        $scope.entityOptions = response.data.entityOptions;
        entityOptionsOriginal = angular.copy(response.data.entityOptions);
    }

    function loadBillingGeneral() {
        if ($scope.billingGeneral) return;

        $http.get("/Portfolio/Products/Verbose/" + ( (args.isNewLocal || args.isAdvisorProduct) ? "New" : args.id) + "?expand=billing", {trackerMsg: 'Loading billing'})
            .then(function (response) {
                $scope.billingGeneral = response.data.billing;
                $scope.billingGeneral.excludedBillEntityIds = $scope.billingGeneral.excludedBillEntityIds || [];
                if ($scope.billingGeneral.feeBillExclusionMode === undefined || $scope.billingGeneral.feeBillExclusionMode === null) {
                    $scope.billingGeneral.feeBillExclusionMode = $scope.billingGeneral.feeExcluded ? 1 : 0;
                }
                billingGeneralOriginal = angular.copy($scope.billingGeneral);
                CShareCheck();
                if ($scope.current.entityUseFeeHierarchy && $scope.excludeByBillEntitySplitEnabled && $scope.billingGeneral.feeBillExclusionMode === 2) {
                    loadBillEntityPickerSource();
                }
            });
            
    }

    function loadBillEntityPickerSource() {
        if ($scope.billEntityPickerSource) {
            return $q.resolve();
        }
        return $http.get('/Billing/Entities/EntityList?isActive=true', { trackerMsg: 'Loading bill entities' })
            .then(function (resp) {
                $scope.billEntityPickerSource = (resp.data || []).map(function (e) {
                    return { id: e.id, name: e.name };
                });
            });
    }

    $scope.billEntityNameById = function (id) {
        var src = $scope.billEntityPickerSource;
        if (!src) {
            return id;
        }
        var found = src.find(function (x) { return x.id === id; });
        return found ? found.name : id;
    };

    $scope.onProductFeeExcludedCheckboxChange = function () {
        $scope.billingGeneral.feeBillExclusionMode = $scope.billingGeneral.feeExcluded ? 1 : 0;
        $scope.billingGeneral.excludedBillEntityIds = [];
    };

    $scope.onProductFeeBillExclusionDropdownChange = function () {
        if ($scope.billingGeneral.feeBillExclusionMode !== 2) {
            $scope.billingGeneral.excludedBillEntityIds = [];
            $scope.billEntityExclusionListExpanded = false;
        }
        $scope.billingGeneral.feeExcluded = ($scope.billingGeneral.feeBillExclusionMode === 1);
        if ($scope.billingGeneral.feeBillExclusionMode === 2) {
            loadBillEntityPickerSource();
        }
    };

    $scope.openSelectBillEntitiesModal = function () {
        loadBillEntityPickerSource().then(function () {
            $scope.selectBillEntitiesModalOpen = true;
        });
    };

    $scope.onBillEntitiesEdited = function (ids) {
        $scope.selectBillEntitiesModalOpen = false;
        if (ids !== null && ids !== undefined) {
            $scope.billingGeneral.excludedBillEntityIds = ids;
            $scope.billingGeneral.feeBillExclusionMode = 2;
            $scope.billingGeneral.feeExcluded = false;
            $scope.billEntityExclusionListExpanded = true;
        }
    };

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: function() { $scope.close(true); } }
            ]);
        });
    }
//endregion

    //region PUBLIC METHODS
    $scope.loadTab = function (child) {
        checkTabForDirty();

        $scope.menu.categories.each(function (c) {
            c.children.each(function (ch) {
                ch.active = ch.code == child.code;
            });
        });

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab();
    };

    $scope.openLink = function (child) {
        if (child.link && child.link.startsWith('#/')) {
            $window.open(child.link, '_blank');
        }
    };

    $scope.startOverProductGeneral = function () {
        $scope.productGeneral = angular.copy(productGeneralOriginal);
    };

    $scope.startOverProductGlobal = function () {
        $scope.productGlobal = angular.copy(productGlobalOriginal);
    };

    $scope.editDownloadSymbol = function (ds) {
        $dialog.dialog({templateUrl: "download-symbol-edit.html", controller: "DownloadSymbolEditCtrl", downloadSymbol: ds})
            .open()
            .then(function (rslt) {
                if (!rslt) return;

                const sbl = $scope.downloadSymbols.find({ symbol: rslt.symbol });
                if (sbl && sbl.id !== rslt.id) {
                    $scope.errors.push({ type: 'warning', title: 'Download Symbol Already Exists! ', msg: rslt.symbol + ' is already assigned to the product.' });
                } else {
                    if (ds) {
                        $scope.downloadSymbols.remove(ds);
                    }
                    $scope.downloadSymbols.push(rslt);
                }

                if (rslt.isNASDAQPlatformSymbol) {
                    $scope.downloadSymbols.each(function (sym) {
                        if (sym.id !== rslt.id) {
                            sym.isNASDAQPlatformSymbol = false;
                        }
                    });
                }
            });
    };

    $scope.removeDownloadSymbol = function (ds) {
        $dialog.confirmAction("Are you sure you want to remove download symbol <b>" + ds.symbol + "</b>?")
            .open()
            .then(function (result) {
                if (result == 'yes') {
                    $scope.downloadSymbols.remove(ds);
                }
            });
    };

    $scope.onClickNASDAQPlatformSymbol = function (id) {
        $scope.downloadSymbols.each(function (ds) {
            if (ds.id !== id) {
                ds.isNASDAQPlatformSymbol = false;
            }
        });
    };

    $scope.startOverDownloadSymbols = function () {
        $scope.downloadSymbols = angular.copy(downloadSymbolsOriginal);
    };

    $scope.editFundFamily = function (ff) {
        $dialog.dialog({templateUrl: "fund-family-edit.html", controller: "FundFamilyEditCtrl", fundFamily: ff})
            .open()
            .then(function (rslt) {
                if (!rslt) return;

                if ($scope.fundFamilies.any({name: rslt.name})) { // If trying to add fund family that already exists
                    $scope.errors.push({type: 'warning', title: 'Fund Family Already Exists! ', msg: rslt.name + ' is already assigned to the product.'});
                } else { // Else editing an existing fund family... remove old add new
                    if (ff) {
                        $scope.fundFamilies.remove(ff);
                    }
                    $scope.fundFamilies.push(rslt);
                }
            });
    };

    $scope.removeFundFamily = function (ff) {
        $dialog.confirmAction("Are you sure you want to remove fund family <b>" + ff.name + "</b>?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.fundFamilies.remove(ff);
                }
            });
    };

    $scope.startOverFundFamilies = function () {
        $scope.fundFamilies = angular.copy(fundFamiliesOriginal);
    };

    $scope.editBondRate = function (br) {
        $dialog.dialog({templateUrl: "bond-rate-edit.html", controller: "BondRateEditCtrl", bondRate: br, dialogClass: "modal wide"})
            .open()
            .then(function (rslt) {
                if(rslt) {
                    $scope.bondRates.remove(br);
                    $scope.bondRates.push(rslt);
                }
            });
    };

    $scope.removeBondRate = function (br) {
        $dialog.confirmAction("Are you sure you want to remove bond rate <b>" + br.datedDate + "</b>?")
            .open()
            .then(function (result) {
                if (result == 'yes') {
                    $scope.bondRates.remove(br);
                }
            });
    };

    $scope.editCorporateAction = function (ca, action) {
        $dialog.editor("products/editors/corporate-action.html", "CorporateActionCtrl", {args: function () {
            return {
                corporateAction:    ca,
                selectedProcess:    undefined,
                productId:          args.id,
                isNew:              (ca == undefined || ca == false || ca == null),
                action:             action, // or string 'processing-add' or 'processing-clone'
                app:                apps.productsAndPrices.name,
                defaultTab:         {name: 'General', active: true, code: 'general'},
            };
        }})
            .open()
            .then(function (rslt) {
                if (rslt) {
                    loadCorporateActions(true);
                }
            });
    };

    $scope.editDividend = function (di) {
        $dialog.editor("products/editors/dividend.html", "DividendCtrl", {args: function () {return {dividend: di, productId: args.id};}})
            .open()
            .then(function (rslt) {
                if (rslt) {
                    loadDividends(true);
                }
            });
    };

    $scope.refreshDividends = function () {
            loadDividends(true);
        
    };

    $scope.addAssumedRate = function(rateType) {
        let newRate = {
            rateType: rateType,
            asOfDate: Date.create().formatted(),
            value: 0.00
        }

        $scope.assumedRates.push(newRate);        

        if(rateType == 1){
            $scope.assumedDividendRates.push(newRate);
        } else if(rateType == 2) {
            $scope.assumedTurnoverRates.push(newRate);
        }
    }

    $scope.removeAssumedRate = function (tr) {
        $dialog.confirmAction("Are you sure you want to remove the assumed rate?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.assumedRates.remove(tr);
                    if(tr.rateType === 'Assumed Dividend Rate' || tr.rateType === 1){
                        $scope.assumedDividendRates.remove(tr);
                    } else if(tr.rateType === 'Assumed Turnover Rate' || tr.rateType === 2) {
                        $scope.assumedTurnoverRates.remove(tr);
                    }
                }
            });
    };

    $scope.addPreferredRate = function () {
        $scope.preferredRates.push({id: 0, dividendRate: 0, frequency: 0, parValue: 0, isFixedRate: false, isCallable: false, isConvertible: false, isCumulative: false, isInDefault: false, isParticipating: false, isVotingRights: false});
    };

    $scope.removePreferredRate = function (pr) {
        $dialog.confirmAction("Are you sure you want to remove preferred rate <b>" + pr.dividendRate + "</b>?")
            .open()
            .then(function (result) {
                if (result == 'yes') {
                    $scope.preferredRates.remove(pr);
                }
            });
    };

    $scope.editPriceFactor = function (pf) {
        $dialog.editor("products/editors/price-factor.html", "PriceFactorCtrl", {args: function () {return {priceFactor: pf, productId: args.id};}})
            .open()
            .then(function (rslt) {
                if (rslt) {
                    loadPriceFactors(true);
                }
            });
    };

    $scope.refreshPriceFactors = function () {
        if ($scope.current.priceFactorStartDate.daysUntil($scope.current.priceFactorEndDate) > 1827) {
            $scope.errors.push({type: 'error', title: 'Invalid Price Factor Range! ', msg: ' Price factor date range must be 5 years or less.'});
        } else {
            loadPriceFactors(true);
        }
    };

    $scope.addProductSubstitution = function () {
        $dialog.search("product", "Add Product Substitution")
            .open()
            .then(function (rslt) {
                    if (!rslt) return;

                    $http.get("/Portfolio/Products/Verbose/" + rslt.productId + "?expand=productGroup", {trackerMsg: 'Checking product for additional substitutes'})
                        .then(function (response) {
                            var data = response.data;
                            if (data.productGroup && data.productGroup.items.length > 1) {
                                $dialog.confirmAction(rslt.productName + " contains substitutes itself.  Would you like to add them as well?")
                                    .open()
                                    .then(function (result) {
                                        if (result === 'yes') {
                                            $scope.productSubstitution.items.add(data.productGroup.items);
                                        } else {
                                            $scope.productSubstitution.items.push(rslt);
                                        }
                                    });
                            } else {
                                $scope.productSubstitution.items.push(rslt);
                            }
                        });
                }
            );
    };

    $scope.removeProductSubstitution = function (ps) {
        $dialog.confirmAction("Are you sure you want to remove substitute product <b>" + ps.productName + "</b>?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.productSubstitution.items.remove(ps);
                }
            });
    };

    $scope.editBondCall = function (bc) {
        $dialog.dialog({templateUrl: "bond-call-edit.html", controller: "BondCallEditCtrl", bondCall: bc, productId: args.id, dialogClass: "modal wide"})
            .open()
            .then(function (rslt) {
                if (rslt) {
                    loadBondCallPrices(true);
                }
            });
    };

    $scope.addAlternativeExpectedReturn = function() {
        return $scope.alternativeExpectedReturns.push({
            productId: $scope.productGeneral.id,
            startDate: Date.create('today'),
            high: null,
            low: null,
            comment: null
        });
    };

    function canViewDatabaseAssignment () {
        $scope.current.canViewALClients = !!($scope.user.authorization.entity === 'Administrator' && $scope.rightsGlobalProducts.canUpdate);
    }

    function checkIfTickerExists(hasPrefix) {
        if ($scope.productGlobal.ticker) {
            if ($scope.masterGroupPromise) {
                $scope.masterGroupPromise.then(_ => {
                    const tickerToCheck = hasPrefix
                        ? $scope.current.masterGroup + '_' + $scope.productGlobal.ticker
                        : $scope.productGlobal.ticker;
                    callSymbolExists(tickerToCheck);
                })
            } else if ($scope.current.masterGroup) {
                const tickerToCheck = hasPrefix
                    ? $scope.current.masterGroup + '_' + $scope.productGlobal.ticker
                    : $scope.productGlobal.ticker;
                callSymbolExists(tickerToCheck);
            } else {
                return;
            }
        }

    }

    function callSymbolExists(tickerToCheck) {
        $scope.current.isExecuting = true;
        $http.get(`/Global/Products/SymbolExists?symbol=${encodeURIComponent(tickerToCheck)}`, {
            trackerMsg: `Checking if symbol ${tickerToCheck} exists`
        })
            .then(response => {
                const symbolExists = response && response.data && response.data.exists;
                if (symbolExists) {
                    $dialog.messageBox('Ticker check', `Symbol ${tickerToCheck} currently exists in global table.`)
                        .open();
                } else {
                    $scope.productGlobal.cusip = $scope.current.masterGroup + '_' + $scope.productGlobal.ticker;
                }
                $scope.current.advisorProductValid = !symbolExists;
            })
            .finally(_ => $scope.current.isExecuting = false);
    }

    $scope.save = function () {
        const zeroWeight = (element) => element.weight === 0;

        if ($scope.assetCategoryWeightings && $scope.assetCategoryWeightings.details && $scope.assetCategoryWeightings.details.length > 0) {
            if ($scope.assetCategoryWeightings.details.some(zeroWeight)) {
                $scope.errors.push({ type: 'error', title: 'Invalid Category Weightings! ', msg: ' Asset category weightings cannot have a value of 0.' });
            }
            if (!angular.equals(assetCategoryWeightingsOriginal, $scope.assetCategoryWeightings) && $scope.current.assetCategoryWeightingsTotal !== 100) {
                $scope.errors.push({ type: 'error', title: 'Invalid Category Weightings! ', msg: ' Asset category weightings do not add to 100%.' });
            }
        }

        if ($scope.assetClassWeightings && $scope.assetClassWeightings.details && $scope.assetClassWeightings.details.length > 0) {
            if ($scope.assetClassWeightings.details.some(zeroWeight)) {
                $scope.errors.push({ type: 'error', title: 'Invalid Class Weightings! ', msg: ' Asset class weightings cannot have a value of 0.' });
            }
            if (!angular.equals(assetClassWeightingsOriginal, $scope.assetClassWeightings) && $scope.current.assetClassWeightingsTotal !== 100) {
                $scope.errors.push({ type: 'error', title: 'Invalid Class Weightings! ', msg: ' Asset class weightings do not add to 100%.' });
            }
        }

        if ($scope.propertyTypeWeightings && $scope.propertyTypeWeightings.details && $scope.propertyTypeWeightings.details.length > 0) {
            if ($scope.propertyTypeWeightings.details.some(zeroWeight)) {
                $scope.errors.push({ type: 'error', title: 'Invalid Class Weightings! ', msg: ' Property type weightings cannot have a value of 0.' });
            }
            if (!angular.equals(propertyTypeWeightingsOriginal, $scope.propertyTypeWeightings) && $scope.current.propertyTypeWeightingsTotal !== 100) {
                $scope.errors.push({ type: 'error', title: 'Invalid Class Weightings! ', msg: ' Property type weightings do not add to 100%.' });
            }
        }

        if ($scope.propertyRegionWeightings && $scope.propertyRegionWeightings.details && $scope.propertyRegionWeightings.details.length > 0) {
            if ($scope.propertyRegionWeightings.details.some(zeroWeight)) {
                $scope.errors.push({ type: 'error', title: 'Invalid Class Weightings! ', msg: ' Property region weightings cannot have a value of 0.' });
            }
            if (!angular.equals(propertyRegionWeightingsOriginal, $scope.propertyRegionWeightings) && $scope.current.propertyRegionWeightingsTotal !== 100) {
                $scope.errors.push({ type: 'error', title: 'Invalid Class Weightings! ', msg: ' Property region weightings do not add to 100%.' });
            }
        }

        if ($scope.productGlobal && $scope.current.parentProduct && $scope.productGlobal.id === $scope.current.parentProduct.productId) {
            $scope.errors.push({ type: 'error', title: 'Invalid Parent Product! ', msg: ' Parent product same as current product' });
        }

        if ($scope.productGlobal && $scope.productGlobal.ticker && ($scope.productGlobal.ticker.endsWith(" ") || $scope.productGlobal.ticker.startsWith(" "))) {
            $scope.errors.push({ type: 'error', title: 'Invalid Ticker', msg: ' Ticker cannot start with or end with a space' });
        }

        if ($scope.productGlobal && $scope.productGlobal.cusip && ($scope.productGlobal.cusip.endsWith(" ") || $scope.productGlobal.cusip.startsWith(" "))) {
            $scope.errors.push({ type: 'error', title: 'Invalid CUSIP', msg: ' CUSIP cannot start with or end with a space' });
        }

        if ($scope.productGlobal && $scope.productGlobal.productName && $scope.productGlobal.productName.has("  ")) {
            $scope.errors.push({ type: 'error', title: 'Invalid Product Name', msg: ' Product name cannot contain consecutive spaces' });
        }

        if ($scope.productGlobal && $scope.productGlobal.portfolio && ($scope.productGlobal.shareClassId === undefined || $scope.productGlobal.shareClassId === null || $scope.productGlobal.shareClassId === 0)) {
            $scope.errors.push({ type: 'error', title: 'Invalid Share Class', msg: ' Product must have a share class' });
        }

        if ($scope.current.isAdvisorProduct && !$scope.current.advisorProductValid) {
            $scope.errors.push({ type: 'error', title: 'Invalid Advisor Product', msg: ' Product ticker already exists' });
        }

        if ($scope.assumedRates && $scope.assumedRates.filter(r => (!r.value && r.value != 0) || r.value < 0 || r.value > 100).length > 0) {
            $scope.errors.push({ type: 'error', title: 'Invalid Assumed Rate Values! ', msg: ' Assumed Rate values must be between 0% and 100%.' });
        }

        if (!$scope.errors.length) {
            var verboseGlobalProduct = { id: args.id || 0 };
            var verboseLocalProduct = { id: args.id || 0 };

            var saveGlobal = false;
            var saveLocal = false;

            if ($scope.current.isAdvisorProduct && $scope.user.authorization.entity !== 'Administrator' && $scope.productGlobal.ticker) {
                var tempProduct = $scope.current.masterGroup + '_' + $scope.productGlobal.ticker;
                $scope.productGlobal.ticker = tempProduct;
            }

            if ($scope.current.parentProduct) {
                $scope.productGlobal.productParentId = $scope.current.parentProduct.productId;
            }

            var anyAddedDbs = $scope.alClients.selected.any(function (a) {
                return a['id'] !== $scope.user.authorization.alClientId
            });
            if (anyAddedDbs) {
                $scope.productGlobal.includeByDefault = false;
            }

            if ($scope.productGlobal && !angular.equals(productGlobalOriginal, $scope.productGlobal)) {
                verboseGlobalProduct["Portfolio"] = $scope.productGlobal;
                saveGlobal = true;
            }
            if (args.isAdvisorProduct) {
                //download Symbols
                if ($scope.downloadSymbols && $scope.productGlobal.cusip) {
                    $scope.downloadSymbols.add({ symbol: $scope.productGlobal.cusip });
                }
            }

            if (($scope.current.isAdvisorProduct || $scope.user.authorization.entity === 'Administrator') && !angular.equals(advisorProductsAlClientsOriginal, $scope.alClients.selected)) {
                if (!verboseGlobalProduct.alClients) {
                    verboseGlobalProduct['alClients'] = [];
                }

                $scope.alClients.selected.forEach(function (item) {
                    verboseGlobalProduct.alClients.add(item.id);
                });

                saveGlobal = true;
            }

            if ($scope.productGeneral) {
                verboseLocalProduct["portfolio"] = $scope.productGeneral.portfolio;

                if($scope.productGeneral.alternative){
                    formatK1Dates($scope.productGeneral.alternative.k1DeliveryDate, $scope.productGeneral.alternative.k1EstimatedDeliveryDate);
                }

                verboseLocalProduct["alternative"] = $scope.productGeneral.alternative;
                saveLocal = true;
                if ($scope.current.isAdvisorProduct) {
                    if (!verboseGlobalProduct.localProduct) {
                        verboseGlobalProduct['localProduct'] = {};
                    }

                    if ($scope.productGeneral && $scope.productGeneral.portfolio) {
                        verboseGlobalProduct.localProduct["portfolio"] = $scope.productGeneral.portfolio;
                    }
                    saveGlobal = true;
                }
            }

            if ($scope.productGeneral) {
                verboseLocalProduct.advAssetCategoryId = $scope.productGeneral.portfolio.advAssetCategoryId;
            }

            if ($scope.downloadSymbols && !angular.equals(downloadSymbolsOriginal, $scope.downloadSymbols)) {
                verboseGlobalProduct["DownloadSymbols"] = $scope.downloadSymbols;
                saveGlobal = true;
            }

            if ($scope.fundFamilies && !angular.equals(fundFamiliesOriginal, $scope.fundFamilies)) {
                verboseGlobalProduct["FundFamilies"] = $scope.fundFamilies;
                saveGlobal = true;
            }

            if ($scope.ffo) {
                verboseLocalProduct["FundFamiliesOverriden"] = $scope.ffo.fundFamiliesOverriden;
                //verboseLocalProduct["IsAlternativeSymColumnShown"] = $scope.ffo.isAlternativeSymColumnShown;
                saveGlobal = false;
                saveLocal = true;
            }

            if ($scope.bondRates && !angular.equals(bondRatesOriginal, $scope.bondRates)) {
                verboseGlobalProduct["BondRates"] = $scope.bondRates;
                saveGlobal = true;
            }

            if ($scope.productSubstitution && !angular.equals(bondRatesOriginal, $scope.productSubstitution)) {
                verboseLocalProduct["ProductGroup"] = $scope.productSubstitution;
                saveLocal = true;
            }

            if ($scope.alternativeExpectedReturns && !angular.equals(alternativeExpectedReturnsOriginal, $scope.alternativeExpectedReturns)) {
                verboseLocalProduct["alternativeExpectedReturns"] = $scope.alternativeExpectedReturns;
                saveLocal = true;
            }

            if ($scope.preferredRates && !angular.equals(preferredRatesOriginal, $scope.preferredRates)) {
                verboseGlobalProduct["PreferredRates"] = $scope.preferredRates;
                saveGlobal = true;
            }

            if ($scope.assumedRates && !angular.equals(assumedRatesOriginal, $scope.assumedRates)) {
                verboseLocalProduct["AssumedRates"] = $scope.assumedRates;
                saveLocal = true;
            }

            if ($scope.customFields && !angular.equals(customFieldsOriginal, $scope.customFields)) {
                var cfs = $scope.customFields.findAll({ entity: entities.product.name });
                if (cfs.length) {
                    verboseLocalProduct["userDefinedFields"] = cfs;
                    saveLocal = true;
                }
            }

            if ($scope.customTSFields && !angular.equals(customTSFieldsOriginal, $scope.customTSFields)) {
                var ctsfs = $scope.customTSFields.findAll({ entity: entities.product.name });
                if (ctsfs.length) {
                    verboseLocalProduct["userDefinedTimeFields"] = ctsfs;
                    saveLocal = true;
                }
            }

            if ($scope.entityOptions && !angular.equals(entityOptionsOriginal, $scope.entityOptions)) {
                verboseLocalProduct["entityOptions"] = $portfolio.restoreEntityOptions($scope.entityOptions);
                saveLocal = true;
            }

            if ($scope.billingGeneral && !angular.equals(billingGeneralOriginal, $scope.billingGeneral)) {
                verboseLocalProduct["Billing"] = $scope.billingGeneral;
                saveLocal = true;
            }

            if ($scope.productGlobal && $scope.productGlobal.isin && $scope.productGlobal.isin.length > 0 && (!productGlobalOriginal.isin || $scope.productGlobal.isin !== productGlobalOriginal.isin)) {
                $http.get('/Global/Products/ISIN/Validate?isin=' + $scope.productGlobal.isin, { trackerMsg: "Validating ISIN" }).then(function (response) {
                    if (response.data === true) {
                        saveTabs(saveGlobal, saveLocal, verboseGlobalProduct, verboseLocalProduct);
                    } else {
                        return $dialog.messageBox(
                            "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Confirm Action",
                            "The ISIN entered is not a valid value.  Would you like to continue and save anyway?",
                            [{ result: 'no', label: 'No' }, { result: 'yes', label: 'Yes', cssClass: 'btn-primary' }]
                        ).open()
                            .then(function (result) {
                                if (result === 'yes') {
                                    saveTabs(saveGlobal, saveLocal, verboseGlobalProduct, verboseLocalProduct);
                                }
                            });
                    }
                });
            } else {
                saveTabs(saveGlobal, saveLocal, verboseGlobalProduct, verboseLocalProduct);
            }
        }
    };

     function CheckSplitIsEnabled(splitName) {
         return new Promise((resolve, reject) => {
             splitIoService.getBoolTreatment(splitName).subscribe((isEnabled) => {
                 resolve(isEnabled);
             });
         }); 
    }

   async function saveTabs(saveGlobal, saveLocal, verboseGlobalProduct, verboseLocalProduct) {
        var savePromises = [];
        var msgProduct = $scope.current.isNew ? 'Adding ' : 'Saving ';

        var verbLocalProduct = args.isNewLocal ? 'POST' : 'PUT';
        var verbGlobalProduct = (args.isNewGlobal || args.isAdvisorProduct) ? 'POST' : 'PUT';

        var urlGlobalProduct = (args.isNewGlobal || args.isAdvisorProduct) ? '/Global/Products/Verbose/' : '/Global/Products/Verbose/' + args.id;
        var urlLocalProduct = args.isNewLocal ? '/Portfolio/Products/Verbose/' : '/Portfolio/Products/Verbose/' + args.id;
        var urlFundFamilyOverride = '/Trading/Products/FundFamilyOverrideSave/';

        if (saveGlobal) {
            savePromises.push($http({ method: verbGlobalProduct, url: urlGlobalProduct, data: verboseGlobalProduct, trackerMsg: msgProduct + 'global product' }));
        }

        if (saveLocal && !args.isAdvisorProduct) {
            let urlIs = args.isFundFamilyOverride ? urlFundFamilyOverride : urlLocalProduct;

            const isSplitEnabled = await CheckSplitIsEnabled("OC_Trading_FundFamilyOverride_405PostPutFix_8953");

            if (isSplitEnabled) {
                verbLocalProduct = 'POST';
            }
                
            if (verboseLocalProduct.FundFamiliesOverriden) {
                verboseLocalProduct.FundFamiliesOverriden.forEach(function (detail) {
                    if (detail.altProductOverrideAgg != undefined) {
                        detail.altProductId = detail.altProductOverrideAgg.productId;
                        detail.altTicker = detail.altProductOverrideAgg.ticker;
                        detail.altProductName = detail.altProductOverrideAgg.productName;
                    }
                });
            }

            verboseLocalProduct.FundFamiliesOverriden ?
                savePromises.push($http({ method: verbLocalProduct, url: urlIs, data: verboseLocalProduct, trackerMsg: msgProduct + 'fund families' })) :
                savePromises.push($http({ method: verbLocalProduct, url: urlIs, data: verboseLocalProduct, trackerMsg: msgProduct + 'local product' }));
        }

        if (!angular.equals(assetCategoryWeightingsOriginal, $scope.assetCategoryWeightings)) {
            var argsCat = $scope.assetCategoryWeightings.id > 0 ? { method: "PUT", id: $scope.assetCategoryWeightings.id, trackerMsg: "Saving asset category weightings" } : { method: "POST", id: "", trackerMsg: "Adding new asset category weightings" };
            savePromises.push($http({ method: argsCat.method, url: '/Portfolio/ProductCategories/Weighted/' + argsCat.id, data: $scope.assetCategoryWeightings, trackerMsg: argsCat.trackerMsg }));
        }

        if (!angular.equals(assetClassWeightingsOriginal, $scope.assetClassWeightings)) {
            var argsClass = $scope.assetClassWeightings.id > 0 ? { method: "PUT", id: $scope.assetClassWeightings.id, trackerMsg: "Saving asset class weightings" } : { method: "POST", id: "", trackerMsg: "Adding new asset class weightings" };
            savePromises.push($http({ method: argsClass.method, url: '/Portfolio/ProductClasses/Weighted/' + argsClass.id, data: $scope.assetClassWeightings, trackerMsg: argsClass.trackerMsg }));
        }

        if (!angular.equals(propertyRegionWeightingsOriginal, $scope.propertyRegionWeightings)) {
            savePromises.push($scope.propertyRegionWeightings.id > 0
                ? ProductsAndPrices.weightings.regions.save({ data: $scope.propertyRegionWeightings, params: { id: $scope.propertyRegionWeightings.id } })
                : ProductsAndPrices.weightings.regions.create({ data: $scope.propertyRegionWeightings })
            );
        }

        if (!angular.equals(propertyTypeWeightingsOriginal, $scope.propertyTypeWeightings)) {
            savePromises.push($scope.propertyTypeWeightings.id > 0
                ? ProductsAndPrices.weightings.propertyTypes.save({ data: $scope.propertyTypeWeightings, params: { id: $scope.propertyTypeWeightings.id } })
                : ProductsAndPrices.weightings.propertyTypes.create({ data: $scope.propertyTypeWeightings })
            );
        }

        $q.all(savePromises).then(function (results) {
            editorHotKeys.destroy();
            if (results && results.length > 0) {
                dialog.close(results);
            } else {
                dialog.close(false);
            }
        });
    }

    function formatK1Dates(k1DeliveryDate, k1EstimatedDeliveryDate) {
        if ($scope.productGeneral.alternative && k1DeliveryDate) {
            $scope.productGeneral.alternative.k1DeliveryDate = new Date(k1DeliveryDate).toISOString().split('T')[0];
        }
        if ($scope.productGeneral.alternative && k1EstimatedDeliveryDate) {
            $scope.productGeneral.alternative.k1EstimatedDeliveryDate = new Date(k1EstimatedDeliveryDate).toISOString().split('T')[0];
        }
    }

    $scope.close = function (validate) {
        if (validate) {
            if ($scope.current.parentProduct && ( !angular.equals($scope.productGlobal.productParentId, $scope.current.parentProduct.productId) )) {
                $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true});
            } else if (
                !angular.equals(productGeneralOriginal, $scope.productGeneral) ||
                !angular.equals(productGlobalOriginal, $scope.productGlobal) ||
                !angular.equals(downloadSymbolsOriginal, $scope.downloadSymbols) ||
                !angular.equals(fundFamiliesOriginal, $scope.fundFamilies) ||
                !angular.equals(assetCategoryWeightingsOriginal, $scope.assetCategoryWeightings) ||
                !angular.equals(assetClassWeightingsOriginal, $scope.assetClassWeightings) ||
                !angular.equals(propertyTypeWeightingsOriginal, $scope.propertyTypeWeightings) ||
                !angular.equals(propertyRegionWeightingsOriginal, $scope.propertyRegionWeightings) ||
                !angular.equals(bondRatesOriginal, $scope.bondRates) ||
                !angular.equals(corporateActionsOriginal, $scope.corporateActions) ||
                !angular.equals(dividendsOriginal, $scope.dividends) ||
                !angular.equals(assumedRatesOriginal, $scope.assumedRates) ||
                !angular.equals(preferredRatesOriginal, $scope.preferredRates) ||
                !angular.equals(priceFactorsOriginal, $scope.priceFactors) ||
                !angular.equals(productSubstitutionOriginal, $scope.productSubstitution) ||
                !angular.equals(bondCallsOriginal, $scope.bondCalls) ||
                !angular.equals(customFieldsOriginal, $scope.customFields) ||
                !angular.equals(entityOptionsOriginal, $scope.entityOptions)
            ) {
                $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true});
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };

    $scope.checkForExisting = function (checkWithPrefix) {
        if ($scope.current.isAdvisorProduct && $scope.user.authorization.entity !== 'Administrator') {
            if ($scope.productGlobal.ticker) {
                checkIfTickerExists($scope.current.isAdvisorProduct);
            }else {
                $scope.productGlobal.cusip = null;
            }
        }
    };

    $scope.syncIncomeOverride = function () {
        $scope.productGlobal.allowIncomeOverride = $scope.productGlobal.isDividendSuspended;
    };

// endregion

    //region WATCHES
    $scope.$watch("productGeneral.portfolio.assetClassId", function (newValue, oldValue) {
        if (newValue === oldValue) return;
        setAssetCategory();
    }, true);

    $scope.$watch("alClients.selected", function (newValue, oldValue) {
        if (newValue === oldValue) return;

    }, true);

    $scope.$watch("productGlobal.productType", function (modified, previous) {
        if (previous === modified) return;

        if(
            previous &&
            !$scope.current.productTypeChangePending &&
            !['Bond', 'CD'].any(productGlobalOriginal.productType) &&
            ['Bond', 'CD'].any(modified)
        ) {
            $scope.current.productTypeChangePending = true;
            $http.get('/Global/Products/Prices?$top=1&minPrice=2&minPriceInclusive=false&productId=' + $scope.productGlobal.id, {trackerMsg: 'Testing product type changes'})
                .then(function(response){
                    if(response.data.length) {
                        return $dialog.messageBox(
                            "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Confirm Action",
                            "You are about to update the product type to Bond or CD.  The Orion platform automatically adjusts " +
                            "prices for these product types.  If you are positive this is the appropriate product type, you may commit " +
                            "your change.  However, if you are unsure this is the appropriate product type, please click Cancel and " +
                            "consult the Orion Products & Prices team.",
                            [{result:'confirm', label: 'Confirm', cssClass: 'btn-primary'}, {result:'cancel', label: 'Cancel'}]
                        ).open()
                            .then(function (result) {
                                if (result !== 'confirm') {
                                    $scope.productGlobal.productType = previous;
                                }
                            });
                    }
                }).then(function(){
                    $scope.current.productTypeChangePending = false;
                });
        }
    }, true);



//endregion

    //region INITIALIZE
    $scope.current = {
        productId: args.id,
        isNew: args.isNewLocal || args.isNewGlobal || args.isAdvisorProduct,
        isAdvisorProduct: args.isAdvisorProduct,
        assetCategoryWeightingsTotal: 0,
        assetClassWeightingsTotal: 0,
        propertyTypeWeightingsTotal: 0,
        propertyRegionWeightingsTotal: 0,
        dividendStartDate: Date.create('today').addMonths(-48),
        dividendEndDate: Date.create('today').addMonths(1),
        priceFactorStartDate: Date.create('last month'),
        priceFactorEndDate: Date.create('today'),
        selectedTab: '',
        parentProduct: null,
        assetClassCategory: '',
        advisorProductValid: true,
        fundFamilyName:'',
        selectedFundFamily:{},
        masterGroup:'',
        ownerCode:null,
        isExecuting: false,
        canViewALClients: false,
        cShareExclusionEO: null,
        cShareExclusion: null,
        entityUseFeeHierarchy: false
    };

    $scope.assetClassFieldMap = [{name: "ID", value: "id"}, {name: "Name", value: "name"}, {name: "Description", value: "description"}, {name: "Category", value: "category"}, {name: "Provider", value: "productDescriptionProviderName"}];
    $scope.riskCategoryFieldMap = [{name: "ID", value: "id"}, {name: "Abbreviation", value: "abbreviation"}, {name: "Name", value: "fullName"}, {name: "Provider", value: "productDescriptionProvider"}];
    $scope.productManagerFieldMap = [{name: "ID", value: "id"}, {name: "Name", value: "name"}];


    $scope.errors = [];

    $scope.alClients = {list:[], selected:[]};
    
    $scope.riskCategoriesPromise = null;
    $scope.assetClassesPromise = null;
    //endregion

    //Needed for advisor products -
    function loadMasterGroup() {
        $scope.masterGroupPromise = $http.get('/Settings/Database/EntityOptions/Code/69ADVISORP', {
            trackerMsg: 'Fetching owner code for database'
        })
            .then(function (response) {
                return response.data && response.data.value || $http.get('/Settings/Owner/Code', {trackerMsg: 'Looking up advisor number'})
                    .then(function (response) {
                        return response.data;
                    });
            }).then(function(masterGroup) {
                return $scope.current.masterGroup = masterGroup;
            });
        return $scope.masterGroupPromise;
    }

    function loadDatabases() {
        return $http.get('/Authorization/User/Databases?filterForMasterGroup=true&isActive=true', { trackerMsg: 'Getting database list' })
            .then(function (response) {
                var currentDatabase = response.data.find(database => {
                    return database.id === $scope.user.authorization.alClientId;
                });
                if (currentDatabase && currentDatabase.lockDown) {
                    let isBillingLockdownOverridePrivilege = $oasRights.forCode("billingLockdownOverride").canRead;
                    $scope.isBillingLockdown = isBillingLockdownOverridePrivilege ? false : response.data === currentDatabase.lockDown.toLowerCase().includes('billing');
                }
                return $scope.alClients.list = response.data.sortBy('clientName');
            });
    }


    init();
}]);


app.controller('DownloadSymbolEditCtrl', function DownloadSymbolEditCtrl($scope, $http, $oasRights, dialog) {

    // PRIVATE METHODS
    function init() {
        $scope.current = {maintainVerb: dialog.options.downloadSymbol ? 'Edit' : 'New'};
        $scope.rightsGlobalProducts = $oasRights.forCode("GLOBALPRODUCT");
        $scope.downloadSymbol = dialog.options.downloadSymbol ? angular.copy(dialog.options.downloadSymbol) : null;
    }


    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close(null);
    };

    $scope.save = function () {
        dialog.close($scope.downloadSymbol);
    };


    // INITIALIZE
    init();

});

app.controller('FundFamilyEditCtrl', function FundFamilyEditCtrl($scope, $http, $oasRights, dialog) {

    // PRIVATE METHODS
    function init() {
        $scope.current = {maintainVerb: dialog.options.fundFamily ? 'Edit' : 'New'};
        $scope.rightsGlobalProducts = $oasRights.forCode("GLOBALPRODUCT");
        $scope.fundFamily = dialog.options.fundFamily ? angular.copy(dialog.options.fundFamily) : null;
    }


    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close(null);
    };

    $scope.save = function () {
        dialog.close($scope.fundFamily);
    };


    // INITIALIZE
    init();
});

app.controller('BondRateEditCtrl', function BondRateEditCtrl($scope, $http, $oasRights, dialog, paymentFrequency, dayCounts) {

    // PRIVATE METHODS
    function init() {
        $scope.rightsBondRates = $oasRights.forCode("BONDRATES");

        if (!dialog.options.bondRate) {
            $scope.bondRate = {
                id: 0,
                datedDate: null,
                couponRate: null,
                maturityDate: null,
                alternateMaturityDate: null,
                parValue: null,
                paymentFrequency: null,
                isCompounding: false,
                issueDate: null,
                interestAccrualDate: null,
                isFederallyTaxable: false,
                isStateTaxable: false,
                stateId: null,
                dayCount: null,
                isVariableRate: false,
                isInDefault: false,
                callDate: null,
                callPrice: null,
                initialCouponDate: null,
                isoid: false,
                isamt: false,
                inDefaultDate: null
            };
        } else {
            $scope.bondRate = angular.copy(dialog.options.bondRate);
            $scope.bondRate.couponRate = ($scope.bondRate.couponRate * 100).round(8);
        }

        $scope.paymentFrequency = paymentFrequency.keys().map(function (key) {
            return {id: parseInt(paymentFrequency[key].value), name: paymentFrequency[key].name};
        });

        $scope.dayCounts = dayCounts.keys().map(function (key) {
            return {id: parseInt(dayCounts[key].value), name: dayCounts[key].name};
        });
    }


    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close(null);
    };

    $scope.save = function () {
        $scope.bondRate.couponRate = ($scope.bondRate.couponRate / 100).round(8);
        dialog.close($scope.bondRate);
    };


    // INITIALIZE
    init();

});

app.controller('BondCallEditCtrl', function BondCallEditCtrl($scope, $http, $oasRights, dialog, $dialog) {

    // PRIVATE METHODS
    function init() {
        $scope.current = {isNew: false};
        $scope.rightsBondCall = $oasRights.forCode("PRODUCTBONDCALL");

        if (!dialog.options.bondCall) {
            $scope.bondCall = {
                productId: dialog.options.productId,
                callPrice: null,
                callDate: null
            };

            $scope.current.isNew = true;
        } else {
            $scope.bondCall = angular.copy(dialog.options.bondCall);
        }
    }

    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close(null);
    };

    $scope.saveBondCall = function () {
        if ($scope.current.isNew) {
            $http.post("/Portfolio/Products/BondCalls", $scope.bondCall, {trackerMsg: 'Adding new bond call'})
                .then(function () {
                    dialog.close('refresh');
                });
        } else {
            $http.put("/Portfolio/Products/BondCalls/" + $scope.bondCall.productId + "/" + dialog.options.bondCall.callDate, $scope.bondCall, {trackerMsg: 'Updating bond call'})
                .then(function () {
                    dialog.close('refresh');
                });
        }
    };

    $scope.deleteBondCall = function () {
        $dialog.confirmAction("Are you sure you want to remove the bond call price?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete("/Portfolio/Products/BondCalls/" + $scope.bondCall.productId + "/" + dialog.options.bondCall.callDate, $scope.bondCall, {trackerMsg: 'Deleting bond call'})
                        .then(function () {
                            dialog.close('delete');
                        });
                }
            });
    };

    // INITIALIZE
    init();

});

'use strict';

app.controller('PriceLocalListCtrl', function PriceLocalListCtrl($scope, $http, $oasRights, $dialog, views, $routeParams, civ2Service, splitIoService) {


    // PUBLIC METHODS
    $scope.refreshGrid = function( ) {
        $scope.current.loadedProduct = $scope.current.product.productName;
        $scope.$broadcast('event:localprice-action', {action: 'refresh-grid'});
    };

    $scope.addPrice = function( ) {
        var newPriceLocal = {
            productId: $scope.current.product.productId,
            priceDate: $scope.current.priceDate.formatted(),  //because API doesn't allow a time
            navPrice: $scope.current.navPrice
        };

        $http.post('/Portfolio/Products/Prices/Local/', newPriceLocal, { trackerMsg: 'Adding new price' } )
            .then( function ( ) {
                $scope.$broadcast('event:localprice-action', {action: 'refresh-grid'});
                $scope.current.priceDate = Date.create();
                $scope.current.navPrice = null;
            });
    };

    $scope.setPriceFilter = function() {
        $scope.current.view.filters.find({name: "Price"}).value = "(function (a) { return a " + $scope.current.filterPriceType + " " + $scope.current.filterPrice + "; })";
    };

    $scope.setDateFilter = function() {
        var startDate = Date.create($scope.current.filterStartDate).addDays(-1);
        var endDate = Date.create($scope.current.filterEndDate).addDays(1);
        $scope.current.view.filters.find({name: "Date"}).value = "(function (a) { return Date.create(a).isBetween('" + startDate + "', '" + endDate + "'); })";
    };

    $scope.importPrices = function () {
        if (hasRightsToLocalPriceImport()) {
            civ2Service.getImportType("Local Price").then(function (res) {
                $dialog.createCustomImport(res.data.id, "Local Price Import");
            });
        } else {
            var errorMessage = 'The Local Price Import has been added to the Custom Imports application. You do not have the necessary access required. ' +
                'Please contact your firm’s administrator to update your role inside the Manage Users Application. </br></br>' +
                'You are missing the following privilege(s):</br></br>' +
                customImportRightsErrorMessage();

            $dialog.actionFailed(errorMessage).open();
        }
    };

    function hasRightsToLocalPriceImport() {
        return $scope.rightsCustomImports.canRead && $scope.rightsLocalPriceImport.canRead;
    }

    function customImportRightsErrorMessage() {
        var rightsErrorMessage = [];

        if (!$scope.rightsCustomImports.canRead) {
            rightsErrorMessage.push('Apps > Tools > Custom Imports 2');
        }

        if (!$scope.rightsLocalPriceImport.canRead) {
            rightsErrorMessage.push('Actions > Custom Imports > Local Price Import');
        }

        return rightsErrorMessage.join('</br></br>')
    }

    // PRIVATE METHODS
    function init( ) {
        $scope.rightsLocalPrices = $oasRights.forCode("LOCALPRICES");
        $scope.rightsCustomImports = $oasRights.forCode("CUSTOMIMPORTS2");
        $scope.rightsLocalPriceImport = $oasRights.forCode("LOCALPRICEIMPORT");

        $scope.current.view.filterType = "All";
        $scope.current.view.filters.push({ name: "Price", value: "(function (a) { return true; })", key: "navPrice", include: true });
        $scope.current.view.filters.push({ name: "Date", value: "(function (a) { return true; })", key: "priceDate", include: true });

        $scope.setPriceFilter();
        $scope.setDateFilter();

        $http.get("/Settings/Database/EntityOptions/Code/69PRICECUT", {cache: true, trackerMsg: 'Local price cut-over date'})
            .then(function (response) {
                if (new Date(response.data.value).isValid()){
                    $scope.current.cutOverDate = Date.create(response.data.value).formatted();

                    // Check if this date is the default date then set it to null
                    if ($scope.current.cutOverDate === '01/01/1900'){
                        $scope.current.cutOverDate = null;
                    }
                }

            });

        if ($routeParams.startDate) {
            $scope.current.filterStartDate = Date.create($routeParams.startDate);
        }
        if ($routeParams.endDate) {
            $scope.current.filterEndDate = Date.create($routeParams.endDate);
        }
        if ($routeParams.productId) {
            $scope.current.product = {
                productId: $routeParams.productId
            };
            $http.get("/Global/Products/" + $routeParams.productId, { cache: true, trackerMsg: 'Loading global product' })
                .then(function (responseGlobal) {
                    if (responseGlobal && responseGlobal.data) {
                        $scope.current.product = {
                            productId: responseGlobal.data.id,
                            productName: responseGlobal.data.productName,
                            productType: responseGlobal.data.productType,
                            ticker: responseGlobal.data.ticker
                        };

                        //get the local product in case there is a name override
                        $http.get("/Portfolio/Products/" + $scope.current.product.productId, { cache: true, trackerMsg: 'Loading local product' })
                            .then(function (responseLocal) {
                                if (responseLocal && responseLocal.data) {
                                    $scope.current.product.productName = responseLocal.data.productName;
                                    $scope.current.loadedProduct = responseLocal.data.productName;
                                }
                            });
                    }
                });
        }
    }


    // WATCHES
    $scope.$watch("current.product", function (newValue, oldValue) {
        if (newValue == null || newValue === oldValue || (oldValue != null && newValue.productId === oldValue.productId)) return;
        if ($scope.current.product != null && $scope.current.product.productId > 0) {
            $scope.productLocal = null;
            $scope.productGlobal = null;

            $http.get("/Portfolio/Products/Verbose/" + $scope.current.product.productId, { trackerMsg: 'Loading local product' })
                .then(function (response) {
                    $scope.productLocal = response.data.portfolio;
                });

            $http.get("/Global/Products/Verbose/" + $scope.current.product.productId, { trackerMsg: 'Loading global product' })
                .then(function (response) {
                    $scope.productGlobal = response.data.portfolio;
                });
        }
    });

    // INIT
    $scope.current = {
        product: null,
        view: views[0],
        priceDate: Date.create(),
        navPrice: null,
        filterStartDate: Date.create('today').addYears(-1),
        filterEndDate: Date.create('today'),
        filterPriceType: ">=",
        filterPrice: 0,
        loadedProduct: ''
    };
    $scope.selectedIds = [];

    init( );
});
'use strict';

app.controller('PriceGlobalListCtrl', function PriceGlobalListCtrl($scope, $http, $oasRights, $dialog, views, $routeParams, productTypes) {
    // PRIVATE VARIABLES

    // PRIVATE METHODS
    function init( ) {
        $scope.rightsPrices = $oasRights.forCode("PRICES");
        $scope.rightsIndexPrices = $oasRights.forCode("INDEXPRODUCTSEARCH");

        const params = ['codeNames=69OPTIMIZEPRICESCRN', 'codeNames=69ENABLEPRICEMOVETOOL'];

        $http.get('/Settings/Database/EntityOptions?' + params.join('&'), { trackerMsg: 'Loading page settings' })
            .then(function (response) {
                response.data.forEach((setting) => {
                    if (setting.code == '69ENABLEPRICEMOVETOOL') {
                        $scope.isPriceMoveToolEnabled = setting.value.toLowerCase() === 'true';
                    } else if (setting.code == '69OPTIMIZEPRICESCRN') {
                        $scope.usePriceScreenOptimizations = setting.value.toLowerCase() === 'true';
                        if ($scope.usePriceScreenOptimizations) {
                            $scope.current.view.filters.push({ name: "Custodian", value: "(function (a) { return true; })", key: "custodianCommonId", include: true });
                        }
                    }
                });
            });

        $scope.current.view.filters.push({ name: "Price", value: "(function (a) { return true; })", key: "navPrice", include: true });

        if ($routeParams.startDate) {
            $scope.current.startDate = Date.create($routeParams.startDate);
        }
        if ($routeParams.endDate) {
            $scope.current.endDate = Date.create($routeParams.endDate);
        }
        if ($routeParams.productId) {
            $scope.current.product = {
                productId: $routeParams.productId
            };
            $http.get("/Global/Products/" + $routeParams.productId, { cache: true, trackerMsg: 'Loading global product' })
                .then(function (responseGlobal) {
                    if (responseGlobal && responseGlobal.data) {
                        $scope.current.product = {
                            productId: responseGlobal.data.id,
                            productName: responseGlobal.data.productName,
                            productType: responseGlobal.data.productType,
                            ticker: responseGlobal.data.ticker
                        };

                        //get the local product in case there is a name override
                        $http.get("/Portfolio/Products/" + $scope.current.product.productId, { cache: true, trackerMsg: 'Loading local product' })
                            .then(function (responseLocal) {
                                if (responseLocal && responseLocal.data) {
                                    $scope.current.product.productName = responseLocal.data.productName;
                                    $scope.current.loadedProductName = responseLocal.data.productName;
                                }
                            });
                    }
                });
        }
    }

    // PUBLIC METHODS
    $scope.refreshGrid = function( ) {
        $scope.current.loadedProductName = $scope.current.product.productName;
        $scope.$broadcast('event:global-price-action', {action: 'refresh-grid'});
    };

    $scope.setPriceFilter = function() {
        $scope.current.view.filters.find({name: "Price"}).value = "(function (a) { return a " + $scope.current.filterPriceType + " " + $scope.current.filterPrice + "; })";
    };

    $scope.setCustodianFilter = function (custodian) {
        if ($scope.usePriceScreenOptimizations) {
            $scope.current.view.filters.find({ name: "Custodian" }).value = "(function (a) { return !" + custodian + " || a === " + custodian + "; })";
        }
    };

    $scope.updatePrice = function( isNew ) {
        var dialogOpts = {
            templateUrl : "global-price-edit.html",
            controller : "GlobalPriceEditCtrl",
            id : isNew ? null : $scope.selectedIds[0],
            product : isNew ? $scope.current.product : null,
            dialogClass: "modal wide"
        };

        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function(rslt){
                if( rslt ) {
                    $scope.$broadcast('event:global-price-action', {action: 'refresh-grid'});
                }
            });
    };

    $scope.movePrices = function() {
        var dialogOpts = {
            templateUrl: "global-price-move-tool.html",
            controller: "GlobalPriceMoveToolCtrl",
            ids: $scope.selectedIds,
            moveAction: 'Move',
            dialogClass: "modal wide",
        };

        $dialog.dialog(dialogOpts).open().then((completedMessage) => {
            if (completedMessage) {
                $dialog.actionComplete(completedMessage).open();
                $scope.refreshGrid();
            }
        });
    };

    $scope.copyPrices = function() {
        var dialogOpts = {
            templateUrl: "global-price-move-tool.html",
            controller: "GlobalPriceMoveToolCtrl",
            ids: $scope.selectedIds,
            moveAction: 'Copy',
            dialogClass: "modal wide",
        };

        $dialog.dialog(dialogOpts).open().then((completedMessage) => {
            if (completedMessage) {
                $dialog.actionComplete(completedMessage).open();
                $scope.refreshGrid();
            }
        });
    };

    $scope.openHistory = function( ) {
        var dialogOpts = {
            templateUrl : "global-price-history.html",
            controller : "GlobalPriceHistoryCtrl",
            id : $scope.selectedIds[0],
            dialogClass: "modal wide"
        };

        $dialog.dialog(dialogOpts).open();
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.updatePrice(false);
    };


    // WATCHES
    $scope.$watch("current.product", function (newValue, oldValue) {
        if (newValue == null || newValue === oldValue || (oldValue != null && newValue.productId === oldValue.productId)) return;
        if ($scope.current.product != null && $scope.current.product.productId > 0) {
            $scope.productLocal = null;
            $scope.productGlobal = null;

            $http.get("/Portfolio/Products/Verbose/" + $scope.current.product.productId, { cache: true, trackerMsg: 'Loading local product' })
                .then(function (response) {
                    $scope.productLocal = response.data.portfolio;
                });

            $http.get("/Global/Products/Verbose/" + $scope.current.product.productId, { cache: true, trackerMsg: 'Loading global product' })
                .then(function (response) {
                    $scope.productGlobal = response.data.portfolio;
                });

            if ($scope.usePriceScreenOptimizations) {
                //setTimeout will execute it immediately, but in a separate digest/event cycle
                //to allow the productId to finish updating on the slickgrid control
                setTimeout($scope.refreshGrid);
            }
        }
    });


    // INIT
    $scope.current = { 
        product: null, 
        loadedProductName: null, 
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick, 
        startDate: Date.create('1 month ago'), 
        endDate: Date.create('today'), 
        custodianCommonId: 0, 
        filterPriceType: ">=", 
        filterPrice: 0,
        isAdmin: $scope.user.authorization.entity === 'Administrator'
    } ;

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            $scope.updatePrice(false);
    }}];
    $scope.selectedIds = [];
    $scope.isPriceMoveToolEnabled = false;
    $scope.usePriceScreenOptimizations = false;
    $scope.productTypes = productTypes;

    init( );
});

app.controller('GlobalPriceEditCtrl', function GlobalPriceEditCtrl( $scope, $http, $oasRights, dialog ) {

    var keys = dialog.options.id ? dialog.options.id.split('/') : null;

    function init( ) {
        $scope.price = null;
        $scope.product = null;

        $scope.rightsPrices = $oasRights.forCode("PRICES");

        if( keys ) {
            $http.get("/Global/Products/Prices/" + keys[0] + "/" + keys[1] + "/" + keys[2], {trackerMsg: 'Loading price'})
                .then(function (response) {
                    $scope.price = response.data;

                    $http.get("/Trading/Products/Search/" + response.data.productId , {trackerMsg: 'Loading product'})
                        .then(function(products){
                            $scope.product = products.data[0];
                        });

                });
        } else {
            $scope.price = {
                "productId" : null,
                "priceDate" : null,
                "navPrice" : null,
                "custodianCommonId": 1
            };

            if( dialog.options.product ) {
                $scope.product = dialog.options.product;
            }

            $scope.current.isNew = true;
        }
    }

    // PUBLIC METHODS
    $scope.cancel = function( ) {
        dialog.close( null );
    };

    $scope.save = function( ) {
        if( keys ) {
            var urlPut = "/Global/Products/Prices/" + keys[0] + "/" + keys[1] + "/" + keys[2] + "?isValidated=" + $scope.current.isValidated + "&reason=" + $scope.current.priceReason + "&notes=" + $scope.current.notes;
            $http.put(urlPut, $scope.price, { trackerMsg: 'Updating price' } )
                .then( function ( response ) {
                    dialog.close( response.data );
                });
        } else {
            $scope.price.productId = $scope.product.productId;
            $scope.price.priceDate = $scope.price.priceDate.formatted( );
            var urlPost = "/Global/Products/Prices?isValidated=" + $scope.current.isValidated + "&reason=" + $scope.current.priceReason + "&notes=" + $scope.current.notes;
            $http.post(urlPost, $scope.price, { trackerMsg: 'Adding price' } )
                .then( function ( response ) {
                    dialog.close( response.data );
                });
        }
    };

    $scope.current = { notes: null, priceReason: null, isValidated: false, isNew : false };

    $scope.priceReasons = [
        { id: 1, name: "Third Party Website" },
        { id: 2, name: "Institution Website" },
        { id: 3, name: "Advisor Confirmed Price" },
        { id: 4, name: "Other" },
        { id: 5, name: "Multiplying price * factor" },
        { id: 6, name: "Bond pricing-first price in" },
        { id: 7, name: "Less rounded price" },
        { id: 8, name: "Correcting decimal on price" },
        { id: 9, name: "Updating CSI price from CSI update records" },
        { id: 10, name: "Price is not a USD price" },
        { id: 11, name: "Price is from a different effective date" }
    ];


    // INITIALIZE
    init( );

} );

app.controller('GlobalPriceHistoryCtrl', function GlobalPriceHistoryCtrl( $scope, $http, $oasRights, dialog ) {

    var keys = dialog.options.id ? dialog.options.id.split('/') : null;

    function init( ) {
        $scope.priceHistories = null;
        $scope.rightsPrices = $oasRights.forCode("PRICES");

        $http.get("/Global/Products/Prices/" + keys[0] + "/" + keys[1] + "/" + keys[2] + "/Audits?$orderby=Timestamp desc", {trackerMsg: 'Loading price history'})
            .then(function (response) {
                $scope.priceHistories = response.data;
            });
    }

    // PUBLIC METHODS
    $scope.close = function( ) {
        dialog.close( null );
    };


    // INITIALIZE
    init( );

} );

app.controller('GlobalPriceMoveToolCtrl', function GlobalPriceMoveToolCtrl( $scope, $http, $oasRights, dialog ) {

    var priceIds = dialog.options.ids;
    var moveAction = dialog.options.moveAction;

    function init() {
        $scope.rightsPrices = $oasRights.forCode("PRICES");

        buildPriceKeys();
        
        $scope.moveFromProductId = $scope.priceKeys.first()?.productId;
        $scope.confirmMessageAction = (moveAction === 'Move') ? 'Moved' : 'Copied';
    }

    function buildPriceKeys() {
        if (priceIds) {
            priceIds.forEach((priceId) => {
                var ids = priceId.split('/');
                $scope.priceKeys.push({
                    productId: ids[0],
                    custodianCommonId: ids[1],
                    priceDate: ids[2]
                });
            });
        }
    }

    // PUBLIC METHODS
    $scope.cancel = function( ) {
        dialog.close(null);
    };

    $scope.save = function() {
        $scope.isSaving = true;
        
        if($scope.priceKeys && $scope.priceKeys.length > 0 && $scope.current.product && $scope.current.product.productId) {
            var moveActionApi = '';
            var trackerMessage = '';
            if (moveAction === 'Move') {
                moveActionApi = 'MovePrices';
                trackerMessage = 'Moving Prices';
            } else if (moveAction === 'Copy') {
                moveActionApi = 'CopyPrices';
                trackerMessage = 'Copying Prices';                
            }

            var urlPost = `/Global/Products/Prices/${moveActionApi}/${$scope.current.product.productId}?auditNotes=${$scope.current.notes}&overwriteOnMatch=${$scope.current.overwriteOnMatch}`;
            $http.post(urlPost, $scope.priceKeys, { trackerMsg: trackerMessage })
                .then(function () {
                    dialog.close(`${$scope.confirmMessageAction} ${$scope.priceKeys.length} price(s) from Product ID ${$scope.moveFromProductId} to Product ID ${$scope.current.product.productId}`);  
                }).finally(() => {
                    $scope.isSaving = false;
                });
        } else {
            dialog.close(null);
        }
    }

    $scope.current = { 
        notes: null, 
        product: null,
        overwriteOnMatch: false,
    };
    $scope.moveToolActionTitle = `${moveAction} Prices to Another Product`;
    $scope.moveFromProductId = null;
    $scope.priceKeys = [];
    $scope.confirmMessageAction = '';
    $scope.isSaving = false;

    init();
} ); 
'use strict';

app.controller('BondRatingsListCtrl', function BondRatingsListCtrl($scope, $http, $oasRights, $dialog) {

    // PRIVATE METHODS
    function init( ) {
        $http.get('/Portfolio/BondRatings', {trackerMsg: 'Loading bond ratings'})
            .then(function(response) {
                $scope.bondRatings = response.data;
            });
    }


    // PUBLIC METHODS
    $scope.deleteBondRating = function(br) {
        $dialog.confirmAction( "Are you sure you want to remove bond rating <b>" + br.description + "</b>?" )
            .open()
            .then( function( result ) {
                if( result == 'yes' ) {
                    $http.delete('/Portfolio/BondRatings/' + br.id, {trackerMsg: 'Deleting bond rating ' + br.description})
                        .then(function () {
                            $scope.bondRatings.remove({id: br.id});
                        }
                    );
                }
            } );
    };

    // INITIALIZE
    $scope.rightsBondRating = $oasRights.forCode('BONDRATING');
    $scope.bondRatings = [];

    init( );
});
'use strict';

app.controller('BondRatingCtrl', function BondRatingCtrl($scope, $http, $location, $routeParams, $oasRights, $cacheFactory, API_CONFIG) {

    // PRIVATE VARIABLES
    var bondRatingId = $routeParams.id;


    // PRIVATE METHODS
    function loadBondRating( ) {
        if( bondRatingId > 0 ) {
            $http.get('/Portfolio/BondRatings/' + bondRatingId, {trackerMsg: 'Loading bond rating ' + bondRatingId})
                .then(function (response) {
                    $scope.bondRating = response.data;
                });
        }
        else {
            $scope.bondRating = { id: 0, code: null, ratingNumber: null, description: null, source: null };
        }
    }


    // PUBLIC METHODS
    $scope.saveBondRating = function( form ) {
        if (!form.$valid) return;

        var args = bondRatingId > 0 ? {method: "PUT", id: bondRatingId, trackerMsg: "Saving bond rating " + bondRatingId} : {method: "POST", id: "", trackerMsg: "Adding new bond rating"};

        $http( { method: args.method, url: '/Portfolio/BondRatings/' + args.id, data: $scope.bondRating, trackerMsg: args.trackerMsg } )
            .then(function() {
                var cache = $cacheFactory.get('$http');
                cache.remove(API_CONFIG.baseUrl + '/Portfolio/BondRatings/Simple');

                $location.path( '/bondratings' );
            });
    };

    $scope.deleteBondRating = function( ) {
        $http.delete('/Portfolio/BondRatings/' +  bondRatingId, {trackerMsg: 'Deleting bond rating ' + bondRatingId})
            .then(function () {
                $location.path( '/bondratings' );
            });
    };


    // INIT
    $scope.rightsBondRating = $oasRights.forCode('BONDRATING');
    $scope.sources = [ 'MOODY', 'S&P' ];

    loadBondRating( );
});
'use strict';

app.controller('ProductCategoryListCtrl', function ProductCategoryListCtrl($scope, $http, $oasRights, $dialog) {

    // PRIVATE METHODS
    function init( ) {
        $http.get('/Portfolio/ProductCategories', {trackerMsg: 'Loading asset categories'})
            .then(function(response) {
                $scope.productCategories = response.data;
            });
    }


    // PUBLIC METHODS
    $scope.deleteProductCategory = function(productCategory) {
        $dialog.confirmAction( "Are you sure you want to remove asset category <b>" + productCategory.categoryName + "</b>?" )
            .open()
            .then( function( result ) {
                if( result == 'yes' ) {
                    $http.delete('/Portfolio/ProductCategories/' + productCategory.id, {trackerMsg: 'Deleting asset category ' + productCategory.categoryName})
                        .then(function () {
                            $scope.productCategories.remove({id: productCategory.id});
                        }
                    );
                }
            } );
    };

    $scope.assignProductCategoryColors = function( ) {
        $dialog.confirmAction( "Do you want to assign random colors to any asset class without a color?" )
            .open()
            .then( function( result ) {
                if( result == 'yes' ) {
                    $http.put("/Portfolio/ProductCategories/Action/EstablishColors", [], {trackerMsg: 'Updating colors.'})
                        .then(function () {
                            init( );
                            $dialog.messageBox("Update successful", "The unassigned colors have been updated.").open();
                        });
                }
            } );
    };

    // INITIALIZE
    $scope.current = { isAdmin: $scope.user.authorization.entity === 'Administrator' };
    $scope.rightsProductCategory = $oasRights.forCode('PRODUCTCATEGORY');
    $scope.productCategories = [];

    init( );
});
'use strict';

app.controller('ProductCategoryCtrl', function ProductCategoryCtrl($scope, $http, $location, $routeParams, $oasRights, $cacheFactory, $portfolio, API_CONFIG) {

    // PRIVATE VARIABLES
    var productCategoryId = $routeParams.id;
    var entityOptionsOriginal;


    // PRIVATE METHODS
    function init() {
        loadProductCategory();
        loadEntityOptions();
        loadParentCategories();
    }
    function loadProductCategory( ) {
        if( productCategoryId > 0 ) {
            $http.get('/Portfolio/ProductCategories/' + productCategoryId, {trackerMsg: 'Loading asset category ' + productCategoryId})
                .then(function (response) {
                    $scope.productCategory = response.data;
                });
        }
        else {
            $scope.productCategory = { id: 0, abbreviation: null, categoryName: null, color: null, parentCategory: null, sortOrder: null };
        }
    }

    function loadEntityOptions() {
        if( productCategoryId > 0 ) {
            $http.get("/Settings/EntityOptions/AssetCategories/" + productCategoryId, {trackerMsg: 'Loading options'})
                .then(function (response) {
                    $scope.entityOptions = response.data;
                    $portfolio.cleanCustomFields($scope.entityOptions);
                    entityOptionsOriginal = angular.copy($scope.entityOptions);
                });
        }
    }

    function loadParentCategories() {
        $http.get('/Portfolio/ParentCategories/', {trackerMsg: 'Loading parent categories'})
            .then(function (response) {
                $scope.parentCategories = response.data;
            });
    }


    // PUBLIC METHODS
    $scope.saveProductCategory = function( form ) {
        //if (!form.$valid) return;

        var args = productCategoryId > 0 ? {method: "PUT", id: productCategoryId, trackerMsg: "Saving asset category " + productCategoryId} : {method: "POST", id: "", trackerMsg: "Adding new asset category"};

        if($scope.entityOptions && !angular.equals(entityOptionsOriginal, $scope.entityOptions)) {
            var eo = $portfolio.restoreEntityOptions($scope.entityOptions)
            $http.put("/Settings/EntityOptions/AssetCategories", eo, {trackerMsg: 'Saving options'})
                .then(function (response) {
                    return $http( { method: args.method, url: '/Portfolio/ProductCategories/' + args.id, data: $scope.productCategory, trackerMsg: args.trackerMsg } )
                })
                .then(function (){
                    var cache = $cacheFactory.get('$http');
                    cache.remove(API_CONFIG.baseUrl + '/Portfolio/ProductCategories/Simple');

                    $location.path( '/assetcategories' );
                });
        }
        else {
            $http( { method: args.method, url: '/Portfolio/ProductCategories/' + args.id, data: $scope.productCategory, trackerMsg: args.trackerMsg } )
                .then(function() {
                    var cache = $cacheFactory.get('$http');
                    cache.remove(API_CONFIG.baseUrl + '/Portfolio/ProductCategories/Simple');

                    $location.path( '/assetcategories' );
                });
        }
    };

    $scope.deleteProductCategory = function( ) {
        $http.delete('/Portfolio/ProductCategories/' +  productCategoryId, {trackerMsg: 'Deleting asset category ' + productCategoryId})
            .then(function () {
                $location.path( '/assetcategories' );
            });
    };


    // INIT
    $scope.rightsProductCategory = $oasRights.forCode('PRODUCTCATEGORY');

    init( );
});
'use strict';

app.controller('ParentCategoryListCtrl', function ParentCategoryListCtrl( $scope, $oasRights ) {
    $scope.current = {
        updateValue: null
    };
    //PRIVATE VARIABLES

    //PRIVATE METHODS
    function init(){
    }

    //PUBLIC METHODS

    $scope.add = function(){
        $scope.current.updateValue = "add|" + Date.create().getMilliseconds();
    };

    //INITIALIZE
    $scope.rights = $oasRights.forCode("PARENTCATEGORIES");
    init();
});
'use strict';

var riskCategoryCtrl = app.controller('RiskCategoryCtrl', function RiskCategoryCtrl($scope, $http, $location, $dialog, $oasRights, $routeParams, $portfolio, $cacheFactory, API_CONFIG) {

    // PRIVATE VARIABLES
    var riskCategoryId = $routeParams.id;


    // PRIVATE METHODS
    function loadRiskCategory() {
        if (riskCategoryId > 0) {
            $http.get('/Portfolio/RiskCategories/Verbose/' + riskCategoryId, {trackerMsg: 'Loading risk category ' + riskCategoryId})
                .then(function (response) {
                    $scope.riskCategory = response.data;
                });
            $http.get('/Settings/EntityOptions/RiskCategories/' + riskCategoryId, {trackerMsg: 'Loading risk category options'})
                .then(function (response) {
                    $portfolio.cleanCustomFields(response.data);
                    $scope.entityOptions = response.data;
                });
        }
        else {
            $http.get('/Portfolio/RiskCategories/Verbose/New', {trackerMsg: 'Loading risk category'})
                .then(function (response) {
                    $scope.riskCategory = response.data;
                });
        }
    }

    function checkBillingLockdown(){
        $http.get("/Authorization/User/Databases/LockDown", { trackerMsg: 'Checking Billing Lockdown' })
        .then(function (response) {
            let isBillingLockdownOverridePrivilege = $oasRights.forCode("billingLockdownOverride").canRead;
            $scope.isBillingLockdown = isBillingLockdownOverridePrivilege ? false : response.data === 'Billing';
        });
    }


    // PUBLIC METHODS
    $scope.saveRiskCategory = function () {
        var verboseRiskCategory = {id: riskCategoryId, portfolio: $scope.riskCategory.portfolio};

        if (riskCategoryId > 0) verboseRiskCategory["entityOptions"] = $portfolio.restoreEntityOptions($scope.entityOptions);

        var args = riskCategoryId > 0 ? {method: "PUT", id: riskCategoryId, trackerMsg: "Saving risk category " + riskCategoryId} : {method: "POST", id: "", trackerMsg: "Adding new risk category"};

        $http({method: args.method, url: '/Portfolio/RiskCategories/Verbose/' + args.id, data: verboseRiskCategory, trackerMsg: args.trackerMsg})
            .then(function () {
                var cache = $cacheFactory.get('$http');
                cache.remove(API_CONFIG.baseUrl + '/Portfolio/RiskCategories/Simple');

                $location.path('/riskcategories');
            });
    };

    $scope.deleteRiskCategory = function () {
        $http.delete('/Portfolio/Riskcategories/Verbose/' + riskCategoryId, {trackerMsg: 'Deleting risk category ' + riskCategoryId})
            .then(function () {
                $location.path('/riskcategories');
            });
    };


    // INIT
    $scope.rightsRiskCategory = $oasRights.forCode('RISKCAT');
    checkBillingLockdown();
    loadRiskCategory();
});


riskCategoryCtrl.getRiskCategoryListConfig = function () {
    return {
        getUrl: '/Portfolio/RiskCategories',
        deleteUrl: '/Portfolio/RiskCategories/Verbose/',
        listName: 'Risk Categories',
        template: 'products/views/risk-category-list-item.html',
        icon: 'fa fa-compass',
        selectEnabled: false,
        multiSelectEnabled: false,
        nameProperty: 'fullName',
        sortFields: {fullName: "Name", id: "ID", rank: "Rank", value: "Value"},
        listFilter: ['fullName', 'abbreviation'],
        securityCode: 'RISKCAT',
        additionalLinks: [
            {name: "Assign Colors", url: "", clickEvent: "assignRiskColors", icon: "fa fa-tint", securityCode: "RISKCAT"},
            {name: "New Risk Category", url: "#/riskcategories/0", icon: "fa fa-pencil", securityCode: "RISKCAT"}
        ]
    };
};

riskCategoryCtrl.getRiskCategoryListConfig = ["$oasRights", function( $oasRights ) {

    var rightsRiskCategory = $oasRights.forCode('RISKCAT');
    var c = {
        getUrl: '/Portfolio/RiskCategories',
        deleteUrl: '/Portfolio/RiskCategories/Verbose/',
        listName: 'Risk Categories',
        template: 'products/views/risk-category-list-item.html',
        icon: 'fa fa-compass',
        selectEnabled: false,
        multiSelectEnabled: false,
        nameProperty: 'fullName',
        sortFields: {fullName: "Name", id: "ID", rank: "Rank", value: "Value"},
        listFilter: ['fullName', 'abbreviation'],
        securityCode: 'RISKCAT',
        additionalLinks: [


        ]
    };

    if( rightsRiskCategory.canAdd ) {
        c.additionalLinks.push( {name: "New Risk Category", url: "#/riskcategories/0", icon: "fa fa-pencil", securityCode: "RISKCAT"} );
    }

    if( rightsRiskCategory.canUpdate ) {
        c.additionalLinks.push( {name: "Assign Colors", url: "", clickEvent: "assignRiskColors", icon: "fa fa-tint", securityCode: "RISKCAT"} );
    }

    return c;

}];
'use strict';

var productClassCtrl = app.controller('ProductClassCtrl', function ProductClassCtrl($scope, $http, $location, $dialog, $oasRights, $routeParams, $portfolio, $cacheFactory, API_CONFIG) {

    // PRIVATE VARIABLES
    var productClassId = $routeParams.id;


    // PRIVATE METHODS
    function loadProductClass() {
        if (productClassId > 0) {
            $http.get('/Portfolio/ProductClasses/Verbose/' + productClassId, {trackerMsg: 'Loading asset class ' + productClassId})
                .then(function (response) {
                    $scope.productClass = response.data;
                });
            $http.get('/Settings/EntityOptions/AssetClasses/' + productClassId, {trackerMsg: 'Loading asset class options'})
                .then(function (response) {
                    $portfolio.cleanCustomFields(response.data);
                    $scope.entityOptions = response.data;
                });
        }
        else {
            $http.get('/Portfolio/ProductClasses/Verbose/New', {trackerMsg: 'Loading asset class'})
                .then(function (response) {
                    $scope.productClass = response.data;
                });
        }
    }


    // PUBLIC METHODS
    $scope.saveProductClass = function (form) {
        //if (!form.$valid) return;

        var verboseProductClass = {};
        verboseProductClass["id"] = productClassId;
        verboseProductClass["portfolio"] = $scope.productClass.portfolio;

        if (productClassId > 0 && $scope.entityOptions) verboseProductClass["entityOptions"] = $portfolio.restoreEntityOptions($scope.entityOptions);

        var args = productClassId > 0 ? {method: "PUT", id: productClassId, trackerMsg: "Saving asset class " + productClassId} : {method: "POST", id: "", trackerMsg: "Adding new asset class"};

        $http({method: args.method, url: '/Portfolio/ProductClasses/Verbose/' + args.id, data: verboseProductClass, trackerMsg: args.trackerMsg})
            .then(function () {
                var cache = $cacheFactory.get('$http');
                cache.remove(API_CONFIG.baseUrl + '/Portfolio/ProductClasses/Simple');

                $location.path('/assetclasses');
            });
    };

    $scope.deleteProductClass = function () {
        $http.delete('/Portfolio/ProductClasses/Verbose/' + productClassId, {trackerMsg: 'Deleting asset class ' + productClassId})
            .then(function () {
                $location.path('/assetclasses');
            });
    };


    // INIT
    $scope.rightsProductClass = $oasRights.forCode('ASSETCLASSES');
    $scope.rightsProductCategory = $oasRights.forCode('PRODUCTCATEGORY');   
    $scope.rightsAssetClassAbbreviation = $oasRights.forCode('ASSETCLASSABBREVIATION');

    loadProductClass();
});


productClassCtrl.getProductClassListConfig = ["$oasRights", function( $oasRights ) {

    var rightsProductClass = $oasRights.forCode('ASSETCLASSES');
    var c = {
        getUrl: '/Portfolio/ProductClasses',
        deleteUrl: '/Portfolio/ProductClasses/Verbose/',
        listName: 'Asset Classes',
        template: 'products/views/productclass-list-item.html',
        icon: 'fa fa-leaf',
        selectEnabled: false,
        multiSelectEnabled: false,
        nameProperty: 'description',
        sortFields: {name: "Abbreviation", id: "ID", category: "Category", sortOrder1: 'Sort Order 1', sortOrder2: 'Sort Order 2', value: 'Value'},
        listFilter: ['name', 'description'],
        securityCode: 'ASSETCLASSES',
        additionalLinks: []
    };

    if( rightsProductClass.canAdd ) {
        c.additionalLinks.push( {name: "New Asset Class", url: "#/assetclasses/0", icon: "fa fa-pencil", securityCode: "ASSETCLASSES"} );
    }

    if( rightsProductClass.canUpdate ) {
        c.additionalLinks.push( {name: "Assign Colors", url: "", clickEvent: "assignProductClassColors", icon: "fa fa-tint", securityCode: "ASSETCLASSES"} );
    }

    return c;

}];
'use strict';

var productRegionCtrl = app.controller('ProductRegionCtrl', function ProductRegionCtrl($scope, ProductsAndPrices, $http, $location, $dialog, $oasRights, $routeParams) {
    // PRIVATE METHODS
    function init() {
        if ($scope.item.id > 0) {
            ProductsAndPrices.regions.get({params: {id: $scope.item.id}, trim: true}).then(function(item){
                return angular.copy(item, $scope.item);
            });
        }
    }

    // PUBLIC METHODS
    $scope.save = function () {
        return ($scope.item.id > 0
                ? ProductsAndPrices.regions.save({params: {id: $scope.item.id}, data: $scope.item, trim: true})
                : ProductsAndPrices.regions.create({data: $scope.item, trim: true})
        ).then(function(item){
            ProductsAndPrices.goTo.regions();
        });
    };

    $scope.delete = function () {
        return ProductsAndPrices.regions.delete({params: {id: $scope.item.id}, trim: true}).then(function(){
            ProductsAndPrices.goTo.regions();
        });
    };


    // INIT
    $scope.rights = $oasRights.forCode('ASSETCLASSES');

    $scope.item = {
        id: $routeParams.id || 0
    };

    init();
});


productRegionCtrl.getProductRegionListConfig = ["$oasRights", function( $oasRights ) {

    var rightsProductClass = $oasRights.forCode('ASSETCLASSES');
    var c = {
        getUrl: '/Portfolio/Regions/',
        deleteUrl: '/Portfolio/Regions/',
        listName: 'Product Region',
        template: 'products/views/productregion-list-item.html',
        icon: 'fa fa-leaf',
        selectEnabled: false,
        multiSelectEnabled: false,
        nameProperty: 'name',
        sortFields: {id: "ID", name: "Name"},
        listFilter: ['id', 'name'],
        securityCode: 'ASSETCLASSES',
        additionalLinks: []
    };

    if( rightsProductClass.canAdd ) {
        c.additionalLinks.push( {name: "New Region", url: "#/products/regions/0", icon: "fa fa-pencil", securityCode: "ASSETCLASSES"} );
    }

    return c;

}];
'use strict';

var productPropertyTypeCtrl = app.controller('ProductPropertyTypeCtrl', function ProductPropertyTypeCtrl($scope, ProductsAndPrices, $http, $location, $dialog, $oasRights, $routeParams) {
    // PRIVATE METHODS
    function init() {
        if ($scope.item.id > 0) {
            ProductsAndPrices.propertyTypes.get({params: {id: $scope.item.id}, trim: true}).then(function(item){
                return angular.copy(item, $scope.item);
            });
        }
    }

    // PUBLIC METHODS
    $scope.save = function () {
        return ($scope.item.id > 0
                ? ProductsAndPrices.propertyTypes.save({params: {id: $scope.item.id}, data: $scope.item, trim: true})
                : ProductsAndPrices.propertyTypes.create({data: $scope.item, trim: true})
        ).then(function(item){
            ProductsAndPrices.goTo.propertyTypes();
        });
    };

    $scope.delete = function () {
        return ProductsAndPrices.propertyTypes.delete({params: {id: $scope.item.id}, trim: true}).then(function(){
            ProductsAndPrices.goTo.propertyTypes();
        });
    };


    // INIT
    $scope.rights = $oasRights.forCode('ASSETCLASSES');

    $scope.item = {
        id: $routeParams.id || 0
    };

    init();
});


productPropertyTypeCtrl.getProductPropertyTypeListConfig = ["$oasRights", function( $oasRights ) {

    var rightsProductClass = $oasRights.forCode('ASSETCLASSES');
    var c = {
        getUrl: '/Portfolio/PropertyTypes/',
        deleteUrl: '/Portfolio/PropertyTypes/',
        listName: 'Product Property Types',
        template: 'products/views/productpropertytype-list-item.html',
        icon: 'fa fa-leaf',
        selectEnabled: false,
        multiSelectEnabled: false,
        nameProperty: 'name',
        sortFields: {id: "ID", name: "Name"},
        listFilter: ['id', 'name'],
        securityCode: 'ASSETCLASSES',
        additionalLinks: []
    };

    if( rightsProductClass.canAdd ) {
        c.additionalLinks.push( {name: "New Property Type", url: "#/products/propertytypes/0", icon: "fa fa-pencil", securityCode: "ASSETCLASSES"} );
    }

    return c;

}];
'use strict';

var productManagerCtrl = app.controller('ProductManagerCtrl', function ProductManagerCtrl($scope, ProductsAndPrices, $http, $location, $dialog, $oasRights, $routeParams) {
    // PRIVATE METHODS
    function init() {
        if ($scope.item.id > 0) {
            ProductsAndPrices.managers.get({params: {id: $scope.item.id}, trim: true}).then(function(item){
                return angular.copy(item, $scope.item);
            });
        }
    }

    // PUBLIC METHODS
    $scope.save = function () {
        return ($scope.item.id > 0
                ? ProductsAndPrices.managers.save({params: {id: $scope.item.id}, data: $scope.item, trim: true})
                : ProductsAndPrices.managers.create({data: $scope.item, trim: true})
        ).then(function(item){
            ProductsAndPrices.goTo.managers();
        });
    };

    $scope.delete = function () {
        return ProductsAndPrices.managers.delete({params: {id: $scope.item.id}, trim: true}).then(function(){
            ProductsAndPrices.goTo.managers();
        });
    };


    // INIT
    $scope.rights = $oasRights.forCode('ASSETCLASSES');

    $scope.item = {
        id: $routeParams.id || 0
    };

    init();
});


productManagerCtrl.getProductManagerListConfig = ["$oasRights", function( $oasRights ) {

    var rightsProductClass = $oasRights.forCode('ASSETCLASSES');
    var c = {
        getUrl: '/Portfolio/Managers/',
        deleteUrl: '/Portfolio/Managers/',
        listName: 'Product Managers',
        template: 'products/views/productmanager-list-item.html',
        icon: 'fa fa-leaf',
        selectEnabled: false,
        multiSelectEnabled: false,
        nameProperty: 'name',
        sortFields: {id: "ID", name: "Name"},
        listFilter: ['id', 'name'],
        securityCode: 'ASSETCLASSES',
        additionalLinks: []
    };

    if( rightsProductClass.canAdd ) {
        c.additionalLinks.push( {name: "New Product Manager", url: "#/products/managers/0", icon: "fa fa-pencil", securityCode: "ASSETCLASSES"} );
    }

    return c;

}];
'use strict';

app.controller('ProductNameTranslationListCtrl', function ProductNameTranslationListCtrl( $scope, $http, $oasRights, $dialog, $timeout, $location, $window, apps, views, ProductsAndPrices) {

    // PRIVATE VARIABLES

    // PRIVATE METHODS
    $scope.refreshGrid = $scope.$broadcast.bind($scope,'event:product-name-translation-list-action',{action:'refresh-grid'});

    // EVENT LISTENERS
    $scope.$on('event:product-name-translation-list-select', function(e,args){if(args.length) $scope.selectedItems = args;});

    $scope.deselectGrid = function(){
        $scope.$broadcast('event:product-name-translation-list-action',{action:'select-rows', rows: $scope.selectedItems = [] });
    };

    $scope.save = function() {
        return ($scope.selected.id > 0
            ? ProductsAndPrices.nameTranslations.save({trim: true, params: {id: $scope.selected.id}, data: $scope.selected})
            : ProductsAndPrices.nameTranslations.create({trim: true, data: $scope.selected})
        ).then(function(updated){
            $scope.current.item = {};
            $scope.$broadcast( 'event:product-name-translation-list-action', {action: $scope.selected.id > 0 ? 'update-item' : 'add-item', item: updated});
        });
    };

    $scope.delete = function() {
        return ProductsAndPrices.nameTranslations.delete({params: {id: $scope.selected.id}, confirm: true}).then(function(){
            $scope.$broadcast('event:product-name-translation-list-action',{action:'delete-item', item: $scope.selected });
            $scope.deselectGrid();
        });
    };

    // INITIALIZE
    $scope.rights = {
        productNameTranslation: $oasRights.forCode("PRODUCTNAMETRANSLATION")
    };

    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: {get: function() {return $scope.selectedItems.map('id')}},
        selected: {get: function() {return $scope.selectedItems[0] || $scope.current.item;}}
    });



    $scope.views = views;
    $scope.current = {
        item: {},
        view: views[0],
        grid: {
            load: ProductsAndPrices.nameTranslations.getAll,
            param: {
                startDate: Date.create('today').rewind({month: 1}).set({day: 1}),
                endDate: Date.create('today').addMonths(1).endOfDay() //current.endDate.formatted() + ' 23:59:59'
            }
        }
    }

});
'use strict';

app.controller('CorporateActionCtrl', function CorporateActionCtrl($scope, $q, $dialog, dialog, args, apps, $timeout, CorporateAction, $confirmation, Entity) {

    // PRIVATE VARIABLES
    var editorHotKeys;

    // PRIVATE METHODS
    function init() {
        buildMenu();
        loadHotKeys();

        if (args.defaultTab) $scope.loadTab(args.defaultTab);
        loadProcessingTypes().then(() => corporateActionsInit(args))
    }

    function corporateActionsInit(args) {
        return loadCorporateAction(args.corporateAction)
            .then(function () {
                switch (args.action) {
                    case 'processing-add':
                        $scope.addCorporateActionProcess();
                        $scope.loadTab({ name: 'Processes', active: true, code: 'processes' });
                        break;
                    case 'processing-clone':
                        $scope.addCorporateActionProcess(args.selectedProcess);
                        $scope.loadTab({ name: 'Processes', active: true, code: 'processes' });
                        break;
                    case 'processing-tab':
                        $scope.loadTab({ name: 'Processes', active: true, code: 'processes' });
                        break;
                }
            }).catch(function () {
                $dialog.actionFailed("Could not load Corporate Action").open();
            });
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                { combo: 'ALT+S', command: $scope.save },
                { combo: 'ALT+X', command: $scope.close.bind(null, true) }
            ]);
        });
    }

    function buildMenu() {
        var i = 0;
        $scope.menu = { categories: [] };
        $scope.menu.categories.push({ name: 'Corporate Action', children: [] });
        $scope.menu.categories[i].children.push({ name: 'General', active: false, code: 'general' });
        $scope.menu.categories[i].children.push({ name: 'Processes', active: false, code: 'processes' });
    }

    function loadProcessingTypes() {
        return CorporateAction.processingType.getAll({ trim: true }).then(function (processingTypes) {
            $scope.processingTypes = processingTypes;
        });
    }

    // Date.isPast() doesn't really work because it creates the comparison based on the current date and time rather than just the date
    function isPastDate(inputValue) {
        const today = Date.create('today');
        const inputDate = inputValue instanceof Date ? inputValue : Date.create(inputValue);
        if (!inputDate.isValid()) {
            return false;
        }
        return inputDate < today;
    }

    function checkBoDAndSave() {
        const deferred = $q.defer();
        const effDate = $scope.corporateAction.effectiveDate instanceof Date ? $scope.corporateAction.effectiveDate : Date.create($scope.corporateAction.effectiveDate);

        if ($scope.processes.some(function (p) { return p.isBeginningOfDay === true }) && isPastDate(effDate)) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> BOD transactions won't be processed", "Beginning of Day (BOD) corporate action transactions cannot be processed for an earlier effective date.").open().then(function () {
                deferred.resolve(save());
            });
        } else if ($scope.processes.isModified() &&
            $scope.processes.some(function (p) { return p.task === 'Create Transactions'; }) &&
            effDate.isFuture()) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> BOD transaction processing deferred", "This corporate action will not be processed until " + $scope.corporateAction.effectiveDate).open().then(function () {
                deferred.resolve(save());
            });
        } else {
            deferred.resolve(save());
        }
        return deferred.promise;
    }

    function save() {
        const verboseData = { id: $scope.corporateAction.id };
        const processTasks = [];

        if ($scope.corporateAction.isModified()) verboseData['portfolio'] = $scope.corporateAction;
        if ($scope.processes.isModified()) {
            $scope.processes.each(function (p) {

                if (!displayNavPrice(p.corpActionProcessingTypeId)) { p.navPrice = null; } // clear navPrice value for invalid types
                if (p.navPriceDisplay) { delete p.navPriceDisplay; } // clear display property so its not passed back to the API.

                if (p.task) {
                    const task = CorporateAction.taskDetail(p.task);
                    if (task) {
                        const data = {
                            corpActionProcessingId: p.id,
                            corpActionProcessingTaskType: task.value
                        };
                        processTasks.push(data);
                    }
                    delete p.task;
                }
            });
            verboseData['processes'] = $scope.processes;
        }

        if ($scope.transactions.isModified()) verboseData['transactions'] = $scope.transactions;

        return $q.resolve(
            $scope.corporateAction.id != 0
                ? CorporateAction.corporateAction.saveVerbose({
                    trim: true,
                    params: { id: $scope.corporateAction.id },
                    data: verboseData
                }).then(function (response) {
                    const tasks = [response];
                    processTasks.each(function (t) {
                        tasks.push(CorporateAction.processingRecord.processTask({
                            trim: true,
                            params: { id: t.corpActionProcessingId },
                            data: t
                        }));
                    });
                    return $q.all(tasks);
                })
                : CorporateAction.corporateAction.createVerbose({ trim: true, data: verboseData })
        ).then(function (ca) {
            return ca;
        });
    }

    function isModified() {
        return (
            $scope.corporateAction.isModified() ||
            processesIsModified() ||
            $scope.transactions.isModified()
        );
    }

    function processesIsModified() {
        const ignoreList = ['navPriceDisplay', '$$hashKey']
        return $scope.processes
            .flatMap(item => Object.keys(item).filter((key) => item[key] !== item.__original__[key]))
            .any(function (item) { return ignoreList.indexOf(item) < 0; });
    }

    function getProcessTypeNameById(processTypeId) {
        if (processTypeId && $scope.processingTypes) {
            return $scope.processingTypes.find((pt) => pt.id == processTypeId).name
        }
        return null;
    }

    // check if a given process type should be able to set NAVPrice
    function displayNavPrice(processTypeId) {
        const processTypeName = getProcessTypeNameById(processTypeId);
        if (!processTypeName) return false;

        return ['spin off', 'merger', 'cash to boot merger'].includes(processTypeName.toLowerCase());
    };

    // Check if a given process type should be able to set MergeOutRatio
    function displayMOR(processTypeId) {
        const processTypeName = getProcessTypeNameById(processTypeId);
        if (!processTypeName) return false;

        return ['merger', 'cash to boot merger'].includes(processTypeName.toLowerCase());
    }

    function displayNewProductName(processTypeId) {
        const processTypeName = getProcessTypeNameById(processTypeId);
        if (!processTypeName) return false;

        return ['name change'].includes(processTypeName.toLowerCase());
    };

    function displayRoundingType(processTypeId) {
        const processTypeName = getProcessTypeNameById(processTypeId);
        if (!processTypeName) return false;

         return ['merger', 'cash to boot merger', 'spin off', 'stock split', 'reverse split'].includes(processTypeName.toLowerCase());
    }

    function displayNewCusipTicker(processTypeId) {
        const processTypeName = getProcessTypeNameById(processTypeId);
        if (!processTypeName) return false;

        return ['cusip change'].includes(processTypeName.toLowerCase());
    };


    // Accepts corporateActionId or a CorporateAction object.
    function loadCorporateAction(corporateAction) {
        if(corporateAction) var key = corporateAction.id || corporateAction;
        return $q.resolve(
            corporateAction
                ? $q.all({
                        portfolio:
                            angular.isNumber(corporateAction)
                                ? CorporateAction.corporateAction.get({trim: true, params: {id: corporateAction}})
                                : corporateAction,
                        processes: CorporateAction.corporateAction.getProcesses({trim: true, params: {corporateActionId: key}})
                    })
                : CorporateAction.corporateAction.newVerbose({trim: true})
        ).then(function (ca) {
            if(args.productId) ca.portfolio.productId = args.productId;
            $scope.corporateAction = ca.portfolio;
            $scope.disableBoD = disableBoD($scope.corporateAction);
            angular.extend($scope, {
                corporateAction: Entity.item(ca.portfolio, {track: true}),
                processes: Entity.collection(ca.processes || [], {track: true})
            });
            $scope.current.isReady = true;
            $scope.processes.each((process) => { process.navPriceDisplay = process.navPrice });
            return $scope.corporateAction;
        });
    }

    function disableBoD(corpAction) {
        const effDate = corpAction.effectiveDate instanceof Date ? corpAction.effectiveDate : Date.create(corpAction.effectiveDate);
        return isPastDate(effDate);
    }

    $scope.loadTab = function (child) {
        $scope.menu.categories.each(function (c) {
            c.children.each(function (ch) {
                ch.active = ch.code == child.code;
            });
        });
        $scope.current.selectedTab = child.code;
    };


    $scope.goToTransactions = function() {
        return $q.resolve(
            isModified() ? $dialog.confirmNavigation("Do you want to save your changes before navigating?").open() : 'no'
        ).then(function(option){
            switch(option) {
                case 'yes': return checkBoDAndSave().then(function(ca){return ca.id;});
                case 'no': return $scope.corporateAction.id;
                default: return $q.reject();
            }
        }).then($confirmation.goToCorporateActionTransactions).then($scope.close);
    };

    $scope.currentStatus = CorporateAction.statusDetail;
    $scope.showTaskType = showTaskType;

    $scope.addCorporateActionProcess = function (selectedProcess) {
        var process = new Entity(CorporateAction.default.process, {track: true});
        if (selectedProcess)
            angular.copy(
                angular.merge(angular.copy(selectedProcess), {
                    id: CorporateAction.default.process.id,
                    processStatus: CorporateAction.default.process.processStatus
                }),
                process
            );
        $scope.processes.push(process);
    };

    $scope.removeCorporateActionProcess = function (process) {
        return $dialog.confirmAction("Are you sure you want to remove this Corporate Action Process?")
            .open()
            .then(function (result) {
                if (result !== 'yes') return $q.reject();
                $scope.processes.remove(process);
            });
    };

    $scope.processingTypeChange = function (process) {
        process.navPriceDisplay = displayNavPrice(process.corpActionProcessingTypeId) ? process.navPrice : null
    }

    $scope.displayNavPrice = displayNavPrice;
    $scope.displayNewCusipTicker = displayNewCusipTicker;
    $scope.displayNewProductName = displayNewProductName;
    $scope.displayMOR = displayMOR;
    $scope.displayRoundingType = displayRoundingType;

    

    $scope.delete = function( ) {
        return CorporateAction.corporateAction.delete({params: {id: $scope.corporateAction.id}, confirm: true})
            .then(function() {
                return dialog.close('delete');
            });
    };

    $scope.save = function( ) {
        return checkBoDAndSave().then(function (corpAction) {
            editorHotKeys.destroy();
            dialog.close(corpAction);
        });
    };

    $scope.close = function (validate) {
        return $q.resolve(
            validate ? isModified() : false
        ).then(function(prevent){
            if(prevent) return $q.reject();
            editorHotKeys.destroy();
            dialog.close(null);
        }).catch(function(){
            $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true});
        });
    };

    function showTaskType(process, taskType) {
        if (!taskType.isStatusChange) { return false; } //short circut for non isStatusChange marked taskTypes

        let processStatus = CorporateAction.statusDetail(process.processStatus)
        let taskTypes = processStatus.taskTypes;
        let conditionalTypes = processStatus.conditionalTypes;

        if (taskTypes.length > 0 && taskTypes.indexOf(taskType.value) !== -1) { return true; } 

        return conditionalTypes != null && conditionalTypes[taskType.value] != null && conditionalTypes[taskType.value].indexOf(process.corpActionProcessingTypeId) !== -1;
    }

    // INITIALIZE
    $scope.rights = CorporateAction.rights;

    $scope.corporateAction = null;
    $scope.disableBoD = false;
    $scope.processes = [];
    $scope.transactions = [];

    $scope.errors = [];
    $scope.current = {
        selectedTab: null,
        isReady: false,
        processStatus: CorporateAction.processStatus,
        taskType: CorporateAction.taskType,
        roundingType: CorporateAction.roundingType
    };

    init( );
});
'use strict';

app.controller('DividendCtrl', function DividendCtrl( $scope, $http, $oasRights, $dialog, dialog, args ) {

    // PRIVATE VARIABLES


    // PRIVATE METHODS
    function init( ) {
        loadDividend( );
        buildMenu( );
    }

    function buildMenu( ) {
        $scope.menu = { categories: [ ] };
        $scope.menu.categories.push({name: 'Dividend', children: [] });
        $scope.menu.categories[0].children.push({name: 'General', active: false, code: 'general'});
    }

    function loadDividend( ) {
        if( args.dividend ) {
            $scope.dividend = angular.copy( args.dividend );
        } else {
            $scope.dividend = {
                "id": 0,
                "productId": args.productId,
                "dividendTypeId": null,
                "payDate": null,
                "exDate": null,
                "oldSymbol": null,
                "newSymbol": null,
                "oldName": null,
                "newName": null,
                "grossDivRate": null,
                "shortTermRate": null,
                "longTermRate": null,
                "splitFactor": null,
                "shareFactor": null,
                "costFactor": null,
                "cashInLieuPrice": null,
                "cash": null,
                "note": null,
                "netDivRate": null,
                "divFeeRate": null,
                "specialDivRate": null,
                "approvalStatus": null,
                "capitalRate": null,
                "qualifiedRateDollar": null,
                "qualifiedRatePercent": null,
                "declarationDate": null,
                "declarationType": null,
                "currencyCode": null,
                "taxStatusCodeId": null,
                "announcementType": null,
                "frequency": null,
                "recordDate": null,
//                "divOnlyRate": null,
                "fileRecordID": null,
                "indicatedAnnualDividend": null
            };
        }
    }

    $scope.delete = function( ) {
        $dialog.confirmAction( "Are you sure you want to remove the dividend?" )
            .open()
            .then( function( result ) {
                if( result == 'yes' ) {
                    $http.delete('/Global/Dividends/' + $scope.dividend.id, {trackerMsg: 'Deleting dividend ' + $scope.dividend.id})
                        .then(function () {
                            dialog.close(true);
                        });
                }
            } );
    };

    $scope.save = function( ) {

        var args = $scope.dividend.id > 0 ? {method: "PUT", id: $scope.dividend.id, trackerMsg: "Saving dividend " + $scope.dividend.id} : {method: "POST", id: "", trackerMsg: "Adding new dividend"};

        $http( { method: args.method, url: '/Global/Dividends/' + args.id, data: $scope.dividend, trackerMsg: args.trackerMsg } )
            .then(function( ) {
                dialog.close(true);
            });
    };

    $scope.close = function( ) {
        dialog.close(false);
    };


    // INITIALIZE
    $scope.rightsDividends = $oasRights.forCode("DIVIDENDS");
    $scope.dividend = null;

    init( );
});
'use strict';

app.controller('PriceFactorCtrl', function PriceFactorCtrl( $scope, $http, $oasRights, $dialog, dialog, args ) {

    // PRIVATE VARIABLES


    // PRIVATE METHODS
    function init( ) {
        loadPriceFactor( );
        buildMenu( );
    }

    function buildMenu( ) {
        $scope.menu = { categories: [ ] };
        $scope.menu.categories.push({name: 'Price Factor', children: [] });
        $scope.menu.categories[0].children.push({name: 'General', active: false, code: 'general'});
    }

    function loadPriceFactor( ) {
        if( args.priceFactor ) {
            $scope.priceFactor = angular.copy( args.priceFactor );
            $scope.priceFactor.id = 1; //isNewFlag
        } else {
            $scope.priceFactor = {
                id:0,
                productId: args.productId,
                factorDate: null,
                factor: null
            };
        }
    }

    $scope.delete = function( ) {
        $dialog.confirmAction( "Are you sure you want to remove the price factor?" )
            .open()
            .then( function( result ) {
                if( result == 'yes' ) {
                    $http.delete('/Global/Products/PriceFactors/' + args.productId + '/' + $scope.priceFactor.factorDate, {trackerMsg: 'Deleting price factor ' + $scope.priceFactor.factorDate})
                        .then(function () {
                            dialog.close(true);
                        });
                }
            } );
    };

    $scope.save = function( ) {
        if( $scope.priceFactor.id > 0 ) {
            $http( { method: 'PUT', url: '/Global/Products/PriceFactors/' + args.productId +'/' + $scope.priceFactor.factorDate, data: $scope.priceFactor, trackerMsg: "Saving price factor " + $scope.priceFactor.factorDate } )
                .then(function( ) {
                    dialog.close(true);
                });
        } else {
            $http( { method: 'POST', url: '/Global/Products/PriceFactors', data: $scope.priceFactor, trackerMsg: "Adding new price factor " + $scope.priceFactor.factorDate } )
                .then(function( ) {
                    dialog.close(true);
                });
        }
    };

    $scope.close = function( ) {
        dialog.close(false);
    };


    // INITIALIZE
    $scope.rightsPriceFactors = $oasRights.forCode("PRICEFACTORS");
    $scope.priceFactor = null;

    init( );
});
'use strict';

app.controller('ProductProviderAssignmentsCtrl', function ProductProviderAssignmentsCtrl( $scope, $http, $oasRights, entities, $dialog ) {

    // PRIVATE METHODS
    function init( ) {
        $http.get('/Portfolio/ProductDescriptionProvider/Assignments', {trackerMsg: 'Loading assignments'})
            .then(function (response) {
                $scope.assignments = response.data;
            });
    }


    // PUBLIC METHODS
    $scope.save = function( ) {
        $http.put("/Portfolio/ProductDescriptionProvider/Assignments", $scope.assignments, {trackerMsg: 'Saving assignments'})
            .then(function () {
                $dialog.saveSuccessful( "Assignment information saved.").open();
            });
    };

    $scope.runAutoAssignments = function () {
        $dialog.confirmAction("Are you sure you want to run auto assignments?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.post("/Portfolio/ProductDescriptionProvider/Assignments/RunAutoAssignments", null, { trackerMsg: 'Running Auto Assignments' })
                        .then(function () {
                            $dialog.messageBox("Auto Assignments", "Run Auto Assignments Successful.").open();
                    });
                }
            });
    };

    $scope.addProvider = function( parentArray ) {
        $http.get(entities.productDescriptionProvider.simpleUrl, {cache: true, trackerMsg: 'Loading product description providers'})
            .then(function (response) {
                $dialog.inputBox("Add Provider", "Description Provider", response.data)
                    .open()
                    .then(function(result) {
                        if (result && parentArray.none({id: result.id})) {
                            parentArray.push(result);
                        }
                    }
                );
            });
    };

    $scope.removeProvider = function( parentArray, objToRemove ) {
        parentArray.remove(objToRemove);
    };


    // INITIALIZE
    $scope.rightsPDM = $oasRights.forCode('PRODDESCMAIN');
    $scope.rightsACAAR = $oasRights.forCode('ASSETCLASSAUTOASSIGNRUN');

    init( );
});
(function(){
    'use strict';
    angular.module('orionConnect')
        .controller('autoAssignmentsCtrl',['$scope', '$q', '$location', '$route', '$http', '$dialog', 'views', 'assetList', 'overrides', 'settings',CTRL]);
    function CTRL($scope, $q, $location, $route, $http, $dialog, views, assetList, overrides, settings){
        $scope.overrides = angular.copy(overrides);
        $scope.title = settings.title;
        $scope.views = views;
        $scope.ready = false;
        $scope.selectedIds = [];
        $scope.gridData =$q.when({});
        $scope.current = {
            providerAssigned:false,
            selected:{},
            selectedIds:[],
            view: setColumnOptions(views[0]),
            grid: {
                test:{
                    data:'testdata'
                },
                load(){
                    let temp = angular.copy($scope.overrides);
                    temp.forEach(function(row){
                        if(row[settings.id] === null) return;
                        row[settings.id] = assetList.find({id:row[settings.id]});
                    });
                    return $q.when(temp);
                },
                update(info) {
                    return $q.when(info);
                }
            }
        };
        $scope.controls = {
            refreshGrid : refreshGrid,
            save : save,
            goto : goto,
            filterAssigned : filterAssigned,
            editMultiple : editMultiple,
            resetSelected : resetSelected
        };

        //INIT
        (function(){
            
            refreshGrid();
            filterAssigned(true);
        })();

        function resetSelected(){
            let assetType = $scope.current.view.assetType;
            $scope.current.selected.forEach(function(item){
                item[assetType] = {id:null, name:''};
            });
            upsertItems($scope.current.selected);
        }

        function editMultiple(){
            $dialog.dialog({
                template:template,
                controller: ['$scope', 'dialog', 'numberOfFields', 'type', dialogCtrl],
                resolve:{
                    numberOfFields(){ return $scope.selectedIds.count(); },
                    type(){return $scope.title;}
                }
            }).open()
                .then(function(res){
                    if(res.edited){
                        let assetType = $scope.current.view.assetType,
                            assetTypeCap = assetType.charAt(0).toUpperCase() + assetType.slice(1),
                            assets = ($scope.current.view.slickGridColumnDefs.find({id:assetTypeCap})).assetList
                        ;
                        $scope.current.selected.forEach(function(item){
                            item[assetType] = (res.id===undefined || res.id===null || res.id==='')?{id:null, name:''}:assets.find({id:res.id});
                        });
                        upsertItems($scope.current.selected);
                    }
                });
            function template(){
                return "" +
                    "<div class='modal-header'>" +
                    "   <h3><i class='fa fa-fw fa-pencil-square-o' aria-hidden='true'></i> Edit {{type}} ({{numberOfFields}} Selected)</h3>" +
                    "</div>" +
                    "<div class='modal-body'>" +
                    "   <div class='form-inline'>" +
                    "       <div class='row-fluid'>" +
                    "           <div class='span12'>" +
                    "               <div class='contorol-group'>" +
                    "                   <div class='controls'>" +
                    "                       <label>" +
                    "                           <span title='class'>{{type}}</span>" +
                    "                       </label>" +
                    "                       <oas-drop-down selected='selected.class' required id-field='autoassignmentassetclassid' ng-if='type===\"Product Class\"'></oas-drop-down>" +
                    "                       <oas-drop-down selected='selected.class' required id-field='autoassignmentriskcategoryid' ng-if='type===\"Risk Category\"'></oas-drop-down>" +
                    "                   </div>" +
                    "               </div>" +
                    "           </div>" +
                    "       </div>" +
                    "   </div> " +
                    "</div>" +
                    "<div class='modal-footer'>\n" +
                    "    <button class='btn btn-primary' ng-click='close(true)'>OK</button>" +
                    "    <button class='btn' ng-click='close(false)'>Cancel</button>" +
                    "</div>";
            }
            function dialogCtrl($scope, dialog, numberOfFields, type){
                $scope.close = close;
                $scope.numberOfFields = numberOfFields;
                $scope.type = type;
                $scope.selected = {
                    class : null
                };
                function close(ret){
                    dialog.close( {edited:ret, id:$scope.selected.class} );
                }
            }
        }
        function goto(route){
            $location.url(route);
        }
        function save(){
            getData();
            $scope.gridData.then(function(data){
                let diff,
                    url
                ;
                diff = calcDiff($scope.overrides, angular.copy(data));
                let endPoint = {
                    productClassId(){
                        url = '/Portfolio/ProductClassAutoAssignOverride';
                    },
                    riskCategoryId(){
                        url = '/Portfolio/RiskCategoryAutoAssignOverride';
                    }
                };
                (typeof endPoint[settings.id] === 'function')?endPoint[settings.id]():null;

                if(url && diff.length>0){
                    $http.post(url,diff,{trackerMsg:'Saving Changes'})
                        .then(function(res){
                            if(res.status === 200){
                                $route.reload();
                            }
                        });
                }

            });
        }
        function calcDiff(obj1, obj2){
            let diff = [];
            obj2.forEach(function(item, index){
                if(item[settings.id] !== null && item[settings.id] !== undefined){
                    let referenceObj = obj1.find({productDescriptionProviderId: item.productDescriptionProviderId, providerName: item.providerName, abbreviation: item.abbreviation});
                    if(item[settings.id].id !== referenceObj[settings.id]){
                        let temp = angular.copy(item);
                        temp[settings.id] = item[settings.id].id;
                        diff.push(temp);
                    }
                }
            });
            return diff;
        }
        function setColumnOptions(view){
            view.slickGridColumnDefs.forEach(function(col){
                let colCase = {
                    ProductClassId(){
                        col.assetList = assetList;
                        view.assetType = 'productClassId';
                    },
                    RiskCategoryId(){
                        col.assetList = assetList;
                        view.assetType = 'riskCategoryId';

                    }
                };
                (typeof colCase[col.id] === 'function')?colCase[col.id]():null;
            });
            return view;
        }
        function filterAssigned(assigned) {
            if(!$scope.views[0].filters) {$scope.views[0].filters = [];}
            if(!$scope.views[0].filters.find({key: "providerAssigned"})){
                $scope.views[0].filters.push({
                    include: true,
                    key: "providerAssigned",
                    name: "ProviderAssigned is true",
                    value: "(function (a) { return angular.isString(a) ? a.toLowerCase() === 'true' : a === true; })"
                });
                $scope.$watch('views[0].filters',function(newVal, oldVal, scope){
                    if(newVal.length === 0){
                        $scope.current.providerAssigned = false;
                    }else{
                        filterAssigned(newVal[0].include);
                    }

                },true);
            }
            $scope.current.providerAssigned = assigned;
            $scope.views[0].filters.find({key: "providerAssigned"}).include = assigned;
        }

        //Event Triggers
        function refreshGrid() {
            $scope.$broadcast('event:auto-assignment-action', {action: 'refresh-grid'});
        }
        function getData() {
            $scope.$broadcast('event:auto-assignment-action', {action: 'get-items'});
        }
        function upsertItems(items) {
            if (items) $scope.$broadcast('event:auto-assignment-action', {action: 'upsert-items', items: items});
        }
        //Event Listeners
        $scope.$on('slickgrid-getitems', function (event, data) {
            $scope.gridData = $q.when(data);
        });
        $scope.$on('event:auto-assignment-select', function (e, data) {
            $scope.current.selected = data;
        });
    }
})();

'use strict';

app.controller('TaxExemptionsListCtrl', function TaxExemptionsListCtrl( $scope, $http, $location, $oasRights, views ) {

    // PUBLIC METHODS
    $scope.addExemption = function( ) {
        var exemption = {
            addressStateId: $scope.current.addressStateId,
            issueStateId: $scope.current.issueStateId,
            taxable: $scope.current.taxable
        };

        $http.put('/Global/StatesMunicipalBondTax/' + $scope.current.addressStateId + '/' + $scope.current.issueStateId, exemption, { trackerMsg: 'Adding exemption' } )
            .then( function ( ) {
                $scope.$broadcast('event:tax-exemptions-action', {action: 'refresh-grid'});
                $scope.current.addressStateId = null;
                $scope.current.issueStateId = null;
                $scope.current.taxable = false;
            });
    };

    // INITIALIZATION
    $scope.rightsTaxExemptions = $oasRights.forCode('TAXEXEMPTIONS');

    $scope.views = views;
    $scope.current = { view: views[0], addressStateId: null, issueStateId: null, taxable: false };
    $scope.selectedIds = [];

});
'use strict';

var productExclusionsCtrl = app.controller('ProductExclusionsCtrl', function ProductExclusionsCtrl($scope, $http, $location, $dialog, $oasRights, $routeParams, listSectionData) {

    var dataItemsEvent = "event: data-items";
    var dataItemDeleteEvent = "event: data-item-delete";
    var addProductEvent = "event: add-product";

    $scope.productExclusionListConfig = {
        listName: 'Product Exclusions',
        template: 'productExclusionList.html',
        headerTemplate: 'productExclusionList-header.html',
        icon: 'fa fa-users',
        selectEnabled: false,
        fieldToSort: 'productName',
        addItemEvent: addProductEvent,
        loadDataItemsEvent: dataItemsEvent,
        deleteItemEvent: dataItemDeleteEvent,
        multiSelectEnabled: false,
        nameProperty: 'name',
        takeInterval: 50000,
        itemsPerPage: 10,
        showLink:true,
        sortFields: {productName: "Product Name", productId: "Product Id", ticker:'Ticker' },
        listFilter: ['productName', 'productId', 'isException', 'ticker'],
        additionalLinks: []
    };

    //Watches
    $scope.$on("item-action", function(e, args){
        if(args.action === 'edit-product-exception'){
            openExceptionEditor(args.item);
        }
        if(args.action === 'delete-product-exception'){
            removeProductExclusion(args.item);
        }
    });

    //Public
    $scope.productExclusionListOptions = {showExceptionColumn:true};

    $scope.saveProductExclusion = function(){

        $http.post('/Portfolio/Products/Exclusions/EnMasse', $scope.enMasseObject,{trackerMsg: 'Saving changes to product exclusion'})
            .then(function () {
                $scope.enMasseObject.create = [];
                $scope.enMasseObject.update = [];
                $scope.enMasseObject.delete = [];
                getProductExclusionsByEntity();
            });
    };

    $scope.addProduct = function() {
        var allocationInList = false;

        var allocation = {
            productId: $scope.current.selectedAllocation.productId,
            productName: $scope.current.selectedAllocation.productName ,
            ticker: $scope.current.selectedAllocation.ticker,
            exceptions: []
        };

        listSectionData.dataItems.forEach(function(item){
            if(item.productId == allocation.productId ){
                allocationInList = true;
            }
        });

        if(allocationInList){
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Product Exclusion Error ", "<b>" + allocation.productName + "</b>" + " is already an excluded product").open();
        }else{
            $scope.$broadcast(addProductEvent, allocation);
            //add one more property before push to enMasse object
            allocation.entity = $scope.current.selectedEntity.name;
            if($scope.current.selectedId){
                allocation.parentId = $scope.current.selectedId;
            }
            $scope.enMasseObject.create.push(allocation);
        }
        $scope.current.selectedAllocation = null;

    };

    $scope.reloadForEntityChange = function(skipLoad){
        listSectionData.dataItems = [];
        $scope.$broadcast(dataItemsEvent);

        $scope.productExclusionListOptions.showExceptionColumn = !$scope.current.selectedId;

        loadEntities(skipLoad);
    };

    //Private Methods
    function removeProductExclusion(item){
        //find index of product in list
        var idx = $scope.productExclusions.findIndex({id:item.id});

        //remove if in create
        $scope.enMasseObject.create.remove(item);

        //remove if in update
        $scope.enMasseObject.update.remove(item);

        //add parent id if selectedId !=null
        if($scope.current.selectedId){
            item.parentId = $scope.current.selectedId;
        }

        $scope.enMasseObject.delete.push($scope.productExclusions.find({id:item.id}));

        $scope.productExclusions.splice( idx, 1 );
        $scope.$broadcast(dataItemsEvent);
    }

    function openExceptionEditor(item){
        var dialogOpts = {
            templateUrl: 'product-exclusion-edit.html',
            controller: 'ProductExclusionEditCtrl',
            data: item,
            entityList: $scope.entityList
        };

        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function(rslt){
                if (rslt){
                    //check to see if entity object is in update [] || create []
                    if($scope.enMasseObject.create.none({id: rslt.id})){
                        if ($scope.enMasseObject.update.none({id: rslt.id})){
                            $scope.enMasseObject.update.push(rslt);
                        }
                    }else{
                        $scope.enMasseObject.create.find({id: rslt.id}).exceptions = rslt.exceptions;
                    }
                }
            });
    }

    function getProductExclusionsByEntity(){
        var entityId = 0;
        var parentId = $scope.current.selectedId > 0 ? $scope.current.selectedId : null;
        switch ($scope.current.selectedEntity.name){
            case "Custodian":
                entityId = 18;
                break;
            case "Representative":
                entityId = 4;
                break;
            case 'Sub-Advisor':
                entityId = 52;
                break;
            case 'Qualified Plan':
                entityId = 58;
                break;
            case 'Registration Type':
                entityId = 94;
                break;
        }

        var url = parentId ? '/Portfolio/Products/Exclusions?entity=' + entityId + '&parentId=' + parentId :'/Portfolio/Products/Exclusions?entity=' + entityId;

         if(entityId > 0){
             $http.get(url,{trackerMsg: 'Loading product exclusions for ' + $scope.current.selectedEntity.name})
                 .then(function(response){
                     listSectionData.dataItems = response.data;
                     $scope.productExclusions = listSectionData.dataItems;
                     $scope.$broadcast(dataItemsEvent);
                 })
         }

    }

    function loadEntities(skipLoad){
        $scope.enMasseObject.create = [];
        $scope.enMasseObject.update = [];
        $scope.enMasseObject.delete = [];
        if(skipLoad){
            var url ='';
            switch ($scope.current.selectedEntity.name){
                case "Custodian":
                    url = '/Portfolio/Custodians/Simple';
                    break;
                case "Representative":
                    url = '/Portfolio/Representatives/Simple';
                    break;
                case 'Sub-Advisor':
                    url = '/Portfolio/SubAdvisors/Simple';
                    break;
                case 'Qualified Plan':
                    url = '/Portfolio/Plans/Simple';
                    break;
                case 'Registration Type':
                    url = '/Portfolio/Registrations/Types';
                    break;
            }
            $http.get(url, {trackerMsg:'Loading list for entities'})
                .then(function(response){
                    $scope.entityList = response.data;

                    getProductExclusionsByEntity()
                })
        }else{
            getProductExclusionsByEntity();
        }
    }

    function initialize(){
        $scope.availableEntities = [{name: 'Custodian'}, {name:'Representative'}, {name:'Sub-Advisor'},{name:'Qualified Plan'},{name:'Registration Type'}];
        $scope.current.selectedEntity = $scope.availableEntities.find({name:'Representative'});

        loadEntities( $scope.current.selectedEntity);
        listSectionData.dataItems = [];

    }

    // INITIALIZATION
    $scope.rightsProductExclusions = $oasRights.forCode('PRODENTITYEXCLUDE');

    $scope.current = {selectedEntity: 'Representative',selectedExcludedFor:'All',showFilterPane:false, showExceptionColumn:false, selectedId:null };
    $scope.selectedIds = [];

    $scope.productExclusions=[];


    $scope.enMasseObject = {create:[], update:[], delete:[]};
    initialize();
});


app.controller('ProductExclusionEditCtrl', function ProductExclusionAddCtrl($scope, $http, $dialog, $oasRights, dialog){

    function initialize(){
        $scope.current.entityList = dialog.options.entityList;
        $scope.current.entity = dialog.options.data;
        $scope.current.productName = dialog.options.data.productName;
        $scope.invalidEntities = [];
        $scope.exceptions = dialog.options.data.exceptions.map(function(id){
            var optionEntity = dialog.options.entityList.find({id: id});
            if(optionEntity) {
                return optionEntity;
            }
            else {
                $scope.invalidEntities.push(id);
            }
        }).filter(function (el) { return el && el.id > 0; });

        if($scope.invalidEntities.length > 0) {
            $dialog.messageBox("<i class='fa fa-lg text-info' aria-hidden='true'></i> Product Exclusion Information ", "Entity id(s) <b>(" + $scope.invalidEntities.toString() + ")</b>" + " are no longer valid. They are removed from exceptions list.").open();
        }
    }

    $scope.removeException = function(item){
        var idx = $scope.exceptions.findIndex({id: item.id});
        if(idx > -1){
            $scope.exceptions.splice(idx, 1);
        }
    };

    $scope.addEntityToException = function(){
        $scope.exceptions.push($scope.current.selectedEntity);
    };

    $scope.saveExceptionList = function(){
        $scope.current.entity.exceptions =$scope.exceptions.map('id');
        dialog.close( $scope.current.entity);
    };

    $scope.close = function(){
        $scope.current.entity.exceptions =$scope.exceptions.map('id');
        dialog.close( $scope.current.entity);
    };

    $scope.rights = $oasRights.forCode("PRODENTITYEXCLUDE");
    $scope.exceptions = [];
    $scope.current = {entityList:null,selectedEntity:null,entity:null, productName:'', selectedExcludedFor:null};

    initialize();
});

'use strict';

app.controller('ProductQueryExportCtrl', function ProductQueryExportCtrl($scope, $http, $oasRights, $routeParams, $dataQuery, $window, apps) {

    // PUBLIC METHODS
    $scope.download = function (dataType) {
        $dataQuery.createFile(dataType, downloadFile);
    };

    $scope.setPageItems = function (page) {
        page = page || $scope.current.page;
        var begin = (page - 1) * $scope.current.itemsPerPage;
        var end = begin + $scope.current.itemsPerPage;
        $scope.current.queryResults = $dataQuery.getResults(begin, end);
    };

    $scope.filterColumn = function (columnName) {
        $dataQuery.applyFilter(columnName, $scope.current.dataFilter[columnName]);
        $scope.current.totalItems = $dataQuery.getResults().length;
        $scope.setPageItems();
    };

    $scope.goBack = function () {
        window.history.back();
    };


    // PRIVATE METHODS
    function init() {
        var queryId = $routeParams.queryId;
        $dataQuery.loadQuery(queryId, prepareQuery);
    }

    function prepareQuery() {
        $scope.current.dataQuery = $dataQuery.getDataQuery($routeParams.queryId);
        refreshGrid();
    }

    function refreshGrid() {
        $scope.current.isLoading = true;
        $dataQuery.setDataQuery($scope.current.dataQuery);
        $dataQuery.loadResults(formatTable);
    }

    function formatTable() {
        $scope.current.totalItems = $dataQuery.getResults().length;
        $scope.current.columnData = $dataQuery.getColumnNames();
        $scope.current.dataFilter = $dataQuery.getProperties();
        $scope.setPageItems();
        $scope.current.isLoading = false;
    }

    function downloadFile(url) {
        $window.location.href = url + "?Authorization=" + sessionStorage.oas_token;
    }


    // INITIALIZE
    $scope.current = {
        page: 1, pageSizes: [10,50,100], itemsPerPage: 100, totalItems: 0, numPages: 0,
        dataQuery: {}, queryResults: null, showFilter: false, dataFilter: {}, isLoading: true, columnData: null
    };

    if ($routeParams.source) {
        var key = apps.find({code: $routeParams.source});
        $scope.middleBreadcrumb = key ? apps[key].name : null;
    }

    init();
});
app.directive('priceWarnings', function priceWarnings( $http ){
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'products/directives/price-warnings.html',
        scope: {productLocal: '=', productGlobal: '='},
        link: function(scope) {

            scope.current = { localPriceCutOverDate: null };

            $http.get("/Settings/Database/EntityOptions/Code/69PRICECUT", {cache: true, trackerMsg: 'Local price cut-over date'})
               .then(function (response) {
                   if (new Date(response.data.value).isValid()){
                       scope.current.localPriceCutOverDate = Date.create(response.data.value).formatted();
                   }

               });

        }
    };

});

'use strict';

app.directive('productWeighting', function productWeighting( ){
    return {
        restrict: 'E',
        templateUrl: 'products/directives/product-weighting.html',
        scope: {},
        bindToController: {weightings: '=group', weightingsTotal: '=total'},
        controllerAs: 'vm',
        controller: function($scope, $element, $attrs, $oasRights, $dialog) {
            var vm = this;
            vm.type = ({
                class:          { name: 'Asset Class', nameProperty: 'className', idProperty: 'productClassId', idField: 'assetClassId', rightsCode: 'ASSETCLASSES' },
                category:       { name: 'Asset Category', nameProperty: 'categoryName', idProperty: 'productCategoryId', idField: 'productCategoryId', rightsCode: 'PRODUCTCATEGORY'  },
                propertyType:   { name: 'Property Type', nameProperty: 'propertyTypeName', idProperty: 'propertyTypeId', idField: 'propertyTypeId', rightsCode: 'PRODUCTS' },
                region:         { name: 'Product Region', nameProperty: 'regionName', idProperty: 'regionId', idField: 'regionId', rightsCode: 'PRODUCTS' }
            })[$attrs.type];
            vm.rights = $oasRights.forCode(vm.type.rightsCode);

            vm.addWeighting = addWeighting;
            vm.removeWeighting = removeWeighting;
            vm.calculateWeightingTotal = calculateWeightingTotal;

            $scope.$watch('vm.weightings.details', function (details) {
                if (!details) return;
                details.forEach(function (detail) {
                    Object.defineProperties(detail, {
                        name: {
                            get: function () { return detail[vm.type.nameProperty]; },
                            set: function (value) { return detail[scope.type.nameProperty] = value; },
                            configurable: true
                        },
                        id: {
                            get: function () { return detail[vm.type.idProperty]; },
                            set: function (value) { return detail[vm.type.idProperty] = value; },
                            configurable: true
                        }
                    })
                });
                vm.calculateWeightingTotal();
            }, true);

            function addWeighting() {
                var weighting = {weight: 0};
                weighting[vm.type.nameProperty] = "";
                vm.weightings.details.push(weighting);
            }

            function removeWeighting(weightings) {
                return $dialog.confirmAction("Are you sure you want to remove the <b> " + weightings.name + "</b> weightings?")
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            vm.weightings.details.remove(weightings);
                        }
                    });
            }

            function calculateWeightingTotal() {
                if (vm.weightings && vm.weightings.details) {
                    let weightingsTotal = 0;
                    for (var i = 0; i < vm.weightings.details.length; i++) {
                        if (vm.weightings.details[i].weight) {
                            let weight = parseFloat(parseFloat(vm.weightings.details[i].weight).toFixed(6));
                            vm.weightings.details[i].weight = weight;
                            weightingsTotal += weight;
                        }
                    }
                    vm.weightingsTotal = weightingsTotal.round(6);
                }
            }
        },
        link: function (scope, elem, attr, vm) {

        }
    };

});

'use strict';

app.factory('ProductsAndPrices', function ProductsAndPrices($http, $q, $oasRights, $location, $dialog, $settings, entities, Repo) {
    var service = this;

    // PRIVATE VARIABLES
    var endpoints = {
        regions: {
            getAll: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/Regions',
                verb: 'GET',
                message: 'Loading Product Regions'
            }),
            get: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/Regions/{id:int}',
                verb: 'GET',
                message: 'Loading Product Region'
            }),
            save: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/Regions/{id:int}',
                verb: 'PUT',
                message: 'Saving Product Region'
            }),
            delete: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/Regions/{id:int}',
                verb: 'DELETE',
                message: 'Deleting Product Region'
            }),
            create: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/Regions',
                verb: 'POST',
                message: 'Saving Product Region'
            })
        },
        propertyTypes: {
            getAll: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/PropertyTypes',
                verb: 'GET',
                message: 'Loading Product Property Type'
            }),
            get: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/PropertyTypes/{id:int}',
                verb: 'GET',
                message: 'Loading Product Property Type'
            }),
            save: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/PropertyTypes/{id:int}',
                verb: 'PUT',
                message: 'Saving Product Property Type'
            }),
            delete: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/PropertyTypes/{id:int}',
                verb: 'DELETE',
                message: 'Deleting Product Property Type'
            }),
            create: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/PropertyTypes',
                verb: 'POST',
                message: 'Saving Product Property Type'
            })
        },
        managers: {
            getAll: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/Managers',
                verb: 'GET',
                message: 'Loading Product Managers'
            }),
            getAllSimple: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/Managers/Simple',
                verb: 'GET',
                message: 'Loading Product Managers'
            }),
            get: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/Managers/{id:int}',
                verb: 'GET',
                message: 'Loading Product Manager'
            }),
            save: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/Managers/{id:int}',
                verb: 'PUT',
                message: 'Saving Product Manager'
            }),
            delete: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/Managers/{id:int}',
                verb: 'DELETE',
                message: 'Deleting Product Manager'
            }),
            create: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/Managers',
                verb: 'POST',
                message: 'Saving Product Manager'
            })
        },
        weightings: {
            regions: {
                save: Repo.endpoint({
                    path: '/Portfolio/Regions/Weighted/{id:int}',
                    verb: 'PUT',
                    message: 'Saving Region Weightings'
                }),
                create: Repo.endpoint({
                    path: '/Portfolio/Regions/Weighted',
                    verb: 'POST',
                    message: 'Saving Region Weightings'
                })
            },
            propertyTypes: {
                save: Repo.endpoint({
                    path: '/Portfolio/PropertyTypes/Weighted/{id:int}',
                    verb: 'PUT',
                    message: 'Saving Property Types Weightings'
                }),
                create: Repo.endpoint({
                    path: '/Portfolio/PropertyTypes/Weighted',
                    verb: 'POST',
                    message: 'Saving Property Types Weightings'
                })
            }
        },
        alternativeReturns: {
            getAll: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Confirm/Alternative/ExpectedReturn',
                verb: 'GET',
                message: 'Loading Product Alternative Returns'
            }),
            get: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Confirm/Alternative/ExpectedReturn{id:int}',
                verb: 'GET',
                message: 'Loading Product Alternative Return'
            }),
            getAllProduct: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Confirm/Alternative/ExpectedReturn/Products/{id:int}',
                verb: 'GET',
                message: 'Loading Product Alternative Returns'
            })
        },
        nameTranslations: {
            getAll: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/Products/NameMappingDST',
                verb: 'GET',
                message: 'Loading Product Name Translations'
            }),
            save: Repo.endpoint({
                path: '/Portfolio/Products/NameMappingDST/{id:int}',
                verb: 'PUT',
                message: 'Saving Product Name Translation'
            }),
            create: Repo.endpoint({
                path: '/Portfolio/Products/NameMappingDST',
                verb: 'POST',
                message: 'Saving Product Name Translation'
            }),
            delete: Repo.endpoint({
                /***
                 * @return  SimpleEntity[]
                 */
                path: '/Portfolio/Products/NameMappingDST/{id:int}',
                verb: 'DELETE',
                message: 'Deleting Product Name Translation'
            })
        }
    };

    var rights = {
        //confirmationOverview: $oasRights.forCode("CONFIRMOVERVIEW"),
    };

    var defaults = {
    };
    // PRIVATE METHODS

    // PUBLIC VARIABLES
    service.rights = rights;
    service.default = defaults;

    // PUBLIC ENDPOINTS
    service.regions = endpoints.regions;
    service.propertyTypes = endpoints.propertyTypes;
    service.managers = endpoints.managers;
    service.weightings = endpoints.weightings;
    service.alternativeReturns = endpoints.alternativeReturns;
    service.nameTranslations = endpoints.nameTranslations;

    // PUBLIC METHODS
    service.goTo = function(route) {
        if (route) $location.url(route);
        else return this;
    };

    angular.extend(service.goTo, {
        regions: function(item) {
            var id = item && item.id ? item.id : item;
            service.goTo("/products/regions" + (angular.isNumber(id) ? "/{1}".assign(id) : ''));
        },
        propertyTypes: function(item) {
            var id = item && item.id ? item.id : item;
            service.goTo("/products/propertytypes" + (angular.isNumber(id) ? "/{1}".assign(id) : ''));
        },
        managers: function(item) {
            var id = item && item.id ? item.id : item;
            service.goTo("/products/managers" + (angular.isNumber(id) ? "/{1}".assign(id) : ''));
        }
    });

    service.openEditor = function( template, controller, options ) {
        options = angular.merge({
            defaultTab: {name: 'General', code: 'general'}
        }, options);
        return $dialog.editor(template, controller, {
            args: function() {return options}
        }).open();
    };

    service.openDialog = function(options) {
        options = angular.merge({dialogClass: "modal", templateUrl: null, controller: null}, options);
        return $dialog.dialog(options).open()
            .then(function (result) {
                    if( result ) return result;
                    else return $q.reject(result);
                }
            );
    };

    service.dialog = {
        // EXAMPLE
        /*newDefinition: function(options) {
            return service.openDialog(angular.merge({templateUrl: 'tools/processdashboard/modals/CreateProcessDefinition.html', controller: 'CreateProcessCtrl'}, options))
        },*/
    };

    service.editor = {
        // EXAMPLE
        /*type: function( options ) {
            return service.openEditor('tools/processdashboard/modals/ProcessTypeEditor.html', 'ProcessTypeCtrl', options)
        }*/
    };

    return service;
});
(function(){
    'use strict';
    angular
        .module('orionConnect')
        .controller('productCombineCtrl', ['$scope', '$dialog', '$timeout', '$window', 'productCombineService', CTRL]);

    function CTRL($scope, $dialog, $timeout, $window, productCombineService){
        $scope.title = 'Product Combine Page';
        $scope.rightPaneState='uploadFile';
        $scope.search={};
        $scope.current={
            data:{},
            selectedProduct:"",
            useSecondaryPrice:0,
            unmatchedPrice:'',
            selections:{
                productType: {objName: 'productType', name: 'Product Type',options: []},
                productName: {objName: 'productName', name: 'Product Name',options: []},
                ticker: {objName: 'ticker', name: 'Ticker',options: []},
                productParentName: {objName: 'productParentName', name: 'Parent Product',options: []},
                micropalCode: {objName: 'micropalCode', name: 'Micropal Code',options: []},
                globalFundFamilyName: {objName: 'globalFundFamilyName', name: 'Fund Family',options: []},
                includeByDefault: {objName: 'includeByDefault', name: 'Include By Default',options: [{name:'True',value:true},{name:'False',value:false}]}, //does not exist in verbose
                productSubTypeName:{objName: 'productSubTypeName', name: 'Product Sub Type',options: []},
                cusip:{objName: 'cusip', name: 'Cusip',options: []},
                shareClassName:{objName: 'shareClassName', name: 'Share Class',options: []},
                apcCode:{objName: 'apcCode', name: 'APC Code',options: []},
                fundNumber:{objName: 'fundNumber', name: 'Fund Number',options: []},
                defaultPrice:{objName: 'defaultPrice', name: 'Default Price',options: []},
                allowIncomeOverride:{objName: 'allowIncomeOverride', name: 'Allow Income Override',options: [{name:'True',value:true},{name:'False',value:false}]}, //does not exist in verbose
                isDividendSuspended: {objName: 'isDividendSuspended', name: 'Suspended Dividends',onchange:"handleisdividendsuspendedclick()" ,options: [{name:'True',value:true},{name:'False',value:false}]},
            },
            crossreference:{//{name:'', id:''}
                productParent:[],
                globalFundFamily:[],
                productSubType:[]
            },
            combinedObj:{
                productId:'',
                productName:'',
                productType:'',
                ticker:'',
                productParentName:'',
                productParentId:'',
                micropalCode:'',
                globalFundFamilyName:'',
                globalFundFamilyId:'',
                includeByDefault:false,
                productSubTypeName:'',
                productSubTypeId:'',
                cusip:'',
                shareClassName:'',
                apcCode:'',
                fundNumber:'',
                defaultPrice:'',
                allowIncomeOverride:false,
                isDividendSuspended:[],
                secondaryProducts:[],
                unmatchedPricingOrder:[]
            }
        };
        $scope.controls={
            onFileSelect:onFileSelect,
            triggerFileSelect:triggerFileSelect,
            selectProduct:selectProduct,
            removeProduct:removeProduct,
            addProduct:addProduct,
            openAddProductModal:openAddProductModal,
            submitPC:submitPC,
            addUnmatchedPrice:addUnmatchedPrice,
            removeUnmatchedPrice:removeUnmatchedPrice,
            clearUnmatchedPricing:clearUnmatchedPricing,
            uploadModal:uploadModal,
            openHistoryCompare:openHistoryCompare
    };

        //INIT
        (function(){
            // selectProduct();
        })();

        //PUBLIC
        function openHistoryCompare(){
            let primaryProduct = $scope.current.selectedProduct;
            let secondaryProductList = $scope.current.data[primaryProduct].join(',');
            $window.open('/orionconnectapp/#/products/productCombine/productHistoryCompare/'+primaryProduct+'/'+secondaryProductList, '_blank');
        }
        function uploadModal(){
            $dialog.dialog({
                template:`
                    <div class="modal-header">
                        <h4><i class="fa fa-upload" aria-hidden="true"></i> New Upload</h4>
                    </div>
                    <div class="modal-body">
                        <div>
                            <input id="fileSelect" type="file" style="display:none;" ng-file-select="controls.close($files)">
                            <div ng-file-drop="controls.close($files)" ng-file-drag-over-class="" class="file-drop-target" style="height:300px; width:500px;" ng-click="controls.triggerFileSelect()">
                                <img style="display:block; width:103px; height: 136px; margin: 50px auto 30px auto;" src="_img\\\\svg\\\\file_upload.svg">
                                <span style="display: block; width: 240px; margin: auto; font-size: 25px; font-weight: 600; color: #666666;" >Select File to Upload</span>
                                <span style="display: block; width: 200px; margin: 15px auto;">Or drag and drop a file here</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn" ng-click="controls.close(false)"> Cancel</button>
                    </div>
                `,
                controller:['$scope', 'dialog', CTRL]
            })
                .open()
                .then(function(res){
                    $scope.controls.onFileSelect(res);
                });
            function CTRL($scope, dialog){
                $scope.controls ={
                    close:close,
                    triggerFileSelect:triggerFileSelect,
                };

                function triggerFileSelect() {
                    $timeout(function () {
                        angular.element('#fileSelect').trigger('click');
                    }, 0);
                }
                function close(file){
                    if(file){
                        dialog.close(file);
                    }else{
                        dialog.close();
                    }
                }
            }
        }
        function clearUnmatchedPricing(){
            $scope.current.combinedObj.unmatchedPricingOrder=[];
            $scope.current.unmatchedPrice = '';
        }
        function removeUnmatchedPrice(index){
            if(index !== -1){
                $scope.current.combinedObj.unmatchedPricingOrder.splice(index,1);
                orderUnmatchedPrices();
            }
        }
        function addUnmatchedPrice(){
            if(!$scope.current.combinedObj.unmatchedPricingOrder.find({fkProduct:$scope.current.unmatchedPrice})){
                $scope.current.combinedObj.unmatchedPricingOrder.push({fkProduct:$scope.current.unmatchedPrice,productOrder:0});
                orderUnmatchedPrices();
            }
        }
        function submitPC() {
            if($scope.current.combinedObj.productParentName){$scope.current.combinedObj.productParentId = $scope.current.crossreference.productParent.find({name:$scope.current.combinedObj.productParentName}).id;}
            if($scope.current.combinedObj.globalFundFamilyName){$scope.current.combinedObj.globalFundFamilyId = $scope.current.crossreference.globalFundFamily.find({name:$scope.current.combinedObj.globalFundFamilyName}).id;}
            if($scope.current.combinedObj.productSubTypeName){$scope.current.combinedObj.productSubTypeId = $scope.current.crossreference.productSubType.find({name:$scope.current.combinedObj.productSubTypeName}).id;}
            productCombineService.submitProductCombine($scope.current.combinedObj)
                .then(function(res){
                    if(res){
                        removeSelectedProduct();
                        $scope.rightPaneState='selectProduct';
                    }
                });
        }
        function openAddProductModal(){
            $dialog.dialog({
                template:`
                    <div class='modal-header'>
                        <h4><i class="fa fa-plus" aria-hidden="true"></i> Add Primary Product ID</h4>
                    </div>
                    <div class="modal-body">
                        <div>
                            <p>Primary Product ID</p>
                            <oas-search entity="productidglobal" selected="primaryProduct"></oas-search>
                        </div>
                        <div>
                            <p>Secondary Product ID</p>
                            <oas-search entity="productidglobal" selected="secondaryProduct" on-select="controls.addProduct(selected)"></oas-search>
                        </div>
                        <div>
                            <ul style="list-style: none;">
                                <li ng-repeat="item in current.items">{{item}}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary" ng-click="controls.close(true)"> Save</button>
                        <button class="btn" ng-click="controls.close(false)"> Cancel</button>
                    </div>
                    
                `,
                controller: ['$scope', 'dialog', Ctrl]
            })
                .open()
                .then(function(data){
                    if(data){
                        Object.assign($scope.current.data, data);
                    }
                })
            ;

            function Ctrl($scope, dialog){
                $scope.primaryProduct='';
                $scope.secondaryProduct='';
                $scope.current={
                    items:[],
                };
                $scope.controls={
                    addProduct:addProduct,
                    close:close,
                };

                function addProduct(selected){
                    $scope.current.items.unshift(selected.id);
                    $scope.secondaryProduct='';
                }

                function close(save){
                    if(save){
                        dialog.close({[$scope.primaryProduct.id]:$scope.current.items});
                    }else{
                        dialog.close();
                    }
                }
            }
        }
        function addProduct(product){
            $scope.current.data[$scope.current.selectedProduct].unshift(product.id);
            $scope.search.product = '';
            selectProduct();
        }
        function removeProduct(item){
            let arr = $scope.current.data[$scope.current.selectedProduct];
            arr.splice(arr.indexOf(item),1);
            selectProduct();
        }
        function selectProduct(){
            let list = angular.copy($scope.current.data[$scope.current.selectedProduct]);
            if(list){
                $scope.current.unmatchedPrice = '';
                $scope.current.useSecondaryPrice = 0;
                $scope.rightPaneState='combineProduct';
                $scope.current.combinedObj.productId = $scope.current.selectedProduct;
                list.push($scope.current.selectedProduct);
                productCombineService.getProductInfo(list)
                    .then(function(res){
                        clearAllOptions();
                        res.forEach(function(obj){
                            if(obj.id === parseInt($scope.current.selectedProduct)){
                                setDefaultOptions(obj);
                            }
                            buildOptionList(obj);
                        });
                    })
                ;
            }
        }
        function triggerFileSelect() {
            $timeout(function () {
                angular.element('#fileSelect').trigger('click');
            }, 0);
        }
        function onFileSelect(file){
            productCombineService.importData(file)
                .then(function(res){
                    let map = {};
                    res.forEach(function(row){
                        if(typeof map[row.product] !== "object") map[row.product] = [];
                        map[row.product].push(row.combineProduct);
                    });
                    $scope.current.data = map;
                    $scope.rightPaneState='uploadComplete';
                })
            ;
        }

        //PRIVATE
        function removeSelectedProduct(){
            delete $scope.current.data[$scope.current.selectedProduct];
        }
        function clearAllOptions(){
            Object.keys($scope.current.crossreference).forEach(function(obj){
                $scope.current.crossreference[obj] = [];
            });
            Object.keys($scope.current.selections).forEach(function(obj){
                if(obj !== 'allowIncomeOverride' && obj !== 'includeByDefault' && obj !== 'isDividendSuspended'){
                    $scope.current.selections[obj].options = [];
                }
            });
        }
        function buildOptionList(obj){
            Object.keys(obj).forEach(function(item){
                if($scope.current.selections[item]){
                    switch (item){
                        case 'productParentName':
                            $scope.current.crossreference.productParent.push({name:obj.productParentName, id:obj.productParentId});
                            break;
                        case 'globalFundFamilyName':
                            $scope.current.crossreference.globalFundFamily.push({name:obj.globalFundFamilyName, id:obj.globalFundFamilyId});
                            break;
                        case 'productSubTypeName':
                            $scope.current.crossreference.productSubType.push({name:obj.productSubTypeName, id:obj.productSubTypeId});
                            break;
                    }
                    let options = $scope.current.selections[item].options;
                    let option = {name:obj[item], value:obj[item]};
                    if( !options.find(option) && option.name!==null && item!=='allowIncomeOverride' && item!=='includeByDefault' && item!=='isDividendSuspended'){
                        options.push(option);
                    }
                }
            });
        }
        function handleisdividendsuspendedclick(){
            $scope.current.combinedObj.allowIncomeOverride = $scope.current.combinedObj.isDividendSuspended;
        }
        $scope.handleisdividendsuspendedclick=handleisdividendsuspendedclick;

        function setDefaultOptions(obj){
            Object.keys($scope.current.combinedObj).forEach(function(item){
                switch(item){
                    case 'unmatchedPricingOrder':
                        $scope.current.combinedObj[item]=[];
                        break;
                    case 'secondaryProducts':
                        $scope.current.combinedObj.secondaryProducts=$scope.current.data[$scope.current.selectedProduct];
                        break;
                    case 'allowIncomeOverride':
                    case 'includeByDefault':
                    case 'isDividendSuspended':
                        $scope.current.combinedObj[item]=(obj[item])?'true':'false';
                        break;
                    case 'productId':
                        break;
                    default:
                        $scope.current.combinedObj[item]=(obj[item] === null)?'':obj[item];
                        break;

                }
            });
        }
        function orderUnmatchedPrices(){
            $scope.current.combinedObj.unmatchedPricingOrder.forEach(function(item, index){
                item.productOrder = index+1;
            });
        }
    }
})();
(function(){
    'use strict';
    app
        .service('productCombineService', ['$http', '$upload', '$q', '$dataQuery', productCombineService])
    ;

    function productCombineService($http, $upload, $q, $dataQuery){
        this.importData = importData;
        this.getProductInfo = getProductInfo;
        this.submitProductCombine = submitProductCombine;
        this.getDataQuery = getDataQuery;
        this.getDataQueryResults = getDataQueryResults;

        function getProductInfo(list){
            return $http.post('/Global/Products/List', list, {trackerMsg:'Get Product Info'})
                .then(function(res){
                    return res.data;
                });
        }

        function importData(file){
            return $upload.upload({
                url: '/ValidateImport/Echo',
                file: file[0],
                method: 'POST',
                headers: {trackerMsg:'Load File Data', Authorization: 'Session ' + sessionStorage.oas_token}
            }).then(function(res){
                return res.data[0].result.table1;
            });
        }

        function submitProductCombine(data){
            var submission = { combinedObject: [data] };
            return $http.post('/Global/Products/Combine', submission, {trackerMsg:'Submitting Product Info'})
                .then(function(res){
                    return res.status === 200;
                });
        }

        function getDataQuery(queryName){
            return $http.get('/Reporting/Custom/Simple/Search/' + queryName, {trackerMsg: "Retrieving data query"})
                .then(function(res){
                    var id = res.data[0].id;
                    var existingConfig = $dataQuery.getDataQuery(id);
                    if (existingConfig && existingConfig.id === id) {
                        return $q.when(existingConfig);
                    } else {
                        return $http.get('/Reporting/Custom/' + id, {trackerMsg: "Loading data query config"})
                            .then(function (response) {
                                if (response) {
                                    $dataQuery.setDataQuery(response.data);
                                    return $dataQuery.getDataQuery(response.data.id);
                                }
                            });
                    }
                });
        }

        function getDataQueryResults(id, dataQuery){
            return $http.post('/Reporting/Custom/' + id + '/Generate/SlickGrid', dataQuery, {trackerMsg: 'Running Data Query'})
                .then(function(res){
                    $dataQuery.setDataQuery(dataQuery);
                    return res.data;
                });
        }
    }
})();
(function(){
    'use strict';
    angular
        .module('orionConnect')
        .controller('productHistoryCompareCtrl', ['$scope', '$route', 'productCombineService', CTRL]);

    function CTRL($scope, $route, productCombineService){
        $scope.current={
            dataQuery: null,
            dataQueryName: 'Product Combine Price Review',
            isLoading: true,
            url: null,
            parameterPrimaryId: $route.current.params.primaryProductId,
            parameterSecondaryId: $route.current.params.secondaryProductIdList,
            grid: {
                events: {
                    action: 'event:product-history-compare-action',
                    select: 'event:product-history-compare-select',
                }
            },
        };
        //INIT
        (function(){
            getDataQuery()
                .then(function(res){
                    $scope.current.dataQuery = res;
                })
                .then(function(){
                    refreshGrid();
                });
        })();

        //PRIVATE
        function refreshGrid () {
            $scope.current.isLoading = true;
            prepareQuery();
            productCombineService.getDataQueryResults($scope.current.dataQuery.id, $scope.current.dataQuery)
                .then(function(res){
                    if(res){
                        $scope.current.view = res;
                        $scope.current.url = '/Reporting/Custom/' + $scope.current.dataQuery.id + '/Generate/SlickGrid/' + $scope.current.view.dataQueryCacheKey;
                        $scope.current.isLoading = false;
                    }
                });
        }

        function getDataQuery() {
            return productCombineService.getDataQuery($scope.current.dataQueryName)
                .then(function(res){
                    if(res){
                        return res;
                    }
                });
        }

        function prepareQuery() {
            $scope.current.dataQuery.prompts.each(function(item){
                if(item.isPromptUser) {
                    switch(item.code.toLowerCase()) {
                        case "@fkproductprimary":
                            item.defaultValue = $scope.current.parameterPrimaryId;
                            break;
                        case "@fkproductssecondary":
                            item.defaultValue = $scope.current.parameterSecondaryId;
                            break;
                    }
                }
            });
        }
    }
})();
'use strict';

var portfolioOverviewCtrl = app.controller('PortfolioOverviewCtrl', function PortfolioOverviewCtrl( $scope, $http, $routeParams, $schwab, $oasRights, $portfolio, portfolioOverviewSettings, entities, $dialog, $location, $rebalance, $tactical, apps, $sce, API_CONFIG ) {

    // PRIVATE VARIABLES


    // PUBLIC METHODS
    $scope.setSelectedTab = function( button ) {
        $scope.topBar.buttons.each( function( b ) {
            b.selected = false;
        });
        button.selected = true;
        $scope.topBar.selectedCode = button.code;
        $scope.topBar.subItems = button.subItems;

        if( $scope.topBar.subItems && $scope.topBar.subItems.length > 0  ) {
            $scope.topBar.subItems.each(function (b) {
                if( b.selected ) {
                    $scope.topBar.selectedCode = b.code;
                }
            });
        }
    };

    $scope.setSelectedSubItem = function( button ) {
        $scope.topBar.subItems.each( function( b ) {
            b.selected = false;
        });
        button.selected = true;
        $scope.topBar.selectedCode = button.code;
        if(button.code === 'schwab' && $schwab.enrollmentInfo && $schwab.enrollmentInfo.statusIndicator !== 'Active' && $schwab.attributes.otpToken.length === 0){
            $schwab.openEnrollmentModal();
        }
    };

    $scope.searchForEntity = function( ) {
        $portfolio.search(entities.client.value)
            .then(function(rslt) {
                if( rslt ) {
                    setEntity( rslt.entity, rslt.item.id, true );
                }
            });
    };

    $scope.openSchwabMoneyMove = function(){
        $schwab.openMoneyMove();
    };

    $scope.signOutSchwabMoneyMove = function(){
        $schwab.signOutMoneyMove();
    };

    $scope.sortSchwabPositions = function(field){
        $schwab.sortPositions(field);
    };

    $scope.sortSchwabProfiles = function(field){
        $schwab.sortProfiles(field);
    };

    $scope.sortSchwabTransactions = function(field){
        $schwab.sortTransactions(field);
    };

    $scope.sortSchwabReports = function(field){
        $schwab.sortReports(field);
    };

    $scope.sortSchwabAlerts = function(field){
        $schwab.sortAlerts(field);
    };

    $scope.openSchwabReport = function(report){
        $schwab.openReport(report);
    };

    $scope.openSchwabUnrealizedLotDetail = function(position){
        if (position.showChildren) {
            position.showChildren = false;
        } else {
            $schwab.openUnrealizedLotDetail(position)
                .then(function () {
                    position.showChildren = true;
                });
        }
    };

    $scope.showSchwabTransactionDetail = function(execDate, publishTimeStamp){
        $schwab.showTransactionDetail(execDate, publishTimeStamp);
    };

    $scope.setIncludedAccountsForView = function( includedAccounts ) {
        $scope.settings.includedAccounts = includedAccounts;
    };

    $scope.setGroupingsForView = function( group, groupNumber ) {
        if( groupNumber === 1 ) {
            $scope.settings.selectedGroup1 = group;
        }
        if( groupNumber === 2 ) {
            $scope.settings.selectedGroup2 = group;
        }
        if( groupNumber === 3 ) {
            $scope.settings.selectedGroup3 = group;
        }

        setGroupingsForDataRetrieval( );
    };

    $scope.toggleAssets = function () {
        $scope.settings.showAssets = !$scope.settings.showAssets;
        setGroupingsForDataRetrieval( );
    };

    $scope.openEditor = function( entity, id ) {
        $portfolio.openEditor( entity.toString( ), [id], null, null, null, null );
    };

    $scope.openCancellationEditor = function( ) {
        $dialog.editor('portfolio/modals/cancelAccount.html', 'CancelAccountCtrl', {args: function() { return {id : $scope.entityLoaded.entityId, entity : parseInt($scope.entityLoaded.entity), app : apps.portfolioLists.name }; }}).open( );
    };

    $scope.runReport = function( ) {
        $portfolio.runReport( $scope.entityLoaded.entity, $scope.entityLoaded.entityId );
    };

    $scope.openDocuments = function( ) {
        $portfolio.openEditor(entities.client.value, [$scope.entityLoaded.entityId], "Notes & Documents", "notesAndDocuments", null, null, null );
    };

    $scope.goToPerformanceViewer = function() {
        $location.url('/reports/performanceviewer3?entity=' + parseInt($scope.entityLoaded.entity) + '&entityId=' + $scope.entityLoaded.entityId);
    };

    $scope.openRebalance = function() {
        $rebalance.start(6, [$scope.entityLoaded.entityId] );
    };

    $scope.runAnnuityTradeFax = function ( format ) {
        $http.get('/Reporting/Reports/1224/Parameters?runAssignedVersion=true', {trackerMsg: 'Getting report parameters'})
            .then(function (response) {
                let report = response.data;
                report.runTo = {storageType: "DirectDownload", reportFormat: format};
                $http.post('/Reporting/Reports/1224/Parameters?runAssignedVersion=true', report, {trackerMsg: 'Getting report parameters'})
                    .then( function(response) {
                        response.data.storable.forEach(function(group) {
                            group.parameters.forEach(function (parameter) {
                                if (parameter.name === "pkFundFamily" ) {
                                    parameter.value = $scope.entityLoaded.data.fundFamilyId;
                                }
                                if (parameter.name === "pkAccountOverride" ) {
                                    parameter.value = $scope.entityLoaded.entityId;
                                }
                            });
                        });
                        report.storable = response.data.storable;
                        $http.post('/Reporting/Reports/1224/Generate', report, {trackerMsg: 'Generating report'})
                            .then(function (response) {
                                if (report.runTo.storageType === "DirectDownload") {
                                    window.location.href = response.headers("location") + (response.headers("location").has("?") ? "&" : "?") + "Authorization=" + sessionStorage.oas_token;
                                } else {
                                    $scope.current.messages.push({name: report.reportName, runTo: report.runTo.displayName});
                                }
                            });
                    })
            });
    };

    $scope.openTactical = function() {
        $tactical.start("account", [$scope.entityLoaded.entityId], true);
    };

    $scope.openPortfolioAudit = function( whereTo ) {
        let urlLevel;
        switch ($scope.entityLoaded.entity) {
            case (entities.client.value):
                urlLevel = 'households';
                break;
            case (entities.registration.value):
                urlLevel = 'registrations';
                break;
            case (entities.account.value):
                urlLevel = 'accounts';
                break;
        }
        $portfolio.goTo( whereTo ? whereTo : urlLevel, $scope.entityLoaded.entity, $scope.entityLoaded.entityId );
    };

    $scope.openFinaMetrica = function () {
        $http.get('/Authorization/User/Verbose?expand=personal', {trackerMsg: 'Loading user information'})
            .then(function (response) {
                let params = {
                    ContactId: $scope.entityLoaded.entityId.toString( ),
                    UserKey: sessionStorage.oas_token,
                    Referrer: "orionadvisor.com",
                    TargetID: "Report",
                    EmailAddress: response.data.personal.email,
                    BusinessPhone: response.data.personal.mobilePhone.number
                };

                let host = window.location.host;

                $portfolio.openUrlWithPost('https://www.' + (host.has('test') || host.has('local') ? 'staging.' : '') + 'finametrica.com/integration/SsoLogin.aspx', params);
            });
    };

    $scope.loadPortfolioOverview = function( ) {
        if ($scope.settings.startDate > $scope.settings.endDate){
            $dialog.actionFailed("The start date cannot occur after the end date.  Please, change either or both start and end date.").open();
            return;
        }
        if ($scope.settings.startDate > Date.create('today') || $scope.settings.endDate > Date.create('today')){
            $dialog.actionFailed("Neither the start nor end date can be in the future.  Please, change either or both start and end date.").open();
            return;
        }

        clearPortfolioOverview( );

        portfolioOverviewSettings.settings.value = JSON.stringify($scope.settings);

        if( !$scope.user.isImpersonating ) {
            $http.post('/Settings/UserOptions/hh_overview_settings', portfolioOverviewSettings.settings).then(function (response) {
                portfolioOverviewSettings.settings.id = response.data.id;
            });
        }

        loadActivity( );
        loadActivityAUMChart( );

        loadHoldings( );

        loadModelTolerance( );

        loadPerformance( true );
        loadPerformance( false );

        //loadSchwab( );
        $schwab.load($scope.entityLoaded.entity, $scope.entityLoaded.entityId);
        $schwab.loadBalances = true;
    };

    // ACTIVITY
    $scope.expandAllActivity = function( ) {
        for( var i = 0; i < $scope.activity.details.length; i++ ) {
            $scope.activity.details[i].showTransactions = !$scope.activity.expandAll;
        }
        $scope.activity.expandAll = !$scope.activity.expandAll;
    };

    // HOLDINGS
    $scope.sortHoldings = function( field ) {
        $scope.holdings.sortField = field;
        $scope.holdings.sortReverse = !$scope.holdings.sortReverse;
    };

    $scope.openEditorFromHoldings = function( grouping, id ) {
        switch( grouping ) {
            case "Asset":
                $scope.openEditor( 8, id );
                break;
            //case "Asset Class":
            //    $location.path( '/assetclasses/' + id );
            //    break;
            //case "Asset Category":
            //    $location.path( '/assetcategories/' + id );
            //    break;
            default:
                break;
        }
    };

    $scope.expandAllHoldings = function( ) {
        for( var i = 0; i < $scope.holdings.details.length; i++ ) {
            $scope.holdings.details[i].showChildren = !$scope.holdings.expandAll;
            if( $scope.holdings.details[i].children ) {
                for( var j = 0; j < $scope.holdings.details[i].children.length; j++ ) {
                    $scope.holdings.details[i].children[j].showChildren = !$scope.holdings.expandAll;
                    if( $scope.holdings.details[i].children[j].children ) {
                        for (var k = 0; k < $scope.holdings.details[i].children[j].children.length; k++) {
                            $scope.holdings.details[i].children[j].children[k].showChildren = !$scope.holdings.expandAll;
                        }
                    }
                }
            }
        }
        $scope.holdings.expandAll = !$scope.holdings.expandAll
    };

    // MODEL TOLERANCE
    $scope.sortModelTolerance = function( field ) {
        $scope.modelTolerance.sortField = field;
        $scope.modelTolerance.sortReverse = !$scope.modelTolerance.sortReverse;
    };

    // PERFORMANCE
    $scope.expandAllPerformance = function( ) {
        if( $scope.performance.fullDetails ) {
            $scope.performance.performanceBenchmarkAnimation = null;
            $scope.performance.isFullDetailsExpanded = !$scope.performance.expandAll;
            for( var i = 0; i < $scope.performance.fullDetails.length; i++ ) {
                $scope.performance.fullDetails[i].isPerformanceGroupExpanded = !$scope.performance.expandAll;
                if( $scope.performance.fullDetails[i].children ) {
                    for( var j = 0; j < $scope.performance.fullDetails[i].children.length; j++ ) {
                        $scope.performance.fullDetails[i].children[j].isPerformanceGroupExpanded = !$scope.performance.expandAll;
                        if( $scope.performance.fullDetails[i].children[j].children ) {
                            for( var k = 0; k < $scope.performance.fullDetails[i].children[j].children.length; k++ ) {
                                $scope.performance.fullDetails[i].children[j].children[k].isPerformanceGroupExpanded = !$scope.performance.expandAll;
                            }
                        }
                    }
                }
            }
            $scope.performance.expandAll = !$scope.performance.expandAll;
        }
    };

    $scope.expandPerformanceDetails = function( ) {
        $scope.performance.performanceBenchmarkAnimation = null;
        $scope.performance.isFullDetailsExpanded = !$scope.performance.isFullDetailsExpanded;
    };

    $scope.expandGroupOnePerformance = function( groupOne ) {
        $scope.performance.performanceBenchmarkAnimation = null;
        groupOne.isPerformanceGroupExpanded = !groupOne.isPerformanceGroupExpanded;
    };

    $scope.expandGroupTwoPerformance = function( groupTwo ) {
        $scope.performance.performanceBenchmarkAnimation = null;
        groupTwo.isPerformanceGroupExpanded = !groupTwo.isPerformanceGroupExpanded;
    };

    $scope.expandGroupThreePerformance = function( groupThree ) {
        $scope.performance.performanceBenchmarkAnimation = null;
        groupThree.isPerformanceGroupExpanded = !groupThree.isPerformanceGroupExpanded;
    };

    $scope.togglePerformanceBenchmarks = function( ) {
        $scope.performance.performanceBenchmarkAnimation = "fade-in-out";
        $scope.performance.showPerformanceBenchmarks = !$scope.performance.showPerformanceBenchmarks;
    };

    $scope.refreshPerformanceChart = function( dateRange ) {
        $scope.performance.detailChart.selectedDateRange = dateRange;
        buildPerformanceChart( );
    };

    // SCHWAB


    // PRIVATE METHODS
    function init( ) {
        loadRights( );

        if( $scope.rightsSchwabSII.canRead ) {
            $scope.topBar.buttons[3].subItems.push( { image: '_img/main-menu/schwab-openview.png', text: 'Schwab OpenView Gateway', code: 'schwab', selected: false, visible: true, showRegistered: true } );
        }

        if( $scope.rightsPrairieSmarts.canRead ) {
            $scope.topBar.buttons[3].subItems.push( { image: '_img/main-menu/prairie-smarts.png', text: 'PrairieSmarts Risk Analysis', code: 'prairie', selected: false, visible: true, showRegistered: false } );
        }

        setDefaultTab( );

        let defaults = null;
        if( portfolioOverviewSettings.settings && portfolioOverviewSettings.settings.value ) {
            defaults = JSON.parse( portfolioOverviewSettings.settings.value );
        }

        $scope.settings = {
            startDate: defaults ? Date.create( defaults.startDate ) : Date.create( 'beginning of this year' ),
            endDate: Date.create( 'today' ),
            selectedGroup1: defaults ? defaults.selectedGroup1 : $scope.groupings[1],
            selectedGroup2: defaults ? defaults.selectedGroup2 : $scope.groupings[0],
            selectedGroup3: defaults ? defaults.selectedGroup3 : $scope.groupings[0],
            includedAccounts: defaults && defaults.includedAccounts ? defaults.includedAccounts : $scope.includedAccounts[0],
            showAssets: defaults ? defaults.showAssets : false,
        };

        $schwab.attributes.settings = $scope.settings;

        setGroupingsForDataRetrieval( );

        if( $routeParams.entityId ) {
            setEntity( $routeParams.entity, parseInt($routeParams.entityId), true );
        } else {
            $scope.searchForEntity( );
        }
    }

    function setGroupingsForDataRetrieval( ) {
        $scope.entityLoaded.groupings = [];
        if( $scope.settings.selectedGroup1.key > 0 ) {
            $scope.entityLoaded.groupings.push( $scope.settings.selectedGroup1.key );
        }
        if( $scope.settings.selectedGroup2.key > 0 ) {
            $scope.entityLoaded.groupings.push( $scope.settings.selectedGroup2.key );
        }
        if( $scope.settings.selectedGroup3.key > 0 ) {
            $scope.entityLoaded.groupings.push( $scope.settings.selectedGroup3.key );
        }
        if ( $scope.settings.showAssets || !$scope.entityLoaded.groupings.length ) {
            $scope.settings.showAssets = true;
            $scope.entityLoaded.groupings.push( 8 );
        }
    }

    function loadRights( ) {
        $scope.rightsTOM = $oasRights.forCode("TRADEORDERMGMT");
        $scope.rightsHHOverview = $oasRights.forCode("HOUSEHOLDOVERVIEW");
        $scope.rightsHH = $oasRights.forCode("CLIENTS");
        $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
        $scope.rightsAccount = $oasRights.forCode("ACCOUNTS");
        $scope.rightsAst = $oasRights.forCode("ASSETS");
        $scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");
        $scope.rightsCancelAccount = $oasRights.forCode("CANCELACCOUNT");
        $scope.rightsPortfolioAudit = $oasRights.forCode("PORTFOLIOLISTSAPP");
        $scope.rightsFinametrica = $oasRights.forCode("FINAMETRICA");
        $scope.rightsPerfViewer = $oasRights.forCode("PERFVIEWER");
        $scope.rightsSchwabSII = $oasRights.forCode("SCHWABSII");
        $scope.rightsPrairieSmarts = $oasRights.forCode("PRAIRIESMARTS");
        $scope.rightsDocuments = $oasRights.forCode("DOCUMENTS");
        $scope.rightsInsight = $oasRights.forCode("INSIGHTBUILDERAPP");
    }

    function setDefaultTab( ) {
        if($routeParams.openTab) {
            let button = undefined;
            let tabName = $routeParams.openTab.toLowerCase( );
            $scope.topBar.buttons.each( function( b ) {
                if( b.code.toLowerCase() === tabName ) {
                    button = b;
                }
                if( b.subItems && b.subItems.length > 0 ) {
                    b.subItems.each( function( s ) {
                        if( s.code.toLowerCase() === tabName ) {
                            s.selected = true;
                            button = b;
                        }
                    });
                }
            });
            if( button !== undefined ) {
                $scope.setSelectedTab( button );
            }
        }
    }

    function setEntity( entity, id, loadTree ) {
        $scope.entityLoaded.entityId = id;
        $scope.entityLoaded.entity = entity.toString( );
        $scope.entityLoaded.entityFriendly = entities[ entities.find( { value: $scope.entityLoaded.entity } ) ].name;
        $scope.entityLoaded.asOfValue = null;
        $scope.entityLoaded.data = null;
        $scope.entityLoaded.allowRead = false;
        $scope.entityLoaded.icon = '';

        if( $scope.entityLoaded.entityFriendly === entities.client.name ) {
            $scope.entityLoaded.allowRead = $scope.rightsHH.canRead;
            $scope.entityLoaded.icon = 'household';
        } else if( $scope.entityLoaded.entityFriendly === entities.registration.name ) {
            $scope.entityLoaded.allowRead = $scope.rightsReg.canRead;
            $scope.entityLoaded.icon = 'registration';
        } else if( $scope.entityLoaded.entityFriendly === entities.account.name ) {
            $scope.entityLoaded.allowRead = $scope.rightsAccount.canRead;
            $scope.entityLoaded.icon = 'account';
        }

        $http.get('/Portfolio/' + $scope.entityLoaded.entityFriendly.replace( 'Household', "Client") + 's/' + $scope.entityLoaded.entityId)
            .then(function (response) {
                $scope.entityLoaded.data = response.data;
                loadPrairieSmarts( );
        });

        if( loadTree ) {
            $scope.entitySelector.searchEntity = {id: id};
        }

        $scope.loadPortfolioOverview( );
    }

    function getPortfolioURLFirstFrag( ) {
        let urlFrag = '';
        switch( $scope.entityLoaded.entity ) {
            case (entities.client.value):
                urlFrag =  "/Portfolio/Clients/" + $scope.entityLoaded.entityId;
                break;
            case (entities.registration.value):
                urlFrag =  "/Portfolio/Registrations/" + $scope.entityLoaded.entityId;
                break;
            case (entities.account.value):
                urlFrag = "/Portfolio/Accounts/" + $scope.entityLoaded.entityId;
                break;
        }
        return urlFrag;
    }

    function clearPortfolioOverview( ) {
        $scope.entityLoaded.asOfValue = null;

        $scope.activity.details = null;
        $scope.activity.aumChart.visible = false;

        $scope.holdings.details = null;
        $scope.holdings.detailChart.visible = false;
        $scope.holdings.detailChart.selected = false;
        $scope.holdings.groupChart.visible = false;
        $scope.holdings.groupChart.selected = true;
        $scope.holdings.valueChart.visible = false;
        $scope.holdings.valueChart.selected = false;

        $scope.modelTolerance.details = null;
        $scope.modelTolerance.detailChart.visible = false;

        $scope.performance.entityDetails = null;
        $scope.performance.fullDetails = null;
        $scope.performance.detailChart.visible = false;
        $scope.performance.showPerformanceSpinner = false;

        $scope.schwab.balances = null;
        $scope.schwab.positions = null;
        $scope.schwab.profiles = null;
        $scope.schwab.transactions = null;
        $scope.schwab.alerts = null;
        $scope.schwab.reports = null;
        $scope.schwab.preferences = null;
        $scope.schwab.realized = null;
        $scope.schwab.unrealized = null;
    }

    // ACTIVITY
    function loadActivity( ) {
        let activitySettings = {
            entity: $scope.entityLoaded.entity,
            entityId: $scope.entityLoaded.entityId,
            startDate: $scope.settings.startDate.format('{yyyy}-{MM}-{dd}'),
            endDate: $scope.settings.endDate.format('{yyyy}-{MM}-{dd}'),
            activitySummaryDetail: 262079,
            clientPerformanceInclude: $scope.settings.includedAccounts.key
        };

        $http.post("/Reporting/Activity/TransactionBreakdown", activitySettings, {trackerMsg: 'Gathering activity summary', allowCancellation: true})
            .then(function( response ) {
                $scope.activity.details = response.data;
            });
    }

    function loadActivityAUMChart( ) {
        let aumChartFullUrl = getPortfolioURLFirstFrag( ) + "/NetAmountInvested?startDate=" + Date.create($scope.settings.startDate).addDays(-1).format('{yyyy}-{MM}-{dd}') + "&endDate=" + $scope.settings.endDate.format('{yyyy}-{MM}-{dd}') + "&clientPerformanceInclude=" + $scope.settings.includedAccounts.key;
        $http.get(aumChartFullUrl).then(function (response) {
            if( response.data && response.data.aumOverTime && response.data.netAmountInvested ) {

                let s = [
                    {data: [], name: 'AUM', color:'#00AEEF', showInLegend: true, fillOpacity: 0.4},
                    {data: [], name: 'Net Invested', color:'#0066FF', showInLegend: true, fillOpacity: 0.001}
                ];

                for( var i = 0; i < response.data.aumOverTime.length; i++ ) {
                    s[0].data.push( {x: Date.utc.create(response.data.aumOverTime[i].asOfDate).getTime(), y:(response.data.aumOverTime[i].value)});
                }
                for( var i = 0; i < response.data.netAmountInvested.length; i++ ) {
                    s[1].data.push( {x: Date.utc.create(response.data.netAmountInvested[i].asOfDate).getTime(), y:(response.data.netAmountInvested[i].value)});
                }

                $scope.activity.aumChart.visible = s[0].data.length > 0;
                $scope.activity.aumChart.config.series = s;
            }
        });
    }

    // HOLDINGS
    function loadHoldings( ) {
        let holdingsSettings = {
            entity: $scope.entityLoaded.entity,
            entityId: $scope.entityLoaded.entityId,
            groupings: $scope.entityLoaded.groupings,
            asOfDate: $scope.settings.endDate.format('{yyyy}-{MM}-{dd}'),
            includeCostBasis: true,
            includeUnitBalance: true,
            clientPerformanceInclude: $scope.settings.includedAccounts.key,
            showZeroValueAssets: false
        };

        $http.post("/Reporting/Activity/DrillDownSummary", holdingsSettings, {trackerMsg: 'Gathering holding summary', allowCancellation: true})
            .then(function( response ) {
                $scope.holdings.details = response.data;
                buildHoldingsDetailChart( );
                buildHoldingsGroupChart( );
                buildHoldingsValueChart( );
            });
    }

    function buildHoldingsGroupChart( ) {
        let dataPoints = [];
        for( let i = 0; i < $scope.holdings.details.length; i++ ) {
            if($scope.holdings.details[i].color ) {
                dataPoints.push( {name: $scope.holdings.details[i].name, y: Math.abs($scope.holdings.details[i].value), color: $scope.holdings.details[i].color } );
            }
            else {
                dataPoints.push( {name: $scope.holdings.details[i].name, y: Math.abs($scope.holdings.details[i].value) } );
            }
        }
        $scope.holdings.groupChart.title = 'Holdings';
        $scope.holdings.groupChart.visible = dataPoints.length > 0;
        $scope.holdings.groupChart.config.series[0].data = dataPoints;
    }

    function buildHoldingsDetailChart( ) {
        let chartData = [];
        let categories = [];
        let colors = [ '#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a' ];

        for( let i = 0; i < $scope.holdings.details.length; i++ ) {
            $scope.entityLoaded.asOfValue += $scope.holdings.details[i].value;
            categories.push($scope.holdings.details[i].name);

            let wedge = {
                y: Math.abs( $scope.holdings.details[i].value ),
                color: $scope.holdings.details[i].color ? $scope.holdings.details[i].color : colors[i%10],
                drilldown: {
                    name: '',
                    categories: [],
                    data: [],
                    color: $scope.holdings.details[i].color ? $scope.holdings.details[i].color : colors[i%10]
                }
            };


            if( $scope.holdings.details[i].children ) {
                for( let j = 0; j < $scope.holdings.details[i].children.length; j++ ) {
                    wedge.drilldown.data.push( Math.abs($scope.holdings.details[i].children[j].value ) );
                    wedge.drilldown.categories.push( $scope.holdings.details[i].children[j].name );
                }
            }

            chartData.push(wedge);
        }

        let groupData = [];
        let detailData = [];
        for (let k = 0; k < chartData.length; k++) {

            groupData.push({
                name: categories[k],
                y: chartData[k].y,
                color: chartData[k].color
            });

            for (let l = 0; l < chartData[k].drilldown.data.length; l++) {
                let brightness = 0.2 - (l / chartData[k].drilldown.data.length) / 5 ;
                detailData.push({
                    name: chartData[k].drilldown.categories[l],
                    y: chartData[k].drilldown.data[l],
                    color: Highcharts.Color(chartData[k].color).brighten(brightness).get()
                });
            }
        }

        $scope.holdings.detailChart.title = 'Holdings (detailed)';
        $scope.holdings.detailChart.visible = groupData.length > 0;

        $scope.holdings.detailChart.config.series[0].data = groupData;
        $scope.holdings.detailChart.config.series[1].data = detailData;

        if( $scope.settings.selectedGroup2.key > 0 || $scope.settings.selectedGroup3.key > 0 ) {
            $scope.holdings.detailChart.config.series[1].name = 'Group';
        } else {
            $scope.holdings.detailChart.config.series[1].name = 'Ticker';
        }
    }

    function buildHoldingsValueChart( ) {
        let chartCat = [];
        let chartValueData = [];
        for( var i = 0; i < $scope.holdings.details.length; i++ ) {
            chartCat.push($scope.holdings.details[i].name);
            chartValueData.push($scope.holdings.details[i].value);
        }

        $scope.holdings.valueChart.title = 'Value';
        $scope.holdings.valueChart.visible = chartCat.length > 0;
        $scope.holdings.valueChart.config.options.xAxis.categories = chartCat;
        $scope.holdings.valueChart.config.series[0].data = chartValueData;
    }

    // MODEL TOLERANCE
    function loadModelTolerance( ) {
        if( $scope.entityLoaded.entity === entities.account.value ) {
            $scope.topBar.buttons[4].visible = true;

            let modelToleranceFullUrl =  getPortfolioURLFirstFrag() + "/ModelTolerance?includeCash=true&includePendingValue=" + $scope.modelTolerance.detailChart.usePendingValue + "&grouping=" + $scope.modelTolerance.detailChart.grouping;

            $http.get(modelToleranceFullUrl, {trackerMsg: 'Running model tolerance'}).then(function (response) {
                $scope.modelTolerance.details = response.data;

                buildModelToleranceChart( );
            });

        } else {
            if( $scope.topBar.selectedCode === "modelTolerance") {
                $scope.topBar.selectedCode = 'holdings';
                $scope.topBar.buttons[4].selected = false;
                $scope.topBar.buttons[2].selected = true;
            }
            $scope.topBar.buttons[4].visible = false;
        }
    }

    function buildModelToleranceChart( ) {
        let points = {lower: [], upper: [], current: [], target: [], categories: []};

        $scope.modelTolerance.details.forEach(function(asset) {
            let current = asset.actualPercent;
            points.categories.push(asset.groupName);
            points.lower.push(-asset.lowerTolerance);
            points.upper.push(asset.upperTolerance);
            points.current.push(asset.inTolerance ? current - asset.targetPercent : {y: current - asset.targetPercent, color: '#BF0B23', borderColor: '#BF0B23'});
            points.target.push(asset.targetPercent);

            asset.diffPercent = asset.actualPercent - asset.targetPercent;
            asset.diffValue = asset.actualValue - asset.targetValue;
            asset.diffShares = asset.actualShares - asset.targetShares;
        });

        $scope.modelTolerance.detailChart.height = (29 * $scope.modelTolerance.details.length) + 69;
        $scope.modelTolerance.detailChart.visible = true;
        $scope.modelTolerance.detailChart.config.options.xAxis.categories = points.categories;
        $scope.modelTolerance.detailChart.config.series[0].data = points.lower;
        $scope.modelTolerance.detailChart.config.series[1].data = points.upper;
        $scope.modelTolerance.detailChart.config.series[2].data = points.current;
        $scope.modelTolerance.detailChart.config.series[3].data = points.target;
    }

    // PERFORMANCE
    function loadPerformance( isForEntityOnly ) {
        var performanceSettings = {};
        if( isForEntityOnly ) {
            performanceSettings = {
                entity: $scope.entityLoaded.entity,
                entityId: $scope.entityLoaded.entityId,
                groupings: [$scope.entityLoaded.entity],
                startDate: $scope.settings.startDate.format('{yyyy}-{MM}-{dd}'),
                endDate: $scope.settings.endDate.format('{yyyy}-{MM}-{dd}'),
                periods: 14,
                clientPerformanceInclude: $scope.settings.includedAccounts.key,
                showZeroValueAssets: false
            };
        } else {
            $scope.performance.showPerformanceSpinner = true;

            performanceSettings = {
                entity: $scope.entityLoaded.entity,
                entityId: $scope.entityLoaded.entityId,
                groupings: $scope.entityLoaded.groupings,
                startDate: $scope.settings.startDate.format('{yyyy}-{MM}-{dd}'),
                endDate: $scope.settings.endDate.format('{yyyy}-{MM}-{dd}'),
                periods: 14,
                clientPerformanceInclude: $scope.settings.includedAccounts.key,
                showZeroValueAssets: false
            };
        }

        $http.post("/Reporting/Performance/DrillDownSummary", performanceSettings, isForEntityOnly ? {trackerMsg: "Running performance", allowCancellation: true} : {allowCancellation: true} )
            .then(function( response ) {
                if( isForEntityOnly ) {
                    $scope.performance.entityDetails = response.data;
                } else {
                    $scope.performance.fullDetails = response.data;
                    buildPerformanceChart( );
                    $scope.performance.showPerformanceSpinner = false;
                }
            });
    }

    function buildPerformanceChart( ) {
        let chartCategories = [];
        let chartPerformanceData = [];

        for( var l = 0; l < $scope.performance.fullDetails.length; l++ ) {
            if( $scope.performance.fullDetails[l].children ) {
                chartCategories.push( $scope.performance.fullDetails[l].name );
                if( $scope.performance.fullDetails[l].dateRanges ) {
                    for( var m = 0; m < $scope.performance.fullDetails[l].dateRanges.length; m++ ) {
                        if( $scope.performance.fullDetails[l].dateRanges[m].dateRangeName === $scope.performance.detailChart.selectedDateRange ) {
                            chartPerformanceData.push( { y: $scope.performance.fullDetails[l].dateRanges[m].performance, color: $scope.performance.fullDetails[l].color } );
                        }
                    }
                }
            }
        }

        $scope.performance.detailChart.title = 'Performance';
        $scope.performance.detailChart.visible = chartCategories.length > 0;
        $scope.performance.detailChart.config.options.xAxis.categories = chartCategories;
        $scope.performance.detailChart.config.series[0].data = chartPerformanceData;
    }

    function showSchwab(){
        let accessMenuIndx = $scope.topBar.buttons.findIndex(function(menu){
            return menu.code === 'integrations';
        });
        if($scope.topBar.buttons[accessMenuIndx].subItems.length>0){
            let schwabButton = $scope.topBar.buttons[accessMenuIndx].subItems.findIndex(function(button){
                return button.text === 'Schwab OpenView Gateway';
            });
            if(schwabButton>=0){
                $scope.topBar.buttons[accessMenuIndx].subItems[schwabButton].visible = true;
            }
        }
    }


    // PRAIRIE SMARTS
    function loadPrairieSmarts( ) {
        if( $scope.rightsPrairieSmarts.canRead ) {
            let qs = '?embed=true';
            if( $scope.entityLoaded.entityFriendly === entities.client.name ) {
                qs += '&clientId=' + $scope.entityLoaded.entityId;
            }
            if( $scope.entityLoaded.entityFriendly === entities.account.name ) {
                qs += '&clientId=' + $scope.entityLoaded.data.clientId;
                qs += '&accountId=' + $scope.entityLoaded.entityId;
            }
            qs += '&session=' + sessionStorage.oas_token;
            $scope.prairieSmartsUrl = $sce.trustAsResourceUrl('https://app.prairiesmarts.com/frio_test/index.html' + qs);
        }
    }


    // SCHWAB
    function hideSchwabButton( ) {
        if( $scope.topBar.selectedCode === "schwab" ) {
            $scope.topBar.selectedCode = 'holdings';
            $scope.topBar.subItems[0].selected = false;
            $scope.topBar.buttons[2].selected = true;
        }
        $scope.topBar.buttons[3].subItems[0].visible = false;
    }

    // WATCHES
    $scope.$watch("entitySelector.selectedEntity", function (newValue, oldValue) {
        if (!newValue || newValue === oldValue || newValue.id === $scope.entityLoaded.entityId) return;
        setEntity( newValue.type, newValue.id, false );
    });

    $scope.$watch("modelTolerance.detailChart.grouping", function (newValue, oldValue) {
        //had to use a watch because ng-click on a btn-radio acts weird
        if (newValue === oldValue) return;
        loadModelTolerance( );
    });

    $scope.$watch("modelTolerance.detailChart.usePendingValue", function (newValue, oldValue) {
        //had to use a watch because ng-click on a btn-radio acts weird
        if (newValue === oldValue) return;
        loadModelTolerance( );
    });

    $scope.$watch("schwab.hideAccess", function (newValue, oldValue) {
        //had to use a watch because ng-click on a btn-radio acts weird
        if (newValue === oldValue) return;
        if($scope.rightsSchwabSII.canRead & $scope.entityLoaded.entityFriendly === 'Account'){
            showSchwab();
        }else{
            hideSchwabButton();
        }
        loadModelTolerance( );
    });


    // SETUP
    $scope.topBar = {
        selectedCode: 'holdings',
        subItems: [],
        buttons: [
            { icon: 'fa fa-fw fa-tasks', text: 'Activity', code: 'activity', selected:false, visible: true },
            { icon: 'fa fa-fw fa-usd', text: 'Billing', code: 'billing', selected: false, visible: false },
            { icon: 'fa fa-fw fa-sitemap fa-rotate-270', text: 'Holdings', code: 'holdings', selected: true, visible: true },
            { icon: 'fa fa-fw fa-link', text: 'Integrations', code: 'integrations', selected: false, visible: true, subItems: [] },
            { icon: 'fa fa-fw fa-crosshairs', text: 'Model Tolerance', code: 'modelTolerance', selected: false, visible: true },
            { icon: 'fa fa-fw fa-bar-chart', text: 'Performance', code: 'performance', selected: false, visible: true },
            { icon: 'fa fa-fw fa-user', text: 'Profile', code: 'profile', selected: false, visible: false },
            { icon: 'fa fa-fw fa-university', text: 'RMD', code: 'rmd', selected: false, visible: false }
        ]
    };

    if(!$schwab.hideAccess){
        showSchwab();
    }

    $scope.groupings = [
        { name: "(None)", key: 0 },
        { name: "Account", key: 7 },
        { name: "Asset Category", key: 15 },
        { name: "Asset Class", key: 9 },
        { name: "Asset Level Strategy", key: 16 },
        { name: "Management Style", key: 11 },
        { name: "Model", key: 74 },
        { name: "Registration", key: 6 },
        { name: "Risk Category", key: 12 }
    ];

    $scope.includedAccounts = [
        { name: "Database Default", key: -1 },
        { name: "All Accounts", key: 0 },
        { name: "Active Accounts", key: 1 },
        { name: "Active With Value", key: 2 }
    ];

    $scope.entitySelector = {
        selectedEntity: null,
        items: [],
        searchEntity: null
    };

    $scope.entityLoaded = {
        entity: 0,
        entityId: 0,
        entityFriendly: '',
        asOfValue: null,
        allowRead: false,
        data: null,
        icon: '',
        groupings: []
    };

    $scope.activity = {
        details: null,
        expandAll: false,
        aumChart: {visible: false, title: '', config: null}
    };

    $scope.holdings = {
        details: null,
        expandAll : false,
        detailChart: {visible: false, title: '', config: null, selected: false},
        groupChart: {visible: false, title: '', config: null, selected: false},
        valueChart: {visible: false, title: '', config: null, selected: false},
        sortField: 'value',
        sortReverse: true
    };

    $scope.modelTolerance = {
        details: null,
        sortField: '',
        sortReverse: false,
        tableMode: 'percent',
        detailChart: {visible: false, title: '', grouping: '0', config: null, usePendingValue: 0}
    };

    $scope.performance = {
        entityDetails: null,
        fullDetails: null,
        expandAll: false,
        isFullDetailsExpanded: false,
        showPerformanceSpinner: false,
        showPerformanceBenchmarks: true,
        performanceBenchmarkAnimation: 'fade-in-out',
        detailChart: {visible: false, title: '', selectedDateRange: 'ytd', config: null}
    };

    $scope.schwab = $schwab.attributes;
    $scope.schwabAccess = $schwab.hideAccess;
    
    // Expose the openEnrollmentModal function to the scope for the deprecation banner link
    $scope.openSchwabPortal = function() {
        $schwab.openEnrollmentModal();
    };

    $scope.insightApp = { url : API_CONFIG.insightUrl + '?p=dashboards&t=' + sessionStorage.oas_token};

    // CHARTS
    $scope.activity.aumChart.config = {
        options: {
            chart: { type: 'area', backgroundColor:'rgba(255, 255, 255, 0.1)' },
            credits: { enabled: false },
            xAxis: { labels: { formatter: function() { return Highcharts.dateFormat('%b %Y', this.value); } }, type: 'datetime' },
            yAxis: { min: 1/1/1970, title: { text: '' }, labels: { formatter: function() { return  '$' + Highcharts.numberFormat(this.value, 0); } } },
            tooltip: { xDateFormat: '%m/%d/%Y', pointFormat: '{series.name}: <b>${point.y:,.0f}</b><br/>', followTouchMove: true, shared: true },
            plotOptions: { area: { pointStart: Date.UTC(1970, 0, 1),  pointInterval: 24 * 3600 * 1000, marker: { enabled: false, symbol: 'circle', radius: 2, states: { hover: { enabled: true } } } } }
        },
        series: [],
        title: {text: ''},
        subtitle: {text: ''}
    };

    $scope.holdings.detailChart.config = {
        options: {
            chart: { type: 'pie' },
            credits: {enabled: false},
            yAxis: { title: { text: '' } },
            plotOptions: {  pie: { shadow: false, center: ['50%', '50%'] } },
            tooltip: { valuePrefix: '$' }
        },
        series: [
            { name: 'Group', data: [], size: '70%', dataLabels: { formatter: function( ) { return this.point.percentage > 5 ? this.point.name : null; }, color: 'white', distance: -30 } },
            { name: 'Group', data: [], size: '80%', innerSize: '70%', dataLabels: { enabled: true, color: '#000000', connectorColor: '#000000', format: '<b>{point.name}</b>: {point.percentage:.1f} %'} }
        ],
        title: {text: ''}
    };

    $scope.holdings.groupChart.config = {
        options: {
            credits: {enabled: false},
            plotOptions: { pie: { allowPointSelect: true, cursor: 'pointer', dataLabels: { enabled: true, color: '#000000', connectorColor: '#000000', format: '<b>{point.name}</b>: {point.percentage:.1f} %'} } },
            tooltip: { pointFormat: '<b>${point.y:,.2f}</b>' }
        },
        series: [{ type: 'pie', name: 'Holdings', data: [] }],
        title: {text: ''}
    };

    $scope.holdings.valueChart.config = {
        options: {
            chart: {type: 'column'},
            credits: {enabled: false},
            legend: {enabled: false, borderWidth: 0, layout: 'vertical', align: 'right', verticalAlign: 'middle'},
            xAxis: {categories: [], labels: { rotation: -75, align: 'right', style: { fontSize: '11px', fontFamily: 'Helvetica, Neue' } } },
            yAxis: {title: {text: ''}},
            plotOptions: { column: { pointPadding: 0.2, borderWidth: 0 }},
            tooltip: { pointFormat: 'Value: <b>${point.y}</b>'}
        },
        series: [
            {data: [], name: '', color:'#00AEEF' }
        ],
        title: {text: ''},
        subtitle: {text: ''}
    };

    $scope.modelTolerance.detailChart.config = {
        options: {
            chart: {type: 'bar', borderWidth: 0},
            credits: {enabled: false},
            legend: {enabled: true, borderWidth: 0},
            xAxis: {categories: []},
            yAxis: {title: {text: ''}, labels: {formatter: function() {return this.value === 0 ? 'Target' : this.value + ' %'}}},
            plotOptions: {bar: {grouping: false, shadow: false, pointPadding: 0}},
            tooltip: {
                formatter: function() {
                    let chart = this.points[0].series.chart;
                    let categories = chart.xAxis[0].categories;
                    let index = 0, temp = {};

                    while(this.x !== categories[index]){index++;}
                    chart.series.forEach(function(series) {
                        temp[series.name] = series.yData[index];
                    });

                    let target = temp['Target'].round(2);
                    let bottom = (temp['Target'] + temp['Lower']).round(2);
                    let top = (temp['Target'] + temp['Upper']).round(2);
                    let range = bottom === target && top === target ? '' : '<br/>Range: ' + bottom + ' - ' + top + ' %';
                    let curr = parseFloat(temp['Current']) + target;

                    return '<b>'+ this.x + '<br/>Target: ' + target + ' %' + range + '<br/>Current: ' + curr + ' %';
                },
                shared: true,
                shadow: false,
                borderColor: "#CCCCCC"
            }
        },
        series: [
            {data: [], name: 'Lower', borderColor: "#00AEEF", color: "rgba(0, 170, 239, 0.1)"},
            {data: [], name: 'Upper', borderColor: "#00AEEF", color: "rgba(0, 170, 239, 0.1)"},
            {data: [], name: 'Current', borderColor: "#00AEEF", color: '#00AEEF', pointPadding: 0.2},
            {data: [], name: 'Target', visible: false, showInLegend: false}
        ],
        title: {text: ''}
    };

    $scope.performance.detailChart.config = {
        options: {
            chart: {type: 'column'},
            credits: {enabled: false},
            legend: {enabled: false, borderWidth: 0, layout: 'vertical', align: 'right', verticalAlign: 'middle'},
            xAxis: {categories: [], labels: { rotation: -75, align: 'right', style: { fontSize: '11px', fontFamily: 'Helvetica, Neue' } } },
            yAxis: {title: {text: ''}, labels: {format: '{value}%'}},
            plotOptions: { column: { pointPadding: 0.2, borderWidth: 0 }},
            tooltip: { pointFormat: 'Performance: <b>{point.y:.2f}%</b>'}
        },
        series: [
            {data: [], name: '', color:'#00AEEF' }
        ],
        title: {text: ''},
        subtitle: {text: ''}
    };


    // INIT
    init( );
});

portfolioOverviewCtrl.loadPortfolioOverviewSettings = ["$http","$q", function( $http, $q ) {

    let loadPromises = [];
    loadPromises.push( $http.get('/Settings/UserOptions/hh_overview_settings', {trackerMsg: 'Loading default settings' } ) );

    return $q.all(loadPromises).then(function(results) {
        return { settings: results[0].data };
    });

}];
'use strict';

app.controller('PortfolioInsightCtrl', function PortfolioInsightCtrl($scope, $http, API_CONFIG, $sce, $oasRights, $portfolio, $routeParams, entities){

    function init() {
        const page = '/dashboardembed?systemType=portfolio&datePickers=show&editDashboard=show&entityEnum={entityEnum}&entityId={entityId}&showInception=true'.assign($routeParams);
        $scope.url = $sce.trustAsResourceUrl(API_CONFIG.insightUrl + '?t=' + sessionStorage.oas_token + '&p=' + encodeURIComponent(page));
        $scope.showInsight = $oasRights.canRead("INSIGHTBUILDERAPP");
        $scope.entityFriendly = entities[ entities.find( { value: $routeParams.entityEnum } ) ].name;
        if( $scope.entityFriendly === entities.client.name ) {
            $scope.allowEntityUpdate = $oasRights.canUpdate("CLIENTS");
        } else if( $scope.entityFriendly === entities.registration.name ) {
            $scope.allowEntityUpdate = $oasRights.canUpdate("REGISTRATIONS");
        } else if( $scope.entityFriendly === entities.account.name ) {
            $scope.allowEntityUpdate = $oasRights.canUpdate("ACCOUNTS");
        }
    }

    $scope.openEditor = function( ) {
        $portfolio.openEditor( $routeParams.entityEnum, [$routeParams.entityId], null, null, null, null );
    };

    $scope.runReport = function( ) {
        $portfolio.runReport( $routeParams.entityEnum, $routeParams.entityId );
    };

    init( );
});
'use strict';

app.controller('SchwabTransactionCtrl', function SchwabTransactionCtrl($scope, $http, dialog) {

    //PRIVATE METHODS
    function init( ) {
        // Note: TransactionDetail endpoint has been deprecated and removed
        // Display message to user
        $scope.t = null;
        $scope.errorMessage = 'Transaction detail view is no longer available. The Schwab integration endpoint has been deprecated. Please access transaction details directly through the Schwab portal via SSO.';
    }


    //PUBLIC METHODS
    $scope.close = function( ) {
        dialog.close( );
    };


    init( );
});
'use strict';

app.controller('HouseholdingCtrl', function HouseholdingCtrl($scope, $http, $portfolio, $oasRights, $dialog, $routeParams, $q, entities, apps, $window) {
    //PRIVATE METHODS
    function init() {
        Object.each({entityId1: "one", entityId2: "two"}, function (key, value) {
            if ($routeParams[key]) {
                $scope.loadClient({id: parseInt($routeParams[key])})
                    .then(function (client) {
                        $scope.clients[value] = client;
                    });
            }
        });

        if ($routeParams.source) {
            const key = apps.find({code: $routeParams.source});
            $scope.middleBreadcrumb = key ? apps[key].name : null;
        }

        if ($scope.user.authorization.alClientLockType === 1) {
            $scope.rightsHH.canAdd = $scope.rightsHH.canUpdate = $scope.rightsHH.canDelete = false;
            $scope.rightsReg.canAdd = $scope.rightsReg.canUpdate = $scope.rightsReg.canDelete = false;
            $scope.rightsAcc.canAdd = $scope.rightsAcc.canUpdate = $scope.rightsAcc.canDelete = false;
            $scope.rightsMoveRegistration.canAdd = $scope.rightsMoveRegistration.canUpdate = $scope.rightsMoveRegistration.canDelete = false;
            $scope.rightsMoveAccount.canAdd = $scope.rightsMoveAccount.canUpdate = $scope.rightsMoveAccount.canDelete = false;
        }
    }
    
    function getClient(entity) {
        const clientOne = $scope.clients.one;
        const clientTwo = $scope.clients.two;

        switch (entity.entity) {
            case entities.client.name:
                return entity;
            case entities.registration.name:
                return clientOne && clientOne.registrations.any({id: entity.id}) ? clientOne : clientTwo;
            case entities.account.name:
                return clientOne && clientOne.registrations.any(function (r) { return r.accounts.any({id: entity.id}); }) ? clientOne : clientTwo;
        }
    }

    function getOtherClient(entity) {
        const myClient = getClient(entity);
        return $scope.clients[myClient === $scope.clients.one ? 'two' : 'one'];
    }

    function promptForOtherClient(sourceClient) {
        return $dialog.search("client", "Destination", "Household")
            .open()
            .then(function (result) {
                if (!result || result.id === sourceClient.id) {
                    return null;
                }

                return $scope.loadClient(result)
                    .then(function (client) {
                        $scope.clients[sourceClient === $scope.clients.one ? 'two' : 'one'] = client;
                        return client;
                    });
            });
    }

    function addHistory(action, actionEntity, secondaryEntity) {
        $scope.history.insert({
            action: action,
            actionEntity: actionEntity,
            secondaryEntity: secondaryEntity,
            time: Date.create().format("{h}:{mm}:{ss}")
        }, 0);
    }

    function openDocumentMover(sourceEntity, destinationEntity) {
        const entityEnum = entities[entities.find({name: sourceEntity.entity})];

        $scope.documentMover.entityEnum = parseInt(entityEnum.value);
        $scope.documentMover.fromEntity = sourceEntity;
        $scope.documentMover.toEntity = destinationEntity;
        $scope.documentMover.isOpen = true;
    }
    
    function moveRegistrations(sourceClient, registrationsToMove) {
        const moveTheThings = function (destinationClient) {
            registrationsToMove.reduce(function (promise, registration) {
                return promise
                    .then(function () {
                        return $http.put(`/Portfolio/Registrations/${registration.id}/Action/MoveToClient/${destinationClient.id}`, null, {trackerMsg: `Moving ${registration.name}`});
                    })
                    .then(function () {
                        addHistory('Moved', registration, destinationClient);
                    });
            }, $q.when())
                .then(function () {
                    $scope.loadClient(sourceClient);
                    $scope.loadClient(destinationClient);
                });
        };

        const otherClient = getOtherClient(sourceClient);
        if (otherClient) {
            const displayText = registrationsToMove === sourceClient.registrations ? "all registrations" : registrationsToMove[0].name;

            $dialog.confirmAction(`Are you sure you want to move <b>${displayText}</b> from the ${sourceClient.name} household to the ${otherClient.name} household?`)
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        moveTheThings(otherClient);
                    }
                });
        } else {
            promptForOtherClient(sourceClient)
                .then(function (destinationClient) {
                    if (!destinationClient) {
                        return;
                    }

                    moveTheThings(destinationClient);
                });
        }
    }
    
    function moveAccounts(sourceRegistration, accountsToMove) {
        const sourceClient = getClient(sourceRegistration);
        const otherClient = getOtherClient(sourceClient);
        const availableDestinations = [];

        [sourceClient, otherClient].forEach(function (client) {
            if (client) {
                client.registrations.forEach(function (registration) {
                    if (registration !== sourceRegistration) {
                        availableDestinations.push({id: registration.id, name: `${registration.name} (${registration.id})`, reference: registration});
                    }
                });
            }
        });

        if (!availableDestinations.length) {
            $dialog.actionFailed('There are currently no other registrations loaded to move accounts to.').open();
            return;
        }

        $dialog.inputBox("Destination", "Registration", availableDestinations)
            .open()
            .then(function (selectedRegistration) {
                if (!selectedRegistration) {
                    return;
                }

                const destinationRegistration = selectedRegistration.reference;

                const promises = accountsToMove.map(function (account) {
                    return $http.put(`/Portfolio/Accounts/${account.id}/Action/MoveToRegistration/${destinationRegistration.id}`, null, {trackerMsg: `Moving ${account.name}`})
                        .then(function () {
                            addHistory('Moved', account, destinationRegistration);
                        });
                });

                $q.all(promises)
                    .then(function () {
                        const destinationClient = getClient(destinationRegistration);
                        if (destinationClient !== sourceClient) {
                            $scope.loadClient(destinationClient);
                        }

                        $scope.loadClient(sourceClient);
                    });
            });
    }


    // PUBLIC METHODS
    $scope.loadClient = function (client) {
        client.registrations = null;  //clear it so the changes get picked up in the one-time bindings

        return $http.get(`/Portfolio/Clients/${client.id}/PortfolioTree?includeAdditionalDetail=true&includeRepresentative=true`, {trackerMsg: 'Loading portfolio'})
            .then(function (response) {
                angular.merge(client, response.data);

                client.entity = entities.client.name;
                
                client.registrations.forEach(function (registration) {
                    registration.entity = entities.registration.name;

                    registration.accounts.forEach(function (account) {
                        account.entity = entities.account.name;
                    });
                });

                return client;
            });
    };

    $scope.runReport = function (entity) {
        $portfolio.runReport(entity.entity, entity.id);
    };
    
    $scope.editEntity = function (entity) {
        $portfolio.openEditor(entity.entity, [entity.id], null, null, apps.none.name)
            .then(function (result) {
                if (!result) {
                    return;
                }

                addHistory("Edited", entity);
                const client = getClient(entity);
                $scope.loadClient(client);
            });
    };

    $scope.addNewChildEntity = function (parentEntity) {
        const client = getClient(parentEntity);
        const extraInfo = {fkClient: client.id};
        let entityEnum;

        if (parentEntity.entity === entities.client.name) {
            entityEnum = entities.registration;
        } else {
            entityEnum = entities.account;
            extraInfo.fkRegistration = parentEntity.id;
        }

        $portfolio.openEditor(entityEnum.value, [], null, null, apps.portfolioLists.name, extraInfo)
            .then(function (result) {
                if (!result) {
                    return;
                }

                result.entity = entityEnum.name;
                addHistory("Added", result, parentEntity);

                $scope.loadClient(client);
            });
    };

    $scope.deleteEntity = function (entity) {
        const entityEnum = entities[entities.find({name: entity.entity})];

        $dialog.confirmAction(`Are you sure you want to delete ${entityEnum.name.toLowerCase()} <b>${entity.name} (${entity.id})</b>?`)
            .open()
            .then(function (result) {
                if (result !== 'yes') {
                    return;
                }

                const baseUrl = entityEnum.simpleUrl.replace('/Simple', '');

                $http.put(`${baseUrl}/action/delete`, [entity.id], {trackerMsg: `Deleting ${entity.name}`})
                    .then(function () {
                        addHistory('Deleted', entity);

                        if (entityEnum === entities.client) {
                            $scope.clients[entity === $scope.clients.one ? 'one' : 'two'] = null;
                        } else {
                            const client = getClient(entity);
                            $scope.loadClient(client);
                        }
                    });
            });
    };
    
    $scope.moveAllRegistrations = function (client) {
        if (!client.registrations.length) {
            $dialog.messageBox("No Registrations", `<b>${client.name}</b> does not have any registrations to move.`).open();
            return;
        }

        moveRegistrations(client, client.registrations);
    };

    $scope.moveRegistration = function (registration) {
        const client = getClient(registration);
        moveRegistrations(client, [registration]);
    };

    $scope.moveAllAccounts = function (registration) {
        if (!registration.accounts.length) {
            $dialog.messageBox("No Accounts", `<b>${registration.name}</b> does not have any accounts to move.`).open();
            return;
        }

        moveAccounts(registration, registration.accounts);
    };

    $scope.moveAccount = function (account, registration) {
        moveAccounts(registration, [account]);
    };
    
    $scope.moveHouseholdDocuments = function (sourceClient) {
        const otherClient = getOtherClient(sourceClient);
        
        if (otherClient) {
            openDocumentMover(sourceClient, otherClient);
        } else {
            promptForOtherClient(sourceClient)
                .then(function (destinationClient) {
                    if (!destinationClient) {
                        return;
                    }

                    openDocumentMover(sourceClient, destinationClient);
                });
        }
    };

    $scope.moveAccountDocuments = function (sourceAccount, sourceClient) {
        const otherClient = getOtherClient(sourceClient);
        const availableDestinations = [];

        [sourceClient, otherClient].forEach(function (client) {
            if (client) {
                client.registrations.forEach(function (registration) {
                    registration.accounts.forEach(function (account) {
                        if (account !== sourceAccount) {
                            availableDestinations.push({id: account.id, name: `${account.name} (${account.id})`, reference: account});
                        }
                    });
                });
            }
        });

        if (!availableDestinations.length) {
            $dialog.actionFailed('There are currently no other accounts loaded to move documents to.').open();
            return;
        }

        $dialog.inputBox("Destination", "Account", availableDestinations)
            .open()
            .then(function (selectedAccount) {
                if (!selectedAccount) {
                    return;
                }

                openDocumentMover(sourceAccount, selectedAccount.reference);
            });
    };

    $scope.onDocumentsMoved = function (count) {
        $scope.documentMover.isOpen = false;

        if (count > 0) {
            addHistory(`Moved ${count} Document${count > 1 ? 's' : ''} from`, $scope.documentMover.fromEntity, $scope.documentMover.toEntity);
        }
    };

    $scope.goBack = function () {
        $window.history.back();
    };


    // INITIALIZE
    $scope.history = [];
    $scope.positions = ['one', 'two'];
    $scope.clients = {};
    $scope.documentMover = {
        isOpen: false,
        entityEnum: null,
        fromEntity: null,
        toEntity: null
    };

    $scope.rightsHH = $oasRights.forCode("CLIENTS");
    $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
    $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
    $scope.rightsMoveRegistration = $oasRights.forCode("MOVEREGISTRATION");
    $scope.rightsMoveAccount = $oasRights.forCode("MOVEACCOUNT");

    init();
});

'use strict';
var benchmarkAssignmentCtrl = app.controller('BenchmarkAssignmentCtrl', function BenchmarkAssignmentCtrl($scope, $http,listSectionData, $dialog,  $oasRights, entities, reportHelper) {
    //PUBLIC VARIABLES

    //PRIVATE VARIABLES

    var dataItemsEvent = "event: data-items";
    var dataItemDeleteEvent = "event: data-item-delete";

    $scope.config = {
        getUrl: null,
        listName: 'Assignments',
        template: 'benchmarkAssignment-list-item.html',
        icon: 'fa fa-users',
        addItemEvent: null,
        rebalanceItemEvent: null,
        loadDataItemsEvent: dataItemsEvent,
        deleteItemEvent: dataItemDeleteEvent,
        selectEnabled: false,
        multiSelectEnabled: false,
        nameProperty: 'name',
        dataProperty: 'entity',
        selectProperty: 'name',
        sortFields: {entityName: "Name", indexCount: "# of Assignments"},
        promptForItemDelete : true,
        //listFilter: function(item, value) {return (item.name && item.name.toLowerCase().indexOf(value) !== -1) || (item.fundName && item.fundName.toLowerCase().indexOf(value) !== -1);}
        listFilter: ['entityName', 'indexCount'],
        additionalLinks: []
    };

    function loadDropDowns(){
        $http.get('/Portfolio/Platforms/Simple', {cache: true, trackerMsg: 'Loading management styles'})
            .then(function(response) {
                $scope.managementStyles = response.data;
            });
        $http.get('/Portfolio/ProductCategories/Simple', {cache: true, trackerMsg: 'Loading asset categories'})
            .then(function(response) {
                $scope.assetCategories = response.data;
            });

        $http.get('/Portfolio/ProductClasses/Simple', {cache: true, trackerMsg: 'Loading asset classes'})
            .then(function(response) {
                $scope.assetClass = response.data;
            });
        $http.get('/Portfolio/RiskCategories/Simple', {cache: true, trackerMsg: 'Loading risk categories'})
            .then(function(response) {
                $scope.riskCategory = response.data;
            });
    }

    $scope.platFormChange = function(value){
        $scope.current.selectedEntity.id = value;
    };

    $scope.levelChange = function( ){
        if($scope.current.entityLevel.isSecurityClassification) {
            $http.get('/Portfolio/SecurityClassification/Local/Methods/Simple?searchText=' + $scope.current.entityLevel.displayName, {cache: true, trackerMsg: 'Loading security classes'})
                .then(function(response) {
                    // security methods have unique names
                    const method = response.data.find(m => m.name === $scope.current.entityLevel.displayName);
                $http.get('/Portfolio/SecurityClassification/Local/SecurityClasses/Simple?securityClassificationMethodIds=' + method.id, {cache: true, trackerMsg: 'Loading security classes'})
                    .then(function(response) {
                        $scope.securityClasses = response.data;
                    });

            });
        }

        $scope.current.selectedEntity = null;
        loadLevel( );
    };

    $scope.$on("item-action", function(e, args){
        if (args.action === 'edit-indexes') {
           openBigMultiSelect(args.item);
        }

        if (args.action === 'delete-index') {
            deleteBenchmarkItem(args.item,false)
        }

    });

    $scope.addAssignment = function(){
        let id = ($scope.current.entityLevel.entity === 'Product') ? $scope.current.selectedEntity.productId : $scope.current.selectedEntity.id;

        $http.get('/Settings/EntityOptions/' + $scope.current.entityLevel.routeName + '/' + id + '/code/1:69BENCHM')
            .then(function (response) {
                openBigMultiSelect(response.data);
                $scope.current.selectedEntity = null;
            });
    };


   //PRIVATE METHODS
    function openBigMultiSelect(entityItem) {
        var originalEntityItem = angular.copy(entityItem);
        var entityType;
        var idProperty = "id";

        entityType = 35;
        idProperty = "key";

        var parameter = entityItem.value.replace(/\s/g, '').split(',');
        var selectedItems = [];
        for (var i = 0; i < parameter.length; i++) {
            var item = {};
            item[idProperty] = parameter[i];
            if(item.key != 0) selectedItems.push(item);
        }

        var executeDelete = function(skipConfirmation){
            deleteBenchmarkItem(entityItem, skipConfirmation);
        };

        $dialog.dialog({ templateUrl: "app/modals/available-select.html", controller: "AvailableSelectCtrl", dialogClass: 'modal wide', resolve: {availableSelectedArgs: function() { return {selectionType: entityType, selectedSelected: selectedItems, sortable: true}; }}})
            .open()
            .then(function(result) {
                if (result) {
                    entityItem.value = result.map(idProperty).join(',') || '0';
                    if(entityItem.entity != 'Owner' && entityItem.value == '0'){
                        $dialog.confirmAction("<span style='font-size: 14px;'>Trying to save an entity without a benchmark index will delete entity, continue? </span>" )
                            .open()
                            .then(function(result){
                                //
                                if (result === 'yes') {
                                    executeDelete(entityItem, true);
                                }
                                else{
                                    openBigMultiSelect(originalEntityItem)
                                }
                            });
                    }else{
                        if($scope.current.benchmarksInAccountHistory && result.length !=1){
                            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Unable to save", "The current benchmark setting does not allow more than 1 index per entity.").open();
                        }else{
                            executeSave(entityItem);
                        }
                    }

                }
            });
    }

    function executeSave (entityItem) {
        var verboseBenchmarkAssignments = [];
        verboseBenchmarkAssignments.push(entityItem);
        $http({method:'PUT',url:'/Settings/EntityOptions/' + $scope.current.entityLevel.routeName, data: verboseBenchmarkAssignments, trackerMsg: 'Updating benchmark assignment'})
            .then(function(response){
                loadLevel( );
            })
    }

    function initialLoad( ) {
        loadDropDowns();
        $scope.current.canAdd = $oasRights.canAdd("BENCHMARK") || $oasRights.canAdd("BENCHMARK_7") || $oasRights.canAdd("BENCHMARK_6") || $oasRights.canAdd("BENCHMARK_5") || $oasRights.canAdd("BENCHMARK_39");
        $scope.current.canUpdate = $oasRights.canUpdate("BENCHMARK") || $oasRights.canUpdate("BENCHMARK_7") || $oasRights.canUpdate("BENCHMARK_6") || $oasRights.canUpdate("BENCHMARK_5") || $oasRights.canUpdate("BENCHMARK_39");
        $scope.current.canDelete = $oasRights.canDelete("BENCHMARK") || $oasRights.canDelete("BENCHMARK_7") || $oasRights.canDelete("BENCHMARK_6") || $oasRights.canDelete("BENCHMARK_5") || $oasRights.canDelete("BENCHMARK_39");
        $scope.current.canRead = $oasRights.canRead("BENCHMARK") || $oasRights.canRead("BENCHMARK_7") || $oasRights.canRead("BENCHMARK_6") || $oasRights.canRead("BENCHMARK_5") || $oasRights.canRead("BENCHMARK_39");

        $http.get('/Settings/EntityOptions/List/Code/1:69BENCHM?canEdit=true', {trackerMsg:'Loading entity levels'})
            .then(function(response){
                var data = response.data;
                //remove the '(pull from database)' that's appended to risk category entity.  i.e 'Risk Category (pull from database)'
                //ng-switch-when on html is looking for 'Risk Category'
                var riskCategory = data.find({routeName: 'RiskCategories'});
                var database = data.find({entity: "Database"});
                if(riskCategory) riskCategory.entity = 'Risk Category';

                const groupingOptions = reportHelper.getAllGroupingOptions();

                const securityClassifications = groupingOptions.filter((option) => option.grouping.toLowerCase().startsWith('security classification')).map((option)=> {
                    return {
                        entity: option.grouping,
                        routeName: getEntityRouteName(option.value),
                        displayName: option.name,
                        isSecurityClassification: true,
                        entityEnumValue: option.value
                    }
                });

                data = data.filter(function(item){ return item.entity.toLowerCase() != 'security classification'; });

                data = data.concat(securityClassifications);

                cleanupEntityLevels( data );

                $scope.entityLevels = data;

                $scope.current.entityLevel = database ? data.find({entity: "Database"}) : data.find({sortOrder: 1});

                loadLevel( );
            });
        $http.get('/Settings/Database/EntityOptions/Code/2:69BENCHM', {trackerMsg:'Checking benchmark change history flag'})
                .then(function(response){
                    $scope.current.benchmarksInAccountHistory = (response.data.value == "True" ? true : false);
                });
    }

    function getEntityRouteName(entityEnumValue){
        switch(entityEnumValue){
            case 176: return 'SecurityClassification1';
            case 177: return 'SecurityClassification2';
            case 178: return 'SecurityClassification3';
            case 179: return 'SecurityClassification4';
            case 180: return 'SecurityClassification5';
            case 181: return 'SecurityClassification6';
            case 182: return 'SecurityClassification7';
            case 183: return 'SecurityClassification8';
            case 184: return 'SecurityClassification9';
            case 185: return 'SecurityClassification10';
            default: return '';}
    }

    function cleanupEntityLevels( entityLevels ) {
        // All this should be probably be done in the api.
        var i = 1;

        var e = entityLevels.find({entity: 'Database'});
        if( e ) { e.sortOrder = i++; }

        e = entityLevels.find({entity: entities.representative.name});
        if( e ) { e.sortOrder = i++; }

        e = entityLevels.find({entity:entities.managementStyle.name});
        if( e ) { e.sortOrder = i++; }

        e = entityLevels.find({entity: entities.model.name});
        if( e ) { e.sortOrder = i++; }

        e = entityLevels.find({entity: "Client"});
        if( e ) { e.sortOrder = i++; e.entity = entities.client.name; }

        e = entityLevels.find({entity: entities.registration.name});
        if( e ) { e.sortOrder = i++; }

        e = entityLevels.find({entity: entities.account.name});
        if( e ) { e.sortOrder = i++; }

        e = entityLevels.find({entity: entities.assetClass.name});
        if( e ) { e.sortOrder = i++; }

        e = entityLevels.find({entity: entities.assetCategory.name});
        if( e ) { e.sortOrder = i++; }

        e = entityLevels.find({entity: entities.riskCategory.name});
        if( e ) { e.sortOrder = i++; }

        entityLevels.filter((x) => x.isSecurityClassification).forEach(function(sc) {
            sc.sortOrder = i++;
        });


    }

    function deleteBenchmarkItem(item, skipConfirmation){
        //this executes only after http.delete is successful
        var executeResult = function(){
            if(item.entityName != 'Owner'){
                listSectionData.dataItems.remove(item);
                $scope.$broadcast(dataItemsEvent);
            }
        };


        if(skipConfirmation){
            $http.delete('/Settings/EntityOptions/' + $scope.current.entityLevel.routeName + '/' + item.entityId + '/code/1:69BENCHM' ,{trackerMsg:'Deleting index'} )
                .then(function(){
                    executeResult();
                });
        }else{
            $dialog.confirmAction("<span style='font-size: 14px;'>Delete Benchmark index for </span>" + "<span style='font-size: 14px;font-weight: bold'>" +  item.entityName + "?</span>")
                .open()
                .then(function(result){
                    if (result === 'yes') {
                        $http.delete('/Settings/EntityOptions/' + $scope.current.entityLevel.routeName + '/' + item.entityId + '/code/1:69BENCHM',{trackerMsg:'Deleting index'})
                            .then(function(){
                                executeResult();
                        });
                    }
                });
        }
    }

    function loadLevel( ){
        //called after list is populated
        var updateList = function(){
            benchmarkAssignments.forEach(function(item){
                item.indexCount = item.value == 0 ? 0 : item.value.split(',').length;
                item.canUpdate = $scope.current.canUpdate;
                item.canDelete = $scope.current.canDelete;
            });

            listSectionData.dataItems =  benchmarkAssignments;
            $scope.$broadcast(dataItemsEvent);


        };

        listSectionData.dataItems = [];
        var benchmarkAssignments = [];

        $http.get('/Settings/EntityOptions/' + $scope.current.entityLevel.routeName + '/code/1:69BENCHM?showAssigned=true', {trackerMsg: 'Loading benchmark assignments'})
            .then(function (response) {
                var data = response.data;
                benchmarkAssignments = data;
                if(benchmarkAssignments.length == 0 && $scope.current.entityLevel.entity == 'Database'){
                    //Build up blank object

                   var tempAssignment = {
                       entity: "Owner",
                       entityId: 0,
                       entityName: "Database",
                       userDefineDefinitionId: data.userDefineDefinitionId,
                       userDefineDataId: data.userDefineDataId,
                       name: "Benchmarks",
                       category: "Benchmark Indexes",
                       type: 12,
                       customObject: "OAS.Controls.CustomControls.UITickerSelection, OAS.UI",
                       code: "1:69BENCHM",
                       value: "0",
                       options: null
                   };
                   benchmarkAssignments.push(tempAssignment);
                }
                updateList( );
            });
    }


    //PUBLIC METHODS
    $scope.current = {entityLevel: null, showFilterRow : true, canDelete: false, canUpdate: false, canAdd: false, benchmarksInAccountHistory: false};
    $scope.rights = $oasRights.forCode("BENCHMARK");

    initialLoad();
});


app.controller('BlendedBenchmarkListCtrl', function BlendedBenchmarkListCtrl($scope, $http, $oasRights, $dialog, views) {
    //PRIVATE VARIABLES

    //PRIVATE METHODS

    //PUBLIC METHODS
    $scope.exportToExcel = function() {
        $scope.$broadcast('event:portfolio-benchmarks-action', {action: 'export-data'});
    };

    $scope.deleteBenchmark = function() {
        $dialog.confirmAction("Are you sure you want to delete this benchmark?")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $http.get('/Performance/AttributionDetails/Benchmark/' + $scope.selectedIds[0], {trackerMsg: 'Getting Attribution Details'})
                    .then(function(results) {
                        var data = results?.data ?? [];

                        if (data.length !== 0) {
                            $dialog.actionFailed(`Unable to delete benchmark due to being used in attribution detail(s): ${data.join(", ")}`)
                            .open();
                            return;
                        }
    
                        $http.delete('/Portfolio/IndexBlends/' + $scope.selectedIds[0], {trackerMsg: 'Deleting blended benchmark'})
                            .then(function() {
                                $scope.$broadcast('event:portfolio-benchmarks-action', {action: 'refresh-grid'});
                            });
                    });
                }
            });
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            location.href = '#/portfolio/blendedbenchmarks/' + $scope.selectedIds[0];
    };

    //INITIALIZE
    $scope.rights = $oasRights.forCode("INDEXBLEND");
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {
        view : views[0], gridDoubleClick: $scope.slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            location.href = '#/portfolio/blendedbenchmarks/' + $scope.selectedIds[0];
    }}];
});
'use strict'

app.controller('BlendedBenchmarkCtrl', function BlendedBenchmarkCtrl($scope, $http, $oasRights, $routeParams, $location, $dialog) {
    // PRIVATE VARIABLES
    var indexBlendId = $routeParams.id;
    var copyIndexBlendId = $routeParams.c;

    //PRIVATE METHODS
    function initialize() {
        $http.get('/Settings/EntityOptions/Database/0/Code/RebalanceInterval', {trackerMsg:'Loading interval options'})
            .then(function (response){
                $scope.interval = response.data;
                if(indexBlendId > 0 || copyIndexBlendId) {
                    var loadId = copyIndexBlendId ? copyIndexBlendId : indexBlendId;
                    $http.get('/Portfolio/IndexBlends/' + loadId, {trackerMsg: 'Loading blended benchmark'})
                        .then(function(response){
                            $scope.indexBlend = response.data;
                            loadProducts();
                            if(copyIndexBlendId) {
                                $scope.indexBlend.id = 0;
                                $scope.indexBlend.interval = null;
                                $scope.indexBlend.name = "Copy of " + $scope.indexBlend.name;
                                $scope.indexBlend.entityOptions = [{ entity: "Index/Blend", code: "RebalanceInterval", value: $scope.indexBlend.entityOptions[0].value }];
                                $scope.indexBlend.createdBy = null;
                                $scope.indexBlend.createdDate = null;
                                $scope.indexBlend.editedBy = null;
                                $scope.indexBlend.editedDate = null;
                            }
                            $scope.addBreadcrumb($scope.indexBlend.name, ('/portfolio/blendedbenchmarks/' + $scope.indexBlend.id));
                            return $http.get('/Portfolio/IndexBlends/' + loadId + '/DateRanges', {trackerMsg: 'Loading date ranges'});
                        })
                        .then(function(response){
                            $scope.dateRanges = response.data.sortBy(function(n) {return Date.create(n.key); });
                            $scope.dateRanges.each(function(dr){ addProductFiller(dr.key); });
                        });
                }
                else {
                    $scope.indexBlend = {
                        id: 0,
                        interval: null,
                        name: "New Benchmark",
                        timeFrames: [{asOfDate: "1900-01-01", allocations: []}],
                        entityOptions: [{ entity: "Index/Blend", code: "RebalanceInterval", value: "Daily" }],
                        dynamicType: $scope.dynamicTypes[0].value,
                        dynamicDetails: []
                    };
                    loadProducts();
                    $scope.dateRanges = [{key:"01/01/1900", value: "Inception - Today"}];
                    $scope.dateRanges.each(function(dr){ addProductFiller(dr.key); });

                    $scope.addBreadcrumb($scope.indexBlend.name, '/portfolio/blendedbenchmarks/0');
                }
            });

        $http.get("/Portfolio/Representatives/Simple", {cache: true, trackerMsg: 'Loading representatives'})
            .then(function (response) {
                $scope.reps = response.data;
                $scope.current.selectedRep = response.data[0];
            });
    }

    function updateDateRanges(asOfDate) {
        var aod = Date.create(asOfDate);
        var nextIndex = $scope.dateRanges.findIndex(function(n) { return Date.create(n.key).isAfter(aod) });
        var priorIndex = ((nextIndex === - 1) ? $scope.dateRanges.length : nextIndex) - 1;
        if(priorIndex === -1) {
            $scope.dateRanges.add({key:"01/01/1900", value: "Inception - " + aod.clone().addDays(-1).format('{MM}/{dd}/{yyyy}')});
            $scope.dateRanges.add({key:aod.format('{MM}/{dd}/{yyyy}'), value: aod.format('{MM}/{dd}/{yyyy}') + " - Today"});
        }
        else {
            var priorFromDate = $scope.dateRanges[priorIndex].value.split('-')[0].trim();
            $scope.dateRanges[priorIndex].value = priorFromDate + " - " + aod.clone().addDays(-1).format('{MM}/{dd}/{yyyy}');
            if(nextIndex === -1) {
                $scope.dateRanges.add({key:aod.format('{MM}/{dd}/{yyyy}'), value: aod.format('{MM}/{dd}/{yyyy}') + " - Today"});
            }
            else {
                var nextFromDate = $scope.dateRanges[nextIndex].key;
                $scope.dateRanges.add({key:aod.format('{MM}/{dd}/{yyyy}'), value: aod.format('{MM}/{dd}/{yyyy}') + " - " + Date.create(nextFromDate).addDays(-1).format('{MM}/{dd}/{yyyy}')});
            }
        }
        $scope.dateRanges = $scope.dateRanges.sortBy(function(n) {return Date.create(n.key); });
    }

    function loadProducts() {
        $scope.products = $scope.indexBlend.timeFrames.map(function(n){
            var allocations = angular.copy(n.allocations);
            allocations.each(function(a){
                a.key = Date.create(n.asOfDate).format('{MM}/{dd}/{yyyy}');
            });
            return allocations;
        }).flatten().groupBy("productId");
    }

    function addProductFiller(selectedKey) {
        var keys = Object.keys($scope.products);
        if(keys.length > 0) {
            keys.each(function (productId) {
                if ($scope.products[productId].none(function (a) { return a.key === selectedKey; })) {
                    $scope.products[productId].push({
                        id: 0,
                        key: selectedKey,
                        productId: productId,
                        productName: $scope.products[productId][0].productName,
                        ticker: $scope.products[productId][0].ticker,
                        weight: 0
                    });
                }
            });
        }
    }

    function updateTimeframeAllocations(removeZeroAlloc) {
        var keys = Object.keys($scope.products);
        keys.each(function (productId) {
            $scope.products[productId].each(function(item){
                var timeframe = $scope.indexBlend.timeFrames.find(function(n){return Date.create(n.asOfDate).format('{MM}/{dd}/{yyyy}') === item.key;})
                var allocation = timeframe.allocations.find({productId: item.productId});
                if(!allocation) {
                    allocation = {id:item.id, productId:item.productId, productName:item.productName, ticker:item.ticker, weight:item.weight};
                    timeframe.allocations.push(allocation);
                }
                else
                    allocation.weight = item.weight;
                if(allocation.weight === 0 && removeZeroAlloc)
                    timeframe.allocations.remove(allocation);
            });
        });
    }

    function processDeletedDateRanges(asOfDate) {
        var aod = Date.create(asOfDate);
        var selectIndex = $scope.dateRanges.findIndex(function(n) { return Date.create(n.key).is(aod) });
        var priorDateKey = $scope.dateRanges[selectIndex-1].key;
        var startPeriod = (priorDateKey === "01/01/1900") ? "Inception" : priorDateKey;
        if(selectIndex === ($scope.dateRanges.length - 1)) {
            $scope.dateRanges[selectIndex-1].value = startPeriod + " - Today";
        }
        else {
            var nextDateKey = $scope.dateRanges[selectIndex+1].key;
            $scope.dateRanges[selectIndex-1].value = startPeriod + " - " + Date.create(nextDateKey).addDays(-1).format('{MM}/{dd}/{yyyy}');
        }
        $scope.dateRanges.remove($scope.dateRanges[selectIndex]);
    }

    function processDeletedProducts(key) {
        Object.keys($scope.products).each(function(productId){
            $scope.products[productId].remove(function(n){
                return Date.create(n.key).is(Date.create(key));
            });
            if ($scope.products[productId].length === 0)
                delete $scope.products[productId];
        });
    }

    //PUBLIC METHODS
    $scope.saveBenchmark = function(closeScreen) {
        updateTimeframeAllocations(true);
        var validWeights = $scope.indexBlend.timeFrames.every(function(n){
            return n.allocations.sum('weight').almostEquals(100);
        });
        if($scope.indexBlend.dynamicType !== 'None' || validWeights) {
            var args = parseInt(indexBlendId) > 0 ? {method: "PUT", id: indexBlendId, trackerMsg: "Saving blended benchmark"} : {method: "POST", id: "", trackerMsg: "Adding new blended benchmark"};

            if($scope.indexBlend.dynamicType !== 'None'){
                $scope.indexBlend.timeFrames = [];
            }

            $http( { method: args.method, url: '/Portfolio/IndexBlends/' + args.id, data: $scope.indexBlend, trackerMsg: args.trackerMsg } )
                .then(function(response){
                    if(!closeScreen) {
                        $scope.indexBlend = response.data;
                        if($scope.indexBlend.dynamicType === 'None'){
                            loadProducts();
                            $scope.dateRanges.each(function(dr){ addProductFiller(dr.key); });
                        }
                        if(parseInt(indexBlendId) === 0)
                            indexBlendId = response.data.id;
                    }
                    else
                        $location.path( '/portfolio/blendedbenchmarks' );
                });
        }
        else {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Weight Totals", '<ul class="unstyled"><li>Weight total for all timeframes must equal 100%</li></ul>').open();
        }
    };

    $scope.deleteBenchmark = function() {
        $dialog.confirmAction("Are you sure you want to delete benchmark " + $scope.indexBlend.name + "?")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $http.delete('/Portfolio/IndexBlends/' + indexBlendId, {trackerMsg: 'Deleting blended benchmark'})
                        .then(function() {
                            $location.path('/portfolio/blendedbenchmarks');
                        });
                }
            });
    };

    $scope.addIndex = function() {
        var allocation = $scope.current.selectedProduct;
        allocation.id = 0;
        allocation.weight = 0;
        updateTimeframeAllocations(false);
        $scope.indexBlend.timeFrames.each(function(n){
            if(n.allocations.none(function(a){ return a.productId === allocation.productId; }))
                n.allocations.push(angular.copy(allocation));
        });
        loadProducts();
        $scope.current.selectedProduct = null;
    };

    $scope.removeIndex = function(product) {
        $dialog.confirmAction("Are you sure you want to delete index " + product[0].productName + "?")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    updateTimeframeAllocations(false);
                    $scope.indexBlend.timeFrames.each(function(n){
                        var allocation = n.allocations.find(function(a){ return a.productId === product[0].productId; });
                        n.allocations.remove(allocation);
                    });
                    loadProducts();
                }
            });
    };

    $scope.deleteBenchmarkDate = function(selectedKey) {
        var key = selectedKey;
        $dialog.confirmAction("Are you sure you want to delete this period?")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $scope.indexBlend.timeFrames.remove(function(n){
                        return Date.create(n.asOfDate).is(Date.create(key));
                    });
                    processDeletedDateRanges(key);
                    processDeletedProducts(key);
                }
            });
    };

    $scope.copyBenchmarkIndexes = function(selectedKey) {
        var timeFrame = $scope.indexBlend.timeFrames.find(function(n){return Date.create(n.asOfDate).format('{MM}/{dd}/{yyyy}') === selectedKey;});
        var dialogOpts = {
            templateUrl : "benchmark-index-copy-date.html",
            controller : "BenchmarkIndexCopyDateCtrl"
        };

        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function(rslt){
                if (rslt){
                    var copy = angular.copy(timeFrame);
                    copy.asOfDate = Date.create(rslt).format('{yyyy}-{MM}-{dd}');
                    copy.allocations.each(function(n) { n.id = 0; });
                    delete copy.id;
                    $scope.indexBlend.timeFrames.push(copy);
                    updateDateRanges(rslt);
                    loadProducts();
                    $scope.dateRanges.each(function(dr){ addProductFiller(dr.key); });
                }
            });
    };

    $scope.getTimeFrame = function(selectedKey) {
        return $scope.indexBlend.timeFrames.find({asOfDate: Date.create(selectedKey).format('{yyyy}-{MM}-{dd}')});
    };

    $scope.getTotalWeight = function(selectedKey) {
        var totals = 0;
        var decimalPlaces = 0;
        var keys = Object.keys($scope.products);
        keys.each(function(productId){
            var weight = $scope.products[productId].find({key:selectedKey}).weight;
            var places = weight.toString().from(weight.toString().lastIndexOf('.')+1).length;
            if(places > decimalPlaces)
                decimalPlaces = places;
            totals += weight;
        });
        return totals.round(decimalPlaces);
    };

    $scope.addRepList = function() {
        $scope.indexBlend.representatives.push($scope.current.selectedRep);
        $scope.current.selectedRep = $scope.reps[0];
    };

    $scope.productAssigned = function() {
        $scope.disableDynamicType = true;
    };

    $scope.updateDynamicType = function() {
        if ($scope.indexBlend.id !== 0) return;

        $scope.indexBlend.dynamicDetails = [];
        var args = {url:'', msg:''};
        if ($scope.indexBlend.dynamicType === 'Asset Category') {
            args.url = '/Portfolio/ProductCategories/Simple';
            args.msg = 'Loading asset categories';
        } else if ($scope.indexBlend.dynamicType === 'Asset Class') {
            args.url = '/Portfolio/ProductClasses/Simple';
            args.msg = 'Loading asset classes';
        } else if ($scope.indexBlend.dynamicType === 'Management Style') {
            args.url = '/Portfolio/Platforms/Simple';
            args.msg = 'Loading management styles';
        } else if ($scope.indexBlend.dynamicType === 'Model Aggregate') {
            args.url = '/Trading/ModelAggs/Simple';
            args.msg = 'Loading model aggregates';
        } else if ($scope.indexBlend.dynamicType === 'Risk Category') {
            args.url = '/Portfolio/RiskCategories/Simple';
            args.msg = 'Loading risk categories';
        }

        $http.get(args.url, {trackerMsg: args.msg, cache: true})
            .then(function(response){
                $scope.indexBlend.dynamicDetails = response.data.map(function(val) {
                    return {
                        id: val.id,
                        name: val.name,
                        product: null
                    };
                });
            });
    };

    //INITIALIZE
    $scope.rights = $oasRights.forCode("INDEXBLEND");
    $scope.indexBlend = null;
    $scope.dateRanges = [];
    $scope.current = {selectedRep: null, selectedProduct: null, indexOnly: true};
    $scope.dynamicTypes = [
        { key: "None", value: "None" },
        { key: "Asset Category", value: "Asset Category" },
        { key: "Asset Class", value: "Asset Class" },
        { key: "Management Style", value: "Management Style" },
        { key: "Model Aggregate", value: "Model Aggregate" },
        { key: "Risk Category", value: "Risk Category" }
    ];
    $scope.assetCategories = null;
    $scope.assetClasses = null;
    $scope.disableDynamicType = false;

    initialize();
});

app.controller ('BenchmarkIndexCopyDateCtrl', function BenchmarkIndexCopyDateCtrl( $scope, $oasRights, dialog) {
    //PUBLIC METHODS
    $scope.process = function() {
        dialog.close($scope.current.startDate);
    };

    $scope.close = function() {
        dialog.close(null);
    };

    //INITIALIZE
    $scope.current = { startDate: Date.create().formatted() };
});
app.controller('ChangeAddressSyncCtrl', function ChangeAddressSyncCtrl($scope, $http, dialog, API_CONFIG, householdId) {

    $scope.isAuthenticated = true;
    //PUBLIC METHODS
    $scope.send = function () {
        $scope.schwabAddressError = null;
        if ($scope.SyncIntegration.Schwab) {
            $http.post('/Integrations/SchwabServiceRequest/' + householdId + '/UpdateAddress', null, { ignoreExceptions: true, trackerMsg: 'Sending new address to Schwab' })
                .then(function (response) {
                    if (response && (response.status == 200 || response.status == 201)) {
                        $scope.isAuthenticated = true;
                        window.open(API_CONFIG.baseUrl + '/Integrations/SchwabSII/SsoV2/19?&Authorization=' + sessionStorage.oas_token);
                    };
                    dialog.close();
                })
                .catch(function (error) {
                    if (error.status === 400) {
                        const data = error?.data;
                        if (data?.Message) {
                            $scope.schwabAddressError = data.Message;
                        } else if (data?.userException && data?.userException?.detail) {
                            $scope.schwabAddressError = data.userException.detail;
                        }
                    } else if (error.status === 500) {
                        $scope.isAuthenticated = false;
                    }
                })
        }
    };

    $scope.cancel = function () {
        dialog.close();
    };

});


'use strict';

app.controller('AssetEditCtrl', function AssetEditCtrl($scope, $http, $oasRights, $dialog, $portfolio, dialog, args, entities, assetStatus, costBasisMethods, excludeType, excludePercentOf, apps, $timeout, $q, splitIoService) {
    // region PRIVATE VARIABLES

    var assetGeneralOriginal,
        stepUpOriginal,
        bifurcateOriginal,
        historicalOriginal,
        billingGeneralOriginal,
        entityOptionsOriginal,
        customFieldsOriginal,
        assetId,
        editorHotKeys,
        excludeFromRebalanceOriginal,
        isManuallyManaged,
        unmanagedAssetsInclusionOriginal;

    $scope.canSave = true;

    //endregion

    //region PRIVATE METHODS
    // region INIT/RIGHT/MENU/TABS
    function init() {
        loadEnumLookUps();
        loadRights();
        buildMenu();
        loadHotKeys();
        showRevPayNoFeeAgg();
        $scope.loadTab(args.defaultTab);
        splitIoService.getBoolTreatment('opex_Margin_Billing_18617')
            .subscribe((isEnabled) => {
                $scope.marginBillingEnabled = isEnabled;
            });

        $http.get("/Settings/Database/EntityOptions/Code/BILLUSEFEHI", { trackerMsg: 'Checking Use Fee Hierarchy options' })
            .then(function (response) {
                $scope.current.entityUseFeeHierarchy = response.data.value === "True";
            });

        splitIoService.getBoolTreatment('opex_Exclude_Assets_by_Bill_Entity_on_editors_31734')
            .subscribe(function (isEnabled) {
                $scope.excludeByBillEntitySplitEnabled = isEnabled;
            });

        $scope.feeBillExclusionModes = [
            { value: 0, label: 'No' },
            { value: 1, label: 'Yes' },
            { value: 2, label: 'Select Bill Entities' }
        ];
        $scope.selectBillEntitiesModalOpen = false;
        $scope.billEntityExclusionListExpanded = false;
        $scope.billEntityPickerSource = null;
    }


    function loadRights() {
        $scope.rightsAsset = $oasRights.forCode("ASSETS");
        $scope.rightsTrans = $oasRights.forCode("TRANSACTIONS");
        $scope.rightsManuallyManaged = $oasRights.forCode('MANUALLYMANAGED');
        $scope.rightsEOs = $oasRights.forCode("ENTITYOPTION");
        $scope.rightsMoveAsset = $oasRights.forCode("MOVEASSET");
        $scope.rightsBilling = $oasRights.forCode("ACCTBILLING");
        $scope.rightsBillingException = $oasRights.forCode("BILLINGEXCEPTION");
        $scope.rightsIsStrategyOverride = $oasRights.forCode("ASSLEVELSTRATASSIGN");
        $scope.rightsNoFeeAggregate = $oasRights.forCode("NOFEEAGGREGATE");
        $scope.rightsActiveStatus = $oasRights.forCode("ACTIVESTATUS");
        $scope.rightsManagedStatus = $oasRights.forCode("MANAGEDSTATUS");
        $scope.rightsTrading = $oasRights.forCode("TRADEORDERMGMT");//find the actual trading right that I want to use
        $scope.rightsExcludeAssetFromRebalance = $oasRights.forCode("EXCLUDEASSETFROMREBALANCE");//find the actual trading right that I want to use
        $scope.rightsUnmanagedAssetsInclusion = $oasRights.forCode("UNMANAGEDASSETSINCLUSION");//Privilege just to allow reps access to entity option
        $scope.rightsOrionVision = $oasRights.forCode("ORIONVISION");
        $scope.rightsAssetPriceHistory = $oasRights.forCode("ASSETPRICEHISTORY");
        $scope.rightsLoaded = "True";
        $scope.assetUpdateDisabled = (!$scope.rightsAsset.canUpdate);
        $scope.rightsAccountAssetPriceHierarchy = $oasRights.forCode("ACCOUNTASSETPRICEHIERARCHY");
        $scope.rightsCustomFields = $oasRights.forCode("CUSTOMFIELDS");
    }

    //  Check if the global CShareClassExclusion entity option is true, and then if this is a C Share (c1,c2,c3)
    function CShareCheck() {
        $http.get("/Settings/Database/EntityOptions/Code/CSHAREEXCLUSION", { trackerMsg: 'Checking For C Share Exclusion' })
            .then(function (response) {
                $scope.current.cShareExclusionEO = response.data.value === "True";

                if (response.data.value === "True" &&
                    ($scope.current.product.shareClass.class === 'C'
                        || $scope.current.product.shareClass.class === 'C1'
                        || $scope.current.product.shareClass.class === 'C2')) {

                    $scope.current.cShareExclusion = true;
                }
            });
    }

    function buildMenu() {
        var i = 0;
        $scope.menu = { categories: [] };

        $scope.menu.categories.push({ name: 'Asset', children: [] });
        $scope.menu.categories[i].children.push({ name: 'General', active: false, code: 'assetGeneral' });
        if ($scope.rightsAssetPriceHistory.canRead) {
            $scope.menu.categories[i].children.push({ name: 'Price History', active: false, code: 'priceHistory' });
        }
        i++;

        $scope.menu.categories.push({ name: 'Cost Basis', children: [] });
        $scope.menu.categories[i].children.push({ name: 'Bifurcate Cost Basis', active: false, code: 'bifurcateCB' });
        $scope.menu.categories[i].children.push({ name: 'Historical Cost Basis', active: false, code: 'historicalCB' });
        $scope.menu.categories[i].children.push({ name: 'Step-Up Cost Basis', active: false, code: 'stepUpCB' });


        if ($scope.rightsBilling) {
            i++;
            $scope.menu.categories.push({ name: 'Billing', children: [] });
            $scope.menu.categories[i].children.push({ name: 'General', active: false, code: 'billingGeneral' });
        }
        if ($scope.user.authorization.entity == "Administrator" || $scope.user.authorization.entity == "Advisor") {
            var canLoadSettings = $scope.rightsCustomFields.canRead || ($scope.rightsEOs.canRead && !args.isNew);
            if (canLoadSettings) {
                i++;
                $scope.menu.categories.push({ name: 'Settings', children: [] });

                if ($scope.rightsCustomFields.canRead) {
                    $scope.menu.categories[i].children.push({ name: 'Custom Fields', active: false, code: 'customFields' });
                }
                if ($scope.rightsEOs.canRead && !args.isNew) {
                    $scope.menu.categories[i].children.push({ name: 'Options', active: false, code: 'entityOptions' });
                }
            }
        }
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                { combo: 'ALT+S', command: $scope.save },
                { combo: 'ALT+X', command: function () { $scope.close(true); } }
            ]);
        });
    }

    function loadDataForSelectedTab() {
        switch ($scope.current.selectedTab) {
            case "assetGeneral":
                loadAssetGeneral();
                break;
            case "priceHistory":
                loadAssetGeneral();
                checkHistoryDateRange();
                if ($scope.rightsAssetPriceHistory.canRead) {
                    loadAssetPriceHistory();
                }
                break;
            case "stepUpCB":
                if ($scope.rightsAsset.canRead) {
                    loadStepUp();
                }
                break;
            case "bifurcateCB":
                if ($scope.rightsAsset.canRead) {
                    loadBifurcate();
                }
                break;
            case "historicalCB":
                if ($scope.rightsAsset.canRead) {
                    loadHistorical();
                }
                break;
            case "billingGeneral":
                if ($scope.rightsAsset.canRead) {
                    loadAsset();
                    loadBillingGeneral();
                }
                break;
            case "entityOptions":
                if ($scope.rightsEOs.canRead) {
                    loadEntityOptions();
                }
                break;
            case "customFields":
                if ($scope.rightsCustomFields.canRead) {
                    loadCustomFields();
                }
                break;
        }
    }

    function checkHistoryDateRange(){
        if(!$scope.priceHistory) {
            $scope.priceHistory = {
                startDate:Date.create('today').addMonths(-3).beginningOfDay(),
                endDate:Date.create('today').beginningOfDay()
            }
        }
    }

    function loadEnumLookUps() {
        var list = {
            assetStatuses: assetStatus,
            costBasisMethods: costBasisMethods,
            excludeTypes: excludeType,
            excludePercentOfs: excludePercentOf
        };

        Object.each(list, function (key, value) {
            $scope[key] = $portfolio.enumToSimpleList(value);
        });
    }

    // endregion

    // region LOAD ASSET
    function loadDownloadSymbols(productId, resetValue) {
        $http.get("/Global/DownloadSymbols/Product/" + productId, { trackerMsg: 'Loading download symbols' })
            .then(function (response) {
                var data = response.data;
                $scope.downloadSymbols = data;

                if (resetValue && data && $scope.current.isReady) {
                    var ds = data.find({ symbol: resetValue });
                    if (ds) {
                        $scope.assetGeneral.downloadSymbol = ds.id;
                    }
                    if (!assetGeneralOriginal)
                        assetGeneralOriginal = angular.copy($scope.assetGeneral);
                } else {
                    if (!assetGeneralOriginal)
                        assetGeneralOriginal = angular.copy($scope.assetGeneral);
                }

                $scope.current.isReady = true;
            });
    }

    function loadAssetGeneral() {
        if ($scope.rightsAsset.canRead) {
            loadAsset();
        }
        if ($scope.user.authorization.entity === "Representative" && ($scope.rightsTrading.canUpdate || $scope.rightsExcludeAssetFromRebalance.canRead)) {
            loadExcludeFromRebalanceEntityOption();
        }
        if ($scope.user.authorization.entity === "Representative" && $scope.rightsUnmanagedAssetsInclusion.canRead) {
            loadUnmanagedAssetsInclusionEntityOption();
        }
    }

    function loadAsset() {
        if ($scope.assetGeneral) return;

        if (args.isNew) {
            $http.get("/Portfolio/Assets/Verbose/New", { trackerMsg: 'Loading asset' })
                .then(function (response) {
                    var data = response.data;
                    $scope.assetGeneral = data.portfolio;

                    // Get Household Accounts
                    if (args.extraInfo.fkClient && args.extraInfo.fkClient > 0) {
                        $http.get("/Portfolio/Clients/" + args.extraInfo.fkClient + "/Accounts", { trackerMsg: 'Loading household accounts' })
                            .then(function (response) {
                                response.data.forEach(function (acct) {
                                    acct.description = acct.id + ' - ' + acct.name + ', ' + acct.fundFamily;
                                });
                                $scope.current.accountList = response.data;
                                $scope.assetGeneral.accountId = args.extraInfo.fkAccount;
                                assetGeneralOriginal = angular.copy($scope.assetGeneral);
                                $scope.current.isReady = true;
                            });
                    } else {
                        assetGeneralOriginal = angular.copy($scope.assetGeneral);
                        $scope.current.isReady = true;
                    }

                    loadAllCustodians();
                });
        } else {
            $http.get("/Portfolio/Assets/Verbose/" + args.ids[0], { trackerMsg: 'Loading asset' })
                .then(function (response) {
                    var data = response.data;
                    assetId = data.id;
                    $scope.assetGeneral = data.portfolio;
                    $scope.isDataSharingEntity = data.isDataSharingEntity;
                    $scope.current.isBlankAcctCode = $scope.assetGeneral.accountNumber ? false : true;

                    if ($scope.user.authorization.entity == "Administrator" && $scope.assetGeneral.isAdvisorOnly) $scope.errors.push({ type: 'error', title: 'Advisor Only! ', msg: ' This asset is manually managed by the advisor only.', showAllowClose: false });

                    if (data.portfolio.status === 'Manually Managed' || data.portfolio.accountStatusId === 3 || data.portfolio.accountStatusId === 8) {
                        $scope.current.rightsManuallyManaged = $scope.rightsManuallyManaged;
                        $scope.assetUpdateDisabled = (!$scope.rightsAsset.canUpdate && !$scope.current.rightsManuallyManaged.canUpdate);
                        isManuallyManaged = true;
                    }

                    // Get Household Accounts
                    $http.get("/Portfolio/Clients/" + data.portfolio.clientId + "/Accounts", { trackerMsg: 'Loading household accounts' })
                        .then(function (response) {
                            var acctData = response.data;
                            acctData.forEach(function (acct) {
                                acct.description = acct.id + ' - ' + acct.name + ', ' + acct.fundFamily;
                            });
                            $scope.current.accountList = acctData;
                        });

                    // Load Product for Asset
                    if (data.portfolio.productId) {
                        $http.get("/Portfolio/Products/Simple/" + data.portfolio.productId, { trackerMsg: 'Loading asset product' })
                            .then(function (response) {
                                $scope.current.product = response.data;

                                $http.get("/Portfolio/Products/Verbose/" + data.portfolio.productId + '?expand=portfolio,billing', { trackerMsg: 'Loading product' })
                                    .then(function (resp) {
                                        $scope.current.isProductGloballyExcluded = resp.data.billing.feeExcluded;
                                        $scope.current.isProductCategoryExcluded = resp.data.portfolio.isRiskCategoryExcluded;
                                        var productExcludedIds = (resp.data.billing.feeBillExclusionMode === 2 && resp.data.billing.excludedBillEntityIds) || [];
                                        $scope.current.productExcludedBillEntityIds = productExcludedIds;
                                        if (productExcludedIds.length) {
                                            loadBillEntityPickerSource();
                                        }
                                    })
                            });
                    } else {
                        $scope.current.isReady = true;
                        assetGeneralOriginal = angular.copy($scope.assetGeneral);
                    }

                    // Check for asset exclusion at hh level
                    $http.get("/Portfolio/Assets/AssetExclusion/" + args.ids[0], { trackerMsg: "Loading household asset exclusion" })
                        .then(function (response) {
                            $scope.current.isFeeExcludedHouseholdAsset = response.data.isFeeExcludedHouseholdAsset;
                        });

                    loadAllCustodians(data.portfolio.custodianCommonIdList);
                });
        }
    }

    function loadAssetPriceHistory() {
        if ($scope.assetPriceHistory) return;
        let url = "/Portfolio/Assets/" + args.ids[0] + "/Prices/Historical" + "?startDate=" + $scope.priceHistory.startDate.formatted() + "&endDate=" + $scope.priceHistory.endDate.formatted();
        $http.get(url, { trackerMsg: "Loading historical asset prices" })
            .then(function (response) {
                $scope.assetPriceHistory = formatAssetPriceHistoryData(response.data);
                $scope.priceSourceList = response.data.map(item => item.priceSourceName).filter((val, idx, arr) => arr.indexOf(val) === idx);
            });
    }

    function formatAssetPriceHistoryData(data) {
        data.forEach(function (price) {
            price.requestedPriceDate = price.requestedPriceDate ? Date.create(price.requestedPriceDate.split('T')[0], { fromUTC: false }).format('{M}/{d}/{yyyy}') : '';
            price.priceDate = price.priceDate ? Date.create(price.priceDate.split('T')[0], { fromUTC: false }).format('{M}/{d}/{yyyy}') : '';
            price.navPrice = fixPriceDecimals(price.navPrice);
            price.cachedPrice = fixPriceDecimals(price.cachedPrice);
            price.pricesMatch = price.navPrice === price.cachedPrice;
        });
        return data;
    }

    function fixPriceDecimals(price) {
        var retPrice = price;
        if (price != null) {
            var priceParts = (price + '').split('.');
            if (priceParts.length > 1) {
                var decimal = priceParts[1];
                if (decimal.length < 2) {
                    retPrice = price.toFixed(2);
                } else if (decimal.length > 8) {
                    retPrice = price.toFixed(8);
                }
            } else {
                retPrice = price.toFixed(2);
            }
        }
        return retPrice;
    }

    function loadAllCustodians(priceHierarchy) {
        if ($scope.rightsAccountAssetPriceHierarchy.canRead) {
            $http.get('/Global/Custodians/Simple', { trackerMsg: 'Loading global custodians' })
                .then(function(response) {
                    if (response && response.data.length > 0) {
                        const custodians = response.data;
                        $scope.availableCustodiansLoaded = true;

                        if (priceHierarchy && priceHierarchy.length > 0) {
                            $scope.current.priceHierarchy = priceHierarchy.replace(/\s/g, '');
                            const ids = $scope.current.priceHierarchy.split(',').map(id => parseInt(id));
                            const availCustodianIds = custodians.map(c => parseInt(c.id));

                            $scope.selectedPriceHierarchyCustodians = ids
                                .filter(cu => availCustodianIds.includes(cu))
                                .map(fcu => ({ id: fcu }));
                        }
                        else {
                            $scope.selectedPriceHierarchyCustodians = [];
                            $scope.current.priceHierarchy = null;
                        }
                    }
                });
        }
    }
    $scope.openPriceHierarchySelect = function () {
        const tempSelectedItems = $scope.selectedPriceHierarchyCustodians.map(cu => ({ id: cu.id }));

        $dialog.dialog({
            templateUrl: 'app/modals/available-select.html',
            controller: 'AvailableSelectCtrl',
            resolve: {
                availableSelectedArgs: function () {
                    return {
                        sortable: true,
                        selectionType: 1980,
                        selectedSelected: tempSelectedItems,
                        disableSave: !$scope.rightsAccountAssetPriceHierarchy.canUpdate
                    };
                }
            }
        })
        .open()
        .then(function (result) {
            if (result) {
                $scope.selectedPriceHierarchyCustodians = result.map(r => ({ id: r.id }));
                $scope.current.priceHierarchy = result.map(r => r.id).join(',');
            }
        });
    };
    //endregion

    // region LOAD STEP-UP CB
    function loadStepUp() {
        if ($scope.stepUps) return;

        $http.get("/Portfolio/Assets/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=stepUps", { trackerMsg: 'Loading step-up cost basis' })
            .then(function (response) {
                $scope.stepUps = response.data.stepUps;
                stepUpOriginal = angular.copy($scope.stepUps);
            });
    }

    // endregion

    // region LOAD BIFURCATE CB
    function loadBifurcate() {
        if ($scope.bifurcates) return;

        $http.get("/Portfolio/Assets/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=bifurcates", { trackerMsg: 'Loading bifurcate cost basis' })
            .then(function (response) {
                $scope.bifurcates = response.data.bifurcates;
                bifurcateOriginal = angular.copy($scope.bifurcates);
            });
    }

    // endregion

    // region LOAD HISTORICAL CB
    function loadHistorical() {
        if ($scope.costBasisHistories) return;

        $http.get("/Portfolio/Assets/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=costBasisHistories", { trackerMsg: 'Loading historical cost basis' })
            .then(function (response) {
                $scope.costBasisHistories = response.data.costBasisHistories;
                historicalOriginal = angular.copy($scope.costBasisHistories);
            });
    }

    // endregion

    function refreshAccountUseFeeHierarchy(accountId) {
        var id = parseInt(accountId, 10);
        if (!id) {
            $scope.current.accountUseFeeHierarchy = false;
            return $q.resolve();
        }
        return $http.get("/Portfolio/Accounts/Verbose/" + id + "?expand=billing", { trackerMsg: 'Loading account billing for fee hierarchy' })
            .then(function (response) {
                var b = response.data && response.data.billing;
                $scope.current.accountUseFeeHierarchy = !!(b && b.useFeeHierarchy);
            })
            .catch(function () {
                $scope.current.accountUseFeeHierarchy = false;
            });
    }

    //region LOAD BILLING GENERAL
    function loadBillingGeneral() {
        if ($scope.billingGeneral) return;

        $http.get("/Portfolio/Assets/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=billing", { trackerMsg: 'Loading billing' })
            .then(function (response) {
                $scope.billingGeneral = response.data.billing;
                $scope.billingGeneral.excludedBillEntityIds = $scope.billingGeneral.excludedBillEntityIds || [];
                if ($scope.billingGeneral.feeBillExclusionMode === undefined || $scope.billingGeneral.feeBillExclusionMode === null) {
                    $scope.billingGeneral.feeBillExclusionMode = $scope.billingGeneral.isFeeExcluded ? 1 : 0;
                }
                billingGeneralOriginal = angular.copy($scope.billingGeneral);

                if (!args.isNew) {
                    loadPartialAssetExclusion(args.ids[0]);
                }

                refreshAccountUseFeeHierarchy($scope.assetGeneral && $scope.assetGeneral.accountId).then(function () {
                    if ($scope.current.entityUseFeeHierarchy && $scope.current.accountUseFeeHierarchy && $scope.excludeByBillEntitySplitEnabled && $scope.billingGeneral.feeBillExclusionMode === 2) {
                        loadBillEntityPickerSource();
                    }
                });

                CShareCheck();
                $scope.current.isReady = true;
            });
    }

    function loadBillEntityPickerSource() {
        if ($scope.billEntityPickerSource) {
            return $q.resolve();
        }
        return $http.get('/Billing/Entities/EntityList?isActive=true', { trackerMsg: 'Loading bill entities' })
            .then(function (resp) {
                $scope.billEntityPickerSource = (resp.data || []).map(function (e) {
                    return { id: e.id, name: e.name };
                });
            });
    }

    $scope.billEntityNameById = function (id) {
        var src = $scope.billEntityPickerSource;
        if (!src) {
            return id;
        }
        var found = src.find(function (x) { return x.id === id; });
        return found ? found.name : id;
    };

    $scope.onFeeExcludedCheckboxChange = function () {
        $scope.billingGeneral.feeBillExclusionMode = $scope.billingGeneral.isFeeExcluded ? 1 : 0;
        $scope.billingGeneral.excludedBillEntityIds = [];
    };

    $scope.onFeeBillExclusionDropdownChange = function () {
        if ($scope.billingGeneral.feeBillExclusionMode !== 2) {
            $scope.billingGeneral.excludedBillEntityIds = [];
            $scope.billEntityExclusionListExpanded = false;
        }
        $scope.billingGeneral.isFeeExcluded = ($scope.billingGeneral.feeBillExclusionMode === 1);
        if ($scope.billingGeneral.feeBillExclusionMode === 2) {
            loadBillEntityPickerSource();
        }
    };

    $scope.openSelectBillEntitiesModal = function () {
        loadBillEntityPickerSource().then(function () {
            $scope.selectBillEntitiesModalOpen = true;
        });
    };

    $scope.onBillEntitiesEdited = function (ids) {
        $scope.selectBillEntitiesModalOpen = false;
        if (ids !== null && ids !== undefined) {
            $scope.billingGeneral.excludedBillEntityIds = ids;
            $scope.billingGeneral.feeBillExclusionMode = 2;
            $scope.billingGeneral.isFeeExcluded = false;
            $scope.billEntityExclusionListExpanded = true;
        }
    };

    function loadPartialAssetExclusion(assetId) {
        $http.get("/Settings/EntityOptions/Asset/" + assetId + "/Code/69PARTIALA", { trackerMsg: 'Loading partial asset exclusion settings' })
            .then(function (response) {
                $scope.current.isMaxAmountBilled = response.data.value === 'Max Amount Billed' ? true : false;
            });
    }

    //endregion

    // region LOAD ENTITY OPTIONS
    function loadEntityOptions() {
        if ($scope.entityOptionsLoaded)
            return;

        $http.get("/Settings/EntityOptions/Assets/" + args.ids[0], { trackerMsg: 'Loading options' })
            .then(function (response) {
                var entityOptionsValue;

                if ($scope.entityOptions)
                    entityOptionsValue = $scope.entityOptions[$scope.indexOfRevPayNoFeeAgg()].value;

                $portfolio.cleanCustomFields(response.data);
                $scope.entityOptions = response.data;
                entityOptionsOriginal = angular.copy(response.data);

                if (entityOptionsValue)
                    $scope.entityOptions[$scope.indexOfRevPayNoFeeAgg()].value = entityOptionsValue;

                $scope.entityOptionsLoaded = true;
            });
    }

    function loadExcludeFromRebalanceEntityOption() {
        if ($scope.current.excludeFromRebalance) return;

        $http.get("/Settings/EntityOptions/Assets/" + args.ids[0] + "/Code/69EXCLUDEF", { trackerMsg: 'Loading Exclude From Rebalance Option' })
            .then(function (response) {
                $scope.current.excludeFromRebalance = response.data.value.toLowerCase() === 'true';
                excludeFromRebalanceOriginal = angular.copy(response.data.value.toLowerCase() === 'true');
            });
    }

    function loadUnmanagedAssetsInclusionEntityOption() {
        if ($scope.current.unmanagedAssetsInclusion.options) return;

        $http.get("/Settings/EntityOptions/Assets/" + args.ids[0] + "/Code/69UNMANAGE", { trackerMsg: 'Loading Unmanaged Assets Inclusion Option' })
            .then(function (response) {
                if (response.data.value) {
                    response.data.value = response.data.value.split(',');
                } else {
                    response.data.value = [];
                }
                $scope.current.unmanagedAssetsInclusion = response.data;
                unmanagedAssetsInclusionOriginal = angular.copy(response.data);

            });
    }

    //endregion

    // region LOAD CUSTOM FIELDS
    function loadCustomFields() {
        if ($scope.customFields) return;

        var url = args.isNew
            ? '/Settings/UserDefinedFields/Definitions/Asset'
            : '/Settings/UserDefinedFields/Assets/' + args.ids[0];

        $http.get(url, { trackerMsg: 'Loading custom fields' })
            .then(function (response) {
                var data = args.isNew
                    ? response.data.map(function (definition) { return $portfolio.makeCustomFieldFromDefinition(definition, "Asset"); })
                    : response.data;

                $portfolio.cleanCustomFields(data);
                $scope.customFields = data.sortBy("name");
                customFieldsOriginal = angular.copy($scope.customFields);
            });
    }

    //endregion

    //endregion

    // region PUBLIC METHODS
    // region LOAD/CLOSE
    $scope.loadTab = function (child) {
        $scope.menu.categories.each(function (c) {
            c.children.each(function (ch) {
                ch.active = ch.code == child.code;
            });
        });

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab();
    };

    function saveAsset() {
        // Regular save
        var verboseAsset = {};

        if ($scope.current.priceHierarchy !== null) {
            $scope.assetGeneral.custodianCommonIdList = $scope.current.priceHierarchy;
        }

        if ($scope.assetGeneral && !angular.equals(assetGeneralOriginal, $scope.assetGeneral)) verboseAsset["portfolio"] = $scope.assetGeneral;

        if ($scope.stepUps && !angular.equals(stepUpOriginal, $scope.stepUps)) verboseAsset["stepUps"] = $scope.stepUps;

        if ($scope.bifurcates && !angular.equals(bifurcateOriginal, $scope.bifurcates)) verboseAsset["bifurcates"] = $scope.bifurcates;

        if ($scope.costBasisHistories && !angular.equals(historicalOriginal, $scope.costBasisHistories)) verboseAsset["costBasisHistories"] = $scope.costBasisHistories;

        if ($scope.billingGeneral && !angular.equals(billingGeneralOriginal, $scope.billingGeneral)) {
            if (!$scope.billingGeneral.excludeAmountType) {
                $scope.billingGeneral.excludeAmountType = excludeType.Dollars.name;
            }
            if (!$scope.billingGeneral.excludePercentOf) {
                $scope.billingGeneral.excludePercentOf = excludePercentOf.Asset.name;
            }

            verboseAsset["billing"] = $scope.billingGeneral;
        }

        if ($scope.entityOptions && !angular.equals(entityOptionsOriginal, $scope.entityOptions)) verboseAsset["entityOptions"] = $portfolio.restoreEntityOptions($scope.entityOptions);

        if ($scope.customFields && !angular.equals(customFieldsOriginal, $scope.customFields)) {
            var udfs = $scope.customFields.findAll({ entity: entities.asset.name });
            if (udfs.length) verboseAsset["userDefinedFields"] = udfs;
        }

        verboseAsset["id"] = args.isNew ? 0 : args.ids[0];

        let assetPromises = { verbose: null, excludeFromRebalance: null, unmanagedAssetsInclusion: null };

        //if rep user, they can edit these entity options.
        if ($scope.user.authorization.entity === "Representative") {
            if (($scope.rightsTrading.canUpdate || $scope.rightsExcludeAssetFromRebalance.canUpdate) && !angular.equals(excludeFromRebalanceOriginal, $scope.current.excludeFromRebalance)) {
                assetPromises.excludeFromRebalance = $http.put('/Settings/EntityOptions/Asset/' + args.ids[0] + '/69EXCLUDEF/Value', { value: $scope.current.excludeFromRebalance ? 'true' : 'false' }, { trackerMsg: 'Saving "Exclude From Rebalance" option.' });
            }

            if ($scope.rightsUnmanagedAssetsInclusion.canUpdate && !angular.equals(unmanagedAssetsInclusionOriginal, $scope.current.unmanagedAssetsInclusion)) {
                assetPromises.unmanagedAssetsInclusion = $http.put('/Settings/EntityOptions/Asset/' + args.ids[0] + '/69UNMANAGE/Value', { value: $scope.current.unmanagedAssetsInclusion.value.length > 0 ? $scope.current.unmanagedAssetsInclusion.value.join(",") : '' }, { trackerMsg: 'Saving "Unmanaged Assets Inclusion" option.' });
            }
        }
        
        if ($scope.user.authorization.entity !== "Representative" || $scope.rightsManagedStatus.canUpdate) {
            var msg = args.isNew ? 'Adding ' : 'Saving ';
            var verb = args.isNew ? 'POST' : 'PUT';
            var urlSave = args.isNew ? '/Portfolio/Assets/Verbose/' : '/Portfolio/Assets/Verbose/' + args.ids[0];
            assetPromises.verbose = $http({ method: verb, url: urlSave, data: verboseAsset, trackerMsg: msg + 'asset' });
        }

        $q.all(assetPromises)
            .then(function (responses) {
                var assetId = responses.verbose ? responses.verbose.data.id : verboseAsset.id;
                if (responses.verbose && responses.verbose.data.id) {
                    $scope.current.assetId = responses.verbose.data.id;
                    args.ids[0] = responses.verbose.data.id;
                    args.isNew = false;
                }
                if ($scope.customFields) {
                    customFieldsOriginal = angular.copy($scope.customFields);
                }
                if ($scope.current.isFullPage) {
                    $dialog.saveSuccessful("Asset saved.").open();
                } else {
                    if (args.app) {
                        var retUrl = '';
                        if (args.app === apps.portfolioLists.name) {
                            retUrl = '/Portfolio/Assets/' + assetId;
                        }
                        else if (args.app === apps.billingAudit.name) {
                            retUrl = '/Billing/Assets/' + assetId;
                        }

                        $http.get(retUrl, { trackerMsg: 'Refreshing asset' })
                            .then(function (response) {
                                var retData = response.data;
                                if (args.isNew) {
                                    retData.isNew = true;
                                }
                                editorHotKeys.destroy();
                                dialog.close(retData);
                            });

                    } else {
                        editorHotKeys.destroy();
                        dialog.close(null);
                    }
                }
            }).catch(function () {
                $scope.isSaving = false;
            });
    }

    $scope.save = function () {
        if ($scope.assetGeneral && !$scope.assetGeneral.accountNumber && !$scope.current.isBlankAcctCode) {
            $scope.errors.push({ type: 'error', title: 'Blank Account Number! ', msg: ' The account number cannot be blank.', showAllowClose: false });
            return;
        }

        $scope.isSaving = true;
        splitIoService.getBoolTreatment("recon_datasharing_editwarningmessages_7285")
            .subscribe((isEnabled) => {

                if (args.isNew) {
                    $http.get('/PortfolioDataSync/DataSharing/Sources/EntityLink/IsActive?entityType=7&entityId= ' + $scope.assetGeneral.accountId, { trackerMsg: 'Checking Datasharing Status' })
                        .then((response) => {
                            $scope.isDataSharingEntity = response.data;
                            saveDataSharingWarningCheck(isEnabled);
                        });
                } else {
                    saveDataSharingWarningCheck(isEnabled);
                }

            });
    };

    function saveDataSharingWarningCheck(isDataSharingCheckEnabled) {
        if ($scope.isDataSharingEntity && isDataSharingCheckEnabled) {
            $dialog.confirmAction('Asset is a data sharing Asset. Changes are likely to be reverted by subsequent syncs.  Would you still like to proceed?')
                .open()
                .then((response) => {
                    if (response == 'yes') {
                        saveAssetWithMoveCheck();
                    } else {
                        $scope.isSaving = false;
                    }
                });
        }
        //else do legacy
        else {
            saveAssetWithMoveCheck();
        }
    }

    function saveAssetWithMoveCheck() {
        // Check to see if the account id is differ from the original then call move endpoint
        if (assetGeneralOriginal.accountId != $scope.assetGeneral.accountId && assetGeneralOriginal.accountId != 0 && !args.isNew) {
            $http.put('/Portfolio/Assets/' + args.ids[0] + '/Action/MoveToAccount/' + $scope.assetGeneral.accountId, { trackerMsg: 'Moving asset to different account' })
                .then(function () {
                    saveAsset();
                }).catch(function () {
                    $scope.isSaving = false;
                });
        } else {
            saveAsset();
        }
    }

    $scope.close = function (validate) {
        if (validate) {
            if (
                !angular.equals(assetGeneralOriginal, $scope.assetGeneral) ||
                !angular.equals(stepUpOriginal, $scope.stepUps) ||
                !angular.equals(bifurcateOriginal, $scope.bifurcates) ||
                !angular.equals(historicalOriginal, $scope.costBasisHistories) ||
                !angular.equals(billingGeneralOriginal, $scope.billingGeneral) ||
                !angular.equals(entityOptionsOriginal, $scope.entityOptions) ||
                ($scope.customFields && !angular.equals(customFieldsOriginal, $scope.customFields))
            ) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };
    //endregion

    //region GENERAL
    $scope.verifyNewNoFeeAggSelection = function (event) {
        if (event) {
            if (event.target.value && $scope.entityOptions[$scope.indexOfRevPayNoFeeAgg()].value) {
                $scope.canSave = false;
                $dialog.confirmAction("Selecting this option will change advisor's aggregation with this account’s value. " + " <b>" + 'Do you want to continue?' + "</b>")
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            //Hooray, it worked.
                        }
                        else {
                            $scope.entityOptions[$scope.indexOfRevPayNoFeeAgg()].value = entityOptionsOriginal[$scope.indexOfRevPayNoFeeAgg()].value;
                        }
                        $scope.canSave = true;
                    });
            }
        }
    }

    $scope.indexOfRevPayNoFeeAgg = function () {
        return $scope.entityOptions.findIndex(option => option.code == 'RevPayNoFeeAgg');
    }

    function showRevPayNoFeeAgg() {
        $http.get("/Settings/Database/EntityOptions/Code/RevPayBps")
            .then(function (response) {
                $scope.current.revenuePayoutBPS = response.data.value === 'True';

                if ($scope.current.revenuePayoutBPS)
                    loadRevPayNoFeeAggValue();
            });
    }

    function loadRevPayNoFeeAggValue() {
        if ($scope.entityOptionsLoaded)
            return;

        if (args.isNew) {
            var RevNoFeeAggDefaultValues = [{
                canEdit: true,
                category: "Billing",
                code: "RevPayNoFeeAgg",
                entity: "Account",
                input: "select",
                name: "Revenue Payout No Fee Aggregation",
                options: ["Default", "No Fee/No Pay", "Always Payout"],
                securityCode: null,
                sequence: 2,
                type: "List",
                value: "Default"
            }];
            $scope.entityOptions = RevNoFeeAggDefaultValues;
            entityOptionsOriginal = angular.copy($scope.entityOptions);
        }
        else {
            $http.get("/Settings/EntityOptions/asset/" + args.ids[0] + "/Code/RevPayNoFeeAgg")
                .then(function (response) {
                    var option = response.data;
                    $scope.entityOptions = [option];
                    entityOptionsOriginal = angular.copy($scope.entityOptions);
                });
        }
    }

    $scope.toggleAccountLookUp = function (isLookUpMode) {
        $scope.current.showAccountLookUp = isLookUpMode;
    };

    $scope.toggleBlankAccountNumber = function () {
        if ($scope.current.isBlankAcctCode && $scope.assetGeneral.accountNumber) {
            $dialog.confirmAction("Are you sure you want to clear the account number for this asset?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $scope.assetGeneral.accountNumber = "";
                    } else {
                        $scope.current.isBlankAcctCode = false;
                    }
                });
        }
    };

    $scope.openEditor = function () {
        var extraInfo = { fkClient: $scope.assetGeneral.clientId, fkAsset: args.ids[0], isManuallyManaged: isManuallyManaged };
        $portfolio.openEditor(entities.transaction.value, [], null, null, apps.portfolioLists.name, extraInfo);
    };

    $scope.sortRecords = function (field) {
        var sortField = $scope.getSortField(field);
        $scope.sort.desc = $scope.sort.field === sortField ? !$scope.sort.desc : false;
        $scope.sort.field = sortField;
    };

    $scope.getSortField = function (field) {
        var sortField = field;
        if (field === 'requestedPriceDate') {
            sortField = 'sortRequestedPriceDate';
        } else if (field === 'priceDate') {
            sortField = 'sortPriceDate';
        }
        return sortField;
    };

    $scope.sortRequestedPriceDate = function (price) {
        return Date.create(price.requestedPriceDate).getTime();
    };

    $scope.sortPriceDate = function (price) {
        return Date.create(price.priceDate).getTime();
    };

    //endregion

    // region STEP-UP CB
    $scope.addStepUp = function () {
        $scope.stepUps.push({
            id: 0,
            percent: 100,
            date: Date.create('today').formatted(),
            unitPrice: 0.00
        });
    };

    $scope.removeStepUp = function (stepup) {
        $dialog.confirmAction("Are you sure you want to remove this step-up cost basis record?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.stepUps.remove(stepup);
                }
            });
    };
    //endregion

    // region BIFURCATE CB
    $scope.addBifurcate = function () {
        $scope.bifurcates.push({
            id: 0,
            startDate: Date.create('today').formatted(),
            method: 0
        });

    };

    $scope.removeBifurcate = function (bi) {
        $dialog.confirmAction("Are you sure you want to remove this bifurcate record?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.bifurcates.remove(bi);
                }
            });
    };

    // endregion

    // region HISTORICAL CB
    $scope.addHistoricalCB = function () {
        $scope.costBasisHistories.push({
            id: 0,
            acquiredDate: null,
            sellDate: null,
            holdingPeriodDate: null,
            costAmount: 0,
            numberOfUnits: 0,
            method: "",
            proceedAmount: 0
        });
    };

    $scope.removeHistoricalCB = function (cb) {
        $dialog.confirmAction("Are you sure you want to remove this historical cost basis record?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.costBasisHistories.remove(cb);
                }
            });
    };

    $scope.refreshPriceHistory = function(){
        $scope.assetPriceHistory = "";
        loadAssetPriceHistory();
    };

    // endregion
    //endregion

    // region INITIALIZE
    $scope.current = {
        selectedTab: args.defaultTab,
        assetId: args.ids.length > 1 ? 0 : parseInt(args.ids[0]),
        canChangeNoFeeAggregate: $oasRights.canUpdate("NOFEEAGGREGATE"),
        showAccountLookUp: false,
        accountList: null,
        selectedRegistration: null,
        isBlankAcctCode: false,
        matrixReinvestDividends: null,
        matrixReinvestSTCapGains: null,
        matrixReinvestLTCapGains: null,
        product: null,
        isReady: false,
        isFullPage: false,
        isMaxAmountBilled: false,
        isProductGloballyExcluded: false,
        productExcludedBillEntityIds: [],
        excludeFromRebalance: null,
        rightsManuallyManaged: { canAdd: false, canDelete: false, canRead: false, canUpdate: false },
        unmanagedAssetsInclusion: { options: null, value: [], canEdit: true },
        revenuePayoutBPS: false,
        feeAggregateOptions: ["Default", "No Fee/No Pay", "Always Payout"],
        cShareExclusionEO: null,
        cShareExclusion: null,
        entityUseFeeHierarchy: false,
        accountUseFeeHierarchy: false
    };


    if (args.isFullPage) {
        $scope.current.isFullPage = args.isFullPage;
    }

    $scope.isSaving = false;
    $scope.columns = ['requestedPriceDate', 'priceSourceName', 'priceDate', 'navPrice', 'cachedPrice', 'pricesMatch'];
    $scope.filter = {};
    $scope.sort = { field: 'sortRequestedPriceDate', desc: false };
    $scope.priceSourceList = [];
    $scope.errors = [];

    $scope.marginBillingEnabled = false;
    $scope.customFields = null;

    init();
    // endregion

    //region WATCHES
    $scope.$watch('current.selectedAccount', function (newVal, oldVal) {
        if (newVal === oldVal || !newVal) return;

        var acct;

        if (!$scope.current.accountList) {
            $scope.current.accountList = [];
        } else {
            acct = $scope.current.accountList.find({ id: newVal.id });

            if (args.isNew && !acct) {

                args.extraInfo.fkClient = newVal.clientId;

                // Reload assetGeneral
                $scope.current.selectedTab = "assetGeneral";
                loadDataForSelectedTab();
                $scope.assetGeneral.accountId = newVal.id;
            } else {
                $scope.assetGeneral.accountId = acct.id;
            }
        }

        if (!acct) {
            $http.get("/Portfolio/Accounts/" + newVal.id, { trackerMsg: 'Loading account' })
                .then(function (response) {
                    var data = response.data;
                    data.description = data.id + ' - ' + data.name + ', ' + data.fundFamily;
                    $scope.current.accountList.push(data);
                    $scope.assetGeneral.accountId = data.id;
                    refreshAccountUseFeeHierarchy(data.id);
                });
        } else {
            $scope.assetGeneral.accountId = acct.id;
            refreshAccountUseFeeHierarchy(acct.id);
        }

        $scope.current.showAccountLookUp = false;
    });

    $scope.$watch(function () {
        return $scope.assetGeneral && $scope.assetGeneral.accountId;
    }, function (newVal, oldVal) {
        if (newVal === oldVal) {
            return;
        }
        refreshAccountUseFeeHierarchy(newVal);
    });

    $scope.$watch('current.product', function (newVal, oldVal) {
        if (newVal === oldVal || !newVal) return;

        $scope.assetGeneral.productId = newVal.productId;
        loadDownloadSymbols(newVal.productId, newVal.ticker);
    });

    //endregion
});

'use strict';

app.controller('AccountEditCtrl', function AccountEditCtrl($scope, $http, $q, $oasRights, $dialog, dialog, args, $location, $portfolio, entities, statementDeliveryMethod, additionalAnnualAmtType, billingStyle, billFrequency, cashflowFrequency, valuationMethod, apps, systematicTaxWithType, $timeout, $cacheFactory, API_CONFIG, splitIoService, targetAllocationSaveValidator) {
    //region PRIVATE VARIABLES
    const verbose = {},
        original = {},
        esgSecurities = {},
        changeHistoryToDelete = [];

    let feeSchedulePromise,
        changeHistoryOriginal,
        relatedHouseholdAccounts,
        editorHotKeys,
        canLoadLaserApp,
        feeSchedule = {},
        clientId = 0,
        excludepaybyaccountid = [],
        lastManagementStyleId = null;
    //endregion
    $scope.feeScheduleObj = {
        isFeeScheduleOpen: false,
        feeScheduleId: 0,
        feeScheduleType: '',
        gridEdit: false,
        action: 'edit'
    };
    $scope.payoutScheduleObj = {
        isPayoutScheduleOpen: false,
        payoutScheduleId: 0,
        action: 'edit'
    };
    $scope.assetFeeScheduleModal = {
        isOpen: false,
        schedules: []
    };
    splitIoService.getBoolTreatment('Reg_Level_Trade_Block').subscribe((isEnabled) => {
        $scope.tradeBlockSleevedAccountsFeatureFlag = isEnabled;
    });

    splitIoService.getBoolTreatment('TEXP_read_only_account_trade_block_12484').subscribe((isEnabled) => {
        $scope.multiTradeBlockFeatureFlag = isEnabled;
    });
    splitIoService.getBoolTreatment('opex_Account_link_23410').subscribe((isEnabled) => {
        $scope.availableAccountstoLink = isEnabled;
    });
    splitIoService.getBoolTreatment('opex_Billing_UseNewSecurityClass_19909').subscribe((isEnabled) => {
        $scope.useNewAssetFeeScheduleModal = isEnabled;
    });

   
    splitIoService.getBoolTreatment('oc_portfolioAudit_sharedTargetAllocation_31732').subscribe((isEnabled) => {
        $scope.useSharedTargetAllocationEditor = isEnabled;
    });
   

    //region PRIVATE METHODS
    function getBoolSettingValue(setting) {
        if (setting == null || setting.value == null) {
            return false;
        } else {
            return setting.value.toLocaleLowerCase() === "true";
        }

    }

    //region INIT/RIGHT/MENU/TABS
    function init() {
        checkBillingLockdown();
        if (!$oasRights.canRead("ACCOUNTS")) return;
        loadRights()
            .then(
                function () {
                    if ($scope.rightsAccountChange.canRead)
                        loadAllPaidbyAccounts();
                    //look up database level options
                    $http.get('/Settings/Database/EntityOptions?codeNames=69USEMODEL&codeNames=69FFSMAModel&codeNames=EnableLastReconDate&codeNames=69TRADEBLOCKSLEEVED')
                        .then(function (response) {
                            response.data.forEach((setting) => {
                                switch (setting.code) {
                                    case '69USEMODEL':
                                        $scope.current.useModelGroupNumbers = getBoolSettingValue(setting);
                                        break;
                                    case 'EnableLastReconDate':
                                        $scope.current.isLastReconDateEnabled = getBoolSettingValue(setting);
                                        if ($scope.current.isLastReconDateEnabled) {
                                            getLastBusinessDate();
                                        }
                                        break;
                                    case '69FFSMAModel':
                                        $scope.current.featureFlagSMAModel = getBoolSettingValue(setting);
                                        break;
                                    case '69TRADEBLOCKSLEEVED':
                                        $scope.current.tradeBlockSleevedAccounts = getBoolSettingValue(setting);
                                        break;
                                }
                            });

                            buildMenu();
                            loadEnumLookUps();
                            loadHotKeys();

                            $scope.menu.each(function (category) {
                                const menuItem = category.items.find({ code: args.defaultTab.code });
                                if (menuItem) {
                                    $scope.loadTab(menuItem);
                                    return false;
                                }
                            });

                            //get all the custody options available
                            $http.get('/Compliance/Disclose/AdvCustodyTypes', { cache: true, trackerMsg: 'Loading Custody Types', ignoreExceptions: true })
                                .then(function (response) {
                                    $scope.complianceCustodyTypes = response.data;
                                });
                        });
                });

        if (!dialog) {
            window.parent.postMessage("iframeload");
        }
    }

    $scope.verifyNewNoFeeAggSelection = function (event){
        if(event)
        {
            if (event.target.value && $scope.verbose.entityOptions[$scope.indexOfRevPayNoFeeAgg()].value){
                $scope.current.canSave = false;
                $dialog.confirmAction("Selecting this option will change advisor's aggregation with this account’s value. "+ " <b>" + 'Do you want to continue?' + "</b>")
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            //Hooray, it worked.
                        }
                        else
                        {
                            $scope.verbose.entityOptions[$scope.indexOfRevPayNoFeeAgg()].value = $scope.entityOptionsValue;
                        }
                        $scope.current.canSave = true;
                    });
            }
        }
    }

    $scope.indexOfRevPayNoFeeAgg = function() {
        if (verbose && verbose.entityOptions) {
            return verbose.entityOptions.findIndex(option => option.code == 'RevPayNoFeeAgg');
        } else {
            return -1;
        }
    }

    function loadRights() {
        $scope.rightsAccount = $oasRights.forCode("ACCOUNTS");
        $scope.rightsAssets = $oasRights.forCode("ASSETS");
        $scope.rightsNotes = $oasRights.forCode("NOTES");
        $scope.rightsDocuments = $oasRights.forCode("DOCUMENTS");
        $scope.rightsEOs = $oasRights.forCode("ENTITYOPTION");
        $scope.rightsCCView = $oasRights.forCode("CREDITCARDVIEWING");
        $scope.rightsSystematics = $oasRights.forCode("SYSTEMATICS");
        $scope.rightsBillAudit = $oasRights.forCode("BILLAUDIT");
        $scope.rightsAccountChange = $oasRights.forCode("ACCOUNTCHANGE");
        $scope.rightsMoveAccount = $oasRights.forCode("MOVEACCOUNT");
        $scope.rightsMA = $oasRights.forCode("MODELACCT");
        $scope.rightsAcctModelMaintenance = $oasRights.forCode("ACCTMODELMAINT");
        $scope.rightsBilling = $oasRights.forCode("ACCTBILLING");
        $scope.rightsNoFeeAggregate = $oasRights.forCode("NOFEEAGGREGATE");
        $scope.rightsBillingException = $oasRights.forCode("BILLINGEXCEPTION");
        $scope.rightsReferralSchedule = $oasRights.forCode("REFERRALSCHEDULE");
        $scope.rightsAllowAccountStatusChange = $oasRights.forCode("ACCTSTATUSCHG");
        $scope.rightsViewAssetFeeSchedules = $oasRights.forCode("ACCTFEEANDPAYOUTCBO");
        $scope.rightsBondTradingEnabled = $oasRights.forCode("ACCOUNTBONDTRADE");
        $scope.rightsTargetAllocation = $oasRights.forCode("TARGETALLOCATION");
        $scope.rightsSMA = $oasRights.forCode("SMA");
        $scope.rightsFutureCashFlows = $oasRights.forCode("FUTURECASHFLOWS");
        $scope.rightsGoals = $oasRights.forCode("GOALS");
        $scope.rightsGrowthRates = $oasRights.forCode("GROWTHRATES");
        $scope.rightsCreditCardInfo = $oasRights.forCode("CREDITCARDINFO");
        $scope.rightsFeeSchedule = $oasRights.forCode("FEESCHEDULES");
        $scope.rightsEclipseAdmin = $oasRights.forCode("ECLIPSEORIONADMIN");
        $scope.rightsEclipseTrading = $oasRights.forCode("ECLIPSETRADING");
        $scope.rightsActiveStatus = $oasRights.forCode("ACTIVESTATUS");
        $scope.rightsManagedStatus = $oasRights.forCode("MANAGEDSTATUS");
        $scope.rightsCustomFields = $oasRights.forCode("CUSTOMFIELDS");
        $scope.isAdminOrRia = ["Administrator", "Advisor"].any($scope.user.authorization.entity);
        $scope.rightsPlatform = $oasRights.forCode("MGMTSTYLES");
        $scope.rightsPortfolioBillingPayees = $oasRights.forCode("PORTFOLIOBILLINGPAYEES");
        $scope.rightsPortfolioBillingGeneralAccount = $oasRights.forCode("PORTFOLIOBILLINGGENERALACCOUNT");
        $scope.rightsPortfolioBillingRecurringAdjustments = $oasRights.forCode("PORTFOLIOBILLINGRECURRINGADJUSTMENTS");
        $scope.rightsAstroAssetRestrictions = $oasRights.forCode("ASTROASSETRESTRICTIONS");
        $scope.rightsAstroSectorIndustryConstraints = $oasRights.forCode("ASTROSECTORINDUSTRYCONSTRAINTS");
        $scope.rightsAstroEsgConstraints = $oasRights.forCode("ASTROESGCONSTRAINTS");
        $scope.rightsTransactionsManuallyManagedOnly = $oasRights.forCode("MANUALLYMANAGED");
        $scope.rightsTaxRates = $oasRights.forCode("TAXRATES");
        $scope.rightsRGHs = $oasRights.forCode("REPORTGROUPHOUSEHOLD");
        $scope.rightsAccountAssetPriceHierarchy = $oasRights.forCode("ACCOUNTASSETPRICEHIERARCHY");
        $scope.rightsPayoutSchedules = $oasRights.forCode('MASTERPAYOUTSCHEDULE');
        $scope.rightsBillAppFeePayout = $oasRights.forCode('BILLAPPFEEPAYOUT');

        const promises = [
            $http.get('/Integrations/LaserApp/Configuration/Test', {cache: true, trackerMsg: 'Loading LaserApp configuration', ignoreExceptions: true})
                .then(function () {
                    canLoadLaserApp = true;
                }, function () {
                    canLoadLaserApp = false;
                })
        ];

        if (!args.isNew) {
          promises.push(
            $http.get(`/Portfolio/Accounts/Verbose/${args.ids[0]}`, {
              cache: true,
              ignoreExceptions: true
            }).then(function (res) {
              $scope.isAstroEnabled = !!res.data.isAstroEnabled;
            })
          );
        }

        return $q.all(promises);
    }

    function loadAllPaidbyAccounts() {
        $http.get("/billing/Accounts/GetAllPaidbyBillAccounts", {trackerMsg: 'Loading all paidby accounts', ignoreExceptions: true})
            .then(function (response) {
                excludepaybyaccountid=response.data;
            })
    }

    function buildMenu() {
        const canLoadSettings = $scope.rightsCustomFields.canRead || ($scope.rightsEOs.canRead && !args.isNew);
        const canLoadProjections = $scope.rightsFutureCashFlows.canRead || $scope.rightsGoals.canRead || $scope.rightsGrowthRates.canRead;
        const canLoadBilling = $scope.rightsBilling.canRead || $scope.rightsPortfolioBillingPayees.canRead || $scope.rightsPortfolioBillingGeneralAccount.canRead || $scope.rightsPortfolioBillingRecurringAdjustments.canRead;
        const canLoadAstro = !args.isNew && $scope.isAstroEnabled;

        const menu = [
            {name: "Account", enabled: true, items: [
                    {name: 'General', code: 'accountGeneral', enabled: true, load: [loadAccountLookUps, loadAccount]},
                    {name: 'Change History', code: 'changeHistory', enabled: $scope.rightsAccountChange.canRead, load: [loadChangeHistory, loadCompositeMonthExclusions]},
                    {name: 'Model Assignment', code: 'modelAssignment', enabled: $scope.rightsAcctModelMaintenance.canRead, load: [loadAccount, loadModelAssignments, loadProductEquivalents, loadPermissibleAggregateModels]},
                    {name: 'Notes & Documents', code: 'notesAndDocuments', enabled: $scope.rightsNotes.canRead || $scope.rightsDocuments.canRead, load: [loadNotes, loadDocuments]},
                    {name: 'Systematics', code: 'systematics', enabled: $scope.rightsSystematics.canRead, load: [loadSystematics]},
                    {name: 'Compliance', code: 'compliance', enabled: true, load: [loadCompliance]},
                    {name: 'Target Allocation', code: 'targetAllocation', enabled: $scope.rightsTargetAllocation.canRead, load: [loadTargetAllocationsForTab]},
                    {name: 'Separately Managed', code: 'sma', enabled: $scope.rightsSMA.canRead, load: [loadSMA]},
                    {name: 'Bond Trade', code: 'bondTrade', enabled: $scope.rightsBondTradingEnabled.canRead, load: [loadBondTradingForAccount]},
                    {name: 'Astro Settings', code: 'astroRestrictions', enabled: canLoadAstro, load: [loadAstroAccount, loadTaxSchedule]},
                    {name: 'Tax Rates', code: 'taxRates', enabled: $scope.rightsTaxRates.canRead, load: [loadTaxRates]},
                    {name: 'Associated Households', code: 'additionalClients', enabled: $scope.rightsRGHs.canRead, load: []},
                ]},
            {name: "Billing", enabled: canLoadBilling, items: [
                    {name: 'General', code: 'billingGeneral', enabled: $scope.rightsBilling.canRead, load: [loadAccount, loadBillingGeneral, loadProductTypes, loadRelatedHouseholdAccounts]},
                    {name: 'Credit Card', code: 'creditCard', enabled: $scope.rightsCreditCardInfo.canRead, load: [loadBillingGeneral]},
                    {name: 'General Account', code: 'generalAccounts', enabled: $scope.rightsBilling.canRead || $scope.rightsPortfolioBillingGeneralAccount.canRead, load: [loadBillingGeneral,loadAdjustmentTypes, loadBillingEntities, loadGeneralAccounts]},
                    {name: 'Payees', code: 'payees', enabled: ($scope.rightsBilling.canRead || $scope.rightsPortfolioBillingPayees.canRead), load: [loadBillingEntities, loadPayeesLookUps, loadBillingGeneral]},
                    {name: 'Recurring Adjustments', code: 'recurringAdjustments', enabled: ($scope.rightsBilling.canRead || $scope.rightsPortfolioBillingRecurringAdjustments.canRead), load: [loadRecurringAdjustments, loadAdjustmentTypes, loadBillingEntities]},
                    {name: 'Referral Schedules', code: 'referralSchedules', enabled: $scope.rightsReferralSchedule.canRead, load: [loadReferralSchedules, loadReferralPayouts]}
                ]},
            {name: "Projections", enabled: canLoadProjections, items: [
                    {name: 'Future Cash Flows', code: 'futureCashFlows', enabled: false /*$scope.rightsFutureCashFlows.canRead*/, load: [loadFutureCashFlows]},
                    {name: 'Goals', code: 'goals', enabled: $scope.rightsGoals.canRead, load: [loadGoals]},
                    {name: 'Growth Rates', code: 'growthRates', enabled: $scope.rightsGrowthRates.canRead, load: [loadGrowthRates]}
                ]},
            {name: "Settings", enabled: canLoadSettings, items: [
                    {name: 'Custom Fields', code: 'customFields', enabled: $scope.rightsCustomFields.canRead, load: [loadCustomFields]},
                    {name: 'Options', code: 'entityOptions', enabled: $scope.rightsEOs.canRead && !args.isNew, load: [loadEntityOptions]}
                ]},
            {name: "Integrations", enabled: canLoadLaserApp, items: [
                    {name: 'LaserApp', code: 'laserApp', enabled: canLoadLaserApp, load: [loadLaserApp]}
                ]}

        ];

        menu.remove({enabled: false});
        menu.forEach(function (category) {
            category.items.remove({enabled: false});
        });
        if ( args.isNew){
            const accountMenu =  menu.find( m => m.name === 'Account');
            const index = accountMenu?.items.findIndex( item => item.name === 'Notes & Documents');
            if ( index >= 0){
                accountMenu.items.splice(index,1);
            }
        }


        $scope.menu = menu;
    }

    function loadEnumLookUps() {
        const list = {
            billStyles: billingStyle,
            billFrequencies: billFrequency,
            valuationMethods: valuationMethod,
            annualAmtTypes: additionalAnnualAmtType,
            cashflowFrequencies: cashflowFrequency
        };

        Object.each(list, function (key, value) {
            $scope[key] = $portfolio.enumToSimpleList(value);
        });
    }

    function expandVerbose(propertyName, data) {
        verbose[propertyName] = data;
        original[propertyName] = angular.copy(data);
    }

    $scope.onAccountAdditionalClientsChange = function (list) {
        verbose.additionalClients = list;
    };

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: function() { $scope.close(true); } }
            ]);
        });
    }
    //endregion

    // region LOAD ACCOUNT
    function loadAccount() {
        if (verbose.portfolio) return;

        if (args.isNew) {
            $http.get("/Portfolio/Accounts/Verbose/New", {trackerMsg: 'Loading account'})
                .then(function (response) {
                    const data = response.data;

                    expandVerbose("portfolio", data.portfolio);
                    lastManagementStyleId = verbose.portfolio.managementStyleId;

                    //this is for model assignment but needs to be loaded when account loads
                    loadSubAdvisorDetail();

                    loadCompliance();
                    loadAllCustodians();

                    if (args.extraInfo && args.extraInfo.fkClient) {
                        loadHHRegistrations(args.extraInfo.fkClient, args.extraInfo.fkRegistration);
                    }
                    if (!verbose.portfolio.isSleeveAccount && $scope.rightsEclipseTrading.canRead) {
                        loadEclipseFirms();
                    }
                });
        } else {
            $http.get("/Portfolio/Accounts/Verbose/" + args.ids[0] + "?expand=accountManagers,portfolio,suitability", {trackerMsg: 'Loading account'})
                .then(function (response) {
                    const data = response.data;
                    $scope.isDataSharingEntity = data.isDataSharingEntity;
                    expandVerbose("portfolio", data.portfolio);
                    lastManagementStyleId = verbose.portfolio.managementStyleId;

                    if ($scope.user.authorization.entity === "Administrator" && verbose.portfolio.accountStatusDescription === 'Manually Maintained Advisor Only') {
                        $scope.errors.push({
                            type: 'error',
                            title: 'Advisor Only! ',
                            msg: ' This account is manually managed by the advisor only.',
                            showAllowClose: false
                        });
                    }

                    expandVerbose("accountManagers", data.accountManagers);
                    expandVerbose("suitability", data.suitability);

                    $scope.current.accountNumber = data.number;

                    const lastPosDt = data.portfolio.lastPositionDate ? Date.create(data.portfolio.lastPositionDate.slice(0,10)): null;
                    const prevBusDt = $scope.current.lastBusinessDate;

                    if ($scope.current.isLastReconDateEnabled && data.portfolio.inBalance != null && lastPosDt != null) {
                        if (!data.portfolio.inBalance) {
                            const lastReconDt = (data.portfolio.lastReconciledEffectiveDate != null ? Date.create(data.portfolio.lastReconciledEffectiveDate.slice(0, 10)) : null);
                            if (lastReconDt && lastPosDt >= lastReconDt) {
                                $scope.current.inBalanceStatusIcon = 'fa-exclamation-triangle fa-lg';
                                $scope.current.inBalanceStatusHeader = 'Balance Changed';
                                $scope.current.inBalanceStatusBody = 'Account was reconciled into balance effective <b>' + lastReconDt.formatted() + '</b>, but the balance on the account has since changed';

                            } else {
                                $scope.current.inBalanceStatusIcon = 'fa-exclamation-triangle fa-lg';
                                $scope.current.inBalanceStatusHeader = 'Inaccurate Balance';
                                $scope.current.inBalanceStatusBody = 'This account is not in balance as of <b>' + lastPosDt.formatted() + '</b>';
                            }
                        } else if (lastPosDt < prevBusDt) {
                            $scope.current.inBalanceStatusIcon = 'fa-exclamation-triangle fa-lg';
                            $scope.current.inBalanceStatusHeader = 'Unconfirmed Balance';
                            $scope.current.inBalanceStatusBody = 'Current account balance has not been confirmed.  Last in balance as of <b>' + lastPosDt.formatted() + '</b>';
                        }
                    }

                    //this is for model assignment but needs to be loaded when account loads
                    loadSubAdvisorDetail();

                    loadCompliance();

                    clientId = data.portfolio.clientId;

                    // Load Accounts for this HH
                    loadAccountsInHousehold(clientId);
                    loadHHRegistrations(clientId, 0);
                    loadLinkedAccounts(data);
                    loadCustodianAccountStatusRestriction(data);
                    loadModelAssignments();
                    loadAllCustodians(data.portfolio.custodianCommonIdList);

                    if (!verbose.portfolio.isSleeveAccount && $scope.rightsEclipseTrading.canRead) {
                        loadEclipseFirms();
                    }
                });
        }
    }

    function getLastBusinessDate(){
        $http.get('/Utility/PreviousBusinessDay/v2')
            .then(function(response){
                if(response){
                    $scope.current.lastBusinessDate = Date.create(response.data);
                };
            } );
    }

    function loadEclipseFirms() {
        $http.get('/Integrations/Eclipse/Firms/ByAlClientId/' + $scope.user.authorization.alClientId, {trackerMsg: 'Loading Eclipse firms'})
            .then(function (response) {
                response.data.forEach(firm => {
                    if (firm.alClients && firm.alClients.length && firm.alClients[0].isDefaultEclipseFirm) {
                        $scope.current.defaultEclipseFirmName = firm.name;
                    }
                });
                $scope.eclipseFirmList = response.data;
            });
    }

    function loadAccountsInHousehold(clientId) {
        $http.get("/Portfolio/Clients/" + clientId + "/Accounts?isActive=true", {cache: true, trackerMsg: 'Loading accounts for current household'})
            .then(function (response) {
                const d = response.data;
                $scope.accountsInHH = d.remove({id: args.ids[0]});

                $scope.accountsInHH.forEach(function (item) {
                    item.name = item.id + ": " + item.number + ' (' + item.name + ')';
                });
            });
    }

    function loadAccountLookUps() {
        if ($scope.modelGroups) return;

        $http.get('/Portfolio/Accounts/GroupNumbers', {trackerMsg: 'Loading group numbers'})
            .then(function (response) {
                const data = response.data;
                data.remove({name: null}, {name: ''});
                $scope.modelGroups = data.map("name");
            });

        $http.get("/Settings/EntityOptions/Database/0/code/69USEAUTOA", {trackerMsg: 'Loading billing auto assign schedules'})
            .then(function (response) {
                $scope.current.useAutoAssignSchedules = response.data.value === "True";
            });
        $http.get("/Settings/EntityOptions/Database/0/code/69MULTITRADEBLOCK", { trackerMsg: 'Loading Entity Option' })
            .then(function (response) {
                $scope.multiTradeBlockFF = response.data.value === "True";
            });
    }

    function loadHHRegistrations(clientId, defaultRegistrationId) {
        if ($scope.current.hhRegistrations) return;

        $http.get("/Portfolio/Clients/" + clientId + "/Registrations", {trackerMsg: 'Loading household registrations'})
            .then(function (response) {
                const regsData = response.data;
                regsData.forEach(function (reg) {
                    reg.description = reg.id + ' - ' + reg.name + ', ' + reg.typeCode;
                });
                $scope.current.hhRegistrations = regsData;
                if (defaultRegistrationId) {
                    verbose.portfolio.registrationId = defaultRegistrationId;
                    original.portfolio = angular.copy(verbose.portfolio);
                }
            });
    }

    function loadLinkedAccounts(data) {
        let url = $scope.availableAccountstoLink ? "/Portfolio/Registrations/" + data.portfolio.registrationId + "/UnlinkedAccounts?accountId=" + data.id : "/Portfolio/Registrations/" + data.portfolio.registrationId + "/Accounts";        
        $http.get(url, {trackerMsg: 'Loading linked accounts in registration'})
            .then(function (response) {
                const acctData = response.data;
                acctData.remove({id: data.id});
                $scope.linkedAccountList = acctData;

                if (data.portfolio.accountHistoryId && acctData.none({id: data.portfolio.accountHistoryId})) {
                    $scope.current.isBadLinkedAccount = true;

                    $scope.errors.push({type: 'error', title: 'Invalid Linked Account! ', msg: "The linked account does not belong to the same registration.", showAllowClose: false});
                }
            });
    }

    function loadCustodianAccountStatusRestriction(account) {
        $http.get("/Settings/Database/EntityOptions/Code/69CUSTODIANACCTSTATUS", {cache: true, trackerMsg: 'Loading model settings'})
            .then(function (response) {
                $scope.current.restrictAccountStatus = response.data.value.split(',').some(function (id) {
                    return id.toNumber() === account.portfolio.custodianId;
                }) ? !$scope.rightsAllowAccountStatusChange.canUpdate : false;
            });
    }

    $scope.fixLinkedAccount = function () {
        $dialog.confirmAction("Do you want to remove the invalid linked account?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    verbose.portfolio.accountHistoryId = null;
                    $scope.current.isBadLinkedAccount = false;
                }
            });
    };

    function loadAllCustodians(priceHierarchy) {
        if ($scope.rightsAccountAssetPriceHierarchy.canRead) {

            $http.get('/Global/Custodians/Simple', { trackerMsg: 'Loading global custodians' })
                .then(function(response) {
                    if (response && response.data.length > 0) {
                        const custodians = response.data;
                        $scope.availableCustodiansLoaded = true;

                        if (priceHierarchy && priceHierarchy.length > 0) {
                            $scope.current.priceHierarchy = priceHierarchy.replace(/\s/g, '');
                            const ids = $scope.current.priceHierarchy.split(',').map(id => parseInt(id));
                            const availCustodianIds = custodians.map(c => parseInt(c.id));

                            $scope.selectedPriceHierarchyCustodians = ids
                                .filter(cu => availCustodianIds.includes(cu))
                                .map(fcu => ({ id: fcu }));
                        }
                        else {
                            $scope.selectedPriceHierarchyCustodians = [];
                            $scope.current.priceHierarchy = null;
                        }
                    }
                });
        }
    }

    $scope.openPriceHierarchySelect = function () {
        const tempSelectedItems = $scope.selectedPriceHierarchyCustodians.map(cu => ({ id: cu.id }));

        $dialog.dialog({
            templateUrl: 'app/modals/available-select.html',
            controller: 'AvailableSelectCtrl',
            resolve: {
                availableSelectedArgs: function () {
                    return {
                        sortable: true,
                        selectionType: 1980,
                        selectedSelected: tempSelectedItems,
                        disableSave: !$scope.rightsAccountAssetPriceHierarchy.canUpdate
                    };
                }
            }
        })
            .open()
            .then(function (result) {
                if (result) {
                    $scope.selectedPriceHierarchyCustodians = result.map(r => ({ id: r.id }));
                    $scope.current.priceHierarchy = result.map(r => r.id).join(',');
                }
            });
    };
    //endregion

    // region TARGET ALLOCATIONS
    function loadTargetAllocationsForTab() {
        if (!$scope.useSharedTargetAllocationEditor) {
            loadTargetAllocations();
        }
    }

    function loadTargetAllocations() {
        if (verbose.targetAllocations) return;

        loadTargetAllocationGroupings();

        $http.get("/Portfolio/Accounts/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=targetAllocations", {trackerMsg: 'Loading account target allocations'})
            .then(function (response) {
                const data = response.data;
                if (data.targetAllocations.length) {
                    getTargetAllocationGroupingValue(data.targetAllocations)
                        .then(function (responseGroupingOptions) {
                            loadGroupingOptions(responseGroupingOptions.data, data.targetAllocations);
                        });
                } else {
                    expandVerbose("targetAllocations", []);
                }
            });
    }

    function isUserDefinedFieldTargetAllocationType(groupingType) {
        return groupingType != null && String(groupingType).indexOf('udf:') === 0;
    }

    function getUserDefinedFieldDefinitionId(groupingType) {
        if (!isUserDefinedFieldTargetAllocationType(groupingType)) {
            return null;
        }

        return parseInt(String(groupingType).substring(4), 10);
    }

    function getTargetAllocationGroupingValue(targetAllocations) {
        const first = targetAllocations[0];
        const entityName = first.entity;

        if (first.userDefinedFieldDefinitionId) {
            $scope.current.targetAllocationType = 'udf:' + first.userDefinedFieldDefinitionId;
            return $http.get('/Portfolio/Clients/TargetAllocationUserDefinedFieldValues/Simple?fieldDefinitionId=' + first.userDefinedFieldDefinitionId, { trackerMsg: 'Loading custom field grouping values' });
        }

        if (entityName === 32 || entityName === '32') {
            return $http.get("/Portfolio/Clients/TargetAllocationGroupings", { trackerMsg: 'Loading target allocation groupings' })
                .then(function (response) {
                    $scope.targetAllocationGroupings = response.data;
                    return { data: [] };
                });
        }

        if (String(entityName).includes('Security Classification')) {
            $scope.current.targetAllocationType = entityName;
            return $http.get('/Portfolio/SecurityClassification/Local/SecurityClasses/Simple?entity=' + entityName, {cache: true, trackerMsg: 'Loading security classes'});
        }

        const entity = entities[entities.find({name: entityName})] || entities[entities.find({ value: String(entityName) })];
        $scope.current.targetAllocationType = entity?.value || entity?.name || entityName;

        if ($scope.current.targetAllocationType === entities.product.value || $scope.current.targetAllocationType === entities.product.name) {
            const ids = targetAllocations.map("entityId");
            return $http.post("/Portfolio/Products/List/Id", ids, {trackerMsg: 'Loading Product Grouping', allowCancellation: true});
        }

        return $http.get(entity.simpleUrl, {trackerMsg: 'Loading grouping information'});
    }

    function loadTargetAllocationGroupings() {
        if ($scope.targetAllocationGroupings) {
            return;
        }

        $http.get("/Portfolio/Clients/TargetAllocationGroupings", {trackerMsg:'Loading target allocation groupings'})
            .then(function (response) {
                $scope.targetAllocationGroupings = response.data;
            });
    }

    function loadGroupingOptions(groupingOptions, targetAllocations) {
        $scope.groupingOptions = groupingOptions;

        targetAllocations.forEach(function (item) {
            item.entityName = loadGroupingName(item.entityId, item.entity);
        });

        expandVerbose("targetAllocations", targetAllocations);
    }

    function loadGroupingName(entityId, entityName) {
        const entity = $scope.groupingOptions.find({id: entityId});
        if (entity) {
            if (entityName === entities.product.name)
                return entity.ticker + " (" + entity.productName + ")";
            else
                return entity.name;
        }
        else
            return "Unknown " + entityName;
    }

    $scope.loadGroupAllocation = function () {
        const simpleUrl = entities[entities.find({name: $scope.current.targetAllocationType})]?.simpleUrl;

        if (isUserDefinedFieldTargetAllocationType($scope.current.targetAllocationType)) {
            const definitionId = getUserDefinedFieldDefinitionId($scope.current.targetAllocationType);
            $http.get('/Portfolio/Clients/TargetAllocationUserDefinedFieldValues/Simple?fieldDefinitionId=' + definitionId, { trackerMsg: 'Loading custom field grouping values' })
                .then(function (response) {
                    $scope.groupingOptions = response.data;
                });
        } else if ($scope.current.targetAllocationType.includes('Security Classification')) {
            $http.get('/Portfolio/SecurityClassification/Local/SecurityClasses/Simple?entity=' + $scope.current.targetAllocationType, {cache: true, trackerMsg: 'Loading security classes'})
            .then(function (response) {
                $scope.groupingOptions = response.data;
            });
        } else if (!simpleUrl.isBlank()) {
            $http.get(simpleUrl, {trackerMsg: 'Loading grouping information'})
                .then(function (response) {
                    $scope.groupingOptions = response.data;
                });
        }

        if (verbose.targetAllocations && verbose.targetAllocations.length > 0) {
            const firstEntity = verbose.targetAllocations[0].entity;
            const currentType = $scope.current.targetAllocationType;
            const entityMatches = firstEntity === currentType
                || (isUserDefinedFieldTargetAllocationType(currentType) && (firstEntity === 32 || firstEntity === '32'));
            if (!entityMatches) {
                verbose.targetAllocations = [];
            }
        }
    };

    $scope.addTargetAllocation = function () {
        const savedEntity = isUserDefinedFieldTargetAllocationType($scope.current.targetAllocationType)
            ? 32
            : $scope.current.targetAllocationType;

        if ($scope.current.targetAllocationType !== entities.product.name && $scope.current.targetAllocationType !== entities.product.value) {
            $scope.current.selectedTargets.forEach(function (entityId) {
                if (verbose.targetAllocations.none({entityId: entityId})) {
                    verbose.targetAllocations.push({entity: savedEntity, entityId: entityId, entityName: loadGroupingName(entityId), weight: 0.0});
                }
            });
        } else if (verbose.targetAllocations.none({entityId: $scope.current.product.productId})) {
            verbose.targetAllocations.push({
                entity: savedEntity,
                entityId: $scope.current.product.productId,
                entityName: $scope.current.product.ticker + " (" + $scope.current.product.productName + ")",
                weight: 0.0
            });
        }
    };

    $scope.removeTargetAllocation = function (item) {
        verbose.targetAllocations.remove(item);
    };

    $scope.onAccountTargetAllocationLoaded = function (payload) {
        expandVerbose('targetAllocations', payload.allocations);
        $scope.current.targetAllocationType = payload.targetAllocationType;
    };

    //endregion

    //region LOAD SMA

    function loadSMA() {
        if (verbose.sma) return;

        $http.get("/Portfolio/Accounts/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=sma", {trackerMsg: 'Loading SMA information'})
            .then(function (response) {
                const data = response.data;
                if (!args.isNew) {
                    $http.get("/Portfolio/Assets?accountId=" + args.ids[0], {trackerMsg: 'Loading account assets'})
                        .then(function (response) {
                            $scope.accountAssets = response.data?.sort( ( left, right ) => left.name.localeCompare( right.name));
                        });
                }

                if (!data.sma.eclipseSMA) {
                    data.sma.eclipseSMA = "Follow Orion";
                }

                expandVerbose("sma", data.sma);
            });
    }
    //endregion

    //region TAX SCHEDULES

    $scope.currentYear = new Date().getFullYear();

    $scope.calculateMaxMultiYearCapGain = function () {
        $scope.taxScheduleMaxMultiYearCapGain = verbose.astroTaxSchedules.filter(function (n) {
            return n.year >= $scope.currentYear;
        }).sum(function (n) {
            return n.annualCapGain || 0;
        });
        $scope.checkAstroSettingsValidation();
    };

    $scope.canDeleteTaxSchedule = function (item) {
        const maxYear = verbose.astroTaxSchedules.max(function (n) {
            return n.year;
        });

        // can delete only the last item in the list
        return (item.year === maxYear.year);
    };

    $scope.removeTaxSchedule = function (item) {
        verbose.astroTaxSchedules.remove(item);
        $scope.calculateMaxMultiYearCapGain();
        $scope.calculateMaxAnnualCapGain();
    };

    $scope.addTaxScheduleYear = function () {
        let nextYear = $scope.currentYear;
    
        if (verbose.astroTaxSchedules && verbose.astroTaxSchedules.length > 0) {
            let latestTaxSchedule = verbose.astroTaxSchedules.max(function (n) {
                return n.year;
            });
            if (nextYear <= Number(latestTaxSchedule.year)) { 
                nextYear = Number(latestTaxSchedule.year) + 1; 
            }
        } else {
            expandVerbose('astroTaxSchedules', []);
        }
    
        verbose.astroTaxSchedules.push({
            year: nextYear, 
            annualCapGain: null, 
            q1Percent: null, 
            q2Percent: null, 
            q3Percent: null, 
            q4Percent: null, 
            isNew: true
        });
        $scope.calculateMaxMultiYearCapGain();
        $scope.calculateMaxAnnualCapGain();
    };

    $scope.currentAndFutureYearFilter = function (item) {
        return item.year >= $scope.currentYear;
    };

    $scope.showCalculatedMaxAnnualCapGainText = function () {
        const text = 'If you have a row for the Current Year in the Tax Schedule section below, this field will be calculated by the Cap Gain ($) times the Current Quarter\'s Percent and saved to Astro.';

        $dialog.messageBox('Calculated Max Annual Cap Gain', text).open();
    };

    $scope.calculateMaxAnnualCapGain = function() {
        if(!verbose.astroTaxSchedules){
            return;
        }

        var currentYearTaxSchedule =  verbose.astroTaxSchedules.filter(function (n) {
            return n.year === $scope.currentYear;
        })[0];

        if(currentYearTaxSchedule) {
            const d = new Date();
            var month = d.getMonth() + 1; //month is zero based
            var percent = 0.0;

            switch(month){
                case 1:
                case 2:
                case 3:
                    percent = currentYearTaxSchedule.q1Percent / 100;
                    break;
                case 4:
                case 5:
                case 6:
                    percent = currentYearTaxSchedule.q2Percent / 100;
                    break;
                case 7:
                case 8:
                case 9:
                    percent = currentYearTaxSchedule.q3Percent / 100;
                    break;
                default:
                    percent = currentYearTaxSchedule.q4Percent / 100;
                    break;
            }

            var calculatedMaxAnnualCapGainString = parseFloat(currentYearTaxSchedule.annualCapGain * percent).toFixed(2);

            //toFixed returns a string and angular wants a number for the input box;
            var calculatedMaxAnnualCapGain = parseFloat(calculatedMaxAnnualCapGainString);

            expandVerbose('calculatedMaxAnnualCapGain', calculatedMaxAnnualCapGain);

        } else {
            expandVerbose('calculatedMaxAnnualCapGain', null);
        }
        $timeout(function() {
            $scope.checkAstroSettingsValidation();
        });
    };

    function loadTaxSchedule() {
        if (verbose.astroTaxSchedules) return;

        $http.get("/Portfolio/Accounts/Verbose/" + args.ids[0] + "?expand=astroTaxSchedules", {trackerMsg: 'Loading tax schedule'})
            .then(function (response) {
                expandVerbose('astroTaxSchedules', response.data.astroTaxSchedules.sortBy('year'));
                $scope.calculateMaxMultiYearCapGain();
                $scope.calculateMaxAnnualCapGain();
            });
    }

    //endregion

    // region LOAD ASTRO

    function loadAstroAccount() {
        if (verbose.astroAccount) return;

        $http.get("/Portfolio/Accounts/Verbose/" + args.ids[0] + "?expand=astroAccount", {trackerMsg: 'Loading Astro account'})
            .then(function (response) {

                response.data.astroAccount.assets.map(function(asset){
                    asset.isChecked = false;
                    return asset;
                });
                response.data.astroAccount.assets = response.data.astroAccount.assets.sortBy('productName');

                response.data.astroAccount.sectors.map(function(sector){
                    sector.error = false;
                    sector.industries.map(function(ind){
                        ind.error = false;
                        return ind;
                    });
                    return sector;
                });

                response.data.astroAccount.sleeves.map(function(sleeve){
                    if (!sleeve.status) sleeve.status = 'Exists';
                    return sleeve;
                });
                response.data.astroAccount.sleeves = response.data.astroAccount.sleeves.sortBy('number');

                response.data.astroAccount.esgRestriction = response.data.astroAccount.esgRestriction.sortBy('name');

                expandVerbose('astroAccount', response.data.astroAccount);
                $scope.calculateMaxAnnualCapGain();
                $timeout(function() {
                    $scope.astroValidate = true;
                });
            });

    }


    $scope.addAstroAssetRestriction = function () {
        const allAssets = verbose.astroAccount.assets;
        const availableAssets = allAssets.findAll(function(asset){
            if (asset.assetId !== 0 && asset.restrictionType === 'None') return asset;
        });

        if (!availableAssets.length) {
            $dialog.actionFailed("There are no other assets available.").open();
            return;
        }

        $dialog.inputBox("Add Restriction", "Select Asset", availableAssets, {inputValue: availableAssets[0], nameProperty: 'productName'})
            .open()
            .then(function (result) {
                if (!result) return;

                result.restrictionType = "Do Not Buy";

                allAssets.remove(result);
                allAssets.unshift(result);
            });
    };

    $scope.adjustAstroAssetRestriction = function (asset, weightField, isAsset) {
        if(asset.restrictionType=== "Bring Weight Exactly To")
        {
            if (weightField === 'minPercentWeight') {
                asset.maxPercentWeight = asset.minPercentWeight;
            } else {
                asset.minPercentWeight = asset.maxPercentWeight;
            }
        }
        $scope.syncAssetItems(asset, isAsset);
        $timeout(function() {
            $scope.checkAstroSettingsValidation();
        });
    };

    function getActiveEsgSecurity(productId){
        if (!verbose.astroAccount || !verbose.astroAccount.esgRestriction){
            return null;
        }
        let match = null;
        verbose.astroAccount.esgRestriction.each(function(grp){
            if (match) return;
            if (grp.isExcluded && esgSecurities[grp.esgCategoryId]){
                let found = esgSecurities[grp.esgCategoryId].find({productId: productId});
                if (found) match = found;
            }
        });
        return match;
    }

    //Source for a security is ESG when it belongs to an active ESG category and its type matches
    //the ESG default; otherwise it is an investor-preference override.
    function resolveAstroSource(item){
        let esgSec = getActiveEsgSecurity(item.productId);
        return (esgSec && item.restrictionType === esgSec.restrictionType)
            ? 'ESG_Restrictions'
            : 'INVESTOR_PREFERENCES';
    }

    $scope.syncAssetItems = function (item, isAsset){
        item.source = resolveAstroSource(item);  //ESG when it matches the ESG default, else investor preference
        let items = [];
        verbose.astroAccount.assets.findAll(function (asset) {
            if (isAsset && asset.assetId !== 0 && asset.restrictionType !== 'None') {
                items.push(asset);
            }
            if (!isAsset && asset.assetId === 0 && asset.restrictionType !== 'None' ){
                items.push(asset);
            }
        });

        items.map(function(obj){
            if (obj.isChecked){
                obj.minPercentWeight = item.minPercentWeight;
                obj.maxPercentWeight = item.maxPercentWeight;
                obj.restrictionType = item.restrictionType;
                obj.source = resolveAstroSource(obj);
            }
            return obj;
        });

        $timeout(function() {
            $scope.checkAstroSettingsValidation();
        });
    };

    $scope.removeAstroRestriction = function (security, isAsset){
        let esgSec = getActiveEsgSecurity(security.productId);
        if (esgSec){
            security.restrictionType = esgSec.restrictionType;
            security.source = 'ESG_Restrictions';
        }
        else{
            security.restrictionType = 'None';
        }
        $timeout(function() {
            $scope.checkAstroSettingsValidation();
        });
    };

    $scope.addAstroSecurityRestriction = function () {
        $dialog.search('product', 'Add Security Restriction', null, "")
            .open()
            .then(function (result) {
                if (result){
                    if (verbose.astroAccount.assets.none({productId: result.productId})){
                        verbose.astroAccount.assets.push({
                            accountId: $scope.current.accountId,
                            assetId: 0,
                            maxPercentWeight: null,
                            minPercentWeight: null,
                            ticker: result.ticker,
                            productId: result.productId,
                            productName: result.productName,
                            restrictionType: "Do Not Buy"
                        });
                    }
                    else{
                        let asset = verbose.astroAccount.assets.find({productId: result.productId});
                        asset.source = "INVESTOR_PREFERENCES";
                        if (asset.assetId == 0){
                            if (asset.restrictionType != 'None'){
                                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Security Not Added", "This security is already a restriction.").open();
                            }
                            else{
                                asset.restrictionType = "Do Not Buy";
                            }
                        }
                        else{
                            if (asset.restrictionType != 'None'){
                                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Security Not Added", "This security is already an Asset Restriction.").open();
                            }
                            else{
                                asset.restrictionType = "Do Not Buy";
                                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Security Added", "This security is an asset.  Please go to the Asset Restriction tab.").open();
                            }

                        }
                    }
                }

            });
    };

    $scope.assetFilter = function(isAsset) {
        return function(item) {
            if (isAsset){
                return item.restrictionType !== 'None' && item.assetId !== 0;
            }
            else{
                return item.restrictionType !== 'None' && item.assetId === 0;
            }
        };
    };

    $scope.assetRestrictionExists = function(isAsset) {
        let restrictionItems = [];
        if (verbose.astroAccount){
            verbose.astroAccount.assets.findAll(function (asset) {
                if (isAsset && asset.assetId !== 0 && asset.restrictionType !== 'None') {
                    restrictionItems.push(asset);
                }
                if (!isAsset && asset.assetId === 0 && asset.restrictionType !== 'None' ){
                    restrictionItems.push(asset);
                }
            });
        }
        return restrictionItems.length === 0
    };

    $scope.openAstroAssetRestrictionImport = function () {
        $dialog.dialog({templateUrl: "astroAssetRestrictionImport.html", controller: 'AstroAssetRestrictionImportCtrl', dialogClass: "modal wide"})
            .open()
            .then(function (result) {
                if (result) {
                    result.each(function (sec) {
                        verbose.astroAccount.assets.remove({productId: sec.productId});
                        verbose.astroAccount.assets.unshift(sec);
                    });
                }
            });
    };

    $scope.clearAssetRestrictions = function(isAsset){
        verbose.astroAccount.assets.map(function(asset){
            let applies = (asset.assetId === 0) ? !isAsset : isAsset;
            if (applies){
                $scope.removeAstroRestriction(asset, isAsset);
            }
            return asset;
        });
    };

    $scope.updateAllSleeves= function(){
        $scope.allSleevesSelected = !$scope.allSleevesSelected;
        verbose.astroAccount.sleeves.map(function(sl){
            sl.useCustodialRestrictions = $scope.allSleevesSelected;
            return sl;
        });
    };

    $scope.updateOneSleeve = function(sleeve){
        sleeve.useCustodialRestrictions = !sleeve.useCustodialRestrictions;
        $scope.allSleevesSelected = false;
    };

    $scope.clearSectorIndustryConstraints = function(){
        verbose.astroAccount.sectors.map(function(sec){
            sec.minimumValue = sec.maximumValue = null;
            sec.error = false;
            sec.industries.map(function(ind){
                ind.minimumValue = ind.maximumValue = null;
                ind.error = false;
                return ind;
            });
            return sec;
        })
    };

    $scope.checkSectorIndustryWeight = function (item) {
        if (item.minimumValue && (item.maximumValue || item.maximumValue === 0)){
            item.error = (item.minimumValue > item.maximumValue)
        }
        else {
            item.error = false;
        }
        $scope.checkAstroSettingsValidation();
    };

    function updateEsgSecurities(esgCatSecs, excluded) {
        if (esgCatSecs){
            esgCatSecs.each(function(sec){
                if (verbose.astroAccount.assets.none({productId: sec.productId})){
                    if (excluded){
                        verbose.astroAccount.assets.push({
                            accountId: $scope.current.accountId,
                            assetId: 0,
                            maxPercentWeight: null,
                            minPercentWeight: null,
                            ticker: sec.ticker,
                            productId: sec.productId,
                            productName: sec.productName,
                            restrictionType: sec.restrictionType,
                            source: "ESG_Restrictions"
                        });
                    }
                }
                else{
                    let asset = verbose.astroAccount.assets.find({productId: sec.productId});

                    //Only set as ESG_Restriction iif there isn't another type of restriction
                    if (excluded && asset.restrictionType === "None") {
                        asset.restrictionType = sec.restrictionType;
                        asset.source = "ESG_Restrictions";
                    }
                    else if(!excluded && asset.source === "ESG_Restrictions")
                    {
                        asset.restrictionType = "None";
                    }
                }
            });
        }
    }


    $scope.clearEsgConstraints = function(){
        verbose.astroAccount.esgRestriction.map(function(grp){
            grp.isExcluded = false;
            updateEsgSecurities(esgSecurities[grp.name], false);
            return grp;
        })
    };

    let esgRequests = 0;

    $scope.processEsg = function(grp){
        grp.isExcluded = !grp.isExcluded;

        if (!esgSecurities[grp.esgCategoryId]){
            esgRequests++;
            $scope.current.canSave = false;
            esgSecurities[grp.esgCategoryId] = [];
            $http.get(`/Portfolio/Esg/Restriction/Securities/${grp.esgCategoryId}`, {trackerMsg: 'Loading ASTRO ESG'})
                .then(function (response) {
                    esgSecurities[grp.esgCategoryId] = response.data;
                    updateEsgSecurities(esgSecurities[grp.esgCategoryId], grp.isExcluded);
                    esgRequests--;
                    if(esgRequests === 0) { $scope.current.canSave = true; }
                });
        }
        else{
            updateEsgSecurities(esgSecurities[grp.esgCategoryId], grp.isExcluded);
        }

    };

    //endregion

    // region LOAD DOCUMENTS AND NOTES
    function loadNotes() {
        if (!$scope.rightsNotes.canRead || verbose.notes) return;

        $http.get("/Portfolio/Accounts/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=notes", {trackerMsg: 'Loading account notes'})
            .then(function (response) {
                expandVerbose("notes", response.data.notes);
            });
    }

    function loadDocuments() {
        if (!$scope.rightsDocuments.canRead || verbose.documents) return;

        $http.get("/Portfolio/Accounts/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=documents", {trackerMsg: 'Loading account documents'})
            .then(function (response) {
                expandVerbose("documents", response.data.documents);
            });
    }
    //endregion

    //region LOAD Compliance
    function loadCompliance() {
        if (verbose.compliance) return;

        $http.get("/Portfolio/Accounts/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=compliance", {trackerMsg: 'Loading compliance'})
            .then(function (response) {
                expandVerbose("compliance", response.data.compliance);
            });
    }
    //endregion

    //region LOAD SYSTEMATICS
    function loadSystematics() {
        if (verbose.systematics) return;

        $http.get("/Portfolio/Accounts/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=systematics", {trackerMsg: 'Loading systematics'})
            .then(function (response) {
                const data = response.data;
                data.systematics.forEach(function (systematic) {
                    setSystematicDescription(systematic);
                });

                expandVerbose("systematics", data.systematics);
            });
    }

    function setSystematicDescription(systematic) {
        let frequency = '$' + systematic.swpAmount + ' will be';

        switch (systematic.type) {
            case 0:
                systematic.typeDescription = "Invalid";
                break;
            case 1: // Withdrawal
                frequency += " withdrawn ";
                systematic.typeDescription = "Withdrawal";
                break;
            case 3: // Purchase
                frequency += " purchased ";
                systematic.typeDescription = "Purchase";
                break;
            case 4: // DCA
                frequency += " purchased ";
                systematic.typeDescription = "DCA";
                break;
        }

        if (["Monthly", "Quarterly", "Semiannually", "Annually"].any(systematic.frequency)) {
            frequency += " on the " + systematic.transactionDay.ordinalize() + " day of " + (systematic.frequency === "Monthly" ? "every month." : " the " + systematic.cycleMonth.ordinalize() + " month of every");

            switch (systematic.frequency) {
                case "Quarterly":
                    frequency += " quarter.";
                    break;
                case "Semiannually":
                    frequency += " half year.";
                    break;
                case "Annually":
                    frequency += " year.";
                    break;
            }
        }

        systematic.description = frequency;

        if (systematic.type === 3) {
            systematic.netWithdrawal = 0;
        } else {
            if (systematic.swpAmount === 0) {
                systematic.netWithdrawal = 0;
            } else {
                let fedWithholding = 0,
                    stateWithholding = 0;

                if (systematic.isTaxWithType === systematicTaxWithType.dollar.name) {
                    fedWithholding = systematic.taxesWithheld;
                    stateWithholding = systematic.stateTax;
                } else if (systematic.isTaxWithType === systematicTaxWithType.percent.name) {
                    fedWithholding = (systematic.taxesWithheld / 100) * systematic.swpAmount;
                    stateWithholding = (systematic.stateTax / 100) * systematic.swpAmount;
                }

                systematic.netWithdrawal = systematic.swpAmount - (fedWithholding + stateWithholding);
            }
        }
    }

    //endregion

    // region CHANGE HISTORY

    function loadChangeHistory() {
        if ($scope.chsts) return;

        $http.get("/Portfolio/Accounts/" + args.ids[0] + "/Changes", {trackerMsg: 'Loading change history'})
            .then(function (response) {
                const data = response.data;
                data.forEach(function (chghst) {
                    chghst.asOfDate = Date.create(chghst.asOfDate);
                    chghst.editedDate = Date.create(chghst.editedDate);
                    chghst.isUncommitted = false;
                });

                $scope.chsts = data;
                changeHistoryOriginal = angular.copy($scope.chsts);
            });
    }

    function loadCompositeMonthExclusions() {
        if ($scope.compositeExclusions) return;

        $http.get('/Portfolio/Accounts/Verbose/' + (args.isNew ? "New" : args.ids[0]) + "?expand=compositeExclusions,portfolio", {trackerMsg: 'Loading composite month exclusions'})
            .then(function (res) {
                if (res.data) {
                    if (!verbose["portfolio"]){
                        expandVerbose("portfolio", res.data.portfolio);
                    }

                    expandVerbose('compositeExclusions', res.data.compositeExclusions);
                }
                else {
                    expandVerbose('compositeExclusions', []);
                    expandVerbose("portfolio", []);
                }
            });
    }

    function processChangeHistory() {
        //delete will only apply to non massUpdate
        if (changeHistoryToDelete.length > 0) {
            $http.post('/Portfolio/Accounts/' + args.ids[0] + '/Changes/Action/Delete', changeHistoryToDelete, {trackerMsg: 'Deleting change history'})
                .then(function () {
                    changeHistoryToDelete.length = 0;
                });
        }

        if (!$scope.chsts) return null;

        const saveCH = {
            accountIds: args.ids,
            changes: {},
            changeDate: null
        };

        $scope.chsts.findAll({isUncommitted: true}).forEach(function (chst) {
            saveCH.changeDate = chst.asOfDate.formatted();

            const changeObj = {id: chst.newEntityId, name: ''};

            switch (chst.entity) {
                case 'Inception Date':
                    saveCH.changes.inceptionDate = chst.newEntityName === "First Transaction Date" ? {useFirstTransactionDate: true, customDate: ''} : {useFirstTransactionDate: false, customDate: chst.newEntityName};
                    break;
                case 'Management Style':
                    saveCH.changes.managementStyle = changeObj;
                    break;
                case 'Sub-Advisor':
                    saveCH.changes.subAdvisor = chst.newEntityId === 0 ? null : changeObj;
                    break;
                case 'Fee Schedule':
                    saveCH.changes.feeSchedule = changeObj;
                    break;
                case 'Payout Schedule':
                    saveCH.changes.payoutSchedule = changeObj;
                    break;
                case 'Share Class':
                    saveCH.changes.shareClass = changeObj;
                    break;
                case 'Model':
                    saveCH.changes.modelAggregate = chst.newEntityId === 0 ? null : changeObj;
                    break;
                case "Index Blend":
                    saveCH.changes.indexBlend = chst.newEntityId === 0 ? null : changeObj;
                    break;
                case "Managed":
                    saveCH.changes.managedUnmanaged = changeObj;
                    break;
                case "Bill Pay Method":
                    saveCH.changes.billPayMethod = changeObj;
                    break;
                case "Qualified Plan":
                    saveCH.changes.plan401K = changeObj;
                    break;
            }
        });

        return saveCH.changeDate ? saveCH : null;
    }

    //endregion

    //region BILLING GENERAL


    function showRevPayNoFeeAgg() {
        if ($scope.current.revenuePayoutBPS !== undefined)
            return;

        $http.get("/Settings/Database/EntityOptions/Code/RevPayBps")
            .then(function (response) {
                $scope.current.revenuePayoutBPS = response.data.value === "True";

                if ($scope.current.revenuePayoutBPS)
                    loadRevPayNoFeeAggValue();
            });
    }

    function loadRevPayNoFeeAggValue() {
        if ($scope.entityOptionsLoaded)
            return;

        if (args.isNew) {
            var RevNoFeeAggDefaultValues = [{
                canEdit: true,
                category: "Billing",
                code: "RevPayNoFeeAgg",
                entity: "Account",
                input: "select",
                name: "Revenue Payout No Fee Aggregation",
                options: ["Default", "No Fee/No Pay", "Always Payout"],
                securityCode: null,
                sequence: 2,
                type: "List",
                value: "Default"
            }];
            expandVerbose("entityOptions",  RevNoFeeAggDefaultValues);
        }
        else
        {
            $http.get("/Settings/EntityOptions/account/" + args.ids[0] + "/Code/RevPayNoFeeAgg")
                .then(function (response) {
                    expandVerbose("entityOptions",  [response.data]);
                });
        }
    }

    function loadBillingGeneral() {
        if (verbose.billing) return;

        $http.get("/Portfolio/Accounts/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=billing,billAccountSchedules", { trackerMsg: 'Loading billing' })
            .then(function (response) {
                const data = response.data;

                //look up database level options
                $http.get("/Settings/Database/EntityOptions/Code/BILLUSEFEHI", { trackerMsg: 'Checking Use Fee Hierarchy options' })
                    .then(function (response) {
                        $scope.current.useFeeHierarchy = response.data.value === "True";
                    });

                //look up include in aggregate
                $http.get('/Authorization/User/Privileges/includeinAggregate?resetCache=true', { trackerMsg: 'Checking Include in Aggregate option' })
                    .then(function (response) {
                        $scope.current.includeInAggregate = response.data.editIsGranted;
                    });

                $http.get('/Authorization/User/Privileges/useFeeHierarchyAccountEdit?resetCache=true', { trackerMsg: 'Checking Use FeeHierarchy Account Edit option' })
                    .then(function (response) {
                        $scope.current.UseFeeHierarchyAccountEdit = response.data.editIsGranted;
                    });

                if (data.billing == null) {
                    $scope.billingDataMissing = true;
                    data.billing = {};
                }

                getFriendlyName(data.billing.feeHierarchyItems);

                $scope.feeHierarchyDetails = data.billing.feeHierarchyItems || [];
                $scope.feeHiOverrides = [];

                $scope.current.allowEditCC = data.billing.creditCardNumber === null || data.billing.creditCardNumber?.length === 0;
                setCycleMonths(data.billing.billFrequency);

                $http.get('/Billing/AccountStatusTypes', {trackerMsg: 'Loading Account status types'})
                    .then(function (response) {
                        $scope.accountStatus = response.data;
                    });

                expandVerbose("billing", data.billing);
                expandVerbose("billAccountSchedules", data.billAccountSchedules);

                loadFeeSchedule();
                showRevPayNoFeeAgg();
            });
    }

    function getFriendlyName(items) {
        if (items) {

            items.forEach(item => {
                let level = $scope.hierarchyLevels.find(x => x.name == item.level);

                if (level && level.friendlyName) {
                    item.level = level.friendlyName;
                }
            });
        }
    }

    function loadRelatedHouseholdAccounts() {
        if (relatedHouseholdAccounts || args.isNew) return;

        $http.get("/Portfolio/Accounts/" + args.ids[0])
            .then(function (response) {
                return response.data.clientId;
            })
            .then(function (clientId) {
                return $http.get("/Billing/Clients/" + clientId + "/RelatedAccounts", {trackerMsg: 'Loading related household accounts for current household'});
            })
            .then(function (response) {
                relatedHouseholdAccounts = response.data;
                var idx = $scope.indexOfRevPayNoFeeAgg();
                if (verbose.entityOptions && idx > -1) {
                    $scope.entityOptionsValue = verbose.entityOptions[idx].value;
                }
            });
    }

    function loadProductTypes() {
        if ($scope.productClasses || args.isNew) return;

        $http.get('/Portfolio/ProductTypes/Simple', {trackerMsg: 'Loading Product types'})
            .then(function (response) {
                $scope.productTypes = response.data;
            });

        if ($oasRights.forCode("FEEHIERARCHY").canRead) {
            $http.get('/Billing/BillProductGroup', { trackerMsg: 'Loading Bill Product Groups ' })
                .then(function (response) {
                    $scope.billProductGroups = response.data;
                });
        }
    }

    function setCycleMonths(frequency) {
        switch (frequency) {
            case billFrequency.monthly.name:
                $scope.billCycleMonths = [{id: 1, name: 'Every Month'}];
                break;
            case billFrequency.quarterly.name:
                $scope.billCycleMonths = buildCycleMonths(3, 'Quarter');
                break;
            case billFrequency.semiannually.name:
                $scope.billCycleMonths = buildCycleMonths(6, 'Semi-Annual Cycle');
                break;
            default:
                $scope.billCycleMonths = buildCycleMonths(12, 'Year');
        }
    }

    function buildCycleMonths(max, name) {
        return (1).upto(max).map(function (value) {
            return {id: value, name: "Month " + value + " of " + name};
        });
    }

    function loadPayoutRates (billEntity, $index) {
        $http.get( "/Billing/Schedules/Simple?billEntity=" + billEntity, {trackerMsg: 'Loading payable rates'} )
            .then( function( response ) {
                $scope.payoutRates[$index] = response.data;
            } );
    }

    $scope.loadPayoutScheduleForEntity = function(selected, $index){
        if (selected !== 0){
            loadPayoutRates(selected, $index);
        }
    };

    $scope.addFeeHiOverride = function () {
        $scope.feeHierarchyDetails.push({
            billEntityId : 0,
            billScheduleId: 0,
            payoutId: 0,
            level: 0,
            isNewOverride: true,
            billEntityCollectFromId: 3,
            status: true
        });
    };

    $scope.payoutRates = [];

    //At the current time, only Registration and Account levels are available for overrides.
    $scope.hierarchyLevels = [
        { id: 6, name: "Registration", friendlyName: 'Registration', level: 7 },
        { id: 7, name: "Account", friendlyName: 'Account', level: 10 }
    ];


    $scope.filterFeeHierarchyAssetLevel = function(prop)
    {
        return function (item)
        {
            return item[prop] > 0;
        }
    }
    //endregion

    //region AUTO SCHEDULES ASSIGN
    $scope.openAutoSchedule = function () {
        $dialog.dialog({templateUrl: 'auto-assign-fee-payout.html', controller: 'AutoAssignFeePayoutCtrl', accountId: args.ids[0], platformId: verbose.portfolio.managementStyleId, dialogClass: "modal wide"})
            .open()
            .then(function (result) {
                if (result) {
                    verbose.portfolio.managementStyleId = result.platformId;
                    verbose.portfolio.subAdvisorId = result.subAdvisorId;
                    const cache = $cacheFactory.get('$http');
                    cache.remove(API_CONFIG.baseUrl + '/Billing/Schedules/Simple?schedule=fee');
                    cache.remove(API_CONFIG.baseUrl + '/Billing/MasterPayoutSchedule/Simple?schedule=fee');
                }
            });
    };
    //endregion

    //region LOAD RECURRING ADJUSTMENTS
    function loadRecurringAdjustments() {
        if (verbose.recurringAdjustments) return;

        $http.get("/Portfolio/Accounts/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=recurringAdjustments", {trackerMsg: 'Loading recurring adjustments'})
            .then(function (response) {
                expandVerbose("recurringAdjustments", response.data.recurringAdjustments);
                checkBillingLockdown();
            });
    }

    function checkBillingLockdown(){
        $http.get("/Authorization/User/Databases/LockDown", { trackerMsg: 'Checking Billing Lockdown' })
            .then(function (response) {
                let isBillingLockdownOverridePrivilege = $oasRights.forCode("billingLockdownOverride").canRead;
                $scope.isBillingLockdown = isBillingLockdownOverridePrivilege ? false : response.data === 'Billing';
            });
    }

    function loadAdjustmentTypes() {
        if ($scope.adjTypes) return;

        $http.get("/Billing/AdjustmentTypes?isPayable=false&ispayableAffect=true", {trackerMsg: 'Loading adjustment types'})
            .then(function (response) {
                $scope.adjTypes = response.data;
            });
    }

    function loadBillingEntities() {
        if (!$scope.billingEntities) {
            if($scope.current.accountId && ($scope.rightsBillAppFeePayout.canRead || $scope.rightsPayoutSchedules.canRead)) {
                $scope.billingEntities = [{id: 0, entityName: "<Prorate by Payouts>", name: "<Prorate by Payouts>", isPayableEntity: true}];

                $http.get("/Billing/MasterPayoutSchedule/BillEntities/ByAccount/" + ($scope.current.accountId) + "", {trackerMsg: 'Loading account payees'})
                    .then(function (response) {
                        $scope.billingEntities.add(response.data);
                    });
            }
        }

        if (!$scope.billingEntitiesActive) {
            $scope.billingEntitiesActive = [{id: 0, entityName: "<Prorate by Payouts>", name: "<Prorate by Payouts>", isPayableEntity: true}];

            $http.get("/Billing/BillingEntities?isActive=true", {trackerMsg: 'Loading billing entities'})
                .then(function (response) {
                    $scope.billingEntitiesActive.add(response.data);
                });
        }
    }

    function loadFeeSchedule() {
        if ($scope.rightsFeeSchedule.canRead && verbose.billing && verbose.billing.feeScheduleId) {
            feeSchedulePromise = $http.get('/Billing/Schedules/' + verbose.billing.feeScheduleId, {trackerMsg: 'Loading fee schedule'})
                .then(function (response) {
                    feeSchedule = response.data;
                });
        }
    }
    //endregion

    //region LOAD MODEL ASSIGNMENTS
    function getAccountVerboseModelingInfoUrl() {
        return '/Portfolio/Accounts/Verbose/' + (args.isNew ? 'New' : args.ids[0]) + '?expand=modelingInfo';
    }

    function applyTradingBlockedState(modelingInfo) {
        $scope.current.disableTradingBlocked = modelingInfo.isRegistrationDoNotTrade &&
            ($scope.current.tradeBlockSleevedAccounts || !$scope.tradeBlockSleevedAccountsFeatureFlag);

        if ($scope.current.disableTradingBlocked) {
            $scope.current.disableTradingBlockedText = 'This Sleeve Account\'s Registration is set to "Do Not Trade". Trading Blocked cannot be edited.';
        } else if ($scope.multiTradeBlockFeatureFlag && $scope.multiTradeBlockFF) {
            $scope.current.disableTradingBlocked = true;
            $scope.current.disableTradingBlockedText = 'The Multi-Trade Block Feature entity option is enabled. Trading Blocked cannot be modified here.';
        } else {
            $scope.current.disableTradingBlocked = false;
        }
    }

    function shouldSyncAccountTradingBlockedForChange(change, sleevePrefOn) {
        if (!change) {
            return false;
        }
        // Account-level MTB changes always sync.
        if (change.relatedType === parseInt(entities.account.value, 10)) {
            return true;
        }
        // Registration-level blocks sync only when Trade Block Sleeved Accounts pref is on.
        return change.relatedType === parseInt(entities.registration.value, 10) && sleevePrefOn;
    }

    function loadModelAssignments(refreshTradingBlockedOnly) {
        if (refreshTradingBlockedOnly) {
            if (!verbose.modelingInfo || args.isNew) {
                return;
            }
        } else if (verbose.modelingInfo) {
            return;
        }

        const trackerMsg = refreshTradingBlockedOnly ? 'Refreshing trading blocked' : 'Loading model information';

        $http.get(getAccountVerboseModelingInfoUrl(), {trackerMsg: trackerMsg})
            .then(function (response) {
                const data = response.data;
                const modelingInfo = data.modelingInfo;

                if (!modelingInfo) {
                    return;
                }

                if (refreshTradingBlockedOnly) {
                    // Refresh disable state only; isTradingBlocked is driven by MTB or unsaved checkbox edits.
                    applyTradingBlockedState(modelingInfo);
                    return;
                }

                applyTradingBlockedState(modelingInfo);

                const setModelAssignment = function () {
                    data.modelingInfo.customAllocations.allocation.isActiveTab = true;
                    $scope.setFrequencyValues(data.modelingInfo.autoRebalanceFrequency);

                    expandVerbose("modelingInfo", data.modelingInfo);
                };

                if (data.modelingInfo.customAllocations) {
                    const promises = {};
                    Object.each(data.modelingInfo.customAllocations, function (key, value) {
                        if (value.modelAggId) {
                            promises[key] = getModelAllocation(value.modelAggId);
                        }
                    });

                    $q.all(promises)
                        .then(function (results) {
                            Object.each(results, function (key, value) {
                                data.modelingInfo.customAllocations[key].items.forEach(function (item) {
                                    item.currentPercent = value.find({productId: item.productId}).currentPercent;
                                });
                            });

                            setModelAssignment();
                        });
                }
                else {
                    data.modelingInfo.customAllocations = {allocation: {items: [], modelAggId: null}, newMoney: {items: [], modelAggId: null}};
                    setModelAssignment();

                    if ($scope.customModelSetup.enabled && !$scope.customModelSetup.isSelfDirected()) {
                        $scope.loadSubAdvisorModels();
                    }
                }
            });
    }

    $scope.showTradingBlockedText = function () {
        $dialog.messageBox('Trading Blocked', $scope.current.disableTradingBlockedText).open();
    };

    function loadPermissibleAggregateModels() {
        if (!$scope.user.isStephensGroupAssetManagement || verbose.permissibleAggregateModels) return;

        $http.get("/Portfolio/Accounts/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=permissibleAggregateModels", {trackerMsg: 'Loading permissible aggregate models'})
            .then(function (response) {
                expandVerbose("permissibleAggregateModels", response.data.permissibleAggregateModels.sortBy('name'));
            });
    }

    function loadProductEquivalents() {
        if (verbose.productEquivalents) return;

        $http.get("/Portfolio/Accounts/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=ProductEquivalents", {trackerMsg: 'Loading product equivalents'})
            .then(function (response) {
                expandVerbose("productEquivalents", response.data.productEquivalents.sortBy('sortOrder'));
            });
    }

    function setProductEquivalentFields(item, side, newProduct) {
        item[side + "Id"] = newProduct.productId;
        item[side + "Name"] = newProduct.productName;
        item[side + "Ticker"] = newProduct.ticker;
    }

    $scope.addProductEquivalent = function () {
        $dialog.search('product', 'Model Product', null, {accountId: (args.isNew ? 0 : args.ids[0])})
            .open()
            .then(function (productModel) {
                if (!productModel) return;

                $dialog.search('product', 'Account Equivalent', null, {accountId: (args.isNew ? 0 : args.ids[0])})
                    .open()
                    .then(function (product) {
                        if (!product) return;

                        if (verbose.productEquivalents.any({productId: product.productId})) {
                            $dialog.actionFailed(product.ticker + " (" + product.productName + ") cannot be used in the list more than once.").open();
                        } else {
                            const item = {};
                            setProductEquivalentFields(item, 'productModel', productModel);
                            setProductEquivalentFields(item, 'product', product);

                            verbose.productEquivalents.push(item);
                        }
                    });
            });
    };

    $scope.editProductEquivalent = function (item, side) {
        $dialog.search('product', 'Replace Product', null, {accountId: (args.isNew ? 0 : args.ids[0])})
            .open()
            .then(function (result) {
                if (!result) return;

                if (side === "product" && verbose.productEquivalents.any({productId: result.productId})) {
                    $dialog.actionFailed(result.ticker + " (" + result.productName + ") cannot be used in the list more than once.").open();
                } else {
                    setProductEquivalentFields(item, side, result);
                }
            });
    };

    $scope.removeProductEquivalent = function (item) {
        $dialog.confirmAction("Are you sure you want to remove this product equivalent?")
            .open()
            .then(function (result) {
                if (result === "yes") {
                    verbose.productEquivalents.remove(item);
                }
            });
    };

    $scope.moveProductEquivalent = function (item, indexChange) {
        const index = verbose.productEquivalents.indexOf(item),
            newPos = index + indexChange;

        verbose.productEquivalents.splice(index, 1);
        verbose.productEquivalents.splice(newPos, 0, item);
    };

    // initial MTB load must not overwrite account DB isTradingBlocked.
    // sync Trading Blocked only when user adds/removes MTB on this screen (pref checked at that time).
    $scope.onAccountTradeBlockDetailsChanged = function (event) {
        if (!event || !verbose || !verbose.modelingInfo || event.isBlocked === undefined) {
            return;
        }

        // Pref at save/delete time — not when emit runs (pref may have changed since).
        const sleevePrefOn = event.sleevePrefOn === true;
        if (shouldSyncAccountTradingBlockedForChange(event, sleevePrefOn)) {
            verbose.modelingInfo.isTradingBlocked = event.isBlocked;
        }
    };

    $scope.isEntityTradeBlocked = function () {
        // Ignore initial MTB emit on load/remount; user actions sync via onAccountTradeBlockDetailsChanged.
    };

    function loadSubAdvisorDetail() {
        $http.get("/Settings/Database/EntityOptions/Code/SELFDIRECTEDSUBADVID", {cache: true, trackerMsg: 'Loading model settings'})
            .then(function (response) {
                const data = response.data;
                $scope.customModelSetup = {enabled: data.value !== "0", selfDirectedId: parseInt(data.value)};
                $scope.customModelSetup.isSelfDirected = function () {
                    return verbose.portfolio.subAdvisorId === $scope.customModelSetup.selfDirectedId;
                };

                if ($scope.customModelSetup.enabled) {
                    if (args.isNew) {
                        //for now they can't assign custom models until they've saved the account once
                        $scope.menu[0].items.remove({name: 'Model Assignment'});
                    }
                    else {
                        $scope.customModelSetup.allowSelfDirected = $scope.customModelSetup.isSelfDirected(); //if they were already, they're grand-fathered in

                        $http.get("/Portfolio/SubAdvisors/Simple?isActive=true&accountId=" + args.ids[0], {cache: true, trackerMsg: 'Loading sub-advisors'})
                            .then(function (response) {
                                const data = response.data;
                                if (!data || !data.length) return;

                                const index = data.findIndex({id: $scope.customModelSetup.selfDirectedId});
                                if (index !== -1) {
                                    $scope.customModelSetup.allowSelfDirected = true;
                                    data.splice(index, 1);
                                }

                                $scope.subAdvisors = data;
                            });
                    }
                }
            });
    }

    function loadBondTradingForAccount() {
        if (verbose.bondTrade) return;

        $http.get('/Portfolio/Accounts/Verbose/' + args.ids[0] + '?expand=bondTrade', {trackerMsg: 'Loading bond trading for account'})
            .then(function (response) {
                if (response.data && response.data.bondTrade) {
                    expandVerbose("bondTrade", response.data.bondTrade);
                    $scope.current.bondTrade.classTotal = verbose.bondTrade.cashPercent + verbose.bondTrade.equityPercent + verbose.bondTrade.bondPercent;
                    $scope.current.bondTrade.termTotal = verbose.bondTrade.shortTermBondPercent + verbose.bondTrade.intermediateTermBondPercent;
                } else {
                    const tempNewBondTrade = {
                        bondPercent: 0, cashPercent: 0, equityPercent: 0, excludeEquitiesFromRebalance: false, excludeUntilDate: null, excludeUntilNotes: null, intermediateTermBondPercent: 0, shortTermBondPercent: 0
                    };
                    expandVerbose("bondTrade", tempNewBondTrade);
                    $scope.current.bondTrade.classTotal = verbose.bondTrade.cashPercent + verbose.bondTrade.equityPercent + verbose.bondTrade.bondPercent;
                    $scope.current.bondTrade.termTotal = verbose.bondTrade.shortTermBondPercent + verbose.bondTrade.intermediateTermBondPercent;
                }
            });
    }

    function getModelAllocation(modelAggId) {
        return $http.get("/Trading/ModelAggs/" + modelAggId + "/" + args.ids[0] + "/Allocations", {cache: true, trackerMsg: 'Loading model allocation'})
            .then(function (response) {
                return response.data;
            });
    }

    function getModelTabState(usePrettyNames) {
        const state = {active: null, inactive: null};
        Object.each(verbose.modelingInfo.customAllocations, function (key, value) {
            state[value.isActiveTab ? 'active' : 'inactive'] = usePrettyNames ? key.spacify().capitalize(true) : key;
        });
        return state;
    }

    $scope.toggleSubAdvisorId = function () {
        if ($scope.customModelSetup.isSelfDirected()) {
            verbose.portfolio.subAdvisorId = $scope.subAdvisors[0].id;

            if (!$scope.customModelSetup.modeledAllocation) {
                $scope.loadSubAdvisorModels();
            }
        }
        else {
            verbose.portfolio.subAdvisorId = $scope.customModelSetup.selfDirectedId;

            const alloc = verbose.modelingInfo.customAllocations.allocation;
            if (!alloc.modelAggId && $scope.customModelSetup.modeledAllocation) {
                alloc.items = angular.copy($scope.customModelSetup.modeledAllocation);
            }
        }
    };

    $scope.loadSubAdvisorModels = function () {
        if (!verbose.portfolio.subAdvisorId) return;

        $http.get("/Trading/ModelAggs?accountId=" + args.ids[0] + "&subAdvisorId=" + verbose.portfolio.subAdvisorId, {cache: true, trackerMsg: 'Loading models'})
            .then(function (response) {
                const data = response.data;
                if (!data || !data.length) return;

                $scope.subAdvisorModels = data;

                if (!verbose.modelingInfo.aggregateModel) {
                    verbose.modelingInfo.aggregateModel = {};
                }

                if (data.none({id: verbose.modelingInfo.aggregateModel.id})) {
                    verbose.modelingInfo.aggregateModel.id = data[0].id;
                }
                $scope.loadModeledAllocation();
            });
    };

    $scope.loadModeledAllocation = function () {
        getModelAllocation(verbose.modelingInfo.aggregateModel.id)
            .then(function (data) {
                $scope.customModelSetup.modeledAllocation = data;
            });
    };

    $scope.copyModel = function () {
        const tabs = getModelTabState(true);
        $dialog.confirmAction("This will remove all assets from the " + tabs.active + " tab and replace them with the assets from the " + tabs.inactive + " tab.  Do you want to continue?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    const tabs = getModelTabState();
                    const oldModel = angular.copy(verbose.modelingInfo.customAllocations[tabs.active].items);

                    verbose.modelingInfo.customAllocations[tabs.active].items = angular.copy(verbose.modelingInfo.customAllocations[tabs.inactive].items);
                    verbose.modelingInfo.customAllocations[tabs.active].items.forEach(function (item) {
                        const oldItem = oldModel.find({productId: item.productId});
                        item.currentPercent = oldItem ? oldItem.currentPercent : 0;
                    });
                }
            });
    };

    $scope.addToModel = function () {
        const list = verbose.modelingInfo.customAllocations[getModelTabState().active].items;
        const product = $scope.current.selectedProduct;

        if (list.none({productId: product.productId})) {
            list.push({productId: product.productId, productName: product.productName, ticker: product.ticker, targetPercent: 100 - list.sum('targetPercent'), currentPercent: 0});
        }

        $scope.current.selectedProduct = null;
    };

    $scope.removeFromModel = function (key, index) {
        verbose.modelingInfo.customAllocations[key].items.splice(index, 1);
    };

    $scope.openModelAggEditor = function (isNew) {
        $dialog.editor('modelAggTemplate.html', 'ModelAggCtrl', {args: function () {return {modelAggId: isNew ? 0 : verbose.modelingInfo.aggregateModel.id, isModalEdit: true};}})
            .open()
            .then(function (result) {
                if (result) {
                    verbose.modelingInfo.aggregateModel = Object.select(result, ['id', 'name']);
                }
            });
    };

    $scope.setFeeSchedule = function () {
        if ($scope.useNewAssetFeeScheduleModal) {
            // Use new Angular modal
            $scope.assetFeeScheduleModal.schedules = angular.copy(verbose.billAccountSchedules || []);
            $scope.assetFeeScheduleModal.isOpen = true;
        } else {
            // Use old AngularJS modal
            const tempBillAccountSchedules = angular.copy(verbose.billAccountSchedules);
            $dialog.dialog({templateUrl: "assetLevelFeeSchedules.html", controller: 'AssetLevelFeeSchedulesCtrl', accountId: $scope.current.accountId, billSchedules: tempBillAccountSchedules})
                .open()
                .then(function (result) {
                    if (result) verbose.billAccountSchedules = result;
                });
        }
    };

    $scope.onAssetFeeScheduleClose = function (schedules) {
        if (schedules) {
            verbose.billAccountSchedules = schedules;
        }
        $scope.assetFeeScheduleModal.isOpen = false;
    };

    $scope.onAssetFeeScheduleCancel = function () {
        $scope.assetFeeScheduleModal.isOpen = false;
    };

    $scope.unAssignModelAgg = function () {
        $dialog.confirmAction("Are you sure you want unassign model <b>" + verbose.modelingInfo.aggregateModel.name + "</b> from this account?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    if(verbose.modelingInfo.aggregateModel.hasSMAModel && $scope.current.featureFlagSMAModel && !verbose.portfolio.isSleeveAccount){
                        verbose.modelingInfo.isTradingBlocked = false;
                    }
                    verbose.modelingInfo.aggregateModel = null;
                }
            });
    };

    $scope.modelAggSelected = function(modelAgg) {
        if(modelAgg.hasSMAModel && $scope.current.featureFlagSMAModel && !verbose.portfolio.isSleeveAccount) {
            verbose.modelingInfo.isTradingBlocked = true;
        }
    }

    $scope.compareAccount = function () {
        $http.get("/Portfolio/Accounts/" + args.ids[0], {trackerMsg: 'Loading account'})
            .then(function (response) {
                const data = response.data;
                const account = {id: args.ids[0], accountNumber: data.number, accountName: data.name, accountType: data.accountType};
                $dialog.dialog({dialogClass: "modal wide", templateUrl: "account-compare.html", controller: "AccountCompareCtrl", account: account}).open();
            });
    };

    $scope.setFrequencyValues = function (frequency) {
        switch (frequency) {
            case 'None':
                $scope.frequencyValue = [{id: 1, name: "1"}];
                break;
            case 'Monthly' :
                $scope.frequencyValue = [{id: 1, name: "Every Month"}];
                break;
            case 'Quarterly':
                $scope.frequencyValue = buildCycleMonths(3, "Quarter");
                break;
            case 'Semiannual':
                $scope.frequencyValue = buildCycleMonths(6, "Semi-Annual Cycle");
                break;
            case 'Annual':
                $scope.frequencyValue = buildCycleMonths(12, "Cycle");
                break;
        }
    };

    $scope.setModelAssignmentOnManagementStyleChange = function (id) {
        if (lastManagementStyleId === id) {
            return;
        }
        lastManagementStyleId = id;
        if (verbose.portfolio && verbose.portfolio.managementStyleId && verbose.modelingInfo && $scope.rightsPlatform.canRead) {
            $http.get('/Portfolio/Platforms/' + id, {trackerMsg: 'Retrieving Model Agg Information'})
                .then(function (response) {
                    if (response.data.modelAggId) {
                        verbose.modelingInfo.aggregateModel = {id: response.data.modelAggId, name: response.data.modelAggName}
                    }
                })
        }
    };
    //endregion

    //region PAYEES
    function loadPayeesLookUps() {
        if ($scope.payees) return;

        $http.get("/Billing/Payees?isActive=true", {cache: true, trackerMsg: 'Loading payees'})
            .then(function (response) {
                response.data.unshift({id: 0, name: '(None)'});
                $scope.payees = response.data;
            });
    }
    //endregion

    //region LOAD GENERAL ACCOUNTS
    function loadGeneralAccounts() {
        if (verbose.generalAccounts) return;

        $http.get("/Portfolio/Accounts/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=generalAccounts", {trackerMsg: 'Loading general accounts'})
            .then(function (response) {
                expandVerbose("generalAccounts", response.data.generalAccounts);
            });
    }
    //endregion

    //region LOAD REFERRAL SCHEDULES
    function loadReferralSchedules() {
        if (verbose.referralSchedules) return;

        $http.get("/Portfolio/Accounts/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=referralSchedules", {trackerMsg: 'Loading referral schedules'})
            .then(function (response) {
                expandVerbose("referralSchedules", response.data.referralSchedules);
            });
    }

    function loadReferralPayouts() {
        if ($scope.referralPayouts) return;

        $http.get('/Billing/ReferralPayouts', {trackerMsg: 'Loading referral payouts'})
            .then(function (response) {
                $scope.referralPayouts = response.data;
            });
    }
    //endregion

    //region LOAD ENTITY OPTIONS

    $scope.entityOptionsValue = null;

    function loadEntityOptions() {
        if ($scope.entityOptionsLoaded) return;

        $http.get("/Settings/EntityOptions/Accounts/" + args.ids[0], {trackerMsg: 'Loading options'})
            .then(function (response) {

                if (verbose.entityOptions)
                {
                    $scope.entityOptionsValue =  verbose.entityOptions[$scope.indexOfRevPayNoFeeAgg()].value;
                }


                $portfolio.cleanCustomFields(response.data);
                expandVerbose("entityOptions", response.data);

                if ($scope.entityOptionsValue)
                {
                    verbose.entityOptions[$scope.indexOfRevPayNoFeeAgg()].value = $scope.entityOptionsValue;
                }

                $scope.entityOptionsValue = verbose.entityOptions[$scope.indexOfRevPayNoFeeAgg()].value;

                $scope.entityOptionsLoaded = true;
            });
    }

    //endregion

    //region LOAD CUSTOM FIELDS
    function loadCustomFields() {
        if (verbose.userDefinedFields) return;

        $http.get(args.isNew ? '/Settings/UserDefinedFields/Definitions/Account' : '/Portfolio/Accounts/' + args.ids[0] + '/UserDefinedFields', {trackerMsg: 'Loading custom fields'})
            .then(function (response) {
                const data = args.isNew ? response.data.map(function (definition) {return $portfolio.makeCustomFieldFromDefinition(definition, "Account");}) : response.data;

                $portfolio.cleanCustomFields(data);
                expandVerbose("userDefinedFields", data);
            });
    }
    //endregion

    //region LOAD LASERAPP DATA
    function loadLaserApp() {
        if ($scope.formsLibrary) return;

        $http.get('/Integrations/LaserApp/Accounts/' + args.ids[0] + "/Forms", {trackerMsg: 'Loading LaserApp forms'})
            .then(function (response) {
                let data = response.data;

                if (args.extraInfo && args.extraInfo.laserAppFilter && args.extraInfo.laserAppFilter.length > 0) {
                    const dataFilter = [];
                    args.extraInfo.laserAppFilter.forEach(function (filter) {
                        data.findAll(function (form) {
                            if (form.title.has(filter)) {
                                dataFilter.push(form);
                            }
                        });
                    });

                    data = dataFilter;
                }

                data.each(function (form) {
                    form.selected = form.isRequired;
                });

                $scope.formsLibrary = data;
            });
    }

    //endregion

    //region LOAD FUTURE CASH FLOWS
    function loadFutureCashFlows() {
        if (verbose.futureCashflows) return;

        $http.get("/Portfolio/Accounts/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=futureCashflows", {trackerMsg: 'Loading account future cash flows'})
            .then(function (response) {
                const data = response.data;
                if (data.futureCashflows.length) {
                    expandVerbose("futureCashflows", data.futureCashflows);
                } else {
                    expandVerbose("futureCashflows", []);
                }
            });
    }
    //endregion

    //region LOAD GOALS
    function loadGoals() {
        if (verbose.goals) return;

        $http.get("/Portfolio/Accounts/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=goals", {trackerMsg: 'Loading account goals'})
            .then(function (response) {
                expandVerbose("goals", response.data.goals.length ? response.data.goals : []);
            });

        $http.get("/Settings/EntityOptions/Client/" + verbose.portfolio.clientId + "/Code/GOALSTART", {trackerMsg: 'Loading default goal start date'})
            .then(function (response) {
                if (response.data) {
                    if (Date.create(response.data.value).isValid())
                        $scope.current.defaultGoalStartDate = Date.create(response.data.value)
                }
            });
    }
    //endregion

    //region LOAD GROWTH RATES
    function loadGrowthRates() {
        if (verbose.growthRates) return;

        $http.get("/Portfolio/Accounts/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=growthRates", {trackerMsg: 'Loading account growth rates'})
            .then(function (response) {
                const data = response.data;
                if (data.growthRates.length) {
                    data.growthRates.each(function (gr) {
                        gr.annualGrowthRate *= 100;
                    });
                    expandVerbose("growthRates", data.growthRates);
                } else {
                    expandVerbose("growthRates", []);
                }
            });
    }
    //endregion

    //region LOAD TAX RATES

    function loadTaxRates() {
        if (verbose.taxRates) { return };

        $http.get("/Portfolio/Accounts/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=taxRates", { trackerMsg: 'Loading account tax rates' })
            .then(function (response) {
                const data = response.data;
                if (data.taxRates.length) {
                    data.taxRates.each(function (tr) {
                        tr.shortTermRate *= 100;
                        tr.longTermRate *= 100;
                    });
                    expandVerbose("taxRates", data.taxRates);
                } else {
                    expandVerbose("taxRates", []);
                }
            });
    }

    //endregion

    //region PUBLIC METHODS

    //region LOAD/CLOSE
    $scope.loadTab = function (menuItem) {
        $scope.current.selectedTab = menuItem;
        if (menuItem.code === 'modelAssignment' && verbose.modelingInfo) {
            loadModelAssignments(true);
        }
        menuItem.load.forEach(function (fn) {fn();});
    };

    function beforeSaveAccountAPICheck() {
        //implenment any backend AIP Data Validation Check here
        var err = CheckPayforAccounts(verbose['billing']);
    }

    function saveAccount(billingerrmsg) {
        const account = {id: args.ids[0]},
            abortMessages = [];

        if (billingerrmsg != null && billingerrmsg.length>1)
            abortMessages.push(billingerrmsg); //msg for billing pay method direct vs payforaccounts api check

        var originalMaxAnnualCapGain = 0;
        var currentYearTaxSchedule;

        if ($scope.verbose.astroAccount) {
            originalMaxAnnualCapGain = $scope.verbose.astroAccount.maxRealizedGain ?? 0;
        }

        if (verbose.astroTaxSchedules) {
            currentYearTaxSchedule = verbose.astroTaxSchedules.filter(function (n) {
                return n.year === $scope.currentYear;
            })[0];
        }

        if(currentYearTaxSchedule) {
            $scope.verbose.astroAccount.maxRealizedGain = $scope.verbose.calculatedMaxAnnualCapGain;
        }


        if ($scope.feeHierarchyDetails) {
            $scope.feeHierarchyDetails.forEach(detail => {
                if (detail.billEntityCollectFromId != 3
                    && detail.billEntityId != null
                    && $scope.feeHierarchyDetails.any(x => x.billEntityCollectFromId == detail.billEntityId)) {
                    abortMessages.push("Cannot chain together Fee Hierarchy 'Collect From' for entity " + detail.billEntity.name);
                }
            });
        }

        if (verbose.portfolio && $scope.current.priceHierarchy !== null) {
            //The porfolio object is not loaded when calling the edit modal from Eclipse
            verbose.portfolio.custodianCommonIdList = $scope.current.priceHierarchy;
        }

        Object.each(verbose, function (key, value) {
            if (angular.equals(original[key], value)) return;

            let expand = angular.copy(value);

            switch (key) {  //do any necessary custom manipulations and error checks
                case "entityOptions":
                    expand = $portfolio.restoreEntityOptions(expand);
                    break;
                case "modelingInfo":
                    if (expand.minimumCashBalanceType === 'Percent' && expand.minimumCashBalance > 100) {
                        abortMessages.push("Minimum Cash cannot be greater than 100%.");
                    }

                    if (expand.expireMinCashType === 'Percent' && expand.expireMinCash > 100) {
                        abortMessages.push("Expired Minimum Cash cannot be greater than 100%.");
                    }

                    expand[$scope.customModelSetup.isSelfDirected() ? 'aggregateModel' : 'customAllocations'] = null;
                    break;
                case "bondTrade":
                    const termTotal = expand.shortTermBonds + expand.intermediateTermBonds;
                    const classTotal = expand.cash + expand.equity + expand.fixedIncome;

                    if ((termTotal > 0 && termTotal !== 100.00) || (classTotal > 0 && classTotal !== 100.00)) {
                        abortMessages.push("Bond trading allocations must add up to 100%");
                    }
                    break;
                case "userDefinedFields":
                    expand = expand.findAll({entity: entities.account.name});
                    break;
                case "targetAllocations":
                    if ($scope.useSharedTargetAllocationEditor) {
                        targetAllocationSaveValidator.validateRows(expand).forEach(function (m) {
                            abortMessages.push(m);
                        });
                    } 
                    else if (expand.length > 0 && !expand.sum('weight').almostEquals(100)) {
                        abortMessages.push("Account target allocation must equal 100%.");
                    }
                    break;
                case "productEquivalents":
                    expand.forEach(function (item, index) {
                        item.sortOrder = index + 1;
                    });
                    break;
                case "growthRates":
                    expand.forEach(function (item) {
                        item.asOfDate = angular.isString(item.asOfDate) ? item.asOfDate : item.asOfDate.formatted();
                        item.annualGrowthRate /= 100;
                    });
                    const dateGrouping = expand.groupBy('asOfDate');
                    if(Object.keys(dateGrouping).some(function(date){ return dateGrouping[date].length > 1; })) {
                        abortMessages.push("All growth rates must have a different as of date.");
                    }
                    break;
                case "taxRates":
                    expand.forEach(function (item) {
                        item.asOfDate = angular.isString(item.asOfDate) ? item.asOfDate : item.asOfDate.formatted();
                    });
                    const taxDateGrouping = expand.groupBy('asOfDate');
                    if (Object.keys(taxDateGrouping).some(function (date) {
                        return taxDateGrouping[date].length > 1;
                    })) {
                        abortMessages.push("All tax rates must have a different as of date.");
                    }
                    break;
                case "astroAccount":
                    let isError = expand.sectors.find({error: true});
                    if (!isError){
                        expand.sectors.forEach(function(sector){
                            if (sector.industries.find({error: true})){
                                isError = true;
                            }
                        });
                    }
                    if (isError){
                        abortMessages.push("A Sector or Industry constraint has Min % Weight greater than Max % Weight.");
                    }

                    expand.astroTemplate = args.extraInfo.astroTemplate;
                    break;
                case "astroTaxSchedules":
                    const currentYear = new Date().getFullYear();
                    expand.forEach(function (item) {
                        if (item.q4Percent < 100) {
                            abortMessages.push(item.year + " tax schedule Q4 must be 100%.");
                        } else if (item.year === currentYear && (!item.q4Percent)) {
                            abortMessages.push(item.year + " tax schedule must have at least Q4 defined.");
                        } else if (item.year > currentYear && (!item.q1Percent || !item.q2Percent || !item.q3Percent || !item.q4Percent)) {
                            abortMessages.push(item.year + " tax schedule quarters are required.");
                        } else if (item.q4Percent < (item.q3Percent || 0)
                            || ((item.q3Percent || 0) < (item.q2Percent || 0))
                            || ((item.q2Percent || 0) < (item.q1Percent || 0))) {
                            abortMessages.push(item.year + " tax schedule quarter values must increase (Q1 <= Q2, etc)");
                        }
                    });
                    break;
                case "billing":
                    expand.billStartDate = (original[key].billStartDate == value.billStartDate) ? original[key].billStartDate :
                        expand.billStartDate ? new Date(expand.billStartDate).toLocaleDateString() : null;
                    break;
            }

            account[key] = expand;
        });

        if (abortMessages.length) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Data", '<ul class="unstyled"><li>' + abortMessages.join("</li><li>") + '</li></ul>').open();
            $scope.isSaving = false;
            return;
        }

        const save = args.isNew ? {verb: 'post', msg: 'Adding', suffix: ''} : {verb: 'put', msg: 'Saving', suffix: args.ids[0]};

        const savePromises = [
            $http[save.verb]('/Portfolio/Accounts/Verbose/' + save.suffix, account, {trackerMsg: save.msg + ' account'})
        ];

        function isFullBeneficiarySsn(ssn) {
            if (!ssn || ssn.indexOf('X') !== -1) {
                return false;
            }

            var clean = ssn.replace(/-/g, '').replace(/ /g, '');
            return /^\d{9}$/.test(clean);
        }

        function shouldSaveSystematicBeneficiarySsn(sys) {
            if (!sys.id || !sys.updateBeneficiarySSN || !sys.reason) {
                return false;
            }

            if (isFullBeneficiarySsn(sys.beneficiarySSN)) {
                return true;
            }

            return !sys.beneficiarySSN || sys.beneficiarySSN.trim() === '';
        }

        if (!args.isNew && account.systematics) {
            account.systematics.forEach(function (sys) {
                if (shouldSaveSystematicBeneficiarySsn(sys)) {
                    savePromises.push($http.put(
                        '/Portfolio/Accounts/' + args.ids[0] + '/Systematics/' + sys.id + '/BeneficiarySSN',
                        {
                            ssN: sys.beneficiarySSN || '',
                            reason: sys.reason || 'adding systematic beneficiary SSN'
                        },
                        { trackerMsg: 'Saving systematic beneficiary SSN' }));
                }
            });
        }

        $q.all(savePromises)
            .then(function (results) {
                const response = results[0];
                const savedData = response.data;
                const closeProcess = function () {
                    if ($scope.current.isFullPage && !$scope.current.showCancel) {
                        $dialog.saveSuccessful("Account saved.").open();
                    } else {
                        if (args.app) {
                            let retUrl;
                            switch (args.app) {
                                case apps.portfolioLists.name:
                                    retUrl = '/Portfolio/Accounts/' + savedData.id;
                                    break;
                                case apps.billingAudit.name:
                                    retUrl = '/Billing/Accounts/' + savedData.id;
                                    break;
                                case apps.newAccount.name:
                                    retUrl = '/Portfolio/Accounts/NewPortfolio/' + savedData.id;
                                    break;
                                case apps.rmd.name:
                                    retUrl = '/Portfolio/Accounts/' + savedData.id + '/RMDCalculation?returnstyle=standard';
                                    break;
                            }
                            if (retUrl) {
                                $http.get(retUrl, {trackerMsg: 'Refreshing account'})
                                    .then(function (response) {
                                        const retData = response.data;
                                        if (args.isNew) retData.isNew = true;
                                        editorHotKeys.destroy();
                                        if (dialog) {
                                            dialog.close(retData);
                                        } else {
                                            window.parent.postMessage("iframeclose");
                                        }
                                    });
                            } else {
                                //this is for apps that don't need to have refreshed data.  i.e. referral schedules
                                editorHotKeys.destroy();
                                if (dialog) {
                                    dialog.close(account);
                                } else {
                                    window.parent.postMessage("iframeclose");
                                }
                            }
                        } else {
                            editorHotKeys.destroy();
                            if (dialog) {
                                dialog.close(null);
                            } else {
                                window.parent.postMessage("iframeclose");
                            }
                        }
                    }
                };

                //commit account edits before doing account changes
                const saveCH = processChangeHistory();

                if (saveCH) {
                    $http.post('/Portfolio/Accounts/Changes/New', saveCH, {trackerMsg: "Saving change history"})
                        .then(function () {
                            closeProcess();
                        });
                } else {
                    closeProcess();
                }
            }).catch(function (response){
            if(response && response.data){
                $scope.isSaving = false;
                if(currentYearTaxSchedule && $scope.verbose.astroAccount.maxRealizedGain){
                    $scope.verbose.astroAccount.maxRealizedGain = originalMaxAnnualCapGain;
                }

                if(response.data.Message && (response.data["Message"].has("SMA Error"))){
                    resetModelAggOnModelAssignment();
                }
            }
        });
    }

    function resetModelAggOnModelAssignment(){
        $scope.verbose.modelingInfo.aggregateModel = null;
    }

    function CheckPayforAccounts(billingvalue) {
        if (angular.equals(original['billing'], verbose['billing'])) //skip below api check
            saveAccount(null);
        else {
            $http.post('/Billing/Accounts/CheckPayforAccounts', billingvalue , {trackerMsg: 'Checking account with an Indirect pay method cannot pay for other accounts', allowCancellation: true})
                .then( function(r) {
                    saveAccount(r.data);
                }).catch( err=>{ console.log(err); });
        }
        return false;
    }

    $scope.save = function () {
        if (!$scope.checkAstroSettingsValidation()) {
            return;
        }
        splitIoService.getBoolTreatment("recon_datasharing_editwarningmessages_7285")
            .subscribe((isEnabled) => {
                if ($scope.isDataSharingEntity && isEnabled) {
                    $dialog.confirmAction('Account is a data sharing Account. Changes are likely to be reverted by subsequent syncs.  Would you still like to proceed?')
                        .open()
                        .then((response) => {
                            if (response == 'yes') {
                                saveAction();
                            }
                        });
                }
                //else do legacy
                else {
                    saveAction();
                }
            });
    };

    function saveAction() {
        $scope.isSaving = true;
        if (original.portfolio && original.portfolio.registrationId && original.portfolio.registrationId !== verbose.portfolio.registrationId) {
            $http.put('/Portfolio/Accounts/' + args.ids[0] + '/Action/MoveToRegistration/' + verbose.portfolio.registrationId, { trackerMsg: 'Moving account to different registration' })
                .then(function () {
                    beforeSaveAccountAPICheck();
                }).catch(function () {
                $scope.isSaving = false;
            });
        } else {
            beforeSaveAccountAPICheck();
        }
    }

    $scope.updateBondTradeTotals = function (type) {
        if (type === 'classTotal') {
            $scope.current.bondTrade.classTotal = verbose.bondTrade.cashPercent + verbose.bondTrade.equityPercent + verbose.bondTrade.bondPercent;
        }

        if (type === 'termTotal') {
            $scope.current.bondTrade.termTotal = verbose.bondTrade.shortTermBondPercent + verbose.bondTrade.intermediateTermBondPercent;
        }
    };

    $scope.runReport = function () {
        $portfolio.runReport(entities.account.value, args.ids[0]);
    };

    $scope.openEditor = function () {
        const extraInfo = {fkClient: verbose.portfolio.clientId, fkAccount: args.ids[0]};
        $portfolio.openEditor(entities.asset.value, [], null, null, apps.portfolioLists.name, extraInfo);
    };

    $scope.editFeeSchedule = function () {
        $scope.feeScheduleObj.action = 'edit';
        $scope.feeScheduleObj.feeScheduleId = verbose.billing.feeScheduleId;
        $scope.feeScheduleObj.feeScheduleType = 'fee';
        $scope.feeScheduleObj.isFeeScheduleOpen = true;
    }

    $scope.onCloseFeeSchedule = function (event) {
        $scope.feeScheduleObj.action = '';
        $scope.feeScheduleObj.feeScheduleId = 0;
        $scope.feeScheduleObj.isFeeScheduleOpen = false;
        if(event != 0) {
            loadFeeSchedule(); //reload back to edit account modal
        }
    };

    $scope.editPayoutSchedule = function () {
        $scope.payoutScheduleObj.action = 'edit';
        $scope.payoutScheduleObj.payoutScheduleId = verbose.billing.masterPayoutScheduleId;
        $scope.payoutScheduleObj.isPayoutScheduleOpen = true;
    }

    $scope.onClosePayoutSchedule = function (event) {
        $scope.payoutScheduleObj.action = '';
        $scope.payoutScheduleObj.payoutScheduleId = 0;
        $scope.payoutScheduleObj.isPayoutScheduleOpen = false;
        if(event != 0) {
            loadBillingGeneral(); //reload back to edit account modal
        }
    };

    $scope.close = function (validate) {
        if (validate && (!angular.equals(original, verbose) || !angular.equals(changeHistoryOriginal, $scope.chsts))) {
            $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true});
        } else {
            editorHotKeys.destroy();
            if (dialog) {
                dialog.close(null);
            } else {
                window.parent.postMessage("iframeclose");
            }
        }
    };
    //endregion

    //region GENERAL
    $scope.toggleRegLookUp = function (isLookUpMode) {
        $scope.current.showRegLookUp = isLookUpMode;
    };
    //endregion

    //region CREDIT CARD
    $scope.viewCardInfo = function () {
        if (args.ids[0] > 0 && verbose.billing.creditCardNumber.indexOf('*') != -1) {
            $dialog.inputBox("Reason to View Credit Card Number", "Reason", "textarea")
                .open()
                .then(function (rslt) {
                    if (rslt && rslt.trim().length > 0) {
                        $http.put('/Billing/Accounts/' + args.ids[0] + '/CreditCardNumber', "'" + rslt + "'", {trackerMsg: 'Getting credit card information'})
                            .then(function (response) {
                                const data = response.data;
                                verbose.billing.creditCardNumber = data;
                                $scope.current.allowEditCC = true;
                            });
                    }
                });
        }
    };
    //endregion

    //region SLOAs
    $scope.addSloa = function () {
        verbose.compliance.sloas.push({
            sloaDate:'',
            isActive:true,
            thirdParty:'',
            isAffiliated:false,
            distributionType:'',
            notes:''
        });
    };

    $scope.removeSloa = function (sloa) {
        //Remove the SLOA from the list
        if (!sloa) return;
        verbose.compliance.sloas.remove(sloa);
    };
    // endregion


    //region SYSTEMATICS
    $scope.addSystematic = function () {
        const systematic = {
            isActive: true,
            isDoubleCheck: false,
            type: 1,
            swpAmount: 0,
            isProrated: true,
            isCashFundingIgnored: false,
            frequency: "Monthly",
            cycleMonth: 1,
            startDate: Date.create().formatted(),
            endDate: null,
            transactionDay: 1,
            custodialSWPDate: 24,
            taxesWithheld: 0,
            stateTax: 0,
            source: 0,
            dataEntryMethod: 0,
            lifeType: 1,
            isSpouse: false,
            isAutoRmd: false,
            billProductGroups: [],
            isTaxWithType: systematicTaxWithType.dollar.name
        };

        $scope.editSystematic(systematic, true);
    };

    $scope.editSystematic = function (sys, isAdd) {
        $dialog.dialog({dialogClass: "modal wide", templateUrl: 'portfolio/views/systematic.html', controller: 'SystematicCtrl', resolve: {
            systematicData: function () { return angular.copy(sys); },
            accountId: function () { return args.ids[0]; }
        }})
            .open()
            .then(function (result) {
                if (!result) return;

                setSystematicDescription(result);

                if (isAdd) {
                    verbose.systematics.push(result);
                } else {
                    const systematicIndex = verbose.systematics.findIndex({ id: sys.id });
                    if (systematicIndex >= 0) {
                        verbose.systematics[systematicIndex] = result;
                    }
                }
            });
    };

    $scope.removeSystematic = function (sys) {
        $dialog.confirmAction("Are you sure you want to remove this systematic record?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    verbose.systematics.remove(sys);
                }
            });
    };

    $scope.viewSystematicAuditHistory = function (id) {
        if (!$scope.auditSystematics) {
            $scope.auditSystematics = {startDate: Date.create('beginning of last year').formatted(), endDate: Date.create().formatted()};
        }

        $http.get("/Portfolio/SystematicAccount/" + id + "/Audit?$orderby=AuditDate desc&startDate=" + $scope.auditSystematics.startDate + "&endDate=" + $scope.auditSystematics.endDate, {trackerMsg: 'Loading systematic audit history'})
            .then(function (response) {
                const data = response.data;
                $scope.auditSystematics.data = data;

                if (!data.length) return;

                const swpSources = {1: "Direct", 2: "Custodial", 3: "Custodial/Direct"},
                    dataEntryMethods = {1: "AutoTrade", 2: "Download", 3: "HandEntry"},
                    transferMethods = {1: "ACH", 2: "Mail"},
                    lifeTypes = {1: "Single Life", 2: "Joint Life"},
                    frequencies = {Quarterly: "quarter", Semiannually: "half year", Annually: "year"};

                data.forEach(function (audit) {
                    audit.swpSourceDescr = swpSources[audit.swpSource] || "None";
                    audit.dataEntryMethodDescr = dataEntryMethods[audit.dataEntryMethod] || "None";
                    audit.howTransferredDescr = transferMethods[audit.howTransfered] || "";
                    audit.lifeTypeDescr = lifeTypes[audit.lifeType] || "";
                    audit.frequencyDescr = audit.transactionDay.ordinalize() + " day of " + (audit.swpFrequency === "Monthly" ? "every month" : ("the " + audit.swpCycleMonth.ordinalize() + " month of every " + frequencies[audit.swpFrequency]));
                });

                $http.get('/Trading/DistributionCodes/Simple', {cache: true, trackerMsg: 'Loading distribution codes'})
                    .then(function (response) {
                        const codes = response.data;
                        $scope.auditSystematics.data.forEach(function (audit) {
                            if (audit.distributionCodeId) {
                                audit.distributionCodeDescr = codes.find({id: audit.distributionCodeId}).name;
                            }
                        });
                    });
            });
    };

    //endregion

    // region CHANGE HISTORY
    $scope.deleteChangeHistory = function (chst) {
        $dialog.confirmAction("<span> Are you sure you want to delete this record? " + (chst.isUncommitted ? "" : " You will have to manually update the account to its previous setting.") + "</span>")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    if (!chst.isUncommitted) {
                        changeHistoryToDelete.push(chst.id);
                    }
                    $scope.chsts.remove(chst); //
                }
            });
    };
    $scope.addChangeHistory = function () {
        const chgHistInfo = {
            accountIds: args.ids,
            asOfDate: ($scope.chsts.find({isUncommitted: true}) || {asOfDate: null}).asOfDate,
            compositeExclusions: $scope.compositeExclusions,
            fundFamily: $scope.verbose.portfolio.fundFamily,
            custodian: $scope.verbose.portfolio.custodian
        };

        $dialog.dialog({dialogClass: "modal wide", templateUrl: 'portfolio/views/changeHistory.html', controller: 'ChangeHistoryCtrl', resolve: {chgHistData: function () {return chgHistInfo;}}})
            .open()
            .then(function (resultCH) {
                if (resultCH) {
                    $scope.chsts.insert(resultCH, 0);

                    $scope.chsts.findAll({isUncommitted: true, entity: 'Composite Exclusions'}).forEach(function (item) {
                        verbose.compositeExclusions = verbose.compositeExclusions || []; //initalize the array if undefined

                        verbose.compositeExclusions.push({
                            id: item.id,
                            startDate: Date.create(item.asOfDate),
                            endDate: Date.create(item.asOfDate).addMonths(item.newEntityName - 1),
                            reason: 'Account Change'
                        });
                    });
                }
            });
    };

    $scope.deleteCompositeExclusions = function (exclusion) {
        $dialog.confirmAction("Are you sure you want to delete this record?")
            .open()
            .then(function (result) {
                if (result === "yes") {
                    verbose.compositeExclusions.remove(exclusion);
                }
            });
    };

    //endregion

    // region BILLING GENERAL
    $scope.setCycleMonths = function (frequency) {
        setCycleMonths(frequency);
    };

    $scope.addPaysForAccount = function () {
        const accounts = [];
        relatedHouseholdAccounts.forEach(function (account) {
            if (account.id !== args.ids[0] && verbose.billing.paysForAccounts.none({accountId: account.id})) {
                if(!excludepaybyaccountid.includes(account.id))
                    accounts.push({id: account.id, name: account.id + ": " + account.number + ' (' + account.name + ')' + ' - Active -' + (account.isActive ? ' True ' : ' False')});
            }
        });

        $dialog.dialog({dialogClass: "modal medium", templateUrl: "account-pays-for.html", controller: "AccountPaysForCtrl", accounts: accounts})
            .open()
            .then(function(rslt){
                if (!rslt) return;

                if (verbose.billing.paysForAccounts.any({accountId: rslt.id}) || (excludepaybyaccountid.includes(rslt.id))){
                    let wmsg = "No account has been added.  This account(" + rslt.id + ") has already been added.";
                    if ( excludepaybyaccountid.includes(rslt.id))
                        wmsg = "No account has been added.  This account(" + rslt.id + ") has paid for another account and can't be added.";
                    $dialog.actionFailed(wmsg).open();
                    return;
                }

                $http.get("/Portfolio/Accounts/" + rslt.id, {cache: true, trackerMsg: 'Loading account'})
                    .then(function (response) {
                        const data = response.data;
                        verbose.billing.paysForAccounts.push({
                            accountId: data.id,
                            accountNumber: data.number,
                            isActive: true, // WI 8065 always set to true
                            percent: 100,
                            accountSummary: data.name + ' (' + data.id + ') - ' + data.fundFamily
                        });
                    });
            });
    };

    $scope.removePaysForAccount = function (account) {
        $dialog.confirmAction("Are you sure you want to remove this account?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    verbose.billing.paysForAccounts.remove(account);
                }
            });
    };

    $scope.removePayedBy = function (acct) {
        $dialog.confirmAction("Are you sure you want to remove this account?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    verbose.billing.payedByAccounts.remove(acct);
                }
            })
    };
    //endregion

    //region RECURRING ADJUSTMENT
    $scope.addRecurringAdj = function () {
        verbose.recurringAdjustments.push({
            additionalAnnualAmount: 0.00,
            additionalAnnualAmountType: 0,
            billScheduleId: 0,
            billAjdTypeId: 0,
            billEntityId: 0,
            entityId: 0,
            EntityEnum: parseInt(entities.client.value),
            FkEntity: args.ids[0]
        });
    };

    $scope.removeRecurringAdj = function (adj) {
        $dialog.confirmAction("Are you sure you want to remove the recurring adjustment?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    verbose.recurringAdjustments.remove(adj);
                }
            });

    };
    //endregion

    //region GENERAL ACCOUNT
    $scope.addGeneralAccount = function (isSingle, isNew) {
        $scope.editGeneralAccount(verbose.generalAccounts, isSingle, isNew)
    };

    $scope.editGeneralAccount = function (ga, isSingle, isNew) {
        feeSchedulePromise.then(function () {
            const config = {parentId: args.ids[0], gas: verbose.generalAccounts, adjTypes: $scope.adjTypes, isSingle: isSingle, isNew: isNew, billingEntities: $scope.billingEntities, feeSchedule: feeSchedule};

            if (isSingle) {
                if (isNew && ga.length > 0) {
                    const newGa = angular.copy(ga[0]);
                    newGa.id = "new";
                    config.gas = [newGa];
                }
                else {
                    if (ga && ga.isNew) {
                        ga.id = "new";
                    }
                    config.gas = [ga];
                }
            }

            $dialog.dialog({dialogClass: "modal wide", templateUrl: 'portfolio/views/generalAccount.html', controller: 'GeneralAccountCtrl', resolve: {args: function () {return config;}}})
                .open()
                .then(function (result) {
                    if (result) {
                        if (isNew) {
                            result.each(function (ga) {
                                ga.entity = parseInt(entities.account.value);
                                verbose.generalAccounts.push(ga);
                            });
                        } else {
                            result.each(function (ga) {
                                const sel = verbose.generalAccounts.findIndex({id: ga.id});

                                // Update selected
                                if (sel != -1) {
                                    if (ga.isNew) ga.id = null;
                                    verbose.generalAccounts[sel] = ga;
                                }
                            });
                        }

                    }
                });
        });


    };

    $scope.clearReportableFields = function(field){

        switch (field){
            case '13f':
                if(!$scope.verbose.compliance.is13FReportable) return;
                $scope.verbose.compliance.isAuaReportable = false;
            case 'adv':
                if(!$scope.verbose.compliance.isAdvReportable) return;
                $scope.verbose.compliance.isAuaReportable = false;
            case 'aua':
                if(!$scope.verbose.compliance.isAuaReportable) return;

                if($scope.verbose.compliance.isAdvReportable || $scope.verbose.compliance.is13FReportable ){
                    var buttons = [{result:'continue', label: 'Continue', cssClass: 'btn-primary'}, {result:'cancel', label: 'Cancel', cssClass: 'pull-left'}];
                    $dialog.messageBox("Warning", "By selecting this option, this account will not be counted toward your ADV and 13f totals.",buttons)
                        .open()
                        .then( function(result){
                            if(result =='cancel'){
                                $scope.verbose.compliance.isAuaReportable = false;
                                return;
                            } else {
                                $scope.verbose.compliance.isAdvReportable = false;
                                $scope.verbose.compliance.is13FReportable = false;
                            }
                        })
                }
                return;
        }

    };


    $scope.removeGeneralAccount = function (ga) {
        $dialog.confirmAction("Are you sure you want to remove this general account record?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    verbose.generalAccounts.remove(ga);
                }
            });
    };
    //endregion

    //region REFERRAL SCHEDULES
    $scope.addReferralSchedule = function () {

        verbose.referralSchedules.push({
            id: 0,
            billEntityId: null,
            payee: null,
            payoutType: 'Perpetual',
            payoutFrequency: 'Quarterly',
            startDate: Date.create('today'),
            amountType: "Percent",
            amounts: "0",
            completeDate: null
        });
    };


    $scope.deleteReferralSchedule = function (idx) {
        $dialog.confirmAction("Are you sure you want to remove this referral schedule record?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    verbose.referralSchedules.splice(idx, 1);
                }
            });
    };
    //endregion

    //region NOTES AND DOCUMENTS
    $scope.syncNewDocument = function (newDocument) {
        original.documents.push(newDocument);
    };
    //endregion

    //region ACCOUNT MANAGER
    $scope.addAcctManager = function () {
        $http.get('/Portfolio/Accounts/AccountManagers', {cache: true, trackerMsg: 'Loading account managers'})
            .then(function (response) {
                const data = response.data;
                const managers = [];
                data.forEach(function (manager) {
                    if (verbose.accountManagers.none({entityId: manager.entityId})) {
                        managers.push(angular.extend({name: manager.entityName + " (" + manager.entity + ")"}, manager));
                    }
                });

                $dialog.inputBox("Add Manager", "Manager", managers.sortBy("name"))
                    .open()
                    .then(function (rslt) {
                        if (rslt) {
                            verbose.accountManagers.push(rslt);
                        }
                    });
            });
    };

    $scope.removeAccountManager = function (accountManager) {
        $dialog.confirmAction("Are you sure you want to remove this account manager?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    verbose.accountManagers.remove(accountManager);
                }
            });
    };
    //endregion

    //region LASERAPP
    $scope.noFormSelected = function () {
        return $scope.formsLibrary && $scope.formsLibrary.none({selected: true});
    };

    $scope.launchLaserApp = function () {
        const formSelection = angular.copy($scope.formsLibrary.findAll({selected: true}));
        formSelection.forEach(function (form) {
            delete form.selected;
        });

        $http.post('/Integrations/LaserApp/Accounts/' + args.ids[0] + "/Submit", formSelection, {trackerMsg: 'Launching LaserApp'})
            .then(function (response) {
                window.open(response.headers("location"));
            });
    };
    //endregion


    //region FUTURE CASH FLOWS
    $scope.addFutureCashFlow = function () {
        verbose.futureCashflows.push({
            id: null,
            name: '',
            startDate: Date.create(),
            endDate: Date.create(),
            frequency: 0,
            daysIntoPeriod: 0,
            amount: 0.00
        });
    };

    $scope.removeFutureCashFlow = function (cf) {
        $dialog.confirmAction("Are you sure you want to remove the future cashflow?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    verbose.futureCashflows.remove(cf);
                }
            });

    };
    //endregion

    //region GOALS
    $scope.addGoal = function () {
        verbose.goals.push({
            id: null,
            name: '',
            startDate: $scope.current.defaultGoalStartDate,
            endDate: Date.create(),
            amount: 0.00
        });
    };

    $scope.removeGoal = function (g) {
        $dialog.confirmAction("Are you sure you want to remove the goal?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    verbose.goals.remove(g);
                }
            });

    };
    //endregion

    //region GROWTH RATES
    $scope.addGrowthRate = function () {
        verbose.growthRates.push({
            asOfDate: Date.create().formatted(),
            annualGrowthRate: 0.00
        });
    };

    $scope.removeGrowthRate = function (gr) {
        $dialog.confirmAction("Are you sure you want to remove the growth rate?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    verbose.growthRates.remove(gr);
                }
            });
    };


    //endregion

    //region TAX RATES
    $scope.addTaxRate = function () {
        verbose.taxRates.push({
            id: 0,
            asOfDate: Date.create().formatted(),
            shortTermRate: 0.00,
            longTermRate: 0.00
        });
    };

    $scope.removeTaxRate = function (tr) {
        $dialog.confirmAction("Are you sure you want to remove the tax rate?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    verbose.taxRates.remove(tr);
                }
            });
    };


    //endregion

    //endregion

    //endregion

    //region INITIALIZE
    $scope.verbose = verbose;

    $scope.current = {
        accountId: null,
        selectedRegistration: null,
        hhRegistrations: null,
        showRegLookUp: false,
        allowEditCC: false,
        canReadCreditCard: $oasRights.canUpdate("CREDITCARDVIEWING"),
        canChangeNoFeeAggregate: $oasRights.canUpdate("NOFEEAGGREGATE"),
        accountNumber: null,
        isBadLinkedAccount: false,
        isFullPage: false,
        noteCategories: [],
        targetAllocationType: "",
        bondTrade: {classTotal: 0, termTotal: 0},
        portfolioGroups: [],
        useAutoAssignSchedules: false,
        defaultGoalStartDate: Date.create(),
        useModelGroupNumbers: true,
        singleTabMode: args.defaultTab.code === 'astroRestrictions' && args.isFullPage,
        showCancel: false,
        canSave: true,
        feeAggregateOptions: ["Default", "No Fee/No Pay", "Always Payout"],
        inBalanceStatusIcon: null,
        inBalanceStatusHeader: null,
        inBalanceStatusBody: null,
        inBalanceStatusFooter: null,
        defaultEclipseFirmName: null,
    };

    $scope.thirdPartyHelp = "This field is used to record the name of the third party to whom the funds were distributed.";
    $scope.distributionTypes = ['Check','EFT','Journal','Wire','Other'];

    $scope.astroRestrictionTypes = ["Do Not Buy", "Do Not Sell", "Do Not Trade", "Sell All Shares", "Bring Weight Exactly To", "Percent (Min/Max Weight)"];
    $scope.astroCashRestrictionTypes = ["Sell All Shares", "Bring Weight Exactly To", "Percent (Min/Max Weight)"];

    $scope.productClasses = null;

    $scope.eclipseSMA = ["True", "False", "Follow Orion"];

    $scope.linkedAccountFieldMap = [{name: "ID", value: "id"}, {name: "Number", value: "number"}, {name: "Fund Name", value: "fundFamily"}, {name: "Class", value: "shareClass"}, {name: "Custodian", value: "custodian"}, {
        name: "Mgmt Style",
        value: "managementStyle"
    }];

    if (args.ids != null) {
        $scope.current.accountId = args.ids.length > 1 ? 0 : parseInt(args.ids[0]);
    }

    if (args.isFullPage) {
        $scope.current.isFullPage = args.isFullPage;
    }

    if (args.showCancel) {
        $scope.current.showCancel = args.showCancel;
    }

    $scope.errors = [];

    $scope.systematicTaxWithType = systematicTaxWithType;

    $scope.isSaving = false;

    $scope.billingDataMissing = false;


    init();
    //endregion


    //region WATCHES
    $scope.$watch('current.selectedRegistration', function (newVal, oldVal) {
        if (newVal === oldVal || !newVal) return;

        let reg;

        if (!$scope.current.hhRegistrations) {
            $scope.current.hhRegistrations = [];
        } else {
            reg = $scope.current.hhRegistrations.find({id: newVal.id});
        }

        if (!reg) {
            $http.get("/Portfolio/Registrations/" + newVal.id, {trackerMsg: 'Loading registration'})
                .then(function (response) {
                    const data = response.data;
                    delete data.notes;
                    delete data.beneficiaries;
                    delete data.suitability;

                    data.description = data.id + ' - ' + data.name + ', ' + data.typeCode;

                    $scope.current.hhRegistrations.push(data);
                    verbose.portfolio.registrationId = data.id;
                    verbose.portfolio.registrationName = data.name;

                });
        } else {
            verbose.portfolio.registrationId = reg.id;
            verbose.portfolio.registrationName = reg.name;
        }

        $scope.current.showRegLookUp = false;

        const data = {id: 0, portfolio: {registrationId: newVal.id}};
        loadLinkedAccounts(data)

    });

    //Astro Settings validations
    // Comments added for future understanding of code flow.
    $scope.astroIssues = [];
    $scope.astroValidate = false;

    $scope.getQuarterFromMonth = function (m) {
        return Math.floor(m / 3) + 1; // m = 0..11
    };

    $scope.currentQuarter = function () {
        return $scope.getQuarterFromMonth(new Date().getMonth());
    };

    $scope.isQuarterRequired = function (ts, qIdx) {
        var cy = $scope.currentYear; // already set in controller
        var cq = $scope.currentQuarter();
        // future years: all required
        if (ts.year > cy) return true;
        // current year: require currentQuarter..Q4
        if (ts.year === cy) return qIdx >= cq;
        // past years: not required
        return false;
    };

    $scope.isQuarterDisabled = function (ts, qIdx) {
        var cy = $scope.currentYear;
        var cq = $scope.currentQuarter();
        return ts.year === cy && qIdx < cq; // disable earlier quarters
    };


    $scope.checkAstroSettingsValidation = function (f) {
        const issues = [];
        if(!$scope.astroValidate){
            return issues.length === 0;
        }

        // Friendly map for top-of-form (Account Restrictions) fields ONLY
        var astroFieldMeta = {
            shortTermTaxRate: { label: 'Short Term Tax Rate', section: 'Account Restrictions' },
            longTermTaxRate:  { label: 'Long Term Tax Rate',  section: 'Account Restrictions' },
            maxRealizedGain:  { label: 'Current Max Annual Cap Gain', section: 'Account Restrictions' },
            currentMaxAnnualCapGain: { label: 'Current Max Annual Cap Gain', section: 'Account Restrictions' },
            ticketCharge:     { label: 'Ticket Charge', section: 'Account Restrictions' }
        };

        function metaFor(name){
            return astroFieldMeta[name] || null; // return null for non-mapped controls
        }
        function prefix(section, msg){ return (section ? section + ': ' : '') + msg; }

        // Decide whether a row is on Asset or Security tab (uses your existing filters)
        function sectionForItem(item){
            try {
                var isAssetPred = $scope.assetFilter && $scope.assetFilter(true);
                if (typeof isAssetPred === 'function' && isAssetPred(item)) return 'Asset';
                var isSecPred = $scope.assetFilter && $scope.assetFilter(false);
                if (typeof isSecPred === 'function' && isSecPred(item)) return 'Security';
            } catch(e){ }
            return 'Asset/Security';
        }

        f = f || $scope.astroRestrictionsForm;

        // 1) Angular built-in validation — but ONLY for mapped top-of-form fields.
        if (f && f.$error) {
            angular.forEach(f.$error, function (controls, errorType) {
                (controls || []).forEach(function (ctrl) {
                    var name = ctrl.$name;
                    var m = metaFor(name);
                    if (!m) return; // skip asset/security cells or any non-mapped control

                    var msg = null;
                    switch (errorType) {
                        case 'required': msg = m.label + ' is required.'; break;
                        case 'number':   msg = m.label + ' must be a valid number.'; break;
                        case 'min':      msg = m.label + ' must be GREATER THAN OR EQUAL TO 0.'; break;
                        case 'max':      msg = m.label + ' must be LESS THAN OR EQUAL TO 100'; break;
                    }
                    if (msg) {
                        msg = prefix(m.section, msg);
                        if (issues.indexOf(msg) === -1) issues.push(msg);
                    }
                });
            });
        }

        // 2) Sector/Industry — validate numbers, range, and Min<=Max (values optional)
        if ($scope.verbose?.astroAccount?.sectors) {
            function has(v){ return v !== null && v !== undefined && v !== ''; }
            function nn(v){ return +v; }

            $scope.verbose.astroAccount.sectors.forEach(function (sec) {
                var sMin = sec.minimumValue, sMax = sec.maximumValue;

                // Sector range/type
                if (has(sMin)) {
                    var n = nn(sMin);
                    if (isNaN(n)) issues.push(prefix('Sector/Industry', 'Sector "' + sec.name + '": Min % Weight must be a valid number.'));
                    else if (n < 0 || n > 100) issues.push(prefix('Sector/Industry', 'Sector "' + sec.name + '": Min % Weight must be between 0 and 100.'));
                }
                if (has(sMax)) {
                    var n = nn(sMax);
                    if (isNaN(n)) issues.push(prefix('Sector/Industry', 'Sector "' + sec.name + '": Max % Weight must be a valid number.'));
                    else if (n < 0 || n > 100) issues.push(prefix('Sector/Industry', 'Sector "' + sec.name + '": Max % Weight must be between 0 and 100.'));
                }
                if (has(sMin) && has(sMax) && !isNaN(nn(sMin)) && !isNaN(nn(sMax)) && nn(sMin) > nn(sMax)) {
                    issues.push(prefix('Sector/Industry', 'Sector "' + sec.name + '": Min % Weight cannot exceed Max % Weight.'));
                }

                // Industries within this sector
                (sec.industries || []).forEach(function (ind) {
                    var iMin = ind.minimumValue, iMax = ind.maximumValue;

                    if (has(iMin)) {
                        var n = nn(iMin);
                        if (isNaN(n)) issues.push(prefix('Sector/Industry', 'Industry "' + ind.name + '": Min % Weight must be a valid number.'));
                        else if (n < 0 || n > 100) issues.push(prefix('Sector/Industry', 'Industry "' + ind.name + '": Min % Weight must be between 0 and 100.'));
                    }
                    if (has(iMax)) {
                        var n = nn(iMax);
                        if (isNaN(n)) issues.push(prefix('Sector/Industry', 'Industry "' + ind.name + '": Max % Weight must be a valid number.'));
                        else if (n < 0 || n > 100) issues.push(prefix('Sector/Industry', 'Industry "' + ind.name + '": Max % Weight must be between 0 and 100.'));
                    }
                    if (has(iMin) && has(iMax) && !isNaN(nn(iMin)) && !isNaN(nn(iMax)) && nn(iMin) > nn(iMax)) {
                        issues.push(prefix('Sector/Industry', 'Industry "' + ind.name + '": Min % Weight cannot exceed Max % Weight.'));
                    }
                });
            });
        }

        // 3) Asset/Security rows
        if ($scope.verbose?.astroAccount?.assets) {
            $scope.verbose.astroAccount.assets.forEach(function (a) {
                var needsWeights = ['Bring Weight Exactly To', 'Percent (Min/Max Weight)'].indexOf(a.restrictionType) >= 0;
                if (!needsWeights) return;

                var sect  = sectionForItem(a);
                var label = a.productName || a.ticker || 'Security';

                var hasMin = a.minPercentWeight !== null && a.minPercentWeight !== undefined && a.minPercentWeight !== '';
                var hasMax = a.maxPercentWeight !== null && a.maxPercentWeight !== undefined && a.maxPercentWeight !== '';

                // If value present, validate range first (allowInvalid keeps 101 here)
                if (hasMin) {
                    var min = +a.minPercentWeight;
                    if (isNaN(min)) {
                        issues.push(prefix(sect, label + ': Min % Weight must be a valid number.'));
                    } else if (min < 0 || min > 100) {
                        issues.push(prefix(sect, label + ': Min % Weight must be between 0 and 100.'));
                    }
                }
                if (hasMax) {
                    var max = +a.maxPercentWeight;
                    if (isNaN(max)) {
                        issues.push(prefix(sect, label + ': Max % Weight must be a valid number.'));
                    } else if (max < 0 || max > 100) {
                        issues.push(prefix(sect, label + ': Max % Weight must be between 0 and 100.'));
                    }
                }

                if (!hasMin && !hasMax) {
                    issues.push(prefix(sect, label + ': Enter at least one of Min % Weight or Max % Weight.'));
                }

                // Consistency (only if both present and numeric)
                if (hasMin && hasMax && !isNaN(+a.minPercentWeight) && !isNaN(+a.maxPercentWeight)) {
                    if (+a.minPercentWeight > +a.maxPercentWeight) {
                        issues.push(prefix(sect, label + ': Min % Weight cannot exceed Max % Weight.'));
                    }
                }
            });
        }

        // 4) Tax Schedule — cumulative/YTD model (matches calculateMaxAnnualCapGain)
        // Rules:
        // - Each Q in [0, 100], numeric
        // - For the current year: Q4 is required and must be 100
        // - For future years: all Q1–Q4 required
        // - When all quarters are present: enforce Q1 ≤ Q2 ≤ Q3 ≤ Q4
        if ($scope.verbose?.astroTaxSchedules) {
            var cy = $scope.currentYear;

            $scope.verbose.astroTaxSchedules.forEach(function (ts) {
                function n(v){ return (v === 0 || v) ? +v : null; }
                var q1 = n(ts.q1Percent),
                    q2 = n(ts.q2Percent),
                    q3 = n(ts.q3Percent),
                    q4 = n(ts.q4Percent);

                // Type/range checks for any provided quarters
                [['Q1', q1], ['Q2', q2], ['Q3', q3], ['Q4', q4]].forEach(function ([label, v]) {
                    if (v == null) return;                  // completeness handled below
                    if (isNaN(v))  issues.push(prefix('Tax Schedule', ts.year + ': ' + label + ' must be a valid number.'));
                    else if (v < 0 || v > 100)
                        issues.push(prefix('Tax Schedule', ts.year + ': ' + label + ' must be between 0 and 100.'));
                });

                var allDefined = (q1 != null && q2 != null && q3 != null && q4 != null);

                // ---- CURRENT YEAR rules ----
                if (ts.year === cy) {
                    var cq = $scope.currentQuarter(); // 1..4
                    var provided = [q1, q2, q3, q4];

                    // Require current-quarter..Q4 to be present
                    for (var i = cq; i <= 4; i++) {
                        if (provided[i-1] === null) {
                            issues.push(prefix('Tax Schedule', ts.year + ': Q' + i + ' is required.'));
                        }
                    }

                    // Q4 must always be 100 for current year
                    if (q4 != null && q4 !== 100) {
                        issues.push(prefix('Tax Schedule', ts.year + ': Q4 must be 100%.'));
                    }

                    // If values exist in order, enforce non-decreasing across the defined ones
                    // (e.g., in August (Q3), enforce Q3 ≤ Q4; in June (Q2), enforce Q2 ≤ Q3 ≤ Q4)
                    var pairs = [[q1,q2,'Q1','Q2'], [q2,q3,'Q2','Q3'], [q3,q4,'Q3','Q4']];
                    pairs.forEach(function([a,b,la,lb], idx){
                        // only compare from current quarter boundary forward
                        if (idx+1 >= cq-1) {
                            if (a != null && b != null && a > b) {
                                issues.push(prefix('Tax Schedule', ts.year + ': ' + la + ' ≤ ' + lb + ' is required.'));
                            }
                        }
                    });
                }

                // ---- FUTURE YEAR rules ----
                if (ts.year > cy) {
                    if (!allDefined) {
                        issues.push(prefix('Tax Schedule', ts.year + ': all four quarter percentages (Q1–Q4) are required.'));
                    } else {
                        // NEW: Q4 must always be 100 for future years too
                        if (q4 !== 100) {
                            issues.push(prefix('Tax Schedule', ts.year + ': Q4 must be 100%.'));
                        }
                        // existing monotonic rule
                        if (q1 > q2 || q2 > q3 || q3 > q4) {
                            issues.push(prefix('Tax Schedule', ts.year + ': Q1 ≤ Q2 ≤ Q3 ≤ Q4 is required.'));
                        }
                    }
                }
            });
        }

        $scope.astroIssues = issues;
        $scope.isSaving = issues.length > 0;
        $scope.current.astroHasErrors = issues.length > 0;
        return issues.length === 0;
    };
    //endregion
});

app.controller('AccountCompareCtrl', function AccountCompareCtrl($scope, $http, $oasRights, $timeout, dialog) {
    //PRIVATE METHODS
    function init() {
        $scope.analyzer.account = dialog.options.account;
        $scope.analyzer.isActiveTab = true;

        $timeout(function () {
            $scope.$broadcast('event:refresh-analyzer', {analyzer: $scope.analyzer, action: 'load-analyzer', forceRefresh: false, includePendingValue: false});
        });
    }

    $scope.close = function(){
        if (dialog) {
            dialog.close();
        } else {
            window.parent.postMessage("iframeclose");
        }
    };

    //PRIVATE
    //INITIALIZE
    $scope.analyzer = {groupingType: "0", usePendingValue: 'current', tableMode: "percent", lastAnalyzedId: 0, sortField: '', sortReverse: false};
    $scope.analyzer.chart = {
        options: {
            chart: {type: 'bar', borderWidth: 0},
            credits: {enabled: false},
            legend: {enabled: true, borderWidth: 0},
            xAxis: {
                categories: [], labels: {
                    formatter: function () {
                        return this.value.length > 6 ? this.value.first(3) + "..." : this.value;
                    }
                }
            },
            yAxis: {
                title: {text: ''}, labels: {
                    formatter: function () {
                        return this.value === 0 ? 'Target' : this.value + ' %';
                    }
                }
            },
            plotOptions: {bar: {grouping: false, shadow: false, pointPadding: 0}},
            tooltip: {
                formatter: function () {
                    const chart = this.points[0].series.chart;
                    const categories = chart.xAxis[0].categories;
                    const temp = {};
                    let index = 0;

                    while (this.x !== categories[index]) {
                        index++;
                    }
                    chart.series.forEach(function (series) {
                        temp[series.name] = series.yData[index];
                    });

                    const target = temp['Target'].round(2);
                    const bottom = (temp['Target'] + temp['Lower']).round(2);
                    const top = (temp['Target'] + temp['Upper']).round(2);
                    const range = bottom === target && top === target ? '' : '<br/>Range: ' + bottom + ' - ' + top + ' %';
                    const curr = parseFloat(temp['Current']) + target;

                    return '<b>' + this.x + '<br/>Target: ' + target + ' %' + range + '<br/>Current: ' + curr + ' %';
                },
                shared: true,
                shadow: false,
                borderColor: "#CCCCCC"
            }
        },
        series: [
            {data: [], name: 'Lower', borderColor: "#00AEEF", color: "rgba(0, 170, 239, 0.1)"},
            {data: [], name: 'Upper', borderColor: "#00AEEF", color: "rgba(0, 170, 239, 0.1)"},
            {data: [], name: 'Current', borderColor: "#00AEEF", color: '#00AEEF', pointPadding: 0.2},
            {data: [], name: 'Target', visible: false, showInLegend: false}
        ],
        title: {text: ''},
        subtitle: {text: null}
    };

    init();
});

app.controller('AssetLevelFeeSchedulesCtrl', function AssetLevelFeeSchedulesCtrl($scope, $http, $oasRights, dialog) {
    //PRIVATE VARIABLES
    let billScheduleTemplate;


    //PRIVATE METHODS
    function init() {
        $scope.rightsAssetFeeSchedules = $oasRights.forCode("ASSETBILLING");
        $scope.current.billAccountSchedules = !dialog.options.billSchedules.isEmpty() ? dialog.options.billSchedules : [];
        $scope.current.billAccountSchedules.forEach(function (item) {
            if (item.category) {
                item['category'] = {id: item['category'], name: item['category'], isEditMode: false};
            }
            if (item.productClass) {
                item['productClass'].isEditMode = false;
            }
            if (item.riskCategory) {
                item['riskCategory'].isEditMode = false;
            }
            if (item.productCategory) {
                item['productCategory'].isEditMode = false;
            }
            if (item.ticker) {
                item['ticker'].isEditMode = false;
            }
        });
        setScheduleName();
        loadFeeSchedules();
        $scope.getSimpleListForDropDown();

    }

    function loadFeeSchedules() {
        $http.get('/Billing/Schedules/Simple?schedule=1', {trackerMsg: 'Loading fee schedules'})
            .then(function (response) {
                $scope.fesScheduleList = response.data;
            });
    }

    function setScheduleName() {
        if ($scope.current.assignmentType === 0) return;
        $scope.current.assignmentTypeName = $scope.assignmentTypes.find({id: $scope.current.assignmentType}).propName;
    }


    //PUBLIC METHODS
    $scope.save = function () {
        //before save go through array to set the assignment type and if necessary change Product Category (category) to single property object.
        $scope.current.billAccountSchedules.forEach(function (schedule) {
            schedule.assignmentType = $scope.assignmentTypes[$scope.current.assignmentType].name;
            if (schedule.assignmentType === 'Product Category') {
                //remove properties on this object and set its value from the name property
                schedule['category'] = schedule.category.name;
            }
        });
        if (dialog) {
            dialog.close($scope.current.billAccountSchedules);
        } else {
            window.parent.postMessage("iframeclose");
        }
    };

    $scope.close = function () {
        if (dialog) {
            dialog.close(null);
        } else {
            window.parent.postMessage("iframeclose");
        }
    };

    $scope.categoryListChange = function (schedule, selectedId) {
        schedule.assignmentType = $scope.assignmentTypes.find({propName: $scope.current.assignmentTypeName}).name;
        schedule[$scope.current.assignmentTypeName].name = $scope.simpleList.find({id: schedule[$scope.current.assignmentTypeName].id}).name;
    };

    $scope.feeScheduleListChange = function (schedule) {
        schedule.billSchedule.name = $scope.fesScheduleList.find({id: schedule.billSchedule.id}).name
    };

    $scope.addAssetLevelFeeSchedule = function (level) {
        billScheduleTemplate = {id: 0, billSchedule: null, assignmentType: null, category: null, productClass: null, riskCategory: null, productCategory: null, product: null};
        billScheduleTemplate.assignmentType = $scope.assignmentTypes.find({propName: $scope.current.assignmentTypeName}).name;
        billScheduleTemplate.billSchedule = {id: 0, name: null};
        billScheduleTemplate[$scope.current.assignmentTypeName] = {id: 0, name: $scope.simpleList.find({id: 0}).name};
        billScheduleTemplate[$scope.current.assignmentTypeName].isEditMode = true;
        $scope.current.billAccountSchedules.push(billScheduleTemplate);
    };

    $scope.removeAssetLevelFeeSchedule = function (schedule) {
        const index = $scope.current.billAccountSchedules.indexOf(schedule);
        $scope.current.billAccountSchedules.splice(index, 1);
    };

    $scope.editAssetLevelFeeSchedule = function (schedule) {
        // this will allow user to edit object.  If object is null, then create property first.
        if (schedule[$scope.current.assignmentTypeName]) {
            schedule[$scope.current.assignmentTypeName].isEditMode = true;
        } else {
            //if object property was null then create it.
            schedule[$scope.current.assignmentTypeName] = {isEditMode: true};
        }
    };

    $scope.getSimpleListForDropDown = function () {
        setScheduleName();
        let simpleGet;
        $scope.simpleList = null;
        switch ($scope.current.assignmentType) {
            case 1:
                $scope.simpleList = [{name: 'B', id: 0}, {name: 'E', id: 1}, {name: 'M', id: 2}, {name: 'UNASSIGNED', id: 3}];
                break;
            case 2:
                simpleGet = '/Portfolio/ProductClasses/Simple';
                break;
            case 3:
                simpleGet = '/Portfolio/RiskCategories/Simple';
                break;
            case 4:
                simpleGet = '/Portfolio/ProductCategories/simple';
                break;
            case 5:
                simpleGet = `/Billing/Accounts/${dialog.options.accountId}/Tickers/Simple`;
                break;

        }
        if ($scope.current.assignmentType > 1) {
            $http.get(simpleGet, {trackerMsg: 'Loading list'})
                .then(function (response) {
                    $scope.simpleList = response.data;
                    $scope.simpleList.unshift({id: 0, name: 'UNASSIGNED'})
                });
        }
    };


    //INITIALIZE
    $scope.assignmentTypes = [
        {name: '(none)', id: 0},
        {propName: 'category', name: 'Product Category', id: 1},
        {propName: 'productClass', name: 'Product Class', id: 2},
        {propName: 'riskCategory', name: 'Risk Category', id: 3},
        {propName: 'productCategory', name: 'Asset Category', id: 4},
        {propName: 'product', name: 'Ticker', id: 5}
    ];

    $scope.fesScheduleList = null;
    $scope.simpleList = null;
    $scope.current = {
        billAccountSchedules: null,
        assignmentType: $scope.useNewAssetFeeScheduleModal ? 0 : (dialog.options.billSchedules.length ? $scope.assignmentTypes.find({name: dialog.options.billSchedules[0].assignmentType}).id : 0),
        assignmentTypeName: '',
        useAssignment: true,
        selectedAssetLevelAssignment: null,
        selectedAssetLevelFeeSchedule: null
    };
    $scope.current.assignmentTypeName = $scope.current.assignmentType > 0 ? $scope.assignmentTypes.find({id: $scope.current.assignmentType}).propName : 'None';

    init();
});

app.controller('CompositeGroupsCtrl', function CompositeGroupsCtrl($scope, $http, $oasRights, dialog, $q) {
    //PRIVATE VARIABLES
    let clientId;


    //PRIVATE METHODS
    function init() {
        $scope.rightsComposite = $oasRights.forCode('COMPOSITEACCOUNT');
        $http.get('/Portfolio/Clients/' + clientId + "/PortfolioGroups", {trackerMsg: 'Loading Composite Groupd'})
            .then(function (res) {
                $scope.compositeGroups = res.data;
                $scope.compositeGroups.forEach(function (group) {
                    group.isDeleted = false;
                })
            });
    }


    //PUBLIC METHODS
    $scope.delete = function (index) {
        if ($scope.compositeGroups[index].id === 0) {
            $scope.compositeGroups.splice(index, 1);
        } else {
            $scope.compositeGroups[index].isDeleted = true;
        }
    };

    $scope.save = function () {
        const promises = [];

        $scope.compositeGroups.forEach(function (group) {
            if (group.id === 0) {
                promises.push($http.post('/Portfolio/Clients/' + clientId + '/PortfolioGroups', group, {trackerMsg: 'Saving Composite Group'}));
            } else {
                if (group.isDeleted) {
                    promises.push($http.put('/Portfolio/Clients/' + clientId + '/PortfolioGroups/Action/Delete', [group.id], {trackerMsg: 'Deleting Composite Group'}));
                } else {
                    promises.push($http.put('/Portfolio/Clients/' + clientId + '/PortfolioGroups/' + group.id, group, {trackerMsg: 'Saving Composite Group'}));
                }

            }
        });

        $q.all(promises)
            .then(function () {
                if (dialog) {
                    dialog.close({saved: true});
                } else {
                    window.parent.postMessage("iframeclose");
                }
            });
    };

    $scope.addNewGroup = function () {
        $scope.compositeGroups.push({
            id: 0,
            name: '',
            clientId: clientId,
            portfolioType: 1
        })
    };

    $scope.close = function () {
        if (dialog) {
            dialog.close(null);
        } else {
            window.parent.postMessage("iframeclose");
        }
    };


    //INITIALIZE
    $scope.compositeGroups = []; //[{id: 1, name: "Group 1"}, {id: 2, name: "Group 2"}, {id: 3, name : "Group 3"}];
    clientId = dialog.options.clientId;
    init();
});

app.controller('AutoAssignFeePayoutCtrl', function AutoAssignFeePayoutCtrl($scope, $http, dialog) {
    //PRIVATE METHODS
    function init() {
        $http.get('/Billing/Schedules/CLS/Platform/' + $scope.current.platformId + '/BillSchedule', {trackerMsg: 'Loading cls auto schedule setup'})
            .then(function (res) {
                $scope.platformSchedule = res.data;

                if ($scope.platformSchedule.subAdvisorId) {
                    $http.get('/Portfolio/SubAdvisors/' + $scope.platformSchedule.subAdvisorId, {trackerMsg: 'Getting sub-advisor'})
                        .then(function (res) {
                            $scope.current.subAdvisorName = res.data.name;
                        });
                }

                $scope.addTotal();
            });
    }


    //PUBLIC METHODS
    $scope.addTotal = function () {
        $scope.current.feeName = "";
        $scope.current.payoutName = "";
        let clsTotal = 0;
        $scope.platformSchedule.details.forEach(function (item) {
            item.total = item.cls + item.rep;
            $scope.current.feeName += item.total + "/";
            $scope.current.payoutName += item.cls + "/";
            clsTotal += item.cls;
        });

        $scope.current.feeName = $scope.current.feeName.substring(0, $scope.current.feeName.length - 1);
        $scope.current.payoutName = $scope.current.payoutName.substring(0, $scope.current.payoutName.length - 1);
        $scope.current.minFee = clsTotal > 0 ? 100 : 0;
    };

    $scope.close = function () {
        if (dialog) {
            dialog.close(null);
        } else {
            window.parent.postMessage("iframeclose");
        }
    };

    $scope.save = function () {
        $scope.platformSchedule.accountId = $scope.current.accountId;
        $scope.platformSchedule.managementStyleId = $scope.current.platformId;
        $scope.platformSchedule.feeName = $scope.current.feeName;
        $scope.platformSchedule.payoutName = $scope.current.payoutName;
        $scope.platformSchedule.minimumFee = $scope.current.minFee;

        $http.post('/Billing/Schedules/CLSBillingWizard', $scope.platformSchedule, {trackerMsg: 'Add auto schedules'})
            .then(function (res) {
                if (dialog) {
                    dialog.close({subAdvisorId: res.data.subAdvisorId, platformId: $scope.current.platformId});
                } else {
                    window.parent.postMessage("iframeclose");
                }
            })
    };

    $scope.current = {
        accountId: dialog.options.accountId,
        platformId: dialog.options.platformId,
        subAdvisorName: "",
        feeName: "",
        payoutName: "",
        minFee: 0,
        revenuePayoutBPS: false,
        lastBusinessDate: ''
    };


    //INITIALIZE
    init();
    //SCOPE WATCHERS
    $scope.$watch('current.platformId', function (newVal, oldVal) {
        if (newVal === oldVal || !newVal) return;
        $scope.current.subAdvisorName = "";
        $scope.current.platformId = newVal;
        init();
    });
});

app.controller('AccountPaysForCtrl', function AccountsPaysForCtrl($scope, dialog){
    $scope.addAccount = function(){
        if (dialog) {
            dialog.close({id: $scope.current.inputValue.id});
        } else {
            window.parent.postMessage("iframeclose");
        }
    };

    $scope.cancel = function(){
        if (dialog) {
            dialog.close(null);
        } else {
            window.parent.postMessage("iframeclose");
        }
    };

    $scope.accounts = dialog.options.accounts;


});

app.controller('AstroAssetRestrictionImportCtrl', function AstroAssetRestrictionImportCtrl($scope, dialog) {
    //PRIVATE VARIABLES

    //PRIVATE METHODS

    //PUBLIC METHODS
    $scope.save = function () {
        if (dialog) {
            dialog.close( $scope.current.selectedItems.exclude({isValid: false}));
        } else {
            window.parent.postMessage("iframeclose");
        }
    };

    $scope.close = function () {
        if (dialog) {
            dialog.close(null);
        } else {
            window.parent.postMessage("iframeclose");
        }
    };

    //INITIALIZE
    $scope.current = { selectedItems: [] };

});

'use strict';

app.controller('TransactionEditCtrl', function TransactionEditCtrl($scope, $http, $oasRights, $dialog, dialog, args, entities, commissionIndicator, orderType, marketCode, blotterCode, distributionIndicator, revenueType, spreadStraddle, apps, $portfolio, $timeout, splitIoService, oasDates) {

    // region PRIVATE VARIABLES
    var transactionGeneralOriginal,
        costBasisOriginal,
        additionalInfoOriginal,
        billingGeneralOriginal,
        entityOptionsOriginal,
        customFieldsOriginal,
        unitsToAssign = 0,
        editorHotKeys;

    const financialTypes = ["Contributions", "Withdrawals", "Exchanges", "Transfers In/Out", "Merge Entries"];

    var validationMessages = {
        futureDatedNonAlternative: "Unable to save transaction. Future-dated transactions can only be saved for assets with status set to 'alternative'. Please update the asset status or modify the transaction date.",
        futureDatedAlternativeRequires: "Unable to save transaction. Future-dated transactions on alternative assets must have status set to 'Future AIP'. Please update the transaction status or modify the date.",
        requiresFutureDate: "Unable to save transaction. Transactions with 'Future AIP' status must have a future date. Please update the transaction date or modify the status."
    };
    //endregion

    //region PRIVATE METHODS
    // region INIT/RIGHT/MENU/TABS
    function init() {
        loadEnumLookUps();
        loadRights();
        buildMenu();
        loadHotKeys();
        loadTransactionSubTypes();
        loadCashFlowOption();
        $scope.loadTab(args.defaultTab);
        if ($scope.rightsTransactionSuppression.canUpdate){
            $scope.current.filterIds = "39,42,61,156,157";
        }
    }

    function loadRights() {
        $scope.rightsBilling = $oasRights.forCode("ACCTBILLING");
        $scope.rightsTransaction = $oasRights.forCode("TRANSACTIONS");
        $scope.rightsTransactionNotes = $oasRights.forCode("TRANSACTIONNOTES");
        $scope.rightsEOs = $oasRights.forCode("ENTITYOPTION");
        $scope.rightsCustomFields = $oasRights.forCode("CUSTOMFIELDS");
        $scope.isAdminOrRia = ["Administrator", "Advisor"].any($scope.user.authorization.entity);
        $scope.rightsTransactionSuppression = $oasRights.forCode('TRANSACTIONTYPESUPPRESSION');
        $scope.rightsManuallyManaged = $oasRights.forCode('MANUALLYMANAGED');
        $scope.rightsAsset = $oasRights.forCode('ASSETS');
        $scope.transactionUpdateDisabled = !$scope.rightsTransaction.canUpdate;
    }

    function buildMenu() {
        var canLoadSettings = $scope.rightsCustomFields.canRead || $scope.rightsEOs.canRead;
        var i = 0;
        $scope.menu = {categories: []};

        $scope.menu.categories.push({name: 'Transaction', children: []});
        $scope.menu.categories[i].children.push({name: 'General', active: false, code: 'transactionGeneral'});
        $scope.menu.categories[i].children.push({name: 'Additional Information', active: false, code: 'additionalInfo'});
        $scope.menu.categories[i].children.push({name: 'Cost Basis', active: false, code: 'costBasis'});

        if (['Administrator', 'Advisor'].any($scope.user.authorization.entity)) {
            i++;
            $scope.menu.categories.push({name: 'Billing', children: []});
            $scope.menu.categories[i].children.push({name: 'General', active: false, code: 'billingGeneral'});
        }

        if (!args.isNew && canLoadSettings) {
            i++;
            $scope.menu.categories.push({name: 'Settings', children: []});

            if($scope.rightsCustomFields.canRead){
                $scope.menu.categories[i].children.push({name: 'Custom Fields', active: false, code: 'customFields'});
            }
            if ($scope.rightsEOs.canRead) {
                $scope.menu.categories[i].children.push({name: 'Options', active: false, code: 'entityOptions'});
            }
        }
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: function() { $scope.save($scope.mainForm); } },
                { combo:'ALT+X', command: function() { $scope.close(true); } }
            ]);
        });
    }

    function loadDataForSelectedTab() {
        switch ($scope.current.selectedTab) {
            case "transactionGeneral":
                if ($scope.rightsTransaction.canRead) {
                    loadPayees();
                    loadTransaction();
                }
                break;
            case "costBasis":
                if ($scope.rightsTransaction.canRead) {
                    loadCostBasisLookUps();
                    loadCostBasis();
                }
                break;
            case "additionalInfo":
                if ($scope.rightsTransaction.canRead) {
                    loadAdditionalInfo();
                    loadTransTypeInfo($scope.transactionGeneral.transTypeId);
                }
                break;
            case "billingGeneral":
                if ($scope.rightsTransaction.canRead) {
                    loadBillingGeneral();
                }
                break;
            case "entityOptions":
                if ($scope.rightsEOs.canRead) {
                    loadEntityOptions();
                }
                break;
            case "customFields":
                if ($scope.rightsCustomFields.canRead) {
                    loadCustomFields();
                }
                break;
        }
    }

    function loadEnumLookUps() {
        var list = {
            commissionIndicators: commissionIndicator,
            orderTypes: orderType,
            marketCodes: marketCode,
            blotterCodes: blotterCode,
            distributionIndicators: distributionIndicator,
            revenueTypes: revenueType,
            spreadStraddles: spreadStraddle
        };

        Object.each(list, function (key, value) {
            $scope[key] = $portfolio.enumToSimpleList(value);
        });
    }

    function loadTransactionSubTypes( ) {
        $http.get('/Trading/TransactionSubTypes', {trackerMsg: 'Loading transaction sub types'})
            .then(function(response){
                $scope.transactionSubTypes = response.data;
            })
    }

    // endregion

    // region LOAD TRANSACTION
    function loadPayees() {
        if ($scope.payees) return;

        $scope.payees = [{id: 0, payeeName: '(None)'}];

        $http.get("/Billing/Payees", {cache: true, trackerMsg: 'Loading payees'})
            .then(function (response) {
                $scope.payees.add(response.data);
            });
    }

    function loadAssetList(clientId, assetId) {
        return $http.get("/Portfolio/Clients/" + clientId + "/Assets", {trackerMsg: 'Loading household assets'})
            .then(function (response) {
                $scope.assetListLoaded = true;
                    if (response.data.length > 100) {
                        $scope.current.asset = Object.select(response.data.find({id: assetId}), "id", "accountNumber", "registrationType", "name", "ticker", "accountId", "status");
                    } else {
                    //ranked sorting to put the currently selected account assets first in the list
                    $scope.current.asset = response.data.find({ id: assetId });
                    const accountNumber = $scope.current.asset.accountNumber;
                    response.data.forEach(item => item.rank = item.accountNumber === accountNumber ? 1 : 9);
                    $scope.assetList = response.data.sortBy("rank").sortBy("accountNumber");
                    //highlight rows in the asset dropdown with the currently selected account number
                    $scope.assetDropdownHighlightModel.value = accountNumber;
                }
            });
    }

    function refreshAssetAfterAssetEditor() {
        var tg = $scope.transactionGeneral;
        if (!tg || !tg.clientId || !tg.assetId) {
            return;
        }

        loadAssetList(tg.clientId, tg.assetId).then(function () {
            $scope.errors.remove(function (e) {
                return e.title === 'Validation';
            });
        });;
    }

    var tempTransTime;

    function loadTransaction() {
        if ($scope.transactionGeneral) return;

        if (args.isNew) {
            $scope.transactionGeneral = { assetId : args.extraInfo.fkAsset, clientId : args.extraInfo.fkClient};

            loadAssetList(args.extraInfo.fkClient, args.extraInfo.fkAsset);

            if (args.extraInfo.isManuallyManaged){
                $scope.current.rightsManuallyManaged = $scope.rightsManuallyManaged;
                $scope.transactionUpdateDisabled = (!$scope.rightsTransaction.canUpdate && !$scope.current.rightsManuallyManaged.canUpdate);
            }

            $http.get("/Portfolio/Transactions/Verbose/New", {trackerMsg: 'Loading transaction'})
                .then(function (response) {
                    var data = response.data;
                    data.portfolio.assetId = args.extraInfo.fkAsset;
                    data.portfolio.clientId = args.extraInfo.fkClient;
                    $scope.transactionGeneral = data.portfolio;

                    $http.get("/Utility/PreviousBusinessDay")
                        .then(function (response) {
                            $scope.transactionGeneral.transDate =  Date.create(response.data).formatted();
                            $scope.lookupPrice();
                        });

                    unitsToAssign = 0;
                    $scope.current.unitsToAssign = data.portfolio.noUnits;

                    transactionGeneralOriginal = angular.copy($scope.transactionGeneral);
                    $scope.current.originalStatus = transactionGeneralOriginal.status;
                });
        } else {
            $http.get("/Portfolio/Transactions/Verbose/" + args.ids[0], {trackerMsg: 'Loading transaction'})
                .then(function (response) {
                    var data = response.data;
                    $scope.transactionGeneral = data.portfolio;

                    if (!data.portfolio.transTime) {
                        data.portfolio.transTime = Date.create();
                        tempTransTime = data.portfolio.transTime;
                    }

                    if (!$scope.rightsTransaction.canDelete){ //Users should not be able to delete
                        // Check the Account for Status of Manually Managed(3) and Advisor Only(3)
                        $http.get('/Portfolio/Accounts/' + data.portfolio.accountId, {trackerMsg:  'Getting account information'})
                            .then(function(response){
                                if (response.data.accountStatusId === 3 || response.data.accountStatusId === 8){
                                    $scope.current.rightsManuallyManaged = $scope.rightsManuallyManaged;
                                    $scope.transactionUpdateDisabled = !$scope.rightsTransaction.canUpdate && !$scope.current.rightsManuallyManaged.canUpdate;
                                }else {
                                    $http.get('/Portfolio/Assets/' + data.portfolio.assetId, {trackerMsg: 'Getting asset information'})
                                        .then(function(response){
                                            if (response.data.status ===2 ){
                                                $scope.current.rightsManuallyManaged = $scope.rightsManuallyManaged;
                                                $scope.transactionUpdateDisabled = !$scope.rightsTransaction.canUpdate && !$scope.current.rightsManuallyManaged.canUpdate;
                                            }
                                        });
                                }
                            })
                    }

                    loadAssetList(data.portfolio.clientId, data.portfolio.assetId);

                    unitsToAssign = data.portfolio.noUnits;
                    $scope.current.unitsToAssign = data.portfolio.noUnits;

                    $scope.adjustUnitRemaining(0);

                    transactionGeneralOriginal = angular.copy($scope.transactionGeneral);
                    $scope.current.originalStatus = transactionGeneralOriginal.status;
                });
        }
    }

    //endregion

    // region LOAD COST BASIS
    function loadCostBasisLookUps() {
        if ($scope.transactionTypes) return;

        $http.get('/Trading/TransactionTypes', {cache: true, trackerMsg: 'Loading transaction types'})
            .then(function (response) {
                $scope.transactionTypes = response.data;
            });
    }

    function loadCostBasis() {
        if ($scope.costBasis) return;

        $http.get("/Portfolio/Transactions/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=costBasis", {trackerMsg: 'Loading transaction cost basis'})
            .then(function (response) {
                $scope.costBasis = response.data.costBasis;
                costBasisOriginal = angular.copy($scope.costBasis);

                loadTransaction();
                $scope.adjustUnitRemaining(0);
            });
    }

    // endregion

    // region LOAD ADDITIONAL INFO
    function loadAdditionalInfo() {
        if ($scope.additionalInformation) return;

        $http.get("/Portfolio/Transactions/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=additionalInformation", {trackerMsg: 'Loading additional information'})
            .then(function (response) {
                $scope.additionalInformation = response.data.additionalInformation;
                additionalInfoOriginal = angular.copy($scope.additionalInformation);

                if($scope.additionalInformation.includeAsRmdDistributionIsSystemMaintained === null){
                    $scope.additionalInformation.includeAsRmdDistributionIsSystemMaintained = true;
                }

                //FYI - this has changed between two project 101111 and 104275.  Setting this to always true until new project submitted
                $scope.current.showRMDFields = (!($scope.transactionGeneral.transTypeId === 39 || $scope.transactionGeneral.transTypeId === 172));

            });
    }
    function loadTransTypeInfo(transtypeid) {
        if ($scope.transTypeInfo) return;

        $http.get("/Trading/TransactionTypes/" + + transtypeid, { trackerMsg: 'Loading TransType information' })
            .then(function (response) {
                $scope.transTypeInfo = response.data;
                if (!$scope.transTypeInfo.isNoUnits && $scope.transTypeInfo.shareEffect == 1 && financialTypes.includes($scope.transTypeInfo.financialType)) {
                    $scope.current.showOID = true;
                }
                else {
                    $scope.current.showOID = false;
                }
            });
    }

    // endregion

    //region LOAD BILLING GENERAL
    function loadBillingGeneral() {
        if ($scope.billingGeneral) return;

        let expandVal = args.defaultTab.code === 'billingGeneral' ? "?expand=billing,portfolio" : "?expand=billing"
        $http.get("/Portfolio/Transactions/Verbose/" + (args.isNew ? "New" : args.ids[0]) + expandVal, {trackerMsg: 'Loading billing'})
            .then(function (response) {
                $scope.billingGeneral = response.data.billing;
                billingGeneralOriginal = angular.copy($scope.billingGeneral);

                if(args.defaultTab.code === 'billingGeneral'){
                    $scope.transactionGeneral = response.data.portfolio;
                    transactionGeneralOriginal = angular.copy($scope.transactionGeneral);
                }
            });
    }

    //endregion

    // region LOAD ENTITY OPTIONS
    function loadEntityOptions() {
        if ($scope.entityOptions) return;

        $http.get("/Settings/EntityOptions/Transactions/" + args.ids[0], {trackerMsg: 'Loading options'})
            .then(function (response) {
                $portfolio.cleanCustomFields(response.data);
                $scope.entityOptions = response.data;
                entityOptionsOriginal = angular.copy(response.data);
            });
    }

    //endregion

    function loadCashFlowOption(){
        $http.get("/Settings/Database/EntityOptions?codeNames=ToggleCashFlow", {tracker: 'main', trackerMsg: 'Loading billing cash flow settings'})
        .then(function (response){
            $scope.current.useCashFlow = (response && response.data && response.data.length > 0) ? response.data[0].value === "True" : false;
        });
    }

    //region LOAD CUSTOM FIELDS
    function loadCustomFields() {
        if ($scope.customFields) return;

        $http.get('/Portfolio/Transactions/' + args.ids[0] + '/UserDefinedFields', {trackerMsg: 'Loading custom fields'})
            .then(function (response) {
                $scope.customFields = response.data.sortBy("name");
                $portfolio.cleanCustomFields($scope.customFields);
                customFieldsOriginal = angular.copy($scope.customFields);
            });
    }

    //endregion

    //endregion

    // region PUBLIC METHODS
    // region LOAD/CLOSE
    $scope.loadTab = function (child) {
        $scope.menu.categories.each(function (c) {
            c.children.each(function (ch) {
                ch.active = ch.code === child.code;
            });
        });

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab();
    };

    $scope.checkTransTypeForRMD = function (transTypeId) {
        if(transTypeId){
            $scope.current.showRMDFields = (!(transTypeId === 39 || transTypeId === 172));
        }
    };


    function saveTransaction() {
        var verboseTrans = {};

        if ($scope.transactionGeneral && !angular.equals(transactionGeneralOriginal, $scope.transactionGeneral)) {
            $scope.transactionGeneral.transDate = Date.create($scope.transactionGeneral.transDate).formatted();
            if ($scope.transactionGeneral.transTime !== tempTransTime) {
                $scope.transactionGeneral.transTime = Date.create('1/1/1900 ' + Date.create($scope.transactionGeneral.transTime).format('{HH}:{mm}:{ss}'));
            }
            else {
                $scope.transactionGeneral.transTime = null;
            }
            verboseTrans["portfolio"] = $scope.transactionGeneral;
        }

        if ($scope.costBasis && !angular.equals(costBasisOriginal, $scope.costBasis)) {
            $scope.costBasis.forEach(function (cb) {
                if (cb.costDate !== null) cb.costDate = Date.create(cb.costDate).formatted();
                if (cb.holdingPeriodDate !== null) cb.holdingPeriodDate = Date.create(cb.holdingPeriodDate).formatted();
                if ((!cb.costPrice || cb.costPrice === 0) && cb.costUnits !== 0) {
                    cb.costPrice = cb.costTotal / cb.costUnits;
                }
                if (!cb.costTotal || cb.costTotal === 0) {
                    cb.costTotal = cb.costPrice * cb.costUnits;
                }
            });

            verboseTrans["costBasis"] = $scope.costBasis;
        }

        if ($scope.additionalInformation && !angular.equals(additionalInfoOriginal, $scope.additionalInformation)) verboseTrans["additionalInformation"] = $scope.additionalInformation;

        if ($scope.billingGeneral && !angular.equals(billingGeneralOriginal, $scope.billingGeneral)) verboseTrans["billing"] = $scope.billingGeneral;

        if ($scope.customFields && !angular.equals(customFieldsOriginal, $scope.customFields)) {
            var udfs = $scope.customFields.findAll({entity: entities.transaction.name});
            if (udfs.length) verboseTrans["userDefinedFields"] = udfs;
        }

        if ($scope.entityOptions && !angular.equals(entityOptionsOriginal, $scope.entityOptions)) verboseTrans["entityOptions"] = $portfolio.restoreEntityOptions($scope.entityOptions);

        verboseTrans["id"] = args.isNew ? 0 : args.ids[0];
        var msg = args.isNew ? 'Adding ' : 'Saving ';
        var verb = args.isNew ? 'POST' : 'PUT';
        var urlSave = args.isNew ? '/Portfolio/Transactions/Verbose/' : '/Portfolio/Transactions/Verbose/' + args.ids[0] + '?reverseOffset=' + $scope.current.reverseOffset;

        $http({method: verb, url: urlSave, data: verboseTrans, trackerMsg: msg + 'transaction'})
            .then(function (response) {
                var savedData = response.data;
                if ($scope.current.isFullPage) {
                    $dialog.saveSuccessful("Transaction saved.").open();
                } else {
                    if (args.app) {
                        var retUrl = '';
                        if (args.app === apps.portfolioLists.name) {
                            retUrl = '/Portfolio/Transactions/' + savedData.id;
                        }
                        else if (args.app === apps.billingAudit.name || args.app === apps.billing.code) {
                            retUrl = '/Billing/Transactions/' + savedData.id;
                        }

                        $http.get(retUrl, {trackerMsg: 'Refreshing transactions'})
                            .then(function (response) {
                                var retData = response.data;
                                if (args.isNew) retData.isNew = true;
                                if ($scope.current["reverseOffset"] === true) retData["reverseOffset"] = true;
                                editorHotKeys.destroy();
                                dialog.close(retData);
                            });

                    } else {
                        editorHotKeys.destroy();
                        dialog.close(null);
                    }
                }
            }).finally(function() {
                $scope.isSaving = false;
            });
    }

    function validateBeforeSave() {
        var tg = $scope.transactionGeneral;
        if (!tg || !tg.assetId || tg.assetId <= 0) {
            return null;
        }

        var asset = ($scope.assetList && $scope.assetList.find({ id: tg.assetId }))
            || ($scope.current.asset && $scope.current.asset.id === tg.assetId ? $scope.current.asset : null);
        if (!asset || asset.status == null || asset.status === '') {
            return null;
        }

        var statusNum = typeof asset.status === 'number' ? asset.status : parseInt(asset.status, 10);
        if (isNaN(statusNum)) {
            return null;
        }

        var isAlternative = statusNum === 3;
        var isFutureAipStatus = tg.status === 'Future (AIP)';
        var isFutureDate = oasDates.isAfterTodayCentral(tg.transDate);

        if (isFutureAipStatus && !isFutureDate) {
            return validationMessages.requiresFutureDate;
        }
        if (isFutureDate && isAlternative && !isFutureAipStatus) {
            return validationMessages.futureDatedAlternativeRequires;
        }
        if (isFutureDate && !isAlternative) {
            return validationMessages.futureDatedNonAlternative;
        }
        return null;
    }

    $scope.save = function (mainForm) {
        if (isValid(mainForm)) {
            $scope.isSaving = true;
            splitIoService.getBoolTreatment("recon_datasharing_editwarningmessages_7285")
                .subscribe((isEnabled) =>
                {
                    if (isEnabled && $scope.current?.asset?.accountId != null)
                    {
                        $http.get('/PortfolioDataSync/DataSharing/Sources/EntityLink/IsActive?entityType=7&entityId=' + $scope.current.asset.accountId.toString(), { trackerMsg: 'Checking Datasharing Status' })
                            .then((response) => {
                                if (response.data) {
                                    $dialog.confirmAction('Account is a data sharing account. Transaction is likely to be reverted by subsequent syncs.  Would you still like to proceed?')
                                        .open()
                                        .then((response) => {
                                            if (response == 'yes') {
                                                saveBase()
                                            }
                                        });
                                }
                                else {
                                    saveBase();
                                }
                            });
                    }
                    //else do legacy
                    else {
                        saveBase();
                    }
                    });

        }
    };

    function saveBase() {
        if (transactionGeneralOriginal && transactionGeneralOriginal.assetId !== $scope.transactionGeneral.assetId && transactionGeneralOriginal.assetId !== 0 && !args.isNew) {
            $http.put('/Portfolio/Transactions/' + args.ids[0] + '/Action/MoveToAsset/' + $scope.transactionGeneral.assetId, { trackerMsg: 'Moving transaction to different asset' })
                .then(function (response) {
                    saveTransaction();
                }).catch(function () {
                    $scope.isSaving = false;
                });
        } else {
            saveTransaction();
        }
    }

    function isValid(mainForm) {
        var isValid = true;
        if (mainForm.frmTransGeneral) {
            if (mainForm.frmTransGeneral.$invalid) {
                $scope.errors.push({type: 'error', title: 'Required Fields! ', msg: ' Must complete all required fields (*)'});
                isValid = false;
            }
        }

        if ($scope.transactionGeneral.navPrice < 0) {
            $scope.errors.push({ type: 'error', title: 'Invalid share price!', msg: 'Share price must be positive.' });
            isValid = false;
        }

        var validationMessage = validateBeforeSave();
        if (validationMessage) {
            $scope.errors.push({ type: 'error', title: 'Validation', msg: validationMessage });
            isValid = false;
        }

        if( $scope.user.authorization.entity === "Administrator" && args.isNew === true && ( $scope.transactionGeneral.notes === null || $scope.transactionGeneral.notes.length < 5 ) ) {
            $scope.errors.push({type: 'error', title: 'Required Notes! ', msg: ' Notes are required for manually added transactions'});
            isValid = false;
        }

        return isValid;
    }

    $scope.close = function (validate) {
        if (validate) {
            if (
                !angular.equals(transactionGeneralOriginal, $scope.transactionGeneral) ||
                !angular.equals(billingGeneralOriginal, $scope.billingGeneral) ||
                !angular.equals(additionalInfoOriginal, $scope.additionalInformation) ||
                !angular.equals(entityOptionsOriginal, $scope.entityOptions) ||
                !angular.equals(customFieldsOriginal, $scope.customFields) ||
                !angular.equals(costBasisOriginal, $scope.costBasis)
            ) {
                $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true});
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };
    //endregion

    //region GENERAL
    $scope.openAssetEditor = function () {
        var assetId = $scope.transactionGeneral && $scope.transactionGeneral.assetId;
        if (!assetId || assetId <= 0) {
            return;
        }

        $portfolio.openEditor(
            entities.asset.value,
            [assetId],
            null,
            null,
            apps.portfolioLists.name,
            null
        ).then(function () {
            refreshAssetAfterAssetEditor();
        });
    };

    $scope.recalcAmount = function () {
        if ($scope.transactionGeneral.noUnits === 0 || $scope.transactionGeneral.navPrice === 0) return;

        $scope.transactionGeneral.transAmount = $scope.transactionGeneral.noUnits * $scope.transactionGeneral.navPrice;
    };

    $scope.recalcUnits = function () {
        if ($scope.transactionGeneral.transAmount === 0 || $scope.transactionGeneral.navPrice === 0) return;

        $scope.transactionGeneral.noUnits = $scope.transactionGeneral.transAmount / $scope.transactionGeneral.navPrice;
    };

    $scope.recalcUnitPrice = function () {
        if ($scope.transactionGeneral.transAmount === 0 || $scope.transactionGeneral.noUnits === 0) return;

        $scope.transactionGeneral.navPrice = $scope.transactionGeneral.transAmount / $scope.transactionGeneral.noUnits;
    };

    $scope.lookupPrice = function( ) {
        $http.get("/Portfolio/Assets/" + $scope.transactionGeneral.assetId + "/Price/" + Date.create($scope.transactionGeneral.transDate).format('{MM}-{dd}-{yyyy}'), {cache: true, trackerMsg: 'Loading price'})
            .then(function (response) {
                if( response.data ) {
                    $scope.transactionGeneral.navPrice = response.data.last;
                }
        });
    };

    $scope.subTypeFilter = function( ) {
        return function( item ) {
            return $scope.transactionGeneral && item.transTypeCommonId === $scope.transactionGeneral.transTypeId;
        };
    };

    //endregion

    //region ADDITIONAL INFORMATION
    $scope.rmdSystemMaintainedChange = function () {
        if ($scope.additionalInformation.includeAsRmdDistributionIsSystemMaintained && $scope.additionalInformation.includeAsRmdDistribution) {
            $scope.additionalInformation.includeAsRmdDistribution = false;
        }
    };
    //endregion

    // region COST BASIS
    $scope.addCostBasis = function () {
        $scope.costBasis.push({
            id: 0,
            costDate: null,
            holdingPeriodDate: null,
            costUnits: null,
            costPrice: null,
            costTotal: null,
            costNotes: "",
            transTypeId: 0
        });
    };

    $scope.removeCostBasis = function (cb) {
        $dialog.confirmAction("Are you sure you want to remove this cost basis record?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.costBasis.remove(cb);
                }
            });
    };

    $scope.adjustUnitRemaining = function (costUnits) {
        if (isNaN(costUnits))
            return;

        if (!$scope.costBasis && args.isNew === false) {
            loadCostBasis();
        } else if ($scope.costBasis) {
            var tempUnits = unitsToAssign - $scope.costBasis.sum('costUnits');
            $scope.current.unitsToAssign =  Math.round(tempUnits * 1000) / 1000;
        }
    };

    $scope.setCostBasisLotDefaults = function (cb) {
        var tt = $scope.transactionTypes.find({ id: cb.transTypeId });
        if( tt && tt.name === 'Uncovered Cost Basis' ) {
            cb.costDate = $scope.transactionGeneral.transDate;
            cb.costUnits = $scope.transactionGeneral.noUnits;
            cb.costPrice = 0;
            cb.costTotal = cb.costUnits * cb.costPrice;

            $scope.adjustUnitRemaining(cb.costUnits)
        }
    };

    // endregion
    //endregion

    // region INITIALIZE
    $scope.current = {
        selectedTab: args.defaultTab,
        transactionId: args.ids.length > 1 ? 0 : parseInt(args.ids[0]),
        transType: null,
        states: null,
        isFullPage: false,
        originalStatus: '',
        useCashFlow: false,
        reverseOffset: false,
        showRMDFields: true,  //FYI - this has changed between two project 101111 and 104275.  Setting this to always true until new project submitted,
        filterIds: null,
        rightsManuallyManaged: {canAdd: false, canDelete: false, canRead: false, canUpdate: false}
    };

    $scope.assetIdFieldMap = [{ name: 'Asset ID', value: 'id', sortable: true }, { name: 'Account', value: 'accountNumber', sortable: true }, { name: 'Reg Type', value: 'registrationType', sortable: true }, { name: 'Name', value: 'name', sortable: true }, { name: 'Ticker', value: 'ticker', sortable: true }];
    $scope.assetDropdownHighlightModel = { field: 'accountNumber', value: '', color: '#efefef' };

    if (args.isFullPage) {
        $scope.current.isFullPage = args.isFullPage;
    }

    $scope.isSaving = false;
    $scope.assetListLoaded = false;

    $scope.errors = [];

    init();
    // endregion

});

'use strict';

function MaintainPaperworkCtrl($scope, $http, $oasRights, $settings, $timeout, $dialog, $paperwork ) {
     //Public variables
    var newSelections;

    var paperworkList = {};

    $scope.paperwork = null;
    $scope.paperworkSelections = [];
    $scope.paperworkForm = {selections:[]};

    //PUBLIC METHODS
    $scope.getFormInfo = function(id){
        $paperwork.getFormInfoById(id)
            .then(function(form){
                $scope.paperworkForm = form;
                $paperwork.setFormChangeList($scope.paperworkForm);
            });
    };

    $scope.addPaperWorkAssignment = function(){
        var dialogOpts = {
            templateUrl : "paperwork-assignment-manager.html",
            controller : "PaperworkAssignmentCtrl"
        };

        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function(rslt){
                if (rslt){
                    newSelections = rslt;
                    var x = buildSelectionsToSave.apply(null, Object.values(newSelections));
                    x.forEach(function(uniqueCombo) {
                        var newRow = {};
                        uniqueCombo.forEach(function(item) {
                            Object.merge(newRow, item);
                        });
                        $scope.paperworkForm.selections.push(newRow);
                    });
                }
            });

    };

    $scope.assignmentPreview = function(){
        var dialogOpts = {
            templateUrl: 'preview-assignment.html',
            controller: 'PaperworkAssignmentPreviewCtrl'
        };

        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function(rslt){
                if (rslt){
                    $scope.paperworkFormsList.id = rslt;
                    $scope.getFormInfo(rslt);
                }
            });
    };

    $scope.removeAssignment = function(item){
        var idx = $scope.paperworkForm.selections.indexOf( item );
        $scope.paperworkForm.selections.splice( idx, 1 );
    };

    $scope.toggleFormsLookUp = function(isLookUpMode){
        $scope.current.showFormsLookUp = isLookUpMode;
        $scope.current.selectedLaserAppForm =  null;
    };

    //WATCHES
    $scope.$watch("paperworkForm", function(newVal,oldVal){
        if(newVal === oldVal || oldVal.length === 0) return;
        //$paperwork.cacheChanges();
    }, true);

    $scope.$watch("current.selectedLaserAppForm",function(newVal, oldVal){
        if (newVal === oldVal || !newVal) return;

        $scope.paperworkFormsList.id =  $scope.paperworkFormsList.find({id: $scope.current.selectedLaserAppForm.id}).id;

        $scope.current.selectedLaserAppForm =  null;

        $scope.current.showFormsLookUp = false;

        $scope.getFormInfo($scope.paperworkFormsList.id);
    });

    //PRIVATE METHODS
    function LoadAvailablePaperwork() {
        $paperwork.getFormList()
            .then(function(list){
                if(list.length > 0){
                    $scope.paperworkFormsList = list;
                    $scope.paperworkFormsList.id = list[0].id;
                    $scope.getFormInfo($scope.paperworkFormsList.id);
                }
            });
    }
    function buildSelectionsToSave(paramArray) {

        function addTo(curr, args) {

            var i, copy,
                rest = args.slice(1),
                last = !rest.length,
                result = [];

            for (i = 0; i < args[0].length; i++) {

                copy = curr.slice();
                copy.push(args[0][i]);

                if (last) {
                    result.push(copy);

                } else {
                    result = result.concat(addTo(copy, rest));
                }
            }

            return result;
        }

        return addTo([], Array.prototype.slice.call(arguments));
    }
    function initialize(){
        $paperwork.initialize();
        LoadAvailablePaperwork();
    }

    initialize();
}
app.controller('MaintainPaperworkCtrl', MaintainPaperworkCtrl);
app.controller ('PaperworkAssignmentCtrl', function PaperworkAssignmentCtrl( $scope, $http, $oasRights, dialog){
    // PUBLIC VARIABLES
    var tempAssignments = [];
    var newAssignments = { };

    // PUBLIC METHODS
    $scope.cancel = function( ) {
        dialog.close( null );
    };

    $scope.close = function( ) {
        dialog.close( { assignmentSelections : newAssignments } );
    };

    $scope.back = function() {
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep -= 1;
    };

    $scope.next = function() {
        $scope.current.animation = 'slide-right';

        $scope.current.wizardStep += 1;
        setSelectedEntityTypeName();

    };

    $scope.jumpBackTo = function(index) {
        if ($scope.current.executing) return;

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };

    $scope.isStepIncomplete = function() {
        switch ($scope.current.wizardStep) {
            case 0:
                return false;
            case 1:
                return false;
            default:
                return false;
        }
    };

    // INITIALIZE
    $scope.custodianAssignment = [];
    $scope.brokerDealerAssignment = [];
    $scope.subAdvisorAssignment = [];
    $scope.registrationTypeAssignment = [];
    $scope.managementStyleAssignment = [];
    $scope.fundFamilyAssignment = [];
    $scope.sourceOfFundsAssignment = [];
    $scope.formTypeAssignment = [];
    $scope.feeScheduleAssignment = [];


    $scope.current = {entityLevelSelectionType: 0, selectionTypeName: "", wizardStep: 0, animation: 'slide-right', executing: false, availableItems: [], availableSelected: [], selectedItems: [], selectedSelected: []};
    $scope.wizardSteps = [ "Selection Method", "Filter Selections" ];

    $scope.items = [];

    $scope.selectedItem = {sItem: []};

    $scope.rightsAccount = $oasRights.forCode( "ACCOUNTS" );

    $scope.saveAssignment = function(){
        //this is the last selection before finish
        moveSelectedAssignmentToArray();

        //go through all assignment entities
        if( $scope.custodianAssignment.length > 0) {
            newAssignments.custodian = $scope.custodianAssignment.map(function(x) {return {custodianId: x.id, custodian: x.name};});
        }
        if( $scope.subAdvisorAssignment.length > 0) {
            newAssignments.subAdvisor = $scope.subAdvisorAssignment.map(function(x) {return {subAdvisorId: x.id, subAdvisor: x.name};});
        }
        if( $scope.managementStyleAssignment.length > 0) {
            newAssignments.managementStyle = $scope.managementStyleAssignment.map(function(x) {return {platformId: x.id, managementStyle: x.name};});
        }
        if( $scope.brokerDealerAssignment.length > 0) {
            newAssignments.brokerDealer = $scope.brokerDealerAssignment.map(function(x) {return {brokerDealerId: x.id, brokerDealer: x.name};});
        }
        if( $scope.registrationTypeAssignment.length > 0) {
            newAssignments.registrationType = $scope.registrationTypeAssignment.map(function(x) {return {registrationTypeId: x.id, accountType: x.name};});
        }
        if( $scope.fundFamilyAssignment.length > 0) {
            newAssignments.fundFamily = $scope.fundFamilyAssignment.map(function(x) {return {fundFamilyId: x.id, fundFamily: x.name};});
        }
        if( $scope.sourceOfFundsAssignment.length > 0) {
            newAssignments.sourceOfFunds = $scope.sourceOfFundsAssignment.map(function(x) {return {sourceOfFundsId: x.id, sourceOfFunds: x.name};});
        }
        if( $scope.formTypeAssignment.length > 0) {
            newAssignments.formType = $scope.formTypeAssignment.map(function(x) {return {formTypeId: x.id, formType: x.name};});
        }
        if( $scope.feeScheduleAssignment.length > 0) {
            newAssignments.feeSchedule = $scope.feeScheduleAssignment.map(function(x) {return {feeScheduleId: x.id, feeSchedule: x.name};});
        }
       dialog.close(newAssignments);
    };

    $scope.addAnother = function(){
        moveSelectedAssignmentToArray();
        $scope.back();

    };

    function moveSelectedAssignmentToArray(){
        if($scope.selectedItem.sItem.length > 0){
            //move to temp array
            switch ($scope.current.entityLevelSelectionType){
                case 0 :
                    $scope.custodianAssignment = $scope.selectedItem.sItem;
                    break;
                case 1 :
                    $scope.subAdvisorAssignment = $scope.selectedItem.sItem;
                    break;
                case 2 :
                    $scope.managementStyleAssignment = $scope.selectedItem.sItem;
                    break;
                case 3 :
                    $scope.brokerDealerAssignment = $scope.selectedItem.sItem;
                    break;
                case 4 :
                    $scope.registrationTypeAssignment = $scope.selectedItem.sItem;
                    break;
                case 5 :
                    $scope.fundFamilyAssignment = $scope.selectedItem.sItem;
                    break;
                case 6 :
                    $scope.sourceOfFundsAssignment = $scope.selectedItem.sItem;
                    break;
                case 7 :
                    $scope.formTypeAssignment = $scope.selectedItem.sItem;
                    break;
                case 8:
                    $scope.feeScheduleAssignment = $scope.selectedItem.sItem;
                    break;
            }
        }
        $scope.selectedItem = {sItem: []};

    }
    var selectionTypeLookUp = {
        0: {name: "custodian", url: '/Portfolio/Custodians', entity: "custodian"},
        1: {name: "sub-advisor", url: '/Portfolio/SubAdvisors/Simple', entity: "subAdvisor"},
        2: {name: "management styles", url: '/Portfolio/Platforms/Simple', entity: "managementStyles"},
        3: {name: "broker/dealer", url: '/Portfolio/BrokerDealers/Simple', entity: "brokerDealer"},
        4: {name: "registration type", url: '/Portfolio/Registrations/Types', entity: "registrationType"},
        5: {name: "fund family", url: '/Portfolio/FundFamilies/Simple', entity: "fundFamily"},
        6: {name: "source of funds", url: '', entity:"sourceOfFunds"},
        7: {name: "form type", url:'', entity: "formType"},
        8: {name: "Fee Schedule", url:'/Billing/Schedules/Simple?schedule=fee', entity:"feeSchedule"}
    };

    function setSelectedEntityTypeName(){
        var lookUp = selectionTypeLookUp[$scope.current.entityLevelSelectionType];

        //Source of funds
        if(lookUp.name == 'source of funds'){
            $scope.items =  [{id: 1, name: "Rollover"}, {id: 2, name: "Transfer"},{id: 3, name: "Ach/Wire"}, {id: 4, name: "Cash/Check"}];
        }  // form types
        else if (lookUp.name == 'form type'){
           $scope.items = [{id: 1, name: "New Account"}, {id: 2, name: "Distribution"}]
        }
        else{
            $http.get(lookUp.url, {trackerMsg:'Retrieving available paperwork forms'})
                .then(function(response){
                    $scope.items = response.data;
                });
        }
        $scope.current.selectionTypeName = lookUp.name;
    }
    function initialize() {
        setSelectedEntityTypeName();
    }

    initialize();
});

app.controller('PaperworkAssignmentPreviewCtrl', function PaperworkAssignmentPreviewCtrl($scope, $http, $oasRights, dialog){

    function initialize(){
        LoadDropDowns();
    }

    function LoadDropDowns(){
        var selectionTypeLookUp = {
            0: {name: "custodian", url: '/Portfolio/Custodians', entity: "custodian"},
            1: {name: "sub-advisor", url: '/Portfolio/SubAdvisors/Simple', entity: "subAdvisor"},
            2: {name: "management styles", url: '/Portfolio/Platforms/Simple', entity: "managementStyles"},
            3: {name: "broker/dealer", url: '/Portfolio/BrokerDealers/Simple', entity: "brokerDealer"},
            4: {name: "registration type", url: '/Portfolio/Registrations/Types', entity: "registrationType"},
            5: {name: "fund family", url: '/Portfolio/FundFamilies/Simple', entity: "fundFamily"},
            6: {name: "source of funds", url: '', entity:"sourceOfFunds"},
            7: {name: "form type", url:'', entity: "formType"},
            8: {name: "fee schedule", url: '/Billing/Schedules/Simple?schedule=fee', entity: "feeSchedule"}

        };

        $http.get(selectionTypeLookUp[0].url, {trackerMsg:'Loading custodians'})
            .then(function(response){
                $scope.custodianAssignment = response.data;
            });
        $http.get(selectionTypeLookUp[1].url, {trackerMsg:'Loading sub-advisors'})
            .then(function(response){
                $scope.subAdvisorAssignment = response.data;
            });
        $http.get(selectionTypeLookUp[2].url, {trackerMsg:'Loading management styles'})
            .then(function(response){
                $scope.managementStyleAssignment = response.data;
            });
        $http.get(selectionTypeLookUp[3].url, {trackerMsg:'Loading broker/dealers'})
            .then(function(response){
                $scope.brokerDealerAssignment = response.data;
            });
        $http.get(selectionTypeLookUp[4].url, {trackerMsg:'Loading account types'})
            .then(function(response){
                $scope.registrationTypeAssignment = response.data;
            });
        $http.get(selectionTypeLookUp[5].url, {trackerMsg:'Loading fund families'})
            .then(function(response){
                $scope.fundFamilyAssignment = response.data;
            });
        $http.get(selectionTypeLookUp[8].url, {trackerMsg:'Loading fee schedules'})
            .then(function(response){
                $scope.feeScheduleAssignment = response.data;
            });

        $scope.sourceOfFundsAssignment = [{id: 1, name: "Rollover"}, {id: 2, name: "Transfer"},{id: 3, name: "Ach/Wire"}, {id: 4, name: "Cash/Check"}];
        $scope.formTypeAssignment =  [{id: 1, name: "New Account"}, {id: 2, name: "Distribution"}];
    }

    $scope.search = function(){

        var custodianId = $scope.custodianAssignment ? $scope.custodianAssignment.id : null;
        var brokerDealerId = $scope.brokerDealerAssignment ? $scope.brokerDealerAssignment.id : null;
        var subAdvisorId = $scope.subAdvisorAssignment ? $scope.subAdvisorAssignment.id : null;
        var accountTypeId = $scope.registrationTypeAssignment ? $scope.registrationTypeAssignment.id : null;
        var managementStyleId = $scope.managementStyleAssignment ? $scope.managementStyleAssignment.id : null;
        var fundFamilyId = $scope.fundFamilyAssignment ? $scope.fundFamilyAssignment.id : null;
        var sourceOfFundsId = $scope.sourceOfFundsAssignment.id ? $scope.sourceOfFundsAssignment.id : null;
        var formTypeId = $scope.formTypeAssignment.id ? $scope.formTypeAssignment.id : null;
        var feeScheduleId = $scope.feeScheduleAssignment.id ? $scope.feeScheduleAssignment.id : null;

        $http.get('/Integrations/LaserApp/Forms?custodianId=' + custodianId +
                    '&brokerDealerId=' + brokerDealerId + '&managementStyleId='+ managementStyleId + '&accountTypeId=' + accountTypeId +
                    '&fundFamilyId=' + fundFamilyId + '&subAdvisorId=' + subAdvisorId + '&sourceOfFunds=' + sourceOfFundsId + '&formType=' + formTypeId + '&feeSchedule=' + feeScheduleId)
            .then(function(response){
                $scope.paperworkFormFilteredItems = response.data;
            });

    };

    $scope.goToForm = function(id){
        dialog.close(id);
    };
    $scope.close = function(){
      dialog.close(null);
    };

    $scope.paperworkFormFilteredItems = [];
    $scope.custodianAssignment = [];
    $scope.brokerDealerAssignment = [];
    $scope.subAdvisorAssignment = [];
    $scope.registrationTypeAssignment = [];
    $scope.managementStyleAssignment = [];
    $scope.fundFamilyAssignment = [];
    $scope.sourceOfFundsAssignment = [];
    $scope.formTypeAssignment = [];
    $scope.feeScheduleAssignment = [];

    initialize();
});

app.service('$paperwork',['$http','$q', function ($http, $q) {
    //PRIVATE VARIABLES
    var paperWorkData = {id: 0, form: null, isDirty: false };
    var tempPaperWorkList = {original: [], changed: []};
    var self = this;

    self.initialize = function(){
        tempPaperWorkList = {original: [], changed: []};
    };
    self.getFormList = function(){
        return $http.get('/Integrations/LaserApp/Forms', {trackerMsg:'Retrieving available paperwork forms'})
            .then(function(response){
                return response.data ? response.data : [];
            })
    };

    self.setFormChangeList = function(formChange){
        //already in array
        if(tempPaperWorkList.original.find({id:formChange.id})) return;

        tempPaperWorkList.original.push(angular.copy(formChange));
        tempPaperWorkList.changed.push(formChange);
        self.cacheChanges();
    };

    self.getFormInfoById = function(id){
        //check to see if in the changedlist already
        var x = tempPaperWorkList.changed.find({id: id});
        if(x){
            var deferred = $q.defer();
            deferred.resolve(x);
            return deferred.promise;
        }else{
            paperWorkData.id = id;
            return $http.get('/Integrations/LaserApp/Forms/' + id, {trackerMsg:'Retrieving paperwork assignment'})
                .then(function(response){
                    paperWorkData.form = response.data;
                    paperWorkData.isDirty = false;
                    return response.data;
                });
        }
    };

    self.cacheChanges = function(){
        paperWorkData.isDirty = true;
    };

    self.isDirty = function() {
        for (var i = 0; i < tempPaperWorkList.changed.length; i++){
            var item = tempPaperWorkList.changed[i];
            if(!angular.equals(item, tempPaperWorkList.original[i])){
                    return true;
            }
        }
        return false;
    };

    self.save = function() {
        var promises = [];

        for (var i = 0; i < tempPaperWorkList.changed.length; i++){
            var item = tempPaperWorkList.changed[i];
            if(!angular.equals(item, tempPaperWorkList.original[i])){
                promises.push($http.put('/Integrations/LaserApp/Forms/' + item.id, item, {trackerMsg: 'Updating LaserApp paperwork assignment'}));
            }
        }

        tempPaperWorkList = null;
        return promises;
    };
}]);
'use strict';
function AkoyaCredentialsCtrl($scope, $http, $q, $akoyacredservice) {

    function initialize() {
        $scope.current.currentDBAdvisorNumber = JSON.parse(sessionStorage.getItem('oas_authorization')).advisorNumber;
        $scope.getCredentials();
    };

    $scope.getCredentials = function (setToDirty = false) {
        $akoyacredservice.getCredentials()
            .then(function (creds) {
                $scope.current.secret = creds.secret ?? '';
                $scope.current.clientId = creds.clientId ?? '';
                $scope.current.isRegisteringSectionVisible = ($scope.current.secret == '' && $scope.current.clientId == '');
                if (setToDirty) {
                    $akoyacredservice.setIsDirty($scope.current.secret, $scope.current.clientId);
                }
            });
    }

    $scope.checkAdvisorNumber = function () {
        let status = ($scope.current.advisorNumberUserEntered != $scope.current.currentDBAdvisorNumber);
        $scope.current.isRegisterButtonDisabled = status;
    }

    $scope.register = function () {
        $scope.current.isRegistering = true;
        $scope.current.areCredsDisabled = true;
        $scope.current.isRegisterButtonDisabled = true;
        $scope.current.regStatus = "Processing Registration..."

        $akoyacredservice.register()
            .then(response => {
                if (response.status >= 300) {
                    $scope.current.regStatus = response;
                    $scope.current.isRegisterButtonDisabled = false;
                }
                else {
                    $scope.current.regStatus = "Successfully registered!";
                    // Do not allow any previously changed clientid/secret values to save
                    $akoyacredservice.clearIsDirty();  

                    // Everything should be correct - but make sure all our fields still have the right status
                    $scope.current.areCredsDisabled = true;
                    $scope.current.isRegisterButtonDisabled = false;

                    $scope.getCredentials(true);
                }
            })
            .catch(error => {
                if (error.data.ExceptionMessage)
                {
                    $scope.current.regStatus = error.data.ExceptionMessage;
                }
                if (error.data.Message)
                {
                    $scope.current.regStatus = error.data.Message;
                }
                else 
                {
                    $scope.current.regStatus = "Error registering";
                }
                $scope.current.isRegisterButtonDisabled = false;
                $scope.current.areCredsDisabled = false;
            })
    };

    $scope.hasChanges = function () {
        $akoyacredservice.setIsDirty($scope.current.secret, $scope.current.clientId);
    };

    $scope.setClientId = function (value) {
        $scope.current.clientId = value;
        $scope.hasChanges();
    };

    $scope.setSecret = function (value) {
        $scope.current.secret = value;
        $scope.hasChanges();
    };

    $scope.current =
    {
        secret: ''
        , clientId: ''
        , isRegisteringSectionVisible: false
        , isRegisterButtonDisabled: true
        , isRegistering: false
        , currentDBAdvisorNumber: -1
        , regStatus: ''
        , advisorNumberUserEntered: ''
        , areCredsDisabled: false
    }

    initialize();
};

app.controller('AkoyaCredentialsCtrl', AkoyaCredentialsCtrl);

app.service('$akoyacredservice', ['$http', '$q', function ($http, $q) {
    var self = this;
    var isDirty = false;

    self.secret = '';
    self.clientId = '';

    self.initialize = function () {
    };

    self.clearIsDirty = function () {
        isDirty = false;
    };

    self.setIsDirty = function (secret, clientId) {
        self.secret = secret;
        self.clientId = clientId;
        isDirty = true;
    };

    self.isDirty = function () {
        return isDirty;
    };

    self.register = function () {
       return $http.post('/Integrations/Akoya/App', { trackerMsg: 'Registering new Application with Akoya' })
       };

    self.getCredentials = function () {
        return $http.get('/Integrations/Akoya/Configuration', { trackerMsg: 'Retrieving Akoya Configurations' })
            .then(function (response) {
                return response.data;
            })
    };

    self.save = function () {
        let integrationConfig = {
            ClientId: self.clientId,
            Secret: self.secret
        };

        return $http.put('/Integrations/Akoya/Configuration', integrationConfig, { trackerMsg: 'Updating Akoya Configurations' });
    };

}]);
'use strict';

var newAccountsCtrl = app.controller('NewAccountsCtrl', function NewAccountsCtrl($scope, $http, $oasRights, $portfolio, $settings, $timeout, $location, $routeParams, views, numberOfDays, $dialog, entities, apps, $rebalance, $tactical, $window, API_CONFIG, $schwab, splitIoService) {
    //PRIVATE VARIABLES
    var startDate;
    var selectedRegIds = [];
    var selectedClientIds = [];
    var selectedAccounts = [];
    var accountId = null, registrationId = null,isSleeveAccount = false;


    //PRIVATE METHODS
    function init() {
        $scope.rightsHH = $oasRights.forCode("CLIENTS");
        $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
        $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
        $scope.rightsAst = $oasRights.forCode("ASSETS");
        $scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");
        $scope.rightsNewAccWizard = $oasRights.forCode("NEWACCOUNTWIZ");
        $scope.rightsHouseholding = $oasRights.forCode("HOUSEHOLDINGAPP");
        $scope.rightsPortfolioAudit = $oasRights.forCode("PORTFOLIOLISTSAPP");
        $scope.rightsCancelAccount = $oasRights.forCode("CANCELACCOUNT");
        $scope.rightsUndoCancel = $oasRights.forCode("UNDOACCTCANCEL");
        $scope.rightsTOM = $oasRights.forCode("TRADEORDERMGMT");
        $scope.rightsLaserApp = $oasRights.forCode("LASERAPP");
        $scope.rightsOrionEnterpriseProposal = $oasRights.forCode("ORIONENTERPRISEPROPOSAL");
        $scope.rightsSchwabnewaccount = $oasRights.forCode("SCHWABDIGITALACCOUNTOPENING");
        $scope.rightsRestoreAccounts = $oasRights.forCode("RESTOREACCOUNTS");

        //$scope.rightsTDAnewaccount = $oasRights.forCode("TDADIGITALACCOUNTOPENING");
        $scope.rightsTDAnewaccount = $oasRights.forCode("TDAPP");

        $scope.rightswealthScapenewaccout = $oasRights.forCode("WEALTHSCAPEDIGITALACCOUNTOPENING");
        $scope.rightsstreetScapenewaccout = $oasRights.forCode("STREETSCAPEDIGITALACCOUNTOPENING");
        $scope.rightsBlackRock = $oasRights.forCode("BLACKROCK");

        tryAutoLaunchEditor();
    }

    function tryAutoLaunchEditor(){
         var editor = $location.search().editor;
         var accountId = $location.search().accountId;
         if(editor){
            $scope.selectedIds.push(accountId);
            $scope.openAccountEditor(editor, editor);
         }
    }

    var setStartDate = (function () {
        startDate = Date.create('today').addDays(-$scope.current.numberOfDays);

        $http.get('/Portfolio/Accounts/NewPortfolio/Counts/Header?startdate=' + startDate.formatted())
            .then(function (response) {
                var data = response.data;
                $scope.current.newAccounts = data.newAccounts;
                $scope.current.accountsPending = data.filteredCount;
                $scope.current.newMoneyAvailable = data.newMoneyAvailable;
            });

        $settings.setSetting('newAccountDays', $scope.current.numberOfDays);
        $scope.current.gridQueries[0].days = $scope.current.numberOfDays;
    }).debounce(350);


    //PUBLIC METHODS
    $scope.refreshGrid = function () {
        //$timeout because the $broadcast happens during the same digest as the $watch, so gridDataUrl and usePendingValue hasn't changed in the view yet
        $timeout(function () {
            $scope.$broadcast('event:new-accounts', {action: 'refresh-grid'});
        });
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:new-accounts', {action: 'export-data'});
    };

    $scope.undoCancellation = function () {
        $dialog.confirmAction('Are you sure you want to undo account cancellation?')
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.put('/Portfolio/Accounts/Action/UndoCancel/' + $scope.selectedIds[0], null, {trackerMsg: 'Undoing account cancellation'})
                        .then(function (response) {
                            $dialog.messageBox('Undo Cancel Results', response.data.result).open();

                            $http.get("/Portfolio/Accounts/NewPortfolio" + $scope.selectedIds[0], {trackerMsg: 'Refreshing account'})
                                .then(function (response) {
                                    $scope.$broadcast('event:new-accounts', {action: 'update-item', item: response.data});
                                });
                        });
                }
            });
    };

    $scope.openAccountEditor = function (defaultHeading, defaultCode) {
        if ($scope.selectedIds.length == 1) {
            $portfolio.openEditor(entities.account.value, $scope.selectedIds, defaultHeading, defaultCode, apps.newAccount.name, null)
                .then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:new-accounts', {action: 'update-item', item: rslt});
                    }
                });
        } else {
            $portfolio.openMassEditor(entities.account.value, $scope.selectedIds, apps.newAccount.name, null)
                .then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:new-accounts', {action: 'update-items', items: rslt});
                    }
                });
        }
    };

    $scope.openRegistrationEditor = function () {
        $portfolio.openEditor(entities.registration.value, selectedRegIds, null, null, apps.newAccount.name, null)
            .then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast('event:new-accounts', {action: 'update-items', items: rslt});
                }
            });
    };

    $scope.openHouseholdEditor = function () {
        $portfolio.openEditor(entities.client.value, selectedClientIds, null, null, apps.newAccount.name)
            .then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast('event:new-accounts', {action: 'update-items', items: rslt});
                }
            });
    };

    $scope.openRebalance = function () {
        $rebalance.start(6, $scope.selectedIds);
    };

    $scope.openTactical = function () {
        $tactical.start("account", $scope.selectedIds, true);
    };

    $scope.goToLower = function (urlLevel) {
        $portfolio.goTo(urlLevel, entities.account.value, $scope.selectedIds[0]);
    };

    $scope.goToHigher = function (urlLevel) {
        if ($scope.current.selectedHouseholdId > 0) {
            $portfolio.goTo(urlLevel, entities.client.value, $scope.current.selectedHouseholdId);
        }
    };

    $scope.goToHouseholding = function () {
        $location.url('/portfolio/household/householding?source=' + apps.newAccount.code + '&entityId1=' + selectedClientIds[0] + (selectedClientIds.length > 1 ? '&entityId2=' + selectedClientIds[1] : ''));
    };

    $scope.openCancellationEditor = function (isMassCancel) {
        var args = {id: isMassCancel ? null : $scope.selectedIds[0], entity: entities.account.value, app: apps.newAccount.name, preselectedIds: isMassCancel ? $scope.selectedIds : null};

        $dialog.editor('portfolio/modals/cancelAccount.html', 'CancelAccountCtrl', {args: function () {return args;}})
            .open()
            .then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast('event:new-accounts', {action: 'refresh-grid'});
                }
            });
    };

    $scope.openAccountRestoreEditor = function () {
        $scope.restoreAccountsSelected = [];

        selectedAccounts.forEach((acct) => {
            for (const [key, value] of Object.entries(acct)) {
                $scope.restoreAccountsSelected.push({ accountNumber: value, accountId: Number(key) });
            }
        });

        $scope.showAccountRestoreModal = true;
    };


    $scope.openProposalTool = function (){
        $http.get('/Settings/Database/EntityOptions/Code/69SLEEVETR', {cache: true, trackerMsg: 'Loading use sleeve setting'} )
            .then(function(response){
                var useSleeve = 'false';

                if(response.data.value.toLowerCase() === "true"){
                    useSleeve = 'true';
                }

                if (isSleeveAccount){ // Null out account id if it is a Sleeve Account
                    accountId = null;
                } else {
                    registrationId = null;
                }

                var url = API_CONFIG.ftjProposalToolUrl + '?portfolioId=null&registrationId=' +  registrationId  + '&accountId=' +  accountId + '&UseSleeves='  + useSleeve + '&t=' + sessionStorage.oas_token;
                window.open(url,'_blank');
            });
    };

   $scope.schwabNewAccount = function () {
        // checking for user Authorization, if user is not authorized it will show Authenticate button otherwise it will redirect to schwab
        const url = `../api/v1/Integrations/SchwabAlliance/UserToken?Authorization=${sessionStorage.oas_token}`;
        $http.get(url, { trackerMsg: 'Authenticating User for Schwab', ignoreExceptions: [500] }).then(function (response) {
            if (response && response.data.access_token != null && response.data.access_token.length > 0) {
                $scope.showAuthenticateBtn = false;
                 //It will redirect to schwab when user is Authorized
                $schwab.SchwabNewAccount($scope.selectedIds);
            } else $scope.showAuthenticateBtn = true;
        }).catch(function (error) {
            if (error.status === 500) {
                //show Authenticate button when user is not Authorized
                $scope.showAuthenticateBtn = true;
            }
        });
    };

    // To cancel the Authenticate button popup
     $scope.cancel = function () {
         $scope.showAuthenticateBtn = false;
    };

    $scope.schwabAccountStatus = function() {
            //$window.open(API_CONFIG.baseUrl + '/Integrations/SchwabSII/SSO?pageId=18&Authorization=' + sessionStorage.oas_token);
            $window.open(API_CONFIG.baseUrl + '/Integrations/SchwabSII/SsoV2/18?Authorization=' + sessionStorage.oas_token);
    };

    $scope.schwabAlerts = function() {
        //$window.open(API_CONFIG.baseUrl + '/Integrations/SchwabSII/SSO?pageId=3&Authorization=' + sessionStorage.oas_token);
        $window.open(API_CONFIG.baseUrl + '/Integrations/SchwabSII/SsoV2/3?Authorization=' + sessionStorage.oas_token);
    };

    $scope.tdAmeritradeNewAccount = function() {
            $http.get('/Integrations/NewAccount/' + accountId + '/TDAmeritrade').then(function (response) {
                var request = {referenceId : response.data,
                    tdaContext: "accountWizard"};
                $window.open(API_CONFIG.baseUrl + '/Integrations/TDAmeritrade/Action/StartSSO?referenceId=' + request.referenceId +'&tdaContext=accountWizard&Authorization=' + sessionStorage.oas_token)
            });
    };

    $scope.fidelityNewAccount = function(fidelityscape) {
        $http.get('/Integrations/NewAccount/' + accountId + '/'+ fidelityscape).then(function (response) {
             var request = {referenceId : response.data}

            $window.open(API_CONFIG.baseUrl + '/Integrations/Fidelity/'+ fidelityscape +'/SSO?accountNumber=' + request.referenceId +'&relayState=UrlProspectPrefill&Authorization=' + sessionStorage.oas_token)
        });
    };

    $scope.fidelityCreds = function(fidelityscape){
        $window.open('/orionconnectapp/fidelitydao-credentials.html?location=' + fidelityscape +'&state=init&t=' + sessionStorage.oas_token);
    };

    $scope.openBlackrockiRetire = function(){
        var testEnvironment = window.location.host.has("local") || window.location.host.has("test") ? "true" : "false";
        $window.open(API_CONFIG.baseUrl + '/Integrations/BlackRock/Redirect?testEnvironment=' + testEnvironment + '&portfolioId=' + selectedClientIds[0] + '&entity=' + parseInt(entities.account.value) + '&entityId=' + accountId + '&Authorization=' + sessionStorage.oas_token);
    };

    $scope.onAccountRestoreModalClose = function () {
        $scope.showAccountRestoreModal = false;
    };

    //INITIALIZE
    $scope.selectedIds = [];
    $scope.views = views;

    $scope.current = {
        view: views[0],
        newAccountFilter: $routeParams.newAccountFilter,
        numberOfDays: $settings.getSetting('newAccountDays') || numberOfDays,
        newAccounts: 0,
        accountsPending: 0,
        newMoneyAvailable: 0.00,
        clientId: null,
        isActive: false,
        maxDays: numberOfDays < 90 ? 90 : numberOfDays,
        gridQueries: [{id: "CUSTOM_1", name: "Date Filter", filterFn: function (x) {return x && Date.create(x).isAfter(startDate);}, field: "createdDate", enabled: true, visible: false}]
    };

    $scope.current.startDate = Date.create('today').addDays(-$scope.current.maxDays).formatted();
    $scope.showAccountRestoreModal = false;
    $scope.restoreAccountsSelected = [];

    setStartDate();

    init();


    //EVENT LISTENERS
    $scope.$on('event:account-select', function (e, args) {
        if (!args.length) return;

        selectedRegIds = args.map('registrationId').unique();
        selectedClientIds = args.map('clientId').unique();
        selectedAccounts = args.map((acct) => ({ [acct.id]: acct.accountNumber }));

        $scope.current.clientId = args[0].clientId;
        accountId = args[0].id;
        isSleeveAccount = args[0].isSleeveAccount;
        registrationId = args[0].registrationId;

        $scope.current.showSchwabLink = args[0].custodian.match(/schwab/gi) != null;
        $scope.current.showTDALink = (args[0].custodian.match(/TD Ameri/gi) != null || args[0].custodian.match(/TDA/gi) != null);
        $scope.current.showFidelityLink = args[0].custodian.match(/Fidelity/gi) != null;
        $scope.current.isActive = args.map('isActive').unique()[0];
        checkCustodian(accountId);
    });

    function checkCustodian(accountId){
        if(!accountId || $scope.current.showFidelityLink == true || $scope.current.showSchwabLink == true){
            return;
        }
        $http.get(`/Integrations/Custodian/Account/${accountId}`)
        .then(function(result){
            if(result.data == "Fidelity"){
                $scope.current.showFidelityLink = true;
            }
            if(result.data == "Schwab"){
                $scope.current.showSchwabLink = true;
            }
        });
    }

    //SCOPE WATCHERS
    $scope.$watch('current.numberOfDays', function (newValue, oldValue) {
        if (!newValue || newValue === oldValue) return;

        setStartDate();
    });
});



newAccountsCtrl.loadNumberOfDays = ["$http", function ($http) {
    return $http.get('/Settings/Apps/newAccountsCenter/Options/numberofdays', {cache: true, trackerMsg: 'Loading settings for new accounts'})
        .then(function (response) {
            return parseInt(response.data.value);
        });
}];


app.controller('NewAccountsAddCtrl', ["$scope", "$http", "$q", "$window", "$routeParams", "$location", "$portfolio", "billFrequency", "billingStyle", "valuationMethod", "$oasRights", "custodianTypes", "entities", "apps", "splitIoService", function ($scope, $http, $q, $window, $routeParams, $location, $portfolio, billFrequency, billingStyle, valuationMethod, $oasRights, custodianTypes, entities, apps, splitIoService) {
    //PRIVATE VARIABLES
    var registrationList;
    var defaultUDFs = {};

    //PRIVATE METHODS
    function existingClientFlagChanged(newValue, householdId) {
        if (newValue === false) {
            $scope.current.selectedClient = null;
            $scope.current.existingReg = false;
            $scope.current.selectedReg = null;
            registrationList = null;
            $scope.current.registrations = null;
            $scope.newAccount.client.id = 0;
            if (defaultUDFs.client) {
                $scope.newAccount.client.userDefinedFields = defaultUDFs.client;
            }
            $scope.current.availablePlaidAccounts = [];
            $scope.current.availableAkoyaAccounts = [];

            removeExtraProperties();
        } else {
            if (householdId) {
                $http.get('/Portfolio/Clients/Simple/Search?search=' + householdId)
                    .then(function (households) {
                        selectedClientChanged(households.data[0]);
                    });
            }
        }
    }

    function selectedClientChanged(householdSearchResult) {
        if (householdSearchResult) {
            $http.get('/Portfolio/Clients/Verbose/' + householdSearchResult.id, {trackerMsg: 'Loading selected household'})
                .then(function (response) {
                    $scope.current.selectedClient = householdSearchResult;
                    $scope.newAccount.client = response.data;
                    loadSelectedRep($scope.newAccount.client.portfolio.representativeId);
                    loadExistingRegistrations(householdSearchResult.id);
                    if ($scope.current.heldawayProvider === 'plaid'){
                        loadAvailablePlaidAccounts(householdSearchResult.id);
                    }else{
                        $scope.current.availablePlaidAccounts = [];
                    }
                    if ($scope.current.heldawayProvider === 'akoya'){
                        loadAvailableAkoyaAccounts(householdSearchResult.id);
                    }else{
                        $scope.current.availableAkoyaAccounts = [];
                    }
                });
        } else {
            if (householdSearchResult != null) {
                $scope.current.selectedClient = null;
            }
            
            $scope.current.selectedReg = null;
            registrationList = null;
            $scope.current.registrations = null;
            $scope.newAccount.client.id = 0;
            $scope.newAccount.registration.id = 0;
            $scope.current.availablePlaidAccounts = [];
            $scope.current.availableAkoyaAccounts = [];
            removeExtraProperties();
        }
    }

    function init() {
        $scope.current.paperworkProvider = 'laserApp';

        var billingEnums = {
            billStyles: billingStyle,
            billFrequencies: billFrequency,
            valuationMethods: valuationMethod
        };

        Object.each(billingEnums, function (key, value) {
            $scope.current[key] = $portfolio.enumToSimpleList(value);
        });

        $http.get('/Integrations/LaserApp/Configuration/Test', {trackerMsg: 'Check for LaserApp integration', ignoreExceptions: true})
            .then(function (result) {
                $scope.current.loadLaserApp = result.status >= 200 || result.status <= 299;
            });

        //The wizard melts down unless these are loaded first
        var promises = [
            $http.get("/Settings/Database/EntityOptions/Code/SELFDIRECTEDSUBADVID", {cache: true, trackerMsg: 'Loading model settings'})
                .then(function (response) {
                    var data = response.data;
                    $scope.customModelSetup = {enabled: data.value !== "0", selfDirectedId: parseInt(data.value)};
                }),
            $http.get('/Portfolio/Representatives/Simple?$orderby=Name', {trackerMsg: 'Loading representatives'})
                .then(function (response) {
                    $scope.current.reps = response.data;
                }),
            $http.get('/Portfolio/Custodians/Simple?$orderby=Name')
                .then(function (response) {
                    $scope.current.custodians = response.data;
                }),
            $http.get('/Portfolio/FundFamilies/Simple?$orderby=Name')
                .then(function (response) {
                    $scope.current.fundFamilies = response.data;
                }),
            $http.get('/Portfolio/Registrations/Types?$orderby=Name')
                .then(function (response) {
                    $scope.current.regTypes = response.data;
                }),
            $http.get('/Portfolio/Platforms/Simple?$orderby=Name')
                .then(function (response) {
                    $scope.current.platforms = response.data;
                }),
            $http.get('/Billing/PayMethods?$orderby=Name')
                .then(function (response) {
                    $scope.current.payMethods = response.data;
                }),
            $http.get('/Billing/Schedules/Simple?schedule=Fee&$orderby=Name')
                .then(function (response) {
                    $scope.current.billFees = response.data;
                }),
            $http.get('/Portfolio/Registrations/Beneficiary/Relations', {trackerMsg: 'Loading relationships for beneficiaries'})
                .then(function (response) {
                    $scope.current.beneficiaryRelationships = response.data;
                }),
            $http.get('/Portfolio/Custodians/Simple', {trackerMsg: 'Loading custodians'})
                .then(function (response) {
                    $scope.current.custodianWithTrustType = response.data;
                }),
            $http.get('/Portfolio/BusinessLines/Simple', {trackerMsg: 'Loading business lines'})
                .then(function (response) {
                    $scope.current.businessLines = response.data;
                }),
            $http.get('/Billing/MasterPayoutSchedule/Simple?$orderby=Name', {trackerMsg: 'Loading payout schedules'})
                .then(function (response) {
                    $scope.current.billPayouts = response.data;
                }),
            $http.get("/Settings/Database/EntityOptions/Code/69SHOWREGI", {cache: true, trackerMsg: 'Loading settings'})
                .then(function (response) {
                    $scope.current.showRegAddress = response.data.value.toLowerCase() === "true";

                    if ($scope.current.showRegAddress) {
                        registerAddressWatches();
                    }

                    return $scope.current.showRegAddress;
                })
                .then(function (customRegExpand) {
                    return $http.get('/Portfolio/Accounts/NewPortfolio/New' + (customRegExpand ? '?expandRegistration=Portfolio,Suitability,Beneficiaries,Contact' : ''));
                })
                .then(function (response) {
                    $scope.newAccount = response.data;
                    $scope.newAccount.client.portfolio.isActive = true;
                    $scope.newAccount.registration.beneficiaries = [{name: "", dob: "", ssn: "", relation: "", address: "", percentage: 0.0, type: "Primary"}];
                    $scope.newAccount.registration.portfolio.isActive = true;
                    $scope.newAccount.account.portfolio.accountStatusDescription = "Pending";
                    if ($scope.newAccount && $scope.newAccount.client && 
                        $scope.newAccount.client.portfolio && 
                        $scope.newAccount.client.portfolio.representativeId && 
                        $scope.newAccount.client.portfolio.representativeId !== 0) {
                            loadSelectedRep($scope.newAccount.client.portfolio.representativeId);
                    }

                    setCycleMonths($scope.newAccount.account.billing.billFrequency);

                    if ($scope.newAccount.account.billing.plaidAccountId){
                        $scope.current.heldawayProvider = 'plaid';
                    }  else {
                        $scope.current.heldawayProvider = 'byAllAccounts';
                    }

                    if ($oasRights.canUpdate("CUSTOMFIELDS")) {
                        var udfsToFetch = {client: "Household", registration: "Registration", account: "Account"};

                        Object.each(udfsToFetch, function (key, value) {
                            $http.get('/Settings/UserDefinedFields/Definitions/' + key, {trackerMsg: 'Loading ' + key + ' custom fields'})
                                .then(function (response) {
                                    var fields = response.data.map(function (definition) {
                                        return $portfolio.makeCustomFieldFromDefinition(definition, value);
                                    });

                                    $portfolio.cleanCustomFields(fields);

                                    $scope.newAccount[key].userDefinedFields = fields;
                                    defaultUDFs[key] = fields;
                                });
                        });
                    }
                }),
            $http.get("/Settings/Database/EntityOptions/Code/69NACACCOUNTNUM", {cache: true, trackerMsg: 'Loading Settings'})
                .then(function (response) {
                    $scope.current.disabledAccountNumber = response.data.value.toLowerCase() === "false";
                    return $scope.current.disabledAccountNumber;
                })
        ];

        $q.all(promises)
            .then(function () {
                if ($routeParams.mode === "import") {
                    $scope.importAccounts();
                } else {
                    $scope.loadWizard();

                    if ($routeParams.key) {
                        $scope.current.existingClient = true;
                        existingClientFlagChanged(true, $routeParams.key);
                    }
                }
            });
    }

    function loadSelectedRep(repId) {
        if (repId) {
            $http.get(`/Portfolio/Representatives/${repId}/Simple`, 
                {trackerMsg: 'Loading representative information', ignoreExceptions: true})
                .then((response) => {
                    if (response && response.data) {
                        var rep = response.data;
                        $scope.current.selectedRep = {id: rep.id, name: rep.name, number: rep.number}
                    }
                });
        }        
    }

    function resetScreens() {
        $scope.current.enableWizard = false;
        $scope.current.enableImport = false;
    }

    function isValidClient() {
        var isValid = true;

        if (!$scope.newAccount.client.id) {
            isValid = isValid && ($scope.newAccount.client.portfolio.lastName && $scope.newAccount.client.portfolio.lastName != "");
            isValid = isValid && ($scope.newAccount.client.portfolio.name && $scope.newAccount.client.portfolio.name != "");
            isValid = isValid && (angular.isNumber($scope.newAccount.client.portfolio.representativeId) && $scope.newAccount.client.portfolio.representativeId != 0);
            isValid = isValid && !$scope.newAccount.client.portfolio.invalidEmail;
        }

        return isValid;
    }

    function isValidRegistration() {
        var isValid = true;

        if (!$scope.newAccount.registration.id) {
            isValid = isValid && ($scope.newAccount.registration.portfolio.lastName != "");
            isValid = isValid && ($scope.newAccount.registration.portfolio.name != "");
            isValid = isValid && (angular.isNumber($scope.newAccount.registration.portfolio.typeId) && $scope.newAccount.registration.portfolio.typeId != 0);
            isValid = isValid && (!$scope.current.regDobRequired || $scope.newAccount.registration.portfolio.dob);
            isValid = isValid && (!$scope.current.regSsnRequired || $scope.newAccount.registration.portfolio.ssN_TaxID);
            isValid = isValid && !$scope.current.regDobIsInvalid
        }

        return isValid;
    }

    function isValidAccount() {
        var isValid = true;
        isValid = isValid && (angular.isNumber($scope.newAccount.account.portfolio.custodianId) && $scope.newAccount.account.portfolio.custodianId != 0);
        isValid = isValid && (angular.isNumber($scope.newAccount.account.portfolio.fundFamilyId) && $scope.newAccount.account.portfolio.fundFamilyId != 0);
        isValid = isValid && (angular.isNumber($scope.newAccount.account.portfolio.managementStyleId) && $scope.newAccount.account.portfolio.managementStyleId != 0);
        isValid = isValid && (angular.isNumber($scope.newAccount.account.billing.feeScheduleId) && $scope.newAccount.account.billing.feeScheduleId != 0);
        isValid = isValid && (angular.isNumber($scope.newAccount.account.billing.masterPayoutScheduleId) && $scope.newAccount.account.billing.masterPayoutScheduleId != 0);
        isValid = isValid && ($scope.newAccount.account.billing.valuationMethod && $scope.newAccount.account.billing.valuationMethod != "");
        isValid = isValid && ($scope.newAccount.account.billing.billStyle && $scope.newAccount.account.billing.billStyle != "");
        isValid = isValid && ($scope.newAccount.account.billing.billFrequency && $scope.newAccount.account.billing.billFrequency != "");
        isValid = isValid && (angular.isNumber($scope.newAccount.account.billing.cycleMonth) && $scope.newAccount.account.billing.cycleMonth != 0);
        isValid = isValid && (angular.isNumber($scope.newAccount.account.billing.payMethodId) && $scope.newAccount.account.billing.payMethodId != 0);
        return isValid;
    }

    function checkBeneficiaries() {
        $scope.newAccount.registration.beneficiaries.remove(function (beneficiary) {
            return beneficiary.name.trim() === '' && beneficiary.dob.trim() === '' && beneficiary.ssn.trim() === '' && beneficiary.relation.trim() === '' && beneficiary.address.trim() === '';
        });
        $scope.newAccount.registration.beneficiaries.each(function (beneficiary) {
            beneficiary.dob = Date.create(beneficiary.dob).formatted(false);
            if (beneficiary.type.trim() === "")
                beneficiary.type = "Primary";
            if (!beneficiary.id || beneficiary.id < 0)
                beneficiary.reason = "adding new beneficiary"
        });
    }

    function removeExtraProperties(regOnly) {
        if (!regOnly) {
            delete $scope.newAccount.client.additionalAccounts;
            delete $scope.newAccount.client.billing;
            delete $scope.newAccount.client.documents;
            delete $scope.newAccount.client.feePayingAccounts;
            delete $scope.newAccount.client.householdMembers;
            delete $scope.newAccount.client.notes;
            delete $scope.newAccount.client.recurringAdjustments;
            delete $scope.newAccount.client.suitability;

            delete $scope.newAccount.client.portfolio.categoryId;
            delete $scope.newAccount.client.portfolio.company;
            delete $scope.newAccount.client.portfolio.country;
            delete $scope.newAccount.client.portfolio.gender;
            delete $scope.newAccount.client.portfolio.jobTitle;
            delete $scope.newAccount.client.portfolio.startDate;
            delete $scope.newAccount.client.portfolio.webAddress;
        }

        delete $scope.newAccount.registration.notes;

        delete $scope.newAccount.registration.portfolio.clientId;
        delete $scope.newAccount.registration.portfolio.company;
        delete $scope.newAccount.registration.portfolio.gender;
        delete $scope.newAccount.registration.portfolio.jobTitle;
        delete $scope.newAccount.registration.portfolio.typeCode;
        delete $scope.newAccount.registration.portfolio.accountType;
    }

    function setRegistrationList() {
        $scope.current.registrations = registrationList.findAll(function (registration) {
            return registration.typeId === $scope.current.selectAccountType && registration.isActive;
        });
    }

    function loadExistingRegistrations(clientId) {
        $http.get('/Portfolio/Clients/' + clientId + '/Registrations', {trackerMsg: 'Loading registrations for selected household'})
            .then(function (response) {
                registrationList = response.data;
                setRegistrationList();
            });
    }

    function loadNewAccountAndForms(result) {
        if ((result.client && result.client.id != 0) && (result.registration && result.registration.id != 0) && (result.account && result.account.id != 0)) {
            $scope.newAccount = result;
            if ($scope.current.loadLaserApp) {
                $http.get('/Integrations/LaserApp/Accounts/' + $scope.newAccount.account.id + "/Forms", {trackerMsg: 'Loading forms'})
                    .then(function (response) {
                        var data = response.data;
                        data.forEach(function (form) {
                            form.selected = form.isRequired;
                        });
                        $scope.current.formsLibrary = data;
                        $scope.current.wizardStep = $scope.wizardSteps.length - 1;
                    });
            } else {
                $scope.current.wizardStep = $scope.wizardSteps.length - 1;
            }
        }
    }

    function setCycleMonths(frequency) {
        switch (frequency) {
            case billFrequency.monthly.name:
                $scope.current.cycleMonths = [{id: 1, name: 'Every Month'}];
                break;
            case billFrequency.quarterly.name:
                buildCycleMonths(3, ' of Quarter');
                break;
            case billFrequency.semiannually.name:
                buildCycleMonths(6, ' of Cycle');
                break;
            default:
                buildCycleMonths(12, ' of Cycle');
        }
    }

    function buildCycleMonths(upperBound, endText) {
        $scope.current.cycleMonths = [];
        (1).upto(upperBound, function (n) {
            $scope.current.cycleMonths.push({id: n, name: 'Month ' + n + endText});
        });
    }

    function loadAvailablePlaidAccounts(clientId) {
        if ($scope.current.availablePlaidAccounts.length > 0) return;
        $http.get('/Integrations/Plaid/Accounts/'+clientId, {trackerMsg: 'Loading available Plaid accounts for selected household'})
            .then(function (response) {
                $scope.current.availablePlaidAccounts = response.data;
            });
    }

    function loadAvailableAkoyaAccounts(clientId) {
        if ($scope.current.availableAkoyaAccounts.length > 0) return;
        $http.get('/Integrations/CustodialIntegrator/AkoyaAccounts/Simple?isLinked=false&clientId='+clientId, {trackerMsg: 'Loading available Akoya accounts for selected household'})
            .then(function (response) {
                $scope.current.availableAkoyaAccounts = response.data;
            });
    }

    //PUBLIC METHODS
    $scope.invalidEmail = function (invalid) {
        $scope.newAccount.client.portfolio.invalidEmail = invalid;
    }

    $scope.setEmail = function (value ) {
        $scope.newAccount.client.portfolio.email = value;
    }

    $scope.loadWizard = function () {
        $scope.current.enableWizard = true;
        $scope.current.enableImport = false;
    };

    $scope.importAccounts = function () {
        $scope.current.enableWizard = false;
        $scope.current.enableImport = true;
        $scope.current.selectedItems = [];
        $scope.current.processedItems = [];
    };

    $scope.processAccounts = function () {
        $scope.current.executing = true;

        $http.post('/Portfolio/ValidateImport/NewPortfolio/Process', $scope.current.selectedItems, {trackerMsg: 'Processing new account imports'})
            .then(function (response) {
                var data = response.data;

                $scope.current.processedItems = data;
                $scope.current.isImportProcessed = data.every({isValid: true});
            })
            .finally(function () {
                $scope.current.executing = false;
            });
    };

    $scope.back = function () {
        if ($scope.current.wizardStep === 0) {
            resetScreens();
            return;
        }
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep -= 1;
    };

    $scope.next = function () {
        if ($scope.current.wizardStep === 1 && $scope.newAccount.registration.portfolio.dob) {
            $scope.newAccount.registration.portfolio.dob = Date.create($scope.newAccount.registration.portfolio.dob).formatted(false);
            if ($scope.newAccount.client.id === 0) {
                $scope.newAccount.client.portfolio.dob = $scope.newAccount.registration.portfolio.dob;
            }
        }
        if ($scope.current.wizardStep === 2 && $scope.newAccount.account.billing.billStartDate){
            $scope.newAccount.account.billing.billStartDate = Date.create($scope.newAccount.account.billing.billStartDate).formatted(false);
        }
        if ($scope.current.wizardStep === 3) {
            checkBeneficiaries();
        }
        $scope.current.animation = 'slide-right';
        $scope.current.wizardStep += 1;
    };

    $scope.jumpBackTo = function (index) {
        if ($scope.current.executing || ($scope.current.wizardStep === $scope.wizardSteps.length - 1)) return;

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };

    $scope.isStepIncomplete = function () {

        switch ($scope.current.wizardStep) {
            case 0:
                return !($scope.current.enableWizard && isValidClient());
            case 1:
                return !isValidRegistration();
            case 2:
                return !isValidAccount();
            case 3:
                return $scope.current.beneficiaryDobIsInvalid;
            default:
                return false;
        }
    };

    $scope.onDobChange = function () {
        switch ( $scope.current.wizardStep) {
            case 1:
                $scope.current.regDobIsInvalid = this.newRegistrationForm?.$invalid ?? false;
                break;
            case 3:
                $scope.current.beneficiaryDobIsInvalid = this.newAccountAddBeneficiaryForm?.$invalid ?? false;
                break;
        }
    }
    $scope.getNextAccountNumber = function () {
        $http.get('/Portfolio/AvailableAccountNumbers/Next', {trackerMsg: 'Looking up account number'})
            .then(function (response) {
                $scope.newAccount.account.billing.custodialAccountNumber = response.data.accountNumber;
            });
    };

    $scope.getValue = function (collection, id, prop) {
        var result = collection.find({id: id});
        return result ? result[prop] : 'None';
    };

    $scope.addAccount = function () {
        $scope.current.executing = true;

        $http.post('/Portfolio/Accounts/NewPortfolio', $scope.newAccount, {trackerMsg: 'Adding new account'})
            .then(function (response) {
                loadNewAccountAndForms(response.data);
            })
            .finally(function () {
                $scope.current.executing = false;
            });
    };

    $scope.noFormSelected = function () {
        return $scope.current.formsLibrary.none({selected: true});
    };

    $scope.launchLaserApp = function () {
        $scope.current.executing = true;

        $http.post('/Integrations/LaserApp/Accounts/' + $scope.newAccount.account.id + "/Submit", $scope.current.formsLibrary.findAll({selected: true}), {trackerMsg: 'Launching LaserApp'})
            .then(function (response) {
                $window.open(response.headers("location"));
            })
            .finally(function () {
                $scope.current.executing = false;
            });
    };

    $scope.setCycleMonths = function (frequency) {
        setCycleMonths(frequency);
    };

    $scope.setHouseholdName = function () {
        if (!$scope.current.existingClient) {
            var fullName = "";
            if ($scope.newAccount.client.portfolio.firstName && $scope.newAccount.client.portfolio.firstName.length > 0) {
                fullName = $scope.newAccount.client.portfolio.firstName;
            }
            if ($scope.newAccount.client.portfolio.lastName && $scope.newAccount.client.portfolio.lastName.length > 0) {
                if (fullName.length > 0) {
                    fullName += " ";
                }
                fullName += $scope.newAccount.client.portfolio.lastName;
            }
            if (fullName.length > 0) {
                $scope.newAccount.client.portfolio.name = fullName;
            }
        }
    };

    $scope.addBeneficiary = function () {
        $scope.newAccount.registration.beneficiaries.push({name: "", dob: "", ssn: "", relation: "", address: "", percentage: 0.0, type: "Primary"});
    };

    $scope.removeBeneficiary = function (beneficiary) {
        $scope.newAccount.registration.beneficiaries.remove(beneficiary);
    };

    $scope.updateBeneficiaryPercentageTotal = function () {
        $scope.current.beneficiaryTotalPercent = $scope.newAccount.registration.beneficiaries.findAll({type: "Primary"}).sum("percentage");
    };

    $scope.custodianChange = function (custodianId) {
        var selectedCustodian = $scope.current.custodianWithTrustType.find({id: custodianId});
        $scope.current.accountNumberAutoGenerate = selectedCustodian.trustType == custodianTypes.eas.name;
    };

    $scope.heldawayProviderChange = function(){
        if ($scope.current.selectedClient){
            $scope.newAccount.account.billing.byAllAccountId = null;
            $scope.newAccount.account.billing.plaidAccountId = null;
            $scope.newAccount.account.billing.akoyaAccountId = null;

            if ($scope.current.heldawayProvider==='plaid'){
                loadAvailablePlaidAccounts($scope.current.selectedClient.id);
            }  else if ($scope.current.heldawayProvider==='akoya'){
                loadAvailableAkoyaAccounts($scope.current.selectedClient.id);
            }
        }
    };

    // SCOPE WATCHERS
    $scope.$watch('current.existingClient', function (newValue, oldValue) {
        if (newValue === oldValue) return;
        existingClientFlagChanged(newValue, 0);
    });

    $scope.$watch('current.existingReg', function (newValue, oldValue) {
        if (newValue === oldValue) return;

        if (newValue === false) {
            $scope.current.selectedReg = null;
            $scope.newAccount.registration.id = 0;
            if (defaultUDFs.registration) {
                $scope.newAccount.registration.userDefinedFields = defaultUDFs.registration;
            }
            $scope.newAccount.registration.portfolio.ssN_TaxID = "";
            removeExtraProperties(true);
        } else if (registrationList) {
            setRegistrationList();
        }
    });

    $scope.$watch('current.selectedClient', function (newValue, oldValue) {
        if (newValue === oldValue) return;
        selectedClientChanged(newValue);
    });

    $scope.$watch('current.selectedRep', function (newValue, oldValue) {
        if (newValue === oldValue) return;
        if (newValue && newValue != '' && newValue.id) {
            $scope.newAccount.client.portfolio.representativeId = newValue.id;
        } else {
            $scope.newAccount.client.portfolio.representativeId = null;
        }
    });

    $scope.$watch('current.selectedReg', function (newValue, oldValue) {
        if (newValue === oldValue || !newValue) return;

        $http.get('/Portfolio/Registrations/Verbose/' + newValue + "?expand=portfolio,beneficiaries" + ($scope.rightsSuitability.canUpdate ? ",suitability" : "") + ($scope.current.showRegAddress ? ",contact" : ""), {trackerMsg: 'Loading selected registration'})
            .then(function (response) {
                $scope.newAccount.registration = response.data;

                if (!$scope.newAccount.registration.beneficiaries) {
                    $scope.newAccount.registration.beneficiaries = [{name: "", dob: "", ssn: "", relation: "", address: "", percentage: 0.0, type: "Primary"}];
                }

                $scope.updateBeneficiaryPercentageTotal();
            });
    });

    $scope.$watch('current.selectedModel', function (newValue, oldValue) {
        if (newValue === oldValue || !newValue) return;

        $scope.newAccount.account.modelingInfo = {aggregateModel: {id: newValue.id}};
    });

    $scope.$watch('current.selectAccountType', function (newValue, oldValue) {
        if (newValue === oldValue) return;

        if (!registrationList || !registrationList.length || !$scope.current.existingReg) {
            $scope.newAccount.registration.portfolio.typeId = newValue;
            return;
        }

        setRegistrationList();
    });

    ["firstName", "lastName", "name"].forEach(function (field) {
        $scope.$watch('newAccount.client.portfolio.' + field, function (newValue, oldValue) {
            if (newValue === oldValue) return;

            if (!$scope.newAccount.registration.portfolio[field] || $scope.newAccount.registration.portfolio[field].trim() === '' || oldValue === $scope.newAccount.registration.portfolio[field].trim()) {
                $scope.newAccount.registration.portfolio[field] = newValue;
            }
        });
    });

    function registerAddressWatches() {
        ["address1", "address2", "address3", "city", "state", "zip"].forEach(function (field) {
            $scope.$watch('newAccount.client.portfolio.' + field, function (newValue, oldValue) {
                if (newValue === oldValue) return;

                if (!$scope.newAccount.registration.contact[field] || $scope.newAccount.registration.contact[field].trim() === '' || oldValue === $scope.newAccount.registration.contact[field].trim()) {
                    $scope.newAccount.registration.contact[field] = newValue;
                }
            });
        });
    }

    $scope.$watch('newAccount.account.portfolio.custodianId', function (newValue, oldValue) {
        if (newValue === oldValue || !newValue) return;

        if (!$scope.current.custodians || !$scope.current.fundFamilies) return;
        var selectedCustodian = $scope.current.custodians.find({id: newValue});
        var exactResult = $scope.current.fundFamilies.find(function (n) {
            return n.name.trim() === selectedCustodian.name;
        });
        if (exactResult)
            $scope.newAccount.account.portfolio.fundFamilyId = exactResult.id;
        else {
            var containsResult = $scope.current.fundFamilies.find(function (n) {
                return n.name.trim().has(selectedCustodian.name);
            });
            if (containsResult)
                $scope.newAccount.account.portfolio.fundFamilyId = containsResult.id;
        }
    });

    $scope.$watch('current.selectedItems', function (newValue, oldValue) {
        if (newValue === oldValue) return;

        $scope.current.invalidImportRecord = newValue.find(function (n) {
            return !n.isValid;
        });
    });

    $scope.clearReportableFields = function(field){

        switch (field){
            case '13f':
                if(!$scope.newAccount.account.portfolio.is13FReportable) return;
                $scope.newAccount.account.portfolio.isAuaReportable = false;
            case 'adv':
                if(!$scope.newAccount.account.portfolio.isAdvReportable) return;
                $scope.newAccount.account.portfolio.isAuaReportable = false;
            case 'aua':
                if(!$scope.newAccount.account.portfolio.isAuaReportable) return;

                if($scope.newAccount.account.portfolio.isAdvReportable || $scope.newAccount.account.portfolio.is13FReportable ){
                    var buttons = [{result:'continue', label: 'Continue', cssClass: 'btn-primary'}, {result:'cancel', label: 'Cancel', cssClass: 'pull-left'}];
                    $dialog.messageBox("Warning", "By selecting this option, this account will not be counted toward your ADV and 13f totals.",buttons)
                        .open()
                        .then( function(result){
                            if(result =='cancel'){
                                $scope.newAccount.account.portfolio.isAuaReportable = false;
                                return;
                            } else {
                                $scope.newAccount.account.portfolio.isAdvReportable = false;
                                $scope.newAccount.account.portfolio.is13FReportable = false;
                            }
                        })
                }
                return;
        }

    };

    //INITIALIZE
    $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
    $scope.rightsBilling = $oasRights.forCode("ACCTBILLING");
    $scope.rightsSuitability = $oasRights.forCode("INVESTMENTOBJ");
    
    $scope.current = {
        enableImport: false,
        enableWizard: false,
        wizardStep: 0,
        animation: 'slide-right',
        executing: false,
        selectAccountType: 0,
        existingClient: false,
        existingReg: false,
        selectedItems: [],
        processedItems: [],
        isImportProcessed: false,
        accountNumberAutoGenerate: false,
        loadLaserApp: false,
        formsLibrary: [],
        regDobRequired: $scope.user.isBAM,
        regDobIsInvalid: false,
        beneficiaryDobIsInvalid: false,
        regSsnRequired: $scope.user.isBAM,
        availablePlaidAccounts: [],
        availableAkoyaAccounts: [],
        selectedRep: null
    };

    $scope.newAccount = {};

    $scope.wizardSteps = ["Household", "Registration", "Account/Billing", "Beneficiary", "Review Input", "Paperwork"];

    $scope.blockAccountNumberRights = $oasRights.forCode("NEWACCTBLOCKLIST");

    init();
}]);

'use strict';

var newAccountsExcludedListCtrl = app.controller('NewAccountsExcludedListCtrl', function NewAccountsExcludedListCtrl($scope, $http, $oasRights, $settings, $dialog, $routeParams, views, splitIoService) {

    //PRIVATE VARIABLES

    //PRIVATE METHODS
    function init() {
        $scope.rightsExclusion = $oasRights.forCode("DOWNLOADEXCLUSION");
        $scope.rightsConfirmationOverview = $oasRights.forCode("CONFIRMOVERVIEW");
        $scope.rightsRestoreAccounts = $oasRights.forCode("RESTOREACCOUNTS");

        if ($routeParams.accountNumberFilter && $routeParams.accountNumberFilter.length > 0) {
            var accountNumberFilter = $routeParams.accountNumberFilter.split(',');
            accountNumberFilter.forEach(function (x) {
                $scope.current.view.filters.push({ name: "Account Number = " + x, value: "(function (a) { return a === '" + x + "'; })", key: "accountNumber", include: true });
            });
            $scope.current.view.filterType = "Any";
        }

        setDates();
        getExcludeFeatureFlag();
    }

    function doAction(actionUrl, msgVerb, confirmMsg) {
        $dialog.confirmAction(confirmMsg)
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.put(actionUrl, $scope.selectedIds, { trackerMsg: msgVerb + ' excluded account(s))' })
                        .then(function () {
                            refreshGrid();
                        });
                }
            });
    }

    function refreshGrid() {
        setDates();
        $scope.$broadcast('event:new-accounts-excluded-action', { action: 'refresh-grid' });
    }

    function slickGridDoubleClick() {
        if ($scope.selectedIds.length === 1 && $scope.rightsConfirmationOverview.canUpdate) {
            $scope.openEditor(false);
        }
    }

    function setDates() {
        if ($scope.current.filterStartDate && $scope.current.filterEndDate) {
            $scope.current.startDate = $scope.current.filterStartDate.format('{MM}-{dd}-{yyyy}');
            $scope.current.endDate = $scope.current.filterEndDate.format('{MM}-{dd}-{yyyy}');
        }
    }

    function setInitialStartDate(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    function getExcludeFeatureFlag() {
        $http.get('/Settings/Database/EntityOptions/Code/69EXCLUDESEARCH', { trackerMsg: 'Loading NAC Search feature flag' })
            .then(function (response) {
                $scope.current.featureFlagNACSearch = response.data.value.toLocaleLowerCase() === "true";
                if ($scope.current.featureFlagNACSearch) {
                    $scope.current.featureFlagNACSearchSelected = true;
                }
            });
    }

    // PUBLIC METHODS
    $scope.$on('event:exclude-account-select', function (e, args) {
        selectedExcludeIds = args.map('id').unique();
        $scope.selectedExcludeAccountNumbers = args.map('accountNumber').unique();
    });

    $scope.removeAccountExclusion = function () {
        doAction('/Confirm/Exclusions/Action/Delete', 'Deleting', 'Deleting account exclusion.  Are you sure you want to proceed?');
    };

    $scope.editAdvisorNotes = function () {
        return $dialog.inputBox('Edit Advisor Notes', "Advisor Notes", "textarea")
            .open()
            .then(function (rslt) {
                if (rslt && rslt.trim().length > 0) {
                    $http.put(
                        '/Confirm/Exclusions/Action/AdvisorNotes',
                        { keyList: $scope.selectedIds, note: rslt },
                        { trackerMsg: 'Updating advisor notes' }
                    ).then(function (r) {
                        $scope.$broadcast('event:new-accounts-excluded-action', { action: 'refresh-grid' });//{action: 'update-items', items: r.data });
                    });
                }
            });
    };

    $scope.openAccountRestoreEditor = function () {
        $scope.restoreAccountsSelected = [];

        $scope.selectedExcludeAccountNumbers.forEach(acctNum => {
            $scope.restoreAccountsSelected.push({ accountNumber: acctNum, accountId: null });
        });
        $scope.showAccountRestoreModal = true;
    };

    $scope.openAccountRestoreEditorOld = function () {
        const dialogOpts = {
            templateUrl: 'portfolio/modals/account-restore.html',
            controller: 'AccountRestoreCtrl',
            accounts: $scope.selectedExcludeAccountNumbers,
            exclusionTable: true,
            dialogClass: "modal wide"
        };
        $dialog.dialog(dialogOpts)
            .open()
            .then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast('event:new-accounts-excluded-action', { action: 'refresh-grid' });
                }
            });
    };

    $scope.openEditor = function( isNew ) {
        if( ( $scope.rightsExclusion.canUpdate && !isNew ) || $scope.rightsExclusion.canAdd && isNew ) {
            $dialog.dialog({templateUrl: "new-accounts-excluded-edit.html", controller: "NewAccountsExcludedEditCtrl", id:  $scope.selectedIds[0], isNew: isNew})
                .open()
                .then(function (rslt) {
                    if (!rslt) return;
                    $scope.$broadcast('event:new-accounts-excluded-action', {action: isNew ? 'add-item' : 'update-item', item: rslt});
                });
        }
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:new-accounts-excluded-action', {action: 'export-data'});
    };

    $scope.refreshNewAccountsExclusionGrid = function( ) {
        refreshGrid( );
    };

    $scope.onAccountRestoreModalClose = function () {
        $scope.showAccountRestoreModal = false;
    };
    
    $scope.$watch('current.filterStartDate', function (newValue) {
        setDates();
    });

    $scope.$watch('current.filterEndDate', function (newValue) {
        setDates();
    });

    //INITIALIZE
    $scope.selectedIds = [];
    $scope.views = views;
    $scope.current = {
        view: views[0], 
        URL : '/Confirm/Exclusions/Current', 
        lastDownloadedDays:$routeParams.accountNumberFilter ? null : 200,  
        newAccountExcludeFilter: $routeParams.newAccountExcludeFilter, 
        filterStartDate:setInitialStartDate($settings.getSetting('confirmStartDate'), -60), 
        filterEndDate:$settings.getSetting('confirmEndDate'), 
        filterAccountNumber:null,
        filterCusip:null,
        featureFlagNACSearch:false,
        featureFlagNACSearchSelected: null,
        gridDoubleClick: slickGridDoubleClick,
    };
    var selectedExcludeIds = [];
    $scope.selectedExcludeAccountNumbers = [];
    $scope.showAccountRestoreModal = false;
    $scope.restoreAccountsSelected = [];

    init( );
});


app.controller('NewAccountsExcludedEditCtrl', function NewAccountsExcludedEditCtrl( $scope, $http, $oasRights, dialog ) {

    // PRIVATE METHODS
    function init( ) {
        $scope.current = {isNew: dialog.options.isNew};
        $scope.rightsExclusion = $oasRights.forCode( "DOWNLOADEXCLUSION" );
        $scope.rightsConfirmationOverview = $oasRights.forCode("CONFIRMOVERVIEW");

        $http.get('/Confirm/DownloadFormats/Simple', {trackerMsg:'Loading download formats'})
            .then(function(response){
                $scope.downloadFormats = response.data;
            });

        if( $scope.current.isNew ) {
            $scope.exclusion = {
                id: 0,
                downloadFormatId: null,
                accountNumber: null,
                cusip: null,
                notes: null
            };
        } else {
            $http.get('/Confirm/Exclusions/' + dialog.options.id, {trackerMsg:'Loading account exclusion'})
                .then(function(response){
                    $scope.exclusion = response.data;
                });
        }
    }

    // PUBLIC METHODS
    $scope.cancel = function( ) {
        dialog.close( null );
    };

    $scope.save = function( ) {
        if($scope.current.isNew) {
            $http.post("/Confirm/Exclusions/", $scope.exclusion, {trackerMsg: 'Adding new exclusion'})
                .then(function ( response ) {
                    dialog.close( response.data );
                });
        } else {
            $http.put("/Confirm/Exclusions/" + $scope.exclusion.id, $scope.exclusion, {trackerMsg: 'Updating exclusion'})
                .then(function ( response ) {
                    dialog.close( response.data );
                });
        }
    };

    // INITIALIZE
    init();

});





app.controller('AdditionalHouseholdCtrl', function AdditionalHouseholdCtrl($scope, $http, $dialog, $oasRights, args, dialog) {
    //PRIVATE VARIABLES
    var ssnEditReason;


    //PRIVATE METHODS
    function init() {
        $http.get('/Portfolio/HouseholdMemberTypes', {trackerMsg: 'Loading house types'})
            .then(function (response) {
                $scope.memberTypes = response.data;
            });
    }


    //PUBLIC METHODS
    $scope.viewSSNInfo = function (allowEdit) {
        if ($scope.member.ssN_TaxID && $scope.member.ssN_TaxID.has('X')) {
            $dialog.inputBox('Reason to View the SSN or Tax ID', "Reason", "textarea")
                .open()
                .then(function (result) {
                    if (!result) return;

                    $http.put('/Portfolio/Clients/' + args.clientId + '/HouseholdMembers/' + $scope.member.id + '/SSNTaxId', {ssN: null, reason: result}, {trackerMsg: 'Getting SSN/Tax ID information'})
                        .then(function (response) {
                            $scope.member.ssN_TaxID = response.data;
                            $scope.current.allowEditSSN = allowEdit;
                            if (allowEdit) {
                                $scope.member.ssnEditReason = result;
                            } else {
                                ssnEditReason = result;
                            }
                        });
                });
        } else if (allowEdit) {
            $scope.current.allowEditSSN = true;
            if (!$scope.member.ssnEditReason) {
                $scope.member.ssnEditReason = ssnEditReason || "Populate blank SSN";
            }
        }
    };

    $scope.addAlternateAddress = function () {
        $dialog.inputBox("New Address", "Description (i.e. Work)")
            .open()
            .then(function (result) {
                if (!result) return;

                $scope.member.additionalAddresses.push({id: 0, sendPeriodicStatements: false, type: result});
            });
    };

    $scope.deleteAlternateAddress = function (address) {
        $scope.member.additionalAddresses.remove(address);
    };

    $scope.update = function () {
        if ($scope.member?.invalidEmail) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Email is invalid", "Email for member is invalid.").open();
            return;
        }

        const invalidAddress = $scope.additionalAddresses?.some(x => x.invalidEmail);
        if (invalidAddress) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Email is invalid", "An email for address is invalid.").open();
            return;
        }

        dialog.close($scope.member);
    };

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.invalidMemberEmail = function (invalid) {
        $scope.member.invalidEmail = invalid;
    }

    $scope.setMemberEmail = function (value) {
        $scope.member.email = value;
    }

    $scope.invalidAddressEmail = function (address, invalid) {
        address.invalidEmail = invalid;
    }

    $scope.setAddressEmail = function (address,value) {
        address.email = value;
    }
    

    //INITIALIZE
    init();

    $scope.member = args.householdMember;
    $scope.isAdd = args.hashKey == 0;

    $scope.current = {
        allowEditSSN: false
    };

    $scope.rightsHH = $oasRights.forCode("CLIENTS");
    $scope.rightsSSNView = $oasRights.forCode("SSNVIEW");
    $scope.rightsSSNChange = $oasRights.forCode("SSNCHANGE");
});

'use strict';

app.controller('ChangeHistoryCtrl', function ChangeHistoryCtrl($scope, $http, $routeParams, $location, $timeout, $oasRights, chgHistData, dialog, $dialog) {

    // PRIVATE VARIABLES
    //var accountID = $routeParams.accountId;
    // region PRIVATE METHODS
    function loadChange(){
        if (!$scope.current.isMassUpdate){
            loadCurrentValues();
        }

        loadFeeSchedules();
        loadBillPayMethods();
        loadPayoutSchedules();
        loadSharedClasses();
        loadManagedUnmanaged();
        if($scope.current.benchmarksInAccountHistory){
            loadBlendedIndexes();
        }
    }

    function loadCurrentValues(){
        $http.get('/Portfolio/Accounts/' + $scope.current.accountID + '/Changes/New', {trackerMsg: 'Loading current values'})
            .then(function(response) {
                $scope.chst = response.data;
                $scope.changeValues.changeDate =  Date.create($scope.chst.changeDate);
                $scope.changeValues.useFirstTransactionDate = $scope.chst.original.inceptionDate.useFirstTransactionDate;
                if (!$scope.changeValues.useFirstTransactionDate){
                    $scope.changeValues.inceptionDate = Date.create($scope.chst.original.inceptionDate.customDate);
                }
                $scope.chst.original.compositeExclusions = 0;
            });
    }

    function loadFeeSchedules() {
        $http.get('/Billing/Schedules/Simple?schedule=fee', {cache: true, trackerMsg: 'Loading fee schedules'})
            .then(function(response) {
                $scope.feeSchedules = response.data.sortBy("name");
                if ( response.data.length > $scope.maxItemInList){
                    $scope.changeValues.feeSchedule = '';
                    return;
                }
                $scope.feeSchedules.insert($scope.changeValues.feeSchedule, 0);
            });
    }

    function loadBillPayMethods() {
        $http.get('/Billing/PayMethods', {cache: true, trackerMsg: 'Loading bill payment methods'})
            .then(function(response) {
                $scope.payMethods = response.data.sortBy("name");
                $scope.payMethods.insert($scope.changeValues.billPayMethod, 0);
            });
    }

    function loadPayoutSchedules() {
        getPayoutSchedulesRecursive(0,$scope.maxItemInList+1);
    }

    function loadManagedUnmanaged(){
        $scope.managedUnmanaged = [{id : 0, name: 'False'}, {id : 1, name: 'True'}];
        $scope.managedUnmanaged.insert($scope.changeValues.managedUnmanaged, 0);
    }

    function getPayoutSchedulesRecursive(skip, take){
        $http.get('/Billing/MasterPayoutSchedule/Simple?$skip=' + skip + '&$top=' + take, {cache: true, trackerMsg: 'Loading payout schedules'})
                .then(function(response) {
                    var data = response.data;
                    $scope.payoutSchedules = data.sortBy("name");

                    if (data.length > 0) {
                        if (data.length === take){
                            //throw away results and grab all of payouts at once
                            $http.get('/Billing/MasterPayoutSchedule/Simple', {cache: true, trackerMsg: 'Loading payout schedules'})
                            .then(function(response){
                                $scope.payoutSchedules = response.data.sortBy("name");
                            });
                        }
                    }

                    $scope.payoutSchedules.insert($scope.changeValues.payoutSchedule, 0);

                    if ( $scope.payoutSchedules.length > $scope.maxItemInList+1){
                        $scope.changeValues.payoutSchedule = '';
                        const index = $scope.payoutSchedules.indexOf( p => p.id === -2);
                        $scope.payoutSchedules.splice(1,index);
                    }

                });

    }

    function loadSharedClasses() {
        $http.get('/Portfolio/ShareClasses/Simple', {cache: true, trackerMsg: 'Loading share classes'})
            .then(function(response) {
                $scope.shareClasses = response.data;
                if ( response.data.length > $scope.maxItemInList){
                    $scope.changeValues.shareClass='';
                    return;
                }
                $scope.shareClasses.insert($scope.changeValues.shareClass, 0);
            });
    }

    function loadBlendedIndexes(){
        $http.get('/Portfolio/Benchmarks?bmtype=b', {cache:true, trackerMsg:''})
            .then(function(response){
                $scope.blends = response.data;
                $scope.blends.insert($scope.changeValues.blendedIndex, 0);
            });
    }

    function processChange() {

        if (chgHistData.asOfDate && !angular.equals(chgHistData.asOfDate, $scope.changeValues.changeDate)) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Change History", "There are already change history requests with a different change date. Please save these before continuing.").open();
            return false;
        }

        if (!$scope.current.isMassUpdate) {
            if ($scope.changeValues.useFirstTransactionDate && !angular.equals($scope.chst.original.inceptionDate.useFirstTransactionDate, $scope.changeValues.useFirstTransactionDate)) {
                addToChsts("Inception Date", Date.create($scope.chst.original.inceptionDate.customDate).formatted(), "First Transaction Date", 0);
            }

            if (!$scope.changeValues.useFirstTransactionDate && !angular.equals(Date.create($scope.chst.original.inceptionDate.customDate), Date.create($scope.changeValues.inceptionDate))) {
                addToChsts("Inception Date", $scope.chst.original.inceptionDate.useFirstTransactionDate ? "First Transaction Date" : Date.create($scope.chst.original.inceptionDate.customDate).formatted(), $scope.changeValues.inceptionDate.formatted(), 0);
            }

        }

        if ($scope.changeValues.mgmtStyle.id && $scope.changeValues.mgmtStyle.id !== -2) {
            addToChsts("Management Style", (!$scope.current.isMassUpdate ? ($scope.chst.original.managementStyle ? $scope.chst.original.managementStyle.name : "") : ""), $scope.changeValues.mgmtStyle.name, $scope.changeValues.mgmtStyle.id);
        }
        if ($scope.changeValues.subAdvisorsUnassigned || ($scope.changeValues.subAdvisor.id && $scope.changeValues.subAdvisor.id !== -2)) {
            const subAdvisor = $scope.changeValues.subAdvisorsUnassigned ? { id : 0, name: '(none)'} : $scope.changeValues.subAdvisor;
            addToChsts("Sub-Advisor", (!$scope.current.isMassUpdate ? ($scope.chst.original.subAdvisor ? $scope.chst.original.subAdvisor.name : "") : ""), subAdvisor.name, subAdvisor.id);
        }
        if ($scope.changeValues.feeSchedule.id && $scope.changeValues.feeSchedule.id !== -2) {
            addToChsts("Fee Schedule", (!$scope.current.isMassUpdate ? ($scope.chst.original.feeSchedule ? $scope.chst.original.feeSchedule.name : "") : ""), $scope.changeValues.feeSchedule.name, $scope.changeValues.feeSchedule.id);
        }
        if ($scope.changeValues.payoutSchedule.id && $scope.changeValues.payoutSchedule.id !== -2) {
            addToChsts("Payout Schedule", (!$scope.current.isMassUpdate ? ($scope.chst.original.payoutSchedule ? $scope.chst.original.payoutSchedule.name : "") : ""), $scope.changeValues.payoutSchedule.name, $scope.changeValues.payoutSchedule.id);
        }
        if ($scope.changeValues.shareClass.id && $scope.changeValues.shareClass.id !== -2) {
            addToChsts("Share Class", (!$scope.current.isMassUpdate ? ($scope.chst.original.shareClass ? $scope.chst.original.shareClass.name : "") : ""), $scope.changeValues.shareClass.name, $scope.changeValues.shareClass.id);
        }
        if ($scope.changeValues.modelAggUnassigned ||($scope.changeValues.modelAgg.id && $scope.changeValues.modelAgg.id !== -2)){
            const modelAgg = $scope.changeValues.modelAggUnassigned ? { id : 0, name: '(none)'} : $scope.changeValues.modelAgg;
            addToChsts("Model", (!$scope.current.isMassUpdate ? ($scope.chst.original.modelAggregate ? $scope.chst.original.modelAggregate.name : "") : ""), modelAgg.name, modelAgg.id);
        }
        if ($scope.changeValues.blendedIndex.id !== -2) {
            addToChsts("Index Blend", (!$scope.current.isMassUpdate ? ($scope.chst.original.indexBlend ? $scope.chst.original.indexBlend.name : "") : ""), $scope.changeValues.blendedIndex.name, $scope.changeValues.blendedIndex.id);
        }
        if ($scope.changeValues.compositeExclusions) {
            addToChsts("Composite Exclusions", (!$scope.current.isMassUpdate ? $scope.chst.original.compositeExclusions : 0), $scope.changeValues.compositeExclusions, 0);
        }
        if ($scope.changeValues.managedUnmanaged.id !== -2) {
            addToChsts("Managed", (!$scope.current.isMassUpdate ? ($scope.chst.original.managedUnmanaged ? $scope.chst.original.managedUnmanaged.name : "") : ""), $scope.changeValues.managedUnmanaged.name, $scope.changeValues.managedUnmanaged.id);
        }
        if ($scope.changeValues.billPayMethod.id !== -2) {
            addToChsts("Bill Pay Method", (!$scope.current.isMassUpdate ? ($scope.chst.original.billPayMethod ? $scope.chst.original.billPayMethod.name : "") : ""), $scope.changeValues.billPayMethod.name, $scope.changeValues.billPayMethod.id);
        }
        if ($scope.changeValues.plan401K.id && $scope.changeValues.plan401K.id !== -2) {
            addToChsts("Qualified Plan", (!$scope.current.isMassUpdate ? ($scope.chst.original.plan401K ? $scope.chst.original.plan401K.name : "") : ""), $scope.changeValues.plan401K.name, $scope.changeValues.plan401K.id);
        }

        return true;
    }


    function addToChsts(entityName, oldEntityName, newEntityName, newEntityId){
        var chstTemp = {
            id: 0,
            asOfDate : $scope.changeValues.changeDate,
            entity: entityName,
            oldEntityName: oldEntityName,
            newEntityName: newEntityName,
            newEntityId: newEntityId,
            isUncommitted: true
        };

        $scope.chsts.insert(chstTemp, 0);

    }

    function unAssignBenchmarkForEntity(){
        var entity = Object.find($scope.current.includeBenchmark, function(key, value) {
            return value.value === true;
        });
        if(entity){
            $scope.current.includeBenchmark[entity].value = false;
            $scope.changeValues.blendedIndex =  $scope.blends.find({id: -2});
        }
    }


    function init(){
        $http.get('/Settings/Database/EntityOptions/Code/2:69BENCHM', {trackerMsg: 'Loading and verifying entity options'} )
            .then(function(response){
                if(response.data.value.toLowerCase() === "true"){
                    $scope.current.benchmarksInAccountHistory = true;
                    loadBlendedIndexes();
                }
            });

    }
    //endregion



    //region PUBLIC METHODS

    $scope.setBenchmarkForEntity = function(){
        $timeout(function () {
            var entity = Object.find($scope.current.includeBenchmark, function(key, value) {
                return value.value === true;
            });
            if(entity && entity !== 'benchmark' ){
                if(entity === 'modelAgg'){
                    $http.get('/Trading/ModelAggs/' + $scope.changeValues.modelAgg.id +'/assignedbenchmarks', {trackerMsg:'Setting benchmark'})
                        .then(function(response){
                            var bIndexes = response.data.findAll({type: 'B'});
                            if(bIndexes.length > 1){
                                $dialog.inputBox('Multiple Index Blends for ' +  $scope.changeValues.modelAgg.name, 'Choose Index Blend',bIndexes )
                                    .open()
                                    .then(function(result){
                                        if(result){
                                            $scope.changeValues.blendedIndex =  $scope.blends.find({key: result.key});
                                        }else{
                                            $scope.current.includeBenchmark[entity].value = false;
                                        }
                                    });
                            }else{
                                $scope.changeValues.blendedIndex =  $scope.blends.find({key: bIndexes[0].key});

                            }
                        });
                }else{
                    $http.get('/Settings/EntityOptions/' + $scope.current.includeBenchmark[entity].name + '/code/1:69BENCHM', {trackerMsg:'Setting benchmark'})
                        .then(function(response){
                            $scope.changeValues.blendedIndex =  $scope.blends.find({key: response.data.find({entityId: $scope.changeValues[entity].id}).value });
                            if(!$scope.changeValues.blendedIndex){
                                //Message and then reset
                                $dialog.messageBox("Assignment Unsuccessful", "There were no index blends found for this " + $scope.current.includeBenchmark[entity].name).open();
                                $scope.current.includeBenchmark[entity].value = false;
                                $scope.changeValues.blendedIndex =  $scope.blends.find({id: -2});
                            }
                        });
                }
            }
        });
};


    $scope.saveChst = function( form ) {
        if (!form.$valid) return;

        var method = 'POST';
        var url = '/Portfolio/Accounts/' + $scope.current.accountID + '/Changes/New';

        $scope.chst.changeDate = $scope.changeValues.changeDate.formatted();

        if ($scope.changeValues.useFirstTransactionDate && $scope.chst.original.inceptionDate.useFirstTransactionDate != $scope.changeValues.useFirstTransactionDate){
            $scope.chst.changes.inceptionDate = { useFirstTransactionDate: $scope.changeValues.useFirstTransactionDate, customDate: null};
        }

        if ((!$scope.changeValues.useFirstTransactionDate && Date.create($scope.chst.original.inceptionDate.customDate).formatted != $scope.changeValues.inceptionDate.formatted()) ){
            $scope.chst.changes.inceptionDate = { useFirstTransactionDate: $scope.changeValues.useFirstTransactionDate, customDate: $scope.changeValues.inceptionDate.formatted()};
        }

        if ($scope.changeValues.mgmtStyle.id !== -2){
            $scope.chst.changes.managementStyle = { id: $scope.changeValues.mgmtStyle.id, name: ''};
        }
        if ($scope.changeValues.subAdvisor.id !== -2){
            if ($scope.changeValues.subAdvisor.id === 0){
                $scope.chst.changes.subAdvisor = null;
            }
            else{
                $scope.chst.changes.subAdvisor = { id: $scope.changeValues.subAdvisor.id, name: ''};
            }
        }
        if ($scope.changeValues.feeSchedule.id !== -2){
            $scope.chst.changes.feeSchedule = { id: $scope.changeValues.feeSchedule.id, name: ''};
        }
        if ($scope.changeValues.payoutSchedule.id !== -2){
            $scope.chst.changes.payoutSchedule = { id: $scope.changeValues.payoutSchedule.id, name: ''};
        }
        if ($scope.changeValues.billPayMethod.id !== -2){
            $scope.chst.changes.billPayMethod = { description: $scope.changeValues.billPayMethod.id, name: ''};
        }
        if ($scope.changeValues.shareClass.id !== -2){
            $scope.chst.changes.shareClass = { id: $scope.changeValues.shareClass.id, name: ''};
        }
        if ($scope.changeValues.modelAgg.id !== -2){
            if ($scope.changeValues.modelAgg.id === 0){
                $scope.chst.changes.modelAggregate = null;
            }
            else{
                $scope.chst.changes.modelAggregate = { id: $scope.changeValues.modelAgg.id, name: ''};
            }
        }
        if ($scope.changeValues.managedUnmanaged.id !== -2){
            $scope.chst.changes.managedUnmanaged = { id: $scope.changeValues.managedUnmanaged.id, name: ''};
        }

        if ($scope.changeValues.plan401K.id !== -2){
            $scope.chst.changes.plan401K = { id: $scope.changeValues.plan401K.id, name: ''};
        }

        $http( { method: method, url: url, data: $scope.chst, trackerMsg: "Saving change" } )
            .then(function() {
                $location.url( '/portfolio/accounts/' + $scope.current.accountID + '/changehistory');
            });
    };

    $scope.close = function(isCancel) {
        if (isCancel)
            dialog.close(null);
        else{
            if (processChange()){
                dialog.close($scope.chsts);
            }

        }
    };

    $scope.formatter = function(item){
        return !item ? '' : (angular.isNumber(item.id) ? item.id : item.id.first(8)) + ': ' + item.name;
    };

    $scope.filterSearch = function( list, searchText){
        const filteredList =  list.filter( p => p.name && p.name.toLowerCase().indexOf( searchText.toLowerCase()) >= 0 || p.id.toString().indexOf(searchText) >=0);
        return filteredList.slice(0, $scope.maxItemInList);
    };

    $scope.onModelUnassigned = function(){
        if (this.changeValues.modelAggUnassigned){
            this.changeValues.modelAgg = '';
        }
    }

    $scope.onSubAdvisorsUnassigned = function() {
        if (this.changeValues.subAdvisorsUnassigned) {
            this.changeValues.subAdvisor = '';
        }
    }

    //endregion

    // INITIALIZE
    $scope.rights = $oasRights.forCode("ACCOUNTCHANGE");
    $scope.rightsModel = $oasRights.forCode("MODELACCT");
    $scope.rightsComposite = $oasRights.forCode("COMPOSITEACCOUNT");

    $scope.current = {
        benchmarksInAccountHistory: false,
        includeBenchmark: {
            mgmtStyle: {name: 'Management Style', value: false},
            modelAgg: {name: 'ModelAgg', value: false}
        },
        isModal: (dialog ? true : false),
        isMassUpdate: (dialog && chgHistData.accountIds.length > 1 ? true  : false ),
        accountID: (dialog ? chgHistData.accountIds[0] : $routeParams.accountId)
    };
    $scope.chsts = [];

    $scope.changeValues = {
        changeDate: Date.create('today'),
        useFirstTransactionDate: true,
        inceptionDate: Date.create('today'),
        mgmtStyle: '',
        subAdvisor: '',
        feeSchedule:{id : -2, name: 'No Change'},
        payoutSchedule: {id : -2, name: 'No Change'},
        shareClass:{id : -2, name: 'No Change'},
        modelAgg: '',
        blendedIndex:{id : -2, name: 'No Change'},
        managedUnmanaged: {id : -2, name: 'No Change'},
        billPayMethod:{id : -2, name: 'No Change'},
        plan401K: '',
        modelAggUnassigned: false,
        subAdvisorsUnassigned : false
    };
    $scope.maxItemInList = 100;
    init();
    loadChange( );

    //SCOPE WATCHERS
    $scope.$watch('changeValues.mgmtStyle', function (newVal, oldVal) {
        if (newVal === oldVal){
            return;
        }
        if(!newVal || newVal === ''){
            unAssignBenchmarkForEntity();
        }
    });

    $scope.$watch('changeValues.modelAgg', function (newVal, oldVal) {
        if (newVal === oldVal){
            return;
        }
        if(!newVal || newVal === ''){
            unAssignBenchmarkForEntity();
        }
    });

});

'use strict';

/**
 * Portfolio list OData profiles (client / registration / account).
 * Generic parsing and sidebar sync live in slickGridODataSidebarSync.js.
 */
(function (global) {
    var slick = global.slickGridODataSidebarSync;

    /** Hash-route navigation keys — mapped to API params in list controllers (finishInit), not sent to Grid. */
    var NAV_ROUTE_ONLY_KEYS = {
        entity: true,
        entityId: true,
        entityEnum: true,
        openEditor: true,
        source: true
    };

    /**
     * DTO property names that do not map via capitalize-first-char (acronyms, TaxID, etc.).
     * Merged into every portfolio list profile odataPropertyNames.
     */
    var SHARED_ODATA_PROPERTY_NAMES = {
        ssn_taxid: 'SSN_TaxID',
        deceasedssn_taxid: 'DeceasedSSN_TaxID',
        taxtype: 'TaxType',
        sleevetype: 'SleeveType',
        billfrequency: 'BillFrequency',
        videostatementdeliverymethod: 'VideoStatementDeliveryMethod',
        isrtqlocked: 'isRTQLocked',
        globalid: 'GlobalId',
        clientglobalid: 'ClientGlobalId',
        registrationglobalid: 'RegistrationGlobalId',
        dob: 'strDOB'
    };

    /** DTO fields that are not EF-projectable for OData $orderby (lowercase OData property keys). */
    var SHARED_ODATA_NON_SORTABLE_PROPERTIES = {
        isdatasharingentity: true,
        missinginformation: true,
        bondpercent: true
    };

    /**
     * Keys bound on slick-grid `parameters` in each list template — omit from gridParams.
     * scopeSearchBindings: query param name → $scope.current property for deep-link filters.
     */
    var PROFILES = {
        client: {
            id: 'client',
            gridListUrl: '/Portfolio/Clients/Grid',
            odataCountUrl: '/Portfolio/Clients/Count',
            odataPageSize: 100000,
            reloadEvent: 'event:portfoliolist-household-action',
            gridExportKey: 'portfolio.clients',
            gridExportDownloadName: 'Households',
            gridExportSheetName: 'Households',
            // Filter by file (OC-42239): server-side only, so offered only while the grid is SSRM.
            fileFilter: { entity: 'Client', headerText: 'Households' },
            odataPropertyNames: {
                id: 'Id',
                name: 'Name',
                lastname: 'LastName',
                firstname: 'FirstName',
                aum: 'AUM',
                value: 'AUM',
                isactive: 'IsActive',
                isdatasharingentity: 'IsDataSharingEntity',
                representativename: 'RepresentativeName',
                representativeid: 'RepresentativeId',
                categoryid: 'CategoryId',
                brokerdealername: 'BrokerDealerName',
                cashbalance: 'CashBalance',
                createddate: 'CreatedDate'
            },
            routeOnlyKeys: { info: true, filterLabel: true },
            templateParamKeys: {
                isActive: true,
                householdFilter: true,
                pageQueryId: true,
                representativeId: true,
                returnStyle: true,
                registrationId: true,
                accountId: true,
                refreshCache: true,
                entitySessionId: true
            },
            propertyAliases: { aum: 'aum', value: 'aum' },
            propertyDisplayLabels: { name: 'Full Name' },
            scopeSearchBindings: {
                representativeId: 'repId',
                accountId: 'accountId',
                pageQueryId: 'pageQueryId',
                entitySessionId: 'entitySessionId'
            }
        },
        registration: {
            id: 'registration',
            gridListUrl: '/Portfolio/Registrations/Grid',
            odataCountUrl: '/Portfolio/Registrations/Count',
            reloadEvent: 'event:portfoliolist-registration-action',
            gridExportKey: 'portfolio.registrations',
            gridExportDownloadName: 'Registrations',
            gridExportSheetName: 'Registrations',
            // Filter by file (OC-42239): server-side only, so offered only while the grid is SSRM.
            fileFilter: { entity: 'Registration', headerText: 'Registrations' },
            odataNonSortableProperties: {
                currentvalue: true
            },
            odataPropertyNames: {
                id: 'Id',
                name: 'Name',
                lastname: 'LastName',
                accounttype: 'AccountType',
                currentvalue: 'CurrentValue',
                isactive: 'IsActive',
                clientid: 'ClientId',
                typeid: 'TypeId',
                representativename: 'RepresentativeName',
                representativeid: 'RepresentativeId',
                isdatasharingentity: 'IsDataSharingEntity'
            },
            routeOnlyKeys: { info: true, filterLabel: true },
            templateParamKeys: {
                isActive: true,
                registrationFilter: true,
                pageQueryId: true,
                representativeId: true,
                accountId: true,
                investmentObjective: true,
                refreshCache: true,
                entitySessionId: true
            },
            propertyAliases: {},
            scopeSearchBindings: {
                representativeId: 'repId',
                accountId: 'accountId',
                pageQueryId: 'pageQueryId',
                entitySessionId: 'entitySessionId',
                investmentObjective: 'investmentObjective'
            }
        },
        account: {
            id: 'account',
            gridListUrl: '/Portfolio/Accounts/Grid',
            odataCountUrl: '/Portfolio/Accounts/Count',
            reloadEvent: 'event:portfoliolist-account-action',
            gridExportKey: 'portfolio.accounts',
            gridExportDownloadName: 'Accounts',
            gridExportSheetName: 'Accounts',
            // Filter by file (OC-41861): server-side only, so offered only while the grid is SSRM.
            fileFilter: { entity: 'Account', headerText: 'Accounts' },
            odataPropertyNames: {
                id: 'Id',
                name: 'Name',
                number: 'Number',
                accounttype: 'AccountType',
                currentvalue: 'CurrentValue',
                isactive: 'IsActive',
                ismanaged: 'IsManaged',
                custodian: 'Custodian',
                custodianid: 'CustodianId',
                registrationid: 'RegistrationId',
                clientid: 'ClientId',
                fundfamily: 'FundFamily',
                managementstyle: 'ManagementStyle',
                isdatasharingentity: 'IsDataSharingEntity'
            },
            routeOnlyKeys: { info: true, filterLabel: true },
            // Do not put representativeId/clientId/registrationId/accountId here: AccountListCtrl
            // carries those only on gridParams for deep links. Seeding them in templateParamKeys as
            // '' made buildLegacyPortfolioGridParams skip the gridParams copy (OC-42354).
            templateParamKeys: {
                isActive: true,
                accountFilter: true,
                pageQueryId: true,
                returnStyle: true,
                refreshCache: true,
                entitySessionId: true
            },
            // Mirrors AccountsGridScope int[] fields / [FromUri] int[] on Accounts Grid (OC-42354).
            arrayScopeKeys: {
                representativeId: true,
                clientId: true,
                registrationId: true,
                accountId: true
            },
            propertyAliases: {},
            scopeSearchBindings: {
                pageQueryId: 'pageQueryId',
                returnStyle: 'returnStyle',
                entitySessionId: 'entitySessionId'
            }
        }
    };

    Object.each(PROFILES, function (_key, profile) {
        profile.odataPropertyNames = angular.extend({}, SHARED_ODATA_PROPERTY_NAMES, profile.odataPropertyNames || {});
        profile.odataNonSortableProperties = angular.extend({}, SHARED_ODATA_NON_SORTABLE_PROPERTIES, profile.odataNonSortableProperties || {});
        profile.routeOnlyKeys = angular.extend({}, NAV_ROUTE_ONLY_KEYS, profile.routeOnlyKeys || {});
    });

    /** Matches app/services/enums.js entities.*.value */
    var ENTITY_VALUE = {
        representative: '4',
        client: '5',
        registration: '6',
        account: '7'
    };

    /**
     * Same-level entity deep links (entity=7 on account list, etc.) use GET-by-id and ignore Show Active.
     * Cross-entity routes still normalize to Grid + OData filter for Count/Export.
     */
    function isPortfolioSsrmEnabled(scope) {
        return slick && slick.isRecordColumnLimitFeatureEnabled
            && slick.isRecordColumnLimitFeatureEnabled(scope);
    }

    function isSameLevelEntityRouteGetById(profileKey, routeEntity, routeEntityId, scope) {
        if (!isPortfolioSsrmEnabled(scope)) {
            return false;
        }

        var profile = resolveProfile(profileKey);
        if (!profile) {
            return false;
        }

        var routeScope = resolveEntityRouteScope(routeEntity, routeEntityId, scope, profile);
        if (!routeScope || routeScope.clientScope) {
            return false;
        }

        if (profile.id === 'account' && routeScope.entity === ENTITY_VALUE.account) {
            return true;
        }
        if (profile.id === 'registration' && routeScope.entity === ENTITY_VALUE.registration) {
            return true;
        }
        if (profile.id === 'client' && routeScope.entity === ENTITY_VALUE.client) {
            return true;
        }

        return false;
    }

    function applyEntityRouteODataListScope(scope, profile, options) {
        options = options || {};
        scope.current.url = profile.gridListUrl;
        delete scope.current.entityRouteGetById;

        if (options.odataFilter) {
            scope.current.routeScopeODataFilter = options.odataFilter;
            scope.current.gridParams = slick.upsertGridParam(scope.current.gridParams, '$filter', options.odataFilter);
            if (!scope.current.odataFilter) {
                scope.current.odataFilter = options.odataFilter;
            }
        }

        if (options.gridParams) {
            Object.each(options.gridParams, function (key, value) {
                if (value !== undefined && value !== null && value !== '') {
                    scope.current.gridParams = slick.upsertGridParam(scope.current.gridParams, key, value);
                }
            });
        }
    }

    function applyEntityRouteGetByIdMode(scope, profileKey, routeEntity, routeEntityId) {
        if (!isSameLevelEntityRouteGetById(profileKey, routeEntity, routeEntityId, scope)) {
            if (scope && scope.current) {
                delete scope.current.entityRouteGetById;
            }
            return false;
        }

        var profile = resolveProfile(profileKey);
        var routeScope = resolveEntityRouteScope(routeEntity, routeEntityId, scope, profile);
        if (profile && routeScope) {
            if (profile.id === 'client') {
                scope.current.url = '/Portfolio/Clients/' + routeScope.entityId;
            } else if (profile.id === 'registration') {
                scope.current.url = '/Portfolio/Registrations/' + routeScope.entityId;
            } else if (profile.id === 'account') {
                scope.current.url = '/Portfolio/Accounts/' + routeScope.entityId;
            }
        }

        scope.current.entityRouteGetById = true;
        scope.current.useOData = false;
        scope.current.useServerSideRowModel = false;
        delete scope.current.odataFilter;
        delete scope.current.routeScopeODataFilter;
        return true;
    }

    /**
     * Cross-entity deep links map to OData Grid/Count/Export with a scoped filter.
     * Same-level routes keep GET-by-id (see isSameLevelEntityRouteGetById).
     */
    function normalizeEntityRouteScopeForODataList(scope, profileKey, routeEntity, routeEntityId) {
        if (!isPortfolioSsrmEnabled(scope)) {
            return false;
        }

        if (applyEntityRouteGetByIdMode(scope, profileKey, routeEntity, routeEntityId)) {
            return false;
        }

        var profile = resolveProfile(profileKey);
        if (!profile || !slick) {
            return false;
        }

        var routeScope = resolveEntityRouteScope(routeEntity, routeEntityId, scope, profile);
        if (!routeScope) {
            return false;
        }

        var entity = routeScope.entity;
        var entityId = routeScope.entityId;
        var changed = false;

        if (profile.id === 'registration' && (entity === ENTITY_VALUE.client || routeScope.clientScope)) {
            applyEntityRouteODataListScope(scope, profile, {
                odataFilter: 'ClientId eq ' + entityId
            });
            changed = true;
        } else if (profile.id === 'registration' && entity === ENTITY_VALUE.account) {
            scope.current.accountId = entityId;
            applyEntityRouteODataListScope(scope, profile, {
                gridParams: { accountId: entityId }
            });
            changed = true;
        } else if (profile.id === 'account' && entity === ENTITY_VALUE.client) {
            applyEntityRouteODataListScope(scope, profile, {
                odataFilter: 'ClientId eq ' + entityId,
                gridParams: { clientId: entityId }
            });
            changed = true;
        } else if (profile.id === 'account' && entity === ENTITY_VALUE.registration) {
            applyEntityRouteODataListScope(scope, profile, {
                odataFilter: 'RegistrationId eq ' + entityId,
                gridParams: { registrationId: entityId }
            });
            changed = true;
        } else if (profile.id === 'account' && entity === ENTITY_VALUE.representative) {
            // Firm Profile → Rep → Accounts deep link (?entity=4&entityId=…). Same as AccountListCtrl
            // gridParams append; keep SSRM export scope aligned (OC-42354).
            applyEntityRouteODataListScope(scope, profile, {
                gridParams: { representativeId: entityId }
            });
            changed = true;
        } else if (profile.id === 'client' && entity === ENTITY_VALUE.registration) {
            scope.current.registrationId = entityId;
            applyEntityRouteODataListScope(scope, profile, {
                gridParams: { registrationId: entityId }
            });
            changed = true;
        } else if (profile.id === 'client' && entity === ENTITY_VALUE.account) {
            scope.current.accountId = entityId;
            applyEntityRouteODataListScope(scope, profile, {
                gridParams: { accountId: entityId }
            });
            changed = true;
        }

        if (!changed) {
            delete scope.current.entityRouteGetById;
        }
        return changed;
    }

    function resolveEntityRouteScope(routeEntity, routeEntityId, scope, profile) {
        if (routeEntity && routeEntityId) {
            return { entity: String(routeEntity), entityId: String(routeEntityId) };
        }

        var url = scope && scope.current ? scope.current.url : '';
        if (!url || !profile) {
            return null;
        }

        if (profile.id === 'account') {
            var accountMatch = url.match(/^\/Portfolio\/Accounts\/(\d+)$/);
            if (accountMatch) {
                return { entity: ENTITY_VALUE.account, entityId: accountMatch[1] };
            }
        }

        if (profile.id === 'registration') {
            var registrationMatch = url.match(/^\/Portfolio\/Registrations\/(\d+)$/);
            if (registrationMatch) {
                return { entity: ENTITY_VALUE.registration, entityId: registrationMatch[1] };
            }
            var clientRegistrationsMatch = url.match(/^\/Portfolio\/Clients\/(\d+)\/Registrations$/);
            if (clientRegistrationsMatch) {
                return { entity: ENTITY_VALUE.client, entityId: clientRegistrationsMatch[1], clientScope: true };
            }
        }

        if (profile.id === 'client') {
            var clientMatch = url.match(/^\/Portfolio\/Clients\/(\d+)$/);
            if (clientMatch) {
                return { entity: ENTITY_VALUE.client, entityId: clientMatch[1] };
            }
        }

        return null;
    }

    function resolveProfile(profileKey) {
        if (!profileKey) {
            return null;
        }
        if (typeof profileKey === 'object') {
            return profileKey;
        }
        return PROFILES[profileKey] || null;
    }

    function applyODataSortFromView(scope, profileKey, search, options) {
        if (!isPortfolioSsrmEnabled(scope)) {
            return null;
        }
        if (!slick) {
            return null;
        }
        var profile = resolveProfile(profileKey);
        if (!profile) {
            return null;
        }
        return slick.applyODataSortFromView(scope, profile, search, options);
    }

    function ensurePortfolioListQueryParams(scope, profileKey) {
        if (!isPortfolioSsrmEnabled(scope)) {
            return;
        }
        if (!slick) {
            return;
        }
        var profile = resolveProfile(profileKey);
        if (!profile) {
            return;
        }
        slick.ensurePortfolioListQueryParams(scope, profile);
    }

    function applyODataRouteFilters(scope, location, profileKey, activeState) {
        if (!slick) {
            return false;
        }
        var profile = resolveProfile(profileKey);
        if (!profile) {
            return false;
        }
        return slick.applyODataRouteFilters(scope, location, profile, activeState);
    }

    function applySidebarFiltersToGrid(scope, location, profileKey, options) {
        if (!slick) {
            return false;
        }
        var profile = resolveProfile(profileKey);
        if (!profile) {
            return false;
        }
        return slick.applySidebarFiltersToGrid(scope, location, profile, options);
    }

    function syncActiveStateToLocationSearch(scope, location) {
        if (!slick || !scope || !location) {
            return;
        }
        var search = angular.extend({}, location.search());
        slick.syncActiveStateQueryToSearch(search, scope, scope.current.activeStates);
        location.search(search);
    }

    function syncCommittedActiveState(scope) {
        if (!slick) {
            return;
        }
        slick.syncCommittedActiveState(scope);
    }

    function refreshPortfolioSidebarFilterCount(scope, http) {
        if (!slick) {
            return null;
        }
        return slick.refreshPortfolioSidebarFilterCount(scope, http);
    }

    function onActiveStateChanged(scope, settings, timeout, refreshGridFn, http) {
        if (!slick) {
            if (typeof refreshGridFn === 'function') {
                timeout(function () { refreshGridFn(); });
            }
            return;
        }
        slick.onPortfolioListActiveStateChanged(scope, settings, timeout, refreshGridFn, http);
    }

    var RECORD_COLUMN_LIMIT_SPLIT_FLAG = 'opex_slick_grid_connect_record_column_limit_entity_39220';
    var LEGACY_PORTFOLIO_GRID_TOP = 50000;

    function tryEnableLegacyPortfolioListGrid(scope) {
        if (!scope || !scope.current || isPortfolioSsrmEnabled(scope)) {
            return;
        }
        // Split FF on: wait for GridRecordLimit EO before mounting the grid.
        if (scope.current.slickGridRecordColumnLimitEnabled) {
            return;
        }
        if (!scope.current.portfolioListInitReady || !scope.current.slickGridViewReady) {
            return;
        }
        scope.current.gridLimitsReady = true;
    }

    function markPortfolioListInitComplete(scope) {
        if (!scope || !scope.current) {
            return;
        }
        scope.current.portfolioListInitReady = true;
        // Split FF on: applyGridLimitEntityOptions sets gridLimitsReady after EO loads.
        if (scope.current.slickGridRecordColumnLimitEnabled) {
            return;
        }
        if (!isPortfolioSsrmEnabled(scope)) {
            scope.current.gridLimitsReady = true;
            return;
        }
        tryEnableLegacyPortfolioListGrid(scope);
    }

    function markPortfolioListViewReady(scope) {
        if (!scope || !scope.current) {
            return;
        }
        scope.current.slickGridViewReady = true;
        tryEnableLegacyPortfolioListGrid(scope);
    }

    function resolveLegacyTemplateParamValue(current, key, profile) {
        if (key === 'isActive') {
            return current.activeState && current.activeState.queryString !== undefined
                ? current.activeState.queryString
                : undefined;
        }

        var prop = (profile.scopeSearchBindings && profile.scopeSearchBindings[key]) || key;
        var camelProp = prop.charAt(0).toLowerCase() + prop.slice(1);
        var val = current[camelProp];
        if (val === undefined) {
            val = current[prop];
        }
        if (val === undefined || val === null || val === '') {
            return undefined;
        }
        return val;
    }

    function buildLegacyPortfolioGridParams(scope, profileKey) {
        var profile = resolveProfile(profileKey);
        if (!profile || !scope || !scope.current || !profile.templateParamKeys) {
            return null;
        }

        var params = {};
        // Match buildODataListQueryParams: only set keys that have a real value so
        // parseGridParamParts can still apply deep-link ids from gridParams.
        Object.each(profile.templateParamKeys, function (key) {
            var val = resolveLegacyTemplateParamValue(scope.current, key, profile);
            if (val === undefined) {
                return;
            }
            params[key] = val;
        });

        if (scope.current.gridParams && slick && slick.parseGridParamParts) {
            slick.parseGridParamParts(scope.current.gridParams, params);
        }

        return params;
    }

    function initRecordColumnLimitFeature(scope, splitIoService, http, location, activeState, profileKey, callback) {
        callback = callback || function () {};

        if (!scope || !scope.current) {
            callback(false);
            return;
        }

        scope.current.slickGridRecordColumnLimitEnabled = false;
        scope.current.portfolioGridLimitsSettingEnabled = false;
        scope.current.portfolioSsrmEnabled = false;
        scope.current.portfolioListFiltersReady = false;
        scope.current.portfolioListInitReady = false;
        scope.current.slickGridViewReady = false;

        if (!splitIoService || !slick) {
            callback(false);
            return;
        }

        splitIoService.getBoolTreatment(RECORD_COLUMN_LIMIT_SPLIT_FLAG).subscribe(function (isEnabled) {
            scope.current.slickGridRecordColumnLimitEnabled = !!isEnabled;

            if (!isEnabled) {
                delete scope.current.gridRequestTop;
                scope.current.loadUntilRecordLimit = false;
                scope.current.gridRecordLimit = 0;
                scope.current.portfolioGridLimitsSettingEnabled = false;
                scope.current.portfolioSsrmEnabled = false;
                scope.current.gridLimitsReady = true;
                callback(false);
                return;
            }

            scope.current.portfolioListFiltersReady = false;
            var hasODataFilter = applyODataRouteFilters(scope, location, profileKey, activeState);
            applyGridLimitEntityOptions(scope, http, location, activeState);
            callback(hasODataFilter);
        });
    }

    function applyGridLimitEntityOptions(scope, http, location, activeState) {
        if (!slick) {
            if (scope && scope.current) {
                scope.current.gridLimitsReady = true;
            }
            return;
        }
        slick.applyGridLimitEntityOptions(scope, http, location, activeState);
    }

    function applyPendingODataSidebarSync(scope, profileKey) {
        if (!slick) {
            return false;
        }
        var profile = resolveProfile(profileKey);
        if (!profile) {
            return false;
        }
        return slick.applyPendingODataSidebarSync(scope, profile);
    }

    function fetchODataListCount(scope, http, profileKey) {
        if (!slick) {
            return null;
        }
        var profile = resolveProfile(profileKey);
        if (!profile) {
            return null;
        }
        return slick.fetchODataListCount(scope, http, profile);
    }

    function fetchSidebarFilterRowCount(scope, http, profileKey) {
        if (!slick) {
            return null;
        }
        var profile = resolveProfile(profileKey);
        if (!profile) {
            return null;
        }
        return slick.fetchSidebarFilterRowCount(scope, http, profile);
    }

    var api = {
        profiles: PROFILES,
        recordColumnLimitSplitFlag: RECORD_COLUMN_LIMIT_SPLIT_FLAG,
        legacyPortfolioGridTop: LEGACY_PORTFOLIO_GRID_TOP,
        resolveProfile: resolveProfile,
        isSameLevelEntityRouteGetById: isSameLevelEntityRouteGetById,
        applyEntityRouteGetByIdMode: applyEntityRouteGetByIdMode,
        normalizeEntityRouteScopeForODataList: normalizeEntityRouteScopeForODataList,
        applyODataSortFromView: applyODataSortFromView,
        ensurePortfolioListQueryParams: ensurePortfolioListQueryParams,
        initRecordColumnLimitFeature: initRecordColumnLimitFeature,
        isPortfolioSsrmEnabled: isPortfolioSsrmEnabled,
        markPortfolioListInitComplete: markPortfolioListInitComplete,
        markPortfolioListViewReady: markPortfolioListViewReady,
        buildLegacyPortfolioGridParams: buildLegacyPortfolioGridParams,
        applyODataRouteFilters: applyODataRouteFilters,
        applySidebarFiltersToGrid: applySidebarFiltersToGrid,
        syncActiveStateToLocationSearch: syncActiveStateToLocationSearch,
        syncCommittedActiveState: syncCommittedActiveState,
        onActiveStateChanged: onActiveStateChanged,
        applyPendingODataSidebarSync: applyPendingODataSidebarSync,
        applyGridLimitEntityOptions: applyGridLimitEntityOptions,
        fetchODataListCount: fetchODataListCount,
        fetchSidebarFilterRowCount: fetchSidebarFilterRowCount,
        refreshPortfolioSidebarFilterCount: refreshPortfolioSidebarFilterCount
    };

    if (slick) {
        [
            'getODataFilterFromSearch',
            'buildODataGridParams',
            'splitODataAnd',
            'splitODataOr',
            'collectODataLeafClauses',
            'detectODataFilterJoinType',
            'parseComparisonClause',
            'parseFunctionClause',
            'parseSubstringofClause',
            'parseODataClause',
            'parseIsActiveFromODataFilter',
            'removeIsActiveClauses',
            'buildSidebarFiltersFromOData',
            'buildIsActiveSidebarFilter',
            'toODataPropertyName',
            'compileFilterToODataClause',
            'compileFiltersToOData',
            'prepareViewFiltersForClientSide',
            'upsertGridParam',
            'parseEntityOptionInt',
            'findColumnForProperty',
            'isRecordColumnLimitFeatureEnabled',
            'isGridRecordLimitEnabled',
            'isDeferredODataSidebarSearchEnabled',
            'ODATA_LIST_PAGE_SIZE',
            'resolveRecordLimitGridTop',
            'resolvePortfolioGridRequestTop',
            'buildODataListQueryParams',
            'updatePortfolioGridRowCounts'
        ].forEach(function (method) {
            api[method] = slick[method];
        });
    }

    global.portfolioListODataSidebarSync = api;
    global.householdListODataSidebarSync = api;
}(window));

'use strict';

var householdListCtrl = app.controller('HouseholdListCtrl', function HouseholdListCtrl($scope, $http, $q, $location, $oasRights, $dialog, $portfolio, $tactical, $routeParams, $settings, $timeout, entities, views, apps, activeState, searchResult, API_CONFIG, civ2Service, $window, splitIoService) {
    //PRIVATE VARIABLES
    var selectedHH;
    var lastCell = null;
    var lastRow = null;

    // PRIVATE METHODS
    function applyWorkflowAssistantODataFilters() {
        var sync = window.portfolioListODataSidebarSync;
        if (!sync) {
            return false;
        }
        return sync.applyODataRouteFilters($scope, $location, 'client', activeState);
    }

    function needsDefaultActiveStateFromSettings() {
        if ($routeParams.householdFilter === 'inactiveclientsactiveaccounts') {
            return false;
        }
        if ($routeParams.entitySessionId) {
            return false;
        }
        if ($routeParams.queryStudioId) {
            return false;
        }
        if ($routeParams.pageQueryId) {
            return false;
        }
        return true;
    }

    function init() {
        splitIoService.getBoolTreatment('recon_datasharing_editwarningmessages_7285').subscribe((isEnabled) => {
            $scope.isDataSharingWarningEnabled = isEnabled;
        });

        var sync = window.portfolioListODataSidebarSync;
        if (sync && sync.initRecordColumnLimitFeature) {
            sync.initRecordColumnLimitFeature($scope, splitIoService, $http, $location, activeState, 'client', finishInit);
        } else {
            $scope.current.gridLimitsReady = true;
            finishInit(false);
        }
    }

    function finishInit(hasODataClientFilter) {
        if (!$scope.current.portfolioSsrmEnabled) {
            hasODataClientFilter = applyWorkflowAssistantODataFilters();
        }

        $scope.rightsHH = $oasRights.forCode("CLIENTS");
        $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
        $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
        $scope.rightsAst = $oasRights.forCode("ASSETS");
        $scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");
        $scope.rightsNewAcc = $oasRights.forCode("NEWACCOUNT");
        $scope.rightsHouseholding = $oasRights.forCode("HOUSEHOLDINGAPP");
        $scope.rightsCancelAccount = $oasRights.forCode("CANCELACCOUNT");
        $scope.rightsTOM = $oasRights.forCode("TRADEORDERMGMT");
        $scope.rightsInstances = $oasRights.forCode("TRADEINSTANCES");
        $scope.rightsPerfViewer = $oasRights.forCode("PERFVIEWER");
        $scope.rightsHouseholdOverview = $oasRights.forCode("HOUSEHOLDOVERVIEW");
        $scope.rightsTaxCenter = $oasRights.forCode("TAXCENTERMAINTAIN");
        $scope.rightsInsight = $oasRights.forCode("INSIGHTBUILDERAPP");
        $scope.rightsTargetAllocation = $oasRights.forCode("TARGETALLOCATION");
        $scope.rightsMoneyGuidePro = $oasRights.forCode("MONEYGUIDEPRO");
        $scope.rightsSalesForceSync = $oasRights.forCode("SFSYNCHISTORY");
        $scope.rightsNotes = $oasRights.forCode("NOTES");
        $scope.rightsDocuments = $oasRights.forCode("DOCUMENTS");
        $scope.rightsPVCompare = $oasRights.forCode("PORTFOLIOVIEWCOMPARE");
        $scope.rightsPortfolioRepresentativePayouts = $oasRights.forCode('PORTFOLIOREPRESENTATIVEPAYOUTS');

        if ($routeParams.householdFilter === 'inactiveclientsactiveaccounts') {
            $scope.current.activeState = activeState.inActive;
        } else if (!$scope.current.activeState && needsDefaultActiveStateFromSettings()) {
            $scope.current.activeState = $settings.getSetting('activeState');
        }
        if ($scope.current.portfolioSsrmEnabled && $scope.current.activeState) {
            $scope.current.committedActiveState = $scope.current.activeState;
        }

        if (!hasODataClientFilter) {
            if ($routeParams.entitySessionId) {
                $scope.current.url = '/Portfolio/Clients';
                $scope.current.entitySessionId = $routeParams.entitySessionId;
                $scope.current.detailInfo = '(' + ($routeParams.info ? $routeParams.info : 'Externally Filtered') + ')';
            } else if ($routeParams.queryStudioId) {
                $scope.current.url = '/Portfolio/Clients/qs?queryStudioQueryId=' + $routeParams.queryStudioId;
                $scope.current.detailInfo = '(' + ($routeParams.info ? $routeParams.info : ' Filtered by Query Studio') + ')';
            }
        }

        if (searchResult) {
            $scope.current.url = '';
            $portfolio.goTo(entities[entities.find({value: searchResult.entity})].urlFrag, searchResult.entity, searchResult.item.id);
        } else {
            if (!hasODataClientFilter && $routeParams.entityId) {
                switch ($routeParams.entity) {
                    case entities.representative.value:
                        $scope.current.repId = $routeParams.entityId;
                        $scope.current.gridParams += '&representativeId=' + $routeParams.entityId;

                        $http.post('/Portfolio/Representatives/Simple/List/Id', [$routeParams.entityId], {allowCancellation: true})
                            .then(function (response) {
                                if (response.data[0]) {
                                    $scope.current.detailInfo = $portfolio.getBreadcrumb($routeParams.entity, response.data[0].name);
                                }
                            });
                        break;
                    case entities.client.value:
                    case entities.portfolioGroup.value:
                        const urls = $portfolio.getDataUrls($routeParams.entity, $routeParams.entityId, $routeParams.entity === entities.client.value ? 0 : entities.client.value);
                        $scope.current.url = urls.urlForList;
                        break;
                    case entities.registration.value:
                        $scope.current.registrationId = $routeParams.entityId;
                        $scope.current.gridParams += '&registrationId=' + $routeParams.entityId;
                        break;
                    case entities.account.value:
                        $scope.current.accountId = $routeParams.entityId;
                        $scope.current.gridParams += '&accountId=' + $routeParams.entityId;
                        break;
                    default:
                        throw new Error('Invalid entity passed in url query string');
                }
            } else if ($routeParams.pageQueryId) {
                $scope.current.activeState = activeState.activeAndInActive; // don't set a filter on active state, the page query spocs will handle that
                $portfolio.getPageQueryName($routeParams.pageQueryId)
                    .then(function (queryName) {
                        $scope.current.detailInfo = '(' + queryName + ')';
                    });
            }
        }

        var portfolioSync = window.portfolioListODataSidebarSync;
        if ($scope.current.portfolioSsrmEnabled && portfolioSync) {
            if (portfolioSync.normalizeEntityRouteScopeForODataList) {
                portfolioSync.normalizeEntityRouteScopeForODataList($scope, 'client', $routeParams.entity, $routeParams.entityId);
            }
            if (portfolioSync.applyODataSortFromView) {
                portfolioSync.applyODataSortFromView($scope, 'client', $location.search(), {});
            }
        }

        if ($routeParams.source) {
            const key = apps.find({code: $routeParams.source});
            $scope.middleBreadcrumb = key ? apps[key].name : null;
        }

        $scope.resetWidth(false);

        if ($routeParams.openEditor && $scope.rightsHH.canRead && $routeParams.entityId && $routeParams.entity === entities.client.value) {
            $scope.selectedIds.push($routeParams.entityId);
            let tabToOpen = null;
            if ($routeParams.openEditor === 'portfolioGroups' && $oasRights.canRead("PORTFOLIOGROUPS")) {
                tabToOpen = $routeParams.openEditor;
            }
            $scope.openEditor(false, tabToOpen);
        }

        var portfolioSync = window.portfolioListODataSidebarSync;
        if (portfolioSync && portfolioSync.markPortfolioListInitComplete) {
            portfolioSync.markPortfolioListInitComplete($scope);
        } else if (!$scope.current.portfolioSsrmEnabled) {
            $scope.current.gridLimitsReady = true;
        }
    }

    function doAction(actionUrl, msgVerb, confirmMsg) {
        $dialog.confirmAction(confirmMsg)
            .open()
            .then(function (result) {
                if (result === 'yes') {

                    $http.post('/Portfolio/Clients/ListCounts', $scope.selectedIds, {trackerMsg: 'Getting counts for household(s)', allowCancellation: true} )
                        .then(function(response){
                            var count = response.data;
                            var msg = 'By deleting this record, you will be permanently removing the following from your database: <br />';
                            msg += '  * ' + count.registrationsCount +  ' Registrations' + '<br />';
                            msg += '  * ' + count.accountsCount + ' Accounts' + '<br />';
                            msg += '  * ' + count.assetsCount + ' Assets' + '<br />';
                            msg += '  * ' + count.transactionsCount +  ' Transaction' + '<br />';
                            msg += 'If this data is needed to be restored, this can come at a cost to your firm.  Are you sure you still want to proceed?';

                            $dialog.confirmAction(msg)
                                .open()
                                .then(function(rst){
                                   if (rst === 'yes'){
                                       $http.put(actionUrl, $scope.selectedIds, {trackerMsg: msgVerb + ' household(s)'})
                                           .then(function () {
                                               refreshGrid();
                                           });
                                   }
                                });
                        });
                }
            });
    }

    function refreshGrid() {
        $scope.$broadcast('event:portfoliolist-household-action', {action: 'refresh-grid'});
    }

    // PUBLIC METHODS

    $scope.getHouseholdDetailLink = function () {
        return `#/billing/householdbills?id=${$scope.selectedIds[0]}&source=phh` + ($routeParams.entityId ? `&sourceid=${$routeParams.entityId}` : '')
    }

    $scope.search = function () {
        $portfolio.search(entities.client.value)
            .then(function (rslt) {
                if (rslt) {
                    $portfolio.goTo(entities[entities.find({value: rslt.entity})].urlFrag, rslt.entity, rslt.item.id);
                }
            });
    };

    $scope.runReport = function () {
        $portfolio.runReport(entities.client.value, $scope.selectedIds[0]);
    };
    
    $scope.importTargetAllocations = function () {
        $dialog.dialog({
            dialogClass: "modal medium",
            templateUrl: "app/modals/upload-file.html",
            controller: "UploadFileCtrl",
            title: "Target Allocation Import",
            idField: "id",
            downloadUrl: '/Portfolio/ValidateImport/TargetAllocationClient/Templates/',
            validateUrl: '/Portfolio/ValidateImport/TargetAllocationClient',
            commitVerb: 'PUT',
            commitUrl: '/Portfolio/Clients/Verbose'})
            .open();
    };

    $scope.sfSyncDelta = function(){
        var startSync = function(){
          $http.post('/Integrations/Salesforce/OrionConnect/DeltaSync/5/' + $scope.current.clientId, { trackerMsg:'Sending SalesForce Sync Request'})
              .then(function (response) {
                  $dialog.messageBox('SalesForce Sync', 'The SalesForce Sync started successfully').open();
              })
              .catch(function (reason) {
                  if(reason.statusText === 'Not Found'){
                      $dialog.messageBox('Sync Failed', 'Advisor is not setup with the salesforce.').open();
                  }
              })
        };

      $dialog.confirmAction('This will start the SalesForce Sync for ' + $scope.current.clientName + '.  Would you like to continue?')
          .open()
          .then(function (result) {
              if(result.toLowerCase() === 'yes'){
                  startSync();
              }
          })

    };

    $scope.openEditor = function (isNewHH, tabToOpen) {
        if ($scope.selectedIds.length == 1 || isNewHH) {
            $portfolio.openEditor(entities.client.value, isNewHH ? [] : $scope.selectedIds, null, tabToOpen, apps.portfolioLists.name, null).then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast('event:portfoliolist-household-action', {action: isNewHH ? 'add-item' : 'update-item', item: rslt});
                }
            });
        } else {
            $portfolio.openMassEditor(entities.client.value, $scope.selectedIds, apps.portfolioLists.name).then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast('event:portfoliolist-household-action', {action: 'update-items', items: rslt});
                }
            });
        }
    };
    
    $scope.copyHousehold = function () {
        $portfolio.openEditor(entities.client.value, $scope.selectedIds, null, null, apps.portfolioLists.name, {createCopy: true})
            .then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast('event:portfoliolist-household-action', {action: 'add-item', item: rslt});
                }
            });
    };

    $scope.openCancellationEditor = function (isMassCancel) {
        var d = $dialog.editor('portfolio/modals/cancelAccount.html', 'CancelAccountCtrl', {
            args: function () {
                return {id: isMassCancel ? null : $scope.selectedIds[0], entity: isMassCancel ? entities.account.value : entities.client.value, app: apps.portfolioLists.name};
            }
        });
        d.open().then(function (rslt) {
            if (rslt) {
                $scope.$broadcast('event:portfoliolist-household-action', {action: 'refresh-grid'});
            }
        });
    };

    $scope.resetWidth = function (goWide) {
        let customWidth = $scope.rightsPortfolioRepresentativePayouts.canRead ? 500 : 350;
        $scope.rightSidebar.width = goWide ? customWidth : 250;
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:portfoliolist-household-action', {action: 'export-data'});
    };

    $scope.deleteHouseholds = function () {
        //if feature flag enabled show datasharing dialog
        var msg = 'It is Orion\'s best practice to not delete households. If you proceed with this deletion, you will be responsible for providing this data should you need it to be recorded in Orion in the future or for auditing purposes. Are you sure you want to proceed?';
        var deleteUrl = '/portfolio/clients/action/delete';
        var verb = 'Deleting';
        splitIoService.getBoolTreatment("recon_datasharing_editwarningmessages_7285")
            .subscribe((isEnabled) => {
                if ($scope.isDataSharingEntitySelected && isEnabled) {
                    $dialog.confirmAction('Household is a data sharing Household. Changes are likely to be reverted by subsequent syncs.  Would you still like to proceed?')
                        .open()
                        .then((response) => {
                            if (response == 'yes') {
                                doAction(deleteUrl, '', msg);
                            }
                        });
                }
                //else do legacy
                else {
                    doAction(deleteUrl, verb, msg);
                }
        });
        
    };

    $scope.goToHouseholdOverview = function () {
        $location.url('/portfolio/household/overview?entity=' + parseInt(entities.client.value) + '&entityId=' + $scope.selectedIds[0]);
    };

    $scope.goToPortfolioView = function (tab) {
        let urlTemp = '/orion/dashboard?entity=' + parseInt(entities.client.value) + '&entityId=' + $scope.selectedIds[0];
        if (tab?.length > 0) {
            urlTemp = urlTemp + '&tab=' + tab;
        }
        $location.url(urlTemp);
    };

    $scope.goToPerformanceViewer = function () {
        $location.url('/reports/performanceviewer3?entity=' + parseInt(entities.client.value) + '&entityId=' + $scope.selectedIds[0]);
    };

    $scope.goToTaxCenter = function() {
        $location.url('/tax/custodianrealized?entity=' + parseInt(entities.client.value) + '&entityId=' + $scope.selectedIds[0]);
    };

    $scope.goToHouseholding = function () {
        if ($scope.selectedIds.length == 1) {
            $location.url('/portfolio/household/householding?entityId1=' + $scope.selectedIds[0] + '&source=' + apps.portfolioLists.code);
        } else {
            $location.url('/portfolio/household/householding?entityId1=' + $scope.selectedIds[0] + '&entityId2=' + $scope.selectedIds[1] + '&source=' + apps.portfolioLists.code);
        }
    };

    $scope.goToLower = function (urlLevel) {
        $portfolio.goTo(urlLevel, entities.client.value, $scope.selectedIds[0]);
    };

    $scope.setActiveState = function () {
        if (!$scope.current.portfolioSsrmEnabled) {
            $settings.setSetting('activeState', $scope.current.activeState);
            $timeout(refreshGrid);
            return;
        }
        var sync = window.portfolioListODataSidebarSync;
        if (sync && sync.onActiveStateChanged) {
            sync.onActiveStateChanged($scope, $settings, $timeout, refreshGrid, $http);
            return;
        }
        $settings.setSetting('activeState', $scope.current.activeState);
        $timeout(refreshGrid);
    };

    $scope.refreshMGP = function () {
        $q.all({
            summary: $http.get("/Integrations/MoneyGuidePro/PlanSummary/Client/" + $scope.selectedIds[0] + "?includeImage=false&forceRefresh=true", {

                trackerMsg: 'Loading plan summary'
            }),
            insurance: $http.get("/Integrations/MoneyGuidePro/InsurancePolicies/Client/" + $scope.selectedIds[0] + "?forceRefresh=true", {

                trackerMsg: 'Loading insurance policies'
            }),
            monteCarlo: $http.get("/Integrations/MoneyGuidePro/MonteCarloMeter/Client/" + $scope.selectedIds[0] + "?includeImage=false&forceRefresh=true", {

                trackerMsg: 'Loading monte-carlo data'
            }),
            netWorth: $http.get("/Integrations/MoneyGuidePro/Networth/Client/" + $scope.selectedIds[0] + "?forceRefresh=true", {

                trackerMsg: 'Loading net worth'
            })
        }).then(function (responses) {
            if (responses.summary.data) {
                selectedHH.probabilityOfSuccess = parseFloat(responses.summary.data.results['current'].monteCarloMeter.probabilityOfSuccess);
                $scope.$broadcast('event:portfoliolist-household-action', {
                    action: 'update-item',
                    item: selectedHH
                });
            }
        });
    };

    $scope.openTactical = function () {
        $tactical.startHousehold(selectedHH, true);
    };

    $scope.goBack = function () {
        window.history.back();
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    };

    $scope.refreshGridData = function(){
        $scope.current.refreshCache = true;
        $timeout(function () {
            var clearRefreshCache = function () {
                $scope.current.refreshCache = false;
            };
            var searchSidebarFilters = $scope.searchSidebarFilters || $scope.current.searchSidebarFilters;
            if ($scope.current.portfolioSsrmEnabled
                && typeof searchSidebarFilters === 'function'
                && !$scope.current.entityRouteGetById) {
                // Same as the sidebar's Refresh Grid: re-applies the filters and re-matches file filters.
                searchSidebarFilters();
                $timeout(clearRefreshCache);
            } else {
                refreshGrid();
                $timeout(clearRefreshCache);
            }
        });
    };

    $scope.createTransactionImport = function(){
        civ2Service.getImportType("Transaction Add").then(function(res){
            $dialog.createCustomImport(res.data.id,"Create New Transaction Add Import");
        });
    };

    // EVENT LISTENERS
    $scope.$on('event:portfoliolist-household-select', function (e, args) {
        if (args.length === 0) return;
        $scope.current.clientId = args[0].id;
        $scope.current.clientName = args[0].name;
        selectedHH = args[0];
        $scope.isDataSharingEntitySelected = false;
        args.forEach((item) =>
        {
            if (item.isDataSharingEntity)
            {
                $scope.isDataSharingEntitySelected = true;
            }
        })
        // Rep payout tab
        $scope.repPayout.clientId = args[0].id;
        if($scope.repPayout.isActiveTab){
            $scope.resetWidth(true);
        }
    });
    $scope.$on("event:portfoliolist-household-edit", function (e, args) {
        if (!args.item) return;
        if (!args.item.isDataSharingEntity) return;
        var isDifferentRow = false;
        var isDifferentCell = false;
        if (lastRow != args.row) {
            isDifferentRow = true;
            lastRow = args.row;
        }
        if (lastCell != args.cell) {
            isDifferentCell = true;
            lastCell = args.cell;
        }

        if ($scope.isDataSharingWarningEnabled && (isDifferentRow || isDifferentCell)) {
            $dialog.messageBox("Household is a data sharing household. Changes are likely to be reverted by subsequent syncs.")
                .open().then(() => {
                    args.grid.gotoCell(args.row, args.cell, true);
                }
                );
        }
    });

    $scope.$on('slickgrid-data-loaded', function(event, data) {
        if (data.length !== 1) return;
        $scope.current.clientId = data[0].id;
        selectedHH = data[0];
        $scope.$broadcast('event:portfoliolist-household-action',{action:'select-items', items: data.slice(0,1) });
    });

    $scope.$on('slickgrid-last-refresh', function(event, data) {
        $scope.current.lastUpdated = data;
    });

    // INITIALIZE
    $scope.views = views;

    $scope.repPayout = {
        clientId: null,
        isActiveTab: false
    };

    $scope.selectedIds = [];
    $scope.reportArgs = {};
    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        gridQueries: [],
        url: '/Portfolio/Clients/Grid',
        detailInfo: '',
        activeStates: activeState,
        householdFilter: $routeParams.householdFilter,
        pageQueryId: $routeParams.pageQueryId,
        clientId: null,
        repId: null,
        accountId: null,
        useOData: false,
        useServerSideRowModel: false,
        gridParams: '',
        odataListProfileKey: 'client',
        gridLimitsReady: false,
        portfolioListFiltersReady: false,
        gridRowCountsReady: false,
        slickGridRecordColumnLimitEnabled: false,
        portfolioGridLimitsSettingEnabled: false,
        portfolioSsrmEnabled: false,
        gridRecordLimit: 0,
        viewsColumnsLimit: 0,
        insightUrl: API_CONFIG.insightUrl + '?p=dashboards&t=' + sessionStorage.oas_token,
        returnStyle : $location.path().has('prospects') ? 'Prospects' : null,
        refreshCache: false,
        lastUpdated: null,
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        $scope.openEditor(false);
    }}];

    init();
});

householdListCtrl.loadPortfolioListConfig = ["$http", "$route", "$location", "$portfolio", function ($http, $route, $location, $portfolio) {
    var search = $location.search();
    if ($route.current.params.entity || $route.current.params.householdFilter || $route.current.params.registrationFilter || $route.current.params.accountFilter || $route.current.params.pageQueryId || $route.current.params.entitySessionId || search.$filter || search.odataFilter) {
        return null;
    } else {
        return $http.get("/Settings/EntityOptions/Database/0/code/PortfolioAuditForceSearch", {cache: true, trackerMsg: 'Loading search setting'})
            .then(function (response) {
                return response.data.value == "True" ? $portfolio.search($route.current.$$route.entity) : null;
            });
    }
}];

'use strict';

app.controller('HouseholdEditCtrl', function HouseholdEditCtrl($scope, $http, $oasRights, $dialog, $portfolio, dialog, args, entities, statementDeliveryMethod, additionalAnnualAmtType, apps, $q, $timeout, billingStyle, billFrequency, splitIoService, targetAllocationSaveValidator) {
    var dateFormat = '{MM}/{dd}/{yyyy}';
    var botDate = '1/1/1900';
    var eotDate = '12/31/9999';

    function isDateRangeCurrent(startDate, endDate) {
        if (!startDate || !endDate) return false;
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var start = new Date(startDate);
        start.setHours(0, 0, 0, 0);
        var end = new Date(endDate);
        end.setHours(0, 0, 0, 0);
        return start <= today && today <= end;
    }

    function getCurrentRepsFromClientRepAdditional(clientRepAdditional) {
        var details = (clientRepAdditional && clientRepAdditional.details) ? clientRepAdditional.details : [];
        var currentReps = details.filter(function (rep) {
            return isDateRangeCurrent(rep.startDate, rep.endDate) && !rep.isPrimary;
        });
        return currentReps.map(function (rep) {
            return {
                repId: rep.representativeId,
                clientId: rep.clientId,
                repTitleId: rep.representativeTitleId,
                canDelete: true,
                numberOfHouseholds: 0,
                simpleRep: rep.simpleRep,
                startDate: rep.startDate,
                endDate: rep.endDate
            };
        });
    }

    /** When clientRepAdditional has no rows, use legacy additionalRepresentatives; otherwise current-window non-primary reps from CRA. */
    function applyHouseholdAdditionalRepresentativesFromVerboseResponse(data) {
        if (!data) {
            return;
        }
        var craDetails = (data.clientRepAdditional && data.clientRepAdditional.details) ? data.clientRepAdditional.details : [];
        if (craDetails.length === 0) {
            $scope.current.hasClientRepAdditional = false;
            $scope.householdAdditionalRepresentatives = data.additionalRepresentatives || [];
        } else {
            $scope.current.hasClientRepAdditional = true;
            $scope.householdAdditionalRepresentatives = getCurrentRepsFromClientRepAdditional(data.clientRepAdditional);
        }
    }

    function buildClientRepAdditionalPayload() {
        var clientId = args.ids[0] || 0;
        return $scope.householdAdditionalRepresentatives.map(function (rep) {
            return {
                clientId: rep.clientId || clientId,
                representativeId: rep.repId,
                representativeTitleId: rep.repTitleId,
                isPrimary: false,
                isActive: true
            };
        });
    }

    var additionalRepsPercent = [];

    // PRIVATE VARIABLES
    let householdGeneralOriginal,
        householdNotesOriginal,
        householdDocumentsOriginal,
        householdHHMembersOriginal,
        householdAdditionalRepresentativesOriginal,
        householdSuitabilityOriginal,
        billingGeneralOriginal,
        billingRecurringAdjustmentsOriginal,
        billingRelatedHHsOriginal,
        billingFeePayingAccountsOriginal,
        entityOptionsOriginal,
        customFieldsOriginal,
        targetAllocationsOriginal,
        editorHotKeys,
        assetExclusionsOriginal,
        financialPlanningFeeOriginal,
        portfolioGroupsOriginal,
        relatedHouseholdAccounts,
        tieredFeeAccountsOriginal,
        changeHistoryOriginal,
        representativesOriginal,
        original = {householdAdditionalRegs: undefined, householdAdditionalAccounts: undefined};

    var representativesDefaultItems = null;

    var repErrorMessages = {
        startAndEndDateRequired: "Start and End Dates are Required",
        startDateShouldLessOrEqualEndDate: "Start Date should be less than or equal to End date",
        DateRangeOverlappingWithOtherGroup: "Date range overlapping with other group",
        dateRangeGapExists: "Gap exists in representative date ranges. Dates must be continuous with no gaps.",
    };

   
    splitIoService.getBoolTreatment('oc_portfolioAudit_sharedTargetAllocation_31732').subscribe((isEnabled) => {
        $scope.useSharedTargetAllocationEditor = isEnabled; 
    });

    // PRIVATE METHODS - INIT
    function init() {
        $http.get("/Settings/Database/EntityOptions/Code/RepPayoutPercent").then(function (response) {
            $scope.isRepPayoutPercentEnabled = response.data.value === "True";

            splitIoService.getBoolTreatment('opex_Rep_Split_5809').subscribe((isEnabled) => {
                // if we opened the editor that is not loading the General tab by default, we want globally check the flag so we know to show 
                // the new reps tab - then clicking the reps tab will call the Portfolio to get rep info to help build the reps section
                if (args.defaultTab !== 'householdGeneral') {
                    $scope.isNewRepSplitFlagEnabled = isEnabled;
                }
    
                checkBillingLockdown();
                loadEnumLookUps();
                loadRights();
                buildMenu();
                loadHotKeys();
                $scope.loadTab(args.defaultTab);
                if (!dialog) {
                    window.parent.postMessage("iframeload");
                }
            });
        });        
    }
    
    function loadRights() {
        $scope.rightsChangeTradingPortfolioGroups = $oasRights.forCode("CHANGETRADINGPORTFOLIOGROUPS");
        $scope.rightsHH = $oasRights.forCode("CLIENTS");
        $scope.rightsNotes = $oasRights.forCode("NOTES");
        $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
        $scope.rightsDocuments = $oasRights.forCode("DOCUMENTS");
        $scope.rightsExternalAccts = $oasRights.forCode("REPORTGROUPHOUSEHOLD");
        $scope.rightsExternalRegs = $oasRights.forCode("EXTERNALREGISTRATIONS");
        $scope.rightsSuitability = $oasRights.forCode("INVOBJATCLIENTLEVEL");
        $scope.rightsEOs = $oasRights.forCode("ENTITYOPTION");
        $scope.rightsSSNView = $oasRights.forCode("SSNVIEW");
        $scope.rightsSSNChange = $oasRights.forCode("SSNCHANGE");
        $scope.rightsBilling = $oasRights.forCode("CLIENTBILLING");
        $scope.rightsBillingException = $oasRights.forCode("BILLINGEXCEPTION");
        $scope.rightsTargetAllocation = $oasRights.forCode("TARGETALLOCATION");
        $scope.rightsBluePay = $oasRights.forCode("BLUEPAY");
        $scope.rightsActiveStatus = $oasRights.forCode("ACTIVESTATUS");
        $scope.rightsCustomFields = $oasRights.forCode("CUSTOMFIELDS");
        $scope.isAdminOrRia = ["Administrator", "Advisor"].any($scope.user.authorization.entity);
        $scope.rightsHouseholdBillingRecurringAdjustments = $oasRights.forCode("HOUSEHOLDBILLINGRECURRINGADJUSTMENTS");
        $scope.rightsFinancialPlanningFee = $oasRights.forCode('FINANCIALPLANNINGFEE');
        $scope.rightsADVClientCategory = $oasRights.forCode("ADVCLIENTCATEGORY");
        $scope.rightsPortfolioGroups = $oasRights.forCode("PORTFOLIOGROUPS");
        $scope.rightsPortfolioRepresentativePayouts = $oasRights.forCode('PORTFOLIOREPRESENTATIVEPAYOUTS');
        $scope.rightsPayoutSchedules = $oasRights.forCode('MASTERPAYOUTSCHEDULE');
        $scope.rightsBillAppFeePayout = $oasRights.forCode('BILLAPPFEEPAYOUT');
    }

    function buildMenu() {
        var canLoadSettings = $scope.rightsCustomFields.canRead || (!args.isNew && !args.extraInfo.createCopy);
        var i = 0;
        $scope.menu = { categories: [] };

        $scope.menu.categories.push({ name: 'Household', children: [] });

        $scope.menu.categories[i].children.push({ name: 'General', active: false, code: 'householdGeneral' });

        $http.get("/Settings/Database/EntityOptions/Code/69USEHHCHANGEHISTORY", { trackerMsg: 'Checking Billing Household Change History' })
            .then(function (response) {
                $scope.rightsHHChangeHistory = response.data.value === "True";

                splitIoService.getBoolTreatment('opex_Rep_Split_5809').subscribe((isEnabled) => {
                    // do not set the scopes enabled flag yet on purpose. we want that set when the client details is loaded.
                    // but we do not want to add the change history tab based on the EO alone still
                    if ($scope.rightsHHChangeHistory && !isEnabled) {
                        $scope.menu.categories[0].children.splice(1, 0, { name: 'Change History', active: false, code: 'changeHistory', children: [] });
                    }

                    if ($scope.isRepPayoutPercentEnabled && isEnabled && $scope.rightsHH.canRead) {
                        $scope.menu.categories[0].children.splice(1, 0, { name: 'Representatives', active: false, code: 'representatives', children: [] });
                    }
                });
            });

        $scope.menu.categories[i].children.push({ name: 'Household Members', active: false, code: 'householdMembers' });

        if (($scope.rightsNotes.canRead || $scope.rightsDocuments.canRead) && !args.isNew) {
            $scope.menu.categories[i].children.push({ name: 'Notes & Documents', active: false, code: 'notesAndDocuments' });
        }

        if ($scope.rightsExternalRegs.canRead || $scope.rightsExternalAccts.canRead) {
            $scope.menu.categories[i].children.push({ name: 'Associated Accounts', active: false, code: 'householdAdditionalAccounts' });
        }

        if ($scope.rightsTargetAllocation.canRead) {
            $scope.menu.categories[i].children.push({ name: 'Target Allocation', active: false, code: 'targetAllocation' });
        }

        if ($scope.rightsSuitability.canRead) {
            $scope.menu.categories[i].children.push({ name: 'Suitability', active: false, code: 'suitability' });
        }

        if ($scope.rightsPortfolioGroups.canRead) {
            $scope.menu.categories[i].children.push({ name: 'Portfolio Groups', active: false, code: 'portfolioGroups' });
        }

        if ($scope.rightsBilling.canRead || $scope.rightsHouseholdBillingRecurringAdjustments.canRead) {
            i++;
            $scope.menu.categories.push({ name: 'Billing', children: [] });
            $scope.menu.categories[i].children.push({ name: 'General', active: false, code: 'billingGeneral' });

            if ($oasRights.canRead("BLUEPAY")) {
                $scope.menu.categories[i].children.push({ name: 'Credit Card', active: false, code: 'bluePay' });
            }
            if ($scope.rightsBilling.canRead) {
                $scope.menu.categories[i].children.push({ name: 'Fee Paying Accounts', active: false, code: 'feePayingAccounts' });
                $scope.menu.categories[i].children.push({ name: 'Related Households', active: false, code: 'relatedHouseholds' });
                $scope.menu.categories[i].children.push({ name: 'Asset Exclusion', active: false, code: 'assetExclusion' });
                if (!args.isNew && $scope.rightsFinancialPlanningFee.canRead) {
                    $scope.menu.categories[i].children.push({ name: 'Financial Planning Fee', active: false, code: 'financialPlanningFee' });
                }
                $scope.menu.categories[i].children.push({ name: 'Tiered Fee Priority', active: false, code: 'tieredFeePriority' })
            }

            if ($scope.rightsBilling.canRead || $scope.rightsHouseholdBillingRecurringAdjustments.canRead) {
                $scope.menu.categories[i].children.push({ name: 'Recurring Adjustments', active: false, code: 'recurringAdjustments' });
            }
        }

        if (canLoadSettings) {
            i++;
            $scope.menu.categories.push({ name: 'Settings', children: [] });

            if ($scope.rightsCustomFields.canRead) {
                $scope.menu.categories[i].children.push({ name: 'Custom Fields', active: false, code: 'customFields' });
            }

            if (!args.isNew && !args.extraInfo.createCopy) {
                if ($scope.rightsEOs.canRead) {
                    $scope.menu.categories[i].children.push({ name: 'Options', active: false, code: 'entityOptions' });
                }
            }
        }
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                { combo: 'ALT+S', command: $scope.save },
                { combo: 'ALT+X', command: function () { $scope.close(true); } }
            ]);
        });
    }

    function loadDataForSelectedTab() {
        switch ($scope.current.selectedTab) {
            case "householdGeneral":
                if ($scope.rightsHH.canRead) {
                    loadHousehold();
                }
                break;
            case "changeHistory":
                if ($scope.rightsHHChangeHistory) {
                    loadChangeHistory();
                }
                break;
            case 'representatives': 
                if ($scope.rightsHH.canRead) {
                    loadRepresentatives();
                }
                break;
            case "notesAndDocuments":
                if ($scope.rightsNotes.canRead) {
                    loadNotes();
                }
                if ($scope.rightsDocuments.canRead) {
                    loadDocuments();
                }
                break;
            case "householdMembers":
                if ($scope.rightsHH.canRead) {
                    loadHouseholdMembers();
                }
                break;
            case "householdAdditionalAccounts":
                break;
            case "suitability":
                if ($scope.rightsSuitability.canRead) {
                    loadSuitability();
                }
                break;
            case "portfolioGroups":
                if ($scope.rightsPortfolioGroups.canRead) {
                    loadPortfolioGroups();
                }
                break;
            case "billingGeneral":
                if ($scope.rightsHH.canRead) {
                    loadBillingGeneral();
                    loadHousehold();
                }
                break;
            case "bluePay":
                if ($scope.rightsBluePay.canRead) {
                    LoadCreditCard();
                }
                break;
            case "recurringAdjustments":
                if ($scope.rightsHH.canRead) {
                    loadRecurringAdjustments();
                    loadAdjustmentTypes();
                    loadBillingEntities();
                }
                break;
            case "relatedHouseholds":
                if ($scope.rightsHH.canRead) {
                    loadBillingGeneral();
                    loadHousehold();
                }
                break;
            case "assetExclusion":
                if ($scope.rightsHH.canRead) {
                    loadAssetExclusion();
                }
                break;
            case "financialPlanningFee":
                if ($scope.rightsHH.canRead) {
                    loadFinancialPlanning();
                }
            case "feePayingAccounts":
                if ($scope.rightsHH.canRead) {
                    loadFeePayingAccounts();
                }
                break;
            case "tieredFeePriority":
                if ($scope.rightsHH.canRead) {
                    loadRelatedHouseholdAccounts();
                    loadTieredFeePriority();
                }
                break;
            case "householdBills":
                if ($scope.rightsHH.canRead) {
                    loadHouseholdBills();
                }
                break;
            case "entityOptions":
                if ($scope.rightsEOs.canRead) {
                    loadEntityOptions();
                }
                break;
            case "customFields":
                if ($scope.rightsHH.canRead) {
                    loadCustomFields();
                }
                break;
            case "targetAllocation":
                if ($scope.rightsTargetAllocation.canRead) {
                    loadTargetAllocationGroupings();
                   
                    if (!$scope.useSharedTargetAllocationEditor) {
                        loadTargetAllocations();
                    }
                }
                break;
        }
    }

    function loadEnumLookUps() {
        var list = {
            billStyles: billingStyle,
            billFrequencies: billFrequency,
            annualAmtTypes: additionalAnnualAmtType
        };

        Object.each(list, function (key, value) {
            $scope[key] = $portfolio.enumToSimpleList(value);
        });
    }


    // PRIVATE METHODS - LOAD CLIENT
    function loadHousehold() {
        if ($scope.householdGeneral) return;

        splitIoService.getBoolTreatment('opex_Rep_Split_5809').subscribe((isEnabled) => {
            var useClientRepAdditional = isEnabled && $scope.isRepPayoutPercentEnabled;
            var expandParams = useClientRepAdditional
                ? 'portfolio,clientRepAdditional,additionalRepresentatives'
                : 'portfolio,additionalRepresentatives';

            if (args.isNew) {
                $http.get("/Portfolio/Clients/Verbose/New?expand=" + expandParams, { trackerMsg: 'Loading household' })
                    .then(function (response) {
                        $scope.householdGeneral = response.data.portfolio;
                        if (useClientRepAdditional) {
                            applyHouseholdAdditionalRepresentativesFromVerboseResponse(response.data);
                        } else {
                            $scope.householdAdditionalRepresentatives = response.data.additionalRepresentatives || [];
                        }
                        householdGeneralOriginal = angular.copy($scope.householdGeneral);
                        householdAdditionalRepresentativesOriginal = angular.copy($scope.householdAdditionalRepresentatives);
                        loadRepTitles();
                        $scope.isNewRepSplitFlagEnabled = isEnabled;
                    });
            } else {
                $http.get("/Portfolio/Clients/Verbose/" + args.ids[0] + "?expand=" + expandParams, { trackerMsg: 'Loading household' })
                    .then(function (response) {
                        $scope.householdGeneral = response.data.portfolio;
                        $scope.householdGeneral.emailInvalid = false;
                        if (useClientRepAdditional) {
                            applyHouseholdAdditionalRepresentativesFromVerboseResponse(response.data);
                        } else {
                            $scope.householdAdditionalRepresentatives = response.data.additionalRepresentatives || [];
                        }
                        $scope.isDataSharingEntity = response.data.isDataSharingEntity;
                        if (args.extraInfo.createCopy) {
                            $scope.householdGeneral.ssN_TaxID = null;
                            $scope.householdGeneral.id = 0;
                            args.isNew = true;
                        }
    
                        $scope.setAge();
                        householdGeneralOriginal = angular.copy($scope.householdGeneral);
                        householdAdditionalRepresentativesOriginal = angular.copy($scope.householdAdditionalRepresentatives);
                        loadRepForClient();
                        loadRepTitles();
                        $scope.isNewRepSplitFlagEnabled = isEnabled;
                    });
            }
        });        
    }

    $scope.addRepresentativeItem = function () {
        const tRepTitle = $scope.current.repTitles.find(r => r.name === 'Support Advisor');

        $scope.representatives.unshift({
            representativeId: null,
            representativeTitleId: tRepTitle.id,
            payoutRate: 0,
            isActive: true,
            clientId: $scope.current.householdId,
            isPrimary: false,
            isNew: true
        });

        $scope.groupedReps = buildGroupedRepresentatives($scope.representatives);
        findRegistrationRepPayoutOverrides();

        $scope.repSectionChanged();
    };

    $scope.validateUIRepresentatives = function () {
        var deferred = $q.defer();
        var validationStatus = true;
        $scope.representatives.forEach((rep) => {
            let startDateFormat;
            let endDateFormat;
            let isStart;
            let isCurrent;
            var errorMessage = [];
            if (rep.startDate != null) {
                startDateFormat = (rep.startDate)?.format(dateFormat);
                isStart = Date.create(botDate).getTime() === rep.startDate.getTime();
                startDateFormat = isStart ? "Start" : startDateFormat;
            }
            if (rep.endDate != null) {
                endDateFormat = (rep.endDate)?.format(dateFormat);
                isCurrent = Date.create(eotDate).getTime() === rep.endDate.getTime();
                endDateFormat = isCurrent ? "Onwards" : endDateFormat;
            }
            if (rep.isActive == true) {
                if ((!rep.isStartRecord && rep.startDate == null) || (!rep.isCurrentRecord && rep.endDate == null)) { // Validate start and end date for non default dates(Start and Current)
                    errorMessage.push(repErrorMessages.startAndEndDateRequired);
                }
            }

            // Overlap new date with other bundle
            let checkOverlapStartDate, checkOverlapEndDate = false;
            if(rep.startDate != null && rep.endDate != null && rep.isActive == true) {
                var getUnMatchingReps = $scope.representatives?.filter(val => !((val.startDate)?.format(dateFormat) == (rep.startDate)?.format(dateFormat) && (val.endDate)?.format(dateFormat) == (rep.endDate)?.format(dateFormat)) && val.isActive === true);
                checkOverlapStartDate = getUnMatchingReps.some(existRep => existRep.isActive == true && (rep.startDate >= existRep.startDate && rep.startDate <= existRep.endDate));
                checkOverlapEndDate = getUnMatchingReps.some(existRep => existRep.isActive == true && (rep.endDate >= existRep.startDate && rep.endDate <= existRep.endDate));
                if(checkOverlapStartDate || checkOverlapEndDate) {
                    errorMessage.push(repErrorMessages.DateRangeOverlappingWithOtherGroup);
                }
            }

            // checkMultiGroup - validate rep having more than one group
            let activeReps = $scope.representatives?.filter(val => val.isActive == true);
            let checkMultiGroup = activeReps.length > 0 ? activeReps?.some(val =>  (activeReps[0].startDate)?.format(dateFormat) != (val.startDate)?.format(dateFormat)) : false;
            if (rep.isNew && checkMultiGroup && rep.startDate != null && rep.isActive == true && (!checkOverlapStartDate && !checkOverlapEndDate)) {
                let checkPrimaryAssignedContinously = true;
                let minDate = new Date(Math.min.apply(null, activeReps.map(function(item) {
                    return new Date(item.startDate);
                })));
                let maxDate = new Date(Math.max.apply(null, activeReps.map(function(item) {
                    return new Date(item.endDate);
                })));
                // Start group - Check current rep end date with other group start dates
                if((minDate)?.format(dateFormat) == (rep.startDate)?.format(dateFormat)) { // Start group
                    checkPrimaryAssignedContinously = activeReps?.some(val => {
                        const startDateTemp = new Date(val.startDate);
                        startDateTemp.setDate(startDateTemp.getDate() - 1);
                        let startDateOfYesterday = new Date(startDateTemp);
                        return (startDateOfYesterday)?.format(dateFormat) == (rep.endDate)?.format(dateFormat);
                    });
                }
            }

            if (errorMessage.length > 0) {
                rep.isValid = false;
                errorMessage = [...new Set(errorMessage)];
                rep.validationMessage = errorMessage.join(', ');
                validationStatus = false;
            } else {
                rep.isValid = true;
                rep.validationMessage = null;
            }
        });

        var gaps = detectDateRangeGaps($scope.representatives);
        if (gaps.length > 0 && $scope.repDatesHaveChanged) {
            validationStatus = false;
            gaps.forEach(function(gap) {
                $scope.representatives.forEach(function(rep) {
                    if (rep.isActive && rep.endDate) {
                        var repEnd = new Date(rep.endDate);
                        repEnd.setHours(0, 0, 0, 0);
                        if (repEnd.getTime() === gap.afterEnd.getTime()) {
                            rep.isValid = false;
                            var existing = rep.validationMessage ? rep.validationMessage + ', ' : '';
                            rep.validationMessage = existing + repErrorMessages.dateRangeGapExists;
                        }
                    }
                    if (rep.isActive && rep.startDate) {
                        var repStart = new Date(rep.startDate);
                        repStart.setHours(0, 0, 0, 0);
                        if (repStart.getTime() === gap.beforeStart.getTime()) {
                            rep.isValid = false;
                            var existing = rep.validationMessage ? rep.validationMessage + ', ' : '';
                            rep.validationMessage = existing + repErrorMessages.dateRangeGapExists;
                        }
                    }
                });
            });
        }

        if (validationStatus) {
            deferred.resolve();
        } else {
            deferred.reject();
        }
        return deferred.promise;
    };

    $scope.validateRepresentatives = function () {
        if (!$scope.representatives) {
            return;
        }

        var repsToSave = JSON.parse(JSON.stringify($scope.representatives));
        repsToSave.forEach((rep) => {
            if (rep.payoutRate) {
                rep.payoutRate = parseFloat((rep.payoutRate / 100).toFixed(10));
            }
            // Remove time from the start and end dates
            rep.startDate = rep.startDate ? new Date(rep.startDate).toLocaleDateString("en-US") : rep.startDate;
            rep.endDate = rep.endDate ? new Date(rep.endDate).toLocaleDateString("en-US") : rep.endDate;

            // Remove temp primary rep value
            rep.representativeTitleId = rep.representativeTitleId == -1 ? null : rep.representativeTitleId;
        });

        if($scope.representatives.length > 0) {
            $scope.validateUIRepresentatives().then(
                function success(result) {
                    $http.post(`/Portfolio/Clients/Action/ValidateRepresentatives/${$scope.current.householdId}`, repsToSave, { trackerMsg: 'Validating representatives' }).then((response) => {
                        let data = formatRepresentativesData(response.data);
                        $scope.representatives = data;
                        if ($scope.representatives && $scope.representatives.length > 0) {
                            $scope.representatives.forEach((rep) => {
                                if (rep.payoutRate) {
                                    rep.payoutRate = parseFloat(parseFloat(rep.payoutRate * 100).toFixed(2));
                                }
                                if (rep.simpleRep && rep.simpleRep.id === 0) {
                                    rep.simpleRep = null;
                                }
                            });
                        }
                        $scope.groupedReps = buildGroupedRepresentatives($scope.representatives);
                        findRegistrationRepPayoutOverrides();

                        $scope.repSectionChanged();
                    });
                },
                function error(reason) {
                    // Invalid Representative Configuration
                }
            );
        }
    };

    $scope.resetRepresentativeItem = function() {
        if (representativesOriginal && representativesOriginal.length > 0) {
            $scope.representatives = JSON.parse(JSON.stringify(representativesOriginal));
            if ($scope.representatives && $scope.representatives.length > 0) {
                $scope.representatives.forEach((rep) => {
                    if (rep.startDate) {
                        rep.startDate = Date.create(rep.startDate);
                    } else {
                        rep.startDate = null;
                    }
                });
            }
        }

        $scope.groupedReps = buildGroupedRepresentatives($scope.representatives);
        findRegistrationRepPayoutOverrides(); 
        $scope.repDatesHaveChanged = false;

        $scope.repSectionChanged();
    };

    $scope.deleteRepresentativeItem = function(rep) {
        $dialog.confirmAction("<span> Are you sure you want to delete this record?</span>")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    rep.isActive = false;
                    $scope.repDatesHaveChanged = true;
                    $scope.repSectionChanged();
                }
            });
    };

    $scope.undoDeleteRepresentativeItem = function(rep) {
        rep.isActive = true;
        $scope.repDatesHaveChanged = true;
        $scope.repSectionChanged();
    };

    $scope.setSelectedRepItem = function(selected, rep) {
        if (selected && selected.id) {
            rep.representativeId = selected.id;
            rep.simpleRep = selected;
        }
        
        $scope.repSectionChanged();
    };

    $scope.updateRepresentativeEndDate = function (rep) {
        if (rep.isNew) {
            var originals = representativesOriginal || [];

            // Step 1: Reset all end dates to a clean slate
            $scope.representatives.forEach(function(value) {
                var original = originals.find(function(orig) { return orig.id === value.id; });
                if (original) {
                    value.endDate = original.endDate ? Date.create(original.endDate) : null;
                } else if (Date.create(botDate).getTime() === value.startDate?.getTime()) {
                    value.endDate = Date.create(eotDate);
                }
            });

            // Step 2: Identify reps that differ from their original state (not reliant on isNew which is lost after validate)
            var repsToProcess = $scope.representatives
                .filter(function(val) {
                    if (val.startDate == null) return false;
                    var original = originals.find(function(orig) { return orig.id === val.id; });
                    if (!original) return true;
                    var origStart = original.startDate ? Date.create(original.startDate) : null;
                    return (val.startDate)?.format(dateFormat) != origStart?.format(dateFormat);
                })
                .sort(function(a, b) { return new Date(a.startDate) - new Date(b.startDate); });

            // Step 3: Process each changed rep chronologically — split the closest enclosing date range
            repsToProcess.forEach(function(curRep) {
                if (Date.create(botDate).getTime() !== curRep.startDate?.getTime()) {
                    curRep.endDate = null;
                }

                $scope.representatives.forEach(function(value) {
                    if (value === curRep) return;
                    var sDate = new Date(value.startDate);
                    var eDate = new Date(value.endDate);
                    var curStart = new Date(curRep.startDate);
                    if (sDate < curStart && eDate > curStart) {
                        curRep.endDate = value.endDate;
                        value.endDate = Date.create(curRep.startDate).addDays(-1);
                    }
                });

                if (curRep.endDate == null) {
                    var sameStart = $scope.representatives.find(function(val) {
                        return val !== curRep &&
                               (val.startDate)?.format(dateFormat) == (curRep.startDate)?.format(dateFormat) &&
                               val.endDate != null;
                    });
                    if (sameStart) {
                        curRep.endDate = sameStart.endDate;
                    }
                }
            });

            // Step 4: Ensure the trigger rep gets the correct end date from its bundle
            var bundleMate = $scope.representatives.find(function(val) {
                return val !== rep &&
                       (val.startDate)?.format(dateFormat) == (rep.startDate)?.format(dateFormat) &&
                       val.endDate != null;
            });
            if (bundleMate) {
                rep.endDate = bundleMate.endDate;
            }
            var isNewest = $scope.representatives.every(function(val) {
                return val.endDate != null && (rep.startDate)?.format(dateFormat) > (val.endDate)?.format(dateFormat);
            });
            if (isNewest) {
                rep.endDate = Date.create(eotDate);
            }
        }
        $scope.repSectionChanged();
    };

    $scope.repTitleChange = function(rep) {
        rep.isPrimary = rep.representativeTitleId == -1;
        $scope.repSectionChanged();
    };

    $scope.repSectionChanged = function() {
        if ($scope.representatives && $scope.representatives.length > 0) {
            formatRepresentativesData($scope.representatives);
        }

        $scope.repsHaveChanged = true;
    };

    $scope.repChangeHistoryEditNote = function (rep) {
        $dialog.dialog({
            dialogClass: "modal",
            templateUrl: "change-history-notes.html",
            controller: "ChangeHistoryNotesCtrl",
            repChangeHistory: rep,
            rightsHH: $scope.rightsHH,
        })
            .open()
            .then(function (result) {
                rep.notes = result.notes;
            });
    };

    $scope.addChangeHistory = function (chst) {
        if (checkPendingChange()) {
            return;
        }
        if (chst) {
            let hasNewChange = true;
            let asOfDate = new Date(chst.asOfDate).formatted();
            let oldChangeSet = getSameDateChangeSet(asOfDate);
            if (oldChangeSet) {
                chst.changes.forEach((newChange) => {
                    if (newChange.actionType !== 'None') {
                        if (newChange.entityType === 'Representative') {
                            let filteredRep = oldChangeSet.changes.find(oldChange => oldChange.entityType === 'Representative' && oldChange.isPartOfSet);
                            if (filteredRep && !filteredRep.isDeleted && filteredRep.actionType === 'None') {
                                const idx = oldChangeSet.changes.indexOf(filteredRep);
                                oldChangeSet.changes[idx] = newChange;
                                hasNewChange = false;
                            } else if (filteredRep && filteredRep.isDeleted) {
                                filteredRep.isPartOfSet = false;
                                oldChangeSet.changes.push(newChange);
                                hasNewChange = false;
                            }
                        } else {
                            let filterAddlReps = oldChangeSet.changes.findAll((ocs) => ocs.entityType === 'Additional Representative');
                            let addlRepsWithNoneCount = filterAddlReps.findAll((ocs) => ocs.entityType === 'Additional Representative' && ocs.actionType === 'None')?.length;
                            let addlRepsWithDelete = filterAddlReps.findAll((ocs) => ocs.entityType === 'Additional Representative' && (ocs.isDeleted === true))?.length;

                            // // All are type None
                            if (filterAddlReps?.length === addlRepsWithNoneCount) {
                                oldChangeSet.changes = oldChangeSet.changes.filter(newCh => newCh.entityType === 'Representative');
                                chst.changes.filter(newCh => newCh.entityType === 'Additional Representative')?.forEach(addRep => {
                                    oldChangeSet.changes.push(addRep);
                                });
                                hasNewChange = false;
                            }
                            else if (filterAddlReps?.length === addlRepsWithDelete) {
                                filterAddlReps.forEach(addlRep => addlRep.isPartOfSet = false);
                                chst.changes.filter(newCh => newCh.entityType === 'Additional Representative')?.forEach(addRep => {
                                    oldChangeSet.changes.push(addRep);
                                });
                                hasNewChange = false;
                            }
                        }

                    }
                });
            }

            if (hasNewChange) {
                chst.changes.forEach(c => c.isUncommitted = true);
                chst.asOfDate = Date.create(chst.asOfDate);
                $scope.chsts.insert(chst, 0);
            }

            chst.changes.forEach(change => {
                $scope.changesFullSet.push({
                    id: chst.id,
                    clientId: chst.clientId,
                    asOfDate: Date.create(chst.asOfDate),
                    entityType: change.entityType,
                    oldEntityId: change.oldEntityId,
                    oldEntityName: change.oldEntityName,
                    newEntityId: change.newEntityId,
                    oldEntityNumber: change.oldEntityNumber,
                    newEntityNumber: change.newEntityNumber,
                    newEntityName: change.newEntityName,
                    editedBy: change.editedBy,
                    editedDate: change.editedDate,
                    isDeleted: change.isDeleted,
                    isUncommitted: change.isUncommitted,
                    actionType: change.actionType
                });
            });
        }
        $scope.current.showChangeHistory = !$scope.current.showChangeHistory;
    };

    function getSameDateChangeSet(asOfDate) {
        let sameDateChanges = [];
        $scope.chsts.forEach((oldChangeSet) => {
            if (oldChangeSet.asOfDate.formatted() === asOfDate) {
                sameDateChanges.add(oldChangeSet);
            }
        });

        let maxId = 0;
        sameDateChanges.forEach(changeSet => {
            if (changeSet.id > maxId) {
                maxId = changeSet.id;
            }
        });

        return $scope.chsts.find(changes => changes.id === maxId);
    }

    function loadRepresentatives() {
        if ($scope.loadedReps && $scope.representatives && $scope.representatives.length > 0) return;

        var expands = '';
        var isLoadingPortfolio = false;
        $scope.representatives = [];
        $scope.groupedReps = [];
        $scope.currentRepresentatives = [];
        $scope.repOrPayoutRateChanged = false;

        if ($scope.householdGeneral && $scope.householdGeneral.representativeId) {
            expands = 'ClientRepAdditional,additionalRepresentatives';
        } else {
            expands += 'ClientRepAdditional,Portfolio,additionalRepresentatives';
            isLoadingPortfolio = true;
        }

        $http.get(`/Portfolio/Clients/Verbose/${(args.isNew ? "New" : args.ids[0])}?expand=${expands}`, { trackerMsg: 'Loading representatives' }).then((response) => {
            if (isLoadingPortfolio) {
                var hhID = $scope.current.householdId;
        
                if (hhID === 0) {
                    if (args.ids.length > 0) {
                        hhID = args.ids[0];
                    }
                }
        
                if (hhID !== 0) {
                    $http.get(`/Portfolio/Clients/${hhID}/RepSimple`).then((repSimpleResponse) => {
                        $scope.current.selectedRep = repSimpleResponse.data;
                        $scope.householdGeneral = response.data.portfolio;
                        applyHouseholdAdditionalRepresentativesFromVerboseResponse(response.data);
                        householdGeneralOriginal = angular.copy($scope.householdGeneral);
                        householdAdditionalRepresentativesOriginal = angular.copy($scope.householdAdditionalRepresentatives);
                        $http.get("/Portfolio/Representatives/Reptitles")
                            .then(function (titlesResponse) {
                                $scope.current.repTitles = titlesResponse.data;
                                $scope.current.repTitles.unshift({id: -1, name: 'Primary Rep'});
                                setupRepresentatives(response);
                            });
                        $scope.loadedReps = true;
                    });
                } else {
                    $scope.householdGeneral = response.data.portfolio;
                    applyHouseholdAdditionalRepresentativesFromVerboseResponse(response.data);
                    householdGeneralOriginal = angular.copy($scope.householdGeneral);
                    householdAdditionalRepresentativesOriginal = angular.copy($scope.householdAdditionalRepresentatives);
                    $http.get("/Portfolio/Representatives/Reptitles")
                        .then(function (titlesResponse) {
                            $scope.current.repTitles = titlesResponse.data;
                            $scope.current.repTitles.unshift({id: -1, name: 'Primary Rep'});
                            setupRepresentatives(response);
                        });
                    $scope.loadedReps = true;
                }                
            } else {
                applyHouseholdAdditionalRepresentativesFromVerboseResponse(response.data);
                setupRepresentatives(response);
                $scope.loadedReps = true;
            }
        });
    }

    function loadRegistrationRepPayouts() {
        if (!args.isNew && $scope.rightsPortfolioRepresentativePayouts.canRead) {
            $http.get(`/Portfolio/Clients/${args.ids[0]}/RegistrationRepPayouts`, { trackerMsg: 'Loading registration payout overrides' }).then((response) => {
                var repPayouts = response.data;
                if (repPayouts && repPayouts.length > 0) {
                    $scope.repPayoutOverrides = repPayouts;
                    
                    var groupedByReg = repPayouts.sort((a, b) => a.registrationId - b.registrationId).reduce((payoutGroup, payoutObj) => {
                        var startDate = Date.create(payoutObj.startDate);
                        var endDate = Date.create(payoutObj.endDate);
                        var isStart = Date.create(botDate).getTime() === startDate.getTime();
                        var isEndSentinel = Date.create(eotDate).getTime() === endDate.getTime();
                        var dateRange = `${isStart ? 'Start' : startDate.format(dateFormat)} - ${isEndSentinel ? 'Onwards' : endDate.format(dateFormat)}`

                        if (isDateRangeCurrent(startDate, endDate)) {
                            const key = `${payoutObj.registrationId}: ${payoutObj.registrationName} | ${dateRange}`;
                            payoutObj.payoutRate = parseFloat(parseFloat(payoutObj.payoutRate * 100).toFixed(2));
                            payoutGroup[key] = (payoutGroup[key] || []).concat(payoutObj);
                        }

                        return payoutGroup;
                    }, {});

                    $scope.registrationRepPayouts = Object.entries(groupedByReg).map(([key, value]) => ({ header: key, repPayouts: value }));
                    findRegistrationRepPayoutOverrides();
                }
            });
        }
    }

    function setupRepresentatives(response) {
        $scope.current.hasClientRepAdditional = (response.data.clientRepAdditional?.details ?? []).length > 0;
        let data = formatRepresentativesData(response.data.clientRepAdditional?.details ?? []);
        if (data) {
            data.forEach((rep) => {
                rep.isActive = true;
                rep.payoutRate = parseFloat(parseFloat(rep.payoutRate * 100).toFixed(2));
            });
        }

        if (!data || data.length === 0) {
            data = [];
            // we need to automatically stage up a "current" representative history item if no representative history items exist
            var currentRepresentatives = [];

            if ($scope.householdGeneral && $scope.current.selectedRep && $scope.current.selectedRep.id > 0) {
                currentRepresentatives.push({
                    clientId: $scope.current.householdId,
                    representativeId: $scope.current.selectedRep.id,
                    simpleRep: $scope.current.selectedRep,
                    representativeTitleId: null,
                    payoutRate: 100,
                    isPrimary: true,
                    isActive: true,
                    isNew: true,
                    startDate: Date.create(botDate),
                    endDate: Date.create(eotDate)
                });
            }            

            if ($scope.householdAdditionalRepresentatives && $scope.householdAdditionalRepresentatives.length > 0) {
                $scope.householdAdditionalRepresentatives.forEach((additionalRep) => {
                    currentRepresentatives.push({
                        clientId: $scope.current.householdId,
                        representativeId: additionalRep.repId,
                        simpleRep: additionalRep.simpleRep,
                        representativeTitleId: additionalRep.repTitleId,
                        payoutRate: 0,
                        isPrimary: false,
                        isActive: true,
                        isNew: true,
                        ...(!$scope.current.hasClientRepAdditional ? { startDate: Date.create(botDate) }: {}),
                        ...(!$scope.current.hasClientRepAdditional ? { endDate: Date.create(eotDate) }: {})
                    });
                });
            }    
            $scope.representativesCreatedForEdit = !args.isNew;
            representativesDefaultItems = angular.copy(currentRepresentatives);

            data = currentRepresentatives;
        } else {
            // Same window as orion-representative-payout: if portfolio primary is missing from the current date range,
            // add them to history + summary at 0% (must mutate data so groupedReps includes the row, not only currentReps).
            var portfolioPrimaryIdInject = ($scope.householdGeneral && $scope.householdGeneral.representativeId) || ($scope.current.selectedRep && $scope.current.selectedRep.id);
            if (portfolioPrimaryIdInject > 0 && $scope.current.selectedRep && $scope.current.selectedRep.id > 0) {
                var inWindowForPrimary = data.filter(function (rep) {
                    return isDateRangeCurrent(rep.startDate, rep.endDate);
                });
                var hasPrimaryInWindow = inWindowForPrimary.some(function (r) {
                    return r.representativeId === portfolioPrimaryIdInject || r.isPrimary;
                });
                if (!hasPrimaryInWindow) {
                    data.unshift({
                        clientId: $scope.current.householdId,
                        representativeId: portfolioPrimaryIdInject,
                        simpleRep: $scope.current.selectedRep,
                        representativeTitleId: null,
                        payoutRate: 0,
                        isPrimary: true,
                        isActive: true,
                        isNew: false,
                        startDate: Date.create(botDate),
                        endDate: Date.create(eotDate)
                    });
                    formatRepresentativesData(data);
                }
            }
        }

        $scope.representatives = modifyRepTitle(data);
        var currentRecords = data.filter(rep => isDateRangeCurrent(rep.startDate, rep.endDate));
        if (currentRecords.length === 0 && $scope.current.selectedRep && $scope.current.selectedRep.id > 0) {
            currentRecords = [{
                representativeId: $scope.current.selectedRep.id,
                simpleRep: $scope.current.selectedRep,
                payoutRate: 100,
                isPrimary: true,
                isActive: true
            }];
        }
        $scope.currentReps = JSON.parse(JSON.stringify(currentRecords));
        $scope.groupedReps = buildGroupedRepresentatives($scope.representatives);
        findRegistrationRepPayoutOverrides();
        representativesOriginal = formatRepresentativesData(angular.copy($scope.representatives));

        var initialGaps = detectDateRangeGaps($scope.representatives);
        if (initialGaps.length > 0) {
            $scope.errors.push({ type: 'warning', title: 'Warning! ', msg: 'Gaps exist in representative date ranges. Please review the representative change history.' });
        }

        loadRegistrationRepPayouts();
        $scope.repSectionChanged();
    }

    function modifyRepTitle(data) {
        if(data.length > 0) {
            data.forEach((rep) => {
                rep.representativeTitleId = rep.isPrimary ? -1 : rep.representativeTitleId;
            });
        }
        return data;
    }

    $scope.startRecordClicked = function(rep) {
        if (rep.isStartRecord) {
            rep.startDate = null;
            rep.isStartRecord = false;
            $scope.repDatesHaveChanged = true;
        }
    };

    $scope.endDateRecordClicked = function(rep) {
        if (rep.isCurrentRecord) {
            rep.endDate = null;
            rep.isCurrentRecord = false;
            $scope.repDatesHaveChanged = true;
        }
    };

    function onStartDateBlurComplete(rep) {
        if (!rep.startDate) {
            rep.startDate = Date.create(botDate);
            rep.isStartRecord = true;
        } else if (rep.startDate instanceof Date) {
            rep.startDate = Date.create(rep.startDate);
        }
        $scope.repDatesHaveChanged = true;
        $scope.updateRepresentativeEndDate(rep);
    }

    function onEndDateBlurComplete(rep) {
        if (!rep.endDate) {
            rep.endDate = Date.create(eotDate);
            rep.isCurrentRecord = true;
        } else if (rep.endDate instanceof Date) {
            rep.endDate = Date.create(rep.endDate);
        }
        $scope.repDatesHaveChanged = true;
        $scope.repSectionChanged();
    }

    // Watch the isopen because the calendar popup blur fires before setting the model value for the blur methods
    $scope.repStartDateBlur = function(rep) {
        if (rep.startDatePopupOpen) {
            var unwatch = $scope.$watch(function() { return rep.startDatePopupOpen; }, function(isOpen) {
                if (!isOpen) {
                    unwatch();
                    onStartDateBlurComplete(rep);
                }
            });
        } else {
            onStartDateBlurComplete(rep);
        }
    };

    $scope.repEndDateBlur = function(rep) {
        if (rep.endDatePopupOpen) {
            var unwatch = $scope.$watch(function() { return rep.endDatePopupOpen; }, function(isOpen) {
                if (!isOpen) {
                    unwatch();
                    onEndDateBlurComplete(rep);
                }
            });
        } else {
            onEndDateBlurComplete(rep);
        }
    };

    function findRegistrationRepPayoutOverrides() {
        if ($scope.groupedReps && $scope.groupedReps.length > 0 && $scope.repPayoutOverrides && $scope.repPayoutOverrides.length > 0) {
            $scope.repPayoutOverrides.forEach((repPayoutOverride) => {
                var startDate = Date.create(repPayoutOverride.startDate);
                var endDate = Date.create(repPayoutOverride.endDate);
                var isStart = Date.create(botDate).getTime() === startDate.getTime();
                var isCurrent = Date.create(eotDate).getTime() === endDate.getTime();
                var dateRange = `${isStart ? 'Start' : startDate.format(dateFormat)} - ${isCurrent ? 'Onwards' : endDate.format(dateFormat)}`
                
                if ($scope.groupedReps && $scope.groupedReps.length > 0) {
                    var groupedRepHasRegistrationOverrides = $scope.groupedReps.find((groupedRep) => {
                        return groupedRep.header === dateRange;
                    });

                    if (groupedRepHasRegistrationOverrides) {
                        groupedRepHasRegistrationOverrides.hasRegistrationOverrides = true;
                    }
                }
            });
        }
    }

    function buildGroupedRepresentatives(reps) {
        var groupedReps = [];
        if (reps && reps.length > 0) {
            groupedReps = reps.sort((a, b) => b.startDate?.getTime() - a.startDate?.getTime()).reduce((repGroup, repObj) => {
                if(!$scope.current.hasClientRepAdditional) { // Set Default Start and Current dates
                    repObj.startDate = repObj.startDate == null ? Date.create(botDate) : repObj.startDate;
                    repObj.endDate = repObj.endDate == null ? Date.create(eotDate) : repObj.endDate;
                }
                var startDate = Date.create(repObj.startDate);
                var endDate = Date.create(repObj.endDate);
                var isStart = Date.create(botDate).getTime() === startDate.getTime();
                var isCurrent = Date.create(eotDate).getTime() === endDate.getTime();
                var dateRange = `${isStart ? 'Start' : startDate.format(dateFormat)} - ${isCurrent ? 'Onwards' : endDate.format(dateFormat)}`

                const key = `${repObj.isNew ? 'New' : dateRange}`;
                repGroup[key] = (repGroup[key] || []).concat(repObj);

                return repGroup;
            }, {});
        }

        return Object.entries(groupedReps).map(([key, value]) => ({ header: key, reps: value }))
    }

    function formatRepresentativesData(data) {
        if (data) {
            data.forEach((rep) => {
                rep.startDate = rep.startDate ? Date.create(rep.startDate) : null; 
                rep.endDate = rep.endDate ? Date.create(rep.endDate) : null;
                const tRepTitle = $scope.current.repTitles.find(r => r.id === rep.representativeTitleId);
                if (tRepTitle && tRepTitle.id > 0) {
                    rep.repTitleName = tRepTitle.name
                }

                if (rep.startDate) {
                    rep.isStartRecord = Date.create('1/1/1900').getTime() === rep.startDate.getTime();
                }
                if (rep.endDate) {
                    rep.isCurrentRecord = Date.create('12-31-9999').getTime() === rep.endDate.getTime();
                }
                if(rep.isPrimary) { // set temp primary rep
                    rep.representativeTitleId = -1;
                } else if(rep.representativeTitleId == -1) {
                    rep.isPrimary = true;
                }

                if (rep.id < 0) {
                    rep.createdBy = null;
                    rep.createdDate = null;
                    rep.editedBy = null;
                    rep.editedDate = null;
                } 
            });
        }

        return data;
    }

    function detectDateRangeGaps(reps) {
        var activeReps = (reps || []).filter(function(rep) {
            return rep.isActive && rep.startDate && rep.endDate;
        });
        if (activeReps.length === 0) return [];

        var dateRanges = [];
        var seen = {};
        activeReps.forEach(function(rep) {
            var start = new Date(rep.startDate);
            var end = new Date(rep.endDate);
            start.setHours(0, 0, 0, 0);
            end.setHours(0, 0, 0, 0);
            var key = start.getTime() + '-' + end.getTime();
            if (!seen[key]) {
                seen[key] = true;
                dateRanges.push({ startDate: start, endDate: end });
            }
        });

        if (dateRanges.length < 2) return [];

        dateRanges.sort(function(a, b) { return a.startDate.getTime() - b.startDate.getTime(); });

        var gaps = [];
        for (var i = 0; i < dateRanges.length - 1; i++) {
            var expectedNextDay = new Date(dateRanges[i].endDate);
            expectedNextDay.setDate(expectedNextDay.getDate() + 1);

            if (expectedNextDay.getTime() < dateRanges[i + 1].startDate.getTime()) {
                gaps.push({
                    afterEnd: dateRanges[i].endDate,
                    beforeStart: dateRanges[i + 1].startDate
                });
            }
        }

        return gaps;
    }

    function loadChangeHistory() {
        if ($scope.chsts) return;

        var promises = { clientChanges: $http.get("/Portfolio/ClientChanges/" + args.ids[0], { trackerMsg: 'Loading change history' }) };
        promises.addlRepsPercent = $http.get("/Portfolio/Clients/" + args.ids[0] + "/AdditionalRepresentativesPercent", { trackerMsg: 'Loading additional representatives percent' });

        $q.all(promises)
            .then(function (response) {
                const data = response.clientChanges.data;
                data.forEach(function (chghst) {
                    chghst.asOfDate = Date.create(chghst.asOfDate);
                    chghst.editedDate = Date.create(chghst.editedDate);
                    chghst.isUncommitted = false;
                });

                additionalRepsPercent = response.addlRepsPercent.data?.map(arp => arp.representativeId);

                $scope.chsts = data;
                $scope.changesFullSet = [];

                $scope.chsts.forEach(chst => {
                    chst.changes.forEach(change => {
                        change.isUncommitted = false;
                        $scope.changesFullSet.push({
                            id: chst.id,
                            clientId: chst.clientId,
                            asOfDate: chst.asOfDate,
                            entityType: change.entityType,
                            oldEntityName: change.oldEntityName,
                            oldEntityNumber: change.oldEntityNumber,
                            oldEntityId: change.oldEntityId,
                            newEntityName: change.newEntityName,
                            newEntityNumber: change.newEntityNumber,
                            newEntityId: change.newEntityId,
                            editedBy: change.editedBy,
                            editedDate: change.editedDate,
                            isDeleted: change.isDeleted,
                            isUncommitted: change.isUncommitted,
                            actionType: change.actionType
                        });
                    });
                });

                changeHistoryOriginal = angular.copy($scope.chsts);
            });
    }

    function checkPendingChange() {
        if ($scope.changesFullSet?.filter(ch => ch.isUncommitted === true)?.length > 0) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Pending Changes",
                "There's a pending change.  Please save before continuing.")
                .open();

            return true;
        }

        return false;
    }

    $scope.deleteChangeHistory = function (chst) {
        if (checkPendingChange()) {
            return;
        }
        // Check Rep Percent
        $dialog.confirmAction("<span> Are you sure you want to delete this record?</span>")
            .open()
            .then(function (result) {
                if (result === 'yes') {

                    if ($scope.changesFullSet.filter(ch => ch.asOfDate > chst.asOfDate && ch.actionType != 'None' && !ch.isDeleted).length > 0) {
                        var month = chst.asOfDate.getMonth() + 1;
                        var day = chst.asOfDate.getDate();
                        var year = chst.asOfDate.getFullYear() >= 2000 ? chst.asOfDate.getYear() - 100 : chst.asOfDate.getYear();

                        $dialog.actionFailed(`Change history that is after ${month}/${day}/${year} must be deleted first.`).open();
                        return;
                    }

                    // Check saved change for rep with percent assigned
                    if (chst.isUncommitted === false) {
                        chst.isDeleted = true;
                        const changeSet = $scope.chsts.find(ch => ch.id === chst.id && ch.asOfDate === chst.asOfDate);
                        if (changeSet) {
                            let change = changeSet.changes.find(chg => chg.entityType === chst.entityType && (chst.editedDate === chg.editedDate) && (chg.newEntityId ? chg.newEntityId : 0) === (chst.newEntityId ? chst.newEntityId : 0) && (chg.oldEntityId ? chg.oldEntityId : 0) === (chst.oldEntityId ? chst.oldEntityId : 0));
                            if (change) {
                                change.isDeleted = true;
                                change.isUncommitted = true;
                            }
                            let pending = $scope.changesFullSet?.find(chg => chg.entityType === chst.entityType && (chst.editedDate === chg.editedDate) && (chg.newEntityId ? chg.newEntityId : 0) === (chst.newEntityId ? chst.newEntityId : 0) && (chg.oldEntityId ? chg.oldEntityId : 0) === (chst.oldEntityId ? chst.oldEntityId : 0));

                            if (pending) {
                                pending.isDeleted = true;
                                pending.isUncommitted = true;
                            }
                        }
                    }
                }
            });
    };

    function loadRepForClient() {
        if ($scope.current.selectedRep) {
            return;
        }

        var hhID = $scope.current.householdId;

        if (hhID === 0) {
            if (args.ids.length > 0) {
                hhID = args.ids[0];
            }
        }

        if (hhID === 0) return;

        $http.get(`/Portfolio/Clients/${hhID}/RepSimple`)
            .then(function (response) {
                $scope.current.selectedRep = response.data;
            });

    }

    function loadRepTitles() {
        if ($scope.current.repTitles) return;

        $http.get("/Portfolio/Representatives/Reptitles")
            .then(function (response) {
                $scope.current.repTitles = response.data;
                if ($scope.isNewRepSplitFlagEnabled && $scope.isRepPayoutPercentEnabled) {
                    $scope.current.repTitles.unshift({id: -1, name: 'Primary Rep'});
                } 
            });
    }


    // PRIVATE METHODS - LOAD DOCUMENTS AND NOTES
    function loadNotes() {
        if ($scope.householdNotes) return;

        $http.get("/Portfolio/Clients/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=notes", { trackerMsg: 'Loading notes' })
            .then(function (response) {
                $scope.householdNotes = response.data.notes;
                householdNotesOriginal = angular.copy($scope.householdNotes);
            });
    }

    function loadDocuments() {
        if ($scope.householdDocuments) return;

        $http.get("/Portfolio/Clients/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=documents", { trackerMsg: 'Loading documents' })
            .then(function (response) {
                $scope.householdDocuments = response.data.documents;
                householdDocumentsOriginal = angular.copy($scope.householdDocuments);
            });
    }


    // PRIVATE METHODS - LOAD HOUSEHOLD MEMBERS
    function loadHouseholdMembers() {
        if ($scope.householdHHMembers) return;

        $http.get("/Portfolio/Clients/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=householdMembers", { trackerMsg: 'Loading household members' })
            .then(function (response) {
                $scope.householdHHMembers = response.data.householdMembers;
                householdHHMembersOriginal = angular.copy($scope.householdHHMembers);
            });
    }

    // PRIVATE METHODS - LOAD SUITABILITY
    function loadSuitability() {
        if ($scope.householdSuitability) return;

        $http.get("/Portfolio/Clients/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=suitability", { trackerMsg: 'Loading suitability' })
            .then(function (response) {
                $scope.householdSuitability = response.data.suitability;
                $scope.setBondPercent();
                householdSuitabilityOriginal = angular.copy($scope.householdSuitability);
            });
    }

    //PRIVATE METHODS - PORTFOLIO GROUPS
    function buildPgHelperAccounts(registrationsAndAccounts, expandedByDefault) {
        const types = $scope.pgHelper.types.list;

        const sections = [
            {name: 'Internal', isExpanded: expandedByDefault, allowedTypes: types.join(), allowRegistrations: true, registrations: []},
            {name: 'Associated Registrations', isExpanded: expandedByDefault, allowedTypes: types.exclude('Composite').join(), allowRegistrations: true, registrations: []},
            {name: 'Associated Accounts', isExpanded: true, allowedTypes: types.exclude('Composite').join(), allowRegistrations: false, registrations: []},
        ];

        registrationsAndAccounts.forEach(registration => {
            const section = sections.find({name: registration.isAdditional ? 'Associated Registrations' : registration.clientId !== $scope.current.householdId ? 'Associated Accounts' : 'Internal'});

            registration.isExpanded = section.isExpanded;
            section.registrations.push(registration);
        });

        return sections.exclude(section => section.registrations.length === 0);
    }

    function isTradingPortfolioGroup(portfolioGroup) {
        return portfolioGroup.portfolioType.includes('Trading');
    }

    function setPortfolioGroupDisabledState(portfolioGroup) {
        portfolioGroup.isDisabled = isTradingPortfolioGroup(portfolioGroup) && !$scope.rightsChangeTradingPortfolioGroups.canRead;
    }

    function loadPortfolioGroups() {
        if ($scope.portfolioGroups) {
            return;
        }

        if (args.isNew) {
            $scope.portfolioGroups = [];
            portfolioGroupsOriginal = [];
            return;
        }

        $q.all({
            verbose: $http.get(`/Portfolio/Clients/Verbose/${$scope.current.householdId}?expand=portfolioGroups`, { trackerMsg: 'Loading portfolio groups' }),
            registrationsAndAccounts: $http.get(`/Portfolio/Clients/${$scope.current.householdId}/Registrations/Simple?includeAccounts=true&includeAdditionalAccounts=true`, { trackerMsg: 'Loading registrations and accounts' }),
            dbeo: $http.get('/Settings/EntityOptions/Database/0/69PGRegistration/Value', { cache: true, trackerMsg: 'Loading portfolio group settings' })
        }).then(responses => {
            $scope.pgHelper.accounts = buildPgHelperAccounts(responses.registrationsAndAccounts.data, responses.dbeo.data.value === 'False');

            $scope.portfolioGroups = responses.verbose.data.portfolioGroups.map(pg => {
                setPortfolioGroupDisabledState(pg);

                // strip these down and sort so the original copy is easier to compare for changes
                pg.accounts = pg.accounts.map(account => ({accountId: account.accountId})).sortBy('accountId');
                pg.registrationIds = pg.registrationIds.sort();
                return pg;
            });
            syncPortfolioGroupEntitiesToAssignments();
            portfolioGroupsOriginal = angular.copy($scope.portfolioGroups);
        });
    }

    function syncPortfolioGroupEntitiesToAssignments() {
        $scope.portfolioGroups.forEach(pg => {
            pg.assignments = {registrations: {}, accounts: {}};

            $scope.pgHelper.accounts.forEach(section => {
                section.registrations.forEach(registration => {
                    pg.assignments.registrations[registration.id] = pg.registrationIds.any(registration.id);

                    registration.accounts.forEach(account => {
                        pg.assignments.accounts[account.id] = pg.accounts.any({accountId: account.id});
                    });
                });
            });
        });
    }

    function syncAssignmentsToPortfolioGroupEntities() {
        $scope.portfolioGroups.forEach(pg => {
            pg.registrationIds = Object.entries(pg.assignments.registrations)
                .filter(([id, isAssigned]) => isAssigned)
                .map(([id]) => parseInt(id))
                .sort();

            pg.accounts = Object.entries(pg.assignments.accounts)
                .filter(([id, isAssigned]) => isAssigned)
                .map(([id]) => ({accountId: parseInt(id)}))
                .sortBy('accountId');
        });
    }

    function tradingPortfolioGroupAssignmentsChanged() {
        return ($scope.portfolioGroups || []).any(pg => {
            if (!isTradingPortfolioGroup(pg)) {
                return false;
            }

            return !angular.equals(pg.assignments, portfolioGroupsOriginal.find({id: pg.id})?.assignments);
        });
    }

    function checkForPortfolioGroupViolation(allTargetGroups, maxAllowedInGroup, entityType, entity, messages) {
        const assignedTargetGroups = allTargetGroups.filter(pg => pg.assignments[entityType + 's'][entity.id]);

        if (assignedTargetGroups.length > maxAllowedInGroup) {
            const formattedList = assignedTargetGroups.map(pg => `${pg.name} (${pg.id})`).join(', ');
            messages.push(`- ${entityType.capitalize()} <b>${entity.name} (${entity.id})</b> is assigned to: ${formattedList}.`);
            return true;
        }

        return false;
    }

    function getPortfolioGroupAbortMessages(portfolioGroupFilter, accountSectionFilter, maxAllowedInGroup, validationMsg) {
        const messages = [];
        const allTargetGroups = ($scope.portfolioGroups || []).filter(portfolioGroupFilter);

        if (allTargetGroups.length <= maxAllowedInGroup || !$scope.pgHelper.accounts) {
            return messages;
        }

        const sectionsToCheck = $scope.pgHelper.accounts.filter(accountSectionFilter);
        sectionsToCheck.forEach(section => {
            section.registrations.forEach(registration => {
                if (checkForPortfolioGroupViolation(allTargetGroups, maxAllowedInGroup, 'registration', registration, messages)) {
                    return;
                }

                registration.accounts.forEach(account => {
                    checkForPortfolioGroupViolation(allTargetGroups, maxAllowedInGroup, 'account', account, messages);
                });
            });
        });

        return messages.length ? [validationMsg].concat(messages) : [];
    }

    function getAssociatedCompositeGroupAbortMessages() {
        const isCompositePortfolioGroup = pg => pg.portfolioType.includes('Composite');
        const isNonCompositeAccountSection = section => !section.allowedTypes.includes('Composite');

        return getPortfolioGroupAbortMessages(isCompositePortfolioGroup, isNonCompositeAccountSection, 0, 'Associated Accounts cannot be assigned to Composite portfolio groups.');
    }

    function getMultipleTradingGroupAbortMessages() {
        const isAnySection = () => true; // check all sections

        return getPortfolioGroupAbortMessages(isTradingPortfolioGroup, isAnySection, 1, 'Accounts cannot be assigned to multiple Trading portfolio groups.');
    }


    // PRIVATE METHODS - LOAD BILLING GENERAL
    function loadBillingGeneral() {
        if ($scope.billingGeneral) return;

        $http.get("/Settings/Database/EntityOptions/Code/HouseholdDefaultSchedules", { trackerMsg: 'Checking Household Default Schedule Option' })
            .then(function (response) {
                $scope.current.useHouseholdDefaultSchedules = response.data.value === "True";
            });

        $http.get("/Portfolio/Clients/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=billing", { trackerMsg: 'Loading billing' })
            .then(function (response) {
                $scope.billingGeneral = response.data.billing;
                billingGeneralOriginal = angular.copy($scope.billingGeneral);

                $scope.billingRelatedHHs = response.data.billing.relatedClients || [];
                billingRelatedHHsOriginal = angular.copy($scope.billingRelatedHHs);
            });
    }

    //PRIVATE METHODS - ASSIGNMENT EXCLUSION
    function loadAssetExclusion() {
        splitIoService.getBoolTreatment('opex_Billing_UseNewSecurityClass_19909').subscribe((isEnabled) => {
            $scope.isUseNewSecurityClassEnabled = isEnabled;
            if ($scope.isUseNewSecurityClassEnabled && !$scope.assignmentTypes.some(type => type.id === 6)) {
                $scope.assignmentTypes = $scope.assignmentTypes.concat({ propName: 'securityClassification', name: 'Security Classification', id: 6 });
            }
        });
        $http.get('/Portfolio/Clients/Verbose/' + (args.isNew ? "New" : args.ids[0]) + "?expand=assetExclusion", { trackerMsg: 'Loading assignment type' })
            .then(function (response) {
                $scope.assetExclusions = response.data.assetExclusions || [];
                var promises = [];

                if ($scope.isUseNewSecurityClassEnabled) {
                    ($scope.assetExclusions).filter(ax => ax.exclusionType === 6).forEach(function (exclusion) {
                        $scope.getMethodListForDropDown(exclusion, true);
                    });
                }

                var tickerTypes = $scope.assetExclusions?.findAll({ exclusionType: 5 });
                if (tickerTypes) {
                    tickerTypes.forEach(function (ticker) {
                        if (ticker.exclusionValue) {
                            promises.push($http.get("/Global/Products/Verbose/" + ticker.exclusionValue, { trackerMsg: 'Loading product' }));
                        }
                    });

                    $q.all(promises)
                        .then(function (response) {
                            response.forEach(function (res) {
                                var ticker = tickerTypes.find({ exclusionValue: res.data.id });

                                if (ticker) {
                                    ticker.exclusionValue = {
                                        productId: res.data.id,
                                        productName: res.data.name,
                                        productType: res.data.portfolio.productSubTypeId,
                                        ticker: res.data.portfolio.ticker
                                    }
                                }

                            });
                            assetExclusionsOriginal = angular.copy($scope.assetExclusions);
                        });
                } else {
                    assetExclusionsOriginal = angular.copy($scope.assetExclusions);
                }
            });
    }

    function loadFinancialPlanning() {
        $scope.current.billPayMethod = [
            {
                "description": "ACH",
                "isVisible": false,
                "includeInBusinessMetrics": false,
                "isDownloading": false,
                "id": 4,
                "name": "ACH"
            },
            {
                "description": "Check",
                "isVisible": false,
                "includeInBusinessMetrics": false,
                "isDownloading": false,
                "id": 3,
                "name": "Check"
            },
            {
                "description": "Credit Card",
                "isVisible": false,
                "includeInBusinessMetrics": false,
                "isDownloading": false,
                "id": 6,
                "name": "Credit Card"
            },
            {
                "description": "Indirect from Fund",
                "isVisible": false,
                "includeInBusinessMetrics": false,
                "isDownloading": false,
                "id": 2,
                "name": "Indirect"
            }
        ];

        $scope.current.frequencies = [
            { name: 'Monthly', value: 'Monthly' },
            { name: 'Quarterly', value: 'Quarterly' },
            { name: 'Annual', value: 'Annual' },
            { name: 'Semi-Annually', value: 'Semi-Annual' },
            { name: 'Tri-Annually', value: 'Triannual' }
        ];

        if ($scope.financialPlanningFee) {
            $scope.current.wasFinanicalPlanningFeeNull = false;
        }


        if ($scope.financialPlanningFee) return;

        $http.get('/Portfolio/Clients/Verbose/' + (args.isNew ? "New" : args.ids[0]) + "?expand=financialPlanningFee", { trackerMsg: 'Loading financial planning fee' })
            .then(function (response) {
                $scope.financialPlanningFee = response.data.financialPlanningFee;

                if ($scope.financialPlanningFee === null) $scope.financialPlanningFee = undefined;

                if ($scope.financialPlanningFee) {
                    $scope.setCycleMonths($scope.financialPlanningFee.billFrequency);
                    financialPlanningFeeOriginal = angular.copy($scope.financialPlanningFee);
                }

                if (!args.isNew) {
                    $http.get("/Billing/Clients/" + args.ids[0] + "/RelatedAccounts", { trackerMsg: 'Loading accounts for current household' })
                        .then(function (response) {
                            relatedHouseholdAccounts = response.data;

                            relatedHouseholdAccounts.forEach(function (account) {
                                $scope.current.relatedAccounts.push({ id: account.id, name: account.id + ": " + account.number + ' (' + account.name + ')' });
                            });
                        });
                }
            });
    }

    $scope.populateFinancialPlanningFee = function () {
        if ($scope.financialPlanningFee && $scope.current.wasFinanicalPlanningFeeNull === true) {
            $scope.financialPlanningFee = undefined;
        } else {
            $http.get('/Portfolio/Clients/Verbose/' + (args.isNew ? "New" : args.ids[0]) + "?expand=financialPlanningFee", { trackerMsg: 'Loading financial planning fee' })
                .then(function (response) {
                    $scope.financialPlanningFee = response.data.financialPlanningFee;

                    if ($scope.financialPlanningFee === null) {
                        $http.get('/Portfolio/Clients/Verbose/New?expand=financialPlanningFee', { trackerMsg: 'Getting new financial planning fee' })
                            .then(function (res) {
                                $scope.financialPlanningFee = res.data.financialPlanningFee;
                                $scope.setCycleMonths($scope.financialPlanningFee.billFrequency);
                            });
                    } else {
                        $scope.setCycleMonths($scope.financialPlanningFee.billFrequency);
                    }
                });
        }
    };

    $scope.setCycleMonths = function (frequency) {
        switch (frequency) {
            case billFrequency.monthly.name:
                $scope.current.cycleMonths = [{ id: 1, name: 'Every Month' }];
                break;
            case billFrequency.quarterly.name:
                buildCycleMonths(3, ' of Quarter');
                break;
            case billFrequency.semiannually.name:
                buildCycleMonths(6, ' of Cycle');
                break;
            default:
                buildCycleMonths(12, ' of Cycle');
        }
    };

    function buildCycleMonths(upperBound, endText) {
        $scope.current.cycleMonths = [];
        (1).upto(upperBound, function (n) {
            $scope.current.cycleMonths.push({ id: n, name: 'Month ' + n + endText });
        });
    }

    // PRIVATE METHODS - LOAD CREDIT CARD INFO
    function LoadCreditCard() {
        $http.get("/Portfolio/Clients/Verbose/" + args.ids[0] + "?expand=creditCard", { trackerMsg: 'Loading credit card information' })
            .then(function (response) {
                if (response.data.creditCard) {
                    if (response.data.creditCard.ccToken) {
                        if (response.data.creditCard.ccType == "ACH") {
                            //parse the ccNum field
                            var tempCCInfo = response.data.creditCard.ccNum.unescapeURL().split(':');
                            $scope.ccInfo.achAccountType = tempCCInfo[0] == 'C' ? 'checking' : 'savings';
                            $scope.ccInfo.achAccountNum = tempCCInfo[2];
                            $scope.current.ccPaymentType = 'check';
                            $scope.setAchImage();
                        } else {
                            $scope.ccInfo.ccExpiration = null;
                            $scope.ccInfo.ccNumber = response.data.creditCard.ccNum;
                            $scope.ccInfo.cvv2 = response.data.creditCard.ccType.toLowerCase() == 'amex' ? 'xxxx' : 'xxx';
                            $scope.ccInfo.ccType = response.data.creditCard.ccType.toLowerCase();
                            // if($scope.current.ccPaymentType == 'check'){
                            //     $scope.ccInfo.accountType = 'checking';
                            // }
                        }
                        $scope.current.storedPaymentInfo = response.data.creditCard.ccToken ? true : false;
                    }
                }
                $timeout(function () {
                    $scope.current.ccLoading = false;
                }, 550);
            });
    }

    // PRIVATE METHODS - LOAD RECURRING ADJUSTMENTS
    function loadRecurringAdjustments() {
        if ($scope.billingRecurringAdjustments) return;

        $http.get("/Portfolio/Clients/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=recurringAdjustments", { trackerMsg: 'Loading recurring adjustments' })
            .then(function (response) {
                $scope.billingRecurringAdjustments = response.data.recurringAdjustments;
                billingRecurringAdjustmentsOriginal = angular.copy($scope.billingRecurringAdjustments);
            });
    }

    function loadAdjustmentTypes() {
        if ($scope.adjustmentTypes) return;

        $http.get("/Billing/AdjustmentTypes?isPayable=false&isPayableAffect=true", { trackerMsg: 'Loading adjustment types' })
            .then(function (response) {
                $scope.adjustmentTypes = response.data;
            });
    }

    function checkBillingLockdown() {
        $http.get("/Authorization/User/Databases/LockDown", { trackerMsg: 'Checking Billing Lockdown' })
            .then(function (response) {
                let isBillingLockdownOverridePrivilege = $oasRights.forCode("billingLockdownOverride").canRead;
                $scope.isBillingLockdown = isBillingLockdownOverridePrivilege ? false : response.data === 'Billing';
            });
    }

    function loadBillingEntities() {
        if ($scope.billingEntities) return;

        $scope.billingEntities = [{ id: 0, entityName: "<Prorate by Payouts>", name: "<Prorate by Payouts>", isPayableEntity: true }];

        if ($scope.current.householdId && ($scope.rightsBillAppFeePayout.canRead || $scope.rightsPayoutSchedules.canRead)) {
            $http.get("/Billing/MasterPayoutSchedule/BillEntities/ByClient/" + ($scope.current.householdId) + "", { trackerMsg: 'Loading billing entities' })
                .then(function (response) {
                    $scope.billingEntities.add(response.data);
                });
        }
        else {
            $http.get("/Billing/BillingEntities?isActive=true", { trackerMsg: 'Loading billing entities' })
                .then(function (response) {
                    $scope.billingEntities.add(response.data);
                });
        }

    }


    // PRIVATE METHODS - LOAD FEE PAYING ACCOUNTS
    function loadFeePayingAccounts() {
        if ($scope.billingFeePayingAccounts) return;

        $http.get("/Portfolio/Clients/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=feePayingAccounts", { trackerMsg: 'Loading fee paying accounts' })
            .then(function (response) {
                response.data.feePayingAccounts.forEach(function (acct) {
                    acct.payPercent = (acct.payPercent * 100).round(3);
                });

                $scope.billingFeePayingAccounts = response.data.feePayingAccounts;
                billingFeePayingAccountsOriginal = angular.copy($scope.billingFeePayingAccounts);
            });
    }

    // PRIVATE METHODS - LOAD TIERED FEE ACCOUNTS
    function loadRelatedHouseholdAccounts() {
        if ($scope.current.relatedHouseholdAccounts || args.isNew) return;

        $http.get("/Billing/Clients/" + args.ids[0] + "/RelatedAccounts", { trackerMsg: 'Loading accounts for current household' })
            .then(function (response) {
                $scope.current.relatedHouseholdAccounts = response.data;
                $scope.current.relatedHouseholdAccounts.forEach(function (account, index) {
                    account.tieredFeePriority = index + 1;
                })
            });
    }

    function loadTieredFeePriority() {
        $http.get("/Portfolio/Clients/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=tieredFeeAccounts", { trackerMsg: 'Loading tiered fee accounts' })
            .then(function (response) {
                $scope.tieredFeeAccounts = response.data.tieredFeeAccounts;
                tieredFeeAccountsOriginal = angular.copy($scope.tieredFeeAccounts);
            });
    }

    // PRIVATE METHODS - LOAD ENTITY OPTIONS
    function loadEntityOptions() {
        if ($scope.entityOptions) return;

        $http.get("/Settings/EntityOptions/Clients/" + args.ids[0], { trackerMsg: 'Loading options' })
            .then(function (response) {
                $scope.entityOptions = response.data;
                $portfolio.cleanCustomFields($scope.entityOptions);
                entityOptionsOriginal = angular.copy($scope.entityOptions);
            });
    }


    // PRIVATE METHODS - LOAD CUSTOM FIELDS
    function loadCustomFields() {
        if ($scope.customFields) return;

        $http.get($scope.current.isNew ? '/Settings/UserDefinedFields/Definitions/Client' : '/Portfolio/Clients/' + args.ids[0] + '/UserDefinedFields', { trackerMsg: 'Loading custom fields' })
            .then(function (response) {
                if ($scope.current.isNew) {
                    $scope.customFields = response.data.map(function (definition) {
                        return $portfolio.makeCustomFieldFromDefinition(definition, "Household");
                    });
                } else {
                    $scope.customFields = response.data;
                }

                $portfolio.cleanCustomFields($scope.customFields);
                customFieldsOriginal = angular.copy($scope.customFields);
            });
    }


    //PRIVATE METHODS - LOAD TARGET ALLOCATIONS
    function loadTargetAllocations() {
        if ($scope.targetAllocations) return;

        $http.get("/Portfolio/Clients/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=targetAllocations", { trackerMsg: 'Loading household target allocations' })
            .then(function (response) {
                var data = response.data;
                if (data.targetAllocations.length > 0) {
                    getGroupingValue(data.targetAllocations)
                        .then(function (groupingValueResponse) {
                            $scope.groupingOptions = groupingValueResponse.data;

                            $scope.targetAllocations = data.targetAllocations;
                            $scope.targetAllocations.each(function (item) {
                                item.entityName = loadGroupingName(item.entityId, item.entity);
                            });
                            targetAllocationsOriginal = angular.copy($scope.targetAllocations);
                        });
                }
                else {
                    $scope.targetAllocations = [];
                    targetAllocationsOriginal = angular.copy($scope.targetAllocations);
                }
            });
    }

    function loadTargetAllocationGroupings() {
        if ($scope.targetAllocationGroupings) {
            return;
        }

        $http.get("/Portfolio/Clients/TargetAllocationGroupings", {trackerMsg:'Loading target allocation groupings'})
            .then(function (response) {
                $scope.targetAllocationGroupings = response.data;
            });
    }

    function getGroupingValue(targetAllocations) {
        var entityName = targetAllocations[0].entity;

        if (targetAllocations[0].userDefinedFieldDefinitionId) {
            $scope.current.targetAllocationType = 'udf:' + targetAllocations[0].userDefinedFieldDefinitionId;
            return $http.get('/Portfolio/Clients/TargetAllocationUserDefinedFieldValues/Simple?fieldDefinitionId=' + targetAllocations[0].userDefinedFieldDefinitionId, { trackerMsg: 'Loading custom field grouping values' });
        }

        if (entityName === 32 || entityName === '32') {
            return $http.get("/Portfolio/Clients/TargetAllocationGroupings", { trackerMsg: 'Loading target allocation groupings' })
                .then(function (response) {
                    $scope.targetAllocationGroupings = response.data;
                    return { data: [] };
                });
        }

        if (String(entityName).includes('Security Classification')) {
            $scope.current.targetAllocationType = entityName;
            return $http.get('/Portfolio/SecurityClassification/Local/SecurityClasses/Simple?entity=' + entityName, {cache: true, trackerMsg: 'Loading security classes'});
        }

        var entity = entities[entities.find({ name: entityName })] || entities[entities.find({ value: String(entityName) })];
        $scope.current.targetAllocationType = entity?.name || entityName;

        if ($scope.current.targetAllocationType === entities.product.name) {
            const ids = targetAllocations.map("entityId");
            return $http.post("/Portfolio/Products/List/Id", ids, { trackerMsg: 'Loading Product Grouping', allowCancellation: true });
        }

        return $http.get(entity.simpleUrl, { trackerMsg: 'Loading grouping information' });
    }

    function isUserDefinedFieldTargetAllocationType(groupingType) {
        return groupingType != null && String(groupingType).indexOf('udf:') === 0;
    }

    function loadGroupingName(entityId, entityName) {
        if (entityName === entities.product.name) {
            var product = $scope.groupingOptions.find({ id: entityId });
            return product.ticker + " (" + product.productName + ")";
        } else {
            return $scope.groupingOptions.find({ id: entityId }).name;
        }
    }

    // PUBLIC METHODS
    $scope.loadTab = function (child) {
        $scope.menu.categories.each(function (c) {
            c.children.each(function (ch) {
                ch.active = ch.code == child.code;
            });
        });

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab();
    };

    $scope.save = function () {
        $scope.isSaving = true;

        if ($scope.householdGeneral?.emailInvalid)  {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid email",
                "The household contact email address is invalid.")
                .open();

            $scope.isSaving = false;
            return;
        }

        if ($scope.ccInfo?.emailInvalid) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid email",
                "The credit card email address is invalid.")
                .open();

            $scope.isSaving = false;
            return;
        }

        splitIoService.getBoolTreatment("recon_datasharing_editwarningmessages_7285")
            .subscribe(isEnabled => {
                if ($scope.isDataSharingEntity && isEnabled) {
                    $dialog.confirmAction("Household is a data sharing Household. Changes are likely to be reverted by subsequent syncs.  Would you still like to proceed?")
                        .open()
                        .then(result => {
                            if (result === 'yes') {
                                promptForPortfolioGroupEclipseChanges();
                            }
                        });
                } else {
                    promptForPortfolioGroupEclipseChanges();
                }
            });
    };

    function promptForPortfolioGroupEclipseChanges() {
        if (tradingPortfolioGroupAssignmentsChanged()) {
            $dialog.confirmAction("You have made changes to one or more Trading portfolio groups.  If you have linked portfolios in Eclipse, this will edit your portfolio group in Eclipse and may remove portfolio level preferences.  You can log in to Eclipse to edit your preferences after this change takes place.<br /><br />  Do you want to continue?")
                .open()
                .then(result => {
                    if (result === 'no') {
                        $scope.isSaving = false;
                        return;
                    }

                    saveAll();
                });
        } else {
            saveAll();
        }
    }

    function saveAll() {
        if (($scope.isNewRepSplitFlagEnabled && $scope.isRepPayoutPercentEnabled) && $scope.representatives && $scope.representatives.length > 0 && $scope.repsHaveChanged) {
            var repsToSave = JSON.parse(JSON.stringify($scope.representatives));
            var needsToSaveReps = JSON.parse(JSON.stringify(repsToSave));

            if (repsToSave && repsToSave.length > 0) {
                if ($scope.representativesCreatedForEdit) {
                    repsToSave.forEach((rep) => {
                        rep.startDate = rep.startDate ? Date.create(rep.startDate) : null;
                        rep.endDate = rep.endDate ? Date.create(rep.endDate) : null;
                        var defaultCreatedRep = representativesDefaultItems.findIndex((repDefault) => {
                            return repDefault.representativeId === rep.representativeId && repDefault.representativeTitleId === rep.representativeTitleId && 
                                repDefault.isPrimary === rep.isPrimary && repDefault.payoutRate === rep.payoutRate && repDefault.notes === rep.notes && repDefault.isActive === rep.isActive
                        });
                        if (defaultCreatedRep > -1) {
                            needsToSaveReps.splice(0, 1);
                        }
                    });
                }
            }

            if (repsToSave && repsToSave.length > 0 && needsToSaveReps && needsToSaveReps.length > 0) {
                if ($scope.repDatesHaveChanged) {
                    var gapsOnSave = detectDateRangeGaps($scope.representatives);
                    if (gapsOnSave.length > 0) {
                        gapsOnSave.forEach(function(gap) {
                            $scope.representatives.forEach(function(rep) {
                                if (rep.isActive && rep.endDate) {
                                    var repEnd = new Date(rep.endDate);
                                    repEnd.setHours(0, 0, 0, 0);
                                    if (repEnd.getTime() === gap.afterEnd.getTime()) {
                                        rep.isValid = false;
                                        var existing = rep.validationMessage ? rep.validationMessage + ', ' : '';
                                        rep.validationMessage = existing + repErrorMessages.dateRangeGapExists;
                                    }
                                }
                                if (rep.isActive && rep.startDate) {
                                    var repStart = new Date(rep.startDate);
                                    repStart.setHours(0, 0, 0, 0);
                                    if (repStart.getTime() === gap.beforeStart.getTime()) {
                                        rep.isValid = false;
                                        var existing = rep.validationMessage ? rep.validationMessage + ', ' : '';
                                        rep.validationMessage = existing + repErrorMessages.dateRangeGapExists;
                                    }
                                }
                            });
                        });
                        $scope.groupedReps = buildGroupedRepresentatives($scope.representatives);
                        findRegistrationRepPayoutOverrides();
                        $scope.repSectionChanged();

                        $scope.errors.push({ type: 'error', title: 'Unsaved Changes!', msg: 'Representative date changes have introduced gaps in date ranges. Dates must be continuous with no gaps.', showAllowClose: true });
                        $scope.isSaving = false;
                        return;
                    }
                }

                repsToSave.forEach((rep) => {
                    if (rep.payoutRate) {
                        rep.payoutRate = parseFloat((rep.payoutRate / 100).toFixed(10));
                    }
                    // Remove time from the start and end dates
                    rep.startDate = rep.startDate ? new Date(rep.startDate).toLocaleDateString("en-US") : rep.startDate;
                    rep.endDate = rep.endDate ? new Date(rep.endDate).toLocaleDateString("en-US") : rep.endDate;

                    // Remove temp primary rep value
                    rep.representativeTitleId = rep.representativeTitleId == -1 ? null : rep.representativeTitleId;
                });

                $http.post(`/Portfolio/Clients/Action/ValidateRepresentatives/${$scope.current.householdId}`, repsToSave, { trackerMsg: 'Validating representatives' }).then((response) => {
                    let data = formatRepresentativesData(response.data);
                    repsToSave = JSON.parse(JSON.stringify(data));
                    
                    if (data && data.length > 0) {
                        data.forEach((rep) => {
                            if (rep.payoutRate) {
                                rep.payoutRate = parseFloat(parseFloat(rep.payoutRate * 100).toFixed(2));
                            }
                        });
                    }

                    const repsHasInvalid = repsToSave.filter((rep) => rep.isValid === false);
                    if (repsHasInvalid && repsHasInvalid && repsHasInvalid.length > 0) {
                        $scope.representatives = data;
                        $scope.groupedReps = buildGroupedRepresentatives($scope.representatives);
                        findRegistrationRepPayoutOverrides();
                        $scope.repSectionChanged();

                        $scope.errors.push({ type: 'error', title: 'Unsaved Changes!', msg: 'Representatives configuration is invalid', showAllowClose: true })
                        $scope.isSaving = false;
                        return;
                    } else {
                        repsToSave.forEach((rep) => {
                            rep.startDate = rep.startDate ? new Date(rep.startDate).toLocaleDateString("en-US") : rep.startDate;
                            rep.endDate = rep.endDate ? new Date(rep.endDate).toLocaleDateString("en-US") : rep.endDate;
                        });
                        
                        saveHouseholdAll(repsToSave);
                    }
                }).catch(() => {
                    $scope.isSaving = false;
                });
            } else {
                saveHouseholdAll();
            }
        } else {
            saveHouseholdAll();
        }
    }

    function saveHouseholdAll(repsToSave) {
        const verboseHH = {};
        const promises = [];
        const abortMessages = [];

        if ($scope.useSharedTargetAllocationEditor && $scope.targetAllocations && $scope.targetAllocations.length > 0) {
            targetAllocationSaveValidator.validateRows($scope.targetAllocations).forEach(function (m) {
                abortMessages.push(m);
            });
        }
        else if ($scope.targetAllocations && $scope.targetAllocations.length > 0 && !$scope.targetAllocations.sum('weight').almostEquals(100)) {
            abortMessages.push("Account target allocation must equal 100%.");
        }

        if ($scope.current.selectedRep && $scope.householdAdditionalRepresentatives.length > 0) {
            let allRepIds = $scope.householdAdditionalRepresentatives.map(a => a.repId);
            allRepIds.push($scope.current.selectedRep.id);
            let findDuplicates = arr => arr.filter((item, index) => arr.indexOf(item) != index);
            if (findDuplicates(allRepIds).length > 0) {
                abortMessages.push("Duplicate Representative assigned.");
            }
        }

        if ($scope.assetExclusions?.findAll({ exclusionType: 5 }).some(ax => typeof ax.exclusionValue === 'undefined' || ax.exclusionValue === null || typeof ax.exclusionValue.productId === 'undefined' || ax.exclusionValue.productId === null)) {
            abortMessages.push("Category is not assigned to Excluded Ticker Assets.");
        }

        abortMessages.add(getAssociatedCompositeGroupAbortMessages());
        abortMessages.add(getMultipleTradingGroupAbortMessages());

        if (abortMessages.length > 0) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Data", '<ul class="unstyled"><li>' + abortMessages.join("</li><li>") + '</li></ul>').open();
            $scope.isSaving = false;
            return;
        }

        if ($scope.householdGeneral && (!angular.equals(householdGeneralOriginal, $scope.householdGeneral) || ($scope.current.selectedRep && $scope.current.selectedRep != householdGeneralOriginal.representativeId))) {
            verboseHH["portfolio"] = angular.copy($scope.householdGeneral);

            //HACK: if you're in India, for example, the timezone makes the date off by one
            if (verboseHH["portfolio"].dob) {
                verboseHH["portfolio"].dob = Date.create(verboseHH["portfolio"].dob).formatted();
            }

            if ($scope.current.selectedRep) {
                verboseHH["portfolio"].representativeId = $scope.current.selectedRep.id;
            }
        }

        if ($scope.portfolioGroups && !angular.equals(portfolioGroupsOriginal, $scope.portfolioGroups)) {
            syncAssignmentsToPortfolioGroupEntities();
            verboseHH.portfolioGroups = $scope.portfolioGroups;
        }

        if ($scope.householdNotes && !angular.equals(householdNotesOriginal, $scope.householdNotes)) verboseHH["notes"] = $scope.householdNotes;

        if ($scope.householdDocuments && !angular.equals(householdDocumentsOriginal, $scope.householdDocuments)) verboseHH["documents"] = $scope.householdDocuments;

        if ($scope.isNewRepSplitFlagEnabled && $scope.isRepPayoutPercentEnabled) {
            if (repsToSave && repsToSave.length > 0) {
                var formattedRepsToSave = JSON.parse(JSON.stringify(repsToSave));
                formattedRepsToSave.forEach((rep) => {
                    if (rep.startDate) {
                        rep.startDate = Date.create(rep.startDate);
                    }
                    if (rep.endDate) {
                        rep.endDate = Date.create(rep.endDate);
                    }
                    delete rep.simpleRep;
                });
                
                var formattedOriginalsForCompare = JSON.parse(JSON.stringify(representativesOriginal || []));
                formattedOriginalsForCompare.forEach((rep) => {
                    rep.isValid = true;
                    rep.payoutRate = parseFloat((rep.payoutRate / 100).toFixed(10));
                    delete rep.simpleRep;
                });

                if (!angular.equals(formattedOriginalsForCompare, formattedRepsToSave)) {
                    verboseHH['clientRepAdditional'] = { appendOnly: false, details: repsToSave };
                    verboseHH['additionalRepresentatives'] = angular.copy($scope.householdAdditionalRepresentatives || []);
                }
            }
        }

        var hhMemberSSNPromises = [];
        if ($scope.householdHHMembers && !angular.equals(householdHHMembersOriginal, $scope.householdHHMembers)) {
            $scope.householdHHMembers.forEach(function (member) {
                if (member.dob) {
                    member.dob = Date.create(member.dob).formatted();
                }

                if (member.id == 0) {
                    member.id = null;
                } else if (member.ssnEditReason) {
                    hhMemberSSNPromises.push($http.put('/Portfolio/Clients/' + args.ids[0] + '/HouseholdMembers/' + member.id + '/SSNTaxId', { ssN: member.ssN_TaxID, reason: member.ssnEditReason }, { trackerMsg: 'Saving SSN/Tax ID information' }))
                }
            });
            verboseHH["householdMembers"] = $scope.householdHHMembers;
        }

        for (const [list, verboseSection] of Object.entries({householdAdditionalRegs: 'additionalRegistrations', householdAdditionalAccounts: 'additionalAccounts'})) {
            if ($scope[list] && !angular.equals(original[list], $scope[list])) {
                verboseHH[verboseSection] = JSON.parse(JSON.stringify($scope[list]));
            }
        }

        if ($scope.householdAdditionalRepresentatives && !angular.equals(householdAdditionalRepresentativesOriginal, $scope.householdAdditionalRepresentatives)) {
            if ($scope.isNewRepSplitFlagEnabled && $scope.isRepPayoutPercentEnabled) {
                if (!verboseHH['clientRepAdditional']) {
                    verboseHH['clientRepAdditional'] = { appendOnly: false, details: buildClientRepAdditionalPayload() };
                }
                verboseHH['additionalRepresentatives'] = angular.copy($scope.householdAdditionalRepresentatives);
            } else {
                verboseHH["additionalRepresentatives"] = $scope.householdAdditionalRepresentatives;
            }
        }

        if ($scope.householdSuitability && !angular.equals(householdSuitabilityOriginal, $scope.householdSuitability)) verboseHH["suitability"] = $scope.householdSuitability;

        if ($scope.billingGeneral && !angular.equals(billingGeneralOriginal, $scope.billingGeneral)) verboseHH["billing"] = $scope.billingGeneral;

        if ($scope.billingRecurringAdjustments && !angular.equals(billingRecurringAdjustmentsOriginal, $scope.billingRecurringAdjustments)) verboseHH["recurringAdjustments"] = $scope.billingRecurringAdjustments;

        if ($scope.financialPlanningFee && !angular.equals(financialPlanningFeeOriginal, $scope.financialPlanningFee)) {
            $scope.financialPlanningFee.startDate = Date.create($scope.financialPlanningFee.startDate).formatted();
            verboseHH["financialPlanningFee"] = $scope.financialPlanningFee;
        }

        if ($scope.billingFeePayingAccounts && !angular.equals(billingFeePayingAccountsOriginal, $scope.billingFeePayingAccounts)) {
            $scope.billingFeePayingAccounts.forEach(function (acct) {
                acct.payPercent = acct.payPercent / 100;
            });

            verboseHH["feePayingAccounts"] = $scope.billingFeePayingAccounts;
        }

        if ($scope.tieredFeeAccounts && !angular.equals(tieredFeeAccountsOriginal, $scope.tieredFeeAccounts)) {
            verboseHH["tieredFeeAccounts"] = $scope.tieredFeeAccounts;
        }

        if ($scope.assetExclusions && !angular.equals(assetExclusionsOriginal, $scope.assetExclusions)) {
            var tickerTypes = $scope.assetExclusions?.findAll({ exclusionType: 5 });
            if (tickerTypes) {
                tickerTypes.forEach(function (ticker) {
                    if (ticker.exclusionValue) ticker.exclusionValue = ticker.exclusionValue.productId;
                })
            }
            // strip ui-only fields before save
            var assetExclusionsToSave = ($scope.assetExclusions || []).map(function (ax) {
                var clone = angular.copy(ax);
                delete clone.securityClassOptions;
                delete clone.securityClassesProgress;
                return clone;
            });
            verboseHH["assetExclusions"] = assetExclusionsToSave;
        }

        if ($scope.customFields && !angular.equals(customFieldsOriginal, $scope.customFields)) {
            var udfs = $scope.customFields.findAll({ entity: entities.client.name });
            if (udfs.length) verboseHH["userDefinedFields"] = udfs;
        }

        if ($scope.entityOptions && !angular.equals(entityOptionsOriginal, $scope.entityOptions)) verboseHH["entityOptions"] = $portfolio.restoreEntityOptions($scope.entityOptions);

        if ($scope.targetAllocations && !angular.equals(targetAllocationsOriginal, $scope.targetAllocations)) {
            $scope.targetAllocations.each(function (item) {
                delete item.entityName;
            });
            verboseHH["targetAllocations"] = $scope.targetAllocations;
        }

        verboseHH["id"] = args.isNew ? 0 : args.ids[0];
        var msg = args.isNew ? 'Adding ' : 'Saving ';
        var verb = args.isNew ? 'POST' : 'PUT';
        var urlSave = args.isNew ? '/Portfolio/Clients/Verbose/' : '/Portfolio/Clients/Verbose/' + args.ids[0];

        promises.push($http({ method: verb, url: urlSave, data: verboseHH, trackerMsg: msg + 'household' }));

        if ($scope.current.viewSSNReason || $scope.current.updateSSN) {
            promises.push($http.put("/Portfolio/Clients/" + verboseHH["id"] + "/SSNTaxId", { SSN: $scope.householdGeneral.ssN_TaxID, Reason: $scope.current.viewSSNReason }, { trackerMsg: 'Saving SSN/Tax ID' }));
        }

        promises.add(hhMemberSSNPromises);

        if ($scope.chsts && !angular.equals(changeHistoryOriginal, $scope.chsts)) {
            promises.add($http.put('/Portfolio/ClientChanges/' + $scope.current.householdId, $scope.chsts, { trackerMsg: 'Saving household change history' }));
        }

        $q.all(promises).then(function (results) {
            const postSave = function () {
                if ($scope.current.isFullPage && !$scope.current.showCancel) {
                    $dialog.saveSuccessful("Household saved.").open();
                } else {
                    if (args.app) {
                        var retUrl = '';
                        var savedData = results[0].data;
                        if (args.app == apps.portfolioLists.name) {
                            retUrl = '/Portfolio/Clients/' + savedData.id;
                        }
                        else if (args.app == apps.billingAudit.name) {
                            retUrl = '/Billing/Clients/' + savedData.id;
                        }
                        else if (args.app == apps.newAccount.name) {
                            retUrl = '/Portfolio/Accounts/NewPortfolio?clientId=' + savedData.id;
                        }
                        $http.get(retUrl, { trackerMsg: 'Refreshing household' })
                            .then(function (response) {
                                editorHotKeys.destroy();
                                if (dialog) {
                                    dialog.close(response.data);
                                } else {
                                    window.parent.postMessage("iframeclose");
                                }
                            });
                    } else {
                        editorHotKeys.destroy();
                        if (dialog) {
                            dialog.close(null);
                        } else {
                            window.parent.postMessage("iframeclose");
                        }
                    }
                }
            };

            if ($scope.householdGeneral) {
                if (
                    (!angular.equals(householdGeneralOriginal.address1, $scope.householdGeneral.address1) ||
                        !angular.equals(householdGeneralOriginal.address2, $scope.householdGeneral.address2) ||
                        !angular.equals(householdGeneralOriginal.address3, $scope.householdGeneral.address3) ||
                        !angular.equals(householdGeneralOriginal.city, $scope.householdGeneral.city) ||
                        !angular.equals(householdGeneralOriginal.country, $scope.householdGeneral.country) ||
                        !angular.equals(householdGeneralOriginal.zip, $scope.householdGeneral.zip) ||
                        !angular.equals(householdGeneralOriginal.state, $scope.householdGeneral.state)
                    )
                    &&
                    $oasRights.canRead("SCHWABADDRESSCHANGE")
                ) {
                    $dialog.dialog({ dialogClass: "modal medium", templateUrl: 'portfolio/views/change-address-sync.html', controller: 'ChangeAddressSyncCtrl', resolve: { householdId: function () { return $scope.current.householdId; } } })
                        .open()
                        .then(function (result) {
                            postSave();
                        });
                } else {
                    postSave();
                }
            } else {
                postSave();
            }

        }).catch(function () {
            $scope.isSaving = false;
        });
    }

    $scope.runReport = function () {
        $portfolio.runReport(entities.client.value, args.ids[0]);
    };

    $scope.openEditor = function () {
        var extraInfo = { fkClient: args.ids[0] };
        $portfolio.openEditor(entities.registration.value, [], null, null, apps.portfolioLists.name, extraInfo);
    };

    $scope.setAge = function () {
        if ($scope.householdGeneral.dob) {
            $scope.householdGeneral.age = Date.create($scope.householdGeneral.dob).yearsAgo();
        }
    };

    $scope.invalidEmail = function (invalid) {
        $scope.householdGeneral.emailInvalid = invalid;
    };

    $scope.setEmail = function (value) {
        $scope.householdGeneral.email = value;
    };

    $scope.invalidCcEmail = function (invalid) {
        $scope.ccInfo.emailInvalid = invalid;
    };

    $scope.setCcEmail = function (value) {
        $scope.ccInfo.email = value;
    };

    $scope.close = function (validate) {
        if (validate) {
            if (
                !angular.equals(householdGeneralOriginal, $scope.householdGeneral) ||
                !angular.equals(householdNotesOriginal, $scope.householdNotes) ||
                !angular.equals(householdDocumentsOriginal, $scope.householdDocuments) ||
                !angular.equals(householdHHMembersOriginal, $scope.householdHHMembers) ||
                !angular.equals(original.householdAdditionalAccounts, $scope.householdAdditionalAccounts) ||
                !angular.equals(original.householdAdditionalRegs, $scope.householdAdditionalRegs) ||
                !angular.equals(householdAdditionalRepresentativesOriginal, $scope.householdAdditionalRepresentatives) ||
                !angular.equals(householdSuitabilityOriginal, $scope.householdSuitability) ||
                !angular.equals(portfolioGroupsOriginal, $scope.portfolioGroups) ||
                !angular.equals(billingGeneralOriginal, $scope.billingGeneral) ||
                !angular.equals(billingRecurringAdjustmentsOriginal, $scope.billingRecurringAdjustments) ||
                !angular.equals(billingRelatedHHsOriginal, $scope.billingRelatedHHs) ||
                !angular.equals(assetExclusionsOriginal, $scope.assetExclusions) ||
                !angular.equals(billingFeePayingAccountsOriginal, $scope.billingFeePayingAccounts) ||
                !angular.equals(entityOptionsOriginal, $scope.entityOptions) ||
                !angular.equals(customFieldsOriginal, $scope.customFields) ||
                !angular.equals(targetAllocationsOriginal, $scope.targetAllocations) ||
                !angular.equals(changeHistoryOriginal, $scope.chsts) ||
                !angular.equals(financialPlanningFeeOriginal, $scope.financialPlanningFee) ||
                (($scope.isNewRepSplitFlagEnabled && $scope.isRepPayoutPercentEnabled) && !angular.equals(representativesOriginal, $scope.representatives))
            ) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                editorHotKeys.destroy();
                if (dialog) {
                    dialog.close(null);
                } else {
                    window.parent.postMessage("iframeclose");
                }
            }

        } else {
            editorHotKeys.destroy();
            if (dialog) {
                dialog.close(null);
            } else {
                window.parent.postMessage("iframeclose");
            }
        }
    };


    // PUBLIC METHODS - SSN
    $scope.unlockSSNField = function (forEdit) {
        if (args.ids[0] > 0 && ($scope.householdGeneral.ssN_TaxID && $scope.householdGeneral.ssN_TaxID.has('X')) || forEdit) {
            $dialog.inputBox('Reason to ' + (forEdit ? 'Edit' : 'View') + ' the SSN or Tax ID', "Reason", "textarea")
                .open()
                .then(function (rslt) {
                    if (rslt) {
                        var updateSSN = { ssN: null, reason: rslt };
                        $http.put('/Portfolio/Clients/' + args.ids[0] + '/SSNTaxId', updateSSN, { trackerMsg: 'Getting SSN/Tax ID information' })
                            .then(function (response) {
                                $scope.householdGeneral.ssN_TaxID = response.data;

                                if (forEdit && $scope.current.updateSSN == false) {
                                    $scope.current.viewSSNReason = rslt;
                                    $scope.current.updateSSN = true;
                                }
                            });
                    }
                });
        }
    };


    // PUBLIC METHODS - HOUSEHOLD MEMBERS
    $scope.addHouseholdMember = function () {
        $scope.editHouseholdMember({ id: 0, additionalAddresses: [{ id: 0, sendPeriodicStatements: false, type: "Home" }] }, true);
    };

    $scope.editHouseholdMember = function (hh, isAdd) {
        var config = {
            householdMember: angular.copy(hh),
            clientId: args.ids[0],
            hashKey: isAdd ? 0 : hh.$$hashKey
        };

        $dialog.dialog({ dialogClass: "modal wide", templateUrl: 'portfolio/views/additionalHousehold.html', controller: 'AdditionalHouseholdCtrl', resolve: { args: function () { return config; } } })
            .open()
            .then(function (result) {
                if (!result) return;

                if (config.hashKey == 0) {
                    $scope.householdHHMembers.push(result);
                } else {
                    var index = $scope.householdHHMembers.findIndex({ $$hashKey: config.hashKey });
                    $scope.householdHHMembers[index] = result;
                }
            });
    };

    $scope.removeHouseholdMember = function (hh) {
        $dialog.confirmAction("Are you sure you want to remove household member <b>" + hh.fullName + "</b>?")
            .open()
            .then(function (result) {
                if (result == 'yes') {
                    $scope.householdHHMembers.remove(hh);
                }
            });
    };

    $scope.calculateMemberAge = function (dob) {
        var isDate = new Date(dob).isValid();
        return (dob && isDate ? Date.create(dob).yearsAgo() : '');
    };


    // PUBLIC METHODS - RECURRING ADJUSTMENTS
    $scope.removeRecurringAdj = function (adj) {
        $dialog.confirmAction("Are you sure you want to remove the recurring adjustment?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.billingRecurringAdjustments.remove(adj);
                }
            });

    };

    $scope.addRecurringAdj = function () {
        var recurringAdj = {
            additionalAnnualAmount: 0.00,
            additionalAnnualAmountType: 0,
            billScheduleId: 0,
            billAjdTypeId: 0,
            billEntityId: 0,
            entityId: 0,
            EntityEnum: parseInt(entities.client.value),
            FkEntity: args.ids[0]
        };

        $scope.billingRecurringAdjustments.push(recurringAdj);
    };

    //PUBLIC METHODS - ADDITIONAL REPS
    $scope.removeAdditionalRep = function (rep) {
        $dialog.confirmAction("Are you sure you want to remove the rep assignment?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.householdAdditionalRepresentatives.remove(rep);
                }
            });
    };

    $scope.primaryRepEditClicked = function () {
        navigateToRepresentativesTab();
    };

    $scope.addAdditionalRep = function () {
        if ($scope.isNewRepSplitFlagEnabled && $scope.isRepPayoutPercentEnabled) {
            navigateToRepresentativesTab();
        } else {
            if (!$scope.householdAdditionalRepresentatives) {
                $scope.householdAdditionalRepresentatives = [];
            }
            const tRepTitle = $scope.current.repTitles.find(r => r.name === 'Support Advisor');
            const additionalRep = {
                repId: 0,
                clientId: args.ids[0],
                repTitleId: tRepTitle.id,
                repTitle: tRepTitle.name,
                canDelete: true,
                numberOfHouseholds: 0,
                simpleRep: null
            };

            if ($scope.isNewRepSplitFlagEnabled && !$scope.isRepPayoutPercentEnabled && $scope.householdAdditionalRepresentatives.length > 0) {
                additionalRep.startDate = $scope.householdAdditionalRepresentatives[0].startDate;
                additionalRep.endDate = $scope.householdAdditionalRepresentatives[0].endDate;
            } else if (!$scope.current.hasClientRepAdditional) {
                additionalRep.startDate = Date.create(botDate);
                additionalRep.endDate = Date.create(eotDate);
            }

            $scope.householdAdditionalRepresentatives.push(additionalRep);
        }
    };

    function navigateToRepresentativesTab() {
        let representativesMenuItem = $scope.menu.categories.map((category) => category.children).flatten().find((children) => children.code === 'representatives');
        $scope.loadTab(representativesMenuItem);
    }

    $scope.setSelectedRep = function (selected, rep) {
        rep.repId = selected.id;

        if (selected && selected.id > 0) {
            $http.get("/Portfolio/Representatives/" + selected.id)
                .then(function (response) {
                    if (response && response.data) {
                        rep.numberOfHouseholds = response.data.households;
                    }
                });
        }
    };

    $scope.editRepTitles = function () {
        const defaultTitles = ['Financial Planner', 'Support Advisor'];
        let editRepTitles = $scope.current.repTitles.filter(_ => !defaultTitles.includes(_.name));
        const defTitles = $scope.current.repTitles.filter(_ => defaultTitles.includes(_.name));
        $dialog.dialog({ dialogClass: "modal rep-title-dialog", templateUrl: "rep-titles-edit.html", controller: 'RepTitlesEditCtrl', repTitles: editRepTitles })
            .open()
            .then(function (result) {
                if (result) {
                    $http.put('/Portfolio/Representatives/Reptitles', defTitles.concat(result), { trackerMsg: 'Saving Rep Title Changes' })
                        .then(function (res) {
                            const rtIds = res.data.map(_ => {
                                return _.id
                            });
                            let missing = $scope.householdAdditionalRepresentatives.filter(_ => !rtIds.includes(_.repTitleId));

                            if (missing?.length > 0) {
                                const df = res.data.find(_ => _.name === "Support Advisor");
                                missing.forEach(_ => {
                                    _.repTitleId = df.id;
                                });
                            }
                            $scope.current.repTitles = res.data;
                            $scope.current.repTitles.unshift({id: -1, name: 'Primary Rep'});
                        });
                }
            });
    };

    // region FEE PRIORITY
    $scope.movePriority = function (account, isDown, event) {
        if (event.originalEvent.screenX !== 0 && event.originalEvent.screenY !== 0) { //Discerns if something is an actual mouse click, or a simulated one. We don't want to allow for simulated mouse clicks.
            var idx;
            idx = $scope.tieredFeeAccounts.indexOf(account);

            if (idx !== -1) {
                if (isDown) {
                    $scope.tieredFeeAccounts.splice(idx, 1);
                    $scope.tieredFeeAccounts.add(account, idx + 1);
                } else {
                    $scope.tieredFeeAccounts.splice(idx, 1);
                    $scope.tieredFeeAccounts.add(account, idx - 1);
                }

                $scope.tieredFeeAccounts.forEach(function (account, idx) {
                    account.priority = idx + 1;
                });
            }
        }
    };

    $scope.reorderPriority = function (account, isBaseOnLocation) {
        var missingPosition = null;
        var bumpUp = true;
        for (var i = 1; i <= $scope.tieredFeeAccounts.count(); i++) {
            var previousNumberFound = false;
            $scope.tieredFeeAccounts.forEach(function (account, idx) {
                if (account.priority == i) {
                    previousNumberFound = true;
                }
            });
            if (!previousNumberFound) {
                missingPosition = i;
                break;
            }
        }
        bumpUp = missingPosition < account.priority; //This determines whether to bump the replacement number up or down.
        if (missingPosition != null) { //only run if the number entered is actually different.
            if (isBaseOnLocation) {
                $scope.tieredFeeAccounts.forEach(function (account, idx) {
                    account.priority = idx + 1;
                });
            } else {
                var newPriority = account.priority;
                var priorIteratedAccount = null;

                $scope.tieredFeeAccounts.forEach(function (acct) {
                    if (acct.priority > newPriority && acct.accountId !== account.accountId) {
                        acct.priority *= 1;
                    } else if (acct.priority == newPriority && acct.accountId !== account.accountId) {
                        if (bumpUp) {
                            acct.priority *= -1;
                        } else {
                            acct.priority *= 1
                        }
                    } else if (acct.priority < newPriority && acct.accountId !== account.accountId) {
                        acct.priority *= -1;
                    }
                    else if (acct.accountId == account.accountId) {
                        acct.priority = 0; //By definition, all the other account priorities have been made to be bigger (stay positive) or smaller (made negative)
                    }
                });
                var negativeNumberedOrderedAccounts = $scope.tieredFeeAccounts.filter((function (x) { return x.priority < 0 })).sortBy('priority').reverse(); //Negative numbers are sorted in an "opposite" order. This is reversed to correct for that.
                var positiveNumberedOrderedAccounts = $scope.tieredFeeAccounts.filter((function (x) { return x.priority >= 0 })).sortBy('priority');
                $scope.tieredFeeAccounts = negativeNumberedOrderedAccounts.concat(positiveNumberedOrderedAccounts);

                var priority = 1;
                $scope.tieredFeeAccounts.forEach(function (a) {
                    a.priority = priority;
                    priority += 1;
                });

            }
        }
    };

    // end region

    // PUBLIC METHODS - SUITABILITY
    $scope.setBondPercent = function () {
        if ($scope.householdSuitability.stockPercent) {
            $scope.householdSuitability.bondPercent = 100 - parseInt($scope.householdSuitability.stockPercent);
        }
    };

    //PUBLIC METHODS - PORTFOLIO GROUPS
    $scope.togglePgHelperAccountSection = function (section) {
        section.isExpanded = !section.isExpanded;
        section.registrations.forEach(registration => registration.isExpanded = section.isExpanded);
    };

    $scope.onRegAddedOrRemovedFromPortfolioGroup = function (registration, portfolioGroup) {
        registration.accounts.forEach(account => {
            portfolioGroup.assignments.accounts[account.id] = portfolioGroup.assignments.registrations[registration.id];
        });
    };

    function openPortfolioGroupEditor(portfolioGroup, isAdd) {
        return $dialog.dialog({
            dialogClass: 'modal wide',
            templateUrl: 'portfolio/editors/views/portfolio-group-edit.html',
            controller: 'PortfolioGroupEditCtrl',
            isAddingNewGroup: isAdd,
            clientId: $scope.current.householdId,
            portfolioGroupId: portfolioGroup?.id,
            portfolioTypes: angular.copy($scope.pgHelper.types.list),
            allowedChangeTradingPortfolioGroups: $scope.rightsChangeTradingPortfolioGroups.canRead
        }).open();
    }

    $scope.addPortfolioGroup = function () {
        openPortfolioGroupEditor(null, true).then(newPortfolioGroup => {
            if (!newPortfolioGroup) {
                return;
            }

            setPortfolioGroupDisabledState(newPortfolioGroup);
            newPortfolioGroup.assignments = {registrations: {}, accounts: {}}; // no need to set values since they all default to false anyway

            $scope.portfolioGroups.push(newPortfolioGroup);
        });
    };

    $scope.editPortfolioGroup = function (originalPortfolioGroup) {
        openPortfolioGroupEditor(originalPortfolioGroup, false).then(updatedPortfolioGroup => {
            if (!updatedPortfolioGroup) {
                return;
            }

            // the updated object has a different shape, so copy over only what we need
            Object.keys(originalPortfolioGroup).forEach(key => {
                if (['registrationIds', 'accounts', 'assignments'].any(key) || !updatedPortfolioGroup.hasOwnProperty(key)) {
                    return;
                }

                originalPortfolioGroup[key] = updatedPortfolioGroup[key];
            });

            setPortfolioGroupDisabledState(originalPortfolioGroup);
        });
    };

    $scope.deletePortfolioGroup = function (portfolioGroup) {
        $scope.portfolioGroups.remove({id: portfolioGroup.id});
    };

    // PUBLIC METHODS - RELATED HOUSEHOLDS
    $scope.addRelatedHH = function () {
        $portfolio.search(entities.account.value)
            .then(function (rslt) {
                if (!rslt || (!args.isNew && rslt.item.id == args.ids[0].id)) return;

                if (rslt.entity == entities.client.value) {
                    getClient(rslt.item.id);
                } else {
                    $http.get("/Portfolio/" + entities.find({ value: rslt.entity }).pluralize() + "/" + rslt.item.id, { trackerMsg: 'Loading household' })
                        .then(function (response) {
                            getClient(response.data.clientId);
                        });
                }
            });
    };

    function getClient(clientId) {
        $http.get("/Portfolio/Clients/Verbose/" + clientId, { trackerMsg: 'Loading household' })
            .then(function (response) {
                var data = response.data;
                var relatedHH = {
                    billClientId: $scope.billingGeneral.billClientId,
                    clientId: data.id,
                    firstName: data.portfolio.firstName,
                    lastName: data.portfolio.lastName
                };
                $scope.billingRelatedHHs.push(relatedHH);
            });
    }

    $scope.clearPaidBy = function () {
        if ($scope.financialPlanningFee.payMethodId != 2) {
            $scope.financialPlanningFee.paidByAccountNumber = null;
        }
    };

    $scope.removeRelatedHH = function (hh) {
        $dialog.confirmAction("Are you sure you want to remove related household <b>" + hh.firstName + " " + hh.lastName + "</b> from this household?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.billingRelatedHHs.remove(hh);
                }
            });
    };


    // PUBLIC METHODS - NOTES AND DOCUMENTS
    $scope.syncNewDocument = function (newDocument) {
        householdDocumentsOriginal.push(newDocument);
    };


    //PUBLIC METHOD - TARGET ALLOCATIONS
    $scope.loadGroupAllocation = function () {
        var entity = entities[entities.find({ name: $scope.current.targetAllocationType })];
        var simpleUrl = entity?.simpleUrl;

        if (isUserDefinedFieldTargetAllocationType($scope.current.targetAllocationType)) {
            var definitionId = parseInt(String($scope.current.targetAllocationType).substring(4), 10);
            $http.get('/Portfolio/Clients/TargetAllocationUserDefinedFieldValues/Simple?fieldDefinitionId=' + definitionId, { trackerMsg: 'Loading custom field grouping values' })
                .then(function (response) {
                    $scope.groupingOptions = response.data;
                });
        } else if ($scope.current.targetAllocationType.includes('Security Classification')) {
            $http.get('/Portfolio/SecurityClassification/Local/SecurityClasses/Simple?entity=' + $scope.current.targetAllocationType, {cache: true, trackerMsg: 'Loading security classes'})
            .then(function (response) {
                $scope.groupingOptions = response.data;
            });
        } else if (simpleUrl) {
            $http.get(simpleUrl, { trackerMsg: 'Loading grouping information' })
                .then(function (response) {
                    $scope.groupingOptions = response.data;
                });
        }

        if ($scope.targetAllocations && $scope.targetAllocations.length > 0) {
            var firstEntity = $scope.targetAllocations[0].entity;
            var currentType = $scope.current.targetAllocationType;
            var entityMatches = firstEntity == currentType
                || (isUserDefinedFieldTargetAllocationType(currentType) && (firstEntity == 32 || firstEntity == '32'));
            if (!entityMatches) {
                $scope.targetAllocations = [];
            }
        }
    };

    $scope.addTargetAllocation = function () {
        var savedEntity = isUserDefinedFieldTargetAllocationType($scope.current.targetAllocationType)
            ? 32
            : $scope.current.targetAllocationType;

        if ($scope.current.targetAllocationType != entities.product.name) {
            $scope.current.selectedTargets.each(function (item) {
                if ($scope.targetAllocations.none({ entityId: item })) {
                    $scope.targetAllocations.push({ entity: savedEntity, entityId: item, entityName: loadGroupingName(item), weight: 0.0 });
                }
            });
        }
        else {
            if ($scope.targetAllocations.none({ entityId: $scope.current.product.productId })) {
                $scope.targetAllocations.push({ entity: savedEntity, entityId: $scope.current.product.productId, entityName: $scope.current.product.ticker + " (" + $scope.current.product.productName + ")", weight: 0.0 });
            }
        }
    };

    $scope.removeTargetAllocation = function (item) {
        $scope.targetAllocations.remove(item);
    };

    $scope.onHouseholdTargetAllocationLoaded = function (payload) {
        $scope.targetAllocations = payload.allocations;
        targetAllocationsOriginal = angular.copy(payload.allocations);
        $scope.current.targetAllocationType = payload.targetAllocationType;
    };

    $scope.onHouseholdAdditionalRegsChange = function (list) {
        $scope.householdAdditionalRegs = list;
    };

    $scope.onHouseholdAdditionalAccountsChange = function (list) {
        $scope.householdAdditionalAccounts = list;
    };


    $scope.setCCLogo = function (ccNumber) {
        if (ccNumber && ccNumber.length == 16) {
            if (ccNumber.first() == "4") {
                $scope.current.ccLogo = 'fa fa-cc-visa fa-lg';
            } else if (ccNumber == "6") {
                $scope.current.ccLogo = 'fa fa-cc-discover fa-lg';
            } else if (ccNumber == "3") {
                $scope.current.ccLogo = 'fa fa-cc-amex fa-lg';
            } else if (ccNumber == "5") {
                $scope.current.ccLogo = 'fa fa-cc-mastercard fa-lg';
            }
        } else {
            $scope.current.ccLogo = '-muted';
        }
    };

    $scope.modifyCCInfo = function () {
        $scope.ccInfo = {};
        $timeout(function () {
            $scope.current.storedPaymentInfo = false;
        }, 100);
    };

    $scope.removeCCInfoFromHousehold = function () {
        $dialog.confirmAction('This will remove associated credit card from ' + $scope.householdGeneral.name + '<br>' + '<em>Please note that any fee schedule payments that have already been scheduled will still post. Subsequent credit card payments from this day forward will discontinue</em>')
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete('/Integrations/BluePay/' + $scope.current.householdId, { trackerMsg: 'Removing payment information' })
                        .then(function () {
                            $scope.modifyCCInfo();
                        });
                }
            });
    };

    $scope.updateCCInfo = function (form) {
        //in case there' an error
        $scope.current.storedPaymentInfo = false;

        var paymentType = $scope.current.ccPaymentType == 'credit' ? '/StoreCreditCard' : '/StoreACHInfo';

        var saveCcInfo = function () {
            $http.post('/Integrations/BluePay/' + $scope.current.householdId + paymentType, $scope.ccInfo, { trackerMsg: 'Updating Credit Card Information' })
                .then(function (response) {
                    if (response && response.data) {
                        $scope.current.storedPaymentInfo = true;
                        $scope.ccInfo = response.data;
                    }
                });
        };

        if (form.$valid) {
            saveCcInfo();
        } else {
            var requiredFields = [];
            var invalidFields = [];
            if (form.$error.required) {
                requiredFields = form.$error.required.findAll({ $invalid: true });
            }
            if (form.$error.card) {
                form.$error.card.each(function (e) {
                    invalidFields.add(e);
                });
            }
            if (form.$error.expiry) {
                form.$error.expiry.each(function (e) {
                    invalidFields.add(e);
                });
            }
            if (form.$error.cvc) {
                form.$error.cvc.each(function (e) {
                    invalidFields.add(e);
                });
            }

            var message = "One or more fields are invalid or required." + '<br>';

            //broke validation
            message += '<ul>';
            invalidFields.forEach(function (item) {
                Object.each(item, function (key, val) {
                    if (key == "$name") {
                        if (val == 'cvv2') {
                            message += '<li>' + 'Invalid CVV2 number.' + '</li>';
                        }
                        else if (val == "ccNumber") {
                            message += '<li>' + 'Invalid Credit Card Number' + '</li>';
                        }
                        else if (val == "ccExp") {
                            message += '<li>' + 'Invalid Expiration Date.  Format: MM/YYYYY' + '</li>';
                        }
                    }
                });
            });
            message += '</ul>';

            //required fields
            message += '<ul>';
            requiredFields.forEach(function (item) {
                Object.each(item, function (key, val) {
                    if (key == "$name") {
                        if (val == 'cvv2') {
                            message += '<li>' + val + ' is required' + '</li>';
                        }
                        else {
                            if (val == "ccNumber") {
                                message += '<li>' + 'Card ' + val.from(2) + ' is required' + '</li>';
                            } else {
                                message += '<li>' + val + ' is required' + '</li>';
                            }
                        }
                    }
                });
            });
            message += '</ul>';

            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Information Entered", message).open();
        }
    };

    $scope.setAchImage = function (controlName) {
        if (controlName) {
            $scope.current.achImageTop = controlName == 'account' ? -199 : -99;
        } else {
            $scope.current.achImageTop = 1;
        }
    };

    // PUBLIC METHOD - Asset Exclusion
    $scope.addAssetExclusion = function () {
        if (!$scope.assetExclusions) {
            $scope.assetExclusions = [];
        }
        $scope.assetExclusions.push({ id: 0, exclusionType: 1, exclusionValue: 0, isExcluded: true })
    };

    $scope.removeAssetExclusion = function (item) {
        $scope.assetExclusions.remove(item);
    };

    $scope.getSimpleListForDropDown = function (item, preserveSelection) {
        var simpleGet;
        var exclusionType = item.exclusionType;
        if (!$scope.simpleList) $scope.simpleList = [];
        
        switch (exclusionType) {
            case 1:
                $scope.simpleList[1] = [{ name: 'B', id: 0 }, { name: 'E', id: 1 }, { name: 'M', id: 2 }, { name: 'UNASSIGNED', id: 3 }];
                break;
            case 2:
                simpleGet = '/Portfolio/ProductClasses/Simple';
                break;
            case 3:
                simpleGet = '/Portfolio/RiskCategories/Simple';
                break;
            case 4:
                simpleGet = '/Portfolio/ProductCategories/simple';
                break;
        }

        if (exclusionType > 1 && exclusionType != 5 && exclusionType != 6) {
            $http.get(simpleGet, { trackerMsg: 'Loading list' })
                .then(function (response) {
                    $scope.simpleList[exclusionType] = response.data;
                    $scope.simpleList[exclusionType].unshift({ id: 0, name: 'UNASSIGNED' })
                });
        } else if (exclusionType == 6) { // load security classification methods
            $scope.getMethodListForDropDown(item, preserveSelection);
        }        
    };

    $scope.getMethodListForDropDown = function (item, preserveSelection) {
        if (!$scope.securityClassificationMethods) $scope.securityClassificationMethods = [];
        const hasSavedMethod = !!item.securityClassificationMethodId;
        const shouldPreserveSelection = preserveSelection && hasSavedMethod;

        const setMethodAndLoadClasses = function () {
            if (!$scope.securityClassificationMethods.length) {
                item.securityClassOptions = [];
                item.securityClassificationMethodId = null;
                return;
            }

            if (item.securityClassificationMethodId) {
                $scope.getSecurityClassesForDropdown(item, shouldPreserveSelection);
            } 
            if(!item.securityClassificationMethodId && item.exclusionType == 6) {
                item.securityClassificationMethodId = $scope.securityClassificationMethods[0].id;
                $scope.getSecurityClassesForDropdown(item, shouldPreserveSelection);
            }
        };

        if ($scope.securityClassificationMethods.length > 0) {
            setMethodAndLoadClasses();
        } else if ($scope.securityClassificationMethodsPromise) {
            $scope.securityClassificationMethodsPromise.then(setMethodAndLoadClasses);
        } else {
            $scope.securityClassificationMethodsPromise = $http.get(`/Portfolio/SecurityClassification/Local/Methods/Simple?billingEnabled=true`, { trackerMsg: 'Loading security classification methods' })
                .then(function (response) {
                    $scope.securityClassificationMethods = response?.data;
                    setMethodAndLoadClasses();
                })
                .finally(function () {
                    $scope.securityClassificationMethodsPromise = null;
                });
        }
    };

    $scope.getSecurityClassesForDropdown = function (item, preserveSelection) {
        item.securityClassesProgress = true;
        if(item.exclusionType == 6) {
            if (item.securityClassificationMethodId) {
                var cachedClasses = $scope.securityClassesByMethodId[item.securityClassificationMethodId];
                var pendingValue = item.exclusionValue; // Keep saved value to apply after async load
                var handleSecurityClasses = function (classes) {
                    // Store per method id and per row to avoid cross-row overwrite
                    $scope.securityClassesByMethodId[item.securityClassificationMethodId] = classes;
                    item.securityClassOptions = classes;
                    item.securityClassesProgress = false;
                    
                    var availableClasses = item.securityClassOptions || [];
                    if (!availableClasses.length) {
                        item.exclusionValue = null;
                        return;
                    }

                    var savedValue = preserveSelection ? pendingValue : item.exclusionValue;
                    var hasSavedValue = savedValue !== undefined && savedValue !== null;
                    if (hasSavedValue && availableClasses.some(sc => sc.id == savedValue)) {
                        item.exclusionValue = savedValue;
                        return;
                    }

                    if (item.exclusionValue && availableClasses.some(sc => sc.id == item.exclusionValue)) {
                        return;
                    }

                    item.exclusionValue = availableClasses[0].id;
                };

                if (cachedClasses) { // Set cached security classes
                    handleSecurityClasses(cachedClasses);
                } else {
                    $http.get(`/Portfolio/SecurityClassification/local/SecurityClasses/Simple?securityClassificationMethodIds=${item.securityClassificationMethodId}`, {trackerMsg: 'Loading security classes'})
                    .then(function (response) {
                        var classes = response?.data || [];
                        handleSecurityClasses(classes);
                    })
                }
            } else { // Reset security class dropdown options and value
                item.securityClassOptions = [];
                item.exclusionValue = null;
                item.securityClassesProgress = false;
            }
        } else { // Reset security classification dropdown value
            item.securityClassificationMethodId = null;
            item.securityClassesProgress = false;
        }
    };

    // INITIALIZE
    $scope.ccInfo = { ccNumber: null, ccExpiration: null, cvv2: null, ccType: null, achRoutingNum: null, achAccountNum: null, achAccountType: null };

    $scope.pgHelper = {
        accounts: undefined,
        types: {
            list: ['Reporting', 'Composite', 'Trading'],
            selected: 'Reporting'
        }
    };

    $scope.current = {
        isNew: args.isNew || args.extraInfo.createCopy,
        showChangeHistory: false,
        selectedTab: args.defaultTab,
        householdId: args.isNew || args.extraInfo.createCopy ? 0 : parseInt(args.ids[0]),
        updateSSN: false,
        viewSSNReason: null,
        selectedRep: null,
        isFullPage: false,
        targetAllocationType: "",
        storedPaymentInfo: false,
        ccLoading: true,
        achImageTop: 1,
        ccPaymentType: 'credit',
        relatedAccounts: [],
        wasFinanicalPlanningFeeNull: true,
        useHouseholdDefaultSchedules: false,
        hasClientRepAdditional: false
    };

    $scope.assignmentTypes = [
        { name: '(none)', id: 0 },
        { propName: 'category', name: 'Product Category', id: 1 },
        { propName: 'productClass', name: 'Product Class', id: 2 },
        { propName: 'riskCategory', name: 'Risk Category', id: 3 },
        { propName: 'productCategory', name: 'Asset Category', id: 4 },
        { propName: 'ticker', name: 'Ticker', id: 5 }
    ];

    if (args.isFullPage) {
        $scope.current.isFullPage = args.isFullPage;
    }

    $scope.current.showCancel = false;
    if (args.showCancel) {
        $scope.current.showCancel = args.showCancel;
    }

    $scope.isSaving = false;
    $scope.errors = [];

    $scope.repDatesHaveChanged = false;
    $scope.isNewRepSplitFlagEnabled = false;
    $scope.isUseNewSecurityClassEnabled = false; // split flag
    $scope.securityClassificationMethods = []; // security classificaiton methods dropdown
    $scope.securityClassificationMethodsPromise = null; // cache the methods request to avoid duplicate calls
    $scope.securityClassesByMethodId = {}; // cache security classes per method id
    
    init();

});

app.controller('RepTitlesEditCtrl', function RepTitlesEditCtrl($scope, $http, dialog) {

    const defaultTitles = ['Financial Planner', 'Support Advisor'];
    // PRIVATE METHODS
    function init() {

    }

    $scope.addRepTitle = function () {
        if ($scope.current.newRepTitle && $scope.current.newRepTitle.length > 0
            && !$scope.current.repTitleList.find(_ => _.name === $scope.current.newRepTitle) && !defaultTitles.includes($scope.current.newRepTitle)) {
            $scope.current.repTitleList.push({ id: 0, name: $scope.current.newRepTitle })
        }

        $scope.current.newRepTitle = '';
    };

    $scope.setRepTitle = function (rt) {
        rt.update = true;
        rt.oldName = rt.name;
    };

    $scope.editRepTitle = function (rt) {
        if (rt.update) {
            delete rt.update;
        }

        if (rt.oldName) {
            delete rt.oldName
        }

        if (!rt.name || rt.name.length === 0 || $scope.current.repTitleList.filter(_ => _.name === rt.name)?.length > 1 || defaultTitles.includes(rt.name)) {
            $scope.current.repTitleList.remove(rt);
        }
    };

    $scope.removeRepTitle = function (rt) {
        $scope.current.repTitleList.remove(rt);
    };

    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close();
    };

    $scope.close = function () {
        let unSavedTitles = $scope.current.repTitleList.filter(_ => _.update);
        if (unSavedTitles?.length > 0) {
            unSavedTitles.forEach(title => {
                delete title.update;

                if (title.oldName) {
                    title.name = title.oldName;
                    delete title.oldName;
                }
            });
        }

        dialog.close($scope.current.repTitleList);
    };


    //INITIALIZE
    $scope.current = { repTitleList: (dialog.options.repTitles).filter((t => t.id != -1)) ?? [], newRepTitle: '' };

    init();
});

app.controller('ChangeHistoryNotesCtrl', function ChangeHistoryNotesCtrl($scope, $dialog, dialog) {
    function init() {
        $scope.rightsHH = dialog.options.rightsHH;
    }

    $scope.cancel = function () {
        if (dialog) {
            dialog.close(null);
        } else {
            window.parent.postMessage("iframeclose");
        }
    };

    $scope.close = function () {
        dialog.close($scope.current);
    };

    $scope.current = { notes: dialog.options.repChangeHistory.notes, isActive: dialog.options.repChangeHistory.isActive };
    init();
});


'use strict';

app.controller('RegistrationListCtrl', function RegistrationListCtrl($scope, $http, $location, $oasRights, $dialog, $portfolio, $routeParams, $tactical, $settings, $timeout, entities, views, apps, activeState, searchResult, API_CONFIG, splitIoService) {

    // PRIVATE VARIABLES
    var lastCell = null;
    var lastRow = null;
    const pageEntityType = entities.registration.value;

    function applyWorkflowAssistantODataFilters() {
        var sync = window.portfolioListODataSidebarSync;
        if (!sync) {
            return false;
        }
        return sync.applyODataRouteFilters($scope, $location, 'registration', activeState);
    }

    // PRIVATE METHODS
    function init() {
        var sync = window.portfolioListODataSidebarSync;
        if (sync && sync.initRecordColumnLimitFeature) {
            sync.initRecordColumnLimitFeature($scope, splitIoService, $http, $location, activeState, 'registration', finishInit);
        } else {
            $scope.current.gridLimitsReady = true;
            finishInit(false);
        }
    }

    function finishInit(hasODataRegistrationFilter) {
        if (!$scope.current.portfolioSsrmEnabled) {
            hasODataRegistrationFilter = applyWorkflowAssistantODataFilters();
        }

        splitIoService.getBoolTreatment('recon_datasharing_editwarningmessages_7285').subscribe((isEnabled) => {
            $scope.isDataSharingWarningEnabled = isEnabled;
        });

        $scope.rightsHH = $oasRights.forCode("CLIENTS");
        $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
        $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
        $scope.rightsAst = $oasRights.forCode("ASSETS");
        $scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");
        $scope.rightsNewAcc = $oasRights.forCode("NEWACCOUNT");
        $scope.rightsTOM = $oasRights.forCode("TRADEORDERMGMT");
        $scope.rightsInstances = $oasRights.forCode("TRADEINSTANCES");
        $scope.rightsPerfViewer = $oasRights.forCode("PERFVIEWER");
        $scope.rightsHouseholdOverview = $oasRights.forCode("HOUSEHOLDOVERVIEW");
        $scope.rightsTaxCenter = $oasRights.forCode("TAXCENTERMAINTAIN");
        $scope.rightsInsight = $oasRights.forCode("INSIGHTBUILDERAPP");
        $scope.rightsSleeveSetup = $oasRights.forCode("SLEEVESETUP");
        $scope.rightsMoveRegistration = $oasRights.forCode("MOVEREGISTRATION");
        $scope.rightsSleeveTransferPortfolio = $oasRights.forCode("SLEEVETRANSFERPORTFOLIO");
        $scope.rightsPVCompare = $oasRights.forCode("PORTFOLIOVIEWCOMPARE");
        $scope.rightsPortfolioRepresentativePayouts = $oasRights.forCode('PORTFOLIOREPRESENTATIVEPAYOUTS');
        $scope.rightsTargetAllocation = $oasRights.forCode("TARGETALLOCATION");

        if (!$scope.current.activeState) {
            $scope.current.activeState = $settings.getSetting('activeState');
        }

        if (searchResult) {
            $scope.current.url = '';
            $portfolio.goTo(entities[entities.find({value: searchResult.entity})].urlFrag, searchResult.entity, searchResult.item.id);
        } else if (!hasODataRegistrationFilter) {
            if ($routeParams.entityId && $routeParams.entity == parseInt(entities.client.value)) {
                var urls = $portfolio.getDataUrls($routeParams.entity, $routeParams.entityId, entities.registration.value);
                $scope.current.url = urls.urlForList;
            } else if ($routeParams.entityId && $routeParams.entity == parseInt(entities.registration.value)) {
                $scope.current.url = '/Portfolio/Registrations/' + $routeParams.entityId;
            } else if ($routeParams.entityId && $routeParams.entity == parseInt(entities.account.value)) {
                $scope.current.accountId = $routeParams.entityId;
                $scope.current.gridParams += '&accountId=' + $routeParams.entityId;
            } else if ($routeParams.pageQueryId) {
                $scope.current.activeState = activeState.activeAndInActive; // don't set a filter on active state, the page query spocs will handle that
                $portfolio.getPageQueryName($routeParams.pageQueryId)
                    .then(function (queryName) {
                        $scope.current.detailInfo = '(' + queryName + ')';
                    });
            } else if ($routeParams.entityId && $routeParams.entity == parseInt(entities.representative.value)) {
                $scope.current.repId = $routeParams.entityId;
                $scope.current.gridParams += '&representativeId=' + $routeParams.entityId;
            } else if ($routeParams.entityId && $routeParams.entity === entities.portfolioGroup.value){
                var Urls = $portfolio.getDataUrls($routeParams.entity, $routeParams.entityId, entities.registration.value);
                $scope.current.url = Urls.urlForList;
            } else if ($routeParams.entitySessionId) {
                $scope.current.url = '/Portfolio/Registrations';
                $scope.current.entitySessionId = $routeParams.entitySessionId;
                $scope.current.detailInfo = '(' + ($routeParams.info ? $routeParams.info : 'Externally Filtered') + ')';
            }else if ($routeParams.queryStudioId) {
                $scope.current.url = '/Portfolio/Registrations/qs?queryStudioQueryId=' + $routeParams.queryStudioId;
                $scope.current.detailInfo = '(' + ($routeParams.info ? $routeParams.info : 'Filtered by Query Studio') + ')';
            }

            if ($routeParams.entity && $routeParams.entityId) {
                getCurrentEntityInfo().then(function (response) {
                    if (response.data) {
                        $scope.current.entity = response.data;
                        let name = $scope.current.entity.name;

                        if ($routeParams.entity === entities.representative.value) {
                            name = $scope.current.entity.lastName == null ? $scope.current.entity.firstName
                                : ($scope.current.entity.firstName == null ? $scope.current.entity.lastName
                                    : $scope.current.entity.lastName + ', ' + $scope.current.entity.firstName);
                        } else if ($routeParams.entity === entities.client.value) {
                            name = $scope.current.entity.lastName + ', ' + $scope.current.entity.firstName;
                            $scope.current.selectedHouseholdId = $scope.current.entity.id;
                        } else {
                            $scope.current.selectedHouseholdId = 0;
                        }

                        if ($scope.current.entity !== null) {
                            switch ($routeParams.entity) {
                                case entities.representative.value:
                                case entities.client.value:
                                case entities.portfolioGroup.value:
                                    $scope.current.detailInfo = $portfolio.getBreadcrumb($routeParams.entity, name);
                                    break;
                            }
                        }
                    }
                });
            }
        }

        var portfolioSync = window.portfolioListODataSidebarSync;
        if ($scope.current.portfolioSsrmEnabled && portfolioSync) {
            if (portfolioSync.normalizeEntityRouteScopeForODataList) {
                portfolioSync.normalizeEntityRouteScopeForODataList($scope, 'registration', $routeParams.entity, $routeParams.entityId);
            }
            if (portfolioSync.applyODataSortFromView) {
                portfolioSync.applyODataSortFromView($scope, 'registration', $location.search(), {});
            }
        }

        if ($routeParams.source) {
            var key = apps.find({code: $routeParams.source});
            $scope.middleBreadcrumb = key ? apps[key].name : null;
        }

        $scope.resetWidth(false);

        if ($routeParams.openEditor && $scope.rightsReg.canRead && $routeParams.entityId && $routeParams.entity == parseInt(entities.registration.value)) {
            $scope.selectedIds.push($routeParams.entityId);
            $scope.openEditor(false);
        }

        if ($scope.current.portfolioSsrmEnabled && $scope.current.activeState) {
            $scope.current.committedActiveState = $scope.current.activeState;
        }

        var portfolioSync = window.portfolioListODataSidebarSync;
        if (portfolioSync && portfolioSync.markPortfolioListInitComplete) {
            portfolioSync.markPortfolioListInitComplete($scope);
        } else if (!$scope.current.portfolioSsrmEnabled) {
            $scope.current.gridLimitsReady = true;
        }
    }


    function doAction(actionUrl, msgVerb, confirmMsg) {
        $dialog.confirmAction(confirmMsg)
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.post('/Portfolio/Registrations/ListCounts', $scope.selectedIds, {trackerMsg: 'Getting household counts', allowCancellation: true})
                        .then(function(response){
                            var count = response.data;
                            var msg = 'By deleting this record, you will be permanently removing the following from your database: <br />';
                            msg += '  * ' + count.accountsCount + ' Accounts' + '<br />';
                            msg += '  * ' + count.assetsCount + ' Assets' + '<br />';
                            msg += '  * ' + count.transactionsCount +  ' Transaction' + '<br />';
                            msg += '  * ' + count.decedentCount + ' Decedent' + '<br />';
                            msg += 'If this data is needed to be restored, this can come at a cost to your firm.  Are you sure you still want to proceed?';

                            $dialog.confirmAction(msg)
                                .open()
                                .then(function(rst){
                                    if (rst === 'yes'){
                                        $http.put(actionUrl, $scope.selectedIds, {trackerMsg: msgVerb + ' registration(s)'})
                                            .then(function () {
                                                refreshGrid();
                                            });
                                    }
                             });
                    });
                }
            });
    }

    function refreshGrid() {
        $scope.$broadcast('event:portfoliolist-registration-action', {action: 'refresh-grid'});
    }

    // PUBLIC METHODS
    $scope.search = function () {
        $portfolio.search(entities.registration.value)
            .then(function (rslt) {
                if (rslt) {
                    $portfolio.goTo(entities[entities.find({value: rslt.entity})].urlFrag, rslt.entity, rslt.item.id);
                }
            });
    };

    $scope.syncToEclipse = function () {
        $http.post('/Portfolio/Registrations/SyncToEclipse', $scope.selectedIds, { tackerMsg: 'Syncing registrations to Eclipse' }).then(function (response) {
            // This function handles success
            const syncRegistrations = response.data.syncableRegistrations;
            const unsyncdRegistrations = response.data.unsyncableRegistrations;

            var headerText = 'Sync To Eclipse Started Successfully'
            var messageBody = `<h4>successful registrations: ${syncRegistrations.length} <br/> failed registrations: ${unsyncdRegistrations.length}</h4>`;
            if (unsyncdRegistrations.length > 0) {
                messageBody += '<label>'
                //In case we need to troubleshoot successes
                //$(syncRegistrations).each(function (index, item) {
                //    messageBody += `<br/>Registration ${item.accountId}: sync started succesfully`;
                //});
                $(unsyncdRegistrations).each(function (index, item) {
                    messageBody += `<br/>Registration ${item.registrationId}: cannot be sync'd to Eclipse.`;
                });
                messageBody += '</label>'
            }
            $dialog.messageBox(`<i class='fa fa-info-circle fa-lg text-info' aria-hidden='true'></i> ${headerText}, ${messageBody}`).open();
        });
    };

    $scope.runReport = function () {
        $portfolio.runReport(entities.registration.value, $scope.selectedIds[0]);
    };

    $scope.openCustomIndexing = function() {
        $scope.current.showCustomIndex = true;
    };

    $scope.customindexevent = function(e){
        $scope.current.showCustomIndex = false;
    };

    $scope.goToHouseholdOverview = function () {
        $location.url('/portfolio/household/overview?entity=' + parseInt(entities.registration.value) + '&entityId=' + $scope.selectedIds[0]);
    };

    $scope.goToPortfolioView = function (tab) {
        let urlTemp = '/orion/dashboard?entity=' + parseInt(entities.registration.value) + '&entityId=' + $scope.selectedIds[0];
        if (tab?.length > 0) {
            urlTemp = urlTemp + '&tab=' + tab;
        }
        $location.url(urlTemp);
    };

    $scope.goToPerformanceViewer = function () {
        $location.url('/reports/performanceviewer3?entity=' + parseInt(entities.registration.value) + '&entityId=' + $scope.selectedIds[0]);
    };

    $scope.goToTaxCenter = function() {
        $location.url('/tax/custodianrealized?entity=' + parseInt(entities.registration.value) + '&entityId=' + $scope.selectedIds[0]);
    };

    $scope.openEditor = function (isNewReg, defaultTab) {
        var extraInfo = $routeParams.entity === entities.client.value && $routeParams.entityId ? {fkClient: $routeParams.entityId} : null;

        if ($scope.selectedIds.length === 1 || isNewReg){
            $portfolio.openEditor(entities.registration.value, isNewReg ? [] : $scope.selectedIds, null, defaultTab, apps.portfolioLists.name, extraInfo)
                .then(function (result) {
                    if (result) {
                        $scope.$broadcast('event:portfoliolist-registration-action', {action: result.isNew ? 'add-item' : 'update-item', item: result});
                    }
                });
        } else {
            $portfolio.openMassEditor(entities.registration.value, $scope.selectedIds, apps.portfolioLists.name).then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast('event:portfoliolist-registration-action', {action: 'update-items', items: rslt});
                }
            });
        }

    };

    $scope.openMassEditor = function () {
        $portfolio.openMassEditor(entities.registration.value, $scope.selectedIds, apps.portfolioLists.name, null)
            .then(function (result) {
                if (result) {
                    $scope.$broadcast('event:portfoliolist-registration-action', {action: 'update-items', items: result});
                }
            });
    };

    $scope.resetWidth = function (goWide) {
        let customWidth = $scope.rightsPortfolioRepresentativePayouts.canRead ? 600 : 350;
        $scope.rightSidebar.width = goWide ? customWidth : 250;
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:portfoliolist-registration-action', {action: 'export-data'});
    };

    $scope.importTargetAllocations = function () {
        $dialog.dialog({
            dialogClass: "modal medium",
            templateUrl: "app/modals/upload-file.html",
            controller: "UploadFileCtrl",
            title: "Target Allocation Import",
            idField: "id",
            downloadUrl: '/Portfolio/ValidateImport/TargetAllocationRegistration/Templates/',
            validateUrl: '/Portfolio/ValidateImport/TargetAllocationRegistration',
            commitVerb: 'PUT',
            commitUrl: '/Portfolio/Registrations/Verbose'})
            .open();
    };

    $scope.deleteRegistrations = function ()
    {
        splitIoService.getBoolTreatment("recon_datasharing_editwarningmessages_7285")
            .subscribe((isEnabled) => {
                if (isEnabled && $scope.isDataSharingEntitySelected) {
                    $dialog.confirmAction("Registration is a data sharing Registration. Changes are likely to be reverted by subsequent syncs.  Would you still like to proceed?")
                        .open()
                        .then((result) => {
                            if (result === 'yes') {
                                doAction('/portfolio/registrations/action/delete', 'Deleting', 'It is Orion\'s best practice to not delete registrations. If you proceed with this deletion, you will be responsible for providing this data should you need it to be recorded in Orion in the future or for auditing purposes. Are you sure you want to proceed?');
                            }
                        });
                }
                else
                {
                    doAction('/portfolio/registrations/action/delete', 'Deleting', 'It is Orion\'s best practice to not delete registrations. If you proceed with this deletion, you will be responsible for providing this data should you need it to be recorded in Orion in the future or for auditing purposes. Are you sure you want to proceed?');
                }
            });
    };

    $scope.moveRegistrations = function () {
        $dialog.search('household', 'Destination')
            .open()
            .then(function (result) {
                if (!result) return;
                
                if ($scope.selectedIds.length > 1) {
                    $http.put('/Portfolio/Registrations/Action/MoveToClient/' + result.id, {registrationIds : $scope.selectedIds }, { trackerMsg: 'Moving Registration ID: ' + $scope.selectedIds.join(", ") })
                                                .then(function (response) {
                                                    $scope.$broadcast('event:portfoliolist-registration-action', { action: 'update-items', items: response.data });
                                                });
                }
                else {
                    $scope.selectedIds.forEach(function (registrationId) {
                        $http.put('/Portfolio/Registrations/' + registrationId + '/Action/MoveToClient/' + result.id, null, { trackerMsg: 'Moving Registration ID: ' + registrationId })
                            .then(function (response) {
                                $scope.$broadcast('event:portfoliolist-registration-action', { action: 'update-item', item: response.data });
                            });
                    });
                }
            });
    };

    $scope.goToLower = function (urlLevel) {
        $portfolio.goTo(urlLevel, entities.registration.value, $scope.selectedIds[0]);
    };

    $scope.goToHigher = function (urlLevel) {
        if ($scope.current.selectedHouseholdId > 0) {
            $portfolio.goTo(urlLevel, entities.client.value, $scope.current.selectedHouseholdId);
        }
    };

    $scope.goToPortfolioGroups = function(){
        if ($routeParams.entityId && $routeParams.entity === entities.portfolioGroup.value){
            $portfolio.goTo('portfoliogroups', entities.portfolioGroup.value, $routeParams.entityId);
        } else {
            $portfolio.goTo('portfoliogroups', entities.registration.value, $scope.selectedIds[0]);
        }
    };

    $scope.setActiveState = function () {
        if (!$scope.current.portfolioSsrmEnabled) {
            $settings.setSetting('activeState', $scope.current.activeState);
            $timeout(refreshGrid);
            return;
        }
        var sync = window.portfolioListODataSidebarSync;
        if (sync && sync.onActiveStateChanged) {
            sync.onActiveStateChanged($scope, $settings, $timeout, refreshGrid, $http);
            return;
        }
        $settings.setSetting('activeState', $scope.current.activeState);
        $timeout(refreshGrid);
    };

    $scope.openTactical = function () {
        $tactical.start("registration", $scope.selectedIds, true);
    };
    
    $scope.goBack = function () {
        window.history.back();
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    };

    $scope.refreshGridData = function(){
        $scope.current.refreshCache = true;
        $timeout(function () {
            var clearRefreshCache = function () {
                $scope.current.refreshCache = false;
            };
            var searchSidebarFilters = $scope.searchSidebarFilters || $scope.current.searchSidebarFilters;
            if ($scope.current.portfolioSsrmEnabled
                && typeof searchSidebarFilters === 'function'
                && !$scope.current.entityRouteGetById) {
                // Same as the sidebar's Refresh Grid: re-applies the filters and re-matches file filters.
                searchSidebarFilters();
                $timeout(clearRefreshCache);
            } else {
                refreshGrid();
                $timeout(clearRefreshCache);
            }
        });
    };

    $scope.goToSleeveTransfer = function () {
        if ($scope.selectedIds && $scope.selectedIds.length > 0) {
            $http.post(`/Portfolio/SleeveTransfer/EntitySession/Registration`, $scope.selectedIds, { trackerMsg: 'Opening Sleeve Transfer' }).then((response) => {
                window.open(`#/portfolio/sleeve/transfer/${response.data}`, '_blank');
            })
        }
    };

    $scope.goToSleeveTransferHistory = function () {
        window.open('#/portfolio/sleeve/transfer/history', '_blank');
    };

    function setQuickFiltersFromSession() {
        if ($scope.current.selectedHouseholdId && $scope.current.setQuickFilters) {
            const key = $scope.user.authorization.alClientId + '_' + $scope.current.selectedHouseholdId + '_' + pageEntityType;
            const portfolioFiltersJson = sessionStorage.getItem('porfolio_grid_filters');
            let portfolioFilters = {};
            if (portfolioFiltersJson) {
                portfolioFilters = JSON.parse(portfolioFiltersJson);
                if (key in portfolioFilters) {
                    $scope.current.setQuickFilters(JSON.parse(portfolioFilters[key]))
                }
            }
        } else {
            sessionStorage.setItem('porfolio_grid_filters', "{}");
        }
    }

    function getCurrentEntityInfo() {
        if ($routeParams.entityId && $routeParams.entity) {
            let url = null;
            switch ($routeParams.entity) {
                case entities.representative.value:
                    url = '/Portfolio/Representatives/';
                    break;
                case entities.client.value:
                    url = '/Portfolio/Clients/';
                    break;
                case entities.registration.value:
                    url = '/Portfolio/Registrations/';
                    break;
                case entities.portfolioGroup.value:
                    url = '/Portfolio/PortfolioGroups/';
                    break;
                case entities.account.value:
                    url = '/Portfolio/Accounts/';
                    break;
                case entities.asset.value:
                    url = '/Portfolio/Assets/';
                    break;
                case entities.transaction.value:
                    url = '/Portfolio/Transactions/';
                    break;
            }

            if (url !== null) {
                return $http.get(url + $routeParams.entityId, {
                    cache: true,
                    trackerMsg: 'Loading entity info',
                });
            }
        }

        return Promise.reject('The entity specified is invalid.');
    }

    //EVENT LISTENERS
    $scope.$on("event:portfoliolist-registration-select", function (e, args) {
        if (args.length === 0) return;
        $scope.current.selectedHouseholdId = args[0].clientId;
        $scope.isDataSharingEntity = false;
        $scope.selectedRegistrationId = args[0].id;

        args.forEach((item) => {
            if (item.isDataSharingEntity) {
                $scope.isDataSharingEntitySelected = true;
            }
        });
        // Rep payout tab
        $scope.repPayout.clientId = args[0].clientId;
        if($scope.repPayout.isActiveTab){
            $scope.resetWidth(true);
        }
    });
    $scope.$on("event:portfoliolist-registration-edit", function (e, args) {
        if (!args.item) return;
        if (!args.item.isDataSharingEntity) return;
        var isDifferentRow = false;
        var isDifferentCell = false;
        if (lastRow != args.row) {
            isDifferentRow = true;
            lastRow = args.row;
        }
        if (lastCell != args.cell) {
            isDifferentCell = true;
            lastCell = args.cell;
        }

        if ($scope.isDataSharingWarningEnabled && (isDifferentRow || isDifferentCell)) {
            $dialog.messageBox("Registration is a data sharing registration. Changes are likely to be reverted by subsequent syncs.")
                .open().then(() => {
                    args.grid.gotoCell(args.row, args.cell, true);
                }
                );
        }
    });

    $scope.$on('slickgrid-data-loaded', function(event, data) {
        if (data.length === 1){
            $scope.current.selectedHouseholdId = data[0].clientId;
            $scope.$broadcast('event:portfoliolist-registration-action',{action:'select-items', items: data.slice(0,1) });
        }
        else if ($routeParams.entityId && data.length > 0){
            $scope.current.selectedHouseholdId = data[0].clientId;
        }
        setQuickFiltersFromSession();
    });

    $scope.$on('slickgrid-last-refresh', function(event, data) {
        $scope.current.lastUpdated = data;
    });

    $scope.$on('event:slickgrid-columnfilter-change', function (e, args) {
        if ($scope.current.selectedHouseholdId) {
            const newValJson = JSON.stringify(args);
            const key = $scope.user.authorization.alClientId + '_' + $scope.current.selectedHouseholdId + '_' + pageEntityType;
            const portfolioFiltersJson = sessionStorage.getItem('porfolio_grid_filters');
            let portfolioFilters = {};
            if (portfolioFiltersJson) {
                portfolioFilters = JSON.parse(portfolioFiltersJson);
                if (!(key in portfolioFilters)) {
                    // make sure no other entries exist at the same time
                    portfolioFilters = {};
                }
            }
            portfolioFilters[key] = newValJson;
            sessionStorage.setItem('porfolio_grid_filters', JSON.stringify(portfolioFilters));
        }
    });

    // INITIALIZE
    $scope.views = views;
    $scope.reportArgs = {};
    $scope.selectedIds = [];
    $scope.repPayout = {
        clientId: null,
        isActiveTab: false
    };
    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        gridQueries: [],
        url: '/Portfolio/Registrations/Grid',
        useOData: false,
        useServerSideRowModel: false,
        gridParams: '',
        odataListProfileKey: 'registration',
        gridLimitsReady: false,
        portfolioListFiltersReady: false,
        gridRowCountsReady: false,
        portfolioGridLimitsSettingEnabled: false,
        portfolioSsrmEnabled: false,
        slickGridRecordColumnLimitEnabled: false,
        gridRecordLimit: 0,
        viewsColumnsLimit: 0,
        detailInfo: '',
        selectedHouseholdId: 0,
        activeStates: activeState,
        registrationFilter: $routeParams.registrationFilter,
        pageQueryId: $routeParams.pageQueryId,
        repId: null,
        accountId: null,
        investmentObjective: $routeParams.investmentObjective,
        insightUrl: API_CONFIG.insightUrl + '?p=dashboards&t=' + sessionStorage.oas_token,
        refreshCache: false,
        lastUpdated: null,
        entity: null
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        $scope.openEditor(false);
    }}];

    init();
});

'use strict';

app.controller('RegistrationEditCtrl', function RegistrationEditCtrl($scope, $http, $q, $location, $dialog, $oasRights, $portfolio, dialog, args, additionalAnnualAmtType, entities, apps, sleeveType, $tradeGenerator, $timeout, API_CONFIG, $templateCache, splitIoService, targetAllocationSaveValidator, advisorTradingEmbedService, advisorTradingEmbedHostMessageTypes) {
    var additionalRepsPercent = [];
    var dateFormat = '{MM}/{dd}/{yyyy}';
    var botDate = '1/1/1900';
    var eotDate = '12/31/9999';


    //region PRIVATE VARIABLES
    var registrationGeneralOriginal,
        registrationContactOriginal,
        registrationBeneficiariesOriginal,
        registrationDecedentOriginal,
        additionalRepresentativesPercentOriginal,
        registrationNotesOriginal,
        registrationSuitabilityOriginal,
        registrationSleeveOriginal,
        registrationTrusteeOriginal,
        entityOptionsOriginal,
        customFieldsOriginal,
        beneficiaryTypesOriginal,
        editorHotKeys,
        rowId = -1,
        billingFeePayingAccountsOriginal,
        changeHistoryOriginal,
        registrationRepPayoutsOriginal,
        regChangeStartDate,
        inputDisabled = true,
        registrationTargetAllocationsOriginal,
        registrationAdditionalClientsOriginal,
        retainedOverlayId,
        hasRetainedOverlayId = false;
    //endregion

    function retainOverlayIdFrom(sleeveReg) {
        if (sleeveReg && Object.prototype.hasOwnProperty.call(sleeveReg, 'overlayId')) {
            retainedOverlayId = sleeveReg.overlayId;
            hasRetainedOverlayId = true;
        }
    }

    function applyRetainedOverlayId(sleeveReg) {
        if (sleeveReg && hasRetainedOverlayId) {
            sleeveReg.overlayId = retainedOverlayId;
        }
    }

    $templateCache.put("RegistrationEditorSleeveTemplate", `<a><span ng-bind-html="match.label | typeaheadHighlight:query"></span></a>`);

    //region PRIVATE METHODS
    function nextRowId() {
        return ++rowId;
    }

    function resetRowId() {
        rowId = -1;
    }

    $scope.resetDSSN = function (selected, record) {
        if (selected !== 0 && record !== undefined) {
            $scope.current.isBIRA = record.isBIRA;
        }
    };

    $scope.invalidContactEmail = function (invalid) {
        $scope.registrationContact.invalidEmail = invalid;
    }

    $scope.setContactEmail = function (value) {
        $scope.registrationContact.email = value;
    }

    function bootstrapRegistrationEditor() {
        if (args.isNew) {
            buildMenu();
            $scope.loadTab(args.defaultTab);
        } else {
            $http.get("/Portfolio/Registrations/" + args.ids[0] + "/FirstActiveAccount/Custodian/EntityOptions/Code/69SLEEVETR", { cache: true, ignoreExceptions: true })
                .then(function (response) {
                    var data = response.data;
                    if (data && data.value.toLowerCase() === "false") {
                        $scope.rightsSleeveSetup.canRead = false;
                    }

                    buildMenu();
                    $scope.loadTab(args.defaultTab);
                }, function error() {
                    buildMenu();
                    $scope.loadTab(args.defaultTab);
                });
        }
        loadSubAdvisorsForRegistration(args.ids[0]);
        loadEnumLookUps();
        loadBeneficiariesRelationships();
        loadHotKeys();
        if (!dialog) {
            window.parent.postMessage("iframeload");
        }
    }

    function init() {
        $http.get("/Settings/Database/EntityOptions/Code/RepPayoutPercent").then(function (response) {
            $scope.isRepPayoutPercentEnabled = response.data.value === "True";

            splitIoService.getBoolTreatment('opex_Rep_Split_5809').subscribe((isEnabled) => {
                $scope.isNewRepSplitFlagEnabled = isEnabled;

                loadRights();
                $scope.hasReadOnlyAccess = !$scope.rightsSleeves.canUpdate;
                $scope.ssaEclipseFirmFeatureFlag = false;
                $scope.sleeveSetupInvestmentCategoryFlag = false;
                splitIoService.getBoolTreatment('OC_SSA_Eclipse_Sync_260157').subscribe((isEnabled) => {
                    $scope.ssaEclipseFirmFeatureFlag = isEnabled;
                });
                splitIoService.getBoolTreatment('OC_Sleeve_Setup_Investment_Category_b17795').subscribe((isEnabled) => {
                    $scope.sleeveSetupInvestmentCategoryFlag = isEnabled;
                });

                splitIoService.getBoolTreatment('oc_portfolioAudit_sharedTargetAllocation_31732').subscribe((isEnabled) => {
                    $scope.useSharedTargetAllocationEditor = isEnabled;

                    $scope.current.allowCustomization = true;
                    //check entity option to show/hide billing feature
                    $http.get('/Settings/Database/EntityOptions/Code/69ENABLESL', { trackerMsg: 'Checking settings...' })
                        .then(function (response) {
                            if (response.data && response.data.value) {
                                $scope.current.showSleeveBillingTab = response.data.value.toLowerCase() === 'true';
                            }
                        });

                    //option to show/hide model substitutions
                    $http.get('/Settings/Database/EntityOptions/Code/1:69SHOWSL', { trackerMsg: 'Checking settings...' })
                        .then(function (response) {
                            if (response.data && response.data.value) {
                                $scope.current.showSleeveStrategyModelSubstitutions = response.data.value.toLowerCase() === 'true';
                            }
                        });

                    splitIoService.getBoolTreatment('Overlay_Sleeve_Assignment_SMaC_18634').subscribe((isEnabled) => {
                        $scope.overlaySleeveAssignmentEmbedEnabled = isEnabled;
                        $scope.overlaySleeveAssignmentEmbedResolved = true;

                        bootstrapRegistrationEditor();
                    });
                });
            });
        });

        $http.get("/Settings/EntityOptions/Database/0/code/69MULTITRADEBLOCK", { trackerMsg: 'Loading Entity Option' })
            .then(function (response) {
                $scope.multiTradeBlockFF = response.data.value === "True";
            });

        splitIoService.getBoolTreatment('TEXP_read_only_registration_trade_block_12485').subscribe((isEnabled) => {
            $scope.multiTradeBlockFeatureFlag = isEnabled;
        });
    }

    function loadSubAdvisorsForRegistration(registrationId) {
        $scope.subAdvisorForRegistrationCache = {};
        $http.get("/Portfolio/SubAdvisors/Simple?registrationId=" + registrationId + "&modelAggType=", { trackerMsg: 'Loading sub-advisors' })
            .then(function (response) {
                $scope.subAdvisorForRegistrationCache[registrationId] = response.data;
            });
    }

    function loadRights() {
        $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
        $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
        $scope.rightsNotes = $oasRights.forCode("NOTES");
        $scope.rightsEOs = $oasRights.forCode("ENTITYOPTION");
        $scope.rightsSSNView = $oasRights.forCode("SSNVIEW");
        $scope.rightsSSNChange = $oasRights.forCode("SSNCHANGE");
        $scope.rightsMoveRegistration = $oasRights.forCode("MOVEREGISTRATION");
        $scope.rightsSleeveSetup = $oasRights.forCode("SLEEVESETUP");
        $scope.rightsSleeveStrategy = $oasRights.forCode("SLEEVE_STRATEGY");
        $scope.rightsSleeves = $oasRights.forCode("SLEEVES");
        $scope.rightsSuitability = $oasRights.forCode("INVESTMENTOBJ");
        $scope.rightsEclipseAdmin = $oasRights.forCode("ECLIPSEORIONADMIN");
        $scope.rightsEclipseTrading = $oasRights.forCode("ECLIPSETRADING");
        $scope.rightsActiveStatus = $oasRights.forCode("ACTIVESTATUS");
        $scope.rightsDoNotTrade = $oasRights.forCode("CHANGEDONOTTRADE");
        $scope.rightsBilling = $oasRights.forCode("ACCTBILLING");
        $scope.rightsBillingException = $oasRights.forCode("BILLINGEXCEPTION");
        $scope.rightsFeeSchedule = $oasRights.forCode("FEESCHEDULES");
        $scope.rightsCustomFields = $oasRights.forCode("CUSTOMFIELDS");
        $scope.isAdminOrRia = ["Administrator", "Advisor"].any($scope.user.authorization.entity);
        $scope.rightsOrionEnterpriseProposal = $oasRights.forCode("ORIONENTERPRISEPROPOSAL");
        $scope.rightsDeceasedSSNView = $oasRights.forCode("SSNVIEW");
        $scope.rightsDeceasedSSNChange = $oasRights.forCode("SSNCHANGE");
        $scope.rightsPortfolioRepresentativePayouts = $oasRights.forCode('PORTFOLIOREPRESENTATIVEPAYOUTS');
        $scope.isRegistrationDecedentDobValid = true;
        $scope.rightsRMD = $oasRights.forCode('RMD');
        $scope.rightsBeneficiaryTrust = $oasRights.forCode('BENEFICIARYTRUST');
        $scope.rightsTargetAllocation = $oasRights.forCode('TARGETALLOCATION');
        $scope.rightsExternalRegs = $oasRights.forCode('EXTERNALREGISTRATIONS');
        $scope.registrationVerbose = { targetAllocations: undefined };
    }

    function buildMenu() {
        var canLoadSettings = $scope.rightsCustomFields.canRead || (!args.isNew && $scope.rightsEOs.canRead);

        if (!$scope.rightsSleeveSetup.canRead && args.defaultTab.code === "sleeveSetup") {
            args.defaultTab.code = "registrationGeneral";
        }

        var i = 0;
        $scope.menu = { categories: [] };

        $scope.menu.categories.push({ name: 'Registration', children: [] });

        $scope.menu.categories[i].children.push({ name: 'General', active: false, code: 'registrationGeneral' });

        $http.get("/Settings/Database/EntityOptions/Code/69USEREPCHANGEHISTORY", { trackerMsg: 'Checking Billing Registration Change History' })
            .then(function (response) {
                $scope.rightsRegChangeHistory = response.data.value === "True";

                if ($scope.rightsRegChangeHistory && !$scope.isNewRepSplitFlagEnabled) {
                    $scope.menu.categories[0].children.splice(1, 0, { name: 'Change History', active: false, code: 'changeHistory', children: [] });
                }
            });

        if ($scope.rightsBeneficiaryTrust.canRead) {
            $scope.menu.categories[i].children.push({ name: 'Beneficiary/Trust', active: false, code: 'beneficiaryTrust' });
        }

        if ($scope.rightsRMD.canRead) {
            $scope.menu.categories[i].children.push({ name: 'RMD', active: false, code: 'requiredMinimumDistribution' });
        }

        if ($scope.rightsNotes.canRead && !args.isNew) {
            $scope.menu.categories[i].children.push({ name: 'Notes', active: false, code: 'notesAndDocuments' });
        }

        if ($scope.rightsSuitability.canRead) {
            $scope.menu.categories[i].children.push({ name: 'Suitability', active: false, code: 'suitability' });
        }

        if ($scope.rightsTargetAllocation.canRead && $scope.useSharedTargetAllocationEditor) {
            $scope.menu.categories[i].children.push({ name: 'Target Allocation', active: false, code: 'targetAllocation' });
        }

        if ($scope.rightsExternalRegs.canRead) {
            $scope.menu.categories[i].children.push({ name: 'Associated Households', active: false, code: 'additionalClients' });
        }

        if ($scope.rightsBilling.canRead) {
            i++;
            $scope.menu.categories.push({ name: 'Billing', children: [] });
            if ($scope.rightsBilling.canRead) {
                $scope.menu.categories[i].children.push({ name: 'Fee Paying Accounts', active: false, code: 'feePayingAccounts' });
            }
            if ($scope.isRepPayoutPercentEnabled) {
                $scope.menu.categories[i].children.push({ name: 'Representative Payouts', active: false, code: 'representativePayouts' });
            }
        }

        if (!args.isNew) {
            if ($scope.rightsSleeveSetup.canRead) {
                i++;
                $scope.menu.categories.push({
                    name: 'Trading', children: [
                        { name: 'Sleeve Setup', active: false, code: 'sleeveSetup' }
                    ]
                });
            }
        }

        if (canLoadSettings) {
            i++;
            $scope.menu.categories.push({ name: 'Settings', children: [] });

            if ($scope.rightsCustomFields.canRead) {
                $scope.menu.categories[i].children.push({ name: 'Custom Fields', active: false, code: 'customFields' });
            }

            if (!args.isNew) {
                if ($scope.rightsEOs.canRead) {
                    $scope.menu.categories[i].children.push({ name: 'Options', active: false, code: 'entityOptions' });
                }
            }
        }
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                { combo: 'ALT+S', command: $scope.save },
                { combo: 'ALT+X', command: function () { $scope.close(true); } }
            ]);
        });
    }

    function loadLegacySleeveSetupTab() {
        loadSleeveSetup(false);
        loadEclipseFirmsByAlClient();
        loadDefaultEclipseFirmIdByAlClient();
        if ($scope.rightsSleeveStrategy.canRead) {
            loadSleeveStrategies();
        }
    }

    function loadEmbeddedSleeveSetupTab() {
        if ($scope.sleeveReg) {
            return;
        }

        $http.get("/Trading/Sleeve/Registrations/" + args.ids[0] + "?includeCostBasis=false", { trackerMsg: 'Loading sleeve data' })
            .then(function (response) {
                applyEmbeddedSleeveSetupSupportingData(response.data);
                loadSleeveRegistrationHistories();
            });
    }

    function applyEmbeddedSleeveSetupSupportingData(sleeveRegData) {
        $scope.sleeveReg = sleeveRegData;
        retainOverlayIdFrom($scope.sleeveReg);

        if (!$scope.sleeveReg.custodialBilling) {
            $scope.sleeveReg.custodialBilling = {
                billFeeScheduleId: null,
                billFeeScheduleName: '',
                billMasterPayoutScheduleId: null,
                billMasterPayoutScheduleName: '',
                recurringAdjustments: []
            };
        }

        if (!$scope.sleeveReg.sleeveBilling) {
            $scope.sleeveReg.sleeveBilling = {
                billFeeScheduleId: null,
                billFeeScheduleName: '',
                billMasterPayoutScheduleId: null,
                billMasterPayoutScheduleName: '',
                recurringAdjustments: []
            };
        }

        $scope.sleeveReg.normalSleeves = function () {
            return $scope.sleeveReg.accountSleeves.filter({ sleeveType: sleeveType.normal.name });
        };

        if ($scope.multiTradeBlockFF) {
            $scope.isSleevedRegistration = $scope.sleeveReg.normalSleeves().length > 0;
        }

        registrationSleeveOriginal = angular.copy($scope.sleeveReg);
    }

    function loadSleeveRegistrationHistories() {
        if (!$scope.sleeveReg || !$scope.sleeveReg.createdBy) {
            return;
        }

        var changeTypeFormats = { U: "Update", I: "Insert", D: "Delete" };

        [{ name: "registration", urlSuffix: "" }, { name: "account", urlSuffix: "/Accounts" }].forEach(function (type) {
            $http.get("/Trading/Sleeve/Registrations/" + args.ids[0] + "/Histories" + type.urlSuffix, { trackerMsg: 'Loading sleeve ' + type.name + ' history' })
                .then(function (response) {
                    const histories = response.data;

                    histories.forEach(function (item) {
                        item.changeType = changeTypeFormats[item.changeType];
                    });

                    $scope[type.name + 'SleeveHistory'] = histories;
                });
        });
    }

    function loadDataForSelectedTab() {
        checkRegistrationSleeveForDirty();

        switch ($scope.current.selectedTab) {
            case "registrationGeneral":
                if ($scope.rightsReg.canRead) {
                    loadRegistration();
                }
                break;
            case "beneficiaryTrust":
                if ($scope.rightsBeneficiaryTrust.canRead) {
                    loadBeneficiaries();
                }
                break;
            case "requiredMinimumDistribution": // formerly just decedent
                if ($scope.rightsRMD.canRead) {
                    loadDecedent();
                }
                break;
            case "notesAndDocuments":
                if ($scope.rightsNotes.canRead) {
                    loadNotes();
                }
                break;
            case "suitability":
                if ($scope.rightsReg.canRead) {
                    loadSuitability();
                }
                break;
            case "feePayingAccounts":
                if ($scope.rightsReg.canRead) {
                    $scope.current.paysForReg = true;
                    loadFeePayingAccounts();
                }
                break;
            case "sleeveSetup":
                if (!$scope.overlaySleeveAssignmentEmbedResolved) {
                    break;
                }

                if ($scope.overlaySleeveAssignmentEmbedEnabled) {
                    loadEmbeddedSleeveSetupTab();
                } else {
                    loadLegacySleeveSetupTab();
                }
                break;
            case "entityOptions":
                if ($scope.rightsEOs.canRead) {
                    loadEntityOptions();
                }
                break;
            case "customFields":
                if ($scope.rightsCustomFields.canRead) {
                    loadCustomFields();
                }
                break;
            case 'representativePayouts':
                if ($scope.isNewRepSplitFlagEnabled && $scope.isRepPayoutPercentEnabled && $scope.rightsPortfolioRepresentativePayouts.canRead) {
                    loadRepPayouts();
                }
                break
            case "additionalClients":
                if ($scope.rightsExternalRegs.canRead) {
                    loadRegistration();
                }
                break;
        }
    }

    // PRIVATE METHODS - LOAD REGISTRATION
    function loadRegistration() {
        if ($scope.registrationGeneral) return;

        $http.get("/Settings/Database/EntityOptions/Code/69SHOWREGI", { cache: true, trackerMsg: 'Loading settings' })
            .then(function (response) {
                $scope.current.showAddress = response.data.value.toLowerCase() === "true";

                var expandString = ($scope.isNewRepSplitFlagEnabled && $scope.isRepPayoutPercentEnabled) ? "portfolio" : "portfolio,AdditionalRepresentativesPercent";
                $http.get('/Portfolio/Registrations/Verbose/' + (args.isNew ? 'New' : args.ids[0]) + `?expand=${expandString}` + ($scope.current.showAddress ? ",contact" : ""), { trackerMsg: 'Loading registration' })
                    .then(function (response) {
                        var data = response.data;
                        if (data.contact) {
                            $scope.registrationContact = data.contact;
                            $scope.registrationContact.invalidEmail = false;
                            registrationContactOriginal = angular.copy($scope.registrationContact);
                        }

                        if (args.isNew && (args.extraInfo && args.extraInfo.fkClient)) {
                            data.portfolio.clientId = args.extraInfo.fkClient;
                        }

                        if (!args.isNew || (args.extraInfo && args.extraInfo.fkClient)) {
                            var urlGetClient = '/Portfolio/Clients/' + data.portfolio.clientId;

                            $http.get(urlGetClient, { trackerMsg: 'Loading household registrations' })
                                .then(function (response) {
                                    var hhData = response.data;
                                    hhData.description = hhData.id + ' - ' + hhData.name;
                                    $scope.current.hhList.push(hhData);

                                    $scope.registrationGeneral = data.portfolio;
                                    $scope.registrationGeneral.clientId = hhData.id;
                                    $scope.additionalRepresentativesPercent = data.additionalRepresentativesPercent;
                                    $scope.current.isBIRA = $scope.registrationGeneral.isBIRA;
                                    $scope.setAge();
                                    registrationGeneralOriginal = angular.copy($scope.registrationGeneral);
                                    additionalRepresentativesPercentOriginal = angular.copy($scope.additionalRepresentativesPercent);
                                    $scope.current.registrationLoaded = true;
                                    $scope.chsts = [];
                                    $scope.changesFullSet = [];
                                    $scope.isDataSharingEntity = data.isDataSharingEntity;
                                    if (!$scope.isNewRepSplitFlagEnabled) {
                                        loadChangeHistory();
                                    }
                                });
                        } else {
                            $scope.registrationGeneral = data.portfolio;
                            $scope.additionalRepresentativesPercent = data.additionalRepresentativesPercent;
                            $scope.setAge();
                            registrationGeneralOriginal = angular.copy($scope.registrationGeneral);
                            additionalRepresentativesPercentOriginal = angular.copy($scope.additionalRepresentativesPercent);
                        }

                    });
            });
    }

    // PRIVATE METHODS - LOAD BENEFICIARIES
    function loadBeneficiaries() {
        if ($scope.registrationBeneficiaries || $scope.custodialBeneficiaries) {
            return;
        }

        $scope.beneficiaryTypes = ['Primary', 'Contingent'];
        beneficiaryTypesOriginal = angular.copy($scope.beneficiaryTypes);

        $q.all({
            dbeo: $http.get('/Settings/Database/EntityOptions/Code/69USECUSTODIALBENEDATA', {cache: true, trackerMsg: 'Loading options'}),
            beneficiaries: $http.get("/Portfolio/Registrations/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=beneficiaries", { trackerMsg: 'Loading beneficiaries' })
        }).then(function (responses) {
            const data = responses.beneficiaries.data;

            if (responses.dbeo.data.value === 'True' && data.custodianBeneficiary.length > 0) {
                data.custodianBeneficiary.forEach(beneficiary => {
                    beneficiary.dateOfBirth = beneficiary.dateOfBirth ? Date.create(beneficiary.dateOfBirth).formatted() : '';
                });
                $scope.custodialBeneficiaries = data.custodianBeneficiary;
                return;
            }

            //if there's a trustee; then grab it from data and put int object $scope.trustee
            const trusteeIndex = data.beneficiaries.findIndex(function (x) {
                return (x.type ? x.type.toLowerCase() : "") === 'trustee';
            });
            if (trusteeIndex > -1) {
                $scope.trustee = data.beneficiaries.splice(trusteeIndex, 1)[0];
                registrationTrusteeOriginal = angular.copy($scope.trustee);
                if ($scope.trustee) {
                    $scope.current.useTrustee = true;
                }
            }
            //data will contain either all beneficiaries or a spliced version with trustee removed (from above)
            $scope.registrationBeneficiaries = data.beneficiaries;

            $scope.registrationBeneficiaries.forEach(function (b) {
                b.originalType = b.type;
                b.editMode = false;
                if (b.type && $scope.beneficiaryTypes.none(b.type) && b.type.toLowerCase() !== 'trustee') {
                    $scope.beneficiaryTypes.push(b.type);
                }
            });
            totalPercents();

            registrationBeneficiariesOriginal = angular.copy($scope.registrationBeneficiaries);
        });
    }

    function loadBeneficiariesRelationships() {
        $http.get('/Portfolio/Registrations/Beneficiary/Relations', { trackerMsg: 'Loading relationships for beneficiaries' })
            .then(function (response) {
                $scope.current.beneficiaryRelationships = response.data;
            });
    }

    function loadFeePayingAccounts() {
        if ($scope.billingFeePayingAccounts) return;

        $http.get("/Portfolio/Registrations/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=feePayingAccounts", { trackerMsg: 'Loading fee paying accounts' })
            .then(function (response) {
                response.data.feePayingAccounts.forEach(function (acct) {
                    acct.payPercent = (acct.payPercent * 100).round(3);
                });

                $scope.billingFeePayingAccounts = response.data.feePayingAccounts;
                billingFeePayingAccountsOriginal = angular.copy($scope.billingFeePayingAccounts);
            });
    }

    // PRIVATE METHODS - LOAD DOCUMENTS AND NOTES
    function loadNotes() {
        if ($scope.registrationNotes) return;

        $http.get("/Portfolio/Registrations/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=notes", { trackerMsg: 'Loading notes' })
            .then(function (response) {
                $scope.registrationNotes = response.data.notes;
                registrationNotesOriginal = angular.copy($scope.registrationNotes);
            });
    }

    // PRIVATE METHODS - LOAD SUITABILITY
    function loadSuitability() {
        if ($scope.registrationSuitability) return;

        $http.get("/Portfolio/Registrations/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=suitability", { trackerMsg: 'Loading suitability' })
            .then(function (response) {
                $scope.registrationSuitability = response.data.suitability;
                $scope.setBondPercent();
                registrationSuitabilityOriginal = angular.copy($scope.registrationSuitability);
            });
    }

    // PRIVATE METHODS - LOAD SLEEVE
    function loadSleeveStrategies() {
        const registrationId = $scope.current.registrationId;
        $http.get('/Trading/SleeveStrategyAggregate/Simple?registrationId=' + registrationId, { cache: false, trackerMsg: 'Getting Sleeve Strategies' })
            .then(function (response) {
                const data = response.data;
                if (data.length) {
                    data.unshift({ id: null, name: 'Custom Sleeve' });
                }
                $scope.sleeveStrategiesOriginal = data;
                $scope.sleeveStrategies = data;
                if ($scope.sleeveReg && $scope.sleeveReg.accountSleeves && $scope.sleeveReg.accountSleeves[0].registrationId > 0) {
                    $scope.current.sleeveStrategyAgg = $scope.sleeveStrategies.find({ id: $scope.current.sleeveStrategyAggId });
                }
            });
    }

    function loadEnumLookUps() {
        var list = {
            annualAmtTypes: additionalAnnualAmtType

        };

        Object.each(list, function (key, value) {
            $scope[key] = $portfolio.enumToSimpleList(value);
        });

        loadAdjustmentTypes();
        loadBillingEntities();
    }

    function loadEclipseFirmsByAlClient() {
        $http.get('/Integrations/Eclipse/Firms/ByAlClientId/' + $scope.user.authorization.alClientId, { trackerMsg: 'Loading Eclipse Firms' })
            .then(function (response) {
                response.data.forEach(firm => {
                    if (firm.alClients && firm.alClients.length && firm.alClients[0].isDefaultEclipseFirm) {
                        $scope.current.defaultEclipseFirmName = firm.name;
                    }
                });
                $scope.eclipseFirmList = response.data;
            });
    }

    function loadDefaultEclipseFirmIdByAlClient() {
        $http.get('/Integrations/Eclipse/Firms/DefaultByAlClientId/' + $scope.user.authorization.alClientId, { trackerMsg: 'Loading Default Eclipse Firm' })
            .then(function (response) {
                $scope.defaultEclipseFirmId = response.data;
            });
    }

    function loadSleeveSetup(forceReload, reset) {
        if ($scope.sleeveReg && !forceReload && !reset) {
            return;
        }

        if (forceReload) {
            $scope.errors = [];
            $scope.sleeveReg = null;
            registrationSleeveOriginal = null;
        }

        if (reset) {
            $scope.current.sleeveDetails = null;
            if ($scope.sleeveReg) {
                $scope.sleeveReg.normalGroupedSleeves = null;
            }
            return;
        }

        $http.get("/Trading/Sleeve/Registrations/" + args.ids[0] + "/Check", { trackerMsg: 'Validating registration' })
            .then(function (responseValidataion) {
                var validation = responseValidataion.data;

                if (validation == null || !validation.message) {
                    // An empty validation message means there is no error or warning to display.
                    loadSleeveDetails();
                    return;
                }

                if (!validation.isError) {
                    // If isError is not true, Warning is assumed and we prompt..
                    $dialog.confirmAction(validation.message + " Would you like to continue processing?")
                        .open()
                        .then(function (result) {
                            if (result === 'yes') {
                                loadSleeveDetails();
                            } else {
                                $scope.errors.push({ type: 'warning', title: 'Warning! ', msg: validation.message });
                            }
                        });
                    return;
                }

                if (!validation.promptToSplit) {
                    // isError == true and not prompting -- this is a hard stop.
                    $scope.errors.push({ type: 'error', title: 'Invalid Registration! ', msg: validation.message });
                    $scope.hasErrors = true;

                    if (validation.alwaysLoadSleeves) {
                        // Loading sleeve details here might cause an HTTP 400 error, which is what alwaysLoadSleeves prevents.
                        loadSleeveDetails();
                    }
                    return;
                }

                $dialog.confirmAction(validation.message + " Would you like to create separate registrations for each account so it can be sleeved?")
                    .open()
                    .then(function (result) {
                        if (result !== 'yes') {
                            $scope.errors.push({ type: 'error', title: 'Multiple Accounts! ', msg: ' Multiple active accounts exist for this registration.' });
                            $scope.hasErrors = true;
                            return;
                        }

                        $http.put("/Portfolio/Registrations/" + args.ids[0] + "/Action/Split", null, { trackerMsg: 'Splitting registration' })
                            .then(function (responseReg) {
                                var registration = responseReg.data;
                                var householdingUrl = '/portfolio/household/householding?entityId1=' + registration.clientId;
                                if (!$scope.current.singleTabMode) {
                                    $scope.close(false);
                                    $location.url(householdingUrl);
                                    return;
                                }

                                if (args.extraInfo.accountId) {
                                    $http.get("/Portfolio/Accounts/" + args.extraInfo.accountId, { trackerMsg: 'Loading account' })
                                        .then(function (response) {
                                            $location.url("/portfolio/edit/registrations/" + response.data.registrationId + "?tabCode=sleeveSetup");
                                        });
                                } else {
                                    $location.url(householdingUrl);
                                }
                            });
                    });
            });
    }

    function loadSleeveDetails() {
        $q.all({
            selfDirectedId: $http.get("/Settings/Database/EntityOptions/Code/SELFDIRECTEDSUBADVID", { cache: true, trackerMsg: 'Loading model settings' }),
            maxNumberOfSleeves: $http.get('/Settings/Database/EntityOptions/Code/69MAXNUMBE', { cache: true, trackerMsg: 'Getting max number of sleeves' }),
            sleeveAutoRebalance: $http.get('/Settings/Database/EntityOptions/Code/69SLEEVEAU', { cache: true, trackerMsg: 'Loading sleeve options' }),
            modelTypes: $http.get("/Trading/ModelAggs/AggTypes", { cache: true, trackerMsg: "Loading investment categories" }),
            sleeveReg: $http.get("/Trading/Sleeve/Registrations/" + args.ids[0] + "?includeCostBasis=false", { trackerMsg: 'Loading sleeve data' }),
            canDeleteSleeves: $http.get('/Portfolio/Transactions/ValidationForUnsleeving/' + args.ids[0], { trackerMsg: 'Validating if sleeves can be deleted' }),
            enableDollarSleeves: $http.get('/Settings/Database/EntityOptions/Code/69ENABLEDO', { cache: true, trackerMsg: 'Verifying dollar sleeves allowed' }),
            tolerancePercentDefault: $http.get('/Settings/Database/EntityOptions/Code/69SLEEVETO', { cache: true, trackerMsg: 'Retrieving tolerance percent default' }),
            showRiskScore: $http.get('/Settings/Database/EntityOptions/Code/69SLVRSKEE', { cache: true, trackerMsg: 'Checking for risk score' })
        }).then(function (responses) {
            //process selfDirectedId and modelTypes
            $scope.mandates = {
                enabled: responses.selfDirectedId.data.value !== "0",
                isSelfDirected: function (sleeve) {
                    return sleeve.subAdvisorId === parseInt(responses.selfDirectedId.data.value);
                },
                setSelectedModel: function (sleeve, models) {
                    sleeve.model = sleeve.model
                        ? models.find({ id: sleeve.model.id }) || null
                        : null;

                    if ($scope.user.isFTJ
                        && sleeve.sleeveType !== sleeveType.normal.name) {
                        //FTJ doesn't set these values on special sleeves
                        sleeve.model = null;
                        sleeve.modelAgg = null;
                        sleeve.modelAggId = null;
                    }

                    $scope.calculateSleeveRiskScores();
                },
                modelTypes: responses.modelTypes.data,
                subAdvisorCache: {
                    list: {},
                    clear: function () {
                        this.list = {};
                    },
                    clearFor: function (sleeve) {
                        let cacheVal = this.list[sleeve.rowId];

                        if (cacheVal) {
                            this.list[sleeve.rowId] = null;
                        }
                    },
                    getFor: function (sleeve) {
                        let cacheVal = this.list[sleeve.rowId];

                        //this prevents us from returning a null entry and making the UI look dumb
                        if (cacheVal) {
                            cacheVal = cacheVal.filter(x => !!x.id);
                        }

                        return cacheVal && cacheVal.length > 0 ? cacheVal : null;
                    },
                    setFor: function (sleeve, data) {
                        this.list[sleeve.rowId] = data;
                    }
                },
                modelCache: {
                    list: {},
                    clear: function () {
                        this.list = {};
                    },
                    clearFor: function (sleeve) {
                        let cacheVal = this.list[sleeve.rowId];

                        if (cacheVal) {
                            this.list[sleeve.rowId] = null;
                        }
                    },
                    getFor: function (sleeve) {
                        let cacheVal = this.list[sleeve.rowId];

                        //this prevents us from returning a null entry and making the UI look dumb
                        if (cacheVal) {
                            cacheVal = cacheVal.filter(x => !!x.id);
                        }

                        return cacheVal;
                    },
                    setFor: function (sleeve, models) {
                        this.list[sleeve.rowId] = models;
                    }
                }
            };

            const assignSleeveStrategyAggregateData = function () {
                $scope.sleeveReg = responses.sleeveReg.data;
                retainOverlayIdFrom($scope.sleeveReg);

                $scope.current.sleeveStrategyAggId = $scope.sleeveReg.sleeveStrategyAggId;
                $scope.current.sleeveStrategyId = $scope.sleeveReg.sleeveStrategyId;
                $scope.current.sleeveStrategyAgg = $scope.sleeveStrategies.find({ id: $scope.current.sleeveStrategyAggId });

                if (!$scope.sleeveReg.custodialBilling) {
                    $scope.sleeveReg.custodialBilling = { billFeeScheduleId: null, billFeeScheduleName: '', billMasterPayoutScheduleId: null, billMasterPayoutScheduleName: '', recurringAdjustments: [] };
                }

                if (!$scope.sleeveReg.sleeveBilling) {
                    $scope.sleeveReg.sleeveBilling = { billFeeScheduleId: null, billFeeScheduleName: '', billMasterPayoutScheduleId: null, billMasterPayoutScheduleName: '', recurringAdjustments: [] };
                }

                $scope.tolerancePercentDefault = responses.tolerancePercentDefault.data.value ? responses.tolerancePercentDefault.data.value.toNumber() : null;

                $scope.sleeveReg.normalSleeves = function () {
                    return $scope.sleeveReg.accountSleeves.filter({ sleeveType: sleeveType.normal.name });
                };

                if ($scope.multiTradeBlockFF) {
                    $scope.isSleevedRegistration = $scope.sleeveReg.normalSleeves().length > 0;
                }

                $scope.sleeveReg.hasSMAModel = function () { return $scope.sleeveReg.accountSleeves.any(x => x.hasSMAModel) || $scope.sleeveReg.accountSleeves.any(x => x.model && x.model.hasSMAModel); };

                $scope.current.toleranceBandPercent = $scope.sleeveReg.tolerancePercent;

                if ($scope.current.toleranceBandPercent) {
                    $scope.current.toleranceCalcMethod = 'fixed';
                    $scope.toggleToleranceCalcMethod(false);
                } else {
                    $scope.current.toleranceCalcMethod = 'range';
                }

                if (!$scope.current.toleranceBandPercent) {
                    $scope.current.toleranceBandPercent = $scope.tolerancePercentDefault;
                }

                $scope.sleeveAutoRebalance = responses.sleeveAutoRebalance.data;

                $scope.showRiskScore = responses.showRiskScore.data.value.toLowerCase() === 'true';

                $scope.canDeleteSleeves = responses.canDeleteSleeves.data === 'true';

                $scope.enableDollarSleeves = responses.enableDollarSleeves.data.value.toLowerCase() === 'true';

                //set max number of sleeves - code below grandfathers in registrations that have more sleeves than when entity option
                //for max number was created.
                var normalSleeveCount = $scope.sleeveReg.normalSleeves().length;
                var maxNumberOfSleeves = responses.maxNumberOfSleeves.data.value.toNumber();
                if (maxNumberOfSleeves !== 0) {
                    $scope.current.maxNumberOfSleeves = normalSleeveCount > maxNumberOfSleeves ? normalSleeveCount : maxNumberOfSleeves;
                } else {
                    $scope.current.maxNumberOfSleeves = maxNumberOfSleeves;
                }

                if ($scope.sleeveReg.sleeveStrategyId) {
                    setRebalanceFrequencies();
                }

                $scope.sleeveReg.specialSleeves = function () {
                    return $scope.sleeveReg.accountSleeves.filter(function (x) {
                        return x.sleeveType !== sleeveType.normal.name;
                    });
                };

                $scope.rebalanceMonths = { Monthly: [{ id: 1, name: "Every Month" }] };
                var buildRebalanceMonths = function (property, max, name) {
                    $scope.rebalanceMonths[property] = (1).upto(max).map(function (value) {
                        return { id: value, name: "Month " + value + " of " + name };
                    });
                };
                buildRebalanceMonths("Quarterly", 3, 'Quarter');
                buildRebalanceMonths("Semiannual", 6, 'Cycle');
                buildRebalanceMonths("Annual", 12, 'Year');

                setRebalanceFrequencies();

                $scope.sleeveReg.accountSleeves.forEach(function (sleeve) {
                    sleeve.rowId = sleeve.rowId || nextRowId();
                    sleeve.modelAllocations = null;

                    if (sleeve.modelAggId) {
                        sleeve.model = { id: sleeve.modelAggId, name: sleeve.modelAgg, riskScore: sleeve.riskScore };
                    }

                    if (sleeve.managementStyle && sleeve.managementStyleId) {
                        sleeve.mStyle = { id: sleeve.managementStyleId, name: sleeve.managementStyle };
                    }

                    sleeve.targetBalanceType = sleeve.targetBalanceType === 'Percent' ? 1 : 0;

                    initSleeveDropdowns(sleeve);
                });

                $scope.sleeveReg.normalGroupedSleeves = groupedSleevesFn();

                $scope.calculateSleeveTotals();
                $scope.calculateSleeveRiskScores();

                registrationSleeveOriginal = angular.copy($scope.sleeveReg);

                loadSleeveRegistrationHistories();
            };
            if (responses.sleeveReg.data.sleeveStrategyAggId) {
                //process sleeveReg
                const url = `/Trading/SleeveStrategyAggregate/SleeveSetup/${responses.sleeveReg.data.sleeveStrategyAggId}`;
                $http.get(`${url}`, { trackerMsg: 'Loading sleeve agg details' })
                    .then(function (sleeves) {
                        $scope.current.sleeveDetails = sleeves.data.details;
                        $scope.current.allowCustomization = sleeves.data.allowCustomization;
                        $scope.hasReadOnlyAccess = sleeves.data.hasReadOnlyAccess;
                        $scope.disableAssignEclipseFirm = $scope.hasReadOnlyAccess || (sleeves.data.eclipseFirmId !== null && $scope.ssaEclipseFirmFeatureFlag);
                        assignSleeveStrategyAggregateData();
                        // if there is only one sleeve in the agg, expand it by default
                        if ($scope.sleeveReg.normalGroupedSleeves && $scope.sleeveReg.normalGroupedSleeves.length === 1) {
                            $scope.sleeveReg.normalGroupedSleeves[0].expanded = true;
                        }
                    });
            } else {
                assignSleeveStrategyAggregateData();
            }
        });
    }

    $scope.sleevesClicked = function () {
        document.getElementById('sleeveStategySearch').focus();
        document.getElementById('sleeveStategySearch').select();
    };

    $scope.searchSleeves = function (searchValue) {
        let data;
        if (!searchValue || searchValue === 'Custom Sleeve') {
            data = $scope.sleeveStrategiesOriginal;
        } else {
            searchValue = searchValue.toLowerCase();

            data = $scope.sleeveStrategiesOriginal.filter(item => {
                return !item.id || (item.name.toLowerCase().indexOf(searchValue) >= 0);
            });
        }

        //sort the results by name, keep 'Custom Sleeve' at the top
        const customSleeve = data.shift();

        data.sort((a, b) => (a.name > b.name) ? 1 : -1);

        data.unshift(customSleeve);

        return data;
    };

    $scope.toggleGroupExpansion = function (group = null) {
        if (!group && (!$scope.sleeveReg.normalGroupedSleeves || !$scope.sleeveReg.normalGroupedSleeves.length)) {
            return;
        }
        if (group) {
            group.expanded = !group.expanded;
        } else {
            const toggleTo = !$scope.current.hasAllExpanded;
            $scope.sleeveReg.normalGroupedSleeves.forEach(group => {
                group.expanded = toggleTo;
            });
        }

        $scope.current.hasAllExpanded = $scope.sleeveReg.normalGroupedSleeves.all({ expanded: true });
    };

    $scope.updateIsCustomizedOnSleeves = function (group) {
        group.isCustomized = !group.isCustomized;

        group.sleeves.forEach(x => {
            x.isCustomized = group.isCustomized;
        });

        //set the allocation validation as true, because we're going to overwrite whatever is in there with the sleeve strategy values anyway
        if (!group.isCustomized) {
            $scope.sleeveReg.normalGroupedSleeves
                .filter(x => x.sleeveStrategyId === group.sleeveStrategyId)
                .forEach(x => {
                    x['contributionAllocationIsValid'] = true;
                    x['distributionAllocationIsValid'] = true;
                    x['targetAllocationIsValid'] = true;
                });
        }
    };

    //groups sleeves up by sleeve strategy
    function groupedSleevesFn() {
        //custom sleeve
        if (!$scope.current.sleeveDetails) {
            return {
                sleeveStrategyId: null,
                name: null,
                sleeves: $scope.sleeveReg.accountSleeves.filter(s => {
                    return s.sleeveType === sleeveType.normal.name;
                })
            };
        }

        //find all the expanded groups
        let expandedSleeveStrategyIds = [];

        if ($scope.sleeveReg.normalGroupedSleeves) {
            expandedSleeveStrategyIds = $scope.sleeveReg.normalGroupedSleeves
                .filter(x => x.expanded)
                .map(x => x.sleeveStrategyId);
        }

        //group sleeves by sleeveStrategy
        return $scope.current.sleeveDetails.map(sd => {
            const group = {
                sleeveStrategyId: sd.sleeveStrategyId,
                name: sd.strategy.name,
                sleeves: $scope.sleeveReg.accountSleeves.filter(s => {
                    return s.sleeveType === sleeveType.normal.name && s.sleeveStrategyId === sd.sleeveStrategyId;
                }),
                isCustomized: false,
                targetAllocation: sd.targetAllocation,
                contributionAllocation: sd.contributionAllocation,
                distributionAllocation: sd.distributionAllocation,
            };

            group.isCustomized = group.sleeves.some(x => {
                return x.isCustomized === true;
            });

            group.allocationIsValid = group['contributionAllocationIsValid']
                && group['distributionAllocationIsValid']
                && group['targetAllocationIsValid'];

            $scope.calculateSleeveRiskScores(group);

            //re-expand any groups that were initially expanded
            if (expandedSleeveStrategyIds.find(x => x === group.sleeveStrategyId)) {
                group.expanded = true;
            }

            return group;
        });
    }

    function initSleeveDropdowns(sleeve) {
        if ($scope.mandates.enabled) {
            $scope.loadMandateSubAdvisors(sleeve);
        }
    }

    function setRebalanceFrequencies() {
        if ($scope.sleeveAutoRebalance.value === 'None' || ($scope.sleeveAutoRebalance.value === 'Self-Directed' && !$scope.mandates.enabled)) return;

        var normalSleeves = $scope.sleeveReg.normalSleeves();
        switch (normalSleeves.length) {
            case 0:
                $scope.rebalanceFrequencies = ["None"];
                break;
            default:
                $scope.rebalanceFrequencies = ["None", "Monthly", "Quarterly", "Semiannual", "Annual"];
        }

        if ($scope.rebalanceFrequencies.none($scope.sleeveReg.autoRebalFrequency)) {
            $scope.sleeveReg.autoRebalFrequency = $scope.rebalanceFrequencies[0];
            $scope.resetRebalanceMonthDay();
        }
    }

    function checkRegistrationSleeveForDirty() {
        if (!$scope.sleeveReg) {
            return false;
        }

        // ignore these properties (can cause false positives when comparing object differences)
        const ignoreProperties = ['riskScore', 'riskScoreTotal', 'subAdvisorName', 'hasSMAModel', 'expanded'];
        let differences = Object.compare(registrationSleeveOriginal, $scope.sleeveReg);

        differences = differences.filter(d => ignoreProperties.indexOf(d) < 0);

        if (differences.length) {
            const message = { type: 'error', title: 'Unsaved Changes!', msg: 'There are unsaved changes to sleeve setup.' };
            if ($scope.errors.none(message)) {
                $scope.errors.push(message);
            }
            return true;
        }
        return false;
    }

    // PRIVATE METHODS - LOAD ENTITY OPTIONS
    function loadEntityOptions() {
        if ($scope.entityOptions) return;

        $http.get("/Settings/EntityOptions/Registrations/" + args.ids[0], { trackerMsg: 'Loading options' })
            .then(function (response) {
                $portfolio.cleanCustomFields(response.data);
                $scope.entityOptions = response.data;
                entityOptionsOriginal = angular.copy(response.data);
            });
    }

    // PRIVATE METHODS - LOAD CUSTOM FIELDS
    function loadCustomFields() {
        if ($scope.customFields) return;

        $http.get(args.isNew ? '/Settings/UserDefinedFields/Definitions/Registration' : '/Portfolio/Registrations/' + args.ids[0] + '/UserDefinedFields', { trackerMsg: 'Loading custom fields' })
            .then(function (response) {
                if (args.isNew) {
                    $scope.customFields = response.data.map(function (definition) {
                        return $portfolio.makeCustomFieldFromDefinition(definition, "Registration");
                    });
                } else {
                    $scope.customFields = response.data;
                }

                $portfolio.cleanCustomFields($scope.customFields);
                customFieldsOriginal = angular.copy($scope.customFields);
            });
    }


    // PRIVATE METHODS - LOAD CHANGE HISTORY
    $scope.addChangeHistory = function (chst) {
        if (checkPendingChange()) {
            return;
        }
        if (chst) {
            chst.asOfDate = Date.create(chst.asOfDate);
            $scope.chsts.insert(chst, 0);

            chst.changes.forEach(change => {
                $scope.changesFullSet.push({
                    id: chst.id,
                    registrationId: chst.registrationId,
                    asOfDate: Date.create(chst.asOfDate),
                    entityType: change.entityType,
                    entityId: change.entityId,
                    entityName: change.entityName,
                    entityNumber: change.entityNumber,
                    sourceType: 'Registration',
                    oldBillRepPercentage: change.oldBillRepPercentage,
                    newBillRepPercentage: change.newBillRepPercentage,
                    editedBy: change.editedBy,
                    editedDate: change.editedDate,
                    isDeleted: change.isDeleted,
                    isUncommitted: change.isUncommitted,
                    actionType: change.actionType
                });
            });
        }
        $scope.current.showChangeHistory = !$scope.current.showChangeHistory;
    };

    function loadRepPayouts() {
        if ($scope.registrationRepPayouts) return;

        if ($scope.isNewRepSplitFlagEnabled && $scope.isRepPayoutPercentEnabled) {
            if ($scope.registrationRepPayouts) return;

            $http.get(`/Portfolio/Registrations/${($scope.registrationGeneral?.clientId ?? 0)}/Client/Payouts`, { trackerMsg: 'Loading client payout percentages' }).then(function (response) {
                $scope.clientRepAdditional = response.data;

                if (response && response.data && response.data.length > 0) {
                    $http.get(`/Portfolio/Registrations/Verbose/${(args.isNew) ? "New" : args.ids[0]}?expand=RegistrationRepAdditionals`, { trackerMsg: 'Loading representative payouts' }).then((repPayoutsResponse) => {
                        var repPayouts = repPayoutsResponse.data.registrationRepAdditionals;
                        if (repPayouts && repPayouts.length > 0) {
                            repPayouts.forEach((payout) => {
                                payout.isValid = null;
                            });
                        }

                        $scope.registrationRepPayouts = buildRegistrationRepPayouts(response.data, repPayouts);
                        registrationRepPayoutsOriginal = angular.copy($scope.registrationRepPayouts);
                    })
                }
            });
        }
    }

    function loadChangeHistory() {
        if ($scope.chst || !args?.ids[0]) return;

        var promises = { registrationChanges: $http.get("/Portfolio/RegistrationChanges/" + args.ids[0], { trackerMsg: 'Loading change history' }) };
        promises.addlRepsPercent = $http.get("/Portfolio/Registrations/" + args.ids[0] + "/AdditionalRepresentativesPercent", { trackerMsg: 'Loading additional representatives percent' });

        $q.all(promises)
            .then(function (response) {
                const data = response.registrationChanges.data;
                data.forEach(function (chghst) {
                    chghst.asOfDate = Date.create(chghst.asOfDate);
                    chghst.editedDate = Date.create(chghst.editedDate);
                    chghst.isUncommitted = false;
                });

                additionalRepsPercent = response.addlRepsPercent.data?.map(arp => arp.representativeId);

                $scope.chsts = data;

                $scope.chsts.forEach(chst => {
                    chst.changes.forEach(change => {
                        change.isUncommitted = false;
                        $scope.changesFullSet.push({
                            id: chst.id,
                            registrationId: chst.registrationId,
                            asOfDate: chst.asOfDate,
                            entityType: change.entityType,
                            entityName: change.entityName,
                            entityNumber: change.entityNumber,
                            sourceType: change.sourceType,
                            oldBillRepPercentage: change.oldBillRepPercentage,
                            newBillRepPercentage: change.newBillRepPercentage,
                            editedBy: change.editedBy,
                            editedDate: change.editedDate,
                            isDeleted: change.isDeleted,
                            isUncommitted: change.isUncommitted,
                            actionType: change.actionType
                        });
                    });
                });

                changeHistoryOriginal = angular.copy($scope.chsts);

                if ($scope.chsts.any(vc => vc.changes.any(c => c.isDeleted == false))) {
                    $scope.inputDisabled = true;
                }
                getRepPercentStartDate();

            });
    }

    function buildRegistrationRepPayouts(clientPayouts, repPayoutOverrides) {
        var formattedClientPayouts = [];
        if (clientPayouts && clientPayouts.length > 0) {
            clientPayouts = JSON.parse(JSON.stringify(clientPayouts));

            formattedClientPayouts = clientPayouts.map((payout) => {
                if (payout?.clientRepAdditionals?.length > 0) {
                    payout.clientRepAdditionals.forEach((rep) => {
                        rep.isActive = true;
                        rep.payoutRate = parseFloat(parseFloat(rep.payoutRate * 100).toFixed(2));
                    });
                }

                var startDate = Date.create(payout.startDate);
                var endDate = Date.create(payout.endDate);
                var isStart = Date.create(botDate).getTime() === startDate.getTime();
                var isCurrent = Date.create(eotDate).getTime() === endDate.getTime();

                var repPayoutOverridesForDates = [];
                if (repPayoutOverrides && repPayoutOverrides.length > 0) {
                    repPayoutOverridesForDates = repPayoutOverrides.filter((payoutOverride) => {
                        // Compare dates by stripping time component to match API response format
                        var overrideStartDate = Date.create(payoutOverride.startDate);
                        var overrideEndDate = Date.create(payoutOverride.endDate);

                        // Reset time to midnight for accurate date-only comparison
                        overrideStartDate.setHours(0, 0, 0, 0);
                        overrideEndDate.setHours(0, 0, 0, 0);
                        var compareStartDate = new Date(startDate);
                        var compareEndDate = new Date(endDate);
                        compareStartDate.setHours(0, 0, 0, 0);
                        compareEndDate.setHours(0, 0, 0, 0);

                        return overrideStartDate.getTime() === compareStartDate.getTime() &&
                            overrideEndDate.getTime() === compareEndDate.getTime();
                    });
                }

                return {
                    dateRange: `${isStart ? 'Start' : startDate.format(dateFormat)} - ${isCurrent ? 'Onwards' : endDate.format(dateFormat)}`,
                    reps: formatRepresentativesData(payout.clientRepAdditionals ?? [], repPayoutOverridesForDates)
                }
            })
        }

        return formattedClientPayouts;
    }

    function formatRepresentativesData(reps, repPayoutOverridesForDates) {
        if (reps && reps.length > 0) {
            reps.forEach((rep) => {
                rep.clientRepAdditionalId = rep.id;

                if (repPayoutOverridesForDates && repPayoutOverridesForDates.length > 0) {
                    var repPayoutOverride = repPayoutOverridesForDates.find((payoutOverride) => {
                        return payoutOverride.clientRepAdditionalId === rep.id;
                    });

                    if (repPayoutOverride) {
                        if (repPayoutOverride.payoutRate !== null && repPayoutOverride.payoutRate !== undefined) {
                            rep.payoutRateOverride = parseFloat(parseFloat(repPayoutOverride.payoutRate * 100).toFixed(2));
                        }
                        rep.registrationRepPayoutId = repPayoutOverride.id;
                        rep.isValid = repPayoutOverride.isValid;
                        rep.validationMessage = repPayoutOverride.validationMessage;
                    }
                }

                rep.startDate = rep.startDate ? Date.create(rep.startDate) : null;
                rep.endDate = rep.endDate ? Date.create(rep.endDate) : null;
                if (rep.startDate) {
                    rep.isStartRecord = Date.create(botDate).getTime() === rep.startDate.getTime();
                }
                if (rep.endDate) {
                    rep.isCurrentRecord = Date.create(eotDate).getTime() === rep.endDate.getTime();
                } else {
                    rep.isCurrentRecord = true;
                }
            })
        }

        return reps;
    }

    $scope.validateRepresentatives = function () {
        if (!$scope.registrationRepPayouts) {
            return;
        }

        var clientPayoutOverrides = getClientPayoutOverrides();

        $http.post(`/Portfolio/Registrations/Action/ValidateRepPayouts/${$scope.current.registrationId}`, clientPayoutOverrides, { trackerMsg: 'Validate representative payouts' }).then((response) => {
            // Build with validation results
            let data = buildRegistrationRepPayouts($scope.clientRepAdditional, response.data);
            $scope.registrationRepPayouts = data;
        })
    }

    function getClientPayoutOverrides() {
        var clientPayoutOverrides = null;

        if ($scope.registrationRepPayouts && $scope.registrationRepPayouts.length > 0) {
            clientPayoutOverrides = $scope.registrationRepPayouts.map((payout) => {
                var includePayoutOverrideGroup = false;
                payout.reps.forEach((rep) => {
                    if (rep.payoutRateOverride) {
                        includePayoutOverrideGroup = true;
                    }
                })

                if (includePayoutOverrideGroup) {
                    return payout.reps;
                }
            })?.flat()?.filter(item => item !== undefined);

            if (clientPayoutOverrides && clientPayoutOverrides.length > 0) {
                clientPayoutOverrides = JSON.parse(JSON.stringify(clientPayoutOverrides));
                clientPayoutOverrides.forEach((payout) => {
                    payout.id = payout.registrationRepPayoutId || 0;
                    payout.registrationId = $scope.current.registrationId;

                    if (payout.payoutRateOverride != null) {
                        payout.payoutRateOverride = parseFloat((payout.payoutRateOverride / 100).toFixed(10));
                        payout.payoutRate = payout.payoutRateOverride;
                    } else {
                        payout.payoutRate = parseFloat((payout.payoutRate / 100).toFixed(10));
                    }

                    // Remove time from the start and end dates - use local date components to avoid timezone shifts
                    if (payout.startDate) {
                        var startDate = new Date(payout.startDate);
                        payout.startDate = startDate.getFullYear() + '-' +
                            String(startDate.getMonth() + 1).padStart(2, '0') + '-' +
                            String(startDate.getDate()).padStart(2, '0');
                    }
                    if (payout.endDate) {
                        var endDate = new Date(payout.endDate);
                        payout.endDate = endDate.getFullYear() + '-' +
                            String(endDate.getMonth() + 1).padStart(2, '0') + '-' +
                            String(endDate.getDate()).padStart(2, '0');
                    }
                })
            }
        }

        return clientPayoutOverrides;
    }

    $scope.resetRepresentativeItem = function () {
        if (registrationRepPayoutsOriginal && registrationRepPayoutsOriginal.length > 0) {
            $scope.registrationRepPayouts = JSON.parse(JSON.stringify(registrationRepPayoutsOriginal));
            $scope.registrationRepPayouts.forEach((payout) => {
                payout.reps = formatRepresentativesData(payout.reps);
            });
        }
    }

    function getRepPercentStartDate() {
        let validChanges = $scope.chsts.filter(vc => vc.changes.every(c => c.isDeleted == false));
        let maxDate;
        let startDate;

        if (validChanges.length > 0) {
            maxDate = new Date(Math.max.apply(null, validChanges.map(vc => vc.asOfDate)));
        }

        if (!maxDate) {
            let percentMaxDate = Math.max.apply(null, $scope.additionalRepresentativesPercent.map(vc => new Date(vc.editedDate)));
            if (percentMaxDate) {
                startDate = new Date(percentMaxDate);
            }
            else {
                startDate = null;
            }
        }

        $scope.regChangeStartDate = maxDate ? maxDate.addDays(1) : startDate;
    }


    function checkPendingChange() {
        if ($scope.changesFullSet?.filter(ch => ch.isUncommitted === true)?.length > 0) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Pending Changes",
                "There's a pending change.  Please save before continuing.")
                .open();

            return true;
        }

        return false;
    }
    $scope.deleteChangeHistory = function (chst) {
        if (checkPendingChange()) {
            return;
        }
        // Check Rep Percent
        $dialog.confirmAction("<span> Are you sure you want to delete this record?</span>")
            .open()
            .then(function (result) {
                if (result === 'yes') {

                    if ($scope.changesFullSet.filter(ch => ch.asOfDate > chst.asOfDate && ch.actionType != 'None' && !ch.isDeleted).length > 0) {
                        var month = chst.asOfDate.getMonth() + 1;
                        var day = chst.asOfDate.getDate();
                        var year = chst.asOfDate.getFullYear() >= 2000 ? chst.asOfDate.getYear() - 100 : chst.asOfDate.getYear();

                        $dialog.actionFailed(`Change history that is after ${month}/${day}/${year} must be deleted first.`).open();
                        return;
                    }

                    let allowedDelete = true;

                    // Check saved change for rep with percent assigned
                    if (chst.isUncommitted === false) {
                        if (allowedDelete) {
                            chst.isDeleted = true;
                            const changeSet = $scope.chsts.find(ch => ch.id === chst.id && ch.asOfDate === chst.asOfDate);
                            if (changeSet) {
                                changeSet.changes.forEach(change => {
                                    change.isDeleted = true;
                                    change.isUncommitted = true;
                                });

                                let pendingSet = $scope.changesFullSet?.filter(chg => chg.id === changeSet.id);

                                pendingSet.forEach(change => {
                                    change.isDeleted = true;
                                    change.isUncommitted = true;
                                });
                            }
                        }
                    }
                }
            });
    };

    function saveRegistration(clientPayoutOverrides) {
        // Regular save
        var verboseReg = {};
        var promises = [];
        var abortMessages = [];

        // if ($scope.additionalRepresentativesPercent && $scope.additionalRepresentativesPercent.length > 0 && !$scope.additionalRepresentativesPercent.sum(function (n) { return parseFloat(n['percentage']).round(2) > 0 ? parseFloat(n['percentage']).round(2) : 0 }).almostEquals(100)) {
        //     abortMessages.push("Payout Percent must total 100%.");
        // }

        if (abortMessages.length > 0) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Data", '<ul class="unstyled"><li>' + abortMessages.join("</li><li>") + '</li></ul>').open();
            return;
        }

        if ($scope.registrationGeneral && !angular.equals(registrationGeneralOriginal, $scope.registrationGeneral)) {
            verboseReg["portfolio"] = angular.copy($scope.registrationGeneral);

            //HACK: if you're in India, for example, the timezone makes the date off by one
            if (verboseReg["portfolio"].dob) {
                verboseReg["portfolio"].dob = Date.create(verboseReg["portfolio"].dob).formatted();
            }
            if (verboseReg["portfolio"].initialOwnerDateOfDeath) {
                verboseReg["portfolio"].initialOwnerDateOfDeath = Date.create(verboseReg["portfolio"].initialOwnerDateOfDeath).formatted();
            }
        }

        if (!$scope.isNewRepSplitFlagEnabled && $scope.additionalRepresentativesPercent && !angular.equals(additionalRepresentativesPercentOriginal, $scope.additionalRepresentativesPercent)) {
            verboseReg["additionalRepresentativesPercent"] = $scope.additionalRepresentativesPercent;
        }

        if ($scope.isNewRepSplitFlagEnabled && $scope.isRepPayoutPercentEnabled) {
            if (clientPayoutOverrides != null) {
                if (!angular.equals(registrationRepPayoutsOriginal, clientPayoutOverrides)) {
                    verboseReg['registrationRepAdditionals'] = clientPayoutOverrides;
                }
            }
        }

        if ($scope.registrationContact && !angular.equals(registrationContactOriginal, $scope.registrationContact)) {
            verboseReg["contact"] = $scope.registrationContact;
        }

        if ($scope.registrationNotes && !angular.equals(registrationNotesOriginal, $scope.registrationNotes)) {
            verboseReg["notes"] = $scope.registrationNotes;
        }

        if (($scope.registrationBeneficiaries && !angular.equals(registrationBeneficiariesOriginal, $scope.registrationBeneficiaries)) || ($scope.trustee && !angular.equals(registrationTrusteeOriginal, $scope.trustee))) {
            verboseReg["beneficiaries"] = $scope.registrationBeneficiaries;
        }


        // FYI - since $scope.trustee is not an array it's treated differently during saves.
        // Check Trustee here and if it's different then the original
        if ($scope.trustee && !angular.equals(registrationTrusteeOriginal, $scope.trustee)) {
            // if trustee has properties and is not already in the verbose array
            if (Object.size($scope.trustee) > 0 && verboseReg["beneficiaries"].none(function (n) {
                return n.type.toLowerCase() === 'trustee';
            }))
                verboseReg["beneficiaries"].push($scope.trustee);
        } else if (Object.size($scope.trustee) > 0) {
            //this if check is if nothing changed on the trustee object then make sure it's include in the verbose array; otherwise it will be removed.
            verboseReg["beneficiaries"].push($scope.trustee);
        }

        if ($scope.registrationDecedent && !angular.equals(registrationDecedentOriginal, $scope.registrationDecedent)) {
            verboseReg["decedent"] = $scope.registrationDecedent;
        }


        if ($scope.registrationSuitability && !angular.equals(registrationSuitabilityOriginal, $scope.registrationSuitability)) verboseReg["suitability"] = $scope.registrationSuitability;

        if ($scope.customFields && !angular.equals(customFieldsOriginal, $scope.customFields)) {
            var udfs = $scope.customFields.findAll({ entity: entities.registration.name });
            if (udfs.length) verboseReg["userDefinedFields"] = udfs;
        }


        if ($scope.billingFeePayingAccounts && !angular.equals(billingFeePayingAccountsOriginal, $scope.billingFeePayingAccounts)) {
            $scope.billingFeePayingAccounts.forEach(function (acct) {
                acct.payPercent = acct.payPercent / 100;
            });

            verboseReg["feePayingAccounts"] = $scope.billingFeePayingAccounts;
        }

        if ($scope.entityOptions && !angular.equals(entityOptionsOriginal, $scope.entityOptions)) verboseReg["entityOptions"] = $portfolio.restoreEntityOptions($scope.entityOptions);

        if ($scope.registrationAdditionalClients && !angular.equals(registrationAdditionalClientsOriginal, $scope.registrationAdditionalClients)) {
            verboseReg["additionalClients"] = JSON.parse(JSON.stringify($scope.registrationAdditionalClients));
        }

        if ($scope.useSharedTargetAllocationEditor && registrationTargetAllocationsOriginal !== undefined && $scope.registrationVerbose.targetAllocations !== undefined) {
            if ($scope.rightsTargetAllocation.canUpdate && !angular.equals(registrationTargetAllocationsOriginal, $scope.registrationVerbose.targetAllocations)) {
                verboseReg.targetAllocations = angular.copy($scope.registrationVerbose.targetAllocations);
            }
        }

        if (verboseReg.targetAllocations !== undefined && $scope.useSharedTargetAllocationEditor) {
            targetAllocationSaveValidator.validateRows(verboseReg.targetAllocations).forEach(function (m) {
                abortMessages.push(m);
            });
        }

        if (abortMessages.length > 0) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Data", '<ul class="unstyled"><li>' + abortMessages.join("</li><li>") + '</li></ul>').open();
            $scope.isSaving = false;
            return;
        }

        verboseReg["id"] = args.isNew ? 0 : args.ids[0];
        var msg = args.isNew ? 'Adding ' : 'Saving ';
        var verb = args.isNew ? 'POST' : 'PUT';
        var urlSave = args.isNew ? '/Portfolio/Registrations/Verbose/' : '/Portfolio/Registrations/Verbose/' + args.ids[0];

        promises.push($http({ method: verb, url: urlSave, data: verboseReg, trackerMsg: msg + 'registration' }));

        if ($scope.current.viewSSNReason || $scope.current.updateSSN) {
            promises.push($http.put("/Portfolio/Registrations/" + verboseReg["id"] + "/SSNTaxId", { SSN: $scope.registrationGeneral.ssN_TaxID, Reason: $scope.current.viewSSNReason }, { trackerMsg: 'Saving SSN/Tax ID' }));
        }

        if ($scope.current.viewDeceasedSSNReason || $scope.current.updateDeceasedSSN) {
            promises.push($http.put("/Portfolio/Registrations/" + verboseReg["id"] + "/DeceasedSSNTaxId", { SSN: $scope.registrationGeneral.deceasedSSN_TaxID, Reason: $scope.current.viewDeceasedSSNReason }, { trackerMsg: 'Saving Deceased SSN/Tax ID' }));
        }

        if (!$scope.isNewRepSplitFlagEnabled) {
            if ($scope.chsts && $scope.chsts.length > 0 && !args.isNew && !angular.equals(changeHistoryOriginal, $scope.chsts)) {
                promises.add($http.put('/Portfolio/RegistrationChanges/' + args.ids[0], $scope.chsts, { trackerMsg: 'Saving registration change history' }));
            }
        }

        $q.all(promises).then(function (results) {
            if ($scope.current.isFullPage && !$scope.current.showCancel) {
                $dialog.saveSuccessful("Registration saved.").open();
            } else {
                if (args.app) {
                    var retUrl = '';
                    var savedData = results[0].data;


                    if (!$scope.isNewRepSplitFlagEnabled) {
                        if (savedData?.id && args.isNew) {
                            if ($scope?.chsts && $scope.chsts.length > 0) {
                                $scope.chsts.forEach(c => {
                                    c.registrationId = savedData.id
                                });
                                $http.put('/Portfolio/RegistrationChanges/' + savedData.id, $scope.chsts, { trackerMsg: 'Saving registration change history' }).then(x => { });
                            }
                        }
                    }

                    switch (args.app) {
                        case apps.portfolioLists.name:
                            retUrl = '/Portfolio/Registrations/' + savedData.id;
                            break;
                        case apps.newAccount.name:
                            retUrl = '/Portfolio/Accounts/NewPortfolio?registrationId=' + savedData.id;
                            break;
                        case apps.rmd.name:
                            if (args.extraInfo && args.extraInfo.fkAccount)
                                retUrl = '/Portfolio/Accounts/' + args.extraInfo.fkAccount + '/RMDCalculation?returnstyle=standard';
                            else
                                retUrl = '/Portfolio/Registrations/' + savedData.id;
                            break;
                        default:
                            break;
                    }

                    $http.get(retUrl, { trackerMsg: 'Refreshing registration' })
                        .then(function (response) {
                            var retData = response.data;
                            if (args.isNew) retData.isNew = true;
                            editorHotKeys.destroy();
                            if (dialog) {
                                dialog.close(retData);
                            } else {
                                window.parent.postMessage("iframeclose");
                            }
                        });

                } else {
                    editorHotKeys.destroy();
                    if (dialog) {
                        dialog.close(null);
                    } else {
                        window.parent.postMessage("iframeclose");
                    }
                }
            }
        }).catch(function () {
            $scope.isSaving = false;
        });
    }

    $scope.getChangeHistory = function () {
        let result = [];

        if (!this.changesFullSet) {
            return result;
        }
        let regSource = this.changesFullSet.filter(x => x.sourceType === 'Registration');
        result = regSource;
        let clientSource = this.changesFullSet.filter(x => x.sourceType === 'Client');
        let clientSourcesToAdd = clientSource.filter(cs => cs.isDeleted || !result.where(r => !r.isDeleted).map(x => x.asOfDate.toDateString()).includes(cs.asOfDate.toDateString()));

        clientSourcesToAdd.forEach(csa => result.add(csa));
        return result;
    }

    function totalPercents() {
        var totals = 0;
        $scope.registrationBeneficiaries.forEach(function (item) {
            if (item.type.toLowerCase() === 'primary')
                totals += item.percentage;
        });
        $scope.current.totalPercent = totals;
    }

    function loadAdjustmentTypes() {
        if ($scope.adjTypes) return;

        $http.get("/Billing/AdjustmentTypes?isPayable=false&ispayableAffect=true", { trackerMsg: 'Loading adjustment types' })
            .then(function (response) {
                $scope.adjTypes = response.data;
            });
    }

    function loadBillingEntities() {
        if ($scope.billingEntities) return;

        $scope.billingEntities = [{ id: 0, entityName: "<Prorate by Payouts>", name: "<Prorate by Payouts>", isPayableEntity: true }];

        $http.get("/Billing/BillingEntities", { trackerMsg: 'Loading billing entities' })
            .then(function (response) {
                $scope.billingEntities.add(response.data);
            });
    }

    function getLastDayOfMonth(month) {
        var year = Date.create('today').format('{yyyy}').toNumber();
        $scope.current.lastDayOfMonth = new Date((new Date(year, month, 1)) - 1).getDate();
    }

    function buildSubstituteDropDownList(sleeve, substitutes) {
        //sleeve is the row passed in, using isSubstitute flag, compare what's in the
        //sleeve.substitutes array to the array coming out of the Model Substitution modal.
        //if there's no match then the user removed a model from modal dialog.
        sleeve.substitutes.forEach(function (item) {
            if (item.isSubstitute) {
                var tempObj = substitutes.find({ aggregateModelId: item.aggregateModelId });
                if (!tempObj) {
                    item.markedForDeletion = true;
                }
            }
        });

        //any item marked above gets removed for sleeve substitutes
        sleeve.substitutes.remove({ markedForDeletion: true });

        //this will add any model substitutions the user added from the Model Substitution Modal
        substitutes.forEach(function (item) {
            var temp = sleeve.substitutes.find(item);
            if (!temp) {
                item.isSubstitute = true;
                sleeve.substitutes.add(item);
            }
        });

        //update the the Sleeve Strategy with new model substitutions
        var args = { method: "PUT", url: '/Trading/SleeveStrategy/UpdateSubstitutes/' + sleeve.sleeveStrategyId + '/' + sleeve.sleeveStrategyDetailId, trackerMsg: 'Updating model substitution' };

        $http.put(args.url, substitutes, { trackerMsg: args.trackerMsg })
            .then(function (response) {
                if (response) {
                    $dialog.messageBox('Model Substitution', 'Successfully updated model substitutions').open();
                }
            });
    }

    function aggregateGroupTotals() {
        if (!$scope.current.sleeveDetails) {
            return;
        }

        const toleranceFields = ['toleranceUpper', 'toleranceLower'];
        const allocationFields = ['targetAllocation', 'contributionAllocation', 'distributionAllocation'];

        if ($scope.sleeveReg && $scope.sleeveReg.normalGroupedSleeves) {
            $scope.sleeveReg.normalGroupedSleeves.forEach(group => {
                let sleeveDtl = $scope.current.sleeveDetails.find(sd => sd.sleeveStrategyId === group.sleeveStrategyId);
                toleranceFields.forEach(toleranceField => {
                    if (sleeveDtl) {
                        group[toleranceField] = sleeveDtl[toleranceField];
                    }
                });

                allocationFields.forEach(allocationField => {
                    const expectedTotal = group[allocationField];

                    const actualTotal = group.sleeves
                        .filter(sleeve => !isNaN(+sleeve[allocationField]))
                        .reduce((total, sleeve) => total + (+sleeve[allocationField]), 0);

                    //group total is not valid if expected & actual don't match
                    group[allocationField + 'IsValid'] = actualTotal.almostEquals(expectedTotal);
                });
            });
        }
    }

    $scope.isEntityTradeBlocked = function (event) {
        if ($scope.sleeveReg) {
            $scope.sleeveReg.isDoNotTrade = event;
        }

        // Sync registration Do Not Trade into the Sleeve Allocation iframe when saved trade block state
        // changes. The first emit records baseline state without sending.
        if (!$scope.overlaySleeveAssignmentEmbedEnabled) {
            return;
        }

        if ($scope.sleeveAssignmentEmbedLastTradeBlocked === event) {
            return;
        }

        const previousTradeBlocked = $scope.sleeveAssignmentEmbedLastTradeBlocked;

        $scope.sleeveAssignmentEmbedLastTradeBlocked = event;

        if (previousTradeBlocked === null || previousTradeBlocked === undefined) {
            return;
        }

        advisorTradingEmbedService.sendToIframe({
            type: advisorTradingEmbedHostMessageTypes.REGISTRATION_SLEEVE_STATE,
            isDoNotTrade: event
        });
    }

    //endregion

    //region PUBLIC METHODS

    $scope.calculateToleranceBand = function () {
        if ($scope.current.toleranceCalcMethod === 'fixed') {
            const normalSleeves = $scope.sleeveReg.normalSleeves();
            normalSleeves.forEach(function (item) {
                if (item.targetBalanceType === 1) {
                    const tempPercent = (item.targetAllocation * $scope.current.toleranceBandPercent) / 100;
                    item.toleranceUpper = tempPercent;
                    item.toleranceLower = tempPercent;
                }
            });
        } else {
            $scope.current.toleranceBandPercent = 0;
        }
        aggregateGroupTotals();
    };

    $scope.toggleToleranceCalcMethod = function (isVisible) {
        $scope.isCollapsed = isVisible;
        if (!isVisible) {
            $scope.calculateToleranceBand();
        }
    };

    $scope.toggleGroupDoNotTrade = function (group) {
        group.sleeves.forEach(sleeve => sleeve.doNotTrade = value);
    };

    $scope.doNotTradeChange = function (sleeve) {
    };

    $scope.eclipseFirmChange = function () {
        //a slight delay for before close.
        var finished = function () {
            $timeout(function () {
                $scope.current.savingEclipseFirm = false;
                editorHotKeys.destroy();
                if (dialog) {
                    dialog.close(null);
                } else {
                    window.parent.postMessage("iframeclose");
                }
            }, 500);
        };
        //update eclipse firm on registration
        $scope.current.savingEclipseFirm = true;

        var url = '/Trading/Sleeve/Registrations/UpdateFirmId/' + args.ids[0];
        if ($scope.sleeveReg.eclipseFirmId) {
            url += '/?firmId=' + $scope.sleeveReg.eclipseFirmId;
        }

        $http.put(url, { trackerMsg: 'Updating eclipse firm for registration' })
            .then(function () {
                finished();
            })
    };

    $scope.onRegistrationTargetAllocationLoaded = function (payload) {
        $scope.registrationVerbose.targetAllocations = payload.allocations;
        $scope.current.targetAllocationType = payload.targetAllocationType;
        registrationTargetAllocationsOriginal = angular.copy(payload.allocations);
    };

    $scope.onRegistrationAdditionalClientsChange = function (list) {
        $scope.registrationAdditionalClients = list;
    };

    $scope.loadTab = function (child) {
        $scope.menu.categories.each(function (c) {
            c.children.each(function (ch) {
                ch.active = ch.code === child.code;
            });
        });

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab(this);
    };

    $scope.toggleDollarPercent = function (sleeve) {
        //if user switches from % -> $
        if (sleeve.targetBalanceType === 0) {
            sleeve.contributionAllocation = 0;
            sleeve.distributionAllocation = 0;
        }

        $scope.calculateSleeveTotals();
    };

    $scope.calcPrimaryRepPerc = function () {

        let AdditionalRepPercSum = $scope.additionalRepresentativesPercent
            .filter(r => r.repTitle !== "Primary Representative")
            .sum(function (n) { return parseFloat(n['percentage']).round(4) });
        $scope.additionalRepresentativesPercent
            .filter(r => r.repTitle == "Primary Representative")[0]
            .percentage = (100 - AdditionalRepPercSum).round(4);
    }

    $scope.save = function () {
        splitIoService.getBoolTreatment("recon_datasharing_editwarningmessages_7285")
            .subscribe((isEnabled) => {
                if (isEnabled && $scope.isDataSharingEntity) {
                    $dialog.confirmAction("Registration is a data sharing Registration. Changes are likely to be reverted by subsequent syncs.  Would you still like to proceed?")
                        .open()
                        .then((result) => {
                            if (result === 'yes') {
                                save();
                            }
                        });
                }
                else {
                    save();
                }
            });
    };

    function save() {
        if ($scope.isNewRepSplitFlagEnabled && $scope.isRepPayoutPercentEnabled) {
            var clientPayoutOverrides = getClientPayoutOverrides();
            if (clientPayoutOverrides) {
                $http.post(`/Portfolio/Registrations/Action/ValidateRepPayouts/${$scope.current.registrationId}`, clientPayoutOverrides, { trackerMsg: 'Validate representative payouts' }).then((response) => {
                    let data = buildRegistrationRepPayouts($scope.clientRepAdditional, response.data);
                    $scope.registrationRepPayouts = data;
                    clientPayoutOverrides = getClientPayoutOverrides();

                    const overridesHasInvalid = $scope.registrationRepPayouts?.map((payout) => payout.reps)?.flatten()?.filter((rep) => rep.isValid === false);
                    if (overridesHasInvalid && overridesHasInvalid.length > 0) {
                        $scope.errors.push({ type: 'error', title: 'Unsaved Changes!', msg: 'Representative Payouts are invalid', showAllowClose: true })
                        return;
                    } else {
                        saveReg(clientPayoutOverrides);
                    }
                })
            } else {
                saveReg();
            }
        } else {
            saveReg();
        }
    }

    function saveReg(clientPayoutOverrides) {
        if ($scope.registrationContact?.invalidEmail) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Email is invalid", "Contact email is invalid.").open();
        }

        if (!$scope.isRegistrationDecedentDobValid) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Decedent Date Of Birth","Decedent Date Of Birth must be less than 150 Years").open();
            return;
        }

        $scope.isSaving = true;
        // Check to see if the client id is differ from the original the then call move endpoint
        if (shouldMoveRegistration()) {
            $http.put('/Portfolio/Registrations/' + args.ids[0] + '/Action/MoveToClient/' + $scope.registrationGeneral.clientId, null, { trackerMsg: 'Moving registration to different household' })
                .then(function () {
                    saveRegistration(clientPayoutOverrides);
                });
        } else {
            saveRegistration(clientPayoutOverrides);
        }
    }

    function shouldMoveRegistration() {
        const registrationGeneralOriginalClientId = registrationGeneralOriginal?.clientId ?? 0;
        const registrationGeneralClientId = $scope.registrationGeneral?.clientId ?? 0;

        return (!args.isNew && registrationGeneralOriginalClientId !== registrationGeneralClientId && registrationGeneralClientId !== 0);
    }


    $scope.runReport = function () {
        $portfolio.runReport(entities.registration.value, args.ids[0]);
    };

    $scope.openEditor = function () {
        var extraInfo = { fkClient: $scope.registrationGeneral.clientId, fkRegistration: args.ids[0] };
        $portfolio.openEditor(entities.account.value, [], null, null, apps.portfolioLists.name, extraInfo);
    };

    $scope.setAge = function () {
        if ($scope.registrationGeneral.dob) {
            let regDateOfBirth = Date.create($scope.registrationGeneral.dob);
            $scope.registrationGeneral.age = regDateOfBirth.yearsAgo();
            if ($scope.registrationDecedent && $scope.registrationDecedent?.relationToBeneficiary.toLocaleLowerCase() !== 'spouse') {
                setIsMinorChild();
            }
        }
    };

    function setIsMinorChild() {
        let regYearOfBirth = Date.create($scope.registrationGeneral.dob).getFullYear();
        let yod = Date.create($scope.registrationGeneral.dateOfDeath).getFullYear();
        if (regYearOfBirth < yod) {
            let age = yod - regYearOfBirth;
            $scope.registrationGeneral.isMinorChild = (age < 21);
        }
    }

    function cleanGeneral() {
        if (!$scope.registrationGeneral) {
            return $scope.registrationGeneral;
        }
        let general = angular.copy($scope.registrationGeneral);
        delete general.ageOfFirstRmd;
        delete general.isMinorChild;
        return general;
    }

    $scope.close = function (validate) {
        if (validate) {
            if (!angular.equals(registrationGeneralOriginal, cleanGeneral()) ||
                !angular.equals(registrationContactOriginal, $scope.registrationContact) ||
                !angular.equals(registrationBeneficiariesOriginal, $scope.registrationBeneficiaries) ||
                !angular.equals(additionalRepresentativesPercentOriginal, $scope.additionalRepresentativesPercent) ||
                !angular.equals(registrationTrusteeOriginal, $scope.trustee) ||
                !angular.equals(registrationNotesOriginal, $scope.registrationNotes) ||
                !angular.equals(registrationSuitabilityOriginal, $scope.registrationSuitability) ||
                !angular.equals(entityOptionsOriginal, $scope.entityOptions) ||
                !angular.equals(customFieldsOriginal, $scope.customFields) ||
                !angular.equals(billingFeePayingAccountsOriginal, $scope.billingFeePayingAccounts) ||
                !angular.equals(registrationDecedentOriginal, $scope.registrationDecedent) ||
                !angular.equals(registrationAdditionalClientsOriginal, $scope.registrationAdditionalClients) ||
                $scope.current.isDirtyTrustee ||
                ($scope.isNewRepSplitFlagEnabled && $scope.isRepPayoutPercentEnabled && !angular.equals(registrationRepPayoutsOriginal, $scope.registrationRepPayouts))
            ) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                editorHotKeys.destroy();
                if (dialog) {
                    dialog.close(null);
                } else {
                    window.parent.postMessage("iframeclose");
                }
            }

        } else {
            editorHotKeys.destroy();
            if (dialog) {
                dialog.close(null);
            } else {
                window.parent.postMessage("iframeclose");
            }
        }
    };

    // PUBLIC METHODS - GENERAL
    $scope.toggleHHLookUp = function (isLookUpMode) {
        $scope.current.showHHLookUp = isLookUpMode;
    };

    $scope.unlockSSNField = function (forEdit) {
        if (args.ids[0] > 0 && ($scope.registrationGeneral.ssN_TaxID && $scope.registrationGeneral.ssN_TaxID.indexOf('X') !== -1) || forEdit) {
            $dialog.inputBox('Reason to ' + (forEdit ? 'Edit' : 'View') + ' the SSN or Tax ID', "Reason", "textarea")
                .open()
                .then(function (rslt) {
                    if (rslt && rslt.trim().length > 0) {
                        var updateSSN = { ssN: null, reason: rslt };
                        $http.put('/Portfolio/Registrations/' + args.ids[0] + '/SSNTaxId', updateSSN, { trackerMsg: 'Getting SSN/Tax ID information' })
                            .then(function (response) {
                                $scope.registrationGeneral.ssN_TaxID = response.data;

                                if (forEdit && $scope.current.updateSSN === false) {
                                    $scope.current.viewSSNReason = rslt;
                                    $scope.current.updateSSN = true;
                                }
                            });
                    }
                });
        }
    };

    $scope.unlockDeceasedSSNField = function (forEdit) {
        if (args.ids[0] > 0 && ($scope.registrationGeneral.deceasedSSN_TaxID && $scope.registrationGeneral.deceasedSSN_TaxID.indexOf('X') !== -1) || forEdit) {
            $dialog.inputBox('Reason to ' + (forEdit ? 'Edit' : 'View') + ' the Deceased SSN or Tax ID', "Reason", "textarea")
                .open()
                .then(function (rslt) {
                    if (rslt && rslt.trim().length > 0) {
                        var updateDeceasedSSN = { ssN: null, reason: rslt };
                        $http.put('/Portfolio/Registrations/' + args.ids[0] + '/DeceasedSSNTaxId', updateDeceasedSSN, { trackerMsg: 'Getting Deceased SSN/Tax ID information' })
                            .then(function (response) {
                                $scope.registrationGeneral.deceasedSSN_TaxID = response.data;

                                if (forEdit && $scope.current.updateDeceasedSSN === false) {
                                    $scope.current.viewDeceasedSSNReason = rslt;
                                    $scope.current.updateDeceasedSSN = true;
                                }
                            });
                    }
                });
        }
    };

    // PUBLIC METHODS - BENEFICIARY
    $scope.addBeneficiary = function () {
        if (!$scope.registrationBeneficiaries) {
            $scope.registrationBeneficiaries = [];
        }

        $scope.registrationBeneficiaries.push({
            name: '',
            dob: '',
            ssn: '',
            percentage: 0,
            relation: 'spouse',
            type: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            reason: 'adding new beneficiary',
            editMode: true,
            deceasedSSN: ''
        });
        totalPercents();
    };

    $scope.createTrusteeRecord = function (isNew) {
        if (isNew) {
            $scope.trustee = {
                name: '',
                dob: '',
                ssn: '',
                percentage: 100,
                relation: null,
                type: 'Trustee',
                address: '',
                city: '',
                state: '',
                zip: '',
                reason: 'adding new trustee',
                editMode: true,
                deceasedSSN: ''
            };
            $scope.current.useTrustee = true;
            $scope.current.isDirtyTrustee = false;
        } else {
            if ($scope.trustee) {
                $dialog.confirmAction("This action will remove Trustee <b>" + $scope.trustee.name + "</b>?")
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            $scope.trustee = {};
                            $scope.current.isDirtyTrustee = true;
                            $scope.current.useTrustee = false;

                            //if this was put in the $scope.registrationBeneficiaries array; then remove it
                            var index = $scope.registrationBeneficiaries.findIndex(function (n) {
                                return (n.type ? n.type.toLowerCase() : "") === 'trustee'
                            });
                            if (index > -1) {
                                $scope.registrationBeneficiaries.splice(index, 1);
                            }
                        } else {
                            $scope.current.useTrustee = true;
                        }
                    });
            } else {
                $scope.current.useTrustee = false;
            }
        }
    };

    $scope.updateTotal = function () {
        totalPercents();
    };

    $scope.removeBeneficiary = function (ben) {
        $dialog.confirmAction("Are you sure you want to remove beneficiary <b>" + ben.name + "</b>?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    var idx = $scope.registrationBeneficiaries.indexOf(ben);
                    $scope.registrationBeneficiaries.splice(idx, 1);
                }
            });
    };

    $scope.viewBeneficiarySSN = function (ben, forEdit) {
        $dialog.inputBox('Reason to ' + (forEdit ? "Edit" : "View") + ' the SSN or Tax ID', "Reason", "textarea")
            .open()
            .then(function (result) {
                if (result) {
                    ben.reason = result;
                    $http.put('/Portfolio/Registrations/' + args.ids[0] + '/Beneficiary/' + ben.id + '/SSN', "'" + result + "'")
                        .then(function (response) {
                            ben.ssn = response.data;
                            if (forEdit && $scope.rightsSSNChange.canUpdate) {
                                if (ben.type === 'Trustee') {
                                    $scope.current.viewTaxIdReason = ben.reason;
                                }
                                ben.editMode = true;
                            }
                        });
                }
            });
    };

    $scope.viewBeneficiaryDeceasedSSN = function (ben, forEdit) {
        $dialog.inputBox('Reason to ' + (forEdit ? "Edit" : "View") + ' the Deceased SSN or Tax ID', "Reason", "textarea")
            .open()
            .then(function (result) {
                if (result) {
                    ben.reason = result;
                    $http.put('/Portfolio/Registrations/' + args.ids[0] + '/Beneficiary/' + ben.id + '/SSN', "'" + result + "'")
                        .then(function (response) {
                            ben.deceasedSSN = response.data;
                            if (forEdit && $scope.rightsDeceasedSSNChange.canUpdate) {
                                if (ben.type === 'Trustee') {
                                    $scope.current.viewTaxIdReason = ben.reason;
                                }
                                ben.editMode = true;
                            }
                        });
                }
            });
    };

    $scope.validateType = function (b) {
        if (b.type !== b.originalType) {
            if (beneficiaryTypesOriginal.none(b.type)) {
                b.type = b.originalType;
            }

            $scope.updateTotal();
        }
    };

    //region PUBLIC/PRIVATE METHODS - REQUIRED MINIMUM DISTRIBUTION (Formerly Just Decedent)
    function loadDecedent() {
        if ($scope.registrationDecedent) {
            setIsMinorChild();
            setAgeOfFirstRmd();
            return;
        }
        let expands = 'decedent';
        if (!$scope.registrationGeneral) {
            expands += ',portfolio'
        }
        if (!$scope.registrationDecedent) {
            $scope.registrationDecedent = newDecedent();
        }

        $http.get("/Portfolio/Registrations/Verbose/" + (args.isNew ? "New" : args.ids[0]) + "?expand=" + expands, { trackerMsg: 'Loading decedent' })
            .then(function (response) {
                var data = response.data;

                $scope.registrationDecedent = data.decedent;
                if (!$scope.registrationGeneral) {
                    $scope.registrationGeneral = data.portfolio;
                }
                $scope.setDecedentAge();
                setIsMinorChild();
                setAgeOfFirstRmd();
                registrationDecedentOriginal = angular.copy($scope.registrationDecedent);
            });
    }

    //Required Beginning Date - The year after their 72nd birthday or the year after death
    function setRequiredBeginningDate() {
        if (!$scope.registrationDecedent.dateOfBirth) {
            return;
        }

        const dateOfBirthAsDate = Date.create($scope.registrationDecedent.dateOfBirth);
        const yearsToAdd = getYearsToAdd(dateOfBirthAsDate.getFullYear());
        const rmdStartYear = Date.create(dateOfBirthAsDate).addYears(yearsToAdd).getFullYear();
        const rmdStartDate = Date.create('4/1/' + rmdStartYear);

        $scope.registrationDecedent.requiredBeginningDate = rmdStartDate.short();
        return rmdStartDate;
    }

    function getYearsToAdd(birthYear) {
        if (birthYear < 1951) {
            return 73;
        }
        else if (birthYear >= 1951 && birthYear <= 1959) {
            return 74;
        }
        else {
            return 76;
        }
    }

    //Occurence of Death - Did the decedent die before or after the RMD required beginning date?
    function getOccurenceOfDeath(dateOfRmdStart) {
        if ($scope.registrationGeneral.dateOfDeath) {
            let dateOfDeath = Date.create($scope.registrationGeneral.dateOfDeath);
            $scope.registrationDecedent.occurrenceOfDeath = (dateOfRmdStart > dateOfDeath) ? "Before" : "After";
        }
    }

    $scope.setDecedentAge = function () {
        let dateOfRmdStart = setRequiredBeginningDate();
        getOccurenceOfDeath(dateOfRmdStart);
        if ($scope.registrationDecedent.dateOfBirth && $scope.registrationGeneral.dateOfDeath) {
            let dateOfBirth = Date.create($scope.registrationDecedent.dateOfBirth);
            let dateOfDeath = Date.create($scope.registrationGeneral.dateOfDeath);
            if (dateOfBirth.isBefore(dateOfDeath)) {
                let birthYear = dateOfBirth.getFullYear();
                let deathYear = dateOfDeath.getFullYear();
                $scope.registrationDecedent.ageAtDeath = deathYear - birthYear;
            }

            setAgeOfFirstRmd();
        }
        if ($scope.registrationDecedent.dateOfBirth) {
            const currentDate = new Date();
            const dateOfBirth = Date.create($scope.registrationDecedent.dateOfBirth);
            const checkYearDiff = currentDate.getFullYear() - dateOfBirth.getFullYear();
            $scope.isRegistrationDecedentDobValid = (Math.abs(checkYearDiff) > 150) ? false : true;
        }
    };

    $scope.clearDecedent = function () {
        $scope.registrationDecedent = newDecedent();
    };

    function newDecedent() {
        return { dateOfBirth: null, name: null, relationToBeneficiary: null };
    }

    function setAgeOfFirstRmd() {
        if ($scope.registrationGeneral.dob && $scope.registrationGeneral.dateOfDeath) {
            //Age of First RMD - The age of the current account owner the year after the death of the decedent.
            let dateOfDeath = Date.create($scope.registrationGeneral.dateOfDeath);
            let currentOwnerYearOfBirth = Date.create($scope.registrationGeneral.dob).getFullYear();
            let decedentYearAfterDeath = dateOfDeath.getFullYear() + 1;
            $scope.registrationGeneral.ageOfFirstRmd = decedentYearAfterDeath - currentOwnerYearOfBirth;
        }
    }
    //endregion

    // PUBLIC/PRIVATE METHODS - SUITABILITY
    $scope.canCompleteSuitability = false;

    $scope.setBondPercent = function () {
        if ($scope.registrationSuitability.stockPercent) {
            $scope.registrationSuitability.bondPercent = 100 - parseInt($scope.registrationSuitability.stockPercent);
        }
    };

    $scope.$watch('registrationSuitability', (newVal, oldVal) => {
        if (oldVal === newVal || !newVal) {
            return;
        } else {
            validSuitability() ? $scope.canCompleteSuitability = true : $scope.canCompleteSuitability = false;

            if (!$scope.registrationSuitability.reviewCompleted) {
                $scope.registrationSuitability.reviewCompletedDate = null;
            }
        }
    }, true)

    $scope.setCompletedDate = () => {
        if ($scope.registrationSuitability.reviewCompleted) {
            let date = new Date();
            $scope.registrationSuitability.reviewCompletedDate = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();;
        }
    }

    const validSuitability = () => {
        if ($scope.registrationSuitability.returnObjective !== null &&
            $scope.registrationSuitability.investmentObjective !== null &&
            $scope.registrationSuitability.timeHorizon !== null) {
            return true;
        }
        $scope.registrationSuitability.reviewCompleted = false;
        return false;
    }

    // PUBLIC METHODS - SLEEVE SETUP

    $scope.modelSelectedOasSearch = function (mms, sleeve) {
        $scope.updateManagementStyleOnSleeve(mms, sleeve);
        $scope.updateSubAdvisorOnSleeve(mms, sleeve);
        //calculateSleeveRiskScores needs model on sleeve to be populated
        //and it was not happening in this function so created updateModelOnSleeve
        $scope.updateModelOnSleeve(mms, sleeve);
        //We need to update the minimumInvestmentAmount on the sleeve, even if it is null
        sleeve.minimumInvestmentAmount = mms.minimumInvestmentAmount;
        $scope.calculateSleeveRiskScores();
    };

    $scope.updateModelOnSleeve = function (mms, sleeve) {
        if (mms.id) {
            sleeve.model = { id: mms.id, name: mms.name, riskScore: mms.riskScore, excludeRebalanceSleeve: mms.excludeRebalanceSleeve };
            sleeve.doNotTrade = sleeve.doNotTrade || mms.excludeRebalanceSleeve;
            sleeve.modelAggExcludeRebalanceSleeve = mms.excludeRebalanceSleeve;
        }
    };

    $scope.updateManagementStyleOnSleeve = function (mms, sleeve) {
        if (mms.managementStlyeId) {
            sleeve.mStyle = { id: mms.managementStlyeId, name: mms.managementStyleName };
            sleeve.editMgmtStyle = true;
        }
    };

    $scope.updateSubAdvisorOnSleeve = function (mms, sleeve) {
        if (mms.subAdvisorId) {
            sleeve.subAdvisorId = mms.subAdvisorId;
            sleeve.editSubAdvisor = true;
        }
    }

    $scope.setColSpanSleeveStrategy = function () {
        let colSpan = 2;  // Delete and Model columns
        if ($scope.mandates.enabled) {
            colSpan += 1; // Strategist column
            if ($scope.sleeveReg.mandate) {
                colSpan += 1; // Mandate column
            }
        }

        return colSpan.toString();
    };

    //PUBLIC METHOD'S PROPOSAL TOOL
    $scope.openProposalTool = function () {

        $http.get('/Settings/Database/EntityOptions/Code/69SLEEVETR', { cache: true, trackerMsg: 'Loading use sleeve setting' })
            .then(function (response) {
                var accountId = args.extraInfo.accountId ? args.extraInfo.accountId : null;
                var useSleeve = 'false';

                if (response.data.value.toLowerCase() === "true") {
                    useSleeve = 'true';
                }

                var url = API_CONFIG.ftjProposalToolUrl + '?portfolioId=null&registrationId=' + args.ids[0] + '&accountId=' + accountId + '&UseSleeves=' + useSleeve + '&t=' + sessionStorage.oas_token;
                window.open(url, '_blank');
            });

        if (dialog) {
            dialog.close(null);
        } else {
            window.parent.postMessage("iframeclose");
        }
    };

    $scope.setSleeveStrategyType = function (model) {
        if (model) {
            $scope.current.sleeveStrategyAggId = model.id;
        }

        if ($scope.current.sleeveStrategyAggId) {
            let sleeve = $scope.sleeveStrategies.find({ id: $scope.current.sleeveStrategyAggId });

            let method = `/Trading/SleeveStrategyAggregate/ReturnRegSleeveWithStrategyAggregate/${sleeve.id}?registrationId=${args.ids[0]}`;

            $scope.current.sleeveStrategyId = sleeve.singleStrategyId;

            $http.get(method, { trackerMsg: 'Loading Sleeve Strategy' })
                .then(function (response) {
                    let tempData = response.data;

                    $scope.current.sleeveStrategyAggId = tempData.sleeveStrategyAggId;
                    $scope.current.sleeveStrategy = tempData;
                    $scope.current.sleeveStrategyId = tempData.sleeveStrategyId;

                    tempData.normalSleeves = function () {
                        return tempData.accountSleeves.filter({ sleeveType: sleeveType.normal.name });
                    };

                    tempData.specialSleeves = function () {
                        return tempData.accountSleeves.filter(function (x) {
                            return x.sleeveType !== sleeveType.normal.name;
                        });
                    };

                    if ($scope.user.isFTJ) {
                        //FTJ only wires these up on normal sleeves; special sleeves get cleared out
                        tempData.normalSleeves().forEach(function (detail) {
                            detail.editMgmtStyle = true;
                            detail.editSubAdvisor = true;
                            detail.selectedAutoTradeTypes = [];
                            detail.model = { id: detail.modelAggId, name: detail.modelAgg, riskScore: detail.riskScore };

                            if (detail.managementStyleId && detail.managementStyle) {
                                detail.mStyle = { id: detail.managementStyleId, name: detail.managementStyle };
                            }
                        });

                        tempData.specialSleeves().forEach(function (detail) {
                            detail.editMgmtStyle = false;
                            detail.editSubAdvisor = false;
                            detail.selectedAutoTradeTypes = [];
                            detail.model = null;
                            detail.modelAgg = null;
                            detail.modelAggId = null;
                            detail.managementStyleId = null;
                            detail.managementStyle = null;
                            detail.managementStyleName = null;
                            detail.mStyle = null;
                            detail.subAdvisorId = null;
                        });
                    }
                    else {
                        //everyone else wires these up for all sleeves
                        tempData.accountSleeves.forEach(function (detail) {
                            detail.editMgmtStyle = true;
                            detail.editSubAdvisor = true;
                            detail.selectedAutoTradeTypes = [];
                            detail.model = { id: detail.modelAggId, name: detail.modelAgg, riskScore: detail.riskScore };

                            if (detail.managementStyleId && detail.managementStyle) {
                                detail.mStyle = { id: detail.managementStyleId, name: detail.managementStyle };
                            }
                        });
                    }

                    $scope.sleeveReg = tempData;
                    applyRetainedOverlayId($scope.sleeveReg);

                    resetRowId();
                    $scope.mandates.subAdvisorCache.clear();
                    $scope.mandates.modelCache.clear();

                    $scope.sleeveReg.accountSleeves.forEach(function (item) {
                        item.rowId = sleeve.rowId || nextRowId();
                        item.targetBalanceType = item.targetBalanceType === 'Percent' ? 1 : 0;
                        item.substitutes = item.substitutes || [];

                        item.substitutes.add({
                            aggregateModelId: item.modelAggId,
                            modelAggName: item.modelAgg || '',
                            isSubstitute: false
                        });

                        var models = $scope.mandates.modelCache.getFor(item);

                        if (!models) {
                            models = [item.model];
                            $scope.mandates.modelCache.setFor(item, models);
                        }

                        $scope.mandates.setSelectedModel(item, models);

                        initSleeveDropdowns(item);

                        $scope.mandates.subAdvisorCache.setFor(item, [{ id: item.subAdvisorId, name: item.subAdvisor }]);
                    });

                    if ($scope.current.sleeveStrategyAggId) {
                        //process sleeveReg
                        $http.get(`/Trading/SleeveStrategyAggregate/${$scope.current.sleeveStrategyAggId}`, { trackerMsg: 'Loading sleeve agg details' })
                            .then(function (sleeves) {
                                $scope.current.sleeveDetails = sleeves.data.details;
                                $scope.current.allowCustomization = sleeves.data.allowCustomization;
                                $scope.sleeveReg.normalGroupedSleeves = groupedSleevesFn();
                                // if there is only one sleeve in the agg, expand it by default
                                if ($scope.sleeveReg.normalGroupedSleeves && $scope.sleeveReg.normalGroupedSleeves.length === 1) {
                                    $scope.sleeveReg.normalGroupedSleeves[0].expanded = true;
                                }
                                $scope.calculateSleeveTotals();
                                $scope.disableAssignEclipseFirm = $scope.hasReadOnlyAccess || (sleeves.data.eclipseFirmId !== null && $scope.ssaEclipseFirmFeatureFlag);
                            });
                    } else {
                        $scope.current.sleeveDetails = null;
                        $scope.sleeveReg.normalGroupedSleeves = groupedSleevesFn();
                        $scope.disableAssignEclipseFirm = $scope.hasReadOnlyAccess;
                        // if there is only one sleeve in the agg, expand it by default
                        if ($scope.sleeveReg.normalGroupedSleeves && $scope.sleeveReg.normalGroupedSleeves.length === 1) {
                            $scope.sleeveReg.normalGroupedSleeves[0].expanded = true;
                        }

                        $scope.calculateSleeveTotals();
                    }
                });
        } else {
            //custom sleeve, wipe out strategy info
            $scope.current.sleeveStrategyAggId = null;
            $scope.current.sleeveStrategy = null;
            $scope.current.sleeveStrategyId = null;
            $scope.sleeveReg.normalGroupedSleeves = null;
            $scope.current.allowCustomization = false;
            $scope.disableAssignEclipseFirm = $scope.hasReadOnlyAccess;

            loadSleeveSetup(false, true);
        }
    };

    $scope.addModelAggSubstitute = function (sleeve) {

        var modelSubstitutionFilterList = [];
        var substitutes = [];
        var sleeveDetailId = sleeve.sleeveStrategyDetailId; //sleeve.substitutes[0].sleeveStrategyDetailId;

        //grab all the account sleeve aggregate model id's.  They can only be used once.
        var aggregateModelIdFilterList = $scope.sleeveReg.accountSleeves.map(function (a) {
            if (a.modelAggId) {
                return a.modelAggId;
            }
        }).unique();

        //for each sleeve, get any model substitutes associated with sleeve
        $scope.sleeveReg.accountSleeves.forEach(function (item) {
            if (item.substitutes && item.substitutes.length) {
                var tempList = item.substitutes.map('aggregateModelId').unique();

                modelSubstitutionFilterList.add(tempList);
            }
        });

        sleeve.substitutes.forEach(function (item) {
            if (item.isSubstitute) {
                substitutes.add(item);
            }
        });

        var dialogOpts = {
            templateUrl: "trading/modals/model-substitution-list-search.html",
            controller: "ModelSubstitutionListSearchCtrl",
            sleeveDetailId: sleeveDetailId,
            substitutes: substitutes,
            aggregateModelIdFilterList: aggregateModelIdFilterList,
            modelSubstitutionFilterList: modelSubstitutionFilterList,
            dialogClass: "modal wide"
        };

        $dialog.dialog(dialogOpts)
            .open()
            .then(function (results) {
                if (results) {
                    buildSubstituteDropDownList(sleeve, results);
                }
            })
    };

    $scope.setSleeveContributionDistributionPercents = function (type) {
        var copyField;

        switch ($scope.sleeveReg[type + 'AllocationMethod']) {
            case "Sleeve Target":
            case "Most Out Of Balance":
                copyField = "targetAllocation";
                break;
            case "Sleeve Current Percent":
                copyField = "currentAllocation";
                break;
            default:
                return;
        }

        $scope.sleeveReg.normalSleeves().forEach(function (sleeve) {

            if (copyField === 'currentAllocation') {
                sleeve[type + 'Allocation'] = sleeve[copyField].round(2);
            } else if (copyField === 'targetAllocation' && sleeve.targetBalanceType === 1) {
                sleeve[type + 'Allocation'] = sleeve[copyField].round(2);
            } else {
                sleeve[type + 'Allocation'] = 0;
            }

        });

        $scope.sleeveReg.specialSleeves().forEach(function (sleeve) {
            if (copyField === 'currentAllocation') {
                sleeve[type + 'Allocation'] = sleeve[copyField];
            } else if (copyField === 'targetAllocation') {
                sleeve[type + 'Allocation'] = sleeve[copyField];
            } else {
                sleeve[type + 'Allocation'] = 0;
            }
        });

        $scope.calculateSleeveTotals();
    };

    $scope.rebalanceRegistration = function () {
        if (!checkRegistrationSleeveForDirty()) {
            $dialog.confirmAction("Are you sure you want to rebalance this registration?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        //project 079141; ftj - user was clicking rebalance too many times causing issues.  Now, user needs to exit editor to re-enable button
                        $scope.current.disableRebalanceBtn = $scope.user.isFTJ;
                        $tradeGenerator.submitTradeDefinition({ routine: "Rebalance", keys: [$scope.sleeveReg.registrationId], entity: "Registration", level: "Registration", reason: "NeedReview" });
                    }
                });
        }
    };

    $scope.toggleMandateMode = function () {
        $dialog.confirmAction("This may force changes in the strategist and model selections of the sleeves below.  Are you sure you want to continue?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.sleeveReg.normalSleeves().forEach(function (sleeve) {
                        initSleeveDropdowns(sleeve);
                    });
                } else {
                    $scope.sleeveReg.mandate = !$scope.sleeveReg.mandate;
                }
            });
    };

    $scope.loadMandateSubAdvisors = function (sleeve, refresh = false) {
        if ($scope.sleeveSetupInvestmentCategoryFlag) {
            if (sleeve.originalModelType === undefined) {
                sleeve.originalModelType = sleeve.modelType;
            }

            if ($scope.sleeveReg.mandate) {
                if (!sleeve.modelType || sleeve.modelType === "All") {
                    sleeve.modelType = (sleeve.originalModelType && sleeve.originalModelType !== "All" &&
                        $scope.mandates.modelTypes.includes(sleeve.originalModelType))
                        ? sleeve.originalModelType
                        : $scope.mandates.modelTypes[0];
                }
            } else {
                sleeve.modelType = "All";
            }
        } else {
            if (!sleeve.modelType || (sleeve.modelType === "All" && $scope.sleeveReg.mandate)) {
                sleeve.modelType = $scope.sleeveReg.mandate ? $scope.mandates.modelTypes[0] : "All";
            } else if (!$scope.sleeveReg.mandate) {
                sleeve.modelType = "All";
            }
        }

        if (refresh) {
            $scope.mandates.subAdvisorCache.clearFor(sleeve);
        }

        const subAdvisors = $scope.mandates.subAdvisorCache.getFor(sleeve);

        if (subAdvisors) {
            $scope.processSubAdvisors(subAdvisors, sleeve, refresh);
        }
        else {
            if ($scope.user.isFTJ) {
                //FTJ only wires this up on normal sleeves
                if (sleeve.modelAggId
                    && sleeve.sleeveType === sleeveType.normal.name) {
                    $http.get('/Trading/ModelAggs/' + sleeve.modelAggId + '?returnStyle=ModelAggLight', { trackerMsg: 'Loading ModelAgg' })
                        .then(function (resp) {
                            if (resp.data && resp.data.subAdvisorId && resp.data.subAdvisorName) {
                                sleeve.subAdvisorId = resp.data.subAdvisorId;
                                sleeve.subAdvisorName = resp.data.subAdvisorName;
                                $scope.getAllSubAdvisors(sleeve, $scope.sleeveReg.registrationId, refresh);
                            }
                        });
                }
                else {
                    $scope.getAllSubAdvisors(sleeve, $scope.sleeveReg.registrationId, refresh);
                }
            } else {
                if (sleeve.modelAggId) {
                    $http.get('/Trading/ModelAggs/' + sleeve.modelAggId + '?returnStyle=ModelAggLight', { trackerMsg: 'Loading ModelAgg' })
                        .then(function (resp) {
                            if (resp.data && resp.data.subAdvisorId && resp.data.subAdvisorName) {
                                sleeve.subAdvisorId = resp.data.subAdvisorId;
                                sleeve.subAdvisorName = resp.data.subAdvisorName;
                                $scope.getAllSubAdvisors(sleeve, $scope.sleeveReg.registrationId, refresh);
                            }
                        });
                }
                else {
                    $scope.getAllSubAdvisors(sleeve, $scope.sleeveReg.registrationId, refresh);
                }
            }
        }
    };

    $scope.processSubAdvisors = function (subAdvisors, sleeve, refresh) {
        if (!subAdvisors.length) {
            return;
        }

        if ($scope.sleeveReg.mandate) {
            // this check is for multi-mandate, need to set each row to default strategist prior to loading Models
            if (refresh && subAdvisors.none({ id: sleeve.subAdvisorId })) {
                sleeve.subAdvisorId = subAdvisors[0].id;
            }

            $scope.loadSubAdvisorModels(sleeve);
        } else if (!$scope.sleeveReg.mandate) {
            //this check is for advisor-directed, if sub-advisor is not in list don't load models until a strategist is picked from list
            $scope.loadSubAdvisorModels(sleeve);
        }
    };

    $scope.getAllSubAdvisors = function (sleeve, registrationId, refresh) {
        const subAdvisors = $scope.subAdvisorForRegistrationCache[registrationId];

        if (sleeve.modelType === "All" && subAdvisors) {
            $scope.mandates.subAdvisorCache.setFor(sleeve, subAdvisors);
            $scope.processSubAdvisors(subAdvisors, sleeve, refresh);
        }
        else {
            $http.get("/Portfolio/SubAdvisors/Simple?registrationId=" + registrationId + "&modelAggType=" + (sleeve.modelType === "All" ? '' : sleeve.modelType), { trackerMsg: 'Loading sub-advisors' })
                .then(function (response) {
                    $scope.mandates.subAdvisorCache.setFor(sleeve, response.data);
                    $scope.processSubAdvisors(response.data, sleeve, refresh);
                });
        }
    }

    $scope.loadSubAdvisorModels = function (sleeve, lock = false) {
        var loadModels = function (data) {
            if (data.length) {
                const models = data.map(function (m) {
                    return { id: m.id, name: m.name, riskScore: m.riskScore, hasSMAModel: m.hasSMAModel, minimumInvestmentAmount: m.minimumInvestmentAmount };
                });

                $scope.mandates.modelCache.setFor(sleeve, models);

                $scope.mandates.setSelectedModel(sleeve, models);
            } else if ($scope.mandates.isSelfDirected(sleeve)) {
                $dialog.confirmAction("A self-directed model for this account does not exist.  Would you like to create one?")
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            var models = [{ id: null, name: "Self-Directed Model" }];
                            $scope.mandates.modelCache.setFor(sleeve, models);
                            sleeve.model = models[0];
                            $scope.openModelAllocation(sleeve);
                        } else {
                            var subAdvisor = $scope.mandates.subAdvisorCache.getFor(sleeve)[0];

                            sleeve.subAdvisorId = subAdvisor.id;
                            sleeve.subAdvisorName = subAdvisor.name;

                            $scope.loadSubAdvisorModels(sleeve);
                        }
                    });
            }
            else if (!lock) {
                //the lock is to prevent showing this dialog repeatedly for the same sleeve when no models are found
                $scope.loadSubAdvisorModels(sleeve, true);

                let subAdvisorName = sleeve.subAdvisorName || '';

                //if no subAdvsiorName is present, fetch it from the cache
                if (subAdvisorName === '') {
                    const sleeveSubAdvisor = $scope.mandates.subAdvisorCache
                        .getFor(sleeve)
                        .filter(x => x.id === sleeve.subAdvisorId);

                    subAdvisorName = sleeveSubAdvisor && sleeveSubAdvisor.length === 1 ? sleeveSubAdvisor[0].name : '';
                }

                $scope.mandates.modelCache.clearFor(sleeve);

                $dialog.messageBox('<i class="fa fa-exclamation-circle fa-lg text-error" aria-hidden="true"></i> No Models', `There are no models available for the strategist <strong>${subAdvisorName}</strong></br></br>Please select a different strategist.`).open();
            }
        };

        if (!sleeve.accountId && $scope.mandates.isSelfDirected(sleeve)) {
            loadModels(sleeve.modelAllocations ? [{ id: null, name: "Self-Directed Model" }] : []);
        }
        else {
            if (sleeve.subAdvisorId) {
                let queryParams = `registrationId=${args.ids[0]}&subAdvisorId=${sleeve.subAdvisorId}&accountId=${sleeve.accountId || ''}`;

                //only filter by modelAggType when we're doing a custom sleeve
                if (!$scope.current.sleeveStrategyId) {
                    queryParams += `&modelAggType=${sleeve.modelType === "All" ? '' : sleeve.modelType}`;
                }

                $http.get(`/Trading/ModelAggs/Limited?${queryParams}`, { trackerMsg: 'Loading models' })
                    .then(function (response) { loadModels(response.data); });
            }
        }

        setRebalanceFrequencies();
    };

    $scope.setAllocationValues = (sleeve) => {
        //set contribution and distribution values to match the target allocation if they are disabled
        $scope.sleeveAllocationTypes.forEach(type => {
            if ((!sleeve.isCustomized && $scope.current.sleeveStrategyAggId)
                || $scope.sleeveReg[type + 'AllocationMethod'] !== 'Assigned') {
                //the input is disabled, set it = targetAllocation value
                sleeve[`${type}Allocation`] = sleeve.targetAllocation;
            }
        });
    };

    $scope.calculateSleeveTotals = function () {
        $scope.sleeveAllocationTypes.include('target').forEach(function (type) {
            //set the totals
            if (type === 'target') {
                $scope.sleeveReg[type + "Total"] = $scope.sleeveReg.accountSleeves
                    .findAll({ targetBalanceType: 1 })
                    .sum(type + "Allocation")
                    .round(2);
            } else {
                $scope.sleeveReg[type + "Total"] = $scope.sleeveReg.accountSleeves
                    .sum(type + "Allocation")
                    .round(2);
            }
        });

        aggregateGroupTotals();
    };

    $scope.opsModelSelected = function (group = null) {
        $scope.calculateSleeveRiskScores(group);
        $scope.resetMinimumInvestmentAmount();
    }

    $scope.calculateSleeveRiskScores = function (group = null) {
        let filteredSleeves = [];
        if (group) {
            filteredSleeves = group.sleeves
                .filter(sleeve => sleeve.model);
            group.riskScore = null;
        } else {
            filteredSleeves = $scope.sleeveReg.normalSleeves()
                .filter(sleeve => sleeve.sleeveType === 'Normal sleeve' && sleeve.model);
        }

        // any sleeves that have a model with a null risk score cannot be calculated, so return null
        if (filteredSleeves.filter(sleeve => sleeve.model.riskScore === null && sleeve.targetAllocation > 0).length) {
            $scope.sleeveReg.riskScoreTotal = null;
            return;
        }

        if (group) {
            const groupTargetSum = group.sleeves.reduce((prev, next) => prev + next.targetAllocation, 0);
            const riskScore = group.sleeves
                .filter(sleeve => sleeve.model)
                .map(sleeve => sleeve.model.riskScore ? ((sleeve.targetAllocation / 100) / (groupTargetSum / 100)) * sleeve.model.riskScore : 0) // average weighted risk = target allocation % * risk score
                .reduce((prev, next) => prev + next, 0); // sum the average weighted risk;
            group.riskScore = riskScore;
        } else {
            $scope.sleeveReg.riskScoreTotal = filteredSleeves
                .map(sleeve => sleeve.model.riskScore ? (sleeve.targetAllocation / 100) * sleeve.model.riskScore : 0) // average weighted risk = target allocation % * risk score
                .reduce((prev, next) => prev + next, 0); // sum the average weighted risk;
        }
    };

    $scope.resetMinimumInvestmentAmount = function () {
        let filteredSleeves = [];
        filteredSleeves = $scope.sleeveReg.normalSleeves()
            .filter(sleeve => sleeve.sleeveType === 'Normal sleeve' && sleeve.model);

        filteredSleeves.forEach(sleeve => {
            if (sleeve.model.minimumInvestmentAmount !== undefined) {
                sleeve.minimumInvestmentAmount = sleeve.model.minimumInvestmentAmount;
            }
        });
    }

    $scope.addButtonIsDisabled = function () {
        //disable the button if
        //1. reg is not active
        //2. we have errors
        //3. normalSleeves has more sleeves than the max number allowed
        //4. any promises haven't been resolved
        //5. user has read only access
        const maxSleeveCountExceeded = $scope.current.maxNumberOfSleeves > 0
            && $scope.sleeveReg.normalSleeves().length >= $scope.current.maxNumberOfSleeves;

        let isDisabled = false;

        if (!$scope.sleeveReg.isActive
            || $scope.hasErrors
            || maxSleeveCountExceeded
            || $scope.hasReadOnlyAccess
            || $scope.mainTracker.active()) {
            isDisabled = true;
        }

        return isDisabled;
    };

    $scope.addAccountSleeve = function (group = null) {
        // if no sleeve strategy is selected then select Custom Sleeves by default
        if (!$scope.current.sleeveStrategyAgg && $scope.sleeveStrategies && $scope.sleeveStrategies.length) {
            $scope.current.sleeveStrategyAgg = $scope.sleeveStrategies.find(ss => ss.id === null)
                || $scope.sleeveStrategies[0];
        }

        let last = {};

        if (group) {
            last = group.sleeves.last();
        } else {
            last = $scope.sleeveReg.accountSleeves.last();
        }

        let sleeve = angular.extend({
            accountId: 0,
            targetBalanceType: 1,
            sleeveType: sleeveType.normal.name,
            currentAllocation: 0,
            sleeveStrategyId: group ? group.sleeveStrategyId : null,
            isCustomized: group ? group.isCustomized : false,
            subAdvisorId: null
        }, Object.select(last, "toleranceLower", "toleranceUpper", "modelType"));

        sleeve.rowId = sleeve.rowId || nextRowId();

        if ($scope.mandates.enabled) {
            sleeve.model = {};
            sleeve.subAdvisorId = last.subAdvisorId;

            if ($scope.mandates.isSelfDirected(sleeve)) {
                //will get set to a valid id on dropdown init
                sleeve.subAdvisorId = 0;
            }
        }

        $scope.sleeveAllocationTypes.include('target').forEach(function (type) {
            sleeve[type + "Allocation"] = type === 'target' || $scope.sleeveReg[type + 'AllocationMethod'] === 'Assigned'
                ? (100 - $scope.sleeveReg[type + "Total"]).round(2)
                : 0;
        });

        $scope.sleeveAllocationTypes.forEach(function (type) {
            if (["Sleeve Target", "Most Out Of Balance"].any($scope.sleeveReg[type + "AllocationMethod"])) {
                if (sleeve.targetBalanceType === 1) {
                    sleeve[type + "Allocation"] = sleeve.targetAllocation;
                }
            }
        });

        initSleeveDropdowns(sleeve);

        $scope.sleeveReg.accountSleeves.push(sleeve);

        if (group) {
            let sleeveGroup = $scope.sleeveReg.normalGroupedSleeves
                .find(x => x.sleeveStrategyId === group.sleeveStrategyId);
            if (sleeveGroup && sleeveGroup.sleeves) {
                sleeveGroup.sleeves.push(sleeve);
            } else {
                $scope.sleeveReg.normalGroupedSleeves = groupedSleevesFn();
            }
        }

        $scope.calculateSleeveTotals();

        if ($scope.current.toleranceCalcMethod === "fixed") {
            $scope.calculateToleranceBand();
        }

        setRebalanceFrequencies();
    };

    $scope.deleteSleeves = function () {
        var deleteSleeve = function () {
            $http.delete('/Trading/Sleeve/Registrations/' + $scope.sleeveReg.registrationId, { trackerMsg: 'Deleting sleeves' })
                .then(function () {
                    if (dialog) {
                        dialog.close(true);
                    } else {
                        window.parent.postMessage("iframeclose");
                    }
                });
        };
        $dialog.confirmAction("Are you sure you want to delete the sleeves for this registration?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    deleteSleeve();
                }
            });
    };

    $scope.removeAccountSleeve = function (sleeve) {

        $scope.sleeveReg.accountSleeves.remove(sleeve);

        const hasSMAModel = sleeve.hasSMAModel || (sleeve.model && sleeve.model.hasSMAModel);

        if (hasSMAModel && !$scope.sleeveReg.hasSMAModel()) {
            $scope.sleeveReg.isDoNotTrade = false;
        }

        $scope.sleeveReg.normalGroupedSleeves = groupedSleevesFn();

        $scope.calculateSleeveTotals();

        setRebalanceFrequencies();

        $scope.calculateSleeveRiskScores();
    };

    $scope.resetRebalanceMonth = function (d) {
        if ($scope.user.isFTJ) {
            $scope.current.lastDayOfMonth = 28;
        } else {
            getLastDayOfMonth($scope.sleeveReg.autoRebalMonth);
            $scope.sleeveReg.autoRebalDay = d ? d.getDate() : Date.create('365 days from now').getDate();
        }
    };

    $scope.resetRebalanceMonthDay = function () {
        var rebalDate;
        switch ($scope.sleeveReg.autoRebalFrequency) {
            case "Semiannual":
                rebalDate = Date.create("6 months from now");
                if ((rebalDate.getMonth() + 1) > 6) {
                    rebalDate = Date.create();
                }
                break;
            case "Annual":
                rebalDate = Date.create("365 days from now");
                break;
            default:
                rebalDate = Date.create("1/10/2000");
                break;
        }
        //figure out last day of month
        $scope.resetRebalanceMonth(rebalDate);

        if (rebalDate.getDate() === Date.create("today").getDate()) { rebalDate.rewind("1 day"); }
        $scope.sleeveReg.autoRebalMonth = rebalDate.getMonth() + 1;

        //this sets the last day of the month (FTJ will cap at 28)
        $scope.sleeveReg.autoRebalDay = rebalDate.getDate().cap($scope.current.lastDayOfMonth);

    };

    $scope.updateModelAggSubstitution = function (sleeve) {
        var temp = sleeve.substitutes.find({ aggregateModelId: sleeve.modelAggId });
        if (temp) {
            sleeve.modelAgg = temp.modelAggName;
            sleeve.model.id = sleeve.modelAggId;
            sleeve.model.name = temp.modelAggName;
        }
    };

    $scope.openModelAllocation = function (sleeve) {
        var lastModelId = sleeve.model.id;
        var data = function () {
            return { registrationId: args.ids[0], sleeve: sleeve, mandates: $scope.mandates };
        };

        $dialog.editor('sleeve-model-allocations.html', 'SleeveModelAllocationsCtrl', { args: data })
            .open()
            .then(function () {
                if (sleeve.model.id !== lastModelId) {
                    //in case there's 1 sleeve and it's been changed to self-directed or vice versa
                    setRebalanceFrequencies();
                }
            });
    };

    //I don't think this is being used - Jesse Temple
    $scope.setActiveDefaults = function () {
        if ($scope.sleeveReg.accountSleeves.length !== 1) return;

        var defaultValue = $scope.sleeveReg.isActive ? 0 : 100;
        $scope.sleeveAllocationTypes.include('target').forEach(function (type) {
            if ($scope.sleeveReg.accountSleeves[0].sleeveType === 'Normal sleeve') {
                $scope.sleeveReg.accountSleeves[0][type + "Allocation"] = defaultValue;
            }
        });

        $scope.calculateSleeveTotals();
    };


    /**
     *
     * @returns true if the user should not be able to click the Process button.
     */
    $scope.processSleevesDisabled = () => {
        // these don't rely on sleeveReg being populated
        if ($scope.hasErrors || $scope.hasReadOnlyAccess) {
            return true;
        }

        if (!$scope.sleeveReg) {
            return false;
        }

        //if the reg isn't active, we don't care if normal sleeves are missing or not (if sleeve reg is not active,
        // we return false to permit a registration to be unsleeved)
        const isMissingNormalSleeves = $scope.sleeveReg.isActive && $scope.sleeveReg.normalSleeves().length === 0;
        const isDisableProcessBtn = $scope.current.disableProcessBtn;

        if (isMissingNormalSleeves || isDisableProcessBtn) {
            return true;
        }

        //true if we're assigned to a strategy or aggregate and have customized sleeves
        const isCustomized =
            $scope.sleeveReg.normalGroupedSleeves
            && $scope.sleeveReg.normalGroupedSleeves.length
            && $scope.sleeveReg.normalGroupedSleeves.any(group => group.isCustomized);

        if (!isCustomized) {
            return false;
        }

        //true if the target totals don't sum up to 100
        const isTargetTotalInvalid =
            $scope.sleeveReg.normalSleeves().length
            && ($scope.sleeveReg.targetTotal
                && !$scope.sleeveReg.targetTotal.almostEquals(100));

        //true if the allocation totals don't sum up to 100
        const isAllocationTotalInvalid = () =>
            $scope.sleeveAllocationTypes.any(type => {
                const isInvalid = $scope.sleeveReg[`${type}AllocationMethod`] === 'Assigned'
                    && $scope.sleeveReg.normalSleeves().length
                    && $scope.sleeveReg[`${type}Total`] !== undefined
                    && !$scope.sleeveReg[`${type}Total`].almostEquals(100);

                return isInvalid;
            });

        //true if the grouped sleeves allocation totals don't sum up to the target defined in the sleeve strategy
        const isAllocationSubtotalsInvalid = () =>
            (
                $scope.sleeveReg.normalGroupedSleeves
                && !$scope.sleeveReg.normalGroupedSleeves.every(group => {
                    var allValid = group['contributionAllocationIsValid']
                        && group['distributionAllocationIsValid']
                        && group['targetAllocationIsValid'];

                    return allValid;
                })) ?? false;

        const isDisabled =
            isTargetTotalInvalid
            || isAllocationTotalInvalid()
            || isAllocationSubtotalsInvalid();

        return isDisabled;
    };

    $scope.processSleeves = function () {
        if ($scope.multiTradeBlockFF) {
            $scope.refreshTradeBlockData = false;
        }
        $scope.sleeveReg.accountSleeves.forEach(function (sleeve) {
            //set the modelAgg
            if (sleeve.sleeveType === sleeveType.normal) {
                //normal sleeve, models are required
                //once a model is set, it cannot be removed
                sleeve.modelAggId = sleeve.model && sleeve.model.id ? sleeve.model.id : sleeve.modelAggId;
                sleeve.modelAgg = sleeve.model && sleeve.model.name ? sleeve.model.name : sleeve.modelAgg;
            } else {
                //special sleeve, models are optional
                //if one isn't chosen in the search box, set it to null
                sleeve.modelAggId = sleeve.model && sleeve.model.id ? sleeve.model.id : null;
                sleeve.modelAgg = sleeve.model && sleeve.model.name ? sleeve.model.name : null;
            }

            //set the managementStyle
            sleeve.managementStyleId = sleeve.mStyle ? sleeve.mStyle.id : sleeve.managementStyleId;
            sleeve.managementStyleName = sleeve.mStyle ? sleeve.mStyle.name : sleeve.managementStyleName;

            //apply special FTJ rules
            if ($scope.user.isFTJ && sleeve.sleeveType !== sleeveType.normal.name) {
                //FTJ doesn't set these values on special sleeves
                sleeve.model = null;
                sleeve.modelAggId = null;
                sleeve.modelAgg = null;
                sleeve.mStyle = null;
                sleeve.managementStyle = null;
                sleeve.managementStyleId = null;
                sleeve.managementStyleName = null;
                sleeve.subAdvisorId = null;
            }

            $scope.sleeveAllocationTypes.forEach(function (type) {
                if (["Sleeve Target", "Most Out Of Balance"].any($scope.sleeveReg[type + "AllocationMethod"])) {
                    if (sleeve.targetBalanceType === 1) {
                        sleeve[type + "Allocation"] = sleeve.targetAllocation;
                    }
                }
            });
        });

        $scope.sleeveReg.sleeveStrategyAggId = $scope.current.sleeveStrategyAggId;
        $scope.sleeveReg.sleeveStrategyId = $scope.current.sleeveStrategyId;
        $scope.sleeveReg.tolerancePercent = $scope.current.toleranceCalcMethod === 'fixed' ? $scope.current.toleranceBandPercent : null;
        applyRetainedOverlayId($scope.sleeveReg);

        $scope.calculateSleeveTotals();

        const deletedModels = [];
        let existingModels = [];

        // create an array of the accounts that were deleted
        if (registrationSleeveOriginal && registrationSleeveOriginal.accountSleeves) {
            registrationSleeveOriginal.accountSleeves.filter(slv => !!slv.model).forEach(slv => {
                if (!$scope.sleeveReg.accountSleeves.find(a => a.accountId === slv.accountId)) {
                    deletedModels.push({ accountId: slv.accountId, modelId: slv.model.id, modelName: slv.model.name, targetModelId: null });
                }
            });
        }

        // create an array of the normal sleeve models that still exist on the registration
        $scope.sleeveReg.normalSleeves().filter(slv => !!slv.model && !!slv.model.id).forEach(slv => {
            if (!deletedModels.filter(m => !!m.modelId).find(m => m.modelId === slv.model.id)) {
                existingModels.push({ modelId: slv.model.id, modelName: slv.model.name });
            }
        });

        existingModels = existingModels.sortBy('modelName');
        existingModels.unshift({ modelId: null, modelName: 'Default' });

        $dialog.dialog({
            templateUrl: "sleeve-setup-process-prompt.html",
            controller: "SleeveSetupProcessPromptCtrl",
            sleeveReg: $scope.sleeveReg,
            sleeveAllocationTypes: $scope.sleeveAllocationTypes.include("target"),
            deletedModels: deletedModels,
            existingModels: existingModels,
            dialogClass: 'modal wide'
        })
            .open()
            .then(function (rslt) {
                if (rslt) {
                    //project 079141; ftj - user was clicking rebalance after process too many times causing issues.  Now, user needs to exit editor to re-enable button
                    $scope.current.disableRebalanceBtn = $scope.user.isFTJ;

                    loadSleeveSetup(true);
                    if ($scope.multiTradeBlockFF) {
                        $scope.refreshTradeBlockData = true;
                    }
                }
            });
    };

    $scope.getToolTipMsg = function (type) {
        //DON'T KNOW WHAT THIS DOES
        var msg = 'Auto calculate ' + type + ' tolerance' + '&#13;';
        msg += 'i.e. enter ' + type + ' tolerance to calculate % from target';
        return msg;
    };

    $scope.showHelpText = function (option) {
        var text = null;
        switch (option) {
            case 'Excluded Rebal Sleeve':
                text = 'This will keep the sleeve from being journaled out of, or traded in a Portfolio (Registration) level rebalance. Raise/spend cash trades can continue to occur, as well as individual sleeve level rebalances.';
                break;
            case 'Do Not Trade':
                text = 'Marking Do Not Trade on a Registration means each Sleeve Account will automatically be blocked from generating an order. Removing this setting will unblock each Account automatically.';
                break;
        }
        if (text) {
            $dialog.messageBox(option, text).open();
        }
    };

    //region Sleeve - Recurring Adj's
    $scope.addSleeveBillingRecurringAdj = function (type) {
        $scope.sleeveReg[type + 'Billing'].recurringAdjustments.add({ id: 0, annualAmount: null, type: null, schedule: null, adjustmentType: null, responsibleEntity: null, endDate: null });
    };

    $scope.removeRecurringAdj = function (radj, type) {
        $scope.sleeveReg[type + 'Billing'].recurringAdjustments.remove(radj);
    };

    $scope.resetSleeveBillingRecurringAdj = function () {

        var clearSleeveSettings = function () {
            $scope.sleeveReg.sleeveBilling.billFeeScheduleId = null;
            $scope.sleeveReg.sleeveBilling.billMasterPayoutScheduleId = null;
            $scope.sleeveReg.sleeveBilling.recurringAdjustments = [];
        };

        $dialog.confirmAction('This action will reset Fee Schedule, Payout Schedule and all Recurring Adjustments for Sleeves! <br><br> <span style="font-weight: bold">Click Yes to continue</span>')
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    clearSleeveSettings();
                }
            })
    };

    //endregion

    //endregion

    //region WATCHES

    $scope.$watch('current.selectedHH', function (newVal, oldVal) {
        if (newVal === oldVal || !newVal) return;

        var hh;

        if (!$scope.current.hhList) {
            $scope.current.hhList = [];
        } else {
            hh = $scope.current.hhList.find({ id: newVal.id });
        }

        if (!hh) {
            $http.get("/Portfolio/Clients/" + newVal.id, { trackerMsg: 'Loading household' })
                .then(function (response) {
                    var data = response.data;
                    delete data.notes;
                    delete data.beneficiaries;
                    delete data.suitability;

                    data.description = data.id + ' - ' + data.name;
                    $scope.current.hhList.push(data);
                    $scope.registrationGeneral.clientId = data.id;
                });
        } else {
            $scope.registrationGeneral.clientId = hh.id;
        }

        $scope.current.showHHLookUp = false;
    });
    //endregion

    //region INITIALIZE
    $scope.current = {
        isNew: args.isNew,
        showChangeHistory: false,
        singleTabMode: args.defaultTab.code === 'sleeveSetup' && args.isFullPage,
        showLockedSleeves: false,
        registrationId: args.ids.length > 0 ? parseInt(args.ids[0]) : 0,
        updateSSN: false,
        isBIRA: false,
        viewSSNReason: null,
        viewTaxIdReason: null,
        showHHLookUp: false,
        selectedHH: null,
        hhList: [],
        isFullPage: !!args.isFullPage,
        showCancel: false,
        useTrustee: false,
        isDirtyTrustee: false,
        sleeveStrategyId: null,
        sleeveStrategyAggId: null,
        sleeveStrategyAgg: null,
        maxNumberOfSleeves: 0,
        disableProcessBtn: false,
        savingEclipseFirm: false,
        toleranceCalcMethod: 'range',
        toleranceBandPercent: 0,
        showSleeveBillingTab: false,
        showSleeveStrategyModelSubstitutions: true,
        updateDeceasedSSN: false,
        viewDeceasedSSNReason: null,
        registrationLoaded: false,
        hasInvalidForm: false,
        defaultEclipseFirmName: null,
        selectedClientPayout: null
    };

    $scope.overlaySleeveAssignmentEmbedEnabled = false;
    $scope.overlaySleeveAssignmentEmbedResolved = false;
    $scope.sleeveAssignmentEmbedLastTradeBlocked = null;

    if (args.showCancel) {
        $scope.current.showCancel = args.showCancel;
    }

    $scope.isCollapsed = true;

    $scope.errors = [];

    $scope.toggleUseSleeveStrategy = 'CustomSleeve';

    $scope.sleeveAllocationTypes = ["contribution", "distribution"]; //corporateAction

    $scope.sleeveStrategies = [];

    $scope.isSaving = false;

    $scope.forms = {}

    $scope.isNewRepSplitFlagEnabled = false;

    //endregion
    init();
});


app.controller('SleeveSetupProcessPromptCtrl', function SleeveSetupProcessPromptCtrl($scope, $http, $dialog, dialog) {

    function init() {
        var sleevesWithModelAggId = $scope.sleeveReg.accountSleeves.filter(function (x) {
            return x.modelAggId;
        });
        sleevesWithModelAggId.forEach(function (sleeve) {
            var errorMsg = "Model " + sleeve.modelAgg + " cannot exist in multiple sleeves.";
            if (sleevesWithModelAggId.count({ modelAggId: sleeve.modelAggId }) > 1 && $scope.errors.none(errorMsg)) {
                $scope.errors.push(errorMsg);
            }
        });
    }

    $scope.cancel = function () {
        if (dialog) {
            dialog.close(false);
        } else {
            window.parent.postMessage("iframeclose");
        }
    };

    $scope.targetedModelChange = function () {
        // if any deleted models should move their assets to a single model, add the model targets to the sleeve reg object
        $scope.sleeveReg.deletedSleeveTargets = $scope.deletedModels
            .filter(m => !!m.targetModelId)
            .map(m => ({
                accountId: m.accountId,
                deletedModelId: m.modelId,
                targetModelId: m.targetModelId
            }));
    };

    $scope.processSleeves = function () {
        const config = {
            AggregateRiskScore: $scope.sleeveReg.riskScoreTotal,
            ClientRiskProfile: $scope.sleeveReg.registrationRiskTolerance
        };

        if ($scope.sleeveReg.isActive && $scope.sleeveReg.normalSleeves()?.length > 0) {
            $http.post('/Trading/Sleeve/Registrations/Guardrails/Action/Validate', config, { trackerMsg: 'Validating Risk Tolerance' })
                .then(function (toleranceResponse) {
                    var toleranceData = toleranceResponse.data;
                    if (!toleranceData.successful) {
                        $dialog.actionFailed(toleranceData.message).open();
                        return;
                    }

                    if (toleranceData.message != null && toleranceData.message.length > 0) {
                        $dialog.confirmAction(`${toleranceData.message}
                                            Do you want to continue?`)
                            .open()
                            .then(function (answer) {
                                if (answer === 'yes') {
                                    $scope.processSleeveResult();
                                } else {
                                    $scope.cancel();
                                }
                            });
                    } else {
                        $scope.processSleeveResult();
                    }
                });
        } else {
            $scope.processSleeveResult();
        }
    };


    $scope.processSleeveResult = function () {
        $http.put('/Trading/Sleeve/Registrations/' + $scope.sleeveReg.registrationId + '/Validate', $scope.sleeveReg, { trackerMsg: 'Validating sleeves' })
            .then(function (response) {
                var data = response.data;

                if (data.isValid) {
                    var processSleeve = function () {
                        $http.post('/Trading/Sleeve/Registrations/Action/Process', $scope.sleeveReg, { trackerMsg: 'Processing sleeves' })
                            .then(function () {
                                $http.put('/Trading/Sleeve/Registrations/SpecialSleeves', $scope.sleeveReg.specialSleeves(), { trackerMsg: 'Processing locked sleeves' });

                                if (dialog) {
                                    dialog.close(true);
                                }
                                else {
                                    window.parent.postMessage("iframeclose");
                                }
                            });
                    };

                    if (data.validationMessage) {
                        $dialog.confirmAction('<ul class="unstyled"><li>' + data.validationMessage.split(". ").join(".</li><li>") + '</li></ul><p>Do you want to continue?</p>')
                            .open()
                            .then(function (result) {
                                if (result === 'yes') {
                                    processSleeve();
                                }
                                else {
                                    $scope.cancel();
                                }
                            });
                    }
                    else {
                        processSleeve();
                    }
                }
                else {
                    $dialog.messageBox("<i class='fa fa-exclamation-circle fa-lg text-error' aria-hidden='true'></i> Invalid Sleeve", data.validationMessage).open();
                    $scope.cancel();
                }
            });
    }

    $scope.sleeveReg = dialog.options.sleeveReg;
    $scope.sleeveAllocationTypes = dialog.options.sleeveAllocationTypes;
    $scope.deletedModels = dialog.options.deletedModels;
    $scope.existingModels = dialog.options.existingModels;
    $scope.errors = [];

    init();
});

app.controller('SleeveModelAllocationsCtrl', function SleeveModelAllocationsCtrl($scope, $http, $q, $dialog, dialog, args) {

    //region PRIVATE VARIABLES
    var sleeve = args.sleeve;
    //endregion

    //region PRIVATE METHODS
    function init() {
        $http.get("/Settings/Database/EntityOptions/Code/69REQUIRED", { cache: true, trackerMsg: 'Loading minimum cash requirements' })
            .then(function (response) {
                var data = response.data;
                $scope.current.minCashRequired = parseFloat(data.value);
                $scope.loadModelAllocations();
            });
    }

    //endregion

    //region PUBLIC METHODS

    $scope.loadSubAdvisorModels = function () {
        var loadModels = function (data) {
            if (data.length) {
                var models = $scope.mandates.modelCache.getFor(sleeve);
                if (!models) {
                    models = data.map(function (m) {
                        return { id: m.id, name: m.name, riskScore: m.riskScore, hasSMAModel: m.hasSMAModel, minimumInvestmentAmount: m.minimumInvestmentAmount };
                    });
                    $scope.mandates.modelCache.setFor(sleeve, models);
                }

                $scope.mandates.setSelectedModel(sleeve, models);
                $scope.loadModelAllocations();
            } else if ($scope.mandates.isSelfDirected(sleeve)) {
                $dialog.confirmAction("A self-directed model for this account does not exist.  Would you like to create one?")
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            var models = [{ id: null, name: "Self-Directed Model" }];
                            $scope.mandates.modelCache.setFor(sleeve, models);
                            sleeve.model = models[0];
                            $scope.loadModelAllocations();
                        } else {
                            sleeve.subAdvisorId = $scope.mandates.subAdvisorCache.getFor(sleeve)[0].id;
                            $scope.loadSubAdvisorModels(sleeve);
                        }
                    });
            } else {
                sleeve.subAdvisorId = $scope.mandates.subAdvisorCache.getFor(sleeve)[0].id;
                $scope.loadSubAdvisorModels();
                $dialog.messageBox("<i class='fa fa-exclamation-circle fa-lg text-error' aria-hidden='true'></i> No Models", "There are no models available for this strategist. Please select a different strategist.").open();
            }
        };

        if (!sleeve.accountId && $scope.mandates.isSelfDirected(sleeve)) {
            loadModels(sleeve.modelAllocations ? [{ id: null, name: "Self-Directed Model" }] : []);
        } else {
            var models = $scope.mandates.modelCache.getFor(sleeve);
            if (models) {
                $scope.mandates.setSelectedModel(sleeve, models);
                $scope.loadModelAllocations();
            } else {
                $http.get("/Trading/ModelAggs/Limited?registrationId=" + args.registrationId + "&subAdvisorId=" + sleeve.subAdvisorId + "&accountId=" + (sleeve.accountId || '') + "&modelAggType=" + (sleeve.modelType === "All" ? '' : sleeve.modelType), {

                    trackerMsg: 'Loading models'
                })
                    .then(function (response) {
                        loadModels(response.data);
                    });
            }
        }
    };

    $scope.loadModelAllocations = function () {
        if (!$scope.mandates.isSelfDirected(sleeve) || (sleeve.accountId && !sleeve.modelAllocations)) {
            $http.get("/Trading/ModelAggs/" + (sleeve.model.id || sleeve.modelAggId) + (sleeve.accountId ? "/" + sleeve.accountId : "") + "/Allocations", { trackerMsg: 'Loading model allocation' })
                .then(function (response) {
                    var data = response.data;
                    if ($scope.mandates.isSelfDirected(sleeve)) {
                        sleeve.modelAllocations = data;
                    }
                    $scope.current.modelAllocations = data;
                });
        } else if (sleeve.modelAllocations) {       //self-directed, new or existing account, existing allocations
            $scope.current.modelAllocations = sleeve.modelAllocations;
        } else {                                    //self-directed, new account, no allocations
            $http.get('/Portfolio/Products?exactTicker=CUSTODIAL_CASH', { cache: true, trackerMsg: 'Loading cash product' })
                .then(function (response) {
                    var data = response.data;
                    sleeve.modelAllocations = [{ productId: data[0].id, productName: data[0].productName, ticker: data[0].ticker, targetPercent: $scope.current.minCashRequired, currentPercent: 0 }];
                    $scope.current.modelAllocations = sleeve.modelAllocations;
                });
        }
    };

    $scope.addToModel = function () {
        $dialog.search('product', 'New Allocation', null, { accountId: sleeve.accountId })
            .open()
            .then(function (result) {
                if (result && $scope.current.modelAllocations.none({ productId: result.productId })) {
                    $scope.current.modelAllocations.push({
                        productId: result.productId,
                        productName: result.productName,
                        ticker: result.ticker,
                        targetPercent: (100 - $scope.current.modelAllocations.sum('targetPercent')).round(2),
                        currentPercent: 0
                    });
                }
            });
    };

    $scope.removeFromModel = function (item) {
        $scope.current.modelAllocations.remove(item);
    };

    $scope.close = function () {
        if ($scope.mandates.isSelfDirected(sleeve) && !$scope.current.modelAllocations.sum('targetPercent').almostEquals(100)) {
            $dialog.messageBox("<i class='fa fa-exclamation-circle fa-lg text-error' aria-hidden='true'></i> Invalid Allocation", "The target allocations must total 100%.").open();
            return;
        }

        if (dialog) {
            dialog.close();
        } else {
            window.parent.postMessage("iframeclose");
        }
    };

    //endregion

    //region INITIALIZE

    $scope.current = { selectedProduct: null };
    $scope.sleeve = sleeve;
    $scope.mandates = args.mandates;

    //endregion

    init();
});

'use strict';

app.controller('PortfolioGroupEditCtrl', function PortfolioGroupEditCtrl($scope, $dialog, dialog, $http, $oasRights, $portfolio, splitIoService, targetAllocationSaveValidator) {

    splitIoService.getBoolTreatment('oc_portfolioAudit_sharedTargetAllocation_31732').subscribe(function (isEnabled) {
        $scope.useSharedTargetAllocationEditor = isEnabled;
    });

    //PRIVATE METHODS
    function loadCustomFields() {
        $http.get($scope.current.isAddingNewGroup ? '/Settings/UserDefinedFields/Definitions/PortfolioGroup' : `/Portfolio/PortfolioGroups/${$scope.current.portfolioGroupId}/UserDefinedFields`, {trackerMsg: 'Loading custom fields'})
            .then(function (response) {
                if ($scope.current.isAddingNewGroup) {
                    $scope.customFields = response.data.map(function (definition) {
                        return $portfolio.makeCustomFieldFromDefinition(definition, 'Portfolio Group');
                    });
                } else {
                    $scope.customFields = response.data;
                }

                $portfolio.cleanCustomFields($scope.customFields);
            });
    }

    function init() {
        $scope.rightsCustomFields = $oasRights.forCode('CUSTOMFIELDS');
        $scope.rightsTargetAllocation = $oasRights.forCode('TARGETALLOCATION');

        if ($scope.rightsCustomFields.canRead) {
            loadCustomFields();
        }

        if ($scope.current.isAddingNewGroup) {
            return;
        }

        $http.get(`/Portfolio/PortfolioGroups/${$scope.current.portfolioGroupId}`, { trackerMsg: 'Getting Portfolio Group' })
            .then(response => {
                $scope.current.portfolioGroup = response.data;

                $scope.current.name = $scope.current.portfolioGroup.name;
                $scope.current.portfolioType = $scope.current.portfolioGroup.portfolioType.split(', ');
                $scope.current.planId = $scope.current.portfolioGroup.planId;
                $scope.current.custodianId = $scope.current.portfolioGroup.custodianId;
                $scope.current.fundFamilyId = $scope.current.portfolioGroup.fundFamilyId;
                $scope.current.platformId = $scope.current.portfolioGroup.platformId;
                $scope.current.repId = $scope.current.portfolioGroup.repId;
                $scope.current.riskBudgetRange = $scope.current.portfolioGroup.riskBudgetRange;
                $scope.current.riskToleranceRange = $scope.current.portfolioGroup.riskToleranceRange;
                $scope.current.stockRange = $scope.current.portfolioGroup.stockRange;
                $scope.current.allowAttribute = $scope.current.portfolioType.any('Composite');

                if ($scope.current.portfolioGroup.modelAggId) {
                    $http.get(`/Trading/ModelAggs/${$scope.current.portfolioGroup.modelAggId}`, { trackerMsg: 'Getting Model Agg' })
                        .then(response => {
                            $scope.current.modelAggId = Object.select(response.data, ['id', 'name']);
                            $scope.original.modelAggId = $scope.current.modelAggId;
                        });
                }

                $scope.current.portfolioGroupChanges = $scope.current.portfolioGroup.changes.sortBy('effectiveDate').groupBy(['effectiveDate']);

                Object.each($scope.current.portfolioGroupChanges, function (key, value) {
                    const gd = { name: $scope.current.portfolioGroup.name, effectiveDate: key, monthsExclude: value[0].monthsExclude === null ? 1 : value[0].monthsExclude, changes: value };
                    $scope.current.portfolioGroupChangesGrouped.push(gd);
                });
            });
    }


    //PUBLIC METHODS
    $scope.close = function () {
        if (dialog) {
            dialog.close(null);
        }
        else {
            window.parent.postMessage("iframeclose");
        }
    };

    $scope.onPortfolioGroupTargetAllocationLoaded = function (payload) {
        $scope.current.targetAllocations = payload.allocations;
        $scope.current.targetAllocationType = payload.targetAllocationType;
    };

    $scope.onTargetAllocationTabSelected = function () {
        $scope.targetAllocationTabSelected = true;
    };

    $scope.save = function () {
        const payLoad = {
            accounts: null,
            name: $scope.current.name,
            clientId: $scope.current.clientId,
            portfolioType: $scope.current.portfolioType.join(),
            effectiveDate: $scope.current.effectiveDate,
            planId: $scope.current.planId,
            custodianId: $scope.current.custodianId,
            fundFamilyId: $scope.current.fundFamilyId,
            platformId: $scope.current.platformId,
            modelAggId: $scope.current.modelAggId ? $scope.current.modelAggId.id : null,
            repId: $scope.current.repId,
            riskBudgetRange: $scope.current.riskBudgetRange,
            riskToleranceRange: $scope.current.riskToleranceRange,
            stockRange: $scope.current.stockRange,
            eclipsePortfolioId: $scope.current.portfolioGroup?.eclipsePortfolioId,
            userDefinedFields: $scope.customFields
        };

        if ($scope.targetAllocationTabSelected && $scope.rightsTargetAllocation.canUpdate) {
            payLoad.targetAllocations = $scope.current.targetAllocations || [];
        }

        if ($scope.original.modelAggId && !payLoad.modelAggId) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Model",
                "Please use the Change History tab to delete a Model assignment.")
                .open();

            $scope.current.modelAggId = $scope.original.modelAggId;
            return;
        }

        if ($scope.useSharedTargetAllocationEditor && payLoad.targetAllocations && payLoad.targetAllocations.length > 0) {
            var abortMessages = [];
            targetAllocationSaveValidator.validateRows(payLoad.targetAllocations).forEach(function (m) {
                abortMessages.push(m);
            });
            if (abortMessages.length > 0) {
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Data", '<ul class="unstyled"><li>' + abortMessages.join("</li><li>") + '</li></ul>').open();
                return;
            }
        }

        if (!$scope.current.isAddingNewGroup) {
            payLoad.id = $scope.current.portfolioGroup.id;
            payLoad.changes = [];

            $scope.current.portfolioGroupChangesGrouped.forEach(gc => {
                if(gc.changes && (gc.changes.first.monthsExclude !== gc.monthsExclude || gc.changes.first.effectiveDate !== gc.effectiveDate)) {
                    gc.changes.forEach(change => {
                        change.monthsExclude = gc.monthsExclude;
                        change.effectiveDate = gc.effectiveDate;
                    });
                }
            });
            var changesGrouped = $scope.current.portfolioGroupChangesGrouped.map("changes");


            changesGrouped.forEach(function (changes) {
                changes.forEach(function (change) {
                    payLoad.changes.push(change);
                });
            });

            $http.put(`/Portfolio/PortfolioGroups/${$scope.current.portfolioGroup.id}`, payLoad, { trackerMsg: 'Saving Composite Group Changes' })
                .then(function (res) {
                    if (dialog) {
                        dialog.close(res.data);
                    }
                    else {
                        window.parent.postMessage("iframeclose");
                    }
                });
        } else {
            payLoad.id = 0;

            $http.post(`/Portfolio/Clients/${$scope.current.clientId}/PortfolioGroups`, payLoad, { trackerMsg: 'Saving Composite Group' })
                .then(function (res) {
                    if (dialog) {
                        dialog.close(res.data);
                    } else {
                        window.parent.postMessage("iframeclose");
                    }
                });
        }
    };

    $scope.portfolioTypeChanged = function () {
        $scope.current.allowAttribute = $scope.current.portfolioType.any("Composite");
    };

    $scope.changeGroupData = function (group) {
        group.changes.forEach(function (change) {
            if (change.action !== 'Delete') {
                change.effectiveDate = group.effectiveDate;
                change.monthsExclude = group.monthsExclude;
                change.action = 'Update';
            }
        });
    };

    $scope.deleteChange = function (change) {
        change.action = 'Delete';
    };

    $scope.disableOption = function (item) {
        const isRenderingTradingOption = item.optionId === 'Trading';
        const doesNotHaveTheRight = !$scope.current.allowedChangeTradingPortfolioGroups;
        return isRenderingTradingOption && doesNotHaveTheRight;
    };


    //INITIALIZE
    $scope.current = {
        portfolioGroupChangesGrouped: [],
        portfolioGroupChanges: [],
        isAddingNewGroup: dialog.options.isAddingNewGroup,
        portfolioTypes: dialog.options.portfolioTypes.reduce((obj, type) => {obj[type] = type; return obj;}, {}),
        clientId: dialog.options.clientId,
        portfolioGroupId: dialog.options.portfolioGroupId,
        name: null,
        portfolioType: ['Reporting'],
        planId: null,
        custodianId: null,
        fundFamilyId: null,
        platformId: null,
        modelAggId: null,
        repId: null,
        riskBudgetRange: null,
        riskToleranceRange: null,
        stockRange: null,
        effectiveDate: Date.create('today'),
        allowAttribute: false,
        allowedChangeTradingPortfolioGroups: dialog.options.allowedChangeTradingPortfolioGroups,
        targetAllocations: undefined,
        targetAllocationType: null
    };

    $scope.targetAllocationTabSelected = false;


    $scope.original = {
        modelAggId: null,
    };

    init();
});
'use strict';

var AccountListCtrl = app.controller('AccountListCtrl', function AccountListCtrl( $scope, $http, $oasRights, $location, $portfolio, $dialog, $routeParams, $settings, $timeout, $window, entities, views, apps, activeState, searchResult, $rebalance, $tactical, API_CONFIG, GoldmanSachsSsoService, $q,$schwab, civ2Service, splitIoService) {

    // PRIVATE VARIABLES
    var existingEditor;
    var accountId = null, registrationId = null, isSleeveAccount = false;
    var selectedIsActive = [];
    var selectedAccounts = [];
    var lastCell = null;
    var lastRow = null;
    const pageEntityType = entities.account.value;

    function applyWorkflowAssistantODataFilters() {
        var sync = window.portfolioListODataSidebarSync;
        if (!sync) {
            return false;
        }
        return sync.applyODataRouteFilters($scope, $location, 'account', activeState);
    }

    // PRIVATE METHODS
    function init() {
        var sync = window.portfolioListODataSidebarSync;
        if (sync && sync.initRecordColumnLimitFeature) {
            sync.initRecordColumnLimitFeature($scope, splitIoService, $http, $location, activeState, 'account', finishInit);
        } else {
            $scope.current.gridLimitsReady = true;
            finishInit(false);
        }
    }

    function finishInit(hasODataAccountFilter) {
        if (!$scope.current.portfolioSsrmEnabled) {
            hasODataAccountFilter = applyWorkflowAssistantODataFilters();
        }

        splitIoService.getBoolTreatment('recon_datasharing_editwarningmessages_7285').subscribe((isEnabled) => {
            $scope.isDataSharingWarningEnabled = isEnabled;
        });

        $scope.rightsHH = $oasRights.forCode("CLIENTS");
        $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
        $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
        $scope.rightsAst = $oasRights.forCode("ASSETS");
        $scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");
        $scope.rightsNewAcc = $oasRights.forCode("NEWACCOUNT");
        $scope.rightsCancelAccount = $oasRights.forCode("CANCELACCOUNT");
        $scope.rightsAccountChange = $oasRights.forCode("ACCOUNTCHANGE");
        $scope.rightsTOM = $oasRights.forCode("TRADEORDERMGMT");
        $scope.rightsFeeSchedules = $oasRights.forCode("FEESCHEDULES");
        $scope.rightsInstances = $oasRights.forCode("TRADEINSTANCES");
        $scope.rightsUndoCancel = $oasRights.forCode("UNDOACCTCANCEL");
        $scope.rightsPerfViewer = $oasRights.forCode("PERFVIEWER");
        $scope.rightsHouseholdOverview = $oasRights.forCode("HOUSEHOLDOVERVIEW");
        $scope.rightsTaxCenter = $oasRights.forCode("TAXCENTERMAINTAIN");
        $scope.rightsSchwabSII = $oasRights.forCode("SCHWABSII");
        $scope.rightsSchwabRequestCenter = $oasRights.forCode("SCHWABSERVICEREQUESTBETA");
        $scope.rightsInsight = $oasRights.forCode("INSIGHTBUILDERAPP");
        $scope.rightsUpdateCashModelForFees = $oasRights.forCode("UPDATEMODELFORFEES");
        $scope.rightsTargetAllocation = $oasRights.forCode("TARGETALLOCATION");
        $scope.rightsLaserApp = $oasRights.forCode("LASERAPP");
        $scope.rightsQuik = $oasRights.forCode("QUIK");
        $scope.rightsMoveAccount = $oasRights.forCode("MOVEACCOUNT");
        $scope.rightsDailyAnnuityValue = $oasRights.forCode("DAILYANNUITYVALUE");
        $scope.rightsStoredPerformance = $oasRights.forCode("STOREDPERFORMANCE");
        $scope.rightsSalesForceSync = $oasRights.forCode("SFSYNCHISTORY");
        $scope.rightsOrionEnterpriseProposal = $oasRights.forCode("ORIONENTERPRISEPROPOSAL");
        $scope.rightsBlackRock = $oasRights.forCode("BLACKROCK");
        $scope.rightsTransactionsManuallyManagedOnly = $oasRights.forCode("MANUALLYMANAGED");
        $scope.rightsPershingIntegration = $oasRights.forCode("PERSHINGINTEGRATION");
        $scope.rightsOrionStoredCostBasisManualCalc = $oasRights.forCode("ORIONSTOREDCOSTBASISMANUALCALC");
        $scope.rightsSleeveTransferPortfolio = $oasRights.forCode("SLEEVETRANSFERPORTFOLIO");
        $scope.rightsRestoreAccounts = $oasRights.forCode("RESTOREACCOUNTS");
        $scope.rightsPVCompare = $oasRights.forCode("PORTFOLIOVIEWCOMPARE");
        $scope.rightsPortfolioConvertAccount = $oasRights.forCode('PORTFOLIOCONVERTACCOUNT');
        $scope.rightsPortfolioRepresentativePayouts = $oasRights.forCode('PORTFOLIOREPRESENTATIVEPAYOUTS');

        $http.get("/Settings/Database/EntityOptions/Code/EnableLastReconDate", { cache: true, ignoreExceptions: true })
            .then(function (response) {
                $scope.current.isLastReconDateEnabled = response.data.value.toLocaleLowerCase() === "true";

                if (!$scope.current.isLastReconDateEnabled)
                {
                    $scope.current.view.slickGridColumnDefs = $scope.current.view.slickGridColumnDefs.filter(function (obj) {
                        return obj.id !== 'InBalance' && obj.id !== 'LastPositionDate' && obj.id !== 'LastReconciledEffectiveDate';
                    });
                }
            });

        if ( $routeParams.accountFilter === 'inactiveaccountsnotzero'){
            $scope.current.activeState = activeState.inActive;
        } else {
            if ($routeParams.accountFilter === 'missinginformation') $scope.current.returnStyle = "Audit";
            if (!hasODataAccountFilter && !$scope.current.activeState) {
                $scope.current.activeState = $settings.getSetting('activeState');
            }
        }

        if( searchResult ) {
            $scope.current.url = '';
            $portfolio.goTo(entities[entities.find({value: searchResult.entity})].urlFrag, searchResult.entity, searchResult.item.id);
        } else if (!hasODataAccountFilter) {
            if ($routeParams.entityId && ($routeParams.entity == parseInt(entities.client.value) || $routeParams.entity == parseInt(entities.registration.value))) {
                var urls = $portfolio.getDataUrls($routeParams.entity, $routeParams.entityId, entities.account.value);
                $scope.current.url = urls.urlForList;
                $scope.current.gridParams += urls.urlParams;
            } else if ($routeParams.entityId && $routeParams.entity == parseInt(entities.account.value)) {
                $scope.current.url = '/Portfolio/Accounts/' + $routeParams.entityId;
            } else if ($routeParams.pageQueryId) {
                $scope.current.activeState = activeState.activeAndInActive; // don't set a filter on active state, the page query spocs will handle that
                $portfolio.getPageQueryName($routeParams.pageQueryId)
                    .then(function (queryName) {
                        $scope.current.detailInfo = '(' + queryName + ')';
                    });
            } else if ($routeParams.entityId && $routeParams.entity == parseInt(entities.representative.value)) {
                $scope.current.url = '/Portfolio/Accounts';
                $scope.current.gridParams += '&representativeId=' + $routeParams.entityId;
            } else if ($routeParams.entityId && $routeParams.entity === entities.portfolioGroup.value) {
                var Urls = $portfolio.getDataUrls($routeParams.entity, $routeParams.entityId, entities.account.value);
                $scope.current.url = Urls.urlForList;
            } else if ($routeParams.entitySessionId) {
                $scope.current.url = '/Portfolio/Accounts';
                $scope.current.entitySessionId = $routeParams.entitySessionId;
                $scope.current.detailInfo = '(' + ($routeParams.info ? $routeParams.info : 'Externally Filtered') + ')';
            }
            else if ($routeParams.queryStudioId) {
                $scope.current.url = '/Portfolio/Accounts/qs';
                $scope.current.gridParams += '&queryStudioQueryId=' + $routeParams.queryStudioId;
                $scope.current.detailInfo = '(' + ($routeParams.info ? $routeParams.info : 'Filtered by Query Studio') + ')';
            }

            if ($routeParams.entity && $routeParams.entityId) {
                getCurrentEntityInfo().then(function (response) {
                    if (response.data) {
                        $scope.current.entity = response.data;
                        let name = $scope.current.entity.name;

                        if ($routeParams.entity === entities.representative.value) {
                            name = $scope.current.entity.lastName == null ? $scope.current.entity.firstName
                                : ($scope.current.entity.firstName == null ? $scope.current.entity.lastName
                                    : $scope.current.entity.lastName + ', ' + $scope.current.entity.firstName);
                        } else if ($routeParams.entity === entities.client.value) {
                            name = $scope.current.entity.lastName + ', ' + $scope.current.entity.firstName;
                            $scope.current.selectedHouseholdId = $scope.current.entity.id;
                        } else if ($routeParams.entity === entities.registration.value) {
                            name = $scope.current.entity.name + ', ' + $scope.current.entity.accountType;
                            $scope.current.selectedHouseholdId = $scope.current.entity.clientId;
                        } else {
                            $scope.current.selectedHouseholdId = 0;
                        }

                        if ($scope.current.entity !== null) {
                            switch ($routeParams.entity) {
                                case entities.representative.value:
                                case entities.client.value:
                                case entities.registration.value:
                                case entities.portfolioGroup.value:
                                    $scope.current.detailInfo = $portfolio.getBreadcrumb($routeParams.entity, name);
                                    break;
                            }
                        }
                    }
                });
            }
        }

        var portfolioSync = window.portfolioListODataSidebarSync;
        if ($scope.current.portfolioSsrmEnabled && portfolioSync) {
            if (portfolioSync.normalizeEntityRouteScopeForODataList) {
                portfolioSync.normalizeEntityRouteScopeForODataList($scope, 'account', $routeParams.entity, $routeParams.entityId);
            }
            if (portfolioSync.applyODataSortFromView) {
                portfolioSync.applyODataSortFromView($scope, 'account', $location.search(), {});
            }
        }

        if ($routeParams.source) {
            var key = apps.find({code: $routeParams.source});
            $scope.middleBreadcrumb = key ? apps[key].name : null;
        }

        $scope.resetWidth(false);

        if ($routeParams.openEditor && $scope.rightsAcc.canRead && $routeParams.entityId && $routeParams.entity == parseInt(entities.account.value)) {
            $scope.selectedIds.push($routeParams.entityId);
            $scope.openEditor(false);
        }

        if ($scope.current.portfolioSsrmEnabled && $scope.current.activeState) {
            $scope.current.committedActiveState = $scope.current.activeState;
        }

        var portfolioSync = window.portfolioListODataSidebarSync;
        if (portfolioSync && portfolioSync.markPortfolioListInitComplete) {
            portfolioSync.markPortfolioListInitComplete($scope);
        } else if (!$scope.current.portfolioSsrmEnabled) {
            $scope.current.gridLimitsReady = true;
        }
    }

    function doAction(actionUrl, msgVerb, confirmMsg) {
        $dialog.confirmAction(confirmMsg )
            .open()
            .then(function(result){
                if (result === 'yes') {
                    $http.post('/Portfolio/Accounts/ListCounts',  $scope.selectedIds, {trackerMsg: 'Getting account counts', allowCancellation: true})
                        .then(function(response){
                            var count = response.data;
                            var msg = 'By deleting this record, you will be permanently removing the following from your database: <br />';
                            msg += '  * ' + count.assetsCount + ' Assets' + '<br />';
                            msg += '  * ' + count.transactionsCount +  ' Transaction' + '<br />';
                            msg += 'If this data is needed to be restored, this can come at a cost to your firm.  Are you sure you still want to proceed?';

                            $dialog.confirmAction(msg)
                                .open()
                                .then(function(rst){
                                    if (rst === 'yes'){
                                        $http.put(actionUrl, $scope.selectedIds, {trackerMsg: msgVerb + ' account(s)'})
                                            .then(function () {
                                                refreshGrid();
                                            });
                                    }
                                });
                        });
                }
            });
    }

    function checkCustodian(accountId){
        $scope.current.showFidelityFBSLink = false;
        $scope.current.showFidelityNFSLink = false;
        if(!accountId || $scope.current.showSchwabLink == true || $scope.current.showGoldmanSachsLink == true){
            return;
        }
        $http.get(`/Integrations/Custodian/Account/${accountId}`)
        .then(function(result){
            if(result.data == "Fidelity"){
                checkFidelityType(accountId);
            }
            if(result.data == "Schwab"){
                $scope.current.showSchwabLink = true;
            }
            if(result.data == "GoldmanSachs"){
                $scope.current.showGoldmanSachsLink = true;
                fetchGoldmanSachsTokenStatus();
            }
        });
    }

    function fetchGoldmanSachsTokenStatus() {
        GoldmanSachsSsoService.getTokenStatus().then(function(res) {
            $scope.$evalAsync(function() { $scope.goldmanSachsTokenEstablished = res.tokenEstablished; });
        }).catch(function() {
            $scope.$evalAsync(function() { $scope.goldmanSachsTokenEstablished = false; });
        });
    }

    function checkFidelityType(accountId){
        $http.get(`/Integrations/Custodian/Account/${accountId}/FidelityType`)
                .then(function(result){
                    switch(result.data){
                        case "NFS":
                            $scope.current.showFidelityNFSLink = true;
                            break;
                        case "FBS":
                            $scope.current.showFidelityFBSLink = true;
                            break;
                    }
                });
    }

    function refreshGrid( ) {
        $scope.$broadcast('event:portfoliolist-account-action', {action: 'refresh-grid'});
    }

    function setOnRowSelect(args){
        $scope.current.selectedHouseholdId = args[0].clientId;
        $scope.current.selectedRegistrationId = args[0].registrationId;
        $scope.current.selectedFeeScheduleId = args[0].feeScheduleId;
        $scope.current.isActiveAccount = args[0].isActive;
        $scope.current.hasCancelDate = args[0].cancelDate;
        $scope.current.isSleeveAccount = args.none({isSleeveAccount: false});
        $scope.current.showSchwabLink =  args[0].custodian.match(/Schwab/gi) != null;
        $scope.current.showPershingLink = args[0].custodian.match(/Pershing/gi) != null;
        $scope.current.showGoldmanSachsLink = args[0].custodian.match(/Goldman|folio|gsas/gi) != null;
        if ($scope.current.showGoldmanSachsLink) fetchGoldmanSachsTokenStatus();
        else $scope.goldmanSachsTokenEstablished = null;
        $scope.analyzer.account.id = args[0].id;
        $scope.analyzer.account.accountNumber = args[0].number;
        $scope.analyzer.account.accountName = args[0].name;
        $scope.analyzer.account.accountType = args[0].accountType;
        $scope.analyzer.account.assets = [];

        checkCustodian(args[0].id);

        if($scope.analyzer.isActiveTab){
            $scope.enableAnalyzer();
        }
        // Rep payout tab
        $scope.repPayout.clientId = args[0].clientId;
        if($scope.repPayout.isActiveTab){
            $scope.resetWidth(true);
        }
    }

    // PUBLIC METHODS    

    $scope.syncToEclipse = function () {
        $http.post('/Portfolio/Accounts/SyncToEclipse', $scope.selectedIds, { tackerMsg: 'Syncing accounts to Eclipse' }).then(function (response) {
            // This function handles success
            const syncdAccounts = response.data.syncableAccounts;
            const unsyncdAccounts = response.data.unsyncableAccounts;

            var headerText = 'Sync To Eclipse Started Successfully'
            var messageBody = `<h4>successful accounts: ${response.data.syncableAccounts.length} <br/> failed accounts: ${response.data.unsyncableAccounts.length}</h4>`;
            if (unsyncdAccounts.length > 0) {
                messageBody += '<label>'
                //In case we need to troubleshoot successes
                //$(syncdAccounts).each(function (index, item) {
                //    messageBody += `<br/>Account ${item.accountId}: sync started succesfully`;
                //});
                $(unsyncdAccounts).each(function (index, item) {
                    messageBody += `<br/>Account ${item.accountId}: cannot be sync'd to Eclipse.`;
                });
                messageBody += '</label>'
            }
            $dialog.messageBox(`<i class='fa fa-info-circle fa-lg text-info' aria-hidden='true'></i> ${headerText}, ${messageBody}`).open();
        });
    };

    $scope.openBlackrockiRetire = function(){
        var testEnvironment = window.location.host.has("local") || window.location.host.has("test") ? "true" : "false";
        $window.open(API_CONFIG.baseUrl + '/Integrations/BlackRock/Redirect?testEnvironment=' + testEnvironment + '&portfolioId=' + $scope.current.selectedHouseholdId + '&entity=' + parseInt(entities.account.value) + '&entityId=' + $scope.selectedIds[0] + '&Authorization=' + sessionStorage.oas_token);
    }

    $scope.search = function( ) {
        $portfolio.search(entities.account.value)
            .then(function(rslt) {
                if( rslt ) {
                    $portfolio.goTo( entities[entities.find({value: rslt.entity})].urlFrag, rslt.entity, rslt.item.id );
                }
            });
    };

    $scope.runReport = function( ) {
        $portfolio.runReport( entities.account.value, $scope.selectedIds[0] );
    };

    $scope.openCustomIndexing = function() {
        $scope.current.showCustomIndex = true;
    };

    $scope.customindexevent = function(e){
        $scope.current.showCustomIndex = false;
    };

    $scope.importTargetAllocations = function () {
        $dialog.dialog({
            dialogClass: "modal medium",
            templateUrl: "app/modals/upload-file.html",
            controller: "UploadFileCtrl",
            title: "Target Allocation Import",
            idField: "id",
            downloadUrl: '/Portfolio/ValidateImport/TargetAllocationAccount/Templates/',
            validateUrl: '/Portfolio/ValidateImport/TargetAllocationAccount',
            commitVerb: 'PUT',
            commitUrl: '/Portfolio/Accounts/Verbose'})
            .open();
    };

    $scope.sfSyncDelta = function(){
        var startSync = function(){
            $http.post('/Integrations/Salesforce/OrionConnect/DeltaSync/7/' + $scope.analyzer.account.id, { trackerMsg:'Sending SalesForce Sync Request'})
                .then(function (response) {
                    $dialog.messageBox('SalesForce Sync', 'The SalesForce Sync started successfully').open();
                })
                .catch(function (reason) {
                    if(reason.statusText === 'Not Found'){
                        $dialog.messageBox('Sync Failed', 'Advisor is not setup with the salesforce.').open();
                    }
                })
        };

        $dialog.confirmAction('This will start the SalesForce Sync for ' + $scope.analyzer.account.accountName + '.  Would you like to continue?')
            .open()
            .then(function (result) {
                if(result.toLowerCase() === 'yes'){
                    startSync();
                }
            })

    };

    $scope.importStoredPerformance = function () {
        $dialog.dialog({
            dialogClass: "modal medium",
            templateUrl: "app/modals/upload-file.html",
            controller: "UploadFileCtrl",
            title: "Stored Performance Import",
            idField: "id",
            errorsOnly: true,
            downloadUrl: '/Portfolio/ValidateImport/StoredPerformance/Templates/',
            validateUrl: '/Portfolio/ValidateImport/StoredPerformance',
            //commitVerb: 'PUT',
            //commitUrl: '/Portfolio/ValidateImport/StoredPerformance/Import',
            exportUrl: '/Portfolio/ValidateImport/StoredPerformance/ExportErrors'})
            .open().then(function (result) {
                if(!result) return;

                $http.put('/Portfolio/ValidateImport/StoredPerformance/Import/' + result, null, {trackerMsg: 'Processing import'})
                    .then(function(response){
                        $dialog.messageBox("<i class='fa fa-check-square fa-lg text-success' aria-hidden='true'></i> Import Successful", "Stored performance has successfully imported " + response.data.length.format() + " records.").open();
                    });
            });
    };

    $scope.importSLOA = function () {
        civ2Service.getImportType("Account SLOA Add").then(function(res){
            $dialog.createCustomImport(res.data.id,"Create New Account SLOA Add");
        });
    };

    $scope.goToHouseholdOverview = function() {
        $location.url('/portfolio/household/overview?entity=' + parseInt(entities.account.value) + '&entityId=' + $scope.selectedIds[0]);
    };

    $scope.goToPortfolioView = function (tab) {
        let urlTemp = '/orion/dashboard?entity=' + parseInt(entities.account.value) + '&entityId=' + $scope.selectedIds[0];
        if (tab?.length > 0) {
            urlTemp = urlTemp + '&tab=' + tab;
        }
        $location.url(urlTemp);
    };

    $scope.goToSchwab = function(redirectId) {
        $http.get(`/portfolio/accounts/${$scope.selectedIds[0]}`, {trackerMsg: 'Signing into Schwab'})
        .then((res)=>{
            //let ssoUrl = `/api/v1/Integrations/SchwabSII/SSO?pageId=${redirectId}&Authorization=${sessionStorage.oas_token}&accountId=${res.data.number}`;
            let contextKey = (redirectId === 1 || redirectId === 15) ? "accountNumber" : "subaccount";
            let ssoUrl = `/api/v1/Integrations/SchwabSII/SsoV2/${redirectId}?Authorization=${sessionStorage.oas_token}&${contextKey}=${res.data.number}`;
                let ssoObject = {
                    name: 'Charles Schwab',
                    routeUrl: ssoUrl,
                    appCode: 'charlesSchwab'
                }
            $schwab.openEnrollmentModal(ssoObject);
        });
    };

    $scope.goToSchwabV2 = function(redirectId) {
        $http.get(`/portfolio/accounts/${$scope.selectedIds[0]}`, {trackerMsg: 'Signing into Schwab'})
            .then((res)=> {
                let contextKey = (redirectId === 1 || redirectId === 15) ? "accountNumber" : "subaccount";
                let ssoUrl = `/api/v1/Integrations/SchwabSII/SsoV2/${redirectId}?Authorization=${sessionStorage.oas_token}&${contextKey}=${res.data.number}`;
                let ssoObject = {
                    name: 'Charles Schwab',
                    routeUrl: ssoUrl,
                    appCode: 'charlesSchwab'
                }
                $schwab.sacCenter(ssoObject);
            });
    };

    function withGoldmanSachsToken(landingPage, accountNumber) {
        var context = accountNumber ? { accountNumber: accountNumber } : undefined;
        GoldmanSachsSsoService.goldmanSachsSsoRequest(landingPage, context, $scope.goldmanSachsTokenEstablished)
            .then(function(result) {
                if (result && result.actualTokenEstablished !== $scope.goldmanSachsTokenEstablished) {
                    $scope.$evalAsync(function() { 
                        $scope.goldmanSachsTokenEstablished = result.actualTokenEstablished; 
                    });
                }
            });
    }

    $scope.goToGoldmanSachs = function(landingPage) {
        withGoldmanSachsToken(landingPage, null);
    };

    $scope.goToGoldmanSachsClientView = function(landingPage) {
        var accountNumber = $scope.analyzer && $scope.analyzer.account && $scope.analyzer.account.accountNumber;
        if (!accountNumber) return;
        withGoldmanSachsToken(landingPage, accountNumber);
    };

    $scope.goToTaxCenter = function() {
        $location.url('/tax/custodianrealized?entity=' + parseInt(entities.account.value) + '&entityId=' + $scope.selectedIds[0]);
    };

    $scope.goToPerformanceViewer = function() {
        $location.url('/reports/performanceviewer3?entity=' + parseInt(entities.account.value) + '&entityId=' + $scope.selectedIds[0]);
    };

    $scope.goToAuditHistory = function() {
        $location.url('/portfolio/audithistory?entity=' + parseInt(entities.account.value) + '&entityId=' + $scope.selectedIds[0]);
    };

    $scope.goToSleeveTransfer = function () {
        if ($scope.selectedIds && $scope.selectedIds.length > 0) {
            $http.post(`/Portfolio/SleeveTransfer/EntitySession/Account`, $scope.selectedIds, { trackerMsg: 'Opening Sleeve Transfer' }).then((response) => {
                window.open(`#/portfolio/sleeve/transfer/${response.data}`, '_blank');
            })
        }
    };

    $scope.goToSleeveTransferHistory = function () {
        window.open('#/portfolio/sleeve/transfer/history', '_blank');
    };

    $scope.openEditor = function( isNewAccount, defaultTabNameOverride, defaultTabCodeOverride ) {
        if( $scope.selectedIds.length == 1 || isNewAccount ) {
            $portfolio.openEditor( entities.account.value, isNewAccount ? [] : $scope.selectedIds, defaultTabNameOverride, defaultTabCodeOverride, apps.portfolioLists.name, null ).then(function(rslt) {
                if( rslt ) {
                    $scope.$broadcast( 'event:portfoliolist-account-action', {action: rslt.isNew ? 'add-item' : 'update-item', item: rslt } );
                }
            });
        } else {
            $portfolio.openMassEditor( entities.account.value, $scope.selectedIds, apps.portfolioLists.name, null ).then(function(rslt) {
                if( rslt ) {
                    $scope.$broadcast( 'event:portfoliolist-account-action', {action: 'update-items', items: rslt } );
                }
            });
        }
    };
    
    $scope.clearCancelDate = function() {
        $scope.selectedIds.forEach(function (accountId) {
            $http.put('/Portfolio/Accounts/' + accountId + '/ClearCancelationDate/', {trackerMsg: 'Clearing cancelation date for ID: ' + accountId})
                .then(function (response) {
                    $scope.$broadcast( 'event:portfoliolist-account-action', {action: 'update-item', item: response.data} );
                });
        });
    }

    $scope.resetWidth = function (goWide) {
        let customWidth = $scope.repPayout.isActiveTab && !$scope.rightsPortfolioRepresentativePayouts.canRead ? 350 : 600;
        $scope.rightSidebar.width = goWide ? customWidth : 250;
    };

    $scope.enableAnalyzer = function () {
        $scope.resetWidth(true);
        $timeout(function () {
            $scope.$broadcast('event:refresh-analyzer', {analyzer: $scope.analyzer, action:'load-analyzer', forceRefresh:true, includePendingValue:true});
        });
    };

    $scope.enablePayout = function () {
        $scope.repPayout.isActiveTab = true;
        $scope.resetWidth(true);
    };

    $scope.openFeeSchedule = function( ) {
        $portfolio.openEditor( entities.feeSchedule.value, [$scope.current.selectedFeeScheduleId], null, null, apps.portfolioLists.name, {isFeeSchedule: true} ).then(function(rslt) {
            if( rslt ) {
                //$scope.$broadcast( 'event:portfoliolist-account-action', {action: 'update-item', item: rslt} );
                $scope.$broadcast( 'event:portfoliolist-account-action', {action: 'refresh-grid' } );
            }
        });
    };

    $scope.moveAccounts = function () {
        $dialog.search('registration', 'Destination')
            .open()
            .then(function (result) {
                if (!result) return;

                $scope.selectedIds.forEach(function (accountId) {
                    $http.put('/Portfolio/Accounts/' + accountId + '/Action/MoveToRegistration/' + result.id, null, {trackerMsg: 'Moving Account ID: ' + accountId})
                        .then(function (response) {
                            $scope.$broadcast( 'event:portfoliolist-account-action', {action: 'update-item', item: response.data} );
                        });
            });
        });
    };

    $scope.openCancellationEditor = function( isMassCancel ) {
        var d = $dialog.editor('portfolio/modals/cancelAccount.html', 'CancelAccountCtrl', {args: function() { return {id : isMassCancel ? null : $scope.selectedIds[0], entity : entities.account.value, app : apps.portfolioLists.name, preselectedIds: isMassCancel ? $scope.selectedIds : null }; }});
        d.open( ).then(function(rslt) {
            if( rslt ) {
                $scope.$broadcast( 'event:portfoliolist-account-action', {action: 'refresh-grid' } );
            }
        });
    };

    $scope.undoCancellation = function () {
        $scope.restoreAccountsSelected = [];

        selectedAccounts.forEach((acct) => {
            for (const [key, value] of Object.entries(acct)) {
                $scope.restoreAccountsSelected.push({ accountNumber: value, accountId: Number(key) });
            }
        });

        $scope.showAccountRestoreModal = true;
    }

    $scope.convertAccount = function () {
        $scope.showConvertAccountModal = true;
    }

    $scope.undoConvertAccount = function () {
        return $dialog.confirmAction(
            "Are you sure you want to undo account conversion?"
        ).open().then(function (result) {

            if (result === 'yes') {
                $http.delete('/Portfolio/Accounts/' + $scope.selectedIds[0] + '/Action/UndoConversion', { trackerMsg: 'Undoing Account Conversion' })
                    .then(function (response) {
                    });
            }

        });
    }

    $scope.undoCancellationOld = function () {
            return $dialog.messageBox(
                "<i class='fa fa-fw fa-undo text-info' aria-hidden='true'></i> Undo Account Cancellation",
                "Are you sure you want to undo account cancellation?",
                [
                    { result: 'restore', label: 'With Restore', cssClass: 'btn-success', focus: true },
                    { result: 'uncancel', label: 'Only Undo Cancellation', cssClass: 'btn-primary', focus: true },
                    { result: 'no', label: 'No' }
                ]
            ).open().then(function (result) {
                var params = {};
                if (result === 'restore') params.restore = true;
                else if (result === 'uncancel') params.restore = false;
                else return $q.reject();

                return $http.put('/Portfolio/Accounts/Action/UndoCancel/' + $scope.selectedIds[0], null, { params: params, trackerMsg: 'Undoing account cancellation' })
                    .then(function (response) {
                        $dialog.messageBox('Undo Cancel Results', response.data.result).open();
                        return $http.get("/Portfolio/Accounts/" + $scope.selectedIds[0], { trackerMsg: 'Refreshing account' })
                            .then(function (response) {
                                $scope.$broadcast('event:portfoliolist-account-action', { action: 'update-item', item: response.data });
                            });
                    });

            });
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:portfoliolist-account-action', {action: 'export-data'});
    };

    $scope.deleteAccounts = function () {
        splitIoService.getBoolTreatment("recon_datasharing_editwarningmessages_7285")
            .subscribe((isEnabled) => {
                if ($scope.isDataSharingEntitySelected && isEnabled) {
                    $dialog.confirmAction('Account is a data sharing Account. Changes are likely to be reverted by subsequent syncs.  Would you still like to proceed?')
                        .open()
                        .then((response) => {
                            if (response == 'yes') {
                                doAction('/portfolio/accounts/action/delete', 'Deleting', 'It is Orion\'s best practice to not delete accounts. If you proceed with this deletion, you will be responsible for providing this data should you need it to be recorded in Orion in the future or for auditing purposes. Are you sure you want to proceed?');
                            }
                        });
                }
                //else do legacy
                else {
                    doAction('/portfolio/accounts/action/delete', 'Deleting', 'It is Orion\'s best practice to not delete accounts. If you proceed with this deletion, you will be responsible for providing this data should you need it to be recorded in Orion in the future or for auditing purposes. Are you sure you want to proceed?');
                }
            });
        
    };

    $scope.goToLower = function( urlLevel ) {
        $portfolio.goTo( urlLevel, entities.account.value, $scope.selectedIds[0]);
    };

    $scope.goToHigher = function( urlLevel ) {
        if( urlLevel == 'households' && $scope.current.selectedHouseholdId > 0 ) {
            $portfolio.goTo( urlLevel, entities.client.value, $scope.current.selectedHouseholdId );
        } else if( urlLevel == 'registrations' && $scope.current.selectedRegistrationId > 0 ) {
            $portfolio.goTo( urlLevel, entities.registration.value, $scope.current.selectedRegistrationId );
        }
    };

    $scope.goToOrionStoredCostBasisStatus = function() {
        $location.url('/portfolio/orionstoredcostbasis/manualcalculations');
    };

    $scope.goToPortfolioGroups = function(){
        if ($routeParams.entityId && $routeParams.entity === entities.portfolioGroup.value){
            $portfolio.goTo('portfoliogroups', entities.portfolioGroup.value, $routeParams.entityId);
        } else {
            $portfolio.goTo('portfoliogroups', entities.account.value, $scope.selectedIds[0]);
        }
    };

    $scope.setActiveState = function( ) {
        if (!$scope.current.portfolioSsrmEnabled) {
            $settings.setSetting('activeState', $scope.current.activeState);
            $timeout(refreshGrid);
            return;
        }
        var sync = window.portfolioListODataSidebarSync;
        if (sync && sync.onActiveStateChanged) {
            sync.onActiveStateChanged($scope, $settings, $timeout, refreshGrid, $http);
            return;
        }
        $settings.setSetting( 'activeState', $scope.current.activeState );
        $timeout(refreshGrid);
    };

    $scope.openRebalance = function() {
        $rebalance.start( 6, $scope.selectedIds );
    };

    $scope.openTactical = function() {
        $tactical.start( "account", $scope.selectedIds, true );
    };

    $scope.updateCashModelForFees = function () {
        $dialog.confirmAction("Would you like to update model to reserve fees?  Please note this can take a while.")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.post("/Portfolio/Accounts/Action/UpdateCashModelForFees", null, {trackerMsg: "Updating cash model for fees"})
                        .then(function () {
                            $dialog.actionComplete("Cash model update finished successfully.").open();
                        });
                }
            });
    };

    $scope.goBack = function () {
        window.history.back();
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    };

    $scope.openAnnuityValues = function () {
        var dialogOpts = {
            templateUrl: "portfolio/modals/annuity-value.html",
            controller: "AnnuityValueCtrl",
            accountId: $scope.selectedIds[0],
            dialogClass: "modal wide"
        };
        $dialog.dialog( dialogOpts ).open( );
    };

    $scope.calculateOrionStoredCostBasis = function() {
        var dialogOpts = {
            templateUrl: 'portfolio/modals/calculate-orion-stored-cost-basis.html',
            controller: 'CalculateOrionStoredCostBasisCtrl',
            isAccountLevel: true,
            calculateIds: $scope.selectedIds,
            backdrop: true,
            backdropClick: true
        }

        $dialog.dialog(dialogOpts).open();
    };

    $scope.openProposalTool = function (){
        $http.get('/Settings/Database/EntityOptions/Code/69SLEEVETR', {cache: true, trackerMsg: 'Loading use sleeve setting'} )
            .then(function(response){
                var useSleeve = 'false';

                if(response.data.value.toLowerCase() === "true"){
                    useSleeve = 'true';
                }

                if (isSleeveAccount){ // Null out account id if it is a Sleeve Account
                    accountId = null;
                } else {
                    registrationId = null;
                }

                var url = API_CONFIG.ftjProposalToolUrl + '?portfolioId=null&registrationId=' +  registrationId  + '&accountId=' +  accountId + '&UseSleeves='  + useSleeve + '&t=' + sessionStorage.oas_token;
                window.open(url,'_blank');
            });
    };

    $scope.refreshGridData = function(){
        $scope.current.refreshCache = true;
        $timeout(function () {
            var clearRefreshCache = function () {
                $scope.current.refreshCache = false;
            };
            var searchSidebarFilters = $scope.searchSidebarFilters || $scope.current.searchSidebarFilters;
            if ($scope.current.portfolioSsrmEnabled
                && typeof searchSidebarFilters === 'function'
                && !$scope.current.entityRouteGetById) {
                // Same as the sidebar's Refresh Grid: re-applies the filters and re-matches file filters.
                searchSidebarFilters();
                $timeout(clearRefreshCache);
            } else {
                refreshGrid();
                $timeout(clearRefreshCache);
            }
        });
    };

    $scope.schwabServiceRequest = function() {
        //debugger;
        let schwabSSOUrl = API_CONFIG.baseUrl + '/Integrations/SchwabSII/SsoV2/11?Authorization=' + sessionStorage.oas_token;
        const account = {
            id: $scope.analyzer.account.id,
            number: $scope.analyzer.account.accountNumber,
            name: $scope.analyzer.account.accountName
        };
        $schwab.sacCenter({ appCode: 'charlesSchwab', routeUrl: schwabSSOUrl });
        
        //$schwab.getEnrollmentStatus().then(function (enrollment) {
        //    if (enrollment.data["enrollmentStatus"] != "Enrolled" && enrollment.data["statusIndicator"] != "Active") {
        //        $schwab.openEnrollmentModal();
        //        ;
        //    } else {
        //        const account = {
        //            id: $scope.analyzer.account.id,
        //            number: $scope.analyzer.account.accountNumber,
        //            name: $scope.analyzer.account.accountName
        //        };
        //        $dialog.dialog({templateUrl: "app/modals/schwabServiceRequest.html", controller: "schwabServiceRequestCtrl", account: account }).open();
        //    }
        //});
    }

    function setQuickFiltersFromSession() {
        if ($scope.current.selectedHouseholdId && $scope.current.setQuickFilters) {
            const key = $scope.user.authorization.alClientId + '_' + $scope.current.selectedHouseholdId + '_' + pageEntityType;
            const portfolioFiltersJson = sessionStorage.getItem('porfolio_grid_filters');
            let portfolioFilters = {};
            if (portfolioFiltersJson) {
                portfolioFilters = JSON.parse(portfolioFiltersJson);
                if (key in portfolioFilters) {
                    $scope.current.setQuickFilters(JSON.parse(portfolioFilters[key]))
                }
            }
        } else {
            sessionStorage.setItem('porfolio_grid_filters', "{}");
        }
    }

    function getCurrentEntityInfo() {
        if ($routeParams.entityId && $routeParams.entity) {
            let url = null;
            switch ($routeParams.entity) {
                case entities.representative.value:
                    url = '/Portfolio/Representatives/';
                    break;
                case entities.client.value:
                    url = '/Portfolio/Clients/';
                    break;
                case entities.registration.value:
                    url = '/Portfolio/Registrations/';
                    break;
                case entities.portfolioGroup.value:
                    url = '/Portfolio/PortfolioGroups/';
                    break;
                case entities.account.value:
                    url = '/Portfolio/Accounts/';
                    break;
                case entities.asset.value:
                    url = '/Portfolio/Assets/';
                    break;
                case entities.transaction.value:
                    url = '/Portfolio/Transactions/';
                    break;
            }

            if (url !== null) {
                return $http.get(url + $routeParams.entityId, {
                    cache: true,
                    trackerMsg: 'Loading entity info',
                });
            }
        }

        return Promise.reject('The entity specified is invalid.');
    }

    //EVENT LISTENERS
    $scope.$on("event:portfoliolist-account-select", function(e, args) {
        if( args.length === 0 ) return;

        accountId = args[0].id;
        isSleeveAccount = args[0].isSleeveAccount;
        registrationId = args[0].registrationId;
        selectedIsActive = args.map('isActive').unique();
        selectedAccounts = args.map((acct) => ({ [acct.id]: acct.number }));
        $scope.allSelectedInactive = !selectedIsActive.any((isActive) => isActive == true);
        $scope.isDataSharingEntitySelected = false;

        args.forEach((arg) =>
        {
            if (arg.isDataSharingEntity === true) {
                $scope.isDataSharingEntitySelected = true;
            }
        });

        setOnRowSelect(args);
    });
    $scope.$on("event:portfoliolist-account-edit", function (e, args) {
        if (!args.item) return;
        if (!args.item.isDataSharingEntity) return;
        var isDifferentRow = false;
        var isDifferentCell = false;
        if (lastRow != args.row) {
            isDifferentRow = true;
            lastRow = args.row;
        }
        if (lastCell != args.cell) {
            isDifferentCell = true;
            lastCell = args.cell;
        }

        if ($scope.isDataSharingWarningEnabled && (isDifferentRow || isDifferentCell)) {
            $dialog.messageBox("Account is a data sharing account. Changes are likely to be reverted by subsequent syncs.")
                .open().then(() => {
                    args.grid.gotoCell(args.row, args.cell, true);
                }
                );
        }
    });

    $scope.$on('slickgrid-data-loaded', function(event, data) {
        if (data.length === 1){
            setOnRowSelect(data);
            $scope.$broadcast('event:portfoliolist-account-action',{action:'select-items', items: data.slice(0,1) });
        }
        else if ($routeParams.entityId && data.length > 0){
            setOnRowSelect(data);
        }
        setQuickFiltersFromSession();
    });

    $scope.$on('slickgrid-last-refresh', function(event, data) {
        $scope.current.lastUpdated = data;
    });

    $scope.$on('event:slickgrid-columnfilter-change', function (e, args) {
        if ($scope.current.selectedHouseholdId) {
            const newValJson = JSON.stringify(args);
            const key = $scope.user.authorization.alClientId + '_' + $scope.current.selectedHouseholdId + '_' + pageEntityType;
            const portfolioFiltersJson = sessionStorage.getItem('porfolio_grid_filters');
            let portfolioFilters = {};
            if (portfolioFiltersJson) {
                portfolioFilters = JSON.parse(portfolioFiltersJson);
                if (!(key in portfolioFilters)) {
                    // make sure no other entries exist at the same time
                    portfolioFilters = {};
                }
            }
            portfolioFilters[key] = newValJson;
            sessionStorage.setItem('porfolio_grid_filters', JSON.stringify(portfolioFilters));
        }
    });

    $scope.onAccountRestoreModalClose = function () {
        $scope.showAccountRestoreModal = false;
    };

    $scope.onConvertAccountModalClose = function (convertedAccount) {
        $scope.showConvertAccountModal = false;
        if (convertedAccount && convertedAccount.id) {
            $scope.$broadcast('event:portfoliolist-account-action', { action: 'update-item', item: convertedAccount });
        }
    }

    // INITIALIZE
    $scope.views = views;

    $scope.analyzer = {
        groupingType: "0",
        usePendingValue: "pending",
        tableMode: "percent",
        lastAnalyzedId: 0,
        height: 400,
        sortField: '',
        sortReverse: false,
        account: {id: 0, accountNumber: "", registrationName: "", accountType: "", assets: []},
        isActiveTab: false
    };
    $scope.repPayout = {
        clientId: null,
        isActiveTab: false
    };
    $scope.analyzer.chart = {
        options: {
            chart: {type: 'bar', borderWidth: 0},
            credits: {enabled: false},
            legend: {enabled: true, borderWidth: 0},
            xAxis: {
                categories: [], labels: {
                    formatter: function () {
                        return this.value.length > 6 ? this.value.first(3) + "..." : this.value;
                    }
                }
            },
            yAxis: {
                title: {text: ''}, labels: {
                    formatter: function () {
                        return this.value === 0 ? 'Target' : this.value + ' %';
                    }
                }
            },
            plotOptions: {bar: {grouping: false, shadow: false, pointPadding: 0}},
            tooltip: {
                formatter: function () {
                    var chart = this.points[0].series.chart;
                    var categories = chart.xAxis[0].categories;
                    var index = 0, temp = {};

                    while (this.x !== categories[index]) {
                        index++;
                    }
                    chart.series.forEach(function (series) {
                        temp[series.name] = series.yData[index];
                    });

                    var target = temp['Target'].round(2);
                    var bottom = (temp['Target'] + temp['Lower']).round(2);
                    var top = (temp['Target'] + temp['Upper']).round(2);
                    var range = bottom === target && top === target ? '' : '<br/>Range: ' + bottom + ' - ' + top + ' %';
                    var curr = parseFloat(temp['Current']) + target;

                    return '<b>' + this.x + '<br/>Target: ' + target + ' %' + range + '<br/>Current: ' + curr + ' %';
                },
                shared: true,
                shadow: false,
                borderColor: "#CCCCCC"
            }
        },
        series: [
            {data: [], name: 'Lower', borderColor: "#00AEEF", color: "rgba(0, 170, 239, 0.1)"},
            {data: [], name: 'Upper', borderColor: "#00AEEF", color: "rgba(0, 170, 239, 0.1)"},
            {data: [], name: 'Current', borderColor: "#00AEEF", color: '#00AEEF', pointPadding: 0.2},
            {data: [], name: 'Target', visible: false, showInLegend: false}
        ],
        title: {text: ''},
        subtitle: {text: null}
    };

    $scope.selectedIds = [];
    $scope.current = {
        view : views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        gridQueries: [],
        hasValue : false,
        url : '/Portfolio/Accounts/Grid',
        useOData: false,
        useServerSideRowModel: false,
        gridParams : '',
        odataListProfileKey: 'account',
        gridLimitsReady: false,
        portfolioListFiltersReady: false,
        gridRowCountsReady: false,
        portfolioGridLimitsSettingEnabled: false,
        portfolioSsrmEnabled: false,
        slickGridRecordColumnLimitEnabled: false,
        gridRecordLimit: 0,
        viewsColumnsLimit: 0,
        detailInfo : '',
        selectedHouseholdId : 0,
        selectedRegistrationId : 0,
        activeStates : activeState,
        accountFilter : $routeParams.accountFilter,
        pageQueryId: $routeParams.pageQueryId,
        returnStyle : 'Standard',
        selectedFeeScheduleId : 0,
        isSleeveAccount: false,
        isActive : false,
        hasCancelDate : false,
        showSchwabLink: false,
        showGoldmanSachsLink: false,
        showFidelityFBSLink: false,
        showFidelityNFSLink: false,
        showPershingLink: true,
        insightUrl : API_CONFIG.insightUrl + '?p=dashboards&t=' + sessionStorage.oas_token,
        refreshCache: false,
        lastUpdated: null,
        showCustomIndex: false,
        entity: null
    };

    $scope.showAccountRestoreModal = false;
    $scope.showConvertAccountModal = false;
    $scope.restoreAccountsSelected = [];
    $scope.allSelectedInactive = false;
    $scope.reportArgs = {};

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
            $scope.openEditor(false);
    }}];

    init( );
});

AccountListCtrl.loadAccountViews = ["$http", "$route", function($http, $route){
    var dto = "";
    switch ($route.current.params.accountFilter ? $route.current.params.accountFilter.toLowerCase() : "") {
        case "missinginformation":
            dto = "AccountMissingInfoDto";
            break;
        default:
            dto = "AccountDto";
            break;
    }

    if (dto === "") dto = "AccountDto";

    return $http.get('/Settings/Views/' + dto, {trackerMsg : 'Loading account views'}).then(function(response){return response.data});
}];

'use strict';

app.controller('AssetListCtrl', function AssetListCtrl($scope, $http, $oasRights, $location, $dialog, $portfolio, $routeParams, $timeout, $window, entities, views, apps, API_CONFIG, splitIoService) {
    //PRIVATE VARIABLES
    let selectedProductId = 0;
    let symbol = undefined;
    var lastCell = null;
    var lastRow = null;
    const pageEntityType = entities.asset.value;

    // PRIVATE METHODS
    function init() {
        splitIoService.getBoolTreatment('recon_datasharing_editwarningmessages_7285').subscribe((isEnabled) => {
            $scope.isDataSharingWarningEnabled = isEnabled;
        });

        $scope.rightsHH = $oasRights.forCode("CLIENTS");
        $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
        $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
        $scope.rightsAst = $oasRights.forCode("ASSETS");
        $scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");
        $scope.rightsProduct = $oasRights.forCode("PRODUCTS");
        $scope.rightsIsStrategyOverride = $oasRights.forCode("ASSLEVELSTRATASSIGN");
        $scope.rightsHistoricalAst = $oasRights.forCode("HISTORICALASSETS");
        $scope.rightsTaxCenter = $oasRights.forCode("TAXCENTERMAINTAIN");
        $scope.rightsSchwabSII = $oasRights.forCode("SCHWABSII");
        $scope.rightsAssetPriceHistory = $oasRights.forCode("ASSETPRICEHISTORY");
        $scope.rightsManuallyManaged = $oasRights.forCode('MANUALLYMANAGED');
        $scope.rightsOrionStoredCostBasisManualCalc = $oasRights.forCode("ORIONSTOREDCOSTBASISMANUALCALC");
        $scope.rightsSleeveTransferPortfolio = $oasRights.forCode("SLEEVETRANSFERPORTFOLIO");

        setUrlAndParams(true);

        if ($routeParams.openEditor && $scope.rightsAst.canRead && $routeParams.entityId && $routeParams.entity == parseInt(entities.asset.value)) {
            $scope.selectedIds.push($routeParams.entityId);
            $scope.openEditor(false);
        }
    }

    function setUrlAndParams(firstRun) {
        $scope.current.gridParameters = "includeCostBasis=" + $scope.current.showCostBasis;
        const asOfDate = $scope.current.asOfDate.format('{MM}-{dd}-{yyyy}');

        if ($routeParams.hasValue) {
            $scope.current.gridParameters += `&hasValue=${$routeParams.hasValue}`;
        }

        if ($routeParams.custodianName) {
            $scope.current.gridParameters += `&custodianName=${$routeParams.custodianName}`;
        }

        if ($routeParams.entity && $routeParams.entityId) {
            switch ($routeParams.entity) {
                case entities.client.value:
                case entities.registration.value:
                case entities.account.value:
                    const urls = $portfolio.getDataUrls($routeParams.entity, $routeParams.entityId, entities.asset.value, asOfDate);
                    $scope.current.url = urls.urlForList;
                    break;
                case entities.asset.value:
                    $scope.current.url = '/Portfolio/Assets/' + $routeParams.entityId;
                    $scope.current.gridParameters += "&asOfDate=" + asOfDate;
                    break;
                case entities.product.value:
                    $scope.current.url = '/Portfolio/Assets';
                    $scope.current.gridParameters += '&productId=' + $routeParams.entityId + "&asOfDate=" + asOfDate;
                    break;
                case entities.portfolioGroup.value:
                    const Urls = $portfolio.getDataUrls($routeParams.entity, $routeParams.entityId, entities.asset.value);
                    $scope.current.url = Urls.urlForList;
                    $scope.current.gridParameters += "&asOfDate=" + asOfDate;
                    break;
            }

            getCurrentEntityInfo().then(function (response) {
                if (response.data) {
                    $scope.current.entity = response.data;
                    let name = $scope.current.entity.name;

                    if ($routeParams.entity === entities.representative.value) {
                        name = $scope.current.entity.lastName == null ? $scope.current.entity.firstName
                            : ($scope.current.entity.firstName == null ? $scope.current.entity.lastName
                                : $scope.current.entity.lastName + ', ' + $scope.current.entity.firstName);
                    } else if ($routeParams.entity === entities.client.value) {
                        name = $scope.current.entity.lastName + ', ' + $scope.current.entity.firstName;
                        $scope.current.selectedHouseholdId = $scope.current.entity.id;
                    } else if ($routeParams.entity === entities.registration.value || $routeParams.entity === entities.account.value) {
                        name = $scope.current.entity.name + ', ' + $scope.current.entity.accountType;
                        $scope.current.selectedHouseholdId = $scope.current.entity.clientId;
                    } else if ($routeParams.entity !== entities.product.value) {
                        $scope.current.selectedHouseholdId = $scope.current.entity.clientId;
                    }

                    if (firstRun && $scope.current.entity !== null) {
                        switch ($routeParams.entity) {
                            case entities.client.value:
                            case entities.registration.value:
                            case entities.account.value:
                            case entities.portfolioGroup.value:
                                $scope.current.detailInfo = $portfolio.getBreadcrumb($routeParams.entity, name);
                                break;
                            case entities.product.value:
                                $scope.current.detailInfo = '(Product: ' + name + ')';
                                break;
                        }
                    }
                }
            });
        } else if ($routeParams.pageQueryId) {
            $scope.current.url = '/Portfolio/Assets';
            $scope.current.gridParameters += "&pageQueryId=" + $routeParams.pageQueryId + "&asOfDate=" + asOfDate;

            if (firstRun) {
                $portfolio.getPageQueryName($routeParams.pageQueryId)
                    .then(function (queryName) {
                        $scope.current.detailInfo = '(' + queryName + ')';
                    });
            }
        } else {
            $scope.search();
        }
    }

    function doAction(actionUrl, msgVerb, confirmMsg) {
        $dialog.confirmAction(confirmMsg)
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.post('/Portfolio/Assets/ListCounts', $scope.selectedIds, {trackerMsg: 'Getting transaction counts', allowCancellation: true})
                        .then(function (response) {
                            const count = response.data;
                            const msg   = 'By deleting this record, you will be permanently removing the following from your database: <br />'
                                        + '  * ' + count.transactionsCount + ' Transaction' + '<br />'
                                        + 'If this data needs to be restored, this can come at a cost to your firm.  Are you sure you still want to proceed?';
                            $dialog.confirmAction(msg)
                                .open()
                                .then(function (result) {
                                    if (result === 'yes') {
                                        $http.put(actionUrl, $scope.selectedIds, {trackerMsg: msgVerb + ' asset(s)'})
                                            .then(function () {
                                                refreshGrid();
                                            });
                                    }
                                });
                        });
                }
            });
    }

    function refreshGrid() {
        $scope.$broadcast('event:portfoliolist-asset-action', {action: 'refresh-grid'});
    }

    function setOnRowSelect(args) {
        $scope.current.selectedHouseholdId = args[0].clientId;
        $scope.current.selectedRegistrationId = args[0].registrationId;
        $scope.current.selectedAccountId = args[0].accountId;
        symbol = args[0].ticker;
        selectedProductId = args[0].productId;

        args.forEach((item) => {
            if (item.isDataSharingEntity) {
                $scope.isDataSharingEntity = true;
            }
        });

        handleManuallyMangedAsset(args);
    }

    function handleManuallyMangedAsset ( assets){
        if ($scope.selectedIds.length !== 1)
            return;
        const asset = assets[0];
        $scope.current.rightsManuallyManaged = isManuallyManaged(asset) ? $scope.rightsManuallyManaged : {
                canUpdate: false,
                canDelete: false,
                canRead: false,
                canAdd: false,
        }
    }

    function isManuallyManaged( asset){
        if ( asset == null)
            return false;

        return asset.status === 2 || asset.accountStatusId === 3 || asset.accountStatusId === 8;
    }

    // PUBLIC METHODS
    $scope.openSchwabResearchCenter = function () {
        //$window.open(API_CONFIG.baseUrl + '/Integrations/SchwabSII/SSO?pageId=4&symbol=' + symbol + '&Authorization=' + sessionStorage.oas_token);
        $window.open(API_CONFIG.baseUrl + '/Integrations/SchwabSII/SsoV2/4?symbol=' + symbol + '&Authorization=' + sessionStorage.oas_token);
    };

    $scope.runAssetStrategy = function () {
        const args = {method: "PUT", url: '/Portfolio/AssetLevelStrategies/Action/AutoAssign?accountId=' + $scope.current.selectedAccountId, trackerMsg: "Auto assign asset strategy for account: " + $scope.current.selectedAccountId};
        $http({method: args.method, url: args.url, data: null, trackerMsg: args.trackerMsg});
    };

    $scope.assignAssetLevelStrategy = function () {
        const dialogOpts = {
            templateUrl: "assetLevelStrategy-assignment.html",
            controller: "AssetLevelStrategyAssignmentCtrl"
        };

        const d = $dialog.dialog(dialogOpts);
        d.open();
    };

    $scope.calculateOrionStoredCostBasis = function() {
        var dialogOpts = {
            templateUrl: 'portfolio/modals/calculate-orion-stored-cost-basis.html',
            controller: 'CalculateOrionStoredCostBasisCtrl',
            isAccountLevel: false,
            calculateIds: $scope.selectedIds,
            backdrop: true,
            backdropClick: true
        }

        $dialog.dialog(dialogOpts).open();
    };

    function loadAssetEditor(accountId, isNewAsset) {
        $http.get('/Portfolio/Accounts/' + accountId + '/Simple', {trackerMsg: 'Loading account'})
            .then(function (response) {
                $scope.current.selectedAccountId = $routeParams.entityId;
                $scope.current.selectedHouseholdId = response.data.clientId;
                const extraInfo = {
                    fkClient: response.data.clientId,
                    fkAccount: response.data.id
                };

                $portfolio.openEditor(entities.asset.value, isNewAsset ? [] : $scope.selectedIds, null, null, apps.portfolioLists.name, extraInfo).then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:portfoliolist-asset-action', {action: rslt.isNew ? 'add-item' : 'update-item', item: rslt});
                    }
                });
            });
    }

    $scope.openEditor = function (isNewAsset, tabCode) {
        if ($scope.selectedIds.length == 1 || isNewAsset) {
            let extraInfo = null;

            // This is to handle when the user doesn't click on an existing asset row. TT 12.2.2014
            if (isNewAsset && $scope.selectedIds.length == 0) {

                switch ($routeParams.entity) {
                    case "5": // Household
                        $http.get('/Portfolio/Clients/' + $routeParams.entityId + '/Accounts', {trackerMsg: 'Loading accounts'})
                            .then(function (response) {
                                loadAssetEditor(response.data[0].id, isNewAsset);
                            });
                        break;
                    case "6": // Registration
                        $http.get('/Portfolio/Registrations/' + $routeParams.entityId + '/Accounts', {trackerMsg: 'Loading accounts'})
                            .then(function (response) {
                                loadAssetEditor(response.data[0].id, isNewAsset);
                            });
                        break;
                    case "7":// Account
                        loadAssetEditor($routeParams.entityId, isNewAsset);
                        break;

                }
            } else {
                extraInfo = {
                    fkClient: $scope.current.selectedHouseholdId,
                    fkAccount: $scope.current.selectedAccountId
                };

                $portfolio.openEditor(entities.asset.value, isNewAsset ? [] : $scope.selectedIds, null, tabCode, apps.portfolioLists.name, extraInfo).then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:portfoliolist-asset-action', {action: rslt.isNew ? 'add-item' : 'update-item', item: rslt});
                    }
                });
            }
        } else {
            $portfolio.openMassEditor(entities.asset.value, $scope.selectedIds, apps.portfolioLists.name, null).then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast('event:portfoliolist-asset-action', {action: 'update-items', items: rslt});
                }
            });
        }
    };

    $scope.search = function () {
        $portfolio.customSearch(entities.account.value, [entities.client.value,entities.portfolioGroup.value, entities.registration.value, entities.account.value, entities.asset.value])
            .then(function (rslt) {
                if (rslt) {
                    $portfolio.goTo('assets', rslt.entity, rslt.item.id);
                }
            });
    };

    $scope.goToProduct = function () {
        const d = $dialog.editor("products/editors/product-edit.html", "ProductEditCtrl", {
            args: function () {
                return {
                    id: selectedProductId,
                    app: apps.productsAndPrices,
                    defaultTab: {name: "Local", active: true, code: "productGeneral"},
                    extraInfo: null,
                    isNewGlobal: false,
                    isNewLocal: false
                };
            }
        });

        d.open().then(function (rslt) {
            if (rslt) {
                $scope.$broadcast('event:portfoliolist-asset-action', {action: 'refresh-grid'}); // refresh entire grid in case there are multiple assets owning the product
            }
        });
    };

    $scope.goToProducts = function () {
        $portfolio.goToProduct(selectedProductId);
    };

    $scope.goToTaxCenter = function () {
        $location.url('/tax/custodianrealized?entity=' + parseInt(entities.asset.value) + '&entityId=' + $scope.selectedIds[0]);
    };

    $scope.goToSleeveTransfer = function () {
        if ($scope.selectedIds && $scope.selectedIds.length > 0) {
            $http.post(`/Portfolio/SleeveTransfer/EntitySession/Asset`, $scope.selectedIds, { trackerMsg: 'Opening Sleeve Transfer' }).then((response) => {
                window.open(`#/portfolio/sleeve/transfer/${response.data}`, '_blank');
            })
        }
    };

    $scope.goToSleeveTransferHistory = function () {
        window.open('#/portfolio/sleeve/transfer/history', '_blank');
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:portfoliolist-asset-action', {action: 'export-data'});
    };

    $scope.updateGridUrl = function () {
        setUrlAndParams(false);

        $timeout(function () {
            refreshGrid();
        });
    };

    $scope.deleteAssets = function ()
    {
        splitIoService.getBoolTreatment("recon_datasharing_editwarningmessages_7285")
            .subscribe((isEnabled) => {
                if ($scope.isDataSharingEntity && isEnabled) {
                    $dialog.confirmAction('Asset is a data sharing Asset. Changes are likely to be reverted by subsequent syncs.  Would you still like to proceed?')
                        .open()
                        .then((response) => {
                            if (response == 'yes') {
                                doAction('/portfolio/assets/action/delete', 'Deleting', 'It is Orion\'s best practice to not delete assets. If you proceed with this deletion, you will be responsible for providing this data should you need it to be recorded in Orion in the future or for auditing purposes. Are you sure you want to proceed?');
                            }
                        });
                }
                //else do legacy
                else {
                    doAction('/portfolio/assets/action/delete', 'Deleting', 'It is Orion\'s best practice to not delete assets. If you proceed with this deletion, you will be responsible for providing this data should you need it to be recorded in Orion in the future or for auditing purposes. Are you sure you want to proceed?');
                }
            });
       
    };

    $scope.goToLower = function (urlLevel) {
        $portfolio.goTo(urlLevel, entities.asset.value, $scope.selectedIds[0]);
    };

    $scope.removeHistorical = function () {
        doAction('/Portfolio/Assets/Action/RemoveHistorical', 'Remove Hist', "Are you sure you want to remove the '_Hist'?");
    };

    $scope.goToHigher = function (urlLevel) {
        if (urlLevel == 'households' && $scope.current.selectedHouseholdId > 0) {
            $portfolio.goTo(urlLevel, entities.client.value, $scope.current.selectedHouseholdId);
        } else if (urlLevel == 'registrations' && $scope.current.selectedRegistrationId > 0) {
            $portfolio.goTo(urlLevel, entities.registration.value, $scope.current.selectedRegistrationId);
        } else if (urlLevel == 'accounts' && $scope.current.selectedRegistrationId > 0) {
            $portfolio.goTo(urlLevel, entities.account.value, $scope.current.selectedAccountId);
        }
    };
    
    $scope.goToOrionStoredCostBasisStatus = function() {
        $location.url('/portfolio/orionstoredcostbasis/manualcalculations');
    };

    $scope.goToPortfolioGroups = function(){
        if ($routeParams.entityId && $routeParams.entity === entities.portfolioGroup.value){
            $portfolio.goTo('portfoliogroups', entities.portfolioGroup.value, $routeParams.entityId);
        } else {
            $portfolio.goTo('portfoliogroups', entities.asset.value, $scope.selectedIds[0]);
        }
    };   

    $scope.slickGridDoubleClick = function () {
        if ($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    };

    function setQuickFiltersFromSession() {
        if ($scope.current.selectedHouseholdId && $scope.current.setQuickFilters) {
            const key = $scope.user.authorization.alClientId + '_' + $scope.current.selectedHouseholdId + '_' + pageEntityType;
            const portfolioFiltersJson = sessionStorage.getItem('porfolio_grid_filters');
            let portfolioFilters = {};
            if (portfolioFiltersJson) {
                portfolioFilters = JSON.parse(portfolioFiltersJson);
                if (key in portfolioFilters) {
                    $scope.current.setQuickFilters(JSON.parse(portfolioFilters[key]))
                }
            }
        } else {
            sessionStorage.setItem('porfolio_grid_filters', "{}");
        }
    }

    function getCurrentEntityInfo() {
        if ($routeParams.entityId && $routeParams.entity) {
            let url = null;
            switch ($routeParams.entity) {
                case entities.client.value:
                    url = '/Portfolio/Clients/';
                    break;
                case entities.registration.value:
                    url = '/Portfolio/Registrations/';
                    break;
                case entities.portfolioGroup.value:
                    url = '/Portfolio/PortfolioGroups/';
                    break;
                case entities.account.value:
                    url = '/Portfolio/Accounts/';
                    break;
                case entities.asset.value:
                    url = '/Portfolio/Assets/';
                    break;
                case entities.transaction.value:
                    url = '/Portfolio/Transactions/';
                    break;
                case entities.product.value:
                    url = '/Portfolio/Products/Verbose/';
                    break;
            }

            if (url !== null) {
                return $http.get(url + $routeParams.entityId, {
                    cache: true,
                    trackerMsg: 'Loading entity info',
                });
            }
        }

        return Promise.reject('The entity specified is invalid.');
    }

    //EVENT LISTENERS
    $scope.$on("event:portfoliolist-asset-select", function (e, args) {
        if (args.length === 0) return;
        setOnRowSelect(args);
    });
    $scope.$on("event:portfoliolist-asset-edit", function (e, args) {
        if (!args.item) return;
        if (!args.item.isDataSharingEntity) return;
        var isDifferentRow = false;
        var isDifferentCell = false;
        if (lastRow != args.row) {
            isDifferentRow = true;
            lastRow = args.row;
        }
        if (lastCell != args.cell) {
            isDifferentCell = true;
            lastCell = args.cell;
        }

        if ($scope.isDataSharingWarningEnabled && (isDifferentRow || isDifferentCell)) {
            $dialog.messageBox("Asset is a data sharing asset. Changes are likely to be reverted by subsequent syncs.")
                .open().then(() => {
                    args.grid.gotoCell(args.row, args.cell, true);
                }
                );
        }
    });

    $scope.$on('slickgrid-data-loaded', function (event, data) {
        let selected = data.filter(function (item) {
            return $scope.selectedIds.some(function (id) {
                return item.id === id;
            })
        });
        selected = selected.length > 0 ? selected : data;

        if (selected.length > 0) {
            setOnRowSelect(selected);
            if ($routeParams.entityId && selected.length === 1) {
                $scope.$broadcast('event:portfoliolist-asset-action', {action: 'select-items', items: selected.slice(0, 1)});
            }
        }
        setQuickFiltersFromSession();
    });

    $scope.$on('event:slickgrid-columnfilter-change', function (e, args) {
        if ($scope.current.selectedHouseholdId) {
            const newValJson = JSON.stringify(args);
            const key = $scope.user.authorization.alClientId + '_' + $scope.current.selectedHouseholdId + '_' + pageEntityType;
            const portfolioFiltersJson = sessionStorage.getItem('porfolio_grid_filters');
            let portfolioFilters = {};
            if (portfolioFiltersJson) {
                portfolioFilters = JSON.parse(portfolioFiltersJson);
                if (!(key in portfolioFilters)) {
                    // make sure no other entries exist at the same time
                    portfolioFilters = {};
                }
            }
            portfolioFilters[key] = newValJson;
            sessionStorage.setItem('porfolio_grid_filters', JSON.stringify(portfolioFilters));
        }
    });


    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    
    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        gridQueries: [],
        url: '',
        gridParameters: '',
        showCostBasis: false,
        asOfDate: Date.create('today'),
        detailInfo: '',
        selectedHouseholdId: 0,
        selectedRegistrationId: 0,
        selectedAccountId: 0,
        hotKeyActions: [{
            combo: 'ALT+E', command: function () {
                $scope.openEditor(false);
            }
        }],
        entity: null
    };

    init();
});


app.controller('AssetLevelStrategyAssignmentCtrl', function AssetLevelStrategyAssignmentCtrl($scope, $http, $oasRights, $filter, $dialog, dialog) {
    //PRIVATE VARIABLES
    const orderBy = $filter('orderBy');


    //PRIVATE METHODS
    function init() {
        $http.get('/Portfolio/AssetLevelStrategies', {trackerMsg: 'Loading asset level strategies'})
            .then(function (response) {
                $scope.assetLevelStrategies = response.data;
                $scope.order('name', false);
            });

        $http.get('/Portfolio/Platforms/Simple', {cache: true, trackerMsg: 'Loading management styles'})
            .then(function (response) {
                $scope.managementStyles = response.data;
            });

        $http.get('/Portfolio/ProductClasses/Simple', {cache: true, trackerMsg: 'Loading asset classes'})
            .then(function (response) {
                $scope.assetClasses = response.data;
            });
    }


    //PUBLIC METHODS
    $scope.close = function () {
        dialog.close(null);
    };

    $scope.removeAssignment = function (d, item) {
        d.assignmentDefinitions.remove(item);
    };

    $scope.order = function (predicate, reverse) {
        $scope.assetLevelStrategies = orderBy($scope.assetLevelStrategies, predicate, reverse);
    };

    $scope.saveAssetLevelStrategies = function () {
        $http.put('/Portfolio/AssetLevelStrategies', $scope.assetLevelStrategies, {trackerMsg: "Saving asset level strategy"})
            .then(function () {
                dialog.close(null);
            });
    };

    $scope.assetStrategyLevelAssign = function () {
        const definition =
            {
                assetClassId: $scope.current.assetClass ? $scope.current.assetClass.id : null,
                assetClass: $scope.current.assetClass ? $scope.current.assetClass.name : null,
                managementStyleId: $scope.current.managementStyle ? $scope.current.managementStyle.id : null,
                managementStyle: $scope.current.managementStyle ? $scope.current.managementStyle.name : null
            };

        if ($scope.current.assetStrategyLevel.assignmentDefinitions.none(definition)) {
            $scope.current.assetStrategyLevel.assignmentDefinitions.push(definition);
        }

        $scope.current.assetStrategyLevel = null;
        $scope.current.managementStyle = null;
        $scope.current.assetClass = null;
    };


    //INITIALIZE
    $scope.current = {
        managementStyle: null,
        assetClass: null,
        assetStrategyLevel: null,
        rightsManuallyManaged : {
            canUpdate: false,
            canDelete: false,
            canRead: false,
            canAdd: false,
        }
    };

    $scope.reverse = false;
    $scope.rightsIsStrategyOverride = $oasRights.forCode("ASSLEVELSTRATASSIGN");

    init();
});

'use strict';

app.controller('AssetHistoricalListCtrl', function AssetHistoricalListCtrl($scope, $http, $oasRights, $dialog, views) {

    // PRIVATE METHODS
    function init( ) {
        $scope.rightsHistoricalAst = $oasRights.forCode("HISTORICALASSETS");
    }


    // PUBLIC METHODS
    $scope.removeHistorical = function( ) {
        $dialog.confirmAction("Are you sure you want to remove the '_Hist'?" )
            .open()
            .then(function(result){
                if (result === 'yes') {
                    $http.put('/Portfolio/Assets/Action/RemoveHistorical', $scope.selectedIds, {trackerMsg: 'Removing _Hist' })
                        .then(function () {
                            $scope.$broadcast('event:portfoliolist-asset-historical-action', {action: 'refresh-grid'});
                        });
                }
            });
    };


    // INITIALIZE
    $scope.views = views;

    $scope.selectedIds = [];
    $scope.current = { view : views[0] };

    init( );
});
'use strict';

const transactionListCtrl = app.controller('TransactionListCtrl', function TransactionListCtrl($scope, $http, $oasRights, $location, $dialog, $routeParams, $portfolio, entities, views, apps, dates, userOptionService, splitIoService) {
    //PRIVATE VARIABLES
    let lastSelectedHouseholdId = 0;
    let isManuallyManaged;
    var lastCell = null;
    var lastRow = null;
    var isDataSharing = false;
    const pageEntityType = entities.transaction.value;

    // PRIVATE METHODS
    function init() {
        splitIoService.getBoolTreatment('recon_datasharing_editwarningmessages_7285').subscribe((isEnabled) => {
            $scope.isDataSharingWarningEnabled = isEnabled;
        });

        $scope.rightsHH = $oasRights.forCode('CLIENTS');
        $scope.rightsReg = $oasRights.forCode('REGISTRATIONS');
        $scope.rightsAcc = $oasRights.forCode('ACCOUNTS');
        $scope.rightsAst = $oasRights.forCode('ASSETS');
        $scope.rightsTrn = $oasRights.forCode('TRANSACTIONS');
        $scope.rightsManuallyManaged = $oasRights.forCode('MANUALLYMANAGED');
        $scope.rightsProducts = $oasRights.forCode('PRODUCTS');
        $scope.rightsDAZL = $oasRights.forCode('FLAGFORDAZL');
        $scope.rightsAdvisorNotes = $oasRights.forCode('TRANSACTIONNOTES');

        $scope.current.filterStartDate = Date.create($routeParams.startDate || dates.startDate);
        $scope.current.filterEndDate = Date.create($routeParams.endDate || dates.endDate);

        if ($routeParams.entity && $routeParams.entityId) {
            $scope.current.url = '/Portfolio/Transactions';
            $scope.current.entityQueryString = '&' + entities.find({ value: $routeParams.entity }) + 'Id=' + $routeParams.entityId;

            if ($routeParams.openEditor && $scope.rightsTrn.canRead) {
                $scope.selectedIds = [$routeParams.tranId || $routeParams.entityId];
                $scope.openEditor(false, $routeParams.tabCode);
            }

            if ($routeParams.entity === entities.transaction.value) {
                $scope.current.filterStartDate = null;
                $scope.current.filterEndDate = null;
            }

            if ($routeParams.entity === entities.portfolioGroup.value) {
                const Urls = $portfolio.getDataUrls($routeParams.entity, $routeParams.entityId, entities.transaction.value);
                $scope.current.url = Urls.urlForList;
            }

            $portfolio.getBreadcrumbDetail($routeParams.entity, $routeParams.entityId)
                .then(function (detail) {
                    $scope.current.breadcrumbDetail = detail;
                });

            getCurrentEntityInfo().then(function (response) {
                if (response.data) {
                    $scope.current.entity = response.data;

                    if ($routeParams.entity === entities.client.value) {
                        $scope.current.selectedHouseholdId = $scope.current.entity.id;
                    } else {
                        $scope.current.selectedHouseholdId = $scope.current.entity.clientId;
                    }

                    if ($scope.current.entity !== null) {
                        switch ($routeParams.entity) {
                            case entities.account.value:
                                setManuallyManageRights($routeParams.entityId, $scope.current.entity, null);
                                break;
                            case entities.asset.value:
                                if ($scope.current.entity.status === 2) {
                                    $scope.current.rightsManuallyManaged = $scope.rightsManuallyManaged;
                                    isManuallyManaged = true;
                                } else {
                                    setManuallyManageRights($scope.current.entity.accountId, null, $scope.current.entity);
                                }
                                break;
                            case entities.portfolioGroup:
                                $scope.current.detailInfo = $portfolio.getBreadcrumb($routeParams.entity, $scope.current.entity.name);
                                break;
                        }
                    }
                }
            });
        } else if ($routeParams.startDate && $routeParams.endDate) {
            $scope.current.url = '/Portfolio/Transactions';
            $scope.current.breadcrumbDetail = '(' + $scope.current.filterStartDate.formatted() + ' - ' + $scope.current.filterEndDate.formatted() + ')';
        } else if ($routeParams.pageQueryId) {
            $scope.current.url = '/Portfolio/Transactions';
            $portfolio.getPageQueryName($routeParams.pageQueryId)
                .then(function (queryName) {
                    $scope.current.breadcrumbDetail = '(' + queryName + ')';
                });
        } else {
            $scope.search();
        }
    }

    function setManuallyManageRights(accountId, account, asset) {
        // Check the Account for Status of Manually Managed(3) and Advisor Only(3)
        if (account !== null) {
            setManuallyManagedForAccount(account, asset);
        } else {
            $http.get('/Portfolio/Accounts/' + accountId, { trackerMsg: 'Getting account information' })
                .then(function (response) {
                    setManuallyManagedForAccount(response?.data, asset);
                });
        }
    }

    function setManuallyManagedForAccount(account, asset) {
        if (account?.isDataSharingEntity === true) {
            isDataSharing = true;
        }
        if (account.accountStatusId === 3 || account.accountStatusId === 8) {
            $scope.current.rightsManuallyManaged = $scope.rightsManuallyManaged;
            isManuallyManaged = true;
        } else {
            if ($routeParams.entity === '8' || !$scope.current.selectedAssetId) {
                return;
            }
            if (asset !== null) {
                setManuallyManagedForAsset(asset);
            } else {
                $http.get('/Portfolio/Assets/' + $scope.current.selectedAssetId, { trackerMsg: 'Getting asset information' })
                    .then(function (response) {
                        setManuallyManagedForAsset(response?.data);
                    });
            }
        }
    }

    function setManuallyManagedForAsset(asset) {
        if (asset.status === 2) {
            $scope.current.rightsManuallyManaged = $scope.rightsManuallyManaged;
            isManuallyManaged = true;
        } else {
            isManuallyManaged = false;
            $scope.current.rightsManuallyManaged = {
                canUpdate: false,
                canDelete: false,
                canRead: false,
                canAdd: false
            }
        }
    }

    function doAction(actionUrl, msgVerb, confirmMsg) {
        $dialog.confirmAction(confirmMsg)
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.put(actionUrl, $scope.selectedIds, { trackerMsg: msgVerb + ' transaction(s)' })
                        .then(function () {
                            $scope.$broadcast('event:portfoliolist-transaction-action', { action: 'refresh-grid' });
                        });
                }
            });
    }

    function setOnRowSelect(args) {
        $scope.current.selectedHouseholdId = args[0].clientId;
        $scope.current.selectedRegistrationId = args[0].registrationId;
        $scope.current.selectedAccountId = args[0].accountId;
        $scope.current.selectedAssetId = args[0].assetId;
        $scope.current.selectedProductId = args[0].productId;

        $scope.current.selectedTransaction = angular.copy(args[0]);

        if (lastSelectedHouseholdId !== $scope.current.selectedHouseholdId) {
            $http.get('/Portfolio/Clients/' + $scope.current.selectedHouseholdId + '/Assets', { trackerMsg: 'Loading household assets' })
                .then(function (r) {
                    $scope.current.householdAssetList = r.data;
                    renderSelectedAsset();
                });
        } else {
            renderSelectedAsset();
        }
        lastSelectedHouseholdId = angular.copy($scope.current.selectedHouseholdId);
        const transaction = args[0];
        const hasStatus = transaction.hasOwnProperty('accountStatusId') && transaction.hasOwnProperty('assetStatusId');

        !hasStatus || args.length !== 1 ? setManuallyManageRights($scope.current.selectedAccountId, $routeParams.entity === entities.account.value ? $scope.current.entity : null, $routeParams.entity === entities.asset.value ? $scope.current.entity : null) : handleManuallyTransaction(args[0]);
    }

    function handleManuallyTransaction(transaction) {
        if (!transaction)
            return;
        isManuallyManaged = isManuallyManagedTransaction(transaction);
        $scope.current.rightsManuallyManaged = isManuallyManaged ? $scope.rightsManuallyManaged : {
            canUpdate: false,
            canDelete: false,
            canRead: false,
            canAdd: false,
        }
    }

    function isManuallyManagedTransaction(transaction) {
        return transaction.assetStatusId === 2 || transaction.accountStatusId === 3 || transaction.accountStatusId === 8;
    }

    function renderSelectedAsset() {
        $scope.current.asset = null;
        $scope.current.dropdownHouseholdAssetList = null;

        if ($scope.current.householdAssetList) {
            if ($scope.current.householdAssetList.length > 100) {
                $scope.current.asset = Object.select($scope.current.householdAssetList.find({ id: $scope.current.selectedAssetId }), "id", "accountNumber", "registrationType", "name", "ticker");
            } else {
                const accountNumber = $scope.current.selectedTransaction.accountNumber;
                $scope.current.householdAssetList.forEach(item => item.rank = item.accountNumber === accountNumber ? 1 : 9);
                $scope.current.dropdownHouseholdAssetList = $scope.current.householdAssetList;
                //highlight rows in the asset dropdown with the currently selected account number
                $scope.assetDropdownHighlightModel.value = accountNumber;
            }
        }
    }

    // PUBLIC METHODS
    $scope.openEditor = function (isNew, defaultTabCodeOverride) {
        let extraInfo = null;

        if ($scope.selectedIds.length === 1 || isNew) {
            if (isNew) {
                extraInfo = { fkAsset: $scope.current.selectedAssetId, fkClient: $scope.current.selectedHouseholdId, isManuallyManaged: isManuallyManaged };
            }
            var defaultTabNameOverride = defaultTabCodeOverride ? 'Transaction' : null;
            $portfolio.openEditor(entities.transaction.value, isNew ? [] : $scope.selectedIds, defaultTabNameOverride, defaultTabCodeOverride || null, apps.portfolioLists.name, extraInfo).then(function (rslt) {
                if (rslt) {
                    if (rslt.reverseOffset === true) {
                        $scope.$broadcast('event:portfoliolist-transaction-action', { action: 'refresh-grid' });
                    } else {
                        $scope.$broadcast('event:portfoliolist-transaction-action', { action: rslt.isNew ? 'add-item' : 'update-item', item: rslt });
                    }
                }
            });
        } else {
            extraInfo = { isManuallyManaged: isManuallyManaged };
            $portfolio.openMassEditor(entities.transaction.value, $scope.selectedIds, apps.portfolioLists.name, extraInfo).then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast('event:portfoliolist-transaction-action', { action: 'update-items', items: rslt });
                }
            });
        }
    };

    $scope.flagForDazl = function () {
        $dialog.confirmAction('Would you like to flag the selected transactions to be sent to DAZL?')
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.put('/Portfolio/Transactions/Action/DAZLOverride', $scope.selectedIds, { trackerMsg: 'Flagging for DAZL ' });
                }
            });
    };

    $scope.search = function () {
        const dateRange = {
            startDate: $scope.current.filterStartDate,
            endDate: $scope.current.filterEndDate,
            excludedEntities: [
                entities.transaction.value,
            ],
        };

        const validate = function (result) {
            if (result.item != null) {
                return;
            }
            var start = new Date(result.dateRange.startDate);
            var end = new Date(result.dateRange.endDate);

            if (!isValidDate(start, end)) {
                return `Cannot exceed 31 days when no entity is selected.`;
            }
        }
        $portfolio.customSearch($routeParams.entity || entities.account.value, [entities.client.value, entities.portfolioGroup.value, entities.registration.value, entities.account.value, entities.asset.value, entities.transaction.value], 'Find', dateRange, validate)
            .then(function (rslt) {
                if (rslt) {
                    $portfolio.goTo('transactions', rslt.entity, rslt.item ? rslt.item.id : '', rslt.dateRange);
                }
            });
    };

    $scope.goToProduct = function (productId) {
        $portfolio.goToProduct(productId);
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:portfoliolist-transaction-action', { action: 'export-data' });
    };

    $scope.deleteTransactions = function () {
        var verb = 'Deleting';
        var url = '/portfolio/transactions/action/delete';
        var msg = 'It is Orion\'s best practice to not delete transactions. If you proceed with this deletion, you will be responsible for providing this data should you need it to be recorded in Orion in the future or for auditing purposes. Are you sure you want to proceed?';

        splitIoService.getBoolTreatment("recon_datasharing_editwarningmessages_7285")
            .subscribe((isEnabled) => {
                if (isEnabled) {
                    $http.get('/Portfolio/Accounts/' + $scope.current.selectedAccountId, { trackerMsg: 'Getting account information' })
                        .then(function (response) {
                            if (response?.data?.isDataSharingEntity === true) {
                                $dialog.confirmAction('Account is a data sharing account. Transaction is likely to be reverted by subsequent syncs.  Would you still like to proceed?')
                                    .open()
                                    .then((response) => {
                                        if (response == 'yes') {
                                            doAction(url, verb, msg);
                                        }
                                    });
                            }
                            else {
                                doAction(url, verb, msg);
                            }
                        });
                }
                //else do legacy
                else {
                    doAction(url, verb, msg);
                }
            });
    };

    $scope.refreshGrid = function () {
        let isValid = true;
        isValid = isValidDate($scope.current.filterStartDate, $scope.current.filterEndDate);

        if (!isValid) {
            $scope.current.invalidDateMessage = "Cannot exceed 31 days when no entity is selected.";
            return;
        }
        $scope.current.invalidDateMessage = null;

        userOptionService.save('transaction_list_start_date', $scope.current.filterStartDate);

        $scope.$broadcast('event:portfoliolist-transaction-action', { action: 'refresh-grid' });
    };

    function isValidDate(startDate, endDate) {
        if ($routeParams.entityId?.length > 0) {
            return true;
        }
        const start = new Date(startDate);
        const end = new Date(endDate);
        const timeBetweenDates = Math.abs(start - end);

        const numberOfDate = timeBetweenDates / (24 * 60 * 60 * 1000) + 1; // hour min sec ms
        return numberOfDate <= 31;
    }

    $scope.goToHigher = function (urlLevel) {
        if (urlLevel === 'households' && $scope.current.selectedHouseholdId > 0) {
            $portfolio.goTo(urlLevel, entities.client.value, $scope.current.selectedHouseholdId);
        } else if (urlLevel === 'registrations' && $scope.current.selectedRegistrationId > 0) {
            $portfolio.goTo(urlLevel, entities.registration.value, $scope.current.selectedRegistrationId);
        } else if (urlLevel === 'accounts' && $scope.current.selectedRegistrationId > 0) {
            $portfolio.goTo(urlLevel, entities.account.value, $scope.current.selectedAccountId);
        } else if (urlLevel === 'assets' && $scope.current.selectedAssetId > 0) {
            $portfolio.goTo(urlLevel, entities.asset.value, $scope.current.selectedAssetId);
        }
    };

    $scope.goToPortfolioGroups = function () {
        if ($routeParams.entityId && $routeParams.entity === entities.portfolioGroup.value) {
            $portfolio.goTo('portfoliogroups', entities.portfolioGroup.value, $routeParams.entityId);
        } else {
            $portfolio.goTo('portfoliogroups', entities.transaction.value, $scope.selectedIds[0]);
        }
    };

    $scope.slickGridDoubleClick = function () {
        if ($scope.selectedIds.length === 1) {
            $scope.openEditor(false);
        }
    };

    $scope.saveSelectedTransaction = function () {
        if ($scope.current.selectedTransaction && isValidSelectedTransaction()) {
            splitIoService.getBoolTreatment("recon_datasharing_editwarningmessages_7285")
                .subscribe((isEnabled) => {
                    if (isEnabled) {
                        $http.get('/Portfolio/Accounts/' + $scope.current.selectedAccountId, { trackerMsg: 'Getting account information' })
                            .then(function (response) {
                                if (response?.data?.isDataSharingEntity === true) {
                                    $dialog.confirmAction('Account is a data sharing account. Transaction is likely to be reverted by subsequent syncs.  Would you still like to proceed?')
                                        .open()
                                        .then((response) => {
                                            if (response == 'yes') {
                                                saveBase();
                                            }
                                        });
                                }
                                else {
                                    saveBase();
                                }
                            });
                    }
                    //else do legacy
                    else {
                        saveBase();
                    }
                });
        }
    };

    function saveBase() {
        $http.put('/Portfolio/Transactions/' + $scope.current.selectedTransaction.id, $scope.current.selectedTransaction, { trackerMsg: 'Updating transaction ' + $scope.current.selectedTransaction.id })
            .then(function (r) {
                $scope.$broadcast('event:portfoliolist-transaction-action', { action: 'update-items', items: [r.data] });
            });
    }

    function isValidSelectedTransaction() {
        let isValid = true;

        if ($scope.current.selectedTransaction.navPrice < 0) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid share price!", "Share price must be positive.", [{ result: 'OK', label: 'OK', cssClass: 'btn-primary', focus: true }]).open();
            isValid = false;
        }

        return isValid;
    }

    $scope.recalculateAmount = function () {
        if ($scope.current.selectedTransaction.noUnits === 0 || $scope.current.selectedTransaction.navPrice === 0) {
            return;
        }
        $scope.current.selectedTransaction.transAmount = $scope.current.selectedTransaction.noUnits * $scope.current.selectedTransaction.navPrice;
    };

    $scope.recalculateUnits = function () {
        if ($scope.current.selectedTransaction.transAmount === 0 || $scope.current.selectedTransaction.navPrice === 0) {
            return;
        }
        $scope.current.selectedTransaction.noUnits = $scope.current.selectedTransaction.transAmount / $scope.current.selectedTransaction.navPrice;
    };

    $scope.recalculateUnitPrice = function () {
        if ($scope.current.selectedTransaction.transAmount === 0 || $scope.current.selectedTransaction.noUnits === 0) {
            return;
        }
        $scope.current.selectedTransaction.navPrice = $scope.current.selectedTransaction.transAmount / $scope.current.selectedTransaction.noUnits;
    };

    $scope.lookupPrice = function () {
        $http.get('/Portfolio/Assets/' + $scope.current.selectedTransaction.assetId + '/Price/' + Date.create($scope.current.selectedTransaction.transDate).format('{MM}-{dd}-{yyyy}'), {
            cache: true,
            trackerMsg: 'Loading price',
        })
            .then(function (r) {
                if (r.data) {
                    $scope.current.selectedTransaction.navPrice = r.data.last;
                }
            });
    };

    function setQuickFiltersFromSession() {
        if ($scope.current.selectedHouseholdId && $scope.current.setQuickFilters) {
            const key = $scope.user.authorization.alClientId + '_' + $scope.current.selectedHouseholdId + '_' + pageEntityType;
            const portfolioFiltersJson = sessionStorage.getItem('porfolio_grid_filters');
            let portfolioFilters = {};
            if (portfolioFiltersJson) {
                portfolioFilters = JSON.parse(portfolioFiltersJson);
                if (key in portfolioFilters) {
                    $scope.current.setQuickFilters(JSON.parse(portfolioFilters[key]))
                }
            }
        } else {
            sessionStorage.setItem('porfolio_grid_filters', "{}");
        }
    }

    function getCurrentEntityInfo() {
        if ($routeParams.entityId && $routeParams.entity) {
            let url = null;
            switch ($routeParams.entity) {
                case entities.client.value:
                    url = '/Portfolio/Clients/';
                    break;
                case entities.registration.value:
                    url = '/Portfolio/Registrations/';
                    break;
                case entities.portfolioGroup.value:
                    url = '/Portfolio/PortfolioGroups/';
                    break;
                case entities.account.value:
                    url = '/Portfolio/Accounts/';
                    break;
                case entities.asset.value:
                    url = '/Portfolio/Assets/';
                    break;
                case entities.transaction.value:
                    url = '/Portfolio/Transactions/';
                    break;
            }

            if (url !== null) {
                return $http.get(url + $routeParams.entityId, {
                    cache: true,
                    trackerMsg: 'Loading entity info',
                });
            }
        }

        return Promise.reject('The entity specified is invalid.');
    }

    //EVENT LISTENERS
    $scope.$on('event:portfoliolist-transaction-select', function (e, args) {
        if (args.length === 0) {
            return;
        }
        setOnRowSelect(args);
    });
    $scope.$on("event:portfoliolist-transaction-edit", function (e, args) {
        if (!args.item) return;
        if (!isDataSharing) return;
        var isDifferentRow = false;
        var isDifferentCell = false;
        if (lastRow != args.row) {
            isDifferentRow = true;
            lastRow = args.row;
        }
        if (lastCell != args.cell) {
            isDifferentCell = true;
            lastCell = args.cell;
        }

        if ($scope.isDataSharingWarningEnabled && (isDifferentRow || isDifferentCell)) {
            $dialog.messageBox("Transaction is a data sharing transaction. Changes are likely to be reverted by subsequent syncs.")
                .open().then(() => {
                    args.grid.gotoCell(args.row, args.cell, true);
                }
                );
        }
    });

    $scope.$on('slickgrid-data-loaded', function (event, data) {
        if (data.length === 1) {
            setOnRowSelect(data);
            $scope.$broadcast('event:portfoliolist-transaction-action', { action: 'select-items', items: data.slice(0, 1) });
        } else if ($routeParams.entityId && data.length > 0) {
            setOnRowSelect(data);
        }
        setQuickFiltersFromSession();
    });

    $scope.$on('event:slickgrid-columnfilter-change', function (e, args) {
        if ($scope.current.selectedHouseholdId) {
            const newValJson = JSON.stringify(args);
            const key = $scope.user.authorization.alClientId + '_' + $scope.current.selectedHouseholdId + '_' + pageEntityType;
            const portfolioFiltersJson = sessionStorage.getItem('porfolio_grid_filters');
            let portfolioFilters = {};
            if (portfolioFiltersJson) {
                portfolioFilters = JSON.parse(portfolioFiltersJson);
                if (!(key in portfolioFilters)) {
                    // make sure no other entries exist at the same time
                    portfolioFilters = {};
                }
            }
            portfolioFilters[key] = newValJson;
            sessionStorage.setItem('porfolio_grid_filters', JSON.stringify(portfolioFilters));
        }
    });

    // INITIALIZE
    $scope.views = views;

    $scope.selectedIds = [];
    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        gridQueries: [],
        entityQueryString: '',
        pageQueryId: $routeParams.pageQueryId,
        selectedHouseholdId: 0,
        selectedRegistrationId: 0,
        selectedAccountId: 0,
        selectedAssetId: 0,
        selectedTransaction: null,
        householdAssetList: null,
        dropdownHouseholdAssetList: null,
        invalidDateMessage: null,
        rightsManuallyManaged: { canAdd: false, canDelete: false, canRead: false, canUpdate: false },
        entity: null
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function () {
            $scope.openEditor(false);
        },
    }];

    $scope.assetIdFieldMap = [{ name: 'Asset ID', value: 'id', sortable: true }, { name: 'Account', value: 'accountNumber', sortable: true }, { name: 'Reg Type', value: 'registrationType', sortable: true }, { name: 'Name', value: 'name', sortable: true }, { name: 'Ticker', value: 'ticker', sortable: true }];
    $scope.assetDropdownHighlightModel = { field: 'accountNumber', value: '', color: '#efefef' };

    init();
});

transactionListCtrl.loadTransactionListDates = ['userOptionService', '$q', function (userOptionService, $q) {
    return $q.all({
        startDate: userOptionService.get('transaction_list_start_date', 'last year'),
        endDate: Date.create('today'),
    });
}];
'use strict';

app.controller('BatchAddTransactionCtrl', function BatchAddTransactionCtrl( $scope, $http, $oasRights, $dialog ) {

    // PUBLIC METHODS
    $scope.processImport = function( ) {
        var postData = $scope.current.selectedItems.findAll( { isValid: true } );
        if( postData ) {
            $scope.current.allowProcess = false;
            $http.post('/Portfolio/Transactions/Verbose/New', postData, {trackerMsg: 'Processing transactions'})
                .then(function() {
                    $scope.current.allowProcess = true;
                    $dialog.messageBox("Import successful", "Transaction information saved.").open();
                });
        }
    };

    $scope.startTransactionImportOver = function( ) {
        $scope.current.allowProcess = false;
        $scope.current.selectedItems = null;
    };


    // WATCHES
    $scope.$watchCollection( "current.selectedItems", function( newValue, oldValue ) {
        if(newValue != oldValue && newValue != null ) {
            $scope.current.allowProcess = $scope.current.selectedItems.find( { isValid: true } );
        }
    });


    // INITIALIZE
    $scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");
    $scope.current = { selectedItems: [], allowProcess : true };

});




app.controller('SystematicCtrl', function SystematicCtrl($scope, $http, $oasRights, $dialog, systematicData, accountId, dialog, systematicTaxWithType) {
    //PRIVATE METHODS
    function init() {
        buildMenu();
        loadLookUps();
        $scope.setCycleMonths(false);
    }

    function buildMenu() {
        $scope.menu = [
            {name: 'With/Purch', children: [
                {name: 'Type', code: 'type'},
                {name: 'Fund Selection', code: 'fundSelection'},
                {name: 'Schedule', code: 'schedule'},
                {name: 'Tax Withholding (withdrawals only)', code: 'taxWithholding'},
                {name: 'Distribution Code', code: 'distCode'}
            ]},
            {name: 'Bank/RMD', children: [
                {name: 'Bank Information', code: 'bankInformation'},
                {name: 'RMD', code: 'rmd'}
            ]}
        ];
    }

    function loadLookUps() {
        $http.get('/Trading/DistributionCodes/Simple', {cache: true, trackerMsg: 'Loading distribution codes'})
            .then(function (response) {
                $scope.distributionCodes = response.data;
            });
    }

    function buildCycleMonths(max, name) {
        return (1).upto(max).map(function (value) {
            return {id: value, name: "Month " + value + " of " + name};
        });
    }

    function isFullBeneficiarySsn(ssn) {
        if (!ssn || ssn.indexOf('X') !== -1) {
            return false;
        }

        var clean = ssn.replace(/-/g, '').replace(/ /g, '');
        return /^\d{9}$/.test(clean);
    }

    function isBeneficiarySsnCleared(ssn) {
        return !ssn || ssn.trim() === '';
    }

    function getSystematicId() {
        return systematicData.id || $scope.systematic.id || 0;
    }

    function resolveBeneficiarySsnReason(payload) {
        if ($scope.current.updateBeneficiarySSN && $scope.current.viewBeneficiarySSNReason) {
            return $scope.current.viewBeneficiarySSNReason;
        }

        if (!$scope.current.updateBeneficiarySSN && !$scope.isNewSystematic) {
            return null;
        }

        if (isFullBeneficiarySsn(payload.beneficiarySSN)) {
            return $scope.isNewSystematic ? 'adding new systematic' : 'adding systematic beneficiary SSN';
        }

        if (isBeneficiarySsnCleared(payload.beneficiarySSN)) {
            if ($scope.isNewSystematic) {
                return null;
            }

            return 'clearing systematic beneficiary SSN';
        }

        return null;
    }

    function putBeneficiarySsnAndClose(payload, ssn, reason) {
        $http.put(
            '/Portfolio/Accounts/' + accountId + '/Systematics/' + getSystematicId() + '/BeneficiarySSN',
            { ssN: ssn, reason: reason },
            { trackerMsg: 'Saving systematic beneficiary SSN' })
            .then(function (response) {
                payload.beneficiarySSN = response.data;
                payload.reason = null;
                payload.updateBeneficiarySSN = false;
                dialog.close(payload);
            });
    }


    //PUBLIC METHODS
    $scope.close = function (isCancel) {
        if (isCancel) {
            dialog.close(null);
            return;
        }

        var payload = $scope.systematic;
        var systematicId = getSystematicId();
        var reason = resolveBeneficiarySsnReason(payload);

        if (reason) {
            payload.reason = reason;
        }

        if (systematicId > 0 && $scope.current.updateBeneficiarySSN && reason) {
            payload.updateBeneficiarySSN = true;

            if (isBeneficiarySsnCleared(payload.beneficiarySSN)) {
                putBeneficiarySsnAndClose(payload, '', reason);
                return;
            }

            if (isFullBeneficiarySsn(payload.beneficiarySSN)) {
                putBeneficiarySsnAndClose(payload, payload.beneficiarySSN, reason);
                return;
            }
        }

        payload.updateBeneficiarySSN = $scope.current.updateBeneficiarySSN ||
            ($scope.isNewSystematic && isFullBeneficiarySsn(payload.beneficiarySSN));

        dialog.close(payload);
    };

    $scope.unlockBeneficiarySSNField = function (forEdit) {
        if (systematicData.id > 0 && (($scope.systematic.beneficiarySSN && $scope.systematic.beneficiarySSN.indexOf('X') !== -1) || forEdit)) {
            $dialog.inputBox('Reason to ' + (forEdit ? 'Edit' : 'View') + ' the Beneficiary SSN', 'Reason', 'textarea')
                .open()
                .then(function (rslt) {
                    if (rslt && rslt.trim().length > 0) {
                        var updateSSN = { ssN: null, reason: rslt };
                        $http.put('/Portfolio/Accounts/' + accountId + '/Systematics/' + systematicData.id + '/BeneficiarySSN', updateSSN, { trackerMsg: 'Getting Beneficiary SSN information' })
                            .then(function (response) {
                                $scope.systematic.beneficiarySSN = response.data;
                                $scope.current.viewBeneficiarySSNReason = rslt;

                                if (forEdit) {
                                    $scope.current.updateBeneficiarySSN = true;
                                }
                            });
                    }
                });
        }
    };

    $scope.loadTab = function (code) {
        $scope.current.selectedTab = code;
    };

    $scope.setCycleMonths = function (resetValue) {
        switch ($scope.systematic.frequency) {
            case "Monthly":
                $scope.cycleMonths = [{id:1, name: 'Every Month'}];
                break;
            case "Quarterly":
                $scope.cycleMonths = buildCycleMonths(3, 'Quarter');
                break;
            case "Semiannually":
                $scope.cycleMonths = buildCycleMonths(6, 'Semi-Annual Cycle');
                break;
            case "Annually":
                $scope.cycleMonths = buildCycleMonths(12, 'Year');
                break;
        }

        if (resetValue) {
            $scope.systematic.cycleMonth = $scope.cycleMonths[0].id;
        }
    };


    //INITIALIZE
    $scope.rightsSSNView = $oasRights.forCode('SSNVIEW');
    $scope.rightsSSNChange = $oasRights.forCode('SSNCHANGE');
    $scope.rightsSystematics = $oasRights.forCode('SYSTEMATICS');
    $scope.isNewSystematic = !systematicData.id;
    $scope.current = {
        selectedTab: 'type',
        systematicTaxWithholdingType: systematicTaxWithType,
        viewBeneficiarySSNReason: null,
        updateBeneficiarySSN: false
    };
    $scope.systematic = systematicData;
    $scope.autoRmdHelp = "This checkbox forces the account to be On Track for RMD";

    $scope.frequencies = ['Monthly', 'Quarterly', 'Semiannually', 'Annually'];

    $scope.lifeTypes = [{name: 'Single Life', id: 1}, {name: 'Joint Life', id: 2}];
    $scope.transferTypes = [{name: 'ACH', id: 1}, {name: 'Mail', id: 2}];
    $scope.sources = [{name: 'None', id: 0}, {name: 'Direct', id: 1}, {name: 'Custodial', id: 2}, {name: 'Custodial/Direct', id: 3}];
    $scope.dateEntryMethods = [{name: 'None', id: 0}, {name: 'AutoTrade', id: 1}, {name: 'Download', id: 2}, {name: 'HandEntry', id: 3}];

    if( !$scope.taxWithholdingTypes ) {
        $scope.taxWithholdingTypes = [];
        systematicTaxWithType.keys().forEach(function (key) {
            $scope.taxWithholdingTypes.push({id: parseInt(systematicTaxWithType[key].value), name: systematicTaxWithType[key].name});
        });
    }


    init();
});

app.controller('GeneralAccountCtrl', function GeneralAccountCtrl($scope, $http, $dialog, args, dialog, entities, $timeout ){

    function init(){
        $scope.current.netAdjAmount = 0;
        $scope.current.totalPerc = 0;

        $scope.generalAccts.forEach(function(acct){
            $scope.current.netAdjAmount += acct.amount;
        });

        setDefaults($scope.current.isNew, $scope.current.isSingle);
    }

    function setDefaults(isNew, isSingle){

        if ($scope.generalAccts && $scope.generalAccts.length > 0){
            $scope.current.adjustmentType = $scope.generalAccts[0].adjustmentType;
            $scope.current.isDebit = $scope.generalAccts[0].isDebit;
            $scope.current.notes = $scope.generalAccts[0].notes;
        }

        $scope.current.totalAppliedAdj = $scope.current.netAdjAmount.round(2);
        $scope.current.balRemaining = 0;

        $http.get('/Billing/Accounts/' + $scope.current.parentId + '/DefaultPercentsForGeneralAccount', {trackerMsg: 'Loading default for general accounts'})
            .then(function(response){
                var gaDefault = response.data;

                var payoutPerc = 0;
                var currBal = 0;

                gaDefault.forEach(function(item){
                    if (item.isPoints)
                        $scope.current.totalPerc  += item.point / 100;
                    else
                        $scope.current.totalPerc  += item.rate * 100;
                });

                // If Existing general account detail
                if ($scope.generalAccts && $scope.generalAccts.length > 0 && !isNew){

                    if ($scope.generalAccts.length === 1 && !$scope.current.isSingle){
                        $scope.generalAccts = [];
                        setMultipleEntitiesPercent(gaDefault);
                    } else if ($scope.generalAccts.length > 1 && $scope.current.isSingle){
                        setSingleEntityPercent();
                    } else {
                        $scope.generalAccts.forEach(function(ga){
                            payoutPerc = 0;
                            var billEntity = gaDefault.find({billEntityId: ga.billEntity});

                            if (billEntity) {
                                if (billEntity.isRemainder){
                                    payoutPerc = (100 - $scope.current.totalPerc );
                                    if (payoutPerc < 0) payoutPerc = 0;
                                } else {
                                    if (billEntity.isPoints)
                                        payoutPerc = billEntity.points / 100;
                                    else
                                        payoutPerc = billEntity.rate * 100;
                                }
                            }

                            currBal += ga.amount;

                            ga.percent = (ga.amount / $scope.current.netAdjAmount) * 100;
                            ga.payout = payoutPerc;
                        }); // Loops through generalAccountsDetail
                    }

                } else {
                    if (!isSingle) // Multiple Entities
                    {
                        setMultipleEntitiesPercent(gaDefault);
                    } else { // Single Entity
                        setSingleEntityPercent();
                    }
                }
                getTotal($scope.generalAccts);
            });
    }

    function setSingleEntityPercent(){
        $scope.current.totalPerc = 100;
        var amount = 0;

        if ($scope.generalAccts.length > 0){
            amount = $scope.generalAccts.sum(function(ga){return ga.amount;});
        }

        $scope.generalAccts = [
            {
                billEntity: 1,
                entity : parseInt(entities.account.value),
                parentId : $scope.current.parentId,
                dateOccured: Date.create('today').formatted(true),
                adjustmentType : 18,
                amount: amount,
                isDebit : false,
                percent : 100,
                payout : 100,
                netAdjAmount : 0,
                notes : '',
                isNew : true
            }];
    }

    function setMultipleEntitiesPercent(gaDefault){
        var perc = 0;
        var feeSchedule = $scope.current.feeSchedule;
        var totalPercent = 0;

        $scope.generalAccts = [];
        $scope.current.gaToEdit = [];

        if (feeSchedule.type === 'Flat'){
            feeSchedule.details[0].basisPoints = feeSchedule.details[0].rate * 10000;

            gaDefault.sortBy('isRemainder').forEach(function(item){
                if (item.type === 'Flat'){
                    if (item.isRemainder){
                        perc = (100 - totalPercent);
                        if (perc < 0) perc = 0;
                    } else {
                        if (item.isPoints){
                            var pointPer = item.point / feeSchedule.details[0].basisPoints;
                            if(isNaN(parseFloat(pointPer))) pointPer = 0;
                            if(!isFinite(pointPer)) pointPer = 0;

                            perc = pointPer  * 100;
                        }
                        else
                            perc = item.rate * 100;
                    }
                } else {
                    // If Linear/Tiered
                    if (item.isRemainder){
                        perc = (100 - totalPercent);
                        if (perc < 0) perc = 0;
                    } else {
                        if (item.isPoints){
                            if (item.currValue >= item.minAmt && item.currValue <= item.maxAmt){
                                perc = (item.point / feeSchedule.details[0].basisPoints) * 100;
                            }
                        }
                        else
                            perc = item.rate * 100;
                    }
                }

                perc = perc.round(2);

                totalPercent += perc;

                var tempObject = {
                    billEntity: item.billEntityId,
                    entity : parseInt(entities.account.value),
                    parentId : $scope.current.parentId,
                    dateOccured: Date.create('today').formatted(true),
                    adjustmentType : 18,
                    amount: ((perc / 100) * $scope.current.netAdjAmount).round(2),
                    isDebit : false,
                    percent : perc,
                    payout : perc,
                    netAdjAmount : $scope.current.netAdjAmount,
                    notes : '',
                    isNew : true
                };
                $scope.generalAccts.push(tempObject);

            });
        } else { // Fee Schedule is Tiered or Linear
            feeSchedule.details.forEach(function(detail){
                detail.basisPoints = detail.rate * 10000;
            });

            gaDefault.sortBy('isRemainder').forEach(function(item){
                    if (item.isRemainder){
                        perc = (100 - totalPercent);
                        if (perc < 0) perc = 0;
                    } else {
                        if (item.isPoints){
                            // Look up what what rate the hh value should be charge at
                            var result = feeSchedule.details.find(function(fsDtl){
                                return item.currValue >= fsDtl.minimumAmount && item.currValue <= fsDtl.maximumAmount;
                            });

                            if (result){
                                perc = (item.point / result.basisPoints) * 100;
                            } else {
                                perc = item.point / 100;
                            }

                        }
                        else
                            perc = item.rate * 100;
                    }
                perc = perc.round(2);

                totalPercent += perc;

                var tempObject = {
                    billEntity: item.billEntityId,
                    entity : parseInt(entities.account.value),
                    parentId : $scope.current.parentId,
                    dateOccured: Date.create('today').formatted(true),
                    adjustmentType : 18,
                    amount: ((perc / 100) * $scope.current.netAdjAmount).round(2),
                    isDebit : false,
                    percent : perc,
                    payout : perc,
                    netAdjAmount : $scope.current.netAdjAmount,
                    notes : '',
                    isNew : true
                };
                $scope.generalAccts.push(tempObject);

            });
        }
    }

    function getTotal(ga) {
        $scope.current.totalPerc = 0;
        $scope.current.totalAppliedAdj = null;

        var adjType = $scope.current.adjustmentType;

        for (var i = 0; i < ga.length; i++){
            $scope.current.totalPerc += ga[i].percent;
            if (isNaN(parseFloat(ga[i].amount))) ga[i].amount = 0;

            $scope.current.totalAppliedAdj += ga[i].amount;
            ga[i].currBalance = $scope.current.totalAppliedAdj;
            ga[i].adjustmentType = adjType;
        }

        $scope.current.totalAppliedAdj.round(2);
        $scope.current.totalPerc = $scope.current.totalPerc.round(0);
        $scope.current.balRemaining = $scope.current.netAdjAmount - $scope.current.totalAppliedAdj;


        // if applied amount greater then net adj amount then take it from the RIA
        if (Math.abs($scope.current.totalAppliedAdj) > Math.abs($scope.current.netAdjAmount) ){
            var diff = $scope.current.totalAppliedAdj - $scope.current.netAdjAmount;
            var ria = ga.find({billEntity: 7});

            if (ria) {
                ria.amount = (ria.amount - diff).round(2);

                $scope.current.totalAppliedAdj -= diff;
                $scope.current.balRemaining = $scope.current.netAdjAmount - $scope.current.totalAppliedAdj;
            }
        }



    }

    //PUBLIC
    $scope.close = function(isCancel) {
        if (isCancel)
            dialog.close(null);
        else{
            var errorMsg = $scope.validateAmount($scope.current.isDebit);

            if (errorMsg && errorMsg.length)
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Amount", errorMsg).open();
            else
                dialog.close($scope.generalAccts);
        }

    };

    $scope.adjustTotal = function(ga) {
        if (ga.length === 0)
            return;

        $timeout(function(){
            var net = 0;

            // get the new Total
            for (var i =0; i < ga.length; i++){
                net += ga[i].amount;
            }

            if ( net === 0 && $scope.current.netAdjAmount > 0 ){
                $scope.adjustPTC(ga);
                return;
            }

            if (net > 0){
                ga.netAdjAmount = net;
                $scope.current.netAdjAmount = net;
            }
            else
                return;

            // update the percentages
            var adj = 0;

            for (var i = 0; i < ga.length; i++){
                var value = (ga[i].amount / net) * 100;
                ga[i].percent = Math.abs(value.round(4));
                adj += ga[i].percent;
            }

            if (adj !== 100){
                var remainder = (100 - adj).round(2);

                if (Math.abs(remainder) <= 0.02){
                    ga[ga.length -1].percent = (ga[ga.length -1].percent + remainder).round(2);
                }
            }

            getTotal(ga);
        },500);
    };

    $scope.adjustPTC = function(ga){
        $scope.current.totalAppliedAdj = $scope.current.netAdjAmount;

        for (var i = 0; i < ga.length; i++){
            var pct = ga[i].percent / 100;
            var adjAmt = ($scope.current.netAdjAmount * pct.round(4)).round(3);

            $scope.current.totalAppliedAdj -= adjAmt;

            // fix rounding problems
            if (i === ga.length - 1){
                if ($scope.current.totalAppliedAdj >= -0.02 && $scope.current.totalAppliedAdj <= 0.02 && $scope.current.totalAppliedAdj != 0){
                    adjAmt += $scope.current.totalAppliedAdj;
                }
            }

            $scope.current.totalAppliedAdj = $scope.current.totalAppliedAdj.round(2);

            ga[i].amount = adjAmt.round(2);
        }

        getTotal(ga);
    };
    $scope.adjustBal = function(ga){
        var gaList = [];
        gaList.push(ga);

        getTotal(gaList);
    };

    $scope.getTotalAdj = function(){
        var totalAdj = 0;

        if ($scope.current.billing && $scope.current.billing.generalAccts){
            $scope.current.billing.generalAccts.forEach(function(ga){
                totalAdj += ga.amount;
            });
        }

        return totalAdj;
    };

    $scope.validateAmount = function(isDebit){
        $scope.generalAccts.forEach(function(ga){
            ga.isDebit = $scope.current.isDebit;
            ga.adjustmentType = $scope.current.adjustmentType;
            ga.notes = $scope.current.notes;
        });

        if (isDebit)
        {
            if ($scope.generalAccts.any(function(ga){ return ga.amount > 0})){
                return 'Amount must be negative for a debit adjustment.';
            } else {
                return '';
            }
        } else {
            if ($scope.generalAccts.any(function(ga){ return ga.amount < 0})){
                return 'Amount must be positive for a credit adjustment.';
            } else {
                return '';
            }
        }
    };

    $scope.getBillEntities = function (isSingle, billEntities) {
        if (!isSingle) {
            return billEntities;
        }

        return billEntities.filter((be) => be.id !== 0);
    };

    //INITIALIZE
    $scope.generalAccts = args.isNew && args.gas.length === 0 ? [] : angular.copy(args.gas);

    $scope.current = {
        adjustmentTypes : args.adjTypes,
        billingEntities: $scope.getBillEntities(args.isSingle, args.billingEntities),
        netAdjAmount : 0,
        adjustmentType :18,
        isDebit : false,
        totalPerc : 0,
        totalAppliedAdj : 0,
        balRemaining: 0,
        isSingle : args.isSingle,
        isNew : args.isNew,
        parentId : args.parentId,
        feeSchedule : args.feeSchedule
    };

    init();
});

'use strict';

app.controller('AuditHistoryCtrl', function AuditHistoryCtrl($scope, $http, $oasRights, $routeParams, views) {
    // PRIVATE VARIABLES
    const accountID = $routeParams.entityId;


    // PRIVATE METHODS
    function init() {
        $scope.rightsAccount = $oasRights.forCode('ACCOUNTCHANGE');
        loadAccount();
    }

    function loadAccount() {
        $http.get('/Portfolio/Accounts/' + accountID, {trackerMsg: 'Loading account'})
            .then(function(response) {
                $scope.account = response.data;
            });
    }

    function loadAccountHistory() {
        return $http.get('/Portfolio/Accounts/' + accountID + '/Audits', {trackerMsg: 'Loading account history'})
            .then(function(response) {
                return setGridKeys(response.data);
            });
    }

    function setGridKeys(data) {
        return data.map((item, index) => {
            return Object.defineProperty(item, 'gridKey', {value: index + 1});
        });
    }


    // PUBLIC METHODS
    $scope.exportToExcel = function() {
        $scope.$broadcast('event:auditHistory-action', { action: 'export-data' });
    };


    // INITIALIZE
    $scope.views = views;

    $scope.selectedIds = [];

    $scope.current = {
        view: views[0],
        grid: {
            get load() {
                return loadAccountHistory;
            },
            param: {},
        },
    };

    init();
});




'use strict';

var platformCtrl = app.controller('PlatformCtrl', function PlatformCtrl($scope, $http, $location, $dialog, $oasRights, $routeParams, $cacheFactory, API_CONFIG) {
    // PRIVATE VARIABLES
    var platformId = $routeParams.id;


    // PRIVATE METHODS
    function loadPlatform( ) {
        $http.get('/Portfolio/PlatformTypes/', {trackerMsg: 'Loading management style types'})
            .then(function (response) {
                $scope.platformTypes = response.data;
                $scope.platformTypes.push( { id: null, type:'(none)'});
            });

        if( platformId > 0 ) {
            $http.get('/Portfolio/Platforms/' + platformId, {trackerMsg: 'Loading management style ' + platformId})
                .then(function (response) {
                    $scope.platform = response.data;

                    if( $scope.platform.modelAggId){
                        $scope.current.aggregateModel = {id: $scope.platform.modelAggId, name:$scope.platform.modelAggName};
                    }

                });
            $http.get("/Settings/EntityOptions/Database/0/code/69USEAUTOA", {trackerMsg: 'Loading billing auto assign schedules'})
                .then(function (response) {
                    $scope.current.useAutoAssignSchedules = response.data.value === "True" ? true : false;

                    if ($scope.current.useAutoAssignSchedules){
                        $http.get('/Billing/Schedules/CLS/Platform/' + platformId + '/BillSchedule', {trackerMsg: 'Loading cls auto schedule setup'})
                            .then(function(res){
                                $scope.platformSchedule = res.data;
                            });
                    }
                });
        }
        else {
            $scope.platform = {
                "id": 0,
                "name": null,
                "isActive": true,
                "abbreviation": null,
                "description": null,
                "rankOrder": null,
                "isDefault": false,
                "ipsId": null,
                "color": "#ffffff",
                "platformTypeId": null,
                "objective": null
            }
        }


    }


    // PUBLIC METHODS
    $scope.savePlatform = function( form ) {
        if (!form.$valid) return;

        if ($scope.platformSchedule){
            var args = $scope.platformSchedule.id > 0 ?
            {method: "PUT" , url: '/Billing/Schedules/CLS/Platform/' + platformId + '/BillSchedule/', trackerMsg: "Saving management style schedule details"} :
            {method: "POST", url: '/Billing/Schedules/CLS/Platform/BillSchedule/', trackerMsg: "Adding new management style schedule details"};

            if ($scope.current.useAutoAssignSchedules){
                $http({method: args.method, url: args.url, data: $scope.platformSchedule, trackerMsg: args.trackerMsg})
                    .then(function(res){
                        $location.path( '/portfolio/managementstyles' );
                    });
            }
        }
        
        $scope.platform.modelAggId = $scope.current.aggregateModel ? $scope.current.aggregateModel.id : null;

        var args = platformId > 0 ? {method: "PUT", id: platformId, trackerMsg: "Saving management style " + platformId} : {method: "POST", id: "", trackerMsg: "Adding new management style"};

        $http( { method: args.method, url: '/Portfolio/Platforms/' + args.id, data: $scope.platform, trackerMsg: args.trackerMsg } )
            .then(function() {
                var cache = $cacheFactory.get('$http');
                cache.remove(API_CONFIG.baseUrl + '/Portfolio/Platforms/Simple');

                $location.path( '/portfolio/managementstyles' );
            });
    };

    $scope.deletePlatform = function( ) {
        $http.delete('/portfolio/platforms/' +  platformId, {trackerMsg: 'Deleting management style ' + platformId})
            .then(function () {
                if ($scope.current.useAutoAssignSchedules) {
                    $http.delete('/Billing/Schedules/' + platformId, {trackerMsg: 'Delete management style schedule details'});
                }

                $location.path( '/portfolio/managementstyles' );
            });
    };

    $scope.addNewTier = function(){
        $scope.platformSchedule.details.push({cMinAmount: 0, cMaxAmount: 0, cls: 0, rep: 0, total: 0});
    };

    $scope.current = {
        aggregateModel: null,
        useAutoAssignSchedules: false
    };
    
    // INIT
    $scope.rightsPlatform = $oasRights.forCode('MGMTSTYLES');

    loadPlatform( );
});


platformCtrl.getPlatformListConfig = function() {
    return {
        getUrl: '/Portfolio/Platforms',
        deleteUrl: '/Portfolio/Platforms/',
        listName: 'Management Styles',
        template: 'portfolio/views/platform-list-item.html',
        icon: 'fa fa-book',
        selectEnabled: false,
        multiSelectEnabled: false,
        nameProperty: 'name',
        sortFields: {name: "Name", id: "ID", rankOrder: "Rank"},
        listFilter: ['fullName', 'name', 'abbreviation'],
        securityCode: 'MGMTSTYLES',
        additionalLinks: [{name: "New Management Style", url: "#/portfolio/managementstyles/0", icon: "fa fa-pencil", securityCode: "MGMTSTYLES"}]
    };
};
'use strict';

app.controller('AssetLevelStrategyListCtrl', function AssetLevelStrategyListCtrl($scope, $http, $dialog, $oasRights) {
    // PRIVATE METHODS
    function init() {
        $http.get('/Portfolio/AssetLevelStrategies', {trackerMsg: 'Loading strategies'})
            .then(function (response) {
                $scope.strategies = response.data;
            });
    }


    // PUBLIC METHODS
    $scope.addStrategy = function () {
        var newStrategy = {color: "#000000", sortOrder: $scope.strategies.length ? $scope.strategies.max('sortOrder').sortOrder + 1 : 1};

        $dialog.dialog({templateUrl: "asset-level-strategy-edit.html", controller: "AssetLevelStrategyEditCtrl", strategy: newStrategy})
            .open()
            .then(function (result) {
                if (result) {
                    $scope.strategies.push(result);
                }
            });
    };

    $scope.editStrategy = function (strategy) {
        $dialog.dialog({templateUrl: "asset-level-strategy-edit.html", controller: "AssetLevelStrategyEditCtrl", strategy: strategy})
            .open()
            .then(function (result) {
                if (result) {
                    angular.extend(strategy, result);
                }
            });
    };

    $scope.deleteStrategy = function (strategy) {
        $dialog.confirmAction("Are you sure you want to remove <b>" + strategy.name + "</b>?")
            .open()
            .then(function (result) {
                if (result == 'yes') {
                    $http.delete('/Portfolio/AssetLevelStrategies/' + strategy.id, {trackerMsg: 'Deleting ' + strategy.name})
                        .then(function () {
                            $scope.strategies.remove(strategy);
                        });
                }
            });
    };

    
    // INITIALIZE
    $scope.rightsAssets = $oasRights.forCode('ASSETS');
    init();
});

app.controller('AssetLevelStrategyEditCtrl', function AssetLevelStrategyEditCtrl($scope, $http, dialog) {
    //PUBLIC METHODS
    $scope.save = function () {
        var save = $scope.strategy.id ? {verb: 'put', msg: 'Saving', suffix: $scope.strategy.id} : {verb: 'post', msg: 'Adding', suffix: ''};

        $http[save.verb]('/Portfolio/AssetLevelStrategies/' + save.suffix, $scope.strategy, {trackerMsg: save.msg + ' strategy'})
            .then(function (response) {
                dialog.close(response.data);
            });
    };

    $scope.cancel = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.strategy = angular.copy(dialog.options.strategy);
});
'use strict';

app.controller('CustodianListCtrl', function CustodianListCtrl($scope, $http, $location, $dialog, $oasRights) {

    // PRIVATE METHODS
    function init( ) {
        $http.get('/Portfolio/Custodians', {trackerMsg: 'Loading custodians'})
            .then(function(response) {
                $scope.custodians = response.data;
            });
    }


    // PUBLIC METHODS
    $scope.deleteCustodian = function(c) {
        $dialog.confirmAction( "Are you sure you want to remove custodian <b>" + c.name + "</b>?" )
            .open()
            .then( function( result ) {
                if( result == 'yes' ) {
                    $http.delete('/Portfolio/Custodians/Verbose/' + c.id, {trackerMsg: 'Deleting custodian ' + c.name})
                        .then(function () {
                            $scope.custodians.remove({id: c.id});
                        }
                    );
                }
            } );
    };

    // INITIALIZE
    $scope.rightsCustodian = $oasRights.forCode('CUSTODIAN');
    $scope.custodians = [];

    init( );

});
'use strict';

app.controller('CustodianCtrl', function CustodianCtrl($scope, $http, $location, $dialog, $oasRights, $routeParams, $portfolio, sweepLevel, feeRequestSource, directTrading, uploadFormatTypes, $cacheFactory, API_CONFIG, splitIoService) {

    // PRIVATE VARIABLES
    var custodianId = $routeParams.id;

    // PRIVATE METHODS
    function loadEnumLookUps() {
        var list = {
            sweepLevels: sweepLevel,
            feeRequestSources: feeRequestSource,
            directTradingOptions: directTrading
        };

        Object.each(list, function (key, value) {
            $scope[key] = $portfolio.enumToSimpleList(value);
        });
    }

    function loadProductTypes() {
        $http.get('/Portfolio/ProductTypes/Simple', {trackerMsg:'Loading product types'})
            .then(function(response){
                $scope.productTypes = response.data.exclude(function(u){return u['name'] == 'None' || u['name'] == 'CD' || u['name'] == 'Index' || u['name'] == 'Unknown';})
            })
    }

    function loadCommunitiesDirectTrading() {

        $http.get("/Settings/Database/EntityOptions/Code/69FFSMAModel", {cache: true, ignoreExceptions: true})
        .then(function(response) {
            $scope.current.featureFlagSMAModel = response.data.value.toLowerCase() === "true";
        });

        $http.get('/Integrations/Communities/Custodians/List', {trackerMsg:'Loading Communities Direct Trading'})
            .then(function(response){
                $scope.communitiesCustodians = ['None'].concat(response.data);
                if(!$scope.custodian.portfolio.communitiesDirectTrading || $scope.communitiesCustodians.indexOf($scope.custodian.portfolio.communitiesDirectTrading) < 0) {
                    $scope.custodian.portfolio.communitiesDirectTrading = 'None';
                }
        })
    }

    function loadCustodian( ) {
        if( custodianId > 0 ) {
            $http.get('/Portfolio/Custodians/Verbose/' + custodianId + '?expand=fixTradingSettings&expand=portfolio&expand=algorithms', {trackerMsg: 'Loading custodian ' + custodianId})
                .then(function (response) {
                    $scope.custodian = response.data;

                    loadFeatureFlags();

                    if(!$scope.custodian.portfolio.shareTradeThreshold){
                        $scope.custodian.portfolio.shareTradeThreshold = 95.00;
                    }

                    loadCommunitiesDirectTrading();
                    loadAllCustodians();

                    if($scope.custodian.fixTradingSettings){
                        var item =  $scope.custodian.fixTradingSettings.find({productType: 'Stock/ETF'});
                        item.blockMethod = !item.fixVersion && !item.fixRouting ?  'FixEft': item.blockMethod;
                        $scope.disableAlgoForEditing();
                    }

                    if($scope.custodian.algorithms && $scope.custodian.algorithms.length === 0){
                        $scope.algoCodeMapping.each(function (item) {
                            item.custodianId = custodianId
                        });
                        $scope.custodian.algorithms = $scope.algoCodeMapping;
                    }
                });
            $http.get('/Settings/EntityOptions/Custodians/' + custodianId, {trackerMsg: 'Loading custodian options'})
                .then(function (response) {
                    $portfolio.cleanCustomFields(response.data);
                    $scope.entityOptions = response.data;
                });

            $http.get('/Portfolio/TRInterfaceFormats/Simple', {trackerMsg: 'Loading TRInterface Formats'})
                .then(function (response) {
                    $scope.trInterfaceFormats = response.data;
                });
        }
        else {
            $http.get('/Portfolio/Custodians/Verbose/New', {trackerMsg: 'Loading custodian'})
                .then(function (response) {
                    $scope.custodian = response.data;
                    loadCommunitiesDirectTrading();
                    loadAllCustodians();
                    loadFeatureFlags();
                });
        }
    }

    function loadGlobalCustodians() {
        $http.get('/Portfolio/Custodians/global', { trackerMsg: 'Loading global custodians' })
            .then((response) =>
            {
                $scope.globalCustodians = response.data;
            });
    }

    function loadAllCustodians() {
        $http.get('/Global/Custodians/Simple', { trackerMsg: 'Loading common custodians' })
            .then(function (response) {
                $scope.availableCustodians = response.data;
                $scope.availableCustodiansLoaded = true;
                if ($scope.custodian && $scope.custodian.portfolio.custodianCommonIdList)
                {
                    var ids = $scope.custodian.portfolio.custodianCommonIdList.split(',').map(id => parseInt(id.trim()));

                    $scope.selectedPriceHeirarchyCustodians = ids.map(id => $scope.availableCustodians.find(o => o.id == id));
                }
            });
    }

    $scope.disableAlgoForEditing = function() {
        var item = $scope.custodian.fixTradingSettings.find({productType: 'Stock/ETF'});
        return (!($scope.rightsCustodian.canUpdate && (item.fixVersion && item.fixVersion.toLowerCase() === 'fix.4.4')));
    };

    $scope.checkForCustodianGlobal = checkCustodianGlobalId;

    function loadUploadTargets( ) {
        $http.get('/Trading/UploadTargets/Simple?formatType=' + uploadFormatTypes.fixAllocation.value, {trackerMsg: 'Loading upload targets'})
            .then(function (response) {
                $scope.uploadTargets = response.data;
            });
    }

    function loadFeatureFlags() {
        splitIoService.getBoolTreatment('recon_firmprofile_custodianglobalrequired_7597')
        .subscribe((isEnabled) => {
            $scope.enableRequiringGlobalCustodian = isEnabled;
            checkCustodianGlobalId();
        });
    }

    function checkCustodianGlobalId() {
        if ($scope.custodian.portfolio.custodianGlobalId == null && ($scope.enableRequiringGlobalCustodian || custodianId == 0)) {
            $scope.errors = [{ type: 'error', msg: 'Global Custodian is required', showAllowClose: false }]
            $scope.preventSave = true;
        } else {
            $scope.errors = [];
            $scope.preventSave = false;
        }
    }

    // PUBLIC METHODS
    $scope.invalidEmail = function (invalid) {
        $scope.custodian.portfolio.invalidEmail = invalid;
    }

    $scope.setEmail = function (value) {
        $scope.custodian.portfolio.email = value;
    }

    $scope.saveCustodian = function( form ) {
        if (!form.$valid) return;

        if ($scope.custodian.portfolio.invalidEmail) return;

        var verboseCustodian = {};
        verboseCustodian["id"] = custodianId;

        // update price hierarchy if user has correct rights and verify custodian list was loaded and has results
        if ($scope.rightCustodianPriceHierarchy.canUpdate && $scope.availableCustodiansLoaded)
        {
            $scope.custodian.portfolio.custodianCommonIdList = $scope.selectedPriceHeirarchyCustodians.map(o => o.id).join(',');
        }

        verboseCustodian["portfolio"] = $scope.custodian.portfolio;

        if( custodianId > 0 && $scope.custodian.fixTradingSettings) {
            $scope.custodian.fixTradingSettings.forEach(function(item){
                item.custodianId = custodianId;
            });
            verboseCustodian["fixTradingSettings"] = $scope.custodian.fixTradingSettings;
        }

        if( custodianId > 0 && $scope.entityOptions ) {
            verboseCustodian["entityOptions"] = $portfolio.restoreEntityOptions($scope.entityOptions);
        }

        if(custodianId > 0 && $scope.custodian.algorithms){
            verboseCustodian["algorithms"] = $scope.custodian.algorithms;
        }

        if($scope.custodian.portfolio.communitiesDirectTrading && $scope.custodian.portfolio.communitiesDirectTrading==='None') {
            $scope.custodian.portfolio.communitiesDirectTrading = undefined;
        }

        var args = custodianId > 0 ? {method: "PUT", id: custodianId, trackerMsg: "Saving custodian " + custodianId} : {method: "POST", id: "", trackerMsg: "Adding new custodian"};

        $http( { method: args.method, url: '/Portfolio/Custodians/Verbose/' + args.id, data: verboseCustodian, trackerMsg: args.trackerMsg } )
            .then(function() {
                var cache = $cacheFactory.get('$http');
                cache.remove(API_CONFIG.baseUrl + '/Portfolio/Custodians/Simple');

                $location.path( '/portfolio/custodians' );
            });
    };

    $scope.deleteCustodian = function( ) {
        $http.delete('/Portfolio/Custodians/Verbose/' +  custodianId, {trackerMsg: 'Deleting custodian ' + custodianId})
            .then(function () {
                $location.path( '/portfolio/custodians' );
            });
    };

    

    // INIT
    $scope.blockMethods = [
        {id: 'Default', name:'Default'},
        {id: 'FixEft', name:'Equity Blocking'},
        {id: 'OneToOne', name:'Mutual Fund Blocking'}
    ];

    $scope.globalCustodians = [];
    $scope.enableRequiringGlobalCustodian = false;

    $scope.algoCodeMapping = [
        {tag:'A', algorithmCode:null},
        {tag:'B', algorithmCode:null},
        {tag:'C', algorithmCode:null},
        {tag:'D', algorithmCode:null},
        {tag:'E', algorithmCode:null},
        {tag:'F', algorithmCode:null},
        {tag:'G', algorithmCode:null},
        {tag:'H', algorithmCode:null},
        {tag:'I', algorithmCode:null},
        {tag:'J', algorithmCode:null},
        {tag:'K', algorithmCode:null},
        {tag:'L', algorithmCode:null},
        {tag:'M', algorithmCode:null},
        {tag:'N', algorithmCode:null},
        {tag:'O', algorithmCode:null},
        {tag:'P', algorithmCode:null},
        {tag:'Q', algorithmCode:null},
        {tag:'R', algorithmCode:null},
        {tag:'S', algorithmCode:null},
        {tag:'T', algorithmCode:null},
        {tag:'U', algorithmCode:null},
        {tag:'V', algorithmCode:null},
        {tag:'W', algorithmCode:null},
        {tag:'X', algorithmCode:null},
        {tag:'Y', algorithmCode:null},
        {tag:'Z', algorithmCode:null}


    ];
    $scope.enableAlgoEditing = false;


    $scope.rightsCustodian = $oasRights.forCode('CUSTODIAN');
    $scope.rightCustodianPriceHierarchy = $oasRights.forCode('CUSTODIANPRICEHIERARCHY');
    $scope.current = {selectedBlockId: 0};
    $scope.selectedPriceHeirarchyCustodians = [];
    $scope.availableCustodians = [];
    $scope.errors = [];

    loadEnumLookUps();
    loadUploadTargets();
    loadProductTypes();
    loadCustodian();
    loadGlobalCustodians();
});
'use strict';

app.controller('FundFamilyAddEditCtrl', function FundFamilyAddEditCtrl($scope, $rootScope, $http, $location, $dialog, $portfolio, $oasRights, $routeParams, collectionMethods) {

    //PRIVATE VARIABLES
    var fundFamilyID = $routeParams.id;
    var customFieldsOriginal = null;

    //PRIVATE METHODS
    function init() {
        loadCollectionMethods();
        loadCustomFields();
        //Load existing fund family if a valid ID has been passed.  Otherwise, create a new fund family.
        if (fundFamilyID != 0) {
            $http.get('/Portfolio/FundFamilies/' + fundFamilyID, {trackerMsg: 'Loading Fund Family'})
                .then(function (response) {

                    $scope.fundFamily = response.data;
                    $scope.fundFamily.entityOptions.forEach(function (option) {
                        if (option.definition.type === 'Check box') {
                            option.value = (option.value.toLowerCase() === 'true');
                        }
                    });
                });
        } else {
            $scope.fundFamily = {id: 0, name: "New Fund Family"};
        }
        $http.get('/Portfolio/FundFamilies/EndResultTradeFormats')
            .then(function (response) {
                $scope.endResultTradeFormats = response.data;
                $scope.endResultTradeFormats = $scope.endResultTradeFormats.filter(function (x) {
                    return x.type === 'VB';
                }).map(function (x) {
                    return x.tradeFormatId;
                });
            });
    }

    //PUBLIC METHODS
    $scope.saveFundFamily = function () {
        var args = $scope.fundFamily.id != 0 ? {
            method: 'PUT',
            id: $scope.fundFamily.id,
            action: 'Update',
            trackerMsg: 'Saving fund family ' + $scope.fundFamily.id
        } : {method: 'POST', action: 'Create', id: '', trackerMsg: 'Adding new fund family'};

        //See if we have any VB formats in the last two drop downs.
        var foundVBFormat = false;

        if ($scope.fundFamily.custodianTradeFileFormats != null && $scope.fundFamily.custodianTradeFileFormats.length){
            $scope.fundFamily.custodianTradeFileFormats.forEach(function (format) {
                if ($scope.endResultTradeFormats.includes(format.trExFmtId) || $scope.endResultTradeFormats.includes(format.trExFmtEndResultId)) {
                    foundVBFormat = true;
                }
            });
        }

        if ($scope.customFields && !angular.equals(customFieldsOriginal, $scope.customFields)) {
            var udfs = $scope.customFields;
            if (udfs) $scope.fundFamily["userDefinedFields"] = udfs;
        }

        // We found a VB format, validate that the user actually wants to save them
        if (foundVBFormat) {
            $dialog.confirmAction('A VB format is currently selected, are you sure you want to save?')
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $http({
                            method: args.method,
                            url: '/Portfolio/FundFamilies/' + args.action,
                            data: $scope.fundFamily,
                            trackerMsg: args.trackerMsg
                        })
                            .then(function () {
                                $location.path('/portfolio/fundfamilies/');
                            });
                    }
                });
        } else {
            $http({
                method: args.method,
                url: '/Portfolio/FundFamilies/' + args.action,
                data: $scope.fundFamily,
                trackerMsg: args.trackerMsg
            })
                .then(function () {
                    $location.path('/portfolio/fundfamilies/');
                });
        }
    };


    function loadCustomFields() {
        if ($scope.customFields) return;

        var url = fundFamilyID == 0 ? '/Settings/UserDefinedFields/Definitions/FundFamilies' : '/Portfolio/FundFamilies/' + fundFamilyID + '/UserDefinedFields';

        $http.get(url, { trackerMsg: 'Loading custom fields' })
            .then(function (response) {
                if (fundFamilyID == 0) {
                    $scope.customFields = response.data.map(function (definition) {
                        return $portfolio.makeCustomFieldFromDefinition(definition, "Fund Family");
                    });
                } else {
                    $scope.customFields = response.data;
                }

                $portfolio.cleanCustomFields($scope.customFields);
                customFieldsOriginal = angular.copy($scope.customFields);
            });
    }

    $scope.removeLocalFundFamily = function () {
        $dialog.confirmAction("Are you sure you want to remove fund family <b>" + $scope.fundFamily.name + "</b>?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete('/Portfolio/FundFamilies/' + $scope.fundFamily.id, {
                        trackerMsg: 'Deleting fund family ' + $scope.fundFamily.name
                    })
                        .then(function () {
                                $location.path('/portfolio/fundfamilies/');
                            }
                        );
                }
            });
    };

    $scope.addTradeFormatRow = function () {
        var row = {
            id: 0,
            custodianId: 0,
            registrationTypeId: 0,
            trExFmtId: 0,
            trExFmtEndResultId: 0,
            fundFamilyId: $scope.fundFamily.id
        };

        if (!$scope.fundFamily.custodianTradeFileFormats) {
            $scope.fundFamily.custodianTradeFileFormats = [];
        }

        $scope.fundFamily.custodianTradeFileFormats.push(row);
    };

    $scope.removeTradeFormatRow = function (tradeFormat) {
        $dialog.confirmAction('Are you sure you want to remove this row?')
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.fundFamily.custodianTradeFileFormats.remove(tradeFormat);
                }
            });
    };

    $scope.removeAllTradeFormatRows = function () {
        $dialog.confirmAction('Are you sure you want to remove all Custodian Trade File Format Rows? This is only committed on saving of Fund Family.')
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.fundFamily.custodianTradeFileFormats = [];
                }
            });
    };

    //CUSTODIAN/METHOD/FORMAT ROW FUNCTIONS
    $scope.addRow = function () {
        var row = {
            id: 0,
            custodianId: 0,
            collectionMethod: 0,
            collectFmtid: 0,
            fundFamilyId: $scope.fundFamily.id
        };

        if (!$scope.fundFamily.custComplexes) {
            $scope.fundFamily.custComplexes = [];
        }

        $scope.fundFamily.custComplexes.push(row);
    };

    $scope.removeRow = function (dtl) {
        $dialog.confirmAction('Are you sure you want to remove this row?')
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.fundFamily.custComplexes.remove(dtl);
                }
            });
    };

    // INITIALIZE
    $scope.collectionMethods = collectionMethods;
    $scope.rightsFundFamily = $oasRights.forCode('FUNDFAMILIES');
    $scope.rightsGlobalFundFamily = $oasRights.forCode('GLOBALFUNDFAMILIES');
    $scope.rightsGlobalProducts = $oasRights.forCode('GLOBALPRODUCT');
    $scope.rightsCollectionMethod = $oasRights.forCode('FUNDFAMILYCOLLECTIONMETHOD');
    $scope.rightsAdmin = $oasRights.forCode('ECLIPSEORIONADMIN');
    $scope.isAdmin = $rootScope.user.authorization.entity === 'Administrator';
    $scope.customFields = null;

    $scope.editableField = !($scope.rightsFundFamily.canUpdate || $scope.rightsFundFamily.canAdd);

    $scope.globalFieldReadonly = !($scope.rightsGlobalFundFamily.canUpdate || $scope.rightsGlobalFundFamily.canAdd);
    $scope.readonlyCollectionField = !($scope.rightsFundFamily.canUpdate || $scope.rightsFundFamily.canAdd ||
        ($scope.rightsFundFamily.canRead && $scope.rightsCollectionMethod.canUpdate) ||
        $scope.rightsGlobalFundFamily.canUpdate || $scope.rightsGlobalFundFamily.canAdd ||
        ($scope.rightsGlobalFundFamily.canRead && $scope.rightsCollectionMethod.canUpdate));

    init();

    //DATA LOAD METHODS
    function loadCollectionMethods() {
        if ($scope.collectionMethods === null) {
            $scope.collectionMethods = [];
            collectionMethods.keys().forEach(function (key) {
                $scope.collectionMethods.push({id: collectionMethods[key].value, name: collectionMethods[key].name});
            });
        }
    }
});
'use strict';

app.controller('FundFamilyCtrl', function FundFamilyCtrl(views, $scope, $http, $location, $dialog, $oasRights){
    //public methods
    $scope.loadLocalFundFamily = function init () {
        $http.get('/Portfolio/FundFamilies', {trackerMsg: 'Loading fund families'})
            .then(function (response) {
                $scope.localFundFamilies = response.data;
            });
    };
    $scope.loadGlobalFundFamily= function (){
        $http.get('/Global/FundFamilies')
            .then(function (response) {
                $scope.globalFundFamilies = response.data;
            });
    };

    $scope.removeLocalFundFamily = function (ff){
        $dialog.confirmAction("Are you sure you want to remove fund family <b>" + ff.name + "</b>?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete('/Portfolio/FundFamilies/' + ff.id, {

                        trackerMsg: 'Deleting fund family ' + ff.name
                    })
                        .then(function () {
                            $scope.$broadcast('event:fund-family-action', {action: 'refresh-grid'} );
                            }
                        );
                }
            });
    };

    $scope.removeListFundFamily = function (){
        if($scope.selectedIds.length === 1) {
            $dialog.confirmAction("Are you sure you want to remove fund family <b>" + $scope.selectedIds[0] + "</b>?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $http.delete('/Portfolio/FundFamilies/' + $scope.selectedIds[0], {

                            trackerMsg: 'Deleting fund family ' + $scope.selectedIds[0]
                        })
                            .then(function () {
                                $scope.$broadcast('event:fund-family-action', {action: 'refresh-grid'} );
                                }
                            );
                    }
                });
            } 
            else {
                $dialog.messageBox("No Changes Made", "Please select one Fund Family for deletion.").open();
            }
    };


    $scope.cancelFundFamilyChanges = function (){
        fundFamiliesBeforeChanges = [];
        $location.path("/portfolio/fundfamilies");
    };

    $scope.saveLocalFundFamilies = function () {
        var reviewItems = [];

        var deleteCandidates = findDeleteCandidates();
        var addCandidates = findAddCandidates();
        appendArray(reviewItems, deleteCandidates);
        appendArray( reviewItems, addCandidates);

        if ( reviewItems.length > 0) {
            var dialogOpts = {
                scope: $scope,
                templateUrl: "portfolio/modals/fundFamilyChangesReview.html",
                resolve: {
                    reviewItems: function () {
                        return reviewItems;
                    }
                },
                controller: "fundFamilyChangesReviewCtrl",
                dialogClass: "modal wide",
                height: "600px"
            };
            $dialog.dialog(dialogOpts).open()
                .then(function (result) {
                    if (result) {
                        $scope.onLoadFundFamilyForEdit();
                    }
                });
        }else{
            $dialog.messageBox("", "No Changes.").open();
        };
    };
    $scope.onLoadFundFamilyForEdit = function (){
        $scope.loadGlobalFundFamily();
        $http.get('/Portfolio/FundFamilies', {trackerMsg: 'Loading fund families'})
            .then(function (response) {
                $scope.localFundFamilies = response.data.sort();
                fundFamiliesBeforeChanges = angular.copy(response.data);
                $scope.globalFundFamilies = $scope.globalFundFamilies.filter ( function (source){
                    return !$scope.localFundFamilies.some( function (target){
                        return target.id === source.id;
                    });
                });
            });
    };

    function appendArray(source, target){
        angular.forEach( target, function(item){
           source.push ( item);
        });
    };

    function findDeleteCandidates(){
        var items = fundFamiliesBeforeChanges.filter(function (source) {
            return !$scope.localFundFamilies.some(function (target) {
                return target.id === source.id;
            });
        });
        var deleteCandidates = [];
        angular.forEach(items, function(value){
            var newItem = {
                id : value.id,
                name : value.name,
                action : "Delete",
                status : "Pending",
                errorMessage: ""
            };
            deleteCandidates.push(newItem);
        });
        return deleteCandidates;
    };

    function findAddCandidates(){
        var items = $scope.localFundFamilies.filter(function (source) {
            return !fundFamiliesBeforeChanges.some(function (target) {
                return source.id == target.id;
            });
        });
        var addCandidates = [];
        angular.forEach(items, function(value){
            var newItem = {
                id : value.id,
                name : value.name,
                action : "Add",
                status : "Pending",
                errorMessage: ""
            }
            addCandidates.push(newItem);
        });
        return addCandidates;
    };

    
    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $location.path( '/portfolio/fundfamilies/' + $scope.selectedIds[0]);
    };

    //Initialization
    $scope.localFundFamilies = [];
    $scope.globalFundFamilies = [];
    $scope.selectedIds = [];

    $scope.views = views;
    $scope.rightsFundFamily = $oasRights.forCode('FUNDFAMILIES');
    $scope.rightsGlobalProducts = $oasRights.forCode('GLOBALPRODUCT');

    $scope.current = {
        view : views[0],
        gridDoubleClick : $scope.slickGridDoubleClick
    };

    var fundFamiliesBeforeChanges = [];
});

(function () {
    'use strict';
    angular
        .module('orionConnect')
        .controller('pendingClientInfoCtrl', ['$scope', '$http', '$q', '$portfolio', 'entities', 'views', CTRL]);

    function CTRL($scope, $http, $q, $portfolio, entities, views) {
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.current = {
            tab: {table: false, report: true},
            selectedRows: [],
            view: views[0],
            loadUrl: '/Portfolio/AccountCustodialInfo/Active',
            data: [],
            filterOptions: {},
            grid: {
                update(obj) {
                    let data = (Object.prototype.toString.call(obj.data) === "[object Object]") ? [obj.data] : obj.data;
                    return $http.post('/Portfolio/AccountCustodialInfo', data, {trackerMsg: 'Updating status'});
                }
            }
        };
        $scope.controls = {
            setAllSelected: setAllSelected,
            filterOptions: filterOptions,
            clearFilters: clearFilters,
            exportToExcel:exportToExcel,
            openEntityEditor:openEntityEditor
        };

        //INIT
        (function () {

        })();

        function openEntityEditor(entity) {
            switch (entity) {
                case 'household':
                    $portfolio.openEditor( entities.client.value, [$scope.current.selectedRows[0].householdId], null, null, 'New Accounts', null );
                    break;
                //Registration wont actually be used at this point but I'm leaving the code in for future development.
                case 'registration':
                    $portfolio.openEditor( entities.client.value, [$scope.current.selectedRows[0].householdId], null, null, 'New Accounts', null );
                    break;
            }
        };

        function exportToExcel() {
            $scope.$broadcast('event:pendingClientInfo-action', {action: 'export-data'});
        }
        function clearFilters() {
            $scope.current.filterOptions = {};
        }

        function filterOptions() {
            let queryString = '/Portfolio/AccountCustodialInfo?';

            Object.keys($scope.current.filterOptions, function (key, value) {
                if (queryString !== '/Portfolio/AccountCustodialInfo?') {
                    queryString += '&';
                }
                switch (key) {
                    case 'startDate':
                        queryString += 'startdate=' + formatDate(value);
                        break;
                    case 'endDate':
                        queryString += 'enddate=' + formatDate(value);
                        break;
                    case 'household':
                        queryString += 'householdid=' + value.id;
                        break;
                    case 'accountid':
                        queryString += 'accountid=' + value.id;
                        break;
                    default:
                        queryString = '/Portfolio/AccountCustodialInfo/Active';
                        break;
                }
            });
            $http.get(queryString,{trackerMsg: "Loading Data"}).then(function (res) {
                $scope.$broadcast('event:pendingClientInfo-action', {action: 'clear-items'});
                $scope.$broadcast('event:pendingClientInfo-action', {
                    action: 'add-items',
                    items: res.data,
                    markAsNew: false
                });
            });
        }

        function setAllSelected(status) {
            $scope.current.selectedRows.forEach(function (row) {
                row.changeStatus = status;
            });
            upsertItems($scope.current.selectedRows);
        }

        // update supplied rows
        function upsertItems(items, skipUpdate) {
            if (items) $scope.$broadcast('event:pendingClientInfo-action', {
                action: 'upsert-items',
                items: items,
                autoUpdate: true
            });
            if (skipUpdate) {
                return;
            }
            $scope.current.grid.update({data: items});
        }

        //PRIVATE FUNCTIONS
        function formatDate(obj) {
            let mm = obj.getMonth() + 1;
            let dd = obj.getDate();
            let yyyy = obj.getFullYear();
            if (mm < 10) mm = '0' + mm;
            if (dd < 10) dd = '0' + dd;

            return mm + "/" + dd + "/" + yyyy;
        }

        //EVENT LISTENERS
        $scope.$on('event:pendingClientInfo-select', function (e, data) {
            $scope.current.selectedRows = data;
            $scope.selectedIds = Object.values(data);
        });
    }
})();
'use strict';

app.controller('MatrixB50Ctrl', function MatrixB50Ctrl($scope, $http, $oasRights, views) {

    // PRIVATE METHODS
    const baseUrl = '/Portfolio/MatrixB50';

    $scope.rights = {
        matrixb50: $oasRights.forCode("MATRIXB50"),
        matrixb50records: $oasRights.forCode("MATRIXB50RECORDS")
    };

    $scope.$on('event:matrixb50-check-select', function (e, args) {
        $scope.selectedItems = args;
    });

    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: { get: function () { return $scope.selectedItems.map('id') } },
        selected: { get: function () { return $scope.selectedItems[0] || $scope.current.item; } }
    });

    $scope.refreshGrid = function() {
        $scope.$broadcast('event:matrixb50-refresh-action', { action: 'refresh-grid' });
    };

    $scope.updateStatus = function updateStatus(status)
    {
        if (status == null)
        {
            return;
        }
        let statusUrl = baseUrl + '/List/UpdateStatus?status=' + encodeURI(status)

        if (!$scope.selectedItems || $scope.selectedItems.length === 0)
        {
            return;
        }
        let putBody = $scope.selectedItems.map('id')

        $http.put(statusUrl, putBody
            , { trackerMsg: "Updating B50 Status" })
            .then(function () { $scope.refreshGrid(); });
    };

    $scope.filterData = function ()
    {
        const promise = new Promise(function (resolve, reject)
        {
            let statusFilterSelected = $scope.current.filterOptions.status;
            if ($scope.statusfromapiwithall && statusFilterSelected != null)
            {
                let statusFromApi = $scope.statusfromapiwithall[statusFilterSelected];
                $scope.current.status = statusFromApi.name
            }
            $scope.formatDate()
            resolve();
        })
        .then(() =>
        {
            $scope.refreshGrid();
        });
    }

    $scope.formatDate = function()
    {
        angular.merge($scope.current, {
            startDate: $scope.current.filterOptions.startCreatedDate?.format('{MM}-{dd}-{yyyy}'),
            endDate: $scope.current.filterOptions.endCreatedDate?.format('{MM}-{dd}-{yyyy}')
        });
    }

    $scope.views = views;
    $scope.current = {
        tab: { clientfilter: true, datafilter: false },
        view: views[0],
        filters: {},
        slickGridUrl: baseUrl,
        matrixb50statusurl: "/Portfolio/MatrixB50/Status",
        gridDoubleClick: $scope.slickGridDoubleClick,
        filterOptions: {},
    };

    function init() {
        $http.get($scope.current.matrixb50statusurl + "?includeAll=false", { trackerMsg: "Getting B50 Statuses" })
            .then(function (response) {
                $scope.statusfromapi = response.data
            })

        // This second query gets the "all" value for mapping the filter properly to easily "refresh" or filter just on the dates
        $http.get($scope.current.matrixb50statusurl + "?includeAll=true", { trackerMsg: "Getting B50 Statuses" })
            .then(function (response) {
                $scope.statusfromapiwithall = response.data
            })
    }

    init()
});
'use strict';

app.controller('PlanListCtrl', function PlanListCtrl($scope, $http, entities, $portfolio, views, apps, $oasRights, $location) {

    //PRIVATE VARIABLES

    //PRIVATE METHODS

    // PUBLIC METHODS
    $scope.openEditor = function(isNew) {
        if( $scope.selectedIds.length == 1 || isNew ) {
            $portfolio.openEditor(entities.plan401k.value, isNew ? [] : $scope.selectedIds, 'General', 'planGeneral', apps.portfolioLists.name).then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast( 'event:portfolio-plans-action', {action: isNew ? 'add-item' : 'update-item', item: rslt } );
                }
            });
        }
    };

    $scope.deletePlan = function(id){
        $http.delete( "/Portfolio/Plans/Verbose/" + id, {trackerMsg: 'Deleting plan'} )
            .then( function( ) {
                $scope.$broadcast('event:portfolio-plans-action', {action: 'refresh-grid'});
            });
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:portfolio-plans-action', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    };

    // INTIALIZE
    $scope.rights401kPlan = $oasRights.forCode( "401KPLAN" );
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: '/Portfolio/Plans'
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    }}];
});

'use strict';

app.controller('PlanEditCtrl', function PlanEditCtrl($scope, $http, $q, $timeout, $filter, $oasRights, $dialog, $portfolio, dialog, args, entities, apps, planStatus) {
    // PRIVATE VARIABLES
    const verbose = {id: args.isNew ? null : args.ids[0]};
    const original = angular.copy(verbose);
    const editorHotKeys = new HotKeys();

    // PRIVATE METHODS
    function init() {
        loadRights();
        buildMenu();
        loadEnumLookUps();
        loadHotKeys();
        loadPlanParticipantAddOption();

        $scope.menu.each(function (category) {
            const menuItem = category.items.find({code: args.defaultTab.code});
            if (menuItem) {
                $scope.loadTab(menuItem);
                return false;
            }
        });
    }

    function loadRights() {
        $scope.rights401kPlan = $oasRights.forCode("401KPLAN");
        $scope.rightsSSNView = $oasRights.forCode("SSNVIEW");
        $scope.rightsSSNChange = $oasRights.forCode("SSNCHANGE");
        $scope.rightsNotes = $oasRights.forCode("NOTES");
    }

    function buildMenu() {
        $scope.menu = [
            {name: "Plan Detail", enabled: $scope.rights401kPlan.canRead, items: [
                {name: 'General', code: 'planGeneral', enabled: true, load: [loadPlan, loadPersonal]},
                {name: 'Sponsor', code: 'planSponsor', enabled: true, load: [loadSponsor, loadPersonal]},
                {name: 'Participants', code: 'planParticipants', enabled: true, load: [loadPlan, loadParticipants]},
                {name: 'Notes', code: 'planNotes', enabled: $scope.rightsNotes.canRead, load: [loadNotes]}
            ]},
            {name: "Plan Items", enabled: $scope.rights401kPlan.canRead, items: [
                {name: 'Representatives', code: 'planRepresentatives', enabled: true, load: [loadRepresentatives]},
                {name: 'Management Styles', code: 'planPlatforms', enabled: true, load: [loadPlatforms]},
                {name: 'Fees', code: 'agreementFees', enabled: true, load: [loadFees]},
            ]}
        ];

        $scope.menu.forEach(function (category) {
            category.items.remove({enabled: false});

            if (!category.items.length) {
                category.enabled = false;
            }
        });

        $scope.menu.remove({enabled: false});
    }

    function loadEnumLookUps() {
        const list = {
            planStatuses: planStatus
        };

        Object.each(list, function (key, value) {
            $scope[key] = $portfolio.enumToSimpleList(value);
        });
    }

    function loadHotKeys() {
        $timeout(function () {
            editorHotKeys.addActions([
                {combo: 'ALT+S', command: $scope.save},
                {combo: 'ALT+X', command: function () {$scope.close(true);}}
            ]);
        });
    }

    function expandVerbose(section, postRetrievalFn) {
        if (verbose[section]) return $q.when(verbose[section]);

        return $http.get("/Portfolio/Plans/Verbose/" + (verbose.id || 'New') + "?expand=" + section, {trackerMsg: 'Loading ' + section + ' data'})
            .then(function (response) {
                verbose[section] = response.data[section];

                if (postRetrievalFn) {
                    postRetrievalFn(verbose[section]);
                }

                original[section] = angular.copy(verbose[section]);

                return verbose[section];
            });
    }

    function loadPlan() {
        expandVerbose('portfolio')
            .then(function (data) {
                $scope.current.allowParticipantImport = verbose.id && data.custodianId && data.registrationTypeId;
            });
    }

    function loadPersonal() {
        expandVerbose('personal');
    }

    function loadSponsor() {
        expandVerbose('sponsor');
    }

    function loadRepresentatives() {
        expandVerbose('representatives');
    }

    function loadPlatforms() {
        expandVerbose('platforms');
    }

    function loadParticipants() {
        expandVerbose('participants');
    }

    function loadFees() {
        const addDefaultParties = function (data) {
            ['RIA', 'Rep', 'TPA', 'MGA'].forEach(function (party) {
                if (data.none({party: party})) {
                    data.push({id: 0, party: party, feePercent: 0});
                }
            });
        };

        expandVerbose('fees', addDefaultParties);
    }

    function loadNotes() {
        if (!$scope.rightsNotes.canRead || verbose.notes) return;

        expandVerbose('notes');
    }
    function loadPlanParticipantAddOption() {
        $http.get('/Settings/Database/EntityOptions/Code/69QUALPLANNEWADD', { cache: true, ignoreExceptions: true })
            .then(function (response) {
                $scope.usePlanParticipantAdd = response.data && response.data.value === 'True';
            });
    }

    function openPlanParticipantAddModal() {
        $q.all([loadPlan(), loadPlatforms()])
            .then(function () {
                $scope.showPlanParticipantAddModal = true;
            });
    }

    function openExistingParticipantSearch() {
        $dialog.search('account', 'Add Participant')
            .open()
            .then(function (result) {
                if (!result || verbose.participants.any({ accountId: result.id })) {
                    return;
                }

                $http.get('/Portfolio/Accounts/' + result.id, { trackerMsg: 'Loading account' })
                    .then(function (response) {
                        const data = response.data;

                        verbose.participants.push({
                            accountId: data.id,
                            accountNumber: data.number,
                            currValue: data.currentValue,
                            fundFamilyName: data.fundFamily,
                            houseHoldEmail: null,
                            householdId: data.clientId,
                            householdName: data.household,
                            isActive: data.isActive,
                            managementStyleName: data.managementStyle,
                            riskBudget: data.riskBudget,
                            isLifestyleOption: data.isLifestyleOption,
                        });
                    });
            });
    }

    function confirmAndRemove(list, item, nameProperty) {
        $dialog.confirmAction("Are you sure you want to remove <b>" + item[nameProperty || 'name'] + "</b>?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    list.remove(item);
                }
            });
    }


    // PUBLIC METHODS
    $scope.invalidEmail = function (invalid) {
        if ($scope.verbose.personal) {
            $scope.verbose.personal.invalidEmail = invalid;
        }
    };

    $scope.setEmail = function (value) {
        if ($scope.verbose.personal) {
            $scope.verbose.personal.email = value;
        }
    };

    $scope.invalidSponsorEmail = function (invalid) {
        if ($scope.verbose.sponsor) {
            $scope.verbose.sponsor.invalidEmail = invalid;
        }
    };

    $scope.setSponsorEmail = function (value) {
        if ($scope.verbose.sponsor) {
            $scope.verbose.sponsor.email = value;
        }
    };

    $scope.loadTab = function (menuItem) {
        $scope.current.selectedTab = menuItem;
        menuItem.load.forEach(function (fn) {fn();});
    };

    $scope.unlockSSNField = function (forEdit) {
        if (forEdit || (verbose.sponsor.ssN_TaxID && verbose.sponsor.ssN_TaxID.has('X'))) {
            $dialog.inputBox('Reason to ' + (forEdit ? 'Edit' : 'View') + ' the SSN or Tax ID', "Reason", "textarea")
                .open()
                .then(function (result) {
                    if (!result) return;

                    $http.put('/Portfolio/Plans/' + verbose.id + '/Sponsor/SSNTaxId', {reason: result}, {trackerMsg: 'Getting SSN/Tax ID information'})
                        .then(function (response) {
                            verbose.sponsor.ssN_TaxID = response.data;

                            if (forEdit) {
                                $scope.current.updateSSNReason = result;
                            }
                        });
                });
        }
    };

    $scope.save = function () {
        const entityToSave = {id: verbose.id},
            abortMessages = [];

        if ($scope.verbose.personal?.invalidEmail) {
            abortMessages.push("Invalid custodian contact email address.")
        }

        if ($scope.verbose.sponsor?.invalidEmail) {
            abortMessages.push("Invalid sponsor contact email")
        }

        Object.each(verbose, function (key, value) {
            if (angular.equals(original[key], value)) return;

            let verboseSection = angular.copy(value);

            //do any necessary custom manipulations and error checks
            switch (key) {
                case "entityOptions":
                    verboseSection = $portfolio.restoreEntityOptions(verboseSection);
                    break;
            }

            entityToSave[key] = verboseSection;
        });

        if (abortMessages.length) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Data", '<ul class="unstyled"><li>' + abortMessages.join("</li><li>") + '</li></ul>').open();
            return;
        }

        const xhr = args.isNew ? {verb: 'post', msg: 'Adding', suffix: ''} : {verb: 'put', msg: 'Saving', suffix: entityToSave.id};

        const promises = [];
        promises.push($http[xhr.verb]('/Portfolio/Plans/Verbose/' + xhr.suffix, entityToSave, {trackerMsg: xhr.msg + ' plan'}));

        if ($scope.current.updateSSNReason) {
            promises.push($http.put("/Portfolio/Plans/" + entityToSave.id + "/Sponsor/SSNTaxId", {ssN: entityToSave.sponsor.ssN_TaxID, reason: $scope.current.updateSSNReason}, {trackerMsg: 'Saving SSN/Tax ID'}));
        }

        $q.all(promises)
            .then(function (responses) {
                let returnDataUrl;

                switch (args.app) {
                    case apps.portfolioLists.name:
                        returnDataUrl = '/Portfolio/Plans/' + responses[0].data.id;
                        break;
                    default:
                        $scope.close(false);
                        return;
                }

                $http.get(returnDataUrl, {trackerMsg: 'Refreshing plan'})
                    .then(function (response) {
                        editorHotKeys.destroy();
                        dialog.close(response.data);
                    });
            });
    };

    $scope.close = function (validate) {
        if (validate && !angular.equals(original, verbose)) {
            $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true});
        } else {
            editorHotKeys.destroy();
            dialog.close();
        }
    };

    $scope.syncSponsorAddressFromPlan = function () {
        if (verbose.sponsor.syncAddress) {
            const fieldsToSync = Object.reject(verbose.personal, 'ssN_TaxID', 'salutation', 'dob');
            angular.extend(verbose.sponsor, fieldsToSync);
        }
    };

    $scope.addRep = function () {
        $dialog.search('representative', 'Add Plan Representative')
            .open()
            .then(function (result) {
                if (!result || verbose.representatives.any({id: result.id})) return;

                verbose.representatives.push(result);
            });
    };

    $scope.removeRep = function (rep) {
        confirmAndRemove(verbose.representatives, rep);
    };

    $scope.addParticipant = function () {
        if ($scope.usePlanParticipantAdd) {
            openPlanParticipantAddModal();
            return;
        }

        openExistingParticipantSearch();
    };

    $scope.onPlanParticipantAddModalClose = function (participant) {
        $scope.showPlanParticipantAddModal = false;

        if (!participant) {
            return;
        }

        if (!verbose.participants) {
            verbose.participants = [];
        }

        if (verbose.participants.any({ accountId: participant.accountId })) {
            return;
        }

        verbose.participants.push(participant);
    };

    $scope.editParticipant = function (participant) {
        $portfolio.openEditor(entities.account.value, [participant.accountId], 'Accounts', 'accountGeneral', null, null);
    };

    $scope.removeParticipant = function (participant) {
        confirmAndRemove(verbose.participants, participant, 'householdName');
    };

    $scope.exportParticipants = function () {
        const data = {
            columns: [
                {name: "ID", field: "accountId"},
                {name: "Account Number", field: "accountNumber"},
                {name: "Fund Family", field: "fundFamilyName"},
                {name: "Management Style", field: "managementStyleName"},
                {name: "Value", field: "currValue"},
                {name: "Active", field: "isActive"},
                {name: "Household Name", field: "householdName"},
                {name: "Household ID", field: "householdId"},
                {name: "Household Email", field: "houseHoldEmail"},
                {name: "Risk Budget", field: "riskBudget"},
                {name: "Lifestyle Option", field: "isLifestyleOption"},
            ],
            data: $filter('filter')(verbose.participants, $scope.searchFor)
        };

        $http.post('/Utility/SlickGridExport/csv', data, {trackerMsg: 'Exporting participants'})
            .then(function (response) {
                window.location.href = response.headers("location") + "?Authorization=" + sessionStorage.oas_token;
            });
    };

    $scope.importParticipants = function () {
        const options = {
            dialogClass: "modal wide",
            templateUrl: "app/modals/upload-file.html",
            controller: "UploadFileCtrl",
            title: "Participant Import",
            idField: "id",
            downloadUrl: '/Portfolio/ValidateImport/Participant/Templates/',
            validateUrl: '/Portfolio/ValidateImport/Participant?planId=' + verbose.id
        };

        $dialog.dialog(options)
            .open()
            .then(function (result) {
                if (!result) return;

                result.forEach(function (participant) {
                    if (verbose.participants.none({id: participant.id})) {
                        verbose.participants.push(participant);
                    }
                });
            });
    };

    $scope.addPlatform = function () {
        verbose.platforms.push({
            id: verbose.id,
            feePercent: 0
        });
    };

    $scope.removePlatform = function (platform) {
        confirmAndRemove(verbose.platforms, platform, 'platformName');
    };

    $scope.removeFee = function (fee) {
        confirmAndRemove(verbose.fees, fee, 'party');
    };


    $scope.feeTotal = function () {
        var fees = verbose['fees']?.reduce((acc, cur) => acc + cur.feePercent, 0) ?? 0;
        return parseFloat(fees.toFixed(4));
    };

    //INITIALIZE
    $scope.verbose = verbose;
    $scope.planNotes = null;

    $scope.current = {
        isNew: args.isNew,
        allowParticipantImport: false,
        updateSSNReason: null,
    };

    $scope.searchFor = {};
    $scope.showPlanParticipantAddModal = false;

    $scope.errors = [];

    init();
});
'use strict';
app.controller('schwabServiceRequestCtrl', function schwabServiceRequestCtrl($scope, $http, $dialog, dialog, $upload, $window, API_CONFIG) {
    //PUBLIC VARIABLES
    $scope.isBusy = false;
    $scope.disclosureAccepted = false;

    //PRIVATE VARIABLES

    //PRIVATE METHODS
    function init() {

        let otp = '?otp=';
        getTopics(otp);
        
        $scope.current.account = dialog.options.account;     
    }

    function getTopics(otp){
        $http.get('/Integrations/SchwabServiceRequest/Topics' + otp, {trackerMsg: 'Loading Schwab request topics'})
        .then(function (response) {
            $scope.topics = {
                list: response.data,
                selected: response.data[0]
            };

            $scope.formData.subTopic = $scope.topics.selected.subtopics[0].name;
        });

    }

    function quickValidate() {
        let errorMessage = [];

        if (!$scope.topics.selected){
            errorMessage.push("Topic is required");
        } 

        if (!$scope.formData.subTopic){
            errorMessage.push("Subtopic is required");
        }

        if (!$scope.current.account){
            errorMessage.push("Account is required")
        }

        if (!$scope.formData.requestName){
            errorMessage.push("Request Name is required");
        }

        if (!$scope.formData.requestDescription){
            errorMessage.push("Request Description is required");
        }

        if ($scope.files.length > 0){
            if ($scope.files.length > 10 ) {
                errorMessage.push("Only a maximum of 10 files is allowed.")
            } else {
                const MAX_SIZE = 31457280;
                let fileSizeSum = 0;
                let largeFileFound = false;

                for( let idx = 0, max = $scope.files.length ; idx < max ; idx++){
                    
                    let file = $scope.files[idx];
                    fileSizeSum += file.size;
                    if( file.size >= MAX_SIZE ){
                        errorMessage.push(`'${file.name}' exceeds 30MB limit.` );
                        largeFileFound = true;
                    }    
                }
                if( !largeFileFound && fileSizeSum >= MAX_SIZE ){
                    errorMessage.push("Total size of all files exceeds 30MB limit");
                }
            }
        }

        return errorMessage.length > 0
                ? { isValid: false, message: errorMessage.join("<br/>") }
                : { isValid: true, message: "" };
    }


    //PUBLIC METHODS
    $scope.save = function () {
        let quickValidateResponse = quickValidate();

        if (quickValidateResponse.isValid) {
            
            $scope.formData.topic = $scope.topics.selected.name;
            if($scope.current.account){
                $scope.formData.subAccount = $scope.current.account.number;
            }

            var config = {
                url: "/Integrations/SchwabServiceRequest/create",
                data: $scope.formData,
                file: $scope.files,
                fileFormDataName: $scope.files.map(function (item, i) {
                    return "files[" + i + "]"
                })
            };

            $scope.isBusy = true;
            $upload.upload(config).then(function (response) {

                if (response && response.status == 200) {

                    if( response.data.hasError === false){
                        $dialog.messageBox("Success! <a href='" + response.data.item.serviceRequestTrackingUrl + "' target='_blank'  data-test-id='schwabSrSuccessLaunch'><i class='fa fa-fw fa-external-link'  title='Launch into Schwab Service Center' aria-hidden='true'></i></a>", "Sent successfully.<br /><br/>Tracking ID: " + response.data.item.confirmationId).open()
                            .then(function () {
                                dialog.close();
                            });
                    } else {
                        $dialog.messageBox("Unable to submit", response.data.status).open();
                    }

                } else {
                    $dialog.messageBox("Failed", "Status: Case was not Created" ).open();
                }
                
            }, function(errResponse){
                $scope.isBusy = false;
            }).then(function(){
                $scope.isBusy = false;
            });
        } else {
            $dialog.messageBox("Unable to submit", quickValidateResponse.message).open();
        }
    };

    $scope.close = function () {
        dialog.close();
    };

    $scope.onFileSelect = function (files) {
        $scope.files.add(files);
        $scope.numberOfFilesSelected = files.length;

        $scope.removeFile = function (file) {
            $scope.files.remove(file);
        };
    };

    $scope.openSchwabRequestCenterDirect = function() {
        //$window.open(API_CONFIG.baseUrl + '/Integrations/SchwabSII/SSO?pageId=12&Authorization=' + sessionStorage.oas_token);
        $window.open(API_CONFIG.baseUrl + '/Integrations/SchwabSII/SsoV2/12?Authorization=' + sessionStorage.oas_token);
    };

   $scope.acceptDisclosure = function(){
    $scope.disclosureAccepted = true;
   }

    //PUBLIC VARIABLES
    $scope.numberOfFilesSelected = 0;
    $scope.fileNames = [];
    $scope.files = [];
    $scope.formData = {};
    $scope.current = {};


    //INITIALIZE
    init();
});
(function(){
    'use strict';
    app
        //SERVICES
        .service('mclWizardServices', mclWizardServices)
        .factory('mclWizardTracking', mclWizardTracking)
        .factory('mclWizardToolTips', mclWizardToolTips)
    ;

    //SERVICES
    function mclWizardServices($http) {
        this.sort = function (arr) {
            // let arr = cust.list.status;
            for (let i = arr.length - 1; i >= 0; i--) {
                if (arr[i].id) arr.push(arr.splice(i, 1)[0]);
            }
        };
        this.update = function (id, obj) {
            return $http.post('/Portfolio/ValidateImport/MasterClientListWizard/' + id + '/EntityUpdate', [obj]);
        };
        this.delete = function (id) {
            return $http.delete('/Portfolio/ValidateImport/MasterClientListWizard/' + id, {trackerMsg: 'Deleting import instance'});
        };
        this.householdUpdate = function (id, obj) {
            return $http.post('/Portfolio/ValidateImport/MasterClientListWizard/' + id + '/Household', [obj]);
        };
        this.registrationUpdate = function (id, obj) {
            return $http.post('/Portfolio/ValidateImport/MasterClientListWizard/' + id + '/Registration', [obj]);
        };
        this.getErrorList = function (id, s) {
            return $http.get('/Portfolio/ValidateImport/MasterClientListWizard/' + id + '/' + s);
        };
        this.retrieveList = function (str, trackerMsg) {
            return $http.get(str, trackerMsg);
        };
        this.createRep = function (obj) {
            return $http.post('/Portfolio/Representatives/Verbose', obj);
        };
        this.createRegistration = function(obj){
            return $http.post('/Portfolio/Registrations/Type',obj);
        };
        this.createCustodian = function(obj){
            return $http.post('/Portfolio/Custodians/Verbose/',obj);
        };
        return this;
    }

    function mclWizardTracking() {
        let mclWizardTracking = {
            currentStep: {},
            currentImport: {},
            errors:1
        };

        this.getErrorCount = function(){
            return mclWizardTracking.errors;
        };
        this.setErrorCount = function(val){
            mclWizardTracking.errors = val;
        };
        this.getCurrentStep = function () {
            return mclWizardTracking.currentStep;
        };
        this.setCurrentStep = function (val) {
            mclWizardTracking.currentStep = val;
        };
        this.getCurrentImport = function () {
            return mclWizardTracking.currentImport;
        };
        this.setCurrentImport = function (val) {
            mclWizardTracking.currentImport = val;
        };

        return this;
    }

    function mclWizardToolTips(){
        return {
            FileUpload:{
                importName:'Name of this file.',
                groupingType:'This selection will be the basis for creating the households for your accounts.'
            },
            Households:{
                HHGroupingCode:'HHGroupingCode.',
                ClientId:'ClientId.',
                HouseholdSSN:'Select the correct Social Security Number or Tax ID to be assigned to this grouping.',
                HouseholdLastName:'Select the correct client last name to be assigned to this grouping.',
                HouseholdFirstName:'Select the correct client first name to be assigned to this grouping.',
                HouseholdName:'Select the correct client name to be assigned to this grouping.  This will appear on your client reports.',
                RepresentativeName:'Select the correct name of the representative who manages these accounts.',
                HouseholdDOB:'Select the correct date of birth for the primary owner of this grouping’s accounts.',
                Address1:'Select the correct address for this grouping’s accounts.',
                Address2:'Select the correct address for this grouping’s accounts.',                
                City:'Select the correct city for this grouping’s accounts.',
                State:'Select the correct state for this grouping’s accounts.',
                Zip:'Select the correct zip for this grouping’s accounts.',
                Email:'Select the correct email for this grouping’s accounts.',
                HomePhone:'Select the correct home phone for this grouping’s accounts.',
                BusinessPhone:'Select the correct business phone for this grouping’s accounts.'
            },
            Reps:{
                RepFirstName: 'Apply the first name of the representative.',
                RepLastName: 'Apply the last name of the selected representative.',
                RepBroker: 'Select the representative\'s broker/dealer.',
                RepNumber: 'Assign any desired identifier as a method to search for or sort your representatives.'
            },
            RegTypes:{
                code: 'Apply a desired abbreviation of the registration description.',
                desc: 'Apply a name for the type of account (registration type) which is not already available.',
                planType: 'plan type'

            },
            Custodians:{
                name:'Assign a name for your custom custodian.',
                sweepAssetClass:'This field sets the pending cash asset used for trading.',
                feeRequestSource:'feeRequestSource'
            },
            FundFamilies:{},
            Registrations:{}
        };
    }
})();
(function(){
    'use strict';
    app
        //FILTERS
        .filter('mclUnique', mclUnique)
        .filter('mclShowInHeader', mclShowInHeader)
    ;
    // filters
    function mclUnique() {
        return function (items, filterOn) {

            if (filterOn === false) {
                return items;
            }

            if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
                var hashCheck = {}, newItems = [];

                var extractValueToCompare = function (item) {
                    if (angular.isObject(item) && angular.isString(filterOn)) {
                        return item[filterOn];
                    } else {
                        return item;
                    }
                };

                angular.forEach(items, function (item) {
                    var valueToCheck, isDuplicate = false;

                    for (var i = 0; i < newItems.length; i++) {
                        if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
                            isDuplicate = true;
                            break;
                        }
                    }
                    if (!isDuplicate) {
                        newItems.push(item);
                    }

                });
                items = newItems;
            }
            return items;
        };
    }

    function mclShowInHeader() {
        return function (items) {
            let ret = [];
            if (angular.isArray(items)) {
                angular.forEach(items, function (item) {
                    if (item && item.mclShowInHeader && item.mclShowInHeader === true) {
                        ret.push(item);
                    }
                })
            }
            return ret;
        }
    }
})();


(function () {
    'use strict';
    app
    //DIRECTIVES
        .directive('mclSsnFormat', mclSsnFormat)
        .directive('mclDateFormat', mclDateFormat)
        //MISC COMPONENTS
        .component('mclEditObj', mclEditObj())
        //WIZARD SECTIONS
        .component('mclFileUpload', mclFileUploadObj())
        .component('mclHouseholds', mclHouseholdsObj())
        .component('mclReps', mclRepsObj())
        .component('mclCustodians', mclCustodiansObj())
        .component('mclRegTypes', mclRegTypesObj())
        .component('mclFundFamilies', mclFundFamiliesObj())
        .component('mclRegistrations', mclRegistrationsObj())
    ;

    //WIZARD SECTIONS
    function mclFileUploadObj() {
        let obj;
        obj = {
            bindings: {},
            controller: ['$interval', 'mclWizardTracking', 'mclWizardToolTips', 'splitIoService', fileUploadCTRL],
            controllerAs: 'fu',
            template: fileUploadTemplate
        };

        function fileUploadCTRL($interval, mclWizardTracking, mclWizardToolTips, splitIoService) {
            let fu = this;
            fu.mclWizardTracking = mclWizardTracking;
            fu.mclWizardToolTips = mclWizardToolTips;
            fu.title = "Master Client List File Import";
            fu.importData = null;
            fu.groupingTypes = [
                {name: 'HH Grouping Code', value: 0},
                {name: 'Household SSN', value: 1},
                {name: 'Address Line 1', value: 2}
            ];
            fu.selectedGroup = {};
            fu.additionalData = {
                importName: '',
                groupingType: fu.selectedGroup.value
            };
            fu.dataUploaded = dataUploaded;
            fu.display = 'upload';
            fu.show = {
                value: null,
                set: setShowValue
            };
            fu.setGroup = setGroup;


            // INIT
            (function () {
                fu.mclWizardTracking.setErrorCount(1);
                splitIoService.getBoolTreatment('opex_Consolidated_MCL_27768').subscribe(function (isEnabled) {
                    fu.opex_Consolidated_MCL_27768 = isEnabled;
                    if (isEnabled) {
                        fu.groupingTypes.push({name: 'Consolidated HH Grouping Code', value: 3});
                    }
                });
            })();

            function dataUploaded(res) {
                let watch = $interval(function () {
                    if (fu.importData && fu.importData.errors) {
                        fu.title = 'Initial MCL Verification';
                        if (fu.importData.errors.length > 0) {
                            fu.display = 'error';
                        } else {
                            fu.display = 'complete';
                            fu.mclWizardTracking.setCurrentImport({mclWizardInstanceId: fu.importData.mclWizardInstanceId});
                        }
                        fu.mclWizardTracking.setErrorCount(fu.importData.errors.length);
                        $interval.cancel(watch);
                    } else {
                    }
                }, 500);
            }

            function setGroup() {
                fu.additionalData.grouping = fu.selectedGroup.value;
            }

            function setShowValue(int) {
                fu.show.value = (fu.show.value === int) ? null : int;
            }
        }

        function fileUploadTemplate() {
            return `<h1>{{fu.title}}</h1>
                   <div ng-if="fu.display=='upload'" class="span6">
                       <p>Upload the CSV or Excel file containing your completed master client list and follow each prompt to create any necessary values and import the file.</p>
                       <p>All changes made within each prompt will be saved as you advance through the wizard. You may close and return to your last point of progress at any time.</p>
                       <p ng-if="fu.opex_Consolidated_MCL_27768">If you need a place to start, <a href="_content/mcl-wizard-import-template.zip">download the full file template</a> or choose the <a href="_content/Consolidated MCL Template Rules for Import.xlsx">consolidated version</a>.</p>
                       <p ng-if="!fu.opex_Consolidated_MCL_27768">If you need a place to start, <a href="_content/mcl-wizard-import-template.zip">download the file template.</a></p>
                   </div>
                   <div ng-if="fu.display=='upload'" class="span6">
                    <form class="form-horizontal">
                            <div class="control-group">
                               <label class="control-label" >Import Name</label>
                               <div class="controls">
                                   <input ng-model='fu.additionalData.importName' class="input-large" tooltip='{{fu.mclWizardToolTips.FileUpload.importName}}'/>
                               </div>
                           </div>
                           <div class="control-group">
                               <label class="control-label">Grouping Type</label>
                               <div class="controls">
                                   <select ng-options="item.name for item in fu.groupingTypes" ng-model='fu.selectedGroup' class="input-large" ng-change='fu.setGroup()' tooltip='{{fu.mclWizardToolTips.FileUpload.groupingType}}'></select>
                               </div>
                           </div>
                       </form>
                   </div>
                   <div ng-if="fu.display=='upload' && fu.selectedGroup.name && fu.additionalData.importName" class="span6">
                       <file-uploader return-data="fu.importData" post-url="/Portfolio/ValidateImport/MasterClientListWizard" additional-data="fu.additionalData" on-data-uploaded="fu.dataUploaded()" ng-disabled="fu.additionalData.importName.length===0"></file-uploader>
                   </div>
                   <div ng-if="fu.display=='error'" class="span6">
                       <p>Your spreadsheet contains errors that prevent it from being loaded.  Please address the errors below then reload an updated file.</p>
                       <ul style='list-style-type: none'>
                           <li ng-repeat="error in fu.importData.errors" ng-click="fu.show.set($index)">
                               <span ng-if="error.errorNotes.length < 1">
                                   {{error.errorMessage}} in {{error.errorCount}} record(s)
                               </span>
                               <span ng-if="error.errorNotes.length > 0">
                                   <i class="fa fa-minus-square-o" aria-hidden="true" ng-if="fu.show.value === $index"></i>
                                   <i class="fa fa-plus-square-o" aria-hidden="true" ng-if="fu.show.value !== $index"></i>
                                   <a>{{error.errorMessage}} in {{error.errorCount}} record(s)</a>
                                   <ul ng-if="error.errorNotes.length > 0 && fu.show.value === $index"><li ng-repeat="note in error.errorNotes">{{note}}</li></ul>
                               </span>
                           </li>
                       </ul>
                   </div>
                   <div ng-if="fu.display=='complete'">
                      <h4>Initial validation complete. Please proceed.</h4>
                   </div>`;
        }

        return obj;
    }

    function mclHouseholdsObj() {
        let obj;
        obj = {
            bindings: {},
            controller: ['mclWizardServices', 'mclWizardTracking', 'mclWizardToolTips', '$http', 'splitIoService', householdsCTRL],
            controllerAs: 'hh',
            template: householdsTemplate
        };

        function householdsCTRL(mclWizardServices, mclWizardTracking, mclWizardToolTips, $http, splitIoService) {
            let hh = this;
            hh.mclWizardTracking = mclWizardTracking;
            hh.mclWizardToolTips = mclWizardToolTips;
            hh.title = "Household/Client Level Information";
            hh.viewStatus = false;
            hh.list = {
                status: [],
                houseHolds: [],
                fixItems: [],
                selected: {}

            };
            hh.checkForValidChoices = checkForValidChoices;
            hh.controls = {
                fixItem: null,
                collapsible: null,
                sort: mclWizardServices.sort,
                update: update,
                getErrorList: mclWizardServices.getErrorList,
                showPopup: false
            };

            // INIT
            (function () {
                hh.viewStatus = 'loading';
                // Get feature flag
                splitIoService.getBoolTreatment('opex_Consolidated_MCL_27768').subscribe(function (isEnabled) {
                    hh.opex_Consolidated_MCL_27768 = isEnabled;                      
                });
                hh.controls.getErrorList(hh.mclWizardTracking.getCurrentImport().mclWizardInstanceId, 'Household')
                    .then(function (res) {
                        hh.list.status = res.data;
                        filterErrors();
                    })
                    .then(function () {
                        hh.viewStatus = (hh.list.status.length === 0) ? 'finished' : 'loaded';
                    })
                ;
            })();

            function update(index, obj) {
                hh.viewStatus = 'updating';
                obj.list.status[index].errors.forEach(function (error) {
                    if(error){
                        if (typeof error.choice === 'string') error.choice = JSON.parse(error.choice);
                        if(error.choice === null){
                            error.choice = {value:'',isValid:''};
                        }
                        error.choice.isValid = true;
                    }
                });
                mclWizardServices.householdUpdate(obj.mclWizardTracking.getCurrentImport().mclWizardInstanceId, obj.list.status[index])
                    .then(function (res) {
                        if (res.status === 200) {
                            obj.list.status = res.data;
                            filterErrors();
                        }
                    })
                    .then(function () {
                        hh.viewStatus = (hh.list.status.length === 0) ? 'finished' : 'loaded';
                        hh.list.selected = {};
                        hh.controls.fixItem = null;
                        hh.controls.collapsible= null;
                    })
                ;
            }

            function filterErrors() {
                hh.list.status.forEach(function (group, index) {
                    group.errors.forEach(function (error, error_index) {
                        if (error.property === "HouseholdName") {
                            let temp = group.errors.splice(error_index, 1)[0];
                            group.errors.unshift(temp);
                        }
                    });
                    for (let i = group.errors.length - 1; i > -1; i--) {
                        let error = group.errors[i];
                        if (error.property === "HouseholdName" && error.choices.length === 1) {
                            group.groupName = error.choices[0].value;
                        }
                        if (error.choices.length === 1 && (error.choices[0].isValid || error.choices[0].isValid === null)) {
                            let x = group.errors.splice(i, 1)[0];
                            continue;
                        }
                        for (let j = error.choices.length - 1, k = 0; j > -1; j--) {
                            let choice = error.choices[j];
                            if (choice.isValid === false) k++;
                            if (k === error.choices.length) {
                                error.choices = [];
                                break;
                            }
                        }
                    }
                });
                hh.mclWizardTracking.setErrorCount(hh.list.status.length);
            }

            function checkForValidChoices(choices) {
                let valid = false;
                choices.forEach(function (choice) {
                    if (choice.isValid === true) {
                        valid = true;
                    }
                });
                return valid;
            }
        }

        function householdsTemplate() {
            return `<h1>{{hh.title}}</h1>
                        <div ng-if="!hh.opex_Consolidated_MCL_27768">
                            <p>This page displays any errors in columns B through Q where values do not match within your selected 
                            groupings.  Each value in a group can only have one selected answer and will create the household for 
                            all the accounts within it.</p>
                        </div>
                        <div ng-if="hh.opex_Consolidated_MCL_27768">
                            <p>This page displays any errors in columns B through Q where values do not match within your selected groupings. Each value in a group can only have one selected answer and will create the household for all the accounts within it.</p>
                            <p>For the consolidated MCL, this page will show any errors with columns B-D.</p>
                        </div>
                        <span ng-if="hh.viewStatus == 'loading'"><i class="fa fa-pulse fa-spinner fa-spin fa-3x" aria-hidden="true"></i>Checking for errors</span>
                        <span ng-if="hh.viewStatus == 'updating'"><i class="fa fa-pulse fa-spinner fa-spin fa-3x" aria-hidden="true"></i>Updating</span>
                        <ul ng-if="hh.viewStatus == 'loaded'" style='margin: 20px;'>
                            <li ng-repeat="status in hh.list.status" class="MCLfadeIn" style="margin:10px;font-size: x-large" >
                                <span ng-if="status.groupName">{{::status.groupName}}</span> 
                                <span ng-if="!status.groupName">Group {{::status.group}}</span> 
                                    has {{status.errors.length}} error<span ng-if="status.errors.length !== 1">s</span><br/>
                                <div ng-if="status.errors && status.errors.length>=1" class="MCLslideDown" style="font-size: small;" ng-init="group = status.group">
                                   <i>
                                       <span  style="color: red; font-size: small;">ERROR: Household information does not match  </span><a ng-click="hh.controls.fixItem=$index; hh.controls.collapsible=$index;">Edit</a>
                                   </i>
                                   <div ng-if="hh.controls.collapsible==$index" class="MCLslideDown" style="color: black; font-size: unset;">
                                       <table >
                                           <tr ng-repeat="error in status.errors">
                                               <td ng-if="error.choices.length>1||(error.choices.length===1&&error.choices[0].isValid==='true')">{{error.displayName}}</td><td ng-if="error.choices.length>1||(error.choices.length===1&&error.choices.isValid==='true')">
                                                   <select ng-model="error.choice" tooltip="{{hh.mclWizardToolTips.Households[error.property]}}">
                                                       <option value="" hidden>select one...</option>
                                                       <option ng-repeat="item in error.choices" ng-style="{color: {true:'black',false:'red'}[item.isValid]}" ng-disabled="item.isValid === false" ng-value="item">{{item.value}}</option>
                                                   </select>
                                               </td>
                                               <td ng-if="error.choices.length===1 && error.choices[0].isValid===false">{{error.choices[0].value}} is not a valid option for {{error.displayName}}.<br/> Please enter new value:</td>
                                               <td ng-if="error.choices.length===0">No valid option available for {{error.displayName}}.<br/> Please enter new value:</td>
                                               <td ng-if="error.property === 'HouseholdDOB' && (error.choices.length===0) || (error.choices.length===1 && error.choices[0].isValid===false)"><input type="text" class="ng-pristine ng-valid ng-isolate-scope ng-not-empty ng-valid-date ng-touched" ng-model="error.choice.value" max-date="regist.controls.today" datepicker-popup="" style="" tooltip="{{hh.mclWizardToolTips.Households[error.property]}}"></td>
                                               <td ng-if="error.property !== 'HouseholdDOB' && (error.choices.length===0) || (error.choices.length===1 && error.choices[0].isValid===false)"><input type="text" class="ng-pristine ng-valid ng-isolate-scope ng-not-empty ng-valid-date ng-touched" ng-model="error.choice.value" max-date="regist.controls.today" style="" tooltip="{{hh.mclWizardToolTips.Households[error.property]}}"></td>
                                           </tr>
                                       </table>
                                       <button ng-click="hh.controls.update($index, hh)">SAVE</button>
                                   </div>
                               </div>
                            </li>
                        </ul>
                    <span class="MCLfadeSwap" ng-if="hh.viewStatus == 'finished'"> NO ERRORS - PLEASE PROCEED. </span>
            `;

        }

        return obj;
    }

    function mclRepsObj() {
        let obj;
        obj = {
            bindings: {},
            controller: ['mclWizardServices', 'mclWizardTracking', 'mclWizardToolTips', repsCTRL],
            controllerAs: 'reps',
            template: repsTemplate
        };

        function repsCTRL(mclWizardServices, mclWizardTracking, mclWizardToolTips) {
            let reps = this;
            reps.mclWizardTracking = mclWizardTracking;
            reps.mclWizardToolTips = mclWizardToolTips;
            reps.title = "Representative Creation and Validation";
            reps.viewStatus = false;
            reps.controls = {
                fixItem: null,
                collapsible: null,
                sort: mclWizardServices.sort,
                getErrorList: mclWizardServices.getErrorList,
                retrieveList: mclWizardServices.retrieveList,
                update: update,
                showPopup: false,
                addRep: addRep
            };
            reps.list = {
                status: [],
                selected: '',
                representatives: [],
                brokers: [],
                newRep: {
                    fName: '',
                    lName: '',
                    broker: '',
                    repNum: ''
                }
            };

            // INIT
            (function () {
                reps.viewStatus = 'loading';
                reps.controls.retrieveList('/Portfolio/Representatives/Simple', {trackerMsg: 'Loading representatives'})
                    .then(function (res) {
                        reps.list.representatives = res.data;
                    })
                    .then(reps.controls.retrieveList('/Portfolio/BrokerDealers', {trackerMsg: 'Loading broker dealers'})
                        .then(function (res) {
                            reps.list.brokers = res.data
                        })
                    )
                    .then(
                        reps.controls.getErrorList(reps.mclWizardTracking.getCurrentImport().mclWizardInstanceId, 'Representative')
                            .then(function (res) {
                                reps.list.status = res.data;
                            })
                            .then(function () {
                                reps.viewStatus = (reps.list.status.length === 0) ? 'finished' : 'loaded';
                                reps.mclWizardTracking.setErrorCount(reps.list.status.length);
                            })
                    )
                ;

            })();

            function update(index, obj) {
                reps.viewStatus = 'updating';
                obj.list.selected = (typeof obj.list.selected === 'object')? obj.list.selected : JSON.parse(obj.list.selected);
                obj.list.status[index].updateId = obj.list.selected.id;
                obj.list.status[index].valueName = obj.list.selected.name;
                return mclWizardServices.update(obj.mclWizardTracking.getCurrentImport().mclWizardInstanceId, obj.list.status[index])
                    .then(function (res) {
                        if (res.status === 200) {
                            obj.list.status = res.data;
                        }
                    })
                    .then(function () {
                        reps.viewStatus = (reps.list.status.length === 0) ? 'finished' : 'loaded';
                        reps.mclWizardTracking.setErrorCount(reps.list.status.length);
                        reps.list.selected = '';
                        reps.controls.fixItem = null;
                        reps.controls.collapsible = null;
                    })
                    ;
            }

            function addRep(index, obj) {
                reps.viewStatus = 'updating';
                reps.controls.retrieveList('/Portfolio/Representatives/Verbose/New', {trackerMsg: 'Loading representatives'})
                    .then(function (res) {
                        let repObj = res.data;
                        repObj.portfolio.number = reps.list.newRep.repNum;
                        repObj.portfolio.name = reps.list.newRep.fName + " " + reps.list.newRep.lName;
                        repObj.portfolio.lastName = reps.list.newRep.lName;
                        repObj.portfolio.firstName = reps.list.newRep.fName;
                        repObj.portfolio.startDate = new Date();
                        repObj.portfolio.brokerDealerId = reps.list.newRep.broker.id;
                        reps.list.newRep = {fName: '', lName: '', broker: '', repNum: ''};
                        return repObj
                    })
                    .then(function (repObj) {
                        mclWizardServices.createRep(repObj)
                            .then(
                                function success(res) {
                                    obj.controls.retrieveList('/Portfolio/Representatives/Simple', {trackerMsg: 'Loading representatives'})
                                        .then(function success(r) {
                                            obj.list.representatives = r.data;
                                            obj.list.selected = {
                                                id : res.data.id,
                                                name : res.data.name
                                            }
                                        })
                                        .then(function () {
                                            update(index, obj)
                                                .then(function () {
                                                    obj.viewStatus = (obj.list.status.length === 0) ? 'finished' : 'loaded';
                                                })
                                        })
                                    ;
                                }
                            )
                    })
                ;
            }
        }

        function repsTemplate() {
            return `<h1>{{reps.title}}</h1>
                <p>This page allows you to create any representative needed for your database. Shared representatives can be listed with the following formats: and, /, &</p>
                <span ng-if="reps.viewStatus == 'loading'"><i class="fa fa-pulse fa-spinner fa-spin fa-3x" aria-hidden='true'></i>Checking for errors</span>
                <span ng-if="reps.viewStatus == 'updating'"><i class="fa fa-pulse fa-spinner fa-spin fa-3x" aria-hidden='true'></i>Updating</span>
                <ul ng-if="reps.viewStatus == 'loaded'" style="margin: 20px;">
                   <li ng-repeat="status in reps.list.status" class="MCLfadeIn" style="margin:10px;font-size: x-large">
                       {{::status.count}} account<span ng-if="status.count !== 1">s</span> using {{status.valueName}} <br/>
                       <div ng-show="status.id == null" style="font-size: small;">
                           <i>
                               <span  style='color: red; font-size: small; '>ERROR: This Representative does not exist. </span><a ng-click='reps.controls.fixItem=$index; reps.controls.collapsible=null;' >Edit</a> | <a ng-click='reps.controls.collapsible=$index; reps.controls.fixItem=null;'>Add New</a> 
                           </i>
                           <mcl-edit-obj display='reps.controls.fixItem==$index' list='reps.list.representatives' selected='reps.list.selected' update='reps.controls.update($index,reps)' index='status' close='reps.controls.fixItem'></mcl-edit-obj>
                           
                           <div ng-if='reps.controls.collapsible==$index' class='MCLslideDown' style='color: black; font-size: unset; '>
                               <label>First Name</label><input ng-model='reps.list.newRep.fName' tooltip='{{reps.mclWizardToolTips.Reps.RepFirstName}}'/>
                               <label>Last Name</label><input ng-model='reps.list.newRep.lName' tooltip='{{reps.mclWizardToolTips.Reps.RepLastName}}'/>
                               <label>Representative Number</label><input ng-model='reps.list.newRep.repNum' tooltip='{{reps.mclWizardToolTips.Reps.RepNumber}}'/></label>
                               <label>Broker/Dealer</label><select ng-options='broker as broker.name for broker in reps.list.brokers' ng-model='reps.list.newRep.broker' tooltip='{{reps.mclWizardToolTips.Reps.RepBroker}}'></select>
                               <br/><button ng-click='reps.controls.addRep($index, reps);' ng-disabled="reps.list.newRep.lName ==='' || reps.list.newRep.broker ==='' || reps.list.newRep.repNum ===''">Save</button><Button ng-click='reps.controls.collapsible=null'>Cancel</Button>
                           </div>
                       </div>
                   </li> 
                </ul>
                <span class='MCLfadeSwap' ng-if='reps.viewStatus == \"finished\"'> NO ERRORS - PLEASE PROCEED. </span>
                `;

        }

        return obj;
    }

    function mclRegTypesObj() {
        let obj;
        obj = {
            bindings: {},
            controller: ['mclWizardServices', 'mclWizardTracking', 'mclWizardToolTips', 'splitIoService', regTypesCTRL],
            controllerAs: 'reg',
            template: regTypesTemplate
        };

        function regTypesCTRL(mclWizardServices, mclWizardTracking, mclWizardToolTips, splitIoService) {
            let reg = this;
            reg.mclWizardTracking = mclWizardTracking;
            reg.mclWizardToolTips = mclWizardToolTips;
            reg.title = "Registration Type Creation and Verification";
            reg.viewStatus = false;
            reg.list = {
                status: [],
                registrations: [],
                selected: '',
                newReg: {
                    code: '',
                    description: ''
                }
            };
            reg.controls = {
                fixItem: null,
                collapsible: null,
                sort: mclWizardServices.sort,
                update: update,
                getErrorList: mclWizardServices.getErrorList,
                retrieveList: mclWizardServices.retrieveList,
                showPopup: false,
                addRegType: addRegType
            };
            // INIT
            (function () {
                reg.viewStatus = 'loading';
                // Get feature flag
                splitIoService.getBoolTreatment('opex_Consolidated_MCL_27768').subscribe(function (isEnabled) {
                    reg.opex_Consolidated_MCL_27768 = isEnabled;                      
                });
                reg.controls.retrieveList('/Portfolio/Registrations/Types', {trackerMsg: 'Loading registration types'})
                    .then(function (res) {
                        reg.list.registrations = sort(res.data);
                    })
                    .then(
                        reg.controls.getErrorList(reg.mclWizardTracking.getCurrentImport().mclWizardInstanceId, 'RegistrationType')
                            .then(function (res) {
                                reg.list.status = res.data;
                            })
                            .then(function () {
                                reg.viewStatus = (reg.list.status.length === 0) ? 'finished' : 'loaded';
                                reg.mclWizardTracking.setErrorCount(reg.list.status.length);
                            })
                    )
                ;
            })();

            function update(index, obj) {
                reg.viewStatus = 'updating';
                obj.list.selected = (typeof obj.list.selected === 'object')? obj.list.selected : JSON.parse(obj.list.selected);
                obj.list.status[index].updateId = obj.list.selected.id;
                obj.list.status[index].valueName = obj.list.selected.name;
                return mclWizardServices.update(obj.mclWizardTracking.getCurrentImport().mclWizardInstanceId, obj.list.status[index])
                    .then(function (res) {
                        if (res.status === 200) {
                            obj.list.status = res.data;
                        }
                    })
                    .then(function () {
                        reg.viewStatus = (reg.list.status.length === 0) ? 'finished' : 'loaded';
                        reg.mclWizardTracking.setErrorCount(reg.list.status.length);
                        reg.list.selected = '';
                        reg.controls.fixItem = null;
                        reg.controls.collapsible = null;
                    })
                    ;
            }

            function addRegType(index, obj) {
                reg.viewStatus = 'updating';
                let regTypeObj = {
                    "id": 0,
                    "sRegCode": reg.list.newReg.code,
                    "sRegDesc": reg.list.newReg.description,
                    "isQual": false,
                    "isira": false,
                    "is403b": false,
                    "isbira": false,
                    "includeInRMD": false,
                    "isDefault": false,
                    "planType": null,
                    "externalCode": null,
                    "socialCode": null,
                    "commonCode": null,
                    "category": null,
                    "benTypes": null,
                    "taxType" : null
                };
                reg.list.newReg = {code: '', description: ''};

                mclWizardServices.createRegistration(regTypeObj)
                    .then(function success(res) {
                        obj.controls.retrieveList('/Portfolio/Registrations/Types', {trackerMsg: 'Loading registration types'})
                            .then(function (r) {
                                reg.list.registrations = sort(r.data);
                                obj.list.selected = {id: res.data.id, name: res.data.name};
                            })
                            .then(function () {
                                update(index, obj)
                                    .then(function () {
                                        obj.viewStatus = (obj.list.status.length === 0) ? 'finished' : 'loaded';
                                    })
                            })
                        ;
                    }, function error(res) {
                        obj.controls.retrieveList('/Portfolio/Registrations/Types', {trackerMsg: 'Loading registration types'})
                            .then(function (r) {
                                reg.list.registrations = sort(r.data);
                                obj.list.selected = {id: res.data.id, name: res.data.name};
                            })
                            .then(
                                reg.controls.getErrorList(reg.mclWizardTracking.getCurrentImport().mclWizardInstanceId, 'RegistrationType')
                                    .then(function (res) {
                                        reg.list.status = res.data;
                                    })
                                    .then(function () {
                                        reg.viewStatus = (reg.list.status.length === 0) ? 'finished' : 'loaded';
                                    })
                            )
                        ;
                    })
                ;
            }

            function sort(data){
                data.sort(function(a,b){
                    return a.name.localeCompare(b.name);
                });
                return data;
            }
        }

        function regTypesTemplate() {
            return `<h1>{{reg.title}}</h1>
                <div ng-if="!reg.opex_Consolidated_MCL_27768">
                    <p>This page allows you to review and edit any registration types created from the MCL import.  
                    Columns R-W of the MCL allow you to specify the account owner's demographic information and the 
                    type of account (registration type) held in each registration. Registration types can appear on 
                    reports so the best practice is to list them as the type of account that exists in the 
                    registration.  Creating custom registration types that include client name is not recommended.</p>
                </div>
                <div ng-if="reg.opex_Consolidated_MCL_27768">
                    <p>This page allows you to review and edit any registration types created from the MCL import. 
                    Columns R-W of the MCL allow you to specify the account owner's demographic information and the 
                    type of account (registration type) held in each registration. Registration types can appear on 
                    reports so the best practice is to list them as the type of account that exists in the 
                    registration. Creating custom registration types that include client name is not recommended.</p>
                    <p>This step is not required for the consolidated MCL.</p>
                </div>
                <span ng-if="reg.viewStatus=='loading'"><i class="fa fa-pulse fa-spinner fa-spin fa-3x" aria-hidden="true"></i>Checking for errors</span>
                <span ng-if="reg.viewStatus == 'updating'"><i class="fa fa-pulse fa-spinner fa-spin fa-3x" aria-hidden="true"></i>Updating</span>
                <ul ng-if="reg.viewStatus=='loaded'" style="margin: 20px;">
                   <li ng-repeat="status in reg.list.status" class="MCLfadeIn" style="margin:10px;font-size: x-large">
                       {{::status.count}} account<span ng-if="status.count !== 1">s</span> using {{status.valueName}} <br/>
                       <div ng-show="status.id == null" style="font-size: small;">
                           <i>
                               <span  style="color: red; font-size: small;">ERROR: This registration type does not exist. </span><a ng-click="reg.controls.fixItem=$index; reg.controls.collapsible=null;" >Edit</a> | <a ng-click="reg.controls.collapsible=$index; reg.controls.fixItem=null;">Add New</a> 
                           </i>
                           <mcl-edit-obj display="reg.controls.fixItem==$index" list="reg.list.registrations" selected="reg.list.selected" update="reg.controls.update($index, reg)" index="status" close="reg.controls.fixItem" ></mcl-edit-obj>
                           <div ng-if="reg.controls.collapsible==$index" class="MCLslideDown" style="color: black; font-size: unset;">
                               <label>Registration Code</label><input ng-model="reg.list.newReg.code" tooltip="{{reg.mclWizardToolTips.RegTypes.code}}" maxlength="10"/>
                               <label>Registration Description</label><input ng-model="reg.list.newReg.description" tooltip="{{reg.mclWizardToolTips.RegTypes.desc}}"/>
                               <br/><button ng-click="reg.controls.addRegType($index, reg);" ng-disabled="reg.list.newReg.code === '' || reg.list.newReg.description === ''">Save</button><Button ng-click="reg.controls.collapsible=null">Cancel</Button>
                           </div>
                       </div>
                   </li> 
                </ul>
                <span class="MCLfadeSwap" ng-if="reg.viewStatus=='finished'"> NO ERRORS - PLEASE PROCEED. </span>
                `;
        }

        return obj;
    }

    function mclCustodiansObj() {
        let obj;
        obj = {
            bindings: {},
            controller: ['mclWizardServices', 'mclWizardTracking', 'mclWizardToolTips', custodiansCTRL],
            controllerAs: 'cust',
            template: custodiansTemplate
        };

        function custodiansCTRL(mclWizardServices, mclWizardTracking, mclWizardToolTips) {
            let cust = this;
            cust.mclWizardTracking = mclWizardTracking;
            cust.mclWizardToolTips = mclWizardToolTips;
            cust.title = "Custodian Creation and Verification";
            cust.viewStatus = false;
            cust.list = {
                status: [],
                custodians: [],
                selected: '',
                sweepAssetClass: {},
                feeReqSrc: {
                    none: {name: 'Not set', value: "0"},
                    highValueFund: {name: 'High value fund', value: "1"},
                    cashAccount: {name: 'Cash account', value: "2"},
                    proRata: {name: 'Pro-Rata', value: "3"}
                },
                newCustodian: {
                    name: '',
                    ProductClasses: ''
                }
            };
            cust.controls = {
                fixItem: null,
                collapsible: null,
                sort: mclWizardServices.sort,
                update: update,
                addCustodian: addCustodian,
                getErrorList: mclWizardServices.getErrorList,
                retrieveList: mclWizardServices.retrieveList,
                showPopup: false
            };
            // INIT
            (function () {
                cust.viewStatus = 'loading';
                cust.controls.retrieveList('/Portfolio/ProductClasses/Simple', {trackerMsg: 'Loading product classes'})
                    .then(function (res) {
                        cust.list.ProductClasses = res.data;
                    })
                ;
                cust.controls.retrieveList('/Portfolio/Custodians/Simple', {trackerMsg: 'Loading custodians'})
                    .then(function (res) {
                        cust.list.custodians = res.data;
                    })
                    .then(
                        cust.controls.getErrorList(cust.mclWizardTracking.getCurrentImport().mclWizardInstanceId, 'Custodian')
                            .then(function (res) {
                                cust.list.status = res.data;
                            })
                            .then(function () {
                                cust.viewStatus = (cust.list.status.length === 0) ? 'finished' : 'loaded';
                                cust.mclWizardTracking.setErrorCount(cust.list.status.length);
                            })
                    )
                ;
            })();

            function update(index, obj) {
                cust.viewStatus = 'updating';
                obj.list.selected = (typeof obj.list.selected === 'object')? obj.list.selected : JSON.parse(obj.list.selected);
                obj.list.status[index].updateId = obj.list.selected.id;
                obj.list.status[index].valueName = obj.list.selected.name;
                return mclWizardServices.update(obj.mclWizardTracking.getCurrentImport().mclWizardInstanceId, obj.list.status[index])
                    .then(function (res) {
                        if (res.status === 200) {
                            obj.list.status = res.data
                        }

                    })
                    .then(function () {
                        cust.viewStatus = (cust.list.status.length === 0) ? 'finished' : 'loaded';
                        cust.mclWizardTracking.setErrorCount(cust.list.status.length);
                        cust.list.selected = '';
                        cust.controls.fixItem = null;
                        cust.controls.collapsible = null;
                    })
                    ;
            }

            function addCustodian(index, obj) {
                cust.viewStatus = 'updating';
                mclWizardServices.retrieveList('/Portfolio/Custodians/Verbose/New', {trackerMsg: 'Loading new custodian template'})
                    .then(function (res) {
                        let custodianObj = res.data;
                        custodianObj.portfolio.name = cust.list.newCustodian.name;
                        custodianObj.portfolio.sweepProductClassId = cust.list.newCustodian.ProductClasses.id;
                        custodianObj.portfolio.feeReqSrc = cust.list.feeReqSrc.none.name;
                        cust.list.newCustodian = {name: '', ProductClasses: '', feeReqSrc: ''};
                        return custodianObj;
                    })
                    .then(function (custodianObj) {
                        return mclWizardServices.createCustodian(custodianObj);
                    })
                    .then(
                        function success(res) {
                            obj.controls.retrieveList('/Portfolio/Custodians/Simple', {trackerMsg: 'Loading custodians'})
                                .then(function (r) {
                                    obj.list.custodians = r.data;
                                    obj.list.selected = {id: res.data.id, name: res.data.name};
                                })
                                .then(function () {
                                    return update(index, obj);
                                })
                                .then(function () {
                                    return cust.controls.getErrorList(cust.mclWizardTracking.getCurrentImport().mclWizardInstanceId, 'Custodian');
                                })
                                .then(function (res) {
                                    cust.controls.collapsible = null;
                                    cust.list.newCustodian = {
                                        name: '',
                                        ProductClasses: ''
                                    };
                                    cust.list.status = res.data;
                                    cust.viewStatus = (cust.list.status.length === 0) ? 'finished' : 'loaded';
                                });
                        },
                        function error(err) {
                            obj.controls.retrieveList('/Portfolio/Custodians/Simple', {trackerMsg: 'Loading custodians'})
                                .then(function (r) {
                                    obj.list.custodians = r.data;
                                    obj.list.selected = {id: '', name: ''};
                                })
                                .then(function(){
                                    return cust.controls.getErrorList(cust.mclWizardTracking.getCurrentImport().mclWizardInstanceId, 'Custodian')
                                })
                                .then(function (res) {
                                    cust.controls.collapsible = null;
                                    cust.list.newCustodian = {
                                        name: '',
                                        ProductClasses: ''
                                    };
                                    cust.list.status = res.data;
                                    cust.viewStatus = (cust.list.status.length === 0) ? 'finished' : 'loaded';
                                });
                        })
                ;
            }
        }

        function custodiansTemplate() {
            return `<h1>{{cust.title}}</h1>
                <p>Custodian is a field that allows you to notate the custodian for each account in the system.
                This differs from fund family in that custodians can be created in Orion and do not need to match
                 the download source. Orion’s best practice is to have custodian match fund family unless that 
                fund family is a data aggregator.  If you are using DST or DTCC you can use the custodian
                 to reflect the actual custodian the account is held at within those download sources.</p>
                <p>This page allows you to create or edit any custodian provided on your Master Client List.  </p>
                <span ng-if="cust.viewStatus == 'loading'"><i class="fa fa-pulse fa-spinner fa-spin fa-3x" aria-hidden="true"></i>Checking for errors</span>
                <span ng-if="cust.viewStatus == 'updating'"><i class="fa fa-pulse fa-spinner fa-spin fa-3x" aria-hidden="true"></i>Updating</span>
                <ul ng-if="cust.viewStatus == 'loaded'" style="margin: 20px;">
                   <li ng-repeat="status in cust.list.status" class="MCLfadeIn" style="margin:10px;font-size: x-large">
                       {{::status.count}} account<span ng-if="status.count !== 1">s</span> using {{status.valueName}} <br/>
                       <div ng-show="status.id == null" style="font-size: small;">
                           <i>
                               <span  style="color: red; font-size: small;">ERROR: This custodian does not exist. </span><a ng-click="cust.controls.fixItem=$index; cust.controls.collapsible=null;">Edit</a> | <a ng-click="cust.controls.collapsible=$index; cust.controls.fixItem=null;">Add New</a>
                           </i>
                           <mcl-edit-obj display="cust.controls.fixItem==$index" list="cust.list.custodians" selected="cust.list.selected" update="cust.controls.update($index, cust)" index="status" close="cust.controls.fixItem"></mcl-edit-obj>
                           <div ng-if="cust.controls.collapsible==$index" class="MCLslideDown" style="color: black; font-size: unset;">
                               <label>Name</label><input ng-model="cust.list.newCustodian.name" tooltip="{{cust.mclWizardToolTips.Custodians.name}}"/>
                               <!--Leaving the following commented out in case they decide they want these back later. TODO: remove before build-->
                               <label>Sweep Asset Class</label><select ng-options="item as item.name for item in cust.list.ProductClasses" ng-model="cust.list.newCustodian.ProductClasses" tooltip="{{cust.mclWizardToolTips.Custodians.sweepAssetClass}}"></select><br/>
                               <!--<label>Fee Request Source</label><select ng-options="item as item.name for item in cust.list.feeReqSrc" ng-model="cust.list.newCustodian.feeReqSrc" tooltip="{{cust.mclWizardToolTips.Custodians.feeRequestSource}}"/>-->
                               <br/><button ng-click="cust.controls.addCustodian($index, cust);" ng-disabled="cust.list.newCustodian.name === '' || cust.list.newCustodian.ProductClasses === '' ">Save</button><Button ng-click="cust.controls.collapsible=null">Cancel</Button>
                           </div>
                       </div>
                   </li> 
                </ul>
                <span class="MCLfadeSwap" ng-if="cust.viewStatus=='finished'"> NO ERRORS - PLEASE PROCEED. </span>
                `;
        }

        return obj;
    }

    function mclFundFamiliesObj() {
        let obj;
        obj = {
            bindings: {},
            controller: ['mclWizardServices', 'mclWizardTracking', '$dialog', fundFamiliesCTRL],
            controllerAs: 'fundF',
            template: fundFamiliesTemplate
        };

        function fundFamiliesCTRL(mclWizardServices, mclWizardTracking, $dialog) {
            let fundF = this;
            fundF.mclWizardTracking = mclWizardTracking;
            fundF.title = "Fund Family Verification";
            fundF.list = {
                status: [],
                custodians: [],
                selected: '',
                globalFundFamilies: [],
                localFundFamilies: [],
                fundFamilyBeforeChanges: []
            };
            fundF.controls = {
                fixItem: null,
                collapsible: null,
                sort: mclWizardServices.sort,
                update: update,
                updateFundFamilies: updateFundFamilies,
                getErrorList: mclWizardServices.getErrorList,
                retrieveList: mclWizardServices.retrieveList,
                showPopup: false
            };
            // INIT
            (function () {
                fundF.loading = true;
                fundF.controls.retrieveList('/Portfolio/FundFamilies/Simple', {trackerMsg: 'Loading fund families'})
                    .then(function (res) {
                        fundF.list.FundFamilies = res.data;
                    })
                    .then(
                        fundF.controls.getErrorList(fundF.mclWizardTracking.getCurrentImport().mclWizardInstanceId, 'FundFamily')
                            .then(function (res) {
                                fundF.list.status = res.data;
                                fundF.mclWizardTracking.setErrorCount(fundF.list.status.length);
                            })
                    ).then(
                    loadUpdateData()
                )
                    .then(function () {
                        fundF.loading = false;
                        fundF.loaded = true;
                    });
            })();

            function update(index, obj) {
                fundF.viewStatus = 'updating';
                obj.list.selected = (typeof obj.list.selected === 'object')? obj.list.selected : JSON.parse(obj.list.selected);
                obj.list.status[index].updateId = obj.list.selected.id;
                obj.list.status[index].valueName = obj.list.selected.name;
                mclWizardServices.update(obj.mclWizardTracking.getCurrentImport().mclWizardInstanceId, obj.list.status[index])
                    .then(function (res) {
                        if (res.status === 200) {
                            obj.list.status = res.data;
                        }
                        fundF.mclWizardTracking.setErrorCount(fundF.list.status.length);
                        fundF.list.selected = '';
                        fundF.controls.fixItem = null;
                        fundF.controls.collapsible = null;
                        fundF.viewStatus = 'loading';
                    });
            }

            function loadUpdateData() {
                return fundF.controls.retrieveList('/Global/FundFamilies', {trackerMsg: 'Loading fund families'})
                    .then(function (res) {
                        fundF.list.globalFundFamilies = res.data.sort();
                    }).then(
                        fundF.controls.retrieveList('/Portfolio/FundFamilies', {trackerMsg: 'Loading fund families'})
                            .then(function (res) {
                                fundF.list.localFundFamilies = res.data.sort();
                                fundF.list.fundFamilyBeforeChanges = angular.copy(res.data.sort());
                            })
                    )
            }

            function updateFundFamilies(index) {
                let deletes = [], adds = [], reviewItems = [];
                fundF.list.fundFamilyBeforeChanges.forEach(function (item) {
                    if (!fundF.list.localFundFamilies.some(function (target) {
                        return target.id === item.id;
                    })) {
                        reviewItems.push({
                            id: item.id,
                            name: item.name,
                            action: "Delete",
                            status: "Pending",
                            errorMessage: ""
                        });
                    }
                });
                fundF.list.localFundFamilies.forEach(function (item) {
                    if (!fundF.list.fundFamilyBeforeChanges.some(function (target) {
                        return target.id === item.id;
                    })) {
                        reviewItems.push({
                            id: item.id,
                            name: item.name,
                            action: "Add",
                            status: "Pending",
                            errorMessage: ""
                        });
                    }
                });
                if (reviewItems.length > 0) {
                    var dialogOpts = {
                        templateUrl: "portfolio/modals/fundFamilyChangesReview.html",
                        resolve: {
                            reviewItems: function () {
                                return reviewItems;
                            }
                        },
                        controller: "fundFamilyChangesReviewCtrl",
                        dialogClass: "modal wide",
                        height: "600px"
                    };
                    $dialog.dialog(dialogOpts).open()
                        .then(function (result) {
                            if (result) {
                                loadUpdateData();
                                fundF.controls.retrieveList('/Portfolio/FundFamilies/Simple', {trackerMsg: 'Loading fund families'})
                                    .then(function (res) {
                                        fundF.list.FundFamilies = res.data;
                                        fundF.controls.collapsible = null;
                                        fundF.controls.fixItem = index;
                                    })
                            }
                        });
                } else {
                    $dialog.messageBox("", "No Changes.").open();
                }
            }
        }

        function fundFamiliesTemplate() {
            return `<h1>{{fundF.title}}</h1>
                <p>Fund families notate the download source for your accounts. The Fund Families screen will display 
                any fund families listed in the Master Client List that do not exist within the database. New fund 
                families cannot be created, so you must select from the existing list found on the MCL template. If 
                there are unidentified fund families listed below, and you are unable to find the fund name you wish 
                to use for your accounts, you may select Other as a placeholder and work with Orion to find a suitable 
                choice after the import is complete.</p>
                <span ng-if="fundF.loading"><i class="fa fa-pulse fa-spinner fa-spin fa-3x" aria-hidden="true"></i>Checking for errors</span>
                <ul ng-if="fundF.loaded" style="margin: 20px;">
                   <li ng-repeat="status in fundF.list.status" class="MCLfadeIn" style="margin:10px;font-size: x-large">
                       {{::status.count}} account<span ng-if="status.count !== 1">s</span> using {{status.valueName}} <br/>
                       <div ng-show="status.id == null" style="font-size: small;">
                           <i>
                               <span  style="color: red; font-size: small;">ERROR: This Fund Family does not exist. </span><a ng-click="fundF.controls.fixItem=$index; fundF.controls.collapsible=null;" >Edit</a> | <a ng-click="fundF.controls.collapsible=$index; fundF.controls.fixItem=null;">Modify List</a>
                           </i>
                           <mcl-edit-obj display="fundF.controls.fixItem==$index" list="fundF.list.FundFamilies" selected="fundF.list.selected" update="fundF.controls.update($index, fundF)" index="status" close="fundF.controls.fixItem"></mcl-edit-obj>
                           <div ng-if="fundF.controls.collapsible==$index" class="MCLslideDown" style="color: black; font-size: unset;">
                               <available-selected style="height: 250px" selected-entity="1979" items="fundF.list.globalFundFamilies" selection-type-name="Fund Families" enable-titles="true" name="name" sel-items="fundF.list.localFundFamilies"></available-selected>
                               <br/><button ng-click="fundF.controls.updateFundFamilies($index)">Save</button><Button ng-click="fundF.controls.collapsible=null">Cancel</Button>
                           </div>
                       </div>
                   </li> 
                </ul>
                <span class="MCLfadeSwap" ng-if="fundF.loaded && fundF.mclWizardTracking.getErrorCount() === 0"> NO ERRORS - PLEASE PROCEED. </span>
                `;
        }

        return obj;
    }

    function mclRegistrationsObj() {
        let obj;
        obj = {
            bindings: {},
            controller: ['mclWizardServices', 'mclWizardTracking', 'splitIoService', registrationsCTRL],
            controllerAs: 'regist',
            template: registrationsTemplate
        };

        function registrationsCTRL(mclWizardServices, mclWizardTracking, splitIoService) {
            let regist = this;
            regist.mclWizardTracking = mclWizardTracking;
            regist.title = "Registration Level Information";
            regist.list = {
                status: []
            };
            regist.controls = {
                fixItem: null,
                collapsible: null,
                update: update,
                getErrorList: mclWizardServices.getErrorList,
                retrieveList: mclWizardServices.retrieveList,
                showPopup: false,
                today: new Date()
            };
            //INIT
            (function () {
                regist.loading = true;
                // Get feature flag
                splitIoService.getBoolTreatment('opex_Consolidated_MCL_27768').subscribe(function (isEnabled) {
                    regist.opex_Consolidated_MCL_27768 = isEnabled;                      
                });
                regist.controls.getErrorList(regist.mclWizardTracking.getCurrentImport().mclWizardInstanceId, 'Registration')
                    .then(function (res) {
                        regist.list.status = res.data;
                        regist.mclWizardTracking.setErrorCount(regist.list.status.length);

                    })
                    .then(function () {
                        regist.loading = false;
                        regist.loaded = true;
                    })
            })();

            function update(index, obj) {
                mclWizardServices.registrationUpdate(obj.mclWizardTracking.getCurrentImport().mclWizardInstanceId, obj.list.status[index])
                    .then(function (res) {
                        if (res.status === 200) {
                            obj.list.status = res.data;
                        }
                        regist.mclWizardTracking.setErrorCount(regist.list.status.length);
                        regist.controls.fixItem = null;
                        regist.controls.collapsible = null;
                    });
            }
        }

        function registrationsTemplate() {
            return `<br/><h1>{{regist.title}}</h1>
                <div ng-if="!regist.opex_Consolidated_MCL_27768">
                    <p>This page will show you any issues in columns R through W.  These columns are account based 
                    information and should reflect the actual account owner information rather than the household 
                    group.</p>
                </div>
                <div ng-if="regist.opex_Consolidated_MCL_27768">
                    <p>This page will show you any issues in columns R through W. These columns are account based 
                    information and should reflect the actual account owner information rather than the household 
                    group.</p>
                    <p>For the consolidated MCL, this page will show any issues with columns E-F.</p>
                </div>
                <span ng-if="regist.loading"><i class="fa fa-pulse fa-spinner fa-spin fa-3x" aria-hidden="true"></i>Checking for errors</span>
                <ul ng-if="regist.loaded" style="margin: 20px;">
                   <li ng-repeat="status in regist.list.status" class="MCLfadeIn" style="margin:10px;font-size: x-large">
                       {{::status.error}} <br/>
                       <div ng-show="status.id == null" style="font-size: small;">
                           <i>
                               <span  style="color: red; font-size: small;"></span><a ng-click="regist.controls.collapsible=$index;" >Edit</a>
                           </i>
                           <div ng-if="regist.controls.collapsible==$index" class="MCLslideDown" style="color: black; font-size: unset;">
                               <label>{{::status.property}}</label>
                               <input ng-if="status.property=='RegistrationDOB'" type="text" class="ng-pristine ng-valid ng-isolate-scope ng-not-empty ng-valid-date ng-touched" ng-model="status.value" max-date="regist.controls.today" datepicker-popup="" style="">
                               <input ng-if="status.property=='RegistrationSSN'" type="text" ng-model="status.value" ssn-format ng-model-options="{updateOn: 'default'}"/>
                               <br/><button ng-click="regist.controls.update($index, regist)">Save</button>
                           </div>
                       </div>
                   </li> 
                </ul>
                <span class="MCLfadeSwap" ng-if="regist.loaded && regist.list.status.length == 0"> NO ERRORS - PLEASE PROCEED. </span>
                `;
        }

        return obj;
    }

    //MISC COMPONENTS
    function mclEditObj() {
        return {
            bindings: {
                display: '=',
                list: '<',
                selected: '=',
                close: '=',
                index: '<',
                update: '&'
            },
            template: ` <div ng-if='$ctrl.display' class='MCLslideDown'>
                            <select ng-model="$ctrl.selected">
                                <option value="" hidden>select one...</option>
                                <option ng-repeat="item in $ctrl.list" ng-value="item">{{item.name}}</option>
                            </select>
                           <br/><button ng-click='$ctrl.update()' ng-disabled="$ctrl.selected === ''">Save</button><Button ng-click='$ctrl.close=null'>Cancel</Button>
                       </div>`
        };
    }

    //DIRECTIVES
    function mclDateFormat($filter, $browser) {
        return {
            require: 'ngModel',
            link: function ($scope, $element, $attrs, ngModelCtrl) {

                function mclDateFormat(date) {
                    if (!date) {
                        return '';
                    }
                    return date.split('T')[0];
                }

                var listener = function () {
                    $element.val(mclDateFormat($element.val()));
                };

                // This runs when we update the text field
                ngModelCtrl.$parsers.push(function (viewValue) {
                    return mclDateFormat(viewValue);
                });

                // This runs when the model gets updated on the scope directly and keeps our view in sync
                ngModelCtrl.$render = function () {
                    $element.val(mclDateFormat(ngModelCtrl.$viewValue));
                };

                $element.bind('change', listener);
                $element.bind('keydown', function (event) {
                    var key = event.keyCode;
                    // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
                    // This lets us support copy and paste too
                    if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
                        return;
                    }
                    $browser.defer(listener); // Have to do this or changes don't get picked up properly
                });

                $element.bind('paste cut', function () {
                    $browser.defer(listener);
                });
            }

        };
    }

    function mclSsnFormat($filter, $browser) {
        return {
            require: 'ngModel',
            link: function ($scope, $element, $attrs, ngModelCtrl) {

                function ssnFilter(ssn) {
                    if (!ssn) {
                        return '';
                    }
                    var value = ssn.toString().trim().replace(/[^0-9]/g, '').replace(/^\+/, '');
                    if (value.match(/[^0-9]/)) return ssn;
                    var three = value.slice(0, 3);
                    var six = value.slice(3);
                    if (six) {
                        if (six.length > 2) six = six.slice(0, 2) + '-' + six.slice(2, 6);
                        return (three + "-" + six).trim();
                    } else return three;
                }

                var listener = function () {
                    $element.val(ssnFilter($element.val()));
                };

                // This runs when we update the text field
                ngModelCtrl.$parsers.push(function (viewValue) {
                    return ssnFilter(viewValue);
                });

                // This runs when the model gets updated on the scope directly and keeps our view in sync
                ngModelCtrl.$render = function () {
                    $element.val(ssnFilter(ngModelCtrl.$viewValue));
                };

                $element.bind('change', listener);
                $element.bind('keydown', function (event) {
                    var key = event.keyCode;
                    // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
                    // This lets us support copy and paste too
                    if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
                        return;
                    }
                    $browser.defer(listener); // Have to do this or changes don't get picked up properly
                });

                $element.bind('paste cut', function () {
                    $browser.defer(listener);
                });
            }

        };
    }
})();

(function(){
    'use strict';
    app
    //ANIMATIONS
        .animation('.MCLlistAnimations', MCLlistAnimations)
        .animation('.MCLslideDown', MCLslideDown)
        .animation('.MCLfadeIn', MCLfadeIn)
        .animation('.MCLfadeSwap', MCLfadeSwap)
    ;

    //ANIMATIONS
    function MCLlistAnimations() {
        return {
            enter: function (element, done) {
                let offset = element[0].rowIndex;
                element.css('display', 'none');
                setTimeout(function () {
                    $(element).fadeIn(750, function () {
                        done();
                    });
                }, offset * 100);
            },
            move: function (element, done) {
            },
            leave: function (element, done) {
                $(element).fadeOut(500, function () {
                    done();
                });
            }
        }
    }

    function MCLslideDown() {
        return {
            enter: function (element, done) {
                element.css('display', 'none');
                setTimeout(function () {
                    $(element).slideDown(500, function () {
                        done();
                    });
                }, 250);
            },
            leave: function (element, done) {
                $(element).slideUp(225, function () {
                    done();
                });
            }
        }
    }

    function MCLfadeIn() {
        return {
            enter: function (element, done) {
                element.css('display', 'none');
                $(element).fadeIn(200, function () {
                    done();
                });
            },
            leave: function (element, done) {
                $(element).fadeOut(300, function () {
                    done();
                });
            }
        }
    }

    function MCLfadeSwap() {
        return {
            enter: function (element, done) {
                element.css('display', 'none');
                setTimeout(function () {
                    $(element).fadeIn(300, function () {
                        done();
                    });
                }, 350);
            },
            leave: function (element, done) {
                $(element).fadeOut(0, function () {
                    done();
                });
            }
        }
    }
})();
// *0Orion!
// $oasRights
// $scope.rightsCustodian = $oasRights.forCode('CUSTODIAN');
(function () {
    'use strict';
    app
    //MAIN CONTROLLER
        .controller('MasterClientListWizardCtrl', CTRL)
    ;

    CTRL.$inject = ['mclWizardTracking', 'mclWizardServices', '$location', '$oasRights', '$dialog', '$timeout'];

    //MAIN CONTROLLER
    function CTRL(mclWizardTracking, mclWizardServices, $location, $oasRights, $dialog, $timeout) {
        let vm = this;
        vm.rightMclWizard = $oasRights.forCode("MASTERCLIENTLISTWIZARD");
        //VARIABLES
        vm.mclWizardTracking = mclWizardTracking;
        vm.mclWizardServices = mclWizardServices;
        vm.show = 'loading';
        vm.pendingDelete = null;
        vm.steps = [
            {id: 'fileUpload', name: 'File Upload', index: 0, percentComplete: 0},
            {id: 'Household', name: 'Households', index: 1, percentComplete: 12.5, mclShowInHeader: true},
            {id: 'Representative', name: 'Representatives', index: 2, percentComplete: 25, mclShowInHeader: true},
            {id: 'Registration Type', name: 'Registration Types', index: 3, percentComplete: 37.5, mclShowInHeader: true},
            {id: 'Custodian', name: 'Custodians', index: 4, percentComplete: 50, mclShowInHeader: true},
            {id: 'Fund Family', name: 'Fund Families', index: 5, percentComplete: 62.5, mclShowInHeader: true},
            {id: 'Registration', name: 'Registrations', index: 6, percentComplete: 75, mclShowInHeader: true},
            {id: 'Summary', name: 'Summary', index: 7, percentComplete: 87.5}
        ];
        vm.list = {
            pending: [],
            completed: []
        };

        //PUBLIC METHODS
        vm.controls = {
            loadList: loadList,
            exportFile: exportFile,
            getProgress: getProgress,
            deleteRecord: deleteRecord,
            toggleWizard: toggleWizard,
        };
        vm.nav = {
            next: next,
            goto: goto
        };

        // INIT
        (function () {
            vm.mclWizardTracking.setCurrentStep(vm.steps[0]);
            loadList();
        })();

        //METHOD DEFINITIONS

        function next() {
            vm.mclWizardTracking.setErrorCount(1);
            let step = vm.steps[(vm.mclWizardTracking.getCurrentStep()).index + 1];

            if (step.id === 'Summary') {
                goto(step.id);
                return;
            }
            vm.mclWizardTracking.setCurrentStep(step);
        }

        function goto(step) {
            if (vm.pendingDelete) return;
            if (step === 'Summary' || step === 'Complete') {
                $location.path('/portfolio/newaccounts/mclWizard/' + vm.mclWizardTracking.getCurrentImport().mclWizardInstanceId);
                return;
            }
            if (typeof step === 'string') {
                vm.steps.forEach(function (obj, index) {
                    if (obj.id === step) {
                        step = vm.steps[index];
                    }
                });
            }
            vm.mclWizardTracking.setCurrentStep(step);
            if (vm.show !== 'wizard') {
                vm.show = 'wizard';
            }
        }

        function toggleWizard() {
            vm.mclWizardTracking.setCurrentStep(vm.steps[0]);
            vm.show = (vm.show === 'wizard') ? 'list' : 'wizard';
        }

        function getProgress(step) {
            let pc = 0;
            vm.steps.forEach(function (i) {
                if (step.currentStep === i.id) pc = i.percentComplete
            });
            return pc;
        }

        function loadList() {
            vm.list.pending = [];
            vm.list.completed = [];
            vm.mclWizardServices.retrieveList('/Portfolio/ValidateImport/MasterClientListWizard', {trackerMsg: 'Loading import list'})
                .then(function (res) {
                    let completed = [];
                    res.data.forEach(function (r) {
                        r.percentComplete = (r.completed)? 100 : getProgress(r);
                        r.currentStep = (r.completed)? 'Complete' : r.currentStep;
                        (r.currentStep === "Complete")?completed.push(r):vm.list.pending.push(r);
                    });
                    vm.list.pending.sort(sortIdDesc);
                    completed.sort(sortIdDesc);
                    completed.forEach(function (i) {vm.list.pending.push(i);});
                    vm.show = "list";
                })
            ;
        }

        function exportFile() {
            let id = vm.mclWizardTracking.getCurrentImport().mclWizardInstanceId;
            window.location.href = '/api/v1/Portfolio/ValidateImport/MasterClientListWizard/' + id + '/Export' + '?Authorization=' + sessionStorage.oas_token;
        }

        function deleteRecord(i) {
            if (vm.pendingDelete) return;
            vm.pendingDelete = i;
            $dialog.confirmAction("Are you sure you want to remove this unfinished import?")
                .open()
                .then(function (result) {
                        if (result === 'yes') {
                            vm.mclWizardServices.delete(vm.list.pending[i].mclWizardInstanceId)
                                .then(function (res) {
                                    if (res.status === 204) {
                                        vm.list.pending.splice(i, 1);
                                    }
                                    vm.pendingDelete = null;
                                })
                            ;
                        }
                        vm.pendingDelete = null;
                    }
                );
        }

        function sortIdDesc(a,b){
            if(a.mclWizardInstanceId > b.mclWizardInstanceId) return -1;
            if(a.mclWizardInstanceId < b.mclWizardInstanceId) return 1;
            return 0;
        }
    }
})();



(function(){
    'use strict';
    app
        .controller('MasterClientListWizardSummaryCtrl',CTRL);
    function CTRL($scope, views, $oasRights, $routeParams, $http, $location, entities, $portfolio, apps, API_CONFIG){

        $scope.summary = {
            id:$routeParams.id,
            instanceData:{},
            exportFile:exportFile,
            commitUpload:commitUpload,
            goToHigher:goToHigher,
            openAccountEditor:openAccountEditor,
            openRegistrationEditor:openRegistrationEditor,
            openHouseholdEditor:openHouseholdEditor
        };
        $scope.rights={};
        $scope.selectedIds = [];
        $scope.views = views;
        $scope.current = {
            view: views[0],
            loadUrl: '/Portfolio/ValidateImport/MasterClientListWizard/' + $scope.summary.id + '/Summary',
            selectedHouseholdId : 0,
            selectedRegistrationId : 0,
            selectedAccountId : 0,
            showContextMenu : true
        };
        $scope.importing = false;

        //INIT
        (function(){
            getInstanceDetails()
                .then(function(res){
                    $scope.summary.instanceData = res;
                });

            $scope.rights={
                household : $oasRights.forCode("CLIENTS"),
                registration : $oasRights.forCode("REGISTRATIONS"),
                account : $oasRights.forCode("ACCOUNTS")
            };
        })();


        // PUBLIC
        function exportFile(){
            $scope.$broadcast('event:mcl-wizard-action', {action: 'export-data'});
        }

        function commitUpload() {
            $scope.importing = true;
            $http.post('/Portfolio/ValidateImport/MasterClientListWizard/'+$scope.summary.id+'/Commit', {trackerMsg:'Uploading Final Import'})
                .then(
                    function success(){
                        $location.path('/portfolio/newaccounts/mclWizard');
                    },
                    function error(err){
                    }
                )
            ;
        }

        function goToHigher( urlLevel ) {
            if( urlLevel === 'households' && $scope.current.selectedHouseholdId > 0 ) {
                $portfolio.goTo( urlLevel, entities.client.value, $scope.current.selectedHouseholdId);
            } else if( urlLevel === 'registrations' && $scope.current.selectedRegistrationId > 0 ) {
                $portfolio.goTo( urlLevel, entities.registration.value, $scope.current.selectedRegistrationId);
            } else if( urlLevel === 'accounts' && $scope.current.selectedAccountId > 0 ) {
                $portfolio.goTo( urlLevel, entities.account.value, $scope.current.selectedAccountId);
            }
        }

        function openAccountEditor( isNewAccount, defaultTabNameOverride, defaultTabCodeOverride ) {
            if( $scope.selectedIds.length === 1 || isNewAccount ) {
                $portfolio.openEditor( entities.account.value,
                    $scope.current.selectedAccountId,
                    defaultTabNameOverride, defaultTabCodeOverride, apps.portfolioLists.name, null ).then(function(rslt) {
                    if( rslt ) {
                        $scope.$broadcast( 'event:mcl-wizard-action', {action: rslt.isNew ? 'add-item' : 'update-item', item: rslt } );
                    }
            });
            } else {
                $portfolio.openMassEditor( entities.account.value, $scope.selectedIds, apps.portfolioLists.name, null ).then(function(rslt) {
                    if( rslt ) {
                        $scope.$broadcast( 'event:mcl-wizard-action', {action: 'update-items', items: rslt } );
                    }
                });
            }
        }

        function openRegistrationEditor() {
            $portfolio.openEditor(entities.registration.value, $scope.current.selectedRegistrationId, null, null, apps.newAccount.name, null)
                .then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:new-accounts', {action: 'update-items', items: rslt});
                    }
                });
        }

        function openHouseholdEditor() {
            $portfolio.openEditor(entities.client.value, $scope.current.selectedHouseholdId, null, null, apps.newAccount.name)
                .then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:new-accounts', {action: 'update-items', items: rslt});
                    }
                });
        }

        //Event Listeners
        $scope.$on("event:mcl-wizard-select", function(e, args) {
            if( args.length === 0 ) return;
            setOnRowSelect(args);
        });

        // PRIVATE
        function setOnRowSelect(args){
            $scope.current.selectedHouseholdId = [args[0].clientId];
            $scope.current.selectedRegistrationId = [args[0].registrationID];
            $scope.current.selectedAccountId = [args[0].accountID];
            $scope.current.showContextMenu = (
                $scope.current.selectedHouseholdId > 0 ||
                $scope.current.selectedRegistrationId > 0 ||
                $scope.current.selectedAccountId > 0
            );
        }
        function getInstanceDetails(){
            return $http.get('/Portfolio/ValidateImport/MasterClientListWizard/'+$scope.summary.id).then(function(res){
                return res.data;
            });
        }

    }
})();

'use strict';

app.controller('PortfolioGroupCtrl', function PortfolioGroupCtrl($scope, $http, $oasRights, API_CONFIG, $location, $portfolio, apps, entities, views, $tactical, $routeParams, searchResult, $dialog){

    //PRIVATE VARIABLES

    //PRIVATE METHODS
    function init(){
        $scope.rightsHH = $oasRights.forCode("CLIENTS");
        $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
        $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
        $scope.rightsAst = $oasRights.forCode("ASSETS");
        $scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");
        $scope.rightsNewAcc = $oasRights.forCode("NEWACCOUNT");
        $scope.rightsHouseholding = $oasRights.forCode("HOUSEHOLDINGAPP");
        $scope.rightsCancelAccount = $oasRights.forCode("CANCELACCOUNT");
        $scope.rightsTOM = $oasRights.forCode("TRADEORDERMGMT");
        $scope.rightsInstances = $oasRights.forCode("TRADEINSTANCES");
        $scope.rightsPerfViewer = $oasRights.forCode("PERFVIEWER");
        $scope.rightsHouseholdOverview = $oasRights.forCode("HOUSEHOLDOVERVIEW");
        $scope.rightsTaxCenter = $oasRights.forCode("TAXCENTERMAINTAIN");
        $scope.rightsInsight = $oasRights.forCode("INSIGHTBUILDERAPP");
        $scope.rightsTargetAllocation = $oasRights.forCode("TARGETALLOCATION");
        $scope.rightsMoneyGuidePro = $oasRights.forCode("MONEYGUIDEPRO");
        $scope.rightsSalesForceSync = $oasRights.forCode("SFSYNCHISTORY");
        $scope.rightsNotes = $oasRights.forCode("NOTES");
        $scope.rightsDocuments = $oasRights.forCode("DOCUMENTS");
        $scope.rightsPVCompare = $oasRights.forCode("PORTFOLIOVIEWCOMPARE");

        if ($routeParams.portfolioGroupId){
            $scope.current.portfolioGroupId = $routeParams.portfolioGroupId;
        }

        if (searchResult) {
            $scope.current.url = '';
            $portfolio.goTo(entities[entities.find({value: searchResult.entity})].urlFrag, searchResult.entity, searchResult.item.id);
        } else {
            if ($routeParams.entityId && $routeParams.entity === entities.client.value){
                $scope.current.clientId = $routeParams.entityId;
            } else if ($routeParams.entityId && $routeParams.entity === entities.portfolioGroup.value){
                $scope.current.url = '/Portfolio/PortfolioGroups/' + $routeParams.entityId;
            } else if ($routeParams.entityId && $routeParams.entity === entities.representative.value) {
                $scope.current.repId = $routeParams.entityId;
            } else if ($routeParams.entityId && $routeParams.entity === entities.registration.value) {
                $scope.current.registrationId = $routeParams.entityId;
            } else if ($routeParams.entityId && $routeParams.entity === entities.account.value) {
                $scope.current.accountId = $routeParams.entityId;
            } else if ($routeParams.entityId && $routeParams.entity === entities.asset.value){
                $scope.current.assetId = $routeParams.entityId;
            } else if ($routeParams.entityId && $routeParams.entity === entities.transaction.value){
                $scope.current.transactionId = $routeParams.entityId;
            }

            if ($routeParams.entity && $routeParams.entityId) {
                getCurrentEntityInfo().then(function (response) {
                    if (response.data) {
                        $scope.current.entity = response.data;
                        let name = $scope.current.entity.name;

                        if ($routeParams.entity === entities.representative.value) {
                            name = $scope.current.entity.lastName == null ? $scope.current.entity.firstName
                                : ($scope.current.entity.firstName == null ? $scope.current.entity.lastName
                                    : $scope.current.entity.lastName + ', ' + $scope.current.entity.firstName);
                        } else if ($routeParams.entity === entities.client.value) {
                            name = $scope.current.entity.lastName + ', ' + $scope.current.entity.firstName;
                            $scope.current.selectedHouseholdId = $scope.current.entity.id;
                        } else {
                            $scope.current.selectedHouseholdId = 0;
                        }

                        if ($scope.current.entity !== null) {
                            switch ($routeParams.entity) {
                                case entities.representative.value:
                                case entities.client.value:
                                    $scope.current.detailInfo = $portfolio.getBreadcrumb($routeParams.entity, name);
                                    break;
                            }
                        }
                    }
                });
            }
        }
    }

    // PUBLIC METHODS
    $scope.goToHouseholdOverview = function () {
        $location.url('/portfolio/household/overview?entity=' + parseInt(entities.client.value) + '&entityId=' + $scope.current.householdId);
    };

    $scope.goToPortfolioView = function (tab) {
        let urlTemp = '/orion/dashboard?entity=' + parseInt(entities.portfolioGroup.value) + '&entityId=' + $scope.selectedIds[0];
        if (tab?.length > 0) {
            urlTemp = urlTemp + '&tab=' + tab;
        }
        $location.url(urlTemp);
    };

    $scope.goToPerformanceViewer = function () {
        $location.url('/reports/performanceviewer3?entity=' + parseInt(entities.client.value) + '&entityId=' + $scope.current.householdId);
    };

    $scope.goToTaxCenter = function() {
        $location.url('/tax/custodianrealized?entity=' + parseInt(entities.client.value) + '&entityId=' + $scope.current.householdId);
    };

    $scope.goToHouseholding = function () {
        if ($scope.selectedIds.length === 1) {
            $location.url('/portfolio/household/householding?entityId1=' + $scope.current.householdId + '&source=' + apps.portfolioLists.code);
        }
    };

    $scope.openTactical = function () {
        $tactical.start( $scope.current.householdId, true);
    };

    $scope.goToLower = function (urlLevel) {
        $portfolio.goTo(urlLevel, entities.portfolioGroup.value, $scope.current.portfolioGroupId);
    };

    $scope.runReport = function () {
        $portfolio.runReport(entities.portfolioGroup.value, $scope.selectedIds[0] || $scope.current.portfolioGroupId);
    };

    $scope.openEditor = function (isNewHH, tabToOpen) {
        if ($scope.selectedIds.length === 1 || isNewHH) {
            $portfolio.openEditor(entities.client.value, isNewHH ? [] : [$scope.current.householdId], null, tabToOpen, null, null)
                .then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:portfolio-groups-action', {action: 'refresh-grid'});
                    }
                });
        }
    };
    $scope.search = function () {
        $portfolio.search(entities.client.value)
            .then(function (rslt) {
                if (rslt) {
                    $portfolio.goTo(entities[entities.find({value: rslt.entity})].urlFrag, rslt.entity, rslt.item.id);
                }
            });
    };


    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1){
            $scope.openEditor(false, "portfolioGroups");
        }
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:portfolio-groups-action', {action: 'export-data'});
    };

    $scope.importTargetAllocations = function () {
        $dialog.dialog({
            dialogClass: "modal medium",
            templateUrl: "app/modals/upload-file.html",
            controller: "UploadFileCtrl",
            title: "Target Allocation Import",
            idField: "id",
            downloadUrl: '/Portfolio/ValidateImport/TargetAllocationPortfolioGroup/Templates/',
            validateUrl: '/Portfolio/ValidateImport/TargetAllocationPortfolioGroup',
            commitVerb: 'PUT',
            commitUrl: '/Portfolio/PortfolioGroups/Verbose'})
            .open();
    };
    
    function getCurrentEntityInfo() {
        if ($routeParams.entityId && $routeParams.entity) {
            let url = null;
            switch ($routeParams.entity) {
                case entities.representative.value:
                    url = '/Portfolio/Representatives/';
                    break;
                case entities.client.value:
                    url = '/Portfolio/Clients/';
                    break;
                case entities.registration.value:
                    url = '/Portfolio/Registrations/';
                    break;
                case entities.portfolioGroup.value:
                    url = '/Portfolio/PortfolioGroups/';
                    break;
                case entities.account.value:
                    url = '/Portfolio/Accounts/';
                    break;
                case entities.asset.value:
                    url = '/Portfolio/Assets/';
                    break;
                case entities.transaction.value:
                    url = '/Portfolio/Transactions/';
                    break;
            }

            if (url !== null) {
                return $http.get(url + $routeParams.entityId, {
                    cache: true,
                    trackerMsg: 'Loading entity info',
                });
            }
        }

        return Promise.reject('The entity specified is invalid.');
    }

    // INTIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.reportArgs = {};
    $scope.current = {
        view : views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: '/Portfolio/PortfolioGroups',
        insightUrl: API_CONFIG.insightUrl + '?p=dashboards&t=' + sessionStorage.oas_token,
        clientId: null,
        repId: null,
        registrationId: null,
        accountId: null,
        assetId: null,
        transactionId: null,
        portfolioGroupId: null,
        detailInfo: '',
        entity: null
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
            if($scope.selectedIds.length === 1){
                $scope.openEditor(false);
            }
        }}];

    init();

    //EVENT LISTENERS
    $scope.$on("event:portfolio-groups-select", function(e, args){
        if (args.length === 0) {return;}
        $scope.current.householdId = args[0].clientId;
        $scope.current.portfolioGroupId = args[0].id;
        $scope.$broadcast('event:portfolio-groups-tree-select',{householdId: args[0].clientId});
    });

    $scope.$on('slickgrid-data-loaded', function(event, data) {
        if (data.length !== 1) return;
        $scope.$broadcast('event:portfolio-groups-action',{action:'select-items', items: data.slice(0,1) });
    });

});



'use strict';

app.controller('RegistrationTypesListCtrl', function RegistrationTypesListCtrl($scope, $http, $portfolio, $oasRights, $dialog, entities, views, apps) {
    //PRIVATE VARIABLES

    //PRIVATE METHODS

    // PUBLIC METHODS
    $scope.openEditor = function (isNew) {
        if ($scope.selectedIds.length == 1 || isNew) {
            $portfolio.openEditor(entities.registrationType.value, isNew ? [] : $scope.selectedIds, 'General', 'rtGeneral', apps.portfolioLists.name)
                .then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:registrationtype-action', {action: isNew ? 'add-item' : 'update-item', item: rslt});
                    }
                });
        }
    };

    $scope.deleteSelected = function () {
        if ($scope.selectedIds.length === 1) {
            $dialog.confirmAction("Are you sure you want to delete registration type id " + $scope.selectedIds + "?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $http.delete('/Portfolio/Registrations/Type/' + $scope.selectedIds, { trackerMsg: 'Deleting registration type id ' + $scope.selectedIds })
                            .then(function () {
                                $scope.$broadcast('event:registrationtype-action', { action: 'delete-items', items: $scope.selectedIds });
                                //$scope.$broadcast('event:rmd-calculation-action', { action: 'refresh-grid' });
                            }
                            );
                    }
                });
        }
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:registrationtype-action', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    };


    // INITIALIZE
    $scope.rightsRegistrationTypes = $oasRights.forCode('REGTYPES');
    $scope.views = views;
    $scope.current = {view: views[0], gridDoubleClick: $scope.slickGridDoubleClick};

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    }}];
    $scope.selectedIds = [];
});

'use strict';

app.controller('RegistrationTypeEditCtrl', function RegistrationTypeEditCtrl( $scope, $http, $oasRights, $dialog, $timeout, $location, dialog, args, entities, taxType, splitIoService) {

    // region PRIVATE VARIABLES
    var rtGeneralOriginal = null, editorHotKeys, changeImpact = null, isRegTypeChangeImpactWarningEnabled = false;
    const REG_TYPE_CHANGE_IMPACT_WARNING_FLAG = 'oc_firmprofile_regtypewarning_39512';

    function init( ) {
        loadRights( );
        buildMenu( );
        loadHotKeys();
        $scope.loadTab( args.defaultTab );
    }

    function loadRights( ) {
            $scope.rightsRegistrationTypes = $oasRights.forCode("REGTYPES");
    }

    function buildMenu( ) {
        $scope.menu = { categories : [ ] };

        $scope.menu.categories.push({name : 'Registration Type', children : [] });
        $scope.menu.categories[0].children.push( {name:'General', active: false, code : 'rtGeneral'} );
    }


    function loadDataForSelectedTab( ) {
        switch ($scope.current.selectedTab) {
            case "rtGeneral":
                if( $scope.rightsRegistrationTypes.canRead ) {
                    loadRegistrationTypeDetail();
                    loadTaxTypeLookUps();
                }
                break;
        }

    }

    function loadRegistrationTypeDetail( ) {
        if( $scope.rtGeneral === null ) {

            if ($scope.current.rtId != 0){

                $http.get( '/Portfolio/Registrations/Types/' + $scope.current.rtId, {trackerMsg: 'Loading registration type'} )
                    .then( function( response ) {
                        $scope.rtGeneral = response.data;
                        rtGeneralOriginal = angular.copy( $scope.rtGeneral);
                    } );

                loadChangeImpact();

            }
            else{
                $scope.rtGeneral = {
                    id: 0,
                    sRegCode: "",
                    sRegDesc: null,
                    isQual: false,
                    isIRA: false,
                    is403b: false,
                    isBIRA: false,
                    isMultipleOwners: false,
                    includeInRMD: false,
                    isDefault: false,
                    planType: null,
                    externalCode: null,
                    socialCode: null,
                    commonCode: null,
                    category: null,
                    benTypes: null,
                    taxType: 0,
                    isERISA: false
                };
            }
        }
    }

    function loadTaxTypeLookUps() {
        if ($scope.taxType === null) {
            $scope.taxType = [];
            taxType.keys().forEach(function (key) {
                $scope.taxType.push({id: parseInt(taxType[key].value), name: taxType[key].name});
            });
        }
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: function() { $scope.close(true); } }
            ]);
        });
    }

    // region PUBLIC METHODS
    //  region LOAD/CLOSE
    $scope.loadTab = function( child ) {
        $scope.menu.categories.each( function( c ) {
            c.children.each( function( ch ) {
                ch.active = ch.code == child.code;
            });
        });

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab( );
    };

    function loadChangeImpact() {
        splitIoService.getBoolTreatment(REG_TYPE_CHANGE_IMPACT_WARNING_FLAG)
            .subscribe(function (isEnabled) {
                isRegTypeChangeImpactWarningEnabled = isEnabled;

                if (!isEnabled) {
                    changeImpact = null;
                    return;
                }

                $http.get('/Portfolio/Registrations/Types/' + $scope.current.rtId + '/ChangeImpact', {trackerMsg: 'Loading registration type change impact'})
                    .then(function (response) {
                        changeImpact = response.data || null;
                    });
            });
    }

    function hasCodeOrDescriptionChanged() {
        return rtGeneralOriginal
            && (rtGeneralOriginal.sRegCode !== $scope.rtGeneral.sRegCode
                || rtGeneralOriginal.sRegDesc !== $scope.rtGeneral.sRegDesc);
    }

    function shouldShowChangeImpactWarning() {
        return isRegTypeChangeImpactWarningEnabled
            && changeImpact
            && (changeImpact.formatCount > 0 || changeImpact.registrationCount > 0)
            && hasCodeOrDescriptionChanged();
    }

    function buildFormatExamplesList(formatNames, formatCount) {
        var examples = (formatNames || []).slice(0, 4).join(', ');

        if (formatCount > 4) {
            examples += ', ...';
        }

        return examples;
    }

    function buildPortfolioAuditRegistrationsUrl() {
        var embedPrefix = $location.url().startsWith('/embed') ? '/embed' : '';
        var path = embedPrefix + '/portfolio/registrations?odataFilter=' + encodeURIComponent('TypeId eq ' + $scope.current.rtId);
        var baseUrl = window.location.protocol + '//' + window.location.host + window.location.pathname.replace('index.html', '');

        return baseUrl + 'integration.html?p=' + encodeURIComponent(path) + '&t=' + sessionStorage.oas_token;
    }

    function buildChangeImpactWarningMessage() {
        var lines = ['Warning: By changing the description or code of this registration type you will be impacting:'];

        if (changeImpact.formatCount > 0) {
            var formatLabel = changeImpact.formatCount === 1 ? 'data format' : 'data formats';
            lines.push(
                'New accounts opened for ' + changeImpact.formatCount + ' ' + formatLabel +
                ' (IE: ' + buildFormatExamplesList(changeImpact.formatNames, changeImpact.formatCount) + ')'
            );
        }

        if (changeImpact.registrationCount > 0) {
            var registrationLabel = changeImpact.registrationCount === 1
                ? '1 Existing registration'
                : changeImpact.registrationCount + ' Existing registrations';

            lines.push(
                '<a href="' + buildPortfolioAuditRegistrationsUrl() + '" target="_blank" rel="noopener noreferrer">' + registrationLabel + '</a> assigned to this type.'
            );
        }

        lines.push('Do you want to continue?');

        return lines.join('<br><br>');
    }

    function performSave() {
        var rtGeneralToSave = angular.copy( $scope.rtGeneral );

        var saveArgs = $scope.current.rtId > 0 ? {method: "PUT", id: $scope.current.rtId, trackerMsg: "Saving registration type " + $scope.current.rtId} : {method: "POST", id: "", trackerMsg: "Adding new registration type"};

        $http({method: saveArgs.method, url: '/Portfolio/Registrations/Type/' + saveArgs.id, data: rtGeneralToSave, trackerMsg: saveArgs.trackerMsg})
            .then(function (response) {
                editorHotKeys.destroy();
                dialog.close(response.data);
            });
    }

    $scope.save = function( ) {
        if ($scope.current.rtId > 0 && shouldShowChangeImpactWarning()) {
            $dialog.confirmAction(buildChangeImpactWarningMessage())
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        performSave();
                    }
                });
        } else {
            performSave();
        }
    };

    $scope.close = function( validate ) {
        if( validate ) {
            if(
                !angular.equals( rtGeneralOriginal, $scope.rtGeneral )
            ) {
                $scope.errors.push( { type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true } );
            }else {
                editorHotKeys.destroy();
                dialog.close(null);
            }

        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };
    //endregion

    // region INITIALIZE
    $scope.current = {
        selectedTab : args.defaultTab,
        rtId : args.isNew ? 0 : parseInt(args.ids[0]),
        regType: 'Registration Type'
    };

    $scope.rtGeneral = null;
    $scope.taxType = null;
    $scope.errors = [];
    init();
});

'use strict';

const portfolioAuditDashboardCtrl = app.controller('PortfolioAuditDashboardCtrl', function PortfolioAuditDashboardCtrl($scope, $http, $portfolio, pageQueries) {
    //PRIVATE METHODS
    function init() {
        const list = [];

        pageQueries.forEach(function (level) {
            level.items.forEach(function (item) {
                item.value = '<i class="fa fa-spinner fa-spin" aria-hidden="true"></i>';

                $http.post('/Utility/PageQueries/' + item.id + '/Count', item, {allowCancellation: true})
                    .then(function (response) {
                        item.value = response.data;
                    });
            });

            list.push({entity: level.entity, groups: level.items.inGroupsOf(3).compact()});
        });

        $scope.pageQueries = list;
    }


    //PUBLIC METHODS
    $scope.loadEntity = function (selectedEntity, entityEnum) {
        $portfolio.goTo(selectedEntity.icon.split('-').last().pluralize(), entityEnum, selectedEntity.id, {source: "pl"});
    };


    //INITIALIZE
    init();
});

portfolioAuditDashboardCtrl.loadPageQueries = ["$http", "$q", "$settings", "entities", function ($http, $q, $settings, entities) {
    let queries = $settings.getSetting("paDashboardQueries");

    if (queries) {
        return $q.when(queries);
    }

    queries = [
        {entity: entities.client, code: "ClientDto"},
        {entity: entities.registration, code: "RegistrationDto"},
        {entity: entities.account, code: "AccountDto"},
        {entity: entities.asset, code: "AssetDto"},
        {entity: entities.transaction, code: "TransactionDto"}
    ];

    const promises = queries.map(function (item) {
        return $http.get('/Utility/PageQueries?pageCode=' + item.code, {trackerMsg: 'Loading ' + item.entity.name + ' data'});
    });

    return $q.all(promises)
        .then(function (responses) {
            const queryNames = $settings.getSetting("pageQueryNames");

            responses.forEach(function (response, index) {
                const data = response.data;

                if (data.length) {
                    queries[index].items = data.sortBy('name');

                    data.forEach(function (query) {
                        queryNames[query.id] = query.name;
                    });
                }
            });

            queries.remove({items: undefined});

            $settings.setSetting("paDashboardQueries", queries);
            return queries;
        });
}];

'use strict';

app.controller('QPENonManagedListCtrl', function QPENonManagedListCtrl( $scope, $http, $oasRights, views, $dialog ) {

    // PUBLIC METHODS
    $scope.openEditor = function( isNew ) {
        if( $scope.selectedIds.length === 1 || isNew ) {
            var dialogOpts = {
                templateUrl: "portfolio/modals/qpe-non-managed-edit.html",
                controller: "QPENonManagedEditCtrl",
                id: $scope.selectedIds.length > 0 ? $scope.selectedIds[0] : 0,
                isNew : isNew,
                dialogClass: "modal wide"
            };

            $dialog.dialog( dialogOpts ).open( ).then(function(result){
                if( result ) {
                    $scope.$broadcast('event:btla-action', {action: isNew ? 'add-item' : 'update-item', item: result});
                }
            });
        }
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:btla-action', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function( ) {
        if( $scope.selectedIds.length === 1 )
            $scope.openEditor(false);
    };


    // INITIALIZE
    $scope.rightsAsset = $oasRights.forCode("BELOWTHELINEASSETS");

    $scope.views = views;
    $scope.current = { view: views[0], gridDoubleClick: $scope.slickGridDoubleClick };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if( $scope.selectedIds.length === 1 ) {
            $scope.openEditor(false);
        }
    }}];

    $scope.selectedIds = [];
});

'use strict';

app.controller('HypotheticalMonthlyPerformanceImportCtrl', function HypotheticalMonthlyPerformanceImportCtrl( $scope, $http, $oasRights, views ) {

    // PRIVATE VARIABLES

    // PRIVATE METHODS
    function init( ) {
    }

    // PUBLIC METHODS
    $scope.startImportOver = function() {
        $scope.content.details = null;
    };
    $scope.submit = function() {
        $scope.current.executing = true;
        $http.put('/Portfolio/InvestmentObjectives/Verbose', $scope.current.objectives, {trackerMsg: 'Submitting Hypothetical Monthly Performance'})
            .then(function(){
                $scope.current.executing = false;
                $scope.messages.push({type: 'success', title: 'Data Saved ', msg: ' The hypothetical monthly performance data has been saved successfully.', showAllowClose: false});
            });
    };

    //WATCHES
    $scope.$watch("content.details", function(newValue, oldValue){
        if (newValue === oldValue) return;

        if(newValue !== null) {
            newValue.forEach(function(d, i) {
                d.id = parseInt(-i);
            });
            var eventArgs = {action: "set-data", newData: newValue };
            $scope.$broadcast('event:hypothetical-monthly-performance-action', eventArgs);
        }
    });
    $scope.$watch("current.objectives", function(newValue, oldValue){
        if (newValue === oldValue) return;
        var details = [];
        newValue.each(function(io) {
            var values = io.hypotheticalMonthlyPerformanceValues;
            values.each(function(v){
                v.investmentObjectiveId = io.id;
            });
            details.add(values);
        });
        $scope.content.details = details;
    });

    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.messages = [];
    $scope.rightsHypotheticalMonthlyPerformance = $oasRights.forCode("HYPOTHETICAL_MTHLY_PERF");
    $scope.content = { details: null };
    $scope.current = { view: views[0], executing: false, objectives: null, token: sessionStorage.oas_token };

    init( );
});




'use strict';

app.controller('CustodialIntegratorNoteMappingListCtrl', function CustodialIntegratorNoteMappingListCtrl( $scope, views, $oasRights, $dialog ){
    //PRIVATE METHODS
    function slickGridDoubleClick( ) {
        $scope.openCustodialIntegratorNoteMappingEditor( false );
    }

    // PUBLIC METHODS
    $scope.openCustodialIntegratorNoteMappingEditor = function( isNew ) {
        $dialog.dialog({templateUrl: "portfolio/custodialintegrator/editors/views/custodial-integrator-note-mapping-edit.html", controller: 'CustodialIntegratorNoteMappingEditCtrl', id: isNew ? 0 : $scope.selectedIds[0] })
            .open()
            .then( function( result ) {
                if( result ) {
                    $scope.$broadcast( 'event:custodial-integrator-note-mapping-list-action', {action: isNew ? 'add-item' : 'update-item', item: result } );
                }
            });
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast('event:custodial-integrator-note-mapping-list-action', {action: 'export-data'});
    };

    // INITIALIZE
    $scope.rightsCustodialIntegrator = $oasRights.forCode("CUSTODIALINTEGRATOR");
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view: views[0],
        gridDoubleClick: slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length ) {
                $scope.openAlternativesGlobalValuationEditor( false );
            }
        }
    }];
});
(function(){
    'use strict';
    angular
        .module('orionConnect')
        .controller('CustodialIntegratorOffsetSymbolMapping',CTRL)
        .$inject = ['$scope','views','$oasRights','$dialog'];
    function CTRL($scope, views, $oasRights, $dialog, $http){
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.current={
            view:views[0],
            loadUrl:''
        };
        $scope.rightsCustodialIntegrator = $oasRights.forCode("CUSTODIALINTEGRATOR");
        $scope.createSymbol = createSymbol;
        $scope.editSymbol = editSymbol;
        $scope.deleteSymbol = deleteSymbol;

        function processAction(obj){
            let actions={
                'create':function(obj){
                    return $http.post("/Integrations/CustodialIntegrator/ByAllOffsetSymbol",obj,{trackerMsg:"Creating Symbol"});
                },
                'update':function(obj){
                    return $http.put("/Integrations/CustodialIntegrator/ByAllOffsetSymbol/"+obj.id,obj,{trackerMsg:"Updating Symbol"});
                },
                'delete':function(){
                    return $http.put("/Integrations/CustodialIntegrator/ByAllOffsetSymbol/Action/Delete",$scope.selectedIds,{trackerMsg:"Delete Symbols"});
                }
            };
            (typeof actions[obj.action] === 'function')?actions[obj.action](obj.data):refreshGrid();
        }
        function refreshGrid(){
            $scope.$broadcast('event:custodial-integrator-asset-symbol-mapping-list-action',{action: 'refresh-grid'});
        }
        function createSymbol(){
            let data = {
                id: 0,
                fI_ID: 0,
                symbol: '',
                auditedDate: '',
                auditedByDisplay: ''
            };
            $dialog.dialog(
                {
                    templateUrl: 'portfolio/custodialintegrator/editors/views/custodial-integrator-offset-symbol-edit.html',
                    controller: 'custodialIntegratorOffsetSymbolEditCtrl',
                    symbolMapping: data,
                    new:true
                })
                .open()
                .then(function(res){
                    if(res){
                        processAction(res)
                            .then(refreshGrid());
                    }
                });
        }
        function editSymbol(){
            $http.get( '/Integrations/CustodialIntegrator/ByAllOffsetSymbol/' + $scope.selectedIds[0], {trackerMsg: 'Loading Offset Symbol'} )
                .then( function(res){
                    $dialog.dialog(
                        {
                            templateUrl: 'portfolio/custodialintegrator/editors/views/custodial-integrator-offset-symbol-edit.html',
                            controller: 'custodialIntegratorOffsetSymbolEditCtrl',
                            symbolMapping: res.data,
                            new:false
                        })
                        .open()
                        .then(function(res){
                            if(res){
                                processAction(res)
                                    .then(refreshGrid());
                            }
                        });
                });
        }
        function deleteSymbol(){
            processAction({action:'delete',data:null})
                .then(refreshGrid());
        }
    }
})();
'use strict';

app.controller('CustodialIntegratorTreatmentListCtrl', function CustodialIntegratorTreatmentListCtrl( $scope, views, $oasRights, $dialog ){
    //PRIVATE METHODS
    function slickGridDoubleClick( ) {
        $scope.openCustodialIntegratorTreatmentEditor( false );
    }

    // PUBLIC METHODS
    $scope.openCustodialIntegratorTreatmentEditor = function( isNew ) {
        $dialog.dialog({templateUrl: "portfolio/custodialintegrator/editors/views/custodial-integrator-treatment-edit.html", controller: 'CustodialIntegratorTreatmentEditCtrl', id: isNew ? 0 : $scope.selectedIds[0] })
            .open()
            .then( function( result ) {
                if( result ) {
                    $scope.$broadcast( 'event:custodial-integrator-treatment-list-action', {action: isNew ? 'add-item' : 'update-item', item: result } );
                }
            });
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast('event:custodial-integrator-treatment-list-action', {action: 'export-data'});
    };

    // INITIALIZE
    $scope.rightsCustodialIntegrator = $oasRights.forCode("CUSTODIALINTEGRATOR");
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view: views[0],
        gridDoubleClick: slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length ) {
                $scope.openCustodialIntegratorTreatmentEditor( false );
            }
        }
    }];
});
'use strict';

app.controller('CustodialIntegratorGlobalSymbolListCtrl', function CustodialIntegratorGlobalSymbolListCtrl( $scope, views, $oasRights, $dialog ){
    //PRIVATE METHODS
    function slickGridDoubleClick( ) {
        $scope.openCustodialIntegratorGlobalSymbolEditor( false );
    }

    // PUBLIC METHODS
    $scope.openCustodialIntegratorGlobalSymbolEditor = function( isNew ) {
        $dialog.dialog({templateUrl: "portfolio/custodialintegrator/editors/views/custodial-integrator-global-symbol-edit.html", controller: 'CustodialIntegratorGlobalSymbolEditCtrl', id: isNew ? 0 : $scope.selectedIds[0] })
            .open()
            .then( function( result ) {
                if( result ) {
                    $scope.$broadcast( 'event:custodial-integrator-global-symbol-list-action', {action: isNew ? 'add-item' : 'update-item', item: result } );
                }
            });
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast('event:custodial-integrator-global-symbol-list-action', {action: 'export-data'});
    };

    // INITIALIZE
    $scope.rightsCustodialIntegrator = $oasRights.forCode("CUSTODIALINTEGRATOR");
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view: views[0],
        gridDoubleClick: slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length ) {
                $scope.openCustodialIntegratorGlobalSymbolEditor( false );
            }
        }
    }];
});
'use strict';

app.controller('CustodialIntegratorLocalSymbolListCtrl', function CustodialIntegratorLocalSymbolListCtrl( $scope, views, $oasRights, $dialog ){
    //PRIVATE METHODS
    function slickGridDoubleClick( ) {
        $scope.openCustodialIntegratorLocalSymbolEditor( false );
    }

    // PUBLIC METHODS
    $scope.openCustodialIntegratorLocalSymbolEditor = function( isNew ) {
        $dialog.dialog({templateUrl: "portfolio/custodialintegrator/editors/views/custodial-integrator-local-symbol-edit.html", controller: 'CustodialIntegratorLocalSymbolEditCtrl', id: isNew ? 0 : $scope.selectedIds[0] })
            .open()
            .then( function( result ) {
                if( result ) {
                    $scope.$broadcast( 'event:custodial-integrator-local-symbol-list-action', {action: isNew ? 'add-item' : 'update-item', item: result } );
                }
            });
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast('event:custodial-integrator-local-symbol-list-action', {action: 'export-data'});
    };

    // INITIALIZE
    $scope.rightsCustodialIntegrator = $oasRights.forCode("CUSTODIALINTEGRATOR");
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view: views[0],
        gridDoubleClick: slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length ) {
                $scope.openCustodialIntegratorLocalSymbolEditor( false );
            }
        }
    }];
});
'use strict';

app.controller('CustodialIntegratorAccountListCtrl', function CustodialIntegratorAccountListCtrl( $scope, views, $oasRights, $dialog ){
    //PRIVATE METHODS
    function slickGridDoubleClick( ) {
        $scope.openCustodialIntegratorAccountEditor( false );
    }

    // PUBLIC METHODS
    $scope.openCustodialIntegratorAccountEditor = function( isNew ) {
        $dialog.dialog({templateUrl: "portfolio/custodialintegrator/editors/views/custodial-integrator-account-edit.html", controller: 'CustodialIntegratorAccountEditCtrl', id: isNew ? 0 : $scope.selectedIds[0] })
            .open()
            .then( function( result ) {
                if( result ) {
                    $scope.$broadcast( 'event:custodial-integrator-account-list-action', {action: isNew ? 'add-item' : 'update-item', item: result } );
                }
            });
    };

    $scope.backdateAccounts = function () {
        return $dialog.dialog({ templateUrl: "portfolio/custodialintegrator/modals/backdate-account.html", controller: "BackdateAccountCtrl", dialogClass: 'modal', resolve: {args: function() { return {
                    accounts: $scope.selectedItems
                }; }}}).open().then(function(result) {
                    if (result) {
                    }
                });
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast('event:custodial-integrator-account-list-action', {action: 'export-data'});
    };

    // EVENTS
    $scope.$on('event:custodial-integrator-account-list-select', function(e,args){$scope.selectedItems = args;});

    // INITIALIZE
    $scope.rightsCustodialIntegrator = $oasRights.forCode("CUSTODIALINTEGRATOR");
    $scope.views = views;

    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: {get: function() {return $scope.selectedItems.map('id')}},
        selected: {get: function() {return $scope.selectedItems[0] || $scope.current.item;}}
    });

    $scope.current = {
        view: views[0],
        gridDoubleClick: slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length ) {
                $scope.openCustodialIntegratorAccountEditor( false );
            }
        }
    }];
});
'use strict';

app.controller('CustodialIntegratorNoteMappingEditCtrl', function CustodialIntegratorNoteMappingEditCtrl( $scope, $http, $oasRights, dialog ) {
    function init( ) {
        $scope.rightsCustodialIntegrator = $oasRights.forCode( "CUSTODIALINTEGRATOR" );
        if( dialog.options.id === 0 ) {
            $scope.noteMapping = {
                id: 0,
                fiId: null,
                fileTransCode: null,
                note: null,
                replacementFileTransCode: null,
                rational: null,
                priority: null
            };
        } else {
            $http.get( '/Integrations/CustodialIntegrator/ByAllNoteMappings/' + dialog.options.id, {trackerMsg: 'Loading note mapping'} )
                .then( function(r){
                    $scope.noteMapping = r.data;
                });
        }
    }

    $scope.save = function( ) {
        var args = $scope.noteMapping.id > 0 ? {method: "PUT", id: $scope.noteMapping.id, trackerMsg: "Saving note mapping"} : {method: "POST", id: "", trackerMsg: "Adding new note mapping"};

        if( $scope.noteMapping.priority <= 0 || $scope.noteMapping.priority >= 11 || $scope.noteMapping.priority === null || !angular.isNumber($scope.noteMapping.priority) ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Priority must be between 1 and 10.'} );
        }

        if( $scope.noteMapping.replacementFileTransCode === null || $scope.noteMapping.replacementFileTransCode === "" ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Replacement File Transaction Code is required.'} );
        }

        if( $scope.noteMapping.note === null || $scope.noteMapping.note === "" ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Note is required.'} );
        }

        if( $scope.errors.length === 0 ) {
            $http( { method: args.method, url: '/Integrations/CustodialIntegrator/ByAllNoteMappings/' + args.id, data: $scope.noteMapping, trackerMsg: args.trackerMsg } )
                .then( function( r ) {
                    dialog.close( r.data );
                });
        }
    };

    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.errors = [];

    init( );
});
(function(){
    'use strict';
    angular
        .module('orionConnect')
        .controller('custodialIntegratorOffsetSymbolEditCtrl',CTRL)
        .$inject = ['$scope','$http','dialog'];
    function CTRL($scope, $http, dialog){
        $scope.symbolMapping = dialog.options.symbolMapping;
        $scope.errors = [];
        $scope.controls = {
            save:save,
            close:close
        };
        //INIT
        (function(){
        })();

        function save(){
            if(dialog.options.new){
                dialog.close({action:"create",data:$scope.symbolMapping});
            }else{
                dialog.close({action:"update",data:$scope.symbolMapping});
            }
        }
        function close(){
            dialog.close(null);
        }
    }
})();
'use strict';

app.controller('CustodialIntegratorAccountEditCtrl', function CustodialIntegratorAccountEditCtrl( $scope, $http, $oasRights, dialog ) {
    function init( ) {
        $scope.rightsCustodialIntegrator = $oasRights.forCode( "CUSTODIALINTEGRATOR" );
        if( dialog.options.id === 0 ) {
            $scope.IsEditMode = false;
            $scope.account = {
                id: 0,
                byAllAccountId: null,
                accountCode: null,
                secondaryAccountCode: null,
                lastUpdatedDateTime: null,
                lastProcessedDateTime: null,
                clientFirstName: null,
                clientLastName: null,
                advisorFirstName: null,
                advisorLastName: null,
                fiId: null,
                accountName: null,
                maxByAllTransId: null,
                updateStatusErrorCode: null,
                updateStatusInfo: null
            };
        } else {
            $scope.IsEditMode = true;
            $http.get( '/Integrations/CustodialIntegrator/ByAllAccounts/' + dialog.options.id, {trackerMsg: 'Loading account'} )
                .then( function(r){
                    $scope.account = r.data;
                });
        }
    }

    $scope.save = function( ) {
        var args = $scope.account.id > 0 ? {method: "PUT", id: $scope.account.id, trackerMsg: "Saving account"} : {method: "POST", id: "", trackerMsg: "Adding new account"};

        if( $scope.account.byAllAccountId === null || $scope.account.byAllAccountId === "" ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Account ID is required.'} );
        }

        if( $scope.errors.length === 0 ) {
            $http( { method: args.method, url: '/Integrations/CustodialIntegrator/ByAllAccounts/' + args.id, data: $scope.account, trackerMsg: args.trackerMsg } )
                .then( function( r ) {
                    dialog.close( r.data );
                });
        }
    };

    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.errors = [];

    init( );
});
'use strict';

app.controller('CustodialIntegratorGlobalSymbolEditCtrl', function CustodialIntegratorGlobalSymbolEditCtrl( $scope, $http, $oasRights, dialog ) {
    function init( ) {
        $scope.rightsCustodialIntegrator = $oasRights.forCode( "CUSTODIALINTEGRATOR" );
        if( dialog.options.id === 0 ) {
            $scope.globalSymbol = {
                id: 0,
                securityId: null,
                ticker: null,
                fiId: null,
                webName: null,
                downloadSymbol: null,
                isTranslationBlocked: false
            };
        } else {
            $http.get( '/Integrations/CustodialIntegrator/ByAllGlobalSymbols/' + dialog.options.id, {trackerMsg: 'Loading global symbol'} )
                .then( function(r){
                    $scope.globalSymbol = r.data;
                });
        }
    }

    $scope.save = function( ) {
        var args = $scope.globalSymbol.id > 0 ? {method: "PUT", id: $scope.globalSymbol.id, trackerMsg: "Saving global symbol"} : {method: "POST", id: "", trackerMsg: "Adding new global symbol"};

        if( $scope.globalSymbol.fiId === null || $scope.globalSymbol.fiId === "" ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' FI ID is required.'} );
        }

        if( $scope.errors.length === 0 ) {
            $http( { method: args.method, url: '/Integrations/CustodialIntegrator/ByAllGlobalSymbols/' + args.id, data: $scope.globalSymbol, trackerMsg: args.trackerMsg } )
                .then( function( r ) {
                    dialog.close( r.data );
                });
        }
    };

    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.errors = [];

    init( );
});
'use strict';

app.controller('CustodialIntegratorTreatmentEditCtrl', function CustodialIntegratorTreatmentEditCtrl( $scope, $http, $oasRights, dialog ) {
    function init( ) {
        $scope.rightsCustodialIntegrator = $oasRights.forCode( "CUSTODIALINTEGRATOR" );

        $http.get( '/Integrations/CustodialIntegrator/ByAllTreatmentTypes', {trackerMsg: 'Loading treatment types'} )
            .then( function (r) {
                $scope.treatmentTypes = r.data;
            });

        if( dialog.options.id === 0 ) {
            $scope.treatment = {
                id: 0,
                fiId: null,
                byAllTreatmentTypeId: null
            };
        } else {
            $http.get( '/Integrations/CustodialIntegrator/ByAllTreatments/' + dialog.options.id, {trackerMsg: 'Loading treatment'} )
                .then( function(r){
                    $scope.treatment = r.data;
                });
        }
    }

    $scope.save = function( ) {
        var args = $scope.treatment.id > 0 ? {method: "PUT", id: $scope.treatment.id, trackerMsg: "Saving treatment"} : {method: "POST", id: "", trackerMsg: "Adding new treatment"};

        if( $scope.treatment.fiId === null || $scope.treatment.fiId === "" ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' FI ID is required.'} );
        }

        if( $scope.treatment.byAllTreatmentTypeId === null || $scope.treatment.byAllTreatmentTypeId === "" ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Treatment Type is required.'} );
        }

        if( $scope.errors.length === 0 ) {
            $http( { method: args.method, url: '/Integrations/CustodialIntegrator/ByAllTreatments/' + args.id, data: $scope.treatment, trackerMsg: args.trackerMsg } )
                .then( function( r ) {
                    dialog.close( r.data );
                });
        }
    };

    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.errors = [];

    init( );
});
'use strict';

app.controller('CustodialIntegratorLocalSymbolEditCtrl', function CustodialIntegratorLocalSymbolEditCtrl( $scope, $http, $oasRights, dialog ) {
    function init( ) {
        $scope.rightsCustodialIntegrator = $oasRights.forCode( "CUSTODIALINTEGRATOR" );
        if( dialog.options.id === 0 ) {
            $scope.localSymbol = {
                id: 0,
                holdingId: null,
                securityId: null,
                ticker: null,
                fiId: null,
                webName: null,
                downloadSymbol: null,
                unitBalanceOverride: null
            };
        } else {
            $http.get( '/Integrations/CustodialIntegrator/ByAllLocalSymbols/' + dialog.options.id, {trackerMsg: 'Loading local symbol'} )
                .then( function(r){
                    $scope.localSymbol = r.data;
                });
        }
    }

    $scope.save = function( ) {
        var args = $scope.localSymbol.id > 0 ? {method: "PUT", id: $scope.localSymbol.id, trackerMsg: "Saving local symbol"} : {method: "POST", id: "", trackerMsg: "Adding new local symbol"};

        if( $scope.localSymbol.fiId === null || $scope.localSymbol.fiId === "" ) {
            $scope.errors.push({type: 'error', title: 'Error! ', msg: ' FI Id is required.'});
        }

        if( $scope.errors.length === 0 ) {
            $http( { method: args.method, url: '/Integrations/CustodialIntegrator/ByAllLocalSymbols/' + args.id, data: $scope.localSymbol, trackerMsg: args.trackerMsg } )
                .then( function( r ) {
                    dialog.close( r.data );
                });
        }
    };

    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.errors = [];

    init( );
});
'use strict';

app.controller('BackdateAccountCtrl', function CancelAccountCtrl($scope, dialog, $http, $dialog, $oasRights, args) {
    // PRIVATE METHODS
    function init() {
    }

    // PUBLIC METHODS
    $scope.close = function () {
        dialog.close(null);
    };

    $scope.backdate = function () {
        return $http.put('/Integrations/CustodialIntegrator/ByAllAccounts/Action/Backdate', $scope.current, {trackerMsg: 'Backdating ByAll accounts'})
            .then(function (response) {
                dialog.close(response.data);
            });
    };

    //INITIALIZE
    $scope.current = {
        date: null,
        accounts: args.accounts
    };
    init();
});

'use strict';

app.controller('PlaidSecurityMappingListCtrl', function PlaidSecurityMappingListCtrl( $scope, views, $oasRights, $dialog, $http ){
    var selectedItems = [];

    //PRIVATE METHODS
    function slickGridDoubleClick( ) {
        $scope.openEditor( false );
    }

    function deleteItem(item) {
        return $http.put( '/Integrations/CustodialIntegrator/PlaidSecurityMappings/Action/Delete', [item.id], {trackerMsg: 'Deleting security mapping'} )
            .then(function(){
                $scope.$broadcast( $scope.current.grid.events.action, {action: 'delete-item', item: item } );
            });
    }

    // PUBLIC METHODS
    $scope.openEditor = function( isNew ) {
        $dialog
            .dialog({
                templateUrl: "portfolio/custodialintegrator/editors/views/plaid-security-mapping-edit.html",
                controller: 'PlaidSecurityMappingEditCtrl',
                id: isNew ? 0 : $scope.selectedIds[0],
                dialogClass: "modal wide",
            })
            .open()
            .then( function( item ) {
                if( item ) {
                    $scope.$broadcast( $scope.current.grid.events.action, {action: isNew ? 'add-item' : 'update-item', item: item } );
                }
            });
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast($scope.current.grid.events.action, {action: 'export-data'});
    };

    $scope.deleteSecurityMapping = function( ) {
        if ($scope.selectedItem) {
            return $dialog.confirmAction("Are you sure you want to delete this security mapping?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        return deleteItem($scope.selectedItem);
                    }
                });
        }
    };

    // INITIALIZE
    $scope.rightsCustodialIntegrator = $oasRights.forCode("CUSTODIALINTEGRATOR");
    $scope.views = views;
    $scope.selectedIds = [];

    Object.defineProperties($scope, {
        selectedItems: {
            get: function() { return selectedItems; },
            set: function(items) { selectedItems = items; },
            enumerable: true
        },
        selectedItem: {
            get: function() { return (selectedItems||[])[0]; },
            set: function(item) { selectedItems = [item]; },
            enumerable: true
        },
        selectedIds: {
            get: function() { return selectedItems.map(function(item){ return item.id; }); },
            set: function(items) { console.log('Implementation Incomplete', items); },
            enumerable: true
        }
    });

    $scope.current = {
        grid: {
            load: '/Integrations/CustodialIntegrator/PlaidSecurityMappings',
            events: {
                action: 'event:plaid-security-mapping-list-action',
                select: 'event:plaid-security-mapping-list-select',
            }
        },
        view: views[0],
        gridDoubleClick: slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length ) {
                $scope.openEditor( false );
            }
        }
    }];

    // EVENTS
    $scope.$on($scope.current.grid.events.select, function(e, args) { if( args.length ) selectedItems = args; });
});
'use strict';

app.controller('PlaidNoteMappingListCtrl', function PlaidNoteMappingListCtrl( $scope, views, $oasRights, $dialog, $http ){
    var selectedItems = [];

    //PRIVATE METHODS
    function slickGridDoubleClick( ) {
        $scope.openEditor( false );
    }

    function deleteItem(item) {
        return $http.put( '/Integrations/CustodialIntegrator/PlaidNoteMappings/Action/Delete', [item.id], {trackerMsg: 'Deleting note mapping'} )
            .then(function(){
                $scope.$broadcast( $scope.current.grid.events.action, {action: 'delete-item', item: item } );
            });
    }

    // PUBLIC METHODS
    $scope.openEditor = function( isNew ) {
        $dialog
            .dialog({
                templateUrl: "portfolio/custodialintegrator/editors/views/plaid-note-mapping-edit.html",
                controller: 'PlaidNoteMappingEditCtrl',
                id: isNew ? 0 : $scope.selectedIds[0],
                dialogClass: "modal wide",
            })
            .open()
            .then( function( item ) {
                if( item ) {
                    $scope.$broadcast( $scope.current.grid.events.action, {action: isNew ? 'add-item' : 'update-item', item: item } );
                }
            });
    };

    $scope.deleteNoteMapping = function( ) {
        if ($scope.selectedItem) {
            return $dialog.confirmAction("Are you sure you want to delete this note mapping?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        return deleteItem($scope.selectedItem);
                    }
                });
        }
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast($scope.current.grid.events.action, {action: 'export-data'});
    };

    // INITIALIZE
    $scope.rightsCustodialIntegrator = $oasRights.forCode("CUSTODIALINTEGRATOR");
    $scope.views = views;

    Object.defineProperties($scope, {
        selectedItems: {
            get: function() { return selectedItems; },
            set: function(items) { selectedItems = items; },
            enumerable: true
        },
        selectedItem: {
            get: function() { return (selectedItems||[])[0]; },
            set: function(item) { selectedItems = [item]; },
            enumerable: true
        },
        selectedIds: {
            get: function() { return selectedItems.map(function(item){ return item.id; }); },
            set: function(items) { console.log('Implementation Incomplete', items); },
            enumerable: true
        }
    });

    $scope.current = {
        grid: {
            load: '/Integrations/CustodialIntegrator/PlaidNoteMappings',
            events: {
                action: 'event:plaid-note-mapping-list-action',
                select: 'event:plaid-note-mapping-list-select',
            }
        },
        view: views[0],
        gridDoubleClick: slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length ) {
                $scope.openEditor( false );
            }
        }
    }];

    // EVENTS
    $scope.$on($scope.current.grid.events.select, function(e, args) { if( args.length ) selectedItems = args; });
});
'use strict';

app.controller('PlaidUnitBalanceOverrideListCtrl', function PlaidUnitBalanceOverrideListCtrl( $scope, views, $oasRights, $dialog, $http ){
    var selectedItems = [];

    //PRIVATE METHODS
    function slickGridDoubleClick( ) {
        $scope.openEditor( false );
    }

    function deleteItem(item) {
        return $http.put( '/Integrations/CustodialIntegrator/PlaidUnitBalanceOverrides/Action/Delete', [item.id], {trackerMsg: 'Deleting unit balance override'} )
            .then(function(){
                $scope.$broadcast( $scope.current.grid.events.action, {action: 'delete-item', item: item } );
            });
    }

    // PUBLIC METHODS
    $scope.openEditor = function( isNew ) {
        $dialog
            .dialog({
                templateUrl: "portfolio/custodialintegrator/editors/views/plaid-unit-balance-override-edit.html",
                controller: 'PlaidUnitBalanceOverrideEditCtrl',
                id: isNew ? 0 : $scope.selectedIds[0],
                dialogClass: "modal wide",
            })
            .open()
            .then( function( item ) {
                if( item ) {
                    $scope.$broadcast( $scope.current.grid.events.action, {action: isNew ? 'add-item' : 'update-item', item: item } );
                }
            });
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast($scope.current.grid.events.action, {action: 'export-data'});
    };

    $scope.deleteUnitBalanceOverride = function( ) {
        if ($scope.selectedItem) {
            return $dialog.confirmAction("Are you sure you want to delete this unit balance override?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        return deleteItem($scope.selectedItem);
                    }
                });
        }
    };

    // INITIALIZE
    $scope.rightsCustodialIntegrator = $oasRights.forCode("CUSTODIALINTEGRATOR");
    $scope.views = views;
    $scope.selectedIds = [];

    Object.defineProperties($scope, {
        selectedItems: {
            get: function() { return selectedItems; },
            set: function(items) { selectedItems = items; },
            enumerable: true
        },
        selectedItem: {
            get: function() { return (selectedItems||[])[0]; },
            set: function(item) { selectedItems = [item]; },
            enumerable: true
        },
        selectedIds: {
            get: function() { return selectedItems.map(function(item){ return item.id; }); },
            set: function(items) { console.log('Implementation Incomplete', items); },
            enumerable: true
        }
    });

    $scope.current = {
        grid: {
            load: '/Integrations/CustodialIntegrator/PlaidUnitBalanceOverrides',
            events: {
                action: 'event:plaid-override-list-action',
                select: 'event:plaid-override-list-select',
            }
        },
        view: views[0],
        gridDoubleClick: slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length ) {
                $scope.openEditor( false );
            }
        }
    }];

    // EVENTS
    $scope.$on($scope.current.grid.events.select, function(e, args) { if( args.length ) selectedItems = args; });
});
'use strict';

app.controller('PlaidAccountListCtrl', function PlaidAccountListCtrl( $scope, views, $oasRights, $dialog ){
    //PRIVATE METHODS
    function slickGridDoubleClick( ) {
        $scope.openEditor( false );
    }

    // PUBLIC METHODS
    $scope.openEditor = function() {
        return $dialog
            .dialog({
                templateUrl: "portfolio/custodialintegrator/editors/views/plaid-account-edit.html",
                controller: 'PlaidAccountEditCtrl',
                id: $scope.selectedIds[0],
                dialogClass: "modal wide",
            })
            .open()
            .then( function( item ) {
                if( item ) {
                    $scope.$broadcast( $scope.current.grid.events.action, {action: 'update-item', item: item } );
                }
            });
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast($scope.current.grid.events.action, {action: 'export-data'});
    };

    // INITIALIZE
    $scope.rightsCustodialIntegrator = $oasRights.forCode("CUSTODIALINTEGRATOR");
    $scope.views = views;

    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: {get: function() {return $scope.selectedItems.map('id')}},
        selected: {get: function() {return $scope.selectedItems[0] || $scope.current.item;}}
    });

    $scope.current = {
        grid: {
            load: '/Integrations/CustodialIntegrator/PlaidAccounts',
            events: {
                action: 'event:plaid-account-list-action',
                select: 'event:plaid-account-list-select',
            }
        },
        view: views[0],
        gridDoubleClick: slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length ) {
                $scope.openEditor( false );
            }
        }
    }];

    // EVENTS
    $scope.$on($scope.current.grid.events.select, function(e,args){ $scope.selectedItems = args; });
});
'use strict';

app.controller('PlaidNoteMappingEditCtrl', function PlaidNoteMappingEditCtrl( $scope, $http, $oasRights, dialog, $q ) {
    function init( ) {
        $scope.rightsCustodialIntegrator = $oasRights.forCode( "CUSTODIALINTEGRATOR" );

        getItem($scope.item.id)
            .then( function(item){ $scope.item = item; });
    }

    function getItem(id) {
        return $q.resolve(
            id > 0
                ? $http.get( '/Integrations/CustodialIntegrator/PlaidNoteMappings/' + dialog.options.id, {trackerMsg: 'Loading note mapping'} ).then(function(r){return r.data;})
                : {
                    id: 0,
                    institutionName: null,
                    financialInstitutionId: null,
                    fileTransCode: null,
                    note: null,
                    replacementFileTransCode: null,
                    rationale: null,
                    priority: null
                }
        );
    }

    function saveItem(item) {
        return $q
            .resolve(
                item.id > 0
                    ? {method: "PUT", trackerMsg: "Saving note mapping"}
                    : {method: "POST", trackerMsg: "Adding new note mapping"}
            ).then(function(args){
                return $http({ method: args.method, url: '/Integrations/CustodialIntegrator/PlaidNoteMappings/' + (item.id || ''), data: item, trackerMsg: args.trackerMsg });
            })
            .then( function( r ) {
                return r.data;
            });
    }

    function validate() {
        $scope.errors.length = 0;

        if( !Number($scope.item.priority) || Number($scope.item.priority) < 1 || Number($scope.item.priority) > 10 ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Priority must be between 1 and 10.'} );
        }

        if( $scope.item.financialInstitutionId == null || $scope.item.financialInstitutionId.length < 1 ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Financial Institution ID is required.'} );
        }

        if( $scope.item.fileTransCode == null || !String($scope.item.fileTransCode).length ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' File Transaction Code is required.'} );
        }

        if( $scope.item.replacementFileTransCode == null || !String($scope.item.replacementFileTransCode).length ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Replacement File Transaction Code is required.'} );
        }

        if( $scope.item.note == null || !String($scope.item.note).length ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Note is required.'} );
        }

        if( $scope.item.rationale == null || !String($scope.item.rationale).length ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Rationale is required.'} );
        }

        return $scope.errors.length === 0;
    }

    $scope.save = function( ) {
        if( validate() ) {
            return saveItem($scope.item)
                .then( function( item ) {
                    return dialog.close( item );
                });
        }
    };

    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.errors = [];
    $scope.item = {id: dialog.options.id};

    init( );
});
'use strict';

app.controller('PlaidSecurityMappingEditCtrl', function PlaidSecurityMappingEditCtrl( $scope, $http, $oasRights, dialog, $q ) {
    var config = {
        url: '/Integrations/CustodialIntegrator/PlaidSecurityMappings/',
        type: 'Local Symbol',
        default: {
            id: 0,
            securityId: null,
            ticker: null,
            institutionName: null,
            financialInstitutionId: null,
            webName: null,
            downloadSymbol: null
        }
    };

    function init( ) {
        $scope.rightsCustodialIntegrator = $oasRights.forCode( "CUSTODIALINTEGRATOR" );

        getItem($scope.item.id)
            .then( function(item){ $scope.item = item; });
    }

    function getItem(id) {
        return $q.resolve(
            id > 0
                ? $http.get( config.url + dialog.options.id, {trackerMsg: 'Loading ' + String(config.type).toLowerCase()} ).then(function(r){return r.data;})
                : config.default
        );
    }

    function saveItem(item) {
        return $q
            .resolve(
                item.id > 0
                    ? {method: 'PUT', trackerMsg: 'Saving ' + String(config.type).toLowerCase()}
                    : {method: 'POST', trackerMsg: 'Adding new ' + String(config.type).toLowerCase()}
            ).then(function(args){
                return $http({ method: args.method, url: config.url + (item.id || ''), data: item, trackerMsg: args.trackerMsg });
            })
            .then( function( r ) {
                return r.data;
            });
    }

    function validate() {
        $scope.errors.length = 0;

        // if( $scope.item.plaidInstitutionId == null || !String($scope.item.plaidInstitutionId).length) {
        //     $scope.errors.push({type: 'error', title: 'Error! ', msg: ' Plaid Institution ID is required.'});
        // }

        return $scope.errors.length === 0;
    }

    $scope.save = function( ) {
        if( validate() ) {
            return saveItem($scope.item)
                .then( function( item ) {
                    return dialog.close( item );
                });
        }
    };

    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.errors = [];
    $scope.item = {id: dialog.options.id};

    init( );
});
'use strict';

app.controller('PlaidUnitBalanceOverrideEditCtrl', function PlaidUnitBalanceOverrideEditCtrl( $scope, $http, $oasRights, dialog, $q ) {
    var config = {
        url: '/Integrations/CustodialIntegrator/PlaidUnitBalanceOverrides/',
        type: 'UnitBalanceOverride',
        default: {
            id: 0,
            connectionId: null,
            plaidAccountId: null,
            accountNumber: null,
            effectiveDateRange: null,
            ticker: null,
            startDate: null,
            endDate: null,
            unitAmount: null,
        }
    };

    function init( ) {
        $scope.rightsCustodialIntegrator = $oasRights.forCode( "CUSTODIALINTEGRATOR" );

        getItem($scope.item.id)
            .then( function(item){
                $scope.item = item;
            });
    }

    function getItem(id) {
        return $q.resolve(
            id > 0
                ? $http.get( config.url + dialog.options.id, {trackerMsg: 'Loading ' + String(config.type).toLowerCase()} ).then(function(r){return r.data;})
                : config.default
        );
    }

    function saveItem(item) {
        return $q
            .resolve(
                item.id > 0
                    ? {method: 'PUT', trackerMsg: 'Saving ' + String(config.type).toLowerCase()}
                    : {method: 'POST', trackerMsg: 'Adding new ' + String(config.type).toLowerCase()}
            ).then(function(args){
                return $http({ method: args.method, url: config.url + (item.id || ''), data: item, trackerMsg: args.trackerMsg });
            })
            .then( function( r ) {
                return r.data;
            });
    }

    function validate() {
        $scope.errors.length = 0;

        if( $scope.item.ticker == null || !String($scope.item.ticker).length ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Ticker is required.'} );
        }

        if( $scope.item.startDate == null ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Start Date is required.'} );
        }

        if( !Number($scope.item.unitAmount) ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Unit Amount is required'} );
        }

        if( $scope.item.plaidAccountId == null || !String($scope.item.plaidAccountId).length ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Plaid Account ID is required.'} );
        }

        return $scope.errors.length === 0;
    }

    $scope.save = function( ) {
        if( validate() ) {
            return saveItem($scope.item)
                .then( function( item ) {
                    return dialog.close( item );
                });
        }
    };

    $scope.close = function( ) {
        dialog.close( null );
    };


    $scope.errors = [];
    $scope.item = {id: dialog.options.id};
    $scope.current = {};

    init( );
});
'use strict';

app.controller('PlaidAccountEditCtrl', function PlaidAccountEditCtrl($scope, $http, $oasRights, dialog, $q ) {
    var config = {
        url: '/Integrations/CustodialIntegrator/PlaidAccounts/',
        type: 'Account',
        default: {
            id: 0
            //define rest of the object
        }
    };

    function init( ) {
        $scope.rightsCustodialIntegrator = $oasRights.forCode( "CUSTODIALINTEGRATOR" );

        getItem($scope.item.id)
            .then( function(item){
                $scope.item = item;
            });
    }

    function getItem(id) {
        return $q.resolve(
            id > 0
                ? $http.get( config.url + dialog.options.id, {trackerMsg: 'Loading ' + String(config.type).toLowerCase()} ).then(function(r){return r.data})
                : config.default
        );
    }

    function searchAccounts(key) {
        $scope.current.search.inProgress = true;
        $scope.current.search.accounts = $scope.current.search.matches;
        return $q.resolve(
            key > 0 || (key != null && key !== '')
                ? $http.get( '/Portfolio/Accounts/Simple/Search?search={search}&top={top}'.assign({search: key, top: 10}), {tracker: false}).then(function(r){return r.data })
                : []
        ).then(function(accounts){
            $scope.current.search.inProgress = false;
            return $scope.current.search.accounts = accounts;
        })
    }

    function saveItem(item) {
        return $q
            .resolve(
                item.id > 0
                    ? {method: 'PUT', trackerMsg: 'Saving ' + String(config.type).toLowerCase()}
                    : {method: 'POST', trackerMsg: 'Adding new ' + String(config.type).toLowerCase()}
            ).then(function(args){
                return $http({ method: args.method, url: config.url + (item.id || ''), data: item, trackerMsg: args.trackerMsg });
            })
            .then( function( r ) {
                return r.data;
            });
    }

    function validate() {
        $scope.errors.length = 0;

        return $scope.errors.length === 0;
    }

    $scope.save = function( ) {
        if( validate() ) {
            return saveItem($scope.item)
                .then( function( item ) {
                    return dialog.close( item );
                });
        }
    };

    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.$watch('item.accountNumber', function(key){
        searchAccounts(key);
    });

    $scope.errors = [];
    $scope.item = {id: dialog.options.id};
    $scope.current = {
        style: {
            get searchIcon() {
                var c = ['fa fa-fw'];
                c.push($scope.current.search.inProgress ? 'fa-spinner fa-spin' : ($scope.current.search.accounts.length ? ($scope.current.search.isMatch ? 'fa-check text-success' : 'fa-question-circle text-warning') : 'fa-warning text-error'));
                return c;
            }
        },
        search: {
            get matches() {
                return $scope.current.search.accounts.filter(function(a){return a.number == $scope.item.accountNumber; });
            },
            get isMatch() {
                return $scope.current.search.accounts.some(function(a){return a.number == $scope.item.accountNumber; });
            },
            accounts: [],
            inProgress: true
        }
    };

    init( );
});
'use strict';

app.controller('AkoyaAccountListCtrl', function AkoyaAccountListCtrl($scope, views, $oasRights, $dialog, $location, API_CONFIG ){
    //PRIVATE METHODS
    function slickGridDoubleClick( ) {
        $scope.openEditor( false );
    }

    // PUBLIC METHODS
    $scope.openLogs = function () {
        var akoyaAccount = $scope.selectedItems[0].akoyaAccountId;
        $location.url('/portfolio/custodialintegrator/akoya/logs?akoyaAccountId=' + akoyaAccount);
    }

    $scope.openEditor = function() {
        return $dialog
            .dialog({
                templateUrl: "portfolio/custodialintegrator/editors/views/akoya-account-edit.html",
                controller: 'AkoyaAccountEditCtrl',
                id: $scope.selectedIds[0],
                dialogClass: "modal wide",
            })
            .open()
            .then( function( item ) {
                if( item ) {
                    $scope.$broadcast( $scope.current.grid.events.action, {action: 'update-item', item: item } );
                }
            });
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast($scope.current.grid.events.action, {action: 'export-data'});
    };

    // INITIALIZE
    $scope.rightsCustodialIntegrator = $oasRights.forCode("CUSTODIALINTEGRATOR");
    $scope.views = views;

    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: {get: function() {return $scope.selectedItems.map('id')}},
        selected: {get: function() {return $scope.selectedItems[0] || $scope.current.item;}}
    });

    $scope.current = {
        grid: {
            load: '/Integrations/CustodialIntegrator/AkoyaAccounts',
            events: {
                action: 'event:akoya-account-list-action',
                select: 'event:akoya-account-list-select',
            }
        },
        view: views[0],
        gridDoubleClick: slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length ) {
                $scope.openEditor( false );
            }
        }
    }];

    // EVENTS
    $scope.$on($scope.current.grid.events.select, function(e,args){ $scope.selectedItems = args; });
});
'use strict';

app.controller('AkoyaAccountEditCtrl', function AkoyaAccountEditCtrl($scope, $http, $oasRights, dialog, $q ) {
    var config = {
        url: '/Integrations/CustodialIntegrator/AkoyaAccounts/',
        type: 'Account',
        default: {
            id: 0
        }
    };

    function init( ) {
        $scope.rightsCustodialIntegrator = $oasRights.forCode( "CUSTODIALINTEGRATOR" );

        getItem($scope.item.id)
            .then( function(item){
                $scope.item = item;
            });
    }

    function getItem(id) {
        return $q.resolve(
            id > 0
                ? $http.get( config.url + dialog.options.id, {trackerMsg: 'Loading ' + String(config.type).toLowerCase()} ).then(function(r){return r.data})
                : config.default
        );
    }

    function searchAccounts(key) {
        $scope.current.search.inProgress = true;
        $scope.current.search.accounts = $scope.current.search.matches;
        return $q.resolve(
            key > 0 || (key != null && key !== '')
                ? $http.get( '/Portfolio/Accounts/Simple/Search?search={search}&top={top}'.assign({search: key, top: 10}), {tracker: false}).then(function(r){return r.data })
                : []
        ).then(function(accounts){
            $scope.current.search.inProgress = false;
            return $scope.current.search.accounts = accounts;
        })
    }

    function saveItem(item) {
        return $q
            .resolve(
                item.id > 0
                    ? {method: 'PUT', trackerMsg: 'Saving ' + String(config.type).toLowerCase()}
                    : {method: 'POST', trackerMsg: 'Adding new ' + String(config.type).toLowerCase()}
            ).then(function(args){
                return $http({ method: args.method, url: config.url + (item.id || ''), data: item, trackerMsg: args.trackerMsg });
            })
            .then( function( r ) {
                return r.data;
            });
    }

    function validate() {
        $scope.errors.length = 0;

        return $scope.errors.length === 0;
    }

    $scope.save = function( ) {
        if( validate() ) {
            return saveItem($scope.item)
                .then( function( item ) {
                    return dialog.close( item );
                });
        }
    };

    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.$watch('item.accountNumber', function(key){
        searchAccounts(key);
    });

    $scope.errors = [];
    $scope.item = {id: dialog.options.id};
    $scope.current = {
        style: {
            get searchIcon() {
                var c = ['fa fa-fw'];
                c.push($scope.current.search.inProgress ? 'fa-spinner fa-spin' : ($scope.current.search.accounts.length ? ($scope.current.search.isMatch ? 'fa-check text-success' : 'fa-question-circle text-warning') : 'fa-warning text-error'));
                return c;
            }
        },
        search: {
            get matches() {
                return $scope.current.search.accounts.filter(function(a){return a.number == $scope.item.accountNumber; });
            },
            get isMatch() {
                return $scope.current.search.accounts.some(function(a){return a.number == $scope.item.accountNumber; });
            },
            accounts: [],
            inProgress: true
        }
    };

    init( );
});
'use strict';

app.controller('QPENonManagedEditCtrl', function QPENonManagedEditCtrl($scope, $http, $dialog, dialog, $oasRights) {

    //PRIVATE METHODS
    function init( ) {
        $scope.btla = null;

        if( dialog.options.id > 0 && !dialog.options.isNew ){
            $http.get('/Portfolio/QPENonManaged/' + dialog.options.id, {trackerMsg: 'Loading below the line asset'})
                .then(function (response) {
                    $scope.btla = response.data;
                });
        } else if( dialog.options.isNew ) {
            $scope.btla =   {
                id: 0,
                clientId: "",
                asOfDt: Date.create("now"),
                ssN_TaxId: "",
                registrationNm: "",
                assetNm: "",
                acctNum: "",
                shares: "",
                price: "",
                startingVal: "",
                mktVal: "",
                fileNm: "",
                isError: false,
                errorText: ""
            }
        }
    }


    // PUBLIC METHODS
    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.save = function( ) {
        var args = $scope.btla.id > 0 ? {method: "PUT", id: $scope.btla.id, trackerMsg: "Saving below the line asset"} : {method: "POST", id: "", trackerMsg: "Adding new below the line asset"};

        $http( { method: args.method, url: '/Portfolio/QPENonManaged/' + args.id, data: $scope.btla, trackerMsg: args.trackerMsg } )
            .then(function( response ) {
                dialog.close( response.data );
            });
    };


    //INITIALIZE
    $scope.rightsAsset = $oasRights.forCode("BELOWTHELINEASSETS");

    init( );

});

'use strict';

app.controller('CancelAccountCtrl', function CancelAccountCtrl($scope, dialog, $http, $dialog, $oasRights,privilegeService, args, entities, splitIoService) {
    $scope.todayDate = new Date();
    // PRIVATE METHODS
    function init() {
        if ($scope.current.id) {
            if ($scope.current.entity == entities.client.value) {
                $http.get('/Portfolio/Clients/' + $scope.current.id + '/Accounts', {trackerMsg: 'Loading accounts'})
                    .then(function (response) {
                        $scope.accounts = response.data;
                        $scope.cancelInstruction.clientId = $scope.current.id;
                        $scope.cancelInstruction.cancelType = 'Full';
                        $scope.setSelected();
                        if ($scope.accounts.length > 0) {
                            $scope.current.name = response.data[0].name;
                        }
                    });
            } else if ($scope.current.entity == entities.account.value) {
                $http.get('/Portfolio/Accounts/' + $scope.current.id, {trackerMsg: 'Loading account'})
                    .then(function (response) {
                        $scope.accounts.push(response.data);
                        if (response.data) {
                            $scope.cancelInstruction.clientId = response.data.clientId;
                            $scope.cancelInstruction.cancelType = 'Partial';
                            if ($scope.accounts.length > 0) {
                                $scope.current.name = response.data.name;
                            }
                        }
                    });
            }
        } else {
            $scope.current.name = 'Mass Cancellation';
            $scope.cancelInstruction.cancelType = 'Partial';
            if( args.preselectedIds && args.preselectedIds.length > 0 ) {
                loadAccounts( args.preselectedIds );
            }
        }
        loadAccountCancellationSubjects();
    }

    function loadAccountCancellationSubjects(){
            $http.get('/Portfolio/AccountCancellationSubjects',{cache: false, trackerMsg: 'Loading Cancellation Types'})
                .then(function(response){
                    $scope.subjects = response.data;
                    $scope.subjects.sort((x,y)=> x.name.localeCompare(y.name));
                    $scope.cancelInstruction.journalSubject = $scope.subjects[0].name;
                });
    }

    function showResult(msg) {
        $dialog.messageBox('Cancel Results', msg)
            .open()
            .then(function () {
                $scope.current.disableSave = false;
                dialog.close(msg);
            });
    }

    function loadAccounts( ids ) {
        $http.post('/Portfolio/Accounts/List', ids, {trackerMsg: 'Loadings accounts', allowCancellation: true})
            .then(function (response) {
                $scope.accounts = response.data;
                $scope.setSelected();
            });
    }

    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close(null);
    };

    $scope.setSelected = function () {
        if ($scope.cancelInstruction.cancelType == 'Full' || !$scope.current.id) {
            if ($scope.accounts && $scope.accounts.length > 0) {
                for (var i = 0; i < $scope.accounts.length; i++) {
                    $scope.accounts[i].isSelected = true;
                }
            }
        }
    };

    $scope.process = function () {
        
        $scope.errors = [];
        var validateCancelDate = true;
        var cancelDate = $scope.cancelInstruction.asOfDate;
        if(!cancelDate) { validateCancelDate = false };
        var cancelInputDate = document.getElementById('cancelDate').value;
        var regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(\d{4})$/;
        let validationResult = validateAndFormatDate(cancelDate);
        validateCancelDate = regex.test(validationResult);
        if(validateCancelDate && validationResult == cancelInputDate && cancelDate.getTime() <= ($scope.todayDate).getTime()) {
            save();
        } else {
            if(!validateCancelDate) {
                $scope.errors.push({type: 'error', title: 'Invalid Cancel Date! ', msg: ' Cancel Date must have standard date format'});
            } else if(validationResult != cancelInputDate) {
                $scope.errors.push({type: 'error', title: 'Invalid Cancel Date! ', msg: ' Cancel Date must have valid calender date'});
            } else if(!(cancelDate.getTime() <= ($scope.todayDate).getTime())){
                $scope.errors.push({type: 'error', title: 'Invalid Cancel Date! ', msg: ' Cancel Date must not be in the future'});
            }
        }
    };

    function validateAndFormatDate(date) {
        if(!(date instanceof Date)) return 'Invalid Date';
        let selectedDate = new Date(date);
        if(isNaN(selectedDate)) return 'Invalid Date';
        let month = ("0" + (date.getMonth()+1)).slice(-2);
        let day = ("0" + (date.getDate())).slice(-2);
        let year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }

    function save() {
        if ($scope.accounts && $scope.accounts.length > 0) {
            $scope.cancelInstruction.accountIds = $scope.accounts.findAll({isSelected: true}).map("id");
            if ($scope.cancelInstruction.accountIds.length > 0) {
                $scope.current.disableSave = true;
                $dialog.confirmAction("Are you sure you want to process the cancellation?")
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            var ci = angular.copy($scope.cancelInstruction);
                            ci.accountIds = $scope.cancelInstruction.cancelType == 'Full' ? null : ci.accountIds;
                            ci.clientId = $scope.cancelInstruction.cancelType == 'Partial' ? '' : ci.clientId;

                            $http.put("/portfolio/clients/action/cancel", ci, {trackerMsg: 'Cancelling account' + ($scope.cancelInstruction.accountIds.length > 1 ? 's' : '')})
                                .then(function (response) {
                                    showResult(response.data.result);
                                })
                                .catch(function () {
                                    $scope.current.disableSave = false;
                                });
                        } else {
                            $scope.current.disableSave = false;
                        }
                    });
            } else {
                $scope.errors.push({type: 'error', title: 'No Account(s) Selected! ', msg: ' No accounts have been selected.'});
            }
        }
    };

    $scope.importFile = function () {
        $dialog.inputBox("Upload Account IDs", "File", "file", {postUrl: "/ValidateImport/Echo"})
            .open()
            .then(function (data) {
                    if (data) {
                        var ids = Object.values(data[0].result)[0].map(function (x) {
                            return Object.values(x)[0];
                        });

                        if (ids.length > 0) {
                            loadAccounts( ids );
                        }
                    }
                }
            );
    };

    $scope.openSubjectList = function() {
        $dialog.dialog({ templateUrl: 'app/modals/select-with-add.html', controller: "SelectWithAddCtrl", data: {items: angular.copy($scope.subjects), selectedItem: $scope.cancelInstruction.journalSubject}})
                .open()
                .then(function(result){
                    if (result) {
                        $http.post('/Portfolio/AccountCancellationSubjects', result.items)
                            .then(function(response){
                                $scope.subjects = response.data.map(function(subject){return {id: subject.id, name : subject.cancellationSubject};});
                                $scope.subjects.sort((x,y)=> x.name.localeCompare(y.name));
                                $scope.cancelInstruction.journalSubject = result.selectedItem;
                            });
                    }
                });
    };

    //INITIALIZE
    $scope.rightsCancelAccount = $oasRights.forCode("CANCELACCOUNT");

    $scope.current = {entity: args.entity, id: args.id, app: args.app};
    $scope.cancelTypes = [{id: 'Partial', name: 'Partial (Account)'}];

    if ($scope.current.id) {
        $scope.cancelTypes.insert({id: 'Full', name: 'Full (Household)'}, 0);
    }

    $scope.subjects = [
        "None",
        "Other",
        "Account Liquidation",
        "Account Value Below Minimum",
        "Advisor did not request cancellation",
        "Advisor Not Licensed in State",
        "Advisor requested cancellation via email notification",
        "Advisor requested cancellation via phone conversation",
        "Advisor requested cancellation via audit file notification",
        "BD Change on Annuity",
        "Client Requested Cancellation ",
        "Death of Account Owner",
        "Non-Payment of Fees",
        "Representative Terminated",
        "Third Party Authorization Removed",
        "Transferred to internal account"
    ];

    $scope.subjects.add([
        "Advisor terminated relationship",
        "Client/trust depleted assets",
        "Market fears",
        "Moved to index funds",
        "Switched to another advisor/firm",
        "Unhappy with portfolio performance/returns",
        "Unknown",
        "Wants to personally manage assets",
        "Business plan termination",
        "Delink"
    ]);

    $scope.subjects.add([
        $scope.user.authorization.alClientName + "'s investment counsel fee too high",
        "Unhappy with " + $scope.user.authorization.alClientName + "'s service",
    ]).sort();

    $scope.cancelInstruction = {
        cancelType: null,
        asOfDate: Date.create('today'),
        journalSubject: $scope.subjects[0],
        journalNote: '',
        zeroAssets: true,
        excludeDownloads: true,

        createFinalBill: true,
        clientId: 0,
        accountIds: []
    };

    $scope.errors = [];
    $scope.accounts = [];

    init();
});

'use strict';

app.controller('AccountRestoreCtrl', function AccountRestoreCtrl($scope, $http, dialog, $dialog) {

    // PRIVATE METHODS
    function init() {
        loadSources();
        loadAccounts(dialog.options.accounts)
    }

    function loadSources() {
        return $http.get('/Confirm/DownloadSources/Simple', {trackerMsg: 'Loading download sources'})
            .then(function (response) {
                $scope.current.downloadSources = response.data;
            });

    }

    function loadAccounts( newKeys ) {
        var route = '/Portfolio/Accounts/NewPortfolio/List/Id',
            keyName = 'id';
        if ($scope.current.exclusionTable)  {
            route = '/Portfolio/Accounts/NewPortfolio/List/AccountNumber';
            keyName = 'number';
        }

        var currentKeys = $scope.current.accounts.map(keyName);
        newKeys = newKeys.filter(function(key){ return currentKeys.indexOf(key) == -1 && key !== null});

        if(newKeys.length) {
            $http.post(route, newKeys, {trackerMsg: 'Loadings accounts', allowCancellation: true})
                .then(function (response) {
                    var newAccounts = newKeys.map(function(key) {
                        return $.extend({ accountNumber: key }, response.data.filter(function(account){return account.accountNumber==key})[0]);
                    });
                    Array.prototype.push.apply($scope.current.accounts, newAccounts);
                    $scope.current.selectedEntity = null;
                    $scope.loading = false;
                    $scope.disable = false;
                });
        } else {
            $scope.loading = false;
        }
    }

    // PUBLIC METHODS
    $scope.removeAccount = function(key) {
        $scope.current.accounts = $scope.current.accounts.filter(function(account){return account.accountNumber !== key});
    };

    $scope.close = function (result) {
        dialog.close(result);
    };

    $scope.restore = function () {
        if ($scope.current.accounts && $scope.current.accounts.length > 0) {
            if ($scope.current.downloadSource == null) {
                $scope.errors.push({type: 'error', title: 'No Download Source Selected! ', msg: ' You must select a Download Source to use this action.'});
                return;
            }
            $scope.disable = true;
            $dialog.confirmAction("Are you sure you want to restore these accounts?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        var accountKeys = $scope.current.accounts.map("accountNumber");
                        var params = {
                            downloadSource: $scope.current.downloadSource,
                            effectiveDate: $scope.current.effectiveDate,
                            isReturnAllPositions: $scope.current.allPositions
                        };
                        $scope.loading = true;
                        $http.post("/Portfolio/Accounts/Action/Restore", accountKeys,
                            {

                                trackerMsg: 'Restoring account' + (accountKeys.length > 1 ? 's' : ''),
                                params: params
                            })
                            .then(function (response) {
                                $scope.close(response.data.result);
                            })
                            .catch(function () {
                                $scope.disable = false;
                                $scope.loading = false;
                                $scope.errors.push({type: 'error', title: 'Account Restore Unsuccessful. ', msg: ' There has been a problem in trying to restore.'});
                            });
                    } else {
                        $scope.disable = false;
                    }
                });
        } else {
            $scope.errors.push({type: 'error', title: 'No Account(s) Selected! ', msg: ' No accounts have been selected.'});
        }
    };

    // WATCHES
    $scope.$watch('current.selectedEntity', function(newEntity, oldEntity){
        var keyName = 'id';
        if ($scope.current.exclusionTable) keyName = 'number';

        if(newEntity) loadAccounts([newEntity[keyName]]);
    });

    $scope.loading = true;
    $scope.disable = true;


    //INITIALIZE
    $scope.current = {
        selected: null,
        exclusionTable: dialog.options.exclusionTable,
        accounts: [],
        downloadSources: [],
        allPositions: false,
        effectiveDate: new Date.create('today').getPriorWorkday(),
        downloadSource: null
    };

    $scope.errors = [];

    init();
});

app.controller('TransactionsQuickAddCtrl', function TransactionsQuickAddCtrl( $scope, $http, dialog, $dialog, $filter ) {

    //PRIVATE METHODS
    function init( ) {
        $scope.account = dialog.options.account;

        var asOfDate = Date.create('today').format('{MM}-{dd}-{yyyy}');

        if( $scope.current.isPositionOnly ) {
            $scope.refreshData( );
        } else {
            // To Do: When this dialog gets plugged into Portfolio Audit
            // $http.get('/Portfolio/Accounts/' + $scope.account.id + '/Assets/' + asOfDate, {trackerMsg: 'Loading assets'})
            //     .then(function (r) {
            //         $scope.current.transactions = r.data;
            //     });
        }

        $scope.loadTransactionTypes( 10 );
    }

    function updateSummary( ) {
        $scope.current.totalAmount = 0;
        $scope.current.totalCashEffectAmount = 0;
        if( $scope.current.transactions ) {
            for( var i = 0; i < $scope.current.transactions.length; i++ ) {
                if( $scope.current.transactions[i].transTypeId > 0 ) {
                    if ($scope.current.showErrorsOnly && ( $scope.current.transactions[i].transactionError || $scope.current.transactions[i].performanceError )) {
                        $scope.current.totalAmount += $scope.current.transactions[i].amount;
                        $scope.current.totalCashEffectAmount += $scope.current.transactions[i]["cashEffect"] ? $scope.current.transactions[i]["cashEffect"] : 0;
                    } else if (!$scope.current.showErrorsOnly) {
                        $scope.current.totalAmount += $scope.current.transactions[i].amount;
                        $scope.current.totalCashEffectAmount += $scope.current.transactions[i]["cashEffect"] ? $scope.current.transactions[i]["cashEffect"] : 0;
                    }
                }
            }
        }
    }


    // PUBLIC METHODS
    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.changeTransType = function( trn ) {
        $scope.setCashEffect(trn);
        updateSummary( );
    };

    $scope.sortTransactions = function( sortField ) {
        $scope.current.sortField = sortField;
        $scope.current.sortReverse = !$scope.current.sortReverse;
    };

    $scope.loadTransactionTypes = function( usagePriority ) {
        var usageQs = '';
        if( usagePriority ) {
            usageQs = '?usagePriority=' + usagePriority;
        }
        $http.get('/Confirm/HeldAway/TransactionTypes' + usageQs, {trackerMsg: 'Loading transaction types'})
            .then(function (r) {
                $scope.transactionTypes = r.data;

                if( usagePriority === 10 ) {
                    $scope.transactionTypes.push({id: 0, description: '[Show More]', offsetMultiplier: null});
                }
            });
    };

    $scope.refreshData = function( ) {
        if( $scope.current.isPositionOnly ) {
            $http.get('/Confirm/HeldAway/AssetValues?accountId=' + $scope.account.id + '&startDate=' + dialog.options.positionOnlyStartDate.format('{MM}-{dd}-{yyyy}') + '&endDate=' + dialog.options.positionOnlyEndDate.format('{MM}-{dd}-{yyyy}')+ '&balanceDate=' + $scope.current.transDate.format('{MM}-{dd}-{yyyy}'), {trackerMsg: 'Loading assets'})
                .then(function (r) {
                    if( r.data ) {
                        for (var i = 0; i < r.data.length; i++) {
                            r.data[i]["transDateFriendly"] = Date.create(r.data[i].transDate).format("{MM}/{dd}/{yyyy}");
                        }
                    }
                    $scope.current.transactions = r.data;
                    updateSummary( );
                });
        }
    };

    $scope.save = function( ) {
        if( $scope.current.transactions && $scope.current.transactions.length > 0 ) {
            var transactionsToPost = [];

            for( var i = 0; i < $scope.current.transactions.length; i++ ) {
                if( ( $scope.current.transactions[i].units !== 0 || $scope.current.transactions[i].price !== 0 || $scope.current.transactions[i].amount !== 0 ) && $scope.current.transactions[i].transTypeId > 0 ) {
                    var clone = angular.copy( $scope.current.transactions[i] );
                    transactionsToPost.push( clone );
                }
            }

            if( transactionsToPost.length > 0 ) {
                $dialog.confirmAction("Are you sure you want to create the specified transactions including the necessary cash offsets and any new assets?  " + transactionsToPost.length + " transactions will be created for a total amount of " + $filter('currency')(transactionsToPost.sum('amount')) + ".")
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            $http.post('/Confirm/HeldAway/CreateTransactions?accountId=' + $scope.account.id, transactionsToPost, {trackerMsg: 'Creating transactions'})
                                .then(function( r ){
                                    dialog.close( null );
                                });
                        }
                    });
            }
        }

    };

    $scope.addNewTransaction = function( ) {
        $dialog.search( 'product', 'New Transaction', null, null )
            .open()
            .then(function (result) {
                if( result ) {

                    var existing = $scope.current.transactions.find({productId: result.productId});

                    var transaction = {
                        amount: 0,
                        custodianUnits: 'N/A',
                        assetId: existing ? existing.assetId : 0,
                        orionUnits: 'N/A',
                        performanceError: false,
                        price: 0,
                        productId: result.productId,
                        productName: result.productName,
                        ticker: result.ticker,
                        transactionError: false,
                        units: 0
                    };

                    if (existing) {
                        $http.get('/Portfolio/Assets/' + transaction.assetId, {trackerMsg: 'Getting asset'})
                            .then(function (r) {
                                if( r.data ) {
                                    transaction.price = r.data.currentPrice;
                                    transaction.orionUnits = 'N/A';
                                }
                                $scope.current.transactions.insert( transaction, 0 );
                            });
                    } else {
                        $http.get('/Portfolio/Products/' + result.productId, {trackerMsg: 'Getting price'})
                            .then(function (r) {
                                if( r.data ) {
                                    transaction.price = r.data.currentOrionPrice;
                                }
                                $scope.current.transactions.insert( transaction, 0 );
                            });
                    }
                }
            });
    };

    $scope.calculateAmount = function( trn ) {
        trn.amount = trn.units * trn.price;
        updateSummary( );
    };

    $scope.calculateUnits = function( trn ) {
        if( trn.price !== 0 ) {
            trn.units = trn.amount / trn.price;
        }
    };

    $scope.calculatePrice = function( trn ) {
        if( trn.units !== 0 ) {
            trn.price = trn.amount / trn.units;
        }
    };

    $scope.amountChange = function( trn ) {
        $scope.setCashEffect( trn );
        updateSummary( );
    };

    $scope.setCashEffect = function( trn ) {
        if( trn.transTypeId === 0 ) {
            $scope.loadTransactionTypes( -1 );
        } else {
            trn["cashEffect"] = 0;
            if( trn.transTypeId > 0 && $scope.transactionTypes ) {
                var tt = $scope.transactionTypes.find({id: trn.transTypeId});
                if (tt.offsetMultiplier) {
                    trn.cashEffect = trn.amount * tt.offsetMultiplier;
                }
            }
        }
    };

    $scope.toggleErrorFilter = function( ) {
        $scope.current.showErrorsOnly = !$scope.current.showErrorsOnly;
        updateSummary( );
    };

    $scope.addNoteToAll = function( ) {
        $dialog.inputBox("Enter note for transactions", "Note", "textarea")
            .open()
            .then(function (r) {
                if( r ) {
                    if( $scope.current.transactions && $scope.current.transactions.length > 0 ) {
                        for( var i = 0; i < $scope.current.transactions.length; i++ ) {
                            $scope.current.transactions[i].note = r;
                        }
                    }
                }
            });
    };

    $scope.lookupPrice = function( t ) {
        if( t.assetId > 0 ) {
            $http.get("/Portfolio/Assets/" + t.assetId + "/Price/" + Date.create(t.transactionDate).format('{MM}-{dd}-{yyyy}'), {trackerMsg: 'Loading price'})
                .then(function (r) {
                    if( r.data ) {
                        t.price = r.data.last;
                    }
                });
        } else {
            $http.get('/Global/Products/Prices?productId=' + t.productId + '&priceDate=' + Date.create(t.transactionDate).format('{MM}-{dd}-{yyyy}'), {trackerMsg: 'Loading price'})
                .then(function (r) {
                    if( r.data && r.data.length > 0 ) {
                        t.price = r.data[0].navPrice;
                    }
                });
        }
    };

    $scope.deleteTransaction = function( t ) {
        $dialog.confirmAction( "Are you sure you want to delete the " + t.productName + " transaction?" )
            .open()
            .then(function (result) {
                if(result === 'yes' ) {
                    $scope.current.transactions.splice( $scope.current.transactions.indexOf(t), 1 );
                    updateSummary( );
                }
            });
    };

    $scope.cloneTransaction = function( t ) {
        var clone = angular.copy( t );
        var idx = $scope.current.transactions.findIndex(t);
        if( idx != -1 ) {
            $scope.current.transactions.insert( clone, idx )
        }
    };

    $scope.changeDate = function( t ) {
        t["transDateFriendly"] = Date.create( t.transDate ).format( "{MM}/{dd}/{yyyy}" );
        $scope.lookupPrice( t );
    };

    // INIT
    $scope.current = { transactions: null, transDate: Date.create('yesterday'), isPositionOnly: dialog.options.isPositionOnly, showErrorsOnly: true, totalAmount: 0, totalCashEffectAmount: 0, sortField : '', sortReverse : false, showTransactionFilterRow: false };

    init( );

});
'use strict';

app.controller('ReportingGroupCtrl', function ReportingGroupCtrl($scope, dialog, $http, args) {
    // PRIVATE METHODS
    function init() {
    }

    // PUBLIC METHODS
    $scope.save = function () {
        dialog.close($scope.current.group);
    };

    $scope.close = function () {
        dialog.close(null);
    };

    $scope.addAccount = function() {
        if(!$scope.current.group.accounts.some({accountId: $scope.current.selectedAccount.id})) {
            $http.get("/Portfolio/Accounts/" + $scope.current.selectedAccount.id, {trackerMsg: 'Loading account'})
                .then(function (response) {
                    if(response.data) {
                        var accountDetails = {
                            accountId: response.data.id,
                            accountNumber: response.data.number,
                            custodian: response.data.custodianId,
                            custodianName: response.data.custodian,
                            fundFamily: response.data.fundFamilyId,
                            fundFamilyName: response.data.fundFamily,
                            managementStyle: response.data.managementStyleId,
                            managementStyleName: response.data.managementStyle,
                            modelName: response.data.modelName,
                            registration: response.data.name,
                            typeName: response.data.accountType
                        };
                        $scope.current.group.accounts.add(accountDetails);
                    }
                    $scope.current.selectedAccount = null;
                });
        }
    };

    $scope.removeAccount = function(account) {
        $scope.current.group.accounts.remove(account);
    };

    //INITIALIZE
    $scope.search = { parameters: 'clientId=' + args.clientId + '&includeAdditionalAccounts=true' };
    $scope.current = { group: args.reportingGroup, selectedAccount: null };

    init();
});

'use strict';

app.controller('AnnuityValueCtrl', function AnnuityValueCtrl($scope, $http, $dialog, dialog) {

    //PUBLIC METHODS
    $scope.loadData = function () {
        $scope.annuity = null;

        $http.get('/Portfolio/Accounts/' + dialog.options.accountId + '/DailyAnnuityValue/' + $scope.current.selectedDate.format('{yyyy}-{MM}-{dd}'), {trackerMsg: 'Loading Annuity Value', ignoreExceptions: [404]})
            .then(function (response) {
                $scope.annuity = response.data;
            })
            .catch(function (response) {
                if (response.status === 404) {
                    $dialog.actionFailed("You have chosen a date for which no earlier data exists.").open();
                }
            });
    };

    $scope.close = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.current = {
        selectedDate: Date.create()
    };

    $scope.loadData();
});

'use strict';

app.controller('fundFamilyChangesReviewCtrl', function fundFamilyChangesReviewCtrl($scope, $http, $dialog, dialog,reviewItems) {

    //PUBLIC METHODS
    $scope.reviewItems = reviewItems;

    $scope.close = function () {
        dialog.close(true);
    };

    function addLocalFundFamilies(fundFamilies){
        if ( fundFamilies.length > 0) {
            $http({
                method: 'POST',
                url: '/Portfolio/FundFamilies',
                data: fundFamilies,

                trackerMsg: 'Adding new fund families'
            })
                .then(function (response) {
                    angular.forEach( fundFamilies,function(item){
                        angular.forEach(response.data, function (item2) {
                            if (item.id === item2.id) {
                                item.status = item2.status;
                                item.errorMessage = item2.errorMessage;
                            }
                        });
                    });
                });}
    }

    function removeLocalFundFamilies(fundFamilies){
        if ( fundFamilies.length > 0){
            $http({
                method: 'DELETE',
                url: '/Portfolio/FundFamilies',
                data: fundFamilies,

                trackerMsg: 'Deleting fund families'
            })
                .then(function (response) {
                    angular.forEach( fundFamilies,function(item){
                        angular.forEach(response.data, function (item2) {
                            if (item.id === item2.id) {
                                item.status = item2.status;
                                item.errorMessage = item2.errorMessage;
                            }
                        });
                    });
                });}
    }

    $scope.saveChanges = function(){
        var toDelete =  $scope.reviewItems.filter(function (source) {
                return source.action === "Delete" && source.status === "Pending";
        });
        var toAdd =  $scope.reviewItems.filter(function (source) {
            return source.action === "Add" && source.status === "Pending";
        });
        isSubmitted = true;
        addLocalFundFamilies(toAdd);
        removeLocalFundFamilies(toDelete);
    };

    $scope.disableConfirm = function(){
        return isSubmitted;
    };

    var isSubmitted = false;
});

'use strict';

app.controller('CalculateOrionStoredCostBasisCtrl', function CalculateOrionStoredCostBasisCtrl($scope, $http, dialog, $dialog, $location, $oasRights, splitIoService) {

    function init() {
        $scope.isAccountLevel = dialog.options.isAccountLevel;
        $scope.rightsOrionStoredCostBasisManualCalcOverride = $oasRights.forCode('ORIONSTOREDCOSTBASISMANUALCALCOVERRIDE');

        setDefaults();    

        if ($scope.isAccountLevel && $scope.rightsOrionStoredCostBasisManualCalcOverride.canRead) {
            $http.get('/Settings/EntityOptions/Database/Code/69COSTBASI')
                .then((response) => {
                    if (response && response.data && response.data.length > 0 && response.data[0].value) {
                        $scope.current.orionLastUpdate = new Date(response.data[0].value);
                    } else {
                        $scope.current.orionLastUpdate = null;
                    }
                });
        }
    }

    function setDefaults() {
        $scope.calculateIds = dialog.options.calculateIds;

        if ($scope.isAccountLevel) {
            $scope.selectedTypeText = ($scope.calculateIds && $scope.calculateIds.length > 1) ? 'accounts' : 'account';
        } else {
            $scope.selectedTypeText = ($scope.calculateIds && $scope.calculateIds.length > 1) ? 'assets' : 'asset';
        }
    }

    $scope.disableCalculate = function() {
        return $scope.calculateIds.length == 0 || ($scope.isAccountLevel && $scope.current.accountOverwriteOrionLastUpdate && !$scope.current.orionLastUpdate)
    };

    $scope.calculateOrionStoredCostBasis = function () {
        let postUrl = '';
        if ($scope.isAccountLevel) {
            postUrl = '/Portfolio/CostBasis/Queue/AccountList/Create';
            if ($scope.rightsOrionStoredCostBasisManualCalcOverride.canRead && $scope.current.accountOverwriteOrionLastUpdate) {
                postUrl += `?orionLastUpdate=${$scope.current.orionLastUpdate.toLocaleDateString('en-US')}`;
            }
        } else {
            postUrl = '/Portfolio/CostBasis/Queue/AssetList/Create';
        }

        $http.put(postUrl, $scope.calculateIds, { trackerMsg: 'Saving Orion Stored Cost Basis Manual Calculations' })
            .then(() => {
                dialog.close();
                $location.url('/portfolio/orionstoredcostbasis/manualcalculations');
            });
    };

    $scope.close = function () {
        dialog.close();
    }

    $scope.selectedTypeText = "asset"
    $scope.calculateIds = [];
    $scope.isAccountLevel = false;
    $scope.current = {
        orionLastUpdate: null,
        accountOverwriteOrionLastUpdate: false
    };
    
    init();
});
app.directive('userDefined', function userDefined($rootScope, $http, $portfolio, $dialog, $oasRights, entities) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            userDefinedData: '=',
            entity: '@',
            entityId: '=',
            userDefinedType: '@',
            enableValueEdit: '='
        },
        templateUrl: 'portfolio/directives/userDefined.html',
        link: function (scope) {
            //INITIALIZE
            scope.rightsCustomFields = $oasRights.forCode("CUSTOMFIELDS");
            scope.isAdminOrRia = ["Administrator", "Advisor"].any($rootScope.user.authorization.entity);
            scope.isTimeSensitive = scope.userDefinedType === 'TimeSensitive';

            scope.addCustomField = function () {
                var fields = scope.userDefinedData.findAll({entity: scope.entity});
                var lastSequence = fields.length ? fields.sortBy('sequence').last().sequence : 0;

                $dialog.dialog({templateUrl: "customfields-prompt.html", controller: 'CustomFieldsCtrl', entity: scope.entity, lastSequence: lastSequence, withTime: scope.isTimeSensitive})
                    .open()
                    .then(function (result) {
                        if (!result) return;

                        var url = (scope.isTimeSensitive ? '/Settings/UserDefinedTimeFields/' : '/Settings/UserDefinedFields/') + entities.find({name: scope.entity}).pluralize() + '/' + scope.entityId + '/Code/' + encodeURIComponent(result.code)

                        $http.get(url, {trackerMsg: 'Loading new custom field'})
                            .then(function (response) {
                                var data = response.data;
                                if (scope.isTimeSensitive){
                                    cleanCustomField(data)
                                }
                                else{
                                    $portfolio.cleanCustomField(data);
                                }
                                scope.userDefinedData.push(data);

                                scope.userDefinedData.findAll({entity: scope.entity}).sortBy('sequence').each(function (field, index) {
                                    field.sequence = index + 1;
                                });
                            });
                    });
            };

            function cleanCustomField(field) {
                field.value = field.mostRecent.value;
                $portfolio.cleanCustomField(field);
                field.mostRecent.value = field.value;
                delete field.value;
            }
        }
    }
});

app.directive('userDefinedControls', function userDefinedControls($dialog, $portfolio) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            userDefinedData: '=',
            parentEntity: '@',
            entity: '@',
            enableDefinitionEdit: '=',
            isTimeSensitive: '='
        },
        template:
        '<fieldset ng-disabled="::parentEntity != entity" style="margin: 30px;">' +
            '<div class="row-fluid" ng-if="isTimeSensitive">' +
                '<div class="span6"></div>' +
                '<div class="span3">' +
                    '<span>Effective Date</span>' +
                '</div>' +
                '<div class="span3">' +
                    '<span>Manage Values</span>' +
                '</div>' +
            '</div>' +
            '<div class="row-fluid" ng-repeat="def in userDefinedData | filter:{entity: entity} | orderBy:\'sequence\'">' +
                '<div ng-class="{span6: isTimeSensitive, span12:!isTimeSensitive}">' +
                    '<div class="control-group">' +
                        '<label class="control-label" >' +
                            '<button ng-style="{\'width\': !isTimeSensitive ? \'175px\' : \'\', \'text-align\': !isTimeSensitive ? \'right\' : \'\', \'white-space\': !isTimeSensitive ? \'normal\' : \'\'}" class="btn btn-link" ng-if="::parentEntity == entity && enableDefinitionEdit" ng-click="editCustomField(def)">{{ ::def.name }}</button>' +
                            '<span ng-if="::parentEntity != entity || !enableDefinitionEdit">{{ ::def.name }}</span>' +
                        '</label>' +
                        '<div ng-if="!isTimeSensitive" class="controls" ng-switch="def.type" ng-disable="!enableDefinitionEdit">' +
                            '<select id="{{ ::def.userDefineDefinitionId }}" ng-switch-when="List" ng-model="def.value" ng-options="item for item in def.options"></select>' +
                            '<input id="{{ ::def.userDefineDefinitionId }}" ng-switch-when="Check box" type="checkbox" ng-model="def.value" style="margin-top: 10px"/>' +
                            '<input id="{{ ::def.userDefineDefinitionId }}" ng-switch-when="Currency" type="number" step="any" ng-model="def.value" />' +
                            '<input id="{{ ::def.userDefineDefinitionId }}" ng-switch-when="Date" type="text" ng-model="def.value" max-date="null" datepicker-popup />' +
                            '<input id="{{ ::def.userDefineDefinitionId }}" ng-switch-when="Date/Time" type="text" ng-model="def.value" max-date="null" datepicker-popup />' +
                            '<input id="{{ ::def.userDefineDefinitionId }}" ng-switch-when="Integer" type="number" ng-model="def.value" />' +
                            '<input id="{{ ::def.userDefineDefinitionId }}" ng-switch-when="String" type="text" ng-model="def.value" />' +
                            '<input id="{{ ::def.userDefineDefinitionId }}" ng-switch-when="Double" type="number" step="any" ng-model="def.value" />' +
                            '<div id="{{ ::def.userDefineDefinitionId }}" timepicker ng-switch-when="Time" ng-model="def.value"></div>' +
                            '<input id="{{ ::def.userDefineDefinitionId }}" ng-switch-when="Long" type="number" ng-model="def.value" />' +
                            '<textarea id="{{ ::def.userDefineDefinitionId }}" ng-switch-when="Multi-line editor" class="input-xlarge" ng-model="def.value" rows="3"></textarea>' +
                        '</div>' +
                        '<div ng-if="isTimeSensitive" class="controls" ng-switch="def.type" ng-disable="!enableDefinitionEdit">' +
                            '<select id="{{ ::def.userDefineDefinitionId }}" ng-disabled="true" ng-switch-when="List" ng-model="def.mostRecent.value" ng-options="item for item in def.options"></select>' +
                            '<input id="{{ ::def.userDefineDefinitionId }}" ng-disabled="true" ng-switch-when="Check box" type="checkbox" ng-model="def.mostRecent.value" />' +
                            '<input id="{{ ::def.userDefineDefinitionId }}" ng-disabled="true" ng-switch-when="Currency" type="number" step="any" ng-model="def.mostRecent.value" />' +
                            '<input id="{{ ::def.userDefineDefinitionId }}" ng-disabled="true" ng-switch-when="Date" type="text" ng-model="def.mostRecent.value" max-date="null" datepicker-popup />' +
                            '<input id="{{ ::def.userDefineDefinitionId }}" ng-disabled="true" ng-switch-when="Date/Time" type="text" ng-model="def.mostRecent.value" max-date="null" datepicker-popup />' +
                            '<input id="{{ ::def.userDefineDefinitionId }}" ng-disabled="true" ng-switch-when="Integer" type="number" ng-model="def.mostRecent.value" />' +
                            '<input id="{{ ::def.userDefineDefinitionId }}" ng-disabled="true" ng-switch-when="String" type="text" ng-model="def.mostRecent.value" />' +
                            '<input id="{{ ::def.userDefineDefinitionId }}" ng-disabled="true" ng-switch-when="Double" type="number" step="any" ng-model="def.mostRecent.value" />' +
                            '<div id="{{ ::def.userDefineDefinitionId }}" ng-disabled="true" timepicker ng-switch-when="Time" ng-model="def.mostRecent.value"></div>' +
                            '<input id="{{ ::def.userDefineDefinitionId }}" ng-disabled="true" ng-switch-when="Long" type="number" ng-model="def.mostRecent.value" />' +
                            '<textarea id="{{ ::def.userDefineDefinitionId }}" ng-disabled="true" ng-switch-when="Multi-line editor" class="input-xlarge" ng-model="def.mostRecent.value" rows="3"></textarea>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div ng-if="isTimeSensitive" class="span3">' +
                    '<span>{{def.mostRecent.effectiveDate | date:\'MM/dd/yyyy\'}}</span>' +
                '</div>' +
                '<div ng-if="isTimeSensitive" class="span3">' +
                    '<button class="btn btn-link" ng-click="viewPreviousValues(def)">View</button>' +
                '</div>' +
            '</div>' +
        '</fieldset>',
        link: function (scope) {
            //INITIALIZE
             if (scope.userDefinedData && scope.isTimeSensitive){
                 scope.userDefinedData.forEach(function(udd){
                     cleanCustomField(udd);
                     udd.mostRecent.effectiveDate = Date.create(udd.mostRecent.effectiveDate).format('{yyyy}-{MM}-{dd}');
                     udd.values.forEach(function(val){
                         val.effectiveDate = Date.create(val.effectiveDate).format('{yyyy}-{MM}-{dd}')
                     });
                 });
             }

            scope.editCustomField = function (customField) {
                var dialogOpts = {
                    templateUrl: "customfields-prompt.html",
                    controller: 'CustomFieldsCtrl',
                    entity: scope.entity,
                    code: customField.code,
                    currentSequence: customField.sequence
                };
                
                $dialog.dialog(dialogOpts)
                    .open()
                    .then(function (result) {
                        if (!result) return;

                        if (result === "delete") {
                            scope.userDefinedData.remove(customField);
                        } else {
                            customField.name = result.description;
                            customField.sequence = result.sequence;
                            customField.type = result.type;
                            customField.options = result.options.sortBy('sequence').map('listValue');
                            customField.useForReportGrouping = result.useForReportGrouping;
                        }

                        scope.userDefinedData.findAll({entity: scope.entity}).sortBy('sequence').each(function (field, index) {
                            field.sequence = index + 1;
                        });
                    });
            };

            scope.viewPreviousValues = function (def) {
                var udt = angular.copy(def);
                udt.values.forEach(function(val){
                    val.effectiveDate = Date.create(val.effectiveDate)
                });

                udt.values = udt.values.sortBy('effectiveDate', true);

                var dialogOpts = {
                    templateUrl: "customfields-previous-values.html",
                    controller: 'CustomFieldsPreviousValuesCtrl',
                    customField: udt
                };

                $dialog.dialog(dialogOpts)
                    .open()
                    .then(function (result) {
                        if (!result) return;

                        result.values.forEach(function(val){
                            val.effectiveDate = Date.create(val.effectiveDate)
                        });
                        var descValues = result.values.sortBy('effectiveDate', true);
                        def.mostRecent.value = descValues.first().value;
                        def.mostRecent.effectiveDate = descValues.first().effectiveDate.format('{yyyy}-{MM}-{dd}');

                        scope.userDefinedData.find({code: def.code}).values = descValues;

                    });
            };


            var cancelWatcher = scope.$watch("userDefinedData", function (newValue, oldValue) {
                if (newValue === oldValue) return;

                if (scope.isTimeSensitive){
                    newValue.forEach(function(udd){
                        cleanCustomField(udd);
                        udd.mostRecent.effectiveDate = Date.create(udd.mostRecent.effectiveDate).format('{yyyy}-{MM}-{dd}');
                        udd.values.forEach(function(val){
                            val.effectiveDate = Date.create(val.effectiveDate).format('{yyyy}-{MM}-{dd}')
                        });
                    });
                }
                cancelWatcher();

            }, true);

            function cleanCustomField(field) {
                field.value = field.mostRecent.value;
                $portfolio.cleanCustomField(field);
                field.mostRecent.value = field.value;
                delete field.value;
            }

        }
    }
});


app.controller('CustomFieldsCtrl', function CustomFieldsCtrl($scope, $http, $oasRights, $dialog, dialog, userDefineControlMask, entities, $portfolio, splitIoService) {
    // PRIVATE VARIABLES
    var udfUrl = "/Settings/UserDefinedFields/Definitions/" + entities.find({name: dialog.options.entity}) + (dialog.options.code ? "/Code/" + encodeURIComponent(dialog.options.code) : "");
    var enableUserDefinedFieldReportGroupingFeatureFlag = "OC_Custom_Field_Groupings_34035";
    var reportGroupingSupportedEntities = ["Household", "Registration", "Portfolio Group", "Account", "Asset"];

    // PRIVATE METHODS
    function isReportGroupingEntitySupported(entity) {
        return reportGroupingSupportedEntities.any(entity);
    }

    function updateShowReportGroupingOption() {
        if (!$scope.userDefinedDefinition) {
            return;
        }

        $scope.current.showReportGroupingOption = $scope.current.reportGroupingFeatureEnabled
            && isReportGroupingEntitySupported(dialog.options.entity)
            && !dialog.options.withTime
            && !$scope.userDefinedDefinition.isTimeSensitive;
    }

    function shouldClearUseForReportGrouping(udd) {
        if (dialog.options.withTime || udd.isTimeSensitive || !isReportGroupingEntitySupported(dialog.options.entity)) {
            return true;
        }

        return $scope.current.reportGroupingFeatureFlagLoaded
            && !$scope.current.reportGroupingFeatureEnabled;
    }

    function loadReportGroupingFeatureFlag() {
        splitIoService.getBoolTreatment(enableUserDefinedFieldReportGroupingFeatureFlag).subscribe(function (isEnabled) {
            $scope.current.reportGroupingFeatureEnabled = isEnabled;
            $scope.current.reportGroupingFeatureFlagLoaded = true;
            updateShowReportGroupingOption();
        });
    }

    function init() {
        if ($scope.current.isNew) {
            $scope.userDefinedDefinition = {
                entity: dialog.options.entity,
                code: null,
                defaultValue: null,
                description: null,
                options: [],
                type: "String",
                sequence: dialog.options.lastSequence + 1,
                pageCodes: [],
                isTimeSensitive: dialog.options.withTime,
                useForReportGrouping: false
            };
            updateShowReportGroupingOption();
        } else {
            $http.get(udfUrl, {trackerMsg: 'Loading definition'})
                .then(function (response) {
                    const data = response.data;
                    cleanCustomField(data);

                    //sequence may have changed without being committed
                    data.sequence = dialog.options.currentSequence;

                    $scope.userDefinedDefinition = data;
                    if ($scope.userDefinedDefinition.useForReportGrouping === undefined) {
                        $scope.userDefinedDefinition.useForReportGrouping = false;
                    }
                    updateShowReportGroupingOption();
                });
        }

        $http.get('/Settings/Views/PageCodes/'  + entities.find({name: dialog.options.entity}) + '/simple', {cache: true, trackerMsg: 'Loading definition'})
            .then(function(response){
                $scope.current.pageCodes = response.data;
            });

        loadReportGroupingFeatureFlag();
    }

    function cleanCustomField(field, method) {
        field.value = field.defaultValue;
        $portfolio[method || "cleanCustomField"](field);
        field.defaultValue = field.value;
        delete field.value;
        field.code = field.code ? field.code.replace(/\//g, '') : null;
    }


    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close();
    };

    $scope.save = function () {
        var udd = angular.copy($scope.userDefinedDefinition);
        cleanCustomField(udd, "restoreEntityOption");

        if (udd.type !== "List") {
            udd.options = [];
        }

        if (shouldClearUseForReportGrouping(udd)) {
            udd.useForReportGrouping = false;
        }

        $http[$scope.current.isNew ? "post" : "put"](udfUrl, udd, {trackerMsg: 'Saving custom field'})
            .then(function (response) {
                var data = response.data;
                cleanCustomField(data);

                dialog.close(data);
            });
    };

    $scope.delete = function () {
        $dialog.confirmAction("All data associated with this custom field will be lost.<br/><br/>Are you sure you want to continue?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete(udfUrl, {trackerMsg: 'Deleting custom field'})
                        .then(function () {
                            dialog.close("delete");
                        });
                }
            });
    };

    $scope.setType = function () {
        cleanCustomField($scope.userDefinedDefinition);
        updateShowReportGroupingOption();
    };

    $scope.setListValues = function () {
        $dialog.dialog({templateUrl: 'listvalues-prompt.html', controller: 'ListValuesCtrl', resolve: {userDefinedDefOptions: function () {return $scope.userDefinedDefinition.options;}}})
            .open()
            .then(function (result) {
                if (result) {
                    if (result.none({listValue: $scope.userDefinedDefinition.defaultValue})) {
                        $scope.userDefinedDefinition.defaultValue = result.find({isDefault: true}).listValue;
                    }

                    $scope.userDefinedDefinition.options = result;
                }
            });
    };

    $scope.togglePageCode = function (pageCode) {
        var codes = $scope.userDefinedDefinition.pageCodes;

        if (codes.any(pageCode)) {
            codes.remove(pageCode);
        } else {
            codes.push(pageCode);
        }
    };


    //INITIALIZE
    $scope.current = {
        isNew: !dialog.options.code,
        types: userDefineControlMask.values().map('name'),
        reportGroupingFeatureEnabled: false,
        reportGroupingFeatureFlagLoaded: false,
        showReportGroupingOption: false
    };
    $scope.rightsCustomFields = $oasRights.forCode("CUSTOMFIELDS");

    init();
});


app.controller('ListValuesCtrl', function ListValuesCtrl($scope, $dialog, dialog, userDefinedDefOptions) {

    // PRIVATE METHODS
    function init() {
        $scope.userDefinedDefOptions = angular.copy(userDefinedDefOptions);
    }


    // PUBLIC METHODS
    $scope.addListValues = function () {
        var newListValue = {
            isDefault: $scope.userDefinedDefOptions.none({isDefault: true}),
            listValue: "",
            sequence: $scope.userDefinedDefOptions.length + 1
        };

        $scope.userDefinedDefOptions.push(newListValue);
    };

    $scope.removeListValue = function (opt) {
        $scope.userDefinedDefOptions.remove(opt);
    };

    $scope.setDefault = function (option) {
        if (option.isDefault) {
            $scope.userDefinedDefOptions.forEach(function (opt) {
                if (option.listValue != opt.listValue) {
                    opt.isDefault = false;
                }
            });
        }
    };

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.save = function () {
        var originalItemCount = $scope.userDefinedDefOptions.length;
        $scope.userDefinedDefOptions = $scope.userDefinedDefOptions.unique('listValue').sortBy('sequence');

        if ($scope.userDefinedDefOptions.length !== originalItemCount) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Duplicate List Value", "Any duplicate list values have been removed from the list.").open();
        }

        $scope.userDefinedDefOptions.each(function (option, index) {
            option.sequence = index + 1;
        });

        if ($scope.userDefinedDefOptions.none({isDefault: true})) {
            $scope.userDefinedDefOptions[0].isDefault = true;
        }

        dialog.close($scope.userDefinedDefOptions);
    };


    //INITIALIZE
    init();
});


app.controller('CustomFieldsPreviousValuesCtrl', function CustomFieldsPreviousValuesCtrl($scope, $dialog, dialog, $http, $portfolio) {
    // PRIVATE VARIABLES
    var customFieldOrig = null;

    // PRIVATE METHODS
    function cleanCustomField(field) {
        field.values.forEach(function(val){
            val.category = "No Category";
            val.type = field.type;
            val.effectiveDate = Date.create(val.effectiveDate).format('{yyyy}-{MM}-{dd}');
            $portfolio.cleanCustomField(val);
            delete val.type;
            delete val.category;
        });
    }

    // PUBLIC METHODS
    $scope.addValue = function(){
        var newTimeValue = {
            userDefineTimeDataId: 0,
            effectiveDate: Date.create('today').format('{yyyy}-{MM}-{dd}'),
            value: null
        };
        $scope.current.customField.values.push(newTimeValue);
    };


    $scope.close = function () {
        dialog.close();
    };

    $scope.save = function () {
        if (angular.equals(customFieldOrig.values, $scope.current.customField.values)){
             dialog.close();
        }

        cleanCustomField($scope.current.customField);
        var uniqueItemCount = $scope.current.customField.values.unique('effectiveDate').length;

        if ($scope.current.customField.values.length !== uniqueItemCount) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Duplicate Effective Date", "Multiple values cannot exist on the same date.").open();
        }
        else{
            dialog.close($scope.current.customField);
        }
    };

    $scope.removeValue = function (val) {
        $scope.current.customField.values.remove(val);
    };


    //INITIALIZE
    $scope.current = {
        customField: dialog.options.customField
    };

    cleanCustomField($scope.current.customField);
    customFieldOrig = angular.copy($scope.current.customField);
});

'use strict';

app.directive('documents', function documents($http, $dialog, API_CONFIG, $oasRights, entities) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            list: '=',
            entity: '@',
            entityId: '=',
            onAdd: '&'
        },
        templateUrl: 'portfolio/directives/documents.html',
        link: function (scope) {
            //PRIVATE METHODS
            function getDocumentUrl(id) {
                return entities[entities.find({name: scope.entity})].simpleUrl.replace('/Simple', '') + "/" + scope.entityId + '/Documents/' + id;
            }


            //PUBLIC METHODS
            scope.viewDocument = function (doc) {
                window.location.href = API_CONFIG.baseUrl + getDocumentUrl(doc.id) + '/Download?Authorization=' + sessionStorage.oas_token;
            };

            scope.removeDocument = function (doc) {
                $dialog.confirmAction("Are you sure you want to delete " + doc.description + "?")
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            scope.list.remove(doc);
                        }
                    });
            };

            scope.addDocument = function () {
                $dialog.dialog({templateUrl: "documents-prompt.html", controller: 'DocumentsCtrl', url: getDocumentUrl("")})
                    .open()
                    .then(function (result) {
                        if (result) {
                            scope.list.push(result);
                            scope.onAdd({newDocument: result});
                        }
                    });
            };

            scope.editDocument = function (doc) {
                $dialog.dialog({templateUrl: "documents-prompt.html", controller: 'DocumentsCtrl', url: getDocumentUrl(doc.id), document: doc})
                    .open()
                    .then(function (result) {
                        if (result) {
                            angular.merge(doc, result);
                        }
                    });
            };

            scope.toggleSysGenFilter = function () {
                scope.filter.systemGenerated = scope.current.showSystemGenerated ? undefined : false;
            };

            scope.sortDocuments = function (field) {
                scope.sort.desc = scope.sort.field === field ? !scope.sort.desc : false;
                scope.sort.field = field;
            };


            //INITIALIZE
            scope.current = {showSystemGenerated: true};
            scope.filter = {};
            scope.columns = ['category', 'description', 'editedBy', 'editedDate'];
            scope.sort = {field: 'editedDate', desc: true};
            scope.rightsDocuments = $oasRights.forCode("DOCUMENTS");
            scope.rightsSysGenerate = $oasRights.forCode( "DOCDELSYSGEN");
        }
    }
});


app.controller('DocumentsCtrl', function DocumentsCtrl($scope, $http, $oasRights, dialog) {

    // PRIVATE METHODS
    function init() {
        if (!$scope.current.isNew) {
            $scope.current.fileDetails.category = dialog.options.document.category;
            $scope.current.fileDetails.blobDesc = dialog.options.document.description;
        }

        $http.get('/Portfolio/CRMDocuments/Categories', {trackerMsg: 'Loading categories'})
            .then(function (response) {
                $scope.categories = response.data;

                if ($scope.current.isNew) {
                    $scope.current.fileDetails.category = response.data[0];
                }
            });
    }


    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close();
    };

    $scope.update = function () {
        dialog.close({category: $scope.current.fileDetails.category, description: $scope.current.fileDetails.blobDesc, editedBy: $scope.user.authorization.loginUserId, editedDate: Date.create().format(Date.ISO8601_DATETIME) });
    };


    //INITIALIZE
    $scope.current = {
        fileDetails: {blobType: 'CRMDocuments'},
        documentUrl: dialog.options.url,
        isNew: !dialog.options.document
    };
    $scope.rightsDocuments = $oasRights.forCode("DOCUMENTS");

    init();


    // WATCHES
    $scope.$watch('current.returnData', function (newValue, oldValue) {
        if (newValue === oldValue || !newValue) return;

        dialog.close({id: newValue.id, category: newValue.category, description: newValue.blobDesc, systemGenerated: false, editedBy: $scope.user.authorization.loginUserId, editedDate: Date.create().format(Date.ISO8601_DATETIME)});
    });
});
app.directive('notes', function notes($dialog, $oasRights) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'portfolio/directives/notes.html',
        scope: {
            list: '=',
            canEdit: '=',
            entity: '@'
        },
        link: function (scope) {
            scope.addNote = function () {
                $dialog.dialog({templateUrl: "notes-prompt.html", controller: 'NotesCtrl', category: '', text: '', entity: scope.entity})
                    .open()
                    .then(function (rslt) {
                        if (rslt && rslt.text.length > 0) {
                            scope.list.push({category: rslt.category, text: rslt.text});
                        }
                    });
            };
            
            scope.editNote = function (note) {
                $dialog.dialog({templateUrl: "notes-prompt.html", controller: 'NotesCtrl', category: note.category, text: note.text, entity: scope.entity})
                    .open()
                    .then(function (rslt) {
                        if (rslt && rslt.text.length > 0) {
                            note.category = rslt.category;
                            note.text = rslt.text;
                        }
                    });
            };

            scope.removeNote = function (note) {
                $dialog.confirmAction("Are you sure you want to remove this note?")
                    .open()
                    .then(function (rslt) {
                        if (rslt === 'yes') {
                            scope.list.remove(note);
                        }
                    });
            };

            scope.rightsNotes = $oasRights.forCode("NOTES");
        }
    };
});


app.controller('NotesCtrl', function NotesCtrl($scope, $http, dialog) {

    // PRIVATE METHODS
    function init() {
        if (!$scope.current.categories || !$scope.current.categories.length) {
            $http.get("/Portfolio/NoteCategories?entity=" + dialog.options.entity, {trackerMsg: 'Loading note categories'})
                .then(function (response) {
                    $scope.current.categories = response.data;

                    var rmd = Object.find(response.data, function (key, value) {
                        return value == 'RMD';
                    });
                    if (!rmd) {
                        $scope.current.categories.push('RMD');
                    }
                });
        }
    }

    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close();
    };

    $scope.close = function () {
        dialog.close($scope.current);
    };


    //INITIALIZE
    $scope.current = {categories: dialog.options.noteCategories, category: dialog.options.category, text: dialog.options.text};

    init();
});
'use strict';

app.service('$portfolio', function $portfolio($http, $q, $location, $dialog, $settings, entities, reportRunPrompterService) {

    var self = this;

    self.goTo = function (urlLevel, entityFor, entityIdFor, additionalParams) {
        $location.url(self.getGoToRoute(urlLevel, entityFor, entityIdFor, false) + (additionalParams ? "&" + Object.toQueryString(additionalParams) : ""));
    };

    self.getGoToRoute = function (urlLevel, entityFor, entityIdFor, encodeAmp) {
        var amp = encodeAmp ? '%26' : '&';
        return ($location.url().startsWith('/embed') ? '/embed' : '') + '/portfolio/' + urlLevel + '?entity=' + entityFor + amp + 'entityId=' + entityIdFor;
    };

    self.goToProduct = function (id) {
        $location.url('/products/local/' + id);
    };

    self.getBreadcrumb = function (entityFor, friendlyName) {
        return '(' + entities[entities.find({value: entityFor})].name + ': ' + friendlyName + ')';
    };

    self.getPageQueryName = function (pageQueryId) {
        const nameList = $settings.getSetting("pageQueryNames");
        const queryName = nameList[parseInt(pageQueryId)];

        if (queryName) {
            return $q.when(queryName);
        } else {
            return $http.get('/Utility/PageQueries/' + pageQueryId, {trackerMsg: 'Checking page query name'})
                .then(function (response) {
                    const data = response.data;
                    nameList[data.id] = data.name;

                    return data.name;
                });
        }
    };

    self.getBreadcrumbDetail = function (entity, entityId) {
        var entityEnum = entities[entities.find({value: entity})];

        return $http.get(entityEnum.simpleUrl.replace('/Simple', '') + "/" + entityId, {trackerMsg: 'Loading details'})
            .then(function (response) {
                return '(' + entityEnum.name + ': ' + response.data[entityEnum === entities.transaction ? "productName" : "name"] + ')';
            });
    };

    self.getDataUrls = function (entityFor, entityId, entityToLoad, asOfDate) {
        var urlInfo = {urlForList: '/Portfolio/', urlParams: '', httpArgsForSimple: {method: '', data: '', url: ''}};

        switch (entityFor) {
            case entities.client.value:
                if (entityToLoad === entities.account.value){
                    urlInfo.urlForList += 'Accounts';
                    urlInfo.urlParams += '&clientId='
                }
                else{
                    urlInfo.urlForList += 'Clients/';
                }
                urlInfo.httpArgsForSimple.method = "POST";
                urlInfo.httpArgsForSimple.data = [entityId];
                urlInfo.httpArgsForSimple.url = '/Portfolio/Clients/Simple/List/Id';
                break;
            case entities.registration.value:
                if (entityToLoad === entities.account.value){
                    urlInfo.urlForList += 'Accounts';
                    urlInfo.urlParams += '&registrationId='
                }
                else{
                    urlInfo.urlForList += 'Registrations/';
                }
                urlInfo.httpArgsForSimple.method = "GET";
                urlInfo.httpArgsForSimple.data = [entityId];
                urlInfo.httpArgsForSimple.url = '/Portfolio/Registrations/Simple/Search/?search=' + entityId;
                break;
            case entities.account.value:
                urlInfo.urlForList += 'Accounts/';
                urlInfo.httpArgsForSimple.method = "POST";
                urlInfo.httpArgsForSimple.data = [entityId];
                urlInfo.httpArgsForSimple.url = '/Portfolio/Accounts/Simple/List/Id';
                break;
            case entities.asset.value:
                urlInfo.urlForList += 'Assets/';
                urlInfo.httpArgsForSimple.method = "GET";
                urlInfo.httpArgsForSimple.data = [entityId];
                urlInfo.httpArgsForSimple.url = '/Portfolio/Assets/' + entityId;
                break;
            case entities.transaction.value:
                urlInfo.urlForList += 'Transactions/';
                urlInfo.httpArgsForSimple.method = "POST";
                urlInfo.httpArgsForSimple.data = [entityId];
                urlInfo.httpArgsForSimple.url = '/Portfolio/Transactions/List/Id';
                break;
            case entities.portfolioGroup.value:
                urlInfo.urlForList += 'PortfolioGroups/';
                urlInfo.httpArgsForSimple.method = "GET";
                urlInfo.httpArgsForSimple.data = [entityId];
                urlInfo.httpArgsForSimple.url = "/Portfolio/PortfolioGroups/" + entityId + "/Simple";
                break;
        }

        var urlEntity = '';
        if (parseInt(entityToLoad) > 0) {
            switch (entityToLoad) {
                case entities.client.value:
                    urlEntity = '/Clients';
                    break;
                case entities.registration.value:
                    urlEntity = '/Registrations';
                    break;
                case entities.account.value:
                    urlEntity = '/Accounts';
                    break;
                case entities.asset.value:
                    urlEntity = '/Assets';
                    break;
                case entities.transaction.value:
                    urlEntity = '/Transactions';
                    break;
            }
        }

        if ((entityFor === entities.client.value || entityFor === entities.registration.value) && entityToLoad === entities.account.value){
            urlInfo.urlParams += entityId;
        }
        else{
            urlInfo.urlForList += entityId + urlEntity;
        }

        if (asOfDate) {
            urlInfo.urlForList += ('/' + asOfDate);
        }

        return urlInfo;
    };

    self.runReport = function (entityEnum, pkEntity) {
        if (!parseInt(entityEnum)) { //they passed in the name instead
            entityEnum = entities[entities.find({name: entityEnum})].value
        }

        reportRunPrompterService.runReport(entityEnum, pkEntity, true);
    };

    self.customSearch = function (defaultEntity, entityTypes, title, dateRange, validate) {
        var dialogOpts = {
            backdrop: true,
            keyboard: true,
            backdropClick: true,
            templateUrl: 'app/modals/search.html',
            controller: 'SearchCtrl',
            defaultPane: defaultEntity,
            panes: entityTypes,
            title: title,
            dateRange: dateRange || false,
            validate: validate
        };

        return $dialog.dialog(dialogOpts).open();
    };

    self.search = function (defaultEntity, dateRange, validate) {
        return self.customSearch(defaultEntity, [entities.client.value, entities.portfolioGroup.value, entities.registration.value, entities.account.value], dateRange, validate);
    };

    self.openEditor = function (entityEnum, entityIds, defaultTabNameOverride, defaultTabCodeOverride, appName, extraInfo) {
        if (!parseInt(entityEnum)) { //they passed in the name instead
            entityEnum = entities[entities.find({name: entityEnum})].value
        }
        
        var page = 'portfolio/editors/views/';
        var controller = '';
        var tabCode = '';
        var tabName = '';

        switch (entityEnum) {
            case entities.brokerDealer.value:
                page = 'advisor/editors/views/brokerdealer-edit.html';
                controller = 'BrokerDealerEditCtrl';
                tabCode = 'brokerdealerGeneral';
                tabName = 'General';
                break;
            case entities.representative.value:
                page = 'advisor/editors/views/representative-edit.html';
                controller = 'RepresentativeEditCtrl';
                tabCode = 'representativeGeneral';
                tabName = 'General';
                break;
            case entities.plan401k.value:
                page = 'portfolio/views/plan-edit.html';
                controller = 'PlanEditCtrl';
                tabCode = 'planGeneral';
                tabName = 'General';
                break;
            case entities.client.value:
                page += 'household-edit.html';
                controller = 'HouseholdEditCtrl';
                tabCode = 'householdGeneral';
                tabName = 'General';
                break;
            case entities.registration.value:
                page += 'registration-edit.html';
                controller = 'RegistrationEditCtrl';
                tabCode = 'registrationGeneral';
                tabName = 'General';
                break;
            case entities.account.value:
                page += 'account-edit.html';
                controller = 'AccountEditCtrl';
                tabCode = 'accountGeneral';
                tabName = 'General';
                break;
            case entities.asset.value:
                page += 'asset-edit.html';
                controller = 'AssetEditCtrl';
                tabCode = 'assetGeneral';
                tabName = 'General';
                break;
            case entities.transaction.value:
                page += 'transaction-edit.html';
                controller = 'TransactionEditCtrl';
                tabCode = 'transactionGeneral';
                tabName = 'General';
                break;
            case entities.feeSchedule.value:
                page = 'billing/editors/views/feeSchedule-edit.html';
                controller = 'FeeScheduleEditCtrl';
                tabCode = 'fsGeneral';
                tabName = 'General';
                extraInfo = {isFeeSchedule: extraInfo ? extraInfo.isFeeSchedule : true};
                break;
            case entities.billMasterPayout.value:
                page = 'billing/editors/views/payoutSchedule-edit.html';
                controller = 'PayoutScheduleEditCtrl';
                tabCode = 'psGeneral';
                tabName = 'General';
                break;
            case entities.cancellationFeeAdjustment.value:
                page = 'billing/editors/views/cancellation-fee-adjustment-edit.html';
                controller = 'CancellationFeeAdjustmentEditCtrl';
                tabCode = 'cfadGeneral';
                tabName = 'General';
                break;
            case entities.billPayMethod.value:
                page = 'billing/editors/views/bill-pay-method-edit.html';
                controller = 'BillPayMethodEditCtrl';
                tabCode = 'bpmGeneral';
                tabName = 'General';
                break;
            case entities.businessLine.value:
                page = 'advisor/editors/views/business-line-edit.html';
                controller = 'BusinessLineEditCtrl';
                tabCode = 'businessLineGeneral';
                tabName = 'General';
                break;
            case entities.subAdvisor.value:
                page = 'advisor/editors/views/subadvisor-edit.html';
                controller = 'SubAdvisorEditCtrl';
                tabCode = 'subAdvisorGeneral';
                tabName = 'General';
                break;
            case entities.wholesaler.value:
                page = 'advisor/editors/views/wholesaler-edit.html';
                controller = 'WholesalerEditCtrl';
                tabCode = 'wholesalerGeneral';
                tabName = 'General';
                break;
            case entities.ria.value:
                page = 'advisor/editors/views/ria-edit.html';
                controller = 'RIAEditCtrl';
                tabCode = 'riaGeneral';
                tabName = 'General';
                break;
            case entities.registrationType.value:
                page = 'portfolio/editors/views/registrationTypeEdit.html';
                controller = 'RegistrationTypeEditCtrl';
                tabCode = 'rtGeneral';
                tabName = 'General';
                break;
            case entities.billAdjustmentType.value:
                page = 'billing/editors/adjustment-type-edit.html';
                controller = 'AdjustmentTypeEditCtrl';
                tabCode = 'billAdjustmentGeneral';
                tabName = 'General';
                break;
            case entities.feeType.value:
                page = 'billing/editors/views/feeType-edit.html';
                controller = 'FeeTypeEditCtrl';
                tabCode = 'feeTypeGeneral';
                tabName = 'General';
                break;
            case entities.thirdPartyAdministrator.value:
                page = 'advisor/editors/views/planadministrator-edit.html';
                controller = 'PlanAdministratorEditCtrl';
                tabCode = 'paGeneral';
                tabName = 'General';
                break;
            case entities.billEntity.value:
                page = 'billing/editors/bill-entity-edit.html';
                controller = 'BillEntityEditCtrl';
                tabCode = 'billEntityGeneral';
                tabName='General';
                break;
            case entities.payee.value:
                page = 'advisor/editors/views/payee-edit.html';
                controller = 'PayeeEditCtrl';
                tabCode = 'payeeGeneral';
                tabName='General';
                break;

        }

        if (defaultTabNameOverride) {
            tabName = defaultTabNameOverride;
        }

        if (defaultTabCodeOverride) {
            tabCode = defaultTabCodeOverride;
        }

        var d = $dialog.editor(page, controller, {
            args: function () {
                return {
                    ids: entityIds,
                    isNew: entityIds.length == 0,
                    app: appName,
                    defaultTab: {name: tabName, active: true, code: tabCode},
                    extraInfo: extraInfo || {}
                };
            }
        });

        return d.open().then(function (rslt) {
            return rslt;
        });
    };

    self.openMassEditor = function (entity, entityIds, appName, extraInfo) {
        var d = $dialog.editor('app/modals/massUpdate.html', 'MassUpdateCtrl', {
            args: function () {
                return {ids: entityIds, entity: entity, app: appName, extraInfo: extraInfo};
            }
        });
        return d.open().then(function (rslt) {
            if (rslt) {
                return rslt;
            }
        });
    };

    self.enumToSimpleList = function (enumObject) {
        return enumObject.values().map(function (value) {
            return {id: parseInt(value.value), name: value.name};
        });
    };

    self.cleanCustomField = function (field) {
        if (!field) return;

        if (!field.category) field.category = "No Category";

        switch (field.type) {
            case "Check box":
                field.value = field.value ? field.value.toString().toLowerCase() === 'true' : false;
                break;
            case "Currency":
            case "Double":
                field.value = parseFloat(field.value);
                break;
            case "Date/Time":
            case "Time":
                field.value = field.value ? Date.create(field.value).format('{M}/{d}/{yyyy} {12hr}:{mm}:{ss} {TT}') : "";
                break;
            case "Integer":
            case "Long":
                field.value = parseInt(field.value);
                break;
            case "Custom object":
                if (field.input) {
                    if (field.input.has("multi-select") && field.input !== "big-multi-select") {
                        field.value = field.value ? (angular.isString(field.value) ? field.value.split(",") : field.value): [];
                    } else if (field.input === "select-plus") {
                        if (!field.options[field.value]) {
                            field.options[field.value] = field.value;
                        }
                        field.originalOptions = field.options;
                        field.options = Object.values(field.options);
                    }
                    else if (field.input === "positive-currency") {
                        field.value = parseFloat(field.value);
                    }
                }
                break;
        }
    };

    self.makeCustomFieldFromDefinition = function (def, entityLevel) {
        return angular.extend({entity: entityLevel, value: def.defaultValue, name: def.description, input: def.controlProperties, options: def.options.map("listValue")}, Object.select(def, "category", "code", "securityCode", "sequence", "type"));
    };

    self.cleanCustomFields = function (customFields) {
        if (!customFields) return;

        customFields.forEach(function (field) {
            self.cleanCustomField(field);
        });
    };

    self.restoreEntityOption = function (entityOption) {
        if (!entityOption) return;

        var field = angular.copy(entityOption);
        switch (field.type) {
            case "Check box":
                field.value = String(field.value).capitalize();
                break;
            case "Currency":
            case "Integer":
            case "Double":
            case "Long":
                field.value = String(field.value);
                break;
            case "Date":
                if (field.value) {
                    field.value = Date.create(field.value).format('{M}/{d}/{yyyy}');
                }
                break;
            case "Date/Time":
            case "Time":
                if (field.value) {
                    field.value = Date.create(field.value).format('{M}/{d}/{yyyy} {12hr}:{mm}:{ss} {TT}');
                }
                break;
            case "Custom object":
                if (field.input) {
                    if (field.input.has("multi-select") && field.input !== "big-multi-select") {
                        field.value = field.value.join();
                    } else if (field.input === "select-plus") {
                        field.value = Object.find(field.originalOptions, field.value) || field.value;
                        field.options = field.originalOptions;
                        delete field.originalOptions;
                    } else if (field.input === "positive-currency") {
                        field.value = String(field.value); 
                    }
                }
                break;
        }

        return field;
    };

    self.restoreEntityOptions = function (entityOptions) {
        if (!entityOptions) return;

        var restoredEOs = angular.copy(entityOptions);

        restoredEOs.forEach(function (field, index) {
            restoredEOs[index] = self.restoreEntityOption(field);
        });

        return restoredEOs;
    };

    self.openUrlWithPost = function(url, params, target) {
        var form = document.createElement("form");
        form.setAttribute("target", target || "_blank");
        form.setAttribute("method", 'POST');
        form.setAttribute("action", url);

        if (params) {
            Object.each(params, function (key, value) {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", key);
                hiddenField.setAttribute("value", value);
                form.appendChild(hiddenField);
            });
        }

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    };

    self.launchDeliverMessageSetUp = function(itemId,isOneTime){
        $location.url('/reports/rbdeliver');

        if (itemId === undefined){
            itemId = 0;
        }

        var config = {
            itemId: itemId,
            isNew: itemId === 0,
            isOneTime: isOneTime
        };

        var d = $dialog.dialog({
            dialogClass: "modal wide",
            templateUrl: 'reporting/rbdeliver/modals/deliver-message-setup.html',
            controller: 'DeliverMessageSetupCtrl',
            resolve: {
                args: function () {
                    return config;
                }
            }
        });

        d.open().then(function (rslt) {
            if (rslt) {
            }
        });
    };
});

'use strict';

app.directive('entitySelector', function entitySelector($http, $dialog, entities) {
    return {
		restrict: 'E',
		scope: {
			current: '=ngModel',
            disableAutoFocus: '=',
            entitySelected: '&entitySelected'
		},
		replace: true,
		templateUrl: 'reporting/directives/entitySelector.html',
        link: function (scope, element, attrs) {
			//INTIALIZE
			if (scope.selected === undefined) {
				scope.selected = {};
			}
			if (scope.current.selectedEntities === undefined) {
				scope.current.selectedEntities = [];
			}

            if (scope.allowedDynamicReportingGroupEntities === undefined) {
                scope.allowedDynamicReportingGroupEntities = [];
            }

            scope.importCount = 0;
            scope.dynamicReportingGroups = {};
            scope.dynamicReportingGroupMode = false;
            scope.allowedImportEntities = ['Household', 'Portfolio Group', 'Account', 'Registration'];
            scope.searchOptionsOverride = scope.current.simpleMode ? '{advancedSearch: false}' : '';

            //function loadDynamicReportingGroupEntities(){
                $http.get('/Utility/Groupings/Entities?usedFor=Reporting', {trackerMsg: 'Loading dynamic report group entities'})
                    .then(function(response){
                        scope.allowedDynamicReportingGroupEntities = response.data;
                    });
			//}

			function loadDynamicReportingGroups(){
                if(scope.dynamicReportingGroupMode) {
                    var selectedEntity = scope.current.entity;
                    if (scope.dynamicReportingGroups[selectedEntity] === undefined) {
                        scope.dynamicReportingGroups[selectedEntity] = [];

                        $http.get('/Utility/Groupings/Simple?usedFor=Reporting&entity=' + selectedEntity, {

                            trackerMsg: 'Loading dynamic report group entities'
                        })
                            .then(function (response) {
                                scope.dynamicReportingGroups[selectedEntity] = response.data;
                            });
                    }
                }
			}

			function addToEntityList(entity, id, name, childItems) {
				if (scope.current.selectedEntities.none({ key: entity + '-' + id })) {
					scope.current.selectedEntities.push(makeEntityItem(entity, id, name, childItems));
                    scope.$emit('rc-entity--selector-event:entity-change', scope.current.selectedEntities);
				}
			}

            function makeEntityItem(entity, id, name, childItems) {
                return { key: entity + '-' + id, entity: entity, entityId: id, name: name, items: childItems, icon: entity.toLowerCase() };
            }

			function resetSearch() {
                scope.dynamicReportingGroupMode = scope.dynamicReportingGroupMode && scope.allowedDynamicReportingGroupEntities.includes(scope.current.entity);
				scope.selected.entity = null;
				scope.current.selectedEntities = [];
                loadDynamicReportingGroups();
			}

            function seedEntityList( ){
                var ids = scope.current.entityIds;

                if (ids && ids.length > 0 && !scope.current.entityIdsSeeded) {
                    var entity = entities[entities.find({name: scope.current.entity})];
                    $http.post(entity.simpleUrl + "/List", ids, {trackerMsg: 'Processing ' + entity.name})
                        .then(function (response) {
                            if (response.data.length !== ids.length) {
                                $dialog.actionFailed('Failed Action: Loading portfolio tree').open();
                            }
                            else {
                                response.data.forEach(function(item) {
                                    addToEntityList(scope.current.entity, item.id, item.name);
                                });
                            }
                        })
                        .catch(function(error) {
                            console.error('Failed to seed entity list:', error);
                            $dialog.actionFailed('Failed to load entity data').open();
                        })
                        .finally(function() {
                            scope.current.entityIdsSeeded = true;
                        });
                }
            }

			//PUBLIC METHODS
			scope.current.isValid = function () {
				return (scope.current.entity !== 'Prospect' && scope.current.selectedEntities.length > 0) || (scope.current.entity === 'Prospect' && scope.current.prospectId)|| ['Database'].any(scope.current.entity);
			};

            scope.dashifyIcon = (icon) => {
                return icon.replace(/ /g, '-');
            };

			scope.removeEntity = function (index) {
				scope.current.selectedEntities.splice(index, 1);
                scope.$emit('rc-entity--selector-event:entity-change', scope.current.selectedEntities);
			};

			scope.addToList = function (selected) {
				if(scope.dynamicReportingGroupMode){
                    $http.get("/Utility/Groupings/"+ scope.selected.entity.id +"?doRefresh=true", {trackerMsg: 'Loading report group members'})
                        .then(function (response) {
							var childItems = [];
                            response.data.details.forEach(function(member) {
                                childItems.push(makeEntityItem(member.entity, member.entityId, member.name));
                            });
                            addToEntityList(entities.dynamicReportingGroup.value, scope.selected.entity.id, scope.selected.entity.name, childItems);
                            scope.selected.entity = null;
                        });
				}else if(scope.current.entity === 'Product'){
                    addToEntityList(scope.current.entity, selected.productId, selected.productName);
                    scope.selected.entity = null;
                }else if(scope.current.entity === 'Prospect'){
                    scope.current.prospectId = selected.prospectId;
                    scope.current.prospectName = selected.name;
                    scope.selected.entity = null;
                }
                else{
					addToEntityList(scope.current.entity, selected.id, selected.name);
                    scope.selected.entity = null;
				}

                if (scope.entitySelected) scope.entitySelected(selected);
			};

			scope.addEntity = function () {
				/*if (scope.current.runForParameter.value.has(",")) {
					addToEntityList(scope.selected.entity.type, scope.selected.entity.id, scope.selected.entity.name);

					if (scope.selected.entity.type === entities.client.value && scope.user.authorization.entity !== entities.client.name) {
						scope.current.searchEntity = null;
					} else {
						scope.selected.entity.selected = false;
						scope.current.items[0].selected = true;
						scope.selected.entity = scope.current.items[0];
					}
				} else {*/
					addToEntityList(scope.current.entity, scope.selected.entity.id, scope.selected.entity.name);
					scope.selected.entity = null;
				//}
			};

            scope.importEntityIds = function() {
                var entity = entities[entities.find({name: scope.current.entity})];

                $dialog.inputBox("Import " + entity.name + " IDs", "File", "file", {postUrl: "/ValidateImport/Echo"})
                    .open()
                    .then(function(data){
                            if (!data) return;

                            var ids = Object.values(data[0].result)[0].map(function (x) {
                                return Object.values(x)[0];
                            });

                            if (ids.length > 0) {
                                $http.post(entity.simpleUrl + "/List", ids, {trackerMsg: 'Processing ' + data[0].fileName})
                                    .then(function (response) {
                                        var childItems = [];
                                        response.data.forEach(function(item) {
                                            childItems.push(makeEntityItem(entity.value, item.id, item.name));
                                        });
                                        var importFileName = "Import File";
                                        if (scope.importCount > 0){
                                            importFileName += " ("+scope.importCount+")";
										}
                                        addToEntityList("import", scope.importCount, importFileName, childItems);
                                        scope.importCount++;
                                    });
                            }
                        }
                    );
            };

            scope.toggleDynamicReportingGroupMode = function(){
                scope.dynamicReportingGroupMode = !scope.dynamicReportingGroupMode;
                resetSearch();
			};

            scope.removeProspect = function() {
                scope.current.prospectId = null;
                scope.current.prospectName = null;
            };
			
            //SCOPE WATCHERS
			scope.$watch("current.entity", function (newValue, oldValue) {
				if (newValue === oldValue) return;

				resetSearch();				
			});

            seedEntityList();
		}
    };
});

'use strict';

app.directive('date', function date($http, entities) {
    return {
        templateUrl: function ($element, $attrs) {
            var qualifier = '';

            if ($attrs.renderAs) {
                qualifier = "-" + $attrs.renderAs;
            }

            return "reporting/directives/date" + qualifier + ".html";
        },
        restrict: 'E',
        scope: {
			current: '=ngModel',
        },
		replace: true,
        link: function (scope, element, attrs) {
			//PUBLIC METHODS
			scope.current.isValid = function () {
				return scope.current.value || scope.current.date;
			};
        }
    };
});

'use strict';

app.directive('dateRange', function dateRange($http, entities) {
    return {
        restrict: 'E',
        scope: {
			current: '=ngModel',
			setInception: '&setInception'
        },
		replace: true,
		templateUrl: 'reporting/directives/dateRange.html',
		link: function (scope, element, attrs) {
            //INITIALIZE
            scope.dateRanges = [];
            scope.structuredDateRanges = [];

			//PUBLIC METHODS
			scope.current.isValid = function () {
				return scope.current.end.date && (scope.current.start.date || scope.current.useInception);
			};

			scope.setDates = function (rangeId) {
                var dr = scope.dateRanges.find({id: rangeId});

				scope.current.start.date = dr.startDate;
				scope.current.end.date = dr.endDate;
				scope.current.useInception = false;
			};

			var today = Date.create().addDays(-1).format('{yyyy}-{MM}-{dd}');
            $http.get("/Reporting/Calculate/DateRanges/{1}?isDefault=true".assign(today), {trackerMsg: 'Loading date ranges'})
                .then(function (response) {
                    response.data.sortBy("sortOrder").forEach(function(item) {
                    	if(item.startDate){
                        	scope.dateRanges.push({id: item.id, name: item.name, startDate: Date.create(item.startDate).format('{M}/{d}/{yyyy}'), endDate: Date.create(item.endDate).format('{M}/{d}/{yyyy}')});
                    	}
                    });

                    if(!scope.dateRanges.isEmpty()){
                        var index = 0;
                        var structuredDateRange = [];
						scope.dateRanges.forEach(function(dr) {
                            structuredDateRange.push(dr);
							if(index % 2 === 1){
                                scope.structuredDateRanges.push(structuredDateRange);
                                structuredDateRange = [];
							}
							index++;
						});
						if(structuredDateRange.length !== 0){
                            structuredDateRange.push({});
                            scope.structuredDateRanges.push(structuredDateRange);
                        }
					}
                });
			
			//SCOPE WATCHERS
			scope.$watch("current.useInception", function (newValue, oldValue) {
				//had to use a watch because ng-click on a btn-checkbox acts weird
				if (newValue === oldValue || !newValue) return;

				scope.setInception();
			});
        }
    };
});

'use strict';

app.directive('prompt', function prompt() {
    return {
        restrict: 'E',
        scope: {
			current: '=ngModel'
        },
		replace: true,
		templateUrl: 'reporting/directives/prompt.html',
		link: function (scope) {
			function init() {
				//INITIALIZE
				scope.current.isIgnored = false;
				
				const prompt = scope.current;
				Object.defineProperties(prompt, {
					'intValue': {
						get: function () {
							return parseInt(prompt.value);
						},
						set: function (value) {
							prompt.value = value.toString();
						}
					},
					'floatValue': {
						get: function () {
							return parseFloat(prompt.value);
						},
						set: function (value) {
							prompt.value = value.toString();
						}
					},
					'percValue': {
						get: function () {
							return parseFloat(prompt.value) * 100;
						},
						set: function (value) {
							prompt.value = (value / 100).toString();
						}
					},
					'dateValue': {
						get: function () {
							return prompt.value;
						},
						set: function (value) {
							prompt.value = Date.create(value).format('{yyyy}-{MM}-{dd}');
						}
					},
					'boolValue': {
						get: function () {
							return !!prompt.value;
						},
						set: function (value) {
							prompt.value = value.toString();
						}
					}
				});
			}
			//PUBLIC METHODS
			scope.displayFilterType = function() {
				var filterDisplay = scope.current.filterType.replace(/-/g," ").capitalize(true, true);

				switch(scope.current.filterType) {
					case "equal":
						filterDisplay += "s";
						break;
					case "not-equal":
						filterDisplay = "Does " + filterDisplay;
						break;
					case "not-contains":
						filterDisplay = "Does " + filterDisplay.singularize();
						break;
					case "greater-than":
					case "less-than":
						filterDisplay = "Is " + filterDisplay;
						break;
					case "greater-than-equal":
					case "less-than-equal":
						filterDisplay = "Is " + filterDisplay.replace("Equal", "Or Equal To");
						break;
				}

				return filterDisplay;
			};

			scope.getInputWidth = function() {
				switch(scope.current.filterType) {
					case "equal":
						return scope.showResultType() ? "210px" : "274px";
					case "not-equal":
						return scope.showResultType() ? "154px" : "274px";
					case "contains":
						return scope.showResultType() ? "196px" : "274px";
					case "not-contains":
						return scope.showResultType() ? "140px" : "274px";
					case "greater-than":
						return scope.showResultType() ? "156px" : "274px";
					case "less-than":
						return scope.showResultType() ? "176px" : "274px";
					case "greater-than-equal":
						return scope.showResultType() ? "81px" : "274px";
					case "less-than-equal":
						return scope.showResultType() ? "101px" : "274px";
					case "ends-with":
						return scope.showResultType() ? "188px" : "274px";
					case "starts-with":
						return scope.showResultType() ? "182px" : "274px";
					case "range":
						return scope.showResultType() ? "211px" : "274px";
				}
			};

			scope.showResultType = function() {
				return ['range', 'equal'].none(scope.current.filterType);
			};

			scope.boolOptions = [
				{ name: "True", value: true },
				{ name: "False", value: false }
			];

			scope.ignorePrompt = function() {
				scope.current.isIgnored = !scope.current.isIgnored;
			};

			init();
        }
    };
});


'use strict';

app.directive('deliveryMethod', function deliveryMethod($http, entities) {
    return {
        restrict: 'E',
        scope: {
			current: '=ngModel',
            getCombinationMethods: '&getCombinationMethods',
            getCloudProvidersPromise: '&getCloudProvidersPromise',
            numEntities: '=numEntities'
        },
		replace: true,
		templateUrl: 'reporting/directives/delivery-method.html',
        link: function (scope, element, attrs) {
            //INITIALIZE
            var cachedFolderTrees = {};
            scope.selected = {deliveryMethod: scope.current.options[0]};

            if (scope.current.hideScreenOutputFormat === true) {
                scope.formatOptions = [{name: 'PDF', value: 'PDF'}];
                scope.current.reportFormat = "PDF";
            } else {
                scope.formatOptions = [{name: 'Screen', value: 'Html'}, {name: 'PDF', value: 'PDF'}];
            }

            scope.combinationMethods = scope.getCombinationMethods();
            scope.folderSelector = {selectedFolder: null, items: []};
            scope.current.combinationMethod = scope.combinationMethods[0].value;

			//PUBLIC METHODS
			scope.current.isValid = function () {
				return scope.current.value;
			};

            scope.getCloudProviders = function() {
				scope.getCloudProvidersPromise()
                    .then(function (response) {
                        var index = 1;
                        response.data.forEach(function(item) {
                            if (scope.current.options.none({provider: item.provider})) {
                                scope.current.options.splice(index, 0, {storageType: "CloudStorage", displayName: item.provider, provider: item.provider, folderPath: null});
                                index++;
                            }
                        });
                    });
            };

            scope.setDefaultCombinationMethod = function() {
                scope.current.combinationMethod = "None";
            };
            scope.setCurrentFromSelected = function() {
                scope.current.storageType = scope.selected.deliveryMethod.storageType;
                scope.current.displayName = scope.selected.deliveryMethod.displayName
                scope.current.provider = scope.selected.deliveryMethod.provider;
                scope.current.folderPath = scope.selected.deliveryMethod.folderPath;
            };

            scope.buildFolderTree = function() {
                scope.setDefaultCombinationMethod();
                scope.setCurrentFromSelected();

                if (scope.current.storageType !== "CloudStorage") return;

                var tree = cachedFolderTrees[scope.current.provider];

                if (!tree) {
                    tree = [];
                    var node = {label: scope.current.displayName, id: "/", collapsed: false, selected: true, children: [], isLoaded: false};
                    tree.push(node);
                    cachedFolderTrees[scope.current.provider] = tree;
                    scope.folderSelector.selectedFolder = node;
                }

                scope.folderSelector.items = tree;
            };

            scope.reportFormatChanged = function(){
                scope.combinationMethods = scope.getCombinationMethods();
                scope.current.combinationMethod = scope.combinationMethods[0].value;

                if(scope.current.reportFormat === 'Html'){
                    scope.setDefaultCombinationMethod();
                }
            };


            scope.changeSelectedInbox = function(selected) {
                if (selected) {
                    scope.current.userIdList = [selected.userId];
                } else {
                    scope.current.userIdList = null;
                }
            };

            scope.addNewFolder = function() {
                var selectedFolder = scope.folderSelector.selectedFolder;
                var newNode = {label: scope.current.newCloudFolder, id: selectedFolder.id + (selectedFolder.id.endsWith("/") ? "" : "/") + scope.current.newCloudFolder, collapsed: false, selected: true, children: [], isLoaded: true};

                selectedFolder.selected = false;
                selectedFolder.children.push(newNode);
                scope.folderSelector.selectedFolder = newNode;

                scope.current.newCloudFolder = null;
            };

            //SCOPE WATCHERS
            scope.$watch("folderSelector.selectedFolder", function (newValue, oldValue) {
                if (newValue === oldValue) return;
                var node = scope.folderSelector.selectedFolder;
                scope.current.folderPath = node.id;

                if (!node.isLoaded) {
                    $http.get("/Integrations/CloudStorage/" + scope.current.provider + "/Browse" + node.id, {trackerMsg: 'Loading folder paths'})
                        .then(function (response) {
                            var folders = response.data.folders.sortBy("name");
                            folders.forEach(function (folder) {
                                node.children.push({label: folder.name, id: folder.path, collapsed: true, selected: false, children: [], isLoaded: false});
                            });

                            node.isLoaded = true;
                        });
                }
            }, true);

            scope.getCloudProviders();
        }
    };
});

'use strict';

app.directive('activityCategoryParameter', function activityCategoryParameter() {
    return {
        restrict: 'E',
        scope: {
            options: '=',
            value: '=',
            disabled: '=',
            closeFn: '&',
            openFn: '&'
        },
        template:   '<div dropdown dropdown-append-to-body auto-close="outsideClick" on-toggle="toggled(open)" class="dropdown">' +
                        '<button dropdown-toggle class="btn btn-block" style="font-size: 13px;" ng-disabled="disabled">{{ current.omitCount }} Omitted <b class="caret"></b></button>' +
                        '<div class="parameter dropdown-menu dropdown-menu-right">' +
                            '<tabs>' +
                                '<pane heading="Mapping">' +
                                    '<label ng-repeat="a in current.activityList">' +
                                        '{{ a.name }}' +
                                        '<select ng-model="a.category" class="input-block-level" ng-options="c.currentName as c.currentName for c in current.categoryList" ng-change="syncOmitCount()"></select>' +
                                    '</label>' +
                                '</pane>' +
                                '<pane heading="Categories">' +
                                    '<div class="input-append" style="margin-bottom:20px;" ng-model-options="{updateOn: \'default\'}">' +
                                        '<input type="text" ng-model="current.newCategory" style="width: 193px;" placeholder="new category" />' +
                                        '<button class="btn btn-primary" ng-click="addCategory()" ng-disabled="!current.newCategory">Add</button>' +
                                    '</div>' +
                                    '<div ui-sortable="{handle: \'.add-on\'}" ng-model="current.categoryList">' +
                                        '<div ng-repeat="c in current.categoryList" ng-hide="c.currentName == current.omitValue">' +
                                            '<div class="input-append">' +
                                                '<input type="text" style="width: 214px;" ng-model="c.currentName" ng-blur="updateActivityList(c)" />' +
                                                '<span class="add-on" title="Drag to reorder">&nbsp;<i class="fa fa-exchange fa-rotate-90" aria-hidden="true"></i></span>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</pane>' +
                            '</tabs>' +
                        '</div>' +
                    '</div>',
        replace: true,
        link: function(scope) {
            //PUBLIC METHODS
            scope.toggled = function (open) {
                if (open) {
                    scope.openFn();
                } else {
                    var activityCategories = scope.current.categoryList.map(function(category) {
                        return {name: category.currentName, activity: {}};
                    });
                    scope.current.activityList.forEach(function(activity) {
                        activityCategories.find({name: activity.category}).activity[activity.value] = activity.name;
                    });
                    scope.value = JSON.stringify(activityCategories.remove({name: scope.current.omitValue}));

                    scope.closeFn();
                }
            };

            scope.updateActivityList = function(category) {
                if (category.previousName === category.currentName) return;

                scope.current.activityList.forEach(function (activity) {
                    if (activity.category === category.previousName) {
                        activity.category = category.currentName;
                    }
                });

                category.previousName = category.currentName;
            };

            scope.addCategory = function() {
                scope.current.categoryList.push({previousName: scope.current.newCategory, currentName: scope.current.newCategory});
                scope.current.newCategory = null;
            };

            scope.syncOmitCount = function() {
                scope.current.omitCount = scope.current.activityList.count({category: scope.current.omitValue});
            };


            //INITIALIZE
            scope.current = {categoryList: [], activityList: [], newCategory: null, omitCount: 0, omitValue: 'Omit'};


            //SCOPE WATCHERS
            scope.$watch('value', function () {
                //using a watch here because it's possible for the value to get swapped out from outside of the control
                var value =  JSON.parse(scope.value);
                scope.current.categoryList = [];
                scope.current.activityList = [];

                scope.current.categoryList.push({previousName: scope.current.omitValue, currentName: scope.current.omitValue});

                value.forEach(function (category) {
                    scope.current.categoryList.push({previousName: category.name, currentName: category.name});
                });

                var getCategory = function(key) {
                    for (var i = 0; i < scope.current.categoryList.length; i++) {
                        var catName = scope.current.categoryList[i].currentName;
                        if (catName !== scope.current.omitValue && value.find({name: catName}).activity[key]) {
                            return catName;
                        }
                    }
                    return scope.current.omitValue;
                };

                Object.keys(scope.options).forEach(function (key) {
                    scope.current.activityList.push({name: scope.options[key], value: key, category: getCategory(key)});
                });

                scope.syncOmitCount();
            });
        }
    }
});


'use strict';

app.directive('hoverControl', function hoverControl(reportHelper) {
    return {
        link: function (scope, element) {
            element.on('mouseover', function (event) {
                reportHelper.hoverControl(event);
            });
        },
    };
});

'use strict';

app.directive('multiCheckedSelectParameter', function multiCheckedSelectParameter() {
    return {
        restrict: 'E',
        scope: {
            value: '=',
            disabled: '=',
            closeFn: '&',
            openFn: '&'
        },
        template:   '<div dropdown dropdown-append-to-body auto-close="outsideClick" on-toggle="toggled(open)" class="dropdown">' +
                        '<button dropdown-toggle class="btn btn-block" style="font-size: 13px;" ng-disabled="disabled">{{ items.count({isChecked: true}) }}/{{ items.length }} Managed <b class="caret"></b></button>' +
                        '<ul class="parameter dropdown-menu dropdown-menu-right">' +
                            '<li ng-repeat="item in items track by item.id"><label class="checkbox"><input type="checkbox" ng-model="item.isChecked" ng-change="updateValues()" /> {{ item.name }}</label></li>' +
                        '</ul>' +
                    '</div>',
        replace: true,
        link: function(scope) {
            //PUBLIC METHODS
            scope.toggled = function (open) {
                if (open) {
                    scope.openFn();
                } else {
                    scope.value = JSON.stringify(scope.items);
                    scope.closeFn();
                }
            };

            scope.updateValues = function () {
                scope.value = JSON.stringify(scope.items);
            };


            //SCOPE WATCHERS
            scope.$watch('value', function () {
                //using a watch here because it's possible for the value to get swapped out from outside of the control
                scope.items = JSON.parse(scope.value);
            });
        }
    }
});

'use strict';

app.directive('multiRangeParameter', function multiRangeParameter() {
    return {
        restrict: 'E',
        scope: {
            options: '=',
            value: '=',
            disabled: '=',
            closeFn: '&',
            openFn: '&'
        },
        template:   '<div dropdown dropdown-append-to-body auto-close="outsideClick" on-toggle="toggled(open)" class="dropdown">' +
                        '<button dropdown-toggle class="btn btn-block" style="font-size: 13px;" ng-disabled="disabled">{{current.ranges.length}} Periods <b class="caret"></b></button>' +
                        '<div class="parameter dropdown-menu dropdown-menu-right">' +
                            '<table style="width:100%;">' +
                                '<tr>' +
                                    '<td class="text-right" style="padding: 0 15px 10px 0;">Period Start</td>' +
                                    '<td><input type="number" min="0" max="365" ng-model="current.newRange.start" class="input-block-level" /></td>' +
                                    '<td><select ng-model="current.newRange.startType" class="input-block-level"><option value="day">Days</option><option value="year">Years</option></select></td>' +
                                '</tr>' +
                                '<tr>' +
                                    '<td class="text-right" style="padding: 0 15px 10px 0;">Period End</td>' +
                                    '<td><input type="number" min="0" max="365" ng-model="current.newRange.end" class="input-block-level" /></td>' +
                                    '<td><select ng-model="current.newRange.endType" class="input-block-level"><option value="day">Days</option><option value="year">Years</option></select></td>' +
                                '</tr>' +
                            '</table>' +
                            '<button class="btn btn-block" ng-click="addRange()" ng-disabled="(current.newRange.start != 0 && !current.newRange.start) || (current.newRange.end != 0 && !current.newRange.end)"><i class="fa fa-plus" aria-hidden="true"></i> Add New Range</button>' +
                            '<table class="table table-condensed no-bottom-margin" style="border:1px solid #ccc;">' +
                                '<thead>' +
                                    '<tr><th>&nbsp;</th><th>Start</th><th>End</th></tr>' +
                                '</thead>' +
                                '<tbody>' +
                                    '<tr ng-show="current.ranges.length == 0"><td colspan="3"><em>No ranges found</em></td></tr>' +
                                    '<tr ng-repeat="range in current.ranges">' +
                                        '<td><button class="btn btn-link" ng-click="deleteRange($index)"><i class="fa fa-times" aria-hidden="true"></i></button></td>' +
                                        '<td>{{ range.start | multiRangeFormatter }}</td>' +
                                        '<td>{{ range.end | multiRangeFormatter }}</td>' +
                                    '</tr>' +
                                '</tbody>' +
                            '</table>' +
                        '</div>' +
                    '</div>',
        replace: true,
        link: function(scope) {
            //PUBLIC METHODS
            scope.toggled = function (open) {
                if (open) {
                    scope.openFn();
                } else {
                    scope.value = JSON.stringify(scope.current.ranges);
                    scope.closeFn();
                }
            };

            scope.addRange = function() {
                var start = scope.current.newRange.startType === 'year' ? (scope.current.newRange.start * 365) + 1 : scope.current.newRange.start;
                var end = scope.current.newRange.endType === 'year' ? scope.current.newRange.end * 365 : scope.current.newRange.end;

                if (scope.current.ranges.none(function(range) { return range.start === start && range.end === end; })) {
                    scope.current.ranges.push({start: start, end: end});
                    scope.current.ranges = scope.current.ranges.sortBy("start");
                }

                scope.current.newRange.start = scope.current.newRange.end + 1;
                scope.current.newRange.end = scope.current.newRange.start + 1;
            };

            scope.deleteRange = function(index) {
                scope.current.ranges.splice(index, 1);
            };


            //INITIALIZE
            scope.current = {ranges: [], newRange: {start: 0, startType: 'day', end: 0, endType: 'day'}};


            //SCOPE WATCHERS
            scope.$watch('value', function () {
                //using a watch here because it's possible for the value to get swapped out from outside of the control
                scope.current.ranges = JSON.parse(scope.value);
            });
        }
    }
});

app.filter('multiRangeFormatter', function() {
    return function(input) {
        return input > 365 ? parseInt(input / 365) + ' Years' : input + ' Days';
    }
});
'use strict';

app.directive('multiSelectParameter', function multiSelectParameter() {
    return {
        restrict: 'E',
        scope: { choices: '=', selected: '=', disabled: '=', showUseAssigned: '@', closeFn: '&', openFn: '&', changeFn: '&', disableOptionFn : '&', hideSelectAll: '=', hideDeselectAll: '=' },
        template:   '<div dropdown dropdown-append-to-body dropdown-zindex-from-parent auto-close="outsideClick" on-toggle="toggled(open)" class="dropdown">' +
                        '<button dropdown-toggle class="btn btn-block" style="font-size: 13px;" ng-disabled="disabled" data-test-id="btn{{ ::uniqueId }}Toggle">{{optionsDisabled() ? \'Use Assigned\' : selected.length + \' Selected\'}} <b class="caret"></b></button>' +
                        '<ul class="parameter dropdown-menu dropdown-menu-right">' +
                            '<li class="clearfix"><button class="btn btn-mini btn-link pull-left" ng-hide="hideSelectAll"  ng-click="setAll(true)" data-test-id="lnk{{ ::uniqueId }}SelectAll">Select All</button><button class="btn btn-mini btn-link pull-right" ng-hide="hideDeselectAll" ng-click="setAll(false)" data-test-id="lnk{{ ::uniqueId }}DeselectAll">Deselect All</button></li>' +
                            '<li ng-show="showUseAssigned"><label class="checkbox"><input type="checkbox" ng-checked="optionsDisabled()" ng-click="toggleOptions()" data-test-id="chkUseAssigned" />Use Assigned</label></li>' +
                            '<li ng-show="showUseAssigned" class="divider"></li>' +
                            '<li ng-repeat="(key, value) in choices"><label style="margin-left: 3px" class="checkbox"><input type="checkbox" ng-disabled="disable(value)" ng-click="toggleCheck(key)" ng-checked="isChecked(key)" data-test-id="chk{{ ::(uniqueId + key) }}_{{value}}" />{{value}}</label></li>' +
                        '</ul>' +
                    '</div>',
        replace: true,
        link: function(scope, element, attrs) {
            //PRIVATE METHODS
            function init(){
                if ( typeof(scope.inputType) === 'undefined' || !scope.inputType){
                    scope.inputType = 'checkbox';
                }
                if(scope.selected) {
                    if (!angular.isArray(scope.selected)) {
                        scope.selected = scope.selected.split(',');
                        commitChange();
                    }
                    if (scope.choices) {
                        scope.selected.each(function (s) {
                            if (Object.keys(scope.choices).none(s.toString().trim()))
                                scope.choices[s.toString()] = s;
                        });
                        commitChange();
                    }

                    setOptionEnableStatus();

                }
            }

            function commitChange() {
                return scope.changeFn({
                    selected: scope.selected,
                    choices: scope.choices
                });
            }

            function setOptionEnableStatus() {
                if (typeof (scope.optionDisabledStatus) === 'undefined') {
                    scope.optionDisabledStatus = {};
                }

                const choiceKeys = Object.keys(scope.choices || {});
                choiceKeys.each(function(key) {
                    if (typeof (scope.optionDisabledStatus) !== 'undefined') {
                        const selected = { optionId: scope.choices[key], selectedValues: scope.selected };
                        const isDisabled = scope.disableOptionFn() ? scope.disableOptionFn()(selected) : false;
                        scope.optionDisabledStatus[key] = isDisabled;
                        if (isDisabled) {
                            const index = scope.selected.indexOf(selected.optionId);
                            if (index >= 0) {
                                scope.selected.splice(index, 1);
                            }
                        }
                    } else {
                        scope.optionDisabledStatus[scope.choices[key]] = false;
                    }

                });
            }

            //PUBLIC METHODS
            scope.disable = function(value) {
                return scope.optionDisabledStatus && scope.optionDisabledStatus[value];
            };
            scope.toggled = function (open) {
                if (open) {
                    scope.openFn();
                } else {
                    scope.closeFn();
                }
            };

            scope.isChecked = function(id){
                return scope.selected ? scope.selected.indexOf(id) !== -1 : false;
            };

            scope.toggleCheck = function(id){
                if (scope.optionsDisabled())
                    scope.selected.length = 0;

                var index = scope.selected.findIndex(id);

                if (index === -1) scope.selected.push(id);
                else scope.selected.splice(index, 1);

                setOptionEnableStatus()
                commitChange();
            };

            scope.toggleOptions = function() {
                var wasDisabled = scope.optionsDisabled();

                scope.selected.length = 0;

                if (!wasDisabled) scope.selected.push("-1");

                commitChange();
            };

            scope.optionsDisabled = function() {
                //this is a function instead of a variable because scope.selected could be swapped out from under us at any time
                return scope.showUseAssigned && scope.selected.length === 1 && scope.selected[0] === "-1";
            };

            scope.setAll = function(checked) {
                scope.selected.length = 0;

                if (checked) {
                    Object.keys(scope.choices).each(function(key){
                        scope.selected.push(key);
                    });
                }
                if ( scope.selected.length === 0){
                    setOptionEnableStatus();
                }
                commitChange();
            };

            //INITIALIZE
            if(attrs.testId) {
                scope.uniqueId = attrs.testId.charAt(0).toLocaleUpperCase() + attrs.testId.slice(1);
            } else {
                scope.uniqueId = "";
            }

            init();
        }
    };
});

'use strict';

app.directive('multiSelectTreeParameter', function multiSelectTreeParameter() {
    return {
        restrict: 'E',
        scope: {
            selected: '=',
            choices: '=',
            disabled: '=',
            closeFn: '&',
            openFn: '&'
        },
        template:   '<div dropdown dropdown-append-to-body auto-close="outsideClick" on-toggle="toggled(open)" class="dropdown">' +
                        '<button dropdown-toggle class="btn btn-block" style="font-size: 13px;" ng-disabled="disabled">{{ selected.length }} Selected <b class="caret"></b></button>' +
                        '<ul class="parameter dropdown-menu dropdown-menu-right" style="width: 270px; overflow-x: auto;">' +
                            '<li class="clearfix"><button class="btn btn-mini btn-link pull-left" ng-click="setAll(true)">Select All</button><button class="btn btn-mini btn-link pull-right" ng-click="setAll(false)">Deselect All</button></li>' +
                            '<li ng-repeat="group in choices">' +
                                '<button class="btn btn-link" ng-click="group.showItems = !group.showItems" style="color:#333;"><i class="fa fa-fw fa-caret-{{ group.showItems ? \'down\' : \'right\' }}"></i></button><label class="checkbox inline"><input type="checkbox" ng-click="toggleGroupCheck(group)" ng-checked="isGroupChecked(group)" />{{ group.name }}</label>' +
                                '<ul class="unstyled" ng-if="group.showItems" style="padding-left: 40px;">' +
                                    '<li ng-repeat="item in group.items"><label class="checkbox"><input type="checkbox" ng-click="toggleItemCheck(item.id)" ng-checked="isItemChecked(item.id)" />{{ item.name }}</label></li>' +
                                '</ul>' +
                            '</li>' +
                        '</ul>' +
                    '</div>',
        replace: true,
        link: function(scope) {
            //PUBLIC METHODS
            scope.toggled = function (open) {
                if (open) {
                    scope.openFn();
                } else {
                    scope.closeFn();
                }
            };

            scope.isGroupChecked = function(group) {
                return group.items.all(function(item) {return scope.isItemChecked(item.id)});
            };

            scope.isItemChecked = function(id) {
                return scope.selected.indexOf(String(id)) !== -1;
            };

            scope.toggleGroupCheck = function(group) {
                if (scope.isGroupChecked(group)) {
                    group.items.forEach(function(item) {
                        scope.toggleItemCheck(item.id, false);
                    });
                }
                else {
                    group.items.forEach(function(item) {
                        scope.toggleItemCheck(item.id, true);
                    })
                }
            };

            scope.toggleItemCheck = function(id, addOnly) {
                id = String(id);

                var index = scope.selected.findIndex(id);

                if (index === -1)
                    scope.selected.push(id);
                else if (!addOnly)
                    scope.selected.splice(index, 1);
            };

            scope.setAll = function(checked) {
                scope.selected.length = 0;

                if (checked) {
                    for( var i = 0; i < scope.choices.length; i++ ) {
                        for( var j = 0; j < scope.choices[i].items.length; j++ ) {
                            scope.selected.push(String(scope.choices[i].items[j].id));
                        }
                    }
                }
            };
        }
    };
});
'use strict';

app.directive('richTextParameter', function richTextParameter() {
    return {
        restrict: 'E',
        scope: {
            text: '=',
            disabled: '=',
            closeFn: '&',
            openFn: '&',
            title: '@?'
        },
        template:   '<div dropdown dropdown-append-to-body auto-close="outsideClick" on-toggle="toggled(open)" class="dropdown">' +
                        '<button dropdown-toggle class="btn btn-block" style="font-size:13px;" ng-disabled="disabled">{{ ::title || \'Text Editor\' }} <b class="caret"></b></button>' +
                        '<div class="parameter dropdown-menu dropdown-menu-right">' +
                            '<textarea ui-tinymce="{toolbar: \'fontfamily fontsize | bold italic underline | alignleft aligncenter alignright | bullist numlist\'}" ng-model="text"></textarea>' +
                        '</div>' +
                    '</div>',
        replace: true,
        link: function(scope) {
            //PUBLIC METHODS
            scope.toggled = function (open) {
                if (open) {
                    scope.openFn();
                } else {
                    scope.closeFn();
                }
            };
        }
    };
});

'use strict';

app.directive('taxMethodsParameter', function taxMethodsParameter(costBasisMethods) {
    return {
        restrict: 'E',
        scope: {
            taxMethods: '=',
            methods: '=',
            disabled: '=',
            closeFn: '&',
            openFn: '&'
        },
        template:   '<div dropdown dropdown-append-to-body auto-close="outsideClick" on-toggle="toggled(open)" class="dropdown">' +
                        '<button dropdown-toggle class="btn btn-block" style="font-size: 13px;" ng-disabled="disabled">{{overrideCount == 0 ? \'Use Assigned\' : overrideCount + \' Overridden\'}} <b class="caret"></b></button>' +
                        '<div class="parameter dropdown-menu dropdown-menu-right">' +
                            '<table style="width:100%;">' +
                                '<tr ng-repeat="pair in methods | orderBy: \'productType.name\'">' +
                                    '<td class="text-right" style="padding: 0 15px 10px 0;">{{ pair.productType.name }}</td>' +
                                    '<td><select ng-options="m.method.value as m.method.name for m in pair.allowedMethods" ng-change="syncOverrideCount()" ng-model="selectedValues[pair.productType.name]" class="input-block-level"></select></td>'  +
                                '</tr>' +
                            '</table>' +
                        '</div>' +
                    '</div>',
        replace: true,
        link: function(scope) {
            //PUBLIC METHODS
            scope.toggled = function (open) {
                if (open) {
                    scope.openFn();
                } else {
                    scope.taxMethods = scope.methods.map(function (method) {
                        return method.productType.value + ',' + scope.selectedValues[method.productType.name];
                    }).join(";") + ";";

                    scope.closeFn();
                }
            };
            
            scope.syncOverrideCount = function() {
                scope.overrideCount = scope.methods.count(function (method) {
                    return scope.selectedValues[method.productType.name] !== parseInt(costBasisMethods.useAssigned.value)
                });
            };


            //INITIALIZE
            scope.selectedValues = {};


            //SCOPE WATCHERS
            scope.$watch('taxMethods', function () {
                //using a watch here because it's possible for the value to get swapped out from outside of the control
                var methodValues = {};
                scope.taxMethods.split(';').forEach(function (valuePair) {
                    var methodValueArray = valuePair.split(',');
                    methodValues[methodValueArray[0]] = methodValueArray[1];
                });

                scope.methods.forEach(function (method) {
                    scope.selectedValues[method.productType.name] = parseInt(methodValues[String(method.productType.value)]);
                });

                scope.syncOverrideCount();
            });
        }
    };
});
'use strict';

app.directive('themeStyleBlock', function themeStyleBlock() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            style: '=sectionStyle'
        },
        templateUrl: "reporting/directives/themeStyleBlock.html",
        link: function (scope, element, attrs) {
            scope.includeBackground = attrs.includeBackground ? scope.$eval(attrs.includeBackground) : true;
            scope.includeFont = attrs.includeFont ? scope.$eval(attrs.includeFont) : true;
            scope.includeBorder = attrs.includeBorder ? scope.$eval(attrs.includeBorder) : true;

            scope.fontFamilies = ["Arial", "Cambria", "Tahoma", "Times New Roman", "Verdana"];
            scope.fontSizes = ["6pt", "7pt", "8pt", "9pt", "10pt", "11pt", "12pt"];
            scope.borderStyles = ["None", "Solid", "Dashed", "Dotted"];
        }
    };
});
'use strict'

app.directive('bullBearParameter', function bullBearParameter($http){
    return {
        restrict: 'E',
        scope: {
            choices: '=',
            selected: '=',
            disabled: '='
        },
        template:   '<div>' +
                        '<label>' +
                            '<select class="parameter-input" ng-disabled="disabled" ng-model="selected" ng-options="k as v for (k,v) in choices"></select>' +
                        '</label>' +
                    '</div>',
        replace: true
    }
});
'use strict'

app.directive('feeBenchmarkFilterParameter', function feeBenchmarkFilterParameter(){
    return {
        restrict: 'E',
        scope: {
            options: '=',
            value: '=',
            closeFn: '&',
            openFn: '&'
        },
        templateUrl: "reporting/directives/feeBenchmarkFilterParameter.html",
        replace: true,
        link: function(scope) {
            //PUBLIC METHODS
            scope.toggled = function (open) {
                if (open) {
                    scope.openFn();
                } else {
                    var update = angular.copy(scope.current);
                    Object.keys(update).each(function(key){
                        update[key] = update[key].join(',');
                    });
                    scope.value = JSON.stringify(update);
                    scope.closeFn();
                }
            };

            scope.isChecked = function(key, value){
                return scope.current[key] ? (scope.current[key].indexOf(value) !== -1) : false;
            };

            scope.toggleCheck = function(key, value){
                if(!scope.current[key])
                    scope.current[key] = [];

                var index = scope.current[key].findIndex(value);

                if (index === -1)
                    scope.current[key].push(value);
                else
                    scope.current[key].splice(index, 1);
            };

            //INITIALIZE
            scope.current = { };

            //SCOPE WATCHERS
            scope.$watch('value', function () {
                //using a watch here because it's possible for the value to get swapped out from outside of the control
                var value =  JSON.parse(scope.value);
                Object.keys(value).each(function(key){
                    scope.current[key] = value[key].split(',');
                });
            });
        }
    }
});
'use strict';

function multiSelectEnumCtrl() {
    var ctrl = this;

    ctrl.$onInit = function() {
        ctrl.selected = [];
        ctrl.useAssigned = ctrl.showUseAssigned || false;
    };

    ctrl.selectAll = function() {
        if(ctrl.useAssigned) ctrl.useAssigned = false;
        ctrl.selected = angular.copy(ctrl.options);
        ctrl.update();
    };

    ctrl.selectNone = function() {
        if(ctrl.useAssigned) ctrl.useAssigned = false;
        ctrl.selected = [];
        ctrl.update();
    };

    ctrl.toggleUseAssigned = function() {
        ctrl.useAssigned = !ctrl.useAssigned;
        ctrl.update();
    };

    ctrl.toggle = function(selection) {
        if(ctrl.useAssigned) ctrl.useAssigned = false;
        if(ctrl.selected.any(selection)) ctrl.selected.remove(selection);
        else ctrl.selected.add(selection);
        ctrl.update();
    };

    ctrl.update = function() {
        ctrl.onUpdate({selected: ctrl.useAssigned ? null : ctrl.selected.intersect(ctrl.options)});
    }
}

app.component('multiSelectEnum', {
    templateUrl: 'reporting/components/multi-select-enum.html',
    controller: multiSelectEnumCtrl,
    bindings: {
        options: '<',
        onDelete: '&',
        onUpdate: '&',
        showUseAssigned: '@'
    }
});
'use strict';

app.controller('DataQuerySchedulerCtrl',function DataQuerySchedulerCtrl($scope, $http, $q, $oasRights, $dialog, dialog) {
    var dataQueryScheduleOriginal = null;
    var intervalsTemp = [];
    var fileFormats = [{name: "CSV", code: "csv"}, {name: "Pipe Delimited", code: "psv"}, {name: "Excel", code: "xlsx"}];

    function init(){
        var loadedCalls = { alClients: getAlClients(), ownerCode: getOwnerCode(), databaseGroups: null, scheduledQuery: getScheduledQuery(), dataQuery: getDataQuery() };
        if($scope.rightsDatabaseGrouping.canRead) {
            loadedCalls.databaseGroups = getDatabaseGroups();
        } else {
            $scope.runForOptions.remove({name: "Group", code: "group"});
        }
        $q.all(loadedCalls)
            .then(function(responses) {
                //Set up ALClients list
                $scope.alClients.list = responses.alClients.data.sortBy('clientName');

                //Get owner code
                $scope.current.ownerCode = responses.ownerCode.data;

                //Set up database groups
                if(responses.databaseGroups) {
                    $scope.databaseGroups.list = responses.databaseGroups.data.sortBy('name');
                }

                //Set up scheduled query data
                $scope.dataQuerySchedule = responses.scheduledQuery.data;
                prepareScheduledQuery();

                //Set up data query
                prepareDataQuery(responses.dataQuery.data);
            });
    }

    function prepareScheduledQuery() {
        if($scope.current.scheduleId > 0) {
            dataQueryScheduleOriginal = angular.copy($scope.dataQuerySchedule);

            if($scope.dataQuerySchedule.parameters?.databaseIdList?.length > 0) {
                $scope.current.selectedRunFor = "multiple";
                $scope.dataQuerySchedule.parameters.databaseIdList.forEach(function(dbId) {
                    var alClient = $scope.alClients.list.find({id:dbId});
                    if (alClient) {
                        $scope.alClients.selected.add(angular.copy(alClient));
                    }
                });
            }

            $scope.intervalValues = [];

            //Set initial intervalType
            Object.keys($scope.dataQuerySchedule.frequencyInfo.interval, function (key, value) {
                intervalsTemp.push({name: key.capitalize(), selected: value});
            });

            //Move to bindable array
            $scope.intervalValues = intervalsTemp.clone().exclude({name: '$type'}, {name: 'Day'});

            if ($scope.intervalValues.length === 0) {
                $scope.current.intervalType = 'Daily';
            } else {
                $scope.current.intervalType = $scope.intervalValues.exclude({name: '$type'}).length === 7 ? 'Weekly' : 'Monthly';
            }

            $scope.current.selectedMonthDay = $scope.dataQuerySchedule.frequencyInfo.interval.day ? $scope.dataQuerySchedule.frequencyInfo.interval.day.toNumber() : '';

            $scope.frequency.selectedFrequency = $scope.current.intervalType;

            $scope.dataQueryParameters = createColumnData($scope.dataQuerySchedule.parameters.prompts, 3);

            if ($scope.dataQuerySchedule.parameters.dynamicDateFormat) {
                $scope.current.includeDynamicDate = true;
                $scope.current.dynamicDateFormat = $scope.dataQuerySchedule.parameters.dynamicDateFormat;
            }
            if ($scope.dataQuerySchedule.parameters.fileName) {
                $scope.current.fileName = $scope.dataQuerySchedule.parameters.fileName;
            }
        }
        else {
            $scope.dataQuerySchedule.isActive = true;
        }

        setAllowedFileFormats();
        setFileFormatForSchedule();

        $scope.frequencyInfo = $scope.dataQuerySchedule.frequencyInfo;
    }

    function prepareDataQuery(dataQuery) {
        var data = dataQuery;
        $scope.current.defaultFileName = data.title.replace("/", "") + "_" + $scope.current.ownerCode;
        var prompts = [];
        if($scope.current.scheduleId > 0) {
            var newPrompts = [];
            data.prompts.forEach(function (item) {
                if (item.promptType === "Numeric") {
                    item.defaultValue = item.defaultValue ? item.defaultValue.toNumber() : 0;
                }
                if (!findParameter(item.code)) {
                    item.customReportId = 0;
                    newPrompts.push(item);
                }
            });

            $scope.dataQueryParameters.forEach(function (tempArr) {
                prompts = prompts.concat(tempArr);
            });
            prompts.remove(function (p) {
                return !data.prompts.some({code: p.code});
            });
            if (newPrompts.length > 0) {
                prompts = prompts.concat(newPrompts);
            }
            prompts.forEach(function (p) { //This will split the date placeholder from the +/- day difference
                if (p.promptType === "Date") {
                    var dateParts;
                    if (p.defaultValue.includes('-')) {
                        dateParts = p.defaultValue.split('-');
                    } else if (p.defaultValue.includes('+')) {
                        dateParts = p.defaultValue.split('+');
                    }
                    if (dateParts && dateParts.length > 1) {
                        p.dayDifference = parseInt(dateParts[1]);
                        p.isPositive = p.defaultValue.includes('+');
                        p.defaultValue = dateParts[0];
                    } else {
                        p.dayDifference = 0;
                        p.isPositive = true;
                    }
                } else if (p.promptType ==="Numeric") {
                    p.defaultValue = p.defaultValue ? p.defaultValue.toNumber() : 0;
                }
            });
        } else {
            data.prompts.forEach(function (item) {
                if(item.promptType === "Numeric"){
                    item.defaultValue = item.defaultValue ? item.defaultValue.toNumber() : 0;
                } else if(item.promptType === "Date") {
                    item.dayDifference = 0;
                    item.isPositive = true;
                }
            });
            loadIntervalValues('Weekly');
            prompts = data.prompts;
        }
        $scope.dataQueryParameters = createColumnData(prompts, 3);
    }

    function findParameter(code) {
        var found = false;
        $scope.dataQueryParameters.forEach(function(paramArray){
            if(paramArray.find({code: code})) {
                found = true;
                return false;
            }
        });
        return found;
    }

    function loadIntervalValues(intervalType) {
        $scope.intervalValues = [];
        if(dataQueryScheduleOriginal && intervalType === $scope.current.intervalType){
                $scope.dataQuerySchedule = {};
                $scope.dataQuerySchedule = dataQueryScheduleOriginal;
                $scope.intervalValues = intervalsTemp.exclude({name: '$type'});
        } else {
            $http.get('/Reporting/Custom/Schedules/New?frequencyType=' + intervalType.toLowerCase(), {cache: true, trackerMsg: 'Creating template'})
                .then(function (response) {
                    var data = response.data;
                    data.frequencyInfo.timeOfDay = new Date();
                    data.frequencyInfo.startDate =  Date.create('today');
                    data.frequencyInfo.endDate = null;
                    $scope.dataQuerySchedule.frequencyInfo = data.frequencyInfo;
                    var interval = Object.keys(data.frequencyInfo.interval, function (key, value) {
                        if (key.has('day') && intervalType.toLowerCase() === 'weekly') {
                            $scope.intervalValues.push({name: key.capitalize(), selected: value});
                        } else {
                            //if this is monthly; I'm removing a property called 'day', which is the day of the month, so it doesn't show on UI
                            if(!key.has('day') && !key.has('$type'))$scope.intervalValues.push({name: key.capitalize(), selected: value});
                        }
                    });
                });
        }
    }

    function createColumnData(inputArray, size){
        var newArray = [];
        for (var i=0; i<inputArray.length; i+=size) {
            newArray.push(inputArray.slice(i, i+size));
        }
        return newArray;
    }

    function formatPrompts(prompts){
        //Copy parameters into dataQueryParameters
        $scope.dataQueryParameters.forEach(function(tempArr){
            prompts = prompts.concat(tempArr);
        });
        //Format date prompts
        prompts.forEach(function(p){
            if(p.promptType === "Date" && p.dayDifference && angular.isNumber(p.dayDifference) && parseInt(p.dayDifference) > 0) {
                p.defaultValue += ((p.isPositive ? '+' : '-') + parseInt(p.dayDifference));
                delete p.dayDifference;
                delete p.isPositive;
            }
        });
        return prompts;
    }

    function getScheduledQuery() {
        if($scope.current.scheduleId > 0) {
            return $http.get('/Reporting/Custom/Schedules/' + dialog.options.scheduleId, { trackerMsg: 'Loading query schedule '});
        } else {
            return $http.get('/Reporting/Custom/Schedules/New?frequencyType=' + $scope.frequency.selectedFrequency, { trackerMsg: 'Loading query schedule'});
        }
    }

    function getDataQuery() {
        return $http.get('/Reporting/Custom/' + $scope.current.customReportId, { trackerMsg: 'Loading query schedule template '});
    }

    function getAlClients() {
        return $http.get('/Authorization/User/Databases?isActive=true&filterForMasterGroup=true', {trackerMsg: 'Loading database list'});
    }

    function getOwnerCode() {
        return $http.get("/Settings/Owner/Code", {cache:true, trackerMsg: 'Loading settings'});
    }

    function getDatabaseGroups() {
        return $http.get('/Utility/DatabaseGroups', {trackerMsg: 'Loading database groups'});
    }

    function isValidFrequency() {
        switch ($scope.frequency.selectedFrequency) {
            case "Daily":
                return true;

            case "Weekly":
                return $scope.intervalValues?.some(param => param.selected);

            case "Monthly":
                return $scope.intervalValues?.some(param => param.selected) && $scope.current.selectedMonthDay > 0;

            default:
                return false;
        }
    }

    function setAllowedFileFormats() {
        if(
            ($scope.current.uploadTarget?.transmitMethod === "FTP"
                && (
                    $scope.current.uploadTarget?.pgpUserID === null
                    || $scope.current.uploadTarget?.pgpUserID.trim() === ""
                ))
            || $scope.user.authorization.entity === "Administrator"
        ) {
            $scope.fileFormats = angular.copy(fileFormats).remove(type => { return type.code !== "xlsx"; });
        } else {
            $scope.fileFormats = angular.copy(fileFormats);
        }
    }

    function setFileFormatForSchedule() {
        // If the fileFormat isn't set yet, try to set it from the schedule itself.
        if (!$scope.current.fileFormat) {
            $scope.current.fileFormat = $scope.dataQuerySchedule.parameters?.fileFormat?.toLocaleLowerCase();
        }

        // Whether or not we just set the fileFormat above, we need to ensure it is still valid based on the currently available fileFormats.
        if (!$scope.fileFormats.some({code: $scope.current.fileFormat})) {
            $scope.current.fileFormat = null;
        }
    }

    $scope.deleteSchedule = function(){
        $scope.dataQuerySchedule.isActive = false;
        var prompts = [];
        prompts = formatPrompts(prompts);
        $scope.dataQuerySchedule.parameters = {prompts: prompts};
        dialog.close($scope.dataQuerySchedule);
    };

    $scope.intervalChange = function(changeType){
        loadIntervalValues(changeType);
    };

    $scope.setSchedule = function(){
        $scope.dataQuerySchedule.id = $scope.current.scheduleId;
        var prompts = [];
        prompts = formatPrompts(prompts);
        //Convert $scope.intervalValues
        if($scope.intervalValues.length > 0){
            var frequencyInfoIntervals={};
            $scope.intervalValues.forEach(function(item){
                frequencyInfoIntervals[item.name.toLowerCase()] = item.selected;
            });

            if($scope.dataQuerySchedule.frequencyInfo.interval.$type) {
                frequencyInfoIntervals["$type"] = $scope.dataQuerySchedule.frequencyInfo.interval.$type;
            }

            $scope.dataQuerySchedule.frequencyInfo.interval = frequencyInfoIntervals;
        }
        if($scope.frequency.selectedFrequency === 'Monthly') {
            $scope.dataQuerySchedule.frequencyInfo.interval.day = $scope.current.selectedMonthDay.format();
        }
        var idList = [];
        if($scope.current.selectedRunFor !== 'current' ) {
            $scope.alClients.selected.forEach( function ( setIds ) {
                idList.push(setIds.id);
            });
        }
        let dynamicDateFormat = null;
        if($scope.current.includeDynamicDate) {
            dynamicDateFormat = $scope.current.dynamicDateFormat;
        }
        let fileName = null;
        if($scope.current.fileName !== "") {
            fileName = $scope.current.fileName;
        }
        $scope.dataQuerySchedule.parameters = {prompts: prompts, databaseIdList: idList, fileFormat: $scope.current.fileFormat, fileName: fileName, dynamicDateFormat: dynamicDateFormat};

        $scope.dataQuerySchedule.customReportId = $scope.current.customReportId;
        $scope.dataQuerySchedule.isActive = true;
        dialog.close($scope.dataQuerySchedule);
    };

    $scope.setDescription = function(prompt) {
        $scope.current.promptDescription = prompt.promptDescription;
    };

    $scope.loadUploadTarget = function() {
        $dialog.dialog({id: $scope.dataQuerySchedule.uploadTargetId, templateUrl: "dataquery-schedule-uploadtarget.html", controller: "DataQueryScheduleUploadTargetCtrl"})
            .open().then(function(rslt) {
            if(rslt) {
                $scope.dataQuerySchedule.uploadTargetId = rslt.pkUploadTarget;
                $scope.current.uploadTarget = rslt;

                setAllowedFileFormats();
                setFileFormatForSchedule();
            }
        });
    };

    $scope.clearUploadTarget = function() {
        $scope.dataQuerySchedule.uploadTargetId = null;
        
        setAllowedFileFormats();
        setFileFormatForSchedule();
    };

    $scope.updateDatabases = function() {
        if($scope.databaseGroups.selected) {
            var selected = angular.copy($scope.alClients.selected);
            $scope.alClients.selected = [];
            selected.each(function(s){
                $scope.alClients.list.push(s);
            });
            $scope.alClients.list.sortBy('clientName');
            var dbs = [];
            $scope.databaseGroups.selected.databases.forEach(function(db){
                if(db) {
                    var currentDb = angular.copy($scope.alClients.list.find( { id : db.id } ));
                    if(currentDb) {
                        dbs.push(currentDb);
                    }
                }
            });
            $scope.alClients.selected = dbs;
        }
    };

    $scope.close = function(){
        dialog.close();
    };

    $scope.canSchedule = function() {
        const startDate = $scope.dataQuerySchedule?.frequencyInfo?.startDate;
        const startTime = $scope.dataQuerySchedule?.frequencyInfo?.timeOfDay;
        const isValidFreqencyData = isValidFrequency();
        const runForDatabaseCurrent = $scope.current.selectedRunFor === 'current';
        const runForDatabaseMultiple = $scope.current.selectedRunFor === 'multiple';
        const selectedDatabases = $scope.alClients.selected.length > 0;
        const runForDatabaseGroup = $scope.current.selectedRunFor === 'group';
        const selectedDatabaseGroup = $scope.databaseGroups.selected;
        return startDate
            && startTime
            && isValidFreqencyData
            && (runForDatabaseCurrent
                || (runForDatabaseMultiple && selectedDatabases)
                || (runForDatabaseGroup && selectedDatabaseGroup));
    };

    $scope.rightsDataQueryFtp = $oasRights.forCode("DATAQUERYFTP");
    $scope.rightsDatabaseGrouping = $oasRights.forCode("DB_GROUPING");
    $scope.frequencyInfo = {};

    $scope.dataQueryParameters = [];

    $scope.frequencyNames =['Daily','Weekly','Monthly'];

    $scope.frequency = {selectedFrequency:'Weekly'};

    $scope.current = {
        intervalType:'', scheduleId: dialog.options.scheduleId ? dialog.options.scheduleId : 0, customReportId: dialog.options.id,selectedDayOfWeek:'Monday',
        startDate:Date.create('today'), startTime:'18:00', useLastDayOfMonth:false, selectedMonthDay:null, selectedRunFor: "current",
        uploadTarget: null, fileFormat: null, defaultFileName: null, fileName: "", includeDynamicDate: false, dynamicDateFormat: null, ownerCode: null
    };

    $scope.fileInfoPopup = "<h5>File Information</h5><p>When a file downloads, it will display the file name and, if desired, a dynamic date.</p><p>A custom file name may be entered, otherwise the default query name will display.</p><p>A dynamic date, if checked, will display the date of download on each query scheduled.</p>";

    $scope.selectedMonths = [];

    $scope.intervalValues = [];

    $scope.dateDefaults = [
        {id: "NOW", name: "Now"},
        {id: "LBD", name: "Last Business Day"},
        {id: "STARTQTD", name: "Start Quarter-To-Date"},
        {id: "STARTYTD", name: "Start Year-To-Date"},
        {id: "STARTLQ", name: "Start Last Quarter"},
        {id: "STARTLM", name: "Start Last Month"},
        {id: "STARTLY", name: "Start Last Year"},
        {id: "ENDQTD", name: "End Quarter-To-Date"},
        {id: "ENDYTD", name: "End Year-To-Date"},
        {id: "ENDLQ", name: "End Last Quarter"},
        {id: "ENDLM", name: "End Last Month"},
        {id: "ENDLY", name: "End Last Year"}
    ];

    $scope.fileFormats = angular.copy(fileFormats);

    $scope.runForOptions = [{name: "Current", code: "current"}, {name: "Multiple", code: "multiple"}, {name: "Group", code: "group"}];

    $scope.dynamicDates = ["MMddyy","MMddyyyy", "yyyyMMdd", "yyyyMMddHHmmss", "MM-dd-yy", "MM-dd-yy HH:mm:ss", "yyMMdd HH:mm:ss"];

    $scope.databaseGroups = {list: [], selected: null};

    $scope.alClients = {list: [], selected: [], entity: 1979 };

    init();

});

app.controller('DataQueryScheduleUploadTargetCtrl',function DataQueryScheduleUploadTargetCtrl($scope, $http, dialog) {
    //PRIVATE VARIABLES
    var baseUploadTarget = { fkUploadFormat: 1, transmitMethod: 'FTP', useForScrubs: false };
    var uploadTargetOriginal;

    //PRIVATE METHODS
    function init() {
        $scope.current.isExecuting = true;
        $http.get('/Reporting/Custom/UploadTargets', { trackerMsg: 'Loading available upload targets' })
            .then(function(response){
                if(response.data) {
                    $scope.current.uploadTargets = response.data;
                    if(dialog.options.id && dialog.options.id > 0) {
                        $scope.target = $scope.current.uploadTargets.find({pkUploadTarget: dialog.options.id});
                    }
                }
                $scope.current.isExecuting = false;
            });
    }

    //PUBLIC METHODS
    $scope.assign = function() {
        $scope.current.isExecuting = true;
        if(!angular.equals(uploadTargetOriginal, $scope.target)) {
            var save = ($scope.target.pkUploadTarget && $scope.target.pkUploadTarget > 0) ? {method: "PUT", id: $scope.target.pkUploadTarget, trackerMsg: "Saving upload target"} : {method: "POST", id: "", trackerMsg: "Adding new upload target"};
            $http({method: save.method, url: '/Reporting/Custom/UploadTargets/' + save.id, data: $scope.target, trackerMsg: save.trackerMsg})
                .then(function(response){
                    $scope.current.isExecuting = false;
                    dialog.close(response.data);
                })
                .catch(function(reason){
                    $scope.current.isExecuting = false;
                });
        }
        else {
            $scope.current.isExecuting = false;
            dialog.close($scope.target);
        }
    };

    $scope.cancel = function() {
        dialog.close(null);
    };

    //WATCHES
    $scope.$watch('target', function (newValue, oldValue) {
        if (newValue == oldValue) return;

        if(!$scope.target)
            $scope.target = angular.copy(baseUploadTarget);
        else
            uploadTargetOriginal = angular.copy($scope.target);
    });

    //INITIALIZE
    $scope.target = { fkUploadFormat: 1, transmitMethod: 'FTP', useForScrubs: false };
    $scope.current = { uploadTargets: [],  isExecuting: false };
    init();
});
'use strict';

app.controller('DataQueryViewParamsCtrl', function DataQueryViewParamsCtrl($scope, $http, $oasRights, dialog, $dataQuery, $route, $location, $q, splitIoService) {
    //PRIVATE VARIABLES
    var previousRoute, alClientsLoaded;
    var baseUploadTarget = { fkUploadFormat: 1, transmitMethod: 'FTP', useForScrubs: false };
    var uploadTargetOriginal;

    //PRIVATE METHODS
    function init() {
        var loadQuery = function (id) {
            return $http.get('/Reporting/Custom/' + id, {trackerMsg: 'Loading parameters'})
                .then(function (response) {
                    response.data.prompts.forEach(function (prompt) {
                        var desc = prompt.promptDescription;
                        if (desc && desc.toLowerCase() === prompt.prompt.toLowerCase()) {
                            prompt.promptDescription = null;
                        }

                        if (prompt.prompt.toLowerCase().startsWith("enter")) {
                            prompt.prompt = prompt.prompt.from(6);
                        }
                    });

                    $scope.dataQuery = response.data;
                    setExecutionSource();
                    return $scope.dataQuery;
                });
        };

        $q.resolve().then(function() {
            if (dialog.options.dataQueryId) {
                return loadQuery(dialog.options.dataQueryId);
            } else if (dialog.options.dataQueryName) {
                return $http.get('/Reporting/Custom/Simple/Search?search=' + dialog.options.dataQueryName + '&$top=1', {trackerMsg: 'Locating data query'})
                    .then(function (response) {
                        return loadQuery(response.data[0].id);
                    });
            } else {
                $scope.dataQuery = angular.copy(dialog.options.dataQuery);
                setExecutionSource();
                return $scope.dataQuery;
            }
        }).then(function(dataQuery) {
            alClientsLoaded.then(function(){
                var idList = dataQuery.databaseIdList||[],
                    currentDb = $scope.user.authorization.alClientId;
                if(!idList.length) idList.push(currentDb);

                idList.forEach(function(id) {
                    if(id !== currentDb) $scope.current.selectedRunFor = 'multiple';
                    var db = $scope.alClients.list.find( { id : id } );
                    if(db) $scope.alClients.selected.push(angular.copy(db));
                });
            });

            loadCustomImportTypes().then(() => {
                setRunToOptions();
            });            
        });

        if ($route.current.params.source &&  $route.current.params.source === 'compositeAccountList'){
            previousRoute =  '/reports/composites/accounts/'
        }

        if ($scope.rightsDataQueryFtp.canRead){
            $http.get('/Reporting/Custom/UploadTargets', { trackerMsg: 'Loading available upload targets' })
                .then(function(response){
                    if(response.data) {
                        $scope.current.uploadTargets = response.data;
                        if(dialog.options.id && dialog.options.id > 0) {
                            $scope.target = $scope.current.uploadTargets.find({pkUploadTarget: dialog.options.id});
                        }
                    }
                });
        }
    }


    // PUBLIC METHODS
    $scope.setCurrentPrompt = function (prompt) {
        $scope.current.prompt = prompt;
    };

    $scope.run = function () {
        $scope.dataQuery.prompts.forEach(function (prompt) {
            if (prompt.promptType === "Date") {
                prompt.defaultValue = Date.create(prompt.defaultValue).formatted();
            }
        });

        //set the databaseIdList to the selected database Id's
        var idList = [];
        if($scope.current.selectedRunFor !== 'current' ) {
            $scope.alClients.selected.forEach( function ( setIds ) {
                idList.push(setIds.id);
            });
        }

        $scope.dataQuery.databaseIdList = idList;

        if ($scope.current.mode === "grid-filter" || $scope.current.selectedRunTo === 'screen') {
            $http.post('/Reporting/Custom/' + $scope.dataQuery.id + '/Generate/SlickGrid', $scope.dataQuery, {trackerMsg: 'Loading data query'})
                .then(function (response) {
                    if(response.data && response.data.slickGridColumnDefs) {
                        $scope.dataQuery.filterMethod = $scope.current.gridFilterMethod;
                        $scope.dataQuery.views = [response.data];
                        $dataQuery.setDataQuery($scope.dataQuery);
                        dialog.close($scope.dataQuery);
                    } else {
                        dialog.close(response.data);
                    }
                });
        }
        else if ($scope.current.mode === "audit-request-blob"){
            $dataQuery.setDataQuery($scope.dataQuery);
            dialog.close($dataQuery.createBlob(dialog.options.blobParentForAuditRequest));
        }
        else if ($scope.current.selectedRunTo === 'customImport') {
            if (!$scope.customImportTypes.selected) {
                return;
            }

            $scope.dataQuery.importTypeId = $scope.customImportTypes.selected.id;

            dialog.close(
                $http.post(`/Reporting/Custom/${$scope.dataQuery.id}/Generate/CustomImport`, $scope.dataQuery, {trackerMsg: 'Generating Custom Import'})
                    .then((response) => {
                        if (response && response.data) {
                            let customImportResponse = response.data;
                            
                            if (customImportResponse.import) { // A single DB import was returned
                                $dataQuery.goToCustomImport(customImportResponse.import.importTypeId, customImportResponse.import.importId);
                            } else if (customImportResponse.importCommon) { // A MultiDb import was returned
                                $dataQuery.goToMultiDbCustomImport(customImportResponse.importCommon.id);
                            }
                        } 
                    })
            );
        }
        else {
            $dataQuery.setDataQuery($scope.dataQuery);

            if ($scope.current.selectedDestination === 'directDownload') {
                var token = sessionStorage.oas_token;
                if( dialog.options.tokenOverrideForDownloads !== null ) {
                    token = dialog.options.tokenOverrideForDownloads;
                }
                dialog.close($dataQuery.createFile($scope.current.selectedRunTo, function (url) {window.location.href = url + "?Authorization=" + token;}, dialog.options.tokenOverrideForDownloads));
            }
            else if ($scope.current.selectedDestination === 'fileTransfer') {
                $scope.dataQuery.runTo = {storageType: $scope.current.selectedDestination, reportFormat: $scope.current.selectedRunTo === 'xlsx' ? 'excel' : $scope.current.selectedRunTo, source: "OnDemandUI"};

                $scope.dataQuery.runTo.uploadTargetId = $scope.current.selectedTarget.pkUploadTarget;
                dialog.close($dataQuery.sendToSftp());
            }
            else {
                $scope.dataQuery.runTo = {storageType: $scope.current.selectedDestination, reportFormat: $scope.current.selectedRunTo === 'xlsx' ? 'excel' : $scope.current.selectedRunTo, source: "OnDemandUI"};

                if ($scope.dataQuery.runTo.storageType === 'selectedInbox') {
                    $scope.dataQuery.runTo.storageType = 'reportInbox';
                    $scope.dataQuery.runTo.userIdList = [$scope.current.selectedProfile.userId];
                    $scope.dataQuery.provider = 3;
                }

                dialog.close($dataQuery.sendToInbox());
            }
        }
    };

    $scope.updateDatabases = function() {
        if($scope.databaseGroups.selected) {
            var selected = angular.copy($scope.alClients.selected);
            $scope.alClients.selected = [];
            selected.each(function(s){
                $scope.alClients.list.push(s);
            });
            $scope.alClients.list.sortBy('clientName');
            var dbs = [];
            $scope.databaseGroups.selected.databases.forEach(function(db){
                if(db) {
                    var currentDb = angular.copy($scope.alClients.list.find( { id : db.id } ));
                    if(currentDb)
                        dbs.push(currentDb);
                }
            });
            $scope.alClients.selected = dbs;
        }
    };

    $scope.saveChanges = function() {
        dialog.close($scope.dataQuery);
    };

    $scope.cancel = function () {
        if (previousRoute){
            $location.url(previousRoute);
        }

        dialog.close();


    };

    function getAlClients() {
        return $http.get('/Authorization/User/Databases?isActive=true&filterForMasterGroup=true', {trackerMsg: 'Loading database list'})
            .then(function (response) {
                $scope.alClients.list = response.data.sortBy('clientName');
            });
    }

    function loadCustomImportTypes() {
        if (!$scope.rightsCustomImports.canRead) {
            return $q.resolve({});
        }

        return $http.get(`/Reporting/Custom/${$scope.dataQuery.id}/CustomImportTypes`)
            .then((response) => {
                $scope.customImportTypes.singleDbList = response.data?.singleDbImportTypes?.sortBy('importTypeName');
                $scope.customImportTypes.multiDbList = response.data?.multiDbImportTypes?.sortBy('importTypeName');
            });
    }

    function getDatabaseGroups() {
        return $http.get('/Utility/DatabaseGroups', {trackerMsg: 'Loading database groups'})
            .then(function (response) {
                $scope.databaseGroups.list = response.data.sortBy('name');
            });
    }

    function getDynamicGroups() {
        return $http.get('/Utility/Groupings/Simple?usedFor=Reporting', {trackerMsg: 'Loading dynamic groups'})
            .then(function (response) {
                $scope.dynamicGroups.list = response.data.sortBy('name');
                $scope.dynamicGroups.list.insert({pageViewId: 0, id:"0",name:"All Dynamic Groups"},0);
            });
    }

    function setExecutionSource() {
        if($scope.dataQuery.runTo) {
            $scope.dataQuery.runTo.source = "OnDemandUI";
        }
        else {
            $scope.dataQuery.runTo = { source: "OnDemandUI" };
        }
    }

    function setRunToOptions() {
        let runToOptions = [{name: "Screen", code: "screen"}, {name: "CSV", code: "csv"}, {name: "Excel", code: "xlsx"}]
        
        if ($scope.rightsCustomImports.canRead) {
            if (($scope.customImportTypes.singleDbList && $scope.customImportTypes.singleDbList.length > 0) || ($scope.customImportTypes.multiDbList && $scope.customImportTypes.multiDbList.length > 0)) {
                runToOptions.push({name: 'Custom Import', code: 'customImport'});
            }
        } 

        $scope.runToOptions = runToOptions;
    }

    $scope.$watch('current.selectedRunFor', function() {
        $scope.customImportTypes.selected = null;
    });

    $scope.$watch('current.selectedRunTo', function(newValue, oldValue) {
        if (newValue !== 'customImport') {
            $scope.customImportTypes.selected = null;
        }
        
        if (newValue === 'screen') {
            $scope.current.selectedDestination = 'directDownload';
        }
        
    });

    $scope.$watch('current.selectedTarget', function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }

        if(!$scope.current.selectedTarget) {
            $scope.current.selectedTarget = angular.copy(baseUploadTarget);
        }
        else {
            uploadTargetOriginal = angular.copy($scope.current.selectedTarget);
        }
    });

    // INITIALIZE
    $scope.rightsDatabaseGrouping = $oasRights.forCode("DB_GROUPING");
    $scope.rightsCustomImports = $oasRights.forCode("CUSTOMIMPORTS2");
    $scope.rightsDataQueryFtp = $oasRights.forCode("DATAQUERYFTP");
    $scope.runToOptions = [{name: "Screen", code: "screen"}, {name: "CSV", code: "csv"}, {name: "Excel", code: "xlsx"}];
    $scope.destinationOptions = [{name: "Direct Download", code: "directDownload"}, {name: "My Inbox", code: "reportInbox"}];
    $scope.runForOptions = [{name: "Current", code: "current"}, {name: "Multiple", code: "multiple"}, {name: "Group", code: "group"}];

    if( dialog.options.hideToScreen === true ) {
        $scope.runToOptions.splice( 0, 1 );
    }

    if( dialog.options.hideInbox === true ) {
        $scope.destinationOptions.splice( 1, 1 );
    }

    if( dialog.options.hideInbox === true ){
        $scope.runForOptions.splice( 0, 1 );
    }

    if (["Administrator", "Advisor"].any($scope.user.authorization.entity)) {
        if( dialog.options.hideInbox !== true ) {
            $scope.destinationOptions.push({name: "Selected Inbox", code: "selectedInbox"});
        }
    }
    
    if ($scope.rightsDataQueryFtp.canRead){
        $scope.destinationOptions.push({name: "SFTP", code: "fileTransfer"});
    }

    $scope.databaseGroups = {list: [], selected: null};
    $scope.dynamicGroups = {list: []};
    $scope.alClients = {list: [], selected: [], entity: 1979 };
    $scope.customImportTypes = {singleDbList: [], multiDbList: [], selected: null};
    $scope.current = {
        mode: dialog.options.promptMode, 
        selectedRunTo: dialog.options.hideToScreen ? "xlsx" : "screen", 
        selectedDestination: "directDownload", 
        selectedProfile: null,
        gridFilterMethod: "include", 
        selectedRunFor: "current",
        selectedCustomImport: null,
        selectedTarget: dialog.options.selectedTarget || null,
    };

    alClientsLoaded = getAlClients();
    getDynamicGroups();
    if($scope.rightsDatabaseGrouping.canRead)
        getDatabaseGroups();
    else
        $scope.runForOptions.remove({name: "Group", code: "group"});
    init();
});
'use strict';

app.controller('QueryBuilderViewParamsCtrl', function QueryBuilderViewParamsCtrl($scope, $http, $oasRights, dialog, $dataQuery, $route, $location) {
    //PRIVATE VARIABLES
    var previousRoute;
    var storedParameterValues;

    //PRIVATE METHODS
    function init() {
        var loadSettings = (id) => {
            return $http.get("/Settings/UserOptions/report_params_" + id, {trackerMsg: 'Loading settings'})
            .then(function(response){
                storedParameterValues = response.data;
            });
        }

        var parseSettings = () => {
            if (storedParameterValues.value) {
                var storedSettings = JSON.parse(storedParameterValues.value);
    
                if (storedSettings) {
                    storedSettings.forEach(function (setting) {
                        var parameter = $scope.dataQuery.requiredOptions.find({ $type: setting.$type });
    
                        if (parameter) {
                            switch (parameter.$type) {
                                case 'daterange':
                                    parameter.start.date = setting.start;
                                    parameter.end.date = setting.end;
                                    parameter.rememberDateParameter = true;
                                    break;
    
                                case 'date':
                                    parameter.value = setting.value;
                                    parameter.rememberDateParameter = true;
                                    break;
                            }
                        }
                    });
                }
            }
        }

        var loadQuery = function (id) {
            return $http.get('/Reporting/Envision/ExcelReports/' + id + '/Parameters', {trackerMsg: 'Loading parameters'})
                .then(function (response) {
                    $scope.dataQuery = response.data;
                    $scope.current.deliveryMethod = $scope.dataQuery.deliveryOptions.find({id: 'delivery-method'});
                    $scope.current.deliveryMethod.reportFormat = 'Html';
                    $scope.current.selectedDestination = $scope.current.deliveryMethod.storageType + '|' + $scope.current.deliveryMethod.provider;
                });
        };

        if (dialog.options.dataQueryId) {
            loadSettings(dialog.options.dataQueryId).then(function(){
                return loadQuery(dialog.options.dataQueryId);
            }).then(function(){
                parseSettings();
            });
        } else if (dialog.options.dataQueryName) {
            $http.get('/Reporting/Envision/ExcelReports/Simple/Search?search=' + dialog.options.dataQueryName + '&$top=1', {trackerMsg: 'Locating data query'})
                .then(function (response) {
                    loadSettings(response.data[0].id);
                    loadQuery(response.data[0].id);
                });
        } else {
            $scope.dataQuery = angular.copy(dialog.options.dataQuery);
        }

        if ($route.current.params.source && $route.current.params.source === 'compositeAccountList') {
            previousRoute = '/reports/composites/accounts/';
        }
    }

    function getCleanReport() {
        //using a copy here so we don't permanently alter any values currently being displayed to the user
        var report = angular.copy($scope.dataQuery);

        if (report.requiredOptions && report.requiredOptions.length > 0) {
            report.requiredOptions.forEach(function (parameter) {
                switch (parameter.$type) {
                    case "select-entity":
                        if (parameter.id === "entity") {
                            var entityIds = [];
                            parameter.selectedEntities.forEach(function (entity) {
                                if (entity.items) {
                                    entity.items.forEach(function (item) {
                                        entityIds.push(item.entityId);
                                    });
                                } else {
                                    entityIds.push(entity.entityId);
                                }
                            });
                            parameter.entityIds = entityIds.unique();
                            delete parameter.selectedEntities;
                        }
                        break;

                    case "daterange":
                        parameter.start.date = parameter.useInception ? null : Date.create(parameter.start.date).format('{M}/{d}/{yyyy}');
                        parameter.start.dateSource = "Static";
                        parameter.end.date = Date.create(parameter.end.date).format('{M}/{d}/{yyyy}');
                        parameter.end.dateSource = "Static";
                        delete parameter.useInception;
                        delete parameter.rememberDateParameter;
                        break;

                    case "date":
                        parameter.value.date = Date.create(parameter.value.date).format('{M}/{d}/{yyyy}');
                        parameter.value.dateSource = "Static";
                        break;
                }
            });
        }
        return report;
    }

    // PUBLIC METHODS
    $scope.setCurrentPrompt = function (prompt) {
        $scope.current.prompt = prompt;
    };

    $scope.setInceptionDate = function () {
        var entitySelection = $scope.dataQuery.requiredOptions.find({id: 'entity'});
        var period = $scope.dataQuery.requiredOptions.find({$type: 'daterange'});

        if (!period.useInception) return;

        if (entitySelection.selectedEntities.length === 1) {
            var report = getCleanReport();

            $http.post("/Reporting/Reports/" + dialog.options.dataQueryId + "/Calculate/InceptionDate", report, {trackerMsg: 'Retrieving inception date'})
                .then(function (response) {
                    period.start.date = response.data.inceptionDate ? Date.create(response.data.inceptionDate).format("{M}/{d}/{yyyy}") : null;
                });
        } else {
            period.start.date = null;
        }
    };

    $scope.formatStorageType = function(option) {
        return option.storageType + '|' + option.provider;
    };

    $scope.updateDelivery = function (option){
        $scope.current.deliveryMethod.storageType = option.storageType;
        $scope.current.deliveryMethod.provider = option.provider;
        if($scope.isSelectedInbox()) {
            $scope.current.selectedProfile = null;
        }
    };

    $scope.isInputValid = function() {
        var isValid = true;
        if ($scope.dataQuery && $scope.dataQuery.requiredOptions && $scope.dataQuery.requiredOptions.length > 0) {
            $scope.dataQuery.requiredOptions.forEach(function (parameter) {
                switch (parameter.$type) {
                    case "select-entity":
                        if (parameter.id === "entity") {
                            if(parameter.entity !== "Database") {
                                var entityIds = [];
                                if(parameter.selectedEntities) {
                                    parameter.selectedEntities.forEach(function (entity) {
                                        if (entity.items) {
                                            entity.items.forEach(function (item) {
                                                entityIds.push(item.entityId);
                                            });
                                        } else {
                                            entityIds.push(entity.entityId);
                                        }
                                    });
                                }
                                if(entityIds.length === 0) {
                                    isValid = false;
                                }
                            }
                        }
                        break;

                    case "daterange":
                        if((!parameter.start.date && !parameter.useInception) || !parameter.end.date) {
                            isValid = false;
                        }
                        break;

                    case "date":
                        if(!parameter.value) {
                            isValid = false;
                        }
                        break;
                    case "prompt":
                        if((!parameter.value || parameter.value.toString().trim().length === 0) && !parameter.isIgnored) {
                            isValid = false;
                        }
                        break;
                }
            });
        }
        return isValid;
    };

    $scope.run = function () {

        var saveUserOptions = () => {
            if (!$scope.user.isImpersonating) {  //only save user options when not impersonating
                var period = $scope.dataQuery.requiredOptions.find({ $type: 'daterange' });

                if (period && period.rememberDateParameter) {
                    var dataToSave = [];
                    dataToSave.push({ id: period.id, $type: period.$type, start: Date.create(period.start.date).format("{M}/{d}/{yyyy}"), end: Date.create(period.end.date).format("{M}/{d}/{yyyy}") });
                    if (dataToSave.length > 0) {
                        var payload = {
                            id: storedParameterValues.id,
                            optionName: storedParameterValues.optionName,
                            value: JSON.stringify(dataToSave)
                        };

                        $http.post("/Settings/UserOptions/report_params_" + dialog.options.dataQueryId, payload)
                            .then(function (response) {
                                storedParameterValues.id = response.data.id;
                            });
                    }
                } else if (storedParameterValues.id !== 0) {
                    $http.delete("/Settings/UserOptions/report_params_" + dialog.options.dataQueryId)
                        .then(function () {
                            storedParameterValues.id = 0;
                        });
                }
            }
        }

        var report = getCleanReport();
        //set the databaseIdList to the selected database Id's
        var idList = [];
        $scope.alClients.selected.forEach( function ( setIds ) {
            idList.push(setIds.id);
        });
        report.databaseIdList = idList;

        saveUserOptions();

        var deliveryMethod = report.deliveryOptions.find({id: 'delivery-method'});

        if ($scope.current.deliveryMethod.reportFormat === 'Html')
        {
            deliveryMethod.storageType = "DirectDownload";
            deliveryMethod.provider = null;
        }

        $http.post("/Reporting/Envision/ExcelReports/" + dialog.options.dataQueryId + "/Generate", report, {trackerMsg: 'Generating query'})
            .then(function (response) {

                if (deliveryMethod.reportFormat === 'Html') {
                    $scope.dataQuery.views = [response.data];
                    dialog.close($scope.dataQuery);
                } else if (deliveryMethod.storageType === "DirectDownload") {
                    var location = response.headers("location");
                    if (location) {
                        var url = location + (location.has("?") ? "&" : "?") + "Authorization=" + sessionStorage.oas_token;
                        window.location.href = url;
                    }
                } else {
                    dialog.close();

                }
            });
    };

    $scope.updateDatabases = function () {
        if ($scope.databaseGroups.selected) {
            var selected = angular.copy($scope.alClients.selected);
            $scope.alClients.selected = [];
            selected.each(function (s) {
                $scope.alClients.list.push(s);
            });
            $scope.alClients.list.sortBy('clientName');
            var dbs = [];
            $scope.databaseGroups.selected.databases.forEach(function (db) {
                if (db) {
                    var currentDb = angular.copy($scope.alClients.list.find({id: db.id}));
                    if (currentDb)
                        dbs.push(currentDb);
                }
            });
            $scope.alClients.selected = dbs;
        }
    };

    $scope.cancel = function () {
        if (previousRoute) {
            $location.url(previousRoute);
        }
        dialog.close();
    };

    $scope.isSelectedInbox = function() {
        if(!$scope.current.deliveryMethod) return false;
        var selected = $scope.current.deliveryMethod.options.find({storageType: $scope.current.deliveryMethod.storageType, provider: $scope.current.deliveryMethod.provider });
        return selected.displayName.includes("Selected Inbox");
    };

    $scope.$watch("current.selectedProfile", function(newValue, oldValue){
        if(newValue === oldValue) return;
        $scope.current.deliveryMethod.userIdList = newValue ? [newValue.userId] : null;
    });

    function getAlClients() {
        return $http.get('/Authorization/User/Databases?isActive=true&filterForMasterGroup=true', {trackerMsg: 'Loading database list'})
            .then(function (response) {
                $scope.alClients.list = response.data.sortBy('clientName');
                var currentDb = angular.copy($scope.alClients.list.find({id: $scope.user.authorization.alClientId}));
                $scope.alClients.selected.push(currentDb);
                $scope.alClients.entity = 1979;
            });
    }

    function getDatabaseGroups() {
        return $http.get('/Utility/DatabaseGroups', {trackerMsg: 'Loading database groups'})
            .then(function (response) {
                $scope.databaseGroups.list = response.data.sortBy('name');
            });
    }


    // INITIALIZE
    $scope.rightsDatabaseGrouping = $oasRights.forCode("DB_GROUPING");
    $scope.runToOptions = [{name: "Screen", code: "Html"}, {name: "CSV", code: "Csv"}, {name: "Excel", code: "Excel"}];
    $scope.runForOptions = [{name: "Current", code: "current"}, {name: "Multiple", code: "multiple"}, {
        name: "Group",
        code: "group"
    }];

    if (dialog.options.hideToScreen === true) {
        $scope.runToOptions.splice(0, 1);
    }

    if (dialog.options.hideInbox === true) {
        $scope.runForOptions.splice(0, 1);
    }

    $scope.databaseGroups = {list: [], selected: null};
    $scope.alClients = {list: [], selected: []};
    $scope.current = {
        mode: dialog.options.promptMode,
        selectedDestination: null,
        selectedProfile: null,
        gridFilterMethod: "include",
        selectedRunFor: "current"
    };

    getAlClients();
    if ($scope.rightsDatabaseGrouping.canRead)
        getDatabaseGroups();
    else
        $scope.runForOptions.remove({name: "Group", code: "group"});
    init();
});
'use strict';

app.controller('ReportDefaultsCtrl', function ReportDefaultsCtrl($scope, $http, $oasRights, dialog, reportId) {
    //PRIVATE METHODS
    function init() {
        $http.get('/ReportAdministration/Reports/' + reportId, {trackerMsg: 'Loading defaults for report ' + reportId})
            .then(function (response) {
                $scope.dateTypes.forEach(function (type) {
                    if (!response.data.dateDefaults[type]) {
                        response.data.dateDefaults[type] = {value: null, sign: "+", modifier: 0};
                    }
                });

                $scope.report = response.data;
            });

        $http.get("/Reporting/Reports/" + reportId + "/Parameters", {trackerMsg: 'Loading report settings'})
            .then(function (response) {
                $scope.dateTypes.forEach(function (type) {
                    $scope.disabled[type] = response.data.unstorable && response.data.unstorable.length ? response.data.unstorable[0].parameters.none({name: type}) : true;
                });
            });

        $http.get("/ReportBuilder/WebMenuOptions", {cache: true, trackerMsg: 'Loading web menu options'})
            .then(function (response) {
                $scope.webMenuOptions = response.data;
            });
    }


    //PUBLIC METHODS
    $scope.save = function () {
        $http.put('/ReportAdministration/Reports/' + reportId, $scope.report, {trackerMsg: 'Saving defaults for ' + $scope.report.reportName})
            .then(function (response) {
                dialog.close(response.data);
            });
    };

    $scope.cancel = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.rightsGlobalReportAdmin = $oasRights.forCode("GLOBALREPORTADMIN");
    $scope.dateTypes = ['StartDate', 'EndDate', 'AsOfDate'];
    $scope.disabled = {};

    $scope.dateDefaults = [
        {id: "NOW", name: "Now"},
        {id: "LBD", name: "Last Business Day"},
        {id: "STARTQTD", name: "Start Quarter-To-Date"},
        {id: "STARTYTD", name: "Start Year-To-Date"},
        {id: "STARTLQ", name: "Start Last Quarter"},
        {id: "STARTLM", name: "Start Last Month"},
        {id: "STARTLY", name: "Start Last Year"},
        {id: "ENDQTD", name: "End Quarter-To-Date"},
        {id: "ENDYTD", name: "End Year-To-Date"},
        {id: "ENDLQ", name: "End Last Quarter"},
        {id: "ENDLM", name: "End Last Month"},
        {id: "ENDLY", name: "End Last Year"}
    ];

    init();
});

'use strict';

app.controller('ReportPrompterCtrl', ['$scope', '$http', '$dialog', '$timeout', '$oasRights', 'entities', 'dialog', 'reportId', 'reportArgs', 'popupBlockerChecker', 'optionsHelper', function ReportPrompterCtrl($scope, $http, $dialog, $timeout, $oasRights, entities, dialog, reportId, reportArgs, popupBlockerChecker, optionsHelper) {
    //PRIVATE VARIABLES
    var entityParameter, startDateParameter, endDateParameter, inceptionDateParameter, storedParameterValues;
    var cachedFolderTrees = {};
    var baseReportUrl, parameterUrl;
    var combinationMethods = {
		none: { value: "None", name: "None" },
		aggregate: { value: "None", name: "Aggregate" },
        zip: {value: "Zip", name: "Zip"},
        simplex: {value: "MergeSimplex", name: "Merge Single Page"},
        duplex: {value: "MergeDuplex", name: "Merge Duplex"}
    };


    //PRIVATE METHODS
    function loadReport() {

        if(reportArgs.reportType === 'ReportPackage'){
            baseReportUrl = "/Reporting/ReportPackages/Verbose/" + reportId;
            parameterUrl = baseReportUrl;
        }
        else {
            baseReportUrl = "/Reporting/Reports/" + reportId;
            parameterUrl = baseReportUrl + "/Parameters";
        }

        $scope.wizardSteps.remove("Options", "Parameters", "Delivery");

        var runAssignedVersion = reportArgs.runAssignedVersion === undefined || reportArgs.runAssignedVersion === null ? "true" : reportArgs.runAssignedVersion;

        $http.get("/Settings/UserOptions/report_params_" + reportId, {trackerMsg: 'Loading settings'})
            .then(function(response){
                storedParameterValues = response.data;
                return $http.get(parameterUrl + "?runAssignedVersion=" + runAssignedVersion, {trackerMsg: 'Loading report'});
            })
            .then(function (response) {
                var data = response.data;
                $scope.current.showDateDefaultEditBtn = data.category !== "ReportBuild" && $oasRights.canUpdate("STNDRDRPTSECURITYBTN");

				if (data.requiredOptions !== undefined && data.requiredOptions.length > 0) {
					//this is for rb 3.0 report options
                    $scope.current.showDateDefaultEditBtn = false; //Project 138101 - Remove report defaults button for RB3 until screens are ready
                    $scope.current.prompterMode = 'new';
					$scope.wizardSteps.push("Options");
					var presetEntity = { id: 0, type: "", childType: "" };
					$scope.current.hideExcelOutputFormat = true;

                    var entitySelection = data.requiredOptions.find({ id: 'entity' });

                    var entityEnum = reportArgs["EntityEnum"];
                    var pkEntity = reportArgs["PkEntity"];
                    var entityArgs = reportArgs["entities"];

                    if (entityEnum && pkEntity) {
                        let entityName = entities[entities.find({value: entityEnum})].name;
                        if( entitySelection.options.any(entityName)) {
                            entitySelection.entity = entityName;
                            entitySelection.entityIds = [pkEntity];
                        }
                    } else if (entityArgs?.length > 0) {
                        entityArgs.forEach((entity) => {
                            let entityName = entities[entities.find({value: entity.entityEnum})].name;
                            if( entitySelection.options.any(entityName)) {
                                entitySelection.entity = entityName;
                                entitySelection.entityIds = [entity.pkEntity];
                            }
                        });
                    }

					if (storedParameterValues.value) {
						var storedSettings = JSON.parse(storedParameterValues.value);

						if (storedSettings) {
							storedSettings.forEach(function (setting) {
                                var parameter = data.requiredOptions.find({ $type: setting.$type });

								if (parameter) {
									switch (parameter.$type) {
										case 'daterange':
											parameter.start.date = setting.start;
											parameter.end.date = setting.end;
											parameter.rememberDateParameter = true;
											break;

										case 'date':
											parameter.value = setting.value;
											parameter.rememberDateParameter = true;
											break;
									}
								}
							});
						}
					}

                    if (data.hasAdditionalOptions) {
                        $scope.wizardSteps.push("Parameters");
                    }

				} else if (data.unstorable !== undefined && data.unstorable.length > 0) {
					//this is for ssrs report options
					$scope.wizardSteps.push("Options");
                    var presetEntity = {id: 0, type: "", childType: ""};

                    data.unstorable[0].parameters.forEach(function (parameter) {
                        switch(parameter.input) {
                            case "inception-date-picker":
                                inceptionDateParameter = parameter;
                                break;
                            case "select":
                                var options = [];
                                Object.keys(parameter.options, function(key, value) {
                                    options.push({id: key, name: value});
                                });
                                parameter.options = options.sortBy("name");
                                break;
                        }

                        switch (parameter.name) {
							case "EntityEnum":
							    $scope.current.runForParameter = parameter;

                                if (parameter.options.length === 1) {
                                    parameter.input = "hidden";
                                }

                                if (parameter.options.none({id: parameter.value})) {
                                    parameter.value = parameter.options.any({id: "5,6,7"}) ? "5,6,7" : (parameter.options.any({id: "5"}) ? "5" : (parameter.options.length > 0 ? parameter.options.first().id : parameter.value));
                                }

                                $scope.current.showImport = parameter.options.any(function (option) {
                                    return ["5", "6", "7", "5,6,7"].any(option.id);
                                });
								break;

							case "PkEntity":
							    entityParameter = parameter;
								break;

                            case "StartDate":
                                if (reportArgs["isAdhoc"]){
                                    parameter.isDisabled = true;
                                }
                                startDateParameter = parameter;
								break;

                            case "EndDate":
                                if (reportArgs["isAdhoc"]){
                                    parameter.isDisabled = true;
                                }
                                endDateParameter = parameter;
                                break;
                        }

                        var argValue = reportArgs[parameter.name];
                        if (argValue) {
                            switch (parameter.name) {
                                case "EntityEnum":
                                    var cleanValue = parameter.options.any({id: "5,6,7"}) && ["5", "6", "7"].any(argValue) ? "5,6,7" : parameter.options.any({id: argValue}) ? argValue : null;
                                    if (cleanValue) {
                                        presetEntity.type = argValue;
                                        parameter.value = cleanValue;
                                    } else {
                                        var promotePresetEntity = function (childType, parentType) {
                                            presetEntity.childType = childType;
                                            presetEntity.type = parentType;
                                            parameter.value = parentType;
                                        };

                                        if (argValue === "7" && (parameter.options.any({id: "5"}) || parameter.options.any({id: "6"}))) {
                                            if (parameter.options.any({id: "6"})) {
                                                promotePresetEntity("7", "6");
                                            } else if (parameter.options.any({id: "5"})) {
                                                promotePresetEntity("7", "5");
                                            }
                                        } else if (argValue === "6" && parameter.options.any({id: "5"})) {
                                            promotePresetEntity("6", "5");
                                        }
                                        else if (["5","6","7"].any(argValue) && (parameter.options.any({id: argValue}) || parameter.options.any({id: "24"}))) {
                                            presetEntity.type = argValue;
                                        }
                                    }
                                    break;
                                case "PkEntity":
                                    presetEntity.id = parseInt(argValue);
                                    break;
                                case "PkTRInstance":
                                    argValue.each(function(av) {
                                        parameter.options.push({id: av, name: av});
                                    });
                                    break;
                                default:
                                    parameter.value = argValue;
                            }
                        }
                        if(storedParameterValues.value) {
                            var storedSettings = JSON.parse(storedParameterValues.value);
                            var storedValue = storedSettings ? storedSettings.find({id: parameter.id}) : null;
                            if (storedValue) {
                                parameter.value = storedValue.value;
                                if(parameter.input.has('date'))
                                    $scope.current.rememberDateParameter = true;
                            }
                        }
                    });

                    if (presetEntity.type && presetEntity.id) {
                        var setupEntitySelector = function () {
                            switch ($scope.current.runForParameter.value) {
                                case "5,6,7":
                                    switch (presetEntity.type) {
                                        case entities.registration.value:
                                            $scope.current.runForParameter.value = "6,7";
                                            break;
                                        case entities.account.value:
                                            $scope.current.runForParameter.value = "7,up";
                                            break;
                                    }

                                    $timeout(function() {$scope.entitySelector.searchEntity = presetEntity;});
                                    break;
                                case entities.client.value:
                                case entities.registration.value:
                                case entities.account.value:
                                case entities.model.value:
                                case entities.representative.value:
                                    var entity = entities[entities.find({value: presetEntity.type})];
                                    $http.get(entity.simpleUrl.replace('/Simple', '/') + presetEntity.id, {trackerMsg: 'Loading ' + entity.name})
                                        .then(function (response) {
                                            $scope.entitySelector.selectedEntity = {id: response.data.id, name: response.data.name, number: response.data.number};
                                        });
                                    break;
                                case entities.notDefined.value: //performance tracking accounts don't have an entity
                                case entities.owner.value:      //owner/db doesn't have an entity
                                    break;
                                default:
                                    if ($scope.current.runForParameter.value === entities.bill.value) {
                                        var entity = entities[entities.find({value: presetEntity.type})];
                                        switch(presetEntity.type) {
                                            case entities.account.value:
                                            case entities.registration.value:
                                                $http.get(entity.simpleUrl.replace('/Simple', '/') + presetEntity.id, {trackerMsg: 'Loading ' + entity.name})
                                                    .then(function(response){
                                                        return $http.get(entities.client.simpleUrl.replace('/Simple', '/') + response.data.clientId, {trackerMsg: 'Loading ' + entities.client.name});
                                                    })
                                                    .then(function (response) {
                                                        $scope.entitySelector.searchEntity = {id: response.data.id, name: response.data.name};
                                                    });
                                                break;
                                            case entities.client.value:
                                                $http.get(entity.simpleUrl.replace('/Simple', '/') + presetEntity.id, {trackerMsg: 'Loading ' + entity.name})
                                                    .then(function (response) {
                                                        $scope.entitySelector.searchEntity = {id: response.data.id, name: response.data.name};
                                                    });
                                                break;
                                            default:
                                                $http.get('/Billing/Invoices/' + presetEntity.id, {trackerMsg: 'Loading selected client'})
                                                    .then(function(response) {
                                                        $scope.entitySelector.searchEntity = {id: response.data.clientId, name: response.data.clientName};
                                                    });
                                        }
                                    }

                                    var cancelEntitiesWatcher = $scope.$watch('current.entities', function (newValue, oldValue) {
                                        if (newValue === oldValue || !newValue) return;

                                        $scope.entitySelector.selectedEntity = newValue.find({id: presetEntity.id});
                                        cancelEntitiesWatcher();
                                    });
                                    break;
                            }
                        };

                        if (presetEntity.childType) {
                            $http.get(entities[entities.find({value: presetEntity.childType})].simpleUrl.replace('/Simple', '/') + presetEntity.id, {trackerMsg: 'Loading parent entity'})
                                .then(function (response) {
                                    presetEntity.id = response.data[entities.find({value: presetEntity.type}) + "Id"];
                                    setupEntitySelector();
                                });
                        } else {
                            setupEntitySelector();
                        }
                    }
                }

                if (data.hasStorableParameters) {
                    $scope.wizardSteps.push("Parameters");
                }

                $scope.wizardSteps.push("Delivery");
                $scope.current.animation = 'slide-right';
				$scope.current.wizardStep = $scope.wizardSteps[$scope.wizardSteps.first() === "Selection" ? 1 : 0];

				$scope.report = data;

				if ($scope.current.prompterMode !== 'new') {
                    $scope.report.runTo = $scope.runToOptions[0];
					$scope.report.entities = [];
					if (response.data.category === 'Composite') {
						$scope.report.runTo.archiveReport = false;
						$scope.current.archiveReport = true;
					}
                }
            });

        $http.get("/Settings/Database/EntityOptions/Code/69HIDEEXCE", {cache: true, trackerMsg: 'Loading output format setting'})
            .then(function(response) {
                $scope.current.hideExcelOutputFormat = response.data.value == "True";
            });
    }

    function isPkEntityRequired() {
        return [entities.owner.value, entities.notDefined.value].none($scope.current.runForParameter.value);
    }

    function getCleanReport(removeAdditionalOptionLists) {
        //using a copy here so we don't permanently alter any values currently being displayed to the user
        var report = angular.copy($scope.report);

        var deliveryMethod = report.deliveryOptions?.find({ id: 'delivery-method' });
		if (report.requiredOptions && report.requiredOptions.length > 0) {
			report.requiredOptions.forEach(function (parameter) {
				switch (parameter.$type) {
                    case "select-entity":
                        if (parameter.id === 'entity') {
                            var entityIds = [];
                            parameter.selectedEntities.forEach(function (entity) {
                                // Import lists and Dynamic Grouping (when we aren't aggregating) should send all their items
                                if (
                                    entity.items &&
                                    (entity.entity !== 'Dynamic Grouping' ||
                                        ![combinationMethods.none.value, combinationMethods.aggregate.name].includes(deliveryMethod?.combinationMethod))
                                ) {
                                    entity.items.forEach(function (item) {
                                        entityIds.push(item.entityId);
                                    });
                                } else {
                                    entityIds.push(entity.entityId);
                                    parameter.entity = entity.entity;
                                }
                            });
                            parameter.entityIds = entityIds.unique();
                            delete parameter.selectedEntities;
                        }
                        break;

					case "daterange":
						parameter.start.date = parameter.useInception ? null : Date.create(parameter.start.date).format('{M}/{d}/{yyyy}');
                        parameter.start.dateSource = "Static";
						parameter.end.date = Date.create(parameter.end.date).format('{M}/{d}/{yyyy}');
                        parameter.end.dateSource = "Static";
						delete parameter.useInception;
						delete parameter.rememberDateParameter;
						break;

					case "date":
						parameter.value = Date.create(parameter.value).format('{M}/{d}/{yyyy}');
						break;
				}
			});
		}

        if (report.unstorable && report.unstorable.length > 0) {
            var shouldSetEntity = entityParameter && report.entities.length === 0;

            report.unstorable[0].parameters.forEach(function(parameter){
                if (shouldSetEntity) {
                    if (parameter.name === "EntityEnum" && parameter.value.has(",")) {
                        parameter.value = $scope.entitySelector.selectedEntity.type;
                    }

                    if (parameter.name === "PkEntity" && isPkEntityRequired()) {
                        parameter.value = $scope.entitySelector.selectedEntity.id;
                    }
                }

                if (parameter.input.has("date-picker")) {
                    parameter.value = parameter.input === "inception-date-picker" && $scope.current.useInception ? null : Date.create(parameter.value).format('{M}/{d}/{yyyy}');
                }
            });
        }

        if (report.storable && report.storable.length > 0) {
            report.storable.forEach(function(group) {
                group.parameters.forEach(function (parameter) {
                    if (parameter.input.has("multi-select")) {
                        parameter.value = parameter.value.join();
                    } else if (parameter.input.has("date-picker")) {
                        parameter.value = Date.create(parameter.value).format('{M}/{d}/{yyyy}');
                    }
                });
            });
        }

        if(report.runTo){
            report.runTo.userIdList = report.runTo.provider === 3 ? [$scope.current.selectedProfile.userId] : null;
		}

        if(report.additionalOptions && report.hasAdditionalOptions && removeAdditionalOptionLists === true) {
            removeOptionSets(report, [
                {category: 'General', id: 'cover-page'},
                {category: 'Themes', id: 'theme'}
            ]);
        }

        return report;
    }

    function removeOptionSets(report, removeOptions) {
        removeOptions.forEach(function(section) {
            if(report.additionalOptions.findIndex(o => o.category === section.category) >= 0) {
                let optionsType = report.additionalOptions.find({category: section.category}).options.find({id: section.id});
                if(optionsType) {
                    optionsType.options = optionsType.options.filter(o => optionsType.selection && o.id === optionsType.selection.id);
                }
            }
        });
    }

    function normalizeAdHocPromptOptions(additionalOptions) {
        if (optionsHelper && typeof optionsHelper.normalizeAdHocPromptOptions === 'function') {
            optionsHelper.normalizeAdHocPromptOptions(additionalOptions);
        }
    }

    function loadAdditionalOptions() {
        var report = getCleanReport();

        $scope.numEntities = $scope.report.requiredOptions.find({ id: 'entity' }).selectedEntities.length;

        return $http.post(parameterUrl, report, {trackerMsg: 'Loading report parameters'})
            .then(function (response) {
                $scope.report.id = response.data.id; //in case it changed on us (versioned report)

                $scope.report.additionalOptions = response.data.additionalOptions;
                normalizeAdHocPromptOptions($scope.report.additionalOptions);
                $scope.report.deliveryOptions = response.data.deliveryOptions;
                $scope.report.featureFlagOverrides = response.data.featureFlagOverrides;
            });
    }

    function loadStorableParameters() {
        var report = getCleanReport();

        return $http.post(parameterUrl, report, {trackerMsg: 'Loading report parameters'})
            .then(function (response) {
                $scope.report.id = response.data.id; //in case it changed on us (versioned report)

                response.data.storable.forEach(function(group) {
                    group.parameters.forEach(function (parameter) {
                        if (parameter.input.has("multi-select")) {
                            parameter.value = parameter.value ? parameter.value.split(",") : [];
                        }
                    });
                });
                $scope.report.storable = response.data.storable;
                $scope.report.defaultsType = response.data.defaultsType;
            });
    }

    function setReportInboxOptions() {
        var report = getCleanReport();

        $scope.runToOptions.remove({storageType: "ReportInbox"});

        $http.post(baseReportUrl + "/ReportInboxes", report, {trackerMsg: 'Loading report inbox options'})
            .then(function (response) {
                response.data.forEach(function (inboxType) {
                    $scope.runToOptions.push({storageType: "ReportInbox", displayName: "Report Inbox: " + inboxType.name, provider: inboxType.id, combinationMethod: 'None', reportFormat: 'PDF'});
                });
            });

        if( ["Administrator", "Advisor"].any($scope.user.authorization.entity) ) {
            $scope.runToOptions.push({storageType: "ReportInbox", displayName: "Selected Inbox", provider: 3, combinationMethod: 'None', reportFormat: 'PDF', userIdList: null});
        }
    }

    function addToEntityList(entity, id, name) {
        if ($scope.report.entities.none({key: entity + '-' + id})) {
            $scope.report.entities.push({key: entity + '-' + id, entity: entity, entityId: id, name: name, icon: entities[entities.find({value: entity})].name.toLowerCase()});
        }
    }

    function unpackingIsNeeded() {
        return $scope.current.runForParameter && $scope.entitySelector.selectedEntity && [entities.reportingGroup.value, entities.dynamicReportingGroup.value].any($scope.current.runForParameter.value);
    }

    function unpackGroupForEntityList() {
        var entity = entities[entities.find({value: $scope.current.runForParameter.value})],
            url = entity.simpleUrl.replace('/Simple', '/') + $scope.entitySelector.selectedEntity.id,
            collectionName = "entities";

        if (entity === entities.dynamicReportingGroup) {
            url += "?doRefresh=true";
            collectionName = "details";
        }

        return $http.get(url, {trackerMsg: 'Loading report group members'})
            .then(function (response) {
                response.data[collectionName].forEach(function(member) {
                    addToEntityList(entities[entities.find({name: member.entity})].value, member.entityId, member.name);
                });
                $scope.entitySelector.selectedEntity = null;
            });
    }

    function setDefaultCombinationMethod() {
        if ($scope.current.prompterMode !== 'new') {
        	$scope.report.runTo.combinationMethod = $scope.report.runTo.storageType === "DirectDownload" && $scope.report.entities.length > 1 ? "Zip" : "None";
		}
    }

	//PUBLIC METHODS
	$scope.setInceptionDate = function () {
		if ($scope.current.prompterMode === 'new') {
			var entitySelection = $scope.report.requiredOptions.find({ id: 'entity' });
			var period = $scope.report.requiredOptions.find({ $type: 'daterange' });

			if (entitySelection.selectedEntities.length === 1) {
				var report = getCleanReport();

				$http.post(baseReportUrl + "/Calculate/InceptionDate", report, { trackerMsg: 'Retrieving inception date' })
					.then(function (response) {
						period.start.date = response.data.inceptionDate ? Date.create(response.data.inceptionDate).format("{M}/{d}/{yyyy}") : null;
					});
			} else {
				period.start.date = null;
			}
		} else {
			if ($scope.report.entities.length > 1 || ($scope.report.entities.length === 0 && !$scope.entitySelector.selectedEntity)) {
				inceptionDateParameter.value = null;
			} else {
				var report = getCleanReport();

				$http.post(baseReportUrl + "/Calculate/InceptionDate", report, { trackerMsg: 'Retrieving inception date' })
					.then(function (response) {
						inceptionDateParameter.value = response.data.inceptionDate ? Date.create(response.data.inceptionDate).format("{M}/{d}/{yyyy}") : null;
					});
			}
		}
	};

    $scope.openReportDefaults = function() {
        $dialog.dialog({templateUrl: "reporting/modals/report-defaults.html", controller: "ReportDefaultsCtrl", resolve: { reportId: function() { return reportId; } } }).open();
    };

    $scope.back = function() {
        var backStep = function() {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = $scope.wizardSteps[$scope.wizardSteps.indexOf($scope.current.wizardStep) - 1];
        };
        switch($scope.current.wizardStep) {
            case "Parameters":
                if ($scope.current.prompterMode == 'new') {                     
                    //this is for rb 3.0 report options
                    //always load additional options since that's how we get the delivery options too
                    loadAdditionalOptions().then(backStep);

                } else {
                    //this is for ssrs report options
                    if ($scope.report.hasStorableParameters && $scope.report.entities.length <= 1) {
                        loadStorableParameters().then(backStep);
                    } else {
                        $scope.report.storable = null;
                        backStep();
                    }
                }
                break;

            default:
                backStep();
                break;
        }
    };

    $scope.next = function() {
        var advanceStep = function () {
            $scope.current.animation = 'slide-right';
            $scope.current.wizardStep = $scope.wizardSteps[$scope.wizardSteps.indexOf($scope.current.wizardStep) + 1];
        };

        switch ($scope.current.wizardStep) {
            case "Selection":
                loadReport();
                break;
            case "Options":
                if ($scope.current.prompterMode == 'new') {
                    //this is for rb 3.0 report options
                    //always load additional options since that's how we get the delivery options too
                    loadAdditionalOptions().then(advanceStep);

                } else {
                    //this is for ssrs report options
                    var continueProcess = function() {
                        if (entityParameter) {
                            var count = $scope.report.entities.length;
                            $scope.current.singleEntity = count === 1 ? $scope.report.entities[0]
                                : count === 0 && isPkEntityRequired() ? {entity: $scope.current.runForParameter.value.has(",") ? $scope.entitySelector.selectedEntity.type : $scope.current.runForParameter.value, entityId: $scope.entitySelector.selectedEntity.id, name: $scope.entitySelector.selectedEntity.name}
                                : null;
                        }

                        setReportInboxOptions();

                        setDefaultCombinationMethod();

                        if ($scope.report.hasStorableParameters && $scope.report.entities.length <= 1) {
                            loadStorableParameters().then(advanceStep);
                        } else {
                            $scope.report.storable = null;
                            advanceStep();
                        }
                    };

                    if (unpackingIsNeeded()) {
                        unpackGroupForEntityList().then(continueProcess);  //if user didn't unpack it by clicking 'add', it needs to be forced
                    } else {
                        continueProcess();
                    }
                }
                break;
            default:
                advanceStep();
                break;
        }
    };

    $scope.jumpBackTo = function(index) {
        if ($scope.mainTracker.active() || index >= $scope.wizardSteps.indexOf($scope.current.wizardStep)) return;

        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep = $scope.wizardSteps[index];
    };

    $scope.selectReport = function (report) {
        $scope.reportList.selected = report;
        reportId = report.id;
    };

    $scope.toggleFavorite = function (report) {
        if (report.isFavorite) {
            $scope.reportList.favorites.remove({id: report.id});
        }

        $http.put(`/Reporting/Envision/Reports/${report.id}/Favorite`, null, {trackerMsg: 'Toggling favorite'})
            .then(response => {
                report.isFavorite = response.data.isFavorite;

                if (report.isFavorite) {
                    $scope.reportList.favorites.push(report);
                    $scope.reportList.favorites = $scope.reportList.favorites.sortBy('reportName');
                }
            });
    };

    $scope.isStepIncomplete = function() {
        switch ($scope.current.wizardStep) {
            case "Selection":
				return !reportId;

            case "Options":
                if ($scope.current.prompterMode === 'new') {
                    //this is for rb 3.0 report options

					return $scope.report.requiredOptions.any(function (option) {
						if (option.isValid === undefined) {
							return false;
						}

						return !option.isValid();
					});
                }

				//this is for ssrs report options
				if (entityParameter && isPkEntityRequired() && !$scope.entitySelector.selectedEntity && $scope.report.entities.length === 0) {
					return true;
				}

				return $scope.report.unstorable[0].parameters.any(function (parameter) {
					if (parameter === inceptionDateParameter && $scope.current.useInception)
						return false;
					else
						return parameter.input.has("date-picker") && !parameter.value;
				});
				
            default:
                return false;
        }
    };

    $scope.loadEntities = function() {
        var entity = entities[entities.find({value: $scope.current.runForParameter.value})];

        if (!entity) {
            $scope.current.entities = [{id: 0, name: "Error - No Options"}];
            return;
        }

        var clientOnly = $scope.current.runForParameter.options.every(function(option){
            return [5, NaN].some(parseInt(option.id)) && option.id.split(',').length === 1;
        });
        var regOnly = $scope.current.runForParameter.options.every(function(option){
            return [6, NaN].some(parseInt(option.id)) && option.id.split(',').length === 1;
        });
        var accountOnly = $scope.current.runForParameter.options.every(function(option){
            return [7, NaN].some(parseInt(option.id)) && option.id.split(',').length === 1;
        });

        var entityUrl = entity.simpleUrl;
        switch (entity) {
            case entities.bill:
                entityUrl += '?clientId=' + $scope.entitySelector.searchEntity.id;
                break;
            case entities.dynamicGroup:
            case entities.dynamicReportingGroup:
                entityUrl += '?usedFor=Reporting';
                if(clientOnly)
                    entityUrl += '&entity=Household';
                if(regOnly)
                    entityUrl += '&entity=Registration';
                if(accountOnly)
                    entityUrl += '&entity=Account';
                break;
        }

        $http.get(entityUrl, {trackerMsg: 'Loading ' + entity.name.pluralize()})
            .then(function (response) {
                switch (entity) {
                    case entities.wholesaler:
                        if ($scope.user.authorization.entity !== entities.wholesaler.name) {
                            response.data.unshift({id: 0, name: "All Wholesalers"});
                        }
                        break;
                    case entities.reportingGroup:
                        response.data.remove({count: 0}).forEach(function(group) {group.name += ' (' + group.count + ')';});
                        break;
                }

                $scope.current.entities = response.data;
            });
    };

    $scope.removeEntity = function(index) {
        $scope.report.entities.splice(index, 1);
    };

    $scope.addEntity = function() {
        if (unpackingIsNeeded()) {
            unpackGroupForEntityList();
        } else if ($scope.current.runForParameter.value.has(",")) {
            addToEntityList($scope.entitySelector.selectedEntity.type, $scope.entitySelector.selectedEntity.id, $scope.entitySelector.selectedEntity.name);

            if ($scope.entitySelector.selectedEntity.type === entities.client.value && $scope.user.authorization.entity !== entities.client.name) {
                $scope.entitySelector.searchEntity = null;
            } else {
                $scope.entitySelector.selectedEntity.selected = false;
                $scope.entitySelector.items[0].selected = true;
                $scope.entitySelector.selectedEntity = $scope.entitySelector.items[0];
            }
        } else {
            addToEntityList($scope.current.runForParameter.value, $scope.entitySelector.selectedEntity.id, $scope.entitySelector.selectedEntity.name);
            $scope.entitySelector.selectedEntity = null;
        }
    };

    $scope.setDates = function(rangeName) {
        var startDate = Date.create('today');
        var endDate = Date.create('today');

        switch (rangeName) {
            case "last-month":
                startDate.addMonths(-1).beginningOfMonth();
                endDate.addMonths(-1).endOfMonth();
                break;
            case "last-year":
                startDate.addYears(-1).beginningOfYear();
                endDate.addYears(-1).endOfYear();
                break;
            case "last-quarter":
                endDate = endDate.getStartOfQuarter().addDays(-1);
                startDate = endDate.getStartOfQuarter();
                break;
            case "MTD":
                startDate.beginningOfMonth();
                break;
            case "QTD":
                startDate = startDate.getStartOfQuarter();
                break;
            case "YTD":
                startDate.beginningOfYear();
                break;
            case "roll-1-year":
                startDate.addYears(-1);
                endDate.addDays(-1);
                break;
            case "roll-3-year":
                startDate.addYears(-3);
                endDate.addDays(-1);
                break;
        }

        startDateParameter.value = startDate;
        endDateParameter.value = endDate;
        $scope.current.useInception = false;
    };

    $scope.setChildOptions = function(categoryName, parameter, resetValue) {
        var childParameter = $scope.report.storable.find({category: categoryName}).parameters.find({name: parameter.childParameter});

        if (childParameter.parentValue === parameter.value) return;

        $http.get(parameterUrl + '/' + parameter.name + '/' + parameter.value + '/ChildOptions', {trackerMsg: 'Loading values for ' + parameter.childParameter})
            .then(function(response) {
                childParameter.parentValue = parameter.value;
                childParameter.options = response.data;

                if (resetValue)
                    childParameter.value = childParameter.input.has("multi-select") ? [] : Object.keys(response.data)[0];
            });
    };

    $scope.openMultiSelect = function(parameter) {
        var entityType;
        var idProperty = "id";

        if (parameter.$type === 'benchmark-override') {
            entityType = 35;
            idProperty = "key";
        }
        else
            throw "Invalid parameter passed to big-multi-select: " + parameter.name;

        var selectedItems = parameter.benchmarks.map(function(b){
            var item = {};
            item[idProperty] = b;
            return item;
        });

        $dialog.dialog({ templateUrl: "app/modals/available-select.html", controller: "AvailableSelectCtrl", dialogClass: 'modal wide', resolve: {availableSelectedArgs: function() { return {selectionType: entityType, selectedSelected: selectedItems}; }}})
            .open()
            .then(function(result) {
                if (result) {
                    parameter.benchmarks = result.map(idProperty);
                }
            });
    };

    $scope.openBigMultiSelect = function(parameter) {
        var entityType;
        var idProperty = "id";

        if (parameter.name.toLowerCase().has("index")) {
            entityType = 35;
            idProperty = "key";
        }
        else
            throw "Invalid parameter passed to big-multi-select: " + parameter.name;

        var selectedItems = [];
        for (var i = 0; i < parameter.value.length; i++) {
            var item = {};
            item[idProperty] = parameter.value[i];
            selectedItems.push(item);
        }

        $dialog.dialog({ templateUrl: "app/modals/available-select.html", controller: "AvailableSelectCtrl", dialogClass: 'modal wide', resolve: {availableSelectedArgs: function() { return {selectionType: entityType, selectedSelected: selectedItems}; }}})
            .open()
            .then(function(result) {
                if (result) {
                    parameter.value = result.map(idProperty);
                }
            });
    };

    $scope.openComparisonOverrideMultiSelect= function(parameter) {
        var entityType;

        if (parameter.$type === 'comparison-override') {
            entityType = 35;
        }
        else {
            throw "Invalid parameter passed to big-multi-select: " + parameter.name;
        }

        let selectedItems = [];
        if (parameter.selection) {
            selectedItems = parameter.selection.benchmarks.map((x) => {
               return {
                   key: x.entityId + "_" + x.entity.charAt(0)
               };
            });
        }

        $dialog.dialog({
            templateUrl: "app/modals/available-select.html",
            controller: "AvailableSelectCtrl",
            dialogClass: 'modal wide',
            resolve: {
                availableSelectedArgs: function() {
                    return {
                        selectionType: entityType, selectedSelected: selectedItems
                    };
                }
            }
        })
            .open()
            .then(function(result) {
                if (result) {
                    parameter.$type = 'comparison-override';
                    parameter.selection = {
                        $type: 'comparison',
                        benchmarks: result.map((x) => {
                            return {
                                entity: GetBenchmarkEntity(x.type),
                                entityId: x.id
                            };
                        })
                    };
                }
            });
    };

    function GetBenchmarkEntity(type) {
        switch (type) {
            case 'B':
                return 'Blend';
            case 'P':
                return 'Product';
            case 'M':
                return 'Model';
        }
    }

    $scope.saveDefaults = function(defaultsType) {
        var report = getCleanReport();

        $http.post(parameterUrl + "/" + defaultsType, report, {trackerMsg: 'Saving defaults'})
            .then(function () {
                if (defaultsType === "EntityDefaults" || ($scope.report.defaultsType === "ReportDefaults" && defaultsType === "UserDefaults")) {
                    $scope.report.defaultsType = defaultsType;
                }
            });
    };

    $scope.deleteDefaults = function() {
        var report = getCleanReport();
        var runAssignedVersion = reportArgs.runAssignedVersion === undefined || reportArgs.runAssignedVersion === null ? "true" : reportArgs.runAssignedVersion;
        var urlSuffix = $scope.report.defaultsType === "EntityDefaults" ? "/" + $scope.current.singleEntity.entity + "/" + $scope.current.singleEntity.entityId : "";
        $http.post(parameterUrl + "/" + $scope.report.defaultsType + "/Delete" + urlSuffix + "?runAssignedVersion=" + runAssignedVersion, report, {trackerMsg: 'Deleting defaults'})
            .then(function () {
                if ($scope.current.prompterMode == 'new') {
                    loadAdditionalOptions();
                }else{
                    loadStorableParameters();
                }
            });
    };

    $scope.combinationIsAllowed = function() {
        return $scope.report.runTo.storageType === "ReportInbox" ? $scope.report.runTo.provider !== 2 : true; // 2 = Client Inbox
    };

    $scope.getCombinationMethods = function () {
        var list = [];

		if ($scope.current.prompterMode === 'new') {
            var entitySelection = $scope.report.requiredOptions.find({ id: 'entity' });
            var deliveryMethod = $scope.report.deliveryOptions.find({ id: 'delivery-method' });

            combinationMethods.none.name = "Aggregate";

            if (deliveryMethod.storageType !== "DirectDownload" || entitySelection.selectedEntities.length <= 1) {
                list.push(combinationMethods.none);
            } else {
                list.push(combinationMethods.aggregate);
            }

			if (deliveryMethod.reportFormat === "PDF") {
				list.push(combinationMethods.zip);

				if (entitySelection.selectedEntities.length > 1 || entitySelection.selectedEntities.find(item => item.entity === "import" || item.entity === "Dynamic Grouping")?.items?.length > 1) {
					list.push(combinationMethods.simplex);
					list.push(combinationMethods.duplex);
				}
			}

		} else {
			if ($scope.report.runTo.storageType !== "DirectDownload" || $scope.report.entities.length <= 1) {
				list.push(combinationMethods.none);
			}

			list.push(combinationMethods.zip);

			if ($scope.report.runTo.reportFormat === "PDF" && $scope.report.entities.length > 1 ) {
				list.push(combinationMethods.simplex);
				list.push(combinationMethods.duplex);
			}
		}

        return list;
    };

    $scope.runReport = function() {
        var continueProcess = function() {

            if ($scope.current.prompterMode !== 'new') {
                if ($scope.getCombinationMethods().none({value: $scope.report.runTo.combinationMethod})) {
                    setDefaultCombinationMethod();
                }
            }

            var report = getCleanReport(true);

            var saveUserOptionsAndRunReport = function () {
			    if (!$scope.user.isImpersonating) {  //only save user options when not impersonating
                    if ($scope.current.prompterMode === 'new') {
                        var period = $scope.report.requiredOptions.find({ $type: 'daterange' });

                        if (period && period.rememberDateParameter) {
                            var dataToSave = [];
                            dataToSave.push({ id: period.id, $type: period.$type, start: Date.create(period.start.date).format("{M}/{d}/{yyyy}"), end: Date.create(period.end.date).format("{M}/{d}/{yyyy}") });
                            if (dataToSave.length > 0) {
                                var payload = {
                                    id: storedParameterValues.id,
                                    optionName: storedParameterValues.optionName,
                                    value: JSON.stringify(dataToSave)
                                };

                                $http.post("/Settings/UserOptions/" + payload.optionName, payload)
                                    .then(function (response) {
                                        storedParameterValues.id = response.data.id;
                                    });
                            }
                        } else if (storedParameterValues.id !== 0) {
                            $http.delete("/Settings/UserOptions/" + storedParameterValues.optionName)
                                .then(function () {
                                    storedParameterValues.id = 0;
                                });
                        }
                    } else {
                        if ($scope.current.rememberDateParameter && $scope.report.unstorable.length > 0) {
                            var dataToSave = [];
                            $scope.report.unstorable[0].parameters.forEach(function (parameter) {
                                if (parameter.input.has('date'))
                                    dataToSave.push({ id: parameter.id, value: Date.create(parameter.value).format("{M}/{d}/{yyyy}") });
                            });
                            if (dataToSave.length > 0) {
                                var payload = {
                                    id: storedParameterValues.id,
                                    optionName: storedParameterValues.optionName,
                                    value: JSON.stringify(dataToSave)
                                };

                                $http.post("/Settings/UserOptions/" + payload.optionName, payload)
                                    .then(function (response) {
                                        storedParameterValues.id = response.data.id;
                                    });
                            }
                        } else if (storedParameterValues.id !== 0) {
                            $http.delete("/Settings/UserOptions/" + storedParameterValues.optionName)
                                .then(function () {
                                    storedParameterValues.id = 0;
                                });
                        }
                    }
                }

                $http.post(baseReportUrl + "/Generate", report, {trackerMsg: 'Generating report'})
                    .then(function (response) {
                        if ($scope.current.prompterMode === 'new') {
                            var deliveryMethod = $scope.report.deliveryOptions.find({ id: 'delivery-method' });
                            var entitySelection = $scope.report.requiredOptions.find({ id: 'entity' });

                            if (entitySelection.selectedEntities.length > 1 && deliveryMethod.reportFormat === "PDF" && deliveryMethod.combinationMethod !== "Aggregate" && deliveryMethod.combinationMethod !== "None") {
                                $scope.isRunningBatch = true;
                                $scope.batchMessage.push({
                                    reportName: report.reportName,
                                    numEntities: entitySelection.selectedEntities.length
                                });
                            } else {
                                if (deliveryMethod.storageType === "DirectDownload") {
                                    var location = response.headers("location");
                                    if (location) {
                                        var url = location + (location.has("?") ? "&" : "?") + "Authorization=" + sessionStorage.oas_token;
                                        if (deliveryMethod.reportFormat === "Html") {
                                            popupBlockerChecker.open(url);
                                        } else {
                                            window.location.href = url;
                                        }
                                    }
                                } else {
                                    $scope.current.messages.push({
                                        name: report.reportName,
                                        runTo: report.runTo.displayName
                                    });
                                }
                            }
                        } else {
                            if (report.runTo.storageType === "DirectDownload") {
                                var location = response.headers("location");
                                if (location) {
                                    window.location.href = location + (location.has("?") ? "&" : "?") + "Authorization=" + sessionStorage.oas_token;
                                }
                            } else {
                                $scope.current.messages.push({
                                    name: report.reportName,
                                    runTo: report.runTo.displayName
                                });
                            }
                        }
                    });
            };

            if (report.disclaimer) {
                $dialog.confirmAction("<p>" + report.disclaimer.replace(new RegExp('\r\n\r\n', 'g'), '</p><p>') + "</p><p>Do you want to continue?</p>")
                    .open()
                    .then(function(result) {
                        if (result === 'yes') {
                            saveUserOptionsAndRunReport();
                        }
                    });
            } else {
                saveUserOptionsAndRunReport();
            }
        };

        if($scope.versionReportId) {
            $scope.originalReportId = $scope.originalReportId || reportId;
            reportId = $scope.versionReportId;
            $scope.report.id = $scope.versionReportId;
        }
        if ($scope.current.wizardStep === "Options" && unpackingIsNeeded()) {
            unpackGroupForEntityList().then(continueProcess);  //if user didn't unpack it by clicking 'add', it needs to be forced
        } else {
            continueProcess();
        }
	};

	var cloudProvidersPromise;
	$scope.resetCloudProvidersPromise = function () {
		cloudProvidersPromise = $http.get("/Integrations/CloudStorage/List", { trackerMsg: 'Loading cloud storage providers' });
		return cloudProvidersPromise;
	};

	$scope.getCloudProvidersPromise = function () {
		if (!cloudProvidersPromise) {
			return resetCloudProvidersPromise();
        }

        return cloudProvidersPromise;
    };

    $scope.getCloudProviders = function() {
		$scope.resetCloudProvidersPromise()
            .then(function (response) {
                response.data.forEach(function(item) {
                    if ($scope.runToOptions.none({provider: item.provider})) {
                        $scope.runToOptions.push({storageType: "CloudStorage", displayName: item.provider, provider: item.provider, folderPath: null, combinationMethod: 'None', reportFormat: 'PDF'});
                    }
                });
            });
    };

    $scope.buildFolderTree = function() {
        setDefaultCombinationMethod();

        if ($scope.report.runTo.storageType !== "CloudStorage") return;

        var tree = cachedFolderTrees[$scope.report.runTo.provider];

        if (!tree) {
            tree = [];
            var node = {label: $scope.report.runTo.displayName, id: "/", collapsed: false, selected: true, children: [], isLoaded: false};
            tree.push(node);
            cachedFolderTrees[$scope.report.runTo.provider] = tree;
            $scope.folderSelector.selectedFolder = node;
        }

        $scope.folderSelector.items = tree;
    };

    $scope.addNewFolder = function() {
        var selectedFolder = $scope.folderSelector.selectedFolder;
        var newNode = {label: $scope.current.newCloudFolder, id: selectedFolder.id + (selectedFolder.id.endsWith("/") ? "" : "/") + $scope.current.newCloudFolder, collapsed: false, selected: true, children: [], isLoaded: true};

        selectedFolder.selected = false;
        selectedFolder.children.push(newNode);
        $scope.folderSelector.selectedFolder = newNode;

        $scope.current.newCloudFolder = null;
    };

    $scope.close = function() {
        if (!$scope.current.isFullPage) {
            dialog.close();
        } else {
            window.parent.postMessage("iframeclose");
        }
    };

    $scope.importEntityIds = function() {
        var entity = entities[entities.find({value: $scope.current.runForParameter.value.split(',')[0]})];

        $dialog.inputBox("Import " + entity.name + " IDs", "File", "file", {postUrl: "/ValidateImport/Echo"})
            .open()
            .then(function(data){
                if (!data) return;

                var ids = Object.values(data[0].result)[0].map(function (x) {
                    return Object.values(x)[0];
                });

                if (ids.length > 0) {
                    $http.post(entity.simpleUrl + "/List", ids, {trackerMsg: 'Processing ' + data[0].fileName})
                        .then(function (response) {
                            response.data.forEach(function (item) {
                                addToEntityList(entity.value, item.id, item.name);
                            });
                        });
                }
            }
        );
    };

    $scope.getFlagKeys = function () {
        return Object.keys($scope.report.featureFlagOverrides).sort();
    };

    //INITIALIZE
    $scope.wizardSteps = [];
    $scope.current = {showImport:false, animation: 'slide-right', isFullPage: !dialog, canUpdateDefaults: $oasRights.canUpdate("RPTSVC_PARAMS"), canUpdateEntityDefaults: $oasRights.canUpdate("RPTSVC_PARAMS_ENTITY"), messages: [], cloudSetupInProgress: false, newCloudFolder: null, expandAll: false, runForParameter: null, entities: [], useInception: false, singleEntity: null, selectedProfile: null, rememberDateParameter: false, archiveReport: false};
    $scope.runToOptions = [{storageType: "DirectDownload", displayName: "Direct Download", combinationMethod: 'None', reportFormat: 'PDF'}];
    $scope.folderSelector = {selectedFolder: null, items: []};
    $scope.entitySelector = {selectedEntity: null, items: [], searchEntity: null};
    $scope.isRunningBatch = false;
    $scope.batchMessage = [];
    $scope.numEntities = 0;
    $scope.getCloudProviders();
    $scope.current.fromNewReportPage = reportArgs.fromNewReportPage;

    if ($scope.current.isFullPage) {
        window.parent.postMessage("iframeload");
    }

    if (!reportId) {
        $http.get('/Reporting/Reports?orionConnectMenu=true', {trackerMsg: 'Loading reports'})
            .then(function (response) {
                const rawData = response.data.findAll({parentCategory: 'Portfolio'}).sortBy('reportName');

                $scope.reportList = {
                    categorized: rawData.groupOn('category', true),
                    favorites: rawData.findAll({isFavorite: true}),
                    selected: null
                };

                $scope.wizardSteps.add(['Selection', 'Options']);
                $scope.current.wizardStep = 'Selection';
            });
    } else {
        loadReport();
    }

    //EVENT LISTENERS
    $scope.$on('rc-entity--selector-event:entity-change', function (e, args) {
        if(!$scope.current.fromNewReportPage) {
            return;
        }

        const entitySelection = $scope.report.requiredOptions.find({ id: 'entity' });
        const entityIds = args.map(x=>x.entityId);

        if (entityIds.length === 0) {
            return;
        }
        
        const parentReportId = $scope.originalReportId ? $scope.originalReportId : reportId;
        $http.post("/Reporting/Envision/Reports/GetReportVersionAssignment/" + entitySelection.entity + "/" + parentReportId, entityIds)
            .then(function (response) {
                $scope.originalReportId = parentReportId;
                $scope.versionReportId = response.data == null ? $scope.originalReportId : response.data;
        });
    });


    //SCOPE WATCHERS
    $scope.$watch("folderSelector.selectedFolder", function (newValue, oldValue) {
        if (newValue === oldValue) return;

        var node = $scope.folderSelector.selectedFolder;
        $scope.report.runTo.folderPath = node.id;

        if (!node.isLoaded) {
            $http.get("/Integrations/CloudStorage/" + $scope.report.runTo.provider + "/Browse" + node.id, {trackerMsg: 'Loading folder paths'})
                .then(function (response) {
                    var folders = response.data.folders.sortBy("name");
                    folders.forEach(function (folder) {
                        node.children.push({label: folder.name, id: folder.path, collapsed: true, selected: false, children: [], isLoaded: false});
                    });

                    node.isLoaded = true;
                });
        }
    }, true);

    $scope.$watch("current.runForParameter.value", function (newValue, oldValue) {
        if (newValue === oldValue) return;

        $scope.entitySelector.selectedEntity = null;
        $scope.entitySelector.searchEntity = null;
    });

    $scope.$watch("current.useInception", function (newValue, oldValue) {
        //had to use a watch because ng-click on a btn-checkbox acts weird
        if (newValue === oldValue || !newValue) return;

		$scope.setInceptionDate();
    });
}]);


'use strict';

app.controller('CompositeReportPrompterCtrl', ['$scope', '$http', '$dialog', '$timeout', '$oasRights', 'entities', 'dialog', 'reportId', 'reportArgs', 'popupBlockerChecker', function CompositeReportPrompterCtrl($scope, $http, $dialog, $timeout, $oasRights, entities, dialog, reportId, reportArgs, popupBlockerChecker) {
    //PRIVATE VARIABLES
    var entityParameter, startDateParameter, endDateParameter, inceptionDateParameter, storedParameterValues;
    var cachedFolderTrees = {};
    var baseReportUrl, parameterUrl, compositeReportUrl;

    //PRIVATE METHODS
    function loadReport() {
        baseReportUrl = "/Reporting/Reports/" + reportId;
        parameterUrl = baseReportUrl + "/Parameters";
        compositeReportUrl = "/Reporting/Composite/Reports/";

        $scope.wizardSteps.remove("Options", "Parameters", "Delivery");

        $http.get("/Settings/UserOptions/report_params_" + reportId, {trackerMsg: 'Loading settings'})
            .then(function(response){
                storedParameterValues = response.data;
                return $http.get(parameterUrl, {trackerMsg: 'Loading report'});
            })
            .then(function (response) {
                var data = response.data;
                $scope.current.showDateDefaultEditBtn = data.category !== "ReportBuild" && $oasRights.canUpdate("STNDRDRPTSECURITYBTN");

				if (data.unstorable !== undefined && data.unstorable.length > 0) {
					//this is for ssrs report options
					$scope.wizardSteps.push("Options");

                    data.unstorable[0].parameters.forEach(function (parameter) {
                        switch(parameter.input) {
                            case "inception-date-picker":
                                inceptionDateParameter = parameter;
                                break;
                            case "select":
                                var options = [];
                                Object.keys(parameter.options, function(key, value) {
                                    options.push({id: key, name: value});
                                });
                                parameter.options = options.sortBy("name");
                                break;
                        }

                        if (parameter.name === "fkCompositeAdHocInstance") {
                            if (reportArgs.fkCompositeAdHocInstance) {
                                var instance = parameter.options.find(o => o.id == [reportArgs.fkCompositeAdHocInstance]);

                                if (instance) {
                                    parameter.value = instance.id;
                                }
                            }
                        }

                        if(storedParameterValues.value) {
                            var storedSettings = JSON.parse(storedParameterValues.value);
                            var storedValue = storedSettings ? storedSettings.find({id: parameter.id}) : null;
                            if (storedValue) {
                                parameter.value = storedValue.value;
                                if(parameter.input.has('date')) {
                                    $scope.current.rememberDateParameter = true;
                                }
                            }
                        }
                    });
                }

                if (data.hasStorableParameters) {
                    $scope.wizardSteps.push("Parameters");
                }

                $scope.wizardSteps.push("Delivery");
                $scope.current.animation = 'slide-right';
				$scope.current.wizardStep = $scope.wizardSteps[$scope.wizardSteps.first() === "Selection" ? 1 : 0];

				$scope.report = data;
                $scope.report.runTo = $scope.runToOptions[0];
                $scope.report.entities = [];
                $scope.report.runTo.archiveReport = false;
                $scope.current.archiveReport = true;
                $scope.current.isAdhoc = reportArgs.isAdhoc;

                loadStorableParameters();

                if($scope.hideScreenOutput) {
                    $scope.report.deliveryOptions.find({ id: 'delivery-method' }).reportFormat = "PDF";
                }
            });

        $http.get("/Settings/Database/EntityOptions/Code/69HIDEEXCE", {cache: true, trackerMsg: 'Loading output format setting'})
            .then(function(response) {
                $scope.current.hideExcelOutputFormat = response.data.value == "True";
            });
    }

    function isPkEntityRequired() {
        return [entities.owner.value, entities.notDefined.value].none($scope.current.runForParameter.value);
    }

    function getCleanReport() {
        //using a copy here so we don't permanently alter any values currently being displayed to the user
        var report = angular.copy($scope.report);

        if (report.unstorable && report.unstorable.length > 0) {

            report.unstorable[0].parameters.forEach(function(parameter){

                if (parameter.input.has("date-picker")) {
                    parameter.value = parameter.input === "inception-date-picker" && $scope.current.useInception ? null : Date.create(parameter.value).format('{M}/{d}/{yyyy}');
                }
            });
        }

        if (report.storable && report.storable.length > 0) {
            report.storable.forEach(function(group) {
                group.parameters.forEach(function (parameter) {
                    if (parameter.input.has("multi-select")) {
                        parameter.value = parameter.value.join();
                    } else if (parameter.input.has("date-picker")) {
                        parameter.value = Date.create(parameter.value).format('{M}/{d}/{yyyy}');
                    }
                });
            });
        }

        if(report.runTo){
            report.runTo.userIdList = report.runTo.provider === 3 ? [$scope.current.selectedProfile.userId] : null;
		}

        return report;
    }

    function loadStorableParameters() {
        var report = getCleanReport();

        return $http.post(parameterUrl, report, {trackerMsg: 'Loading report parameters'})
            .then(function (response) {
                $scope.report.id = response.data.id; //in case it changed on us (versioned report)

                response.data.storable.forEach(function(group) {
                    group.parameters.forEach(function (parameter) {
                        if (parameter.input.has("multi-select")) {
                            parameter.value = parameter.value ? parameter.value.split(",") : [];
                        }
                    });
                });
                $scope.report.storable = response.data.storable;
                $scope.report.defaultsType = response.data.defaultsType;
            });
    }

    function setReportInboxOptions() {
        var report = getCleanReport();

        $scope.runToOptions.remove({storageType: "ReportInbox"});

        $http.post(baseReportUrl + "/ReportInboxes", report, {trackerMsg: 'Loading report inbox options'})
            .then(function (response) {
                response.data.forEach(function (inboxType) {
                    $scope.runToOptions.push({storageType: "ReportInbox", displayName: "Report Inbox: " + inboxType.name, provider: inboxType.id, combinationMethod: 'None', reportFormat: 'PDF'});
                });
            });

        if( ["Administrator", "Advisor"].any($scope.user.authorization.entity) ) {
            $scope.runToOptions.push({storageType: "ReportInbox", displayName: "Selected Inbox", provider: 3, combinationMethod: 'None', reportFormat: 'PDF', userIdList: null});
        }
    }

    function setDefaultCombinationMethod() {
        if ($scope.current.prompterMode !== 'new') {
        	$scope.report.runTo.combinationMethod = $scope.report.runTo.storageType === "DirectDownload" && $scope.report.entities.length > 1 ? "Zip" : "None";
		}
    }

    function getFeeOption(feeOption) {
        switch (feeOption) {
            case "Gross & Net":
                return  "GrossAndNetActual";
            default:
                return feeOption;
        }
    }

    function getCompositeRequest(report) {
        var request = {
            compositeReportId: 1,
            compositeReportName: "Composite Firmwide",
            reportFormat: report.runTo.reportFormat,
            compositeAdHocInstance: reportArgs.fkCompositeAdHocInstance
        };

        function addParametersToRequest(optionGroup) {
            optionGroup.forEach(function(category) {
                if (category.parameters && category.parameters.length > 0) {
                    category.parameters.forEach(function(parameter) {
                        switch (parameter.name) {
                            case "fkCompositeReport":
                                request.compositeReportId = parameter.value;
                                request.compositeReportName = parameter.options.find(g => g.id == request.compositeReportId).name;
                                break;

                            case "feeOption":
                                request[parameter.name] = getFeeOption(parameter.options[parameter.value]);
                                break;

                            case "fkCompositeAdHocInstance":
                                if (reportArgs.isAdhoc && reportArgs.fkCompositeAdHocInstance === null)
                                {
                                    request.compositeAdHocInstance = parameter.value;
                                }
                                break;

                            default:
                                request[parameter.name] = parameter.value;
                                break;
                        }
                    });
                }
            });
        }

        if(report.unstorable && report.unstorable.length > 0) {
            addParametersToRequest(report.unstorable);
        }

        if(report.storable && report.storable.length > 0) {
            addParametersToRequest(report.storable);
        }

        request.compositeReportType = setCompositeReportType(report.reportDescription);

        return request;
    }

    function setCompositeReportType(description) {
        switch(description) {
            case "Composite GIPS":
                return "Firmwide";

            case "Composite Membership Report":
                return "Membership";

            case "Composite Interval":
                return "Interval";

            case "Composite Daily":
                return  "Daily";

            default:
                return "Standard";
        }
    }

	//PUBLIC METHODS
    $scope.openReportDefaults = function() {
        $dialog.dialog({templateUrl: "reporting/modals/report-defaults.html", controller: "ReportDefaultsCtrl", resolve: { reportId: function() { return reportId; } } }).open();
    };

    $scope.back = function() {
        var backStep = function() {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = $scope.wizardSteps[$scope.wizardSteps.indexOf($scope.current.wizardStep) - 1];
        };
        switch($scope.current.wizardStep) {
            case "Parameters":
                //this is for ssrs report options
                if ($scope.report.hasStorableParameters && $scope.report.entities.length <= 1) {
                    loadStorableParameters().then(backStep);
                } else {
                    $scope.report.storable = null;
                    backStep();
                }
                break;

            default:
                backStep();
                break;
        }
    };

    $scope.next = function() {
        var advanceStep = function () {
            $scope.current.animation = 'slide-right';
            $scope.current.wizardStep = $scope.wizardSteps[$scope.wizardSteps.indexOf($scope.current.wizardStep) + 1];
        };

        switch ($scope.current.wizardStep) {
            case "Selection":
                loadReport();
                break;
            case "Options":
                 {
                    //this is for ssrs report options
                    var continueProcess = function() {
                        if (entityParameter) {
                            var count = $scope.report.entities.length;
                            $scope.current.singleEntity = count === 1 ? $scope.report.entities[0]
                                : count === 0 && isPkEntityRequired() ? {entity: $scope.current.runForParameter.value.has(",") ? $scope.entitySelector.selectedEntity.type : $scope.current.runForParameter.value, entityId: $scope.entitySelector.selectedEntity.id, name: $scope.entitySelector.selectedEntity.name}
                                : null;
                        }

                        setReportInboxOptions();

                        setDefaultCombinationMethod();

                        if ($scope.report.hasStorableParameters && $scope.report.entities.length <= 1) {
                            loadStorableParameters().then(advanceStep);
                        } else {
                            $scope.report.storable = null;
                            advanceStep();
                        }
                    };

                    continueProcess();
                }
                break;
            default:
                advanceStep();
                break;
        }
    };

    $scope.jumpBackTo = function(index) {
        if ($scope.mainTracker.active() || index >= $scope.wizardSteps.indexOf($scope.current.wizardStep)) return;

        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep = $scope.wizardSteps[index];
    };

    $scope.setReportId = function(report) {
        $scope.reportList.forEach(function(item){
            item.reports.forEach(function(report) {
                report.isActive = false;
            });
        });

        reportId = report.id;
        report.isActive = true;
    };

    $scope.isStepIncomplete = function() {
        switch ($scope.current.wizardStep) {
            case "Selection":
                return !reportId;

            case "Options":
                //this is for ssrs report options
                if (entityParameter && isPkEntityRequired() && !$scope.entitySelector.selectedEntity && $scope.report.entities.length === 0) {
                    return true;
                }

                return $scope.report.unstorable[0].parameters.any(function (parameter) {
                    if (parameter === inceptionDateParameter && $scope.current.useInception) {
                        return false;
                    }
                    else {
                        return parameter.input.has("date-picker") && !parameter.value;
                    }
                });

            default:
                return false;
        }
    };

    $scope.setDates = function(rangeName) {
        var startDate = Date.create('today');
        var endDate = Date.create('today');

        switch (rangeName) {
            case "last-month":
                startDate.addMonths(-1).beginningOfMonth();
                endDate.addMonths(-1).endOfMonth();
                break;
            case "last-year":
                startDate.addYears(-1).beginningOfYear();
                endDate.addYears(-1).endOfYear();
                break;
            case "last-quarter":
                endDate = endDate.getStartOfQuarter().addDays(-1);
                startDate = endDate.getStartOfQuarter();
                break;
            case "MTD":
                startDate.beginningOfMonth();
                break;
            case "QTD":
                startDate = startDate.getStartOfQuarter();
                break;
            case "YTD":
                startDate.beginningOfYear();
                break;
            case "roll-1-year":
                startDate.addYears(-1);
                endDate.addDays(-1);
                break;
            case "roll-3-year":
                startDate.addYears(-3);
                endDate.addDays(-1);
                break;
        }

        startDateParameter.value = startDate;
        endDateParameter.value = endDate;
        $scope.current.useInception = false;
    };

    $scope.setChildOptions = function(categoryName, parameter, resetValue) {
        var childParameter = $scope.report.storable.find({category: categoryName}).parameters.find({name: parameter.childParameter});

        if (childParameter.parentValue === parameter.value) {
            return;
        }

        $http.get(parameterUrl + '/' + parameter.name + '/' + parameter.value + '/ChildOptions', {trackerMsg: 'Loading values for ' + parameter.childParameter})
            .then(function(response) {
                childParameter.parentValue = parameter.value;
                childParameter.options = response.data;

                if (resetValue) {
                    childParameter.value = childParameter.input.has("multi-select") ? [] : Object.keys(response.data)[0];
                }
            });
    };

    $scope.openMultiSelect = function(parameter) {
        var entityType;
        var idProperty = "id";

        if (parameter.$type === 'benchmark-override') {
            entityType = 35;
            idProperty = "key";
        }
        else
            throw "Invalid parameter passed to big-multi-select: " + parameter.name;

        var selectedItems = parameter.benchmarks.map(function(b){
            var item = {};
            item[idProperty] = b;
            return item;
        });

        $dialog.dialog({ templateUrl: "app/modals/available-select.html", controller: "AvailableSelectCtrl", dialogClass: 'modal wide', resolve: {availableSelectedArgs: function() { return {selectionType: entityType, selectedSelected: selectedItems}; }}})
            .open()
            .then(function(result) {
                if (result) {
                    parameter.benchmarks = result.map(idProperty);
                }
            });
    };

    $scope.openBigMultiSelect = function(parameter) {
        var entityType;
        var idProperty = "id";

        if (parameter.name.toLowerCase().has("index")) {
            entityType = 35;
            idProperty = "key";
        }
        else
            throw "Invalid parameter passed to big-multi-select: " + parameter.name;

        var selectedItems = [];
        for (var i = 0; i < parameter.value.length; i++) {
            var item = {};
            item[idProperty] = parameter.value[i];
            selectedItems.push(item);
        }

        $dialog.dialog({ templateUrl: "app/modals/available-select.html", controller: "AvailableSelectCtrl", dialogClass: 'modal wide', resolve: {availableSelectedArgs: function() { return {selectionType: entityType, selectedSelected: selectedItems}; }}})
            .open()
            .then(function(result) {
                if (result) {
                    parameter.value = result.map(idProperty);
                }
            });
    };

    $scope.saveDefaults = function(defaultsType) {
        var report = getCleanReport();

        $http.post(parameterUrl + "/" + defaultsType, report, {trackerMsg: 'Saving defaults'})
            .then(function () {
                if (defaultsType === "EntityDefaults" || ($scope.report.defaultsType === "ReportDefaults" && defaultsType === "UserDefaults")) {
                    $scope.report.defaultsType = defaultsType;
                }
            });
    };

    $scope.deleteDefaults = function() {
        var report = getCleanReport();
        var runAssignedVersion = reportArgs.runAssignedVersion === undefined || reportArgs.runAssignedVersion === null ? "true" : reportArgs.runAssignedVersion;
        var urlSuffix = $scope.report.defaultsType === "EntityDefaults" ? "/" + $scope.current.singleEntity.entity + "/" + $scope.current.singleEntity.entityId : "";
        $http.post(parameterUrl + "/" + $scope.report.defaultsType + "/Delete" + urlSuffix + "?runAssignedVersion=" + runAssignedVersion, report, {trackerMsg: 'Deleting defaults'})
            .then(function () {
                loadStorableParameters();
            });
    };

    $scope.runReport = function() {
        var continueProcess = function() {

            var report = getCleanReport();
            var compositeRequest = getCompositeRequest(report);

            var saveUserOptionsAndRunReport = function () {
			    if (!$scope.user.isImpersonating) {  //only save user options when not impersonating
                    if ($scope.current.rememberDateParameter && $scope.report.unstorable.length > 0) {
                        var dataToSave = [];
                        $scope.report.unstorable[0].parameters.forEach(function (parameter) {
                            if (parameter.input.has('date')) {
                                dataToSave.push({
                                    id: parameter.id,
                                    value: Date.create(parameter.value).format("{M}/{d}/{yyyy}")
                                });
                            }
                        });

                        if (dataToSave.length > 0) {
                            var payload = {
                                id: storedParameterValues.id,
                                optionName: storedParameterValues.optionName,
                                value: JSON.stringify(dataToSave)
                            };

                            $http.post("/Settings/UserOptions/report_params_" + reportId, payload)
                                .then(function (response) {
                                    storedParameterValues.id = response.data.id;
                                });
                        }
                    } else if (storedParameterValues.id !== 0) {
                        $http.delete("/Settings/UserOptions/report_params_" + reportId)
                            .then(function () {
                                storedParameterValues.id = 0;
                            });
                        }
                }

                $http.post(compositeReportUrl + "/Generate", compositeRequest, {trackerMsg: 'Generating report'})
                    .then(function (response) {

                        if (report.runTo.storageType === "DirectDownload") {
                            var location = response.headers("location");
                            if (location) {
                                var url = location + (location.has("?") ? "&" : "?") + "Authorization=" + sessionStorage.oas_token;
                                if (report.runTo.reportFormat === "Screen") {
                                    popupBlockerChecker.open(url);
                                } else {
                                    window.location.href = url;
                                }
                            }
                        } else {
                            $scope.current.messages.push({
                                name: report.reportName,
                                runTo: report.runTo.displayName
                            });
                        }
                    });
            };

            if (report.disclaimer) {
                $dialog.confirmAction("<p>" + report.disclaimer.replace(new RegExp('\r\n\r\n', 'g'), '</p><p>') + "</p><p>Do you want to continue?</p>")
                    .open()
                    .then(function(result) {
                        if (result === 'yes') {
                            saveUserOptionsAndRunReport();
                        }
                    });
            } else {
                saveUserOptionsAndRunReport();
            }
        };

        continueProcess();
	};

	var cloudProvidersPromise;
	$scope.resetCloudProvidersPromise = function () {
		cloudProvidersPromise = $http.get("/Integrations/CloudStorage/List", { trackerMsg: 'Loading cloud storage providers' });
		return cloudProvidersPromise;
	};

	$scope.getCloudProvidersPromise = function () {
		if (!cloudProvidersPromise) {
			return resetCloudProvidersPromise();
        }

        return cloudProvidersPromise;
    };

    $scope.getCloudProviders = function() {
		$scope.resetCloudProvidersPromise()
            .then(function (response) {
                response.data.forEach(function(item) {
                    if ($scope.runToOptions.none({provider: item.provider})) {
                        $scope.runToOptions.push({storageType: "CloudStorage", displayName: item.provider, provider: item.provider, folderPath: null, combinationMethod: 'None', reportFormat: 'PDF'});
                    }
                });
            });
    };

    $scope.buildFolderTree = function() {
        setDefaultCombinationMethod();

        if ($scope.report.runTo.storageType !== "CloudStorage") return;

        var tree = cachedFolderTrees[$scope.report.runTo.provider];

        if (!tree) {
            tree = [];
            var node = {label: $scope.report.runTo.displayName, id: "/", collapsed: false, selected: true, children: [], isLoaded: false};
            tree.push(node);
            cachedFolderTrees[$scope.report.runTo.provider] = tree;
            $scope.folderSelector.selectedFolder = node;
        }

        $scope.folderSelector.items = tree;
    };

    $scope.addNewFolder = function() {
        var selectedFolder = $scope.folderSelector.selectedFolder;
        var newNode = {label: $scope.current.newCloudFolder, id: selectedFolder.id + (selectedFolder.id.endsWith("/") ? "" : "/") + $scope.current.newCloudFolder, collapsed: false, selected: true, children: [], isLoaded: true};

        selectedFolder.selected = false;
        selectedFolder.children.push(newNode);
        $scope.folderSelector.selectedFolder = newNode;

        $scope.current.newCloudFolder = null;
    };

    $scope.close = function() {
        if (!$scope.current.isFullPage) {
            dialog.close();
        } else {
            window.parent.postMessage("iframeclose");
        }
    };

    $scope.compositeSelected = function() {
        var fkCompositeReport = 0;

        if ($scope.report) {
            if ($scope.report.reportDescription != "Composite GIPS") {
                var category = $scope.report.unstorable.find(c => c.category == "Additional Options");
                fkCompositeReport = category.parameters.find(p => p.name == "fkCompositeReport").value;
            } else {
                fkCompositeReport = 1;
            }
        }

        return fkCompositeReport > 0;
    }

    //INITIALIZE
    $scope.wizardSteps = [];
    $scope.current = {showImport:false, animation: 'slide-right', isFullPage: !dialog, canUpdateDefaults: $oasRights.canUpdate("RPTSVC_PARAMS"), canUpdateEntityDefaults: $oasRights.canUpdate("RPTSVC_PARAMS_ENTITY"), messages: [],
        cloudSetupInProgress: false, newCloudFolder: null, expandAll: false, runForParameter: null, entities: [], useInception: false, singleEntity: null, selectedProfile: null, rememberDateParameter: false, archiveReport: false};
    $scope.runToOptions = [{storageType: "DirectDownload", displayName: "Direct Download", combinationMethod: 'None', reportFormat: 'Screen'}];
    $scope.folderSelector = {selectedFolder: null, items: []};
    $scope.entitySelector = {selectedEntity: null, items: [], searchEntity: null};
    $scope.isRunningBatch = false;
    $scope.batchMessage = [];
    $scope.getCloudProviders();
    $scope.hideScreenOutput = false;

    $http.get("/Settings/Database/EntityOptions/Code/69HIDESCREEN", {cache: true, trackerMsg: 'Loading screen output format setting'})
        .then(function(response) {
            $scope.hideScreenOutput = response.data.value === "True";
        });

    if ($scope.current.isFullPage) {
        window.parent.postMessage("iframeload");
    }

    if (!reportId) {
        $http.get("/Reporting/Reports?menu=compositeNew", {cache: true, trackerMsg: "Loading reports"})
            .then(function(response) {
                var myObj = response.data.findAll({parentCategory: "Advisor"},{parentCategory:"Composite"}).sortBy("category").groupBy("category");
                $scope.reportList = Object.keys(myObj).map(function(key) {
                    return {category: key, reports: myObj[key]};
                });
                $scope.wizardSteps.add(["Selection", "Options"]);
                $scope.current.wizardStep = "Selection";
            });
    } else if (reportId && reportId.length > 1) {
        // This will be used when the reportId that is passed in is actually an array of reports. This will be used in the selection screen of the prompter.
        var myObj = reportId.findAll({parentCategory: "Advisor"}).sortBy("category").groupBy("category");
        $scope.reportList = Object.keys(myObj).map(function(key) {
            return {category: key, reports: myObj[key]};
        });
        $scope.wizardSteps.add(["Selection", "Options"]);
        $scope.current.wizardStep = "Selection";
    } else {
        loadReport();
    }


    //SCOPE WATCHERS
    $scope.$watch("folderSelector.selectedFolder", function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }

        var node = $scope.folderSelector.selectedFolder;
        $scope.report.runTo.folderPath = node.id;

        if (!node.isLoaded) {
            $http.get("/Integrations/CloudStorage/" + $scope.report.runTo.provider + "/Browse" + node.id, {trackerMsg: 'Loading folder paths'})
                .then(function (response) {
                    var folders = response.data.folders.sortBy("name");
                    folders.forEach(function (folder) {
                        node.children.push({label: folder.name, id: folder.path, collapsed: true, selected: false, children: [], isLoaded: false});
                    });

                    node.isLoaded = true;
                });
        }
    }, true);

}]);


'use strict';

app.controller ('SyncEntityListCtrl', function SyncEntityListCtrl( $scope, dialog) {
    //PUBLIC METHODS
    $scope.submit = function() {
        dialog.close($scope.current.inputValue);
    };

    $scope.cancel = function() {
        dialog.close(null);
    };

    //WATCHES
    $scope.$watch('current.inputValue.fileData', function(newValue, oldValue) {
        if (newValue === oldValue || !newValue) return;
        $scope.current.inputValue.ids = Object.values(newValue[0].result)[0].map(function (x) {
            return parseInt(Object.values(x)[0]);
        });
    });

    //INITIALIZE
    $scope.current = { entity: dialog.options.entity.capitalize(), inputValue: {fileData: null, ids: [], addOnly: false} };
});
'use strict'

app.controller ('NewVideoStatementCtrl', function NewVideoStatementCtrl( $scope, dialog) {
    //PUBLIC METHODS
    $scope.create = function() {
        dialog.close($scope.current);
    };

    $scope.cancel = function() {
        dialog.close(null);
    };

    //INITIALIZE
    $scope.current = { id: 0, name: "", startDate: dialog.options.startDate, endDate: dialog.options.endDate, videoId: null, viewableBy: "" };
});
'use strict';

app.controller ('DataQueryEntityExclusionEditCtrl', function DataQueryEntityExclusionEditCtrl( $scope, $http, dialog ) {


    // PRIVATE METHODS
    function init( ) {
        loadDatabases( );
        loadDataQueryEntityExclusion( );
    }

    function loadDatabases( ) {
        $http.get("/Authorization/Databases", {cache: true, trackerMsg: 'Loading databases', ignoreExceptions: true})
            .then(function (response) {
                $scope.databases = response.data;
            });
    }

    function loadDataQueryEntityExclusion( ) {
        if( dialog.options.isNew ) {
            $scope.dqee = { id: 0, alClientId: 0, customRptId: 0, entity: '', parentId: 0, expirationDate: Date.create( 'tomorrow' ), notes: '', database: '', dataQueryName: '' };
            $scope.dataQueryExclusion = { id: 0, name: '' };
        } else {
            $http.get( "/Confirm/DataQueryEntityExcludes/" + dialog.options.id, { trackerMsg: 'Loading data query exclusion' } )
                .then(function ( r ) {
                    $scope.dqee = r.data;
                    $scope.dataQueryExclusion = { id: r.data.customRptId, name: r.data.dataQueryName };
                });
        }
    }

    function isValidDataQueryEntityExclusion( ) {
        var isValid = true;
        $scope.dqeeErrors = [];

        if( new Date( ).daysUntil( $scope.dqee.expirationDate ) > 30 ) {
            $scope.dqeeErrors.push( { type: 'error', title: 'Invalid Expiration Date! ', msg: ' The expiration date cannot be more than 30 days in the future' } );
            isValid = false;
        }

        if( $scope.dqee.notes === undefined || $scope.dqee.notes.length < 1 ) {
            $scope.dqeeErrors.push( { type: 'error', title: 'Invalid Notes!', msg: ' Notes are required' } );
            isValid = false;
        }

        return isValid;
    }


    //PUBLIC METHODS
    $scope.save = function( ) {
        if( isValidDataQueryEntityExclusion( ) ) {
            var args = dialog.options.isNew ? { method: "POST", id: "", trackerMsg: "Adding new data query exclusion" } : { method: "PUT", id: $scope.dqee.id, trackerMsg: "Saving data query exclusion " + $scope.dqee.id };

            $scope.dqee.customRptId = $scope.dataQueryExclusion.id;
            $scope.dqee.dataQueryName = $scope.dataQueryExclusion.name;

            $http( { method: args.method, url: '/Confirm/DataQueryEntityExcludes/' + args.id, data: $scope.dqee, trackerMsg: args.trackerMsg } )
                .then(function( r ) {
                    dialog.close( r.data );
                });
        }
    };

    $scope.cancel = function( ) {
        dialog.close( null );
    };


    //INITIALIZE
    init( );

});
'use strict';

app.controller('ReportCategoryCtrl', function SubReportCategoryCtrl($scope, dialog, args) {
    $scope.isNew = args.isNew;
    $scope.current = dialog.options || {};
    $scope.categorySelected = args.categorySelected;
    $scope.title = $scope.isNew ? 'Add New Category' :  'Edit Category';
    $scope.submit = function () {
        dialog.close($scope.categorySelected);
    };
    $scope.cancel = function () {
        dialog.close();
    };
});
'use strict';

app.controller('ReportBatchEditCtrl', function ReportBatchEditCtrl($scope, $http, $q, $oasRights, $window, $location, $routeParams, $dialog, $timeout, dialog, args, API_CONFIG, batchInsertData, splitIoService) {
    //region PRIVATE VARIABLES
    var verbose = {}, original = {}, isSaved = false, editorHotKeys;
    //endregion

    //region PRIVATE METHODS

    //region INIT/RIGHT/MENU/TABS
    function init() {
        if (!$oasRights.canRead("REPORTBATCHNEW")) {
            return;
        }

        loadRights();
        buildMenu();

        $scope.menu.each(function (category) {
            var menuItem = category.items.find({code: args.defaultTab.code});
            if (menuItem) {
                $scope.loadTab(menuItem);
                return false;
            }
        });
        loadHotKeys();
        $scope.current.isBillInstanceDisabled = !($scope.user.authorization.entity === "Administrator" || $scope.user.authorization.entity === "Advisor");
    }

    function loadRights() {
        $scope.rightsReportBatch = $oasRights.forCode("REPORTBATCHNEW");
        $scope.rightsReportBatchInternalSettings = $oasRights.forCode("REPORTBATCH_INTERNAL");
        $scope.rightsQpeDashboard = $oasRights.forCode("QPEDASHBOARD");
        $scope.rightsBillGenerator = $oasRights.forCode("BILLGENERATOR");
        $scope.rightsBillingAudit = $oasRights.forCode("BILLAUDIT");
    }

    function buildMenu() {
        var isAdminOrRIA = ["Administrator", "Advisor"].any($scope.user.authorization.entity);

        var menu = [
            {name: "Report Batch", enabled: true, items: [
                {name: 'General', code: 'reportBatchGeneral', enabled: true, load: [loadReportBatch]},
                {name: 'Email', code: 'reportBatchEmail', enabled: true, load: [loadReportBatch]},
                {name: 'Inserts', code: 'reportBatchInserts', enabled: true, load: [loadBatchInserts]}
            ]}
        ];

        /*menu.remove({enabled: false});
        menu.forEach(function (category) {
            category.items.remove({enabled: false});
        });*/

        $scope.menu = menu;
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+D', command: $scope.delete },
                { combo:'ALT+X', command: function () { $scope.close(true); } }
            ]);
        });
    }

    function loadLookups() {
        var promises = [];
        if(!$scope.current.videoStatements || $scope.current.videoStatements.length === 0) {
            promises.push($http.get('/Reporting/VideoStatements', { trackerMsg: 'Loading video statements' }));
        }
        if($scope.rightsBillGenerator.canRead || $scope.rightsBillingAudit.canRead) {
            promises.push(loadBillInstances());
        }

        $q.all( promises ).then( function( results ) {
            results.each(function(result){
                if(result) {
                    switch (result.config.url.toLocaleLowerCase()) {
                        case '/api/v1/reporting/videostatements':
                            $scope.current.videoStatements = result.data;
                            break;
                    }
                }
            });
        });
    }

    function loadBillInstances() {
        return getPagesRecursive(0, 50000);
    }

    function getPagesRecursive(skip, take) {
        return $http.get('/Billing/Instances/Simple?$top=' + take + '&$skip=' + skip, { trackerMsg: 'Loading billing instances' })
            .then(function (response) {
                if (response.data.length > 0) {
                    $scope.current.billInstances = (skip === 0) ? response.data : $scope.current.billInstances.concat(response.data);

                    if (response.data.length === take) {
                        getPagesRecursive((skip + take), take);
                    } else {
                        $scope.current.billInstances = $scope.current.billInstances.sortBy('id', true);
                        loadCurrentBillInstanceData();
                    }
                }
                else {
                    loadCurrentBillInstanceData();
                }
            });
    }

    function expandVerbose(propertyName, data) {
        verbose[propertyName] = data;
        original[propertyName] = angular.copy(data);

        if (propertyName == 'batch') {
            $scope.assignDates();
        }
    }

    function loadBaseData(data) {
        if (verbose.id === undefined) {
            expandVerbose("id", data.id);
        }
        if (verbose.hasCoverPage === undefined) {
            expandVerbose("hasCoverPage", data.hasCoverPage);
        }
        if (verbose.canEdit === undefined) {
            expandVerbose("canEdit", args.isCopy ? true : data.canEdit);
        }
        if (verbose.isGenerating === undefined) {
            expandVerbose("isGenerating", args.isCopy ? false : data.isGenerating);
        }
        if (verbose.reportName === undefined) {
            expandVerbose("reportName", data.reportName);
        }

        $scope.current.selectedDeliveryMethods = verbose.batch.statementDeliveryMethod.split(', ');

        if((data.isGenerating && !args.isCopy) && $scope.errors.none({title: 'Pending Generation '})) {
            $scope.errors.push({
                type: 'info',
                title: 'Pending Generation ',
                msg: ' This batch has reports pending generation and cannot be modified at this time.',
                showAllowClose: false
            });
        }
    }

    function saveBatch(){
        if (!verbose.batch.postedReportName || verbose.batch.postedReportName.trim() === '') {
            $dialog.actionFailed('Posted File Name is required.').open();
            return $q.resolve(false);
        }

        //Inserts need to be flattened into one collection before being submitted.
        return batchInsertData.flattenInserts()
            .then(function(inserts){
                undoInsertFormatting(inserts);
                var content = verbose;
                content.inserts = inserts; //Flattened inserts overwrite the separated inserts.
                var save = $scope.current.batchId > 0 ? {method: "PUT", id: $scope.current.batchId, trackerMsg: "Saving report batch"} : {method: "POST", id: "", trackerMsg: "Adding new report batch"};
                return $http({method: save.method, url: '/Reporting/Batch/Verbose/' + save.id, data: content, trackerMsg: save.trackerMsg});
            })
            .then(function (response) {
                isSaved = true;
                $scope.errors = [];
                $scope.current.batchId = response.data.batch.id;
                formatInserts(response.data.inserts);
                verbose = {};
                original = {};
                $scope.verbose = verbose;

                expandVerbose("id", response.data.id);
                expandVerbose("hasCoverPage", response.data.hasCoverPage);
                expandVerbose("canEdit", response.data.canEdit);
                expandVerbose("isGenerating", response.data.isGenerating);
                expandVerbose("batch", response.data.batch);
                expandVerbose("inserts", response.data.inserts);
                expandVerbose("reportName", response.data.reportName);

                batchInsertData.loadInserts(response.data.inserts)
                    .then(function(structuredInserts){
                        $scope.inserts = structuredInserts;
                        $scope.updateInserts();
                    });

                return true;
            });
    }
    //endregion

    // region LOAD REPORT BATCH
    function loadReportBatch() {
        if (verbose.batch) {
            return;
        }

        if (args.isNew && !args.isCopy) {
            var data = getNewReportBatchTemplate();
            expandVerbose("batch", data.batch);
            loadBaseData(data);
        } else {
            $http.get("/Reporting/Batch/Verbose/" + args.ids[0] + "?expand=batch,inserts", {trackerMsg: 'Loading report batch'})
                .then(function (response) {
                    expandVerbose("batch", response.data.batch);
                    loadBaseData(response.data);
                    loadLookups();

                    if(args.isCopy){
                        verbose.id = 0;
                        verbose.batch.id = 0;
                        verbose.batch.name = "Copy of " + verbose.batch.name;
                        verbose.batch.auditedBy = null;
                        verbose.batch.auditedDate = null;
                        verbose.batch.isLockedDown = false;
                        verbose.batch.ftpFileName = null;
                    }

                    //always load the inserts
                    expandVerbose("inserts", response.data.inserts);
                    if(verbose.inserts) {
                        if(args.isCopy){
                            verbose.inserts.each(function(insert, index){
                                //when copying don't bring the old pdfs over
                                insert.entityCount = 0;
                                insert.id = -(index+1);
                                insert.hasFile = false;
                                insert.warningMessage = null;
                            });
                        }

                        batchInsertData.loadInserts(verbose.inserts)
                            .then(function(structuredInserts){
                                $scope.inserts = structuredInserts;
                                $scope.updateInserts();
                            });
                    }

                    return getQpeItems();
                })
                .then(function (response) {
                    if(response && response.data.length > 0) {
                        $scope.current.qpeItems = response.data;
                    }

                    if(verbose.batch.reportId) {
                        return $http.get('/Reporting/Batch/Reports/' + verbose.batch.reportId, {
                            trackerMsg: 'Loading report information',
                            ignoreExceptions: true
                        });
                    }
                    else if(verbose.batch.isAdvisoryFee) {
                        const deferred = $q.defer();
                        const response = {
                            data: {
                                id: "FEE",
                                name: "Advisory Fee Notification",
                                allowed: [{
                                    entity: "Household",
                                    selectionMethods: [
                                        "Bill Instance"
                                    ]
                                }]
                            }
                        };
                        deferred.resolve(response);
                        return deferred.promise;
                    }
                })
                .then(function (response) {
                    if (response && response.data) {
                        var report = response.data;
                        $scope.current.report = {id: report.id, name: report.name};

                        if (args.isCopy) {
                            $http.get('/Reporting/Reports?orionConnectMenu=true', { cache: true, trackerMsg: 'Loading reports' })
                                .then(function (response) {

                                    const reportFound = response.data.find({ id: report.id });
                                    if (!reportFound) {
                                        $scope.current.report = null;
                                    }
                                });
                        }

                        $scope.current.allowedEntities = response.data.allowed.map(function (a) { return a['entity']; });
                        var selected = response.data.allowed.find({entity: verbose.batch.entity});
                        $scope.current.allowedEntitySelectionMethods = selected.selectionMethods;
                    }

                    if (verbose.batch.customReportId) {
                        return $http.get('/Reporting/Custom/Simple/Search?search=' + verbose.batch.customReportId, {
                            trackerMsg: 'Loading data query',
                            ignoreExceptions: true
                        });
                    }
                    else {
                        return null;
                    }
                })
                .then(function (response) {
                    if (response && response.data.length > 0) {
                        var dataquery = response.data.find({id: verbose.batch.reportId});
                        $scope.current.dataquery = {id: dataquery.id, name: dataquery.name};
                    }

                    if (verbose.batch.representativeId) {
                        return $http.get('/Portfolio/Representatives/' + verbose.batch.representativeId, {
                            trackerMsg: 'Loading representative information',
                            ignoreExceptions: true
                        });
                    }
                    else {
                        return null;
                    }
                })
                .then(function (response) {
                    if (response && response.data) {
                        var rep = response.data;
                        $scope.current.rep = {id: rep.id, name: (rep.lastName + ', ' + rep.firstName), number: rep.repNo};
                    }
                    return updateDynamicGroups();
                })
                .then(function (response) {
                    $scope.current.dynamicGroups = response.data.filter({isPrivate: false});
                });
        }
    }

    function loadCurrentBillInstanceData() {
        if(verbose.batch.billInstanceId) {
            var billInstance = $scope.current.billInstances.find({id: verbose.batch.billInstanceId});
            if(billInstance) {
                $scope.current.billInstanceSelectionName = billInstance;
            }
        }
    }

    function updateDynamicGroups() {
        return $http.get('/Utility/Groupings?usedFor=Reporting&entity=' + verbose.batch.entity, {trackerMsg: 'Loading dynamic groupings'});
    }

    function getQpeItems() {
        if($scope.rightsQpeDashboard.canRead) {
            return $http.get('/Reporting/Qpe', {trackerMsg: 'Loading quarterly statements'});
        }
        else {
            return null;
        }
    }

    function getNewReportBatchTemplate(){
        return {
            canEdit: true, hasCoverPage: true, id: 0, inserts: null, isGenerating: false,
            batch: {
                auditedBy: '', auditedDate: '',
                customReportId: null,
                dynamicGroupingId: null,
                startDate: '', endDate: '',
                fromInception: false,
                showInternalOnlyWarning: false,
                entity: 'Household',
                entitySelectionMethod: 'All',
                id:0, name: '', postedReportName: '',
                printAlternativeAddresses: false,
                qpeItemId: null,
                reportId: null,
                videoStatementId: null,
                representativeId: null,
                billInstanceId: null,
                isActive: false,
                customReport: null,
                statementDeliveryMethod: 'Use Assigned',
                ftpFileName: null,
                emailFrom: null,
                emailSubject: null,
                emailBody: null,
                includeAllBills: false,
                isLockedDown: false
            }
        };
    }

    function getToEmailAddress(){
        return $dialog.inputBox('Send To', "Email Address").open();
    }

    function sendEmail(emailTo){
        if(emailTo) {
            return $http.post('/Reporting/Batch/' + $scope.current.batchId + '/Action/SendTestEmail', "'" + emailTo + "'", {trackerMsg: 'Sending test email'});
        } else {
            return null;
        }
    }

    $scope.invalidEmail = function (invalid) {
        $scope.verbose.batch.emailFromInvalid = invalid;
    };

    $scope.setEmail = function (value) {
        $scope.verbose.batch.emailFrom = value;
    };

    $scope.entityCheck = function () {
        if (verbose.batch.entity !== 'Household') {
            verbose.batch.videoStatementId = null;
            verbose.batch.printAlternativeAddresses = null;
        }

        var selected = $scope.current.allowed.find({entity: verbose.batch.entity});
        if(selected !== undefined) {
            $scope.current.allowedEntitySelectionMethods = selected.selectionMethods;
        }

        updateDynamicGroups()
            .then(function (response) {
                $scope.current.dynamicGroups = response.data;
            });
    };

    $scope.assignDates = function () {
        var qpeItem = $scope.current.qpeItems.find({id: verbose.batch.qpeItemId});
        if (qpeItem) {
            $scope.current.startDate = qpeItem.startDate;
            $scope.current.endDate = Date.create(qpeItem.startDate).advance({month: (qpeItem.period === "Quarterly") ? 3 : 1}).addDays(-1);
        }
        else {
            $scope.current.startDate = verbose.batch.startDate;
            $scope.current.endDate = verbose.batch.endDate;
        }
    };

    $scope.setDates = function(rangeName) {
        var startDate = Date.create('today');
        var endDate = Date.create('today');

        switch (rangeName) {
            case "last-month":
                startDate.addMonths(-1).beginningOfMonth();
                endDate.addMonths(-1).endOfMonth().beginningOfDay();
                break;
            case "last-year":
                startDate.addYears(-1).beginningOfYear();
                endDate.addYears(-1).endOfYear().beginningOfDay();
                break;
            case "last-quarter":
                endDate = endDate.getStartOfQuarter().addDays(-1);
                startDate = endDate.getStartOfQuarter();
                break;
            case "MTD":
                startDate.beginningOfMonth();
                break;
            case "QTD":
                startDate = startDate.getStartOfQuarter();
                break;
            case "YTD":
                startDate.beginningOfYear();
                break;
            case "roll-1-year":
                startDate.addYears(-1);
                endDate.addDays(-1);
                break;
            case "roll-3-year":
                startDate.addYears(-3);
                endDate.addDays(-1);
                break;
        }

        $scope.current.startDate = startDate;
        $scope.current.endDate = endDate;
    };

    $scope.loadPrompts = function(dataQueryId) {
        $dialog.dataQueryPrompt(verbose.batch.customReport || dataQueryId, "edit-only")
            .open()
            .then(function (result) {
                if (result) {
                    verbose.batch.customReport = result;
                }
            });
    };

    $scope.isChecked = function(key){
        var uaIndex = $scope.current.selectedDeliveryMethods.findIndex("Use Assigned");
        if(key === -1 && uaIndex === 0) {
            return true;
        }
        var method = $scope.current.allowedDeliveryMethods[key];
        return $scope.current.selectedDeliveryMethods.findIndex(method) !== -1;
    };

    $scope.toggleCheck = function(key) {
        var method = $scope.current.allowedDeliveryMethods[key];
        var index = $scope.current.selectedDeliveryMethods.findIndex(method);
        var uaIndex = $scope.current.selectedDeliveryMethods.findIndex("Use Assigned");
        if(index === -1) {
            if(uaIndex >= 0) {
                $scope.current.selectedDeliveryMethods.remove("Use Assigned");
            }
            $scope.current.selectedDeliveryMethods.push(method);
        }
        else {
            $scope.current.selectedDeliveryMethods.remove(method);
        }
    };

    $scope.toggleOptions = function() {
        var index = $scope.current.selectedDeliveryMethods.findIndex("Use Assigned");

        if (index === -1) {
            $scope.current.selectedDeliveryMethods = [];
            $scope.current.selectedDeliveryMethods.push("Use Assigned");
        }
        else {
            $scope.current.selectedDeliveryMethods.remove("Use Assigned");
        }
    };

    $scope.sendTestEmail = function(){
        if ($scope.verbose.batch.emailFromInvalid) {
           $scope.openWarning('Invalid email address.').open();
           return;
        }

        if (!angular.equals(original.batch, verbose.batch)) {
            $dialog.confirmAction("Would you like to save changes before sending the test email?")
                .open()
                .then(function(rslt){
                    if (rslt === 'yes') {
                        return saveBatch()
                            .then(function(finish){
                                if (finish) {
                                    return getToEmailAddress();
                                }
                                else {
                                    return null;
                                }
                            });
                    } else {
                        return getToEmailAddress();
                    }
                })
                .then(sendEmail);
        } else {
            getToEmailAddress().then(sendEmail);
        }
    };

    $scope.createVideoStatement = function(){
        var dialogOpts = {
            templateUrl: "reporting/modals/newVideoStatement.html",
            controller: "NewVideoStatementCtrl",
            startDate: verbose.batch.startDate,
            endDate: verbose.batch.endDate
        };
        $dialog.dialog(dialogOpts)
            .open()
            .then(function(result){
                if (result) {
                    var videoStatementId;
                    $http.post('/Reporting/VideoStatements', result, {trackerMsg: 'Creating new video statement'})
                        .then(function(response){
                            videoStatementId = response.data.id;
                            return $http.get('/Reporting/VideoStatements', {trackerMsg: 'Loading video statements'});
                        })
                        .then(function (response) {
                            $scope.current.videoStatements = response.data;
                            verbose.batch.videoStatementId = videoStatementId;
                        });
                }
            });
    };

    $scope.filterBillInstances = function (filterText) {
        return $scope.current.billInstances.filter(function (billInst) {
            return billInst.name.toLowerCase().includes(filterText.toLowerCase());
        });
    };

    $scope.onSelect = function(item) {
        $scope.verbose.batch.billInstanceId = item.id;
    };
    //endregion

    // region BATCH INSERTS
    function loadBatchInserts() {
        if (verbose.inserts) {
            return;
        }

        if (args.isNew) {
            if (!verbose.batch) {
                var data = getNewReportBatchTemplate();
                expandVerbose("batch", data.batch);
                loadBaseData(data);
            }

            var inserts = [];
            formatInserts(inserts);
            expandVerbose("inserts", inserts);
            batchInsertData.loadInserts(inserts)
                .then(function(structuredInserts){
                    $scope.inserts = structuredInserts;
                    $scope.updateInserts();
                });
        }
        else {
            $http.get("/Reporting/Batch/Verbose/" + args.ids[0] + "?expand=inserts", {trackerMsg: 'Loading report batch inserts'})
                .then(function (response) {
                    loadBaseData(response.data);
                    formatInserts(response.data.inserts);
                    expandVerbose("inserts", response.data.inserts);
                    batchInsertData.loadInserts(response.data.inserts)
                        .then(function(structuredInserts){
                            $scope.inserts = structuredInserts;
                            $scope.updateInserts();
                        });
                });
        }
    }

    function formatInserts(inserts) {
        inserts.each(function(insert){
            if(insert.type === 'Blank Page (even only)') {
                insert.type = 'Blank Page';
                insert.evenOnly = true;
            }
            else {
                insert.evenOnly = false;
            }
        });
    }

    function undoInsertFormatting(inserts) {
        inserts.each(function(insert){
            if(insert.type === 'Blank Page' && insert.evenOnly) {
                insert.type = 'Blank Page (even only)';
            }
            delete insert.evenOnly;
        });
    }

    function saveInserts() {
        return batchInsertData.flattenInserts()
            .then(function(inserts){
                undoInsertFormatting(inserts);
                return $http.put('/Reporting/Batch/' + $scope.current.batchId + '/Inserts', inserts, {trackerMsg: 'Updating batch inserts'});
            })
            .then(function (response) {
                formatInserts(response.data);
                verbose["inserts"] = null;
                original["inserts"] = null;

                expandVerbose("inserts", response.data);

                batchInsertData.loadInserts(response.data)
                    .then(function(structuredInserts){
                        $scope.inserts = structuredInserts;
                        $scope.updateInserts();
                        $scope.current.insertExecuting = false;
                    });
                return true;
            });
    }

    $scope.updateInserts = function() {
        var selectedInserts = [];
        if(verbose.hasCoverPage) {
            selectedInserts = $scope.inserts.afterCoverPageBeforeReport.findAll({location: "Before cover page"});
            selectedInserts.each(function(insert){
                $scope.inserts.afterCoverPageBeforeReport.remove(insert);
                $scope.inserts.beforeCoverPage.add(insert);
            });
        }
        else {
            selectedInserts = $scope.inserts.beforeCoverPage;
            var index = 0;
            selectedInserts.each(function(insert){
                $scope.inserts.beforeCoverPage.remove(insert);
                $scope.inserts.afterCoverPageBeforeReport.add(insert, index);
                index++;
            });
        }
    };
    
    $scope.addNewInsert = function(insertType) {
        $scope.current.insertExecuting = true;
        var newInsertCount = 0;
        Object.keys(batchInsertData.inserts)
            .each(function (location) {
                newInsertCount += batchInsertData.inserts[location].count(function(n) { return n.name.has("New Insert"); });
                batchInsertData.inserts[location]
                    .each(function(n) {
                        if(n.name.has("New Insert")) {
                            var pos = n.name.lastIndexOf(")");
                            var insertCount = parseInt(n.name.substring(12, pos));
                            newInsertCount = insertCount >= newInsertCount ? insertCount + 1 : newInsertCount;
                        }
                    });
            });
        var initLocation = verbose.hasCoverPage ? "beforeCoverPage" : "afterCoverPageBeforeReport";
        var insert = {
            id: -1,
            name: "New Insert (" + newInsertCount + ")",
            type: insertType,
            location: (verbose.hasCoverPage ? "Before cover page" : "After cover page / Before report"),
            sequence: batchInsertData.inserts[initLocation].length
        };
        batchInsertData.inserts[initLocation].add(insert);
        verbose.inserts.add(insert);
        saveInserts();
    };

    $scope.removeInsert = function(insertId) {
        var insert, currentLocation;
        Object.keys(batchInsertData.inserts)
            .each(function (location) {
                if (batchInsertData.inserts[location].some({id: insertId})) {
                    insert = batchInsertData.inserts[location].find({id: insertId});
                    currentLocation = location;
                    return false;
                }
            });
        $dialog.confirmAction("Are you sure you want to remove this insert: \"" + insert.name + "\"?")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $scope.inserts[currentLocation].remove(insert);
                    verbose.inserts.remove(insert);
                    $scope.current.insertExecuting = true;
                    saveInserts();
                }
            });
    };

    $scope.upload = function(insertId) {
        saveInserts()
            .then(function (rslt){
                if(rslt === true) {
                    $dialog.inputBox("Upload Insert", "Insert Upload", "file", {postUrl: "/Reporting/Batch/" + $scope.current.batchId + "/Inserts/" + insertId + "/Action/Upload"})
                        .open()
                        .then(function (files) {
                            if (!files) {
                                return;
                            }
                            var originalInsert = original.inserts.find({id: insertId});
                            var insert;
                            Object.keys(batchInsertData.inserts)
                                .each(function (location) {
                                    if (batchInsertData.inserts[location].some({id: insertId})) {
                                        insert = batchInsertData.inserts[location].find({id: insertId});
                                        return false;
                                    }
                                });
                            insert.name = originalInsert.name = files.name;
                            insert.hasFile = originalInsert.hasFile = files.hasFile;
                            insert.entityCount = originalInsert.entityCount = files.entityCount;
                            insert.warningMessage = originalInsert.warningMessage = files.warningMessage;
                        });
                }
            });
    };

    $scope.download = function(insertId) {
        $window.location.href = API_CONFIG.baseUrl + '/Reporting/Batch/' + $scope.current.batchId + '/Inserts/' + insertId + '/Download?Authorization=' + sessionStorage.oas_token;
    };

    $scope.openWarning = function(insert) {
        $dialog.messageBox("Insert Warning","<pre>" + insert.warningMessage + "</pre>").open();
    };

    //endregion

    //endregion

    //region PUBLIC METHODS

    //region LOAD/CLOSE
    $scope.loadTab = function (menuItem) {
        $scope.current.selectedTab = menuItem;
        menuItem.load.forEach(function (fn) {fn();});
    };
    
    $scope.canSave = function() {
        if (!$scope.rightsReportBatch.canUpdate) {
            return false;
        }
        
        if (angular.equals(original.batch, verbose.batch) && angular.equals(original.inserts, verbose.inserts)) {
            return false;
        }
        
        return true;
    };

    $scope.save = function () {
        if ($scope.verbose.batch.emailFromInvalid) {
            $dialog.actionFailed('Email is invalid.').open();
            return;
        }

        if (angular.equals(original.batch, verbose.batch) && angular.equals(original.inserts, verbose.inserts)) {
            editorHotKeys.destroy();
            dialog.close({isSaved: isSaved, batch: original.batch});
            return;
        }

        saveBatch()
            .then(function(finish){
                if (!finish) {
                    return;
                }
                editorHotKeys.destroy();
                dialog.close({isSaved: isSaved, batch: original.batch, reportName: original.reportName});
            });
    };

    $scope.close = function (validate) {
        if (validate && !angular.equals(original, verbose)) {
            $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true});
        } else {
            editorHotKeys.destroy();
            dialog.close({isSaved: isSaved, batch: original.batch});
        }
    };

    $scope.delete = function() {
        $dialog.confirmAction("Are you sure you want to delete this batch?  <span class='text-error'>All reports will also be deleted!</span>")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $http.delete('/Reporting/Batch/Verbose/' + $scope.current.batchId, {trackerMsg: 'Deleting batch'})
                        .then(function () {
                            editorHotKeys.destroy();
                            dialog.close("delete");
                        });
                }
            });
    };
    //endregion

    //endregion

    //region INITIALIZE
    $scope.verbose = verbose;
    $scope.inserts = {};

    $scope.current = {
        batchId: 0,
        report: null,
        dataquery: null,
        rep: null,
        qpeItems: [],
        videoStatements: [],
        dynamicGroups: [],
        billInstances: [],
        allowedEntities: ["Household", "Registration", "Account"],
        allowedEntitySelectionMethods: ["All", "Active", "Active with Value", "Dynamic Group", "Data Query", "Bill Instance", "Import IDs"],
        allowedDeliveryMethods: ["Mail", "Email", "Website"],
        selectedDeliveryMethods: [],
        sortOptions: {
            connectWith: ".insert-container",
            scroll: false,
            helper: 'clone',
            stop: batchInsertData.updateInserts,
            items: "div.insert-item"
        },
        isFullPage: false,
        insertExecuting: false,
        isRep: ["Representative"].any($scope.user.authorization.entity),
        billInstanceSelectionName: null,
        additionalItems: [{id: "FEE", name: "Advisory Fee Notification"}]
    };
    $scope.reportEntities = ["Household", "Registration", "Account", "Portfolio Group"];
    $scope.selectionMethods = ["Active with Value", "Active", "All", "Dynamic Group", "Data Query", "Bill Instance", "Import IDs"];

    if (args.ids !== null) {
        $scope.current.batchId = args.ids.length >= 1 && !args.isCopy ? parseInt(args.ids[0]) : 0;
    }

    if (args.isFullPage) {
        $scope.current.isFullPage = args.isFullPage;
    }

    $scope.errors = [];

    init();
    //endregion

    //region WATCHES
    $scope.$watch("current.report", function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }

        if (angular.isObject(newValue)) {
            if(newValue.id === "FEE") { //This allows for the handling of the new Advisory Fee Notification report from OpEx - Billing
                verbose.batch.reportId = null;
                verbose.batch.isAdvisoryFee = true; //This is only for the new Advisory Fee Notification report
                verbose.hasCoverPage = false;
                $scope.current.allowed = [{
                    entity: "Household",
                    selectionMethods: [
                        "Bill Instance"
                    ]
                }];
                $scope.current.allowedEntities = ["Household"];
                $scope.current.allowedEntitySelectionMethods = ["Bill Instance"];
                verbose.batch.entitySelectionMethod = "Bill Instance";
                if ($scope.rightsBillGenerator.canRead || $scope.rightsBillingAudit.canRead) {
                    loadBillInstances();
                }
            }
            else {
                verbose.batch.reportId = newValue.id;
                verbose.batch.isAdvisoryFee = false; //This is only for the new Advisory Fee Notification report
                $http.get('/Reporting/Batch/Reports/' + verbose.batch.reportId, { trackerMsg: 'Loading report information' })
                    .then(function(response) {
                        if (response.data) {
                            verbose.hasCoverPage = response.data.hasCoverPage;
                            $scope.current.allowed = response.data.allowed;
                            $scope.current.allowedEntities = response.data.allowed.map(function(a) {
                                return a['entity'];
                            });
                            if (!$scope.current.allowedEntities.some(verbose.batch.entity)) {
                                verbose.batch.entity = $scope.current.allowedEntities[0];
                            }
                            if (!$scope.current.allowedEntitySelectionMethods.some(verbose.batch.entitySelectionMethod)) {
                                verbose.batch.entitySelectionMethod = $scope.current.allowedEntitySelectionMethods[0];
                            }

                            var entity;
                            var methods = [];

                            $scope.reportEntities.forEach(function(e) {
                                $scope.current.allowed.forEach(function(a) {
                                    if (typeof entity === "undefined" && a.entity === e.entity) {
                                        entity = a.entity;
                                        methods = a.selectionMethods;
                                    }
                                });
                            });

                            if (typeof entity !== "undefined") {
                                $scope.content.batch.entity = entity;
                            }
                            if (methods !== undefined && methods.length > 0) {
                                $scope.current.allowedEntitySelectionMethods = methods;
                            }

                            if ($scope.current.isRep) {
                                $scope.current.allowedEntitySelectionMethods = $scope.current.allowedEntitySelectionMethods.filter(x => x !== "Dynamic Group");
                            }

                            if (!$scope.current.allowedEntitySelectionMethods.some(verbose.batch.entitySelectionMethod)) {
                                if ($scope.current.allowedEntitySelectionMethods.some("Active with Value")) {
                                    verbose.batch.entitySelectionMethod = "Active with Value";
                                } else if ($scope.current.allowedEntitySelectionMethods.some("Active")) {
                                    verbose.batch.entitySelectionMethod = "Active";
                                } else if ($scope.current.allowedEntitySelectionMethods.some("All")) {
                                    verbose.batch.entitySelectionMethod = "All";
                                } else if ($scope.current.allowedEntitySelectionMethods.some("Dynamic Group")) {
                                    verbose.batch.entitySelectionMethod = "Dynamic Group";
                                } else if ($scope.current.allowedEntitySelectionMethods.some("Data Query")) {
                                    verbose.batch.entitySelectionMethod = "Data Query";
                                } else if ($scope.current.allowedEntitySelectionMethods.some("Bill Instance")) {
                                    verbose.batch.entitySelectionMethod = "Bill Instance";
                                } else if ($scope.current.allowedEntitySelectionMethods.some("Import IDs")) {
                                    verbose.batch.entitySelectionMethod = "Import IDs";
                                }
                            }
                        } else {
                            verbose.hasCoverPage = false;
                        }
                    });
            }
        }
        else {
            verbose.batch.reportId = null;
            verbose.batch.isAdvisoryFee = false; //This is only for the new Advisory Fee Notification report
        }
    });

    $scope.$watch("current.dataquery", function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }

        if (angular.isObject(newValue)) {
            verbose.batch.customReportId = newValue.id;
            $scope.loadPrompts(newValue.id);
        }
        else {
            verbose.batch.customReportId = null;
            verbose.batch.customReport = null;
        }
    });

    $scope.$watch("current.rep", function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }

        if (angular.isObject(newValue)) {
            verbose.batch.representativeId = newValue.id;
        }
        else {
            verbose.batch.representativeId = null;
        }
    });

    $scope.$watch("current.selectedDeliveryMethods", function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }

        verbose.batch.statementDeliveryMethod = newValue.join(', ');
    }, true);

    $scope.$watch("verbose.batch.entitySelectionMethod", function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }

        if (['All','Active','Active with Value'].some(newValue)) {
            $scope.current.rep = null;
        }
        if (newValue !== 'Dynamic Group') {
            verbose.batch.dynamicGroupingId = null;
        }
        if (newValue !== 'Data Query') {
            $scope.current.dataquery = null;
        }
        if (newValue !== 'Bill Instance') {
            verbose.batch.billInstanceId = null;
            verbose.batch.includeAllBills = false;
        }
    });

    $scope.$watch("current.startDate", function(newValue, oldValue){
        if (!newValue && verbose.batch) {
            verbose.batch.startDate = newValue;
            return;
        }

        if (newValue === oldValue) {
            return;
        }

        verbose.batch.startDate = Date.create(newValue).formatted(false);
    });
    $scope.$watch("current.endDate", function(newValue, oldValue){
        if (!newValue && verbose.batch) {
            verbose.batch.endDate = newValue;
            return;
        }

        if (newValue === oldValue) {
            return;
        }

        verbose.batch.endDate = Date.create(newValue).formatted(false);
    });
    //endregion
});
'use strict';

app.controller('DataQueryEditCtrl', function DataQueryEditCtrl($scope, $http, $oasRights, $location, $window, $dialog, $timeout, dialog, args, splitIoService, civ2Service, $q) {
    //region PRIVATE VARIABLES
    var verbose = {}, original = {}, isSaved = false, editorHotKeys;

    //endregion

    //region PRIVATE METHODS

    //region INIT/RIGHT/MENU/TABS
    function init() {
        if (!$oasRights.canRead("DATAQUERY_ADMIN")) return;

        loadRights();

        loadCustomImportTypes().then(() => {
            buildMenu();
            setMenu();
        });  
        
        loadHotKeys();        
    }

    function setMenu() {
        $scope.menu.each(function (category) {
            var menuItem = category.items.find({code: args.defaultTab.code});
            if (menuItem) {
                $scope.loadTab(menuItem);
                return false;
            }
        });
    }

    function loadRights() {
        $scope.rightsDataQueryAdmin = $oasRights.forCode("DATAQUERY_ADMIN");
        $scope.rightsDataQueryToCustomImports = $oasRights.forCode('DATAQUERYTOCUSTOMIMPORTADMIN');
    }

    function buildMenu() {
        var isAdminOrRIA = ["Administrator", "Advisor"].any($scope.user.authorization.entity);

        var menu = [
            {name: "Data Query", enabled: true, items: [
                {name: 'General', code: 'dataQueryGeneral', enabled: true, load: [loadLookups]},
                {name: 'SQL Text', code: 'dataQuerySql', enabled: true, load: [loadPrompts]}
            ]}
        ];

        $scope.menu = menu;
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: function () {
                        if($scope.rightsDataQueryAdmin.canUpdate || $scope.rightsDataQueryAdmin.canAdd)
                            $scope.save();
                    }
                },
                { combo:'ALT+X', command: function () {
                        $scope.close(true);
                    }
                }
            ]);
        });
    }

    function loadLookups() {
        $http.get("/Authorization/Databases", {cache: true, trackerMsg: 'Loading databases', ignoreExceptions: true})
            .then(function (response) {
                $scope.current.databases = response.data;
                loadDataQuery();
            });
    }

    function loadCustomImportTypes() {
        if ($scope.rightsDataQueryToCustomImports.canUpdate || $scope.rightsDataQueryToCustomImports.canAdd) { 
            let promises = [];
            
            promises.push(civ2Service.getAllImportTypes().then(function(res) {
                $scope.current.customImportTypes = res.data;
            }));

            return $q.all(promises);
        }

        return $q.resolve({});
    }

    function expandVerbose(propertyName, data) {
        verbose[propertyName] = data;
        original[propertyName] = angular.copy(data);
    }
    //endregion

    // region LOAD DATA QUERY
    function loadDataQuery() {
        if (verbose.report) return;

        if (args.isNew && !args.isCopy) {
            var data = getNewDataQueryTemplate();
            expandVerbose("report", data.report);
            expandVerbose("id", data.id);
        } else {
            var url = "/Reporting/Custom/Verbose/" + args.id + "?expand=report" + (args.isCopy ? "&expand=prompts" : "");
            $http.get(url, {trackerMsg: 'Loading data query'})
             .then(function (response) {
                 expandVerbose("report", response.data.report);
                 expandVerbose("id", response.data.id);
                 if(response.data.prompts)
                     expandVerbose("prompts", response.data.prompts);

                 if(args.isCopy) {
                     verbose.id = 0;
                     verbose.report.id = 0;
                     verbose.report.title += "  - (Copy)";
                     verbose.report.alClients.forEach(function(a){
                         a.id = 0;
                         a.customReportId = 0;
                     });

                     if ($scope.rightsDataQueryToCustomImports.canUpdate || $scope.rightsDataQueryToCustomImports.canAdd) {
                        if (verbose.report.importTypes && verbose.report.importTypes.length > 0) {
                            verbose.report.importTypes.forEach((i) => {
                                i.customReportId = 0
                            });
                        }
                     }
                 }

                 if(verbose.report.alClients.length > 0) {
                     $scope.current.allDatabases = '0';
                     $scope.current.dbCollection = verbose.report.alClients.map(function(n){
                         return $scope.current.databases.find({id: n.alClientId});
                     });
                 } else {
                     $scope.current.allDatabases = '1';
                     $scope.current.dbCollection = [];
                 }

                 setCustomImportTypeCollections();
             });
        }
    }

    function getNewDataQueryTemplate(){
        return {
            id: 0,
            report : {
                id: 0,
                //alClientId: null,
                title: '',
                reportDescription: '',
                category: '',
                sqlText: '',
                isLandscape: false,
                reportClass: null,
                isInternal: true,
                guid: '',
                promptClass: null,
                reportType: 'Query',
                userOwnerId: null,
                entity: null,
                alClients: [],
                importTypes: [],
                /*createdDate: null,
                createdBy: null,
                editedDate: null,
                editedBy: null*/
                isReadOnly: true,
            },
            prompts: null
        };
    }

    function getDateFromString (dateInfo){
        var returnDate;
        var isDate = angular.isDate(dateInfo);
        if(!isDate && dateInfo.length > 0) {
            if(dateInfo.toLocaleUpperCase().includes("NOW")
                || dateInfo.toLocaleUpperCase( ).includes("ENDYTD")
                || dateInfo.toLocaleUpperCase( ).includes("ENDQTD") ) {
                returnDate = Date.create();
            } else if( dateInfo.toLocaleUpperCase( ).includes("LBD") ) {
                switch (Date.create().getDay()) {
                    case 1: //Monday
                        returnDate = Date.create().addDays(-3);
                        break;
                    case 0: //Sunday
                        returnDate = Date.create().addDays(-2);
                        break;
                    default:
                        returnDate = Date.create().addDays(-1);
                        break;
                }
            } else if( dateInfo.toLocaleUpperCase( ).includes("STARTYTD") ) {
                returnDate = Date.create("the beginning of this year");
            } else if( dateInfo.toLocaleUpperCase( ).includes("STARTQTD") ) {
                var intQtr = parseInt(Date.create().getMonth()/3) + 1;
                returnDate = Date.create({year: Date.create().getFullYear(), month: (3 * (intQtr - 1)), day: 1});
            } else if( dateInfo.toLocaleUpperCase( ).includes("STARTLQ") ) {
                var intQtr = parseInt(Date.create().getMonth()/3);
                intQtr = (intQtr > 0) ? intQtr : 4;
                returnDate = Date.create({year: Date.create().addMonths(-3).getFullYear(), month: ( 3 * (intQtr - 1)), day: 1});
            } else if( dateInfo.toLocaleUpperCase( ).includes("ENDLQ") ) {
                var intQtr = parseInt(Date.create().getMonth()/3);
                intQtr = (intQtr > 0) ? intQtr : 4;
                returnDate = Date.create({year: Date.create().addMonths(-3).getFullYear(), month: (3 * intQtr - 1), day: Date.create({year: Date.create().addMonths(-4).getFullYear(), month: (3 * intQtr - 1)}).daysInMonth()});
            } else if( dateInfo.toLocaleUpperCase( ).includes("STARTLM") ) {
                returnDate = Date.create("the beginning of last month");
            } else if( dateInfo.toLocaleUpperCase( ).includes("ENDLM") ) {
                returnDate = Date.create("the end of last month");
            } else if( dateInfo.toLocaleUpperCase( ).includes("STARTLY") ) {
                returnDate = Date.create("the beginning of last year");
            } else if( dateInfo.toLocaleUpperCase( ).includes("ENDLY") ) {
                returnDate = Date.create("the end of last year");
            } else {
                return Date.create('1/1/0001');
            }

            // Add or subtract days (int) from the calculated date
            if(dateInfo.includes("+")) {
                var x = dateInfo.indexOf("+");
                var intAdd = parseInt(dateInfo.from(x + 1));
                if(intAdd != NaN) {
                    returnDate = returnDate.addDays(intAdd);
                    if( returnDate > Date.create() )
                        returnDate = Date.create();
                }
            } else if(dateInfo.includes("-")) {
                var x = dateInfo.indexOf("-");
                var intSub = parseInt(dateInfo.from(x + 1));
                if(intSub != NaN)
                    returnDate = returnDate.addDays( -intSub );
            }
        } else if( !isDate ) {
            returnDate = Date.create();
        }
        return returnDate;
    }

    function openPromptScreen(prompt) {
        var dialogOpts = {
            templateUrl: "prompt-editor.html",
            controller: "PromptEditorCtrl",
            prompt: angular.copy(prompt)
        };
        return $dialog.dialog(dialogOpts).open();
    }

    $scope.addPrompt = function(){
        openPromptScreen()
            .then(function(result){
                if(result)
                    verbose.prompts.add(result);
            });
    };

    $scope.editPrompt = function(prompt){
        openPromptScreen(prompt)
            .then(function(result){
                if(result)
                    angular.extend(prompt, result);
            });
    };

    $scope.removePrompt = function(prompt){
        $dialog.confirmAction("Are you sure you want to remove the prompt \"" + prompt.prompt + " (" + prompt.code + ")\"?")
            .open()
            .then(function(result){
                if(result === 'yes')
                    verbose.prompts.remove(prompt);
            });
    };

    $scope.copyPrompt = function(prompt){
        var copy = angular.copy(prompt);
        copy.id = 0;
        openPromptScreen(copy)
            .then(function(result){
                if(result)
                    verbose.prompts.add(result);
            });
    };

    $scope.movePrompt = function (prompt, indexChange) {
        var index = verbose.prompts.indexOf(prompt),
            newPos = index + indexChange;

        verbose.prompts.splice(index, 1);
        verbose.prompts.splice(newPos, 0, prompt);
        verbose.prompts.forEach(function (n, i) {
            n.sortOrder = i + 1;
        });
    };

    $scope.addDbToCollection = function() {
        if ($scope.current.dbCollection.none({id: $scope.current.selectedDatabase.id})) {
            $scope.current.dbCollection.push($scope.current.selectedDatabase);
            if (original.report.alClients.none({alClientId: $scope.current.selectedDatabase.id}))
                verbose.report.alClients.push({id: 0, customReportId: args.isCopy ? 0 : verbose.report.id, alClientId: $scope.current.selectedDatabase.id, reportDescription: verbose.report.reportDescription});
            else {
                var alClient = angular.copy(original.report.alClients.find({alClientId: $scope.current.selectedDatabase.id}));
                if(args.isCopy) {
                    alClient.id = 0;
                    alClient.customReportId = 0;
                }
                verbose.report.alClients.push(alClient);
            }
        }
        $scope.current.selectedDatabase = null;
    };
    
    $scope.removeDbFromCollection = function(db) {
        $scope.current.dbCollection.remove(db);
        if(db)
            verbose.report.alClients.remove({alClientId: db.id});
    };

    $scope.addCustomImportTypeToCollection = function() {
        var importCollection = $scope.current.customImportCollection;
        var selectedImportType = $scope.current.selectedCustomImportType;

        if (importCollection.none({id: selectedImportType.id})) {
            selectedImportType.isInternalOnly = true;
            importCollection.push(selectedImportType);
            if (original.report.importTypes.none({importTypeId: selectedImportType.id})) {
                verbose.report.importTypes.push({customReportId: args.isCopy ? 0 : verbose.report.id, importTypeId: selectedImportType.id, isInternalOnly: true});
            } else {
                var importType = angular.copy(original.report.importTypes.find({importTypeId: selectedImportType.id}));
                if (args.isCopy) {
                    importType.customReportId = 0;
                }
                importType.isInternalOnly = true;
                verbose.report.importTypes.push(importType);
            }
        }

        $scope.current.selectedCustomImportType = null;
    };

    $scope.setImportIsInternalOnly = function(importTypeId, isInternalOnly) {
        let importType = verbose.report.importTypes.find({importTypeId: importTypeId});
        importType.isInternalOnly = isInternalOnly;
    }

    $scope.removeCustomImportTypeFromCollection = function(cic) {
        $scope.current.customImportCollection.remove(cic);            
        
        if (cic) {
            verbose.report.importTypes.remove({importTypeId: cic.id});
        }
    };

    //endregion

    //region LOAD PROMPTS
    function loadPrompts() {
        if (verbose.prompts) return;

        if (args.isNew && !args.isCopy) {
            var data = getNewDataQueryTemplate();
            data.prompts = [];
            if (!verbose.report) {
                expandVerbose("report", data.report);
                expandVerbose("id", data.id);
            }
            expandVerbose("prompts", data.prompts);
        } else {
            $http.get("/Reporting/Custom/Verbose/" + args.id + "?expand=report&expand=prompts", {trackerMsg: 'Loading prompt data'})
                .then(function (response) {
                    if (!verbose.report) {
                        expandVerbose("report", response.data.report);
                        expandVerbose("id", response.data.id);
                        if(args.isCopy) {
                            verbose.id = 0;
                            verbose.report.id = 0;
                            verbose.report.title += "  - (Copy)";
                            verbose.report.alClients.forEach(function(a){
                                a.id = 0;
                                a.customReportId = 0;
                            });

                            if ($scope.rightsDataQueryToCustomImports.canUpdate || $scope.rightsDataQueryToCustomImports.canAdd) {
                                if (verbose.report.importTypes && verbose.report.importTypes.length > 0) {
                                    verbose.report.importTypes.forEach((i) => {
                                        i.customReportId = 0
                                    });
                                }
                             }
                        }

                        if(verbose.report.alClients.length > 0) {
                            $scope.current.allDatabases = '0';
                            $scope.current.dbCollection = verbose.report.alClients.map(function(n){
                                return $scope.current.databases.find({id: n.alClientId});
                            });
                        } else {
                            $scope.current.allDatabases = '1';
                            $scope.current.dbCollection = [];
                        }

                        setCustomImportTypeCollections();
                    }
                    expandVerbose("prompts", response.data.prompts);

                    if(args.isCopy && verbose.prompts.length > 0) {
                        verbose.prompts.forEach(function(p){
                            p.id = 0;
                        });
                    }
                });
        }
    }

    function setCustomImportTypeCollections() {
        if ($scope.rightsDataQueryToCustomImports.canRead) {
            if (verbose.report.importTypes && verbose.report.importTypes.length > 0) {
                $scope.current.customImportCollection = verbose.report.importTypes.map((i) => {
                    let importType = $scope.current.customImportTypes.find({id: i.importTypeId});
                    importType.isInternalOnly = i.isInternalOnly;
                    return importType;
                });
            }
            else {
                verbose.report.importTypes = [];
            }
         }
    }
    //endregion

    //endregion

    //region PUBLIC METHODS

    //region LOAD/CLOSE
    $scope.loadTab = function (menuItem) {
        $scope.current.selectedTab = menuItem;
        menuItem.load.forEach(function (fn) {fn();});
    };
    
    $scope.canSave = function() {
        if (!$scope.rightsDataQueryAdmin.canUpdate)
            return false;
        
        if (angular.equals(original.report, verbose.report))
            return false;
        
        return true;
    };

    $scope.test = function (data) {
        var dataQuery = angular.copy(verbose);
        dataQuery.prompts.each(function(prompt){
            if(prompt.promptType === 'Date')
                prompt.defaultValue = getDateFromString(prompt.defaultValue);
        });

        var dialogOpts = {
            templateUrl: "query-tester.html",
            controller: "QueryTesterCtrl",
            dataQuery: dataQuery
        };
        $dialog.dialog(dialogOpts).open()
            .then(function(rslt){
                if(rslt) {
                    //$window.open('#/reports/dataqueries/-1', '_blank');
                }
            });
    };

    $scope.save = function () {
        if (angular.equals(original.report, verbose.report) && angular.equals(original.prompts, verbose.prompts) && (original.prompts && original.prompts.every(function(p){ return (p.sortOrder && p.sortOrder > 0); }))) {
            editorHotKeys.destroy();
            dialog.close({isSaved: isSaved});
            return;
        }

        var content = verbose;
        if(content.prompts) {
            content.prompts.forEach(function (n, i) {
                n.sortOrder = i + 1;
            });
        }
        if($scope.current.customReportId === 0) {
            content.report.alClients.forEach(function (n){
                n.reportDescription = content.report.reportDescription;
            });
        }
        var save = $scope.current.customReportId > 0 ? {method: "PUT", id: $scope.current.customReportId, trackerMsg: "Saving data query"} : {method: "POST", id: "", trackerMsg: "Adding new data query"};
        $http({method: save.method, url: '/Reporting/Custom/Verbose/' + save.id, data: content, trackerMsg: save.trackerMsg})
            .then(function(response){
                isSaved = true;
                $scope.current.customReportId = response.data.report.id;
                verbose = {};
                original = {};
                $scope.verbose = verbose;

                expandVerbose("id", response.data.id);
                expandVerbose("report", response.data.report);
                expandVerbose("prompts", response.data.prompts);

                editorHotKeys.destroy();
                dialog.close({isSaved: isSaved});
            });
    };

    $scope.close = function (validate) {
        if (validate && !angular.equals(original, verbose)) {
            $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true});
        } else {
            editorHotKeys.destroy();
            dialog.close({isSaved: isSaved});
        }
    };

    $scope.delete = function() {
        $dialog.confirmAction("Are you sure you want to delete this data query?")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $http.delete('/Reporting/Custom/Verbose/' + $scope.current.customReportId, {trackerMsg: 'Deleting data query'})
                        .then(function () {
                            editorHotKeys.destroy();
                            dialog.close("delete");
                        });
                }
            });
    };
    //endregion

    //endregion

    //region INITIALIZE
    $scope.verbose = verbose;
    $scope.inserts = {};

    $scope.current = {
        customReportId: 0,
        databases: [],
        selectedDatabase: null,
        dbCollection: [],
        allDatabases: '1',
        reportType: { queryValue: false, scrubValue: false, customImportValue: false },
        isFullPage: false,
        insertExecuting: false,
        customImportTypes: [], 
        selectedCustomImportType: null,
        customImportCollection: [],
    };

    if (args.id != null) {
        $scope.current.customReportId = !args.isCopy ? parseInt(args.id) : 0;
    }

    if (args.isFullPage) {
        $scope.current.isFullPage = args.isFullPage;
    }

    $scope.errors = [];

    init();
    //endregion

    //region WATCHES
    $scope.$watch("current.reportType", function (newValue, oldValue) {
        if (newValue === oldValue) return;

        verbose.report.reportType = (newValue.queryValue ? 1 : 0) + (newValue.scrubValue ? 4 : 0) + (newValue.customImportValue ? 2 : 0);
    }, true);

    $scope.$watch("current.allDatabases", function (newValue, oldValue) {
        if(newValue === oldValue) return;

        if (newValue === "1")
            verbose.report.alClients = [];
        else {
            $scope.current.dbCollection.each(function(db){
                if (db && verbose.report.alClients.none({alClientId: db.id})) {
                    if (original.report.alClients.none({alClientId: db.id}))
                        verbose.report.alClients.push({id: 0, customReportId: verbose.report.id, alClientId: db.id, reportDescription: verbose.report.reportDescription});
                    else
                        verbose.report.alClients.push(angular.copy(original.report.alClients.find({alClientId: db.id})));
                }
            });
        }
    });
    //endregion
});

app.controller('PromptEditorCtrl', function PromptEditorCtrl($scope, $http, dialog) {
    //PRIVATE METHODS
    function init() {
        if(dialog.options.prompt)
            $scope.query = dialog.options.prompt;
    }

    //PUBLIC METHODS
    $scope.submit = function() {
        dialog.close($scope.query);
    };

    $scope.cancel = function() {
        dialog.close(null);
    };

    //INITIALIZE
    $scope.query = { id: 0, code: '', prompt: '', promptDescription: '', promptType: 'Text', defaultValue: '', isPromptUser: true };
    $scope.promptTypes = ["Text","Numeric","Date","Dynamic Group"];
    init();
});

app.controller('QueryTesterCtrl', function QueryTesterCtrl($scope, $http, $window, $dialog, dialog, $dataQuery) {
    //PRIVATE METHODS
    function init() {
        getAlClients();
        if(dialog.options.dataQuery) {
            $scope.dataQuery = dialog.options.dataQuery;
        }
    }

    function getAlClients() {
        $http.get('/Authorization/User/Databases?isActive=true&filterForMasterGroup=true', {trackerMsg: 'Loading database list'})
            .then(function (response) {
                $scope.alClients.list = response.data.sortBy('clientName');
            });
    }

    //PUBLIC METHODS
    $scope.run = function() {
        //set the databaseIdList to the selected database Id's
        var idList = [];
        $scope.alClients.selected.forEach( function ( setIds ) {
            idList.push(setIds.id);
        });
        $scope.dataQuery.databaseIdList = idList;
        $scope.dataQuery.prompts.forEach(function (prompt) {
            if (prompt.promptType === "Date") {
                prompt.defaultValue = Date.create(prompt.defaultValue).formatted();
            }
        });
        $http.post('/Reporting/Custom/Verbose/Test', $scope.dataQuery, {trackerMsg: 'Running data query test'})
            .then(function (response) {
                /*$http.post('/Reporting/Custom/' + $scope.dataQuery.id + '/Generate/SlickGrid', $scope.dataQuery, {trackerMsg: 'Loading data query'})
                    .then(function (response) {
                        dialog.close({id: $scope.dataQuery.id, title: $scope.dataQuery.title, prompts: $scope.dataQuery.prompts, entity: $scope.dataQuery.entity, views: [response.data], filterMethod: $scope.current.gridFilterMethod});
                    });*/
                $dataQuery.setDataQuery({id: -1, title: $scope.dataQuery.report.title, prompts: $scope.dataQuery.report.prompts, entity: $scope.dataQuery.entity, views: [response.data]});
                var dialogOpts = {
                    templateUrl: "dataquery-test-screen.html",
                    controller: "DataQueryTestScreenCtrl",
                    dialogClass: "modal wide"
                };
                $dialog.dialog(dialogOpts).open();
                dialog.close(null);
            });
    };

    $scope.cancel = function() {
        dialog.close(null);
    };

    //INITIALIZE
    $scope.runForOptions = [{name: "Current", code: "current"}, {name: "Multiple", code: "multiple"}];
    $scope.dataQuery = {report: {title: '', reportDescription: '', sqlText: ''}, prompts: []};
    $scope.alClients = {list: [], selected: [] };
    $scope.current = {selectedRunFor: "current"};
    init();
});

app.controller('DataQueryTestScreenCtrl', function DataQueryTestScreenCtrl($scope, $http, dialog, $timeout, $dataQuery) {
    //PRIVATE VARIABLES
    var config = $dataQuery.getDataQuery(-1);

    //PRIVATE METHODS
    function init( ) {
        if(config.views){
            $scope.current.view = config.views[0];
            $scope.current.dataQueryCacheKey = config.views[0].dataQueryCacheKey;
            $scope.current.dataQueryId = -1;
            $scope.current.url = '/Reporting/Custom/-1/Generate/SlickGrid/' + $scope.current.dataQueryCacheKey;
            $scope.current.dataQueryTitle = config.title

            $timeout(function() {resizeGridHeight();});
        }
    }

    function resizeGridHeight( ) {
        $scope.$broadcast('event:dataquery-export-action', {action: 'set-height'});
    }

    //PUBLIC METHODS
    $scope.exportToExcel = function() {
        $scope.$broadcast('event:dataquery-export-action', {action: 'export-data'});
    };

    $scope.close = function() {
        dialog.close(null);
    };

    // INITIALIZE
    $scope.current = { url: '', view: null , dataQueryCacheKey: null, dataQueryId: 0, dataQueryTitle: '', dataQueryEntity: config.entity };

    $scope.rightsDataQueryToCustomImports = false;

    init();
    $scope.views = config.views;
});
'use strict';

app.controller('ReportAccessEditCtrl', function ReportAccessEditCtrl($scope, $http, $q, $timeout, $dialog, $oasRights, args, dialog, reportAccessEditCtrlHelper) {
    // PRIVATE VARIABLES
    const verbose = {};
    const original = {};
    let editorHotKeys;


    // PRIVATE METHODS
    function init() {
        buildMenu();

        let selectedMenuItem;

        $scope.menu.each(function(category) {
            selectedMenuItem = category.items.find({ code: args.defaultTab.code });
            if (selectedMenuItem) {
                return false;
            }
        });

        $scope.loadTab(selectedMenuItem || $scope.menu.first().items.first());

        loadHotKeys();
    }

    function buildMenu() {
        const callbacks = {
            reportLoginAccess: [loadReportAccess, loadLoginAccessDefaults],
            reportDatabaseGroupAccess: [
                loadReportAccess,
                loadDatabaseGroupAccessDefaults,
            ],
            reportDatabaseAccess: [
                loadReportAccess,
                loadDatabaseAccessDefaults,
            ],
            reportRoleAccess: [loadReportAccess, loadRoleAccessDefaults],
            reportUserAccess: [loadReportAccess, loadUserAccessDefaults],
            reportRepresentativeAccess: [
                loadReportAccess,
                loadRepresentativeAccessDefaults,
            ],
            reportRepresentativeClientAccess: [
                loadReportAccess,
                loadRepresentativesClientsAccessDefaults,
            ],
            reportClientAccess: [
                loadReportAccess,
                loadClientAccessDefaults,
            ],
            reportBrokerDealersRepresentativeAccess: [
                loadReportAccess,
                loadBrokerDealersRepresentativesAccessDefaults,
            ],
        };

        const canAccessRules = angular.isDefined(args.canAccessRules) ? args.canAccessRules : $oasRights.canRead('REPORTBUILDERADVANCEDEDITOR');

        $scope.menu = reportAccessEditCtrlHelper.buildMenu(
            $scope.user.authorization,
            args.accessLevels,
            canAccessRules,
            callbacks
        );
    }

    function loadHotKeys() {
        editorHotKeys = new window.HotKeys();

        $timeout(function() {
            editorHotKeys.addActions([
                { combo: 'ALT+S', command: $scope.save },
                {
                    combo: 'ALT+X', command: function() {
                        $scope.close(true);
                    },
                },
            ]);
        });
    }

    function expandVerbose(propertyName, data) {
        verbose[propertyName] = data;
        original[propertyName] = angular.copy(data);
    }

    function loadReportAccess() {
        if (verbose.accessLevels) {
            return;
        }

        expandVerbose('accessLevels', args.accessLevels);
    }

    function loadLoginAccessDefaults() {
        $scope.loginAccess = {loginEntityId: null, canRun: false};
    }

    function loadDatabaseGroupAccessDefaults() {
        $scope.databaseGroupAccess = {name: '', databaseGroupId: null, loginEntityId: null, canRun: false, canEdit: null};
        $scope.databaseGroups.selected = null;

        if (!$scope.databaseGroups.list) {
            $http.get('/Utility/DatabaseGroups/Simple?isPrivate=false', { cache: true, trackerMsg: 'Loading database groups', ignoreExceptions: true })
                .then(function(response) {
                    $scope.databaseGroups.list = response.data;
                });
        }
    }

    function loadDatabaseAccessDefaults() {
        $scope.databaseAccess = {name: $scope.user.authorization.alClientName, alClientId: $scope.user.authorization.alClientId, loginEntityId: null, canRun: false, canEdit: null};
        $scope.databases.selected = null;
    }

    function loadRoleAccessDefaults() {
        $scope.roleAccess = {name: '', roleId: null, canRun: null, canEdit: null, canDelete: null};
        $scope.roles.selected = null;

        if (!$scope.roles.list) {
            const rolesToExclude = [5 /* Default Client*/];
            const includeGlobalRoles = $scope.user.authorization.entity === 'Administrator' ? '' : '?includeGlobalRoles=false';
            $http.get('/Security/Roles/Simple' + includeGlobalRoles, { cache: true, trackerMsg: 'Loading roles', ignoreExceptions: true })
                .then(function(response) {
                    $scope.roles.list = response.data.filter(r =>  {return !rolesToExclude.includes(r.id) } ) 
                });
        }
    }

    function loadUserAccessDefaults() {
        $scope.userAccess = {name: '', userId: null, canRun: null, canEdit: null, canDelete: null};
        $scope.users.selected = null;
    }

    function loadRepresentativeAccessDefaults() {
        $scope.representativeAccess = {name: '', representativeId: null, canRun: false};
        $scope.representatives.selected = null;
    }

    function loadRepresentativesClientsAccessDefaults() {
        $scope.representativesClientsAccess = {name: '', representativeId: null, canRun: false};
        $scope.representativesClient.selected = null;
    }

    function loadClientAccessDefaults() {
        $scope.clientAccess = {name: '', clientId: null, canRun: false};
        $scope.clients.selected = null;
    }

    function loadBrokerDealersRepresentativesAccessDefaults() {
        $scope.brokerDealersRepresentativesAccess = {name: '', brokerDealerId: null, canRun: false};
        $scope.brokerDealersRepresentative.selected = null;
    }

    function addAccess(verboseLevel, requiredFields, resetDefaultsFn) {
        const scopeObject = $scope[verboseLevel + 'Access'];

        if (requiredFields.any(field => !scopeObject[field])) {
            $dialog.actionFailed('Please fill out all required fields before adding a new access rule.').open();
            return;
        }

        // only add it to the list if it doesn't already exist
        const fieldsToMatchOn = Object.select(scopeObject, requiredFields);
        if (verbose.accessLevels[verboseLevel].none(fieldsToMatchOn)) {
            verbose.accessLevels[verboseLevel].add(angular.copy(scopeObject));
        } else {
            $dialog.actionFailed('Cannot create a duplicate access rule.').open();
        }

        resetDefaultsFn();
    }


    // PUBLIC METHODS
    $scope.loadTab = function(menuItem) {
        $scope.current.selectedTab = menuItem;
        menuItem.load.forEach(function(fn) {
            fn();
        });
    };

    $scope.save = function() {
        editorHotKeys.destroy();
        dialog.close({ isSaved: true, accessLevels: verbose.accessLevels });
    };

    $scope.close = function(validate) {
        if (validate && !angular.equals(original, verbose)) {
            $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
        } else {
            editorHotKeys.destroy();
            dialog.close({ isSaved: false, accessLevels: original.accessLevels });
        }
    };

    $scope.openDbSwitcher = function() {
        $http.get('/Authorization/Databases', { cache: true, trackerMsg: 'Loading databases', ignoreExceptions: true })
            .then(function(response) {
                $scope.showDbSwitcher = true;

                $scope.databases.list = response.data;
                $scope.databaseAccess.alClientId = null;

                setTimeout(function() {
                    document.getElementById('txtDatabases').focus();
                }, 10);
            });
    };

    $scope.selectDatabaseGroup = function(item) {
        $scope.databaseGroupAccess.databaseGroupId = item.id;
        $scope.databaseGroupAccess.name = item.name;
    };

    $scope.selectDatabase = function(item) {
        $scope.databaseAccess.alClientId = item.id;
        $scope.databaseAccess.name = item.clientName;
    };

    $scope.selectRole = function(item) {
        $scope.roleAccess.roleId = item.id;
        $scope.roleAccess.name = item.name;
    };

    $scope.selectUser = function(item) {
        $scope.userAccess.userId = item.userId;
        $scope.userAccess.name = item.loginUserId;
    };

    $scope.selectRep = function(item) {
        $scope.representativeAccess.representativeId = item.id;
        $scope.representativeAccess.name = item.name;
    };

    $scope.selectRepClient = function(item) {
        $scope.representativesClientsAccess.representativeId = item.id;
        $scope.representativesClientsAccess.name = item.name;
    };

    $scope.selectClient = function(item) {
        $scope.clientAccess.clientId = item.entityId;
        $scope.clientAccess.name = item.entityName;
    };

    $scope.selectBrokerDealerRep = function(item) {
        $scope.brokerDealersRepresentativesAccess.brokerDealerId = item.id;
        $scope.brokerDealersRepresentativesAccess.name = item.name;
    };

    $scope.addLoginAccess = function() {
        addAccess('login', ['loginEntityId'], loadLoginAccessDefaults);
    };

    $scope.addDatabaseGroupAccess = function() {
        addAccess('databaseGroup', ['databaseGroupId', 'loginEntityId'], loadDatabaseGroupAccessDefaults);
    };

    $scope.addDatabaseAccess = function() {
        addAccess('database', ['alClientId', 'loginEntityId'], loadDatabaseAccessDefaults);
    };

    $scope.addRoleAccess = function() {
        addAccess('role', ['roleId'], loadRoleAccessDefaults);
    };

    $scope.addUserAccess = function() {
        addAccess('user', ['userId'], loadUserAccessDefaults);
    };

    $scope.addRepAccess = function() {
        addAccess('representative', ['representativeId'], loadRepresentativeAccessDefaults);
    };

    $scope.addRepClientAccess = function() {
        addAccess('representativesClients', ['representativeId'], loadRepresentativesClientsAccessDefaults);
    };

    $scope.addClientAccess = function() {
        addAccess('client', ['clientId'], loadClientAccessDefaults);
    };

    $scope.addBrokerDealerRepAccess = function() {
        addAccess('brokerDealersRepresentatives', ['brokerDealerId'], loadBrokerDealersRepresentativesAccessDefaults);
    };

    $scope.removeLoginAccess = function(item) {
        verbose.accessLevels.login.remove(item);
    };

    $scope.removeDatabaseGroupAccess = function(item) {
        verbose.accessLevels.databaseGroup.remove(item);
    };

    $scope.removeDatabaseAccess = function(item) {
        verbose.accessLevels.database.remove(item);
    };

    $scope.removeRoleAccess = function(item) {
        verbose.accessLevels.role.remove(item);
    };

    $scope.removeUserAccess = function(item) {
        verbose.accessLevels.user.remove(item);
    };

    $scope.removeRepAccess = function(item) {
        verbose.accessLevels.representative.remove(item);
    };

    $scope.removeRepClientAccess = function(item) {
        verbose.accessLevels.representativesClients.remove(item);
    };

    $scope.removeClientAccess = function(item) {
        verbose.accessLevels.client.remove(item);
    };

    $scope.removeBrokerDealerRepAccess = function(item) {
        verbose.accessLevels.brokerDealersRepresentatives.remove(item);
    };

    $scope.searchProfiles = function(searchText, entityLevel) {
        return $http.get('/Security/Profiles/Search?search=' + searchText + (entityLevel ? '&entity=' + entityLevel : ''))
            .then(function(response) {
                return response.data;
            });
    };

    $scope.searchRep = function(searchText) {
        return $http.get('/Portfolio/Representatives/Simple/Search?search=' + searchText)
            .then(function(response) {
                return response.data;
            });
    };

    $scope.searchBrokerDealer = function(searchText) {
        return $http.get('/Portfolio/BrokerDealers/Simple/Search?search=' + searchText)
            .then(function(response) {
                return response.data;
            });
    };

    $scope.profileFormatter = function(profile) {
        return !profile ? '' : (profile.entityId || profile.userId) + ': ' + profile.entityName + ' (' + profile.loginUserId + ')';
    };

    $scope.repProfileFormatter = function(profile) {
        return !profile ? '' : profile.id + ': ' + profile.name;
    };

    $scope.filterRoleAccess = function(rules) {
        if ($scope.user.authorization.entity !== 'Administrator') {
            if ($scope.roles && $scope.roles.list) {
                return rules.filter(function(r) {
                    return $scope.roles.list.some({ id: r.roleId });
                });
            } else {
                return [];
            }
        }

        return rules;
    };


    //INITIALIZE
    $scope.databaseGroups = {selected: null};
    $scope.databases = {selected: null};
    $scope.roles = {selected: null};
    $scope.users = {selected: null};
    $scope.representatives = {selected: null};
    $scope.representativesClient = {selected: null};
    $scope.clients = {selected: null};
    $scope.brokerDealersRepresentative = {selected: null};

    $scope.verbose = verbose;

    $scope.current = {name: args.name, searchInProgress: false};

    $scope.loginEntities = [
        'Administrator',
        'Advisor',
        'Wholesaler',
        'Broker/Dealer',
        'Representative',
        'Client'
    ];

    if (args.isFullPage) {
        $scope.current.isFullPage = args.isFullPage;
    }

    $scope.errors = [];

    init();
});

'use strict';

app.factory(
    'reportAccessEditCtrlHelper',
    function reportAccessEditCtrlHelper() {
        const self = this;

        self.buildMenu = (
            auth,
            accessLevels,
            canAccessRules,
            callbacks
        ) => {
            if (
                !auth ||
                !accessLevels ||
                typeof canAccessRules !== 'boolean' ||
                !callbacks
            ) {
                return null;
            }

            const isAdmin = auth.entity.toLocaleLowerCase() === 'administrator';
            const isRIA = auth.entity.toLocaleLowerCase() === 'advisor';
            const isAdminOrRIA = isAdmin || isRIA;
            const isRep = auth.entity.toLocaleLowerCase() === 'representative';
            const multipleDb = auth.databaseCount > 1;
            const menu = [
                {
                    name: 'Access Level',
                    enabled: true,
                    items: [
                        {
                            name: 'Login Level',
                            code: 'reportLoginAccess',
                            enabled:
                                isAdmin &&
                                canAccessRules &&
                                angular.isArray(accessLevels.login),
                            load: callbacks.reportLoginAccess,
                        },
                        {
                            name: 'Database Group',
                            code: 'reportDatabaseGroupAccess',
                            enabled:
                                (isAdmin || (isRIA && multipleDb)) &&
                                canAccessRules &&
                                angular.isArray(accessLevels.databaseGroup),
                            load: callbacks.reportDatabaseGroupAccess,
                        },
                        {
                            name: 'Database',
                            code: 'reportDatabaseAccess',
                            enabled:
                                isAdminOrRIA &&
                                canAccessRules &&
                                angular.isArray(accessLevels.database),
                            load: callbacks.reportDatabaseAccess,
                        },
                        {
                            name: 'Role',
                            code: 'reportRoleAccess',
                            enabled:
                                isAdminOrRIA &&
                                canAccessRules &&
                                angular.isArray(accessLevels.role),
                            load: callbacks.reportRoleAccess,
                        },
                        {
                            name: 'User',
                            code: 'reportUserAccess',
                            enabled:
                                isAdminOrRIA &&
                                canAccessRules &&
                                angular.isArray(accessLevels.user),
                            load: callbacks.reportUserAccess,
                        },
                        {
                            name: 'Representative',
                            code: 'reportRepresentativeAccess',
                            enabled:
                                !isRep &&
                                angular.isArray(accessLevels.representative),
                            load: callbacks.reportRepresentativeAccess,
                        },
                        {
                            name: "Representative's Clients",
                            code: 'reportRepresentativeClientAccess',
                            enabled: angular.isArray(
                                accessLevels.representativesClients
                            ),
                            load: callbacks.reportRepresentativeClientAccess,
                        },
                        {
                            name: 'Client',
                            code: 'reportClientAccess',
                            enabled: angular.isArray(accessLevels.client),
                            load: callbacks.reportClientAccess,
                        },
                        {
                            name: 'Broker/Dealer\'s Representatives',
                            code: 'reportBrokerDealersRepresentativeAccess',
                            enabled: angular.isArray(
                                accessLevels.brokerDealersRepresentatives
                            ),
                            load: callbacks.reportBrokerDealersRepresentativeAccess,
                        },
                    ],
                },
            ];

            menu.forEach((category) => {
                category.items.remove({ enabled: false });
            });

            return menu;
        };

        return self;
    }
);

'use strict';

app.controller('ReportPackageAccessEditCtrl', function ReportPackageAccessEditCtrl($scope, $http, $q, $timeout, $dialog, $oasRights, args, dialog, reportPackageAccessEditCtrlHelper) {
    // PRIVATE VARIABLES
    const verbose = {};
    const original = {};
    let editorHotKeys;


    // PRIVATE METHODS
    function init() {
        loadRights();
        buildMenu();

        $scope.menu.each(function(category) {
            const menuItem = category.items.find({ code: args.defaultTab.code });
            if (menuItem) {
                $scope.loadTab(menuItem);
                return false;
            }
        });

        loadHotKeys();
    }

    function loadRights() {
        $scope.hasAdvancedEditorRights = $oasRights.canRead('REPORTBUILDERADVANCEDEDITOR');
    }

    function buildMenu() {
        const callbacks = {
            reportLoginAccess: [loadReportAccess, loadLoginAccessDefaults],
            reportDatabaseGroupAccess: [
                loadReportAccess,
                loadDatabaseGroupAccessDefaults,
            ],
            reportDatabaseAccess: [
                loadReportAccess,
                loadDatabaseAccessDefaults,
            ],
            reportRoleAccess: [loadReportAccess, loadRoleAccessDefaults],
            reportUserAccess: [loadReportAccess, loadUserAccessDefaults],
            reportRepresentativeAccess: [
                loadReportAccess,
                loadRepresentativeAccessDefaults,
            ],
            reportRepresentativeClientAccess: [
                loadReportAccess,
                loadRepresentativesClientsAccessDefaults,
            ],
            reportClientAccess: [
                loadReportAccess,
                loadClientAccessDefaults,
            ],
        };

        $scope.menu = reportPackageAccessEditCtrlHelper.buildMenu(
            $scope.user.authorization,
            args.accessLevels,
            $scope.hasAdvancedEditorRights,
            callbacks
        );
    }

    function loadHotKeys() {
        editorHotKeys = new window.HotKeys();

        $timeout(function() {
            editorHotKeys.addActions([
                { combo: 'ALT+S', command: $scope.save },
                {
                    combo: 'ALT+X', command: function() {
                        $scope.close(true);
                    },
                },
            ]);
        });
    }

    function expandVerbose(propertyName, data) {
        verbose[propertyName] = data;
        original[propertyName] = angular.copy(data);
    }

    function loadReportAccess() {
        if (verbose.accessLevels) {
            return;
        }

        expandVerbose('accessLevels', args.accessLevels);
    }

    function loadLoginAccessDefaults() {
        $scope.loginAccess = {loginEntityId: null, canRun: false};
    }

    function loadDatabaseGroupAccessDefaults() {
        $scope.databaseGroupAccess = {name: '', databaseGroupId: null, loginEntityId: null, canRun: false, canEdit: null};
        $scope.databaseGroups.selected = null;

        if (!$scope.databaseGroups.list) {
            $http.get('/Utility/DatabaseGroups/Simple?isPrivate=false', { cache: true, trackerMsg: 'Loading database groups', ignoreExceptions: true })
                .then(function(response) {
                    $scope.databaseGroups.list = response.data;
                });
        }
    }

    function loadDatabaseAccessDefaults() {
        $scope.databaseAccess = {name: $scope.user.authorization.alClientName, alClientId: $scope.user.authorization.alClientId, loginEntityId: null, canRun: false, canEdit: null};
        $scope.databases.selected = null;
    }

    function loadRoleAccessDefaults() {
        $scope.roleAccess = {name: '', roleId: null, canRun: null, canEdit: null, canDelete: null};
        $scope.roles.selected = null;

        if (!$scope.roles.list) {
            const includeGlobalRoles = $scope.user.authorization.entity === 'Administrator' ? '' : '?includeGlobalRoles=false';
            $http.get('/Security/Roles/Simple' + includeGlobalRoles, { cache: true, trackerMsg: 'Loading roles', ignoreExceptions: true })
                .then(function(response) {
                    $scope.roles.list = response.data;
                });
        }
    }

    function loadUserAccessDefaults() {
        $scope.userAccess = {name: '', userId: null, canRun: null, canEdit: null, canDelete: null};
        $scope.users.selected = null;
    }

    function loadRepresentativeAccessDefaults() {
        $scope.representativeAccess = {name: '', representativeId: null, canRun: false};
        $scope.representatives.selected = null;
    }

    function loadRepresentativesClientsAccessDefaults() {
        $scope.representativesClientsAccess = {name: '', representativeId: null, canRun: false};
        $scope.representativesClient.selected = null;
    }

    function loadClientAccessDefaults() {
        $scope.clientAccess = {name: '', clientId: null, canRun: false};
        $scope.clients.selected = null;
    }

    function addAccess(verboseLevel, requiredFields, resetDefaultsFn) {
        const scopeObject = $scope[verboseLevel + 'Access'];

        if (requiredFields.any(field => !scopeObject[field])) {
            $dialog.actionFailed('Please fill out all required fields before adding a new access rule.').open();
            return;
        }

        // only add it to the list if it doesn't already exist
        const fieldsToMatchOn = Object.select(scopeObject, requiredFields);
        if (verbose.accessLevels[verboseLevel].none(fieldsToMatchOn)) {
            verbose.accessLevels[verboseLevel].add(angular.copy(scopeObject));
        } else {
            $dialog.actionFailed('Cannot create a duplicate access rule.').open();
        }

        resetDefaultsFn();
    }


    // PUBLIC METHODS
    $scope.loadTab = function(menuItem) {
        $scope.current.selectedTab = menuItem;
        menuItem.load.forEach(function(fn) {
            fn();
        });
    };

    $scope.save = function() {
        editorHotKeys.destroy();
        dialog.close({ isSaved: true, accessLevels: verbose.accessLevels });
    };

    $scope.close = function(validate) {
        if (validate && !angular.equals(original, verbose)) {
            $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
        } else {
            editorHotKeys.destroy();
            dialog.close({ isSaved: false, accessLevels: original.accessLevels });
        }
    };

    $scope.openDbSwitcher = function() {
        $http.get('/Authorization/Databases', { cache: true, trackerMsg: 'Loading databases', ignoreExceptions: true })
            .then(function(response) {
                $scope.showDbSwitcher = true;

                $scope.databases.list = response.data;
                $scope.databaseAccess.alClientId = null;

                setTimeout(function() {
                    document.getElementById('txtDatabases').focus();
                }, 10);
            });
    };

    $scope.selectDatabaseGroup = function(item) {
        $scope.databaseGroupAccess.databaseGroupId = item.id;
        $scope.databaseGroupAccess.name = item.name;
    };

    $scope.selectDatabase = function(item) {
        $scope.databaseAccess.alClientId = item.id;
        $scope.databaseAccess.name = item.clientName;
    };

    $scope.selectRole = function(item) {
        $scope.roleAccess.roleId = item.id;
        $scope.roleAccess.name = item.name;
    };

    $scope.selectUser = function(item) {
        $scope.userAccess.userId = item.userId;
        $scope.userAccess.name = item.loginUserId;
    };

    $scope.selectRep = function(item) {
        $scope.representativeAccess.representativeId = item.id;
        $scope.representativeAccess.name = item.name;
    };

    $scope.selectRepClient = function(item) {
        $scope.representativesClientsAccess.representativeId = item.id;
        $scope.representativesClientsAccess.name = item.name;
    };

    $scope.selectClient = function(item) {
        $scope.clientAccess.clientId = item.entityId;
        $scope.clientAccess.name = item.entityName;
    };

    $scope.addLoginAccess = function() {
        addAccess('login', ['loginEntityId'], loadLoginAccessDefaults);
    };

    $scope.addDatabaseGroupAccess = function() {
        addAccess('databaseGroup', ['databaseGroupId', 'loginEntityId'], loadDatabaseGroupAccessDefaults);
    };

    $scope.addDatabaseAccess = function() {
        addAccess('database', ['alClientId', 'loginEntityId'], loadDatabaseAccessDefaults);
    };

    $scope.addRoleAccess = function() {
        addAccess('role', ['roleId'], loadRoleAccessDefaults);
    };

    $scope.addUserAccess = function() {
        addAccess('user', ['userId'], loadUserAccessDefaults);
    };

    $scope.addRepAccess = function() {
        addAccess('representative', ['representativeId'], loadRepresentativeAccessDefaults);
    };

    $scope.addRepClientAccess = function() {
        addAccess('representativesClients', ['representativeId'], loadRepresentativesClientsAccessDefaults);
    };

    $scope.addClientAccess = function() {
        addAccess('client', ['clientId'], loadClientAccessDefaults);
    };

    $scope.removeLoginAccess = function(item) {
        verbose.accessLevels.login.remove(item);
    };

    $scope.removeDatabaseGroupAccess = function(item) {
        verbose.accessLevels.databaseGroup.remove(item);
    };

    $scope.removeDatabaseAccess = function(item) {
        verbose.accessLevels.database.remove(item);
    };

    $scope.removeRoleAccess = function(item) {
        verbose.accessLevels.role.remove(item);
    };

    $scope.removeUserAccess = function(item) {
        verbose.accessLevels.user.remove(item);
    };

    $scope.removeRepAccess = function(item) {
        verbose.accessLevels.representative.remove(item);
    };

    $scope.removeRepClientAccess = function(item) {
        verbose.accessLevels.representativesClients.remove(item);
    };

    $scope.removeClientAccess = function(item) {
        verbose.accessLevels.client.remove(item);
    };

    $scope.searchProfiles = function(searchText, entityLevel) {
        return $http.get('/Security/Profiles/Search?search=' + searchText + (entityLevel ? '&entity=' + entityLevel : ''))
            .then(function(response) {
                return response.data;
            });
    };

    $scope.searchRep = function(searchText) {
        return $http.get('/Portfolio/Representatives/Simple/Search?search=' + searchText)
            .then(function(response) {
                return response.data;
            });
    };

    $scope.profileFormatter = function(profile) {
        return !profile ? '' : (profile.entityId || profile.userId) + ': ' + profile.entityName + ' (' + profile.loginUserId + ')';
    };

    $scope.repProfileFormatter = function(profile) {
        return !profile ? '' : profile.id + ': ' + profile.name;
    };

    $scope.filterRoleAccess = function(rules) {
        if ($scope.user.authorization.entity !== 'Administrator') {
            if ($scope.roles && $scope.roles.list) {
                return rules.filter(function(r) {
                    return $scope.roles.list.some({ id: r.roleId });
                });
            } else {
                return [];
            }
        }

        return rules;
    };


    //INITIALIZE
    $scope.databaseGroups = {selected: null};
    $scope.databases = {selected: null};
    $scope.roles = {selected: null};
    $scope.users = {selected: null};
    $scope.representatives = {selected: null};
    $scope.representativesClient = {selected: null};
    $scope.clients = {selected: null};

    $scope.verbose = verbose;

    $scope.current = {name: args.name, searchInProgress: false};

    $scope.loginEntities = [
        'Administrator',
        'Advisor',
        'Wholesaler',
        'Broker/Dealer',
        'Representative',
        'Client'
    ];

    if (args.isFullPage) {
        $scope.current.isFullPage = args.isFullPage;
    }

    $scope.errors = [];

    init();
});

'use strict';

app.factory(
    'reportPackageAccessEditCtrlHelper',
    function reportPackageAccessEditCtrlHelper() {
        const self = this;

        self.buildMenu = (
            auth,
            accessLevels,
            hasAdvancedEditorRights,
            callbacks
        ) => {
            if (
                !auth ||
                !accessLevels ||
                typeof hasAdvancedEditorRights !== 'boolean' ||
                !callbacks
            ) {
                return null;
            }

            const isAdmin = auth.entity.toLocaleLowerCase() === 'administrator';
            const isRIA = auth.entity.toLocaleLowerCase() === 'advisor';
            const isAdminOrRIA = isAdmin || isRIA;
            const isRep = auth.entity.toLocaleLowerCase() === 'representative';
            const multipleDb = auth.databaseCount > 1;
            const menu = [
                {
                    name: 'Access Level',
                    enabled: true,
                    items: [
                        {
                            name: 'Login Level',
                            code: 'reportLoginAccess',
                            enabled:
                                isAdmin &&
                                hasAdvancedEditorRights &&
                                angular.isArray(accessLevels.login),
                            load: callbacks.reportLoginAccess,
                        },
                        {
                            name: 'Database Group',
                            code: 'reportDatabaseGroupAccess',
                            enabled:
                                (isAdmin || (isRIA && multipleDb)) &&
                                hasAdvancedEditorRights &&
                                angular.isArray(accessLevels.databaseGroup),
                            load: callbacks.reportDatabaseGroupAccess,
                        },
                        {
                            name: 'Database',
                            code: 'reportDatabaseAccess',
                            enabled:
                                isAdminOrRIA &&
                                hasAdvancedEditorRights &&
                                angular.isArray(accessLevels.database),
                            load: callbacks.reportDatabaseAccess,
                        },
                        {
                            name: 'Role',
                            code: 'reportRoleAccess',
                            enabled:
                                isAdminOrRIA &&
                                hasAdvancedEditorRights &&
                                angular.isArray(accessLevels.role),
                            load: callbacks.reportRoleAccess,
                        },
                        {
                            name: 'User',
                            code: 'reportUserAccess',
                            enabled:
                                isAdminOrRIA &&
                                hasAdvancedEditorRights &&
                                angular.isArray(accessLevels.user),
                            load: callbacks.reportUserAccess,
                        },
                        {
                            name: 'Representative',
                            code: 'reportRepresentativeAccess',
                            enabled:
                                !isRep &&
                                angular.isArray(accessLevels.representative),
                            load: callbacks.reportRepresentativeAccess,
                        },
                        {
                            name: "Representative's Clients",
                            code: 'reportRepresentativeClientAccess',
                            enabled: angular.isArray(
                                accessLevels.representativesClients
                            ),
                            load: callbacks.reportRepresentativeClientAccess,
                        },
                        {
                            name: 'Client',
                            code: 'reportClientAccess',
                            enabled: angular.isArray(accessLevels.client),
                            load: callbacks.reportClientAccess,
                        },
                    ],
                },
            ];

            menu.forEach((category) => {
                category.items.remove({ enabled: false });
            });

            return menu;
        };

        return self;
    }
);
'use strict';

app.controller('ReportVersionAssignmentEditCtrl', function ReportVersionAssignmentEditCtrl($scope, $http, $q, $oasRights, $timeout, args, dialog, entities) {
    //PRIVATE VARIABLES
    const verbose = {}, original = {};
    let sortedAssignments = [];
    let editorHotKeys;

    //PRIVATE METHODS
    function init() {
        //if (!$oasRights.canRead("")) return;

        loadRights();
        loadReportVersions();
        buildMenu();

        $scope.menu.each(function (category) {
            const menuItem = category.items.find({code: args.defaultTab.code});
            if (menuItem) {
                $scope.loadTab(menuItem);
                return false;
            }
        });
        loadHotKeys();
    }

    function loadRights() {
        //$scope.rightsReportVersionAssignment = $oasRights.forCode("");
    }

    function buildMenu() {
        const isAdminOrRIA = ["Administrator", "Advisor"].any($scope.user.authorization.entity);
        const isRep = $scope.user.authorization.entity === "Representative";
        const multipleDb = $scope.user.authorization.databaseCount > 1;
        const menu = [
            {
                name: "Version Assignment", enabled: true, items: [
                    {name: 'Representative', code: 'reportRepresentativeVersionAssignment', enabled: true, load: [loadReportVersionAssignment, loadRepresentativeVersionAssignmentDefaults]},
                    {name: 'Broker/Dealer', code: 'reportBrokerDealerVersionAssignment', enabled: true, load: [loadReportVersionAssignment, loadBrokerDealerVersionAssignmentDefaults]},
                    {name: 'Client', code: 'reportClientVersionAssignment', enabled: true, load: [loadReportVersionAssignment, loadClientVersionAssignmentDefaults]},
                    {name: 'Portfolio Group', code: 'reportPortfolioGroupVersionAssignment', enabled: true, load: [loadReportVersionAssignment, loadPortfolioGroupVersionAssignmentDefaults]},
                ]
            }
        ];

        menu.forEach(function (category) {
            category.items.remove({enabled: false});
        });

        $scope.menu = menu;
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                {combo: 'ALT+S', command: $scope.save},
                {combo: 'ALT+X', command: function () {$scope.close(true);}}
            ]);
        });
    }

    function expandVerbose(propertyName, data) {
        verbose[propertyName] = data;
        original[propertyName] = angular.copy(data);
    }

    //region LOAD REPORT ACCESS

    function loadReportVersionAssignment() {
        if (verbose.versionAssignments) return;

        expandVerbose("versionAssignments", args.versionAssignments);
    }

    function loadReportVersions() {
        $http.get("/Reporting/Envision/Reports/Verbose/" + args.reportId + "?expand=versions", {trackerMsg: 'Loading report versions'})
            .then(function (response) {
                $scope.versions = response.data.versions.filter(x => !x.isDeleted);
            });
    }

    function loadRepresentativeVersionAssignmentDefaults() {
        $scope.representativeVersionAssignment = {name: '', reportId: args.reportId, reportVersionId: '', representativeId: 0};
        $scope.current.representative = "";
    }

    function loadBrokerDealerVersionAssignmentDefaults() {
        $scope.brokerDealerVersionAssignment = {name: '', reportId: args.reportId, reportVersionId: '', brokerDealerId: 0};
        $scope.current.brokerdealer = "";
    }

    function loadClientVersionAssignmentDefaults() {
        $scope.clientVersionAssignment = {name: '', reportId: args.reportId, reportVersionId: '', clientId: 0};
        $scope.current.client = "";
    }

    function loadPortfolioGroupVersionAssignmentDefaults() {
        $scope.portfolioGroupVersionAssignment = {name: '', reportId: args.reportId, reportVersionId: '', portfolioGroupId: 0};
        $scope.current.portfolioGroups = "";
    }


    //endregion

    //PUBLIC METHODS

    //region LOAD/CLOSE
    $scope.loadTab = function (menuItem) {
        $scope.current.selectedTab = menuItem;
        menuItem.load.forEach(function (fn) {
            fn();
        });
    };

    $scope.save = function () {
        editorHotKeys.destroy();
        dialog.close({isSaved: true, versionAssignments: verbose.versionAssignments});
    };

    $scope.close = function (validate) {
        if (validate && !angular.equals(original, verbose)) {
            $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true});
        } else {
            editorHotKeys.destroy();
            dialog.close({isSaved: false, versionAssignments: original.versionAssignments});
        }
    };

    //endregion

    $scope.selectRep = function (item) {
        $scope.representativeVersionAssignment.representativeId = item.id;
        $scope.representativeVersionAssignment.name = item.name;
    };
    $scope.selectBrokerDealer = function (item) {
        $scope.brokerDealerVersionAssignment.brokerDealerId = item.id;
        $scope.brokerDealerVersionAssignment.name = item.name;
    };
    $scope.selectClient = function (item) {
        $scope.clientVersionAssignment.clientId = item.id;
        $scope.clientVersionAssignment.name = item.name;
    };
    $scope.selectPortfolioGroup = function (item) {
        $scope.portfolioGroupVersionAssignment.portfolioGroupId = item.id;
        $scope.portfolioGroupVersionAssignment.name = item.name;
    };

    $scope.addRepVersionAssignment = function () {
        if(!$scope.representativeVersionAssignment.representativeId)
            return;
        var rep = verbose.versionAssignments.representative.find({representativeId: $scope.representativeVersionAssignment.representativeId});
        if(rep)
            rep.reportVersionId =  $scope.representativeVersionAssignment.reportVersionId;
        else
            verbose.versionAssignments.representative.add(angular.copy($scope.representativeVersionAssignment));
        loadRepresentativeVersionAssignmentDefaults();
    };
    $scope.addBrokerDealerVersionAssignment = function () {
        if(!$scope.brokerDealerVersionAssignment.brokerDealerId)
            return;
        var bd = verbose.versionAssignments.brokerDealer.find({brokerDealerId: $scope.brokerDealerVersionAssignment.brokerDealerId});
        if(bd)
            bd.reportVersionId =  $scope.brokerDealerVersionAssignment.reportVersionId;
        else
            verbose.versionAssignments.brokerDealer.add(angular.copy($scope.brokerDealerVersionAssignment));
        loadBrokerDealerVersionAssignmentDefaults();
    };
    $scope.addClientVersionAssignment = function () {
        if(!$scope.clientVersionAssignment.clientId)
            return;
        var client = verbose.versionAssignments.client.find({clientId: $scope.clientVersionAssignment.clientId});
        if(client)
            client.reportVersionId =  $scope.clientVersionAssignment.reportVersionId;
        else
            verbose.versionAssignments.client.add(angular.copy($scope.clientVersionAssignment));
        loadClientVersionAssignmentDefaults();
    };
    $scope.addPortfolioGroupVersionAssignment = function () {
        if(!$scope.portfolioGroupVersionAssignment.portfolioGroupId)
            return;
        var pg = verbose.versionAssignments.portfolioGroup.find({portfolioGroupId: $scope.portfolioGroupVersionAssignment.portfolioGroupId});
        if(pg)
            pg.reportVersionId =  $scope.portfolioGroupVersionAssignment.reportVersionId;
        else
            verbose.versionAssignments.portfolioGroup.add(angular.copy($scope.portfolioGroupVersionAssignment));
        loadPortfolioGroupVersionAssignmentDefaults();
    };

    $scope.removeRepVersionAssignment = function (item) {
        verbose.versionAssignments.representative.remove(item);
    };
    $scope.removeBrokerDealerVersionAssignment = function (item) {
        verbose.versionAssignments.brokerDealer.remove(item);
    };
    $scope.removeClientVersionAssignment = function (item) {
        verbose.versionAssignments.client.remove(item);
    };
    $scope.removePortfolioGroupVersionAssignment = function (item) {
        verbose.versionAssignments.portfolioGroup.remove(item);
    };

    $scope.searchEntity = function (searchText, entityLevel) {
        var url = entities[entityLevel].simpleUrl;
        if(entityLevel === 'portfolioGroup')
            url = url.replace("Simple", "");
        url += ("/Search?search=" + searchText);
        return $http.get( url )
            .then(function (response) {
                return response.data;
            });
    };

    $scope.profileFormatter = function (profile) {
        return !profile ? '' : profile.id + ': ' + profile.name;
    };
    $scope.portfolioGroupProfileFormatter = function (profile) {
        return !profile ? '' : profile.id  + ': ' + profile.name + ', ' + profile.clientName + ' (' + profile.clientId + ')';
    };

    $scope.getVersionName = function (id) {
        return $scope.versions.find({id: id}).name;
    };

    //INITIALIZE
    $scope.verbose = verbose;
    //intialize default values.
    $scope.pagination = {
        page: 1,
        itemsPerPage: 200,
        maxSize: 10,
    };

    // Returns a sorted copy of client assignments array.
    function getSortedAssignments(assignments) {
        const clientsList = assignments;
        if (Array.isArray(clientsList)) {
            //Return a shallow copy sorted by 'name'.
            return clientsList.slice().sort((firstClient, secondClient) => (firstClient.name || '').localeCompare(secondClient.name || ''));
        }
        return [];
    }

    //Watches for changes in the assignments data and initalizes pagination once data is available.
    $scope.$watchCollection('verbose.versionAssignments.client', function (newValue) {
        if (Array.isArray(newValue) && newValue.length > 0) {
            intializePagination(newValue);
        }
    });

    $scope.updatePagination = function () {
        intializePagination(verbose.versionAssignments.client);
    };


    //Intializes pagination by sorting the data and setting up page details.
    function intializePagination(assignments) {
        sortedAssignments = getSortedAssignments(assignments);
        $scope.pagination.totalItems = sortedAssignments.length;
        $scope.pagination.numPages = Math.ceil($scope.pagination.totalItems / $scope.pagination.itemsPerPage);
        $scope.setPageItems($scope.pagination.page); //Load the first page.
    }

    //Slices the sorted assignments array to get only the items for the current page.
    $scope.setPageItems = function (page) {
        $scope.pagination.page = page;
        const start = (page - 1) * $scope.pagination.itemsPerPage;
        const end = start + $scope.pagination.itemsPerPage;
        $scope.pagination.start = start + 1;
        $scope.pagination.end = Math.min(start + $scope.pagination.itemsPerPage, $scope.pagination.totalItems);
        //Slice the sorted data for current page display.
        $scope.paginatedAssignments = sortedAssignments.slice(start, end);
    };

    $scope.current = {name: args.name, searchInProgress: false, representative: null, brokerDealer: null, client: null, portfolioGroup: null};
    $scope.loginEntities = {
        6: "Administrator",
        5: "Advisor",
        2: "Wholesaler",
        1: "Broker/Dealer",
        3: "Representative",
        4: "Client"
    };

    if (args.isFullPage) {
        $scope.current.isFullPage = args.isFullPage;
    }

    $scope.errors = [];

    init();
});
'use strict';

app.controller('QueryAccessEditCtrl', function QueryAccessEditCtrl($scope, $http, $q, $oasRights, $timeout, args, dialog) {
    //PRIVATE VARIABLES
    const verbose = {}, original = {};
    let editorHotKeys;

    //PRIVATE METHODS
    function init() {
        //if (!$oasRights.canRead("")) return;

        loadRights();
        buildMenu();

        $scope.menu.each(function (category) {
            const menuItem = category.items.find({code: args.defaultTab.code});
            if (menuItem) {
                $scope.loadTab(menuItem);
                return false;
            }
        });
        loadHotKeys();
    }

    function loadRights() {
        //$scope.rightsReportAccess = $oasRights.forCode("");
    }

    function buildMenu() {
        const isAdmin = ($scope.user.authorization.entity.toLocaleLowerCase() === "administrator");
        const isRIA = ($scope.user.authorization.entity.toLocaleLowerCase() === "advisor");
        const isAdminOrRIA = ["Administrator", "Advisor"].any($scope.user.authorization.entity);
        const isRep = $scope.user.authorization.entity.toLocaleLowerCase() === "representative";
        const multipleDb = $scope.user.authorization.databaseCount > 1;
        const menu = [
            {
                name: "Access Level", enabled: true, items: [
                {name: 'Login Level', code: 'queryLoginAccess', enabled: (isAdmin && angular.isArray(args.accessLevels.login)), load: [loadQueryAccess, loadLoginAccessDefaults]},
                {name: 'Database Group', code: 'queryDatabaseGroupAccess', enabled: ((isAdmin || (isRIA && multipleDb)) && angular.isArray(args.accessLevels.databaseGroup)), load: [loadQueryAccess, loadDatabaseGroupAccessDefaults]},
                {name: 'Database', code: 'queryDatabaseAccess', enabled: (isAdminOrRIA && angular.isArray(args.accessLevels.database)), load: [loadQueryAccess, loadDatabaseAccessDefaults]},
                {name: 'Role', code: 'queryRoleAccess', enabled: (isAdminOrRIA && angular.isArray(args.accessLevels.role)), load: [loadQueryAccess, loadRoleAccessDefaults]},
                {name: 'User', code: 'queryUserAccess', enabled: (isAdminOrRIA && angular.isArray(args.accessLevels.user)), load: [loadQueryAccess, loadUserAccessDefaults]},
                {name: 'Representative', code: 'queryRepresentativeAccess', enabled: (!isRep && angular.isArray(args.accessLevels.representative)), load: [loadQueryAccess, loadRepresentativeAccessDefaults]}
            ]
            }
        ];

        menu.forEach(function (category) {
            category.items.remove({enabled: false});
        });

        $scope.menu = menu;
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                {combo: 'ALT+S', command: $scope.save},
                {combo: 'ALT+X', command: function () {$scope.close(true);}}
            ]);
        });
    }

    function expandVerbose(propertyName, data) {
        verbose[propertyName] = data;
        original[propertyName] = angular.copy(data);
    }

    //region LOAD REPORT ACCESS

    function loadQueryAccess() {
        if (verbose.accessLevels) return;

        expandVerbose("accessLevels", args.accessLevels);
    }

    function loadLoginAccessDefaults() {
        $scope.loginAccess = {loginEntityId: '', canRun: false};
    }

    function loadDatabaseGroupAccessDefaults() {
        $scope.databaseGroupAccess = {name: '', databaseGroupId: '', loginEntityId: '', canRun: false, canEdit: null};
        loadDatabaseGroups();
    }

    function loadDatabaseAccessDefaults() {
        $scope.databaseAccess = {name: $scope.user.authorization.alClientName, alClientId: $scope.user.authorization.alClientId, loginEntityId: '', canRun: false, canEdit: null};
    }

    function loadRoleAccessDefaults() {
        $scope.roleAccess = {name: '', roleId: 0, canRun: null, canEdit: null, canDelete: null};
        loadRoles();
    }

    function loadUserAccessDefaults() {
        $scope.userAccess = {name: '', userId: 0, canRun: null, canEdit: null, canDelete: null};
    }

    function loadRepresentativeAccessDefaults() {
        $scope.representativeAccess = {name: '', representativeId: 0, canRun: false};
    }


    //endregion

    //PUBLIC METHODS

    //region LOAD/CLOSE
    $scope.loadTab = function (menuItem) {
        $scope.current.selectedTab = menuItem;
        menuItem.load.forEach(function (fn) {
            fn();
        });
    };

    $scope.save = function () {
        editorHotKeys.destroy();
        dialog.close({isSaved: true, accessLevels: verbose.accessLevels});
    };

    $scope.close = function (validate) {
        if (validate && !angular.equals(original, verbose)) {
            $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true});
        } else {
            editorHotKeys.destroy();
            dialog.close({isSaved: false, accessLevels: original.accessLevels});
        }
    };

    //endregion

    function loadDatabaseGroups() {
        $http.get("/Utility/DatabaseGroups/Simple?isPrivate=false", {cache: true, trackerMsg: 'Loading database groups', ignoreExceptions: true})
            .then(function (response) {
                $scope.databaseGroups = {list: response.data};
            });
    }

    $scope.closeDbGroupPicker = function () {
        $scope.showDbGroupPicker = false;
    };

    $scope.openDbSwitcher = function () {
        $http.get("/Authorization/Databases", {cache: true, trackerMsg: 'Loading databases', ignoreExceptions: true})
            .then(function (response) {
                $scope.databases = {list: response.data};
                $scope.showDbSwitcher = true;
                setTimeout(function () {
                    document.getElementById("txtDatabases").focus();
                }, 10);
            });
    };

    $scope.closeDbSwitcher = function () {
        $scope.showDbSwitcher = false;
    };

    function loadRoles() {
        var includeGlobalRoles = $scope.user.authorization.entity.toLocaleLowerCase() === "administrator" ? "" : "?includeGlobalRoles=false";
        $http.get("/Security/Roles/Simple" + includeGlobalRoles, {cache: true, trackerMsg: 'Loading roles', ignoreExceptions: true})
            .then(function (response) {
                $scope.roles = {list: response.data};
            });
    }

    $scope.selectDatabaseGroup = function (item) {
        $scope.databaseGroupAccess.databaseGroupId = item.id;
        $scope.databaseGroupAccess.name = item.name;
    };
    $scope.selectDatabase = function (item) {
        $scope.databaseAccess.alClientId = item.id;
        $scope.databaseAccess.name = item.clientName;
    };
    $scope.selectRole = function (item) {
        $scope.roleAccess.roleId = item.id;
        $scope.roleAccess.name = item.name;
    };
    $scope.selectUser = function (item) {
        $scope.userAccess.userId = item.userId;
        $scope.userAccess.name = item.loginUserId;
    };
    $scope.selectRep = function (item) {
        $scope.representativeAccess.representativeId = item.id;
        $scope.representativeAccess.name = item.name;
    };
    $scope.addLoginAccess = function () {
        verbose.accessLevels.login.add(angular.copy($scope.loginAccess));
        loadLoginAccessDefaults();
    };
    $scope.addDatabaseGroupAccess = function () {
        verbose.accessLevels.databaseGroup.add(angular.copy($scope.databaseGroupAccess));
        loadDatabaseGroupAccessDefaults();
    };
    $scope.addDatabaseAccess = function () {
        verbose.accessLevels.database.add(angular.copy($scope.databaseAccess));
        loadDatabaseAccessDefaults();
    };
    $scope.addRoleAccess = function () {
        verbose.accessLevels.role.add(angular.copy($scope.roleAccess));
        loadRoleAccessDefaults();
    };
    $scope.addUserAccess = function () {
        verbose.accessLevels.user.add(angular.copy($scope.userAccess));
        loadUserAccessDefaults();
    };
    $scope.addRepAccess = function () {
        verbose.accessLevels.representative.add(angular.copy($scope.representativeAccess));
        loadRepresentativeAccessDefaults();
    };
    $scope.removeLoginAccess = function (item) {
        verbose.accessLevels.login.remove(item);
    };
    $scope.removeDatabaseGroupAccess = function (item) {
        verbose.accessLevels.databaseGroup.remove(item);
    };
    $scope.removeDatabaseAccess = function (item) {
        verbose.accessLevels.database.remove(item);
    };
    $scope.removeRoleAccess = function (item) {
        verbose.accessLevels.role.remove(item);
    };
    $scope.removeUserAccess = function (item) {
        verbose.accessLevels.user.remove(item);
    };
    $scope.removeRepAccess = function (item) {
        verbose.accessLevels.representative.remove(item);
    };

    $scope.searchProfiles = function (searchText, entityLevel) {
        return $http.get('/Security/Profiles/Search?search=' + searchText + (entityLevel ? '&entity=' + entityLevel : ''))
            .then(function (response) {
                return response.data;
            });
    };
    $scope.searchRep = function (searchText) {
        return $http.get('/Portfolio/Representatives/Simple/Search?search=' + searchText )
            .then(function (response) {
                return response.data;
            });
    };
    $scope.profileFormatter = function (profile) {
        return !profile ? '' : (profile.entityId || profile.userId) + ': ' + profile.entityName + ' (' + profile.loginUserId + ')';
    };
    $scope.repProfileFormatter = function(profile) {
        return !profile ? '' : profile.id + ': ' + profile.name;
    }

    $scope.filterRoleAccess = function (rules) {
        if($scope.user.authorization.entity.toLocaleLowerCase() !== "administrator") {
            if($scope.roles && $scope.roles.list) {
                return rules.filter(function(r) {
                    return $scope.roles.list.some({id: r.roleId});
                });
            } else return [];
        }
        return rules;
    };

    //INITIALIZE
    $scope.verbose = verbose;

    $scope.current = {name: args.name, searchInProgress: false};
    $scope.loginEntities = {
        6: "Administrator",
        5: "Advisor",
        2: "Wholesaler",
        1: "Broker/Dealer",
        3: "Representative"
    };

    if (args.isFullPage) {
        $scope.current.isFullPage = args.isFullPage;
    }

    $scope.errors = [];

    init();
});
'use strict';

app.service('$dataQuery', ['$http', '$dialog', '$location', function ($http, $dialog, $location) {
    // var cache = JSON.parse(localStorage.data_query_cache||'{}', function (k, v) {
    //     // at this point, we probably want more recent data
    //     return k === 'views' ? undefined : v;
    // });

    var self = this;
    var pageDefaults = null;
    var dataQuery;
    var queryList = [];
    var selectedQueryList = [];
    var results = [];
    var resultProps = {};
    var filterResults = [];
    var filteredColumns = [];
    var columnNames = [];
    var fileData = [];

    var user = null;

    self.setDataQuery = function (data) {
        // if(!user) {
        //     loadUser();
        // }
        //
        // if(data) {
        //     cache[data.id + "_" + user.userDetailId] = data;
        // }
        dataQuery = data;
        // localStorage.data_query_cache = JSON.stringify(cache);
    };

    self.getDataQuery = function (id) {
        // if(!user) {
        //     loadUser();
        // }
        var result;
        // if(id && cache[id + "_" + user.userDetailId]) {
        //     result = cache[id + "_" + user.userDetailId];
        // } else if(dataQuery && (dataQuery.id === id || dataQuery.id === parseInt(id))) {
        //     result = dataQuery;
        // }

        if(dataQuery && (dataQuery.id === id || dataQuery.id === parseInt(id))) {
            result = dataQuery;
        }
        return result;
    };

    self.getColumnNames = function () {
        return columnNames;
    };

    self.getProperties = function () {
        return resultProps;
    };

    self.loadQuery = function (item, postBackFn) {
        var id = 0;
        var msg = 'Loading parameters';
        if (angular.isObject(item)) {
            id = item.id;
            msg += ' for \"' + item.title + '\"';
        }
        else
            id = item;
        return $http.get('/Reporting/Custom/' + id, { trackerMsg: msg })
            .then(function (response){
                if(response) {
                    dataQuery = response.data;
                    if(postBackFn) handlePostBack(postBackFn);
                    return response.data;
                } else {
                    return Promise.reject();
                }
            });
    };

    self.loadParameterDialog = function (dq) {
        $dialog.dataQueryPrompt(dq)
            .open()
            .then(function (result) {
                if (result && result.id) {
                    self.setDataQuery(result);
                    $location.path('/reports/dataqueries/' + dq.id);
                }
            });
    };

    self.loadResults = function (postBackFn) {
        formatDates();
        $http.post('/Reporting/Custom/' + dataQuery.id + '/Generate/Table', dataQuery, { trackerMsg: 'Loading \"' + dataQuery.title + '\"' } )
            .then( function (response) {
                results = response.data;
                filterResults = response.data;
                filteredColumns = [];
                processColumnData();
                processFilters();
                fileData = [];
                handlePostBack(postBackFn);
            });
    };

    self.getResults = function (begin, end) {
        var resultPage = [];
        if(begin !== undefined) {
            if (end !== undefined) {
                resultPage = filterResults.slice(begin, end);
            }
            else {
                resultPage = filterResults.slice(begin);
            }
        }
        else {
            resultPage = filterResults;
        }
        return resultPage;
    };

    self.applyFilter = function (property, filterValue) {
        var match = function (node) { return node[0] === property; };
        if(filterValue.isBlank())
            filteredColumns.remove(match);
        else if (filteredColumns.none(match))
            filteredColumns.push([property,filterValue]);
        else
            filteredColumns.find(match)[1] = filterValue;

        filterResults = (filteredColumns.length > 0) ? results.filter(function(item) { return filterFunction(item); }) : results;
    };

    self.createFile = function(dataType, postBackFn, tokenOverride) {
        formatDates();
        var item = getFileData (dataQuery.id, dataType);
        var token = sessionStorage.oas_token;
        if( tokenOverride != null ) {
            token = tokenOverride
        }
        return $http.post('/Reporting/Custom/' + dataQuery.id + '/Generate/' + dataType, dataQuery, {headers: {Authorization: "Session " + token}, trackerMsg: 'Downloading \"' + dataQuery.title + '\"' } )
            .then( function ( response ) {
                if(item) {
                    setFileData(dataType, response.headers("location"));
                }
                else {
                    item = { id: 0, dataType: '', downloadUrl: '' };
                    item.id = dataQuery.id;
                    item.dataType = dataType;
                    item.downloadUrl = response.headers("location");
                    fileData.push(item);
                }
                if (postBackFn && angular.isFunction(postBackFn))
                    postBackFn(item.downloadUrl);
            });
    };

    self.createBlob = function(blobParentForAuditRequest) {
        formatDates();
        return $http.post('/Compliance/AuditRequests/' + blobParentForAuditRequest + '/DataQuery', dataQuery, {trackerMsg: "Data Query processing"} );
    };

    self.sendToSftp = function( ) {
        formatDates();
        return $http.post('/Reporting/Custom/' + dataQuery.id + '/Generate', dataQuery, {trackerMsg: "Data Query processing"} );
    };

    self.sendToInbox = function( ) {
        formatDates();
        return $http.post('/Reporting/Custom/' + dataQuery.id + '/Generate', dataQuery );
    };

    self.getFullQueryList = function () {
        var list = [];
        queryList.forEach(function(item){
            list.push({ id: item.id, title: item.title, reportDescription: item.reportDescription, scheduleId: item.scheduleId });
        });
        return list;
    };

    self.getSelectedDataQueryList = function () {
        var selectList = [];
        selectedQueryList.forEach(function(item){
            selectList.push({ id: item.id, title: item.title, reportDescription: item.reportDescription, scheduleId: item.scheduleId, scheduleIsActive: item.scheduleIsActive });
        });
        return selectList;
    };

    self.loadDataQueryList = function (postBackFn, resetList) {
        if(resetList)
            queryList = [];
        if(queryList.length === 0) {
            getQueryListRecursive(0, 1000, [processQueryList, postBackFn]);
        }
        else {
            handlePostBack([processQueryList, postBackFn]);
        }
    };

    self.loadDataQueryPageDefaults = function () {
        return $http.get('/Settings/Apps/dataQueries/Options/dataqueries', {trackerMsg:'Loading defaults for Queries'})
            .then(function(results) {
                pageDefaults = results.data.value;
                return true;
            });
    };

    self.runExcelReport = function(dataQueryId) {
        $dialog.dataQueryPrompt(dataQueryId)
            .open()
            .then(function (result) {
                if (result && result.id) {
                    self.setDataQuery(result);
                    $location.path('/reports/dataqueries/querybuilder/' + dataQueryId);
                    //$location.path('/reports/dataqueries/' + dataQueryId);
                }
            });
    };

    self.goToCustomImport = function (importTypeId, importId) {
        const url = `/orionconnectapp/#/customImports2/Validate/${importTypeId}/${importId}`;
        window.open(url, '_blank');
    };

    self.goToMultiDbCustomImport = function (importCommonId) {
        const url = `/orionconnectapp/#/customImports2/history/multidb/${importCommonId}`
        window.open(url, '_blank');
    };

    function loadUser () {
        user = JSON.parse(sessionStorage.oas_authorization);
    }

    function getQueryListRecursive (skip, take, postBack) {
        $http.get('/Reporting/Custom/Simple?reportType=Query&$orderby=Title&$skip=' + skip + '&$top=' + take, { trackerMsg: 'Loading queries' })
            .then( function (response) {
                if (response.data.length > 0) {
                    queryList = queryList.concat(response.data);
                    if (response.data.length === take)
                        getQueryListRecursive((skip + take), take, postBack);
                    else {
                        //queryList = queryList.sortBy(function(n) { return n.title; });
                        handlePostBack(postBack);
                    }
                }
                else
                    handlePostBack(postBack);
            });
    }

    function processQueryList(postBack) {
        var loadedQueries = [];
        pageDefaults.split(',').forEach(function (item){
            loadedQueries.push(parseInt(item));
        });
        selectedQueryList = queryList.filter(function(item) {
            return loadedQueries.some(item.id);
        });
        handlePostBack(postBack);
    }

    function processColumnData(){
        columnNames = [];
        for (var prop in results[0])
            columnNames.push(prop);
    }

    function processFilters(){
        resultProps = angular.copy(results[0]);
        for (var prop in resultProps) {
            resultProps[prop] = null;
        }
    }

    function filterFunction (item) {
        var matchFlag = true;
        filteredColumns.forEach(function (node) {
            var data = item[node[0]];
            var filterValue = node[1].toLowerCase();
            matchFlag = matchFlag && (data && data.toString().toLowerCase().indexOf(filterValue) !== -1);
        });
        return matchFlag;
    }

    function getFileData (id, dataType) {
        var result = null;
        angular.forEach(fileData, function(item){
            if(item.id === id && item.dataType === dataType)
                result = item;
        });
        return result;
    }

    function setFileData (dataType, val) {
        var result = false;
        angular.forEach(fileData, function(item){
            if(item.dataType === dataType) {
                item.downloadUrl = val;
                result = true;
            }
        });
        return result;
    }

    function formatDates() {
        dataQuery.prompts.each(function(prompt){
            if(prompt.promptType === "Date")
                prompt.defaultValue = Date.create(prompt.defaultValue).formatted(false);
        });
    }

    //postBack can be a function or an array of functions
    function handlePostBack (postBack) {
        if (postBack) {
            if (angular.isArray(postBack)) {
                var func = postBack[0];
                if (angular.isFunction(func)) {
                    if (postBack.length > 1)
                        func(postBack.slice(1));
                    else
                        func();
                }
            }
            else if (angular.isFunction(postBack))
                postBack();
        }
    }

}]);

'use strict';

app.service('batchInsertData', ['$q','$http', function ($q, $http) {
    //PRIVATE VARIABLES
    var self = this;
    var internal = {
        inserts: { beforeCoverPage: [], afterCoverPageBeforeReport: [], afterReport: [] },
        insertLoadPromise: null
    };

    //PUBLIC API
    self.inserts = internal.inserts;

    self.loadInserts = function(inserts) {
        internal.insertLoadPromise = $q.when({status:'pending'})
            .then(function(){
                internal.inserts.beforeCoverPage = inserts.filter({location: "Before cover page"}).sortBy("sequence");
                internal.inserts.afterCoverPageBeforeReport = inserts.filter({location: "After cover page / Before report"}).sortBy("sequence");
                internal.inserts.afterReport = inserts.filter({location: "After report"}).sortBy("sequence");

                return internal.inserts;
            });

        return internal.insertLoadPromise;
    };

    self.updateInserts = function () {
        Object.keys(internal.inserts).each(function(location){
            internal.inserts[location].each(function(insert){
                switch(location) {
                    case "beforeCoverPage":
                        if(insert.location !== "Before cover page") {
                            insert.location = "Before cover page";
                        }
                        break;
                    case "afterCoverPageBeforeReport":
                        if(insert.location !== "After cover page / Before report"){
                            insert.location = "After cover page / Before report";
                        }
                        break;
                    case "afterReport":
                        if(insert.location !== "After report") {
                            insert.location = "After report";
                        }
                        break;
                }
            });
        });
    };

    self.save = function() {
        return self.flattenInserts()
            .then(function(batchInsert){
                return $http.put('/Reporting/Batch/' + self.batchId + "/Inserts", batchInsert, {trackerMsg: 'Saving report batch inserts'});
            });
    };

    self.flattenInserts = function() {
        //ensure the inserts were loaded before flattening so we never return an empty array unless that's what was loaded.
        return internal.insertLoadPromise.then(function(insertStatus){
            var batchInsert = [];
            Object.keys(internal.inserts).each(function(location){
                var index = 0;
                internal.inserts[location].each(function(insert){
                    insert.sequence = index;
                    index++;
                });
            });
            batchInsert.add(internal.inserts.beforeCoverPage);
            batchInsert.add(internal.inserts.afterCoverPageBeforeReport);
            batchInsert.add(internal.inserts.afterReport);
            return batchInsert;
        });
    };
}]);
'use strict';

app.controller('AdvisoryFeeListCtrl', function AdvisoryFeeListCtrl($scope, $http, entities, API_CONFIG) {
    //PRIVATE METHODS
    function init() {
        var loadForUser = function () {
            $scope.entities.selected = {id: $scope.user.authorization.entityId};
            $scope.loadDocuments();
        };

        if (["Administrator", "Advisor"].any($scope.user.authorization.entity)) {
            $scope.entityTypes.show = true;
            $scope.loadEntities();
        } else {
            var entity = entities[entities.find({name: $scope.user.authorization.entity})];
            if ($scope.entityTypes.list.any(entity)) {
                $scope.entityTypes.selected = entity;
                loadForUser();
            }
        }
    }

    function getDocumentsUrl(document) {
        var docEntityId = $scope.entities.selected.id;
        if (document) {
            if (document.representativeId) {
                docEntityId = document.representativeId;
            } else if ( document.brokerDealerId) {
                docEntityId = document.brokerDealerId
            }
        }
        return $scope.entityTypes.selected.simpleUrl.replace("/Simple", "") + "/" + docEntityId + "/Documents";
    }

    //PUBLIC METHODS
    $scope.loadEntities = function () {
        $http.get($scope.entityTypes.selected.simpleUrl, {cache: true, trackerMsg: 'Loading entities'})
            .then(function (response) {
                $scope.entities.list = response.data;

                if ($scope.entities.list.length) {
                    $scope.entities.selected = $scope.entities.list[0];
                    $scope.loadDocuments();
                } else {
                    $scope.entities.selected = null;
                    $scope.documents = [];
                }
            });
    };

    $scope.loadDocuments = function () {
        $http.get(getDocumentsUrl(), {trackerMsg: 'Loading documents'})
            .then(function (response) {
                response.data.forEach(function (document) {
                    document.createdDate = Date.create(document.createdDate);
                });
                $scope.documents = response.data.sortBy('createdDate', true);
            });
    };

    $scope.downloadDocument = function (document) {
        var documentsUrl = document ? getDocumentsUrl(document) : getDocumentsUrl();
        window.location.href = API_CONFIG.baseUrl + documentsUrl + "/" + document.id + '/Download?Authorization=' + sessionStorage.oas_token;
    };


    //INITIALIZE
    $scope.entityTypes = {
        list: [entities.brokerDealer, entities.representative, entities.payee],
        selected: entities.brokerDealer,
        show: false
    };

    $scope.entities = {
        list: null,
        selected: null
    };

    init();
});
'use strict';

app.controller('CloudStorageListCtrl', function ($scope, $http, $dialog, cloudStorageProviders, API_CONFIG) {
    //PRIVATE VARIABLES
    var redirectURL = window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "cloudstorage-credentials.html?provider=";


    // PRIVATE METHODS
    function loadCSProviders() {
        $scope.current.isProvidersLoaded = false;

        for (var key in $scope.cloudProviders) {
            if ($scope.cloudProviders.hasOwnProperty(key)) {
                $scope.cloudProviders[key].isLinked = false;
            }
        }

        $http.get("/Integrations/CloudStorage/List", {cache: true, trackerMsg: 'Loading cloud provider lists'})
            .then(function (response) {
                response.data.forEach(function (cs) {
                    if (cs.provider.toLowerCase() === $scope.cloudProviders.dropBox.name.toLowerCase())
                        $scope.cloudProviders.dropBox.isLinked = true;

                    if (cs.provider.toLowerCase() === $scope.cloudProviders.box.name.toLowerCase())
                        $scope.cloudProviders.box.isLinked = true;

                    if (cs.provider.toLowerCase() === $scope.cloudProviders.egnyte.name.toLowerCase())
                        $scope.cloudProviders.egnyte.isLinked = true;

                    if (cs.provider.toLowerCase() === $scope.cloudProviders.shareFile.name.toLowerCase())
                        $scope.cloudProviders.shareFile.isLinked = true;

                    if (cs.provider.toLowerCase() === $scope.cloudProviders.netDocuments.name.toLowerCase())
                        $scope.cloudProviders.netDocuments.isLinked = true;

                });
                $scope.current.isProvidersLoaded = true;
            });
    }

    function processRedirection(provider) {
        switch (provider) {
            case $scope.cloudProviders.box.name:
                window.location.href = API_CONFIG.baseUrl + "/Integrations/CloudStorage/Box/Redirect?url=" + redirectURL + 'Box&Authorization=' + sessionStorage.oas_token;
                break;
            case $scope.cloudProviders.dropBox.name:
                var dbRedirectUrl
                if(API_CONFIG.baseUrl.includes("cloud") || window.location.host.includes("cloud")){
                    dbRedirectUrl = "https://api.orionadvisor.com/orionconnectapp/cloudstorage-credentials.html?provider="
                }
                else{
                    dbRedirectUrl = redirectURL
                }
                window.location.href = API_CONFIG.baseUrl + "/Integrations/CloudStorage/Dropbox/Redirect?url=" + dbRedirectUrl + 'DropBox&Authorization=' + sessionStorage.oas_token;
                break;
            case $scope.cloudProviders.egnyte.name:
                $dialog.inputBox($scope.cloudProviders.egnyte.name, "Domain")
                    .open()
                    .then(function (rslt) {
                        if (rslt && rslt.trim().length > 0) {
                            window.location.href = API_CONFIG.baseUrl + "/Integrations/CloudStorage/Egnyte/Redirect?url=" + redirectURL + "Egnyte%26dm=" + rslt + "&domain=" + rslt + "&Authorization=" + sessionStorage.oas_token;
                        }
                    });
                break;
            case $scope.cloudProviders.shareFile.name:
                window.location.href = API_CONFIG.baseUrl + "/Integrations/CloudStorage/ShareFile/Redirect?url=" + redirectURL + 'ShareFile&Authorization=' + sessionStorage.oas_token;
                break;
            case $scope.cloudProviders.netDocuments.name:
                window.location.href = API_CONFIG.baseUrl + "/Integrations/CloudStorage/NetDocuments/Redirect?url=" + redirectURL + 'NetDocuments&Authorization=' + sessionStorage.oas_token;
                break;
        }
    }


    //PUBLIC METHODS
    $scope.redirectToCloudProvider = function (provider, isLinked) {
        if (isLinked) {
            $dialog.confirmAction("Are you sure you want to unlink your " + provider + " account?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $http.delete('/Integrations/CloudStorage/' + provider + '/Credentials')
                            .then(function () {
                                loadCSProviders();
                                location.reload();
                            });
                    }
                });
        } else {
            processRedirection(provider);
        }
    };


    //INITIALIZE
    $scope.current = {isProvidersLoaded: false};
    $scope.cloudProviders = cloudStorageProviders;

    loadCSProviders();
});

'use strict';

app.controller('ReportBuilderCtrl', function ReportBuilderCtrl($scope, $http, $q, $dialog, $timeout, $routeParams, $location, $oasRights, entities) {
    //PRIVATE VARIABLES
    var sectionLookup, parameterLookup, reportDefaultsEditor, userDefaultsEditor;


    //PRIVATE METHODS
    function initialLoad() {
        $scope.current.isExecuting = true;
        $http.get('/ReportBuilder/Sections/Parameters', {cache: true, trackerMsg: 'Loading parameter data'})
            .then(function (response) {
                sectionLookup = {};
                parameterLookup = {};
                var keys = Object.keys(response.data);

                for (var i = keys.length - 1; i >= 0; i--) {
                    sectionLookup[keys[i]] = [];
                    response.data[keys[i]].forEach(function(parameter) {
                        sectionLookup[keys[i]].push(parameter.name);
                        if (!parameterLookup.hasOwnProperty(parameter.name)) {
                            parameter.value = parameter.input.indexOf("multi-select") !== -1 ? parameter.value.split(",") : parameter.value;
                            parameterLookup[parameter.name] = parameter;
                        }
                    });
                }

                loadReport();
            });

        $http.get("/Portfolio/Representatives/Simple", {cache: true, trackerMsg: 'Loading representatives'})
            .then(function (response) {
                $scope.reps = response.data;
                $scope.current.selectedRep = response.data[0];
            });

        $http.get("/ReportBuilder/WebMenuOptions", {cache: true, trackerMsg: 'Loading web menu options'})
            .then(function (response) {
                $scope.webMenuOptions = response.data;
            });

        $http.get('/ReportBuilder/Themes/Simple', {cache: true, trackerMsg: 'Loading themes'})
            .then(function (response) {
                $scope.themes = response.data;
            });

        $http.get('/ReportBuilder/Reports/Templates', {cache: true, trackerMsg: 'Loading templates'})
            .then(function (response) {
                $scope.current.templateList = response.data;
            });
    }

    function loadReport() {
        var reportId = $routeParams.reportId;

        if (reportId > 0) {
            $http.get('/ReportBuilder/Reports/' + reportId, {trackerMsg: 'Loading report ' + reportId})
                .then(function (response) {
                    var data = response.data;
                    $scope.addBreadcrumb(data.isVersion ? 'v. ' + data.versionDescription : data.reportName);

                    $scope.current.canSave = data.isCreatedByMe || $oasRights.forCode("EDITALLRPTS").canUpdate;

                    //a little pre-processing
                    if (data.layoutType === 'Standard') { data.householdSections.add(data.sections); data.sections = []; }
                    if (!data.dateDefaults.StartDate) { data.dateDefaults.StartDate = {value: null, sign: "+", modifier: 0}; }
                    if (!data.dateDefaults.EndDate) { data.dateDefaults.EndDate = {value: null, sign: "+", modifier: 0}; }
                    if (!data.dateDefaults.AsOfDate) { data.dateDefaults.AsOfDate = {value: null, sign: "+", modifier: 0}; }
                    if ($routeParams.mode === 'copy') {
                        data.id = 0;
                        data.reportName = (data.isVersion ? '' : 'Copy of ') + data.reportName;
                        data.repAssignments = [];
                        data.clientAssignments = [];
                    }
                    if ($routeParams.mode === 'version') { data.id = 0; data.isVersion = true; data.versionDescription = 'New Version of ' + data.reportName }

                    $scope.report = data;

                    var processSections = function(sections) {
                        sections.forEach(function(section){
                            if (section.displayName === "Manager's Message")
                                section.parameters[3].value = (section.parameters[3].value === 'true');
                        })
                    };

                    processSections($scope.report.householdSections);
                    processSections($scope.report.registrationSections);
                    processSections($scope.report.accountSections);
                    processSections($scope.report.disclaimerSections);

                    loadSectionsForOrientation((data.orientationType === "Landscape"), data.templateType, false);

                    reportDefaultsEditor = buildParameterEditor(data.reportDefaults);
                    $scope.parameterList = reportDefaultsEditor;
                    if (data.userDefaults)
                        userDefaultsEditor = buildParameterEditor(data.userDefaults);

                    var promises = {};
                    promises.repAccessList = $http.post('/Portfolio/Representatives/Simple/List/Id', data.isVersion ? data.repAssignments : data.repUsers, {trackerMsg: 'Building rep access list'});
                    promises.clientAccessList = $http.post('/Portfolio/Clients/Simple/List/Id', data.isVersion ? data.clientAssignments : data.clientUsers, {trackerMsg: 'Building household access list'});

                    return $q.all(promises);
                })
                .then(function(response) {
                    $scope.current.repAccessList = response.repAccessList.data;
                    $scope.current.clientAccessList = response.clientAccessList.data;
                    $scope.current.isExecuting = false;
                });
        }
        else {
            $scope.current.canSave = true;

            $scope.addBreadcrumb("New Report");
            loadSectionsForOrientation(false, "Standard", false);
            $scope.report = {
                id: 0,
                isCreatedByRep: $scope.user.authorization.entity === "Representative",
                reportName: "New Report",
                reportDescription: "Report Description",
                orientationType: "Portrait",
                reportBuilderThemeId: null,
                coverPageId: null,
                layoutType: "Standard",
                templateType: "Standard",
                historicalAccounts: "Performance",
                registrationSort: "None",
                accountSort: "None",
                dateDefaults: {AsOfDate: {value: null, sign: "+", modifier: 0}, StartDate: {value: null, sign: "+", modifier: 0}, EndDate: {value: null, sign: "+", modifier: 0}},
                useIncludeOptionForInception: false,
                sections: [],
                householdSections: [],
                registrationSections: [],
                accountSections: [],
                disclaimerSections: [],
                reportDefaults: null,
                userDefaults: null,
                webLevel: $scope.user.authorization.entity === "Representative" ? "Representative" : "None",
                optionGroupId: null,
                includeUserByDefault: true,
                repUsers: [],
                clientUsers: [],
                repAssignments: [],
                clientAssignments: []
            };
            reportDefaultsEditor = buildParameterEditor({});  //can't just set to new array, because the report-level parameters need to get added
            $scope.parameterList = reportDefaultsEditor;

            $scope.current.isExecuting = false;
        }
    }

    function loadSectionsForOrientation(isLandscape, templateType, clearReport) {
        var orientation = isLandscape ? 'landscape' : 'portrait';

        $http.get('/ReportBuilder/Sections/' + orientation + '/Grouped', {cache: true, trackerMsg: 'Loading ' + orientation + ' report sections'})
            .then(function (response) {
                var fortyFiveDaysAgo = Date.create('45 days ago');
                response.data.forEach(function(group) {
                    var hasNewSections = false;

                    group.reportSections.forEach(function(section) {
                        if (Date.create(section.createdDate).isAfter(fortyFiveDaysAgo)) {
                            section.isNew = true;
                            hasNewSections = true;
                        }

                        if (group.category === "Misc") {
                            if (section.displayName.startsWith("Subreport Header"))
                                section.parameters[1].value = "Period";
                            else if (section.displayName === "Manager's Message")
                                section.parameters[3].value = false;
                        }
                    });

                    group.hasNewSections = hasNewSections;
                });

                $scope.availableSections = response.data;
                if (clearReport) {
                    $scope.report.householdSections = [];
                    $scope.report.registrationSections = [];
                    $scope.report.accountSections = [];
                    $scope.report.disclaimerSections = [];
                    $scope.clearParameterFilter();
                    $scope.clearParameterDefaults('report');
                    $scope.clearParameterDefaults('user');
                }
            });

        $scope.updateCoverPage(isLandscape,templateType);
    }

    function buildParameterEditor(defaults) {
        var editor = [];
        var processSections = function(sectionList) {
            sectionList.forEach(function (section) {
                var sectionParameters = sectionLookup[section.id];

                if (sectionParameters !== undefined) {
                    sectionParameters.forEach(function (parameterName) {
                        var parameter = angular.copy(parameterLookup[parameterName]);  //use a copy otherwise parameterLookup's value could get changed below

                        if (defaults.hasOwnProperty(parameterName))
                            parameter.value = parameter.input.indexOf("multi-select") !== -1 ? defaults[parameterName].split(",") : defaults[parameterName];

                        var index = editor.findIndex({category: parameter.category});
                        if (index === -1)
                            editor.push({ category: parameter.category, parameters: [parameter] });
                        else if (editor[index].parameters.none({ name: parameter.name })) {
                            editor[index].parameters.push(parameter);
                        }
                    });
                }
            });
        };

        processSections([{id: "default"}]);  //force the report-level parameters that get added to every report
        processSections($scope.report.householdSections);
        processSections($scope.report.registrationSections);
        processSections($scope.report.accountSections);
        processSections($scope.report.disclaimerSections);

        return editor;
    }

    function addParametersToEditors(sectionId) {
        var sectionParameters = sectionLookup[sectionId];

        sectionParameters.forEach(function (parameterName) {
            var parameter = parameterLookup[parameterName];

            var index = reportDefaultsEditor.findIndex({ category: parameter.category });
            if (index === -1) {
                reportDefaultsEditor.push({ category: parameter.category, parameters: [angular.copy(parameter)] });
                if (userDefaultsEditor)
                    userDefaultsEditor.push({ category: parameter.category, parameters: [angular.copy(parameter)] });
            }
            else if (reportDefaultsEditor[index].parameters.none({ name: parameter.name })) {
                reportDefaultsEditor[index].parameters.push(angular.copy(parameter));
                if (userDefaultsEditor)
                    userDefaultsEditor[index].parameters.push(angular.copy(parameter));
            }
        });
    }

    function removeParametersFromEditors(sectionId) {
        var parametersToKeep = [];

        //First get a list of the parameters to keep (because they exist in other report sections)
        var processSections = function(sectionList) {
            sectionList.forEach(function (section) {
                parametersToKeep.add(sectionLookup[section.id]);
            });
        };
        processSections([{id: "default"}]);  //ensure the report-level parameters stick around
        processSections($scope.report.householdSections);
        processSections($scope.report.registrationSections);
        processSections($scope.report.accountSections);
        processSections($scope.report.disclaimerSections);
        parametersToKeep.unique();

        //Now find the ones to remove
        var sectionParameters = sectionLookup[sectionId];
        var parametersToRemove = (sectionParameters !== undefined) ? sectionParameters.subtract(parametersToKeep) : [];

        //Now remove them from the editors
        if (parametersToRemove.length > 0) {
            parametersToRemove.forEach(function (parameterName) {
                var index = reportDefaultsEditor.findIndex({ category: parameterLookup[parameterName].category });

                reportDefaultsEditor[index].parameters.remove({name: parameterName});
                if (userDefaultsEditor)
                    userDefaultsEditor[index].parameters.remove({name: parameterName});

                if (reportDefaultsEditor[index].parameters.length === 0) {
                    reportDefaultsEditor.splice(index, 1);
                    if (userDefaultsEditor)
                        userDefaultsEditor.splice(index, 1);
                }
            });
        }
    }

    function buildDefaults(editor) {
        if (!editor) return null;

        var defaults = {};
        editor.forEach(function (group) {
            group.parameters.forEach(function (parameter) {
                defaults[parameter.name] = parameter.input.indexOf("multi-select") !== -1 ? parameter.value.join() : parameter.value;
            });
        });
        return defaults;
    }

    function activeTabReportSections() {
        if ($scope.current.reportTab.household)
            return $scope.report.householdSections;
        else if ($scope.current.reportTab.registration)
            return $scope.report.registrationSections;
        else if ($scope.current.reportTab.account)
            return $scope.report.accountSections;
        else if ($scope.current.reportTab.disclaimer)
            return $scope.report.disclaimerSections;
        else
            return null;
    }


    //PUBLIC METHODS
    $scope.filterSectionCategoriesBySectionName = function(category) {
        if ($scope.current.sectionSearchText === "") return true;

        var search = $scope.current.sectionSearchText.toLowerCase(), sections = category.reportSections;
        return sections.any( function(s) { return s.displayName.toLowerCase().search(search) !== -1; } );
    };

    $scope.filterSectionsByName = function(section) {
        if ($scope.current.sectionSearchText === "") return true;

        return section.displayName.toLowerCase().search($scope.current.sectionSearchText.toLowerCase()) !== -1;
    };

    $scope.filterParamGroupsByParamName = function(group) {
        if (!$scope.current.triggerSection) return true;

        return group.parameters.any( function(p) { return $scope.current.parametersToFilter.any(p.name); } );
    };

    $scope.filterParamsByName = function(parameter) {
        if (!$scope.current.triggerSection) return true;

        return $scope.current.parametersToFilter.any(parameter.name);
    };

    $scope.toggleOrientation = function(isLandscape) {
        if ($scope.report.householdSections.length > 0 || $scope.report.registrationSections.length > 0 || $scope.report.accountSections.length > 0 || $scope.report.disclaimerSections.length > 0) {
            var title = 'Convert to ' + (isLandscape ? 'Landscape' : 'Portrait');
            var msg = 'This action will remove all sections and parameters from the report. Do you want to proceed?';
            var buttons = [{result:'yes', label: 'Yes', cssClass: 'btn-primary'}, {result:'no', label: 'No'}];

            $dialog.messageBox(title, msg, buttons)
                .open()
                .then(function(result){
                    if (result === 'yes') {
                        $scope.report.coverPageId = null;
                        loadSectionsForOrientation(isLandscape, $scope.report.templateType, true);
                    } else {
                        $scope.report.orientationType = isLandscape ? "Portrait" : "Landscape"; //they cancelled, so flip it back
                    }
                });
        } else {
            $scope.report.coverPageId = null;
            loadSectionsForOrientation(isLandscape, $scope.report.templateType, false);
        }
    };

    $scope.updateCoverPage = function(isLandscape, templateType) {
        if(isLandscape)
            isLandscape = ($scope.report.orientationType === "Landscape");
        if(!templateType)
            templateType = $scope.report.templateType;
        var orientation = isLandscape ? 'landscape' : 'portrait';
        $http.get('/ReportBuilder/CoverPages/' + orientation + '?templateType=' + templateType, {cache: true, trackerMsg: 'Loading ' + orientation + ' cover pages'})
            .then(function (response) {
                $scope.coverPages = response.data;
            });
    };

    $scope.checkForCoverPage = function() {
        if(!$scope.report.coverPageId)
            $scope.report.includeBlankPageAfterCover = false;
    };

    $scope.convertToStandardLayout = function () {
        if ($scope.report.registrationSections.length > 0 || $scope.report.accountSections.length > 0 || $scope.report.disclaimerSections.length > 0) {
            var title = 'Convert to Standard Layout';
            var msg = 'This action will remove the Registration, Account, and Disclaimer tabs.  Would you like to merge the sections from those tabs or delete them from the report?';
            var buttons = [{result:'merge', label: 'Merge', cssClass: 'btn-primary'},{result:'delete', label: 'Delete', cssClass: 'btn-danger'}, {result:'cancel', label: 'Cancel'}];

            $dialog.messageBox(title, msg, buttons)
                .open()
                .then(function(result){
                    switch (result) {
                        case "merge":
                            $scope.report.householdSections.add($scope.report.registrationSections);
                            $scope.report.householdSections.add($scope.report.accountSections);
                            $scope.report.householdSections.add($scope.report.disclaimerSections);
                            $scope.report.registrationSections = [];
                            $scope.report.accountSections = [];
                            $scope.report.disclaimerSections = [];
                            $scope.current.reportTab.household = true;
                            break;
                        case "delete":
                            var processSections = function(sectionList) {
                                for (var i = sectionList.length - 1; i >= 0; i--) {
                                    var id = sectionList[i].id;
                                    sectionList.splice(i, 1);
                                    removeParametersFromEditors(id);
                                }
                            };
                            processSections($scope.report.registrationSections);
                            processSections($scope.report.accountSections);
                            processSections($scope.report.disclaimerSections);

                            $scope.clearParameterFilter();
                            $scope.current.reportTab.household = true;
                            break;
                        default:
                            $scope.report.layoutType = 'Advanced'; //they cancelled, so flip it back
                    }
                });
        }
        else
            $scope.current.reportTab.household = true;
    };

    $scope.toggleParameterList = function() {
        if ($scope.current.displayParametersFor === "report") {
            $scope.parameterList = reportDefaultsEditor;
            return;
        }

        if (userDefaultsEditor)
            $scope.parameterList = userDefaultsEditor;
        else {
            var title = 'My Default Parameters';
            var msg = 'You currently do not have any parameters saved for yourself.  Do you want to copy the defaults you have saved for the report or start with the system defaults?';
            var buttons = [{result:'report', label: 'Report', cssClass: 'btn-primary'}, {result:'system', label: 'System', cssClass: 'btn-success'}, {result:'cancel', label: 'Cancel'}];

            $dialog.messageBox(title, msg, buttons)
                .open()
                .then(function(result){
                    switch (result) {
                        case "report":
                            userDefaultsEditor = angular.copy(reportDefaultsEditor);
                            $scope.parameterList = userDefaultsEditor;
                            break;
                        case "system":
                            userDefaultsEditor = buildParameterEditor({});  //using {} to keep the defaulted values as-is
                            $scope.parameterList = userDefaultsEditor;
                            break;
                        default:
                            $scope.current.displayParametersFor = "report";
                    }
                });
        }
    };

    $scope.addSection = function(section) {
        if ($scope.current.isExecuting || !$scope.current.canSave) return;

        var copy = angular.copy(section);
        activeTabReportSections().push(copy);
        addParametersToEditors(section.id);
    };

    $scope.deleteSection = function (index, id) {
        activeTabReportSections().splice(index, 1);
        removeParametersFromEditors(id);

        if (id === $scope.current.triggerSection) $scope.clearParameterFilter();
    };

    $scope.clearParameterDefaults = function(type) {
        type = type || $scope.current.displayParametersFor;

        if (type === 'user') {
            userDefaultsEditor = null;
            $scope.current.displayParametersFor = "report";
        }
        else {
            reportDefaultsEditor = buildParameterEditor({}); //can't just clear out, because the report-level parameters need to stay put
        }

        $scope.parameterList = reportDefaultsEditor;
    };

    $scope.clearParameterFilter = function () {
        $scope.current.triggerSection = null;
        $scope.current.parametersToFilter = [];
    };

    $scope.clearSectionHighlights = function () {
        $scope.current.sectionsToHighlight = [];
        $scope.current.highlightCount.household = null;
        $scope.current.highlightCount.registration = null;
        $scope.current.highlightCount.account = null;
        $scope.current.highlightCount.disclaimer = null;
    };

    $scope.filterParameters = function (sectionId) {
        var tempId = $scope.current.triggerSection;
        $scope.clearParameterFilter();

        if (sectionId === tempId) return; //user just wanted to toggle filter off

        $scope.current.sidebarTab.parameters = true;

        $timeout(function () {  //in Angular 1.3 this stopped updating in the UI w/o timeout
            $scope.current.triggerSection = sectionId;
            $scope.current.parametersToFilter.add(sectionLookup[sectionId]);
        }, 1000);
    };

    $scope.highlightSections = function (parameterName) {
        var processSections = function(sectionList) {
            var count = 0;
            sectionList.forEach(function (section) {
                if (sectionLookup[section.id].any(parameterName) ) {
                    count += 1;
                    if ($scope.current.sectionsToHighlight.none(section.id))
                        $scope.current.sectionsToHighlight.push(section.id);
                }
            });
            return count > 0 ? count : null;
        };

        $scope.current.highlightCount.household = processSections($scope.report.householdSections);
        $scope.current.highlightCount.registration = processSections($scope.report.registrationSections);
        $scope.current.highlightCount.account = processSections($scope.report.accountSections);
        $scope.current.highlightCount.disclaimer = processSections($scope.report.disclaimerSections);
    };

    $scope.addRepToAccessList = function() {
        if ($scope.current.repAccessList.none({id: $scope.current.selectedRep.id})) {
            $scope.current.repAccessList.push($scope.current.selectedRep);
        }
        $scope.current.selectedRep = $scope.reps[0];
    };

    $scope.addClientToAccessList = function() {
        if ($scope.current.clientAccessList.none({id: $scope.current.selectedClient.id})) {
            $scope.current.clientAccessList.push($scope.current.selectedClient);   
        }
        $scope.current.selectedClient = null;
    };

    $scope.saveReport = function(postSaveAction) {
        var report = angular.copy($scope.report);
        
        if (report.layoutType === 'Standard') {
            report.sections.add(report.householdSections);
            report.householdSections = [];
        }

        report.reportDefaults = buildDefaults(reportDefaultsEditor);
        report.userDefaults = buildDefaults(userDefaultsEditor);

        if (report.isVersion) {
            report.repAssignments = $scope.current.repAccessList.map("id");
            report.clientAssignments = $scope.current.clientAccessList.map("id");
        }
        else {
            report.repUsers = $scope.current.repAccessList.map("id");
            report.clientUsers = $scope.current.clientAccessList.map("id");
        }

        var args = report.id > 0 ? {method: "PUT", id: report.id, trackerMsg: "Saving report " + report.id} : {method: "POST", id: "", trackerMsg: "Adding new report"};

        $http({ method: args.method, url: '/ReportBuilder/Reports/' + args.id, data: report, trackerMsg: args.trackerMsg })
            .then(function (response) {
                var crumbName = report.isVersion ? 'v. ' + report.versionDescription : report.reportName;
                if (report.id > 0)
                    $scope.updateBreadcrumb(crumbName); //in case it changed
                else {
                    $scope.deleteBreadcrumb();
                    $scope.addBreadcrumb(crumbName, '/reports/reportbuilder/' + response.data.id);
                    $scope.report.id = response.data.id;  //in case save without closing
                    $scope.report.ownerEntity = response.data.ownerEntity;
                    $scope.report.ownerEntityId = response.data.ownerEntityId;
                }

                if (postSaveAction === 'close')
                    $location.path('/reports/reportbuilder');
                else if (postSaveAction === 'run')
                    $scope.runReport();
            });
    };

    $scope.deleteReport = function() {
        $dialog.confirmAction( "Are you sure you want to delete report <b>" + $scope.report.reportName + "</b>?" )
            .open()
            .then( function( result ) {
                if( result == 'yes' ) {
                    $http.delete('/ReportBuilder/Reports/' + $scope.report.id, {trackerMsg: 'Deleting report ' + $scope.report.id})
                        .then(function () {
                            $scope.deleteBreadcrumb();
                            $location.path('/reports/reportbuilder').replace();
                        });
                }
            } );
    };

    $scope.runReport = function() {
        $dialog.reportPrompt($scope.report.id, {runAssignedVersion: false}).open();
    };

    $scope.importEntityIds = function(entityName) {
        var entity = entities[entityName];

        $dialog.inputBox("Import " + entity.name + " IDs", "File", "file", {postUrl: "/ValidateImport/Echo"})
            .open()
            .then(function(data){
                if (!data) return;
                var ids = Object.values(data[0].result)[0].map(function (x) {
                    return Object.values(x)[0];
                });
                var list;

                switch(entityName){
                    case "representative":
                        list = $scope.current.repAccessList;
                        break;
                    case "client":
                        list = $scope.current.clientAccessList;
                        break;
                }

                if (ids.length > 0) {
                    $http.post(entity.simpleUrl + "/List", ids, {trackerMsg: 'Processing ' + data[0].fileName})
                        .then(function (response) {
                            response.data.forEach(function (item) {
                                if (list.none({id: item.id})) {
                                    list.push({id: item.id, name: item.name, isActive: item.isActive});
                                }
                            });
                        });
                }
            });
    };

    $scope.setChildOptions = function(categoryName, parameter, resetValue) {
        var parameterUrl = "/Reporting/Reports/" + $routeParams.reportId + "/Parameters";
        var childParameter = $scope.parameterList.find({category: categoryName}).parameters.find({name: parameter.childParameter});

        if (childParameter.parentValue === parameter.value) return;

        $http.get(parameterUrl + '/' + parameter.name + '/' + parameter.value + '/ChildOptions', {trackerMsg: 'Loading values for ' + parameter.childParameter})
            .then(function(response) {
                childParameter.parentValue = parameter.value;
                childParameter.options = response.data;

                if (resetValue)
                    childParameter.value = childParameter.input.has("multi-select") ? [] : Object.keys(data)[0];
                else if(childParameter.input.has("multi-select")) {
                    childParameter.value = Object.values(childParameter.options).intersect(childParameter.value);
                }
            });
    };


    //INITIALIZE
    //var testSort;
    $scope.rightSidebar.width = 275;
    $scope.rightSidebar.isOpen = true;
    $scope.current = {isExecuting: false, highlightCount: {household: null, registration: null, account: null, disclaimer: null}, sectionSearchText: "", triggerSection: null, parametersToFilter: [], sectionsToHighlight: [], displayParametersFor: "report", reportTab: {household: true, registration: false, account: false, disclaimer: false}, sidebarTab: {settings: true, sections: false, parameters: false, security: false}, repAccessList: [], clientAccessList: [], templateList: []};
    $scope.sortOptions = {
        handle: '.report-section-handle',
        stop: function (e, ui) {
            var sections;
            if ($scope.report.layoutType == 'Standard' || $scope.current.reportTab.household) {
                sections = $scope.report.householdSections;
            }
            else if ($scope.current.reportTab.registration) {
                sections = $scope.report.registrationSections;
            }
            else if ($scope.current.reportTab.account) {
                sections = $scope.report.accountSections;
            }
            else if ($scope.current.reportTab.disclaimer) {
                sections = $scope.report.disclaimerSections;
            }
            var copyData = {};
            sections.each(function(section){
                if(section.displayName == "Manager's Message" || section.displayName == "Custom Text Box") {
                    var index = sections.findIndex(section);
                    var copy = angular.copy(section);
                    copyData[index] = copy;
                    //sections.remove(section);
                }
            });
            var removeCount = 0;
            Object.keys(copyData).each(function(index){
                sections.removeAt(parseInt(index)-removeCount);
                removeCount++;
            });
            Object.keys(copyData).each(function(index){
                $timeout(function() {
                    sections.add(copyData[index], parseInt(index));
                });
            });
        }
    };
    $scope.dateDefaults = [
        {id: "NOW", name: "Now"},
        {id: "LBD", name: "Last Business Day"},
        {id: "STARTQTD", name: "Start Quarter-To-Date"},
        {id: "STARTYTD", name: "Start Year-To-Date"},
        {id: "STARTLQ", name: "Start Last Quarter"},
        {id: "STARTLM", name: "Start Last Month"},
        {id: "STARTLY", name: "Start Last Year"},
        {id: "ENDQTD", name: "End Quarter-To-Date"},
        {id: "ENDYTD", name: "End Year-To-Date"},
        {id: "ENDLQ", name: "End Last Quarter"},
        {id: "ENDLM", name: "End Last Month"},
        {id: "ENDLY", name: "End Last Year"}
    ];
    initialLoad();


    //DESTROY
    $scope.$on('$destroy', function () {
        delete window.sectionLookup;
        delete window.parameterLookup;
        delete window.reportDefaultsEditor;
        delete window.userDefaultsEditor;
    });
});
'use strict';

app.controller('ReportBuilderListCtrl', function ReportBuilderListCtrl($scope, $http, $dialog, $oasRights, splitIoService) {

    const isLegacyReportCreateEnabledFeatureFlag = 'oc_reporting_legacyreportbuilder_report_creation_clone_201274';

    //PRIVATE METHODS
    function init() {
        splitIoService.getBoolTreatment(isLegacyReportCreateEnabledFeatureFlag).subscribe(isEnabled => {
            $scope.isLegacyReportCreateEnabled = isEnabled;
            $scope.$apply();
        });

        $http.get('/ReportBuilder/Reports/Simple', {trackerMsg: 'Loading reports'})
            .then(function (response) {
                response.data.forEach(function (report) {
                    report.previewIsOpen = false;
                });
                $scope.reports = response.data;
            });
    }


    //PUBLIC METHODS
    $scope.showPreview = function(report) {
        $scope.reports.forEach(function (report) {
            report.previewIsOpen = false;
        });
        report.previewIsOpen = true;
    };

    $scope.runReport = function(reportId) {
        $dialog.reportPrompt(reportId, {runAssignedVersion: false}).open();
    };

    $scope.deleteReport = function(report) {
        $dialog.confirmAction( "Are you sure you want to delete report <b>" + report.reportName + "</b>?" )
            .open()
            .then( function( result ) {
                if( result == 'yes' ) {
                    $http.delete('/ReportBuilder/Reports/' + report.id, {trackerMsg: 'Deleting report ' + report.id})
                        .then(function () {
                            $scope.deleteBreadcrumb(report.isVersion ? 'v. ' +report.versionDescription : report.reportName);
                            $scope.reports.remove({id: report.id});
                        });
                }
            } );
    };


    //INITIALIZE
    $scope.isLegacyReportCreateEnabled = false;
    init();
    $scope.current = {
        canEditAllRpts: $oasRights.forCode("EDITALLRPTS").canUpdate
    };
});

'use strict';

app.controller('ReportingGroupsCtrl', function ReportingGroupsCtrl($scope, $http, $routeParams, $dialog, entities) {
    //PRIVATE METHODS
    function init() {
        $http.get(entities.reportingGroup.simpleUrl, {trackerMsg: 'Loading report groups'})
            .then(function (response) {
                $scope.reportingGroups = response.data;

                if ($routeParams.groupId)
                    $scope.loadGroup($routeParams.groupId);
                else if ($scope.reportingGroups.length)
                    $scope.loadGroup();
                else
                    $scope.newGroup();
            });
    }


    //PUBLIC METHODS
    $scope.loadGroup = function (id) {
        if (id === undefined) {
            if ($scope.reportingGroups.length)
                id = $scope.reportingGroups[0].id;
            else
                return;
        }

        $http.get("/Reporting/ReportGroups/" + id, {trackerMsg: 'Loading report group'})
            .then(function (response) {
                $scope.current.group = response.data;
                $scope.current.selectedGroupId = response.data.id;
            });
    };

    $scope.newGroup = function () {
        $scope.current.group = {id: 0, groupName: "New Group", entities: []};
        $scope.current.selectedGroupId = 0;
    };

    $scope.saveGroup = function () {
        var group = $scope.current.group;
        if((!group.runForEntity || group.runForEntity === "Undefined") && group.entities.length > 0) {
            group.runForEntity = group.entities[0].entity;
        }

        var args = group.id > 0 ? {method: "PUT", id: group.id, trackerMsg: "Saving report group"} : {method: "POST", id: "", trackerMsg: "Adding new report group"};

        $http({ method: args.method, url: "/Reporting/ReportGroups/" + args.id , data: group, trackerMsg: args.trackerMsg })
            .then(function (response) {
                var data = response.data;

                if (group.id > 0) {
                    var groupFromList = $scope.reportingGroups.find({id: group.id});
                    groupFromList.name = data.groupName;
                    groupFromList.count = data.entities.length;
                } else {
                    $scope.reportingGroups.push({id: data.id, name: data.groupName, count: data.entities.length});
                    group.id = data.id;
                    $scope.current.selectedGroupId = data.id;
                }
            });
    };

    $scope.deleteGroup = function () {
        var id = $scope.current.group.id;
        $http.delete("/Reporting/ReportGroups/" + id, {trackerMsg: 'Deleting report group'})
            .then(function () {
                $scope.reportingGroups.remove({id: id});
                $scope.loadGroup();
            });
    };

    $scope.addEntity = function () {
        var entity = $scope.current.entityToAdd.selectedEntity;
        entity.entity = entities[entities.find({value: entity.type})].name;

        if(!$scope.current.group.runForEntity || $scope.current.group.runForEntity === "Undefined") {
            $scope.current.group.runForEntity = $scope.current.group.entities[0] ? $scope.current.group.entities[0].entity : entity.entity;
        }

        if($scope.current.group.runForEntity !== entity.entity) {
            $dialog.actionFailed('One or more group members do not have the same type as the member being added.  Please review, make changes, and try again.').open();
        } else {
            if ($scope.current.group.entities.none({entity: entity.entity, entityId: entity.id})) {
                $scope.current.group.entities.push({entity: entity.entity, entityId: entity.id, name: entity.name});
            }
        }

        if (entity.entity === entities.client.name) {
            $scope.current.entityToAdd.searchEntity = null;
        } else {
            entity.selected = false;
            $scope.current.entityToAdd.items[0].selected = true;
            $scope.current.entityToAdd.selectedEntity = $scope.current.entityToAdd.items[0];
        }
    };

    $scope.importEntityIds = function() {
        var dialogOpts = {
            templateUrl: "reporting-group-import-ids.html",
            controller: "ReportingGroupImportIdsCtrl",
            entity: $scope.current.group.runForEntity
        };
        $dialog.dialog(dialogOpts)
            .open()
            .then(function(rslt){
                if (!rslt) return;

                if(!$scope.current.group.runForEntity || $scope.current.group.runForEntity === "Undefined") {
                    $scope.current.group.runForEntity = $scope.current.group.entities[0] ? $scope.current.group.entities[0].entity : rslt.entity;
                }

                if($scope.current.group.runForEntity !== rslt.entity) {
                    $dialog.actionFailed('One or more group members do not have the same type as the members being imported.  Please review, make changes, and try again.').open();
                }
                else if (rslt.ids.length > 0) {
                    var entity = rslt.entity;
                    var url = entities[entities.find({name: rslt.entity})].simpleUrl + '/List';
                    $http.post(url, rslt.ids, {trackerMsg: 'Processing ' + rslt.fileData[0].fileName})
                        .then(function (response) {
                            response.data.forEach(function (item) {
                                if ($scope.current.group.entities.none({entity: entity, entityId: item.id})) {
                                    $scope.current.group.entities.push({entity: entity, entityId: item.id, name: item.name});
                                }
                            });
                        });
                }
            });
    };

    $scope.removeEntity = function (entity) {
        $scope.current.group.entities.remove(entity);
        if($scope.current.group.entities.length === 0) {
            $scope.current.group.runForEntity = "Undefined";
        }
    };


    //INITIALIZE
    $scope.rightSidebar.width = 275;
    $scope.current = {selectedGroupId: null, group: null, entityToAdd: null};

    init();
});

app.controller('ReportingGroupImportIdsCtrl', function ReportingGroupImportIdsCtrl($scope, dialog){
    //PUBLIC METHODS
    $scope.submit = function() {
        dialog.close($scope.current.inputValue);
    };

    $scope.cancel = function() {
        dialog.close(null);
    };

    //WATCHES
    $scope.$watch('current.inputValue.fileData', function(newValue, oldValue) {
        if (newValue === oldValue || !newValue) return;
        $scope.current.inputValue.ids = Object.values(newValue[0].result)[0].map(function (x) {
            return parseInt(Object.values(x)[0]);
        });
    });

    //INITIALIZE
    $scope.current = {inputValue: { entity: dialog.options.entity, fileData: null, ids: []} };
});
'use strict';

app.controller('ThemeBuilderCtrl', function ThemeBuilderCtrl($scope, $http, $dialog, $routeParams, $location, $timeout) {

    //PRIVATE METHODS
    function loadTheme() {
        var themeId = $routeParams.themeId;

        $http.get('/ReportBuilder/Themes/' + themeId, {trackerMsg: 'Loading theme ' + themeId})
            .then(function (response) {
                $scope.addBreadcrumb(response.data.name);

                //a little pre-processing
                if ($routeParams.mode === 'copy') {
                    response.data.id = 0;
                    response.data.name = 'Copy of ' + response.data.name;
                    response.data.canEdit = true;
                    response.data.isRepEnabled = $scope.user.authorization.entity === "Representative" ? true : response.data.isRepEnabled;
                }

                response.data.reportTitle.showLabels = response.data.reportTitle.showLabels === "true";
                (1).upto(3, function(n) {
                    var grouping = "tableGrouping" + n;
                    response.data[grouping].headerRow.hidden = response.data[grouping].headerRow.hidden === "true";
                    response.data[grouping].footerRow.hidden = response.data[grouping].footerRow.hidden === "true";
                });

                response.data.pieChartStyle = response.data.pieChartStyle || "Concave";

                $scope.current.defaultChartPalette = response.data.defaultChartPalette.map(function(color){
                    return {"value": color};
                });

                $scope.theme = response.data;
                if(!$scope.theme.sectionDetail2)
                    $scope.theme.sectionDetail2 = { style: { backgroundColor: "" } };
                setLogoImage();
                $scope.setLogoAlignment();
            });
    }

    function setLogoImage() {
        var title = $scope.theme.reportTitle;
        $scope.current.reportTitleBackground.backgroundImage = "url('" + (title.logo || title.defaultLogo) + "')";
    }


    //PUBLIC METHODS
    $scope.setLogoAlignment = function() {
        switch ($scope.theme.reportTitle.logoAlign)
        {
            case "left":
                $scope.current.reportTitleBackground.backgroundSize = "216px 120px";
                $scope.current.reportTitleBackground.backgroundPosition = "5% center";
                break;
            case "right":
                $scope.current.reportTitleBackground.backgroundSize = "216px 120px";
                $scope.current.reportTitleBackground.backgroundPosition = "95% center";
                break;
            case "center":
                $scope.current.reportTitleBackground.backgroundSize = "cover";
                delete $scope.current.reportTitleBackground.backgroundPosition;
                break;
        }
    };

    $scope.clearCustomLogo = function() {
        $scope.theme.reportTitle.logo = null;
    };

    $scope.clearFooterImage = function() {
        $scope.theme.footer.image = null;
    };

    $scope.addPaletteColor = function() {
        if($scope.current.defaultChartPalette.none(function(color){ return color.value.toLocaleLowerCase() === $scope.current.newPaletteColor.toLocaleLowerCase(); }))
            $scope.current.defaultChartPalette.unshift({value: $scope.current.newPaletteColor});
        $scope.current.newPaletteColor = null;
    };

    $scope.removePaletteColor = function(index) {
        $scope.current.defaultChartPalette.splice(index, 1);
    };

    $scope.saveTheme = function() {
        var currentPalette = $scope.current.defaultChartPalette.map(function(color){ return color.value; });
        if(!angular.equals($scope.theme.defaultChartPalette, currentPalette))
            $scope.theme.defaultChartPalette = currentPalette;

        var args = $scope.theme.id > 0 ? {method: "PUT", id: $scope.theme.id, trackerMsg: "Saving theme " + $scope.theme.id} : {method: "POST", id: "", trackerMsg: "Adding new theme"};

        $http({ method: args.method, url: '/ReportBuilder/Themes/' + args.id, data: $scope.theme, trackerMsg: args.trackerMsg })
            .then(function (response) {
                if ($scope.theme.id > 0)
                    $scope.updateBreadcrumb($scope.theme.name); //in case it changed
                else {
                    $scope.deleteBreadcrumb();
                    $scope.addBreadcrumb($scope.theme.name, '/reports/themes/' + response.data.id );
                }

                $location.path('/reports/themes');
            });
    };

    $scope.deleteTheme = function() {
        $dialog.confirmAction("Are you sure you want to delete <b>" + $scope.theme.name + "</b>?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete('/ReportBuilder/Themes/' + $scope.theme.id, {trackerMsg: 'Deleting theme ' + $scope.theme.id})
                        .then(function () {
                            $scope.deleteBreadcrumb();
                            $location.path('/reports/themes').replace();
                        });
                }
            });
    };

    $scope.setActivePane = function(tab, accordionPane) {
        $scope.current.tab[tab] = true;

        $timeout(function () {  //in Angular 1.3 this stopped updating in the UI w/o timeout
            $scope.current.pane[tab][accordionPane] = true;
        }, 100);
    };


    //INITIALIZE
    $scope.rightSidebar.width = 275;
    $scope.rightSidebar.isOpen = true;

    $scope.current = {
        reportTitleBackground: {},
        newPaletteColor: null,
        defaultChartPalette: [],
        tab: {page: true, sections: false, groupings: false, charts: false},
        pane: {
                page: {general: true, header: false, reportTitle: false, reportLogo: false, footer: false, footerTimestamp: false, footerImage: false},
                sections: {sectionTitleBar: true, disclaimerText: false, sectionBorder: false, sectionColumnHeader: false, sectionRowHeader: false, sectionDetail: false, sectionDetail2: false},
                groupings: {tableGrouping1headerRow: true, tableGrouping1footerRow: false, tableGrouping2headerRow: false, tableGrouping2footerRow: false, tableGrouping3headerRow: false, tableGrouping3footerRow: false},
                charts: {chart: true, colorPalette: false, pieStyle: false}
            }
    };

    loadTheme();


    //SCOPE WATCHERS
    $scope.$watch("theme.reportTitle.logo", function (newValue, oldValue) {
        if (newValue === oldValue) return;
        setLogoImage();
    });
});
'use strict';

app.controller('ThemeBuilderListCtrl', function ThemeBuilderListCtrl($scope, $http, $dialog) {
    //PRIVATE METHODS
    function loadThemes() {
        $http.get('/ReportBuilder/Themes/Simple', {trackerMsg: 'Loading themes'})
            .then(function (r) {
                $scope.themes = r.data;
            });
    }

    //PUBLIC METHODS
    $scope.deleteTheme = function(theme) {
        $dialog.confirmAction("Are you sure you want to delete <b>" + theme.name + "</b>?")
            .open()
            .then(function (result) {
                if (result === 'yes') {

                    $http.delete('/ReportBuilder/Themes/' + theme.id, {trackerMsg: 'Deleting theme ' + theme.id})
                        .then(function () {
                            $scope.deleteBreadcrumb(theme.name);
                            loadThemes();
                        });

                }
            });
    };

    //INITIALIZE
    loadThemes();
});

'use strict';

app.controller('DataQueryListCtrl', function DataQueryListCtrl($scope, $http, $dialog, $window, $location, $dataQuery, $oasRights) {


    // PRIVATE VARIABLES
    var updateResults = false;
    var fullList, filteredList, filterFn, selectDialog;


    // PRIVATE METHODS
    function init() {
        if (filteredList && fullList && filteredList.length > 0 && fullList.length > 0) return;
        $dataQuery.loadDataQueryPageDefaults()
            .then(function () {
                loadQueryList();
            });
    }

    function download() {
        if ($scope.rightSidebarSettings.selectedDestination.code == 'directDownload') {
            $dataQuery.createFile($scope.rightSidebarSettings.selectedRunTo.code, downloadFile);
        } else {
            $scope.dataQuery.runTo = {storageType: $scope.rightSidebarSettings.selectedDestination.code, reportFormat: $scope.rightSidebarSettings.selectedRunTo.code === 'xlsx' ? 'excel' : $scope.rightSidebarSettings.selectedRunTo.code};
            $dataQuery.sendToInbox();
            $scope.current.messages.push({name: $scope.dataQuery.title});
        }
    }

    function outputToScreen() {
        $location.path('/reports/dataqueries/' + $scope.dataQuery.id);
    }

    function loadQueryList(resetList) {
        $dataQuery.loadDataQueryList(loadSelectedQueries, resetList);
    }

    function finalizeScreen() {
        $scope.dataQuery = $dataQuery.getDataQuery();
        $scope.rightSidebar.isOpen = true;
        updateResults = false;
    }

    function downloadFile(url) {
        $window.location.href = url + "?Authorization=" + sessionStorage.oas_token;
        updateResults = false;
    }

    function loadSelectedQueries() {
        updateSelectedQueries();
        loadDataQuerySelection();
    }

    function updateSelectedQueries() {
        fullList = $dataQuery.getSelectedDataQueryList();
        filteredList = fullList;
        resetPagination();
    }

    function loadDataQuerySelection() {
        $scope.current.selection = fullList;
        var list = $dataQuery.getFullQueryList();
        $scope.current.fullList = list.filter(function (item) {
            return fullList.none(item);
        });
    }

    function buildFilterFn(filterFields) {
        var filterString = "(function(item, value) {return ";
        filterFields.forEach(function (field) {
            filterString += "(item." + field + " && item." + field + ".toString().toLowerCase().indexOf(value) !== -1) || ";
        });
        filterString = filterString.to(filterString.length - 4) + ";})";
        return eval(filterString);
    }

    function resetPagination() {
        $scope.current.totalItems = filteredList.length;
        $scope.setPageItems();
    }


    // PUBLIC METHODS
    $scope.runQuery = function () {
        if ($scope.rightSidebarSettings.selectedRunTo.code == "screen") {
            outputToScreen();
        } else {
            download()
        }
    };

    $scope.loadQuery = function (item) {
        // $location.path( '/reports/dataqueries/' + item.id );
        //$dataQuery.loadQuery(item,finalizeScreen);
    };

    $scope.loadScheduler = function (item) {
        $dialog.dialog({id: item.id, scheduleId: item.scheduleId, templateUrl: "reporting/modals/dataqueryScheduler.html", controller: "DataQuerySchedulerCtrl", dialogClass: "modal wide"})
            .open()
            .then(function (result) {
                if (result) {
                    //Add or Save schedule.
                    var args = result.id > 0 ? {method: "PUT", url: '/Reporting/Custom/Schedules/' + result.id, id: result.scheduleId, trackerMsg: "Saving query schedule: "} : {
                        method: "POST",
                        id: 0,
                        url: '/Reporting/Custom/Schedules/',
                        trackerMsg: "Adding new query schedule"
                    };
                    $http({method: args.method, url: args.url, data: result, trackerMsg: args.trackerMsg})
                        .then(function () {
                            loadQueryList(true);
                        });
                } else {
                    loadQueryList(true);
                }
            });
    };

    $scope.openParameters = function (item) {
        $dialog.dataQueryPrompt(item.id)
            .open()
            .then(function (result) {
                if (result) {
                    $dataQuery.setDataQuery(result);
                    $location.path('/reports/dataqueries/' + item.id);
                }
            });
    };

    $scope.queryUpdate = function () {
        updateResults = true;
    };

    $scope.moveSome = function (selectedItems, from, to) {
        angular.forEach(selectedItems, function (item) {
            var index = from.indexOf(item);
            if (index !== -1) {
                from.splice(index, 1);
                to.push(item);
            }
        });
        selectedItems.length = 0;
    };

    $scope.moveAll = function (from, to, selectedItems) {
        angular.forEach(from, function (item) {
            to.push(item);
        });
        from.length = 0;
        selectedItems.length = 0; //in case they selected some and then did move all
    };

    $scope.filterItems = function () {
        var value = $scope.current.filterValue.toLowerCase();
        filteredList = value ? fullList.filter(function (item) {
            return filterFn(item, value);
        }) : fullList;

        resetPagination();
        $scope.current.page = 1;
    };

    $scope.setPageItems = function (page) {
        page = page || $scope.current.page;

        var begin = (page - 1) * $scope.current.itemsPerPage;
        var end = begin + $scope.current.itemsPerPage;

        $scope.pageItems = filteredList.slice(begin, end);
    };

    $scope.sortItems = function () {
        var field = $scope.current.sort;
        if ($scope.current.sortAsc)
            filteredList.sort(function (a, b) {
                return a[field] > b[field] ? 1 : b[field] > a[field] ? -1 : 0;
            });
        else
            filteredList.sort(function (a, b) {
                return a[field] < b[field] ? 1 : b[field] < a[field] ? -1 : 0;
            });

        $scope.setPageItems();
    };

    $scope.toggleSortAsc = function () {
        $scope.current.sortAsc = !$scope.current.sortAsc;
        $scope.sortItems();
    };

    $scope.showRepId = function (promptItem) {
        return ($scope.user.authorization.entity === "Representative" && (promptItem.code.toLowerCase() === '@repid' || promptItem.code.toLowerCase() === '@repids')); //Rep && '@repid'
    };

    $scope.openSettings = function () {
        $dialog.editor("app/modals/settings/settings.html", "SettingsCtrl", {
            args: function () {
                return {filteredAppCode: 'dataQueries'};
            }
        }).open().then(function (rslt) {
            if (rslt) {
                if (rslt.any(function (n) {
                        return n == "dataQueries"
                    }))
                    $dataQuery.loadDataQueryPageDefaults()
                        .then(function () {
                            loadQueryList();
                        });
            }
        });
    };


    //INITIALIZE
    $scope.rightsDataQueries = $oasRights.forCode("TM_DATAQUERY");

    $scope.runToOptions = [
        {name: "CSV", code: "csv"},
        {name: "Excel", code: "xlsx"},
        {name: "Screen", code: "screen"}
    ];

    $scope.destinationOptions = [
        {name: "Direct Download", code: "directDownload"},
        {name: "Report Inbox", code: "reportInbox"}
    ];

    $scope.rightSidebarSettings = {
        selectedRunTo: $scope.runToOptions[0],
        selectedDestination: $scope.destinationOptions[0]
    };

    $scope.current = {
        listName: 'Queries', template: 'reporting/views/dataquery-item.html', filterValue: null,
        sortFields: {title: "title", reportDescription: "description"}, fullList: [], selection: [],
        sort: 'title', sortAsc: true, page: 1, pageSizes: [10, 50, 100], itemsPerPage: 50, totalItems: 0,
        numPages: 0, selectEnabled: false, multiSelectEnabled: false, listFilter: ['title'], wizardStep: 0,
        animation: 'slide-right', messages: [], notScheduled: true
    };

    $scope.pageItems = [];
    $scope.dataQuery = {};
    $scope.selectFullList = [];
    $scope.selectionItems = [];

    filterFn = angular.isFunction($scope.current.listFilter) ? $scope.current.listFilter : buildFilterFn($scope.current.listFilter);

    init();
});
'use strict';

app.controller('DataQueryList2Ctrl', function DataQueryList2Ctrl( $scope, $rootScope, $http, $oasRights, $dialog, $location, $dataQuery, $timeout, views, $q, userOptionService, $route, OrionQueriesSchedulesModalService ) {
    //PRIVATE VARIABLES
    var rankColumn = {
        conditionType: "basicNumber",
        field: "rank",
        headerCssClass: "id-col",
        cssClass: 'darken right-align',
        id: "Rank",
        name: "Rank",
        sortOrder: 99,
        width: 60,
        visible: true
    };
    var rankSort = {columnId: rankColumn.id, field: rankColumn.field, sortAsc: true};

    //PRIVATE METHODS
    function init(){
        if($scope.rightsConfirmationGroups.canRead) loadConfirmGroups();
        toggleRank();
    }

    function loadConfirmGroups() {
        return $q.all({
            list: $http.get('/Confirm/Groups/Simple', {trackerMsg:'Loading Confirm Groups'}).then(function(response){ return response.data; }),
            selected: $scope.current.confirmGroups.selected || userOptionService.get('query_selected_confirm_group')
        }).then(function(data) {
            return $scope.current.confirmGroups = data;
        });
    }

    function refreshGrid( ) {
        toggleRank();

        $scope.$broadcast('event:dataqueries-action', {action: 'refresh-grid'});
    }

    function getDefaultListIds() {
        return $http.get('/Settings/Apps/dataQueries/Options/dataqueries', {trackerMsg:'Loading favorites for Query'})
            .then(function(results) {
                return results.data;
            });
    }

    function handleScheduleClicked(querySchedule) {
        launchLegacyQueryScheduleDialog(querySchedule.customReportId, querySchedule.id);
    }

    function generateNewScheduleClickedCallback(dataQueryId) {
        return function () {
            handleNewScheduleClicked(dataQueryId);
        }
    }

    function handleNewScheduleClicked(dataQueryId) {
        launchLegacyQueryScheduleDialog(dataQueryId, undefined);
    }

    function handleScheduleDeleteClicked(querySchedule) {
        refreshGrid();
    }

    function launchLegacyQueryScheduleDialog(dataQueryId, scheduleId) {
        $dialog.dialog({id: dataQueryId, scheduleId: scheduleId, templateUrl: "reporting/modals/dataqueryScheduler.html", controller: "DataQuerySchedulerCtrl", dialogClass: "modal wide"})
            .open()
            .then(function (result) {
                if (result) {
                    //Add or Save schedule.
                    var args = result.id > 0 ? {method: "PUT", url: '/Reporting/Custom/Schedules/' + result.id, id: result.scheduleId, trackerMsg: "Saving query schedule: "} : {
                        method: "POST",
                        id: 0,
                        url: '/Reporting/Custom/Schedules/',
                        trackerMsg: "Adding new query schedule"
                    };
                    $http({method: args.method, url: args.url, data: result, trackerMsg: args.trackerMsg})
                        .then(function (response) {
                            $scope.$broadcast('event:dataqueries-action', {action: 'refresh-grid'});
                            $scope.selectedScheduleIds[0] = response.data.id;
                        });
                } else {
                    $scope.$broadcast('event:dataqueries-action', {action: 'refresh-grid'});
                }
            });
    }

    //PUBLIC METHODS
    $scope.exportToExcel = function() {
        $scope.$broadcast('event:dataqueries-action', {action: 'export-data'});
    };

    $scope.openEditor = function(mode) {
        if (!$scope.rightsDataQueryAdmin.canRead && !$scope.rightsDataQueryAdmin.canUpdate) return;
        if ((mode === 'new' || mode === 'copy') && !$scope.rightsDataQueryAdmin.canAdd) return;
        var d = $dialog.editor("reporting/editors/views/dataquery-edit.html", "DataQueryEditCtrl", {args: function() { return {
            id: mode === 'new' ? null : $scope.selectedIds[0],
            isNew: mode === 'new' || mode === 'copy',
            isCopy: mode === 'copy',
            defaultTab: {name: "General", active: true, code: "dataQueryGeneral"}
        }; }});

        d.open().then(function(rslt) {
            if( rslt ) {
                if(rslt.isSaved || rslt === "delete") {
                    $scope.$broadcast('event:dataqueries-action', {action: 'refresh-grid'});
                }
            }
        });
    };

    $scope.deleteQuery = function() {
        $dialog.confirmAction("Are you sure you want to delete this data query?")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $http.delete('/Reporting/Custom/Verbose/' + $scope.selectedIds[0], {trackerMsg: 'Deleting data query'})
                        .then(function () {
                            $scope.$broadcast('event:dataqueries-action', {action: 'refresh-grid'});
                        });
                }
            });
    };

    $scope.editDescription = function() {
        if (!$scope.rightsDataQueryEditDescr.canUpdate) return;
        $dialog.dialog({id: $scope.selectedIds[0], templateUrl: "dataquery-edit-description.html", controller: "DataQueryEditDescriptionCtrl"})
            .open().then(function(rslt) {
                if (rslt) {
                    $http.put('/Reporting/Custom/' + $scope.selectedIds[0] + '/Description', JSON.stringify(rslt), { trackerMsg: 'Updating data query description.' })
                        .then(function(response){
                            if(response.data)
                                $scope.$broadcast('event:dataqueries-action', {action: 'update-item', item: response.data });
                        });
                }
            });
    };

    $scope.openParameters = function () {
        var dataQueryId = $scope.selectedIds[0],
            confirmGroupExt = $scope.current.selectedOption.name === 'Confirm Group' ? '/ConfirmGroup/'+ $scope.current.confirmGroups.selected : '';
        $http.get('/Reporting/Custom/' + dataQueryId + confirmGroupExt, {trackerMsg: 'Loading parameters'}).then(function(response){
            $dialog.dataQueryPrompt(response.data)
                .open()
                .then(function (result) {
                    if (result && result.id) {
                        $dataQuery.setDataQuery(result);
                        $location.path('/reports/dataqueries/' + dataQueryId);
                    }
                    else if(result.outputType.toLocaleLowerCase() === 'xlsx')
                    {
                        $timeout(() => {
                            $dialog.dialog({templateUrl: "dataquery-inbox-notification.html", controller: "DataQueryInboxNotificationCtrl", dialogClass: "opl modal"})
                            .open()
                            .then(function(rslt) {
                                if (rslt) $location.path(rslt);
                            });
                        }, 0);
                    }
                });
        });

    };

    $scope.loadScheduler = function () {
        var dataQueryId = $scope.selectedIds[0];

        OrionQueriesSchedulesModalService.open(dataQueryId, false, handleScheduleClicked, generateNewScheduleClickedCallback(dataQueryId), handleScheduleDeleteClicked);
    };

    $scope.addToDefaultList = function() {
        getDefaultListIds()
            .then(function(data){
                var option = data;
                var ids = data.value.split(',').add($scope.selectedIds).unique();
                option.value = ids.join(',');
                return $http.put('/Settings/Apps/dataQueries/Options/dataqueries', option, {trackerMsg:'Loading favorites for Query'});
            })
            .then(function(response){
                $timeout(function() {refreshGrid();});
            });
    };

    $scope.removeFromDefaultList = function() {
        getDefaultListIds()
            .then(function(data){
                var option = data;
                var ids = data.value.split(',');
                $scope.selectedIds.each(function(id){
                    if(ids.some(id.toString())){
                        ids.remove(id.toString());
                    }
                });
                option.value = ids.join(',');
                return $http.put('/Settings/Apps/dataQueries/Options/dataqueries', option, {trackerMsg:'Loading favorites for Query'});
            })
            .then(function(response){
                $timeout(function() {refreshGrid();});
            });
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openParameters();
    };

    //EVENT LISTENERS
    $scope.$on('event:dataqueries-select', function (e, args) {
        e.stopPropagation();
        $scope.selectedIds = args.map("id");
        $scope.selectedScheduleIds = args.map("scheduleId");
        $scope.current.favorites = args.map(function(a){ return {id: a.id, isFavorite: a.isFavorite}; });
        $scope.isCustomItems = args.map("isCustom");
    });

    $scope.updateSelectedConfirmGroup = function() {
        userOptionService.save('query_selected_confirm_group', $scope.current.confirmGroups.selected);
    };

    //WATCHES
    $scope.$watch("current.selectedOption", function(newValue, oldValue){
        if (newValue === oldValue) return;
        $timeout(function() {refreshGrid();});
    }, true);

    function toggleRank() {
        var state = state == null ? $scope.current.selectedOption.name === "Confirm Group" : state;
        views.each(function(view){
            var colIndex = view.slickGridColumnDefs.indexOf(rankColumn);
            var sortIndex = view.slickGridColumnDefs.indexOf(rankColumn);
            if(state) {
                if(!~colIndex) view.slickGridColumnDefs.unshift(rankColumn);
                if(!~sortIndex) view.sorts.push(rankSort);
            } else {
                if(~colIndex) view.slickGridColumnDefs.splice(colIndex, 1);
                if(~sortIndex) view.sorts.splice(sortIndex, 1);
            }
        });
    }


    //INITIALIZE
    $scope.rightsDataQueryApp = $oasRights.forCode("TM_DATAQUERY");
    $scope.rightsDataQueryAdmin = $oasRights.forCode("DATAQUERY_ADMIN");
    $scope.rightsDataQueryFtp = $oasRights.forCode("DATAQUERYFTP");
    $scope.rightsDataQueryEditDescr = $oasRights.forCode("DATAQUERY_EDITDESCR");
    $scope.rightsConfirmationGroups = $oasRights.forCode("CONFIRMGROUPS");
    $scope.views = views;

    $scope.selectedIds = [];
    $scope.filterOptions = [
        {name: "Favorites List", show: true, url: "/Reporting/Custom/Simple/DefaultQueryList", parameters: "$orderby=Name"},
        {name: "Custom Queries", show: true, url:"/Reporting/Custom/Simple", parameters: "reportType=Query&isGlobal=false&$orderby=Name"},
        {name: "All Queries", show: true, url:"/Reporting/Custom/Simple", parameters: "reportType=Query&$orderby=Name"},
        {name: "Confirm Group", show: $scope.rightsConfirmationGroups.canRead === true, get url() { return "/Reporting/Custom/Simple/ConfirmGroup/" + ($scope.current.confirmGroups.selected||0); }, parameters: ""}
    ];

    $scope.current = {
        confirmGroups: {
            selected: parseInt($route.current.params.confirmGroupId) || 0
        },
        view : views[0],
        selectedOption: $scope.filterOptions.find(function(o) { return o.name.replace(/ /g, '').toLowerCase() === String($route.current.params.list).replace(/ /g, '').toLowerCase(); }) || $scope.filterOptions[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        favorites: []
    };

    $scope.current.hotKeyActions = [
        { combo:'ALT+R', command: function(){
            if($scope.selectedIds.length === 1)
                $scope.openParameters();
        }},
        { combo:'ALT+E', command: function(){
            if($scope.selectedIds.length === 1 && $scope.rightsDataQueryAdmin.canUpdate)
                $scope.openEditor('edit');
        }},
        { combo:'ALT+C', command: function(){
            if($scope.selectedIds.length === 1 && $scope.rightsDataQueryAdmin.canAdd)
                $scope.openEditor('copy');
        }},
        { combo:'ALT+D', command: function(){
            if($scope.selectedIds.length === 1 && $scope.rightsDataQueryAdmin.canDelete)
                $scope.deleteQuery();
        }}];
    init();
});

app.controller("DataQueryEditDescriptionCtrl", function DataQueryEditDescriptionCtrl($scope, $http, dialog){
    function init() {
        $http.get('/Reporting/Custom/' + dialog.options.id, { trackerMsg: 'Loading data query' })
            .then(function(response){
                if(response && response.data) {
                    $scope.dataQuery = response.data;
                }
            });
    }

    $scope.submit = function() {
        dialog.close($scope.dataQuery.description);
    };

    $scope.cancel = function() {
        dialog.close();
    };

    $scope.current = {};
    $scope.dataQuery = {};
    init();
});

app.controller("DataQueryInboxNotificationCtrl", function DataQueryInboxNotificationCtrl($scope, $http, dialog){
    function init() {}

    $scope.closeInboxNotification = function() {
        dialog.close();
    };

    $scope.goToInbox = function() {
        dialog.close('/reports/inbox');
    };

    init();
});

'use strict';

var dataQueryCtrl = app.controller('DataQueryCtrl', function DataQueryCtrl($scope, $http, $route, $dialog, $portfolio, $dataQuery, $location, config, entities, $oasRights, $q, tokenFactory) {
    //PRIVATE VARIABLES
    var dataQuery;
    var guidMatch = /^(\{{0,1}([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}\}{0,1})$/;
    // PRIVATE METHODS
    function init() {
        resolveQuery().then(function(query){
            dataQuery = (query.config && query.config.data) ? query.config.data : query;
            //dataQuery = query;
            $scope.current.dataQueryId = dataQuery.id;
            $scope.current.dataQueryTitle = dataQuery.title || dataQuery.name;
            $scope.current.isNoteEnabled = !!dataQuery.isNoteEnabled;
            var isNew = guidMatch.test($scope.current.dataQueryId);
            $scope.current.breadcrumb.name = !isNew ? 'Orion Queries' : 'Query Builder';
            $scope.current.breadcrumb.route = !isNew ? '/reports/dataqueries/' : '/reports/dataqueries/querybuilder/';
            $scope.addBreadcrumb(dataQuery.title || dataQuery.name, $scope.current.breadcrumb.route + dataQuery.id);
            //Adding query builder to same screens as data queries caused breadcrumb routing issues.
            //TODO: work on fixing breadcrumb routing issues

            return resolveViews().then(resolveCustomReportViews).then(function(){
                $scope.views = config.views;
                $scope.current.view = config.views[0];
                $scope.current.dataQueryCacheKey = config.views[0].dataQueryCacheKey;
                var baseRoute = !isNew ? 'Custom/' : 'Envision/ExcelReports/';
                $scope.current.url = '/Reporting/' + baseRoute + $scope.current.dataQueryId + '/Generate/SlickGrid/' + $scope.current.dataQueryCacheKey;
                $dataQuery.setDataQuery(config);
                if ($scope.current.view.databaseString != null && $scope.current.view.databaseString.length > 1) {
                    var databases = JSON.parse($scope.current.view.databaseString);
                    $scope.current.databasesLookup = Object.assign({}, ...databases.map((x) => ({ [x.DatabaseName]: x.Id })));
                }
            });
        });
    }

    function resolveQuery() {
        return $q.resolve(
            config ||
            $http.get('/Reporting/Custom/' + $route.current.params.id, {trackerMsg: 'Loading parameters'})
                .then(function(response){
                    return config = response.data;
                })
        );
    }

    function resolveViews() {
        var dqId = $scope.current.dataQueryId || config.id || config.config.data.id;
        var payload = (config.config && config.config.data) ? config.config.data : config;
        if(payload.runTo?.storageType && payload.runTo.storageType.toLocaleLowerCase() === "reportinbox") {
            payload.runTo.storageType = "DirectDownload";
        }
        var isNew = guidMatch.test(dqId);
        var baseRoute = !isNew? 'Custom/' : 'Envision/ExcelReports/';
        return $q.resolve(
            (config && config.views) ||
            $http.post('/Reporting/' + baseRoute + dqId + '/Generate/SlickGrid', payload, {trackerMsg: 'Loading data query'})
                .then(function(response){return config.views = [response.data]; })
        );
    }

    function resolveCustomReportViews() {
        return $q.resolve(
            (config && config.views && config.views.length > 1) ||
            $http.get('/Settings/Views/' + config.views[0].pageCode, {trackerMsg: 'Loading custom report views'})
                .then(function (response) {
                    return config.views.push(...response.data);
                })
        );
    }

    function redirectUrl(path, token, openEditor = false) {
        
        if (openEditor) {
            path = path + '&openEditor=true';
        }
        return window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html?p=" + encodeURIComponent(path) + "&t=" + token;
    }

    function doViewsMatch() {
        var standardView = $scope.views[0];
        var currentView = $scope.current.view;
        if (!standardView || !currentView) return true;

        return (currentView.slickGridColumnDefs.every((currentViewCol) => {
            return standardView.slickGridColumnDefs.some((standardViewCol) => {
                return currentViewCol.id === standardViewCol.id;
            });
        }));
    };

    //PUBLIC METHODS
    $scope.goTo = function (entityEnum, entityId) {
        var entity = entities[entityEnum];
        $portfolio.goTo(entity.urlFrag, entity.value, entityId);
    };

    $scope.getPortfolioRoute = function (entityEnum, entityId, openEditor = false) {
        var entity = entities[entityEnum];
        if ($scope.current.token == null) {
            if (openEditor) {
                return "#" + $portfolio.getGoToRoute(entity.urlFrag, entity.value, entityId) + '&openEditor=true';
            } else {
                return "#" + $portfolio.getGoToRoute(entity.urlFrag, entity.value, entityId);
            }
        }
        
        return redirectUrl($portfolio.getGoToRoute(entity.urlFrag, entity.value, entityId), $scope.current.token, openEditor);
    };

    $scope.openEditor = function (entityEnum, entityId) {
        $portfolio.openEditor(entities[entityEnum].value, [entityId]);
    };

    $scope.goToHouseholdOverview = function () {
        var entityValue;
        var id;
        if ($scope.current.accountId) {
            id = $scope.current.accountId;
            entityValue = entities.account.value;
        }
        if ($scope.current.registrationId) {
            id = $scope.current.registrationId;
            entityValue = entities.registration.value;
        }
        if ($scope.current.clientId) {
            id = $scope.current.clientId;
            entityValue = entities.client.value;
        }
        $location.url('/portfolio/household/overview?entity=' + parseInt(entityValue) + '&entityId=' + id);
    };

    $scope.startOver = function () {
        $dialog.dataQueryPrompt(dataQuery)
            .open()
            .then(function (result) {
                if (result) {
                    var config = result.config ? result.config.data : result;
                    $dataQuery.setDataQuery(config);
                    //this is a (interesting) way to use $location and fake to think the url has changed.  Needed to reload grid.
                    $location.url('/reports/dataqueries/' + $route.current.params.id + "?x=" + Date.create().getMilliseconds());
                }
            });
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:dataquery-export-action', {action: 'export-data'});
    };

    $scope.addNote = function () {
        return $dialog.inputBox('Create Note', "Note", "textarea")
            .open()
            .then(function(rslt) {
                if (rslt && rslt.trim().length > 0) {
                    return $http({
                        method: 'POST',
                        url: '/Reporting/Custom/Notes',
                        data: {
                            "customReportId": config.id,
                            "alClientId": (
                                $scope.selected.alClientId ||
                                $scope.selected.alClientID ||
                                $scope.selected.fkAlClient ||
                                $scope.user.authorization.alClientId
                            ),
                            "note": rslt,
                            "rowData": $scope.selected
                        },
                        trackerMsg: 'adding note'
                    });
                }
            });
    };

    // EVENT LISTENERS
    $scope.$on('event:dataquery-select', function (e, args) {
        if (args.length === 0) return;
        $scope.selectedItems = args;

        

        var propertyMap = {
            clientId: ["pkclient", "fkclient", "householdid"],
            registrationId: ["regid", "pkreg", "fkreg"],
            accountId: ["acctid", "pkaccount", "fkaccount"],
            assetId: ["pkasset", "fkasset"],
            transactionId: ["transid", "tranid", "pktransaction", "fktransaction"]
        };

        Object.each(args[0], function (key, value) {
            var searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
                if (searchProperty === 'databasename' && $scope.current.databasesLookup != null) {
                    if ($scope.current.selectedAlClientID !== $scope.current.databasesLookup[value]) {
                        $scope.current.selectedAlClientID = $scope.current.databasesLookup[value];
                        tokenFactory.getDatabaseToken($scope.current.selectedAlClientID).then(function (token) {
                            $scope.current.token = token;
                        });
                        $scope.current.databaseName = value;
                    }
                }
            });
        });
    });

    $scope.$watch('current.view', function() {
        $scope.currentViewMatches = doViewsMatch();
    });

    // INITIALIZE
    $scope.rightsDataQueries = $oasRights.forCode("TM_DATAQUERY");
    $scope.rightsHH = $oasRights.forCode("CLIENTS");
    $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
    $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
    $scope.rightsAst = $oasRights.forCode("ASSETS");
    $scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");
    $scope.rightsHouseholdOverview = $oasRights.forCode("HOUSEHOLDOVERVIEW");
    $scope.rightsPortfolioAudit = $oasRights.forCode("PORTFOLIOLISTSAPP");
    $scope.rightsConfirmGroups = $oasRights.forCode("CONFIRMGROUPS");

    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: {get: function() {return $scope.selectedItems.map('id')}},
        selected: {get: function() {return $scope.selectedItems[0] || undefined;}}
    });

    $scope.views = config ? config.views : null;
    $scope.current = {url: '', view: null, dataQueryCacheKey: null, dataQueryId: 0, dataQueryTitle: '', dataQueryEntity: config ? config.entity : null, breadcrumb: {name: '', route: ''}};
    $scope.currentViewMatches = true;

    init();
});


dataQueryCtrl.loadDataQueryConfig = ["$dialog", "$q", "$route", "$dataQuery", "$http", "dataQuerySvc", function ($dialog, $q, $route, $dataQuery, $http, dataQuerySvc) {
    let existingConfig;
    const queryId = $route.current.params.id;
    existingConfig = dataQuerySvc.getDataQuery(Number(queryId));
    if (existingConfig){
        $dataQuery.setDataQuery(existingConfig);
        dataQuerySvc.removeDataQuery(Number(queryId));
    }
    else{
        existingConfig = $dataQuery.getDataQuery(queryId);
    }

    const dqCacheKey = 'oas_data_query_view';

    return $q.resolve(existingConfig)
        .then(function(config){
            if (!config) {
                return $http.get("/Settings/UserOptions/" + dqCacheKey, {trackerMsg: 'Loading settings', headers: {Unmasquerade: "true"}})
                    .then(result => {
                        if (result?.data?.id > 0) {
                            $http.delete("/Settings/UserOptions/" + dqCacheKey, {headers: {Unmasquerade: "true"}}).then();
                            const dqCached = JSON.parse(result.data.value);
                            if (parseInt(dqCached?.id) === parseInt(queryId)) {
                                return dqCached;
                            }
                        }

                        return null;
                    });
            }

            return config;
        })
        .then(function(config){ return config || $dialog.dataQueryPrompt($route.current.params.id).open(); })
        .then(function(config){
            return !config ? $q.reject() : config;
        });
}];


'use strict';

app.controller( 'DataQueryEntityExclusionListCtrl', function ( $scope, $http, $oasRights, views, $dialog ) {


    $scope.rightsConfirmationOverview = $oasRights.forCode( "CONFIRMOVERVIEW" );

    //PUBLIC METHODS
    $scope.openEditor = function( isNew ) {
        var dialogOpts = {
            templateUrl: "reporting/modals/dataQueryEntityExclusionEdit.html",
            controller: "DataQueryEntityExclusionEditCtrl",
            isNew: isNew,
            id: isNew ? 0 : $scope.selectedIds[0]
        };

        $dialog.dialog( dialogOpts )
            .open()
            .then(function( result ){
                if( result ) {
                    $scope.$broadcast( 'event:dataquery-exclusion-action', {action: isNew ? 'add-item' : 'update-item', item: result } );
                }
            });
    };

    $scope.slickGridDoubleClick = function( ) {
        if( $scope.selectedIds.length === 1 ) {
            $scope.openEditor( false );
        }
    };

    // $scope.deleteExclusion = function( ) {
    //     $dialog.confirmAction( "Are you sure you want to remove the exclusion?" )
    //         .open()
    //         .then( function( result ) {
    //             if( result === 'yes' ) {
    //                 $scope.planRepresentatives.remove(rep);
    //             }
    //         } );
    // };


    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        gridDoubleClick: $scope.slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor( false );
    }}];

});

'use strict';

app.controller('MenuCtrl', function MenuCtrl( $scope, $http, $routeParams, $dialog, $oasRights, entities ) {

    //PUBLIC METHODS
    $scope.runReport = function(reportId) {
        var reportArgs = $routeParams.EntityEnum ? { EntityEnum: $routeParams.EntityEnum, PkEntity: $routeParams.PkEntity } : {};
        $dialog.reportPrompt(reportId, reportArgs).open();
    };

    $scope.openReportDefaults = function(reportId) {
        $dialog.dialog({templateUrl: "reporting/modals/report-defaults.html", controller: "ReportDefaultsCtrl", resolve: { reportId: function() { return reportId; } } }).open();
    };


    //PRIVATE METHODS
    function initialize () {
        $scope.canEditDefaults = $oasRights.canUpdate("STNDRDRPTSECURITYBTN");

        if($routeParams.EntityEnum) {
            switch(parseInt($routeParams.EntityEnum)) {
                case entities.client.value:
                    getClient();
                    break;
                case entities.registration.value:
                    getRegistration();
                    break;
                case entities.account.value:
                    getAccount();
                    break;
            }
        }
        $http.get('/Reporting/Reports?orionConnectMenu=true&type=ssrs', { cache: true, trackerMsg: 'Loading report menu' })
            .then(function (response) {
                if (!$routeParams.EntityEnum || !(parseInt($routeParams.EntityEnum) >= entities.client.value && parseInt($routeParams.EntityEnum) <= entities.account.value)) {
                    $scope.current.advisorRpts.data = processData(response.data, 'Advisor');
                    loadCategories($scope.current.advisorRpts);
                    $scope.current.tradingRpts.data = processData(response.data, 'Trading');
                    loadCategories($scope.current.tradingRpts);
                    $scope.current.billingRpts.data = processData(response.data, 'Billing');
                    loadCategories($scope.current.billingRpts);
                    $scope.current.limitView = false;
                }
                $scope.current.portfolioRpts.data = processData(response.data.filter(function (rpt) {
                        return rpt.category.trim() === 'Custom Reports' || rpt.category.trim() === 'Standard Reports'
                }), 'Portfolio');

                loadCategories($scope.current.portfolioRpts);
                $scope.current.recentRpts = response.data.filter(function(rpt) { return rpt.lastRunDate != null; }).sortBy('lastRunDate', true).first(6);
            });
    }

    function getClient() {
        $http.get('/Portfolio/Clients/' + $routeParams.PkEntity)
            .then(function (response){
                $scope.current.breadCrumb = response.data.firstName + ' ' + response.data.lastName;
            });
    }

    function getRegistration() {
        $http.get('/Portfolio/Registrations/' + $routeParams.PkEntity)
            .then(function (response){
                $scope.current.breadCrumb = response.data.name;
            });
    }

    function getAccount() {
        $http.get('/Portfolio/Accounts/' + $routeParams.PkEntity)
            .then(function (response){
                $scope.current.breadCrumb = response.data.number;
            });
    }

    function processData(reports, parentCategory) {
        var results = reports.filter(function(rpt) { return rpt.parentCategory.trim() === parentCategory.trim(); });
        results.forEach(function(item) {
            item.category = item.category.trim();
        });
        return results.groupBy('category');
    }

    function loadCategories(rpt) {
        for(var category in rpt.data) {
            rpt.categories.push(category);
        }
        rpt.categories = rpt.categories.sortBy();
    }

    //INITIALIZE
    $scope.current = { limitView: true, advisorRpts: { data: [], categories: [] }, portfolioRpts: { data: [], categories: [] }, tradingRpts: { data: [], categories: [] }, billingRpts: { data: [], categories: [] }, recentRpts: [], breadCrumb: 'Report Menu' };

    initialize();
});

'use strict';

app.controller('AttributionDetailListCtrl', function AttributionDetailListCtrl( $scope, $oasRights ) {
    //PRIVATE VARIABLES

    //PRIVATE METHODS
    function init(){
    }

    //PUBLIC METHODS

    //EVENT LISTENERS

    //WATCHES

    //INITIALIZE
    $scope.rights = $oasRights.forCode("INDEXBLEND");
    init();
});
'use strict';

app.controller('AttributionDetailCtrl', function AttributionDetailCtrl( $scope, $oasRights ) {
    $scope.current = {
        detail: null,
        updateValue: null
    };
    //PRIVATE VARIABLES

    //PRIVATE METHODS
    function init(){
    }

    //PUBLIC METHODS

    $scope.save = function(closeScreen){
        $scope.current.updateValue = "save|" + closeScreen + "|" + Date.create().getMilliseconds();
    };
    $scope.delete = function(){
        $scope.current.updateValue = "delete|" + Date.create().getMilliseconds();
    };

    //EVENT LISTENERS

    //WATCHES
    $scope.$watch('current.detail', function (newValue, oldValue) {
        if (!newValue || newValue === oldValue) return;
        if(!oldValue) {
            $scope.addBreadcrumb(newValue.name, '/portfolio/attributiondetail/' + newValue.id);
        }
    });

    //INITIALIZE
    $scope.rights = $oasRights.forCode("INDEXBLEND");
    init();
});
'use strict';

app.controller('AttributionAssignmentCtrl', function AttributionAssignmentCtrl($scope, $oasRights) {
    $scope.current = {
        detail: null,
        actionValue: null
    };

    $scope.save = function () {
        $scope.current.actionValue = "save|" + Date.create().getMilliseconds();;
    };

    $scope.rights = $oasRights.forCode("INDEXBLEND");
});
'use strict';

app.service('$performanceOptions', ['$http', function($http) {
    var self = this;

    self.getPerformanceDefaults = function () {
       return $http.get('/Reporting/Calculate/Verbose/New', {trackerMsg:'Loading performance options defaults'})
            .then(function(response){
                return response.data;
            });
    };

    self.getPerformanceData = function( performanceInstruction ) {
        return $http.post('/Reporting/Calculate/Verbose', performanceInstruction, {trackerMsg: 'Loading performance'}).then(function( r ) {
            return r;
        });
    };

    self.getPerformanceDataNew = function( performanceInstructionNew ) {
        return $http.post('/Reporting/Scope', performanceInstructionNew, {trackerMsg: 'Calculating performance...'})
            .then(function( r ) {
                return r;
            });
    };
}]);
'use strict';

app.controller('PerformanceCompareCtrl', function PerformanceCompareCtrl($scope, $http, $oasRights, $dialog, views) {
    //PRIVATE VARIABLES

    //PRIVATE METHODS
    function init() {

    }

    //PUBLIC METHODS
    $scope.exportToExcel = function() {
        $scope.$broadcast('event:performance-compare-action', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            location.href = '#/reports/performancecomparison/' + $scope.selectedIds[0];
    };

    $scope.delete = function() {
        $dialog.confirmAction("Are you sure you want to delete this comparison?")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $http.delete('/Performance/Compare/' + $scope.selectedIds[0], {trackerMsg: 'Deleting comparison'})
                        .then(function() {
                            $scope.$broadcast('event:performance-compare-action', {action: 'refresh-grid'});
                        });
                }
            });
    };

    //EVENT LISTENERS
    $scope.$on('event:performance-compare-select', function (e, args) {
        e.stopPropagation();

        $scope.selectedIds = args.map("id");
        $scope.status.canDelete = args.every(function(a){ return !a.isLockedDown; }) && $scope.rightsPerfomanceCompare.canDelete;
    });

    //INITIALIZE
    $scope.rightsPerfomanceCompare = $oasRights.forCode("PERFCOMPARE");
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.status = { canDelete: false };
    $scope.current = { view : views[0], gridDoubleClick: $scope.slickGridDoubleClick };

    init();
});
'use strict';

var performanceCompareDetailsCtrl = app.controller('PerformanceCompareDetailsCtrl', function PerformanceCompareDetailsCtrl($scope, $http, $oasRights, $routeParams, $dialog, $timeout, $portfolio, $signalRManager, views, entities) {
    //PRIVATE VARIABLES
    var compareDetails = [], itemsToUpdate = [], onRouteChangeOff, canSubscribe = true;

    //PRIVATE METHODS
    function init() {
        initSignalR();
        $http.get('/Performance/Compare/' + $routeParams.id, {trackerMsg: 'Loading Performance Compare Data'})
            .then(function (response) {
                $scope.compare = response.data;
                slickGridDataSetup();
            });
    }

    function refreshGrid() {
        $scope.$broadcast('event:performance-compare-details-action', {action: 'refresh-grid'});
    }

    function requestItems( list ) {
        list.each(function(item){
            itemsToUpdate.push(item);
        });
        $scope.$broadcast('event:performance-compare-details-action', {action: 'get-items'});
    }

    function initSignalR(){
        if($scope.current.performanceCompareId) {
            $.connection.hub.qs["performanceCompareId"] = $scope.current.performanceCompareId;
            $signalRManager.subscribeToHub('performanceCompareDetailsHub', 'resetList', null, resetList);
            $signalRManager.subscribeToHub('performanceCompareDetailsHub', 'addItems', null, addItems);
            $signalRManager.subscribeToHub('performanceCompareDetailsHub', 'updateItems', null, updateItems);
            $signalRManager.subscribeToHub('performanceCompareDetailsHub', 'removeItems', null, removeItems);
            onRouteChangeOff = $scope.$on("$routeChangeStart", unsubscribeHubs);
        }
    }

    function unsubscribeHubs() {
        $signalRManager.unSubscribeToHub( 'performanceCompareDetailsHub', 'resetList' );
        $signalRManager.unSubscribeToHub( 'performanceCompareDetailsHub', 'addItems' );
        $signalRManager.unSubscribeToHub( 'performanceCompareDetailsHub', 'updateItems' );
        $signalRManager.unSubscribeToHub( 'performanceCompareDetailsHub', 'removeItems' );
        delete $.connection.hub.qs["performanceCompareId"];

        onRouteChangeOff();
    }

    function resetList(subscribe) {
        if(subscribe === undefined) {
            refreshGrid();
            return;
        }

        canSubscribe = subscribe;
        if(!canSubscribe)
            unsubscribeHubs();
    }

    function addItems(list) {
        $scope.$broadcast('event:performance-compare-details-action', {action: 'upsert-items', items: list });
        list.forEach(function(item){
            increaseCount(item);
            if(item.calculationStatus === 'Pending Calculation')
                updatePendingCalculationCount(1);
            compareDetails.push(item);
        });
    }

    function updateItems(list) {
        if($scope.current.view.pageCode === 'PerformanceCompareDetailFullDto') {
            $scope.$broadcast('event:performance-compare-details-action', {action: 'upsert-items', items: list});
        }
        list.forEach(function(item){
            var detail = compareDetails.find({id: item.id});
            if(detail && detail.actionStatus !== item.actionStatus) {
                decreaseCount(detail);
                increaseCount(item);
                detail.actionStatus = item.actionStatus;
            }
            if(detail && detail.calculationStatus !== item.calculationStatus) {
                if(detail.calculationStatus === 'Pending Calculation')
                    updatePendingCalculationCount(-1);
                if(item.calculationStatus === 'Pending Calculation')
                    updatePendingCalculationCount(1);
                detail.calculationStatus = item.calculationStatus;
            }
        });
        requestItems(list);
    }

    function removeItems(list) {
        $scope.$broadcast('event:performance-compare-details-action', {action: 'delete-items', items: list });
        list.forEach(function(item){
            var detail = compareDetails.find({id: item.id});
            decreaseCount(detail);
            if(detail.calculationStatus === 'Pending Calculation')
                updatePendingCalculationCount(-1);
            compareDetails.remove(detail);
        });
    }

    function increaseCount(detail) {
        switch(detail.actionStatus) {
            case "Not Complete":
                $scope.counts.notComplete.value++;
                break;
            case "Orion to Research":
                $scope.counts.orionResearch.value++;
                break;
            case "Advisor to Research":
                $scope.counts.advisorResearch.value++;
                break;
            case "Complete":
            case "Addressed":
            case "No Action":
                $scope.counts.complete.value++;
                break;
        }
    }

    function decreaseCount(detail){
        switch(detail.actionStatus) {
            case "Not Complete":
                $scope.counts.notComplete.value--;
                break;
            case "Orion to Research":
                $scope.counts.orionResearch.value--;
                break;
            case "Advisor to Research":
                $scope.counts.advisorResearch.value--;
                break;
            case "Complete":
            case "Addressed":
            case "No Action":
                $scope.counts.complete.value--;
                break;
        }
    }

    function updatePendingCalculationCount(change) {
        $scope.counts.pendingCalculation.value += change;
    }

    function detailCount(statuses) {
        return compareDetails.count(function(detail){
            return statuses.some(detail.actionStatus);
        });
    }

    function pendingCalculationCount() {
        return compareDetails.count(function(detail){
            return detail.calculationStatus === "Pending Calculation";
        });
    }

    function updateCounts() {
        $scope.counts.notComplete.value = detailCount(["Not Complete"]);
        $scope.counts.orionResearch.value = detailCount(["Orion to Research"]);
        $scope.counts.advisorResearch.value = detailCount(["Advisor to Research"]);
        $scope.counts.complete.value = detailCount(["Complete", "Addressed", "No Action"]);
        $scope.counts.pendingCalculation.value = pendingCalculationCount();
    }

    function slickGridDataSetup() {
        if($scope.current.view.pageCode === 'PerformanceCompareDetailFullDto') {
            $scope.current.uniqueId = "id";
            $scope.current.url = "/Performance/Compare/" + $routeParams.id + "/Details";
        }
        else {
            $scope.current.uniqueId = "entityId";
            $scope.current.url = "/Performance/Compare/" + $routeParams.id + "/Details/Timeframe";
        }
        if($scope.current.params.length > 0)
            $scope.current.params = "";
        $timeout(function() {refreshGrid();});
    }

    //PUBLIC METHODS
    $scope.exportToExcel = function() {
        $scope.$broadcast('event:performance-compare-details-action', {action: 'export-data'});
    };

    $scope.filterActionStatus = function(status) {
        var gridQueryId, filterFn;

        $scope.current.gridQueries = [];

        if(status.length === 0) return;

        gridQueryId = "PCD";
        status.each(function(s){
            gridQueryId += ("_" + s);
        });

        if($scope.current.gridQueries)
            $scope.current.gridQueries.remove({id: gridQueryId});
        else
            $scope.current.gridQueries = [];

        filterFn = function (x) {
            return status.some(x);
        };
        $scope.current.gridQueries.push({
            id: gridQueryId,
            name: status.join('/'),
            description: "Action Status: " + status.join(' or '),
            field: "actionStatus",
            filterFn: filterFn,
            itemCount: detailCount(status),
            enabled: true
        });
    };

    $scope.filterCalculationStatus = function(status) {
        var gridQueryId, filterFn;

        $scope.current.gridQueries = [];

        if(status.length === 0) return;

        gridQueryId = "PCD";
        status.each(function(s){
            gridQueryId += ("_" + s);
        });

        if($scope.current.gridQueries)
            $scope.current.gridQueries.remove({id: gridQueryId});
        else
            $scope.current.gridQueries = [];

        filterFn = function (x) {
            return status.some(x);
        };
        $scope.current.gridQueries.push({
            id: gridQueryId,
            name: status.join('/'),
            description: "Calculation Status: " + status.join(' or '),
            field: "calculationStatus",
            filterFn: filterFn,
            itemCount: pendingCalculationCount(),
            enabled: true
        });
    };

    $scope.calculate = function(all) {
        $http.post('/Performance/Compare/' + $scope.current.performanceCompareId + '/Details/Action/Generate', (all ? null : $scope.selectedIds), {trackerMsg: 'Calculating records'})
            .then(function(){
                if(!canSubscribe)
                    refreshGrid();
            });
    };

    $scope.cancelCalculation = function() {
        $dialog.confirmAction("Are you sure you want to cancel calculating records?")
            .open()
            .then(function(result) {
                if (result === 'yes') {
                    $http.delete('/Performance/Compare/' + $scope.current.performanceCompareId + '/Details/Action/Generate', {trackerMsg: 'Cancel calculating records'})
                        .then(function () {
                            if(!canSubscribe)
                                refreshGrid();
                        });
                }
            });
    };

    $scope.reset = function(all) {
        $dialog.confirmAction("Are you sure you want to reset the selected record?")
            .open()
            .then(function(result){
                if (result === 'yes') {
                    $http.post('/Performance/Compare/' + $scope.current.performanceCompareId + '/Details/Action/Reset', (all ? null : $scope.selectedIds), {trackerMsg: 'Resetting selected records'})
                        .then(function(){
                            if(!canSubscribe)
                                refreshGrid();
                        });
                }
            });
    };

    $scope.actionStatus = function(all) {
        var dialogOpts = {
            templateUrl: "performance-compare-action-status.html",
            controller: "PerformanceCompareActionStatusCtrl",
            statuses: $scope.current.actionStatusList
        };
        $dialog.dialog(dialogOpts)
            .open()
            .then(function(result){
                if (result) {
                    var url = '/Performance/Compare/' + $scope.current.performanceCompareId + '/Details/Action/ChangeActionStatus?actionStatus=' + result.status + (result.isAdvisorVisible ? '&advisorNote=':'&note=') + result.note.escapeURL(true);
                    var ids = angular.copy($scope.selectedIds);
                    if($scope.current.view.pageCode !== 'PerformanceCompareDetailFullDto') {
                        ids = $scope.current.statusNoteIds;
                    }
                    $http.post(url, (all ? null : ids), {trackerMsg: 'Updating action status.'})
                        .then(function(){
                            if(!canSubscribe || $scope.current.view.pageCode !== 'PerformanceCompareDetailFullDto')
                                refreshGrid();
                        });
                }
            });
    };

    $scope.goTo = function (entityEnum) {
        var entity = entities[entityEnum];
        var entityFor;
        var dateRange = (entityEnum === 'transaction' && $scope.selectedDetail.startDate) ? {
                startDate: Date.create($scope.selectedDetail.startDate).formatted(),
                endDate: Date.create($scope.selectedDetail.endDate).formatted()
        } : null;
        switch($scope.selectedDetail.entity){
            case 'Household':
                entityFor = entities['client'];
                break;
            default:
                entityFor = entities[$scope.selectedDetail.entity.toLocaleLowerCase()];
                break;
        }
        $portfolio.goTo(entity.urlFrag, entityFor.value, $scope.selectedDetail.entityId, dateRange);
    };

    $scope.toggleView = function() {
        $scope.current.url = "";
        var url = "";
        if($scope.current.view.pageCode === 'PerformanceCompareDetailFullDto') {
            $scope.current.view.pageCode = "";
            url = '/Settings/Views/PerformanceCompareDetailPivotDto:' + $routeParams.id;
        }
        else {
            url = '/Settings/Views/PerformanceCompareDetailFullDto';
        }
        $scope.$broadcast('event:performance-compare-details-action', {action: 'clear-items'});
        $http.get(url, {trackerMsg : 'Loading performance comparison view'})
            .then(function (response){
                $scope.views = response.data;
                $scope.current.view = response.data[0];
                slickGridDataSetup();
            });
    };

    $scope.zoomToDetail = function() {
        var entityId = $scope.selectedIds[0];
        $scope.current.url = "";
        var url = '/Settings/Views/PerformanceCompareDetailFullDto';
        $scope.$broadcast('event:performance-compare-details-action', {action: 'clear-items'});
        $http.get(url, {trackerMsg : 'Loading performance comparison view'})
            .then(function (response){
                $scope.views = response.data;
                $scope.current.view = response.data[0];
                $scope.current.uniqueId = "id";
                $scope.current.url = "/Performance/Compare/" + $routeParams.id + "/Details";
                $scope.current.params = "entityId=" + entityId;
                $timeout(function() {refreshGrid();});
            });
    };


    //EVENT LISTENERS
    $scope.$on('slickgrid-data-loaded', function(event, data) {
        if($scope.current.view.pageCode === 'PerformanceCompareDetailFullDto') {
            compareDetails = angular.copy(data);
            updateCounts();
        }
        else {
            $http.get("/Performance/Compare/" + $routeParams.id + "/Details", {trackerMsg: 'Loading Performance Compare Details'})
                .then(function(response){
                    compareDetails = angular.copy(response.data);
                    updateCounts();
                });
        }
    });

    $scope.$on('slickgrid-getitems', function(event, data) {
        itemsToUpdate.forEach(function(item){
            var timeframe = item.timeframe.toLocaleLowerCase();
            var systemnetfield = 's' + timeframe + 'net';
            var systemgrossfield = 's' + timeframe + 'gross';
            var usernetfield = 'u' + timeframe + 'net';
            var usergrossfield = 'u' + timeframe + 'gross';
            var diffnetfield = 'd' + timeframe + 'net';
            var diffgrossfield = 'd' + timeframe + 'gross';
            var selected = data.find({ entity: item.entity, entityId: item.entityId });
            if(selected){
                selected[systemgrossfield] = item.systemGrossPerformance;
                selected[systemnetfield] = item.systemNetPerformance;
                selected[usergrossfield] = item.grossPerformance;
                selected[usernetfield] = item.netPerformance;
                selected[diffgrossfield] = item.compareGrossPerformance;
                selected[diffnetfield] = item.compareNetPerformance;
                if(selected.maxDiff) {
                    selected.maxDiff = (selected.maxDiff > item.compareGrossPerformance) ? selected.maxDiff : item.compareGrossPerformance;
                    selected.maxDiff = (selected.maxDiff > item.compareNetPerformance) ? selected.maxDiff : item.compareNetPerformance;
                } else {
                    selected.maxDiff = (item.compareGrossPerformance > item.compareNetPerformance) ? item.compareGrossPerformance : item.compareNetPerformance;
                }
                $scope.$broadcast('event:performance-compare-details-action', {action: 'upsert-items', items: [selected] });
            }
            itemsToUpdate.remove(item);
        });
    });

    $scope.$on('event:performance-compare-details-select', function (e, args) {
        e.stopPropagation();
        if (args.length === 0) return;

        $scope.selectedIds = args.map($scope.current.uniqueId);
        $scope.current.statusNoteIds = args.map('ids')[0];
        $scope.status.canReset = args.every(function(a){ return a.calculationStatus === 'Errored' || a.calculationStatus === 'Calculated'; });
        $scope.status.canCalculate = args.every(function(a){ return a.calculationStatus === 'Not Calculated' || a.calculationStatus === 'Errored'; });

        $scope.current.actionStatusList = args.map('actionStatus').unique();

        $scope.selectedDetail.entity = args.map('entity')[0];
        $scope.selectedDetail.entityId = args.map('entityId')[0];
        $scope.selectedDetail.startDate = args.map('startDate')[0];
        $scope.selectedDetail.endDate = args.map('endDate')[0];

        if($scope.selectedIds.length > 0) {
            var ids = angular.copy($scope.selectedIds);
            if($scope.current.view.pageCode !== 'PerformanceCompareDetailFullDto') {
                ids = $scope.current.statusNoteIds;
            }
            $http.post('/Performance/Compare/' + $scope.current.performanceCompareId + '/Details/Notes', ids, {trackerMsg: 'Getting notes.'})
                .then(function(response){
                    $scope.notes = response.data;
                });
        }
    });

    //WATCHES
    $scope.$watch("counts.notComplete.value", function(newValue, oldValue){
        if (newValue === oldValue) return;

        if($scope.counts.notComplete.change)
            $scope.counts.notComplete.change = false;

        $scope.counts.notComplete.change = true;
        $timeout(function() {$scope.counts.notComplete.change = false;}, 500);
    });

    $scope.$watch("counts.orionResearch.value", function(newValue, oldValue){
        if (newValue === oldValue) return;

        if($scope.counts.orionResearch.change)
            $scope.counts.orionResearch.change = false;

        $scope.counts.orionResearch.change = true;
        $timeout(function() {$scope.counts.orionResearch.change = false;}, 500);
    });

    $scope.$watch("counts.advisorResearch.value", function(newValue, oldValue){
        if (newValue === oldValue) return;

        if($scope.counts.advisorResearch.change)
            $scope.counts.advisorResearch.change = false;

        $scope.counts.advisorResearch.change = true;
        $timeout(function() {$scope.counts.advisorResearch.change = false;}, 500);
    });

    $scope.$watch("counts.complete.value", function(newValue, oldValue){
        if (newValue === oldValue) return;

        if($scope.counts.complete.change)
            $scope.counts.complete.change = false;

        $scope.counts.complete.change = true;
        $timeout(function() {$scope.counts.complete.change = false;}, 500);
    });

    $scope.$watch("counts.pendingCalculation.value", function(newValue, oldValue){
        if (newValue === oldValue) return;

        if($scope.counts.pendingCalculation.change)
            $scope.counts.pendingCalculation.change = false;

        $scope.counts.pendingCalculation.change = true;
        $timeout(function() {$scope.counts.pendingCalculation.change = false;}, 500);
    });

    //INITIALIZE
    $scope.compare = {};
    $scope.rightsPerfomanceCompare = $oasRights.forCode("PERFCOMPARE");
    $scope.rightsPortfolioAudit = $oasRights.forCode("PORTFOLIOLISTSAPP");
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.status = { canReset: false };
    $scope.selectedDetail = {entity: null, entityId: null, startDate: null, endDate: null};
    $scope.current = {
        view : views[0], performanceCompareId: $routeParams.id, actionStatusList: [], url: "", params: "", statusNoteIds: []
    };
    $scope.counts = {notComplete: {value: 0, change: false}, orionResearch: {value: 0, change: false}, advisorResearch: {value: 0, change: false}, complete: {value: 0, change: false}, pendingCalculation: {value: 0, change: false}};
    $scope.notes = []; //[{ performanceCompareId: 1, id: 2, auditedDate: '1/30/2017', auditedByDisplay: 'Jan-Michael Williams', isAdvisorVisible: true, note: 'This is a test' }];

    init();
});

performanceCompareDetailsCtrl.loadPerformanceCompareView = ["$http","$route", function( $http, $route ) {
    var url = '';
    if($route.current.params.id) {
        return $http.get('/Performance/Compare/' + $route.current.params.id, {trackerMsg: 'Loading Performance Compare Data'})
            .then(function (response) {
                if(response.data.haveTimeframes) {
                    url = '/Settings/Views/PerformanceCompareDetailPivotDto:' + $route.current.params.id;
                } else {
                    url = '/Settings/Views/PerformanceCompareDetailFullDto';
                }
                return $http.get(url, {trackerMsg : 'Loading performance comparison view'});
            })
            .then(function(response){
                return response.data;
            });
    }
    /*else {
        url = '/Settings/Views/PerformanceCompareDetailFullDto';
    }*/
}];

app.controller ('PerformanceCompareActionStatusCtrl', function PerformanceCompareActionStatusCtrl( $scope, dialog) {
    //PRIVATE METHODS
    function init() {
        if (dialog.options.statuses.some("Advisor to Research"))
            $scope.current.status = "Advisor to Research";
        else if (dialog.options.statuses.some("Orion to Research"))
            $scope.current.status = "Orion to Research";
        else if (dialog.options.statuses.some("No Action"))
            $scope.current.status = "No Action";
        else if (dialog.options.statuses.some("Addressed"))
            $scope.current.status = "Addressed";
        else if (dialog.options.statuses.some("Complete"))
            $scope.current.status = "Complete";
    }

    //PUBLIC METHODS
    $scope.submit = function() {
        dialog.close($scope.current);
    };

    $scope.cancel = function() {
        dialog.close(null);
    };

    //INITIALIZE
    $scope.isAdvisor = ($scope.user.authorization.entity === 'Advisor');
    $scope.current = { status: "Not Complete", note: '', isAdvisorVisible: $scope.isAdvisor };
    init();
});

'use strict';

app.controller('PerformanceCompareWizardCtrl', function PerformanceCompareWizardCtrl($scope, $http, $oasRights, $location, $dialog, views) {
    //PRIVATE VARIABLES

    //PRIVATE METHODS
    function init() {
        $http.get('/Settings/EntityOptions/Database/0/Categories/Performance Calculator', {cache: true, trackerMsg: 'Loading Performance Options'})
            .then(function (response) {
                if(!$scope.content.calcMethod)
                    $scope.content.calcMethod = $scope.calcMethods.find({name: response.data.find({code:'69CALCULAT'}).value}).value;
            });
    }

    //PUBLIC METHODS
    $scope.back = function() {
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep -= 1;
    };
    $scope.next = function() {
        $scope.current.animation = 'slide-right';
        $scope.current.wizardStep += 1;
    };
    $scope.jumpBackTo = function(index) {
        if ($scope.current.executing || $scope.current.wizardStep < index) return;

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };
    $scope.isStepIncomplete = function() {
        switch ($scope.wizardSteps[$scope.current.wizardStep]) {
            case "Performance Details":
                var test = ($scope.content.name === null || $scope.content.name.trim() === '');
                test = (test || $scope.content.calcMethod === null);
                return test;
            case "File Import":
                var test = $scope.content.details === null || ($scope.content.details.any({isValid: false}) && !$scope.current.ignoreInvalid);
                return test;
            case "Review/Submit":
                return false;
            default:
                return false;
        }
    };
    $scope.submit = function() {
        $scope.content.details = $scope.content.details.filter({isValid: true});
        $http.post('/Performance/Compare?beginGeneration=true', $scope.content, {trackerMsg: 'Submitting Performance Compare'})
            .then(function(response){
                if(response.data) {
                    $location.url('/reports/performancecomparison/' + response.data.id);
                }
            });
    };
    $scope.close = function() {
        $location.url('/reports/performancecomparison');
    };
    $scope.viewValidation = function(d) {
        $dialog.messageBox("Validation Message", d.validationMessage).open();
    };
    $scope.startImportOver = function() {
        $scope.content.details = null;
    };

    //WATCHES
    $scope.$watch("content.details", function(newValue, oldValue){
        if (newValue === oldValue) return;

        if(newValue !== null) {
            newValue.forEach(function(d, i) {
                d.id = -i;
            });
            var eventArgs = {action: "set-data", newData: angular.copy(newValue.filter({isValid: false})).first(100)};
            $scope.$broadcast('event:performance-compare-wizard-action', eventArgs);
        }
    });

    //INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.content = {
        name: '',
        calcMethod: null,
        isLockedDown: false,
        details:null
    };
    $scope.rightsApp = $oasRights.forCode("PERFCOMPARE");
    $scope.current = { view: views[0], executing: false, wizardStep: 0, animation: 'slide-right', token: sessionStorage.oas_token, ignoreInvalid: false };
    $scope.wizardSteps = [ "Performance Details", "File Import", "Review/Submit" ];
    $scope.calcMethods = [{name: 'TWR', value: 0}, {name: 'IRR', value: 2}, {name: 'Simple', value: 1}];

    init();
});
(function(){
    // 'use strict';
    app.component('treeEntityOptions', treeEntityOptionsObj());

    function treeEntityOptionsObj(){
        let obj = {
            bindings:{
                allowedEntities:"=",
                groupEntities:"=",
                ready:"="
            },
            controller: ['$scope', treeEntityOptionsCTRL],
            controllerAs:'com',
            template: treeEntityOptionsTemplate,
        };

        function treeEntityOptionsCTRL($scope){
            let com = this;
            com.newSubItem = newSubItem;

            //FUNCTIONS
            function newSubItem(entityNode) {
                var entityData =   entityNode.$modelValue;
                var nodeData = {grouping: null, title:'', groupings:[]};
                nodeData.grouping =entityData.grouping;
                nodeData.title =entityData.title;

                if (entityData.userDefinedFieldDefinitionId != null) {
                    nodeData.groupingOptionName = entityData.groupingOptionName || entityData.title;
                    nodeData.userDefinedFieldDefinitionId = entityData.userDefinedFieldDefinitionId;
                    nodeData.userDefinedFieldEntity = entityData.userDefinedFieldEntity;
                    nodeData.userDefinedFieldCode = entityData.userDefinedFieldCode;
                }

                com.groupEntities.add(nodeData);
            }

            //WATCHES
            //Make sure the list can never be empty, it looks ugly when it is.
            $scope.$watch('com.groupEntities', function (newVal, oldVal) {
                if(newVal.length === 0){
                    com.groupEntities = oldVal;
                }
            }, true);
        }

        function treeEntityOptionsTemplate(){
            return `
                    <script type="text/ng-template" id="entity-nodes-renderer2.html">
                        <div class="pull-left tree-handle" ui-tree-handle>
                            <span class="fa fa-list"></span>
                        </div>
                        <div ui-tree-handle class="tree-node tree-node-content">
                            <a class="btn btn-link btn-mini" ng-if="node.groupings && node.groupings.length > 0" data-nodrag ng-click="toggle(this)">
                                <span class="fa fa-chevron-right" ng-class="{'fa fa-chevron-right': collapsed,'fa fa-chevron-down': !collapsed}"></span>
                            </a>
                            {{node.title}}
                            <a class="pull-right btn btn-primary btn-mini" data-nodrag ng-click="com.newSubItem(this)" style="margin-right: 8px;" aria-label="Add {{node.title}}"><i class="fa fa-plus" aria-hidden="true"></i></a>
                        </div>
                        <ol ui-tree-nodes="" ng-model="node.groupings" ng-class="{hidden: collapsed}">
                            <li ng-repeat="node in node.groupings" ui-tree-node ng-include="'entity-nodes-renderer2.html'"></li>
                        </ol>
                    </script>
                    <script type="text/ng-template" id="group-entity-nodes-renderer2.html">
                        <div class="pull-left tree-handle" ui-tree-handle>
                            <span class="fa fa-list"></span>
                        </div>
                        <div ui-tree-handle class="tree-node tree-node-content">
                            <a class="btn btn-link btn-mini" ng-if="node.groupings && node.groupings.length > 0" data-nodrag ng-click="toggle(this)">
                                <span class="fa fa-chevron-right" ng-class="{'fa fa-chevron-right': collapsed,'fa fa-chevron-down': !collapsed}"></span>
                            </a>
                            {{node.title}}
                            <a class="pull-right btn btn-danger btn-mini" data-nodrag ng-click="remove(this)" aria-label="Remove {{node.title}}"><i class="fa fa-remove" aria-hidden="true"></i></a>
                        </div>
                        <ol ui-tree-nodes="" ng-model="node.groupings" ng-class="{hidden: collapsed}">
                            <li ng-repeat="node in node.groupings" ui-tree-node ng-include="'group-entity-nodes-renderer2.html'"></li>
                        </ol>
                    </script>
                    
                    <div class="container">
                        <div class="row-fluid" ng-if="com.ready">
                            <div class="span5" style="padding: 15px;">
                                <div style="margin-left:10px; font-size: medium; color: #7c9eb2;font-weight: bold"> Available Entities</div>
                                <div ui-tree id="entity-tree-root-source" data-clone-enabled="true" data-nodrop-enabled="true">
                                    <ol ui-tree-nodes ng-model="com.allowedEntities">
                                        <li ng-repeat="node in com.allowedEntities" ui-tree-node ng-include="'entity-nodes-renderer2.html'"></li>
                                    </ol>
                                </div>
                            </div>
                            <div class="span2">
                                <p style="margin-left:5px; font-size: small;padding-top: 40px">
                                    <em>Drag & drop or click plus icon to move entity to grouping entity</em>
                                </p>
                                <p style="margin-left:5px; font-size: small;padding-top: 40px">
                                    <em>To re-order list, drag and move entity up/down in list. </em>
            
                                </p>
                                <p style="margin-left:5px; font-size: small;padding-top: 40px">
                                    <em>To create a group within a group, drag and move grouping entity to the right to increase indent; move grouping entity to the left to decrease indent</em>
                                </p>
                            </div>
                            <div class="span5" style="padding: 15px;">
                                <div style=" font-size: medium; color: #7c9eb2;"> Grouping Entities</div>
            
                                <div ui-tree id="entity-tree-root-destination">
                                    <ol ui-tree-nodes ng-model="com.groupEntities">
                                        <li ng-repeat="node in com.groupEntities" ui-tree-node ng-include="'group-entity-nodes-renderer2.html'"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    
            `;
        }

        return obj;
    }
})();
(function () {
    'use strict';
    app
    //wizard steps
        .component('bptBatchInfo', bptBatchInfoObj())
        .component('bptSelection', bptSelectionObj())
        .component('bptOptions', bptOptionsObj())
        .component('bptReview', bptReviewObj())
        .controller('bptAvailableSelectCtrl', ['$scope', 'dialog', 'availableSelectedArgs', bptAvailableSelectCtrl])
    ;

    //Wizard Sections
    function bptBatchInfoObj() {
        let obj = {
            bindings: {},
            controller: ['bptWizardTracking', 'bptWizardServices', bptBatchInfoCTRL],
            controllerAs: 'com',
            templateUrl: 'reporting/performance/batchPerformanceTool/components/views/bptBatchInfo.html'
        };

        function bptBatchInfoCTRL(bptWizardTracking, bptWizardServices) {
            let com = this;
            com.title = "Batch Info CTRL";
            com.batchInfoObj = bptWizardServices.batchObj.batchInfoObj;
            com.data = {
                availableDateRanges: [],
                selecetedDateRanges:[],
                newDateRanges: {},
                selectionInProgress: false,
                selectedPeriods: [],
                representatives: [],
                mngmntStyle: [],
                model: []
            };
            com.controls = {
                setDates: setDates,
                updateDateRanges: updateDateRanges,
                updateMonthly: updateMonthly,
                loadSelectedDateRanges: loadSelectedDateRanges,
                setSelectedPeriods:setSelectedPeriods
            };

            //INIT
            (function () {
                buildDateRanges(com.batchInfoObj.endDate)
                    .then(function () {
                        return loadSelectedDateRanges();
                    })
                    .then(function () {
                        bptWizardServices.retrieveList('/Portfolio/Representatives/Simple', {trackerMsg: 'Loading representatives'})
                            .then(function (res) {
                                com.data.representatives = res.data
                            });
                    });
            })();

            function setDates(rangeName) {
                let startDate = angular.copy(com.batchInfoObj.startDate);
                let endDate = angular.copy(com.batchInfoObj.endDate);

                switch (rangeName) {
                    case "last-month":
                        startDate = Date.create('today').addDays(-1).addMonths(-1).beginningOfMonth();
                        endDate = Date.create('today').addMonths(-1).endOfMonth().beginningOfDay();
                        break;
                    case "last-year":
                        startDate = Date.create('today').addYears(-1).beginningOfYear();
                        endDate = Date.create('today').addYears(-1).endOfYear().beginningOfDay();
                        break;
                    case "last-quarter":
                        startDate = Date.create('today').getStartOfQuarter().addDays(-1).getStartOfQuarter();
                        endDate = Date.create('today').getStartOfQuarter().addDays(-1);
                        break;
                    case "MTD":
                        startDate = angular.copy(endDate).beginningOfMonth();
                        break;
                    case "QTD":
                        startDate = angular.copy(endDate).getStartOfQuarter();
                        break;
                    case "YTD":
                        startDate = angular.copy(endDate).beginningOfYear();
                        break;
                    case "roll-1-year":
                        startDate = angular.copy(endDate).addYears(-1);
                        break;
                    case "roll-3-year":
                        startDate = angular.copy(endDate).addYears(-3);
                        break;
                }

                com.batchInfoObj.startDate = startDate;
                com.batchInfoObj.endDate = endDate;
                com.controls.updateDateRanges();
            }

            function loadSelectedDateRanges() {
                com.data.selectedPeriods = [];
                com.batchInfoObj.selectedPeriods.forEach(function (range) {
                    com.data.selectedPeriods.push(range.name);
                });
            }

            function setSelectedPeriods() {
                let temp = [];
                com.data.selectedPeriods.forEach(function (range) {
                    temp.push(com.data.availableDateRanges.find({name: range}));
                });
                com.batchInfoObj.selectedPeriods = temp;
            }

            function updateDateRanges() {
                if (com.batchInfoObj.monthly) {
                    updateMonthly();
                } else {
                    buildDateRanges(com.batchInfoObj.endDate)
                        .then(function () {
                            let temp = [];
                            com.data.selectedPeriods.forEach(function (range) {
                                temp.push(com.data.availableDateRanges.find({ name: range }));
                            });
                            com.batchInfoObj.selectedPeriods = temp;
                        });
                }
            }

            function updateMonthly() {
                if (com.batchInfoObj.monthly) {
                    com.data.selectedPeriods = [];
                    com.batchInfoObj.selectedPeriods = createMonthlyIntervals(com.batchInfoObj.startDate, com.batchInfoObj.endDate, Math.max(...com.data.availableDateRanges.map(d => d.id)) + 1);
                }
            }

            function buildDateRanges(endDate) {
                return bptWizardServices.retrieveList('/Reporting/Calculate/DateRanges/' + Date.create(endDate).format('{MM}-{dd}-{yyyy}'), {trackerMsg: 'Building date options'})
                    .then(function (response) {
                        com.data.availableDateRanges = response.data;
                        com.data.availableDateRanges.forEach(function (item) {
                            com.data.newDateRanges[item.name] = item.name;
                        });
                    })
            }
        }

        return obj;
    }

    function createMonthlyIntervals(startDate, endDate, intervalId) {
        let monthlyIntervals = [];

        let intervalMonth = startDate.getMonth()
        let intervalYear = startDate.getFullYear();
        let endYear = endDate.getFullYear();
        let endMonth = endDate.getMonth();        

        if (endYear - intervalYear > 5) {
            return [];
        }

        while (intervalYear <= endYear) {
            while (intervalMonth <= 11) {
                const start = new Date(intervalYear, intervalMonth, 1);
                const end = new Date(intervalYear, intervalMonth + 1, 0);

                monthlyIntervals.push({
                    id: intervalId,
                    name: periodName(start, end),
                    sortOrder: intervalId,
                    startDateMethod: "Inception",
                    startDate: start,
                    endDate: end
                });

                intervalMonth++;

                if (intervalMonth > 11 || (intervalYear == endYear && intervalMonth > endMonth)) {
                    intervalMonth = 0;
                    intervalYear++;
                    break;
                }

                intervalId++;
            }
        }        

        if (monthlyIntervals.length > 0) {
            //Fix first and last periods
            const first = monthlyIntervals[0];
            const last = monthlyIntervals[monthlyIntervals.length - 1];

            first.startDate.setDate(startDate.getDate());
            first.name = periodName(first.startDate, first.endDate);
            last.endDate.setDate(endDate.getDate());
            last.name = periodName(last.startDate, last.endDate);
        }

        return monthlyIntervals;
    }

    function periodName(startDate, endDate) {
        return (startDate.getMonth() + 1) + '/' + startDate.getDate() + '/' + startDate.getFullYear() + '-' + (endDate.getMonth() + 1) + '/' + endDate.getDate() + '/' + endDate.getFullYear()
    }

    function bptSelectionObj() {
        let obj = {
            bindings: {},
            controller: ['bptWizardTracking', 'bptWizardServices', '$dialog', '$http', bptSelectionCTRL],
            controllerAs: 'com',
            templateUrl: 'reporting/performance/batchPerformanceTool/components/views/bptSelection.html'
        };

        function bptSelectionCTRL(bptWizardTracking, bptWizardServices, $dialog, $http) {
            let com = this;
            com.title = "Selection";
            com.selectionObj = bptWizardServices.batchObj.selectionObj;
            com.ready = false;
            com.allowedEntities = [];
            com.dynamicGroups = [];
            com.controls = {
                uploadImport: uploadImport,
                updateDynamicGroups: updateDynamicGroups,
                resetOptions: resetOptions,
                filterSelect: filterSelect
            };

            (function () {
                if (!com.selectionObj.groupEntities) {
                    com.selectionObj.groupEntities = [{
                        grouping: 5,
                        title: "Household",
                        groupings: []
                    }];
                }

                var baseEntities = [
                    {grouping: 5,  title: 'Household',        groupings:[]},  {grouping: 107, title: 'Portfolio Group',      groupings:[]},
                    {grouping: 6,  title: 'Registration',     groupings:[]},  {grouping: 16,  title: 'Management Style',     groupings:[]},
                    {grouping: 74, title: 'Aggregated Model', groupings:[]},  {grouping: 7,   title: 'Account',              groupings:[]},
                    {grouping: 90, title: 'Asset Category',   groupings:[]},  {grouping: 91,  title: 'Risk Category',        groupings:[]},
                    {grouping: 81, title: 'Asset Class',      groupings:[]},  {grouping: 104, title: 'Product Type',         groupings:[]},
                    {grouping: 9,  title: 'Product',          groupings:[]},  {grouping: 85,  title: 'Asset Level Strategy', groupings:[]},
                    {grouping: 8,  title: 'Asset',            groupings:[]}
                ];

                com.allowedEntities = angular.copy(baseEntities);

                function finishSelectionInit() {
                    com.controls.updateDynamicGroups();
                    com.controls.resetOptions();
                    com.ready = true;
                }

                function mapGroupingOption(opt) {
                    var entity = {
                        grouping: opt.grouping,
                        title: opt.name,
                        groupings: []
                    };

                    if (opt.userDefinedFieldDefinitionId != null) {
                        entity.groupingOptionName = opt.name;
                        entity.userDefinedFieldDefinitionId = opt.userDefinedFieldDefinitionId;
                        entity.userDefinedFieldEntity = opt.userDefinedFieldEntity;
                        entity.userDefinedFieldCode = opt.userDefinedFieldCode;
                    }

                    return entity;
                }

                bptWizardServices.getDynamicGroupingOptions()
                    .then(function (res) {
                        var options = res.data || [];
                        var securityClassifications = options
                            .filter(function (opt) { return opt.grouping !== 32; })
                            .map(mapGroupingOption);
                        var customFields = options
                            .filter(function (opt) { return opt.grouping === 32; })
                            .map(mapGroupingOption);

                        com.allowedEntities = baseEntities.concat(securityClassifications).concat(customFields);
                        finishSelectionInit();
                    });
            })();

            function filterSelect(filter, active) {
                if (!active) {
                    filter.ids = [];
                    return;
                }
                $dialog.dialog({
                    templateUrl: "app/modals/available-select.html",
                    controller: "bptAvailableSelectCtrl",
                    resolve: {
                        availableSelectedArgs: function () {
                            return {selectionType: angular.copy(filter.filterId), selectedSelected: angular.copy(filter.ids), sortable: false};
                        }
                    }
                }).open()
                    .then(function (res) {
                        if(res.save){
                            filter.ids = angular.copy(res.data);
                            if(filter.ids.length === 0) filter.active = false;
                        }else if(!res.save && res.data === null){
                            if(filter.ids.length === 0) filter.active = false;
                        }
                    });
            }

            function resetFilters(filter) {
                if(filter){
                    com.selectionObj.filterBy.filter({filterBy:filter})[0].ids = [];
                }else{
                    com.selectionObj.filterBy = [
                        {allowed: true, active: false, filterId: 4,  displayName:'Representative', filterBy: 'Representative', ids: []},
                        {allowed: true, active: false, filterId: 16, displayName:'Management Style',  filterBy: 'Management Style', ids: []},
                        {allowed: true, active: false, filterId: 74, displayName:'Aggregated Model',  filterBy: 'Aggregated Model', ids: []}
                    ];
                }
            }

            function resetOptions(opt) {
                let settings = {
                    'Dynamic group'() {
                        com.selectionObj.entityIds = null;
                        com.selectionObj.filter = false;
                        resetFilters();
                    },
                    'Import IDs'() {
                        com.selectionObj.dynamicGroupingId = null;
                        com.selectionObj.filter = false;
                        resetFilters();

                    },
                    'batchType'() {
                        com.selectionObj.dynamicGroupingId = null;
                        com.selectionObj.entityIds = null;
                        com.selectionObj.filter = false;
                        resetFilters();
                        resetGroupingRoot();
                    },
                    'default'() {
                        if(com.selectionObj.groupType !== 'Dynamic group'){
                            com.selectionObj.dynamicGroupingId = null;
                            com.selectionObj.entityIds = null;
                        }
                        com.selectionObj.filter = false;
                    }
                };
                (typeof settings[opt] === 'function') ? settings[opt]() : settings['default']();
            }

            function resetGroupingRoot(){
                com.selectionObj.groupEntities = [angular.copy(com.allowedEntities.find({title:com.selectionObj.batchType}))];
            }

            function updateDynamicGroups( batchType ) {
                bptWizardServices.updateDynamicGroups( batchType )
                    .then(function (res) {
                        com.dynamicGroups = res.data;
                    });
            }

            function uploadImport() {
                var dialogOpts = {
                    template: `
                        <div class="modal-body">
                            <form class="form-horizontal">
                                <div class="row-fluid">
                                    <div class="span6" style="background-color: #E5E5E5; padding:20px; border-radius: 4px;">
                                        <h5 style="margin-top:0;"><i class="fa fa-lightbulb-o" aria-hidden="true"></i> A word about file formats...</h5>
                                        <p>Use the template below and fill in the appropriate IDs.  Invalid IDs will be automatically discarded during the import.</p>
                                        <p><a href="_content/rb-entities-template.zip" class="btn btn-primary">Download File Template</a></p>
                                    </div>
                                    <div class="span6">
                                        <file-uploader return-data="current.inputValue.fileData" post-url="/ValidateImport/Echo"></file-uploader><br />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button ng-click="submit()" class="btn btn-primary">OK</button>
                            <button ng-click="cancel()" class="btn">Cancel</button>
                        </div>
                    `,
                    controller: ["$scope","dialog",function importIdCTRL($scope, dialog) {
                        let dg = this;
                        //PUBLIC METHODS
                        //WATCHES
                        $scope.$watch('current.inputValue.fileData', function (newValue, oldValue) {
                            if (newValue === oldValue || !newValue) return;
                            $scope.current.inputValue.ids = Object.values(newValue[0].result)[0].map(function (x) {
                                return parseInt(Object.values(x)[0]);
                            });
                            dialog.close($scope.current.inputValue);
                        });

                        $scope.submit = function () {
                            dialog.close($scope.current.inputValue);
                        };

                        $scope.cancel = function () {
                            dialog.close(null);
                        };
                    }]
                };
                $dialog.dialog(dialogOpts)
                    .open()
                    .then(function (res) {
                        if (res) {
                            com.selectionObj.entityIds = res.ids;
                        }
                    });
            }
        }

        return obj;
    }

    function bptOptionsObj() {
        let obj = {
            bindings: {},
            controller: ['bptWizardTracking', 'bptWizardServices', bptOptionsCTRL],
            controllerAs: 'com',
            templateUrl: 'reporting/performance/batchPerformanceTool/components/views/bptOptions.html'
        };

        function bptOptionsCTRL(bptWizardTracking, bptWizardServices) {
            let com = this;
            com.title = "Performance Options";
            com.optionsObj = bptWizardServices.batchObj.optionsObj;
            com.controls = {
                searchElement: searchElement,
                loadMultiSelect: loadMultiSelect,
                updateMultiSelect: updateMultiSelect,
            };
            com.data = {
                assetsInclusion: {selected: []}
            };

            //INIT
            (function () {
            })();

            //FUNCTIONS
            function searchElement(str) {
                return com.optionsObj.find({code: str});
            }

            function loadMultiSelect() {
                com.data.assetsInclusion.selected = [];
                com.optionsObj['69UNMANAGE'].options.forEach(function (range) {
                    com.data.assetsInclusion.selected.push(range.name);
                });
            }

            function updateMultiSelect() {
                let perfSelection = 0;
                com.data.assetsInclusion.selected.forEach(function (optionValue){
                    if(optionValue === "-1")
                        return null;
                    perfSelection += parseInt(optionValue);
                });
                com.optionsObj['69UNMANAGE'].value = perfSelection;
            }
        }

        return obj;
    }

    function bptReviewObj() {
        let obj = {
            bindings: {},
            controller: ['bptWizardTracking', 'bptWizardServices', bptReviewCTRL],
            controllerAs: 'com',
            templateUrl: 'reporting/performance/batchPerformanceTool/components/views/bptReview.html'
        };

        function bptReviewCTRL(bptWizardTracking, bptWizardServices) {
            let com = this;
            com.title = "Review Template";
            com.reviewObj = bptWizardServices.batchObj;
        }

        return obj;
    }

    function bptAvailableSelectCtrl($scope, dialog, availableSelectedArgs) {
        //PUBLIC METHODS
        $scope.close = function(save) {
            dialog.close({save:save,data:save ? $scope.current.selectedSelected : null});
        };


        //INITIALIZE
        $scope.current = {
            selectionType: availableSelectedArgs.selectionType,
            selectedSelected: availableSelectedArgs.selectedSelected,
            sortable: availableSelectedArgs.sortable || false,
            availableItems: availableSelectedArgs.availableItems || [],
            id: availableSelectedArgs.id || undefined };
    }
})();

// let obj = {
//         "id": 0,
//         "batchName": "New Performance Batch",
//         "general": {
//             "runForEntity": "Household",
//             "startDate": "03/27/2019",
//             "endDate": "03/27/2019",
//             "description": null,
//             "showBenchmarks": false,
//             "auditedDate": "0001-01-01T00:00:00+00:00",
//             "auditedBy": null
//         },
//         "options": {
//             "performanceOptions": {
//                 "id": 0,
//                 "name": null,
//                 "calculationMethod": "TWR",
//                 "includeAccruedInterest": true,
//                 "calcGrossOfFees": false,
//                 "calcFirstDayPerformance": false,
//                 "calcIntraDayPerformance": false,
//                 "annualize": false,
//                 "annualizeIncludeDaysWithoutValue": false,
//                 "flipSignForShort": true,
//                 "suppressMixedRanges": false,
//                 "suppressMixedAssetLevelGroups": false
//             },
//             "accountInclusion": "All accounts",
//             "entityIds": [46, 83, 93, 94, 95, 114, 115, 116, 622],
//             "unmanagedInclusionOverride": "",
//             "dateRanges": [],
//             "filters": "",
//             "groupings": [{"grouping": 5, "title": "Household", "groupings": [], "$$hashKey": "object:114"}],
//             "readOnlyOptions": {
//                 "localPriceCutOverDate": "1900-01-01",
//                 "dividendAccrualStartDate": "2015-01-01",
//                 "allowDividendAccrual": true,
//                 "dailyInterestAccrual": {
//                     "enabled": false,
//                     "startDate": "2018-09-26T00:00:00-05:00",
//                     "dailyReturnThreshold": 0.0001,
//                     "maxDays": 90
//                 },
//                 "forceAssetGroupingIntraday": true
//             }
//         }
//     }
// ;
(function () {
    'use strict';
    app
        .service('bptWizardTracking', bptWizardTracking)
        .service('bptEntitySelectionTracking', bptEntitySelectionTracking)
        .service('bptWizardServices', ["$http", bptWizardServices]);

    function bptWizardTracking() {
        let trackingObj = {
            currentStep:
            {id: 'batchInfo', name: 'Batch Info', index: 0}
            // {id: 'selection', name: 'Selection', index: 1}
            // {id: 'options', name: 'Performance Options', index: 2}
            // {id: 'review', name: 'Review & Submit', index: 3}
        };

        this.getCurrentStep = getCurrentStep;
        this.setCurrentStep = setCurrentStep;

        function getCurrentStep() {
            return trackingObj.currentStep;
        }

        function setCurrentStep(val) {
            trackingObj.currentStep = val;
        }

        return this;
    }

    function bptEntitySelectionTracking(){
        // let trackerObj = [];

        // this.set = set;
        // this.reset = reset;
        // this.list = list;
        //
        // function set(list){trackerObj = list;}
        // function reset(){trackerObj = [];}
        // function list(){return trackerObj}
        // return this;
        return {
            entityTracker:[],
            batchTracker:{}
        };
    }

    function bptWizardServices($http) {
        let instanceObj = {};
        let batchObj = {
            batchInfoObj: {},
            selectionObj: {},
            optionsObj: {}
        };

        this.batchObj = batchObj;
        this.instanceObj = instanceObj;

        this.cleanup = cleanup;
        this.createBatch = createBatch;
        this.deleteBatch = deleteBatch;
        this.getPerformanceOptions = getPerformanceOptions;
        this.loadDefaults = loadDefaults;
        this.retrieveList = retrieveList;
        this.syncObj = syncObj;
        this.updateDynamicGroups = updateDynamicGroups;
        this.getDynamicGroupingOptions = getDynamicGroupingOptions;

        function cleanup() {
            batchObj = {
                batchInfoObj: {},
                selectionObj: {},
                optionsObj: {}
            };
        }

        function createBatch(obj) {
            return $http.post("/Performance/Batch/Verbose?beginGeneration=true", obj, {trackerMsg: "Creating batch"});
        }

        function deleteBatch(id) {
            return $http.delete('/Performance/Batch/' + id, {trackerMsg: 'Deleting Batch Record'});
        }

        function mapBatchDateRangesToDateOnlyStrings(ranges) {
            if (!ranges || !ranges.length) {
                return [];
            }
            return ranges.map((p) => {
                const copy = angular.copy(p);
                if (copy.startDate != null) {
                    copy.startDate = Date.create(copy.startDate).format('{yyyy}-{MM}-{dd}');
                }
                if (copy.endDate != null) {
                    copy.endDate = Date.create(copy.endDate).format('{yyyy}-{MM}-{dd}');
                }
                return copy;
            });
        }

        /** Strip UI-only fields (e.g. title) from grouping tree for API payload. */
        function mapGroupEntitiesToVerboseDto(nodes) {
            if (!nodes || !nodes.length) {
                return [];
            }
            return nodes.map(function (node) {
                var dto = {
                    grouping: node.grouping,
                    groupings: mapGroupEntitiesToVerboseDto(node.groupings || [])
                };

                if (node.userDefinedFieldDefinitionId != null) {
                    dto.groupingOptionName = node.groupingOptionName || node.title;
                    dto.userDefinedFieldDefinitionId = node.userDefinedFieldDefinitionId;
                    dto.userDefinedFieldEntity = node.userDefinedFieldEntity;
                    dto.userDefinedFieldCode = node.userDefinedFieldCode;
                }

                return dto;
            });
        }

        function getPerformanceOptions(entityID) {
            return $http.post("/Settings/EntityOptions/Database/0/Codes",
                [
                    "69ANNUALIZ", "69INCLUDEA", "69ALLOWFIR", "69ALLOWINT",
                    "69SUPPRESS", "69FORCEASS", "69ALLOWDIV", "69DAILYINTACCRUAL",
                    "1:69SUPPRE", "69CLIENTPE", "1:69ANNUAL", "INTRA:CALC",
                    "69DIVIDEND", "69CALCULAT", "69PRICECUT", "69UNMANAGE",
                    "INTRA:CALC", "69PERFAFTERTAX"
                ], {trackerMsg: 'Loading Performance Defaults'}
            );
        }

        function loadDefaults() {

            retrieveList('/Reporting/Envision/Reports/Settings', { trackerMsg: 'Loading Settings' })
                .then(function (res) {        
                    const activityOptions = res.data.filter(s => s.optionType === 'activity');
                    const activityDefault = activityOptions.find(a => a.isDefault);

                    const activitySelect = {
                        options: activityOptions,
                        value: activityDefault?.guid,
                        getName: (g) => activityOptions.find(o => o.guid === g)?.name
                    }
                    
                    batchObj.optionsObj['ACTAFTERTAX'] = activitySelect;
                });

            return retrieveList('/Performance/Batch/Verbose/New', { trackerMsg: 'Loading Default Values' })
                .then(function (res) {
                    instanceObj.obj = res.data;
                    return getPerformanceOptions();
                })
                .then(function (res) {
                    res.data.forEach(function (item) {
                        let spec = {
                            "69DAILYINTACCRUAL"() {
                                item.value = JSON.parse(item.value).enabled;
                            },
                            "1:69ANNUAL"() {
                                item.value = instanceObj.obj.options.performanceOptions.annualizeIncludeDaysWithoutValue;
                            },
                            "convBool"() {
                                item.value = JSON.parse(item.value.toLowerCase())
                            }
                        };
                        item.value === "True" || item.value === "False" ? spec["convBool"]() :
                            typeof spec[item.code] === 'function' ? spec[item.code]() :
                                null;
                        batchObj.optionsObj[item.code] = item;
                    });
                    batchObj.optionsObj.calcGrossOfFees = { value: instanceObj.obj.options.performanceOptions.calcGrossOfFees };
                    const normalizedDateRanges = mapBatchDateRangesToDateOnlyStrings(instanceObj.obj.options.dateRanges);
                    instanceObj.obj.options.dateRanges = normalizedDateRanges;
                    //map 1st half of defaults
                    batchObj.batchInfoObj = {
                        batchName: instanceObj.obj.batchName,
                        startDate: Date.create('today').addDays(-2),
                        endDate: Date.create('today').addDays(-1),
                        selectedPeriods: normalizedDateRanges.slice(),
                        benchmarks: instanceObj.obj.general.showBenchmarks,
                        monthly: false
                    };
                    batchObj.selectionObj = {
                        groupEntities: [
                            {
                                grouping: 5,
                                title: "Household",
                                groupings: []
                            }
                        ],
                        batchType: instanceObj.obj.general.runForEntity,
                        groupType: instanceObj.obj.options.entitySelectionMethod,
                        dynamicGroupingId: instanceObj.obj.options.dynamicGroupingId,
                        filter: (instanceObj.obj.options.filters === null),
                        filterBy: [
                            { active: false, filterId: 4, displayName: 'Representative', filterBy: 'Representative', ids: [] },
                            { active: false, filterId: 16, displayName: 'Aggregated  Style', filterBy: 'Aggregated  Style', ids: [] },
                            { active: false, filterId: 27, displayName: 'Aggregate Model', filterBy: 'Aggregate Model', ids: [] }
                        ],
                    };
                    return true;
                });
        }

        function retrieveList(str, trackerMsg) {
            return $http.get(str, trackerMsg);
        }

        function syncObj() {
            instanceObj.obj.batchName = batchObj.batchInfoObj.batchName;
            instanceObj.obj.general.startDate = batchObj.batchInfoObj.startDate.format('{MM}-{dd}-{yyyy}');
            instanceObj.obj.general.endDate = batchObj.batchInfoObj.endDate.format('{MM}-{dd}-{yyyy}');
            instanceObj.obj.options.dateRanges = mapBatchDateRangesToDateOnlyStrings(batchObj.batchInfoObj.selectedPeriods);
            instanceObj.obj.general.showBenchmarks = batchObj.batchInfoObj.benchmarks;

            instanceObj.obj.general.runForEntity = batchObj.selectionObj.batchType;
            instanceObj.obj.options.entitySelectionMethod = batchObj.selectionObj.groupType;
            instanceObj.obj.options.dynamicGroupingId = batchObj.selectionObj.dynamicGroupingId;
            instanceObj.obj.options.filters = batchObj.selectionObj.filterBy;

            instanceObj.obj.options.groupings = mapGroupEntitiesToVerboseDto(batchObj.selectionObj.groupEntities);

            instanceObj.obj.options.performanceOptions.annualize = batchObj.optionsObj["69ANNUALIZ"].value;
            instanceObj.obj.options.performanceOptions.includeAccruedInterest = batchObj.optionsObj["69INCLUDEA"].value;
            instanceObj.obj.options.performanceOptions.calcFirstDayPerformance = batchObj.optionsObj["69ALLOWFIR"].value;
            instanceObj.obj.options.performanceOptions.calcIntraDayPerformance = batchObj.optionsObj["69ALLOWINT"].value;
            instanceObj.obj.options.performanceOptions.suppressMixedRanges = batchObj.optionsObj["69SUPPRESS"].value;
            instanceObj.obj.options.performanceOptions.suppressMixedAssetLevelGroups = batchObj.optionsObj["1:69SUPPRE"].value;
            instanceObj.obj.options.performanceOptions.calculationMethod = batchObj.optionsObj["69CALCULAT"].value;
            instanceObj.obj.options.performanceOptions.calcGrossOfFees = batchObj.optionsObj.calcGrossOfFees.value;
            instanceObj.obj.options.accountInclusion = batchObj.optionsObj["69CLIENTPE"].value;
            instanceObj.obj.options.unmanagedInclusionOverride = batchObj.optionsObj["69UNMANAGE"].value;
            instanceObj.obj.options.performanceOptions.annualizeIncludeDaysWithoutValue = batchObj.optionsObj["1:69ANNUAL"].value;
            instanceObj.obj.options.performanceOptions.intradayCalculationMethod = batchObj.optionsObj["INTRA:CALC"].value;
            instanceObj.obj.options.performanceOptions.calcAfterTax = batchObj.optionsObj["69PERFAFTERTAX"].value;
            instanceObj.obj.options.afterTaxActivityOptionId = batchObj.optionsObj["ACTAFTERTAX"].value;
            instanceObj.obj.options.afterTaxActivityOptionName = batchObj.optionsObj["ACTAFTERTAX"].getName(batchObj.optionsObj["ACTAFTERTAX"].value);
            // {"69ALLOWDIV":obj.options.readOnlyOptions.allowDividendAccrual},
            // {"69DAILYINTACCRUAL":obj.options.readOnlyOptions.dailyInterestAccrual},
            // {"69DIVIDEND":obj.options.readOnlyOptions.dividendAccrualStartDate},
            // {"69FORCEASS":vm.instanceObj.obj.options.readOnlyOptions.forceAssetGroupingIntraday},
            // {"69PRICECUT":vm.instanceObj.obj.options.readOnlyOptions.localPriceCutOverDate},

            if (batchObj.selectionObj.entityIds) {
                instanceObj.obj.options.entityIds = batchObj.selectionObj.entityIds;
            }

            if (instanceObj.obj.options.filters.length > 0) {
                let base = angular.copy(instanceObj.obj.options.filters);
                base.forEach(function (filterType) {
                    if (!filterType.active) {
                        delete base[base.indexOf(base.find({filterBy: filterType.filterBy}))];
                    } else {
                        delete filterType.allowed;
                        delete filterType.active;
                        delete filterType.filterId;
                        delete filterType.displayName;
                        let tempIds = [];
                        filterType.ids.forEach(function (id) {
                            tempIds.push(id.id);
                        });
                        filterType.ids = tempIds;
                    }
                });
                instanceObj.obj.options.filters = [];
                base.forEach(function(filter){
                    if(filter){
                        instanceObj.obj.options.filters.push(filter);
                    }
                });
            }
        }

        function updateDynamicGroups( batchType) {
            if ( !batchType ) {
                batchType = 'Household';
            }

            return $http.get('/Utility/Groupings?usedFor=Reporting&entity=' + batchType, {trackerMsg: 'Loading dynamic groupings'});
        }

        function getDynamicGroupingOptions() {
            return $http.get('/Performance/Batch/Verbose/GroupingOptions', { trackerMsg: 'Loading dynamic groupings' });
        }

        // function retrieveGroupIds(id) {
        //     return $http.get('/Utility/Groupings/' + id, {trackerMsg: "Retrieving Group IDs"});
        // }

        return this;
    }
})();
(function () {
    'use strict';
    app.controller('BatchPerformanceListCtrl', ['$scope', '$http', '$location', '$portfolio', 'views', '$oasRights', '$dialog', 'bptWizardTracking', 'bptWizardServices', 'bptEntitySelectionTracking', 'entities', CTRL]);

    function CTRL($scope, $http, $location, $portfolio, views, $oasRights, $dialog, bptWizardTracking, bptWizardServices, bptEntitySelectionTracking, entities) {

        // INIT
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.rights={
            household : $oasRights.forCode("CLIENTS"),
            registration : $oasRights.forCode("REGISTRATIONS"),
            account : $oasRights.forCode("ACCOUNTS"),
            batchPerformance : $oasRights.forCode("BATCHPERFORMANCE")
        };

        $scope.current = {
            selected:{},
            view: views[0],
            loadUrl: '/Performance/Batch',
            gridDoubleClick: viewBatch
        };

        $scope.controls = {
            deleteBatch: deleteBatch,
            viewBatch:viewBatch,
            viewRunLog:viewRunLog,
            goToHigher:goToHigher,
            addNote:addNote
        };

        //EVENT LISTENERS
        $scope.$on('event:bpt-select', function (e, args) {
            e.stopPropagation();
            $scope.current.selected = args[0];
            $scope.selectedIds = args.map("id");
            bptEntitySelectionTracking.batchTracker = args[0];
        });

        // FUNCTIONS
        function deleteBatch( ) {
            $dialog.confirmAction( "Are you sure you want to delete this batch?" )
                .open()
                .then( function( result ) {
                    if( result == 'yes' ) {
                        bptWizardServices.deleteBatch($scope.selectedIds[0])
                            .then(function () {
                                $scope.$broadcast('event:bpt-action', {action: 'refresh-grid'});
                            });
                    }
                } );
        }
        function viewBatch() {
            $location.path('/reporting/performance/batchperformance/'+$scope.selectedIds[0]);
        }
        function viewRunLog() {
            let id = $scope.selectedIds[0];

            var dialogOpts = {
                dialogClass: "modal wide",
                templateUrl: 'reporting/performance/batchPerformanceTool/views/runLog.html',
                controller: ['$scope','dialog',importIdCTRL]
            };
            function importIdCTRL($scope, dialog) {
                $scope.close = close;

                //INIT()
                (function(){
                    bptWizardServices.retrieveList('/Performance/Batch/Verbose/'+id+'?expand=all', 'Retrieving Batch Information').then(function(res){
                        $scope.data = res.data;
                    });
                })();
                //FUNCTIONS
                function close() {
                    dialog.close(null);
                }
            }
            $dialog.dialog(dialogOpts).open();
        }
        function addNote(){
            $dialog.dialog({
                templateUrl: 'reporting/performance/batchPerformanceTool/views/modalNote.html',
                controller: ['$scope','dialog','selected',dialogCtrl],
                resolve: {
                    selected(){return angular.copy($scope.current.selected)}
                }
            }).open()
                .then(function (res) {
                    if(res.save){
                        if(res.note.description === null)res.note.description = '';
                        $http.put('/Performance/Batch/Verbose/'+$scope.current.selected.id+'/Description',"'"+res.note.description+"'",{trackerMsg:"Updating Notes"})
                            .then(function(res){
                                $scope.current.selected.description = res.data;
                                refreshGrid();
                            });
                    }
                });
            function dialogCtrl($scope, dialog, selected){
                $scope.selected = selected;
                $scope.close = close;

                function close(save){
                    dialog.close({save:save, note:$scope.selected});
                }
            }
        }
        function goToHigher( urlLevel ) {
            if( urlLevel === 'households' && $scope.current.selectedHouseholdId > 0 ) {
                $portfolio.goTo( urlLevel, entities.client.value, $scope.current.selectedHouseholdId);
            } else if( urlLevel === 'registrations' && $scope.current.selectedRegistrationId > 0 ) {
                $portfolio.goTo( urlLevel, entities.registration.value, $scope.current.selectedRegistrationId);
            } else if( urlLevel === 'accounts' && $scope.current.selectedAccountId > 0 ) {
                $portfolio.goTo( urlLevel, entities.account.value, $scope.current.selectedAccountId);
            }
        }
        function refreshGrid() {
            $scope.$broadcast('event:bpt-action', {action: 'refresh-grid'});
        }

    }
})();
'use strict';

(function () {
    app.controller('batchPerformanceDetailCtrl', ['$scope', '$location', '$http', '$oasRights', '$routeParams', '$timeout', '$portfolio', 'views', 'entities', 'bptWizardServices', 'bptEntitySelectionTracking', CTRL]);

    function CTRL($scope, $location, $http, $oasRights, $routeParams, $timeout, $portfolio, views, entities, bptWizardServices, bptEntitySelectionTracking) {
        var compareDetails = [], itemsToUpdate = [], onRouteChangeOff, canSubscribe = true;
        $scope.rights={
            batchPerformance : $oasRights.forCode("BATCHPERFORMANCE"),

            household : $oasRights.forCode("CLIENTS"), //--
            registration : $oasRights.forCode("REGISTRATIONS"), //--
            account : $oasRights.forCode("ACCOUNTS"), //--
            asset : $oasRights.forCode("ASSETS"), //--
            product : $oasRights.forCode("PRODUCTS"), //--
            platform : $oasRights.forCode("MGMTSTYLES"), //--
            riskCategory : $oasRights.forCode("RISKCAT"), //--
            aggregatedModel : $oasRights.forCode("MODELAGGS"), //--
            assetClass : $oasRights.forCode("ASSETCLASSES"), //--
            assetCategory : $oasRights.forCode('PRODUCTCATEGORY') //--
        };
        $scope.routeID = $routeParams.id;
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.notes = [];
        $scope.compare = {};
        $scope.current = {
            view: views[0],
            gridUrl:"/Performance/Batch/" + $routeParams.id + "/Details/ByEntities",
            postData:JSON.stringify(bptEntitySelectionTracking.entityTracker),
            idProperty: 'performanceBatchId,entityId,groupId,groupEntityId,benchmarkName,benchmarkId',
            performanceCompareId: $routeParams.id,
            actionStatusList: [],
            params: "",
            statusNoteIds: [],
            batch:{}
        };
        $scope.status = {
            canReset: false
        };
        $scope.selectedDetail = {
            entity: null,
            entityId: null,
            startDate: null,
            endDate: null
        };
        $scope.counts = {
            complete: {value: 0, change: false},
            pending: {value: 0, change: false},
            total: {value: 0, change: false}
        };

        $scope.controls = {
            goTo:goTo,
            exportToExcel:exportToExcel,
            isContextMenuEmpty:isContextMenuEmpty
        };

        $scope.updateView = function(pivotType) {
            $scope.current.url = "";
            var url = "";
            $scope.current.view.pageCode = "";
            if(pivotType === 'entityPivot') {
                url = '/Settings/Views/PerformanceBatchEntityDetailPivotDto:' + $routeParams.id;
                $scope.current.idProperty = 'performanceBatchId,entityId,groupId,groupEntityId,benchmarkName';
            }
            else {
                url = '/Settings/Views/PerformanceBatchEntityDetailDto';
                $scope.current.idProperty = 'id,entityId';
            }
            $scope.$broadcast('event:bpd-action', {action: 'clear-items'});
            $http.get(url, {cache: true, trackerMsg: 'Loading performance data'})
                .then(function (response){
                    $scope.views = response.data;
                    $scope.current.view = response.data[0];
                    slickGridDataUpdate();
                });
        };

        function slickGridDataUpdate() {
            if($scope.current.view.pageCode === 'PerformanceBatchEntityDetailDto') {
                $scope.current.gridUrl = "/Performance/Batch/" + $routeParams.id + "/Details"; // Timeframe URL
            }
            else {
                $scope.current.gridUrl = "/Performance/Batch/" + $routeParams.id + "/Details/ByEntities"; // Entities URL
            }
            $timeout(function() {
                $scope.$broadcast('event:bpd-action', {action: 'refresh-grid'});
            });
        }

        //EVENT LISTENERS
        $scope.$on('event:bpd-select', function (e, args) {
            e.stopPropagation();
            console.log(entities);
            if(args[0]){
                $scope.selected = {
                    groupEntityEnum: args[0].groupEntityEnum,
                    groupEntityId: args[0].groupEntityId,
                    entities:[]
                };
                (args[0].entityPath.split('->')).forEach(function(ent){
                    let temp = ent.trim().split(' ');
                    $scope.selected.entities.push({entityName:temp.slice(0,temp.length-1).join(' '),entityID:temp[temp.length-1]});
                });
            }

        });

        //INIT
        (function () {
            bptWizardServices.retrieveList('/Performance/Batch/'+$routeParams.id,{trackerMsg: "Loading batch information"})
                .then(function(res){
                    $scope.current.batch = res.data;
                })
            ;


        })();

        //FUNCTIONS


        function addItems(list) {
            $scope.counts.complete.value += list.count();
            $scope.$broadcast('event:bpd-action', {action: 'add-items', markAsNew: false, items: list});
            refreshGrid();

        }

        function refreshGrid() {
            $scope.$broadcast('event:bpd-action', {action: 'refresh-grid'});
        }

        function isContextMenuEmpty() {
            if ($scope.selected && $scope.selected.entities) {
                let ret = true;
                ['Client', 'Account', 'Registration', 'Asset', 'Product', 'Platform', 'Risk Category', 'Aggregated Model', 'Asset Class', 'Asset Category']
                    .forEach(function (item) {
                        if ($scope.selected.entities.find({entityName: item})) ret = false;
                    });
                return ret;
            }
        }

        function goTo(urlLevel,id) {
            let go = {
                'Product'(id){
                    $portfolio.goToProduct(id);
                },
                'Platform'(id){
                    $location.url('/portfolio/managementstyles/'+id);
                },
                'Risk Category'(id){
                    $location.url('/riskcategories/'+id);
                },
                'Aggregated Model'(id){
                    $location.url('/modeling/modelaggs/'+id);
                },
                'Asset Class'(id){
                    $location.url('/assetclasses/'+id);
                },
                'Asset Category'(id){
                    $location.url('/assetcategories/'+id);
                },
                'default'(urlLevel,id){
                    let ent = entities[urlLevel.toLowerCase()];
                    $portfolio.goTo(ent.urlFrag, ent.value, id);
                }
            };
            (typeof go[urlLevel] === "function")? go[urlLevel](id) : go['default'](urlLevel,id);
        }

        function exportToExcel() {
            $scope.$broadcast('event:bpd-action', {action: 'export-data'});
        }
    }
})();
var batchPerformanceDetail = {
    loadPerformanceDetailView: ['$http', '$route', function ($http, $route) {
        return $http.get('/Settings/Views/PerformanceBatchEntityDetailPivotDto:' + $route.current.params.id, {trackerMsg: 'Loading performance data'})
            .then(function (res) {
                return res.data;
            });
    }]
};

(function(){
    'use strict';
    app.controller('batchPerformanceToolWizardCtrl',CTRL);
    function CTRL(bptWizardTracking, bptWizardServices, $location, $oasRights, $dialog){
        let vm = this;
        vm.title = "Batch Performance Tool";
        vm.ready = false;
        vm.steps = [
            {id:'batchInfo',    name:'Batch Info',          index:0},
            {id:'selection',    name:'Selection',           index:1},
            {id:'options',      name:'Performance Options', index:2},
            {id:'review',       name:'Review & Submit',     index:3}
        ];
        vm.tracking = bptWizardTracking;
        vm.services = bptWizardServices;
        vm.rightsBatchPerformance = $oasRights.forCode("BATCHPERFORMANCE");

        // batchObj;
        vm.hideControls = false;
        vm.controls={
            next:next,
            back:back,
            createBatch:createBatch,
            close:close
        };

        //INIT
        (function(){
            vm.services.loadDefaults()
                .then(function (res) {
                    vm.ready = res;
                    vm.tracking.setCurrentStep({id: 'batchInfo', name: 'Batch Info', index: 0});
                    vm.hideControls = false;
                });
        })();
        //functions
        function next() {
            const error = datesAreValid();
            if (!error) {
                vm.tracking.setCurrentStep(vm.steps[vm.tracking.getCurrentStep().index+1]);
            } else {
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Date", error).open();
            }
        }
        function back(){
            vm.tracking.setCurrentStep(vm.steps[vm.tracking.getCurrentStep().index-1]);
        }
        function close(){
            $location.path("/reporting/performance/batchperformance");
            vm.tracking.setCurrentStep(vm.steps[0]);
        }
        function createBatch(){
            vm.hideControls = true;
            vm.services.syncObj();
            vm.services.createBatch(vm.services.instanceObj.obj)
                .then(function () {
                    $location.path("/reporting/performance/batchperformance");
                    vm.tracking.setCurrentStep(vm.steps[0]);
                });
        }
        function datesAreValid() {
            var batchInfo = vm.services.batchObj.batchInfoObj;
            var periods = batchInfo.selectedPeriods;
            var today = Date.create('today');

            if (batchInfo) {
                //make sure what's provided is a date and it's equal to or less than today
                if (!angular.isDate(batchInfo.startDate)
                    || !angular.isDate(batchInfo.endDate)
                    || batchInfo.startDate > today
                    || batchInfo.endDate > today
                    || batchInfo.startDate > batchInfo.endDate
                    || batchInfo.startDate < Date.create("1/1/1900")
                    || batchInfo.endDate < Date.create("1/1/1900")) {
                    return "Please choose a valid date.";
                }

                if (periods) {
                    if (periods.any(p => (!Date.create(p.startDate) && p.name !== "Inception")
                        || !Date.create(p.endDate)
                        || (Date.create(p.startDate) > today && p.name !== "Inception")
                        || Date.create(p.endDate) > today)) {
                        return "Please choose a valid date.";
                    }
                }

                if (batchInfo.monthly) {
                    const startYear = batchInfo.startDate.getFullYear();
                    const endYear = batchInfo.endDate.getFullYear();
                    if (endYear - startYear > 5) {
                        return "Please choose a range within 5 years or less.";
                    }                    
                }
            }

            return null;
        }

    }
})();
(function () {
    'use strict';
    app.controller('batchPerformanceEntitiesCtrl', ['$scope', '$http', '$oasRights', '$routeParams', '$dialog', '$timeout', '$portfolio', '$location', 'views', 'entities', 'bptEntitySelectionTracking', CTRL]);

    function CTRL($scope, $http, $oasRights, $routeParams, $dialog, $timeout, $portfolio, $location, views, entities, bptEntitySelectionTracking) {
        var compare = [];
        $scope.rights={
            household : $oasRights.forCode("CLIENTS"),
            registration : $oasRights.forCode("REGISTRATIONS"),
            account : $oasRights.forCode("ACCOUNTS"),
            batchPerformance : $oasRights.forCode("BATCHPERFORMANCE")
        };
        $scope.status = {canReset: false};
        $scope.selected = {};
        $scope.counts = {
            notGenerated: {value: 0, change: false},
            errored: {value: 0, change: false},
            generated: {value: 0, change: false},
            pendingGeneration: {value: 0, change: false},
            total: {value: 0, change: false},
        };
        $scope.notes = [];
        $scope.compare = {};
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.current = {
            view: views[0],
            loadUrl: '/Performance/Batch/' + $routeParams.id + '/Entities ',
            gridDoubleClick: viewDetails,
            idProperty: 'groupEntityId',
            performanceCompareId: $routeParams.id,
            actionStatusList: [],
            params: "",
            statusNoteIds: [],
            batch:{}
        };
        $scope.controls = {
            viewDetails:viewDetails,
            goToHigher: goToHigher,
            filterActionStatus:filterActionStatus
        };
        $scope.canGenerateReport = function() {return ($scope.selected.generationStatus === 'Not Generated' || $scope.selected.generationStatus === 'Errored');};
        $scope.canReset = function() {return $scope.selected.generationStatus === 'Errored' || $scope.selected.generationStatus === 'Generated'; };

        //INIT
        (function () {
            $http.get('/Performance/Batch/' + $routeParams.id, { trackerMsg: "Loading batch information" })
                .then(function (res) {
                    $scope.current.batch = res.data;

                    if ($scope.current.batch.hangfireJobId) {
                        startGenerationStatusPolling();
                    }

                    $scope.$on('slickgrid-data-loaded', function (event, data) {                        
                        resetCounts();
                        var pending = false;
                        $scope.counts.total.value = data.count();           

                        data.forEach(function (item) {
                            if (item.generationStatus === 'Not Generated' || item.generationStatus === 'Pending Generation') {
                                pending = true;
                            }
                            updateCounts(item, 1);
                        });
                        compare = angular.copy(data);

                        if (!pending) {
                            stopGenerationStatusPolling();  
                        }
                    });
                });
        })();

        //EVENT LISTENERS
        $scope.$on('event:bpe-select', function (e, args) {
            e.stopPropagation();
            $scope.selected = {
                ids: args.map("id"),
                runForEntity: args[0].runForEntity,
                generationStatus: args[0].generationStatus,
                entity: args[0].entityId
            };
            bptEntitySelectionTracking.entityTracker = args.map("entityId");
        });

        //FUNCTIONS        
        function detailCount(statuses) {
            return compare.count(function(detail){
                return statuses.some(detail.actionStatus);
            });
        }

        function filterActionStatus(status) {
            var gridQueryId, filterFn;
            $scope.current.gridQueries = [];

            if(status.length === 0) return;

            gridQueryId = "PCD";
            status.each(function(s){
                gridQueryId += ("_" + s);
            });

            if($scope.current.gridQueries)
                $scope.current.gridQueries.remove({id: gridQueryId});
            else
                $scope.current.gridQueries = [];

            filterFn = function (x) {
                return status.some(x);
            };
            $scope.current.gridQueries.push({
                id: gridQueryId,
                name: status.join('/'),
                description: "Generation Status: " + status.join(' or '),
                field: "generationStatus",
                filterFn: filterFn,
                itemCount: detailCount(status),
                enabled: true
            });
        }

        function viewDetails(all){
            if(all)bptEntitySelectionTracking.entityTracker=[];
            $location.path('/reporting/performance/batchperformance/details/'+$routeParams.id);
        }

        function updateCounts(item, val) {
            let refmap={
                "Not Generated"         : 'notGenerated',
                "Errored"               : 'errored',
                "Generated"             : 'generated',
                "Pending Generation"    : 'pendingGeneration',
            };
            let ref = refmap[item.generationStatus];
            $scope.counts[ref].change = true;
            $scope.counts[ref].value += val;
            if ($scope.counts[ref].value < 0) {
                $scope.counts[ref].value = 0;
            }
            $timeout(function() {$scope.counts[ref].change = false;}, 500);
        }

        function resetCounts() {
            $scope.counts = {
                notGenerated: {value: 0, change: false},
                errored: {value: 0, change: false},
                generated: {value: 0, change: false},
                pendingGeneration: {value: 0, change: false},
                total: {value: 0, change: false},
            };
        }

        $scope.generate = function(all) {
            if(all && $scope.counts.notGenerated === 0 && $scope.counts.errored === 0) {
                $dialog.actionFailed("There are no entities to generate performance against.").open();
                return;
            }
            $http.post('/Performance/Batch/' + $routeParams.id + '/Entities/Action/Generate', (all ? null : $scope.selectedIds), {trackerMsg: 'Generating batch'})
                .then(function () {
                    refreshGrid();
                    startGenerationStatusPolling();
                });
        };

        $scope.cancelGeneration = function() {
            $dialog.confirmAction("Are you sure you want to cancel generating batch?")
                .open()
                .then(function(result) {
                    if (result === 'yes') {
                        $http.delete('/Performance/Batch/' + $routeParams.id + '/Entities/Action/Generate', {trackerMsg: 'Canceling Batch Generation'})
                            .then(function () {
                                stopGenerationStatusPolling();
                                refreshGrid();
                            });
                    }
                });
        };

        $scope.resetGeneration = function(all) {
            let msg;

            if (all) {
                if ($scope.counts.pendingGeneration.value > 0) {
                    msg = "Please cancel the generation of all entities prior to resetting the generation status.";
                    $dialog.actionFailed(msg).open();
                    return;
                } else {
                    msg = "Are you sure you want to reset all entities?  Doing so will delete any existing performance.";

                    //if resetting all entities then grab all appropriate entities and set selectedIds
                    $http.get($scope.current.loadUrl, { trackerMsg: "Loading entity information" })
                        .then(function(res) {
                            let resetIds = [];

                            res.data.map(function(e) {
                                if (e.generationStatus === 'Errored' || e.generationStatus === 'Generated') {
                                    resetIds.push(e.entityId);
                                }
                            });

                            $scope.selectedIds = resetIds;
                        });

                }
            } else {
                msg = "Are you sure you want to reset the selected entities?  Doing so will delete any existing performance.";
            }

            $dialog.confirmAction(msg)
                .open()
                .then(function(result){
                    if (result === 'yes' && $scope.selectedIds.length > 0) {
                        $http.post('/Performance/Batch/' + $scope.current.batch.id + '/Entities/Action/Reset', $scope.selectedIds, { trackerMsg: 'Resetting selected batch entities' })
                            .then(function(){
                                refreshGrid();
                            });
                    }
                });
        };

        $scope.$on('$destroy', function () {            
            stopGenerationStatusPolling();
        });

        function startGenerationStatusPolling() {
            $scope.generationStatusPolling = setInterval(() => {
                refreshGrid();
            }, 1000 * 30);
        }

        function stopGenerationStatusPolling() {
            if ($scope.generationStatusPolling) {
                clearInterval($scope.generationStatusPolling);
                $scope.generationStatusPolling = null;
            }
        }

        function refreshGrid() {
            $timeout(function () {
                $scope.$broadcast('event:bpe-action', {action: 'refresh-grid'});
            });
        }

        function goToHigher(urlLevel) {
            if (urlLevel === 'households' && $scope.selected.entity) {
                $portfolio.goTo(urlLevel, entities.client.value, $scope.selected.entity);
            } else if (urlLevel === 'registrations' && $scope.selected.entity) {
                $portfolio.goTo(urlLevel, entities.registration.value, $scope.selected.entity);
            } else if (urlLevel === 'accounts' && $scope.selected.entity) {
                $portfolio.goTo(urlLevel, entities.account.value, $scope.selected.entity);
            }
        }
    }
})();

var batchPerformanceEntities = {
    loadPerformanceEntitiesView: ['$http', function ($http) {
        return $http.get('/Settings/Views/PerformanceBatchEntityDto', {trackerMsg: 'Loading performance data'})
            .then(function (res) {
                return res.data;
            })
    }]
};

'use strict';

app.controller('ReportVersionAssignmentCtrl', function ReportVersionAssignmentCtrl($scope, $http, entities) {
    //PRIVATE METHODS
    function initialize() {
        $http.get('/ReportBuilder/Reports/Simple', {trackerMsg: 'Loading reports'})
            .then(function (response) {
                $scope.reports = response.data;
            });
    }

    //PUBLIC METHODS
    $scope.addClient = function() {
        if($scope.selector.selectedClient){
            $scope.current.clients.push($scope.selector.selectedClient);
            $scope.selector.selectedClient = null;
        }
    };

    $scope.removeClient = function (client) {
        $scope.current.clients.remove(client);
    };

    $scope.assign = function() {
        var reportId = $scope.current.selectedReport.id;
        $http.get('/ReportBuilder/Reports/' + reportId, {trackerMsg: 'Loading report ' + reportId})
            .then(function (response) {
                var report = response.data;

                if(report.includeUserByDefault && !report.isVersion) {
                    $scope.current.resultMsg = "No Changes: Clients are already assigned by default."
                    return;
                }

                var selectedIds = $scope.current.clients.map("id");
                var currentAccessList = [];
                var accessListCopy;
                if (report.isVersion) {
                    currentAccessList = report.clientAssignments;
                    accessListCopy = angular.copy(report.clientAssignments);
                } else {
                    currentAccessList = report.clientUsers;
                    accessListCopy = angular.copy(report.clientUsers);
                }
                selectedIds.forEach(function(id){
                    if(!currentAccessList.some(function(access){ return access === id; }))
                        currentAccessList.push(id);
                });

                if(!angular.equals(accessListCopy, currentAccessList)){
                    if (report.isVersion)
                        report.clientAssignments = currentAccessList;
                    else
                        report.clientUsers = currentAccessList;

                    $http.put('/ReportBuilder/Reports/' + reportId, report, {trackerMsg: "Saving report " + reportId})
                        .then(function () {
                            $scope.current.resultMsg = "Clients were assigned successfully."
                        })
                        .catch(function () {
                            $scope.current.resultMsg = "No Changes: An error occurred while assigning clients."
                        });
                } else {
                    $scope.current.resultMsg = "No Changes: Clients are already assigned."
                }
            });
    };

    //WATCHES
    $scope.$watch("selector.importClients", function (newValue, oldValue) {
        if (newValue === oldValue) return;

        var clientIds = Object.values($scope.selector.importClients[0].result)[0].map(function (item) {
            return Object.values(item)[0];
        });
        if (clientIds.length > 0) {
            $http.post(entities.client.simpleUrl + "/List", clientIds, {trackerMsg: 'Processing ' + $scope.selector.importClients[0].fileName})
                .then(function (response) {
                    if(response && response.data)
                        response.data.forEach(function(item){
                            item.icon = "fa-orion-household";
                            $scope.current.clients.push(item);
                        });
                });
        }
    });

    //INITIALIZE
    $scope.current = { clients: [], selectedReport: null, resultMsg: "" };
    $scope.selector = { selectedClient: null, importClients: null };
    $scope.reports = null;
    initialize();
});
'use strict';

app.controller('ReportInboxCtrl', function ReportInboxCtrl($scope, $http, $dialog, $oasRights, API_CONFIG) {

    //PRIVATE PROPERTIES
    var inbox;

    //PRIVATE METHODS
    function init( isFirstLoad ) {
        $http.get("/Reporting/ReportInbox", {trackerMsg: 'Loading report inbox'})
            .then(function(response) {
                if(response.data) {
                    inbox = response.data;
                    inbox.each(function(inboxItem){
                        inboxItem.createdDate = Date.create(inboxItem.createdDate).format('{MM}/{dd}/{yyyy}');  //Used to get filtering to work.
                    });
                    if( isFirstLoad ) {
                        $scope.sort('description');
                    }
                }
            });
    }

    //PUBLIC METHODS
    $scope.download = function(inboxId) {
        window.location.href = API_CONFIG.baseUrl + '/Reporting/ReportInbox/' + inboxId + '/Download' + '?Authorization=' + sessionStorage.oas_token;
    };

    $scope.refresh = function() {
        init( false );
    };

    $scope.delete = function(inboxItem){
        $dialog.confirmAction("Are you sure you want to delete \"" + inboxItem.description + "\" from your inbox?")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $http.delete("/Reporting/ReportInbox/" + inboxItem.id, {trackerMsg: 'Deleting ' + inboxItem.description + ' from inbox'})
                        .then(function() {
                            $scope.inbox.remove(inboxItem);
                        });
                }
            });
    };

    $scope.sort = function(sortField) {
        if($scope.sorting.sortBy !== sortField) {
            $scope.sorting.sortBy = sortField;
            $scope.sorting.isDescending = false;
        }
        else {
            $scope.sorting.isDescending = !$scope.sorting.isDescending;
        }
        $scope.inbox = inbox.sortBy(function(inboxItem) {
            return inboxItem[$scope.sorting.sortBy];
        }, $scope.sorting.isDescending);
    };

    //INIT
    $scope.rights = $oasRights.forCode("REPORTINBOXAPP");
    $scope.inbox = [];
    $scope.sorting = {sortBy: '', isDescending: false};
    init( true );
});
'use strict';

app.controller('ReportBatchListCtrl', function ReportBatchListCtrl( $scope, $rootScope, $http, $oasRights, $dialog, $timeout, views ) {
    //PRIVATE VARIABLES

    //PRIVATE METHODS
    function init(){
        delete sessionStorage.batchId;
    }

    //PUBLIC METHODS
    $scope.exportToExcel = function() {
        $scope.$broadcast('event:report-batches-action', {action: 'export-data'});
    };

    $scope.deleteBatch = function() {
        $dialog.confirmAction("Are you sure you want to delete this batch?  <span class='text-error'>All reports will also be deleted!</span>")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $http.delete('/Reporting/Batch/Verbose/' + $scope.selectedIds[0], {trackerMsg: 'Deleting batch'})
                        .then(function() {
                            $scope.$broadcast('event:report-batches-action', {action: 'refresh-grid'});
                        });
                }
            });
    };

    $scope.copyBatch = function(){
        var d = $dialog.editor("reporting/editors/views/report-batch-edit.html", "ReportBatchEditCtrl", {args: function() { return {
            ids: $scope.selectedIds,
            isNew: true,
            isCopy: true,
            defaultTab: {name: "General", active: true, code: "reportBatchGeneral"}
        }; }});

        d.open().then(function(rslt) {
            if( rslt ) {
                $scope.$broadcast('event:report-batches-action', {action: 'refresh-grid'});
            }
        });
    };

    $scope.updateList = function() {
        $timeout(function() {
            $scope.$broadcast('event:report-batches-action', {action: 'refresh-grid'});
        });
    };

    $scope.openBatchEditor = function(){
        var d = $dialog.editor("reporting/editors/views/report-batch-edit.html", "ReportBatchEditCtrl", {args: function() { return {
            ids: $scope.selectedIds,
            isNew: false,
            defaultTab: {name: "General", active: true, code: "reportBatchGeneral"}
        }; }});

        d.open().then(function(rslt) {
            if( rslt ) {
                if(rslt === "delete" || rslt.isSaved) {
                    $scope.$broadcast('event:report-batches-action', {action: 'refresh-grid'});
                }
            }
        });
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            location.href = '#/reports/batches/entities?batchId=' + $scope.selectedIds[0];
    };

    //EVENT LISTENERS
    $scope.$on('event:report-batches-select', function (e, args) {
        e.stopPropagation();
        if (args.length === 0) {
            delete sessionStorage.batchId;
            delete sessionStorage.restrictReps;
            return;
        }

        $scope.selectedIds = args.map("id");
        sessionStorage.batchId = $scope.selectedIds[0];

        $scope.restrictReps = args.map("restrictReps")[0];
        sessionStorage.restrictReps = $scope.restrictReps;
    });

    //INITIALIZE
    $scope.rightsReportBatch = $oasRights.forCode("REPORTBATCHNEW");
    $scope.rightsReportBatchAdmin = $oasRights.forCode("REPORTBATCH_ADMIN");
    $scope.canViewQuantum = ['Administrator', 'Advisor'].any($scope.user.authorization.entity);
    $scope.views = views;

    $scope.selectedIds = [];
    $scope.current = { view : views[0], gridDoubleClick: $scope.slickGridDoubleClick };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1 && $scope.rightsReportBatchAdmin.canRead) {
            $scope.openBatchEditor($scope.selectedIds[0]);
        }
    }}];
    init();
});
'use strict';

var ReportBatchEntitiesCtrl = app.controller ('ReportBatchEntitiesCtrl', function ReportBatchEntitiesCtrl( $scope, $http, $oasRights, $routeParams, $window, $location, $timeout, $dialog, views, entities, syncStatus, API_CONFIG, $signalRManager, privilegeService) {
    //PRIVATE VARIABLES
    var simpleBatchEntities = [], onRouteChangeOff, canSubscribe = true;
    var electronicStatementBatchEntities = ['Household', 'Registration', 'Account', 'Portfolio Group'];
    var printVendorBatchEntities = ['Household', 'Registration', 'Account', 'Portfolio Group'];

    //PRIVATE METHODS
    function batchSupportsElectronicStatement() {
        return electronicStatementBatchEntities.some($scope.batch.entity);
    }

    function batchSupportsPrintVendor() {
        return printVendorBatchEntities.some($scope.batch.entity);
    }

    function isEligibleForElectronicStatement(entity) {
        return entity.generationStatus === 'Generated'
            && (entity.viewableBy === 'Household' || entity.viewableBy === 'Client')
            && (entity.emailStatus === 'Errored' || entity.emailStatus === 'Has not been sent');
    }
    function init() {
        if(sessionStorage.newBatchId && sessionStorage.newBatchId === $routeParams.batchId) {
            delete sessionStorage.newBatchId;
            delete sessionStorage.restrictReps;
            newBatchNotice();
        }
        $scope.current.batchId = $routeParams.batchId;
        if(!$scope.current.batchId) {
            if(sessionStorage.batchId) {
                $location.url('/reports/batches/entities' + ($routeParams.generationStatus ? ('/' + $routeParams.generationStatus) : '') + '?batchId=' + sessionStorage.batchId);
            }
            else {
                $http.get('/Reporting/Batch?activeOnly=true', {trackerMsg: 'Loading report batches'})
                    .then(function (response) {
                        $dialog.inputBox("Batch Selection", "Name", response.data)
                            .open()
                            .then(function (result) {
                                if (result) {
                                    sessionStorage.batchId = result.id;
                                    $location.url('/reports/batches/entities' + ($routeParams.generationStatus ? ('/' + $routeParams.generationStatus) : '') + '?batchId=' + result.id);
                                }
                            });
                    });
            }
        }
        else {
            $scope.current.url = '/Reporting/Batch/' + $scope.current.batchId + '/Entities';
            updateUrlParameters();
            initSignalR();
            $http.get('/Reporting/Batch/Verbose/' + $scope.current.batchId, {trackerMsg: 'Loading report batch'})
                .then(function (response) {
                    $scope.batch = response.data.batch;
                    $scope.batch.reportName = $scope.batch.isAdvisoryFee ? "Advisory Fee Notification" : response.data.reportName;
                    $scope.batch.hasCoverPage = response.data.hasCoverPage;
                    $scope.restrictReps = response.data.batch.restrictReps;
                    $scope.isPageLoading = false;
                    updateEligibleElectronicStatementCount();
                });
        }
    }

    function newBatchNotice() {
        var message = "The batch has been created with the entities you wanted but no reports have been generated.<br /><br />" +
            "To run reports you need to use the \"Actions\" dropdown located in the upper right-hand corner of your screen. " +
            "You can also run for one or more entities in the list (hold the Ctrl key to select more than one entity). " +
            "Once a selection has been made right click and select \"Generate Report.\"";
        $dialog.messageBox("You’re not done yet!!", message).open();
    }

    function initSignalR(){
        $.connection.hub.qs["reportBatchId"] = $scope.current.batchId;
        $signalRManager.subscribeToHub( 'reportBatchEntitiesHub', 'resetList', null, resetList );
        $signalRManager.subscribeToHub( 'reportBatchEntitiesHub', 'addItems', null, addItems );
        $signalRManager.subscribeToHub( 'reportBatchEntitiesHub', 'updateItems', null, updateItems );
        $signalRManager.subscribeToHub( 'reportBatchEntitiesHub', 'removeItems', null, removeItems );
        onRouteChangeOff =  $scope.$on("$routeChangeStart", unsubscribeHubs);
    }

    function resetList(subscribe) {
        if(subscribe === undefined) {
            refreshGrid();
            return;
        }

        canSubscribe = subscribe;
        if(!canSubscribe)
            unsubscribeHubs();
    }

    function addItems(list) {
        $scope.$broadcast('event:report-batch-entities-action', {action: 'upsert-items', items: list });
        list.forEach(function(item){
            increaseCount(item);
            $scope.counts.total.value++;
            simpleBatchEntities.push(item);
        });
        updateEligibleElectronicStatementCount();
    }

    function updateItems(list) {
        $scope.$broadcast('event:report-batch-entities-action', {action: 'upsert-items', items: list });
        list.forEach(function(item){
            var entityItem = simpleBatchEntities.find({id: item.id});
            if (!entityItem) {
                return;
            }

            if (entityItem.generationStatus !== item.generationStatus) {
                decreaseCount(entityItem);
                increaseCount(item);
                entityItem.generationStatus = item.generationStatus;
            }

            entityItem.viewableBy = item.viewableBy;
            entityItem.emailStatus = item.emailStatus;
            entityItem.printVendorStatus = item.printVendorStatus;
        });
        updateEligibleElectronicStatementCount();
    }

    function removeItems(list) {
        $scope.$broadcast('event:report-batch-entities-action', {action: 'delete-items', items: list });
        list.forEach(function(item){
            var entityItem = simpleBatchEntities.find({id: item.id});
            decreaseCount(entityItem);
            $scope.counts.total.value--;
            simpleBatchEntities.remove(entityItem);
        });
        updateEligibleElectronicStatementCount();
    }

    function increaseCount(entityItem) {
        switch(entityItem.generationStatus) {
            case "Pending Generation":
                $scope.counts.pendingGeneration.value++;
                break;
            case "Not Generated":
                $scope.counts.notGenerated.value++;
                break;
            case "Errored Report":
                $scope.counts.errored.value++;
                break;
            case "Generated":
                $scope.counts.generated.value++;
                break;
            case "On Hold":
                $scope.counts.onHoldNoStatement.value++;
                break;
        }
    }

    function decreaseCount(entityItem){
        switch(entityItem.generationStatus) {
            case "Pending Generation":
                $scope.counts.pendingGeneration.value--;
                break;
            case "Not Generated":
                $scope.counts.notGenerated.value--;
                break;
            case "Errored Report":
                $scope.counts.errored.value--;
                break;
            case "Generated":
                $scope.counts.generated.value--;
                break;
            case "On Hold":
                $scope.counts.onHoldNoStatement.value--;
                break;
        }
    }

    function entityCount(statuses) {
        return simpleBatchEntities.count(function(entity){
            if(statuses)
                return statuses.some(entity.generationStatus) && $scope.current.syncStatusSelection.some(entity.syncStatus.toLocaleLowerCase());
            else
                return $scope.current.syncStatusSelection.some(entity.syncStatus.toLocaleLowerCase());
        });
    }

    function eligibleElectronicStatementCount() {
        if (!batchSupportsElectronicStatement())
            return 0;

        return simpleBatchEntities.count(function(entity) {
            return isEligibleForElectronicStatement(entity)
                && $scope.current.syncStatusSelection.some(entity.syncStatus.toLocaleLowerCase());
        });
    }

    function updateEligibleElectronicStatementCount() {
        $scope.counts.eligibleElectronicStatement.value = eligibleElectronicStatementCount();
    }

    function updateCounts() {
        $scope.counts.total.value = entityCount();
        $scope.counts.pendingGeneration.value = entityCount(["Pending Generation"]);
        $scope.counts.notGenerated.value = entityCount(["Not Generated"]);
        $scope.counts.errored.value = entityCount(["Errored Report"]);
        $scope.counts.generated.value = entityCount(["Generated"]);
        $scope.counts.onHoldNoStatement.value = entityCount(["On Hold", "Will not be generated"]);
        updateEligibleElectronicStatementCount();
    }

    function unsubscribeHubs() {
        $signalRManager.unSubscribeToHub( 'reportBatchEntitiesHub', 'resetList' );
        $signalRManager.unSubscribeToHub( 'reportBatchEntitiesHub', 'addItems' );
        $signalRManager.unSubscribeToHub( 'reportBatchEntitiesHub', 'updateItems' );
        $signalRManager.unSubscribeToHub( 'reportBatchEntitiesHub', 'removeItems' );
        delete $.connection.hub.qs["reportBatchId"];

        onRouteChangeOff();
    }

    function refreshGrid( ) {
        $scope.$broadcast('event:report-batch-entities-action', {action: 'refresh-grid'});
    }

    function updateUrlParameters() {
        $scope.current.urlParameters = '';
        $scope.current.generationStatus.forEach(function(g){
            if($scope.current.urlParameters.trim().length === 0)
                $scope.current.urlParameters += ('generationStatus=' + g);
            else
                $scope.current.urlParameters += ('&generationStatus=' + g);
        });
        $scope.current.syncStatusSelection.forEach(function(s){
            if(s.trim() != '') {
                if($scope.current.urlParameters.trim().length === 0)
                    $scope.current.urlParameters += ('syncStatus=' + s);
                else
                    $scope.current.urlParameters += ('&syncStatus=' + s);
            }
        });
    }


    //PUBLIC METHODS
    $scope.filterGenerationStatus = function(status) {
        var gridQueryId, filterFn;

        $scope.current.gridQueries = [];

        if(status.length === 0) return;

        gridQueryId = "RBE";
        status.each(function(s){
            gridQueryId += ("_" + s);
        });

        if($scope.current.gridQueries)
            $scope.current.gridQueries.remove({id: gridQueryId});
        else
            $scope.current.gridQueries = [];

        filterFn = function (x) {
            return status.some(x);
        };
        $scope.current.gridQueries.push({
            id: gridQueryId,
            name: status.join('/'),
            description: "Generation Status: " + status.join(' or '),
            field: "generationStatus",
            filterFn: filterFn,
            itemCount: entityCount(status),
            enabled: true
        });
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:report-batch-entities-action', {action: 'export-data'});
    };

    $scope.generate = function(all) {
        if(all && entityCount() === 0) {
            $dialog.actionFailed("There are no entities to generate reports against.").open();
            return;
        }
        $http.post('/Reporting/Batch/' + $scope.current.batchId + '/Entities/Action/Generate', (all ? null : $scope.selectedIds), {trackerMsg: 'Generating report(s)'})
            .then(function(){
                if(!canSubscribe) {
                    refreshGrid();
                }
            });
    };

    $scope.batchSupportsPrintVendor = batchSupportsPrintVendor;

    $scope.sendToPrint = function (all) {
        if (!batchSupportsPrintVendor()) {
            $dialog.actionFailed('Send to print vendor is not supported for this batch entity level.').open();
            return;
        }
        var message = "Are you sure you want to send to the print vendor?<br /><br />" +
                      "<em>Note: Please check your notifications to ensure your statement transmission to the print vendor was successful.</em>",
            dialogType = "confirmAction";

        if (!$scope.batch.hasCoverPage) {
            if ($scope.user.authorization.entity === "Administrator") {
                message = "A cover page is not detected.<br /><br />" + message;
            } else {
                message = "A cover page is not detected.  Please update the report to include a cover page and rerun the batch.";
                dialogType = "actionFailed";
            }
        }

        $dialog[dialogType](message)
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.post('/Reporting/Batch/' + $scope.current.batchId + '/Entities/Action/SendToPrintVendor', (all ? null : $scope.selectedIds), {trackerMsg: 'Sending report(s) to print vendor'})
                        .then(function () {
                            if (!canSubscribe)
                                refreshGrid();
                        });
                }
            });
    };

    $scope.sendElectronicStatement = function(all) {
        if (!batchSupportsElectronicStatement()) {
            $dialog.actionFailed('Electronic statement notifications are not supported for this batch entity level.').open();
            return;
        }
        if (!$scope.batch.emailFrom || !$scope.batch.emailSubject || !$scope.batch.emailBody) {
            $dialog.actionFailed('Configure the batch email template (From, Subject, and Body) before sending electronic statement notifications.').open();
            return;
        }
        if (!all && (!$scope.selectedIds || $scope.selectedIds.length === 0)) {
            $dialog.actionFailed('Select at least one generated entity before sending an electronic statement notification.').open();
            return;
        }
        if (all && eligibleElectronicStatementCount() === 0) {
            $dialog.actionFailed('There are no generated entities eligible to send electronic statement notifications. Entities must have Viewable By set to Household and Email Status of Has not been sent or Errored.').open();
            return;
        }

        $dialog.confirmAction("Are you sure you want to send e-statement notifications?")
            .open()
            .then(function(result) {
                if (result === 'yes') {
                    $http.post('/Reporting/Batch/' + $scope.current.batchId + '/Entities/Action/SendElectronicStatement', (all ? null : $scope.selectedIds), {trackerMsg: 'Sending electronic statement(s)'})
                        .then(function(){
                            if(!canSubscribe)
                                refreshGrid();
                        });
                }
            });
    };

    $scope.cancelGeneration = function() {
        $dialog.confirmAction("Are you sure you want to cancel generating reports?")
            .open()
            .then(function(result) {
                if (result === 'yes') {
                    $http.delete('/Reporting/Batch/' + $scope.current.batchId + '/Entities/Action/Generate', {trackerMsg: 'Cancel generating report(s)'})
                        .then(function () {
                            if(!canSubscribe)
                                refreshGrid();
                        });
                }
            });
    };

    $scope.putOnHold = function() {
        $dialog.confirmAction("Are you sure you want to put the selected entities on hold?  Doing so will delete any existing reports.")
            .open()
            .then(function(result){
                if (result === 'yes') {
                    $http.post('/Reporting/Batch/' + $scope.current.batchId + '/Entities/Action/OnHold?onHold=true', $scope.selectedIds, {trackerMsg: 'Placing selected batch entities on hold'})
                        .then(function(){
                            if(!canSubscribe)
                                refreshGrid();
                        });
                }
            });
    };

    $scope.takeOffHold = function(generate) {
        $http.post('/Reporting/Batch/' + $scope.current.batchId + '/Entities/Action/OnHold?onHold=false&generate=' + generate, $scope.selectedIds, {trackerMsg: 'Taking selected batch entities off hold'})
            .then(function(){
                if(!canSubscribe)
                    refreshGrid();
            });
    };

    $scope.reset = function(status) {
        var msg, endpoint;
        switch(status) {
            case 'Generation':
                msg = "Are you sure you want to reset the selected entities?  Doing so will delete any existing reports.";
                endpoint = '/Reporting/Batch/' + $scope.current.batchId + '/Entities/Action/ResetGeneration';
                break;
            case 'PrintVendor':
                msg = "Are you sure you want to reset the selected entities' print vendor statuses?";
                endpoint = '/Reporting/Batch/' + $scope.current.batchId + '/Entities/Action/ResetPrintVendor';
                break;
            case 'ElectronicStatement':
                msg = "Are you sure you want to reset the selected entities' e-statement notifications?";
                endpoint = '/Reporting/Batch/' + $scope.current.batchId + '/Entities/Action/ResetElectronicStatement';
                break;
        }
        $dialog.confirmAction(msg)
            .open()
            .then(function(result){
                if (result === 'yes') {
                    $http.post(endpoint, $scope.selectedIds, {trackerMsg: 'Resetting selected batch entities'})
                        .then(function(){
                            if(!canSubscribe)
                                refreshGrid();
                        });
                }
            });
    };

    $scope.viewableBy = function(all) {
        var dialogOpts = {
            templateUrl: "viewableBy.html",
            controller: "ViewableByCtrl",
            entities: $scope.current.viewableByList
        };
        $dialog.dialog(dialogOpts)
            .open()
            .then(function(result){
                if (result) {
                    $http.post('/Reporting/Batch/' + $scope.current.batchId + '/Entities/Action/ViewableBy?viewableBy=' + result, (all ? null : $scope.selectedIds), {trackerMsg: 'Updating viewable status.'})
                        .then(function(){
                            if(!canSubscribe)
                                refreshGrid();
                        });
                }
            });
    };

    $scope.setSyncStatus = function() {
        updateUrlParameters();
        $timeout(function() {refreshGrid();});
    };

    $scope.syncEntities = function() {
        $http.post('/Reporting/Batch/' + $scope.current.batchId + '/Entities/Action/Sync', {trackerMsg: 'Syncing entities'})
            .then(function(response){
                var count = response.data;
            });
    };

    $scope.syncEntityList = function() {
        var entity = entities[entities.find({name: $scope.batch.entity})];

        var dialogOpts = {
            templateUrl: "reporting/modals/syncEntityList.html",
            controller: "SyncEntityListCtrl",
            entity: entity.name
        };
        $dialog.dialog(dialogOpts)
            .open()
            .then(function(rslt){
                if(!rslt) return;

                if (rslt.ids.length > 0) {
                    var entityList = rslt.ids.map(function(id){ return {id:id}; });
                    $http.post('/Reporting/Batch/' + $scope.current.batchId + '/Entities/Action/SyncList?addOnly=' + rslt.addOnly, entityList, {trackerMsg: 'Syncing entity list'});
                } else {
                    $http.post('/Reporting/Batch/' + $scope.current.batchId + '/Entities/Action/SyncList?addOnly=' + rslt.addOnly, null, {trackerMsg: 'Syncing entity list'});
                }
            });
    };

    $scope.download = function () {
        $window.location.href = API_CONFIG.baseUrl + '/Reporting/Batch/' + $scope.current.batchId + '/Entities/' + $scope.selectedIds[0] + '/Action/Download?Authorization=' + sessionStorage.oas_token;
    };

    $scope.downloadBatch = function (status, combineMethod) {
        var url = '/Reporting/Batch/' + $scope.current.batchId + '/Entities/Action/Download';

        if(status !== undefined && status !== null)
            url += ('?status=' + status);

        if(combineMethod !== undefined && combineMethod !== null)
            url += ('?combinationMethod=' + combineMethod);

        $http.post(url, ((status !== undefined && status !== null) ? null : $scope.selectedIds), {trackerMsg: 'Creating a batch download'})
            .then(function(response){
                $window.location.href = response.headers("location") + "?Authorization=" + sessionStorage.oas_token;
            });
    };

    $scope.openBatchEditor = function(){
        var d = $dialog.editor("reporting/editors/views/report-batch-edit.html", "ReportBatchEditCtrl", {args: function() { return {
            ids: [$scope.current.batchId],
            isNew: false,
            defaultTab: {name: "General", active: true, code: "reportBatchGeneral"}
        }; }});

        d.open().then(function(rslt) {
            if( rslt ) {
                if(rslt === "delete") {
                    $location.url('/reports/batches');
                }
                else if(rslt.isSaved) {
                    $scope.batch = rslt.batch;
                    $scope.batch.reportName = rslt.reportName;
                }
            }
        });
    };

    $scope.lockDownBatch = function(lockdown) {
        $http.post('/Reporting/Batch/' + $scope.current.batchId + '/Action/ToggleLockDown?lockdown=' + lockdown, {trackerMsg: lockdown ? 'Locking down batch' : 'Unlocking batch'})
            .then(function(response){
                $scope.batch.isLockedDown = response.data.isLockedDown;
            });
    };


    //EVENT LISTENERS
    $scope.$on('slickgrid-data-loaded', function(event, data) {
        simpleBatchEntities = angular.copy(data);
        updateCounts();
    });

    $scope.$on('event:report-batch-entities-select', function (e, args) {
        e.stopPropagation();
        if (args.length === 0) return;

        $scope.current.canDownload = args.every({hasFile: true});
        $scope.current.canPutOnHold = args.every(function(a){ return a.generationStatus === 'Not Generated' || a.generationStatus === 'Errored Report' || a.generationStatus === 'Generated'; });
        $scope.current.canTakeOffHold = args.every({generationStatus: 'On Hold'});
        $scope.current.canReset = args.every(function(a){ return a.generationStatus === 'Errored Report' || a.generationStatus === 'Generated'; });
        $scope.current.canResetPrintVendor = batchSupportsPrintVendor() && args.every(function(a){ return a.printVendorStatus === 'Errored' || a.printVendorStatus === 'Successfully sent'; });
        $scope.current.canResetElectronicStatement = args.every(function(a){ return a.emailStatus === 'Errored' || a.emailStatus === 'Successfully sent'; });
        $scope.current.canChangeViewableSetting = args.every({generationStatus: 'Generated'});
        $scope.current.canGenerateReport = args.every(function(a){ return a.generationStatus === 'Not Generated' || a.generationStatus === 'Errored Report'; });
        $scope.current.canSendToPrintVendor = batchSupportsPrintVendor() && args.every(function(a){ return a.generationStatus === 'Generated' && (a.printVendorStatus === 'Errored' || a.printVendorStatus === 'Has not been sent'); });
        $scope.current.canSendElectronicStatement = batchSupportsElectronicStatement() && args.every(isEligibleForElectronicStatement);
        $scope.current.viewableByList = args.map('viewableBy').unique();
    });

    //WATCHES
    $scope.$watch("counts.total.value", function(newValue, oldValue){
        if (newValue === oldValue) return;

        if($scope.counts.total.change)
            $scope.counts.total.change = false;

        $scope.counts.total.change = true;
        $timeout(function() {$scope.counts.total.change = false;}, 500);
    });

    $scope.$watch("counts.pendingGeneration.value", function(newValue, oldValue){
        if (newValue === oldValue) return;

        if($scope.counts.pendingGeneration.change)
            $scope.counts.pendingGeneration.change = false;

        $scope.counts.pendingGeneration.change = true;
        $timeout(function() {$scope.counts.pendingGeneration.change = false;}, 500);
    });

    $scope.$watch("counts.notGenerated.value", function(newValue, oldValue){
        if (newValue === oldValue) return;

        if($scope.counts.notGenerated.change)
            $scope.counts.notGenerated.change = false;

        $scope.counts.notGenerated.change = true;
        $timeout(function() {$scope.counts.notGenerated.change = false;}, 500);
    });

    $scope.$watch("counts.errored.value", function(newValue, oldValue){
        if (newValue === oldValue) return;

        if($scope.counts.errored.change)
            $scope.counts.errored.change = false;

        $scope.counts.errored.change = true;
        $timeout(function() {$scope.counts.errored.change = false;}, 500);
    });

    $scope.$watch("counts.generated.value", function(newValue, oldValue){
        if (newValue === oldValue) return;

        if($scope.counts.generated.change)
            $scope.counts.generated.change = false;

        $scope.counts.generated.change = true;
        $timeout(function() {$scope.counts.generated.change = false;}, 500);
    });

    $scope.$watch("counts.onHoldNoStatement.value", function(newValue, oldValue){
        if (newValue === oldValue) return;

        if($scope.counts.onHoldNoStatement.change)
            $scope.counts.onHoldNoStatement.change = false;

        $scope.counts.onHoldNoStatement.change = true;
        $timeout(function() {$scope.counts.onHoldNoStatement.change = false;}, 500);
    });


    //INITIALIZE
    $scope.rightsReportBatch = $oasRights.forCode("REPORTBATCHNEW");
    $scope.rightsReportBatchAdmin = $oasRights.forCode("REPORTBATCH_ADMIN");
    $scope.rightsReportBatchInternalSettings = $oasRights.forCode("REPORTBATCH_INTERNAL");
    $scope.rightsReportBatchDelivery = privilegeService.canRead('reportBatchDelivery');
    $scope.views = views;

    $scope.selectedIds = [];
    $scope.current = { view : parseInt($routeParams.batchId) > 0 ? views[0] : null, batchId: 0, url: '', urlParameters: '', generationStatus: [], syncStatuses: syncStatus, syncStatusSelection: ["none", "added"], viewableByList: []};
    $scope.isPageLoading = true;
    $scope.batch = {};
    $scope.counts = {total: {value: 0, change: false}, pendingGeneration: {value: 0, change: false}, notGenerated: {value: 0, change: false}, errored: {value: 0, change: false}, generated: {value: 0, change: false}, onHoldNoStatement: {value: 0, change: false}, eligibleElectronicStatement: {value: 0, change: false}};
    init();
});

app.controller ('ViewableByCtrl', function ViewableByCtrl( $scope, dialog) {
    //PRIVATE METHODS
    function init() {
        if ($scope.user.authorization.entity == "Representative") {
            //set up Rep specific defaults
            $scope.current.showAdministrator = $scope.current.showAdvisor = false;
            $scope.current.entity = "Representative";
        }

        if (dialog.options.entities.some("Household"))
            $scope.current.entity = "Client";
        else if (dialog.options.entities.some("Representative"))
            $scope.current.entity = "Representative";
        else if (dialog.options.entities.some("Advisor"))
            $scope.current.entity = "RIA";
    }

    //PUBLIC METHODS
    $scope.submit = function() {
        dialog.close($scope.current.entity);
    };

    $scope.cancel = function() {
        dialog.close(null);
    };

    //INITIALIZE
    $scope.current = { entity: "Administrator", showAdministrator: true, showAdvisor: true, showRepresentative: true };
    init();
});

ReportBatchEntitiesCtrl.loadBatchEntityViews = ["$http", "$route", function($http, $route){
    if($route.current.params.batchId) {
        return $http.get('/Reporting/Batch/' + $route.current.params.batchId, {

                trackerMsg: 'Loading report batch'
            })
            .then(function (response) {
                var dto = "";
                switch (response.data.entity) {
                    case "Household":
                        dto = "ReportBatchClientDto";
                        break;
                    case "Registration":
                        dto = "ReportBatchRegistrationDto";
                        break;
                    case "Account":
                        dto = "ReportBatchAccountDto";
                        break;
                    case "Portfolio Group":
                        dto = "ReportBatchPortfolioGroupDto";
                        break;
                    default:
                        dto = "ReportBatchEntityDto";
                        break;
                }
                if (dto === "") dto = "ReportBatchEntityDto";
                return $http.get('/Settings/Views/' + dto, {trackerMsg: 'Loading ' + response.data.entity.toLowerCase() + ' views'});
            })
            .then(function (response) {
                return response.data;
            });
    }
}];
'use strict'

app.controller('ReportBatchWizardCtrl', function ReportBatchWizardCtrl($scope, $http, $q, $oasRights, $dialog, $window, $location, $routeParams, API_CONFIG, batchInsertData, entities, splitIoService) {

    //PRIVATE VARIABLES
    var original;

    //PRIVATE METHODS
    function init(){

        original = angular.copy($scope.content);
        if($routeParams.qpeId) {
            $http.get('/Reporting/Qpe/' + $routeParams.qpeId, {trackerMsg: 'Loading quarter end data'})
                .then(function(response){
                    $scope.current.isQpeBatch = true;
                    $scope.content.batch.qpeItemId = $routeParams.qpeId;
                    $scope.content.batch.statementDeliveryMethod = "Use Assigned";
                    $scope.startDate = response.data.startDate;
                    $scope.content.batch.startDate = Date.create(response.data.startDate);
                    $scope.content.batch.endDate = Date.create(response.data.startDate).advance({month: (response.data.period === "Quarterly") ? 3 : 1}).addDays(-1);
                    $scope.endDate = Date.parse(Date.create(response.data.startDate).advance({month: (response.data.period === "Quarterly") ? 3 : 1}).addDays(-1));
                    setQuarterEndPostedReportName(response.data);
                    //$scope.content.batch.postedReportName = response.data.friendlyName;
                    $scope.reportEntities.remove(function(re) { return re.entity !== "Household"; });
                    $scope.wizardSteps.add("Quarter End",1);
                    loadEmailDefaults();
                });
        }
        parseStatementDelivery();

        $scope.current.isRepresentative = !($scope.user.authorization.entity === "Administrator" || $scope.user.authorization.entity === "Advisor");
        $scope.updateDynamicGroups();
    }

    function setQuarterEndPostedReportName(qpe) {
        const month = $scope.content.batch.startDate.getMonth()+1;
        const year = $scope.content.batch.endDate.getFullYear();
        if(qpe.period === 'Quarterly') {
            const quarter = ( month <= 3 ) ? "1st" : (( month <= 6 ) ? "2nd" : (( month <= 9 ) ? "3rd" : "4th"));
            $scope.content.batch.postedReportName = year + ' - ' + quarter + ' Quarter Statement';
        }
        else { //Monthly
            $scope.content.batch.postedReportName = year + ' - ' + month + ' Statement';
        }
    }

    function parseStatementDelivery() {
        $scope.current.selectedDeliveryMethods = $scope.content.batch.statementDeliveryMethod.split(',');
    }

    function updateDynamicGroups() {
        return $http.get('/Utility/Groupings?usedFor=Reporting&entity=' + $scope.content.batch.entity, {trackerMsg: 'Loading dynamic groupings'});
    }

    function loadBillInstances() {
        getPagesRecursive(0, 50000);
    }

    function getPagesRecursive(skip, take) {
        $http.get('/Billing/Instances/Simple?$top='+ take +'&$skip=' + skip, {trackerMsg: 'Loading billing instances'})
            .then(function (response) {
                if (response.data.length > 0) {
                    $scope.current.billInstances = (skip === 0) ? response.data : $scope.current.billInstances.concat(response.data);

                    if (response.data.length === take){
                        getPagesRecursive((skip + take), take);
                    } else {
                        $scope.current.billInstances = $scope.current.billInstances.sortBy('id', true);
                    }
                }
            });
    }

    function loadQuarterEndLookups() {
        if($scope.current.videoStatements && $scope.current.videoStatements.length > 0) return;

        $http.get('/Reporting/VideoStatements', {trackerMsg: 'Loading video statements'})
            .then(function (response) {
                $scope.current.videoStatements = response.data;
            });
    }

    function loadEmailDefaults() {
        $http.get('/Settings/Database/EntityOptions/Code/69EMAILFRO', {trackerMsg: 'Loading default sender email'})
            .then(function(response) {
                if(response.data)
                    $scope.content.batch.emailFrom = response.data.value.trim();
                return $http.get('/Settings/Database/EntityOptions/Code/69EStmntSubjLine', {trackerMsg: 'Loading default email subject'});
            })
            .then(function(response) {
                if(response.data)
                    $scope.content.batch.emailSubject = response.data.value.trim();
                return $http.get('/Settings/Database/EntityOptions/Code/69EstmntText', {trackerMsg: 'Loading default email body text'});
            })
            .then(function(response) {
                if(response.data)
                    $scope.content.batch.emailBody = response.data.value.trim();
            });
    }

    function prepareInserts() {
        formatInserts($scope.content.inserts);
        batchInsertData.loadInserts($scope.content.inserts)
            .then(function(structuredInserts){
                $scope.inserts = structuredInserts;
                $scope.updateInserts();
            });
    }

    function formatInserts(inserts) {
        inserts.each(function(insert){
            if(insert.type === 'Blank Page (even only)') {
                insert.type = 'Blank Page';
                insert.evenOnly = true;
            }
            else {
                insert.evenOnly = false;
            }
        });
    }

    function undoInsertFormatting(inserts) {
        inserts.each(function(insert){
            if(insert.type === 'Blank Page' && insert.evenOnly) {
                insert.type = 'Blank Page (even only)';
            }
            delete insert.evenOnly;
        });
    }

    function saveInserts() {
        return batchInsertData.flattenInserts()
            .then(function(inserts){
                undoInsertFormatting(inserts);
                return $http.put('/Reporting/Batch/' + $scope.content.id + '/Inserts', inserts, {trackerMsg: 'Updating batch inserts'});
            })
            .then(function (response) {
                $scope.content.inserts = response.data;
                prepareInserts();
                return true;
            });
    }

    function updateBatch() {
        var save = $scope.content.id > 0 ? {method: "PUT", id: $scope.content.id, trackerMsg: "Updating report batch"} : {method: "POST", id: "", trackerMsg: "Creating report batch"};
        return $http({method: save.method, url: '/Reporting/Batch/Verbose/' + save.id, data: $scope.content, trackerMsg: save.trackerMsg});
    }

    function emailNotificationCheck() {
        if($scope.current.selectedDeliveryMethods.some('Email') || $scope.current.selectedDeliveryMethods.some('Use Assigned')) {
            if(!$scope.wizardSteps.some("Email Notification")) {
                $scope.wizardSteps.add("Email Notification", 2);
            }
        }
        else if($scope.wizardSteps.some("Email Notification")) {
            $scope.wizardSteps.remove("Email Notification");
        }
    }

    //PUBLIC METHODS
    $scope.invalidEmail = function (invalid) {
        $scope.content.batch.emailFromInvalid = invalid;
    };

    $scope.setEmail = function (value) {
        $scope.content.batch.emailFrom = value;
    };

    $scope.back = function() {
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep -= 1;
    };
    $scope.next = function() {
        var selectionStep = $scope.wizardSteps.findIndex("Selection");
        var insertStep = $scope.wizardSteps.findIndex("Batch Inserts");
        var qpeStep = $scope.wizardSteps.findIndex("Quarter End");

        if(selectionStep === 1 && $scope.current.isRepresentative && $scope.current.isBillInstance){
            $scope.user.alerts.push({ type: 'error', msg: 'You do not have access to run ' + $scope.current.report.name + ' report. Please select a different report.' });
        }

        if ($scope.current.wizardStep === (qpeStep - 1) && $scope.current.isQpeBatch) {
            loadQuarterEndLookups();
        }
        //Only save after the "Selection" step.  The Advisory Fee Notifcation report requires the Bill Instance ID to be assigned in Selection step before save
        if($scope.current.wizardStep > (selectionStep-1)) {
            if (($scope.inserts.beforeCoverPage && $scope.inserts.beforeCoverPage.length > 0) || ($scope.inserts.afterCoverPageBeforeReport && $scope.inserts.afterCoverPageBeforeReport.length > 0) || ($scope.inserts.afterReport && $scope.inserts.afterReport.length > 0)) {
                //Inserts need to be flattened into one collection before being submitted.
                batchInsertData.flattenInserts()
                    .then(function (inserts) {
                        undoInsertFormatting(inserts);
                        $scope.content.inserts = inserts; //Flattened inserts overwrite the separated inserts.
                    });
            }

            $scope.current.executing = true;

            updateBatch()
                .then(function (response) {
                    $scope.current.executing = false;
                    $scope.content = response.data;
                    if (response.data.inserts.length > 0) {
                        prepareInserts();
                    }

                    $scope.current.animation = 'slide-right';

                    if ($scope.current.wizardStep === (insertStep - 1)) {
                        prepareInserts();
                    }

                    $scope.current.wizardStep += 1;
                }, function (rejection) {
                    $scope.current.executing = false;
                });
        }
        else {
            $scope.current.animation = 'slide-right';
            $scope.current.wizardStep += 1;
        }
    };
    $scope.jumpBackTo = function(index) {
        if ($scope.current.executing || $scope.current.wizardStep < index) {
            return;
        }

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };
    $scope.isStepIncomplete = function() {
        switch ($scope.wizardSteps[$scope.current.wizardStep]) {
            case "Selection":
                switch($scope.content.batch.entitySelectionMethod) {
                    case "All":
                    case "Active":
                    case "Active with Value":
                        return ($scope.current.filterByRep && $scope.content.batch.representativeId === null);
                    case "Dynamic Group":
                        return ($scope.content.batch.dynamicGroupingId === null || $scope.content.batch.dynamicGroupingId === 0);
                    case "Data Query":
                        return ($scope.content.batch.customReportId === null || $scope.content.batch.customReportId === 0);
                    case "Bill Instance":
                        return ($scope.content.batch.billInstanceId === null || $scope.content.batch.billInstanceId === 0);
                    default:
                        return false;
                }
                return false;
            case "Batch Information":
                var test = (($scope.content.batch.reportId === null || $scope.content.batch.reportId === 0) && !$scope.content.batch.isAdvisoryFee);
                test = (test || $scope.content.batch.name === undefined || $scope.content.batch.name.trim() === '');
                test = (test || !$scope.content.batch.postedReportName || $scope.content.batch.postedReportName.trim() === '');
                test = (test || !$scope.content.batch.startDate || (angular.isObject($scope.content.batch.startDate) && $scope.content.batch.startDate.trim() === ''));
                test = (test || !$scope.content.batch.endDate || (angular.isObject($scope.content.batch.endDate) && $scope.content.batch.endDate.trim() === ''));
                return test;
            case "Quarter End":
                if($scope.current.hasVideoStatement) {
                    return ($scope.content.batch.videoStatementId === null || $scope.content.batch.videoStatementId === 0);
                }
                return false;
            case "Email Notification":
                return $scope.content.batch.emailFromInvalid;
            case "Batch Inserts":
                return false;
            default:
                return false;
        }
    };
    $scope.disableSendTestEmail = function() {
        var test = $scope.content.batch.emailSubject === null || $scope.content.batch.emailSubject === undefined || $scope.content.batch.emailSubject.trim() === '';
        test = (test || $scope.content.batch.emailFrom === null || $scope.content.batch.emailFrom === undefined || $scope.content.batch.emailFrom.trim() === '');
        test = (test || $scope.content.batch.emailBody === null || $scope.content.batch.emailBody === undefined || $scope.content.batch.emailBody.trim() === '');
        test = (test || $scope.content.batch.emailFromInvalid);
        return test;
    };
    $scope.entityCheck = function () {
        if ($scope.content.batch.entity !== 'Household') {
            $scope.content.batch.videoStatementId = null;
            $scope.content.batch.printAlternativeAddresses = null;
        }

        var selected = $scope.current.allowed.find({entity: $scope.content.batch.entity});
        $scope.current.allowedEntitySelectionMethods = selected.selectionMethods;

        $scope.updateDynamicGroups();
    };
    $scope.updateDynamicGroups = function () {
        updateDynamicGroups()
            .then(function (response) {
                $scope.current.dynamicGroups = response.data.filter({isPrivate: false});
            });
    };
    $scope.setDates = function(rangeName) {
        var startDate = Date.create('today');
        var endDate = Date.create('today');

        switch (rangeName) {
            case "last-month":
                startDate.addMonths(-1).beginningOfMonth();
                endDate.addMonths(-1).endOfMonth().beginningOfDay();
                break;
            case "last-year":
                startDate.addYears(-1).beginningOfYear();
                endDate.addYears(-1).endOfYear().beginningOfDay();
                break;
            case "last-quarter":
                endDate = endDate.getStartOfQuarter().addDays(-1);
                startDate = endDate.getStartOfQuarter();
                break;
            case "MTD":
                startDate.beginningOfMonth();
                break;
            case "QTD":
                startDate = startDate.getStartOfQuarter();
                break;
            case "YTD":
                startDate.beginningOfYear();
                break;
            case "roll-1-year":
                startDate.addYears(-1);
                endDate.addDays(-1);
                break;
            case "roll-3-year":
                startDate.addYears(-3);
                endDate.addDays(-1);
                break;
        }

        $scope.current.startDate = startDate;
        $scope.current.endDate = endDate;
    };
    $scope.updateInserts = function() {
        var selectedInserts = [];
        if($scope.content.hasCoverPage) {
            selectedInserts = $scope.inserts.afterCoverPageBeforeReport.findAll({location: "Before cover page"});
            selectedInserts.each(function(insert){
                $scope.inserts.afterCoverPageBeforeReport.remove(insert);
                $scope.inserts.beforeCoverPage.add(insert);
            });
        }
        else {
            selectedInserts = $scope.inserts.beforeCoverPage;
            var index = 0;
            selectedInserts.each(function(insert){
                $scope.inserts.beforeCoverPage.remove(insert);
                $scope.inserts.afterCoverPageBeforeReport.add(insert, index);
                index++;
            });
        }
    };
    $scope.addNewInsert = function(insertType) {
        var newInsertCount = 0;
        Object.keys(batchInsertData.inserts)
            .each(function (location) {
                newInsertCount += batchInsertData.inserts[location].count(function(n) { return n.name.has("New Insert"); });
            });
        var initLocation = $scope.content.hasCoverPage ? "beforeCoverPage" : "afterCoverPageBeforeReport";
        var insert = {
            id: -1,
            name: "New Insert (" + newInsertCount + ")",
            type: insertType,
            location: ($scope.content.hasCoverPage ? "Before cover page" : "After cover page / Before report"),
            sequence: batchInsertData.inserts[initLocation].length
        };
        batchInsertData.inserts[initLocation].add(insert);
        $scope.content.inserts.add(insert);
        saveInserts();
    };
    $scope.removeInsert = function(insertId) {
        var insert, currentLocation;
        Object.keys(batchInsertData.inserts)
            .each(function (location) {
                if (batchInsertData.inserts[location].some({id: insertId})) {
                    insert = batchInsertData.inserts[location].find({id: insertId});
                    currentLocation = location;
                    return false;
                }
            });
        $dialog.confirmAction("Are you sure you want to remove this insert: \"" + insert.name + "\"?")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $scope.inserts[currentLocation].remove(insert);
                    $scope.content.inserts.remove(insert);
                    saveInserts();
                }
            });
    };
    $scope.upload = function(insertId) {
        saveInserts()
            .then(function (rslt){
                if(rslt === true) {
                    $dialog.inputBox("Upload Insert", "Insert Upload", "file", {postUrl: "/Reporting/Batch/" + $scope.content.id + "/Inserts/" + insertId + "/Action/Upload"})
                        .open()
                        .then(function (files) {
                            if (!files) {
                                return;
                            }
                            var insert;
                            Object.keys(batchInsertData.inserts)
                                .each(function (location) {
                                    if (batchInsertData.inserts[location].some({id: insertId})) {
                                        insert = batchInsertData.inserts[location].find({id: insertId});
                                        return false;
                                    }
                                });
                            insert.name = files.name;
                            insert.hasFile = files.hasFile;
                            insert.entityCount = files.entityCount;
                            insert.warningMessage = files.warningMessage;
                        });
                }
            });
    };
    $scope.download = function(insertId) {
        $window.location.href = API_CONFIG.baseUrl + '/Reporting/Batch/' + $scope.content.id + '/Inserts/' + insertId + '/Download?Authorization=' + sessionStorage.oas_token;
    };
    $scope.openWarning = function(insert) {
        $dialog.messageBox("Insert Warning","<pre>" + insert.warningMessage + "</pre>").open();
    };

    $scope.finalize = function() {
        //Inserts need to be flattened into one collection before being submitted.
        batchInsertData.flattenInserts()
            .then(function(inserts){
                undoInsertFormatting(inserts);
                $scope.content.inserts = inserts; //Flattened inserts overwrite the separated inserts.
                $scope.content.batch.isActive = true;
                $scope.current.executing = true;
                return updateBatch();
            })
            .then(function () {
                $scope.current.executing = false;
                sessionStorage.newBatchId = $scope.content.id;
                $location.url('/reports/batches/entities?batchId=' + $scope.content.id);
            }, function (rejection) {
                $scope.current.executing = false;
            });
    };

    $scope.updateVideo = function() {
        if(!$scope.current.hasVideoStatement) {
            $scope.content.batch.videoStatementId = null;
        }
    };
    $scope.updateRep = function() {
        if(!$scope.current.filterByRep) {
            $scope.current.rep = null;
        }
    };
    $scope.close = function() {
        if (!angular.equals(original, $scope.content)) {
            $dialog.confirmAction("The wizard has not finished.  Leaving from this wizard without generating the batch will result in a loss of your batch information.  Do you want to continue?")
                .open()
                .then(function(result){
                    if(result === 'yes') {
                        if($scope.content.id > 0) {
                            $http.delete('/Reporting/Batch/Verbose/' + $scope.content.id, {trackerMsg: 'Deleting report batch ' + $scope.content.id})
                                .then(function(){
                                    $location.url('/reports/batches');
                                });
                        } else {
                            $location.url('/reports/batches');
                        }
                    }
                });
        } else {
            $location.url('/reports/batches');
        }
    };
    $scope.loadPrompts = function(dataQueryId) {
        $dialog.dataQueryPrompt($scope.content.batch.customReport || dataQueryId, "edit-only")
            .open()
            .then(function (result) {
                if (result) {
                    $scope.content.batch.customReport = result;
                }
            });
    };
    $scope.isChecked = function(key){
        var uaIndex = $scope.current.selectedDeliveryMethods.findIndex("Use Assigned");
        if(key === -1 && uaIndex === 0) {
            return true;
        }
        var method = $scope.current.allowedDeliveryMethods[key];
        return $scope.current.selectedDeliveryMethods.findIndex(method) !== -1;
    };
    $scope.toggleCheck = function(key) {
        var method = $scope.current.allowedDeliveryMethods[key];
        var index = $scope.current.selectedDeliveryMethods.findIndex(method);
        var uaIndex = $scope.current.selectedDeliveryMethods.findIndex("Use Assigned");
        if(index === -1) {
            if(uaIndex >= 0) {
                $scope.current.selectedDeliveryMethods.remove("Use Assigned");
            }
            $scope.current.selectedDeliveryMethods.push(method);
        }
        else {
            $scope.current.selectedDeliveryMethods.remove(method);
        }

        emailNotificationCheck();
    };
    $scope.toggleOptions = function() {
        var index = $scope.current.selectedDeliveryMethods.findIndex("Use Assigned");

        if (index === -1) {
            $scope.current.selectedDeliveryMethods = [];
            $scope.current.selectedDeliveryMethods.push("Use Assigned");
        }
        else {
            $scope.current.selectedDeliveryMethods.remove("Use Assigned");
        }

        emailNotificationCheck();
    };
    $scope.sendTestEmail = function(){
        $dialog.inputBox('Send To', "Email Address")
            .open()
            .then(function(rslt){
                if(rslt) {

                    $scope.current.executing = true;
                    updateBatch()
                        .then(function (response) {
                            $scope.current.executing = false;
                            $scope.content = response.data;
                            if(response.data.inserts.length > 0){
                                prepareInserts();
                            }
                            $http.post('/Reporting/Batch/' + $scope.content.id + '/Action/SendTestEmail', "'" + rslt + "'", {trackerMsg: 'Sending test email'});
                        }, function (rejection){
                            $scope.current.executing = false;
                        });
                }
            });
    };
    $scope.showInsertNote = function () {
        var message = "<span class='help-action'>Important Note About Inserts:</span> Inserts can contain fonts that are not compatible with the Orion reporting platform.  If you receive an error while adding an insert please reach out to the Orion Reporting Team.<br /><br />" +
            "<ul><li><b>Blank Page Insert</b> – This will insert a blank page at either the beginning or end of the report.</li>" +
            "<li><b>PDF Insert</b> – General insert that will be added to every report ran in the batch.</li>" +
            "<li><b>Batch Insert</b> – Gives you the ability to insert a unique PDF per individual client.</li></ul><br />" +
            "For questions on this please reach out to the Orion Reporting Team.";
        $dialog.messageBox("Batch Inserts", message).open();
    };

    $scope.syncEntityList = function() {
        $scope.current.executing = true;

        updateBatch()
            .then(function (response) {
                $scope.current.executing = false;
                $scope.content = response.data;
                if (response.data.inserts.length > 0) {
                    prepareInserts();
                }
                var entity = entities[entities.find({name: $scope.content.batch.entity})];

                var dialogOpts = {
                    templateUrl: "reporting/modals/syncEntityList.html",
                    controller: "SyncEntityListCtrl",
                    entity: entity.name
                };
                $dialog.dialog(dialogOpts)
                    .open()
                    .then(function(rslt){
                        if(!rslt) {
                            return;
                        }

                        if (rslt.ids.length > 0) {
                            var entityList = rslt.ids.map(function(id){ return {id:id}; });
                            $http.post('/Reporting/Batch/' + $scope.content.id + '/Entities/Action/SyncList?addOnly=' + rslt.addOnly, entityList, {trackerMsg: 'Syncing entity list'});
                        }
                    });
            }, function (rejection) {
                $scope.current.executing = false;
            });
    };

    $scope.createVideoStatement = function(){
        var dialogOpts = {
            templateUrl: "reporting/modals/newVideoStatement.html",
            controller: "NewVideoStatementCtrl",
            startDate: $scope.content.batch.startDate,
            endDate: $scope.content.batch.endDate
        };
        $dialog.dialog(dialogOpts)
            .open()
            .then(function(result){
                if (result) {
                    var videoStatementId;
                    $http.post('/Reporting/VideoStatements', result, {trackerMsg: 'Creating new video statement'})
                        .then(function(response){
                            videoStatementId = response.data.id;
                            return $http.get('/Reporting/VideoStatements', {trackerMsg: 'Loading video statements'});
                        })
                        .then(function (response) {
                            $scope.current.videoStatements = response.data;
                            $scope.content.batch.videoStatementId = videoStatementId;
                        });
                }
            });
    };

    $scope.filterBillInstances = function(filterText) {
        return $scope.current.billInstances.filter(function(billInst) {
            return billInst.name.toLowerCase().includes(filterText.toLowerCase());
        });
    };

    $scope.onSelect = function(item) {
        $scope.content.batch.billInstanceId = item.id;
    };

    //WATCHES
    $scope.$watch("current.rep", function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }

        if (angular.isObject(newValue)) {
            $scope.content.batch.representativeId = newValue.id;
        }
        else {
            $scope.content.batch.representativeId = null;
        }
    });

    $scope.$watch("current.dataquery", function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }

        if (angular.isObject(newValue)) {
            $scope.content.batch.customReportId = newValue.id;
            $scope.loadPrompts(newValue.id);
        }
        else {
            $scope.content.batch.customReportId = null;
            $scope.content.batch.customReport = null;
        }
    });

    $scope.$watch("current.report", function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }

        if (angular.isObject(newValue)) {
            if(newValue.id === "FEE") { //This allows for the handling of the new Advisory Fee Notification report from OpEx - Billing
                $scope.content.batch.reportId = null;
                $scope.content.batch.isAdvisoryFee = true; //This is only for the new Advisory Fee Notification report
                $scope.content.hasCoverPage = false;
                $scope.current.allowed = [{
                    entity: "Household",
                    selectionMethods: [
                        "Bill Instance"
                    ]
                }];
                $scope.current.allowedEntities = ["Household"];
                $scope.current.allowedEntitySelectionMethods = ["Bill Instance"];
                $scope.content.batch.entitySelectionMethod = "Bill Instance";
                $scope.current.isBillInstance = true;
                if ($scope.rightsBillGenerator.canRead || $scope.rightsBillingAudit.canRead) {
                    loadBillInstances();
                }
            }
            else {
                $scope.content.batch.reportId = newValue.id;
                $scope.content.batch.isAdvisoryFee = false; //This is only for the new Advisory Fee Notification report
                $http.get('/Reporting/Batch/Reports/' + $scope.content.batch.reportId, { trackerMsg: 'Loading report information' })
                    .then(function(response) {
                        if (response.data) {
                            $scope.content.hasCoverPage = response.data.hasCoverPage;
                            $scope.current.allowed = response.data.allowed;
                            $scope.current.allowedEntities = response.data.allowed.map(function(a) {
                                return a['entity'];
                            });

                            var entity;
                            var methods = [];
                            $scope.reportEntities.forEach(function(e) {
                                $scope.current.allowed.forEach(function(a) {
                                    if (typeof entity === "undefined" && a.entity == e.entity) {
                                        entity = a.entity;
                                        methods = a.selectionMethods;
                                        $scope.current.isBillInstance = methods.includes("Bill Instance");
                                    }
                                });
                            });

                            if (typeof entity !== "undefined") {
                                $scope.content.batch.entity = entity;
                            }
                            if (methods !== undefined && methods.length > 0) {
                                $scope.current.allowedEntitySelectionMethods = methods;
                            }

                            if (methods.includes("Bill Instance") && ($scope.rightsBillGenerator.canRead || $scope.rightsBillingAudit.canRead)) {
                                loadBillInstances();
                            }

                            if ($scope.current.allowedEntitySelectionMethods.some("Active with Value")) {
                                $scope.content.batch.entitySelectionMethod = "Active with Value";
                            } else if ($scope.current.allowedEntitySelectionMethods.some("Active")) {
                                $scope.content.batch.entitySelectionMethod = "Active";
                            } else if ($scope.current.allowedEntitySelectionMethods.some("All")) {
                                $scope.content.batch.entitySelectionMethod = "All";
                            } else if ($scope.current.allowedEntitySelectionMethods.some("Dynamic Group")) {
                                $scope.content.batch.entitySelectionMethod = "Dynamic Group";
                            } else if ($scope.current.allowedEntitySelectionMethods.some("Data Query")) {
                                $scope.content.batch.entitySelectionMethod = "Data Query";
                            } else if ($scope.current.allowedEntitySelectionMethods.some("Bill Instance")) {
                                $scope.content.batch.entitySelectionMethod = "Bill Instance";
                            } else if ($scope.current.allowedEntitySelectionMethods.some("Import IDs")) {
                                $scope.content.batch.entitySelectionMethod = "Import IDs";
                            }
                        } else {
                            $scope.content.hasCoverPage = false;
                        }
                    });
            }
        }
        else {
            $scope.content.batch.reportId = null;
            $scope.content.hasCoverPage = false;
            $scope.content.batch.isAdvisoryFee = false; //This is only for the new Advisory Fee Notification report
        }
    });

    $scope.$watch("current.selectedDeliveryMethods", function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }

        $scope.content.batch.statementDeliveryMethod = newValue.join(', ');
    }, true);

    $scope.$watch("content.batch.entitySelectionMethod", function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }

        if (['All','Active','Active with Value'].some(newValue)) {
            $scope.current.filterByRep = false;
            $scope.current.rep = null;
        }
        if (newValue !== 'Dynamic Group') {
            $scope.content.batch.dynamicGroupingId = null;
        }
        if (newValue !== 'Data Query') {
            $scope.current.dataquery = null;
        }
        if (newValue !== 'Bill Instance') {
            $scope.content.batch.billInstanceId = null;
        }
    });

    var cancelWatch = $scope.$watch('leftSidebar.exists', function(newVal, oldVal){
        if (newVal) {
            $scope.leftSidebar.exists = false;
            cancelWatch();
        }
    });

    $scope.$watch("current.startDate", function(newValue, oldValue){
        if (!newValue) {
            $scope.content.batch.startDate = newValue;
            return;
        }

        if (newValue === oldValue) {
            return;
        }

        $scope.content.batch.startDate = Date.create(newValue).formatted(false);
    });
    $scope.$watch("current.endDate", function(newValue, oldValue){
        if (!newValue) {
            $scope.content.batch.endDate = newValue;
            return;
        }

        if (newValue === oldValue) {
            return;
        }

        $scope.content.batch.endDate = Date.create(newValue).formatted(false);
    });

    $scope.$on('$destroy', function () {
        $scope.leftSidebar.exists = true;
    });

    //INITIALIZE
    $scope.rightsBillGenerator = $oasRights.forCode("BILLGENERATOR");
    $scope.rightsBillingAudit = $oasRights.forCode("BILLAUDIT");
    $scope.content = {
        canEdit: true, hasCoverPage: false, id: 0, isGenerating: false, //Required
        batch: {
            auditedBy: '', auditedDate: '',
            customReportId: null,
            dynamicGroupingId: null,
            startDate: null, endDate: null, //Required
            fromInception: false,
            showInternalOnlyWarning: false,
            entity: 'Household', //Required
            entitySelectionMethod: 'All', //Required
            id:0, name: '', postedReportName: '',
            printAlternativeAddresses: false, //Required
            qpeItemId: null,
            reportId: null, //Required
            videoStatementId: null,
            representativeId: null,
            billInstanceId: null,
            isActive: false, //Required
            customReport: null,
            statementDeliveryMethod: "Use Assigned",
            ftpFileName: null,
            emailFrom: null,
            emailSubject: null,
            emailBody: null,
            includeAllBills: false,
            isAdvisoryFee: false, //This is only for the new Advisory Fee Notification report
            folder: 'Portfolio Statements'
        },
        inserts: []
    };
    $scope.inserts = {};
    $scope.current = {
        executing: false, wizardStep: 0, animation: 'slide-right',
        rep: null, dataquery: null, dynamicGroups: [], billInstances: [], report: null,
        isQpeBatch: false, hasVideoStatement: false, videoStatements: [], filterByRep: false,
        allowedEntities: ["Household", "Registration", "Account"],
        allowedEntitySelectionMethods: ["Active with Value", "Active", "All", "Dynamic Group", /*"Data Query", "Bill Instance",*/ "Import IDs"],
        allowedDeliveryMethods: ["Mail", "Email", "Website"], selectedDeliveryMethods: [],
        sortOptions: {
            connectWith: ".insert-container",
                scroll: false,
                helper: 'clone',
                stop: batchInsertData.updateInserts,
                items: "div.insert-item"
        },
        additionalItems: [{id: "FEE", name: "Advisory Fee Notification"}]
    };
    $scope.wizardSteps = [ "Batch Information", "Selection", "Email Notification", "Batch Inserts", "Review/Submit" ];
    $scope.reportEntities = [{entity: "Household", label: "Households"}, {entity: "Registration", label: "Registrations"}, {entity: "Account", label: "Accounts"}, {entity: "Portfolio Group", label: "Portfolio Group"}];

    init();
});

'use strict';

app.controller('QuantumJobStatusCtrl', function QuantumJobStatusCtrl($scope, $http, $q, $oasRights, views) {
    //PRIVATE VARIABLES

    //PRIVATE METHODS
    function init() { }

    function refreshGrid( ) {
        $scope.$broadcast('event:quantum-jobs-action', {action: 'refresh-grid'});
    }

    //PUBLIC METHODS
    $scope.exportToExcel = function() {
        $scope.$broadcast('event:quantum-jobs-action', {action: 'export-data'});
    };

    //WATCHES

    //INITIALIZE
    $scope.views = views;
    $scope.current = { view : views[0] };

    init();
});
'use strict';

var compositeAccountListCtrl = app.controller('CompositeAccountListCtrl', function CompositeAccountListCtrl($rootScope, $scope, $http, $dialog, $timeout, $oasRights, views, summary, $dataQuery, $location, $portfolio, entities, $route, $settings, $signalRManager, $routeParams, compositeReportPrompterService) {
    var accountId = null, onRouteChangeOff, canSubscribe = true;

    // PRIVATE METHODS
    function initialLoad() {
        $scope.rights = $oasRights.forCode("COMPOSITEACCOUNT");
        $scope.rightsAdmin = $oasRights.forCode("CUSIPADMIN");
        $scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");
        $scope.rightsPortfolioAudit = $oasRights.forCode( "PORTFOLIOLISTSAPP" );
        $scope.rightsPerfViewer = $oasRights.forCode("PERFVIEWER");

        $http.get('/Reporting/Reports?menu=composite', {cache: true, trackerMsg: 'Loading composite reports'})
            .then(function (response) {
                $scope.current.reports = response.data.filter(report => report.category === "Composite");
            });

        $http.get('/Reporting/Composite/GIPS', {trackerMsg: 'Loading GIPS reports'})
            .then(function(response){
                $scope.current.GIPSReports = response.data;
                $scope.current.GIPSReports.forEach(function(dq){
                    dq.urlString = '#/reports/dataqueries/' + dq.id;
                });
            });

        if ($routeParams.compositeInstanceId){
            initSignalR($routeParams.compositeInstanceId);
        } else {
            $http.get('/Reporting/Composite/Instances/Running', {trackerMsg: 'Loading running composite instances'})
                .then(function(res){
                    res.data.forEach(function(instance){
                        initSignalR(instance);
                    })
                });
        }

        $http.get('/Utility/PageQueries?pageCode=CompositeAccountDto', {cache: true, trackerMsg: 'Loading composite queries'})
            .then(function (response) {
                var data = response.data;

                data.forEach(function (query) {query.isPageQuery = true;});

                $scope.current.gridQueries = data;

                if($scope.current.composite) {
                   setBeginDateParameter();
                }
            });
    }

    function initSignalR(instance){
        $.connection.hub.qs['compositeInstanceId'] = instance;
        $signalRManager.subscribeToHub( 'compositeInstanceHub', 'resetList', null, resetList );
        $signalRManager.subscribeToHub( 'compositeInstanceHub', 'addItems', null, addItems );
        $signalRManager.subscribeToHub( 'compositeInstanceHub', 'updateItems', null, updateItems );
        $signalRManager.subscribeToHub( 'compositeInstanceHub', 'removeItems', null, removeItems );
        onRouteChangeOff =  $scope.$on("$routeChangeStart", unsubscribeHubs);
    }
    function unsubscribeHubs() {
        $signalRManager.unSubscribeToHub( 'compositeInstanceHub', 'resetList' );
        $signalRManager.unSubscribeToHub( 'compositeInstanceHub', 'addItem' );
        $signalRManager.unSubscribeToHub( 'compositeInstanceHub', 'updateItem' );
        $signalRManager.unSubscribeToHub( 'compositeInstanceHub', 'removeItem' );
        delete $.connection.hub.qs["compositeInstanceId"];

        onRouteChangeOff();
    }

    function resetList(subscribe) {
        if(subscribe === undefined) {
            refreshGrid();
            return;
        }

        canSubscribe = subscribe;
        if(!canSubscribe)
            unsubscribeHubs();
    }

    function addItems(list) {
        list.forEach(function(item){
        });
    }

    function updateItems(list) {
        if (!list.hangfireJobId){
            $route.reload();
        };
        $rootScope.$broadcast('event:status-update', { id: list.id, isDone: list.hangfireJobId ? false : true, msg: list.statusText, showClose: list.statusText.includes('Error (Job Canceled)')});
    }

    function removeItems(list) {
        list.forEach(function(item){
        });
    }

    function delayedRefresh() {
        //$timeout because the $broadcast happens during the same digest as the $watch, so the values haven't changed in the view yet
        $timeout(function() {
            $scope.$broadcast('event:composite-accounts-action', {action: 'refresh-grid'});
            if($scope.current.composite)
                setBeginDateParameter( );
        });
    }

    function setBeginDateParameter( ) {
        for( var i = 0; i < $scope.current.gridQueries.length; i++ ) {
            if( $scope.current.gridQueries[i].parameters ) {
                for( var j = 0; j < $scope.current.gridQueries[i].parameters.length; j++ ) {
                    if( $scope.current.gridQueries[i].parameters[j].name == "BeginDate") {
                        $scope.current.gridQueries[i].parameters[j].value = $scope.current.composite.begDate.formatted();
                    }
                }
            }
        }
    }


    // PUBLIC METHODS

    $scope.viewLog = function() {
        $http.get( "/Reporting/Composite/Accounts/Logs?asOfDate="  + $scope.current.composite.begDate.formatted(), {trackerMsg: 'Loading composite log'})
            .then(function(response) {
                var data = response.data;

                $dialog.messageBox('Composite Log for ' + $scope.current.composite.begDate.formatted(), data.length ? '<ul><li>' + data[0].runLog.to(data[0].runLog.length - 1).split(". ").join("</li><li>") + '</li></ul>' : 'No log data found').open( );
            });
    };

    $scope.makeLive = function() {
        $http.put( "/Reporting/Composite/Accounts/Action/MakeLive?asOfDate=" + $scope.current.composite.begDate.formatted(), {trackerMsg: 'Making composite live'})
            .then (function() {
                $scope.$broadcast('event:composite-accounts-action', {action: 'refresh-grid'});
            });
    };

    $scope.syncPreliminary = function() {
        $http.put( "/Reporting/Composite/Accounts/Action/Sync?beginDate=" + $scope.current.composite.begDate.formatted(), {trackerMsg: 'Syncing Premininary'})
            .then (function() {
                $scope.$broadcast('event:composite-accounts-action', {action: 'refresh-grid'});
            });
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:composite-accounts-action', {action: 'export-data'});
    };

    $scope.runReport = function(reportId){
        $dialog.reportPrompt(reportId).open();
    };

    $scope.runReportNew = function(){
        compositeReportPrompterService.runCompositeReport();
    };

    $scope.recalculatePerformance = function( ) {
        $http.get("/Reporting/Composite/Wizard/CompositeDefinition", {trackerMsg: 'Loading composite definition'})
            .then(function(response){

                var compositeDefinition = response.data;

                compositeDefinition.entity = "Other";
                compositeDefinition.keys = $scope.selectedIds;
                compositeDefinition.numberOfMonths = 1;
                compositeDefinition.overwrite = true;
                compositeDefinition.recalc = true;
                compositeDefinition.start =  $scope.current.composite.begDate.formatted();
                compositeDefinition.databaseID = 0;

                $http.post("/Reporting/Composite/Wizard/Action/Recalc", compositeDefinition, {trackerMsg: 'Recalculating account performance'})
                    .then( function() {
                        $route.reload();
                    });
            });
    };

    $scope.addGridQuery = function( ) {
        $http.post('/Utility/PageQueries/' + $scope.current.selectedGridQuery.id + '/Results', $scope.current.selectedGridQuery, {trackerMsg: 'Loading query ' + $scope.current.selectedGridQuery.name} )
            .then(function(response) {
                var data = response.data;

                $scope.current.selectedGridQuery.field = "id";
                $scope.current.selectedGridQuery.filterFn = function(x) {
                    for (var i = data.length - 1; i >= 0; i--) {
                        if (data[i] == x) return true;
                    }
                    return false;
                };
                $scope.current.selectedGridQuery.itemCount = data.length;
                $scope.current.selectedGridQuery.enabled = true;
            });
    };

    $scope.removeGridQuery = function( query ) {
        if(query.enabled)
            query.enabled = false;
    };

    $scope.updateAdvisorNote = function(){
        var dialogOpts = {
            templateUrl : "composite-account-advisor-notes.html",
            controller : "CompositeAccountAdvisorNotesCtrl",
            ids: $scope.selectedIds
        };

        var d = $dialog.dialog(dialogOpts);
        d.open()
                .then(function(rslt){
                    if (rslt){
                        $scope.$broadcast('event:composite-accounts-action', {action: 'refresh-grid'});
                    }
                });
    };

    $scope.importExclusionList = function( ) {
        $dialog.inputBox("Upload Account IDs", "File", "file", {postUrl: "/ValidateImport/Echo", helpText: 'The imported file should include an "Account ID" column.'})
            .open()
            .then(function (data) {
                if (data) {
                    var ids = Object.values(data[0].result)[0].map(function (x) {
                        return Object.values(x)[0];
                    });

                    if (ids.length > 0) {
                        $http.put('/Reporting/Composite/Accounts/Action/Exclude/AccountIds?asOfDate=' + $scope.current.composite.begDate.formatted() + '&type=' + $scope.current.composite.type, ids, {trackerMsg: 'Excluding accounts'})
                            .then(function () {
                                $scope.$broadcast('event:composite-accounts-action', {action: 'refresh-grid'});
                        });
                    }
                }
            });
    };

    $scope.runDifferencesReport = function(){
        $http.get('/Reporting/Custom/Simple/Search/Composite Account Performance Differences', {trackerMsg: 'Loading difference report'})
            .then(function (response) {
                var dataQuery = response.data[0];

                if (dataQuery && dataQuery.id > 0){
                    $dialog.dataQueryPrompt(dataQuery.id)
                        .open()
                        .then(function (result) {
                            if (result && result.id) {
                                $dataQuery.setDataQuery(result);
                                $location.path('/reports/dataqueries/' + dataQuery.id);
                            }
                        });
                }
            });
    };

    $scope.goToTransactions = function(){
        $portfolio.goTo( 'transactions', entities.account.value, accountId);
    };

    $scope.delete = function(isAll, isFundFamily){
        if (isAll){
            $http.put( "/Reporting/Composite/Accounts/Action/Delete/All?asOfDate=" + $scope.current.composite.begDate.formatted() + "&type=" + $scope.current.composite.type, {trackerMsg: 'Deleting Accounts'})
             .then (function() {
                 $route.reload();
             });
        } else {
            showDeleteType(isFundFamily);
        }

    };

    $scope.refreshGrid = function(){
        $http.get( "/Reporting/Composite/Accounts/Summary", {trackerMsg: 'Loading composite list'})
            .then(function(response) {
                var data = response.data;
                var list = {preliminary: [], saved: []};

                for (var i = 0; i < data.length; i++) {
                    var newEntry = {begDate: Date.create(data[i].begDate), count: data[i].accountCount, createdDate: Date.create(data[i].createdDate).formatted(), type: data[i].isPreliminary ? "preliminary" : "live"};

                    if (data[i].isPreliminary)
                        list.preliminary.push(newEntry);
                    else {
                        var year = newEntry.begDate.getFullYear();

                        var yearList = list.saved.find(function(n) {
                            return n.year == year;
                        });

                        if (yearList)
                            yearList.entries.push(newEntry);
                        else {
                            yearList = {year: year, entries: []};
                            yearList.entries.push(newEntry);
                            list.saved.push(yearList);
                        }
                    }
                }

                summary = list;
                $scope.compositeList = summary;
                initialLoad();
            })
    };

    $scope.cancelCalculation = function(){
      $scope.current.isStopCalculating = true;
    };

    $scope.makeLiveForSelected = function(){
        $http.put('/Reporting/Composite/Accounts/Action/MakeLiveForSelected?asOfDate=' + $scope.current.composite.begDate.formatted(), $scope.selectedIds, {trackerMsg: 'Make live for selected'})
            .then(function(res){
                $route.reload();
            });
    };

    $scope.getPortfolioRoute = function (entityEnum) {
        var entity = entities[entityEnum];
        return "#" + $portfolio.getGoToRoute(entity.urlFrag, entity.value, accountId);
    };
    
    $scope.goToPortfolioAudit = function( ) {
        $portfolio.goTo( 'accounts', entities.account.value, accountId);
    };

    $scope.goToPerformanceViewer = function() {
        $location.url('/reports/performanceviewer3?entity=' + parseInt(entities.account.value) + '&entityId=' + accountId);
    };

    $scope.getPerformanceViewerRoute = function () {
        var amp = '&';
        return '#' + ($location.url().startsWith('/embed') ? '/embed' : '') + '/reports/performanceviewer3?entity=' + entities.account.value + amp + 'entityId=' + accountId;
    };

    var showDeleteType = function(isFundFamily){
        var dialogOpts = {
            templateUrl : "delete-composite-prompt.html",
            controller : "DeleteCompositePromptCtrl",
            type: isFundFamily ? "Fund Family" : "Model",
            begDate: $scope.current.composite.begDate.formatted(),
            compositeType : $scope.current.composite.type
        };

        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function(rslt){
                $route.reload();
            });
    };

    //EVENT LISTENERS
    $scope.$on("event:composite-accounts-select", function(e, args){
        if (args.length === 0) return;
        $scope.selectedIds = args.map(function(a){ return a.id});
        accountId = args[0].accountId;
        $scope.current.isLocked = false;
        
        args.forEach(function(item){
            if (item.isLocked){
                $scope.current.isLocked = true;
                return;
            }
        })
    });

    // INITIALIZE
    $scope.views = views;
    $scope.compositeList = summary;
    $scope.current = { view: views[0], gridQueries: [], selectedGridQuery: {}, isCalculating: false, isStopCalculating: false, isLocked: false, isAdmin: $scope.user.authorization.entity === 'Administrator' };
    $scope.selectedIds = [];
    initialLoad();


    //WATCHES
    $scope.$watch("current.composite", function (newValue, oldValue) {
        if (newValue === oldValue) return;

        delayedRefresh();
    }, true);
});


compositeAccountListCtrl.loadSummary = ["$http", function($http) {
    return $http.get( "/Reporting/Composite/Accounts/Summary", {trackerMsg: 'Loading composite list'})
        .then(function(response) {
            var data = response.data;
            var list = {preliminary: [], saved: []};

            for (var i = 0; i < data.length; i++) {
                var newEntry = {begDate: Date.create(data[i].begDate), count: data[i].accountCount, createdDate: Date.create(data[i].createdDate).formatted(), type: data[i].isPreliminary ? "preliminary" : "live"};

                if (data[i].isPreliminary)
                    list.preliminary.push(newEntry);
                else {
                    var year = newEntry.begDate.getFullYear();

                    var yearList = list.saved.find(function(n) {
                        return n.year == year;
                    });

                    if (yearList)
                        yearList.entries.push(newEntry);
                    else {
                        yearList = {year: year, entries: []};
                        yearList.entries.push(newEntry);
                        list.saved.push(yearList);
                    }
                }
            }

            return list;
        });
}];

app.controller ('CompositeAccountAdvisorNotesCtrl', function CompositeAccountAdvisorNotesCtrl( $scope, $http, $oasRights, dialog ){
    // PUBLIC METHODS
    $scope.cancel = function( ) {
        dialog.close( null );
    };

    $scope.close = function( ) {
        $http.put('/Reporting/Composite/Accounts/Action/UpdateNote?note=' + encodeURIComponent($scope.current.note), $scope.current.ids, {trackerMsg: 'Updating advisor note'})
                .then(function (response) {
                    dialog.close(response.data);
                });
    };

    // INITIALIZE
    $scope.current = {
        ids : dialog.options.ids,
        note: '',
        fundFamilyId : null,
        modelId : null
    };



    $scope.rights = $oasRights.forCode( "COMPOSITEACCOUNT" );
});

app.controller('DeleteCompositePromptCtrl', function DeleteCompositePromptCtrl($scope, $http, dialog){
    $scope.cancel = function( ) {
        dialog.close( null );
    };

    $scope.delete = function(){
        if ($scope.current.type === 'Fund Family'){
            $http.put( "/Reporting/Composite/Accounts/Action/Delete/All?asOfDate=" + $scope.current.begDate + "&type=" + $scope.current.compositeType  + '&modelId=' + null + '&fundFamilyId=' + $scope.current.fundFamilyId, {trackerMsg: 'Deleting Accounts'})
                .then (function() {
                    dialog.close({success: true});
                });
        } else {
            $http.put( "/Reporting/Composite/Accounts/Action/Delete/All?asOfDate=" + $scope.current.begDate + "&type=" + $scope.current.compositeType + '&modelId=' + $scope.current.selectedEntity.id + '&fundFamilyId=' + null, {trackerMsg: 'Deleting Accounts'})
                .then (function() {
                    dialog.close({success: true});
                });
        }
    };

    // INITIALIZE
    $scope.current = {
        type : dialog.options.type,
        selectedEntity: null,
        fundFamilyId: null,
        begDate: dialog.options.begDate,
        compositeType: dialog.options.compositeType
    };
});
'use strict';

app.controller('CompositeMissingAccountListCtrl', function CompositeMissingAccountListCtrl($scope, $http, $routeParams) {

    // PRIVATE METHODS
    function loadCompositeMissingAccounts( ) {
        $http.get( "/Reporting/Composite/Accounts/Missing?asOfDate=" + $scope.current.asOfDate + "&type=" + $routeParams.type, {trackerMsg: 'Loading composite missing accounts'})
            .then(function(response) {
                $scope.missingAccounts = response.data;
            });
    }


    // INITIALIZE
    $scope.current = { showFilterRow: false, asOfDate: $routeParams.asOfDate };
    loadCompositeMissingAccounts( );
});
'use strict';

app.controller('CompositeFirmAssetListCtrl', function CompositeFirmAssetListCtrl($scope, $http, $oasRights) {

    // PUBLIC METHODS
    $scope.loadAssets = function( ) {
        $http.get( "/Reporting/Composite/FirmAssets?startDate=" + $scope.current.startDate.formatted() + "&enddate=" + $scope.current.endDate.formatted() + " 23:59:59.9", {trackerMsg: 'Loading composite firm asset list'})
            .then(function(response) {
                $scope.assetList = response.data;
            });
    };

    $scope.deleteAsset = function(asset) {
        $http.delete('/Reporting/Composite/FirmAssets/' + asset.id, {trackerMsg: 'Deleting composite firm asset ' + asset.importSource})
            .then(function () {
                $scope.assetList.remove({id: asset.id});
            }
        );
    };


    // INITIALIZE
    $scope.current = { showFilterRow : false, startDate : Date.create('beginning of this year'), endDate : Date.create('today') };
    $scope.rights = $oasRights.forCode("COMPOSITEACCOUNT");
    $scope.loadAssets( );
});
'use strict';

app.controller('CompositeFirmAssetCtrl', function CompositeFirmAssetCtrl($scope, $http, $location, $routeParams, $oasRights) {
    
    // PRIVATE VARIABLES
    var assetId = $routeParams.id;


    // PRIVATE METHODS
    function loadAsset() {
        if( assetId > 0 )
            $http.get('/Reporting/Composite/FirmAssets/' + assetId, {trackerMsg: 'Loading composite firm asset ' + assetId})
                .then(function(response) {
                    $scope.asset = response.data;
                    $scope.asset.asOfDate = Date.create($scope.asset.asOfDate); // it is odd that this has to be done but some records were coming out with an offset from GMT causing the date to be off by 1 day.
                });
        else
            $scope.asset = { id: 0, asOfDate: Date.create('today'), importSource: "New Source", totalValue: null, isImported: false };
    }


    // PUBLIC METHODS
    $scope.saveAsset = function( form ) {
        if (!form.$valid) return;

        var args = assetId > 0 ? {method: "PUT", id: assetId, trackerMsg: "Saving composite firm asset " + assetId} : {method: "POST", id: "", trackerMsg: "Adding new composite firm asset"};

        $http( { method: args.method, url: '/Reporting/Composite/FirmAssets/' + args.id, data: $scope.asset, trackerMsg: args.trackerMsg } )
            .then(function() {
                $location.path( '/reports/composites/firmassets' );
            });
    };

    $scope.deleteAsset = function( ) {
        $http.delete('/Reporting/Composite/FirmAssets/' +  assetId, {trackerMsg: 'Deleting composite firm asset ' + assetId})
            .then(function () {
                $location.path( '/reports/composites/firmassets' );
            });
    };


    // INITIALIZE
    $scope.current = {canDelete: $oasRights.canDelete("COMPOSITEACCOUNT")};
    loadAsset( );
});
'use strict';

app.controller('CompositeRangeListCtrl', function CompositeRangeListCtrl($scope, $http, $oasRights) {

    // PRIVATE METHODS
    function loadRanges() {
        $http.get( "/Reporting/Composite/Ranges", {trackerMsg: 'Loading composite range list'})
            .then(function(response) {
                $scope.rangeList = response.data;
                $scope.rangeTypes = response.data.map("name").unique();
            });
    }


    // PUBLIC METHODS
    $scope.deleteRange = function(range) {
        $http.delete('/Reporting/Composite/Ranges/' + range.id, {trackerMsg: 'Deleting composite range ' + range.id})
            .then(function () {
                loadRanges( );
            });
    };


    // INITIALIZE
    $scope.current = { showFilterRow : false };
    $scope.rights = $oasRights.forCode("COMPOSITEACCOUNT");
    loadRanges( );
});
'use strict';

app.controller('CompositeRangeCtrl', function CompositeRangeCtrl($scope, $http, $routeParams, $location, $oasRights) {
    // PRIVATE VARIABLES
    var rangeId = $routeParams.id;


    // PRIVATE METHODS
    function loadRange() {
        if( rangeId > 0 )
            $http.get('/Reporting/Composite/Ranges/' + rangeId, {trackerMsg: 'Loading composite range ' + rangeId})
                .then(function(response) {
                    $scope.range = response.data;
                });
        else
            $scope.range = { id: 0, name: 'New Range', upperBound: 100, lowerBound: 0 };
    }

    function loadRangeTypes() {
        $http.get('/Reporting/Composite/Ranges/Options/RangeType')
            .then(function(response) {
                $scope.rangeTypes = response.data.map("value");
            });
    }


    // PUBLIC METHODS
    $scope.saveRange = function( form ) {
        if (!form.$valid) return;

        var args = rangeId > 0 ? {method: "PUT", id: rangeId, trackerMsg: "Saving composite range " + rangeId} : {method: "POST", id: "", trackerMsg: "Adding new composite range"};

        $http( { method: args.method, url: '/Reporting/Composite/Ranges/' + args.id, data: $scope.range, trackerMsg: args.trackerMsg } )
            .then(function() {
                $location.path( '/reports/composites/ranges' );
            });
    };

    $scope.deleteRange = function( ) {
        $http.delete('/Reporting/Composite/Ranges/' +  rangeId, {trackerMsg: 'Deleting composite range ' + rangeId})
            .then(function () {
                $location.path( '/reports/composites/ranges' );
            });
    };


    // INITIALIZE
    $scope.current = {canDelete: $oasRights.canDelete("COMPOSITEACCOUNT")};
    loadRange( );
    loadRangeTypes( );
});
'use strict';

app.controller('CompositeReportListCtrl', function CompositeReportListCtrl($scope, $http, $oasRights, $dialog, compositeReportPrompterService) {

    // PUBLIC METHODS
    $scope.deleteCompositeReport = function( compositeReport ) {
        $dialog.confirmAction( "Are you sure you want to remove composite <b>" + compositeReport.reportName + "</b>?" )
            .open()
            .then( function( result ) {
                if( result === 'yes' ) {
                    $http.delete('/Reporting/Composite/Reports/' + compositeReport.id, {trackerMsg: 'Deleting composite report'})
                        .then(function () {
                            $scope.compositeReports.remove({id: compositeReport.id});
                        });
                }
            } );
    };

    $scope.runReportNew = function(){
        compositeReportPrompterService.runCompositeReport();
    };

    // PRIVATE METHODS
    function loadCompositeReports( ) {
        $http.get('/Reporting/Composite/Reports?expandGroups=false', {trackerMsg: 'Loading composite reports'})
            .then(function(response) {
                $scope.compositeReports = response.data;
            });
    }

    // INITIALIZE
    $scope.rights = $oasRights.forCode("COMPOSITEACCOUNT");
    $scope.current = {
        reports: []
    };
    loadCompositeReports( );
});
app.controller('CompositeReportCtrl', function CompositeReportCtrl($scope, $http, $location, $timeout, $window, $routeParams, API_CONFIG, $oasRights, $dialog, reportHelper) {

    // PRIVATE VARIABLES
    var masterGroupTypeList = [
        { groupType: 58, name:'401K Plan', keys: [], optionalFilters : {minValue: {isUsed: false, value: 0}, percentCashflow: {isUsed: false, value: 0}, minAssetAllocation: {isUsed: false, value: 0}, noFeePayingAccounts: {isUsed: false, value: false}, modelFeeAmount: {isUsed: false, value: 0}, discretionaryAccounts: {isUsed: false, value: false}, nonDiscretionaryAccounts: {isUsed: false, value: false}, minFixedIncomePercent: {isUsed: false, value: 0}}},
        { groupType: 18, name:'Custodian', keys: [], optionalFilters : {minValue: {isUsed: false, value: 0}, percentCashflow: {isUsed: false, value: 0}, minAssetAllocation: {isUsed: false, value: 0}, noFeePayingAccounts: {isUsed: false, value: false}, modelFeeAmount: {isUsed: false, value: 0}, discretionaryAccounts: {isUsed: false, value: false}, nonDiscretionaryAccounts: {isUsed: false, value: false}, minFixedIncomePercent: {isUsed: false, value: 0}}},
        { groupType: 12, name:'Fund Family', keys: [], optionalFilters : {minValue: {isUsed: false, value: 0}, percentCashflow: {isUsed: false, value: 0}, minAssetAllocation: {isUsed: false, value: 0}, noFeePayingAccounts: {isUsed: false, value: false}, modelFeeAmount: {isUsed: false, value: 0}, discretionaryAccounts: {isUsed: false, value: false}, nonDiscretionaryAccounts: {isUsed: false, value: false}, minFixedIncomePercent: {isUsed: false, value: 0}}},
        { groupType: 16, name:'Management Style', keys: [], optionalFilters : {minValue: {isUsed: false, value: 0}, percentCashflow: {isUsed: false, value: 0}, minAssetAllocation: {isUsed: false, value: 0}, noFeePayingAccounts: {isUsed: false, value: false}, modelFeeAmount: {isUsed: false, value: 0}, discretionaryAccounts: {isUsed: false, value: false}, nonDiscretionaryAccounts: {isUsed: false, value: false}, minFixedIncomePercent: {isUsed: false, value: 0}}},
        { groupType: 74, name:'Model', keys: [], optionalFilters : {minValue: {isUsed: false, value: 0}, percentCashflow: {isUsed: false, value: 0}, minAssetAllocation: {isUsed: false, value: 0}, noFeePayingAccounts: {isUsed: false, value: false}, modelFeeAmount: {isUsed: false, value: 0}, discretionaryAccounts: {isUsed: false, value: false}, nonDiscretionaryAccounts: {isUsed: false, value: false}, minFixedIncomePercent: {isUsed: false, value: 0}}},
        { groupType: 4, name:'Rep', keys: [], benchMarks : '', optionalFilters : {minValue: {isUsed: false, value: 0}, percentCashflow: {isUsed: false, value: 0}, minAssetAllocation: {isUsed: false, value: 0}, noFeePayingAccounts: {isUsed: false, value: false}, modelFeeAmount: {isUsed: false, value: 0}, discretionaryAccounts: {isUsed: false, value: false}, nonDiscretionaryAccounts: {isUsed: false, value: false}, minFixedIncomePercent: {isUsed: false, value: 0}} },
        { groupType: 999, name:'Risk Budget Range', keys: [], optionalFilters : {minValue: {isUsed: false, value: 0}, percentCashflow: {isUsed: false, value: 0}, minAssetAllocation: {isUsed: false, value: 0}, noFeePayingAccounts: {isUsed: false, value: false}, modelFeeAmount: {isUsed: false, value: 0}, discretionaryAccounts: {isUsed: false, value: false}, nonDiscretionaryAccounts: {isUsed: false, value: false}, minFixedIncomePercent: {isUsed: false, value: 0}} },
        { groupType: 1, name:'Risk Tolerance Range', keys: [], optionalFilters : {minValue: {isUsed: false, value: 0}, percentCashflow: {isUsed: false, value: 0}, minAssetAllocation: {isUsed: false, value: 0}, noFeePayingAccounts: {isUsed: false, value: false}, modelFeeAmount: {isUsed: false, value: 0}, discretionaryAccounts: {isUsed: false, value: false}, nonDiscretionaryAccounts: {isUsed: false, value: false}, minFixedIncomePercent: {isUsed: false, value: 0}} },
        { groupType: 0, name:'Stock Range', keys: [], optionalFilters : {minValue: {isUsed: false, value: 0}, percentCashflow: {isUsed: false, value: 0}, minAssetAllocation: {isUsed: false, value: 0}, noFeePayingAccounts: {isUsed: false, value: false}, modelFeeAmount: {isUsed: false, value: 0}, discretionaryAccounts: {isUsed: false, value: false}, nonDiscretionaryAccounts: {isUsed: false, value: false}, minFixedIncomePercent: {isUsed: false, value: 0}}}
    ];

    // PRIVATE METHODS
    function loadCompositeReport( ) {
        if( $routeParams.id > 0 ) {
            $http.get('/Reporting/Composite/Reports/' + $routeParams.id, {trackerMsg: 'Loading composite report'})
                .then(function(response) {
                    $scope.compositeReport = response.data;
                    
                    $scope.compositeReport.composites.forEach(function(composite){
                        composite.groups.forEach(function(group){
                            var filters ={};
                            Object.each(group.optionalFilters, function(k,v){
                                filters[k] = {value: v, isUsed: !!v};
                            });
                            group.optionalFilters = filters;
                        });
                    });
                });
        } else {
            $scope.compositeReport = {
                id: 0,
                reportName: '',
                lastUpdate: Date.create('today'),
                webEnabled: true,
                composites: []
            };
        }
    }

    // PUBLIC METHODS
    $scope.addComposite = function( ) {
        var composite = {
            id: 0,
            compositeName: $scope.current.newCompositeName,
            groups: angular.copy( masterGroupTypeList ),
            benchmarks: ''
        };
        $scope.compositeReport.composites.push( composite );
    };

    $scope.deleteCompositeReport = function( compositeReport ) {
        $dialog.confirmAction( "Are you sure you want to remove composite <b>" + compositeReport.reportName + "</b>?" )
            .open()
            .then( function( result ) {
                if( result == 'yes' ) {
                    $http.delete('/Reporting/Composite/Reports/' + compositeReport.id, {trackerMsg: 'Deleting composite report'})
                        .then(function () {
                            $location.path( '/reports/composites/reports' );
                        });
                }
            } );
    };

    $scope.downloadMembershipReport = function( ) {
        if( $scope.compositeReport ) {
            $window.location.href = API_CONFIG.baseUrl + '/Reporting/Composite/Reports/' +  $scope.compositeReport.id + '/run/csv?Authorization=' + sessionStorage.oas_token;
        }
    };
    

    $scope.saveCompositeReport = function( ) {
        if( $scope.compositeReport ) {
            $scope.compositeReport.composites.forEach(function(composite){
                composite.groups.forEach(function(group){
                    var filters ={};
                    Object.each(group.optionalFilters, function(k,v){
                        if (v != null){
                            if (!v.isUsed){
                                filters[k] = null;
                            } else {
                                filters[k] = v.value;
                            }

                        }
                    });
                    group.optionalFilters = filters;
                });
            });

            var args = $scope.compositeReport.id > 0 ? {method: "PUT", id: $scope.compositeReport.id, trackerMsg: "Saving composite report " + $scope.compositeReport.id} : {method: "POST", id: "", trackerMsg: "Adding new composite report"};

            $http( { method: args.method, url: '/Reporting/Composite/Reports/' + args.id, data: $scope.compositeReport, trackerMsg: args.trackerMsg } )
                .then( function ( ) {
                    $location.path( '/reports/composites/reports' );
                });
        }
    };

    $scope.removeComposite = function( idx ) {
        $scope.compositeReport.composites.splice(idx, 1);
    };

    $scope.loadBenchmarks = function(composite){
        var selectedItems = [];

        if (composite.benchmarks){
            selectedItems = composite.benchmarks.split(',').map(function(id){ return {key: id};});
        }

        $dialog.dialog({ templateUrl: "app/modals/available-select.html", controller: "AvailableSelectCtrl", resolve: {availableSelectedArgs: function() { return {selectionType: 35, selectedSelected: selectedItems, sortable: true}; }}})
                .open()
                .then(function(result) {
                    if (result) {
                        composite.benchmarks = result.map("key").join(',') || '0';
                    }
                });
    };

    $scope.loadStatisticalBenchmarks = function(composite){
        var selectedItems = [];

        if (composite.statisticalMarketIndex){
            selectedItems = composite.statisticalMarketIndex.split(',').map(function(id){ return {key: id};});
        }

        $dialog.dialog({ templateUrl: "app/modals/available-select.html", controller: "AvailableSelectCtrl", resolve: {availableSelectedArgs: function() { return {selectionType: 35, selectedSelected: selectedItems, sortable: true}; }}})
            .open()
            .then(function(result) {
                if (result) {
                    composite.statisticalMarketIndex = result[0].key; //Only one statistic can be used at a time
                }
            });
    };

    $scope.openDescriptionChangeHistory = function(groupId){
        $dialog.dialog({templateUrl: "description-change-history.html", controller: 'DescriptionChangeHistoryCtrl', groupId: groupId})
            .open()
            .then(function(result) {
                if(result) descriptionHistory = result;
            });
    };
    
    // INITIALIZE
    $scope.compositeReport = null;
    $scope.current = { newCompositeName: '' };
    $scope.rights = $oasRights.forCode("COMPOSITEACCOUNT");

    loadCompositeReport( );
});


app.controller('DescriptionChangeHistoryCtrl', function DescriptionChangeHistoryCtrl($scope, dialog, $http){
    var descriptionOriginal;

    function init(){
        $http.get('/Reporting/Composite/Reports/Group/' + $scope.current.groupId + '/Description', {trackerMsg: 'Getting description change history'})
            .then(function(response){
                descriptionOriginal = response.data;
                if (response.data.length > 1 ){
                    $scope.descriptionCurrent = response.data[0];
                    $scope.current.changeTo = response.data[1].description;

                    descriptionOriginal = angular.copy($scope.descriptionCurrent);
                    
                } else {
                    $scope.descriptionCurrent = response.data[0];
                    $scope.current.changeTo = "";
                }
            });
    };

    $scope.save = function(){

        if (!angular.equals(descriptionOriginal, $scope.descriptionCurrent)){;
            var payload = $scope.descriptionCurrent;
            payload.id = 0;

            $http.post('/Reporting/Composite/Reports/Group/' + $scope.current.groupId + '/Description', payload, {trackerMsg:'Saving composite description history'})
                .then(function(response){
                    dialog.close(null);
                })
        } else {
            dialog.close(null);
        }
    };

    $scope.close = function(){
        dialog.close(null);
    };

    $scope.current = {
        groupId : dialog.options.groupId,
        changeTo: ''
   };

    init();

});
'use strict';

app.controller('CompositeArchivedRptCtrl', function CompositeArchivedRptCtrl($scope, $http, views, $oasRights,API_CONFIG){
    
    function init(){
        $scope.rights = $oasRights.forCode("COMPOSITEACCOUNT");
    }

    $scope.downloadReport = function(){
        // window.location.href = API_CONFIG.baseUrl + '/Reporting/ReportInbox/' + $scope.selectedIds[0] + '/Download' + '?Authorization=' + sessionStorage.oas_token;
        window.location.href = API_CONFIG.baseUrl + '/Reporting/Composite/Accounts/Archive/' + $scope.selectedIds[0] + '/Download'  + '?Authorization=' + sessionStorage.oas_token;

    };

    $scope.deleteArchiveRpt = function(){
        $http.delete('/Reporting/Composite/Accounts/Archive/' + $scope.selectedIds[0], {trackerMsg: 'Deleting Report', headers: {Unmasquerade: "true"}})
            .then(function(response){
                $scope.$broadcast('event:composite-accounts-archived-reports-action', {action: 'refresh-grid'});
            });
    }
    
    // INITIALIZE
    $scope.views = views;

    $scope.selectedIds = [];
    $scope.current = {
        view: views[0],
        url: '/Reporting/Composite/Accounts/Archive'
    };

    init();
});

'use strict';

app.controller('CompositeWizardCtrl', function CompositeWizardCtrl($scope,$http,$oasRights, $location, dbeoService){
   //PRIVATE FUNCTIONS
    function init(){
        $scope.rightsCompositeWizard = $oasRights.forCode('COMPOSITEACCOUNT');

        $scope.availableMonths = [];
        $scope.monthsToCalculate = (1).upto(12, function(n) {
            $scope.availableMonths.push({id: n, name: Date.create(n + "/1/2000").format('{Month}')})
        });
        $scope.availableYears = ($scope.current.year).downto($scope.current.year - 20);
        dbeoService.get('69USENEWCOMPACCOUNTSPAGE').then(useNewCompositeAccountsPage => {
                $scope.useNewCompositeAccountsPage = useNewCompositeAccountsPage;
            });
    };

    function setRunFor(){
        switch($scope.current.accountSelectionType){
            case 5:
                $scope.current.runForText = "Household";
                break;
            case 6:
                $scope.current.runForText = "Registration";
                break;
            case 7:
                $scope.current.runForText = "Accounts";
                break;
            case 74:
                $scope.current.runForText = "Models";
                break;
            case 12:
                $scope.current.runForText = "Fund Families";
                break;
            case 58:
                $scope.current.runForText = "401k Plan";
                break;
            case 18:
                $scope.current.runForText = "Custodian";
                break;
            case 4:
                $scope.current.runForText = "Representative";
                break;
            case 16:
                $scope.current.runForText = "Management Style";
                break;
        }
    }

    //PUBLIC METHODS
    $scope.clearSelected = function() {
        $scope.current.selectedItems = [];

        if ($scope.current.accountSelectionType === 7){
            $scope.current.selectionType = 0;
        }
    };

    $scope.jumpBackTo = function(index) {
        if ($scope.current.executing) return;

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };

    $scope.next = function() {
        switch ($scope.current.wizardStep) {
            case 0:  // Selection
            case 1:
                setRunFor();
            case 2:
                $scope.current.animation = 'slide-right';
                $scope.current.wizardStep += 1;
                break;
            default:
                $scope.current.animation = 'slide-right';
                $scope.current.wizardStep += 1;
                break;
        }
    };

    $scope.back = function() {
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep -= 1;
    };

    $scope.isStepIncomplete = function() {
        switch ($scope.current.wizardStep) {
            case 1:
                if (($scope.current.selectionType === 1 || $scope.current.selectionType === 2) && $scope.current.selectedItems.length === 0){
                    return true;
                } else {
                    return false;
                }
            default:
                return false;
        }
    };

    $scope.getMonthName = function(monthNumber){
        monthNumber += -1;
        var month =[ "January","February","March","April","May","June","July","August","September","October", "November", "December"];
        return month[monthNumber];
    };

    $scope.saveSettings = function(){
        var args = {
            override: $scope.current.override,
            selection: $scope.current.accountSelectionType
        };

    };

    $scope.createBatchList = function(){
        $http.get("/Reporting/Composite/Wizard/CompositeDefinition", {trackerMsg: 'Loading composite definition', allowCancellation: false})
            .then(function(response){

                var compositeDefinition = response.data;

                compositeDefinition.entity = $scope.current.accountSelectionType;
                compositeDefinition.keys = $scope.current.selectedItems.map("id");

                if ($scope.current.selectionType === 0){
                    compositeDefinition.keys = null;
                }
                compositeDefinition.numberOfMonths = $scope.current.monthsToCalc;
                compositeDefinition.overwrite = $scope.current.override;
                compositeDefinition.recalc = false;
                compositeDefinition.start = $scope.current.month + "/01/" + $scope.current.startYear.getFullYear();

                $http.post("/Reporting/Composite/Wizard/Action/Instance", compositeDefinition, {trackerMsg: 'Running calculation'})
                    .then(function(res) {
                        const text = $scope.useNewCompositeAccountsPage ? 'accounts-new' : 'accounts-old';
                        $location.url('/reports/composites/' + text + '?compositeInstanceId=' + res.data);
                    });
            });

        location.href = '#/reports/composites/accounts';
    };

    $scope.startImportOver = function( ) {
        $scope.current.selectedItems = null;
    };

    $scope.current = {
        wizardStep: 0,
        animation: 'slide-right',
        accountSelectionType: 7,
        month: Date.create('today').getMonth() + 1,
        year: Date.create('today').getFullYear(),
        minAcctVal: 0,
        minIncDate: Date.create('today').getStartOfQuarter(),
        monthsToCalc: 1,
        override: true,
        selectedItems: [],
        filterBasedOnMin: false,
        selectionType: 0,
        startYear: Date.create('today')
    };
    $scope.wizardSteps = ['Batch Information', 'Selection', 'Review/Submit'];

    init();
});
'use strict';


app.controller('CompositeSupervisionCtrl', function CompositeSupervisionCtrl($scope, $http, $portfolio, entities, apps, compositeFeeOptionType, $oasCharts){
    var composite_supervision_settings;

    function init(){
        $http.get('/Settings/UserOptions/composite_supervision_settings', {trackerMsg: 'Loading search fields'})
            .then(function(response){
               composite_supervision_settings = response.data;
               if (composite_supervision_settings.id > 0){
                   $scope.current.params = JSON.parse(response.data.value);
                   $scope.current.params.startDate = Date.create($scope.current.params.startDate);
                   $scope.current.params.endDate = Date.create($scope.current.params.endDate);
               }
            });

        $scope.compositeFeeOptionType = $portfolio.enumToSimpleList(compositeFeeOptionType);
    }

    function setPropToNull(payload, prop){
      payload[prop] = null;
    }

    function parsePerfNumber(data, idx) {
        return isNaN(parseFloat(data.values[idx])) ? 0 : parseFloat(data.values[idx]).round(2)
    }

    function showHideProp(payload, toleranceDetails){
        for(var prop in $scope.current){
            if ($scope.current.hasOwnProperty(prop)) {
                switch (prop) {
                    case 'perfPercent':
                        if (!$scope.current[prop]){
                            if (payload){
                                setPropToNull(payload, "performanceHigh");
                                setPropToNull(payload, "performanceLow");
                            }
                            else {
                                delete toleranceDetails.remove({name: 'Index Performance'});
                            }
                        }
                        break;
                    case 'beta':
                        if (!$scope.current[prop]){
                            if (payload){
                                setPropToNull(payload, "betaHigh");
                                setPropToNull(payload, "betaLow");
                            }
                            else{
                                delete toleranceDetails.remove({name: 'Beta'});
                            }

                        }
                        break;
                    case 'sharpe':
                        if (!$scope.current[prop]){
                            if (payload){
                                setPropToNull(payload, "sharpeHigh");
                                setPropToNull(payload, "sharpeLow");
                            }else {
                                delete toleranceDetails.remove({name: 'Sharpe'});
                            }
                        }
                        break;
                    case 'stDev':
                        if (!$scope.current[prop]){
                            if (payload){
                                setPropToNull(payload, "standardDeviationHigh");
                                setPropToNull(payload, "standardDeviationLow");
                            } else {
                                delete toleranceDetails.remove({name: 'Standard Deviation'});
                            }
                        }
                        break;
                    case 'alpha':
                        if (!$scope.current[prop]){
                            if (payload){
                                setPropToNull(payload, "alphaHigh");
                                setPropToNull(payload, "alphaLow");
                            } else {
                                delete toleranceDetails.remove({name:'Alpha'});
                            }
                        }
                        break;
                    case 'sortino':
                        if (!$scope.current[prop]){
                            if (payload){
                                setPropToNull(payload, "sortinoHigh");
                                setPropToNull(payload, "sortinoLow");
                            } else {
                                delete toleranceDetails.remove({name: 'Sortino'});
                            }
                        }
                        break;
                    case 'treynor':
                        if (!$scope.current[prop]){
                            if (payload){
                                setPropToNull(payload, "treynorHigh");
                                setPropToNull(payload, "treynorLow");
                            } else {
                                delete toleranceDetails.remove({name: 'Treynor'});
                            }
                        }
                        break;
                    case 'compPercent':
                        if (!$scope.current[prop]){
                            if (payload){
                                setPropToNull(payload, "compPercentHigh");
                                setPropToNull(payload, "compPercentLow");
                            } else {
                                delete toleranceDetails.remove({name: 'Composite Performance'});
                            }
                        }
                        break;
                    case 'compDispersion':
                        if (!$scope.current[prop]){
                            if (payload){
                                setPropToNull(payload, "compDispersion");
                                setPropToNull(payload, "compDispersion");
                            } else {
                                delete toleranceDetails.remove({name: 'Composite Performance Dispersion'});
                            }
                        }
                        break;
                    case 'targetFilter':
                        if (!$scope.current[prop]){
                            if (payload){
                                setPropToNull(payload, "compDispersion");
                            }
                        }
                        break;
                }
            }
        }
    }

    $scope.showAccounts = function(index, data){

        var compositeDetails = {
            performance: parsePerfNumber(data, 1),
            alpha: parsePerfNumber(data, 2),
            beta: parsePerfNumber(data, 3),
            sharpe: parsePerfNumber(data, 4),
            sortino: parsePerfNumber(data, 5),
            treynor: parsePerfNumber(data, 6),
            standardDev: parsePerfNumber(data, 7)
        };

        var outLiersData = { totalAccounts: data.values[9], outliers: data.values[8], inTolerance: data.values[9] - data.values[8]};

        var payload = angular.copy($scope.current.params), compDispersionMultiplier;
        payload.startDate = Date.create(payload.startDate).formatted();
        payload.endDate = Date.create(payload.endDate).endOfMonth().formatted();
        payload.targetIndexes = payload.targetIndexes.map("key");

        switch( payload.compDispersion){
            case 1:
                compDispersionMultiplier = 0.341;
                break;
            case 2:
                compDispersionMultiplier = 0.477;
                break;
            case 3:
                compDispersionMultiplier = 0.498;
                break;
        }

        $scope.current.toleranceDetails = [
            {name: 'Composite Performance', lower: payload.compPercentLow, higher:  payload.compPercentHigh, valid: (compositeDetails.performance - payload.compPercentLow).round(2), range: (compositeDetails.performance + payload.compPercentHigh).round(2)},
            {name: 'Index Performance', lower: payload.performanceLow, higher: payload.performanceHigh, valid: parseFloat(index[1]).round(2) - payload.performanceLow , range: payload.performanceHigh + parseFloat(index[1]).round(2)},
            {name: 'Standard Deviation', lower: payload.standardDeviationLow, higher: payload.standardDeviationHigh, valid: (compositeDetails.standardDev - payload.standardDeviationLow).round(2) , range: (compositeDetails.standardDev + payload.standardDeviationHigh).round(2)},
            {name: 'Beta', lower: payload.betaLow, higher: payload.betaHigh, valid: (compositeDetails.beta - payload.betaLow).round(2), range: (payload.betaHigh + compositeDetails.beta).round(2) },
            {name: 'Alpha', lower: payload.alphaLow, higher: payload.alphaHigh, valid: (compositeDetails.alpha - payload.alphaLow).round(2), range: (payload.alphaHigh + compositeDetails.alpha).round(2)},
            {name: 'Sharpe', lower: payload.sharpeLow, higher: payload.sharpeHigh, valid: (compositeDetails.sharpe - payload.sharpeLow).round(2), range: (payload.sharpeHigh + compositeDetails.sharpe).round(2)},
            {name: 'Sortino', lower: payload.sortinoLow, higher: payload.sortinoHigh, valid: (compositeDetails.sortino - payload.sortinoLow).round(2), range: (payload.sortinoHigh + compositeDetails.sortino).round(2)},
            {name: 'Treynor', lower: payload.treynorLow, higher: payload.treynorHigh, valid: (compositeDetails.treynor - payload.treynorLow).round(2), range: (payload.treynorHigh + compositeDetails.treynor).round(2)},
            {name: 'Composite Performance Dispersion', lower: null, higher: payload.treynorHigh, valid: compositeDetails.performance -(compositeDetails.performance * compDispersionMultiplier) , range: compositeDetails.performance  + (compositeDetails.performance * compDispersionMultiplier) },
        ];

        showHideProp(null, $scope.current.toleranceDetails);

        $http.post(data.action, payload, {trackerMsg: 'Getting account data'})
            .then(function(response){
                $scope.current.accounts = response.data;

                // Use for histogram chart
                var performanceNumbers = $scope.current.accounts.data.map(function(data){ return data.values[8]; });
                var uniquePerfNumbers = performanceNumbers.unique();

                var performanceCount = [];

                uniquePerfNumbers.forEach(function(performance){
                    var count = performanceNumbers.reduce(function(a,b){
                        return a + (b === performance)
                    }, 0);

                    performanceCount.push([performance.toNumber(), count]);
                });

                $scope.current.inToleranceChartConfig = $oasCharts.createPieChart('', [{ name: 'In Tolerance', y: outLiersData.inTolerance, value: outLiersData.inTolerance, color: '#2F7ED8' }, { name: 'Outliers', y: outLiersData.outliers, value: outLiersData.outliers, color: '#FF0000'}]);
                $scope.current.inToleranceChartConfig.title.text = 'Accounts In/Out Tolerance';
                $scope.current.inToleranceChartConfig.options.plotOptions.pie.dataLabels.enabled = true;
                $scope.current.inToleranceChartConfig.options.plotOptions.pie.dataLabels.format = '<b>{point.name}</b>: {point.y}';
                $scope.current.inToleranceChartConfig.options.tooltip.pointFormat = '{series.name}: <b>{point.y}</b>';
                $scope.current.tabs.accounts = true;
            })
    };

    $scope.viewSuitability = function(account){
        $http.get('/Portfolio/Accounts/' + account + '/Simple',{trackerMsg: 'Getting account information'})
            .then(function(response){
                $portfolio.openEditor(entities.registration.value,[response.data.registrationId], 'Suitability', 'suitability', apps.billingAudit.name, null);
            })

    };

    $scope.toggleOptions = function(){
      $scope.current.toggleOn = !$scope.current.toggleOn;
    };

    $scope.runReport = function(){
        var payload = angular.copy($scope.current.params);
        payload.startDate = Date.create(payload.startDate).formatted();
        payload.endDate = Date.create(payload.endDate).endOfMonth().formatted();
        payload.targetIndexes = payload.targetIndexes.map("key");
        var settingsPayload = {};

        showHideProp(payload,null);

        if (composite_supervision_settings.id > 0){
            composite_supervision_settings.value = JSON.stringify($scope.current.params);
        } else {
            composite_supervision_settings = {
                id: 0,
                optionName: 'composite_supervision_settings',
                value: JSON.stringify($scope.current.params)
            };
        }

        $http.post('/Settings/UserOptions/composite_supervision_settings', composite_supervision_settings)
            .then(function (response) {
                composite_supervision_settings = response.data;
                $scope.current.params = JSON.parse(response.data.value);

                $scope.current.params.startDate = Date.create($scope.current.params.startDate);
                $scope.current.params.endDate = Date.create($scope.current.params.endDate);
            });

        $http.post('/Reporting/Composite/Dashboard', payload, {trackerMsg: 'Running report'})
            .then(function(response){
                $scope.current.report.columns = response.data.columns;
                $scope.current.report.managementStyleData = response.data.data;
                $scope.toggleOptions();
            })
    };

    $scope.current = {
        params: {
            startDate: Date.create('today').addMonths(-1).beginningOfMonth(),
            endDate: Date.create('today').endOfMonth(),
            targetIndexes: [],
            showAllAccounts: false,
            runReportAutomatically: false,
            feeOptionId: null,
            performanceHigh: null,
            performanceLow: null,
            standardDeviationHigh: null,
            standardDeviationLow: null,
            treynorHigh: null,
            treynorLow: null,
            betaHigh: null,
            betaLow: null,
            alphaHigh: null,
            alphaLow: null,
            compPercentHigh: null,
            compPercentLow: null,
            sharpeHigh: null,
            sharpeLow: null,
            sortinoHigh: null,
            sortinoLow: null,
            compDispersion: null
        },
        perfPercent: false,
        stDev: false,
        treynor: false,
        beta: false,
        alpha: false,
        compPercent: false,
        sharpe: false,
        sortino: false,
        targetFilter: false,
        report:{
            columns: [],
            data:[]
        },
        inToleranceChartConfig: [],
        indices: {ids: [], showFilters: false},
        toggleOn: true,
        tabs: {
            indices: true,
            accounts: false
        },
        toleranceDetails: []
    };

    init();
});
'use strict';

app.controller('CompositeRulesCtrl', function CompositeRulesCtrl($scope, $http, $dialog, compositeReportPrompterService){
    $scope.masterGroupTypeList = [
        { entityEnum: 58, entity:'401K Plan', ids: [] },
        { entityEnum: 18, entity:'Custodian', ids: []},
        { entityEnum: 12, entity:'Fund Family', ids: []},
        { entityEnum: 16, entity:'Management Style', ids: []},
        { entityEnum: 74, entity:'Model', ids: []},
        { entityEnum: 4, entity:'Rep', ids: [], benchMarks : '' },
        { entityEnum: 999, entity:'Risk Budget Range', ids: [] },
        { entityEnum: 0, entity:'Stock Range', ids: []}
    ];

    // PRIVATE FUNCTIONS
    function init(){
        $http.get('/Reporting/Composite/Rules',{trackerMsg: 'Loading composite rules'})
            .then(function(res){
                $scope.compositeRules = res.data;
            });
    }

    function extractKeys(list){
        $scope.masterGroupTypeList.forEach(function(entity){
            entity.ids = [];
        });

        list.forEach(function(item){
            var group = $scope.masterGroupTypeList.find({entityEnum: item.entityEnum});

            if (group){
                group.ids = item.ids.map(function(id){ return {id: id}});
            }
        });
    };

    // PUBLIC FUNCTIONS
    $scope.saveRules = function(){
        $scope.masterGroupTypeList.forEach(function(group){
            group.ids = group.ids.map("id");
            group.showFilters = false;
        });

        $scope.current.selectedRule.ruleDetail.filters = $scope.masterGroupTypeList;

        if ($scope.current.selectedRule){
            var args = $scope.current.selectedRule.id > 0 ? {method: "PUT", id: $scope.current.selectedRule.id, trackerMsg: "Saving composite rules " + $scope.current.selectedRule.id, url: '/Reporting/Composite/Rules/' + $scope.current.selectedRule.id} : {method: "POST", id: "", trackerMsg: "Adding new composite rules", url: '/Reporting/Composite/Rules/' };

            $http({method: args.method, url: args.url, data: $scope.current.selectedRule, trackerMsg: 'Saving composite rules'})
                .then(function(res){
                    init();
                    if (res.data){
                        $scope.current.selectedRule = null;
                    }
                });
        }

    };

    $scope.addNewRule = function(){
        $scope.masterGroupTypeList.forEach(function(entity){
            entity.ids = [];
        });
        $scope.current.selectedRule = {
            id: 0,
            name: 'New Rule',
            isVisible: true,
            ruleDetail: {
                filters : {
                } ,
                minValue: 0,
                minEndValue: 0,
                cashFlowPercent: null,
                outFlow: null,
            }
        };
    };

    $scope.editRule = function(rule){
        rule.isVisible = true;
        if (rule){
            $scope.masterGroupTypeList.forEach(function(entity){
                entity.showFilters = false;
            });

            $scope.current.selectedRule = rule;
            extractKeys($scope.current.selectedRule.ruleDetail.filters);
        }
    };

    $scope.deleteRule = function(rule){
        $dialog.confirmAction("Are you sure you want to remove this composite rule?")
            .open()
            .then(function (result) {
                if (result === "yes") {
                    $http.delete('/Reporting/Composite/Rules/Action/Delete/' + rule.id, {trackerMsg: 'Deleting composite rule'})
                        .then(function(res){
                            $scope.compositeRules.remove(rule);
                        })
                }
            });
    };

    $scope.showFilter = function(selectedEntity){
        selectedEntity.showFilters = !selectedEntity.showFilters;

        $scope.masterGroupTypeList.forEach(function(entity){
            if (selectedEntity != entity){
                entity.showFilters = false;
            }
        })
    };

    $scope.toggleVisibility = function(selectedRule){
        selectedRule.isVisible = !selectedRule.isVisible;
    };

    $scope.showHelpText = function (option) {
        var text = null;
        switch (option) {
            case 'Minimum Beginning Value':
                text = 'The minimum Beginning Value that a group can have.';
                break;
            case 'Minimum Ending Value':
                text = 'The minimum Ending Value that a group can have.';
                break;
            case 'Minimum Equity Asset Allocation':
                text = 'The minimum percentage allocated to Equity that a group can have. Equity includes any product which is assigned to an asset category that has a parent category of Equity.';
                break;
            case 'Maximum Cash Inflow Percent':
                text = 'The maximum inflow percentage that a group can have. Inflow percentage is the sum of the inflow transactions divided by the Beginning Value. Inflow transactions include Contribution, Merge In From Other Account, SWP, Internal Account Journal In, Transfer In - Non Taxable, ' +
                    'and Deposit.';
                break;
            case 'Maximum Cash Outflow Percent':
                text = 'The maximum outflow percentage that a group can have. Outflow percentage is the sum of the outflow transactions divided by the Beginning Value. Outflow transactions include Distribution, Merge Out To Other Account, SWD, Internal Account Journal Out, Transfer Out - Non Taxable, ' +
                    'and Withdrawal.';
                break;
            case 'Maximum Cash Flow Percent':
                text = 'The maximum cashflow percentage that a group can have. Cashflow percentage is the absolute sum of the contribution and distribution transactions divided by the Beginning Value. Contribution transactions include Contribution, Employer Contribution, ' +
                    '1035 Exchange In, Starting Value, SWP, Short Starting Value, Rollover Contribution, Loan Setup, Loan Repayment, Unknown Cost Basis, Reportable Transfer In, Transfer In - Non Taxable, and Deposit. Distribution transactions include ' +
                    'Dividend Tax, Long Term Gain Tax, 1035 Exchange Out, Distribution, Employer Distribution, Short Term Gain Tax, Foreign Tax Withheld, Tax Withheld, SWD, Cancel Account, Federal Tax Withheld, State Tax Withheld, Loan Payment, Loan Distribution, Transfer Out - Non Taxable, Tax Credit, and Withdrawal.';
                break;
            case 'Exclude No Fee Paying':
                text = 'Exclude groups which have a Fee Amount equal to zero. The Fee Amount comes from the bill schedule assigned to the group.';
                break;
            case 'Exclude Non Discretionary Accounts':
                text = 'Exclude the accounts which are Non Discretionary.';
                break;
            case 'Exclude Discretionary Accounts':
                text = 'Exclude the accounts which are Discretionary.';
                break;
            case 'Minimum Fixed Income Percent':
                text = 'The minimum Fixed Income percentage that a group can have.';
                break;
            case 'Trade Hold Days Exclusion':
                text = 'Excludes accounts that have been on trade hold for the specified number of days during the month.'
                break;
            case 'Minimum Restricted Percent':
                text = 'The minimum allowed percentage of restricted assets that a group can have.'
                break;
            case 'Maximum Restricted Percent':
                text = 'The maximum allowed percentage of restricted assets that a group can have.'
                break;
            case 'Maximum Capital Gain Budget':
                text = 'The maximum allowed capital gain budget that a group can have.'
                break;
            case 'Minimum Capital Gain Budget':
                text = 'The minimum allowed capital gain budget that a group can have.'
                break;
        }
        if(text) {
            $dialog.messageBox(option, text).open();
        }
    };

    $scope.groupDiscretionary = function (selectedRule) {
        if (selectedRule == "nondiscretionary") {
            $scope.current.selectedRule.ruleDetail.discretionaryAccounts = false;
        }
        else {
            $scope.current.selectedRule.ruleDetail.nonDiscretionaryAccounts = false;
        }
    };

    $scope.runReportNew = function () {
        compositeReportPrompterService.runCompositeReport();
    };

    $scope.current = {
        selectedRule : null,
        reports: []
    };

    init();

});
'use strict';

app.service('$oasCharts', function() {

    //PRIVATE VARIABLES
    var self = this;

    var pieConfig = {
        options: {
            chart: {backgroundColor:'transparent' },
            credits: {enabled: false },
            plotOptions: {
                pie: {
                    innerSize: '70%',
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: { enabled: false, color: '#000000', connectorColor: '#000000', format: '{point.name}: <b>{point.percentage:.1f}%</b>' }
                }
            },
            tooltip: {pointFormat: '<b>${point.value:,.2f}</b>' },
            drilldown: { series:[] }
        },
        series: [ {type: 'pie', name: 'Series', data: [], animation: false } ],
        title: {text: ''}
    };

    var areaConfig = {
        options: {
            chart: {type: 'area', backgroundColor:'transparent', zoomType: 'xy'},
            credits: {enabled: false },
            xAxis: {labels: { formatter: function() { return Highcharts.dateFormat('%b %y', this.value); } }, type: 'datetime'},
            yAxis: {title: { text: '' }, labels: { formatter: function() { return  '' + Highcharts.numberFormat(this.value, 0) + ''; } }},
            tooltip: {xDateFormat: '%m/%d/%Y', pointFormat: '{series.name}: <b>${point.y:,.2f}</b><br/>', followTouchMove: true, shared: true},
            plotOptions: {area: { pointStart: Date.UTC(1970, 0, 1),  pointInterval: 24 * 3600 * 1000, marker: { enabled: false, symbol: 'circle', radius: 2, states: { hover: { enabled: true } } } }}
        },
        series: [],
        title: {text: ''},
        subtitle: {text: ''}
    };

    var columnConfig = {
        options: {
            chart: {type: 'column', backgroundColor:'transparent'},
            credits: {enabled: false},
            legend: {enabled: false},
            xAxis: {categories: [], labels: { rotation: -45, align: 'right', style: { fontSize: '11px', fontFamily: 'Helvetica, Neue' } }},
            yAxis: {title: {text: ''}, labels: {format: '{value}%'}},
            plotOptions: { column: { pointPadding: 0.2, borderWidth: 0 }},
            tooltip: { pointFormat: '{series.name}: <b>{point.y:.2f}%</b>'},
            drilldown: { series:[] }
        },
        series: [],
        title: {text: ''},
        subtitle: {text: ''}
    };

    var stackedColumnConfig = {
        options: {
            legend: { enabled: false },
            chart: { type: 'column' },
            xAxis: { categories: [] },
            yAxis: { min: 0, title: { text: '' },
                stackLabels: { enabled: true, style: { fontWeight: 'bold', color: '#000000'}, formatter: function () {return "$" + Highcharts.numberFormat(this.total, 2, '.', ',');} }
            },
            plotOptions: { column: { stacking: 'normal', dataLabels: { enabled: false, color: '#FFFFFF', style: { textShadow: '0 0 3px black' } } } },
            tooltip: {
                formatter: function () {
                    return '<b>' + this.x + '</b><br/>' + this.series.name + ': ' + '$' + Highcharts.numberFormat(this.y, 2, '.', ',') + '<br/>' + 'Total: $' + Highcharts.numberFormat(this.point.stackTotal, 2, '.', ',')
                }
            }
        },
        credits: { enabled: false },
        series: [],
        title: {text: ''},
        subtitle: {text: ''}
    };

    var lineConfig = {
        options: {
            chart: {backgroundColor:'transparent'},
            credits: {enabled: false},
            xAxis: {categories: [], gridLineColor: 'transparent', labels: { enabled: false, rotation: -45, align: 'right', style: { fontSize: '11px', fontFamily: 'Helvetica, Neue' } },
                lineWidth: 0,
                minorGridLineWidth: 0,
                lineColor: 'transparent',
                minorTickLength: 0,
                tickLength: 0
            },
            yAxis: {
                title: {text: ''},
                plotLines: [{value: 0, width: 1, color: '#808080'}],
                labels: { enabled: false }//,
                //gridLineColor: 'transparent'
            },
            tooltip: {valueSuffix: ''},
            legend: {enabled: false, layout: 'vertical', align: 'right', verticalAlign: 'middle', borderWidth: 0}
        },
        series: [ ],
        title: {text: ''},
        subtitle: {text: ''}
    };

    var scatterConfig = {
        options: {
            chart: {type: 'scatter', zoomType: 'xy', backgroundColor:'transparent'},
            credits: {enabled: false},
            xAxis: {title: {enabled: true, text: ''}},
            yAxis: {title: {text: ''}, labels: { formatter: function() { return  '$' + Highcharts.numberFormat(this.value, 0); } }},
            legend: {enabled: true},
            plotOptions: {
                scatter: {
                    tooltip: {
                        headerFormat: '<b>{series.name}</b><br>',
                        pointFormat: '{point.name} for {point.noUnits} shares on {point.transDate} ({point.x} days ago) at an amount of ${point.y};'

                    }
                }
            }
        },
        series: [ ],
        title: {text: ''},
        subtitle: {text: ''}
    };

    var columnWithDrilldownConfig = {
        options: {
            chart: {type: 'column', backgroundColor:'transparent'},
            credits: {enabled: false},
            subtitle: {text: ''},
            xAxis: {type: 'category'},
            yAxis: {title: {text: ''}},
            legend: {enabled: false},
            plotOptions: {series: {borderWidth: 0, dataLabels: {enabled: true,format: '${point.y:,.2f}'}}},
            tooltip: {
                headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>${point.y:,.2f}</b><br/>'
            },
            drilldown: {
                series: []
            }
        },
        title: {text: ''},
        series: [{
            name: "Totals",
            //colorByPoint: true,
            data: []
        }],

    };

    var barConfig = {
        options: {
            chart: { type: 'bar', backgroundColor:'transparent' },
            credits: {enabled: false },
            xAxis: { categories: [] },
            yAxis: { title: { text: '' } },
            legend: { enabled: false },
            plotOptions: { series: { stacking: 'normal' } },
            tooltip: {pointFormat: '<b>${point.y:,.2f}</b>' }
        },
        series: [{
            name: 'Group',
            data: []
        }],
        title: {text: ''}
    };

    var gaugeConfig = {
        options: {
            chart: { type: 'solidgauge', backgroundColor:'transparent' },
            pane: { size: '50%', startAngle: -90, endAngle: 90, background: { backgroundColor:'#EEE', innerRadius: '60%', outerRadius: '100%', shape: 'arc'} },
            solidgauge: { dataLabels: { y: -30, borderWidth: 0, useHTML: true } },
            tooltip: { pointFormat: '{series.name}: <b>{point.name}</b>'}
        },
        series: [{
            data: [ {y:25, name:'25/75'}],
            name: 'Stock To Bond',
            dataLabels: { format: '<span style="font-size:10px;color:#000000">{point.name}</span><br/></span>' }
        }],
        yAxis: {
            currentMin: 0,
            currentMax: 100,
            stops: [
                [0.25, '#55BF3B'], // green
                [0.50, '#DDDF0D'], // yellow
                [0.75, '#DF5353'] // red
            ],
            tickInterval: 25
        },
        title: { text: '' }
    };

    var modelToleranceConfig = {
        options: {
            chart: {type: 'bar', borderWidth: 0, backgroundColor:'transparent'},
            credits: {enabled: false},
            legend: {enabled: true, borderWidth: 0},
            xAxis: {categories: []},
            yAxis: {title: {text: ''}, labels: {formatter: function() {return this.value === 0 ? 'Target' : this.value + ' %'}}},
            plotOptions: {bar: {grouping: false, shadow: false, pointPadding: 0}},
            tooltip: {
                formatter: function() {
                    var chart = this.points[0].series.chart;
                    var categories = chart.xAxis[0].categories;
                    var index = 0, temp = {};

                    while(this.x !== categories[index]){index++;}
                    chart.series.forEach(function(series) {
                        temp[series.name] = series.yData[index];
                    });

                    var target = temp['Target'].round(2);
                    var bottom = (temp['Target'] + temp['Lower']).round(2);
                    var top = (temp['Target'] + temp['Upper']).round(2);
                    var range = bottom === target && top === target ? '' : '<br/>Range: ' + bottom + ' - ' + top + ' %';
                    var curr = parseFloat(temp['Current']) + target;

                    return '<b>'+ this.x + '<br/>Target: ' + target + ' %' + range + '<br/>Current: ' + curr + ' %';
                },
                shared: true,
                shadow: false,
                borderColor: "#CCCCCC"
            }
        },
        series: [
            {data: [], name: 'Lower', animation: false, borderColor: "#00AEEF", color: "rgba(0, 170, 239, 0.1)"},
            {data: [], name: 'Upper', animation: false, borderColor: "#00AEEF", color: "rgba(0, 170, 239, 0.1)"},
            {data: [], name: 'Current', animation: false, borderColor: "#00AEEF", color: '#00AEEF', pointPadding: 0.2},
            {data: [], name: 'Target', animation: false, visible: false, showInLegend: false}
        ],
        title: {text: ''}
    };

    var treemapConfig = {
        options: {
            credits: {enabled: false },
            legend: { enabled: false },
            tooltip: {pointFormat: '<b>{point.tooltip}</b>' }
            //tooltip: {pointFormat: '<b>{point.name}:</b> {point.value:,.2f}%' }
        },
        series: [{
            dataLabels: { enabled: true, format: '<span style="font-size:10px;color:#FFFFFF">{point.name}</span>' },
            type: 'treemap',
            layoutAlgorithm: 'squarified',
            data: []
        }],
        title: {text: ''}
    };

    var columnRangeConfig = {
        options: {
            chart: { type: 'columnrange', backgroundColor:'transparent', inverted:false },
            credits: {enabled: false},
            tooltip: { valueSuffix: '' },
            legend: { enabled: true }
        },
        series: [],
        xAxis: { categories: [] },
        yAxis: { title: { text: '' }, labels: { format: '{value}%' } },
        title: { text: '' },
        subtitle: { text: '' }
    };


    //PUBLIC API
    self.createPieChart = function( seriesName, seriesData, drilldownDataFullDefinition ) {
        var p = angular.copy( pieConfig );
        p.series[0].animation = true;
        p.series[0].name = seriesName;
        p.series[0].data = seriesData;

        if( drilldownDataFullDefinition ) {
            p.options.drilldown = drilldownDataFullDefinition;
        }

        return p;
    };

    self.createAreaChart = function( pointStart, fullSeriesDefinition, unitsPrefix, unitsSuffix ) {
        var a = angular.copy( areaConfig );
        a.options.plotOptions.area.pointStart = pointStart;
        a.options.yAxis.labels = { formatter: function() { return  unitsPrefix + Highcharts.numberFormat(this.value, 0) + unitsSuffix; } };
        a.options.tooltip.pointFormat = '{series.name}: <b>' + unitsPrefix + '{point.y:,.2f}' + unitsSuffix + '</b><br/>';
        a.series = fullSeriesDefinition;
        return a;
    };

    self.createColumnChart = function( categories, fullSeriesDefinition, enableLegend, drilldownDataFullDefinition, yAxisFormatString, tooltipFormatString ) {
        var c = angular.copy( columnConfig );
        c.options.plotOptions.column.animation = true;
        c.options.xAxis.categories = categories;
        c.options.yAxis.labels.format =  yAxisFormatString;
        c.options.tooltip.pointFormat = tooltipFormatString;
        c.options.legend.enabled = enableLegend;
        c.series = fullSeriesDefinition;

        if( drilldownDataFullDefinition ) {
            c.options.drilldown = drilldownDataFullDefinition;
        }

        return c;
    };

    self.createStackedColumnChart = function( categories, fullSeriesDefinition ) {
        var s = angular.copy( stackedColumnConfig );
        s.options.xAxis.categories = categories;
        s.series = fullSeriesDefinition;
        return s;
    };

    self.createLineChart = function( categories, fullSeriesDefinition ) {
        var l = angular.copy( lineConfig );
        l.options.xAxis.categories = categories;
        l.series = fullSeriesDefinition;
        return l;
    };

    self.createScatterChart = function( fullSeriesDefinition, yTitle, xTitle ) {
        var s = angular.copy( scatterConfig );
        s.options.yAxis.title.text = yTitle;
        s.options.xAxis.title.text = xTitle;
        s.series = fullSeriesDefinition;
        return s;
    };

    self.createColumnWithDrilldownChart = function (parentSeries, childSeries) {
        var c = angular.copy( columnWithDrilldownConfig );
        c.series[0].data = parentSeries;
        c.options.drilldown.series = childSeries;
        return c;
    };

    self.createBarChart = function( categories, seriesData ) {
        var b = angular.copy( barConfig );
        b.options.xAxis.categories = categories;
        b.series[0].data = seriesData;
        return b;
    };

    self.createGaugeChart = function( seriesData ) {
        var g = angular.copy( gaugeConfig );
        //b.series[0].data = seriesData;
        return g;
    };

    self.createModelToleranceChart = function( toleranceData ) {
        var m = angular.copy( modelToleranceConfig );
        m.series[0].animation = true;
        m.series[1].animation = true;
        m.series[2].animation = true;
        m.series[3].animation = true;

        var points = {lower: [], upper: [], current: [], target: [], categories: []};

        toleranceData.forEach(function(asset) {
            var current = asset.actualPercent;
            points.categories.push(asset.groupName);
            points.lower.push(-asset.lowerTolerance);
            points.upper.push(asset.upperTolerance);
            points.current.push(asset.inTolerance ? current - asset.targetPercent : {y: current - asset.targetPercent, color: '#FF0000', borderColor: '#FF0000'});
            points.target.push(asset.targetPercent);

            asset.diffPercent = asset.actualPercent - asset.targetPercent;
            asset.diffValue = asset.actualValue - asset.targetValue;
            asset.diffShares = asset.actualShares - asset.targetShares;
        });

        modelToleranceConfig.height = (29 * toleranceData.length) + 69;
        m.options.xAxis.categories = points.categories;
        m.series[0].data = points.lower;
        m.series[1].data = points.upper;
        m.series[2].data = points.current;
        m.series[3].data = points.target;

        return m;
    };

    self.createTreemapChart = function( seriesData ) {
        var t = angular.copy( treemapConfig );
        t.series[0].data = seriesData;
        return t;
    };

    self.createColumnRange = function(  categories, fullSeriesDefinition  ) {
        var c = angular.copy( columnRangeConfig );
        c.xAxis.categories = categories;
        c.series = fullSeriesDefinition;
        return c;
    };

});
'use strict';

app.controller('CompositeAdhocCtrl', function CompositeAdhocCtrl($scope, $http, $oasRights, $dialog, views, $timeout, $location, compositeReportPrompterService){
    var adhocInstanceId;

    // PRIVATE FUNCTIONS
    function init(){
        $scope.rightsComposite = $oasRights.forCode("COMPOSITEACCOUNT");

        $http.get('/Reporting/Reports?menu=_compositedaily', {cache: true, trackerMsg: 'Loading composite reports'})
            .then(function (response) {
                var categories = ["_CompositeDailyNew"];
                //if($scope.user.authorization.entity === "Administrator") {
                categories.add("_CompositeDaily");
                //}

                $scope.current.reports = response.data.filter(r => categories.any(r.category));
            });
    }

    function refreshGrid(){
        $scope.$broadcast('event:composite-adhoc-action', {action: 'refresh-grid'});
    }
    
    $scope.newDailyComposites = function(){
        var dialogOpts = {
            templateUrl : "daily-composite-prompt.html",
            controller : "DailyCompositePromptCtrl"
        };

        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function(rslt){
                if (rslt){
                    $scope.$broadcast('event:composite-adhoc-action', {action: 'refresh-grid'});
                }
            });
    };
    
    $scope.deleteInstance = function(){
        var confirmMsg = 'You are about to delete daily composite instance(s). Are you sure you want to proceed?';
        
        $dialog.confirmAction(confirmMsg)
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.put('/Reporting/Composite/AdHocInstances/Action/Delete', $scope.selectedIds, {trackerMsg: 'Deleting daily composite instance(s)'})
                        .then(function () {
                            refreshGrid();
                        });
                }
            });
    };
    
    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
        {
            $timeout(function () {
                $location.url('/reports/composites/adhocaccounts?instanceId=' + $scope.selectedIds[0]);
            });
        }
    };

    $scope.runReport = function(report){
        const forceLegacy = report && report.reportName.includes('Retired');
        compositeReportPrompterService.runCompositeReport(adhocInstanceId, true, forceLegacy);
    };

    $scope.exportToExcel = function(){
        $scope.$broadcast('event:composite-adhoc-action', {action: 'export-data'});
    };

    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick
    };

    init();
    
    //EVENT LISTENERS
    $scope.$on("event:composite-adhoc-select", function(e, args){
        if (args.length === 0) { return; }

        adhocInstanceId = args[0].id;
    });
});

app.controller('DailyCompositePromptCtrl', function DailyCompositePromptCtrl($scope,dialog, $http){
    $scope.close = function(){
        dialog.close(null);
    };

    $scope.run = function(){
        $http.get("/Reporting/Composite/Wizard/CompositeDefinition", {trackerMsg: 'Loading composite definition'})
            .then(function(response){
               var compositeDefinition = response.data;

                compositeDefinition.start = $scope.current.startDate.formatted();
                compositeDefinition.end = $scope.current.endDate.formatted();
                compositeDefinition.nickName = $scope.current.name;

                $http.post("/Reporting/Composite/AdHocInstances/Action/Instance", compositeDefinition, {trackerMsg: 'Running calculation'})
                    .then(function(res) {
                        dialog.close(res.data);
                    });
            });
    };

    $scope.current = {
        startDate : Date.create('today'),
        endDate: Date.create('today'),
        name: ''
    };
});
'use strict';

var compositeAdhocAccountListCtrl = app.controller('CompositeAdhocAccountListCtrl', function CompositeAdhocAccountListCtrl( $scope, $http, $oasRights, views, $routeParams, compositeReportPrompterService) {
    // PRIVATE METHODS
    function initialLoad() {
        $scope.rights = $oasRights.forCode("COMPOSITEACCOUNT");

        $http.get('/Reporting/Composite/AdHocInstances/' + $scope.current.instanceId, {cache: true, trackerMsg: 'Loading composite accounts'})
            .then(function (response) {
                if (response.data.length > 0) {
                    $scope.current.name = response.data[0].nickName;
                }
            });
    }


    // PUBLIC METHODS
    $scope.exportToExcel = function() {
        $scope.$broadcast('event:composite-adhoc-accounts-action', {action: 'export-data'});
    };


    $scope.refreshGrid = function(){
        $scope.$broadcast('event:composite-adhoc-accounts-action', {action: 'refresh-grid'});
    };

    $scope.runReport = function(){
        compositeReportPrompterService.runCompositeReport(Number($scope.current.instanceId), true);
    };


    //EVENT LISTENERS
    $scope.$on("event:composite-adhoc-accounts-select", function(e, args){
        if (args.length === 0) { return; }
    });

    // INITIALIZE
    $scope.views = views;
    $scope.current = { 
        view: views[0],
        instanceId : $routeParams.instanceId,
        url: '/Reporting/Composite/AdHocAccounts'
    };
    $scope.selectedIds = [];
    initialLoad();


    //WATCHES
});


'use strict';

app.controller('CompositeDisclosureListCtrl', function CompositeDisclosureListCtrl($scope, $http, $oasRights, views, $dialog) {

    // PRIVATE VARIABLES
    var originalDisclosureList = null;
    var isProcessingDialog = false;

    // PRIVATE METHODS
    function init( ) {
        $scope.rightsCompositeText = $oasRights.forCode("COMPOSITEACCOUNT");
        loadDisclosureList();
    }

    function loadDisclosureList(){
        $http.get('/Reporting/Composite/Disclosures', {trackerMsg: 'Loading disclosure list'})
            .then(function(response){
                $scope.disclosureList = response.data.sortBy('disclosureOrder');
                originalDisclosureList = angular.copy($scope.disclosureList);
            });
    }

    function sortDisclosure(){
        $scope.disclosureList.forEach(function(disclosure, $index){
            disclosure.disclosureOrder = $index + 1;
        });

        if (!angular.equals(originalDisclosureList, $scope.disclosureList)){
            $scope.current.listHasChange = true;
        } else {
            $scope.current.listHasChange = false;
        }
    }

    function reorderDisclosure(indexOrder){
        var updateTarget = null;

        if (!indexOrder.isFirst && !indexOrder.isLast){
            if (indexOrder.nextItemIsLast){
                updateTarget = $scope.disclosureList.find({disclosureOrder: indexOrder.disclosureOrder + 1});
                if (updateTarget){
                    updateTarget.disclosureOrder -= 1;
                }
            } else if (indexOrder.lastItemIsFirst){
                var updatedItems = $scope.disclosureList.findAll(function(disclosure){
                    return disclosure.disclosureOrder > indexOrder.disclosureOrder;
                });

                updatedItems.forEach(function(discloure){
                   discloure.disclosureOrder -= 1;
                });
            }
            else {
                updateTarget = $scope.disclosureList.find({disclosureOrder: indexOrder.disclosureOrder - 1});
                if (updateTarget){
                    updateTarget.disclosureOrder += 1;
                }
            }
        } else {
            if (indexOrder.isFirst){
               $scope.disclosureList.forEach(function(disclosure){
                  disclosure.disclosureOrder -= 1;
               });
            }
        }

        $scope.saveDisclosures();
    }

    $scope.saveDisclosures = function(){
        $http.put('/Reporting/Composite/Disclosures/Reorder', $scope.disclosureList, {trackerMsg: 'Saving disclosure list'})
            .then(function(response){
                $scope.disclosureList = response.data.sortBy('disclosureOrder');
                originalDisclosureList = angular.copy($scope.disclosureList);
                $scope.current.listHasChange = false;
            });
    };

    $scope.openDisclosure = function(isNew, disclosure) {
        $http.get('/Reporting/Composite/Reports?expandGroups=false', {trackerMsg: 'Loading Composite Reports'})
            .then(function(response){

                if (!isProcessingDialog){
                    var dialogOpts = {
                        dialogClass: "modal wide",
                        templateUrl: "new-disclosure.html",
                        controller: 'NewDisclosureCtrl',
                        reports: response.data,
                        disclosure: null,
                        disclosureOrder: $scope.disclosureList.length > 0 ? $scope.disclosureList.at($scope.disclosureList.length - 1).disclosureOrder + 1 : 1
                    };

                    isProcessingDialog = true;
                    if (!isNew){
                        dialogOpts.disclosure = disclosure;
                    }

                    var d = $dialog.dialog(dialogOpts);
                    d.open()
                        .then(function(rslt){
                            if (rslt){
                                loadDisclosureList();
                            }
                            isProcessingDialog = false;
                        });
                }
        });
    };

    $scope.deleteDisclosure = function(id){
        $dialog.confirmAction("You are about to permanently delete this disclosure from your database would you like to proceed?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    var deleteItem  =  $scope.disclosureList.find({id: id});
                    var indexOrder = {
                        isFirst: deleteItem.disclosureOrder === 1,
                        isLast: deleteItem.disclosureOrder === $scope.disclosureList.length,
                        disclosureOrder: deleteItem.disclosureOrder,
                        nextItemIsLast: $scope.disclosureList.indexOf(deleteItem) + 1 === $scope.disclosureList.length - 1,
                        lastItemIsFirst: $scope.disclosureList.length > 1 ? $scope.disclosureList.indexOf(deleteItem)  - 1 === 0 : false
                    };

                    $scope.disclosureList.remove(deleteItem);
                    $http.delete('/Reporting/Composite/Disclosures/' + id, {trackerMsg: 'Deleting Disclosure'})
                        .then(function(){
                            reorderDisclosure(indexOrder);
                        });
                }
            });
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:composite-text-action', {action: 'export-data'});
    };

    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        data: [],
        url : '/Reporting/Composite/Disclosures',
        sortOptions : {
            axix: 'y',
            stop: sortDisclosure
        },
        listHasChange: false
    };

    init( );
});


app.controller('NewDisclosureCtrl', function NewDisclosureCtrl($scope, $http, dialog){
    var originalDisclosureList;

    function init(){
        if ($scope.current.disclosure){
            $scope.current.params = $scope.current.disclosure;

           $scope.current.disclosure.reports.forEach(function(rpt){
               var result = $scope.current.reports.find({id: rpt.compositeReportId});

               if (result) {result.isSelected = true;}

               $scope.maintainReportSelection({isSelected: true, id: rpt.compositeReportId});
           });
        }
    }

   $scope.close = function(){
       dialog.close(null);
   };

   $scope.saveDisclosure = function(){
        var args = $scope.current.params.id > 0 ?
            {method: "PUT", id: $scope.current.params.id, trackerMsg: "Saving disclosure", url: '/Reporting/Composite/Disclosures/Update/' + $scope.current.params.id} :
            {method: "POST", id: "", trackerMsg: "Add new disclosure", url: '/Reporting/Composite/Disclosures/Create'};

        $http({ method: args.method, url: args.url, data: $scope.current.params, trackerMsg: args.trackerMsg})
            .then(function(response){
                dialog.close(response.data);
            });
   };


   $scope.maintainReportSelection = function(rpt){
       if (rpt.isSelected){
           if ($scope.current.params.reports.none(function(report){ return report.compositeReportId === rpt.id})){
               $scope.current.params.reports.add({disclosureId: $scope.current.disclosureId, compositeReportId: rpt.id });
           }
       } else {
           if ($scope.current.params.reports.any(function(report){ return report.compositeReportId === rpt.id})){
               $scope.current.params.reports.remove({compositeReportId: rpt.id });
           }
       }
   };

    $scope.current = {
        params: {
            id: 0,
            disclosureName: '',
            disclosureText: '',
            disclosureOrder: dialog.options.disclosureOrder,
            reports : [
            ]
        },
        reports: dialog.options.reports,
        disclosure: angular.copy(dialog.options.disclosure)
    };


    $scope.current.reports.forEach(function(rpt){
        rpt.isSelected = false;
    });

    init();
});
'use strict';

app.controller('ReportEditorCtrl', function ($scope, $http, $location, $route, $routeParams, $dialog, $timeout, RB_TOOLBAR,
    reportHelper, fragmentHelper, imageHelper, $q, $oasRights, reportService, optionsHelper, reportFormattingHelper, promiseTracker, reportCleanHelper, reportCopyService, reportSaveService, privilegeService, ReportStyleService, ReportApiService, ReportAssistantChatHelper, $window, reportRunPrompterService, adHocSettingsService) {
    //PRIVATE VARIABLES
    fragmentHelper.setShowFragmentActions(true);
    $scope.globalSettings = [];
    $scope.adHocSettings = [];
    $scope.categories = [];
    let prevRunForEntities;
    const restoreMsgId = 'restore-msg';


    //PRIVATE METHODS
    function init() {
        reportHelper.setScope($scope);
        reportHelper.initScope($scope, true);

        $scope.optionsHelper = optionsHelper;

        $scope.isVersion = false;

        $http.get('/Settings/Database/EntityOptions/Code/69ENABLEPROSPECTREPORTING', { trackerMsg: 'Loading database settings' })
            .then(function (response) {
                $scope.enableProspectReporting = response.data.value === "True";
            });

        $scope.canAccessReport = privilegeService.canRead('reportBuilder3');
        $scope.canEditTemplates = privilegeService.canEdit('reportTemplates');
        $scope.canEditStandardTemplates = privilegeService.canEdit('standardReportTemplates');

        const isNew = $routeParams.id === '0';
        let reportCopy;

        ReportStyleService.styleChanged.subscribe((newStyle) => {
            $scope.updateReportStyle(newStyle);
        });

        $scope.chatSub = ReportAssistantChatHelper.chatEnabled$.subscribe(enabled => {
            $scope.aiChatEnabled = enabled;
            ReportAssistantChatHelper.clearChatContext();
            $scope.rightSidebar.width = 375;
        });

        reportService.loadReportCategories().then((data) => {
            $scope.categories = data;
        });

        const reportPromise = reportHelper.getReport(isNew, $routeParams.id, $routeParams.mode === 'copyFromTemplate' || $route.current.isTemplate)
            .then(function (report) {
                report = reportHelper.sanititizeResponse(report);
                if (['copy', 'copyFromTemplate'].any($routeParams.mode)) {
                    $scope.current.isCopyMode = true;
                    reportCopy = report;
                    return reportService.getNew();
                } else {
                    return $q.resolve(report);
                }
            }, function (error) {
                // Action was aborted
                if (error.status === -1) {
                    return;
                }

                // For a 404 we want to return to the report list
                if (error.status === 404) {
                    window.location.href = '#/reports/reportbuilder3';
                    window.location.reload();
                }

                // All other errors should show a message
                let message = error?.data?.userException?.detail || "An error has occurred.";
                $dialog.actionFailed(message).open();
            })
            .then(function (response) {
                let data = response.data ? response.data : response;
                if (reportCopy) {
                    data = reportCopyService.reportCopySetData(data, reportCopy);
                    let contextHasMissingGlobals = false;
                    optionsHelper.optionTypes.some(function (optionType) {
                        contextHasMissingGlobals = optionsHelper.contextHasMissingGlobals(
                            optionType,
                            data.schema.contextChange,
                            reportHelper.getOptions(optionType.optionType, true)
                        );

                        return contextHasMissingGlobals;
                    });

                    if (contextHasMissingGlobals) {
                        $dialog
                            .actionFailed(
                                'Unable to clone the report due to one or more report settings missing global unique identifiers. Please contact the Reporting Team to add missing GUIDs.'
                            )
                            .open();
                        $location.path('/reports/reportbuilder3')
                    }
                }

                $scope.isVersion = !!data.portfolio.versionOfReportId;  //if exists, then this is version

                if ($routeParams.mode === 'version') {
                    $scope.isVersion = true;
                    reportService.setRoleData($scope.user.authorization, data);
                }

                $scope.report = data;
                $scope.report.id = isNew ? null : data.id;
                $scope.report.isTemplate = $route.current.isTemplate;
                if (isNew && ReportAssistantChatHelper.pendingPdfBuild) {
                    $scope.report.portfolio.name = ReportAssistantChatHelper.pendingPdfBuild.reportName;
                    $scope.report.portfolio.category = ReportAssistantChatHelper.pendingPdfBuild.reportCategory;
                }
                bindSchemaEvents($scope.report.schema);

                if ($scope.report.isTemplate) {
                    if ($scope.current.isCopyMode && $scope.report.portfolio.isStandardTemplate && !$scope.canEditStandardTemplates) {
                        $scope.report.portfolio.isStandardTemplate = false;
                    }
                    $scope.current.wasStandardTemplateInitially = $scope.report.portfolio.isStandardTemplate;
                    $scope.current.alerts.push({ type: 'info', msg: 'You are now viewing a template' });
                    $scope.addBreadcrumb(`Template: ${data.portfolio.name}`, `#/reports/reportbuilder3/templates/${response.id}`);
                } else {
                    $scope.addBreadcrumb(isNew ? 'New Report' : `${$scope.isVersion ? 'v. ' : ''}${data.portfolio.name}`, `#/reports/reportbuilder3/${response.id}`);
                }

                if ($scope.report.portfolio.isDeleted && $scope.current.alerts.none({ id: restoreMsgId })) {
                    $scope.current.alerts.push({ type: 'error', msg: 'To restore this report, go to the Actions menu and select Restore Report.', id: restoreMsgId });
                } else {
                    $scope.current.alerts.remove({ id: restoreMsgId });
                }
            });

        const settingsPromise = reportService.getGlobalSettings().then(function (response) {
            $scope.globalSettings = response.data;
            adHocSettingsService.setGlobalSettings(response.data);
        });

        const adHocSettingsPromise = $q(function (resolve) {
            adHocSettingsService.getAdHocSettings().subscribe(
                function (settings) {
                    $scope.adHocSettings = Array.isArray(settings) ? settings : [];
                    optionsHelper.setAdHocSettings($scope.adHocSettings);
                    $scope.$root.$broadcast('rb-event:ad-hoc-settings-changed');
                    resolve($scope.adHocSettings);
                },
                function () {
                    $scope.adHocSettings = [];
                    optionsHelper.setAdHocSettings([]);
                    $scope.$root.$broadcast('rb-event:ad-hoc-settings-changed');
                    resolve([]);
                }
            );
        });

        $q.all([reportPromise, settingsPromise, adHocSettingsPromise]).then(() => {
            reportHelper.addFragmentReferencedOptions($scope.report);
            $scope.adHocSettings = optionsHelper.getAdHocSettingsCache();
            loadSettingsOptions();
            loadScopeFromOptions();
            reportHelper.refreshOptions();

            //$scope.updatePaperSizeStyle(true, 1);
            $scope.initializeLayout();
            $scope.loadTheme().then(function () {
                $scope.report.loaded = true;
                $scope.reportLoaded = true;
                reportHelper.refreshOptions();
            });
        });

        fragmentHelper.load()
            .then(function (fragments) {
                $scope.fragments = fragments;
                if ($scope.fragments.length > 0) {
                    $scope.fragments[0].isOpen = true;
                }
            });
    }

    function setRunForEntityOptions() {
        $scope.runForEntities = $scope.report.requiredOptions.find({ $type: 'select-entity' });
        prevRunForEntities = Object.assign({}, $scope.runForEntities);
        setSelectedRunForEntity();
    }

    function loadScopeFromOptions() {
        $scope.coverPage = reportFormattingHelper.getSelectedCoverPage($scope.globalSettings, $scope.report.options);
        $scope.paper = reportFormattingHelper.getSelectedPaper($scope.globalSettings, $scope.report.options);
        $scope.defaultFormats = reportFormattingHelper.getSelectedFormats($scope.globalSettings, $scope.report.options);
        $scope.themes = reportFormattingHelper.getSelectedTheme($scope.globalSettings, $scope.report.options);

        setRunForEntityOptions();
        $scope.current.hasVersion = $scope.isVersion || ($scope.report.versions && $scope.report.versions.length > 0);
    }

    function loadSettingsOptions() {
        $scope.fullOptions.forEach(function (m) {
            reportHelper.getDefault(m.optionType).then(function (d) {
                if (d) {
                    $scope.current.defaultOptions[m.propertyName] = d.optionId;

                    // Set the default on the report if it does not exist.
                    // The settings area should always match the contextChange.
                    if (!$scope.report.schema.contextChange.hasOwnProperty(m.propertyName)) {
                        optionsHelper.updateIdAndGuid(m.optionType, $scope.report.schema.contextChange, d.optionId, d.optionGuid);
                    }
                }
            });
        });
    }

    function flattenControls(control) {
        const results = [], children = [];
        if (control.controls && control.controls.length > 0) {
            control.controls.forEach(function (c) {
                results.add(c);
                results.forEach(function (r) {
                    children.add(flattenControls(r));
                });
            });
        }
        if (children && children.length > 0) {
            results.add(children);
        }
        return results;
    }

    //PUBLIC METHODS
    $scope.filterSectionCategoriesBySectionName = function (category) {
        if ($scope.current.sectionSearchText === "") {
            return true;
        }

        const search = $scope.current.sectionSearchText.toLowerCase(), sections = category.items;
        return sections.any(function (s) { return s.name.toLowerCase().search(search) !== -1; });
    };

    $scope.filterSectionsByName = function (section) {
        if ($scope.current.sectionSearchText === "") {
            return true;
        }

        return section.name.toLowerCase().search($scope.current.sectionSearchText.toLowerCase()) !== -1;
    };

    $scope.loadTheme = function () {
        const promises = {};
        promises.standard = $http.get('/Reporting/Envision/Themes/Standard/Css', { cache: true })
            .then(function (standardResponse) {
                $scope.style.standard = standardResponse.data;
            });

        if ($scope.themes.selection && $scope.themes.selection.id) {
            let themeKey = $scope.themes.selection.id;
            // empty guid means use database default
            if (themeKey === '00000000-0000-0000-0000-000000000000') {
                promises.defaultTheme = $http.get('/Reporting/Envision/Themes/Default', { trackerMsg: 'Loading default theme' })
                    .then(function (defaultThemeResponse) {
                        themeKey = defaultThemeResponse.data.id;
                        promises.theme = getTheme(themeKey);
                    });
            }

            if (!promises.defaultTheme) {
                promises.theme = getTheme(themeKey);
            }
        }
        return $q.all(promises);
    };

    $scope.getThemes = function () {
        if (!$scope.themes) {
            return;
        }

        let themes = [];
        // since we'll be removing database default from theme.options make a shallow copy to not remove it from $scope
        let themeOptions = [...$scope.themes.options];

        let databaseDefaultIndex = themeOptions.findIndex((t) => t.id === '00000000-0000-0000-0000-000000000000');

        // database default needs to be first element in dropdown
        themes.push(themeOptions[databaseDefaultIndex]);
        themeOptions.splice(databaseDefaultIndex, 1);

        // all other theme options should be sorted
        themeOptions.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));

        themes = themes.concat(themeOptions);
        return themes;
    };

    function getTheme(themeKey) {
        return $http.get('/Reporting/Envision/Themes/' + themeKey + '/Css', { trackerMsg: 'Loading theme', ignoreExceptions: true })
            .then(function (themeResponse) {
                $scope.style.theme = themeResponse.data;
            }, function (error) {
                if (error.status === 404) {
                    let errorMessage = "The report theme, <b>" + $scope.themes.selection.name + "</b>, could not be found. The theme may have been deleted.";
                    $http.get('/Reporting/Envision/Themes', { trackerMsg: 'Loading themes' })
                        .then(function (response) {
                            let theme = $scope.themes.options.exclude({ id: $scope.themes.selection.id })[0];
                            if (response.data && response.data.length > 0 && response.data.findIndex({ isDefault: true }) >= 0) {
                                theme = $scope.themes.options.find({ id: response.data.find({ isDefault: true }).id });
                            }

                            errorMessage += " The system will currently substitute the missing theme with <b>" + theme.name + "</b>.";
                            $scope.themes.selection = theme;
                        })
                        .finally(function () {
                            errorMessage += " Save the report to keep the change or save after making a new selection.";
                            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Missing Report Theme", errorMessage).open();
                            $scope.loadTheme();
                        });
                }
            });
    }

    $scope.deleteFragment = function (fragment) {
        fragmentHelper.delete(fragment)
            .then(function (result) {
                if (result) {
                    $scope.$broadcast('rb-event:remove-fragment', fragment.id);
                }
            });
    };

    $scope.addFragment = function (originalFragment, targetList, targetIndex) {
        //clone the fragment so that any changes that are made to it don't impact the stored fragment schemas in the sidebar.
        let fragment = angular.copy(originalFragment);

        if (targetList === 'body' && targetIndex === undefined) {
            return fragmentHelper.loadDetails(fragment.id)
                .then(function (fullFragment) {
                    fragment = angular.copy(fullFragment);
                    return reportHelper.prepareFragmentForAdd(fragment);
                })
                .then(function (fixedFragment) {
                    //just add it to the end of the report
                    $scope.report.schema.body.addControl(fixedFragment.schema);

                    syncGlobalSettingsForSubReport();
                    // By returning true from dnd-drop we signal we already handled the item.
                    return true;
                });
        }

        if (targetList.dragoverCallback(fragment.type.toLowerCase())) {
            return fragmentHelper.loadDetails(fragment.id)
                .then(function (fullFragment) {
                    fragment = angular.copy(fullFragment);
                    return reportHelper.prepareFragmentForAdd(fragment);
                })
                .then(function (fixedFragment) {
                    // Copy the item from source to target (wrapping if needed)
                    targetList.control.controls[targetIndex] = targetList.wrapControlIfNeeded(fixedFragment.schema);

                    //need to reflow the charts after adding
                    targetList.reflow();

                    //need to initialize column resizer
                    targetList.initColumnResizer();

                    syncGlobalSettingsForSubReport();
                    // By returning true from dnd-drop we signal we already handled the item.
                    return true;
                });
        }

        //cancel the drop event
        return false;
    };

    function syncGlobalSettingsForSubReport() {
        if ($scope.report.schema.contextChange.globalsSynced) {
            $timeout(() => {
                syncGlobalsSettingsToReport(true);
            });
        }
    }

    $scope.hoverControl = reportHelper.hoverControl;

    $scope.selectControl = function (event) {
        // Prevent users without advanced editor rights from selecting things.
        if (!$scope.hasAdvancedEditorRights) {
            return;
        }

        const control = reportHelper.selectControl(event);
        
        if (!$scope.aiChatEnabled) {
            if (!control) {
                $scope.current.sidebarTab.settings = true;
            } else if (!$scope.current.control || $scope.current.control.$index !== control.$index) {
                $scope.current.sidebarTab.parameters = true;
            }
        }

        if (control && !!control.isInSubReport) {
            control.disabled = true;
        }

        $scope.current.control = control;
    };

    $scope.chatAiSchemaChange = function (event) {
        $scope.report.schema = event
        if (!$scope.report.schema.controls || $scope.report.schema.controls.length <= 0) {
            $scope.emptyReport = true;
        } else {
            $scope.emptyReport = false;
        }
    }

    $scope.syncGlobalsSettingsToReport = function () {
        promiseTracker('main').addPromise($timeout(() => {
        }, 1000), { trackerMsg: 'Defaults Syncing' });

        $timeout(() => {
            syncGlobalsSettingsToReport();
        });
    };

    $scope.addMissingGlobalGuids = function () {

        const title = '<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Add Missing Guids';
        const msg = 'Do you want to add missing guids to this report based on the current database? If so make sure all changes have already been saved. If global settings were synced make sure to save before calling this.';
        const buttons = [{ result: false, label: 'Cancel' }, { result: true, label: 'Save', cssClass: 'btn-primary' }];

        $dialog.messageBox(title, msg, buttons).open().then((result) => {
            if (!result) {
                return;
            }

            optionsHelper.addMissingGuidsToReport($scope.report.id, $scope.user.authorization.alClientId).then(() => {
                window.location.reload();
            });
        });
    };

    function updateDefaultOptionsToContext() {
        Object.keys($scope.report.schema.contextChange).forEach(propertyKey => {
            $scope.current.defaultOptions[propertyKey] = $scope.report.schema.contextChange[propertyKey];
        });
    }

    function syncGlobalsSettingsToReport(previouslySynced) {

        $scope.selectControl({});
        const remappedOptions = optionsHelper.syncGlobalSettingsToReport($scope.report, $scope.globalSettings);
        $scope.report.schema.contextChange.globalsSynced = true;

        if (!previouslySynced) {
            updateDefaultOptionsToContext();
            openSyncCompleteMessage(remappedOptions.length);
        }

        if (remappedOptions.length > 0) {
            $timeout(reportHelper.refreshOptions(true));
            $timeout(() => $scope.$broadcast(reportHelper.RefreshResolvesEvent, remappedOptions));
        }
    }

    function openSyncMessage(postSaveAction) {
        const title = '<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Sync Defaults';
        const msg = 'Saving will sync default options, do you want to proceed?';
        const buttons = [{ result: false, label: 'Cancel' }, { result: true, label: 'Save', cssClass: 'btn-primary' }];

        $dialog.messageBox(title, msg, buttons).open().then((result) => {
            if (!result) {
                return;
            }

            syncGlobalsSettingsToReport($scope.report.schema.contextChange.globalsSynced);
            $scope.saveReport(postSaveAction);
        });
    }

    function openSyncCompleteMessage(remappedCount) {
        const title = '<i class="fa fa-check fa-lg text-success" aria-hidden="true"></i> Sync Complete';
        const msg = `Defaults Synced: ${remappedCount} Options Updated to Sync with Globals`;
        const buttons = [{ result: true, label: 'OK', cssClass: 'btn-primary' }];

        $dialog.messageBox(title, msg, buttons).open();
    }

    function updateBrokenSubReport(subReport, subReportsOnReport) {
        const matchedNested = subReportsOnReport.find(nc => nc.id === subReport.id);
        if (matchedNested) {
            const subReportIndex = matchedNested.parent.controls.findIndex(c => c.id === subReport.id);
            if (subReportIndex < 0) {
                return $q.when([]);
            }

            //this re-adds options that have been removed that are needed by a sub report
            return reportHelper.prepareFragmentForAdd(subReport);
        }

        return $q.when([]);
    }

    function cleanBrokenSubReports(brokenSubReportIds, subReportsAndParents) {
        if (!$scope.fragments) {
            return $q.when([]);
        }

        const subReportsToReplace = $scope.fragments.flatMap(groups => groups.items).filter(i => brokenSubReportIds.includes(i.id));

        const fixPromises = [];
        subReportsToReplace.forEach(sub => fixPromises.push(updateBrokenSubReport(sub, subReportsAndParents)));

        return $q.when(fixPromises);
    }

    function cleanReport(postSaveAction) {
        promiseTracker('main').addPromise($timeout(() => { }, 1000), { trackerMsg: 'Cleaning Report' });

        const cleanResults = reportCleanHelper.cleanReport($scope.report, reportHelper.getFullOptions());
        if (cleanResults && cleanResults.brokenSubReportIds.length > 0) {
            $timeout(() => {
                cleanBrokenSubReports(cleanResults.brokenSubReportIds, cleanResults.subReportsAndParents).then(() => {
                    $scope.saveReport(postSaveAction, true);
                });
            });
            return;
        }

        $scope.saveReport(postSaveAction, true);
    }

    function setSelectedRunForEntity() {
        //reset the selection to whatever the first available is
        $scope.runForEntities.selected = $scope.availableReportEntities
            .filter(entity => entity !== "Prospect")
            .find(entity => !$scope.runForEntities.options.includes(entity));


        if ($scope.runForEntities && $scope.runForEntities.entity === 'Prospect') {
            reportHelper.resetTagsAfterRunForChange();
            $scope.reportType = 'ProspectBased';
        }
        else if ($scope.runForEntities && $scope.runForEntities.entity !== 'Prospect') {
            reportHelper.resetTagsAfterRunForChange();
            $scope.reportType = 'AssetBased';
        }
    }

    $scope.filterAvailableReportEntities = function (reportEntity) {
        return !($scope.runForEntities?.options.includes(reportEntity) ||
            $scope.runForEntities?.options.includes("Prospect") ||
            (!$scope.enableProspectReporting && reportEntity === "Prospect") ||
            ($scope.runForEntities?.options.length > 0 && reportEntity === "Prospect"));
    };

    $scope.disableRunForEntitiesSelect = function () {
        return $scope.runForEntities?.options.includes("Prospect") ||
            $scope.availableReportEntities.filter(entity => entity !== "Prospect").every(entity => $scope.runForEntities?.options.includes(entity));
    };

    function openInvalidTagWarning(postSaveAction) {
        const msg = 'Changing the Run For to prospect could potentially result in invalid data tags. Do you want to continue?';

        $dialog.confirmAction(msg).open().then((result) => {
            if (!result) {
                return;
            }
            prevRunForEntities = null;
            $scope.saveReport(postSaveAction, true, true);
        });
    }

    function showInvalidTagOrGroupingForAllowedEntityTypesWarning(postSaveAction) {
        const msg = 'This report contains data tags or groupings that are not valid for the Run For Entity. These will be removed upon generation. Do you want to continue?';

        $dialog.confirmAction(msg).open().then((result) => {
            if (result === "no") {
                return;
            }

            $scope.saveReport(postSaveAction, true, true);
        });
    }

    // OC-15177: Mitigate option guid not being related to option id in context change
    function fixPossibleGuidAndIdMismatch() {
        // Perform the guid/id check across all option types (fullOptions is all option types)
        $scope.fullOptions.forEach(optionData => {
            // Only need to check if the option type has a global property in the context change object
            if (optionData.globalPropertyName != null) {
                const contextOption = $scope.report.schema.contextChange[optionData.globalPropertyName];
                if (contextOption) { // Local option will not have a guid in context change
                    const guid = contextOption.globalOptionGuid; // Get the guid for the current selected option type
                    let option = $scope.globalSettings.find({ optionType: optionData.optionType, guid: guid }); // Look up option in the list of global options

                    // We only need to do a check of the id if there is an option found in the list of global options
                    if (option) {
                        const id = option.id + 1000; // Make the id global from the selected option

                        // If the id does not match between the selected option and the context change, then update is needed
                        if ($scope.report.schema.contextChange[optionData.propertyName] !== id) {
                            $scope.report.schema.contextChange[optionData.propertyName] = id;

                            // If the id needs to be updated, then the required option likely needs to be updated as well
                            reportHelper.getOptions(option.optionType, true).forEach(o => {
                                const isRequired = (o.optionId === id && o.guid === guid);
                                delete option.prompt;
                                option.isRequired = isRequired;
                                if (option.$type === 'daterange' && isRequired) {
                                    option.prompt = 'Always';
                                }
                            });
                        }
                    }
                    else {
                        // Read-only globals (2000-2999) and ad hoc bundles (3000+)
                        option = reportHelper.getOptions(optionData.optionType, true).find(function (o) {
                            return o.optionGuid == guid && (o.isAdHoc || (o.optionId >= 3000));
                        });

                        if (!option) {
                            option = reportHelper.getOptions(optionData.optionType, true).find(function (o) {
                                return o.optionGuid == guid && o.optionId >= 2000 && o.optionId < 3000;
                            });
                        }

                        if (option) {
                            if ($scope.report.schema.contextChange[optionData.propertyName] !== option.optionId) {
                                $scope.report.schema.contextChange[optionData.propertyName] = option.optionId;
                            }
                        }
                    }
                }
            }
        });
    }

    $scope.getSelectedOptions = function (optionType) {
        const option = getOptionFromContext(optionType);

        if (option) {
            return option.optionGuid ?? option.optionId;
        }

        const contextSelection = optionsHelper.getOptionIdOrGuidFromObject(
            optionType,
            $scope.report.schema.contextChange
        );
        if (contextSelection != null && contextSelection !== '') {
            return contextSelection;
        }

        return optionsHelper.getOptionIdOrGuidFromObject(optionType, $scope.current.defaultOptions);
    }

    $scope.saveReport = function (postSaveAction, skipCleanCheck, overrideValidation) {
        let areAllLimitsValuesValid = validateLimitValues($scope.report.schema.body.controls); // function to check if all the limit values are valid

        if (!areAllLimitsValuesValid) {
            // if Limit values are not valid raise error in dialog else continue with normal flow
            const title = `<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Error`;
            const msg = `The Limit field is required when Limit Method is set to Count.`;
            const buttons = [{ result: true, label: 'OK', cssClass: 'btn-primary' }];
            $dialog.messageBox(title, msg, buttons).open();
            return;
        }

        if (!skipCleanCheck) {
            cleanReport(postSaveAction);
            return;
        }

        if (optionsHelper.usesGlobalsWithoutSync($scope.report)) {
            openSyncMessage(postSaveAction);
            return;
        }

        if (!overrideValidation && (!reportHelper.validateTags($scope.report.schema) || !reportHelper.validateGroupings($scope.report.schema))) {
            showInvalidTagOrGroupingForAllowedEntityTypesWarning(postSaveAction);
            return;
        }

        if (prevRunForEntities && prevRunForEntities.entity !== 'Prospect' && $scope.runForEntities.entity === 'Prospect') {
            openInvalidTagWarning(postSaveAction);
            return;
        }

        fixPossibleGuidAndIdMismatch();

        const remappedOptionsOut = {};
        reportSaveService.save($scope.report, $scope.globalSettings, remappedOptionsOut, {
            coverPageSelection: $scope.coverPage,
            paperSelection: $scope.paper,
            themesSelection: $scope.themes,
            defaultFormats: $scope.defaultFormats
        }).then(savedReport => {
            const crumb = $route.current.isTemplate ? { name: `Template: ${savedReport.portfolio.name}`, path: `/reports/reportbuilder3/templates/${savedReport.id}` } : { name: `${$scope.isVersion ? 'v. ' : ''}${savedReport.portfolio.name}`, path: `/reports/reportbuilder3/${savedReport.id}` };
            prevRunForEntities = Object.assign({}, $scope.runForEntities);
            if ($scope.report.id) {
                $scope.updateBreadcrumb(crumb.name);  //in case it changed

                if (angular.isFunction(postSaveAction)) {
                    postSaveAction();
                } else if (postSaveAction === 'close') {
                    $location.path('/reports/reportbuilder3');
                } else if (postSaveAction === 'run') {
                    $scope.runReport();
                }
            } else {
                $scope.deleteBreadcrumb();
                $scope.addBreadcrumb(crumb.name, crumb.path);

                if (postSaveAction === 'close') {
                    $location.path('/reports/reportbuilder3');
                } else if ($scope.report.id !== savedReport.id && !$route.current.isTemplate) {
                    $location.search('');
                    $location.path(`/reports/reportbuilder3/${savedReport.id}`);
                    if (postSaveAction === 'run') {
                        $scope.runReport(savedReport.id);
                    }
                } else {
                    reportHelper.getReport(false, savedReport.id, $route.current.isTemplate)
                        .then(function (report) {
                            $scope.report = report;

                            if ($route.current.isTemplate) {
                                $scope.report.isTemplate = true;
                                $scope.current.wasStandardTemplateInitially = $scope.report.portfolio.isStandardTemplate;
                            }

                            loadScopeFromOptions();

                            if (postSaveAction === 'run') {
                                $scope.runReport();
                            }
                        });
                }
            }

            if (remappedOptionsOut.remapped && remappedOptionsOut.remapped.length > 0) {
                // if there are remapped options we need to update report defaults, and option lists
                updateDefaultOptionsToContext();
                $timeout(reportHelper.refreshOptions);
                $timeout(() => $scope.$broadcast(reportHelper.RefreshResolvesEvent, remappedOptionsOut.remapped));
            }
        });
    };

    $scope.deleteReport = function () {
        if ($scope.report.isTemplate) {
            $dialog.confirmAction(`Are you sure you want to delete <b>${$scope.report.portfolio.name}</b>?`).open()
                .then(result => {
                    if (result !== 'yes') {
                        return;
                    }

                    $http.delete(`/Reporting/ReportTemplates/Verbose/${$scope.report.id}`, { trackerMsg: 'Deleting template' })
                        .then(() => {
                            $location.path('/reports/reportbuilder3').replace();
                        });
                });

            return;
        }

        ReportApiService.deleteReportWithPackageCheck($scope.report)
            .then(function (result) {
                if (result) {
                    $scope.deleteBreadcrumb();
                    $location.path('/reports/reportbuilder3').replace();
                }
            });
    };

    $scope.restoreReport = function () {
        $dialog.confirmAction(`Are you sure you want to restore <b>${$scope.report.portfolio.name}</b>?`).open()
            .then(function (result) {
                if (result !== 'yes') {
                    return;
                }

                $http.put(`/Reporting/Envision/Reports/Verbose/Action/RestoreReport/${$scope.report.id}`, $scope.report, { trackerMsg: `Restoring report` })
                    .then(response => {
                        $scope.report.portfolio.isDeleted = response.data.portfolio.isDeleted;

                        $scope.current.alerts.remove({ id: restoreMsgId });
                    });
            });
    };

    $scope.runReport = function (reportId) {
        var currentReportId = reportId ?? $scope.report.id;
        reportRunPrompterService.runReportById(currentReportId, { runAssignedVersion: false });
    };

    $scope.editReportAccess = function () {
        const args = function () {
            return {
                defaultTab: { code: $scope.user.authorization.entity === "Representative" ? "reportRepresentativeClientAccess" : "reportDatabaseAccess" },
                name: $scope.report.name,
                canAccessRules: $scope.report.isTemplate ? true : undefined,
                accessLevels: {
                    login: angular.copy($scope.report.loginAccessRules),
                    databaseGroup: angular.copy($scope.report.databaseGroupAccessRules),
                    database: angular.copy($scope.report.databaseAccessRules),
                    role: angular.copy($scope.report.roleAccessRules),
                    user: angular.copy($scope.report.userAccessRules),
                    representative: angular.copy($scope.report.representativeAccessRules),
                    representativesClients: angular.copy($scope.report.representativesClientsAccessRules),
                    client: angular.copy($scope.report.clientAccessRules),
                    brokerDealersRepresentatives: angular.copy($scope.report.brokerDealersRepresentativesAccessRules),
                }
            };
        };

        $dialog.editor("reporting/editors/views/report-access-edit.html", "ReportAccessEditCtrl", { args: args })
            .open()
            .then(function (result) {
                if (result && result.isSaved) {
                    $scope.report.loginAccessRules = angular.copy(result.accessLevels.login);
                    $scope.report.databaseGroupAccessRules = angular.copy(result.accessLevels.databaseGroup);
                    $scope.report.databaseAccessRules = angular.copy(result.accessLevels.database);
                    $scope.report.roleAccessRules = angular.copy(result.accessLevels.role);
                    $scope.report.userAccessRules = angular.copy(result.accessLevels.user);
                    $scope.report.representativeAccessRules = angular.copy(result.accessLevels.representative);
                    $scope.report.representativesClientsAccessRules = angular.copy(result.accessLevels.representativesClients);
                    $scope.report.clientAccessRules = angular.copy(result.accessLevels.client);
                    $scope.report.brokerDealersRepresentativesAccessRules = angular.copy(result.accessLevels.brokerDealersRepresentatives);
                }
            });
    };

    $scope.editReportVersionAssignment = function () {
        const args = function () {
            return {
                defaultTab: { code: 'reportRepresentativeVersionAssignment' },
                name: $scope.report.name,
                reportId: $scope.report.portfolio.versionOfReportId ? $scope.report.portfolio.versionOfReportId : $scope.report.id,
                versionAssignments: {
                    representative: angular.copy($scope.report.representativeVersionAssignments),
                    brokerDealer: angular.copy($scope.report.brokerDealerVersionAssignments),
                    client: angular.copy($scope.report.clientVersionAssignments),
                    portfolioGroup: angular.copy($scope.report.portfolioGroupVersionAssignments)
                }
            };
        };

        $dialog.editor("reporting/editors/views/report-version-assignment-edit.html", "ReportVersionAssignmentEditCtrl", { args: args })
            .open()
            .then(function (result) {
                if (result && result.isSaved) {
                    $scope.report.representativeVersionAssignments = angular.copy(result.versionAssignments.representative);
                    $scope.report.brokerDealerVersionAssignments = angular.copy(result.versionAssignments.brokerDealer);
                    $scope.report.clientVersionAssignments = angular.copy(result.versionAssignments.client);
                    $scope.report.portfolioGroupVersionAssignments = angular.copy(result.versionAssignments.portfolioGroup);
                }
            });
    };

    $scope.coverPageOptions = function () {
        if (!($scope.coverPage && $scope.paper)) {
            return [];
        }

        let coverPages = [];
        let filteredCoverPages = [...$scope.coverPage.options.filter(function (cpo) {
            // only display cover pages that match the page orientation & page size
            // no cover page will not have paperSize nor orientation, but we still want to display it
            return (cpo.orientation === $scope.paper.orientation && cpo.paperSize === $scope.paper.selection) || (!cpo.paperSize && !cpo.orientation);
        })];

        const defaultIndex = filteredCoverPages.findIndex(x => x.id === '00000000-0000-0000-0000-000000000000');
        const selectedCoverPage = $scope.coverPage.selection;
        const selectionIndex = !selectedCoverPage ? defaultIndex : filteredCoverPages.findIndex(x => x.id === selectedCoverPage.id && x.name === selectedCoverPage.name);

        const noCoverPageIndex = filteredCoverPages.findIndex(x => x.id === null);

        if (selectionIndex < 0) {
            $scope.coverPage.selection = filteredCoverPages[noCoverPageIndex];
        } else if (!selectedCoverPage) {
            $scope.coverPage.selection = filteredCoverPages[selectionIndex];
        }

        coverPages.push(filteredCoverPages[noCoverPageIndex]);

        if (defaultIndex >= 0) {
            coverPages.push(filteredCoverPages[defaultIndex]);
            filteredCoverPages.splice(defaultIndex, 1);
        }

        filteredCoverPages.splice(noCoverPageIndex, 1);

        filteredCoverPages.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));

        return coverPages.concat(filteredCoverPages);
    };

    $scope.updateOption = function (option, optionId, guid) {
        optionsHelper.updateIdAndGuid(option.optionType, $scope.report.schema.contextChange, optionId, guid);
        $scope.current.defaultOptions[option.propertyName] = optionId;
    };

    $scope.updateReportStyle = function (styles) {
        if (!styles) {
            return;
        }

        $scope.reportStyle.width = styles.width;
        $scope.reportStyle['min-height'] = styles['min-height'];
        $scope.reportStyle['padding-top'] = styles['padding-top'];
        $scope.reportStyle['padding-right'] = styles['padding-right'];
        $scope.reportStyle['padding-bottom'] = styles['padding-bottom'];
        $scope.reportStyle['padding-left'] = styles['padding-left'];
        $scope.reportStyle.transform = styles.transform;

        if (styles.header && styles.header['margin-top']) {
            $scope.headerStyle['margin-top'] = styles.header['margin-top'];
            $scope.headerStyle.height = styles.header.height;
        }

        if (styles.footer && styles.footer['margin-bottom']) {
            $scope.footerStyle['margin-bottom'] = styles.footer['margin-bottom'];
            $scope.footerStyle.height = styles.footer.height;
        }

        $scope.reportCenterStyle.width = 'calc(' + styles.width + ' * ' + (styles.scale || 1) + ')';
        $scope.reportCenterStyle['min-height'] = 'calc(' + styles['min-height'] + ' * ' + (styles.scale || 1) + ')';

        reportHelper.setReportStyle($scope.reportStyle);
        $scope.sendReflow();
    };

    $scope.sendReflow = function () {
        $timeout(function () {
            $scope.$broadcast('highchartsng.reflow');
            $window.dispatchEvent(new Event("resize"));
        }, 500);
    };

    $scope.initializeLayout = function () {
        ReportStyleService.updateLayout($scope.paper);
    };

    $scope.updateZoomLevel = function (scale) {
        $scope.paper.scale = scale;
        ReportStyleService.updateLayout($scope.paper);
    };

    $scope.getDefaultFormatsDisplayByKey = function (id) {
        switch (id) {
            case 'default-percent-format':
                return 'Percent';
            case 'default-decimal-format':
                return 'Decimal';
            case 'default-dollar-format':
                return 'Dollar';
            case 'default-numeric-format':
                return 'Numeric';
            default:
                return id.capitalize();
        }
    };

    $scope.setDefaultRunForEntity = function (indexOrEntity) {
        const currentIndex = isNaN(indexOrEntity) ? $scope.runForEntities.options.indexOf(indexOrEntity) : indexOrEntity;

        if (currentIndex !== -1) {
            $scope.runForEntities.entity = $scope.runForEntities.options[currentIndex];
        }
    };

    $scope.addRunForEntity = function () {
        $scope.runForEntities.options.add($scope.runForEntities.selected);

        if ($scope.runForEntities.options.length === 1) {
            //update default selection to whatever is first in the list
            $scope.setDefaultRunForEntity(0);
        }

        setSelectedRunForEntity();
    };

    $scope.removeRunForEntity = function (entity) {
        $scope.runForEntities.options.remove(entity);

        if ($scope.runForEntities.entity === entity) {
            //update default selection to whatever is first in the list
            $scope.setDefaultRunForEntity(0);
        }

        setSelectedRunForEntity();
    };

    $scope.moveRunForEntity = function (index, item) {
        const currentIndex = $scope.runForEntities.options.indexOf(item);
        if (currentIndex !== -1 && currentIndex !== index) {
            //first remove it from it's current location
            $scope.runForEntities.options.splice(currentIndex, 1);

            //we just deleted an item before this one so it has moved one index less
            if (currentIndex < index) {
                index--;
            }

            //then insert it into the new location
            $scope.runForEntities.options.splice(index, 0, item);
        }
        return false;
    };

    $scope.viewResolveOptionLibrary = function () {
        $dialog.dialog({ templateUrl: 'reporting/envision/modals/resolve-option-library.html', controller: 'ResolveOptionLibraryCtrl', dialogClass: 'modal wide' }).open();
    };

    function loadReportFromHistory(historyId) {
        $scope.report.loaded = false;
        $scope.reportLoaded = false;

        $http.get(`/Reporting/Envision/Reports/${$scope.report.id}/History/${historyId}`, { trackerMsg: 'Loading History Report' }).then(resp => {
            $scope.report = reportHelper.setupReportFromRestore(resp.data);
            $scope.report.loaded = true;
            $scope.reportLoaded = true;

            loadSettingsOptions();
            loadScopeFromOptions();
            reportHelper.refreshOptions();
        });
    }

    $scope.viewReportHistory = function () {
        $dialog.dialog({
            templateUrl: 'reporting/envision/modals/report-history.html',
            controller: 'ReportHistoryCtrl',
            dialogClass: 'modal wide',
            args: { reportId: $scope.report.id }
        }).open().then(response => {
            if (response) {
                loadReportFromHistory(response);
            }
        });
    };

    $scope.saveAsNewTemplate = function () {
        $scope.report.id = null;
        $scope.report.portfolio.isStandardTemplate = false;

        //clear all the access rules, so the defaults get applied
        Object.keys($scope.report).forEach(key => {
            if (key.endsWith('AccessRules')) {
                $scope.report[key] = [];
            }
        });

        $http.post('/Reporting/ReportTemplates/Verbose', $scope.report, { trackerMsg: 'Saving Report Template' })
            .then(resp => {
                $scope.report.id = resp.data.id;

                $dialog.saveSuccessful("The report template has saved successfully.").open()
                    .then(() => {
                        $location.url(`/reports/reportbuilder3/templates/${resp.data.id}`);
                    });
            });
    };

    function promptToSaveChanges(callbackFn) {
        const title = `<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Save ${$scope.current.documentType} Changes`;
        const msg = `Would you like to save your changes before continuing to the ${$scope.report.isTemplate ? 'report' : 'template'} editor? Unsaved changes will be lost.`;
        const buttons = [{ result: 0, label: 'Cancel' }, { result: 1, label: 'Continue Without Saving' }, { result: 2, label: `Save ${$scope.current.documentType}`, cssClass: 'btn-primary' }];

        $dialog.messageBox(title, msg, buttons).open().then(result => {
            if (result === 2) {
                $scope.saveReport(callbackFn);
            } else if (result === 1) {
                callbackFn();
            }
        });
    }

    $scope.saveReportAsTemplate = function () {
        const saveTemplate = function () {
            $dialog.dialog({ templateUrl: 'reporting/envision/modals/report-template.html', controller: 'ReportTemplateCtrl', dialogClass: 'modal small' }).open()
                .then(result => {
                    if (!result) {
                        return;
                    }

                    $scope.report.portfolio.name = result.name;
                    $scope.report.portfolio.category = result.category;

                    $scope.saveAsNewTemplate();
                });
        };

        promptToSaveChanges(saveTemplate);
    };

    $scope.createReportFromTemplate = function () {
        const createReport = function () {
            $location.url(`/reports/reportbuilder3/${$scope.report.id}?mode=copyFromTemplate`);
        };

        promptToSaveChanges(createReport);
    };

    //INITIALIZE
    $scope.enableProspectReporting = false;
    $scope.current = {
        isCopyMode: false,
        control: null,
        sectionSearchText: "",
        sidebarTab: { aiChat: true, settings: true, parameters: false, sections: false },
        defaultOptions: {},
        alerts: [],
        documentType: $route.current.isTemplate ? 'Template' : 'Report'
    };

    $scope.availableReportEntities = Object.keys(reportHelper.allowedEntityTypesMap).sort();

    $scope.hasAdvancedEditorRights = $oasRights.canRead("REPORTBUILDERADVANCEDEDITOR");

    $scope.canEditReportSettings = $oasRights.canUpdate("REPORTSETTINGS");
    $scope.canReadReportSettings = $oasRights.canRead("REPORTSETTINGS");

    $scope.canRestore = $oasRights.canRead("RESTOREREPORTS");
    $scope.header = {
        hasAdvancedEditorRights: $oasRights.canRead("REPORTBUILDERADVANCEDEDITOR"),
        user: $scope.user
    };

    init();

    //EVENT LISTENERS
    $timeout(function () {
        let viewport = reportHelper.getViewport();
        viewport.addEventListener("scroll", function () {
            $scope.$broadcast('rb-event:render-visible', viewport.getBoundingClientRect());
        });
    }, 10);

    $scope.$on('$destroy', function () {
        reportHelper.setReport(null);
        $scope.chatSub.unsubscribe();
    });

    $scope.$on('rb-event:select-control', function (event, data) {
        $scope.selectControl(data.control, data.event);
    });

    $scope.$on('rb-event:update-current-control', function (event, updatedControl) {
        if (updatedControl) {
            $scope.current.control = updatedControl;
        }
    });

    $scope.$on('rb-event:remove-controls', function (event, removedControls) {
        const childControls = [];
        removedControls.forEach(function (c) {
            childControls.add(flattenControls(c));
        });
        if (childControls && childControls.length > 0) {
            removedControls.add(childControls);
        }
        if (removedControls.some($scope.current.control)) {
            $scope.current.control = null;
        }

        ReportAssistantChatHelper.clearChatContext(removedControls);

        $timeout(function () {
            let viewport = reportHelper.getViewport();
            $scope.$broadcast('rb-event:render-visible', viewport.getBoundingClientRect());
        }, 10);
    });

    $scope.$on("rb-event:get-default-option", function (event, data) {
        //this is the report level. The buck stops here
        event.stopPropagation();
        //just get the default from the helper
        reportHelper.getDefault(data.type, data.path)
            .then(function (d) {
                data.setDefault(d, this);
            });
    });

    $scope.addReportCategory = function () {
        const args = function () {
            return {
                isNew: true,
                categorySelected: '',
            };
        };
        $dialog.editor('reporting/modals/ReportCategory.html', 'ReportCategoryCtrl', { args: args }, 'rbcategory')
            .open()
            .then(function (result) {
                if (!result) return;
                addCategoryIfNotExists(result, args.isNew);
                $scope.report.portfolio.category = result;
            });
    };
    $scope.editReportCategory = function () {
        const args = function () {
            return {
                isNew: false,
                categorySelected: $scope.report.portfolio.category,
            };
        };
        $dialog.editor('reporting/modals/ReportCategory.html', 'ReportCategoryCtrl', { args: args }, 'rbcategory')
            .open()
            .then(function (result) {
                if (!result) return;
                addCategoryIfNotExists(result, args.isNew);
                $scope.report.portfolio.category = result;
            });
    };

    function addCategoryIfNotExists(category, isNew) {
        if ($scope.categories.none(category) && !isNew) {
            $scope.categories.insert(category, 0);
        } else if ($scope.categories.none(category) && isNew) {
            $scope.categories.push(category);
        }
    }

    function validateLimitValues(reportSchemaBodyControls) {
        let countValuesArray = [];

        function fetchLimitValues(reportSchemaBodyControls) {
            // Recursive Helper Function to Extract Counts from nested objects
            // base case if object is null/undefined or not an object return immediately
            if (!reportSchemaBodyControls || typeof reportSchemaBodyControls !== 'object') {
                return; // to prevent errors when trying to access properties of null or non object values.
            }

            for (let key in reportSchemaBodyControls) {
                if (key === 'limitMethod' && typeof reportSchemaBodyControls[key] === 'object' && reportSchemaBodyControls[key]) {
                    if (reportSchemaBodyControls[key].limitMethod === 'Count') {
                        //only add values if limitMethod is Count
                        countValuesArray.push(reportSchemaBodyControls[key].count); // Add counts to array even if null
                    }
                } else if (typeof reportSchemaBodyControls[key] === 'object') {
                    fetchLimitValues(reportSchemaBodyControls[key]); //Recursively search deeper
                }
            }
        }

        angular.forEach(reportSchemaBodyControls, function (item) {
            fetchLimitValues(item);
        });

        if (countValuesArray.length === 0) {
            // to return true if no limitMethod of count is present
            return true;
        }

        // check if all limit values are valid (excluding null,blank zero and undefined ones return true if all are valid else false)
        let allValidLimits = countValuesArray.every((value) => value !== null && !isNaN(value));

        return allValidLimits > 0; // return true if all Limit values are valid else false
    }

    function getOptionFromContext(optionType) {
        const optionData = $scope.fullOptions.find(fo => fo.optionType === optionType);
        if (!optionData || optionData.globalPropertyName == null) {
            return;
        }

        const contextOption = $scope.report.schema.contextChange[optionData.globalPropertyName];
        if (!contextOption) {
            return;
        }

        const adhocGuid = contextOption.adhocOptionGuid || contextOption.AdhocOptionGuid;
        if (contextOption.$type === 'adhoc-guid' && adhocGuid) {
            return reportHelper.getOptions(optionData.optionType, true).find(function (o) {
                return o.isAdHoc && (o.optionGuid == adhocGuid || o.guid == adhocGuid);
            });
        }

        if (contextOption.globalOptionGuid == null) {
            return;
        }

        const guid = contextOption.globalOptionGuid;
        return reportHelper.getOptions(optionData.optionType, true).find(o => o.optionGuid == guid);
    }

    function bindSchemaEvents(schema) {
        if (!schema) {
            return;
        }

        const defineFn = (name, fn) => {
            if (typeof schema[name] === 'function') {
                return;
            }

            try {
                Object.defineProperty(schema, name, {
                    value: fn,
                    enumerable: false,
                    configurable: true,
                    writable: true
                });
            } catch (error) {
                schema[name] = fn;
            }
        }

        defineFn('$emit', function (event, data) { return $scope.$emit(event, data); });
        defineFn('$on', function (event, handler) { return $scope.$on(event, handler); });
        defineFn('$broadcast', function (event, data) { return $scope.$broadcast(event, data); });
    }
});

'use strict';

app.controller('SubReportEditorCtrl', function ($scope, reportHelper, fragmentHelper, $routeParams, $q, $oasRights, reportService, $timeout, $dialog, $location, optionsHelper, promiseTracker, ReportStyleService, ReportAssistantChatHelper, $window, adHocSettingsService, $exceptionHandler) {
    const subReportsPath = '/reports/reportbuilder3/subreports/';
    fragmentHelper.setShowFragmentActions(false);

    $scope.header = {
        hasAdvancedEditorRights: true,
        user: $scope.user,
    };
    $scope.categories = [];
    $scope.paper = {
        selection: 'Letter',
        orientation: 'Portrait',
        scale: 1,
        margins: {
            top: 0.5,
            right: 0.5,
            bottom: 0.5,
            left: 0.5,
            units: 'in'
        }
    };

    $scope.disableSave = false;
    $scope.aiChatEnabled = false;
    let missingSettingsAlert;

    // wraps the schema fragment if new fragment or existing
    function wrapFirstItem(item, isNew = false) {
        return {
            $type: isNew ? 'rcWrapper' : 'rcList',
            controls: [angular.copy(item)],
        };
    }

    function init() {
        $scope.header.loaded = true;
        $scope.emptyReport = false;
        $scope.adHocSettings = [];
        reportHelper.setScope($scope);
        reportHelper.initScope($scope);

        ReportStyleService.styleChanged.subscribe((newStyle) => {
            $scope.updateReportStyle(newStyle);
        });

        $scope.chatSub = ReportAssistantChatHelper.chatEnabled$.subscribe(enabled => {
            $scope.aiChatEnabled = enabled;
            ReportAssistantChatHelper.clearChatContext();
            $scope.rightSidebar.width = 375;
        });


        const isNew = $routeParams.id === '0';
        let reportCopy;
        const handledLoadErrors = new Set();

        const subReportPromise = reportHelper.getSubReport(isNew, $routeParams.id)
            .then(function (report) {
                if ($routeParams.mode === 'copy') {
                    reportCopy = report;
                    return reportService.getNewSubReport();
                } else {
                    return $q.resolve(report);
                }
            }, function (error) {
                handledLoadErrors.add(error);
                // Action was aborted
                if (error.status === -1) {
                    return $q.reject(error);
                }

                // For a 404 we want to return to the report list
                if (error.status === 404) {
                    window.location.href = '#/reports/reportbuilder3/subreports';
                    window.location.reload();
                    return $q.reject(error);
                }

                // All other errors should show a message
                let message = error?.data?.userException?.detail || "An error has occurred.";
                $dialog.actionFailed(message).open();
                return $q.reject(error);
            })
            .then(function (response) {
                let data = response.data ? response.data : response;

                if (reportCopy) {
                    data = reportHelper.reportCopySubReportData(data, reportCopy);
                }

                $scope.addBreadcrumb(isNew ? 'New Sub-Report' : data.portfolio.name, `#/reports/reportbuilder3/subreports/${data.id}`);
                $scope.report = data;
                $scope.report.id = isNew ? null : data.id;

                if (isNew) {
                    $scope.report.portfolio.isDynamic = true;
                } else {
                    $scope.report.portfolio.isDynamic = data.portfolio.isDynamic;
                }

                $scope.emptyReport = $scope.report.schema.$type === 'rcEmptySubReport';

                if (!$scope.emptyReport && $scope.report.schema.$type !== 'rcList') {
                    $scope.report.schema = wrapFirstItem($scope.report.schema);
                }

                $scope.current.alerts.push({ type: 'info', msg: 'You are now working in the sub-report editor' });
                if (data.missingSettingGuids?.length) {
                    missingSettingsAlert = {
                        type: 'warning',
                        missingSettings: true,
                        msg: 'Unavailable settings must be fixed before saving.'
                    };
                    $scope.current.alerts.push(missingSettingsAlert);
                }

                reportService.loadSubReportCategories().then((data) => {
                    $scope.categories = data;
                });
            });

        const settingsPromise = reportService.getGlobalSettings().then(function (response) {
            $scope.globalSettings = response.data;
            adHocSettingsService.setGlobalSettings(response.data);
        });

        const adHocSettingsPromise = $q(function (resolve) {
            adHocSettingsService.getAdHocSettings().subscribe(
                function (settings) {
                    $scope.adHocSettings = Array.isArray(settings) ? settings : [];
                    optionsHelper.setAdHocSettings($scope.adHocSettings);
                    $scope.$root.$broadcast('rb-event:ad-hoc-settings-changed');
                    resolve($scope.adHocSettings);
                },
                function () {
                    $scope.adHocSettings = [];
                    optionsHelper.setAdHocSettings([]);
                    $scope.$root.$broadcast('rb-event:ad-hoc-settings-changed');
                    resolve([]);
                }
            );
        });

        $q.all([subReportPromise, settingsPromise, adHocSettingsPromise]).then(
            () => {
                reportHelper.addFragmentReferencedOptions($scope.report);
                $scope.adHocSettings = optionsHelper.getAdHocSettingsCache();
                loadSettingsOptions();
                reportHelper.refreshOptions();

                $scope.initializeLayout();
                loadThemes();
            },
            error => {
                if (!handledLoadErrors.has(error)) {
                    $exceptionHandler(error);
                    const message = error?.data?.userException?.detail || "An error has occurred.";
                    $dialog.actionFailed(message).open();
                }
            }
        );
    }

    function loadThemes() {
        reportService.loadSubReportTheme().then((data) => {
            $scope.style.standard = data[0];
            $scope.style.theme = data[1];
            $scope.reportLoaded = true;
            reportHelper.refreshOptions();
        });
    }

    function addCategoryIfNotExists(category, isNew) {
        if ($scope.categories.none(category) && !isNew) {
            $scope.categories.insert(category, 0);
        } else if ($scope.categories.none(category) && isNew) {
            $scope.categories.push(category);
        }
    }

    $scope.addSubReportCategory = function () {
        const args = function () {
            return {
                isNew: true,
                categorySelected: '',
            };
        };
        $dialog.editor('reporting/modals/ReportCategory.html', 'ReportCategoryCtrl', { args: args }, 'rbcategory')
            .open()
            .then(function (result) {
                if (!result) return;
                addCategoryIfNotExists(result, args.isNew);
                $scope.report.portfolio.category = result;
            });
    };
    $scope.editSubReportCategory = function () {
        const args = function () {
            return {
                isNew: false,
                categorySelected: $scope.report.portfolio.category,
            };
        };
        $dialog.editor('reporting/modals/ReportCategory.html', 'ReportCategoryCtrl', { args: args }, 'rbcategory')
            .open()
            .then(function (result) {
                if (!result) return;
                addCategoryIfNotExists(result, args.isNew);
                $scope.report.portfolio.category = result;
            });
    };

    function loadSettingsOptions() {
        $scope.fullOptions.forEach(function (m) {
            reportHelper.getDefault(m.optionType).then(function (d) {
                if (d) {
                    $scope.current.defaultOptions[m.propertyName] = d.optionId;
                }
            });
        });
    }

    function flattenControls(control) {
        const results = [], children = [];
        if (control.controls && control.controls.length > 0) {
            control.controls.forEach(function (c) {
                results.add(c);
                results.forEach(function (r) {
                    children.add(flattenControls(r));
                });
            });
        }
        if (children && children.length > 0) {
            results.add(children);
        }
        return results;
    }

    function backToList() {
        $location.path(subReportsPath).search('');
    }

    function backToRB3(reportID) {
        $location.path('/reports/reportbuilder3/' + reportID);
    }

    function reportIsValid(report) {
        if (report.schema.$type === 'rcEmptySubReport') {
            const parms = {
                header: `<i class="fa fa-times-circle fa-lg text-error modal-icon-large" aria-hidden="true"></i> Save Failed`,
                message: `You cannot save an empty sub-report<br/>
                            <br/>
                            Select an option from the toolbar in the builder to begin creating a sub-report. Once created, you will be able to save.`,
                buttons: [{ result: 'ok', label: 'OK', cssClass: 'btn-primary', focus: true }],
            };
            $dialog.messageBox(parms.header, parms.message, parms.buttons).open();
            return false;
        }

        return true;
    }

    function SyncGlobalOptions() {
        $scope.selectControl({});
        return optionsHelper.syncGlobalOptionsAndLocalOptions($scope.report, $scope.globalSettings).then((remappedOptions) => {
            if (remappedOptions && remappedOptions.length > 0) {
                optionsHelper.updateGlobalSettingsWithNewOptions($scope.globalSettings, remappedOptions, $scope.report.options);
                //fire and forget refresh options
                $timeout(reportHelper.refreshOptions(true));
                $timeout(() => $scope.$broadcast(reportHelper.RefreshResolvesEvent, remappedOptions));
            }
        });
    }

    $scope.addMissingGlobalGuids = function () {

        const title = '<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Add Missing Guids';
        const msg = 'Do you want to add missing guids to this sub-report based on the current database? If so make sure all changes have already been saved. If global settings were synced make sure to save before calling this.';
        const buttons = [{ result: false, label: 'Cancel' }, { result: true, label: 'Save', cssClass: 'btn-primary' }];

        $dialog.messageBox(title, msg, buttons).open().then((result) => {
            if (!result) {
                return;
            }

            optionsHelper.addMissingGuidsToSubReport($scope.report.id, $scope.user.authorization.alClientId).then(() => {
                window.location.reload();
            });
        });
    };

    $scope.deleteSubReport = function () {
        fragmentHelper.delete($scope.report)
            .then(function (result) {
                if (result) {
                    $scope.$broadcast('rb-event:remove-fragment', $scope.report.id);
                    $scope.deleteBreadcrumb($scope.report.portfolio.name);
                    backToList();
                }
            });
    };

    $scope.editReportAccess = function () {
        const args = function () {
            return {
                defaultTab: { code: 'reportDatabaseAccess' },
                name: $scope.report.portfolio.name,
                accessLevels: {
                    login: angular.copy($scope.report.loginAccessRules),
                    databaseGroup: angular.copy($scope.report.databaseGroupAccessRules),
                    database: angular.copy($scope.report.databaseAccessRules),
                    role: angular.copy($scope.report.roleAccessRules),
                    user: angular.copy($scope.report.userAccessRules),
                    brokerDealersRepresentatives: angular.copy($scope.report.brokerDealersRepresentativesAccessRules),
                },
            };
        };

        $dialog.editor('reporting/editors/views/report-access-edit.html', 'ReportAccessEditCtrl', { args: args })
            .open()
            .then(function (result) {
                if (!result || !result.isSaved) return;

                $scope.report.loginAccessRules = result.accessLevels.login;
                $scope.report.databaseGroupAccessRules = result.accessLevels.databaseGroup;
                $scope.report.databaseAccessRules = result.accessLevels.database;
                $scope.report.roleAccessRules = result.accessLevels.role;
                $scope.report.userAccessRules = result.accessLevels.user;
                $scope.report.brokerDealersRepresentativesAccessRules = result.accessLevels.brokerDealersRepresentatives;
            });
    };

    $scope.previewSubReport = function () {
        $dialog.dialog({
            template: `<div class="modal-header"><h4>New Feature</h4></div>
                <div class="modal-body"><p>Coming Soon{{ctrl | json}}</p></div>
                <div class="modal-footer">
                    <button ng-click="close()" class="btn btn-primary">OK</button>
                </div>`,
            controller: function ($scope, dialog) {
                $scope.close = function (res) {
                    dialog.close(res);
                };
            },
        }).open();
    };

    function removeOptionsBeforeSave(subReport) {
        subReport.requiredOptions = [];
        subReport.additionalOptions = [];
    }

    $scope.$on('call-save-sub-report', function () {
        $scope.saveSubReport('close');
    });

    $scope.saveSubReport = function (postSaveAction) {

        let areAllLimitsValuesValid = validateLimitValues($scope.report.schema.controls); // function to check if all the limit values are valid

        if (!areAllLimitsValuesValid) {
            // if Limit values are not valid raise error in dialog else continue with normal flow
            const title = `<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Error`;
            const msg = `The Limit field is required when Limit Method is set to Count.`;
            const buttons = [{ result: true, label: 'OK', cssClass: 'btn-primary' }];
            $dialog.messageBox(title, msg, buttons).open();
            return;
        }

        if (reportIsValid($scope.report) === false) {
            return;
        }

        $scope.disableSave = true;
        const saveSubReportPromise = SyncGlobalOptions().then(() => {
            const subReport = angular.copy($scope.report);
            subReport.schema = subReport.schema.unWrapControl();

            removeOptionsBeforeSave(subReport);

            return fragmentHelper.saveSubReport(subReport).then((response) => {
                if (!response) {
                    $scope.disableSave = false;
                    return;
                }
                const firstSave = !$scope.report.id || $routeParams.mode === 'copy';
                if (firstSave) {
                    $scope.deleteBreadcrumb();
                    $scope.addBreadcrumb($scope.report.portfolio.name, subReportsPath + response.data.id);

                    $scope.report.id = response.data.id;
                    $location.search('');
                    $location.path(subReportsPath + response.data.id);
                }

                $scope.updateBreadcrumb($scope.report.portfolio.name);
                $scope.report.missingSettingGuids = [];
                $scope.report.missingSettings = [];
                const warningIndex = $scope.current.alerts.indexOf(missingSettingsAlert);
                if (warningIndex >= 0) {
                    $scope.current.alerts.splice(warningIndex, 1);
                }
                missingSettingsAlert = null;
                $scope.disableSave = false;

                if (postSaveAction === 'close') {
                    if ($routeParams.origin && $routeParams.origin.length > 0) {
                        backToRB3($routeParams.origin);
                    }
                    else {
                        backToList();
                    }
                }
            });
        }).catch(error => {
            if (!error?.errorDialogShown) {
                const message = error?.data?.userException?.detail || "Error trying to save Sub-Report. Please check tags and settings and try again.";
                $dialog.actionFailed(message).open();
            }
            $scope.disableSave = false;
        });

        promiseTracker('main').addPromise(saveSubReportPromise, { trackerMsg: 'Saving Sub-Report' });
    };

    $scope.viewResolveOptionLibrary = function () {
        $dialog.dialog({
            templateUrl: 'reporting/envision/modals/resolve-option-library.html',
            controller: 'ResolveOptionLibraryCtrl',
            dialogClass: 'modal wide',
        }).open();
    };

    $scope.updateReportStyle = function (styles) {
        if (!styles) {
            return;
        }

        $scope.reportStyle.width = styles.width;
        $scope.reportStyle['min-height'] = styles['min-height'];
        $scope.reportStyle['padding-top'] = styles['padding-top'];
        $scope.reportStyle['padding-right'] = styles['padding-right'];
        $scope.reportStyle['padding-bottom'] = styles['padding-bottom'];
        $scope.reportStyle['padding-left'] = styles['padding-left'];
        $scope.reportStyle.transform = styles.transform;

        if (styles.header && styles.header['margin-top']) {
            $scope.headerStyle['margin-top'] = styles.header['margin-top'];
            $scope.headerStyle.height = styles.header.height;
        }

        if (styles.footer && styles.footer['margin-bottom']) {
            $scope.footerStyle['margin-bottom'] = styles.footer['margin-bottom'];
            $scope.footerStyle.height = styles.footer.height;
        }

        $scope.reportCenterStyle.width = 'calc(' + styles.width + ' * ' + (styles.scale || 1) + ')';
        $scope.reportCenterStyle['min-height'] = 'calc(' + styles['min-height'] + ' * ' + (styles.scale || 1) + ')';

        reportHelper.setReportStyle($scope.reportStyle);
        $scope.sendReflow();
    };

    $scope.sendReflow = function () {
        $timeout(function () {
            $scope.$broadcast('highchartsng.reflow');
            $window.dispatchEvent(new Event("resize"));
        }, 500);
    };

    $scope.initializeLayout = function () {
        $scope.paper.orientation = ReportStyleService.getCurrentStoredOrientation();
        ReportStyleService.updateLayout($scope.paper);
    };

    $scope.updateZoomLevel = function (scale) {
        $scope.paper.scale = scale;
        ReportStyleService.updateLayout($scope.paper);
    };

    $scope.hoverControl = reportHelper.hoverControl;

    $scope.selectControl = function (event) {
        const control = reportHelper.selectControl(event);
        
        if (!$scope.aiChatEnabled) {
            if (control) {
                if ($scope.current.control !== control) {
                    $scope.current.sidebarTab.parameters = true;
                }
            } else {
                $scope.current.sidebarTab.settings = true;
            }
        }

        $scope.current.control = control;
        //Check if there is empty schema
        if (!$scope.report.schema.controls || $scope.report.schema.controls.length <= 0) {
            $scope.emptyReport = true;
        }
    };

    $scope.addControlCallback = function (item) {
        const initialContext = angular.copy($scope.report.schema.contextChange);
        $scope.report.schema = wrapFirstItem(item, true);
        $scope.report.schema.contextChange = initialContext;
        //When dnd fragment is initially added
        $scope.report.schema.$type = 'rcList';
        $scope.$broadcast(reportHelper.MenuCloseEvent);
        $scope.emptyReport = false;
    };

    $scope.chatAiSchemaChange = function (event) {
        $scope.report.schema = event
        if (!$scope.report.schema.controls || $scope.report.schema.controls.length <= 0) {
            $scope.emptyReport = true;
        } else {
            $scope.emptyReport = false;
        }
    }

    $scope.openGlobalSettings = function () {
        var dialogParameters = {
            templateUrl: 'reporting/envision/views/reports-global-settings.html',
            controller: 'ReportsGlobalSettingsCtrl',
            dialogClass: 'modal wide',
        };

        $dialog.dialog(dialogParameters).open();
    };

    $scope.openPreview = false;
    $scope.launchPreviewPrompt = function () {
        $scope.openPreview = true;
        $timeout(() => {
            //reset to false for changes to allow for reopen later, does not close modal
            $scope.openPreview = false;
        }, 250);
    };

    $scope.previewClose = function () {
        $scope.openPreview = false;
    };

    //INITIALIZE
    $scope.current = {
        control: null,
        sectionSearchText: '',
        sidebarTab: { aiChat: true, settings: true, parameters: false, sections: false },
        defaultOptions: {},
        isNewFromReport: $routeParams.isNewFromReport === 'true',
        alerts: []
    };

    $scope.hasAdvancedEditorRights = $oasRights.canRead("REPORTBUILDERADVANCEDEDITOR");
    $scope.hasReportSettingsRights = $oasRights.canRead("REPORTSETTINGS");

    init();

    //EVENT LISTENERS
    $timeout(function () {
        let viewport = reportHelper.getViewport();
        viewport.addEventListener('scroll', function () {
            $scope.$broadcast('rb-event:render-visible', viewport.getBoundingClientRect());
        });
    }, 10);

    $scope.$on('$destroy', function () {
        reportHelper.setReport(null);
        $scope.chatSub.unsubscribe();
    });

    $scope.$on('rb-event:select-control', function (event, data) {
        $scope.selectControl(data.control, data.event);
    });

    $scope.$on('rb-event:update-current-control', function (event, updatedControl) {
        if (updatedControl) {
            $scope.current.control = updatedControl;
        }
    });

    $scope.$on('rb-event:remove-controls', function (event, removedControls) {
        const childControls = [];
        removedControls.forEach(function (c) {
            childControls.add(flattenControls(c));
        });
        if (childControls && childControls.length > 0) {
            removedControls.add(childControls);
        }

        ReportAssistantChatHelper.clearChatContext(removedControls);

        if (removedControls.some($scope.current.control)) {
            $scope.current.control = null;
        }

        if (!$scope.report.schema.controls || $scope.report.schema.controls.length <= 0) {
            $scope.report.schema.$type = 'rcEmptySubReport'
            $scope.emptyReport = true;
        }

        $timeout(function () {
            let viewport = reportHelper.getViewport();
            $scope.$broadcast('rb-event:render-visible', viewport.getBoundingClientRect());
        }, 10);
    });

    $scope.$on('rb-event:get-default-option', function (event, data) {
        //this is the report level. The buck stops here
        event.stopPropagation();
        //just get the default from the helper
        reportHelper.getDefault(data.type, data.path)
            .then(function (d) {
                data.setDefault(d, this);
            });
    });

    $scope.$on("rb-event:update-global-settings", function (event, updatedOptions) {
        if (!updatedOptions.options || !angular.isArray(updatedOptions.options)) {
            return;
        }
        var optionType = updatedOptions.type;
        $scope.globalSettings = [...$scope.globalSettings.filter(g => g.optionType !== optionType), ...updatedOptions.options];
        reportHelper.refreshOptions();
    });

    function validateLimitValues(reportSchemaControls) {
        let countValuesArray = [];

        function fetchLimitValues(reportSchemaControls) {
            // Recursive Helper Function to Extract Counts from nested objects
            // base case if object is null/undefined or not an object return immediately
            if (!reportSchemaControls || typeof reportSchemaControls !== 'object') {
                return; // to prevent errors when trying to access properties of null or non object values.
            }

            for (let key in reportSchemaControls) {
                if (key === 'limitMethod' && typeof reportSchemaControls[key] === 'object' && reportSchemaControls[key]) {
                    if (reportSchemaControls[key].limitMethod === 'Count') {
                        // only add values if limitMethod is Count
                        countValuesArray.push(reportSchemaControls[key].count); // Add counts to array even if null
                    }
                } else if (typeof reportSchemaControls[key] === 'object') {
                    fetchLimitValues(reportSchemaControls[key]); //Recursively search deeper
                }
            }
        }

        angular.forEach(reportSchemaControls, function (item) {
            fetchLimitValues(item);
        });

        if (countValuesArray.length === 0) {
            // to return true if no limitMethod of count is present
            return true;
        }

        // check if all limit values are valid (excluding null,blank zero and undefined ones return true if all are valid else false)
        let allValidLimits = countValuesArray.every((value) => value !== null && !isNaN(value));

        return allValidLimits > 0; // return true if all Limit values are valid else false
    }
});

'use strict';

app.controller('ReportsGlobalSettingsCtrl', function ($scope, reportHelper, reportService, $dialog, optionsHelper, dialog, $oasRights, adHocSettingsService) {
    $scope.data = {globalOptions: [], selectedOptions: {}};
    $scope.optionTypes = reportHelper.getFullOptions();
    $scope.current = { isLoaded: false, fullScreen: true, useAdHocSettings: false, settingsTab: 0 };
    $scope.canEditReportSettings = $oasRights.canUpdate("REPORTSETTINGS");

    adHocSettingsService.isFeatureEnabled().subscribe(function (enabled) {
        $scope.current.useAdHocSettings = enabled;
    });

    function init() {
        if (dialog) {
            $scope.current.fullScreen = false;
        }
        reportService.getGlobalSettings().then(resp => {
            $scope.data.globalOptions = resp.data;
            adHocSettingsService.setGlobalSettings(resp.data);
            reportHelper.addGlobalPlaceholders($scope.data.globalOptions);
            setSelectedOptions($scope.data.globalOptions);
            $scope.current.isLoaded = true;
        });
    }

    function getListByType(optionType) {
        return $scope.data.globalOptions.filter((o) => o.optionType === optionType);
    }

    function getSettingsListByType(optionType) {
        return getListByType(optionType).map((o) => {
            let result = JSON.parse(o.settings);

            if (!result.optionGuid)
            {
                result.optionGuid = o.guid
            }

            if (result.optionId < 1000) {
                result.optionId += 1000;
            }

            result.isSystemDefault = o.isSystemDefault;
            result.isGlobal = o.isGlobal;
            result.isDisabled = o.isDisabled;
            
            return result;
        });
    }

    function setSelectedOptions(options) {
        options.filter(o => o.isDefault).forEach(d => {
            $scope.data.selectedOptions[d.optionType] = d;
        });
    }

    function saveOptions(options, optionType) {
        $scope.current.isLoaded = false;
        const optionLabel = reportHelper.getOptionLabel(optionType);

        return reportService.saveGlobalOptions(options, optionType, optionLabel).then(resp => {
            $scope.data.globalOptions = [...resp.data];
            adHocSettingsService.setGlobalSettings(resp.data);

            const defaultRemoved = !resp.data.some(go => go.id === $scope.data.selectedOptions[optionType].id);
            if (defaultRemoved) {
                $scope.data.selectedOptions[optionType] = resp.data.find(d => d.id === resp.data.map(ot => ot.id).min());
            }

            reportHelper.updateOptions(resp.data, optionType);
            $scope.current.isLoaded = true;
        });
    }

    function updateDefaults(allOptions, selectedDefaults) {
        allOptions.forEach(o => o.isDefault = false);

        selectedDefaults.forEach(d => {
            let matchedOption = allOptions.find(o => o.id === d.value && o.optionType === d.key);
            if (!!matchedOption) {
                matchedOption.isDefault = true;
            }
        });
    }

    function mapToSettings(results) {
        const newResults = optionsHelper.updateDuplicateIdByType(results);

        return newResults.map(r => {
            return optionsHelper.mapOptionToSetting(r);
        });
    }

    function mapDefaults(selectedOptions) {
        return Object.keys(selectedOptions).map(key => {
            const sd = selectedOptions[key];

            return {item1: sd.optionType, item2: sd.id, item3: sd.guid};
        });
    }

    $scope.saveChanges = function () {
        const mappedDefaults = mapDefaults($scope.data.selectedOptions);

        reportService.saveDefaultSettings(mappedDefaults).then(() => {
            updateDefaults($scope.data.globalOptions, mappedDefaults);
        });
    };

    $scope.resetChanges = function () {
        const title = '<i class="fa fa-undo fa-lg" aria-hidden="true"></i> Reset Changes?';
        const buttons = [
            {result: null, label: 'Cancel', cssClass: ''},
            {result: 'ok', label: 'Reset', cssClass: 'btn-primary'},
        ];
        const message = 'All changes will be reverted. Do you want to continue?';

        $dialog.messageBox(title, message, buttons).open().then((results) => {
            if (!results) {
                return;
            }

            setSelectedOptions($scope.data.globalOptions);
        });
    };


    $scope.launchEditor = function (optionType, contextType) {
        const currentItem = $scope.data.selectedOptions[optionType];

        const config = {
            type: contextType,
            item: currentItem ? currentItem.id : null,
            itemList: getSettingsListByType(optionType),
            action: 'edit',
            submitButtonText: 'Save',
            isGlobalEditor: true,
            submitBeforeCloseCallBack: function (results) {
                return new Promise(function (resolve, reject) {
                    if (!results) {
                        reject("Results cannot be null or undefined.");
                    }

                    const options = mapToSettings(results);

                    return saveOptions(options, optionType).then(resp => {resolve(resp)}, err =>{$scope.current.isLoaded = true; reject(err)});
                });
            }
        };

        const d = $dialog.dialog({
            templateUrl: 'reporting/envision/modals/context-change-options.html',
            controller: 'ContextChangeOptionsCtrl',
            resolve: {
                args: function () {
                    return config;
                },
            },
        });

        $scope.current.isLoaded = false;
        d.open()
            .then(resp => { $scope.current.isLoaded = true; }, err => { $scope.current.isLoaded = true; });
    };

    $scope.close = function () {
        if(dialog) {
            dialog.close(true);
        }
    };

    init();
});

'use strict';

app.controller('ReportingEnvisionCoverPageListCtrl', function ReportingEnvisionCoverPageListCtrl( $scope, $http, $oasRights, $dialog ) {


    //PRIVATE METHODS
    function init( ) {
        $http.get('/Reporting/Envision/CoverPages', {trackerMsg: 'Loading cover pages'})
            .then(function (response) {
                $scope.coverPages = response.data;
            });
    }


    //PUBLIC METHODS
    $scope.deleteCoverPage = function( coverPage ) {
        $dialog.confirmAction( "Are you sure you want to delete cover page <b>" + coverPage.name + "</b>?" )
            .open()
            .then( function( result ) {
                if( result === 'yes' ) {
                    $http.delete('/Reporting/Envision/CoverPages/Verbose/' + coverPage.id, {trackerMsg: 'Deleting cover page ' + coverPage.id})
                        .then(function () {
                            $scope.coverPages.remove({id: coverPage.id});
                            $scope.deleteBreadcrumb(coverPage.name);
                        });
                }
            } );
    };


    //INITIALIZE
    $scope.rightsCoverPages = $oasRights.forCode("REPORTCOVERPAGERIGHTS");
    init( );
});
'use strict';

app.controller('ReportingEnvisionCoverPageItemCtrl', function ReportingEnvisionCoverPageItemCtrl($scope, $http, $oasRights, $dialog, $routeParams, $location, $timeout, imageHelper, RB_TOOLBAR, RB_COMPONENT_NAMES, $q, reportHelper) {
    //PRIVATE VARIABLES
    const rcPositionCtrl = {selected: null, hovered: null};


    //PRIVATE METHODS
    function init() {
        $scope.reportCenterStyle = {};
        $scope.reportStyle = {};
        $scope.current = {control: null, isDragging: false};
        $scope.settings = {showEnvelopeWindows: false};

        $scope.envelopeWindows = [
            {envelopeType: 'Print Vendor 9 x 12 Portrait', style: getBoxStyle(.65, .3, 2.15, 2.8, 'in')},
            {envelopeType: 'Print Vendor 9 x 12 Portrait', style: getBoxStyle(3, 4.7, 1.65, 2.8, 'in')},
            {envelopeType: 'Print Vendor 9 x 12 Landscape', style: getBoxStyle(.7, .6, 2.2, 2.75, 'in')},
            {envelopeType: 'Print Vendor 9 x 12 Landscape', style: getBoxStyle(5.1, 6.6, 1.44, 3, 'in')},
            {envelopeType: 'Print Vendor 6 x 9 Portrait', style: getBoxStyle(.65, .3, 2.5625, 2.8, 'in')},
            {envelopeType: 'Print Vendor 6 x 9 Portrait', style: getBoxStyle(3, 4.7, 1.8125, 2.8, 'in')}
        ];

        $scope.toolBar = [
            {name: 'Tables', icon: 'fa-table'},
            {name: 'Text Boxes', icon: 'fa-text-width'},
            {name: 'Media', icon: 'fa-photo'}
        ];

        $scope.toolBar.forEach(function (category) {
            category.items = angular.copy(RB_TOOLBAR[category.name].findAll({canUseInCoverPage: true}));
        });

        const isNew = $routeParams.id === '0';
        var data = {};

        $http.get('/Reporting/Envision/Coverpages/Verbose/' + (isNew ? 'New' : ($routeParams.id + '?expand=all')), {trackerMsg: 'Loading cover page'})
            .then(function (response) {
                data = response.data;
                if ($routeParams.mode === 'copy') {
                    return $http.get('/Reporting/Envision/Coverpages/Verbose/New', {trackerMsg: 'Loading cover page'});
                } else {
                    return $q.resolve({data});
                }
            })
            .then(function(response){
                if ($routeParams.mode === 'copy') {
                    const newCoverPage = response.data ? response.data : response;
                    data.id = null;
                    data.name = 'Copy of ' + data.name;
                    data.portfolio.name = 'Copy of ' + data.portfolio.name;
                    data.portfolio.canEdit = true;
                    data.portfolio.canDelete = true;

                    data.loginAccessRules = newCoverPage.loginAccessRules;
                    data.databaseGroupAccessRules = newCoverPage.databaseGroupAccessRules;
                    data.databaseAccessRules = newCoverPage.databaseAccessRules;
                    data.roleAccessRules = newCoverPage.roleAccessRules;
                    data.userAccessRules = newCoverPage.userAccessRules;
                }
                $scope.addBreadcrumb(isNew ? 'New Cover Page' : data.name, `#/reports/reportbuilder3/coverpages/${data.id}`);
                $scope.coverPage = data;
                $scope.coverPage.id = isNew ? null : data.id;
                $scope.paper = $scope.coverPage.additionalOptions.find({category: 'Paper Layout'}).options.find({id: 'paper-layout'});
                $scope.updatePaperSizeStyle( 1);

                $scope.envelope = $scope.coverPage.additionalOptions.find({category: 'Envelope Window'}).options.find({id: 'envelope-window'});
                $scope.updateEnvelopWindows( true );
            });

        loadDefaultTheme();
    }

    function loadDefaultTheme(){
        $http.get('/Reporting/Envision/Themes', {trackerMsg: 'Loading themes'})
            .then(function (response) {
                var defaultTheme = response.data.find(d => d.isDefault === true);
                $scope.defaultTheme = !defaultTheme ? response.data[0].css : defaultTheme.css;
            });
    }

    function getPixelsPerUnit(unit) {
        const converter = document.getElementById(unit+"Converter");
        const info = converter.getBoundingClientRect();
        return info.width / 100;
    }

    function getBoxStyle(top, left, height, width, units) {
        return {top: top + units, left: left + units, width: width + units, height: height + units};
    }

    function setControlStatus(control, status, event) {
        if (control && event) {
            event.stopPropagation();
        }

        if (rcPositionCtrl[status]) {
            rcPositionCtrl[status][status] = false;
        }

        if (control) {
            control[status] = true;
        }

        rcPositionCtrl[status] = control;
    }

    function getPaperSize(){
        const dimensions = {
            Letter: {short: 8.5, long: 11, unit: 'in'},
            A4: {short: 210, long: 297, unit: 'mm'},
            Legal: {short: 8.5, long: 14, unit: 'in'}
        }[$scope.paper.selection];

        const pixelsPerUnit = getPixelsPerUnit(dimensions.unit);
        const paperSize = $scope.paper.orientation === 'Landscape'
            ? {width: dimensions.long, height: dimensions.short, pixelsPerUnit: pixelsPerUnit, unit: dimensions.unit}
            : {width: dimensions.short, height: dimensions.long, pixelsPerUnit: pixelsPerUnit, unit: dimensions.unit};
        return paperSize;
    }

    function bindEvents(item) {
        //need to add these methods to the item so they exist when the editor(s) call them. On the cover page they don't need to do anything though since we don't have any options to show.
        item.$emit = function(event, data){ };
        item.$on = function(event, data){ };
        item.$broadcast = function(event, data) { };
        return item;
    }

    // PUBLIC METHODS
    $scope.reportAccess = function () {
        const isRep = $scope.user.authorization.entity === "Representative";
        const defaultTab = isRep ? {code: "reportRepresentativeClientAccess"} : {code: "reportDatabaseAccess"};
        const d = $dialog.editor("reporting/editors/views/report-access-edit.html", "ReportAccessEditCtrl", {
            args: function () {
                return {
                    defaultTab: defaultTab,
                    name: $scope.coverPage.name,
                    accessLevels: {
                        login: angular.copy($scope.coverPage.loginAccessRules),
                        databaseGroup: angular.copy($scope.coverPage.databaseGroupAccessRules),
                        database: angular.copy($scope.coverPage.databaseAccessRules),
                        role: angular.copy($scope.coverPage.roleAccessRules),
                        user: angular.copy($scope.coverPage.userAccessRules),
                        representative: angular.copy($scope.coverPage.representativeAccessRules),
                        representativesClients: angular.copy($scope.coverPage.representativesClientsAccessRules),
                        client: angular.copy($scope.coverPage.clientAccessRules)
                    }
                };
            }
        });

        d.open().then(function (rslt) {
            if (rslt && rslt.isSaved) {
                $scope.coverPage.loginAccessRules = angular.copy(rslt.accessLevels.login);
                $scope.coverPage.databaseGroupAccessRules = angular.copy(rslt.accessLevels.databaseGroup);
                $scope.coverPage.databaseAccessRules = angular.copy(rslt.accessLevels.database);
                $scope.coverPage.roleAccessRules = angular.copy(rslt.accessLevels.role);
                $scope.coverPage.userAccessRules = angular.copy(rslt.accessLevels.user);
                $scope.coverPage.representativeAccessRules = angular.copy(rslt.accessLevels.representative);
                $scope.coverPage.representativesClientsAccessRules = angular.copy(rslt.accessLevels.representativesClients);
                $scope.coverPage.clientAccessRules = angular.copy(rslt.accessLevels.client);
            }
        });
    };

    $scope.updateEnvelopWindows = function ( overrideShowCheck ) {
        if( overrideShowCheck ) {
            $scope.settings.showEnvelopeWindows = $scope.envelope.selection !== "None";
        }

        $scope.envelopeWindows.forEach(function (window) {
            window.enabled = window.envelopeType === $scope.envelope.selection && $scope.settings.showEnvelopeWindows;
        });
    };

    $scope.updatePaperSizeStyle = function (scale) {
        const paperSize = getPaperSize();

        if(!scale) {
            var regExp = /scale\(([^)]+)\)/;
            var matches = regExp.exec($scope.reportCenterStyle.transform);
            scale = matches.length > 0 ? matches[1] : 1;
        }

        if (scale <= 1) {
            $scope.reportCenterStyle.left = "50%";
            $scope.reportCenterStyle.transform = "scale(" + scale + ") translate(-50%, 0)";
        } else {
            $scope.reportCenterStyle.left = "0";
            $scope.reportCenterStyle.transform = "scale(" + scale + ") translate(0, 0)";
        }

        //take the scale back out of the padding so it appears to be the same as the scale changes.
        $scope.reportCenterStyle.padding = 'calc(80px / ' + scale + ')';
        $scope.reportCenterStyle.width = 'calc(' + paperSize.width + paperSize.unit + ' + (160px / ' + scale + ') )';
        $scope.reportCenterStyle['min-height'] = 'calc(' + paperSize.height + paperSize.unit + ' + (160px / ' + scale + ') )';

        $scope.reportStyle.width = paperSize.width + paperSize.unit;
        $scope.reportStyle['min-height'] = paperSize.height + paperSize.unit;

        if ($scope.envelope) {
            $scope.envelope.selection = "None";
            $scope.settings.showEnvelopeWindows = false;
        }
    };

    $scope.deleteCoverPage = function () {
        $dialog.confirmAction("Are you sure you want to delete cover page <b>" + $scope.coverPage.portfolio.name + "</b>?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete('/Reporting/Envision/CoverPages/Verbose/' + $scope.coverPage.id, {trackerMsg: 'Deleting cover page ' + $scope.coverPage.id})
                        .then(function () {
                            $scope.deleteBreadcrumb($scope.coverPage.name);
                            $location.path('/reports/reportbuilder3/coverpages');
                        });
                }
            });
    };

    $scope.saveCoverPage = function (close) {
        const coverPage = angular.copy($scope.coverPage);

        if (!$scope.coverPage.portfolio.name || $scope.coverPage.portfolio.name.trim().length === 0) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Cannot Save Cover Page", "The cover page cannot be saved without a name.  Please add a cover page name then try again.").open();
            return;
        }

        const args = $scope.coverPage.id ? {method: "put", id: coverPage.id, trackerMsg: "Saving " + coverPage.portfolio.name} : {method: "post", id: "", trackerMsg: "Creating new cover page"};

        $http[args.method]('/Reporting/Envision/CoverPages/Verbose/' + args.id, coverPage, {trackerMsg: args.trackerMsg})
            .then(function (response) {
                const crumbName = coverPage.portfolio.name;
                if (coverPage.id) {
                    $scope.updateBreadcrumb(crumbName);  //in case it changed
                } else {
                    $scope.deleteBreadcrumb(crumbName);
                    $scope.addBreadcrumb(crumbName, '/reports/reportbuilder3/coverpages/' + response.data.id);
                    $location.search('');
                    $location.path(`/reports/reportbuilder3/coverpages/${response.data.id}`);
                }

                //in case save without closing
                $scope.coverPage = response.data;

                if (close) {
                    $location.path('/reports/reportbuilder3/coverpages');
                }
            });
    };

    $scope.getComponentName = function (control) {
        return RB_COMPONENT_NAMES[control.$type];
    };

    $scope.hoverControl = function (control, event) {
        setControlStatus(control, 'hovered', event);

        if(control) {
            reportHelper.current.hovered = control.control;
        }
    };

    $scope.selectControl = function (control, event) {
        setControlStatus(control, 'selected', event);

        if (control) {
            $scope.current.control = control.control;
            $scope.current.sidebarTab.parameters = true;
            reportHelper.current.selected = control.control;
        }
    };

    $scope.deleteControl = function (control) {
        $dialog.confirmAction("Are you sure you want to delete control?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.coverPage.schema.body.controls.remove(control);
                    $scope.current.control = null;
                }
            });
    };

    $scope.sendControlToBack = function (control) {
        $scope.coverPage.schema.body.controls.remove(control);
        $scope.coverPage.schema.body.controls.insert(control, 0);
    };

    $scope.sendControlToFront = function (control) {
        $scope.coverPage.schema.body.controls.remove(control);
        $scope.coverPage.schema.body.controls.push(control);
    };

    $scope.moveControl = function (event, control, elem) {
        const paperSize = getPaperSize();

        const top = parseInt(elem.css("top"));
        const left = parseInt(elem.css("left"));
        const height = parseInt(elem.css("height"));
        const width = parseInt(elem.css("width"));

        control.c.top = ( top / paperSize.pixelsPerUnit ) + paperSize.unit;
        control.c.left = ( left / paperSize.pixelsPerUnit ) + paperSize.unit;

        if(top === 0 && paperSize.height *.99 <= ( height / paperSize.pixelsPerUnit )) {
            //force to 100%
            control.c.height = paperSize.height + paperSize.unit;
        } else {
            control.c.height = ( height / paperSize.pixelsPerUnit ) + paperSize.unit;
        }

        if(left === 0 && paperSize.width *.99 <= ( width / paperSize.pixelsPerUnit )) {
            //force to 100%
            control.c.width = paperSize.width + paperSize.unit;
        } else {
            control.c.width = (width / paperSize.pixelsPerUnit) + paperSize.unit;
        }

        $scope.selectControl(control);
    };

    $scope.addControl = function (event, control, elem) {
        const paperSize = getPaperSize();

        const top = parseInt(event.target.style.top) - 60;
        const left = parseInt(event.target.style.left);

        $timeout(function () {
            const rcPositioned = {
                $type: "rcPositioned",
                control: bindEvents( angular.copy(control.item.schema) ),
                top: ( top / paperSize.pixelsPerUnit ) + paperSize.unit,
                left: ( left / paperSize.pixelsPerUnit ) + paperSize.unit,
                height: "2in",
                width: "3in"
            };

            $scope.coverPage.schema.body.controls.push(rcPositioned);
            $scope.selectControl(rcPositioned);
        });
    };

    $scope.updateControl = function (control) {
        control.canEdit = $scope.coverPage.portfolio.canEdit && $scope.rightsCoverPages.canUpdate;
    }

    // EVENT LISTENERS
    $scope.$on('rc-image-event:change-image', function (e, args) {
        if (!rcPositionCtrl.selected) return;

        const paperSize = getPaperSize();
            rcPositionCtrl.selected.height = args.control.heightPixels ? (args.control.heightPixels / paperSize.pixelsPerUnit) + paperSize.unit : null;
            rcPositionCtrl.selected.width = args.control.widthPixels ? ( args.control.widthPixels / paperSize.pixelsPerUnit ) + paperSize.unit : null;
    });


    // INITIALIZE
    $scope.rightsCoverPages = $oasRights.forCode("REPORTCOVERPAGERIGHTS");
    init();
});

app.directive('draggable', function ($document) {
    return {
        restrict: 'A',
        scope: {dropFn: '&', copyElement: '=', allowResize: '=', grabHandle: '@', childControl: '=', isDragging: '=?'},
        link: function (scope, elem, attrs) {

            elem.draggable({
                revert: "false",
                helper: scope.copyElement ? 'clone' : '',
                handle: scope.grabHandle || undefined,
                containment: scope.grabHandle ? 'parent' : undefined
            });

            if (scope.allowResize) {

                elem.resizable({
                    handles: "n, e, s, w",
                    aspectRatio: scope.childControl.$type === 'rcReportImage',
                    containment: "parent"
                });
            }

            elem.on('mousedown', function (event) {
                scope.isDragging = true;
                $document.on('mouseup', mouseup);
            });

            function mouseup(event) {
                scope.isDragging = false;
                $document.off('mouseup', mouseup);
                const expressionHandler = scope.dropFn();
                expressionHandler(event, scope.$parent, elem);
            }
        }
    };
});

'use strict';

app.controller('ReportingEnvisionListCtrl', function ReportingEnvisionListCtrl($scope, $http, $oasRights, entities, $dialog, ReportApiService) {
    //PRIVATE VARIABLES

    //PRIVATE METHODS
    function init() {
        $http.get('/Reporting/Envision/Reports', {trackerMsg: 'Loading reports'})
            .then(function (response) {
                $scope.reports = response.data;
            });
    }

    //PUBLIC METHODS
    $scope.runReport = function (reportId) {
        $dialog.reportPrompt(reportId, {runAssignedVersion: false}).open();
    };

    $scope.deleteReport = function (report) {
        ReportApiService.deleteReportWithPackageCheck($scope.report)
            .then(function (result) {
                if (result) {
                    $scope.reports.remove({id: report.id});
                    $scope.deleteBreadcrumb(report.name);
                }
            });
    };

    $scope.removeWhitespace = function (itemName) {
        const whitespace = /\s/g;
        return itemName.replace(whitespace, '');
    };


    //INITIALIZE
    $scope.hasAdvancedEditorRights = $oasRights.canRead("REPORTBUILDERADVANCEDEDITOR");
    init();
});
'use strict';

app.controller('ReportingEnvisionQueryBuilderListCtrl', function ReportingEnvisionQueryBuilderListCtrl($scope, $http, $oasRights, entities, $dialog, $dataQuery, QueryBuilderSchedulesService, QueryBuilderSchedulesModalService, reportService, splitIoService) {
    //PRIVATE VARIABLES
    const isQueryBuilderCreateNewAndCloneEnabledFeatureFlag = 'oc_querybuilder_createnewandclone_41603';

    //PRIVATE METHODS
    function init() {
        splitIoService.getBoolTreatment(isQueryBuilderCreateNewAndCloneEnabledFeatureFlag).subscribe(isEnabled => {
            $scope.isQueryBuilderCreateNewAndCloneEnabled = isEnabled;
            $scope.$apply();
        });

        $http.get('/Reporting/Envision/ExcelReports', {trackerMsg: 'Loading queries'})
            .then(function (response) {
                $scope.queries = response.data;
            });

        $http.get('/Settings/Database/EntityOptions/Code/69NEWQBSCHEDUI', {trackerMsg:'Loading database settings'})
            .then(function (response) {
                $scope.enableFullQBSchedUi = response.data.value;
            });

        if (!$scope.globalSettings) {
            $scope.loadingGlobalSettings = true;

            reportService.getGlobalSettings()
                .then((response) => {
                    if (response) {
                        $scope.globalSettings = response.data;
                        $scope.loadingGlobalSettings = false;
                    }
                });
        }
    }

    function launchLegacyQueryScheduleDialog(dataQueryId, scheduleId) {
        $dialog.dialog({id: dataQueryId, scheduleId: scheduleId, templateUrl: "reporting/envision/modals/queryBuilderScheduler.html",controller: "QueryBuilderSchedulerCtrl", dialogClass: "modal wide"})
            .open()
            .then(function (result) {
                if (result) {
                    //Add or Save schedule.
                    var args = result.id !== 0 ? {
                        method: "PUT",
                        url: '/Reporting/Envision/ExcelReportSchedules/' + result.id,
                        id: result.scheduleId,
                        trackerMsg: "Saving query schedule: "
                    } : {
                        method: "POST",
                        id: 0,
                        url: '/Reporting/Envision/ExcelReportSchedules/',
                        trackerMsg: "Adding new query schedule"
                    };
                    $http({ method: args.method, url: args.url, data: result, trackerMsg: args.trackerMsg })
                        .then(function(response) {
                            let query = $scope.queries.find({id: dataQueryId});
                            query.scheduleId = response.data.id;
                            query.isActive = response.data.isActive;
                            if (response.config.method === "POST") query.scheduleCount += 1;
                        });
                } else {
                    $scope.$broadcast('event:dataqueries-action', {action: 'refresh-grid'});
                }
            });
    }

    function handleScheduleClicked(querySchedule) {
        if ($scope.enableFullQBSchedUi === "False") launchLegacyQueryScheduleDialog(querySchedule.excelReportId, querySchedule.id);
    }

    function handleScheduleDeleteClicked(querySchedule) {
        let query = $scope.queries.find({id: querySchedule.excelReportId});
        query.scheduleCount -= 1;
    }

    function generateNewScheduleClickedCallback(dataQueryId) {
        return function () {
            handleNewScheduleClicked(dataQueryId);
        }
    }

    function handleNewScheduleClicked(dataQueryId) {
        if ($scope.enableFullQBSchedUi === "False") launchLegacyQueryScheduleDialog(dataQueryId, undefined);
    }

    //PUBLIC METHODS
    $scope.newQuery = function () {
        $scope.editQuery( 0, false);
    };

    $scope.editQuery = function (queryId, clone) {
        const options = {
            templateUrl: 'reporting/envision/modals/QueryBuilderWizard.html',
            controller: 'QueryBuilderWizardCtrl',
            dialogClass: "modal wide queryBuilder",
            resolve: {
                isNew: function () {return !queryId || clone;},
                isClone: function () { return clone; },
                queryId: function () {return queryId;},
                globalSettings: function() { return $scope.globalSettings; }
            }
        };

        $dialog.dialog(options)
            .open()
            .then(function (result) {
                if (result) {
                    init();
                }
            });
    };

    $scope.runQuery = function (queryId) {
        $dataQuery.runExcelReport(queryId); // moved to service so both favorites and query list screens can call it
    };

    $scope.deleteQuery = function (query) {
        $dialog.confirmAction("Are you sure you want to delete query <b>" + query.name + "</b>?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete('/Reporting/Envision/ExcelReports/Verbose/' + query.id, {trackerMsg: 'Deleting query ' + query.id})
                        .then(function () {
                            $scope.queries.remove({id: query.id});
                            $scope.deleteBreadcrumb(query.name);
                        });
                }
            });
    };

    $scope.toggleFavorite = function (query) {
        $http.put(`/Reporting/Envision/ExcelReports/${query.id}/Favorite`, {trackerMsg: 'Updating query favorite'})
            .then(function (response) {
                $scope.queries.find({id: query.id}).isFavorite = response.data.isFavorite;
            });
    };
    $scope.editQueryAccess = function (query) {
        $http.get('/Reporting/Envision/ExcelReports/Verbose/' + query.id + '?expand=All', { trackerMsg: 'Loading query access' })
            .then(function(response) {
                var loadedAccess = response.data;
                const args = function () {
                    return {
                        defaultTab: {code: "queryDatabaseAccess"},
                        name: loadedAccess.name,
                        accessLevels: {
                            login: angular.copy(loadedAccess.loginAccessRules),
                            databaseGroup: angular.copy(loadedAccess.databaseGroupAccessRules),
                            database: angular.copy(loadedAccess.databaseAccessRules),
                            role: angular.copy(loadedAccess.roleAccessRules),
                            user: angular.copy(loadedAccess.userAccessRules)
                        }
                    };
                };

                $dialog.editor("reporting/editors/views/query-access-edit.html", "QueryAccessEditCtrl", {args: args})
                    .open()
                    .then(function (result) {
                        if (result && result.isSaved) {
                            loadedAccess.loginAccessRules = angular.copy(result.accessLevels.login);
                            loadedAccess.databaseGroupAccessRules = angular.copy(result.accessLevels.databaseGroup);
                            loadedAccess.databaseAccessRules = angular.copy(result.accessLevels.database);
                            loadedAccess.roleAccessRules = angular.copy(result.accessLevels.role);
                            loadedAccess.userAccessRules = angular.copy(result.accessLevels.user);
                            $http.put('/Reporting/Envision/ExcelReports/Verbose/' + query.id, loadedAccess, { trackerMsg: 'Saving query access' });
                        }
                    })
            });
    };
    $scope.loadQueryScheduler = function (query) {
        QueryBuilderSchedulesModalService.open(query.id, $scope.enableFullQBSchedUi === "True", handleScheduleClicked, generateNewScheduleClickedCallback(query.id), handleScheduleDeleteClicked);
    };

    //INITIALIZE
    $scope.isQueryBuilderCreateNewAndCloneEnabled = false;
    $scope.rightsDataQueryFtp = $oasRights.forCode("DATAQUERYFTP");
    init();
});

'use strict';

app.controller('ReportingEnvisionQueryFavoriteListCtrl', function ReportingEnvisionQueryFavoriteListCtrl($scope, $http, $oasRights, entities, $dialog, $dataQuery, $location) {
    //PRIVATE VARIABLES

    //PRIVATE METHODS
    function init() {
        $http.get('/Reporting/Envision/ExcelReports?type=All&favoritesOnly=true', {trackerMsg: 'Loading queries'})
            .then(function (response) {
                $scope.queryFavorites = response.data;
            });
    }

    //PUBLIC METHODS
    $scope.runFavorite = function(id, queryType){
        switch(queryType) {
            case 'Custom':
                $dialog.dataQueryPrompt(id)
                    .open()
                    .then(function (result) {
                        if (result && result.id) {
                            $dataQuery.setDataQuery(result);
                            $location.path('/reports/dataqueries/' + id);
                        }
                    });

                break;
            case 'Excel':
                $dataQuery.runExcelReport(id);
                break;
        }
    };

    //INITIALIZE
    init();
});
'use strict';

app.controller('ReportingEnvisionSubReportListCtrl', function ReportingEnvisionSubReportListCtrl($scope, $http, $oasRights, entities, $dialog) {
    //PRIVATE VARIABLES
    //const self = this;
    const internal = {
        cache: {},
        list: []
    };

    //PRIVATE METHODS
    function init() {
        $http.get('/Reporting/Envision/Fragments', {trackerMsg: 'Loading sub-reports'})
            .then(function (response) {

                const data = response.data.sortBy('name');

                data.forEach(function (subreport) {
                    if(subreport.isDynamic === null) {
                        subreport.isDynamic = false;
                    }

                    addToList(subreport);
                });

                if(internal.list){
                    $scope.categories = internal.list.sortBy('name');
                    $scope.categories[0].isOpen = true;
                }
            });
    }

    function addToList(subreport) {
        const existingGroup = internal.list.find({ name: subreport.category });

        if (existingGroup) {

            existingGroup.items.push(subreport);
        } 
        else {

            internal.list.push({ 
                name: subreport.category,
                items: [subreport],
                isOpen: false
            });
        }
    }

    //PUBLIC METHODS

    $scope.subreportToggle = function (category) {
        $scope.categories.find({ name: category.name }).isOpen = !category.isOpen;
    };


    //INITIALIZE
    $scope.hasAdvancedEditorRights = $oasRights.canRead("REPORTBUILDERADVANCEDEDITOR");
    init();
});
'use strict';

app.controller('ReportingEnvisionThemeListCtrl', function ReportingEnvisionThemeListCtrl($scope, $http, $dialog, $oasRights) {
    //PRIVATE METHODS
    function init() {
        $http.get('/Reporting/Envision/Themes', {trackerMsg: 'Loading themes'})
            .then(function (response) {
                $scope.themes = response.data;
            });
    }

    //PUBLIC METHODS
    $scope.deleteTheme = function (theme) {
        $dialog.confirmAction("Are you sure you want to delete theme <b>" + theme.name + "</b>?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete('/Reporting/Envision/Themes/Verbose/' + theme.id, {trackerMsg: 'Deleting theme ' + theme.id})
                        .then(function () {
                            $scope.themes.remove({id: theme.id});
                            $scope.deleteBreadcrumb(theme.name);

                        });
                }
            });
    };

    //INITIALIZE
    $scope.rightsReportThemes = $oasRights.forCode("REPORTTHEMERIGHTS");
    init();
});
'use strict';

app.controller('ReportingEnvisionThemeItemCtrl', function ReportingEnvisionThemeItemCtrl($scope, $http, $dialog, $routeParams, $timeout, $location, API_CONFIG, $q, $oasRights) {
    //PRIVATE VARIABLES
    var hasOptions = false;

    //PRIVATE METHODS
    function init() {
        const isNew = $routeParams.id === '0';
        var data = {};

        $http.get('/Reporting/Envision/Themes/Verbose/' + (isNew ? 'New' : ($routeParams.id + '?expand=all')), {trackerMsg: 'Loading report'})
            .then(function (response) {
                data = response.data;
                if ($routeParams.mode === 'copy') {
                    return $http.get('/Reporting/Envision/Themes/Verbose/New', {trackerMsg: 'Loading report'});
                } else {
                    return $q.resolve({data});
                }
            })
            .then(function(response){
                if ($routeParams.mode === 'copy') {
                    const newTheme = response.data ? response.data : response;
                    data.id = null;
                    data.name = 'Copy of ' + data.name;
                    data.canEdit = true;
                    data.canDelete = true;

                    data.loginAccessRules = newTheme.loginAccessRules;
                    data.databaseGroupAccessRules = newTheme.databaseGroupAccessRules;
                    data.databaseAccessRules = newTheme.databaseAccessRules;
                    data.roleAccessRules = newTheme.roleAccessRules;
                    data.userAccessRules = newTheme.userAccessRules;
                }

                //in case save without closing
                $scope.addBreadcrumb(isNew ? 'New Theme' : data.name, `#/reports/reportbuilder3/themes/${data.id}`);
                $scope.theme.id = isNew ? null : data.id;
                $scope.theme.name = data.name;
                $scope.theme.canEdit = data.canEdit;
                $scope.theme.canDelete = data.canDelete;
                $scope.theme.isDefault = data.isDefault;
                $scope.theme.description = data.description;
                $scope.theme.category = data.category;
                //$scope.theme.standardStyle = data.css;
                $scope.theme.importedStyle = data.import;
                $scope.theme.loginAccessRules = data.loginAccessRules;
                $scope.theme.databaseGroupAccessRules = data.databaseGroupAccessRules;
                $scope.theme.databaseAccessRules = data.databaseAccessRules;
                $scope.theme.roleAccessRules = data.roleAccessRules;
                $scope.theme.userAccessRules = data.userAccessRules;
                $scope.theme.loaded = true;
                if(data.options) {
                    $scope.theme.options = data.options;
                    hasOptions = true;
                }

                if (!$scope.theme.options.tableGroupLevels) {
                    $scope.theme.options.tableGroupLevels = 3;
                }
                loadCss(data.css);
                formatPaletteCss();
                formatTableGroupingCss();

                $scope.current.showCharts = true;
            });
    }

    function loadCss(css) {
        const contentModel = $scope.theme.content;
        const re = /[A-Za-z0-9 .\-+:,@#()>]+{/g;
        const results = css.match(re);
        let atContent;

        if (results === null) {
            return;
        }

        //clear the palette, it will be filled back in as we parse the styles
        $scope.theme.palette = [];

        results.forEach(function (style, styleIndex) {
            const search = style.substr(0, style.length - 1);
            var contentBefore = 0;
            results.forEach(function(test, testIndex){
                if (testIndex < styleIndex) {
                    contentBefore += (test.includes(search) && testIndex < styleIndex) ? 1 : 0;
                } else {
                    return false;
                }
            });
            var contentStart = css.indexOf(search) + search.length + 2;
            while(contentBefore > 0) {
                contentStart = css.indexOf(search, contentStart) + search.length + 2;
                contentBefore--;
            }
            const contentEnd = css.indexOf('}', contentStart);
            const content = css.substring(contentStart, contentEnd).trim().split(';');
            for (let i = 0; i < content.length; i++) { //This is a fix for background image urls that are in base64
                if (content[i].includes("url('data:")) {
                    content[i] += (';' + content[i + 1]);
                    content.removeAt(i + 1);
                }
            }
            const styleArray = content.map(function (i) {
                i = i.replace('\n\t', '').trim();
                if (i.length > 0 && !i.startsWith('$$hash-key')) {
                    const stylePair = i.split(':');
                    stylePair[0] = stylePair[0].camelize(false);
                    stylePair[1] = stylePair[1].trim();
                    if (stylePair.length > 2) {
                        for (let j = 2; j < stylePair.length; j++) {
                            stylePair[1] += (':' + stylePair[j].trim());
                        }
                    }
                    return stylePair;
                }
            }).compact();

            if (search.startsWith('.entity:nth-child')) {
                const index = parseInt(search.match(/\(\d+n\+(\d+)\)/)[1]) - 1;
                while (index >= $scope.theme.palette.length) {
                    $scope.theme.palette.add({});
                }
                styleArray.each(function (sa) {
                    $scope.theme.palette[index].fill = sa[1];
                });
            } else if(search.startsWith(".oasTableGrouping")) {
                let styleItem = null;
                let number = parseInt(search.replace(".oasTableGroupingHeader", "").replace(".oasTableGroupingFooter", ""));
                if(number > 3 && (number <= $scope.theme.options.tableGroupLevels || !hasOptions)) {
                    if(!$scope.tableGroupLevels.some(number)) {
                        $scope.tableGroupLevels.add(number);
                        $scope.reverseTableGroupLevels.add(number,0);
                    }
                    contentModel[search.trim()] = {};
                    styleItem = contentModel[search.trim()];
                } else if(number <= $scope.theme.options.tableGroupLevels) {
                    styleItem = contentModel[search.trim()];
                }
                if (styleItem) {
                    styleArray.each(function (sa) {
                        styleItem[sa[0]] = sa[1];
                    });
                }
            } else if (search.startsWith(".highcharts-column-series.highcharts-positive > .highcharts-point.highcharts-negative")){
                styleArray.each(function (sa) {
                    $scope.theme.content['.highcharts-column-series.highcharts-positive > .highcharts-point.highcharts-negative'].fill = sa[1];
                    $scope.theme.content['.highcharts-column-series.highcharts-positive > .highcharts-point.highcharts-negative'].stroke = sa[1];
                });
            } else if (search.startsWith(".highcharts-column-series.highcharts-positive > .highcharts-point:not(.highcharts-negative)")) {
                styleArray.each(function (sa) {
                    $scope.theme.content['.highcharts-column-series.highcharts-positive > .highcharts-point:not(.highcharts-negative)'].fill = sa[1];
                    $scope.theme.content['.highcharts-column-series.highcharts-positive > .highcharts-point:not(.highcharts-negative)'].stroke = sa[1];
                });

            } else if (!search.startsWith('@')) {
                const styleItem = contentModel[search.trim()];
                if (styleItem) {
                    styleArray.each(function (sa) {
                        styleItem[sa[0]] = sa[1];
                    });
                }
            } else if(!search.startsWith('@page') && !search.startsWith('@top')) { //starts with '@'
                const keys = contentModel[search.trim()] ? Object.keys(contentModel[search.trim()]) : [];
                if (keys.length === 1 && keys[0].startsWith('@')) {
                    atContent = contentModel[search.trim()];
                } else if (atContent && atContent[search.trim()]) {
                    const styleItem = atContent[search.trim()];
                    if (styleItem) {
                        styleArray.each(function (sa) {
                            styleItem[sa[0]] = sa[1];
                        });
                    }
                }
            }
        });
        if(($scope.tableGroupLevels.length+3) > $scope.theme.options.tableGroupLevels) {
            $scope.theme.options.tableGroupLevels = ($scope.tableGroupLevels.length+3);
        }
        $scope.tableGroupLevels.sort(function(a, b){return a - b;});
        $scope.reverseTableGroupLevels.sort(function(a, b){return b - a;});
    }

    function formatPaletteCss() {
        $scope.theme.palette.forEach(function (color, index) {
            //this should be the only thing we need for the pallet
            $scope.theme.content['.entity:nth-child(' + $scope.theme.palette.length + 'n+' + (index + 1) + '):not(.highcharts-color) .oasColorBlock'] = {backgroundColor: color.fill};
            $scope.theme.content['.entity .entity:nth-child(' + $scope.theme.palette.length + 'n+' + (index + 1) + '):not(.highcharts-color) .oasColorBlock'] = {backgroundColor: color.fill};
            $scope.theme.content['.entity .entity .entity:nth-child(' + $scope.theme.palette.length + 'n+' + (index + 1) + '):not(.highcharts-color) .oasColorBlock'] = {backgroundColor: color.fill};
            $scope.theme.content['.entity .entity .entity .entity:nth-child(' + $scope.theme.palette.length + 'n+' + (index + 1) + '):not(.highcharts-color) .oasColorBlock'] = {backgroundColor: color.fill};
            $scope.theme.content['.entity .entity .entity .entity .entity:nth-child(' + $scope.theme.palette.length + 'n+' + (index + 1) + '):not(.highcharts-color) .oasColorBlock'] = {backgroundColor: color.fill};
            $scope.theme.content['.entity .entity .entity .entity .entity .entity:nth-child(' + $scope.theme.palette.length + 'n+' + (index + 1) + '):not(.highcharts-color) .oasColorBlock'] = {backgroundColor: color.fill};
            $scope.theme.content['.entity .entity .entity .entity .entity .entity .entity:nth-child(' + $scope.theme.palette.length + 'n+' + (index + 1) + '):not(.highcharts-color) .oasColorBlock'] = {backgroundColor: color.fill};
            $scope.theme.content['.benchmark:nth-child(' + $scope.theme.palette.length + 'n+' + (index + 1) + '):not(.highcharts-color) .oasColorBlock'] = {backgroundColor: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-line-series', '')] = {fill: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-line-series>', '.highcharts-point')] = {fill: color.fill, stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-line-series>', '.highcharts-halo')] = {fill: color.fill, stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-line-series', '>.highcharts-point')] = {fill: color.fill, stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-line-series', '>.highcharts-graph')] = {stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-line-series', ' .highcharts-point')] = {fill: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-line-series', ' .highcharts-graph')] = {stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-pie-series>', '.highcharts-point')] = {fill: color.fill, stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-pie-series>', '.highcharts-halo')] = {fill: color.fill, stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-pie-series>', '.highcharts-data-label-connector')] = {stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-pie-series .highcharts-point', '')] = {fill: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-scatter-series>', '.highcharts-point')] = {fill: color.fill, stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-scatter-series>', '.highcharts-halo')] = {fill: color.fill, stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-scatter-series .highcharts-point', '')] = {fill: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-area-series', '>.highcharts-area')] = {fill: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-area-series', '>.highcharts-graph')] = {stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-column-series>', '.highcharts-point')] = {fill: color.fill, stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-column-series .highcharts-point', '')] = {fill: color.fill, stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-columnrange-series>', '.highcharts-point')] = {fill: color.fill, stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-columnrange-series .highcharts-point', '')] = {fill: color.fill, stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-area-series', '')] = {fill: color.fill, stroke: 'none'};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-label-symbol', '')] = { fill: color.fill, color: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-legend-item.highcharts-pie-series', ' .highcharts-point')] = {fill: color.fill, backgroundColor: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-legend-item.highcharts-column-series', ' .highcharts-point')] = {fill: color.fill, stroke: 'none', backgroundColor: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-legend-item.highcharts-columnrange-series', ' .highcharts-point')] = {fill: color.fill, stroke: 'none', backgroundColor: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-legend-item.highcharts-area-series', ' .highcharts-point')] = {fill: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-legend-item.highcharts-scatter-series', ' .highcharts-point')] = {fill: color.fill, backgroundColor: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-legend-item.highcharts-scatter-series', ' .highcharts-graph')] = {stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-legend-item.highcharts-line-series', ' .highcharts-point')] = {fill: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-legend-item.highcharts-line-series', ' .highcharts-graph')] = {stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-bar-series>', '.highcharts-point')] = {fill: color.fill, stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-bar-series .highcharts-point', '')] = {fill: color.fill, stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-barrange-series>', '.highcharts-point')] = {fill: color.fill, stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-barrange-series .highcharts-point', '')] = {fill: color.fill, stroke: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-legend-item.highcharts-bar-series', ' .highcharts-point')] = {fill: color.fill, stroke: 'none', backgroundColor: color.fill};
            $scope.theme.content[makeHighchartsClassName(index, $scope.theme.palette.length, '.highcharts-legend-item.highcharts-barrange-series', ' .highcharts-point')] = {fill: color.fill, stroke: 'none', backgroundColor: color.fill};
        });
    }

    function formatTableGroupingCss() {
        let remaining = 30 - $scope.theme.options.tableGroupLevels;
        if(remaining > 0) {
            for (var level = $scope.theme.options.tableGroupLevels+1; level <= 30; level++) {
                var groupTableIndex = (level % $scope.theme.options.tableGroupLevels === 0 ? $scope.theme.options.tableGroupLevels : level % $scope.theme.options.tableGroupLevels);

                let groupingCopy = [
                    angular.copy($scope.theme.content[".oasTableGroupingHeader" + groupTableIndex]),
                    angular.copy($scope.theme.content[".oasTableGroupingFooter" + groupTableIndex])
                ];
                $scope.theme.content[".oasTableGroupingHeader" + level] = groupingCopy[0];
                $scope.theme.content[".oasTableGroupingFooter" + level] = groupingCopy[1];
            }
        }
    }

    function makeHighchartsClassName(index, length, selectorPrepend, selectorAppend) {
        let c = selectorPrepend + '.highcharts-color-' + index + selectorAppend;

        for (let i = 1; (i * length) + index < 200; i++) {
            const number = (i * length) + index;
            c += ',\n\t' + selectorPrepend + '.highcharts-color-' + number + selectorAppend;
        }
        return c;
    }

    //PUBLIC METHODS
    $scope.deleteTheme = function () {
        $dialog.confirmAction("Are you sure you want to delete theme <b>" + $scope.theme.name + "</b>?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete('/Reporting/Envision/Themes/Verbose/' + $scope.theme.id, {trackerMsg: 'Deleting theme ' + $scope.theme.name})
                        .then(function () {
                            $scope.deleteBreadcrumb();
                            $location.path('/reports/reportbuilder3/themes').replace();
                        });
                }
            });
    };
    $scope.saveTheme = function (close) {
        if (!$scope.theme.name || $scope.theme.name.trim().length === 0) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Cannot Save Theme", "The theme cannot be saved without a name.  Please add a theme name then try again.").open();
            return;
        } else {
            formatTableGroupingCss();
        }
        validateBarChartColors();
        const args = $scope.theme.id ? {method: "put", id: $scope.theme.id, trackerMsg: "Saving " + $scope.theme.name} : {method: "post", id: "", trackerMsg: "Creating new theme"};
        const content = {
            id: $scope.theme.id,
            name: $scope.theme.name,
            description: $scope.theme.description,
            category: $scope.theme.category,
            css: $scope.theme.standardStyle,
            import: $scope.theme.importedStyle,
            options: $scope.theme.options,
            loginAccessRules: $scope.theme.loginAccessRules,
            databaseGroupAccessRules: $scope.theme.databaseGroupAccessRules,
            databaseAccessRules: $scope.theme.databaseAccessRules,
            roleAccessRules: $scope.theme.roleAccessRules,
            userAccessRules: $scope.theme.userAccessRules,
            isDefault: $scope.theme.isDefault
        };
        $http[args.method]('/Reporting/Envision/Themes/Verbose/' + args.id, content, {trackerMsg: args.trackerMsg})
            .then(function (response) {
                const crumbName = $scope.theme.name;
                if ($scope.theme.id) {
                    $scope.updateBreadcrumb(crumbName);  //in case it changed
                } else {
                    $scope.deleteBreadcrumb();
                    $scope.addBreadcrumb(crumbName, '/reports/reportbuilder3/themes/' + response.data.id);
                    $location.search('');
                    $location.path(`/reports/reportbuilder3/themes/${response.data.id}`);
                }

                //in case save without closing
                const data = response.data;
                $scope.theme.id = data.id;
                $scope.theme.name = data.name;
                $scope.theme.description = data.description;
                $scope.theme.category = data.category;
                $scope.theme.standardStyle = data.css;
                $scope.theme.importedStyle = data.import;
                $scope.theme.options = data.options;
                $scope.theme.loginAccessRules = data.loginAccessRules;
                $scope.theme.databaseGroupAccessRules = data.databaseGroupAccessRules;
                $scope.theme.databaseAccessRules = data.databaseAccessRules;
                $scope.theme.roleAccessRules = data.roleAccessRules;
                $scope.theme.userAccessRules = data.userAccessRules;

                if (close) {
                    $location.path('/reports/reportbuilder3/themes');
                }
            });
    };

    function validateColor(color, defaultColor,className) {
        if (color === "" || color === undefined) {
            $scope.theme.content[`.${className}`].fill = $scope.theme.content[`.${className}`].stroke = "";
            const escapedClassName = className.replace(/[.*+?^=!:${}()|\[\]\/\\]/g, "\\$&");  // Escape special characters
            const regex = new RegExp(`\\.${escapedClassName}\\s*\\{[^}]*fill:\\s*([^;]*);[^}]*stroke:\\s*([^;]*);`, 'g');
            const match = $scope.theme.standardStyle.match(regex);
            if (match && (match[0].includes("fill: ;") || match[0].includes("fill: undefined"))) {
                // If color value is empty, replaces it with the default color
                $scope.theme.standardStyle = $scope.theme.standardStyle.replace(regex, `.${className} {\n\t\tfill: ${defaultColor}; \n\t\tstroke: ${defaultColor};`);
                return defaultColor;
            }
        }
        return color;
    }

    function validateBarChartColors() {
        $scope.theme.content['.highcharts-column-series.highcharts-positive > .highcharts-point:not(.highcharts-negative)'].fill = validateColor($scope.theme.content['.highcharts-column-series.highcharts-positive > .highcharts-point:not(.highcharts-negative)'].fill, "#008000",'highcharts-column-series.highcharts-positive > .highcharts-point:not(.highcharts-negative)');
        $scope.theme.content['.highcharts-column-series.highcharts-positive > .highcharts-point:not(.highcharts-negative)'].stroke = $scope.theme.content['.highcharts-column-series.highcharts-positive > .highcharts-point:not(.highcharts-negative)'].fill;
        $scope.theme.content['.highcharts-column-series.highcharts-positive > .highcharts-point.highcharts-negative'].fill = validateColor($scope.theme.content['.highcharts-column-series.highcharts-positive > .highcharts-point.highcharts-negative'].fill, "#FF0000",'highcharts-column-series.highcharts-positive > .highcharts-point.highcharts-negative');
        $scope.theme.content['.highcharts-column-series.highcharts-positive > .highcharts-point.highcharts-negative'].stroke = $scope.theme.content['.highcharts-column-series.highcharts-positive > .highcharts-point.highcharts-negative'].fill;
    }

    $scope.checkAndRevertToDefault = function (type) {
        if (type === 'positive'){
            $scope.theme.content['.highcharts-column-series.highcharts-positive > .highcharts-point:not(.highcharts-negative)'].stroke = $scope.theme.content['.highcharts-column-series.highcharts-positive > .highcharts-point:not(.highcharts-negative)'].fill;
        } else if (type === 'negative'){
            $scope.theme.content['.highcharts-column-series.highcharts-positive > .highcharts-point.highcharts-negative'].stroke = $scope.theme.content['.highcharts-column-series.highcharts-positive > .highcharts-point.highcharts-negative'].fill;
        }
    };

    $scope.setActivePane = function (tab, accordionPane) {
        $scope.current.tab[tab] = true;

        $timeout(function () {  //in Angular 1.3 this stopped updating in the UI w/o timeout
            $scope.current.pane[tab][accordionPane] = true;
        }, 100);
    };
    $scope.downloadTemplate = function () {
        window.location.href = API_CONFIG.baseUrl + '/Reporting/Envision/Themes/ValidateImport/Template?Authorization=' + sessionStorage.oas_token;
    };

    $scope.editImportedCss = function () {
        $dialog.inputBox('Edit Custom Styles', null, "textarea", {
            required: false,
            templateUrl: "app/modals/codeEditor.html",
            dialogClass: "modal full",
            inputValue: $scope.theme.importedStyle
        })
            .open()
            .then(function (result) {
                if (typeof result === "string") {
                    $scope.theme.importedStyle = result;
                }
            });
    };

    $scope.reportAccess = function () {
        const defaultTab = {code: "reportDatabaseAccess"};
        const d = $dialog.editor("reporting/editors/views/report-access-edit.html", "ReportAccessEditCtrl", {
            args: function () {
                return {
                    defaultTab: defaultTab,
                    name: $scope.theme.name,
                    accessLevels: {
                        login: angular.copy($scope.theme.loginAccessRules),
                        databaseGroup: angular.copy($scope.theme.databaseGroupAccessRules),
                        database: angular.copy($scope.theme.databaseAccessRules),
                        role: angular.copy($scope.theme.roleAccessRules),
                        user: angular.copy($scope.theme.userAccessRules)
                    }
                };
            }
        });

        d.open().then(function (rslt) {
            if (rslt && rslt.isSaved) {
                $scope.theme.loginAccessRules = angular.copy(rslt.accessLevels.login);
                $scope.theme.databaseGroupAccessRules = angular.copy(rslt.accessLevels.databaseGroup);
                $scope.theme.databaseAccessRules = angular.copy(rslt.accessLevels.database);
                $scope.theme.roleAccessRules = angular.copy(rslt.accessLevels.role);
                $scope.theme.userAccessRules = angular.copy(rslt.accessLevels.user);
            }
        });
    };

    $scope.addPaletteColor = function () {
        if ($scope.theme.palette.none(function (color) {return color.fill.toLocaleLowerCase() === $scope.current.newPaletteColor.toLocaleLowerCase();})) {
            $scope.theme.palette.unshift({ fill: $scope.current.newPaletteColor });
        }
        $scope.current.newPaletteColor = null;
    };

    $scope.addGrouping = function () {
        let groupingCopy = [
            angular.copy($scope.theme.content[".oasTableGroupingHeader" + ($scope.tableGroupLevels.length+3)]),
            angular.copy($scope.theme.content[".oasTableGroupingFooter" + ($scope.tableGroupLevels.length+3)])
        ];
        $scope.tableGroupLevels.add(($scope.tableGroupLevels.length+4));
        $scope.reverseTableGroupLevels.add(($scope.reverseTableGroupLevels.length+4),0);
        $scope.theme.content[".oasTableGroupingHeader" + ($scope.tableGroupLevels.length+3)] = groupingCopy[0];
        $scope.theme.content[".oasTableGroupingFooter" + ($scope.tableGroupLevels.length+3)] = groupingCopy[1];
        $scope.theme.options.tableGroupLevels++;
        formatTableGroupingCss();
    };

    $scope.removeGrouping = function () {
        if($scope.tableGroupLevels.length > 0) {
            delete $scope.theme.content[".oasTableGroupingHeader" + ($scope.tableGroupLevels.length+3)];
            delete $scope.theme.content[".oasTableGroupingFooter" + ($scope.tableGroupLevels.length+3)];
            $scope.tableGroupLevels.remove(($scope.tableGroupLevels.length+3));
            $scope.reverseTableGroupLevels.remove(($scope.reverseTableGroupLevels.length+3));
            $scope.theme.options.tableGroupLevels--;
            formatTableGroupingCss();
        }
    };

    //SCOPE WATCHERS
    $scope.$watch("theme.content['.oasHeader,.oasHeader .oasStaticTable>.oasSectionDetail'].textDecoration", function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }
        $scope.theme.content['.oasHeader>div.title'].textDecoration = newValue.toLocaleLowerCase();
    }, true);
    $scope.$watch("theme.palette", function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }
        Object.keys($scope.theme.content).forEach(function (k) {
            if (k.includes('.highcharts-color')) {
                delete $scope.theme.content[k];
            }
        });

        formatPaletteCss();
    }, true);

    //EVENT LISTENERS

    //INITIALIZE
    $scope.theme = {
        id: '', //Guid??
        name: '',
        description: '',
        content: {
            ".oasPageHeader,.oasPageHeader .oasSectionDetail": {
                backgroundColor: "#FFFFFF",
                fontFamily: "Arial",
                fontWeight: "normal",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "8pt",
                color: "#000000",
                borderTopStyle: "none",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "none",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "none",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "none",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px"
            },
            ".oasHeader,.oasHeader .oasSectionDetail": {
                backgroundColor: "#FFFFFF",
                fontFamily: "Arial",
                fontWeight: "normal",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "10pt",
                color: "#000000",
                borderTopStyle: "none",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "none",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "none",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "none",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px",
                padding: "2pt",
                marginBottom: "15px"
            },
            ".oasHeader .oasSectionDetail": {
                border: "none"
            },
            ".oasHeader>div.title": {
                float: 'left',
                textDecoration: "none"
            },
            ".oasPageFooter,.oasPageFooter .oasSectionDetail": {
                backgroundColor: "#FFFFFF",
                fontFamily: "Arial",
                fontWeight: "normal",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "8pt",
                color: "#000000",
                borderTopStyle: "none",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "none",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "none",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "none",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px"
            },
            ".oasSectionTitleBar": {
                backgroundColor: "#E0E0E0",
                fontFamily: "Arial",
                fontWeight: "bold",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "9pt",
                color: "#000000",
                borderTopStyle: "none",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "none",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "none",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "none",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px",
                margin: "0",
                lineHeight: ".25in",
                padding: "2pt 2pt",
                textAlign: "left",
                verticalAlign: "middle"
            },
            ".oasSectionTitleBar button": {
                fontWeight: "bold",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "9pt",
                color: "#000000"
            },
            ".oasSection": {
                borderTopStyle: "solid",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "solid",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "solid",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "solid",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px",
                marginBottom: "15px"
            },
            ".oasSection .rcControl.text": {
                padding: "2px"
            },
            ".oasDisclaimer": {
                fontFamily: "Arial",
                fontWeight: "normal",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "7pt",
                color: "#000000"
            },
            ".oasSectionHeader": {
                backgroundColor: "#FFFFFF",
                fontFamily: "Arial",
                fontWeight: "bold",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "7pt",
                color: "#000000",
                borderTopStyle: "none",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "none",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "none",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "none",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px",
                height: ".2in",
                verticalAlign: "top"
            },
            ".oasSectionFooter": {
                backgroundColor: "#FFFFFF",
                fontFamily: "Arial",
                fontWeight: "bold",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "7pt",
                color: "#000000",
                borderTopStyle: "none",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "none",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "none",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "none",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px",
                height: ".2in",
                verticalAlign: "top"
            },
            ".oasSectionDetail": {
                backgroundColor: "#FFFFFF",
                fontFamily: "Arial",
                fontWeight: "normal",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "7pt",
                color: "#000000",
                borderTopStyle: "none",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "none",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "none",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "none",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px"
            },
            ".oasSectionDetail.alternate": {
                backgroundColor: "#FFFFFF",
                color: "#000000"
            },
            ".oasBenchmarkHeader": {
                backgroundColor: "#FFFFFF",
                fontFamily: "Arial",
                fontWeight: "bold",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "7pt",
                color: "#000000",
                borderTopStyle: "none",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "none",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "none",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "none",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px",
                height: ".2in",
                verticalAlign: "top"
            },
            ".oasBenchmarkFooter": {
                backgroundColor: "#FFFFFF",
                fontFamily: "Arial",
                fontWeight: "bold",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "7pt",
                color: "#000000",
                borderTopStyle: "none",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "none",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "none",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "none",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px",
                height: ".2in",
                verticalAlign: "top"
            },
            ".oasBenchmarkDetail": {
                backgroundColor: "#FFFFFF",
                fontFamily: "Arial",
                fontWeight: "normal",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "7pt",
                color: "#000000",
                borderTopStyle: "none",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "none",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "none",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "none",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px"
            },
            ".oasBenchmarkDetail.alternate": {
                backgroundColor: "#FFFFFF",
                color: "#000000"
            },
            ".highcharts-legend, .highcharts-axis-labels, .highcharts-axis-title": {
                fontFamily: "Arial",
                fontWeight: "normal",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "7pt",
                color: "#000000"
            },
            ".highcharts-data-label-connector": {
                fill: "none"
            },
            ".oasTableGroupingHeader1": {
                backgroundColor: "#999999",
                fontFamily: "Arial",
                fontWeight: "bold",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "8pt",
                color: "#26282B",
                borderTopStyle: "none",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "none",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "none",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "none",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px"
            },
            ".oasTableGroupingFooter1": {
                backgroundColor: "#FFFFFF",
                fontFamily: "Arial",
                fontWeight: "bold",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "7pt",
                color: "#000000",
                borderTopStyle: "none",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "none",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "none",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "none",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px"
            },
            ".oasTableGroupingHeader2": {
                backgroundColor: "#BBBBBB",
                fontFamily: "Arial",
                fontWeight: "bold",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "8pt",
                color: "#333333",
                borderTopStyle: "none",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "none",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "none",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "none",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px"
            },
            ".oasTableGroupingFooter2": {
                backgroundColor: "#FFFFFF",
                fontFamily: "Arial",
                fontWeight: "bold",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "7pt",
                color: "#333333",
                borderTopStyle: "none",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "none",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "none",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "none",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px"
            },
            ".oasTableGroupingHeader3": {
                backgroundColor: "#EEEEEE",
                fontFamily: "Arial",
                fontWeight: "bold",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "8pt",
                color: "#333333",
                borderTopStyle: "none",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "none",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "none",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "none",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px"
            },
            ".oasTableGroupingFooter3": {
                backgroundColor: "#FFFFFF",
                fontFamily: "Arial",
                fontWeight: "bold",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "7pt",
                color: "#333333",
                borderTopStyle: "none",
                borderTopColor: "#EAEAEA",
                borderBottomStyle: "none",
                borderBottomColor: "#EAEAEA",
                borderLeftStyle: "none",
                borderLeftColor: "#EAEAEA",
                borderRightStyle: "none",
                borderRightColor: "#EAEAEA",
                borderWidth: "1px"
            },
            "#tableOfContents h2.tocHeader": {
                backgroundColor: "#FFFFFF",
                fontFamily: "Arial",
                fontWeight: "normal",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "20pt",
                color: "#000000"
            },
            "#tableOfContents ul, #tableOfContents a": {
                fontFamily: "Arial",
                fontWeight: "normal",
                fontStyle: "normal",
                textDecoration: "none",
                fontSize: "7pt",
                color: "#000000"
            },
            ".highcharts-column-series.highcharts-positive > .highcharts-point:not(.highcharts-negative)": {
                fill: "#008000",
                stroke: "#008000"
            },
            ".highcharts-column-series.highcharts-positive > .highcharts-point.highcharts-negative": {
                fill: "#FF0000",
                stroke: "#FF0000"
            },
        },
        palette: [
            {fill: "#008000"},
            {fill: "#0000FF"},
            {fill: "#FF0000"},
            {fill: "#FFA500"},
            {fill: "#00FFFF"},
            {fill: "#008080"},
            {fill: "#FFD700"},
            {fill: "#4169E1"},
            {fill: "#A59D93"},
            {fill: "#B8341B"},
            {fill: "#352F26"},
            {fill: "#F1E7D6"},
            {fill: "#E16C56"},
            {fill: "#CFBA9B"}
        ],
        standardStyle: "",
        importedStyle: "",
        options: { tableGroupLevels: 3 },
        title: {logoAlign: 'right'},
        footer: {image: null},
        loginAccessRules: [],
        databaseGroupAccessRules: [],
        databaseAccessRules: [],
        roleAccessRules: [],
        userAccessRules: []
    };
    $scope.rightSidebar.width = 275;
    $scope.rightSidebar.isOpen = true;
    $scope.current = {
        tab: {page: true},
        pane: {
            page: {general: true, header: false, reportTitle: false, footer: false},
            sections: {
                tableOfContentsHeader: true,
                tableOfContentsDetail: false,
                sectionTitleBar: false,
                disclaimerText: false,
                sectionBorder: false,
                sectionColumnHeader: false,
                sectionColumnFooter: false,
                sectionDetail: false,
                sectionDetail2: false,
                benchmarkHeader: false,
                benchmarkFooter: false,
                benchmarkDetail: false,
                benchmarkDetail2: false
            },
            groupings: {tableGroupingHeader1: true, tableGroupingFooter1: false, tableGroupingHeader2: false, tableGroupingFooter2: false, tableGroupingHeader3: false, tableGroupingFooter3: false},
            charts: {chart: true, colorPalette: false, pieStyle: false}
        },
        charts: {
            assetClassConfig: {
                options: {
                    chart: {type: "pie", height: 134, width: 134, margin: [0, 0, 0, 0]},
                    plotOptions: {pie: {animation: false, showInLegend: false, dataLabels: {enabled: false}}},
                    tooltip: {enabled: false},
                },
                credits: {enabled: false},
                series: [{
                    name: "Asset Class",
                    type: "pie",
                    data: [
                        {name: "ETF", y: 48.77, dataLabels: {enabled: false}, className: "entity assetClass-" + Math.round(Math.random() * 1000)},
                        {name: "Conservative Allocation", y: 29.29, dataLabels: {enabled: false}, className: "entity assetClass-" + Math.round(Math.random() * 1000)},
                        {name: "Money Market Funds", y: 21.94, dataLabels: {enabled: false}, className: "entity assetClass-" + Math.round(Math.random() * 1000)}
                    ],
                }],
                title: {text: null, margin: 0}
            },
            assetCategoryConfig: {
                options: {
                    chart: {type: "pie", height: 134, width: 134, margin: [0, 0, 0, 0]},
                    plotOptions: {pie: {animation: false, showInLegend: false, dataLabels: {enabled: false}}},
                    tooltip: {enabled: false},
                },
                credits: {enabled: false},
                series: [{
                    name: "Asset Category",
                    type: "pie",
                    data: [
                        {name: "Equity", y: 78.06, dataLabels: {enabled: false}, className: "entity assetCategory-" + Math.round(Math.random() * 1000)},
                        {name: "Money Market", y: 21.94, dataLabels: {enabled: false}, className: "entity assetCategory-" + Math.round(Math.random() * 1000)},
                    ],
                }],
                title: {text: null, margin: 0}
            }
        },
        barChart:{
            options: {
                chart: { type: "column"},
                plotOptions: {
                    series: {
                        className: "highcharts-positive",
                        negativeColor: true,
                    },
                    column: {animation: false, showInLegend: false, dataLabels: { enabled: false}}
                },
                tooltip: {enabled: false}
            },
            xAxis: {
                categories: ['Category 1', 'Category 2', 'Category 3'],
                title: { text: 'Categories' }
            },
            yAxis: {
                title: { text: 'Values' },
                min: -30, // Set a minimum to make the negative values visible
            },
            series: [{
                data: [10, -15, 20]
            }],
            title: {text: null, margin: 0},
        },
        newPaletteColor: null,
        showCharts: false
    };
    $scope.tableGroupLevels = [];
    $scope.reverseTableGroupLevels = [];

    $scope.rightsReportThemes = $oasRights.forCode("REPORTTHEMERIGHTS");
    $scope.hasReportThemeCustomStylesRights = $oasRights.canRead("REPORTTHEMECUSTOMSTYLES");
    init();
});

'use strict';

app.component('rcOrionPlanningFinancialPlanEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcOrionPlanningFinancialPlanEditor.html',
    bindings: {
        control: '<',
    },
});

'use strict';

app.component('rcOrionPlanningNetWorthTableEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcOrionPlanningNetWorthTableEditor.html',
    bindings: {
        control: '<',
    },
});

'use strict';

app.component('rcOrionPlanningPldEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcOrionPlanningPldEditor.html',
    bindings: {
        control: '<',
    },
});

'use strict';

app.component('rcOrionPlanningGoalsEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcOrionPlanningGoalsEditor.html',
    bindings: {
        control: '<',
    },
    controller: function () {
        const $ctrl = this;
    }
});

'use strict';
app.component('rcFixedIncomeExpectedIncomeEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcFixedIncomeExpectedIncomeEditor.html',
    bindings: {
        control: '<',
    },
    controller: ['FixedIncomeExpectedIncomeService', 'optionsHelper', function (fixedIncomeExpectedIncomeService, optionsHelper) {
        var $ctrl = this;

        $ctrl.optionsHelper = optionsHelper;

        $ctrl.reportYearOptions = [
            { value: "Current", name: "Current"},
            { value: "NextTwelveMonths", name: "Next 12 Months"},
            { value: "NextSixtyMonths", name: "Next 60 Months"},
            { value: "NextFiveYears", name: "Next 5 Years"}
        ];

        $ctrl.update = function () {
            fixedIncomeExpectedIncomeService.updateChartConfig({
                contextChange: {
                    incomeOptionId: $ctrl.control.contextChange.incomeOptionId,
                    dateRangeId: $ctrl.control.contextChange.dateRangeId,
                    reportCategoryId: $ctrl.control.contextChange.reportCategoryId,
                },
                projectedIncomeOption: {
                    $type: "projected-income",
                    reportYear: $ctrl.control.projectedIncomeOption.reportYear,
                    includeRedemptions: $ctrl.control.projectedIncomeOption.includeRedemptions,
                    includeUnpaidProjected: $ctrl.control.projectedIncomeOption.includeUnpaidProjected
                },
                index: $ctrl.control.$index
            });
        };

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            try {
                if(!$ctrl.control.contextChange) {
                    $ctrl.control.contextChange = { };
                }

                if(!$ctrl.control.projectedIncomeOption)
                {
                    $ctrl.control.projectedIncomeOption = { includeRedemptions: false, includeUnpaidProjected: false, reportYear: "Current" };
                }
                if(!$ctrl.control.projectedIncomeOption.includeRedemptions) {
                    $ctrl.control.projectedIncomeOption.includeRedemptions = false;
                }
                if(!$ctrl.control.projectedIncomeOption.includeUnpaidProjected) {
                    $ctrl.control.projectedIncomeOption.includeUnpaidProjected = false;
                }
                if(!$ctrl.control.projectedIncomeOption.reportYear) {
                    $ctrl.control.projectedIncomeOption.reportYear = "Current";
                }
            } catch (ex) {
                console.log('FixedIncomeExpectedIncomeEditor init err',ex);
            }
        };

        $ctrl.$onChanges = function () {
            if ($ctrl.control.$type !== 'rcFixedIncomeExpectedIncomeEditor') {
                return;
            }
        };
    }]
});
'use strict';

app.component('rcAstroConcentratedTaxBenefitEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcAstroConcentratedTaxBenefitEditor.html',
    bindings: {
        control: '<'
    },
    controller: function (reportHelper, optionsHelper) {
        const $ctrl = this;

        $ctrl.options = reportHelper.getExpandedOptions([
            "ReportCategory",
            "DateRange",
            "CostBasis",
            "Activity",
            "Activity",
            "Performance"
        ]);

        $ctrl.options[3].label = "Beginning Market Value";
        $ctrl.options[4].label = "Ending Market Value";

        function init() {
            if($ctrl.control){
                $ctrl.options.forEach(function(o){
                    switch(o.label){
                        case "Report Category":
                            if($ctrl.control.costBasis) {
                                o.selected = $ctrl.control.costBasis[o.propertyName];
                            }
                            o.setValue = function(option, optionId, guid) {
                                optionsHelper.updateIdAndGuid(option.optionType, $ctrl.control.costBasis, optionId, guid);
                                optionsHelper.updateIdAndGuid(option.optionType, $ctrl.control.beginningMarketValue, optionId, guid);
                                optionsHelper.updateIdAndGuid(option.optionType, $ctrl.control.endingMarketValue, optionId, guid);
                            };
                            break;

                        case "Date Range":
                            if($ctrl.control.costBasis) {
                                o.selected = $ctrl.control.costBasis[o.propertyName];
                            }                            o.setValue = function(option, optionId, guid) {
                                optionsHelper.updateIdAndGuid(option.optionType, $ctrl.control.costBasis, optionId, guid);
                                optionsHelper.updateIdAndGuid(option.optionType, $ctrl.control.beginningMarketValue, optionId, guid);
                                optionsHelper.updateIdAndGuid(option.optionType, $ctrl.control.endingMarketValue, optionId, guid);
                            };
                            break;

                        case "Cost Basis":
                            if($ctrl.control.costBasis) {
                                o.selected = $ctrl.control.costBasis[o.propertyName];
                            }
                            o.setValue = function(option, optionId, guid) {
                                optionsHelper.updateIdAndGuid(option.optionType, $ctrl.control.costBasis, optionId, guid);
                            };
                            break;

                        case "Beginning Market Value":
                            if($ctrl.control.beginningMarketValue) {
                                o.selected = $ctrl.control.beginningMarketValue[o.propertyName];
                            }
                            o.setValue = function(option, optionId, guid) {
                                optionsHelper.updateIdAndGuid(option.optionType, $ctrl.control.beginningMarketValue, optionId, guid);
                            };
                            break;

                        case "Ending Market Value":
                            if($ctrl.control.endingMarketValue) {
                                o.selected = $ctrl.control.endingMarketValue[o.propertyName];
                            }
                            o.setValue = function(option, optionId, guid) {
                                optionsHelper.updateIdAndGuid(option.optionType, $ctrl.control.endingMarketValue, optionId, guid);
                            };
                            break;

                        case "Performance":
                            if($ctrl.control.performance) {
                                o.selected = $ctrl.control.performance[o.propertyName];
                            }
                            o.setValue = function(option, optionId, guid) {
                                optionsHelper.updateIdAndGuid(option.optionType, $ctrl.control.performance, optionId, guid);
                            };
                            break;

                    }
                });
            }
        }

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            init();
        };

        $ctrl.$onChanges = function () {
            init();
        };
    }
});

'use strict';

app.component('rcAstroMarketSectorWeightingsEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcAstroMarketSectorWeightingsEditor.html',
    bindings: {
        control: '<',
    },
});

'use strict';

app.component('rcAstroTaxBenefitEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcAstroTaxBenefitEditor.html',
    bindings: {
        control: '<'
    },
    controller: function (reportHelper, optionsHelper) {
        const $ctrl = this;

        $ctrl.optionsHelper = optionsHelper;

        $ctrl.options = reportHelper.getExpandedOptions([
            "ReportCategory",
            "DateRange",
            "CostBasis",
            "Activity",
            "Activity",
            "Performance"
        ]);

        $ctrl.options[3].label = "Beginning Market Value";
        $ctrl.options[4].label = "Ending Market Value";

        function init() {
            if($ctrl.control){
                $ctrl.options.forEach(function(o){
                    switch(o.label){
                        case "Report Category":
                            o.selected = $ctrl.control.costBasis[o.propertyName];
                            o.setValue = function(optionId){
                                $ctrl.control.costBasis[o.propertyName] = optionId;
                                $ctrl.control.beginningMarketValue[o.propertyName] = optionId;
                                $ctrl.control.endingMarketValue[o.propertyName] = optionId;
                            };
                            break;

                        case "Date Range":
                            o.selected = $ctrl.control.costBasis[o.propertyName];
                            o.setValue = function(optionId, guid){
                                updateGlobalOptionGuid(o, 'date-range', $ctrl.control.costBasis, optionId, guid);
                                updateGlobalOptionGuid(o, 'date-range', $ctrl.control.beginningMarketValue, optionId, guid);
                                updateGlobalOptionGuid(o, 'date-range', $ctrl.control.endingMarketValue, optionId, guid);
                            };
                            break;

                        case "Cost Basis":
                            o.selected = $ctrl.control.costBasis[o.propertyName];
                            o.setValue = function (optionId, guid){
                                updateGlobalOptionGuid(o, 'costbasis', $ctrl.control.costBasis, optionId, guid);
                            };
                            break;

                        case "Beginning Market Value":
                            o.selected = $ctrl.control.beginningMarketValue[o.propertyName];
                            o.setValue = function (optionId, guid){
                                updateGlobalOptionGuid(o, 'activity', $ctrl.control.beginningMarketValue, optionId, guid);
                            };
                            break;

                        case "Ending Market Value":
                            o.selected = $ctrl.control.endingMarketValue[o.propertyName];
                            o.setValue = function (optionId, guid){
                                updateGlobalOptionGuid(o, 'activity', $ctrl.control.endingMarketValue, optionId, guid);
                            };
                            break;

                        case "Performance":
                            o.selected = $ctrl.control.performance[o.propertyName];
                            o.setValue = function (optionId, guid){
                                updateGlobalOptionGuid(o, 'performance', $ctrl.control.performance, optionId, guid);
                            };
                            break;

                    }
                });
            }
        }

        function updateGlobalOptionGuid(option, optionType, control, id, guid) {
            if (!guid) {
                //remove any assigned global options if not using global options
                delete control[option.globalPropertyName];
            }
            $ctrl.optionsHelper.updateIdAndGuid(optionType, control, id, guid);
        }

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            init();
        };

        $ctrl.$onChanges = function () {
            init();
        };
    }
});
'use strict';

app.component('rcAstroProposalEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcAstroProposalEditor.html',
    bindings: {
        control: '<'
    },
    controller: function (reportHelper, optionsHelper) {
        const $ctrl = this;

        $ctrl.optionsHelper = optionsHelper;

        $ctrl.options = reportHelper.getExpandedOptions([
            "ReportCategory",
            "DateRange",
            "CostBasis",
            "Activity",
            "Activity",
            "Performance"
        ]);

        $ctrl.options[3].label = "Beginning Market Value";
        $ctrl.options[4].label = "Ending Market Value";
        
        function init() {
            if($ctrl.control){
                $ctrl.options.forEach(function(o){
                    switch(o.label){
                        case "Report Category":
                            o.selected = $ctrl.control.costBasis[o.propertyName];
                            o.setValue = function(optionId){
                                $ctrl.control.costBasis[o.propertyName] = optionId;
                                $ctrl.control.beginningMarketValue[o.propertyName] = optionId;
                                $ctrl.control.endingMarketValue[o.propertyName] = optionId;
                            };
                            break;

                        case "Date Range":
                            o.selected = $ctrl.control.costBasis[o.propertyName];
                            o.setValue = function (optionId, guid) {
                                updateGlobalOptionGuid(o, 'date-range', $ctrl.control.costBasis, optionId, guid);
                                updateGlobalOptionGuid(o, 'date-range', $ctrl.control.beginningMarketValue, optionId, guid);
                                updateGlobalOptionGuid(o, 'date-range', $ctrl.control.endingMarketValue, optionId, guid);
                            };
                            break;

                        case "Cost Basis":
                            o.selected = $ctrl.control.costBasis[o.propertyName];
                            o.setValue = function (optionId, guid) {
                                updateGlobalOptionGuid(o, 'costbasis', $ctrl.control.costBasis, optionId, guid);
                            };
                            break;

                        case "Beginning Market Value":
                            o.selected = $ctrl.control.beginningMarketValue[o.propertyName];
                            o.setValue = function (optionId, guid) {
                                updateGlobalOptionGuid(o, 'activity', $ctrl.control.beginningMarketValue, optionId, guid);
                            };
                            break;

                        case "Ending Market Value":
                            o.selected = $ctrl.control.endingMarketValue[o.propertyName];
                            o.setValue = function (optionId, guid) {
                                updateGlobalOptionGuid(o, 'activity', $ctrl.control.endingMarketValue, optionId, guid);
                            };
                            break;

                        case "Performance":
                            o.selected = $ctrl.control.performance[o.propertyName];
                            o.setValue = function (optionId, guid) {
                                updateGlobalOptionGuid(o, 'performance', $ctrl.control.performance, optionId, guid);
                            };
                            break;

                    }
                });
            }
        }        

        function updateGlobalOptionGuid(option, optionType, control, id, guid) {
            if (!guid) {
                //remove any assigned global options if not using global options
                delete control[option.globalPropertyName];
            }
            $ctrl.optionsHelper.updateIdAndGuid(optionType, control, id, guid);
        }

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            init();
        };

        $ctrl.$onChanges = function () {
            init();
        };
    }
});
'use strict';

app.component('rcOrionCustomIndexingTargetStrategyDetailsEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcOrionCustomIndexingTargetStrategyDetailsEditor.html',
    bindings: {
        control: '<',
    },
});
'use strict';

app.component('rcRiskalyzeAnalysisChartEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcRiskalyzeAnalysisChartEditor.html',
    bindings: {
        control: '<'
    }
});

'use strict';

app.component('rcRiskalyzeAnalysisDetailEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcRiskalyzeAnalysisDetailEditor.html',
    bindings: {
        control: '<'
    }
});
'use strict';

app.component('rcRiskalyzeRiskNumberEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcRiskalyzeRiskNumberEditor.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        const $ctrl = this;


        //INITIALIZE
        Object.defineProperties($ctrl, {
            height: {
                get: function() {
                    return $ctrl.control.height;
                },
                set: function(value) {
                    const [match, amount, unit] = /(\d+)\s*(px|%)?/i.exec(value) || [];
                    $ctrl.control.height = amount > 0 ? '{1}{2}'.assign(amount, unit || 'px') : null;
                },
                enumerable: true
            },
            width: {
                get: function() {
                    return $ctrl.control.width;
                },
                set: function(value) {
                    const [match, amount, unit] = /(\d+)\s*(px|%)?/i.exec(value) || [];
                    $ctrl.control.width = amount > 0 ? '{1}{2}'.assign(amount, unit || 'px') : null;
                },
                enumerable: true
            }
        });
    }
});
'use strict';

app.component('rcEclipseModelToleranceAnalysisTableEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcEclipseModelToleranceAnalysisTableEditor.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        const $ctrl = this;

        //LIFECYCLE HOOKS
        $ctrl.$onChanges = function () {
            if (!$ctrl.control || $ctrl.control.$type !== "rcEclipseModelToleranceAnalysisTable") {
                return;
            }
            if ($ctrl.control.sortOrder === undefined) {
                $ctrl.control.sortOrder = 'No Sorting';
            }
            if ($ctrl.control.showCashLast === undefined) {
                $ctrl.control.showCashLast = false;
            }
            $ctrl.groupChange();
        };

        //INITIALIZE
        $ctrl.groupingOptions = ['Category', 'Asset Class', 'Sub Class', 'Security Set', 'Ticker'];
        $ctrl.sortOrderOptions = ['No Sorting', 'Alphabetically', 'By Target Percent'];
        $ctrl.relativeDifferenceInfoMessage = "<strong>What is Relative Difference?</strong><br/>The relative difference shows by what percentage the number changed from the original number.";
        $ctrl.grouping2Options = $ctrl.grouping3Options = [];

        $ctrl.groupChange = function () {
            var indexGrp1 = $ctrl.groupingOptions.indexOf($ctrl.control.grouping1);
            if ((indexGrp1 + 1) < $ctrl.groupingOptions.length) {
                $ctrl.grouping2Options = $ctrl.groupingOptions.slice(indexGrp1 + 1);
            }
            else {
                $ctrl.grouping2Options = [];
            }
            var indexGrp2 = $ctrl.groupingOptions.indexOf($ctrl.control.grouping2);
            if (indexGrp2 < 0) {
                $ctrl.control.grouping3 = null;
            }
            if ((indexGrp2 + 1) < $ctrl.groupingOptions.length) {
                $ctrl.grouping3Options = $ctrl.groupingOptions.slice(indexGrp2 + 1);
            }
            else {
                $ctrl.grouping3Options = [];
            }
        }

    }

});
'use strict';

app.component('rcEclipseModelToleranceAnalysisPieChartEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcEclipseModelToleranceAnalysisPieChartEditor.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        const $ctrl = this;

        //LIFECYCLE HOOKS
        $ctrl.$onChanges = function () {
            if($ctrl.control.$type !== "rcEclipseModelToleranceAnalysisPieChart") {
                return;
            }
        };

        //INITIALIZE
        $ctrl.groupingOptions = ['Category', 'Asset Class', 'Sub Class', 'Security Set', 'Ticker'];
    }
});
'use strict';

app.component('rcOrionPlanningActionStepsEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcOrionPlanningActionStepsEditor.html',
    bindings: {
        control: '<',
    },
});

'use strict';

app.component('rcProjectedCashFlowsEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/integrations/rcProjectedCashFlowsEditor.html',
    bindings: {
        control: '<',
    },
    controller: function (rcChartHelper, optionsHelper, ProjectedCashFlowsService) {
        var $ctrl = this;

        $ctrl.optionsHelper = optionsHelper;
        $ctrl.projectedCashFlowsService = ProjectedCashFlowsService;

        $ctrl.formatSettings = {
            showDollarSign: true,
            useThousandsSeparator: true,
            numberOfDecimal: 2
        };

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if (!$ctrl.control.contextChange) {
                $ctrl.control.contextChange = {
                    returnStyle: {
                        basedOn: "Calendar",
                        frequency: "Monthly"
                    }
                };
            }
            if ($ctrl.control.formatSettings) {
                $ctrl.formatSettings = $ctrl.control.formatSettings;
            }
        };

        $ctrl.$onChanges = function () {
            if ($ctrl.control.$type !== "rcProjectedCashFlows")
                return;            
        };

        $ctrl.onDataChange = function () {
            $ctrl.projectedCashFlowsService.updateFormatSettings($ctrl.formatSettings);
        }

        //INITIALIZE
        var commonOptions = Object.select(rcChartHelper, 'groupingOptions');
        angular.extend($ctrl, commonOptions);
    }
});

'use strict';

var externalDataTablePromptsCache = {};

app.component('rcExternalDataTableEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcExternalDataTableEditor.html',
    bindings: {
        control: '<',
    },
    controller: function ($http, $scope, reportHelper) {
        var $ctrl = this;
        var controlRef = null;
        var suppressBindingSync = false;
        var editorReady = false;

        var START_DATE_PROMPT_ALIASES = ['startdate', 'periodstartdate', 'periodstart', 'batchstart'];
        var END_DATE_PROMPT_ALIASES = ['enddate', 'periodenddate', 'periodend', 'batchend'];
        var GROUP_LEVEL_PROMPT_ALIASES = ['fkentityenum', 'entityenum', 'grouplevel', 'groupinglevel', 'fkentity'];

        // Replaced parameters: custom editor UI instead of the generic binding list.
        // Add new entries here (+ template + backend resolver) and binding/summary behavior follows automatically.
        var RESOLVED_PARAMETERS = [
            {
                detect: detectDatePromptPair,
                apply: applyPeriodPromptPair,
                clear: clearPeriodPromptCodes,
                stripBindings: stripPeriodDateBindings,
                isActive: function () {
                    return $ctrl.hasPeriodPromptPair();
                },
                isConfigured: function () {
                    return true;
                },
                isPrompt: function (prompt) {
                    return $ctrl.isPeriodPrompt(prompt);
                },
            },
            {
                detect: detectGroupLevelPrompt,
                apply: applyGroupLevelPrompt,
                clear: clearGroupLevelPrompt,
                stripBindings: stripGroupLevelBindings,
                isActive: function () {
                    return $ctrl.hasGroupLevelPrompt();
                },
                isConfigured: function () {
                    return true;
                },
                isPrompt: function (prompt) {
                    return $ctrl.isGroupLevelPrompt(prompt);
                },
            },
        ];

        $ctrl.sourceTypeOptions = [
            { value: 1, label: 'Orion Query' },
        ];

        $ctrl.prompts = [];
        $ctrl.loadingPrompts = false;
        $ctrl.dynamicGroups = [];
        $ctrl.groupingOptions = reportHelper.getAllGroupingOptions();
        $ctrl.selectedGroupLevelOption = null;

        $ctrl.filterAvailableGroupingOptions = function (groupingOption) {
            return reportHelper.filterGroupingOptionsByAllowedEntityTypes(groupingOption);
        };

        $ctrl.isDataQuerySource = function () {
            return isDataQuerySourceType(getControl());
        };

        $ctrl.hasPeriodPromptPair = function () {
            var control = getControl();
            return !!(control && control.startDatePromptCode && control.endDatePromptCode);
        };

        $ctrl.hasGroupLevelPrompt = function () {
            var control = getControl();
            return !!(control && control.groupLevelPromptCode);
        };

        $ctrl.isPeriodPrompt = function (prompt) {
            var control = getControl();
            if (!$ctrl.hasPeriodPromptPair()) {
                return false;
            }

            return prompt.code === control.startDatePromptCode
                || prompt.code === control.endDatePromptCode;
        };

        $ctrl.isGroupLevelPrompt = function (prompt) {
            var control = getControl();
            return control && prompt.code === control.groupLevelPromptCode;
        };

        $ctrl.getPromptEditorType = function (prompt) {
            if (isBooleanPrompt(prompt)) {
                return 'Boolean';
            }

            return prompt.promptType || 'Text';
        };

        $ctrl.isBooleanPrompt = function (prompt) {
            return isBooleanPrompt(prompt);
        };

        $ctrl.onSourceTypeChange = function () {
            if ($ctrl.control && !isDataQuerySourceType($ctrl.control)) {
                resetControlConfiguration();
            }
        };

        $ctrl.getPromptLabel = function (prompt) {
            return prompt.prompt || prompt.code;
        };

        $ctrl.getParameterBindingValues = function () {
            return ensureParameterBindingValues();
        };

        $ctrl.onBindingChange = function () {
            syncParameterBindingsArray();
        };

        $ctrl.onPeriodChange = function (optionId) {
            var control = getControl();
            if (control) {
                control.periodDateRangeId = optionId || null;
            }

            updateParameterSummary();
        };

        $ctrl.onGroupLevelChange = function () {
            var control = getControl();
            if (!control) {
                return;
            }

            control.groupLevelValue = $ctrl.selectedGroupLevelOption
                ? $ctrl.selectedGroupLevelOption.value
                : null;
            syncParameterBindingsArray();
        };

        $ctrl.$onInit = function () {
            rememberControlReference();
            normalizeControlSourceType();
            ensureControlDefaults();
            reloadPromptsForCurrentSource();

            $scope.$watch(function () {
                return getControl() && getControl().sourceId;
            }, function (sourceId, previousSourceId) {
                if (sourceId === previousSourceId) {
                    return;
                }

                reloadPromptsForSourceId(sourceId);
            });

            $scope.$watch(function () {
                var control = getControl();
                return control && control.parameterBindingValues;
            }, function () {
                if (suppressBindingSync) {
                    return;
                }

                syncParameterBindingsArray();
            }, true);

            editorReady = true;
        };

        $ctrl.$onChanges = function () {
            rememberControlReference();
            normalizeControlSourceType();
            if (editorReady && !$ctrl.prompts.length && !$ctrl.loadingPrompts) {
                reloadPromptsForCurrentSource();
            }
        };

        $ctrl.$onDestroy = function () {
            syncParameterBindingsArray();
        };

        function rememberControlReference() {
            if ($ctrl.control) {
                controlRef = $ctrl.control;
            }
        }

        function getControl() {
            return $ctrl.control || controlRef;
        }

        function isDataQuerySourceType(control) {
            if (!control) {
                return false;
            }

            var sourceType = control.sourceType;
            if (sourceType == 1 || sourceType === 'DataQuery' || sourceType === 'dataQuery') {
                return true;
            }

            // A saved query id with no matching source type is still an Orion Query.
            // The canvas already shows that query; the editor must too.
            return !!control.sourceId && (sourceType == null || sourceType === '');
        }

        function normalizeControlSourceType() {
            var control = getControl();
            if (!isDataQuerySourceType(control) || control.sourceType == 1) {
                return;
            }

            control.sourceType = 1;
        }

        function reloadPromptsForCurrentSource() {
            var control = getControl();
            if (control && control.sourceId && $ctrl.isDataQuerySource()) {
                loadPrompts(control.sourceId);
            }
        }

        function reloadPromptsForSourceId(sourceId) {
            if (sourceId && $ctrl.isDataQuerySource()) {
                loadPrompts(sourceId);
            } else {
                $ctrl.prompts = [];
                clearAllResolvedParameters();
                clearBooleanPromptCodes();
            }
        }

        function getCachedPrompts(sourceId) {
            return externalDataTablePromptsCache[sourceId];
        }

        function setCachedPrompts(sourceId, prompts) {
            externalDataTablePromptsCache[sourceId] = prompts;
        }

        function getBindingPromptCode(binding) {
            return binding && (binding.promptCode || binding.PromptCode);
        }

        function hasParameterValue(value) {
            return value != null && String(value).trim().length > 0;
        }

        function getBindingValue(binding) {
            if (!binding) {
                return '';
            }

            if (binding.value != null) {
                return binding.value;
            }

            return binding.Value != null ? binding.Value : '';
        }

        function ensureControlDefaults() {
            var control = getControl();
            if (!control) {
                return;
            }

            if (!control.parameterBindings) {
                control.parameterBindings = [];
            }

            ensureParameterBindingValues();
        }

        function ensureParameterBindingValues() {
            var control = getControl();
            if (!control) {
                return {};
            }

            if (!control.parameterBindingValues) {
                control.parameterBindingValues = {};
            }

            (control.parameterBindings || []).forEach(function (binding) {
                var promptCode = getBindingPromptCode(binding);
                if (promptCode && control.parameterBindingValues[promptCode] === undefined) {
                    control.parameterBindingValues[promptCode] = getBindingValue(binding);
                }
            });

            return control.parameterBindingValues;
        }

        function initializePromptBindingValues() {
            var values = ensureParameterBindingValues();

            $ctrl.prompts.forEach(function (prompt) {
                if (isResolvedEditorPrompt(prompt)) {
                    return;
                }

                if (values[prompt.code] === undefined) {
                    if (isBooleanPrompt(prompt) && hasParameterValue(prompt.defaultValue)) {
                        values[prompt.code] = normalizeBooleanEditorValue(prompt.defaultValue);
                    } else {
                        values[prompt.code] = '';
                    }
                }
            });
        }

        function normalizeBooleanEditorValue(value) {
            var normalized = String(value == null ? '' : value).trim().toLowerCase();
            if (normalized === '1' || normalized === 'yes' || normalized === 'y' || normalized === 'true' || normalized === 'on') {
                return '1';
            }

            if (normalized === '0' || normalized === 'no' || normalized === 'n' || normalized === 'false' || normalized === 'off') {
                return '0';
            }

            return String(value).trim();
        }

        function isResolvedEditorPrompt(prompt) {
            return RESOLVED_PARAMETERS.some(function (definition) {
                return definition.isPrompt(prompt);
            });
        }

        function applyAllResolvedParameters(prompts) {
            RESOLVED_PARAMETERS.forEach(function (definition) {
                definition.apply(definition.detect(prompts));
            });
        }

        function clearAllResolvedParameters() {
            RESOLVED_PARAMETERS.forEach(function (definition) {
                definition.clear();
            });
        }

        function stripAllResolvedBindings() {
            RESOLVED_PARAMETERS.forEach(function (definition) {
                definition.stripBindings();
            });
        }

        function getActiveResolvedParameters() {
            return RESOLVED_PARAMETERS.filter(function (definition) {
                return definition.isActive();
            });
        }

        function getBindingListPrompts() {
            return $ctrl.prompts.filter(function (prompt) {
                return !isResolvedEditorPrompt(prompt);
            });
        }

        function isBindingListPromptConfigured(prompt) {
            var values = ensureParameterBindingValues();
            var value = values[prompt.code];

            if (isBooleanPrompt(prompt)) {
                return hasParameterValue(normalizeBooleanEditorValue(value));
            }

            return hasParameterValue(value);
        }

        function updateParameterSummary() {
            var control = getControl();
            if (!control) {
                return;
            }

            var bindingListPrompts = getBindingListPrompts();
            var activeResolvedParameters = getActiveResolvedParameters();

            control.totalParameterCount = bindingListPrompts.length + activeResolvedParameters.length;
            control.configuredParameterCount = bindingListPrompts.filter(isBindingListPromptConfigured).length
                + activeResolvedParameters.filter(function (definition) {
                    return definition.isConfigured();
                }).length;
            control.userParameterCount = control.totalParameterCount;
        }

        function findParameterBinding(control, promptCode) {
            return (control.parameterBindings || []).find(function (binding) {
                var bindingPromptCode = getBindingPromptCode(binding);
                return bindingPromptCode && promptCode
                    && bindingPromptCode.toLowerCase() === promptCode.toLowerCase();
            });
        }

        function setBindingPromptValue(binding, promptCode, value) {
            if (binding.PromptCode != null && binding.promptCode == null) {
                binding.PromptCode = promptCode;
                binding.Value = value;
                return;
            }

            binding.promptCode = promptCode;
            binding.value = value;
        }

        function upsertParameterBinding(control, promptCode, value) {
            if (!control.parameterBindings) {
                control.parameterBindings = [];
            }

            var existing = findParameterBinding(control, promptCode);
            if (existing) {
                setBindingPromptValue(existing, promptCode, value);
                return;
            }

            control.parameterBindings.push({ promptCode: promptCode, value: value });
        }

        function removeParameterBinding(control, promptCode) {
            var bindings = control.parameterBindings;
            if (!bindings) {
                return;
            }

            for (var i = bindings.length - 1; i >= 0; i--) {
                var bindingPromptCode = getBindingPromptCode(bindings[i]);
                if (bindingPromptCode && promptCode
                    && bindingPromptCode.toLowerCase() === promptCode.toLowerCase()) {
                    bindings.splice(i, 1);
                }
            }
        }

        function syncParameterBindingsArray() {
            var control = getControl();
            if (!control || !$ctrl.prompts.length) {
                return;
            }

            var values = ensureParameterBindingValues();

            $ctrl.prompts.forEach(function (prompt) {
                if (isResolvedEditorPrompt(prompt)) {
                    return;
                }

                var trimmedValue = String(values[prompt.code] == null ? '' : values[prompt.code]).trim();
                if (isBooleanPrompt(prompt)) {
                    trimmedValue = normalizeBooleanEditorValue(trimmedValue);
                    values[prompt.code] = trimmedValue;
                }

                if (hasParameterValue(trimmedValue)) {
                    upsertParameterBinding(control, prompt.code, trimmedValue);
                } else {
                    removeParameterBinding(control, prompt.code);
                }
            });

            updateParameterSummary();
        }

        function resetControlConfiguration() {
            var control = getControl();
            if (!control) {
                return;
            }

            control.sourceId = null;
            control.dataQueryName = null;
            control.parameterBindings = [];
            control.parameterBindingValues = {};
            control.totalParameterCount = 0;
            control.configuredParameterCount = 0;
            control.userParameterCount = 0;
            $ctrl.prompts = [];
            clearAllResolvedParameters();
            clearBooleanPromptCodes();
        }

        function clearPeriodPromptCodes() {
            var control = getControl();
            if (!control) {
                return;
            }

            control.startDatePromptCode = null;
            control.endDatePromptCode = null;
            control.periodDateRangeId = null;
        }

        function clearGroupLevelPrompt() {
            var control = getControl();
            if (!control) {
                return;
            }

            control.groupLevelPromptCode = null;
            control.groupLevelValue = null;
            $ctrl.selectedGroupLevelOption = null;
        }

        function clearBooleanPromptCodes() {
            var control = getControl();
            if (!control) {
                return;
            }

            control.booleanPromptCodes = [];
        }

        function normalizePromptCode(code) {
            return (code || '').toLowerCase().replace(/[^a-z0-9]/g, '');
        }

        function hasZeroOnePair(description, zeroLabels, oneLabels) {
            var hasZero = zeroLabels.some(function (label) {
                return new RegExp('\\b0\\s*=\\s*' + label + '\\b').test(description);
            });
            var hasOne = oneLabels.some(function (label) {
                return new RegExp('\\b1\\s*=\\s*' + label + '\\b').test(description);
            });

            return hasZero && hasOne;
        }

        function isBooleanPrompt(prompt) {
            if (!prompt) {
                return false;
            }

            var description = (prompt.promptDescription || prompt.prompt || '').toLowerCase();

            if (hasZeroOnePair(description, ['no', 'false', 'off'], ['yes', 'true', 'on'])) {
                return true;
            }

            if (/\b(yes|no|true|false|on|off)\s*\/\s*(yes|no|true|false|on|off)\b/.test(description)) {
                return true;
            }

            if (/\bbit\b/.test(description) && /\b[01]\s*=/.test(description)) {
                return true;
            }

            return false;
        }

        function syncBooleanPromptCodes() {
            var control = getControl();
            if (!control) {
                return;
            }

            control.booleanPromptCodes = $ctrl.prompts
                .filter(function (prompt) {
                    return isBooleanPrompt(prompt) && !isResolvedEditorPrompt(prompt);
                })
                .map(function (prompt) {
                    return prompt.code;
                });
        }

        function detectDatePromptPair(prompts) {
            var datePrompts = prompts.filter(function (prompt) { return prompt.promptType === 'Date'; });
            var startPrompt = datePrompts.find(function (prompt) {
                return START_DATE_PROMPT_ALIASES.indexOf(normalizePromptCode(prompt.code)) >= 0;
            });
            var endPrompt = datePrompts.find(function (prompt) {
                return END_DATE_PROMPT_ALIASES.indexOf(normalizePromptCode(prompt.code)) >= 0;
            });

            if (!startPrompt || !endPrompt || startPrompt.code === endPrompt.code) {
                return null;
            }

            return {
                startDatePromptCode: startPrompt.code,
                endDatePromptCode: endPrompt.code,
            };
        }

        function applyPeriodPromptPair(pair) {
            var control = getControl();
            if (!control) {
                return;
            }

            if (pair) {
                control.startDatePromptCode = pair.startDatePromptCode;
                control.endDatePromptCode = pair.endDatePromptCode;

                if (control.periodDateRangeId === undefined) {
                    control.periodDateRangeId = null;
                }
            } else {
                clearPeriodPromptCodes();
            }

            stripPeriodDateBindings();
        }

        function detectGroupLevelPrompt(prompts) {
            for (var i = 0; i < prompts.length; i++) {
                var prompt = prompts[i];
                var normalizedCode = normalizePromptCode(prompt.code);
                if (GROUP_LEVEL_PROMPT_ALIASES.indexOf(normalizedCode) >= 0) {
                    return prompt;
                }

                var normalizedPrompt = normalizePromptCode(prompt.prompt || '');
                if (normalizedPrompt.indexOf('grouplevel') >= 0
                    || normalizedPrompt.indexOf('entityenum') >= 0
                    || normalizedPrompt.indexOf('fkentityenum') >= 0) {
                    return prompt;
                }
            }

            return null;
        }

        function applyGroupLevelPrompt(prompt) {
            var control = getControl();
            if (!control) {
                return;
            }

            if (prompt) {
                control.groupLevelPromptCode = prompt.code;
                if (control.groupLevelValue === undefined) {
                    control.groupLevelValue = null;
                }

                migrateGroupLevelFromBindings();
            } else {
                clearGroupLevelPrompt();
            }

            stripGroupLevelBindings();
            syncGroupLevelSelectionFromControl();
        }

        function migrateGroupLevelFromBindings() {
            var control = getControl();
            if (!control || !control.groupLevelPromptCode || control.groupLevelValue != null) {
                return;
            }

            var values = control.parameterBindingValues || {};
            var fromValues = values[control.groupLevelPromptCode];
            if (hasParameterValue(fromValues)) {
                control.groupLevelValue = parseInt(fromValues, 10);
                if (isNaN(control.groupLevelValue)) {
                    control.groupLevelValue = null;
                }
            } else {
                var binding = (control.parameterBindings || []).find(function (item) {
                    return getBindingPromptCode(item) === control.groupLevelPromptCode;
                });

                if (binding && hasParameterValue(getBindingValue(binding))) {
                    control.groupLevelValue = parseInt(getBindingValue(binding), 10);
                    if (isNaN(control.groupLevelValue)) {
                        control.groupLevelValue = null;
                    }
                }
            }
        }

        function syncGroupLevelSelectionFromControl() {
            var control = getControl();
            if (!control || !control.groupLevelPromptCode || control.groupLevelValue == null) {
                $ctrl.selectedGroupLevelOption = null;
                return;
            }

            $ctrl.selectedGroupLevelOption = reportHelper.findGroupingOptionByValue(control.groupLevelValue) || null;
        }

        function stripGroupLevelBindings() {
            var control = getControl();
            if (!control || !$ctrl.hasGroupLevelPrompt()) {
                return;
            }

            var excludedCode = control.groupLevelPromptCode.toLowerCase();

            control.parameterBindings = (control.parameterBindings || []).filter(function (binding) {
                var bindingPromptCode = getBindingPromptCode(binding);
                return bindingPromptCode && bindingPromptCode.toLowerCase() !== excludedCode;
            });

            if (control.parameterBindingValues) {
                delete control.parameterBindingValues[control.groupLevelPromptCode];
            }
        }

        function stripPeriodDateBindings() {
            var control = getControl();
            if (!control || !$ctrl.hasPeriodPromptPair()) {
                return;
            }

            var excludedCodes = [
                control.startDatePromptCode.toLowerCase(),
                control.endDatePromptCode.toLowerCase(),
            ];

            control.parameterBindings = (control.parameterBindings || []).filter(function (binding) {
                var bindingPromptCode = getBindingPromptCode(binding);
                return bindingPromptCode && excludedCodes.indexOf(bindingPromptCode.toLowerCase()) < 0;
            });

            if (control.parameterBindingValues) {
                delete control.parameterBindingValues[control.startDatePromptCode];
                delete control.parameterBindingValues[control.endDatePromptCode];
            }
        }

        function loadPrompts(sourceId, forceReload) {
            var queryId = parseInt(sourceId, 10);
            if (!queryId) {
                $ctrl.prompts = [];
                clearAllResolvedParameters();
                clearBooleanPromptCodes();
                return;
            }

            var cachedPrompts = !forceReload ? getCachedPrompts(sourceId) : null;
            if (cachedPrompts) {
                applyLoadedPrompts(cachedPrompts);
                return;
            }

            $ctrl.loadingPrompts = true;
            $http.get('/Reporting/Custom/' + queryId, { trackerMsg: 'Loading data query parameters' })
                .then(function (response) {
                    var prompts = (response.data.prompts || [])
                        .filter(function (prompt) { return prompt.isPromptUser; })
                        .sort(function (a, b) { return a.sortOrder - b.sortOrder; });
                    setCachedPrompts(sourceId, prompts);
                    applyLoadedPrompts(prompts);
                })
                .finally(function () {
                    $ctrl.loadingPrompts = false;
                });
        }

        function applyLoadedPrompts(prompts) {
            suppressBindingSync = true;
            $ctrl.prompts = prompts;
            applyAllResolvedParameters($ctrl.prompts);
            syncBooleanPromptCodes();
            updateParameterSummary();
            removeStaleBindings();
            initializePromptBindingValues();
            syncParameterBindingsArray();
            suppressBindingSync = false;
        }

        function loadDynamicGroupsIfNeeded() {
            if (!$ctrl.prompts.some(function (prompt) { return prompt.promptType === 'Dynamic Group'; })) {
                $ctrl.dynamicGroups = [];
                return;
            }

            $http.get('/Utility/Groupings/Simple?usedFor=Reporting', { trackerMsg: 'Loading dynamic groups' })
                .then(function (response) {
                    $ctrl.dynamicGroups = [{ id: '0', name: 'All Dynamic Groups' }]
                        .concat((response.data || []).sort(function (a, b) { return a.name.localeCompare(b.name); }));
                });
        }

        function removeStaleBindings() {
            var control = getControl();
            if (!control) {
                return;
            }

            var promptCodes = {};
            $ctrl.prompts.forEach(function (prompt) {
                if (!isResolvedEditorPrompt(prompt)) {
                    promptCodes[prompt.code] = true;
                }
            });

            control.parameterBindings = (control.parameterBindings || []).filter(function (binding) {
                var bindingPromptCode = getBindingPromptCode(binding);
                return bindingPromptCode && promptCodes[bindingPromptCode];
            });

            if (control.parameterBindingValues) {
                Object.keys(control.parameterBindingValues).forEach(function (promptCode) {
                    if (!promptCodes[promptCode]) {
                        delete control.parameterBindingValues[promptCode];
                    }
                });
            }

            stripAllResolvedBindings();
        }
    },
});

'use strict';

app.component('rcBlendedBenchmarkTableEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcBlendedBenchmarkTableEditor.html',
    bindings: {
        control: '<',
    },
    controller: function (reportHelper, optionsHelper) {
        const $ctrl = this;

        $ctrl.optionsHelper = optionsHelper;

        $ctrl.options = reportHelper.getExpandedOptions([
            'DateRange',
        ]);

        function init() {
            if ($ctrl.control.$type !== 'rcBlendedBenchmarkTable') {
                return;
            }


            if ($ctrl.control) {
                $ctrl.options.filter(o => o.label === 'Date Range').forEach(function(o) {
                    if (!$ctrl.control.dateRange) {
                        $ctrl.control.dateRange = {};
                    }

                    o.selected = $ctrl.control.dateRange[o.propertyName];
                });
            }
        }

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function() {
            init();
        };

        $ctrl.$onChanges = function() {
            init();
        };
    },
});

'use strict';

app.component('rcColumnGroupingTableEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcColumnGroupingTableEditor.html',
    bindings: {
        control: '<'
    },
    controller: function (rcChartHelper, $scope, reportHelper, optionsHelper) {
        var $ctrl = this;
        const controlType = "rcColumnGroupingTable";

        //INITIALIZE
        var commonOptions = Object.select(rcChartHelper, 'groupingOptions', 'frequencyOptions', 'basedOnOptions');
        angular.extend($ctrl, commonOptions);

        $ctrl.optionsHelper = optionsHelper;

        $ctrl.groupingLabel = function (grouping) {
            if (!grouping) {
                return '';
            }

            return reportHelper.getGroupingDisplayName(grouping) || grouping.name || grouping.value || '';
        };

        $ctrl.$onInit = function () {
            reportHelper.setGroupingOptionNameAndValue($ctrl.control.columnGrouping);
            ($ctrl.control.rowGroupings || []).forEach(function (rowGrouping) {
                reportHelper.setGroupingOptionNameAndValue(rowGrouping);
            });
            $scope.$on(reportHelper.GetDefaultOptionEvent, function (event, data) {
                event.stopPropagation();

                if ($ctrl.control.$type !== controlType) {
                    return;
                }

                var scope = event.targetScope;
                do {
                    if (scope.grouping || scope === event.currentScope) break;
                } while (scope && (scope = scope.$parent));

                var rowGroupings = [];
                $ctrl.control.rowGroupings.some(function (rowGrouping) {
                    if (scope.grouping === rowGrouping) return true;
                    rowGroupings.push(rowGrouping);
                });

                //need to put these in reverse order so the fourth row grouping inherits from the 3rd, then 2nd, then 1st row groupings.
                for (var i = rowGroupings.length - 1; i >= 0; i--) {
                    data.path.push(rowGroupings[i]);
                }

                data.path.push($ctrl.control.columnGrouping);

                if ($ctrl.control.$emit)
                    $ctrl.control.$emit("rb-event:get-default-option", data);
            });
        };

        $ctrl.$onChanges = function () {
            if ($ctrl.control.$type !== controlType) {
                return;
            }

            $scope.$broadcast("rcContextOptionList-refreshList");
        };

        $ctrl.hasAncestor = function (rowGrouping, value) {
            for (var i = $ctrl.control.rowGroupings.indexOf(rowGrouping); i >= 0; i--) {
                const grouping = $ctrl.control.rowGroupings[i];
                if (grouping.value == value || $ctrl.groupingLabel(grouping) == value) return true;
            }
            return false;
        };

        $ctrl.valueSet = function (v) {
            return Number.isInteger(v);
        };
    }
});
'use strict';

app.component('rcEditorWrapper', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcEditorWrapper.html',
    bindings: {
        control: '<',
    },
    controller: function($scope, reportHelper) {
        const $ctrl = this;

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function() {
            $scope.$on(reportHelper.GetDefaultOptionEvent, function(event, data) {
                event.stopPropagation();
                if ($ctrl.control) {
                    $ctrl.control.$emit('rb-event:get-default-option', data);
                }
            });
        };
    },
});
'use strict';

app.component('rcGroupingActivityLineEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcGroupingActivityLineEditor.html',
    bindings: {
        control: '<'
    },
    controller: function (reportHelper, rcChartHelper, resolveHelper, $timeout, $scope, $rootScope, optionsHelper) {
        var $ctrl = this;
        $scope.canEditCumulative = false;
        $ctrl.optionsHelper = optionsHelper;

        var contextItems = ['DateRange', 'Activity', 'Performance', 'Trading'];
        var allowCumulativeDataSources = ['Performance.Drawdown', 'Benchmark.Drawdown', 'Performance.PerformanceBenchmarkDrawdown'];
        var preFillControlState = null;

        $scope.$watch(() => $ctrl.control, function(newValue, oldValue)  {
            if($ctrl.control.$type !== "rcGroupingActivityLine") {
                return;
            }
            $rootScope.$broadcast('reloadLineChart');
        }, true);

        Object.defineProperties($ctrl, {
            useFill: {
                get: function() { return !!$ctrl.control.fillContextChange; },
                set: function(value) { setFill(value); }
            },
            includeIntervalBars: {
                get: function() { return !!$ctrl.control.includeIntervalBars; },
                set: function(value) { setIntervalBars(value); }
            },
            xAxisLabelOrientation: {
                get: function() { return $ctrl.control.xAxisLabelOrientation; },
                set: function(value) { $ctrl.control.xAxisLabelOrientation = value; }
            }
        });

        //PRIVATE METHODS
        function getNetIncomeId(){
            reportHelper.getOptions('activity')
                .then(function (activtyOptions) {
                    var opt = activtyOptions.find({name: 'Net Amount Invested'});
                    if (opt) {
                        $ctrl.netIncomeId = opt.optionId;
                    }
                });
        }

        function setFill(useFill, options) {
            options = options || {};
            if (useFill) {
                if (!$ctrl.control.fillContextChange) {
                    preFillControlState = angular.copy(Object.select($ctrl.control, 'grouping', 'dataSource', 'chartType', 'stacking', 'limitMethod', 'cumulative'));
                    if ($ctrl.netIncomeId) {
                        $ctrl.control.fillContextChange = {activityOptionId: $ctrl.netIncomeId};
                    } else {
                        $ctrl.control.fillContextChange = {activityOptionId: null};
                    }
                    $ctrl.control.grouping = 'Self';
                    $ctrl.control.dataSource.path = 'Activity.Value';
                    $ctrl.selectedDataSource = resolveHelper.findResolveOption( $ctrl.control.dataSource );
                    updateContextValues();
                    $ctrl.control.chartType = 'Line';
                    $ctrl.control.stacking = 'Normal';
                }
            } else {
                delete $ctrl.control.fillContextChange;
                if (preFillControlState) {
                    var grouping = $ctrl.control.grouping;
                    angular.extend($ctrl.control, preFillControlState);
                    if (options.preserveGrouping) {
                        $ctrl.control.grouping = grouping;
                    }
                    reportHelper.setGroupingValuesForCharts($ctrl.control);
                    $ctrl.selectedDataSource = resolveHelper.findResolveOption($ctrl.control.dataSource);
                    if (!options.skipContextUpdate) {
                        updateContextValues();
                    }
                    preFillControlState = null;
                }
            }
        }
        function setIntervalBars(useIntervalBars) {
            if (useIntervalBars) {
                $ctrl.control.includeIntervalBars = useIntervalBars;
            } else {
                delete $ctrl.control.includeIntervalBars;
            }
        }

        function stackingValidation(){
            if( $ctrl.control.chartType === 'Line'){
                $ctrl.control.stacking = 'Normal';
            }
        }

        function updateContextValues() {
            var unused = contextItems.exclude(function(c){
                return $ctrl.selectedDataSource.options?.some(c);
            });
            unused.forEach(function(u){
                switch(u) {
                    case 'DateRange':
                        optionsHelper.removeIdAndGuidByType('date-range', $ctrl.control.dataSource);
                        break;
                    case 'Activity':
                        optionsHelper.removeIdAndGuidByType('activity', $ctrl.control.dataSource);
                        break;
                    case 'Performance':
                        optionsHelper.removeIdAndGuidByType('performance', $ctrl.control.dataSource);
                        break;
                    case 'Trading':
                        optionsHelper.removeIdAndGuidByType('trading', $ctrl.control.dataSource);
                        break;
                }
            });

            $timeout(function(){
                checkPerformanceFilter();
            }, 500);

            handleCumulative();
            
            $ctrl.control.dataSource.label = $ctrl.selectedDataSource.label;
            $ctrl.control.dataSource.path = $ctrl.selectedDataSource.path;
            if($ctrl.selectedDataSource.$type === 'option-value') {
                optionsHelper.syncChartDataSourceActivityOption($ctrl.selectedDataSource, $ctrl.control.dataSource);
            }
            defaultGroupName();
            defaultBarGroupName();                       
        }

        function handleCumulative() {
            $scope.canEditCumulative = allowCumulativeDataSources.includes($ctrl.selectedDataSource.path);
            if ($ctrl.control.dataSource.path !== $ctrl.selectedDataSource.path) {
                // data source changed
                $ctrl.control.cumulative = !$scope.canEditCumulative; // default value unchecked for editable cumulative sources
            }
        }

        function checkPerformanceFilter(){
            if($ctrl.selectedDataSource.path === 'Performance.Value'&&
                reportHelper.groupingMatchesName($ctrl.control, 'Time')){
                reportHelper.$broadcast("rb-event:filter-performance-context", true);
            } else {
                reportHelper.$broadcast("rb-event:filter-performance-context", false);
            }
        }

        function defaultGroupName(){
            if(!$ctrl.control.groupName){
                const newGroupName = {
                    $type: 'rcStringResolver',
                    value: '[@{"path":"Group.Name","displayText":"Group Name"}@]'
                };
                $ctrl.control.groupName = newGroupName;
            }
        };

        function defaultBarGroupName(){
            if(!$ctrl.control.barGroupName){
                const newGroupName = {
                    $type: 'rcStringResolver',
                    value: '[@{"path":"Group.Name","displayText":"Group Name"}@]'
                };
                $ctrl.control.barGroupName = newGroupName;
            }
        };

        //PUBLIC METHODS
        $ctrl.groupingMatches = function (name) {
            return reportHelper.groupingMatchesName($ctrl.control, name);
        };

        $ctrl.frequencyChange = function () {
            if ($ctrl.control.frequency === 'Daily') {
                $ctrl.control.cumulative = true;
            }
        }

        $ctrl.groupingChange = function(){
            reportHelper.applyAdHocChartGroupingSelection($ctrl.control, $ctrl.control.groupingOption);
            reportHelper.applyUserDefinedFieldGroupingMetadata($ctrl.control, $ctrl.control.groupingOption);

            if(reportHelper.groupingMatchesName($ctrl.control, 'Self')){
                $ctrl.control.chartType = 'Line';
            } else {
                setFill(false, { preserveGrouping: true, skipContextUpdate: true });
            }

            stackingValidation();
            updateContextValues();
        };        

        $ctrl.updateChartType = function(){
            stackingValidation();
        };

        $ctrl.getOptions = function(name){
            return $ctrl.resolveOptions.filter(function(ro){
                if(angular.isString(name) && name.length > 0 && !ro.label.has(new RegExp(name, 'i'))) return false;
                return reportHelper.filterStaticTagConfigsByAllowedEntityTypes(ro, $ctrl.control.dataSource.path) && ro.types.some('Set') && ro.allowedLocations.some('LineChart');
            });
        };

        $ctrl.loadSelectedDataSource = function(ds) {
            $ctrl.selectedDataSource = ds;
            if($ctrl.control.dataSource.path !== 'Activity.Value') setFill(false, { skipContextUpdate: true });
            if($ctrl.selectedDataSource.$type === 'currency-growth-of') $ctrl.control.dataSource.format = "$#,##0.00|1000";
            updateContextValues();
        };

        $ctrl.updateActivitySelection = function(optionId, guid) {
            if (optionsHelper.activitySelectionMatches($ctrl.control.dataSource, optionId, guid)) {
                return;
            }

            optionsHelper.updateIdAndGuid('activity', $ctrl.control.dataSource, optionId, guid);
            updateContextValues();
        };

        $ctrl.filterAvailableGroupingOptions = function(groupingOption) {
            return reportHelper.filterGroupingOptionsByAllowedEntityTypes(groupingOption, [$ctrl.control.grouping]);
        };

        //LIFECYCLE HOOKS
        $ctrl.$onChanges = function () {
            if($ctrl.control.$type !== "rcGroupingActivityLine")
                return;
            if(!$ctrl.control.xAxisLabelOrientation) {
                $ctrl.control.xAxisLabelOrientation = { orientation: 'Auto' };
            }
            getNetIncomeId();
            $ctrl.control.config.options.legend = rcChartHelper.getLegendOption($ctrl.control.config.options.legend);

            if(!$ctrl.control.dataSource)
                $ctrl.control.dataSource = { path: 'Activity.Value' };
            $ctrl.selectedDataSource = resolveHelper.findResolveOption($ctrl.control.dataSource);
            reportHelper.resolveChartGroupingOption($ctrl.control, $ctrl.groupingOptions);
            updateContextValues();

            if (allowCumulativeDataSources.includes($ctrl.control.dataSource.path)) {
                $scope.canEditCumulative = true;
            }
        };

        $ctrl.$onInit = function () {
            if (allowCumulativeDataSources.includes($ctrl.control.dataSource.path)) {
                $scope.canEditCumulative = true;
            }

            $timeout(function(){
                checkPerformanceFilter();
            }, 500);
        };

        //INITIALIZE
        $ctrl.selectedOption = null;
        var commonOptions = Object.select(rcChartHelper, 'dataLabelOptions', 'legendOptions', 'dataSourceOptions', 'frequencyOptions', 'yAxisLocationOptions', 'labelOrientationSettings', 'limitOptions');
        angular.extend($ctrl, commonOptions);
        $ctrl.resolveOptions = resolveHelper.options;
        $ctrl.groupingOptions = reportHelper.getAllGroupingOptions();

        $ctrl.chartTypeOptions = [
            {name: 'Line', value: 'Line'},
            {name: 'Stacked', value: 'Area'}
        ];

        $ctrl.chartStackingOptions = [
            'Normal', 'Percent'
        ];

        $ctrl.yAxisLocationOptions = [
            {name: 'Left', value: 'Default'}, {name: 'Right', value: 'Opposite'}, {name: 'Both', value: 'Both'}
        ];

        function refreshGroupingOptions() {
            if (!$ctrl.control || $ctrl.control.$type !== 'rcGroupingActivityLine') {
                return;
            }

            $ctrl.groupingOptions = reportHelper.getAllGroupingOptions();
            reportHelper.resolveChartGroupingOption($ctrl.control, $ctrl.groupingOptions);
        }

        $scope.$on('rb-event:ad-hoc-settings-changed', refreshGroupingOptions);

        $scope.$on('rc-event:load-selected-datasource', function (event, data) {
            const resolveOption = $ctrl.resolveOptions.find(function (ro) { return ro.$key === data.key; });
            if (resolveOption) {
                $ctrl.loadSelectedDataSource(resolveOption);
            }
        });
    }
});
'use strict';

app.component('rcGroupingActivityDonutEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcGroupingActivityDonutEditor.html',
    bindings: {
        control: '<'
    },
    controller: function (rcChartHelper, resolveHelper, $scope, $rootScope, optionsHelper, reportHelper) {
        var $ctrl = this;
        var contextItems = ['DateRange','Activity','Performance','Trading'];

        $ctrl.optionsHelper = optionsHelper;

        const donutGrouping1Fields = {
            grouping: 'grouping1',
            groupingLabel: 'groupingLabel1',
            groupingOption: 'groupingOption1',
        };
        const donutGrouping2Fields = {
            grouping: 'grouping2',
            groupingLabel: 'groupingLabel2',
            groupingOption: 'groupingOption2',
        };
        const donutGrouping3Fields = {
            grouping: 'grouping3',
            groupingLabel: 'groupingLabel3',
            groupingOption: 'groupingOption3',
        };

        function refreshGroupingOptions() {
            if (!$ctrl.control) {
                return;
            }

            $ctrl.groupingOptions = reportHelper.getAllGroupingOptions();
            reportHelper.resolveChartGroupingOption($ctrl.control, $ctrl.groupingOptions, donutGrouping1Fields);
            reportHelper.resolveChartGroupingOption($ctrl.control, $ctrl.groupingOptions, donutGrouping2Fields);
            reportHelper.resolveChartGroupingOption($ctrl.control, $ctrl.groupingOptions, donutGrouping3Fields);
        }

        $scope.$watch(() => $ctrl.control, function(newValue, oldValue)  {
            if(!$ctrl.control || $ctrl.control.$type !== "rcGroupingActivityDonut") {
                return;
            }
            $rootScope.$broadcast('reloadDonutChart');
        }, true);

        //PRIVATE METHODS
        function updateContextValues() {
            var unused = contextItems.exclude(function(c){
                return $ctrl.selectedDataSource.options?.some(c);
            });
            unused.forEach(function(u){
                switch(u) {
                    case 'DateRange':
                        optionsHelper.removeIdAndGuidByType('date-range', $ctrl.control.dataSource);
                        break;
                    case 'Activity':
                        optionsHelper.removeIdAndGuidByType('activity', $ctrl.control.dataSource);
                        break;
                    case 'Performance':
                        optionsHelper.removeIdAndGuidByType('performance', $ctrl.control.dataSource);
                        break;
                    case 'Trading':
                        optionsHelper.removeIdAndGuidByType('trading', $ctrl.control.dataSource);
                        break;
                }
            });
            $ctrl.control.dataSource.label = $ctrl.selectedDataSource.label;
            $ctrl.control.dataSource.path = $ctrl.selectedDataSource.path;
            if($ctrl.selectedDataSource.$type === 'option-value') {
                optionsHelper.syncChartDataSourceActivityOption($ctrl.selectedDataSource, $ctrl.control.dataSource);
            }

            defaultGroupName1();
            defaultGroupName2();
            defaultGroupName3();
        }

        function defaultGroupName1(){
            if(!$ctrl.control.groupName1){
                const newGroupName = {
                    $type: 'rcStringResolver',
                    value: '[@{"path":"Group.Name","displayText":"Group Name"}@]'
                };
                if($ctrl.control.grouping1 === 'Self'){
                    newGroupName.value = '[@{"path":"Activity.Name","displayText":"Activity Name"}@]';
                }
                $ctrl.control.groupName1 = newGroupName;
            }
        };

        function defaultGroupName2(){
            if(!$ctrl.control.groupName2){
                const newGroupName = {
                    $type: 'rcStringResolver',
                    value: '[@{"path":"Group.Name","displayText":"Group Name"}@]'
                };

                if($ctrl.control.grouping2 === 'Self'){
                    newGroupName.value = '[@{"path":"Activity.Name","displayText":"Activity Name"}@]';
                }

                $ctrl.control.groupName2 = newGroupName;
            }
        };

        function defaultGroupName3(){
            if(!$ctrl.control.groupName3){
                const newGroupName = {
                    $type: 'rcStringResolver',
                    value: '[@{"path":"Group.Name","displayText":"Group Name"}@]'
                };

                if($ctrl.control.grouping3 === 'Self'){
                    newGroupName.value = '[@{"path":"Activity.Name","displayText":"Activity Name"}@]';
                }
                
                $ctrl.control.groupName3 = newGroupName;
            }
        };

        $ctrl.filterAvailableGroupingOptions = function(groupingOption) {
            return reportHelper.filterGroupingOptionsByAllowedEntityTypes(groupingOption, [$ctrl.control.grouping1, $ctrl.control.grouping2, $ctrl.control.grouping3]);
        };

        //PUBLIC METHODS
        $ctrl.getOptions = function(name){
            return $ctrl.resolveOptions.filter(function(ro) {
                if(angular.isString(name) && name.length > 0 && !ro.label.has(new RegExp(name, 'i'))) return false;
                return reportHelper.filterStaticTagConfigsByAllowedEntityTypes(ro, $ctrl.control.dataSource.path) && ro.types.some('Set') && ro.allowedLocations.some('PieChart');
            });
        };

        $ctrl.loadSelectedDataSource = function(ds) {
            $ctrl.selectedDataSource = ds;
            updateContextValues();
        };

        $ctrl.updateActivitySelection = function(optionId, guid) {
            if (optionsHelper.activitySelectionMatches($ctrl.control.dataSource, optionId, guid)) {
                return;
            }

            optionsHelper.updateIdAndGuid('activity', $ctrl.control.dataSource, optionId, guid);
            updateContextValues();
        };

        $ctrl.onGrouping1Change = function() {
            reportHelper.applyAdHocChartGroupingSelection(
                $ctrl.control,
                $ctrl.control.groupingOption1,
                donutGrouping1Fields
            );
            defaultGroupName1();
            reportHelper.applyUserDefinedFieldGroupingMetadata($ctrl.control, $ctrl.control.groupingOption1, 1);
        };

        $ctrl.onGrouping2Change = function() {
            if (!$ctrl.control.groupingOption2) {
                $ctrl.control.grouping2 = null;
                $ctrl.control.groupingLabel2 = null;
                delete $ctrl.control.groupingLevelOption2;
                reportHelper.applyUserDefinedFieldGroupingMetadata($ctrl.control, null, 2);
                return;
            }

            reportHelper.applyAdHocChartGroupingSelection(
                $ctrl.control,
                $ctrl.control.groupingOption2,
                donutGrouping2Fields
            );
            defaultGroupName2();
            reportHelper.applyUserDefinedFieldGroupingMetadata($ctrl.control, $ctrl.control.groupingOption2, 2);
        };

        $ctrl.onGrouping3Change = function() {
            if (!$ctrl.control.groupingOption3) {
                $ctrl.control.grouping3 = null;
                $ctrl.control.groupingLabel3 = null;
                delete $ctrl.control.groupingLevelOption3;
                reportHelper.applyUserDefinedFieldGroupingMetadata($ctrl.control, null, 3);
                return;
            }

            reportHelper.applyAdHocChartGroupingSelection(
                $ctrl.control,
                $ctrl.control.groupingOption3,
                donutGrouping3Fields
            );
            defaultGroupName3();
            reportHelper.applyUserDefinedFieldGroupingMetadata($ctrl.control, $ctrl.control.groupingOption3, 3);
        };

        //LIFECYCLE HOOKS
        $ctrl.$onChanges = function () {
            if(!$ctrl.control || $ctrl.control.$type !== "rcGroupingActivityDonut"){
                return;
            }

            $ctrl.control.config.options.legend = rcChartHelper.getLegendOption($ctrl.control.config.options.legend);
            if(!$ctrl.control.dataSource)
                $ctrl.control.dataSource = { path: 'Activity.Value' };
            $ctrl.selectedDataSource = resolveHelper.findResolveOption( $ctrl.control.dataSource );
            refreshGroupingOptions();
            updateContextValues();
        };

        //INITIALIZE
        $ctrl.selectedOption = null;
        var commonOptions = Object.select(rcChartHelper, 'dataLabelOptions', 'legendOptions', 'dataSourceOptions', 'limitOptions');
        angular.extend($ctrl, commonOptions);
        $ctrl.resolveOptions = resolveHelper.options;

        $scope.$on('rb-event:ad-hoc-settings-changed', refreshGroupingOptions);

        $scope.$on('rc-event:load-selected-datasource', function (event, data) {
            const resolveOption = $ctrl.resolveOptions.find(function (ro) { return ro.$key === data.key; });
            if (resolveOption) {
                $ctrl.loadSelectedDataSource(resolveOption);
            }
        });
    }
});

'use strict';

app.component('rcGroupingPieEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcGroupingPieEditor.html',
    bindings: {
        control: '<'
    },
    controller: function (rcChartHelper, resolveHelper, $scope, $rootScope, optionsHelper, reportHelper) {
        var $ctrl = this;
        var contextItems = ['DateRange','Activity','Performance','Trading'];

        $ctrl.optionsHelper = optionsHelper;
        $ctrl.groupingOptions = [];

        //PRIVATE METHODS
        function refreshGroupingOptions() {
            if (!$ctrl.control) {
                return;
            }

            $ctrl.groupingOptions = reportHelper.getAllGroupingOptions();
            reportHelper.resolveChartGroupingOption($ctrl.control, $ctrl.groupingOptions);
        }

        function updateContextValues() {
            if (!$ctrl.control || !$ctrl.selectedDataSource) {
                return;
            }

            var unused = contextItems.exclude(function(c){
                return $ctrl.selectedDataSource.options?.some(c);
            });
            unused.forEach(function(u){
                switch(u) {
                    case 'DateRange':
                        optionsHelper.removeIdAndGuidByType('date-range', $ctrl.control.dataSource);
                        break;
                    case 'Activity':
                        optionsHelper.removeIdAndGuidByType('activity', $ctrl.control.dataSource);
                        break;
                    case 'Performance':
                        optionsHelper.removeIdAndGuidByType('performance', $ctrl.control.dataSource);
                        break;
                    case 'Trading':
                        optionsHelper.removeIdAndGuidByType('trading', $ctrl.control.dataSource);
                        break;
                }
            });
            $ctrl.control.dataSource.label = $ctrl.selectedDataSource.label;
            $ctrl.control.dataSource.path = $ctrl.selectedDataSource.path;
            if($ctrl.selectedDataSource.$type === 'option-value') {
                optionsHelper.syncChartDataSourceActivityOption($ctrl.selectedDataSource, $ctrl.control.dataSource);
            }
            defaultGroupName();
            $ctrl.control.config.title.useHtml = true;
        }

        function defaultGroupName(){
            if(!$ctrl.control.groupName){
                const newGroupName = {
                    $type: 'rcStringResolver',
                    value: '[@{"path":"Group.Name","displayText":"Group Name"}@]'
                };
                if(reportHelper.groupingMatchesName($ctrl.control, 'Self')){
                    newGroupName.value = '[@{"path":"Activity.Name","displayText":"Activity Name"}@]';
                }
                $ctrl.control.groupName = newGroupName;
            }
        };

        function resolveSelectedDataSource() {
            if (!$ctrl.control?.dataSource) {
                return null;
            }

            return resolveHelper.findResolveOption($ctrl.control.dataSource)
                || resolveHelper.options.find(function (option) {
                    return option.path === $ctrl.control.dataSource.path;
                })
                || null;
        }

        function initializeEditorState() {
            if (!$ctrl.control || $ctrl.control.$type !== 'rcGroupingPie') {
                return;
            }

            $ctrl.control.config.options.legend = rcChartHelper.getLegendOption($ctrl.control.config.options.legend);
            if (!$ctrl.control.dataSource) {
                $ctrl.control.dataSource = { path: 'Activity.Value' };
            }

            $ctrl.selectedDataSource = resolveSelectedDataSource();
            refreshGroupingOptions();
            updateContextValues();
        }

        //PUBLIC METHODS
        $ctrl.getOptions = function(name){
            return $ctrl.resolveOptions.filter(function(ro) {
                if(angular.isString(name) && name.length > 0 && !ro.label.has(new RegExp(name, 'i'))) return false;
                return reportHelper.filterStaticTagConfigsByAllowedEntityTypes(ro, $ctrl.control.dataSource.path) && ro.types.some('Set') && ro.allowedLocations.some('PieChart');
            });
        };

        $ctrl.loadSelectedDataSource = function(ds) {
            $ctrl.selectedDataSource = ds;
            updateContextValues();
        };

        $ctrl.updateActivitySelection = function(optionId, guid) {
            if (optionsHelper.activitySelectionMatches($ctrl.control.dataSource, optionId, guid)) {
                return;
            }

            optionsHelper.updateIdAndGuid('activity', $ctrl.control.dataSource, optionId, guid);
            updateContextValues();
        };

        $ctrl.filterAvailableGroupingOptions = function(groupingOption) {
            return reportHelper.filterGroupingOptionsByAllowedEntityTypes(groupingOption, [$ctrl.control.grouping]);
        };

        $ctrl.onGroupingChange = function() {
            reportHelper.applyAdHocChartGroupingSelection($ctrl.control, $ctrl.control.groupingOption);
            defaultGroupName();
            reportHelper.applyUserDefinedFieldGroupingMetadata($ctrl.control, $ctrl.control.groupingOption);
        };

        //LIFECYCLE HOOKS
        $ctrl.$onChanges = function () {
            initializeEditorState();
        };

        $ctrl.$onInit = function () {
            $scope.$on('rb-event:ad-hoc-settings-changed', refreshGroupingOptions);

            $scope.$on('rc-event:load-selected-datasource', function (event, data) {
                const resolveOption = $ctrl.resolveOptions.find(function (ro) { return ro.$key === data.key; });
                if (resolveOption) {
                    $ctrl.loadSelectedDataSource(resolveOption);
                }
            });
        };

        $scope.$watch(function () {
            return $ctrl.control;
        }, function (newValue) {
            if (!newValue || newValue.$type !== 'rcGroupingPie') {
                return;
            }

            $rootScope.$broadcast('reloadPieChart');
        }, true);

        //INITIALIZE
        $ctrl.selectedOption = null;
        var commonOptions = Object.select(rcChartHelper, 'dataLabelOptions', 'legendOptions', 'dataSourceOptions', 'limitOptions');
        angular.extend($ctrl, commonOptions);
        $ctrl.resolveOptions = resolveHelper.options;
    }
});

'use strict';

app.component('rcGroupingTableEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcGroupingTableEditor.html',
    bindings: {
        control: '<'
    },
    controller: function (rcChartHelper, $scope, $timeout, reportHelper, optionsHelper) {
        var $ctrl = this;

        //INITIALIZE
        var commonOptions = Object.select(rcChartHelper, 'groupingOptions', 'frequencyOptions', 'basedOnOptions');
        angular.extend($ctrl, commonOptions);

        $ctrl.optionsHelper = optionsHelper;

        $ctrl.groupingLabel = function (grouping) {
            if (!grouping) {
                return '';
            }

            return reportHelper.getGroupingDisplayName(grouping) || grouping.name || grouping.value || '';
        };

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            ($ctrl.control.groupings || []).forEach(function (grouping) {
                reportHelper.setGroupingOptionNameAndValue(grouping);
            });
            $scope.$on(reportHelper.GetDefaultOptionEvent, function (event, data) {               
                event.stopPropagation();
                var scope = event.targetScope;               
                do {
                    if(scope.grouping || scope === event.currentScope) break;
                } while (scope && (scope = scope.$parent));

                var groupings = [];
                $ctrl.control.groupings.some(function (grouping) {
                    if (!grouping.contextChange) {
                        grouping.contextChange = {};
                    }
                    if(scope.grouping === grouping) return true;
                    groupings.push(grouping);
                });

                //need to put these in reverse order so the fourth grouping inherits from the 3rd, then 2nd, then 1st groupings.
                for (var i = groupings.length - 1; i >= 0; i--) {
                    data.path.push(groupings[i]);
                }

                if($ctrl.control.$emit)
                    $ctrl.control.$emit(reportHelper.GetDefaultOptionEvent, data);
            });

            reportHelper.$on("rb-event:trigger-grouping-table", function(event){
                $timeout(function () {
                    reportHelper.$broadcast("rb-event:filter-performance-context", {});
                });
            });
        };

        $ctrl.onChanges = function(){
            if($ctrl.control.$type !== "rcGroupingTable") {
                return;
            }
        };

        $ctrl.hasAncestor = function (grouping, value) {
            for (var i = $ctrl.control.groupings.indexOf(grouping); i >= 0; i--) {
                var ancestor = $ctrl.control.groupings[i];
                if (ancestor.value == value || $ctrl.groupingLabel(ancestor) == value) return true;
            }
            return false;
        };

        $ctrl.valueSet = function( v ) {
            return Number.isInteger(v);
        };
    }
});
'use strict';

app.component('rcGroupRepeaterEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcGroupRepeaterEditor.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        const $ctrl = this;

        $ctrl.onChanges = function(){
            if($ctrl.control.$type !== "rcGroupRepeater") {
                return;
            }
        };
    }
});
'use strict';

app.component('rcColumnChartEditor', {
    templateUrl:
        'reporting/envision/components/report-control-editors/rcColumnChartEditor.html',
    bindings: {
        control: '<',
    },
    controller: function (rcChartHelper, resolveHelper, $scope, $rootScope, optionsHelper, reportHelper) {
        const $ctrl = this;

        $ctrl.optionsHelper = optionsHelper;

        let previousId;
        const contextItems = [
            'DateRange',
            'Activity',
            'Performance',
            'Trading',
        ];
        let internalArray = null;

        $scope.$watch(() => $ctrl.control, function()  {
            if($ctrl.control.$type !== "rcColumnChart") {
                return;
            }
            $rootScope.$broadcast('reloadColumnChart');
        }, true);

        Object.defineProperties($ctrl, {
            contextChanges: {
                get: function () {
                    if (!internalArray) {
                        internalArray = optionsHelper.mapDateRangeArrayGetter($ctrl.control);
                    }
                    return internalArray;
                },
                set: function (newValue) {
                    const {forInternal, forControl, dateRanges} = optionsHelper.mapDateRangeArraySetter(newValue);

                    internalArray =  forInternal;
                    $ctrl.control.dateRangeArray = forControl;
                    $ctrl.control.dateRanges = dateRanges;
                },
                enumerable: true,
            },
            displayHorizontal: {
                get: function () {
                    return !!$ctrl.control.displayHorizontal;
                },
                set: function (value) {
                    setDisplayHorizontal(value);
                },
            },
            columnOrganization: {
                get: function () {
                    return $ctrl.control.columnOrganization;
                },
                set: function (value) {
                    setColumnOrganization(value);
                },
            },
            padColumns: {
                get: function () {
                    return !!$ctrl.control.padColumns;
                },
                set: function (value) {
                    $ctrl.control.padColumns = value;
                },
            },
            xAxisLabelOrientation: {
                get: function () {
                    return $ctrl.control.xAxisLabelOrientation;
                },
                set: function (value) {
                    $ctrl.control.xAxisLabelOrientation = value;
                },
            },
            usePositiveNegativeColors: {
                get: function () {
                    return !!$ctrl.control.usePositiveNegativeColors;
                },
                set: function (value) {
                    $ctrl.control.usePositiveNegativeColors = value;
                },
            }
        });

        //PRIVATE METHODS
        function updateContextValues() {
            const unused = contextItems.exclude(function (c) {
                return $ctrl.selectedDataSource.options?.some(c);
            });
            unused.forEach(function (u) {
                switch (u) {
                    case 'DateRange':
                        optionsHelper.removeIdAndGuidByType('date-range', $ctrl.control.dataSource);
                        $ctrl.control.dateRangeArray = [];
                        $ctrl.control.dateRanges = [];
                        break;
                    case 'Activity':
                        optionsHelper.removeIdAndGuidByType('activity', $ctrl.control.dataSource);
                        break;
                    case 'Performance':
                        optionsHelper.removeIdAndGuidByType('performance', $ctrl.control.dataSource);
                        break;
                    case 'Trading':
                        optionsHelper.removeIdAndGuidByType('trading', $ctrl.control.dataSource);
                        break;
                }
            });
            $ctrl.selectedDataSource.options?.forEach(function(s) {
                switch (s) {
                    case 'DateRange':
                        if ($ctrl.control.frequency === 'Summary') {
                            if (!Array.isArray($ctrl.control.dateRangeArray) || !$ctrl.control.dateRangeArray.length) {
                                $ctrl.control.dateRangeArray = [];
                            }
                            if (!Array.isArray($ctrl.control.dateRanges) || !$ctrl.control.dateRanges.length) {
                                $ctrl.control.dateRanges = [];
                            }
                            optionsHelper.removeIdAndGuidByType('date-range', $ctrl.control.dataSource);
                        } else {
                            $ctrl.control.dateRangeArray.length = 0;
                            $ctrl.control.dateRanges.length = 0;
                        }
                        break;
                }
            });
            $ctrl.control.dataSource.label = $ctrl.selectedDataSource.label;
            $ctrl.control.dataSource.path = $ctrl.selectedDataSource.path;
            $ctrl.control.dataSource.format = $ctrl.selectedDataSource.format;
            if ($ctrl.selectedDataSource.$type === 'option-value') {
                optionsHelper.syncChartDataSourceActivityOption($ctrl.selectedDataSource, $ctrl.control.dataSource);
            }
            defaultGroupName();
            $ctrl.setDefaultDataLabelFormat();
        }

        function setDisplayHorizontal(displayHorizontal) {
            $ctrl.control.displayHorizontal = displayHorizontal;
        }

        function setColumnOrganization(columnOrganization) {
            $ctrl.control.columnOrganization = columnOrganization;
        }

        function defaultGroupName(overrideExisting = false) {
            if (!$ctrl.control.groupName || overrideExisting) {
                const path = $ctrl.control.dataSource.path
                    .toLocaleLowerCase()
                    .split('.');
                const newGroupName = {
                    $type: 'rcStringResolver',
                    value:
                        '[@{"path":"Group.Name","displayText":"Group Name"}@]',
                };
                switch (path[0]) {
                    case 'performance':
                        if ($ctrl.groupingMatches('Self')) {
                            newGroupName.value =
                                '[@{"path":"Performance.CalcMethod","displayText":"Performance Calc Method"}@]';
                        }
                        break;
                    case 'activity':
                        if ($ctrl.groupingMatches('Self') || $ctrl.groupingMatches('Activity Options')) {
                            newGroupName.value =
                                '[@{"path":"Activity.Name","displayText":"Activity Name"}@]';
                        }
                        break;
                }
                $ctrl.control.groupName = newGroupName;
            }
        }

        function resetContextChanges(newDataSource) {
            if (dataSourceRequiresSingleDateRange(newDataSource.path)) {
                $ctrl.contextChanges = undefined;
            }
        }

        function resetSelectedFrequency(newDataSource) {
            if (dataSourceRequiresSingleDateRange(newDataSource.path)) {
                $ctrl.control.frequency = "Summary";
            }
        }

        function resetSelectedGrouping(newDataSource) {
            switch(newDataSource.path) {
                case 'TargetPercentDifference.TargetAndActualPercent':
                    $ctrl.control.grouping = "Target Allocation";
                    break;
                case 'TargetPercentDifference.ModelAndTargetVersusActualPercent':
                    $ctrl.control.grouping = "Self";
                    break;
            }
        }

        function resetSelectedColumnOrgSetting(newDataSource) {
            if (dataSourceRequiresSingleDateRange(newDataSource.path)) {
                $ctrl.control.columnOrganization = "GroupName";
            }
        }

        function dataSourceRequiresSingleDateRange(path) {
            switch (path) {
                case 'Trading.ModelAndActualPercent':
                    return true;
                case 'TargetPercentDifference.TargetAndActualPercent':
                    return true;
                case 'TargetPercentDifference.ModelAndTargetVersusActualPercent':
                    return true;
                default:
                    return false;
            }
        }

        function dataSourceRequiresSpecificGrouping(path) {
            switch(path) {
                case 'TargetPercentDifference.TargetAndActualPercent':
                    return true;
                case 'TargetPercentDifference.ModelAndTargetVersusActualPercent':
                    return true;
                default:
                    return false;
            }
        }

        $ctrl.selectionChanged = function () {
            let element = document.getElementById('columnOrganizationSettingSelector');
            if ($ctrl.control.config.options.plotOptions.column.stacking != undefined) {
                $ctrl.control.columnOrganization = 'DateRange';
                element.options.selectedIndex = 0;
            }
        };

        $ctrl.setDefaultDataLabelFormat = function () {
            if (
                (!$ctrl.control.dataLabelFormat ||
                    $ctrl.control.dataLabelFormat.value === '') &&
                $ctrl.control.config.options.plotOptions.column.dataLabels
                    .enabled
            ) {
                const newDataLabelFormat = {
                    $type: 'rcStringResolver',
                    value: `[@{"path":"${$ctrl.control.dataSource.path}","displayText":"${$ctrl.control.dataSource.label}","format":"${$ctrl.control.dataSource.format}"}@]`,
                };
                $ctrl.control.dataLabelFormat = newDataLabelFormat;
            }
        };

        function updateConfig() {
            previousId = $ctrl.control.$index;
        }

        //PUBLIC METHODS
        $ctrl.groupingMatches = function (name) {
            return optionsHelper.groupingMatchesName($ctrl.control, name);
        };

        $ctrl.resetDateRangeSelection = function () {
            internalArray = null;
        };

        $ctrl.getOptions = function (name) {
            return $ctrl.resolveOptions.filter(function (ro) {
                if (
                    angular.isString(name) &&
                    name.length > 0 &&
                    !ro.label.has(new RegExp(name, 'i'))
                )
                    return false;
                return (
                    reportHelper.filterStaticTagConfigsByAllowedEntityTypes(ro, $ctrl.control.dataSource.path) && ro.types.some('Set') && ro.allowedLocations.some('BarChart')
                );
            });
        };

        $ctrl.loadSelectedDataSource = function (ds) {
            $ctrl.selectedDataSource = ds;

            // Datasource specific defaults
            resetSelectedFrequency(ds);
            resetSelectedGrouping(ds);
            resetContextChanges(ds);
            resetSelectedColumnOrgSetting(ds);

            updateContextValues();

            setDefaultSeriesNames();
        };

        $ctrl.updateFrequency = function () {
            updateContextValues();
        };

        $ctrl.isFrequencyDisabled = function () {
            return dataSourceRequiresSingleDateRange($ctrl?.control?.dataSource?.path);
        };

        $ctrl.isGroupingDisabled = function () {
            return dataSourceRequiresSpecificGrouping($ctrl?.control?.dataSource?.path);
        };

        $ctrl.isColumnOrgSettingDisabled = function () {
            return (
                !!$ctrl.control.config.options.plotOptions.column.stacking ||
                dataSourceRequiresSingleDateRange($ctrl.control.dataSource.path)
            );
        };

        $ctrl.useDateRangeContextProfileEditor = function () {
            return $ctrl.control.frequency !== 'Summary' || dataSourceRequiresSingleDateRange($ctrl.control.dataSource.path);
        };

        $ctrl.useDateRangeOptionList = function () {
            return $ctrl.control.frequency === 'Summary' && !dataSourceRequiresSingleDateRange($ctrl.control.dataSource.path);
        };

        $ctrl.showHideEmptyDateRangeToggle = function () {
            return $ctrl.control.frequency === 'Summary' && !dataSourceRequiresSingleDateRange($ctrl.control.dataSource.path);
        };

        $ctrl.updateActivitySelection = function (optionId, guid) {
            if (optionsHelper.activitySelectionMatches($ctrl.control.dataSource, optionId, guid)) {
                return;
            }

            optionsHelper.updateIdAndGuid('activity', $ctrl.control.dataSource, optionId, guid);
            updateContextValues();
        };

        $ctrl.updateLabelsForGrouping = function () {
            reportHelper.applyAdHocChartGroupingSelection($ctrl.control, $ctrl.control.groupingOption);
            reportHelper.applyUserDefinedFieldGroupingMetadata($ctrl.control, $ctrl.control.groupingOption);

            if ($ctrl.groupingMatches('Activity Options')) {
                defaultGroupName(true);
            }
        };

        $ctrl.removeParents = function (resolve) {
            return resolve.$type !== 'parent';
        };

        $ctrl.filterAvailableGroupingOptions = function(groupingOption) {
            return reportHelper.filterGroupingOptionsByAllowedEntityTypes(groupingOption, [$ctrl.control.grouping]);
        };

        function setDefaultSeriesNames() {
            delete $ctrl.control.namedSeries;
            if(!$ctrl.selectedDataSource.namedSeries) {
                return;
            }

            $ctrl.selectedDataSource.namedSeries.forEach(function(seriesName) {
                setSeriesName(seriesName);
            });
        }

        function setSeriesName(seriesName) {
            const series = {
                seriesName: {
                    $type: 'rcStringResolver',
                    value: seriesName,
                    isHtml: false
                }
            }

            if(!$ctrl.control.namedSeries) {
                $ctrl.control.namedSeries = {};
            }

            $ctrl.control.namedSeries[seriesName] = series;
        }

        //LIFECYCLE HOOKS
        $ctrl.$onChanges = function () {
            if ($ctrl.control.$type !== 'rcColumnChart') return;

            $ctrl.control.config.options.legend = rcChartHelper.getLegendOption(
                $ctrl.control.config.options.legend
            );
            if (!$ctrl.control.basedOn) $ctrl.control.basedOn = 'Calendar';
            if (!$ctrl.control.dataSource)
                $ctrl.control.dataSource = {path: 'Activity.Value'};
            if (
                !$ctrl.control.config.options.plotOptions.column.dataLabels
                    .allowOverlap
            )
                $ctrl.control.config.options.plotOptions.column.dataLabels.allowOverlap = false;
            if (
                !$ctrl.control.config.options.plotOptions.column.dataLabels.crop
            )
                $ctrl.control.config.options.plotOptions.column.dataLabels.crop = false;
            if (
                !$ctrl.control.config.options.plotOptions.column.dataLabels
                    .overflow
            )
                $ctrl.control.config.options.plotOptions.column.dataLabels.overflow =
                    'none';
            if (!$ctrl.control.columnOrganization)
                $ctrl.control.columnOrganization = 'DateRange';
            if (!$ctrl.control.xAxisLabelOrientation) {
                $ctrl.control.xAxisLabelOrientation = {orientation: 'Auto'};
            }

            $ctrl.selectedDataSource = resolveHelper.findResolveOption(
                $ctrl.control.dataSource
            );
            reportHelper.resolveChartGroupingOption($ctrl.control, $ctrl.groupingOptions);
            updateContextValues();
            updateConfig();
        };

        $ctrl.$doCheck = function () {
            if ( $ctrl.control.$index !== previousId ) {
                internalArray = null;
                updateConfig();
                $scope.$broadcast('rcContextOptionList-refreshList');
            }
        };

        //INITIALIZE
        const commonOptions = Object.select(
            rcChartHelper,
            'dataLabelOptions',
            'legendOptions',
            'frequencyOptions',
            'dataSourceOptions',
            'groupingOptions',
            'yesNoOptions',
            'ColumnOrganizationSetting',
            'labelOrientationSettings',
            'limitOptions'
        );

        angular.extend($ctrl, commonOptions);
        $ctrl.resolveOptions = resolveHelper.options;
        $ctrl.groupingOptions = reportHelper.getAllGroupingOptions();

        $ctrl.ColumnOrganizationSetting = [
            {name: 'Date Range', value: 'DateRange'},
            {name: 'Group Name', value: 'GroupName'},
        ];

        $ctrl.barChartStackingOptions = [
            {
                name: 'Column',
                value: undefined
            },
            {
                name: 'Stacked',
                value: 'normal'
            },
            {
                name: 'Percent Stacked',
                value: 'percent'
            }
        ];

        function refreshGroupingOptions() {
            if (!$ctrl.control || $ctrl.control.$type !== 'rcColumnChart') {
                return;
            }

            $ctrl.groupingOptions = reportHelper.getAllGroupingOptions();
            reportHelper.resolveChartGroupingOption($ctrl.control, $ctrl.groupingOptions);
        }

        $scope.$on('rb-event:ad-hoc-settings-changed', refreshGroupingOptions);

        $scope.$on('rc-event:load-selected-datasource', function (event, data) {
            const resolveOption = $ctrl.resolveOptions.find(function (ro) { return ro.$key === data.key; });
            if (resolveOption) {
                $ctrl.loadSelectedDataSource(resolveOption);
            }
        });
    },
});

'use strict';

app.component('rcGaugeChartEditor', {
    templateUrl:
        'reporting/envision/components/report-control-editors/rcGaugeChartEditor.html',
    bindings: {
        control: '<',
    },
    controller: function (rcChartHelper, resolveHelper, $scope, GaugeChartService, optionsHelper) {
        const $ctrl = this;
        $ctrl.selectedLegend = 'Disabled';
        $ctrl.optionsHelper = optionsHelper;

        const contextItems = [
            'DateRange',
            'Activity',
            'Performance',
            'Trading',
            'Registration'
        ];
        let internalArray = null;

        Object.defineProperties($ctrl, {
            contextChanges: {
                get: function () {
                    if (!internalArray) {
                        internalArray = [];
                        if (
                            $ctrl.control &&
                            $ctrl.control.dateRangeArray &&
                            $ctrl.control.dateRangeArray.length > 0
                        ) {
                            $ctrl.control.dateRangeArray.forEach(function (d) {
                                internalArray.push({
                                    dateRangeId: parseInt(d),
                                });
                            });
                        }
                    }
                    return internalArray;
                },
                set: function (newValue) {
                    if (newValue.length > 0) {
                        internalArray = newValue;
                        $ctrl.control.dateRangeArray = newValue.map(function (cc) {
                            return String(cc.dateRangeId);
                        });
                    }
                    else {
                        internalArray = [];
                        $ctrl.control.dateRangeArray = [];
                    }

                },
                enumerable: true,
            },
        });

        //PRIVATE METHODS
        function updateContextValues() {
            if (!$ctrl.selectedDataSource.options) {
                $ctrl.control.dataSource.label = $ctrl.selectedDataSource.label;
                $ctrl.control.dataSource.path = $ctrl.selectedDataSource.path;
                $ctrl.control.dataSource.format = $ctrl.selectedDataSource.format;
                return;
            }

            const unused = contextItems.exclude(function (c) {
                return $ctrl.selectedDataSource.options.some(c);
            });

            unused.forEach(function (u) {
                switch (u) {
                    case 'DateRange':
                        optionsHelper.removeIdAndGuidByType('date-range', $ctrl.control.dataSource);
                        $ctrl.control.dateRangeArray = [];
                        break;
                    case 'Activity':
                        optionsHelper.removeIdAndGuidByType('activity', $ctrl.control.dataSource);
                        break;
                    case 'Performance':
                        optionsHelper.removeIdAndGuidByType('performance', $ctrl.control.dataSource);
                        break;
                    case 'Trading':
                        optionsHelper.removeIdAndGuidByType('trading', $ctrl.control.dataSource);
                        break;
                }
            });

            $ctrl.selectedDataSource.options.forEach(function (s) {
                switch (s) {
                    case 'DateRange':
                        if ($ctrl.control.frequency === 'Summary') {
                            if (
                                !Array.isArray($ctrl.control.dateRangeArray) ||
                                !$ctrl.control.dateRangeArray.length
                            )
                                $ctrl.control.dateRangeArray = [];
                            optionsHelper.removeIdAndGuidByType('date-range', $ctrl.control.dataSource);
                        } else {
                            if ($ctrl.control.dateRangeArray && $ctrl.control.dateRangeArray.length > 0){
                                $ctrl.control.dateRangeArray.length = 0;
                            }
                        }
                        break;
                }
            });
            $ctrl.control.dataSource.label = $ctrl.selectedDataSource.label;
            $ctrl.control.dataSource.path = $ctrl.selectedDataSource.path;
            $ctrl.control.dataSource.format = $ctrl.selectedDataSource.format;
            if ($ctrl.selectedDataSource.$type === 'option-value') {
                optionsHelper.syncChartDataSourceActivityOption($ctrl.selectedDataSource, $ctrl.control.dataSource);
            }
            defaultGroupName();
            $ctrl.setDefaultDataLabelFormat();
        }

        function defaultGroupName(overrideExisting = false) {
            if (!$ctrl.control.groupName || overrideExisting) {
                const path = $ctrl.control.dataSource.path
                    .toLocaleLowerCase()
                    .split('.');
                const newGroupName = {
                    $type: 'rcStringResolver',
                    value:
                        '[@{"path":"Group.Name","displayText":"Group Name"}@]',
                };
                switch (path[0]) {
                    case 'performance':
                        if ($ctrl.groupingMatches('Self')) {
                            newGroupName.value =
                                '[@{"path":"Performance.CalcMethod","displayText":"Performance Calc Method"}@]';
                        }
                        break;
                    case 'activity':
                        if ($ctrl.groupingMatches('Self') || $ctrl.groupingMatches('Activity Options')) {
                            newGroupName.value =
                                '[@{"path":"Activity.Name","displayText":"Activity Name"}@]';
                        }
                        break;
                }
                $ctrl.control.groupName = newGroupName;
            }
        }

        $ctrl.setDefaultDataLabelFormat = function () {
            if (
                (!$ctrl.control.dataLabelFormat ||
                    $ctrl.control.dataLabelFormat.value === '') &&
                $ctrl.control.config.options.plotOptions.column.dataLabels
                    .enabled
            ) {
                const newDataLabelFormat = {
                    $type: 'rcStringResolver',
                    value: `[@{"path":"${$ctrl.control.dataSource.path}","displayText":"${$ctrl.control.dataSource.label}","format":"${$ctrl.control.dataSource.format}"}@]`,
                };
                $ctrl.control.dataLabelFormat = newDataLabelFormat;
            }
        };

        //PUBLIC METHODS
        $ctrl.groupingMatches = function (name) {
            return optionsHelper.groupingMatchesName($ctrl.control, name);
        };

        $ctrl.getOptions = function (name) {
            return $ctrl.resolveOptions.filter(function (ro) {
                if (
                    angular.isString(name) &&
                    name.length > 0 &&
                    !ro.label.has(new RegExp(name, 'i'))
                )
                    return false;
                return (
                    ro.allowedLocations.some('GaugeChart')
                );
            });
        };

        $ctrl.updateChartControl = function () {
            GaugeChartService.updateChartConfig($ctrl.control);
        };

        $ctrl.legendChanged = function () {
            switch ($ctrl.selectedLegend) {
                case 'Left':
                case 'Right':
                    $ctrl.control.config.options.legend.enabled = true;
                    $ctrl.control.config.options.legend.align = $ctrl.selectedLegend.toLowerCase();
                    break;
                default:
                    $ctrl.control.config.options.legend.enabled = false;
            }

            $ctrl.updateChartControl();
        };

        $ctrl.loadSelectedDataSource = function (ds) {
            $ctrl.selectedDataSource = ds;
            updateContextValues();
        };

        $ctrl.updateActivitySelection = function(optionId, guid) {
            if (optionsHelper.activitySelectionMatches($ctrl.control.dataSource, optionId, guid)) {
                return;
            }

            optionsHelper.updateIdAndGuid('activity', $ctrl.control.dataSource, optionId, guid);
            updateContextValues();
        };

        function setupDataSource() {
            if (!$ctrl.control.dataSource) {
                $ctrl.control.dataSource = {path: 'Registration.RiskBudget'};
            }

            $ctrl.selectedDataSource = resolveHelper.findResolveOption($ctrl.control.dataSource);
        }

        function setLegend() {
            if ($ctrl.control.config.options.legend?.enabled) { // jshint ignore:line
                $ctrl.selectedLegend = $ctrl.control.config.options.legend.align.capitalize();
            } else {
                $ctrl.selectedLegend = 'Disabled';
            }
        }

        //LIFECYCLE HOOKS
        $ctrl.$onChanges = function () {
            if ($ctrl.control.$type !== 'rcGaugeChart') {
                return;
            }

            setLegend();
            setupDataSource();
            updateContextValues();
            $scope.$broadcast('rcContextOptionList-refreshList');
        };

        //INITIALIZE
        const commonOptions = Object.select(
            rcChartHelper,
            'dataLabelOptions',
            'legendOptions',
            'frequencyOptions',
            'dataSourceOptions',
            'groupingOptions',
            'yesNoOptions',
            'ColumnOrganizationSetting',
            'labelOrientationSettings',
            'limitOptions'
        );
        angular.extend($ctrl, commonOptions);
        $ctrl.resolveOptions = resolveHelper.options;

        $ctrl.ColumnOrganizationSetting = [
            {name: 'Date Range', value: 'DateRange'},
            {name: 'Group Name', value: 'GroupName'},
        ];

        $scope.$on('rc-event:load-selected-datasource', function (event, data) {
            const resolveOption = $ctrl.resolveOptions.find(function (ro) { return ro.$key === data.key; });
            if (resolveOption) {
                $ctrl.loadSelectedDataSource(resolveOption);
            }
        });
    },
});

'use strict';

app.component('rcNoEditorRequired', {
    template: '<div style="padding: 5px"><h5>{{ ::$ctrl.title }}</h5><p>No configuration required</p></div>',
    bindings: {
        title: '@'
    }
});

'use strict';

app.component('rcFragmentEditor', {
    templateUrl: ['$element', '$attrs', function ($element, $attrs) {
        let qualifier = '';

        if ($attrs.renderAs) {
            qualifier = '-' + $attrs.renderAs;
        }

        return 'reporting/envision/components/report-control-editors/rcFragmentEditor' + qualifier + '.html';
    }],
    bindings: {
        control: '<',
    },
    controller: function ($scope, fragmentHelper, $oasRights) {
        const $ctrl = this;
        $ctrl.showFragmentActions = fragmentHelper.getShowFragmentActions();

        //PUBLIC METHODS
        $ctrl.edit = function () {
            fragmentHelper.goToEditor($ctrl.control);
        };

        $ctrl.clone = function () {
            fragmentHelper.edit($ctrl.control, true);
        };

        $ctrl.save = function () {
            fragmentHelper.save($ctrl.control);
        };

        $ctrl.create = function () {
            fragmentHelper.create($ctrl.control);
        };


        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if ($ctrl.control.id) {
                fragmentHelper.getCached($ctrl.control.id)
                    .then(function (fragment) {
                        if (fragment) {
                            $ctrl.control.canEdit = fragment.portfolio.canEdit;
                            $ctrl.control.isDynamic = fragment.portfolio.isDynamic;
                        } else {
                            $ctrl.control.canEdit = false;
                        }
                    });
            }
        };

        $scope.$on('rb-event:remove-fragment', function (event, data) {
            if ($ctrl.control.id === data) {
                $ctrl.$onInit();
            }
        });

        $ctrl.$onChanges = $ctrl.$onInit;

        $ctrl.hasAdvancedEditorRights = $oasRights.canRead('REPORTBUILDERADVANCEDEDITOR');
    },
});
'use strict';

app.component('rcContextProfileEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcContextProfileEditor.html',
    bindings: {
        type: '@',
        typeRef: '<',
        selected: '<',
        selectDisabled: '<',
        isDisabled: '<',
        edit: '<',
        onUpdate: '&',
        onDelete: '&',
        isDefault: '<',
    },
    controller: function ($dialog, reportHelper, $scope, $route) {
        const $ctrl = this;
        let optionFilterEvent;
        const isSubReportEditor = $route && $route.current && $route.current.controller === "SubReportEditorCtrl";
        $ctrl.defaultOption = null;
        $ctrl.defaultName = isSubReportEditor ? "Use Default ( From Report )" : "Default";

        //PRIVATE VARIABLES
        const optionTypes = {
            'date-range': {type: 'daterange'},
            'transaction-option':{type:'transaction-option'},
            'activity': {type: 'activity'},
            'performance': {type: 'performance'},
            'trading': {type: 'trading'},
            'comparison': {type: 'comparison'},
            'statistical': {type: 'statistical'},
            'costbasis': {type: 'costbasis'},
            'income': {type: 'income'},
            'maturity-period': {type: 'maturity-period'},
            'billing': {type: 'billing'},
            'calculation': {type: 'calculation'}
        };

        //PRIVATE METHODS
        function getType(){
            return $ctrl.type || $ctrl.typeRef;
        }
        
        function refreshList(){
            reportHelper.getOptions(getType())
                .then(function (options) {
                    $ctrl.list = options;
                    // $ctrl.getModel($ctrl.selected);
                });
        }

        function refreshDefault(){
            $scope.$emit(reportHelper.GetDefaultOptionEvent, {
                path: [],
                type: getType(),
                setDefault: function(newDefault){
                    if(newDefault){
                        $ctrl.defaultOption = newDefault;
                        if(isSubReportEditor){
                            $ctrl.defaultName = "Use Default ( From Report )";
                        }else{
                            $ctrl.defaultName = "Use Default ( " + newDefault.name + " )";
                        }
                    }else{
                        $ctrl.defaultOption = null;
                        $ctrl.defaultName = "Use Default";
                    }
                }
            });
        }

        function containsFormulaResolve(parent) {
            if(parent.$resolve && parent.$resolve.displayMode)
                return parent.$resolve.displayMode;
            else if (parent.$parent)
                return containsFormulaResolve(parent.$parent);
            else return null;
        }

        function getSelectedId() {
            if (Object.isArray($ctrl.selected) && $ctrl.selected.length > 0) {
                return parseInt($ctrl.selected[0].optionId);
            }

            if ($ctrl.selected) {
                return $ctrl.selected.optionId;
            }

            if ($ctrl.defaultOption) {
                return $ctrl.defaultOption.optionId;
            }

            if ($ctrl.list.length > 0) {
                return $ctrl.list[0].optionId;
            }

            return null;
        }

        function findMatchingOptionByGuidOrId(option, optionToMatch) {
            if (optionToMatch?.guid) {
                return option?.guid === optionToMatch.guid;
            }

            return option?.optionId === optionToMatch?.optionId;
        }

        //PUBLIC METHODS
        $ctrl.delete = function() {
            $ctrl.onDelete({optionId: $ctrl.selected.optionId, guid: $ctrl.selected.guid});
        };

        $ctrl.change = function () {
            const selectedHasValue = $ctrl.selected !== undefined && $ctrl.selected !== null;

            if ($ctrl.isDefault && $ctrl.list) {
                if (!selectedHasValue) {
                    $ctrl.selected = $ctrl.list[0];
                }

                let newDefault = $ctrl.list.find(function (option) { return findMatchingOptionByGuidOrId(option, $ctrl.selected)});
                reportHelper.setDefault(getType(), newDefault);
            }

            const guidSelected = $ctrl.list.find(function (option) { return findMatchingOptionByGuidOrId(option, $ctrl.selected)})?.guid;

            $ctrl.onUpdate({ optionId: $ctrl.selected?.optionId, guid: guidSelected, optionLabel: $ctrl.selected?.name });
            reportHelper.$broadcast("rb-event:update-context", {type: getType()});
        };
        
        $ctrl.launchEditor = function () {
            if($ctrl.isDisabled){
                return false;
            }

            if(!$ctrl.list){
                $ctrl.list = [];
            }

            const selectedId = getSelectedId();
            
            const type = optionTypes[getType()].type;

            const config = {
                type: type,
                item: selectedId,
                itemList: $ctrl.list,
                action: 'edit'
            };

            const d = $dialog.dialog({
                templateUrl: 'reporting/envision/modals/context-change-options.html',
                controller: 'ContextChangeOptionsCtrl',
                resolve: {
                    args: function () {
                        return config;
                    }
                }
            });

            d.open().then(function (rslt) {
                if (rslt) {
                    const currentType = getType();
                    reportHelper.setOptions(currentType, rslt);
                    if(!$ctrl.defaultOption){
                        reportHelper.getDefault(currentType)
                            .then (function (defaultOpt){
                                $ctrl.defaultOption = defaultOpt;
                                $ctrl.defaultName = "Use Default ( " + defaultOpt.name + " )";
                            });
                    }
                }
            });
        };

        $ctrl.getUniqueId = function () {
            let optionType = optionTypes[getType()];
            if(!optionType && getType() !== 'report-category') { return ''; }
            const type = getType() === 'report-category' ? 'reportcategory' : optionType.type;
            return type.charAt(0).toLocaleUpperCase() + type.slice(1);
        };

        $ctrl.getContainer = function () {
            return $scope.$parent.$parent.$parent.heading || '';
        };

        $ctrl.getModel = function (value) {
            // dropdown set by angular input
            if (value === undefined)
            {
                $ctrl.selected = modelFromInput()
            } else {
                $ctrl.selected = value;
            }

            return $ctrl.selected;
        };

        function modelFromInput() {
            if (($ctrl.selected === null || $ctrl.selected === undefined) && $ctrl.isDefault) {
                return $ctrl.defaultOption || $ctrl.list[0];
            }

            if (($ctrl.selected === null || $ctrl.selected === undefined) && !$ctrl.isDefault) {
                return null;
            }

            if (($ctrl.selected !== null || $ctrl.selected !== undefined) && typeof $ctrl.selected === 'object') {
                return $ctrl.list.find(function (item) {
                    if ($ctrl.selected.guid) {                    
                        return item.optionGuid === $ctrl.selected.guid;
                    }
    
                    return item.optionId === $ctrl.selected.optionId;
                });
            }

            let foundListItem = $ctrl.list.find(function (item) {
                if (typeof $ctrl.selected === 'string') {
                    return item.optionGuid === $ctrl.selected || item.guid === $ctrl.selected;
                }

                return item.optionId === $ctrl.selected;
            });

            return foundListItem;
        }

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            let type = getType();
            if (type === 'report-category' || type === 'use-sma-setting') {
                $ctrl.edit = false;
            }

            if (!isSubReportEditor && ($ctrl.edit === undefined || $ctrl.edit)) {
                $ctrl.showEdit = true; //defaults to show edit button
            } else {
                $ctrl.showEdit = false;
            }
            if ($ctrl.isDefault !== undefined || $ctrl.isDefault) {
                $ctrl.isDefault = true;
            } else {
                $ctrl.isDefault = false; //defaults to not default
            }
            if ($ctrl.selected === undefined) {
                $ctrl.selected = null;
            }

            reportHelper.$onOptionChange(getType(), function(){
                refreshList();
                refreshDefault();
            });
            reportHelper.$onDefaultChange(getType(), function(){
                refreshDefault();
            });

            reportHelper.$on("rb-event:update-context", function(event, data){
                if(data.type === getType())
                    refreshDefault();
            });

            if ( getType() === 'performance' ){
                reportHelper.$broadcast("rb-event:trigger-grouping-table");
                optionFilterEvent = reportHelper.$on("rb-event:filter-performance-context", function(event, twrFilter){

                    let performFilter = twrFilter;
                    if(angular.isObject(twrFilter)) {

                        let parentControl = angular.element(reportHelper.resolve?.$cursorScope.$resolve.$element).scope()?.$parent.$parent.$parent.$parent.$ctrl;
                        if(!parentControl) { return; }

                        let grouping = parentControl.groupLevel;
                        let groupIndex = parentControl.groupIndex;
                        if(groupIndex > 0) {

                            for(let parentIndex = 0; parentIndex < groupIndex; parentIndex++) {

                                if(parentControl.control.groupings[parentIndex].value.toLocaleLowerCase() === 'time') {
                                    grouping = parentControl.control.groupings[parentIndex];
                                    break;
                                }
                            }
                        }

                        if(!grouping) { return; }
                        if((grouping.value && grouping.value.toLocaleLowerCase() === 'time') &&
                            (grouping.contextChange && grouping.contextChange.returnStyle.frequency &&
                                grouping.contextChange.returnStyle.frequency.toLocaleLowerCase() === 'daily')) {
                            performFilter = true;
                        } else {
                            performFilter = false;
                        }
                    }

                    if(performFilter){
                        $ctrl.originalList = angular.copy($ctrl.list);
                        $ctrl.list = $ctrl.list.filter(item => {
                            return !item.calculationMethod || item.calculationMethod === 'Time-weighted return';
                        });
                    } else if($ctrl.originalList) {                        
                        $ctrl.list = $ctrl.originalList;
                    }
                });
            }

            refreshList();
            refreshDefault();

            if(containsFormulaResolve($scope.$parent)) {
                reportHelper.getDefault(getType(), [])
                    .then(function(d){
                        if(d){
                            $ctrl.defaultOption = d;
                            $ctrl.defaultName = "Use Default ( " + d.name + " )";
                        }else{
                            $ctrl.defaultOption = null;
                            $ctrl.defaultName = "Use Default";
                        }
                    });
            }
        };

        $ctrl.$onChanges = function(changes) {
            if($ctrl.isDefault && changes.selected &&  $ctrl.list && !changes.selected.currentValue && !findMatchingOptionByGuidOrId(changes.selected.previousValue, changes.selected.currentValue)) {
                var newDefault = $ctrl.defaultOption = $ctrl.list.find(function (option) { return findMatchingOptionByGuidOrId(option, $ctrl.selected)});
                reportHelper.setDefault(getType(), newDefault);
            }
            refreshDefault();
        };

        $ctrl.$onDestroy = function() {
            if(optionFilterEvent) {
                optionFilterEvent();
            }
        };
    }
});
'use strict';

app.component('rcContextOptionList', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcContextOptionList.html',
    bindings: {
        type: '@',
        typeRef: '<',
        isDisabled: '<',
        onUpdate: '&',
        contextChanges: '<',
        // The grouping that owns these context changes. When set on an activity list, enables its activityGroupingSettings
        // (market change, inception value method).
        activityGroupingOwner: '<'
    },
    controller: function ($dialog, reportHelper, $scope, $route, optionsHelper) {
        var $ctrl = this;
        const isSubReportEditor = $route && $route.current && $route.current.controller === "SubReportEditorCtrl";
        $ctrl.defaultOption = {
            optionId: null,
            name: isSubReportEditor ? "Use Default ( From Report )" : "Default"
        };
        $ctrl.useOptionInceptionValueMethodLabel = "Use each activity option's setting";
        // The owner's activityGroupingSettings, edited in place and saved back by commitSettings.
        $ctrl.settings = {};
        $ctrl.endingChoices = {};
        $ctrl.endingSelection = [];

        //PRIVATE VARIABLES
        var optionTypes = {
            'date-range': {type: 'daterange', display: 'Date Range Options', optionIdProp: 'dateRangeId', guidProp: 'dateRange'},
            'activity': {type: 'activity', display: 'Activity Options', optionIdProp: 'activityOptionId', guidProp: 'activityOption'},
            'performance': {type: 'performance', display: 'Performance Options', optionIdProp: 'performanceOptionId', guidProp: 'performanceOption'},
            'maturity-period': {type: 'maturity-period', display: 'Maturity Period', optionIdProp: 'maturityPeriodOptionId', guidProp: 'maturityPeriodOption'}
        };

        //PRIVATE METHODS
        function getType(){
            return $ctrl.type || $ctrl.typeRef;
        }

        function refreshList(skipTriggerOnUpdate){
            return reportHelper.getOptions(getType())
                .then(function (options) {
                    const type = getType();
                    const optionIdProp = optionTypes[type].optionIdProp;

                    const list = options.map(function(o){
                        const newItem = { option: o };
                        optionsHelper.updateIdAndGuid(type, newItem, o.optionId, o.optionGuid);
                        return newItem;
                    });

                    const defaultOption = { option: $ctrl.defaultOption };
                    defaultOption[optionIdProp] = null;

                    //add null default item to the top of the list
                    list.splice(0, 0, defaultOption);

                    //break list into 2 based on what's selected and what's not
                    const selectedList = [];

                    //ensure the order of contextChanges is reflected in the order of selectedList
                    $ctrl.contextChanges.forEach(function(cc){
                        var o = list.find(function(item) {
                            return optionsMatch(cc, item);
                        });

                        //found option in the contextChanges
                        if(o){
                            if (cc.isMarketChangeEnding) {
                                o.isMarketChangeEnding = true;
                            }
                            list.remove(o);
                            selectedList.push(o);
                        }
                    });

                    $ctrl.selectionList = list;
                    setDefaultSelection( );

                    $ctrl.contextChanges = selectedList;
                    refreshMarketChange();
                    if (!skipTriggerOnUpdate){
                        $ctrl.onUpdate({chgContextChanges: $ctrl.contextChanges});
                    }

                });
        }

        function getItemGuid(item) {
            if (!item) {
                return null;
            }

            const guidRef = item[optionTypes[getType()].guidProp];
            return (guidRef && (guidRef.adhocOptionGuid || guidRef.globalOptionGuid))
                || (item.option && (item.option.optionGuid || item.option.guid))
                || null;
        }

        function optionsMatch(left, right) {
            const optionIdProp = optionTypes[getType()].optionIdProp;
            const leftGuid = getItemGuid(left);
            const rightGuid = getItemGuid(right);

            if (leftGuid && rightGuid) {
                return leftGuid.toLowerCase() === rightGuid.toLowerCase();
            }

            const leftId = left[optionIdProp];
            const rightId = right[optionIdProp];
            if (leftId == null && rightId == null) {
                return !leftGuid && !rightGuid;
            }

            return leftId === rightId;
        }

        function isPlaceholderOption(item) {
            const type = optionTypes[getType()];
            const hasId = item[type.optionIdProp] !== undefined && item[type.optionIdProp] !== null;
            const guidRef = item[type.guidProp];
            const isAdHoc = !!(item.option && item.option.isAdHoc)
                || !!(guidRef && (guidRef.$type === 'adhoc-guid' || guidRef.adhocOptionGuid));

            return !hasId && !isAdHoc;
        }

        function setDefaultSelection( ){
            $ctrl.selectionList.sort(function(a, b){
                const aPlaceholder = isPlaceholderOption(a);
                const bPlaceholder = isPlaceholderOption(b);
                if (aPlaceholder !== bPlaceholder) {
                    return aPlaceholder ? -1 : 1;
                }

                const aName = (a.option && a.option.name) || '';
                const bName = (b.option && b.option.name) || '';
                return aName.localeCompare(bName, 'en', { sensitivity: 'base', numeric: true });
            });

            if($ctrl.selectionList.length > 0){
                $ctrl.selected = $ctrl.selectionList[0];
            } else {
                $ctrl.selected = null;
            }
        }

        function refreshMarketChange() {
            if (!$ctrl.showMarketChange()) {
                $ctrl.marketChange = null;
                return;
            }

            // The "Use Default" item resolves to the report's default activity option when the report runs.
            const items = ($ctrl.contextChanges || []).map(function (item) {
                return isPlaceholderOption(item)
                    ? { option: $ctrl.resolvedDefaultOption, isMarketChangeEnding: item.isMarketChangeEnding }
                    : item;
            });
            $ctrl.marketChange = optionsHelper.evaluateContextChangesMarketChange(items, $ctrl.settings.inceptionValueMethod);
            refreshEndingSelection();
        }

        // Feeds the Ending Market Value Options multi select: keys are positions in the list.
        // Detected ending options show as selected until the user picks their own.
        function refreshEndingSelection() {
            const choices = {};
            ($ctrl.contextChanges || []).forEach(function (item, index) {
                choices[String(index)] = (item.option && item.option.name) || ('Option ' + (index + 1));
            });
            $ctrl.endingChoices = choices;

            const flagged = getFlaggedEndingIndexes().map(String);
            const selected = flagged.length ? flagged : getDetectedEndingIndexes().map(String);

            // the multi select binds to this array, so update it in place
            $ctrl.endingSelection.length = 0;
            Array.prototype.push.apply($ctrl.endingSelection, selected);
        }

        function syncSettings() {
            $ctrl.settings = ($ctrl.activityGroupingOwner && $ctrl.activityGroupingOwner.activityGroupingSettings) || {};
        }

        // Saves the settings on the grouping, or removes them when nothing is set.
        function commitSettings() {
            const settings = $ctrl.settings;
            if (!settings.includeMarketChange) {
                delete settings.includeMarketChange;
                delete settings.marketChangeName;
            }
            if (!settings.inceptionValueMethod) {
                delete settings.inceptionValueMethod;
            }

            if (Object.keys(settings).length) {
                $ctrl.activityGroupingOwner.activityGroupingSettings = settings;
            } else {
                delete $ctrl.activityGroupingOwner.activityGroupingSettings;
            }
        }

        function getDetectedEndingIndexes() {
            return (($ctrl.marketChange && $ctrl.marketChange.detectedEndingGuids) || []).map(Number);
        }

        function getFlaggedEndingIndexes() {
            return ($ctrl.contextChanges || []).reduce(function (indexes, item, index) {
                if (item.isMarketChangeEnding) {
                    indexes.push(index);
                }
                return indexes;
            }, []);
        }

        function refreshDefault(){
            return reportHelper.getDefault(getType())
                .then(function(d){
                    // A sub report's default comes from the parent report, so it isn't known here.
                    $ctrl.resolvedDefaultOption = isSubReportEditor ? null : d;
                    refreshMarketChange();

                    if(d){
                        if(isSubReportEditor){
                            $ctrl.defaultOption.name = "Use Default ( From Report )";
                        }else{
                            $ctrl.defaultOption.name = "Use Default ( " + d.name + " )";
                        }
                    }else{
                        $ctrl.defaultOption.name = "Use Default";
                    }
                });
        }

        //PUBLIC METHODS
        $ctrl.addOption = function() {
            if (!$ctrl.selected) {
                return;
            }

            const option = $ctrl.selectionList.find(function (o) {
                return optionsMatch($ctrl.selected, o);
            }) || $ctrl.selected;

            //just move the selected item from the selectionList to contextChange
            $ctrl.contextChanges.push(option);
            $ctrl.selectionList.remove(option);
            setDefaultSelection();
            refreshMarketChange();

            $ctrl.onUpdate({chgContextChanges: $ctrl.contextChanges});
        };

        $ctrl.removeOption = function(option){
            //just move the selected item from the contextChange to selectionList
            delete option.isMarketChangeEnding;
            $ctrl.selectionList.push(option);
            $ctrl.contextChanges.remove(option);
            setDefaultSelection();
            refreshMarketChange();

            $ctrl.onUpdate({chgContextChanges: $ctrl.contextChanges});
        };

        $ctrl.moveOption = function(index) {
            $ctrl.contextChanges.splice(index, 1);
            refreshMarketChange();

            $ctrl.onUpdate({chgContextChanges: $ctrl.contextChanges});
        };

        $ctrl.showMarketChange = function () {
            return getType() === 'activity' && !!$ctrl.activityGroupingOwner;
        };

        // Overrides the inception value method of every activity option in the list; null uses each option's own.
        $ctrl.onInceptionValueMethodChanged = function (inceptionValueMethod) {
            $ctrl.settings.inceptionValueMethod = inceptionValueMethod;
            commitSettings();
            refreshMarketChange();
            $ctrl.onUpdate({chgContextChanges: $ctrl.contextChanges});
        };

        $ctrl.onIncludeMarketChangeChanged = function () {
            const settings = $ctrl.settings;
            if (settings.includeMarketChange) {
                settings.marketChangeName = settings.marketChangeName || 'Market Change';
            } else {
                ($ctrl.contextChanges || []).forEach(function (item) {
                    delete item.isMarketChangeEnding;
                });
            }
            commitSettings();
            refreshMarketChange();
        };

        $ctrl.onMarketChangeNameChanged = function () {
            commitSettings();
        };

        $ctrl.onEndingSelectionChange = function (selection) {
            const detected = getDetectedEndingIndexes();
            const selected = (selection || []).map(Number);

            // Matching the detected options means there's nothing to override.
            const matchesDetected = selected.length === detected.length
                && selected.every(function (i) { return detected.indexOf(i) >= 0; });

            $ctrl.contextChanges.forEach(function (item, i) {
                if (!matchesDetected && selected.indexOf(i) >= 0) {
                    item.isMarketChangeEnding = true;
                } else {
                    delete item.isMarketChangeEnding;
                }
            });
            refreshMarketChange();

            $ctrl.onUpdate({chgContextChanges: $ctrl.contextChanges});
        };

        //LIFECYCLE HOOKS

        $ctrl.$onChanges = function () {
            syncSettings();
            refreshList(true);
            refreshDefault();
        };

        $ctrl.$onInit = function () {
            if ($ctrl.isDefault !== undefined || $ctrl.isDefault) {
                $ctrl.isDefault = true;
            } else {
                $ctrl.isDefault = false; //defaults to not default
            }
            if ($ctrl.selected === undefined) {
                $ctrl.selected = null;
            }
            if ($ctrl.contextChanges === undefined || $ctrl.contextChanges === null) {
                $ctrl.contextChanges = [];
                $ctrl.onUpdate({ chgContextChanges: $ctrl.contextChanges });
            }

            reportHelper.$onOptionChange(getType(), function(scope, isForSync) {
                if (!isForSync) {
                refreshList();
                refreshDefault();
                }
            });
            reportHelper.$onDefaultChange(getType(), function () {
                refreshDefault();
            });

            refreshList();
            refreshDefault();

            $ctrl.defaultDisplay = optionTypes[getType()].display;
        };

        $scope.$on("rcContextOptionList-refreshList", refreshList);
    }
});
'use strict';

app.component('rcReportImageEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcReportImageEditor.html',
    bindings: {
        control: '<'
    },
    controller: function ($scope, imageHelper, $route) {
        const $ctrl = this;

        //PUBLIC METHODS
        $ctrl.getImage = imageHelper.get;

        $ctrl.allowEdit = function(image){
            return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test((image || {}).id);
        };

        $ctrl.allowSizing = function() {
            return $route.current.$$route.controller !== 'ReportingEnvisionCoverPageItemCtrl';
        };

        $ctrl.edit = function(image){
            return imageHelper.edit(image, $scope.$ctrl.control.$index).then(function(image){
                $ctrl.image = image;
            });
        };

        $ctrl.delete = function(image){
            return imageHelper.delete(image).then(function(){
                $ctrl.image = null;
            });
        };

        //INITIALIZE
        $ctrl.sections = {list: ['header', 'body', 'footer'], selected: 'header'};
        $ctrl.images = imageHelper.list();

        Object.defineProperties($ctrl, {
            image: {
                get: function() {
                    if (!$ctrl.control) {
                        return;
                    }

                    // Custom uploads have unique GUIDs. Built-in images share an entity id
                    // (Portal Image and Representative Image are both "Representative").
                    if ($ctrl.allowEdit({ id: $ctrl.control.reportImageId })) {
                        return $ctrl.images.find({ id: $ctrl.control.reportImageId });
                    }

                    return $ctrl.images.find({
                        id: $ctrl.control.reportImageId,
                        name: $ctrl.control.name,
                    });
                },
                set: function (image) {
                    if($ctrl.control) {
                        const safeImage = image || {};
                        $ctrl.control.reportImageId = safeImage.id;
                        $ctrl.control.name = safeImage.name;
                        $ctrl.control.alt = safeImage.alt;
                        $ctrl.control.imageUrl = safeImage.imageUrl;
                        $scope.$emit('rc-image-event:change-image', {control: image});
                    }
                }
            },
            height: {
                get: function() {
                    if($ctrl.control)
                        return $ctrl.control.height;
                },
                set: function(value) {
                    if($ctrl.control) {
                        var [match, amount, unit] = /(\d+)\s*(px|%)?/i.exec(value) || [];
                        $ctrl.control.height = amount > 0 ? '{1}{2}'.assign(amount, unit || 'px') : null;
                    }
                },
                enumerable: true
            },
            width: {
                get: function() {
                    if($ctrl.control)
                        return $ctrl.control.width;
                },
                set: function(value) {
                    if($ctrl.control) {
                        var [match, amount, unit] = /(\d+)\s*(px|%)?/i.exec(value) || [];
                        $ctrl.control.width = amount > 0 ? '{1}{2}'.assign(amount, unit || 'px') : null;
                    }
                },
                enumerable: true
            },
            opacity: {
                get: function() {
                    if($ctrl.control){
                        var opacity = parseFloat($ctrl.control.opacity);
                        return Math.round((isNaN(opacity) ? 1 : opacity).clamp(0,1) * 100);
                    }
                },
                set: function(percent) {
                    if($ctrl.control) {
                        $ctrl.control.opacity = (isNaN(percent) ? 100 : parseInt(percent)).clamp(0, 100) / 100;
                    }
                },
                enumerable: true
            }
        });
    }
});

'use strict';

app.component('rcReportPdfEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcReportPdfEditor.html',
    bindings: {
        control: '<',
    },
    controller: function($scope, pdfHelper) {
        const $ctrl = this;

        //PUBLIC METHODS
        $ctrl.getPdf = pdfHelper.get;

        $ctrl.allowEdit = function(pdf) {
            return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test((pdf || {}).id);
        };

        $ctrl.edit = function(pdf) {
            return pdfHelper.edit(pdf, $scope.$ctrl.control.$index).then(function(pdf) {
                $ctrl.pdf = pdf;
            });
        };

        $ctrl.delete = function(pdf) {
            return pdfHelper.delete(pdf, $scope.$ctrl.control.$index).then(function() {
                $ctrl.pdf = null;
            });
        };

        //INITIALIZE
        $ctrl.sections = { list: ['body'], selected: 'body' };
        $ctrl.pdfs = pdfHelper.list();

        Object.defineProperties($ctrl, {
            pdf: {
                get: function() {
                    if ($ctrl.control) {
                        return $ctrl.pdfs.find({ id: $ctrl.control.reportPdfId, name: $ctrl.control.name });
                    }
                },
                set: function(pdf) {
                    if ($ctrl.control) {
                        const safePdf = pdf || {};
                        $ctrl.control.reportPdfId = safePdf.id;
                        $ctrl.control.name = safePdf.name;
                        $ctrl.control.alt = safePdf.name;
                        $ctrl.control.pdfUrl = safePdf.pdfUrl;
                        $ctrl.control.pageCount = safePdf.pageCount;
                        $ctrl.control.alClientId = safePdf.alClientId;
                    }
                },
            },
        });
    },
});

'use strict';

app.component('rcProjectedIncomeAndRedemption', {
    OAS_DATA: {
        name: 'Projected Income And Redemption',
        icon: 'fa-table',
        category: 'Integrations',
        schema: {
            $type: 'rcProjectedIncomeAndRedemption',
            contextChange: null,
            grouping: 'Asset Class',
            grouping2: 'Product',
            groupName: null,
            group2Name: null,
            showAssetDetail: true,
            formatSettings: {
                numberOfDecimal: 2,
                showDollarSign: true,
                useThousandsSeparator: true,
            },
            projectedIncomeOption: {
                $type: 'projected-income',
                reportYear: 'Current', //'Current', 'NextTwelveMonths', 'NextFiveYears'
                displayCurrentMonth: false,
                dividendDate: 'ExDate',
                includeRedemptions: false,
                includeUnpaidProjected: false,
            }
        },
    },
    templateUrl: 'reporting/envision/components/report-controls/rcProjectedIncomeAndRedemption.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        var $ctrl = this;
        $ctrl.$onInit = function () {
            getColumnHeaders();
        };

        const monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec" ];
        $ctrl.colHeaders = [];

        function getColumnHeaders() {
            let today = new Date();

            let reportYear = $ctrl.control.projectedIncomeOption.reportYear;

            if(reportYear === 'Current') {
                $ctrl.colHeaders = getCurrentYearMonths(today.getFullYear());
            }
            else {
                $ctrl.colHeaders = getNextTwelveMonths(today.getMonth() + 1, today.getFullYear());
            }
        }

        function getCurrentYearMonths(year) {
            let headers = [];
            for(let i = 0; i < monthNames.length; i++ ) {
                headers.push(monthNames[i] + '<br/>' + year);
            }

            return headers;
        }

        function getNextTwelveMonths(startIndex, year) {
            let headers = [];

            [...monthNames.slice(startIndex)].forEach(str => headers.push(str + '<br/>' + year));

            [...monthNames.slice(0, startIndex)].forEach(str => headers.push(str + '<br/>' + (year + 1)));
            return headers;
        }

        $ctrl.$onChanges = function() {
            getColumnHeaders();
        };

        $ctrl.colHeaders = [];
    }
});
'use strict';

app.component('rcProjectedIncomeAndRedemptionByMonth', {
    OAS_DATA: {
        name: 'Projected Income And Redemption By Month',
        icon: 'fa-table',
        category: 'Integrations',
        schema: {
            $type: 'rcProjectedIncomeAndRedemptionByMonth',
            contextChange: null,
            grouping: 'Asset Class',
            grouping2: 'Product',
            groupName: null,
            group2Name: null,
            showAssetDetail: true,
            formatSettings: {
                numberOfDecimal: 2,
                showDollarSign: true,
                useThousandsSeparator: true,
            },
            projectedIncomeOption: {
                $type: 'projected-income',
                reportYear: 'NextFiveYearsByMonth', //'CurrentYear - 5 years 12 months view'
                displayCurrentMonth: false,
                dividendDate: 'ExDate',
                includeRedemptions: false,
                includeUnpaidProjected: false,
            }
        },
    },
    templateUrl: 'reporting/envision/components/report-controls/rcProjectedIncomeAndRedemptionByMonth.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        var $ctrl = this;
        $ctrl.$onInit = function () {
        };
    }
});
'use strict';

app.component('rcProjectedIncomeAndRedemptionEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcProjectedIncomeAndRedemptionEditor.html',
    bindings: {
        control: '<'
    },
    controller: function (rcChartHelper, optionsHelper) {
        var $ctrl = this;
        $ctrl.optionsHelper = optionsHelper;

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if(!$ctrl.control.contextChange){
                $ctrl.control.contextChange = {};
            }
        };

        $ctrl.$onChanges = function () {
            if($ctrl.control.$type !== "rcProjectedIncomeAndRedemption")
                return;
        };

        //INITIALIZE
        var commonOptions = Object.select(rcChartHelper, 'groupingOptions');
        angular.extend($ctrl, commonOptions);
    }
});
'use strict';

app.component('rcProjectedIncomeAndRedemptionByMonthEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcProjectedIncomeAndRedemptionByMonthEditor.html',
    bindings: {
        control: '<'
    },
    controller: function (rcChartHelper, optionsHelper) {
        var $ctrl = this;
        $ctrl.optionsHelper = optionsHelper;

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if (!$ctrl.control.contextChange) {
                $ctrl.control.contextChange = {};
            }
        };

        $ctrl.$onChanges = function () {
            if ($ctrl.control.$type !== "rcProjectedIncomeAndRedemptionByMonth")
                return;
        };

        //INITIALIZE
        var commonOptions = Object.select(rcChartHelper, 'groupingOptions');
        angular.extend($ctrl, commonOptions);
    }
});
'use strict';

app.component('rcSpacerEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcSpacerEditor.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        var $ctrl = this;

        //INITIALIZE
        Object.defineProperties($ctrl, {
            height: {
                get: function() {
                    return $ctrl.control.height;
                },
                set: function(value) {
                    var [match, amount, unit] = /(\d+)\s*(px|%)?/i.exec(value) || [];
                    $ctrl.control.height = amount > 0 ? '{1}{2}'.assign(amount, unit || 'px') : null;
                },
                enumerable: true
            },
            width: {
                get: function() {
                    return $ctrl.control.width;
                },
                set: function(value) {
                    var [match, amount, unit] = /(\d+)\s*(px|%)?/i.exec(value) || [];
                    $ctrl.control.width = amount > 0 ? '{1}{2}'.assign(amount, unit || 'px') : null;
                },
                enumerable: true
            }
        });
    }
});
'use strict';

app.component('rcStaticTableEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcStaticTableEditor.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        var $ctrl = this;
    }
});
'use strict';

app.component('rcScatterPlotEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcScatterPlotEditor.html',
    bindings: {
        control: '<'
    },
    controller: function (rcChartHelper, resolveHelper, $scope, $rootScope, optionsHelper) {
        var $ctrl = this;
        var contextItems = ['DateRange','Activity','Performance','Trading'];

        $ctrl.optionsHelper = optionsHelper;

        $scope.$watch(() => $ctrl.control, function(newValue, oldValue)  {
            if($ctrl.control.$type !== "rcScatterPlot") {
                return;
            }
            $rootScope.$broadcast('reloadScatterPlot');
        }, true);

        //PRIVATE METHODS
        function updateContextValues() {
            var unused = contextItems.exclude(function(c){
                return $ctrl.selectedDataSource.options.some(c);
            });
            unused.forEach(function(u){
                switch(u) {
                    case 'DateRange':                        
                        optionsHelper.removeIdAndGuidByType('date-range', $ctrl.control.dataSource);
                        $ctrl.control.dateRangeArray = [];
                        break;
                    case 'Activity':
                        optionsHelper.removeIdAndGuidByType('activity', $ctrl.control.dataSource);
                        break;
                    case 'Performance':
                        optionsHelper.removeIdAndGuidByType('performance', $ctrl.control.dataSource);
                        break;
                    case 'Trading':
                        optionsHelper.removeIdAndGuidByType('trading', $ctrl.control.dataSource);
                        break;
                }
            });
            $ctrl.control.dataSource.label = $ctrl.selectedDataSource.label;
            $ctrl.control.dataSource.path = $ctrl.selectedDataSource.path;
            defaultGroupName();
        }

        function defaultGroupName(){
            if(!$ctrl.control.groupName){
                const newGroupName = {
                    $type: 'rcStringResolver',
                    value: '[@{"path":"Group.Name","displayText":"Group Name"}@]'
                };
                $ctrl.control.groupName = newGroupName;
            }
        };

        function mergeDataSourceOptions(){
            var opt = $ctrl.selectedDataSource.options.concat($ctrl.selectedComparison.options);
            $ctrl.combinedOptions = opt.filter(function (item, pos) {return opt.indexOf(item) === pos});
        }

        //PUBLIC METHODS
        $ctrl.getOptions = function(name){
             return $ctrl.resolveOptions.filter(function(ro){
                if( angular.isString(name) && name.length > 0 && !ro.label.has(new RegExp(name, 'i'))) return false;
                return ro.allowedLocations.some('ScatterChart');
            });
        };
        $ctrl.loadSelectedDataSource = function(ds) {
            $ctrl.selectedDataSource = ds;
            updateContextValues();
            mergeDataSourceOptions();
        };

        $ctrl.loadComparison = function(ds) {
            $ctrl.selectedComparison = ds;
            $ctrl.control.comparison.label = $ctrl.selectedComparison.label;
            $ctrl.control.comparison.path = $ctrl.selectedComparison.path;
            mergeDataSourceOptions();
        };

        //LIFECYCLE HOOKS
        $ctrl.$onChanges = function () {
            if($ctrl.control.$type !== "rcScatterPlot")
                return;
            $ctrl.control.config.options.legend = rcChartHelper.getLegendOption($ctrl.control.config.options.legend);
            if(!$ctrl.control.basedOn)
                $ctrl.control.basedOn = "Calendar";
            if(!$ctrl.control.dataSource)
                $ctrl.control.dataSource = { path: 'Activity.Value' };
            $ctrl.selectedDataSource = resolveHelper.findResolveOption( $ctrl.control.dataSource );
            if(!$ctrl.control.comparison)
                $ctrl.control.comparison = { path: 'Benchmark.Mean' };
            $ctrl.selectedComparison = resolveHelper.findResolveOption( $ctrl.control.comparison );
            $ctrl.control.comparison.label = $ctrl.selectedComparison.label;
            updateContextValues();
            mergeDataSourceOptions();
        };

        //INITIALIZE
        var commonOptions = Object.select(rcChartHelper, 'dataLabelOptions', 'legendOptions', 'dataSourceOptions');
        angular.extend($ctrl, commonOptions);
        $ctrl.resolveOptions = resolveHelper.options;

        $scope.$on('rc-event:load-selected-datasource', function (event, data) {
            const resolveOption = $ctrl.resolveOptions.find(function (ro) { return ro.$key === data.key; });
            if (resolveOption) {
                if (data.isComparison) {
                    $ctrl.loadComparison(resolveOption);
                }
                else {
                    $ctrl.loadSelectedDataSource(resolveOption);
                }
            }
        });
    }
});
'use strict';

app.component('rcTableOfContentsEntryEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcTableOfContentsEntryEditor.html',
    bindings: {
        control: '<'
    }
});
'use strict';

app.component('rcSimpleTableEditor', {
    templateUrl: 'reporting/envision/components/report-control-editors/rcSimpleTableEditor.html',
    bindings: {
        control: '<',
    },
    controller: function () {
        const $ctrl = this;
        $ctrl.selectControl = function(ctrl, event) {
            $ctrl.$emit('rb-event:select-control', {control: ctrl, event: event});
        };
    }
});

'use strict';

app.component('rcAdvizrMonteCarlo', {
    OAS_DATA: {
        name: 'Orion Planning Probability of Success',
        icon: 'fa-align-justify',
        category: 'Integrations',
        schema: {
            $type: 'rcAdvizrMonteCarlo'
        },
        noEditorRequired: true
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcAdvizrMonteCarlo.html',
    bindings: {
        control: '<'
    },

    controller: function () {
        const $ctrl = this;

        //PRIVATE VARIABLES
        let previousVersion;
        const initialConfigPie = {
            options: {
                chart: {backgroundColor:'transparent' },
                credits: {enabled: false },
                plotOptions: {pie: { innerSize: '75%', allowPointSelect: true, cursor: 'pointer', dataLabels: { enabled: false, format: '<b>{point.percentage:.1f}%</b>' } } },
                tooltip: {pointFormat: '<b>${point.value:,.2f}</b>' },
                legend: {enabled: false}
            },
            series: [ {type: 'pie', name: 'Series', showInLegend: false, data: [{name: "Success", y: 99, className: 'advizr-monte-carlo-success'}, {name: "Fail", y: 1, className: 'advizr-monte-carlo-fail'}] } ],
            title: {text: "99%",verticalAlign:'middle', y: 5}
        };
        function updateChartConfig() {
            $ctrl.chartConfigPie = angular.merge(initialConfigPie, $ctrl.control.config);
            previousVersion = angular.copy($ctrl.control);
        }


        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            updateChartConfig();
        };

        $ctrl.$doCheck = function () {
            if (!angular.equals($ctrl.control, previousVersion)) {
                updateChartConfig();
            }
        };

    }
});


'use strict';

app.component('rcAstroTaxBenefit', {
    OAS_DATA: {
        name: 'Astro Tax Benefit',
        icon: 'fa-table',
        category: 'Integrations',
        schema: {
            $type: 'rcAstroTaxBenefit'
        }
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcAstroTaxBenefit.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        var $ctrl = this;

        $ctrl.data = {
            marketValue: {
                header: [],
                detail: [
                    { name: "Beginning Market Value", amount: 200000.00, class: "BeginningMarketValue" },
                    { name: "Ending Market Value", amount: 275000.00, class: "EndingMarketValue" }
                ],
                footer: [],
            },
            performance: {
                header: [
                    { name: "Performance", class: "Performance" }
                ],
                detail: [
                    { name: "Portfolio", amount: 4.0, class: "Portfolio" },
                    { name: "Russell 2000", amount: 4.3, class: "Benchmark" }
                ],
                footer: [
                { name: "Optimized Return Difference", amount: -.3, class: "OptimizedReturnDifference" }
                ],
            },
            taxLossHarvesting: {
                header: [
                    { name: "Tax Loss Harvesting", name2: "TaxLossHarvesting"}
                ],
                detail: [
                    { name: "Total Short Term Realized Gains", amounts: [{ type: "currency", value: 11000.00 }, null] , class: "TotalShortTermRealizedGains" },
                    { name: "Total Short Term Realized Losses", amounts: [{ type: "currency", value: -19900.00 }, null], class: "TotalShortTermRealizedLosses" },
                    { name: "Total Long Term Realized Gains", amounts: [{ type: "currency", value: 15000.00 }, null], class: "TotalLongTermRealizedGains"},
                    { name: "Total Long Term Realized Losses", amounts: [{ type: "currency", value: -6000.00 }, null], class: "TotalLongTermRealizedLosses"},
                    { name: "Net Realized Short Term Losses (39.7 %)", amounts: [{ type: "currency", value: -8900.00 }, { type: "currency", value: 3533.30 }], class: "NetRealizedShortTermLosses" },
                    { name: "Net Realized Long Term Losses (20 %)", amounts: [{ type: "currency", value: 0.00 }, { type: "currency", value: 0.00 }], class: "NetRealizedLongTermLosses" }
                ],
                footer: [
                    { name: "Additional Potential Tax Benefit", amount: { type: "currency", value: 3533.30 }, class: "AdditionalPotentialTaxBenefit"  },
                    { name: "Tax Yield", amount: { type: "percent", value: 1.49 }, class: "TaxYield" },
                    { name: "Potential After Tax Optimized Portfolio Benefit", amount: { type: "percent", value: 1.19 }, class:  "PotentialAfterTaxOptimizedPortfolioBenefit" }
                ],
            }
        };
    }
});
'use strict';

app.component('rcAstroProposal', {
    OAS_DATA: {
        name: 'Astro Proposal',
        icon: 'fa-star',   // TODO: change placeholder to whatever icon we're using for ASTRO
        category: 'Integrations',
        schema: {
            $type: 'rcAstroProposal'
        },
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcAstroProposal.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        const $ctrl = this;
        let previousVersion;

        var getRandom = {
            USD: function () {
                const formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2
                });

                return formatter.format(getRandom.decimal(100000));
            },
            int: function (maxVal = 100) {
                return Math.floor(Math.random() * maxVal);
            },
            percent: function () {
                return getRandom.decimal(100) + ' %';
            },
            decimal: function (maxVal = 100) {
                return (Math.random() * maxVal).toFixed(2);
            }
        };

        $ctrl.colHeaders = [
            [
                {name: 'Target Strategy', class: "text-right"},
                {name: 'Initial Portfolio', class: "text-right"},
                {name: 'Proposed Portfolio', class: "text-right"}
            ],
            [
                {name: 'Current Realized', class: "text-right"},
                {name: 'Proposed Realized', class: "text-right"}
            ],
            [
                {name: 'Security', class: "text-left"},
                {name: 'Ticker', class: "text-left"},
                {name: '% Initial', class: "text-right"},
                {name: '% Optimal', class: "text-right"},
                {name: '% Change', class: "text-right"}
                ],
        ];

        $ctrl.data = {
            portSum: [
                {
                    name: "Market Value",
                    target: null,
                    initial: getRandom.USD(),
                    optimal: getRandom.USD(),
                },
                {
                    name: "Number Of Holdings",
                    target: getRandom.int(),
                    initial: getRandom.int(),
                    optimal: getRandom.int(),
                },
                {
                    name: "% Cash",
                    target: getRandom.percent(),
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                },
                {
                    name: "Tracking Error vs. Target",
                    target: null,
                    initial: getRandom.decimal(10),
                    optimal: getRandom.decimal(10),
                },
                {
                    name: "R-Squared",
                    target: null,
                    initial: getRandom.decimal(2),
                    optimal: getRandom.decimal(2),
                },
                {
                    name: "Predicted Beta",
                    target: null,
                    initial: getRandom.decimal(2),
                    optimal: getRandom.decimal(2),
                },
                {
                    name: "Projected Risk (SD %)",
                    target: getRandom.decimal(),
                    initial: getRandom.decimal(),
                    optimal: getRandom.decimal(),
                },
                {
                    name: "Projected Turnover",
                    target: null,
                    initial: null,
                    optimal: getRandom.decimal(),
                },
                {
                    name: "Number Of Securities Bought",
                    target: null,
                    initial: null,
                    optimal: getRandom.int(),
                },
                {
                    name: "Number Of Securities Sold",
                    target: null,
                    initial: null,
                    optimal: getRandom.int(),
                },
            ],
            gainsLosses: [
                {
                    name: "Gains",
                    initial: getRandom.USD(),
                    optimal: getRandom.USD(),
                },
                {
                    name: "Short-term",
                    initial: getRandom.USD(),
                    optimal: getRandom.USD(),
                    isIndented: true
                },
                {
                    name: "Long-term",
                    initial: getRandom.USD(),
                    optimal: getRandom.USD(),
                    isIndented: true
                },
                {
                    name: "Losses",
                    initial: getRandom.USD(),
                    optimal: getRandom.USD(),
                },
                {
                    name: "Short-term",
                    initial: getRandom.USD(),
                    optimal: getRandom.USD(),
                    isIndented: true
                },
                {
                    name: "Long-term",
                    initial: getRandom.USD(),
                    optimal: getRandom.USD(),
                    isIndented: true
                },
                {
                    name: "Net Gains / Losses",
                    initial: getRandom.USD(),
                    optimal: getRandom.USD(),
                },
                {
                    name: "Short-term",
                    initial: getRandom.USD(),
                    optimal: getRandom.USD(),
                    isIndented: true
                },
                {
                    name: "Long-term",
                    initial: getRandom.USD(),
                    optimal: getRandom.USD(),
                    isIndented: true
                },
                {
                    name: "Tax Cost",
                    initial: getRandom.USD(),
                    optimal: getRandom.USD(),
                }
            ],
            topIncreases: [
                {
                    name: "General Motors",
                    ticker: "GM",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "Ford Motor",
                    ticker: "FM",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "Citigroup",
                    ticker: "C",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "Chevron",
                    ticker: "CVX",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "Cisco Systems",
                    ticker: "CSCO",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "Bank of America",
                    ticker: "BAC",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "Walmart",
                    ticker: "WMT",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "Pfizer",
                    ticker: "PFE",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "Gilead Sciences",
                    ticker: "GILD",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "Allergan",
                    ticker: "AGN",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
            ],
            topDecreases: [
                {
                    name: "Bank of New York Mellon",
                    ticker: "BK",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "Facebook Class A",
                    ticker: "FB",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "FedEx",
                    ticker: "FDX",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "PVH",
                    ticker: "PVH",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "Intel",
                    ticker: "INTC",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "Allstate",
                    ticker: "ALL",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "Starbucks",
                    ticker: "SBX",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "Celgene",
                    ticker: "CELG",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "Altria Group",
                    ticker: "MO",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
                {
                    name: "Autonation",
                    ticker: "AN",
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                    change: getRandom.percent()
                },
            ],
            sectorAlloc: [
                {
                    name: "Information Technology",
                    target: getRandom.percent(),
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                },
                {
                    name: "Financials",
                    target: getRandom.percent(),
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                },
                {
                    name: "Health Care",
                    target: getRandom.percent(),
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                },
                {
                    name: "Consumer Discretionary",
                    target: getRandom.percent(),
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                },
                {
                    name: "Industrial",
                    target: getRandom.percent(),
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                },
                {
                    name: "Consumer Staples",
                    target: getRandom.percent(),
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                },
                {
                    name: "Energy",
                    target: getRandom.percent(),
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                },
                {
                    name: "Materials",
                    target: getRandom.percent(),
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                },
                {
                    name: "Utilities",
                    target: getRandom.percent(),
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                },
                {
                    name: "Real Estate",
                    target: getRandom.percent(),
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                },
                {
                    name: "Telecommunications",
                    target: getRandom.percent(),
                    initial: getRandom.percent(),
                    optimal: getRandom.percent(),
                },
            ]
        };
        const initialConfig = {
            options: {
                legend: false,
                chart: {type: 'column', height:300},
                plotOptions: {series: {groupPadding: 0.25, pointPadding: 0.01}},
                tooltip: {
                }
            },
            xAxis: {type: 'category', categories: ['Information Technology', 'Financials', 'Health Care', 'Consumer Discretionary', 'Industrial'], max:4},
            yAxis: {title: {text: ''}, labels: {format: '{value} %'}},
            series: [
                {name: 'Target Strategy', data: [{y: getRandom.int(), name: 'Information Technology'},{y: getRandom.int(), name: 'Financials'},{y: getRandom.int(), name: 'Health Care'},{y: getRandom.int(), name: 'Consumer Discretionary'},{y: getRandom.int(), name: 'Industrial'}, 0, 0]},
                {name: 'Initial Portfolio', data: [{y: getRandom.int(), name: 'Information Technology'},{y: getRandom.int(), name: 'Financials'},{y: getRandom.int(), name: 'Health Care'},{y: getRandom.int(), name: 'Consumer Discretionary'},{y: getRandom.int(), name: 'Industrial'}, 0, 0]},
                {name: 'Proposed Portfolio', data: [{y: getRandom.int(), name: 'Information Technology'},{y: getRandom.int(), name: 'Financials'},{y: getRandom.int(), name: 'Health Care'},{y: getRandom.int(), name: 'Consumer Discretionary'},{y: getRandom.int(), name: 'Industrial'}, 0, 0]}
            ],
            title: {text: ''}
        };

        function updateChartConfig() {
            $ctrl.chartConfig = angular.merge(initialConfig, $ctrl.control.config);
            previousVersion = angular.copy($ctrl.control);
        }

        $ctrl.$onInit = function () {
            updateChartConfig();
        };
    }
});

'use strict'; 

app.component('rcAstroConcentratedTaxBenefit', {
    OAS_DATA: {
        name: 'Astro Concentrated Tax Benefit',
        icon: 'fa-table',   // TODO: change placeholder to whatever icon we're using for ASTRO
        category: 'Integrations',
        schema: {
            $type: 'rcAstroConcentratedTaxBenefit'
        }
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcAstroConcentratedTaxBenefit.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        const $ctrl = this;

        $ctrl.data = {
           marketValue: {
                header: [],
                detail: [
                    { name: "Beginning Market Value", amount: 200000.00, class: "BeginningMarketValue" },
                    { name: "Ending Market Value", amount: 275000.00, class: "EndingMarketValue" }
                ],
                footer: [],
            },
            performance: {
                header: [
                    { name: "Performance", class: "Performance" }
                ],
                detail: [
                    { name: "Portfolio", amount: 4.0, class: "Portfolio" },
                    { name: "Russell 2000", amount: 4.3, class: "Benchmark" }
                ],
                footer: [
                    { name: "After Tax Portfolio Return", amount: 7.10, class: "AfterTaxPortfolioReturn" }
                ],
            },
            taxLossHarvesting: {
                header: [
                    {
                        name:
                            [
                                {class: "text-left", value: "Tax Loss Harvesting Details", width: "40%"},
                                {class: "text-left", value: null, width: "20%"},
                                {class: "text-right",value: "Tax Benefit", width: "20%"}
                            ],
                        class: "TaxLossHarvestingDetails"}
                ],
                detail: [
                    {
                        name: "Realized Short Term Gains",
                        amounts: [{type: "currency", value: 11000.00}, {type: "currency", value: 0.00}],
                        class: "RealizedShortTermGains"
                    },
                    {
                        name: "Paired Short Term Losses (39.7 %)",
                        amounts: [{type: "currency", value: -11000.00}, {type: "currency", value: 4367.00}],
                        class: "PairedShortTermLosses"
                    },
                    {
                        name: "Realized Long Term Gains",
                        amounts: [{type: "currency", value: 15000.00}, {type: "currency", value: 0.00}],
                        class: "RealizedLongTermGains"
                    },
                    {
                        name: "Paired Short Term Losses (20 %)",
                        amounts: [{type: "currency", value: -8000.00}, {type: "currency", value: 1600.00}],
                        class: "PairedShortTermLosses"
                    },
                    {
                        name: "Paired Long Term Losses (20 %)",
                        amounts: [{type: "currency", value: -7000.00}, {type: "currency", value: 1400.00}],
                        class: "PairedLongTermLosses"
                    }
                ],
                footer: [
                    {
                        name: "Total Realized Tax Benefit",
                        amounts: [{type: "currency", value: null}, {type: "currency", value: 7367.00}],
                        class: "TotalRealizedTaxBenefit"
                    },
                    {
                        name: "Tax Loss Harvesting Yield",
                        amounts: [{type: "currency", value: null}, {type: "percent", value: 3.10}],
                        class: "TaxLossHarvestingYield"
                    },
                ]
            },
            additionalTaxLossHarvesting: {
               header: [],
               detail: [
                   {
                       name: "Remaining Realized Short Term Losses (39.7 %)",
                       amounts: [{type: "currency", value: -6900.00}, { type: "currency", value: 2739.00 }],
                       class:"RemainingRealizedShortTermLosses"},
                   {
                       name: "Remaining Realized Long Term Losses (20 %)",
                       amounts: [{type: "currency", value: 0.00}, { type: "currency", value: 0.00 }],
                       class:"RemainingRealizedLongTermLosses"
                   }
               ],
               footer: [
                   {
                       name: "Additional Potential Tax Benefit",
                       amounts: [{type: "currency", value: null}, { type: "currency", value: 2739.30 }],
                       class: "AdditionalPotentialTaxBenefit"
                   },
                   {
                       name: "Additional Tax Yield Potential",
                       amounts: [{type: "currency", value: null}, { type: "percent", value: 1.15 }],
                       class: "AdditionalTaxYieldPotential"
                   },
                   {
                       name: "Potential After Tax Optimized Portfolio Benefit",
                       amounts: [{type: "currency", value: null}, { type: "percent", value: 8.25 }],
                       class:  "PotentialAfterTaxOptimizedPortfolioBenefit" }
               ]

            },
            concentratedPositionTransitionSummary: {
                header: [
                    { name: "Concentrated Position Transition Summary", class:"ConcentratedPositionTransitionSummary"}
                ],
                columnHeader: [
                    {
                        name: "Security",
                        header: [
                            {type: "number",   value: "Shares"},
                            {type: "currency", value: "Market Value"},
                            {type: "currency", value: "Cost Basis"},
                            {type: "currency", value: "Unrealized Gain/Loss"}
                            ],
                        class:"SecurityHeaders"
                    }
                ],
                detail: [
                    {
                        name: "Microsoft",
                        amount: [
                            {type: "number",   value: "113"},
                            {type: "currency", value: "121317.00"},
                            {type: "currency", value: "13000.00"},
                            {type: "currency", value: "58750.00"}
                        ],
                        class:"SecurityDetails"
                    }
                ],
                footer: []
            }
        }
    }
});

'use strict';

app.component('rcMgpInsurancePolicies', {
    OAS_DATA: {
        name: 'MoneyGuide Insurance Policies',
        icon: 'fa-table',
        category: 'Integrations',
        schema: {
            $type: 'rcMgpInsurancePolicies'
        },
        noEditorRequired: true
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcMgpInsurancePolicies.html',
    bindings: {
        control: '<'
    },
    controller: function ($http) {
        const $ctrl = this;

        //PRIVATE METHODS
        function init() {
            $http.get('reporting/envision/components/report-controls/integrations/rcMgpSampleData.json')
                .then(function (response) {
                    const insurance = {groups: [], totalDeathBenefit: 0, asOfDate: response.data.asOfDate};

                    response.data.insurancePolicies.policies.forEach(function (policy) {
                        const groupName = policy.typeName + " (" + (policy.isAsset ? '' : 'not ') + "included in assets)";

                        const existingGroup = insurance.groups.find({name: groupName});
                        if (existingGroup) {
                            existingGroup.policies.push(policy);
                        } else {
                            insurance.groups.push({name: groupName, policies: [policy]});
                        }

                        insurance.totalDeathBenefit += policy.deathBenefit;
                    });

                    $ctrl.data = insurance;
                });
        }


        //INITIALIZE
        init();
    }
});

'use strict';

app.component('rcMgpMonteCarloMeter', {
    OAS_DATA: {
        name: 'MoneyGuide Monte Carlo Meter',
        icon: 'fa-tachometer',
        category: 'Integrations',
        schema: {
            $type: 'rcMgpMonteCarloMeter',
            config: {}
        },
        noEditorRequired: true
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcMgpMonteCarloMeter.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        const $ctrl = this;


        //INITIALIZE
        $ctrl.data = {
            low: 65,
            high: 90,
            score: Number.random(60, 98)
        };
    }
});

app.component('reportBuilderMgpDial', {
    template: '<highchart-styled config="$ctrl.chartConfig"></highchart-styled>',
    bindings: {
        high: '<',
        low: '<',
        score: '<',
        config: '<'
    },
    controller: function () {
        const $ctrl = this;

        //PRIVATE VARIABLES
        let previousVersion;
        const initialConfig = {
            options: {
                chart: {
                    type: 'solidgauge',
                    height: 200,
                    className: 'highcharts-mgp-meter'
                },
                plotOptions: {
                    solidgauge: {dataLabels: {y: 5, borderWidth: 0, useHTML: true}}
                },
                tooltip: {enabled: false},
                pane: {
                    center: ["50%", "85%"],
                    size: "140%",
                    startAngle: -90,
                    endAngle: 90,
                    background: {
                        backgroundColor: "#EEE",
                        innerRadius: "60%",
                        outerRadius: "100%",
                        shape: "arc"
                    }
                }
            },
            credits: {enabled: false},
            yAxis: {
                min: 0,
                max: 100,
                lineWidth: 0,
                minorTickInterval: null,
                tickAmount: 2,
                title: {
                    text: null
                },
                labels: {
                    enabled: false
                },
                plotBands: [{
                    className: 'band-1',
                    from: 0,
                    to: 50,
                    thickness: "40%"
                }, {
                    className: 'band-2',
                    from: 50,
                    to: 75,
                    thickness: "40%"
                }, {
                    className: 'band-3',
                    from: 75,
                    to: 100,
                    thickness: "40%"
                }]
            },
            series: [{
                data: [{y: 0, innerRadius: "70%", radius: "90%", color: "rgba(255,255,255,0.5)"}],
                dataLabels: {
                    format: "<div style='text-align: center; color: #AAA;'><div style='font-size: 40px; line-height: 40px;'>{y}%</div><div style='font-size: 12px; line-height: 12px; font-weight: normal;'>Probability of Success</div></div>"
                }
            }],
            title: {
                text: null,
                verticalAlign: 'bottom',
                y: 0
            }
        };


        //PRIVATE METHODS
        function setSeriesData() {
            const plotBands = initialConfig.yAxis.plotBands;
            plotBands[0].to = plotBands[1].from = $ctrl.low;
            plotBands[1].to = plotBands[2].from = $ctrl.high;
            initialConfig.series[0].data[0].y = $ctrl.score;

            const title = initialConfig.title;
            let css;
            if ($ctrl.score > $ctrl.high) {
                title.text = 'Above Confidence Zone';
                css = 'above-confidence';
            } else if ($ctrl.score < $ctrl.low) {
                title.text = 'Below Confidence Zone';
                css = 'below-confidence';
            } else {
                title.text = 'In Confidence Zone';
                css = 'in-confidence';
            }
            const chart = initialConfig.options.chart;
            chart.className = chart.className.split(' ')[0] + ' ' + css;
        }

        function updateChartConfig() {
            $ctrl.chartConfig = angular.merge(initialConfig, $ctrl.config);
            previousVersion = angular.copy($ctrl.config);
        }


        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            setSeriesData();
            updateChartConfig();
        };

        $ctrl.$doCheck = function () {
            if (!angular.equals($ctrl.config, previousVersion)) {
                updateChartConfig();
            }
        };
    }
});

'use strict';

app.component('rcMgpNetWorth', {
    OAS_DATA: {
        name: 'MoneyGuide Net Worth',
        icon: 'fa-bar-chart',
        category: 'Integrations',
        schema: {
            $type: 'rcMgpNetWorth',
            config: {}
        },
        noEditorRequired: true
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcMgpNetWorth.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        const $ctrl = this;

        //PRIVATE VARIABLES
        let previousVersion;
        const data = {
            investmentAssets: {
                categories: [
                    {name: 'Individual Retirement Accounts', totalValue: 2226795.0},
                    {name: 'Taxable and/or Tax-Free Accounts', totalValue: 717000.0}],
                name: 'Investment Assets', totalValue: 2943795.0,
                cssClass: 'highcharts-mgp-investment-assets'
            },
            otherAssets: {
                categories: [
                    {name: 'Cash Value Life', totalValue: 100000.0}],
                name: 'Other Assets', totalValue: 100000.0,
                cssClass: 'highcharts-mgp-other-assets'
            },
            liabilities: {
                categories: [
                    {name: 'Personal Real Estate Loan', totalValue: 500000.0},
                    {name: 'Vehicle Loan', totalValue: 25000.0}],
                name: 'Liabilities', totalValue: 525000.0,
                cssClass: 'highcharts-mgp-liabilities'
            },
            networth: 2518795.0,
            netWorthCssClass: 'highcharts-mgp-net-worth'
        };
        const initialConfig = {
            options: {
                legend: false,
                chart: {type: 'column'},
                plotOptions: {series: {stacking: 'normal', groupPadding: 0.25, pointPadding: 0.01}},
                tooltip: {
                    formatter: function () {
                        return '<b>' + this.x + '</b><br/>' + this.series.name + ': ' + '$' + Highcharts.numberFormat(this.y, 2, '.', ',') + '<br/>' + 'Total: $' + Highcharts.numberFormat(this.point.stackTotal, 2, '.', ',')
                    }
                }
            },
            xAxis: {categories: ['Assets', 'Liabilities', 'Net Worth']},
            yAxis: {title: {text: ''}},
            series: [
                {name: data.investmentAssets.name, data: [{y: data.investmentAssets.totalValue, className: data.investmentAssets.cssClass}, 0, 0]},
                {name: data.otherAssets.name, data: [{y: data.otherAssets.totalValue, className: data.otherAssets.cssClass}, 0, 0]},
                {name: data.liabilities.name, data: [0, {y: Math.abs(data.liabilities.totalValue), className: data.liabilities.cssClass}, 0]},
                {name: 'Net Worth', data: [0, 0, {y: data.networth, className: data.netWorthCssClass}]}
            ],
            title: {text: ''}
        };


        //PRIVATE METHODS
        function setSeriesData() {
            $ctrl.data = data;
        }

        function updateChartConfig() {
            $ctrl.chartConfig = angular.merge(initialConfig, $ctrl.control.config);
            previousVersion = angular.copy($ctrl.control);
        }


        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            setSeriesData();
            updateChartConfig();
        };

        $ctrl.$doCheck = function () {
            if (!angular.equals($ctrl.control, previousVersion)) {
                updateChartConfig();
            }
        };
    }
});


'use strict';

app.component('rcMgpPlanSummary', {
    OAS_DATA: {
        name: 'MoneyGuide Plan Summary',
        icon: 'fa-tachometer',
        category: 'Integrations',
        schema: {
            $type: 'rcMgpPlanSummary',
            config: {}
        },
        noEditorRequired: true
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcMgpPlanSummary.html',
    bindings: {
        control: '<'
    },
    controller: function ($http) {
        const $ctrl = this;


        //PRIVATE METHODS
        function init() {
            $http.get('reporting/envision/components/report-controls/integrations/rcMgpSampleData.json')
                .then(function (response) {
                    const data = response.data.planSummary;

                    $ctrl.types = ['current', 'recommended'];

                    $ctrl.types.forEach(function (type) {
                        const meter = data.results[type].monteCarloMeter;
                        meter.probabilityOfSuccess = parseInt(meter.probabilityOfSuccess);
                        meter.targetRangeHigh = parseInt(meter.targetRangeHigh);
                        meter.targetRangeLow = parseInt(meter.targetRangeLow);
                    });

                    $ctrl.data = data;
                });
        }


        //INITIALIZE
        init()
    }
});


'use strict';

app.component('rcInstreamCapitalMarketAssumptions', {
    OAS_DATA: {
        name: 'InStream Capital Market Assumptions',
        icon: 'fa-list-alt',
        category: 'Integrations',
        schema: {
            $type: 'rcInstreamCapitalMarketAssumptions'
        },
        noEditorRequired: true
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcInstreamCapitalMarketAssumptions.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        // var $ctrl = this;
    }
});

'use strict';

app.component('rcInstreamNetWorthSummary', {
    OAS_DATA: {
        name: 'InStream Net Worth Summary',
        icon: 'fa-table',
        category: 'Integrations',
        schema: {
            $type: 'rcInstreamNetWorthSummary'
        },
        noEditorRequired: true
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcInstreamNetWorthSummary.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        var $ctrl = this;

        $ctrl.data = {
            netWorth: [
                { name: "Assets", amount: 2125327.45 },
                { name: "Liabilities", amount: 187569.34 }
            ],
            assets: [
                { name: "Primary Home", taxStatus: "Taxable", owner: "Household", amount: 1521000.00 },
                { name: "Martin, Dean (SAMPLE-460)", taxStatus: "Tax Deferred", owner: "Household", amount: 604327.45 }
            ],
            liabilities: [
                { name: "Mortgage", category: "Loan", type: "Other", owner: "Household", amount: 187569.34 },
            ],
        };
    }
});

(function(){
    app.component('rcInstreamPlanDetails',{
        OAS_DATA:{
            name: 'InStream Plan Details',
            icon: 'fa-bar-chart',
            category: 'Integrations',
            schema:{
                $type: 'rcInstreamPlanDetails'
            },
            noEditorRequired: true
        },
        templateUrl: "reporting/envision/components/report-controls/integrations/rcInstreamPlanDetails.html",
        bindings: {
            control: '<'
        },
        controller:CTRL
    });

    function CTRL(){
        let $ctrl = this;
        $ctrl.getYear = getYear;
        $ctrl.getAge = getAge;
        $ctrl.calcTotalYears = calcTotalYears;
        $ctrl.headers = [
            ['Timeline','Date'],
            ['Legacy Goals','Start Year','End Year','Total Years','Annual Amount','Inflation Rate']
        ];
        $ctrl.data = {
            clientName:'Dean Martin',
            clientBirthDate:'3/1/1960',
            goals:[
                {name: 'Charitable Donation',   start: '2015,1,12',end: '2030,11,12',annualAmount: '2000000',inflationRate: '2.40%'},
                {name: 'Disaster Relief',       start: '2010,1,12',end: '2018,9,6',annualAmount: '600000',inflationRate: '2.40%'},
                {name: 'Charitable Donation',   start: '2018,1,12',end: '2028,3,4',annualAmount: '120000',inflationRate: '2.40%'}
            ]
        };
        $ctrl.chartConfig = {
            title:{
                text:null
            },
            chart: {
                type: 'column',
                inverted: true
            },
            xAxis:{
                labels:{enabled:false},
                tickmarkPlacement: 'on'
            },
            yAxis: {
                type:'datetime',
                title:{enabled:false},
                units:[['year']],
                plotLines: [{
                    className:'rcInstreamPlanDetailPlotLine',
                    dashStyle:'dash',
                    width: 2,
                    label:{
                        text:'2009'
                    },
                    value: Date.UTC(2009)
                },{
                    className:'rcInstreamPlanDetailPlotLine',
                    dashStyle:'dash',
                    width: 2,
                    label:{
                        text:'2031'
                    },
                    value: Date.UTC(2031)
                }]
            },
            legend:{enabled:false},
            series: getSeriesList()

        };

        //PUBLIC
        function getYear(str){
            return new Date(str).getFullYear();
        }
        function calcTotalYears(start,end){
            return (new Date(end)).getFullYear()-(new Date(start)).getFullYear();
        }
        function getAge(str){
            let birth= getYear($ctrl.data.clientBirthDate);
            let date = getYear(str);
            return date-birth;
        }
        //PRIVATE
        function getSeriesList(){
            let array=[];
            ($ctrl.data.goals).forEach(function(element){
                let start = element.start.split(',');
                let end = element.end.split(',');
                array.push(
                    {
                        name: element.name,
                        type:'columnrange',
                        lineWidth:2,
                        enableMouseTracking: false,
                        tooltip: {
                            DateFormat: '%Y-%m-%d',
                            shared: false
                        },
                        data: [[Date.UTC(start[0],start[1],start[2]),Date.UTC(end[0],end[1],end[2])]]
                    }
                );
            });
            return array;
        }
    }
})();
'use strict';

app.component('rcInstreamPlanAnalysis', {
    OAS_DATA: {
        name: 'InStream Plan Analysis',
        icon: 'fa-microchip',
        category: 'Integrations',
        schema: {
            $type: 'rcInstreamPlanAnalysis'
        },
        noEditorRequired: true
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcInstreamPlanAnalysis.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        const $ctrl = this;

        //PRIVATE VARIABLES
        let previousVersion;
        const initialConfigPie = {
            options: {
                chart: {backgroundColor:'transparent' },
                credits: {enabled: false },
                plotOptions: {pie: { innerSize: '75%', allowPointSelect: true, cursor: 'pointer', dataLabels: { enabled: false, color: '#000000', connectorColor: '#000000', format: '<b>{point.percentage:.1f}%</b>' } } },
                tooltip: {pointFormat: '<b>${point.value:,.2f}</b>' },
                legend: {enabled: false}
            },
            series: [ {type: 'pie', name: 'Series', showInLegend: false, data: [{name: "Success", y: 85,  className: 'instream-plan-analysis-slice'}, {name: "Fail", y: 15}] } ],
            title: {text: ''}
        };

        const initialConfigLine = {
            options: {
                chart: {zoomType: 'xy'},
                credits: {enabled: false},
                xAxis: {title: {enabled: true, text: ''}},
                yAxis: {title: {text: ''}, labels: {format: '{value}M'}},
                legend: {enabled: false},
                plotOptions: { series: {pointStart: Date.create('now').getFullYear( ) } }
            },
            series: [
                {
                    type: 'scatter',
                    name: 'High',
                    data: [
                        {y: 2.8, className: 'instream-plan-analysis-high'},
                        {y: 3.0, className: 'instream-plan-analysis-high'},
                        {y: 3.2, className: 'instream-plan-analysis-high'},
                        {y: 3.5, className: 'instream-plan-analysis-high'},
                        {y: 3.7, className: 'instream-plan-analysis-high'},
                        {y: 4.1, className: 'instream-plan-analysis-high'},
                        {y: 4.4, className: 'instream-plan-analysis-high'},
                        {y: 4.9, className: 'instream-plan-analysis-high'}
                    ],
                    enableMouseTracking: false,
                    className: 'instream-plan-analysis-high'
                },{
                    type: 'scatter',
                    name: 'Medium',
                    data: [
                        {y: 2.7, className: 'instream-plan-analysis-medium'},
                        {y: 2.6, className: 'instream-plan-analysis-medium'},
                        {y: 2.5, className: 'instream-plan-analysis-medium'},
                        {y: 2.4, className: 'instream-plan-analysis-medium'},
                        {y: 2.4, className: 'instream-plan-analysis-medium'},
                        {y: 2.3, className: 'instream-plan-analysis-medium'},
                        {y: 2.3, className: 'instream-plan-analysis-medium'},
                        {y: 2.2, className: 'instream-plan-analysis-medium'}
                    ],
                    enableMouseTracking: false,
                    className: 'instream-plan-analysis-medium'
                },{
                    type: 'scatter',
                    name: 'Low',
                    data: [
                        {y: 2.5, className: 'instream-plan-analysis-low'},
                        {y: 2.3, className: 'instream-plan-analysis-low'},
                        {y: 2.1, className: 'instream-plan-analysis-low'},
                        {y: 1.9, className: 'instream-plan-analysis-low'},
                        {y: 1.7, className: 'instream-plan-analysis-low'},
                        {y: 1.4, className: 'instream-plan-analysis-low'},
                        {y: 1.1, className: 'instream-plan-analysis-low'},
                        {y: 0.9, className: 'instream-plan-analysis-low'}
                    ],
                    enableMouseTracking: false,
                    className: 'instream-plan-analysis-low'
                }],
            title: {text: ''},
            subtitle: {text: ''}
        };

        //PRIVATE METHODS
        function updateChartConfig() {
            $ctrl.chartConfigPie = angular.merge(initialConfigPie, $ctrl.control.config);
            $ctrl.chartConfigLine = angular.merge(initialConfigLine, $ctrl.control.config);
            previousVersion = angular.copy($ctrl.control);
        }


        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            updateChartConfig();
        };

        $ctrl.$doCheck = function () {
            if (!angular.equals($ctrl.control, previousVersion)) {
                updateChartConfig();
            }
        };

    }
});

app.component('rcInstreamMatrix',{
    OAS_DATA:{
        name: 'InStream Scenario Matrix',
        icon: 'fa-table',
        category: 'Integrations',
        schema:{
            $type: 'rcInstreamMatrix'
        },
        noEditorRequired: true
    },
    templateUrl: "reporting/envision/components/report-controls/integrations/rcInstreamMatrix.html",
    bindings: {
        control: '<'
    },
    controller: function(){
        var $ctrl = this;

        $ctrl.data = [
            { name: "2%", data: [ {cell:"A1",percent:"11",amount:"1154890"}, {cell:"B1",percent:"12",amount:"1077581"}, {cell:"C1",percent:"13",amount:"1009115"} ] },
            { name: "Current Plan", data: [ {cell:"A2",percent:"12",amount:"1065205"}, {cell:"B2",percent:"13",amount:"1027771"}, {cell:"C2",percent:"14",amount:"909278"} ] },
            { name: "-2%", data: [ {cell:"A3",percent:"13",amount:"1014277"}, {cell:"B3",percent:"14",amount:"977325"}, {cell:"C3",percent:"15",amount:"937761"} ] },
        ];
    }
});

app.component('instreamMatrixTile',{
    bindings:{
        cell:'@',
        percent:'@',
        amount:'@'
    },
    template:   "<div class=\"instream-matrix-tile\">\n" +
                "    <div class=\"instream-matrix-cell\">{{$ctrl.cell}}</div>\n" +
                "    <div class=\"instream-matrix-percentage\">{{$ctrl.percent}}%</div>\n" +
                "    <hr/>\n" +
                "    <div class=\"instream-matrix-dollar\">({{$ctrl.amount | currency:\"$\":0}})</div>\n" +
                "</div>"
    ,
    controller: function(){
        var $ctrl = this;
    }
});
'use strict';

app.component('rcMorningstarEquitySectorWeightings', {
    OAS_DATA: {
        name: 'Morningstar Equity Sector Weightings',
        icon: 'fa-table',
        category: 'Integrations',
        schema: {
            $type: 'rcMorningstarEquitySectorWeightings'
        },
        noEditorRequired: true
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcMorningstarEquitySectorWeightings.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        const $ctrl = this;

        $ctrl.data = {
            categories: [
                {
                    className: 'morningstar-sector-weightings-cyclical',
                    name: 'Cyclical',
                    items: [
                        { name: 'Basic Materials', value: 5.6 },
                        { name: 'Consumer Cyclical', value: 16.7 },
                        { name: 'Financial Services', value: 15.4 }
                    ], footer: { name: 'Total', value: 37.7 }
                }, {
                    className: 'morningstar-sector-weightings-sensitive',
                    name: 'Sensitive',
                    items: [
                        { name: 'Consumer Defensive', value: 19.2 },
                        { name: 'Healthcare', value: 4.8 },
                        { name: 'Utilities', value: 1.0 }
                    ], footer: { name: 'Total', value: 25.0 }
                }, {
                    className: 'morningstar-sector-weightings-defensive',
                    name: 'Defensive',
                    items: [
                        { name: 'Communication Services', value: 8.6 },
                        { name: 'Energy', value: 12.4 },
                        { name: 'Industrial', value: 16.3 }
                    ], footer: { name: 'Total', value: 37.3 }
                },
            ]
        }
    }
});

'use strict';

app.component('rcMorningstarEquityAllocation', {
    OAS_DATA: {
        name: 'Morningstar Equity Allocations',
        icon: 'fa-th',
        category: 'Integrations',
        schema: {
            $type: 'rcMorningstarEquityAllocation'
        },
        noEditorRequired: true
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcMorningstarEquityAllocation.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        const $ctrl = this;

        //PRIVATE VARIABLES
        let previousVersion;
        const initialConfig = {
            options: {
                chart: {backgroundColor:'transparent' },
                credits: {enabled: false },
                plotOptions: {pie: { innerSize: '40%', allowPointSelect: true, cursor: 'pointer', dataLabels: { enabled: true, color: '#000000', connectorColor: '#000000', format: '<b>{point.percentage:.1f}%</b>' } } },
                tooltip: {pointFormat: '<b>${point.value:,.2f}</b>' },
                legend: {enabled: true}
            },
            series: [ {type: 'pie', name: 'Series', showInLegend: true, data: [{name: "Stock", y: 35}, {name: "Bond", y: 25}, { name: "Misc", y: 15}, {name: "Cash", y: 15}, {name: "Other", y: 10}], animation: false } ],
            title: {text: ''}
        };

        //PRIVATE METHODS
        function updateChartConfig() {
            $ctrl.chartConfig = angular.merge(initialConfig, $ctrl.control.config);
            previousVersion = angular.copy($ctrl.control);
        }


        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            updateChartConfig();
        };

        $ctrl.$doCheck = function () {
            if (!angular.equals($ctrl.control, previousVersion)) {
                updateChartConfig();
            }
        };

    }
});

'use strict';

app.component('rcMorningstarFundAssetOverlap', {
    OAS_DATA: {
        name: 'Morningstar Fund Asset Overlap',
        icon: 'fa-th',
        category: 'Integrations',
        schema: {
            $type: 'rcMorningstarFundAssetOverlap'
        },
        noEditorRequired: true
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcMorningstarFundAssetOverlap.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        const $ctrl = this;

        //PRIVATE VARIABLES
        let previousVersion;
        const initialConfig = {
            options: {
                chart: { type: 'bar', height: 100 },
                title: { text: ''},
                plotOptions: {
                    bar: {
                        headSize: 0,
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true,
                            inside: true,
                            y: 50,
                            verticalAlign: 'bottom',
                            format: '{series.name}'
                        }
                    }
                },
                tooltip: {
                    enabled: true
                },
                yAxis: {
                    min: 0,
                    max: 100,
                    visible: false,
                    reversedStacks: false,
                    opposite: true,
                    labels: {
                        enabled: false
                    },
                    startOnTick: false,
                    endOnTick: false
                },
                xAxis: {
                    visible: false
                },
                legend: {
                    enabled: false
                }
            },
            series: [
                {
                    name: 'Top 25 Holdings: 75%',
                    data: [75],
                    color: '#0078D4',
                    dataLabels: {
                        align: 'left',
                        inside: true,
                        style: {
                            color: '#8F959F',
                            textOutline: 'none',
                            fontWeight: 'normal'
                        }
                    }
                },
                {
                    name: 'Other Holdings (200): 25%',
                    data: [25],
                    color: '#8F959F',
                    dataLabels: {
                        align: 'right',
                        inside: true,
                        style: {
                            color: '#8F959F',
                            textOutline: 'none',
                            fontWeight: 'normal'
                        }
                    }
                }
            ]
        };
        //PRIVATE METHODS
        function updateChartConfig() {
            $ctrl.chartConfig = angular.merge(initialConfig, $ctrl.control.config);
            previousVersion = angular.copy($ctrl.control);
        }


        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            updateChartConfig();
        };

        $ctrl.$doCheck = function () {
            if (!angular.equals($ctrl.control, previousVersion)) {
                updateChartConfig();
            }
        };

    }
});

'use strict';

app.component('rcRiskalyzeAnalysisChart', {
    OAS_DATA: {
        name: 'Nitrogen Analysis Chart',
        icon: 'fa-list-alt',
        category: 'Integrations',
        schema: {
            $type: 'rcRiskalyzeAnalysisChart',
            portfolioType: 'current',
            config: {}
        }
    },
    templateUrl: 'reporting/envision/components/report-controls/rcChart.html',
    bindings: {
        control: '<'
    },
    controller: function ($http) {
        const $ctrl = this;

        //PRIVATE VARIABLES
        let sampleData;
        let previousVersion;
        const initialConfig = {
            options: {
                chart: {
                    height: 250,
                    spacing: [0, 0, 0, 0],
                    className: 'highcharts-riskalyze-analysis'
                },
                plotOptions: {series: {marker: {radius: 6}}},
                xAxis: {
                    labels: {enabled: false},
                    tickLength: 0
                },
                yAxis: {
                    labels: {enabled: false},
                    title: {text: null}
                },
                tooltip: {
                    valueSuffix: '',
                    formatter: function () {
                        return '$' + Highcharts.numberFormat(this.x, 0);
                    }
                },
                legend: {enabled: false}
            },
            series: [{data: []}],
            title: {text: '95% Probability Rate (6 Months)', useHTML: true, floating: true, margin: 0}
        };


        //PRIVATE METHODS
        function loadSampleData() {
            return $http.get('reporting/envision/components/report-controls/integrations/rcRiskalyzeSampleData.json')
                .then(function (response) {
                    sampleData = response.data;
                });
        }

        function setSeriesData() {
            const portfolio = sampleData[$ctrl.control.portfolioType.toLocaleLowerCase() + 'Portfolio'];

            const bestWorstFormatter = function () {
                const sign = this.point.percent > 0 ? "+" : "-";
                return sign + Highcharts.numberFormat(this.point.percent.abs(), 2) + '%<br />' + sign + '$' + Highcharts.numberFormat(this.point.dollarValue.abs(), 0);
            };

            const analysis = portfolio.analysis;
            const total = portfolio.total;
            const points = {
                best: {y: 1, percent: analysis.best * 100, dollarValue: analysis.best * total, className: 'point-best', dataLabels: {enabled: true, y: 65, formatter: bestWorstFormatter, className: 'data-label-best'}},
                worst: {y: -1, percent: analysis.worst * 100, dollarValue: analysis.worst * total, className: 'point-worst', dataLabels: {enabled: true, y: 65, formatter: bestWorstFormatter, className: 'data-label-worst'}},
                portfolio: {y: 0, x: total, className: 'point-portfolio', dataLabels: {enabled: true, y: -15, format: "${x:,.0f}"}}
            };

            const endLine1Base = [{name: 'best', value: analysis.best.abs()}, {name: 'worst', value: analysis.worst.abs()}].sortBy('value', true)[0].name;
            points.endLine1 = {y: points[endLine1Base].y * 2, dollarValue: points[endLine1Base].dollarValue * 2, marker: {enabled: false, states: {hover: {enabled: false}}}};
            points.endLine2 = {y: points.endLine1.y * -1, dollarValue: points.endLine1.dollarValue * -1, marker: {enabled: false, states: {hover: {enabled: false}}}};

            Object.each(points, function (key, value) {
                if (key !== "portfolio") {
                    value.x = value.dollarValue + total;
                }
            });

            const slope = (points.worst.y - points.best.y) / (points.worst.x - points.best.x);

            Object.each(points, function (key, value) {
                if (['portfolio', 'endLine1', 'endLine2'].any(key)) {
                    value.y = slope * ( value.x - points.best.x ) + points.best.y;
                }
            });

            initialConfig.series[0].data = Object.values(points).sortBy('x');
        }

        function updateChartConfig() {
            $ctrl.chartConfig = angular.merge(initialConfig, $ctrl.control.config);
            previousVersion = angular.copy($ctrl.control);
        }


        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            loadSampleData()
                .then(function () {
                    setSeriesData();
                    updateChartConfig();
                });
        };

        $ctrl.$doCheck = function () {
            if (previousVersion && !angular.equals($ctrl.control, previousVersion)) {
                if ($ctrl.control.portfolioType !== previousVersion.portfolioType) {
                    initialConfig.series[0].data.length = 0;
                    setSeriesData();
                }
                updateChartConfig();
            }
        };
    }
});
'use strict';

app.component('rcRiskalyzeAnalysisDetail', {
    OAS_DATA: {
        name: 'Nitrogen Analysis Detail',
        icon: 'fa-table',
        category: 'Integrations',
        schema: {
            $type: 'rcRiskalyzeAnalysisDetail',
            portfolioType: 'current'
        }
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcRiskalyzeAnalysisDetail.html',
    bindings: {
        control: '<'
    },
    controller: function ($http) {
        const $ctrl = this;


        //PRIVATE METHODS
        function init() {
            $http.get('reporting/envision/components/report-controls/integrations/rcRiskalyzeSampleData.json')
                .then(function (response) {
                    const setGradientBarData = function (entity) {
                        const analysis = entity.analysis;
                        if (analysis) {
                            const absWorst = Math.abs(analysis.worst);
                            const total = analysis.best + absWorst;
                            entity.chart = {
                                worst: ((absWorst / total) * 100).round(2),
                                best: ((analysis.best / total) * 100).round(2)
                            }
                        }
                    };

                    $ctrl.data = {current: {accounts: [], totalValue: 0}, proposed: {accounts: [], totalValue: 0}};

                    ['Current', 'Proposed'].forEach(function (portfolioType) {
                        const portfolio = response.data[portfolioType.toLocaleLowerCase() + 'Portfolio'];
                        if (portfolio) {
                            setGradientBarData(portfolio);

                            portfolio.accounts.forEach(function (account) {
                                setGradientBarData(account);

                                account.allocations.forEach(function (allocation) {
                                    setGradientBarData(allocation);
                                });
                            });

                            $ctrl.data[portfolioType.toLocaleLowerCase()].accounts = portfolio.accounts;
                            $ctrl.data[portfolioType.toLocaleLowerCase()].totalValue = portfolio.accounts.sum('total');
                        }
                    });
                });
        }


        //INITIALIZE
        init()
    }
});
'use strict';

app.component('rcRiskalyzeRiskNumber', {
    OAS_DATA: {
        name: 'Nitrogen Risk Number',
        icon: 'fa-list-alt',
        category: 'Integrations',
        schema: {
            $type: 'rcRiskalyzeRiskNumber',
            imageType: 'standard'
        }
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcRiskalyzeRiskNumber.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        const $ctrl = this;

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if (!$ctrl.control) return;

            $ctrl.riskNumber = $ctrl.control.riskNumber || Number.random(20, 95);
        };

        $ctrl.$onChanges = $ctrl.$onInit;
    }
});
'use strict';

app.component('rcEclipseModelToleranceAnalysisTable', {
    OAS_DATA: {
        name: 'Eclipse Model Tolerance Analysis Table',
        icon: 'fa-table',
        category: 'Integrations',
        schema: {
            $type: 'rcEclipseModelToleranceAnalysisTable',
            grouping1: 'Asset Class',
            grouping2: null,
            grouping3: null,
            displayRelativeDifference: false,
            sortOrder: 'No Sorting',
            showCashLast: false
        }
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcEclipseModelToleranceAnalysisTable.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        var $ctrl = this;

        //PRIVATE VARIABLES
        var previousVersion;

        //PRIVATE METHODS
        function loadData() {
            $ctrl.data.allocations.length = 0;
            let count = Math.floor(Math.random()*5) + 5;
            for(var i = 0; i < count; i++) {
                let aPercent1 = Math.random()*100;
                let mPercent1 = Math.random()*100;
                let dPercent1 = Math.abs(aPercent1-mPercent1);
                let aAmount1 = Math.random()*100000;
                let mAmount1 = Math.random()*100000;
                let dAmount1 = Math.abs(aAmount1-mAmount1);

                $ctrl.data.allocations.add({name: `${$ctrl.control.grouping1} ${i+1}`, actualPercent: `${aPercent1}`, modelPercent: `${mPercent1}`, differencePercent: `${dPercent1}`, actualAmount: `${aAmount1}`, modelAmount: `${mAmount1}`, differenceAmount: `${dAmount1}`, children: []});
                if($ctrl.control.grouping2 && isSecondChildGroup()) {
                    let count2 = Math.floor(Math.random()*3) + 1;
                    for(var j = 0; j < count2; j++) {
                        let aPercent2 = Math.random()*100;
                        let mPercent2 = Math.random()*100;
                        let dPercent2 = Math.abs(aPercent2-mPercent2);
                        let aAmount2 = Math.random()*100000;
                        let mAmount2 = Math.random()*100000;
                        let dAmount2 = Math.abs(aAmount2-mAmount2);

                        $ctrl.data.allocations[i].children.add({ name: `${$ctrl.control.grouping2} ${j + 1}`, actualPercent: `${aPercent2}`, modelPercent: `${mPercent2}`, differencePercent: `${dPercent2}`, actualAmount: `${aAmount2}`, modelAmount: `${mAmount2}`, differenceAmount: `${dAmount2}`, children: [] });
                        if ($ctrl.control.grouping3 && isThirdChildGroup()) {
                            let count3 = Math.floor(Math.random()*3) + 1;
                            for (var w = 0; w < count3; w++) {
                                let aPercent3 = Math.random() * 100;
                                let mPercent3 = Math.random() * 100;
                                let dPercent3 = Math.abs(aPercent3 - mPercent3);
                                let aAmount3 = Math.random() * 100000;
                                let mAmount3 = Math.random() * 100000;
                                let dAmount3 = Math.abs(aAmount3 - mAmount3);
                                $ctrl.data.allocations[i].children[j].children.add({ name: `${$ctrl.control.grouping3} ${w + 1}`, actualPercent: `${aPercent3}`, modelPercent: `${mPercent3}`, differencePercent: `${dPercent3}`, actualAmount: `${aAmount3}`, modelAmount: `${mAmount3}`, differenceAmount: `${dAmount3}`});
                            }
                        }
                    }
                }
            }
            previousVersion = angular.copy($ctrl.control);
        }

        function groupingOptionsIndex(grouping) {
            var groupingOptions = ['Category', 'Asset Class', 'Sub Class', 'Security Set', 'Ticker'];
            return groupingOptions.indexOf(grouping);
        }

        function isSecondChildGroup() {
            return groupingOptionsIndex($ctrl.control.grouping2) > groupingOptionsIndex($ctrl.control.grouping1);
        }

        function isThirdChildGroup() {
            return groupingOptionsIndex($ctrl.control.grouping3) > groupingOptionsIndex($ctrl.control.grouping2);
        }

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            loadData();
        };

        $ctrl.$doCheck = function() {
            if (!angular.equals($ctrl.control, previousVersion)) {
                if ($ctrl.control.grouping1 !== previousVersion.grouping1 || $ctrl.control.grouping2 !== previousVersion.grouping2 || $ctrl.control.grouping3 !== previousVersion.grouping3) {
                    loadData();
                }
            }
        };

        $ctrl.sumActualValue = function() {
            var actualAmounts = $ctrl.data.allocations.map(a => parseFloat(a.actualAmount));
            return actualAmounts.reduce((a, c) => a + c).toString();
        };

        //INITIALIZE
        $ctrl.data = { allocations: [] };
    }
});

'use strict';

app.component('rcEclipseModelToleranceAnalysisPieChart', {
    OAS_DATA: {
        name: 'Eclipse Model Tolerance Analysis Pie Chart',
        icon: 'fa-pie-chart',
        category: 'Integrations',
        schema: {
            $type: 'rcEclipseModelToleranceAnalysisPieChart',
            grouping: 'Asset Class'
        }
    },
    templateUrl: 'reporting/envision/components/report-controls/integrations/rcEclipseModelToleranceAnalysisPieChart.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        var $ctrl = this;

        //PRIVATE VARIABLES
        var previousVersion;
        const initialConfigPie = {
            options: {
                chart: {backgroundColor:'transparent' },
                credits: {enabled: false },
                plotOptions: {pie: { showLegend: true, allowPointSelect: true, cursor: 'pointer', dataLabels: { enabled: false, padding: 1, useHTML: true, format: '<b>{point.percentage:.1f}%</b>' } } },
                tooltip: {enabled: false, pointFormat: '<b>{point.value:,.2f} %</b>' },
                legend: {enabled: true, layout: 'horizontal', verticalAlign: 'bottom', align: 'center', useHTML: true}
            },
            series: [ {type: 'pie', name: 'Series', showInLegend: true, data: [], animation: false } ],
            title: {text: ''}
        };

        //PRIVATE METHODS
        function loadData() {
            $ctrl.chartConfigPieActual = angular.copy(initialConfigPie);
            $ctrl.chartConfigPieModel = angular.copy(initialConfigPie);
            let count = Math.floor(Math.random()*10) + 5;
            for(var i = 0; i < count; i++) {
                let aPercent = Math.random()*100;
                let mPercent = Math.random()*100;
                $ctrl.chartConfigPieActual.series[0].data.add({name: `${$ctrl.control.grouping} ${i+1}`, y: aPercent, colorIndex: i});
                $ctrl.chartConfigPieModel.series[0].data.add({name: `${$ctrl.control.grouping} ${i+1}`, y: mPercent, colorIndex: i});
            }
            previousVersion = angular.copy($ctrl.control);
        }

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            loadData();
        };

        $ctrl.$doCheck = function() {
            if (!angular.equals($ctrl.control, previousVersion)) {
                if ($ctrl.control.grouping !== previousVersion.grouping) {
                    loadData();
                }
            }
        };

        //INITIALIZE
        $ctrl.data = { allocations: [] };
    }
});

'use strict'; 

app.component('rcBlendedBenchmarkTable', {
    OAS_DATA: {
        name: 'Blended Benchmark Table',
        icon: 'fa-table',
        category: 'Tables',
        schema: {
            $type: 'rcBlendedBenchmarkTable'
        }
    },
    templateUrl: 'reporting/envision/components/report-controls/rcBlendedBenchmarkTable.html',
    bindings: {
        control: '<'
    },
    controller: function () {
        const $ctrl = this;

        $ctrl.data = {
          blendedBenchmark: {
                columnHeader: [
                  {
                      name: "Allocation",
                      header: [
                          { type: "string", value: "Index" },
                          { type: "string", value: "Asset Class" }
                      ],
                      class:"BlendedBenchmarkHeaders"
                  }
                ],
                groupingHeader1: [
                    { name: "Blended Benchmark Name", class: "BlendedBenchmarkName" }
                ],
                groupingHeader2: [
                  { name: "Inception - 12/31/2018", class: "BlendDateRange" }

                ],
                groupingHeader2_2: [
                  { name: "1/1/2019 - 6/30/2019", class: "BlendDateRange" }
                ],
                detail: [
                    { amount: 75, name: "S&P 500 (TR)", assetClass: "Large Value" },
                    { amount: 25, name: "Bloomberg Barclays Municipal Bond: 5 Year", assetClass: "Security" }
                ],
                detail_2: [
                  { amount: 50, name: "S&P 500 (TR)", assetClass: "Large Value" },
                  { amount: 50, name: "Bloomberg Barclays Municipal Bond: 5 Year", assetClass: "Security" }
                ]
            },
        }
    }
});

'use strict';

app.component('rcColumnGroupingTable', {
    OAS_DATA: {
        name: 'Dynamic Table',
        icon: 'fa-table',
        category: 'Tables',
        schema: {
            $type: 'rcColumnGroupingTable',
            columnGrouping: {
                value: 90,
                name: 'Asset Category',
                contextChange: {},
                orderBy: [],
                contextChanges: [],
                limitMethod: { limitMethod: 'None', showOtherGroup: false, otherGroupName: 'Other', count: 1, threshold: 0.01, dataSource: {path: 'Activity.Value', activityOptionId: null, dateRangeId: null}},
            },
            tableGuideRow: [],
            rowGroupings: [{
                name: 'Asset',
                value: 8,
                orderBy: [],
                guideRow: [],
                useAlternativeLineShading: true,
                limitMethod: { limitMethod: 'None', showOtherGroup: false, otherGroupName: 'Other', count: 1, threshold: 0.01, dataSource: {path: 'Activity.Value', activityOptionId: null, dateRangeId: null}},
                overallHeader: {
                    show: true,
                    rows: [{
                        columns: [{
                            name: 'Head1',
                            control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Column Header 1'},
                            colspan: 1,
                            width: '33.3%',
                            isDynamic: false
                            },
                            {
                                name: 'Head2',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Column Header 2'},
                                colspan: 1,
                                width: '33.3%',
                                isDynamic: true
                            },
                            {
                                name: 'Head3',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Column Header 3'},
                                colspan: 1,
                                width: '33.4%',
                                isDynamic: false
                            }]
                    }]
                },
                header: {
                    show: false,
                    rows: [{
                        columns: [{
                            name: 'Head1',
                            control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Group Label'},
                            colspan: 1,
                            width: '33.3%',
                            isDynamic: false
                            },
                            {
                                name: 'Head2',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: '&nbsp;'},
                                colspan: 1,
                                width: '33.3%',
                                isDynamic: true
                            },
                            {
                                name: 'Head3',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: '&nbsp;'},
                                colspan: 1,
                                width: '33.4%',
                                isDynamic: false
                            }]
                    }]
                },
                body: {
                    show: true,
                    rows: [{
                        columns: [{
                            name: 'Column1',
                            control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Data Column 1'},
                            colspan: 1,
                            width: '33.3%',
                            isDynamic: false
                            },
                            {
                                name: 'Column2',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Data Column 2'},
                                colspan: 1,
                                width: '33.3%',
                                isDynamic: true
                            },
                            {
                                name: 'Column3',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Data Column 3'},
                                colspan: 1,
                                width: '33.4%',
                                isDynamic: false
                            }]
                    }]
                },
                footer: {
                    show: false,
                    rows: [{
                        columns: [{
                            name: 'Foot1',
                            control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Group Total'},
                            colspan: 1,
                            width: '33.3%',
                            isDynamic: false
                        },
                            {
                                name: 'Foot2',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: '&nbsp;'},
                                colspan: 1,
                                width: '33.3%',
                                isDynamic: true
                            },
                            {
                                name: 'Foot3',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Total'},
                                colspan: 1,
                                width: '33.4%',
                                isDynamic: false
                            }]
                    }]
                },
                overallFooter: {
                    show: false,
                    rows: [{
                        columns: [{
                            name: 'Foot1',
                            control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Table Total'},
                            colspan: 1,
                            width: '33.3%',
                            isDynamic: false
                            },
                            {
                                name: 'Foot2',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: '&nbsp;'},
                                colspan: 1,
                                width: '33.3%',
                                isDynamic: true
                            },
                            {
                                name: 'Foot3',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Total'},
                                colspan: 1,
                                width: '33.4%',
                                isDynamic: false
                            }]
                    }]
                },
                benchmarks: {
                    show: false,
                    guideRow: [],
                    contextChange: {},
                    overallHeader: {
                        show: false,
                        rows: [{
                            columns: [{
                                name: 'Head1',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Benchmark Label'},
                                colspan: 1,
                                width: '33.3%',
                                isDynamic: false
                            },
                                {
                                    name: 'Head2',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: '&nbsp;'},
                                    colspan: 1,
                                    width: '33.3%',
                                    isDynamic: true
                                },
                                {
                                    name: 'Head3',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: '&nbsp;'},
                                    colspan: 1,
                                    width: '33.4%',
                                    isDynamic: false
                                }]
                        }]
                    },
                    header: {
                        show: false,
                        rows: [{
                            columns: [{
                                name: 'Head1',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'bmrecordhead1 value'},
                                colspan: 1,
                                width: '33.3%',
                                isDynamic: false
                            },
                                {
                                    name: 'Head2',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'bmrecordhead2 value'},
                                    colspan: 1,
                                    width: '33.3%',
                                    isDynamic: true
                                },
                                {
                                    name: 'Head3',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'bmrecordhead3 value'},
                                    colspan: 1,
                                    width: '33.4%',
                                    isDynamic: false
                                }]
                        }]
                    },
                    body: {
                        show: true,
                        rows: [{
                            columns: [{
                                name: 'Column1',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: '<section>[@{"path":"Benchmark.Name"}@]</section>'},
                                colspan: 1,
                                width: '33.3%',
                                isDynamic: false
                            },
                                {
                                    name: 'Column2',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Benchmark Value'},
                                    colspan: 1,
                                    width: '33.3%',
                                    isDynamic: true
                                },
                                {
                                    name: 'Column3',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Benchmark Value'},
                                    colspan: 1,
                                    width: '33.4%',
                                    isDynamic: false
                                }]
                        }]
                    },
                    footer: {
                        show: false,
                        rows: [{
                            columns: [{
                                name: 'Foot1',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'bmrecordfoot1 value'},
                                colspan: 1,
                                width: '33.3%',
                                isDynamic: false
                            },
                                {
                                    name: 'Foot2',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'bmrecordfoot2 value'},
                                    colspan: 1,
                                    width: '33.3%',
                                    isDynamic: true
                                },
                                {
                                    name: 'Foot3',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'bmrecordfoot3 value'},
                                    colspan: 1,
                                    width: '33.4%',
                                    isDynamic: false
                                }]
                        }]
                    },
                    overallFooter: {
                        show: false,
                        rows: [{
                            columns: [{
                                name: 'Foot1',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Benchmark Total'},
                                colspan: 1,
                                width: '33.3%',
                                isDynamic: false
                            },
                                {
                                    name: 'Foot2',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: '&nbsp;'},
                                    colspan: 1,
                                    width: '33.3%',
                                    isDynamic: true
                                },
                                {
                                    name: 'Foot3',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Total'},
                                    colspan: 1,
                                    width: '33.4%',
                                    isDynamic: false
                                }]
                        }]
                    },
                },
            }]
        },
        canUseInCoverPage: true
    },
    templateUrl: 'reporting/envision/components/report-controls/rcColumnGroupingTable.html',
    bindings: {
        control: '<',
        rowGroupIndex: '<',
        isBenchmark: '<'
    },
    controller: function (rcChartHelper, $interval, $element, $scope, $route, reportHelper, groupingHelper, $oasRights) {
        let $ctrl = this, isolate = {css:{}};
        $ctrl.groupingOptions = [];
        $ctrl.filteredGroupingOptions = [];
        $ctrl._lastFilteredKeys = null;
        $ctrl.loadNested = false;

        Object.defineProperties($ctrl, {
            focused: {
                get: function() {
                    return (
                        reportHelper.current.selected === $ctrl.control ||
                        reportHelper.current.hovered === $ctrl.control
                    );
                }
            },
            rowGroupLevel: {
                get: function() {
                    return $ctrl.isBenchmark ? $ctrl.control.rowGroupings[$ctrl.rowGroupIndex].benchmarks : $ctrl.control.rowGroupings[$ctrl.rowGroupIndex];
                }
            },

            columnGroupLevel: {
                get: function() {
                    return $ctrl.control.columnGrouping;
                }
            },
            resolveType: {
                get: function() {
                    switch($route.current.$$route.controller) {
                        case 'ReportingEnvisionCoverPageItemCtrl':
                            return 'coverPage';
                        case 'ReportEditorCtrl':
                        case 'SubReportEditorCtrl':
                            return 'reportEditor';
                        default:
                            return '';
                    }
                }
            },
            css: {
                get: function () {
                    return isolate.css;
                }
            }
        });

        $ctrl.setColumnGroup = function(option){
            reportHelper.applyGroupingLevelSelection($ctrl.columnGroupLevel, option.value, $ctrl.groupingOptions, option);
            $ctrl.columnGroupLevel.name = option.name?.replace(/ \(Ad hoc\)$/i, '') || $ctrl.columnGroupLevel.name;
        };

        function refreshGroupingOptions() {
            $ctrl.groupingOptions = reportHelper.getAllGroupingOptions();
            $ctrl._lastFilteredKeys = null;
            hydrateGroupingNames();
            normalizePersistedColumnGrouping();
        }

        function hydrateGroupingNames() {
            if (!$ctrl.control) {
                return;
            }

            reportHelper.setGroupingOptionNameAndValue($ctrl.control.columnGrouping);
            ($ctrl.control.rowGroupings || []).forEach(function (rowGrouping) {
                reportHelper.setGroupingOptionNameAndValue(rowGrouping);
            });
        }

        function normalizePersistedColumnGrouping() {
            const groupLevel = $ctrl.control && $ctrl.control.columnGrouping;
            if (!groupLevel) {
                return;
            }

            const adhocGuid = reportHelper.getAdhocGuidFromGroupingLevel(groupLevel);
            const isAdHocValue = groupLevel.value === -32692 || groupLevel.value === 'Ad Hoc Grouping';
            if (!adhocGuid && !isAdHocValue) {
                return;
            }

            reportHelper.applyAdHocGroupingSelection(
                groupLevel,
                groupLevel.value,
                $ctrl.groupingOptions
            );
        }

        $scope.$on('rb-event:ad-hoc-settings-changed', refreshGroupingOptions);

        $ctrl.rowGroupLevelUpdated = function(newValue, option){
            const selectedValue = newValue != null ? newValue : $ctrl.rowGroupLevel.value;
            reportHelper.applyGroupingLevelSelection($ctrl.rowGroupLevel, selectedValue, $ctrl.groupingOptions, option);

            //clear all context changes when the row grouping is changed
            $ctrl.rowGroupLevel.contextChange = {};
            $ctrl.rowGroupLevel.contextChanges = [];

            const rowOption = option
                || $ctrl.groupingOptions.find(function(groupOption) {
                    return reportHelper.groupingOptionMatchesPersistedValue(groupOption, selectedValue);
                });
            $ctrl.rowGroupLevel.name = rowOption?.name?.replace(/ \(Ad hoc\)$/i, '')
                || reportHelper.getGroupingDisplayName($ctrl.rowGroupLevel, $ctrl.groupingOptions)
                || $ctrl.rowGroupLevel.name;

            if($ctrl.rowGroupLevel.name === 'Time'){
                $ctrl.rowGroupLevel.contextChange = {
                    dateRangeId: null,
                    returnStyle: {
                        frequency: 'Annually',
                        basedOn: 'Calendar',
                        breakBehavior: 'AllowPartialPeriods',
                        cumulative: false,
                        context: 'Self',
                    }
                };
            }
        };

        $ctrl.columnGroupLevelUpdated = function(newValue, option){
            const selectedValue = newValue != null ? newValue : $ctrl.columnGroupLevel.value;
            reportHelper.applyGroupingLevelSelection($ctrl.columnGroupLevel, selectedValue, $ctrl.groupingOptions, option);

            //clear all context changes when the column grouping is changed
            $ctrl.columnGroupLevel.contextChange = {};
            $ctrl.columnGroupLevel.contextChanges = [];

            if (!$ctrl.columnGroupLevel.name){
                const colGroup = option
                    || $ctrl.groupingOptions.find(function(groupOption) {
                        return reportHelper.groupingOptionMatchesPersistedValue(groupOption, selectedValue);
                    });
                $ctrl.columnGroupLevel.name = colGroup?.name?.replace(/ \(Ad hoc\)$/i, '')
                    || reportHelper.getGroupingDisplayName($ctrl.columnGroupLevel, $ctrl.groupingOptions);
            }


            if($ctrl.columnGroupLevel.name === 'Time'){
                $ctrl.columnGroupLevel.contextChange = {
                    dateRangeId: null,
                    returnStyle: {
                        frequency: 'Annually',
                        basedOn: 'Calendar',
                        breakBehavior: 'AllowPartialPeriods',
                        cumulative: false,
                        context: 'Self',
                    }
                };
            }
        };

        $ctrl.current ={
            index:0,
            row:{},
            col:{},
            dynamicCount:0,
            isLeftDynamic: false,
            isRightDynamic: false
        };

        //PRIVATE VARIABLES
        let sections = ['overallHeader','header', 'body', 'footer','overallFooter'];

        //PRIVATE METHODS
        function setGuideRow() {
            if ($ctrl.control.disabled) {
                return;
            }

            let guideRow = [];
            sections.some(function(section) {
                $ctrl.rowGroupLevel[section].rows.some(function(row) {
                    if (row.columns.all({ colspan: 1 })) {
                        guideRow.push(angular.copy(row));
                        return true;
                    }
                });

                if (guideRow.length > 0) return true;
            });

            $ctrl.rowGroupLevel.guideRow = guideRow;
        }

        function setTableGuideRow() {
            let guideRow = [];
            sections.some(function(section) {
                if (section.toLowerCase().includes('header')) {
                    $ctrl.rowGroupLevel[section].rows.some(function(row) {
                        if (row.columns !== null) {
                            guideRow.push(angular.copy(row));
                            return true;
                        }
                    });
                }
                if (guideRow.length > 0) return true;
            });

            $ctrl.tableGuideRow = guideRow;
        }

        function columnWidthSum(columns){
            let totalWidth = 0;
            columns.forEach(function (column) {
                totalWidth += parseFloat(column.width)
            });
            return totalWidth;
        }

        function adjLastColumnWidth(columns) {
            let widthDiff = 100 - columnWidthSum(columns);
            //add the diff to the last column
            columns.last().width = roundToPrecision(parseFloat(columns.last().width) + widthDiff) + "%";
        }

        function roundToPrecision(num){
            const adj = Math.pow(10, $ctrl.columnResizer.options.precision);
            return Math.round(num * adj) / adj;
        }

        function updateToolsStyles() {
            if (!isolate.tools) {
                return;
            }

            if ((Date.now() + 100 > isolate.ts)) {
                isolate.ts = Date.now();
                Object.keys(isolate.tools).forEach(t => groupingHelper.setToolCss(t, isolate, $element));
            }
        }

        function initColumnResizer() {
            $scope.$$postDigest(function () {
                $ctrl.columnResizer.api.update();
            });
        }

        function storeColumnWidths(column) {
            const widths = $ctrl.columnResizer.api.getWidths();

            let setColWidth = function(row){
                let index = 0;
                let colWidth = 0;
                let dynamicColCount = row.columns.filter(x => x.isDynamic).length;
                for (let i = 0; i < row.columns.length; i++) {
                    colWidth = parseFloat(widths[index]);
                        if(row.columns[i].isDynamic)
                        {
                            let j = i;
                            while (j < i+dynamicColCount) {
                                row.columns[j].width = roundToPrecision(colWidth / dynamicColCount) + '%';
                                j++;
                            }
                            i = j-1;
                            index++;
                            continue;
                        }

                        if (row.columns[i].colspan === 1) {
                            row.columns[i].width = roundToPrecision(colWidth) + '%';
                            index++;
                        }
                        else {
                            for (let idx = index + 1; idx < index + row.columns[i].colspan; idx++) {
                                colWidth += parseFloat(widths[idx]);
                            }
                            row.columns[i].width = roundToPrecision(colWidth) + '%';
                            colWidth = 0;
                            index += row.columns[i].colspan;
                    }
                }
            };

            setColWidth($ctrl.tableGuideRow[0]);
            setColWidth($ctrl.rowGroupLevel.guideRow[0]);
            sections.each(function (section) {
                $ctrl.rowGroupLevel[section].rows.each(function(row){
                    setColWidth(row);
                });
            });


            if ($ctrl.rowGroupIndex === 0 && !$ctrl.isBenchmark){
                //if the colspan = number of guiderow colspan, then set colwidths the same
                for (let lev = 0; lev < $ctrl.control.rowGroupings.length; lev++) {
                    //check top level guide row against guide row of children groupings
                    if (($ctrl.rowGroupLevel.guideRow[0].columns.sum('colspan') === $ctrl.control.rowGroupings[lev].guideRow[0].columns.sum('colspan')) && lev !== 0  ){
                        setColWidth($ctrl.control.rowGroupings[lev].guideRow[0]);
                        sections.each(function (section) {
                            $ctrl.control.rowGroupings[lev][section].rows.each(function(row){
                                setColWidth(row)
                            });
                        });
                    }

                    //check top level guide row against all benchmarks guide rows.
                    if ($ctrl.control.rowGroupings[lev].benchmarks.guideRow && $ctrl.control.rowGroupings[lev].benchmarks.guideRow.length > 0 && $ctrl.rowGroupLevel.guideRow[0].columns.sum('colspan') === ($ctrl.control.rowGroupings[lev].benchmarks.guideRow[0].columns.sum('colspan'))){
                        setColWidth($ctrl.control.rowGroupings[lev].benchmarks.guideRow[0]);
                        sections.each(function (section) {
                            $ctrl.control.rowGroupings[lev].benchmarks[section].rows.each(function(row){
                                setColWidth(row)
                            });
                        });
                    }
                }
            }

            initColumnResizer();

        }

        function addNewColumnToRow(row, index, isDynamic) {
            row.columns.insert({
                name: 'New Column',
                control: { $type: 'rcStringResolverCompact', isHtml: true, value: 'New Value' },
                colspan: 1,
                width: roundToPrecision(100 - columnWidthSum(row.columns)) + '%',
                show: true,
                isDynamic: isDynamic,
            }, index);
        }

        function insertColumn(insertIndex, row, isDynamic = false) {

            let numColumns = $ctrl.columnsInRow(row);
            let defaultWidth = 100 / (numColumns + 1);

            const positionLeftOfInsert = groupingHelper.findPositionLeftOfInsert(insertIndex, row.columns);

            let modifyColumns = function(row, isDynamicHeader = false) {
                if(isDynamicHeader){
                    row.columns.forEach(function (column) {
                        if (column.isDynamic) {
                            column.colspan += 1;
                        }
                        else {
                            column.width = roundToPrecision(parseFloat(column.width) * (1 - defaultWidth / 100)) + '%';
                        }
                    });
                }
                else {
                    //adjust the widths of column
                    row.columns.forEach(function (column) {
                        column.width = roundToPrecision(parseFloat(column.width) * (1 - defaultWidth / 100)) + '%';
                    });

                    if (positionLeftOfInsert === -1) {
                        addNewColumnToRow(row, 0);
                    } else if (positionLeftOfInsert === -99) {
                        addNewColumnToRow(row, row.columns.length);
                    } else {
                        let currentPosition = 0;
                        //let columns = angular.copy(row.columns);

                        row.columns.each(function (column, index) {
                            let positionsHeld = currentPosition.upto(currentPosition + (column.colspan - 1));

                            if (positionsHeld.any(positionLeftOfInsert)) {
                                if (positionsHeld.last() === positionLeftOfInsert) {
                                    addNewColumnToRow(row, index + 1, isDynamic);
                                } else {
                                    column.colspan += 1;
                                    column.width = roundToPrecision(parseFloat(column.width) + (100 - columnWidthSum(row.columns))) + '%';
                                }

                                return false; //break out of loop
                            }
                            currentPosition = positionsHeld.last() + 1;
                        });
                    }
                }
            };

            modifyColumns($ctrl.tableGuideRow[0], isDynamic);
            modifyColumns($ctrl.rowGroupLevel.guideRow[0]);

            sections.forEach(function(section) {
                if(section.toLowerCase().includes("header")) {
                    $ctrl.rowGroupLevel[section].rows.forEach(function(row) {
                        modifyColumns(row, isDynamic);
                    });
                }
                else {
                    $ctrl.rowGroupLevel[section].rows.forEach(function (row) {
                        modifyColumns(row);
                    });
                }
            });

            if(isDynamic){
                storeColumnWidths($ctrl.tableGuideRow[0].columns[0]);
            }

            initColumnResizer();
        }

        function filterAvailableGroupingOptions(groupingOption) {
            return reportHelper.filterGroupingOptionsByAllowedEntityTypes(groupingOption);
        };

        function setTablePrivileges() {
            $scope.hasAdvancedEditorRights = $ctrl.control.canEdit || $oasRights.canRead("REPORTBUILDERADVANCEDEDITOR");
        };

        //PUBLIC METHODS
        $ctrl.updateContext = function(section, row, col, index) {
            $ctrl.current.row = row;
            $ctrl.current.col = col;
            $ctrl.current.index = index;
            $ctrl.current.section = section;
            $ctrl.current.dynamicCount = row.columns.filter(x => x.isDynamic).length;
            if(index <= 0){
                $ctrl.current.isLeftDynamic = false;
            }
            else{
                $ctrl.current.isLeftDynamic = row.columns[index-1].isDynamic;
            }
            if(index >= row.columns.length-1){
                $ctrl.current.isRightDynamic = false;
            }
            else {
                $ctrl.current.isRightDynamic = row.columns[index+1].isDynamic;
            }
        };

        $ctrl.overallName = function() {
            return $ctrl.isBenchmark ? $ctrl.rowGroupingName() : 'Table';
        };

        $ctrl.rowGroupingName = function() {
            return reportHelper.getGroupingDisplayName($ctrl.control.rowGroupings[$ctrl.rowGroupIndex], $ctrl.groupingOptions) + ($ctrl.isBenchmark ? " Benchmarks" : "")
        };

        $ctrl.rowGroupingTitle = function(){
            return "Grouping: " + $ctrl.rowGroupingName();
        };

        $ctrl.isRowDisplayed = function(){
            let sectionsWithDisplayedRows = 0;
            for (let i in sections) {
                let section = $ctrl.rowGroupLevel[sections[i]];
                if (section && section.show && section.rows.length > 0){
                    ++sectionsWithDisplayedRows;
                }

                if(sectionsWithDisplayedRows > 1) {
                    return true;
                }
            }
            return false;
        };

        $ctrl.columnGroupingName = function() {
            return reportHelper.getGroupingDisplayName($ctrl.control.columnGrouping, $ctrl.groupingOptions);
        };

        $ctrl.columnroupingTitle = function(){
            return "Grouping: " + $ctrl.columnGroupingName();
        };

        $ctrl.columnsInRow = function(row){
            let sum = 0;
            for(let i in row.columns) {
                sum += (parseFloat(row.columns[i].colspan) || 0);
            }
            return sum;
        };

        $ctrl.clearControlValues = function(rows) {
            rows.forEach(function(row) {
                row.columns.forEach(function(column) {
                    if (column.control.value !== '<p>Table Total</p>') {
                        column.control.value = '<p></p>';
                    }
                });
            });
        };

        $ctrl.addRowGrouping = function (index) {
            let newRowGroup = {
                name: 'Asset',
                value: 8,
                orderBy: [],
                guideRow: angular.copy($ctrl.control.rowGroupings[index].guideRow),
                overallHeader: {show: false, rows: angular.copy($ctrl.control.rowGroupings[index].overallHeader.rows) },
                header: {show: false, rows: angular.copy($ctrl.control.rowGroupings[index].header.rows) },
                body: {show:true, rows: angular.copy($ctrl.control.rowGroupings[index].body.rows) },
                footer: {show: false, rows: angular.copy($ctrl.control.rowGroupings[index].footer.rows) },
                overallFooter: {show: false, rows: angular.copy($ctrl.control.rowGroupings[index].overallFooter.rows) },
                benchmarks: angular.copy($ctrl.control.rowGroupings[index].benchmarks),
                useAlternativeLineShading: true,
                limitMethod: {limitMethod: 'None', showOtherGroup: false, otherGroupName: 'Other', count: null, threshold: null, dataSource: {path: 'Activity.Value', activityOptionId: null, dateRangeId: null}},
            };

            $ctrl.clearControlValues(newRowGroup.overallFooter.rows);

            newRowGroup = reportHelper.prepareForSave(newRowGroup);

            $ctrl.control.rowGroupings.splice(index+1, 0, newRowGroup);

            $scope.$broadcast('rb-event:init-column-resizer');
        };

        $scope.$on('rb-event:get-default-option', function(event, data){
            data.path.push($ctrl.rowGroupLevel);
        });

        $ctrl.deleteRowGrouping = function (rowGrouping) {
            groupingHelper.deleteGrouping($ctrl.control.rowGroupings, rowGrouping);
            $scope.$broadcast('rb-event:init-column-resizer');
        };

        $ctrl.insertRow = function (section, insertIndex, rowToCopy) {
            let rowIndex = $ctrl.rowGroupLevel[section].rows.indexOf(rowToCopy)+insertIndex;
            let newRow = angular.copy(rowToCopy);
            newRow.columns.forEach(function (column) {
                column.control.value = '';
            });

            $ctrl.rowGroupLevel[section].rows.insert(newRow, rowIndex);
        };

        $ctrl.deleteRow = function (section, row) {
            $ctrl.rowGroupLevel[section].rows.remove(row);
        };

        $ctrl.insertColumnLeft = function() {
            insertColumn($ctrl.current.index, $ctrl.current.row);
            $ctrl.current.index += 1;
        };

        $ctrl.insertColumnRight = function() {
            insertColumn($ctrl.current.index + 1, $ctrl.current.row);
        };

        $ctrl.insertDynamicColumnLeft = function() {
            insertColumn($ctrl.current.index, $ctrl.current.row, true);
            $ctrl.current.index += 1;
            $ctrl.current.isLeftDynamic = true;
        };

        $ctrl.insertDynamicColumnRight = function() {
            insertColumn($ctrl.current.index + 1, $ctrl.current.row, true);
            $ctrl.current.isRightDynamic = true;
        };

        $ctrl.deleteColumn = function() {
            const deleteIndex = $ctrl.current.index;
            let startDeletePosition = 0;
            for (let i = 0; i < deleteIndex; i++) {
                startDeletePosition += $ctrl.current.row.columns[i].colspan;
            }

            let positionsToDelete = (startDeletePosition).upto(startDeletePosition + ($ctrl.current.row.columns[deleteIndex].colspan - 1));
            let position = positionsToDelete.last() > 0 ? positionsToDelete.last() - 1 : positionsToDelete.last();
            let remainingWidth = 100 - parseFloat($ctrl.rowGroupLevel.guideRow[0].columns[position].width);

            let modifyColumns = function(row) {
                let currentPosition = 0;
                row.columns.forEach(function(column) {
                    let positionsHeld = currentPosition.upto(currentPosition + (column.colspan - 1));
                    let origColspan = column.colspan;

                    column.colspan = positionsHeld.subtract(positionsToDelete).length;

                    column.width = roundToPrecision(100 * parseFloat(column.width) * (column.colspan / origColspan) / remainingWidth) + '%';

                    currentPosition = positionsHeld.last() + 1;
                });

                row.columns.remove({ colspan: 0 });
                adjLastColumnWidth(row.columns);
            };

            modifyColumns($ctrl.rowGroupLevel.guideRow[0]);
            modifyColumns($ctrl.tableGuideRow[0]);

            sections.forEach(function(section) {
                $ctrl.rowGroupLevel[section].rows.forEach(function(row) {
                    modifyColumns(row);
                });
            });

            if(deleteIndex === 0 || deleteIndex === $ctrl.current.row.columns.length)
            {
                storeColumnWidths($ctrl.tableGuideRow[0].columns[0]);
            }

            initColumnResizer();

        };

        $ctrl.sectionClass = function (part, rowGroupingIndex) {
            let x = {};
            if ($ctrl.isBenchmark){
                x['oasBenchmark'+part] = true;
            }
            else{
                if(rowGroupingIndex === 0 || part === 'Detail'){
                    x['oasSection'+part] = true;
                }else{
                    x['oasTableGrouping'+part+(rowGroupingIndex)] = true;
                }
            }
            return x;
        };

        $ctrl.$onInit = function () {
            $ctrl.active = false;
            if (!$ctrl.rowGroupIndex && $ctrl.rowGroupIndex !== 0)
                $ctrl.rowGroupIndex = 0;

            setTableGuideRow();
            setGuideRow();
            initColumnResizer();

            isolate.tools = groupingHelper.buildTools($element[0]);
            isolate.ts = Date.now();
            updateToolsStyles();
            $scope.$$postDigest(function () {
                $ctrl.loadNested = true;
            });

            setTablePrivileges();

            $ctrl.filteredGroupingOptions = [];
            $ctrl._lastFilteredKeys = null;
            $ctrl.groupingOptions = reportHelper.getAllGroupingOptions();
            refreshGroupingOptions();
        };

        $ctrl.columnResizer = {
            options: {
                manualInit: true,
                precision: 3,
                onResizeEnded: function(column){storeColumnWidths(column)}
            },
            api: null
        };

        /**
         * Note: We use two arrays here because we need to be sure that we maintain the same object reference
         * to avoid an infinite digest loop.
         * 
         * @returns The array of GroupingOption names filtered by the selected run for option(s).
         */
        $ctrl.getGroupingOptions = function() {
            const filteredOptions = $ctrl.groupingOptions
                .filter(x => filterAvailableGroupingOptions(x));

            // Only rebuild the array if the filtered options have actually changed
            const currentKeys = filteredOptions.map(function (x) {
                return x.isAdHoc
                    ? (x.adhocOptionGuid || x.name)
                    : reportHelper.getGroupingSelectionKey(x);
            }).join(',');

            if ($ctrl._lastFilteredKeys !== currentKeys) {
                $ctrl.filteredGroupingOptions.length = 0;

                filteredOptions.forEach(function (x) {
                    $ctrl.filteredGroupingOptions.push(reportHelper.toGroupingMenuOption(x));
                });

                $ctrl._lastFilteredKeys = currentKeys;
            }

            return $ctrl.filteredGroupingOptions;
        };

        $scope.$watch(() => {
            return reportHelper.current.selected?.$index;
        }, () => {
            $interval(() => {
                updateToolsStyles();
            }, 100, 5);

        });

        //EVENT LISTENERS
        $scope.$on("rb-event:init-column-resizer", function (e) {
            initColumnResizer();
        });

        $scope.$on('rb-event:render-visible', function (event, view) {
            $ctrl.contextMenuIsOpen = false;
        });
    }
});

'use strict';

app.component('rcGroupingActivityLine', {
    OAS_DATA: {
        name: 'Line Chart',
        icon: 'fa-line-chart',
        category: 'Charts',
        schema: {
            $type: 'rcGroupingActivityLine',
            stacking: 'Normal',
            chartType: 'Line',
            grouping: 'Asset Class',
            groupName: null,
            barGroupName: null,
            frequency: 'Automatic',
            cumulative: true,
            orderBy: [],
            dataSource: {
                path: 'Activity.Value',
                format: null,
                activityOptionId: null,
                dateRangeId: null
            },
            config: {
                options: {
                    chart: {height: 250},
                    legend: {enabled: true, layout: 'horizontal', verticalAlign: 'bottom', align: 'center', useHTML: true}
                },
                title: {text: ''}
            },
            axes: {
                xAxis: {
                    decimalPlaces: 2,
                    hideSymbol: false
                },
                yAxis: {
                    decimalPlaces: 2,
                    hideSymbol: false
                }
            },
            xAxisLabelOrientation: {
                orientation: 'Auto'
            },
            yAxisLocation: 'Default',
            limitMethod: {
                limitMethod: 'None',
                showOtherGroup: false,
                otherGroupName: 'Other',
                count: 1,
                threshold: 0.01,
                dataSource: {
                    path: 'Activity.Value',
                    activityOptionId: null,
                    dateRangeId: null
                }
            },
        }
    },
    templateUrl: 'reporting/envision/components/report-controls/rcChart.html',
    bindings: {
        control: '<'
    },
    controller: function (reportHelper, $scope) {
        var $ctrl = this;

        var initialConfig = {
            options: {
                xAxis: {type: 'datetime'},
                yAxis: [{opposite: false}],
                plotOptions: {
                    series: {marker: {enabled: false, radius: 4}},
                    area: {
                        $type: 'HighchartsAreaPlotOption',
                        stacking: 'normal',
                        marker: {enabled: false, symbol: 0, radius: 0}
                    }
                },
                tooltip: {enabled: false}
            },
            credits: {enabled: false},
            series: []
        };

        //PRIVATE METHODS
        function getActivityOptions() {
            reportHelper.getOptions('activity')
                .then(function (activtyOptions) {
                    $ctrl.activtyOptions = activtyOptions;
                    setSeriesData();
                });
            reportHelper.getDefault('activity')
                .then(function (activityDefault) {
                    $ctrl.activityDefault = activityDefault.name;
                });
        }

        function setYAxisLocation(location) {
            initialConfig.options.yAxis = [];
            initialConfig.options.yAxis.push({opposite: false});

            switch (location) {
                case 'Both':
                    initialConfig.options.yAxis[0].opposite = false;
                    initialConfig.options.yAxis.push({linkedTo: 0, opposite: true, title: {text: undefined}});
                    break;
                case 'Opposite':
                    initialConfig.options.yAxis[0].opposite = true;
                    break;
                default:
                    initialConfig.options.yAxis[0].opposite = false;
                    break;
            }
        }

        function setPlotOptions() {
            var interval = 1;
            var unit = 'day';
            var yearModifier = 0;
            switch ($ctrl.control.frequency) {
                case 'Annually':
                    interval = 1;
                    unit = 'year';
                    yearModifier = 11;
                    break;
                case 'Quarterly':
                    interval = 3;
                    unit = 'month';
                    yearModifier = 3;
                    break;
                case 'Monthly':
                    interval = 1;
                    unit = 'month';
                    break;
                case 'Weekly':
                    interval = 7;
                    unit = 'day';
                    break;
                // case Summary:
                // case Daily:
                // case Automatic:
                //Use Defaults
            }

            var n = new Date().getFullYear() - yearModifier;
            initialConfig.options.plotOptions.series.pointStart = Date.UTC(n, 0, 1);
            initialConfig.options.plotOptions.series.pointInterval = interval;
            initialConfig.options.plotOptions.series.pointIntervalUnit = unit;

            initialConfig.options.plotOptions.area.stacking = $ctrl.control.stacking.toLowerCase();
            if ($ctrl.control.grouping === 'Self' && $ctrl.control.fillContextChange)
                initialConfig.options.plotOptions.series.marker = false;

            setYAxisLocation($ctrl.control.yAxisLocation);
        }

        function getLegendName(dataSource, defaultName) {
            let legendName = defaultName;

            if (dataSource.activityOption) {
                const foundOption = $ctrl?.activtyOptions?.find({ guid: dataSource.activityOption.globalOptionGuid });
                legendName = foundOption?.name || legendName;
            } else if (dataSource.activityOptionId) {
                const foundOption = $ctrl?.activtyOptions?.find({ optionId: dataSource.activityOptionId });
                legendName = foundOption?.name || legendName;
            } else if ($ctrl.activityDefault) {
                legendName = $ctrl.activityDefault;
            }

            return legendName;
        }

        function setSeriesData() {
            initialConfig.series.length = 0;
            if ($ctrl.control.grouping === 'Self' && $ctrl.control.fillContextChange) {
                var fillName = getLegendName($ctrl.control.fillContextChange, 'Fill');
                var valueName = getLegendName($ctrl.control.dataSource, 'Total Value');

                initialConfig.series.push({name: valueName, data: []});
                initialConfig.series.push({
                    name: fillName,
                    type: 'area',
                    lineWidth: 0,
                    fillOpacity: 0.3,
                    data: []
                });
                for (var y = 1; y <= 12; y++) {
                    var x1 = Math.floor((Math.random() * 100) + 1);
                    var x2 = Math.floor((Math.random() * 25) + 25);
                    initialConfig.series[0].data.push(x1);
                    initialConfig.series[1].data.push([x1 + x2]);
                }
            } else {
                var groups = Math.floor(Math.random() * 3) + 2;
                var isSelf = $ctrl.control.grouping === 'Self';
                var valueName = $ctrl.control.groupingLabel;
                if (isSelf) {
                    groups = 1;
                    valueName = getLegendName($ctrl.control.dataSource, $ctrl.control.groupingLabel);
                }
                for (var i = 1; i <= groups; i++) {
                    var intervalData = populateIntervalArray();

                    initialConfig.series.push({
                        name: isSelf ? valueName : valueName + ' ' + i,
                        type: $ctrl.control.chartType.toLowerCase(),
                        className: "highcharts-line-series highcharts-color-" + (i - 1),
                        data: populateIntervalSeriesData(intervalData),
                        colorIndex: (i - 1)
                    });

                    if ($ctrl.control.includeIntervalBars) {
                        initialConfig.series.push({
                            name: isSelf ? valueName : valueName + ' ' + i,
                            type: 'column',
                            className: "highcharts-column-series highcharts-color-" + (i - 1),
                            data: intervalData,
                            colorIndex: (i - 1)
                        });
                    }
                }
            }
        }

        function populateIntervalArray(range = 10) {
            var data = [];

            data.push(0);

            for (var n = 1; n < 12; n++) {
                //random values between positive/negative range (default: -10 to 10)
                data.push(Math.ceil(Math.random() * (range + range)) - range);
            }

            return data;
        }

        function populateIntervalSeriesData(intervalData) {
            var data = [];

            function getFactor(value) {
                return 1 + value / 100;
            }

            function undoFactor(value) {
                return (value - 1) * 100;
            }

            data.push(0);

            // line is rolling product of value of bars
            for (var x = 1; x < intervalData.length; x++) {
                var value = getFactor(intervalData[x]);

                for (var i = 1; i < x; i++) {
                    value *= getFactor(intervalData[i]);
                }

                data.push(undoFactor(value));
            }

            return data;
        }

        function setXAxisLabelOrientation(ori) {
            if (ori.orientation !== 'Auto') {
                let labels = {
                    rotation: ori.rotation,
                    align: ori.alignment.toLowerCase()
                };

                initialConfig.options.xAxis.labels = labels;
            } else {
                delete initialConfig.options.xAxis.labels;
            }
        }

        function updateChartConfig() {
            $ctrl.chartConfig = angular.merge(initialConfig, $ctrl.control.config);
            setXAxisLabelOrientation($ctrl.control.xAxisLabelOrientation);
        }

        $scope.$on('reloadLineChart', function () {
            setSeriesData();
            setPlotOptions();
            updateChartConfig();
        });

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            getActivityOptions();
            setSeriesData();
            setPlotOptions();
            updateChartConfig();
        };

        $ctrl.$onChanges = function (changes) {
            if (changes.control.currentValue.grouping !== changes.control.previousValue.grouping ||
                changes.control.currentValue.chartType !== changes.control.previousValue.chartType ||
                (changes.control.currentValue.grouping === 'Self' && $ctrl.control.dataSource.activityOptionId !== changes.control.previousValue.dataSource.activityOptionId) ||
                (!changes.control.currentValue.fillContextChange && changes.control.previousValue.fillContextChange) ||
                (changes.control.currentValue.fillContextChange && !changes.control.previousValue.fillContextChange) ||
                (changes.control.currentValue.fillContextChange && changes.control.previousValue.fillContextChange &&
                    changes.control.currentValue.fillContextChange.activityOptionId !== changes.control.previousValue.fillContextChange.activityOptionId) ||
                changes.control.currentValue.includeIntervalBars !== changes.control.previousValue.includeIntervalBars
            ) {
                reportHelper.setGroupingValuesForCharts($ctrl.control);
                setSeriesData();
            }
            setPlotOptions();
            updateChartConfig();
        };
    }
});
'use strict';

app.component('rcGroupingActivityDonut', {
    OAS_DATA: {
        name: 'Donut Chart',
        icon: 'fa-pie-chart',
        category: 'Charts',
        schema: {
            $type: 'rcGroupingActivityDonut',
            grouping1: 'Asset Category',
            grouping2: 'Asset Class',
            groupName1: null,
            groupName2: null,
            orderBy: [],
            dataSource: {
                path: 'Activity.Value',
                activityOptionId: null,
                dateRangeId: null
            },
            config: {
                title: {text: ''},
                options: {
                    chart: {height: 250},
                    legend: {enabled: false},
                    plotOptions: {pie: {$type: 'HighchartsPiePlotOption', innerSize: 30, showInLegend: true, dataLabels: {enabled: true}}}
                }
            },
            limitMethod: {
                limitMethod: 'None',
                showOtherGroup: false,
                otherGroupName: 'Other',
                count: 1,
                threshold: 0.01,
                dataSource: {
                    path: 'Activity.Value',
                    activityOptionId: null,
                    dateRangeId: null
                }
            },
        },
    },
    templateUrl: 'reporting/envision/components/report-controls/rcChart.html',
    bindings: {
        control: '<'
    },
    controller: function ($scope, reportHelper) {
        var $ctrl = this;

        var initialConfig = {
            options: {
                chart: {type: 'pie'},
                plotOptions: {pie: {$type: 'HighchartsPiePlotOption', innerSize: 30, showInLegend: true, dataLabels: {enabled: true}}},
                tooltip: {enabled: false}
            },
            credits: {enabled: false},
            series: []
        };


        //PRIVATE METHODS
        function label1() {
            return $ctrl.control.groupingLabel1 != null ? $ctrl.control.groupingLabel1 : $ctrl.control.grouping1;
        }
        function label2() {
            return $ctrl.control.groupingLabel2 != null ? $ctrl.control.groupingLabel2 : $ctrl.control.grouping2;
        }
        function label3() {
            return $ctrl.control.groupingLabel3 != null ? $ctrl.control.groupingLabel3 : $ctrl.control.grouping3;
        }

        function setSeriesData() {
            initialConfig.series.length = 0;
            var drillDownDataPoints = Math.floor(Math.random() * 2) + 2;  //random between 2 and 3
            initialConfig.series.push({size: $ctrl.control.grouping3 ? '68%' : '100%', dataLabels: {distance: -10}, data: []});
            if ($ctrl.control.grouping3) {
                initialConfig.series[0].innerSize = '33%';
            }

            for (var i = 1; i <= 2; i++) {
                var yValue = Math.floor((Math.random() * 100) + 1);
                initialConfig.series[0].data.push({
                    name: label1() + " " + i,
                    y: yValue,
                    className: "entity " + $ctrl.control.grouping1 + "-" + i
                });
                if ($ctrl.control.grouping2) {
                    initialConfig.series.push({size: $ctrl.control.grouping3 ? '68%' : '100%', innerSize: $ctrl.control.grouping3 ? '68%': '80%', data: []});
                    for (var n = 1; n <= drillDownDataPoints; n++) {
                        initialConfig.series[1].data.push({
                            name: label2() + " " + n,
                            y: Math.floor(yValue / n),
                            className: "entity " + $ctrl.control.grouping2 + "-" + n
                        });
                    }
                }
                if ($ctrl.control.grouping3) {
                    initialConfig.series.push({size: '100%', innerSize: '70%', data: []});
                    for (var n = 1; n <= drillDownDataPoints; n++) {
                        initialConfig.series[2].data.push({
                            name: label3() + " " + n,
                            y: Math.floor(yValue / n),
                            className: "entity " + $ctrl.control.grouping3 + "-" + n
                        });
                    }
                }
            }
        }

        function updateChartConfig() {
            $ctrl.chartConfig = angular.merge(initialConfig, $ctrl.control.config);
        }

        $scope.$on('reloadDonutChart', function () {
            reportHelper.setGroupingValuesForCharts($ctrl.control);
            setSeriesData();
            updateChartConfig();
        });


        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            reportHelper.setGroupingValuesForCharts($ctrl.control);
            setSeriesData();
            updateChartConfig();
        };

        $ctrl.$onChanges = function (changes) {
            if (!changes.control) {
                return;
            }
            var cur = changes.control.currentValue;
            var prev = changes.control.previousValue || {};
            if (cur.grouping1 !== prev.grouping1 || cur.grouping2 !== prev.grouping2 || cur.grouping3 !== prev.grouping3) {
                reportHelper.setGroupingValuesForCharts($ctrl.control);
                setSeriesData();
            }
            updateChartConfig();
        };
    }
});
'use strict';

app.component('rcGroupingContextMenu', {
    templateUrl: 'reporting/envision/components/report-controls/rcGroupingContextMenu.html',
    bindings: {
        options: '<?',
        ngModel: '=',
        groupLevel: '<?',
        groupHeader: '@',
        ngChange: '&',
    },
    transclude: false,
    controller: function($scope, $element, reportHelper) {
        var $ctrl = this;

        function menuOpened() {
            $element.find('.active')[0]?.scrollIntoView();
        }

        function isAdHocSelection() {
            if (!reportHelper.getAdhocGuidFromGroupingLevel($ctrl.groupLevel)) {
                return false;
            }

            if (typeof reportHelper.isPersistedAdHocGroupingValue === 'function') {
                return reportHelper.isPersistedAdHocGroupingValue($ctrl.ngModel);
            }

            return $ctrl.ngModel === -32692 || $ctrl.ngModel === 'Ad Hoc Grouping';
        }

        $ctrl.isOptionActive = function(option) {
            if (option.isAdHoc) {
                if (!isAdHocSelection()) {
                    return false;
                }

                const adhocGuid = reportHelper.getAdhocGuidFromGroupingLevel($ctrl.groupLevel);
                return adhocGuid != null && adhocGuid === option.adhocOptionGuid;
            }

            if (typeof reportHelper.groupingOptionMatchesGroupLevel === 'function') {
                return reportHelper.groupingOptionMatchesGroupLevel(option, $ctrl.groupLevel, $ctrl.ngModel)
                    && !isAdHocSelection();
            }

            if (typeof reportHelper.groupingOptionMatchesPersistedValue === 'function') {
                return reportHelper.groupingOptionMatchesPersistedValue(option, $ctrl.ngModel) && !isAdHocSelection();
            }

            return ($ctrl.ngModel === option.value
                || $ctrl.ngModel === option.grouping
                || $ctrl.ngModel === option.name)
                && !isAdHocSelection();
        };

        $ctrl.selectOption = function(option) {
            $ctrl.changed(option);
        };

        $ctrl.changed = function(selectedOption) {
            if ($ctrl.ngChange) {
                const value = selectedOption != null ? selectedOption.value : $ctrl.ngModel;
                $ctrl.ngChange({ value: value, option: selectedOption });
            }

            $ctrl.name = getName();
        };

        $ctrl.$onInit = function() {
            $element.find('[data-test-id="selected-context-menu-item"]').on('mouseenter', menuOpened);
            $ctrl.name = getName();
        };

        $scope.$watch(function() {
            return [
                $ctrl.ngModel,
                $ctrl.groupLevel && $ctrl.groupLevel.name,
                $ctrl.groupLevel && $ctrl.groupLevel.groupingLevelOption,
                $ctrl.groupLevel && $ctrl.groupLevel.userDefinedFieldDefinitionId,
            ];
        }, function() {
            $ctrl.name = getName();
        }, true);

        function getName() {
            if ($ctrl.groupLevel) {
                return reportHelper.getGroupingDisplayName($ctrl.groupLevel, $ctrl.options || []);
            }

            return ($ctrl.options || []).find(function(option) {
                if (typeof reportHelper.groupingOptionMatchesGroupLevel === 'function') {
                    return reportHelper.groupingOptionMatchesGroupLevel(option, $ctrl.groupLevel, $ctrl.ngModel);
                }

                if (typeof reportHelper.groupingOptionMatchesPersistedValue === 'function') {
                    return reportHelper.groupingOptionMatchesPersistedValue(option, $ctrl.ngModel);
                }

                return option.value === $ctrl.ngModel || option.grouping === $ctrl.ngModel || option.name === $ctrl.ngModel;
            })?.name;
        }
    },
});

'use strict';

app.component('rcGroupingPie', {
    OAS_DATA: {
        name: 'Pie Chart',
        icon: 'fa-pie-chart',
        category: 'Charts',
        schema: {
            $type: 'rcGroupingPie',
            grouping: 'Asset Class',
            groupName: null,
            orderBy: [],
            dataSource: {
                path: 'Activity.Value',
                activityOptionId: null,
                dateRangeId: null
            },
            config: {
                title: { text: '', useHtml: true },
                options: {
                    chart: {height: 250},
                    legend: {enabled: false},
                    plotOptions: {pie: {$type: 'HighchartsPiePlotOption', showInLegend: true, dataLabels: {enabled: true, padding: 1}}},
                }
            },
            limitMethod: {
                limitMethod: 'None',
                showOtherGroup: false,
                otherGroupName: 'Other',
                count: 1,
                threshold: 0.01,
                dataSource: {
                    path: 'Activity.Value',
                    activityOptionId: null,
                    dateRangeId: null
                }
            },
        }
    },
    templateUrl: 'reporting/envision/components/report-controls/rcChart.html',
    bindings: {
        control: '<'
    },
    controller: function ($scope, reportHelper) {
        var $ctrl = this;

        var initialConfig = {
            options: {
                chart: {type: 'pie'},
                plotOptions: {pie: {showInLegend: true, dataLabels: {enabled: true, padding: 1}}},
                tooltip: {enabled: false}
            },
            credits: {enabled: false},
            series: [{data: []}]
        };


        //PRIVATE METHODS
        function setSeriesData() {
            var totalDataPoints = Math.floor(Math.random() * 5) + 3;  //random between 3 and 8
            for (var i = 1; i <= totalDataPoints; i++) {
                initialConfig.series[0].data.push({
                    name: $ctrl.control.groupingLabel + " " + i,
                    y: Math.floor((Math.random() * 100) + 1),
                    className: "entity " + $ctrl.control.grouping + "-" + i
                });
            }
        }

        function updateChartConfig() {
            $ctrl.chartConfig = angular.merge(initialConfig, $ctrl.control.config);
        }

        $scope.$on('reloadPieChart', function () {
            initialConfig.series[0].data.length = 0;
            setSeriesData();
            updateChartConfig();
        });


        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            reportHelper.setGroupingValuesForCharts($ctrl.control);
            setSeriesData();
            updateChartConfig();
        };

        $ctrl.$onChanges = function (changes) {
            if (!changes.control || !changes.control.currentValue) {
                return;
            }

            const previousGrouping = changes.control.previousValue?.grouping;
            if (changes.control.currentValue.grouping !== previousGrouping) {
                initialConfig.series[0].data.length = 0;
                reportHelper.setGroupingValuesForCharts($ctrl.control);
                setSeriesData();
            }
            updateChartConfig();
        };
    }
});
'use strict';

app.component('rcGroupingTable', {
    OAS_DATA: {
        name: 'Advanced Table',
        icon: 'fa-table',
        category: 'Tables',
        schema: {
            $type: 'rcGroupingTable',
            groupings: [{
                name: 'Asset',
                value: 8,
                orderBy: [],
                guideRow: [],
                useAlternativeLineShading: true,
                limitMethod: {
                    limitMethod: 'None',
                    showOtherGroup: false,
                    otherGroupName: 'Other',
                    count: 1,
                    threshold: 0.01,
                    dataSource: {
                        path: 'Activity.Value',
                        activityOptionId: null,
                        dateRangeId: null
                    }
                },
                overallHeader: {
                    show: true,
                    rows: [{
                        columns: [{
                            name: 'Head1',
                            control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Column Header 1'},
                            colspan: 1,
                            width: '33.3%'
                        },
                            {
                                name: 'Head2',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Column Header 2'},
                                colspan: 1,
                                width: '33.3%'
                            },
                            {
                                name: 'Head3',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Column Header 3'},
                                colspan: 1,
                                width: '33.4%'
                            }]
                    }]
                },
                header: {
                    show: false,
                    rows: [{
                        columns: [{
                                name: 'Head1',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Group Label'},
                                colspan: 1,
                                width: '33.3%'
                            },
                            {
                                name: 'Head2',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: '&nbsp;'},
                                colspan: 1,
                                width: '33.3%'
                            },
                            {
                                name: 'Head3',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: '&nbsp;'},
                                colspan: 1,
                                width: '33.4%'
                            }]
                    }]
                },
                body: {
                    show: true,
                    rows: [{
                        columns: [{
                            name: 'Column1',
                            control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Data Column 1'},
                            colspan: 1,
                            width: '33.3%'
                            },
                            {
                                name: 'Column2',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Data Column 2'},
                                colspan: 1,
                                width: '33.3%'
                            },
                            {
                                name: 'Column3',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Data Column 3'},
                                colspan: 1,
                                width: '33.4%'
                        }]
                    }]
                },
                footer: {
                    show: false,
                    rows: [{
                        columns: [{
                            name: 'Foot1',
                            control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Group Total'},
                            colspan: 1,
                            width: '33.3%'
                        },
                            {
                                name: 'Foot2',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: '&nbsp;'},
                                colspan: 1,
                                width: '33.3%'
                            },
                            {
                                name: 'Foot3',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Total'},
                                colspan: 1,
                                width: '33.4%'
                            }]
                    }]
                },
                overallFooter: {
                    show: false,
                    rows: [{
                        columns: [{
                            name: 'Foot1',
                            control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Table Total'},
                            colspan: 1,
                            width: '33.3%'
                        },
                            {
                                name: 'Foot2',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: '&nbsp;'},
                                colspan: 1,
                                width: '33.3%'
                            },
                            {
                                name: 'Foot3',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Total'},
                                colspan: 1,
                                width: '33.4%'
                            }]
                    }]
                },
                benchmarks: {
                    show: false,
                    guideRow: [],
                    contextChange: {},
                    overallHeader: {
                        show: false,
                        rows: [{
                            columns: [{
                                name: 'Head1',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Benchmark Label'},
                                colspan: 1,
                                width: '33.3%'
                            },
                                {
                                    name: 'Head2',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: '&nbsp;'},
                                    colspan: 1,
                                    width: '33.3%'
                                },
                                {
                                    name: 'Head3',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: '&nbsp;'},
                                    colspan: 1,
                                    width: '33.4%'
                                }]
                        }]
                    },
                    header: {
                        show: false,
                        rows: [{
                            columns: [{
                                name: 'Head1',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'bmrecordhead1 value'},
                                colspan: 1,
                                width: '33.3%'
                            },
                                {
                                    name: 'Head2',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'bmrecordhead2 value'},
                                    colspan: 1,
                                    width: '33.3%'
                                },
                                {
                                    name: 'Head3',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'bmrecordhead3 value'},
                                    colspan: 1,
                                    width: '33.4%'
                                }]
                        }]
                    },
                    body: {
                        show: true,
                        rows: [{
                            columns: [{
                                name: 'Column1',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: '<section>[@{"path":"Benchmark.Name"}@]</section>'},
                                colspan: 1,
                                width: '33.3%'
                            },
                                {
                                    name: 'Column2',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Benchmark Value'},
                                    colspan: 1,
                                    width: '33.3%'
                                },
                                {
                                    name: 'Column3',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Benchmark Value'},
                                    colspan: 1,
                                    width: '33.4%'
                                }]
                        }]
                    },
                    footer: {
                        show: false,
                        rows: [{
                            columns: [{
                                name: 'Foot1',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'bmrecordfoot1 value'},
                                colspan: 1,
                                width: '33.3%'
                            },
                                {
                                    name: 'Foot2',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'bmrecordfoot2 value'},
                                    colspan: 1,
                                    width: '33.3%'
                                },
                                {
                                    name: 'Foot3',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'bmrecordfoot3 value'},
                                    colspan: 1,
                                    width: '33.4%'
                                }]
                        }]
                    },
                    overallFooter: {
                        show: false,
                        rows: [{
                            columns: [{
                                name: 'Foot1',
                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Benchmark Total'},
                                colspan: 1,
                                width: '33.3%'
                            },
                                {
                                    name: 'Foot2',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: '&nbsp;'},
                                    colspan: 1,
                                    width: '33.3%'
                                },
                                {
                                    name: 'Foot3',
                                    control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Total'},
                                    colspan: 1,
                                    width: '33.4%'
                                }]
                        }]
                    },
                },
            }]
        },
        canUseInCoverPage: true,
        canUseInQueryBuilder: true
    },
    templateUrl: 'reporting/envision/components/report-controls/rcGroupingTable.html',
    bindings: {
        control: '<',
        groupIndex: '<',
        isBenchmark: '<'
    },
    controller: function ($interval, $element, $scope, $route, reportHelper, groupingHelper, $oasRights) {
        let $ctrl = this, isolate = {css: {}};
        $ctrl.loadNested = false;
        $ctrl.groupingOptions = [];
        $ctrl.filteredGroupingOptions = [];
        $ctrl._lastFilteredKeys = null;

        Object.defineProperties($ctrl, {
            focused: {
                get: function () {
                    return (
                        reportHelper.current.selected === $ctrl.control ||
                        reportHelper.current.hovered === $ctrl.control
                    );
                }
            },
            groupLevel: {
                get: function () {
                    if (!$ctrl.control || !$ctrl.control.groupings) {
                        return null;
                    }
                    return $ctrl.isBenchmark ? $ctrl.control.groupings[$ctrl.groupIndex].benchmarks : $ctrl.control.groupings[$ctrl.groupIndex];
                }
            },
            resolveType: {
                get: function () {
                    switch ($route.current.$$route.controller) {
                        case 'ReportingEnvisionCoverPageItemCtrl':
                            return 'coverPage';
                        case 'ReportEditorCtrl':
                        case 'SubReportEditorCtrl':
                            return 'reportEditor';
                        default:
                            return '';
                    }
                }
            },
            css: {
                get: function () {
                    return isolate.css;
                }
            }
        });

        $ctrl.groupLevelUpdated = function () {
            //clear all context changes when the grouping is changed
            $ctrl.groupLevel.contextChange = {};
            $ctrl.groupLevel.contextChanges = [];

            if ($ctrl.groupLevel.name === 'Time') {
                $ctrl.groupLevel.contextChange = {
                    dateRangeId: null,
                    returnStyle: {
                        frequency: 'Annually',
                        basedOn: 'Calendar',
                        breakBehavior: 'AllowPartialPeriods',
                        cumulative: false,
                        context: 'Self',
                    }
                };
            }
        };

        $ctrl.current ={
            index:0,
            row:{},
            col:{}
        };
        //PRIVATE letIABLES
        let sections = ['overallHeader','header', 'body', 'footer','overallFooter'];

        //PRIVATE METHODS
        function setGuideRow(){
            if ($ctrl.control.disabled){
                return;
            }

            let guideRow = [];
            let hasGuideRow = sections.some(function(section){
                $ctrl.groupLevel[section].rows.some(function(row){
                    if (row.columns.all({colspan:1})) {
                        guideRow.push(angular.copy(row));
                        return true;
                    }
                });

                if (guideRow.length > 0) return true;
            });

            if(hasGuideRow) {
                $ctrl.groupLevel.guideRow = guideRow;
            }
            else {
                //could not find a row with no merged columns to use as guide row so create one
                for(let section of sections){
                    for(let row of $ctrl.groupLevel[section].rows) {
                            if (row.columns !== null) {
                                let newRow = {columns: []};
                                row.columns.forEach(function (column) {
                                    if(column.colspan === 1) {
                                        newRow.columns.push(angular.copy(column));
                                    }
                                    else {
                                        for(let i=0; i < column.colspan; i++) {
                                            let newColumn = {
                                                name: 'newColumn'+i,
                                                control: {$type: 'rcStringResolverCompact', isHtml: true, value: ''},
                                                colspan: 1,
                                                width: (parseFloat(column.width) / column.colspan) + '%'
                                            };
                                            newRow.columns.push(newColumn);
                                        }
                                    }
                                });
                                guideRow.push(newRow);
                                break;
                            }
                        }
                    if (guideRow.length > 0) break;
                }
                $ctrl.groupLevel.guideRow = guideRow;
            }
        }

        function columnWidthSum(columns){
            let totalWidth = 0;
            columns.forEach(function (column) {
                totalWidth += parseFloat(column.width);
            });
            return totalWidth;
        }

        function adjLastColumnWidth(columns) {
            let widthDiff = 100 - columnWidthSum(columns);
            //add the diff to the last column
            columns.last().width = roundToPrecision(parseFloat(columns.last().width) + widthDiff) + "%";
        }

        function roundToPrecision(num){
            const adj = Math.pow(10, $ctrl.columnResizer.options.precision);
            return Math.round(num * adj) / adj;
        }

        let updateToolsStyles = (function updateToolsStyles() {
            if (!isolate.tools) {
                return;
            }

            Object.keys(isolate.tools).forEach(t => groupingHelper.setToolCss(t, isolate, $element));
        }).debounce(50);

        function initColumnResizer() {
            $scope.$$postDigest(function () {
                $ctrl.columnResizer.api.update();
            });
        }

        function storeColumnWidths() {
            const widths = $ctrl.columnResizer.api.getWidths();

            let setColWidth = function(row){
                let index = 0;
                let colWidth = 0;
                for (let i = 0; i < row.columns.length; i++) {
                    colWidth += parseFloat(widths[index]);
                    if (row.columns[i].colspan === 1){
                        row.columns[i].width = roundToPrecision(colWidth) + '%';
                        colWidth = 0;
                        index++;
                    }
                    else{
                        for (let idx = index+1; idx < index + row.columns[i].colspan; idx++ ){
                            colWidth += parseFloat(widths[idx]);
                        }
                        row.columns[i].width = roundToPrecision(colWidth) + '%';
                        colWidth = 0;
                        index += row.columns[i].colspan;
                    }
                }
            };

            setColWidth($ctrl.groupLevel.guideRow[0]);
            sections.each(function (section) {
                $ctrl.groupLevel[section].rows.each(function(row){
                    setColWidth(row);
                });
            });


            if ($ctrl.groupIndex === 0 && !$ctrl.isBenchmark){
                //if the colspan = number of guiderow colspan, then set colwidths the same
                for (let lev = 0; lev < $ctrl.control.groupings.length; lev++) {
                    //check top level guide row against guide row of children groupings
                    if (($ctrl.groupLevel.guideRow[0].columns.sum('colspan') === $ctrl.control.groupings[lev].guideRow[0].columns.sum('colspan')) && lev !== 0  ){
                        setColWidth($ctrl.control.groupings[lev].guideRow[0]);
                        sections.each(function (section) {
                            $ctrl.control.groupings[lev][section].rows.each(function(row){
                                setColWidth(row);
                            });
                        });
                    }

                    //check top level guide row against all benchmarks guide rows.
                    if ($ctrl.control.groupings[lev].benchmarks.guideRow && $ctrl.control.groupings[lev].benchmarks.guideRow.length > 0 && $ctrl.groupLevel.guideRow[0].columns.sum('colspan') === ($ctrl.control.groupings[lev].benchmarks.guideRow[0].columns.sum('colspan'))){
                        setColWidth($ctrl.control.groupings[lev].benchmarks.guideRow[0]);
                        sections.each(function (section) {
                            $ctrl.control.groupings[lev].benchmarks[section].rows.each(function(row){
                                setColWidth(row);
                            });
                        });
                    }
                }
            }

            initColumnResizer();

        }

        function appendInnerNodes(target, sourceNode) {
            if (sourceNode.nodeType === Node.ELEMENT_NODE) {
                while (sourceNode.firstChild) {
                    target.appendChild(sourceNode.firstChild);
                }
                return;
            }

            target.appendChild(sourceNode);
        }

        function mergeSingleChildCellContents(leftCell, rightCell) {
            const leftChild = leftCell.removeChild(leftCell.firstChild);
            const rightChild = rightCell.removeChild(rightCell.firstChild);

            appendInnerNodes(leftCell, leftChild);
            leftCell.appendChild(document.createTextNode(' '));
            appendInnerNodes(leftCell, rightChild);
        }

        function mergeColumns(leftColumn, rightColumn, row) {
            let leftCell = document.createElement('div'),
                rightCell = document.createElement('div');

            leftCell.innerHTML = leftColumn.control.value;
            rightCell.innerHTML = rightColumn.control.value;

            if(rightCell.hasChildNodes() && rightCell.textContent.length !== 0) {
                if(leftCell.childNodes.length === 1 && rightCell.childNodes.length === 1) {
                    mergeSingleChildCellContents(leftCell, rightCell);
                } else {
                    Array.from(rightCell.childNodes||[]).forEach(function(node){
                        leftCell.appendChild(node);
                    });
                }
            }

            leftColumn.colspan += rightColumn.colspan;
            leftColumn.control.value = leftCell.innerHTML;
            leftColumn.width = (parseFloat(leftColumn.width) + parseFloat(rightColumn.width)) + "%";

            row.columns.remove(rightColumn);
        }

        function addNewColumnToRow(row, index) {
            row.columns.insert({
                name: 'New Column',
                control: { $type: 'rcStringResolverCompact', isHtml: true, value: 'New Value' },
                colspan: 1,
                width: roundToPrecision(100 - columnWidthSum(row.columns)) + '%',
            }, index);
        }

        function insertColumn(insertIndex, row) {
            let numColumns = $ctrl.columnsInRow(row);
            let defaultWidth = 100 / (numColumns + 1);

            const positionLeftOfInsert = groupingHelper.findPositionLeftOfInsert(insertIndex, row.columns);

            let modifyColumns = function(row) {
                //adjust the widths of column
                row.columns.forEach(function(column) {
                    column.width = roundToPrecision(parseFloat(column.width) * (1 - defaultWidth / 100)) + '%';
                });

                if (positionLeftOfInsert === -1) {
                    addNewColumnToRow(row, 0);
                } else if (positionLeftOfInsert === -99) {
                    addNewColumnToRow(row, row.columns.length);
                } else {
                    let currentPosition = 0;
                    let columns = angular.copy(row.columns);

                    row.columns.each(function(column, index) {
                        let positionsHeld = currentPosition.upto(currentPosition + (column.colspan - 1));

                        if (positionsHeld.any(positionLeftOfInsert)) {
                            if (positionsHeld.last() === positionLeftOfInsert) {
                                addNewColumnToRow(row, index + 1);
                            } else {
                                column.colspan += 1;
                                column.width = roundToPrecision(parseFloat(column.width) + (100 - columnWidthSum(row.columns))) + '%';
                            }

                            return false; //break out of loop
                        }
                        currentPosition = positionsHeld.last() + 1;
                    });
                }
            };

            modifyColumns($ctrl.groupLevel.guideRow[0]);

            sections.forEach(function(section) {
                $ctrl.groupLevel[section].rows.forEach(function(row) {
                    modifyColumns(row);
                });
            });

            initColumnResizer();
        }

        function filterAvailableGroupingOptions(groupingOption) {
            return reportHelper.filterGroupingOptionsByAllowedEntityTypes(groupingOption);
        };

        function setTablePrivileges() {
            $scope.hasAdvancedEditorRights = $ctrl.control.canEdit || $oasRights.canRead("REPORTBUILDERADVANCEDEDITOR");
        };

        //PUBLIC METHODS
        $ctrl.updateContext = function(section, row, index) {
            $ctrl.current.row = row;
            $ctrl.current.index = index;
            $ctrl.current.section = section;
        };

        $ctrl.overallName = function() {
            return $ctrl.isBenchmark ? $ctrl.groupingName() : 'Table';
        };

        $ctrl.groupingName = function() {
            return reportHelper.getGroupingDisplayName($ctrl.control.groupings[$ctrl.groupIndex], $ctrl.groupingOptions) + ($ctrl.isBenchmark ? " Benchmarks" : "");
        };

        $ctrl.groupingTitle = function(){
            return "Grouping: " + $ctrl.groupingName();
        };

        $ctrl.isRowDisplayed = function(){
            let sectionsWithDisplayedRows = 0;
            for (let i in sections) {
                let section = $ctrl.groupLevel[sections[i]];
                if (section && section.show && section.rows.length > 0)
                    ++sectionsWithDisplayedRows;

                if(sectionsWithDisplayedRows > 1) return true;
            }
            return false;
        };

        $ctrl.columnsInRow = function(row){
            let sum = 0;
            for(let i in row.columns) {
                sum += (parseFloat(row.columns[i].colspan) || 0);
            }
            return sum;
        };

        $ctrl.clearControlValues = function(rows) {
            rows.forEach(function(row) {
                row.columns.forEach(function(column) {
                    if (column.control.value !== '<p>Table Total</p>') {
                        column.control.value = '<p></p>';
                    }
                });
            });
        };

        $ctrl.addGrouping = function (index) {
            let newGroup = {
                name: 'Asset',
                value: 8,
                orderBy: [],
                guideRow: angular.copy($ctrl.control.groupings[index].guideRow),
                overallHeader: {show: false, rows: angular.copy($ctrl.control.groupings[index].overallHeader.rows) },
                header: {show: false, rows: angular.copy($ctrl.control.groupings[index].header.rows) },
                body: {show:true, rows: angular.copy($ctrl.control.groupings[index].body.rows) },
                footer: {show: false, rows: angular.copy($ctrl.control.groupings[index].footer.rows) },
                overallFooter: {show: false, rows: angular.copy($ctrl.control.groupings[index].overallFooter.rows) },
                benchmarks: angular.copy($ctrl.control.groupings[index].benchmarks),
                useAlternativeLineShading: true,
                limitMethod: {limitMethod: 'None', showOtherGroup: false, otherGroupName: 'Other', count: null, threshold: null, dataSource: {path: 'Activity.Value', activityOptionId: null, dateRangeId: null}},
            };

            $ctrl.clearControlValues(newGroup.overallFooter.rows);

            newGroup = reportHelper.prepareForSave(newGroup);

            $ctrl.control.groupings.splice(index+1, 0, newGroup);

            $scope.$broadcast('rb-event:init-column-resizer');
        };

        $scope.$on('rb-event:get-default-option', function(event, data){
            data.path.push($ctrl.groupLevel);
        });

        $ctrl.deleteGrouping = function (grouping) {
            groupingHelper.deleteGrouping($ctrl.control.groupings, grouping);
            $scope.$broadcast('rb-event:init-column-resizer');
        };

        $ctrl.insertRow = function (section, insertIndex, rowToCopy) {
            let rowIndex = $ctrl.groupLevel[section].rows.indexOf(rowToCopy)+insertIndex;
            let newRow = angular.copy(rowToCopy);
            newRow.columns.forEach(function (column) {
                column.control.value = '';
            });

            $ctrl.groupLevel[section].rows.insert(newRow, rowIndex);
        };

        $ctrl.deleteRow = function (section, row) {
            $ctrl.groupLevel[section].rows.remove(row);
        };

        $ctrl.insertColumnLeft = function() {
            insertColumn($ctrl.current.index, $ctrl.current.row);
            $ctrl.current.index += 1;
        };

        $ctrl.insertColumnRight = function() {
            insertColumn($ctrl.current.index + 1, $ctrl.current.row);
        };

        $ctrl.deleteColumn = function() {
            const deleteIndex = $ctrl.current.index;

            let startDeletePosition = 0;
            for (let i = 0; i < deleteIndex; i++) {
                startDeletePosition += $ctrl.current.row.columns[i].colspan;
            }

            let positionsToDelete = (startDeletePosition).upto(startDeletePosition + ($ctrl.current.row.columns[deleteIndex].colspan - 1));
            let remainingWidth = 100 - parseFloat($ctrl.groupLevel.guideRow[0].columns[positionsToDelete.last()].width);

            let modifyColumns = function(row) {
                let currentPosition = 0;
                row.columns.forEach(function(column) {
                    let positionsHeld = currentPosition.upto(currentPosition + (column.colspan - 1));
                    let origColspan = column.colspan;

                    column.colspan = positionsHeld.subtract(positionsToDelete).length;

                    column.width = roundToPrecision(100 * parseFloat(column.width) * (column.colspan / origColspan) / remainingWidth) + '%';

                    currentPosition = positionsHeld.last() + 1;
                });

                row.columns.remove({ colspan: 0 });
                adjLastColumnWidth(row.columns);
            };

            modifyColumns($ctrl.groupLevel.guideRow[0]);

            sections.forEach(function(section) {
                $ctrl.groupLevel[section].rows.forEach(function(row) {
                    modifyColumns(row);
                });
            });

            initColumnResizer();
        };

        $ctrl.mergeColumnsLeft = function () {
            mergeColumns($ctrl.current.row.columns[$ctrl.current.index - 1], $ctrl.current.row.columns[$ctrl.current.index], $ctrl.current.row);

            $ctrl.current.index -= 1;
        };

        $ctrl.mergeColumnsRight = function () {
            mergeColumns($ctrl.current.row.columns[$ctrl.current.index], $ctrl.current.row.columns[$ctrl.current.index + 1], $ctrl.current.row);
        };

        $ctrl.splitColumn = function (index, row) {
            let numRowColumns = 0;
            for (let i = 0; i < index; i++) {
                numRowColumns += row.columns[i].colspan;
            }

            let column = row.columns[index];

            let numColumnsSplit = column.colspan;
            column.colspan = 1;
            column.width = $ctrl.groupLevel.guideRow[0].columns[numRowColumns].width;

            for (let i = 1; i <= numColumnsSplit-1; i++) {
                let newColumn = angular.copy(column);
                newColumn.control.value = "";
                newColumn.width = $ctrl.groupLevel.guideRow[0].columns[numRowColumns+i].width;
                row.columns.insert(newColumn, index + i);
            }
            adjLastColumnWidth(row.columns);
        };

        $ctrl.sectionClass = function (part, groupingIndex) {
            let x = {};
            if ($ctrl.isBenchmark) {
                x['oasBenchmark' + part] = true;
            } else {
                if (groupingIndex === 0 || part === 'Detail') {
                    x['oasSection' + part] = true;
                } else {
                    x['oasTableGrouping' + part + (groupingIndex)] = true;
                }
            }
            return x;
        };

        function syncGroupingSelectionKey() {
            if (!$ctrl.groupLevel) {
                return;
            }

            $ctrl.groupingSelectionKey = reportHelper.syncGroupingSelectionKey($ctrl.groupLevel);
        }

        $ctrl.$onInit = function () {
            $ctrl.active = false;
            if (!$ctrl.groupIndex && $ctrl.groupIndex !== 0)
                $ctrl.groupIndex = 0;

            setGuideRow();
            initColumnResizer();

            isolate.tools = groupingHelper.buildTools($element[0]);
            isolate.ts = Date.now();
            updateToolsStyles();
            $scope.$$postDigest(function () {
                $ctrl.loadNested = true;
            });

            setTablePrivileges();

            $ctrl.filteredGroupingOptions = [];
            $ctrl._lastFilteredKeys = null;
            $ctrl.groupingOptions = reportHelper.getAllGroupingOptions();
            refreshGroupingOptions();
        };

        $ctrl.columnResizer = {
            options: {
                manualInit: true,
                precision: 3,
                onResizeEnded: function (column) {
                    storeColumnWidths(column);
                }
            },
            api: null
        };

        /**
         * Note: We use two arrays here because we need to be sure that we maintain the same object reference
         * to avoid an infinite digest loop.
         *
         * @returns The array of GroupingOption names filtered by the selected run for option(s).
         */
        $ctrl.getGroupingOptions = function() {
            if (!$ctrl.groupingOptions) {
                return $ctrl.filteredGroupingOptions;
            }

            const filteredOptions = $ctrl.groupingOptions
                .filter(x => filterAvailableGroupingOptions(x));

            // Only rebuild the array if the filtered options have actually changed
            const currentKeys = filteredOptions.map(function (x) {
                return x.isAdHoc
                    ? (x.adhocOptionGuid || x.name)
                    : reportHelper.getGroupingSelectionKey(x);
            }).join(',');

            if ($ctrl._lastFilteredKeys !== currentKeys) {
                $ctrl.filteredGroupingOptions.length = 0;
                
                filteredOptions.forEach(function (x) {
                    $ctrl.filteredGroupingOptions.push(reportHelper.toGroupingMenuOption(x));
                });
                
                $ctrl._lastFilteredKeys = currentKeys;
            }

            return $ctrl.filteredGroupingOptions;
        };

        /**
         * Handles changes to the grouping value selection
         * @param {string} newValue - The new grouping value, type number, that was selected
         */
        $ctrl.onGroupingValueChange = function(newValue, option) {
            reportHelper.applyGroupingLevelSelection($ctrl.groupLevel, newValue, $ctrl.groupingOptions, option);
            $ctrl.groupLevel.name = reportHelper.getGroupingDisplayName($ctrl.groupLevel, $ctrl.groupingOptions)
                || $ctrl.groupLevel.name;
            $ctrl.groupLevelUpdated();
        };

        function refreshGroupingOptions() {
            $ctrl.groupingOptions = reportHelper.getAllGroupingOptions();
            $ctrl._lastFilteredKeys = null;
        }

        $scope.$on('rb-event:ad-hoc-settings-changed', refreshGroupingOptions);

        $scope.$watch(() => {
            return reportHelper.current.selected?.$index;
        }, () => {
            $interval(() => {
                updateToolsStyles();
            }, 100, 5);

        });
        
        //EVENT LISTENERS
        $scope.$on("rb-event:init-column-resizer", function (e) {
            initColumnResizer();
        });

        $scope.$on('rb-event:render-visible', function (event, view) {
            $ctrl.contextMenuIsOpen = false;
        });
    }
});

'use strict';

app.component('rcColumnChart', {
    OAS_DATA: {
        name: 'Bar Chart',
        icon: 'fa-bar-chart',
        category: 'Charts',
        schema: {
            $type: 'rcColumnChart',
            frequency: 'Summary',
            orderBy: [],
            dataSource: {
                path: 'Activity.Value',
                activityOptionId: null,
                dateRangeId: null,
            },
            dataLabelFormat: null,
            grouping: 'Asset Class',
            groupName: null,
            dateRangeArray: [],
            usexAxisDates: true,
            config: {
                options: {
                    chart: {height: 250, inverted: false},
                    legend: {enabled: false},
                    plotOptions: {
                        series: {
                            className: '',
                            negativeColor: false,
                        },
                        column: {
                            $type: 'HighchartsColumnPlotOption',
                            dataLabels: {
                                enabled: false,
                                allowOverlap: false,
                                crop: false,
                                overflow: 'none',
                            },
                        },
                    },
                },
                title: {text: ''},
            },
            displayHorizontal: false,
            columnOrganization: 'DateRange',
            limitMethod: {
                limitMethod: 'None',
                showOtherGroup: false,
                otherGroupName: 'Other',
                count: 1,
                threshold: 0.01,
                dataSource: {
                    path: 'Activity.Value',
                    activityOptionId: null,
                    dateRangeId: null,
                },
            },
            padColumns: true,
            xAxisLabelOrientation: {
                orientation: 'Auto',
            },

            axes: {
                xAxis: {
                    decimalPlaces: 2,
                    hideSymbol: false,
                },
                yAxis: {
                    decimalPlaces: 2,
                    hideSymbol: false,
                },
            },
            usePositiveNegativeColors: false
        },
    },
    templateUrl: 'reporting/envision/components/report-controls/rcChart.html',
    bindings: {
        control: '<',
    },
    controller: function (reportHelper, $scope, $route, adHocSettingsService) {
        let $ctrl = this;
        const isSubReportEditor = $route && $route.current && $route.current.controller === "SubReportEditorCtrl";
        let defaultDateRangeName = !!isSubReportEditor ? "Use Default ( From Report )" : "Use Default";

        const initialConfig = {
            options: {
                chart: {type: 'column', inverted: false},
                xAxis: {
                    type: 'datetime',
                    title: {text: ''},
                },
                yAxis: {
                    title: {text: ''},
                },
                tooltip: {enabled: false},
                plotOptions: {
                    series: {
                        className: '',
                        negativeColor: false,
                    },
                    column: {
                        $type: 'HighchartsColumnPlotOption',
                        pointPadding: 0.2,
                        borderWidth: 0,
                        grouping: true,
                    },
                },
            },

            credits: {enabled: false},
            series: [],
            title: {text: ''},
            subtitle: {text: null},
        };

        //PRIVATE METHODS
        function getDateRangeOptions() {
            reportHelper
                .getOptions('date-range')
                .then(function (timeFrameOptions) {
                    $ctrl.timeFrameOptions = timeFrameOptions;
                    setPlotOptions();
                    setSeriesData();
                    updateChartConfig();
                });
        }

        function setPlotOptions() {
            let interval = 1;
            let unit = 'day';
            let yearModifier = 0;
            switch ($ctrl.control.frequency) {
                case 'Annually':
                    unit = 'year';
                    yearModifier = 11;
                    break;
                case 'Quarterly':
                    interval = 3;
                    unit = 'month';
                    yearModifier = 3;
                    break;
                case 'Monthly':
                    unit = 'month';
                    break;
                case 'Weekly':
                    interval = 7;
                    break;
                // case Summary:
                // case Daily:
                // case Automatic:
                //Use Defaults
            }

            // Don't set Positive Negative colors to true when grouping is not equal to Self
            const performancePaths = ['performance.value', 'benchmark.performance', 'performance.benchmarks'];
            if($ctrl.control.grouping.toLocaleLowerCase() !== 'self' || !performancePaths.includes($ctrl.control.dataSource.path.toLocaleLowerCase())) {
                $ctrl.control.usePositiveNegativeColors = false;
            }

            initialConfig.options.plotOptions.column.grouping = true;

            if (
                getSummaryDateRangeNames().length > 0 &&
                $ctrl.control.frequency === 'Summary'
            ) {
                delete initialConfig.options.plotOptions.series.pointStart;
                delete initialConfig.options.plotOptions.series.pointInterval;
                delete initialConfig.options.plotOptions.series.pointIntervalUnit;
                initialConfig.options.xAxis.type = 'category';

                initialConfig.options.xAxis.categories = getSummaryDateRangeNames();

                if (isStackedColumnChart() && initialConfig.options.xAxis.categories.length === 1) {
                    initialConfig.options.xAxis.categories.push(initialConfig.options.xAxis.categories[0] + ' 2');
                }

                if (!isStackedColumnChart() && $ctrl.control.columnOrganization === 'GroupName') {
                    let originalCategories =
                        initialConfig.options.xAxis.categories;
                    let newCategories = [];
                    let groupName = $ctrl.control.groupingLabel;

                    const createLabel = function (grouping, suffix) {
                        return grouping + ' ' + suffix;
                    };

                    initialConfig.options.plotOptions.column.grouping = false;

                    if (originalCategories.length === 1) {
                        if (initialConfig.series.length > 0) {
                            for (
                                let i = 0;
                                i < initialConfig.series.length;
                                i++
                            ) {
                                initialConfig.series[i].data.length = 1;
                                initialConfig.series[i].name = createLabel(
                                    groupName,
                                    i + 1
                                );
                                initialConfig.series[
                                    i
                                    ].data[0].name = createLabel(groupName, i + 1);
                                newCategories.push(
                                    createLabel(groupName, i + 1)
                                );
                            }
                        }
                    } else {
                        initialConfig.series.length = 1;

                        for (let i = 0; i < originalCategories.length; i++) {
                            newCategories.push(
                                createLabel(groupName, originalCategories[i])
                            );
                        }
                    }

                    initialConfig.options.xAxis.categories = newCategories;
                }

                if (
                    !$ctrl.control.padColumns &&
                    $ctrl.control.columnOrganization === 'DateRange'
                ) {
                    initialConfig.options.plotOptions.series = {
                        groupPadding: 0,
                    };
                }
            } else {
                const n = new Date().getFullYear() - yearModifier;
                initialConfig.options.plotOptions.series.pointStart =  Date.UTC(n, 0, 1);
                initialConfig.options.plotOptions.series.pointInterval =  interval;
                initialConfig.options.plotOptions.series.pointIntervalUnit = unit;

                if (
                    !$ctrl.control.padColumns &&
                    $ctrl.control.columnOrganization === 'DateRange'
                ) {
                    initialConfig.options.plotOptions.series.groupPadding = 0;
                } else {
                    delete initialConfig.options.plotOptions.series
                        .groupPadding;
                }

                initialConfig.options.xAxis.type = 'datetime';
                delete initialConfig.options.xAxis.categories;
            }
            if ($ctrl.control.usePositiveNegativeColors) {
                initialConfig.options.plotOptions.series.className = 'highcharts-positive';
                initialConfig.options.plotOptions.series.negativeColor = true;
                initialConfig.options.legend.symbolHeight = 0;
                initialConfig.options.legend.symbolWidth = 0;
                initialConfig.options.legend.symbolPadding = 0;
                initialConfig.options.legend.squareSymbol = false;
            } else {
                initialConfig.options.plotOptions.series.className = '';
                initialConfig.options.plotOptions.series.negativeColor = false;
                delete initialConfig.options.legend.symbolHeight;
                delete initialConfig.options.legend.symbolWidth;
                delete initialConfig.options.legend.symbolPadding;
                delete initialConfig.options.legend.squareSymbol;
            }
        }

        function getBundleDateRangeNames() {
            const bundleGuid = $ctrl.control.contextChangesAdHocOption?.adhocOptionGuid
                || $ctrl.control.contextChangesAdHocOption?.AdhocOptionGuid;
            if (!bundleGuid || !adHocSettingsService) {
                return [];
            }

            return adHocSettingsService.getAdhocContextChangesPreviewNames(
                bundleGuid,
                adHocSettingsService.getAdHocSettingsCache(),
                adHocSettingsService.getGlobalSettings()
            ) || [];
        }

        function getDateRangeOptionName(id, guid) {
            if ($ctrl.timeFrameOptions && guid) {
                const byGuid = $ctrl.timeFrameOptions.find(function (option) {
                    return option.guid === guid || option.optionGuid === guid;
                });
                if (byGuid) {
                    return byGuid.name;
                }
            }

            if ($ctrl.timeFrameOptions) {
                const parsedId = parseInt(id, 10);
                if (!isNaN(parsedId)) {
                    const byId = $ctrl.timeFrameOptions.find({ optionId: parsedId });
                    if (byId) {
                        return byId.name;
                    }
                }

                return defaultDateRangeName;
            }

            if (id === '0' || id == null) {
                return 'Period';
            }

            return id;
        }

        function getSummaryDateRangeNames() {
            const bundleNames = getBundleDateRangeNames();
            if (bundleNames.length > 0) {
                return bundleNames;
            }

            if ($ctrl.control.dateRanges && $ctrl.control.dateRanges.length) {
                return $ctrl.control.dateRanges.map(function (dateRangeRef, index) {
                    const guid = dateRangeRef?.adhocOptionGuid || dateRangeRef?.globalOptionGuid;
                    const id = dateRangeRef?.$type === 'date-range-array-option'
                        ? dateRangeRef.id
                        : ($ctrl.control.dateRangeArray && $ctrl.control.dateRangeArray[index]);
                    return getDateRangeOptionName(id, guid);
                });
            }

            if (!$ctrl.control.dateRangeArray || !$ctrl.control.dateRangeArray.length) {
                return [];
            }

            return $ctrl.control.dateRangeArray.map(function (id) {
                return getDateRangeOptionName(id);
            });
        }

        function setSeriesData() {
            initialConfig.series.length = 0;
            const summaryNames = getSummaryDateRangeNames();
            const isSummary =
                summaryNames.length > 0 &&
                $ctrl.control.frequency === 'Summary';
            const isStacked = isStackedColumnChart();
            let numberOfSeries = isStacked ? 2 : Math.floor(Math.random() * 3) + 1;
            const totalDataPoints = isStacked ? Math.max(isSummary ? summaryNames.length : 5, 2) : (isSummary ? summaryNames.length : 5);

            if ($ctrl.control.namedSeries) {
                for (const [key, value] of Object.entries($ctrl.control.namedSeries)) {
                    const series = makeSeries(value.seriesName.value, totalDataPoints)
                    initialConfig.series.push(series);
                }

                if (isStacked) {
                    while (initialConfig.series.length < 2) {
                        const seriesNumber = initialConfig.series.length + 1;
                        initialConfig.series.push(makeSeries($ctrl.control.grouping + ' ' + seriesNumber, totalDataPoints));
                    }
                }
                return;
            }

            if (
                !isStacked &&
                isSummary &&
                summaryNames.length > 1 &&
                $ctrl.control.columnOrganization === 'GroupName'
            ) {
                numberOfSeries = 1;
            }

            for (let i = 1; i <= numberOfSeries; i++) {
                const series = makeSeries($ctrl.control.grouping + ' ' + i, totalDataPoints)
                initialConfig.series.push(series);
            }
        }

        function isStackedColumnChart() {
            const stacking = $ctrl.control.config.options.plotOptions.column.stacking;

            return stacking === 'normal' || stacking === 'percent';
        }

        function makeSeries(seriesName, totalDataPoints) {
            const series = {
                name: seriesName,
                data: [],
                showInLegend: true,
            };

            for (let j = 1; j <= totalDataPoints; j++) {
                let makeNegative = false;
                if ($ctrl.control.usePositiveNegativeColors) {
                    makeNegative = Math.floor(Math.random() * 2) === 1;
                }
                let point = { y: Math.floor(Math.random() * 100 + 1) };
                point.y *= (makeNegative ? -1 : 1);
                series.data.push(point);
            }

            if ($ctrl.control.usePositiveNegativeColors && !series.data.some(s => s.y < 0)) {
                let index = Math.floor(Math.random() * totalDataPoints);
                series.data[index].y *= -1;
            }

            return series;
        }

        function setXAxisLabelOrientation(ori) {
            if (ori.orientation !== 'Auto') {
                initialConfig.options.xAxis.labels = {
                    rotation: ori.rotation,
                    align: ori.alignment.toLowerCase(),
                };
            } else {
                delete initialConfig.options.xAxis.labels;
            }
        }

        function updateChartConfig() {
            initialConfig.options.xAxis.title.text = $ctrl.control.groupingLabel;
            setXAxisLabelOrientation($ctrl.control.xAxisLabelOrientation);
            $ctrl.control.config.options.chart.inverted = !!$ctrl.control
                .displayHorizontal;
            $ctrl.chartConfig = angular.merge(
                initialConfig,
                $ctrl.control.config
            );
            setPlotOptions();
            if (isStackedColumnChart()) {
                $ctrl.chartConfig.options.xAxis = initialConfig.options.xAxis;
            }
        }

        $scope.$on('reloadColumnChart', function () {
            setSeriesData();
            updateChartConfig();
        });

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            getDateRangeOptions();
            setPlotOptions();
            setSeriesData();
            updateChartConfig();
        };

        $ctrl.$onChanges = function (changes) {
            if (!angular.equals(changes.control.currentValue, changes.control.previousValue)) {
                if (
                    !angular.equals(
                        changes.control.currentValue.grouping,
                        changes.control.previousValue.grouping
                    ) ||
                    (changes.control.currentValue.dateRangeArray &&
                        changes.control.previousValue.dateRangeArray &&
                        changes.control.currentValue.dateRangeArray.length !==
                        changes.control.previousValue.dateRangeArray.length) ||
                    !angular.equals(
                        changes.control.currentValue.contextChangesAdHocOption,
                        changes.control.previousValue.contextChangesAdHocOption
                    )
                ) {
                    reportHelper.setGroupingValuesForCharts($ctrl.control);
                    setSeriesData();
                }

                updateChartConfig();
            }
        };
    },
});

'use strict';

app.component('rcSpacer', {
    OAS_DATA: {
        name: 'Spacer',
        icon: 'fa-square-o',
        category: 'Layout',
        schema: {
            $type: 'rcSpacer',
            height: '100px'
        }
    },
    templateUrl: 'reporting/envision/components/report-controls/rcSpacer.html',
    bindings: {
        control: '<'
    }
});
'use strict';

app.component('rcSplitter', {
    OAS_DATA: {
        schema: {
            $type: 'rcSplitter',
            controls: []
        },
        noEditorRequired: true
    },
    templateUrl: 'reporting/envision/components/report-controls/rcSplitter.html',
    bindings: {
        control: '<'
    }
});
'use strict';

app.component('rcTableOfContentsEntry', {
    OAS_DATA: {
        schema: {
            $type: 'rcTableOfContentsEntry',
            label: {$type: 'rcStringResolverCompact', isHtml: true, value: "Unnamed Contents"},
            controls: []
        },
        name: 'Table of Contents Entry',
        icon: 'fa-th-list',
        category: 'Layout'
    },
    templateUrl: 'reporting/envision/components/report-controls/rcTableOfContentsEntry.html',
    bindings: {
        control: '<'
    }
});
'use strict';

app.component('rcStaticTable', {
    OAS_DATA: {
        name: 'Static Table',
        icon: 'fa-table',
        category: 'Tables',
        schema: {
            $type: 'rcStaticTable',
            guideRow: [],
            showHeader: true,
            showFooter: false,
            header: {
                rows: [
                    {columns: [{control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Header 1'}, colspan: 1, width: '50%'}, {control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Header 2'}, colspan: 1, width: '50%'}]}
                ]
            },
            body: {
                rows: [
                    {columns: [{control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Column 1'}, colspan: 1, width: '50%'}, {control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Column 2'}, colspan: 1, width: '50%'}]}
                ]
            },
            footer: {
                rows: [
                    {columns: [{control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Footer 1'}, colspan: 1, width: '50%'}, {control: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Footer 2'}, colspan: 1, width: '50%'}]}
                ]
            },
            useAlternativeLineShading: true
        },
        canUseInCoverPage: true,
        canUseInQueryBuilder: true
    },
    templateUrl: 'reporting/envision/components/report-controls/rcStaticTable.html',
    bindings: {
        control: '<'
    },

    controller: function ($scope, $route, $oasRights) {
        var $ctrl = this;

        Object.defineProperties($ctrl, {
            resolveType: {
                get: function() {
                    switch($route.current.$$route.controller) {
                        case 'ReportingEnvisionCoverPageItemCtrl':
                            return 'coverPage';
                        case 'ReportEditorCtrl':
                        case 'SubReportEditorCtrl':
                            return 'reportEditor';
                        default:
                            return '';
                    }
                }
            }
        });

        //PRIVATE VARIABLES
        var sections = ['header', 'body', 'footer'];


        //PRIVATE METHODS
        function setGuideRow(){
            $ctrl.control.guideRow = [];
            sections.some(function(section){
                if($ctrl.control[section].rows.length > 0){
                    var temp = angular.copy($ctrl.control[section].rows[0]);
                    var numColumns = $ctrl.columnsInRow(temp);
                    if(temp.columns.length < numColumns){
                        $ctrl.control[section].rows.some(function(row){
                            if(row.columns.length === numColumns) {
                                temp = angular.copy(row);
                                return true;
                            }
                        });
                    }
                    temp.columns.forEach(function (column, index) {
                        if(column.colspan > 1) {
                            var width = parseFloat(column.width);
                            var colSpan = parseInt(column.colspan);
                            var newWidth = width / colSpan;
                            column.colspan = 1;
                            column.width = newWidth + "%";
                            for(var i = 1; i < colSpan; i++) {
                                var newColumn = angular.copy(column);
                                temp.columns.splice(index, 0, newColumn);
                            }
                        }
                    });
                    $ctrl.control.guideRow.push(temp);
                }

                if ($ctrl.control.guideRow.length > 0) return true;
            })
        }

        function columnWidthSum(columns){
            var totalWidth = 0;
            columns.forEach(function (column) {
                totalWidth += parseFloat(column.width)
            });
            return totalWidth;
        }

        function adjLastColumnWidth(columns) {
            var widthDiff = 100 - columnWidthSum(columns);
            //add the diff to the last column
            columns.last().width = calcToOneDecimal(parseFloat(columns.last().width) + widthDiff) + "%";
        }

        function calcToOneDecimal(num){
            return Math.round(num * 10) / 10;
        }

        function initColumnResizer() {
            $scope.$$postDigest(function () {
                $ctrl.columnResizer.api.update();
            });
        }

        function storeColumnWidths() {
            var widths = $ctrl.columnResizer.api.getWidths();

            var setColWidth = function(row){
                var index = 0;
                var colWidth = 0;
                for (var i = 0; i < row.columns.length; i++) {
                    colWidth += parseFloat(widths[index]);
                    if (row.columns[i].colspan === 1){
                        row.columns[i].width = calcToOneDecimal(colWidth) + '%';
                        colWidth = 0;
                        index++;
                    }
                    else{
                        for (var idx = index+1; idx < index + row.columns[i].colspan; idx++ ){
                            colWidth += parseFloat(widths[idx]);
                        }
                        row.columns[i].width = calcToOneDecimal(colWidth) + '%';
                        colWidth = 0;
                        index += row.columns[i].colspan;
                    }
                }
            };

            setColWidth($ctrl.control.guideRow[0]);

            sections.each(function (section) {
                $ctrl.control[section].rows.each(function(row){
                    setColWidth(row)
                });
            });

        }


        //PUBLIC METHODS
        $ctrl.columnsInRow = function(row){
            return row.columns.sum('colspan')
        };

        $ctrl.insertRow = function (section, insertIndex, rowToCopy) {
            var newRow = angular.copy(rowToCopy);
            newRow.columns.forEach(function (column) {
                column.control.value = '';
            });

            $ctrl.control[section].rows.insert(newRow, insertIndex);
        };

        $ctrl.deleteRow = function (section, row) {
            $ctrl.control[section].rows.remove(row);
        };

        $ctrl.insertColumn = function (insertIndex, row) {
            var numColumns = $ctrl.columnsInRow(row);
            var defaultWidth = 100 / (numColumns + 1);
            var positionLeftOfInsert = -1;

            if (insertIndex === row.columns.length) {
                positionLeftOfInsert = -99;
            } else {
                for (var i = 0; i < insertIndex; i++) {
                    positionLeftOfInsert += row.columns[insertIndex].colspan;
                }
            }

            var doInsert = function (row, index) {
                row.columns.insert({control: {$type: 'rcStringResolverCompact', isHtml: true, value: ''}, colspan: 1, width: calcToOneDecimal(100-columnWidthSum(row.columns)) + "%"}, index);
            };

            var modifyColumns = function (row){
                //adjust the widths of column
                row.columns.forEach(function (column) {
                    column.width = calcToOneDecimal(parseFloat(column.width) * (1 - defaultWidth / 100)) + "%";
                });

                if (positionLeftOfInsert === -1) {
                    doInsert(row, 0);
                } else if (positionLeftOfInsert === -99) {
                    doInsert(row, row.columns.length);
                } else {
                    var currentPosition = 0;
                    row.columns.each(function (column, index) {
                        var positionsHeld = currentPosition.upto(currentPosition + (column.colspan - 1));

                        if (positionsHeld.any(positionLeftOfInsert)) {
                            if (positionsHeld.last() === positionLeftOfInsert) {
                                doInsert(row, index + 1);
                            } else {
                                column.colspan += 1;
                                column.width = calcToOneDecimal(parseFloat(column.width) + (100-columnWidthSum(row.columns))) + "%";
                            }

                            return false; //break out of loop
                        }

                        currentPosition = positionsHeld.last() + 1;
                    });
                }

            };

            modifyColumns($ctrl.control.guideRow[0]);

            sections.forEach(function (section) {
                $ctrl.control[section].rows.forEach(function (row) {
                    modifyColumns(row);
                });
            });

            initColumnResizer();

        };

        $ctrl.deleteColumn = function (deleteIndex, row) {
            var startDeletePosition = 0;
            for (var i = 0; i < deleteIndex; i++) {
                startDeletePosition += row.columns[i].colspan;
            }

            var positionsToDelete = (startDeletePosition).upto(startDeletePosition + (row.columns[deleteIndex].colspan - 1));
            var remainingWidth = 100 - parseFloat(row.columns[deleteIndex].width);

            var modifyColumns = function(row){
                var currentPosition = 0;
                row.columns.forEach(function (column) {
                    var positionsHeld = currentPosition.upto(currentPosition + (column.colspan - 1));
                    var origColspan = column.colspan;

                    column.colspan = positionsHeld.subtract(positionsToDelete).length;

                    column.width = calcToOneDecimal(100 * parseFloat(column.width) * (column.colspan / origColspan) / remainingWidth) + "%";

                    currentPosition = positionsHeld.last() + 1;
                });

                row.columns.remove({colspan: 0});
                adjLastColumnWidth(row.columns);
            };

            modifyColumns($ctrl.control.guideRow[0]);

            sections.forEach(function (section) {
                $ctrl.control[section].rows.forEach(function (row) {
                    modifyColumns(row);
                });
            });

            initColumnResizer();

        };

        $ctrl.mergeColumns = function (leftColumn, rightColumn, row) {
            var leftCell = document.createElement('div'),
                rightCell = document.createElement('div');

            leftCell.innerHTML = leftColumn.control.value;
            rightCell.innerHTML = rightColumn.control.value;

            if(rightCell.hasChildNodes() && rightCell.textContent.length !== 0) {
                if(leftCell.childNodes.length === 1 && rightCell.childNodes.length === 1) {
                    var getSafeHtml = function (node) {
                        if(node.innerHTML) {
                            return node.innerHTML;
                        }

                        var encoder = document.createElement('div');
                        encoder.textContent = node.textContent || '';
                        return encoder.innerHTML;
                    };

                    if(leftCell.firstChild.nodeType === 1) {
                        leftCell.firstChild.innerHTML = [
                            getSafeHtml(leftCell.firstChild),
                            getSafeHtml(rightCell.firstChild)
                        ].join(' ');
                    } else {
                        leftCell.innerHTML = [
                            getSafeHtml(leftCell.firstChild),
                            getSafeHtml(rightCell.firstChild)
                        ].join(' ');
                    }
                } else {
                    Array.from(rightCell.childNodes||[]).forEach(function(node){
                        leftCell.appendChild(node);
                    });
                }
            }

            leftColumn.colspan += rightColumn.colspan;
            leftColumn.control.value = leftCell.innerHTML;
            leftColumn.width = (parseFloat(leftColumn.width) + parseFloat(rightColumn.width)) + "%";

            row.columns.remove(rightColumn);
        };

        $ctrl.splitColumn = function (index, row) {
            var numRowColumns = 0;
            for (var i = 0; i < index; i++) {
                numRowColumns += row.columns[i].colspan;
            }

            var column = row.columns[index];

            var numColumnsSplit = column.colspan;
            column.colspan = 1;
            column.width = $ctrl.control.guideRow[0].columns[numRowColumns].width;

            for (var i = 1; i <= numColumnsSplit-1; i++) {
                var newColumn = angular.copy(column);
                newColumn.control.value = "";
                newColumn.width = $ctrl.control.guideRow[0].columns[numRowColumns+i].width;
                row.columns.insert(newColumn, index + i);
            }
            adjLastColumnWidth(row.columns);
        };

        
        $ctrl.hasAdvancedEditorRights = $oasRights.canRead("REPORTBUILDERADVANCEDEDITOR");

        //INITIALIZE
        $ctrl.columnResizer = {
            options: {
                manualInit: true,
                onResizeEnded: storeColumnWidths
            },
            api: null
        };

        $scope.$on('rb-event:render-visible', function (event, view) {
            $ctrl.hideContextMenuForRows($ctrl.control.header.rows);
            $ctrl.hideContextMenuForRows($ctrl.control.body.rows);
            $ctrl.hideContextMenuForRows($ctrl.control.footer.rows);
        });

        $ctrl.hideContextMenuForRows = function(rows){
            if(!rows){
                return;
            }
            for (let i = 0; i < rows.length; i++) {
                if(!rows[i].columns){
                    continue;
                }
                for (let j = 0; j < rows[i].columns.length; j++) {
                    rows[i].columns[j].contextMenuIsOpen = false;
                }
            }
        };

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            setGuideRow();
            initColumnResizer();
        };
    }
});
(function () {
    app.component('rcExternalDataTable', {
        templateUrl: 'reporting/envision/components/report-controls/rcExternalDataTable.html',
        bindings: {
            control: '<',
        },
        controller: function () {
            var $ctrl = this;

            $ctrl.skeletonHeaders = ['Header 1', 'Header 2', 'Header 3'];
            $ctrl.skeletonRows = [
                ['—', '—', '—'],
                ['—', '—', '—'],
                ['—', '—', '—'],
            ];

            var sourceTypeLabels = {
                1: 'Orion Query',
                2: 'Query Studio',
                3: 'Stored Procedure',
            };

            $ctrl.getSourceTypeLabel = function () {
                var sourceType = $ctrl.control && $ctrl.control.sourceType;
                return sourceTypeLabels[sourceType] || 'Orion Query';
            };

            $ctrl.hasSourceType = function () {
                var sourceType = $ctrl.control && $ctrl.control.sourceType;
                return sourceType != null && sourceType !== '';
            };

            $ctrl.getConfiguredParameterCount = function () {
                return ($ctrl.control && $ctrl.control.configuredParameterCount) || 0;
            };

            $ctrl.getTotalParameterCount = function () {
                return ($ctrl.control && $ctrl.control.totalParameterCount) || 0;
            };

            $ctrl.showParameterStatus = function () {
                return $ctrl.control && $ctrl.control.sourceId && $ctrl.getTotalParameterCount() > 0;
            };
        },
    });
})();

'use strict';

app.component('rcStringResolver', {
    OAS_DATA: [
        {
            name: 'Basic Text Box',
            icon: 'fa-text-width',
            category: 'Text Boxes',
            schema: {
                $type: 'rcStringResolver',
                isHtml: true,
                value:  '<section style="font-size: 10pt; font-family: Arial;">' +
                            'Dear [@{"name":"Household.Name","path":"Household.Name","label":"Household Name","formatOptions":[{"name":"Masking Type","type":"select","enabled":true},{"name":"Visible Characters at End","type":"number","enabled":false,"value":0},{"name":"Masking Character","type":"text","enabled":false,"value":"X"}],"types":["Value"]}@],<br /><br />' +
                            'Enclosed is your Quarterly Statement which represents your portfolio allocation as of the end of this quarter. During this past quarter we made allocation adjustments in response to global events and market activity, in order to bring you closer to your target portfolio. By focusing on the things we can control; including savings, expenses, investing wisely over the long term, and continued collaboration, together we will work towards achieving your financial goal.<br /><br />' +
                            'Sincerely,<br />' +
                            '[@{"name":"Representative.Name","path":"Representative.Name","label":"Representative Name","formatOptions":[{"name":"Masking Type","type":"select","enabled":true},{"name":"Visible Characters at End","type":"number","enabled":false,"value":0},{"name":"Masking Character","type":"text","enabled":false,"value":"X"}],"types":["Value"]}@]' +
                        '</section>'
            },
            canUseInCoverPage: true,
            canUseInQueryBuilder: true,
            noEditorRequired: true
        },
        {
            name: 'Framed Text Box',
            icon: 'fa-list-alt',
            category: 'Text Boxes',
            schema: {
                $type: 'rcWrapper',
                titleControl: {$type: 'rcStringResolverCompact', isHtml: true, value: 'Text Box'},
                controls: [
                    {
                        $type: 'rcStringResolver',
                        isHtml: true,
                        value:  '<section style="font-size: 10pt; font-family: Arial;">' +
                                    'Dear [@{"name":"Household.Name","path":"Household.Name","label":"Household Name","formatOptions":[{"name":"Masking Type","type":"select","enabled":true},{"name":"Visible Characters at End","type":"number","enabled":false,"value":0},{"name":"Masking Character","type":"text","enabled":false,"value":"X"}],"types":["Value"]}@],<br /><br />' +
                                    'Enclosed is your Quarterly Statement which represents your portfolio allocation as of the end of this quarter. During this past quarter we made allocation adjustments in response to global events and market activity, in order to bring you closer to your target portfolio. By focusing on the things we can control; including savings, expenses, investing wisely over the long term, and continued collaboration, together we will work towards achieving your financial goal.<br /><br />' +
                                    'Sincerely,<br />' +
                                    '[@{"name":"Representative.Name","path":"Representative.Name","label":"Representative Name","formatOptions":[{"name":"Masking Type","type":"select","enabled":true},{"name":"Visible Characters at End","type":"number","enabled":false,"value":0},{"name":"Masking Character","type":"text","enabled":false,"value":"X"}],"types":["Value"]}@]' +
                                '</section>'
                    }
                ]
            }
        }
    ],
    template: ['$route',function ($route) {
        var resolveType;
        switch($route.current.$$route.controller) {
            case 'ReportingEnvisionCoverPageItemCtrl':
                resolveType = ' resolve-type="coverPage"';
                break;
            case 'ReportEditorCtrl':
            case 'SubReportEditorCtrl':
                resolveType = ' resolve-type="reportEditor"';
                break;
            default:
                resolveType = '';
                break;
        }
        return '<div class="rcControl" rc-resolve' + resolveType + ' ng-model="$ctrl.control.value" ng-disabled="::$ctrl.control.disabled" data-test-id="{{::$ctrl.control.testId}}"></div>';
    }],
    bindings: {
        control: '<'
    }
});
'use strict';

app.component('rcWrapper', {
    OAS_DATA: {
        name: 'Container',
        schema: {
            $type: 'rcWrapper',
            titleControl: {$type: "rcStringResolverCompact", isHtml: true, value: ''},
            controls: []
        },
        noEditorRequired: true
    },
    templateUrl: 'reporting/envision/components/report-controls/rcWrapper.html',
    bindings: {
        control: '<'
    }
  
});
'use strict';

app.component('rcTitleControl', {
    template: `
        <h2 class="oasSectionTitleBar" rc-resolve 
            ng-model="$ctrl.control.titleControl.value"
            ng-disabled="::$ctrl.control.disabled"
            contenteditable="$ctrl.control.disabled ? true : false"
            data-test-id="title-{{::$ctrl.control.testId}}">
        </h2>
    `,
    bindings: {
        control: '<',
    }
});

'use strict';

app.component('rcEmptySubReport', {
    OAS_DATA: {
        name: 'Empty Sub-Report',
        noEditorRequired: true,
    },
    templateUrl: 'reporting/envision/components/report-controls/rcEmptySubReport.html',
    bindings: {
        addControlCallback: '&',
        control: '<',
    },
    controller: function($scope) {
        var $ctrl = this;

        function bindEvents(item) {
            item.$emit = function(event, data) {
                $scope.$emit(event, data);
            };
            item.$on = function(event, data) {
                $scope.$on(event, data);
            };
            item.$broadcast = function(event, data) {
                $scope.$broadcast(event, data);
            };
            return item;
        }

        $ctrl.dragoverCallback = function() {
            return true;
        };

        $ctrl.onDrop = function(item) {
            $ctrl.addControlCallback()(item);
            return true;
        };

        $ctrl.$onInit = function() {
            bindEvents($ctrl.control);
            $ctrl.control.addControl = $ctrl.onDrop;
        };
    },
});
'use strict';

app.component('rcHeader', {
    OAS_DATA: {
        name: 'Header',
        icon: 'fa-id-card-o',
        category: 'Layout',
        schema: {
            $type: 'rcHeader',
            controls: [
                {
                    $type: "rcSplitter",
                    controls: [
                        {
                            $type: "rcStaticTable",
                            header: {
                                rows: []
                            },
                            body: {
                                rows: [
                                    {
                                        columns: [
                                            {
                                                control: {
                                                    $type: "rcStringResolver",
                                                    value: "<div style=\"line-height: 1em; font-size: 2em; margin-bottom: 10px;\">[@{\"name\":\"Report.Name\",\"path\":\"Report.Name\",\"label\":\"Report Name\",\"value\":\"New Report\",\"format\":false}@]</div>",
                                                    isHtml: true
                                                },
                                                colspan: 2,
                                                width: "100%"
                                            }
                                        ]
                                    },
                                    {
                                        columns: [
                                            {
                                                control: {
                                                    $type: "rcStringResolver",
                                                    value: "[@{\"name\":\"Group.Entity\",\"path\":\"Group.Entity\",\"label\":\"Group Entity\",\"format\":false}@]:",
                                                    isHtml: true
                                                },
                                                colspan: 1,
                                                width: "50%"
                                            },
                                            {
                                                control: {
                                                    $type: "rcStringResolver",
                                                    value: "[@{\"name\":\"Group.Name\",\"path\":\"Group.Name\",\"label\":\"Group Name\",\"format\":false}@]",
                                                    isHtml: true
                                                },
                                                colspan: 1,
                                                width: "50%"
                                            }
                                        ]
                                    },
                                    {
                                        columns: [
                                            {
                                                control: {
                                                    $type: "rcStringResolver",
                                                    value: "[@{\"name\":\"DateRange.Name\",\"path\":\"DateRange.Name\",\"label\":\"Period\",\"format\":false}@]:",
                                                    isHtml: true
                                                },
                                                colspan: 1,
                                                width: "50%"
                                            },
                                            {
                                                control: {
                                                    $type: "rcStringResolver",
                                                    value: "[@{\"name\":\"DateRange.StartDate\",\"path\":\"DateRange.StartDate\",\"label\":\"10/1/2018\",\"format\":\"d\"}@] to [@{\"name\":\"DateRange.EndDate\",\"path\":\"DateRange.EndDate\",\"label\":\"10/1/2018\",\"format\":\"d\"}@]",
                                                    isHtml: true
                                                },
                                                colspan: 1,
                                                width: "50%"
                                            }
                                        ]
                                    },
                                    {
                                        columns: [
                                            {
                                                control: {
                                                    $type: "rcStringResolver",
                                                    value: "Financial Advisor:",
                                                    isHtml: true
                                                },
                                                colspan: 1,
                                                width: "50%"
                                            },
                                            {
                                                control: {
                                                    $type: "rcStringResolver",
                                                    value: "[@{\"name\":\"Representative.Name\",\"path\":\"Representative.Name\",\"label\":\"Representative Name\",\"format\":false}@]",
                                                    isHtml: true
                                                },
                                                colspan: 1,
                                                width: "50%"
                                            }
                                        ]
                                    }
                                ]
                            },
                            footer: {
                                rows: []
                            }
                        },
                        {
                            $type: "rcReportImage",
                            reportImageId: "Advisor",
                            name: "Advisor Image",
                            imageUrl: "",
                            height: null,
                            opacity: "1"
                        }
                    ]
                }
            ]
        },
        noEditorRequired: true
    },
    templateUrl: 'reporting/envision/components/report-controls/rcHeader.html',
    bindings: {
        control: '<'
    }
});
'use strict';

app.component('rcList', {
    templateUrl: ['$attrs', function ($attrs) {
        var qualifier = '';

        if ($attrs?.renderAs) {
            qualifier = "-" + $attrs.renderAs;
        }

        return "reporting/envision/components/report-controls/rcList" + qualifier + ".html";
    }],
    bindings: {
        control: '<',
        allowedTypes: '<?',
        itemLimit: '<?',
        topLevel: '<?'
    },
    require: {
        parent: '?^^rcList'
    },
    controller: function ($scope, $timeout, $window, RB_COMPONENT_NAMES, $element, reportHelper, fragmentHelper, $dialog, SimpleTableEditorConversionService, dbeoService, resolveHelper, ReportAssistantChatHelper) {
        var $ctrl = this;

        //PRIVATE METHODS
        var neverWrap = ['rcGroupRepeater', 'rcPageBreak', 'rcSplitter', 'rcTableOfContentsEntry', 'rcReportPdf'];

        function storeColumnWidths() {
            $ctrl.control.columnWidths = $ctrl.columnResizer.api.getWidths();
            $ctrl.reflow();
        }

        function bindEvents(item) {
            item.$emit = function(event, data){
                $scope.$emit(event, data);
            };
            item.$on = function(event, data){
                $scope.$on(event, data);
            };
            item.$broadcast = function(event, data) {
                $scope.$broadcast(event, data);
            };
            return item;
        }

        function wrapControl(item) {
            return {
                $type: 'rcSplitter',
                disabled: item.disabled,
                isInSubReport: item.isInSubReport,
                controls: [bindEvents(item)],
            };
        }

        function isInContainerAtAnyLevel(types) {
            var item = $ctrl;
            var type = $ctrl.control.$type.toLowerCase();

            while (item) {
                if (types instanceof Array ? types.some(type) : type === types) {
                    return true;
                }
                item = item.parent;
            }

            return false;
        }

        function hasOnlyTopLevelControls() {
            if ($ctrl.control.topLevelOnly) {
                return true;
            }

            const allNestedControlsTopLevelOnly = $ctrl.control.controls.flatMap(function loop(node) {
                if (node.controls) {
                    return node.controls.flatMap(loop);
                } else {
                    return node.topLevelOnly;
                }
            });
            
            return allNestedControlsTopLevelOnly.some(tlo => tlo);
        }

        function thisIs(types) {
            var type = $ctrl.control.$type.toLowerCase();
            return types instanceof Array ? types.some(type) : type === types;
        }

        function unWrapControl(control) {
            if (control && control.controls) {
                control.controls = control.controls.map(function (c) {
                    //if this is a fake splitter unwrap it
                    if (c && c.$type === 'rcSplitter' && c.controls.length === 1) {
                        return unWrapControl(c.controls[0]);
                    }
                    return unWrapControl(c);
                });
            }

            return control;
        }


        //PUBLIC METHODS        
        $ctrl.initColumnResizer = function () {
            if (!$ctrl.columnResizer) return;

            $scope.$$postDigest(() => {
                //getWidths also updates the resizer tracking
                $ctrl.control.columnWidths = $ctrl.columnResizer.api.getWidths();
                if($ctrl.control.columnWidths.some(function(cw) { return cw.trim() === ""; })) {
                    var columnWidth = (100/$ctrl.control.controls.length).toString() + "%";
                    var columnWidths = [];
                    $ctrl.control.controls.each(function (control){
                        columnWidths.add(columnWidth);
                    });
                    $ctrl.control.columnWidths = angular.copy(columnWidths);
                }
            });
        };

        $ctrl.indexOf = function (control) {
            return $ctrl.control.controls.findIndex(function (c) {
                return angular.equals(c, control);
            });
        };

        $ctrl.registerOf = function(control) {
            reportHelper.registerControl(control);
            return control.$index;
        };

        $ctrl.isHovered = reportHelper.isHovered;
        $ctrl.isSelected = reportHelper.isSelected;

        $ctrl.selectControl = function (control, event) {
            event.stopPropagation();
            $scope.$emit('rb-event:select-control', {control: control, event: event});
        };

        $ctrl.hoverControl = reportHelper.hoverControl;

        $ctrl.removeControl = function (index) {
            var removedControls = $ctrl.control.controls.splice(index, 1);

            $scope.$emit('rb-event:remove-controls', removedControls);

            if ($ctrl.control.$type === 'rcSplitter' && $ctrl.control.controls.length === 0 && $ctrl.parent !== undefined) {
                //empty splitters need to ask their parents to delete them
                var myIndex = $ctrl.parent.indexOf($ctrl.control);
                if (myIndex !== -1) {
                    $ctrl.parent.removeControl(myIndex);
                }
            }

            if ($ctrl.parent) {
                $ctrl.parent.reflow();
            } else {
                $ctrl.reflow();
            }
        };

        $ctrl.getComponentName = function (control) {
            var name = fragmentHelper.getFragmentName(control);
            return RB_COMPONENT_NAMES[control.$type] + (name ? ` - ${name}` : '');
        };

        var sendingReflow = false;
        $ctrl.reflow = function () {
          if (!sendingReflow) {
                sendingReflow = true;
                $scope.$$postDigest(() => {
                    $scope.$broadcast('highchartsng.reflow');
                    sendingReflow = false;
                    $timeout(function () {
                        $window.dispatchEvent(new Event("resize"));
                    }, 500);
                });
            }
        };

        $ctrl.dragoverCallback = function (incomingType) {
            // remove extra placeholder
            $scope.$evalAsync(function() {
                var $placeholders = $outerList.find('.dndPlaceholder');
                if($placeholders.length > 1) { $placeholders.remove(); }
            });

            if ($ctrl.itemLimit && $ctrl.control.controls.length >= $ctrl.itemLimit) {
                return false;
            }

            if (incomingType === 'toponly'){
                return !!$ctrl.topLevel;
            }
            if (['rcwrapper','rcheader','rcsubreportwrapper'].some(incomingType) && isInContainerAtAnyLevel(['rcwrapper', 'rcheader','rcsubreportwrapper'])) {
                //no wrappers/headers in wrappers/headers
                return false;
            }
            if ('rcpagebreak' === incomingType && isInContainerAtAnyLevel(['rcwrapper', 'rcheader', 'rcsplitter','rcsubreportwrapper'])) {
                //no page break in wrappers or headers or splitters
                return false;
            }
            if ('rcreportpdf' === incomingType && isInContainerAtAnyLevel(['rcwrapper', 'rcheader', 'rcsplitter', 'rcgrouprepeater', 'rctableofcontentsentry','rcsubreportwrapper'])) {
                //no pdfs in wrappers or headers or splitters
                return false;
            }
            if ('rctableofcontentsentry' === incomingType && isInContainerAtAnyLevel(['rcsplitter'])) {
                //no tableofcontentsentry in splitters
                return false;
            }
            if ('rcgrouprepeater' === incomingType && thisIs(['rcheader', 'rcsplitter'])) {
                //no groupers in splitters/headers
                return false;
            }
            if (thisIs(['rcgrouprepeater'])) {
                if (isInContainerAtAnyLevel(['rcwrapper','rcsubreportwrapper'])) {
                    //you can drop anything (except what's restricted above) into a grouping repeater if it is in a wrapper
                    return true;
                }

                //this is a grouping repeater only allow what the parent allows
                if ($ctrl.parent) {
                    if ($ctrl.parent.allowedTypes) {
                        return $ctrl.parent.allowedTypes.some(function (n) {
                            return n.localeCompare(incomingType, undefined, { sensitivity: 'base' });
                        });
                    } else {
                        return $ctrl.parent.dragoverCallback(incomingType);
                    }
                }

                return false;
            }
            if (thisIs('rcsplitter')) {
                if (hasOnlyTopLevelControls()){
                    return false;
                }

                //this is a splitter only allow what the parent allows
                if ($ctrl.parent) {
                    if ($ctrl.parent.allowedTypes) {
                        return $ctrl.parent.allowedTypes.some(function (n) {
                            return n.localeCompare(incomingType, undefined, { sensitivity: 'base' });
                        });
                    } else {
                        return $ctrl.parent.dragoverCallback(incomingType);
                    }
                }

                return false;
            }

            //nothing was defined, just allow drag
            return true;
        };

        $ctrl.controlNeedsWrap = function (item) {
            return (item && $ctrl.control.$type !== 'rcSplitter' && neverWrap.none(item.$type));
        };

        $ctrl.wrapControlIfNeeded = function (item) {
            return $ctrl.controlNeedsWrap(item) ? wrapControl(item) : bindEvents(item);
        };

        $ctrl.onDrop = function (srcList, srcIndex, targetList, targetIndex) {
            if (targetList.dragoverCallback(srcList.control.controls[srcIndex].$type.toLowerCase())) {
                // Copy the item from source to target (wrapping if needed)
                targetList.control.controls.splice(targetIndex, 0, targetList.wrapControlIfNeeded(srcList.control.controls[srcIndex]));

                // Remove the item from the source, possibly correcting the index first.
                // We must do this immediately, otherwise ng-repeat complains about duplicates.
                if (srcList === targetList && targetIndex <= srcIndex) {
                    srcIndex++;
                }
                srcList.removeControl(srcIndex);

                srcList.initColumnResizer();
                targetList.initColumnResizer();

                // By returning true from dnd-drop we signal we already handled the item.
                return true;
            }

            //cancel the drop event
            return false;
        };

        $ctrl.getControls = function() {
            if(!$ctrl.control) {
                return;
            }

            if($ctrl.control.controls instanceof Array) {
                const listLength = $ctrl.control.controls.length;
                let listFilterRequired = false;
                for (let i = 0; i < listLength; i++) {
                    let control = $ctrl.control.controls[i];

                    if(control) {
                        if ($ctrl.controlNeedsWrap(control)) {
                            control = $ctrl.control.controls[i] = wrapControl(control);
                        } else {
                            bindEvents(control);
                        }
                        reportHelper.registerControl(control);
                    } else {
                        listFilterRequired = true;
                    }
                }

                if(listFilterRequired) {
                    let filtered = $ctrl.control.controls.filter(c => !!c);
                    $ctrl.control.controls = filtered;
                }
            }

            return $ctrl.control.controls;
        };

        var $outerList;
        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if ($ctrl.control && $ctrl.control.$type === 'rcSplitter') {
                $ctrl.columnResizer = {
                    options: {
                        manualInit: true,
                        onResizeEnded: storeColumnWidths
                    },
                    api: null
                };

                $ctrl.initColumnResizer();
            }
            $outerList = $element.parent().closest('[dnd-list]') || $element;

            dbeoService.get('69SimpleTableEditor').then((useSimpleTableEditor)=> {
                $ctrl.useSimpleTableEditor = useSimpleTableEditor;
            });
        };

        $ctrl.$onChanges = function (changes) {
            if ($ctrl.control !== undefined && $ctrl.control !== null) {
                bindEvents($ctrl.control);

                //PUBLIC METHODS
                $ctrl.control.isFake = function () {
                    //splitters with one thing in them are fake. They only exist to make the drag and drop work nicer
                    return $ctrl.control !== undefined && $ctrl.control.$type === 'rcSplitter' && $ctrl.control.controls !== undefined && $ctrl.control.controls.length === 1;
                };

                $ctrl.control.addControl = function (item) {
                    $ctrl.control.controls.push($ctrl.wrapControlIfNeeded(item));
                };

                $ctrl.control.replaceControl = function (item, index) {
                    //clear parent and child control index so both are inclued in the internal report registery
                    delete item.$index;
                    if (item.controls !== undefined && item.controls.length === 1 && item.controls[0].$type === 'rcGroupingTable') {
                        delete item.controls[0].$index;
                    } else if (item.controls == undefined && item.$type === 'rcStringResolver') {
                        item = resolveHelper.removeIndexesFromResolves(item);
                    }

                    // Copy the item from source to target (wrapping if needed)
                    $ctrl.control.controls.splice(index, 1, $ctrl.wrapControlIfNeeded(item));
                    bindEvents($ctrl.control);
                    //need to reflow the charts after adding
                    $ctrl.reflow();

                    //need to initialize column resizer
                    $ctrl.initColumnResizer();
                }

                $ctrl.control.unWrapControl = function () {
                    var copied = angular.copy($ctrl.control);
                    return unWrapControl(copied);
                };
            }
            $outerList = $element.parent().closest('[dnd-list]') || $element;

            if ($ctrl.parent) {
                $ctrl.parent.reflow();
            } else {
                $ctrl.reflow();
            }
        };

        $ctrl.convert = function (control) {
            const targetIndex = $ctrl.indexOf(control);
            let copyOfControl = angular.copy(control);

            const resolveOptions = resolveHelper.getResolveOptions('SubReportEditorCtrl');
            
            let convertedControl = SimpleTableEditorConversionService.convert(copyOfControl, true, resolveOptions);

            const replaceCtrlFunction = function (control, index) {
                $ctrl.control.replaceControl(control, index);

                if ($ctrl.parent?.control?.titleControl?.value && $ctrl.parent.control.titleControl.value == 'Simple Table') {
                    $ctrl.parent.control.titleControl.value = 'Advanced Table';
                }
                else if ($ctrl.parent?.control?.titleControl?.value && $ctrl.parent.control.titleControl.value == 'Advanced Table') {
                    $ctrl.parent.control.titleControl.value = 'Simple Table';
                }
            }
            
            if (convertedControl === false) {
                const issuesFound = SimpleTableEditorConversionService.conversionIssues.map(function(issue){
                    return `<li>${issue}</li>`
                }).join('');
                $dialog.confirmAction("The advanced table may not convert as expected. Are you sure you want to convert?</br></br><b>Issues Found:</b>\n<ul>" + issuesFound + "</ul>")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        convertedControl = SimpleTableEditorConversionService.convert(copyOfControl, false, resolveOptions);
                        replaceCtrlFunction(convertedControl, targetIndex);
                    }
                });
            }
            else {
                replaceCtrlFunction(convertedControl, targetIndex);
            }
        }        
    }
});

'use strict';

app.component('rcReportImage', {
    OAS_DATA: {
        name: 'Image',
        menuTitle: 'Image',
        icon: 'fa-photo',
        category: 'Media',
        schema: {
            $type: 'rcReportImage',
            imageUrl: null,
            alt: 'No image is selected',
        },
        canUseInCoverPage: true,
    },
    templateUrl: 'reporting/envision/components/report-controls/rcReportImage.html',
    bindings: {
        control: '<',
    },
    controller: function($scope, $element, imageHelper, API_CONFIG) {
        const $ctrl = this;
        const missingImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOkAAACWCAIAAAC0ITigAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAykSURBVHhe7Z1pQ9tIFkWTTlgNMWEJzvL/f1pCWBwMNgkmyxzpihq3McZSDM1T3fOhplR6VaXgo+cnm2Ze/vjx44UxAfmn+l9jomF3TVTsromK3TVRsbsmKnbXRMXumqjYXRMVu2uiYndNVOyuiYrdNVGxuyYqdtdExe6aqNhdExW7a6Jid01U7K6Jit01UbG7Jip210TF7pqo2F0TFbtromJ3TVTsromK3TVRsbsmKnbXRMXumqjYXRMVu2uiYndNVOzuE/Hnz5+qZ5aE3X0KEPfly5e/f//+9esXfXu8FOzuo4OyEpf+PyUaLE+a5tjdJaO0Ogmy0q6srNAh715eXqbBao5phP8/qpYGLpJf1eoQQen//Pnz5uaGnzOd8XhMu7+/3+l08FiRphl2d2nIRXj16pVyKsoOh8Pr6+tUMDAOm5ubOzs7ijGNsbtNQDulTPknZUFPY/xIya+0UhaVOTU5Cw4PD6dGTF3sbj2mkqWqAhxVVYCydBSjU3Q4qxhGyknFIru7u69fv1aA9W2G3a2BLAS9+zPCT4+S4OrqSmrSkmUZJ0Y5NbUMKkDrbG1tbW9vk6QVbxpgd+9F2qWO+oB5yEqKVSHLWfzDS9W7ZFM6hNHnFGgWMTylEca4FD84OKBTrOu82wi7O42Ewyd1kAzQEfOQFbCWcSKTiHQYkYJJR5kKa2trPJxx2O/3V1dXCdAue3t7KysraaKpi939P9JIbuGrjMRUZVlghFNSjZazxbRb5Ks6RFIVoCayaoRlv3z5QlYuY4sPJbrdbqfTmVrELE6O7koXKTiFtEMsFbK00pFBFQOapTZpR0d9TF1fX1dLDPE8unEbcJbpJycnugE45CwjlA1Kz1rH1CIvdyUNkAUL3W6/PgDOopFKAkA7RtIpYIoko1VuThma/Cpl0ZF4lp20XGGcGgwGl5eXdNLcXq9HcNrC1CI7d9WiC6ARfZQdjUZKsUlHWik16ZamE0aHuVSxGxsbdHQDaK5i0hRgXAHcEqTedLeQkil5WSSJbmrRTncl3JR2aUSJEwXJgiRa1GGEU8qICpucokMpSAy+ArmWEQJYR8EyfiZagYDj42NVERwyEXHfvn2rs6YuLXRXkkmI5KvAG4zhn6yqgEg0YpwOwZqlifS1lGIwdW1tjcIgxdNqZcIeRMuy5nA4JMenibSkXsZrrWZEC91FAgzDTlppgabfS3BO33tJQYKTLlJHUtLqfbzT6ZAaEZd1mMLcFA9MoZ0cmQ+R/LT7/T5Lcch0NiLvcldoU90wZkHa6S7gBykWX6+urnCOcUaAU/TlKB3aNEJH9iDrzs6OlEJiUAz8vV6np6faS4tzb3S73eqcqUNr613EPTs7Qw4UUdZkEDgraxUGxFDFrq6uqjCgQ3zylZZ4YITxNLcBWooiG7ge+khM5+DgIJ1VpFmEFr5JyTlEBGxQq1THuBJn8TFY+fUYJSwp9t27d7x3v3nzBnEZ1OMXsyAlWtmmfjNkp7bQUizOheltQZdnFqedNQMtWijDTSZLRAGyLMqmZy9GyKm0ys2KfCS4EvbiDYHtJC6DVNXcPxjMyIMXwAqKSf+obGmbu7yuyQCVDZKSQzr4urW1hbvAocIkECpIC6YDI48EF3N0dETW13WyO7fQ7u6uLqAKugfigU665nI4U1qbd/W68mBEnlOfjjIcnSLulikDsOri4oJB1lm6HKzJbcMWXEO6o2i5qQoryyufg65qe3ubQkiHGs+Tdj6rJbBwNBrJEl51XmxKW526j+vr636/T1LEqqUnYK4Ba9FX2hW23n4ksuBexFOak6pZ51HfH54/rf3H8xrjh/KZRjhEEXIenTQ4E5wAlFJnuZAyaSevSjcJnfL8PBTPXNBhzrT23y8neKivjksY5H1GL381NAudpWWF5VJIVy6rjbgStbokxcyBYMLSxMxp873Ly8xrvLGxkQpcDikJkGB+0kpmqFPo9ghIx8nOfehKRHldpqDN9S7K8gY9HA4Hg0F6MIJerzfHA+Q+Pz9HbiKJoaXwqM49ObpILin1uR4eN7kh5XTOtNldXl0UvLm5OTs70wgvP4e7u7u89hq5y5S73ACfPn1i/D9xhQuAz58/szsdRuxuos01Ay82ppJ6Qa80I0j5/ft3ebDgy4++i4NbVW8Z8HBJa01n0vJ6l1KBNn3agAeM0OprWMWo8yDonqiGbj+RqEZv8yJtdbwMyn3MDFqed/Xa4646eIasJLP0Bezi7k7BRG6D8XhMFqflUNtB4zVNLdrsbuJ1+Z/lSC9aUiO26RTj6tQFcSmLT09P+/3+cYk+OeaUWvPYtN9dZEVQlQ1YS5/ylydUKgcJXcXVgYmDweDi4gKDuTH0KTIes+yDNwM7NtvUTNF+d8mCKKu/GSppaBmhbCgtaqIRVQelgn6bkUO1bKQvPsqQ2RBJQLGr9f1rsqgZMJVcS4LUofSSZw+myZmwIHcCHSnIOqD7QYdF0B0I4BRTyNbVkPkLsnBXtQFlA/ZUQ+XnuPdJ9iBM5E5gNalfZNGyMpGU9MuoCp1VMB3qY31XonGo4kxNsnBXpE8bAI14tGr8vQzmsYJWQz5lUzLx+vo6jk7pWOh5+2vB7Mi+3DbA4VSkqUUu7iLWxsZG0oUW4dKnvHVhbrfbRVNVDuio9XFXKysswb7abjgc0mciz3lEiirI1CQXd/Vurk8bAIE41KdazeyhgP748ePW1hZL0R4cHOzv77MaXiogLastqDHwlYc8DZJ38ZjroV9cUIlOmQXJqGZAstXyT4jSQRRsxt3GqZcVWIrs2+v19vb2sFA5WDcJpyazL4PUuPoEjXFA5dFohMF6gtQlKdgsSEbuIgfJUpZIIDroy0gVUQem0+IrqRQkq1aWxCyrHEyHXfTftRczS4gkjExMP03UKbMgGbkL5N2klFDeRR3QSC0QTtBnBRZnwa9fv/b7fXbRXUFHjsrpBLNUOUxdklmQvPIuunQ6nVR0Ig32cDhlVQOkPgqenJxQBrBs+ssm5+fnHNIh78pyoTRMPuYsV9Ls5smZjNzFG2SibEAaicKIxMW2v1QH+QBfWYcOCZ46gZxKGk6/cjmJRohkd8I4vBtj5pNXzYBY+pQ3mUofdXC3mTqso6XIuNQJmMq9wYgKBqw9Pj7mVqGv+CkII55nuKurK8I4TAuaB8nLXUARfQpbHZclL8mvmTGlaUUpQmGAgvKPcUYAZeffFQQQTwCVA+8A+szBLEh27qLp5Bds2CZ30aiBvqxD4pS4Sq5zTJ0J8UzkGvRtBYd1V8iWHN0l7yrh4Qot+mIeCnJWJtGZ7zFnFUDwYDDQO34D51KRwO3EIqPRSIO0DKpj7iMvd6Um6N0ZP9TiDbUprmAPb9/p1HxYh3jyJeJWQzVhBXUoGOhraxUeRfp1Ap5Ldu5KSpW8KkZxZTwekz5PT0959+ftW5FQTpoNs66vr/UbYRzOD55D2oh1eE+QvnislNx42RzIy129C6MIFQJayA9EAfRlZMGnJSKJPzs7YyKHLPKXsCBXxe7D8v+QQpfEIKe0o7lLXu5KCNrV8q+c4y59PaiR9pJGUE24B6Z8+/aNYGYxdymwlK6NAobcz+LVZuYeWv53IGci53i75w36bqKVNElfNH3//r36CWKoUFlE9lejS0Jb07KLFj86Okrj7Oi/LSLyyrsCCTCSklcdRvAA9B0bcjBOC4oHBSQYUa1MW+TMZaOtabWXmUmO7gLara2tKemiiCzsdrsfPnw4PDzEGBUDOsUhrSZOUYi8bNiU3emwKX2oNjP/JseaATADNfVt1ubmJq4oj3KKHwi1LGelEZ1er6dZT0whcnmd1Ax0dHlckmsGkWm9mzyQo2kExuPx+e3f0uOQU7jCWToKeBrYMWXc9Gu+tHY3kWnexQBUkA0JBknA/ECSu/hBh9xcRfxHcFXpUu1uIlN353D9779hWo0+G+xuItNntQVR6n0+cD26MPrq5IzdncGvEjpk37KyeC7o3QDoW1/XDNPoWQ05quPnRJl8/3S73c3NTf36TnUiS+zuDNJb83OTgwtT6qVF4ud5gz0Zdnce+FH1ngcqFVJbjeaK3TVR8bOaiYrdNVGxuyYqdtdExe6aqNhdExW7a6Jid01U7K6Jit01UbG7Jip210TF7pqo2F0TFbtromJ3TVTsromK3TVRsbsmKnbXRMXumqjYXRMVu2uiYndNVOyuiYrdNVGxuyYqdtdExe6aqNhdExW7a6Jid01U7K6Jit01UbG7Jip210TF7pqo2F0TFbtromJ3TVTsromK3TVRsbsmKnbXRMXumqjYXRMVu2uiYndNTF68+B+ukFOTpBmzggAAAABJRU5ErkJggg==';
        $ctrl.imageLoading = false;

        //PRIVATE METHODS
        function cacheBustImageUrl(imageUrl) {
            return imageUrl + (imageUrl.has('?') ? '&' : '?') + 'ts=' + Date.now();
        }

        function findListedImage() {
            var reportImageId = $ctrl.control && $ctrl.control.reportImageId;
            if (!reportImageId) {
                return;
            }

            var isCustomImage = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(reportImageId);
            if (isCustomImage) {
                return imageHelper.list().find({ id: reportImageId });
            }

            return imageHelper.list().find({
                id: reportImageId,
                name: $ctrl.control.name,
            });
        }

        function loadImage(imageUrl) {
            if (!imageUrl && ['Advisor', 'Representative'].some($ctrl.control.reportImageId)) {
                //we might be looking at a different database so update the imageUrl with what we'd expect for this database
                const matchedImage = imageHelper.list().find({
                    id: $ctrl.control.reportImageId,
                    name: $ctrl.control.name,
                });
                imageUrl = matchedImage ? matchedImage.imageUrl : '';
            }

            if (!imageUrl) {
                imageUrl = '';
            }

            if (imageUrl.startsWith(API_CONFIG.baseUrl)) {
                //imageUrl already starts with the api, just use it
                $ctrl.current.imageUrl = cacheBustImageUrl(imageUrl);
            } else if (imageUrl.startsWith('/')) {
                //need to prepend the url
                $ctrl.current.imageUrl = cacheBustImageUrl(API_CONFIG.baseUrl + imageUrl);
            } else {
                //the imageUrl might be malicious see card 20592 for detail about request forgery.
                //DO NOT USE IT!

                const image = findListedImage();
                if (image) {
                    $ctrl.control.imageUrl = image.imageUrl;
                    $ctrl.current.imageUrl = cacheBustImageUrl(API_CONFIG.baseUrl + image.imageUrl);
                } else {

                    $ctrl.current.imageUrl = $ctrl.control.name ? missingImage : '';
                }
            }
        }

        //PUBLIC METHODS
        $ctrl.$onInit = function() {
            if ($ctrl.control.allowSizing === undefined) {
                Object.defineProperty($ctrl.control, 'allowSizing', {
                    get: function() {
                        return ['Advisor', 'Representative'].some($ctrl.control.reportImageId);
                    },
                    enumerable: false,
                    configurable: false,
                });
            }

            $scope.$watch('$ctrl.control.imageUrl', function(imageUrl) {
                loadImage(imageUrl);
            });

            imageHelper.isReady.then(function() {
                loadImage($ctrl.control.imageUrl);
            });
        };

        $scope.$on(imageHelper.imageChangeEvent, function(e, args) {
            if ($ctrl.control.$index !== args.index) {
                return;
            }

            $ctrl.imageLoading = args.saving;
            if (!args.saving) {
                var image = findListedImage();
                if (image && image.imageUrl) {
                    $ctrl.control.imageUrl = image.imageUrl;
                    loadImage(image.imageUrl);
                }
            }
        });

        $ctrl.current = { imageUrl: null };
    },
});
'use strict';

app.component('rcReportPdf', {
    OAS_DATA: {
        name: 'PDF',
        menuTitle: 'PDF',
        icon: 'fa fa-file-pdf-o',
        category: 'Media',
        schema: {
            $type: 'rcReportPdf',
            pdfUrl: null,
            alt: 'No pdf is selected',
        },
        canUseInCoverPage: false,
    },
    templateUrl: 'reporting/envision/components/report-controls/rcReportPdf.html',
    bindings: {
        control: '<',
    },
    controller: function($scope, $element, pdfHelper, API_CONFIG, reportHelper) {
        const $ctrl = this;
        $ctrl.missingImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOkAAACWCAIAAAC0ITigAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAykSURBVHhe7Z1pQ9tIFkWTTlgNMWEJzvL/f1pCWBwMNgkmyxzpihq3McZSDM1T3fOhplR6VaXgo+cnm2Ze/vjx44UxAfmn+l9jomF3TVTsromK3TVRsbsmKnbXRMXumqjYXRMVu2uiYndNVOyuiYrdNVGxuyYqdtdExe6aqNhdExW7a6Jid01U7K6Jit01UbG7Jip210TF7pqo2F0TFbtromJ3TVTsromK3TVRsbsmKnbXRMXumqjYXRMVu2uiYndNVOzuE/Hnz5+qZ5aE3X0KEPfly5e/f//+9esXfXu8FOzuo4OyEpf+PyUaLE+a5tjdJaO0Ogmy0q6srNAh715eXqbBao5phP8/qpYGLpJf1eoQQen//Pnz5uaGnzOd8XhMu7+/3+l08FiRphl2d2nIRXj16pVyKsoOh8Pr6+tUMDAOm5ubOzs7ijGNsbtNQDulTPknZUFPY/xIya+0UhaVOTU5Cw4PD6dGTF3sbj2mkqWqAhxVVYCydBSjU3Q4qxhGyknFIru7u69fv1aA9W2G3a2BLAS9+zPCT4+S4OrqSmrSkmUZJ0Y5NbUMKkDrbG1tbW9vk6QVbxpgd+9F2qWO+oB5yEqKVSHLWfzDS9W7ZFM6hNHnFGgWMTylEca4FD84OKBTrOu82wi7O42Ewyd1kAzQEfOQFbCWcSKTiHQYkYJJR5kKa2trPJxx2O/3V1dXCdAue3t7KysraaKpi939P9JIbuGrjMRUZVlghFNSjZazxbRb5Ks6RFIVoCayaoRlv3z5QlYuY4sPJbrdbqfTmVrELE6O7koXKTiFtEMsFbK00pFBFQOapTZpR0d9TF1fX1dLDPE8unEbcJbpJycnugE45CwjlA1Kz1rH1CIvdyUNkAUL3W6/PgDOopFKAkA7RtIpYIoko1VuThma/Cpl0ZF4lp20XGGcGgwGl5eXdNLcXq9HcNrC1CI7d9WiC6ARfZQdjUZKsUlHWik16ZamE0aHuVSxGxsbdHQDaK5i0hRgXAHcEqTedLeQkil5WSSJbmrRTncl3JR2aUSJEwXJgiRa1GGEU8qICpucokMpSAy+ArmWEQJYR8EyfiZagYDj42NVERwyEXHfvn2rs6YuLXRXkkmI5KvAG4zhn6yqgEg0YpwOwZqlifS1lGIwdW1tjcIgxdNqZcIeRMuy5nA4JMenibSkXsZrrWZEC91FAgzDTlppgabfS3BO33tJQYKTLlJHUtLqfbzT6ZAaEZd1mMLcFA9MoZ0cmQ+R/LT7/T5Lcch0NiLvcldoU90wZkHa6S7gBykWX6+urnCOcUaAU/TlKB3aNEJH9iDrzs6OlEJiUAz8vV6np6faS4tzb3S73eqcqUNr613EPTs7Qw4UUdZkEDgraxUGxFDFrq6uqjCgQ3zylZZ4YITxNLcBWooiG7ge+khM5+DgIJ1VpFmEFr5JyTlEBGxQq1THuBJn8TFY+fUYJSwp9t27d7x3v3nzBnEZ1OMXsyAlWtmmfjNkp7bQUizOheltQZdnFqedNQMtWijDTSZLRAGyLMqmZy9GyKm0ys2KfCS4EvbiDYHtJC6DVNXcPxjMyIMXwAqKSf+obGmbu7yuyQCVDZKSQzr4urW1hbvAocIkECpIC6YDI48EF3N0dETW13WyO7fQ7u6uLqAKugfigU665nI4U1qbd/W68mBEnlOfjjIcnSLulikDsOri4oJB1lm6HKzJbcMWXEO6o2i5qQoryyufg65qe3ubQkiHGs+Tdj6rJbBwNBrJEl51XmxKW526j+vr636/T1LEqqUnYK4Ba9FX2hW23n4ksuBexFOak6pZ51HfH54/rf3H8xrjh/KZRjhEEXIenTQ4E5wAlFJnuZAyaSevSjcJnfL8PBTPXNBhzrT23y8neKivjksY5H1GL381NAudpWWF5VJIVy6rjbgStbokxcyBYMLSxMxp873Ly8xrvLGxkQpcDikJkGB+0kpmqFPo9ghIx8nOfehKRHldpqDN9S7K8gY9HA4Hg0F6MIJerzfHA+Q+Pz9HbiKJoaXwqM49ObpILin1uR4eN7kh5XTOtNldXl0UvLm5OTs70wgvP4e7u7u89hq5y5S73ACfPn1i/D9xhQuAz58/szsdRuxuos01Ay82ppJ6Qa80I0j5/ft3ebDgy4++i4NbVW8Z8HBJa01n0vJ6l1KBNn3agAeM0OprWMWo8yDonqiGbj+RqEZv8yJtdbwMyn3MDFqed/Xa4646eIasJLP0Bezi7k7BRG6D8XhMFqflUNtB4zVNLdrsbuJ1+Z/lSC9aUiO26RTj6tQFcSmLT09P+/3+cYk+OeaUWvPYtN9dZEVQlQ1YS5/ylydUKgcJXcXVgYmDweDi4gKDuTH0KTIes+yDNwM7NtvUTNF+d8mCKKu/GSppaBmhbCgtaqIRVQelgn6bkUO1bKQvPsqQ2RBJQLGr9f1rsqgZMJVcS4LUofSSZw+myZmwIHcCHSnIOqD7QYdF0B0I4BRTyNbVkPkLsnBXtQFlA/ZUQ+XnuPdJ9iBM5E5gNalfZNGyMpGU9MuoCp1VMB3qY31XonGo4kxNsnBXpE8bAI14tGr8vQzmsYJWQz5lUzLx+vo6jk7pWOh5+2vB7Mi+3DbA4VSkqUUu7iLWxsZG0oUW4dKnvHVhbrfbRVNVDuio9XFXKysswb7abjgc0mciz3lEiirI1CQXd/Vurk8bAIE41KdazeyhgP748ePW1hZL0R4cHOzv77MaXiogLastqDHwlYc8DZJ38ZjroV9cUIlOmQXJqGZAstXyT4jSQRRsxt3GqZcVWIrs2+v19vb2sFA5WDcJpyazL4PUuPoEjXFA5dFohMF6gtQlKdgsSEbuIgfJUpZIIDroy0gVUQem0+IrqRQkq1aWxCyrHEyHXfTftRczS4gkjExMP03UKbMgGbkL5N2klFDeRR3QSC0QTtBnBRZnwa9fv/b7fXbRXUFHjsrpBLNUOUxdklmQvPIuunQ6nVR0Ig32cDhlVQOkPgqenJxQBrBs+ssm5+fnHNIh78pyoTRMPuYsV9Ls5smZjNzFG2SibEAaicKIxMW2v1QH+QBfWYcOCZ46gZxKGk6/cjmJRohkd8I4vBtj5pNXzYBY+pQ3mUofdXC3mTqso6XIuNQJmMq9wYgKBqw9Pj7mVqGv+CkII55nuKurK8I4TAuaB8nLXUARfQpbHZclL8mvmTGlaUUpQmGAgvKPcUYAZeffFQQQTwCVA+8A+szBLEh27qLp5Bds2CZ30aiBvqxD4pS4Sq5zTJ0J8UzkGvRtBYd1V8iWHN0l7yrh4Qot+mIeCnJWJtGZ7zFnFUDwYDDQO34D51KRwO3EIqPRSIO0DKpj7iMvd6Um6N0ZP9TiDbUprmAPb9/p1HxYh3jyJeJWQzVhBXUoGOhraxUeRfp1Ap5Ldu5KSpW8KkZxZTwekz5PT0959+ftW5FQTpoNs66vr/UbYRzOD55D2oh1eE+QvnislNx42RzIy129C6MIFQJayA9EAfRlZMGnJSKJPzs7YyKHLPKXsCBXxe7D8v+QQpfEIKe0o7lLXu5KCNrV8q+c4y59PaiR9pJGUE24B6Z8+/aNYGYxdymwlK6NAobcz+LVZuYeWv53IGci53i75w36bqKVNElfNH3//r36CWKoUFlE9lejS0Jb07KLFj86Okrj7Oi/LSLyyrsCCTCSklcdRvAA9B0bcjBOC4oHBSQYUa1MW+TMZaOtabWXmUmO7gLara2tKemiiCzsdrsfPnw4PDzEGBUDOsUhrSZOUYi8bNiU3emwKX2oNjP/JseaATADNfVt1ubmJq4oj3KKHwi1LGelEZ1er6dZT0whcnmd1Ax0dHlckmsGkWm9mzyQo2kExuPx+e3f0uOQU7jCWToKeBrYMWXc9Gu+tHY3kWnexQBUkA0JBknA/ECSu/hBh9xcRfxHcFXpUu1uIlN353D9779hWo0+G+xuItNntQVR6n0+cD26MPrq5IzdncGvEjpk37KyeC7o3QDoW1/XDNPoWQ05quPnRJl8/3S73c3NTf36TnUiS+zuDNJb83OTgwtT6qVF4ud5gz0Zdnce+FH1ngcqFVJbjeaK3TVR8bOaiYrdNVGxuyYqdtdExe6aqNhdExW7a6Jid01U7K6Jit01UbG7Jip210TF7pqo2F0TFbtromJ3TVTsromK3TVRsbsmKnbXRMXumqjYXRMVu2uiYndNVOyuiYrdNVGxuyYqdtdExe6aqNhdExW7a6Jid01U7K6Jit01UbG7Jip210TF7pqo2F0TFbtromJ3TVTsromK3TVRsbsmKnbXRMXumqjYXRMVu2uiYndNTF68+B+ukFOTpBmzggAAAABJRU5ErkJggg==';
        $ctrl.pdfLoading = false;
        $ctrl.isOpen = true;

        $scope.marginFixTop = {
            margin: '20px',
        };

        $scope.marginFixBottom = {
            margin: '20px',
        };

        //PRIVATE METHODS
        function loadPdf(pdfUrl) {
            if (!pdfUrl) {
                //we might be looking at a different database so update the pdfUrl with what we'd expect for this database
                const matchedPdf = pdfHelper.list().find({ id: $ctrl.control.reportPdfId, name: $ctrl.control.name });
                pdfUrl = matchedPdf ? matchedPdf.pdfUrl : '';
            }

            if (pdfUrl.startsWith(API_CONFIG.baseUrl)) {
                //pdfUrl already starts with the api, just use it
                $ctrl.current.pdfUrl = pdfUrl;
            } else if (pdfUrl.startsWith('/')) {
                //need to prepend the url
                $ctrl.current.pdfUrl = API_CONFIG.baseUrl + pdfUrl;
            } else {
                //the pdfUrl might be malicious see card 20592 for detail about request forgery.
                //DO NOT USE IT!

                const pdf = pdfHelper.list().find({ id: $ctrl.control.reportPdfId });
                if (pdf) {
                    $ctrl.control.pdfUrl = pdf.pdfUrl;
                    $ctrl.current.pdfUrl = API_CONFIG.baseUrl + pdf.pdfUrl;
                } else {
                    $ctrl.current.pdfMissing = !!$ctrl.control.name;
                }
            }
        }

        //PUBLIC METHODS
        $ctrl.$onInit = function() {
            $scope.$watch('$ctrl.control.pdfUrl', function(pdfUrl) {
                loadPdf(pdfUrl);
            });

            reportHelper.$onReportStyleChanged(function(reportStyle) {
                $scope.reportStyle = reportStyle;
            });

            $scope.$on(pdfHelper.pdfChangeEvent, function(e, args) {
                if ($ctrl.control.$index !== args.index) {
                    return;
                }

                if (args.deleted) {
                    $ctrl.current = { pdfUrl: null };
                }

                $ctrl.pdfLoading = args.saving;
            });
        };

        $ctrl.current = { pdfUrl: null };
    },
});

'use strict';

app.component('rcScatterPlot', {
    OAS_DATA: {
        name: 'Scatter Plot',
        icon: 'fa-braille',
        category: 'Charts',
        schema: {
            $type: 'rcScatterPlot',
            groupName: null,
            dataSource: {
                path: 'Performance.Value',
                activityOptionId: null,
                dateRangeId: null
            },
            comparison: {
                path: 'Performance.StandardDeviation',
            },
            config: {
                options: {
                    chart: { height: 250 },
                    legend: { enabled: true, layout: 'horizontal', verticalAlign: 'bottom', align: 'center', useHTML: true },
                    title: { text: '' }
                }
            },
            axes: {
                xAxis: {
                    decimalPlaces: 2,
                    hideSymbol: false
                },
                yAxis: {
                    decimalPlaces: 2,
                    hideSymbol: false
                }
            }
        }
    },
    templateUrl: 'reporting/envision/components/report-controls/rcChart.html',
    bindings: {
        control: '<'
    },
    controller: function ($scope) {
        var $ctrl = this;

        var xAxisTitleText = 'Standard Deviation';
        var yAxisTitleText = 'Performance Benchmarks (TWR)';

        var initialConfig = {
            options: {
                chart: { type: 'scatter' },
                xAxis: {
                    title: { text: xAxisTitleText},
                    labels: {
                        format: '{value:.2f}%'
                    },
                    minPadding : 0.01
                },
                yAxis: {
                    title: { text: yAxisTitleText },
                    labels: {
                        format: '{value:.2f}%'
                    }                    
                },
                tooltip: { enabled: false }
            },

            credits: { enabled: false },
            series: [],
            title: { text: '' },
            subtitle: { text: null }
        };

        //PRIVATE METHODS
        function setSeriesData() {
            var numberOfSeries = Math.floor(Math.random() * 3) + 3;
            for (var i = 1; i <= numberOfSeries; i++) {
                var series = { name: 'Benchmark ' + i, data: [], showInLegend: true };
                var xRandom = (Math.floor(Math.random() * 1000) / 100) + 2;
                var yRandom = (Math.floor(Math.random() * 1000) / 100) + 2;
                series.data.push([xRandom, yRandom]);
                initialConfig.series.push(series);
            }
        }

        function rcScatterPlotTitle(){
            initialConfig.options.xAxis.title.text = ($ctrl.control.axes.xAxis.hideTitle) ? '' : xAxisTitleText;
            initialConfig.options.yAxis.title.text = ($ctrl.control.axes.yAxis.hideTitle) ? '' : yAxisTitleText;
        }

        function rcScatterPlotAddPadding(){
            initialConfig.options.xAxis.minPadding = ($ctrl.control.axes.xAxis.addPadding) ? 0.05 : 0.01;
            initialConfig.options.xAxis.maxPadding = ($ctrl.control.axes.xAxis.addPadding) ? 0.05 : 0.01;
        }

        function updateChartConfig() {
            if ($ctrl.control.$type === 'rcScatterPlot') {
                rcScatterPlotTitle();
                rcScatterPlotAddPadding();
            }
            $ctrl.chartConfig = angular.merge(initialConfig, $ctrl.control.config);
        }

        $scope.$on('reloadScatterPlot', function () {
            initialConfig.series.length = 0;
            setSeriesData();
            updateChartConfig();
        });

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            setSeriesData();
            updateChartConfig();
        };

        $ctrl.$onChanges = function (changes) {
            if (!angular.equals(changes.control.currentValue.grouping, changes.control.previousValue.grouping)) {
                setSeriesData();
            }
            updateChartConfig();
        };
    }
});
'use strict';

app.component('rcWorkBook', {
    templateUrl: 'reporting/envision/components/report-controls/rcWorkBook.html',
    bindings: {
        control: '<',
        allowedTypes: '<?',
        itemLimit: '<?'
    },
    transclude:true,
    controller: function ($scope, $element) {
        var $ctrl = this;

        //PRIVATE METHODS

        function bindEvents(item) {
            item.$emit = function(event, data){
                $scope.$emit(event, data);
            };
            item.$on = function(event, data){
                $scope.$on(event, data);
            };
            item.$broadcast = function(event, data) {
                $scope.$broadcast(event, data);
            };
            return item;
        }

        function wrapControl(item) {
            // return {
            //     $type: "rcSplitter",
            //     controls: [bindEvents(item)]
            // };
            return bindEvents(item);
        }

        function unWrapControl(control) {
            if (control && control.controls) {
                control.controls = control.controls.map(function (c) {
                    //if this is a fake splitter unwrap it
                    if (c && c.$type === 'rcSplitter' && c.controls.length === 1) {
                        return unWrapControl(c.controls[0]);
                    }
                    return unWrapControl(c);
                });
            }

            return control;
        }

        //PUBLIC METHODS
        $ctrl.controlNeedsWrap = function (item) {
            return (item && $ctrl.control.$type !== 'rcSplitter');
        };

        $ctrl.wrapControlIfNeeded = function (item) {
            return $ctrl.controlNeedsWrap(item) ? wrapControl(item) : bindEvents(item);
        };

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            $scope.$on('qb-event:sheet-action', function (event, data) {
                if(data.action === "load-sheet") {
                    $ctrl.current.selectedSheet = data.focus;
                }
            });
            $ctrl.current.selectedSheet = $ctrl.control.controls[0];  //start with first worksheet
        };

        $ctrl.$onChanges = function () {
            if ($ctrl.control !== undefined && $ctrl.control !== null) {
                $ctrl.control.controls = $ctrl.control.controls.compact();

                bindEvents($ctrl.control);

                //if this is a splitter don't wrap it again
                for (let i = 0; i < $ctrl.control.controls.length; i++) {
                    $ctrl.control.controls[i] = wrapControl($ctrl.control.controls[i]);
                }

                //PUBLIC METHODS
                $ctrl.control.isFake = function () {
                    //splitters with one thing in them are fake. They only exist to make the drag and drop work nicer
                    return $ctrl.control !== undefined && $ctrl.control.$type === 'rcSplitter' && $ctrl.control.controls !== undefined && $ctrl.control.controls.length === 1;
                };

                $ctrl.control.addControl = function (item) {
                    $ctrl.current.selectedSheet.control = bindEvents(item);
                };

                $ctrl.control.unWrapControl = function () {
                    var copied = angular.copy($ctrl.control);
                    return unWrapControl(copied);
                };
            }
        };

        $ctrl.current = {
            selectedSheet: null,
        };
    }
});
'use strict';

app.component('rcWorkSheet', {
    templateUrl: 'reporting/envision/components/report-controls/rcWorkSheet.html',
    bindings: {
        control: '<'
    },
    controller: function ($scope, $timeout, $window, QB_COMPONENT_NAMES) {
        var $ctrl = this;


        $ctrl.selectControl = function (control, event) {
            $scope.$emit('rb-event:select-control', {control: control, event: event});
        };

        $ctrl.hoverControl = function (control, event) {
            $scope.$emit('rb-event:hover-control', {control: control, event: event});
        };

        $ctrl.removeControl = function (index) {
            var removedControls = $ctrl.control.controls.splice(index, 1);

            $scope.$emit('rb-event:remove-controls', removedControls);

            if ($ctrl.control.$type === 'rcSplitter' && $ctrl.control.controls.length === 0 && $ctrl.parent !== undefined) {
                //empty splitters need to ask their parents to delete them
                var myIndex = $ctrl.parent.indexOf($ctrl.control);
                if (myIndex !== -1) {
                    $ctrl.parent.removeControl(myIndex);
                }
            }

            if ($ctrl.parent) {
                $ctrl.parent.reflow();
            } else {
                $ctrl.reflow();
            }
        };

        $ctrl.getComponentName = function (control) {
            return QB_COMPONENT_NAMES[control.$type];
        };

        var sendingReflow = false;
        $ctrl.reflow = function () {
            if (!sendingReflow) {
                sendingReflow = true;
                $timeout(function () {
                    $scope.$broadcast('highchartsng.reflow');
                    sendingReflow = false;
                    $timeout(function () {
                        $window.dispatchEvent(new Event("resize"));
                    }, 500);
                }, 10);
            }
        };
    }
});
'use strict';

app.directive('rcWorkSheetTabs', function() {
    return {
        templateUrl: 'reporting/envision/components/rcWorkSheetTabs.html',
        scope: { controls: "=" },
        replace: true,
        link: function(scope) {
            //PUBLIC METHODS
            scope.limitTextLength = function(sheet) {
                if (sheet.sheetName.length <= 31) {
                    return;
                } else {
                    sheet.sheetName = sheet.sheetName.substr(0, 31);
                }
            };

            scope.focus = function(selected) {
                scope.$emit('qb-event:sheet-action', { action: "load-sheet", focus: selected });
            };

            scope.newSheet = function() {
                scope.controls.add({$type: "rcWorkSheet", sheetName: "New Sheet " + (scope.controls.length + 1), control:null});
            };
        }
    };
});
'use strict'

app.component('oasStylesheet', {
    template:   '<style type="text/css">' +
                    '{{$ctrl.css}}' +
                '</style>',
    bindings: { value: '=', css: '=' },
    controller: function OasStylesheetCtrl($scope, $element, $attrs) {
        //PRIVATE VARIABLES
        var self = this;
        var specialStyles = ['fontWeight','fontStyle','textDecoration','borderTopStyle','borderBottomStyle','borderLeftStyle','borderRightStyle','display','fill'];

        //PRIVATE METHODS
        function loadCSS() {
            self.css = '';
            var selectors = Object.keys(self.value);
            selectors.each(function(s){
                if(angular.isArray(self.value[s])  ){
                    if(s === "palette"){
                        var makeHighchartsClassName = function(index, length){
                            var c = '.highcharts-color.highcharts-color-'+index;

                            for(var i = 1; (i*length) + index < 200; i++) {
                                var number = (i * length) + index;
                                c += ',\n\t.highcharts-color.highcharts-color-' + number;
                            }

                            return c;
                        };
                        self.value[s].forEach(function (color, index) {
                            //this should be the only thing we need for the pallet
                            self.css += '\t.entity:nth-child(' + self.value[s].length + 'n+' + (index+1) + '):not(.highcharts-color) {\n\t\t--entity-color: ' + color.fill + ';\n\t}\n';
                            self.css += '\t.benchmark:nth-child(' + self.value[s].length + 'n+' + (index+1) + '):not(.highcharts-color) {\n\t\t--entity-color: ' + color.fill + ';\n\t}\n';
                            self.css += '\t'+makeHighchartsClassName(index, self.value[s].length)+' {\n\t\t--entity-color:' + color.fill + ';\n\t}\n';
                        });
                    } else {
                        self.value[s].forEach(function (style, index) {
                            self.css += ('\t' + s + '-' + index + ' {\n' + formatStyle(style) + '\n\t}\n');
                        });
                    }
                } else {
                    self.css += ('\t' + s + ' {\n' + self.getSelector(s) + '\n\t}\n');
                }
            });
        }
        function formatStyle(style) {
            var result = '';
            if(style) {
                Object.keys(style).each(function(k){
                    if(!k.startsWith('$$hashKey')) {
                        var isSpecial = specialStyles.some(k);
                        result += ('\t\t' + k.dasherize() + ': ' + (!isSpecial ? style[k] : style[k].toLocaleLowerCase()) + ';\n');
                    }
                });
            }
            return result;
        }

        //PUBLIC METHODS
        self.$onInit = function() {
            loadCSS();
        };
        self.getSelector = function(selector) {
            var result = '';
            if(self.value[selector]) {
                Object.keys(self.value[selector]).each(function(k){
                    if(angular.isObject(self.value[selector][k])) {
                        result += ('\t\t' + k.dasherize() + ' {\n');
                        Object.keys(self.value[selector][k]).each(function(j){
                            var isSpecial = specialStyles.some(j);
                            result += ('\t\t\t' + j.dasherize() + ': ' + (!isSpecial ? self.value[selector][k][j] : self.value[selector][k][j].toLocaleLowerCase()) + ';\n');
                        });
                        result += ('\n\t\t}\n');
                    } else {
                        var isSpecial = specialStyles.some(k);
                        result += ('\t\t' + k.dasherize() + ': ' + (!isSpecial ? self.value[selector][k] : (self.value[selector]?.[k]?.toLocaleLowerCase() || "")) + ';\n');
                    }
                });
            }
            return result;
        };

        //SCOPE WATCHERS
        $scope.$watch("$ctrl.value", function (newValue, oldValue) {
            if (newValue === oldValue) return;
            loadCSS();
        }, true);

        //INITIALIZE
        self.css = "";
    }
});
'use strict';

app.directive('rcResolve', function($oasRights) {
    return {
        require: 'ngModel',
        controller: 'rbResolveCtrl',
        controllerAs: '$resolve',
        scope: false,
        bindToController: {
            filterTags: '&',
            displayMode: '@',
            resolveType: '@',
            rcResolveSimple: '@',
            rcResolveActivate: '=',
            rcQueryBuilder: '@',
            rcEditRights: '<',
            ngDisabled: '='
        },
        compile: function(tElement, tAttributes) {
            
            return {
                post: function (scope, elem, attrs, ngModel) {
                    scope.hasAdvancedEditorRights = scope.$resolve.rcEditRights || $oasRights.canRead('REPORTBUILDERADVANCEDEDITOR');
                    if (scope.hasAdvancedEditorRights && elem[0].nodeName !== 'INPUT') {
                        elem[0].setAttribute('contenteditable', 'true');
                    }
                    scope.$watch(function () { return scope.$resolve.ngDisabled; }, function (newValue, oldValue) {
                        if (newValue === oldValue) {
                            return;
                        }

                        if (newValue){
                            elem[0].setAttribute('contenteditable', 'false');
                            elem[0].classList.add('disabled');
                        }
                        else{
                            elem[0].setAttribute('contenteditable', 'true');
                            elem[0].classList.remove('disabled');
                        }
                    });

                     if(elem[0].nodeName !== 'INPUT') {
                         scope.$resolve.init(ngModel);
                     }
                     //Set element that is disable
                     if(scope.$resolve.ngDisabled) {
                         elem[0].setAttribute('contenteditable', 'false');
                         elem[0].classList.add('disabled');
                     }
                }
            };
        }
    };
});

app.controller('rbResolveCtrl', ["$element", "$attrs", "$scope", "$q", "$compile", "reportHelper", "resolveHelper", "$timeout", "resolveKeyActionHelper", "RcResolveService", "ZIndexCalculationService", "optionsHelper", function ($element, $attrs, $scope, $q, $compile, reportHelper, resolveHelper, $timeout, resolveKeyActionHelper, RcResolveService, ZIndexCalculationService, optionsHelper) {
    const self = this;
    let ngModel;

    const $document = $(window.document);
    const selection = window.getSelection();

    const config = {
        blockTag: 'p',
        fontsizeUnit: 'PT',
        isActive: false,
        isFirefox: /firefox/i.test(navigator.userAgent),
        get isInline() { return config.mode === 'inline' },
        get isResolve() { return config.type === 'resolve' },
        get isText() { return config.type === 'text' },
        type: 'resolve',
        mode: 'inline',
        terms: [],
        commands: {
            fontName: Resolve.Command(Resolve.Command.FONT_NAME),
            fontSize: Resolve.Command(Resolve.Command.FONT_SIZE),
            bold: Resolve.Command(Resolve.Command.BOLD),
            italic: Resolve.Command(Resolve.Command.ITALIC),
            underline: Resolve.Command(Resolve.Command.UNDERLINE),
            justifyLeft: Resolve.Command(Resolve.Command.JUSTIFY_LEFT),
            justifyCenter: Resolve.Command(Resolve.Command.JUSTIFY_CENTER),
            justifyRight: Resolve.Command(Resolve.Command.JUSTIFY_RIGHT),
            foreColor: Resolve.Command(Resolve.Command.FORE_COLOR),
            //strikethrough: Resolve.Command(Resolve.Command.STRIKETHROUGH),
            subscript: Resolve.Command(Resolve.Command.SUBSCRIPT),
            superscript: Resolve.Command(Resolve.Command.SUPERSCRIPT),
            removeFormat: Resolve.Command(Resolve.Command.REMOVE_FORMAT),
        }
    };

    self.$element = $element;
    self.resolveType = $attrs.resolveType;
    self.current = {
        isGroupingTable: null,
        contained: [],
        get useCalculations() {
            if (!self.current.isGroupingTable){
                self.current.isGroupingTable = self.current.term.resolve['controlType'] === 'rcGroupingTable' || self.current.term.resolve['controlType'] === 'rcColumnGroupingTable';
            }

            return !!self.current.term && self.current.term.resolve.resultType === 'currency' &&  this.isGroupingTable && !self.ngDisabled;

        },
        get controlRegister() {
            return config.control && config.control.$index;
        },
        get terms() {
            return self.current.contained.map(function(c){return c.term}).filter(function(t,i,a){return t && a.indexOf(t) === i});
        },
        get term() {
            const terms = self.current.terms;
            if(terms.length === 1) {
                return terms[0];
            }
        },
        panes: [
            { name: 'Info', icon: 'info', get enabled() { return !!self.current.term && !self.rcResolveSimple; } },
            { name: 'CustomizeColumnName', icon: 'columns', get enabled() { return !!self.current.term && self.rcResolveSimple; } },
            { name: 'Options', icon: 'cog', get enabled() { return !!self.current.term && self.current.term.resolve.$options.length > 0; } },
            { name: 'Format' ,icon: 'paragraph', get enabled(){ return !!self.current.term && self.current.term.resolve.$formatOptions.some(function(fo){ return fo.enabled; }) && !self.ngDisabled; }},
            { name: 'Calculations', icon: 'calculator', get enabled() { return self.current.useCalculations; }  },
            { name: 'Filter',icon: 'filter', get enabled() { return !!self.current.term && !self.ngDisabled; } }
        ],
        get activePane() {
            if (config.activePane && config.activePane.enabled) {
                return config.activePane;
            }

            // Find and return the first enabled pane
            for (let index = 0; index < self.current.panes.length; index++) {
                if (self.current.panes[index].enabled) {
                    config.activePane = self.current.panes[index];

                    return config.activePane;
                }
            }

            // If everything is disabled return the first one
            return self.current.panes[0];
        },
        set activePane(pane) {
            config.activePane = pane;
        },
        get commands() {
            return self.ngDisabled ? [] : Object.values(config.commands);
        },
        state: {
            get $cursor() { return config.isActive; },
            get $resolves() { return self.current.state.$cursor && self.current.search; },
            get $term() { return (self.current.open || $scope.$resolve.modalOpen) && self.current.state.$cursor && self.current.term && !self.current.state.$resolves; },
            get $context() { return (self.current.open || $scope.$resolve.modalOpen) && !config.isInline && self.current.state.$cursor && !self.current.state.$resolves; },
        },
        get disabled() {return self.ngDisabled;},
        groupingOptions: reportHelper.groupingOptions,
        weightedBenchmarkGroupingOptions: reportHelper.weightedBenchmarkGroupingOptions,
        handleContextUpdate: (optionId, guid, optionLabel, reportOption) => { RcResolveService.handleContextChange(optionId, guid, optionLabel, reportOption, this.current.term.resolve); },
        handleFilterUpdate: (chgFilter) => { 
            this.current.term.resolve.filter = chgFilter; 
            
        },
        optionIsDisabled: (currentDisabled, reportOption) => {
            return currentDisabled;
        },
        taxInceptionTypes: reportHelper.taxInceptionTypes,
        costPerShareMethods: reportHelper.costPerShareMethods,
        getSelectedOption: (optionType) => { return optionsHelper.getOptionIdOrGuidFromObject(optionType, this.current.term.resolve)}
    };
    self.editor = {
        get size() {
            let value = '~';
            const command = config.commands.fontSize || {};
            if(command.value > 0) {
                value = Number(command.value);
                if(self.editor.unit === 'PX' && command.unit === 'PT') value = (value * 96 / 72);
                if(self.editor.unit === 'PT' && command.unit === 'PX') value = (value * 72 / 96);
                value = value.round(4);
            }
            return value;
        },
        set size(value) {
            self.execCommand(Resolve.Command.FONT_SIZE, value)
        },
        get sizes() {
            const command = config.commands.fontSize || {};
            return command.options
        },
        get unit() {
            if(config.fontsizeUnit) {
                return config.fontsizeUnit;
            } else {
                const command = config.commands.fontSize || {};
                return command.unit;
            }
        },
        set unit(value) {
            config.fontsizeUnit = typeof value === 'string' ? value.toUpperCase() : null;
        },
        get units() {
            const command = config.commands.fontSize || {};
            return command.units
        },
        get font() {
            const command = config.commands.fontName || {};
            return command.value
        },
        set font(value) {
            self.execCommand(Resolve.Command.FONT_NAME, value)
        },
        get fonts() {
            const command = config.commands.fontName || {};
            return command.options
        },
        get color() {
            const command = config.commands.foreColor || {};
            return command.value;
        },
        set color(value) {
            self.execCommand(Resolve.Command.FORE_COLOR, value)
        }
    };

    // PRIVATE

    function rangePosition(range) {
        let position;
        try {
            if (range) {
                const rects = range.getClientRects();
                if (rects.length > 0) {
                    position = rects[rects.length - 1];
                } else {
                    const container = range.commonAncestorContainer,
                        offset = range.startOffset;
                    let right = container.childNodes[offset],
                        left = container.childNodes[offset - 1];

                    if (right && right.nodeType === Node.TEXT_NODE) {
                        right = null;
                    }

                    if (left && left.nodeType === Node.TEXT_NODE) {
                        left = null;
                    }

                    const wrapper = (right || left || container);
                    if (wrapper && wrapper.getBoundingClientRect) {
                        const rect = wrapper.getBoundingClientRect();
                        if (right || !container.hasChildNodes()) {
                            rect.width = 0;
                        }
                        position = rect;
                    }
                }
            }
        } catch (e) {
            console.log('rangePosition', e);
        }
        return position;
    }

    function getPosition(inner, outer) {
        return {
            top: (inner.top + inner.height + outer.scrollTop),
            left: (inner.left + inner.width + outer.scrollLeft),
        };
    }

    function cursorTick() {
        const _scope = reportHelper.resolve.$cursorScope;

        if(!_scope.frame && _scope.$resolve) {
            _scope.frame = requestAnimationFrame(function(){
                let inner;
                if(_scope.$resolve.current.state.$cursor && (inner = rangePosition(_scope.$resolve.current.range))) {
                    const height = reportHelper.resolve.$cursor.outerHeight(true);
                    const width = reportHelper.resolve.$cursor.outerWidth(true);
                    const outer = reportHelper.resolve.$viewport.offset();
                    outer.scrollTop = reportHelper.resolve.$viewport.scrollTop();
                    outer.scrollLeft = reportHelper.resolve.$viewport.scrollLeft();
                    outer.width = reportHelper.resolve.$viewport.width();
                    outer.height = reportHelper.resolve.$viewport.height();

                    const position = getPosition(inner, outer);
                    if(reportHelper.resolve.$viewport[0] !== document.body) {
                        position.top -= outer.top;
                        position.left -= outer.left;
                    }
                    if((position.left + width + 20) > outer.width + outer.scrollLeft) position.left -= width;


                    if(position.top !== _scope.position.top || position.left !== _scope.position.left) {
                        reportHelper.resolve.$cursor.css(_scope.position = position);
                    }
                }
                _scope.frame = false;
                if(_scope.$resolve.current.state.$cursor && (_scope.ts + 1500) >= Date.now()) {
                    cursorTick();
                }
                _scope.$resolve.current.setOriginalFocus = function(e) {
                    _scope.$resolve.current.term.$focus = e.target;
                };
            });
        }
    }

    function updateCursor() {
        reportHelper.resolve.$cursorScope.ts = Date.now();
        cursorTick();
    }

    function attachCursor() {
        initCursor();
        if(!config.scrollParent) config.scrollParent = $(resolveHelper.getScrollParent($element[0]));
        if(reportHelper.resolve.$viewport !== config.scrollParent) {
            reportHelper.resolve.$viewport = config.scrollParent;
            reportHelper.resolve.$cursor.css('z-index', ZIndexCalculationService.getFirstSetZIndex(self.$element[0]));

            reportHelper.resolve.$viewport.append(reportHelper.resolve.$cursor);

            $timeout(() => {
                updateRange();
            });
        }
    }

    function initCursor() {
        if(reportHelper.resolve) {
            return;
        }

        // Without advanced editor rights the user doesn't get to edit tags. Claiming the shared

        if(!$scope.hasAdvancedEditorRights) {
            return;
        }

        // reportHelper.resolve here would leave it without a cursor for later instances that do have rights.
        reportHelper.resolve = {};

        // Cursor
        reportHelper.resolve.$cursor = angular.element('<resolve-cursor data-registry="{{$resolve.current.controlRegister}}"></resolve-cursor>');

        // Context
        reportHelper.resolve.$context = angular.element(
            '<resolve-menu ng-if="$resolve.current.state.$context">' +
            '<resolve-row>' +
            '<div ng-if="($resolve.current.commands | filter:{control:\'button\'}).length > 0 && !$resolve.rcResolveSimple" class="btn-group">' +
            '<button ng-repeat="command in $resolve.current.commands | filter:{control:\'button\'} track by command.key" ng-class="{active: command.value}" ng-click="$resolve.execCommand(command);" data-test-id="resolve-command-{{::command.key}}">' +
            '<i class="fa fa-fw fa-{{::command.image}}" title="{{::command.key}}"></i>' +
            '</button>' +
            '</div>' +
            '</resolve-row>' +
            '<resolve-row>' +
            '<div ng-if="($resolve.current.commands | filter:{control:\'select\'}).length > 0 && !$resolve.rcResolveSimple" class="btn-group">' +
            '<div class="btn-group dropdown" dropdown style="margin: 0">' +
            '<button dropdown-toggle data-test-id="resolve-font-select">' +
            '<span style="overflow:hidden;text-overflow:ellipsis;display:inline-block;max-width:100px;vertical-align:top">{{ $resolve.editor.font }}</span>&nbsp;<i class="fa fa-fw fa-caret-down" aria-hidden="true"></i>' +
            '</button>' +
            '<ul class="dropdown-menu" style="min-width: auto">' +
            '<li ng-repeat="(value, name) in $resolve.editor.fonts" ng-class="{active: $resolve.editor.font == name}" data-test-id="resolve-font-option-{{::name}}">' +
            '<a ng-click="$resolve.editor.font = value;">{{::name}}</a>' +
            '</li>' +
            '</ul>' +
            '</div>' +
            '<div class="btn-group dropdown" dropdown style="margin: 0">' +
            '<button dropdown-toggle data-test-id="resolve-font-size-select">' +
            '{{ $resolve.editor.size }}&nbsp;<i class="fa fa-fw fa-caret-down" aria-hidden="true"></i>' +
            '</button>' +
            '<ul class="dropdown-menu" style="min-width: auto">' +
            '<li ng-repeat="(value, name) in $resolve.editor.sizes" ng-class="{active: $resolve.editor.size == name}" data-test-id="resolve-font-size-option-{{::name}}">' +
            '<a ng-click="$resolve.editor.size = value;">{{::name}}</a>' +
            '</li>' +
            '</ul>' +
            '</div>' +
            '<div class="btn-group dropdown" dropdown style="margin: 0">' +
            '<button dropdown-toggle data-test-id="resolve-font-size-unit-select">' +
            '{{ $resolve.editor.unit }}&nbsp;<i class="fa fa-fw fa-caret-down" aria-hidden="true"></i>' +
            '</button>' +
            '<ul class="dropdown-menu" style="min-width: auto">' +
            '<li ng-repeat="(value, name) in $resolve.editor.units" ng-class="{active: $resolve.editor.unit == name}" data-test-id="resolve-font-size-unit-option-{{::name}}">' +
            '<a ng-click="$resolve.editor.unit = value;">{{::name}}</a>' +
            '</li>' +
            '</ul>' +
            '</div>' +
            '<div class="btn-group" style="margin: 0">' +
            '<button colorpicker="hex" colorpicker-zindex-from-parent ng-model="$resolve.editor.color" ng-model-options="{debounce:250}" data-test-id="resolve-font-color-open-picker">' +
            '<span ng-style="{backgroundColor: $resolve.editor.color}" style="min-width:36px;box-shadow:0 0 2px rgba(0,0,0,.5),inset 0 0 0 1px rgba(255,255,255,.4)">' +
            '<i class="fa fa-fw" aria-hidden="true"></i>' +
            '</span>&nbsp;' +
            '<input ng-model="$resolve.editor.color" ng-model-options="{updateOn:\'blur\'}" data-test-id="resolve-font-color-input" >' +
            '</button>' +
            '</div>' +
            '</div>' +
            '</resolve-row>' +
            '</resolve-menu>'
        );

        // Term
        reportHelper.resolve.$term = angular.element(
            '<resolve-detail ng-if="$resolve.current.state.$term">' +
            '<resolve-list class="resolve-tabs">' +
            '<button ng-repeat="pane in ($resolve.current.panes | filter:{enabled:true}) track by pane.name" ng-class="{active: $resolve.current.activePane === pane}" ng-click="$resolve.current.activePane = pane; $event.stopImmediatePropagation()" data-test-id="resolve-pane-{{::pane.name}}"><i class="fa fa-fw fa-{{::pane.icon}}"></i></button>' +
            '</resolve-list>' +
            '<resolve-panes>' +
            '<div ng-if="(!$resolve.current.activePane.name || $resolve.current.activePane.name == \'Info\')" data-test-id="resolve-pane-info">' +
            '<h5 class="no-top-margin">{{$resolve.current.term.resolve.definitionLabel}}</h5>' +
            '<p>{{$resolve.current.term.resolve.description}}</p>' +
            '</div>' +
            '<div ng-if="(!$resolve.current.activePane.name || $resolve.current.activePane.name == \'CustomizeColumnName\')" data-test-id="resolve-pane-CustomizeColumnName" id ="resolve-pane-CustomizeColumnName">' +
            '<label class="control-label">Customize Column Name ' +
            '<a id="oplCustomColumnNameInfo" [attr.data-test-id]="custom-column-name-info-popover"><i class="fa fa-info-circle" aria-hidden="true"></i></a></label>' +
            '<oat-tooltip target="#oplCustomColumnNameInfo" position="left">' +
            '<div className="oat-popover oat-popover-bc">' +
            '<div className="oat-popover-body">Override the default name defined by the system when the query is generated</div>' +
            '</div>' +
            '</oat-tooltip>'+
            '<input type="text" ng-Model="$resolve.current.term.resolve.label" ng-model-options="{updateOn: \'blur mouseout click\'}">' +
            '</div>' +
            '<div ng-if="$resolve.current.activePane.name == \'Options\'" data-test-id="resolve-pane-options">' +
            '<div ng-repeat="reportOption in $resolve.current.term.resolve.$options track by reportOption.optionType" class="control-group">\n' +
            '<label class="control-label">{{::reportOption.label}}</label>\n' +
            '<div class="controls">\n' +
            '<rc-context-profile-editor type="{{::reportOption.optionType}}" selected="$resolve.current.getSelectedOption(reportOption.optionType)" is-disabled="$resolve.current.optionIsDisabled($resolve.current.disabled, reportOption)" on-update="$resolve.current.handleContextUpdate(optionId, guid, optionLabel, reportOption)" edit="false"></rc-context-profile-editor>\n' +
            '</div>' +
            '<label ng-if="reportOption.optionType === \'date-range\'" class="control-label"><input style="margin-top:-2px;" type="checkbox" ng-model="$resolve.current.term.resolve[\'cumulative\']" ng-disabled="$resolve.current.disabled">&nbsp;&nbsp;Cumulative</label>\n' +
            '</div>' +
            '<div ng-if="$resolve.current.term.resolve.options.some(\'WeightedBenchmarkGrouping\')">' +
            '<label class="control-label">Weighted Benchmark Grouping\n' +
            '<select ' +
            'class="input-block-level" ' +
            'ng-model="$resolve.current.term.resolve[\'weightedBenchmarkGrouping\']" ' +
            'ng-model-options="{updateOn: \'default\'}" ' +
            'ng-options="option for option in $resolve.current.weightedBenchmarkGroupingOptions" ' +
            '></select>' +
            '</label>\n' +
            '</div>' +
            '<div ng-if="$resolve.current.term.resolve.options.some(\'TaxInceptionType\')">' +
            '<label class="control-label">Tax Inception Type\n' +
            '<select ' +
            'class="input-block-level" ' +
            'ng-model="$resolve.current.term.resolve[\'taxInceptionType\']" ' +
            'ng-model-options="{updateOn: \'default\'}" ' +
            'ng-options="option for option in $resolve.current.taxInceptionTypes" ' +
            '></select>' +
            '</label>\n' +
            '</div>' +
            '<div ng-if="$resolve.current.term.resolve.options.some(\'CostPerShareMethod\')">' +
            '<label class="control-label">Cost Per Share Method\n' +
            '<select ' +
            'class="input-block-level" ' +
            'ng-model="$resolve.current.term.resolve[\'costPerShareMethod\']" ' +
            'ng-model-options="{updateOn: \'default\'}" ' +
            'ng-options="option for option in $resolve.current.costPerShareMethods" ' +
            '></select>' +
            '</label>\n' +
            '</div>' +
            '</div>' +
            '<div ng-if="$resolve.current.activePane.name == \'Format\'" data-test-id="resolve-pane-format">' +
            '<div ng-repeat="formatOption in ($resolve.current.term.resolve.$formatOptions | filter:{enabled:true}) track by formatOption.name" class="control-group">' +
            '<label ng-if="(formatOption.type === \'boolean\' && formatOption.name !== \'Show Dollar Sign\')" class="control-label"><input style="margin-top:-2px;" type="checkbox" ng-model="formatOption.value">&nbsp;&nbsp;{{::formatOption.name}}</label>\n' +
            '<label ng-if="(formatOption.type === \'boolean\' && formatOption.name === \'Show Dollar Sign\')" class="control-label"><input style="margin-top:-2px;" type="checkbox" ng-model="formatOption.value" ng-disabled="$resolve.current.term.resolve[\'costPerShareMethod\'] === \'Percentage of Par\'">&nbsp;&nbsp;{{::formatOption.name}}</label>\n' +
            '<label ng-if="formatOption.type !== \'boolean\'" class="control-label">{{::formatOption.name}}</label>\n' +
            '<div ng-if="formatOption.type !== \'boolean\'" class="controls">' +
                                '<input ng-if="formatOption.type === \'text\'" type="text" ng-model="formatOption.value" ng-model-options="{updateOn: \'default\', debounce: 1000}" class="input-block-level" ng-focus="$resolve.current.setOriginalFocus($event);">' +
                                '<input ng-if="formatOption.type === \'number\'" type="number" ng-model="formatOption.value" ng-model-options="{updateOn: \'default\', debounce: 1000}" class="input-block-level" ng-focus="$resolve.current.setOriginalFocus($event);">' +
            '<select ng-if="formatOption.type === \'select\'" ng-options="o.value as o.name for o in formatOption.options" ng-model="formatOption.value"></select>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div ng-if="$resolve.current.activePane.name == \'Calculations\'" data-test-id="resolve-pane-calculations">' +
            '<label ng-if="$resolve.current.useCalculations || ($resolve.current.term.resolve.resultType === \'currency\' && $resolve.current.isGroupingTable)" class="control-label">'+
            '<input style="margin-top:-2px;" type="checkbox" ng-model="$resolve.current.term.resolve[\'isSubtotal\']">&nbsp;&nbsp;Subtotal</label>\n' +
            '<div ng-if="$resolve.current.term.resolve[\'isSubtotal\']">' +
            '<label class="control-label">Subtotal Grouping\n' +
            '<select ' +
            'class="input-block-level" ' +
            'ng-model="$resolve.current.term.resolve[\'subtotalGrouping\']" ' +
            'ng-model-options="{updateOn: \'default\'}" ' +
            'ng-options="option for option in $resolve.current.groupingOptions" ' +
            '></select>' +
            '</label>\n' +
            '</div>' +
            '</div>' +
            '<div ng-if="$resolve.current.activePane.name == \'Filter\'" data-test-id="resolve-pane-filter">' +
            '<rb-filter filter="$resolve.current.term.resolve.filter" on-update="$resolve.current.handleFilterUpdate(chgFilter);" render-as="resolve"></rb-filter>' +
            '</div>' +
            '</resolve-panes>' +
            '</resolve-detail>'
        );

        // options
        reportHelper.resolve.$resolves = angular.element(
            '<resolve-options ng-if="$resolve.current.state.$resolves">' +
            '<resolve-list>' +
            '<button ng-repeat="resolve in ($resolve.current.search.options | filter:{deprecated:\'!true\'}) track by resolve.$key" data-key="{{::resolve.path}}" ng-click="$resolve.select(resolve)" data-test-id="resolve-tag-option-{{::resolve.path}}">' +
            '{{::resolve.label}}' +
            '</button>' +
            '</resolve-list>' +
            '</resolve-options>'
        );

        reportHelper.resolve.$cursor.append(reportHelper.resolve.$context);
        reportHelper.resolve.$cursor.append(reportHelper.resolve.$term);
        reportHelper.resolve.$cursor.append(reportHelper.resolve.$resolves);

        reportHelper.resolve.$cursorScope = $scope.$root.$new(true);
        reportHelper.resolve.$cursorScope.position = {};

        reportHelper.resolve.$cursorScope.$on(reportHelper.GetDefaultOptionEvent, function (event, data) {
            //redirect the event to the controls
            event.stopPropagation();
            reportHelper.resolve.$cursorScope.$resolve.$emit("rb-event:get-default-option", data);
        });

        const onMouseDown = function(event) {
            if(
                reportHelper.resolve.$cursorScope.$resolve && reportHelper.resolve.$cursorScope.$resolve.current.open && (
                    !nodeIsOrContains(reportHelper.resolve.$cursor[0], event.target) &&
                    !nodeIsOrContains(reportHelper.resolve.$cursorScope.$resolve.$element[0], event.target)
                )
            ) {
                reportHelper.resolve.$cursorScope.$resolve.close();
            }
        };

        document.addEventListener("mousedown", onMouseDown);

        $compile(reportHelper.resolve.$cursor)(reportHelper.resolve.$cursorScope);
    }

    function _parse(value) {
        const range = document.createRange();
        range.selectNodeContents($element[0]);
        const fragment = range.createContextualFragment(value||$element[0].innerHTML);
        getTermElements(fragment).forEach(function(node){
            const term = getTerm(node);
            range.selectNode(node);
            range.deleteContents();
            if(term) range.insertNode(document.createTextNode(term.$encode()));
        });
        return fragment;
    }

    function _format(value) {
        let content = value.replace(String.fromCharCode(65279), '');

        if (config.isResolve) {
            content = content.replace(
                resolveHelper.patterns.globalDecode,
                function (match, full, data) {
                    const term = new ResolveTerm(JSON.parse(data), self);
                    config.terms.push(term);
                    return term.$element.outerHTML;
                });

        }

        const range = document.createRange();
        range.selectNodeContents($element[0]);
        const fragment = range.createContextualFragment(content);

        if(!config.isInline) {
            let block;

            Resolve.Node(fragment).descendants().forEach(function (node) {
                if (fragment === node) return;
                const ancestor = node.parentNode;
                if (isBlock(node)) {
                    if (!ResolveNode.isName(node, config.blockTag)) node = changeTag(node, config.blockTag);
                    if (!ancestor.isSameNode(fragment)) {
                        block = undefined;
                        range.selectNode(node);
                        fragment.appendChild(range.extractContents());
                        if (ResolveNode.isEmpty(ancestor)) {
                            range.selectNode(ancestor);
                            range.deleteContents();
                        }
                    }
                } else {
                    if (ancestor.isSameNode(fragment)) {
                        block = block || node.parentNode.insertBefore(document.createElement(config.blockTag), node);
                        range.selectNode(node);
                        block.appendChild(range.extractContents());
                    }
                    if (isBreak(node)) {
                        const curBlock = currentBlock(node);
                        const currentBlockHasContent = !curBlock || curBlock.textContent.length !== 0;
                        if (currentBlockHasContent) {
                            const parent = node.parentNode;
                            range.selectNode(parent);
                            range.setEndAfter(node);

                            const split = range.extractContents().firstChild;
                            parent.parentNode.insertBefore(split, parent);
                        }
                    }
                    if (ResolveNode.isName(node, 'resolve-term')) {
                        const resolve = resolveHelper.getOption({$index: node.getAttribute('index')}, self);
                        if (!resolve) {
                            ancestor.removeChild(node);
                        }
                    }
                }
            });

            if (!fragment.hasChildNodes()) {
                fragment.appendChild(newBlock());
            } else {
                RcResolveService.cleanupEndingBreaks(fragment, Array.from(fragment.querySelectorAll(config.blockTag)));
            }
        }

        return fragment;
    }

    function newBlock(contents) {
        const block = document.createElement(config.blockTag);
        if(!contents || contents.length === 0){
            block.appendChild(document.createElement('br'));
        }
        return block;
    }

    function query() {
        if(self.current.search) {
            let options = self.findOptions(self.current.search.result);
            self.current.search.options = options;
            setSelected(options[0]);
        }
    }

    function getTerm(key) {
        if(key instanceof Node) {
            const node = isUneditable(key);
            if(node) key = node.getAttribute('index');
        }
        if(Object.prototype.toString.call(key) === "[object String]") {
            return config.terms.find({$index: key});
        }
    }

    function insertTerm(term, range) {
        config.terms.push(term);

        range = (range || self.current.search.range).cloneRange();
        const currentTerm = getTerm(range.commonAncestorContainer);
        if(currentTerm) {
            range.selectNode(currentTerm.$element);
        }
        range.deleteContents();
        range.insertNode(term.$element);
        range.collapse(false);
        term.$element.parentElement.normalize();
        return term;
    }

    function ResolveTerm(data, rcResolve) {
        const term = this;
        let element;

        term.resolve = resolveHelper.getOption(data, rcResolve);
        term.$index = term.resolve.$index;
        term.$encode = function () { return term.resolve.encode(); };

        Object.defineProperties(term, {
            '$label': {
                get: function(){
                    if (!term.$element.firstChild) term.$label = term.resolve.displayText;
                    return element.firstChild;
                },
                set: function(value){
                    const e = term.$element;
                    let offset = (self.current.range && self.current.range.intersectsNode(e)) ? self.current.range.endOffset : false;
                    const length = e.textContent.length;

                    value = value instanceof Node ? value.textContent : value;
                    if(!value || value.length === 0) value = String.fromCharCode(65279);
                    e.textContent = value;
                    if (offset) {
                        if(offset === length) offset = value.length;
                        self.current.range.setEnd(term.$label, Math.min(value.length, offset));
                        self.current.range.collapse(false);
                        updateSelection(self.current.range);
                    }
                }
            },
            '$element': {
                get: function() {
                    element = term.resolve.find($element) || term.resolve.createElement();
                    if(self.resolveType === 'deliver' && term && term.resolve && term.resolve.containsPii && element.className.toLowerCase().indexOf("deprecated") === -1){
                        element.className += " deprecated";
                    }
                    return element;
                },
                set: function(value) {
                    term.$label = value;
                }
            }
        });

        term.watcher = $scope.$watchCollection(function(){
            return term.resolve.displayText;
        }, function(newVal, oldVal) {
            if(newVal !== oldVal) {
                term.$label = newVal;
                if(reportHelper.resolve) {
                    if( $scope.$resolve.current.term && $scope.$resolve.current.term.$focus ) {
                        $scope.$resolve.current.term.$focus.focus();
                    }
                }
            }
        });

        return term;
    }

    function textNodesOf(el) {
        return Resolve.Node(el).descendants({types: NodeFilter.SHOW_TEXT});
    }

    function clean() {
        self.$element[0].normalize();
        textNodesOf(self.$element[0]).forEach(function(node){
            const text = node.data, modified = text.replace(String.fromCharCode(65279), '');
            if(text !== modified) node.data = modified;
        });
    }

    function BOM() {
        return document.createTextNode(String.fromCharCode(65279));
    }

    function nextText(node) {
        if(node && node !== $element[0]) {
            const walker = ResolveNode(node).walker({root: $element[0]});
            while(node = walker.nextNode()) {
                if(node.nodeType === Node.TEXT_NODE) return node;
            }
        }
    }

    function previousText(node) {
        if(node && node !== $element[0]) {
            const walker = ResolveNode(node).walker({root: $element[0]});
            walker.currentNode = node;
            while(node = walker.previousNode()) {
                if(node.nodeType === Node.TEXT_NODE) return node;
            }
        }
    }

    function nodeLength(node) {
        if(node instanceof Node) return node.length || node.childNodes.length
    }

    function nodeIsOrContains(subject, target) {
        return subject === target || subject.contains(target)
    }

    function isUneditable(node) {
        const rn = ResolveNode(node).getElement();
        return rn.isName('resolve-term') ? rn.node : false;
    }

    function currentBlock(node) {
        while(node instanceof Node && node !== $element[0]) {
            if(isBlock(node)) return node;
            else node = node.parentNode;
        }
        if(node.firstChild instanceof Node && isBlock(node.firstChild))
            return node.firstChild;
        return false;
    }

    function currentElement(node) {
        while(node instanceof Node) {
            if(node instanceof Element) return node;
            else node = node.parentNode;
        }
        return false;
    }

    function scrollIntoView() {
        $scope.$evalAsync(function() {
            const $list = reportHelper.resolve.$cursor.children('resolve-options');
            const $selected = $list.find('button[data-key="' + self.current.search.selected.path + '"]');
            if ($selected.length > 0) {
                const padding = 10;
                let top = $selected.position().top;
                const clearance = $list.height() - $selected.outerHeight();

                if(top < 0) {
                    top -= padding;
                    $list.scrollTop($list.scrollTop() + top);
                } else if(top > clearance) {
                    top = top - clearance + padding;
                    $list.scrollTop($list.scrollTop() + top);
                }
            }
        });

    }

    function isText(node) {
        return ResolveNode.isText(node);
    }

    function isBreak(node) {
        return ResolveNode.isBreak(node);
    }

    function isBlock(node) {
        return ResolveNode.isBlock(node);
    }

    function changeTag(source, tagname) {
        const range = document.createRange();
        const element = document.createElement(tagname);
        range.selectNodeContents(source);
        element.appendChild(range.extractContents());

        for (let i = 0; i < source.attributes.length; i++) {
            const a = source.attributes[i];
            element.setAttribute(a.name, a.value);
        }

        source.parentNode.replaceChild(element, source);

        return element;
    }

    function getRangeDetails(range) {
        let term;

        const details =  {
            left: {
                offset: range.startOffset,
                container: range.startContainer,
                element: currentElement(range.startContainer),
                block: currentBlock(range.startContainer) || $element[0]
            },
            right: {
                offset: range.endOffset,
                container: range.endContainer,
                element: currentElement(range.endContainer),
                block: currentBlock(range.endContainer) || $element[0]
            },
            terms: []
        };

        const walker = ResolveNode.walker({root: $element[0]});
        do {
            const nodeRangeDetail = Resolve.Node(walker.currentNode).rangeDetail(self.current.range);
            if(
                walker.currentNode.nodeType === Node.TEXT_NODE &&
                nodeRangeDetail.isEffectivelyContained &&
                (term = getTerm(walker.currentNode))
            ) {
                if(!details.terms.any(term)) details.terms.push(term);
            }
        } while(walker.nextNode());

        details.left.node = (details.left.container.nodeType !== Node.TEXT_NODE || details.left.offset === 0)
            ? previousText(details.left.container)
            : details.left.container;
        details.left.term = getTerm(details.left.node);

        details.right.node = (details.right.container.nodeType !== Node.TEXT_NODE || details.right.offset === nodeLength(details.right.container))
            ? nextText(details.right.container)
            : details.right.container;
        details.right.term = getTerm(details.right.node);

        if(!config.isInline) {
            if(details.left.block.textContent.length === 0) {
                details.left.atBlockBoundary = true;
            } else if(details.left.offset === 0) {
                let node = details.left.container;
                while(node === node.parentNode.firstChild && self.$element[0].contains(node)) {
                    node = node.parentNode;
                }
                details.left.atBlockBoundary = isBlock(node);
            }

            if (details.right.block.textContent.length === 0) {
                details.right.atBlockBoundary = true;
            } else if (details.right.offset === nodeLength(details.right.container)) {
                let node = details.right.container;
                while (node === node.parentNode.lastChild && self.$element[0].contains(node)) {
                    node = node.parentNode;
                }
                details.right.atBlockBoundary = isBlock(node);
            }
        }

        return details;
    }

    function updateRange() {
        if(!config.isActive || config.isExecuting) {
            return;
        }

        if (selection.rangeCount > 0) {
            const range = selection.getRangeAt(selection.rangeCount - 1);
            if (nodeIsOrContains(self.$element[0], range.commonAncestorContainer)) {
                self.current.range = range;

                if(config.isResolve) {
                    self.current.contained.length = 0;
                    if (self.current.range) {
                        const walker = ResolveNode.walker({root: range.commonAncestorContainer});
                        do {
                            const containment = Resolve.Node(walker.currentNode).rangeDetail(self.current.range);
                            if (containment.isVisuallyContained) {
                                containment.term = getTerm(containment.node);
                                self.current.contained.push(containment);
                            }
                        } while (walker.nextNode());
                    }

                    if (range && range.collapsed && !self.current.term && range.commonAncestorContainer.nodeType === Node.TEXT_NODE) {
                        const result = resolveHelper.patterns.search.exec((range.commonAncestorContainer.textContent).substring(0, range.startOffset));
                        if (result && result.index > -1) {
                            self.current.search = {
                                result: result,
                                range: range.cloneRange()
                            };
                            self.current.search.range.setStart(range.commonAncestorContainer, self.current.search.result.index);
                            self.current.search.range.setEnd(range.commonAncestorContainer, range.startOffset);
                            query();
                        }
                    }
                }

                self.current.commands.forEach(function (command) {
                    let value = document.queryCommandValue(command.key);
                    if(angular.isString(value)){
                        value = value.replace(/['|"]/g, '');
                    }

                    if (value === 'true') value = true;
                    else if (value === 'false') value = false;
                    else if (value === 'null') value = null;
                    else if (value === 'undefined') value = undefined;
                    else if (command.key === 'justifyLeft') value = (value === 'left');
                    else if (command.key === 'justifyCenter') value = (value === 'center');
                    else if (command.key === 'justifyRight') value = (value === 'right');
                    else if (command.key === 'foreColor') value = Resolve.Color(value).toHex();

                    if (command.key === Resolve.Command.FONT_SIZE) {
                        let inlineSize;
                        let computedSize;
                        const values = self.current.contained.map(function (containment) {
                            let element = (containment.node instanceof Element
                                ? containment.node
                                : containment.node.parentElement);
                            inlineSize = findInlineFontSize(element, $element[0]);
                            computedSize = window.getComputedStyle(element).getPropertyValue('font-size');
                            return inlineSize || computedSize;
                        }).filter(function(t,i,a){return t && a.indexOf(t) === i});
 
                        if(values.length === 1) {
                            if(/PX/i.test(values[0])) command.unit = 'PX';
                            else if (/PT/i.test(values[0])) command.unit = 'PT';
                            if (inlineSize && values[0].match(/(px|pt)$/i)) config.fontsizeUnit = command.unit;
                            value = Number((/\d*\.?\d+/.exec(values[0])||[])[0]);
                        } else {
                            value = null;
                        }
                    }

                    if (command.options) {
                        value = command.options[value] || value;
                    }
                    command.value = value;
                });

                updateCursor();
            }
            else if (!nodeIsOrContains(reportHelper.resolve.$cursor[0], range.commonAncestorContainer)) {
                setActive(false);
            }
        }
    }

    function findInlineFontSize(element, root) {
        for (let cur = element; cur && cur !== root; cur = cur.parentElement) {
            const style = cur.style;
            if (!style) continue;
 
            const size = style.fontSize;
            if (!size) continue;
 
            const trimmed = size.trim();
            if (/(px|pt)$/i.test(trimmed)) {
                return trimmed;
            }
        }
        return null;
}

    function updateSelection(range, clear) {
        try {
            if (clear === true) {
                self.cancel();
            } else {
                selection.removeAllRanges();
            }
        } catch (error) {
            console.log('updateSelection', error);
        }
        selection.addRange(range);
        return range;
    }

    function setActive(value) {
        if(!value && $scope.$resolve.modalOpen) return;
        if(value !== config.isActive) {
            if(value) {
                attachCursor();
                reportHelper.resolve.$cursorScope.$resolve = self;
                updateRange();
                attachEvents();
                $document.on('selectionchange', updateRange);
            } else {
                detachEvents();
                $document.off('selectionchange', updateRange);
                read();
            }
        }
        return config.isActive = value;
    }

    function mergeBlock(source, target) {
        if(isBlock(source) && isBlock(target)) {
            let node;
            const range = document.createRange();
            if(target.textContent.length === 0) {
                $(target).remove();
                return;
            }
            if(source.textContent.length === 0) {
                const rw = ResolveNode.walker({root: target});
                if(source.compareDocumentPosition(target) & 4) {
                    while (rw.firstChild()) {
                        //keep digging
                    }
                    range.selectNodeContents(rw.currentNode);
                    range.collapse(true);
                } else {
                    while (rw.lastChild()) {
                        //keep digging
                    }
                    range.selectNodeContents(rw.currentNode);
                    range.collapse(false);
                }
                $(source).remove();
                return range;
            }

            $(target).find('br').remove();
            $(source).find('br').remove();


            if(target.childNodes.length > 0 && target.style.cssText !== source.style.cssText) {
                range.surroundContents(document.createElement('span'));
                target.firstChild.style.cssText = target.style.cssText;
                target.style.cssText = '';
            }

            range.selectNodeContents(target);
            range.collapse(false);

            if(source.childNodes.length > 0) {
                if(target.style.cssText !== source.style.cssText) {
                    $(source).wrapInner(document.createElement('span'))[0].firstChild.style.cssText = source.style.cssText;
                }

                const split = document.createRange();
                split.selectNodeContents(source);
                range.insertNode(split.extractContents());
                range.collapse(true);

                if(range.startContainer.hasChildNodes()) {
                    if(node = range.startContainer.childNodes[range.startOffset]) {
                        const rw = ResolveNode.walker({root: node});
                        while (rw.firstChild()) {
                            //keep digging
                        }
                        range.selectNodeContents(rw.currentNode);
                        range.collapse(true);
                    } else if(node = range.startContainer.childNodes[range.startOffset - 1]) {
                        const rw = ResolveNode.walker({root: node});
                        while (rw.lastChild()) {
                            //keep digging
                        }
                        range.selectNodeContents(rw.currentNode);
                        range.collapse(false);
                    }
                }
            }

            $(source).remove();

            if(target.textContent.length === 0) {
                range.insertNode(document.createElement('br'));
            }
            range.collapse(false);

            return range;
        }
    }

    function getTermElements(root) {
        return Array.from((root || $element[0]).querySelectorAll('resolve-term'));
    }

    function setTermsState(state) {
        getTermElements().forEach(function(term){
            term.setAttribute('contenteditable', !!state);
        });
    }

    function read() {
        ngModel.$setViewValue(RcResolveService.decodeSpecialCharacters(_parse().innerHTML));
    }

    function getResolveOptions() {
        return resolveHelper.getResolveOptions(self.resolveType);
    }

    function mouseEventAction(event) {
        if (event.which === 1) self.open();
        else self.close();
    }

    function keyupEventAction(event) {
        if(self.moved) return self.moved = false;
        clean();
        updateRange();
        read();
    }

    function rangeNotCollapsed(effectiveRange) {
        const details = getRangeDetails(effectiveRange);

        details.terms.forEach(function (term) {
            const isolate = {
                node: document.createTextNode(term.$element.outerText)
            };

            if (effectiveRange.startContainer === term.$label) isolate.startOffset = effectiveRange.startOffset;
            if (effectiveRange.endContainer === term.$label) isolate.endOffset = effectiveRange.endOffset;

            term.$element.replaceWith(isolate.node);

            if (isolate.startOffset > -1 && isolate.startOffset <= isolate.node.length) effectiveRange.setStart(isolate.node, isolate.startOffset);
            if (isolate.endOffset > -1 && isolate.endOffset <= isolate.node.length) effectiveRange.setEnd(isolate.node, isolate.endOffset);
        });
        updateSelection(effectiveRange);
    }

    function getEffectiveRange() {
        updateRange();
        return self.current.range.cloneRange();
    }

    function shouldBeClosed(content){
        return !content.includes('@');
    }

    function isEmptyNode(node) {
        return node.textContent.length === 0;
    }

    function isCursorAtEnd(offset, container) {
        return offset === (container.length ?? 0);
    }

    function isCursorAtStart(offset) {
        return offset === 0;
    }

    function keydownEventAction(event) {
        if (!self.current.state.$resolves) {
            self.close();
        }

        const actionToTake = resolveKeyActionHelper.getActionToTake(event);

        switch (actionToTake) {
            case 'Up':
                resolveKeyActionHelper.upAction(self, event);
                return;
            case 'Down':
                resolveKeyActionHelper.downAction(self, event);
                return;
            case 'Open':
                resolveKeyActionHelper.openAction(self, event);
                return;
            case 'Style':
                resolveKeyActionHelper.styleAction(self, event);
                return;
            case 'Cancel':
                resolveKeyActionHelper.cancelAction(self);
                return;
            case 'Select':
                resolveKeyActionHelper.selectAction(self, event);
                return;
            case 'Text':
                self.textAction(event);
                return;
            case 'Back':
                self.backAction(event);
                return;
            case 'Delete':
                self.deleteAction(event);
                return;
            case 'None':
                return;
        }
    }

    function focusEventAction(event) {
        setActive(true);
    }

    function attachEvents() {
        if(!$scope.hasAdvancedEditorRights){
            return;
        }
        $element[0].addEventListener("mouseup", mouseEventAction);
        $element[0].addEventListener("mousedown", mouseEventAction);
        $element[0].addEventListener("keyup", keyupEventAction);
        $element[0].addEventListener("keydown", keydownEventAction);
    }

    function detachEvents() {
        $element[0].removeEventListener("mouseup", mouseEventAction);
        $element[0].removeEventListener("mousedown", mouseEventAction);
        $element[0].removeEventListener("keyup", keyupEventAction);
        $element[0].removeEventListener("keydown", keydownEventAction);
    }

    // API
    self.init = function (model) {
        ngModel = model;
        config.mode = $element.attr('mode') || 'editor';
        config.type = $element.attr('type') || 'resolve';
        config.placeholder = $element.attr('placeholder') || '';
        config.control = reportHelper.getControlFromScope($scope);



        ngModel.$render = function () {
            while($element[0].firstChild) {
                $element[0].removeChild($element[0].firstChild);
            }
            var frag = _format(ngModel.$viewValue || '');
            $element[0].appendChild(frag);
        };

        if($scope.hasAdvancedEditorRights) {
            $element[0].addEventListener("focus", focusEventAction);
            $element[0].addEventListener("selectstart", focusEventAction);
        }

        if (config.isFirefox) document.execCommand("styleWithCSS", false, true);
    };

    self.execCommand = function (command, argument) {
        if(config.isInline) return;
        config.isExecuting = true;

        if(angular.isString(command)) command = self.current.commands.fnFind(function(c){ return c.key === command});
        const original = self.current.range.cloneRange();
        let range = original.cloneRange();

        const terms = {
            startOffset: range.startOffset,
            endOffset: range.endOffset,
            start: getTerm(range.startContainer),
            end: getTerm(range.endContainer)
        };

        if(terms.start || terms.end) {
            if (terms.start) {
                const buffer = BOM();
                terms.start.$element.before(buffer);
                range.setStartBefore(buffer);
            }

            if (terms.end) {
                const buffer = BOM();
                terms.end.$element.after(buffer);
                range.setEndAfter(buffer);
            }
        }

        range = updateSelection(range);

        if(config.isFirefox && Resolve.Command.REMOVE_FORMAT === command.key) setTermsState(false);
        if(Resolve.Command.FONT_SIZE === command.key) {
            document.execCommand(Resolve.Command.FONT_SIZE, false, 7);
            self.$element.find('font[size=7]').removeAttr("size").css("font-size", argument+self.editor.unit.toLowerCase());
        } else {
            document.execCommand(command.key, false, command.argument || argument);
        }
        if(config.isFirefox && Resolve.Command.REMOVE_FORMAT === command.key) setTermsState(true);

        clean();

        if(terms.start || terms.end) {
            if(terms.start) range.setStart(terms.start.$label, terms.startOffset);
            if(terms.end) range.setEnd(terms.end.$label, terms.endOffset);
            updateSelection(range);
        }

        config.isExecuting = false;
        updateRange();

        read();
    };

    self.select = function () {
        const option = arguments.length <= 0 || arguments[0] === undefined ? self.current.search.selected : arguments[0];
        if (option) {
            const range = self.current.search.range.cloneRange();
            const term = insertTerm(new ResolveTerm(option, self), range);
            range.selectNodeContents(term.$label);
            range.collapse(false);
            updateSelection(range);
            self.cancel();

            if(!textNodesOf(currentBlock(term.$element)).some(function(n){return /[^\s]/.test(n.textContent) && !n.isSameNode(term.$label)}) &&
                term.resolve.isType(['numeric', 'currency', 'decimal', 'percent', 'currency-growth-of'])) {
                updateRange();
                self.execCommand(ResolveCommand.JUSTIFY_RIGHT, null);
            }

            read();
        }
    };

    self.newLine = function (event) {
        if (config.isInline) {
            event.preventDefault();
            return;
        }

        let effectiveRange = getEffectiveRange();
        const {left, right} = getRangeDetails(effectiveRange);

        if (left.term && nodeIsOrContains(left.term.$element, left.container)) {
            if (left.offset === 0) {
                effectiveRange.setStartBefore(left.term.$element);
            } else if (left.offset === nodeLength(left.container)) {
                effectiveRange.setStartAfter(left.term.$element);
            } else {
                const r = document.createRange();
                r.selectNode(left.term.$element);
                r.deleteContents();
                r.insertNode(left.node = document.createTextNode(left.term.resolve.label));
                effectiveRange.setStart(left.node, left.offset);
            }
            if (effectiveRange.collapsed) effectiveRange.collapse(true);
        }

        if (right.term && nodeIsOrContains(right.term.$element, right.container)) {
            if (right.offset === 0) {
                effectiveRange.setEndBefore(right.term.$element);
            } else if (right.offset === nodeLength(right.container)) {
                effectiveRange.setEndAfter(right.term.$element);
            } else {
                const r = document.createRange();
                r.selectNode(right.term.$element);
                r.deleteContents();
                r.insertNode(right.node = document.createTextNode(left.term.resolve.label));
                effectiveRange.setEnd(right.node, right.offset);
            }
            if (effectiveRange.collapsed) effectiveRange.collapse(false);
        }

        const root = currentBlock(effectiveRange.commonAncestorContainer);
        if (!root){
            return;
        }

        const split = {range: effectiveRange.cloneRange(), node: root.cloneNode(false)};
        split.range.selectNodeContents(root);
        split.range.setStart(effectiveRange.endContainer, effectiveRange.endOffset);
        root.parentNode.insertBefore(split.node, root.nextSibling);
        split.node.appendChild(split.range.extractContents());

        if (root.textContent.length === 0 && !$(root).has('br').length) {
            effectiveRange.insertNode(document.createElement('br'));
        }

        let node = split.node;
        while (node && node.firstChild) {
            node = node.firstChild;
        }
        effectiveRange.selectNodeContents(node);
        effectiveRange.collapse(true);

        if (split.node.textContent.length === 0 && !$(split.node).has('br').length) {
            effectiveRange.insertNode(document.createElement('br'));
            effectiveRange.collapse(false);
        }

        updateSelection(effectiveRange);
        event.preventDefault();
    }

    self.textAction = function (event) {
        let effectiveRange = getEffectiveRange();

        if (!effectiveRange.collapsed) {
            rangeNotCollapsed(effectiveRange);
            return;
        }

        const {left, right} = getRangeDetails(effectiveRange);

        if (left.term && nodeIsOrContains(left.block, left.term.$element)) {
            if (left.term === right.block) {
                const node = document.createTextNode('@' + left.term.resolve.path);
                left.term.$element.replaceWith(node);
                effectiveRange.setStart(node, node.length);
                effectiveRange.collapse(true);
                updateSelection(effectiveRange);
                event.preventDefault();
            } else {
                const node = document.createTextNode(['Space', ' '].any(event.key) ? '\u00a0' : event.key);
                left.term.$element.after(node);
                effectiveRange.setEnd(node, 1);
                effectiveRange.collapse(false);
                updateSelection(effectiveRange);
                event.preventDefault();
            }
        }

        if (right.term && nodeIsOrContains(right.block, right.term.$element)) {
            const node = document.createTextNode(['Space', ' '].any(event.key) ? '\u00a0' : event.key);
            right.term.$element.before(node);
            effectiveRange.setEnd(node, 1);
            effectiveRange.collapse(false);
            updateSelection(effectiveRange);
            event.preventDefault();
        }
    }

    self.backAction = function (event) {
        let effectiveRange = getEffectiveRange();

        if (!effectiveRange.collapsed) {
            rangeNotCollapsed(effectiveRange);
            return;
        }

        const {left} = getRangeDetails(effectiveRange);

        if (left.term && nodeIsOrContains(left.block, left.term.$element)) {
            const node = document.createTextNode('@' + left.term.resolve.path);
            left.term.$element.replaceWith(node);
            effectiveRange.setStart(node, node.length);
            effectiveRange.collapse(true);
            updateSelection(effectiveRange);
            event.preventDefault();
            return;
        }

        if (left.atBlockBoundary || shouldBeClosed(left.container.textContent)) {
            var offset = isEmptyNode(left.block) ? 0 : left.offset;
            if(isCursorAtStart(offset))
            {
                effectiveRange = mergeBlock(left.block, left.block.previousSibling) || effectiveRange;
            }
            updateSelection(effectiveRange, true);
            if(left.atBlockBoundary) {
                event.preventDefault();
            }
        }
    }

    self.deleteAction = function (event) {
        let effectiveRange = getEffectiveRange();

        if (!effectiveRange.collapsed) {
            rangeNotCollapsed(effectiveRange);
            return;
        }

        const {right} = getRangeDetails(effectiveRange);

        if (right.term && nodeIsOrContains(right.block, right.term.$element)) {
            const node = document.createTextNode('@' + right.term.resolve.path);
            right.term.$element.replaceWith(node);
            effectiveRange.setStart(node, node.length);
            effectiveRange.collapse(true);
            updateSelection(effectiveRange);
            event.preventDefault();
            return;
        }

        if (right.atBlockBoundary || shouldBeClosed(right.container.textContent)) {
            var offset = isEmptyNode(right.block) ? 0 : right.offset;
            if(isCursorAtEnd(offset,right.block.textContent)) {
                effectiveRange = mergeBlock(right.block.nextSibling, right.block) || effectiveRange;
            }
            updateSelection(effectiveRange, true);
            if(right.atBlockBoundary) {
                event.preventDefault();
            }
        }
    }

    self.up = function () {
        const index = self.current.search.options.indexOf(self.current.search.selected);
        if (index > 0) {
            setSelected(self.current.search.options[index - 1]);
        } else {
            setSelected(self.current.search.options[self.current.search.options.length - 1]);
        }
        scrollIntoView();
    };

    self.down = function () {
        const index = self.current.search.options.indexOf(self.current.search.selected);
        if (index < self.current.search.options.length - 1) {
            setSelected(self.current.search.options[index + 1]);
        } else {
            setSelected(self.current.search.options[0]);
        }
        scrollIntoView();
    };

    function setSelected(value) {
        if(!value){
            return;
        }

        self.current.search.selected = value;

        setTimeout(() => {
            let $list = reportHelper.resolve.$cursor.children('resolve-options');
            let $selected = $list.find(".active");
            $selected.removeClass("active");

            let $value = $list.find('button[data-key="' + value.path + '"]');
            $value.addClass("active")

        })

    }

    self.findOptions = function (match) {
        let options = getResolveOptions();

        const filterTags = self.filterTags();
        if(filterTags !== undefined){
            options = options.filter(filterTags);
        }
        if(match[1] !== '') {
            options = options.filter(function (o) {
                return RcResolveService.tagMatchesSearch(o, match[1]) && o.types.some('Value');
            });
        }

        const uniqueOptions = [];
        const uniqueKeysMap = new Map();
        options.forEach(o => {
            if (!uniqueKeysMap.has(o.$key)){
                uniqueKeysMap.set(o.$key, true);
                uniqueOptions.push(o);
            }
        })

        return uniqueOptions;
    };

    self.cancel = function () {
        self.current.open = false;
        self.current.search = false;
    };

    self.isContentEditable = function() {
        return ['INPUT', 'TEXTAREA'].indexOf(self.$element[0].nodeName) === -1;
    };

    $scope.$watch(() => $scope.$resolve.rcResolveActivate, (newVal, oldVal) => {
        if(oldVal !== newVal) {
            if(newVal) {
                $element[0].focus();
                setTimeout(self.open, 10);
            }else{
                self.close();
            }
        }
    });

    self.open = function() {
        if(self.current.open) return;
        self.current.open = true;
        if($scope.$resolve.rcResolveActivate !== undefined) {
            $scope.$resolve.rcResolveActivate = true;
        }
    };

    self.close = function() {
        if(!self.current.open) return;
        if(!$scope.$resolve.modalOpen)
            self.current.open = false;
        if($scope.$resolve.rcResolveActivate !== undefined) {
            $scope.$resolve.rcResolveActivate = false;
        }
    };

    self.updateContextOption = function(propertyName, selected){
        const tag = self.current.term.resolve;
        tag[propertyName] = selected;
    };

    function syncRemappedOptions(currentResolve, remappedOptions) {
        remappedOptions.forEach((ro) => {
            if (currentResolve[ro.propertyName] === ro.oldId) {
                self.updateContextOption(ro.propertyName, ro.newId);
            }
        })
    }

    self.$emit = function(name, data) { $scope.$emit(name, data) };

    // EVENTS & WATCHES
    $scope.$on('$destroy', function() {
        setActive(false);
        detachEvents();
        $element[0].removeEventListener("focus", focusEventAction);
        $element[0].removeEventListener("selectstart", focusEventAction);
    });

    $scope.$on(reportHelper.RefreshResolvesEvent, (event, remappedOptions) => {
        if (self.current.term) {
            $timeout(() => {
                syncRemappedOptions(self.current.term.resolve, remappedOptions)
            })
        }
    });
}]);

'use strict';

app.component('rbChartDecimalPlaces', {
   templateUrl: 'reporting/envision/components/rbChartDecimalPlaces.html',
   bindings: {
       axes: '<',
       chartType: '<',
       onUpdate: '&'
   },
   controller: function () {
       const $ctrl = this;

       $ctrl.update = function () {
           $ctrl.onUpdate({chgAxisDecimalPlaces: $ctrl.axes});
       };
   }
});




'use strict'

app.directive('rbStyleBlock', function rbStyleBlock() {
    return {
        restrict: 'E',
        scope: {
            sectionStyle: '='
        },
        templateUrl: 'reporting/envision/components/rbStyleBlock.html',
        link: function (scope, element, attrs) {
            //var $ctrl = this;

            //LIFECYCLE HOOKS
            function init() {
                if(scope.sectionStyle && scope.sectionStyle.fontSize) {
                    scope.current.fontValue = parseInt(scope.sectionStyle.fontSize);
                    scope.current.selectedFontType = scope.sectionStyle.fontSize.substr(scope.sectionStyle.fontSize.length-2,2);
                } else if(scope.includeFont) {
                    scope.current.fontValue = 7;
                    scope.current.selectedFontType = "pt";
                }
                if(scope.sectionStyle && scope.sectionStyle.borderWidth) {
                    scope.current.borderValue = parseInt(scope.sectionStyle.borderWidth);
                }
            }

            //PUBLIC METHODS
            scope.updateFontSize = function() {
                scope.sectionStyle.fontSize = scope.current.fontValue + scope.current.selectedFontType;
            };

            scope.updateBorderWidth = function() {
                scope.sectionStyle.borderWidth = scope.current.borderValue + "px";
            };

            scope.$watch("sectionStyle", function(newValue, oldValue){
                if(newValue === oldValue) return;
                init();
            }, true);

            //INITIALIZE
            scope.includeBackground = attrs.includeBackground ? scope.$eval(attrs.includeBackground) : true;
            scope.includeFont = attrs.includeFont ? scope.$eval(attrs.includeFont) : true;
            scope.includeBorder = attrs.includeBorder ? scope.$eval(attrs.includeBorder) : true;
            scope.includeBorderWidth = attrs.includeBorderWidth ? scope.$eval(attrs.includeBorderWidth) : true;

            scope.fontFamilies = ["Arial", "Arial Black", "Cambria", "Courier New", "Tahoma", "Times New Roman", "Verdana"];
            scope.unitTypes = ["pt", "px", "em"];
            scope.borderStyles = ["none", "solid", "dashed", "dotted"];
            scope.current = { selectedFontType: "pt", fontValue: 7, borderValue: 1 };

            init();
        }
    };

});
'use strict';

app.component('rbGrouping', {
    templateUrl: 'reporting/envision/components/rbGrouping.html',
    bindings: {
        control: '<'
    },
    controller: function ($scope, reportHelper, rcChartHelper, optionsHelper) {
        const $ctrl = this;
        const internal = {};

        //PRIVATE METHODS
        function groupingValidation(){
            if($ctrl.groupingMatches('Time')){
                $ctrl.control.contextChange = {
                    dateRangeId: null,
                    returnStyle: {
                        frequency: 'Annually',
                        basedOn: 'Calendar',
                        breakBehavior: 'AllowPartialPeriods',
                        cumulative: false,
                        context: 'Self',
                    }
                };
            }
        }

        function findGroupingOptionInList(options, saved) {
            if (saved == null || saved === '') {
                return null;
            }

            return options.fnFind(function (option) {
                return option.grouping == saved || option.name === saved || option.value == saved;
            });
        }

        function findResolvedOptionInList(options, resolved) {
            if (!resolved) {
                return null;
            }

            if (resolved.isAdHoc) {
                return options.fnFind(function (option) {
                    return option.isAdHoc && option.adhocOptionGuid === resolved.adhocOptionGuid;
                });
            }

            return options.fnFind(function (option) {
                return option === resolved
                    || option.grouping == resolved.grouping
                    || option.name === resolved.name;
            });
        }

        function setFullGroupingOptions(mergedOptions) {
            $ctrl.fullGroupingOptions.length = 0;

            mergedOptions
                .filter(x => reportHelper.filterGroupingOptionsByAllowedEntityTypes(x, [$ctrl.control.grouping]))
                .forEach(function(option) {
                    if (!option.fullOptions) {
                        option.fullOptions = reportHelper.getExpandedOptions(option.options);
                    }
                    if (!option.fullOptionLists) {
                        option.fullOptionLists = reportHelper.getExpandedOptions(option.optionLists);
                    }
                    $ctrl.fullGroupingOptions.push(option);
                });
        }

        function refreshGroupingSelection() {
            if (!$ctrl.control) {
                return;
            }

            const mergedOptions = reportHelper.getAllGroupingOptions();
            setFullGroupingOptions(mergedOptions);

            const resolved = reportHelper.resolveChartGroupingOption($ctrl.control, mergedOptions);
            internal.grouping = findResolvedOptionInList($ctrl.fullGroupingOptions, resolved)
                || findGroupingOptionInList($ctrl.fullGroupingOptions, $ctrl.control.grouping)
                || findGroupingOptionInList($ctrl.fullGroupingOptions, $ctrl.control.grouping1)
                || findGroupingOptionInList($ctrl.fullGroupingOptions, $ctrl.control.name);
        }

        Object.defineProperties($ctrl, {
            grouping: {
                get: function() {
                    return internal.grouping;
                },
                set: function(newValue){
                    internal.grouping = newValue;
                    reportHelper.applyAdHocChartGroupingSelection($ctrl.control, newValue);
                    setFullGroupingOptions(reportHelper.getAllGroupingOptions());
                    groupingValidation();
                },
                enumerable: true
            },
        });

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            reportHelper.getGroupingOptions().then(refreshGroupingSelection);

            $scope.$on(reportHelper.GetDefaultOptionEvent, function (event, data) {
                if (!$ctrl.control.contextChange) {
                    $ctrl.control.contextChange = {};
                }
                event.stopPropagation();
                $ctrl.control.$emit("rb-event:get-default-option", data);
            });

            $scope.$on('rb-event:ad-hoc-settings-changed', refreshGroupingSelection);
        };

        $ctrl.$onChanges = function () {
            if ($ctrl.control) {
                refreshGroupingSelection();
            }
        };

        //INITIALIZE
        $ctrl.optionsHelper = optionsHelper;
        const commonOptions = Object.select(rcChartHelper, 'frequencyOptions', 'basedOnOptions');
        angular.extend($ctrl, commonOptions);

        $ctrl.fullGroupingOptions = [];

        $ctrl.groupingMatches = function (name) {
            return optionsHelper.groupingMatchesName($ctrl.control, name);
        };
    }
});

'use strict';

app.component('rbContentHeader', {
    templateUrl: 'reporting/envision/components/rbContentHeader.html',
    transclude: true,
    bindings: {
        header: '<',
        report: '<',
        excludeControls: '<',
        excludeCategories: '<',
        loaded: '<',
    },
    controller: function RbContentHeaderController(RB_TOOLBAR, reportHelper, $window, $timeout, $scope, reportControlsSetupService, RB_COMPONENT_NAMES, $templateCache, $oasRights, dbeoService) {
        const ctrl = this;

        app.constant('dbeoService', dbeoService);
        ctrl.menuOpen = false;

        ctrl.removeWhitespace = function (itemName) {
            const whitespace = /\s/g;
            return itemName.replace(whitespace, '');
        };

        ctrl.closeMenu = function () {
            ctrl.toolBar.forEach(function (category) {
                category.openDropDown = false;
            });
        };

        ctrl.addFragment = function (originalFragment, targetList, targetIndex) {
            //clone the fragment so that any changes that are made to it don't impact the stored fragment schemas in the sidebar.
            const fragment = angular.copy(originalFragment);

            ctrl.closeMenu();

            if (targetList === 'body' && targetIndex === undefined) {
                return reportHelper.prepareFragmentForAdd(fragment)
                    .then(function (fixedFragment) {
                        //just add it to the end of the report

                        let body = ctrl.report.schema;
                        if (ctrl.report.schema.body) {
                            body = ctrl.report.schema.body;
                        } else {
                            //For subreport create relist for the editor body
                            ctrl.report.schema.$type = 'rcList';
                            body = ctrl.report.schema;
                        }

                        body.addControl(fixedFragment.schema);

                        // By returning true from dnd-drop we signal we already handled the item.
                        return true;
                    });
            }

            if (targetList.dragoverCallback(fragment.schema.$type.toLowerCase())) {
                return reportHelper.prepareFragmentForAdd(fragment)
                    .then(function (fixedFragment) {
                        // Copy the item from source to target (wrapping if needed)
                        targetList.control.controls[targetIndex] = targetList.wrapControlIfNeeded(fixedFragment.schema);

                        //need to reflow the charts after adding
                        targetList.reflow();

                        //need to initialize column resizer
                        targetList.initColumnResizer();

                        // By returning true from dnd-drop we signal we already handled the item.
                        return true;
                    });
            }

            //cancel the drop event
            return false;
        };

        function initToolbar() {
            reportControlsSetupService.addControls(RB_TOOLBAR, RB_COMPONENT_NAMES, $templateCache);

            ctrl.toolBar = [
                {name: 'Tables', icon: 'fa-table'},
                {name: 'Charts', icon: 'fa-bar-chart'},
                {name: 'Text Boxes', icon: 'fa-text-width'},
                {name: 'Layout', icon: 'fa-list-alt'},
                {name: 'Media', icon: 'fa-photo'},
            ];

            if ($oasRights.canRead('RB3INTEGRATIONSMENU')) {
                ctrl.toolBar.push({name: 'Integrations', icon: 'fa-cubes'});
            }

            ctrl.toolBar.push({name: 'Data Sources', icon: 'fa-database'});

            if (ctrl.excludeCategories) {
                ctrl.toolBar = ctrl.toolBar.filter(i => !ctrl.excludeCategories.includes(i.name));
            }

            dbeoService.get('69SimpleTableEditor').then((useSimpleTableEditor)=> {
               ctrl.toolBar.forEach(function (category) {
                    category.items = angular.copy(RB_TOOLBAR[category.name]);

                    if (ctrl.excludeControls) {
                        category.items = category.items.filter(i => !ctrl.excludeControls.includes(i.name));
                    }

                    category.items.forEach(function (item) {
                        if (reportHelper.controlNeedsWrap(item.schema.$type)) {
                            item.schema = {
                                $type: 'rcWrapper',
                                titleControl: {$type: 'rcStringResolverCompact', isHtml: true, value: item.name},
                                controls: [item.schema],
                            };
                        }
                    });
                });

               const tableCategoryIndex = ctrl.toolBar.findIndex(category => category.name === 'Tables');
               const hasAdvancedEditor = $oasRights.canRead('REPORTBUILDERADVANCEDEDITOR');
               if(!useSimpleTableEditor && tableCategoryIndex >= 0){
                   const controlIndex = ctrl.toolBar[tableCategoryIndex].items.findIndex(item => item.schema.controls[0]?.$type === 'rcSimpleTableEditor');
                   ctrl.toolBar[tableCategoryIndex].items.splice(controlIndex,1);
               }
               else if(useSimpleTableEditor && tableCategoryIndex >= 0) {
                   if(!hasAdvancedEditor) {
                       const controlIndex = ctrl.toolBar[tableCategoryIndex].items.findIndex(item => item.schema.controls[0]?.$type === 'rcGroupingTable');
                       ctrl.toolBar[tableCategoryIndex].items.splice(controlIndex, 1);
                   }
               }
            });
        }

        ctrl.$onInit = function () {
            initToolbar();

            $timeout(() => {
                $window.dispatchEvent(new Event('resize'));
            });
        };

        $scope.$on(reportHelper.MenuCloseEvent, ctrl.closeMenu);
    },
});

app.constant('RB_TOOLBAR', {});

app.constant('RB_COMPONENT_NAMES', {});

app.run(function ($templateCache, RB_TOOLBAR, RB_COMPONENT_NAMES, dbeoService) {
    dbeoService.get('69SimpleTableEditor').then((useSimpleTableEditor)=> {
        const rcComponents = app._invokeQueue.filter(item => item[1] === 'component' && item[2][0].startsWith('rc'));
        rcComponents.forEach(item => {
            const componentName = item[2][0];

            if (!useSimpleTableEditor && componentName === 'rcSimpleTableEditor') {
                return;
            }

            $templateCache.put(componentName, '<{1} control="{2}"></{1}>'.assign(componentName.dasherize(), componentName.endsWith('Editor') ? '$ctrl.control' : 'control'));

            let orionData = item[2][1].OAS_DATA;
            if (!orionData) {
                return;
            }


            if (!angular.isArray(orionData)) {
                orionData = [orionData];
            }

            RB_COMPONENT_NAMES[componentName] = orionData[0].name;

            orionData.forEach(function (item) {
                if (item.noEditorRequired) {
                    $templateCache.put(componentName + 'Editor', '<rc-no-editor-required title="' + item.name + '"></rc-no-editor-required>');
                }

                if (item.category) {
                    item.requiredOptions = [];

                    if (RB_TOOLBAR[item.category]) {
                        RB_TOOLBAR[item.category].push(item);
                    } else {
                        RB_TOOLBAR[item.category] = [item];
                    }
                }
            });

            Object.keys(RB_TOOLBAR, function (category) {
                RB_TOOLBAR[category] = RB_TOOLBAR[category].sortBy('name');
            });

        });
    });


});
'use strict';

app.component('rbAdditionalOptions', {
    templateUrl: 'reporting/envision/components/rbAdditionalOptions.html',
    bindings: {
        control: '<',
        isColumnGroupingTable: '<'
    },
    controller: function ($scope, reportHelper, rcChartHelper, $route, $settings) {
        const $ctrl = this;
        const internal = {};
        $ctrl.useDefault = $route && $route.current && $route.current.controller === "SubReportEditorCtrl" ? "Use Default ( From Report)" : "Use Default ";

        //INITIALIZE
        const commonOptions = Object.select(rcChartHelper, 'frequencyOptions', 'basedOnOptions');
        angular.extend($ctrl, commonOptions);

        // Register the refresh callback
        $settings.setSetting('rpt_addl_options_refresh_fn', function () {
            if (typeof $ctrl.$onChanges === 'function') {
                $ctrl.$onChanges();
            }
        });

        $ctrl.fullGroupingOptions = [];
        reportHelper.getGroupingOptions().then(loadFullGroupingOptions);

        $scope.$on('rb-event:ad-hoc-settings-changed', function () {
            $ctrl.fullGroupingOptions.length = 0;
            reportHelper.getGroupingOptions().then(loadFullGroupingOptions);
        });

        function groupingValidation() {
            if (reportHelper.groupingMatchesName($ctrl.control, 'Time')) {
                $ctrl.control.contextChange = {
                    dateRangeId: null,
                    returnStyle: {
                        frequency: 'Annually',
                        basedOn: 'Calendar',
                        breakBehavior: 'AllowPartialPeriods',
                        cumulative: false,
                        context: 'Self',
                    }
                };
            }
        }

        function findGroupingOption(saved) {
            if (saved == null || saved === '') {
                return null;
            }

            return $ctrl.fullGroupingOptions.fnFind(function (option) {
                return option.grouping == saved || option.name === saved;
            });
        }

        function resolvePrimaryGrouping() {
            const fields = $ctrl.control.$type === 'rcGroupingActivityDonut'
                ? { grouping: 'grouping1', groupingLabel: 'groupingLabel1', groupingOption: 'groupingOption1' }
                : undefined;

            const resolved = reportHelper.resolveChartGroupingOption($ctrl.control, $ctrl.fullGroupingOptions, fields);
            if (resolved) {
                return angular.copy(resolved);
            }

            let grouping = $ctrl.control.grouping;
            if (!grouping && fields) {
                grouping = $ctrl.control[fields.grouping];
            }
            if (!grouping) {
                grouping = $ctrl.control.grouping1 ? $ctrl.control.grouping1 : $ctrl.control.name;
            }

            return angular.copy(findGroupingOption(grouping));
        }

        function mergeGroupingAdditionalOptions(grouping) {
            if (!grouping) {
                return { additionalOptions: [] };
            }

            if (!grouping.additionalOptions) {
                grouping.additionalOptions = [];
            }

            if ($ctrl.control.grouping2) {
                const groupOption2 = findGroupingOption($ctrl.control.grouping2);
                if (groupOption2 && groupOption2.additionalOptions) {
                    angular.extend(grouping.additionalOptions, grouping.additionalOptions, groupOption2.additionalOptions);
                }
            }

            return grouping;
        }

        function invalidateGroupingCache() {
            internal.grouping = null;
            internal.groupingControlKey = null;
        }

        function loadFullGroupingOptions(options) {
            if ($ctrl.fullGroupingOptions.length > 0) {
                return;
            }

            options.forEach(function (option) {
                option.fullOptions = reportHelper.getExpandedOptions(option.options);
                option.fullOptionLists = reportHelper.getExpandedOptions(option.optionLists);
                $ctrl.fullGroupingOptions.push(option);
            });
            invalidateGroupingCache();
        }

        Object.defineProperties($ctrl, {
            grouping: {
                get: function () {
                    if (!$ctrl.control) {
                        return { additionalOptions: [] };
                    }

                    const controlKey = [
                        $ctrl.control.grouping,
                        $ctrl.control.grouping1,
                        $ctrl.control.name,
                        $ctrl.control.grouping2
                    ].join('|');

                    if (!internal.grouping || internal.groupingControlKey !== controlKey) {
                        internal.grouping = mergeGroupingAdditionalOptions(resolvePrimaryGrouping());
                        internal.groupingControlKey = controlKey;
                    }

                    return internal.grouping || { additionalOptions: [] };
                },
                set: function (newValue) {
                    internal.grouping = newValue;
                    $ctrl.control.grouping = internal.grouping.name;
                    groupingValidation();
                },
                enumerable: true
            },
        });

        function defineSMASettings() {
            if($ctrl.control.smaSettingString === undefined) {
                Object.defineProperties($ctrl.control, {
                    smaSettingString: {
                        get: function () {
                            if (!$ctrl.control) {
                                return;
                            }
                            if ($ctrl.control.useSmaSetting === undefined || $ctrl.control.useSmaSetting === null) {
                                return 'default';
                            }
                            return $ctrl.control.useSmaSetting.toString();
                        },
                        set: function (newValue) {
                            if (newValue === 'default') {
                                $ctrl.control.useSmaSetting = null;
                            } else {
                                $ctrl.control.useSmaSetting = (newValue === 'true');
                            }
                        }
                    },
                });
            }
        }

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            defineSMASettings();
        };

        $ctrl.$onChanges = function () {
            if (!$ctrl.control) {
                return;
            }

            invalidateGroupingCache();
            defineSMASettings();
        };

        $scope.$watchGroup(['$ctrl.control.value','$ctrl.control.grouping'], function (newValue, oldValue) {
            // Graph or table grouping
            if (reportHelper.groupingMatchesName($ctrl.control, 'Self') || $ctrl.control.name === 'Self') {
                $ctrl.control.limitMethod.limitMethod = 'None';
            }
        });
    }
});
'use strict';

app.component('rbGroupOrderBy', {
    templateUrl: 'reporting/envision/components/rbGroupOrderBy.html',
    bindings: {
        orderBy: '<',
        onUpdate: '&',
        label: '<',
        disabled: '<',
    },
    controller: function (resolveHelper, $route, $timeout, optionsHelper) {
        var $ctrl = this;

        function getResolveOptions() {
            return resolveHelper.getResolveOptions($route.current.$$route.controller);
        }

        $ctrl.optionsHelper = optionsHelper;
        $ctrl.addOption = function() {
            let orderBy = { order: 'Ascending', path: $ctrl.selectedOrderBy.path, label: $ctrl.selectedOrderBy.label };
            if ($ctrl.selectedOrderBy.activityOptionId) {
                optionsHelper.updateIdAndGuid('activity', orderBy, $ctrl.selectedOrderBy.activityOptionId, $ctrl.selectedOrderBy.activityOption.globalOptionGuid);
            }

            if ($ctrl.selectedOrderBy?.calculationOptionId) {
                optionsHelper.updateIdAndGuid('calculation', orderBy, $ctrl.selectedOrderBy?.calculationOptionId, $ctrl.selectedOrderBy?.calculationOption?.globalOptionGuid);
            }

            if ($ctrl.selectedOrderBy.performanceOptionId) {
                optionsHelper.updateIdAndGuid('performance', orderBy, $ctrl.selectedOrderBy.performanceOptionId, $ctrl.selectedOrderBy.performanceOption.globalOptionGuid);
            }

            if ($ctrl.selectedOrderBy.dateRangeId) {
                optionsHelper.updateIdAndGuid('date-range', orderBy, $ctrl.selectedOrderBy.dateRangeId, $ctrl.selectedOrderBy.dateRange.globalOptionGuid);
            }

            if($ctrl.selectedOrderBy.reportCategoryId) {
                orderBy.reportCategoryId = $ctrl.selectedOrderBy.reportCategoryId;
            }

            if($ctrl.selectedOrderBy.options) {
                orderBy.options = $ctrl.selectedOrderBy.options;
            }

            $ctrl.orderBy.add(orderBy);
            $ctrl.selectedOrderBy = null;
            $ctrl.onUpdate({chgOrderBy: $ctrl.orderBy});
        };

        $ctrl.removeOption = function(option){
            $ctrl.orderBy.remove(option);
            $ctrl.onUpdate({chgOrderBy: $ctrl.orderBy});
        };

        $ctrl.toggleOrder = function(option){
            if(option.order === 'Ascending') {
                option.order = 'Descending';
            } else {
                option.order = 'Ascending';
            }
            $ctrl.onUpdate({chgOrderBy: $ctrl.orderBy});
        };

        function init() {
            if (!$ctrl.orderBy) {
                $ctrl.orderBy = [];
            }

            if ($ctrl.orderBy.length > 0 && !$ctrl.orderBy[0].contextChange) {
                $ctrl.orderBy[0].contextChange = {};
            }

            if (!resolveHelper.loaded) {
                $timeout(init, 100);//need to wait on resolveHelper being done loading
                return;
            }

            $ctrl.resolveOptions = getResolveOptions();

            $ctrl.orderBy.each(function(o) {
                let option = resolveHelper.findResolveOption(o);

                if (!option) {
                    return;
                }

                if(!o.label) {
                    o.label = option.label;
                }

                o.options = option.options;
            });
        };

        //LIFECYCLE HOOKS
        $ctrl.$onInit = init;

        $ctrl.$onChanges = $ctrl.$onInit;

        //INITIALIZE
        $ctrl.resolveOptions = [];

    }
});
'use strict';

app.component('rbLimit', {
    templateUrl: 'reporting/envision/components/rbLimit.html',
    bindings: {
        limit: '<',
        onUpdate: '&'
    },
    controller: function () {
        const $ctrl = this;

        $ctrl.update = function() {
            $ctrl.onUpdate({chgLimit: $ctrl.limit});
        };
    }
});
'use strict';

app.component('rbThreshold', {
    templateUrl: 'reporting/envision/components/rbThreshold.html',
    bindings: {
        threshold: '<',
        onUpdate: '&'
    },
    controller: function (rcChartHelper) {
        const $ctrl = this;

        Object.defineProperty($ctrl, 'thresholdPercent', {
            get: function() { return Math.round($ctrl.threshold * 100); },
            set: function(value) { $ctrl.threshold = parseFloat(value / 100).toFixed(2); }
        });

        $ctrl.update = function() {
            $ctrl.onUpdate({chgThreshold: $ctrl.threshold});
        };

        var commonOptions = Object.select(rcChartHelper, 'dataSourceOptions');
        angular.extend($ctrl, commonOptions);
    }
});
'use strict';

app.component('rbLimitMethod', {
    templateUrl: 'reporting/envision/components/rbLimitMethod.html',
    bindings: {
        limitMethod: '<',
        onUpdate: '&'
    },
    controller: function (rcChartHelper, resolveHelper, $timeout, $route, optionsHelper) {
        const $ctrl = this;

        var commonOptions = Object.select(rcChartHelper, 'limitOptions');
        var contextItems = ['DateRange', 'Activity', 'Performance', 'Trading'];

        angular.extend($ctrl, commonOptions);
        $ctrl.resolveOptions = [];

        $ctrl.getOptions = function (name) {
            return $ctrl.resolveOptions.filter(function (ro) {
                if (angular.isString(name) && name.length > 0 && !ro.label.has(new RegExp(name, 'i'))) return false;
                return ro.types.some('Set') && ro.allowedLocations.some('BarChart');
            });
        };

        $ctrl.loadSelectedDataSource = function (ds, filter) {
            $ctrl.selectedDataSource = ds;
            copyResolveOptionSettings(filter, ds, true);
        };

        function copyResolveOptionSettings(destination, sourceTag, setOptionProperties) {
            if (!sourceTag) {
                return;
            }

            var unused = contextItems;

            if (sourceTag.options) {
                // if there are options, use them to deteremine which items in contextItems are not being used
                unused = contextItems.exclude(function (c) {
                    return sourceTag.options.some(c);
                });
            }

            unused.forEach(function (u) {
                switch (u) {
                    case 'DateRange':
                        optionsHelper.removeIdAndGuidByType('date-range', $ctrl.limitMethod.dataSource);
                        break;
                    case 'Activity':
                        optionsHelper.removeIdAndGuidByType('activity', $ctrl.limitMethod.dataSource);
                        break;
                    case 'Performance':
                        optionsHelper.removeIdAndGuidByType('performance', $ctrl.limitMethod.dataSource);
                        break;
                    case 'Trading':
                        optionsHelper.removeIdAndGuidByType('trading', $ctrl.limitMethod.dataSource);
                        break;
                }
            });

            destination.label = sourceTag.label;
            destination.path = sourceTag.path;
            destination.$options = sourceTag.$options;

            if (setOptionProperties) {
                destination.$options.forEach(function (reportOption) {
                    optionsHelper.updateIdAndGuid(reportOption.optionType, destination, sourceTag[reportOption.propertyName], sourceTag[reportOption.guidName]);
                });
            }
        }

        function defineDataSource() {
            if (!$ctrl.limitMethod.dataSource) {
                $ctrl.limitMethod.dataSource = { path: 'Activity.Value' };
            }
            $ctrl.selectedDataSource = resolveHelper.findResolveOption($ctrl.limitMethod.dataSource);
            copyResolveOptionSettings($ctrl.limitMethod.dataSource, $ctrl.selectedDataSource, true);
        }

        function getResolveOptions() {
            return resolveHelper.getResolveOptions($route.current.$$route.controller);
        }

        $ctrl.updateActivitySelection = function (optionId, guid) {
            if ($ctrl.limitMethod.dataSource.activityOptionId !== optionId) {
                optionsHelper.updateIdAndGuid('activity', $ctrl.selectedDataSource, optionId, guid);
                copyResolveOptionSettings($ctrl.limitMethod.dataSource, $ctrl.selectedDataSource, true);
            }
        };

        function init() {
            if (!resolveHelper.loaded) {
                $timeout(init, 100);//need to wait on resolveHelper being done loading
                return;
            }

            $ctrl.resolveOptions = getResolveOptions();

            if ($ctrl.limitMethod === null) {
                $ctrl.limitMethod = {
                    limitMethod: 'None',
                    showOtherGroup: false,
                    otherGroupName: 'Other',
                    count: 1,
                    threshold: 0.01,
                    dataSource: null,
                    orderBy: null,
                    showOtherGroupLast: false
                };
            }
            defineDataSource();
        }

        $ctrl.toggleOtherGroupVisibility = function () {
            if ($ctrl.limitMethod.limitMethod === 'None') {
                $ctrl.limitMethod.showOtherGroup = false;
                $ctrl.limitMethod.showOtherGroupLast = false;
            } else {
                $ctrl.limitMethod.showOtherGroupLast = $ctrl.limitMethod.showOtherGroup ? $ctrl.limitMethod.showOtherGroupLast : false;
            }
        } 

        $ctrl.$onInit = init;

        $ctrl.$onChanges = function (changes) {
            if (!angular.equals(changes.limitMethod.currentValue, changes.limitMethod.previousValue)) {
                $ctrl.onUpdate({ chgLimitMethod: $ctrl.limitMethod });

                let method = $ctrl.limitMethod ? $ctrl.limitMethod.limitMethod : '';

                if (method === 'Count' || method === 'None') {
                    $ctrl.limitMethod.threshold = 0.01;
                    $ctrl.limitMethod.dataSource = null;
                    $ctrl.selectedDataSource = null;
                }
                if (method === 'Threshold' || method === 'None') {
                    $ctrl.limitMethod.count = 1;
                    $ctrl.limitMethod.orderBy = null;
                }

                if (method === 'None') {
                    $ctrl.limitMethod.showOtherGroup = false;
                    $ctrl.limitMethod.showOtherGroupLast = false;
                    $ctrl.limitMethod.otherGroupName = 'Other';
                }
                if (!$ctrl.limitMethod.dataSource || !$ctrl.limitMethod.dataSource.$options) {
                    defineDataSource();
                }
            }
        };
    }
});
'use strict';

app.component('rbActionMenu', {
    template: `
    <div dropdown class="dropdown pull-right">
        <button class="btn btn-action" ng-disabled="!$ctrl.loaded" dropdown-toggle data-test-id="btnRB3Actions">
            Actions <i ng-class="{'fa fa-caret-down': !!$ctrl.loaded, 'fa fa-ban': !$ctrl.loaded}" aria-hidden="true"></i>
        </button>
        <ul class="dropdown-menu" ng-transclude></ul>
    </div>`,
    transclude: true,
    bindings: {
        loaded: '<',
    },
});

app.component('rbNavActionMenu', {
    template: `
    <ul class="nav pull-right">
        <li dropdown class="dropdown">
            <a dropdown-toggle ng-disabled="!$ctrl.loaded" class="dropdown-toggle" data-test-id="btnRB3Actions">
                Actions <i ng-class="{'fa fa-caret-down': !!$ctrl.loaded, 'fa fa-ban': !$ctrl.loaded}" aria-hidden="true"></i>
            </a>
            <ul class="dropdown-menu" ng-transclude></ul>
        </li>
    </ul>`,
    transclude: true,
    bindings: {
        loaded: '<',
    },
});
'use strict';

app.component('rbFilter', {
    templateUrl: ['$element', '$attrs', function ($element, $attrs) {
        let qualifier = '';

        if ($attrs.renderAs) {
            qualifier = "-" + $attrs.renderAs;
        }

        return "reporting/envision/components/rbFilter" + qualifier + ".html";
    }],
    bindings: {
        filter: '<',
        onUpdate: '&',
        disabled: '<'
    },
    controller: function (resolveHelper, rcChartHelper, $route, $attrs, $dialog, MathService, $timeout, optionsHelper, reportFiltersService) {
        const $ctrl = this;
        let promptOptionIndex = 0;

        $ctrl.optionsHelper = optionsHelper;

        $ctrl.setFilterType = (filter) => {
            const context = resolveHelper.findResolveOption(filter);
            if (context) {
                filter.selectedType = context.resultType;
            } else if (!filter.selectedType && filter.$type) {
                const temp = filter.$type.split('-');
                filter.selectedType = temp.shift();
                filter.selectedFilterType = temp.join('-');
            }

            if (!filter.selectedType || !filter.selectedFilterType) {
                return;
            }

            filter.$type = filter.selectedType + "-" + filter.selectedFilterType;
            $ctrl.updateFilterProperties(filter);


            filter.selFilterProp = reportFiltersService.getDefaultFilterProperty(filter, $attrs.renderAs === 'wizard');
        };

        $ctrl.availableFilters = function (path, calculationOptionId, activityOptionId) {
            if (!path) {
                return;
            }

            const search = {path: path,
                calculationOptionId: calculationOptionId,
                activityOptionId: activityOptionId
            };

            const context = resolveHelper.findResolveOption(search);
            if (!context) {
                return [];
            }
            if (!context.filterType) {
                context.filterType = ((context.calculation ? context.calculation.resultType : null) || context.resultType).toLocaleLowerCase();
            }
            const availableFilterOptions = $ctrl.filterOptions.filter(function (type) {
                return type.contexts.some(context.filterType);
            });
            return availableFilterOptions;
        };

        $ctrl.updateFilterProperties = reportFiltersService.updateFilterProperties;

        $ctrl.displayNeedle = function (filter, needle, stripTags) {
            let display;
            if (needle === null) {
                if (stripTags) {
                    display = 'There is no value present';
                } else {
                    if (filter.selectedType === "string") {
                        display = '<i>null</i>';
                    } else {
                        display = '<i>N/A</i>';
                    }
                }
            } else {
                if (filter.selectedType === "percent") {
                    display = (needle).toString();
                } else if (filter.selectedType === "bool") {
                    display = (needle ? "True" : "False");
                } else {
                    display = needle.toString();
                }
            }

            if (stripTags) {
                return display.stripTags();
            }
            return display;
        };

        $ctrl.displayQueryNeedle = function (filter, haystack, needles, stripTags) {
            let needleList = haystack && haystack.length > 0 ? haystack : needles;
            needleList = needleList || [];

            let displayList = [];

            needleList.forEach(function (needle)
            {
                let display;
                if (needle === null) {
                    if (stripTags) {
                        display = 'There is no value present';
                    } else {
                        display = 'N/A';
                    }
                } else {
                    if (filter.selectedType === "percent") {
                        display = parseFloat((needle).toPrecision(6)).toString();
                    } else if (filter.selectedType === "bool") {
                        display = (needle ? "True" : "False");
                    }
                    else if (filter.selectedType === "date") {
                        display = formatDateDisplayValue(filter.selNeedle);
                    }
                    else {
                        display = needle.toString();
                    }
                }

                if (stripTags) {
                    displayList.add(display.stripTags());
                }
                displayList.add(display);
            });

            return displayList;
        };

        $ctrl.updateFilterDisplayValue = function (filter, haystacks, needles, stripTags) {
            let finalValue = "";
            if (filter.selectedFilterType !== 'range') {
                finalValue = filter.lowerPercent || filter.upperPercent || filter.lower || filter.upper || "";
                if (filter.selectedType === 'date' && finalValue && finalValue !== "") {
                    finalValue = formatDateDisplayValue(finalValue);
                }
            }
            else {
                let lowerValue;
                let upperValue;
                if (filter.selectedType === 'date') {
                    if (filter.lower) {
                        lowerValue = formatDateDisplayValue(filter.lower);
                    }

                    if (filter.upper) {
                        upperValue = formatDateDisplayValue(filter.upper);
                    }
                }
                else {
                    lowerValue = filter.lowerPercent || filter.lower;
                    upperValue = filter.upperPercent || filter.upper;
                }

                if (lowerValue) {
                    finalValue = lowerValue;
                }
                else {
                    finalValue = "N/A";
                }

                if (upperValue) {
                    finalValue += " and " + upperValue;
                }
                else {
                    finalValue += " and N/A";
                }
            }

            if (finalValue != "") {
                finalValue = finalValue.toString();
            }

            filter.filterDisplayValue = $ctrl.displayQueryNeedle(filter, haystacks, needles, stripTags).join(' or ') + finalValue;
            if (!filter.filterDisplayValue) {
                filter.filterDisplayValue = "N/A";
            }
        };

        $ctrl.updatePercent = function (filter, property) {
            if (filter.selectedType !== 'percent') {
                return;
            }

            // We just loaded a filter from the backend and want to display the Percent properly
            if(filter[property] && filter[property + 'Percent'] === undefined){
                $ctrl.formatPercentFromBackend(filter, property);
            } 

            if (filter.selectedType === 'range') {
                return;
            }

            // if were updating range we also need to format upper
            if(filter.upper && filter.upperPercent === undefined){
                $ctrl.formatPercentFromBackend(filter, 'upper');
            }
        };

        $ctrl. formatPercentFromBackend = function (filter, property) {
            if (isNaN(Number(filter[property])) && filter[property] !== undefined && !filter[property].endsWith('%')) {
                filter[property + 'Percent'] = 'N/A';
            } else {
                filter[property] = parseFloat(reportFiltersService.processDollarPercentSign(filter[property], true));
                filter[property + 'Percent'] = parseFloat((filter[property] * 100).toPrecision(6)).toString();
            }
        };

        $ctrl.checkValidValueForUpdate = function (filter, property) {
            if (filter.selectedType === 'percent') {
                if (isNaN(Number(filter[property]))) {
                    filter[property] = null;
                }
            }
        };

        $ctrl.addToHaystack = (filter) => {
            reportFiltersService.addToHaystack(filter, $ctrl.selFilterType, $attrs.renderAs, $ctrl.selFilter.selectedFilterType, promptOptionIndex);
        };

        $ctrl.addToNeedles = function (filter) {
            if (!filter.selNeedle && $ctrl.selFilterType !== 'prompt') {
                return;
            }

            const needlesToAdd = filter.selNeedle && angular.isString(filter.selNeedle) && filter.selNeedle.has(/ or /ig) ? filter.selNeedle.split(/ or /ig) : [filter.selNeedle];

            if (!$ctrl.selFilterType || $ctrl.selFilterType !== 'prompt') {
                needlesToAdd.forEach(function (needle) {
                    if (filter.needles.none(needle)) {
                        filter.needles.push(needle);
                    }
                });
            } else {
                const needle = {path: "Prompt.Value", promptOptionId: promptOptionIndex++};
                if (filter.needles.none(needle)) {
                    filter.needles.push(needle);
                }
            }

            filter.selNeedle = null;
        };

        $ctrl.removeFromHaystack = function (filter, needle) {
            filter.haystack.remove(needle);
        };

        $ctrl.removeFromNeedles = function (filter, needle) {
            filter.needles.remove(needle);
        };

        $ctrl.loadSelectedFilter = (ds, filter) => {
            copyResolveOptionSettings(filter, ds, true);

            if ($ctrl.selFilter.selectedFilterType) {
                $ctrl.setFilterType(filter);
            }
        };

        $ctrl.loadResolveFilter = function (filterToEdit) {
            const filterIndex = $ctrl.filter.filters.findIndex(filterToEdit);
            $dialog.dialog({
                templateUrl: 'reporting/envision/modals/resolve-option-filter.html',
                controller: 'ResolveOptionFilterCtrl',
                dialogClass: 'modal small resolve',
                resolve: {
                    args: function () {
                        return (filterToEdit ? {action: 'edit', filter: filterToEdit} : {action: 'add', filter: {context: 'Self'}});
                    },
                }
            }).open()
                .then(function (filter) {
                    if (filter) {
                        if (!$ctrl.filter) {
                            $ctrl.filter = {};
                        }
                        if (!$ctrl.filter.filters) {
                            $ctrl.filter.filters = [];
                        }

                        if (filterToEdit) {
                            $ctrl.filter.filters[filterIndex] = filter;
                        } else if (filter) {
                            $ctrl.filter.filters.add(filter);
                        }
                        $ctrl.onUpdate({chgFilter: $ctrl.filter});
                    }
                });
        };

        $ctrl.addFilterToQuery = function (filter) {
            if ($ctrl.selFilterType === 'filter' && ['equal', 'not-equal'].any($ctrl.selFilter.selectedFilterType)) {
                $ctrl.addToHaystack(filter);
            }

            $ctrl.addFilter();
        };

        $ctrl.addFilter = function () {
            let filters;
            if ($attrs.renderAs === 'wizard') {
                if ($ctrl.selFilterType === "prompt") {
                    filters = $ctrl.filterCollection.prompts;
                } else {
                    filters = $ctrl.filterCollection.filters;
                }
            } else {
                if (!$ctrl.filter) {
                    $ctrl.filter = {};
                }
                if (!$ctrl.filter.filters) {
                    $ctrl.filter.filters = [];
                }
                filters = $ctrl.filter;
            }

            let isNeedleBoolean = (typeof $ctrl.selFilter.selNeedle) === "boolean";
            if ($ctrl.selFilter.selNeedle || isNeedleBoolean || $ctrl.selFilterType === "prompt") {
                if (['equal', 'not-equal'].any($ctrl.selFilter.selectedFilterType)) {
                    $ctrl.addToHaystack($ctrl.selFilter);
                } else if (['contains', 'not-contains', 'ends-with', 'starts-with'].any($ctrl.selFilter.selectedFilterType)) {
                    $ctrl.addToNeedles($ctrl.selFilter);
                } else {
                    $ctrl.selFilter.selNeedle = null;
                }
            }

            const filter = angular.copy($ctrl.selFilter);
            if (angular.isString(filter.lower) && filter.lower.startsWith('$')) {
                filter.lower = filter.lower.substring(1);
            }
            if (angular.isString(filter.upper) && filter.upper.startsWith('$')) {
                filter.upper = filter.upper.substring(1);
            }

            if ($ctrl.selFilter.selectedType === 'percent') {
                if (filter.upper && angular.isString(filter.upper)) {
                    filter.upperPercent = "N/A";
                    filter.upper = null;
                }
                if (filter.lower && angular.isString(filter.lower)) {
                    filter.lowerPercent = "N/A";
                    filter.lower = null;
                }
            }

            if (!$ctrl.selFilterType || $ctrl.selFilterType !== 'prompt') {
                if (['date', 'datetime'].some($ctrl.selFilter.selectedType)) {
                    if (filter.upper) {
                        filter.upper = filter.upper.formatted($ctrl.selFilter.selectedType === 'datetime');
                    }
                    if (filter.lower) {
                        filter.lower = filter.lower.formatted($ctrl.selFilter.selectedType === 'datetime');
                    }
                }
            } else {
                const prop = filter.selFilterProp ? filter.selFilterProp : null; //filter.upper ? "upper" : (filter.lower ? "lower" : null);
                if (prop === "lower" && filter.selectedFilterType === "range") {
                    filter[prop] = {path: "Prompt.Value", promptOptionId: promptOptionIndex++};
                    filter.upper = {path: "Prompt.Value", promptOptionId: promptOptionIndex++};
                } else {
                    if ($attrs.renderAs === 'wizard') {
                        if (prop === "upper") {
                            filter[prop] = {path: "Prompt.Value", promptOptionId: promptOptionIndex++};
                        }
                    } else {
                        filter[prop] = {path: "Prompt.Value", promptOptionId: promptOptionIndex++};
                    }
                }
            }

            if ($attrs.renderAs === 'wizard') {
                const prop = filter.needles ? "needles" : (filter.haystack ? "haystack" : null);
                if (prop && filter[prop].length > 0) {
                    filter.selNeedle = filter[prop].length > 1 ? filter[prop].join(' or ') : (angular.isArray(filter[prop]) ? filter[prop][0] : filter[prop]);
                }
            }

            filters.filters.add(filter);
            $ctrl.selFilter = {context: 'Self'};
            $ctrl.onUpdate({chgFilter: $ctrl.filter});
        };

        const formatDateDisplayValue = function (value) {
            try {
                return new Date(value).format('{M}/{d}/{yyyy}');
            }
            catch (e) {
                return value;
            }
        };

        $ctrl.updateNeedles = function (filter) {
            const prop = filter.needles ? "needles" : (filter.haystack ? "haystack" : null);
            filter[prop] = [];
            let isNeedleBoolean = (typeof filter.selNeedle) === "boolean";

            if (filter.selNeedle === null ||
                filter.selNeedle === undefined ||
                filter.selNeedle === '' ||
                (filter.selNeedle.toUpperCase && filter.selNeedle.toUpperCase() === "N/A") ||
                (filter.selNeedle.toUpperCase && filter.selNeedle.toUpperCase() === "NULL") ||
                (filter.selNeedle.toUpperCase && filter.selNeedle.toUpperCase() === "BLANK")) {
                    //the value provided should be interpreted as null and added to the haystack
                filter[prop].push(null);
                filter.selNeedle = null;
            } else if (filter.selNeedle || isNeedleBoolean) {
                const needlesToAdd = filter.selNeedle && angular.isString(filter.selNeedle) && filter.selNeedle.has(/ or /ig) ? filter.selNeedle.split(/ or /ig) : [filter.selNeedle];
                const typesToHandleNA = ["decimal", "numeric", "currency", "percent"];

                needlesToAdd.forEach(function (needle) {
                    needle = !angular.isString(needle) ? needle : needle.replace(' or', '').replace(' o', '').trim();
                    if (typesToHandleNA.some(filter.selectedType)) {
                        needle = reportFiltersService.processDollarPercentSign(needle, filter.selectedType === 'percent');
                        filter.selNeedle = needle;
                    }
                    if (filter[prop].none(needle) && needle !== '') {
                        filter[prop].push(needle);
                    }
                });
            }
            $ctrl.updateFilterDisplayValue(filter, filter.haystack, filter.needles, false);
        };

        $ctrl.updateRange = function (filter) {
            filter.upper = reportFiltersService.processDollarPercentSign(filter.upper, filter.selectedType === 'percent');
            filter.lower = reportFiltersService.processDollarPercentSign(filter.lower, filter.selectedType === 'percent');
        };

        $ctrl.removeFilter = function (filter) {
            if ($attrs.renderAs === 'wizard') {
                if ($ctrl.filterCollection.prompts.filters.includes(filter)) {
                    $ctrl.filterCollection.prompts.filters.remove(filter);
                } else {
                    $ctrl.filterCollection.filters.filters.remove(filter);
                }
            } else {
                $ctrl.filter.filters.remove(filter);
            }

            $ctrl.onUpdate({chgFilter: $ctrl.filter});
        };

        $ctrl.disableAddFilter = function () {
            let hasValue = false;
            if ($ctrl.selFilter) {
                if (!$ctrl.selFilterType || $ctrl.selFilterType !== 'prompt') {
                    switch ($ctrl.selFilter.selectedFilterType) {
                        case "equal":
                        case "not-equal":
                            let isNeedleBoolean = (typeof $ctrl.selFilter.selNeedle) === "boolean";
                            hasValue = $ctrl.selFilter.selNeedle || isNeedleBoolean || ($ctrl.selFilter.haystack && $ctrl.selFilter.haystack.length > 0) || $attrs.renderAs === 'wizard';
                            break;
                        case "less-than":
                        case "less-than-equal":
                            hasValue = ($ctrl.selFilter.upper !== null && $ctrl.selFilter.upper !== undefined);
                            break;
                        case "greater-than":
                        case "greater-than-equal":
                            hasValue = ($ctrl.selFilter.lower !== null && $ctrl.selFilter.lower !== undefined);
                            break;
                        case "range":
                            hasValue = ($ctrl.selFilter.lower !== null && $ctrl.selFilter.lower !== undefined) || ($ctrl.selFilter.upper !== null && $ctrl.selFilter.upper !== undefined);
                            break;
                        case "contains":
                        case "not-contains":
                        case "ends-with":
                        case "starts-with":
                            hasValue = $ctrl.selFilter.selNeedle || ($ctrl.selFilter.needles && $ctrl.selFilter.needles.length > 0);
                            break;
                    }
                } else if ($ctrl.selFilter.selectedFilterType) {
                    hasValue = true;
                }
            }
            return !$ctrl.selFilter || !$ctrl.selFilter.label || !$ctrl.selFilter.selectedFilterType || !hasValue;
        };

        $ctrl.updateFilter = (eventFilter) => {
            // update either new selFilter or existing filter being edited with what's returned from report-filter-inputs
            $ctrl.selFilter = eventFilter;
            $ctrl.updatePercent(eventFilter, eventFilter.selFilterProp);
        };

        $ctrl.addToEvent = (filter) => {
            if(['contains', 'not-contains','ends-with', 'starts-with'].some(filter.selectedFilterType)){
                $ctrl.addToNeedles(filter);
            }
            else {
                $ctrl.addToHaystack(filter);
            }
        };

        $ctrl.cancelNewFilter = () => {
            $ctrl.selFilter = {context: 'Self'};
        };

        $ctrl.filterAvailableGroupingOptions = function(groupingOption) {
            return rcChartHelper.filterGroupingOptionsByAllowedEntityTypes(groupingOption) && (groupingOption.isAssetBased || (groupingOption.allowedEntityType.some(x => x !== 'AssetBased')));
        };

        function init() {
            if (!resolveHelper.loaded) {
                $timeout(init, 100);//need to wait on resolveHelper being done loading
                return;
            }

            $ctrl.resolveOptions = getResolveOptions();
            $ctrl.resolveOptions.each(function (option) {
                option.filterType = ((option.calculation ? option.calculation.resultType : null) || option.resultType).toLocaleLowerCase();
            });
            loadType();
        }

        function formatFilters() {
            if ($ctrl.filter.filters.length > 0) {
                $ctrl.filterCollection.prompts = $ctrl.filter.filters.find(function (f) {
                    return f.id && f.id.includes("prompt");
                });
                $ctrl.filterCollection.filters = $ctrl.filter.filters.find(function (f) {
                    return f.id && !f.id.includes("prompt");
                });
            }
            if (!$ctrl.filterCollection.filters) {
                const filters = {$type: "filter-collection", id: "filters", filters: [], method: "All"};
                $ctrl.filter.filters.add(filters);
                $ctrl.filterCollection.filters = filters;
                const oldFilters = angular.copy();
                if (oldFilters) {
                    filters.filters.add(oldFilters);
                    $ctrl.filter.filters.remove(function (f) {
                        return !f.id;
                    });
                }
            }
            if (!$ctrl.filterCollection.prompts) {
                const prompts = {$type: "filter-collection", id: "prompts", filters: [], method: "All"};
                $ctrl.filter.filters.add(prompts);
                $ctrl.filterCollection.prompts = prompts;
            }

            // Update any incorrectly set filter.methods
            if ($ctrl.filter.method === "Any") {
                $ctrl.filter.method = "All";
                $ctrl.filterCollection.filters.method = "Any";
            }
            updatePromptOption();
        }

        function updatePromptOption() {
            $ctrl.filterCollection.prompts.filters.forEach(filter => {
                let prop = "";
                if (filter.needles !== undefined && angular.isArray(filter.needles)) {
                    prop = "needles";
                } else if (filter.haystack !== undefined && angular.isArray(filter.haystack)) {
                    prop = "haystack";
                } else if (filter.lower !== undefined) {
                    prop = "lower";
                } else {
                    prop = "upper";
                }

                if (!Array.isArray(filter[prop]) || !filter[prop].length){
                    switch (prop) {
                        case "needles":
                        case "haystack":
                            filter[prop] = [{path: "Prompt.Value", promptOptionId: -1}];
                            break;
                        default:
                            filter[prop] = {path: "Prompt.Value", promptOptionId: -1};
                            break;
                    }
                }

                if (Array.isArray(filter[prop])) {
                    filter[prop].each(function (p) {
                        if (promptOptionIndex <= p.promptOptionId) {
                            promptOptionIndex = p.promptOptionId + 1;
                        }
                    });
                } else {
                    if (prop === "lower" && filter.selectedFilterType === "range") {
                        if (promptOptionIndex <= filter.lower.promptOptionId || promptOptionIndex <= filter.upper.promptOptionId) {
                            promptOptionIndex = ((filter.lower >= filter.upper) ? filter.lower.promptOptionId : filter.upper.promptOptionId) + 1;
                        }
                    } else {
                        if (promptOptionIndex <= filter[prop].promptOptionId) {
                            promptOptionIndex = filter[prop].promptOptionId + 1;
                        }
                    }
                }

                switch (prop) {
                    case "needles":
                    case "haystack":
                        if (filter[prop][0].promptOptionId === -1) {
                            filter[prop][0].promptOptionId = promptOptionIndex++;
                        }
                        break;
                    default:
                        if (filter[prop].promptOptionId === -1) {
                            filter[prop].promptOptionId = promptOptionIndex++;
                        }
                        break;
                }

            });

            $ctrl.onUpdate({chgFilter: $ctrl.filter});
        }

        function loadType() {
            function processFilters(filters) {
                //remove null filters if any
                filters = filters.filter(function (f) {
                    return f !== null && f.path;
                });

                filters.forEach(function (f) {
                    if (f.$type) {
                        const temp = f.$type.split('-');
                        const type = temp.shift();
                        f.selectedType = type;
                        f.selectedFilterType = temp.join('-');
                        
                        $ctrl.setFilterType(f);
                    }
                    if (f.selectedType === "datetime") {
                        if (f.haystack && f.haystack.length > 0) {
                            for (let i = 0; i < f.haystack.length; i++) {
                                f.haystack[i] = Date.create(f.haystack[i]).formatted(true);
                            }
                        }
                    }
                    // if (f.selectedType === "percent") {
                    //     if (f.upper || f.upper === 0) {
                    //         f.upperPercent = MathService.valueAsPercentage(f.upper);
                    //     }
                    //     if (f.lower || f.lower === 0) {
                    //         f.lowerPercent = MathService.valueAsPercentage(f.lower);
                    //     }
                    // }

                    if ($attrs.renderAs === 'wizard') {
                        const prop = f.needles ? "needles" : (f.haystack ? "haystack" : null);
                        if (prop && f[prop].length > 0) {
                            //Check to see if string array -- JMW 3/15/2021
                            if (angular.isArray(f[prop])) { //is it an array?
                                const isStringArray = f[prop].every(function (needle) {
                                    return angular.isString(needle);
                                });

                                if (isStringArray) { //string array
                                    f.selNeedle = f[prop].join(' or ');
                                } else { //regular array
                                    f.selNeedle = f[prop][0];
                                }
                            } else { //not an array
                                f.selNeedle = f[prop];
                            }
                            //f.selNeedle = f[prop].length > 1 ? f[prop].join(' or ') : (angular.isArray(f[prop]) ? f[prop][0] : f[prop]); -- JMW 3/15/2021 This is the old code
                        }
                    }

                    const context = resolveHelper.findResolveOption(f);
                    if (context) {
                        copyResolveOptionSettings(f, context, false);
                    }
                });
            }

            if (!$ctrl.filter) {
                $ctrl.filter = {filters: []};
            } else if (!$ctrl.filter.filters) {
                $ctrl.filter.filters = [];
            }


            if ($attrs.renderAs === "wizard") {
                formatFilters();
            }

            if ($ctrl.filterCollection.prompts && $ctrl.filterCollection.prompts.filters.length > 0) {
                processFilters($ctrl.filterCollection.prompts.filters);
            }

            if ($ctrl.filterCollection.filters && $ctrl.filterCollection.filters.filters.length > 0) {
                processFilters($ctrl.filterCollection.filters.filters);
            }

            if (!$ctrl.filterCollection.prompts && !$ctrl.filterCollection.filters) {
                processFilters($ctrl.filter.filters.filter(function (f) {
                    return !f.id || (!f.id.includes("prompt") && !f.id.includes("filter"));
                }));
            }
        }

        function copyResolveOptionSettings(destination, sourceTag, setOptionProperties) {
            destination.label = sourceTag.label;
            destination.path = sourceTag.path;
            destination.$options = sourceTag.$options;

            if (setOptionProperties) {
                destination.$options.forEach(function (reportOption) {
                    destination[reportOption.propertyName] = sourceTag[reportOption.propertyName];
                    if (reportOption.globalPropertyName !== null && sourceTag[reportOption.globalPropertyName]) {
                        $ctrl.optionsHelper.updateIdAndGuid(reportOption.optionType, destination, sourceTag[reportOption.propertyName], sourceTag[reportOption.globalPropertyName].globalOptionGuid);
                    }
                });
            }
        }

        function getResolveOptions() {
            return resolveHelper.getResolveOptions($route.current.$$route.controller);
        }

        //LIFECYCLE HOOKS
        $ctrl.$onInit = init;
        $ctrl.$onChanges = function (changes) {
            if (changes?.filter?.currentValue) {
                init();
            }
        };

        //INITIALIZE
        $ctrl.resolveOptions = [];
        $ctrl.selFilter = {context: 'Self'};
        $ctrl.wizardFilterType = [{type: "filter", display: "Filter"}, {type: "prompt", display: "Prompt"}];
        $ctrl.boolOptions = [
            {name: "True", value: true},
            {name: "False", value: false}
        ];
        $ctrl.filterOptions = [
            {type: "equal", name: "Equal To", contexts: ["currency", "decimal", "percent", "date", "datetime", "string", "numeric", "bool"]},
            {type: "not-equal", name: "Not Equal To", contexts: ["currency", "decimal", "percent", "date", "datetime", "string", "numeric", "bool"]},
            {type: "less-than", name: "Less Than", contexts: ["currency", "decimal", "percent", "date", "datetime", "numeric"]},
            {type: "less-than-equal", name: "Less Than Or Equal To", contexts: ["currency", "decimal", "percent", "date", "datetime", "numeric"]},
            {type: "greater-than", name: "Greater Than", contexts: ["currency", "decimal", "percent", "date", "datetime", "numeric"]},
            {type: "greater-than-equal", name: "Greater Than Or Equal To", contexts: ["currency", "decimal", "percent", "date", "datetime", "numeric"]},
            {type: "range", name: "Between", contexts: ["currency", "decimal", "percent", "date", "datetime", "numeric"]},
            {type: "contains", name: "Contains", contexts: ["string"]},
            {type: "not-contains", name: "Does Not Contain", contexts: ["string"]},
            {type: "ends-with", name: "Ends With", contexts: ["string"]},
            {type: "starts-with", name: "Starts With", contexts: ["string"]}
        ];
        $ctrl.filterCollection = {filters: null, prompts: null};
        $ctrl.allGroupingOptions = rcChartHelper.getAllGroupingOptions();
    }
});

'use strict';

app.directive('rcListItem', ['$compile', 'rcListHelper', function ($compile, rcListHelper) {
    return {
        restrict: 'A',
        scope: true,
        bindings: {
            control: '<'
        },
        templateUrl: 'reporting/envision/components/rcListItem.html',
        link: function (scope, element) {
            function renderVisible(view) {
                if (!view) {
                    view = document.body.querySelector('.report-builder-bg').getBoundingClientRect();
                }
                let pos = element[0].getBoundingClientRect();
                if (pos.bottom > 0 && pos.top < view.bottom) {
                    scope.$resume();
                } else {
                    if (scope.firstLoaded) {
                        scope.$suspend();
                    } else {
                        //first time loading needs to fully render and then suspend
                        scope.firstLoaded = true;
                        scope.$$postDigest(() => {
                            scope.$suspend();
                        });
                    }
                }
            }

            if (scope.control && scope.control.$type) {
                // The Angular SimpleTableEditorComponent is downgraded as 'orionSimpleTableEditor' to avoid
                // colliding with the legacy AngularJS 'rcSimpleTableEditor' component (multidir error after
                // upgrade to @angular/upgrade 17). For this $type we render the downgrade tag directly.
                var tagName = scope.control.$type === 'rcSimpleTableEditor'
                    ? 'orion-simple-table-editor'
                    : scope.control.$type.dasherize();
                var bindingName = scope.control.$type.endsWith('Editor') ? '$ctrl.control' : 'control';
                var controlItem = angular.element('<{1} control="{2}" [data]="{2}"></{1}>'.assign(tagName, bindingName));
                var clone = $compile(controlItem)(scope);
                element.append(clone);                

                const canConvert = function(control) {
                    if (control.$type === 'rcSimpleTableEditor') {
                        control.convertTitle = 'Advanced Table';
                    } else if (control.$type === 'rcGroupingTable') {
                        control.convertTitle = 'Simple Table';
                    }

                    return !control.isInSubReport && (control.$type === 'rcSimpleTableEditor' || control.$type === 'rcGroupingTable');
                };

                scope.control.canConvert = canConvert(scope.control);

                if (rcListHelper.keepControlAlive(scope.control)) {
                    return;
                }

                scope.$on('rb-event:render-visible', function (event, view) {
                    renderVisible(view);
                });

                scope.$$postDigest(() => {
                    renderVisible();
                });
            }
        },
    };
}]);

'use strict';

app.component('rbZoomSelector', {
    template: `   
    <div style="position: absolute; bottom: 28px; left: 0; z-index: 100;"> 
        <select ng-model="$ctrl.zoom.selected" ng-options="option.display for option in ::$ctrl.zoom.options" ng-change="$ctrl.handleChange()" style="position: fixed; width: 75px;"></select>
    </div>`,
    bindings: {
        onChange: '&',
    },
    controller: function RbZoomSelectorController() {
        const ctrl = this;

        ctrl.zoom = { options: [] };
        for (let x = 2; x > 0; x -= 0.25) {
            ctrl.zoom.options.push({ value: x, display: x * 100 + '%' });
        }
        ctrl.zoom.selected = ctrl.zoom.options.find({ value: 1 });

        ctrl.handleChange = function() {
            ctrl.onChange()(ctrl.zoom.selected.value);
        };
    },
});
'use strict';

app.component('rbEditorStyles', {
    templateUrl: 'reporting/envision/components/rbEditorStyles.html',
});
const rcResolveComponent = {
    bindings: {
        column: '<'
    },
    template: `
        <div rc-resolve rc-resolve-simple="true" rc-resolve-activate="$ctrl.column.isResolveActive" rc-query-builder="true"
            ng-show="$ctrl.column.isResolveActive" ng-model="$ctrl.column.control.value" dropdown-toggle
            dropdown-context-menu="true" track-by-toggle="true">
        </div>
    `,
    controller: function () {
    }
  };
  
  app.component('rcResolveComponent', rcResolveComponent);
'use strict';

app.component('previewWizardForm', {
    template: `<ng-include src="'reporting/envision/upgrades/preview-wizard-form.html'"></ng-include>`,
    binding: {
        current: '='
    },
    controller: function (ReportPreviewApiService) {
        var $ctrl = this;

        $ctrl.setInceptionDate = function () {
            const entity = $ctrl.current.entityOptions;
            if (entity?.selectedEntities?.length === 1) {
                ReportPreviewApiService.getInceptionDate(entity.entity, entity.selectedEntities[0].entityId).then(resp => {
                    $ctrl.current.dateOptions.start.date = resp.inceptionDate ? Date.create(resp.inceptionDate).format("{M}/{d}/{yyyy}") : null;
                });
            } else {
                $ctrl.current.dateOptions.start.date = null;
            }
        };
    }
});

'use strict';

app.service('fragmentHelper', function fragmentHelper($http, $q, $dialog, $timeout, reportHelper, schemaHelper, optionsHelper) {
    const self = this;
    const internal = {
        promise: null,
        cache: {},
        list: [],
        showFragmentActions: true,
    };

    function GetSubReportCount(fragment, ignoreExceptions = false) {
        return $http.get('/Reporting/Envision/Fragments/FragmentReportCount/' + fragment.id, {trackerMsg: 'Loading get fragment report count', ignoreExceptions})
            .then(function (response) {
                return response.data;
            });
    }

    function findRequiredOptions(schema) {
        const matches = {};

        optionsHelper.findMatches(schema, matches);

        if (matches['calculationOptionId']) {
            //need to include any options that these calculations use
            reportHelper.getOptions('calculationOptionId', true).filter(function (o) {
                return matches['calculationOptionId'].any(o.optionId);
            }).forEach(function (o) {
                optionsHelper.findMatches(o.calculation, matches);
            });
        }

        //clean up the matches
        for (const property in matches) {
            if (matches.hasOwnProperty(property)) {
                matches[property] = matches[property].unique();
            }
        }

        return reportHelper.getOptionsMatch(matches);
    }

    function addToList(fragment, reSort) {
        internal.cache[fragment.id] = fragment;

        const existingGroup = internal.list.find({name: fragment.portfolio.category});

        if (existingGroup) {
            existingGroup.items.push(fragment);
            if (reSort) {
                existingGroup.items = existingGroup.items.sortBy('name');
            }
        } else {
            internal.list.push({name: fragment.portfolio.category, items: [fragment]});
            if (reSort) {
                const groups = internal.list.sortBy('name');
                internal.list.length = 0;
                internal.list.add(groups);
            }
        }
    }

    function updateInList(fragment) {
        var item = internal.cache[fragment.id];
        if(item) {
            item.schema = fragment.schema;
            item.requiredOptions = fragment.requiredOptions;
            item.additionalOptions = fragment.additionalOptions;
            item.referencedOptions = fragment.referencedOptions;
            schemaHelper.cleanupFragmentSchema(item);
        }
        return item;
    }

    function removeFromList(fragment) {
        delete internal.cache[fragment.id];

        const group = internal.list.find({name: fragment.portfolio.category});
        if (!group) {
            return;
        }
        group.items.remove({id: fragment.id});

        if (!group.items.length) {
            internal.list.remove({name: group.name});
        }
    }

    function launchFragmentEditor(verboseFragment, isCloneMode) {
        return $dialog.dialog({
            templateUrl: 'reporting/envision/modals/report-fragment.html',
            controller: 'ReportFragmentCtrl',
            mode: isCloneMode ? 'clone' : 'edit',
            categories: internal.list.map('name'),
            fragment: verboseFragment,
        })
            .open()
            .then(function (result) {
                if (!result) return;

                const args = isCloneMode ? {
                    method: 'post',
                    id: '',
                    trackerMsg: 'Cloning ' + result.name,
                } : {
                    method: 'put',
                    id: result.id,
                    trackerMsg: 'Updating ' + result.name,
                };

                return $http[args.method]('/Reporting/Envision/Fragments/Verbose/' + args.id, result, {trackerMsg: args.trackerMsg})
                    .then(function (response) {
                        if (!isCloneMode) {
                            removeFromList(verboseFragment);
                        }
                        var fragment = response.data;
                        schemaHelper.cleanupFragmentSchema(fragment);
                        addToList(fragment, true);
                    });
            });
    }

    //PUBLIC API
    self.load = function () {
        if (internal.promise === null) {
            internal.promise = $http.get('/Reporting/Envision/Fragments/Verbose', {trackerMsg: 'Loading sub-reports'})
                .then(function (response) {
                    const data = response.data.sortBy('name');

                    internal.list = [];
                    data.forEach(function (fragment) {
                        addToList(fragment);
                    });

                    internal.list = internal.list.sortBy('name');
                    internal.list[0].isOpen = true;

                    return internal.list;
                });
        }
        return internal.promise;
    };

    self.loadDetails = function (fragmentId) {
        if(internal.cache[fragmentId].schema) {
            return $q.when(internal.cache[fragmentId]);
        } else {
            return $http.get(`/Reporting/Envision/Fragments/Verbose/${fragmentId}?expand=schema&expand=requiredOptions&expand=additionalOptions&expand=referencedOptions`, {trackerMsg: 'Loading sub-report details'})
                .then(function (response) {
                    const fragment = response.data;
                    return updateInList(fragment);
                });
        }
    };

    self.getCached = function (fragmentId) {
        return self.load().then(function (fragments) {
            return internal.cache[fragmentId];
        });
    };

    self.create = function (control) {
        return $http.get('/Reporting/Envision/Fragments/Verbose/New', {trackerMsg: 'Loading element template'})
            .then(function (response) {
                const verboseFragment = response.data;
                verboseFragment.portfolio.name = schemaHelper.getSubReportName(control);
                verboseFragment.portfolio.category = 'Custom';
                verboseFragment.schema = reportHelper.prepareForSave(angular.copy(control.schema || control));
                verboseFragment.portfolio.isDynamic = true;

                findRequiredOptions(verboseFragment.schema)
                    .then(function (options) {
                        verboseFragment.requiredOptions = options;

                        $http.post('/Reporting/Envision/Fragments/Verbose', verboseFragment, {trackerMsg: 'Creating ' + verboseFragment.portfolio.name})
                            .then(function (response) {
                                const data = response.data;
                                schemaHelper.cleanupFragmentSchema(data);
                                addToList(data, true);
                                self.goToEditor(data, true);
                            });
                    });
            });
    };

    self.goToEditor = function (fragment, isNewFromReport = false) {
        return $dialog.dialog({
            templateUrl: 'reporting/envision/modals/report-fragment-warning.html',
            controller: 'ReportFragmentWarningCtrl',
            report: reportHelper.getCurrentReport(),
            fragment: fragment,
            globalSettings: reportHelper.getGlobalSettings(),
            isNewFromReport: isNewFromReport
        })
            .open();
    };

    self.edit = function (fragment, isCloneMode) {
        return $http.get('/Reporting/Envision/Fragments/Verbose/' + fragment.id + '?expand=all', {trackerMsg: `Loading ${fragment.name || 'New Sub-Report'}`})
            .then(function (response) {
                const verboseFragment = response.data;
                verboseFragment.schema = reportHelper.prepareForSave(angular.copy(fragment.schema || fragment));
                return verboseFragment;
            }).then(function (verboseFragment) {
                if (!isCloneMode) return findRequiredOptions(verboseFragment.schema)
                    .then(function (options) {
                        verboseFragment.requiredOptions = options;
                        return verboseFragment;
                    });
                return verboseFragment;
            }).then(function (verboseFragment) {
                return launchFragmentEditor(verboseFragment, isCloneMode);
            });
    };

    self.save = function (fragment) {
        return $http.get('/Reporting/Envision/Fragments/Verbose/' + fragment.id + '?expand=all', {trackerMsg: 'Loading ' + fragment.name})
            .then(function (response) {
                const verboseFragment = response.data;
                verboseFragment.schema = reportHelper.prepareForSave(angular.copy(fragment));

                findRequiredOptions(verboseFragment.schema)
                    .then(function (options) {
                        verboseFragment.requiredOptions = options;
                        const args = {
                            method: 'put',
                            id: verboseFragment.id,
                            trackerMsg: 'Updating ' + verboseFragment.name,
                        };

                        $http[args.method]('/Reporting/Envision/Fragments/Verbose/' + args.id, verboseFragment, {trackerMsg: args.trackerMsg})
                            .then(function (response) {
                                removeFromList(verboseFragment);
                                var savedFragment = response.data;
                                schemaHelper.cleanupFragmentSchema(savedFragment);
                                addToList(savedFragment, true);
                            });
                    });
            });
    };


    self.saveSubReport = function (fragment) {
        const report = reportHelper.prepareForSave(angular.copy(fragment));
        report.name = report.portfolio.name;

        function updateSavedReport(response) {
            removeFromList(report);
            const updatedReport = angular.copy(response.data);
            schemaHelper.cleanupFragmentSchema(updatedReport);
            addToList(updatedReport, true);
            return response;
        }

        if (!fragment.id) {
            return $http.post('/Reporting/Envision/Fragments/Verbose', report, {trackerMsg: 'Creating ' + report.portfolio.name, ignoreExceptions: true}).then((resp) => {
                var savedSubReport = resp.data;
                schemaHelper.cleanupFragmentSchema(savedSubReport);
                addToList(savedSubReport, true);
                return resp;
            });
        } else {
            if (fragment.portfolio.isDynamic) {
                return GetSubReportCount(fragment, true)
                    .then(function (response) {
                        let parms = {
                            header: "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Sub-Report Changes",
                            message: fragment.name + " is a dynamic sub-report. Changes made here will affect all <b>" + response +
                                "</b> reports in which this sub-report is used. If you initiated this edit from a report, you will be redirected back to that report once the update is completed.<br><br> <b>Are you sure you want to proceed with these changes?</b>",
                            buttons: [{result: 'cancel', label: 'Cancel'}, {
                                result: 'save',
                                label: 'Save',
                                cssClass: 'btn-primary',
                                focus: true
                            }]
                        };
                        if (response === 0) {
                            parms.message = fragment.name + " is a dynamic sub-report. <br><br> <b>Are you sure you want to make these changes?</b>";
                        }
                        return $dialog.messageBox(parms.header, parms.message, parms.buttons)
                            .open()
                            .then(function (result) {
                                if (result === 'save') {
                                    return $http.put('/Reporting/Envision/Fragments/Verbose/' + report.id, report, {trackerMsg: 'Updating ' + report.portfolio.name, ignoreExceptions: true})
                                        .then(updateSavedReport);
                                }
                            });
                    });
            } else {
                return $http.put('/Reporting/Envision/Fragments/Verbose/' + report.id, report, {trackerMsg: 'Updating ' + report.portfolio.name, ignoreExceptions: true})
                    .then(updateSavedReport);
            }
        }
    };

    self.delete = function (fragment) {
        if (fragment.portfolio.isDynamic) {
            return GetSubReportCount(fragment)
                .then(function (response) {
                    let parms = {
                        header: "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i>  Delete Sub-Report",
                        message: fragment.name + " is a dynamic sub-report. Deleting this sub-report will delete it from all <b>" + response +
                            "</b> reports this sub-report is a part of.<br><br> <b>Are you sure you want to make these changes?</b>",
                        buttons: [{result: 'cancel', label: 'Cancel'}, {
                            result: 'delete',
                            label: 'Delete',
                            cssClass: 'btn-danger',
                            focus: true
                        }]
                    };

                    if (response === 0) {
                        parms.message = 'Are you sure you want to delete <b>' + fragment.name + '</b>?';
                    }
                    return $dialog.messageBox(parms.header, parms.message, parms.buttons)
                        .open()
                        .then(function (result) {
                            if (result === 'delete') {
                                return $http.delete('/Reporting/Envision/Fragments/Verbose/' + fragment.id, {trackerMsg: 'Deleting ' + fragment.name})
                                    .then(function () {
                                        removeFromList(fragment);
                                        return fragment;
                                    });
                            }
                        });
                });
        } else {
            return $dialog.confirmAction('Are you sure you want to delete <b>' + fragment.name + '</b>?')
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        return $http.delete('/Reporting/Envision/Fragments/Verbose/' + fragment.id, {trackerMsg: 'Deleting ' + fragment.name})
                            .then(function () {
                                removeFromList(fragment);
                                return fragment;
                            });
                    }
                });
        }
    };

    self.getFragmentName = function (fragment) {
        var item = internal.cache[fragment.id];
        return (item && item.type === 'rcSubReportWrapper') ? item.name : null;
    };

    self.getShowFragmentActions = function () {
        return internal.showFragmentActions;
    };
    self.setShowFragmentActions = function (showFragmentActions) {
        internal.showFragmentActions = showFragmentActions;
    };
});
'use strict';

app.service('imageHelper', function reportHelper($http, $dialog, $rootScope, $q, $upload) {
    // PRIVATE VARIABLES
    var self = this;
    self.imageChangeEvent = 'rb-event:change-image';
    var internal = {
        images: [],
    };

    internal.allReportImagesPromise = $http.get('/Reporting/Envision/ReportImages', {
        trackerMsg: 'Loading report images',
    }).then(function(response) {
        internal.images.add(response.data);
        return internal.images;
    });

    self.isReady = $q.all([internal.allReportImagesPromise]);

    self.getCached = function(image) {
        return internal.images.find({ id: image.id });
    };

    self.get = function(image) {
        if (image === undefined) {
            internal.images.length = 0;
            return internal.allReportImagesPromise;
        } else {
            image = self.getCached(image) || image;
            return $http.get('/Reporting/Envision/ReportImages/{id}'.assign(image), {

                trackerMsg: 'Loading report image',
            }).then(function(response) {
                Object.merge(image, response.data);
                return image;
            });
        }
    };

    self.list = function() {
        return internal.images;
    };

    self.edit = function(image, index) {
        //get it again before opening editor to ensure we have the most recent
        return $q.resolve(image ? self.get(image) : (image = {}))
            .then(function (image) {                
                image.index = index;
                return $dialog.dialog({
                    templateUrl: 'reporting/envision/modals/report-image.html',
                    controller: 'ReportImageCtrl',
                    title: image.id ? 'Update Report Image' : 'Upload Image',
                    icon: image.id ? 'fa-floppy-o' : '',
                    item: angular.copy(image),
                }).open().then(function(rslt) {
                    if (!rslt) return $q.resolve(image);
                    else {
                        Object.merge(image, rslt);
                        return $q.resolve(image).then(self.save).then(self.upload);
                    }
                });
            });
    };

    self.upload = function(image) {
        var fileReplaced = !!image.file;
        return $q.resolve(!image.file
            ? image
            : $upload.upload({
                url: '/Reporting/Envision/ReportImages/{id}/Action/Upload'.assign(image),
                data: {
                    id: image.id,
                    name: image.name,
                },
                file: image.file,

                trackerMsg: 'Uploading ' + (image.name || 'image'),
            })).then(function() {
            if (fileReplaced) {
                image.imageUrl = addCacheBuster(image.imageUrl);
            }
            $rootScope.$broadcast(self.imageChangeEvent, { index: image.index, saving: false });
            delete image.file;
            return image;
        });
    };

    function addCacheBuster(imageUrl) {
        if (!imageUrl || imageUrl.indexOf('blob:') === 0) {
            return imageUrl;
        }

        var baseUrl = imageUrl.split('?')[0];
        return baseUrl + '?ts=' + Date.now();
    }

    self.save = function (image) {
        $rootScope.$broadcast(self.imageChangeEvent, { index: image.index, saving: true });
        var file = image.file;
        delete image.file;
        delete image.imageExtension;
        return $q.resolve(image.id
            ? $http.put('/Reporting/Envision/ReportImages/{id}'.assign(image), image, { trackerMsg: 'Updating ' + (image.name || 'image') })
            : $http.post('/Reporting/Envision/ReportImages', image, { trackerMsg: 'Initializing ' + (image.name || 'image') }),
        ).then(function (response) {
            Object.merge(image, response.data);
            if (!internal.images.find(image)) internal.images.push(image);
            image.file = file;
            return image;
        });
    };

    self.delete = function(image) {
        return $dialog.confirmAction('Are you sure you want to delete image <b>' + image.name + '</b>?')
            .open()
            .then(function(result) {
                return result !== 'yes'
                    ? $q.reject(false)
                    : $http.delete('/Reporting/Envision/ReportImages/{id}'.assign(image), {
                        trackerMsg: 'Removing ' + (image.name || 'image'),
                    }).then(function() {
                        internal.images.remove({ id: image.id });
                    });
            });
    };
});
'use strict';

app.service('pdfHelper', function reportHelper($http, $dialog, $rootScope, $q, $upload, rbFileHelper) {
    // PRIVATE VARIABLES
    var self = this;
    self.pdfChangeEvent = 'rb-event:change-pdf';
    var internal = {
        pdfs: [],
    };

    internal.allReportPdfsPromise = $http.get('/Reporting/Envision/ReportPdfs', {
        trackerMsg: 'Loading report PDFs',
    }).then(function(response) {
        internal.pdfs.add(response.data);
        return internal.pdfs;
    });

    self.isReady = $q.all([internal.allReportPdfsPromise]);

    self.getCached = function(pdf) {
        return internal.pdfs.find({ id: pdf.id });
    };

    self.get = function(pdf) {
        if (pdf === undefined) {
            internal.pdfs.length = 0;
            return internal.allReportPdfsPromise;
        } else {
            pdf = self.getCached(pdf) || pdf;
            return $http.get('/Reporting/Envision/ReportPdfs/{id}'.assign(pdf), {

                trackerMsg: 'Loading report PDF',
            }).then(function(response) {
                Object.merge(pdf, response.data);
                return pdf;
            });
        }
    };

    self.list = function() {
        return internal.pdfs;
    };

    self.edit = function(pdf, index) {
        //get it again before opening editor to ensure we have the most recent
        return $q.resolve(pdf ? self.get(pdf) : (pdf = {}))
            .then(function(pdf) {
                pdf.index = index;
                return $dialog.dialog({
                    templateUrl: 'reporting/envision/modals/report-pdf-modal.html',
                    controller: 'ReportPdfModalCtrl',
                    title: 'Upload PDF',
                    icon: '',
                    item: angular.copy(pdf),
                }).open().then(function(rslt) {
                    if (!rslt) return $q.resolve(pdf);
                    else {
                        Object.merge(pdf, rslt);
                        return $q.resolve(pdf).then(self.save).then(self.upload);
                    }
                });
            });
    };

    self.upload = function(pdf) {
        return $q.resolve(!pdf.file ? pdf : $upload.upload({
            url: '/Reporting/Envision/ReportPdfs/{id}/Action/Upload'.assign(pdf),
            data: {
                id: pdf.id,
                name: pdf.name,
            },
            file: pdf.file,

            trackerMsg: 'Uploading ' + (pdf.name || 'PDF'),
        })).then(function(response) {
            $rootScope.$broadcast(self.pdfChangeEvent, { index: pdf.index, saving: false });
            delete pdf.file;

            pdf.pageCount = response.data.pageCount;
            return pdf;
        }).catch(function() {
            $rootScope.$broadcast(self.pdfChangeEvent, { index: pdf.index, saving: false, deleted: true });
            delete pdf.file;
            delete pdf.pdfUrl;
            return pdf;
        });

    };

    self.save = function(pdf) {
        $rootScope.$broadcast(self.pdfChangeEvent, { index: pdf.index, saving: true });
        var file = pdf.file;
        if (file) {
            pdf.name = rbFileHelper.ensurePdfExtension(pdf.name, file.name);
        } else if (pdf.fileExtension) {
            pdf.name = rbFileHelper.ensurePdfExtension(pdf.name, 'file' + pdf.fileExtension);
        }
        delete pdf.file;
        delete pdf.fileExtension;
        return $q.resolve(pdf.id
            ? $http.put('/Reporting/Envision/ReportPdfs/{id}'.assign(pdf), pdf, { trackerMsg: 'Updating ' + (pdf.name || 'PDF') })
            : $http.post('/Reporting/Envision/ReportPdfs', pdf, { trackerMsg: 'Initializing ' + (pdf.name || 'PDF') }),
        ).then(function(response) {
            Object.merge(pdf, response.data);
            if (!internal.pdfs.find(pdf)) internal.pdfs.push(pdf);
            pdf.file = file;
            return pdf;
        });
    };

    self.delete = function(pdf, index) {
        return $dialog.confirmAction('Are you sure you want to delete PDF <b>' + pdf.name + '</b>?')
            .open()
            .then(function(result) {
                return result !== 'yes'
                    ? $q.reject(false)
                    : $http.delete('/Reporting/Envision/ReportPdfs/{id}'.assign(pdf), {
                        trackerMsg: 'Removing ' + (pdf.name || 'pdf'),
                    }).then(function() {
                        $rootScope.$broadcast(self.pdfChangeEvent, { index: index, deleted: true });
                        internal.pdfs.remove({ id: pdf.id });
                    });
            });
    };
});
'use strict';

app.factory('rbFileHelper', function rbFileHelper() {
    const self = this;

    self.isTooLarge = function(fileSize) {
        return fileSize > (1048576 * 5); // 5MB
    };

    self.isValidPdfType = function(fileType) {

        return fileType === 'application/pdf';
    };

    self.isValidImageType = function(fileType) {

        const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/bmp', 'image/jpe', 'image/jpg'];

        return acceptedImageTypes.includes(fileType)
    };

    self.IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.jpe', '.bmp', '.gif', '.png'];

    self.isValidImageExtension = function(extension) {
        if (!extension) {
            return false;
        }

        var normalized = extension.charAt(0) === '.' ? extension.toLowerCase() : ('.' + extension.toLowerCase());
        return self.IMAGE_EXTENSIONS.indexOf(normalized) >= 0;
    };

    self.getFileExtension = function(fileName) {
        if (!fileName) {
            return '';
        }

        var lastDot = fileName.lastIndexOf('.');
        if (lastDot <= 0) {
            return '';
        }

        var extension = fileName.slice(lastDot).toLowerCase();
        return self.isValidImageExtension(extension) ? extension : '';
    };

    self.appendImageExtensionIfMissing = function(name, sourceFileName) {
        if (!name) {
            return name;
        }

        if (self.getFileExtension(name)) {
            return name;
        }

        var extension = self.getFileExtension(sourceFileName);
        if (!extension) {
            return name;
        }

        return name + extension;
    };

    self.stripFileExtension = function(fileName) {
        if (!fileName) {
            return '';
        }

        var extension = self.getFileExtension(fileName);
        if (!extension) {
            return fileName;
        }

        return fileName.slice(0, fileName.length - extension.length);
    };

    self.PDF_EXTENSION = '.pdf';

    self.isValidPdfExtension = function(extension) {
        if (!extension) {
            return false;
        }

        var normalized = extension.charAt(0) === '.' ? extension.toLowerCase() : ('.' + extension.toLowerCase());
        return normalized === self.PDF_EXTENSION;
    };

    self.getPdfFileExtension = function(fileName) {
        if (!fileName) {
            return '';
        }

        var lastDot = fileName.lastIndexOf('.');
        if (lastDot <= 0) {
            return '';
        }

        var extension = fileName.slice(lastDot).toLowerCase();
        return self.isValidPdfExtension(extension) ? extension : '';
    };

    self.ensurePdfExtension = function(name, sourceFileName) {
        if (!name) {
            return name;
        }

        var extension = self.getPdfFileExtension(sourceFileName);
        if (!extension) {
            return name;
        }

        var lastDot = name.lastIndexOf('.');
        var baseName = lastDot > 0 ? name.slice(0, lastDot) : name;
        return baseName + extension;
    };

    self.validatePdf = function(file) {
        return new Promise(function(resolve) {
            if (self.isValidPdfType(file.type) === false) {
                resolve({ isValid: false, message: 'Please select a PDF file' });
                return;
            }

            if (file && self.isTooLarge(file.size) === true) {
                resolve({ isValid: false, message: 'The file you selected has a size which exceeds 5MB' });
                return;
            }

            var reader = new FileReader();
            var fileHeader = file.slice(0, 8);

            reader.onloadend = function() {
                var pdfHeader = reader.result;
                var validatePdfHeader = new RegExp('%PDF-1.[0-7]');

                if (!pdfHeader.match(validatePdfHeader)) {
                    resolve({
                        isValid: false,
                        message: 'Invalid PDF, Please ensure the file is not encrypted or corrupted',
                    });
                }

                resolve({ isValid: true });
            };

            reader.readAsText(fileHeader);
        });
    };

    self.validateImage = function(file) {
        return new Promise(function(resolve) {
            if (!file || self.isValidImageType(file.type) === false) {
                resolve({ isValid: false, message: 'Please select an image file' });
                return;
            }

            if (file && self.isTooLarge(file.size) === true) {
                resolve({ isValid: false, message: 'The file you selected has a size which exceeds 5MB' });
                return;
            }
            
            return resolve({ isValid: true });
        });
    };

    return self;
});

'use strict';

app.factory('contextChangeHelper', function contextChangeHelper() {
    const self = this;

    self.comparisonSpecialName = function(name) {
        if (!name) {
            return false;
        }

        if (name.startsWith('Use Assigned')) {
            return true;
        }

        if (name.startsWith('Product Returns')) {
            return true;
        }

        return false;
    };

    self.comparisonListValid = function(list) {
        if (!list || list.length === 0) {
            return true;
        }

        return list.all(function(item) {
            const hasBenchmarks = item.benchmarks && item.benchmarks.length > 0;
            const specialName = self.comparisonSpecialName(item.name);

            return hasBenchmarks || specialName || item.isGlobal;
        });
    };

    self.comparisonBenchmarkKey = function(benchmark) {
        return benchmark.id + '_' + benchmark.type;
    };

    self.comparisonHasDuplicateBenchmarks = function(item) {
        const benchmarks = item && item.benchmarks;

        if (!benchmarks || benchmarks.length < 2) {
            return false;
        }

        const keys = benchmarks.map(self.comparisonBenchmarkKey);

        return keys.some(function(key, index) {
            return keys.indexOf(key) !== index;
        });
    };

    self.statisticalSpecialName = function(name) {
        if (!name) {
            return false;
        }

        if (name.startsWith('Use Assigned')) {
            return true;
        }

        return false;
    };

    self.statisticalListValid = function(list) {
        if (!list || list.length === 0) {
            return true;
        }

        return list.all(function(item) {
            const hasBenchmark = item.marketBenchmark || item.riskFreeBenchmark;
            const specialName = self.statisticalSpecialName(item.name);

            return hasBenchmark || specialName || item.isGlobal;
        });
    };

    self.getPerformanceDefaultValueCapitalized = function(field, perfDefaults){
        const defaultValue = perfDefaults[field];

        if (defaultValue !== undefined && defaultValue !== null){
            return defaultValue.toString().capitalize();
        }
        
        return null;
    };

    return self;
});

'use strict';

app.factory('rcListHelper', function rcListHelper() {
    const self = this;

    const alwaysAliveControls = ['rcGroupingTable', 'rcStaticTable'];

    self.keepControlAlive = function (control) {
        if (alwaysAliveControls.includes(control.$type)){
            return true;
        }

        if (control.$type === 'rcSplitter'){
            return control.controls.length > 1;
        }

        return false;
    };

    return self;
});

'use strict';

app.service('rcChartHelper', function rcChartHelper($http, reportHelper) {
    const self = this;

    //PUBLIC API
    var commonOptions = Object.select(reportHelper, 'groupingOptions', 'limitOptions');
    angular.extend(self, commonOptions);

    self.timeFrameOptions = [
        'As of Report End Date', 'Since Inception', 'Report Period', 'Current Year', 'QTD', 'YTD'
    ];

    self.dataLabelOptions = [
        {name: 'Show', value: true},
        {name: 'Hide', value: false}
    ];

    self.yesNoOptions = [
        {name: 'Yes', value: true},
        {name: 'No', value: false}
    ];

    self.legendOptions = [
        {name: 'Disabled', value: {enabled: false, useHTML: true}},
        {name: 'Right', value: {enabled: true, layout: 'vertical', verticalAlign: 'middle', align: 'right', useHTML: true}},
        {name: 'Left', value: {enabled: true, layout: 'vertical', verticalAlign: 'middle', align: 'left', useHTML: true}},
        {name: 'Top', value: {enabled: true, layout: 'horizontal', verticalAlign: 'top', align: 'center', useHTML: true}},
        {name: 'Bottom', value: {enabled: true, layout: 'horizontal', verticalAlign: 'bottom', align: 'center', useHTML: true}}
    ];

    self.getAllGroupingOptions = function(){
        return reportHelper.getAllGroupingOptions();
    };

    self.filterGroupingOptionsByAllowedEntityTypes = function(groupingOption) {
        return reportHelper.filterGroupingOptionsByAllowedEntityTypes(groupingOption);
    };

    self.getLegendOption = function(legend){
        const legendForCompare = cleanLegendForCompare(legend);
        return self.legendOptions.fnFind(function (option) {
            return angular.equals(cleanLegendForCompare(option.value), legendForCompare);
        }).value;
    };

    function cleanLegendForCompare(legend){
        const newLegend = angular.copy(legend);

        ['$$hashKey','useHTML']
            .forEach(function (p) {
                newLegend[p] = undefined;
            });

        return newLegend;
    }

    self.dataSourceOptions = [
        'Activity', 'Performance', 'Trading'
    ];

    self.frequencyOptions = [
        'Summary', 'Annually', 'Quarterly', 'Monthly', 'Weekly', 'Daily', 'Automatic'
    ];

    self.basedOnOptions = [
        {name: 'Calendar', value: 'Calendar'}, {name: 'Rolling Forward', value: 'RollingForward'}, {name: 'Rolling Backward', value: 'RollingBackward'}
    ];

    self.labelOrientationSettings = [
        {
            orientation: 'Auto'
        },
        {
            orientation: 'Vertical',
            rotation: -90,
            alignment: 'Right'
        },
        {
            orientation: 'Horizontal',
            rotation: 0,
            alignment: 'Center'
        },
        {
            orientation: 'Diagonal',
            rotation: -45,
            alignment: 'Right'
        }
    ];
});
'use strict';

app.factory('schemaHelper', function schemaHelper() {
    const self = this;

    self.isDoubleWrappedFragment = function (schema) {
        if (!schema || schema.$type !== 'rcWrapper' || !schema.controls) {
            return false;
        }

        const firstControl = schema.controls[0];
        if (firstControl.$type !== 'rcSplitter' || !firstControl.controls || firstControl.controls.length !== 1) {
            return false;
        }

        const firstNestedControl = firstControl.controls[0];
        if (firstNestedControl.$type === 'rcWrapper') {
            return true;
        }

        return false;
    };

    self.unwrapFragmentSchema = function (schema) {
        const unwrapedSchema = angular.copy(schema);
        unwrapedSchema.id = schema.id;
        return unwrapedSchema;
    };

    self.cleanupFragmentSchema = function (fragment) {
        //Check if schema is rclist type and convert to save as rcSubReportWrapper for RB3 editor
        if (fragment.schema.$type !== 'rcSubReportWrapper') {
            fragment.schema.$type = 'rcSubReportWrapper';
        }
        if (!fragment.schema.id) {
            fragment.schema.id = fragment.id;
        }
    };

    const resolvesRegex = /(\[@({.*?})@])/ig;

    function stripResolves(value) {
        return value.replace(resolvesRegex, "");
    }

    function stripHtml(value) {
        const div = document.createElement('div');
        div.innerHTML = value;
        return div.innerText;
    }

    function removeExtraSpaces(value) {
        return value.replace(/\s+/g, ' ');
    }

    self.getSubReportName = function (control) {
        if (control.$type !== 'rcWrapper' || !control.titleControl) {
            return 'New Sub-Report';
        }

        let name = control.titleControl.value;

        name = stripResolves(name);
        name = stripHtml(name);
        name = removeExtraSpaces(name);

        const trimmedName = name.trim();
        if (trimmedName.length === 0) {
            return 'New Sub-Report';
        }

        return trimmedName;
    };

    return self;
});

'use strict';

app.factory('reportCleanHelper', function reportCleanHelper() {
    const self = this;

    function updateRequiredOptions(report, requiredOption, optionTypes) {
        const typeMatch = optionTypes.find(ot => ot.type === requiredOption.$type);
        if (!typeMatch) {
            return;
        }

        const contextPropertyId = report.schema.contextChange[typeMatch.propertyName];
        const contextMatches = contextPropertyId === requiredOption.optionId;
        if (contextMatches) {
            return;
        }

        const category = report.options.find(o => o.$type === typeMatch.type);
        if (!category) {
            return;
        }

        const shouldBeRequired = category.options.find(o => o.optionId === contextPropertyId);
        if (shouldBeRequired) {
            category.options.forEach(o => o.isRequired = false);
            shouldBeRequired.isRequired = true;
        } else {
            const requiredOption = category.options.find(o => o.isRequired);
            if (requiredOption) {
                report.schema.contextChange[typeMatch.propertyName] = requiredOption.optionId;
                return;
            }

            const minId = category.options.map(o => o.optionId).min();
            const minOption = category.options.find(o => o.optionId === minId);

            minOption.isRequired = true;
            report.schema.contextChange[typeMatch.propertyName] = minId;
        }
    }

    function cleanRequiredDataRange(report) {
        const requiredDateRange = report.requiredOptions.find(ro => ro.$type === 'daterange');

        if (requiredDateRange) {
            requiredDateRange.prompt = 'Always';
        }
    }

    self.cleanDateRangeZero = function (schema, optionTypes) {
        self.updateProperties(schema, [{
            propertyName: 'dateRangeId',
            oldId: 0,
            newId: 1000
        }], optionTypes);
    };

    self.cleanReport = function (report, optionTypes) {
        self.cleanNestedControl(report.schema.body.controls);

        report.requiredOptions.forEach(ro => {
            updateRequiredOptions(report, ro, optionTypes);
        });

        cleanRequiredDataRange(report);

        const missingOptions = self.findMissingOptions(report, optionTypes);
        if (missingOptions && missingOptions.length > 0) {
            if (missingOptions.some(mo => mo.propertyName === 'dateRangeId' && mo.missingOptionId === 0) && report.schema.contextChange.globalsSynced) {
                self.cleanDateRangeZero(report.schema, optionTypes);
            }

            return self.subReportsWithMissingOptions(report.schema, missingOptions);
        }
    };

    self.subReportsWithMissingOptions = function (schema, missingOptions) {
        const brokenSubReportIds = [];
        const subReportsAndParents = self.getSubReportsAndTheirParent(schema);

        const missingOptionRegexes = [];
        missingOptions.forEach(mo => {
            missingOptionRegexes.push(new RegExp(`(${mo.propertyName})(\\\\"|\\"):(${mo.missingOptionId})`, 'gi'));
        });

        subReportsAndParents.forEach(layers => {
            const stringifiedControl = JSON.stringify(layers.control, null, 0);

            const hasMatch = missingOptionRegexes.some(r => stringifiedControl.match(r));
            if (hasMatch && !brokenSubReportIds.includes(layers.control.id)) {
                brokenSubReportIds.push(layers.control.id);
            }
        });

        return {
            brokenSubReportIds,
            subReportsAndParents: subReportsAndParents
        };
    };

    function seekNestedControl(parent, controls, controlsFound) {
        for (const control of controls) {
            const isSubReport = control.id;

            if (isSubReport) {
                //no need to go deeper
                controlsFound.push({id: control.id, parent, control});
                continue;
            }

            if (!control.controls) {
                //no need to go deeper
                continue;
            }

            seekNestedControl(control, control.controls, controlsFound);
        }
    }

    self.cleanNestedControl = function (controls) {
        for (const control of controls) {

            if (!control.$type) {
                //remove controls without type
                controls.remove(control);
                continue;
            }

            if (control.id || !control.controls) {
                //no need to go deeper
                continue;
            }

            self.cleanNestedControl(control.controls);
        }

        removeEmptySplitters(controls);
    };

    function removeEmptySplitters(controls) {
        for (let i = controls.length; i--;) {
            //look over controls from end because we may remove by index
            const c = controls[i];
            if (c.$type === 'rcSplitter' && c.controls.length === 0) {
                //splice to change current array and
                controls.splice(i, 1);
            }
        }
    }

    self.getSubReportsAndTheirParent = function (schema) {
        const controlsFound = [];

        seekNestedControl(schema.body, schema.body.controls, controlsFound);

        return controlsFound;
    };

    self.findMissingOptions = function (report, optionTypes) {
        const missingOptions = [];
        const propertyNames = optionTypes.map(ot => ot.propertyName).join('|');

        const optionIdsByPropertyName = report.options.reduce((acc, category) => {
            const type = optionTypes.find(ot => ot.type === category.$type);
            if (!type) {
                return {...acc};
            }
            return {...acc, [type.propertyName]: category.options.map(o => o.optionId)};
        }, {});

        const optionRegex = new RegExp('(' + propertyNames + ')(\\\\"|\\"):(\\d+)', 'gi');

        const foundInReport = JSON.stringify(report.schema, null, 0).match(optionRegex);
        (foundInReport || []).forEach(optionsFound => {
            const propertyAndValue = optionsFound.replace(/(\"|\\)/g, "").split(':');

            const availableOptions = optionIdsByPropertyName[propertyAndValue[0]];
            if (!availableOptions) {
                return;
            }

            const optionNeeded = propertyAndValue[1].toNumber();
            const foundValidOptionId = availableOptions.includes(optionNeeded);
            if (foundValidOptionId === false) {
                missingOptions.push({propertyName: propertyAndValue[0], missingOptionId: optionNeeded});
            }
        });

        return missingOptions.filter((missing, index, self) =>
            index === self.findIndex((t) => (
                t.propertyName === missing.propertyName && t.missingOptionId === missing.missingOptionId
            )));
    };

    self.updateString = function (source, matchedOptions) {
        if (source && typeof source === 'string') {
            // this is a string, we can regex replace to do the update

            // get the unique type of options we're dealing with first
            const optionTypes = Array.from(matchedOptions, (remap) => {
                // @ts-ignore
                return remap.propertyName;
            }).unique().join('|');

            // the regex here is a pattern matching digits instead of the specific number we are looking for to keep from updating "dateRangeId:20" to "dateRangeId:40" when the oldValue = 2 and newValue = 4.
            const optionRegex = new RegExp('(' + optionTypes + ')\\":(\\d+)', 'gi');
            return source.replace(optionRegex, (match, p1, p2, offset, string) => {
                // see if we have an option that is the same type and id the regex match
                const mo = matchedOptions.find((remap) => {
                    return remap.propertyName.localeCompare(p1) === 0 && parseInt(p2) === remap.oldId;
                });

                if (mo) {
                    // we found a match, update the id

                    // this is the property we were looking for and the value matches
                    return p1 + '":' + mo.newId;
                }

                // no change
                return match;
            });
        }
    };

    self.updateProperties = function (source, matchedOptions, optionTypes) {
        if (source && ['rcStringResolver', 'rcStringResolverCompact'].some((stringResolverType) => stringResolverType === source.$type)) {
            // this is a string resolver, we can regex replace to do the update
            source.value = self.updateString(source.value, matchedOptions);
        }

        for (const property in source) {
            if (!source.hasOwnProperty(property)) {
                continue;
            }

            self.updateMappedIdsProperty(source, property, matchedOptions, optionTypes);

            if (Array.isArray(source[property])) {
                // this is an array, we need to look at everything inside it
                source[property].forEach((item) => {
                    self.updateProperties(item, matchedOptions, optionTypes);
                });
            } else if (typeof source[property] === 'object') {
                // this is a child object, we need to loop over the properties of it
                self.updateProperties(source[property], matchedOptions, optionTypes);
            } else {
                // see if we have an option that is the same type and id as this property
                const mo = matchedOptions.find((remap) => {
                    return remap.propertyName.localeCompare(property) === 0 && source[property] === remap.oldId;
                });

                if (mo) {
                    // we found a match, update the id
                    source[property] = mo.newId;
                }
            }
        }
    };

    self.updateMappedIdsProperty = function (source, property, matchedOptions, optionTypes) {
        const isArrayMappedOptionType = optionTypes.some((o) => o.propertyName === property && !!o.arrayMapsTo);
        if (!isArrayMappedOptionType) {
            return;
        }

        const matchedPropertyOption = matchedOptions.find(mo => mo.propertyName === property);
        if (matchedPropertyOption) {
            source[property] = matchedPropertyOption.newId;
        }
    };

    return self;
})
;

'use strict';

app.factory('reportHelper', function reportHelper($http, $q, $rootScope, $route, optionsHelper, reportCopyService, ReportStyleService, ReportControlHelperService, SimpleTableEditorConversionService, dbeoService, splitIoService) {
    // PRIVATE VARIABLES
    const self = this;
    self.MenuCloseEvent = "REPORT_MENU_CLOSE";
    self.GetDefaultOptionEvent = "rb-editor-event:get-default-option";
    self.RefreshResolvesEvent = "rb-event:refreshResolves";

    const internal = {
        groupingOptions: [],
        staticTagConfigs: [],
        dynamicTagConfigs: {},
        sortededTagConfigs: [],
        setReportCallbacks: [],
        eventListeners: [],
        weightedBenchmarkGroupingOptions: [],
        taxInceptionTypes: ['Cost Basis', 'Beginning Market Value'],
        costPerShareMethods: ['Valuation Price', 'Percentage of Par']
    };
    const neverWrapControls = ["rcGroupRepeater", "rcWrapper", "rcSubReportWrapper", "rcHeader", "rcStringResolver", "rcPageBreak", "rcTableOfContentsEntry", "rcSpacer", "rcReportPdf"];

    const AD_HOC_GROUPING_LEVEL_GUID_PREFIX = '00000000-0000-4000-8000-';
    const CALCULATION_GROUPING_AD_HOC_GROUPING = -32692;
    const AD_HOC_GROUPING_CALCULATION_NAME = 'Ad Hoc Grouping';

    function parseAdHocGroupingPayload(settingsJson) {
        if (settingsJson === null || settingsJson === undefined) {
            return null;
        }

        try {
            const parsed = typeof settingsJson === 'string' ? JSON.parse(settingsJson) : settingsJson;
            if (!parsed || typeof parsed !== 'object') {
                return null;
            }

            return parsed.category ? parsed : null;
        } catch (e) {
            return null;
        }
    }

    function adHocChildGuidToGroupingValue(guid) {
        const normalized = (guid || '').toLowerCase();
        if (!normalized.startsWith(AD_HOC_GROUPING_LEVEL_GUID_PREFIX)) {
            return null;
        }

        const parsed = parseInt(normalized.slice(AD_HOC_GROUPING_LEVEL_GUID_PREFIX.length), 16);
        return Number.isNaN(parsed) ? null : (parsed | 0);
    }

    function buildAdHocGroupingMenuOptions(baseOptions) {
        const settings = (optionsHelper.getAdHocSettingsCache() || [])
            .filter(function (setting) {
                const payload = parseAdHocGroupingPayload(setting.settings);
                return payload && payload.category === 'GroupingLevel';
            })
            .sort(function (a, b) {
                return (a.name || '').localeCompare(b.name || '', 'en', { sensitivity: 'base', numeric: true });
            });

        return settings.map(function (setting) {
            const payload = parseAdHocGroupingPayload(setting.settings);
            const defaultChildGuid = payload.defaultChildOptionGuid
                || (payload.defaultChildOptionGuids && payload.defaultChildOptionGuids[0])
                || null;
            const defaultGroupingValue = adHocChildGuidToGroupingValue(defaultChildGuid);
            const defaultBaseOption = defaultGroupingValue != null
                ? baseOptions.find(function (option) { return option.value === defaultGroupingValue; })
                : null;

            return {
                name: setting.name + ' (Ad hoc)',
                value: CALCULATION_GROUPING_AD_HOC_GROUPING,
                isAdHoc: true,
                adhocOptionGuid: setting.guid,
                category: 'Ad Hoc',
                allowedEntityType: ['AssetBased', 'Prospect'],
                isAssetBased: !!(defaultBaseOption && defaultBaseOption.isAssetBased),
                defaultGroupingValue: defaultGroupingValue,
                grouping: defaultBaseOption ? defaultBaseOption.grouping : undefined
            };
        });
    }

    function mergeGroupingOptionsWithAdHoc(baseOptions) {
        if (optionsHelper && typeof optionsHelper.mergeGroupingOptionsWithAdHoc === 'function') {
            return optionsHelper.mergeGroupingOptionsWithAdHoc(baseOptions);
        }

        const adHocOptions = buildAdHocGroupingMenuOptions(baseOptions || []);
        if (!adHocOptions.length) {
            return baseOptions || [];
        }

        const merged = (baseOptions || []).concat(adHocOptions);
        merged.sort(function (a, b) {
            return (a.name || '').localeCompare(b.name || '', 'en', { sensitivity: 'base', numeric: true });
        });
        return merged;
    }

    function getAdhocGuidFromGroupingLevel(groupLevel) {
        const ref = groupLevel && groupLevel.groupingLevelOption;
        if (ref && ref.$type === 'adhoc-guid' && ref.adhocOptionGuid) {
            return ref.adhocOptionGuid;
        }

        return null;
    }

    function getGroupingDisplayName(groupLevel, mergedOptions) {
        if (optionsHelper && typeof optionsHelper.getGroupingDisplayName === 'function') {
            return optionsHelper.getGroupingDisplayName(groupLevel, mergedOptions);
        }

        return groupLevel?.name || '';
    }

    function resolveSelectedAdHocGroupingOption(groupLevel, selectedValue, mergedOptions, selectedOption) {
        if (selectedOption && selectedOption.isAdHoc && selectedOption.adhocOptionGuid) {
            return selectedOption;
        }

        const isAdHocValue = selectedValue === CALCULATION_GROUPING_AD_HOC_GROUPING
            || selectedValue === 'Ad Hoc Grouping'
            || groupLevel?.value === CALCULATION_GROUPING_AD_HOC_GROUPING
            || groupLevel?.value === 'Ad Hoc Grouping';

        if (!isAdHocValue) {
            return null;
        }

        if (selectedOption && selectedOption.name) {
            const nameMatch = (mergedOptions || []).find(function (option) {
                return option.isAdHoc && option.name === selectedOption.name;
            });
            if (nameMatch) {
                return nameMatch;
            }
        }

        const adhocGuid = getAdhocGuidFromGroupingLevel(groupLevel);
        if (adhocGuid) {
            const guidMatch = (mergedOptions || []).find(function (option) {
                return option.isAdHoc && option.adhocOptionGuid === adhocGuid;
            });
            if (guidMatch) {
                return guidMatch;
            }
        }

        if (groupLevel && groupLevel.name) {
            const labelMatch = (mergedOptions || []).find(function (option) {
                return option.isAdHoc
                    && option.name.replace(/ \(Ad hoc\)$/i, '') === groupLevel.name;
            });
            if (labelMatch) {
                return labelMatch;
            }
        }

        const adHocOptions = (mergedOptions || []).filter(function (option) { return option.isAdHoc; });
        if (adHocOptions.length === 1) {
            return adHocOptions[0];
        }

        return null;
    }

    function applyAdHocGroupingSelection(groupLevel, selectedValue, mergedOptions, selectedOption) {
        if (optionsHelper && typeof optionsHelper.applyAdHocGroupingSelection === 'function') {
            optionsHelper.applyAdHocGroupingSelection(groupLevel, selectedValue, mergedOptions, selectedOption);
            return;
        }

        const selectedAdHoc = resolveSelectedAdHocGroupingOption(
            groupLevel,
            selectedValue,
            mergedOptions,
            selectedOption
        );

        if (selectedAdHoc) {
            groupLevel.groupingLevelOption = {
                $type: 'adhoc-guid',
                adhocOptionGuid: selectedAdHoc.adhocOptionGuid
            };

            groupLevel.value = CALCULATION_GROUPING_AD_HOC_GROUPING;
            groupLevel.name = selectedAdHoc.name.replace(/ \(Ad hoc\)$/i, '');
            return;
        }

        try {
            delete groupLevel.groupingLevelOption;
        } catch (e) {
            groupLevel.groupingLevelOption = null;
        }

        const previousValue = groupLevel.value;
        const standardOption = findStandardGroupingOption(selectedValue, mergedOptions)
            || findStandardGroupingOption(previousValue, mergedOptions);

        if (standardOption) {
            groupLevel.name = standardOption.name;
            groupLevel.value = persistStandardGroupingValue(previousValue, standardOption);
        }
    }

    function groupingOptionMatchesPersistedValue(option, persistedValue) {
        if (optionsHelper && typeof optionsHelper.groupingOptionMatchesPersistedValue === 'function') {
            return optionsHelper.groupingOptionMatchesPersistedValue(option, persistedValue);
        }

        if (!option || option.isAdHoc === true || persistedValue == null || persistedValue === '') {
            return false;
        }

        if (option.userDefinedFieldDefinitionId != null) {
            if (typeof persistedValue === 'string' && persistedValue.indexOf('udf-') === 0) {
                return persistedValue === 'udf-' + option.userDefinedFieldDefinitionId;
            }

            return false;
        }

        if (typeof persistedValue === 'string' && persistedValue.indexOf('udf-') === 0) {
            return false;
        }

        return option.value == persistedValue
            || option.grouping == persistedValue
            || option.name === persistedValue;
    }

    function groupingOptionMatchesGroupLevel(option, groupLevel, persistedValue) {
        if (!option || option.isAdHoc === true) {
            return false;
        }

        if (option.userDefinedFieldDefinitionId != null) {
            if (groupLevel && groupLevel.userDefinedFieldDefinitionId != null) {
                return groupLevel.userDefinedFieldDefinitionId == option.userDefinedFieldDefinitionId;
            }

            return typeof persistedValue === 'string'
                && persistedValue.indexOf('udf-') === 0
                && persistedValue === 'udf-' + option.userDefinedFieldDefinitionId;
        }

        if (groupLevel && groupLevel.userDefinedFieldDefinitionId != null) {
            return false;
        }

        return groupingOptionMatchesPersistedValue(option, persistedValue);
    }

    function resolveGroupingSelectionOption(selectedValue, mergedOptions, selectedOption) {
        if (selectedOption && selectedOption.userDefinedFieldDefinitionId != null) {
            return self.findGroupingOptionBySelectionKey(self.getGroupingSelectionKey(selectedOption))
                || selectedOption;
        }

        if (selectedOption && selectedOption.isAdHoc) {
            return selectedOption;
        }

        if (selectedOption) {
            return selectedOption;
        }

        return self.findGroupingOptionBySelectionKey(selectedValue)
            || findStandardGroupingOption(selectedValue, mergedOptions);
    }

    function applyGroupingLevelSelection(groupLevel, selectedValue, mergedOptions, selectedOption) {
        const resolvedOption = resolveGroupingSelectionOption(selectedValue, mergedOptions, selectedOption);

        if (resolvedOption && resolvedOption.isAdHoc) {
            applyAdHocGroupingSelection(groupLevel, selectedValue, mergedOptions, resolvedOption);
            self.applyUserDefinedFieldGroupingMetadata(groupLevel, null);
            return;
        }

        if (resolvedOption && resolvedOption.userDefinedFieldDefinitionId != null) {
            try {
                delete groupLevel.groupingLevelOption;
            } catch (e) {
                groupLevel.groupingLevelOption = null;
            }

            self.applyUserDefinedFieldGroupingMetadata(groupLevel, resolvedOption);
            return;
        }

        applyAdHocGroupingSelection(groupLevel, selectedValue, mergedOptions, resolvedOption);
        self.applyUserDefinedFieldGroupingMetadata(groupLevel, null);
    }

    function toGroupingMenuOption(option) {
        return {
            name: option.name,
            value: self.getGroupingSelectionKey(option),
            grouping: option.grouping,
            isAdHoc: option.isAdHoc,
            adhocOptionGuid: option.adhocOptionGuid,
            userDefinedFieldDefinitionId: option.userDefinedFieldDefinitionId,
            userDefinedFieldEntity: option.userDefinedFieldEntity,
            userDefinedFieldCode: option.userDefinedFieldCode,
        };
    }

    function findStandardGroupingOption(persistedValue, mergedOptions) {
        if (optionsHelper && typeof optionsHelper.findStandardGroupingOption === 'function') {
            return optionsHelper.findStandardGroupingOption(persistedValue, mergedOptions);
        }

        return (mergedOptions || []).find(function (option) {
            return groupingOptionMatchesPersistedValue(option, persistedValue);
        });
    }

    function persistStandardGroupingValue(previousValue, standardOption) {
        const previousWasLegacyString = typeof previousValue === 'string'
            && previousValue !== AD_HOC_GROUPING_CALCULATION_NAME;

        if (previousWasLegacyString) {
            return typeof standardOption.grouping === 'string' && standardOption.grouping
                ? standardOption.grouping
                : standardOption.name;
        }

        return standardOption.value;
    }

    internal.eventNames = {
        reportStyle: 'rb-event:reportStyle',
        dynamicNameChange: 'rb-event:dynamicTagChange',
        tagConfigChange: 'rb-event:tagConfigChange'
    };

    internal.optionTypes = optionsHelper.optionTypes;

    internal.typeFormats = [
        {type: 'currency', format: '$#,##0.00' },
        {type: 'decimal', format: '#,##0.00' },
        {type: 'percent', format: '0.00 %' },
        {type: 'numeric', format: '#,##0' }
    ];

    internal.getMap = function(type, supressError) {
        if(type) {
            let typeLower;
            const map = internal.optionTypes.fnFind(function(t){
                return (
                    t.optionType === type ||
                    t.type === type ||
                    t.optionName === type ||
                    t.propertyName === type ||
                    t.optionType === (typeLower = type.toLocaleLowerCase()) ||
                    t.type === typeLower
                )
            });
            if(map) return map;
        }
        if(!supressError) {
            throw new Error('unknown type "' + type + '"');
        }
    };

    internal.optionEventName = function (type) { return "rb-event:"+type+":options"; };

    internal.defaultEventName = function (type) { return "rb-event:"+type+":default"; };

    internal.groupingOptionsPromise = $q.all([
        $http.get('/Reporting/Envision/GroupingOptions', {trackerMsg: 'Loading grouping options'}),
        splitIoService.isLoaded.then(() => splitIoService.getBoolTreatment('oc_reporting_allowproductsubholding_tech4582').toPromise())
    ]).then(function(responses) {
        const groupingOptions = responses[0].data;
        const allowProductSubHolding = responses[1];

        if (!allowProductSubHolding) {
            groupingOptions.remove({name: 'Product Sub-Holding'});
        }

        groupingOptions
            .sort(function(a, b) {return a.name.localeCompare(b.name, 'en', {sensitivity: 'base', numeric: true});})
            .forEach(function(go) {
                internal.groupingOptions.push(go);
                self.groupingOptions.push( go.name );
                internal.weightedBenchmarkGroupingOptions.push(go);
                self.weightedBenchmarkGroupingOptions.push( go.name );
                if(go.isAssetBased){
                    self.assetBasedGroupingOptions.push( go.name );
                }
            });

        invalidateMergedGroupingOptionsCache();
        return internal.groupingOptions;
    });

    function crawlPlaceholderHeirarchy(items, path) {
        if (!path) path = [];
        items.forEach(function (config) {
            const localPath = path.concat(config.name);
            config.path = localPath.join('.');
            //set the key to the path, for all static configs they are the same
            config.key = config.path;
            config.resultType = String(config.resultType||'').toLowerCase();
            config.format = config.format || self.getTypeFormat(config.resultType);
            internal.staticTagConfigs.push(config);

            if(config.$type === 'option-value'){
                updateDynamicPlaceholders(config);
                self.getScope().$broadcast(internal.eventNames.dynamicNameChange, angular.copy(config));
                addDynamicTagChangeEvent(config);
            }

            if (config.children) {
                crawlPlaceholderHeirarchy(config.children, localPath);
            }
        });
    }

    function updateDynamicPlaceholders(optionValueConfig){
        const map = internal.getMap(optionValueConfig.optionType);

        internal.tagConfigPromises.push(
            self.getOptions(map.optionType).then(function (calculationOptions) {

                const newDynamicTagConfigs = [];
                if(calculationOptions) {
                    calculationOptions.forEach(function (option) {
                        const config = optionsHelper.mapOptionToDynamicTagConfig
                            ? optionsHelper.mapOptionToDynamicTagConfig(optionValueConfig, option, map, internal.typeFormats)
                            : (function buildLegacyConfig() {
                                const legacyConfig = angular.copy(optionValueConfig);
                                legacyConfig.resultType = (option.resultType || optionValueConfig.resultType).toLowerCase();
                                legacyConfig.description = option.description || optionValueConfig.description;
                                legacyConfig.label = map.label + ': ' + option.name;
                                legacyConfig[map.propertyName] = option.optionId;
                                legacyConfig[map.guidName] = option.guid;
                                legacyConfig.key = legacyConfig.key + '.' + option.optionId;
                                legacyConfig.format = legacyConfig.format || self.getTypeFormat(legacyConfig.resultType);
                                return legacyConfig;
                            })();

                        newDynamicTagConfigs.push(config);
                    });
                }

                internal.dynamicTagConfigs[map.optionType] = newDynamicTagConfigs;
                updateSortededTagConfigs();
                return newDynamicTagConfigs;
            })
        );
    }

    function addDynamicTagChangeEvent(config){
        const map = internal.getMap(config.optionType);

        //also bind event so these can be recreated when the options change
        self.getScope().$on(internal.optionEventName(map.optionType), function(){
            //Need to update the dynamic tags for this option type if there are any.
            if(internal.dynamicTagConfigs[map.optionType]){
                updateDynamicPlaceholders(config);
                self.getScope().$broadcast(internal.eventNames.dynamicNameChange, angular.copy(config));
            }
        });
    }

    internal.tagConfigPromises = [ $http.get('/Reporting/Envision/PlaceholderHeirarchy', {cache: true}).then(function (response) {
        self.originalTags = response.data;
        crawlPlaceholderHeirarchy(response.data);

        return updateSortededTagConfigs();
    }) ];

    function updateSortededTagConfigs(){
        let options = internal.staticTagConfigs;

        for (const prop in internal.dynamicTagConfigs) {
            //optional check for properties from prototype chain
            if (internal.dynamicTagConfigs.hasOwnProperty(prop)) {
                options = options.concat(internal.dynamicTagConfigs[prop]);
            }
        }

        options = options.sort(function(a, b) {
            return a.label.localeCompare(b.label, 'en', {sensitivity: 'base', numeric: true});
        });

        internal.sortededTagConfigs = options;
        self.getScope().$broadcast(internal.eventNames.tagConfigChange, angular.copy(options));
        return internal.sortededTagConfigs;
    }

    // PUBLIC VARIABLES
    self.isReady = $q.all([internal.tagConfigPromises, internal.groupingOptionsPromise]);
    self.current = {};

    let cachedMergedGroupingOptions = null;

    function invalidateMergedGroupingOptionsCache() {
        cachedMergedGroupingOptions = null;
    }

    function ensureMergedGroupingOptionsCacheInvalidationListener() {
        if (internal.mergedGroupingOptionsCacheListenerRegistered) {
            return;
        }

        const scope = self.getScope && self.getScope();
        if (!scope) {
            return;
        }

        internal.mergedGroupingOptionsCacheListenerRegistered = true;
        scope.$on('rb-event:ad-hoc-settings-changed', function () {
            invalidateMergedGroupingOptionsCache();
            syncGroupingLevelsInCurrentReport();
        });
    }

    self.getAllGroupingOptions = function() {
        ensureMergedGroupingOptionsCacheInvalidationListener();

        if (!cachedMergedGroupingOptions) {
            cachedMergedGroupingOptions = mergeGroupingOptionsWithAdHoc(internal.groupingOptions);
        }

        return cachedMergedGroupingOptions;
    };

    self.invalidateMergedGroupingOptionsCache = invalidateMergedGroupingOptionsCache;

    self.getAdhocGuidFromGroupingLevel = getAdhocGuidFromGroupingLevel;
    self.getGroupingDisplayName = getGroupingDisplayName;
    self.groupingMatchesName = function(source, displayName) {
        if (optionsHelper && typeof optionsHelper.groupingMatchesName === 'function') {
            return optionsHelper.groupingMatchesName(source, displayName);
        }

        if (!source || !displayName) {
            return false;
        }

        return source.name === displayName
            || source.value === displayName
            || source.grouping === displayName
            || source.groupingLabel === displayName;
    };
    self.groupingOptionMatchesPersistedValue = groupingOptionMatchesPersistedValue;
    self.findStandardGroupingOption = findStandardGroupingOption;
    self.isPersistedAdHocGroupingValue = function(value) {
        if (optionsHelper && typeof optionsHelper.isPersistedAdHocGroupingValue === 'function') {
            return optionsHelper.isPersistedAdHocGroupingValue(value);
        }

        return value === CALCULATION_GROUPING_AD_HOC_GROUPING || value === AD_HOC_GROUPING_CALCULATION_NAME;
    };
    self.applyAdHocGroupingSelection = applyAdHocGroupingSelection;
    self.groupingOptionMatchesGroupLevel = groupingOptionMatchesGroupLevel;
    self.applyGroupingLevelSelection = applyGroupingLevelSelection;
    self.toGroupingMenuOption = toGroupingMenuOption;

    function applyAdHocChartGroupingSelection(control, selectedOption, fields) {
        if (!control) {
            return;
        }

        if (optionsHelper && typeof optionsHelper.applyAdHocChartGroupingSelection === 'function') {
            optionsHelper.applyAdHocChartGroupingSelection(control, selectedOption, fields);
            return;
        }
    }

    function resolveChartGroupingOption(control, mergedOptions, fields) {
        if (!control) {
            return null;
        }

        if (optionsHelper && typeof optionsHelper.resolveChartGroupingOption === 'function') {
            return optionsHelper.resolveChartGroupingOption(control, mergedOptions || self.getAllGroupingOptions(), fields);
        }

        return null;
    }

    function stripChartGroupingEditorState(control) {
        if (optionsHelper && typeof optionsHelper.stripChartGroupingEditorState === 'function') {
            optionsHelper.stripChartGroupingEditorState(control);
        }
    }

    function stripChartControlsForSave(control) {
        if (!control) {
            return;
        }

        stripChartGroupingEditorState(control);

        if (Array.isArray(control.controls)) {
            control.controls.forEach(stripChartControlsForSave);
        }
    }

    function normalizePersistedAdHocGroupingLevel(groupLevel, mergedOptions) {
        if (!groupLevel) {
            return;
        }

        const adhocGuid = getAdhocGuidFromGroupingLevel(groupLevel);
        const isAdHocValue = groupLevel.value === CALCULATION_GROUPING_AD_HOC_GROUPING
            || groupLevel.value === 'Ad Hoc Grouping';

        if (!adhocGuid && !isAdHocValue) {
            return;
        }

        applyAdHocGroupingSelection(groupLevel, groupLevel.value, mergedOptions);
    }

    function normalizePersistedAdHocChartGrouping(control, mergedOptions) {
        if (!control) {
            return;
        }

        const groupingLevelOption = control.groupingLevelOption;
        const isAdHocGrouping = control.grouping === 'Ad Hoc Grouping'
            || control.grouping === AD_HOC_GROUPING_CALCULATION_NAME
            || (groupingLevelOption && groupingLevelOption.$type === 'adhoc-guid');

        if (!isAdHocGrouping) {
            return;
        }

        const resolvedOption = resolveChartGroupingOption(control, mergedOptions);
        // Failed resolve must not clear a persisted ad-hoc binding (e.g. options not loaded yet).
        if (!resolvedOption) {
            return;
        }

        applyAdHocChartGroupingSelection(control, resolvedOption);
    }

    function getDonutGroupingFieldSets() {
        return [
            {
                grouping: 'grouping1',
                groupingLabel: 'groupingLabel1',
                groupingOption: 'groupingOption1',
                groupingLevelOption: 'groupingLevelOption',
            },
            {
                grouping: 'grouping2',
                groupingLabel: 'groupingLabel2',
                groupingOption: 'groupingOption2',
                groupingLevelOption: 'groupingLevelOption2',
            },
            {
                grouping: 'grouping3',
                groupingLabel: 'groupingLabel3',
                groupingOption: 'groupingOption3',
                groupingLevelOption: 'groupingLevelOption3',
            },
        ];
    }

    function normalizePersistedAdHocDonutGroupings(control, mergedOptions) {
        if (!control) {
            return;
        }

        // Donut uses grouping1/2/3, not grouping. Normalizing with the default chart field
        // map clears groupingLevelOption and drops ring-1 ad-hoc bindings on save.
        getDonutGroupingFieldSets().forEach(function (fields) {
            const groupingValue = control[fields.grouping];
            const groupingLevelOption = control[fields.groupingLevelOption];
            const isAdHocGrouping = groupingValue === 'Ad Hoc Grouping'
                || groupingValue === AD_HOC_GROUPING_CALCULATION_NAME
                || (groupingLevelOption && groupingLevelOption.$type === 'adhoc-guid');

            if (!isAdHocGrouping) {
                return;
            }

            const fieldMap = {
                grouping: fields.grouping,
                groupingLabel: fields.groupingLabel,
                groupingOption: fields.groupingOption,
            };
            const resolvedOption = resolveChartGroupingOption(control, mergedOptions, fieldMap);
            if (!resolvedOption) {
                return;
            }

            applyAdHocChartGroupingSelection(control, resolvedOption, fieldMap);
        });
    }

    function normalizeAdHocGroupingInControl(control, mergedOptions) {
        if (!control) {
            return;
        }

        if (Array.isArray(control.controls)) {
            control.controls.forEach(function (subControl) {
                normalizeAdHocGroupingInControl(subControl, mergedOptions);
            });
        }

        switch (control.$type) {
            case 'rcColumnGroupingTable':
                (control.rowGroupings || []).forEach(function (rowGrouping) {
                    self.setGroupingOptionNameAndValue(rowGrouping);
                    normalizePersistedAdHocGroupingLevel(rowGrouping, mergedOptions);
                });
                self.setGroupingOptionNameAndValue(control.columnGrouping);
                normalizePersistedAdHocGroupingLevel(control.columnGrouping, mergedOptions);
                break;

            case 'rcGroupingTable':
                (control.groupings || []).forEach(function (grouping) {
                    self.setGroupingOptionNameAndValue(grouping);
                    normalizePersistedAdHocGroupingLevel(grouping, mergedOptions);
                });
                break;

            case 'rcGroupingPie':
            case 'rcColumnChart':
            case 'rcGroupingActivityLine':
                normalizePersistedAdHocChartGrouping(control, mergedOptions);
                break;

            case 'rcGroupingActivityDonut':
                normalizePersistedAdHocDonutGroupings(control, mergedOptions);
                break;

            default:
                break;
        }
    }

    function syncGroupingLevelsInReport(report) {
        if (!report || !report.schema) {
            return;
        }

        normalizeAdHocGroupingInSchema(report.schema);
    }

    function syncGroupingLevelsInCurrentReport() {
        syncGroupingLevelsInReport(internal.report);
    }

    function normalizeAdHocGroupingInSchema(schema) {
        if (!schema) {
            return;
        }

        const mergedOptions = self.getAllGroupingOptions();
        ['header', 'body', 'footer'].forEach(function (section) {
            if (schema[section]) {
                normalizeAdHocGroupingInControl(schema[section], mergedOptions);
            }
        });
    }

    self.applyAdHocChartGroupingSelection = applyAdHocChartGroupingSelection;
    self.resolveChartGroupingOption = resolveChartGroupingOption;
    self.mergeGroupingOptionsWithAdHoc = mergeGroupingOptionsWithAdHoc;

    self.getGroupingOptions = function() {
        return internal.groupingOptionsPromise.then(function() {
            return self.getAllGroupingOptions();
        });
    };

    self.filterByDbeo = function(tagsOrGroups) {
        const placeHolderEntityTypes = ['AssetBased'];

        let enableProspectReporting = false;
        const prosepectDbeoPromise = dbeoService.get('69ENABLEPROSPECTREPORTING').then((dbeoEnableProspect) => (enableProspectReporting = dbeoEnableProspect));

        return tagsOrGroups.then(function(i) {
            return $q.all([prosepectDbeoPromise]).then(function() {
                if (enableProspectReporting) {
                    placeHolderEntityTypes.push('Prospect');
                }
                return i.filter(tag => tag.allowedEntityType.some(type => placeHolderEntityTypes.includes(type)));
            });
        });
    };

    self.filterStaticTagConfigsByAllowedEntityTypes = function(staticTagConfig, currentlySelectedTagPath) {
        return staticTagConfig.path === currentlySelectedTagPath
            || staticTagConfig.allowedEntityTypes.some(x => self.getAllowedEntityTypesForEntityOption().includes(x));
    }

    self.findGroupingOptionByName = function(name) {
        if (name == null || name === '') {
            return null;
        }

        return internal.groupingOptions.find(go =>
            go.name === name
            || go.grouping === name
            || go.value == name);
    }

    self.findGroupingOptionBySelectionKey = function(selectionKey) {
        if (selectionKey == null || selectionKey === '') {
            return null;
        }

        const normalizedKey = normalizeGroupingSelectionKey(selectionKey);

        if (typeof normalizedKey === 'string' && normalizedKey.indexOf('udf-') === 0) {
            const udfDefinitionId = Number(normalizedKey.substring(4));
            return internal.groupingOptions.find(go => go.userDefinedFieldDefinitionId == udfDefinitionId);
        }

        const standardMatch = internal.groupingOptions.find(go =>
            go.userDefinedFieldDefinitionId == null && go.value == normalizedKey);
        if (standardMatch) {
            return standardMatch;
        }

        return internal.groupingOptions.find(go => go.userDefinedFieldDefinitionId == normalizedKey);
    }

    function normalizeGroupingSelectionKey(selectionKey) {
        if (typeof selectionKey === 'number') {
            return selectionKey;
        }

        if (typeof selectionKey === 'string' && selectionKey.indexOf('udf-') === 0) {
            return selectionKey;
        }

        if (typeof selectionKey === 'string' && selectionKey !== '' && !isNaN(selectionKey)) {
            return Number(selectionKey);
        }

        return selectionKey;
    }

    self.normalizeGroupingSelectionKey = normalizeGroupingSelectionKey;

    self.applyUserDefinedFieldGroupingMetadata = function(groupingObject, option, level) {
        if (!groupingObject) {
            return;
        }

        level = level || 1;

        function propertyName(baseName) {
            return level === 1 ? baseName : baseName + level;
        }

        if (!option) {
            delete groupingObject[propertyName('userDefinedFieldDefinitionId')];
            delete groupingObject[propertyName('userDefinedFieldEntity')];
            delete groupingObject[propertyName('userDefinedFieldCode')];
            return;
        }

        if (level === 1) {
            groupingObject.name = option.name;
            groupingObject.value = option.value;
        }

        if (option.userDefinedFieldDefinitionId != null) {
            groupingObject[propertyName('userDefinedFieldDefinitionId')] = option.userDefinedFieldDefinitionId;
            groupingObject[propertyName('userDefinedFieldEntity')] = option.userDefinedFieldEntity;
            groupingObject[propertyName('userDefinedFieldCode')] = option.userDefinedFieldCode;
        } else {
            delete groupingObject[propertyName('userDefinedFieldDefinitionId')];
            delete groupingObject[propertyName('userDefinedFieldEntity')];
            delete groupingObject[propertyName('userDefinedFieldCode')];
        }
    }

    self.getGroupingSelectionKey = function(groupingObject) {
        if (!groupingObject) {
            return null;
        }

        return groupingObject.userDefinedFieldDefinitionId != null
            ? 'udf-' + groupingObject.userDefinedFieldDefinitionId
            : groupingObject.value;
    }

    self.findGroupingOptionByValue = function(value) {
        return self.getAllGroupingOptions().find(go => go.value === value);
    }

    self.setGroupingOptionNameAndValue = function(groupingObject) {
        if (!groupingObject || groupingObject.name) {
            return;
        }

        const mergedOptions = self.getAllGroupingOptions();
        const displayName = getGroupingDisplayName(groupingObject, mergedOptions);
        if (displayName) {
            groupingObject.name = displayName;
        }
    }

    self.getGroupingDisplayName = function(groupingObject) {
        return getGroupingDisplayName(groupingObject, self.getAllGroupingOptions());
    }

    self.setGroupingValuesForCharts = function (control) {
        if (!control) {
            return;
        }

        if (control.$type === 'rcGroupingActivityDonut') {
            const mergedOptions = self.getAllGroupingOptions();
            const donutGroupingFieldSets = [
                {
                    grouping: 'grouping1',
                    groupingLabel: 'groupingLabel1',
                    groupingOption: 'groupingOption1',
                },
                {
                    grouping: 'grouping2',
                    groupingLabel: 'groupingLabel2',
                    groupingOption: 'groupingOption2',
                },
                {
                    grouping: 'grouping3',
                    groupingLabel: 'groupingLabel3',
                    groupingOption: 'groupingOption3',
                },
            ];

            if (optionsHelper && typeof optionsHelper.resolveChartGroupingOption === 'function') {
                donutGroupingFieldSets.forEach(function (fields) {
                    resolveChartGroupingOption(control, mergedOptions, fields);
                });
            } else {
                control.groupingOption1 = mergedOptions.find(function (option) {
                    return option.grouping === control.grouping1 && !option.isAdHoc;
                });
                if (control.groupingOption1) {
                    control.groupingLabel1 = control.groupingOption1.name;
                }

                function resolveGroupingOption(saved, udfDefinitionId) {
                    if (saved == null || saved === '') {
                        return null;
                    }

                    if (udfDefinitionId != null) {
                        return mergedOptions.find(function (option) {
                            return option.userDefinedFieldDefinitionId == udfDefinitionId;
                        });
                    }

                    return mergedOptions.find(function (option) {
                        return !option.userDefinedFieldDefinitionId && option.grouping == saved;
                    }) || mergedOptions.find(function (option) {
                        return option.name === saved;
                    });
                }

                control.groupingOption2 = resolveGroupingOption(control.grouping2, control.userDefinedFieldDefinitionId2);
                if (control.groupingOption2) {
                    control.grouping2 = control.groupingOption2.grouping;
                    control.groupingLabel2 = control.groupingOption2.name;
                } else {
                    control.grouping2 = null;
                    control.groupingOption2 = null;
                    control.groupingLabel2 = null;
                }

                control.groupingOption3 = resolveGroupingOption(control.grouping3, control.userDefinedFieldDefinitionId3);
                if (control.groupingOption3) {
                    control.grouping3 = control.groupingOption3.grouping;
                    control.groupingLabel3 = control.groupingOption3.name;
                } else {
                    control.grouping3 = null;
                    control.groupingOption3 = null;
                    control.groupingLabel3 = null;
                }
            }

            return;
        }

        const mergedOptions = self.getAllGroupingOptions();
        if (optionsHelper && typeof optionsHelper.resolveChartGroupingOption === 'function') {
            resolveChartGroupingOption(control, mergedOptions);
            return;
        }

        control.groupingOption = mergedOptions.find(function (option) {
            return option.grouping === control.grouping && !option.isAdHoc;
        });
        if (control.groupingOption) {
            control.groupingLabel = control.groupingOption.name;
        }
    }

    /**
     * Returns true if the GroupingOption is allowed based on the currently selected run for, false if not.
     *
     * @param {*} groupingOption The grouping option to consider.
     * @param {*} excludedGroupingOptionNames An array of GroupingOption names to exclude from the filter, meaning they will
     * this function will return true if the groupingOption.name is in excludedGroupingOptionNames.
     * @returns
     */
    self.filterGroupingOptionsByAllowedEntityTypes = function(groupingOption, excludedGroupingOptionNames) {
        if (excludedGroupingOptionNames?.length) {
            if (excludedGroupingOptionNames.includes(groupingOption.value)
                || excludedGroupingOptionNames.includes(groupingOption.grouping)
                || excludedGroupingOptionNames.includes(groupingOption.name)) {
                return true;
            }
        }

        return groupingOption.allowedEntityType.some(x => self.getAllowedEntityTypesForEntityOption().includes(x));
    }

    self.filterResolveOptionsByAllowedEntityTypes = function(resolveOption) {
        return resolveOption.allowedEntityTypes.some(x => self.getAllowedEntityTypesForEntityOption().includes(x));
    }

    self.getStaticTagConfigs = function(){
        return $q.all(internal.tagConfigPromises).then(function() {
            return internal.sortededTagConfigs;
        });
    };

    self.getStaticTagConfig = function(key){
        const staticOption = internal.staticTagConfigs.fnFind(function(o) { return key === o.key; });

        if(staticOption) {
            return staticOption;
        }

        for (const prop in internal.dynamicTagConfigs) {
            //optional check for properties from prototype chain
            if (internal.dynamicTagConfigs.hasOwnProperty(prop)) {
                const dynamicOption = internal.dynamicTagConfigs[prop].fnFind(function(o) { return key === o.key; });
                if(dynamicOption) {
                    return dynamicOption;
                }
            }
        }

        const dynamicParents = internal.staticTagConfigs.filter(function(o){return o.$type === 'option-value';});

        const optionTypes = Array.from(dynamicParents, function(i){return i.key.replace('.', '\\.');}).join("|");
        const optionRegex = new RegExp('^(?<staticKey>('+optionTypes+'))\\.\\d+$', 'i');
        const matched = optionRegex.exec(key);

        if(matched){
            //this tag is for a dynamic tag that doesn't exist, just return the static tag that backs it
            return self.getStaticTagConfig(matched.groups["staticKey"]);
        }

        console.log('null from getStaticTagConfigs', key);
        debugger; //this should never be hit. If it does we've got a problem that has to be fixed
    };

    self.fullGroupingOptions = internal.groupingOptions;
    self.groupingOptions = [];
    self.weightedBenchmarkGroupingOptions = [];
    self.assetBasedGroupingOptions = [];
    self.limitOptions = [ 'None', 'Count', 'Threshold' ];
    self.disableControls = false;
    self.taxInceptionTypes = ['Cost Basis', 'Beginning Market Value', 'Tax-Neutral Benchmark'];
    self.costPerShareMethods = ['Valuation Price', 'Percentage of Par'];
    self.allowedEntityTypesMap = {
        "Database": ["AssetBased"],
        "Representative": ["AssetBased"],
        "Household": ["AssetBased"],
        "Registration": ["AssetBased"],
        "Account": ["AssetBased"],
        "Portfolio Group": ["AssetBased"],
        "Product": ["AssetBased"],
        "Aggregate Model": ["AssetBased"],
        "Prospect": ["Prospect"]
    };

    // PRIVATE METHODS
    function isAdHocListOption(option) {
        if (optionsHelper && typeof optionsHelper.isAdHocListOption === 'function') {
            return optionsHelper.isAdHocListOption(option);
        }

        return !!(option && option.isAdHoc);
    }

    function Report(data) {
        const report = this;

        Object.defineProperties(report, {
            requiredOptions: {
                get: function() {
                    return report.options.map(function(group){return group.options.fnFind(function(o){return o.isRequired && !isAdHocListOption(o);});}).filter(function(o){return o instanceof Object;});
                },
                set: function(value) {
                    if (!value) return;

                    value.forEach(function(option){
                        option.isRequired = true;
                        setOption(option);
                    });
                }, configurable: false, enumerable: true
            },
            additionalOptions: {
                get: function() {
                    return report.options.map(function(group){
                        const options = group.options.filter(function(o){return !o.isRequired && !isAdHocListOption(o);});
                        if(options.length > 0) {
                            if(!group.category){
                                const map = internal.optionTypes.fnFind(function (t) {
                                    return t.type === group.$type;
                                });

                                if(map){
                                    group.category = map.labels;
                                }
                            }
                            return {category: group.category, $type: group.$type, options: options};
                        }
                    }).compact();
                },
                set: function(value) {
                    if (!value) return;

                    value.forEach(function(group){
                        if(Array.isArray(group.options)) {
                            group.options.forEach(function(option){
                                option.isRequired = false;
                                setOption(option);
                            });
                            if (group.options[0])
                            {
                            const map = report.options.fnFind(function(option){return option.$type === group.options[0].$type;});
                            if(map){
                                map.category = group.category;
                            }
                        }
                        }
                    });
                }, configurable: false, enumerable: true
            },
            options: {
                value: [], configurable: false, writable: false
            },
            registry: {
                value: {}, configurable: false, writable: false
            }
        });

        function setOption(data) {
            if (isAdHocListOption(data)) {
                return data;
            }

            //OC-17141: Adding more thorough option match.
            function optionMatch(first, second) {
                const matchName = (!!first.name && !!second.name && first.name === second.name);
                const matchOptionGuid = (first.optionGuid === second.optionGuid);
                const matchGlobal = (first.isGlobal === second.isGlobal);
                const matchDisabled = (first.isDisabled === second.isDisabled);
                const matchIgnored = (first.isIgnored === second.isIgnored);
                const matchInception = (first.useInception === second.useInception);

                return matchName && matchOptionGuid && matchGlobal && matchDisabled && matchIgnored && matchInception;
            }
            let group = report.options.fnFind(function(option){return option.$type === data.$type;});
            if (!group) {
                group = {$type: data.$type, options: []};
                report.options.push(group);
            }
            let option = group.options.fnFind(
                function(option){
                    return angular.equals(option, data) || option.id === data.id || (optionMatch(option, data));
                }
            );
            if (!option) {
                option = data;
                group.options.push(option);
            } else if(option.id === data.id) { //options with the same name and the id did match.  Can happen when cloning reports.
                for(let prop in data) {
                    option[prop] = data[prop];
                }
            } else { //options with the same name and the id did NOT match.  Can happen when cloning reports.
                const map = internal.getMap(data.$type, true);
                if(map && report.schema && report.schema.contextChange){
                    const requiredOptionId = report.schema.contextChange[map.propertyName];
                    if(requiredOptionId !== data.optionId) {
                        for(let prop in data) {
                            option[prop] = data[prop];
                        }
                        optionsHelper.updateIdAndGuid(map.optionType, report.schema.contextChange, data.optionId, data.optionGuid);
                    }
                }
            }
            return option;
        }

        angular.extend(report, data);
        optionsHelper.sortOptions(report.options);

        return report;
    }

    function Query(data, globalSettings) {
        const query = this;
        query.globalSettings = globalSettings;

        Object.defineProperties(query, {
            options: {
                value: [], configurable: false, writable: false
            }
        });

        function setOption(data) {
            if (isAdHocListOption(data)) {
                return data;
            }

            let group = query.options.fnFind(function(option){return option.$type === data.$type;});
            if (!group) {
                group = {$type: data.$type, options: []};
                query.options.push(group);
            }
            let option = group.options.fnFind(
                function(option){
                    return angular.equals(option, data) || option.id === data.id || (option.name !== undefined && option.name === data.name);
                }
            );
            if (!option) {
                option = data;
                group.options.push(option);
            } else if(option.id === data.id) { //options with the same name and the id did match.  Can happen when cloning queries.
                for(let prop in data) {
                    option[prop] = data[prop];
                }
            } else { //options with the same name and the id did NOT match.  Can happen when cloning queries.
                const map = internal.getMap(data.$type, true);
                if(map){
                    const requiredOptionId = query.schema.contextChange[map.propertyName];
                    if(requiredOptionId !== data.optionId) {
                        for(let prop in data) {
                            option[prop] = data[prop];
                        }
                        query.schema.contextChange[map.propertyName] = data.optionId;
                    }
                }
            }
            return option;
        }

        angular.extend(query, data);

        query.requiredOptions.forEach(function(option){
            option.isRequired = true;
            setOption(option);
        });
        query.additionalOptions.forEach(function(group){
            if(Array.isArray(group.options)) {
                group.options.forEach(function(option){
                    option.isRequired = false;
                    setOption(option);
                });
                const map = query.options.fnFind(function(option){return option.$type === group.options[0].$type;});
                if(map){
                    map.category = group.category;
                }
            }
        });

        optionsHelper.sortOptions(query.options);

        return query;
    }

    Report.prototype.getOption = function (type, originalOptionId) {
        var optionId = String(originalOptionId);
        const map = internal.getMap(type);

        //options need to come from a cached version and not a function call
        const foundOptions = this.options.find(option => option.$type === map.type);
        let options = foundOptions ? foundOptions.options : [];

        let requiredId = String(internal.report.schema && internal.report.schema.contextChange ? internal.report.schema.contextChange[map.propertyName] : '0'),
            required = null;

        var found = options.fnFind(function (option) {
            const id = String(option.optionId);
            if (id === requiredId) {
                required = option;
            }
            return String(option.optionId) === optionId;
        });

        return found || required || options[0];
    };

    Query.prototype.getOption = function (type, originalOptionId) {
        var optionId = String(originalOptionId);
        const map = internal.getMap(type);
        let options = null,
            requiredId = null,
            required = null;
        if(map.getOptions){
            options = map.getOptions();
        }else{
            options = (internal.query.options.fnFind(function(option){return option.$type === map.type;})||{}).options || [];
        }
        return (
            options.fnFind(function(option){
                const id = String(option.optionId);
                if(id === requiredId) { required = option; }
                return String(option.optionId) === optionId;
            }) || required || options[0]
        );
    };



    function getReportCategoryDefault(type, options){
        const globalMatches = (self.getScope().globalSettings || []).filter(o => o.optionType === type);

        if (globalMatches){
            const globalDefault = globalMatches.find(go => go.isDefault);

            return options.find(o => o.optionId === globalDefault.id);
        }else{
            return options.find(o => o.optionId === 0);
        }
    }

    function getDefault(type, path) {
        const map = internal.getMap(type);

        let requiredOptionId;
        let adHocDefaultGuid = null;

        path = path || [];

        const baseDocument = internal.report ? internal.report : internal.query;
        path.push(baseDocument.schema);
        path.some(function(control) {
            const context = control.contextChange || control;
            if (angular.isNumber(requiredOptionId = context[map.propertyName])) {
                return true;
            }

            // An ad hoc default has no option id; it is stored as an adhoc-guid reference instead.
            const guidRef = map.globalPropertyName && context[map.globalPropertyName];
            if (guidRef && guidRef.$type === 'adhoc-guid' && guidRef.adhocOptionGuid) {
                adHocDefaultGuid = guidRef.adhocOptionGuid;
                return true;
            }

            return false;
        });

        const options = getOptions(type) || [];

        if (adHocDefaultGuid) {
            // Report runs resolve an ad hoc default to its default child, so that is the effective default here too.
            const childGuid = (optionsHelper.getAdHocDefaultChildGuid(adHocDefaultGuid) || '').toLowerCase();
            const child = childGuid && options.fnFind(function(option) {
                return !option.isAdHoc && (option.guid || option.optionGuid || '').toLowerCase() === childGuid;
            });
            if (child) {
                return child;
            }
        }

        let required = options.fnFind(function(option) {
            return option.optionId === requiredOptionId;
        });

        const reportCategoryNotDefined = type === 'report-category' && !required;
        if (reportCategoryNotDefined){
            required = getReportCategoryDefault(type, options);
        }

        if (required) {
            setIsRequired(required, true);
            return required;
        }

        return options.find(o => o.isDefault) || options[0];
    }

    function getOptions(type) {
        const map = internal.getMap(type);
        const globalSettings = internal.query ? internal.query.globalSettings : self.getScope().globalSettings;
        let globalMatches = (globalSettings || []).filter(o => o.optionType === type);

        if (map.getOptions) {
            return map.getOptions();
        }

        const baseDocument = internal.report ? internal.report : internal.query;
        let baseSettings = {};
        let optionIndex = -1;
        if (baseDocument && baseDocument.options) {
            optionIndex = baseDocument.options.findIndex(option => option.$type === map.type);
            const tmpBaseSettings = optionIndex > -1 ? baseDocument.options[optionIndex] : null;
            baseSettings = tmpBaseSettings || {};
        }

        // if this is a query then filter out the options in globalMatches that already exist in baseSettings.options
        if (internal.query && baseSettings.options) {

            if (type === 'date-range') {
                baseSettings.options = globalMatches;
            } else {
                const baseSettingIds = baseSettings.options.map(b => b.optionId);
                globalMatches = globalMatches.filter(gm =>
                    !baseSettingIds.includes(Math.abs(gm.id)));
            }
        }

        return optionsHelper.combineOptions(
            baseSettings.options,
            globalMatches,
            optionsHelper.filterAdHocSettingsByOptionType(type)
        );
    }

    function setIsRequired (option, isRequired) {
        delete option.prompt;
        option.isRequired = isRequired;
        if (option.$type === 'daterange' && isRequired) option.prompt = 'Always';
    }

    self.getTypeFormat = function (type) {
        const formatMap = internal.typeFormats.fnFind(function (f) {
            return f.type === type;
        });
        if (formatMap) {
            return formatMap.format;
        }
    };

    function getReportBody(){
        if(!internal.report || !internal.report.schema) {
            return;
        }

        let body = internal.report.schema;
        if (internal.report.schema.body){
            body = internal.report.schema.body;
        }

        return body;
    }

    function mapStoredBenchmarkOption(benchmark) {
        if (!benchmark.type && benchmark.entity) {
            benchmark.type = benchmark.entity.substring(0, 1);
            benchmark.id = benchmark.entityId;
            benchmark.key = `${benchmark.id}_${benchmark.type}`;
            delete benchmark.entity;
            delete benchmark.entityId;
        }
    }

    function cleanBenchmarkOption(option) {
        if (option.hasOwnProperty("benchmarks") && option.benchmarks) {
            option.benchmarks.forEach(b => {
                mapStoredBenchmarkOption(b);
            });
        }

        if (option.hasOwnProperty("marketBenchmark") && option.marketBenchmark) {
            mapStoredBenchmarkOption(option.marketBenchmark);
        }

        if (option.hasOwnProperty("riskFreeBenchmark") && option.riskFreeBenchmark) {
            mapStoredBenchmarkOption(option.riskFreeBenchmark);
        }
    }

    function cleanHistoryReport(storedReport) {
        storedReport.additionalOptions.forEach(cat => {
            cat.options.filter(o => o.$type && o.$type.indexOf('-stored') >= 0).forEach(o => {

                o.$type = o.$type.replace(/-stored/g, '');

                cleanBenchmarkOption(o);
            });
        });

        return {
            schema: storedReport.schema,
            additionalOptions: storedReport.additionalOptions,
            requiredOptions: storedReport.requiredOptions
        };
    }

    self.setupReportFromRestore = function (reportData) {
        const cleanedHistory = cleanHistoryReport(reportData);

        self.setReport({...internal.report, ...cleanedHistory});

        self.recursiveProcess(internal.report, true);

        // Refresh the list of dynamic tags once we load a new report
        internal.staticTagConfigs.forEach(function (config) {
            if (config.$type === 'option-value') {
                updateDynamicPlaceholders(config);
                self.getScope().$broadcast(internal.eventNames.dynamicNameChange, angular.copy(config));
                addDynamicTagChangeEvent(config);
            }
        });

        return internal.report;
    };

    //PUBLIC METHODS
    self.getReport = function (isNew, rptId, isTemplate, expand) {
        const route = `/Reporting/${isTemplate ? 'ReportTemplates' : 'Envision/Reports'}/Verbose/`;

        internal.rptPromise = $q.when(internal.resolveOptionsPromise).then(function() {
            return $http.get(route + (isNew ? 'New' : (rptId + '?expand=' + (expand ? expand : 'all' ))), {

                trackerMsg: 'Loading report'
            });
        }).then(function(response) {
            self.setReport(response.data);

            if( !isNew ) {
                self.recursiveProcess( internal.report, true );
            }

            // Refresh the list of dynamic tags once we load a new report
            internal.staticTagConfigs.forEach(function(config){
                if(config.$type === 'option-value'){
                    updateDynamicPlaceholders(config);
                    self.getScope().$broadcast(internal.eventNames.dynamicNameChange, angular.copy(config));
                    addDynamicTagChangeEvent(config);
                }
            });

            return self.getGroupingOptions().then(function () {
                syncGroupingLevelsInCurrentReport();
                return internal.report;
            });
        });
        return internal.rptPromise;
    };

    function DummyReport() {
        const dummy = this;

        dummy.schema = {
            contextChange: {}
        };

        return dummy;
    }

    DummyReport.prototype.getOption = function () {
        // Dummy Get Option only to prevent exceptions
    };

    self.addGlobalPlaceholders = function (globalOptions) {
        self.getScope().globalSettings = globalOptions;

        internal.rptPromise = $q.when([]).then(function() {
            if(!internal.report) {
                internal.report = new DummyReport();
            }

            internal.staticTagConfigs.filter(stc => stc.$type === 'option-value').forEach(config => {
                const optionMap = internal.getMap(config.optionType);
                optionsHelper.addPlaceholdersForGlobals(config, globalOptions, internal.dynamicTagConfigs, optionMap, internal.typeFormats);
            });
            updateSortededTagConfigs();

            return internal.report;
        });
    };

    self.refreshOptions = function(isForSync = false){
        internal.optionTypes.forEach(function(map){
            self.getScope().$broadcast(internal.optionEventName(map.optionType), isForSync);
        });
    };

    self.updateOptions = function(options, optionType){
        self.getScope().$broadcast("rb-event:update-global-settings", {type:optionType, options:options});
    };

    self.getSubReport = function (isNew, rptId, expand) {
        internal.rptPromise = $q.when(internal.resolveOptionsPromise).then(function() {
            return $http.get('/Reporting/Envision/Fragments/Verbose/Edit/' + (isNew ? 'New' : (rptId + '?expand=' + (expand ? expand : 'all' ))), {

                trackerMsg: 'Loading Sub-Report'
            });
        }).then(function(response) {
            self.setSubReport(response.data);

            if( !isNew ) {
                self.recursiveProcess( internal.report, true );
            }

            // Refresh the list of dynamic tags once we load a new report
            internal.staticTagConfigs.forEach(function(config){
                if(config.$type === 'option-value'){
                    updateDynamicPlaceholders(config);
                    self.getScope().$broadcast(internal.eventNames.dynamicNameChange, angular.copy(config));
                    addDynamicTagChangeEvent(config);
                }
            });

            internal.optionTypes.forEach(function(map){
                self.getScope().$broadcast(internal.optionEventName(map.optionType));
            });

            return self.getGroupingOptions().then(function () {
                syncGroupingLevelsInCurrentReport();
                return internal.report;
            });
        });
        return internal.rptPromise;
    };

    self.getCurrentReport = function () {
        const baseDocument = internal.report ? internal.report : internal.query;
        return baseDocument;
    };

    self.getGlobalSettings = function () {
        return internal.$scope.globalSettings;
    };

    self.getScope = function() {
        return internal.$scope || $rootScope;
    };

    self.setScope = function(scope) {
        internal.$scope = scope;

        internal.eventListeners.forEach(function(event){
            internal.$scope.$on(event.name, event.callback);
        });
    };

    self.initScope = function(scope, disableControls) {
        self.disableControls = disableControls;

        scope.reportCenterStyle = {};
        scope.reportStyle = {};
        scope.headerStyle = {};
        scope.footerStyle = {};
        scope.style = {};

        //don't return prompt or dateRangeArray options for the Options Map. This will prevent them from appearing in RB3.
        scope.fullOptions = self.getFullOptions();
    };

    self.reportCopySubReportData = function(data, reportCopy){
        data = reportCopyService.reportCopySetData(data, reportCopy);

        return data;
    };

    self.$broadcast = function(eventName, data) {
        let body = getReportBody();

        if (body && body.$broadcast){
            body.$broadcast(eventName, data);
        }
    };

    self.$on = function(eventName, callback) {
        let body = getReportBody();

        if (body && body.$on){
            body.$on(eventName, callback);
        }
    };

    self.setReport = function (report) {
        internal.report = !report ? undefined : new Report(report);

        internal.setReportCallbacks.forEach(function(callback){
           callback(internal.report);
        });
    };

    self.setSubReport = function (report) {
        internal.report = !report ? undefined : new Report(report);

        internal.setReportCallbacks.forEach(function(callback){
            callback(internal.report);
        });
    };

    self.$onSetReport = function(callback){
        internal.setReportCallbacks.push(callback);
    };

    self.getDefault = function(type, path){
        return internal.rptPromise
            .then(function(report){
                return getDefault(type, path);
            });
    };

    self.setDefault = function (type, defaultOption) {
        if(!defaultOption) {
            throw new Error("defaultOption must be provided");
        }

        getOptions(type).forEach(function(o){
            setIsRequired(o, defaultOption === o);
        });
        self.getScope().$broadcast(internal.defaultEventName(type));
    };

    self.getOption = function (type, optionId) {
        return internal.rptPromise
            .then(function (report) {
                return report.getOption(type, optionId);
            });
    };

    self.getOptions = function (type, immediate) {
        if(immediate){
            return getOptions(type);
        }
        if(internal.rptPromise === undefined) {
            return $q(function (resolve, reject) {
                try {
                    if (internal.report === undefined && internal.query === undefined) {
                        //there isn't a report, probably this is the cover page
                        resolve([]);
                    } else {
                        const options = getOptions(type);
                        resolve(options);
                    }
                } catch (e) {
                    //no options, return empty array?
                    reject("Could not get options");
                }
            });
        }
        return internal.rptPromise
            .then(function (report) {
                return getOptions(type);
            });
    };

    self.setOptions = function (type, newOptions) {
        if(!newOptions){
            throw new Error("new options must be provided");
        }
        let defaultChanged = false;
        const map = internal.getMap(type);
        const persistableOptions = newOptions.filter(function(option) {
            return !isAdHocListOption(option);
        });
        const newSortedOptions = angular.copy(persistableOptions).sort(function(a, b) {
            return a.name.localeCompare(b.name, 'en', {sensitivity: 'base', numeric: true});
        });

        if(newSortedOptions.length && !newSortedOptions.any(function(option){
            return option.isRequired || option.isDefault;
        })){
            //no default found, mark the first one in the list as default
            const newDefaultItem = newSortedOptions[0];
            setIsRequired(newDefaultItem, true);
            if (internal.report.schema.contextChange){
                internal.report.schema.contextChange[map.propertyName] = newDefaultItem.optionId;
            }
            defaultChanged = true;
        }

        let group = internal.report.options.fnFind(function(option){ return option.$type === map.type; });
        if (!group) {
            group = {$type: map.type, options: []};
            internal.report.options.push(group);
        }
        group.options = newSortedOptions;

        self.getScope().$broadcast(internal.optionEventName(type));
        if(defaultChanged){
            self.getScope().$broadcast(internal.defaultEventName(type));
        }
    };

    self.getExpandedOptions = function(optionNames){
        const options = [];
        if(optionNames){
            optionNames.forEach(function(optionName){
                let option = internal.optionTypes.fnFind(function(o){
                    return o.optionName === optionName;
                });
                if(option){
                    option = angular.copy(option);
                    option.edit = optionName !== 'ReportCategory';
                    options.push(option);
                }
            });
        }
        return options;
    };

    self.getOptionsMap = function () {
        return internal.optionTypes;
    };

    self.getFullOptions = function (){
        return optionsHelper.getFullOptions();
    };

    self.getOptionsMatch = function (matches) {
        const matchedOptions = [];
        return internal.rptPromise
            .then(function (report) {
                for (let prop in matches) {
                    if (matches.hasOwnProperty(prop)) {
						const map = internal.optionTypes.fnFind(function (t) { return t.propertyName.localeCompare(prop) === 0; });

                        if(map) {
                            const options = (internal.report.options.fnFind(function(option){return option.$type === map.type})||{}).options;
                            if(options){
                                options.forEach(function(o){
                                    if(matches[prop].includes(o.optionId)){
                                        matchedOptions.push(o);
                                    }
                                });
                            }
                        }
                    }
                }

                return matchedOptions;
            });
    };

    function findOptionCategory(option) {
        let category = internal.report.options.fnFind(function(o) {
            return o.$type === option.$type;
        });

        if (!category) {
            category = { $type: option.$type, options: [] };
            internal.report.options.push(category);
        }
        return category;
    }

    self.prepareFragmentForAdd = function (fragment) {
        //need to merge the options into the report
        let matchedOptions = [];
        let newOptionCreated = [];

        if(fragment?.referencedOptions?.length > 0){
            const newOptions = self.addFragmentReferencedOptions(fragment);
            newOptionCreated = newOptions[0];
            matchedOptions = newOptions[1];
        }

        if(fragment?.portfolio && fragment.schema){
            fragment.schema.isDynamic = fragment.portfolio?.isDynamic;
        }

        let allOptions = optionsHelper.getFragmentOptions(fragment);

        if(fragment?.referencedOptions?.length < 1 && (!allOptions || allOptions.length < 1)) {
            return $q.when(fragment);
        }

        allOptions.forEach(function (option) {
            if (isAdHocListOption(option)) {
                return;
            }

            if (option.calculation) {
                //need to update the calculation before comparing
                option.calculation = optionsHelper.updateString(option.calculation, matchedOptions);
            }
            let category = findOptionCategory(option);

            let newId = null;
            category.options.forEach(function (o) {
                if (newId === null) {
                    if (optionsHelper.optionsMatch(o, option)) {
                        newId = o.optionId;
                    }
                }
            });

            const map = internal.getMap(option.$type);

            if (newId === null) {
                newId = optionsHelper.getNewLocalId(category.options);

                const newOption = angular.copy(option);
                newOption.optionId = newId;
                const re = /(\w+\s)(\d+)/;
                newOption.id = option.id.replace(re, '$1' + newId);

                optionsHelper.setNewLocalName(category.options, newOption);

                category.options.push(newOption);
                category.options = category.options.sort(function (a, b) {
                    return a.name.localeCompare(b.name, 'en', {sensitivity: 'base', numeric: true});
                });

                //track the kind of option, so we can broadcast it later
                newOptionCreated.push(map.optionType);
            }

            matchedOptions.push({
                propertyName: map.propertyName,
                oldId: option.optionId,
                newId: newId,
                newGuid: option.optionGuid
            });
        });

        optionsHelper.updateMappedIdsToArray(matchedOptions);

        //if any options were created above we need to broadcast the change. Do it after all of them have been made so we don't broadcast the same kind of change if 2+ options were created.
        newOptionCreated.unique().forEach(function (t) {
            self.getScope().$broadcast(internal.optionEventName(t));
        });

        //remove any matches that aren't making changes
        matchedOptions = matchedOptions.filter(function (remap) {
            return remap.oldId !== remap.newId
        });
        optionsHelper.updateProperties(fragment, matchedOptions);

        return $q.when(fragment);
    };

    self.addFragmentReferencedOptions = function(fragment) {

        let newOptions = [];
        let updatedOptions = [];
        (fragment.referencedOptions || []).forEach(function (referencedOption) {
            const referencedType = referencedOption.option && referencedOption.option.$type;

            if (optionsHelper.isAdHocReferencedOptionType(referencedType)) {
                const refreshType = optionsHelper.registerReferencedAdHocSetting(referencedOption);

                if (refreshType) {
                    newOptions.push(refreshType);
                }

                return;
            }

            if (isAdHocListOption(referencedOption.option)) {
                return;
            }

            const map = internal.getMap(referencedOption.option.$type);
            const options = self.getOptions(map.optionType, true);
            const existingOption = options.find((o) => o.optionGuid === referencedOption.optionGuid);
            const oldId = optionsHelper.prepareReadOnlyOption(referencedOption.option, options);
            if (!existingOption) {

                updatedOptions.push({
                    propertyName: map.propertyName,
                    oldId: oldId,
                    newId: referencedOption.option.optionId,
                    newGuid: referencedOption.optionGuid
                });

                options.push(referencedOption.option);
                self.setOptions(referencedOption.option.$type, options);
                newOptions.push(map.optionType);
            } else {
                updatedOptions.push({
                    propertyName: map.propertyName,
                    oldId: oldId,
                    newId: existingOption.optionId,
                    newGuid: existingOption.optionGuid
                });
            }
        });

        return [newOptions, updatedOptions];
    };

    self.recursiveProcess = function(obj, isPreProcess) {
        for( let p in obj ) {
            if( obj[p] instanceof Object && obj[p] !== null ) {
                self.recursiveProcess(obj[p], isPreProcess);
            } else {
                if( p === "otherThreshold" ) {
                    if( isPreProcess ) {
                        obj[p] = obj[p] * 100.0;
                    } else {
                        obj[p] = obj[p] / 100.0;
                    }
                }
            }
        }
    };

    self.getMap = internal.getMap;
    self.reportStyle = {};

    self.prepareForSave = function (reportSchema) {
        if (!reportSchema || !reportSchema.schema) {
            return indexCleanUp(reportSchema)
        }

        reportSchema.schema = SimpleTableEditorConversionService.convertSimpleTableToGroupingTable(reportSchema.schema, internal.staticTagConfigs);
        normalizeAdHocGroupingInSchema(reportSchema.schema);

        return indexCleanUp(reportSchema)
    };

    self.reportPrepareForSave = function (schema) {
        if (schema?.controls) {
            schema.controls.forEach(function (control) {
                control = SimpleTableEditorConversionService.convertSimpleTableToGroupingTable(control, internal.staticTagConfigs);
                stripChartControlsForSave(control);
            });
        }

        normalizeAdHocGroupingInControl(schema, self.getAllGroupingOptions());

        return indexCleanUp(schema)
    };

    function indexCleanUp(schema) {
        //remove all the $index properties from inside string resolvers so if the saved element is added back to the report it won't linked to the original string resovler.
        const regex = /\\"\$index\\":\\"[^\s"]+\\",/gi;
        let json = JSON.stringify(schema);
        json = json.replace(regex, '');
        return JSON.parse(json);
    }

    self.setReportStyle = function(reportStyle){
        self.reportStyle = reportStyle;
        self.getScope().$broadcast(internal.eventNames.reportStyle, reportStyle);
    };

    self.getQuery = function (isNew, rptId, expand, globalSettings) {
        internal.rptPromise = $q.when(internal.resolveOptionsPromise).then(function() {
            return $http.get('/Reporting/Envision/ExcelReports/Verbose/' + (isNew ? 'New' : (rptId + '?expand=' + (expand ? expand : 'all' ))), { trackerMsg: 'Loading query' });
        }).then(function(response) {
            self.setQuery(response.data, globalSettings);

            if( !isNew ) {
                self.recursiveProcess( internal.query, true );
            }

            internal.optionTypes.forEach(function(map){
                self.getScope().$broadcast(internal.optionEventName(map.optionType));
            });

            return internal.query;
        }, function() {
            window.location.href = '#/reports/dataqueries/querybuilder';
        });
        return internal.rptPromise;
    };

    self.setQuery = function (query, globalSettings) {
        internal.query = !query ? undefined : new Query(query, globalSettings);

        internal.setReportCallbacks.forEach(function(callback){
            callback(internal.query);
        });
    };

    self.hoverControl = function (event) {
        var control = getControlFromEvent(event);
        var ignoreHover = (!control || control.$type === 'rcSplitter');

        if(self.current.hovered !== control && !ignoreHover) {
            self.current.hovered = control;
            self.getScope().$apply();
        }

        return self.current.hovered;
    };

    self.selectControl = function (event) {
        var control = getControlFromEvent(event);
        ReportControlHelperService.selectControl(control, getReportBody());
        return self.current.selected = control;
    };

    self.isHovered = function(control) { return control.$index === self.current.hovered?.$index; };
    self.isSelected = function(control) { return control.$index === self.current.selected?.$index; };

    function isControlFake(control) {
        return control !== undefined && control.$type === 'rcSplitter' && control.controls && control.controls.length === 1;
    }


    self.getControlFromScope = function(scope) {
        if(scope) return scope.control || self.getControlFromScope(scope.$parent);
    };

    function getControlFromEvent(event) {
        var node = event.target;
        var index, control;
        while (node && !index) {
            index = node.getAttribute('data-registry');
            if(index) {
                control = self.getControl(index);
                if(!isControlFake(control)) {
                    return control;
                }
            }
            node = node.parentElement;
        }
    }


    // Used to create unique, deterministic hash from string
    // Found here: https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
    function cyrb53(str, seed = 0) {
        let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
        for (let i = 0, ch; i < str.length; i++) {
            ch = str.charCodeAt(i);
            h1 = Math.imul(h1 ^ ch, 2654435761);
            h2 = Math.imul(h2 ^ ch, 1597334677);
        }
        h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
        h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
        return 4294967296 * (2097151 & h2) + (h1 >>> 0);
    }

    function removeControlProperties(key, value) {
        if (key === "$index") {
            return undefined;
        }

        return value;
    }

    self.buildTestId = function (control) {
        return `${control.$type}-${cyrb53(JSON.stringify(control, removeControlProperties))}`;
    };

    self.makeKey = function() {
        const S4 = function() {
            return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
        };
        return Date.now()+"-"+S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4();
    };

    self.setDisableControls = function(control) {
        if (control.controls && control.isDynamic) {
            if (!!control.id && !control.isInSubReport) {
                control.subReportWrapper = true;
            }

            control.controls.each(c => {
                c.isInSubReport = true;
                if(c.$type === 'rcReportPdf'){
                    control.topLevelOnly = true;
                }
                c.disabled = true;
                if(c.controls){
                    disableChildren(c.controls);
                }
            });
        }
    };

    function disableChildren(controls){
            controls.each(c => {
            c.isInSubReport = true;
            c.disabled = true;
            if(c.controls){
                disableChildren(c.controls);
            }
        });
    }

    self.topLevelOnlyControl = function (control) {
        if (control.$type === 'rcReportPdf') {
            return true;
        }

        if (control.controls) {
            return control.controls.some(c => c.$type === 'rcReportPdf');
        }

        return false;
    }

    self.registerControl = function(control) {
        if (internal.report && !control.$index) {
            control.$index = self.makeKey();
            control.testId = self.buildTestId(control);
            control.topLevelOnly = self.topLevelOnlyControl(control);

            if (self.disableControls) {
                self.setDisableControls(control);
            }

            internal.report.registry[control.$index] = control;
        }
    };

    self.getControl = function(index) {
        if(internal.report) return internal.report.registry[index];
    };

    self.getViewport = function() {
        return document.body.querySelector('.report-builder-bg');
    };

    function searchTree(tree, selector, path = []) {
        let matchFn = selector instanceof Function ? selector : (i) => selector === i;
        let result;
        if (matchFn(tree)) {
            return { item: tree, path: path.concat(tree) };
        } else if (tree.controls) {
            for (let child of tree.controls) {
                result = searchTree(child, selector, path.concat(tree));
                if(result) return result;
            }
        }
    }

    self.searchTree = searchTree;

    /**
     * Determines whether all tags on the report are valid for the currently selected run for options.
     *
     * @param {*} reportSchema The full schema of the report.
     * @returns true if all tags on the report are allowed for the currently selected run for options, otherwise false.
     */
    self.validateTags = function(reportSchema) {
        const entityOption = internal.report ? internal.report.requiredOptions.find(x => x.$type === 'select-entity') : null;
        const entity = entityOption ? entityOption.entity : null;

        if (!entity) return true;

        const regexForMatchingTagPaths = new RegExp('path\\\\":\\\\"(?<pathName>\\w+.\\w+)', 'gi');
        const matches = JSON.stringify(reportSchema, null, 0).matchAll(regexForMatchingTagPaths);

        for (const match of matches) {
            var tagInfo = internal.staticTagConfigs.find((staticTag) => staticTag.path === match.groups.pathName);

            if (!tagInfo.allowedEntityType.some(x => self.getAllowedEntityTypesForEntityOption().includes(x))) {
                return false;
            }
        }

        return true;
    };

    self.validateGroupings = function(reportSchema) {
        const groupingOptionsOfReport = self.traverseReportSchema(reportSchema);

        for (const groupingOption of groupingOptionsOfReport) {
            var groupingOptionInfo = internal.groupingOptions.find(x => x.name === groupingOption);

            if (groupingOptionInfo && !groupingOptionInfo.allowedEntityType.some(x => self.getAllowedEntityTypesForEntityOption().includes(x))) {
                return false;
            }
        }

        return true;
    };

    self.traverseReportSchema = function(reportSchema) {
        const groupingOptionsOfReport = [];

        self.traverseFromControl(reportSchema.header, groupingOptionsOfReport);
        self.traverseFromControl(reportSchema.body, groupingOptionsOfReport);
        self.traverseFromControl(reportSchema.footer, groupingOptionsOfReport);

        return groupingOptionsOfReport;
    };

    self.traverseFromControl = function(control, groupingOptionsOfReport) {
        control.controls?.forEach(subControl => {
            self.traverseFromControl(subControl, groupingOptionsOfReport);
        });

        switch (control.$type) {
            case "rcGroupingTable":
                for (const grouping of control.groupings) {
                    groupingOptionsOfReport.push(grouping.name);
                }
                break;

            case "rcColumnGroupingTable":
                groupingOptionsOfReport.push(control.columnGrouping.name);
                for (const rowGrouping of control.rowGroupings) {
                    groupingOptionsOfReport.push(rowGrouping.name);
                }
                break;

            case "rcGroupingActivityDonut":
                groupingOptionsOfReport.push(control.grouping1);
                groupingOptionsOfReport.push(control.grouping2);
                break;

            case "rcGroupingPie":
            case "rcColumnChart":
            case "rcGroupingActivityLine":
                groupingOptionsOfReport.push(control.grouping);
                break;

            default:
                break;
        }
    };

    /**
     * Returns the allowedEntityTypes for the selected run for options. If there is no run for, then it will return
     * all entityTypes implying that all tags are allowed.
     *
     * @returns An arry of the allowedEntityTypes for the selected run for option.
     */
    self.getAllowedEntityTypesForEntityOption = function() {
        const requireOptions = internal.report && internal.report.requiredOptions;
        const entityOption = requireOptions ? internal.report.requiredOptions.find(x => x.$type === 'select-entity') : null;
        const entity = entityOption ? entityOption.entity : null;

        if (!entity) return [...new Set(Object.values(self.allowedEntityTypesMap).flat())];

        return self.allowedEntityTypesMap[entity];
    }

    // EVENTS
    self.$onReportStyleChanged = function (callback) {
        let func = function (event, data) {
            return callback(data);
        };

        internal.eventListeners.push({ name: internal.eventNames.reportStyle, func });
        self.getScope().$on(internal.eventNames.reportStyle, func);
        callback(self.reportStyle);
        ReportStyleService.updateReportStyle(self.reportStyle);
    };

    self.$onDynamicTagChange = function (callback) {
        internal.eventListeners.push({ name: internal.eventNames.dynamicNameChange, callback });
        self.getScope().$on(internal.eventNames.dynamicNameChange, callback);
    };

    self.$onTagConfigChange = function (callback) {
        internal.eventListeners.push({ name: internal.eventNames.tagConfigChange, callback });
        self.getScope().$on(internal.eventNames.tagConfigChange, callback);
    };

    self.$onOptionChange = function (type, callback) {
        self.getScope().$on(internal.optionEventName(type), callback);
    };

    self.$onDefaultChange = function (type, callback) {
        self.getScope().$on(internal.defaultEventName(type), callback);
    };

    self.controlNeedsWrap = function(controlType) {
        return neverWrapControls.none(controlType);
    };

    self.getOptionLabel = function (optionType) {
        return internal.optionTypes.find(ot => ot.optionType === optionType).labels || optionType;
    };

    self.resetTagsAfterRunForChange = function () {
        internal.staticTagConfigs = [];
        crawlPlaceholderHeirarchy(self.originalTags);
    }

    self.sanitizeHTML = function (str) {
        if (!str) {
            return str;
        }

        return str.replace(/[&<>"'/]/ig, function (c) {
            return '&#' + c.charCodeAt(0) + ';';
        });
    };

    self.decodeHtml = function (str) {
        if (!str) {
            return str;
        }

        return str.replace(/&#([0-9]{1,3});/gi, (match, numStr) => {
            const charCode = parseInt(numStr, 10); // read num as normal number
            return String.fromCharCode(charCode);
        });
    }

    self.sanitizeHTMLStringProperties = function (data) {
        Object.keys(data).forEach(key => {
            if (typeof data[key] === "string") {
                data[key] = self.sanitizeHTML(data[key]);
            }
        });
    };

    self.decodeHtmlStringProperties = function (data) {
        Object.keys(data).forEach(key => {
            if (typeof data[key] === "string") {
                data[key] = self.decodeHtml(data[key]);
            }
        });
    };

    self.originalTags = [];

    self.loadSelectedDataSource = function (value, isComparison) {
        self.getScope().$broadcast('rc-event:load-selected-datasource', { key: value, isComparison: isComparison });
    };

    const blockedHtmlTagPattern = /^(?:script|iframe|object|embed|form|meta|link|base)$/i;
    const htmlMarkupPattern = /<\s*\/?\s*[a-zA-Z!/]/;
    const requiresSanitizationPattern = /<\s*\/?\s*(?:script|iframe|object|embed|form|meta|link|base|style)\b|\bon\w+\s*=|(?:javascript|vbscript)\s*:|data\s*:(?!\s*image\/(?:png|jpe?g|gif|webp|bmp|ico|x-icon)(?:[;,]|$))/i;
    const safeDataImageUriPattern = /^data:image\/(?:png|jpe?g|gif|webp|bmp|ico|x-icon)(?:[;,]|$)/i;
    const embeddedUrlSchemePattern = /(?:[\s,;|'"(]|^)(?:javascript|vbscript)\s*:/i;
    const embeddedCssUrlSchemePattern = /url\s*\(\s*['"]?\s*(?:javascript|vbscript)\s*:/i;

    function decodeHtmlCharacterReferences(value) {
        if (typeof value !== 'string' || value.indexOf('&') === -1) {
            return value;
        }

        return value
            .replace(/&#x([0-9a-f]+);/gi, function (_, hex) {
                const code = parseInt(hex, 16);
                return Number.isFinite(code) ? String.fromCharCode(code) : '&#' + hex + ';';
            })
            .replace(/&#(\d+);/g, function (_, num) {
                const code = parseInt(num, 10);
                return Number.isFinite(code) ? String.fromCharCode(code) : '&#' + num + ';';
            });
    }

    function matchesSanitizationPattern(value) {
        return requiresSanitizationPattern.test(value);
    }

    function isSafeDataUri(value) {
        return typeof value === 'string' && safeDataImageUriPattern.test(value.trim());
    }

    function hasDangerousUrlScheme(value) {
        if (typeof value !== 'string') {
            return false;
        }

        const trimmed = value.trim();

        if (/^(?:javascript|vbscript):/i.test(trimmed)) {
            return true;
        }

        if (/^data:/i.test(trimmed)) {
            return !isSafeDataUri(trimmed);
        }

        const urlMatch = /^url\s*\(\s*['"]?([^'")]+)/i.exec(trimmed);
        if (urlMatch) {
            return hasDangerousUrlScheme(urlMatch[1]);
        }

        return false;
    }

    function containsDangerousDataUris(value) {
        const dataUriMatches = value.match(/data\s*:[^;'")\s,]+/gi);

        if (!dataUriMatches) {
            return false;
        }

        for (let i = 0; i < dataUriMatches.length; i++) {
            if (!isSafeDataUri(dataUriMatches[i])) {
                return true;
            }
        }

        return false;
    }

    function containsDangerousUrlContent(value) {
        if (typeof value !== 'string' || value.length === 0) {
            return false;
        }

        if (containsDecodedDangerousUrlContent(value)) {
            return true;
        }

        if (value.indexOf('&') === -1) {
            return false;
        }

        const decoded = decodeHtmlCharacterReferences(value);
        return decoded !== value && containsDecodedDangerousUrlContent(decoded);
    }

    function containsDecodedDangerousUrlContent(value) {
        if (hasDangerousUrlScheme(value)) {
            return true;
        }

        if (embeddedUrlSchemePattern.test(value) || embeddedCssUrlSchemePattern.test(value)) {
            return true;
        }

        return containsDangerousDataUris(value);
    }

    function hasDangerousSrcset(value) {
        if (typeof value !== 'string' || value.length === 0) {
            return false;
        }

        return value.split(',').some(function (candidate) {
            const url = candidate.trim().split(/\s+/)[0];
            return url && containsDangerousUrlContent(url);
        });
    }

    function hasDangerousUrlList(value) {
        if (typeof value !== 'string' || value.length === 0) {
            return false;
        }

        return value.trim().split(/\s+/).some(function (url) {
            return url && containsDangerousUrlContent(url);
        });
    }

    function hasDangerousStyleContent(value) {
        if (typeof value !== 'string') {
            return false;
        }

        if (containsDecodedDangerousStyleContent(value)) {
            return true;
        }

        if (value.indexOf('&') === -1) {
            return false;
        }

        const decoded = decodeHtmlCharacterReferences(value);
        return decoded !== value && containsDecodedDangerousStyleContent(decoded);
    }

    function containsDecodedDangerousStyleContent(value) {
        if (/\bon\w+\s*=/.test(value) || /(?:javascript|vbscript)\s*:/i.test(value) || /expression\s*\(/i.test(value)) {
            return true;
        }

        return containsDangerousDataUris(value);
    }

    function sanitizeStyleBlockContent(css) {
        if (typeof css !== 'string' || css.length === 0) {
            return css;
        }

        let sanitized = css.indexOf('&') !== -1 ? decodeHtmlCharacterReferences(css) : css;

        sanitized = sanitized
            .replace(/(?:javascript|vbscript)\s*:/gi, '')
            .replace(/expression\s*\(\s*[^)]*\)/gi, '')
            .replace(/@import[\s"']*(?:javascript|vbscript)\s*:[^;]*/gi, '')
            .replace(/behavior\s*:\s*url\s*\(\s*['"]?[^'")]*['"]?\s*\)/gi, '')
            .replace(/-moz-binding\s*:\s*[^;]*/gi, '');

        sanitized = sanitized.replace(/data\s*:[^;)'"\s]+/gi, function (match) {
            return isSafeDataUri(match) ? match : '';
        });

        return sanitized;
    }

    function sanitizeStyleElement(element) {
        sanitizeHtmlAttributes(element);

        for (let i = 0; i < element.childNodes.length; i++) {
            const child = element.childNodes[i];

            if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.CDATA_SECTION_NODE) {
                continue;
            }

            const sanitized = sanitizeStyleBlockContent(child.textContent);

            if (sanitized !== child.textContent) {
                child.textContent = sanitized;
            }
        }
    }

    function containsHtmlMarkup(value) {
        return htmlMarkupPattern.test(value);
    }

    function requiresSanitization(value) {
        if (matchesSanitizationPattern(value)) {
            return true;
        }

        if (value.indexOf('&') === -1) {
            return false;
        }

        const decoded = decodeHtmlCharacterReferences(value);
        return decoded !== value && matchesSanitizationPattern(decoded);
    }

    const urlAttributeMarkupPattern = /<\s*[a-z][^>]*\s(?:href|src|srcset|ping|style|action|formaction|background|xlink:href|data)\s*=/i;

    function hasUrlAttributeMarkup(value) {
        return urlAttributeMarkupPattern.test(value);
    }

    function sanitizeHtmlAttributes(element) {
        for (let i = element.attributes.length - 1; i >= 0; i--) {
            const attr = element.attributes[i];
            const name = attr.name.toLowerCase();

            if (name.indexOf('on') === 0) {
                element.removeAttribute(attr.name);
                continue;
            }

            if (name === 'style' && hasDangerousStyleContent(attr.value)) {
                element.removeAttribute(attr.name);
                continue;
            }

            if (name === 'srcset' && hasDangerousSrcset(attr.value)) {
                element.removeAttribute(attr.name);
                continue;
            }

            if (name === 'ping' && hasDangerousUrlList(attr.value)) {
                element.removeAttribute(attr.name);
                continue;
            }

            if (containsDangerousUrlContent(attr.value)) {
                element.removeAttribute(attr.name);
            }
        }
    }

    function sanitizeHtmlTree(root) {
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT);
        const nodesToRemove = [];
        let node = walker.nextNode();

        while (node) {
            if (blockedHtmlTagPattern.test(node.tagName)) {
                nodesToRemove.push(node);
            } else if (node.tagName === 'STYLE') {
                sanitizeStyleElement(node);
            } else {
                sanitizeHtmlAttributes(node);
            }
            node = walker.nextNode();
        }

        for (let i = nodesToRemove.length - 1; i >= 0; i--) {
            nodesToRemove[i].remove();
        }
    }

    function sanitizeHtmlString(html) {
        if (typeof html !== 'string' || html.length === 0) {
            return html;
        }

        if (!containsHtmlMarkup(html)) {
            return html;
        }

        if (!requiresSanitization(html) && !hasUrlAttributeMarkup(html)) {
            return html;
        }

        if (typeof document === 'undefined') {
            return self.sanitizeHTML(html);
        }

        const template = document.createElement('template');
        template.innerHTML = html;
        sanitizeHtmlTree(template.content);
        return template.innerHTML;
    }

    self.convertHtmlToEntities = function (str) {
        if (typeof str !== 'string') {
            return str;
        }

        return sanitizeHtmlString(str);
    }

    self.sanititizeResponse = function (obj) {       
        if(Array.isArray(obj)){
            return obj.map(item => self.sanititizeResponse(item));
        } else if(obj !== null && typeof obj === 'object'){
            Object.keys(obj).forEach(key => {
                obj[key] = self.sanititizeResponse(obj[key]);
            });
            return obj;
        }else{
            return self.convertHtmlToEntities(obj);
        }
    };

    return self;
});

'use strict';

app.factory('reportService', function reportService($http, $q) {
    const self = this;

    self.getNew = function() {
        return $http.get('/Reporting/Envision/Reports/Verbose/New', { trackerMsg: 'Loading report' });
    };

    self.getNewSubReport = function() {
        return $http.get('/Reporting/Envision/Fragments/Verbose/Edit/New', { trackerMsg: 'Loading sub-report' });
    };

    self.getNewExcelReport = function() {
        return $http.get('/Reporting/Envision/ExcelReports/Verbose/New', { trackerMsg: 'Loading query' });
    };

    self.getGlobalSettings = function() {
        return $http.get('/Reporting/Envision/Reports/Settings', { trackerMsg: 'Loading reports global settings' });
    };

    self.saveDefaultSettings = function(defaultSettings) {
        return $http.put('/Reporting/Envision/Reports/Settings/Defaults', defaultSettings, { trackerMsg: 'Saving default settings' });
    };

    self.saveGlobalOptions = function(options, optionType, optionLabel) {
        return $http.post(`/Reporting/Envision/Reports/Settings/Options/${optionType}`, options, { trackerMsg: `Saving ${optionLabel}` });
    };

    self.deleteOption = function(optionGuid) {
        return $http.delete(`/Reporting/Envision/Reports/Settings/${optionGuid}`, {trackerMsg: 'Deleting report setting'});
    };

    self.setRoleData = function(authorization, data) {
        return $http.get('/Security/Roles/' + authorization.roleId, { trackerMsg: 'Loading details for user role' })
            .then(function(response) {
                return response.data.name;
            }).then(function(name) {
                data.isVersion = true;
                data.portfolio.versionOfReportId = data.id;
                data.portfolio.versionOfReportName = data.portfolio.name;
                data.id = '';
                data.portfolio.name = 'New Version of ' + data.portfolio.name;
                data.versions = [];

                data.loginAccessRules = [];
                data.databaseGroupAccessRules = [];
                data.databaseAccessRules = [
                    {
                        alClientId: authorization.alClientId,
                        name: authorization.alClientName,
                        loginEntityId: 'Administrator',
                        canRun: true,
                        canEdit: true,
                    },
                    {
                        alClientId: authorization.alClientId,
                        name: authorization.alClientName,
                        loginEntityId: 'Advisor',
                        canRun: true,
                        canEdit: true,
                    },
                ];
                data.roleAccessRules = [
                    {
                        roleId: authorization.roleId,
                        name: name,
                        canRun: true,
                        canEdit: true,
                        canDelete: null,
                    },
                ];
                data.userAccessRules = [
                    {
                        userId: authorization.userId,
                        name: authorization.loginUserId,
                        canRun: true,
                        canEdit: true,
                        canDelete: true,
                    },
                ];
                data.representativeAccessRules = [];
                data.representativesClientsAccessRules = [];
                data.clientAccessRules = [];
                data.brokerDealersRepresentativesAccessRules = [];

                data.brokerDealerVersionAssignments = [];
                data.clientVersionAssignments = [];
                data.portfolioGroupVersionAssignments = [];
                data.representativeVersionAssignments = [];
            });
    };

    self.loadSubReportCategories = function() {
        return $http.get('/Reporting/Envision/Fragments/Categories', { trackerMsg: 'Loading fragment categories' })
            .then(function(response) {
                return response.data;
            });
    };

    self.loadReportCategories = function () {
        return $http.get('/Reporting/Envision/Reports/Categories', { trackerMsg: 'Loading report categories' })
            .then(function (response) {
                return response.data;
            });
    };

    self.loadSubReportTheme = function() {
        return $q.all([
            $http.get('/Reporting/Envision/Themes/Standard/Css', { cache: true })
                .then(function(standardResponse) {
                    return standardResponse.data;
                }),
            $http.get('/Reporting/Envision/Themes/Default', { trackerMsg: 'Loading default theme' })
                .then(function(response) {
                    return response.data?.css;
                }),
        ]);
    };

    return self;
});

'use strict';

app.service('resolveHelper', function($http, $q, $rootScope, reportHelper, groupingHelper, RcResolveService, optionsHelper){
    const self = this, internal = {
        resolveOptions: [],
        resolveCache: [],
        resolveOptionsPromises: []
    };

    const queue = {payload: [], predicate: {}};

    function formattedValue(payload, predicate) {
        queue.payload.push(payload);
        queue.predicate[payload.$index] = predicate;
        $rootScope.$evalAsync(function(){
            if(queue.payload.length === 0) { return; }
            const payload = queue.payload;
            queue.payload = [];
            $http.post('/Reporting/Envision/PlaceholderHeirarchy/Action/Format/List', payload, {cache: true}).then(function(response){
                response.data.forEach(function(data){
                    (queue.predicate[data.$index] || angular.noop)(data);
                });
            });
        });
    }

    function refreshResolveOptions(){
        internal.resolveOptionsPromises.push(
            reportHelper.getStaticTagConfigs().then(function (configs) {
                internal.resolveOptions.length = 0;

                configs
                    .forEach(function (config) {
                        const definition = new ResolveOption(config, null);
                        internal.resolveOptions.push(definition);
                    });

                return internal.resolveOptions;
            }
        ));
    }

    function build() {
         $q.all(internal.resolveOptionsPromises).then(i=>{
             self.loaded = true;
        });
    }

    function getScrollParent(element, includeHidden) {
        let style = getComputedStyle(element);
        let isModal = element.classList.contains("modal-resolve");
        const excludeStaticParent = true; //style.position === "absolute";  Why exclude?
        const overflowRegex = /(auto|scroll)/;
        const hiddenRegex = /hidden/;

        if (style.position === "fixed" || isModal) return document.body;
        for (let parent = element; (parent = parent.parentElement);) {
            style = getComputedStyle(parent);
            const overflow = style.overflow + style.overflowY + style.overflowX;
            if (excludeStaticParent && style.position === "static") {
                continue;
            }
            if(hiddenRegex.test(overflow)) {
                if (includeHidden) return parent;
                continue;
            }
            if (overflowRegex.test(overflow)) return parent;
        }

        return document.body;
    }

    function makeGUID() {
        const S4 = function() {
            return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
        };
        return Date.now()+"-"+S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4();
    }

    function nullOrUndefined(x){
        return x === undefined || x === null;
    }

    function ContextFormat(typeName) {
        var config = {
            type: String(typeName || 'string').toLowerCase(),
            compile: function(){ return config.value; },
            parse: function(format = ''){ config.value = format; },
            options: {
                custom: {
                    name: 'Custom',
                    type: 'text',
                    get enabled() {
                        return ['date', 'time', 'datetime', 'daterange'].some(t => config.type === t) && !Object.values(config.options).some(function(fo){ return fo === config.options.custom ? false : fo.enabled });
                    },
                    get value() { return config.value; },
                    set value(value) { config.value = value; }
                },
                showDollarSign: {
                    name: 'Show Dollar Sign',
                    type: 'boolean',
                    get enabled() { return ['currency', 'currency-growth-of'].some(t => config.type === t) },
                    value: undefined
                },
                showPercentSign: {
                    name: 'Show Percent Sign',
                    type: 'boolean',
                    get enabled() { return ['percent'].some(t => config.type === t) },
                    value: undefined
                },
                useThousandsSeparator: {
                    name: 'Use Thousand\'s Separator',
                    type: 'boolean',
                    get enabled() { return ['currency', 'currency-growth-of', 'decimal', 'numeric'].some(t => config.type === t) },
                    value: undefined
                },
                useNegativeParenthesis: {
                    name: 'Use Negative Parenthesis',
                    type: 'boolean',
                    get enabled() { return ['currency', 'currency-growth-of', 'decimal', 'numeric', 'percent'].some(t => config.type === t) },
                    value: undefined
                },
                numberOfDecimal: {
                    name: 'Number of Decimals',
                    type: 'number',
                    get enabled() { return ['percent', 'currency', 'currency-growth-of', 'decimal'].some(t => config.type === t) },
                    value: undefined
                },
                growthOf: {
                    name: 'Growth Of',
                    type: 'select',
                    options: [
                        {name: '$1', value: '|1'},
                        {name: '$100', value: '|100'},
                        {name: '$1000', value: '|1000'},
                    ],
                    get enabled() { return ['currency-growth-of'].some(t => config.type === t) },
                    value: undefined
                },
                maskingType: {
                    name: 'Masking Type',
                    type: 'select',
                    options: [
                        {name: 'No Masking', value: 'N'},
                        {name: 'All Characters', value: 'M'},
                        {name: 'Alpha/Numeric', value: 'm'},
                    ],
                    get enabled() {
                        return ['mask-string'].some(t => config.type === t);
                    },
                    value: undefined
                },
                visibleCharactersAtEnd: {
                    name: 'Visible Characters at End',
                    type: 'number',
                    get enabled() { return config.options.maskingType.enabled && config.options.maskingType.value !== 'N' },
                    value: undefined
                },
                maskingCharacter: {
                    name: 'Masking Character',
                    type: 'text',
                    get enabled() { return config.options.maskingType.enabled && config.options.maskingType.value !== 'N' },
                    value: undefined
                },
                valueToReplace: {
                    name: 'Value to Replace',
                    type: 'text',
                    get enabled() { return ['currency', 'decimal', 'numeric', 'currency-growth-of'].some(t => config.type === t); },
                    value: undefined
                },
                replaceValueWith: {
                    name: 'Replace Value With',
                    type: 'text',
                    get enabled() { return ['currency', 'decimal', 'numeric', 'currency-growth-of'].some(t => config.type === t); },
                    value: undefined
                }

            }
        };

        switch(config.type) {
            case 'numeric':
            case 'decimal':
            case 'currency':
            case 'currency-growth-of':
                config.compile = function() {
                    config.value = RcResolveService.formatNumericValue(config.options);
                    return config.value;
                };
                config.parse = function (format = undefined, data = undefined) {
                    config.value = format || reportHelper.getTypeFormat(config.type) || '';

                    RcResolveService.parseNumericFormat(config.value, config.options, data);
                };
                break;
            case 'percent':
                config.compile = function() {
                    config.value = RcResolveService.formatPercentValue(config.options);
                    return config.value;
                };
                config.parse = function(format, data = undefined) {
                    config.value = format || reportHelper.getTypeFormat(config.type) || '';

                    RcResolveService.parsePercentFormat(config.value, config.options, data);
                };
                break;
            case 'mask-string':
                config.compile = function() {
                    config.value = RcResolveService.formatMaskStringValue(config.options);
                    return config.value;
                };
                config.parse = function(format, data = undefined) {
                    config.value = format || reportHelper.getTypeFormat(config.type) || '';

                    RcResolveService.parseMaskStringFormat(config.value, config.options, data);
                };
                break;

            case 'string':
            case 'time':
            case 'date':
            case 'daterange':
            case 'datetime':
            default:
                break;
        }

        Object.defineProperties(this, {
            options: {
                get: function() { return Object.values(config.options).filter(o => o.enabled); }
            },
            formatOptions: {
                get: () => { return config.options; }
            },
            parse: { value: config.parse },
            compile: { value: config.compile }
        });
    }

    ContextFormat.prototype.toString = function() {
        return this.compile();
    };


    /***
     * Adds a globalPropertyName to the resolve object based on the option GUID.
     */
    function addGlobalGuidOption(isolate, fullOption, resolve) {
        let guid = isolate.data[fullOption.guidName].toString();
        Object.defineProperty(resolve, fullOption.globalPropertyName, {
            get: function() {
                if (optionsHelper.isAdHocSettingGuid && optionsHelper.isAdHocSettingGuid(guid)) {
                    return {
                        $type: 'adhoc-guid', adhocOptionGuid: guid,
                    };
                }

                return {
                    $type: 'guid', globalOptionGuid: guid,
                };
            }, set: function(value) {
                guid = value;
            }, enumerable: true, configurable: true,
        });
    }

    /***
     * Gets the globalOption based on globalPropertyName and adds it to the resolve object
     */
    function reuseGlobalGuidOption(isolate, fullOption, resolve) {
        if (resolve.hasOwnProperty(fullOption.globalPropertyName)) {
            return;
        }

        Object.defineProperty(resolve, fullOption.globalPropertyName, {
            get: function() {
                return isolate.data[fullOption.globalPropertyName];
            }, set: function(value) {
                isolate.data[fullOption.globalPropertyName] = value;
            }, enumerable: true, configurable: true, // This allows changing the guid when changed in dropdown in the editor
        });
    }

    function ResolveOption(data, rcResolve) {
        const resolve = this;

        if(!data){
            throw "data is required when initializing ResolveOption";
        }
        const isolate = {
            parentResolve: rcResolve,
            data: angular.copy(data),
            $index: makeGUID(),
            label: {},
            get report() {
                return reportHelper.getCurrentReport();
            }
        };
        // Dynamic option-value tags (activity, performance, etc.) use a unique config.key
        // such as Activity.Value.3001. Ad hoc options omit activityOptionId, so key must
        // come from config.key rather than path alone or the picker shows "Activity Value".
        isolate.key = isolate.data.key || (Array.isArray(isolate.data.path) ? isolate.data.path.join('.') : isolate.data.path);
        updateForKeyChange(true);

        function updateForKeyChange(isInit){
            isolate.definition = reportHelper.getStaticTagConfig(isolate.key);
            if(isolate.definition.key !== isolate.key){
                //the look up gave us a different tag, need to update isolate to match
                isolate.key = isolate.definition.key;

                //need to clear the optionId too
                const map = reportHelper.getMap(isolate.definition.optionType);
                isolate.data[map.propertyName] = undefined;
            }
            isolate.config = angular.extend({}, angular.copy(isolate.definition), isolate.data);

            if(!isolate.definition){
                //can't do anything more without a definition
                console.log('quitting updateForKeyChange', isInit, isolate.key);
                return;
            }

            const originalType = isolate.resultType;
            if(isolate.definition.$type === 'option-value' && isolate.definition.resultType){
                isolate.$type = isolate.definition.$type;
                isolate.resultType = isolate.definition.resultType;
            }else{
                isolate.$type = isolate.definition.$type;
                isolate.resultType = isolate.definition.$type;
            }

            let propertyConfigurable = isolate.$type === 'option-value';
            let updateTriggeredByOptionType = null;
            if(isolate.$type === 'option-value') {
                updateTriggeredByOptionType = isolate.definition.optionType;
            }

            if(isInit && propertyConfigurable){
                const defOption = reportHelper.getOptionsMap().fnFind(function(map){return map.optionName === isolate.definition.optionType});
                const optionValueId = isolate.data[defOption.propertyName];

                if(defOption && !nullOrUndefined(optionValueId)){
                    isolate.key = isolate.definition.path + '.' + optionValueId;
                    return updateForKeyChange(false);
                }
            }

            //copy over any options that may be set
            reportHelper.getOptionsMap().forEach(function(map){
                if(updateTriggeredByOptionType === map.optionName){
                    Object.defineProperty(resolve, map.propertyName, {
                        get: function () {
                            return isolate.data[map.propertyName];
                        },
                        set: function (value) {
                            isolate.data[map.propertyName] = value;

                            //update the key
                            if(value){
                                isolate.key = isolate.definition.path + '.' + value;
                            } else {
                                isolate.key = isolate.definition.path;
                            }
                            updateForKeyChange(false);
                        },
                        enumerable: true,
                        configurable: propertyConfigurable //we need to be able to override this property when it's an option-value
                    });
                    Object.defineProperty(resolve, '$optionValuePropertyName', {
                        get: function () {
                            return map.propertyName;
                        },
                        enumerable: false,
                        configurable: propertyConfigurable //we need to be able to override this property when it's an option-value
                    });

                }else{
                    Object.defineProperty(resolve, map.propertyName, {
                        get: function () {
                            return isolate.data[map.propertyName];
                        },
                        set: function (value) {
                            isolate.data[map.propertyName] = value;
                        },
                        enumerable: true,
                        configurable: propertyConfigurable //we need to be able to override this property when it's an option-value
                    });
                }
            });

            if(!('$options' in isolate)) {
                initReportOptions();
            }

            if(
                //it hasn't been set up yet
                !('formatOptions' in isolate)

                //the type changed
                || originalType !== isolate.resultType
            ) {
                initFormatOptions();
            }
        }

        function initFormatOptions() {
            isolate.format = new ContextFormat(
                (angular.isArray(isolate.definition.options) && isolate.definition.options.some(n => n === "MaskString"))
                ? 'mask-string'
                : isolate.resultType
            );

            isolate.format.parse(isolate.data.format || isolate.definition.format, isolate.data);
        }

        function initReportOptions() {
            isolate.$options = [];

            if (!isolate.report || !angular.isArray(isolate.definition.options)) {
                return;
            }

            reportHelper.getExpandedOptions(isolate.definition.options).forEach(function(fullOption) {
                try {
                    // Do not add the dateRange property to the resolve object, we do that in next series of IF statements
                    // Everything else will add properties that do not collide (i.e. activityOption, performanceOption)
                    if (fullOption.optionType !== 'date-range') {
                        let optionValue = window.structuredClone(isolate.report.getOption(fullOption.optionType, resolve[fullOption.propertyName]));
                        Object.defineProperty(resolve, fullOption.optionName.camelize(false), {
                            get: function() {
                                return optionValue;
                            }, set: function(value) {
                                optionValue = value;
                            }, enumerable: true, configurable: true,
                        });
                    }

                    // This IF statement is used when we first create all the options Resolve can see
                    if (fullOption.guidName && fullOption.globalPropertyName && isolate.data[fullOption.guidName]) {
                        addGlobalGuidOption(isolate, fullOption, resolve);
                    } else if (fullOption.guidName && fullOption.globalPropertyName && isolate.data[fullOption.globalPropertyName]) {
                        // This IF statement is used when we select the tag and create a new copy of it.
                        reuseGlobalGuidOption(isolate, fullOption, resolve);
                    }
                    isolate.$options.push(fullOption);
                } catch (e) {
                    console.log('initReportOptions', isolate.config, fullOption, e);
                }
            });
        }

        Object.defineProperties(resolve, {
            '$type': {
                get: function() { return isolate.$type; },
                enumerable: true, configurable: false
            },
            'resultType': {
                get: function() { return isolate.resultType; },
                enumerable: true, configurable: false
            },
            '$index': {
                get: function() { return isolate.$index; },
                enumerable: true, configurable: false
            },
            '$key': {
                // this is how we know which unique tag this resolve points to
                get: function(){ return isolate.key; },
                enumerable: true, configurable: false
            },

            //all the following properties come from the definition
            'path': {
                get: function(){ return isolate.definition.path; },
                enumerable: true, configurable: false
            },
            'name': {
                get: function(){
                    const devtools = {
                        break: function(message) {
                            const msg = /./;
                            msg.toString = function() {
                                msg.opened = true;
                            };
                            console.log(msg, message);
                            if (msg.opened) debugger;
                        }
                    };

                    devtools.break("use path instead of name.");
                    return isolate.definition.path;
                },
                enumerable: false, configurable: false
            },
            'label': {
                get: function(){ return isolate.data.label || isolate.definition.label; },
                set: function(value) { isolate.data.label = value; },
                enumerable: true, configurable: false
            },
            // Live catalog name for the tag overlay. Not enumerable so it is not saved over a custom label.
            'definitionLabel': {
                get: function(){ return (isolate.definition && isolate.definition.label) || isolate.data.label; },
                enumerable: false, configurable: false
            },
            'description': {
                get: function(){ return isolate.definition.description; },
                enumerable: true, configurable: false
            },
            'keywords': {
                get: function(){ return isolate.definition.keyWords || []; },
                enumerable: true, configurable: false
            },
            'excludeLocations': {
                get: function(){ return isolate.definition.excludeLocations; },
                enumerable: true, configurable: false
            },
            'types': {
                get: function(){ return isolate.definition.types; },
                enumerable: true, configurable: false
            },
            'deprecated': {
                get: function(){ return isolate.definition.deprecated; },
                enumerable: true, configurable: false
            },
            'cumulative': {
                get: function(){ return isolate.data.cumulative; },
                set: function(value) { isolate.data.cumulative = value; },
                enumerable: true, configurable: false
            },
            'containsPii': {
                get: function(){ return isolate.definition.containsPii; },
                enumerable: true, configurable: false
            },
            'isSubtotal': {
                get: function(){ return isolate.data.isSubtotal; },
                set: function(value) {
                    if(value) {
                        let column = angular.element(isolate.parentResolve.$element[0]).scope().column;
                        isolate.data.subtotalGrouping = groupingHelper.getDefaultTableGroupLevel(column, reportHelper.current.selected.groupings);
                    } else{
                        isolate.data.subtotalGrouping = null;
                    }

                    isolate.data.isSubtotal = value;
                },
                enumerable: true, configurable: false
            },
            'subtotalGrouping': {
                get: function(){return isolate.data.subtotalGrouping;},
                set: function(value) { isolate.data.subtotalGrouping = value; },
                enumerable: true, configurable: false
            },
            'weightedBenchmarkGrouping': {
                get: function(){return isolate.data.weightedBenchmarkGrouping;},
                set: function(value) { isolate.data.weightedBenchmarkGrouping = value; },
                enumerable: true, configurable: false
            },
            'taxInceptionType': {
                get: function () {
                    if (!isolate.data.taxInceptionType) {
                        isolate.data.taxInceptionType = reportHelper.taxInceptionTypes[0];
                        return isolate.data.taxInceptionType;
                    }
                    else {
                        return isolate.data.taxInceptionType;
                    }
                },
                set: function (value) { isolate.data.taxInceptionType = value; },
                enumerable: true, configurable: false
            },
            'controlType': {
                get: function() {return reportHelper.current.selected ? reportHelper.current.selected.$type : 'none';}
            },
            'filter': {
                get: function() { return isolate.data.filter; },
                set: function(value) { isolate.data.filter = value; },
                enumerable: true, configurable: false
            },
            'costPerShareMethod': {
                get: function () {
                    if (!isolate.data.costPerShareMethod) {
                        isolate.data.costPerShareMethod = reportHelper.costPerShareMethods[0];
                        return isolate.data.costPerShareMethod;
                    }
                    else {
                        return isolate.data.costPerShareMethod;
                    }
                },
                set: function (value) {
                    isolate.data.costPerShareMethod = value;

                    if(value === "Percentage of Par") {
                        var showDollarSign = isolate.format.options.find(o => o.name === 'Show Dollar Sign');
                        showDollarSign.value = true;
                    }
                    },
                enumerable: true, configurable: false
            },

            //all the following properties are build up for this object but the $ prevents them from appearing in when the tag is serialized into the text for saving.
            '$formatOptions': {
                get: function(){
                    if(isolate.format) return isolate.format.options;
                },
                enumerable: true, configurable: false
            },
            'format': {
                get: function() {
                    if(isolate.format) return isolate.format.toString();
                },
                enumerable: true, configurable: false
            },
            'formatSettings': {
                get: function () {
                    if (isolate.format) {
                        return RcResolveService.attachFormatProperties(resolve, isolate.format);
                    } else {
                        return undefined;
                    }
                },
                enumerable: true, configurable: false
            },
            '$options': {
                get: function(){
                    return isolate.$options;
                },
                enumerable: true, configurable: false
            },

            'displayText': {
                get: function () {
                    if (isolate.parentResolve && isolate.parentResolve.displayMode === 'formula') {
                        //if the displayMode is formula the display text should always be the definition label, do not change it out for a value
                        return isolate.definition.label;
                    }

                    function getFormattedValue(){
                        const payload = angular.copy(resolve);
                        payload.label = isolate.label.value || isolate.config.label || resolve.path;
                        formattedValue(payload, function (data) {
                            if (isolate.label.formatted !== data.formatted) {
                                isolate.label.formatted = data.formatted;
                            }
                        });
                    }

                    if(isolate.definition.examples !== isolate.examples) {
                        //for strings if they have at least one example
                        isolate.examples = isolate.definition.examples;
                        getFormattedValue();
                    } else if (resolve.format !== isolate.label.format) {
                        //for everything with a format string
                        isolate.label.format = resolve.format;
                        if (resolve.format && resolve.format.length > 0) {
                            getFormattedValue();
                        } else {
                            delete isolate.label.formatted;
                        }
                    }

                    switch (resolve.path) {
                        case 'Report.Name':
                            if (isolate.report) {
                                isolate.label.formatted = isolate.report.portfolio.name;
                            }
                            break;
                        case 'DateRange.Name':
                            isolate.label.formatted = (resolve.dateRange || {}).name;
                            break;
                        case 'Performance.CalcMethod':
                            isolate.label.formatted = (resolve.performance || {}).name;
                            break;
                        case 'Activity.Name':
                            isolate.label.formatted = (resolve.activity || {}).name;
                            break;
                    }
                    return isolate.label.formatted || isolate.definition.label;
                },
                enumerable: true, configurable: false
            },
            'allowedEntityTypes': {
                get: function() {
                    return isolate.config.allowedEntityType;
                },
                enumerable: true, configurable: false
            },
            // used to determine if custom naming of series can be done
            "namedSeries": {
                get: function() {
                    return isolate.config.namedSeries;
                },
                enumerable: true, configurable: false
            }
        });

        resolve.isType = function (names) {
            if(!isolate.resultType) return;
            return Array.isArray(names) ? names.some(function(name){
                return name.toString().toLowerCase() === isolate.resultType.toLowerCase()
            }) : name.toString().toLowerCase() === isolate.resultType.toLowerCase();
        };

        //copy some specific properties
        ['options', 'allowedLocations'].forEach(function (prop) {
            resolve[prop] = Object.clone(isolate.config[prop]);
        });

        return resolve;
    }

    ResolveOption.prototype.encode = function () {
        return optionsHelper.encodeResolve(this);
    };

    ResolveOption.prototype.createElement = function() {
        const resolve = this;
        const element = document.createElement('resolve-term');
        if(resolve.deprecated) {
            element.className = "deprecated";
        }

        element.classList.add(...resolve.allowedEntityTypes);
        element.setAttribute('index', resolve.$index);
        element.textContent = resolve.displayText;
        return element;
    };

    ResolveOption.prototype.find = function(context) {
        return $(context || document)[0].querySelector('resolve-term[index="'+this.$index+'"]');
    };

    ResolveOption.prototype.findAll = function(context) {
        return $(context || document)[0].querySelectorAll('resolve-term[index="'+this.$index+'"]');
    };

    Object.defineProperties(self, {
        options: {
            get: function() {
                return internal.resolveOptions;
            },
            set: function(value) {},
            enumerable: true
        },
    });

    self.patterns = {
        decode: /(\[@({.*?})@])/,
        globalDecode: /(\[@({.*?})@])/g,
        search: new RegExp("{1}([\\w\\' ]*)(?!.*{1})".assign('@'), 'i')
    };

    self.parseResolveJson = function(value) {
        const matches = value.match(self.patterns.decode);

        // last match should be all of the JSON
        const json = matches[matches.length - 1];

        return JSON.parse(json);
    };

    self.removeIndexesFromResolves = function(stringResolver) {
        const matches = stringResolver.value.match(self.patterns.globalDecode);

        if(!matches || matches.length === 0) {
            return stringResolver;
        }

        stringResolver.value = matches.reduce(function(value, match) {
            const resolve = self.parseResolveJson(match);
            if(resolve.$index) {
                delete resolve.$index;
            }
            return value.replace(match, optionsHelper.encodeResolve(resolve));
        }, stringResolver.value);

        return stringResolver;
    };

    self.getOption = function(data, rcResolve) {
        if(!rcResolve || !data){
            throw "data and rcResolve must be provided.";
        }
        let resolve;
        if(!data.$index || !(resolve = internal.resolveCache.fnFind(function(r) { return r.$index === data.$index }))) {
            resolve = new ResolveOption(data, rcResolve);
        }
        internal.resolveCache.push(resolve);
        return resolve;
    };

    function getGuidReference(data, globalPropertyName) {
        if (!data || !globalPropertyName) {
            return null;
        }

        const ref = data[globalPropertyName];
        if (!ref || typeof ref !== 'object') {
            return null;
        }

        return ref.adhocOptionGuid || ref.globalOptionGuid || null;
    }

    function hasOptionReferenceData(data) {
        if (!data) {
            return false;
        }

        return reportHelper.getOptionsMap().some(function(map) {
            if (map.propertyName && !nullOrUndefined(data[map.propertyName])) {
                return true;
            }

            return !!getGuidReference(data, map.globalPropertyName);
        });
    }

    function resolveOptionMatchesData(option, data) {
        if (option.$optionValuePropertyName) {
            const propertyName = option.$optionValuePropertyName;
            const dataValue = data[propertyName];
            const optionValue = option[propertyName];

            if (!nullOrUndefined(dataValue) || !nullOrUndefined(optionValue)) {
                if (dataValue !== optionValue) {
                    return false;
                }
            }
        }

        return reportHelper.getOptionsMap().every(function(map) {
            const dataGuid = getGuidReference(data, map.globalPropertyName);
            if (!dataGuid) {
                return true;
            }

            const optionGuid = getGuidReference(option, map.globalPropertyName);
            if (optionGuid) {
                return dataGuid === optionGuid;
            }

            return true;
        });
    }

    function findResolveOptionFallback(options, data) {
        if (!options || options.length === 0) {
            return null;
        }

        if (data.label) {
            const labelMatches = options.filter(function(o) { return o.label === data.label; });
            if (labelMatches.length === 1) {
                return angular.copy(labelMatches[0]);
            }
        }

        const keyMatches = options.filter(function(o) { return o.$key === data.path; });
        if (keyMatches.length >= 1) {
            return angular.copy(keyMatches[0]);
        }

        return angular.copy(options[0]);
    }

    self.findResolveOption = function(data) {
        if(!data || !data.path){
            return null;
        }
       const pathMatches = self.options.filter(function(o){ return o.path === data.path;});
       
        if(pathMatches.length === 1){
            return angular.copy(pathMatches[0]);
        }

        let options = pathMatches.slice();

        function compareOptionId(propertyName, obj1, obj2){
            const val1 = obj1[propertyName];
            const val2 = obj2[propertyName];

            if( nullOrUndefined(val1) && nullOrUndefined(val2) ){
                return true;
            }

            return val1 === val2;
        }

        if (hasOptionReferenceData(data)) {
            options = options.filter(function(o) {
                return resolveOptionMatchesData(o, data);
            });
        } else {
            options = options.filter(function(o){
                return compareOptionId(o.$optionValuePropertyName, o, data);
            });
        }

        if(options.length === 1){
            return angular.copy(options[0]);
        }

        let fallback = findResolveOptionFallback(options, data);
        if (fallback) {
            return fallback;
        }

        fallback = findResolveOptionFallback(pathMatches, data);
        if (fallback) {
            return fallback;
        }

        console.log('null from findResolveOption', data);
        return null;
    };

    self.getScrollParent = getScrollParent;

    self.getResolveOptions = function (resolveFor) {
        let options = self.options.filter(option => reportHelper.filterResolveOptionsByAllowedEntityTypes(option));
        // always exclude parents
        options = options.exclude({ $type: "parent" });

        switch (resolveFor) {
            case 'ReportingEnvisionCoverPageItemCtrl':
            case 'coverPage':
                return options.filter(function (o) {
                    return o.excludeLocations.indexOf('Cover') === -1;
                });
            case 'deliver':
                return options.filter(function (o) {
                    return o.containsPii !== true && o.excludeLocations.indexOf('Cover') === -1;
                });
            case 'ReportEditorCtrl':
            case 'SubReportEditorCtrl':
            case 'reportEditor':
                return options.filter(function (o) {
                    return o.excludeLocations.indexOf('Report') === -1;
                });
            default:
                return options;
        }
    };

    //bind report helper events
    reportHelper.$onSetReport(function(){ build(); });
    reportHelper.$onDynamicTagChange(function(){ refreshResolveOptions(); });

    refreshResolveOptions();
    build();
});

'use strict';

app.service('resolveKeyActionHelper', function () {
    const self = this;

    function metaKeyTrigger(event) {
        return !event.repeat && (event.ctrlKey || event.metaKey);
    }

    self.getActionToTake = function (event) {
        const metaKeyAction = metaKeyTrigger(event);
        if(metaKeyAction && !['Control','Meta','OS','b','i'].any(event.key)) {
            return 'None';
        }
        switch (event.key) {
            case 'ArrowUp':
            case 'Up':
                return 'Up';
            case 'ArrowDown':
            case 'Down':
                return 'Down';
            case 'Enter':
            case 'Tab':
                return 'Select';
            case 'Control':
            case 'Meta':
            case 'OS':
                return 'Open';
            case 'b':
            case 'i':
                return metaKeyAction ? 'Style' : 'Text';
            case 'Escape':
            case 'Esc':
            case 'Cancel':
                return 'Cancel';
            case 'Space':
            case ' ':
                return 'Text';
            case 'Delete':
            case 'Del':
                return 'Delete';
            case 'Backspace':
                return 'Back';
            default:
                if (event.key.length === 1) {
                    return 'Text';
                }
        }

        return 'None';
    };

    self.upAction = function (resolver, event) {
        if (!resolver.current.state.$resolves) {
            resolver.close();
            return;
        }

        resolver.up();
        resolver.moved = true;
        event.preventDefault();
    };

    self.downAction = function (resolver, event) {
        if (!resolver.current.state.$resolves) {
            resolver.close();
            return;
        }

        resolver.down();
        resolver.moved = true;
        event.preventDefault();
    };

    self.selectAction = function (resolver, event) {
        if (resolver.current.state.$resolves) {
            resolver.select();
            resolver.moved = true;
            event.preventDefault();
            return;
        }

        if (event.key === 'Enter') {
            resolver.newLine(event);
        }

        resolver.close();
    };

    self.openAction = function (resolver, event) {
        resolver.open();
        event.preventDefault();
    };

    self.styleAction = function (resolver, event) {
        if (event.key === 'b') {
            resolver.execCommand('bold');
        }

        if (event.key === 'i') {
            resolver.execCommand('italic');
        }

        event.preventDefault();
    };

    self.cancelAction = function (resolver) {
        resolver.cancel();
    };

    return self;
});

'use strict';

app.controller('ContextChangeOptionsCtrl', function ContextChangeOptionsCtrl($scope, $http, $dialog, dialog, args, contextChangeHelper, reportService, $timeout, reportHelper, $oasRights, optionsHelper, splitIoService) {
    //PRIVATE VARIABLES
    const origItemList = angular.copy(args.itemList);
    const fields = {
        performance: {
            deleteIfDefault: true,
            standard: ['includeAccruedInterest', 'calcFirstDayPerformance', 'calcIntraDayPerformance', 'annualize', 'annualizeIncludeDaysWithoutValue', 'flipSignForShort', 'suppressMixedRanges', 'suppressMixedAssetLevelGroups', 'includeAIPLedger'],
            special: [
                { name: 'calculationMethod', source: 'perfCalculationMethods' },
                { name: 'feeMethod', source: 'perfFeeMethods' },
                { name: 'taxMethod', source: 'perfTaxMethods' }
            ]
        },
        billing: {
            deleteIfDefault: false,
            standard: ['includeOnlyRelevantFeeSchedules', 'includeDollarFlatFeeSchedules', 'useAsOfDateOverride', 'cashflowRollup'],
            special: [
                { name: 'billsToReturn', source: 'billingReturns' }
            ]
        },
        income: {
            deleteIfDefault: false,
            standard: ['prorateIncomeToMaturity', 'showZeroYieldForZeroCouponBonds'],
            special: [
                { name: 'modifiedDurationMarketDate', source: 'modifiedDurationMarketDates' },
                { name: 'annualDividendRateMethod', source: 'annualDividendRateMethods' },
                { name: 'dividendDate', source: 'dividendDates' },
                { name: 'maturityDate', source: 'modifiedDurationMarketDates' }
            ]
        },
        maturityPeriod: {
            deleteIfDefault: false,
            standard: [],
            special: [
                { name: 'maturityPeriodInterval', source: 'maturityPeriodInterval' },
                { name: 'ranges', source: 'ranges' }
            ]
        },
        calculation: {
            deleteIfDefault: false,
            standard: ['resultType', 'calculation'],
            special: []
        },
        costbasis: {
            deleteIfDefault: false,
            standard: [],
            special: [
                { name: 'displayGainsOrLosses', source: 'displayGainsOrLosses' }
            ]
        }
    };
    fields.performance.all = fields.performance.standard.include(fields.performance.special);

    let perfDefaults;


    //PRIVATE METHODS
    const methods = {
        daterange: {
            setOptionsToValues: function (item) {
                prepareDateForSave(item);
            }
        },
        performance: {
            loadValues: function () {
                if ($scope.current.item.isDefault) {
                    fields.performance.special.forEach(function (field) {
                        $scope.current.item[field.name] = perfDefaults[field.name];
                    });
                    fields.performance.standard.forEach(function (field) {
                        const defaultValueCapitalized = contextChangeHelper.getPerformanceDefaultValueCapitalized(field, perfDefaults);
                        if (defaultValueCapitalized !== null) {
                            $scope.current.item[field] = defaultValueCapitalized;
                        }
                    });
                } else {
                    cleanCurrentItemFields(fields.performance);
                }
            },
            setOptionsToValues: function (item) {
                if (item.isDefault) {
                    fields.performance.all.forEach(function (field) {
                        item[field.name || field] = perfDefaults[field.name || field];
                    });
                } else {
                    restoreItemFields(item, fields.performance);
                }
            }
        },
        billing: {
            loadValues: function () {
                cleanCurrentItemFields(fields.billing);

                if (!$scope.current.item.includedBillPayMethods) {
                    $scope.current.item.includedBillPayMethods = [];
                } else {
                    $scope.current.item.includedBillPayMethods = $scope.current.item.includedBillPayMethods.map(function (item) {
                        return Object.find($scope.billPayMethods, item);
                    });
                }

                if (!$scope.current.item.includedBillTypes) {
                    $scope.current.item.includedBillTypes = [];
                } else {
                    $scope.current.item.includedBillTypes = $scope.current.item.includedBillTypes.map(function (item) {
                        return Object.find($scope.billTypes, item);
                    });
                }

                if (!$scope.current.item.includedBillAdjustmentTypes) {
                    $scope.current.item.includedBillAdjustmentTypes = [];
                } else {
                    $scope.current.item.includedBillAdjustmentTypes = $scope.current.item.includedBillAdjustmentTypes.map(function (type) {
                        return type.toString();
                    });
                }

                if (!$scope.current.item.includedBillEntities) {
                    $scope.current.item.includedBillEntities = [];
                } else {
                    $scope.current.item.includedBillEntities = $scope.current.item.includedBillEntities.map(function (entity) {
                        return entity.toString();
                    });
                }
            },
            setOptionsToValues: function (item) {
                restoreItemFields(item, fields.billing);
                if (!item.includedBillPayMethods) {
                    item.includedBillPayMethods = [];
                }
                else
                {
                    item.includedBillPayMethods = item.includedBillPayMethods.map(function (item) {
                        return $scope.billPayMethods[item];
                    })
                }

                if (!item.includedBillTypes) {
                    item.includedBillTypes = [];
                }
                else {
                    item.includedBillTypes = item.includedBillTypes.map(function (item) {
                        return $scope.billTypes[item];
                    })
                }

                if (!item.includedBillAdjustmentTypes) {
                    item.includedBillAdjustmentTypes = [];
                } else {
                    item.includedBillAdjustmentTypes = item.includedBillAdjustmentTypes.map(function (type) {
                        return parseInt(type);
                    });
                }

                if (!item.includedBillEntities) {
                    item.includedBillEntities = [];
                } else {
                    item.includedBillEntities = item.includedBillEntities.map(function (entity) {
                        return parseInt(entity);
                    });
                }
            }
        },
        maturityPeriod: {
            loadValues: function () {
                cleanCurrentItemFields(fields.maturityPeriod);
            },
            setOptionsToValues: function (item) {
                restoreItemFields(item, fields.maturityPeriod);
            }
        },
        income: {
            loadValues: function () {
                cleanCurrentItemFields(fields.income);
            },
            setOptionsToValues: function (item) {
                restoreItemFields(item, fields.income);
            }
        },
        costbasis: {
            loadValues: function () {
                cleanCurrentItemFields(fields.costbasis);
            },
            setOptionsToValues: function (item) {
                restoreItemFields(item, fields.costbasis);
            }
        }


    };

    function init() {
        loadValuesForType();

        $scope.current.reportOptionName = $scope.current.type.titleize();

        switch ($scope.current.type) {
            case 'daterange':
                $scope.current.reportOptionName = "Date Range";
                setDateSourceSelector($scope.current.item, $scope.current.item.start);
                setDateSourceSelector($scope.current.item, $scope.current.item.end);
                $scope.updateDate($scope.current.item.start);
                $scope.updateDate($scope.current.item.end);
                break;
            case 'activity':
                if (!$scope.itemsActivityValuation) {
                    $http.get("/Trading/TransactionTypes?includeRemark=false", { trackerMsg: 'Loading transaction types' })
                        .then(function (response) {
                            $scope.itemsActivityValuation = [
                                { name: "Contributions", category: "Activity" },
                                { name: "Distributions", category: "Activity" },
                                { name: "Net Dividends/Interest/Gains Withdrawn", category: "Activity" },
                                { name: "Miscellaneous Charges", category: "Activity" },
                                { name: "Advisory Fees Paid", category: "Activity" },
                                { name: "Dividends and Interest", category: "Activity" },
                                { name: "Dividend Interest Reinvested", category: "Activity" },
                                { name: "Exchange In", category: "Activity" },
                                { name: "Exchange Out", category: "Activity" },
                                { name: "Merge In", category: "Activity" },
                                { name: "Merge Out", category: "Activity" },
                                { name: "Journal In", category: "Activity" },
                                { name: "Journal Out", category: "Activity" },
                                { name: "Beginning Market Value", category: "Valuation" },
                                { name: "Beginning Bond Accrual", category: "Valuation" },
                                { name: "Ending Market Value", category: "Valuation" },
                                { name: "Ending Bond Accrual", category: "Valuation" }
                            ];

                            response.data.sort(function (a, b) {
                                var x = a.description.toLowerCase();
                                var y = b.description.toLowerCase();
                                if (x < y) { return -1; }
                                if (x > y) { return 1; }
                                return 0;
                            }).forEach(function (type) {
                                $scope.itemsActivityValuation.push({ id: type.id, name: type.description, category: type.financialType });
                            });

                            if ($scope.current.item.details) {
                                $scope.current.item.details.forEach(function (d) {
                                    if (d.$type === 'transaction') {
                                        var tt = $scope.itemsActivityValuation.find(function (element) {
                                            return element.category !== "Activity" && element.category !== "Valuation" && element.id === d.transTypeId;
                                        });
                                        if (tt) {
                                            d.name = tt.name;
                                        } else if (!d.name) {
                                            d.name = 'Unknown Transaction Type ' + d.transTypeId;
                                        }
                                    }
                                });
                            }

                            $scope.current.selectedActivity = $scope.itemsActivityValuation[0];
                        });
                } else {
                    $scope.current.selectedActivity = $scope.itemsActivityValuation[0];
                }
                break;

            case 'costbasis':
                $scope.current.reportOptionName = "Cost Basis";
                break;
            case 'maturity-period':
                $scope.current.reportOptionName = "Maturity Period";
                break;
            case 'transaction-option':
                $scope.current.reportOptionName = "Transaction";
                break;
            case 'billing':
                if (!$scope.billAdjustmentTypes) {
                    $http.get("/Billing/AdjustmentTypes", { trackerMsg: 'Loading billing adjustment types' })
                        .then(function (response) {
                            $scope.billAdjustmentTypes = {};

                            response.data.forEach(function (type) {
                                $scope.billAdjustmentTypes[type.id.toString()] = type.name;
                            });
                        });
                }
                if (!$scope.billEntities) {
                    $http.get("/Billing/Entities/EntityList", { trackerMsg: 'Loading billing entities' })
                        .then(function (response) {
                            $scope.billEntities = {};

                            response.data.forEach(function (entity) {
                                $scope.billEntities[entity.id.toString()] = entity.name;
                            });
                        });
                }
                break;
        }
    }

    function loadValuesForType() {
        const methodSet = methods[$scope.current.type];
        if (methodSet && methodSet.loadValues) {
            methodSet.loadValues();
        }
    }

    function setOptionsToValuesForType(item) {
        const methodSet = methods[$scope.current.type];
        if (methodSet && methodSet.setOptionsToValues) {
            methodSet.setOptionsToValues(item);
        }
    }

    function cleanCurrentItemFields(fields) {
        fields.standard.forEach(function (field) {
            $scope.current.item[field] = !$scope.current.item[field] ? ($scope.current.item[field] === false ? "False" : $scope[field][0]) : "True";
        });

        fields.special.forEach(function (field) {
            if (!$scope.current.item[field.name]) {
                $scope.current.item[field.name] = $scope[field.source][0];
            }
        });
    }

    function restoreItemFields(item, fields) {
        fields.standard.forEach(function (field) {
            if (item[field] === $scope[field][0]) {
                if (fields.deleteIfDefault) {
                    delete item[field];
                }
            } else {
                item[field] = item[field] === 'True';
            }
        });

        fields.special.forEach(function (field) {
            if (item[field.name] === $scope[field.source][0]) {
                if (fields.deleteIfDefault) {
                    delete item[field.name];
                }
            }
        });
    }

    function setupNewItem(item, type, isGlobal) {
        if (item) {
            const newItem = angular.copy(item);

            newItem.name = 'Copy of ' + item.name.remove('(Global)');
            newItem.isRequired = false;
            newItem.isDisabled = false;
            newItem.isGlobal = isGlobal;
            newItem.isSystemDefault = false;

            if (newItem.hasOwnProperty('guid')) {
                newItem.guid = null;
            }

            if (newItem.hasOwnProperty('optionGuid')) {
                newItem.optionGuid = null;
            }

            return newItem;
        } else {
            return {
                name: 'New Option',
                $type: type,
                isRequired: false,
                isGlobal: isGlobal
            };
        }
    }

    function getNewOptionId(list, includeGlobals) {
        let options = [];

        if (includeGlobals) {
            /* Global Editor */
            options = [...list].filter((i) => i.isGlobal);
            if (options.length > 0) {
                return options.max('optionId').optionId + 1;
            } else {
                return 1;
            }
        } else {
            /* Local Editor */
            return optionsHelper.getNewLocalId(list);
        }
    }

    //PUBLIC METHODS
    $scope.addOption = function (item) {
        let newItem = setupNewItem(item, $scope.current.type, $scope.current.isGlobalEditor);

        newItem.optionId = getNewOptionId($scope.current.itemList, $scope.current.isGlobalEditor);

        newItem.id = `${$scope.current.type} ${newItem.optionId}`;

        switch ($scope.current.type) {
            case 'activity':
                if (!item) {
                    newItem.includeUnmanagedJournals = true;
                    newItem.inceptionValueMethod = "New Money";
                    newItem.details = [];
                }
                break;
            case 'calculation':
                if (!item) {
                    newItem.resultType = "Decimal";
                    newItem.calculation = "";
                }
                break;
            case 'comparison':
                if (!item) {
                    newItem.assignmentType = 'User Defined';
                    newItem.benchmarks = [];
                }
                break;
            case 'daterange':
                newItem.id = 'daterange ' + newItem.optionId;
                if (!item) {
                    newItem.start = {
                        dateSourceSelector: "Dynamic",
                        dateSource: "Dynamic",
                        expression: '0d',
                        date: null
                    };
                    newItem.end = {
                        dateSourceSelector: "Dynamic",
                        dateSource: "Dynamic",
                        expression: '0d',
                        date: null
                    };
                    newItem.dataMustExistOnRangeEndDate = false;
                    newItem.dataMustExistOnRangeStartDate = false;
                    newItem.startDateMethod = "Inception";
                }
                break;
            case 'performance':
                if (item) {
                    delete newItem.isDefault;
                    if (item.isDefault) {
                        fields.performance.all.forEach(function (field) {
                            newItem[field.name || field] = $scope[field.source || field][0];
                        });
                    }
                    methods.performance.setOptionsToValues(newItem);
                }
                break;
            case 'maturity-period':
                if (!item) {
                    newItem.ranges = [];
                }
                break;
        }

        if ($scope.current.type !== 'performance') {
            setOptionsToValuesForType(newItem);
        }

        $scope.current.itemList.unshift(newItem);
        $scope.current.item = $scope.current.itemList.find({ optionId: newItem.optionId });
    };

    $scope.deleteOption = function () {
        $dialog.confirmAction("Delete the " + $scope.current.item.name + " option?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    triggerBlurOnInputs();
                    $scope.disabledFlag = true;

                    if ($scope.current.item.isGlobal) {
                        $timeout(function () {
                            reportService.deleteOption($scope.current.item.optionGuid).then(function (newSettings) {
                                deleteSuccess(newSettings);
                            }, function () {
                                deleteFailure();
                            });
                        }, 1);
                    } else {
                        $scope.current.itemList.remove({ id: $scope.current.item.id });
                        finalizeDeletion();
                    }
                }
            });
    };

    function deleteSuccess(newSettings) {
        reportHelper.updateOptions(newSettings, $scope.current.type);

        $scope.current.itemList.remove({ optionGuid: $scope.current.item.optionGuid });
        finalizeDeletion();
    }

    function deleteFailure() {
        triggerBlurOnInputs();
        $scope.disabledFlag = false;
    }

    function finalizeDeletion() {
        $scope.current.item = $scope.current.itemList[0];
        $dialog.saveSuccessful("Setting successfully deleted.").open();

        triggerBlurOnInputs();
        $scope.disabledFlag = false;
    }

    function triggerBlurOnInputs() {
        //Date ranges that need updating
        angular.element(document.querySelectorAll('[data-test-id="txtCCOptionDateRangeEndDate"]')).blur();
        angular.element(document.querySelectorAll('[data-test-id="txtCCOptionDateRangeStartDate"]')).blur();

        //For Calculation formula updating
        angular.element(document.querySelectorAll('[data-test-id="txtCCOptionCalculationName"]')).focus().blur();
    }

    $scope.submit = function () {
        triggerBlurOnInputs();
        $scope.disabledFlag = true;

        //Timeout allows for digest to happen and blur effects to take effect so that option data is correct
        $timeout(() => {
            setOptionsToValuesForType($scope.current.item);
            let itemListNames = $scope.current.itemList.map(function (item) {
                return item.name.trim()
            });
            let duplicates = itemListNames.filter((item, index) => itemListNames.map(b => b.toLowerCase()).indexOf(item.toLowerCase()) !== index);
            if (duplicates.length > 0) {
                $dialog.actionFailed("All options need to have unique names. Please, change or remove any duplicates.</br></br>" + duplicates.join("</br>")).open();
            } else if ($scope.current.submitBeforeCloseCallBack) {
                $scope.current.submitBeforeCloseCallBack($scope.current.itemList).then(resp => {
                    dialog.close(resp);
                }, err => { });
            } else {
                dialog.close($scope.current.itemList);
            }
            $scope.disabledFlag = false;
        }, 1);
    };

    $scope.cancel = function () {
        setOptionsToValuesForType($scope.current.item);

        if (!angular.equals(origItemList, $scope.current.itemList)) {
            $dialog.confirmAction("There are changes that will not be committed.  Do you want to proceed?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        dialog.close(null);
                    } else {
                        loadValuesForType();
                    }
                });
        } else {
            dialog.close(null);
        }
    };

    // Loading a date option in the UI for the first time.
    function setDateSourceSelector(item, date) {
        if (date.dateSourceSelector) {
            return;
        }

        if (date.dateSource === 'Dynamic' && !date.expression) {
            date.dateSourceSelector = item.startDateMethod;
        } else {
            date.dateSourceSelector = date.dateSource;
        }
    }

    function prepareDateForSave(item) {
        prepareStartDateForSave(item, item.start);
        prepareEndDateForSave(item, item.end);
    }

    function prepareStartDateForSave(item, date) {
        if (date.dateSourceSelector === 'Dynamic') {
            date.dateSource = 'Dynamic';
            date.date = null;
            item.startDateMethod = "Inception";
        } else if (date.dateSourceSelector === 'Static') {
            date.dateSource = 'Static';
            date.date = Date.create(date.date).formatted();
            date.expression = null;
            item.startDateMethod = "Inception";
        } else {
            date.dateSource = 'Dynamic';
            date.expression = null;
            date.date = null;
            item.startDateMethod = date.dateSourceSelector;
        }
    }

    function prepareEndDateForSave(item, date) {
        if (date.dateSourceSelector === 'Dynamic') {
            date.dateSource = 'Dynamic';
            date.date = null;
        } else if (date.dateSourceSelector === 'Static') {
            date.dateSource = 'Static';
            date.date = Date.create(date.date).formatted();
            date.expression = null;
        }
    }

    // Returns true if the date is not valid
    function isDateInvalid(item, date) {
        return (date.dateSourceSelector === 'Static' && (!date.date || date.date.length === 0)) || (date.dateSourceSelector === 'Dynamic' && (!date.expression || date.expression.length === 0));
    }

    // Update the display value of the dynamic expression
    $scope.updateDate = function (currentDate) {
        if (currentDate.dateSourceSelector === "Dynamic") {
            $http.post('/Utility/DateExpressions', [currentDate.expression], { trackerMsg: 'Evaluating date expression' })
                .then(function (response) {
                    currentDate.display = response.data[0].date;
                });
        }
    };

    $scope.updateCalculation = function (calcOption) {
        if (calcOption.calculation) {
            const expressions = [];

            expressions.push(calcOption.calculation);
            $http.post('/Utility/ValidateExpressions', expressions, { trackerMsg: 'Evaluating expression' })
                .then(function (response) {
                    const exp = response.data[0];

                    if (exp.isValid) {
                        $scope.current.errorMessage = "";
                    } else {
                        $scope.current.errorMessage = "Invalid expression";
                    }
                });
        } else {
            $scope.current.errorMessage = "No expression";
        }
    };

    $scope.filterTagsForCalculation = function (o) {
        const result =
            //don't allow calculation tags to prevent circular references
            !o.path.startsWith('Calculation.')

            //allow any number type
            && ['numeric', 'currency', 'decimal', 'percent'].any(o.resultType);
        return result;
    };

    $scope.addActivity = function () {
        const detail = {
            $type: $scope.current.selectedActivity.category.toLowerCase(),
            flipSign: false,
            isManaged: true
        };

        switch ($scope.current.selectedActivity.category) {
            case 'Activity':
                detail.activityType = $scope.current.selectedActivity.name;
                break;
            case 'Valuation':
                detail.valuationMethod = $scope.current.selectedActivity.name;
                break;
            default:
                detail.$type = 'transaction';
                detail.name = $scope.current.selectedActivity.name;
                detail.transTypeId = $scope.current.selectedActivity.id;
                detail.inclusionOption = "All";
                break;
        }

        $scope.current.item.details.push(detail);
    };

    $scope.removeActivity = function (detail) {
        $scope.current.item.details.remove(detail);
    };

    $scope.addComparisonBenchmark = function () {
        const selected = $scope.current.selectedComparisonBenchmark;

        if (selected && selected.id > 0) {
            const selectedKey = contextChangeHelper.comparisonBenchmarkKey(selected);
            const alreadyAdded = ($scope.current.item.benchmarks || []).some(function (b) {
                return contextChangeHelper.comparisonBenchmarkKey(b) === selectedKey;
            });

            if (alreadyAdded) {
                $scope.current.benchmarkNotice = selected.name + " has already been added to this comparison option.";
            } else {
                $scope.current.benchmarkNotice = '';
                $scope.current.item.benchmarks.push(selected);
            }

            $scope.current.selectedComparisonBenchmark = null;
        }
    };

    $scope.validationCheck = function (type) {
        let result = false;
        switch (type) {
            case 'activity':
                result = $scope.current.errorMessage.length > 0 || $scope.current.itemList.some(function (item) { return !item.details || item.details.length === 0; });
                break;
            case 'calculation':
                result = $scope.current.errorMessage.length > 0;
                break;
            case 'comparison':
                result = $scope.current.errorMessage.length > 0
                    || contextChangeHelper.comparisonListValid($scope.current.itemList) === false
                    || $scope.current.itemList.some(function (item) { return contextChangeHelper.comparisonHasDuplicateBenchmarks(item); });
                break;
            case 'statistical':
                result = $scope.current.errorMessage.length > 0 || contextChangeHelper.statisticalListValid($scope.current.itemList) === false;
                break;
            case 'daterange':
                result = $scope.current.itemList.some(function (item) {
                    return isDateInvalid(item, item.start) || isDateInvalid(item, item.end);
                });
                break;

            case 'maturity-period':
                result = $scope.current.errorMessage.length > 0 || $scope.current.itemList.some(function (item) {
                    return !item.ranges || item.ranges.length === 0;
                });
                break;
            case 'performance':
            case 'trading':
            case 'costbasis':
            case 'income':
            case 'billing':
            case 'transaction-option':
            default:
                break;
        }
        return result;
    };

    $scope.uniqueActivityLabel = function (detail) {
        let labelName = '';
        if (detail.$type === 'activity') {
            labelName = detail.activityType;
        }
        else if (detail.$type === 'valuation') {
            labelName = detail.valuationMethod;
        }
        else if (detail.$type === 'transaction') {
            labelName = detail.name;
        }

        const whitespace = /\s/g;
        return labelName.replace(whitespace, '');
    };

    //INITIALIZE
    $scope.current = {
        type: args.type,
        itemList: angular.copy(args.itemList),
        action: args.action,
        selectedComparisonBenchmark: null,
        selectedBillPayMethod: null,
        selectedBillTypes: null,
        errorMessage: '',
        benchmarkNotice: '',
        submitButtonText: args.submitButtonText ? args.submitButtonText : 'OK',
        isGlobalEditor: !!args.isGlobalEditor,
        submitBeforeCloseCallBack: args.submitBeforeCloseCallBack
    };

    $scope.canEditReportSettings = $oasRights.canUpdate("REPORTSETTINGS");
    $scope.canReadReportSettings = $oasRights.canRead("REPORTSETTINGS");
    $scope.canDeleteReportSettings = $oasRights.canDelete("REPORTSETTINGS");

    if ($scope.current.itemList.length > 0) {

        $scope.current.item = $scope.current.itemList.find({ optionId: args.item });
        //check if the option is not found 
        if (!$scope.current.item) {
            $scope.current.item = setMissingOption();
        }
    } else {
        $scope.addOption();
    }

    // length of Name in tblReportDataStoreGeneralOptions
    $scope.nameLimit = 255;


    function setMissingOption() {
        ///Add 1000 to the Id as global if missing 
        let setOption = $scope.current.itemList.find({ optionId: 1000 + args.item });

        if (!setOption) {
            ///Subtract -1000 to the Id as global if missing 
            setOption = $scope.current.itemList.find({ optionId: -1000 - args.item });
        } else if (!setOption) {
            // If an option not found set to default to the first option in the array
            setOption = $scope.current.itemList[0];
        }
        return setOption;
    }

    //Date Range lists
    $scope.startDateMethods = [
        { id: 0, value: "Inception", display: "Inception", isEnabled: true },
        { id: 1, value: "Holding Period", display: "Holding Period", isEnabled: true },
        { id: 2, value: "AIP Ledger", display: "AIP Ledger", isEnabled: true }
    ];

    //Performance lists
    $scope.perfCalculationMethods = ["Time-weighted return", "Simple", "Internal rate of return"];
    $scope.perfFeeMethods = ["Net Of Fees", "Gross Of Fees"];
    $scope.perfTaxMethods = ["Before-Tax", "After-Tax"];
    fields.performance.standard.forEach(function (field) {
        $scope[field] = ["True", "False"];
    });

    perfDefaults = angular.copy($scope.current.itemList.find({ isDefault: true }));
    if (perfDefaults && $scope.current.type === 'performance') {
        fields.performance.all.forEach(function (field) {
            const defaultValueCapitalized = contextChangeHelper.getPerformanceDefaultValueCapitalized(field.name || field, perfDefaults);

            if (defaultValueCapitalized !== null) {
                $scope[field.source || field].unshift("Use Default ( " + defaultValueCapitalized + " )");
            }
        });
    }

    //income lists
    $scope.modifiedDurationMarketDates = ["Maturity Date", "Pre Refunded Date", "Next Call Date"];
    $scope.annualDividendRateMethods = ["Use Total for Last 12 Months", "Use Last Div By Frequency", "IDSI Indicated Annual Dividend"];
    $scope.dividendDates = ["ExDate", "PayDate"];
    fields.income.standard.forEach(function (field) {
        $scope[field] = ["True", "False"];
    });

    //billing lists
    $scope.billingReturns = ["All Bills", "Last Bill Only", "All Mock Bills", "Last Mock Bill"];
    $scope.billPayMethods = { ACH: "ACH", Check: "Check", CreditCard: "Credit Card", Direct: "Direct", Indirect: "Indirect", NoFee: "No Fee", NonManaged: "Non Managed", SpecialInstructions: "Special Instructions" };
    $scope.billTypes = { Renewal: "Renewal", NewMoney: "New Money", NewAccount: "New Account", FinancialPlanningFee: "Financial Planning Fee", Performance: "Performance", AdvanceCreditDebit: "Advance Credit/Debit" };
    fields.billing.standard.forEach(function (field) {
        $scope[field] = ["True", "False"];
    });
    //maturity period lists
    $scope.ranges = { start: 0, end: 0, interval: "Days" };
    $scope.maturityPeriodInterval = ["Days", "Years"];
    //calculation lists
    $scope.resultTypes = ["Decimal", "Currency", "Percent"];
    //costbasis
    $scope.displayGainsOrLosses = ["Both", "Gains", "Losses"];

    init();

    if ($scope.current.action === 'add') {
        if ($scope.current.type === 'performance') {
            setOptionsToValuesForType($scope.current.item);
        }
        $scope.addOption();
        init();
    } else if ($scope.current.action === 'clone') {
        if ($scope.current.type === 'performance') {
            const oldItem = angular.copy($scope.current.item);
            setOptionsToValuesForType($scope.current.item);
            $scope.addOption(oldItem);
        } else {
            $scope.addOption($scope.current.item);
        }
        init();
    }
    function hasDuplicate(items) {
        return items.count({ isManaged: true }) > 1 || items.count({ isManaged: false }) > 1;
    }

    function hasDuplicateActivities(items) {
        var hasDuplicates = false;
        Object.keys(items).each(function (category) {
            if (hasDuplicate(items[category])) {
                hasDuplicates = true;

            }
        });
        return hasDuplicates;
    }

    //SCOPE WATCHERS
    $scope.$watch('current.item', function (newValue, oldValue) {
        if (newValue === oldValue) return;

        setOptionsToValuesForType(oldValue);

        init();
    });

    $scope.$watch('current.item.details', function (newValue, oldValue) {
        if ($scope.current.type !== 'activity') return;

        var hasDuplicates = $scope.current.itemList.filter(function (item) {
            var categoryTypes = item.details.groupBy('$type');

            var activities = typeof categoryTypes['activity'] !== 'undefined' ? categoryTypes['activity'].groupBy('activityType') : [];
            var valuations = typeof categoryTypes['valuation'] !== 'undefined' ? categoryTypes['valuation'].groupBy('valuationMethod') : [];
            var transaction = typeof categoryTypes['transaction'] !== 'undefined' ? categoryTypes['transaction'].groupBy('transTypeId') : [];

            return hasDuplicateActivities(activities) || hasDuplicateActivities(valuations) || hasDuplicateActivities(transaction);
        });

        if (hasDuplicates.length > 0) {
            $scope.current.errorMessage = "<b>Duplicate Activities:</b> The following options have one or more duplicate activities. Remove the duplicate activity or update to opposite managed assets settings.<br /><ul>";

            hasDuplicates.each(function (item) {
                $scope.current.errorMessage += "<li>" + item.name + "</li>";
            });
            $scope.current.errorMessage += "</ul>";
        } else {
            $scope.current.errorMessage = "";
        }
        if ($scope.current.itemList.some(function (item) { return item.details.length === 0; })) {
            $scope.current.errorMessage += "<b>No Activity Categories:</b> At least one activity option has no categories assigned.";
        } else {
            $scope.current.errorMessage += "";
        }
    }, true);

    $scope.$watch('current.item.benchmarks', function (newValue, oldValue) {
        if ($scope.current.type !== 'comparison') return;

        $scope.current.benchmarkNotice = '';

        const duplicates = $scope.current.itemList.filter(function (item) {
            return contextChangeHelper.comparisonHasDuplicateBenchmarks(item);
        });

        if (contextChangeHelper.comparisonListValid($scope.current.itemList) === false) {
            $scope.current.errorMessage = "<b>No Benchmarks Assigned:</b> At least one comparison option has no benchmark assigned.";
        } else if (duplicates.length > 0) {
            $scope.current.errorMessage = "<b>Duplicate Benchmarks:</b> The following options use the same benchmark more than once. Remove the duplicate benchmark.<br /><ul>";

            duplicates.each(function (item) {
                $scope.current.errorMessage += "<li>" + item.name + "</li>";
            });

            $scope.current.errorMessage += "</ul>";
        } else {
            $scope.current.errorMessage = "";
        }
    }, true);

    $scope.comparisonSpecialName = function (name) {
        return contextChangeHelper.comparisonSpecialName(name);
    };

    $scope.addRange = function () {
        var start = $scope.ranges.start;
        var end = $scope.ranges.end;
        var interval = $scope.ranges.interval;
        if ($scope.current.item.ranges.none(function (range) { return angular.equals(start, end) || (range.start.value === start && range.end.value === end && range.start.interval === interval && range.end.interval === interval); })) {
            $scope.current.item.ranges.push({ start: { value: start, interval: interval }, end: { value: end, interval: interval } });
            let intervalGroup = $scope.current.item.ranges.groupBy(function (r) { return r.start.interval; });

            let sortedArray = [];
            $scope.maturityPeriodInterval.forEach(function (k) {
                if (intervalGroup[k]) {
                    intervalGroup[k] = intervalGroup[k].sort(compare);
                    sortedArray = sortedArray.concat(intervalGroup[k]);
                }
            });
            $scope.current.item.ranges = sortedArray;
        }
    };
    function compare(a, b) {
        if (a.start.value > b.start.value) {
            return 1;
        } else {
            return -1;
        }
    }
    $scope.deleteRange = function (index) {
        $scope.current.item.ranges.splice(index, 1);
    };

    $scope.$watchGroup(['current.item.marketBenchmark', 'current.item.riskFreeBenchmark'], function (newValue, oldValue) {
        if ($scope.current.type !== 'statistical') return;

        if (contextChangeHelper.statisticalListValid($scope.current.itemList) === false) {
            $scope.current.errorMessage = "<b>No Benchmarks Assigned:</b> At least one statistical option has no benchmark assigned.";
        } else {
            $scope.current.errorMessage = "";
        }
    });

    $scope.statisticalSpecialName = function (name) {
        return contextChangeHelper.statisticalSpecialName(name);
    };

    $scope.handleSelectedInceptionValueMethodChange = function (selectedInceptionValueMethod) {
        $scope.current.item.inceptionValueMethod = selectedInceptionValueMethod;
    };
});
'use strict';

app.controller('QueryBuilderWizardCtrl', [
    '$scope',
    '$http',
    '$q',
    '$dialog',
    '$timeout',
    '$oasRights',
    '$dataQuery',
    'dialog',
    'popupBlockerChecker',
    'reportService',
    'reportCopyService',
    'reportHelper',
    'resolveHelper',
    'queryId',
    'isNew',
    'isClone',
    function QueryBuilderWizardCtrl(
        $scope,
        $http,
        $q,
        $dialog,
        $timeout,
        $oasRights,
        $dataQuery,
        dialog,
        popupBlockerChecker,
        reportService,
        reportCopyService,
        reportHelper,
        resolveHelper,
        queryId,
        isNew,
        isClone
    ) {
        //PRIVATE VARIABLES
        var selectedColumnIterator = 0;

        //PRIVATE METHODS
        function init() {
            if (!resolveHelper.loaded) {
                $timeout(init, 100);//need to wait on resolveHelper being done loading
                return;
            }

            $http
                .get('/Reporting/Envision/ExcelReports/Categories', {
                    trackerMsg: 'Loading categories',
                })
                .then(function (response) {
                    $scope.categories = response.data;
                });

            $http
                .get('/Trading/TransactionTypes?isUsed=true&includeRemark=false', {
                    trackerMsg: 'Loading transaction types'
                })
                .then(function (response) {
                    $scope.transTypes = response.data.sortBy('financialType').groupBy('financialType');
                });

            let queryCopy;
            const promises = {};
            const globalSettings = dialog.options.resolve.globalSettings();

            promises.query = reportHelper
                .getQuery(isNew && !queryId, queryId, null, globalSettings)
                .then(function(query) {
                    if (isNew || isClone) {
                        queryCopy = query;
                        return reportService.getNewExcelReport();
                    } else {
                        return $q.resolve(query);
                    }
                })
                .then(function(response) {
                    let data = response.data ? response.data : response;
                    if (queryCopy) {
                        data = reportCopyService.reportCopySetData(data, queryCopy, isClone);
                    }

                    findDateRangeOptionIdx(data.requiredOptions);

                    if($scope.dateRangeOptionIdx >= 0) {
                        $scope.dateRanges = [
                            data.requiredOptions[$scope.dateRangeOptionIdx],
                        ];
                    } else {
                        $scope.dateRanges = [];
                    }
                    $scope.dateRanges = $scope.dateRanges
                        .add(
                            data.additionalOptions.find({
                                category: 'Date Ranges',
                            }).options
                        )
                        .sortBy('name');

                    // activity
                    //The first part is checking to make sure that there was not more
                    //than one set of activity options were added to required options
                    var activityOptionIndices = [];
                    data.requiredOptions.forEach((option, index) => {
                        if(option.$type === 'activity') {
                            activityOptionIndices.push(index);
                        }
                    });
                    //We want to keep the last activity option, so remove the last one
                    activityOptionIndices.pop();
                    //If there are any sets of activity options left, then remove them from required options
                    activityOptionIndices.forEach((activityOptionIndex) => {
                        data.requiredOptions.splice(activityOptionIndex, 1);
                    });

                    //Now we can find the index of the remaining activity option
                    $scope.activityOptionIdx = data.requiredOptions.findIndex({
                        $type: 'activity',
                    });

                    if ($scope.activityOptionIdx !== -1) {
                        $scope.activityOption =
                            data.requiredOptions[$scope.activityOptionIdx];
                    }

                    $scope.entitySelector = data.requiredOptions.find({
                        $type: 'select-entity',
                    });
                    if (!data.schema.contextChange.reportCategoryId) {
                        data.schema.contextChange.reportCategoryId = 0;
                    }
                    $scope.query = data;
                    return data;
                });

            $scope.columns.available = resolveHelper.options
            .exclude({ $type: 'parent' })
            .sortBy('label');

            $q.all(promises).then(function () {
                handleFilters();
                $scope.columns.selected = $scope.query.schema.workBook.controls[0].control.groupings[0].body.rows[0].columns
                .map(function (queryColumn) {
                    const queryColumnValue = resolveHelper.parseResolveJson(queryColumn.control.value);

                    let foundColumn = { ...$scope.columns.available.find(x => x.path === queryColumnValue.path) };
                    
                    if(foundColumn && foundColumn.$type === 'option-value'){
                        var map = reportHelper.getMap(
                            foundColumn.optionType,
                            true
                        );

                        if(queryColumnValue[map.propertyName]) {
                            foundColumn = { ...$scope.columns.available.find(x => x.path === queryColumnValue.path && x[map.propertyName] === queryColumnValue[map.propertyName]) };
                        }
                    }

                    if (foundColumn) {
                        foundColumn.selected = true;
                        foundColumn.control = queryColumn.control;
                    }

                    return foundColumn;
                })
                .compact() //purge any columns that existed before but don't anymore (foundColumn = undefined)
                .map(function (col){
                    return { ...col, trackBy: selectedColumnIterator++ };
                });
            });

            reportHelper.getGroupingOptions().then(function (options) {
                $scope.groupings = options.filter(function (o) {
                    //US9444 - Remove the below options for row grouping until we can properly handle context changes
                    return [
                        'Activity Options',
                        'Benchmark',
                        'Bill',
                        'Billing Adjustment',
                        'Billing Fee Schedule',
                        'Billing Tier',
                        'Date Ranges',
                        'Prospect',
                        'Time',
                    ].none(o.name);
                });
                $scope.groupings.forEach(function (option) {
                    option.fullOptions = reportHelper.getExpandedOptions(
                        option.options
                    );
                    option.fullOptionLists = reportHelper.getExpandedOptions(
                        option.optionLists
                    );
                });
            });
        }
        
        function handleFilters() {
            var filters = $scope.getFilters('filter');
            if (filters) {
                var oldFilters = $scope.query.schema.workBook.controls[0].control.groupings[0].filter.filters.filter(
                    function (f) {
                        return !f.id;
                    }
                );
                var temp = angular.copy(oldFilters);
                oldFilters.each(function (f) {
                    $scope.query.schema.workBook.controls[0].control.groupings[0].filter.filters.remove(
                        f
                    );
                });
                filters.filters.add(temp);
            }
        }

        function findDateRangeOptionIdx(requiredOptions) {
            $scope.dateRangeOptionIdx = requiredOptions.findIndex(ro => {
                return ['date','daterange'].some(ro.$type);
            });
        }

        function formatFromDateIfDateObjectValue(value) {
            if (value?.year && value?.month && value?.day) {
                return `${value.year}-${value.month}-${value.day}`;
            }

            return value;
        }

        function setAll(checked, selected, transTypes) {
            selected.length = 0;
    
            if (checked) {
                Object.keys(transTypes).each(function(i){
                    for( let j = 0; j < transTypes[i].length; j++ ) {
                        selected.push(String(transTypes[i][j].id));
                    }
                });
            }
        };

        function matchSelected(transTypes, selected) {
            let types = [];
    
            Object.keys(transTypes).each(function(i){
                for( let j = 0; j < transTypes[i].length; j++) {
                    if(isItemChecked(String(transTypes[i][j].id), selected)) {
                        types.push(transTypes[i][j]);
                    }
                }
            });
    
            return types;
        }

        function isItemChecked(id, selected) {
            return selected.indexOf(String(id)) !== -1;
        };

        function createActivityOption(activityID, types, inceptionValueMethod) {
            let options = [];
            let option = {
                id: "activity " + activityID,
                $type: "activity",
                optionId: activityID,
                name: "Transactions",
                inceptionValueMethod,
                details: []
            }
    
            types.each(function(i) {
                option.details.push(
                    {
                        $type: "transaction",
                        transTypeId: i.id,
                        name: i.description,
                        inclusionOption: "All",
                        isManaged: true,
                        flipSign: false
                    }
                );
            });
            options.push(option);
    
            return options;
        }

        function applyRequiredOption(response) {
            if (response) {
                //We want to make sure there are details in the activity option before we push a set to required options
                if ($scope.activityOptionIdx === -1 && response[0].details.length > 0) {
                    $scope.query.requiredOptions.push.apply(
                        $scope.query.requiredOptions,
                        response
                    );
                    //Update the activity option index once added to required options
                    $scope.activityOptionIdx = $scope.query.requiredOptions.findIndex({
                        $type: 'activity',
                    });
                } else {
                    if(response[0].details.length > 0) {
                        //only add if there are details in the activity option
                        $scope.query.requiredOptions[$scope.activityOptionIdx] = response[0];
                    } else {
                        //remove activity option from required options if there are no details
                        var activityOption = $scope.query.requiredOptions[$scope.activityOptionIdx];
                        $scope.query.requiredOptions.remove(activityOption);
                    }
                }
                //update activity option since this is what is used in the transactions editor screen
                $scope.activityOption = $scope.query.requiredOptions[$scope.activityOptionIdx];
                $scope.query.schema.contextChange.activityOptionId =
                    response[0].optionId;
            }
        };

        function getActivityID() {
            let activityID = -999;

            if ($scope.activityOptionIdx === -1) {
                $scope.addlActivityOptions = $scope.query.additionalOptions.find(
                    { category: 'Activity Options' }
                ).options;
                activityID =
                    Math.max.apply(
                        Math,
                        $scope.addlActivityOptions.map(function (
                            o
                        ) {
                            return o.optionId;
                        })
                    ) + 1;
            } else {
                activityID = $scope.activityOption.optionId;
            }

            return activityID;
        };

        //PUBLIC METHODS
        $scope.addNewCategory = function () {
            $dialog
                .inputBox('New Category', 'Category Name')
                .open()
                .then(function (result) {
                    if (!result) {
                        return;
                    }

                    if ($scope.categories.none(result)) {
                        $scope.categories.push(result);
                    }

                    $scope.query.portfolio.category = result;
                });
        };

        /**
         * When the user selects Transaction level row grouping, default the selected list of Transtypes to select all.
         * Also defaults the InceptionValueMethod to 'New Money'.
         * @param {*} selectedOption The selected Row Grouping value.
         */
        $scope.handleTransTypes = (selectedOption) => {
            if (selectedOption == "Transaction") {
                $scope.selected = [];
                setAll(true, $scope.selected, $scope.transTypes);
                let transTypes = matchSelected($scope.transTypes, $scope.selected);
                let activityOption = createActivityOption(getActivityID(), transTypes, "New Money");
                applyRequiredOption(activityOption);
            }
        };

        $scope.launchTransEditor = function () {
            const d = $dialog.dialog({
                templateUrl:
                    'reporting/envision/modals/QueryBuilderTransOptions.html',
                controller: 'QueryBuilderTransOptionsCtrl',
                resolve: {
                    args: function () {
                        let act = {
                            setAll,
                            isItemChecked,
                            matchSelected,
                            createActivityOption,
                            selected: [],
                            activityID: getActivityID(),
                            transTypes: $scope.transTypes,
                            inceptionValueMethod: $scope.activityOption.inceptionValueMethod
                        };

                        if ($scope.activityOptionIdx !== -1) {
                            act.selected = $scope.activityOption.details.map(
                                function (o) {
                                    return o.transTypeId;
                                }
                            );
                        }

                        return act;
                    },
                }
            });

            d.open().then(function (response) {
                applyRequiredOption(response);
            });
        };

        $scope.setDefaultRunForOption = function (runForOption) {
            if (!$scope.query.portfolio.canEdit) {
                return;
            }

            $scope.entitySelector.entity = runForOption;
        };

        $scope.toggleRunForOption = function (runForOption) {
            if (!$scope.query.portfolio.canEdit) {
                return;
            }

            const options = $scope.entitySelector.options;

            if (options.any(runForOption)) {
                if ($scope.entitySelector.entity !== runForOption) {
                    options.remove(runForOption);
                }
            } else {
                options.push(runForOption);
            }
        };

        $scope.activateResolve = function (column) {
            column.isResolveActive = true;
        };

        $scope.pushColumn = function (column) {
            var resolveTag = resolveHelper.findResolveOption(column);
            
            column.control = {
                $type: 'rcStringResolverCompact',
                isHtml: false,
                value: resolveTag.encode(),
            };

            // Our trackBy column is purely to avoid angular dupe errors in the ng-repeat now that we can add the same column again.
            $scope.columns.selected = [...$scope.columns.selected, { ...column, trackBy: selectedColumnIterator++ }];
        };

        $scope.removeColumn = function (column) {
            $scope.columns.selected = $scope.columns.selected.filter(col => col.trackBy !== column.trackBy);
        };

        $scope.reorderColumns = function (cols) {
            $scope.columns.selected = cols;
        };

        $scope.clearColumnSearch = function () {
            $scope.current.columnSearch = '';
        };

        $scope.removeFilter = function (filter, type) {
            var collection = $scope.getFilters(type);
            if (collection && collection.filters.length > 0) {
                collection.filters.remove(filter);
            }
        };

        $scope.getFilters = function (type) {
            return $scope.query &&
                $scope.query.schema &&
                $scope.query.schema.workBook &&
                $scope.query.schema.workBook.controls
                ? $scope.query.schema.workBook.controls[0].control.groupings[0].filter.filters.filter(
                      function (f) {
                          return f.id && f.id.includes(type);
                      }
                  )[0]
                : [];
        };

        $scope.back = function () {
            var backStep = function () {
                $scope.current.animation = 'slide-left';
                $scope.current.wizardStep =
                    $scope.wizardSteps[
                        $scope.wizardSteps.indexOf($scope.current.wizardStep) -
                            1
                    ];
            };

            if ($scope.current.wizardStep.preBackStep) {
                $scope.current.wizardStep.preBackStep().then(backStep);
            } else {
                backStep();
            }
        };

        $scope.next = function () {
            var nextStep = function () {
                $scope.current.animation = 'slide-right';
                $scope.current.wizardStep =
                    $scope.wizardSteps[
                        $scope.wizardSteps.indexOf($scope.current.wizardStep) +
                            1
                    ];
            };

            if ($scope.current.wizardStep.name === "Columns") {
                var isDuplicateColumnName = $scope.columns.selected.some((col, idx) => {
                    var columnLabel = resolveHelper.parseResolveJson(col.control.value).label || col.label;
                    var dupIdx = $scope.columns.selected.slice(idx + 1).findIndex(c => {
                        return (resolveHelper.parseResolveJson(c.control.value).label || c.label) === columnLabel;
                    });
    
                    return dupIdx >= 0;
                });

                if (isDuplicateColumnName) {
                    return $dialog.dialog({
                        templateUrl: 'reporting/envision/modals/QueryBuilderDuplicateColumnNameWarning.html',
                        controller: 'QueryBuilderDuplicateColumnNameWarningCtrl'
                    })
                    .open();
                }
            }

            if ($scope.current.wizardStep.preNextStep) {
                $scope.current.wizardStep.preNextStep().then(nextStep);
            } else {
                nextStep();
            }
        };

        $scope.jumpBackTo = function (index) {
            if (
                $scope.mainTracker.active() ||
                index >= $scope.wizardSteps.indexOf($scope.current.wizardStep)
            ) {
                return;
            }

            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = $scope.wizardSteps[index];
        };

        $scope.saveTemplate = function (postSaveAction) {
            //rebuild entity array to preserve sort order
            const entities = angular.copy($scope.entitySelector.options);
            $scope.entitySelector.options = $scope.runForOptions
                .map(function (option) {
                    return entities.any(option) ? option : null;
                })
                .compact();

            //rebuild grouping table's header and body columns
            const grouping =
                $scope.query.schema.workBook.controls[0].control.groupings[0];
            const headerColumns = grouping.overallHeader.rows[0].columns;
            const bodyColumns = grouping.body.rows[0].columns;
            headerColumns.length = 0;
            bodyColumns.length = 0;

            $scope.columns.selected.forEach(function (selectedColumn, index) {
                const queryColumnValue = resolveHelper.parseResolveJson(selectedColumn.control.value);
                const headerColumn = {
                    name: 'Col ' + (index + 1),
                    colspan: 1,
                    control: {
                        $type: 'rcStringResolverCompact',
                        isHtml: false,
                        value: queryColumnValue.label || selectedColumn.label,
                    },
                };
                headerColumns.push(headerColumn);

                const bodyColumn = angular.copy(headerColumn);
                bodyColumn.control = selectedColumn.control;
                bodyColumns.push(bodyColumn);
            });


            var selectedGroup = $scope.groupings.find({name: $scope.query.schema.workBook.controls[0].control.groupings[0].value});
            var useDateRange = selectedGroup?.options?.some("DateRange") ||
                $scope.columns.selected.some(column => { return column.options?.some("DateRange"); });

            var filters = $scope.getFilters('filter')?.filters;
            if (filters)
            {
                // convert object date to valid date
                filters.forEach(function (dr) {
                    switch (dr.$type) {
                        case 'date-equal':
                        case 'date-not-equal': 
                            dr.haystack[0] = formatFromDateIfDateObjectValue(dr.haystack[0]);
                            break;
                        case 'date-less-than':
                        case 'date-less-than-equal':
                            dr.upper = formatFromDateIfDateObjectValue(dr.upper);
                            break;
                        case 'date-greater-than':
                        case 'date-greater-than-equal': 
                            dr.lower = formatFromDateIfDateObjectValue(dr.lower);
                            break;
                        case 'date-range':
                            dr.lower = formatFromDateIfDateObjectValue(dr.lower);
                            dr.upper = formatFromDateIfDateObjectValue(dr.upper);
                            break;
                    }
                });
            }

            findDateRangeOptionIdx($scope.query.requiredOptions);
            let defaultDateRange = $scope.query.requiredOptions[$scope.dateRangeOptionIdx];
            if(useDateRange) {
                //use date range
                if(!defaultDateRange || defaultDateRange.$type === 'date') //this is as-of-date. will default to period
                {
                    $scope.query.requiredOptions.remove(defaultDateRange);
                    defaultDateRange = angular.copy($scope.dateRanges.find({name: 'Period'}));
                    defaultDateRange.prompt = 'Always';
                    $scope.query.requiredOptions.add(defaultDateRange);
                } else {
                    defaultDateRange.prompt = 'Always';
                    if (defaultDateRange.name === "Inception") defaultDateRange.useInception = true;
                    if($scope.dateRangeOptionIdx === -1) {
                        $scope.query.requiredOptions.add(defaultDateRange);
                    }
                }
                $scope.query.schema.contextChange.dateRangeId = defaultDateRange.optionId;
            } else {
                //use as of date
                if(!defaultDateRange || defaultDateRange.$type === 'daterange') //this is daterange. will replace with as of date
                {
                    $scope.query.requiredOptions.remove(defaultDateRange);
                    var newOptionId = ($scope.dateRanges.max("optionId").optionId + 1);
                    defaultDateRange = {
                        "id": `daterange ${newOptionId}`,
                        "$type": "date",
                        "value": {
                            "date": null,
                            "expression": "/m",
                            "dateSource": "Dynamic"
                        },
                        "name": "As Of Date",
                        "dataMustExistOnRangeStartDate": false,
                        "dataMustExistOnRangeEndDate": false,
                        "allowStartDateAdjustment": true,
                        "startDateMethod": "Inception",
                        "optionId": newOptionId,
                        "isDisabled": false,
                        "isGlobal": null,
                        "prompt": "Always"
                    };
                    $scope.query.requiredOptions.add(defaultDateRange);
                    $scope.query.schema.contextChange.dateRangeId = defaultDateRange.optionId;
                } else {
                    if($scope.dateRangeOptionIdx === -1) {
                        $scope.query.requiredOptions.add(defaultDateRange);
                    }
                    $scope.query.schema.contextChange.dateRangeId = defaultDateRange.optionId;
                }
            }

            const additionalDateRanges = $scope.dateRanges.exclude(dr => {
                return dr.$type === 'date' || dr.id === defaultDateRange?.id;
            });
            additionalDateRanges.forEach(function (dr) {
                //remove the prompt property from the additional parameters
                dr.prompt = undefined;
            });
            $scope.query.additionalOptions.find({
                category: 'Date Ranges',
            }).options = additionalDateRanges;

            const args = $scope.query.id
                ? {
                      method: 'put',
                      id: $scope.query.id,
                      trackerMsg: 'Saving ' + $scope.query.portfolio.name,
                  }
                : { method: 'post', id: '', trackerMsg: 'Creating new query' };

            $http[args.method](
                '/Reporting/Envision/ExcelReports/Verbose/' + args.id,
                $scope.query,
                { trackerMsg: args.trackerMsg }
            ).then(function (response) {
                $scope.close(response.data);

                if (postSaveAction === 'run') {
                    $timeout(function () {
                        $dataQuery.runExcelReport(response.data.id);
                }, 300);
                }
            });
        };

        $scope.runQuery = function (queryId) {
            $scope.close();
            $timeout(function () {
                $dataQuery.runExcelReport(queryId);
            }, 300);
        };

        $scope.placeholderFunc = function (filterCollection) {
            $scope.query.schema.workBook.controls[0].control.groupings[0].filter = filterCollection;
        }

        $scope.handleRequiredOptionsChange = function (options) {
            $scope.query.requiredOptions.remove(function (opt) {
                return (
                    opt?.$type === 'prompt'
                );
            });

            if (options) $scope.query.requiredOptions.push(...options);
        }

        $scope.close = function (result) {
            if (!$scope.current.isFullPage) {
                dialog.close(result);
            }
        };

        $scope.showSave = function () {
            return $scope.current.wizardStep === $scope.wizardSteps.last() || $scope.query?.id;
        };

        $scope.showSaveAndRun = function () {
            return $scope.current.wizardStep === $scope.wizardSteps.last() || $scope.query?.id;
        };

        $scope.promptCheck = function (chgFilter) {
            function updatePromptOption(param, label, filterType, type) {
                if (
                    !$scope.query.requiredOptions.find({
                        $type: 'prompt',
                        optionId: param.promptOptionId,
                    })
                ) {
                    var prompt = {
                        id: 'prompt ' + param.promptOptionId,
                        $type: 'prompt',
                        optionId: param.promptOptionId,
                        name: label,
                        description: label,
                        value: '',
                        resultType: type.split('-')[0].capitalize(),
                        filterType: filterType,
                        prompt: 'Always',
                        isRequired: true,
                    };
                    $scope.query.requiredOptions.add(prompt);
                }
            }

            function removeUnusedPromptOptions(usedOptionIds) {
                $scope.query.requiredOptions.remove(function (o) {
                    return (
                        o.$type === 'prompt' && usedOptionIds.none(o.optionId)
                    );
                });
            }

            function managePromptOptions(filters) {
                var optionIds = [];
                filters.each(function (f) {
                    var prop = '';
                    if (f.needles) {
                        prop = 'needles';
                    } else if (f.haystack) {
                        prop = 'haystack';
                    } else if (f.lower) {
                        prop = 'lower';
                    } else {
                        prop = 'upper';
                    }

                    if (angular.isArray(f[prop])) {
                        f[prop].each(function (p) {
                            updatePromptOption(
                                p,
                                f.label,
                                f.selectedFilterType,
                                f.$type
                            );
                            optionIds.add(p.promptOptionId);
                        });
                    } else {
                        if (
                            prop === 'lower' &&
                            f.selectedFilterType === 'range'
                        ) {
                            updatePromptOption(
                                f[prop],
                                f.label + ' From',
                                f.selectedFilterType,
                                f.$type
                            );
                            updatePromptOption(
                                f.upper,
                                f.label + ' To',
                                f.selectedFilterType,
                                f.$type
                            );
                            optionIds.add(f[prop].promptOptionId);
                            optionIds.add(f.upper.promptOptionId);
                        } else {
                            updatePromptOption(
                                f[prop],
                                f.label,
                                f.selectedFilterType,
                                f.$type
                            );
                            optionIds.add(f[prop].promptOptionId);
                        }
                    }
                });
                removeUnusedPromptOptions(optionIds.unique());
            }

            $scope.query.schema.workBook.controls[0].control.groupings[0].filter = chgFilter;
            var filters = chgFilter.filters.find(function (f) {
                return f.id.includes('prompt');
            }).filters;
            managePromptOptions(filters);
        };

        $scope.showSmaSetting = function () {
            if (!$scope.groupings) {
                return false;
            }
            let selectedGrouping = $scope.groupings.fnFind(function (o) {
                if (!$scope.query) {
                    return false;
                }
                let grouping =
                    $scope.query.schema.workBook.controls[0].control
                        .groupings[0];
                return o.name === grouping.value;
            });
            if (!selectedGrouping) {
                return false;
            }
            return selectedGrouping.additionalOptions.some('Sma');
        };

        //INITIALIZE
        $scope.wizardSteps = [
            {
                name: 'General',
                isComplete: function () {
                    return (
                        $scope.query?.portfolio.name &&
                        $scope.entitySelector.options.length
                    );
                },
            },
            {
                name: 'Columns',
                isComplete: function () {
                    return !!$scope.columns.selected.length;
                },
            },
            {
                name: 'Filters',
                isComplete: function () {
                    return true;
                },
            },
            {
                name: 'Summary',
                isComplete: function () {
                    return !!$scope.columns.selected.length;
                },
            },
        ];
        
        $scope.current = {
            wizardStep: $scope.wizardSteps[0],
            animation: 'slide-right',
            isFullPage: !dialog,
            messages: [],
        };
        $scope.runForOptions = [
            'Database',
            'Representative',
            'Household',
            'Registration',
            'Account',
            'Portfolio Group',
            'Product',
        ];
        $scope.smaOptions = [
            { name: 'Use Default', value: null },
            { name: 'Yes', value: true },
            { name: 'No', value: false },
        ];
        $scope.columns = {};

        $scope.reportCategories = reportHelper.getOptions(
            'report-category',
            true
        );

        reportHelper.$onTagConfigChange(function (e, options) {
            $scope.columns.available = options
                .exclude({ $type: 'parent' })
                .sortBy('label');
        });

        init();
    },
]);

'use strict';

app.controller('QueryBuilderTransOptionsCtrl', function QueryBuilderTransOptionsCtrl($scope, $http, $dialog, dialog, args) {
    //PRIVATE VARIABLES

    //PRIVATE METHODS
    function init() {
        $scope.transTypes = args.transTypes;
        $scope.inceptionValueMethod = args.inceptionValueMethod;
        args.selected.forEach(function(i) {
            $scope.toggleItemCheck(i, false);
        });
    }

    //PUBLIC METHODS
    $scope.setAll = function(checked) {
        args.setAll(checked, $scope.selected, $scope.transTypes);
    };

    $scope.isGroupChecked = function(group) {
        return $scope.transTypes[group].all(function(item) {return $scope.isItemChecked(item.id)});
    };

    $scope.isItemChecked = function(id) {
        return args.isItemChecked(id, $scope.selected);
    };

    $scope.toggleGroupCheck = function(group) {
        if ($scope.isGroupChecked(group)) {
            $scope.transTypes[group].forEach(function(item) {
                $scope.toggleItemCheck(item.id, false);
            });
        }
        else {
            $scope.transTypes[group].forEach(function(item) {
                $scope.toggleItemCheck(item.id, true);
            });
        }
    };

    $scope.toggleItemCheck = function(id, addOnly) {
        id = String(id);

        var index = $scope.selected.findIndex(id);

        if (index === -1)
            $scope.selected.push(id);
        else if (!addOnly)
            $scope.selected.splice(index, 1);
    };

    $scope.submit = function () {
        let transTypes = args.matchSelected($scope.transTypes, $scope.selected);

        dialog.close(args.createActivityOption(args.activityID, transTypes, $scope.inceptionValueMethod));
    };

    $scope.cancel = function () {
        dialog.close(null);
    };

    $scope.handleSelectedInceptionValueMethodChange = function (selectedInceptionValueMethod) {
        $scope.inceptionValueMethod = selectedInceptionValueMethod;
    };

    //INITIALIZE
    $scope.selected = [];

    init();
});
'use strict';

app.controller('QueryBuilderSchedulerCtrl',function QueryBuilderSchedulerCtrl($scope, $http, $q, $oasRights, $dialog, dialog) {
    var fileFormats = [{name: "CSV", code: "csv"}, {name: "Pipe Delimited", code: "psv"}, {name: "Excel", code: "xlsx"}];
    var queryBuilderScheduleOriginal = null;
    var intervalsTemp = [];

    function init(){
        var loadedCalls = { alClients: getAlClients(), ownerCode: getOwnerCode(), databaseGroups: null, scheduledQuery: getScheduledQuery(), dataQuery: getDataQuery() };
        if($scope.rightsDatabaseGrouping.canRead) {
            loadedCalls.databaseGroups = getDatabaseGroups();
        } else {
            $scope.runForOptions.remove({name: "Group", code: "group"});
        }
        $q.all(loadedCalls)
            .then(function (responses) {
                if (responses.scheduledQuery.data.parameters && responses.dataQuery.data.requiredOptions[0]?.$type === 'select-entity') {
                    //The option on the Run For control is a shadow of the option on the requiredOptions property of the query, because
                    //the select component demands an option list, so we check if the requiredoptions changed since the last time and if so 
                    //we update the component options accordingly.
                    if (responses.dataQuery.data.requiredOptions[0].options.sort().join(',') !== responses.scheduledQuery.data.parameters.prompts[0].options.sort().join(',')) {
                        responses.scheduledQuery.data.parameters.prompts[0].options = responses.dataQuery.data.requiredOptions[0].options;
                        // if the previous selected entity for the schedule is no longer in the options, set to default
                        if (responses.dataQuery.data.requiredOptions[0].options.find(el => el === responses.scheduledQuery.data.parameters.prompts[0].entity) === undefined) {
                            responses.scheduledQuery.data.parameters.prompts[0].entity = responses.dataQuery.data.requiredOptions[0].entity;
                            responses.scheduledQuery.data.parameters.prompts[0].entityIds = [];
                        }
                    }

                }


                //Set up ALClients list
                $scope.alClients.list = responses.alClients.data.sortBy('clientName');

                //Get owner code
                $scope.current.ownerCode = responses.ownerCode.data;

                //Set up database groups
                if(responses.databaseGroups) {
                    $scope.databaseGroups.list = responses.databaseGroups.data.sortBy('name');
                }
                //Set up scheduled query data
                $scope.queryBuilderSchedule = responses.scheduledQuery.data;
                prepareScheduledQuery();

                //Set up data query
                //$scope.queryBuilderParameters = responses.dataQuery.data.requiredOptions;
                prepareDataQuery(responses.dataQuery.data);
            });
    }

    function prepareScheduledQuery() {
        if($scope.current.scheduleId !== 0) {
            queryBuilderScheduleOriginal = angular.copy($scope.queryBuilderSchedule);

            if($scope.queryBuilderSchedule.parameters?.databaseIdList?.length > 0) {
                $scope.current.selectedRunFor = "multiple";
                $scope.queryBuilderSchedule.parameters.databaseIdList.forEach(function(dbId) {
                    var alClient = $scope.alClients.list.find({id:dbId});
                    if (alClient) {
                        $scope.alClients.selected.add(angular.copy(alClient));
                    }
                });
            }

            $scope.intervalValues = [];

            //Set initial intervalType
            Object.keys($scope.queryBuilderSchedule.frequencyInfo.interval, function (key, value) {
                intervalsTemp.push({name: key.capitalize(), selected: value});
            });

            //Move to bindable array
            $scope.intervalValues = intervalsTemp.clone().exclude({name: '$type'}, {name: 'Day'});

            if ($scope.intervalValues.length === 0) {
                $scope.current.intervalType = 'Daily';
            } else {
                $scope.current.intervalType = $scope.intervalValues.exclude({name: '$type'}).length === 7 ? 'Weekly' : 'Monthly';
            }

            $scope.current.selectedMonthDay = $scope.queryBuilderSchedule.frequencyInfo.interval.day ? $scope.queryBuilderSchedule.frequencyInfo.interval.day.toNumber() : '';

            $scope.frequency.selectedFrequency = $scope.current.intervalType;

            $scope.queryBuilderParameters = createColumnData($scope.queryBuilderSchedule.parameters.prompts, 3);

            if ($scope.queryBuilderSchedule.parameters.dynamicDateFormat) {
                $scope.current.includeDynamicDate = true;
                $scope.current.dynamicDateFormat = $scope.queryBuilderSchedule.parameters.dynamicDateFormat;
            }
            if ($scope.queryBuilderSchedule.parameters.fileName) {
                $scope.current.fileName = $scope.queryBuilderSchedule.parameters.fileName;
            }
        }
        else {
            $scope.queryBuilderSchedule.isActive = true;
        }

        setAllowedFileFormats();
        setFileFormatForSchedule();

        $scope.frequencyInfo = $scope.queryBuilderSchedule.frequencyInfo;
    }

    function prepareDataQuery(dataQuery) {
        var data = dataQuery;
        $scope.current.defaultFileName = data.name.replace("/", "") + "_" + $scope.current.ownerCode;
        var prompts = [];
        if($scope.current.scheduleId !== 0) {
            var newPrompts = [];
            data.requiredOptions.forEach(function (item) {
                if (item.$type ==="prompt" && (item.resultType === "Numeric" || item.resultType === "Decimal" || item.resultType === "Currency" )) {
                    item.defaultValue = item.defaultValue ? item.defaultValue.toNumber() : 0;
                }
                if (!findParameter(item.id)) {
                    item.excelReportId = 0;
                    newPrompts.push(item);
                }
            });

            $scope.queryBuilderParameters.forEach(function (tempArr) {
                prompts = prompts.concat(tempArr);
            });
            prompts.remove(function (p) {
                return !data.requiredOptions.some({Id: p.Id});
            });
            if (newPrompts.length > 0) {
                prompts = prompts.concat(newPrompts);
            }
            var dateRegex = new RegExp("^([+-]?\\d*[dDmMqQyY]?[\\/\\\\]?[dDmMqQyY])(([-+])(\\d+)[dDmMqQyY])?$");
            prompts.forEach(function (p) { //This will split the date placeholder from the +/- day difference
                if (p.$type === "date"  ||( p.$type === "prompt" && p.resultType === "Date")) {
                    var dateParts;
                    dateParts = dateRegex.exec(p.expression);
                    if (dateParts) {
                        p.expression = dateParts[1];
                        if (dateParts[3]) {
                            p.dayDifference = parseInt(dateParts[4]);
                            p.isPositive = dateParts[3].includes('+');
                        } else {
                            p.dayDifference = 0;
                            p.isPositive = true;
                        }
                    }
                }
                else if(p.$type === "daterange") {
                    var startDateParts = dateRegex.exec(p.start.expression);
                    var endDateParts = dateRegex.exec(p.end.expression);

                    if (startDateParts) {
                        p.start.expression = startDateParts[1];
                        if(startDateParts[3]){
                            p.start.dayDifference = parseInt(startDateParts[4]);
                            p.start.isPositive = startDateParts[3].includes('+');
                        } else {
                            p.start.dayDifference = 0;
                            p.start.isPositive = true;
                        }
                    }
                    if (endDateParts) {
                        p.end.expression = endDateParts[1];
                        if (endDateParts[3]) {
                            p.end.dayDifference = parseInt(endDateParts[4]);
                            p.end.isPositive = endDateParts[3].includes('+');
                        } else {
                            p.end.dayDifference = 0;
                            p.end.isPositive = true;
                        }
                    }
                }
            });
        } else {
            data.requiredOptions.forEach(function (item) {
                switch(item.$type) {
                    case "prompt":
                        if (item.resultType === "Numeric" || item.resultType === "Decimal" || item.resultType === "Currency") {
                            item.defaultValue = item.defaultValue ? item.defaultValue.toNumber() : 0;
                        } else if (item.resultType === "Date") {
                            item.dayDifference = 0;
                            item.isPositive = true;
                        }
                        prompts.push(item);
                        break;
                    case "date":
                        item.dayDifference = 0;
                        item.isPositive = true;
                        prompts.push(item);
                        break;
                    case "daterange":
                        item.start.dayDifference = 0;
                        item.start.isPositive = true;
                        item.end.dayDifference = 0;
                        item.end.isPositive = true;
                        prompts.push(item);
                        break;
                    case "select-entity":
                        prompts.push(item);
                }

            });
            loadIntervalValues('Weekly');
            //prompts = data.requiredOptions;
        }
        $scope.queryBuilderParameters = createColumnData(prompts, 3);
    }
    function getCleanReport() {
        //using a copy here so we don't permanently alter any values currently being displayed to the user
        var report = angular.copy($scope.dataQuery);

        if (report.requiredOptions && report.requiredOptions.length > 0) {
            report.requiredOptions.forEach(function (parameter) {
                switch (parameter.$type) {
                    case "select-entity":
                        if (parameter.id === "entity") {
                            var entityIds = [];
                            parameter.selectedEntities.forEach(function (entity) {
                                if (entity.items) {
                                    entity.items.forEach(function (item) {
                                        entityIds.push(item.entityId);
                                    });
                                } else {
                                    entityIds.push(entity.entityId);
                                }
                            });
                            parameter.entityIds = entityIds.unique();
                            delete parameter.selectedEntities;
                        }
                        break;

                    case "daterange":
                        parameter.start.date = parameter.useInception ? null : Date.create(parameter.start.date).format('{M}/{d}/{yyyy}');
                        parameter.start.dateSource = "Static";
                        parameter.end.date = Date.create(parameter.end.date).format('{M}/{d}/{yyyy}');
                        parameter.end.dateSource = "Static";
                        delete parameter.useInception;
                        delete parameter.rememberDateParameter;
                        break;

                    case "date":
                        parameter.value.date = Date.create(parameter.value.date).format('{M}/{d}/{yyyy}');
                        parameter.value.dateSource = "Static";
                        break;
                }
            });
        }
        return report;
    }
    $scope.setInceptionDate = function () {
        var entitySelection = $scope.dataQuery.requiredOptions.find({id: 'entity'});
        var period = $scope.dataQuery.requiredOptions.find({$type: 'daterange'});

        if (entitySelection.selectedEntities.length === 1) {
            var report = getCleanReport();

            $http.post("/Reporting/Reports/" + dialog.options.dataQueryId + "/Calculate/InceptionDate", report, {trackerMsg: 'Retrieving inception date'})
                .then(function (response) {
                    period.start.date = response.data.inceptionDate ? Date.create(response.data.inceptionDate).format("{M}/{d}/{yyyy}") : null;
                });
        } else {
            period.start.date = null;
        }
    };
    function findParameter(id) {
        var found = false;
        $scope.queryBuilderParameters.forEach(function(paramArray){
            paramArray.forEach(function(parameter){
            if(parameter.id === id) {
                found = true;
                return false;
            }
            });
        });
        return found;
    }

    function loadIntervalValues(intervalType) {
        $scope.intervalValues = [];
        if(queryBuilderScheduleOriginal && intervalType === $scope.current.intervalType){
            $scope.queryBuilderSchedule = {};
            $scope.queryBuilderSchedule = queryBuilderScheduleOriginal;
            $scope.intervalValues = intervalsTemp.exclude({name: '$type'}, {name: 'Day'});
        } else {
            $http.get('/Reporting/Envision/ExcelReportSchedules/New?frequencyType=' + intervalType.toLowerCase(), {cache: true, trackerMsg: 'Creating template'})
                .then(function (response) {
                    var data = response.data;
                    data.frequencyInfo.timeOfDay = new Date();
                    data.frequencyInfo.startDate =  Date.create('today');
                    data.frequencyInfo.endDate = null;
                    $scope.queryBuilderSchedule.frequencyInfo = data.frequencyInfo;
                    var interval = Object.keys(data.frequencyInfo.interval, function (key, value) {
                        if (key.has('day') && intervalType.toLowerCase() === 'weekly') {
                            $scope.intervalValues.push({name: key.capitalize(), selected: value});
                        } else {
                            //if this is monthly; I'm removing a property called 'day', which is the day of the month, so it doesn't show on UI
                            if(!key.has('day') && !key.has('$type'))$scope.intervalValues.push({name: key.capitalize(), selected: value});
                        }
                    });
                });
        }
    }
    function createColumnData(inputArray, size){
        var newArray = [];
        for (var i=0; i<inputArray.length; i+=size) {
            newArray.push(inputArray.slice(i, i+size));
        }
        return newArray;
    }

    function formatPrompts(prompts){
        //Copy parameters into queryBuilderParameters
        $scope.queryBuilderParameters.forEach(function(tempArr){
            prompts = prompts.concat(tempArr);
        });
        //Format date prompts
        prompts.forEach(function(p){
            if(p!== undefined){
            if((p.$type === "date"  ||( p.$type === "prompt" && p.resultType === "Date")) && p.dayDifference && angular.isNumber(p.dayDifference) && parseInt(p.dayDifference) > 0) {
                p.expression += ((p.isPositive ? '+' : '-') + parseInt(p.dayDifference) +'d');
                delete p.dayDifference;
                delete p.isPositive;
            }
            else if(p.$type === "daterange"){
                if(p.start.dayDifference && angular.isNumber(p.start.dayDifference) && parseInt(p.start.dayDifference) > 0){
                    p.start.expression += ((p.start.isPositive ? '+' : '-') + parseInt(p.start.dayDifference)+'d');
                    delete p.start.dayDifference;
                    delete p.start.isPositive;
                }
                if(p.end.dayDifference && angular.isNumber(p.end.dayDifference) && parseInt(p.end.dayDifference) > 0){
                    p.end.expression += ((p.end.isPositive ? '+' : '-') + parseInt(p.end.dayDifference)+'d');
                    delete p.end.dayDifference;
                    delete p.end.isPositive;
                }
            }
            else if(p.$type === "select-entity"){
                if (p.id === "entity") {
                    var entityIds = [];
                    p.selectedEntities.forEach(function (entity) {
                        if (entity.items) {
                            entity.items.forEach(function (item) {
                                entityIds.push(item.entityId);
                            });
                        } else {
                            entityIds.push(entity.entityId);
                        }
                    });
                    p.entityIds = entityIds.unique();
                    delete p.selectedEntities;
                }
            }
            }
        });
        return prompts;
    }

    function getScheduledQuery() {
        if($scope.current.scheduleId !== 0) {
            return $http.get('/Reporting/Envision/ExcelReportSchedules/' + dialog.options.scheduleId, { trackerMsg: 'Loading query schedule '});
        } else {
            return $http.get('/Reporting/Envision/ExcelReportSchedules/New?frequencyType=' + $scope.frequency.selectedFrequency, { trackerMsg: 'Loading query schedule'});
        }
    }

    function getDataQuery() {
        console.log(dialog);
        return $http.get('/Reporting/Envision/ExcelReports/Verbose/' +$scope.current.excelReportId + '?expand=All', { trackerMsg: 'Loading query schedule template '});
    }

    function getAlClients() {
        return $http.get('/Authorization/User/Databases?isActive=true&filterForMasterGroup=true', {trackerMsg: 'Loading database list'});
    }

    function getOwnerCode() {
        return $http.get("/Settings/Owner/Code", {cache:true, trackerMsg: 'Loading settings'});
    }

    function getDatabaseGroups() {
        return $http.get('/Utility/DatabaseGroups', {trackerMsg: 'Loading database groups'});
    }

    function isValidFrequency() {
        switch ($scope.frequency.selectedFrequency) {
            case "Daily":
                return true;

            case "Weekly":
                return $scope.intervalValues?.some(param => param.selected);

            case "Monthly":
                return $scope.intervalValues?.some(param => param.selected) && $scope.current.selectedMonthDay > 0;

            default:
                return false;
        }
    }

    function setAllowedFileFormats() {
        if(
            ($scope.current.uploadTarget?.transmitMethod === "FTP"
                && (
                    $scope.current.uploadTarget?.pgpUserID === null
                    || $scope.current.uploadTarget?.pgpUserID.trim() === ""
                ))
            || $scope.user.authorization.entity === "Administrator"
        ) {
            $scope.fileFormats = angular.copy(fileFormats).remove(type => { return type.code !== "xlsx"; });
        } else {
            $scope.fileFormats = angular.copy(fileFormats);
        }
    }

    function setFileFormatForSchedule() {
        // If the fileFormat isn't set yet, try to set it from the schedule itself.
        if (!$scope.current.fileFormat) {
            $scope.current.fileFormat = $scope.queryBuilderSchedule.parameters?.fileFormat?.toLocaleLowerCase();
        }

        // Whether or not we just set the fileFormat above, we need to ensure it is still valid based on the currently available fileFormats.
        if (!$scope.fileFormats.some({code: $scope.current.fileFormat})) {
            $scope.current.fileFormat = null;
        }
    }

    $scope.intervalChange = function(changeType){
        loadIntervalValues(changeType);
    };

    $scope.setSchedule = function(){
        $scope.queryBuilderSchedule.id = $scope.current.scheduleId;
        $scope.queryBuilderSchedule.guid = $scope.current.excelReportId;
        var prompts = [];
        prompts = formatPrompts(prompts);
        //Convert $scope.intervalValues
        if($scope.intervalValues.length > 0){
            var frequencyInfoIntervals={};
            $scope.intervalValues.forEach(function(item){
                frequencyInfoIntervals[item.name.toLowerCase()] = item.selected;
            });

            if($scope.queryBuilderSchedule.frequencyInfo.interval.$type) {
                frequencyInfoIntervals["$type"] = $scope.queryBuilderSchedule.frequencyInfo.interval.$type;
            }

            $scope.queryBuilderSchedule.frequencyInfo.interval = frequencyInfoIntervals;
        }
        if($scope.frequency.selectedFrequency === 'Monthly') {
            $scope.queryBuilderSchedule.frequencyInfo.interval.day = $scope.current.selectedMonthDay.format();
        }
        var idList = [];
        if($scope.current.selectedRunFor !== 'current' ) {
            $scope.alClients.selected.forEach( function ( setIds ) {
                idList.push(setIds.id);
            });
        }
        let dynamicDateFormat = null;
        if($scope.current.includeDynamicDate) {
            dynamicDateFormat = $scope.current.dynamicDateFormat;
        }
        let fileName = null;
        if($scope.current.fileName !== "") {
            fileName = $scope.current.fileName;
        }
        $scope.queryBuilderSchedule.parameters = {prompts: prompts, databaseIdList: idList, fileFormat: $scope.current.fileFormat, fileName: fileName, dynamicDateFormat: dynamicDateFormat};

        $scope.queryBuilderSchedule.excelReportId = $scope.current.excelReportId;
        $scope.queryBuilderSchedule.isActive = true;
        dialog.close($scope.queryBuilderSchedule);
    };

    $scope.setDescription = function(prompt) {
        $scope.current.promptDescription = prompt.promptDescription;
    };

    $scope.loadUploadTarget = function() {
        $dialog.dialog({id: $scope.queryBuilderSchedule.uploadTargetId, templateUrl: "querybuilder-schedule-uploadtarget.html", controller: "QueryBuilderScheduleUploadTargetCtrl"})
            .open().then(function(rslt) {
            if(rslt) {
                $scope.queryBuilderSchedule.uploadTargetId = rslt.pkUploadTarget;
                $scope.current.uploadTarget = rslt;

                setAllowedFileFormats();
                setFileFormatForSchedule();
            }
        });
    };

    $scope.clearUploadTarget = function() {
        $scope.queryBuilderSchedule.uploadTargetId = null;
        
        setAllowedFileFormats();
        setFileFormatForSchedule();
    };

    $scope.updateDatabases = function() {
        if($scope.databaseGroups.selected) {
            var selected = angular.copy($scope.alClients.selected);
            $scope.alClients.selected = [];
            selected.each(function(s){
                $scope.alClients.list.push(s);
            });
            $scope.alClients.list.sortBy('clientName');
            var dbs = [];
            $scope.databaseGroups.selected.databases.forEach(function(db){
                if(db) {
                    var currentDb = angular.copy($scope.alClients.list.find( { id : db.id } ));
                    if(currentDb) {
                        dbs.push(currentDb);
                    }
                }
            });
            $scope.alClients.selected = dbs;
        }
    };

    $scope.close = function(){
        dialog.close();
    };

    $scope.isValidRunFor = function() {
        const selectEntityParam = $scope.queryBuilderParameters[0]?.find(param => param.$type === "select-entity").entity;
        const selectRunForParam = $scope.current.selectedRunFor;
        return (selectEntityParam && selectEntityParam === "Database") || selectRunForParam === "current";
    };

    $scope.isValidRunForOption = function(runForCode) {
        const selectEntityParam = $scope.queryBuilderParameters[0]?.find(param => param.$type === "select-entity").entity;
        return (selectEntityParam && selectEntityParam === "Database") || runForCode === "current";
    };

    $scope.canSchedule = function() {
        const selectEntityParam = $scope.queryBuilderParameters[0]?.find(param => param.$type === "select-entity");
        const isValidFreqencyData = isValidFrequency();
        const startDateTime = $scope.queryBuilderSchedule;
        const runForOption = $scope.current.selectedRunFor;
        return selectEntityParam && isValidFreqencyData && startDateTime && startDateTime.frequencyInfo.startDate && startDateTime.frequencyInfo.timeOfDay && ((selectEntityParam.selectedEntities?.length > 0 && runForOption === 'current') || selectEntityParam.entity === "Database");
    };

    $scope.rightsDataQueryFtp = $oasRights.forCode("DATAQUERYFTP");
    $scope.rightsDatabaseGrouping = $oasRights.forCode("DB_GROUPING");
    $scope.hasAdvancedEditorRights = $oasRights.canRead("REPORTBUILDERADVANCEDEDITOR");
    $scope.frequencyInfo = {};

    $scope.queryBuilderParameters = [];

    $scope.frequencyNames =['Daily','Weekly','Monthly'];

    $scope.frequency = {selectedFrequency:'Weekly'};

    $scope.current = {
        intervalType:'', scheduleId: dialog.options.scheduleId ? dialog.options.scheduleId : 0, excelReportId: dialog.options.id,selectedDayOfWeek:'Monday',
        startDate:Date.create('today'), startTime:'18:00',useLastDayOfMonth:false, selectedMonthDay:null, selectedRunFor: "current",
        uploadTarget: null, fileFormat: null, defaultFileName: null, fileName: "", includeDynamicDate: false, dynamicDateFormat: null, ownerCode: null
    };

    $scope.fileInfoPopup = "<h5>File Information</h5><p>When a file downloads, it will display the file name and, if desired, a dynamic date.</p><p>A custom file name may be entered, otherwise the default query name will display.</p><p>A dynamic date, if checked, will display the date of download on each query scheduled.</p>";
    $scope.inValidRunForPopup = "Queries for specific entities can only be scheduled for the current database.";
    $scope.selectedMonths = [];

    $scope.intervalValues = [];

    $scope.dateDefaults = [
        {id: "0d", name: "Now"},
        //{id: "LBD", name: "Last Business Day"},
        {id: "/q", name: "Start Quarter-To-Date"},
        {id: "/m", name: "Start Month-To-Date"},
        {id: "/y", name: "Start Year-To-Date"},
        {id: "-1q/q", name: "Start Last Quarter"},
        {id: "-1m/m", name: "Start Last Month"},
        {id: "-1y/y", name: "Start Last Year"},
        {id: "\\q", name: "End Quarter-To-Date"},
        {id: "\\m", name: "End Month-To-Date"},
        {id: "\\y", name: "End Year-To-Date"},
        {id: "-1q\\q", name: "End Last Quarter"},
        {id: "-1m\\m", name: "End Last Month"},
        {id: "-1y\\y", name: "End Last Year"}
    ];

    $scope.fileFormats = angular.copy(fileFormats);

    $scope.runForOptions = [{name: "Current", code: "current"}, {name: "Multiple", code: "multiple"}, {name: "Group", code: "group"}];

    $scope.dynamicDates = ["MMddyy","MMddyyyy", "yyyyMMdd", "MM-dd-yy", "MM-dd-yy HH:mm:ss", "yyMMdd HH:mm:ss"];

    $scope.databaseGroups = {list: [], selected: null};

    $scope.alClients = {list: [], selected: [], entity: 1979 };

    init();

});

app.controller('QueryBuilderScheduleUploadTargetCtrl',function QueryBuilderScheduleUploadTargetCtrl($scope, $http, dialog) {
    //PRIVATE VARIABLES
    var baseUploadTarget = { fkUploadFormat: 1, transmitMethod: 'FTP', useForScrubs: false };
    var uploadTargetOriginal;

    //PRIVATE METHODS
    function init() {
        $scope.current.isExecuting = true;
        $http.get('/Reporting/Custom/UploadTargets', { trackerMsg: 'Loading available upload targets' })
            .then(function(response){
                if(response.data) {
                    $scope.current.uploadTargets = response.data;
                    if(dialog.options.id && dialog.options.id > 0) {
                        $scope.target = $scope.current.uploadTargets.find({pkUploadTarget: dialog.options.id});
                    }
                }
                $scope.current.isExecuting = false;
            });
    }
    //PUBLIC METHODS
    $scope.assign = function() {
        $scope.current.isExecuting = true;
        if(!angular.equals(uploadTargetOriginal, $scope.target)) {
            var save = ($scope.target.pkUploadTarget && $scope.target.pkUploadTarget > 0) ? {method: "PUT", id: $scope.target.pkUploadTarget, trackerMsg: "Saving upload target"} : {method: "POST", id: "", trackerMsg: "Adding new upload target"};
            $http({method: save.method, url: '/Reporting/Custom/UploadTargets/' + save.id, data: $scope.target, trackerMsg: save.trackerMsg})
                .then(function(response){
                    $scope.current.isExecuting = false;
                    dialog.close(response.data);
                })
                .catch(function(reason){
                    $scope.current.isExecuting = false;
                });
        }
        else {
            $scope.current.isExecuting = false;
            dialog.close($scope.target);
        }
    };
      $scope.cancel = function() {
          dialog.close(null);
      };

    //WATCHES
    $scope.$watch('target', function (newValue, oldValue) {
        if (newValue == oldValue) return;

        if(!$scope.target)
            $scope.target = angular.copy(baseUploadTarget);
        else
            uploadTargetOriginal = angular.copy($scope.target);
    });

    //INITIALIZE
    $scope.target = { fkUploadFormat: 1, transmitMethod: 'FTP', useForScrubs: false };
    $scope.current = { uploadTargets: [],  isExecuting: false };
    init();
});
'use strict';

app.controller('ReportFragmentCtrl', function ReportFragmentCtrl($scope, $http, $dialog, dialog) {
    //PRIVATE METHODS
    function init() {
        if($scope.mode === 'clone') {
            $http.get('/Reporting/Envision/Fragments/Verbose/New', {trackerMsg: 'Loading fragment'})
                .then(function(response){

                    const newFragment = response.data ? response.data : response;
                    $scope.fragment.id = null;
                    $scope.fragment.name = $scope.fragment.portfolio.name = 'Copy of ' + $scope.fragment.portfolio.name;
                    $scope.fragment.portfolio.canEdit = true;
                    $scope.fragment.portfolio.canDelete = true;

                    $scope.fragment.loginAccessRules = newFragment.loginAccessRules;
                    $scope.fragment.databaseGroupAccessRules = newFragment.databaseGroupAccessRules;
                    $scope.fragment.databaseAccessRules = newFragment.databaseAccessRules;
                    $scope.fragment.roleAccessRules = newFragment.roleAccessRules;
                    $scope.fragment.userAccessRules = newFragment.userAccessRules;
                });
        }
        addCategoryIfNotExists($scope.fragment.portfolio.category);
    }

    function addCategoryIfNotExists(category) {
        if ($scope.categories.none(category)) {
            $scope.categories.insert(category, 0);
        }
    }


    // PUBLIC METHODS
    $scope.addCategory = function () {
        $dialog.inputBox('New Category', 'Name')
            .open()
            .then(function (result) {
                if (!result) return;

                addCategoryIfNotExists(result);
                $scope.fragment.portfolio.category = result;
            });
    };

    $scope.editAccess = function () {
        const args = function () {
            return {
                defaultTab: {code: "reportDatabaseAccess"},
                name: $scope.fragment.portfolio.name,
                accessLevels: {
                    login: angular.copy($scope.fragment.loginAccessRules),
                    databaseGroup: angular.copy($scope.fragment.databaseGroupAccessRules),
                    database: angular.copy($scope.fragment.databaseAccessRules),
                    role: angular.copy($scope.fragment.roleAccessRules),
                    user: angular.copy($scope.fragment.userAccessRules)
                }
            };
        };

        $dialog.editor("reporting/editors/views/report-access-edit.html", "ReportAccessEditCtrl", {args: args})
            .open()
            .then(function (result) {
                if (!result || !result.isSaved) return;

                $scope.fragment.loginAccessRules = result.accessLevels.login;
                $scope.fragment.databaseGroupAccessRules = result.accessLevels.databaseGroup;
                $scope.fragment.databaseAccessRules = result.accessLevels.database;
                $scope.fragment.roleAccessRules = result.accessLevels.role;
                $scope.fragment.userAccessRules = result.accessLevels.user;
            });
    };

    $scope.submit = function () {
        dialog.close($scope.fragment);
    };

    $scope.cancel = function () {
        dialog.close();
    };


    // INITIALIZE
    $scope.fragment = dialog.options.fragment;
    $scope.categories = dialog.options.categories;
    $scope.mode = dialog.options.mode;
    init();
});
'use strict';

app.controller('ReportFragmentWarningCtrl', function ReportFragment2Ctrl($scope, $http, $dialog, dialog, $location, reportHelper, reportSaveService) {
    $scope.goToSubReportEditor = function (saveBeforeLeaving) {
        if (saveBeforeLeaving) {
            saveReportThenLeave();
        } else {
            goToFragment();
        }
    };

    $scope.cancel = function () {
        dialog.close();
    };

    function goToFragment() {
        $location.path('/reports/reportbuilder3/subreports/' + $scope.fragment.id).search({origin: $scope.report.id, isNewFromReport: $scope.isNewFromReport.toString() });
        dialog.close();
    }

    function saveReportThenLeave() {
        reportSaveService.save($scope.report, $scope.globalSettings).then(resp => {
            const crumbName = ($scope.report.isVersion ? 'v. ' : '') + $scope.report.portfolio.name;
            if ($scope.report.id) {
                $scope.updateBreadcrumb(crumbName);  //in case it changed

                goToFragment();
            } else {
                $scope.deleteBreadcrumb();
                $scope.addBreadcrumb(crumbName, '/reports/reportbuilder3/' + resp.id);

                reportHelper.getReport(false, resp.id, false)
                    .then(function (report) {
                        $scope.report = report;
                        goToFragment();
                    });
            }
        });
    }

    // INITIALIZE
    $scope.fragment = dialog.options.fragment;
    $scope.report = dialog.options.report;
    $scope.globalSettings = dialog.options.globalSettings;
    $scope.isNewFromReport = dialog.options.isNewFromReport;
});

'use strict';

app.controller('ReportImageCtrl', function ReportImageCtrl($scope, $http, $dialog, dialog, $upload, rbFileHelper, API_CONFIG) {
    var ts = Date.now();

    function previewUrl(imageUrl) {
        if (!imageUrl) {
            return;
        }

        if (imageUrl.indexOf('blob:') === 0) {
            return imageUrl;
        }

        if (imageUrl.has('api/v1')) {
            return imageUrl + ('?ts={1}'.assign(ts));
        }

        if (imageUrl.charAt(0) === '/') {
            return API_CONFIG.baseUrl + imageUrl + ('?ts={1}'.assign(ts));
        }

        return imageUrl;
    }

    // PUBLIC METHODS
    $scope.submit = function () {
        dialog.close($scope.current.item);
    };

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.clearImage = function () {
        $scope.current.image = null;
        $scope.current.item.name = null;
        $scope.current.item.imageExtension = null;
        $scope.current.item.file = null;
        $scope.current.item.alt = null;
    };

    // INITIALIZE
    $scope.errors = [];
    $scope.current = {
        get image() {
            return previewUrl($scope.current.item && $scope.current.item.imageUrl);
        },
        set image(value) {
            $scope.errors.length = 0;
            ts = Date.now();
            var url, file = angular.isArray(value) ? value[0] : value;
            
            if(file instanceof File) {
                var img = new Image();
                img.onload = function () {
                    $scope.current.item.widthPixels = this.width;
                    $scope.current.item.heightPixels = this.height;
                };
                img.src = window.URL.createObjectURL(file);
                rbFileHelper.validateImage(file).then(function(result){
                    if (!result.isValid){
                        file = undefined;
                        url = undefined;
                        $scope.current.item.name = null;
                        $scope.current.item.imageExtension = null;
                        $scope.current.item.imageUrl = null;
                        $scope.errors.push(result.message);
                        return;
                    }
                    
                    url = img.src;
                    $scope.current.item.file = file;
                    $scope.current.item.imageUrl = url;
                    if (file) {
                        if (!$scope.current.item.name) {
                            $scope.current.item.name = file.name;
                        }
                        if (!$scope.current.item.alt) {
                            $scope.current.item.alt = file.name;
                        }
                    }
                });
            } else {
                file = undefined;
                $scope.current.item.file = undefined;
                $scope.current.item.imageUrl = value || undefined;
            }
        }
    };

    angular.extend($scope.current, dialog.options);
});
'use strict';

app.controller('ReportPdfModalCtrl', function ReportImageCtrl($scope, $http, $dialog, dialog, $upload, $sce, rbFileHelper, API_CONFIG) {
    function setPdfExtensionFromFileName(fileName) {
        $scope.current.item.fileExtension = rbFileHelper.getPdfFileExtension(fileName);
    }

    function initializeNameFields() {
        if (!$scope.current.item.name) {
            return;
        }

        setPdfExtensionFromFileName($scope.current.item.name);
        if ($scope.current.item.fileExtension) {
            $scope.current.item.name = rbFileHelper.ensurePdfExtension(
                $scope.current.item.name,
                'file' + $scope.current.item.fileExtension
            );
        }
    }

    $scope.submit = function() {
        if ($scope.current.item.fileExtension) {
            $scope.current.item.name = rbFileHelper.ensurePdfExtension(
                $scope.current.item.name,
                'file' + $scope.current.item.fileExtension
            );
        }

        dialog.close($scope.current.item);
    };

    $scope.cancel = function() {
        dialog.close();
    };

    $scope.clearPdf = function() {
        $scope.current.pdf = null;
        $scope.current.item.name = null;
        $scope.current.item.fileExtension = null;
        $scope.current.item.file = null;
    };

    $scope.errors = [];
    $scope.current = {
        get pdf() {
            if ($scope.current.item && $scope.current.item.pdfUrl) {
                return $scope.current.item.pdfUrl;
            }
        },
        set pdf(value) {
            let file = angular.isArray(value) ? value[0] : value;
            $scope.errors.length = 0;

            function setError(message) {
                file = undefined;
                url = undefined;
                $scope.current.item.name = null;
                $scope.current.item.fileExtension = null;
                $scope.errors.push(message);
            }

            if (!(file instanceof File)) {
                $scope.current.item.file = undefined;
                $scope.current.item.pdfUrl = value || undefined;
                return;
            }


            let url = window.URL.createObjectURL(file);
            rbFileHelper.validatePdf(file).then(function(result){
                if (!result.isValid){
                    setError(result.message);
                    return;
                }

                $scope.current.item.file = file;
                $scope.current.item.pdfUrl = url;
                if (file) {
                    setPdfExtensionFromFileName(file.name);
                    if (!$scope.current.item.name) {
                        $scope.current.item.name = file.name;
                    }
                }
            });
        },
        get iframeUrl() {
            if ($scope.current.item && $scope.current.item.pdfUrl) {
                const pdfUrl = $scope.current.item.pdfUrl;

                const isLocalBlob = pdfUrl.startsWith('blob:');
                if (isLocalBlob) {
                    return $sce.trustAsResourceUrl(pdfUrl);
                }

                return API_CONFIG.baseUrl + pdfUrl.replace(API_CONFIG.baseUrl, '');
            }
        },
    };

    angular.extend($scope.current, dialog.options);
    initializeNameFields();
});
'use strict';

app.controller('ResolveOptionLibraryCtrl', function ResolveOptionLibraryCtrl($scope, $http, dialog, resolveHelper) {
    //PUBLIC METHODS
    $scope.exportToExcel = function () {
        const data = {
            columns: [
                {name: "Name", field: "label"},
                {name: "Description", field: "description"},
            ],
            data: $scope.resolveOptions.sortBy('label')
        };

        $http.post('/Utility/SlickGridExport/csv', data, {trackerMsg: 'Exporting library'})
            .then(function (response) {
                window.location.href = response.headers("location") + "?Authorization=" + sessionStorage.oas_token;
            });
    };

    $scope.close = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.resolveOptions = resolveHelper.options;
});

'use strict';

app.controller('ResolveOptionFilterCtrl', function ResolveOptionFilterCtrl($scope, $http, $route, $dialog, dialog, args, reportHelper, resolveHelper, reportFiltersService, rcChartHelper, $timeout, optionsHelper) {
    //PRIVATE VARIABLES
    var originalFilter;    
    $scope.loaded = false;

    //PRIVATE METHODS
    function init() {
        reportHelper.resolve.$cursorScope.$resolve.modalOpen = true;
        $scope.resolveOptions.each(function(option){
            option.filterType = ((option.calculation ? option.calculation.resultType : null) || option.resultType).toLocaleLowerCase();
        });
        processFilter();
        originalFilter = $scope.current.filter;
        $timeout(()=>{
            $scope.loaded = true;
        }, 10);

    }

    function processFilter() {
        //remove null filters if any
        if(!$scope.filter || !$scope.filter.path) {
            return;
        }

        if ($scope.filter.$type) {
            const temp = $scope.filter.$type.split('-');
            const type = temp.shift();
            $scope.filter.selectedType = type;
            $scope.filter.selectedFilterType = temp.join('-');
            $scope.filter.selFilterProp = ['less-than', 'less-than-equal'].any($scope.filter.selectedFilterType) ? 'upper' : 'lower';
            $scope.updateFilterProperties($scope.filter);
        }
        if ($scope.filter.selectedType === "datetime") {
            if ($scope.filter.haystack && $scope.filter.haystack.length > 0) {
                for (var i = 0; i < $scope.filter.haystack.length; i++) {
                    $scope.filter.haystack[i] = Date.create($scope.filter.haystack[i]).formatted(true);
                }
            }
        }
        if ($scope.filter.selectedType === "percent") {
            if ($scope.filter.upper) {
                $scope.filter.upperPercent = $scope.filter.upper * 100;
            }
            if ($scope.filter.lower) {
                $scope.filter.lowerPercent = $scope.filter.lower * 100;
            }
        }

        const context = resolveHelper.findResolveOption($scope.filter);
        copyResolveOptionSettings($scope.filter, context, false);
    }

    function getResolveOptions() {
        var options = resolveHelper.getResolveOptions($route.current.$$route.controller);
        switch($route.current.$$route.controller) {
            case 'ReportingEnvisionCoverPageItemCtrl':
                return options.filter(function(o){
                    return o.excludeLocations.indexOf('Cover') === -1;
                });
            case 'ReportEditorCtrl':
            case 'SubReportEditorCtrl':
                return options.filter(function(o){
                    return o.excludeLocations.indexOf('Report') === -1;
                });
            case 'ReportingEnvisionQueryBuilderListCtrl':
                return options.exclude({$type: "parent"});
            default:
                return options;
        }
    }

    function copyResolveOptionSettings(destination, sourceTag, setOptionProperties){
        destination.label = sourceTag.label;
        destination.path = sourceTag.path;
        destination.$options = sourceTag.$options;

        if(setOptionProperties) {
            destination.$options.forEach(function (reportOption) {
                destination[reportOption.propertyName] = sourceTag[reportOption.propertyName];
                if (reportOption.globalPropertyName != null) {
                    $scope.optionsHelper.updateIdAndGuid(reportOption.optionType, destination, sourceTag[reportOption.propertyName], sourceTag[reportOption.guidName]);
                }
            });
        }
    }

    function getProcessedFilter() {
        let isNeedleBoolean = (typeof $scope.current.filter.selNeedle) === "boolean";
        if ($scope.current.filter.selNeedle || isNeedleBoolean) {
            if (['equal', 'not-equal'].any($scope.current.filter.selectedFilterType)) {
                $scope.addToHaystack($scope.current.filter);
            } else if (['contains', 'not-contains', 'ends-with', 'starts-with'].any($scope.current.filter.selectedFilterType)) {
                $scope.addToNeedles($scope.current.filter);
            } else {
                $scope.current.filter.selNeedle = null;
            }
        }

        var filter = angular.copy($scope.current.filter);

        if (['date', 'datetime'].some($scope.current.filter.selectedType)) {
            if (filter.upper) {
                filter.upper = filter.upper.formatted($scope.current.filter.selectedType === 'datetime');
            }
            if (filter.lower) {
                filter.lower = filter.lower.formatted($scope.current.filter.selectedType === 'datetime');
            }
        }

        return filter;
    }

    //PUBLIC METHODS
    $scope.loadSelectedFilter = function(ds, filter) {
        copyResolveOptionSettings(filter, ds, true);

        if($scope.current.filter.selectedFilterType) {
            $scope.setFilterType(filter);
        }
    };

    $scope.setFilterType = function(filter) {
        var context = resolveHelper.findResolveOption( filter );
        filter.selectedType = context.resultType;
        filter.$type = filter.selectedType + "-" + filter.selectedFilterType;
        $scope.updateFilterProperties(filter);

        filter.selFilterProp = ['less-than','less-than-equal'].any(filter.selectedFilterType) ? 'upper' : 'lower';
    };

    $scope.availableFilters = function(path) {
        if(!path) {return;}

        var search = {path: path};

        if($scope.current.filter) {
            search.calculationOptionId = $scope.current.filter.calculationOptionId;
            search.activityOptionId = $scope.current.filter.activityOptionId;
        }

        var context = resolveHelper.findResolveOption(search);
        if(!context.filterType) {
            context.filterType = ((context.calculation ? context.calculation.resultType : null) || context.resultType).toLocaleLowerCase();
        }
        return $scope.filterOptions.filter(function(type) {
            return type.contexts.some(context.filterType);
        });
    };

    $scope.addToHaystack = function(filter) {
        function addIfNotExists(val, compareFn){
            if(filter.haystack.none(val)){
                filter.haystack.add(val);
                filter.haystack.sort(compareFn);
            }
        }

        let needlesToAdd;
        needlesToAdd = [filter.selNeedle];

        needlesToAdd.forEach(function (needle) {
            switch(filter.selectedType) {
                case "decimal":
                case "numeric":
                case "currency":
                case "percent":
                    //ensure what's provided is a number
                    if (needle === null || needle === undefined || needle === '' || needle.toUpperCase() === "N/A") {
                        //the value provided should be interpreted as null and added to the haystack
                        needle = null;
                        addIfNotExists(needle, reportFiltersService.compareNumbers);
                    } else {
                        needle = Number(needle);
                        if(!isNaN(needle)){
                            addIfNotExists(filter.selectedType === 'percent' ? needle / 100 : needle, reportFiltersService.compareNumbers);
                        }
                    }
                    break;

                case "date":
                case "datetime":
                    if (needle) {
                        needle = needle.formatted(filter.selectedType === "datetime");
                        addIfNotExists(needle);
                    }
                    break;

                case "string":
                    if (needle === null || needle === undefined || needle === '' || needle.toUpperCase() === "NULL") {
                        addIfNotExists(null);
                    }else{
                        addIfNotExists(needle);
                    }
                    break;
                case "bool":
                    if (needle !== null && needle !== undefined){
                        addIfNotExists(needle);
                    }
                    break;
                default:
                    if (needle) {
                        addIfNotExists(needle);
                    }
                    break;
            }
        });

        filter.selNeedle = null;
    };

    $scope.removeFromHaystack = function(filter, needle) {
        filter.haystack.remove(needle);
    };

    $scope.addToNeedles = function(filter) {
        const needlesToAdd = filter.selNeedle && angular.isString(filter.selNeedle) && filter.selNeedle.has(/ or /ig) ? filter.selNeedle.split(/ or /ig) : [filter.selNeedle];

        needlesToAdd.forEach(function (needle) {
            if (filter.needles.none(needle)) {
                filter.needles.push(needle);
            }
        });

        filter.selNeedle = null;
    };

    $scope.removeFromNeedles = function(filter, needle) {
        filter.needles.remove(needle);
    };

    $scope.displayNeedle = function(filter, needle, stripTags) {
        let display;
        if (needle === null) {
            if(stripTags) {
                display = 'There is no value present';
            } else {
                if (filter.selectedType === "string") {
                    display = '<i>null</i>';
                } else {
                    display = '<i>N/A</i>';
                }
            }
        } else {
            if(filter.selectedType === "percent") {
                display = (needle * 100).toString();
            } else if(filter.selectedType === "bool") {
                display = (needle ? "True" : "False");
            } else {
                display = needle.toString();
            }
        }

        if(stripTags){
            return display.stripTags();
        }
        return display;
    };

    $scope.updatePercent = function(filter, property) {
        if (filter.selectedType === 'percent') {
            filter[property] = parseFloat(filter[property + 'Percent'])/100;
        }
    };

    $scope.updateFilterProperties = reportFiltersService.updateFilterProperties;

    $scope.submit = function () {
        reportHelper.resolve.$cursorScope.$resolve.modalOpen = false;
        dialog.close(getProcessedFilter());
    };

    $scope.cancel = function () {
        if (!angular.equals(originalFilter, $scope.current.filter)) {
            $dialog.confirmAction("There are changes that will not be committed.  Do you want to proceed?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        reportHelper.resolve.$cursorScope.$resolve.modalOpen = false;
                        dialog.close(null);
                    }
                });
        } else {
            reportHelper.resolve.$cursorScope.$resolve.modalOpen = false;
            dialog.close(null);
        }
    };

    $scope.disableAddFilter = function() {
        return !$scope.current.filter || !$scope.current.filter.label || !$scope.current.filter.selectedFilterType;
    };

    $scope.filterAvailableGroupingOptions = function(groupingOption) {
        return reportHelper.filterGroupingOptionsByAllowedEntityTypes(groupingOption, [$scope.current.filter.context]);
    };

    //INITIALIZE
    $scope.optionsHelper = optionsHelper;
    $scope.resolveOptions = getResolveOptions();
    $scope.boolOptions = [
        { name: "True", value: true },
        { name: "False", value: false }
    ];
    $scope.filterOptions = [
        { type: "equal", name: "Equal To", contexts: ["currency", "decimal", "percent", "date", "datetime", "string", "numeric","bool"] },
        { type: "not-equal", name: "Not Equal To", contexts: ["currency", "decimal", "percent", "date", "datetime", "string", "numeric","bool"] },
        { type: "less-than", name: "Less Than", contexts: ["currency", "decimal", "percent", "date", "datetime", "numeric"] },
        { type: "less-than-equal", name: "Less Than Or Equal To", contexts: ["currency", "decimal", "percent", "date", "datetime", "numeric"] },
        { type: "greater-than", name: "Greater Than", contexts: ["currency", "decimal", "percent", "date", "datetime", "numeric"] },
        { type: "greater-than-equal", name: "Greater Than Or Equal To", contexts: ["currency", "decimal", "percent", "date", "datetime", "numeric"] },
        { type: "range", name: "Between", contexts: ["currency", "decimal", "percent", "date", "datetime", "numeric"] },
        { type: "contains", name: "Contains", contexts: ["string"] },
        { type: "not-contains", name: "Does Not Contain", contexts: ["string"] },
        { type: "ends-with", name: "Ends With", contexts: ["string"] },
        { type: "starts-with", name: "Starts With", contexts: ["string"] }
    ];
    $scope.current = {
        icon: args.action === 'add' ? 'plus' : 'pencil',
        action: args.action.capitalize() + ' ',
        filter: angular.copy(args.filter)
    };

    $scope.groupingOptions = reportHelper.getAllGroupingOptions();

    init();
});

'use strict';

app.controller('ReportHistoryCtrl', function ReportHistoryCtrl($scope, $http, dialog) {
    $scope.historyList = undefined;

    $scope.close = function () {
        dialog.close();
    };

    $scope.restoreReport = function (historyId) {
        dialog.close(historyId);
    };

    function init() {
        $http.get(`/Reporting/Envision/Reports/${dialog.options.args.reportId}/History`, {trackerMsg: 'Loading History'}).then(resp => {
            $scope.historyList = resp.data;
        });
    }

    init();
});

'use strict';

app.controller('QueryBuilderDuplicateColumnNameWarningCtrl', function WarningCtrl($scope, $http, $dialog, dialog, $location, reportHelper, reportSaveService) {
    $scope.ok = function () {
        dialog.close();
    };
});
'use strict';

app.controller('ReportTemplateCtrl', function ReportTemplateCtrl($scope, $http, $q, dialog) {
    //PRIVATE METHODS
    function init() {
        $q.all([
            $http.get('/Reporting/ReportTemplates/Categories', {trackerMsg: 'Loading template categories'}),
            $http.get('/Reporting/Envision/Reports/Categories', {trackerMsg: 'Loading report categories'})
        ]).then(responses => {
            $scope.categories = responses[0].data.concat(responses[1].data).unique().sort();
        });
    }


    //PUBLIC METHODS
    $scope.save = function () {
        dialog.close($scope.template);
    };

    $scope.cancel = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.template = {
        name: null,
        category: null
    };

    init();
});

'use strict';
app.factory('perfSummaryHelper', function perfSummaryHelper() {
    const self = this;
    self.calculatedType = function (result) {
        var calcType = result.$type;
        if (calcType === 'calculated-activity') {
            return result.value;
        }
        else {
            return result.performance !== null ? result.performance * 100 : null;
        }
    };

    self.buildSummaryData = function (entity) {
        var benchmarkSummaryData = []
        entity.forEach(function(ent) {
            if(ent.calculations && ent.calculations.length > 0){
                ent.fkGroupEntity = ent.groupEntityId;
                ent.entityLevel = ent.grouping;
                var breakdown = [];

                ent.calculations.forEach(function(result) {
                    if(result.$type === 'calculated-activity') {
                        ent[result.id] = result.value;
                    };

                    if(result.$type === 'calculated-performance' || result.$type === 'calculated-benchmark-performance') {
                        ent[result.id] = result.performance != null ? result.performance * 100 : null;
                    };

                    //Put the breakdown data into an an array so we can use them later
                    if(result.$type === 'calculated-performance-breakdown') {
                        breakdown.push(result);
                    };

                    //Put the benchmark types into an array so we can use them later
                    if(result.id === 'Benchmarks') {
                        benchmarkSummaryData.push.apply(benchmarkSummaryData, result.calculations);
                    };

                });

                ent.details = breakdown

                if(benchmarkSummaryData && benchmarkSummaryData.length > 0) {
                    //Gets the unique groupEntityIds in benchmarkSummaryData so we can loop over them
                    const distinctBenchmarks = [...new Set( benchmarkSummaryData.map(obj => obj.groupEntityId)) ];
                    var benchmarks = []

                    //For each distinct benchmark find all of the objects in benchmarkSummaryData and put them into a single array for looping
                    distinctBenchmarks.forEach(function(be){
                        var counter = 0
                        var bmArray = []
                        const benchmarkFilter = benchmarkSummaryData.filter(b => b.groupEntityId == [be])

                        //Loop through and if it's the first time period for the benchmark create an array, else insert the object into the already established array
                        benchmarkFilter.forEach(function(bm) {
                            bm.inceptionDate = ent.inceptionDate
                            var tempBenchmarks = []
                            if(counter == 0) {
                                tempBenchmarks.push(bm)
                                counter++
                            }
                            else {
                                bmArray[0].calculations.push.apply(bmArray[0].calculations, bm.calculations)
                            };
                            bmArray.add(tempBenchmarks)
                        })
                        benchmarks.add(bmArray)
                    })
                }
                if(benchmarks) {
                    ent.benchmarks = benchmarks
                }
                else {
                    ent.benchmarks = []
                }
            };
        });
    };

    return self;
});
'use strict';

app.service('deliverHelper', function deliverHelper($location, $oasRights) {
    // PRIVATE VARIABLES
    var self = this;
    var internal = {};

    internal.rights = {
        deliver: $oasRights.forCode("RB3DELIVER")
    };

    function goTo(url, options) {
        $location.url(url + (/\?/.test(url) ? '&' : '?') + Object.keys(options)
            .filter(function(n) {return options[n] !== undefined})
            .map(function(n) {return [n, options[n]].join('=')})
            .join('&')
        );
    }

    function goToEmailList(deliverId, triggerId) {
        goTo('/reports/rbdeliver/emails', {deliverId, triggerId});
    }

    function goToTriggerList(deliverId) {
        goTo('/reports/rbdeliver/triggers', {deliverId});
    }

    // PUBLIC
    self.goToEmailList = goToEmailList;
    self.goToTriggerList = goToTriggerList;
    self.rights = internal.rights;

});
'use strict';

app.controller('DeliverTriggerListCtrl', function DeliverTriggerListCtrl($scope, $http, $oasRights, views, activeState, $timeout, deliverHelper, $dialog) {
    var selectedItems = [];

    function init( ) {}

    function refreshGrid() {
        $timeout(function () {
            $scope.$broadcast('event:deliver-trigger-list-action', {action: 'refresh-grid'});
        });
    }

    $scope.refreshGrid = refreshGrid;

    $scope.goToDeliverEmail = function () {
        if($scope.selectedItem) deliverHelper.goToEmailList($scope.selectedItem.deliverId, $scope.selectedItem.id);
    };

    // INITIALIZE
    $scope.views = views;

    $scope.current = {
        view: views[0],
        activeStates: activeState,
        activeState : activeState.activeAndInActive
    };

    $scope.rights = {
        deliver: deliverHelper.rights.deliver
    };

    Object.defineProperties($scope, {
        selectedItems: {
            get: function() { return selectedItems },
            set: function(items) { selectedItems = items; },
            enumerable: true
        },
        selectedItem: {
            get: function() { return (selectedItems||[])[0] },
            set: function(item) { selectedItems = [item]; },
            enumerable: true
        },
        selectedIds: {
            get: function() { return selectedItems.map(function(item){ return item.id }) },
            set: function(items) { console.log('Implementation Incomplete', items) },
            enumerable: true
        },
    });

    $scope.launchMessageSetup = function(itemId, isOneTime){
        var config = {
            itemId: itemId,
            isNew: itemId === 0,
            isOneTime: isOneTime
        };

        var d = $dialog.dialog({
            dialogClass: "modal wide",
            templateUrl: 'reporting/rbdeliver/modals/deliver-message-setup.html',
            controller: 'DeliverMessageSetupCtrl',
            resolve: {
                args: function () {
                    return config;
                }
            }
        });

        d.open().then(function (rslt) {
            if (rslt) {
                refreshGrid();
            }
        });


    };


    init( );

    //EVENT LISTENERS
    $scope.$on("event:deliver-trigger-list-select", function(e, args) { if( args.length ) selectedItems = args; });
});
'use strict';

app.controller('DeliverInstanceListCtrl', function DeliverInstanceListCtrl($scope, $http, $oasRights, views, $dialog, deliverHelper, reportHelper, $timeout) {
    var selectedItems = [];

    // PRIVATE
    function init( ) {
        reportHelper.getStaticTagConfigs();
    }

    function refreshGrid() {
        $timeout(function () {
            $scope.$broadcast('event:deliver-instance-list-action', {action: 'refresh-grid'});
        });
    }

    $scope.launchMessageSetup = function(itemId, isOneTime){
        var config = {
            itemId: itemId,
            isNew: itemId === 0,
            isOneTime: isOneTime
        };

        var d = $dialog.dialog({
            dialogClass: "modal wide",
            templateUrl: 'reporting/rbdeliver/modals/deliver-message-setup.html',
            controller: 'DeliverMessageSetupCtrl',
            resolve: {
                args: function () {
                    return config;
                }
            }
        });

        d.open().then(function (rslt) {
            if (rslt) {
                refreshGrid();
            }
        });
    };

    $scope.delete = function(itemId){
        $dialog.confirmAction("Are you sure you want to delete this template?  <span class='text-error'>All pending emails will also be deleted!</span>")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $http.delete('/Reporting/Deliver/Instances/Verbose/' + itemId, {trackerMsg: 'Deleting template'})
                        .then(function() {
                            refreshGrid();
                        });
                }
            });
    };

    function preview() {
        // View sent HTML of first selected
        return $dialog
            .dialog({
                templateUrl: "reporting/rbdeliver/modals/deliverSelectPreview.html",
                controller: "DeliverSelectPreviewCtrl",
                deliverId: $scope.selectedItem.id
            })
            .open()
            .then(function (result) {
                if (result) {
                    $dialog.dialog({
                        templateUrl: "reporting/rbdeliver/modals/deliverViewContent.html",
                        controller: "DeliverViewContentCtrl",
                        dialogClass: "modal full",
                        content: result.content,
                        title: result.entityName
                    }).open()
                }
            });
    }

    function goToEmailList () {
        if($scope.selectedItem) deliverHelper.goToEmailList($scope.selectedItem.id);
    }

    function goToTriggerList () {
        deliverHelper.goToTriggerList();
    }

    // PUBLIC
    $scope.refreshGrid = refreshGrid;
    $scope.preview = preview;
    $scope.goToEmailList = goToEmailList;
    $scope.goToTriggerList = goToTriggerList;

    // INITIALIZE
    $scope.views = views;

    $scope.current = {
        view: views[0]
    };

    $scope.rights = {
        deliver: deliverHelper.rights.deliver
    };

    Object.defineProperties($scope, {
        selectedItems: {
            get: function() { return selectedItems },
            set: function(items) { selectedItems = items; },
            enumerable: true
        },
        selectedItem: {
            get: function() { return (selectedItems||[])[0] },
            set: function(item) { selectedItems = [item]; },
            enumerable: true
        },
        selectedIds: {
            get: function() { return selectedItems.map(function(item){ return item.id }) },
            set: function(items) { console.log('Implementation Incomplete', items) },
            enumerable: true
        },
        selectedIdsCanBeDelete: {
            get: function() { return selectedItems.every(function(item){ return item.canBeDeleted; }); },
            set: function(items) { console.log('Implementation Incomplete', items) },
            enumerable: true
        },
    });

    //EVENT LISTENERS
    $scope.$on("event:deliver-instance-list-select", function(e, args) { if( args.length ) selectedItems = args; });

    init( );
});
'use strict';

app.controller('DeliverEmailListCtrl', function DeliverEmailListCtrl($scope, $http, views, $window, $dialog, $route, deliverHelper, $timeout, $signalRManager, API_CONFIG) {
    //PRIVATE VARIABLES
    var selectedItems = [], onRouteChangeOff, canSubscribe = true;

    // PRIVATE
    function init( ) {
        initSignalR();
    }

    function initSignalR( ){
        if($scope.current.deliverId !== null){
            $.connection.hub.qs["deliverId"] = $scope.current.deliverId;
        }else{
            delete $.connection.hub.qs["deliverId"];
        }
        if($scope.current.triggerId !== null){
            $.connection.hub.qs["triggerId"] = $scope.current.triggerId;
        }else{
            delete $.connection.hub.qs["triggerId"];
        }
        $signalRManager.subscribeToHub( 'deliverEmailsHub', 'resetList', null, resetList );
        $signalRManager.subscribeToHub( 'deliverEmailsHub', 'addItems', null, addItems );
        $signalRManager.subscribeToHub( 'deliverEmailsHub', 'updateItems', null, updateItems );
        $signalRManager.subscribeToHub( 'deliverEmailsHub', 'removeItems', null, removeItems );
        onRouteChangeOff = $scope.$on("$routeChangeStart", unsubscribeHubs);
    }

    function unsubscribeHubs() {
        $signalRManager.unSubscribeToHub( 'deliverEmailsHub', 'resetList' );
        $signalRManager.unSubscribeToHub( 'deliverEmailsHub', 'addItems' );
        $signalRManager.unSubscribeToHub( 'deliverEmailsHub', 'updateItems' );
        $signalRManager.unSubscribeToHub( 'deliverEmailsHub', 'removeItems' );
        delete $.connection.hub.qs["deliverId"];
        delete $.connection.hub.qs["triggerId"];

        onRouteChangeOff();
    }

    function resetList(subscribe) {
        if(subscribe === undefined) {
            refreshGrid();
            return;
        }

        canSubscribe = subscribe;
        if(!canSubscribe)
            unsubscribeHubs();
    }

    function addItems(list) {
        $scope.$broadcast('event:deliver-email-list-action', {action: 'upsert-items', items: list });
        list.forEach(function(item){
            updateCount(item, 1);
            $scope.counts.total.value++;
            selectedItems.push(item);
        });
    }

    function updateItems(list) {
        $scope.$broadcast('event:deliver-email-list-action', {action: 'upsert-items', items: list });
        list.forEach(function(item){
            var entityItem = selectedItems.find({id: item.id});
            if(entityItem && (entityItem.generateStatus !== item.generateStatus || entityItem.emailStatus !== item.emailStatus)) {
                updateCount(entityItem, -1);
                updateCount(item, 1);
                entityItem.generateStatus = item.generateStatus;
                entityItem.emailStatus = item.emailStatus;
            }
        });
    }

    function removeItems(list) {
        $scope.$broadcast('event:deliver-email-list-action', {action: 'delete-items', items: list });
        list.forEach(function(item){
            var entityItem = selectedItems.find({id: item.id});
            updateCount(entityItem, -1);
            $scope.counts.total.value--;
            selectedItems.remove(entityItem);
        });
    }

    function updateCount(entityItem, value) {
        switch(entityItem.generateStatus) {
            case "Pending Generation":
                $scope.counts.pendingGeneration.value = $scope.counts.pendingGeneration.value + value;
                break;
            case "Not Generated":
                $scope.counts.notGenerated.value = $scope.counts.notGenerated.value + value;
                break;
            case "Errored Report":
                $scope.counts.errored.value = $scope.counts.errored.value + value;
                break;
            case "Generated":
                $scope.counts.generated.value = $scope.counts.generated.value + value;
                break;
        }
        switch(entityItem.emailStatus) {
            case "Pending Review":
                $scope.counts.pendingReview.value = $scope.counts.pendingReview.value + value;
                break;
            case "Errored":
                $scope.counts.errorSending.value = $scope.counts.errorSending.value + value;
                break;
        }
    }

    function generateCount(statuses) {
        return selectedItems.count(function(entity){
            if(statuses)
                return statuses.some(entity.generateStatus);
            else
                return true;
        });
    }

    function emailCount(statuses) {
        return selectedItems.count(function(entity){
            if(statuses)
                return statuses.some(entity.emailStatus);
            else
                return true;
        });
    }

    function updateCounts() {
        $scope.counts.total.value = generateCount();

        //generate status counts
        $scope.counts.pendingGeneration.value = generateCount(["Pending Generation"]);
        $scope.counts.notGenerated.value = generateCount(["Not Generated"]);
        $scope.counts.errored.value = generateCount(["Errored"]);
        $scope.counts.generated.value = generateCount(["Generated"]);

        //email status counts
        $scope.counts.pendingReview.value = emailCount(["Pending Review"]);
        $scope.counts.errorSending.value = emailCount(["Errored"]);

    }

    function refreshGrid() {
        $timeout(function () {
            $scope.$broadcast('event:deliver-email-list-action', {action: 'refresh-grid'});
        });
	}

	function resend() {
		// Resend selected items in error status
	}

    function download(format) {
        if($scope.selectedIds.length === 1){
            $window.location.href = API_CONFIG.baseUrl + '/Reporting/Deliver/Emails/'+ $scope.selectedIds[0] +'/Action/Download/' + format + '?Authorization=' + sessionStorage.oas_token;
            return;
        }

        // Download selected items
        return $http
            .post(
                '/Reporting/Deliver/Emails/Action/Download?format={1}'.assign(format),
                $scope.selectedIds,
                {trackerMsg: 'Starting Download'})
            .then(function(response){
                $window.location.href = response.headers("location") + "?Authorization=" + sessionStorage.oas_token;
            });
    }

    function updateStatus(status, sendAll) {
        return $http
            .post(
                '/Reporting/Deliver/Emails/Action/{1}'.assign(status),
                sendAll ? null : $scope.selectedIds, //do not include the id list when sending all. The API will look up the ids
                {trackerMsg: 'Updating Status'})
            .then(function(response){return {content: response.data}});
    }

    function view() {
        var key = $scope.selectedIds[0];
        return $http
            .get(
                '/Reporting/Deliver/Emails/{1}/Action/Download/Html'.assign(key),
                $scope.selectedIds,
                {trackerMsg: 'Getting Email'})
            .then(function(response){
                return $dialog
                    .dialog({
                        templateUrl: "reporting/rbdeliver/modals/deliverViewContent.html",
                        controller: "DeliverViewContentCtrl",
                        dialogClass: "modal full",
                        content: response.data
                    })
                    .open()
                    .then(function (rslt) {
                        if (!rslt) return;
                    });
            });
    }

    // PUBLIC
    $scope.refreshGrid = refreshGrid;
    $scope.resend = resend;
    $scope.download = download;
    $scope.view = view;
    $scope.updateStatus = updateStatus;

    // INITIALIZE
    $scope.views = views;
    $scope.counts = {total: {value: 0, change: false}, pendingGeneration: {value: 0, change: false}, notGenerated: {value: 0, change: false}, errored: {value: 0, change: false}, generated: {value: 0, change: false}, pendingReview: {value: 0, change: false}, errorSending: {value: 0, change: false}};
    $scope.current = {
        view: views[0],
        deliverId: parseInt($route.current.params.deliverId) || null,
        triggerId: parseInt($route.current.params.triggerId) || null,
    };

    $scope.rights = {
        deliver: deliverHelper.rights.deliver
    };

    Object.defineProperties($scope, {
        selectedItems: {
            get: function() { return selectedItems },
            set: function(items) { selectedItems = items; },
            enumerable: true
        },
        selectedItem: {
            get: function() { return (selectedItems||[])[0] },
            set: function(item) { selectedItems = [item]; },
            enumerable: true
        },
        selectedIds: {
            get: function() { return selectedItems.map(function(item){ return item.id }) },
            set: function(items) { console.log('Implementation Incomplete', items) },
            enumerable: true
        },
    });


    //EVENT LISTENERS
    $scope.$on('slickgrid-data-loaded', function(event, data) {
        selectedItems = angular.copy(data);
        updateCounts();
    });

    $scope.$on("event:deliver-email-list-select", function(e, args) {
        e.stopPropagation();
        if (args.length === 0) return;

        $scope.current.canDownload = args.every({hasFile: true});
        $scope.current.canGenerate = args.every(function(a){ return (a.generateStatus === 'Generated' && a.emailStatus === 'Pending Review') || a.generateStatus === 'Not Generated' || a.generateStatus === 'Errored'; });
        $scope.current.canReview = args.every(function(a){ return a.generateStatus === 'Generated' && a.emailStatus === 'Pending Review'; });
        $scope.current.canRetrySend = args.every(function(a){ return a.emailStatus === 'Errored'; });

        selectedItems = args;
    });

    init( );
});
'use strict';

app.controller('DeliverViewContentCtrl',function DeliverViewContentCtrl($scope, $http, $oasRights, $dialog, dialog) {
    var viewFrame, viewDoc;

    function init(){ }

    $scope.close = function(data){
        dialog.close(data);
    };

    $scope.$watch('current.content', function(content){
        if(content) {
            $scope.$applyAsync(function() {
                viewFrame = viewFrame || dialog.modalEl[0].querySelector('.contentViewer');
                if(viewFrame.srcdoc === undefined) {
                    viewFrame.contentWindow.document.open('text/html', 'replace');
                    viewFrame.contentWindow.document.write(content);
                    viewFrame.contentWindow.document.close();
                } else {
                    viewFrame.setAttribute('srcdoc', content);
                }
            });
        }
    });

    $scope.$watch('current.url', function(url){
        if(url) {
            $scope.$applyAsync(function() {
                viewFrame = viewFrame || dialog.modalEl[0].querySelector('.contentViewer');
                viewFrame.setAttribute('src', url);
            });
        }

    });

    $scope.current = {
        title: dialog.options.title || '<i class="fa fa-window-maximize fa-lg" aria-hidden="true"></i>&nbsp;View Content',
        buttons: dialog.options.buttons || [{result: 'ok', label: 'OK', focus: true}],
        url: dialog.options.url,
        content: dialog.options.content
    };

    init();

});
'use strict';

app.controller('DeliverSelectPreviewCtrl', function DeliverSelectPreviewCtrl($scope, $http, $oasRights, $q, $dialog, dialog, promiseTracker) {

    function init() {
        $scope.selected.deliverId = dialog.options.deliverId;
    }

    function close(data) {
        dialog.close(data);
    }

    function preview() {
        return $scope.current.tracker.addPromise($http.post(
            '/Reporting/Deliver/Instances/{deliverId}/Action/EmailPreview'.assign($scope.current), {
                entity: $scope.selected.group.entity,
                entityIds: [$scope.selected.entityId],
            },
        )).promise.then(function(response) {
            close({
                entityName: $scope.selected.entity.name,
                entity: $scope.selected.group.entity,
                entityId: $scope.selected.entity.entityId,
                groupId: $scope.selected.groupId,
                groupName: $scope.selected.name,
                content: response.data,
            });
        });
    }

    $scope.preview = preview;
    $scope.close = close;

    $scope.selected = {
        get deliverId() {
            return ($scope.selected.deliver || {}).id;
        },
        set deliverId(id) {
            if ($scope.selected.deliverId === id) return;
            var deliver = $scope.selected.deliver = { id: id, expand: ['groups'].join(',') };

            $http.get('/Reporting/Deliver/Instances/Verbose/{id}?expand={expand}'.assign(deliver), { trackerMsg: 'Loading Deliver Instance' })
                .then(function(response) {
                    angular.extend(deliver, response.data);
                    $scope.selected.groupId = (deliver.groups[0] || {}).id;
                });
        },
        get groupId() {
            return ($scope.selected.group || {}).id;
        },
        set groupId(id) {
            if ($scope.selected.groupId === id) return;
            var group = $scope.selected.group = { id: id };

            return $http.get('/Utility/Groupings/{id}?usedFor=Reporting&doRefresh=true'.assign(group), { trackerMsg: 'Loading dynamic groups' })
                .then(function(response) {
                    angular.extend(group, response.data);
                    $scope.selected.entityId = (group.details[0] || {}).entityId;
                });
        },
        get entityId() {
            return ($scope.selected.entity || {}).entityId;
        },
        set entityId(id) {
            $scope.selected.entity = (($scope.selected.group || {}).details || []).fnFind(function(i) {
                return i.entityId === id;
            });
        },
    };

    $scope.current = {
        title: dialog.options.title || '<i class="fa fa-window-maximize fa-lg" aria-hidden="true"></i>&nbsp;Preview',
        deliverId: dialog.options.deliverId,
        url: dialog.options.url,
        content: dialog.options.content,
        expand: ['groups'].join(','),
        tracker: promiseTracker('deliverPreview'),
    };

    init();

});
'use strict';

app.controller('DeliverMessageSetupCtrl', function DeliverMessageSetupCtrl($scope, $http, $dialog, $location, dialog, args, reportHelper, DT_EVENTS, reportService, $q, entities) {
    //PRIVATE VARIABLES
    let origMessage;

    //PRIVATE METHODS
    function init() {
        loadMessage();
    }
    function updateOneTimeDisplay(){
        $scope.message.template.startDate = Date.create('today');
        $scope.message.template.endDate = Date.create('tomorrow');
        if (!$scope.message.template.name.includes("(Send One Time)"))
            $scope.message.template.name += " (Send One Time)";

    }
    function loadMessage() {
        reportHelper.setScope($scope);
        reportHelper.initScope($scope);
        //make call to get info associated with this item
        const url = '/Reporting/Deliver/Instances/Verbose/' + ($scope.current.isNew ? 'New' : $scope.current.itemId + '?expand=all');

        const messagePromise = $http.get(url, {trackerMsg: 'Loading communication'})
            .then(function (response) {
                $scope.message = response.data;

                $scope.current.report.id = $scope.message.template.reportId;
                if (!$scope.current.isNew){
                    // $scope.loadDateRange($scope.current.report);
                    $scope.current.triggerOption = $scope.message.triggers[0].triggerOption;
                    $scope.current.selectedDelivery = $scope.deliveryOptions.find({name: $scope.message.template.messageType}).code;
                    $scope.current.selectedEntity = $scope.entityOptions.find({name: $scope.message.template.entity}).code;
                } else {
                    $scope.current.triggerOption = angular.copy($scope.trigOptions.find({$type: "dtrSchedule"}));
                }

                origMessage = angular.copy($scope.message);

                if ($scope.current.isOneTime){
                    $scope.current.triggerOption = angular.copy($scope.trigOptions.find({$type: "dtrOneTime"}));
                }

            });

        const settingsPromise = reportService.getGlobalSettings().then(function (response) {
            $scope.globalSettings = response.data;
        });

        $q.all([messagePromise, settingsPromise]).then(() => {
            loadTrigOptions();
            loadDynamicGroups();

            reportHelper.refreshOptions();
            if (!$scope.current.isNew){
                $scope.loadDateRange($scope.current.report);  
            }
        });
    }

    function loadTrigOptions() {
        if (isRepSelected()) {
                $scope.trigOptions = angular.copy($scope.trigOptionsAll.filter(function(t) {
                    return (t["$type"] === "dtrOneTime" || t["$type"] === "dtrSchedule");
                }));
            }
        else {
                $scope.trigOptions = angular.copy($scope.trigOptionsAll).sortBy('name');
        }
    }

    function loadDynamicGroups() {
        // Reporting groups for Entity 5/Household or 4/Representative; omit isPrivate so reps see their private groups
        const groupingManagerPath = '/Utility/Groupings/Simple?' + (isRepSelected() ? '' : 'usedFor=Reporting&') + '&entity=' + (isRepSelected() ? '4' : '5');

        $http.get(groupingManagerPath, {trackerMsg: 'Loading dynamic groups'})
            .then(function (response) {
                $scope.dynamicGroup = response.data.map(function (dg) {return {id: dg.id, name: dg.name}});
            });
    }

    function isRepSelected() {
        return ($scope.current.selectedEntity === 'representative');
    }

    function isRepUser() {
        return ($scope.user.authorization.entity === entities.representative.name);
    }

    //PUBLIC METHODS
    $scope.invalidEmail = function (invalid) {
        $scope.message.extensionEmail.fromInvalid = invalid;
    }

    $scope.setEmail = function (value) {
        $scope.message.extensionEmail.from = value;
    }

    $scope.invalidBccEmail = function (invalid) {
        $scope.message.extensionEmail.bccInvalid = invalid;
    }

    $scope.setBccEmail = function (value) {
        $scope.message.extensionEmail.bcc = value;
    }

    $scope.cancel = function () {
        if (!angular.equals(origMessage, $scope.message)) {
            $dialog.confirmAction("There are changes that will be lost.  Do you want to proceed?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        dialog.close(null);
                    }
                });
        } else {
            dialog.close(null);
        }

    };

    $scope.save = function(){
        if ($scope.message.extensionEmail.fromInvalid || $scope.message.extensionEmail.bccInvalid) {
            $dialog.actionFailed('Email is invalid.').open();
        }

        $scope.message.template.reportId = $scope.current.report.id;
        $scope.message.reportOptions[0] = $scope.current.dateRangeOption;
        if($scope.message.triggers.length === 0)
            $scope.message.triggers.add({triggerOption: {}, deliverText: ''});
        $scope.message.triggers[0].triggerOption = $scope.current.triggerOption;
        $scope.message.template.messageType = $scope.deliveryOptions.find({code: $scope.current.selectedDelivery}).name;
        $scope.message.template.entity = $scope.entityOptions.find({code: $scope.current.selectedEntity}).name;
        if($scope.message.template.messageType === 'Text')
            $scope.message.triggers[0].deliverText = $scope.message.triggers[0].deliverText.stripTags().replace(/&nbsp;/g, ' ');
        if (!angular.equals(origMessage, $scope.message)) {
            let args = $scope.current.isNew || $scope.current.isOneTime ? {method: "POST", id: "", trackerMsg: "Adding new template"} : {method: "PUT", id: $scope.current.itemId, trackerMsg: "Saving template " + $scope.current.itemId};

            $http({ method: args.method, url: '/Reporting/Deliver/Instances/Verbose/' + args.id, data: $scope.message, trackerMsg: args.trackerMsg })
                .then(function (response) {
                    dialog.close(response.data)
                });
        }
    };

    $scope.goToGroupingManager = function(){
        const groupingManagerPath = '/tools/groupingmanager/' + $scope.current.selectedEntity + 's';

        if (!angular.equals(origMessage, $scope.message)) {
            $dialog.confirmAction("There are changes that will be lost.  Do you want to proceed?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $location.path(groupingManagerPath);
                        dialog.close(null);
                    }
                });
        }else{
            $location.path(groupingManagerPath);
            dialog.close(null);
        }
    };

    $scope.loadDateRange = function (report){
        reportHelper.getReport(false, report.id, false, 'portfolio,alloptions,schema')
            .then(function(response){
                const data = response.data ? response.data : response;
                $scope.current.report.name = data.name;
                $scope.current.report.id = data.id;
                $scope.current.selectedReport = $scope.current.report;
                reportHelper.getOptions('date-range')
                    .then(function (options) {
                        if(options.length === 0) {
                            options = data.additionalOptions.find(x => x.$type === 'daterange').options;
                        }

                        $scope.dateRangeList = options;                        

                        if ($scope.current.report.id !== $scope.message.template.reportId){
                            reportHelper.getDefault('date-range')
                                .then (function (defaultOpt){
                                    if (defaultOpt)
                                    $scope.current.dateRangeOption = $scope.dateRangeList.find(function (option) {return findMatchingOptionByGuidOrId(option, defaultOpt)});
                                });
                        }
                        else{
                                $scope.current.dateRangeOption = $scope.dateRangeList.find(function (option) {return findMatchingOptionByGuidOrId(option, $scope.message.reportOptions[0])});
                        }
                    });
            });
    };

    function findMatchingOptionByGuidOrId(option, optionToMatch) {
        if (optionToMatch?.optionGuid) {
            return option?.optionGuid === optionToMatch.optionGuid;
        }

        return option?.optionId === optionToMatch?.optionId;
    }

    $scope.triggerChanged = function() {
        //make sure the trigger option that was selected gets seeded with the default for that kind of trigger
        $scope.current.triggerOption = angular.copy($scope.trigOptions.find({$type: $scope.current.triggerOption.$type}));
    };

    $scope.changeSelectedDelivery = function(value) {
        switch(value){
            case 'text':
                $scope.current.htmlText = $scope.message.triggers[0].deliverText;
                $scope.message.triggers[0].deliverText = $scope.current.htmlText.stripTags().replace(/&nbsp;/g, ' ');
                break;

            case 'email':
                if($scope.current.htmlText){
                    $scope.message.triggers[0].deliverText = $scope.current.htmlText;
                }
                break;
        }
    };

    $scope.changeSelectedEntity = function() {
        loadTrigOptions();
        loadDynamicGroups();
    };

    $scope.changeDeliverText = function(deliverText) {
        if($scope.message) {
            switch ($scope.current.selectedDelivery) {
                case 'text':
                    $scope.current.htmlText = deliverText;
                    $scope.message.triggers[0].deliverText = $scope.current.htmlText.stripTags().replace(/&nbsp;/g, ' ');
                    break;

                case 'email':
                    //keep a copy of the email text so we can revert back to it if we need to
                    $scope.current.htmlText = deliverText;
                    break;
            }
        }
    };

    $scope.getModel = function (value) {
        if (value) {
            $scope.current.dateRangeOption = value;
        }

        return $scope.current.dateRangeOption;
    }

    $scope.$watch("current.triggerOption.$type",function(newValue,oldValue){
        if(newValue === oldValue) return;
        if(newValue === "dtrOneTime"){
            updateOneTimeDisplay();
        }

    });

    $scope.$watch('dynamicGroup', function(newDynamicGroup, oldDynamicGroup) {
        if (newDynamicGroup === oldDynamicGroup) return;

        $scope.dynamicGroup = newDynamicGroup;
    });

    //INITIALIZE
    $scope.current = {
        itemId: args.itemId,
        isNew: args.isNew,
        triggerOption: null,
        selectedEntity: "household",
        selectedDelivery: "email",
        report: {},
        dateRangeOption: {},
        isOneTime: args.isOneTime,
        htmlText: "",
        isRepUser: isRepUser()
    };

    $scope.trigOptionsAll = angular.copy(DT_EVENTS).sortBy('name');
    $scope.trigOptions = angular.copy(DT_EVENTS).sortBy('name');
    $scope.deliveryOptions = [{name: "Email", code: "email"}, {name: "Text", code: "text"}];
    $scope.entityOptions = [{name: "Household", code: "household"}, {name: "Representative", code: "representative"}];

    init();

});

app.constant('DT_EVENTS', []);

app.run(function ($templateCache, DT_EVENTS) {
    app._invokeQueue.forEach(function (item) {
        if (item[1] === 'component') {
            const componentName = item[2][0];
            if (componentName.startsWith('dtr')) {
                let orionData = item[2][1].OAS_DATA;

                if(orionData){
                    if (orionData.noConfiguration) {
                        $templateCache.put(componentName, '<tr-no-configuration></tr-no-configuration>');
                    } else {
                        $templateCache.put(componentName, '<{1} selected="current.triggerOption" on-update="current.triggerOption = selected"></{1}>'.assign(componentName.dasherize()));
                    }

                    if (!angular.isArray(orionData)) {
                        orionData = [orionData];
                    }
                    orionData.forEach(function (item) {
                        if(item.category == undefined){
                            item.category = 'Event';
                        }
                        DT_EVENTS.push(item);
                    });
                }
            }
        }
    });
    if(DT_EVENTS.length > 0)
        DT_EVENTS = DT_EVENTS.sortBy('name');
});

'use strict';

app.component('dtrSchedule', {
    OAS_DATA: {
        name: 'Schedule',
        $type: 'dtrSchedule',
        category: 'Recurring',
        noConfiguration: false,
        scheduleType: "Monthly",
        monthDay: 1
    },
    templateUrl: 'reporting/rbdeliver/components/dtrSchedule.html',
    bindings: {
        selected: '<',
        onUpdate: '&'
    },
    controller: function () {

        //PRIVATE VARIABLES
        var $ctrl = this;
        var scheduleType;

        //PUBLIC VARIABLES
        $ctrl.scheduleTypes = [
            { id: "Weekly", name: "Weekly" },
            { id: "Monthly", name: "Monthly" },
            { id: "Quarterly", name: "Quarterly" },
            { id: "Yearly", name: "Yearly" }
        ];

        $ctrl.daysOfWeek = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ];

        $ctrl.months = [
            { id: 1, name: "January" },
            { id: 2, name: "February" },
            { id: 3, name: "March" },
            { id: 4, name: "April" },
            { id: 5, name: "May" },
            { id: 6, name: "June" },
            { id: 7, name: "July" },
            { id: 8, name: "August" },
            { id: 9, name: "September" },
            { id: 10, name: "October" },
            { id: 11, name: "November" },
            { id: 12, name: "December" }
        ];

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if($ctrl.selected === undefined){
                $ctrl.selected = null;
            }
            if ($ctrl.selected){
                scheduleType = $ctrl.selected.scheduleType;
            }
        };

        $ctrl.$doCheck = function () {
            if($ctrl.selected.$type !== 'dtrSchedule') return;

            if (!angular.equals($ctrl.selected.scheduleType, scheduleType)) {
                var newScheduleType = $ctrl.selected.scheduleType;
                if (scheduleType) {
                    $ctrl.selected = {}
                }
                if (newScheduleType){
                    $ctrl.selected.scheduleType = newScheduleType;
                    scheduleType = newScheduleType;
                }
                $ctrl.selected.$type = 'dtrSchedule';
            }

            $ctrl.onUpdate({selected: $ctrl.selected});
        };
    }
});
'use strict';

app.component('dtrOneTime', {
    OAS_DATA: {
        name: 'One time',
        $type: 'dtrOneTime',
        category: 'One time',
        noConfiguration: true
    },
    template: '',
    bindings: {
        selected: '<',
        onUpdate: '&'
    },
    controller: function () {

        //PRIVATE VARIABLES
        var $ctrl = this;

        //PUBLIC VARIABLES

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if($ctrl.selected === undefined){
                $ctrl.selected = null;
            }
        };

        $ctrl.$doCheck = function () {
            $ctrl.onUpdate({selected: $ctrl.selected});
        };
    }
});
'use strict';

app.component('dtrAumThreshold', {
    OAS_DATA: {
        name: 'AUM Threshold',
        $type: 'dtrAumThreshold',
        noConfiguration: false,
        threshold: 250000
    },
    templateUrl: 'reporting/rbdeliver/components/dtrAumThreshold.html',
    bindings: {
        selected: '<',
        onUpdate: '&'
    },
    controller: function () {

        //PRIVATE VARIABLES
        var $ctrl = this;

        //PUBLIC VARIABLES

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if($ctrl.selected === undefined){
                $ctrl.selected = null;
            }
        };


        $ctrl.$doCheck = function () {
            $ctrl.onUpdate({selected: $ctrl.selected});
        };


    }
});
'use strict';

app.component('dtrBirthday', {
    OAS_DATA: {
        name: 'Birthday',
        $type: 'dtrBirthday',
        noConfiguration: true
    },
    template: '',
    bindings: {
        selected: '<',
        onUpdate: '&'
    },
    controller: function () {

        //PRIVATE VARIABLES
        var $ctrl = this;

        //PUBLIC VARIABLES

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if($ctrl.selected === undefined){
                $ctrl.selected = null;
            }
        };

        $ctrl.$doCheck = function () {
            $ctrl.onUpdate({selected: $ctrl.selected});
        };
    }
});
'use strict';

app.component('dtrContribution', {
    OAS_DATA: {
        name: 'Minimum Contribution',
        $type: 'dtrContribution',
        noConfiguration: false,
        minimumContribution: 10000
    },
    templateUrl: 'reporting/rbdeliver/components/dtrContribution.html',
    bindings: {
        selected: '<',
        onUpdate: '&'
    },
    controller: function () {

        //PRIVATE VARIABLES
        var $ctrl = this;

        //PUBLIC VARIABLES

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if($ctrl.selected === undefined){
                $ctrl.selected = null;
            }
        };


        $ctrl.$doCheck = function () {
            $ctrl.onUpdate({selected: $ctrl.selected});
        };


    }
});
'use strict';

app.component('dtrDistribution', {
    OAS_DATA: {
        name: 'Minimum Distribution',
        $type: 'dtrDistribution',
        noConfiguration: false,
        minimumDistribution: -10000
    },
    templateUrl: 'reporting/rbdeliver/components/dtrDistribution.html',
    bindings: {
        selected: '<',
        onUpdate: '&'
    },
    controller: function () {

        //PRIVATE VARIABLES
        var $ctrl = this;

        //PUBLIC VARIABLES

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if($ctrl.selected === undefined){
                $ctrl.selected = null;
            }
        };


        $ctrl.$doCheck = function () {
            $ctrl.onUpdate({selected: $ctrl.selected});
        };


    }
});
'use strict';

app.component('dtrWelcome', {
    OAS_DATA: {
        name: 'Welcome',
        $type: 'dtrWelcome',
        noConfiguration: true
    },
    template: '',
    bindings: {
        selected: '<',
        onUpdate: '&'
    },
    controller: function () {

        //PRIVATE VARIABLES
        var $ctrl = this;

        //PUBLIC VARIABLES

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if($ctrl.selected === undefined){
                $ctrl.selected = null;
            }
        };

        $ctrl.$doCheck = function () {
            $ctrl.onUpdate({selected: $ctrl.selected});
        };
    }
});
'use strict';

app.component('dtrNewAccount', {
    OAS_DATA: {
        name: 'New Account',
        $type: 'dtrNewAccount',
        noConfiguration: true
    },
    template: '',
    bindings: {
        selected: '<',
        onUpdate: '&'
    },
    controller: function () {

        //PRIVATE VARIABLES
        var $ctrl = this;

        //PUBLIC VARIABLES

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if($ctrl.selected === undefined){
                $ctrl.selected = null;
            }
        };

        $ctrl.$doCheck = function () {
            $ctrl.onUpdate({selected: $ctrl.selected});
        };
    }
});
'use strict';

app.component('dtrValueOverNai', {
    OAS_DATA: {
        name: 'AUM Over NAI Threshold',
        $type: 'dtrValueOverNai',
        noConfiguration: false,
        percentThreshold: 10
    },
    templateUrl: 'reporting/rbdeliver/components/dtrValueOverNai.html',
    bindings: {
        selected: '<',
        onUpdate: '&'
    },
    controller: function () {

        //PRIVATE VARIABLES
        var $ctrl = this;

        //PUBLIC VARIABLES

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if($ctrl.selected === undefined){
                $ctrl.selected = null;
            }
        };


        $ctrl.$doCheck = function () {
            $ctrl.onUpdate({selected: $ctrl.selected});
        };


    }
});
'use strict';

app.component('dtrUpcomingRmdByAge', {
    OAS_DATA: {
        name: 'RMD Beginning Soon (Req. Age)',
        $type: 'dtrUpcomingRmdByAge',
        noConfiguration: true
    },
    template: '',
    bindings: {
        selected: '<',
        onUpdate: '&'
    },
    controller: function () {

        //PRIVATE VARIABLES
        var $ctrl = this;

        //PUBLIC VARIABLES

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if($ctrl.selected === undefined){
                $ctrl.selected = null;
            }
        };

        $ctrl.$doCheck = function () {
            $ctrl.onUpdate({selected: $ctrl.selected});
        };
    }
});
'use strict';

app.component('dtrSatisfiedRmd', {
    OAS_DATA: {
        name: 'RMD Satisfied',
        $type: 'dtrSatisfiedRmd',
        noConfiguration: true
    },
    template: '',
    bindings: {
        selected: '<',
        onUpdate: '&'
    },
    controller: function () {

        //PRIVATE VARIABLES
        var $ctrl = this;

        //PUBLIC VARIABLES

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if($ctrl.selected === undefined){
                $ctrl.selected = null;
            }
        };

        $ctrl.$doCheck = function () {
            $ctrl.onUpdate({selected: $ctrl.selected});
        };
    }
});
'use strict';

app.component('dtrOffTrackRmd', {
    OAS_DATA: {
        name: 'RMD Off Track',
        $type: 'dtrOffTrackRmd',
        noConfiguration: true
    },
    template: '',
    bindings: {
        selected: '<',
        onUpdate: '&'
    },
    controller: function () {

        //PRIVATE VARIABLES
        var $ctrl = this;

        //PUBLIC VARIABLES

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if($ctrl.selected === undefined){
                $ctrl.selected = null;
            }
        };

        $ctrl.$doCheck = function () {
            $ctrl.onUpdate({selected: $ctrl.selected});
        };
    }
});
'use strict';

app.component('dtrManagementStyleChange', {
    OAS_DATA: {
        name: 'Management Style Change',
        $type: 'dtrManagementStyleChange',
        noConfiguration: true
    },
    template: '',
    bindings: {
        selected: '<',
        onUpdate: '&'
    },
    controller: function () {

        //PRIVATE VARIABLES
        var $ctrl = this;

        //PUBLIC VARIABLES

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if($ctrl.selected === undefined){
                $ctrl.selected = null;
            }
        };

        $ctrl.$doCheck = function () {
            $ctrl.onUpdate({selected: $ctrl.selected});
        };
    }
});
'use strict';

app.component('dtrModelChange', {
    OAS_DATA: {
        name: 'Model Change',
        $type: 'dtrModelChange',
        noConfiguration: true
    },
    template: '',
    bindings: {
        selected: '<',
        onUpdate: '&'
    },
    controller: function () {

        //PRIVATE VARIABLES
        var $ctrl = this;

        //PUBLIC VARIABLES

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if($ctrl.selected === undefined){
                $ctrl.selected = null;
            }
        };

        $ctrl.$doCheck = function () {
            $ctrl.onUpdate({selected: $ctrl.selected});
        };
    }
});
'use strict';

app.component('dtrMoneyGuideProScore', {
    OAS_DATA: {
        name: 'Probability Score Change Threshold',
        $type: 'dtrMoneyGuideProScore',
        noConfiguration: false,
        probabilityScoreChangePct: 10
    },
    templateUrl: 'reporting/rbdeliver/components/dtrMoneyGuideProScore.html',
    bindings: {
        selected: '<',
        onUpdate: '&'
    },
    controller: function () {

        //PRIVATE VARIABLES
        var $ctrl = this;

        //PUBLIC VARIABLES

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if($ctrl.selected === undefined){
                $ctrl.selected = null;
            }
        };


        $ctrl.$doCheck = function () {
            $ctrl.onUpdate({selected: $ctrl.selected});
        };


    }
});
'use strict';

app.component('dtrTradesGenerated', {
    OAS_DATA: {
        name: 'Trades Generated',
        $type: 'dtrTradesGenerated',
        noConfiguration: true
    },
    template: '',
    bindings: {
        selected: '<',
        onUpdate: '&'
    },
    controller: function () {

        //PRIVATE VARIABLES
        var $ctrl = this;

        //PUBLIC VARIABLES

        //PRIVATE METHODS

        //PUBLIC METHODS

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            if($ctrl.selected === undefined){
                $ctrl.selected = null;
            }
        };

        $ctrl.$doCheck = function () {
            $ctrl.onUpdate({selected: $ctrl.selected});
        };
    }
});
'use strict';

var confirmationOverviewCtrl = app.controller('ConfirmationOverviewCtrl', function ConfirmationOverviewCtrl($rootScope, $scope, $http, $oasRights, $dialog, $timeout, views, defaults, tokenFactory, API_CONFIG, $settings, $confirmation, ConfirmationOverview, $routeParams, oasProps, $templateCache, $reconServicesHelper, splitIoService, privilegeService) {

    // PRIVATE VARIABLES
    var tokenOverride;
    var selectedGroupId = null;
    var databaseTokens = {};
    var selectedRows = [];
    var redirectUrl = window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html?";
    var props = oasProps.oasSearchProps;

    const confirmOverviewFileIdsSessionKey = 'confirm_overview_fileids';
    const blockedStatusesForSchedulerInProgress = [0, 1, 2, 3, 4, 5, 6, 8, 9, 11];
    const blockedStatusesForVerifyApplyReconfirm = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 11];
    const AGENT_ACTION_REVIEW_UNMAPPED_TRANS_VIEW_MODE = 'unmappedTransCodes';
    const AGENT_ACTION_REVIEW_MISSING_REG_TYPE_VIEW_MODE = 'missingRegTypeMapping';
    const AGENT_ACTION_REVIEW_LOAD_FOR_DATABASE = 1;
    const UNMAPPED_COUNT_LINK_STYLE = 'color: #007ad9; cursor: pointer; text-decoration: underline;';

    function unmappedCountLinkFormatter(row, cell, value, columnDef, dataContext) {
        const count = value ?? 0;
        if (count <= 0 || !$scope.canReadAgentActionReview) {
            return String(count);
        }

        const alClientId = dataContext.alClientId ?? dataContext.AlClientId;
        const viewMode =
            columnDef.field === 'unmappedRegTypeCount'
                ? AGENT_ACTION_REVIEW_MISSING_REG_TYPE_VIEW_MODE
                : AGENT_ACTION_REVIEW_UNMAPPED_TRANS_VIEW_MODE;
        return `<span class="confirm-overview-embed-link" style="${UNMAPPED_COUNT_LINK_STYLE}" data-al-client-id="${alClientId}" data-view-mode="${viewMode}">${count}</span>`;
    }

    function navigateToAgentActionReviewFromConfirmOverview(alClientId, viewMode) {
        if (!alClientId || !viewMode || !$scope.canReadAgentActionReview) {
            return;
        }

        const url = '#/confirmation/recon/agentactionreview?' + Object.toQueryString({
            viewMode: viewMode,
            loadFor: AGENT_ACTION_REVIEW_LOAD_FOR_DATABASE,
            loadId: alClientId
        });
        window.open(url, '_blank');
    }

    function configureUnmappedCountLinkColumns() {
        ($scope.views || []).forEach(function (view) {
            ['unmappedTransTypeCount', 'unmappedRegTypeCount'].forEach(function (field) {
                const column = view.slickGridColumnDefs.find({ field: field });
                const flag = '__unmappedCountLinkConfigured_' + field;
                if (column && !column[flag]) {
                    column.formatter = unmappedCountLinkFormatter;
                    column[flag] = true;
                }
            });
        });
    }

    function attachUnmappedCountLinkClickHandler() {
        angular.element(document).off('click.confirmOverviewUnmappedLink');
        angular.element(document).on('click.confirmOverviewUnmappedLink', '.confirm-overview-embed-link', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $target = angular.element(this);
            const alClientId = $target.data('al-client-id');
            const viewMode = $target.data('view-mode') || AGENT_ACTION_REVIEW_UNMAPPED_TRANS_VIEW_MODE;
            navigateToAgentActionReviewFromConfirmOverview(alClientId, viewMode);
        });
    }

    // PRIVATE METHODS
    function init( ) {
        $confirmation.cleanupLocalStorage();

        $scope.databases = defaults.databases;
        $scope.fileTypes = defaults.fileTypes;
        $scope.downloadFormats = defaults.downloadFormats;
        $scope.confirmationGroups = defaults.confirmationGroups;
        
        if($routeParams.batchProcessingId)
            $scope.current.view.filters.push({
                name: "BatchProcessingId = " + $routeParams.batchProcessingId,
                value: "(function (a) { return a == "+$routeParams.batchProcessingId+"; })",
                key: "batchProcessingId",
                include: true,
                forced: true
            });
        if($routeParams.defaultStartDate) $scope.current.filterStartDate = Date.create($routeParams.defaultStartDate);
        if($routeParams.defaultEndDate) $scope.current.filterEndDate = Date.create($routeParams.defaultEndDate);
        if($routeParams.startDate) $scope.current.filterStartDate = Date.create($routeParams.startDate);
        if($routeParams.endDate) $scope.current.filterEndDate = Date.create($routeParams.endDate);
        if($routeParams.downloadSourceKeys) $scope.current.downloadSourceKeys = $routeParams.downloadSourceKeys;

        selectedGroupId = parseInt(defaults.group.value);

        if ($routeParams.loadFor) {
            var routeLoadFor = parseInt($routeParams.loadFor, 10);
            if (!isNaN(routeLoadFor)) {
                $scope.current.selectedConfirmEntity = routeLoadFor;
            }
        }
        if ($routeParams.loadId) {
            var routeLoadId = parseInt($routeParams.loadId, 10);
            if (!isNaN(routeLoadId)) {
                if ($scope.current.selectedConfirmEntity === 4) {
                    selectedGroupId = routeLoadId;
                } else if ($scope.current.selectedConfirmEntity === 1) {
                    $scope.current.selectedALClient = routeLoadId;
                } else if ($scope.current.selectedConfirmEntity === 2) {
                    $scope.current.selectedFormat = routeLoadId;
                }
            }
        }

        setDates( );
    
        $templateCache.put("oasSearch-itemTemplate.html", '<a tabindex="-1" ng-class="{muted: match.model.isActive == false}"><i class="fa fa-fw {{ match.model.icon }}"></i> <span ng-bind-html="match.label | typeaheadHighlight:query"></span></a>');
    
        $scope.accountTypeAhead = angular.extend({inProgress: false}, props['account'],{ advancedSearch:false});
        $scope.accountTypeAhead.formatter = accountTypeAheadFormater;
        $reconServicesHelper.getIsMultiUndoEnabled($scope);        

        splitIoService.getBoolTreatment('recon_confirm_limitfileaction_21715').subscribe(function (isEnabled) {
            $scope.current.limitFileActionFlagEnabled = isEnabled;
        });

        configureUnmappedCountLinkColumns();
        attachUnmappedCountLinkClickHandler();
    }

    function setDates( ) {
        angular.merge($scope.current, {
            startDate: $scope.current.filterStartDate.format('{MM}-{dd}-{yyyy}'),
            endDate: $scope.current.filterEndDate.format('{MM}-{dd}-{yyyy}')
        });
    }

    function accountTypeAheadFormater (item) {
        return !item ? '' : item.id + ': ' + item.number + ' (' + item.name.replace('\n','') + ')';
    }

    function doAction( actionUrl, trackerVerb, confirmMsg, isVerifyApply ) {
        $dialog.confirmAction( confirmMsg ).open( )
            .then(function(result){
                if( result !== 'yes' ) return Promise.reject();
                if( isVerifyApply ){
                    checkAndDisplaySelectedFinishedPostProcessing();

                    $http.put(actionUrl, $scope.selectedIds, {trackerMsg: 'Submitting ' + trackerVerb + ' request'})
                        .then(function (response) { if( response.data ) startPollingStatus( response.data, angular.copy($scope.selectedIds) ) });
                }
                else
                    $http.put(actionUrl, $scope.selectedIds, {trackerMsg: 'Refreshing file data'})
                        .then(function (response) { if( response.data ) $scope.$broadcast('event:confirm-overview-action', {action: 'update-items', items: response.data }) });

            });
    }
    
    function startOldPollingStatus(batchId, ids) {
        var lastData;
        var parentId = batchId;
        var sameDataCount = 0;
        var errorCount = 0;

        var pollStatus = function (batchId, ids) {
            if (sameDataCount > 200) {
                $rootScope.$broadcast('event:progress-update', { id: parentId, isDone: true, msg: parentId + ": Status updates aborted", type: "warning" });
                return;
            }

            if (errorCount > 25) {
                if (parentId) $rootScope.$broadcast('event:progress-update', { id: parentId, isDone: true, msg: parentId + ": Status updates aborted", type: "warning" });
                return;
            }

            $http.get("/Confirm/Overview/CheckStatus/" + batchId + "?includeErrors=true", { ignoreExceptions: true })
                .then(function (response) {
                    if (angular.equals(response.data, lastData)) {
                        sameDataCount += 1;
                        $timeout(function () { pollStatus(batchId, ids); }, 5000);
                        return;
                    }

                    sameDataCount = 0;

                    var progress = { id: parentId, completed: response.data.itemsCompleted, total: response.data.totalItems };

                    if (response.data.isDone) {

                        if (response.data.errorCount > 0) {
                            console.log(response.data);
                            var message = response.data.details[0].errorMessage;
                            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Error", message, [{ result: 'OK', label: 'OK', cssClass: 'btn-primary', focus: true }]).open();
                        }
                        progress.isDone = true;

                        $http.post("/Confirm/Overview/List/Id", ids, { trackerMsg: 'Refreshing rows' })
                            .then(function (r) {
                                $scope.$broadcast('event:confirm-overview-action', { action: 'update-items', items: r.data });
                            });

                    }
                    else
                        $timeout(function () { pollStatus(batchId, ids); }, 5000);

                    $rootScope.$broadcast('event:progress-update', progress);
                    lastData = response.data;
                })
                .catch(function () {
                    errorCount += 1;
                    $timeout(function () { pollStatus(batchId, ids); }, 20000);
                });
        };

        pollStatus(batchId, ids);
    }

    function startPollingStatus( response, ids ) {
        startOldPollingStatus(response, ids);
    }
    
    function loadAnalytics( groupBy ) {
        let chartData = [];
        let categories = [];
        let groupId = $scope.current.selectedConfirmEntity == 4 ? selectedGroupId : '';
        let databaseId = $scope.current.selectedConfirmEntity == 1 ? $scope.current.selectedALClient : '';
        let formatId = $scope.current.selectedConfirmEntity == 2 ? selectedGroupId : '';
        let fileTypeId = $scope.current.selectedConfirmEntity == 0 ? $scope.current.selectedALClient : '';
        let searchFileId = null;

        $http.get("/Confirm/Overview/Summary?confirmGroupId=" + groupId + "&groupBy=" + groupBy + "&startDate=" + $scope.current.startDate + "&endDate=" + $scope.current.endDate + "&databaseId=" + databaseId + "&downloadFormatId=" + formatId + "&recordType=" + fileTypeId + "&fileId=" + searchFileId, {trackerMsg: 'Loading summary chart'})
            .then(function (response) {
                for( var i = 0; i < response.data.length; i++ ) {
                    if( response.data[i].value != 0 ) {
                        categories.push(response.data[i].name);

                        var wedge = {
                            y: Math.abs( response.data[i].value ),
                            color: '#666666',
                            drilldown: {
                                name: response.data[i].name,
                                categories: [],
                                data: [],
                                color: '#666666',
                                groupBy: groupBy
                            }
                        };

                        if( response.data[i].children ) {
                            for( var j = 0; j < response.data[i].children.length; j++ ) {
                                if( response.data[i].children[j].value != 0 ) {
                                    wedge.drilldown.data.push( {name: response.data[i].children[j].name, value: Math.abs(response.data[i].children[j].value), groupBy: groupBy} );
                                    wedge.drilldown.categories.push( response.data[i].children[j].name );
                                }
                            }
                        }

                        chartData.push(wedge);
                    }
                }

                var groupData = [];
                var detailData = [];
                var colors = {confirmed: "#009A31", notConfirmed: "#FF2400", excluded: "#66C283"};

                for (var k = 0; k < chartData.length; k++) {
                    groupData.push({
                        name: categories[k],
                        y: chartData[k].y,
                        color: chartData[k].color,
                        groupBy: groupBy
                    });

                    for (var l = 0; l < chartData[k].drilldown.data.length; l++) {
                        detailData.push({
                            name: chartData[k].drilldown.categories[l].first(30),
                            y: chartData[k].drilldown.data[l].value,
                            color: colors[chartData[k].drilldown.data[l].name.camelize(false)],
                            parent: chartData[k].drilldown.name,
                            groupBy: chartData[k].drilldown.groupBy
                        });
                    }
                }

                $scope.groupingChartConfig.series[0].data = groupData;
                $scope.groupingChartConfig.series[1].data = detailData;
            });
    }

    function filterForChartGroup( point, isParentSlice ) {
        var parent = {
            "0": {field: "recordTypeName", name: "File Type"},
            "1": {field: "databaseName", name: "Database"},
            "2": {field: "formatName", name: "Format"}
        };

        $scope.current.view.filters.remove({forced: true});
        $scope.current.view.filters.push({ name: parent[point.groupBy].name + " = " + point.name, value: "(function (a) { return a === '" + point[isParentSlice ? 'name' : 'parent'] + "'; })", key: parent[point.groupBy].field, include: true, forced: true });

        if( !isParentSlice ) {
            $scope.current.view.filters.push({ name: point.name + " > 0", value: "(function (a) { return a > 0; })", key: point.name.camelize(false) + "Count", include: true, forced: true });
        }

        $scope.$apply();
    }

    function addIdTokenToDatabaseTokens(id){
        return tokenFactory.getDatabaseToken(id).then(function (token) {
            databaseTokens[id] = token;
            $scope.current.accountHistoryAlClientToken = token;
        });
    }

    function checkAndDisplaySelectedFinishedPostProcessing(){
        //filter out selected items that post import isn't finished with
        $scope.current.selectedItemsNotAvailable = $scope.selectedItems.filter(item=>{
            if(!item.isImportComplete){
                return item;
            }
        })

        //create message with items that aren't finished
        var messages = [];
        if($scope.current.selectedItemsNotAvailable.length > 0){
            $scope.current.selectedItemsNotAvailable.forEach(item=>{
                var message = `File ID ${item.downloadFileId} in Database: (${item.databaseName}) `;
                messages.push(message);
            });
        }

        //display message to user
        if(messages.length > 0){
            var aggregateMessage = messages.join() + "could not verify/apply or undo due to import in progress";                
            $dialog.messageBox(aggregateMessage).open();
        }
    }

    function isBlockedStatus(status, blockedStatuses) {
        return blockedStatuses.includes(status);
    }

    function getBlockedSelectedItems(blockedStatuses) {
        if (!$scope.current.limitFileActionFlagEnabled || !selectedRows.length) {
            return [];
        }

        return selectedRows.filter(function (row) {
            return isBlockedStatus(row.fileStatusInt ?? -1, blockedStatuses);
        });
    }

    function formatBlockedFilesList(blockedItems) {
        if (!blockedItems || !blockedItems.length) return '';
        var listItems = blockedItems.map(function (item) {
            return "<li>DB: " + (item.databaseName || '') + " - File ID: " + (item.downloadFileId || '') + "</li>";
        });

        return "<ul>" + listItems.join('') + "</ul>";
    }

    function ensureFileActionsAllowed(blockedStatuses) {
        if (!$scope.current.limitFileActionFlagEnabled) {
            return Promise.resolve(true);
        }

        var blockedItems = getBlockedSelectedItems(blockedStatuses);
        if (!blockedItems.length) {
            return Promise.resolve(true);
        }

        var blockedFilesList = formatBlockedFilesList(blockedItems);

        if ($scope.rightsDownloadSources?.canUpdate) {
            var privilegedMessage = "One or more of the following files you have selected are still being processed by the scheduler.  Please review before selecting continue.<br/>" + blockedFilesList;
            return $dialog.messageBox("Warning", privilegedMessage, [
                { result: 'no', label: 'Cancel' },
                { result: 'yes', label: 'Continue', cssClass: 'btn-primary', focus: true }
            ]).open().then(function (result) { return result === 'yes'; });
        }

        var restrictedMessage = "One or more of the following files you have selected are still being processed by the scheduler and you are not allowed to perform this action until the scheduler job is done processing.<br/>" + blockedFilesList;
        return $dialog.messageBox("Warning", restrictedMessage, [
            { result: 'ok', label: 'OK', cssClass: 'btn-primary', focus: true }
        ]).open().then(function () { return false; });
    }

    // PUBLIC METHODS
    $scope.update = doAction.bind($scope, '/confirm/overview/action/refreshdata', 'update', 'Update dashboard file(s).  Are you sure you want to proceed?', false);
    $scope.verify = () => {
        ensureFileActionsAllowed(blockedStatusesForVerifyApplyReconfirm).then(function (canProceed) {
            if (!canProceed) return;

            var url = '/confirm/overview/action/verifyapply?apply=false';
            doAction(url, 'verify', 'Verify file(s).  Are you sure you want to proceed?', true);
        });
    }
    $scope.apply = () => {
        ensureFileActionsAllowed(blockedStatusesForVerifyApplyReconfirm).then(function (canProceed) {
            if (!canProceed) return;

            var url = '/confirm/overview/action/verifyapply?apply=true';
            doAction(url, 'apply', 'Apply file(s).  Are you sure you want to proceed?', true);
        });
    }
    $scope.reConfirm = () => {
        ensureFileActionsAllowed(blockedStatusesForVerifyApplyReconfirm).then(function (canProceed) {
            if (!canProceed) return;

            var url = "/confirm/overview/action/ReConfirm";
            doAction(url, 'reConfirm', 'Reconfirm File(s). Are you sure you want to proceed?', true);
        });
    }

    $scope.loadAnalytics = loadAnalytics;

    $scope.updateDashboardData = function( ) {
        if (!selectedGroupId) return;
        return $http.get( "/Confirm/Groups/" + selectedGroupId + "/RefreshData?" + $.param(Object.select($scope.current, 'startDate', 'endDate')), {trackerMsg: 'Refreshing group data'} )
            .then( function() { $scope.$broadcast('event:confirm-overview-action', {action: 'refresh-grid'}); });
    };

    $scope.undo = function( ) {
        ensureFileActionsAllowed(blockedStatusesForSchedulerInProgress).then(function (canProceed) {
            if (!canProceed) return;

            $dialog.confirmAction("Are you sure you want to undo this file?")
                .open()
                .then(function (result) {
                    if (result === "yes") {
                        checkAndDisplaySelectedFinishedPostProcessing();

                        var urlVersion = '/Details/Action/Undo';
                        var alClient = angular.copy($scope.selected.alClientId);
                        $http.put("/Confirm/DownloadFiles/" + $scope.selectedFileIds[0] + urlVersion + "?Authorization=" + databaseTokens[alClient], [], {trackerMsg: 'Undoing file'} )
                            .then( function( response ) {
                                startPollingStatus( response.data, angular.copy($scope.selectedIds) );
                            } );
                    }
                });
        });
    };

    $scope.undoMultiple = function( ) {
        ensureFileActionsAllowed(blockedStatusesForSchedulerInProgress).then(function (canProceed) {
            if (!canProceed) return;

            const dialogMessage = "Are you sure you want to undo these files?"
            $dialog.confirmAction(dialogMessage)
                .open()
                .then(function (result) {
                    if (result === "yes") {
                        checkAndDisplaySelectedFinishedPostProcessing();

                        var urlVersion = 'UndoMany';

                        $http.put(`/Confirm/Overview/Action/${urlVersion}`, $scope.selectedIds, {trackerMsg: 'Undoing file(s)'} )
                        .then( function( response ) {
                            const ids = angular.copy($scope.selectedIds);
                            $reconServicesHelper.confirmOverviewPollingUniversal(response.data, ids, $scope, $rootScope);
                        } );                    
                    }
                });
        });
    };

    $scope.deleteFiles = function( ) {
        $dialog.dialog({ templateUrl: "confirm-delete-files.html", controller: "ConfirmDeleteFilesCtrl", items: selectedRows })
            .open()
            .then(function () {
                $scope.$broadcast('event:confirm-overview-action', {action: 'refresh-grid'});
            });
    };

    $scope.updateDatabaseDashboardData = function( ) {
        if (!$scope.current.selectedALClient) return;
        return $http.put( "/Confirm/Overview/Action/RefreshDatabaseData?alClientId=" + $scope.current.selectedALClient + "&startDate=" + $scope.current.startDate + "&endDate=" + $scope.current.endDate, {}, {trackerMsg: 'Refreshing group data'} )
            .then( function( ) {
                $scope.$broadcast('event:confirm-overview-action', {action: 'refresh-grid'});
            } );
    };

    $scope.downloadFile = function( ) {
        if($scope.selectedIds.length < 2){
            window.location.href = API_CONFIG.baseUrl + '/Confirm/DownloadFiles/' + $scope.selected.downloadFileId + '/Download' + '?Authorization=' + databaseTokens[$scope.selected.alClientId];
        } else {
            var fileList = $scope.selectedItems.map(i => ({"AlClientId":i.alClientId, "FileId":i.downloadFileId}));
            return $http.post("/Confirm/DownloadFiles/Action/DownloadMany", {"DownloadFileIds":fileList}, {trackerMsg: 'Starting Download'})
                .then(function(response){
                   window.location.href = response.headers("location") + "?Authorization=" + sessionStorage.oas_token;
                });
        }
    };

    $scope.exportTestFiles = function () {
        if ($scope.selectedFileIds.length > 0) {
            const fileIds = $scope.selectedFileIds.join(",");
            const alClientId = $scope.selectedItems[0].alClientId;

            let downloadUri = window.location.origin
                + API_CONFIG.baseUrl
                + "/Confirm/DownloadFiles/Action/DownloadTestFiles?alClientId=" + alClientId + "&fileIds=" + fileIds
                + "&Authorization=" + sessionStorage.oas_token;

            window.location.href = downloadUri;
        }
    }

    $scope.canExportTestFiles = function () {
        const recordTypesAllowed = ["Cost Basis", "Price", "Name", "Security", "Position", "Transaction"];

        const canExportAllFiles = $scope.selectedItems.every(element => {
            return recordTypesAllowed.includes(element.recordTypeName);
        });

        return $scope.rightsExportTestFiles.canUpdate && $scope.selectedFileIds.length > 0
            && !$scope.current.isMultiDatabase && canExportAllFiles;
    }

    $scope.setWidth = function( goWide ) {
        $scope.rightSidebar.width = goWide ? 500 : 254;
    };

    $scope.loadDatabaseFiles = function( ) {
        $scope.current.selectedConfirmEntity = 1;
        $scope.current.selectedALClient = $scope.user.authorization.alClientId;
        $scope.refreshGrid();
    };

    $scope.importFile = function( alClientId ) {
        return $dialog.dialog({dialogClass: "modal wide", templateUrl: "confirmation/modals/importFile.html", controller: "ImportFileCtrl", alClientId: alClientId}).open();
    };

    $scope.reimportBySource = function () {
        var selected = ($scope.selectedItems && $scope.selectedItems.length === 1 && $scope.selectedItems[0]) || $scope.selected;
        var asOfDateValue;
        if (selected && selected.fileDate) {
            asOfDateValue = new Date(selected.fileDate);
        } else {
            var asOfDate = $scope.current.filterEndDate || $scope.current.filterStartDate;
            asOfDateValue = asOfDate ? new Date(asOfDate) : new Date();
        }
        $scope.reimportBySourceModal = {
            visible: true,
            alClientId: (selected && selected.alClientId) || 0,
            downloadSourceId: (selected && selected.downloadSourceId) || 0,
            asOfDate: asOfDateValue
        };
    };

    $scope.onReimportBySourceClosed = function (result) {
        $scope.reimportBySourceModal.visible = false;
        $scope.reimportBySourceModal.downloadSourceId = 0;
        if (result && result.status === 'success') {
            $reconServicesHelper.confirmOverviewPollingUniversal(result.data, [], $scope, $rootScope);
            $scope.refreshGrid();
        }
    };

    $scope.showMessages = function(){
        const messages = $scope.selected.message ?? "No messages to show.";
        $dialog.messageBox("Messages", messages).open();
    }

    $scope.showReconNotes = function () {
        const path = `/confirmation/downloadsourcenotes?downloadSourceId=${$scope.selected.downloadSourceId}`;
        window.open(makeUrl(path), '_blank');
    };

    $scope.reprocessFiles = function () {
        return ensureFileActionsAllowed(blockedStatusesForSchedulerInProgress).then(function (canProceed) {
            if (!canProceed) return;

            if ($scope.rightsNewConfirmationReprocess.canUpdate) {
                var idsToRefreshWhenFinished = $scope.selectedItems.map(item => item.id);
                ConfirmationOverview.overview.newReprocessFiles({ data: $scope.selectedItems }).then((response) =>
                {
                    $reconServicesHelper.confirmOverviewPollingUniversal(response.data, idsToRefreshWhenFinished, $scope, $rootScope);
                });
            } else {
                if ($scope.current.isSelectedNonFileFormat) {
                    return ConfirmationOverview.overview.reprocessFiles({ data: $scope.selectedItems });
                }else {
                    return $dialog.actionFailed('All selected must be a non-file format.').open();
                }
            }
        });
    };

    $scope.fixShareBalances = function( ) {
        return $dialog.inputBox('Fix Small Share Balances', "Effective Date", 'date', {inputValue: Date.create('yesterday')}).open()
            .then(function(rslt) {
                if( rslt ) return $http.put(
                    "/Confirm/Overview/Action/FixShares005/" + Date.create(rslt).format('{yyyy}-{MM}-{dd}'),
                    $scope.selectedIds,
                    {trackerMsg: 'Fixing Share Balances'}
                );
            });
    };

    $scope.sleeveSmallBalanceFix = function () {
        return $http.put("/Confirm/Overview/Action/SleeveFixSmallBalancePositions", $scope.selectedIds, {trackerMsg: 'Fixing Sleeve Shares'}).then(function (response) {
            var dbRunMsg = response.data.databaseRun.length > 0 ? "<ul><li>" + response.data.databaseRun.join("</li><li>") + "</li></ul>" : "n/a";
            var dbNotRunMsg = response.data.databaseNotRun.length > 0 ? "<ul><li>" + response.data.databaseNotRun.join("</li><li>") + "</li></ul>" : "n/a";
            return $dialog.messageBox("Fix Sleeve Shares", "Database Run (AlClient Id's): " + dbRunMsg + "<br>" + "Database Not Run (AlClient Id's): " + dbNotRunMsg).open();
        });
    };

    /** Clears Recon Sign Off deep-link source filter when load criteria change (no grid refresh). */
    $scope.onLoadCriteriaChange = function () {
        $scope.current.downloadSourceKeys = null;
    };

    $scope.refreshGrid = function( ) {
        setDates();

        $settings.setSetting( 'confirmStartDate', $scope.current.filterStartDate );
        $settings.setSetting( 'confirmEndDate', $scope.current.filterEndDate );

        if( $scope.current.selectedGroup ) {
            ConfirmationOverview.confirm.updateSelectedGroup({trim: true, data: defaults.group}).then(function(r){ defaults.group = r });
        }

        $scope.current.searchFileId = null;

        $timeout(function () {
            $scope.$broadcast('event:confirm-overview-action', {action: 'refresh-grid'});
        });

        loadAnalytics( '0' );
    };


    $scope.updateRowNoteCount = function () { $scope.$broadcast('event:confirm-overview-action', {action: 'refresh-grid'}) };

    $scope.addNotesToSelected = function( ) {
        return $dialog.dialog({templateUrl: "confirmation/modals/addNotesToMultiple.html", controller: "AddNotesToMultipleCtrl", args: selectedRows}).open()
            .then(function (result) { if( result ) $scope.current.forceReload += 1; else return Promise.reject() });
    };

    $scope.maintainDetailList = function( availSelVal, propertyToUpdate, detailList ) {
        return $dialog.dialog({ templateUrl: "app/modals/available-select.html", controller: "AvailableSelectCtrl", resolve: {availableSelectedArgs: function() { return {selectionType: availSelVal, selectedSelected: angular.copy( detailList )}; }}}).open()
            .then(function(result) {
                if (result) {
                    $scope.current.selectedGroup[propertyToUpdate] = result;

                    $http.put('/Confirm/Groups/' + $scope.current.selectedGroup.id, $scope.current.selectedGroup, {trackerMsg: "Saving confirmation group " + $scope.current.selectedGroup.id})
                        .then($scope.refreshGrid);
                }
            });
    };

    $scope.search = function () {
        $dialog.inputBox('Find Download File', "File ID", 'number').open()
            .then(function(result){
                if (result) {
                    $scope.current.searchFileId = result;
                    $scope.current.startDate = null;
                    $scope.current.endDate = null
                    $timeout(function () {
                        $scope.$broadcast('event:confirm-overview-action', { action: 'refresh-grid' });
                        $scope.searchFileId = null;
                        setDates();
                    });

                }
            });
    };

    $scope.exportToExcel = function() { $scope.$broadcast('event:confirm-overview-action', {action: 'export-data'}); };
    $scope.runConfirmationQuery = function (id) { return $dialog.dataQueryPrompt(id, "run", true, true, $scope.tokenOverride).open() };

    $scope.loadAccountHistory = function (recordType) {
        var alClientId = $scope.current.accountHistoryALClient.id;
        var accountNumber = $scope.current.accountHistoryAccountNumber.number ? $scope.current.accountHistoryAccountNumber.number : $scope.current.accountHistoryAccountNumber;
        var accountHistoryPath = '/confirmation/files/{fileType}?downloadStatus=notConfirmed&accountNumber={accountNumber}&accountHistory=1'.assign(
            {
                fileType: recordType,
                accountNumber: encodeURIComponent(accountNumber),
            }
        );

        if (!databaseTokens[alClientId]) {
            addIdTokenToDatabaseTokens(alClientId).then(()=>{
                //must be done inside .then due to asyncronous call
                window.open(makeAccountHistoryUrl(accountHistoryPath, alClientId), '_blank');
            });
        } else {
            window.open(makeAccountHistoryUrl(accountHistoryPath, alClientId), '_blank');
        }
    };
    
    $scope.getTokenForAccountSearch = (selected)=>{
        const alClientId = selected.id;
        if(alClientId){
            return addIdTokenToDatabaseTokens(alClientId);
        }
    }

    // INITIALIZE
    $scope.groupingChartConfig = {
        options: {
            chart: { type: 'pie' },
            credits: {enabled: false},
            yAxis: { title: { text: '' } },
            plotOptions: {  pie: { shadow: false, center: ['50%', '50%'] } },
            tooltip: { valuePrefix: '' }
        },
        series: [
            { name: 'Group', data: [], size: '70%', dataLabels: { formatter: function( ) { return this.point.percentage > 5 ? this.point.name : null; }, color: 'white', distance: -30 }, point: {events: { click: function () {
                var point = this;
                setTimeout(function () {filterForChartGroup(point, true);}, 20);
            } } } },
            { name: 'Count', data: [], size: '80%', innerSize: '70%', dataLabels: { enabled: true, color: '#000000', connectorColor: '#000000', format: '{point.y}'}, point: {events: { click: function () {
                var point = this;
                setTimeout(function () {filterForChartGroup(point, false);}, 20);
            } } } }
        ],
        title: {text: ''}
    };

    $scope.rightsConfirmationOverview = $oasRights.forCode("CONFIRMOVERVIEW");
    $scope.rightsDownloadFiles = $oasRights.forCode("DOWNLOADFILES");
    $scope.rightsConfirmationGroups = $oasRights.forCode("CONFIRMGROUPS");
    $scope.rightsConfirmationSignOff = $oasRights.forCode("CONFIRMDASHSIGNOFF");
    $scope.rightsConfirmationImport = $oasRights.forCode("CONFIRM_DWNLDFILEOC");
    $scope.rightsNewConfirmationReprocess = $oasRights.forCode("NEWCONFIRMREPROCESSHANDLING");
    $scope.rightsReImportConfirmFilesBySource = $oasRights.forCode("REIMPORTCONFIRMFILESBYSOURCE");
    $scope.rightsAllowReconfirm = $oasRights.forCode("ALLOWRECONFIRM");
    $scope.rightsDownloadSourceNotes = $oasRights.forCode("DOWNLOADSOURCENOTES");
    $scope.rightsExportTestFiles = $oasRights.forCode("TESTFILEEXPORT");
    $scope.rightsDownloadSources = $oasRights.forCode("DOWNLOADSOURCES");
    $scope.canReadAgentActionReview = privilegeService.canRead('agentActionReview');
    $scope.reimportBySourceModal = {
        visible: false,
        alClientId: 0,
        downloadSourceId: 0,
        asOfDate: new Date()
    };

    $scope.views = views;

    Object.defineProperties($scope, {
            selectedItems: {get: function() {return selectedRows }},
            selected: {get: function() { return selectedRows[0] || false; }},
            selectedIds: {get: function() { return selectedRows.map('id') }},
            selectedFileIds: {get: function() { return selectedRows.map('downloadFileId') }},
            selectedRecordTypes: {get: function() { return selectedRows.map('recordTypeName').unique() }},
            selectedAlClientIds: {get: function() { return selectedRows.map('alClientId').unique() }},
            tokenOverride: {get: function() { return databaseTokens[$scope.selected.alClientId] || undefined }}
        });

    $scope.confirmEntities = ConfirmationOverview.default.confirmEntities; // Defaults
    $scope.databaseEntities = [{ id: "", name:"" },{ id: "1", name: "File Type" },{ id: "2", name: "Format" }];
    function makeUrl(path) { return $scope.tokenOverride ? redirectUrl + $.param({p: path, t: $scope.tokenOverride}) : undefined }

    function makeAccountHistoryUrl(path, alClientId) {
        var token = databaseTokens[alClientId] || undefined;
        return token ? redirectUrl + $.param({ p: path, t: token }) : undefined;
    }

    $scope.current = {
        view: views[0],
        filterStartDate: $settings.getSetting('confirmStartDate'),
        filterEndDate: $settings.getSetting('confirmEndDate'),
        downloadSourceKeys: $routeParams.downloadSourceKeys || null,
        selectedALClient: $scope.user.authorization.alClientId,
        selectedConfirmEntity: $routeParams.batchProcessingId ? 8 : 4,
        selectedDatabaseEntity: "",
        selectedFormat: 0,
        selectedFileType: 0,
        selectedBatchProcessingId: parseInt($routeParams.batchProcessingId) || 0,
        isBlocked:false,
        limitFileActionFlagEnabled: false,
        searchFileId: null,
        forceReload: 0,
        selectedRecordType: null,
        isSelectedNonFileFormat: false,
        accountHistoryALClient: '',
        accountHistoryAccountNumber: '',
        accountHistoryAlClientToken:'',
        get canLoadHistory() {
            return this.accountHistoryALClient === 0 || this.accountHistoryAccountNumber === '';
        },
        get selectedGroup() {
            return $scope.confirmationGroups ? $scope.confirmationGroups.find({id: selectedGroupId}) : undefined },
        set selectedGroup(group) {
            defaults.group.value = group.id;
            ConfirmationOverview.confirm.updateSelectedGroup({trim: true, data: defaults.group}).then(function(r){
                selectedGroupId = parseInt(r.value);
            });
        },

        get allowMultiOpen() { 
            return $scope.selectedRecordTypes.length == 1;
        },
        get isMultiDatabase() { return $scope.selectedAlClientIds.length > 1 },
        get allowMultiFix() { return $scope.selectedItems.length < 100 && $scope.selectedRecordTypes.length == 1 },

        get dataQueriesUrl() { return makeUrl('/reports/dataqueries') },
        get exclusionsUrl() {return makeUrl('/portfolio/newaccounts/excluded') },
        get interfaceReconUrl() {return makeUrl('/confirmation/reconciliations') },
        get performanceViewerUrl() {return makeUrl('/reports/performanceviewer3') },
        get portfolioAuditUrl() {return makeUrl('/portfolio/dashboard') },
        get productsPricesUrl() {return makeUrl('/products/myproducts/currentlyownedproducts') },
        get quarterEndDashboardUrl() {return makeUrl('/advisor/quarterend')},
        get custodialIntegratorUrl() {return makeUrl('/portfolio/custodialintegrator/notemapping') },
        get downloadSourcesUrl() {return makeUrl('/confirmation/sources') },
        get dataQueryAssetCompare( ) { return makeUrl('/reports/dataqueries/10890') },
        get dataQueryAssetNotFound( ) { return makeUrl('/reports/dataqueries/12974') },
        get dataQueryDailyMissingFile( ) { return makeUrl('/reports/dataqueries/4185') },
        get dataQueryDstMissingFile( ) { return makeUrl('/reports/dataqueries/4903') },
        get getFileHistorySearchOptions(){ return "{advancedSearch:false}"},
    };

    $scope.openFiles = function(isMultiDb, downloadStatus = null) {
        if (!$scope.selected || !$scope.selectedItems || $scope.selectedItems < 1) {
            return;
        }

        // Tidy up our local storage so we dont overflood the local storage limit
        $confirmation.cleanupLocalStorage();
        // Generate a random UUID to lookup for the local storage
        let fileIdHash = oas.utils.generateGuid(); 
                
        // Add to our local storage 
        $confirmation.addConfirmOverviewFileIdToStorage(fileIdHash, $scope.selectedItems);

        // Build the URL using the FildID hash instead of a list of files
        let url = getDownloadRecordListUrlForHash(fileIdHash, downloadStatus);
 
        window.open(url, '_blank');
    }

    function getDownloadRecordListUrlForHash(fileIdHash, downloadStatus = null) {
        let url;
        if (downloadStatus === null) {
            url = buildDownloadRecordListUrlForHash(fileIdHash);
        } else {
            switch (downloadStatus) {
                case 'confirmed':
                    url = buildDownloadRecordListUrlForHash(fileIdHash, 'confirmed', true)
                    break;
                case 'notconfirmed':
                    url = buildDownloadRecordListUrlForHash(fileIdHash, 'notConfirmed', true);
                    break;
                case 'excluded':
                    url = buildDownloadRecordListUrlForHash(fileIdHash, 'excluded', true);
                    break;
                case 'aggregationonly':
                    url = buildDownloadRecordListUrlForHash(fileIdHash, 'aggregationOnly', true);
                    break;
                case 'allrecords':
                    url = buildDownloadRecordListUrlForHash(fileIdHash, 'excluded,notConfirmed,confirmed,aggregationOnly', true);
                    break;
                case 'norecords':
                    url = buildDownloadRecordListUrlForHash(fileIdHash, 'notConfirmed', true, true);
                    break;
                default: 
                    url = buildDownloadRecordListUrlForHash(fileIdHash);
            }
        }

        return url;
    }

    function buildDownloadRecordListUrlForHash(fileIdHash, downloadStatus = null, hasPreventLoadParam = null, preventLoad = false) {
        let url = `/confirmation/files/v2/${$scope.selected.recordTypeName.replace(/ /g, '')}?notesId=${$scope.selected.id}-${$scope.selected.downloadSourceId}&fileIdHash=${fileIdHash}`;

        if (downloadStatus !== null) {
            url += `&downloadStatus=${downloadStatus}`;
        }
        if (hasPreventLoadParam !== null) {
            url += `&preventLoad=${preventLoad}`;
        }

        if($scope.current.isBlocked){
            //check the currently selected items aren't currently files that are blocked.
            url += "&blocked=true";
        }

        if ($scope.current.isMultiDatabase) {
            // For multiple DB redirect, but dont provide a token to auth to
            return redirectUrlFunc(url);
        } else {
            // MakeUrl provides a token in the URL to auth to
            // For Single DB requests, ensure we are going to auth to the right DB
            return makeUrl(url);
        }
    }

    function redirectUrlFunc(path) {
        return window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html?p=" + encodeURIComponent(path);
    }

    init( );

    // EVENT LISTENERS
    $scope.$watch('current.filterStartDate', function (newValue) {
        $settings.setSetting('confirmStartDate', newValue)
    });

    $scope.$watch('current.filterEndDate', function (newValue) {
        $settings.setSetting('confirmEndDate', newValue)
    });

    function GetSelectedRecordType(selectedRows) {
        if (selectedRows.every({ recordTypeName: 'Position' })) {
            return 'Position';
        }
        else if (selectedRows.every({ recordTypeName: 'Transaction' })) {
            return 'Transaction';
        }
        else if (selectedRows.every({ recordTypeName: 'Banking' })) {
            return 'Banking';
        }
        else if (selectedRows.every({ recordTypeName: 'Systematic' })) {
            return 'Systematic';
        } else if (selectedRows.every({ recordTypeName: 'RMD' })) {
            return 'RMD';
        }
        return null;
    }

    $scope.$on('event:confirm-overview-select', function(e, args) {
        $scope.current.isBlocked = false;

        if( args.length ) {
            selectedRows = args.map(function(e){return angular.extend(e,{sourceType: "FilesReceived"})});
            
            $scope.current.selectedRecordType = GetSelectedRecordType(selectedRows);

            angular.extend($scope.current, Object.select($scope.selected, "alClientId", "downloadSourceId", "id", "databaseName"));

            $scope.current.isSelectedNonFileFormat = $scope.selectedItems.length > 0 && $scope.selectedItems.all(function(i){return i.isNonFileFormat === true});

            $scope.selectedAlClientIds.forEach(function(clientId){
                if(!databaseTokens[clientId]) tokenFactory.getDatabaseToken(clientId)
                    .then(function(token){ databaseTokens[clientId] = token });
            });

            $scope.current.isBlocked = selectedRows.some(item=> {return !item.isImportComplete});
        } else {
            selectedRows = [];
            angular.extend($scope.current, {alClientId: null, downloadSourceId: null, id: null});

            $scope.current.isSelectedNonFileFormat = false;
        }
    });

    $scope.$on('$destroy', function () {
        angular.element(document).off('click.confirmOverviewUnmappedLink');
    });
});


confirmationOverviewCtrl.loadDefaults = ["ConfirmationOverview", "$q", function(ConfirmationOverview, $q) {
    return $q.all({
        group: ConfirmationOverview.confirm.getSelectedGroup({trim: true}),
        confirmationGroups: ConfirmationOverview.confirm.getGroups({trim: true}),
        databases: ConfirmationOverview.databases.getAll({trim: true}),
        fileTypes: ConfirmationOverview.confirm.getRecordTypes({trim: true}),
        downloadFormats: ConfirmationOverview.confirm.getDownloadFormats({trim: true})
    })
}];

app.controller('ConfirmDeleteFilesCtrl', function ConfirmDeleteFilesCtrl($scope, $http, dialog) {
    // PUBLIC METHODS
    $scope.submitBySearch = function (value) {
        dialog.close(value);
    };

    $scope.submit = function() {
        deleteFiles($scope.current.validItems.map(i=>i.id)).then(function(response){
            dialog.close(response);
        })
    };

    $scope.cancel = function () {
        dialog.close(false);
    };


    function deleteFiles(confirmIdList) {
        return $http.put( "/Confirm/Overview/Action/Delete", confirmIdList, {trackerMsg: 'Deleting file' + (confirmIdList.length === 1 && '' || 's') } );
    }

    // INITIALIZE
    $scope.errors = [];
    $scope.current = {
        items: dialog.options.items,
        validItems: dialog.options.items.filter(i=>!(i.confirmedCount > 0)),
        invalidItems: dialog.options.items.filter(i=>i.confirmedCount > 0),
        expand: {}
    };
});
'use strict';

app.controller('ConfirmationAnalysisCtrl', function ConfirmationAnalysisCtrl($scope, $http, $oasRights, confirmRecordStatus ) {

    // PRIVATE VARIABLES


    // PRIVATE METHODS
    function init( ) {
        if( $scope.current.startDate.getDay( ) == 1 ) {
            $scope.current.startDate = Date.create('two days ago');
        }

        loadRecordsChart( $scope.recordGroupings[1].groupBy, $scope.recordGroupings[1].name );
        loadPaceProgress( $scope.recordGroupings[1].groupBy );
    }

    function loadRecordsChart( groupBy, chartTitle ) {
        var chartData = [];
        var categories = [];

        var groupings = { parents: [] };

        $http.get("/Confirm/Overview/Summary?groupBy=" + groupBy + "&startDate=" + $scope.current.startDate.format('{yyyy}-{MM}-{dd}') + "&endDate=" + $scope.current.endDate.format('{yyyy}-{MM}-{dd}'), {trackerMsg: 'Loading summary chart'})
            .then(function (response) {

                groupings.parents = response.data;

                for( var i = 0; i < groupings.parents.length; i++ ) {
                    if( groupings.parents[i].value != 0 ) {
                        categories.push(groupings.parents[i].name);

                        var wedge = {
                            y: Math.abs( groupings.parents[i].value ),
//                          color: groupings.parents[i].color ? groupings.parents[i].color : colors[i%10],
                            color: '#666666',
                            drilldown: {
                                name: groupings.parents[i].name,
                                categories: [],
                                data: [],
//                              color: groupings.parents[i].color ? groupings.parents[i].color : colors[i%10]
                                color: '#666666',
                                groupBy: groupBy
                            }
                        };


                        if( groupings.parents[i].children ) {
                            for( var j = 0; j < groupings.parents[i].children.length; j++ ) {
                                if( groupings.parents[i].children[j].value != 0 ) {
                                    wedge.drilldown.data.push( {name: groupings.parents[i].children[j].name, value: Math.abs(groupings.parents[i].children[j].value), groupBy: groupBy} );
                                    wedge.drilldown.categories.push( groupings.parents[i].children[j].name );
                                }
                            }
                        }

                        chartData.push(wedge);
                    }
                }

                var groupData = [];
                var detailData = [];
                for (var k = 0; k < chartData.length; k++) {

                    groupData.push({
                        name: categories[k],
                        y: chartData[k].y,
                        color: chartData[k].color,
                        groupBy: groupBy
                    });

                    var color;
                    for (var l = 0; l < chartData[k].drilldown.data.length; l++) {
                        if( chartData[k].drilldown.data[l].name == confirmRecordStatus.confirmed.name ) {
                            color = '#009A31';
                        } else if( chartData[k].drilldown.data[l].name == confirmRecordStatus.notConfirmed.name ) {
                            color = '#FF2400 ';
                        } else if( chartData[k].drilldown.data[l].name == confirmRecordStatus.excluded.name ) {
                            color = '#66C283';
                        }
                        var brightness = 0.2 - (l / chartData[k].drilldown.data.length) / 5 ;
                        detailData.push({
                            name: chartData[k].drilldown.categories[l].substring(0,30),
                            y: chartData[k].drilldown.data[l].value,
//                          color: Highcharts.Color(chartData[k].color).brighten(brightness).get()
                            color: color,
                            parent: chartData[k].drilldown.name,
                            groupBy: chartData[k].drilldown.groupBy
                        });
                    }
                }

                $scope.recordChart.config.series[0].data = groupData;
                $scope.recordChart.config.series[1].data = detailData;
                $scope.recordChart.config.title.text = chartTitle;

            });
    }

    function filterForChartGroup( point, isParentSlice ) {

    }

    function loadPaceProgress( groupBy ) {
        $scope.paces = [];
        $scope.pacesCounts = { confirmed: 0, notConfirmed: 0, projectedOver: 0 };

        // ToDo: Call endpoint to set paces
        $scope.paces.push( { name: 'Fidelity', average: 9.25, current: 61, projected: 12.5, hidden: false } );
        $scope.paces.push( { name: 'Pershing', average: 8, current: 90, projected: 7.5, hidden: false } );
        $scope.paces.push( { name: 'Schwab', average: 6, current: 72, projected: 6, hidden: false } );
        $scope.paces.push( { name: 'TD', average: 5, current: 100, projected: null, hidden: false } );

        for( var i = 0; i < $scope.paces.length; i++ ) {
            if( $scope.paces[i].current == 100 ) {
                $scope.pacesCounts.confirmed += 1;
            } else if( $scope.paces[i].projected > $scope.paces[i].average ) {
                $scope.pacesCounts.projectedOver += 1;
            } else if( $scope.paces[i].projected <= $scope.paces[i].average ) {
                $scope.pacesCounts.notConfirmed += 1;
            }
        }
    }

    function setSelectedTab( button ) {
        $scope.topBar.buttons.each( function( b ) {
            b.selected = false;
        });
        button.selected = true;
        $scope.topBar.selectedCode = button.code;
    }


    // PUBLIC METHODS
    $scope.setSelectedTab = function( button ) {
        setSelectedTab( button );
    };

    $scope.loadRecordsChart = function( groupBy ) {
        loadRecordsChart( groupBy.groupBy, groupBy.name );
    };

    $scope.refreshRecordsChart = function( ) {
        var existing = $scope.recordGroupings.find( {name: $scope.recordChart.config.title.text} );
        loadRecordsChart( existing.groupBy, existing.name );
    };

    $scope.loadPaceProgress = function( groupBy ) {
        loadPaceProgress( groupBy.groupBy );
    };

    $scope.filterPaceProgress = function( filter ) {
        for( var i = 0; i < $scope.paces.length; i++ ) {
            if( filter == 'confirmed' ) {
                $scope.paces[i].hidden = !($scope.paces[i].current == 100);
            } else if( filter == 'projectedOver' ) {
                $scope.paces[i].hidden = !($scope.paces[i].projected > $scope.paces[i].average);
            } else if( filter == 'notConfirmed' ) {
                $scope.paces[i].hidden = !($scope.paces[i].projected <= $scope.paces[i].average && $scope.paces[i].current != 100);
            }
        }
    };


    // INITIALIZE
    $scope.rightsConfirmationOverview = $oasRights.forCode("CONFIRMOVERVIEW");
    $scope.current = { startDate: Date.create('today'), endDate: Date.create('today') };

    $scope.topBar = { selectedCode:'status', buttons: [
        //{icon:'fa fa-bolt', text:'Pace', code:'pace', selected:true, visible:true},
        {icon:'fa fa-bar-chart', text:'Status', code:'status', selected:false, visible:true}
    ] };

    $scope.recordChart = { config: { } };
    $scope.recordGroupings = [ {name: 'Database', groupBy: '1'}, {name: 'File Type', groupBy: '0'}, {name: 'Format', groupBy: '2'}];

    $scope.paces = [];
    $scope.pacesCounts = { confirmed: 0, notConfirmed: 0, projectedOver: 0 };


    // CHARTS
    $scope.recordChart.config = {
        options: {
            chart: { type: 'pie' },
            credits: {enabled: false},
            yAxis: { title: { text: '' } },
            plotOptions: {  pie: { shadow: false, center: ['50%', '50%'] } },
            tooltip: { valuePrefix: '' }
        },
        series: [
            { name: 'Group', data: [], size: '70%', dataLabels: { formatter: function( ) { return this.point.percentage > 5 ? this.point.name : null; }, color: 'white', distance: -30 }, point: {events: { click: function () {
                var point = this;
                setTimeout(function () {filterForChartGroup(point, true);}, 20);
            } } } },
//            { name: 'Count', data: [], size: '80%', innerSize: '70%', dataLabels: { enabled: true, color: '#000000', connectorColor: '#000000', format: '<b>{point.name}</b>: {point.percentage:.1f} %'} }
            { name: 'Count', data: [], size: '80%', innerSize: '70%', dataLabels: { enabled: true, color: '#000000', connectorColor: '#000000', format: '{point.y}'}, point: {events: { click: function () {
                var point = this;
                setTimeout(function () {filterForChartGroup(point, false);}, 20);
            } } } }
        ],
        title: {text: ''}
    };

    init( );

});
'use strict';

app.controller('ConfirmationGroupListCtrl', function ConfirmationGroupListCtrl($scope, $http, $oasRights, $dialog, views, $confirmation) {

    // PRIVATE VARIABLES


    // PRIVATE METHODS
    function init( ) {

    }

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length > 0)
            $scope.openEditor();
    };

    // PUBLIC METHODS
    $scope.openEditor = function(isNew) {
        var d = $dialog.editor('confirmation/editors/views/confirmation-group-edit.html', 'ConfirmationGroupEditCtrl', {args: function() { return {
            id : isNew ? 0 : $scope.selectedIds[0],
            isNew : isNew,
            defaultTab : {name : "General", active: true, code : "general"}
        }; }});

        d.open().then(function(rslt) {
            if( rslt ) {
                $scope.$broadcast( 'event:confirm-groups-action', {action: isNew ? 'add-item' : 'update-item', item: rslt } );
            }
        });
    };

    $scope.goToQueries = function() {
        $confirmation.goToConfirmQueries($scope.selectedIds[0]);
    };



    // INITIALIZE
    $scope.rightsConfirmationGroups = $oasRights.forCode("CONFIRMGROUPS");

    $scope.views = views;

    $scope.selectedIds = [];
    $scope.current = { view : views[0], gridDoubleClick: $scope.slickGridDoubleClick };

    init( );
});
'use strict';

var confirmationAuditListCtrl = app.controller('ConfirmationAuditListCtrl', function ConfirmationAuditListCtrl($scope, $http, $routeParams, $timeout, $dialog, $oasRights, views, defaults, tokenFactory, confirmSourceType, $settings) {
    // PRIVATE VARIABLES
    var redirectUrl = window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html";
    var jobScheduleId;
    var selectedRows = [];

    // PRIVATE METHODS
    function init( ) {
        switch ($routeParams.audit) {
            case "ExclusionTable":
                redirectUrl += "?p=/portfolio/newaccounts/excluded?accountNumberFilter={accountNumberList}";
                break;
            case "DataAudits":
                redirectUrl += "?p=/confirmation/audits/DataAudits/{customReportId}/{downloadSourceId}";
                break;
            case "AccountNotInFile":
                redirectUrl += "?p=/portfolio/edit/accounts/number/{accountNumber}";
                break;
        }
        redirectUrl += "&t={token}";

        setDates();
        loadDatabases( );
        loadDownloadFormats( );
        loadDownloadSources( );
        loadFileTypes( );
        loadConfirmationGroups( );
    }

    function setDates() {
        $scope.current.startDate = $scope.current.filterStartDate.format('{MM}-{dd}-{yyyy}');
        $scope.current.endDate = $scope.current.filterEndDate.format('{MM}-{dd}-{yyyy}');
    }

    function loadDatabases( ) {
        $http.get("/Authorization/Databases", {cache: true, trackerMsg: 'Loading databases', ignoreExceptions: true})
            .then(function (response) {
                $scope.databases = response.data;
            });
    }

    function loadFileTypes( ) {
        $http.get("/Confirm/RecordTypes/Simple", {trackerMsg: 'Loading download file types'})
            .then(function (response) {
                $scope.fileTypes = response.data;
            });
    }

    function loadDownloadSources( ) {
        $http.get("/Confirm/DownloadSources/Simple", {trackerMsg: 'Loading download sources'})
            .then(function (response) {
                $scope.downloadSources = response.data;
            });
    }

    function loadConfirmationGroups( ) {
        $http.get( "/Confirm/Groups", {trackerMsg: 'Loading confirmation groups'} )
            .then( function( response ) {
                $scope.confirmationGroups = response.data;
                $scope.current.selectedGroup = response.data.find({id: parseInt(defaults.group.value)});
            } );
    }

    function loadDownloadFormats( ) {
        $http.get("/Confirm/DownloadFormats/Simple", {trackerMsg: 'Loading download formats'})
            .then(function (response) {
                $scope.downloadFormats = response.data;
            });
    }

    function saveConfirmationGroups( ) {
        $http.put('/Confirm/Groups/' + $scope.current.selectedGroup.id, $scope.current.selectedGroup, {trackerMsg: "Saving confirmation group " + $scope.current.selectedGroup.id} )
            .then(function( ) {
                $scope.refreshGrid( );
            });
    }


    // PUBLIC METHODS
    $scope.maintainDetailList = function( availSelVal, propertyToUpdate, detailList ) {
        var list = angular.copy( detailList );
        $dialog.dialog({ templateUrl: "app/modals/available-select.html", controller: "AvailableSelectCtrl", resolve: {availableSelectedArgs: function() { return {selectionType: availSelVal, selectedSelected: list}; }}})
            .open()
            .then(function(result) {
                if (result) {
                    $scope.current.selectedGroup[propertyToUpdate] = result;
                    saveConfirmationGroups( );
                }
            });
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:confirm-audit-action', {action: 'export-data'});
    };

    $scope.refreshGrid = function( ) {
        setDates();

        $settings.setSetting( 'confirmStartDate', $scope.current.filterStartDate );
        $settings.setSetting( 'confirmEndDate', $scope.current.filterEndDate );

        if( $scope.current.selectedGroup ) {
            defaults.group.value = $scope.current.selectedGroup.id;
            $http.post( '/Settings/UserOptions/confirmation_overview_group', defaults.group )
                .then(function( response ) {
                    defaults.group.id = response.data.id;
                });
        }

        $timeout(function () {
            $scope.$broadcast('event:confirm-audit-action', {action: 'refresh-grid'});
        });
    };

    $scope.updateRowNoteCount = function () {
        $scope.$broadcast('event:confirm-audit-action', {action: 'refresh-grid'});
    };

    $scope.viewScrubResultMessage = function( ) {
        $http.get('/Scheduler/JobSchedules/' + jobScheduleId + '/LastResultMessage', {trackerMsg: 'Loading result message'})
            .then(function(response) {
                $dialog.messageBox("<i class='fa fa-certificate fa-lg text-info' aria-hidden='true'></i> Result Message", "<h5>" + response.data.detailedMessage + "</h5>" + response.data.exceptionDetails).open();
            });
    };

    $scope.updateDashboardData = function () {
        var alClientId = $scope.current.selectedConfirmEntity == 1 ? $scope.current.selectedALClient : '';
        var groupId = $scope.current.selectedConfirmEntity == 4 ? $scope.current.selectedGroup.id : '';
        $http.put( $scope.current.dataUrl + "/Action/RefreshData?alClientId=" + alClientId + "&confirmGroupId=" + groupId, null, {trackerMsg: 'Refreshing group data'} )
            .then( function( ) {
                $scope.$broadcast('event:confirm-audit-action', {action: 'refresh-grid'});
            } );
    };

    $scope.addNotesToSelected = function( ) {
        $dialog.dialog({templateUrl: "confirmation/modals/addNotesToMultiple.html", controller: "AddNotesToMultipleCtrl", args: selectedRows}).open()
            .then(function (result) {
                    if( result ) {
                        $scope.current.forceReload += 1;
                    }
                }
            );
    };


    //INITIALIZE
    $scope.rightsConfirmationOverview = $oasRights.forCode("CONFIRMOVERVIEW");
    $scope.rightsConfirmationGroups = $oasRights.forCode("CONFIRMGROUPS");
    $scope.rightsConfirmationSignOff = $oasRights.forCode("CONFIRMDASHSIGNOFF");

    $scope.views = views;
    $scope.selectedIds = [];

    $scope.confirmEntities = [
        {id: 1, name: "Database"},
        {id: 4, name: "Group"},
        {id: 0, name: "File Type"},
        {id: 5, name: "Format"},
        {id: 2, name: "Source"}
    ];

    $scope.current = {
        view: views[0],
        filterStartDate: $settings.getSetting('confirmStartDate'),
        filterEndDate: $settings.getSetting('confirmEndDate'),
        selectedGroup: {id: defaults.group.value},
        selectedConfirmEntity: 4,
        selectedSource: 0,
        selectedFileType: 0,
        selectedFormat: 0,
        forceReload: 0,
        dataUrl: confirmSourceType[$routeParams.audit.camelize(false)].dataUrl,
        audit: $routeParams.audit
    };

    init( );


    // EVENT LISTENERS
    $scope.$on('event:confirm-audit-select', function(e, args) {
        selectedRows = [];
        if (args.length) {
            jobScheduleId = args[0].jobScheduleId;

            selectedRows = args.map(function(a){ return { alClientId: a.alClientId, id: a.id, sourceType: "AccountNotInFile" }});

            angular.extend($scope.current, Object.select(args[0], "alClientId", "downloadSourceId", "id", "databaseName"));

            var urlParts = angular.extend({accountNumberList: args.map("accountNumber").unique()}, Object.select(args[0], "accountNumber", "customReportId", "downloadSourceId"));

            $scope.current.databaseUrl = null;
            tokenFactory.getDatabaseToken(args[0].alClientId)
                .then(function (token) {
                    urlParts.token = token;
                    $scope.current.databaseUrl = redirectUrl.assign(urlParts);
                });
        } else {
            angular.extend($scope.current, {alClientId: null, downloadSourceId: null, id: null});
        }
    });
});

confirmationAuditListCtrl.loadConfirmationAuditViews = ["$http", "$route", function($http, $route) {
    return $http.get('/Settings/Views/' + $route.current.params.audit + 'ConfirmOverviewDashboardDto', {trackerMsg : 'Loading confirmation audit views'})
        .then(function(response) {
            return response.data;
        });
}];
'use strict';

app.controller('ConfirmationScrubListCtrl', function ConfirmationScrubListCtrl($scope, $http, $oasRights, $dialog) {

    // PRIVATE VARIABLES


    // PRIVATE METHODS
    function init( ) {

    }


    // PUBLIC METHODS
    $scope.openEditor = function(isNew) {
        var d = $dialog.editor('confirmation/editors/views/confirmation-scrub-edit.html', 'ConfirmationScrubEditCtrl', {args: function() { return {
            id : 0,
            isNew : isNew,
            defaultTab : {name : "General", active: true, code : "general"}
        }; }});

        d.open().then(function(rslt) {
            if( rslt ) {

            }
        });
    };


    // INITIALIZE
    $scope.rightsConfirmationScrubs= $oasRights.forCode("SS_SCRUBS");

    init( );
});
'use strict';

app.controller('GlobalExclusionEditCtrl', function GlobalExclusionEditCtrl($scope, $oasRights, dialog, $globalExclusion) {

    // PRIVATE VARIABLES
    var itemOriginal = null;

    // PRIVATE METHODS - INIT
    function init() {
        loadItem();
        loadFormats();
    }

    function loadItem() {
        if($scope.current.item.id > 0)
        {
            $globalExclusion.loadItem($scope.current.item.id)
            .then((response)=>{
                angular.extend($scope.current.item, $globalExclusion.current.item);
                itemOriginal = angular.copy( $scope.current.item );
            })
        }
        else{
            $scope.current.item = $globalExclusion.newItem();
        }
    }

    function loadFormats() {
        $globalExclusion.loadFormats()
            .then(function (response) {
                angular.extend($scope.current.options.downloadFormat, response.data);
            })
    }

    // PUBLIC METHODS
    $scope.onRecordTypeChange = ()=>{
        if($scope.current.item.recordTypeKey === 8){
            $scope.current.item.ticker = null;
        }
    }

    $scope.save = function () {
        if( !angular.equals( itemOriginal, $scope.current.item ) ) {        
            return ($scope.current.item.id > 0 ?
                $globalExclusion.saveItem($scope.current.item) 
                : $globalExclusion.createItem($scope.current.item))
                .then(function (response) {
                    dialog.close(response.data);
                });
        } 
        else {
            dialog.close(null);
        }
    };

    $scope.close = function (validate) {
        if( validate ) {
            if( !angular.equals( itemOriginal, $scope.current.item ) ) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                 dialog.close(null);
            }
        } else {
            dialog.close(null);
        }
    };

    // INITIALIZE
    $scope.current = {
        id: 0,
        item: { id: parseInt(dialog.options.editorOptions.item.id) || 0 },
        options: {
            downloadFormat: [],
            recordTypes: $globalExclusion.recordTypes(),
        }
    };

    $scope.rights = {
        globalExclusions: $oasRights.forCode("GLOBALEXCLUSIONS"),
    };

    $scope.checkRightsForCode = function (privilegeCode) {
        if (privilegeCode == null) {
            return true;
        }

        var isEditable = $oasRights.forCode(privilegeCode).canUpdate;
        return isEditable;
    }

    $scope.errors = [];

    init();

});




'use strict';

app.controller('GlobalExclusionsListCtrl', function GlobalExclusionsListCtrl($scope, views, $oasRights, $dialog, $globalExclusion) {

    // PRIVATE VARIABLES


    // PRIVATE METHODS    

    // PUBLIC METHODS
    $scope.slickGridDoubleClick = function () {
        if ($scope.selectedIds.length === 1) $scope.openEditor($scope.selected);
    };

    $scope.refreshGrid = () => {
        $scope.$broadcast('event:confirm-global-download-exclusion-action', { action: 'refresh-grid' });
    }

    $scope.openEditor = (item) => {
        var editorOptions = {
            item: item || {},
        };
        
        return $dialog.dialog({ templateUrl: 'confirmation/editors/views/global-exclusion-edit.html', 
                                controller: 'GlobalExclusionEditCtrl', editorOptions })
            .open()
            .then(() => { 
                $scope.refreshGrid(); 
            });
    };

    $scope.deleteItems = () => {
        if ($scope.selectedIds.length >= 1) {
            $globalExclusion.deleteItems($scope.selectedIds)
                .then(() => {
                    $scope.refreshGrid();
                });
        }
    }

    $scope.canUpdate = ()=>{
        return ($scope.selected && $scope.selectedItems.length === 1 && $scope.rights.globalExclusions.canUpdate);
    }

    $scope.canDelete = ()=>{
        return ($scope.selected && $scope.selectedItems.length >= 1 && $scope.rights.globalExclusions.canDelete);
    }

    // INITIALIZE
    $scope.rights = {
        globalExclusions: $oasRights.forCode("GLOBALEXCLUSIONS")
    };

    $scope.views = views;

    $scope.current = {
        view: views[0],
        filters: {},
        slickGridUrl: "/Confirm/Exclusions/CommonExclusions",
        gridDoubleClick: $scope.slickGridDoubleClick,
    };

    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: { get: function () { return $scope.selectedItems.map('id') } },
        selected: { get: function () { return $scope.selectedItems[0] || $scope.current.item; } }
    });

    // WATCHES

    $scope.$on('event:confirm-global-download-exclusion-select', function (e, args) {
        $scope.selectedItems = args;
    });

});


'use strict';

app.controller('ConfirmationSignOffListCtrl', function ConfirmationSignOffListCtrl($scope, $http, $oasRights) {

    // PRIVATE VARIABLES


    // PRIVATE METHODS
    function init( ) {

    }

    // PUBLIC METHODS


    // INITIALIZE
    $scope.rightsConfirmationSignOffs = $oasRights.forCode("CONFIRMSIGNOFF");

    init( );
});
'use strict';

app.controller('ConfirmationFormatListCtrl', function ConfirmationFormatListCtrl($scope, $http, $oasRights, $dialog, ConfirmationOverview, $timeout, views) {
    // PRIVATE VARIABLES


    // PRIVATE METHODS
    function init( ) {
    }


    // PUBLIC METHODS
    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1) $scope.openEditor( $scope.selected );
    };

    $scope.openEditor = function( item ) {
        return $dialog.editor('confirmation/modals/confirmationFormatEdit.html','ConfirmationFormatEditCtrl',{args:function(){
                return {
                    item: item || {},
                    defaultTab:{name:"General", active: true, code: "General"}
                };
            }}).open().then(function ( res ) {
                if( res ) {
                    $scope.refreshGrid();
                }
            });
    };

    $scope.openDefaultsEditor = function (item) {
        return $dialog.editor('confirmation/modals/FormatSourceDefaultEdit.html', 'FormatSourceDefaultEditCtrl', {
            args: function () {
                return {
                    item: item || {},
                    defaultTab: { name: "General", active: true, code: "general" }
                };
            }
        }).open().then(function (res) {
            if (res) {
                $scope.refreshGrid();
            }
        });
    };

    $scope.openScheduleJobDefaultEditor = function (item) {
        return $dialog.editor('confirmation/modals/DownloadSubFormatSchedulerDefaultEdit.html', 'DownloadSubFormatSchedulerDefaultEditCtrl', {
            args: function () {
                return {
                    item: item
                };
            }
        }).open().then(function (res) {
            if (res) {
                $scope.refreshGrid();
            }
        });
    };

    $scope.openFormatVersionModal = function () {
        $scope.current.isFormatVersionModalOpen = true;
    }

    $scope.deleteItems = function () {
        return ConfirmationOverview.sources.deleteMany({data: $scope.selectedIds}).then(function(items){
            $scope.refreshGrid();
        });
    };

    $scope.refreshGrid = function( ) {
        $timeout(function() {
            $scope.$broadcast('event:confirm-download-format-action', {action: 'refresh-grid'});
        });
    };

    $scope.views = views;
    // INITIALIZE
    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        isFormatVersionModalOpen: false
    };

    $scope.rights = {
        downloadFormats: $oasRights.forCode("DOWNLOADFORMATS"),
        downloadFormatXmlVersions: $oasRights.forCode("FORMATXMLVERSIONS")
    };

    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: {get: function() {return $scope.selectedItems.map('id')}},
        selected: {get: function() {return $scope.selectedItems[0] || $scope.current.item;}}
    });

    // WATCHES

    $scope.$on('event:confirm-download-format-select', function(e, args) {
        $scope.selectedItems = args;
    });

    init( );
});
(function () {
    'use strict';
    angular
        .module('orionConnect')
        .controller('ConfirmationFormatEditCtrl', ['$scope', '$http', '$oasRights', '$timeout', '$dialog', 'dialog', '$confirmation', '$q', '$confirmDownloadOptionService', 'args', CTRL])
        .directive('restrictField', restrictFieldCTRL)
        ;

    function CTRL($scope, $http, $oasRights, $timeout, $dialog, dialog, $confirmation, $q, $confirmDownloadOptionService, args) {
        //VARIABLES
        $scope.rights = {
            downloadFormats: $oasRights.forCode("DOWNLOADFORMATS"),
            downloadFormatMarkup: $oasRights.forCode("DOWNLOADFORMATMARKUP"),
            downloadFormatSubType: $oasRights.forCode("FORMATSUBTYPE"),
            formatRectypeEditor: $oasRights.forCode("FORMATRECTYPEEDITOR")
        };

        $scope.menu = {
            categories: [
                {
                    name: 'General', children: [
                        { name: 'General', active: false, code: 'General' },
                        { name: 'Format Subtype', active: false, code: 'FormatSubType' },
                        { name: 'Note Mapping', active: false, code: 'Note Mapping' },
                        { name: 'Security Mapping', active: false, code: 'Local Security Mapping' },
                        { name: 'Unique Symbol Mapping', active: false, code: 'Unique Symbol Mapping' },
                        { name: 'Trans Symbol Mapping', active: false, code: 'Trans Symbol Mapping' },
                        { name: 'Offset Cash Mapping', active: false, code: 'Offset Cash Mapping' },
                        { name: 'XML', active: false, code: 'XML' }
                    ]
                }
            ]
        };
        $scope.current = {
            errors: [],
            tinymce: {
                readonly: true,
                menubar: false,
                toolbar: false,
                statusbar: false,
                branding: false,
                height: 400,
                plugins: '',
                // Disable TinyMCE's dotted "visual aid" borders drawn around borderless tables/cells.
                visual: false,
                // Keep the generated highlight markup (table, spans, classes) intact.
                valid_elements: '*[*]',
                content_style: [
                    'body{margin:0;padding:0;}',
                    'table.xml-viewer{border-collapse:collapse;width:100%;font-family:Consolas,Menlo,"Courier New",monospace;font-size:12px;line-height:1.45;}',
                    'table.xml-viewer td.ln{width:1%;white-space:nowrap;text-align:right;padding:0 8px;color:#999;background:#f5f5f5;border-right:1px solid #ddd;-webkit-user-select:none;user-select:none;}',
                    'table.xml-viewer td.code{padding:0 8px;color:#333;}',
                    'table.xml-viewer td.code pre{margin:0;padding:0;border:0;background:transparent;font-family:inherit;font-size:inherit;line-height:inherit;white-space:pre;-moz-tab-size:4;-o-tab-size:4;tab-size:4;}',
                    '.xml-bracket{color:#0000ff;}',
                    '.xml-tag{color:#0000ff;}',
                    '.xml-attr{color:#ff0000;}',
                    '.xml-val{color:#008000;}',
                    '.xml-comment{color:#808080;font-style:italic;}',
                    '.xml-decl{color:#808080;}'
                ].join('')
            },
            xmlDisplay: '',
            costBasisTypes: [
                'None',
                'Unrealized',
                'Realized',
                'Both'
            ],
            extendedCostBasisTypeOptions: [
                { value: 0, label: 'None' },
                { value: 1, label: 'Unrealized Only' },
                { value: 2, label: 'Realized Only' },
                { value: 3, label: 'Unrealized Daily / Realized Daily' },
                { value: 4, label: 'Unrealized Daily / Realized Weekly' },
                { value: 5, label: 'Unrealized Daily / Realized Monthly' },
                { value: 6, label: 'Unrealized Weekly / Realized Weekly' }
            ],
            legacyCostBasisTypeMap: {
                'None': 0,
                'Unrealized': 1,
                'Realized': 2,
                'Both': 3
            },
            legacyCostBasisTypeNames: ['None', 'Unrealized', 'Realized', 'Both'],
            processCostBasisTypeEnabled: false,
            selectedCostBasisType: 0,
            previousFormatSubType: null,
            item: { id: parseInt(args.item) || parseInt(args.item.id) || 0 },
            noteMappings: [],
            selectedTab: '',
            itemOriginal: {},
            markupOriginal: {},
            markup: {
                xml: ''
            },
            selectedVersion: null,
            formatSubTypes: {},
            dropDownCheckBoxesArrayValueByCode:[]
        };

        // The XML viewer is rendered with TinyMCE in read-only mode. TinyMCE treats its
        // content as HTML, so the raw XML is converted into a line-numbered table with
        // syntax-highlighted tags/attributes (replacing ACE's editor view). All text is
        // HTML-escaped; the highlight markup uses classes styled via content_style above.
        function escapeXmlText(text) {
            return String(text)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
        }

        function highlightAttributes(attrText) {
            if (!attrText) { return ''; }
            return escapeXmlText(attrText).replace(
                /([\w:.-]+)(\s*=\s*)("[^"]*"|'[^']*')/g,
                '<span class="xml-attr">$1</span>$2<span class="xml-val">$3</span>'
            );
        }

        function highlightTag(tag) {
            var inner = tag.slice(1, -1);
            var leadingSlash = '';
            var trailingSlash = '';
            if (inner.charAt(0) === '/') { leadingSlash = '/'; inner = inner.slice(1); }
            if (inner.charAt(inner.length - 1) === '/') { trailingSlash = '/'; inner = inner.slice(0, -1); }
            var match = inner.match(/^([\w:.-]+)([\s\S]*)$/);
            var name = match ? match[1] : inner;
            var attrs = match ? match[2] : '';
            return '<span class="xml-bracket">&lt;' + leadingSlash + '</span>' +
                '<span class="xml-tag">' + escapeXmlText(name) + '</span>' +
                highlightAttributes(attrs) +
                '<span class="xml-bracket">' + trailingSlash + '&gt;</span>';
        }

        function highlightXmlLine(line, state) {
            var out = '';
            var s = line;
            while (s.length > 0) {
                if (state.inComment) {
                    var endIdx = s.indexOf('-->');
                    if (endIdx === -1) {
                        out += '<span class="xml-comment">' + escapeXmlText(s) + '</span>';
                        s = '';
                    } else {
                        out += '<span class="xml-comment">' + escapeXmlText(s.slice(0, endIdx + 3)) + '</span>';
                        s = s.slice(endIdx + 3);
                        state.inComment = false;
                    }
                    continue;
                }
                var tagStart = s.indexOf('<');
                if (tagStart === -1) {
                    out += escapeXmlText(s);
                    s = '';
                    continue;
                }
                if (tagStart > 0) {
                    out += escapeXmlText(s.slice(0, tagStart));
                    s = s.slice(tagStart);
                    continue;
                }
                if (s.indexOf('<!--') === 0) {
                    var cEnd = s.indexOf('-->');
                    if (cEnd === -1) {
                        out += '<span class="xml-comment">' + escapeXmlText(s) + '</span>';
                        s = '';
                        state.inComment = true;
                    } else {
                        out += '<span class="xml-comment">' + escapeXmlText(s.slice(0, cEnd + 3)) + '</span>';
                        s = s.slice(cEnd + 3);
                    }
                    continue;
                }
                if (s.charAt(1) === '?' || s.charAt(1) === '!') {
                    var declEnd = s.indexOf('>');
                    if (declEnd === -1) {
                        out += '<span class="xml-decl">' + escapeXmlText(s) + '</span>';
                        s = '';
                    } else {
                        out += '<span class="xml-decl">' + escapeXmlText(s.slice(0, declEnd + 1)) + '</span>';
                        s = s.slice(declEnd + 1);
                    }
                    continue;
                }
                var gtIdx = s.indexOf('>');
                if (gtIdx === -1) {
                    out += escapeXmlText(s);
                    s = '';
                    continue;
                }
                out += highlightTag(s.slice(0, gtIdx + 1));
                s = s.slice(gtIdx + 1);
            }
            return out;
        }

        function buildXmlViewer(xml) {
            if (!xml) { return ''; }
            var lines = String(xml).replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
            var state = { inComment: false };
            var rows = '';
            for (var i = 0; i < lines.length; i++) {
                var code = highlightXmlLine(lines[i], state);
                if (code === '') { code = '&nbsp;'; }
                // Wrap in <pre> so TinyMCE treats the whitespace as significant and does not
                // collapse the leading tabs/spaces (indentation) when it parses the content.
                rows += '<tr><td class="ln">' + (i + 1) + '</td><td class="code"><pre>' + code + '</pre></td></tr>';
            }
            return '<table class="xml-viewer"><tbody>' + rows + '</tbody></table>';
        }

        $scope.$watch('current.selectedVersion', function (version) {
            $scope.current.xmlDisplay = version ? buildXmlViewer(version.xml) : '';
        });

        $scope.checkIsNumberOrNull = function (option)
        {
            return option.Value == null || typeof option.Value === 'number';
        }

        //INTERFACE
        $scope.controls = {
            loadTab: loadTab,
            save: save,
            close: close,
            checkForValidMappings: checkForValidMappings,
            formatDropdownCheckboxChoices: formatDropdownCheckboxChoices,
            onCostBasisTypeChange: onCostBasisTypeChange
        };

        $scope.current.changeSubType = () => {
            // ng-model updates selectedFormatSubType before ng-change, so persist to the subtype we are leaving.
            persistCostBasisTypeToSubType($scope.current.previousFormatSubType);
            $scope.current.downloadFormatConfigOptions = $scope.current.selectedFormatSubType.downloadFormatConfig;
            formatOptions();
            syncSelectedCostBasisTypeFromSubType();
            $scope.current.previousFormatSubType = $scope.current.selectedFormatSubType;
        };

        function formatOptions() {
            if ($scope.current.downloadFormatConfigOptions) {
                $scope.current.dropDownCheckBoxesArrayValueByCode = [];
                $scope.current.downloadFormatConfigOptions.forEach(option => {
                    $confirmDownloadOptionService.parseOption(option);

                    var newObj = {};
                    if (option.ArrayValue && option.ArrayValue.length > 0 && option.Type === 'checkbox_dropdown') {
                        option.ArrayValue.forEach(obj => {
                            var intId = parseInt(obj.id);
                            newObj[intId] = obj.name;
                        });
                    }
                    $scope.current.dropDownCheckBoxesArrayValueByCode[option.Code] = newObj;
                });
            }
        }
        //INIT
        (function () {
            if ($scope.rights.formatRectypeEditor.canRead) {
                $scope.menu.categories[0].children.push({ name: 'Rec Type Editor', active: false, code: 'RecTypeLinkEditor' });
            }

            loadData($scope.current.item.id)
                .then(function (res) {
                    $scope.current.noteMappings = res.downloadFormatNoteMapping;
                    $scope.current.localSecurityMapping = { data: res.downloadFormatLocalSecurityMappings ? res.downloadFormatLocalSecurityMappings : [], labels: [] };
                    $scope.current.downloadFormatTransactionNoteMappings = { data: res.downloadFormatTransactionNoteMappings ? res.downloadFormatTransactionNoteMappings : [], labels: [] };
                    $scope.current.uniqueSymbolMapping = { data: res.downloadFormatUniqueSymbolMappings, labels: [] };
                    $scope.current.formatSubTypes = { data: res.downloadFormatSubTypes, labels: [], canRemove: false };

                    $scope.current.noteMappings.forEach((noteMapping) => {
                        noteMapping.subtypeDesc = noteMapping.downloadFormatSubtypeId;
                        var date = new Date(noteMapping.editedDate);
                        noteMapping.editedDate = date.toLocaleDateString() + ' ' + date.toLocaleTimeString('en-us', { hour: '2-digit', minute: '2-digit' });
                    });

                    $scope.current.downloadFormatTransactionNoteMappings.data.forEach((tranNoteMapping) => {
                        tranNoteMapping.subtypeDesc = tranNoteMapping.downloadFormatSubtypeId;
                        var date = new Date(tranNoteMapping.editedDate);
                        tranNoteMapping.editedDate = date.toLocaleDateString() + ' ' + date.toLocaleTimeString('en-us', { hour: '2-digit', minute: '2-digit' });
                    });

                    $scope.current.localSecurityMapping.data.forEach((localSecurityMapping) => {
                        localSecurityMapping.subtypeDesc = localSecurityMapping.downloadFormatSubtypeId;
                        var date = new Date(localSecurityMapping.editedDate);
                        localSecurityMapping.editedDate = date.toLocaleDateString() + ' ' + date.toLocaleTimeString('en-us', { hour: '2-digit', minute: '2-digit' });
                    });

                    $scope.current.uniqueSymbolMapping.data.forEach((uniqueSymbolMap) => {
                        uniqueSymbolMap.subtypeDesc = uniqueSymbolMap.downloadFormatSubtypeId;
                        var date = new Date(uniqueSymbolMap.editedDate);
                        uniqueSymbolMap.editedDate = date.toLocaleDateString() + ' ' + date.toLocaleTimeString('en-us', { hour: '2-digit', minute: '2-digit' });
                    });

                    $scope.current.offsetCashMappings = { data: res.downloadFormatOffsetCashMappings, labels: [] };
                    $scope.current.offsetCashMappings.data.forEach(
                        (offsetMapping) => {
                            offsetMapping.subtypeDesc = offsetMapping.downloadFormatSubtypeId;
                            var date = new Date(offsetMapping.editedDate);
                            offsetMapping.editedDate = date.toLocaleDateString() + ' ' + date.toLocaleTimeString('en-us', { hour: '2-digit', minute: '2-digit' });
                        });
                    $scope.current.itemOriginal = angular.copy($scope.current.downloadFormat = res.downloadFormat);
                    $scope.current.processCostBasisTypeEnabled = !!res.processCostBasisTypeEnabled;

                    $scope.current.subformatOptions = angular.copy(res.downloadFormatSubTypes);
                    $scope.current.subformatOptions.forEach((subFormat) => {
                        subFormat.downloadFormatConfig = JSON.parse(subFormat.downloadFormatConfigJSON);
                        // Non-default subtypes use their own CostBasisType only (defaults to None/0).
                        subFormat.costBasisType = normalizeCostBasisType(subFormat.costBasisType ?? 0);
                    });
                    $scope.current.item = $scope.current.downloadFormat;

                    $scope.current.downloadFormatConfigOptions = JSON.parse($scope.current.item.downloadFormatConfigJSON);
                    $scope.current.subformatOptions.unshift({
                        id: 0,
                        name: 'Default',
                        downloadFormatConfig: $scope.current.downloadFormatConfigOptions,
                        costBasisType: normalizeCostBasisType(res.downloadFormat.costBasisType)
                    });
                    $scope.current.selectedFormatSubType = $scope.current.subformatOptions[0];
                    $scope.current.previousFormatSubType = $scope.current.selectedFormatSubType;

                    syncSelectedCostBasisTypeFromSubType();

                    loadLabels(res.downloadFormat.id);


                    formatOptions();

                    //  API Get xml
                    Promise.all([
                        loadMarkup(res.downloadFormat.id),
                        loadVersions(res.downloadFormat.id)
                    ]).then(value => {
                        //xml load
                        $scope.current.formatVersions = [];
                        $scope.current.formatVersions.push({ name: 'Default', xml: value[0].xml, code: 'Default' });
                        value[1].forEach((formatVersion) => {
                            $scope.current.formatVersions.push({
                                name: formatVersion.description,
                                xml: formatVersion.xmlFile,
                                code: formatVersion.versionCode
                            });
                        }); // End xml load

                        $scope.current.selectedVersion = $scope.current.formatVersions[0];

                        // recType Load
                        $scope.current.formatVersions.forEach((version) => {
                            let parser = new DOMParser();
                            let xmlDoc = parser.parseFromString(version.xml, "text/xml");
                            let xmlSections = xmlDoc.getElementsByTagName("SECTION");
                            version.RecTypesByType = [];
                            for (let i = 0; i < xmlSections.length; i++) {
                                version.RecTypesByType.push({
                                    sectionName: xmlSections[i].getAttribute("Name"),
                                    fileType: xmlSections[i].getAttribute("SectionType"),
                                    recType: xmlSections[i].getAttribute("RecTypeLink")
                                });
                            }

                            version.OriginalUnchangingRecTypesByType = angular.copy(version.RecTypesByType);
                        }); //End Rectype load
                    }).catch((err) => {
                        // HTTP failures are already surfaced to the user by httpGlobalInterceptor.
                        // Handle the rejection here so it does not bubble up as an unhandled
                        // native promise rejection, which zone.js then tries (and fails) to
                        // JSON.stringify because the $http response carries circular references.
                        $scope.current.formatVersions = $scope.current.formatVersions || [];
                        $scope.current.selectedVersion = null;
                        console.warn('Failed to load download format XML/markup.', err && err.status ? ('Status: ' + err.status) : (err && err.message));
                    }); //End api xml fetch
                }); // End Load Data

            loadTab({ code: 'General' });

        })();

        function loadLabels(formatId) {
            $scope.current.subTypeDescLabel = { code: 'subtypeDesc', value: 'Format Subtype Description', type: 'dropdown', default: '', editable: true, selectOptions: [], allowFilter: true, required: true, key: true };
            $scope.current.subformatOptions.forEach((subFormat) => {
                $scope.current.subTypeDescLabel.selectOptions.push({ displayName: subFormat.name, value: subFormat.id });
            });

            $scope.current.noteMappingLabels = [
                { code: 'downloadFormatSubtypeId', value: 'Format Subtype ID', default: '', editable: false},
                $scope.current.subTypeDescLabel,
                { code: 'fileTranCode', value: 'File Trans Code', default: '', editable: true, required: true, key: true },
                { code: 'searchFor', value: 'Note Search', default: '', editable: true, required: true, key: true },
                { code: 'translateTo', value: 'Translate To', default: '', editable: true, required: true, key: true},
                { code: 'editedBy', value: 'Edited By', editable: false },
                { code: 'editedDate', value: 'EditedDate', editable: false }
            ];

            $scope.current.localSecurityMapping.labels = [
                { code: 'downloadFormatSubtypeId', value: 'Format Subtype ID', default: '', editable: false},
                $scope.current.subTypeDescLabel,
                { code: 'downloadSymbol', value: 'Download Symbol', editable: true, key: true, required: true },
                { code: 'localMapping', value: 'New Symbol Mapping', editable: true, required: true },
                { code: 'editedBy', value: 'Edited By', editable: false },
                { code: 'editedDate', value: 'EditedDate', editable: false }];

            $scope.current.uniqueSymbolMapping.labels = [
                { code: 'downloadFormatSubtypeId', value: 'Format Subtype ID', default: '', editable: false},
                $scope.current.subTypeDescLabel,
                { code: 'uniqueSymbol', value: 'Unique Symbol Mapping', editable: true, required: true, key: true },
                { code: 'editedBy', value: 'Edited By', editable: false },
                { code: 'editedDate', value: 'Edited Date', editable: false }];

            $scope.current.downloadFormatTransactionNoteMappings.labels = [
                { code: 'downloadFormatSubtypeId', value: 'Format Subtype ID', default: '', editable: false },
                $scope.current.subTypeDescLabel,
                { code: 'downloadSymbol', value: 'Download Symbol', editable: true, key: true, required: true },
                { code: 'newSymbol', value: 'New Symbol Mapping', editable: true, required: true },
                { code: 'note', value: 'Note', editable: true, required: true, key: true },
                { code: 'editedBy', value: 'Edited By', editable: false },
                { code: 'editedDate', value: 'Edited Date', editable: false }];

            $scope.current.formatSubTypes.labels =
                [{ code: 'id', value: 'Download Format Subtype ID', default: 0, editable: false },
                { code: 'name', value: 'Download Format Subtype Name', default: '', editable: true }];

            $scope.current.offsetCashMappings.labels = [
                { code: 'downloadFormatSubtypeId', value: 'Format Subtype ID', default: '', editable: false},
                $scope.current.subTypeDescLabel,
                { code: 'externalCode', value: 'External Code', default: '', editable: true, required: true, key: true },
                { code: 'cashSymbol', value: 'Cash Symbol', default: '', editable: true, required: true },
                { code: 'editedBy', value: 'Edited By', editable: false },
                { code: 'editedDate', value: 'Edited Date', editable: false }];
        }

        //PUBLIC METHODS
        function close() {
            dialog.close(null);
        }

        function save() {
            $scope.current.errors = [];
            if ($scope.current.processCostBasisTypeEnabled) {
                persistCostBasisTypeToSubType($scope.current.selectedFormatSubType);
            } else {
                var defaultSubType = $scope.current.subformatOptions.find(s => s.id === 0);
                if (defaultSubType) {
                    defaultSubType.costBasisType = normalizeCostBasisType($scope.current.item.costBasisType);
                }
            }
            let data = {
                id: $scope.current.item.id,
                downloadFormat: $scope.current.item,
                downloadFormatSubTypes: $scope.current.formatSubTypes.data
            };

            $scope.current.subformatOptions.forEach((subType) => {
                subType.downloadFormatConfig.forEach((option) => {
                    option = $confirmDownloadOptionService.serializeOption(option);
                });
                if (subType.id === 0) {
                    $scope.current.downloadFormat.downloadFormatConfigJSON = angular.toJson(subType.downloadFormatConfig);
                    $scope.current.downloadFormat.costBasisType = toCostBasisApiValue(subType.costBasisType);
                }
                else {
                    var subtypeToSave = data.downloadFormatSubTypes.find(dataSubType => dataSubType.id === subType.id);
                    if (subtypeToSave != null) {
                        subtypeToSave.downloadFormatConfigJSON = angular.toJson(subType.downloadFormatConfig);
                        if ($scope.current.processCostBasisTypeEnabled) {
                            subtypeToSave.costBasisType = toCostBasisApiValue(subType.costBasisType);
                        }
                    }
                }
            });

            //Handle Mapping data
            $scope.current.errors = [];
            var noteMappings = checkForValidMappings($scope.current.noteMappingLabels, $scope.current.noteMappings,'Note Mappings', true).valid;
            var localSecurityMappings = checkForValidMappings($scope.current.localSecurityMapping.labels, $scope.current.localSecurityMapping.data,'Local Security Mappings', true).valid;
            var uniqueSymbolMappings = checkForValidMappings($scope.current.uniqueSymbolMapping.labels, $scope.current.uniqueSymbolMapping.data, 'Unique Symbol Mapping', true).valid;
            var transSymbolMappings = checkForValidMappings($scope.current.downloadFormatTransactionNoteMappings.labels, $scope.current.downloadFormatTransactionNoteMappings.data, 'Trans Symbol Mapping', true).valid;
            var offsetCashMappings = checkForValidMappings($scope.current.offsetCashMappings.labels, $scope.current.offsetCashMappings.data, 'Offset Cash Mapping', true).valid;
            if ($scope.current.errors.length > 0) {

                var errorMsg = 'You currently have ' + $scope.current.errors.length + ' error(s) would you like to save all valid entries?';
                $dialog.confirmAction(errorMsg)
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            createRequestAndSaveChanges(data, offsetCashMappings, transSymbolMappings, uniqueSymbolMappings, localSecurityMappings, noteMappings);
                        }
                    });
            }
            else {
                createRequestAndSaveChanges(data, offsetCashMappings, transSymbolMappings, uniqueSymbolMappings, localSecurityMappings, noteMappings);
            }
        }
        function createRequestAndSaveChanges(data, offsetCashMappings, transSymbolMappings, uniqueSymbolMappings, localSecurityMappings, noteMappings) {
            data.DownloadFormatOffsetCashMappings = offsetCashMappings;
            data.DownloadFormatTransactionNoteMappings = transSymbolMappings;
            data.DownloadFormatUniqueSymbolMappings = uniqueSymbolMappings;
            data.DownloadFormatLocalSecurityMappings = localSecurityMappings;
            data.DownloadFormatNoteMapping = noteMappings;

            var recTypesBySectionName = {};
            
            if ($scope.rights.formatRectypeEditor.canUpdate) {
                
                //Only call rectype endpoint if data has changed.
                let shouldUpdateRecTypes = false;
                $scope.current.formatVersions.forEach((version) => {
                    if (JSON.stringify(version.OriginalUnchangingRecTypesByType) !== JSON.stringify(version.RecTypesByType)) {
                        shouldUpdateRecTypes = true;
                    }
                });

                if (shouldUpdateRecTypes) {
                    let promises = [];
                    $scope.current.formatVersions.forEach((version) => {
                        version.RecTypesByType.forEach((recTypeObj) => {
                            recTypesBySectionName[String(recTypeObj.sectionName)] = recTypeObj.recType;
                        });

                        var markupData = { RecTypeBySectionName: recTypesBySectionName };
                        promises.push($http.put(`/Confirm/DownloadFormats/${data.id}/Rectype/${version.code}`, markupData, { trackerMsg: "Updating RecTypes", ignoreExceptions: true }));
                            
                    });

                    Promise.all(promises).then(() => {
                        // only save format changes if all recType updates were successful
                        saveFormatChanges(data);
                    }).catch((err) => {
                        if (err) {
                            $scope.current.errors = [];
                            $scope.current.errors.push({
                                row: 0,
                                type: 'FormatRectypeSaveError',
                                title: 'Format RecType Save Error'
                            });
                        }
                    });
                } else {
                    //if no rectype changes then just update the format/mappings/subtypes
                    saveFormatChanges(data);
                }
            } else {
                saveFormatChanges(data);
            }
        }
        function saveFormatChanges(data) {
            $http.put("/Confirm/DownloadFormats/verbose/" + data.id, data, { trackerMsg: "Saving Changes", ignoreExceptions: true })
                .then(function (res) {
                    dialog.close(res);

                }).catch((err) => {
                    $scope.current.errors = [];
                    if (err.status === 400) {
                        $scope.current.errors.push({
                            row: 0,
                            type: 'FormatSaveError',
                            title: 'Format Save Error',
                            msg: err.data.Message
                        });
                    }
                });
        }

        //returns all valid rows and invalid rows
        function checkForValidMappings(labels, data, dataType, isSave = false) {
            var result = { valid: [], invalid: [] };
            var uniqueValues = [];

            if (!isSave) {
                $scope.current.errors = [];
            }

            data.forEach((item, index) => {
                var invalidReason = null;
                var invalidReasonShort = null;
                var uniqueIndex = '';
                var hasSubtype = false;
                labels.forEach((label) => {
                    if (label.required && (item[label.code] == null || item[label.code] === ""))
                    {
                        invalidReasonShort = label.value + ' is required';
                        invalidReason = label.value + ' is required incomplete records will be removed upon saving';
                    }
                    if (label.code === 'downloadFormatSubtypeId')
                    {
                        hasSubtype = true;   
                    }
                    if (label.key === true)
                    {
                        uniqueIndex += '<[]>' + item[label.code] 
                    }
                });

                if (hasSubtype === true)
                {
                    item['downloadFormatSubtypeId'] = item['subtypeDesc'];
                }

                if (invalidReason == null && uniqueValues.includes(uniqueIndex)) {
                    invalidReason = 'Duplicate Record Exists';
                    invalidReasonShort = 'Duplicate Record Exists';
                }
                else
                {
                    uniqueValues.push(uniqueIndex);
                }

                if (invalidReason != null) {
                    $scope.current.errors.push(
                        {
                            row: index,
                            type: invalidReasonShort ,
                            title: dataType,
                            msg: invalidReason
                        }
                    );
                    result.invalid.push(item);
                } else {
                    result.valid.push(item);
                }
            });

            return result;
        }

        function loadTab(child) {
            // Refresh SubType Options on tab load as there may have been some added or removed.
            if ($scope.current.subTypeDescLabel != null) {
                $scope.current.subTypeDescLabel.selectOptions = [];
                $scope.current.subformatOptions.forEach((subFormat) => {
                    $scope.current.subTypeDescLabel.selectOptions.push({ displayName: subFormat.name, value: subFormat.id });
                });
            }

            $scope.menu.categories.each(function (c) {
                c.children.each(function (ch) {
                    ch.active = ch.code === child.code;
                });
            });

            $scope.current.selectedTab = child.code;
        }

        function formatDropdownCheckboxChoices (arrayValue) {
            
        }

        function normalizeCostBasisType(value) {
            if (value === null || value === undefined || value === '') {
                return 0;
            }
            if (typeof value === 'number') {
                return value;
            }
            if ($scope.current.legacyCostBasisTypeMap.hasOwnProperty(value)) {
                return $scope.current.legacyCostBasisTypeMap[value];
            }
            var fromExtended = $scope.current.extendedCostBasisTypeOptions.find(function (opt) {
                return opt.label === value;
            });
            if (fromExtended) {
                return fromExtended.value;
            }
            var parsed = parseInt(value, 10);
            return isNaN(parsed) ? 0 : parsed;
        }

        function toCostBasisApiValue(value) {
            var normalized = normalizeCostBasisType(value);
            if (!$scope.current.processCostBasisTypeEnabled) {
                return $scope.current.legacyCostBasisTypeNames[normalized] || 'None';
            }
            if (normalized <= 3) {
                return $scope.current.legacyCostBasisTypeNames[normalized] || 'None';
            }
            return normalized;
        }

        function syncSelectedCostBasisTypeFromSubType() {
            if (!$scope.current.selectedFormatSubType || !$scope.current.processCostBasisTypeEnabled) {
                return;
            }
            $scope.current.selectedCostBasisType = normalizeCostBasisType($scope.current.selectedFormatSubType.costBasisType);
        }

        function persistCostBasisTypeToSubType(subType) {
            if (!subType || !$scope.current.processCostBasisTypeEnabled) {
                return;
            }
            subType.costBasisType = normalizeCostBasisType($scope.current.selectedCostBasisType);
            if (subType.id === 0) {
                $scope.current.item.costBasisType = toCostBasisApiValue($scope.current.selectedCostBasisType);
            }
        }

        function persistSelectedCostBasisType() {
            persistCostBasisTypeToSubType($scope.current.selectedFormatSubType);
        }

        function onCostBasisTypeChange() {
            persistSelectedCostBasisType();
        }

        //PRIVATE METHODS
        function loadData(key) {
            if (!key) {
                return {};
            }

            return $http.get("/Confirm/DownloadFormats/verbose/" +
                key +
                "?expand=DownloadFormatNoteMapping,DownloadFormat,DownloadFormatLocalSecurityMapping" +
                ",DownloadFormatUniqueSymbolMapping,DownloadFormatTransactionNoteMapping," +
                "DownloadFormatSubType,DownloadFormatCashOffsetMapping",
                { trackerMsg: "Loading Download Formats" })
                .then(function (res) {
                    return res.data;
                });
        }

        function loadVersions(key) {
            return $q.resolve(key !== 0 && $scope.rights.downloadFormatMarkup.canRead ?
                $http.get("/Confirm/DownloadFormatVersion/" + key, { trackerMsg: "Loading markups" }).then(function (response) {
                    return response.data;
                })
                : null
            );
        }

        function loadMarkup(key) {
            return $q.resolve(key !== 0 && $scope.rights.downloadFormatMarkup.canRead ?
                $http.get("/Confirm/DownloadFormats/" + key + "/Markup", { trackerMsg: "Loading markup" }).then(function (response) {
                    return response.data;
                })
                : null
            );
        }
    }

    function restrictFieldCTRL() {
        return {
            restrict: 'AE',
            scope: {
                restrictField: "=",
                allowSpaces: "="
            },
            link: function (scope) {
                let regex = /[`'\s]/g;
                if (scope.allowSpaces) { regex = /[`']/g; }
                scope.$watch('restrictField', function (newValue, oldValue) {
                    if (newValue !== oldValue && regex.test(newValue)) {
                        scope.restrictField = newValue.replace(regex, '');
                    }
                });
            }
        };
    }
})();
'use strict';

app.controller('FormatSourceDefaultEditCtrl', function ConfirmationSourceEditCtrl($scope, $http, $oasRights, dialog, args, $q, accountCreation, patternMatchType, confirmTransmitMethod, positionOnlyReconcile, splitIoService, $confirmDownloadOptionService) {

    var itemOriginal = null;
    var isNewDownloadFormatSourceDefault = null;
    var hasDownloadSourceOptionJSON = null;

    $scope.save = function () {
        if (!angular.equals(itemOriginal, $scope.downloadFormatSourceDefaults)) {
            $scope.downloadFormatSourceDefaults.forEach((dfsd) => {
                if (!isNaN(dfsd.custodianCommonCode)) {
                    dfsd.custodianCommonCode = $scope.current.custodianCommonCodesById[dfsd.custodianCommonCode];
                }
            });

            if (hasDownloadSourceOptionJSON === true) {
                $scope.downloadFormatSourceDefaults.forEach((dfsd) => {
                    dfsd.normalDefaultOptions.forEach(option => {
                        option = $confirmDownloadOptionService.serializeOption(option);
                    });

                    dfsd.options = dfsd.normalDefaultOptions;
                    var codes = dfsd.options.map(q => q.Code);
                    Object.keys(dfsd.groupedOptions).forEach((optionCode) => {
                        if (!codes.includes(optionCode))
                        {
                            dfsd.options.push($confirmDownloadOptionService.serializeOption(dfsd.groupedOptions[optionCode]));
                        }
                    });

                    dfsd.downloadSourceOptionJSON = angular.toJson(dfsd.options);
                });
            };

            //turn schedule configuration into a json object for api
            var dataToSend = transformSchedulesToJson($scope.downloadFormatSourceDefaults);

            const args = { method: "PUT", id: $scope.current.item.id, trackerMsg: "Saving download format source defaults" };

            $http({ method: args.method, url: '/Confirm/DownloadFormatSourceDefault/BulkUpdate', data: dataToSend, trackerMsg: args.trackerMsg })
                .then(function (r) {
                    dialog.close(r.data);
                    transformSchedulesJsonToObjects(r.data);
                });
        }
        else {
            dialog.close(null);
        }
    };

    $scope.CheckForRights = function () {
        return !$scope.rights.downloadSources.canUpdate;
    };

    $scope.close = function (validate) {
        if (validate) {
            if (!angular.equals(itemOriginal, $scope.current.item)) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                dialog.close(null);
            }
        }
        else {
            dialog.close(null);
        }
    };
    $scope.changeDefault = function () {
        $scope.downloadFormatSourceDefault = $scope.current.selectedDownloadFormatSourceDefault;
    }

    // PRIVATE METHODS - INIT
    function init() {
        $scope.rights = {
            downloadSources: $oasRights.forCode("DOWNLOADSOURCES"),
            downloadSourcesPasswords: $oasRights.forCode("DOWNLOADSOURCESPASSWORDS")
        };

        $scope.downloadFormatSourceDefault = createEmptyDownloadFormatSourceDefault();

        $scope.current = {
            item: { id: getIdFromArgs() },
            selectedTab: args.defaultTab,
            options: {
                accountCreation: accountCreation.values(),
                transmitMethod: confirmTransmitMethod.values(),
                patternMatchType: patternMatchType.values(),
                positionOnlyReconcile: positionOnlyReconcile.values(),
                team: [],
                teamMember: [],
                downloadFormat: []
            },
            sshUploadUrl: getIdFromArgs() ?
                `/Confirm/DownloadFormatSourceDefault/KeyFile/${args.item.id}` :
                ''
        };

        var globalCustodiansSimple = $http.get('/Global/Custodians/Simple', { trackerMsg: 'Loading Custodian Common' });
        var downloadFormatSourceDefaultSubtypes = $http.get('/Confirm/DownloadFormatSourceDefault/Subtypes/' + $scope.current.item.id, { trackerMsg: 'Loading download format source default', ignoreExceptions: [404] });
        
        globalCustodiansSimple
        .then((response) => {
            $scope.current.custodianCommonIdsByCode = Object.assign({}, ...response.data.map((x) => ({ [x.code]: x.id })));
            $scope.current.custodianCommonCodesById = Object.assign({}, ...response.data.map((x) => ({ [x.id]: x.code })));
            
            downloadFormatSourceDefaultSubtypes
            .then(function (r) {
                if (r.data != null) {
                    isNewDownloadFormatSourceDefault = false;
                    //transform json to objects
                    transformSchedulesJsonToObjects(r.data);
                    $scope.downloadFormatSourceDefaults = r.data;

                    itemOriginal = angular.copy($scope.downloadFormatSourceDefaults);

                    $scope.downloadFormatSourceDefaults.forEach((dfsd) => {
                        if(!dfsd.hasOwnProperty("schedules")){
                            dfsd.schedules = [];
                        }
                        
                        //this is for the default format source default, it has no format subtype id
                        if (dfsd.downloadFormatSubTypeId == 0) {
                            $scope.current.selectedDownloadFormatSourceDefault = dfsd;
                            $scope.downloadFormatSourceDefault = dfsd;
                        }
                        

                        dfsd.reconTargetTime = Date.create(dfsd.reconTargetTime);
                        dfsd.custodianCommonCode = $scope.current.custodianCommonIdsByCode[dfsd.custodianCommonCode];
                        if (dfsd.downloadSourceOptionJSON != null) {
                            dfsd.normalDefaultOptions = [];
                            dfsd.groupedOptions = [];
                            hasDownloadSourceOptionJSON = true;
                            dfsd.options = JSON.parse(dfsd.downloadSourceOptionJSON);
                            dfsd.options.forEach(option => {
                                option = $confirmDownloadOptionService.parseOption(option);

                                if (option.LabelGroup == null || option.LabelGroup == "") {
                                    dfsd.normalDefaultOptions.push(option);
                                } else {
                                    dfsd.groupedOptions[option.Code] = option;
                                }
                            });
                        }
                        else {
                            hasDownloadSourceOptionJSON = false;
                        }
                    });

                }
            }).catch(function (r) {
                isNewDownloadFormatSourceDefault = true;

                $scope.downloadFormatSourceDefault = createEmptyDownloadFormatSourceDefault();

                return null;
            });
        });

        loadServiceTeams();
        buildMenu();
        $scope.loadTab(args.defaultTab);

        function createEmptyDownloadFormatSourceDefault() {
            return {
                downloadFormatId: getIdFromArgs(),
                downloadDescription: null,
                serviceTeamReconId: null,
                isActive: null,
                newAccounts: null,
                reconTargetTime: null,
                cashCusip: null,
                transPercTolerance: null,
                transDaysTolerance: null,
                note: null,
                transmitMethod: null,
                url: null,
                filePattern: null,
                altFilePattern: null,
                deleteSourceFile: null,
                patternMatchType: null,
                zipPassword: null,
                userId: null,
                password: null,
                registrationBaseNumber: null,
                positionOnlyReconcile: null,
                dailyAccrualTolerance: null,
                options: null,
                useReversal: null,
                isAutoHouseholding: null,
                ignoreRepVerify: null,
                alwaysCreateNewRegistration: null,
                noOrionPriceCopy: null,
                newAccountCenterSuppression: null,
                isFixSmallBalance: null,
                isDividendTransactionCombination: null,
                namePercentMatch: null,
                positionPercentMatch: null,
                transactionPercentMatch: null,
                comparePositionValue: null,
                runAssetValueComparison: null,
                isSourceExclusionCB: null,
                isSourceExclusionTran: null,
                isUnVerifiedSells: null,
                IsSshEnabled: false,
                allowPriceZero: null,
                allowAcctCodeMatch: null,
                allowAcctCodeMatchWOZero: null,
                allowSecondaryAcctCodeMatch: null,
                allowCorpActionImport: null,
                allowPositionImport: null,
                allowPriceImport: null,
                allowDivImport: null,
                allowGenericImport: null,
                allowNameImport: null,
                allowSecurityImport: null,
                allowTransactionImport: null,
                allowTranDetailImport: null,
                allowCostBasisImport: null,
                allowBeneficiaryImport: null,
                allowBankingImport: null,
                allowRMDImport: null,
                allowSystematicImport: null,
                schedules:[]
            };
        }
    }

    $scope.loadTab = function (child) {
        new Promise((resolve) => {
            $scope.menu.categories.each(function (c) {
                c.children.each(function (ch) {
                    ch.active = ch.code === child.code;
                });
            });

            $scope.current.selectedTab = child.code;
            resolve();
        })
            .then(() => {
                if ($scope.current.selectedTab == "options") {
                    Object.keys($scope.downloadFormatSourceDefault.groupedOptions).forEach((optionCode) => {
                        var option = $scope.downloadFormatSourceDefault.groupedOptions[optionCode];
                        var label = document.createElement("label");
                        label.classList.add(option.Type);
                        label.innerText = option.Name;
                        if (option.Type == "checkbox") {
                            var inputElement = document.createElement("input");
                            inputElement.setAttribute("type", option.Type);
                            inputElement.id = option.Code;
                            inputElement.checked = option.Value == "true" || option.Value == true;
                            label.append(inputElement);
                            inputElement.onchange = handleGroupedOptionUpdate;
                        }
                        $("#" + option.LabelGroup)[0].append(label);
                    });
                }
            });
    };

    function handleGroupedOptionUpdate(e) {
        $scope.downloadFormatSourceDefault.groupedOptions[e.target.id].Value = $("#" + e.target.id).is(":checked");
    }

    $scope.isSshUploadEnabled = function () {
        return enableSshUpload();
    };

    $scope.showSshUpload = function () {
        return showSshUploadButton();
    }
    $scope.isDownloadformatNew = function () {
        return hasFormatBeenSaved();
    }

    function transformSchedulesToJson(data){
        let deepCopyOfData = angular.copy(data);

        for(let dfsd of deepCopyOfData){
            if (dfsd.schedules) {
                for(let schedule of dfsd.schedules){
                    const scheduleConfigurationJson = JSON.stringify(schedule.scheduleConfiguration);

                    schedule.scheduleConfiguration = scheduleConfigurationJson;
                }
            }
        }
        return deepCopyOfData;
    }

    function transformSchedulesJsonToObjects(data){
        data.forEach((dfsd) => {
            if (dfsd.schedules) {
                dfsd.schedules.forEach((schedule) => {
                    const scheduleConfigurationObject = JSON.parse(schedule.scheduleConfiguration);
                    
                    schedule.scheduleConfiguration = scheduleConfigurationObject;
                });
            }
        });
    }

    function loadServiceTeams() {
        return $q.all({
            teams: $http.get("/Global/ServiceTeams?teamType=ReconTeam"),
            members: $http.get("/Global/ServiceTeamMembers")
        }).then(function (response) {
            angular.extend($scope.current.options.team, response.teams.data);
            angular.extend($scope.current.options.teamMember, response.members.data);
        });
    }

    function buildMenu() {
        $scope.menu = { categories: [] };
        $scope.menu.categories.push({ name: 'General', children: [] });
        $scope.menu.categories[0].children.push({ name: 'General', active: false, code: 'general' });
        $scope.menu.categories[0].children.push({ name: 'Options', active: false, code: 'options' });

        splitIoService.getBoolTreatment("recon_downloadformats_schedules_OC-4053")
            .subscribe((isEnabled) => {
                if(isEnabled && args.item.isNonFileFormat){
                    $scope.menu.categories[0].children.push({ name: 'Schedules', active: false, code: 'schedules' });
                }                
            });
    }

    function enableSshUpload() {
        return $scope.downloadFormatSourceDefault.isSshEnabled
            && !$scope.downloadFormatSourceDefault.hasUploadClicked
            && $scope.downloadFormatSourceDefault.downloadFormatId > 0;
    }

    function showSshUploadButton() {
        return $scope.downloadFormatSourceDefault.isSshEnabled
            && $scope.downloadFormatSourceDefault.downloadFormatId > 0
            && $scope.downloadFormatSourceDefault.hasUploadClicked;
    }

    function hasFormatBeenSaved() {
        return $scope.downloadFormatSourceDefault.isSshEnabled && $scope.downloadFormatSourceDefault.downloadFormatId <= 0;
    }

    function getIdFromArgs() {
        return parseInt(args.item) || parseInt(args.item.id) || 0;
    }

    $scope.errors = [];
    
    init();

});

'use strict';

app.controller('DownloadSubFormatSchedulerDefaultEditCtrl', function DownloadSubFormatSchedulerDefaultEditCtrl($scope, $http, $oasRights, dialog, args, intervalType, scheduleDaysOfWeek, searchOption) {

    $scope.Name = args.item.formatName;

    $scope.CheckForRights = function () {
        return !$scope.rights.downloadFormats.canUpdate;
    };

    $scope.close = function () {
        dialog.close(null);
    };

    function createEmptyDownloadSubFormatSchedulerDefault(isCostBasis) {
        return {
            downloadFormatId: getIdFromArgs(),
            downloadFormatSubTypeId: 0,
            isCostBasis: isCostBasis,
            isAltSchedule: false,
            notificationGroup: null,
            notifyOnSuccess: false,
            active: false,
            priorityJob: false,
            interval: "Day",
            frequency: 1,
            offset: 0,
            offsetInterval: "Day",
            startTime: new Date("2000-01-01 00:00:00.000"),
            endTime: new Date("2000-01-01 23:59:00.000"),
            runDays: "Everyday",
            businessDayofMonth: null,
            schedulerTypeName: "FixedIntervalScheduler",
            filePath: null,
            folderPath: null,
            searchPattern: null,
            searchOption: "TopDirectoryOnly",
            importFiles: true,
            applyPriceAndSecurity: !isCostBasis, // we want this to default as true for non-cost basis and false for costbasis
            applyName: false,
            applyPosition: false,
            applyTransaction: false,
            applyDividend: false,
            applySecurityMaster: false,
            applyCorpAction: false,
            applyTranDetail: false,
            applyGeneric: false,
            applyCostBasis: false,
            applyBeneficiary: false,
            applySystematic: false,
            applyRMD: false,
            applyBanking: false,
            numberOfThreads: 4,
            sizeOfBatch: 20000,
            useAlternateFilePattern: true,
            expectedNumberOfFiles: 0,
            parentJobID: null,
            // This is to help control if the toggle gets spammed for create cost basis job
            isFromDB: false
        }
    }

    // PRIVATE METHODS - INIT
    function init() {
        $scope.rights = {
            downloadSources: $oasRights.forCode("DOWNLOADSOURCES"),
            downloadFormats: $oasRights.forCode("DOWNLOADFORMATS"),
        };

        $scope.downloadSubFormatSchedulerDefaults = [];
        $scope.stagingDeletes = [];

        $scope.selectedDownloadSubFormatSchedulerDefault = null;
        $scope.selectedCostBasisDownloadSubFormatSchedulerDefault = null;
        $scope.itemOriginal = null;
        $scope.costBasisItemOriginal = null;
        $scope.previousSelectedDownloadFormatSubType = null;

        $scope.current = {
            item: { id: getIdFromArgs() },
            selectedDownloadFormatSubType: null,
            downloadFormatSubTypes: [],
            shouldCreateCostBasisJob: false,
            notificationGroups: [],
            options: {
                // setup enum values
                intervalType: intervalType.values(),
                scheduleDaysOfWeek: scheduleDaysOfWeek.values(),
                searchOption: searchOption.values()
            }
        }

        loadAllScreenData();

    }

    function loadAllScreenData() {
        const promise1 = loadDownloadFormatSubTypes();
        const promise2 = loadSchedulerNotificationGroups();
        const promise3 = loadDownloadSubFormatSchedulerDefaults();

        Promise.all([promise1, promise2, promise3]).then((values) => {
            $scope.current.selectedDownloadFormatSubType = $scope.current.downloadFormatSubTypes.where(c => c.id == 0)?.first();
            $scope.previousSelectedDownloadFormatSubType = $scope.current.selectedDownloadFormatSubType;

            changeSubType();

            // In order to properly not delete non-existant cost basis rows, we need to know which exist in the DB
            $scope.downloadSubFormatSchedulerDefaults.forEach((row) => {
                row.isFromDB = true;
            });
        });
    }

    function loadDownloadFormatSubTypes() {
        var selectedDownloadFormatId = $scope.current.item.id;

        var url = `/Confirm/DownloadFormats/${selectedDownloadFormatId}/SubTypesSimpleWithDefault`;
        return $http.get(url, { trackerMsg: "Loading download format sub types" })
            .then(function (response) {
                $scope.current.downloadFormatSubTypes = response.data;
            });
    }

    function loadDownloadSubFormatSchedulerDefaults() {
        return $http.get('/Confirm/DownloadFormat/DownloadSubFormatSchedulerDefault/' + $scope.current.item.id, { trackerMsg: 'Loading download sub format scheduler default', ignoreExceptions: [404] })
            .then(function (response) {
                if (response.data != null) {
                    $scope.downloadSubFormatSchedulerDefaults = response.data;

                }
            });
    }

    function loadSchedulerNotificationGroups() {
        return $http.get("/Scheduler/NotificationGroup", { trackerMsg: "Loading Scheduler Notification Groups" })
            .then(function (response) {
                $scope.current.notificationGroups = response.data;
            });

    }

    function changeSubType() {
        $scope.validateAll();
        if ($scope.errors.length != 0) {
            // We have issues on the current screen, don't let the user switch off unless they want to close the whole thing
            $scope.current.selectedDownloadFormatSubType = $scope.previousSelectedDownloadFormatSubType;
            $scope.errors.push({ type: 'error', title: 'Fix other errors', msg: ' Cannot change subtypes until errors are resolved!', showAllowClose: true })
        }
        else {
            $scope.previousSelectedDownloadFormatSubType = $scope.current.selectedDownloadFormatSubType;

            if ($scope.current.selectedDownloadFormatSubType != null && $scope.downloadSubFormatSchedulerDefaults) {
                var subTypeId = $scope.current.selectedDownloadFormatSubType.id;

                let subTypeSchedulerDefaultSelected = $scope.downloadSubFormatSchedulerDefaults.where(c => c.downloadFormatSubTypeId == subTypeId);
                var subtypeCount = subTypeSchedulerDefaultSelected?.count();

                // Only 1 row, this is the main row that should not be a cost basis row
                if (subtypeCount == 1) {
                    var selected = subTypeSchedulerDefaultSelected?.first();
                    if (selected) {
                        if (selected.isCostBasis) {
                            $scope.errors.push({ type: 'error', title: 'CostBasis Data Mismatch', msg: ' Current job is set to cost basis but no cost basis rows were found!', showAllowClose: true });
                        }
                        $scope.selectedDownloadSubFormatSchedulerDefault = selected;
                        $scope.selectedDownloadSubFormatSchedulerDefault.startTime = new Date(selected.startTime);
                        $scope.selectedDownloadSubFormatSchedulerDefault.endTime = new Date(selected.endTime);
                        $scope.current.shouldCreateCostBasisJob = false;
                    }
                }
                // We have two rows, should be the main row and it's correlated costbasis row
                else if (subtypeCount == 2) {
                    var selected = subTypeSchedulerDefaultSelected.where(c => c.isCostBasis == false)?.first();
                    var costBasis = subTypeSchedulerDefaultSelected.where(c => c.isCostBasis == true)?.first();
                    if (!selected || !costBasis) {
                        $scope.errors.push({ type: 'error', title: 'CostBasis Data Mismatch', msg: ' Found 2 rows with the same subid but they are not the main row and cost basis', showAllowClose: true });
                    }

                    $scope.selectedDownloadSubFormatSchedulerDefault = selected;
                    $scope.selectedDownloadSubFormatSchedulerDefault.startTime = new Date(selected.startTime);
                    $scope.selectedDownloadSubFormatSchedulerDefault.endTime = new Date(selected.endTime);

                    $scope.current.shouldCreateCostBasisJob = true;
                    $scope.selectedCostBasisDownloadSubFormatSchedulerDefault = costBasis;
                    $scope.selectedCostBasisDownloadSubFormatSchedulerDefault.startTime = new Date(costBasis.startTime);
                    $scope.selectedCostBasisDownloadSubFormatSchedulerDefault.endTime = new Date(costBasis.endTime);
                }
                // No items exist, we need to generate a new selected object
                else {
                    $scope.current.shouldCreateCostBasisJob = false;

                    $scope.selectedDownloadSubFormatSchedulerDefault = createEmptyDownloadSubFormatSchedulerDefault(false);
                    $scope.selectedDownloadSubFormatSchedulerDefault.downloadFormatId = $scope.current.item.id;
                    $scope.selectedDownloadSubFormatSchedulerDefault.downloadFormatSubTypeId = subTypeId;

                    $scope.downloadSubFormatSchedulerDefaults.push($scope.selectedDownloadSubFormatSchedulerDefault);
                }
            }
        }
    }

    $scope.createStagingDeleteObject = function (costBasisRow) {
        return {
            downloadFormatId: costBasisRow.downloadFormatId,
            downloadFormatSubTypeId: costBasisRow.downloadFormatSubTypeId,
            isCostBasis: costBasisRow.isCostBasis,
            isFromDB: costBasisRow.isFromDB
        }
    }

    $scope.createStagingDeleteObjectMatchingDto = function (costBasisRowDeleteObject) {
        return {
            downloadFormatId: costBasisRowDeleteObject.downloadFormatId,
            downloadFormatSubTypeId: costBasisRowDeleteObject.downloadFormatSubTypeId,
            isCostBasis: costBasisRowDeleteObject.isCostBasis
        }
    }

    $scope.changeSubType = function () {
        changeSubType();
    }

    $scope.createCostBasisJob = function () {
        // This always triggers before the checkbox gets updated so invert the flag
        if (!$scope.current.shouldCreateCostBasisJob) {

            var newCostBasis = null;

            // If the row already existed we should reload that row in vs. creating a new empty row
            // Usually this should only occur if they spam clicked/unclicked the create button
            var existingCostBasisRows = $scope.downloadSubFormatSchedulerDefaults.findIndex(c => c.downloadFormatId == $scope.current.item.id
                && c.downloadFormatSubTypeId == $scope.current.selectedDownloadFormatSubType.id && c.isCostBasis == true);
            if (existingCostBasisRows != null && existingCostBasisRows >= 0) {
                // Row exists so just use it
                newCostBasis = $scope.downloadSubFormatSchedulerDefaults[existingCostBasisRows];
            }
            else {
                // Create a new row and add it to the full collection for saving
                newCostBasis = createEmptyDownloadSubFormatSchedulerDefault(true);
                newCostBasis.downloadFormatId = $scope.current.item.id;
                newCostBasis.downloadFormatSubTypeId = $scope.current.selectedDownloadFormatSubType.id;

                $scope.downloadSubFormatSchedulerDefaults.push(newCostBasis);
            }

            // If the user has previously already unchecked then rechecked the box we need to remove it from the list to be deleted
            var alreadyDeleteStagedIndex = $scope.stagingDeletes.findIndex(
                c => c.downloadFormatId == newCostBasis.downloadFormatId
                    && c.downloadFormatSubTypeId == newCostBasis.downloadFormatSubTypeId);
            if (alreadyDeleteStagedIndex != null && alreadyDeleteStagedIndex >= 0) {
                $scope.stagingDeletes.splice(alreadyDeleteStagedIndex, 1);
            }

            $scope.selectedCostBasisDownloadSubFormatSchedulerDefault = newCostBasis;
        }
        else if ($scope.selectedCostBasisDownloadSubFormatSchedulerDefault) {
            // Stage that this row needs to be deleted
            $scope.stagingDeletes.push($scope.createStagingDeleteObject($scope.selectedCostBasisDownloadSubFormatSchedulerDefault));
            $scope.selectedCostBasisDownloadSubFormatSchedulerDefault = null;
        }
    }
    $scope.save = function () {
        $scope.errors = [];
        $scope.validateAll();

        if ($scope.errors != null && $scope.errors.length == 0) {
            // We need to not create rows that the user "create cost basis" then decided to uncheck the create cost basis
            var rowsToDeleteNotInDB = $scope.stagingDeletes?.where(c => c.isFromDB == false)
            rowsToDeleteNotInDB.forEach((row) => {
                var indexToRemove = $scope.downloadSubFormatSchedulerDefaults.findIndex(c => c.downloadFormatSubTypeId == row.downloadFormatSubTypeId && c.isCostBasis == true)
                if (indexToRemove != null && indexToRemove >= 0) {
                    $scope.downloadSubFormatSchedulerDefaults.splice(indexToRemove, 1);
                }
            });

            // Update existing and save add new rows
            var saveArgs = { method: "POST", id: "", trackerMsg: "Saving Download Sub Format Scheduler Defaults" };
            $http({ method: saveArgs.method, url: '/Confirm/DownloadFormat/DownloadSubFormatSchedulerDefault/BulkUpdate', data: $scope.downloadSubFormatSchedulerDefaults, trackerMsg: args.trackerMsg })
                .then(function (r)
                {
                    // Nest the delete so entityframework finishes running the updates / inserts before we delete

                    // Delete cost basis rows if they were removed and already are in the DB (otherwise we exclude the delete because it never existed)
                    var rowsToDelete = $scope.stagingDeletes?.where(c => c.isFromDB == true)
                    if (rowsToDelete != null && rowsToDelete.length > 0) {
                        // Remove the isFromDB property to match our dto
                        var rowsToDeleteMatchingDto = rowsToDelete.map((row) => $scope.createStagingDeleteObjectMatchingDto(row));

                        var deleteArgs = { method: "POST", id: "", trackerMsg: "Deleting removed Cost Basis Download Sub Format Scheduler Defaults" };
                        $http({ method: deleteArgs.method, url: '/Confirm/DownloadFormat/DownloadSubFormatSchedulerDefault/DeleteCostBasisRows', data: rowsToDeleteMatchingDto, trackerMsg: args.trackerMsg })
                            .then(function (r) {
                                dialog.close(r.data);
                            });
                    }
                    else {
                        dialog.close(r.data);
                    }
                });
        }
    };

    $scope.validateAll = function () {
        $scope.validate($scope.selectedDownloadSubFormatSchedulerDefault);

        if ($scope.current.shouldCreateCostBasisJob) {
            $scope.validate($scope.selectedCostBasisDownloadSubFormatSchedulerDefault);
        }
    }

    $scope.validate = function (currentObject) {
        if (currentObject) {
            var prefixMessage = ''
            if (currentObject.isCostBasis) {
                prefixMessage = 'CostBasis '
            }

            if (currentObject.frequency === null || !angular.isNumber(currentObject.frequency) || currentObject.frequency <= 0) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'Frequency invalid! ', msg: ' frequency must be a positive number' });
            }

            if (currentObject.sizeOfBatch === null || !angular.isNumber(currentObject.sizeOfBatch) || currentObject.sizeOfBatch <= 0) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'Size of Batch invalid! ', msg: ' size of Batch must be a positive number' });
            }

            if (currentObject.expectedNumberOfFiles === null || !angular.isNumber(currentObject.expectedNumberOfFiles)) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'Expected Number of Files invalid! ', msg: ' expected Number of Files must be a number' });
            }

            currentObject.endTime.setDate(currentObject.startTime.getDate());
            currentObject.endTime.setMonth(currentObject.startTime.getMonth());
            currentObject.endTime.setYear(currentObject.startTime.getFullYear());

            if (!currentObject.startTime || !currentObject.endTime) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'Invalid times! ', msg: ' start time and end time must be set' });
            }
            else if (currentObject.startTime.getTime() >= currentObject.endTime.getTime()) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'Invalid end time! ', msg: ' start time must be before end time' });
            }

            if (currentObject.isAltSchedule === null) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'IsAltSchedule invalid! ', msg: ' isAltSchedule must be set' });
            }

            if (currentObject.notifyOnSuccess === null) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'NotifyOnSuccess invalid! ', msg: ' notifyOnSuccess must be set' });
            }

            if (currentObject.active === null) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'Active invalid! ', msg: ' active must be set' });
            }

            if (currentObject.priorityJob === null) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'PriorityJob invalid! ', msg: ' priorityJob must be set' });
            }

            if (currentObject.interval === null) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'Interval invalid! ', msg: ' interval must be set' });
            }

            if (currentObject.offset === null) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'Offset invalid! ', msg: ' offset must be set' });
            }

            if (currentObject.offsetInterval === null) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'OffsetInterval invalid! ', msg: ' offsetInterval must be set' });
            }

            if (currentObject.runDays === null) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'RunDays invalid! ', msg: ' runDays must be set' });
            }

            if (!currentObject.schedulerTypeName) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'SchedulerTypeName invalid! ', msg: ' schedulerTypeName must be set' });
            }
            else {
                if (currentObject.schedulerTypeName == 'FileWatcherScheduler') {
                    if (currentObject.filePath === null) {
                        $scope.errors.push({ type: 'error', title: prefixMessage + 'FileWatcherScheduler invalid! ', msg: ' schedulerTypeName of FileWatcherScheduler requires filePath must be set' });
                    }
                }

                if (currentObject.schedulerTypeName == 'FolderWatcherScheduler' || currentObject.schedulerTypeName == 'S3FolderWatcherScheduler') {
                    if (currentObject.folderPath === null) {
                        $scope.errors.push({ type: 'error', title: prefixMessage + 'FolderPath invalid! ', msg: ' folderPath must be set' });
                    }
                    if (currentObject.searchPattern === null) {
                        $scope.errors.push({ type: 'error', title: prefixMessage + 'SearchPattern invalid! ', msg: ' searchPattern must be set' });
                    }
                    if (currentObject.searchOption === null) {
                        $scope.errors.push({ type: 'error', title: prefixMessage + 'SearchOption invalid! ', msg: ' searchOption must be set' });
                    }
                }
            }

            if (currentObject.importFiles === null) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'ImportFiles invalid! ', msg: ' importFiles must be set' });
            }

            if (currentObject.applyPriceAndSecurity === null) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'ApplyPriceAndSecurity invalid! ', msg: ' applyPriceAndSecurity must be set' });
            }

            if (currentObject.numberOfThreads === null) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'Number of Threads invalid! ', msg: ' number of Threads must be set' });
            }
            else if (!angular.isNumber(currentObject.numberOfThreads) && currentObject.numberOfThreads > 0) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'Number of Threads invalid! ', msg: ' number of Threads must be a positive number' });
            }

            if (currentObject.useAlternateFilePattern === null) {
                $scope.errors.push({ type: 'error', title: prefixMessage + 'Use Alternate File Pattern invalid! ', msg: ' Use Alternate File Pattern must be set' });
            }
        }
    }

    function getIdFromArgs() {
        return parseInt(args.item) || parseInt(args.item.id) || 0;
    }

    $scope.errors = [];

    init();
});
'use strict';

app.controller('ConfirmationSourceListCtrl', function ConfirmationSourceListCtrl($scope, $http, $oasRights, views, $dialog, ConfirmationOverview, $timeout) {

    // PRIVATE VARIABLES


    // PRIVATE METHODS
    function init( ) {
        $http.get("/Confirm/DownloadSources/Verbose", {trackerMsg: "Loading formats"})
            .then(function (response) {
                $scope.sources = response.data;
            });
    }


    // PUBLIC METHODS
    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1) $scope.openEditor( $scope.selected );
    };

    $scope.openEditor = function( item ) {
        return $dialog.editor('confirmation/editors/views/confirmation-source-edit.html', 'ConfirmationSourceEditCtrl', {args: function () {
                return {
                    item: item || {},
                    defaultTab: {name: "General", active: true, code: "general"}
                };
            }}).open().then(function ( result ) {
                if( result ) {
                    $scope.refreshGrid();
                }
            });
    };

    $scope.deleteItems = function () {
        return ConfirmationOverview.sources.deleteMany({data: $scope.selectedIds}).then(function(items){
            $scope.refreshGrid();
        })
    };

    $scope.goToSourceLogs = function() {
        ConfirmationOverview.goTo.sourceLogs($scope.selected);
    };

    $scope.refreshGrid = function( ) {
        $timeout(function() {
            $scope.$broadcast('event:confirm-download-source-action', {action: 'refresh-grid'});
        });
    };

    $scope.views = views;
    // INITIALIZE
    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick
    };

    $scope.rights = {
        downloadSources: $oasRights.forCode("DOWNLOADSOURCES")
    };

    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: {get: function() {return $scope.selectedItems.map('id')}},
        selected: {get: function() {return $scope.selectedItems[0] || $scope.current.item;}}
    });

    // WATCHES

    $scope.$on('event:confirm-download-source-select', function(e, args) {
        $scope.selectedItems = args;
    });

    init( );
});
'use strict';

app.controller('ConfirmationSleeveSettingListCtrl', function ConfirmationSleeveSettingListCtrl($scope, $http) {

    function init() {
        loadRules();
        var loadPromises = [loadUserSleeveRules, loadUserJournalRules ];

        Promise.all(loadPromises).then((values) =>
        {
            $scope.current.settingGroups.push(
                {
                    title: 'Sleeve Rules',
                    idName: 'IsSleeveRule',
                    idValue: true,
                    settings: $scope.current.userSleeveRules
                },
                {
                    title: 'Journal Rules',
                    idName: 'IsSleeveRule',
                    idValue: false,
                    settings: $scope.current.userJournalRules
                });
        });
    }

    var loadUserSleeveRules = new Promise((resolve) => {
        $http.get("/Settings/Database/EntityOptions/Code/SLEEVERULES").then((response) => {
            var values = JSON.parse(response.data.value);
            $scope.current.saveData = response.data;
            $scope.current.userSleeveRules = [];
            values.forEach((userSleeveRule) => {
                if (userSleeveRule.ParameterSet === null || userSleeveRule.ParameterSet === undefined) {
                    userSleeveRule.ParameterSet = [];
                }
                userSleeveRule.RuleID = userSleeveRule.RuleID.toString();
                $scope.current.userSleeveRules.push(userSleeveRule);
            });

            let lowestRunOrder = Math.min(...$scope.current.userSleeveRules.map(item => item.RunOrder));
            $scope.selectUserSleeveRule(lowestRunOrder); //initially pass the lowest run order
            resolve();
        });
    });

    var loadUserJournalRules = new Promise((resolve)=> {
        $http.get("/Settings/Database/EntityOptions/Code/SLEEVEJRULES").then((response) => {
            var values = JSON.parse(response.data.value);
            $scope.current.userJournalRules = [];
            $scope.current.journalSaveData = response.data;

            values.forEach((userJournalRule) => {
                if (userJournalRule.ParameterSet === null || userJournalRule.ParameterSet === undefined) {
                    userJournalRule.ParameterSet = [];
                }

                userJournalRule.RuleID = userJournalRule.RuleID.toString();
                $scope.current.userJournalRules.push(userJournalRule);
            });

            resolve();
        });
    });

    function loadRules() {
        $http.get("/Confirm/SleeveSettings").then((response) => {
            $scope.current.rules = JSON.parse(response.data);
            $scope.current.rules.forEach((rule) => {
                rule.config = JSON.parse(rule.ConfigJson);
            });
        });
    };


    $scope.current = {
        rules: [],
        userSleeveRulesByRunOrder: [],
        selectedUserSleeveRule: null,
        editNameEnabled: false,
        userSleeveRules: [],
        menuDropDownEnabled: false,
        userSleeveRuleSearch: {},
        settingGroups: [],
        privilegeCode: "SLEEVESETTINGS"
    };

    $scope.selectUserSleeveRule = (runOrder) => {
        $scope.current.selectedUserSleeveRule = $scope.current.userSleeveRules.find(userSleeveRule => userSleeveRule.RunOrder === runOrder);
        $scope.current.isJournalSelected = false;
        $scope.current.selectedRuleID = $scope.current.selectedUserSleeveRule.RuleID;
    };

    $scope.toggleEditName = () => {
        $scope.current.editNameEnabled = !$scope.current.editNameEnabled;
    };

    $scope.deleteSleeveRule = () => {
        $scope.current.selectedUserSleeveRule;

        var rule = $scope.current.rules.find(rule => rule.Id == $scope.current.selectedUserSleeveRule.RuleID);
        if (rule.config.IsSleeveRule) {
            removeSleeveRule(0);
        }
        else {
            removeSleeveRule(1);
        }
    };
    function removeSleeveRule(indexInSettingGroup) {
        //Remove Rule
        var index = $scope.current.settingGroups[indexInSettingGroup].settings.findIndex(setting => setting.RunOrder == $scope.current.selectedUserSleeveRule.RunOrder);
        $scope.current.settingGroups[indexInSettingGroup].settings.splice(index, 1)[0];
        delete $scope.current.selectedUserSleeveRule;
        //Reassign run order sequentially while delete/removal a rule
        $scope.current.settingGroups[indexInSettingGroup].settings = reassigRunOrder($scope.current.settingGroups[indexInSettingGroup].settings);
    }

    function reassigRunOrder(array) { //Reassign run order sequentially
        angular.forEach(array,function(item, index){
            item.RunOrder = index + 1;
        });
        return array;
    }

    $scope.saveAllChanges = () => {
        var requestObj = {};
        var journalRules = [];
        var allocationRules = [];

        $scope.current.settingGroups.forEach((settingGroup) => {
            settingGroup.settings.forEach((setting) => {
                if (setting != null && settingGroup.title == 'Sleeve Rules')
                {
                    allocationRules.push(setting);
                }
                else if (setting != null && settingGroup.title == 'Journal Rules')
                {
                    journalRules.push(setting);
                }
            });
        });
        
        requestObj.journalRules = angular.toJson(journalRules);
        requestObj.allocationRules = angular.toJson(allocationRules);
        requestObj.allocationUserDefinedID = $scope.current.saveData.userDefineDataId;
        requestObj.journalUserDefinedID = $scope.current.journalSaveData.userDefineDataId;
        $http.put('/Confirm/SleeveSettings/Save', requestObj, { trackerMsg: 'Saving All Data' });
    };

    init();
});


'use strict';

app.controller('ConfirmationPositionProcessesListCtrl', function ConfirmationPositionProcessesListCtrl($scope, $http, $oasRights, views, $dialog, ConfirmationOverview, $timeout) {

    function init() {
        
        loadRules();
        loadPositionRules();
    }

    function loadPositionRules() {
        $http.get("/Settings/Database/EntityOptions/Code/POSITONRULES").then((response) => {
            var values = JSON.parse(response.data.value);
            $scope.current.saveData = response.data;
            $scope.current.processRules = [];
            values.forEach((processRule) => {
                if (processRule.ParameterSet === null || processRule.ParameterSet === undefined) {
                    processRule.ParameterSet = [];
                }
                processRule.RuleID = processRule.RuleID.toString();
                $scope.current.processRules.push(processRule);
            });
            $scope.selectProcessRule(1);

            $scope.current.settingGroups = [{
                title: 'Position Processes',
                settings: $scope.current.processRules
            }];
        });
    };

    function loadRules() {
        $http.get("/Confirm/DownloadPositionProcess").then((response) => {
            $scope.current.rules = JSON.parse(response.data);
            $scope.current.rules.forEach((rule) => {
                rule.config = JSON.parse(rule.ConfigJson);
            });
        });
    };


    $scope.current = {
        rules: [],
        processRulesByRunOrder: [],
        selectedProcessRule: null,
        editNameEnabled: false,
        processRules: [],
        menuDropDownEnabled: false,
        processRuleSearch: {},
        privilegeCode: "POSITIONPROCESSES"
    };

    $scope.selectProcessRule = (runOrder) => {
        if ($scope.current.processRules !== null && $scope.current.processRules !== undefined && $scope.current.processRules.length > 0) {
            $scope.current.selectedProcessRule = $scope.current.processRules.find(processRule => processRule.RunOrder === runOrder);
            $scope.current.selectedRuleID = $scope.current.selectedProcessRule.RuleID;
        }
    };

    $scope.deleteProcessRule = () => {
            var processRuleIndexToDelete = $scope.current.processRules.findIndex(processRule => processRule.RunOrder === $scope.current.selectedProcessRule.RunOrder);
        $scope.current.processRules.splice(processRuleIndexToDelete, 1);
            var runOrderRemoved = $scope.current.selectedProcessRule.RunOrder;
            delete $scope.current.selectedProcessRule;

        $scope.current.processRules.forEach((processRule) => {
                if (processRule.RunOrder > runOrderRemoved) {
                    processRule.RunOrder--;
                }
        });

        $scope.current.settingGroups[0].settings = $scope.current.processRules;
    };

    $scope.saveAllChanges = () => {
        var requestObj = {};
        var processRulesToSave = [];

        $scope.current.settingGroups[0].settings.forEach((processRule) => {
            if (processRule != null) {
                processRulesToSave.push(processRule);
            }
        });

        requestObj.PositionPostVerifyRules = angular.toJson(processRulesToSave);
        requestObj.PositionPostVerifyUserDefinedID = $scope.current.saveData.userDefineDataId;
        $http.put('/Confirm/DownloadPositionProcess/Save', requestObj, { trackerMsg: 'Saving All Data' })
            .then((response) => {
                $scope.current.saveData.userDefineDataId = response.data;
            });
    };

    init();
});


'use strict';

app.controller('ConfirmationScrubAutomationListCtrl', function ConfirmationScrubAutomationListCtrl($scope, $http) {

    function init() {
        
        loadRules();
        loadPositionRules();
    }

    function loadPositionRules() {
        $http.get("/Settings/Database/EntityOptions/Code/AUTOSCRUBRULES").then((response) => {
            var values = JSON.parse(response.data.value);
            $scope.current.saveData = response.data;
            $scope.current.processRules = [];
            values.forEach((automationRule) => {
                if (automationRule.ParameterSet === null || automationRule.ParameterSet === undefined) {
                    automationRule.ParameterSet = [];
                }
                automationRule.RuleID = automationRule.RuleID.toString();
                $scope.current.automationRules.push(automationRule);
            });
            $scope.selectAutomationRule(1);

            $scope.current.settingGroups = [{
                title: 'Scrub Rules',
                settings: $scope.current.automationRules
            }];
        });
    };

    function loadRules() {
        $http.get("/Confirm/DownloadScrubAutomation").then((response) => {
            $scope.current.rules = JSON.parse(response.data);
            $scope.current.rules.forEach((rule) => {
                rule.config = JSON.parse(rule.ConfigJson);
            });
        });
    };


    $scope.current = {
        rules: [],
        automationRulesByRunOrder: [],
        selectedAutomationRule: null,
        editNameEnabled: false,
        automationRules: [],
        menuDropDownEnabled: false,
        privilegeCode: "AUTOSCRUBRULES"
    };

    $scope.selectAutomationRule = (runOrder) => {
        if ($scope.current.automationRules !== null && $scope.current.automationRules !== undefined && $scope.current.automationRules.length > 0) {
            $scope.current.selectedAutomationRule = $scope.current.automationRules.find(automationRule => automationRule.RunOrder === runOrder);
            $scope.current.selectedRuleID = $scope.current.selectedAutomationRule.RuleID;
        }
    };

    $scope.deleteAutomationRule = () => {
        var automationRuleIndexToDelete = $scope.current.automationRules.findIndex(automationRule => automationRule.RunOrder === $scope.current.selectedAutomationRule.RunOrder);
        $scope.current.automationRules.splice(automationRuleIndexToDelete, 1);
            var runOrderRemoved = $scope.current.selectedAutomationRule.RunOrder;
            delete $scope.current.selectedAutomationRule;

        $scope.current.automationRules.forEach((automationRule) => {
            if (automationRule.RunOrder > runOrderRemoved) {
                automationRule.RunOrder--;
                }
            });
        $scope.current.settingGroups[0].settings = $scope.current.automationRules;
    };

    $scope.saveAllChanges = () => {
        var requestObj = {};
        var automationRulesToSave = [];

        $scope.current.settingGroups[0].settings.forEach((automationRule) => {
            if (automationRule != null) {
                automationRulesToSave.push(automationRule);
            }
        });

        requestObj.ScrubAutomationRules = angular.toJson(automationRulesToSave);
        requestObj.ScrubAutomationUserDefinedDataID = $scope.current.saveData.userDefineDataId;
        $http.put('/Confirm/DownloadScrubAutomation/Save', requestObj, { trackerMsg: 'Saving All Data' })
            .then((response) => {
                $scope.current.saveData.userDefineDataId = response.data;
            });
    };

    init();
});


'use strict';

app.controller('ConfirmationSourceScheduleLogListCtrl', function ConfirmationSourceScheduleLogListCtrl($scope, $http, $oasRights, views, $dialog, $route, $timeout) {

    // PRIVATE VARIABLES


    // PRIVATE METHODS
    function init( ) {
        $http.get("/Confirm/DownloadSources/Verbose", {trackerMsg: "Loading formats"})
            .then(function (response) {
                $scope.sources = response.data;
            });
    }

    function saveFormat( format ) {
        $http.put('/Confirm/DownloadFormats/' + format.id, format, {trackerMsg: 'Saving ' +  format.formatName})
            .then(function () {
                format.isDirty = false;
            });
    }


    // PUBLIC METHODS
    $scope.saveFormats = function( ) {
        for( var i = 0; i < $scope.formats.length; i++ ) {
            if( $scope.formats[i].isDirty ) {
                saveFormat( $scope.formats[i] );
            }
        }
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1) $scope.openSourceEditor(false);
    };

    $scope.openSourceEditor = function( ) {
        return $dialog.editor('confirmation/editors/views/confirmation-source-edit.html', 'ConfirmationSourceEditCtrl', {args: function () {
                return {
                    item: $scope.selected,
                    defaultTab: {name: "General", active: true, code: "general"}
                };
            }}).open().then(function (rslt) {
                if( rslt ) {
                    $scope.$broadcast( 'event:confirm-download-file-action', { action: 'update-item', item: rslt } );
                }
            });
    };

    $scope.refreshGrid = function( ) {
        $timeout(function() {
            $scope.$broadcast('event:confirm-download-source-action', {action: 'refresh-grid'});
        });
    };

    $scope.views = views;
    // INITIALIZE
    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        grid: {
            load: "/confirm/downloadsources/schedules/logs/messages",
            param: {
                startDate: null,
                endDate: null,
                downloadSourceId: parseInt($route.current.params.downloadSourceId) || null
            }
        }
    };

    $scope.rights = {
        downloadFormats: $oasRights.forCode("DOWNLOADFORMATS")
    };

    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: {get: function() {return $scope.selectedItems.map('id')}},
        selected: {get: function() {return $scope.selectedItems[0] || $scope.current.item;}}
    });

    // WATCHES

    $scope.$on('event:confirm-download-source-select', function(e, args) {
        if(args.length) $scope.selectedItems = args;
    });

    init( );
});
'use strict';

app.controller('ConfirmationSourceEditCtrl', function ConfirmationSourceEditCtrl($scope, $http, $oasRights, $timeout, $dialog, dialog, args, $confirmation, $q, ConfirmationOverview, accountCreation, patternMatchType, confirmTransmitMethod, positionOnlyReconcile, splitIoService, $confirmDownloadOptionService) {

    // PRIVATE VARIABLES
    var itemOriginal = null;
    var editorHotKeys;

    // PRIVATE METHODS - INIT
    function init() {
        loadItem();
        loadDownloadFormats();
        loadReps()
        loadServiceTeams();
        loadParentDownloadSources();
        buildMenu();
        loadHotKeys();
        $scope.loadTab(args.defaultTab);
        splitIoService.getBoolTreatment('recon_confirm_source_schedule_j4184').subscribe((isEnabled) => {
            $scope.downloadsourceFormatCheckFeatureFlag = isEnabled;
        });
        $scope.current.isSaving = false;
    }

    function loadDownloadSourceDefaults(downloadFormatId, resolve) {
        $http.get("/Confirm/DownloadFormatSourceDefault/Subtypes/" + downloadFormatId).then((result) => {
            $scope.current.SubTypes = result.data;
            $scope.current.hasSchedules = false;
            loadDownloadSubFormatSchedulerDefault(downloadFormatId).then((schedulerResult) => {
                $scope.current.Schedules = schedulerResult.data;
                if ($scope.current.Schedules != null && $scope.current.Schedules.length > 0 && $scope.current.item.id == 0 && $scope.downloadsourceFormatCheckFeatureFlag == true) {
                    // Make sure that subformat allows schedules
                    for (var i = 0; i < $scope.current.Schedules.length; i++) {
                        if ($scope.current.Schedules[i].downloadFormatSubTypeId == $scope.current.selectedSubType) {
                            $scope.current.hasSchedules = true;
                            break;
                        }
                    }
                    if ($scope.current.hasSchedules == true) {
                        $scope.current.item.portfolio.isCreateJobSchedule = true;
                    }
                }
                resolve();
            });
        });
    }
    function loadDownloadSubFormatSchedulerDefault(downloadFormatId) {
        return $http.get("/Confirm/DownloadFormat/DownloadSubFormatSchedulerDefault/" + downloadFormatId);
    }
    function loadServiceTeams() {
        return $q.all({
            teams: $http.get("/Global/ServiceTeams?teamType=ReconTeam"),
            members: $http.get("/Global/ServiceTeamMembers")
        }).then(function (response) {
            angular.extend($scope.current.options.team, response.teams.data);
            angular.extend($scope.current.options.teamMember, response.members.data);
        });
    }

    function loadParentDownloadSources() {
        return $http.get("/Confirm/DownloadSources/Simple").then(function (response) {
            var allSources = response.data || [];
            var currentItemId = $scope.current.item && $scope.current.item.id ? $scope.current.item.id : 0;
            // Filter out the current download source if editing an existing one
            $scope.current.options.parentDownloadSources = allSources.filter(function (source) {
                return source.id !== currentItemId;
            });
        });
    }

    function loadDownloadFormats() {
        return ConfirmationOverview.confirm.getDownloadFormats().then(function (response) {
            angular.extend($scope.current.options.downloadFormat, response.data);
        });
    }

    function loadReps() {
        $http.get("/Portfolio/Representatives/Simple").then((resolve) => {
            $scope.current.reps = resolve.data;
        });
    }

    function loadDownloadFormat(downloadFormatId, subtypeId) {
        let url = "/Confirm/DownloadFormats/Verbose/" + downloadFormatId;
        let config = {};

        if (subtypeId !== null && subtypeId !== 0) {
            // Add expand parameter for subtype and pass subtypeId
            config = { params: { expand: 'downloadFormatSubType', subtypeId: subtypeId } };
        }

        return $http.get(url, config).then((result) => {
            // If API returns all subtypes, filter client-side
            if (subtypeId !== null && subtypeId !== 0 && Array.isArray(result.data.downloadFormatSubTypes)) {
                const subType = result.data.downloadFormatSubTypes.find(st => st.id === subtypeId);
                $scope.current.formatOptions = subType ? subType.downloadFormatConfigJSON : null;
            } else {
                // Fallback: use the main config if no subtypeId or default subtype
                $scope.current.formatOptions = result.data.downloadFormat.downloadFormatConfigJSON;
            }
        });
    }

    function loadItem(downloadFormatId, subtypeId) {
        return ($scope.current.item.id > 0
            ? ConfirmationOverview.sources.getVerbose({ params: { id: $scope.current.item.id, expand: 'all' } })
            : ConfirmationOverview.sources.newVerbose({ params: { expand: 'all', downloadFormatId: downloadFormatId, subtypeId: subtypeId } })
        ).then(function (response) {
            response.data.portfolio.reconTargetTime = resolveReconTargetTime(response.data.portfolio.reconTargetTime);
            response.data.schedules.each(function (s) {
                s.time = Date.create(s.time);
                s.scheduleConfiguration = JSON.parse(s.scheduleConfiguration);
            });
            angular.extend($scope.current.item, response.data);
            itemOriginal = angular.copy($scope.current.item);

            $scope.current.normalDefaultOptions = [];
            $scope.current.groupedOptions = [];
            if ($scope.current.item.portfolio.downloadSourceOptionJSON) {
                $scope.current.item.portfolio.options = JSON.parse($scope.current.item.portfolio.downloadSourceOptionJSON);
                $scope.current.item.portfolio.options.forEach(option => {
                    option = $confirmDownloadOptionService.parseOption(option);

                    if (option.LabelGroup == null || option.LabelGroup == "") {
                        $scope.current.normalDefaultOptions.push(option);
                    } else {
                        $scope.current.groupedOptions[option.Code] = option;
                    }
                });
            }

            $scope.current.downloadFormatId = $scope.current.item.portfolio.downloadFormatId;
            $scope.current.selectedSubType = $scope.current.item.portfolio.downloadFormatSubTypeId;
            $http.get("/Authorization/User/Databases?filterForCotenant=true").then((result) => {
                $scope.current.options.alClients = result.data;
                $scope.current.options.alClients.push({ id: null, clientName: "N/A" });

                if (!$scope.current.options.alClients.map(client => client.id).includes($scope.current.item.portfolio.alClientId)) {
                    $scope.current.options.alClients.push({ id: $scope.current.item.portfolio.alClientId, clientName: "Unknown" });
                }
            });

            var promise = new Promise((resolve) => {
                if (downloadFormatId) {
                    loadDownloadSourceDefaults(downloadFormatId, resolve);
                    loadDownloadFormat(downloadFormatId, $scope.current.selectedSubType);
                } else if ($scope.current.downloadFormatId != null && $scope.current.downloadFormatId > 0) {
                    loadDownloadSourceDefaults($scope.current.downloadFormatId, resolve);
                    loadDownloadFormat($scope.current.downloadFormatId, $scope.current.selectedSubType);
                }
            });
            promise.then(() => { });

            if (downloadFormatId) {
                itemOriginal.portfolio.downloadFormatId = null;
            }
        });
    }

    function resolveReconTargetTime(reconTargetTime) {
        if (reconTargetTime == null) {
            let date = new Date();
            date.setHours(10, 0, 0, 0);
            return date;
        }

        let tIndex = reconTargetTime.lastIndexOf("T");
        let dateString = reconTargetTime.substring(0, tIndex);
        let timeString = reconTargetTime.substring(tIndex, reconTargetTime.length);

        let indexOfPosOffset = timeString.lastIndexOf("+");
        let indexOfNegoffset = timeString.lastIndexOf("-");
        let strippedOutTimeZone = null;

        if (indexOfNegoffset !== -1) {
            strippedOutTimeZone = timeString.substring(0, indexOfNegoffset);
        }
        else {
            strippedOutTimeZone = timeString.substring(0, indexOfPosOffset);
        }
        let date = new Date(dateString + strippedOutTimeZone);
        return date;
    }

    function buildMenu() {
        $scope.menu = { categories: [] };
        $scope.menu.categories.push({ name: 'General', children: [] });
        $scope.menu.categories[0].children.push({ name: 'General', active: false, code: 'general' });
        $scope.menu.categories[0].children.push({ name: 'Options', active: false, code: 'options' });
        $scope.menu.categories[0].children.push({ name: 'Defaults', active: false, code: 'defaults' });
        $scope.menu.categories[0].children.push({ name: 'Schedules', active: false, code: 'schedules' });
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                { combo: 'ALT+S', command: $scope.save },
                { combo: 'ALT+X', command: function () { $scope.close(true); } }
            ]);
        });
    }

    function showReportableWarning(callback) {
        var buttons = [
            {
                result: true,
                label: 'Continue',
                cssClass: 'btn-primary'
            },
            {
                result: false,
                label: 'Cancel',
                cssClass: 'pull-left'
            }
        ];
        $dialog
            .messageBox(
                'Warning',
                'By selecting this option, accounts created with these defaults '
                + 'will not be counted toward ADV and 13F totals.',
                buttons)
            .open()
            .then(callback);
    }

    // PUBLIC METHODS
    $scope.changeSubType = () => {

        if ($scope.current.selectedSubType === $scope.current.item.portfolio.downloadFormatSubTypeId) return;
        if ($scope.current.item.id > 0) {
            $scope.current.item.portfolio.downloadFormatSubTypeId = $scope.current.selectedSubType;
            loadDownloadFormat($scope.current.downloadFormatId, $scope.current.selectedSubType);
        } else {
            $dialog.confirmAction("This action will reset your progress.  Do you wish to continue?")
                .open().then(function (result) {
                    if (result === 'yes') loadItem($scope.current.downloadFormatId, $scope.current.selectedSubType);

                });
        }
    };

    $scope.loadTab = function (child) {
        new Promise((resolve) => {
            $scope.menu.categories.each(function (c) {
                c.children.each(function (ch) {
                    ch.active = ch.code === child.code;
                });
            });

            $scope.current.selectedTab = child.code;
            resolve();
        })
            .then(() => {
                if ($scope.current.selectedTab == "options") {
                    Object.keys($scope.current.groupedOptions).forEach((optionCode) => {
                        var option = $scope.current.groupedOptions[optionCode];
                        var label = document.createElement("label");
                        label.classList.add(option.Type);
                        label.innerText = option.Name;
                        if (option.Type == "checkbox") {
                            var inputElement = document.createElement("input");
                            inputElement.setAttribute("type", option.Type);
                            inputElement.id = option.Code;
                            inputElement.checked = option.Value == "true" || option.Value == true;
                            label.append(inputElement);
                            inputElement.onchange = handleGroupedOptionUpdate;
                        }
                        $("#" + option.LabelGroup)[0].append(label);
                    });
                }
            });
    };

    function handleGroupedOptionUpdate(e) {
        $scope.current.groupedOptions[e.target.id].Value = $("#" + e.target.id).is(":checked");
    }

    $scope.goToLogs = function () {
        return $q.resolve(
            !angular.equals(itemOriginal, $scope.current.item) ? $dialog.confirmNavigation("Do you want to save your changes before navigating?").open() : 'no'
        ).then(function (option) {
            switch (option) {
                case 'yes': return save().then(function (item) { return item.id; });
                case 'no': return $scope.current.item.id;
                default: return $q.reject();
            }
        }).then(ConfirmationOverview.goTo.sourceLogs).then($scope.close);
    };

    $scope.addSchedule = function () {
        var schedule = {
            skipHolidays: true,
            time: null,
            scheduleConfiguration: JSON.parse('{"Calendar":{"CalendarOptions":{"displayName":"Skip Holidays","value":true,"sortOrder":0,"inputType":"checkbox"},"DayOfWeekOptions":[{"displayName":"Sunday","value":false,"sortOrder":1,"inputType":"checkbox"},{"displayName":"Monday","value":true,"sortOrder":2,"inputType":"checkbox"},{"displayName":"Tuesday","value":true,"sortOrder":3,"inputType":"checkbox"},{"displayName":"Wednesday","value":true,"sortOrder":4,"inputType":"checkbox"},{"displayName":"Thursday","value":true,"sortOrder":5,"inputType":"checkbox"},{"displayName":"Friday","value":true,"sortOrder":6,"inputType":"checkbox"},{"displayName":"Saturday","value":false,"sortOrder":7,"inputType":"checkbox"}]},"Verify/Apply":[{"displayName":"Verify Name","value":true,"sortOrder":0,"inputType":"checkbox"},{"displayName":"Apply Name","value":true,"sortOrder":1,"inputType":"checkbox"},{"displayName":"Verify Position","value":true,"sortOrder":2,"inputType":"checkbox"},{"displayName":"Apply Position","value":true,"sortOrder":3,"inputType":"checkbox"},{"displayName":"Verify Price","value":true,"sortOrder":4,"inputType":"checkbox"},{"displayName":"Apply Price","value":true,"sortOrder":5,"inputType":"checkbox"},{"displayName":"Verify Security","value":true,"sortOrder":6,"inputType":"checkbox"},{"displayName":"Apply Security","value":true,"sortOrder":7,"inputType":"checkbox"},{"displayName":"Verify Transaction","value":true,"sortOrder":8,"inputType":"checkbox"},{"displayName":"Apply Transaction","value":true,"sortOrder":9,"inputType":"checkbox"},{"displayName": "Verify Cost Basis","value": true,"sortOrder": 10,"inputType": "checkbox"},{"displayName": "Apply Cost Basis","value": true,"sortOrder": 11,"inputType": "checkbox"},{"displayName":"Link All Accounts","value":false,"sortOrder":12,"inputType":"checkbox"}]}')

        };
        $scope.current.item.schedules.unshift(schedule)
    };

    $scope.removeSchedule = function (schedule) {
        $dialog.confirmAction("Do you want to remove this schedule?")
            .open().then(function (result) {
                if (result === 'yes') {
                    $scope.current.item.schedules.remove(schedule)
                }
            });
    };

    $scope.save = function () {
        $scope.current.item.portfolio.options = $scope.current.normalDefaultOptions;
        var codes = $scope.current.item.portfolio.options.map(q => q.Code);

        Object.keys($scope.current.groupedOptions).forEach((optionCode) => {
            if (!codes.includes(optionCode)) {
                $scope.current.item.portfolio.options.push($scope.current.groupedOptions[optionCode]);
            }
        });

        $scope.current.groupedOptions

        if (!angular.equals(itemOriginal, $scope.current.item)) {
            var item = angular.copy($scope.current.item);
            item.schedules.each(function (s) {
                s.time = s.time.format("{HH}:{mm}:{ss}");
                s.scheduleConfiguration = angular.toJson(s.scheduleConfiguration);
            });

            item.portfolio.reconTargetTime = item.portfolio.reconTargetTime.toLocaleString();

            if (item.portfolio.options) {
                item.portfolio.options.forEach(option => {
                    option = $confirmDownloadOptionService.serializeOption(option);
                });

                item.portfolio.DownloadSourceOptionJSON = angular.toJson(item.portfolio.options);
            }
            
            return ($scope.current.item.id > 0
                ? ConfirmationOverview.sources.saveVerbose({
                    params: { id: item.id },
                    data: item
                })
                : ConfirmationOverview.sources.createVerbose({
                    data: item
                })).then(function (response) {
                    editorHotKeys.destroy();
                    dialog.close(response.data);
                }).catch(function (error) {
                    $scope.current.isSaving = false;
                });
        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };

    $scope.close = function (validate) {
        if (validate) {
            if (!angular.equals(itemOriginal, $scope.current.item)) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };

    $scope.changeFormat = function () {
        if ($scope.current.downloadFormatId === $scope.current.item.portfolio.downloadFormatId) return;
        if ($scope.current.item.id > 0) {
            $scope.current.item.portfolio.downloadFormatId = $scope.current.downloadFormatId;
            $scope.current.selectedSubType = 0; // Reset the form's subtype value as well
            loadDownloadFormat($scope.current.downloadFormatId, $scope.current.selectedSubType);
        }
        else {
            $dialog.confirmAction("This action will reset your progress.  Do you wish to continue?")
                .open().then(function (result) {
                    if (result === 'yes') {
                        $scope.current.Schedules = null;
                        loadItem($scope.current.downloadFormatId);
                        $scope.current.item.portfolio.subtypeId = 0;
                        loadDownloadFormat($scope.current.downloadFormatId, $scope.current.item.portfolio.subtypeId);
                    }
                    else $scope.current.downloadFormatId = $scope.current.item.portfolio.downloadFormatId;
                });
        }
    };

    $scope.checkReportableFields = function (auaReportableHasChanged) {
        var defaults = $scope.current.item.defaults;
        if (!auaReportableHasChanged) {
            defaults.isAuaReportable = false;
        } else if (defaults.isAuaReportable) {
            var portfolio = $scope.current.item.portfolio;
            if (portfolio.thirteenFReportable || portfolio.advReportable) {
                showReportableWarning(function (isConfirmed) {
                    if (isConfirmed) {
                        portfolio.advReportable = false;
                        portfolio.thirteenFReportable = false;
                    } else {
                        defaults.isAuaReportable = false;
                    }
                });
            }
        }
    }

    $scope.uploadedFileStatus = function () {
        if ($scope.current.item.fileUploaded) {
            if ($scope.current.item.fileUploaded.statusCode === 200) {
                $scope.current.item.fileUploaded.statusMessage = "The import was successful";
                return true;
            }
            return false;
        }
    }

    // INITIALIZE
    $scope.current = {
        downloadFormatId: null,
        selectedSubType: null,
        item: {
            id: (parseInt(args.item) || parseInt(args.item.id) || 0),
            fileUploaded: null
        },
        selectedTab: args.defaultTab,
        options: {
            accountCreation: accountCreation.values(),
            transmitMethod: confirmTransmitMethod.values(),
            patternMatchType: patternMatchType.values(),
            positionOnlyReconcile: positionOnlyReconcile.values(),
            team: [],
            teamMember: [],
            downloadFormat: [],
            parentDownloadSources: []
        }
    };

    $scope.rights = {
        downloadSources: $oasRights.forCode("DOWNLOADSOURCES"),
        downloadSourcesPasswords: $oasRights.forCode("DOWNLOADSOURCESPASSWORDS")
    };

    $scope.checkRightsForCode = function (privilegeCode) {
        if (privilegeCode == null) {
            return true;
        }

        var isEditable = $oasRights.forCode(privilegeCode).canUpdate;
        return isEditable;
    }

    $scope.errors = [];

    $scope.runScheduleNow = function () {
        var args = { method: "PUT", id: $scope.current.item.id, trackerMsg: "Updating NextScheduledRunDate so it will be picked up by the next hangfire job" };

        if ($scope.errors.length === 0) {
            $http({ method: args.method, url: '/Confirm/DownloadSources/Schedules/RunNow/' + args.id, data: $scope.current.item.id, trackerMsg: args.trackerMsg })
                .then(function (r) {
                    dialog.close(r.data);
                });
        }
    };

    init();

    $scope.duplicateUserIdPasswordError = null;
    $scope.ignoreDuplicateWarning = false;

    function clearDuplicateErrors() {
        $scope.errors = $scope.errors.filter(e => e.title !== 'Duplicate UserId/Password!');
        $scope.ignoreDuplicateWarning = false;
    }

    $scope.checkDuplicateUserIdPassword = function () {
        var payload = angular.copy($scope.current.item);

        return $http.post('/Confirm/DownloadSources/Verbose/Duplicate/', payload, { ignoreExceptions: [400] })
            .then(function () {
                clearDuplicateErrors();
                return true;
            })
            .catch(function (error) {
                clearDuplicateErrors();
                if (error.status === 400) {
                    $scope.duplicateUserIdPasswordError = error.data && error.data.Message
                        ? error.data.Message
                        : 'Duplicate detected.';
                    return false;
                }
                throw error;
            });
    };

    $scope.checkDuplicateUserIdPasswordBeforeSave = function () {
        if ($scope.current.isSaving === true) {
            return;
        }
        $scope.current.isSaving = true;
        try {
            const options = $scope.current.formatOptions;
            const jsonArray = Array.isArray(options) ? options : JSON.parse(options);
            const item = jsonArray.find(obj => obj.Code === "DownloadSourceDuplicateUIDPWCheck");
            $scope.shouldCheckDuplicateUserIdPassword = item ? (item.Value === true || item.Value === "true") : false;
        } catch (e) {
            $scope.shouldCheckDuplicateUserIdPassword = false;
            $scope.current.isSaving = false;
        }

        if (!$scope.shouldCheckDuplicateUserIdPassword) {
            // No check needed, just save
            $scope.save();
            return;
        }
        if ($scope.ignoreDuplicateWarning) {
            $scope.save();
            $scope.ignoreDuplicateWarning = false; // reset for next time
            return;
        }
        $scope.checkDuplicateUserIdPassword().then(function (isValid) {
            if (isValid) {
                $scope.save();
            } else {
                // If not valid, error is shown and user can choose to ignore
                // Show a dialog to allow user to ignore and continue, displaying the error message
                var duplicateMsg = $scope.duplicateUserIdPasswordError || "Duplicate UserId/Password detected.";
                $dialog.confirmAction(duplicateMsg + "<br><br>Do you want to ignore this warning and save anyway?")
                    .open().then(function (result) {
                        if (result === 'yes') {
                            $scope.ignoreDuplicateWarning = true;
                            $scope.save().finally(function () {
                                $scope.ignoreDuplicateWarning = false;
                            });
                        }
                        // If 'no', do nothing and let user review the error
                    });
            }
        });
    };

    $scope.ignoreAndSaveAnyway = function () {
        $scope.ignoreDuplicateWarning = true;
        $scope.checkDuplicateUserIdPasswordBeforeSave();
    };

});
'use strict';


app.controller('UploadTargetsListCtrl', function UploadTargetsListCtrl( $scope, views, $oasRights, $dialog ) {
    // PRIVATE METHODS
    function slickGridDoubleClick( ) {
        $scope.openEditor( false );
    }

    // PUBLIC METHODS
    $scope.openEditor = function( isNew ) {
        $dialog
            .dialog({
                    templateUrl: "confirmation/editors/views/upload-targets-edit.html",
                    controller: 'UploadTargetsEditCtrl',
                    id: isNew ? 0 : $scope.selectedIds[0],
                    dialogClass: "modal wide",
                })
            .open()
            .then(function ( item ) {
                if( item ) {
                    $scope.$broadcast( $scope.current.grid.events.action, {action: isNew ? 'add-item' : 'update-item', item: item } );
                }
            });
    };

    // EVENT LISTENERS
    $scope.$on('event:upload-targets-list-select', function (e, args) {
        if (args.length === 0) return;
        //selectedHH = args[0];
    });
    $scope.$on('slickgrid-data-loaded', function(event, data) {
        if (data.length !== 1) return;
        //selectedHH = data[0];
        $scope.$broadcast('event:upload-targets-list-action',{action:'select-items', items: data.slice(0,1) });
    });
    $scope.$on('slickgrid-last-refresh', function(event, data) {
        //$scope.current.lastUpdated = data;
    });

    // INITIALIZE
    $scope.rightsUploadTargets = $oasRights.forCode("UPLOADTARGETS");
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        grid: {
            load: '/Confirm/UploadTarget',
            events: {
                action: 'event:upload-targets-list-action',
                select: 'event:upload-targets-list-select',
            }
        },
        view: views[0],
        gridDoubleClick: slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length ) {
                $scope.openEditor( false );
            }
        }
    }];
});

'use strict';

var SchedulerMaintenanceCtrl = app.controller('SchedulerMaintenanceCtrl', function SchedulerMaintenanceCtrl($scope, views, $oasRights, $http) {
    $scope.sort=
    function sortJSON(arr, key, asc = true) {
        return arr.sort((a, b) => {
            let x = a[key];
            let y = b[key];
            if (asc) { return ((x < y) ? -1 : ((x > y) ? 1 : 0)); }
            else { return ((x > y) ? -1 : ((x < y) ? 1 : 0)); }
        });
    }

    // Constructor
    function init() {
        $http.get("/Confirm/SchedulerMaintenance/", { ignoreExceptions: false })
            .then(function (response) {
                $scope.current.data = $scope.sort(response.data, "runOrder", true);
            });
    }


    // PUBLIC METHODS
    $scope.saveAllChanges = () => {
        $http.put("/Confirm/SchedulerMaintenance", $scope.current.data, { trackerMsg: 'Saving All Changes' })
            .then((response) =>
            {
                $scope.current.data = $scope.sort(response.data, "runOrder", true);
            });
    }

    $scope.rightsSchedulerMaintenance = $oasRights.forCode("SCHEDULERMAINTENANCE");
    $scope.views = views;
    $scope.selectedIds = [];

    // INITIALIZE
    $scope.current = {
    labels:
        [{ code: 'isActive', type: "checkbox", value: 'Active', default: false, editable: $scope.rightsSchedulerMaintenance.canUpdate },
        { code: 'description', value: 'Description', editable: false },
        { code: 'ruleId', value: 'Rule ID', editable: false },
        { code: 'runOrder', value: 'Run Order', editable: true }
        ]
    };

    $scope.current.data = [];              //API RESPONSE
    init();
});

app.component('settingsFrame', {  // This name is what AngularJS uses to match to the `<settings-frame>` element.
    bindings: {
        settingGroups: '=',
        selectedSetting: '=',
        rules: '<',
        save: '&',
        delete: '&',
        privilegeCode: '<'
    },
    templateUrl: 'confirmation/views/confirm-settings-frame.html',
    controller: function SettingsFrameCtrl($timeout, $oasRights) {
        var $ctrl = this;

        $ctrl.toggleMenuDropDown = () => {
            $ctrl.menuDropDownEnabled = !$ctrl.menuDropDownEnabled;
        };

        $ctrl.openRunOrderEditor = () => {
            if ($ctrl.rights.privilege.canAdd || $ctrl.rights.privilege.canUpdate || $ctrl.rights.privilege.canDelete) {
                $ctrl.settingGroups.forEach((settingGroup) => {
                    settingGroup.pendingRunOrders = angular.copy(settingGroup.settings);
                });
                
                $timeout(() => {
                    document.querySelector('#runOrderEditor').open();
                    document.querySelectorAll("#runOrderList li").forEach((element) => {
                        setupDefaultDraggingElement(element);
                        element.addEventListener('drop', drop);
                    });
                }, 0);
            }
        };

        $ctrl.closeRunOrderModal = () => {
            document.querySelector('#runOrderEditor').close();
        };

        $ctrl.saveRunOrder = () => {
            $ctrl.settingGroups.forEach((settingGroup) => {
                settingGroup.settings = angular.copy(settingGroup.pendingRunOrders);
            });
            $ctrl.closeRunOrderModal();
        }

        $ctrl.saveAllChanges = () => {
            $ctrl.save();
        };

        $ctrl.deleteSetting = () => {
            $ctrl.delete();
        };

        $ctrl.addNewSetting = () => {
            var settingToAdd = { RunOrder: null, RuleID: "1" };
            addNewSetting($ctrl.settingGroups[0].settings, settingToAdd);
        };

        function drop(e) {
            e.preventDefault
            var propertiesId = e.currentTarget.id.split(',');
            var settingGroupTitle = propertiesId[propertiesId.length - 1];
            var arrayToHandle = null;
            var settingGroupUsed = null;
            $ctrl.settingGroups.forEach((settingGroup) => {
                if (settingGroup.title == settingGroupTitle) {
                    arrayToHandle = settingGroup.pendingRunOrders;
                    settingGroupUsed = settingGroup;
                }
            });

            if (arrayToHandle) {
                settingGroupUsed.pendingRunOrders = handleDrop(arrayToHandle);
            }
        };

        function handleDrop(arrayToHandle) {
            var draggedProcess = arrayToHandle.find(setting => setting.RunOrder === $ctrl.dragging);
            var draggedOverProcess = arrayToHandle.find(setting => setting.RunOrder === $ctrl.draggedOver);

            var draggedOverStartOrder = draggedOverProcess.RunOrder;
            var draggedStartOrder = draggedProcess.RunOrder;
            draggedProcess.RunOrder = 0;

            if (draggedStartOrder > draggedOverStartOrder) {
                for (var i = draggedStartOrder - 1; i >= draggedOverProcess.RunOrder; i--) {
                    var processToIncrease = arrayToHandle.find(setting => setting.RunOrder === i);
                    if (processToIncrease != null) {
                        processToIncrease.RunOrder++;
                    }
                }
            } else {
                for (var i = draggedStartOrder + 1; i <= draggedOverStartOrder; i++) {
                    var processToIncrease = arrayToHandle.find(setting => setting.RunOrder === i);
                    processToIncrease.RunOrder--;
                }
            }
            draggedProcess.RunOrder = draggedOverStartOrder;
            return arrayToHandle;
        }

        function setDragging(e) {
            e.preventDefault();
            $ctrl.dragging = parseInt(e.currentTarget.id);
        };

        function setDragOver(e) {
            e.preventDefault();
            if (e.currentTarget.id !== $ctrl.dragging) {
                $ctrl.draggedOver = parseInt(e.currentTarget.id);
            }
        };

        function setupDefaultDraggingElement(element) {
            element.addEventListener('drag', setDragging);
            element.addEventListener('dragover', setDragOver);
            element.draggable = true;
        }

        function addNewSetting(array, newRuleToAdd) {
            var highestRunNumber = 0;
            array.forEach((processRule) => {
                if (processRule.RunOrder > highestRunNumber) {
                    highestRunNumber = processRule.RunOrder;
                }
            });
            var newestRunNumber = highestRunNumber + 1;
            newRuleToAdd.RunOrder = newestRunNumber;
            var length = array.push(newRuleToAdd);
            $ctrl.selectedSetting = array[length - 1];
            var newRule = $ctrl.rules.find(rule => rule.Id.toString() == 1);
            $ctrl.selectedSetting.ParameterSet = angular.copy(newRule.config.ParameterSet);
            return newestRunNumber;
        };

        $ctrl.$onInit = function () {
            $ctrl.rights = { privilege: $oasRights.forCode($ctrl.privilegeCode) };
        };
    }
});


app.component('settingGroup', {  // This name is what AngularJS uses to match to the `<settings-group>` element.
    templateUrl: 'confirmation/views/confirmation-setting-group.html',
    bindings: {
        settingGroup: '=', // adds the ability to pass in values by doing <settings-group setting-group="value"><settings-group>
        selectedSetting: '=',
        searchText: '<', 
        rules: '<'
    },
    controller: function settingGroupCtrl(splitIoService) {
        var $ctrl = this;

        $ctrl.click = (runOrder) => {
            $ctrl.selectedSetting = $ctrl.settingGroup.settings.find(setting => setting.RunOrder === runOrder);
            var rule = $ctrl.rules.find(rule => rule.Id == $ctrl.selectedSetting.RuleID);
            if (rule != null && $ctrl.selectedSetting != null && $ctrl.selectedSetting.ParameterSet != null)
            {
                var selectedSettingParamCodes = $ctrl.selectedSetting.ParameterSet.select(param => param.ParameterCode);
                rule.config.ParameterSet.forEach((param) => {
                    if (!selectedSettingParamCodes.includes(param.ParameterCode)) {
                        $ctrl.selectedSetting.ParameterSet.push(param);
                    }
                });
            }
        }

        $ctrl.selectAll = () => {
            var checked = null;
            //only try to toggle if the settings exist and not empty.
            if ($ctrl.settingGroup.settings != null && $ctrl.settingGroup.settings.length > 0) {
                $ctrl.settingGroup.settings.forEach((setting) => {
                    if (checked === null) {
                        checked = !setting.Active; //get the oposite value of the first record and set all to that value.
                    }
                    setting.Active = checked;
                });
            }
        }

        $ctrl.$onInit = function () {
            splitIoService.getBoolTreatment('recon_confirm_activeinactiveprocessmaintenance_182687').subscribe((isEnabled) => {
                if (isEnabled) {
                    $ctrl.settingGroup.settings.forEach((setting) => {
                        if (setting.Active == null) {
                            setting.Active = true
                        }
                    });
                }

                $ctrl.ActiveInactiveEnabled = isEnabled;
            });
        }
    }
});


app.component('settingEditor', {  // This name is what AngularJS uses to match to the `<setting-editor>` element.
    templateUrl: 'confirmation/views/confirmation-setting-editor.html',
    bindings: {
        settingGroups: '=',
        selectedSetting: '<', // adds the ability to pass in values by doing <setting-editor selected-setting="value"><setting-editor>
        rules: '<',
        save: '&',
        delete: '&',
        openRunOrder: '&',
        searchText: '<',
        privilegeCode: '<'
    },
    controller: function SettingEditorCtrl($oasRights) {
        var $ctrl = this;
        $ctrl.editNameEnabled = false;


        $ctrl.toggleEditName = () => {
            $ctrl.editNameEnabled = !$ctrl.editNameEnabled;
        };

        $ctrl.openRunOrderEditor = () => {
            $ctrl.openRunOrder();
        };

        $ctrl.saveAllChanges = () => {
            $ctrl.save();
        };

        $ctrl.deleteSleeveRule = () => {
            $ctrl.delete();
        };
        $ctrl.setOriginalRule = () => {
            $ctrl.originalRule = angular.copy($ctrl.selectedSetting.RuleID);
        };

        function GetRuleToAdd(newRule) {
            var namesOfRules = $ctrl.rules.map(rule => rule.RuleName);
            if (!$ctrl.selectedSetting.Name || $ctrl.selectedSetting.Name === "" || namesOfRules.includes($ctrl.selectedSetting.Name))
            {
                $ctrl.selectedSetting.Name = newRule.RuleName;
            }
            var ruleToAdd = {};

            ruleToAdd.RuleID = newRule.Id.toString();
            ruleToAdd.Name = $ctrl.selectedSetting.Name
            ruleToAdd.ParameterSet = angular.copy(newRule.config.ParameterSet);
            ruleToAdd.Active = $ctrl.selectedSetting.Active;
            ruleToAdd.RunOrder = $ctrl.selectedSetting.RunOrder;

            return ruleToAdd;
        }
        $ctrl.changeRule = () => {
            var newRule = $ctrl.rules.find(rule => rule.Id.toString() == $ctrl.selectedSetting.RuleID);
            var ruleToAdd = GetRuleToAdd(newRule);
            
            var indexaddedTo = null;
            var settingGroupIndex = null;
            var added = false;
            $ctrl.settingGroups.forEach((settingGroup,i) => {
                var indexToRemove = null;
                indexToRemove = settingGroup.settings.findIndexFrom($ctrl.selectedSetting);

                if (indexToRemove != -1) {
                    settingGroup.settings.splice(indexToRemove, 1);
                }

                if (settingGroup.idName != null &&
                    settingGroup.idValue != null &&
                    newRule.config[settingGroup.idName] === settingGroup.idValue) {

                    var maxRunNumber = 0;
                    settingGroup.settings.forEach((setting) => {
                        if (setting.RunOrder > maxRunNumber) {
                            maxRunNumber = setting.RunOrder;
                        }
                    });

                    ruleToAdd.RunOrder = maxRunNumber + 1;

                    var newLength = settingGroup.settings.push(ruleToAdd);
                    indexaddedTo = newLength - 1;
                    settingGroupIndex = i;
                    added = true;
                }
            });

            if (!added) {
                indexaddedTo = $ctrl.settingGroups[0].settings.push(ruleToAdd) - 1;
                settingGroupIndex = 0;
            }

            $ctrl.selectedSetting = $ctrl.settingGroups[settingGroupIndex].settings[indexaddedTo];
        };

        $ctrl.$onInit = function () {
            $ctrl.rights = { privilege: $oasRights.forCode($ctrl.privilegeCode) };
        };
    }
});
app.component('mappingTable', {  // This name is what AngularJS uses to match to the `<mapping-table>` element.
    templateUrl: 'confirmation/views/mapping-table.html',
    bindings: {
        labels: '<',
        mappingObjects: '=',
        canRemove: '=',
        title: '<',
        checkErrors: '&',
        canAdd: '=?',
        enableFilter: '=',
        enablePagination: '=?'
    },
    controller: function MappintTableCtrl() {
        var $ctrl = this;
        $ctrl.pageSizes = [{ value: 25, label: '25' },
        { value: 50, label: '50' },
        { value: 100, label: '100' }];

        $ctrl.pageSize = $ctrl.pageSizes[0];
        $ctrl.currentPage = 1;
        $ctrl.totalItems = 0;
        $ctrl.maxSize = 5; // Number of pages to show in pagination control

        if ($ctrl.canAdd == null) {
            $ctrl.canAdd = true;
        }

        function init() {
            $ctrl.search = [];

            // If enableFilter is not set, default it to false.
            if ($ctrl.enablePagination !== true) {
                $ctrl.enablePagination = false;
            }

            $ctrl.labels.forEach(label => {
                var search = {
                    propToFilter: label.code,
                    input: null
                };
                $ctrl.search[search.propToFilter] = search;
            });

            // If enablePagination is true, initialize the pagedMappingObjects.
            if ($ctrl.enablePagination === true) {
                $ctrl.refreshTableWithPaging();
            }
        }

        $ctrl.addRow = function () {
            var newObject = {}
            $ctrl.labels.forEach((label) =>
            {
                newObject[label.code] = label.default;
            });
            newObject.new = true;

            //If enablePagination is true, we need to add the new object to the pagedMappingObjects array.
            //These should still be linked to the same object so that the table updates correctly.
            //We don't want to refresh the pagination because then you would lose the new object.
            if ($ctrl.enablePagination === true) {
                $ctrl.pagedMappingObjects.push(newObject);
            }

            $ctrl.mappingObjects.push(newObject);
            $ctrl.checkErrors();
        }
        $ctrl.searchChanged = () => {
            $ctrl.currentPage = 1; // Reset to the first page when search changes
            $ctrl.refreshTableWithPaging();
        }
        $ctrl.pageSizeChanged = () => {
            $ctrl.refreshTableWithPaging();
        }

        $ctrl.pageNumberChanged = () => {
            $ctrl.refreshTableWithPaging();
        }

        $ctrl.checkRecordsForErrors = () => {
            $ctrl.checkErrors();
        }

        $ctrl.removeRow = function (mappingObject) {
            $ctrl.mappingObjects.remove(mappingObject);

            //If enablePagination is true, we need to update pagedMappingObjects to remove the object as well.
            if ($ctrl.enablePagination === true) {

                $ctrl.refreshTableWithPaging();
            }
        }

        $ctrl.refreshTableWithPaging = () => {
            if ($ctrl.enablePagination === true) {
                $ctrl.totalItems = $ctrl.mappingObjects.length;
                $ctrl.pagedMappingObjects = [];

                //Determine which search filters have values so we can then limit the mappingObjects to only those that match the search criteria.
                var filtersWithValues = [];
                if ($ctrl.search != null) {
                    Object.keys($ctrl.search).forEach((searchObj) => {
                        var input = $ctrl.search[searchObj].input;
                        if (input != null && input != '') {

                            $ctrl.labels.forEach((label) => {
                                if (label.code === searchObj && label.type === "dropdown") {

                                    var dropDownValuesToAllow = [];
                                   
                                    //Get all the dropdown values that contain the input value.
                                    label.selectOptions.forEach((option) => {
                                        if (option.displayName.toLowerCase().includes(input.toLowerCase())) {
                                            dropDownValuesToAllow.push(option.value);
                                        }
                                    });

                                    $ctrl.search[searchObj].dropDownOptionsToAllow = dropDownValuesToAllow
                                }
                            });
                           
                            filtersWithValues.push($ctrl.search[searchObj]);
                        }
                    }); 
                }

                var tempArray = [];
                // If there are search filters with values, filter the mappingObjects accordingly.
                if (filtersWithValues.length > 0) {

                    for (var i = 0; i < $ctrl.mappingObjects.length; i++) {
                        var mappingObject = $ctrl.mappingObjects[i];
                        var matches = true;
                        filtersWithValues.forEach((filter) => {
                            //handle dropdown filters
                            if (filter.dropDownOptionsToAllow != null && filter.dropDownOptionsToAllow.length > 0) {

                                //check if it matches the dropdown values.
                                if (!filter.dropDownOptionsToAllow.includes(mappingObject[filter.propToFilter])) {
                                    matches = false;
                                }
                            }
                            //Handle normal string filters
                            else {
                                if (mappingObject == null
                                    || mappingObject[filter.propToFilter] == null
                                    || mappingObject[filter.propToFilter].toString() == null
                                    || !mappingObject[filter.propToFilter].toString().toLowerCase().includes(filter.input.toLowerCase())) {
                                    matches = false;
                                }
                            }
                        });
                        if (matches) {
                            tempArray.push(mappingObject);
                        }
                    }

                    //if searching we want to set the totalItems to the length of the filtered array.
                    $ctrl.totalItems = tempArray.length;
                }
                // If there are no search filters with values, use the full mappingObjects array.
                else {
                    tempArray = $ctrl.mappingObjects;
                }


                // If pageSize is -1, it means we want to show all items without pagination.
                if ($ctrl.pageSize.value === -1) {
                    $ctrl.pagedMappingObjects = tempArray;
                    return;
                }

                // handle pagination based on the current page and page size
                var i = ($ctrl.currentPage - 1) * $ctrl.pageSize.value;
                var end = i + $ctrl.pageSize.value;

                //creating a separate array to hold the paginated results.
                //So it doesn't modify the pagedMappingObjects array and cause the page to update until it's finished adding records.
                var displayArray = []; 
                for (i; i < end && i < tempArray.length; i++) {
                    displayArray.push(tempArray[i]);
                }

                //assign the paginated results to the pagedMappingObjects
                $ctrl.pagedMappingObjects = displayArray;
            }
        }

        this.$onInit = init;
    }
});
app.component('downloadSubFormatSchedulerDefaultItem', {  // This name is what AngularJS uses to match to the `<settings-group>` element.
    bindings: {
        selected: '=', // adds the ability to pass in values by doing <settings-group setting-group="value"><settings-group>
        currentScope: '<',
        privilegeCode: '<',
        isCostBasis: '<',
    },
    templateUrl: 'confirmation/modals/downloadSubFormatSchedulerDefaultItem.html',
    controller: function downloadSubFormatSchedulerDefaultItemCtrl($oasRights) {
        var $ctrl = this;

        $ctrl.$onInit = function () {
            if ($ctrl.privilegeCode) {
                $ctrl.rights = {
                    privilege: $oasRights.forCode('DOWNLOADFORMATS') };
            }
        }
    }
});
'use strict';

app.controller('UploadTargetsEditCtrl', function UploadTargetsEditCtrl( $scope, $http, $oasRights, dialog ) {
    function init( ) {
        $scope.rightsuploadTargets = $oasRights.forCode( "UPLOADTARGETS" );
        $scope.rightsuploadTargetsPasswords = $oasRights.forCode( "UPLOADTARGETSPASSWORDS" );

        $http.get( '/Confirm/UploadFormats', {trackerMsg: 'Loading upload formats'} )
            .then( function (r) {
                $scope.uploadFormats = r.data;
            });


        if( dialog.options.id === 0 ) {
            $scope.uploadtarget = {
                id: 0,
                uploadFormat: null,
                Description: null,
                UserId: null,
                Password: null,
                PgpUserId: null,
                SqlText: null,
                Parameters: null,
                BlobType: null,
                Url: null,
                TransmitMethod: 4,
                UseForScrubs: null,
                FinalProcess: null,
                InstructionCode: null
            };
        } else {
            $http.get( '/Confirm/UploadTarget/' + dialog.options.id, {trackerMsg: 'Loading upload target'} )
                .then( function(r){
                    $scope.uploadtarget = r.data;
                });
        }
    }

    $scope.save = function( ) {
        var args = $scope.uploadtarget.id > 0 ? {method: "PUT", id: $scope.uploadtarget.id, trackerMsg: "Saving upload target"} : {method: "POST", id: "", trackerMsg: "Adding new upload target"};

        if( $scope.uploadtarget.uploadFormat === null || $scope.uploadtarget.uploadFormat === "" ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Upload Format is required.'} );
        }

        if( $scope.errors.length === 0 ) {
            $http( { method: args.method, url: '/Confirm/UploadTarget/' + args.id, data: $scope.uploadtarget, trackerMsg: args.trackerMsg } )
                .then( function( r ) {
                    dialog.close( r.data );
                });
        }
    };

    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.errors = [];

    init( );
});

'use strict';

app.controller('ConfirmationImportedFilesCtrl', function ConfirmationImportedFilesCtrl($scope, $http, $oasRights, $dialog, $timeout, $route, ConfirmationOverview, Entity, views, $interval, $confirmation, $settings) {

    // PRIVATE METHODS
    function init( ) {
        $scope.lastRefresh = { date: Date.create( ) };
        $scope.current.view.filterType = 'Any';

        refreshInterval();
        loadCounts();
    }


    // PUBLIC METHODS
    $scope.importFile = function( ) {
        return $dialog.dialog({dialogClass: "modal wide", templateUrl: "confirmation/modals/importFile.html", controller: "ImportFileCtrl"}).open()
            .then(function (result) {
                    if( result && result.status && result.status == 'success' ) {
                        init( false );
                    }
                }
            );
    };

    $scope.goToFilesReceived = function(redirect) {
        return $confirmation.goToFilesReceived({
            batchProcessingId: $scope.selected.id,
            defaultStartDate: $scope.current.grid.param.startDate.format('{MM}-{dd}-{yyyy}'),
            //filterEndDate: $scope.current.grid.param.endDate.format('{MM}-{dd}-{yyyy}')
        }, redirect);
    };

    function refreshInterval() {
        if($scope.refresh) {
            $interval.cancel($scope.refresh);
            $scope.refresh = undefined;
        }
        $scope.refresh = $interval($scope.refreshGrid, 30000);
    }

    function loadCounts() {
        return $scope.current.grid.counts.load({params: $scope.current.grid.param}).then(function(counts){
            $scope.current.grid.counts.data = counts.data;
        })
    }

    $scope.refreshGrid = function() {
        $scope.lastRefresh = { date: Date.create( ) };
        $scope.$broadcast('event:confirm-importfiles-action', {action: 'refresh-grid'});
        loadCounts();
        refreshInterval();
    };

    $scope.sortData = function( fieldName ) {
        $scope.current.sortField = fieldName;
        $scope.current.sortReverse = !$scope.current.sortReverse;
    };

    $scope.$on('event:confirm-importfiles-select', function(e, args) {
        if (!args.length) return;
        $scope.selectedItems = Entity.collection(args);
    });

    $scope.$on('$destroy', function () {
        $interval.cancel($scope.refresh);
    });

    $scope.selectedItems = [];
    Object.defineProperty($scope, 'selectedIds', {get: function() {return $scope.selectedItems.map('id')}});
    Object.defineProperty($scope, 'selected', {get: function() {return $scope.selectedItems[0] || undefined;}});

    $scope.views = views;

    // INITIALIZE
    $scope.rightsConfirmationOverview = $oasRights.forCode("CONFIRMOVERVIEW");
    $scope.current = {
        view: views[0],
        sortField: 'databaseName',
        sortReverse: true,
        grid: {
            counts : {
                load: ConfirmationOverview.files.getFileImportBatchCounts
            },
            load: ConfirmationOverview.files.getFileImportBatch,
            param: {startDate: $settings.getSetting('confirmStartDate'), endDate: $settings.getSetting('confirmEndDate').endOfDay()}
        }
    };

    init( true );

});
'use strict';

app.controller( 'ConfirmationGroupEditCtrl', function ConfirmationGroupEditCtrl( $scope, $http, $oasRights, $timeout, $dialog, dialog, args, $confirmation, $q, DataAudit ) {

    // PRIVATE VARIABLES
    var confirmationGroupOriginal = null;
    var editorHotKeys;


    // PRIVATE METHODS - INIT
    function init( ) {
        loadConfirmGroup( );
        loadRights( );
        buildMenu( );
        loadHotKeys();
        $scope.loadTab( args.defaultTab );
    }

    function loadConfirmGroup( ) {
        return $q.resolve(
            $scope.current.isNew
                ? {data: {
                    id : 0,
                    name : '',
                    isPrivate : false,
                    userId : $scope.user.authorization.userId,
                    databases : [],
                    recordTypes : [],
                    scrubGroups : [],
                    downloadFormats : []
                }}
                : $http.get( "/Confirm/Groups/" + args.id, {trackerMsg: 'Loading confirmation group'} )
        ).then(function(response){
            angular.forEach(response.data.dataQueries, function (value, key) {
                var params = JSON.parse(value.dataQueryParams);
                response.data.dataQueries[key].dataQueryParams = angular.isArray(params) ? params : [];
            });
            $scope.confirmationGroup = response.data;
            confirmationGroupOriginal = angular.copy( $scope.confirmationGroup );
        });
    }

    function loadRights() {
        $scope.rightsConfirmationGroups = $oasRights.forCode("CONFIRMGROUPS");
    }

    function buildMenu() {
        $scope.menu = { categories: [ ] };
        $scope.menu.categories.push( {name: 'General', children: [] } );
        $scope.menu.categories[0].children.push( {name: 'General', active: false, code: 'general'} );

        $scope.menu.categories.push( {name: 'Details', children: [] } );
        $scope.menu.categories[1].children.push( {name: 'File Types', active: false, code: 'fileTypes'} );
        $scope.menu.categories[1].children.push( {name: 'Formats', active: false, code: 'formats'} );
        $scope.menu.categories[1].children.push( {name: 'Databases', active: false, code: 'databases'} );
        $scope.menu.categories[1].children.push( {name: 'Queries', active: false, code: 'dataQueries'} );
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: function() { $scope.close(true); } }
            ]);
        });
    }

    $scope.addGroupQuery = function(){
        return DataAudit.selectDataQuery().then(function(result) {
            if(result && result.item) {
                if(!$scope.confirmationGroup.dataQueries.any(function(i){return i.id === result.item.id; })) {
                    return $http({
                        url: '/Reporting/Custom/' + result.item.id,
                        params: {interpolate: false},
                        method: 'GET',
                        trackerMsg: 'Getting data query details'
                    }).then(function(response){
                        $scope.confirmationGroup.dataQueries.push({
                            confirmGroupId: $scope.confirmationGroup.id,
                            customReportId: result.item.id,
                            dataQuery: response.data,
                            dataQueryParams: []
                        });
                    });
                }
            }
        });
    };

    $scope.removeGroupQuery = function(item) {
        $scope.confirmationGroup.dataQueries.splice($scope.confirmationGroup.dataQueries.indexOf(item), 1);
    };

    $scope.moveGroupQuery = function (item, indexChange) {
        var index = $scope.confirmationGroup.dataQueries.indexOf(item),
            newPos = index + indexChange;

        if(newPos >= 0) {
            $scope.confirmationGroup.dataQueries.splice(index, 1);
            $scope.confirmationGroup.dataQueries.splice(newPos, 0, item);
            $scope.confirmationGroup.dataQueries.forEach(function (n, i) {
                n.sortOrder = i + 1;
            });
        }
    };

    function getCustomPrompt(audit, prompt) {
        if (!audit.dataQueryParams) audit.dataQueryParams = [];
        var customPrompt = audit.dataQueryParams[audit.dataQueryParams.findIndex(function(i){return i.id === prompt.id;})];
        if(!customPrompt) {
            customPrompt = angular.copy(prompt);
            audit.dataQueryParams.push(customPrompt);
        }
        return customPrompt;
    }

    $scope.getCustomPrompt = getCustomPrompt;

    $scope.openPromptDescription = function(item) {
        return $dialog.messageBox(item.prompt,
            item.promptDescription
        ).open();
    };

    $scope.openDateTypeHelp = function(item) {
        return $dialog.messageBox('Date Options',
            'Available calculated values all allowing + or - days: Now, StartYTD, EndYTD, StartQTD, EndQTD, StartLQ, EndLQ, StartLM, EndLM.'
        ).open();
    };

    // PUBLIC METHODS
    $scope.loadTab = function( child ) {
        $scope.menu.categories.each( function( c ) {
            c.children.each( function( ch ) {
                ch.active = ch.code == child.code;
            } );
        } );

        $scope.current.selectedTab = child.code;
    };

    $scope.save = function( ) {
        if( !angular.equals( confirmationGroupOriginal, $scope.confirmationGroup ) ) {
            var saveDtl = args.isNew ? {method: "POST", id: "", trackerMsg: "Adding new confirmation group"} : {method: "PUT", id: args.id, trackerMsg: "Saving confirmation group " + args.id};

            var localConfirmationGroup = angular.copy($scope.confirmationGroup);
            angular.forEach(localConfirmationGroup.dataQueries, function(value, key){
                if(angular.isObject(value.dataQueryParams))
                    localConfirmationGroup.dataQueries[key].dataQueryParams = JSON.stringify(value.dataQueryParams);
            });

            $http({ method: saveDtl.method, url: '/Confirm/Groups/' + saveDtl.id, data: localConfirmationGroup, trackerMsg: saveDtl.trackerMsg })
                .then(function (response) {
                    editorHotKeys.destroy();
                    dialog.close(response.data);
                });
        }
    };

    $scope.close = function( validate ) {
        if( validate ) {
            if( !angular.equals( confirmationGroupOriginal, $scope.confirmationGroup ) ) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };

    $scope.maintainDetailList = function( availSelVal, propertyToUpdate, detailList ) {
        var list = angular.copy( detailList );
        $dialog.dialog({ templateUrl: "app/modals/available-select.html", controller: "AvailableSelectCtrl", resolve: {availableSelectedArgs: function() { return {selectionType: availSelVal, selectedSelected: list}; }}})
            .open()
            .then(function(result) {
                if (result) {
                    $scope.confirmationGroup[propertyToUpdate] = result;
                }
            });
    };

    // INITIALIZE
    $scope.current = {
        isNew : args.isNew,
        selectedTab: args.defaultTab,
        groupId: parseInt( args.id )
    };

    $scope.confirmationGroup = null;
    $scope.errors = [];

    init( );

} );
'use strict';

app.controller( 'ConfirmationScrubEditCtrl', function ConfirmationScrubEditCtrl( $scope, $http, $oasRights, $dialog, dialog, args ) {

    // PRIVATE VARIABLES
    var confirmGroupOriginal = null;
    var editorHotKeys;


    // PRIVATE METHODS - INIT
    function init() {
        loadRights();
        buildMenu();
        loadHotKeys();
        $scope.loadTab( args.defaultTab );
    }

    function loadRights() {
        $scope.rightsConfirmationScrubs = $oasRights.forCode("SS_SCRUBS");
    }

    function buildMenu() {
        $scope.menu = { categories: [ ] };
        $scope.menu.categories.push( {name: 'General', children: [] } );
        $scope.menu.categories[0].children.push( {name: 'General', active: false, code: 'general'} );
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: $scope.close }
            ]);
        });
    }


    // PUBLIC METHODS
    $scope.loadTab = function( child ) {
        $scope.menu.categories.each( function( c ) {
            c.children.each( function( ch ) {
                ch.active = ch.code == child.code;
            } );
        } );

        $scope.current.selectedTab = child.code;
    };

    $scope.save = function() {
        editorHotKeys.destroy();
        dialog.close( null );
    };

    $scope.close = function( ) {
        editorHotKeys.destroy();
        dialog.close( null );
    };


    // INITIALIZE
    $scope.current = {
        isNew : args.isNew,
        selectedTab: args.defaultTab,
        groupId: parseInt( args.id )
    };

    $scope.errors = [];

    init();
} );
'use strict';

app.controller('ReconciliationListCtrl', function ReconciliationListCtrl($scope, $http, $timeout, $settings, views, $dialog) {
    // PRIVATE METHODS
    function setDatesAndLoadCounts() {
        $scope.current.startDate = $scope.current.filterStartDate.format('{MM}-{dd}-{yyyy}');
        $scope.current.endDate = $scope.current.filterEndDate.format('{MM}-{dd}-{yyyy}');
        $http.get("/Confirm/InterfaceReconciliations/Counts?startDate=" + $scope.current.startDate + "&endDate=" + $scope.current.endDate, {trackerMsg: 'Loading position count'})
            .then(function (response) {
                $scope.counts = response.data;
            });
    }


    // PUBLIC METHODS
    $scope.refreshGrid = function () {
        $settings.setSetting('reconStartDate', $scope.current.filterStartDate);
        $settings.setSetting('reconEndDate', $scope.current.filterEndDate);
        $settings.setSetting('reconTrxStatus', $scope.current.trxStatus);
        $settings.setSetting('reconPosStatus', $scope.current.posStatus);
        $settings.setSetting('reconCostBasisStatus', $scope.current.costBasisStatus);

        setDatesAndLoadCounts();

        $timeout(function() {
            $scope.$broadcast('event:confirm-interfaceRecon-action', {action: 'refresh-grid'});
        });
    };

    $scope.updateRowNoteCount = function () {
        $scope.$broadcast('event:confirm-interfaceRecon-action', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:confirm-interfaceRecon-action', {action: 'export-data'});
    };

    $scope.alertReconciliationComplete = function ( ) {
        $dialog.dialog({dialogClass: "modal wide", templateUrl: "reconciliation-complete-alert.html", controller: "ReconciliationCompleteAlertCtrl"}).open()
            .then(function ( result ) {
                if( result ) {
                    $dialog.actionComplete("Notification sent.").open();
                }
            });
    };
    // EVENT LISTENERS
    $scope.$on('event:confirm-interfaceRecon-select', function (e, args) {
        $scope.current.downloadSourceId = args.length ? args[0].downloadSourceId : null;
    });
    // INITIALIZE
    (function(){
        $scope.selectedIds = [];
        $scope.views = views;
        $scope.current = {
            view: views[0],
            filterStartDate: '',
            filterEndDate: Date.create('today'),
            trxStatus: $settings.getSetting('reconTrxStatus') || "",
            posStatus: $settings.getSetting('reconPosStatus') || "",
            costBasisStatus: $settings.getSetting('reconCostBasisStatus') || "",
            slickGridUrl:''
        };
        let dateObj = Date.create('today');
        $scope.current.filterStartDate = (dateObj.getDay() === 1)? Date.create(dateObj.setDate(dateObj.getDate() - 2)) : dateObj;
        setDatesAndLoadCounts();
        $scope.current.slickGridUrl = "/confirm/interfacereconciliations";
    })();
});

app.controller('ReconciliationCompleteAlertCtrl', function ReconciliationCompleteAlertCtrl( $scope, $http, $dialog, dialog ) {

    $scope.alertTemplate = null;

    function init( ) {
        $http.get("/Confirm/InterfaceReconciliations/Action/SendReconCompleteNotification", {trackerMsg: 'Loading reconciliation notification detail'})
            .then(function (response) {
                $scope.alertTemplate = response.data;
            });
    }

    $scope.alert = function ( ) {
        if ($scope.emailInvalid) {
            $dialog.actionFailed('Email address is invalid.').open();
        }

        $http.post("/Confirm/InterfaceReconciliations/Action/SendReconCompleteNotification", $scope.alertTemplate, {trackerMsg: "Sending notification"})
            .then(function () {
                dialog.close( {result: 'sent'} );
            });
    };

    $scope.cancel = function ( ) {
        dialog.close( null );
    };

    $scope.invalidEmail = function (invalid) {
        $scope.emailInvalid = invalid;
    };

    $scope.setEmail = function (value) {
        $scope.alertTemplate.emailToList = value;
    };

    //INITIALIZE
    init( );

});
'use strict';

app.controller('ReconciliationAccountsMissingListCtrl', function ReconciliationAccountsMissingListCtrl($scope, $http, $oasRights, $dialog, views, $portfolio, entities) {


    // PUBLIC METHODS
    $scope.refreshGrid = function( ) {
        $scope.$broadcast('event:interface-recon-accounts-missing-action', {action: 'refresh-grid'});
    };

    $scope.editAccount = function( ) {
        $portfolio.openEditor( entities.account.value, [$scope.current.accountId], null, null,null, null );
    };


    // INITIALIZE
    $scope.rightsInterfaceRecon = $oasRights.forCode("INTERFACERECON");
    $scope.rightsAccount = $oasRights.forCode( "ACCOUNTS" );

    $scope.views = views;

    $scope.selectedIds = [];
    $scope.current = {
        view : views[0],
        startDate: Date.create((new Date).isMonday() ? 'two days ago' : 'today'),
        endDate: Date.create('today'),
        accountId: null
    };


    // EVENT LISTENERS
    $scope.$on('event:interface-recon-accounts-missing-select', function(e, args) {
        if (!args.length) return;

        $scope.current.accountId =  args[0].accountId;
        $scope.current.downloadSourceId = args[0].downloadSourceId;
    });

});
'use strict';

var reconciliationAlertsCtrl = app.controller('ReconciliationAlertsCtrl', function ReconciliationAlertsCtrl($scope, $timeout, $http, $location, $oasRights, $routeParams, $dataQuery, $settings, $window, $portfolio, entities, apps, config) {
    //PRIVATE VARIABLES
    var entityIds = [
        { id: "clientId", columnName: ["clientid", "client id", "householdid", "household id", "pkclient", "fkclient"], entityType: entities.client },
        { id: "registrationId", columnName: ["regid", "reg id", "registrationid", "registration id", "pkreg", "fkreg"], entityType: entities.registration },
        { id: "accountId", columnName: ["acctid", "acct id", "accountid", "account id", "pkaccount", "fkaccount"], entityType: entities.account },
        { id: "assetId", columnName: ["assetid", "asset id", "pkasset", "fkasset"], entityType: entities.asset },
        { id: "transactionId", columnName: ["tranid", "tran id", "transid", "trans id", "transactionid", "transaction id", "pktransaction", "fktransaction"], entityType: entities.transaction },
        //{ columnName: ["prodid", "prod id", "productid", "product id", "pkproduct", "fkproduct"], entityType: entities.product }
    ];
    var redirectUrl = window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html?p={1}&t=" + sessionStorage.oas_token;

    // PUBLIC METHODS
    $scope.refreshGrid = function () {
        $scope.current.isLoading = true;
        prepareQuery();
        $http.post('/Reporting/Custom/' + $scope.current.dataQuery.id + '/Generate/SlickGrid', $scope.current.dataQuery, {

            trackerMsg: 'Running Data Query'
        })
            .then(function (response) {
                $dataQuery.setDataQuery($scope.current.dataQuery);
                $scope.current.view = response.data;
                $scope.current.isLoading = false;
                $timeout(function(){
                    $scope.current.url = '/Reporting/Custom/' + $scope.current.dataQuery.id + '/Generate/SlickGrid/' + $scope.current.view.dataQueryCacheKey;
                    $timeout(function(){
                        $scope.$broadcast('event:confirm-alert-action', {action: 'refresh-grid'});
                    });
                });
            });
    };

    $scope.resetWidth = function(goWide) {
        $scope.rightSidebar.width = goWide ? 1050 : 250;
    };

    $scope.download = function (dataType) {
        $dataQuery.createFile(dataType, downloadFile);
    };

    $scope.openEntityEditor = function(link) {
        $portfolio.openEditor( entities[entities.find({name: link.entity})].value, [link.entityId], null, null, apps.confirmation.name, null );
    };

    $scope.loadTransactionHistory = function( queryString, entityEnum ) {
        if( $scope.current.transactionHistory.autoLoad ) {
            $scope.current.transactionHistory.entityLoaded = entityEnum;
            $http.get('/Portfolio/Transactions?' + queryString, {trackerMsg : 'Loading transaction history'})
                .then(function (response) {
                    $scope.current.transactionHistory.transactions = response.data;
                    $scope.current.transactionHistory.pagination.currentPage = 1;
                    $scope.current.transactionHistory.pagination.totalItems = response.data.length;

                    if( response.data.length > 0 ) {
                        if( entityEnum == entities.asset.value ) {
                            $scope.current.transactionHistory.clientId = response.data[0].clientId;
                            $scope.current.transactionHistory.registrationId = response.data[0].registrationId;
                            $scope.current.transactionHistory.accountId = response.data[0].accountId;
                            $scope.current.transactionHistory.assetId = response.data[0].assetId;
                            $scope.current.transactionHistory.cusip = response.data[0].cusip;
                            $scope.current.transactionHistory.accountNumber = response.data[0].accountNumber;
                        }

                        for( var i = 0; i < response.data.length; i++ ) {
                            $scope.current.transactionHistory.totalAmount += response.data[i].transAmount;
                            $scope.current.transactionHistory.totalUnits += response.data[i].noUnits;
                            $scope.current.transactionHistory.transactions[i].transDate = Date.create( response.data[i].transDate );
                            $scope.current.transactionHistory.transactions[i]["transDateFriendly"] = Date.create( $scope.current.transactionHistory.transactions[i].transDate ).format( "{MM}/{dd}/{yyyy}" );
                        }
                    }
                });
        }
    };

    $scope.sortTransactionHistory = function( sortField ) {
        $scope.current.transactionHistory.sortField = sortField;
        $scope.current.transactionHistory.sortReverse = !$scope.current.transactionHistory.sortReverse;
    };

    $scope.setTransactionPage = function (pageNum) {
        $scope.current.transactionHistory.pagination.currentPage = pageNum;
    };

    $scope.numPages = function() {
        return Math.ceil($scope.current.transactionHistory.pagination.totalItems / $scope.current.transactionHistory.pagination.itemsPerPage) || 1;
    };

    $scope.getTransactionPageData = function() {
        return $scope.current.transactionHistory.transactions.slice(
            (($scope.current.transactionHistory.pagination.currentPage-1)*$scope.current.transactionHistory.pagination.itemsPerPage),
            (($scope.current.transactionHistory.pagination.currentPage)*$scope.current.transactionHistory.pagination.itemsPerPage)
        );
    };

    $scope.openTransaction = function( transaction ) {
        $portfolio.openEditor( entities.transaction.value, [transaction.id], null, null, apps.portfolioLists.name, null ).then(function(rslt) {
            if( rslt ) {
                angular.extend(transaction, rslt);
            }
        });
    };

    $scope.saveTransactions = function( ) {
        if( $scope.current.transactionHistory.transactions.length > 0 ) {
            var transactions = [];
            for( var i = 0; i < $scope.current.transactionHistory.transactions.length; i++ ) {
                if( $scope.current.transactionHistory.transactions[i].isDirty ) {
                    transactions.push( {id: $scope.current.transactionHistory.transactions[i].id, portfolio: $scope.current.transactionHistory.transactions[i] } );
                }
            }

            if( transactions.length > 0 ) {
                $http.put( '/Portfolio/Transactions/Verbose', transactions, { trackerMsg: 'Updating transactions' } )
                    .then( function ( ) {
                        $scope.loadTransactionHistory('assetId=' + $scope.current.transactionHistory.assetId, entities.asset.value);
                    });
            }
        }
    };

    $scope.newTransaction = function( ) {
        var extraInfo = {fkClient: $scope.current.transactionHistory.clientId, fkAsset: $scope.current.transactionHistory.assetId};
        $portfolio.openEditor( entities.transaction.value, [], null, null, apps.portfolioLists.name, extraInfo ).then(function(rslt) {
            if( rslt ) {
                $scope.current.transactionHistory.transactions.push( rslt );
            }
        });
    };

    $scope.multiEditTransaction = function( ) {
        if( $scope.current.transactionHistory.transactions.length > 0 ) {
            var transactionIds = [];
            for( var i = 0; i < $scope.current.transactionHistory.transactions.length; i++ ) {
                if( $scope.current.transactionHistory.transactions[i].isSelected ) {
                    transactionIds.push( $scope.current.transactionHistory.transactions[i].id );
                }
            }
            if( transactionIds.length > 0 ) {
                var extraInfo = { fkClient: $scope.current.transactionHistory.clientId, fkAsset: $scope.current.transactionHistory.assetId };
                $portfolio.openMassEditor(entities.transaction.value, transactionIds, apps.portfolioLists.name, extraInfo).then(function (rslt) {
                    if (rslt) {
                        $scope.loadTransactionHistory('assetId=' + $scope.current.transactionHistory.assetId, entities.asset.value);
                    }
                });
            }
        }
    };

    // PRIVATE METHODS
    function init() {
        if($settings.getSetting('reconStartDate')) $scope.current.startDate = $settings.getSetting('reconStartDate');
        else $settings.setSetting('reconStartDate', $scope.current.startDate);

        if($settings.getSetting('reconEndDate')) $scope.current.endDate = $settings.getSetting('reconEndDate');
        else $settings.setSetting('reconEndDate', $scope.current.endDate);

        $scope.current.downloadSource = parseInt($routeParams.downloadSource);

        loadCounts();
        loadTransactionTypes();
        loadTradeStatuses();

        $scope.refreshGrid();
    }

    function downloadFile(url) {
        $window.location.href = url + "?Authorization=" + sessionStorage.oas_token;
    }

    function loadTransactionTypes( ) {
        $http.get('/Trading/TransactionTypes', {trackerMsg: 'Loading transaction types'})
            .then(function (r) {
                $scope.transactionTypes = r.data;
            });
    }

    function loadTradeStatuses( ) {
        $http.get("/Trading/TradeStatuses", {cache: true, trackerMsg: 'Loading trade statuses', ignoreExceptions: true})
            .then(function (response) {
                $scope.tradeStatuses = response.data;
            });
    }

    function prepareQuery() {
        //$scope.current.dataQuery.databaseIdList = [$routeParams.downloadSource];
        $scope.current.dataQuery.prompts.each(function(item){
            if(item.isPromptUser) {
                switch(item.code.toLowerCase()) {
                    case "@startdate":
                        //item.defaultValue = $scope.current.startDate;
                        break;
                    case "@enddate":
                    case "@filedate":
                        //item.defaultValue = $scope.current.endDate;
                        break;
                    case "@pricedate":
                        item.defaultValue = $scope.current.endDate-1;
                        break;
                    case "@fkdownloadsource":
                        item.defaultValue = $scope.current.downloadSource;
                        break;
                }
            }

            if (item.promptType === "Date") {
                item.defaultValue = Date.create(item.defaultValue).formatted();
            }
        });
    }

    function loadCounts() {
        var params = { startDate: $scope.current.startDate.format("{MM}/{dd}/{yyyy}"),
            endDate: $scope.current.endDate.format("{MM}/{dd}/{yyyy}")
        };
        $http.get("/Confirm/InterfaceReconciliations/Counts?startDate={startDate}&endDate={endDate}".assign(params), {trackerMsg: 'Loading position count'})
            .then(function(response){
                if(response && response.data) {
                    $scope.current.counts = response.data;
                }
            });
    }

    $scope.$on('event:confirm-alert-select', function (e, args) {
        if (args.length === 0) return;

        $scope.selectedIds = [];
        $scope.current.entityContextLinks = [];

        $scope.current.transactionHistory.cusip = '';
        $scope.current.transactionHistory.accountNumber = '';
        $scope.current.transactionHistory.transactions = [];
        $scope.current.transactionHistory.totalAmount = null;
        $scope.current.transactionHistory.totalUnits = null;
        $scope.current.transactionHistory.householdId = null;
        $scope.current.transactionHistory.registrationId = null;
        $scope.current.transactionHistory.accountId = null;
        $scope.current.transactionHistory.assetId = null;
        $scope.current.transactionHistory.entityLoaded = null;

        Object.each(args[0], function (columnName, value) {
            var item = entityIds.find(function(entity){
                return entity.columnName.some(function(name){ return name === columnName.toLowerCase().trim(); });
            });
            if(item && value) {
                $scope.selectedIds[item.id] = value;
                $scope.current.transactionHistory[item.id] = value;
                var contextLink = { entity: item.entityType.name, edit: true, view: true, entityId: value, url: redirectUrl.assign($portfolio.getGoToRoute(item.entityType.urlFrag, item.entityType.value, value, true)) };
                switch (item.entityType.value) {
                    case entities.transaction.value:
                        contextLink.view = false;
                        $scope.current.entityContextLinks.push( contextLink );
                        break;
                    case entities.asset.value:
                        $scope.current.entityContextLinks.push( contextLink );
                        var transactionLink = { entity: "Transaction", editable: false, view: true, entityId: null, url: redirectUrl.assign($portfolio.getGoToRoute(entities.transaction.urlFrag, entities.asset.value, value, true )) };
                        $scope.current.entityContextLinks.push( transactionLink );
                        break;
                    default:
                        $scope.current.entityContextLinks.push( contextLink );
                }
            }
        });
        if ($scope.current.transactionHistory.assetId != null) $scope.loadTransactionHistory('assetId=' + $scope.current.transactionHistory.assetId, entities.asset.value);
    });

    // WATCHES
    $scope.$watch("current.startDate", function(newValue) {
        if(newValue) $settings.setSetting('reconStartDate', newValue);
    });

    $scope.$watch("current.endDate", function(newValue) {
        if(newValue) $settings.setSetting('reconEndDate', newValue);
    });

    // INITIALIZE
    $scope.rights = $oasRights.forCode("INTERFACERECON");
    $scope.views = null;
    $scope.selectedIds = [];

    $scope.current = {
        dataQuery: config,
        isLoading: true,
        startDate: Date.create('a month ago'), endDate: Date.create('today'),
        counts: { unconfirmedAccounts: 0, unconfirmedPositions: 0, unconfirmedTransactions: 0 },
        mode: $location.path().has('/heldaway/') ? 'Account Composer' : !!$routeParams.audit ? 'Confirmation Overview' : 'Reconciliation Status',
        entityContextLinks: [],
        url: null,
        transactionHistory: {
            cusip: '',
            accountNumber: '',
            autoLoad: true,
            transactions: [],
            sortField: 'transDate',
            sortReverse: true,
            totalAmount: null,
            totalUnits: null,
            clientId: null,
            registrationId: null,
            accountId: null,
            assetId: null,
            entityLoaded: null,
            pagination: {
                totalItems: 0,
                currentPage: 1,
                itemsPerPage: 20,
                maxSize: 10
            }
        }
    };

    init();
});

reconciliationAlertsCtrl.loadDataQueryConfigForRecon = ["$http", "$route", "$dataQuery", function ($http, $route, $dataQuery) {
    var dataQueryId = ($route.current.params.audit ? $route.current.params.customReport : $route.current.params.id);

    var existingConfig = $dataQuery.getDataQuery(dataQueryId);
    if (existingConfig && existingConfig.id == dataQueryId) {
        return existingConfig;
    } else {
        return $http.get('/Reporting/Custom/' + dataQueryId, {

            trackerMsg: "Loading data query config"
        }).then(function (response) {
            if (response) {
                $dataQuery.setDataQuery(response.data);
                return $dataQuery.getDataQuery(response.data.id);
            }
        });
    }
}];
'use strict';

app.controller('ReconciliationRecordListCtrl', function ReconciliationRecordListCtrl($rootScope, $scope, $userMessages, $http, $routeParams, $oasRights, $settings, $timeout, $dialog, $portfolio, views, apps, entities) {

    // PRIVATE METHODS
    function init( ) {
        if($routeParams.startDate)
            $scope.current.startDate = Date.create($routeParams.startDate);
        if($routeParams.endDate)
            $scope.current.endDate = Date.create($routeParams.endDate);
        getDownloadSourceName();
        $scope.refreshGrid();
    }

    function getDownloadSourceName() {
        $http.get("/Confirm/InterfaceReconciliations/{id}/SourceName".assign({ id: $scope.current.fileId }), {trackerMsg: 'Loading download source name'})
            .then(function(response){
                $scope.current.downloadSourceName = response.data;
            });
    }

    // PUBLIC METHODS
    $scope.refreshGrid = function( ) {
        $scope.$broadcast('event:confirm-download-file-action', {action: 'refresh-grid'});
    };


    // INITIALIZE
    $scope.rightsConfirmation = $oasRights.forCode("INTERFACERECON");

    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        startDate: Date.create('a month ago'),
        endDate: Date.create('today'),
        fileId: $routeParams.id,
        downloadSourceName: '',
        recordType: null,
        url: '/Confirm/DownloadFiles/Details',
        entityContextLinks: null
    };

    switch( $routeParams.type ) {
        case "position":
            $scope.current.recordType = entities.downloadPosition;
            break;
        case "transaction":
            $scope.current.recordType = entities.downloadTransaction;
            break;
    }

    init( );

});
'use strict';

var downloadRecordListCtrl = app.controller('DownloadRecordListCtrl', function DownloadRecordListCtrl($rootScope, $scope, $userMessages, $http, $q, $routeParams, $oasRights, $timeout, $dialog, $portfolio, API_CONFIG, views, confirmRecordStatus, apps, entities, $settings, $location, $confirmation, ConfirmationOverview, Entity, Repo, tokenFactory, $reconServicesHelper, splitIoService) {
    // PRIVATE VARIABLES
    var rows = [];
    var selectedRows = [];

    var settingName = "originalUrl";
    var originalUrl;
    var fileIdList = $routeParams.fileIdList != null && $routeParams.fileIdList != '' ? $routeParams.fileIdList : '';

    // PRIVATE METHODS
    function init() {
        if ($scope.current.downloadRecordType === entities.downloadPosition || $scope.current.downloadRecordType === entities.downloadTransaction) {
            $scope.transactionHistory = {
                cusip: '',
                accountNumber: '',
                transactions: [],
                sortField: 'transDate',
                sortReverse: true,
                totalAmount: null,
                totalUnits: null,
                clientId: null,
                registrationId: null,
                accountId: null,
                assetId: null,
                entityLoaded: null,
                shareDifference: null,
                pagination: {
                    totalItems: 0,
                    currentPage: 1,
                    itemsPerPage: 20,
                    maxSize: 10
                }
            };

            loadTransactionTypes();
            loadTradeStatuses();
            loadSleeveColumns();
        }

        originalUrl = $settings.getSetting(settingName);
        if (!originalUrl) {
            originalUrl = $location.url();
            $settings.setSetting("originalUrl", originalUrl);
        }

        if ($scope.current.isMultipleDatabases) showDatabases();

        if (!$scope.current.isAdvisorContext && !$scope.current.isMultipleDatabases) {
            $dialog.confirmNavigation('Not all tools are available in this database.  Would you like to open this file in the advisor context?', true).open().then(function (result) {
                if (result !== 'yes') return $q.reject();
                tokenFactory.getDatabaseToken($scope.current.file.__database__).then(function (token) {
                    window.open(redirectUrl($location.url(), token));
                });
            })
        }
        //set initial page size selection and initialize the grid and paging controls
        $scope.current.pagination.itemsPerPage = localStorage.confirmItemsPerPage != null ? JSON.parse(localStorage.confirmItemsPerPage) : $scope.current.pagination.pageSizes[0];
        updateGridAndPagingParams();
    }

    function showDatabases( ) {
        $scope.current.view.slickGridColumnDefs.unshift({
            formatter: function DatabaseFormatter(row, cell, value, columnDef, dataContext) {
                return '<i class="fa fa-database" aria-hidden="true"></i> ' + value;
            },
            conditionType:"basicNumber",
            cssClass:"db-col",
            field: "__database__",
            headerCssClass: "db-col",
            id: "oasdatabase",
            name: "Database",
            sortOrder:-1,
            visible: true,
            width: 100
         })
    }

    // GLOBAL
    function redirectUrl(path, token) {
        return window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html?p=" + encodeURIComponent(path) +"&t=" + token;
    }

    // GLOBAL
    function loadFiles(config) {
        var params = {
            downloadStatus: $scope.confirmRecordStatus.filter(function (s) {
                return s.selected
            }).map('queryString'),

            recordType: $scope.current.type,
            accountNumber: $scope.current.filterAccountNumber,
            memoCode: $scope.current.memoCode === 0 ? null : $scope.current.memoCode,
            cusip: $scope.current.selectedSearchByField === '3' ? $scope.current.filterCusip : null,

            startDate: $scope.current.selectedSearchByField === '0' ? $scope.current.filterStartDate.formatted() : null,
            endDate: $scope.current.selectedSearchByField === '0' ? $scope.current.filterEndDate.formatted() : null,
            effStartDate: $scope.current.selectedSearchByField === '1' ? $scope.current.filterEffStartDate.formatted() : null,
            effEndDate: $scope.current.selectedSearchByField === '1' ? $scope.current.filterEffEndDate.formatted() : null
        };

        if ($scope.current.pagination.currentPage > 1 && $scope.current.takeInterval) {
            params.$skip = ($scope.current.pagination.currentPage - 1) * $scope.current.takeInterval;
        }

        return ($scope.current.files.length > 0 && ($scope.current.selectedSearchByField === '2' || !$scope.current.selectedFileType)
                ? Repo.merge(ConfirmationOverview.files.getAllDetailed.multi(
                    $scope.current.files.groupBy('__database__'),
                    function (database, files) {
                        return angular.merge({
                            database: database,
                            track: true,
                            params: angular.merge(params, {
                                downloadFileId: files.map('id').join(',')
                            })
                        }, config, true);
                    }
                ))
                : ConfirmationOverview.files.getAllDetailed(angular.merge(config, {params: params}))
        ).then(function (response) {
            $scope.current.pagination.totalItems = getRecordCountFromHeader(response);
            setKeys(response.data);
            if (!$scope.preventLoad) {
                return response;
            }
            return null;
        });
    }

    function getRecordCountFromHeader(response) {
        var recordCount = 0;
        if (response.headers && response.headers("RecordCount")) {
            recordCount = parseInt(response.headers("RecordCount"));
        }
        else if (response.responses) {
            for (var key in response.responses) {
                if (response.responses.hasOwnProperty(key) && response.responses[key].headers && response.responses[key].headers("RecordCount")) {
                    recordCount += parseInt(response.responses[key].headers("RecordCount"));
                }
            }
        }
        return recordCount;
    }

    function setKeys(records) {
        records.each(setKey);
        return records;
    }

    function setKey(record) {
        Object.defineProperty(record, 'compositeKey', {value:[record.databaseId,record.downloadFileId,record.id].join('-')});
        return record;
    }

    // ADVISOR
    function doAction( actionUrl, trackerVerb, completedVerb, confirmMsg, isVerifyApply, forDatabaseGroups ) {
        $dialog.confirmAction( confirmMsg ).open( )
            .then(function(result){
                if( result === 'yes' ) {
                    var msg = isVerifyApply ? "Verify/Apply " : "Undo ";
                    if( forDatabaseGroups ) {
                        var promises = [];
                        $scope.current.databaseGroupsLocked = true;
                        for( var i = 0; i < $scope.current.databaseGroups.length; i++ ) {
                            promises.push( getActionForDatabase( actionUrl, trackerVerb, $scope.current.databaseGroups[i] ) );
                        }
                        $q.all(promises).then(function (responses) {
                            for( var i = 0; i < $scope.current.databaseGroups.length; i++ ) {
                                $scope.current.databaseGroups[i].batchProcessingId = responses[i].data;
                                $scope.current.databaseGroups[i].status = "Started";
                            }

                            startPollingStatusForDatabases( $scope.current.databaseGroups );
                        });
                    } else {
                        $http.put(actionUrl, $scope.selectedItems.map('id'), {trackerMsg: 'Submitting ' + trackerVerb + ' request'}).then(function (response) {
                            if( response && response.data ) {
                                startPollingStatus( response.data, completedVerb, msg + "request of " + $scope.selectedIds.length + " records" );
                            }
                        });
                    }
                }
            });
    }

    function getActionForDatabase( actionUrl, trackerVerb, databaseGroup ) {
        var databaseActionUrl = actionUrl.replace( "?", "?Authorization=" + databaseGroup.token + "&");
        return $http.put(databaseActionUrl, databaseGroup.downloadRecords, {trackerMsg: 'Submitting ' + trackerVerb + ' request'});
    }

    // ADVISOR
    $scope.verify = function (insightsSource, forDatabaseGroups) {
        doAction('/confirm/overview/action/verifyapply/records?' + getVerifyApplyQueryString(false), 'verify', 'verified', 'Verify record(s).  Are you sure you want to proceed?', true, forDatabaseGroups);
    };

    // ADVISOR
    $scope.apply = function( insightsSource, forDatabaseGroups ) {
        let user = JSON.parse(sessionStorage.oas_authorization);

        applyWithPercentDialogCheck(confirmCtrl, user, forDatabaseGroups, insightsSource);

        function confirmCtrl($scope, dialog, confirmMsg, body) {
            $scope.showError = false;
            $scope.current = {
                confirmMsg: confirmMsg,
                typedMsg: null,
                body: body
            };
            $scope.controls = {
                close: close,
                checkError: checkError
            };

            function close(bool) {
                if (bool) {
                    checkError();
                    if (!$scope.showError) {
                        dialog.close(true);
                    }
                } else {
                    dialog.close();
                }
            }

            function checkError() {
                $scope.showError = ($scope.current.typedMsg === null) ? true : $scope.current.confirmMsg.toLowerCase().localeCompare($scope.current.typedMsg.toLowerCase()) !== 0;
            }
        }
    };

    function applyWithPercentDialogCheck(confirmCtrl, user, forDatabaseGroups, insightsSource) {


        var verifyApplyUrl = '/confirm/overview/action/verifyapply/records?';

        if ($scope.params.toleranceOverride) {
            $dialog.dialog({
                templateUrl: 'confirmation/modals/verificationModal.html',
                controller: ['$scope', 'dialog', 'confirmMsg', 'body', confirmCtrl],
                resolve: {
                    confirmMsg() { return `I ${user.firstName} ${user.lastName} have done the appropriate review and have made the determination that these accounts belong to this database` },
                    body() {
                        return `You are using the override for a Percentage Match Tolerance violation to create
                                new accounts. Please complete thorough review of the new account process, MCL review, and
                                account code verification to ensure that the use of this override will not result in a
                                violation of the Orion PII Policy. If you?ve completed your review and determined the new
                                accounts should be created please type in the following confirmation message.`;
                    }
                }
            })
                .open()
                .then(function (res) {
                    if (res) { doAction(verifyApplyUrl + getVerifyApplyQueryString(true), 'apply', 'applied', 'Apply records(s).  Are you sure you want to proceed?', true, forDatabaseGroups) };
                })
                ;
        } else {
            doAction(verifyApplyUrl + getVerifyApplyQueryString(true), 'apply', 'applied', 'Apply records(s).  Are you sure you want to proceed?', true, forDatabaseGroups);
        }

    }

    // ADVISOR
    $scope.undo = function( insightsSource, forDatabaseGroups ) {
        var url = '/confirm/overview/action/undo/records?recordtype=';

        doAction(url + $scope.current.downloadRecordType.confirmRecordType, 'undo', 'undone', 'Undo record(s).  Are you sure you want to proceed?', false, forDatabaseGroups);
    };

    // ADVISOR
    function getVerifyApplyQueryString(apply) {
        return Object.toQueryString(angular.extend({recordType: $scope.current.downloadRecordType.confirmRecordType, apply: apply}, $scope.params));
    }

    function startOldPollingStatus(batchId, completedVerb,groupName) {
        
        var lastData;
        var parentId = batchId;
        var sameDataCount = 0;
        var errorCount = 0;
        var erroredBatchProcessings = [];

        var pollStatus = function (batchId) {
            if (sameDataCount > 200) {
                $rootScope.$broadcast('event:progress-update', { id: parentId, isDone: true, msg: parentId + ": Status updates aborted", type: "warning" });
                $userMessages.addConfirmationMsg(parentId + ": Took too long", "The process is taking longer than expected.  Status polling has been aborted.", "warning");
                return;
            }

            if (errorCount > 25) {
                if (parentId) $rootScope.$broadcast('event:progress-update', { id: parentId, isDone: true, msg: parentId + ": Status updates aborted", type: "warning" });
                $userMessages.addConfirmationMsg(parentId + ": Status polling failed", "The status check has erred out 25 times.  Status polling has been aborted.", "warning");
                return;
            }

            $http.get("/Confirm/Overview/CheckStatus/" + batchId + "?includeErrors=true", { ignoreExceptions: true })
                .then(function (response) {
                    var data = response.data;
                    if (angular.equals(data, lastData)) {
                        sameDataCount += 1;
                        $timeout(function () { pollStatus(batchId); }, 5000);
                        return;
                    }

                    sameDataCount = 0;

                    var progress = { id: parentId, completed: data.itemsCompleted, total: data.totalItems };

                    if (data.isDone) {
                        if (data.errorCount > 0 && data.details != null && data.details.length > 0) {
                            data.details.forEach((detail) => {
                                erroredBatchProcessings.push(detail.id);
                                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Error", detail.id + ': Failed - ' + detail.errorMessage, [{ result: 'OK', label: 'OK', cssClass: 'btn-primary', focus: true }]).open();
                            });
                            
                        }

                        progress.isDone = true;
                        $userMessages.addConfirmationMsg(parentId + ": " + data.itemsCompleted + " record(s) " + completedVerb + ' (' + groupName + ')', data.message, progress.type);
                        $scope.refreshGrid();
                    }
                    else
                        $timeout(function () { pollStatus(batchId); }, 5000);

                    $rootScope.$broadcast('event:progress-update', progress);
                    lastData = data;
                })
                .catch(function () {
                    errorCount += 1;
                    $timeout(function () { pollStatus(batchId); }, 20000);
                });
        };

        pollStatus(batchId);
    }

    

    // ADVISOR
    function startPollingStatus(response, completedVerb, groupName) {
        startOldPollingStatus(response, completedVerb, groupName);
    }

    function startPollingStatusForDatabases( databaseGroups ) {
        var lastBatchProcessings;
        var sameDataCount = 0;
        var errorCount = 0;

        var pollStatusForDatabases = function( databaseGroups ) {

            if( sameDataCount > 60 ) {
                $userMessages.addConfirmationMsg("Verify/Apply/Undo took too long.  Status polling has been aborted.", "warning");
                return;
            }

            if( errorCount > 5 ) {
                $userMessages.addConfirmationMsg("Verify/Apply/Undo status check has erred out 5 times.  Status polling has been aborted.", "warning");
                return;
            }

            var batchIds = getBatchProcessingIds( databaseGroups );

            if( batchIds.length === 0 ) {
                return;
            }

            $http.post("/Utility/BatchProcessing/List?includeErrors=true", batchIds, {ignoreExceptions: true})
                .then(function(response) {
                    var batchProcessings = response.data;
                    databaseGroups.lastRefresh = Date.create('now');

                    if( angular.equals(batchProcessings, lastBatchProcessings) ) {
                        sameDataCount += 1;
                        $timeout(function() { pollStatusForDatabases( databaseGroups ); }, 30000);
                        return;
                    }

                    sameDataCount = 0;

                    var isDone = updateDatabaseGroupsStatus( databaseGroups, batchProcessings );

                    if( isDone ) {
                        $userMessages.addConfirmationMsg("Verify/Apply/Undo complete", "success");
                        $scope.current.databaseGroupsLocked = false;
                        $scope.refreshGrid( );
                    }
                    else {
                        $timeout(function() { pollStatusForDatabases( databaseGroups ); }, 15000);
                    }

                    lastBatchProcessings = batchProcessings;
                })
                .catch(function() {
                    errorCount += 1;
                    databaseGroups.lastRefresh = Date.create('now');
                    $timeout(function() { pollStatusForDatabases( databaseGroups ); }, 30000);
                });
        };

        pollStatusForDatabases( databaseGroups );
    }

    function getBatchProcessingIds( ) {
        var batchIds = [];
        for( var i = 0; i < $scope.current.databaseGroups.length; i++ ) {
            batchIds.push( $scope.current.databaseGroups[i].batchProcessingId );
        }
        return batchIds;
    }

    function updateDatabaseGroupsStatus( databaseGroups, batchProcessings ) {
        var isDone = true;
        for( var i = 0; i < batchProcessings.length; i++ ) {
            var dbgIdx = databaseGroups.findIndex({ batchProcessingId: batchProcessings[i].id });
            if( batchProcessings[i].status === "Complete" ) {
                databaseGroups[dbgIdx].status = "Complete";
            }else if( batchProcessings[i].status === "Failed" ) {
                databaseGroups[dbgIdx].status = "Failed";
            } else {
                isDone = false;
                databaseGroups[dbgIdx].status = batchProcessings[i].status;
            }
        }
        return isDone;
    }

    // ADVISOR
    $scope.findReplace = function( findReplaceFlag ) {
        $dialog.inputBox('Find & Replace', " ", "findReplace", {findString: '', replaceString: ''} ).open().then(function(options) {
            if( options ) {
                options.findReplaceFlag = findReplaceFlag;
                return Repo.merge(ConfirmationOverview.files.findReplace.multi(
                    $scope.selectedItems.groupBy('downloadFileId'),
                    function(downloadFileId, items) {
                        return {
                            params: { downloadFileId: downloadFileId, findString: options.findString, replaceString: options.replaceString, findReplaceFlag: findReplaceFlag },
                            database: items[0].__database__,
                            data: items.map('id')
                        }
                    }
                )).then(function() {
                    $scope.refreshGrid( );
                });
            }
        });
    };

    $scope.prefix = function( ) {
        $dialog.inputBox('Prefix', " ", "text", null ).open().then(function(text) {
            if( text && text.length > 0 ) {
                return Repo.merge(ConfirmationOverview.files.prefix.multi(
                    $scope.selectedItems.groupBy('downloadFileId'),
                    function(downloadFileId, items) {
                        return {
                            params: { downloadFileId: downloadFileId, prefixFlag: 32, prefixString: text },
                            database: items[0].__database__,
                            data: items.map('id')
                        };
                    }
                )).then(function(response){
                    $scope.$broadcast( 'event:confirm-download-file-action', {action: 'update-items', items: setKeys(response.data) } );
                });
            }
        });
    };

    $scope.proper = function( properFlag ) {
        return Repo.merge(ConfirmationOverview.files.proper.multi(
            $scope.selectedItems.groupBy('downloadFileId'),
            function(downloadFileId, items) {
                return {
                    params: { downloadFileId: downloadFileId, properFlag: properFlag },
                    database: items[0].__database__,
                    data: items.map('id')
                }
            }
        )).then(function() {
            $scope.refreshGrid( );
        });
    };

    // ADVISOR
    $scope.resetFile = function( ) {
        $dialog.confirmAction("Do you want to reset the file(s)?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    return Repo.merge(ConfirmationOverview.files.resetFile.multi(
                        $scope.selectedItems.groupBy('downloadFileId'),
                        function(downloadFileId, items) {
                            return {
                                params: {downloadFileId: downloadFileId},
                                database: items[0].__database__,
                                data: items.map('id')
                            }
                        }
                    )).then(function() {
                        $scope.refreshGrid( );
                    });
                }
            });
    };

    $scope.manualConfirmDetails = function( ) {
        $dialog.dialog({templateUrl: "manual-confirm-details.html", controller: "ManualConfirmDetailsCtrl"})
            .open()
            .then(function (rslt) {
                if (!rslt) return;
                return Repo.merge(ConfirmationOverview.files.manualConfirmDetails.multi(
                    $scope.selectedItems.groupBy('__database__'),
                    function (database, items) {
                        return {
                            params: rslt,
                            database: database,
                            data: items.map('id')
                        }
                    }
                )).then(function () {
                    $scope.refreshGrid();
                });
            });

    };

    $scope.manualExcludeDetails = function( ) {
        return Repo.merge(ConfirmationOverview.files.manualExcludeDetails.multi(
            $scope.selectedItems.groupBy('__database__'),
            function(database, items) {
                return {
                    database: database,
                    data: items.map('id')
                }
            }
        )).then(function() {
            $scope.refreshGrid( );
        });
    };

    // GLOBAL
    $scope.revertBackToFile = function( ) {
        if ($location.url() === originalUrl ){
            $scope.current.selectedFileType = null;
            $scope.current.selectedSearchByField= null;
            $scope.confirmRecordStatus.forEach(function (status) {
                status.selected = (status === confirmRecordStatus.notConfirmed);
            });
            $scope.refreshGrid()
        }
        else{
            $location.url(originalUrl)
        }
    };

    // TODO
    $scope.reloadGrid = function () {
        $scope.preventLoad = false;
        if (
            $scope.current.selectedFileType &&
            $scope.current.selectedSearchByField !== null
        ){
            var params = {
                memoCode: $scope.current.memoCode === 0 ? null : $scope.current.memoCode,
                downloadStatus: $scope.confirmRecordStatus.filter(function (s) { return s.selected }).map('queryString').join(','),
                accountNumber: $scope.current.filterAccountNumber != null && $scope.current.filterAccountNumber != '' ? $scope.current.filterAccountNumber : null,
                cusip: $scope.current.selectedSearchByField === '3' ? $scope.current.filterCusip : null,
                startDate: $scope.current.selectedSearchByField === '0' ? $scope.current.filterStartDate.format('{MM}-{dd}-{yyyy}') : null,
                endDate: $scope.current.selectedSearchByField === '0' ? $scope.current.filterEndDate.format('{MM}-{dd}-{yyyy}') : null,
                effStartDate: $scope.current.selectedSearchByField === '1' ? $scope.current.filterEffStartDate.format('{MM}-{dd}-{yyyy}') : null,
                effEndDate: $scope.current.selectedSearchByField === '1' ? $scope.current.filterEffEndDate.format('{MM}-{dd}-{yyyy}') : null,
                searchByField: $scope.current.selectedSearchByField && $scope.current.selectedSearchByField !== '-1' ? $scope.current.selectedSearchByField : null,
                fileIdList: $scope.current.selectedSearchByField === '2' ? $scope.current.filterFileId : fileIdList,
                notesId: $routeParams.notesId != null && $routeParams.notesId != '' ? $routeParams.notesId : null,
                accountHistory: $routeParams.accountHistory != null && $routeParams.accountHistory != '' ? $routeParams.accountHistory : null
            };
            $location.path('/confirmation/files/' + $scope.current.selectedFileType.name.replace(/ /g, '')).search(params);
        }
        else{
            $scope.refreshGrid()
        }
    };

    // TODO
    $scope.setSearchFilters = function(){
        $scope.current.selectedSearchByField = null;
        $scope.current.filterStartDate = $settings.getSetting('confirmStartDate');
        $scope.current.filterEndDate = $settings.getSetting('confirmEndDate');
        $scope.current.filterEffStartDate = $settings.getSetting('confirmStartDate');
        $scope.current.filterEffEndDate = $settings.getSetting('confirmEndDate');
        $scope.current.filterFileId = null;
        $scope.current.filterCusip = null;
        setSearchByField()
    };

    // GLOBAL
    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1) $scope.openRecordEditor(false);
    };

    // GLOBAL
    function loadTransactionTypes( ) {
        return $http.get('/Trading/TransactionTypes', {trackerMsg: 'Loading transaction types'})
            .then(function (r) {
                $scope.transactionTypes = r.data.sortBy('description');
            });
    }

    function saveSleeveColumnData() {
        var sleeveDataDtos = [];
        $scope.current.columns.forEach((column) => {
            sleeveDataDtos.push({
                "ColumnSize": column.ColumnSize,
                "ColumnEnabled": column.ColumnEnabled,
                "ColumnName": column.ColumnName,
                "ColumnCodeName": column.ColumnCodeName
            });
        });

        $http.put('/Confirm/DownloadFiles/SleeveColumnData', sleeveDataDtos ,{ trackerMsg: 'Saving sleeve column view' });
    }

    function loadSleeveColumns() {
        if ($scope.current.loadedSleeveColumns != true) {
            $scope.current.loadedSleeveColumns = true;
            ConfirmationOverview.files.getSleeveColumnData().then((response) => {
                var parsedData = JSON.parse(response.data);
                $scope.current.columns = [];
                parsedData.forEach((columnData) => {
                    columnData.Column.ColumnEnabled = columnData.Column.ColumnEnabled.toLowerCase() === "true";
                    var columnSize = parseInt(columnData.Column.ColumnSize);
                    if (columnSize !== "NaN") {
                        columnData.Column.ColumnSize = columnSize;
                    } else {
                        columnData.Column.ColumnSize = 100;
                    }

                    $scope.current.columns.push(columnData.Column);
                });
            });
        }

    }

    function loadSleeveData() {
        if ($scope.current.selectedTransactionIds !== null && $scope.current.selectedTransactionIds !== undefined) {
            var transactionIds = $scope.current.selectedTransactionIds;

            $http.post("/Confirm/DownloadFiles/SleeveData", transactionIds, { trackerMsg: 'Loading sleeve data' }).then((response) => {
                if (response.data !== '' && response.data !== null && response.data !== undefined) {
                    var parsedData = JSON.parse(response.data);
                    $scope.current.sleeveData = parsedData;
                    $scope.current.sleeveDataFiltered = parsedData;
                }
                
            });
        }
    }


     $scope.filterOnClick = function ($event) {
        
         if ($event.currentTarget.parentElement.classList.contains('visible')) {
             $event.currentTarget.parentElement.classList.remove('visible');
        }
        else {
             $event.currentTarget.parentElement.classList.add('visible');
        }
    }

    // GLOBAL
    function loadTradeStatuses( ) {
        return $http.get("/Trading/TradeStatuses", {cache: true, trackerMsg: 'Loading trade statuses', ignoreExceptions: true})
            .then(function (r) {
                $scope.tradeStatuses = r.data;
            });
    }

    // TODO
    function setSearchByField(){
        $scope.searchByFields = [
            {name: "Created Date", value: "0"},
            {name: "Effective Date", value: "1"},
            {name: "File ID", value: "2"}
        ];

        if ($scope.current.selectedFileType.value !== entities.downloadDividend.confirmRecordType){
            $scope.searchByFields.push({name: "CUSIP", value: "3"})
        }
    }

    function buildDatabaseGroups( rows ) {
        $scope.current.databaseGroups = [];
        for( var i = 0; i < rows.length; i++ ) {
            var d = $scope.current.databaseGroups.find( {alClientId: rows[i].databaseId} );
            if( d ) {
                d.downloadRecords.push( rows[i].id );
                d.downloadFiles.push( rows[i].downloadFileId );
            } else {
                $scope.current.databaseGroups.push( {token: "", databaseName: rows[i].databaseName, alClientId: rows[i].databaseId, downloadRecords: [rows[i].id], downloadFiles: [rows[i].downloadFileId], batchProcessingId: 0, status: 'Not started', lastRefresh: null} );
            }
        }

        for( var i = 0; i < $scope.current.databaseGroups.length; i++ ) {
            $scope.current.databaseGroups[i].downloadFiles = $scope.current.databaseGroups[i].downloadFiles.unique( );
        }

        var promises = $q.all($scope.current.databaseGroups.map(function (databaseGroup) { return tokenFactory.getDatabaseToken(databaseGroup.alClientId);}));
        promises.then(function (allTheTokens) {
            Object.each(allTheTokens, function (key, value) {
                $scope.current.databaseGroups[key].token = value;
            });
        });
    }

    // PUBLIC METHODS
    $scope.refreshGrid = function( ) {
        $timeout(function() {
            $scope.$broadcast('event:confirm-download-file-action', {action: 'refresh-grid'});
        });
    };

    // ADVISOR
    $scope.openEntityEditor = function(link) {
        $portfolio.openEditor( entities[entities.find({name: link.entity})].value, [link.entityId], null, null, apps.confirmation.name, null );
    };

    $scope.openProductEditor = function (productId) {
        const d = $dialog.editor("products/editors/product-edit.html", "ProductEditCtrl", {
            args: function () {
                return {
                    id: productId,
                    app: apps.confirmation,
                    defaultTab: {name: "Local", active: true, code: "productGeneral"},
                    extraInfo: null,
                    isNewGlobal: false,
                    isNewLocal: false
                };
            }
        });

        d.open().then(function (rslt) {
            if (rslt) {
                $scope.$broadcast('event:confirm-download-file-action', {action: 'refresh-grid'});
            }
        });
    };

    // GLOBAL
    $scope.createTransactionFileFromPositionFile = function () {

        splitIoService.getBoolTreatment('recon_confirm_newtransactionfromposition_187091').subscribe((isEnabled) => {
            if (isEnabled) {
                return Repo.merge(ConfirmationOverview.files.createTransactionsFromPosition.multi(
                    $scope.selectedItems.groupBy('databaseId'),
                    function (databaseId, items) {
                        return {
                            database: databaseId,
                            data: items.map('id')
                        }
                    }
                )).then(function (response) {
                    if (response && response.data) {
                        var newFileIds;
                        var newConfirmOverviewId = response.data[0].confirmOverviewId;
                        var newDownloadSourceId = response.data[0].downloadSourceId;
                        if ($scope.current.isMultipleDatabases) {
                            newFileIds = response.data.map(function(file) {
                                return ['AL'+file.alClientId, file.downloadFileId].join(':') 
                            }).join(',')
                        } else {
                            newFileIds = response.data.map(d => d.downloadFileId).join(',');
                        }
                        window.open(redirectUrl(`/confirmation/files/Transaction?notesId=${newConfirmOverviewId}-${newDownloadSourceId}&fileIdList=${newFileIds}`, $scope.databaseToken), '_blank');
                    }
                });                            
            } else {
                return Repo.merge(ConfirmationOverview.files.transactionFromPosition.multi(
                    $scope.selectedItems.groupBy('downloadFileId'),
                    function (downloadFileId, items) {
                        return {
                            params: { downloadFileId: downloadFileId },
                            database: items[0].__database__,
                            data: items.map('id')
                        }
                    }
                )).then(function () {
                    $dialog.messageBox('Success', 'Transactions created.').open();
                });
            }
        });
    };

    $scope.createAutoJournal = function( ) {
        return ConfirmationOverview.journaling.createAutoJournal().then(function(){
            return $dialog.messageBox( 'Success', 'Auto Journal Created').open( );
        });
    };

    $scope.openRecordEditor = function( ) {
        if( $scope.selectedIds.length === 1 ) {
            return $dialog.editor('confirmation/editors/views/download-' + $routeParams.type.dasherize() + '-edit.html', 'DownloadRecordEditCtrl', {args: function () {
                return {
                    item: $scope.selected,
                    id: $scope.selected.id,
                    fileId: $scope.selected.downloadFileId,
                    downloadRecordType: $scope.current.downloadRecordType,
                    defaultTab: {name: "General", active: true, code: "general"}
                };
            }}).open().then(function (rslt) {
                if( rslt ) {
                    $scope.$broadcast( 'event:confirm-download-file-action', { action: 'update-item', item: setKey(rslt) } );
                }
            });
        } else {
            return $confirmation.openMassEditor($scope.current.downloadRecordType.value, $scope.selectedItems, apps.confirmation.name, {downloadType: $routeParams.type}).then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast('event:confirm-download-file-action', {action: 'update-items', items: setKeys(rslt)});
                }
            });
        }
    };

    // GLOBAL
    $scope.downloadFile = function() {
        return tokenFactory.getDatabaseToken($scope.current.file.__database__).then(function(token){
            window.location.href = API_CONFIG.baseUrl + '/Confirm/DownloadFiles/' + $scope.current.file.id + '/Download' + '?Authorization=' + token;
        })
    };

    // GLOBAL
    $scope.exportToExcel = function() {
        $scope.$broadcast('event:confirm-download-file-action', {action: 'export-data'});
    };

    $scope.addToExclusion = function (addAsset) {
        if( selectedRows.length > 1 ) {
            //UI only allows for 1 record at a time
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Multiple Records Selected", "Select one record to proceed.").open();
        }
        $dialog.dialog({templateUrl: "confirmation/modals/addToExclusion.html", controller: "AddToExclusionCtrl", info: selectedRows, isAsset: addAsset})
        .open()
        .then(function (result) {
            if (!result) return;

            let exclusionRecord = {
                accountNumber: result.accountNumber,
                cusip: addAsset ? result.cusip : null,
                notes: result.notes,
                downloadFormatId: result.downloadFormat,
                downloadSourceId: result.downloadSourceId
            };
            
            $http.post('/Confirm/Exclusions', exclusionRecord, {trackerMsg: 'Adding record to exclusion table'})
                .then(function() {
                    $dialog.actionComplete("The exclusion record has been added.").open();
                });
        }
        );
    };
    
    // GLOBAL
    $scope.removeFromExclusion = function (removeAsset) {
        return Repo.merge(ConfirmationOverview.exclusions.getAll.each(selectedRows,
            function(item) {
                return {
                    database: item.__database__,
                    params: {
                        accountNumber: item.accountNumber,
                        cusip: removeAsset ? item.cusip : ''
                    }
                }
            }
        )).then(function(exclusions){
            if (exclusions.data.length) {
                return $q.all(ConfirmationOverview.exclusions.deleteMany.multi(exclusions.data.groupBy('__database__'),
                    function(database, e){
                        return {
                            database: database,
                            data: e.map('id')
                        }
                    }
                )).then(function(){
                    return $dialog.messageBox("<i class='fa fa-check-circle fa-lg text-success' aria-hidden='true'></i> Permanent Exclusion Action", "The selected " + (removeAsset ? 'asset(s)' : 'account(s)') + " were successfully removed from the exclusion table.").open();
                });
            } else {
                return $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Permanent Exclusion Action", "The selected " + (removeAsset ? 'asset(s)' : 'account(s)') + " could not be found in the exclusion table.  No action was taken.").open();
            }
        });
    };

    // ADVISOR
    $scope.moveSleeveInactiveByReg = function( ) {
        $portfolio.search(entities.registration.value)
                .then(function(rslt) {
                    if( rslt && rslt.entity === entities.registration.value ) {
                        $scope.moveSleeveInactive(rslt.item.id);
                    }
                });
    };

    // ADVISOR
    $scope.moveSleeveInactive = function( id ) {
        return $http.put('/Trading/Sleeve/Registrations' + (id > 0 ? '/' + id : '') + '/Action/MoveInactiveValue', null, {trackerMsg: 'Running sleeve inactive value move'})
                .then(function () {
                    $dialog.actionComplete("Running sleeve inactive value move complete").open();
                });
    };

    $scope.moveSleeveInactiveDatabase = function( ) {
        $dialog.confirmAction("Do you want to perform sleeve inactive value move?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    return Repo.merge(ConfirmationOverview.files.moveSleeveInactiveDatabase.multi(
                        $scope.selectedItems.groupBy('__database__'),
                        function(item) {
                            return {
                                database: item
                            }
                        }
                    )).then(function() {
                        $dialog.actionComplete("Running sleeve inactive value move complete").open();
                    });
                }
            });
    };

    // GLOBAL
    $scope.resetWidth = function(width) {
        $scope.rightSidebar.width = width;
    };

    $scope.resetWidthSleeve = function() {
        $scope.rightSidebar.width = window.innerWidth - 200;
    }


    // ADVISOR
    $scope.sortTransactionHistory = function( sortField ) {
        $scope.transactionHistory.sortField = sortField;
        $scope.transactionHistory.sortReverse = !$scope.transactionHistory.sortReverse;
    };

    // ADVISOR
    $scope.openTransaction = function( transaction ) {
        $portfolio.openEditor( entities.transaction.value, [transaction.id], null, null, apps.portfolioLists.name, null ).then(function(rslt) {
            if( rslt ) {
                angular.extend(transaction, rslt);
            }
        });
    };

    // ADVISOR
    $scope.saveTransactions = function( ) {
        if( $scope.transactionHistory.transactions.length > 0 ) {
            var transactions = [];
            for( var i = 0; i < $scope.transactionHistory.transactions.length; i++ ) {
                if( $scope.transactionHistory.transactions[i].isDirty ) {
                    transactions.push( {id: $scope.transactionHistory.transactions[i].id, portfolio: $scope.transactionHistory.transactions[i] } );
                }
            }

            if( transactions.length > 0 ) {
                $http.put( '/Portfolio/Transactions/Verbose', transactions, { trackerMsg: 'Updating transactions' } )
                    .then( function ( ) {
                        $scope.loadTransactionHistory('assetId=' + $scope.transactionHistory.assetId, entities.asset.value);
                    });
            }
        }
    };

    // ADVISOR
    $scope.newTransaction = function( ) {
        var extraInfo = {fkClient: $scope.transactionHistory.clientId, fkAsset: $scope.transactionHistory.assetId};
        $portfolio.openEditor( entities.transaction.value, [], null, null, apps.portfolioLists.name, extraInfo ).then(function(rslt) {
            if( rslt ) {
                $scope.transactionHistory.transactions.push( rslt );
            }
        });
    };

    // ADVISOR
    $scope.multiEditTransaction = function( ) {
        if( $scope.transactionHistory.transactions.length > 0 ) {
            var transactionIds = [];
            for( var i = 0; i < $scope.transactionHistory.transactions.length; i++ ) {
                if( $scope.transactionHistory.transactions[i].isSelected ) {
                    transactionIds.push( $scope.transactionHistory.transactions[i].id );
                }
            }
            if( transactionIds.length > 0 ) {
                var extraInfo = { fkClient: $scope.transactionHistory.clientId, fkAsset: $scope.transactionHistory.assetId };
                $portfolio.openMassEditor(entities.transaction.value, transactionIds, apps.portfolioLists.name, extraInfo).then(function (rslt) {
                    if (rslt) {
                        $scope.loadTransactionHistory('assetId=' + $scope.transactionHistory.assetId, entities.asset.value);
                    }
                });
            }
        }
    };

    // ADVISOR
    $scope.loadTransactionHistory = function( queryString, entityEnum ) {
        if( $scope.current.downloadRecordType === entities.downloadPosition && $scope.current.transactionHistoryTabActive ) {

            $scope.transactionHistory.entityLoaded = entityEnum;

            $http.get('/Portfolio/Transactions?' + queryString, {trackerMsg : 'Loading transaction history'})
                .then(function (response) {
                    $scope.transactionHistory.transactions = response.data;

                    if( response.data.length > 0 ) {
                        if( entityEnum === entities.asset.value ) {
                            $scope.transactionHistory.clientId = response.data[0].clientId;
                            $scope.transactionHistory.registrationId = response.data[0].registrationId;
                            $scope.transactionHistory.accountId = response.data[0].accountId;
                            $scope.transactionHistory.assetId = response.data[0].assetId;
                        }

                        for( var i = 0; i < response.data.length; i++ ) {
                            $scope.transactionHistory.totalAmount += response.data[i].transAmount;
                            $scope.transactionHistory.totalUnits += response.data[i].noUnits;
                            $scope.transactionHistory.transactions[i].transDate = Date.create( response.data[i].transDate );
                            $scope.transactionHistory.transactions[i]["transDateFriendly"] = Date.create( $scope.transactionHistory.transactions[i].transDate ).format( "{MM}/{dd}/{yyyy}" );
                        }
                    }
                });
        }
    } ;

    $scope.manualUpdatePriceDisabledText = function() {
        if ($scope.selectedItems.some(function(i){ return i.status !== 'Not Confirmed' })) {
            return "All selected prices need to be Not Confirmed";
        }

        if ($scope.selectedItems.some(function(i){ return i.systemPrice === i.price; })) {
            return "All selected prices need to have a price difference";
        }

        if (hasSelectedDuplicatePrices()) {
            return "Duplicate Price selected";
        }
    }

    $scope.showCanManualExcludeAndUpdatePrice = function () {
        return (
            $scope.current.isAdvisorContext &&
            $scope.rightsManualPrice.canUpdate &&
            $scope.current.downloadRecordType?.confirmRecordType == 3 &&
            $scope.selected
        );
    }

    $scope.canManualExcludePrice = function() {
        // All selected prices must be Not Confirmed
        // All selected prices must have a different Price than System Price

        return (
            $scope.showCanManualExcludeAndUpdatePrice() && 
            !$scope.selectedItems.some(function(i){ return i.status !== 'Not Confirmed' }) &&
            !$scope.selectedItems.some(function(i){ return i.systemPrice === i.price; })
        );
    }

    $scope.canManualUpdatePrice = function() {
        // All selected prices must be Not Confirmed
        // All selected prices must have a different Price than System Price
        // All selected prices must have a unique combo of Custodian ID + Product ID + Date

        return (
            $scope.canManualExcludePrice() &&
            !hasSelectedDuplicatePrices()
        );
    };

    function hasSelectedDuplicatePrices() {
        let selectedPrices = $scope.selectedItems.map(p => { return { custodianId: p.custodianId, productId: p.link.productId, effectiveDate: p.effectiveDate }})        ;
        const set = new Set(selectedPrices.map(JSON.stringify));
        return set.size < selectedPrices.length;
    }

    // INITIALIZE
    $scope.rightsConfirmation = $oasRights.forCode("CONFIRM_CONFIRMMANAG");
    $scope.rightsMultiDatabaseRecon = $oasRights.forCode("MULTIPLEDATABASERECON");
    $scope.rightsSleeveSetup = $oasRights.forCode("SLEEVESETUP");
    $scope.rightsExclusions = $oasRights.forCode("DOWNLOADEXCLUSION");
    $scope.rightsDownloadSource = $oasRights.forCode("DOWNLOADSOURCES");
    $scope.rightsManualPrice = $oasRights.forCode("MANUALPRICECONFIRM");
    $scope.rightsProduct = $oasRights.forCode("PRODUCTS");
    $scope.rightsAddMissingTickerCusip = $oasRights.forCode("ADDMISSINGTICKERCUSIP");
    $scope.confirmRecordStatus = confirmRecordStatus.values().each(function (status) {
        if($routeParams.downloadStatus)
            status.selected = !!$routeParams.downloadStatus.split(',').find(status.queryString);
        else status.selected = (status === confirmRecordStatus.notConfirmed);
    });

    $scope.preventLoad = $routeParams.preventLoad === 'true';
    $scope.fileTypes = ConfirmationOverview.default.fileTypes;
    $scope.memoCodes = ConfirmationOverview.default.memoCodes;
    $scope.newAccountCreationValues = ConfirmationOverview.default.newAccountCreationValues;

    $scope.views = views;

    Object.defineProperties($scope, {
        selectedItems: {get: function() {return selectedRows }},
        selectedIds: {get: function() {return selectedRows.map('compositeKey') }},
        selected: {get: function() { return selectedRows[0] || undefined; }},
        rows: {
            get: function() {return rows},
            set: function(newRows) {rows = newRows}
        }
    });

    $scope.sleeveColumnOptionClick = function () {
        $scope.current.ShowSleeveColumnOptions = !$scope.current.ShowSleeveColumnOptions;

        if (!$scope.current.ShowSleeveColumnOptions) {
            saveSleeveColumnData();
        }
    }

    $scope.handleFilterClick = function (columnName, filterValue, $event) {
        

        ////Checks to see whether the value has already been added or not if it hasn't we add if it has we remove it.
        if ($scope.current.filterValues[columnName] !== null && $scope.current.filterValues[columnName] !== undefined && $scope.current.filterValues[columnName].includes(filterValue)) {
            var existingValueIndex = $scope.current.filterValues[columnName].indexOf(filterValue);
            $scope.current.filterValues[columnName].splice(existingValueIndex, 1);
            $event.currentTarget.classList.add("filter_unselected");
            $event.currentTarget.classList.remove("filter_selected");
        } else {
            if ($scope.current.filterValues[columnName] === undefined ||
                $scope.current.filterValues[columnName] === null) {
                $scope.current.filterValues[columnName] = [];
            }
            $event.currentTarget.classList.remove("filter_unselected");
            $event.currentTarget.classList.add("filter_selected");
            $scope.current.filterValues[columnName].push(filterValue);
        }

        $scope.current.sleeveDataFiltered = [];

        $scope.current.sleeveData.forEach((sleeveDataRow) => {
            var isValidMatch = true;
            for (var columnName in $scope.current.filterValues) {
                if (
                    $scope.current.filterValues[columnName] !== null
                    && $scope.current.filterValues[columnName] !== undefined
                    && $scope.current.filterValues[columnName].length > 0
                    && !$scope.current.filterValues[columnName].includes(sleeveDataRow[columnName])) {
                    isValidMatch = false;
                }
            }
            if (isValidMatch) {
                $scope.current.sleeveDataFiltered.push(sleeveDataRow);
            }
        });

        //Loop through each row of the db result then loop through the filters to see what needs to be included and what shouldn't be.
        

        //Loop through one column and see what data is available after that we restrict on the filtered data.
        
    }

    $scope.getUniqueArray = function (columnName) {
        var results = [];
        $scope.current.sleeveData.forEach((sleeveDataRow) => {
            if (!results.includes(sleeveDataRow[columnName])) {
                results.push(sleeveDataRow[columnName]);
            }
        });
        return results;
    }

    $scope.isAccountHistoryView = function () {
        return $routeParams.accountHistory && parseInt($routeParams.accountHistory) === 1;
    };

    var notesId = $routeParams.notesId ? $routeParams.notesId.split('-') : [];
    var overviewId = notesId.length == 2 ? notesId[0] : '';
    var downloadSourceId = notesId.length == 2 ? notesId[1] : '';

    $scope.current = {
        showSleeveDataTab: false,
        ShowSleeveColumnOptions: false,
        columns: [],
        filterValues:[],
        sleeveData:[],
        view: views[0],
        overviewId: overviewId,
        downloadSourceId: downloadSourceId,
        downloadRecordType: entities["download" + $routeParams.type],
        endDate: Date.create('today').formatted(),
        startDate: Date.create('today').formatted(),
        files: Entity.collection(fileIdList ? fileIdList.split(',') : []),
        databaseGroups: [],
        databaseGroupsLocked: false,
        databaseGroupsTabActive: false,
        memoCode: $routeParams.memoCode ? parseInt($routeParams.memoCode) : 0,
        loadedSleeveColumns: false,

        get file() {
            return $scope.selected ? $scope.current.files.find(function(f) {return f.id == $scope.selected.downloadFileId}) : $scope.current.files[0];
        },
        get isMultipleDatabases() {
            return $scope.current.files.databases().length > 1;
        },
        get isAdvisorContext() {
            return $scope.current.files.databases().length <= 1;
        },
        get isMultipleFiles() {
            return $scope.current.files.length > 1;
        },

        type: $routeParams.type,

        selectedSearchByField: null,
        selectedFileType: $routeParams.searchByField ? $scope.fileTypes.find(function(ft){return ft.name.replace(/ /g, '') === $routeParams.type }) : null,  //only set the file search type if already searched files

        filterStartDate: $routeParams.startDate ? Date.create($routeParams.startDate) : $settings.getSetting('confirmStartDate'),
        filterEndDate: $routeParams.endDate ? Date.create($routeParams.endDate) : $settings.getSetting('confirmEndDate'),
        filterEffStartDate: $routeParams.effStartDate ? Date.create($routeParams.effStartDate) : $settings.getSetting('confirmStartDate'),
        filterEffEndDate: $routeParams.effEndDate ? Date.create($routeParams.effEndDate) : $settings.getSetting('confirmEndDate'),
        filterAccountNumber: $routeParams.accountNumber,
        filterFileId: fileIdList,
        filterCusip: $routeParams.cusip,

        grid: {
            load: loadFiles,
            param: {}
        },
        gridDoubleClick: $scope.slickGridDoubleClick,
        pagination: {
            pageSizes: [{ value: 10000, label: '10000' },
                        { value: 25000, label: '25000' },
                        { value: 50000, label: '50000' },
                        { value: 100000, label: '100000' },
                        { value: -1, label: 'All' }],
            totalItems: 0,
            currentPage: 1,
            maxSize: 5,
            itemsPerPage: { value: 0, label: '' }
        }
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        $scope.openRecordEditor( );
    }}];

    if ($scope.current.selectedFileType !== null){
        setSearchByField();
        $scope.current.selectedSearchByField = $routeParams.searchByField
    }

    $scope.params = {
        allowDuplicateTransactions: false,
        allowAddProductToDatabase: false,
        matchDownloadSource: false,
        bypassExclusion: false,
        allowAddDividend: false,
        allowCreateUnverifiedSells: false,
        newAccountCreation: 0,
        priceHolidayOverride: false,
        allowSymbolCreate: false,
        toleranceOverride: false
    };

    //WATCHES
    $scope.$watch('current.transactionHistoryTabActive', function(value) {
        if($scope.current.selectedAssetId && !$scope.transactionHistory.transactions) $scope.loadTransactionHistory( 'assetId=' + $scope.current.selectedAssetId, entities.asset.value );
    });

    $scope.setItemsPerPage = function () {
        try {
            localStorage.confirmItemsPerPage = JSON.stringify($scope.current.pagination.itemsPerPage);
        } catch (e) { }
        updateGridAndPagingParams();
        $scope.refreshGrid();
    };

    function updateGridAndPagingParams(loadAllPages) {
        if (loadAllPages != undefined) {
            $scope.current.loadAllPages = loadAllPages;
        } else {
            $scope.current.loadAllPages = $scope.current.pagination.itemsPerPage.value === -1;
        }
        $scope.current.takeInterval = $scope.current.loadAllPages ? 100000 : $scope.current.pagination.itemsPerPage.value;
        $scope.current.pagination.currentPage = 1;
        $scope.current.pagination.totalItems = 0;
    }

    // EVENT LISTENERS
    $scope.$on('event:confirm-download-file-select', function(e, args) {
        if (!args.length) return;

        $scope.current.memoDescriptionList = (args[0].memoDescriptionList)?args[0].memoDescriptionList:false;
        if( $scope.rightsMultiDatabaseRecon.canUpdate && !$scope.current.databaseGroupsLocked ) {
            buildDatabaseGroups( args );
        }

        selectedRows = Entity.collection(args);
        $scope.current.startDate = args[0].effectiveDate;

        $scope.current.entityContextLinks = [];
        $scope.current.accountHistoryContextLinks = [];
        $scope.current.productId = 0;
        var transactionLinks = [];
        $scope.current.selectedAssetId = null;


        if ($scope.current.downloadRecordType.confirmRecordType === "2")
        {
            $scope.current.selectedTransactionIds = selectedRows.map(q => q.id);
            loadSleeveData();
        }

        $scope.current.isMissingTickerCusip = !!args.flatMap(record => record.memos).find(memo => memo && (memo.memoCode === 322 || memo.memoCode === 444));
        $scope.current.isMissingProduct = !!args.flatMap(record => record.memos).find(memo => memo && memo.memoCode === 324);

        tokenFactory.getDatabaseToken( args[0].databaseId ).then(function(token){
            $scope.databaseToken = token;

            if( $scope.current.downloadRecordType === entities.downloadPosition || $scope.current.downloadRecordType === entities.downloadTransaction ) {
                $scope.transactionHistory.cusip = '';
                $scope.transactionHistory.accountNumber = '';
                $scope.transactionHistory.transactions = null;
                $scope.transactionHistory.totalAmount = null;
                $scope.transactionHistory.totalUnits = null;
                $scope.transactionHistory.householdId = null;
                $scope.transactionHistory.registrationId = null;
                $scope.transactionHistory.accountId = null;
                $scope.transactionHistory.assetId = null;
                $scope.transactionHistory.entityLoaded = null;
                $scope.transactionHistory.shareDifference = null;
            }

            var accountHistoryPath = '/confirmation/files/';
            var accountHistoryQuery = '?downloadStatus=notConfirmed&accountNumber=' + args[0].accountNumber + '&accountHistory=1';

            $scope.current.accountHistoryContextLinks.push({ entity: 'Position', entityId: null, url: redirectUrl(accountHistoryPath + 'Position' + accountHistoryQuery, token) });
            $scope.current.accountHistoryContextLinks.push({ entity: 'Transaction', entityId: null, url: redirectUrl(accountHistoryPath + 'Transaction' + accountHistoryQuery, token) });
            $scope.current.accountHistoryContextLinks.push({ entity: 'Name', entityId: null, url: redirectUrl(accountHistoryPath + 'Name' + accountHistoryQuery, token) });
            $scope.current.accountHistoryContextLinks.push({ entity: 'Cost Basis', entityId: null, url: redirectUrl(accountHistoryPath + 'CostBasis' + accountHistoryQuery, token) });

            if (args[0].link) {
                if( args[0].link.clientId ) {
                    $scope.current.entityContextLinks.push( { entity: "Household", entityId:  args[0].link.clientId, url: redirectUrl($portfolio.getGoToRoute("households", 6, args[0].link.clientId ), token) } );
                }
                if( args[0].link.registrationId ) {
                    $scope.current.entityContextLinks.push( { entity: "Registration", entityId:  args[0].link.registrationId, url: redirectUrl($portfolio.getGoToRoute("registrations", 6, args[0].link.registrationId ), token) } );
                }
                if( args[0].link.accountId ) {
                    $scope.current.entityContextLinks.push({ entity: "Account", entityId: args[0].link.accountId, url: redirectUrl($portfolio.getGoToRoute("accounts", 7, args[0].link.accountId), token) });
                }
                if( args[0].link.assetId ) {
                    $scope.current.entityContextLinks.push( { entity: "Asset", entityId:  args[0].link.assetId, url: redirectUrl($portfolio.getGoToRoute("assets", 8, args[0].link.assetId ), token) } );

                    if( $scope.current.downloadRecordType === entities.downloadPosition || $scope.current.downloadRecordType === entities.downloadTransaction ) {
                        transactionLinks.push( { entity: "Transaction", entityId: null, url: redirectUrl($portfolio.getGoToRoute("assets", 8, args[0].link.assetId ), token).replace( 'assets', 'transactions' ) } );
                        $scope.current.entityContextLinks.add(transactionLinks);
                        $scope.transactionHistory.cusip = args[0].cusip;
                        $scope.transactionHistory.accountNumber = args[0].accountNumber;
                        $scope.transactionHistory.clientId = null;
                        $scope.transactionHistory.registrationId = null;
                        $scope.transactionHistory.accountId = null;
                        $scope.transactionHistory.assetId = null;
                        $scope.transactionHistory.shareDifference = args[0].shareDifference;
                        $scope.current.selectedAssetId = args[0].link.assetId;

                        $scope.loadTransactionHistory( 'assetId=' + args[0].link.assetId, entities.asset.value );
                    }
                }
                if( args[0].link.productId ) {
                    $scope.current.productId = args[0].link.productId;
                }
            }
        });
    });

    $scope.$on('slickgrid-data-loaded', function(event, data) {
        $scope.current.isPriceOrionCopy = (
            data.length > 0 &&
            data.some(function(i){ return i.isCopyForOrion })
        );
    });

    $scope.$on('user-auth-loaded', function (event, data) {
        var clientIdPromise = new Promise((resolve, reject) => {
            $rootScope.user.authorization.alClientId = data;
            $scope.current.files = Entity.collection(fileIdList ? fileIdList.split(',') : []);
        });
        clientIdPromise.then(() => {
            init();
        });
    });

    $scope.$on('$viewContentLoaded', function () {
        var psContainer = document.querySelectorAll(".pageSizeContainer")[0];
        psContainer.style.marginRight = psContainer.clientWidth * -1 + 'px';
    });

    init();
});

downloadRecordListCtrl.loadRecordTypeView = ["$http","$route", function( $http, $route ) {
    return $http.get('/Settings/Views/Download' + ($route.current.params.type === 'CorpAction' ? 'CorporateAction' : $route.current.params.type) + 'DetailDto', {trackerMsg : 'Loading download file view'})
        .then(function(response){
            return response.data;
        });
}];

app.controller('ManualConfirmDetailsCtrl', function ManualConfirmDetailsCtrl($scope, $http, $oasRights, dialog) {

    // PRIVATE METHODS
    function init() {
        $scope.rightsManualPrice = $oasRights.forCode("MANUALPRICECONFIRM");
    }


    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close(null);
    };

    $scope.save = function () {
        dialog.close({reason: $scope.current.reason, notes: $scope.current.notes, isValidated: false});
    };

    $scope.current = {
        notes: '',
        productId: 0,
        reason: null,
        priceReasons: [
            {name: "Third Party Website", id: 1},
            {name: "Institution Website", id: 2},
            {name: "Advisor Confirmed Price", id: 3},
            {name: "Other", id: 4},
            {name: "Multiplying price * factor", id: 5},
            {name: "Bond pricing-first price in", id: 6},
            {name: "Less rounded price", id: 7},
            {name: "Correcting decimal on price", id: 8},
            {name: "Updating CSI price from CSI update records", id: 9},
            {name: "Price is not a USD price", id: 10},
            {name: "Price is from a different effective date", id: 11}
        ]
    };

    $scope.databaseToken = null;

    // INITIALIZE
    init();

});
'use strict';

var downloadRecordListV2Ctrl = app.controller('DownloadRecordListV2Ctrl', function DownloadRecordListCtrl($rootScope, $scope, $userMessages, $http, $q, $routeParams, $oasRights, $timeout, $dialog, $portfolio, API_CONFIG, views, confirmRecordStatus, apps, entities, $settings, $location, $confirmation, ConfirmationOverview, Entity, Repo, tokenFactory, $reconServicesHelper, splitIoService) {
    // PRIVATE VARIABLES
    var rows = [];
    var selectedRows = [];

    var settingName = "originalUrl";
    var originalUrl;
    var fileIdList = $routeParams.fileIdList != null && $routeParams.fileIdList != '' ? $routeParams.fileIdList : '';
    const confirmOverviewFileIdsSessionKey = 'confirm_overview_fileids';

    // PRIVATE METHODS
    function init() {
        // The loadfiles does a similar set of code , why?
        // 1) The init() is necessary to assemble what is necessary for the $scope.current setup
        //      without this, the $scope.current.files etc won't work
        // 2) The code in the loadFiles() is there due to the grid : { load } configuration, we prevent calling the API unneeded if the hash is invalid
        //      without this the API would be called, loading in ALL records
        convertFileIdObjToString();

        if ($scope.current.downloadRecordType === entities.downloadPosition || $scope.current.downloadRecordType === entities.downloadTransaction) {
            $scope.transactionHistory = {
                cusip: '',
                accountNumber: '',
                transactions: [],
                sortField: 'transDate',
                sortReverse: true,
                totalAmount: null,
                totalUnits: null,
                clientId: null,
                registrationId: null,
                accountId: null,
                assetId: null,
                entityLoaded: null,
                shareDifference: null,
                pagination: {
                    totalItems: 0,
                    currentPage: 1,
                    itemsPerPage: 20,
                    maxSize: 10
                }
            };

            loadTransactionTypes();
            loadTradeStatuses();
            loadSleeveColumns();

            splitIoService.getBoolTreatment('recon_confirm_enableagenticai_31991').subscribe((isEnabled) => {
                $scope.current.aiAgentEnabled = isEnabled;
                if (!isEnabled) {
                    var defs = $scope.current.view.slickGridColumnDefs;
                    if (defs && defs.length) {
                        $scope.current.view.slickGridColumnDefs = defs.filter(function (q) {
                            return q.id !== 'Suggestion';
                        });
                    }
                }
            });
        }

        originalUrl = $settings.getSetting(settingName);
        if (!originalUrl) {
            originalUrl = $location.url();
            $settings.setSetting("originalUrl", originalUrl);
        }

        if ($scope.current.isMultipleDatabases) showDatabases();

        if (!$scope.current.isAdvisorContext && !$scope.current.isMultipleDatabases) {
            $dialog.confirmNavigation('Not all tools are available in this database.  Would you like to open this file in the advisor context?', true).open().then(function (result) {
                if (result !== 'yes') return $q.reject();
                tokenFactory.getDatabaseToken($scope.current.file.__database__).then(function (token) {
                    window.open(redirectUrl($location.url(), token));
                });
            })
        }
        //set initial page size selection and initialize the grid and paging controls
        $scope.current.pagination.itemsPerPage = localStorage.confirmItemsPerPage != null ? JSON.parse(localStorage.confirmItemsPerPage) : $scope.current.pagination.pageSizes[0];
        updateGridAndPagingParams();
    }

    function showDatabases( ) {
        $scope.current.view.slickGridColumnDefs.unshift({
            formatter: function DatabaseFormatter(row, cell, value, columnDef, dataContext) {
                return '<i class="fa fa-database" aria-hidden="true"></i> ' + value;
            },
            conditionType:"basicNumber",
            cssClass:"db-col",
            field: "__database__",
            headerCssClass: "db-col",
            id: "oasdatabase",
            name: "Database",
            sortOrder:-1,
            visible: true,
            width: 100
         })
    }

    // GLOBAL
    function redirectUrl(path, token) {
        return window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html?p=" + encodeURIComponent(path) +"&t=" + token;
    }

    function convertFileIdObjToString() {
        let sessionObj = localStorage.getItem(confirmOverviewFileIdsSessionKey);
        let fileIdStringList = '';

        if (sessionObj) {
            sessionObj = JSON.parse(sessionObj);
            let sessionFileIdList = sessionObj.find(sobj => sobj.fileIdHash === $routeParams.fileIdHash);

            if (sessionFileIdList && sessionFileIdList.fileIdList) {
                let sessionFileIdListJson = JSON.parse(sessionFileIdList.fileIdList);
                for (var key in sessionFileIdListJson) {
                    if (sessionFileIdListJson.hasOwnProperty(key) && sessionFileIdListJson[key] && sessionFileIdListJson[key].length > 0) {
                        if (fileIdStringList !== '') {
                            fileIdStringList += ',';
                        }
                        fileIdStringList += sessionFileIdListJson[key].map(function(file, idx){return ['AL'+key,sessionFileIdListJson[key][idx]].join(':') }).join(',');
                    }
                }

                if (fileIdStringList !== '') {
                    fileIdList = fileIdStringList;
                    $scope.current.files = Entity.collection(fileIdStringList ? fileIdStringList.split(',') : []);
                }
            }
        }
        
        return fileIdStringList;
    }

    function showNoFileIdModal() {
        $dialog.actionFailed("The file id list cannot be found. <br><br> You will now be redirected back to the Confirmation Overview List").open().then((result) => {
            $location.url('/confirmation/overview')
        });
        // Return an empty promise to not break slickgrid "loading nothing"
        return $q.resolve({ data: [] });
    }

    function showInvalidRequestObjectModal() {
        $dialog.actionFailed("The AB Compare Screen Failed to provide proper data <br><br> You will now be redirected back to the AB Format Compare list").open().then((result) => {
            $location.url('/confirmation/abcompare')
        });

        // Return an empty promise to not break slickgrid "loading nothing"
        return $q.resolve({ data: [] });
    }

    // GLOBAL
    function loadFiles(config) {
        // The loadfiles does a similar set of code , why?
        // 1) The init() is necessary to assemble what is necessary for the $scope.current setup
        //      without this, the $scope.current.files etc won't work
        // 2) The code in the loadFiles() is there due to the grid : { load } configuration, we prevent calling the API unneeded if the hash is invalid
        //      without this the API would be called, loading in ALL records
        let fileIdStringList = convertFileIdObjToString();
        if ((!fileIdStringList || fileIdStringList === '') && $scope.current.selectedSearchByField !== '4' ) {
            return showNoFileIdModal();
        }

        var params = {
            downloadStatus: $scope.confirmRecordStatus.filter(function (s) {
                return s.selected
            }).map('queryString'),

            recordType: $scope.current.type,
            accountNumber: $scope.current.filterAccountNumber,
            memoCode: $scope.current.memoCode === 0 ? null : $scope.current.memoCode,
            cusip: $scope.current.selectedSearchByField === '3' ? $scope.current.filterCusip : null,

            startDate: $scope.current.selectedSearchByField === '0' ? $scope.current.filterStartDate.formatted() : null,
            endDate: $scope.current.selectedSearchByField === '0' ? $scope.current.filterEndDate.formatted() : null,
            effStartDate: $scope.current.selectedSearchByField === '1' ? $scope.current.filterEffStartDate.formatted() : null,
            effEndDate: $scope.current.selectedSearchByField === '1' ? $scope.current.filterEffEndDate.formatted() : null
        };

        if ($scope.current.pagination.currentPage > 1 && $scope.current.takeInterval) {
            params.$skip = ($scope.current.pagination.currentPage - 1) * $scope.current.takeInterval;
        }

        let loadPromise = null;
        if ($scope.current.files.length > 0 && ($scope.current.selectedSearchByField === '2' || !$scope.current.selectedFileType))
        {
            loadPromise = Repo.merge(ConfirmationOverview.files.getAllDetailedPost.multi(
                $scope.current.files.groupBy('__database__'),
                function (database, files) {
                    return angular.merge({
                        database: database,
                        track: true,
                        data: files.map('id'),
                        params: params
                    }, config, true);
                }
            ));
        }
        else if ($scope.current.selectedSearchByField === '4') {
            //new loading for recordIds
            if ($scope.current.downloadRecordType.confirmRecordType == null
                || $scope.current.fileEntitySessionId == null
                || $scope.current.recordEntitySessionId == null)
            {
                showInvalidRequestObjectModal();
            }

            var request = {
                fileSessionId: $scope.current.fileEntitySessionId,
                recordSessionId: $scope.current.recordEntitySessionId,
                recordType: $scope.current.downloadRecordType.confirmRecordType
            };
            loadPromise = ConfirmationOverview.files.getAllDetailedRecordsBySessions(angular.merge(config, { params: request }));
        }
        else {
            loadPromise = ConfirmationOverview.files.getAllDetailed(angular.merge(config, { params: params }))
        }

        if (loadPromise != null) {
           return loadPromise.then(function (response) {
               $scope.current.pagination.totalItems = getRecordCountFromHeader(response);
               setKeys(response.data);

               if ($scope.current.selectedSearchByField === '4') {
                   $scope.current.files = Entity.collection(response.data.map(item => item.downloadFileId));
               }

               if (!$scope.preventLoad) {
                    return response;
               }
                return null;
            });
        }
    }

    function getRecordCountFromHeader(response) {
        var recordCount = 0;
        if (response.headers && response.headers("RecordCount")) {
            recordCount = parseInt(response.headers("RecordCount"));
        }
        else if (response.responses) {
            for (var key in response.responses) {
                if (response.responses.hasOwnProperty(key) && response.responses[key].headers && response.responses[key].headers("RecordCount")) {
                    recordCount += parseInt(response.responses[key].headers("RecordCount"));
                }
            }
        }
        return recordCount;
    }

    function checkAndDisplaySelectedFinishedPostProcessing(){
        if($routeParams.blocked){
            $dialog.messageBox("These records could not be verified/applied or undo due to their import being in progress.").open();
        }
    }

    function setKeys(records) {
        records.each(setKey);
        return records;
    }

    function setKey(record) {
        Object.defineProperty(record, 'compositeKey', {value:[record.databaseId,record.downloadFileId,record.id].join('-')});
        return record;
    }

    // ADVISOR
    function doAction( actionUrl, trackerVerb, completedVerb, confirmMsg, isVerifyApply, forDatabaseGroups ) {
        $dialog.confirmAction( confirmMsg ).open( )
            .then(function(result){
                if( result === 'yes' ) {
                    var msg = isVerifyApply ? "Verify/Apply " : "Undo ";

                    checkAndDisplaySelectedFinishedPostProcessing();

                    if( forDatabaseGroups ) {
                        var promises = [];
                        $scope.current.databaseGroupsLocked = true;
                        for( var i = 0; i < $scope.current.databaseGroups.length; i++ ) {
                            promises.push( getActionForDatabase( actionUrl, trackerVerb, $scope.current.databaseGroups[i] ) );
                        }
                        $q.all(promises).then(function (responses) {
                            for( var i = 0; i < $scope.current.databaseGroups.length; i++ ) {
                                $scope.current.databaseGroups[i].batchProcessingId = responses[i].data;
                                $scope.current.databaseGroups[i].status = "Started";
                            }

                            startPollingStatusForDatabases( $scope.current.databaseGroups );
                        });
                    } else {
                        $http.put(actionUrl, $scope.selectedItems.map('id'), {trackerMsg: 'Submitting ' + trackerVerb + ' request'}).then(function (response) {
                            if( response && response.data ) {
                                startPollingStatus( response.data, completedVerb, msg + "request of " + $scope.selectedIds.length + " records" );
                            }
                        });
                    }
                }
            });
    }

    function getActionForDatabase( actionUrl, trackerVerb, databaseGroup ) {
        var databaseActionUrl = actionUrl.replace( "?", "?Authorization=" + databaseGroup.token + "&");
        return $http.put(databaseActionUrl, databaseGroup.downloadRecords, {trackerMsg: 'Submitting ' + trackerVerb + ' request'});
    }

    // ADVISOR
    $scope.verify = function (insightsSource, forDatabaseGroups) {
        doAction('/confirm/overview/action/verifyapply/records?' + getVerifyApplyQueryString(false), 'verify', 'verified', 'Verify record(s).  Are you sure you want to proceed?', true, forDatabaseGroups);
    };

    // ADVISOR
    $scope.apply = function( insightsSource, forDatabaseGroups ) {
        let user = JSON.parse(sessionStorage.oas_authorization);

        var includesAutoExcludeRecords = false;
        $scope.selectedItems.forEach((item) =>
        {
            if (item.newAccountCreationStatus === "AutoExclude") {
                includesAutoExcludeRecords = true;
            }
        });

        if (includesAutoExcludeRecords && $scope.params.newAccountCreation === 1)
        {

            let confirmMsg = '';
            let body = '';
            if ($scope.rightsDownloadSource.canUpdate) {
                body = `You are about to create accounts for where the download source is set to auto exclude new accounts.
                                Please complete a thorough review of the new account process, MCL review, and account code verification to ensure that the use of this override will not result in a violation of the Orion PII Policy.
                                If you've completed your review and determined the new accounts should be created please type in the following confirmation message.`;
                confirmMsg = `I ${user.firstName} ${user.lastName} have done the appropriate review and have made the determination that the selected accounts should be created in this autoexclude download source`;
            } else {
                body = `You are trying to create accounts for where the download source is set to auto exclude new accounts.
                            Please complete a thorough review of the new account process, MCL review, and account code verification to ensure that this will not result in a violation of the Orion PII Policy.
                            If you've completed your review and determined the new accounts should be created, please work with a Senior Recon member that has the rights to create the accounts for this situation.`;
            }
            $dialog.dialog({
                templateUrl: 'confirmation/modals/verificationModal.html',
                controller: ['$scope', 'dialog', 'confirmMsg', 'body', confirmCtrl],
                resolve: {
                    confirmMsg() { return confirmMsg },
                    body() {
                        return body;
                    }
                }
            }).open()
                .then(function (res) {
                    if (res) {
                        applyWithPercentDialogCheck(confirmCtrl, user, forDatabaseGroups, insightsSource);
                    };
                })
        } else {
            applyWithPercentDialogCheck(confirmCtrl, user, forDatabaseGroups, insightsSource);
        }

        function confirmCtrl($scope, dialog, confirmMsg, body) {
            $scope.showError = false;
            $scope.current = {
                confirmMsg: confirmMsg,
                typedMsg: null,
                body: body
            };
            $scope.controls = {
                close: close,
                checkError: checkError
            };

            function close(bool) {
                if (bool) {
                    checkError();
                    if (!$scope.showError) {
                        dialog.close(true);
                    }
                } else {
                    dialog.close();
                }
            }

            function checkError() {
                $scope.showError = ($scope.current.typedMsg === null) ? true : $scope.current.confirmMsg.toLowerCase().localeCompare($scope.current.typedMsg.toLowerCase()) !== 0;
            }
        }

    };
    function applyWithPercentDialogCheck(confirmCtrl,user, forDatabaseGroups, insightsSource) {

        
        var verifyApplyUrl = '/confirm/overview/action/verifyapply/records?';

        if ($scope.params.toleranceOverride) {
            $dialog.dialog({
                templateUrl: 'confirmation/modals/verificationModal.html',
                controller: ['$scope', 'dialog', 'confirmMsg', 'body', confirmCtrl],
                resolve: {
                    confirmMsg() { return `I ${user.firstName} ${user.lastName} have done the appropriate review and have made the determination that these accounts belong to this database` },
                    body() {
                        return `You are using the override for a Percentage Match Tolerance violation to create
                                new accounts. Please complete thorough review of the new account process, MCL review, and
                                account code verification to ensure that the use of this override will not result in a
                                violation of the Orion PII Policy. If you've completed your review and determined the new
                                accounts should be created please type in the following confirmation message.`;
                    }
                }
            })
                .open()
                .then(function (res) {
                    if (res) { doAction(verifyApplyUrl + getVerifyApplyQueryString(true), 'apply', 'applied', 'Apply records(s).  Are you sure you want to proceed?', true, forDatabaseGroups) };
                })
                ;
        } else {
            doAction(verifyApplyUrl + getVerifyApplyQueryString(true), 'apply', 'applied', 'Apply records(s).  Are you sure you want to proceed?', true, forDatabaseGroups);
        }
        
    }

    // ADVISOR
    $scope.undo = function( insightsSource, forDatabaseGroups ) {
        var url = '/confirm/overview/action/undo/records?recordtype=';

        doAction(url + $scope.current.downloadRecordType.confirmRecordType+ `&blockVerifyApply=${$routeParams.blocked}`, 'undo', 'undone', 'Undo record(s).  Are you sure you want to proceed?', false, forDatabaseGroups);
    };

    // ADVISOR
    function getVerifyApplyQueryString(apply) {
        return Object.toQueryString(angular.extend({recordType: $scope.current.downloadRecordType.confirmRecordType, apply: apply, blockVerifyApply: $routeParams.blocked}, $scope.params));
    }

    function startOldPollingStatus(batchId, completedVerb,groupName) {
        
        var lastData;
        var parentId = batchId;
        var sameDataCount = 0;
        var errorCount = 0;
        var erroredBatchProcessings = [];

        var pollStatus = function (batchId) {
            if (sameDataCount > 200) {
                $rootScope.$broadcast('event:progress-update', { id: parentId, isDone: true, msg: parentId + ": Status updates aborted", type: "warning" });
                $userMessages.addConfirmationMsg(parentId + ": Took too long", "The process is taking longer than expected.  Status polling has been aborted.", "warning");
                return;
            }

            if (errorCount > 25) {
                if (parentId) $rootScope.$broadcast('event:progress-update', { id: parentId, isDone: true, msg: parentId + ": Status updates aborted", type: "warning" });
                $userMessages.addConfirmationMsg(parentId + ": Status polling failed", "The status check has erred out 25 times.  Status polling has been aborted.", "warning");
                return;
            }

            $http.get("/Confirm/Overview/CheckStatus/" + batchId + "?includeErrors=true", { ignoreExceptions: true })
                .then(function (response) {
                    var data = response.data;
                    if (angular.equals(data, lastData)) {
                        sameDataCount += 1;
                        $timeout(function () { pollStatus(batchId); }, 5000);
                        return;
                    }

                    sameDataCount = 0;

                    var progress = { id: parentId, completed: data.itemsCompleted, total: data.totalItems };

                    if (data.isDone) {
                        if (data.errorCount > 0 && data.details != null && data.details.length > 0) {
                            data.details.forEach((detail) => {
                                erroredBatchProcessings.push(detail.id);
                                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Error", detail.id + ': Failed - ' + detail.errorMessage, [{ result: 'OK', label: 'OK', cssClass: 'btn-primary', focus: true }]).open();
                            });
                            
                        }

                        progress.isDone = true;
                        $userMessages.addConfirmationMsg(parentId + ": " + data.itemsCompleted + " record(s) " + completedVerb + ' (' + groupName + ')', data.message, progress.type);
                        $scope.refreshGrid();
                    }
                    else
                        $timeout(function () { pollStatus(batchId); }, 5000);

                    $rootScope.$broadcast('event:progress-update', progress);
                    lastData = data;
                })
                .catch(function () {
                    errorCount += 1;
                    $timeout(function () { pollStatus(batchId); }, 20000);
                });
        };

        pollStatus(batchId);
    }

    

    // ADVISOR
    function startPollingStatus(response, completedVerb, groupName) {
        startOldPollingStatus(response, completedVerb, groupName);
    }

    function startPollingStatusForDatabases( databaseGroups ) {
        var lastBatchProcessings;
        var sameDataCount = 0;
        var errorCount = 0;

        var pollStatusForDatabases = function( databaseGroups ) {

            if( sameDataCount > 60 ) {
                $userMessages.addConfirmationMsg("Verify/Apply/Undo took too long.  Status polling has been aborted.", "warning");
                return;
            }

            if( errorCount > 5 ) {
                $userMessages.addConfirmationMsg("Verify/Apply/Undo status check has erred out 5 times.  Status polling has been aborted.", "warning");
                return;
            }

            var batchIds = getBatchProcessingIds( databaseGroups );

            if( batchIds.length === 0 ) {
                return;
            }

            $http.post("/Utility/BatchProcessing/List?includeErrors=true", batchIds, {ignoreExceptions: true})
                .then(function(response) {
                    var batchProcessings = response.data;
                    databaseGroups.lastRefresh = Date.create('now');

                    if( angular.equals(batchProcessings, lastBatchProcessings) ) {
                        sameDataCount += 1;
                        $timeout(function() { pollStatusForDatabases( databaseGroups ); }, 30000);
                        return;
                    }

                    sameDataCount = 0;

                    var isDone = updateDatabaseGroupsStatus( databaseGroups, batchProcessings );

                    if( isDone ) {
                        $userMessages.addConfirmationMsg("Verify/Apply/Undo complete", "success");
                        $scope.current.databaseGroupsLocked = false;
                        $scope.refreshGrid( );
                    }
                    else {
                        $timeout(function() { pollStatusForDatabases( databaseGroups ); }, 15000);
                    }

                    lastBatchProcessings = batchProcessings;
                })
                .catch(function() {
                    errorCount += 1;
                    databaseGroups.lastRefresh = Date.create('now');
                    $timeout(function() { pollStatusForDatabases( databaseGroups ); }, 30000);
                });
        };

        pollStatusForDatabases( databaseGroups );
    }

    function getBatchProcessingIds( ) {
        var batchIds = [];
        for( var i = 0; i < $scope.current.databaseGroups.length; i++ ) {
            batchIds.push( $scope.current.databaseGroups[i].batchProcessingId );
        }
        return batchIds;
    }

    function updateDatabaseGroupsStatus( databaseGroups, batchProcessings ) {
        var isDone = true;
        for( var i = 0; i < batchProcessings.length; i++ ) {
            var dbgIdx = databaseGroups.findIndex({ batchProcessingId: batchProcessings[i].id });
            if( batchProcessings[i].status === "Complete" ) {
                databaseGroups[dbgIdx].status = "Complete";
            }else if( batchProcessings[i].status === "Failed" ) {
                databaseGroups[dbgIdx].status = "Failed";
            } else {
                isDone = false;
                databaseGroups[dbgIdx].status = batchProcessings[i].status;
            }
        }
        return isDone;
    }

    // ADVISOR
    $scope.findReplace = function( findReplaceFlag ) {
        $dialog.inputBox('Find & Replace', " ", "findReplace", {findString: '', replaceString: ''} ).open().then(function(options) {
            if( options ) {
                options.findReplaceFlag = findReplaceFlag;
                return Repo.merge(ConfirmationOverview.files.findReplace.multi(
                    $scope.selectedItems.groupBy('downloadFileId'),
                    function(downloadFileId, items) {
                        return {
                            params: { downloadFileId: downloadFileId, findString: options.findString, replaceString: options.replaceString, findReplaceFlag: findReplaceFlag },
                            database: items[0].__database__,
                            data: items.map('id')
                        }
                    }
                )).then(function() {
                    $scope.refreshGrid( );
                });
            }
        });
    };

    $scope.prefix = function( ) {
        $dialog.inputBox('Prefix', " ", "text", null ).open().then(function(text) {
            if( text && text.length > 0 ) {
                return Repo.merge(ConfirmationOverview.files.prefix.multi(
                    $scope.selectedItems.groupBy('downloadFileId'),
                    function(downloadFileId, items) {
                        return {
                            params: { downloadFileId: downloadFileId, prefixFlag: 32, prefixString: text },
                            database: items[0].__database__,
                            data: items.map('id')
                        };
                    }
                )).then(function(response){
                    $scope.$broadcast( 'event:confirm-download-file-action', {action: 'update-items', items: setKeys(response.data) } );
                });
            }
        });
    };

    $scope.proper = function( properFlag ) {
        return Repo.merge(ConfirmationOverview.files.proper.multi(
            $scope.selectedItems.groupBy('downloadFileId'),
            function(downloadFileId, items) {
                return {
                    params: { downloadFileId: downloadFileId, properFlag: properFlag },
                    database: items[0].__database__,
                    data: items.map('id')
                }
            }
        )).then(function() {
            $scope.refreshGrid( );
        });
    };

    // ADVISOR
    $scope.resetFile = function( ) {
        $dialog.confirmAction("Do you want to reset the file(s)?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    return Repo.merge(ConfirmationOverview.files.resetFile.multi(
                        $scope.selectedItems.groupBy('downloadFileId'),
                        function(downloadFileId, items) {
                            return {
                                params: {downloadFileId: downloadFileId},
                                database: items[0].__database__,
                                data: items.map('id')
                            }
                        }
                    )).then(function() {
                        $scope.refreshGrid( );
                    });
                }
            });
    };

    $scope.manualConfirmDetails = function( ) {
        $dialog.dialog({templateUrl: "manual-confirm-details.html", controller: "ManualConfirmDetailsCtrl"})
            .open()
            .then(function (rslt) {
                if (!rslt) return;
                return Repo.merge(ConfirmationOverview.files.manualConfirmDetails.multi(
                    $scope.selectedItems.groupBy('__database__'),
                    function (database, items) {
                        return {
                            params: rslt,
                            database: database,
                            data: items.map('id')
                        }
                    }
                )).then(function () {
                    $scope.refreshGrid();
                });
            });

    };

    $scope.manualExcludeDetails = function( ) {
        return Repo.merge(ConfirmationOverview.files.manualExcludeDetails.multi(
            $scope.selectedItems.groupBy('__database__'),
            function(database, items) {
                return {
                    database: database,
                    data: items.map('id')
                }
            }
        )).then(function() {
            $scope.refreshGrid( );
        });
    };

    // GLOBAL
    $scope.revertBackToFile = function( ) {
        if ($location.url() === originalUrl ){
            $scope.current.selectedFileType = null;
            $scope.current.selectedSearchByField= null;
            $scope.confirmRecordStatus.forEach(function (status) {
                status.selected = (status === confirmRecordStatus.notConfirmed);
            });
            $scope.refreshGrid()
        }
        else{
            $location.url(originalUrl)
        }
    };

    // TODO
    $scope.reloadGrid = function () {
        $scope.preventLoad = false;
        if (
            $scope.current.selectedFileType &&
            $scope.current.selectedSearchByField !== null &&
            $scope.current.selectedSearchByField !== '4'
        ){
            var params = {
                memoCode: $scope.current.memoCode === 0 ? null : $scope.current.memoCode,
                downloadStatus: $scope.confirmRecordStatus.filter(function (s) { return s.selected }).map('queryString').join(','),
                accountNumber: $scope.current.filterAccountNumber != null && $scope.current.filterAccountNumber != '' ? $scope.current.filterAccountNumber : null,
                cusip: $scope.current.selectedSearchByField === '3' ? $scope.current.filterCusip : null,
                startDate: $scope.current.selectedSearchByField === '0' ? $scope.current.filterStartDate.format('{MM}-{dd}-{yyyy}') : null,
                endDate: $scope.current.selectedSearchByField === '0' ? $scope.current.filterEndDate.format('{MM}-{dd}-{yyyy}') : null,
                effStartDate: $scope.current.selectedSearchByField === '1' ? $scope.current.filterEffStartDate.format('{MM}-{dd}-{yyyy}') : null,
                effEndDate: $scope.current.selectedSearchByField === '1' ? $scope.current.filterEffEndDate.format('{MM}-{dd}-{yyyy}') : null,
                searchByField: $scope.current.selectedSearchByField && $scope.current.selectedSearchByField !== '-1' ? $scope.current.selectedSearchByField : null,
                fileIdList: $scope.current.selectedSearchByField === '2' ? $scope.current.filterFileId : fileIdList,
                notesId: $routeParams.notesId != null && $routeParams.notesId != '' ? $routeParams.notesId : null,
                accountHistory: $routeParams.accountHistory != null && $routeParams.accountHistory != '' ? $routeParams.accountHistory : null
            };
            $location.path('/confirmation/files/' + $scope.current.selectedFileType.name.replace(/ /g, '')).search(params);
        }
        else{
            $scope.refreshGrid()
        }
    };

    // TODO
    $scope.setSearchFilters = function(){
        $scope.current.selectedSearchByField = null;
        $scope.current.filterStartDate = $settings.getSetting('confirmStartDate');
        $scope.current.filterEndDate = $settings.getSetting('confirmEndDate');
        $scope.current.filterEffStartDate = $settings.getSetting('confirmStartDate');
        $scope.current.filterEffEndDate = $settings.getSetting('confirmEndDate');
        $scope.current.filterFileId = null;
        $scope.current.filterCusip = null;
        setSearchByField()
    };

    // GLOBAL
    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1) $scope.openRecordEditor(false);
    };

    // GLOBAL
    function loadTransactionTypes( ) {
        return $http.get('/Trading/TransactionTypes', {trackerMsg: 'Loading transaction types'})
            .then(function (r) {
                $scope.transactionTypes = r.data.sortBy('description');
            });
    }

    function saveSleeveColumnData() {
        var sleeveDataDtos = [];
        $scope.current.columns.forEach((column) => {
            sleeveDataDtos.push({
                "ColumnSize": column.ColumnSize,
                "ColumnEnabled": column.ColumnEnabled,
                "ColumnName": column.ColumnName,
                "ColumnCodeName": column.ColumnCodeName
            });
        });

        $http.put('/Confirm/DownloadFiles/SleeveColumnData', sleeveDataDtos ,{ trackerMsg: 'Saving sleeve column view' });
    }

    function loadSleeveColumns() {
        if ($scope.current.loadedSleeveColumns != true) {
            $scope.current.loadedSleeveColumns = true;
            ConfirmationOverview.files.getSleeveColumnData().then((response) => {
                var parsedData = JSON.parse(response.data);
                $scope.current.columns = [];
                parsedData.forEach((columnData) => {
                    columnData.Column.ColumnEnabled = columnData.Column.ColumnEnabled.toLowerCase() === "true";
                    var columnSize = parseInt(columnData.Column.ColumnSize);
                    if (columnSize !== "NaN") {
                        columnData.Column.ColumnSize = columnSize;
                    } else {
                        columnData.Column.ColumnSize = 100;
                    }

                    $scope.current.columns.push(columnData.Column);
                });
            });
        }

    }

    function loadSleeveData() {
        if ($scope.current.selectedTransactionIds !== null && $scope.current.selectedTransactionIds !== undefined) {
            var transactionIds = $scope.current.selectedTransactionIds;

            $http.post("/Confirm/DownloadFiles/SleeveData", transactionIds, { trackerMsg: 'Loading sleeve data' }).then((response) => {
                if (response.data !== '' && response.data !== null && response.data !== undefined) {
                    var parsedData = JSON.parse(response.data);
                    $scope.current.sleeveData = parsedData;
                    $scope.current.sleeveDataFiltered = parsedData;
                }
                
            });
        }
    }


     $scope.filterOnClick = function ($event) {
        
         if ($event.currentTarget.parentElement.classList.contains('visible')) {
             $event.currentTarget.parentElement.classList.remove('visible');
        }
        else {
             $event.currentTarget.parentElement.classList.add('visible');
        }
    }

    // GLOBAL
    function loadTradeStatuses( ) {
        return $http.get("/Trading/TradeStatuses", {cache: true, trackerMsg: 'Loading trade statuses', ignoreExceptions: true})
            .then(function (r) {
                $scope.tradeStatuses = r.data;
            });
    }

    // TODO
    function setSearchByField(){
        $scope.searchByFields = [
            {name: "Created Date", value: "0"},
            {name: "Effective Date", value: "1"},
            { name: "File ID", value: "2" }
        ];

        if ($scope.current.selectedFileType.value !== entities.downloadDividend.confirmRecordType){
            $scope.searchByFields.push({name: "CUSIP", value: "3"})
        }
    }

    function buildDatabaseGroups( rows ) {
        $scope.current.databaseGroups = [];
        for( var i = 0; i < rows.length; i++ ) {
            var d = $scope.current.databaseGroups.find( {alClientId: rows[i].databaseId} );
            if( d ) {
                d.downloadRecords.push( rows[i].id );
                d.downloadFiles.push( rows[i].downloadFileId );
            } else {
                $scope.current.databaseGroups.push( {token: "", databaseName: rows[i].databaseName, alClientId: rows[i].databaseId, downloadRecords: [rows[i].id], downloadFiles: [rows[i].downloadFileId], batchProcessingId: 0, status: 'Not started', lastRefresh: null} );
            }
        }

        for( var i = 0; i < $scope.current.databaseGroups.length; i++ ) {
            $scope.current.databaseGroups[i].downloadFiles = $scope.current.databaseGroups[i].downloadFiles.unique( );
        }

        var promises = $q.all($scope.current.databaseGroups.map(function (databaseGroup) { return tokenFactory.getDatabaseToken(databaseGroup.alClientId);}));
        promises.then(function (allTheTokens) {
            Object.each(allTheTokens, function (key, value) {
                $scope.current.databaseGroups[key].token = value;
            });
        });
    }

    // PUBLIC METHODS
    $scope.refreshGrid = function( ) {
        $timeout(function() {
            $scope.$broadcast('event:confirm-download-file-action', {action: 'refresh-grid'});
        });
    };

    // ADVISOR
    $scope.openEntityEditor = function(link) {
        $portfolio.openEditor( entities[entities.find({name: link.entity})].value, [link.entityId], null, null, apps.confirmation.name, null );
    };

    $scope.openProductEditor = function (productId) {
        const d = $dialog.editor("products/editors/product-edit.html", "ProductEditCtrl", {
            args: function () {
                return {
                    id: productId,
                    app: apps.confirmation,
                    defaultTab: {name: "Local", active: true, code: "productGeneral"},
                    extraInfo: null,
                    isNewGlobal: false,
                    isNewLocal: false
                };
            }
        });

        d.open().then(function (rslt) {
            if (rslt) {
                $scope.$broadcast('event:confirm-download-file-action', {action: 'refresh-grid'});
            }
        });
    };

    // GLOBAL
    $scope.createTransactionFileFromPositionFile = function () {

        splitIoService.getBoolTreatment('recon_confirm_newtransactionfromposition_187091').subscribe((isEnabled) => {
            if (isEnabled) {
                return Repo.merge(ConfirmationOverview.files.createTransactionsFromPosition.multi(
                    $scope.selectedItems.groupBy('databaseId'),
                    function (databaseId, items) {
                        return {
                            database: databaseId,
                            data: items.map('id')
                        }
                    }
                )).then(function (response) {
                    openTransactionsNewTab(response);
                });                            
            } else {
                return Repo.merge(ConfirmationOverview.files.transactionFromPosition.multi(
                    $scope.selectedItems.groupBy('downloadFileId'),
                    function (downloadFileId, items) {
                        return {
                            params: { downloadFileId: downloadFileId },
                            database: items[0].__database__,
                            data: items.map('id')
                        }
                    }
                )).then(function () {
                    $dialog.messageBox('Success', 'Transactions created.').open();
                });
            }
        });
    };

    function openTransactionsNewTab(response) {
        if (response && response.data) {
            var newConfirmOverviewId = response.data[0].confirmOverviewId;
            var newDownloadSourceId = response.data[0].downloadSourceId;

            $confirmation.cleanupLocalStorage();
            let fileIdHash = oas.utils.generateGuid();
            $confirmation.addConfirmOverviewFileIdToStorage(fileIdHash, response.data);

            window.open(redirectUrl(`/confirmation/files/v2/Transaction?notesId=${newConfirmOverviewId}-${newDownloadSourceId}&fileIdHash=${fileIdHash}`, $scope.databaseToken), '_blank');
        }
    }

    $scope.createAutoJournal = function( ) {
        return ConfirmationOverview.journaling.createAutoJournal().then(function(){
            return $dialog.messageBox( 'Success', 'Auto Journal Created').open( );
        });
    };

    $scope.openRecordEditor = function( ) {
        if( $scope.selectedIds.length === 1 ) {
            return $dialog.editor('confirmation/editors/views/download-' + $routeParams.type.dasherize() + '-edit.html', 'DownloadRecordEditCtrl', {args: function () {
                return {
                    item: $scope.selected,
                    id: $scope.selected.id,
                    fileId: $scope.selected.downloadFileId,
                    downloadRecordType: $scope.current.downloadRecordType,
                    defaultTab: {name: "General", active: true, code: "general"}
                };
            }}).open().then(function (rslt) {
                if( rslt ) {
                    $scope.$broadcast( 'event:confirm-download-file-action', { action: 'update-item', item: setKey(rslt) } );
                }
            });
        } else {
            return $confirmation.openMassEditor($scope.current.downloadRecordType.value, $scope.selectedItems, apps.confirmation.name, {downloadType: $routeParams.type}).then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast('event:confirm-download-file-action', {action: 'update-items', items: setKeys(rslt)});
                }
            });
        }
    };

    // GLOBAL
    $scope.downloadFile = function() {
        return tokenFactory.getDatabaseToken($scope.current.file.__database__).then(function(token){
            window.location.href = API_CONFIG.baseUrl + '/Confirm/DownloadFiles/' + $scope.current.file.id + '/Download' + '?Authorization=' + token;
        })
    };

    // GLOBAL
    $scope.exportToExcel = function() {
        $scope.$broadcast('event:confirm-download-file-action', {action: 'export-data'});
    };

    $scope.addToExclusion = function (addAsset) {
        if( selectedRows.length > 1 ) {
            //UI only allows for 1 record at a time
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Multiple Records Selected", "Select one record to proceed.").open();
        }
        $dialog.dialog({templateUrl: "confirmation/modals/addToExclusion.html", controller: "AddToExclusionCtrl", info: selectedRows, isAsset: addAsset})
        .open()
        .then(function (result) {
            if (!result) return;

            let exclusionRecord = {
                accountNumber: result.accountNumber,
                cusip: addAsset ? result.cusip : null,
                notes: result.notes,
                downloadFormatId: result.downloadFormat,
                downloadSourceId: result.downloadSourceId
            };
            
            $http.post('/Confirm/Exclusions', exclusionRecord, {trackerMsg: 'Adding record to exclusion table'})
                .then(function() {
                    $dialog.actionComplete("The exclusion record has been added.").open();
                });
        }
        );
    };
    
    // GLOBAL
    $scope.removeFromExclusion = function (removeAsset) {
        return Repo.merge(ConfirmationOverview.exclusions.getAll.each(selectedRows,
            function(item) {
                return {
                    database: item.__database__,
                    params: {
                        accountNumber: item.accountNumber,
                        cusip: removeAsset ? item.cusip : ''
                    }
                }
            }
        )).then(function(exclusions){
            if (exclusions.data.length) {
                return $q.all(ConfirmationOverview.exclusions.deleteMany.multi(exclusions.data.groupBy('__database__'),
                    function(database, e){
                        return {
                            database: database,
                            data: e.map('id')
                        }
                    }
                )).then(function(){
                    return $dialog.messageBox("<i class='fa fa-check-circle fa-lg text-success' aria-hidden='true'></i> Permanent Exclusion Action", "The selected " + (removeAsset ? 'asset(s)' : 'account(s)') + " were successfully removed from the exclusion table.").open();
                });
            } else {
                return $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Permanent Exclusion Action", "The selected " + (removeAsset ? 'asset(s)' : 'account(s)') + " could not be found in the exclusion table.  No action was taken.").open();
            }
        });
    };

    // ADVISOR
    $scope.moveSleeveInactiveByReg = function( ) {
        $portfolio.search(entities.registration.value)
                .then(function(rslt) {
                    if( rslt && rslt.entity === entities.registration.value ) {
                        $scope.moveSleeveInactive(rslt.item.id);
                    }
                });
    };

    // ADVISOR
    $scope.moveSleeveInactive = function( id ) {
        return $http.put('/Trading/Sleeve/Registrations' + (id > 0 ? '/' + id : '') + '/Action/MoveInactiveValue', null, {trackerMsg: 'Running sleeve inactive value move'})
                .then(function () {
                    $dialog.actionComplete("Running sleeve inactive value move complete").open();
                });
    };

    $scope.moveSleeveInactiveDatabase = function( ) {
        $dialog.confirmAction("Do you want to perform sleeve inactive value move?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    return Repo.merge(ConfirmationOverview.files.moveSleeveInactiveDatabase.multi(
                        $scope.selectedItems.groupBy('__database__'),
                        function(item) {
                            return {
                                database: item
                            }
                        }
                    )).then(function() {
                        $dialog.actionComplete("Running sleeve inactive value move complete").open();
                    });
                }
            });
    };

    // GLOBAL
    $scope.resetWidth = function(width) {
        $scope.rightSidebar.width = width;
    };

    $scope.resetWidthSleeve = function() {
        $scope.rightSidebar.width = window.innerWidth - 200;
    }


    // ADVISOR
    $scope.sortTransactionHistory = function( sortField ) {
        $scope.transactionHistory.sortField = sortField;
        $scope.transactionHistory.sortReverse = !$scope.transactionHistory.sortReverse;
    };

    // ADVISOR
    $scope.openTransaction = function( transaction ) {
        $portfolio.openEditor( entities.transaction.value, [transaction.id], null, null, apps.portfolioLists.name, null ).then(function(rslt) {
            if( rslt ) {
                angular.extend(transaction, rslt);
            }
        });
    };

    // ADVISOR
    $scope.saveTransactions = function( ) {
        if( $scope.transactionHistory.transactions.length > 0 ) {
            var transactions = [];
            for( var i = 0; i < $scope.transactionHistory.transactions.length; i++ ) {
                if( $scope.transactionHistory.transactions[i].isDirty ) {
                    transactions.push( {id: $scope.transactionHistory.transactions[i].id, portfolio: $scope.transactionHistory.transactions[i] } );
                }
            }

            if( transactions.length > 0 ) {
                $http.put( '/Portfolio/Transactions/Verbose', transactions, { trackerMsg: 'Updating transactions' } )
                    .then( function ( ) {
                        $scope.loadTransactionHistory('assetId=' + $scope.transactionHistory.assetId, entities.asset.value);
                    });
            }
        }
    };

    // ADVISOR
    $scope.newTransaction = function( ) {
        var extraInfo = {fkClient: $scope.transactionHistory.clientId, fkAsset: $scope.transactionHistory.assetId};
        $portfolio.openEditor( entities.transaction.value, [], null, null, apps.portfolioLists.name, extraInfo ).then(function(rslt) {
            if( rslt ) {
                $scope.transactionHistory.transactions.push( rslt );
            }
        });
    };

    // ADVISOR
    $scope.multiEditTransaction = function( ) {
        if( $scope.transactionHistory.transactions.length > 0 ) {
            var transactionIds = [];
            for( var i = 0; i < $scope.transactionHistory.transactions.length; i++ ) {
                if( $scope.transactionHistory.transactions[i].isSelected ) {
                    transactionIds.push( $scope.transactionHistory.transactions[i].id );
                }
            }
            if( transactionIds.length > 0 ) {
                var extraInfo = { fkClient: $scope.transactionHistory.clientId, fkAsset: $scope.transactionHistory.assetId };
                $portfolio.openMassEditor(entities.transaction.value, transactionIds, apps.portfolioLists.name, extraInfo).then(function (rslt) {
                    if (rslt) {
                        $scope.loadTransactionHistory('assetId=' + $scope.transactionHistory.assetId, entities.asset.value);
                    }
                });
            }
        }
    };

    // ADVISOR
    $scope.loadTransactionHistory = function( queryString, entityEnum ) {
        if( $scope.current.downloadRecordType === entities.downloadPosition && $scope.current.transactionHistoryTabActive ) {

            $scope.transactionHistory.entityLoaded = entityEnum;

            $http.get('/Portfolio/Transactions?' + queryString, {trackerMsg : 'Loading transaction history'})
                .then(function (response) {
                    $scope.transactionHistory.transactions = response.data;

                    if( response.data.length > 0 ) {
                        if( entityEnum === entities.asset.value ) {
                            $scope.transactionHistory.clientId = response.data[0].clientId;
                            $scope.transactionHistory.registrationId = response.data[0].registrationId;
                            $scope.transactionHistory.accountId = response.data[0].accountId;
                            $scope.transactionHistory.assetId = response.data[0].assetId;
                        }

                        for( var i = 0; i < response.data.length; i++ ) {
                            $scope.transactionHistory.totalAmount += response.data[i].transAmount;
                            $scope.transactionHistory.totalUnits += response.data[i].noUnits;
                            $scope.transactionHistory.transactions[i].transDate = Date.create( response.data[i].transDate );
                            $scope.transactionHistory.transactions[i]["transDateFriendly"] = Date.create( $scope.transactionHistory.transactions[i].transDate ).format( "{MM}/{dd}/{yyyy}" );
                        }
                    }
                });
        }
    } ;

    $scope.manualUpdatePriceDisabledText = function() {
        if ($scope.selectedItems.some(function(i){ return i.status !== 'Not Confirmed' })) {
            return "All selected prices need to be Not Confirmed";
        }

        if ($scope.selectedItems.some(function(i){ return i.systemPrice === i.price; })) {
            return "All selected prices need to have a price difference";
        }

        if (hasSelectedDuplicatePrices()) {
            return "Duplicate Price selected";
        }
    }

    $scope.showCanManualExcludeAndUpdatePrice = function () {
        return (
            $scope.current.isAdvisorContext &&
            $scope.rightsManualPrice.canUpdate &&
            $scope.current.downloadRecordType?.confirmRecordType == 3 &&
            $scope.selected
        );
    }

    $scope.canManualExcludePrice = function() {
        // All selected prices must be Not Confirmed
        // All selected prices must have a different Price than System Price

        return (
            $scope.showCanManualExcludeAndUpdatePrice() && 
            !$scope.selectedItems.some(function(i){ return i.status !== 'Not Confirmed' }) &&
            !$scope.selectedItems.some(function(i){ return i.systemPrice === i.price; })
        );
    }

    $scope.canManualUpdatePrice = function() {
        // All selected prices must be Not Confirmed
        // All selected prices must have a different Price than System Price
        // All selected prices must have a unique combo of Custodian ID + Product ID + Date

        return (
            $scope.canManualExcludePrice() &&
            !hasSelectedDuplicatePrices()
        );
    };

    function hasSelectedDuplicatePrices() {
        let selectedPrices = $scope.selectedItems.map(p => { return { custodianId: p.custodianId, productId: p.link.productId, effectiveDate: p.effectiveDate }})        ;
        const set = new Set(selectedPrices.map(JSON.stringify));
        return set.size < selectedPrices.length;
    }

    // INITIALIZE
    $scope.rightsConfirmation = $oasRights.forCode("CONFIRM_CONFIRMMANAG");
    $scope.rightsMultiDatabaseRecon = $oasRights.forCode("MULTIPLEDATABASERECON");
    $scope.rightsSleeveSetup = $oasRights.forCode("SLEEVESETUP");
    $scope.rightsExclusions = $oasRights.forCode("DOWNLOADEXCLUSION");
    $scope.rightsDownloadSource = $oasRights.forCode("DOWNLOADSOURCES");
    $scope.rightsManualPrice = $oasRights.forCode("MANUALPRICECONFIRM");
    $scope.rightsProduct = $oasRights.forCode("PRODUCTS");
    $scope.rightsAddMissingTickerCusip = $oasRights.forCode("ADDMISSINGTICKERCUSIP");
    $scope.confirmRecordStatus = confirmRecordStatus.values().each(function (status) {
        if($routeParams.downloadStatus)
            status.selected = !!$routeParams.downloadStatus.split(',').find(status.queryString);
        else status.selected = (status === confirmRecordStatus.notConfirmed);
    });

    $scope.preventLoad = $routeParams.preventLoad === 'true';
    $scope.fileTypes = ConfirmationOverview.default.fileTypes;
    $scope.memoCodes = ConfirmationOverview.default.memoCodes;
    $scope.newAccountCreationValues = ConfirmationOverview.default.newAccountCreationValues;

    $scope.views = views;

    Object.defineProperties($scope, {
        selectedItems: {get: function() {return selectedRows }},
        selectedIds: {get: function() {return selectedRows.map('compositeKey') }},
        selected: {get: function() { return selectedRows[0] || undefined; }},
        rows: {
            get: function() {return rows},
            set: function(newRows) {rows = newRows}
        }
    });

    $scope.sleeveColumnOptionClick = function () {
        $scope.current.ShowSleeveColumnOptions = !$scope.current.ShowSleeveColumnOptions;

        if (!$scope.current.ShowSleeveColumnOptions) {
            saveSleeveColumnData();
        }
    }

    $scope.handleFilterClick = function (columnName, filterValue, $event) {
        

        ////Checks to see whether the value has already been added or not if it hasn't we add if it has we remove it.
        if ($scope.current.filterValues[columnName] !== null && $scope.current.filterValues[columnName] !== undefined && $scope.current.filterValues[columnName].includes(filterValue)) {
            var existingValueIndex = $scope.current.filterValues[columnName].indexOf(filterValue);
            $scope.current.filterValues[columnName].splice(existingValueIndex, 1);
            $event.currentTarget.classList.add("filter_unselected");
            $event.currentTarget.classList.remove("filter_selected");
        } else {
            if ($scope.current.filterValues[columnName] === undefined ||
                $scope.current.filterValues[columnName] === null) {
                $scope.current.filterValues[columnName] = [];
            }
            $event.currentTarget.classList.remove("filter_unselected");
            $event.currentTarget.classList.add("filter_selected");
            $scope.current.filterValues[columnName].push(filterValue);
        }

        $scope.current.sleeveDataFiltered = [];

        $scope.current.sleeveData.forEach((sleeveDataRow) => {
            var isValidMatch = true;
            for (var columnName in $scope.current.filterValues) {
                if (
                    $scope.current.filterValues[columnName] !== null
                    && $scope.current.filterValues[columnName] !== undefined
                    && $scope.current.filterValues[columnName].length > 0
                    && !$scope.current.filterValues[columnName].includes(sleeveDataRow[columnName])) {
                    isValidMatch = false;
                }
            }
            if (isValidMatch) {
                $scope.current.sleeveDataFiltered.push(sleeveDataRow);
            }
        });

        //Loop through each row of the db result then loop through the filters to see what needs to be included and what shouldn't be.
        

        //Loop through one column and see what data is available after that we restrict on the filtered data.
        
    }

    $scope.getUniqueArray = function (columnName) {
        var results = [];
        $scope.current.sleeveData.forEach((sleeveDataRow) => {
            if (!results.includes(sleeveDataRow[columnName])) {
                results.push(sleeveDataRow[columnName]);
            }
        });
        return results;
    }

    $scope.isAccountHistoryView = function () {
        return $routeParams.accountHistory && parseInt($routeParams.accountHistory) === 1;
    };

    $scope.rateAgentNextBestAction = function () {
        if (!$scope.selectedItems || $scope.selectedItems.length === 0) {
            $dialog.messageBox(
                "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> No Selection",
                "Select one or more records to rate the agent next best action."
            ).open();
            return;
        }
        $scope.current.rateAgentNextBestActionModalOpen = true;
    };

    $scope.onRateAgentNextBestActionSubmitted = function (result) {
        if (!result || !result.records || result.records.length === 0) {
            return;
        }
        var groups = [];
        result.records.forEach(function (r) {
            var db = r.__database__;
            var g = null;
            for (var i = 0; i < groups.length; i++) {
                if (groups[i].database === db) {
                    g = groups[i];
                    break;
                }
            }
            if (!g) {
                g = { database: db, records: [] };
                groups.push(g);
            }
            g.records.push({ downloadFileId: r.downloadFileId, id: r.id });
        });
        var promises = groups.map(function (g) {
            return $http.put(
                "/Confirm/DownloadFiles/Details/Action/RateAgentNextBestAction",
                { accuracy: result.accuracy, notes: result.notes || "", records: g.records },
                { database: g.database, trackerMsg: "Saving agent next best action rating" }
            );
        });
        return $q.all(promises).then(function () {
            
        }, function (err) {
            var detail = err && err.data && (err.data.Message || err.data.message || err.data.exceptionMessage);
            $dialog.messageBox(
                "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Save Failed",
                detail || "The rating could not be saved."
            ).open();
        });
    };

    var notesId = $routeParams.notesId ? $routeParams.notesId.split('-') : [];
    var overviewId = notesId.length == 2 ? notesId[0] : '';
    var downloadSourceId = notesId.length == 2 ? notesId[1] : '';

    $scope.current = {
        showSleeveDataTab: false,
        ShowSleeveColumnOptions: false,
        columns: [],
        filterValues:[],
        sleeveData:[],
        view: views[0],
        overviewId: overviewId,
        downloadSourceId: downloadSourceId,
        downloadRecordType: entities["download" + $routeParams.type],
        endDate: Date.create('today').formatted(),
        startDate: Date.create('today').formatted(),
        files: Entity.collection(fileIdList ? fileIdList.split(',') : []),
        databaseGroups: [],
        databaseGroupsLocked: false,
        databaseGroupsTabActive: false,
        memoCode: $routeParams.memoCode ? parseInt($routeParams.memoCode) : 0,
        loadedSleeveColumns: false,
        rateAgentNextBestActionModalOpen: false,

        get file() {
            return $scope.selected ? $scope.current.files.find(function(f) {return f.id == $scope.selected.downloadFileId}) : $scope.current.files[0];
        },
        get isMultipleDatabases() {
            return $scope.current.files.databases().length > 1;
        },
        get isAdvisorContext() {
            return $scope.current.files.databases().length <= 1;
        },
        get isMultipleFiles() {
            return $scope.current.files.length > 1;
        },

        type: $routeParams.type,

        selectedSearchByField: null,
        selectedFileType: $routeParams.searchByField ? $scope.fileTypes.find(function(ft){return ft.name.replace(/ /g, '') === $routeParams.type }) : null,  //only set the file search type if already searched files

        filterStartDate: $routeParams.startDate ? Date.create($routeParams.startDate) : $settings.getSetting('confirmStartDate'),
        filterEndDate: $routeParams.endDate ? Date.create($routeParams.endDate) : $settings.getSetting('confirmEndDate'),
        filterEffStartDate: $routeParams.effStartDate ? Date.create($routeParams.effStartDate) : $settings.getSetting('confirmStartDate'),
        filterEffEndDate: $routeParams.effEndDate ? Date.create($routeParams.effEndDate) : $settings.getSetting('confirmEndDate'),
        filterAccountNumber: $routeParams.accountNumber,
        filterFileId: fileIdList,
        filterCusip: $routeParams.cusip,
        recordEntitySessionId: $routeParams.recordSessionId,
        fileEntitySessionId: $routeParams.fileSessionId,
        grid: {
            load: loadFiles,
            param: {}
        },
        gridDoubleClick: $scope.slickGridDoubleClick,
        pagination: {
            pageSizes: [{ value: 10000, label: '10000' },
                        { value: 25000, label: '25000' },
                        { value: 50000, label: '50000' },
                        { value: 100000, label: '100000' },
                        { value: -1, label: 'All' }],
            totalItems: 0,
            currentPage: 1,
            maxSize: 5,
            itemsPerPage: { value: 0, label: '' }
        }
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            $scope.openRecordEditor( );
    }}];

    if ($scope.current.selectedFileType !== null){
        setSearchByField();
        $scope.current.selectedSearchByField = $routeParams.searchByField
    }

    $scope.params = {
        allowDuplicateTransactions: false,
        allowAddProductToDatabase: false,
        matchDownloadSource: false,
        bypassExclusion: false,
        allowAddDividend: false,
        allowCreateUnverifiedSells: false,
        newAccountCreation: 0,
        priceHolidayOverride: false,
        allowSymbolCreate: false,
        toleranceOverride: false,
        isBlocked: $routeParams.blocked
    };

    //WATCHES
    $scope.$watch('current.transactionHistoryTabActive', function(value) {
        if($scope.current.selectedAssetId && !$scope.transactionHistory.transactions) $scope.loadTransactionHistory( 'assetId=' + $scope.current.selectedAssetId, entities.asset.value );
    });

    $scope.setItemsPerPage = function () {
        try {
            localStorage.confirmItemsPerPage = JSON.stringify($scope.current.pagination.itemsPerPage);
        } catch (e) { }
        updateGridAndPagingParams();
        $scope.refreshGrid();
    };

    function updateGridAndPagingParams(loadAllPages) {
        if (loadAllPages != undefined) {
            $scope.current.loadAllPages = loadAllPages;
        } else {
            $scope.current.loadAllPages = $scope.current.pagination.itemsPerPage.value === -1;
        }
        $scope.current.takeInterval = $scope.current.loadAllPages ? 100000 : $scope.current.pagination.itemsPerPage.value;
        $scope.current.pagination.currentPage = 1;
        $scope.current.pagination.totalItems = 0;
    }

    // EVENT LISTENERS
    $scope.$on('event:confirm-download-file-select', function(e, args) {
        if (!args.length) return;

        $scope.current.memoDescriptionList = (args[0].memoDescriptionList)?args[0].memoDescriptionList:false;
        if( $scope.rightsMultiDatabaseRecon.canUpdate && !$scope.current.databaseGroupsLocked ) {
            buildDatabaseGroups( args );
        }

        selectedRows = Entity.collection(args);
        $scope.current.startDate = args[0].effectiveDate;

        $scope.current.entityContextLinks = [];
        $scope.current.accountHistoryContextLinks = [];
        $scope.current.productId = 0;
        var transactionLinks = [];
        $scope.current.selectedAssetId = null;


        if ($scope.current.downloadRecordType.confirmRecordType === "2")
        {
            $scope.current.selectedTransactionIds = selectedRows.map(q => q.id);
            loadSleeveData();
        }

        $scope.current.isMissingTickerCusip = !!args.flatMap(record => record.memos).find(memo => memo && (memo.memoCode === 322 || memo.memoCode === 444));
        $scope.current.isMissingProduct = !!args.flatMap(record => record.memos).find(memo => memo && memo.memoCode === 324);

        tokenFactory.getDatabaseToken( args[0].databaseId ).then(function(token){
            $scope.databaseToken = token;

            if( $scope.current.downloadRecordType === entities.downloadPosition || $scope.current.downloadRecordType === entities.downloadTransaction ) {
                $scope.transactionHistory.cusip = '';
                $scope.transactionHistory.accountNumber = '';
                $scope.transactionHistory.transactions = null;
                $scope.transactionHistory.totalAmount = null;
                $scope.transactionHistory.totalUnits = null;
                $scope.transactionHistory.householdId = null;
                $scope.transactionHistory.registrationId = null;
                $scope.transactionHistory.accountId = null;
                $scope.transactionHistory.assetId = null;
                $scope.transactionHistory.entityLoaded = null;
                $scope.transactionHistory.shareDifference = null;
            }

            var accountHistoryPath = '/confirmation/files/';
            var accountHistoryQuery = '?downloadStatus=notConfirmed&accountNumber=' + args[0].accountNumber + '&accountHistory=1';

            $scope.current.accountHistoryContextLinks.push({ entity: 'Position', entityId: null, url: redirectUrl(accountHistoryPath + 'Position' + accountHistoryQuery, token) });
            $scope.current.accountHistoryContextLinks.push({ entity: 'Transaction', entityId: null, url: redirectUrl(accountHistoryPath + 'Transaction' + accountHistoryQuery, token) });
            $scope.current.accountHistoryContextLinks.push({ entity: 'Name', entityId: null, url: redirectUrl(accountHistoryPath + 'Name' + accountHistoryQuery, token) });
            $scope.current.accountHistoryContextLinks.push({ entity: 'Cost Basis', entityId: null, url: redirectUrl(accountHistoryPath + 'CostBasis' + accountHistoryQuery, token) });

            if (args[0].link) {
                if( args[0].link.clientId ) {
                    $scope.current.entityContextLinks.push( { entity: "Household", entityId:  args[0].link.clientId, url: redirectUrl($portfolio.getGoToRoute("households", 6, args[0].link.clientId ), token) } );
                }
                if( args[0].link.registrationId ) {
                    $scope.current.entityContextLinks.push( { entity: "Registration", entityId:  args[0].link.registrationId, url: redirectUrl($portfolio.getGoToRoute("registrations", 6, args[0].link.registrationId ), token) } );
                }
                if( args[0].link.accountId ) {
                    $scope.current.entityContextLinks.push({ entity: "Account", entityId: args[0].link.accountId, url: redirectUrl($portfolio.getGoToRoute("accounts", 7, args[0].link.accountId), token) });
                }
                if( args[0].link.assetId ) {
                    $scope.current.entityContextLinks.push( { entity: "Asset", entityId:  args[0].link.assetId, url: redirectUrl($portfolio.getGoToRoute("assets", 8, args[0].link.assetId ), token) } );

                    if( $scope.current.downloadRecordType === entities.downloadPosition || $scope.current.downloadRecordType === entities.downloadTransaction ) {
                        transactionLinks.push( { entity: "Transaction", entityId: null, url: redirectUrl($portfolio.getGoToRoute("assets", 8, args[0].link.assetId ), token).replace( 'assets', 'transactions' ) } );
                        $scope.current.entityContextLinks.add(transactionLinks);
                        $scope.transactionHistory.cusip = args[0].cusip;
                        $scope.transactionHistory.accountNumber = args[0].accountNumber;
                        $scope.transactionHistory.clientId = null;
                        $scope.transactionHistory.registrationId = null;
                        $scope.transactionHistory.accountId = null;
                        $scope.transactionHistory.assetId = null;
                        $scope.transactionHistory.shareDifference = args[0].shareDifference;
                        $scope.current.selectedAssetId = args[0].link.assetId;

                        $scope.loadTransactionHistory( 'assetId=' + args[0].link.assetId, entities.asset.value );
                    }
                }
                if( args[0].link.productId ) {
                    $scope.current.productId = args[0].link.productId;
                }
            }
        });
    });

    $scope.$on('slickgrid-data-loaded', function(event, data) {
        $scope.current.isPriceOrionCopy = (
            data.length > 0 &&
            data.some(function(i){ return i.isCopyForOrion })
        );
    });

    $scope.$on('user-auth-loaded', function (event, data) {
        var clientIdPromise = new Promise((resolve, reject) => {
            $rootScope.user.authorization.alClientId = data;
            $scope.current.files = Entity.collection(fileIdList ? fileIdList.split(',') : []);
        });
        clientIdPromise.then(() => {
            init();
        });
    });

    $scope.$on('$viewContentLoaded', function () {
        var psContainer = document.querySelectorAll(".pageSizeContainer")[0];
        psContainer.style.marginRight = psContainer.clientWidth * -1 + 'px';
    });

    init();
});

downloadRecordListCtrl.loadRecordTypeView = ["$http","$route", function( $http, $route ) {
    return $http.get('/Settings/Views/Download' + ($route.current.params.type === 'CorpAction' ? 'CorporateAction' : $route.current.params.type) + 'DetailDto', {trackerMsg : 'Loading download file view'})
        .then(function(response){
            return response.data;
        });
}];

app.controller('ManualConfirmDetailsCtrl', function ManualConfirmDetailsCtrl($scope, $http, $oasRights, dialog) {

    // PRIVATE METHODS
    function init() {
        $scope.rightsManualPrice = $oasRights.forCode("MANUALPRICECONFIRM");
    }


    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close(null);
    };

    $scope.save = function () {
        dialog.close({reason: $scope.current.reason, notes: $scope.current.notes, isValidated: false});
    };

    $scope.current = {
        notes: '',
        productId: 0,
        reason: null,
        priceReasons: [
            {name: "Third Party Website", id: 1},
            {name: "Institution Website", id: 2},
            {name: "Advisor Confirmed Price", id: 3},
            {name: "Other", id: 4},
            {name: "Multiplying price * factor", id: 5},
            {name: "Bond pricing-first price in", id: 6},
            {name: "Less rounded price", id: 7},
            {name: "Correcting decimal on price", id: 8},
            {name: "Updating CSI price from CSI update records", id: 9},
            {name: "Price is not a USD price", id: 10},
            {name: "Price is from a different effective date", id: 11}
        ]
    };

    $scope.databaseToken = null;

    // INITIALIZE
    init();

});
'use strict'

app.controller('ConfirmationDownloadLocalExclusionListCtrl', function ConfirmationDownloadLocalExclusionListCtrl($scope, views, ConfirmationOverview, $oasRights, $http, $dialog) {
    function init() {
        $scope.current.filters.startDate = new Date(new Date().setDate(new Date().getDate() - 30));
        $scope.current.filters.endDate = new Date();   
        var result = ConfirmationOverview.confirm.getDownloadFormats();
        result.then((downloadFormats) => { $scope.current.downloadFormats = downloadFormats.data});
        setDates();

    }

    $scope.refreshGrid = () =>
    {
        setDates().then(() => {
            $scope.$broadcast('event:confirm-download-exclusion-action', { action: 'refresh-grid' });
        });
    }

    $scope.slickGridDoubleClick = () => {
        if ($scope.selectedIds.length === 1) {
            $scope.openEditor(false);
        }
    }

    $scope.views = views;
    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: { get: function () { return $scope.selectedItems.map('id') } },
        selected: { get: function () { return $scope.selectedItems[0] || $scope.current.item; } }
    });
    $scope.current = {
        view: views[0],
        filters: {},
        gridDoubleClick: $scope.slickGridDoubleClick
    }

    $scope.rights = {
        downloadLocalExclusions: $oasRights.forCode("LOCALEXCLUSIONS")
    };

    $scope.current.onDateChange = function ()
    {
        $scope.current.selectedFormat = null;
        $scope.current.filters.cusip = null;
        $scope.current.filters.acctNum = null;
    }

    function setDates() {
        return new Promise((resolve, reject) => {
            if ($scope.current.filters.startDate) {
                $scope.current.startDate = $scope.current.filters.startDate.format('{MM}-{dd}-{yyyy}');
            }
            if ($scope.current.filters.endDate) {
                $scope.current.endDate = $scope.current.filters.endDate.format('{MM}-{dd}-{yyyy}');
            }
            resolve();
        });
    }

    $scope.openEditor = function (isNew) {

        var editorOptions = {
            item: $scope.selected ?? null,
            defaultTab: { name: "General", active: true, code: "general" },
            formats: $scope.current.downloadFormats
        };
        //If its new give a blank object instead of the selected.
        if (isNew) {
            editorOptions.item = null;
        }
        
        return $dialog.dialog({ templateUrl: 'confirmation/editors/views/download-local-exclusion-edit.html', controller: "DownloadLocalExclusionEditCtrl", editorOptions })
            .open().then(() => { $scope.refreshGrid(); });
    };

    $scope.deleteItems = function () {
        $http.get("/Settings/EntityOptions/Database/0/code/1:69ADVNUM", { trackerMsg: 'Loading database info' })
            .then(function (response) {
                $dialog.inputBox("Advisor Number", "Enter Number", "compare", { compareValue: response.data.value })
                    .open()
                    .then(function (result) {
                        if (result) {
                            $http.put("/Confirm/localexclusion/List/Delete", $scope.selectedIds, { trackerMessage: "Deleting Records" }).then(
                                () => {
                                    $scope.refreshGrid()
                                });
                        }
                    });
            });
    };

    $scope.$on('event:confirm-download-exclusion-select', function (e, args) {
        $scope.selectedItems = args;
    });

    init();
});
'use strict';

app.controller( 'DownloadRecordEditCtrl', function DownloadRecordEditCtrl( $scope, $http, $oasRights, $dialog, $timeout, dialog, args, entities, confirmRecordStatus, productTypes, preferredRateFrequency, Entity ) {

    // PRIVATE VARIABLES
    var editorHotKeys;
    var originalExclusionReason = null;

    // PRIVATE METHODS - INIT
    function init( ) {
        loadDownloadRecord( );
        loadTransactionSubTypes( );
        loadRights( );
        buildMenu( );
        loadHotKeys( );
        loadExclusionReasons( );
        $scope.loadTab( args.defaultTab );
    }

    function loadDownloadRecord( ) {
        $scope.downloadRecord = Entity(args.item).setOriginal();
        confirmRecordStatus.keys().forEach( function( key ) {
            if( !( $scope.current.downloadRecordType.name === entities.downloadPosition.name && confirmRecordStatus[key].name === confirmRecordStatus.confirmed.name && $scope.downloadRecord.status === confirmRecordStatus.notConfirmed.name ) ) {
                $scope.recordStatuses.push( {id: parseInt( confirmRecordStatus[key].value ), name: confirmRecordStatus[key].name} )
            }
        } );

        if( $scope.current.downloadRecordType === entities.downloadSecurity ) {
            $scope.productTypes = [];
            $scope.preferredRatesFrequency = [];

            productTypes.keys( ).forEach( function( key ) {
                $scope.productTypes.push( {id: parseInt( productTypes[key].value ), name: productTypes[key].name} )
            } );

            preferredRateFrequency.keys( ).forEach( function( key ) {
                $scope.preferredRatesFrequency.push( {id: parseInt( preferredRateFrequency[key].value ), name: preferredRateFrequency[key].name} )
            } );
        }
    }

    function loadTransactionSubTypes( ) {
        if((args && args.downloadRecordType.abbr == 'DCA')){
            return; //Corporate Actions don't use this
        }

        $http.get('/Trading/TransactionSubTypes', {trackerMsg: 'Loading transaction sub types', database: $scope.downloadRecord.__database__})
            .then(function(r){
                $scope.transactionSubTypes = r.data;
            })
    }

    function loadRights( ) {
        $scope.rightsConfirmation = $oasRights.forCode("CONFIRM_CONFIRMMANAG");
    }

    function buildMenu() {
        $scope.menu = { categories: [ ] };
        $scope.menu.categories.push( {name: 'General', children: [] } );
        $scope.menu.categories[0].children.push( {name: 'General', active: false, code: 'general'} );
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: function() { $scope.close(true); } }
            ]);
        });
    }

    function loadExclusionReasons(){
        if((args && args.downloadRecordType.abbr == 'DCA')){
            return; //Corporate Actions don't use this
        }

        $http.get('/Confirm/DownloadFiles/ExclusionReason/', {trackerMsg: 'Loading exclusion reasons', database: $scope.downloadRecord.__database__})
            .then(function(res){
                originalExclusionReason = res.data;
                $scope.current.exclusionReasons = Object.keys(res.data).map(function(key) {return res.data[key]});
            })
    }

    // PUBLIC METHODS
    $scope.recalcUnits = function () {
        if ($scope.downloadRecord.netTransactionAmount === 0 || $scope.downloadRecord.price === 0) return;

        $scope.downloadRecord.noUnits = $scope.downloadRecord.netTransactionAmount / $scope.downloadRecord.price;
    };

    $scope.recalcNetAmount = function () {
        if ($scope.downloadRecord.noUnits === 0 || $scope.downloadRecord.price === 0) return;

        $scope.downloadRecord.netTransactionAmount = $scope.downloadRecord.noUnits * $scope.downloadRecord.price;
    };

    $scope.recalcGrossAmount = function () {
        if ($scope.downloadRecord.noUnits === 0 || $scope.downloadRecord.price === 0) return;

        $scope.downloadRecord.grossTransactionAmount = $scope.downloadRecord.noUnits * $scope.downloadRecord.price;
    };

    $scope.recalcUnitPrice = function(){
        if ($scope.downloadRecord.netTransactionAmount === 0 || $scope.downloadRecord.noUnits === 0) return;

        $scope.downloadRecord.price = $scope.downloadRecord.netTransactionAmount / $scope.downloadRecord.noUnits;
    };

    $scope.lookupPrice = function( ) {
        $http.get( "/Portfolio/Assets/" + $scope.downloadRecord.link.assetId + "/Price/" + Date.create($scope.downloadRecord.effectiveDate).format('{MM}-{dd}-{yyyy}'), {trackerMsg: 'Loading price'})
            .then(function (res) {
                if( res.data ) {
                    $scope.downloadRecord.price = res.data.last;
                }
            });
    };

    $scope.loadTab = function( child ) {
        $scope.menu.categories.each( function( c ) {
            c.children.each( function( ch ) {
                ch.active = ch.code === child.code;
            } );
        } );

        $scope.current.selectedTab = child.code;
    };

    $scope.save = function( ) {
        if( $scope.downloadRecord.isModified() ) {
            return $http.put("/Confirm/DownloadFiles/" + args.fileId + "/Details/" + args.id, $scope.downloadRecord, { trackerMsg: "Saving download record", database: $scope.downloadRecord.__database__})
                .then(function (response) {
                    $scope.current.exclusionReasons.forEach(function(reason){
                       if(!Object.values(originalExclusionReason).find(reason)){
                           $http.post('/Confirm/DownloadFiles/ExclusionReason/?reason=' + reason, {trackerMsg: 'Saving exclusion reasons', database: $scope.downloadRecord.__database__});
                       }
                    });

                    editorHotKeys.destroy();
                    dialog.close($scope.downloadRecord); //update API will always return null, use the current record in the UI since it reflects what was saved
                });
        } else return dialog.close($scope.downloadRecord);
    };

    $scope.close = function( validate ) {
        if( validate ) {
            if( $scope.downloadRecord.isModified() ) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };


    // INITIALIZE
    $scope.current = {
        selectedTab: args.defaultTab,
        downloadRecordType: args.downloadRecordType,
        exclusionReasons:[]
    };

    $scope.downloadRecord = null;
    $scope.errors = [];
    $scope.recordStatuses = [];

    init( );

} );
'use strict'

app.controller('DownloadLocalExclusionEditCtrl', function ConfirmationDownloadLocalExclusionListCtrl($scope, $oasRights, $http, dialog, $dialog) {
    function init() {
        $scope.rights = $oasRights.forCode("LOCALEXCLUSIONS");
        
        $scope.current.formats = dialog.options.editorOptions.formats;
        $scope.current.isNew = dialog.options.editorOptions.item == null;
        $scope.item = dialog.options.editorOptions.item ?? {};
    }

    $scope.current = {};

    $scope.save = function () {
        
        $http.get("/Settings/EntityOptions/Database/0/code/1:69ADVNUM", {trackerMsg: 'Loading database info' })
            .then(function (response) {
                $dialog.inputBox("Advisor Number", "Enter Number", "compare", { compareValue: response.data.value })
                    .open()
                    .then(function (result) {
                        if (result) {
                            $http.put("/Confirm/localexclusion/List/Upsert", [$scope.item], { trackerMessage: "Updating Record" })
                                .then(() => {
                                    dialog.close(null);
                                });
                        }
                    });
            });
    };

    $scope.close = function () {
        dialog.close(null);
    };
    init();
});
'use strict';

app.directive('confirmNotes', function confirmNotes($http, $dialog) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'confirmation/directives/confirm-notes.html',
        scope: {onAddDelete: '&', startDate: '=', endDate: '=', sourceType: '@', alClientId: '=', downloadSourceId: '=', parentId: '=', count: '=', forceReload: '=?'},
        link: function (scope) {
            //PRIVATE VARIABLES
            var rawNotes, getInProgress;
            var notesInEdit = [];


            //PRIVATE FUNCTIONS
            function getList() {
                if (getInProgress) return;

                var accountNotInFile = scope.sourceType == 'AccountNotInFile';
                var props = {
                    parentId: scope.sourceType == 'DownloadSource' ? '' : (scope.parentId ?? undefined),
                    startDate: accountNotInFile ? undefined : (scope.startDate ?? undefined),
                    endDate: accountNotInFile ? undefined : (scope.endDate ? Date.create(scope.endDate).addDays(1).formatted() : undefined),
                    sourceType: scope.sourceType == 'DownloadSource' ? '' : (scope.sourceType ?? undefined),
                    alClientId: scope.alClientId ?? undefined,
                    downloadSourceId: scope.downloadSourceId ?? undefined,
                    globalOnly: scope.parentId ? false : true
                };

                getInProgress = true;
                $http.get('/Confirm/Overview/Notes?' + Object.toQueryString(props), {trackerMsg: 'Loading notes'})
                    .then(function(response) {
                        rawNotes = response.data;
                        buildGroups();
                    })
                    .finally(function() {
                        getInProgress = false;
                    });
            }

            function buildGroups() {
                rawNotes = rawNotes.sortBy("createdDate", true);
                scope.count = rawNotes.length;
                scope.notes = [];

                rawNotes.forEach(function (note) {
                    var relativeDate = Date.create(note.createdDate).relative().toUpperCase();
                    var existingGroup = scope.notes.find({name: relativeDate});
                    if (existingGroup) {
                        existingGroup.items.push(note);
                    } else {
                        scope.notes.push({name: relativeDate, items: [note]});
                    }
                });
            }


            //PUBLIC METHODS
            scope.addNote = function () {
                scope.newNote.parentId = scope.parentId;
                scope.newNote.sourceType = scope.sourceType;
                if (scope.sourceType === "DownloadSource") {
                    scope.newNote.isAdvisorVisible = true;
                }

                $http.post('/Confirm/Overview/Notes', scope.newNote, {trackerMsg: "Adding new note"})
                    .then(function (response) {
                        scope.onAddDelete();
                        scope.showAddForm = false;
                        scope.newNote = {};

                        if (Date.range(scope.startDate, Date.create(scope.endDate).addDays(1)).contains(Date.create(response.data.createdDate))) {
                            rawNotes.push(response.data);
                            buildGroups();
                        }
                    });
            };

            scope.toggleEditMode = function (note, mode) {
                if (mode === "edit") {
                    note.isEditing = true;
                    notesInEdit.push(angular.copy(note));
                } else {
                    if (mode === "cancel") {
                        angular.extend(note, notesInEdit.find({id: note.id}));
                    }
                    note.isEditing = false;
                    notesInEdit.remove({id: note.id});
                }
            };

            scope.updateNote = function (note) {
                $http.put("/Confirm/Overview/Notes/" + note.id, note, {trackerMsg: 'Saving note changes'})
                    .then(function (response) {
                        scope.toggleEditMode(note, "save");
                        angular.extend(note, response.data);
                    });
            };

            scope.deleteNote = function (id) {
                $dialog.confirmAction("Are you sure you want to delete this note?")
                    .open()
                    .then(function (result) {
                        if (result !== 'yes') return;

                        $http.delete('/Confirm/Overview/Notes/' + id, {trackerMsg: 'Deleting note'})
                            .then(function () {
                                scope.onAddDelete();
                                rawNotes.remove({id: id});
                                buildGroups();
                            });
                    });
            };


            //INITIALIZE
            scope.newNote = {};
            getList();


            //SCOPE WATCHERS
            scope.$watch("alClientId", function (newValue, oldValue) {
                if (newValue === oldValue) return;

                getList();
            });

            scope.$watch("parentId", function (newValue, oldValue) {
                if (newValue === oldValue) return;

                getList();
            });

            scope.$watch("forceReload", function (newValue, oldValue) {
                if (newValue === oldValue) return;

                getList();
            });

            scope.$watch("startDate", function (newValue, oldValue) {
                if (newValue === oldValue) return;

                getList();
            });

            scope.$watch("endDate", function (newValue, oldValue) {
                if (newValue === oldValue) return;

                getList();
            });
        }
    };
});

'use strict';

app.
controller('ConfirmGroupDataAuditCtrl', function ConfirmGroupDataAuditCtrl($scope, $http, $dialog) {
    var vm = this;

    function loadDataAudit() {

    }

}).
directive('confirmGroupDataAudit', function confirmGroupDataAudit($http, $dialog, $dataQuery) {
    return {
        restrict: 'E',
        controller: 'ConfirmGroupDataAuditCtrl',
        controllerAs: 'vm',
        replace: true,
        bindToController: {
            dataAudit: '='
        },
        scope: {item: '='},
        templateUrl: 'confirmation/directives/confirm-group-data-audit.html',
        link: function (scope, element, attrs, vm) {


        }
    };
}).
directive('confirmGroupDataAuditPrompt', function confirmGroupDataAudit($http, $dialog) {
    return {
        restrict: 'E',
        require: '^^confirmGroupDataAudit',
        templateUrl: 'confirmation/directives/confirm-group-data-audit-prompt.html',
        scope: {prompt: '='},
        link: function (scope, element, attrs, vm) {

        }
    };
});

'use strict';

app.controller('InformReconTransactionEditCtrl', function InformReconTransactionEditCtrl($scope, $q, $http, $dialog, dialog) {
    // PRIVATE METHODS
    function init() {
        $http.get('/Compliance/Inform/Preclearances/V2/AccessPerson/'+ $scope.transaction.accessPersonId + '?forExceptionMatch=true', {trackerMsg: 'Loading pre-clearances'})
            .then(function (response) {
                $scope.preClearances = response.data;

                if ($scope.transaction.informPreClearanceId) {
                    $scope.preClearances.insert({id: $scope.transaction.informPreClearanceId, description: $scope.transaction.preClearanceDescription}, 0);
                }
            });

        $q.all({
            types: $http.get('/Trading/TransactionTypes', {trackerMsg: 'Loading transaction types'}),
            subTypes: $http.get('/Trading/TransactionSubTypes', {trackerMsg: 'Loading transaction sub types'})
        }).then(function (responses) {
            $scope.transactionTypes = responses.types.data;
            $scope.subTypeLookUp = responses.subTypes.data;
        });
    }

    // PUBLIC METHODS
    $scope.resetSubType = function () {
        $scope.transaction.transactionSubType = $scope.subTypeLookUp[$scope.transaction.transactionType][0].code;
    };

    $scope.viewPreClearance = function () {
        $http.get("/Compliance/Inform/Preclearance/" + $scope.transaction.informPreClearanceId + "/V2", {trackerMsg: 'Loading pre-clearance'})
            .then(function (response) {
                const options = {
                    templateUrl: "tools/inform/modal/inform-new-preclearance-dialog.html",
                    controller: "InformPreClearanceDialogCtrl",
                    preclearance: response.data,
                    dialogClass: 'modal wide'
                };

                $dialog.dialog(options).open();
            });
    };

    $scope.editProduct = function () {
        const args = {
            id: $scope.current.product.productId,
            defaultTab: {code: "productGeneral"}
        };

        $dialog.editor("products/editors/product-edit.html", "ProductEditCtrl", {args: function () {return args;}}).open();
    };

    $scope.save = function () {
        $scope.transaction.productId = $scope.current.product ? $scope.current.product.productId : null;

        $http.put('/Confirm/Overview/InformRecon/Transactions/V2/' + $scope.transaction.informTransactionId, $scope.transaction, {trackerMsg: 'Saving transaction'})
            .then(function (response) {
                dialog.close(response.data);
            });
    };

    $scope.cancel = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.transaction = angular.copy(dialog.options.transaction);

    $scope.reconStatuses = ['Not Confirmed', 'Confirmed', 'Excluded'];

    $scope.current = {
        product: $scope.transaction.productId ? {productId: $scope.transaction.productId, productName: $scope.transaction.productName, ticker: $scope.transaction.ticker} : null,
        initialPreClearanceId: $scope.transaction.informPreClearanceId
    };

    init();
});

'use strict';

app.controller('InformReconListCtrl', function InformReconListCtrl($scope, $timeout, $settings, views, tokenFactory) {
    //PRIVATE VARIABLES
    const redirectUrl = window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html?p=/confirmation/inform/{id}&t={token}";


    //PRIVATE METHODS
    function setDates() {
        if ($scope.current.isSignedOff !== false) {
            $scope.current.startDate = $scope.current.filterStartDate.formatted();
            $scope.current.endDate = $scope.current.filterEndDate.formatted();
        } else {
            $scope.current.startDate = null;
            $scope.current.endDate = null;
        }
    }

    function slickGridDoubleClick() {
        if ($scope.selectedIds.length !== 1) return;

        const cancelWatcher = $scope.$watch('current.databaseUrl', function (newValue) {
            if (!newValue) return;

            window.open(newValue, '_blank');
            cancelWatcher();
        });
    }


    // PUBLIC METHODS
    $scope.refreshGrid = function () {
        $settings.setSetting('informStartDate', $scope.current.filterStartDate);
        $settings.setSetting('informEndDate', $scope.current.filterEndDate);

        setDates();

        $timeout(function () {
            $scope.$broadcast('event:confirm-informRecon-action', {action: 'refresh-grid'});
        });
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:confirm-informRecon-action', {action: 'export-data'});
    };


    // INITIALIZE
    $scope.selectedIds = [];
    $scope.views = views;
    $scope.current = {
        view: views[0],
        filterStartDate: $settings.getSetting('informStartDate') || Date.create('last month'),
        filterEndDate: $settings.getSetting('informEndDate') || Date.create('today'),
        isSignedOff: false,
        gridDoubleClick: slickGridDoubleClick
    };

    setDates();


    // EVENT LISTENERS
    $scope.$on('event:confirm-informRecon-select', function(e, args) {
        $scope.current.databaseUrl = null;

        if (args.length === 1) {
            tokenFactory.getDatabaseToken(args[0].alClientId)
                .then(function (token) {
                    const params = {id: args[0].id, token: token};
                    $scope.current.databaseUrl = redirectUrl.assign(params);
                });
        }
    });
});
'use strict';

app.controller('InformReconTransactionsCtrl', function InformReconTransactionsCtrl($scope, $http, $routeParams, $dialog, views) {
    // PUBLIC METHODS
    $scope.viewPreClearance = function (preClearanceId) {
        $http.get("/Compliance/Inform/Preclearance/" + preClearanceId + "/V2", {trackerMsg: 'Loading pre-clearance'})
            .then(function (response) {
                const options = {
                    templateUrl: "tools/inform/modal/inform-new-preclearance-dialog.html",
                    controller: "InformPreClearanceDialogCtrl",
                    preclearance: response.data,
                    dialogClass: 'modal wide'
                };

                $dialog.dialog(options).open();
            });
    };

    $scope.editTransaction = function (transaction) {
        const options = {
            dialogClass: "modal",
            templateUrl: "confirmation/inform/modals/inform-recon-transaction-edit.html",
            controller: "InformReconTransactionEditCtrl",
            transaction: transaction
        };

        $dialog.dialog(options)
            .open()
            .then(function (result) {
                if (result) {
                    $scope.$broadcast('event:confirm-informTransactions-action', {action: 'update-item', item: result});
                }
            });
    };

    $scope.editProduct = function (productId) {
        const args = {
            id: productId,
            defaultTab: {code: "productGeneral"}
        };

        $dialog.editor("products/editors/product-edit.html", "ProductEditCtrl", {args: function () {return args;}}).open();
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:confirm-informTransactions-action', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function () {
        if ($scope.selectedIds.length === 1) {
            $scope.editTransaction($scope.selectedItems[0]);
        }
    };


    // INITIALIZE
    $scope.selectedIds = [];
    $scope.selectedItems = [];
    $scope.views = views;
    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        informReconId: $routeParams.id
    };


    // EVENT LISTENERS
    $scope.$on('event:confirm-informTransactions-select', function (e, args) {
        $scope.selectedItems = args;
    });
});
app.controller('AddToExclusionCtrl', function AddToExclusionCtrl($scope, $http, $oasRights, dialog){

    function init(){
        $scope.exclusionResponses.accountNumber = dialog.options.info[0].accountNumber;
        $scope.exclusionResponses.downloadSourceId = dialog.options.info[0].downloadSourceId;
        $scope.exclusionResponses.cusip = dialog.options.isAsset ? dialog.options.info[0].cusip : "";

        $http.get('/Confirm/DownloadFormats/Simple', {trackerMsg:'Loading download formats'})
            .then(function(response){
                $scope.downloadFormats = response.data;
                $scope.exclusionResponses.downloadFormat = dialog.options.info[0].downloadFormatId;
            })
    }

    $scope.submitResponse = function(){
        dialog.close($scope.exclusionResponses);
    };

    $scope.close = function(){
        dialog.close(null);
    };

    $scope.exclusionResponses = {downloadFormat:null, accountNumber: null, cusip: null, notes:''};
    $scope.downloadFormats = [];
    $scope.current = {excludedAccounts: []};

    init();
});
app.controller('AddNotesToMultipleCtrl', function AddNotesToMultipleCtrl( $scope, $http, $q, tokenFactory, dialog ){

    function init( ) {
        $scope.note = { notes: '', isAdvisorVisible: false, isSaving: false };
    }

    $scope.save = function( ) {
        var promises = [];
        $scope.note.isSaving = true;

        if( dialog.options.args ) {
            dialog.options.args.each( function( r ) {
                tokenFactory.getDatabaseToken( r.alClientId )
                    .then(function (token) {
                        var note = { note: $scope.note.notes, isAdvisorVisible: $scope.note.isAdvisorVisible, parentId: r.id, sourceType: r.sourceType };
                        promises.push( $http.post( "/Confirm/Overview/Notes", note, {headers: {Authorization: "Session " + token}} ) );
                    });
            });
        }

        $q.all(promises)
            .then(function( ) {
                $scope.note.isSaving = false;
                dialog.close( {saved: true} );
        });
    };

    $scope.close = function( ) {
        dialog.close( null );
    };

    init( );

});
app.controller('ImportFileCtrl', function ImportFileCtrl($scope, $http, dialog, $route, splitIoService) {
    //PRIVATE METHODS
    function init() {
        $http.get("/Authorization/Databases", {cache: true, trackerMsg: 'Loading databases', ignoreExceptions: true})
            .then(function (response) {
                $scope.databases = response.data;

                setImportDatabaseWithCurrentDatabase();
                $scope.loadDownloadSources();
            });
    }

    function setImportDatabaseWithCurrentDatabase() {
        const oasAuthorization = JSON.parse(sessionStorage.oas_authorization);
        const currentDatabaseId = dialog.options.alClientId ?? oasAuthorization.alClientId;

        $scope.current.databaseId = currentDatabaseId;
    }

    function setErrorMessages(data) {
        $scope.current.errorMessages = [];
        $scope.current.batchProcessingIds = [];

        data.forEach(function (item) {
            if (item.errorMessage && $scope.current.errorMessages.none(item.errorMessage)) {
                $scope.current.errorMessages.push(item.errorMessage);
            }
            if(item.batchProcessingId) $scope.current.batchProcessingIds.push(item.batchProcessingId);
        });

        $scope.current.importSuccess = $scope.current.errorMessages.isEmpty();
    }

    function importFromDownloadSources(){
        var data = {
            downloadSourceIds: $scope.current.selectedDownloadSourceIds,
            autoApply: $scope.current.autoApply
        };

        $http.post("/Confirm/DownloadFiles/Action/ImportFilesByDownloadSources", data, {database: $scope.current.databaseId, trackerMsg: "Importing files from url"})
            .then(function (response) {
                setErrorMessages(response.data);
            });
    }

    // PUBLIC METHODS
    $scope.loadDownloadSources = function( ) {
        $scope.downloadSources = [];
        $scope.current.downloadSourceId = 0;

        return $http.get("/Confirm/DownloadSources/Simple/Active", {database: $scope.current.databaseId}, {trackerMsg: 'Loading download sources', ignoreExceptions: true})
            .then(function (response) {
                const responseData = response.data;
                
                $scope.downloadSources = angular.copy(responseData);
                $scope.current.multiSelectDownloadSources = responseData;
                $scope.current.multiSelectDownloadSourcesFiltered = responseData;
                $scope.current.selectedDownloadSourceIds = [];
            });
    };

    $scope.close = function () {
        dialog.close({status: $scope.current.importSuccess ? 'success' : null});
    };

    $scope.importFromUrl = function () {
        importFromDownloadSources();        
    };

    $scope.additionalData = function(){
        if($scope.current.selectedDownloadSourceIds.length > 0){
            $scope.current.downloadSourceId = $scope.current.selectedDownloadSourceIds[0];
        }
        return $scope.current;
    }

    $scope.disableImport = function(){
        return $scope.current.selectedDownloadSourceIds.length === 0;
    }

    $scope.disableFilePrompt = function(){
        if($scope.current.selectedDownloadSourceIds.length > 1){
            $scope.current.promptForName = false;
        }
        return $scope.current.selectedDownloadSourceIds.length > 1
    }

    $scope.canImportFilesByPrompt = function(){
        return ($scope.current.downloadSourceId > 0 || $scope.current.selectedDownloadSourceIds.length === 1) 
                && $scope.current.databaseId && $scope.current.promptForName
    }

    $scope.isChecked = function(id){
        return $scope.current.selectedDownloadSourceIds ? $scope.current.selectedDownloadSourceIds.indexOf(id) !== -1 : false;
    };

    $scope.toggleCheck = function(id){
        var index = $scope.current.selectedDownloadSourceIds.findIndex(id);

        if (index === -1) 
            $scope.current.selectedDownloadSourceIds.push(id);
        else 
            $scope.current.selectedDownloadSourceIds.splice(index, 1);
    };

    $scope.setAll = function(checked) {
        if (checked) {
            $scope.current.selectedDownloadSourceIds =
                $scope.current.multiSelectDownloadSources
                .findAll(
                    q => q.name.toLowerCase()
                        .includes($scope.current.search['name'].input.toLowerCase()))
                .map(obj => {
                return obj.id;
            });
        }
        else{
            $scope.current.selectedDownloadSourceIds = [];
        }
    };

    // INITIALIZE
    $scope.current = {
        databaseId: 0,
        downloadSourceId: 0,
        autoApply: 0,
        promptForName: false,
        importSuccess: false,
        errorMessages: [],
        viewingImportsNow: $route.current.$$route.originalPath == '/confirmation/importedfiles',
        selectedDownloadSourceIds:[],
        multiSelectDownloadSources:[],
        multiSelectDownloadSourcesImport: false,
        search: []
    };

    $scope.current.search['name'] = { input: null, propToFilter: 'name' };
    init();


    // SCOPE WATCHERS
    $scope.$watchCollection("current.selectedItems", function (newValue, oldValue) {
        if (newValue !== oldValue && newValue) {
            setErrorMessages($scope.current.selectedItems);
        }
    });
});
'use strict';

app.controller('CorporateActionInputBoxCtrl', function CorporateActionInputBoxCtrl($scope, dialog) {
    $scope.current = dialog.options || {};
    $scope.current.inputValue = $scope.current.currentValue;
    $scope.hasValidator = ($scope.current.inputValidator instanceof Function);
    $scope.maxDate = typeof ($scope.current.maxDate) === 'undefined' ? null : $scope.current.maxDate;
    $scope.validationMessages = [];

    // PUBLIC METHODS
    $scope.submit = function () {
        $scope.validationMessages = [];

        if ($scope.hasValidator) {
            $scope.validationMessages = validateInput($scope.current.currentValue, $scope.current.inputValue, $scope.current.inputType);
        }

        if (!$scope.validationMessages.some(function (error) { return error.type === 'error'; })) {
            let returnValue = $scope.current.inputValue;
            if ($scope.current.inputType === 'date') {
                returnValue = returnValue instanceof Date ? returnValue.formatted() : Date.create(returnValue).formatted();
            }
            dialog.close(returnValue);
        }
    };

    $scope.cancel = function() {
        dialog.close(false);
    };

    $scope.disableOk = function () {
        return !$scope.validationMessages ||
            $scope.validationMessages.some(function (message) { return message.type === 'error'; });
    };

    function validateInput(current, input, inputType) {
        let messages = [];

        if ($scope.hasValidator) {
            messages = $scope.current.inputValidator(current, input);
        }

        if (inputType === 'date' && $scope.maxDate != null) {
            let message = validateMaxDate(input, $scope.maxDate);
            if (message !== null) {
                messages.push(message);
            }
        }

        return messages;
    };

    function validateMaxDate(input, max) {
        let message = null;
        let maxDate = Date.create(max);
        let inputDate = input instanceof Date ? input : Date.create(input);

        if (maxDate.isValid() && inputDate.isValid() && inputDate > maxDate) {
            message = { type: 'error', message: 'The new date is later than the maximum allowed date.' };
        }
        return message;
    }

    $scope.$watch('current.inputValue', function (newValue, oldValue) {
        if (newValue === oldValue || !newValue) return;

        $scope.validationMessages = validateInput($scope.current.currentValue, newValue, $scope.current.inputType);
    });
});
app.controller('CorporateActionTaskQueueSkippedCtrl', function CorporateActionTaskQueueSkippedCtrl($scope, $http, dialog, $route, CorporateAction) {


    $scope.close = function () {
        dialog.close(null);
    };

    $scope.addTaskQueueSkippedRecord = function () {

        var data = {
            alClientId: $scope.current.alClientId,
            corpActionProcessingId: $scope.current.corporateActionProcessingId,
            corpActionTaskQueueStartId: $scope.current.corporateActionTaskQueueStartId,
            corpActionTaskQueueEndId: $scope.current.corporateActionTaskQueueEndId,
            comment: $scope.current.comment
        };

        $http.post("/Confirm/CorporateAction/TaskQueueSkipped", data, {trackerMsg: "Adding new Task Queue Skipped record" })
            .then(function (response) {
                if (response.status == 200) {
                    dialog.close({ saved: true });
                }
            });
    };

    $scope.validInput = function () {
        return $scope.current.alClientId && $scope.current.corporateActionProcessingId && $scope.current.corporateActionTaskQueueStartId && $scope.current.corporateActionTaskQueueStartId > 0
    }

    // INITIALIZE
    
    $scope.current = {
        rights: CorporateAction.rights,
        saveSuccess: false,
        errorMessages: [],
        processingStatus: dialog.options.selected || {}
    };

    $scope.current.alClientId = $scope.current.processingStatus.alClientId;
    $scope.current.databaseName = $scope.current.processingStatus.databaseName;
    $scope.current.corporateActionProcessingId = $scope.current.processingStatus.corporateActionProcessingId;
    $scope.current.corporateActionTaskQueueStartId = $scope.current.processingStatus.corporateActionTaskQueueId;
    $scope.current.corporateActionTaskQueueEndId = null;
    $scope.current.comment = null;
})
'use strict';

var CorporateActionsListCtrl = app.controller('CorporateActionsListCtrl', function CorporateActionsListCtrl($http, $scope, entities, CorporateAction, $confirmation, views, CorporateActionsListSettings, $routeParams) {
    let initialDataLoaded = false;
    // PUBLIC METHODS
    $scope.refreshGrid = $scope.$broadcast.bind($scope,'event:corpaction-list-action',{action:'refresh-grid'});
    $scope.loadCorporateActionsListSettings = function () {
        if ($routeParams && $routeParams.corpActionId) {
            return {
                corpActionId: $routeParams.corpActionId
            }
        }else if (CorporateActionsListSettings.settings && CorporateActionsListSettings.settings.value) {
            const paramJSON = JSON.parse(CorporateActionsListSettings.settings.value);

            if (paramJSON && (paramJSON.startDate || paramJSON.endDate)) {
                return paramJSON;
            }
        }
        return $scope.current.grid.param;
    };
    $scope.updateCorporateActionsListSettings = function(){
        CorporateActionsListSettings.settings.value = JSON.stringify($scope.current.grid.param);
        if(!$scope.user.isImpersonating){
            $http.post('/Settings/UserOptions/CorpActListSettings', CorporateActionsListSettings.settings).then(function(res){
                CorporateActionsListSettings.settings.id = res.data.id;
            });
        }
    };
    // EVENT LISTENERS
    $scope.$on('event:corpaction-list-select', function(e,args){if(args.length) $scope.selectedItems = args;});
    $scope.$on('event:corpaction-list-action', function(e,args){if(args.action && args.action === "refresh-grid")$scope.updateCorporateActionsListSettings();});

    $scope.$on('slickgrid-data-loaded', function (event, data) {
        if (!initialDataLoaded) {
            initialDataLoaded = true;

            // open editor on first data load
            if ($routeParams.openEditor && $scope.rights.corporateAction.canUpdate && $routeParams.corpActionId) {
                $scope.selected = data[0];
                $scope.openEditor();
            }
        }
    })

    $scope.openEditor = function (action) {
        if($scope.selected) {
            $confirmation.openEditor(entities.corporateAction, {
                corporateAction: $scope.selected,
                productId: $scope.selected.productId,
                action: action,
                defaultTab: {name: 'General', active: true, code: 'general'}
            }).then($scope.refreshGrid);
        }
    };

    $scope.views = views;
    $scope.rights = CorporateAction.rights;
    $scope.goToProductsAndPrices = $confirmation.goToProductsAndPrices;
    $scope.goToGlobalPrices = $confirmation.goToGlobalPrices;

    $scope.selectedItems = [];
    Object.defineProperty($scope, 'selectedIds', {get: function() {return $scope.selectedItems.map('id')}});
    Object.defineProperty($scope, 'selected', { get: function () { return $scope.selectedItems[0] || null; }, set: function (item) { $scope.selectedItems[0] = item; }  });


    $scope.current = {
        view : views[0],
        gridDoubleClick: $scope.openEditor,
        grid: {
            load: CorporateAction.corporateAction.getAll,
            param: {
                startDate: Date.create('today').rewind({month: 1}),
                endDate: Date.create('today').advance({day: 10}).endOfDay() //current.endDate.formatted() + ' 23:59:59'
            }
        }
    };
    //INIT
    (function(){
        $scope.current.grid.param = $scope.loadCorporateActionsListSettings();

    })();
});

CorporateActionsListCtrl.loadCorporateActionsListSettings = ["$http","$q",function($http,$q){
   var loadPromises = [];
   loadPromises.push($http.get('/settings/UserOptions/CorpActListSettings', {tracker: 'Loading default settings'}));
   return $q.all(loadPromises).then(function(res){ return {settings:res[0].data} });
}];
'use strict';

var CorporateActionProcessingListCtrl = app.controller('CorporateActionProcessingListCtrl', function CorporateActionProcessingListCtrl($scope, $http, entities, CorporateAction, views, $dialog, apps, processStatus, $confirmation, $q, CorporateActionProcessingListSettings, $location, $routeParams) {
    let initialDataLoaded = false;

    // PUBLIC METHODS
    $scope.refreshGrid = $scope.$broadcast.bind($scope, 'event:corpaction-processing-list-action', { action: 'refresh-grid' });
    $scope.loadCorporateActionProcessingListSettings = function () {
        if ($routeParams && $routeParams.corpActionProcessingId) {
            return {
                skipDates: true,
                corpActionProcessingId: $routeParams.corpActionProcessingId
            }
        } else if (CorporateActionProcessingListSettings.settings && CorporateActionProcessingListSettings.settings.value) {
            const paramJSON = JSON.parse(CorporateActionProcessingListSettings.settings.value);
            if (paramJSON && (paramJSON.startDate || paramJSON.endDate)) {
                return paramJSON;
            }
        }

        return $scope.current.grid.param;
    };
    $scope.updateCorporateActionProcessingListSettings = function () {
        CorporateActionProcessingListSettings.settings.value = JSON.stringify($scope.current.grid.param);
        if (!$scope.user.isImpersonating) {
            $http.post('/Settings/UserOptions/CorpActProcListSettings', CorporateActionProcessingListSettings.settings).then(function (res) {
                CorporateActionProcessingListSettings.settings.id = res.data.id;
            });
        }
    };

    // EVENT LISTENERS
    $scope.$on('event:corpaction-processing-list-select', function (e, args) { if (args.length) $scope.selectedItems = args; });
    $scope.$on('event:corpaction-processing-list-action', function (e, args) { if (args.action && args.action === "refresh-grid") $scope.updateCorporateActionProcessingListSettings(); });

    $scope.$on('slickgrid-data-loaded', function (event, data) {
        if (!initialDataLoaded) {
            initialDataLoaded = true;

            // open editor on first data load
            if ($routeParams.openEditor && $scope.rights.corporateAction.canUpdate && $routeParams.corpActionProcessingId) {
                $scope.selected = data[0];
                $scope.openEditor('processing-tab');
            }
        }
    })

    $scope.openEditor = function (action) {
        if ($scope.selected) {
            $confirmation.openEditor(entities.corporateAction, {
                corporateAction: CorporateAction.corporateAction.get({ trim: true, params: { id: $scope.selected.corpActionId } }),
                selectedProcess: $scope.selected,
                productId: $scope.selected.productId,
                action: action,
                defaultTab: { name: 'General', active: true, code: 'general' }
            }).then(function (ca) {
                if (!ca) return $q.resolve();
                const caId = ca instanceof Array && ca.length > 0 ? ca[0].id : ca.id;
                return CorporateAction.processingRecord.getAllDetail({ trim: true, params: { corpActionId: caId } }).then(function (processes) {
                    $scope.$broadcast('event:corpaction-processing-list-action', { action: 'upsert-items', items: processes });
                });
            });
        }
    };

    $scope.showProcessingStatus = function () {
        if ($scope.selectedIds) {
            $location.path('/confirmation/corporateactions/processes/' + $scope.selectedIds);
        }
    };

    $scope.setDate = function () { return CorporateAction.processingRecord.setDate({ params: { id: $scope.selected.id } }) };
    $scope.deleteProcessingRecord = function () {
        CorporateAction.processingRecord.delete({ params: { id: $scope.selected.id } })
            .then(function () {
                $scope.$broadcast('event:corpaction-processing-list-action', { action: 'delete-items', items: $scope.selectedIds });
                $scope.selected = null;
            });
    }
    $scope.isProcessingStatus = function (status) { return $scope.selected.processStatus.toLowerCase() == status.toLowerCase(); }

    $scope.updateStatus = function (status) {
        $scope.selected.processStatus = status;
        CorporateAction.processingRecord.saveDetail({ trim: true, params: { id: $scope.selected.id }, data: $scope.selected, confirm: true }).then(function (process) {
            $scope.selected = process;
            $scope.$broadcast('event:corpaction-processing-list-action', { action: 'update-item', item: process });
        }).catch(function () { });
    };

    const dateValidator = function (currentValue, inputValue) {
        const errors = [];
        const currentDate = currentValue instanceof Date ? currentValue : Date.create(currentValue);
        const inputDate = inputValue instanceof Date ? inputValue : Date.create(inputValue);
        if (!inputDate.isValid()) {
            errors.push({ type: 'error', message: 'The new date is not valid.' });
        } else if (currentDate.isValid() && !isWithinAWeek(currentDate, inputDate)) {
            errors.push({ type: 'warning', message: 'The new date varies from the current date by more than 7 days.' });
        }
        return errors;
    };

    function isWithinAWeek(currentDate, inputDate) {
        const diffTime = Math.abs(inputDate - currentDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays <= 7;
    }

    // Date.isPast() doesn't really work because it creates the comparison based on the current date and time rather than just the date
    function isPastDate(inputValue) {
        const today = Date.create('today');
        const inputDate = inputValue instanceof Date ? inputValue : Date.create(inputValue);
        if (!inputDate.isValid()) {
            return false;
        }
        return inputDate < today;
    }

    const priceValidator = function (currentValue, inputValue) {
        const errors = [];
        if (!isValidPrice(inputValue)) {
            errors.push({ type: 'error', message: 'You must enter a valid price.' });
        }
        return errors;
    };

    function isValidPrice(inputPrice) {
        return !isNaN(parseFloat(inputPrice)) && !isNaN(Number(inputPrice));
    };

    $scope.performCorpActionTask = function (task) {
        let data = {
            corpActionProcessingId: $scope.selected.id,
            corpActionProcessingTaskType: task,
            effectiveDate: null,
            navPrice: null
        };

        if (task === 1 || task === 2 || task === 4) {
            processTask(data, false); // No need to confirm for simple status changes
        }
        else if (task === 12 || task === 13) {
            const effDate = $scope.selected.effectiveDate instanceof Date ? $scope.selected.effectiveDate : Date.create($scope.selected.effectiveDate);
            if (effDate.isFuture()) {
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Change deferred", "This corporate action will not be processed until " + $scope.selected.effectiveDate).open().then(function () {
                    processTask(data, true);
                });
            } else {
                processTask(data, true);
            }
        }
        else if (task === 3 || task === 8) {
            const effDate = $scope.selected.effectiveDate instanceof Date ? $scope.selected.effectiveDate : Date.create($scope.selected.effectiveDate);
            if (effDate.isFuture()) {
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> BOD transaction processing deferred", "This corporate action will not be processed until " + $scope.selected.effectiveDate).open().then(function () {
                    processTask(data, true);
                });
            } else {
                processTask(data, true);
            }
        }
        else if (task === 5) {
            $dialog.dialog(angular.extend({
                templateUrl: "confirmation/modals/corporateActionInputBox.html",
                controller: "CorporateActionInputBoxCtrl"
            },
                {
                    title: 'Date',
                    inputCaption: 'Effective Date',
                    inputType: 'date',
                    inputValidator: dateValidator,
                    maxDate: 'today',
                    currentValue: $scope.selected.effectiveDate
                })).open()
                .then(function (date) {
                    if (!date) return;
                    data.effectiveDate = Date.create(date).format('{yyyy}-{MM}-{dd}');
                    processTask(data, true);
                });
        } else if (task === 6) {
            $dialog.dialog(angular.extend({
                templateUrl: "confirmation/modals/corporateActionInputBox.html",
                controller: "CorporateActionInputBoxCtrl"
            },
                {
                    title: 'Price',
                    inputCaption: 'Price/Amounts',
                    inputType: 'price',
                    inputValidator: priceValidator,
                    currentValue: $scope.selected.navPrice,
                    min: 0
                })).open()
                .then(function (price) {
                    if (!price) return;
                    data.navPrice = price;
                    processTask(data, true);
                });
        }
        else {
            processTask(data, true);
        }
    };

    function processTask(data, confirm) {
        const confirmationResponse = confirm ? promptForConfirmation() : $q.resolve(true);
        return confirmationResponse.then(function (isConfirmed) {
            if (!isConfirmed) { return; }
            CorporateAction.processingRecord
                .processTask({ trim: true, params: { id: $scope.selected.id }, data: data })
                .then(function (process) {
                    let action = 'update-item';
                    if (process.id != data.corpActionProcessingId) {
                        action = 'add-item';
                    }
                    $scope.$broadcast('event:corpaction-processing-list-action', { action: action, item: process });
                    $scope.selected = process;
                });
        });
    }

    function promptForConfirmation() {
        return $dialog.confirmAction('Are you sure you want to complete this action?')
            .open()
            .then(function (response) { return (response && response.toLowerCase()) === 'yes'; });
    }


    // INIT
    $scope.views = views;
    $scope.rights = CorporateAction.rights;
    $scope.goToTransactions = $confirmation.goToCorporateActionTransactions;
    $scope.goToProductsAndPrices = $confirmation.goToProductsAndPrices;
    $scope.goToGlobalPrices = $confirmation.goToGlobalPrices;
    $scope.currentStatus = CorporateAction.statusDetail;

    $scope.selectedItems = [];
    Object.defineProperty($scope, 'selectedIds', {
        get: function () { return $scope.selectedItems.filter(x => x != null).map(x => x.id); }
    });
    Object.defineProperty($scope, 'selected', {
        get: function () { return $scope.selectedItems[0] || undefined; },
        set: function (item) { $scope.selectedItems[0] = item; }
    });

    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.openEditor,
        grid: {
            load: CorporateAction.processingRecord.getAllDetail,
            param: {
                startDate: Date.create('today').rewind({ month: 1 }),
                endDate: Date.create('today').advance({ day: 10 }).endOfDay()
            }
        },
        processStatus: CorporateAction.processStatus,
        taskType: CorporateAction.taskType
    };

    // INIT
    (function () {
        $scope.current.grid.param = $scope.loadCorporateActionProcessingListSettings();
    })();
});

CorporateActionProcessingListCtrl.loadCorporateActionProcessingListSettings = ["$http","$q", function($http,$q){
   var loadPromises = [];
   loadPromises.push($http.get('/settings/UserOptions/CorpActProcListSettings',{tracker: 'Loading default settings'}));
   return $q.all(loadPromises).then(function(res){return {settings:res[0].data}});
}];

'use strict';

app.controller('CorporateActionProcessingStatusListCtrl',
    function CorporateActionProcessingStatusListCtrl($scope, views, CorporateAction, $routeParams, $http, $dialog) {

        // VARIABLES
        const processingIds = $routeParams.processingIds.split(',').map(function (item) {
            return parseInt(item, 10);
        });


        // PUBLIC METHODS
        $scope.refreshGrid = refreshGrid;

        $scope.filterRecords = function(taskQueueStatus){
            //Need to use name due to how custom views works
            const filtername = createFilterName(taskQueueStatus);
            $scope.views.forEach(v => {
                v.filters.forEach(e => {
                    if(e.name === filtername) {
                        e.include = true;
                    } else {
                        e.include = false;
                    }
                });
            });
        };

        // PRIVATE METHODS
        function init() {
            //Need to manually add the Nav Link
            $scope.addBreadcrumb("Processing Status (" + $scope.current.processingIds + ")", ('#/confirmation/corporateactions/processes/' + $scope.current.processingIds));
            $scope.views = views;
            $scope.selectedItems = [];
            $scope.selectedIds = [];
            createAllFilters();
            getCounts();
        }

        function createAllFilters() {
            const defaultFilter = createFilterId('Pending');
            CorporateAction.taskQueueStatus.forEach(e => {
                let thisFilterId = createFilterId(e.name);
                $scope.views[0].filters.push({
                    id: thisFilterId,
                    include: thisFilterId === defaultFilter,
                    key: "corporateActionTaskQueueStatus",
                    name: createFilterName(e.name),
                    value: "(function (a) { return angular.isString(a) ? a.toLowerCase() === '" + e.name.toLowerCase() + "' : a === " + e.name + "; })"
                });
            });
        }

        function createFilterId(name) {
            return 'taskQueueStatus' + name;
        };

        function createFilterName(name){
            return "Task Queue Status " + name;
        };

        function processingIdParameter() {
            const param = "?processingIds=";
            const ids = $scope.current.processingIds.replace(',', '&processingIds=');
            return param + ids;
        };

        function refreshGrid() {
            $scope.$broadcast('event:corpaction-processing-status-list-reload', { action: 'refresh-grid' });
            getCounts();
        };

        function getCounts() {
            const url = "/Confirm/CorporateAction/Processing/Status/Counts" + processingIdParameter();
            $http.get(url, { cache: false, trackerMsg: 'Loading Processes Status Counts' })
                .then(function (response) {
                    $scope.current.complete = response.data.complete;
                    $scope.current.pending = response.data.pending;
                    $scope.current.skipped = response.data.skipped;
                });
        };

        // EVENT LISTENERS
        $scope.$on('event:corpaction-processing-status-list-select', function (e, args) {
            if (args.length) {
                $scope.selectedItems = args;
                $scope.current.selectedItemIsSkippable = args[0] && !args[0].skippedTask && args[0].corporateActionTaskQueueStatus != 'Complete';
            }
        });

        $scope.addSkippedTaskQueue = function () {
            $dialog.dialog(angular.extend(
                { dialogClass: "modal wide", templateUrl: "confirmation/modals/corporateActionTaskQueueSkipped.html", controller: "CorporateActionTaskQueueSkippedCtrl" },
                { selected: $scope.selectedItems[0] }
            )).open()
                .then(function (response) {
                    if (!response) return;
                    refreshGrid();
                });
        };

        $scope.current = {
            complete: 0,
            pending: 0,
            skipped: 0,
            rights: CorporateAction.rights,
            view: views[0],
            processingIds: $routeParams.processingIds,
            selectedItemIsSkippable: false,
            taskQueueStatus: CorporateAction.taskQueueStatus,
            selectedTaskQueueStatus: CorporateAction.taskQueueStatus[1],
            grid: {
                load: CorporateAction.processingRecord.getStatus,
                param: {
                    processingIds: processingIds,
                    alClientId: 0,
                    incompleteOnly: false,
                }
            }
        };

        init();

    })
'use strict';

app.controller('CorporateActionV2TransactionsListCtrl', function CorporateActionV2TransactionsListCtrl($scope, $http, CorporateAction, views, $confirmation, entities, $q, $dialog, $route, tokenFactory, apps) {
    function init() {
        const corpActionId = $scope.current.initialCorporateActionId;
        return $q.all({
            tradeStatuses: getTradeStatuses(),
            corporateAction: corpActionId ? CorporateAction.corporateAction.get({
                trim: true,
                params: { id: corpActionId }
            }) : $q.resolve(),
            processes: corpActionId ? getCorporateActionProcesses(
                corpActionId,
                $scope.current.initialCorporateActionProcessingId
            ) : $q.resolve()
        }).then(function (responses) {
            if (corpActionId) {
                $scope.current.corporateAction = responses.corporateAction;
                $scope.current.initialCorporateActionId = undefined;
            }
        }).catch(handleError);
    }

    function handleError(response) {
        $dialog.actionFailed(response.data.userException.detail).open();
    }

    function getCorporateActionProcesses(corporateActionId, corporateActionProcessingId) {
        return $q.resolve(
            CorporateAction.processingRecord.getAllDetail({
                trim: true,
                params: { corpActionId: corporateActionId }
            })
        ).then(function (processes) {
            $scope.current.processes = processes || [];
            if (corporateActionProcessingId) {
                $scope.current.corporateActionProcess = (processes || [])
                    .find(p => (p && p.id) === corporateActionProcessingId);
            }
        }).catch(handleError);
    };

    function canSearch() {
        // User can search corp action or processing record without date range.
        if ($scope.current.corporateAction || $scope.current.corporateActionProcess) {
            return true;
        }
        // All other filters require a date range
        if (!($scope.current.startDate || $scope.current.endDate)) { return false; }
        // and at least one of them must be selected.
        return $scope.current.product
            || $scope.current.database
            || ($scope.current.tradeStatuses && $scope.current.tradeStatuses.length);
        
    }

    function getCanEditSingleStatus() {
        const item = $scope.selectedItems[0];
        if (!item) { return { canEdit: false, errorMessage: 'No transaction selected.' }; }

        if ($scope.selectedItems.length > 1) {
            return { canEdit: false, errorMessage: 'Cannot edit multiple transactions.' };
        }

        if (item.isProcessing) {
            return { canEdit: false, errorMessage: 'Corporate Action Process is pending' };
        }

        return { canEdit: true };
    }

    function getCanEditMultipleStatus() {
        if ($scope.selectedItems.length < 2) {
            return { canEdit: false, errorMessage: 'More than one transaction must be selected.' };
        }
        const result = { canEdit: true, errorMessage: '' };

        if ($scope.selectedItems.some(t => t.isProcessing)) {
            result.canEdit = false;
            result.errorMessage = 'Corporate Action Process is pending for at least one transaction';
        }

        const dbId = $scope.selectedItems[0].alClientId;
        if ($scope.selectedItems.some(t => t.alClientId !== dbId)) {
            result.canEdit = false;
            result.errorMessage +=
                `${result.errorMessage ? ' and a' : 'A'}ll transactions must be in the same database.`;
        }

        return result;
    }

    function getSelectedAction() {
        if (!($scope.selectedItems && $scope.selectedItems.length)) { return ''; }
        return $scope.selectedItems.length > 1 ? 'Mass Update' : 'Edit Transaction';
    }

    function getActionStatus(action) {
        if (!action) { return { canEdit: false, errorsMessage: '' }; }
        return isMassUpdate(action) ? getCanEditMultipleStatus() : getCanEditSingleStatus();
    }

    function isMassUpdate(action) {
        return action === 'Mass Update';
    }

    function editSelectedTransaction() {
        const status = getCanEditSingleStatus();
        if (!(status && status.canEdit)) {
            throw new Error((status && status.errorMessage) || 'Invalid action status for transaction edit.');
        }

        const transaction = $scope.selectedItems[0];
        tokenFactory.getDatabaseToken(transaction.alClientId)
            .then(function (token) {
                const url = getTransactionEditUrl(token, transaction.transactionId, transaction.assetId);
                window.open(url, '__blank');
            })
            .catch(handleError);
    }

    function getTransactionEditUrl(token, transactionId, assetId) {
        const location = window.location;
        const path = location.pathname.replace('index.html', '') + 'integration.html';
        const targetPath = encodeURIComponent(getTransactionEditUrlTargetPath(transactionId, assetId));
        const query = `t=${token}&p=${targetPath}`;
        return `${location.protocol}//${location.host}${path}?${query}`;
    }

    function getTransactionEditUrlTargetPath(transactionId, assetId) {
        const params = {
            openEditor: true,
            tranId: transactionId,
            entity: entities.asset.value,
            entityId: assetId
        };
        const queryString = Object.keys(params).map(k => `${k}=${params[k] || ''}`).join('&');
        return `/portfolio/transactions?${queryString}`;
    }

    function massUpdateSelectedTransactions() {
        const status = getCanEditMultipleStatus();
        if (!(status && status.canEdit)) {
            throw new Error((status && status.errorMessage) || 'Invalid action status for mass update.');
        }

        $confirmation.openMassEditor(
            entities.corporateActionTransaction.value,
            $scope.selectedItems.map(t => ({ ...t, __database__: t.alClientId, id: t.transactionId })),
            null,
            { isV2: true }
        )   // MassUpdate rejects undefined on modal closed
            .catch(err => err && console.error(err));
    }

    function getParams() {
        return [
            {
                key: 'corporateActionId',
                value: $scope.current.corporateAction && $scope.current.corporateAction.id
            },
            {
                key: 'processingIds',
                value: $scope.current.corporateActionProcess && $scope.current.corporateActionProcess.id
            },
            {
                key: 'productIds',
                value: $scope.current.product && $scope.current.product.productId
            },
            {
                key: 'alClientId',
                value: $scope.current.database && $scope.current.database.id
            },
            {
                key: 'tradeStatuses',
                value: $scope.current.tradeStatuses && $scope.current.tradeStatuses.length
                    ? $scope.current.tradeStatuses
                    : null
            },
            {
                key: 'startRange',
                value: $scope.current.startDate && DateTime.fromJSDate($scope.current.startDate).toISODate()
            },
            {
                key: 'endRange',
                value: $scope.current.endDate && DateTime.fromJSDate($scope.current.endDate).toISODate()
            },
        ].filter(({ value }) => value).reduce((prev, { key, value }) => ({ ...prev, [key]: value }), {});
    }

    function getTradeStatuses() {
        return $http.get('/Trading/TradeStatuses', { cache: true, trackerMsg: 'Loading Trade Statuses' })
            .then(function (response) {                
                $scope.current.tradeStatusOptions = ((response && response.data) || [])
                    // Workaround multi-select-parameter component not properly supporting arrays.
                    .reduce((prev, curr) => ({ ...prev, [curr.name]: curr.name }), {});
            })
            .catch(handleError);
    }

    $scope.$watch('current.corporateAction', function (newCorpAction, _old, scope) {
        if (!newCorpAction) {
            scope.current.processes = [];
            scope.current.corporateActionProcess = null;
            return;
        }

        // This will be handled by initialization.
        if (newCorpAction.id === $scope.current.corporateActionId) { return; }

        return getCorporateActionProcesses(newCorpAction.id, null);
    });

    $scope.$on('event:corpaction-v2-transaction-list-select', function (_, args) {
        if (args && args.length) {
            $scope.selectedItems = args;
            $scope.selectedAction = getSelectedAction();
            $scope.editableStatus = getActionStatus($scope.selectedAction);
            $scope.actionIconClass = isMassUpdate($scope.selectedAction) ? 'fa-pencil' : 'fa-pencil-square-o';
        }
    });
    
    $scope.refreshGrid = function() {
        $scope.$broadcast('event:corpaction-v2-transaction-list-action', { action: 'refresh-grid' });
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:corpaction-v2-transaction-list-action', { action: 'export-data' });
    };

    $scope.searchDisabled = function () {
        return !canSearch();
    };

    $scope.selectedAction = '';
    $scope.editableStatus = { canEdit: false, errorMessage: '' };
    $scope.actionIconClass = '';

    $scope.performEdit = function () {
        isMassUpdate($scope.selectedAction) ? massUpdateSelectedTransactions() : editSelectedTransaction();
    }

    
    $scope.rights = CorporateAction.rights;
    $scope.views = views;

    $scope.selectedItems = [];
    Object.defineProperty($scope, 'selectedIds', {get: function() {return $scope.selectedItems.map('id')}});
    Object.defineProperty($scope, 'selected', {get: function() {return $scope.selectedItems[0] || null;}});

    $scope.current = {
        view: views[0],
        grid: {
            load: function (options) {
                return $q.resolve(initialized).then(function () {
                    if ($scope.searchDisabled()) { return $q.resolve([]); }
                    return CorporateAction.transaction.getAllV2({
                        ...options,
                        params: { ...(options || {}).params, ...getParams() }
                    });
                }).catch(handleError);
            }
        },
        corporateAction: null,
        corporateActionProcess: null,
        product: null,
        database: null,
        tradeStatuses: [],
        startDate: null,
        endDate: null,
        processes: [],
        tradeStatusOptions: [],
        initialCorporateActionId: parseInt($route.current.params.id) || undefined,
        initialCorporateActionProcessingId: parseInt($route.current.params.corporateActionProcessingId) || undefined
    };

    const initialized = init();
});
'use strict';

app.controller('SignOffOversightCtrl', function SignOffOversightCtrl($scope, $http, $oasRights, $location) {

    // PRIVATE METHODS
    function init( ) {
        $scope.rightsSignOffApp = $oasRights.forCode("SIGNOFFAPP");
        $scope.rightsConfirmationOverview = $oasRights.forCode("CONFIRMOVERVIEW");

        loadCalendar();

        $http.get( "/Authorization/User/Rights/Groups", {cache: true, trackerMsg: 'Loading group membership'} )
            .then( function( r ) {
                $scope.current.isDownloadAdmin = r.data && r.data.find("ADMINDOWNLOADERS") != undefined;
            } );

        $http.get( "/Global/ServiceTeamMembers?userManagerId=" + $scope.user.authorization.userId, {cache: true, trackerMsg: 'Loading manager status'} )
            .then( function( r ) {
                $scope.current.isManager = r.data && r.data.length > 0;
            } );

        loadDetailsForDate( );
    }

    function loadCalendar( ) {
        $scope.current.showCalendar = false;
        $http.get( "/confirm/syncdashboard/counts?userTeamOnly=" + $scope.current.limitResultsToMyTeam, {trackerMsg: 'Loading oversight dashboard'} )
            .then( function( r ) {
                if( r.data ) {
                    for( var i = 0; i < r.data.length; i++ ) {
                        if( r.data[i].dateErrorCount > 0 ) {
                            $scope.current.calendarSummary.push({ date: Date.create(r.data[i].summaryDate), statusClass: 'date-error' })
                        }
                    }
                    $scope.current.showCalendar = true;
                }
            } );
    }

    function loadDetailsForDate( ) {
        $scope.current.dateSummary = [];

        $http.get( "/confirm/syncdashboard?date=" + $scope.current.selectedDate.formatted() + '&userTeamOnly=' + $scope.current.limitResultsToMyTeam, {trackerMsg: 'Loading oversight dashboard for date'} )
        .then( function( r ) {
            $scope.current.dateSummary = r.data;
        } );
    }


    // PUBLIC METHODS
    $scope.getDayClass = function( date, mode ) {
        if( mode === 'day' ) {
            var dayToCheck = new Date(date).setHours(0,0,0,0);

            for( var i = 0; i < $scope.current.calendarSummary.length; i++ ) {
                var currentDay = new Date( $scope.current.calendarSummary[i].date ).setHours(0,0,0,0);

                if( dayToCheck === currentDay ) {
                    return $scope.current.calendarSummary[i].statusClass;
                }
            }
        }

        return '';
    };

    $scope.goToSyncDetail = function( sync ) {
        $location.path('/confirmation/signoff/' + sync.toLowerCase());
    };

    $scope.refresh = function( ) {
        loadCalendar( );
        loadDetailsForDate( );
    };


    // WATCHES
    $scope.$watch("current.selectedDate", function (newValue, oldValue) {
        if (newValue === oldValue) return;

        loadDetailsForDate( );
    }, true);


    // INIT
    $scope.current = {
        selectedDate: Date.create('today'),
        showCalendar: false,
        calendarSummary: [],
        dateSummary: [],
        isManager: false,
        limitResultsToMyTeam: false
    };

    init( );
});


'use strict';

app.controller('SignOffInterfaceListCtrl', function SignOffInterfaceListCtrl($scope, $http, $oasRights, views, syncType, $dialog, tokenFactory, $portfolio, $routeParams, $timeout) {

    var redirectUrl = window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html?p={1}";

    // PRIVATE METHODS
    function init( ) {
        $scope.rightsSignOffApp = $oasRights.forCode("SIGNOFFAPP");
        $scope.rightsConfirmationOverview = $oasRights.forCode("CONFIRMOVERVIEW");

        $http.get( "/Authorization/User/Rights/Groups", {cache: true, trackerMsg: 'Loading group membership'} )
            .then( function( r ) {
                $scope.current.isDownloadAdmin = r.data && r.data.find("ADMINDOWNLOADERS") != undefined;

                if( $scope.current.isDownloadAdmin ) {
                    $http.get( "/Global/ServiceTeamMembers/UserManagers", {cache: true, trackerMsg: 'Loading managers'} )
                        .then( function( s ) {
                            $scope.managers = s.data;
                        } );
                }

            } );

        $http.get( "/Global/ServiceTeamMembers?userManagerId=" + $scope.user.authorization.userId, {cache: true, trackerMsg: 'Loading manager status'} )
            .then( function( r ) {
                $scope.current.isManager = r.data && r.data.length > 0;
            } );

        $http.get( "/Global/ServiceTeamMembers", {cache: true, trackerMsg: 'Loading analysts'} )
            .then( function( s ) {
                if( s.data && s.data.length > 0 ) {
                    var analysts = s.data.findAll( {isAnalyst: true} );
                    if( analysts ) {
                        $scope.analysts = analysts.sortBy("userName");
                        $scope.analysts.insert( {id: null, userName: '(all)'}, 0 );
                    }
                }
            } );
    }


    // LISTENERS
    $scope.$on('event:signoff-interface-list-select', function(e, args) {
        $scope.current.entityContextLinks = [];
        $scope.current.databaseName = null;
        $scope.current.databaseUrl = null;
        var transactionLinks = [];

        if( args.length ) {

            tokenFactory.getDatabaseToken(args[0].alClientId)
                .then(function (token) {

                    $http.get( "/Confirm/DownloadFiles/" + args[0].downloadFileID + "/Details/" + args[0].downloadRecordId, {headers: {Authorization: "Session " + token}}, {cache: true, trackerMsg: 'Loading download record'} )
                        .then( function( r ) {
                            if( r.data && r.data.link ) {

                                if( r.data.link.clientId ) {
                                    $scope.current.entityContextLinks.push( { entity: "Household", entityId:  r.data.link.clientId, url: redirectUrl.assign($portfolio.getGoToRoute("households", 5, r.data.link.clientId, true ) + '&t=' + token ) } );
                                }
                                if( r.data.link.registrationId ) {
                                    $scope.current.entityContextLinks.push( { entity: "Registration", entityId:  r.data.link.registrationId, url: redirectUrl.assign($portfolio.getGoToRoute("registrations", 6, r.data.link.registrationId, true ) + '&t=' + token ) } );
                                }
                                if( r.data.link.accountId ) {
                                    $scope.current.entityContextLinks.push( { entity: "Account", entityId:  r.data.link.accountId, url: redirectUrl.assign($portfolio.getGoToRoute("accounts", 7, r.data.link.accountId, true ) + '&t=' + token ) } );
                                }
                                if( r.data.link.assetId ) {
                                    $scope.current.entityContextLinks.push( { entity: "Asset", entityId:  r.data.link.assetId, url: redirectUrl.assign($portfolio.getGoToRoute("assets", 8, r.data.link.assetId, true ) + '&t=' + token ) } );

                                    transactionLinks.push( { entity: "Transaction", entityId: null, url: redirectUrl.assign($portfolio.getGoToRoute("assets", 8, r.data.link.assetId, true )).replace( 'assets', 'transactions' ) + '&t=' + token } );
                                    $scope.current.entityContextLinks.add(transactionLinks);

                                }

                            }
                        } );

                });
        }
    });


    // PUBLIC METHODS
    $scope.refreshGrid = function( ) {
        $scope.$broadcast('event:signoff-interface-list-action', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:signoff-interface-list-action', {action: 'export-data'});
    };
    
    $scope.signOff = function( isAnalystSignOff ) {
        $dialog.inputBox('Sign Off Notes', "Notes", "textarea")
            .open()
            .then(function(rslt){
                if( rslt && rslt.trim().length > 0 ){
                    var payload = {
                        syncIds: $scope.selectedIds,
                        syncType: $scope.current.syncType,
                        managerSignOff: !isAnalystSignOff,
                        syncNote: rslt,
                        priceNote: null
                    };
                    
                    $http.put('/Confirm/InterfaceSyncs/Action/SignOff', payload, {trackerMsg: 'Signing off'})
                        .then(function( r ) {
                            $scope.$broadcast('event:signoff-interface-list-action', {action: 'update-items', items: r.data });
                        });
                }
            });
    };

    $scope.removeDownloadFileFilter = function( ) {
        $scope.current.downloadFileId = 0;
        $timeout(function () {
            $scope.refreshGrid( );
        });
    };

    // INITIALIZE
    var startDate = null;
    var endDate = null;
    if( syncType == 1) {
        if( new Date().isMonday() ) {
            startDate = Date.create('three days ago');
            endDate = Date.create('three days ago');
        } else if( new Date().isTuesday() ) {
            startDate = Date.create('three days ago');
            endDate = Date.create('yesterday');
        } else {
            startDate = Date.create('yesterday');
            endDate = Date.create('yesterday');
        }
    } else {
        startDate = Date.create('last monday');
        endDate = Date.create('last monday').advance({ days: 6 });
    }

    $scope.current = {
        view: views[0],
        startDate: startDate,
        endDate: endDate,
        isDownloadAdmin: false,
        isManager: false,
        limitResultsToMyTeam: false,
        syncType: syncType,
        entityContextLinks: [],
        selectedManager: syncType == 1 ? 0 : '',
        downloadFileId: 0
    };

    if( $routeParams.startDate ) {
        $scope.current.startDate = $routeParams.startDate;
    }

    if( $routeParams.endDate ) {
        $scope.current.endDate = $routeParams.endDate;
    }

    if( $routeParams.userManagerId ) {
        $scope.current.selectedManager = $routeParams.userManagerId;
    }

    if( $routeParams.downloadFileId ) {
        $scope.current.downloadFileId = $routeParams.downloadFileId;
    }

    
    $scope.views = views;
    $scope.selectedIds = [];

    init( );
});

'use strict';

app.controller('SignOffExclusionListCtrl', function SignOffExclusionListCtrl($scope, $http, $oasRights, views, $dialog) {

    // PRIVATE METHODS
    function init( ) {
        $scope.rightsSignOffApp = $oasRights.forCode("SIGNOFFAPP");
        $scope.rightsConfirmationOverview = $oasRights.forCode("CONFIRMOVERVIEW");
        $scope.rightsExclusion = $oasRights.forCode("DOWNLOADEXCLUSION");

        $http.get( "/Authorization/User/Rights/Groups", {cache: true, trackerMsg: 'Loading group membership'} )
            .then( function( r ) {
                $scope.current.isDownloadAdmin = r.data && r.data.find("ADMINDOWNLOADERS") != undefined;
        } );

        $http.get( "/Global/ServiceTeamMembers?userManagerId=" + $scope.user.authorization.userId, {cache: true, trackerMsg: 'Loading manager status'} )
            .then( function( r ) {
                $scope.current.isManager = r.data && r.data.length > 0;
        } );
    }


    // PUBLIC METHODS
    $scope.refreshGrid = function( ) {
        $scope.$broadcast('event:signoff-exclusion-list-action', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:signoff-exclusion-list-action', {action: 'export-data'});
    };

    $scope.signOff = function( isAnalystSignOff ) {
        $dialog.inputBox('Sign Off Notes', "Notes", "textarea")
            .open()
            .then(function(rslt){
                if( rslt && rslt.trim().length > 0 ){
                    var payload = {
                        syncIds: $scope.selectedIds,
                        syncType: 3,
                        managerSignOff: !isAnalystSignOff,
                        syncNote: rslt,
                        priceNote: null
                    };

                    $http.put('/Confirm/ExclusionSync/Action/SignOff', payload, {trackerMsg: 'Signing off'})
                        .then(function( r ) {
                            $scope.$broadcast('event:signoff-exclusion-list-action', {action: 'update-items', items: r.data });
                        });
                }
            });
    };


    // INIT
    init( );

    $scope.views = views;
    $scope.selectedIds = [];

    var startDate = '';
    var endDate = '';
    if( new Date().isMonday() ) {
        startDate = 'three days ago';
        endDate = 'three days ago';
    } else if( new Date().isTuesday() ) {
        startDate = 'three days ago';
        endDate = 'yesterday';
    } else {
        startDate = 'yesterday';
        endDate = 'yesterday';
    }

    $scope.current = {
        view: views[0],
        startDate: Date.create(startDate),
        endDate: Date.create(endDate),
        isDownloadAdmin: false,
        isManager: false,
        limitResultsToMyTeam: false
    };

});

'use strict';

app.controller('SignOffPriceListCtrl', function SignOffPriceListCtrl($scope, $http, $oasRights, $dialog, views) {

    // PRIVATE METHODS
    function init( ) {
        $scope.rightsSignOffApp = $oasRights.forCode("SIGNOFFAPP");
        $scope.rightsConfirmationOverview = $oasRights.forCode("CONFIRMOVERVIEW");
        $scope.rightsPrices = $oasRights.forCode("PRICES");

        $http.get( "/Authorization/User/Rights/Groups", {cache: true, trackerMsg: 'Loading group membership'} )
            .then( function( r ) {
                $scope.current.isDownloadAdmin = r.data && r.data.find("ADMINDOWNLOADERS") != undefined;
        } );

        $http.get( "/Global/ServiceTeamMembers?userManagerId=" + $scope.user.authorization.userId, {cache: true, trackerMsg: 'Loading manager status'} )
            .then( function( r ) {
                $scope.current.isManager = r.data && r.data.length > 0;
        } );
    }


    // PUBLIC METHODS
    $scope.refreshGrid = function( ) {
        $scope.$broadcast('event:signoff-price-list-action', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:signoff-price-list-action', {action: 'export-data'});
    };

    $scope.addPriceNotes = function() {
        $dialog.inputBox('Enter price notes', "Notes", "textarea")
            .open()
            .then(function(rslt){
                if( rslt && rslt.trim().length > 0 ){
                    var payload = {
                        syncIds: $scope.selectedIds,
                        priceNote: rslt
                    };
                    $http.put('/Confirm/MissingPriceSyncs/Action/PriceNote', payload, {trackerMsg: 'Adding price notes'})
                        .then(function( r ) {
                            $scope.$broadcast('event:signoff-price-list-action', {action: 'update-items', items: r.data });
                    });
                }
            });
    };

    $scope.signOff = function( isAnalystSignOff ) {
        $dialog.inputBox('Sign Off Notes', "Notes", "textarea")
            .open()
            .then(function(rslt){
                if( rslt && rslt.trim().length > 0 ){
                    var payload = {
                        syncIds: $scope.selectedIds,
                        syncType: 4,
                        managerSignOff: !isAnalystSignOff,
                        syncNote: rslt,
                        priceNote: null
                    };

                    $http.put('/Confirm/MissingPriceSyncs/Action/SignOff', payload, {trackerMsg: 'Signing off'})
                        .then(function( r ) {
                            $scope.$broadcast('event:signoff-price-list-action', {action: 'update-items', items: r.data });
                        });
                }
            });
    };


    // INIT
    init( );

    $scope.views = views;

    $scope.selectedIds = [];
    $scope.current = {
        view: views[0],
        startDate: new Date().isMonday() ? Date.create('three days ago') : Date.create('two days ago'),
        endDate: new Date().isMonday() ? Date.create('three days ago') : Date.create('two days ago'),
        isDownloadAdmin: false,
        isManager: false,
        limitResultsToMyTeam: false
    };

});

'use strict';

app.controller('SignOffSyncHistoryCtrl', function SignOffSyncHistoryCtrl($scope, $http, $oasRights, $dialog, views) {

    // PRIVATE METHODS
    function init( ) {
        $scope.rightsSignOffApp = $oasRights.forCode("SIGNOFFAPP");
    }


    // PUBLIC METHODS
    $scope.refreshGrid = function( ) {
        $scope.$broadcast('event:signoff-synchistory-action', {action: 'refresh-grid'});
    };

    $scope.runSync = function( ) {
        $dialog.dialog({templateUrl: "confirmation/signoff/modals/signOffSyncSetup.html", controller: "SignOffSyncSetupCtrl"}).open()
            .then(function (result) {
                    if( result && result.status && result.status == 'success' ) {
                        $scope.refreshGrid( );
                    }
                }
            );
    };


    // INIT
    init( );

    $scope.views = views;

    $scope.selectedIds = [];
    $scope.current = { view : views[0], startDate: Date.create('today'), endDate: Date.create('today') };

});

'use strict';

app.controller('SignOffRulesListCtrl', function SignOffRulesListCtrl($scope, $http, $oasRights, $dialog) {

    // PRIVATE METHODS
    function init( ) {
        $scope.rightsSignOffApp = $oasRights.forCode("SIGNOFFAPP");
        $scope.signOffRules = null;

        $http.get( "/confirm/rules/", {trackerMsg: 'Loading sign off rules'} )
            .then( function( r ) {
                $scope.signOffRules = r.data;
        } );

        $http.get( "/confirm/statusTypes/", {trackerMsg: 'Loading status types'} )
            .then( function( r ) {
                $scope.signOffStatusTypes = r.data;
            } );

        $http.get( "/confirm/syncTypes/", {trackerMsg: 'Loading sync types'} )
            .then( function( r ) {
                $scope.signOffSyncTypes = r.data;
            } );
    }

    function saveRule( rule ) {
        if( rule.id == 0 ) {
            $http.post('/confirm/rules/', rule, {trackerMsg: 'Adding new rule'})
                .then(function ( r ) {
                    rule.id = r.data.id
                });
        } else {
            $http.put('/confirm/rules/' + rule.id, rule, {trackerMsg: 'Saving rule ' + rule.id})
                .then(function () {
                    rule.isDirty = false;
                });
        }
    }


    // PUBLIC METHODS
    $scope.addRule = function( ) {
        $scope.signOffRules.push( { id : 0, syncTypeId : 1, numDaysAnalyst: 0, numDaysManager: 0, statusTypeId : 1, notificationInbox : false, isDirty: true } );
    };

    $scope.deleteRule = function( rule ) {
        $dialog.confirmAction("Do you want to delete the rule?")
            .open()
            .then(function (result) {
                if (result === 'yes') {

                    if( rule.id > 0 ) {
                        $http.delete('/confirm/rules/' + rule.id, {trackerMsg: 'Deleting rule ' + rule.id})
                            .then(function () {
                                $scope.signOffRules.remove( {id: rule.id} );
                            });
                    } else {
                        $scope.signOffRules.remove( {id: rule.id} );
                    }

                }
            });
    };

    $scope.saveRules = function( ) {
        for( var i = 0; i < $scope.signOffRules.length; i++ ) {
            if( $scope.signOffRules[i].isDirty ) {
                saveRule( $scope.signOffRules[i] );
            }
        }
    };


    // INIT
    init( );

});

'use strict';

app.controller('SignOffInterfaceFileListCtrl', function SignOffInterfaceFileListCtrl($scope, $http, $oasRights, views, $dialog) {

    // PRIVATE METHODS
    function init( ) {
        $scope.rightsSignOffApp = $oasRights.forCode("SIGNOFFAPP");
        $scope.rightsConfirmationOverview = $oasRights.forCode("CONFIRMOVERVIEW");

        $http.get( "/Authorization/User/Rights/Groups", {cache: true, trackerMsg: 'Loading group membership'} )
            .then( function( r ) {
                $scope.current.isDownloadAdmin = r.data && r.data.find("ADMINDOWNLOADERS") != undefined;
            } );

        $http.get( "/Global/ServiceTeamMembers?userManagerId=" + $scope.user.authorization.userId, {cache: true, trackerMsg: 'Loading manager status'} )
            .then( function( r ) {
                $scope.current.isManager = r.data && r.data.length > 0;
            } );

        $http.get( "/Global/ServiceTeamMembers", {cache: true, trackerMsg: 'Loading analysts'} )
            .then( function( s ) {
                if( s.data && s.data.length > 0 ) {
                    var analysts = s.data.findAll( {isAnalyst: true} );
                    if( analysts ) {
                        $scope.analysts = analysts.sortBy("userName");
                        $scope.analysts.insert( {id: null, userName: '(all)'}, 0 );
                    }
                }
            } );
    }


    // PUBLIC METHODS
    $scope.refreshGrid = function( ) {
        $scope.$broadcast('event:signoff-interface-file-list-action', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:signoff-interface-file-list-action', {action: 'export-data'});
    };

    $scope.signOff = function( isAnalystSignOff ) {
        $dialog.inputBox('Sign Off Notes', "Notes", "textarea")
            .open()
            .then(function(rslt){
                if( rslt && rslt.trim().length > 0 ){

                    var startDate = Date.create($scope.current.startDate).format('{MM}-{dd}-{yyyy}');

                    $http.get( "/Confirm/InterfaceSyncs?syncType=1&startDate=" + startDate + "&endDate=" + startDate + "&downloadFileId=" + $scope.current.downloadFileId + "&databaseId=" + $scope.current.alClientId, {trackerMsg: 'Loading allowed records to sign'} )
                        .then( function( r ) {

                            if( r && r.data && r.data.length > 0 ) {

                                var ids = [];
                                for( var i = 0; i < r.data.length; i++ ) {
                                    ids.push( r.data[i].id );
                                }

                                var payload = {
                                    syncIds: ids,
                                    syncType: 1,
                                    managerSignOff: !isAnalystSignOff,
                                    syncNote: rslt,
                                    priceNote: null
                                };

                                $http.put('/Confirm/ExclusionSync/Action/SignOff', payload, {trackerMsg: 'Signing off'})
                                    .then(function( r ) {
                                        $scope.$broadcast('event:signoff-interface-file-list-action', {action: 'refresh-grid', items: r.data });
                                });

                            } else {
                                $dialog.messageBox("No Records Found", "No records found to sign off.").open();
                            }

                        } );

                }
            });
    };


    // LISTENERS
    $scope.$on('event:signoff-interface-file-list-select', function(e, args) {
        $scope.current.downloadFileId = 0;
        $scope.current.userManagerId = 0;
        $scope.current.alClientId = 0;
        if( args.length ) {
            $scope.current.downloadFileId = args[0].downloadFileId;
            $scope.current.userManagerId = args[0].userManagerId;
            $scope.current.alClientId = args[0].alClientId;
        }
    });


    // INIT
    init( );

    $scope.views = views;
    $scope.selectedIds = [];

    var startDate = '';
    var endDate = '';
    if( new Date().isMonday() ) {
        startDate = 'three days ago';
        endDate = 'three days ago';
    } else if( new Date().isTuesday() ) {
        startDate = 'three days ago';
        endDate = 'yesterday';
    } else {
        startDate = 'yesterday';
        endDate = 'yesterday';
    }

    $scope.current = {
        view: views[0],
        startDate: Date.create(startDate),
        endDate: Date.create(endDate),
        isDownloadAdmin: false,
        isManager: false,
        userManagerId: 0,
        downloadFileId: 0,
        alClientId: 0
    };

});

app.controller('SignOffSyncSetupCtrl', function SignOffSyncSetupCtrl( $scope, $http, dialog, tokenFactory, $oasRights ){

    //PRIVATE METHODS
    function init( ) {
        $scope.rightsSignOffApp = $oasRights.forCode("SIGNOFFAPP");

        loadDatabases( );

        // $http.get( "/something/syncTypes/", {trackerMsg: 'Loading sync types'} )
        //     .then( function( r ) {
        //         $scope.signOffSyncTypes = r.data;
        //     } );

        $scope.signOffSyncTypes = [
            { id : 1, syncType: 'Daily' },
            { id : 2, syncType: 'Weekly' },
            { id : 3, syncType: 'Exclusion' },
            { id : 4, syncType: 'Price' }
        ];
    }

    function loadDatabases( ) {
        $http.get("/Authorization/Databases", {cache: true, trackerMsg: 'Loading databases', ignoreExceptions: true})
            .then(function (response) {
                $scope.databases = response.data;
            });
    }

    function loadDownloadSources( ) {
        tokenFactory.getDatabaseToken( $scope.current.databaseId )
            .then(function (token) {
                $scope.current.databaseToken = token;
                $http.get("/Confirm/DownloadSources/Simple", {headers: {Authorization: "Session " + token}}, {trackerMsg: 'Loading download sources', ignoreExceptions: true})
                    .then(function (response) {
                        $scope.downloadSources = response.data;
                    });

            });
    }


    // PUBLIC METHODS
    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.runSync = function( ) {
        var queryString = "?syncTypeId=" + $scope.current.syncTypeId + "&databaseId=" + $scope.current.databaseId + "&downloadSourceId=" + $scope.current.downloadSourceId + "&startDate=" + $scope.current.startDate.formatted() + "&endDate=" + $scope.current.endDate.formatted();
        $http.put('/Confirm/ReconJobStatuses/RunReconSyncProcess/' + queryString, null, {trackerMsg: 'Running recon sync process'})
            .then(function() {
                dialog.close( { status: 'success' } );
            })
    };

    $scope.loadDownloadSources = function( ) {
        $scope.current.downloadSourceId = 0;
        loadDownloadSources( );
    };


    // INIT
    $scope.current = { syncTypeId: 1, databaseId: 0, downloadSourceId: 0, databaseToken: '', startDate: Date.create('today'), endDate: Date.create('today') };

    init( );

});
'use strict';

var heldAwayAccountListCtrl = app.controller('HeldAwayAccountListCtrl', function HeldAwayAccountListCtrl($scope, $http, views, $location, $timeout, $portfolio, $dialog, entities, apps, AccountComposer, settings, $routeParams) {

    // PRIVATE METHODS
    function init() {
        getCounts();
        setFilter();
    }

    function getCounts() {
        return $http.get('/Confirm/HeldAway/Counts?startDate=' + $scope.current.startDate.format('{MM}-{dd}-{yyyy}') + '&endDate=' + $scope.current.endDate.format('{MM}-{dd}-{yyyy}'), {trackerMsg: 'Loading counts'})
            .then(function (r) {
                $scope.counts = r.data;
            });
    }

    function setFilter( ) {
        if( $routeParams.errorType ) {
            if( $routeParams.errorType === "performanceErrors" ) {
                $scope.filterGrid( 'performanceErrorCount' );
            } else if( $routeParams.errorType === "transactionErrors" ) {
                $scope.filterGrid( 'transactionErrorCount' );
            }
        }
    }

    function slickGridDoubleClick() {
        if ($scope.selectedIds.length === 1) {
            $scope.openEditor();
        }
    }

    function refreshGrid() {
        getCounts();
        $scope.$broadcast('event:heldaway-account-list-action', {action: 'refresh-grid'});
    }


    // PUBLIC METHODS
    $scope.refreshGrid = refreshGrid;

    $scope.refreshConfirmErrors = function( ) {
        var wait = !($scope.selectedIds.length > $scope.current.refreshWaitLimit);
        return AccountComposer.heldAwayAsset.refreshConfirmErrors({trim: true, params:{waitLimit: $scope.current.refreshWaitLimit}, data: $scope.selectedIds}).then(function(){
            if(wait) return refreshGrid();
        });
    };

    $scope.viewErrors = function (errorType) {
        $location.url('/confirmation/heldaway/accounts/' + errorType + 'Errors?ids=' + $scope.selectedIds.join(','));
    };

    $scope.filterGrid = function (field) {
        $scope.current.view.filters.length = 0;

        if (field !== 'all') {
            $scope.current.view.filters.push({name: field === 'performanceErrorCount' ? "Performance Errors" : 'Transaction Errors', value: "(function (a) { return a && a > 0; })", key: field, include: true});
        }
    };

    $scope.openEditor = function () {
        if ($scope.selectedIds.length === 1) {
            $portfolio.openEditor(entities.account.value, $scope.selectedIds, null, null, apps.portfolioLists.name, null)
                .then(function (rslt) {
                    if (rslt) {
                        // $scope.$broadcast( 'event:heldaway-account-list-action', {action: rslt.isNew ? 'add-item' : 'update-item', item: rslt } );
                    }
                });
        } else {
            $portfolio.openMassEditor(entities.account.value, $scope.selectedIds, apps.portfolioLists.name, null)
                .then(function (rslt) {
                    if (rslt) {
                        //$scope.$broadcast('event:heldaway-account-list-action', {action: 'update-items', items: rslt});
                    }
                });
        }
    };

    $scope.addAccount = function () {
        $dialog.search('account', 'Add Account')
            .open()
            .then(function (result) {
                if (!result) return;

                $http.get("/Portfolio/Accounts/Verbose/" + result.id + "?expand=portfolio", {trackerMsg: 'Loading account'})
                    .then(function (response) {
                        var account = response.data;

                        account.portfolio.isPositionOnlyRecon = true;

                        $http.put('/Portfolio/Accounts/Verbose/' + account.id, account, {trackerMsg: 'Updating account'})
                            .then(function () {
                                // TODO: Need a look up to get just an account
                                refreshGrid();
                            });
                    });
            });
    };

    $scope.showErrorsOnly = function( ) {
        $scope.current.isShowErrorsOnly = !$scope.current.isShowErrorsOnly;
        $timeout(function() {$scope.refreshGrid( );});
    };


    // INITIALIZE
    $scope.views = views;

    $scope.$on('event:heldaway-account-list-select', function(e,args){if(args.length) $scope.selectedItems = args;});

    $scope.selectedItems = [];
    Object.defineProperty($scope, 'selectedIds', {get: function() {return $scope.selectedItems.map('id')}});
    Object.defineProperty($scope, 'selected', {get: function() {return $scope.selectedItems[0] || null;}});

    $scope.current = {
        refreshWaitLimit: settings.refreshThreshold.value,
        errorCheckDays: settings.errorCheckDays.value,
        view: views[0],
        startDate: Date.create(settings.errorCheckDays.value + 'days ago'),
        endDate: Date.create('today'),
        url: '/Confirm/HeldAway/Accounts',
        isShowErrorsOnly: true,
        gridDoubleClick: slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function () {
            if ($scope.selectedIds.length) {
                $scope.openEditor();
            }
        }
    }];

    init();
});

heldAwayAccountListCtrl.heldAwaySettings = ["$q", "$confirmation", "AccountComposer", function ($q, $confirmation, AccountComposer) {
    return $q.all({
        errorCheckDays: AccountComposer.setting.getErrorCheckDays({trim: true}),
        refreshThreshold: AccountComposer.setting.getRefreshThreshold({trim: true})
    });
}];
'use strict';

var heldAwayAccountCtrl = app.controller('HeldAwayAccountCtrl', function HeldAwayAccountCtrl($scope, $http, $q, AccountComposer, $oasRights, $routeParams, $dialog, $portfolio, setting, views, entities, apps) {
    //PRIVATE VARIABLES
    var selectedRows = [];


    // PRIVATE METHODS
    function refreshGrid() {
        $scope.$broadcast('event:heldaway-account-action', {action: 'refresh-grid'});
    }


    // PUBLIC METHODS
    $scope.refreshGrid = refreshGrid;

    $scope.refreshConfirmErrors = function () {
        return AccountComposer.heldAwayAsset.refreshConfirmErrors({trim: true, data: $routeParams.ids.split(',')})
            .then(refreshGrid);
    };

    $scope.openEditor = function (entity, idProperty) {
        var ids = selectedRows.map(idProperty).unique();

        return (ids.length === 1
            ? $portfolio.openEditor(entities[entity].value, ids, null, null, apps.portfolioLists.name, null)
            : $portfolio.openMassEditor(entities[entity].value, ids, apps.portfolioLists.name, null)
        ).then(function (result) {
            return result ? $scope.refreshConfirmErrors().then(refreshGrid) : $q.reject();
        });

    };

    $scope.viewDownloadedTransactions = function () {
        var transaction = selectedRows[0];

        AccountComposer.heldAwayAccount.getSimple({trim: true, params: {key: transaction.accountId}})
            .then(function (account) {
                var settings = {
                    templateUrl: "confirmation/heldaway/modals/held-away-transactions.html",
                    controller: "HeldAwayTransactionsCtrl",
                    dialogClass: "modal medium",
                    account: account,
                    transaction: transaction,
                    startDate: $scope.current.startDate,
                    endDate: $scope.current.endDate
                };

                $dialog.dialog(settings)
                    .open()
                    .then(function (result) {
                        if (result && result.status && result.status === 'success') {
                            refreshGrid();
                        }
                    });
            });
    };

    $scope.openQuickAddTransactions = function () {
        AccountComposer.heldAwayAccount.getSimple({trim: true, params: {key: selectedRows[0].accountId}})
            .then(function (account) {
                var settings = {
                    templateUrl: "portfolio/modals/transactions-quick-add.html",
                    controller: "TransactionsQuickAddCtrl",
                    dialogClass: "edit-pane",
                    account: account,
                    isPositionOnly: true,
                    positionOnlyStartDate: $scope.current.startDate,
                    positionOnlyEndDate: $scope.current.endDate
                };

                $dialog.dialog(settings).open();
            });
    };

    $scope.addLocalPrice = function () {
        $dialog.inputBox('Enter local price', 'Add Local Price', "number")
            .open()
            .then(function (result) {
                if (!result) return;

                var asset = selectedRows[0];

                $http.post('/Portfolio/Products/Prices/Local', {productId: asset.productId, priceDate: asset.asOfDate, navPrice: result}, {trackerMsg: 'Adding local price'});
            });
    };

    $scope.updateExcludedFromPositionOnly = function () {
        var transaction = selectedRows[0];
        AccountComposer.heldAwayAsset.updateExcludeFromPositionOnly({params: {accountId: transaction.accountId, excludedFromPositionOnly: !transaction.excludedFromPositionOnly}, data: [transaction.assetId]})
            .then(function () {
                refreshGrid();
                transaction.excludedFromPositionOnly = !transaction.excludedFromPositionOnly;
            });
    };

    $scope.markSelectedAcceptable = function () {
        $dialog.inputBox('Mark Acceptable', 'Enter Note', "textarea", {required:false}).open()
            .then(function (result) {
                if(result === false) return;
                AccountComposer.heldAwayAsset.markAcceptable({trim: true, params: {note: result}, data: selectedRows.map(function (r) {return {assetId: r.assetId, asOfDate: r.asOfDate};})})
                    .then(refreshGrid);
            });
    };

    $scope.removeSelectedAcceptable = function() {
        AccountComposer.heldAwayAsset.removeAcceptable({trim: true, data: selectedRows.map(function (r) {return {assetId: r.assetId, asOfDate: r.asOfDate};})})
            .then(refreshGrid);
    };

    $scope.viewMappedTransactionTypes = function() {
        var args = {
            transaction: null,
            accountId: $scope.current.accountIdList.split(',')[0]
        };

        $dialog.dialog({templateUrl: "confirmation/heldaway/modals/held-away-transaction-type-map.html", controller: "HeldAwayTransactionTypeMapCtrl", dialogClass:"modal medium", resolve: {args: function () {return args;}}})
            .open()
    };

    $scope.showErrorsOnly = function() {
        $scope.current.isShowErrorsOnly = !$scope.current.isShowErrorsOnly;
        $scope.current.gridQueries.find({id: 'errorFilter'}).enabled = $scope.current.isShowErrorsOnly;
        $scope.current.gridQueries.find({id: 'notAcceptableFilter'}).enabled = $scope.current.isShowErrorsOnly;
    };

    // INITIALIZE
    $scope.views = views;

    $scope.selectedIds = [];

    $scope.current = {
        view: views[0],
        startDate: Date.create(setting.errorCheckDays.value + ' days ago'),
        endDate: Date.create('today'),
        accountComposerUrl: '#/confirmation/heldaway/accounts?errorType=' + $routeParams.errorType,
        errorType: $routeParams.errorType.titleize(),
        gridQueries: [
            {id: "errorFilter", name: "Error Filter", filterFn: function (a) {return a === true;}, field: $routeParams.errorType.singularize(), enabled: true, visible: false},
            {id: "notAcceptableFilter", name: "Not Acceptable Filter", filterFn: function (a) {return a !== true;}, field: 'acceptable', enabled: true, visible: false}
        ],
        isShowErrorsOnly: true,
        url: "/Confirm/HeldAway/Accounts" + ($routeParams.errorType === "performanceErrors" ? "/AssetValueConfirmError" : "/Transactions"),
        accountIdList: $routeParams.ids
    };


    //EVENT LISTENERS
    $scope.$on('event:rows-selected', function (e, args) {
        e.stopPropagation();
        if (args.length === 0) return;

        selectedRows = args;
        $scope.current.selectedRow = args[0];
    });
});

heldAwayAccountCtrl.setting = ["$q", "$confirmation", "AccountComposer", function ($q, $confirmation, AccountComposer) {
    return $q.all({
        errorCheckDays: AccountComposer.setting.getErrorCheckDays({trim: true})
    });
}];

heldAwayAccountCtrl.loadHeldAwayAccountViews = ["$http", "$route", function ($http, $route) {
    return $http.get('/Settings/Views/' + ($route.current.params.errorType === "performanceErrors" ? "HeldAwayAssetValueWithErrorDto" : "HeldAwayTransactionithErrorDto"), {trackerMsg : 'Loading views'}).then(function(response) {return response.data});
}];
app.controller('HeldAwayTransactionsCtrl', function HeldAwayTransactionsCtrl( $scope, $http, $dialog, dialog ) {

    //PRIVATE METHODS
    function init( ) {
        $scope.current = { downloadTransactions: null, downloadTransactionsTotalUnits: 0, downloadTransactionsTotalAmount: 0 };
        $scope.result = { status: '' };
        $scope.transaction = dialog.options.transaction;
        $scope.account = dialog.options.account;
        loadTransactions( );
    }

    function loadTransactions( ) {
        $scope.current.downloadTransactionsTotalUnits = 0;
        $scope.current.downloadTransactionsTotalAmount = 0;
        $scope.current.downloadUndefinedTypeTransactionsTotalUnits = 0;
        $scope.current.downloadUndefinedTypeTransactionsTotalAmount = 0;

        var startDate = Date.create(dialog.options.startDate).format('{MM}-{dd}-{yyyy}');
        var endDate = Date.create(dialog.options.endDate).format('{MM}-{dd}-{yyyy}');

        $http.get('/Confirm/DownloadFiles/Details?downloadStatus=notConfirmed&recordType=Transaction&accountNumber=' + dialog.options.account.number + '&memoCode=302' + '&startDate=' + startDate + '&endDate=' + endDate, {trackerMsg: 'Loading transactions'})
            .then(function (r) {
                $scope.current.downloadTransactions = r.data;
                if( r.data && r.data.length > 0 ) {
                    for( var i = 0; i < r.data.length; i++ ) {
                        $scope.current.downloadTransactionsTotalUnits += r.data[i].noUnits;
                        $scope.current.downloadTransactionsTotalAmount += r.data[i].netTransactionAmount;
                    }
                }
            });

        $http.get('/Confirm/DownloadFiles/Details?downloadStatus=notConfirmed&recordType=Transaction&accountNumber=' + dialog.options.account.number + '&memoCode=313' + '&startDate=' + startDate + '&endDate=' + endDate, {trackerMsg: 'Loading transactions'})
            .then(function (r) {
                $scope.current.downloadUndefinedTypeTransactions = r.data;
                if( r.data && r.data.length > 0 ) {
                    for( var i = 0; i < r.data.length; i++ ) {
                        $scope.current.downloadUndefinedTypeTransactionsTotalUnits += r.data[i].noUnits;
                        $scope.current.downloadUndefinedTypeTransactionsTotalAmount += r.data[i].netTransactionAmount;
                    }
                }
            });

    }


    // PUBLIC METHODS
    $scope.addUnmapped = function( downloadTran ) {
        $http.put('/Confirm/HeldAway/DownloadTransToTransaction?downloadTransId=' + downloadTran.id + '&assetId=' + $scope.transaction.assetId, {}, {trackerMsg: 'Adding transaction'})
            .then(function ( ) {
                $scope.result.status = 'success';
            });
    };

    $scope.addUnmappedTranType = function( downloadTran ) {
        //open modal to add code
        var args = {
            transaction: downloadTran,
            accountId: dialog.options.account.id
        };

        $dialog.dialog({templateUrl: "confirmation/heldaway/modals/held-away-transaction-type-map.html", controller: "HeldAwayTransactionTypeMapCtrl", dialogClass:"modal medium", resolve: {args: function () {return args;}}})
            .open()
    };

    $scope.close = function( ) {
        dialog.close( $scope.result );
    };

    // $scope.ok = function( ) {
    //     dialog.close( {status: 'success'} );
    // };


    // INIT
    init( );

});

app.controller('HeldAwayTransactionTypeMapCtrl', function HeldAwayTransactionTypeMapCtrl($scope, $http, dialog, args) {

    //PRIVATE METHODS
    function init() {
        if (args.transaction){
            //get list of trans types
            $scope.current.transaction = args.transaction;
        }
        getMappedTransactions();
    }

    function getMappedTransactions() {
        $http.get("/Confirm/DownloadMap/Account/" + args.accountId, {trackerMsg: 'Loading mapped transactions'})
            .then(function (response) {
                $scope.current.mappedTransactions = response.data;
            });
    }


    // PUBLIC METHODS

    $scope.add = function () {
        var addMappedTransType = {
            orionKey: $scope.current.transType.id,
            externalCode: $scope.current.transaction.fileTranCode,
            tableName: 'TransactionType'
        };

        $http.post("/Confirm/DownloadMap/Account/" + args.accountId, addMappedTransType, {trackerMsg: 'Adding new mapped transaction'})
            .then(function () {
                getMappedTransactions()
            });

    };

    $scope.remove = function (item) {
        $http.delete('/Confirm/DownloadMap/' + item.id, {trackerMsg: 'Deleting mapping'})
            .then(function() {
                $scope.current.mappedTransactions.remove(item);
            });
    };

    $scope.save = function () {
        $http.put("/Confirm/DownloadMap/List", $scope.current.mappedTransactions, {trackerMsg: 'Updating mapped transaction'})
            .then(function () {
                dialog.close()
            });

    };

    $scope.close = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.current = {
        transType: null,
        mappedTransactions: []
    };

    init();
});
'use strict';

app.controller('AlternativesAccountListCtrl', function AlternativesAccountListCtrl( $scope, $http, views, entities, $portfolio, $oasRights, $dialog, $location, $routeParams, apps, orionVisionSSO ) {

    // PRIVATE VARIABLES
    var redirectUrl = window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html?";


    // PRIVATE METHODS
    function init( ) {
        $scope.rightsHH = $oasRights.forCode( "CLIENTS" );
        $scope.rightsReg = $oasRights.forCode( "REGISTRATIONS" );
        $scope.rightsAcc = $oasRights.forCode( "ACCOUNTS" );
        $scope.rightsAst = $oasRights.forCode( "ASSETS" );
        $scope.rightsCancelAccount = $oasRights.forCode("CANCELACCOUNT");
        $scope.rightsTransaction = $oasRights.forCode( "TRANSACTIONS" );
        $scope.rightsPortfolioAudit = $oasRights.forCode( "PORTFOLIOLISTSAPP" );
        $scope.rightsBillGenerator = $oasRights.forCode( "BILLGENERATOR" );
        $scope.rightsNewAcc = $oasRights.forCode( "NEWACCOUNT" );
        $scope.rightsOrionVision = $oasRights.forCode( "ORIONVISION" );
    }

    function slickGridDoubleClick( ) {
        $scope.openAlternativesAccountEditor( false );
    }

    function doAction( actionUrl, msgVerb, confirmMsg ) {
        $dialog.confirmAction( confirmMsg )
            .open( )
            .then( function( result ){
                if( result === 'yes' ) {
                    $http.put( actionUrl, $scope.selectedIds, {trackerMsg: msgVerb + ' account(s)'} )
                        .then(function ( ) {
                            refreshGrid( );
                        });
                }
            });
    }

    function refreshGrid( ) {
        $scope.$broadcast( 'event:alternatives-account-list-action', {action: 'refresh-grid'} );
    }

    function makeUrl(path) {
        return redirectUrl + $.param({p: path, t: sessionStorage.oas_token});
    }


    // PUBLIC METHODS
   $scope.openAlternativesAccountEditor = function( isNew ) {
        if( isNew ) {
            var d = $dialog.editor( 'confirmation/alternatives/editors/views/alternatives-account-edit.html', 'AlternativesAccountEditCtrl' );
            d.open( ).then(function( result ) {
                if( result ) {
                    $scope.$broadcast( 'event:alternatives-account-list-action', {action: 'add-item', item: result } );
                }
            });
        } else {
            $portfolio.openEditor( entities.account.value, $scope.selectedIds, null, null, apps.portfolioLists.name, null ).then(function(result) {
                if( result ) {
                    $scope.$broadcast( 'event:alternatives-account-list-action', {action: 'update-item', item: result } );
                }
            });
        }
    };

    $scope.openCancellationEditor = function( isMassCancel ) {
        var d = $dialog.editor('portfolio/modals/cancelAccount.html', 'CancelAccountCtrl', {args: function() { return {id : isMassCancel ? null : $scope.selectedIds[0], entity : entities.account.value, app : apps.portfolioLists.name, preselectedIds: isMassCancel ? $scope.selectedIds : null }; }});
        d.open( ).then(function(result) {
            if( result ) {
                refreshGrid( );
            }
        });
    };

    $scope.runReport = function( ) {
        $portfolio.runReport( entities.account.value, $scope.selectedIds[0] );
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast('event:alternatives-account-list-action', {action: 'export-data'});
    };

    $scope.deleteAccounts = function( ) {
        doAction('/portfolio/accounts/action/delete', 'Deleting', 'It is Orion\'s best practice to not delete accounts. If you proceed with this deletion, you will be responsible for providing this data should you need it to be recorded in Orion in the future or for auditing purposes. Are you sure you want to proceed?');
    };

    $scope.goToAssets = function( ) {
        $location.url( '/confirmation/alternatives/assets?accountId=' + $scope.selectedIds[0] );
    };

    $scope.goToBillGenerator = function( ) {
        $location.url( '/billing/generator/billsummary' );
    };

    $scope.goToPortfolioAudit = function( ) {
        $portfolio.goTo( 'accounts', entities.account.value, $scope.selectedIds[0]);
    };

    $scope.goToHigher = function( urlLevel ) {
        if( urlLevel === 'households' && $scope.current.selectedHouseholdId > 0 ) {
            $portfolio.goTo( urlLevel, entities.client.value, $scope.current.selectedHouseholdId );
        } else if( urlLevel === 'registrations' && $scope.current.selectedRegistrationId > 0 ) {
            $portfolio.goTo( urlLevel, entities.registration.value, $scope.current.selectedRegistrationId );
        }
    };

    $scope.goToTransactions = function( ) {
        $location.url( '/confirmation/alternatives/transactions?accountId=' + $scope.selectedIds[0] );
    };

    $scope.goToOrionVision = function(){
        orionVisionSSO.goTo();
    }

    //EVENT LISTENERS
    $scope.$on("event:alternatives-account-list-select", function(e, args) {
        if( args.length === 0 ) return;
        $scope.current.selectedHouseholdId = args[0].clientId;
        $scope.current.selectedRegistrationId = args[0].registrationId;
        $scope.current.selectedAccountId = args[0].id;
    });


    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view: views[0],
        gridDoubleClick: slickGridDoubleClick,
        selectedHouseholdId: 0,
        selectedRegistrationId: 0,
        selectedAccountId: 0,
        gridUrl: '/Portfolio/Accounts' + ( $routeParams.accountId ? '/' + $routeParams.accountId : '' ),
        newAccountsUrl: makeUrl('/portfolio/newaccounts')
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length ) {
                $scope.openAlternativesAccountEditor( false );
            }
        }
    }];

    init( );

});

'use strict';

app.controller('AlternativesAssetListCtrl', function AlternativesAssetListCtrl($scope, $http, views, $oasRights, $dialog, $routeParams, $portfolio, $window, entities, AccountComposer, civ2Service, orionVisionSSO, splitIoService, alternativesAssetEditorSidebarCoordinator, alternativesArchRefreshService, ngToast) {

    const emptyAsset = {
        id: 0,
        productId: 0,
        accountId: 0
    };

    
    // PRIVATE METHODS
    function init( ) {
        $scope.newAlternativesAssetEditor = false;
        $scope.archIntegrationEnabled = false;
        $scope.archRefreshInProgress = false;

        splitIoService.getBoolTreatment('opex_AccountComposer_NewActivityTypes_34892').subscribe(function(isEnabled) {
            $scope.newAlternativesAssetEditor = isEnabled;
        });

        splitIoService.getBoolTreatment('opex_AccountComposer_ArchIntegration_39872').subscribe(function(isEnabled) {
            $scope.archIntegrationEnabled = isEnabled;
            if (!$scope.$$phase) {
                $scope.$applyAsync();
            }
        });

        $scope.rightsAst = $oasRights.forCode( "ASSETS" );
        $scope.rightsAcc = $oasRights.forCode( "ACCOUNTS" );
        $scope.rightsProduct = $oasRights.forCode( "PRODUCTS" );
        $scope.rightsTransaction = $oasRights.forCode( "TRANSACTIONS" );
        $scope.rightsTaxCenterMaintain = $oasRights.forCode( "TAXCENTERMAINTAIN" );
        $scope.rightsPortfolioAudit = $oasRights.forCode( "PORTFOLIOLISTSAPP" );
        $scope.rightsOrionVision = $oasRights.forCode("ORIONVISION");

        $scope.archRefreshDateDialog = { visible: false, confirmationMessage: null };
        $scope.archRefreshPendingAssetIds = [];
        $scope.archRefreshClientSkippedCount = 0;
    }
 

    function slickGridDoubleClick( ) {
            $scope.openAlternativesAssetEditor( $scope.selected );
    }

    function doAction(actionUrl, msgVerb, confirmMsg) {
        $dialog.confirmAction( confirmMsg )
            .open( )
            .then(function( result ){
                if( result === 'yes' ) {
                    $http.put( actionUrl, $scope.selectedIds, {trackerMsg: msgVerb + ' asset(s)'} )
                        .then( function ( ) {
                            $scope.refreshGrid( );
                        });
                }
            });
    }

    function showArchRefreshAlert(detail) {
        $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Refresh from Arch", detail).open();
    }

    function showArchRefreshToast(severity, detail) {
        var className = 'success';
        if (severity === 'error') {
            className = 'danger';
        } else if (severity === 'warn') {
            className = 'warning';
        }

        ngToast.create({
            className: className,
            content: detail
        });
    }


    // PUBLIC METHODS
    $scope.openAlternativesAssetEditor = function( asset, defaultToShow ) {
        if(!asset) asset = emptyAsset;
        if(!defaultToShow) defaultToShow = '';

        splitIoService.getBoolTreatment('opex_AccountComposer_NewActivityTypes_34892').subscribe(function(isEnabled) {
            if (isEnabled) {
                return alternativesAssetEditorSidebarCoordinator.open({
                    id: asset.id,
                    accountId: asset.accountId,
                    productId: asset.productId,
                    defaultToShow: defaultToShow
                }).then(function(rslt) {
                    if (rslt) {
                        $scope.refreshGrid();
                    }
                });
            }

            return $dialog.editor( 'confirmation/alternatives/editors/views/alternatives-asset-edit.html', 'AlternativesAssetEditCtrl', {args: function() { return {
                    id : asset.id,
                    accountId: asset.accountId,
                    productId: asset.productId,
                    expandValuations: defaultToShow.toLowerCase().indexOf('valuation') > -1,
                    expandCommittedCapital: defaultToShow.toLowerCase().indexOf('committedcapital') > -1,
                    expandUnfundedCommitment: defaultToShow.toLowerCase().indexOf('unfundedcommitment') > -1,
                    expandTransactions: defaultToShow.toLowerCase().indexOf('transaction') > -1,
                    expandCapitalCallSchedule: defaultToShow.toLowerCase().indexOf('capitalcall') > -1,
                    expandDistributionSchedule: defaultToShow.toLowerCase().indexOf('distribution') > -1
            }}} ).open( ).then(function( rslt ) {
                if( rslt ) {
                    $scope.refreshGrid( );
                }
            });
        });
    };

    $scope.openAlternativesProductEditor = function( ) {
        var d = $dialog.editor( 'confirmation/alternatives/editors/views/alternatives-product-edit.html', 'AlternativesProductEditCtrl', {args: function() { return {id: 0}; } } );
        d.open( );
    };

    $scope.refreshGrid = function( ) {
        $scope.$broadcast( 'event:alternatives-asset-list-action', {action: 'refresh-grid'} );
    };

    $scope.deleteAssets = function( ) {
        doAction('/portfolio/assets/action/delete', 'Deleting', 'It is Orion\'s best practice to not delete assets. If you proceed with this deletion, you will be responsible for providing this data should you need it to be recorded in Orion in the future or for auditing purposes. Are you sure you want to proceed?');
    };

    $scope.canShowRefreshArchAction = function() {
        return alternativesArchRefreshService.canShowRefreshArchAction(
            $scope.archIntegrationEnabled,
            $scope.rightsAst.canUpdate
        );
    };

    $scope.canRefreshFromArch = function() {
        if (!$scope.canShowRefreshArchAction() || $scope.archRefreshInProgress || !$scope.selectedItems.length) {
            return false;
        }

        return alternativesArchRefreshService.canEnableRefreshAction($scope.selectedItems);
    };

    function finishArchRefreshRequest(onComplete, options) {
        $scope.archRefreshInProgress = false;
        $scope.archRefreshDateDialog.visible = false;
        $scope.archRefreshDateDialog.confirmationMessage = null;
        $scope.archRefreshPendingAssetIds = [];
        $scope.archRefreshClientSkippedCount = 0;
        if (options && options.reloadGrid) {
            $scope.refreshGrid();
        }
        if (!$scope.$$phase) {
            $scope.$applyAsync();
        }
        if (onComplete) {
            onComplete();
        }
    }

    function runArchRefreshForAssetIds(assetIds, ineligibleCount, fromDate, toDate) {
        $scope.archRefreshInProgress = true;

        alternativesArchRefreshService.isArchFirmIntegrationEstablished().subscribe(function(established) {
            if (!established) {
                finishArchRefreshRequest(function() {
                    showArchRefreshToast('warn', alternativesArchRefreshService.buildArchNotConfiguredMessage());
                });
                return;
            }

            alternativesArchRefreshService.refreshFromArch(assetIds, fromDate, toDate).subscribe({
                next: function(response) {
                    var initiatedCount = response.initiatedCount != null ? response.initiatedCount : assetIds.length;
                    var apiSkippedCount = response.skippedCount != null ? response.skippedCount : 0;
                    var failedCount = response.failedCount != null ? response.failedCount : 0;
                    var toast = alternativesArchRefreshService.buildSuccessSummary(
                        initiatedCount,
                        ineligibleCount,
                        apiSkippedCount,
                        failedCount
                    );
                    finishArchRefreshRequest(function() {
                        showArchRefreshToast(toast.severity, toast.detail);
                    }, { reloadGrid: true });
                },
                error: function(error) {
                    finishArchRefreshRequest(function() {
                        showArchRefreshToast('error', alternativesArchRefreshService.buildHttpErrorMessage(error));
                    });
                }
            });
        });
    }

    $scope.onArchRefreshDateRangeRequest = function(range) {
        var assetIds = ($scope.archRefreshPendingAssetIds || []).slice();
        var ineligibleCount = $scope.archRefreshClientSkippedCount || 0;

        if (!assetIds.length || !range) {
            return;
        }

        runArchRefreshForAssetIds(assetIds, ineligibleCount, range.fromDate, range.toDate);
    };

    $scope.onArchRefreshDateDialogCancel = function() {
        $scope.archRefreshPendingAssetIds = [];
        $scope.archRefreshClientSkippedCount = 0;
        $scope.archRefreshDateDialog.confirmationMessage = null;
        $scope.archRefreshDateDialog.visible = false;
    };

    $scope.refreshFromArch = function() {
        if ($scope.archRefreshInProgress) {
            return;
        }

        var selection = $scope.selectedItems || [];
        if (!selection.length) {
            showArchRefreshAlert('Select at least one asset to refresh from Arch.');
            return;
        }

        var partition = alternativesArchRefreshService.partitionByArchHoldingId(selection);
        var eligible = partition.eligible;
        var ineligible = partition.ineligible;

        if (!eligible.length) {
            showArchRefreshAlert(alternativesArchRefreshService.buildIneligibleSelectionMessage());
            return;
        }

        var confirmMsg = ineligible.length
            ? alternativesArchRefreshService.buildMixedConfirmMessage(eligible.length, selection.length)
            : alternativesArchRefreshService.buildStandardConfirmMessage(eligible.length);

        var assetIds = eligible
            .map(function(row) { return alternativesArchRefreshService.resolveAssetId(row); })
            .filter(function(id) { return id > 0; });

        if (!assetIds.length) {
            return;
        }

        $scope.archRefreshPendingAssetIds = assetIds;
        $scope.archRefreshClientSkippedCount = ineligible.length;
        $scope.archRefreshDateDialog.confirmationMessage = confirmMsg;
        $scope.archRefreshDateDialog.visible = false;
        setTimeout(function() {
            $scope.archRefreshDateDialog.visible = true;
            if (!$scope.$$phase) {
                $scope.$applyAsync();
            }
        }, 0);
    };

    $scope.onArchRefreshDateDialogVisibleChange = function(visible) {
        $scope.archRefreshDateDialog.visible = visible;
    };

    $scope.runReport = function( ) {
        if($scope.selected) $portfolio.runReport( entities.account.value, $scope.selected.accountId );
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast('event:alternatives-asset-list-action', {action: 'export-data'});
    };

    $scope.goTo = AccountComposer.goTo;

    $scope.goTo.portfolioAudit = function( asset ) {

        $portfolio.goTo( 'assets', entities.asset.value, asset.id);
    };

    $scope.importAssets = function () {
        civ2Service.getImportType("AIP Asset").then(function (res) {
            $window.open(`#/customImports2/templates?createImport=${res.data.id}`, '_blank');
        });
    };

    $scope.goTo.orionVision = function(){
        orionVisionSSO.goTo();
    }

    //EVENT LISTENERS
    $scope.$on('event:alternatives-asset-list-select', function(e, args) {
        $scope.selectedItems = args && args.length ? args : [];
    });


    // INITIALIZE
    $scope.views = views;
    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: { get: function() {return $scope.selectedItems.map('id')} },
        selected: { get: function() { return $scope.selectedItems[0] } }
    });

    $scope.current = {
        view: views[0],
        asOfDate: Date.create('today'),
        gridDoubleClick: slickGridDoubleClick,
        accountIdLoaded: $routeParams.accountId ? $routeParams.accountId : null,
        productIdLoaded: $routeParams.productId ? $routeParams.productId : null,
        assetIdLoaded: $routeParams.assetId ? $routeParams.assetId : null,
        includeCostBasis: false,
        gridUrl: '/Portfolio/Assets/Alternative'
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length ) {
                $scope.openAlternativesAssetEditor( $scope.selected );
            }
        }
    }];


    init( );    
});




'use strict';

app.controller('AlternativesAssetHistoryListCtrl', function AlternativesAssetHistoryListCtrl( $scope, $http, $oasRights, $routeParams, views, $location, $dialog, $portfolio, entities, splitIoService, alternativesAssetEditorSidebarCoordinator ) {

    // PRIVATE METHODS
    function init( ) {
        $scope.newAlternativesAssetEditor = false;
        splitIoService.getBoolTreatment('opex_AccountComposer_NewActivityTypes_34892').subscribe(function(isEnabled) {
            $scope.newAlternativesAssetEditor = isEnabled;
        });

        $scope.rightsHH = $oasRights.forCode( "CLIENTS" );
        $scope.rightsReg = $oasRights.forCode( "REGISTRATIONS" );
        $scope.rightsAcc = $oasRights.forCode( "ACCOUNTS" );
        $scope.rightsAst = $oasRights.forCode( "ASSETS" );
    }

    function slickGridDoubleClick( ) {
        $scope.openAlternativesAssetEditor( false, null );
    }


    // PUBLIC METHODS
    $scope.goToAsset = function( ) {
        $location.url( '/confirmation/alternatives/assets?assetId=' + $scope.current.selectedAssetId );
    };

    $scope.goToAccount = function( ) {
        $location.url( '/confirmation/alternatives/accounts?accountId=' + $scope.current.selectedAccountId );
    };

    $scope.goToHigher = function( urlLevel ) {
        if( urlLevel === 'households' && $scope.current.selectedHouseholdId > 0 ) {
            $portfolio.goTo( urlLevel, entities.client.value, $scope.current.selectedHouseholdId );
        } else if( urlLevel === 'registrations' && $scope.current.selectedRegistrationId > 0 ) {
            $portfolio.goTo( urlLevel, entities.registration.value, $scope.current.selectedRegistrationId );
        }
    };

    $scope.openAlternativesAssetEditor = function( isNew, defaultToShow ) {
        splitIoService.getBoolTreatment('opex_AccountComposer_NewActivityTypes_34892').subscribe(function(isEnabled) {
            if (isEnabled) {
                return alternativesAssetEditorSidebarCoordinator.open({
                    id: $scope.current.selectedAssetId,
                    accountId: $scope.current.selectedAccountId,
                    productId: $scope.current.selectedProductId,
                    defaultToShow: defaultToShow
                }).then(function(rslt) {
                    if (rslt) {
                        $scope.refreshGrid();
                    }
                });
            }

            return $dialog.editor( 'confirmation/alternatives/editors/views/alternatives-asset-edit.html', 'AlternativesAssetEditCtrl', {args: function() { return {
                    id : $scope.current.selectedAssetId,
                    accountId: $scope.current.selectedAccountId,
                    productId: $scope.current.selectedProductId,
                    defaultToShow: defaultToShow
                }}} ).open( ).then(function( rslt ) {
                if( rslt ) {
                    $scope.refreshGrid( );
                }
            });
        });
    };

    $scope.refreshGrid = function( ) {
        $scope.$broadcast( 'event:alternatives-asset-history-list-action', {action: 'refresh-grid'} );
    };


    //EVENT LISTENERS
    $scope.$on("event:alternatives-asset-history-list-select", function(e, args) {
        if( args.length === 0 ) return;
        $scope.current.selectedHouseholdId = args[0].clientId;
        $scope.current.selectedRegistrationId = args[0].registrationId;
        $scope.current.selectedAccountId = args[0].accountId;
        $scope.current.selectedProductId = args[0].productId;
    });


    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];


    $scope.current = {
        view: views[0],
        gridUrl: '/Confirm/Alternative/InvestmentPlatform/AssetHistory/' + $routeParams.assetId,
        selectedHouseholdId: 0,
        selectedRegistrationId: 0,
        selectedAccountId: 0,
        selectedProductId: 0,
        selectedAssetId: $routeParams.assetId,
        gridDoubleClick: slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length ) {
                $scope.openAlternativesAssetEditor( false, null );
            }
        }
    }];


    init( );

});

'use strict';

app.controller('AlternativesProductListCtrl', function AlternativesProductListCtrl( $scope, $http, views, $oasRights, $dialog, $routeParams, $portfolio, $location, apps, entities, AccountComposer, orionVisionSSO ) {

    // PRIVATE VARIABLES
    var redirectUrl = window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html?";

    // PRIVATE METHODS
    function init( ) {
        $scope.rightsAst = $oasRights.forCode( "ASSETS" );
        $scope.rightsProduct = $oasRights.forCode( "PRODUCTS" );
        $scope.rightsTransaction = $oasRights.forCode( "TRANSACTIONS" );
        $scope.rightsPortfolioAudit = $oasRights.forCode("PORTFOLIOLISTSAPP");
        $scope.rightsOrionVision = $oasRights.forCode( "ORIONVISION" );
    }

    function slickGridDoubleClick( ) {
        $scope.openProductEditor( false );
    }


    // PUBLIC METHODS
    $scope.openAlternativesProductEditor = function( isNew ) {
        var d = $dialog.editor( 'confirmation/alternatives/editors/views/alternatives-product-edit.html', 'AlternativesProductEditCtrl', {args: function() { return {id : isNew ? 0 : $scope.selectedIds[0]}; } } );
        d.open( ).then(function( result ) {
            if( result ) {
                $scope.refreshGrid( );
            }
        });
    };

    $scope.updateAlternative = function( field, value){
        if( $scope.selectedIds.length > 0){
            const url = '/Portfolio/Products/List/Id/OrionVision?option='+ field + '&newValue=' + value;
            $http.put( url, $scope.selectedIds, {trackerMsg: 'Updating Orion Vision Value'} )
                .then( function ( ) {
                    $scope.refreshGrid( );
                });
        }
    };

    $scope.openProductEditor = function( ) {
        if( $scope.selectedIds.length > 1){
            $portfolio.openMassEditor( entities.product.value, $scope.selectedIds, apps.productsAndPrices.name, {isGlobalProductUpdate: false} )
            .then(function(result) {
                if( result ) {
                    $scope.refreshGrid( );
                }
            });
        } else{
            var d = $dialog.editor("products/editors/product-edit.html", "ProductEditCtrl", {args: function () {
                return {
                    id: $scope.selectedIds[0],
                    app: apps.productsAndPrices,
                    defaultTab: {name: "Local", active: true, code: "productGeneral"},
                    extraInfo: null,
                    isNewGlobal: false,
                    isNewLocal: false,
                    isAdvisorProduct: false,
                    isReturnGlobal: false
                };
            }});

        d.open().then(function( result ) {
            if( result ) {
                $scope.refreshGrid( );
            }
        });
        }
        
    };

    $scope.openAlternativesGlobalValuationEditor = function( ) {
        $dialog.dialog({templateUrl: "confirmation/alternatives/editors/views/alternatives-global-valuation-edit.html", controller: 'AlternativeGlobalValuationEditCtrl', id: 0, productId: $scope.selectedIds[0] })
            .open()
            .then(function( result ) {
                if( result ) {
                    if( result.preview ) {
                        AccountComposer.globalValuationForPreview = result;
                        $location.url( '/confirmation/alternatives/globalvaluation/preview' );
                    }
                }
            });
    };

    $scope.openAlternativesGlobalTransactionEditor = function( ) {
        $dialog.dialog({templateUrl: "confirmation/alternatives/editors/views/alternatives-global-transaction-edit.html", controller: 'AlternativeGlobalTransactionEditCtrl', id: 0, productId: $scope.selectedIds[0] })
            .open()
            .then(function( result ) {
                if( result ) {
                    if( result.preview ) {
                        AccountComposer.globalTransactionForPreview = result;
                        $location.url( '/confirmation/alternatives/globaltransaction/preview' );
                    }
                }
            });
    };

    $scope.refreshGrid = function( ) {
        $scope.$broadcast( 'event:alternatives-product-list-action', {action: 'refresh-grid'} );
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast('event:alternatives-product-list-action', {action: 'export-data'});
    };

    $scope.goToAssets = function() {
        if ($scope.hasAltAssets())
            $location.url('/confirmation/alternatives/assets?productId=' + $scope.selectedIds[0]);
    };

    $scope.goToPortfolioAuditUrl = function () {
        var path = $portfolio.getGoToRoute('assets', entities.product.value, $scope.selectedIds[0], false);
        return redirectUrl + $.param({ p: path, t: sessionStorage.oas_token });
    };

    $scope.goToOrionVision = function(){
        orionVisionSSO.goTo();
    }

    $scope.hasAltAssets = function () {
        return $scope.selectedItems.length > 0 && $scope.selectedItems[0].hasAlternativeAssets;
    };

    //EVENT LISTENERS
    $scope.$on('event:alternatives-product-list-select', function(e, args) {
        if (args.length) {
            $scope.selectedItems = args;
            $scope.current.isOrionVision = $scope.selectedItems[0].isOrionVision;
            $scope.current.isOrionVisionPending = $scope.selectedItems[0].isOrionVisionPending;
        } 
    });


    // INITIALIZE
    $scope.views = views;
    $scope.selectedItems = [];
    $scope.selectedIds = [];

    $scope.current = {
        view: views[0],
        gridDoubleClick: slickGridDoubleClick,
        gridUrl: '/Portfolio/Products' + ( $routeParams.productId ? '/' + $routeParams.productId : '' ),
        isOrionVision: false,
        isOrionVisionPending: false
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            $scope.openProductEditor( false );
        }
    }];

    init( );

});

'use strict';

app.controller('AlternativesGlobalValuationListCtrl', function AlternativesGlobalValuationListCtrl( $scope, $http, $oasRights, $dialog, views, AccountComposer, $location ) {


    // PRIVATE METHODS
    function init( ) {
        $scope.rightsAst = $oasRights.forCode( "ASSETS" );
    }

    function slickGridDoubleClick( ) {
        $scope.openAlternativesGlobalValuationEditor( false );
    }


    // PUBLIC METHODS
    $scope.openAlternativesGlobalValuationEditor = function( isNew ) {
        $dialog.dialog({templateUrl: "confirmation/alternatives/editors/views/alternatives-global-valuation-edit.html", controller: 'AlternativeGlobalValuationEditCtrl', id: isNew ? 0 : $scope.selectedIds[0] })
            .open()
            .then( function( result ) {
                if( result ) {
                    if( result.preview ) {
                        AccountComposer.globalValuationForPreview = result;
                        $location.url( '/confirmation/alternatives/globalvaluation/preview' );
                    } else {
                        $scope.$broadcast( 'event:alternatives-global-valuation-list-action', {action: isNew ? 'add-item' : 'update-item', item: result } );
                    }
                }
            });
    };

    $scope.deleteGlobalValuation = function( ) {
        $dialog.confirmAction( "Are you sure you want to remove this global valuation?" )
            .open( )
            .then( function( result ) {
                if( result === "yes" ) {
                    $http.delete( '/Confirm/Alternative/ProductValuation/' + $scope.selectedIds[0], {trackerMsg: 'Deleting global valuation'} )
                        .then( function ( ) {
                            $scope.$broadcast( 'event:alternatives-global-valuation-list-action', {action: 'refresh-grid'} );
                        });
                }
            });
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast('event:alternatives-global-valuation-list-action', {action: 'export-data'});
    };


    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];


    $scope.current = {
        view: views[0],
        gridDoubleClick: slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length ) {
                $scope.openAlternativesGlobalValuationEditor( false );
            }
        }
    }];

    init( );

});

'use strict';

app.controller('AlternativesValuationListCtrl', function AlternativesValuationListCtrl($scope, $http, $oasRights, $dialog, $location, views, civ2Service, $routeParams, $window, splitIoService, alternativesAssetEditorSidebarCoordinator) {


    // PRIVATE METHODS
    function init( ) {
        $scope.newAlternativesAssetEditor = false;
        splitIoService.getBoolTreatment('opex_AccountComposer_NewActivityTypes_34892').subscribe(function(isEnabled) {
            $scope.newAlternativesAssetEditor = isEnabled;
        });

        $scope.rightsAst = $oasRights.forCode( "ASSETS" );
        $scope.rightsAcc = $oasRights.forCode( "ACCOUNTS" );
        $scope.rightsProduct = $oasRights.forCode( "PRODUCTS" );
        $scope.rightsOrionVision = $oasRights.forCode("ORIONVISION");
    }

    function slickGridDoubleClick( ) {
        $scope.openAlternativesValuationEditor( );
    }


    // PUBLIC METHODS
    $scope.openAlternativesValuationEditor = function( ) {
        splitIoService.getBoolTreatment('opex_AccountComposer_NewActivityTypes_34892').subscribe(function(isEnabled) {
            if (isEnabled) {
                return alternativesAssetEditorSidebarCoordinator.open({
                    id: $scope.selected[0].assetId,
                    accountId: $scope.selected[0].accountId,
                    productId: $scope.selected[0].productId,
                    defaultToShow: 'valuations'
                }).then(function(rslt) {
                    if (rslt) {
                        $scope.refreshGrid();
                    }
                });
            }

            var d = $dialog.editor('confirmation/alternatives/editors/views/alternatives-asset-edit.html', 'AlternativesAssetEditCtrl', { args: function () { return { id: $scope.selected[0].assetId, defaultToShow: "valuations"};} } );
            d.open( ).then(function( rslt ) {
                if( rslt ) {
                    $scope.refreshGrid( );
                }
            });
        });
    };

    $scope.completeValuations = function () {
        if ($scope.selected.length > 0) {
            var updateItems = [];
            angular.forEach($scope.selected, function (item) {
                if (item.valuationStatus != 'Complete') {
                    item.valuationStatus = 'Complete';
                    updateItems.push(item);
                }
            });
            if (updateItems.length > 0) {
                $http.put("/Confirm/Alternative/AssetValuation", updateItems, { trackerMsg: 'Completing valuations' })
                    .then(function () {
                        $scope.refreshGrid();
                    });
            }
        }
    };

    $scope.refreshGrid = function () {
        $scope.$broadcast( 'event:alternatives-valuation-list-action', {action: 'refresh-grid'} );
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast('event:alternatives-valuation-list-action', {action: 'export-data'});
    };

    $scope.goToAccount = function( ) {
        $location.url('/confirmation/alternatives/accounts?accountId=' + $scope.selected[0].accountId );
    };

    $scope.goToAsset = function( ) {
        $location.url('/confirmation/alternatives/assets?assetId=' + $scope.selected[0].assetId );
    };

    $scope.goToProduct = function( ) {
        $location.url('/confirmation/alternatives/products?productId=' + $scope.selected[0].productId );
    };

    $scope.goToAssetHistory = function( ) {
        $location.url('/confirmation/alternatives/assethistory?assetId=' + $scope.selected[0].assetId );
    };

    $scope.importValuations = function( ) {
        civ2Service.getImportType("AIP Valuations").then(function (res) {
            $window.open(`#/customImports2/templates?createImport=${res.data.id}`, '_blank');
        });
    };

    // EVENT LISTENERS
    $scope.$on("event:alternatives-valuation-list-select", function(e, args) {
        if (args.length === 0) return;

        $scope.selected = args;
    });


    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];


    $scope.current = {
        view: views[0],
        startDate: Date.create('six month ago'),
        endDate: Date.create('today'),
        gridDoubleClick: slickGridDoubleClick,
        orionVisionPending: $routeParams.orionVisionPending ? JSON.parse($routeParams.orionVisionPending) : false
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length === 1 ) {
                $scope.openAlternativesValuationEditor( );
            }
        }
    }];

    init( );

});

'use strict';

app.controller('AlternativesGlobalValuationPreviewListCtrl', function AlternativesGlobalValuationPreviewListCtrl( $scope, $http, $oasRights, $location, AccountComposer, views ) {


    // PRIVATE METHODS
    function init( ) {
        $scope.rightsAst = $oasRights.forCode( "ASSETS" );
    }

    function goToGlobalValuations( ) {
        $location.url( '/confirmation/alternatives/globalvaluations' );
    }


    // PUBLIC METHODS
    $scope.exportToExcel = function( ) {
        $scope.$broadcast( 'event:alternatives-global-valuation-preview-list-action', {action: 'export-data'} );
    };

    $scope.commitValuations = function( ) {
        var args = $scope.globalValuationForPreview.id > 0 ? {method: "PUT", id: $scope.globalValuationForPreview.id, trackerMsg: "Saving global valuation"} : {method: "POST", id: "", trackerMsg: "Adding new global valuation"};
        $http( {method: args.method, url: '/Confirm/Alternative/ProductValuation/' + args.id, data: $scope.globalValuationForPreview, trackerMsg: args.trackerMsg} )
            .then( function( ) {
                goToGlobalValuations( );
            });
    };


    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];

    if( AccountComposer.globalValuationForPreview === undefined || AccountComposer.globalValuationForPreview === null ) {
        goToGlobalValuations( );
    } else {
        $scope.globalValuationForPreview = AccountComposer.globalValuationForPreview;
        $scope.globalValuationForPreview.valuationDate = Date.create( $scope.globalValuationForPreview.valuationDate );
    }

    $scope.current = {
        gridUrl: ( AccountComposer.globalValuationForPreview === undefined || AccountComposer.globalValuationForPreview === null ) ? null : '/Confirm/Alternative/ProductValuation/ValuationPreview',
        view: views[0]
    };

    init( );


});
'use strict';

app.controller('AlternativesGlobalTransactionListCtrl', function AlternativesGlobalTransactionListCtrl( $scope, $http, $oasRights, $dialog, views, $location, AccountComposer ) {


    // PRIVATE METHODS
    function init( ) {
        $scope.rightsTransaction = $oasRights.forCode( "TRANSACTIONS" );
    }

    function slickGridDoubleClick( ) {
        $scope.openAlternativesGlobalTransactionEditor( false );
    }

    // PUBLIC METHODS
    $scope.openAlternativesGlobalTransactionEditor = function( isNew ) {
        $dialog.dialog({templateUrl: "confirmation/alternatives/editors/views/alternatives-global-transaction-edit.html", controller: 'AlternativeGlobalTransactionEditCtrl', id: isNew ? 0 : $scope.selectedIds[0]})
            .open()
            .then(function( result ) {
                if( result ) {
                    if( result.preview ) {
                        AccountComposer.globalTransactionForPreview = result;
                        $location.url( '/confirmation/alternatives/globaltransaction/preview' );
                    } else {
                        $scope.$broadcast( 'event:alternatives-global-transaction-list-action', {action: isNew ? 'add-item' : 'update-item', item: result } );
                    }
                }
            });
    };

    $scope.deleteGlobalTransaction = function( ) {
        $dialog.confirmAction("Are you sure you want to remove this global transaction?")
            .open()
            .then(function (result) {
                if( result === "yes" ) {
                    $http.delete( '/Confirm/Alternative/ProductTransaction/' + $scope.selectedIds[0], {trackerMsg: 'Deleting global transaction'} )
                        .then( function () {
                            $scope.$broadcast( 'event:alternatives-global-transaction-list-action', {action: 'refresh-grid'} );
                        });
                }
            });
    };

    $scope.exportToExcel = function( ) {
        $scope.$broadcast( 'event:alternatives-global-transaction-list-action', {action: 'export-data'} );
    };


    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];


    $scope.current = {
        view: views[0],
        gridDoubleClick: slickGridDoubleClick
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length ) {
                $scope.openAlternativesGlobalTransactionEditor( false );
            }
        }
    }];

    init( );

});

'use strict';

app.controller('AlternativesGlobalTransactionPreviewListCtrl', function AlternativesGlobalTransactionPreviewListCtrl( $scope, $http, $oasRights, $location, AccountComposer, views ) {


    // PRIVATE METHODS
    function init( ) {
        $scope.rightsTransaction = $oasRights.forCode( "TRANSACTIONS" );
    }

    function goToGlobalTransactions( ) {
        $location.url( '/confirmation/alternatives/globaltransactions' );
    }


    // PUBLIC METHODS
    $scope.exportToExcel = function( ) {
        $scope.$broadcast( 'event:alternatives-global-transaction-preview-list-action', {action: 'export-data'} );
    };

    $scope.commitTransactions = function( ) {
        $scope.globalTransactionForPreview["preview"] = false;
        var args = $scope.globalTransactionForPreview.id > 0 ? {method: "PUT", id: $scope.globalTransactionForPreview.id, trackerMsg: "Saving global transaction"} : {method: "POST", id: "", trackerMsg: "Adding new global transaction"};
        $http( {method: args.method, url: '/Confirm/Alternative/ProductTransaction/' + args.id, data: $scope.globalTransactionForPreview, trackerMsg: args.trackerMsg} )
            .then( function( ) {
                goToGlobalTransactions( );
            });
    };


    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];

    if( AccountComposer.globalTransactionForPreview === undefined || AccountComposer.globalTransactionForPreview === null ) {
        goToGlobalTransactions( );
    } else {
        $scope.globalTransactionForPreview = AccountComposer.globalTransactionForPreview;
        $scope.globalTransactionForPreview.transactionDate = Date.create( $scope.globalTransactionForPreview.transactionDate );
    }

    $scope.current = {
        gridUrl: ( AccountComposer.globalTransactionForPreview === undefined || AccountComposer.globalTransactionForPreview === null ) ? null : '/Confirm/Alternative/ProductTransaction/TransactionPreview',
        view: views[0]
    };

    init( );


});
'use strict';

var alternativesAuditListCtrl = app.controller('AlternativesAuditListCtrl', function ReconciliationAlertsCtrl($scope, $timeout, $http, $location, $oasRights, $routeParams, $dataQuery, $settings, $window, $portfolio, entities, apps, config) {
    // PUBLIC METHODS
    $scope.refreshGrid = function () {
        runDataQuery();
    };
    
    $scope.download = function (dataType) {
        $dataQuery.createFile(dataType, downloadFile);
    };
    
    // PRIVATE METHODS
    function init() {
        runDataQuery();
    }

    function runDataQuery(){
        $scope.current.isLoading = true;
        populateParams();
        $http.post('/Reporting/Custom/' + $scope.current.dataQuery.id + '/Generate/SlickGrid', $scope.current.dataQuery, {
            trackerMsg: 'Running Data Query'
        })
            .then(function (response) {
                $dataQuery.setDataQuery($scope.current.dataQuery);
                $scope.current.view = response.data;
                $scope.current.isLoading = false;
                $timeout(function(){
                    $scope.current.url = '/Reporting/Custom/' + $scope.current.dataQuery.id + '/Generate/SlickGrid/' + $scope.current.view.dataQueryCacheKey;
                    $timeout(function(){
                        $scope.$broadcast('event:alternative-audit-action', {action: 'refresh-grid'});
                    });
                });
            });
    }

    function downloadFile(url) {
        $window.location.href = url + "?Authorization=" + sessionStorage.oas_token;
    }

    function populateParams() {
        $scope.current.dataQuery.prompts.each(function(item){
            if(item.isPromptUser) {
                switch(item.code.toLowerCase()) {
                    case "@startdate":
                        item.defaultValue = Date.create($scope.current.startDate).formatted();
                        break;
                    case "@enddate":
                        item.defaultValue = Date.create($scope.current.endDate-1).formatted();
                        break;
                    case "@manager":
                        item.defaultValue = $scope.current.manager;
                        break;
                }
            }
        });
    }
   
    // INITIALIZE
    $scope.rights = $oasRights.forCode("ACCOUNTCOMPOSER");
    $scope.views = null;
    $scope.selectedIds = [];
    $scope.current = {
        dataQuery: config,
        isLoading: true,
        startDate: Date.create('a month ago'), 
        endDate: Date.create('today'),
        manager: 0,
        url: null,
        mode: $routeParams.audit
    };

    init();

});

alternativesAuditListCtrl.loadDataQuery = ["$http", "$route", "$dataQuery", function ($http, $route, $dataQuery) {
    var dataQueryId = $route.current.params.id;

    var existingConfig = $dataQuery.getDataQuery(dataQueryId);
    if (existingConfig && existingConfig.id == dataQueryId) {
        return existingConfig;
    } else {
        return $http.get('/Reporting/Custom/' + dataQueryId, {
            trackerMsg: "Loading data query config"
        }).then(function (response) {
            if (response) {
                $dataQuery.setDataQuery(response.data);
                return $dataQuery.getDataQuery(response.data.id);
            }
        });
    }
}];
'use strict';

app.controller('AlternativesAccountEditCtrl', function AlternativesAccountEditCtrl( $scope, dialog, $http, $oasRights, $portfolio, entities, $cacheFactory, apps, API_CONFIG ) {

    // PRIVATE METHODS
    function init( ) {
        $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");

        $http.get( '/Portfolio/Accounts/Verbose/New', {trackerMsg: 'Loading new account'} )
            .then( function (r) {
                $scope.account = r.data;
                loadDefaults( )
            });

        $http.get( '/Portfolio/Registrations/Verbose/New', {trackerMsg: 'Loading new registration'} )
            .then( function (r) {
                $scope.registration = r.data;
            });
    }

    function loadDefaults( ) {
        $scope.account.portfolio.fundFamilyId = 769;
        $scope.account.portfolio.isPositionOnlyRecon = false;

        $http.get( '/Portfolio/Platforms/', {trackerMsg: 'Loading default management style'} )
            .then( function (r) {
                if( r.data ) {
                    var platform = r.data.find( {isDefault: true} );
                    if( platform ) {
                        $scope.account.portfolio.managementStyleId = platform.id;
                    }
                }
            });

        $http.get( '/Portfolio/AccountStatuses?displayAll=true', {trackerMsg: 'Loading account statuses'} )
            .then( function (r) {
                var acs = r.data.find( {name: "Manually Managed"} );
                if( acs ) {
                    $scope.account.portfolio.accountStatusId = acs.id;
                }
            });

        $http.get( '/Portfolio/ShareClasses/Simple', {trackerMsg: 'Loading default share class'} )
            .then( function (r) {
                if( r.data ) {
                    var sc = r.data.find( {name: "0"} );
                    if( sc ) {
                        $scope.account.portfolio.shareClassId = sc.id;
                    }
                }
            });
    }

    function saveAccount( ) {
        $http.post( "/Portfolio/Accounts/Verbose/", $scope.account, {trackerMsg: 'Adding account'} )
            .then(function ( r ) {
                $http.get('/Portfolio/Accounts/' + r.data.id, {trackerMsg: 'Refreshing account'})
                    .then( function( account ) {
                        dialog.close( account.data );
                    });
            });
    }


    // PUBLIC METHODS
    $scope.openHouseholdEditor = function( ) {
        $portfolio.openEditor(entities.client.value, [], null, null, apps.portfolioLists.name, null).then(function (result) {
            if( result ) {
                var cache = $cacheFactory.get('$http');
                cache.remove(API_CONFIG.baseUrl + '/Portfolio/Clients/Simple/Search');

                $scope.current.selectedHousehold = { id: result.id, name: result.name };
                $scope.current.selectedRegistration = null;
            }
        });
    };

    $scope.save = function( ) {
        if( $scope.current.selectedHousehold === null ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Select a household.'} );
        }

        if( $scope.errors.length === 0 ) {
            if( $scope.current.selectedRegistration ) {
                $scope.account.portfolio.registrationId = $scope.current.selectedRegistration.id;
                saveAccount( );
            } else {
                $scope.registration.portfolio.clientId = $scope.current.selectedHousehold.id;
                $http.post( "/Portfolio/Registrations/Verbose/", $scope.registration, {trackerMsg: 'Adding registration'} )
                    .then(function (r) {
                        $scope.current.selectedRegistration = { id: r.data.id, name: r.data.name };
                        $scope.account.portfolio.registrationId = r.data.id;
                        saveAccount( );
                    });
            }
        }
    };

    $scope.cancel = function( ) {
        dialog.close( null );
    };


    //SCOPE WATCHERS
    $scope.$watch('current.selectedRegistration', function (newValue, oldValue) {
        if (!newValue || newValue == oldValue) return;

        if( $scope.current.selectedRegistration && $scope.current.selectedRegistration.id > 0 ) {
            $http.get('/Portfolio/Registrations/' + $scope.current.selectedRegistration.id, {trackerMsg: 'Getting registration'})
                .then( function( r ) {
                    if( r.data && r.data.id > 0 && r.data.clientId > 0 ) {

                        $http.get('/Portfolio/Clients/' + r.data.clientId, {trackerMsg: 'Getting household'})
                            .then( function( c ) {
                                if( c.data && c.data.id > 0 ) {
                                    $scope.current.selectedHousehold = { id: c.data.id, name: c.data.name };
                                }
                            });
                    }
                });
        }

    });

    //INITIALIZE
    $scope.errors = [];

    $scope.current = {
        selectedHousehold: null,
        selectedRegistration: null
    };

    init( );

});

'use strict';

app.controller('AlternativesAssetLedgerCopyCtrl',
    function AlternativesAssetLedgerCopyCtrl($scope, AccountComposer,args, dialog, $dialog) {

        var assetExpand = 'portfolio';

        if ($scope.current === undefined || $scope.current === null) {
            $scope.current = {};
        }


        var link = function () {

            var assetId = $("input[name='asset']:checked").val();
            if (assetId === undefined || assetId === null || assetId === 0) {
                alert("Please select valid asset.");
            } else {
                var percentage = $("#" + assetId).val();
                if (percentage === null || percentage === undefined || percentage === '' || percentage > 100 || percentage < 0) {
                    $dialog.messageBox('Error', 'Please enter a valid percentage between 0 and 100.')
                        .open();
                } else {
                   var result = AccountComposer.assets.copyHistoricalAsset({ params: { assetIdToCopy: assetId, assetIdToEdit: $scope.current.assetId, percentage: percentage } });
                   dialog.close(result);
                }
            }
            
        }

        var close = function() {
            dialog.close();
        }

        var enableSubmit = function() {
            $('#copyHistoricalDataSubmit').removeAttr('disabled');
        }

        var onKeyDown = function (e) {
            if (e.which === 69) {
                e.preventDefault();
            }
            return true;
        };

        function init() {
            $scope.current.close = close;
            $scope.current.link = link;
            $scope.current.assetId = args.id;
            $scope.current.assetName = args.assetName;
            $scope.current.enableSubmit = enableSubmit;
            $scope.current.onKeyDown = onKeyDown;

            AccountComposer.assets.getVerboseByProduct({ params: { id: $scope.current.assetId, expand: assetExpand } }).then((
                response) => {
                $scope.current.assets = [];
                    if (response.data.length > 0) {
                        response.data.forEach((asset) => {
                            if (asset.id.toString() === $scope.current.assetId) {
                                $scope.current.selectedAsset = asset;
                            } else {
                                $scope.current.assets.push(asset);
                            }
                        });
                    }
                });
        }

        
       

        init();
    });
'use strict';

app.controller('AlternativesAssetEditCtrl', function AlternativesAssetEditCtrl($scope, $timeout, apps, $filter, dialog, $http, $oasRights, args, $dialog, $q, $window, AccountComposer, $portfolio, excludeType, excludePercentOf, assetStatus, civ2Service, splitIoService, oasDates) {

    var editorHotKeys,
        assetOriginal,
        transactionsOriginal = [],
        assetExpand = 'portfolio,billing,commitments,assetValuations,alternativeSchedules,billing,entityOptions',
        transactionExpand = 'portfolio,alternative',
        futureAipTradeStatus = 'Future (AIP)',
        completeTradeStatus = 'Complete',
        pendingTradeStatus = 'Pending';


    // PRIVATE METHODS
    function isFutureTransDate(t) {
        return t.portfolio && t.portfolio.transDate && oasDates.isAfterTodayCentral(t.portfolio.transDate);
    }

    function onTradeStatusChange(t) {
        if (!t.portfolio) {
            return;
        }
        if (t.portfolio.status === futureAipTradeStatus && !isFutureTransDate(t)) {
            t.portfolio.status = 'Complete';
        }
    }

    // Future-dated trade status rules for transaction date
    function applyAipTradeStatusForTransDate(t) {
        if (!t.portfolio || !t.portfolio.transDate) {
            return;
        }
        var transDay = Date.create(t.portfolio.transDate).beginningOfDay();
        if (!transDay.isValid()) {
            return;
        }

        if (isFutureTransDate(t)) {
            t.portfolio.status = futureAipTradeStatus;
            t.tradeStatusDisabled = true;
        } else {
            t.tradeStatusDisabled = false;
            if (t.portfolio.status === futureAipTradeStatus) {
                t.portfolio.status = 'Complete';
            }
        }
    }

    function init() {
        loadSplits();
        loadHotKeys();
        loadEnumLookUps();

        splitIoService.getBoolTreatment('opex_Margin_Billing_18617')
            .subscribe((isEnabled) => {
                $scope.marginBillingEnabled = isEnabled;
            });

        splitIoService.getBoolTreatment('opex_AccountComposer_NewActivityTypes_34892')
            .subscribe((isEnabled) => {
                $scope.newActivityTypesFeatureEnabled = isEnabled;
            });

        splitIoService.getBoolTreatment('opex_AccountComposer_AIPPendingReview_34901')
            .subscribe((isEnabled) => {
                $scope.pendingReviewLedgerStatusEnabled = isEnabled;
                loadLedgerTradeStatuses();
                applyDefaultTradeStatusToCommitments();
                
                syncCommitmentTradeStatusBaseline();
            });

        $q.all([
            loadTransactionTypes(),
            loadFundingTypes(),
            loadActivityTypes(),
            loadTradeStatuses(),
            loadValuationStatuses()
        ]).then(function(){
            loadAssetVerbose().then(function(){
                if($scope.current.asset.id > 0) {
                    loadTransactions();
                    loadEntityOptions();
                    loadPartialAssetExclusion();
                }
            });
        });
    }

    function loadSplits() {
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: function() { $scope.close(true); } }
            ]);
        });
    }

    function loadTransactionTypes() {
        return AccountComposer.types.transaction({params: {detail: true}}).then(function (response) {
            var types = response.data.sortBy('description');
            angular.copy(types, $scope.current.transactionTypes);
            angular.copy(types.findAll({isCommon:true}), $scope.current.commonTransactionTypes);
            angular.copy(types.findAll({isCommon:false}), $scope.current.uncommonTransactionTypes);
        });
    }

    function loadTradeStatuses() {
        return AccountComposer.types.tradeStatus().then(function (response) {
            angular.copy(response.data, $scope.current.tradeStatuses);
            loadLedgerTradeStatuses();
        });
    }

    function normalizeLedgerTradeStatus(tradeStatus) {
        if (tradeStatus === null || tradeStatus === undefined || tradeStatus === '') {
            return null;
        }

        if (typeof tradeStatus === 'string') {
            var parsedTradeStatusId = parseInt(tradeStatus);
            if (!isNaN(parsedTradeStatusId) && String(parsedTradeStatusId) === tradeStatus) {
                var numericStringMatch = $scope.current.tradeStatuses.find({ id: parsedTradeStatusId });
                return numericStringMatch ? numericStringMatch.name : null;
            }
            return tradeStatus;
        }

        var tradeStatusId = parseInt(tradeStatus);
        if (isNaN(tradeStatusId)) {
            return null;
        }

        var match = $scope.current.tradeStatuses.find({ id: tradeStatusId });
        return match ? match.name : null;
    }

    function loadLedgerTradeStatuses() {
        $scope.current.ledgerTradeStatuses = $scope.current.tradeStatuses.filter(function (status) {
            return status.name === completeTradeStatus || status.name === pendingTradeStatus;
        });
    }

    function applyDefaultTradeStatusToCommitments() {
        if (!$scope.pendingReviewLedgerStatusEnabled || !$scope.current.asset || !$scope.current.asset.commitments) {
            return;
        }

        $scope.current.asset.commitments.each(function(commitment) {
            var normalizedTradeStatus = normalizeLedgerTradeStatus(commitment.tradeStatus);
            commitment.tradeStatus = normalizedTradeStatus || completeTradeStatus;
        });
    }

    function syncCommitmentTradeStatusBaseline() {
        if (!$scope.pendingReviewLedgerStatusEnabled || !assetOriginal || !assetOriginal.commitments) {
            return;
        }

        assetOriginal.commitments.each(function(commitment) {
            var normalizedTradeStatus = normalizeLedgerTradeStatus(commitment.tradeStatus);
            commitment.tradeStatus = normalizedTradeStatus || completeTradeStatus;
        });
    }

    function loadValuationStatuses() {
        return AccountComposer.types.valuationStatus().then(function (response) {
            angular.copy(response.data, $scope.current.valuationStatuses);
        });
    }

    function loadEntityOptions() {
        if( $scope.rights.entityOptions.canRead ) {
            $http.get("/Settings/EntityOptions/Assets/" + $scope.current.asset.id, {trackerMsg: 'Loading options'})
                .then(function (r) {
                    $portfolio.cleanCustomFields( r.data );
                    $scope.current.asset.entityOptions = r.data;
                    assetOriginal.entityOptions = angular.copy(r.data);
                });
        }
    }

    function loadFundingTypes() {
        return AccountComposer.types.equityFunding().then(function (response) {
            angular.copy(response.data, $scope.current.fundingTypes);
        });
    }

    function loadActivityTypes() {
        return $http.get('/Settings/Database/EntityOptions/Code/69NEWAIPTRANSUPSERT')
            .then(response => {
                $scope.useNewActivityTypes = response.data.value.toLowerCase() === 'true';
                return AccountComposer.types.equityActivity().then(function (response) {
                    if ($scope.useNewActivityTypes) {
                        angular.copy(response.data.sortBy('id'), $scope.current.activityTypes);
                        angular.copy($scope.current.activityTypes.filter(at => at.capitalBalanceImpact > 0), $scope.current.activityTypesPositive);
                        angular.copy($scope.current.activityTypes.filter(at => at.capitalBalanceImpact === 0), $scope.current.activityTypesNeutral);
                        angular.copy($scope.current.activityTypes.filter(at => at.capitalBalanceImpact < 0), $scope.current.activityTypesNegative);
                    } else {
                        angular.copy(response.data.sortBy('description').filter(isAllowedActivityType), $scope.current.activityTypes);
                    }
                });
            }, reason => {
                $q.reject(reason);
            });
        return $q.reject();
    }

    function isAllowedActivityType(activityType) {
        return activityType.id <= 7;
    }

    function loadEnumLookUps() {
        var list = {
            excludeTypes: excludeType,
            excludePercentOfs: excludePercentOf,
            assetStatuses: assetStatus
        };

        Object.each(list, function (key, value) {
            $scope[key] = $portfolio.enumToSimpleList(value);
        });
    }

    

    function loadAssetVerbose() {
        return ($scope.current.asset.id > 0
            ? AccountComposer.assets.getVerbose({params: {id: $scope.current.asset.id, expand: assetExpand }})
            : AccountComposer.assets.newVerbose({params: {expand: assetExpand }}).then(function(response){
                    angular.extend(response.data.portfolio, {
                        isActive: true,
                        isManaged: true,
                        accountId: args.accountId || 0,
                        productId: args.productId || 0,
                        status: 3

                    });
                    return response;
                })
        ).then(function(response){
            response.data.entityOptions = undefined;

            angular.copy(response.data, $scope.current.asset);
            applyDefaultTradeStatusToCommitments();

            if($scope.current.asset.portfolio.productId !== 0)
                AccountComposer.products.getSimple({params: {id: $scope.current.asset.portfolio.productId}}).then( function (product) {
                    $scope.current.selectedProduct = product.data;
                    loadFullProduct( );
                    loadDownloadSymbols();
                });

            if($scope.current.asset.portfolio.accountId > 0)
                AccountComposer.accounts.getSimple({params: {id: $scope.current.asset.portfolio.accountId}}).then( function (account) {
                    $scope.current.selectedAccount = {
                        id: account.data.id,
                        name: account.data.name,
                        number: account.data.number
                    };
                });


            return $q.resolve( $scope.current.asset.id > 0
                ? loadAssetCalculations()
                : null
            ).then(function(){
                assetOriginal = angular.copy($scope.current.asset);
                return $scope.current.asset;
            });
        });
    }

    function loadFullProduct( ) {
        return $http.get("/Portfolio/Products/Verbose/" + $scope.current.selectedProduct.productId + '?expand=billing', {trackerMsg: 'Loading product' })
            .then(function(response){
                $scope.current.isProductGloballyExcluded = response.data.billing.feeExcluded;
            })
    }

    function loadDownloadSymbols( ) {
        if($scope.current.selectedProduct && !$scope.current.selectedProduct.downloadSymbols)
            return $http.get("/Global/DownloadSymbols/Product/" + $scope.current.selectedProduct.productId, {trackerMsg: 'Loading download symbols' })
                .then(function(response){
                    $scope.current.selectedProduct.downloadSymbols = response.data;
                });
        return $q.reject();
    }

    function loadPartialAssetExclusion( ) {
        $http.get("/Settings/EntityOptions/Asset/" + $scope.current.asset.id + "/Code/69PARTIALA", {cache: true, trackerMsg: 'Loading partial asset exclusion settings'})
            .then(function (r) {
                $scope.current.isMaxAmountBilled = r.data.value === 'Max Amount Billed' ? true : false;
            });
    }

    function loadAssetCalculations() {
        if(!$scope.current.asset.portfolio) return $q.reject();
        return AccountComposer.assets.get({
            params: {
                returnStyle:'Alternative',
                id: $scope.current.asset.id
            },
            tracker: null
        }).then(function(response){
            angular.extend(
                $scope.current.asset.portfolio,
                Object.select(response.data, [
                    'committedCapital',
                    'committedCapitalDate',
                    'contributedCapital',
                    'costBasis',
                    'unfundedCommitmentAmount',
                    'valuation',
                    'upcomingCapitalCallDate',
                    'upcomingCapitalCallAmount',
                    'upcomingDistributionDate',
                    'upcomingDistributionAmount',
                    'recallableDistribution'
                ])
            );

            if( response.data.upcomingCapitalCallAmountType === "Percent" ) {
                $scope.current.asset.portfolio.upcomingCapitalCallAmount += "%";
            } else if( response.data.upcomingCapitalCallAmountType === "Dollars" ) {
                $scope.current.asset.portfolio.upcomingCapitalCallAmount = "$" + $scope.current.asset.portfolio.upcomingCapitalCallAmount;
            }

            if( response.data.upcomingDistributionAmountType === "Percent" ) {
                $scope.current.asset.portfolio.upcomingDistributionAmount += "%";
            } else if( response.data.upcomingDistributionAmountType === "Dollars" ) {
                $scope.current.asset.portfolio.upcomingDistributionAmount = "$" + $scope.current.asset.portfolio.upcomingDistributionAmount;
            }

        });
    }

    function loadTransactions( transactions ) {
        return ($scope.current.asset.id > 0
                ? ( transactions
                    ? AccountComposer.transactions.getListVerbose({data: transactions.map('id'), params: {expand: transactionExpand}})
                    : AccountComposer.transactions.getAllVerbose({params: {assetId: $scope.current.asset.id, expand: transactionExpand}})
                ) : $q.reject()
        ).then(function(response){
            response.data.each(function(t){
                registerTransaction(t);
            });
            filterTransactions();
        });
    }

    function isChildTransaction(transaction) {
        return $scope.newActivityTypesFeatureEnabled
            && transaction.alternative
            && transaction.alternative.isParent === false;
    }

    function registerTransaction(transaction) {
        transaction.portfolio.transDateFriendly = Date.create(transaction.portfolio.transDate).format("{MM}/{dd}/{yyyy}");
        transaction.portfolio.transDateSortable = Date.create(transaction.portfolio.transDate);

        transaction.alternative.cashDateFriendly = Date.create(transaction.alternative.cashDate).format("{MM}/{dd}/{yyyy}");
        transaction.alternative.cashDateSortable = Date.create(transaction.alternative.cashDate);

        var current = transaction.id > 0 ? $scope.current.transactions.data.find({id: transaction.id}) : null;
        if(!current) {
            transaction.$listener = $scope.$watch(function () {
                return transaction
            }, function (updated) {
                var original = transactionsOriginal.find({id: transaction.id});
                if (!original || isChildTransaction(transaction)) return;
                if (
                    transaction.portfolio.transDate &&
                    !angular.equals(updated.portfolio.transDate, original.portfolio.transDate)
                ) {
                    transaction.portfolio.transDateFriendly = Date.create(transaction.portfolio.transDate).format("{MM}/{dd}/{yyyy}");
                    transaction.portfolio.transDateSortable = Date.create(transaction.portfolio.transDate);
                    applyAipTradeStatusForTransDate(transaction);
                }

                if (
                    transaction.alternative.cashDate &&
                    !angular.equals(updated.alternative.cashDate, original.alternative.cashDate)
                ) {
                    transaction.alternative.cashDateFriendly = Date.create(transaction.alternative.cashDate).format("{MM}/{dd}/{yyyy}");
                    transaction.alternative.cashDateSortable = Date.create(transaction.alternative.cashDate);
                }

                if (
                    !angular.equals(updated.alternative.equityFundingTypeId, original.alternative.equityFundingTypeId)
                ) {
                    var fundingType = $scope.current.fundingTypes.find({id: transaction.alternative.equityFundingTypeId}) || {
                        description: null,
                        id: null
                    };
                    transaction.alternative.equityFundingType = fundingType.description;
                }

                if (updated.id > 0) {
                    var isDirty = !angular.equals(updated.portfolio, original.portfolio) ||
                        !angular.equals(updated.alternative, original.alternative);
                    transaction.$state = isDirty ? 'update' : 'load';
                    if (isDirty) {
                        filterTransactions();
                    }
                } else if (
                    !angular.equals(updated, original) &&
                    updated.id > 0
                ) {
                    transaction.$state = 'update';
                    filterTransactions();
                }
            }, true);

            let type = '';
            let typeId = 0;
            let activityType = {
                description: null,
                id: null,
                hasCashOffset: false
            };
            let transType = {
                name: '',
                description: '',
                id: 0,
                hasCashOffset: false
            };
            if (transaction.alternative.equityActivityTypeId > 0) {
                type = 'activity';
                typeId = transaction.alternative.equityActivityTypeId;
                // Fall back to the default when the saved type is no longer offered in the dropdown
                // (e.g. its tblActivityTransactionTypeALClient association was removed and it is not global)
                // so downstream logic does not run against an undefined type.
                activityType = $scope.current.activityTypes.find({ id: typeId }) || activityType;
            } else if (transaction.portfolio.transTypeId > 0) {
                type = 'transaction';
                typeId = transaction.portfolio.transTypeId;
                transType = $scope.current.transactionTypes.find({ id: typeId }) || transType;
            }
            transaction.selectedType = (typeId > 0 ? type + ':' + typeId : null);
            transaction.isCashDateEnabled = $scope.isCashDateEnabled(transType, activityType);
            transaction.fundingTypeOptions = [];
            if (!transaction.isCashDateEnabled) {
                angular.copy($scope.current.fundingTypes, transaction.fundingTypeOptions);

                transaction.alternative.equityFundingTypeId = 5;  //None Needed
                const fundingType = $scope.current.fundingTypes.find({ id: transaction.alternative.equityFundingTypeId }) || {
                    description: null,
                    id: null
                };
                transaction.alternative.equityFundingType = fundingType.description;
            } else if ($scope.useNewActivityTypes) {
                angular.copy($scope.current.fundingTypes.filter(ft => ft.id !== 5), transaction.fundingTypeOptions);

                if (transaction.alternative.equityFundingTypeId == 5) { //5 or "5" (None Needed)
                    transaction.alternative.equityFundingTypeId = null;
                    transaction.alternative.equityFundingType = null;
                }
            } else {
                angular.copy($scope.current.fundingTypes, transaction.fundingTypeOptions);
            }

            $scope.current.transactions.data.unshift(transaction);
        } else transaction = angular.extend(current, transaction);

        applyAipTradeStatusForTransDate(transaction);
        transaction.$state = transaction.id > 0 ? 'load' : 'create';

        if(transaction.id > 0) {
            var original =  transactionsOriginal.find({id: transaction.id});
            if (original)   angular.copy(transaction, original);
            else            transactionsOriginal.unshift(angular.copy(transaction));
        }

        filterTransactions();
    }

    function saveAssetPortfolio() {
        if ($scope.current.asset.portfolio && !angular.equals(assetOriginal.portfolio, $scope.current.asset.portfolio)) {
            var verboseAsset = {
                id: $scope.current.asset.id,
                portfolio: $scope.current.asset.portfolio
            };

            return (verboseAsset.id > 0
                    ? AccountComposer.assets.saveVerbose({trim: true, data: verboseAsset, params: {id: verboseAsset.id }})
                    : AccountComposer.assets.createVerbose({trim: true, data: verboseAsset}).then(function(asset) {
                        $scope.current.asset.id = asset.id;
                        $scope.current.transactions.data.each(function(t){
                            t.portfolio.assetId = asset.id;
                        });
                        return asset;
                    }).then(function(){
                        return $scope.current.asset;
                    })
            );
        } else {
            return $q.resolve($scope.current.asset)
        }

    }

    function saveAsset() {
        if(
            angular.equals(assetOriginal, $scope.current.asset) &&
            !isTransactionsModified()
        ) return $q.reject();

        return saveAssetPortfolio().then(function(){
            return saveTransactions();
        }).then(function(){
            var verboseAsset = {
                id: $scope.current.asset.id
            };

            if ($scope.current.asset.entityOptions && !angular.equals(assetOriginal.entityOptions, $scope.entityOptions))
                verboseAsset.entityOptions = $portfolio.restoreEntityOptions($scope.current.asset.entityOptions);

            if ($scope.current.asset.assetValuations && !angular.equals(assetOriginal.assetValuations, $scope.current.asset.assetValuations))
                verboseAsset.assetValuations = $scope.current.asset.assetValuations;

            if ($scope.current.asset.commitments && !angular.equals(assetOriginal.commitments, $scope.current.asset.commitments))
                verboseAsset.commitments = $scope.current.asset.commitments;

            if ($scope.current.asset.alternativeSchedules && !angular.equals(assetOriginal.alternativeSchedules, $scope.current.asset.alternativeSchedules))
                verboseAsset.alternativeSchedules = $scope.current.asset.alternativeSchedules;

            if ($scope.current.asset.billing && !angular.equals(assetOriginal.billing, $scope.current.asset.billing)) {
                if (!$scope.current.asset.excludeAmountType) {
                    $scope.current.asset.excludeAmountType = excludeType.Dollars.name;
                }
                if (!$scope.current.asset.excludePercentOf) {
                    $scope.current.asset.excludePercentOf = excludePercentOf.Asset.name;
                }
                verboseAsset.billing = $scope.current.asset.billing;
            }

            return (Object.keys(verboseAsset).length > 1
                ? AccountComposer.assets.saveVerbose({trim: true, data: verboseAsset, params: {id: verboseAsset.id }})
                : $q.resolve()
            )
        });
    }

    function close(asset) {
        editorHotKeys.destroy();
        $scope.$destroy();
        dialog.close(asset);
    }

    function checkError(isError, error) {
        $scope.errors.remove(function(e){
            return e.type + e.title + e.msg === error.type + error.title + error.msg
        });
        if(isError) $scope.errors.push(error);
    }

    function validateEditor() {
        checkError(
            $scope.current.asset.commitments.any(function(c){
                return (new Date(Date.parse(c.asOfDate))).getFullYear() < 1900
            }),
            {type: 'error', title: 'Invalid Commitment Date! ', msg: ' Commitment dates must not be before the year 1900.', showAllowClose: false}
        );
        checkError(
            $scope.current.asset.commitments.any(function (c) {
                return c.ledgerType <= 0;
            }),
            { type: 'error', title: 'Invalid Ledger Type! ', msg: ' Ledger type can not be none.', showAllowClose: false }
        );
        checkError(
            !$scope.current.asset.portfolio.accountNumber,
            {type: 'error', title: 'Blank Account Number! ', msg: ' The account number cannot be blank.', showAllowClose: false}
        );
        checkError(
            $scope.current.asset.portfolio.productId === 0,
            {type: 'error', title: 'Product Missing! ', msg: ' The product must be provided.', showAllowClose: false}
        );
        var uniqueCommitTypeAndAsOfDates = [];
        var isCommitmentLedgerError = false;
        $scope.current.asset.commitments.forEach((commitRecord) => {
            var key = String(commitRecord.ledgerType) + String(commitRecord.asOfDate);
            if (uniqueCommitTypeAndAsOfDates.includes(key)) {
                isCommitmentLedgerError = true;
            } else {
                uniqueCommitTypeAndAsOfDates.push(key);
            }
        });

        checkError(isCommitmentLedgerError,
            { type:'error', title:'Alternative Activity Ledger Error!', msg: 'Alternative Activity Ledger can not contain duplicate records with same date and ledger type.' });
        checkError(
            $scope.pendingReviewLedgerStatusEnabled &&
            $scope.current.asset.commitments.any(function (c) {
                var normalizedTradeStatus = normalizeLedgerTradeStatus(c.tradeStatus);
                return normalizedTradeStatus !== completeTradeStatus && normalizedTradeStatus !== pendingTradeStatus;
            }),
            { type: 'error', title: 'Invalid Ledger Status! ', msg: ' Alternative Activity Ledger status must be Pending or Complete.', showAllowClose: false }
        );
        return $scope.errors.length > 0;
    }

    function addSchedule( scheduleType ) {
        $scope.current.asset.alternativeSchedules.push( {
            assetId: $scope.current.asset.id,
            scheduleType: scheduleType,
            scheduleDate: Date.create('today').formatted(),
            amount: 0,
            amountType: 'Percent'
        } );
    }

    function filterTransactions() {
        $scope.current.transactions.filtered = $filter('orderBy')(
            $filter('filter')(
                $scope.current.transactions.data,
                $scope.current.transactions.searchFor,
                isEquivalent
            ),
            $scope.current.transactions.sortField,
            $scope.current.transactions.sortReverse
        );
    }

    function saveTransactions() {
        if(!isTransactionsModified()) return $q.resolve();

        var upsertedAlternative = [],
            deletedAlternative = [];

        $scope.current.transactions.data.each(function(t){
            if(isChildTransaction(t)) return;
            if(t.$state === 'delete') deletedAlternative.push(t.id);
            if(t.$state === 'create' || t.$state === 'update') {
                var payload = angular.copy(t);
                delete payload.tradeStatusDisabled;
                upsertedAlternative.push(payload);
            }
        });

        return $q.all({
            upsertedAlternative: (upsertedAlternative.length > 0
                ? AccountComposer.transactions.upsertAlternativeListVerbose({data:upsertedAlternative}).then(function(response){
                    upsertedAlternative.each(function(i) {
                        $scope.current.transactions.data.remove(function(t){
                            if(t.id != i.id) return false;
                            t.$listener();
                            return true;
                        });
                    });

                    return response.data;
                })
                : []),
            deletedAlternative: (deletedAlternative.length > 0
                ? AccountComposer.transactions.deleteAlternativeList({data:deletedAlternative}).then(function(response){
                    deletedAlternative.each(function(i) {
                        $scope.current.transactions.data.remove(function(t){
                            if(t.id != i.id) return false;
                            t.$listener();
                            return true;
                        });
                    });

                    return response.data;
                })
                : [])
        });
    }

    function isTransactionsModified() {
        return $scope.current.transactions.data.any(function (t) {
            if(isChildTransaction(t)) return false;
            return t.$state !== 'load'
        });
    }

    function isEquivalent(value, standard) {
        if(standard === '') standard = null;
        if(value === '') value = null;

        if(value === standard || value == standard)
            return true;

        if(!isNaN(value) && !isNaN(standard)) {
            return standard === null || Number(value) === Number(standard);
        }

        return standard === null || new RegExp('^' + standard + '$','i').test(value);
    }


    // PUBLIC METHODS
    $scope.cancel = function( ) {
        close( null );
    };

    $scope.close = function (validate) {
        if (validate) {
            if (
                !angular.equals(assetOriginal.portfolio, $scope.current.asset.portfolio) ||
                !angular.equals(assetOriginal.commitments, $scope.current.asset.commitments) ||
                !angular.equals(assetOriginal.entityOptions, $scope.current.asset.entityOptions) ||
                !angular.equals(assetOriginal.billing, $scope.current.asset.billing) ||
                !angular.equals(assetOriginal.alternativeSchedules, $scope.current.asset.alternativeSchedules) ||
                !angular.equals(assetOriginal.assetValuations, $scope.current.asset.assetValuations) ||
                isTransactionsModified()
            ) {
                $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true});
            } else {
                close(null);
            }
        } else {
            close(null);
        }
    };

    $scope.save = function () {
        if(validateEditor()) return;

        return $q.resolve(  // If account has changed, move first and then save.
            assetOriginal.portfolio.accountId != $scope.current.asset.portfolio.accountId &&
            $scope.current.asset.portfolio.accountId != 0 && $scope.current.asset.id > 0
                ? AccountComposer.assets.moveToAccount({params: {id: $scope.current.asset.id, accountId: $scope.current.asset.portfolio.accountId}})
                : null
        ).then(function(){
            return saveAsset().then(function(){
                close(true);
            }, function() {
                close(null);
            });
        });
    };

    $scope.parseDate = function(item) {
        return new Date(item.scheduleDate || item.asOfDate);
    };

    $scope.addValuation = function( ) {
        $scope.current.expandValuations = true;
        $scope.current.asset.assetValuations.push( {
            isNew: true,
            assetId: $scope.current.asset.id,
            asOfDate: Date.create('today').formatted(),
            unitBalance: 0,
            isEstimated: false,
            valuationStatus: 'Complete',
            notes: null
        } );
    };

    $scope.removeValuation = function( v ) {
        return $dialog.confirmAction("Are you sure you want to remove a valuation?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.current.asset.assetValuations.remove(v);
                }
            });
    };

    $scope.addAlternativeActivityLedger = function (ledgerType = null, asOfDate = Date.create('today').formatted(), amount = null, notes = null, tradeStatus = null) {
        var normalizedTradeStatus = normalizeLedgerTradeStatus(tradeStatus);
        $scope.current.expandAlternativeActivityLedger = true;
        $scope.current.asset.commitments.push({
            ledgerType: ledgerType,
            asOfDate: asOfDate,
            amount: amount,
            notes: notes,
            tradeStatus: $scope.pendingReviewLedgerStatusEnabled ? (normalizedTradeStatus || completeTradeStatus) : normalizedTradeStatus
        });
    };
    $scope.removeAlternativeActivityLedger = function (al) {
        return $dialog.confirmAction("Are you sure you want to remove a ledger record?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.current.asset.commitments.remove(al);
                }
            });
    };

    $scope.isTransactionEditable = function(transaction) {
        return !isChildTransaction(transaction);
    };

    $scope.updateTransactionType = function() {
        var type, id;
        [type, id] = (this.t.selectedType).split(':');

        var transType = type === 'transaction' ? $scope.current.transactionTypes.find({id: parseInt(id)}) : {
            name: '',
            description: '',
            id: 0,
            hasCashOffset: false
        };
        var activityType = type === 'activity' ? $scope.current.activityTypes.find({id: parseInt(id)}) : {
            description: null,
            id: null,
            hasCashOffset: false
        };

        this.t.portfolio.transTypeId = transType.id;
        this.t.portfolio.type = transType.name;
        this.t.portfolio.transactionDescription = transType.description;
        this.t.alternative.equityActivityTypeId = activityType.id;
        this.t.alternative.equityActivityType = activityType.description;
        this.t.alternative.impactsCommitment = activityType.impactsCommitmentDefault;
        this.t.alternative.impactsCapitalBalance = activityType.impactsCapitalBalanceDefault;
        this.t.isCashDateEnabled = $scope.isCashDateEnabled(transType, activityType);
        if (!this.t.isCashDateEnabled) {
            this.t.fundingTypeOptions = [];
            angular.copy($scope.current.fundingTypes, this.t.fundingTypeOptions);

            this.t.alternative.equityFundingTypeId = 5;  //None Needed
            const fundingType = $scope.current.fundingTypes.find({ id: this.t.alternative.equityFundingTypeId }) || {
                description: null,
                id: null
            };
            this.t.alternative.equityFundingType = fundingType.description;
        } else if ($scope.useNewActivityTypes) {
            this.t.fundingTypeOptions = [];
            angular.copy($scope.current.fundingTypes.filter(ft => ft.id !== 5), this.t.fundingTypeOptions);

            if (this.t.alternative.equityFundingTypeId == 5) { //5 or "5" (None Needed)
                this.t.alternative.equityFundingTypeId = null;
                this.t.alternative.equityFundingType = null;
            }
        }
    };

    $scope.isOriginalCostEnabled = function(t) {
        return [
            41,
            100,
            128,
            129,
            168,
            172,
            185,
            196,
            204,
            213, 
            39,
            40,
            61
        ].find(parseInt(t.portfolio.transTypeId));
    };

    $scope.isCashDateEnabled = function (transType, activityType) {
        return !$scope.useNewActivityTypes || transType.hasCashOffset || activityType.hasCashOffset;
    };

    $scope.addTransaction = function() {
        registerTransaction({
            portfolio: {
                assetId: $scope.current.asset.id,
                transDate: Date.create('today').format("{yyyy}-{MM}-{dd}"),
                transAmount: null,
                notes: null,
                type: '',
                transTypeId: null,
                status: 'Complete'
            },
            alternative: { }
        });
        $scope.current.transactions.expand = true;
    };

    $scope.applyAipTradeStatusForTransDate = applyAipTradeStatusForTransDate;
    $scope.onTradeStatusChange = onTradeStatusChange;
    $scope.getTradeStatusesForTransaction = function (t) {
        if (!isFutureTransDate(t)) {
            return $scope.current.tradeStatuses.filter(function (status) {
                return status.name !== futureAipTradeStatus;
            });
        }
        return $scope.current.tradeStatuses;
    };

    $scope.undoTransaction = function(transaction) {
        var original = transactionsOriginal.find({id: transaction.id});
        if (!original) {
            return;
        }
        angular.copy(original, transaction);
        transaction.$state = 'load';
        filterTransactions();
    };

    $scope.saveTransactions = saveTransactions;

    $scope.removeTransaction = function( t ) {
        if(!(t.id > 0)) $scope.current.transactions.data.remove(t);
        else t.$state = 'delete';
        filterTransactions();
    };

    $scope.sortTransactions = function( sortField ) {
        $scope.current.transactions.sortReverse = ($scope.current.transactions.sortField === sortField) ? !$scope.current.transactions.sortReverse : false;
        $scope.current.transactions.sortField = sortField;

        filterTransactions();
    };

    $scope.addCommitment = function(type) {
        if (type === 'Committed Capital' || type === 'UnFunded Adjustment')
            $scope.current.expandAlternativeActivityLedger = true;
       

        $scope.current.asset.commitments.push( {
            assetId: $scope.current.asset.id,
            asOfDate: null,
            ledgerType: type || null,
            amount: null,
            notes: null,
            tradeStatus: $scope.pendingReviewLedgerStatusEnabled ? completeTradeStatus : null
        } );

        var rows = document.querySelectorAll('#alternative-activity-ledger-table tr');

        setTimeout(() => {
            rows[0].scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            })
        }, 0);
        
    };

    $scope.removeCommitment = function( c ) {
        return $dialog.confirmAction("Are you sure you want to remove a commitment?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.current.asset.commitments.remove( c );
                }
            });
    };

    $scope.importAlternativeActivityLedger = function() {
        civ2Service.getImportType("AIP Ledger").then(function (res) {
            $window.open(`#/customImports2/templates?createImport=${res.data.id}`, '_blank');
        });
    }

    $scope.copyAlternativeActivityLedger = function () {
        $dialog.editor(
            "confirmation/alternatives/editors/views/alternatives-asset-ledger-copy.html",
            "AlternativesAssetLedgerCopyCtrl",
            { args: function () { return { id: $scope.current.asset.id, assetName: $scope.current.asset.name}; } },
            "modal-pane-medium")
            .open().then((copiedCommitments) => {
                copiedCommitments.data.forEach((commitment) => {
                    $scope.addAlternativeActivityLedger(commitment.ledgerType,
                        commitment.asOfDate,
                        commitment.amount,
                        commitment.notes,
                        commitment.tradeStatus);
                });
            });
    }

    $scope.importValuations = function( ) {
        civ2Service.getImportType("AIP Valuations").then(function (res) {
            $window.open(`#/customImports2/templates?createImport=${res.data.id}`, '_blank');
        });
    };

    $scope.openAlternativesAccountEditor = function() {
        return $dialog.editor( 'confirmation/alternatives/editors/views/alternatives-account-edit.html', 'AlternativesAccountEditCtrl').open( )
            .then( function( account ) {
                if( account ) {
                    $scope.current.selectedAccount = {
                        id: account.id,
                        name: account.name,
                        number: account.number,
                        clientId: account.clientId,
                        registrationId: account.registrationId,
                        custodian: account.custodian,
                        isActive: account.isActive,
                        managementStyle: account.managamentStyle
                    };
                }
            });
    };
    
    $scope.openAlternativesProductEditor = function() {
        return $dialog.editor( 'confirmation/alternatives/editors/views/alternatives-product-edit.html', 'AlternativesProductEditCtrl', {
                args: function() { return { id : 0 } }
            }).open( )
            .then(function( product ) {
                // Returns a verbose
                if( product && product.portfolio ) {
                    $scope.current.selectedProduct = {
                        productId: product.id,
                        productName: product.name,
                        productType: product.portfolio.productType,
                        ticker: product.portfolio.ticker
                    };
                }
            });
    };

    $scope.openProductEditor = function() {
        if ($scope.current.asset.portfolio.productId === 0) return $q.reject();
        return $dialog.editor("products/editors/product-edit.html", "ProductEditCtrl", {
                    args: function() {
                        return {
                            id: $scope.current.asset.portfolio.productId,
                            app: apps.productsAndPrices,
                            defaultTab: { name: "Local", active: true, code: "productGeneral" },
                            extraInfo: null,
                            isNewGlobal: false,
                            isNewLocal: false,
                            isAdvisorProduct: false,
                            isReturnGlobal: false
                        };
                    }
        }).open().then(function(results) {
            if (results) {
                const resultLocalProduct = results.find(r => typeof r.data.portfolio !== 'undefined' && typeof r.data.localProduct === 'undefined');
                const resultGlobalProduct = results.find(r => typeof r.data.portfolio !== 'undefined' && typeof r.data.localProduct !== 'undefined');

                let localProduct = null;
                let globalProduct = null;

                if (resultLocalProduct) {
                    localProduct = resultLocalProduct.data;
                }
                if (resultGlobalProduct) {
                    globalProduct = resultGlobalProduct.data;
                }

                if (localProduct || globalProduct) {
                    if (localProduct && localProduct.name && localProduct.name.length > 0) {
                        $scope.current.selectedProduct.productName = localProduct.name;
                    } else if (globalProduct && globalProduct.name && globalProduct.name.length > 0) {
                        $scope.current.selectedProduct.productName = globalProduct.name;
                    }
                    if (localProduct &&
                        localProduct.productType &&
                        localProduct.productType.length > 0) {
                        $scope.current.selectedProduct.productType = localProduct.productType;
                    } else if (globalProduct &&
                        globalProduct.portfolio &&
                        globalProduct.portfolio.productType &&
                        globalProduct.portfolio.productType.length > 0) {
                        $scope.current.selectedProduct.productType = globalProduct.portfolio.productType;
                    }
                    if (globalProduct &&
                        globalProduct.portfolio &&
                        globalProduct.portfolio.ticker &&
                        globalProduct.portfolio.ticker.length > 0) {
                        $scope.current.selectedProduct.ticker = globalProduct.portfolio.ticker;
                    }
                }
            }
        });
    };

    $scope.addCapitalCallSchedule = function( ) {
        $scope.current.expandCapitalCallSchedule = true;
        addSchedule( 'Capital Commitment' );
    };

    $scope.addDistributionSchedule = function( ) {
        $scope.current.expandDistributionSchedule = true;
        addSchedule( 'Distribution' );
    };

    $scope.removeSchedule = function( s ) {
        return $dialog.confirmAction("Are you sure you want to remove schedule?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.current.asset.alternativeSchedules.remove( s );
                }
            });
    };

    $scope.toggleBlankAccountNumber = function () {
        if ($scope.assetGeneral.accountNumber) {
            $dialog.confirmAction("Are you sure you want to clear the account number for this asset?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $scope.assetGeneral.accountNumber = "";
                    }
                });
        }
    };

    $scope.importTransactions = function(){
        civ2Service.getImportType("AIP Transaction").then(function (res) {
            $window.open(`#/customImports2/templates?createImport=${res.data.id}`, '_blank');
        });
    };

    // WATCHES
    $scope.$watch('current.selectedAccount', function(account){
        if(!account || !(account.id > 0)) account = null;
        $scope.current.asset.portfolio.accountId = account ? account.id : null;
        $scope.current.asset.portfolio.accountNumber = account ? account.number : null;
    }, true);

    $scope.$watch('current.selectedProduct', function(product){
        if(!product || !((product.productId || product.id) !== 0)) product = null;
        $scope.current.asset.portfolio.productId = product ? (product.productId || product.id) : null;
        loadDownloadSymbols( ).catch(() => {});
    }, true);

    $scope.$watch('current.transactions.searchFor', function(searchFor){
        filterTransactions();
    }, true);

    //INITIALIZE
    $scope.errors = [];

    $scope.rights = {
        assets: $oasRights.forCode( "ASSETS" ),
        transactions: $oasRights.forCode( "TRANSACTIONS" ),
        entityOptions: $oasRights.forCode("ENTITYOPTION"),
        billing: $oasRights.forCode("ACCTBILLING"),
        billingException: $oasRights.forCode("BILLINGEXCEPTION"),
        isStrategyOverride: $oasRights.forCode("ASSLEVELSTRATASSIGN"),
        activeStatus: $oasRights.forCode("ACTIVESTATUS"),
        orionVision: $oasRights.forCode("ORIONVISION")
    };

    $scope.current = {
        transactionTypes: [],
        commonTransactionTypes: [],
        uncommonTransactionTypes: [],
        tradeStatuses: [],
        ledgerTradeStatuses: [],
        activityTypes: [],
        activityTypesPositive: [],
        activityTypesNeutral: [],
        activityTypesNegative: [],
        fundingTypes: [],
        ledgerTypes: AccountComposer.ledgerTypes,
        valuationStatuses: [],
        asset: {
            id: args.id || 0,
            portfolio: {},
            assetValuations: [],
            commitments: [],
            alternativeSchedules: [],
            billing: {}
        },
        get isBlankAcctCode() { return !$scope.current.asset.portfolio.accountNumber },
        set isBlankAcctCode(value) {
            if(value)
                $dialog.confirmAction("Are you sure you want to clear the account number for this asset?")
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            $scope.current.asset.portfolio.accountNumber = "";
                        }
                    });
            else if($scope.current.selectedAccount)
                $scope.current.asset.portfolio.accountNumber = $scope.current.selectedAccount.number;
        },
        expandValuations: !!args.expandValuations,
        expandCommittedCapital: !!args.expandCommittedCapital,
        expandUnfundedCommitment: !!args.expandUnfundedCommitment,
        expandCapitalCallSchedule: !!args.expandCapitalCallSchedule,
        expandDistributionSchedule: !!args.expandDistributionSchedule,
        expandAlternativeActivityLedger: !!args.expandAlternativeActivityLedger,
        transactions: {
            data: [],
            filtered: [],
            searchFor: {},
            get totalItems() { return $scope.current.transactions.data.length },
            currentPage: 1,
            itemsPerPage: 15,
            maxSize: 10,
            expand: !!args.expandTransactions,
            sortField: 'portfolio.transDateSortable',
            sortReverse: true,
            totalAmount: null,
            isModified: true
        },
        selectedAccount: null,
        selectedProduct: null,
        isProductGloballyExcluded: false,
        isMaxAmountBilled: false
    };

    $scope.marginBillingEnabled = false;
    $scope.newActivityTypesFeatureEnabled = false;
    $scope.pendingReviewLedgerStatusEnabled = false;

    init( );

});


function OasAmount() {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {

            element.on('keypress', function (event) {

                if (!isValidAmountChar())
                    event.preventDefault();

                function isValidAmountChar() {
                    return /[\-0-9\.]/.test(
                        String.fromCharCode(event.which))
                }

            })

        }
    }
}

app.directive('oasAmount', OasAmount);

'use strict';

app.controller( 'AlternativesProductEditCtrl', function AlternativesProductEditCtrl( $scope, dialog,ProductsAndPrices,productStatuses, productTypes, pricingStatuses,entities, preferredRateFrequency, $http,$portfolio, $location, $oasRights,$timeout, $q,$dialog, args ) {

    //region PRIVATE VARIABLES
    var productGeneralOriginal,
        productGlobalOriginal,
        downloadSymbolsOriginal,
        fundFamiliesOriginal,
        assetCategoryWeightingsOriginal,
        assetClassWeightingsOriginal,
        propertyRegionWeightingsOriginal,
        propertyTypeWeightingsOriginal,
        advisorProductsAlClientsOriginal,
        bondRatesOriginal,
        corporateActionsOriginal,
        dividendsOriginal,
        preferredRatesOriginal,
        priceFactorsOriginal,
        productSubstitutionOriginal,
        bondCallsOriginal,
        entityOptionsOriginal,
        customFieldsOriginal,
        customTSFieldsOriginal,
        billingGeneralOriginal,
        alternativeExpectedReturnsOriginal,
        editorHotKeys;


    //endregion

    //region PRIVATE METHODS
    function init( ) {
        $scope.rightsProducts = $oasRights.forCode("PRODUCTS");
        $scope.rightsGlobalProducts = $oasRights.forCode("GLOBALPRODUCT");
        $scope.rightsAssetCategory = $oasRights.forCode("PRODUCTCATEGORY");
        $scope.rightsAssetClass = $oasRights.forCode("ASSETCLASSES");
        $scope.rightsAdvisorProduct = $oasRights.forCode("ADVISORPRODUCTS");
        $scope.isAdvisor = $scope.user.authorization.entity === 'Advisor';
        $scope.rightsOrionVisionApp = $oasRights.forCode("ORIONVISION");

        if ($scope.rightsAdvisorProduct.canRead && $scope.rightsGlobalProducts.canRead && $scope.rightsProducts.canRead || $scope.user.authorization.entity === 'Administrator'){
            loadEnumLookUps();
            loadUserDefinedFieldsForProduct();
            loadHotKeys();
            loadProductGeneral();
            loadProductGlobal();
            loadProductManagers();
            $scope.alternativeExpectedReturns = [];

            $scope.masterGroupPromise = $http.get('/Settings/Database/EntityOptions/Code/69ADVISORP', {
                trackerMsg: 'Fecthing owner code for database'
            })
                .then(function(res) {
                    return $http.get('/Settings/Owner', {trackerMsg:'Looking up advisor number'})
                        .then(function (response) {
                            $scope.current.ownerCode = response.data.code;
                            if(res.data && res.data.value){
                                $scope.current.masterGroup = res.data.value;
                            } else{
                                $scope.current.masterGroup = $scope.current.ownerCode;
                            }
                        });
                });
        } else {
            dialog.close(null);
            $location.path('/notauthorized')
        }
    }

    function loadEnumLookUps() {
        var list = {
            productStatusTypes: productStatuses,
            productTypes: productTypes,
            pricingStatusTypes: pricingStatuses,
            preferredRatesFrequency: preferredRateFrequency
        };

        Object.each(list, function (key, value) {
            $scope[key] = $portfolio.enumToSimpleList(value);
        });
    }

    function loadUserDefinedFieldsForProduct(){
        var udfProjection = function(udfs){
            if(udfs.length > 0){
                udfs.forEach(function(item){
                    var udfObj = {
                            userDefineDataId: 0,
                            value: item.defaultValue,
                            childParameter: null,
                            entity: "Product",
                            entityName: null,
                            name: item.description,
                            category: "",
                            type: item.type,
                            code: item.code,
                            sequence: item.sequence,
                            options: item.options ? item.options : [],
                            input: null,
                            securityCode: null,
                            canEdit: false
                        };
                    $scope.current.userDefinedFields.add(udfObj);
                });
                customFieldsOriginal = angular.copy($scope.current.userDefinedFields);
            }
        };

        $http.get('/Settings/UserDefinedFields/Definitions/products', {trackerMsg:'Loading user defined fields for product'})
            .then(function(response){
                udfProjection(response.data)
            })
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: function() { $scope.close(true); } }
            ]);
        });
    }

    function loadProductManagers() {
        if ($scope.productManagers) return;
        return ProductsAndPrices.managers.getAllSimple().then(function(response){
            $scope.productManagers = response.data.sortBy("name");
        });
    }

    function loadProductGlobal() {

        $http.get("/Global/Products/Verbose/New", {trackerMsg: 'Loading product common definition'})
            .then(function (response) {
                $scope.productGlobal = response.data;

                $scope.current.isAdvisorProduct = true;

                $scope.productGlobal.isActive = $scope.current.isAdvisorProduct ? true : false;

                //set some defaults if this a advisor product
                if ($scope.current.isAdvisorProduct) {
                    $scope.productGlobal.productType = 'Miscellaneous';
                    $scope.productGlobal.shareClassId = 1;
                    $scope.productGlobal.defaultPrice = 1;
                    $scope.productGlobal.priceStatus = "1";
                    $scope.productGlobal.fundFamilyId = 769;
                    if (!$scope.productGeneral) {
                        $scope.productGeneral = {portfolio: {useLocalPricesOnly: false, isManaged: true}};
                        $scope.productGeneral.portfolio.useLocalPricesOnly = true;
                    }
                    loadFundFamilies();
                    loadDownloadSymbols();
                    loadAssetClasses();
                    loadRiskCategories();
                    setAssetCategory();

                }
                productGlobalOriginal = angular.copy($scope.productGlobal);

                if ($scope.current.isAdvisorProduct) {
                    loadAdvisorProductAlClients();
                }
            });
    }

    function loadProductGeneral() {

        $scope.productGeneral = {
            id: 0,
            name: '',
            productType: '',
            portfolio: {
                assetClassId:1,
                riskCategoryId: null,
                isDisabled: false,
                productStatus: '',
                snPRatingId: null,
                moodyRatingId: null,
                isAutoAssign: true,
                isUsed: '',
                isCustodialCash: false,
                isManaged: true,
                isAdvReportable: true,
                is13fReportable: true,
                useDailyInterestAccrual: false,
                allowIntraDayPerformance: false,
                hasFees: false,
                useGlobalSetting: true,
                isFederallyTaxable: true,
                isStateTaxable: true,
                useLocalPricesOnly: false,
                color: null
            },
            alternative: { vintageYear: null },
            productGroup: null,
            userDefinedFields: null,
            entityOptions: null,
            billing: null
        };



        loadAssetClasses();
        loadRiskCategories();
        setAssetCategory();

        productGeneralOriginal = angular.copy($scope.productGeneral);
    }

    function setAssetCategory() {
        if ($scope.assetClasses && $scope.productGeneral && $scope.productGeneral.portfolio) {
            var ac = $scope.assetClasses.find({id: $scope.productGeneral.portfolio.assetClassId});
            if (ac) {
                $scope.current.assetClassCategory = ac.category + ' (' + ac.categoryAbbreviation + ')';
            }
        }
    }

    function loadRiskCategories() {
        if ($scope.riskCategories) return;

        $http.get("/Portfolio/RiskCategories", {trackerMsg: 'Loading risk categories'})
            .then(function (response) {
                $scope.riskCategories = response.data.sortBy("fullName");
            });
    }

    function loadDownloadSymbols() {
        if ($scope.downloadSymbols) return;
        $scope.downloadSymbols = [];
        downloadSymbolsOriginal = angular.copy($scope.downloadSymbols);
    }

    function loadFundFamilies() {
        if ($scope.fundFamilies) return;

        $scope.fundFamilies = [];
        fundFamiliesOriginal = angular.copy($scope.fundFamilies);
    }

    function loadAssetClasses() {
        if ($scope.assetClasses) return;

        $http.get("/Portfolio/ProductClasses", {trackerMsg: 'Loading asset classes'})
            .then(function (response) {
                $scope.assetClasses = response.data.sortBy("description");
                setAssetCategory();
            });
    }

    function loadAdvisorProductAlClients() {
        if ($scope.advisorProductsAlClients) return;

        $scope.alClients.selected = [];
        $scope.advisorProductsAlClients = [];
        advisorProductsAlClientsOriginal = angular.copy($scope.alClients.selected);
        $scope.alClients.selected.add({id:$scope.user.authorization.alClientId, clientName:$scope.user.authorization.alClientName});
    }

    //endregion

    //region PUBLIC METHODS

    $scope.addAlternativeExpectedReturn = function() {
        return $scope.alternativeExpectedReturns.push({
            productId: $scope.productGeneral.id,
            startDate: Date.create('today'),
            high: null,
            low: null,
            comment: null
        });
    };

    $scope.save = function () {
        if (!angular.equals(assetCategoryWeightingsOriginal, $scope.assetCategoryWeightings) && $scope.assetCategoryWeightings.length > 0 && $scope.current.assetCategoryWeightingsTotal !== 100) {
            $scope.errors.push({type: 'error', title: 'Invalid Category Weightings! ', msg: ' Asset category weightings do not add to 100%.'});
        }

        if (!angular.equals(assetClassWeightingsOriginal, $scope.assetClassWeightings) && $scope.assetClassWeightings.length > 0 && $scope.current.assetClassWeightingsTotal !== 100) {
            $scope.errors.push({type: 'error', title: 'Invalid Class Weightings! ', msg: ' Asset class weightings do not add to 100%.'});
        }

        if (!angular.equals(propertyTypeWeightingsOriginal, $scope.propertyTypeWeightings) && $scope.propertyTypeWeightings.length > 0 && $scope.current.propertyTypeWeightingsTotal !== 100) {
            $scope.errors.push({type: 'error', title: 'Invalid Class Weightings! ', msg: ' Property type weightings do not add to 100%.'});
        }

        if (!angular.equals(propertyRegionWeightingsOriginal, $scope.propertyRegionWeightings) && $scope.propertyRegionWeightings.length > 0 && $scope.current.propertyRegionWeightingsTotal !== 100) {
            $scope.errors.push({type: 'error', title: 'Invalid Class Weightings! ', msg: ' Property region weightings do not add to 100%.'});
        }

        if ($scope.productGlobal && $scope.current.parentProduct && $scope.productGlobal.id === $scope.current.parentProduct.productId) {
            $scope.errors.push({type: 'error', title: 'Invalid Parent Product! ', msg: ' Parent product same as current product'});
        }

        if( $scope.productGlobal && $scope.productGlobal.ticker && ( $scope.productGlobal.ticker.endsWith(" ") || $scope.productGlobal.ticker.startsWith(" ") ) ){
            $scope.errors.push({type: 'error', title: 'Invalid Ticker!', msg: ' Ticker cannot start with or end with a space'});
        }

        if (!$scope.current.advisorProductValid) {
            $scope.errors.push({
                type: 'error', title: 'Invalid Ticker!', msg: 'Symbol ' + $scope.current.masterGroup + '_' + $scope.productGlobal.ticker + ' currently exists in global table. Ticker must be unique.' });
        }

        if( $scope.productGlobal && $scope.productGlobal.cusip && ( $scope.productGlobal.cusip.endsWith(" ") || $scope.productGlobal.cusip.startsWith(" ") ) ){
            $scope.errors.push({type: 'error', title: 'Invalid CUSIP', msg: ' CUSIP cannot start with or end with a space'});
        }
        if( !$scope.productGlobal.productSubTypeId || $scope.productGlobal.productSubTypeId===null || $scope.productGlobal.productSubTypeId===""){
            $scope.errors.push({type: 'error', title: 'Invalid Sub Type', msg: 'A Sub Type is required to create a product.'});
        }

        if( $scope.productGlobal && $scope.productGlobal.productName && $scope.productGlobal.productName.has("  ") ) {
            $scope.errors.push({type: 'error', title: 'Invalid Product Name', msg: ' Product name cannot contain consecutive spaces'});
        }

        if( $scope.productGlobal && $scope.productGlobal.portfolio && ( $scope.productGlobal.shareClassId === undefined || $scope.productGlobal.shareClassId === null || $scope.productGlobal.shareClassId === 0 ) ) {
            $scope.errors.push({type: 'error', title: 'Invalid Share Class', msg: ' Product must have a share class'});
        }

        if (!$scope.errors.length) {
            var savePromises = [];

            var verboseGlobalProduct = {};
            var verboseLocalProduct = {};

            verboseGlobalProduct["id"] = 0;
            verboseLocalProduct["id"] = 0;

            var msgProduct = 'Adding ';
            var verbProduct ='POST';

            var urlGlobalProduct = '/Global/Products/Verbose/';
            var urlLocalProduct = '/Portfolio/Products/Verbose/';

            var saveGlobal = false;
            var saveLocal = false;

            var downloadSymbols = angular.copy($scope.downloadSymbols);
            var fundFamilies = angular.copy($scope.fundFamilies);

            if($scope.current.isAdvisorProduct && $scope.productGlobal.ticker){
                $scope.productGlobal.ticker = $scope.current.masterGroup + '_' + $scope.productGlobal.ticker;
            }

            if ($scope.current.parentProduct) {
                $scope.productGlobal.productParentId = $scope.current.parentProduct.productId;
            }

            if ($scope.productGlobal && !angular.equals(productGlobalOriginal, $scope.productGlobal)) {
                verboseGlobalProduct["Portfolio"] = $scope.productGlobal;
                saveGlobal = true;
            }

            if($scope.current.isAdvisorProduct){
                verboseGlobalProduct['alClients'] = [];
                verboseGlobalProduct['localProduct'] ={};

                //download Symbols
                if(downloadSymbols && $scope.productGlobal.cusip && !downloadSymbols.some(function(ds){return $scope.productGlobal.cusip===ds.symbol})){
                    downloadSymbols.add({symbol: $scope.productGlobal.cusip});
                }

                //fund families
                if($scope.productGlobal.fundFamilyId && fundFamilies && !fundFamilies.some(function(ff){return $scope.productGlobal.fundFamilyId===ff.id})){
                    fundFamilies.add({id:$scope.productGlobal.fundFamilyId, name:$scope.current.fundFamilyName});
                }

            }

            if($scope.current.isAdvisorProduct && !angular.equals(advisorProductsAlClientsOriginal, $scope.alClients.selected)){
                $scope.alClients.selected.forEach(function(item){
                    verboseGlobalProduct.alClients.add(item.id);
                });
                //check to make sure default alclient is there
                var found = $scope.alClients.selected.find({id:$scope.user.authorization.alClientId});
                if(!found){
                    verboseGlobalProduct.alClients.add($scope.user.authorization.alClientId);
                }

                if($scope.productGeneral.portfolio){
                    verboseGlobalProduct.localProduct["portfolio"] = $scope.productGeneral.portfolio;
                }
                if($scope.productGeneral.alternative){
                    verboseGlobalProduct.localProduct["alternative"] = $scope.productGeneral.alternative;
                }

                saveGlobal = true;
            }

            if ($scope.productGeneral && !angular.equals(productGeneralOriginal, $scope.productGeneral)) {
                verboseLocalProduct["Portfolio"] = $scope.productGeneral.portfolio;

                saveLocal = true;
            }

            if (downloadSymbols && !angular.equals(downloadSymbolsOriginal, downloadSymbols)) {
                verboseGlobalProduct["DownloadSymbols"] = downloadSymbols;
                saveGlobal = true;
            }

            if (fundFamilies && !angular.equals(fundFamiliesOriginal, fundFamilies)) {
                verboseGlobalProduct["FundFamilies"] = fundFamilies;
                saveGlobal = true;
            }

            if ($scope.bondRates && !angular.equals(bondRatesOriginal, $scope.bondRates)) {
                verboseGlobalProduct["BondRates"] = $scope.bondRates;
                saveGlobal = true;
            }

            if ($scope.productSubstitution && !angular.equals(bondRatesOriginal, $scope.productSubstitution)) {
                verboseLocalProduct["ProductGroup"] = $scope.productSubstitution;
                saveLocal = true;
            }

            if ($scope.alternativeExpectedReturns && !angular.equals(alternativeExpectedReturnsOriginal, $scope.alternativeExpectedReturns)) {
                verboseLocalProduct["alternativeExpectedReturns"] = $scope.alternativeExpectedReturns;
                saveLocal = true;
            }

            if ($scope.preferredRates && !angular.equals(preferredRatesOriginal, $scope.preferredRates)) {
                verboseGlobalProduct["PreferredRates"] = $scope.preferredRates;
                saveGlobal = true;
            }

            if ($scope.current.userDefinedFields && !angular.equals(customFieldsOriginal, $scope.current.userDefinedFields)) {
                var udfs = $scope.current.userDefinedFields.findAll({entity: entities.product.name});
                if (udfs.length) {
                    verboseLocalProduct["userDefinedFields"] = udfs;
                    saveLocal = true;
                }
            }

            if ($scope.customTSFields && !angular.equals(customTSFieldsOriginal, $scope.customTSFields)) {
                var udfs = $scope.customTSFields.findAll({entity: entities.product.name});
                if (udfs.length) {
                    verboseLocalProduct["userDefinedTimeFields"] = udfs;
                    saveLocal = true;
                }
            }

            if ($scope.entityOptions && !angular.equals(entityOptionsOriginal, $scope.entityOptions)) {
                verboseLocalProduct["entityOptions"] = $portfolio.restoreEntityOptions($scope.entityOptions);
                saveLocal = true;
            }

            if ($scope.billingGeneral && !angular.equals(billingGeneralOriginal, $scope.entityOptions)){
                verboseLocalProduct["Billing"] = $scope.billingGeneral;
                saveLocal = true;
            }

            if (saveGlobal) {
                savePromises.push($http({method: verbProduct, url: urlGlobalProduct, data: verboseGlobalProduct, trackerMsg: msgProduct + 'global product'}));
            }

            if (saveLocal && !$scope.current.isAdvisorProduct) {
                savePromises.push($http({method: verbProduct, url: urlLocalProduct, data: verboseLocalProduct, trackerMsg: msgProduct + 'local product'}));
            }

            if (!angular.equals(assetCategoryWeightingsOriginal, $scope.assetCategoryWeightings)) {
                var argsCat = $scope.assetCategoryWeightings.id > 0 ? {method: "PUT", id: $scope.assetCategoryWeightings.id, trackerMsg: "Saving asset category weightings"} : {method: "POST", id: "", trackerMsg: "Adding new asset category weightings"};
                savePromises.push($http({method: argsCat.method, url: '/Portfolio/ProductCategories/Weighted/' + argsCat.id, data: $scope.assetCategoryWeightings, trackerMsg: argsCat.trackerMsg}));
            }

            if (!angular.equals(assetClassWeightingsOriginal, $scope.assetClassWeightings)) {
                var argsClass = $scope.assetClassWeightings.id > 0 ? {method: "PUT", id: $scope.assetClassWeightings.id, trackerMsg: "Saving asset class weightings"} : {method: "POST", id: "", trackerMsg: "Adding new asset class weightings"};
                savePromises.push($http({method: argsClass.method, url: '/Portfolio/ProductClasses/Weighted/' + argsClass.id, data: $scope.assetClassWeightings, trackerMsg: argsClass.trackerMsg}));
            }

            if (!angular.equals(propertyRegionWeightingsOriginal, $scope.propertyRegionWeightings)) {
                savePromises.push($scope.propertyRegionWeightings.id > 0
                    ? ProductsAndPrices.weightings.regions.save({data: $scope.propertyRegionWeightings, params:{id: $scope.propertyRegionWeightings.id}})
                    : ProductsAndPrices.weightings.regions.create({data: $scope.propertyRegionWeightings})
                );
            }

            if (!angular.equals(propertyTypeWeightingsOriginal, $scope.propertyTypeWeightings)) {
                savePromises.push($scope.propertyTypeWeightings.id > 0
                    ? ProductsAndPrices.weightings.propertyTypes.save({data: $scope.propertyTypeWeightings, params:{id: $scope.propertyTypeWeightings.id}})
                    : ProductsAndPrices.weightings.propertyTypes.create({data: $scope.propertyTypeWeightings})
                );
            }

            $q.all(savePromises).then(function (results) {
                editorHotKeys.destroy();
                dialog.close(results[0].data);
            });
        }
    };

    $scope.close = function (validate) {
        if (validate) {
            if ($scope.current.parentProduct && ( !angular.equals($scope.productGlobal.productParentId, $scope.current.parentProduct.productId) )) {
                $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true});
            } else if (
                !angular.equals(productGeneralOriginal, $scope.productGeneral) ||
                !angular.equals(productGlobalOriginal, $scope.productGlobal) ||
                !angular.equals(downloadSymbolsOriginal, $scope.downloadSymbols) ||
                !angular.equals(fundFamiliesOriginal, $scope.fundFamilies) ||
                !angular.equals(assetCategoryWeightingsOriginal, $scope.assetCategoryWeightings) ||
                !angular.equals(assetClassWeightingsOriginal, $scope.assetClassWeightings) ||
                !angular.equals(propertyTypeWeightingsOriginal, $scope.propertyTypeWeightings) ||
                !angular.equals(propertyRegionWeightingsOriginal, $scope.propertyRegionWeightings) ||
                !angular.equals(bondRatesOriginal, $scope.bondRates) ||
                !angular.equals(corporateActionsOriginal, $scope.corporateActions) ||
                !angular.equals(dividendsOriginal, $scope.dividends) ||
                !angular.equals(preferredRatesOriginal, $scope.preferredRates) ||
                !angular.equals(priceFactorsOriginal, $scope.priceFactors) ||
                !angular.equals(productSubstitutionOriginal, $scope.productSubstitution) ||
                !angular.equals(bondCallsOriginal, $scope.bondCalls) ||
                !angular.equals(customFieldsOriginal, $scope.current.userDefinedFields) ||
                !angular.equals(entityOptionsOriginal, $scope.entityOptions)
            ) {
                $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true});
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };

    $scope.checkForExisting = function () {
        if (!($scope.current.isAdvisorProduct && $scope.masterGroupPromise)) { return; }
        if (!$scope.productGlobal.ticker) {
            $scope.productGlobal.cusip = null;
            return;
        }       

        $scope.masterGroupPromise.then(_ => {
            const symbol = `${$scope.current.masterGroup}_${$scope.productGlobal.ticker}`;
            $scope.current.isExecuting = true;
            $http.get(`/Global/Products/SymbolExists?symbol=${encodeURIComponent(symbol)}`, {
                trackerMsg: `Checking if symbol ${symbol} exists`
            })
                .then(response => {
                    const symbolExists = response && response.data && response.data.exists;
                    if (symbolExists) {                        
                        $dialog.messageBox('Ticker Check', `Symbol ${symbol} currently exists in global table.`)
                            .open()
                    } else {
                        $scope.productGlobal.cusip = symbol
                    }
                    $scope.current.advisorProductValid = !symbolExists;
                })
                .finally(_ => $scope.current.isExecuting = false);
        })
    };

    //endregion

    //region INITIALIZE
    $scope.assetClassFieldMap = [{name: "ID", value: "id"}, {name: "Name", value: "name"}, {name: "Description", value: "description"}, {name: "Category", value: "category"}, {name: "Provider", value: "productDescriptionProviderName"}];
    $scope.riskCategoryFieldMap = [{name: "ID", value: "id"}, {name: "Abbreviation", value: "abbreviation"}, {name: "Name", value: "fullName"}, {name: "Provider", value: "productDescriptionProvider"}];
    $scope.productManagerFieldMap = [{name: "ID", value: "id"}, {name: "Name", value: "name"}];
    $scope.errors = [];
    $scope.alClients = {list:[], selected:[]};
    $scope.current = { id: args.id,userDefinedFields:[], expandProductGeneral:false, isAdvisorProduct:true, masterGroup:null,assetClassCategory: '', };

    //endregion

    init( );

});

app.controller('AlternativeGlobalValuationEditCtrl', function AlternativeGlobalValuationEditCtrl( $scope, $http, $oasRights, dialog ) {

    function init( ) {
        $scope.rightsAst = $oasRights.forCode( "ASSETS" );

        if( dialog.options.id === 0 ) {
            $scope.valuation = {
                id: 0,
                productId: null,
                valuationDate: Date.create( 'end of last month' ).formatted(),
                changePercent: 10,
                isEstimate: false,
                notes: null,
                preview: false
            };

            if( dialog.options.productId ) {
                $http.get( '/Portfolio/Products/Simple/' + dialog.options.productId, {trackerMsg: 'Loading product information'} )
                    .then( function( product ) {
                        $scope.current.selectedProduct = product.data;
                    })
            }
        } else {
            $http.get( '/Confirm/Alternative/ProductValuation/' + dialog.options.id, {trackerMsg: 'Loading global valuation'} )
                .then( function (r) {
                    $scope.valuation = r.data;
                    $scope.valuation.changePercent *= 100;
                    $scope.current.selectedProduct = { productId: $scope.valuation.productId, productName: $scope.valuation.productName, ticker: $scope.valuation.ticker };
                });
        }
    }

    $scope.save = function( preview ) {
        var args = $scope.valuation.id > 0 ? {method: "PUT", id: $scope.valuation.id, trackerMsg: "Saving global valuation"} : {method: "POST", id: "", trackerMsg: "Adding new global valuation"};

        if( !$scope.current.selectedProduct || $scope.current.selectedProduct.id === 0 ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Select a product.'} );
        }

        if( $scope.valuation.changePercent <= -100 || $scope.valuation.changePercent >= 100 || $scope.valuation.changePercent === undefined || !angular.isNumber($scope.valuation.changePercent) ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Change Percent must be between -99.9999999 and 99.9999999.'} );
        }

        if( $scope.errors.length === 0 ) {
            var valCopy = angular.copy( $scope.valuation );
            valCopy.productId = $scope.current.selectedProduct.productId;
            valCopy.changePercent /= 100;

            if( preview ) {
                valCopy["productName"] = $scope.current.selectedProduct.productName;
                valCopy["preview"] = true;
                dialog.close( valCopy );
            } else {
                $http( { method: args.method, url: '/Confirm/Alternative/ProductValuation/' + args.id, data: valCopy, trackerMsg: args.trackerMsg } )
                    .then( function( r ) {
                        dialog.close( r.data );
                    });
            }

        }


    };

    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.errors = [];
    $scope.current = { selectedProduct: null };


    init( );
});
app.controller('AlternativeGlobalTransactionEditCtrl', function AlternativeGlobalTransactionEditCtrl( $scope, $http, $oasRights, dialog) {

    function init( ) {            
        $scope.rightsTransaction = $oasRights.forCode( "TRANSACTIONS" );
        $scope.ready = false;
        if( dialog.options.id === 0 ) {
            $scope.transaction = {
                id: 0,
                productId: null,
                transactionTypeId: null,
                alternativeEquityActivityTypeId: null,
                alternativeEquityFundingTypeId: null,
                transactionDate: Date.create('today'),
                percentOfCommitmentAmount: 100,
                impactsCommitment: false,
                impactsCapitalBalance: false,
                tranActType: null,
                notes: null
            };

            if( dialog.options.productId ) {
                $http.get( '/Portfolio/Products/Simple/' + dialog.options.productId, {trackerMsg: 'Loading product information'} )
                    .then( function( product ) {
                        $scope.current.selectedProduct = product.data;
                    })
            }
            $scope.ready = true;
        } else {
            $http.get( '/Confirm/Alternative/ProductTransaction/' + dialog.options.id, {trackerMsg: 'Loading global transaction'} )
                .then( function (r) {
                    $scope.transaction = r.data;
                    $scope.transaction.percentOfCommitmentAmount *= 100.0;
                    $scope.transaction.percentOfCommitmentAmount = $scope.transaction.percentOfCommitmentAmount.round(7);
                    $scope.transaction["tranActType"] = $scope.transaction.transactionTypeId > 0 ? "t:" + $scope.transaction.transactionTypeId : "a:" + $scope.transaction.alternativeEquityActivityTypeId;
                    $scope.current.selectedProduct = { productId: $scope.transaction.productId, productName: $scope.transaction.productName, ticker: $scope.transaction.ticker };
                    $scope.ready = true;
                });
        }

        $http.get( '/Trading/TransactionTypes?IsValid=True', {trackerMsg: 'Loading transaction types'} )
            .then( function (r) {
                $scope.transactionTypes = [];
                for( var i = 0; i < r.data.length; i++ ) {
                    if( ['Buy', 'Sell', 'Dividend to Cash', 'Return of Capital'].any(r.data[i].name) ) {
                        $scope.transactionTypes.push( {id:r.data[i].id, name: r.data[i].name})
                    }
                }
            });

        $http.get( '/Confirm/Alternative/Equity/ActivityTypes', {trackerMsg: 'Loading activity types'} )
            .then( function (r) {
                $scope.activityTypes = [];
                for( var i = 0; i < r.data.length; i++ ) {
                    if( ['Capital Call', 'Capital Distribution', 'Income Distribution'].any(r.data[i].description) ) {
                        $scope.activityTypes.push( {id:r.data[i].id, name: r.data[i].description})
                    }
                }
            });

    }

    $scope.save = function( preview ) {
        var args = $scope.transaction.id > 0 ? {method: "PUT", id: $scope.transaction.id, trackerMsg: "Saving global transaction"} : {method: "POST", id: "", trackerMsg: "Adding new global transaction"};

        if( $scope.transaction.tranActType != null ) {
            if( $scope.transaction.tranActType.startsWith("a:") ) {
                $scope.transaction.transactionTypeId = null;
                $scope.transaction.alternativeEquityActivityTypeId = $scope.transaction.tranActType.replace( "a:", "" );
            } else {
                $scope.transaction.alternativeEquityActivityTypeId = null;
                $scope.transaction.transactionTypeId = $scope.transaction.tranActType.replace( "t:", "" );
            }
        } else {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Select a type.'} );
        }

        if( !$scope.current.selectedProduct || $scope.current.selectedProduct.id === 0 ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Select a product.'} );
        }

        if( $scope.transaction.percentOfCommitmentAmount <= 0 || $scope.transaction.percentOfCommitmentAmount > 100 || $scope.transaction.percentOfCommitmentAmount === undefined ) {
            $scope.errors.push( {type: 'error', title: 'Error! ', msg: ' Percent of Commitment must be between 0 and 100.'} );
        }

        if( $scope.errors.length === 0 ) {
            var trnCopy = angular.copy( $scope.transaction );
            trnCopy.productId = $scope.current.selectedProduct.productId;
            trnCopy.percentOfCommitmentAmount = trnCopy.percentOfCommitmentAmount.round(7);
            trnCopy.percentOfCommitmentAmount /= 100.0;
            if( preview ) {
                trnCopy["productName"] = $scope.current.selectedProduct.productName;
                trnCopy["preview"] = true;
                dialog.close( trnCopy );
            } else {
                $http( { method: args.method, url: '/Confirm/Alternative/ProductTransaction/' + args.id, data: trnCopy, trackerMsg: args.trackerMsg } )
                    .then( function( r ) {
                        dialog.close( r.data );
                    });
            }

        }


    };

    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.errors = [];
    $scope.current = { selectedProduct: null };


    init( );
});
'use strict';

app.controller('AlternativesTransactionListCtrl', function AlternativesTransactionListCtrl($scope, $http, views, $oasRights, $dialog, $routeParams, $portfolio, $location, $window, apps, entities, $timeout, civ2Service, orionVisionSSO, $confirmation, splitIoService, alternativesAssetEditorSidebarCoordinator) {

    // PRIVATE METHODS
    function init( ) {
        $scope.newAlternativesAssetEditor = false;
        splitIoService.getBoolTreatment('opex_AccountComposer_NewActivityTypes_34892').subscribe(function(isEnabled) {
            $scope.newAlternativesAssetEditor = isEnabled;
        });

        splitIoService.getBoolTreatment('opex_AIP_Future_Dated_Activity_5851')
            .subscribe((isEnabled) => {
                $scope.futureDatedActivityEnabled = isEnabled;
            });

        $scope.rightsTransaction = $oasRights.forCode( "TRANSACTIONS" );
        $scope.rightsManuallyManaged = $oasRights.forCode('MANUALLYMANAGED');
        $scope.rightsAst = $oasRights.forCode( "ASSETS" );
        $scope.rightsAcc = $oasRights.forCode( "ACCOUNTS" );
        $scope.rightsProduct = $oasRights.forCode( "PRODUCTS" );
        $scope.rightsPortfolioAudit = $oasRights.forCode( "PORTFOLIOLISTSAPP" );
        $scope.rightsOrionVision = $oasRights.forCode( "ORIONVISION" );
        
        $http.get('/Settings/Database/EntityOptions/Code/69NEWAIPTRANSUPSERT')
            .then(response => {
                $scope.useNewActivityTypes = response.data.value.toLowerCase() === 'true';
            });

        if($routeParams.accountId){
            // Check the Account for Status of Manually Managed(3) and Advisor Only(3)
            $http.get('/Portfolio/Accounts/' + $routeParams.accountId, {trackerMsg:  'Getting account information'})
            .then(function(response){
                if (response.data.accountStatusId === 3 || response.data.accountStatusId === 8){
                    $scope.current.rightsManuallyManaged = $scope.rightsManuallyManaged;
                }
            })
        }
    }

    function slickGridDoubleClick( ) {
        $scope.openTransactionEditor();
    }

    // PUBLIC METHODS

    $scope.refreshGrid = function( ) {
        $scope.$broadcast( 'event:alternatives-transaction-list-action', {action: 'refresh-grid'} );
    };


    $scope.exportToExcel = function( ) {
        $scope.$broadcast('event:alternatives-transaction-list-action', {action: 'export-data'});
    };

    $scope.openTransactionEditor = function(){
        $portfolio.openEditor( entities.transaction.value, $scope.selectedIds, null, null, apps.portfolioLists.name, null ).then(function(transaction) {
            if( transaction ) {
                return $http.get("/Portfolio/Transactions/" + transaction.id + "?returnStyle=alternative", {trackerMsg: 'Loading updated transaction'}).then(function(response){
                    $scope.$broadcast( 'event:alternatives-transaction-list-action', {action: 'update-item', item: response.data } );
                });
            }
        });
    };

    $scope.importTransactions = function(){
        civ2Service.getImportType("AIP Transaction").then(function (res) {
            $window.open(`#/customImports2/templates?createImport=${res.data.id}`, '_blank');
        });
    };

    $scope.openAlternativesAssetEditor = function( ) {
        splitIoService.getBoolTreatment('opex_AccountComposer_NewActivityTypes_34892').subscribe(function(isEnabled) {
            if (isEnabled) {
                return alternativesAssetEditorSidebarCoordinator.open({
                    id: $scope.selected[0].assetId,
                    accountId: $scope.selected[0].accountId,
                    productId: $scope.selected[0].productId,
                    expandTransactions: true
                }).then(function(rslt) {
                    if (rslt) {
                        $timeout(function(){
                            $scope.refreshGrid( );
                        });
                    }
                });
            }

            return $dialog.editor( 'confirmation/alternatives/editors/views/alternatives-asset-edit.html', 'AlternativesAssetEditCtrl', {args: function() { return {
                id : $scope.selected[0].assetId,
                accountId: $scope.selected[0].accountId,
                productId: $scope.selected[0].productId,
                expandTransactions: true
            }}} ).open( ).then(function( rslt ) {
                if( rslt ) {
                    $timeout(function(){
                        $scope.refreshGrid( );
                    });

                }
            });
        });
    };

    $scope.editTransactions = function () {
        const importTypeName = 'AIP Transaction Update';
        if ($scope.useNewActivityTypes && $scope.selected.length > 1) {
            civ2Service.getImportType(importTypeName).then(function (importTypeResult) {
                const transactionList = [];
                angular.forEach($scope.selected, function (item) {
                    const transaction = {
                        pkTransaction: item.id
                    };
                    transactionList.push(transaction);
                });
                if (transactionList.length > 0) {
                    civ2Service.createImport({
                        ImportId: null,
                        ImportTypeId: importTypeResult.data.id,
                        ImportMetadata: {},
                        WorkingData: transactionList,
                        ImportName: importTypeName + ' - ' + Date.create('now').format('{M}/{d}/{yyyy} {hh}:{mm}')
                    }).then(function (importResult) {
                        $confirmation.goToCustomImport(importResult.data.importTypeId, importResult.data.importId);
                    });
                }
            });
        }
    };

    $scope.deleteTransactions = function(){
        var confirmMsg = 'Are you sure you want to delete the transaction(s)?';
        var actionUrl = '/Portfolio/Transactions/Action/Delete';

        $dialog.confirmAction( confirmMsg )
            .open( )
            .then(function( result ){
                if( result === 'yes' ) {
                    $http.put( actionUrl, $scope.selectedIds, {trackerMsg: 'Deleting transaction(s)'} )
                        .then( function ( ) {
                            $scope.refreshGrid( );
                        });
                }
            });
    };

    $scope.completeTransactions = function () {
        if ($scope.selected.length > 0) {
            var updateItems = [];
            angular.forEach($scope.selected, function (item) {
                if (item.status != 'Complete') {
                    item.status = 'Complete';
                    updateItems.push(item);
                }
            });
            if (updateItems.length > 0) {
                var trackerMsg = 'Completing transaction(s)';
                //if only 1 selected, update with child transaction validation,
                if ($scope.selected.length == 1) {
                    $http.post('/Portfolio/Transactions/Alternative/List', updateItems, { trackerMsg: trackerMsg })
                        .then(function () {
                            $scope.refreshGrid();
                        });
                }
                else { //update all transactions, parents will be updated instead of children when children are selected
                    $http.put('/Portfolio/Transactions/Alternative/Action/StatusChange/Complete', $scope.selectedIds, { trackerMsg: trackerMsg })
                        .then(function () {
                            $scope.refreshGrid();
                        });
                }
            }
        }
    };

    $scope.goToAccount = function( ) {
        $location.url( '/confirmation/alternatives/accounts?accountId=' + $scope.selected[0].accountId );
    };

    $scope.goToProduct = function( ) {
        $location.url('/confirmation/alternatives/products?productId=' + $scope.selected[0].productId );
    };

    $scope.goToAssetHistory = function( ) {
        $location.url('/confirmation/alternatives/assethistory?assetId=' + $scope.selected[0].assetId );
    };

    $scope.goToPortfolioAudit = function( ) {
        $portfolio.goTo( 'transactions', entities.transaction.value, $scope.selectedIds[0]);
    };

    $scope.goToOrionVision = function(){
        orionVisionSSO.goTo();
    }

    //EVENT LISTENERS
    $scope.$on('event:alternatives-transaction-list-select', function( e, args ) {
        if( args.length === 0 ) return;

        $scope.selected = args;
    });

    $scope.goToAsset = function( ) {
        $location.url( '/confirmation/alternatives/assets?assetId=' + $scope.selected[0].assetId );
    };

    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.useNewActivityTypes = false;

    $scope.current = {
        view: views[0],
        startDate: Date.create('six months ago'),
        endDate: Date.create('today'),
        url: '/Portfolio/Transactions/',
        assetIdLoaded: $routeParams.assetId ? $routeParams.assetId : null,
        accountIdLoaded: $routeParams.accountId ? $routeParams.accountId : null,
        gridDoubleClick: slickGridDoubleClick,
        rightsManuallyManaged: {canAdd: false, canDelete: false, canRead: false, canUpdate: false},
        orionVisionPending: $routeParams.orionVisionPending ? JSON.parse($routeParams.orionVisionPending) : false
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function( ) {
            if( $scope.selectedIds.length === 1 ) {
                $scope.openTransactionEditor();
            }
        }
    }];

    init( );

});

'use strict';

app.factory('Repo', function Repo($http, $q, $location, $dialog, Entity, Endpoint) {
    var self = this;

    // PRIVATE METHODS
    function merge(calls) {
        return $q.all(calls).then(function(r){
            return {data: Entity.collection(Object.values(r).map('data').flatten(0).compact()), responses: r,
                pages: function() {
                    return $q.all(Object.values(r).map(function(call){if(call.pages) return call.pages()}).compact()).then(function (pages) {
                        return pages.isEmpty() ? false : {
                                calls: pages.map('calls').flatten(0).compact(),
                                data: pages.map('data').flatten(0).compact()
                            };
                    })
                }
            };
        });
    }

    /*function RepoCollection(config) {
        var collection = this;
        collection.items = [];

        collection.getList = getList;

        config.endpoints.forEach(function (endpoint, name) {
            if(angular.isObject(endpoint)) endpoint = Endpoint(endpoint);
            if(!angular.isFunction(endpoint)) throw "Something went wrong!";

            Object.defineProperties(detail, name, {
                value: function (c) {
                    return $q.when(endpoint(c)).then(function(response){
                        var loaded = new Date(response.headers().date).getTime();
                        if(Object.isArray(response.data)) return;
                        else return;
                    });
                    return detail[vm.type.nameProperty];
                },
            })
        });

        function applyItem() {
            return $q.when(fakeData)
                .then(function(data) {
                    return angular.copy(data, collection.items);
                });
        }

        return collection;
    }*/

    // PUBLIC METHODS
    return {
        endpoint: Endpoint,
        merge: merge
    };
});

app.factory('Endpoint', function($rootScope, $q, $http, $dialog, Entity) {
    var resolves = {
        date: function(parameter) {
            return $dialog.inputBox('Date', null, 'date').open()
                .then(function (date) {
                    if (!date) return $q.reject();
                    parameter.value = Date.create(date).format('{yyyy}-{MM}-{dd}');
                    return parameter;
                });
        },
        string: function(parameter) {
            return $dialog.inputBox('Enter', parameter.name).open()
                .then(function (value) {
                    if (!value) return $q.reject();
                    parameter.value = value;
                    return parameter;
                })
        }
    };

    function resolveParam(parameter, options) {
        if(parameter.optional || !parameter.name || !options.resolveMissing) return $q.resolve(parameter);
        else if(options.params[parameter.name]) {
            return $q.resolve(options.params[parameter.name]).then(function(value){
                parameter.value = value;
                delete options.params[parameter.name];
                return $q.resolve(parameter);
            });
        } else {
            return resolves[(resolves[parameter.type] ? parameter.type : 'string')](parameter)
        }
    }

    function resolveParams(options) {
        return $q.all(options.params).then(function(){
            return options;
        })
    }

    function resolveURL(options) {
        var re = '([^{]+)(?:{([^:?}]+)(?::?([^?}]*)(\\??))?})?';
        var parts = options.path.match(new RegExp(re, 'g'));
        if (!parts) return $q.resolve().then(function(){ options.url = options.path; return options });
        else {
            parts = parts.map(function (s) {
                var p = s.match(re);
                return resolveParam({
                    before: p[1],
                    name: p[2],
                    type: p[3],
                    optional: p[4] === '?'
                }, options);
            });

            return $q.all(parts).then(function (ps) {
                options.url = ps.map(function (p) {
                    if (p) return p.before + (p.value || '');
                }).join('');
                return options;
            });
        }
    }

    return function(init) {
        var Endpoint = function(override) {
            var options = Endpoint.config(override);
            return $q.resolve(options)
                .then(resolveParams)
                .then(resolveURL)
                .then($http)
                .then(Entity.response)
                .then(function(r){
                    if(!r.data || !options.trim) return r;
                    return r.data;
                });
        };

        Endpoint.config = function(override) {
            return angular.merge(angular.copy({
                method: init.verb !== undefined ? init.verb : undefined,
                path: init.path !== undefined ? init.path : undefined,
                url: init.url !== undefined ? init.url : undefined,
                params: init.params !== undefined ? init.params : {},
                resolveMissing: init.resolveMissing !== false,
                data: init.data !== undefined ? init.data : null,
                cache: init.cache !== undefined ? init.cache : false,
                tracker: init.tracker !== undefined ? init.tracker : 'main',
                trackerMsg: init.message !== undefined ? init.message : 'Loading',
                extend: init.extend !== undefined ? init.extend : {},
                database: init.database !== undefined ? init.database : null,
                confirm: init.confirm !== undefined ? init.confirm : false,
                raw: init.raw !== undefined ? init.raw : false,
                trim: init.trim !== undefined ? init.trim : false,
                track: init.track !== undefined ? init.track : true,
                collection: init.collection !== undefined ? init.collection : undefined
            }), override || {});
        };

        Endpoint.multi = function (grouped, override) {
            return Object.map(grouped, function (name, group) {
                return Endpoint(angular.isFunction(override) ? override(name, group) : override);
            })
        };

        Endpoint.each = function (collection, override) {
            return collection.map(function (item) {
                return Endpoint(angular.isFunction(override) ? override(item) : override);
            })
        };

        return Endpoint;
    }
});


app.factory('Entity', ["$rootScope", function($rootScope) {
    function Entity(item, config) {
        if(item instanceof Entity) return item;
        if(angular.isString(item) || angular.isNumber(item)) this.key(item);
        else angular.copy(item, this);
        this.config(config);
        return this;
    }

    Entity.prototype.key = function(key, idProperty) {
        var composite = key.toString().match(/(?:AL(\d+):)?(.+)/);
        return this
            .set(idProperty || 'id', composite[2])
            .setDatabase(composite[1]);
    };

    Entity.prototype.isModified = function() {
        if(this.__original__) return JSON.stringify(this) !== JSON.stringify(this.__original__);
        else throw "You must define the original value by first calling {this}.setOriginal()";
    };

    Entity.prototype.config = function(config) {
        if(!config) config = {};
        this.setDatabase    (config.database)
            .extend         (config.extend)
            .setTimeLoaded  (config.loaded);
        if(config.track == true) this.setOriginal();
        return this;
    };

    Entity.prototype.extend = function(extension) {
        for (var name in (angular.isObject(extension) ? extension : {})) {
            if(angular.isFunction(extension[name])) this[name] = extension[name].bind(this);
            else this[name] = extension[name];
        }
        return this;
    };

    // ACCESS
    Entity.prototype.set = set;
    function set(name, value) {
        if(typeof value !== 'undefined') return Object.setValue(this, name, value);
    }

    Entity.prototype.setDatabase = function(database) {
        return !(this.__database__ > 0) ? this.setMeta({database: parseInt(database) > 0 ? parseInt(database) : parseInt($rootScope.user.authorization.alClientId)}) : this;
    };

    Entity.prototype.setTimeLoaded = function(time) {
        time = time ? new Date.create(time).getTime() : NaN;
        return this.setMeta({ loaded: isNaN(time) ? false : time });
    };

    Entity.prototype.setOriginal = function() {
        return this.setMeta({original: Object.freeze(angular.copy(this))});
    };

    Entity.prototype.setMeta = function(properties) {
        for (var name in properties)
            if(properties.hasOwnProperty(name))
                try {
                    if(this[name] == undefined) Object.defineProperty(this, '__' + name + '__', { enumerable: false, value: properties[name] });
                    else this[name] = properties[name];
                } catch(e) { /* Do nothing. */ }
        return this;
    };

    Entity.prototype.getMeta = function(name) {
        return this['__' + name + '__'];
    };

    // HELPERS

    Entity.item = function (item, config) {
        return new Entity(item, config);
    };

    Entity.collection = function (collection, config) {
        var Collection = (Array.isArray(collection)? collection : [])
            .findAll(function(item){
                return !(angular.isString(item) && item.length == 0)
            })
            .compact()
            .map(function(item) {
                return Entity.item(item, config);
            });

        Object.defineProperties(Collection, {
            databases: {
                value: function () {
                    return this.map('__database__').unique();
                }
            }
        });

        return Collection;
    };

    Entity.response = function(response, config) {
        if (!angular.isObject(response.data)) return response;
        config = Object.merge({
            database: response.config.database,
            loaded: new Date(response.headers().date).getTime(),
            raw: response.config.raw,
            trim: response.config.trim,
            track: response.config.track
        }, config);

        response.data = Object.isArray(response.data)
            ? Entity.collection(response.data, config)
            : Entity.item(response.data, config);


        if(response.pages) {
            var _pages = response.pages;
            response.pages = function () {
                return _pages().then(function (pages) {
                    pages.data = Entity.collection(pages.data, config);
                    return pages;
                })
            };
        }

        return response;
    };

    return Entity;
}]);

app.factory('EntityCollection', function() {
    var entityService = ProcessDashboard.fields;
    var vm = this;

    vm.loading = false;
    vm.loadAll = loadAll;
    vm.defaultItem = defaultItem;
    vm.loadItem = loadItem;
    vm.deleteItem = deleteItem;
    vm.saveItem = saveItem;

    Object.defineProperty(vm, 'items', {
        get: function() { return vm.action.fields },
        set: function(value) { return vm.action.fields = value }
    });

    function defaultItem() {
        var item = {};
        if(vm.action) item.actionId = vm.action.id;
        return item;
    }

    function loadAll() {
        vm.loading = true;
        return entityService.getAll().then(function(response){
            vm.items = response.data;
            vm.loading = false;
        });
    }

    function loadItem(item) {
        if(!item) item = {};
        vm.loading = true;
        return $q.resolve(
            item.id
                ? entityService.get({params: {id: item.id}, trim: true})
                : this.defaultItem()
        ).then(function(updated){
            angular.copy(updated, item);
            if(!vm.items) vm.items = [];
            if(!~vm.items.findIndex({id: item.id}) || !(item.id > 0)) vm.items.add(item);
            vm.loading = false;
            return item;
        });
    }

    function deleteItem(item) {
        return (item.id
                ? entityService.delete({confirm: "Delete this task?", params: {id: item.id}})
                : $q.resolve()
        ).then(function(response){
            vm.items.remove(item);
        });
    }

    function saveItem(item) {
        vm.loading = true;
        return (!item.id
                ? entityService.create({data: item})
                : entityService.save({data: item, params: {id: item.id}})
        ).then(function(response){
            angular.copy(response.data, item);
            vm.loading = false;
            return item;
        });
    }
});
'use strict';

app.service('$confirmation', function $confirmation($http, $q, $location, $dialog, $settings, entities, apps, $oasRights) {
    var self = this;
    var endpoints = {};

    const confirmOverviewFileIdsSessionKey = 'confirm_overview_fileids';

    // PRIVATE METHODS


    self.goTo = function(route, params, redirect) {
        var paramString = params ? '?' + Object.toQueryString(params) : '';
        if(redirect == false) return route + paramString;
        else $location.url(route + paramString);
    };

    self.goToCorporateActionTransactions = function (corporateActionId, corporateActionProcessingId) {        
        const params = corporateActionProcessingId ? { corporateActionProcessingId } : null;
        const url = `/confirmation/corporateactions/v2/transactions/${corporateActionId}`;
        self.goTo(url, params);
    };

    self.goToProductsAndPrices = function (productId) {        
        const url = `/orionconnectapp/#/products/global?productId=${productId}`;
        window.open(url, '_blank');
    };

    self.goToGlobalPrices = function (productId) {
        const url = `/orionconnectapp/#/prices/global?productId=${productId}`;
        window.open(url, '_blank');
    };

    self.goToFilesReceived = function(options, redirect) {
        return self.goTo('/confirmation/overview', options, redirect);
    };

    self.goToConfirmQueries = function(confirmGroupId) {
        return self.goTo('/reports/dataqueries?list=confirmGroup' + (confirmGroupId ? '&confirmGroupId=' + confirmGroupId : ''));
    };

    self.goToCustomImport = function (importTypeId, importId) {
        const url = `/orionconnectapp/#/customImports2/Validate/${importTypeId}/${importId}`;
        window.open(url, '_blank');
    };

    self.openEditor = function(entity, options) {
        var config = {html: null, ctrl: null, required: []};
        switch(entity.value) {
            case entities.corporateAction.value:
                config = {
                    html: 'products/editors/corporate-action.html',
                    ctrl: 'CorporateActionCtrl',
                    required: ['corporateAction']
                };
                break;
            default:
                throw 'Invalid Editor Selected';
        }
        config.required.each(function(n){if(!options[n]) throw "Required argument not provided"});
        options = $q.all(angular.extend({
            app: apps.confirmation.name
        }, options));
        return $dialog.editor(config.html, config.ctrl, {args: function (){return options;} }).open();
    };

    self.openMassEditor = function (entity, entityItems, appName, extraInfo) {
        var d = $dialog.editor('app/modals/massUpdate.html', 'MassUpdateCtrl', {
            args: function () {
                return { items: entityItems, entity: entity, app: appName, extraInfo: extraInfo };
            }
        });
        return d.open().then(function (rslt) {
            if (rslt) {
                return rslt;
            } else {
                return $q.reject();
            }
        });
    };

    self.customSearch = function (defaultEntity, entityTypes, title, dateRange) {
        var dialogOpts = {
            backdrop: true,
            keyboard: true,
            backdropClick: true,
            templateUrl: 'app/modals/search.html',
            controller: 'SearchCtrl',
            defaultPane: defaultEntity,
            panes: entityTypes,
            title: title,
            dateRange: dateRange || false
        };

        return $dialog.dialog(dialogOpts).open();
    };

    self.search = function (defaultEntity, dateRange) {
        return self.customSearch(defaultEntity, [entities.corporateAction.value], 'Find Corporate Action', dateRange);
    };

    self.cleanupLocalStorage = function() {
        let existingStorage = localStorage.getItem(confirmOverviewFileIdsSessionKey);

        if (existingStorage) {
            existingStorage = JSON.parse(existingStorage);
            if (existingStorage.length > 0) {
                // If a user opened more than 100 files within 12 hours, then remove the first opened one so we stay within 100 files when adding the new item
                if (existingStorage.length >= 100) {
                    existingStorage.splice(0, 1);
                }

                // 12 hours ago
                let expirationDate = new Date( Date.now() - (1000 * 60 * 60 * 12));
                for (let i = existingStorage.length - 1; i >= 0; i--) {

                    // Remove any confirmoverview file ids that are over 12 hours old from localstorage to tidy up
                    if (new Date(existingStorage[i].dateAdded) < expirationDate) {
                        existingStorage.splice(i, 1);
                    }
                }
                
                try {
                    localStorage.setItem(confirmOverviewFileIdsSessionKey, JSON.stringify(existingStorage));
                } catch {
                    // We have exceeded the local storage limit, wipe out our ConfirmOverview FileIDs to be extremely safe
                    existingStorage = [];
                    localStorage.setItem(confirmOverviewFileIdsSessionKey, JSON.stringify(existingStorage));
                }
            }
        }
    };

    self.getConfirmOverviewFileIdsStorage = function() {
        let existingStorage = localStorage.getItem(confirmOverviewFileIdsSessionKey);
        if (existingStorage) {
            existingStorage = JSON.parse(existingStorage);
        } else {
            existingStorage = [];
        }

        return existingStorage;
    };
    
    self.addConfirmOverviewFileIdToStorage = function(fileIdHash, files) {
        //Get existing storage array
        let existingStorage = self.getConfirmOverviewFileIdsStorage();

        let fileIdsObj = files.reduce((alClientObj, obj) => {
            const key = obj['alClientId'];
            if (!alClientObj[key]) {
                alClientObj[key] = [];
            }
            alClientObj[key].push(obj['downloadFileId']);
            return alClientObj;
        }, {});
        
        let sessionObj = {
            fileIdList: JSON.stringify(fileIdsObj),
            fileIdHash: fileIdHash,
            dateAdded: new Date(Date.now())
        };
        existingStorage.push(sessionObj);

        try {
            localStorage.setItem(confirmOverviewFileIdsSessionKey, JSON.stringify(existingStorage));
        } catch {
            // We have exceeded the local storage limit, wipe out our ConfirmOverview FileIDs to be extremely safe
            existingStorage = [sessionObj];
            localStorage.setItem(confirmOverviewFileIdsSessionKey, JSON.stringify(existingStorage));
        }
    }
});

app.service('$globalExclusion', function $globalExclusion($http, ConfirmationOverview) {
    var self = this;
    var actionResourceBase = '/Confirm/Exclusions/CommonExclusions/Actions/';

    self.loadItem = (id) => {
        return $http.get(`/Confirm/Exclusions/CommonExclusions/${id}`, { trackerMsg: "Loading exclusion" })
            .then((response) => {
                self.current.item = response.data;
            });
    }

    self.createItem = (item) => {
        return $http.post(`${actionResourceBase}Create`, item, { trackerMsg: "Saving new exclusion" });
    }

    self.saveItem = (item) => {
        return $http.put(`${actionResourceBase}Update/${item.id}`, item, { trackerMsg: "Updating exclusion" });
    }

    self.deleteItems = (item) => {
        return $http.put(`${actionResourceBase}Delete`, item, { trackerMsg: "Deleting exclusion(s)" });
    }

    self.newItem = () => {
        return { downloadFormatId: null, recordTypeKey: null, recordTypeDisplay: null, cusip: null, ticker: null, excludeCommondCustodian: false, id: 0 };
    }

    self.loadFormats = () => {
        return ConfirmationOverview.confirm.getDownloadFormats();
    }

    self.recordTypes = () => {
        return [
            { name: "Price", id: 3 },
            { name: "Security", id: 8 }
        ];
    }

    self.current = {
        item: self.newItem(),
    }
});
'use strict';

app.service('$reconServicesHelper', function $reconServicesHelper($http, $userMessages, $timeout, $dialog) {
    var self = this;
    const maxSameDataCount = 200;
    const maxErrorCount = 25;
    const pollingIntervalMS = 5000;
    const errorPollingIntervalMS = 2000;

    self.confirmOverviewPollingUniversal = function (response, ids, $scope, $rootScope) {
        var lastData;
        var sameDataCount = 0;
        var errorCount = 0;
        var totalItems = (response.correlationIds ? response.correlationIds.length : 0) + 
                         (response.batchProcessingIds ? response.batchProcessingIds.length : 0);
        var progress = { completed: 0, total: totalItems };
        $rootScope.$broadcast('event:progress-update', progress);
        var pollStatus = function (response) {
            if (!checkStatusCounts(sameDataCount, errorCount, "Session")) {
                return;
            }

            var postData = response;
            var completedCount = 0;
            
            $http.post("/Confirm/Overview/CheckStatus/universal", postData, { ignoreExceptions: true })
                .then(function (response) {
                    completedCount = 0;
                    var failedBatchProcessings = [];
                    if (response.data != null && response.data.length > 0) {
                        response.data.forEach((batchProcessing) =>
                        {
                            if (batchProcessing.isDone) {
                                completedCount++;
                                if (batchProcessing.status == "Failed") {
                                    failedBatchProcessings.push(batchProcessing);
                                }
                            }
                        });
                    }

                    var progress = { completed: completedCount, total: totalItems };
                    lastData = response

                    if (completedCount == totalItems) {
                        progress.isDone = true;
                        $http.put("/confirm/overview/action/refreshdata", ids, { trackerMsg: 'Refreshing rows' })
                            .then(function (r) {
                                $scope.$broadcast('event:confirm-overview-action', { action: 'update-items', items: r.data });
                                $rootScope.$broadcast('event:progress-update', progress);
                            });

                        if (failedBatchProcessings.length > 0) {
                            var errorString = "";
                            failedBatchProcessings.forEach((failedBatchProcessing) => {
                                errorString += `pkBatchProcessing: ${failedBatchProcessing.id}<br/>Status: ${failedBatchProcessing.status}<br/>Message: <br/>${failedBatchProcessing.message}" <br/><hr/><br/>` 
                            });
                            $dialog.actionFailed(errorString).open();
                        }
                        return;
                    }

                    $rootScope.$broadcast('event:progress-update', progress);
                    sameDataCount += 1;
                    $timeout(function () { pollStatus(postData); }, pollingIntervalMS);
                    return;
                })
                .catch(function () {
                    errorCount += 1;
                    $timeout(function () { pollStatus(postData); }, errorPollingIntervalMS);
                });
        };

        pollStatus(response);
    }

    function checkStatusCounts(sameDataCount, errorCount, correlationId) {
        if (sameDataCount > maxSameDataCount) {
            $rootScope.$broadcast('event:progress-update', { id: correlationId, isDone: true, msg: correlationId + ": Status updates aborted", type: "warning" });
            $userMessages.addConfirmationMsg(parentId + ": Took too long", "The process is taking longer than expected.  Status polling has been aborted.", "warning");
            return false;
        }

        if (errorCount > maxErrorCount) {
            if (parentId) $rootScope.$broadcast('event:progress-update', { id: correlationId, isDone: true, msg: correlationId + ": Status updates aborted", type: "warning" });
            $userMessages.addConfirmationMsg(parentId + ": Status polling failed", "The status check has erred out" + maxErrorCount + " times.  Status polling has been aborted.", "warning");
            return false;
        }

        return true;
    }

    self.getIsMultiUndoEnabled = function ($scope) {
        var enabled = false;
        $http.get('/Settings/Database/EntityOptions/Code/69UNDOMULTIPLE')
            .then(function (response) {
                enabled = response.data.value.toLocaleLowerCase() === "true";
                $scope.current.isMultiUndoEnabled = enabled;
            });
    }
});
'use strict';

app.service('CorporateAction', function CorporateAction($http, $q, $oasRights, $location, $dialog, $settings, entities, processStatus, roundingType, roundingTypeV2, transactionSyncStatus, Repo, $confirmation, taskType, corpActionTaskQueueStatus) {
    var self = this;

    const rights = {
        corporateAction: $oasRights.forCode("CORPACTION"),
        corporateActionDashboard: $oasRights.forCode("CORPACTIONDASH"),
        corpActionProcessingDelete: $oasRights.forCode("CORPACTIONPROCESSINGDELETE"),
        corporateActionsV2Skip: $oasRights.forCode("CORPACTIONV2SKIP"),
        globalProducts: $oasRights.forCode("GLOBALPRODUCT"),
        globalPrices: $oasRights.forCode("PRICES")
    };

    var defaults = {
        process: {
            id: 0,
            corporateProcessingTypeId: null,
            processStatus: 'New',
            mergeOutRatio: null,
            roundingType: 'Normal',
            expectedClose: null,
            isHeld: false,
            isVerified: false,
            IsBeginningOfDay: false
        }
    };

    var endpoints = {
        corporateAction: {
            get: Repo.endpoint({
                /**
                 * @param {Number} id
                 * @return {CorporateActionDto}
                 */
                path: '/Global/CorporateActions/{id:int}',
                verb: 'GET',
                message: 'Loading Corporate Action',
            }),
            getAll: Repo.endpoint({
                /**
                 * @return {CorporateActionDto|Array}
                 */
                path: '/Global/CorporateActions',
                verb: 'GET',
                message: 'Loading Corporate Actions'
            }),
            save: Repo.endpoint({
                /**
                 * @param {Number} key
                 * @return {CorporateActionDto}
                 */
                path: '/Global/CorporateActions/{id:int}',
                verb: 'PUT',
                message: 'Saving Corporate Action'
            }),
            create: Repo.endpoint({
                /**
                 * @return {CorporateActionDto}
                 */
                path: '/Global/CorporateActions',
                verb: 'POST',
                message: 'Creating Corporate Action'
            }),
            delete: Repo.endpoint({
                /**
                 * @param {Number} id
                 * @return {CorporateActionDto}
                 */
                path: '/Global/CorporateActions/{id:int}',
                verb: 'DELETE',
                message: 'Deleting Corporate Action'
            }),
            newVerbose: Repo.endpoint({
                /**
                 * @param {String} expand
                 * @return {CorporateActionVerboseDto}
                 */
                path: '/Global/CorporateActions/Verbose/New',
                params: {expand: 'All'},
                verb: 'GET',
                message: 'Generating empty Corporate Action'
            }),
            createVerbose: Repo.endpoint({
                /**
                 * @param {String} expand
                 * @return {CorporateActionVerboseDto}
                 */
                path: '/Global/CorporateActions/Verbose',
                verb: 'POST',
                message: 'Creating Corporate Action'
            }),
            saveVerbose: Repo.endpoint({
                /**
                 * @param {String} expand
                 * @return {CorporateActionVerboseDto}
                 */
                path: '/Global/CorporateActions/Verbose/{id:int}',
                verb: 'PUT',
                message: 'Saving Corporate Action'
            }),
            getProcesses: Repo.endpoint({
                /**
                 * @param {Number} corporateActionId
                 * @return {CorpActionProcessingDto|Array}
                 */
                path: '/Global/CorporateActions/Processing',
                verb: 'GET',
                message: 'Loading Corporate Action Processes'
            })
        },
        corporateActionProcessing: {
            get: Repo.endpoint({
                /**
                 * @param {Number} key
                 * @return {CorpActionProcessingDto}
                 */
                path: '/Confirm/CorporateAction/Processing/{key:int}',
                verb: 'GET',
                message: 'Loading Corporate Action Process'
            }),
            getAll: Repo.endpoint({
                /**
                 * @return {CorpActionProcessingDto|Array}
                 */
                path: '/Confirm/CorporateAction/Processing',
                verb: 'GET',
                message: 'Loading Corporate Action Processes'
            }),
            getAllDetail: Repo.endpoint({
                /**
                 * @return {CorpActionProcessingDto|Array}
                 */
                path: '/Confirm/CorporateAction/Processing/Detail',
                verb: 'GET',
                message: 'Loading Corporate Action Processes'
            }),
            getStatus: Repo.endpoint({
                /**
                 * @param {Number|Array} processingIds
                 * @return {CorpActionProcessingStatusDto|Array}
                 */
                path: '/Confirm/CorporateAction/Processing/Status',
                verb: 'GET',
                message: 'Loading Processes Status'
            }),
            save: Repo.endpoint({
                /**
                 * @param {Number} id
                 * @return {CorpActionProcessingDto}
                 */
                 path: '/Confirm/CorporateAction/Processing/{id:int}',
                verb: 'PUT',
                message: 'Saving Corporate Action Process'
            }),
            saveDetail: Repo.endpoint({
                /**
                 * @param {Number} id
                 * @return {CorpActionProcessingDto}
                 */
                path: '/Confirm/CorporateAction/Processing/Detail/{id:int}',
                verb: 'PUT',
                message: 'Saving Corporate Action Process'
            }),
            processTask: Repo.endpoint({
                /**
                 * @param {Number} id
                 * @return {CorpActionProcessingDto}
                 */
                path: '/Confirm/CorporateAction/Processing/{id:int}/Action/ProcessTask',
                verb: 'PUT',
                message: 'Processing Corporate Action Task'
            }),
            delete: Repo.endpoint({
                /**
                 * @param {Number} id
                 * @return {Null}
                 */
                path: '/Confirm/CorporateAction/Processing/{id:int}',
                verb: 'DELETE',
                message: 'Deleting Corporate Action Processing Record'
            })
        },
        corporateActionProcessingType: {
            getAll: Repo.endpoint({
                /**
                 * @return {CorpActionProcessingTypeDto|Array}
                 */
                path: '/Confirm/CorporateAction/ProcessingType',
                verb: 'GET',
                message: 'Loading Corporate Action Processing Type'
            }),
        },
        corporateActionTransaction: {
            getAllV2: Repo.endpoint({
                /**
                 * @return {CorpActionTransactionV2Dto|Array}
                 */
                path: '/Confirm/CorporateAction/Transactions/V2',
                verb: 'GET',
                message: 'Loading Corporate Action Transactions'
            }),
            massUpdate: {
                put: Repo.endpoint({
                    path: '/Portfolio/Transactions/CorporateAction/List',
                    verb: 'PUT',
                    message: 'Saving Transactions'
                }),
                get: Repo.endpoint({
                    path: '/Portfolio/Transactions/List/Id',
                    verb: 'POST',
                    message: 'Loading Transactions'
                })
            }
        },
        
    };

    // PRIVATE METHODS

    // PUBLIC VARIABLES
    self.rights = rights;
    self.default = defaults;
    self.processingTypes = [];
    self.errors = [];
    self.processStatus = processStatus.values();
    self.taskType = taskType.values();
    self.taskQueueStatus = corpActionTaskQueueStatus.values(),
    self.roundingType = roundingTypeV2.values();
    self.transactionSyncStatus = transactionSyncStatus.values();

    // PUBLIC ENDPOINTS
    self.corporateAction = endpoints.corporateAction;
    self.processingRecord = endpoints.corporateActionProcessing;
    self.processingType = endpoints.corporateActionProcessingType;
    self.transaction = endpoints.corporateActionTransaction;

    // PUBLIC METHODS

    self.statusDetail = function (status, field) {
        return self.processStatus.find(function(s) { return s[field || 'name'] == status });
    };

    self.taskDetail = function(task, field) {
        return self.taskType.find(function(t) { return t[field || 'name'] == task });
    }

    self.goToCorporateActionTransactions = $confirmation.goToCorporateActionTransactions;

    self.openMassEditor = function (entity, entityIds, appName, extraInfo) {
        var d = $dialog.editor('app/modals/massUpdate.html', 'MassUpdateCtrl', {
            args: function () {
                return {ids: entityIds, entity: entity, app: appName, extraInfo: extraInfo};
            }
        });
        return d.open().then(function (rslt) {
            if (rslt) {
                return rslt;
            }
        });
    };
});
'use strict';

app.service('AccountComposer', function AccountComposer($http, $q, $oasRights, $location, $dialog, $settings, entities, roundingType, transactionSyncStatus, alternativeCommitmentType, $confirmation, Repo) {
    var service = this;

    // PRIVATE VARIABLES
    var endpoints = {
        setting: {
            getErrorCheckDays: Repo.endpoint({
                /**
                 * @return AppOptionDto
                 */
                path: '/Settings/Apps/accountComposer/Options/errorCheckDays',
                verb: 'GET',
                message: 'Loading Account Composer Settings: Error Check Days'
            }),
            getRefreshThreshold: Repo.endpoint({
                /**
                 * @return AppOptionDto
                 */
                path: '/Settings/Apps/accountComposer/Options/refreshThreshold',
                verb: 'GET',
                message: 'Loading Account Composer Settings: Refresh Threshold'
            })
        },
        heldAwayAsset: {
            getAll: Repo.endpoint({
                /**
                 * @param   accountId       <int>
                 * @param   startDate       <date>
                 * @param   endDate         <date?>
                 * @return  HeldAwayAssetDto[]
                 */
                path: '/Confirm/HeldAway/Assets',
                verb: 'GET',
                message: 'Loading Assets'
            }),
            getAssetValueConfirmError: Repo.endpoint({
                /**
                 * @param   accountId       <int>
                 * @param   assetId         <int>
                 * @param   startDate       <date>
                 * @param   endDate         <date?>
                 * @return  HeldAwayAssetValueWithErrorDto[]
                 */
                path: '/Confirm/HeldAway/AssetValueConfirmError',
                verb: 'GET',
                message: 'Loading Performance'
            }),
            getTransactions: Repo.endpoint({
                /**
                 * @param   accountId       <int>
                 * @param   assetId         <int>
                 * @param   startDate       <date>
                 * @param   endDate         <date?>
                 * @return  HeldAwayTransactionithErrorDto[]
                 */
                path: '/Confirm/HeldAway/Transactions',
                verb: 'GET',
                message: 'Loading Transactions'
            }),
            markAcceptable: Repo.endpoint({
                /**
                 * @param   acceptable  <bool>
                 * @param   note        <string>
                 */
                path: '/Confirm/HeldAway/Action/AcceptableConfirmError',
                params: {acceptable: true},
                verb: 'PUT',
                message: 'Marking Acceptable'
            }),
            removeAcceptable: Repo.endpoint({
                /**
                 * @param   acceptable  <bool>
                 * @param   note        <string>
                 */
                path: '/Confirm/HeldAway/Action/AcceptableConfirmError',
                params: {acceptable: false},
                verb: 'PUT',
                message: 'Removing Acceptable'
            }),
            updateExcludeFromPositionOnly: Repo.endpoint({
                /**
                 * @param   accountId                   <int>
                 * @param   excludedFromPositionOnly    <bool>
                 */
                path: '/Confirm/HeldAway/Action/UpdateExcludedFromPositionOnly',
                verb: 'POST',
                message: 'Updating Position Only Exclusion'
            }),
            refreshConfirmErrors: Repo.endpoint({
                /**
                 * @param   accountList                 <int>?
                 */
                path: '/Confirm/HeldAway/Action/RefreshConfirmErrors',
                verb: 'POST',
                message: 'Refreshing Confirm Errors'
            })
        },
        heldAwayAccount: {
            getSimple: Repo.endpoint({
                /**
                 * @param   id  <int>
                 * @return  AccountSimpleDto
                 */
                path: '/Portfolio/Accounts/{key:int}/Simple',
                verb: 'GET',
                message: 'Loading Account'
            }),
            getAll: Repo.endpoint({
                /**
                 * @param   startDate       <date>
                 * @param   endDate         <date?>
                 * @return  HeldAwayAssetDto[]
                 */
                path: '/Confirm/HeldAway/Accounts',
                verb: 'GET',
                message: 'Loading Accounts'
            })
        },
        accounts: {
            getSimple: Repo.endpoint({
                path: '/Portfolio/Accounts/{id:int}/Simple',
                verb: 'GET',
                message: 'Loading the account'
            })
        },
        products: {
            getSimple: Repo.endpoint({
                path: '/Portfolio/Products/Simple/{id:int}',
                verb: 'GET',
                message: 'Loading the product'
            })
        },
        transactions: {
            getAll: Repo.endpoint({
                path: '/Portfolio/Transactions',
                verb: 'GET',
                message: 'Loading transactions'
            }),
            getAllVerbose: Repo.endpoint({
                path: '/Portfolio/Transactions/Verbose',
                verb: 'GET',
                message: 'Loading transactions'
            }),
            getList: Repo.endpoint({
                path: '/Portfolio/Transactions/List',
                verb: 'POST',
                message: 'Loading transactions'
            }),
            getListVerbose: Repo.endpoint({
                path: '/Portfolio/Transactions/Verbose/List',
                verb: 'POST',
                message: 'Loading transactions'
            }),
            deleteList: Repo.endpoint({
                path: '/Portfolio/Transactions/Action/Delete',
                verb: 'PUT',
                message: 'Removing transactions'
            }),
            saveListVerbose: Repo.endpoint({
                path: '/Portfolio/Transactions/Verbose',
                verb: 'PUT',
                message: 'Saving transactions'
            }),
            createListVerbose: Repo.endpoint({
                path: '/Portfolio/Transactions/Verbose/New',
                verb: 'POST',
                message: 'Creating transactions'
            }),
            upsertAlternativeListVerbose: Repo.endpoint({
                path: '/Portfolio/Transactions/Verbose/Alternative/List',
                verb: 'POST',
                message: 'Saving alternative transactions'
            }),
            deleteAlternativeList: Repo.endpoint({
                path: '/Portfolio/Transactions/Action/Delete',
                verb: 'PUT',
                message: 'Removing alternative transactions'
            })
        },
        assets: {
            get: Repo.endpoint({
                path: '/Portfolio/Assets/{id:int}',
                verb: 'GET',
                message: 'Loading the asset'
            }),
            getVerbose: Repo.endpoint({
                path: '/Portfolio/Assets/Verbose/{id:int}',
                verb: 'GET',
                message: 'Loading the asset'
            }),
            getVerboseByProduct: Repo.endpoint({
                path: '/Portfolio/Assets/Verbose/ByProduct/{id:int}',
                verb: 'GET',
                message: 'Loading the asset'
            }),
            copyHistoricalAsset: Repo.endpoint({
                path: '/Portfolio/Assets/Verbose/CopyHistoricalData',
                verb: 'GET',
                message: 'Getting asset historical data'
            }),
            save: Repo.endpoint({
                path: '/Portfolio/Assets/{id:int}',
                verb: 'PUT',
                message: 'Saving the asset'
            }),
            saveVerbose: Repo.endpoint({
                path: '/Portfolio/Assets/Verbose/{id:int}',
                verb: 'PUT',
                message: 'Saving the asset'
            }),
            create: Repo.endpoint({
                path: '/Portfolio/Assets',
                verb: 'POST',
                message: 'Creating a new asset'
            }),
            createVerbose: Repo.endpoint({
                path: '/Portfolio/Assets/Verbose',
                verb: 'POST',
                message: 'Creating a new asset'
            }),
            newVerbose: Repo.endpoint({
                path: '/Portfolio/Assets/Verbose/New',
                verb: 'GET',
                message: 'Generating empty asset'
            }),
            moveToAccount: Repo.endpoint({
                path: '/Portfolio/Assets/{id:int}/Action/MoveToAccount/{accountId:int}',
                verb: 'PUT',
                message: 'Moving asset to a different account'
            })
        },
        types: {
            transaction: Repo.endpoint({
                path: '/Trading/TransactionTypes',
                verb: 'GET',
                message: 'Loading transaction types'
            }),
            tradeStatus: Repo.endpoint({
                path: '/Trading/TradeStatuses',
                verb: 'GET',
                message: 'Loading trade status definitions'
            }),
            equityActivity: Repo.endpoint({
                path: '/Confirm/Alternative/Equity/ActivityTypes',
                verb: 'GET',
                message: 'Loading the asset'
            }),
            equityFunding: Repo.endpoint({
                path: '/Confirm/Alternative/Equity/FundingTypes',
                verb: 'GET',
                message: 'Loading the asset'
            }),
            valuationStatus: Repo.endpoint({
                path: '/Confirm/Alternative/Equity/ValuationStatuses',
                verb: 'GET',
                message: 'Loading valuation statuses'
            })
        }
    };
    var defaults = {};
    var rights = {
        corporateAction: $oasRights.forCode("CORPACTION"),
        corporateActionDashboard: $oasRights.forCode("CORPACTIONDASH")
    };
    var globalValuationForPreview = null;
    var globalTransactionForPreview = null;

    // PRIVATE METHODS
    function goTo(path) {
        if (path) $location.url(path);
        else return this;
    }

    angular.extend(goTo, {
        account: function(item) { // account
            var itemId = parseInt(item) || parseInt(item.accountId) || parseInt(item.id);
            if(itemId) service.goTo("/confirmation/alternatives/accounts?accountId={1}".assign(itemId));
            else throw "Route details are missing";
        },
        product: function(item) { // product
            var itemId = parseInt(item) || parseInt(item.productId) || parseInt(item.id);
            if(itemId) service.goTo("/confirmation/alternatives/products?productId={1}".assign(itemId));
            else throw "Route details are missing";
        },
        assetHistory: function(item) { // asset
            var itemId = parseInt(item) || parseInt(item.assetId) || parseInt(item.id);
            if(itemId) service.goTo("/confirmation/alternatives/assethistory?assetId={1}".assign(itemId));
            else throw "Route details are missing";
        },
        transactions: function(item) { // asset
            var itemId = parseInt(item) || parseInt(item.assetId) || parseInt(item.id);
            if(itemId) service.goTo("/confirmation/alternatives/transactions?assetId={1}".assign(itemId));
            else throw "Route details are missing";
        },
        taxCenter: function(item) { // asset
            var itemId = parseInt(item) || parseInt(item.assetId) || parseInt(item.id);
            if(itemId) service.goTo("/tax/orionunrealized?entity=8&entityId={1}".assign(itemId));
            else throw "Route details are missing";
        }
    });


    function groupAssets( assets ) {
        var ret = {
            assetsByTicker: [],
            assetsByDate: []
        };

        if( assets && assets.length > 0 ) {
            var tickers = assets.groupBy("id");
            for( var prop in tickers ) {
                if(!tickers.hasOwnProperty(prop)) continue;

                var asset = { id: 0, productName: '', ticker: '', transactionErrorCount: 0, performanceErrorCount: 0, excludedFromPositionOnly: null };
                if( tickers[prop] && tickers[prop].length > 0 ) {
                    for( var i = 0; i < tickers[prop].length; i++ ) {
                        if( tickers[prop][i].transactionError ) asset.transactionErrorCount++;
                        if( tickers[prop][i].performanceError ) asset.performanceErrorCount++;
                    }
                }
                asset.id = tickers[prop][0].id;
                asset.ticker = tickers[prop][0].ticker;
                asset.productName = tickers[prop][0].productName;
                asset.excludedFromPositionOnly = tickers[prop][0].excludedFromPositionOnly == true;
                ret.assetsByTicker.push( asset );
            }

            var dates = assets.groupBy( "errorDate" );
            for( var prop in dates ) {
                if(!dates.hasOwnProperty(prop)) continue;

                var date = { errorDate: prop, errorCount: 0, transactionErrorCount: 0, performanceErrorCount: 0 };
                if( dates[prop] && dates[prop].length > 0 ) {
                    for( var i = 0; i < dates[prop].length; i++ ) {
                        if( dates[prop][i].transactionError ) date.transactionErrorCount++;
                        if( dates[prop][i].performanceError ) date.performanceErrorCount++;
                    }
                }
                ret.assetsByDate.push( date );
            }
        }
        return ret;
    }

    function openMassEditor (entity, entityIds, appName, extraInfo) {
        return $dialog.editor('app/modals/massUpdate.html', 'MassUpdateCtrl', {
            args: function () {
                return {ids: entityIds, entity: entity, app: appName, extraInfo: extraInfo};
            }
        }).open().then(function (rslt) {
            if (rslt) {
                return rslt;
            }
        });
    }

    // PUBLIC VARIABLES
    service.rights = rights;
    service.default = defaults;
    service.processingTypes = [];
    service.errors = [];
    service.roundingType = roundingType.values();
    service.transactionSyncStatus = transactionSyncStatus.values();
    service.ledgerTypes = alternativeCommitmentType.values();
    service.globalValuationForPreview = globalValuationForPreview;
    service.globalTransactionForPreview = globalTransactionForPreview;

    // PUBLIC ENDPOINTS
    service.setting = endpoints.setting;
    service.heldAwayAsset = endpoints.heldAwayAsset;
    service.heldAwayAccount = endpoints.heldAwayAccount;
    service.assets = endpoints.assets;
    service.accounts = endpoints.accounts;
    service.products = endpoints.products;
    service.transactions = endpoints.transactions;
    service.types = endpoints.types;

    // PUBLIC METHODS
    service.openMassEditor = openMassEditor;
    service.groupAssets = groupAssets;
    service.goTo = goTo;
});
'use strict';

app.service('ConfirmationOverview', function ConfirmationOverview($http, $q, $oasRights, $location, $dialog, $settings, entities, processStatus, roundingType, transactionSyncStatus, $confirmation, Repo) {
    var self = this;

    // PRIVATE VARIABLES
    var endpoints = {
        overview: {
            reprocessFiles: Repo.endpoint({
                path: '/Confirm/Overview/Action/ReprocessFiles',
                verb: 'PUT',
                message: 'Reprocessing files'
            }),
            newReprocessFiles: Repo.endpoint({
                path: '/Confirm/Overview/Action/ReprocessFiles/NewConfirmReprocessHandling',
                verb: 'PUT',
                message:'Reprocessing files'
            })
        },
        databases: {
            getAll: Repo.endpoint({
                path: '/Authorization/Databases',
                cache: true,
                verb: 'GET',
                message: 'Loading Databases'
            })
        },
        confirm: {
            getRecordTypes: Repo.endpoint({
                path: '/Confirm/RecordTypes/Simple',
                verb: 'GET',
                message: 'Loading download file types'
            }),
            getUploadFormats: Repo.endpoint({
                path: '/Confirm/UploadFormats',
                verb: 'GET',
                message: 'Loading upload formats'
            }),
            getDownloadFormats: Repo.endpoint({
                path: '/Confirm/DownloadFormats/Simple',
                verb: 'GET',
                message: 'Loading download formats'
            }),
            getUploadTargets: Repo.endpoint({
                path: '/Confirm/UploadTargets/Simple',
                verb: 'GET',
                message: 'Loading upload targets'
            }),
            getGroups: Repo.endpoint({
                path: '/Confirm/Groups',
                verb: 'GET',
                message: 'Loading confirmation groups'
            }),
            getSelectedGroup: Repo.endpoint({
                path: '/Settings/UserOptions/confirmation_overview_group',
                params: {defaultValue: 8},
                verb: 'GET',
                message: 'Loading selected confirmation group'
            }),
            updateSelectedGroup: Repo.endpoint({
                path: '/Settings/UserOptions/confirmation_overview_group',
                verb: 'POST',
                message: 'Updating selected confirmation group'
            })
        },
        sources: {
            getVerbose: Repo.endpoint({
                path: '/Confirm/DownloadSources/Verbose/{id:int}',
                verb: 'GET',
                message: 'Loading download source'
            }),
            saveVerbose: Repo.endpoint({
                path: '/Confirm/DownloadSources/Verbose/{id:int}',
                verb: 'PUT',
                message: 'Saving download source'
            }),
            createVerbose: Repo.endpoint({
                path: '/Confirm/DownloadSources/Verbose',
                verb: 'POST',
                message: 'Creating download source'
            }),
            newVerbose: Repo.endpoint({
                path: '/Confirm/DownloadSources/Verbose/New',
                verb: 'GET',
                message: 'Generating empty download source'
            }),
            delete: Repo.endpoint({
                path: '/Confirm/DownloadSources/{id:int}',
                verb: 'DELETE',
                message: 'Deleting download source'
            }),
            deleteMany: Repo.endpoint({
                path: '/Confirm/DownloadSources/List/Delete',
                verb: 'PUT',
                message: 'Deleting download sources'
            })
        },
        files: {
            getAllDetailed: Repo.endpoint({
                path: '/Confirm/DownloadFiles/Details',
                verb: 'GET',
                message: 'Loading files'
            }),
            getAllDetailedPost: Repo.endpoint({
                path: '/Confirm/DownloadFiles/Details',
                verb: 'POST',
                message: 'Loading files'
            }),
            getAllDetailedRecordsBySessions: Repo.endpoint({
                path: '/Confirm/DownloadFiles/Details/Records',
                verb: 'GET',
                message: 'Loading download records'
            }),
            getSleeveColumnData: Repo.endpoint({
                path: '/Confirm/DownloadFiles/SleeveColumnData',
                verb: 'GET',
                message: 'Loading sleeve column data'
            }),
            getDetailed: Repo.endpoint({
                path: '/Confirm/DownloadFiles/Details/{id:int}',
                verb: 'GET',
                message: 'Loading files'
            }),
            transactionFromPosition: Repo.endpoint({
                path: '/Confirm/DownloadFiles/{downloadFileId:int}/Positions/Import',
                verb: 'POST',
                message: 'Creating transaction records'
            }),
            transactionFromPositionByProc: Repo.endpoint({
                path: '/Confirm/DownloadFiles/Positions/CreateTrans',
                verb: 'POST',
                message:'Creating transaction records'
            }),
            createTransactionsFromPosition: Repo.endpoint({
                path: '/Confirm/DownloadFiles/Positions/Transactions',
                verb: 'POST',
                message:'Creating transaction records'
            }),
            resetFile: Repo.endpoint({
                path: '/Confirm/DownloadFiles/Action/ResetPositionFile/{downloadFileId}',
                verb: 'PUT',
                message: 'Running file reset'
            }),
            proper: Repo.endpoint({
                path: '/Confirm/DownloadFiles/{downloadFileId}/Details/Action/Proper?properFlag={properFlag}',
                verb: 'PUT',
                message: 'Running proper'
            }),
            findReplace: Repo.endpoint({
                path: '/Confirm/DownloadFiles/{downloadFileId}/Details/Action/FindReplace',
                verb: 'PUT',
                params: {
                    findString: '',
                    replaceString: '',
                    findReplaceFlag: ''
                },
                message: 'Running find and replace'
            }),
            moveSleeveInactiveDatabase: Repo.endpoint({
                path: '/Trading/Sleeve/Registrations/Action/MoveInactiveValue',
                verb: 'PUT',
                message: 'Running file reset'
            }),
            saveDetailed: Repo.endpoint({
                path: '/Confirm/DownloadFiles/RecordType/{downloadType}/Details',
                verb: 'PUT',
                message: 'Saving files'
            }),
            getDetailedList: Repo.endpoint({
                path: '/Confirm/DownloadFiles/RecordType/{downloadType}/Details/List',
                verb: 'POST',
                message: 'Loading files'
            }),
            getFileImportBatch: Repo.endpoint({
                /***
                 * @param   typeId          <int>       This is the WorkflowTypeId
                 * @return  SimpleEntity[]
                 */
                path: '/Confirm/DownloadFiles/FileImports',
                params: {
                    status: [0, 1, 2, 4],
                    includeErrors: false
                },
                verb: 'GET',
                message: 'Loading import file processes'
            }),
            getFileImportBatchCounts: Repo.endpoint({
                /***
                 * @param   typeId          <int>       This is the WorkflowTypeId
                 * @return  SimpleEntity[]
                 */
                path: '/Confirm/DownloadFiles/FileImports/Counts',
                params: {
                    status: [0, 1, 2, 4],
                    includeErrors: false
                },
                verb: 'GET',
                message: 'Loading import file process counts'
            }),
            manualConfirmDetails: Repo.endpoint({
                path: '/Confirm/DownloadFiles/Action/ConfirmDetails',
                verb: 'PUT',
                message: 'Confirming prices'
            }),
            manualExcludeDetails: Repo.endpoint({
                path: '/Confirm/DownloadFiles/Action/ExcludeDetails',
                verb: 'PUT',
                message: 'Excluding prices'
            }),
            prefix: Repo.endpoint({
                path: '/Confirm/DownloadFiles/{downloadFileId}/Details/Action/Prefix',
                verb: 'PUT',
                message: 'Running prefix',
                params: {
                    prefixString: '',
                    prefixFlag: 32
                }
            })
        },
        exclusions: {
            getAll: Repo.endpoint({
                path: '/Confirm/Exclusions',
                verb: 'GET',
                message: 'Loading exclusions'
            }),
            deleteMany: Repo.endpoint({
                path: '/Confirm/Exclusions/Action/Delete',
                verb: 'PUT',
                message: 'Removing exclusions'
            })
        },
        journaling: {
            createAutoJournal: Repo.endpoint({
                path: '/Trading/Sleeve/Registrations/UpcomingSWP/CreateAutoJournal',
                verb: 'POST',
                message: 'Creating Auto Journal'
            })
        }
    };
    var rights = {
        confirmationOverview: $oasRights.forCode("CONFIRMOVERVIEW"),
        confirmationGroups: $oasRights.forCode("CONFIRMGROUPS"),
        confirmationSignOff: $oasRights.forCode("CONFIRMDASHSIGNOFF"),
        confirmationImport: $oasRights.forCode("CONFIRM_DWNLDFILEOC")
    };

    var defaults = {
        confirmEntities: [
            {id: 1, name: "Database"},
            {id: 0, name: "File Type"},
            {id: 2, name: "Format"},
            {id: 4, name: "Group"},
            {id: 8, name: "Batch Processing"}
        ],
        newAccountCreationValues: [
            {name: 'Default', value: -1},
            {name: 'Dont Create', value: 0},
            {name: 'Create', value: 1},
            {name: 'Auto Exclude', value: 3}
        ],
        fileTypes: [
            {name: 'Corp Action', value: "9"},
            {name: 'Cost Basis', value: "12"},
            {name: 'Dividend', value: "4"},
            {name: 'Name', value: "0"},
            {name: 'Position', value: "1"},
            {name: 'Price', value: "3"},
            {name: 'Security', value: "8"},
            {name: 'Transaction', value: "2"},
            {name: 'Generic', value: "11"}
        ],
        memoCodes: [
            {name: '(None)', code: 0},
            {name: 'Account Number Not Found', code: 300},
            {name: 'Product Not in Common Database', code: 302},
            {name: 'Product Not in Local Database', code: 301},
            {name: 'Transaction Type not Found', code: 313},
            {name: 'Ticker or Cusip does not exist', code: 322}
        ]
    };

    // PRIVATE METHODS

    function goTo(path) {
        if (path) $location.url(path);
        else return this;
    }

    angular.extend(goTo, {
        sourceLogs: function (item) {
            var itemId = item ? parseInt(item) || parseInt(item.downloadSourceId) || parseInt(item.id) : null;
            self.goTo("/confirmation/sources/logs/" + (itemId ? "?downloadSourceId={1}".assign(itemId) : ""));
        }
    });

    // PUBLIC VARIABLES
    self.rights = rights;
    self.default = defaults;

    // PUBLIC ENDPOINTS
    self.databases = endpoints.databases;
    self.confirm = endpoints.confirm;
    self.files = endpoints.files;
    self.exclusions = endpoints.exclusions;
    self.journaling = endpoints.journaling;
    self.sources = endpoints.sources;
    self.overview = endpoints.overview;

    // PUBLIC METHODS
    self.goTo = goTo;

});
'use strict';

app.service('InterfaceSetup', function InterfaceSetup($http, $q, $oasRights, $location, $dialog, $settings, entities, processStatus, roundingType, transactionSyncStatus, $confirmation, Repo) {
    var self = this;

    // PRIVATE VARIABLES
    var endpoints = {
        processManager: {
            actionTypes: {
                get: Repo.endpoint({
                    /***
                     * @param   typeId          <int>       This is the WorkflowTypeId
                     * @return  SimpleEntity[]
                     */
                    path: '/Reporting/ProcessManager/ActionTypes',
                    //params: {defaultValue: 8},
                    verb: 'GET',
                    message: 'Loading action types'
                })
            }
        }
    };

    var rights = {
        confirmationOverview: $oasRights.forCode("CONFIRMOVERVIEW"),
    };

    var defaults = {};
    // PRIVATE METHODS

    // PUBLIC VARIABLES
    self.rights = rights;
    self.default = defaults;

    // PUBLIC ENDPOINTS
    self.confirm = endpoints.confirm;

    // PUBLIC METHODS

});
'use strict';

app.service('DataAudit', function DataAudit($http, $q, $oasRights, $location, $dialog, $settings, entities, processStatus, roundingType, transactionSyncStatus, $confirmation, Repo) {
    var self = this;

    // PRIVATE VARIABLES
    var endpoints = {
        databases: {
            getAll: Repo.endpoint({
                path: '/Authorization/Databases',
                cache: true,
                verb: 'GET',
                message: 'Loading Databases'
            })
        },
        confirmGroup: {
            getAll: Repo.endpoint({
                path: '/Confirm/Groups',
                verb: 'GET',
                message: 'Loading confirmation groups'
            }),
            getDataQueries: Repo.endpoint({
                path: '/Confirm/Groups/{confirmGroupId:int}/DataQueries',
                verb: 'GET',
                message: 'Loading confirmation group queries'
            }),
            getDataQuery: Repo.endpoint({
                path: '/Confirm/Groups/{confirmGroupId:int}/DataQueries/{customReportId:int}',
                verb: 'GET',
                message: 'Loading confirmation group queries'
            }),
            saveDataQuery: Repo.endpoint({
                path: '/Confirm/Groups/{confirmGroupId:int}/DataQueries/{customReportId:int}',
                verb: 'POST',
                message: 'Saving confirmation group queries'
            }),
            saveDataQueries: Repo.endpoint({
                path: '/Confirm/Groups/{confirmGroupId:int}/DataQueries/List',
                verb: 'POST',
                message: 'Loading confirmation group queries'
            }),
            deleteDataQuery: Repo.endpoint({
                path: '/Confirm/Groups/{confirmGroupId:int}/DataQueries/{customReportId:int}',
                verb: 'DELETE',
                message: 'Deleting confirmation group queries'
            })
        },
        dataQuery: {
            get: Repo.endpoint({
                path: '/Reporting/Custom/{key:int}',
                params: {interpolate: false},
                verb: 'GET',
                message: 'Getting data query'
            }),
            getFullList: Repo.endpoint({
                path: '/Reporting/Custom/Full/List',
                params: {interpolate: false},
                verb: 'POST',
                message: 'Getting data query list'
            })
        }
    };
    var rights = {
        confirmationGroups: $oasRights.forCode("CONFIRMGROUPS"),
    };

    var defaults = {
        dataQueryPrompt: {
            id: 0,
            code: '',
            prompt: '',
            promptDescription: '',
            promptType: 'Text',
            defaultValue: '',
            isPromptUser: true
        }
    };
    // PRIVATE METHODS

    // PUBLIC VARIABLES
    self.rights = rights;
    self.default = defaults;

    // PUBLIC ENDPOINTS
    self.databases = endpoints.databases;
    self.confirm = endpoints.confirm;
    self.files = endpoints.files;
    self.exclusions = endpoints.exclusions;
    self.dataQuery = endpoints.dataQuery;

    // PUBLIC METHODS
    self.selectDataQuery = function() {
        return $confirmation.customSearch(entities.dataQuery.value, [entities.dataQuery.value], "Attach " + entities.dataQuery.name);
    };

    self.addConfirmGroupDataQuery = function(entity) {
        if(entity == undefined || !(entity.ConfirmGroupId > 0)) return $dialog.actionFailed("Confirm Group is not provided.").open();
        return $q.resolve(
            entity.CustomReportId ||
            $confirmation.customSearch(entities.dataQuery.value, [entities.dataQuery.value], "Attach " + entities.dataQuery.name).then(function(result){
                if(result) return entity.CustomReportId = result.item.id;
                else return $q.reject();
            })
        ).then(function(){
            return endpoints.confirmGroup.saveDataQuery({data: entity, params: {confirmGroupId: entity.ConfirmGroupId, customReportId: entity.CustomReportId}})
        })
    };

});
'use strict';

app.service('orionVisionSSO', function orionVisionSSO(API_CONFIG) {
    const self = this;
    
    // PRIVATE METHODS
    self.goTo = function(){
        window.open(constructUrl(), '_blank');
    }

    self.getUrl = function(oas_token, incomplete = false){
        return constructUrl(oas_token, incomplete);
    }

    function constructUrl(oas_token, incomplete = false){
        const token = oas_token || sessionStorage.oas_token
        
        return 'http://' + window.location.host + API_CONFIG.baseUrl +'/Integrations/Vision/SSO/?Authorization='+ token + '&showIncomplete=' + incomplete;
    }


});

app.service('$confirmDownloadOptionService', function $confirmation() {
    var self = this;
    self.parseOption = function (option) {

        if (option.Type === "dropdown" ) {
            if (option.ArrayValue && typeof option.ArrayValue === 'string') {
                option.ArrayValue = JSON.parse(option.ArrayValue);
            }
        }
        if (option.Type === "number") {
            if (option.Value != null && typeof option.Value === 'string') {
                if (option.Value === "") {
                    option.Value = null;
                } else
                {
                    option.Value = parseInt(option.Value);
                }
            }
        }
        else if (option.Type === "checkbox_dropdown") {
            if (option.Value == null || option.Value == '') {
                option.Value = [];
            } else if(!Array.isArray(option.Value)) {
                option.Value = option.Value.split(',');
            }

            if (option.ArrayValue && typeof option.ArrayValue === 'string') {
                option.ArrayValue = JSON.parse(option.ArrayValue)
            }
        }

        return option;
    };
    

    
    self.serializeOption = function (option) {
        if (option.ArrayValue != null && Array.isArray(option.ArrayValue)) {
            option.ArrayValue = angular.toJson(option.ArrayValue);
        }

        if (option.Value == null) {
            return option;
        }
        else if (option.Type == "checkbox_dropdown" && option.Value != null && Array.isArray(option.Value)) {
            option.Value = option.Value.join(",");
        }
        else if (option.Type === "number") {
            
            option.Value = option.Value.toString();
        }
        else if (option.Type === "dropdown") {
            option.Value = option.Value.toString();
        }
        return option;
    }
})
'use strict';

app.controller('DownloadMapListCtrl', function DownloadMapListCtrl($scope, $http, $oasRights, views, $dialog, ConfirmationOverview, $timeout, $q) {
    // PRIVATE VARIABLES
    const transactionTypeTable = 'TransactionType';
    // local only tables
    const fundFamilyExcludeTable = 'FundFamilyExclude';
    const repTable = 'Rep';
    const repAutoExcludeTable = 'RepAutoExclude';
    const modelNameTable = 'ModelName';
    const costBasisMethod = 'CostBasisMethod';

    var selected = {};
    var optionsCache = {};

    // Setup all the mapping levels and what each of them means
    // These should match the Enum OAT.DataModel.Confirm.Enums.DownloadMappingLevel, but currently that enum got unmapped/removed from being used
    const localAssignedSource = 'Local - Assigned Source';
    const localCurrentDatabase = 'Local - Current Database';
    const localSubFormatType = 'Local - Sub-Format';

    const commonAllDatabases = 'Common - All Databases';
    const commonSubFormatType = 'Common - Sub-Format';

    const localAssignedSourceMapping = { name: localAssignedSource, priority: 1, isCommon: false, isDownloadFormatSubType: false, isDownloadSourceVisible: true, isDownloadSourceEditable: true };
    const localCurrentDatabaseMapping = { name: localCurrentDatabase, priority: 2, isCommon: false, isDownloadFormatSubType: false, isDownloadSourceVisible: true, isDownloadSourceEditable: false };
    const localSubFormatTypeMapping = { name: localSubFormatType, priority: 4, isCommon: false, isDownloadFormatSubType: true, isDownloadSourceVisible: true, isDownloadSourceEditable: false };
    const commonAllDatabasesMapping = { name: commonAllDatabases, priority: 5, isCommon: true, isDownloadFormatSubType: false, isDownloadSourceVisible: false, isDownloadSourceEditable: false };
    const commonSubFormatTypeMapping = { name: commonSubFormatType, priority: 6, isCommon: true, isDownloadFormatSubType: true, isDownloadSourceVisible: false, isDownloadSourceEditable: false };

    function mapMappingLevel(data) {
        var hasFormatSubTypeId = (data.downloadFormatSubTypeId != undefined && data.downloadFormatSubTypeId != null && data.downloadFormatSubTypeId >= 0)
        var hasDownloadSourceId = (data.downloadSourceId != undefined && data.downloadSourceId != null && data.downloadSourceId >= 0)

        // common mapping
        if (data.isCommon) {
            if (hasFormatSubTypeId) {
                return commonSubFormatTypeMapping;
            }
            else {
                return commonAllDatabasesMapping;
            }
        }
        // local mapping
        else {
            if (hasFormatSubTypeId) {
                return localSubFormatTypeMapping;
            }
            else if (hasDownloadSourceId) {
                return localAssignedSourceMapping;
            }
            else {
                return localCurrentDatabaseMapping;
            }
        }
    }

  

    // PRIVATE METHODS
    function init() {
        $scope.rights = {
            mappingTables: $oasRights.forCode("MAPPINGTABLES"),
            globalMapping: $oasRights.forCode("GLOBALMAPPING")
        };

        $q.all([
            loadDownloadSources(),
            loadDownloadFormats()])
            .then(() => {
                loadMappingTables();
                $scope.current.item = emptyItem();
                setMappingLevelsByTableSelected();
                setDefaultDropDowns();

                loadDownloadFormatSubTypes()
                    .then(() => {
                        let defaultSubType = $scope?.current?.downloadFormatSubTypes?.list?.find(function (i) { return i?.id === 0 });

                        if ($scope.current.downloadFormatSubTypes.list.length > 0) {
                            // If there's a subtype selected, pull the proper value
                            if ($scope.current.downloadFormatSubTypeId) {
                                $scope.current.downloadFormatSubTypes.selected = $scope.current.downloadFormatSubTypes.find(function (i) { return i.id === $scope.current.downloadFormatSubTypeId });
                            }
                            // if no subtype selected, use the default subtype if it exists (which it should always)
                            else if (defaultSubType != null && defaultSubType != undefined) {
                                $scope.current.downloadFormatSubTypes.selected = defaultSubType;
                            }
                            // if the default does not exist (there's a data issue) but just use the first item we find
                            else {
                                $scope.current.downloadFormatSubTypes.selected = $scope.current.downloadFormatSubTypes.list[0];
                            }
                        }
                    });
            });
    }

    function setDefaultDropDowns() {
        if (!$scope.current.downloadFormats.selected) {
            $scope.current.downloadFormats.selected = $scope.current.downloadFormats.list[0].id;
        }

        if (!$scope.current.mappingTables.selected) {
            $scope.current.mappingTables.selected = $scope.current.mappingTables.list[0].name;
        }
    }

    function emptyItem() {
        var item = {
            get downloadFormat() { return ($scope.current.downloadFormats.list.find(function (i) { return i.id === $scope.current.downloadFormats.selected }) || {}).name; },
            get downloadFormatId() { return $scope.current.downloadFormats.selected; },
            get tableName() { return $scope.current.mappingTables.selected || $scope.current.mappingTables[0] },
            get isCommon() { return item.mappingLevel.isCommon }, // return [5, undefined].any(($scope.getLevelDetails(item.mappingLevel)||{}).priority); },
            downloadSourceId: $scope.current.downloadSources.selected,
        };
            
        return item;
    }

    function loadMappingTables() {
        $scope.current.mappingTables.list.push({
            name: 'ActivityType'
        });
        $scope.current.mappingTables.list.push({
            name: 'BlotterCode'
        });
        $scope.current.mappingTables.list.push({
            name: 'CommissionIndicator'
        });
        $scope.current.mappingTables.list.push({
            name: 'ContribCode'
        });
        $scope.current.mappingTables.list.push({
            name: 'CorpActionType'
        });
        $scope.current.mappingTables.list.push({
            name: 'Custodian'
        });
        $scope.current.mappingTables.list.push({
            name: 'DistCode'
        });
        $scope.current.mappingTables.list.push({
            name: 'DistributionIndicator'
        });
        $scope.current.mappingTables.list.push({
            name: 'DividendType'
        });
        $scope.current.mappingTables.list.push({
            name: 'FundFamily'
        });
        $scope.current.mappingTables.list.push({
            name: fundFamilyExcludeTable
        });
        $scope.current.mappingTables.list.push({
            name: 'FundManager'
        });
        $scope.current.mappingTables.list.push({
            name: 'InterestFrequency'
        });
        $scope.current.mappingTables.list.push({
            name: 'ManagementStyle'
        });
        $scope.current.mappingTables.list.push({
            name: 'MarketCode'
        });
        $scope.current.mappingTables.list.push({
            name: 'MatrixRejectCodes'
        });
        $scope.current.mappingTables.list.push({
            name: modelNameTable
        });
        $scope.current.mappingTables.list.push({
            name: 'OrderType'
        });
        $scope.current.mappingTables.list.push({
            name: 'ProductSubType'
        });
        $scope.current.mappingTables.list.push({
            name: 'ProductType'
        });
        $scope.current.mappingTables.list.push({
            name: 'RegistrationType'
        });
        $scope.current.mappingTables.list.push({
            name: repTable
        });
        $scope.current.mappingTables.list.push({
            name: repAutoExcludeTable
        });
        $scope.current.mappingTables.list.push({
            name: 'RevenueType'
        });
        $scope.current.mappingTables.list.push({
            name: 'SpreadStraddle'
        });
        $scope.current.mappingTables.list.push({
            name: 'Systematic'
        });
        $scope.current.mappingTables.list.push({
            name: 'SystematicFrequency'
        });
        $scope.current.mappingTables.list.push({
            name: 'SystematicTypes'
        });
        $scope.current.mappingTables.list.push({
            name: 'TaxStatusCode'
        });
        $scope.current.mappingTables.list.push({
            name: 'TransactionFeeType'
        });
        $scope.current.mappingTables.list.push({
            name: 'TransactionSubType'
        });
        $scope.current.mappingTables.list.push({
            name: transactionTypeTable
        });
        $scope.current.mappingTables.list.push({
            name: 'TransactionTypeOffset'
        });
        $scope.current.mappingTables.list.push({
            name: 'CostBasisMethod'
        });
    }

    function loadDownloadSources() {
        return $http.get("/Confirm/DownloadSources/Simple", { trackerMsg: "Loading download sources" })
            .then(function (response) {
                $scope.current.downloadSources.list = response.data;
            });
    }

    function loadDownloadFormats() {
        return $http.get("/Confirm/DownloadFormats/Simple", { trackerMsg: "Loading download formats" })
            .then(function (response) {
                $scope.current.downloadFormats.list = response.data;
            });
    }

    function loadDownloadFormatSubTypes() {
        var selectedDownloadFormatId = $scope.current.downloadFormats.selected;
        var url = `/Confirm/DownloadFormats/${selectedDownloadFormatId}/SubTypesSimpleWithDefault`;

        return $http.get(url, { trackerMsg: "Loading download format sub types" })
            .then(function (response) {
                $scope.current.downloadFormatSubTypes.list = response.data;
            });
    }

    function updateItem(config) {
        var dest = config.data.isCommon ? 'common' : 'local';
        return $http({
            method: 'PUT',
            url: '/Confirm/DownloadMap/' + dest + '/' + config.data.id,
            trackerMsg: 'Saving ' + dest + ' mapping',
            data: config.data
        }).then(function (response) {
            transposeData(response.data);
            return response;
        });
    }

    function loadFiles(config) {
        return $q.all([
            $http({
                method: 'GET',
                url: '/Confirm/DownloadMap/Common',
                trackerMsg: 'Loading common mapping',
                params: angular.extend({
                    downloadFormatId: $scope.current.downloadFormats.selected,
                    tableName: $scope.current.mappingTables.selected
                }, config.params)
            }),
            $http({
                method: 'GET',
                url: '/Confirm/DownloadMap/Local',
                trackerMsg: 'Loading local mapping',
                params: angular.extend({
                    includeUnassigned: true,
                    downloadSourceId: $scope.current.downloadSources.selected,
                    downloadFormatId: $scope.current.downloadFormats.selected,
                    tableName: $scope.current.mappingTables.selected
                }, config.params)
            })
        ]).then(function (responses) {
            return responses
                .map(function (r) { return r.data })
                .flatten()
        }).then(function (data) {
            data.forEach(transposeData);
            return data;
        });
    }

    function transposeData(row) {
        setMappingLevel(row);
        setCompositeKey(row);
        setDownloadFormatSubTypeFromId(row);
    }

    function setMappingLevel(row) {
        let mappingLevel = mapMappingLevel(row);
        row.mappingLevelObject = mappingLevel;
        row.mappingLevel = row.mappingLevelObject.name;
    }

    function setCompositeKey(row) {
        Object.defineProperty(row, 'compositeKey', { value: [(row.isCommon ? 'Common' : 'Local'), row.id].join('/') });
    }

    function setDownloadFormatSubTypeFromId(row) {
        // downloadFormatSubTypeId can and should be 0 quite a bit
        if (row?.downloadFormatSubTypeId != null
            && row?.downloadFormatSubTypeId != undefined
            && $scope?.current?.downloadFormatSubTypes?.list
            && $scope?.current?.downloadFormatSubTypes?.list.length > 0) {
            row.downloadFormatSubType = $scope.current.downloadFormatSubTypes.list.find(function (i) { return i.id === row.downloadFormatSubTypeId })?.name;
        }
    }

    function setMappingLevelsByTableSelected() {
        $scope.current.mappingLevels = [
            localAssignedSourceMapping,
            localCurrentDatabaseMapping
        ]
        let globalOnly = false;
        let localOnly = false;
        switch ($scope.current.mappingTables.selected) {
            case repTable:
            case repAutoExcludeTable:
            case modelNameTable:
                localOnly = true;
                break;
            case fundFamilyExcludeTable:
                $scope.current.mappingLevels.push(localSubFormatTypeMapping);
                localOnly = true;
                break;
            case transactionTypeTable:
                if ($scope.rights.globalMapping.canUpdate === true)
                {
                    $scope.current.mappingLevels.push(commonSubFormatTypeMapping);
                }
                break;
            case costBasisMethod:
                globalOnly = true;
                break;
        }

        if (localOnly === false) {
            if ($scope.rights.globalMapping.canUpdate === true)
            {
                $scope.current.mappingLevels.push(commonAllDatabasesMapping);
            }
        }
        if (globalOnly === true) {
            if ($scope.rights.globalMapping.canUpdate === true) {
                $scope.current.mappingLevels = [commonAllDatabasesMapping];
                $scope.current.item.mappingLevel = commonAllDatabasesMapping;
            } else
            {
                $scope.current.mappingLevels = [];
                $scope.current.item.mappingLevel = null;
            }
        }
    }

    // PUBLIC METHODS
    $scope.slickGridDoubleClick = function () {
        if ($scope.selectedIds.length === 1) {
            $scope.rightSidebar.isOpen = true;
            $scope.current.isEditing = true;
        }
    };

    $scope.deleteItems = function () {
        // Not implemented
    };

    $scope.refreshGrid = function () {
        $timeout(function () {
            $scope.$broadcast('event:confirm-download-map-action', { action: 'refresh-grid' });
        });
    };

    $scope.refreshSubTypesByDownloadFormatId = function () {
        loadDownloadFormatSubTypes();
    }

    $scope.saveItem = function (item) {
        // Copy our item so failing to save doesn't mess up the original item
        let itemToSave = item;
        var dest = itemToSave.isCommon ? 'common' : 'local';

        if (itemToSave.tableName === "RepAutoExclude") {
            itemToSave.orionKey = "1";
        };

        // Since the value in the DTO is just a string, we have to remap from our object to just hte name
        if (itemToSave.mappingLevel && itemToSave.mappingLevel.name != null)
        {
            itemToSave.mappingLevel = itemToSave.mappingLevel.name;
        }

        return $http({
            method: itemToSave.id ? 'PUT' : 'POST',
            url: '/Confirm/DownloadMap/' + dest + (itemToSave.id ? '/' + itemToSave.id : ''),
            trackerMsg: 'Saving ' + dest + ' mapping',
            data: itemToSave
        }).then(function (response) {
            transposeData(response.data);
            $scope.$broadcast('event:confirm-download-map-action', { action: itemToSave.id ? 'update-item' : 'add-item', item: response.data });
            $scope.current.item = emptyItem();
            return response;
        });
    };

    $scope.deleteItem = function (item) {
        return $dialog.confirmAction("Are you sure you want to delete?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    var dest = item.isCommon ? 'common' : 'local';
                    $http.delete('/Confirm/DownloadMap/' + dest + '/' + item.id, { trackerMsg: 'Deleting ' + dest + ' mapping ' + item.id })
                        .then(function () {
                            $scope.$broadcast('event:confirm-download-map-action', { action: 'delete-item', item: item });
                        });
                }
            });
    };

    $scope.getTableOptions = function (tableName) {
        var tableKey = String(tableName).toUpperCase();
        if (tableName != null && String(tableName).length) {
            if (!optionsCache[tableKey]) {
                optionsCache[tableKey] = [];
                $http.get("/Confirm/DownloadMap/Tables/" + tableKey).then(response => {
                    Array.prototype.push.apply(optionsCache[tableKey], response.data);
                });
            }
        }
        return optionsCache[tableKey];
    };

    $scope.canEdit = function () {
    }

    $scope.canSave = function (item) {
        if (!item) { return false };

        if ($scope.rights.globalMapping.canUpdate === false && item.isCommon === true) {
            $scope.current.disableDueToGlobal = true;
            return false;
        } else {
            $scope.current.disableDueToGlobal = false;
        }

        // Handle proper mapping table selection
        let isProperMappingSelections = true;
        if (item.mappingLevelObject) {
            isProperMappingSelections = CheckIfProperMappings(item, item.mappingLevelObject);
        }
        else if (item.mappingLevel) {
            isProperMappingSelections = CheckIfProperMappings(item, item.mappingLevel);
        }
        // If the mapping level isn't set we should not be able to save
        else {
            return false;
        }

        return (isProperMappingSelections &&
            item.externalCode != null &&
            String(item.externalCode).length &&
            item.orionKey != null &&
            String(item.orionKey).length);
    }

    $scope.filterMappingLevelsByMappingTableSelected = () => {
        setMappingLevelsByTableSelected();
    };

    function CheckIfProperMappings(item, mappingLevelObject) {
        if (mappingLevelObject.isDownloadFormatSubType) {
            if (item.downloadFormatSubTypeId == null ||
                item.downloadFormatSubTypeId == undefined ||
                item.downloadFormatSubTypeId < 0) {
                return false;
            }
            else if (mappingLevelObject.isDownloadSourceEditable) {
                if (item.downloadSourceId == null ||
                    item.downloadSourceId == undefined ||
                    item.downloadSourceId < 0) {
                    return false;
                }
            }
        }
        return true;
    }

    function SetDownloadFormatSubTypeMappings(scopeToModify, isDownloadSourceVisible, isDownloadFormatSubType) {
        if (scopeToModify) {
            if (!isDownloadSourceVisible) {
                scopeToModify.downloadSourceId = null;
            }
            if (!isDownloadFormatSubType) {
                scopeToModify.downloadFormatSubTypeId = null;
            }
        }
    }

    $scope.onMappingLevelChangeForUpdate = () => {
        if ($scope?.selected?.mappingLevelObject) {
            let mapObj = $scope.selected.mappingLevelObject;
            SetDownloadFormatSubTypeMappings($scope.selected, mapObj.isDownloadSourceVisible, mapObj.isDownloadFormatSubType);
        }
    }

    $scope.onMappingLevelChangeForNew = () => {
        if ($scope?.current?.item) {
            let mapObj = $scope.current.item;
            SetDownloadFormatSubTypeMappings($scope.current.item, mapObj.mappingLevel.isDownloadSourceVisible, mapObj.mappingLevel.isDownloadFormatSubType);
        }
    }

    $scope.exportToExcel = function () { $scope.$broadcast('event:confirm-download-map-action', { action: 'export-data' }); };

    $scope.views = views;
    // INITIALIZE
    $scope.current = {
        view: views[0],
        canLoad() {
            return $scope.current.downloadFormats.selected && $scope.current.mappingTables.selected;
        },
        mappingLevels: [
            localAssignedSourceMapping,
            localCurrentDatabaseMapping,
            commonAllDatabasesMapping
        ],
        gridDoubleClick: $scope.slickGridDoubleClick,
        downloadSources: {
            get selected() { return selected.downloadSource || parseInt(localStorage.selected_download_source) },
            set selected(v) { localStorage.selected_download_source = selected.downloadSource = v; },
            list: []
        },
        downloadFormats: {
            get selected() { return selected.downloadFormat || parseInt(localStorage.selected_download_format) },
            set selected(v) { localStorage.selected_download_format = selected.downloadFormat = v; },
            list: []
        },
        downloadFormatSubTypes: {
            get selected() { return selected.downloadFormatSubType || parseInt(localStorage.selected_download_format_subType) },
            set selected(v) { localStorage.selected_download_format_subType = selected.downloadFormatSubType = v; },
            list: []
        },
        mappingTables: {
            get selected() { return selected.orionTable || localStorage.selected_orion_table; },
            set selected(v) { localStorage.selected_orion_table = selected.orionTable = v; },
            list: []
        },
        grid: {
            get load() { return $scope.current.canLoad ? loadFiles : undefined; },
            update: updateItem,
            param: {}
        },
    };

    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: { get: function () { return $scope.selectedItems.map('id') } },
        selected: { get: function () { return $scope.selectedItems[0]; } }
    });

    // WATCHES
    function enableEdit(args)
    {
        if (args.item.mappingLevelObject.isCommon && $scope.rights.globalMapping.canUpdate == false) {
            return true;
        }
        else {
            return false;
        }
    }

    $scope.$on("event:confirm-download-map-edit", function (e, args) {
        args.column.enableEdit = enableEdit(args);
        
    });

    // On grid row selected
    $scope.$on('event:confirm-download-map-select', function (e, args) {
        $scope.selectedItems = args;

        if ($scope.selected.isCommon && $scope.rights.globalMapping.canUpdate === false) {
            $scope.current.canDeleteGlobal = false;
        } else {
            $scope.current.canDeleteGlobal = true
        }
        // Refresh what is available to be modified
        $scope.onMappingLevelChangeForUpdate();
    });

    init();
});
'use strict';

app.controller('VisionReconListCtrl', function VisionReconListCtrl($scope, views, tokenFactory, orionVisionSSO) {
    //PRIVATE VARIABLES
    const baseRedirectUrl = window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "");
    const transactionUrl = baseRedirectUrl   + "integration.html?p=/confirmation/alternatives/transactions?orionVisionPending=true&t={token}";
    const importsUrl = baseRedirectUrl   + "integration.html?p=/customImports2/orionVisionHistory?imported=false&t={token}";
    const valuationUrl = baseRedirectUrl   + "integration.html?p=/confirmation/alternatives/valuations?orionVisionPending=true&t={token}";
    
    //PRIVATE METHODS
    function slickGridDoubleClick() {
        if ($scope.selectedIds.length !== 1) return;

        const cancelWatcher = $scope.$watch('current.databaseUrl', function (redirectUrl) {
            if (!redirectUrl) return;

            window.open(redirectUrl, '_blank');
            cancelWatcher();
        });

    }


    // PUBLIC METHODS
    $scope.refreshGrid = function () {
        $scope.$broadcast('event:confirm-orionVision-action', {action: 'refresh-grid'});
    };

    // INITIALIZE
    $scope.selectedIds = [];
    $scope.views = views;
    $scope.current = {
        view: views[0],
        gridDoubleClick: slickGridDoubleClick,
        buttonText: 'View Details',
        loadUrl: '/Confirm/Overview/OrionVision'
    };

    // EVENT LISTENERS
    $scope.$on('event:confirm-orionVision-select', function(e, args) {
        $scope.current.databaseUrl = null;
        $scope.current.buttonText = null;

        if (args.length === 1) {
            tokenFactory.getDatabaseToken(args[0].alClientId)
                .then(function (token) {
                    const params = {token: token};
                    switch(args[0].area){
                        case "Imports":
                            $scope.current.buttonText = 'View Imports';
                            $scope.current.databaseUrl = importsUrl.assign(params);
                            break;
                        case "Pending Transactions":
                            $scope.current.buttonText = 'View Transactions';
                            $scope.current.databaseUrl = transactionUrl.assign(params);
                            break;
                        case "Pending Valuations":
                            $scope.current.buttonText = 'View Valuations';
                            $scope.current.databaseUrl = valuationUrl.assign(params);
                            break;
                        case "Incomplete Extractions":
                            $scope.current.buttonText = 'Go To Orion Vision';
                            $scope.current.databaseUrl = orionVisionSSO.getUrl(token, true);
                            break;
                        default:
                            $scope.current.buttonText = null;
                            $scope.current.databaseUrl = null;
                            break;
                    }
                });
        }
    });
});
'use strict';

app.controller('GeneratedShareLinkCtrl', function GeneratedShareLinkCtrl($scope, dialog) {
    //PUBLIC METHODS
    $scope.cancel = function( ) {
        dialog.close();
    };


    // INITIALIZE
    $scope.current = Object.select(dialog.options, "shareUri", "expirationDate", "notification");
});
'use strict';

app.controller('EmailEditCtrl', function EmailEditCtrl($scope, $http, $location, $upload, $dialog, $oasRights, entities) {
    //PRIVATE VARIABLES
    var ownerCode, checkOwnerCode;


    //PRIVATE METHODS
    function init() {
        var entityMap = {};
        entityMap[entities.administrator.name] = [entities.administrator.name, entities.ria.name, entities.brokerDealer.name, entities.representative.name, entities.repAccountManager.name, entities.thirdParty.name, entities.payee.name];
        entityMap[entities.ria.name] = entityMap[entities.administrator.name];
        entityMap[entities.brokerDealer.name] = [entities.ria.name, entities.representative.name];
        entityMap[entities.payee.name] = [entities.ria.name];
        entityMap[entities.representative.name] = [entities.ria.name, entities.brokerDealer.name];
        entityMap[entities.repAccountManager.name] = [entities.ria.name];

        $scope.entityList = entityMap[$scope.user.authorization.entity];
        $scope.current.entity = $scope.entityList[0];

        if ([$scope.user.authorization.entity, $scope.user.authorization.originalEntity].any(entities.administrator.name)) {
            checkOwnerCode = true;

            $http.get("/Settings/Owner/Code", {cache:true, trackerMsg: 'Loading settings'})
                .then(function (response) {
                    ownerCode = response.data.toLowerCase();
                });
        }
    }


    //PUBLIC METHODS
    $scope.invalidEmail = function (recipient, invalid) {
        recipient.emailInvalid = invalid;
    }

    $scope.setEmail = function (recipient, value) {
        recipient.email = value;
    }

    $scope.back = function() {
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep -= 1;
    };

    $scope.next = function() {
        $scope.current.animation = 'slide-right';
        $scope.current.wizardStep += 1;
    };

    $scope.jumpBackTo = function(index) {
        if ($scope.current.executing) return;

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };
    
    $scope.isStepIncomplete = function() {
        switch ($scope.current.wizardStep) {
            case 0:
                const hasInvalidEmail = $scope.message.recipients.some(function (recipient) {
                    return recipient.emailInvalid;
                });
                return $scope.message.recipients.length === 0 || hasInvalidEmail;
            case 1:
                return false;
            case 2:
                return false;
            case 3:
                return  !$scope.message.subject || !$oasRights.canAdd("SECUREXCHNGAPP");
            default:
                return true;
        }
    };
    
    $scope.addRecipient = function (recipient) {
        if ($scope.message.recipients.none({userId: recipient.userId})) {
            $scope.message.recipients.insert(recipient, 0);   
        }
        $scope.current.recipient = null;
    };

    $scope.removeRecipient = function (recipient) {
        $scope.message.recipients.remove(recipient);
    };
    
    $scope.onFileSelect = function (files) {
        var invalidFiles = [];

        if (checkOwnerCode) {
            files.forEach(function (file) {
                var lastDot = file.name.lastIndexOf(".");
                var fileNameNoExt = lastDot === -1 ? file.name : file.name.substring(0, lastDot);
                var fileNameParts = fileNameNoExt.split("_");

                if (fileNameParts.length === 1 || !fileNameParts.last().toLowerCase().has(ownerCode)) {
                    invalidFiles.push(file.name);
                }
            });
        }

        if (invalidFiles.length) {
            $dialog.actionFailed("The following files are not named in the correct format:<br /><br /><ul class='unstyled'><li>" + invalidFiles.join("</li><li>") + "</li></ul>").open();
        } else {
            $scope.files.add(files);
        }
    };

    $scope.removeFile = function (file) {
        $scope.files.remove(file);
    };

    $scope.sendMessage = function () {
        $scope.current.executing = true;

        var config = {
            url: "/Blogging/Emails/New",
            data: $scope.message,
            file: $scope.files,
            fileFormDataName: $scope.files.map(function (item, i) {return "files[" + i + "]"})
        };

        $upload.upload(config)
            .then(function() {
                $location.path("/tools/email/received");
            })
            .catch(function () {
                $scope.current.executing = false;
            });
    };


    //INITIALIZE
    $scope.message = {recipients: []};
    $scope.files = [];
    $scope.current = {wizardStep: 0, animation: 'slide-right', recipient: null, executing: false};
    $scope.wizardSteps = ["Recipients", "Secure Message", "Attachments", "Notification Email"];

    init();
});

'use strict';

var emailListCtrl = app.controller('EmailListCtrl', function EmailListCtrl($scope, $http, $routeParams, $timeout, $dialog, $settings, $oasRights, views) {
    // PRIVATE VARIABLES

    //PRIVATE METHODS
    function init() {
        $scope.rights = $oasRights.forCode("SECUREXCHNGAPP");

        $http.get("/Blogging/Emails/Mailboxes", {cache: true, trackerMsg: "Loading mailboxes"})
            .then(function (response) {
                $scope.mailboxes = response.data;
            });
    }


    //PUBLIC METHODS
    $scope.changeMailbox = function () {
        $settings.setSetting("mailboxId", $scope.current.userId);
        $timeout($scope.refreshGrid);
    };

    $scope.refreshGrid = function () {
        $scope.$broadcast('event:email-list-action', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:email-list-action', {action: 'export-data'});
    };

    $scope.viewMessage = function () {
        $dialog.dialog({templateUrl: "view-email-message.html", controller: "ViewEmailMessageCtrl", messageId: $scope.selectedIds[0]}).open();
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.viewMessage();
    };


    //INITIALIZE
    $scope.views = views;
    $scope.current = {
        view: views[0], gridDoubleClick: $scope.slickGridDoubleClick,
        folder: $routeParams.folder.capitalize(),
        url: '/Blogging/Emails/' + $routeParams.folder,
        userId: parseInt($routeParams.userId) || $settings.getSetting("mailboxId") || $scope.user.authorization.userId
    };

    $scope.current.hotKeyActions = [{ combo:'CTRL+V', command: function(){
        if($scope.selectedIds.length === 1)
            $scope.viewMessage();
    }}];
    $scope.selectedIds = [];

    init();
});

emailListCtrl.loadEmailViews = ["$http", "$route", function ($http, $route) {
    var dtoPrefix = {"sent": "Sent", "received": "Received", "archived": "Sent", "deleted": "Received"}[$route.current.params.folder];

    return $http.get('/Settings/Views/' + dtoPrefix + 'EmailDto', {trackerMsg: 'Loading views'})
        .then(function (response) {
            return response.data;
        });
}];

app.controller('ViewEmailMessageCtrl', function ViewEmailMessageCtrl($scope, $http, dialog, API_CONFIG) {
    //PRIVATE METHODS
    function init() {
        $http.get("/Blogging/Emails/" + dialog.options.messageId, {trackerMsg: "Loading message"})
            .then(function (response) {
                $scope.message = response.data;
            });
    }


    //PUBLIC METHODS
    $scope.downloadAttachment = function (attachment) {
        window.location.href = API_CONFIG.baseUrl + '/Blogging/Emails/' + $scope.message.id + '/Attachments/' + attachment.id + '/Download?Authorization=' + sessionStorage.oas_token;
    };

    $scope.close = function () {
        dialog.close();
    };


    //INIT
    init();
});

'use strict';

var groupingManagerCtrl = app.controller('GroupingManagerCtrl', function GroupingManagerCtrl($scope, $routeParams, views) {
    //PRIVATE METHODS
    function init() {
        var entity = ($routeParams.entity.toLocaleLowerCase() === 'households') ? 'client' : $routeParams.entity.singularize();
        $scope.current.level = entity.capitalize();
        $scope.current.url = '/Utility/Groupings/' +  entity.pluralize().capitalize();
    }

    //PUBLIC METHODS
    $scope.refreshGrid = function() {
        $scope.$broadcast('event:grouping-mgr-action', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:grouping-mgr-action', {action: 'export-data'});
    };

    $scope.addToGroup = function() {
        $scope.current.view.filters.length = 0;

        $scope.selectedIds.forEach(function(id) {
            $scope.current.view.filters.push({ name: "ID = " + id, value: "(function (a) { return a === " + id + "; })", key: "id", include: true });
        });

        $scope.current.view.filterType = 'Any';
    };


    //INITIALIZE
    $scope.views = views;
    $scope.current = {view: $routeParams.viewId ? views.find({id: parseInt($routeParams.viewId)}) : views[0], gridQueries: [], level: '', url: ''};
    $scope.selectedIds = [];
    init();
});

groupingManagerCtrl.loadGroupingView = ["$http","$route", function( $http, $route ) {
    var entity = ($route.current.params.entity.toLocaleLowerCase() === 'households') ? 'client' : $route.current.params.entity.singularize();
    return $http.get('/Settings/Views/GroupingView' + entity +'Dto', {trackerMsg : 'Loading grouping view'})
        .then(function(response){
            return response.data;
        });
}];
'use strict';

app.controller('DatabaseGroupingManagerCtrl', function DatabaseGroupingManagerCtrl($scope, $http, $dialog, $oasRights, views) {
    //PRIVATE METHODS
    function init() {
        getAlClients()
            .then(function(response){
                $scope.current.dbCount = response.data.length
            });
    }

    function getAlClients() {
        return $http.get('/Authorization/User/Databases?isActive=true&filterForMasterGroup=true', {trackerMsg: 'Loading database list'})
    }

    //PUBLIC METHODS
    $scope.deleteGrouping = function() {
        $dialog.confirmAction("Are you sure you want to delete this database grouping?")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $http.delete('/Utility/DatabaseGroups/' + $scope.selectedIds[0], {trackerMsg: 'Deleting database grouping'})
                        .then(function() {
                            $scope.$broadcast('event:db-grouping-mgr-action', {action: 'refresh-grid'});
                        });
                }
            });
    };

    $scope.refreshGrid = function() {
        $scope.$broadcast('event:db-grouping-mgr-action', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:db-grouping-mgr-action', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            location.href = '#/tools/groupingmanager/database/' + $scope.selectedIds[0];
    };


    //INITIALIZE
    $scope.rightsDbGrouping = $oasRights.forCode("DB_GROUPING");
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = { dbCount: 0, view: views[0], url: '/Utility/DatabaseGroups', gridDoubleClick: $scope.slickGridDoubleClick };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            location.href = '#/tools/groupingmanager/database/' + $scope.selectedIds[0];
    }}];

    init();
});
'use strict';

app.controller('DatabaseGroupingEditorCtrl', function DatabaseGroupingEditorCtrl($scope, $http, $oasRights, $routeParams, $location, $dialog) {
    // PRIVATE VARIABLES
    var groupingId = $routeParams.id;

    //PRIVATE METHODS
    function init() {
        if(groupingId > 0) {
            $http.get('/Utility/DatabaseGroups/' + groupingId, {trackerMsg: 'Loading database group'})
                .then(function(response){
                    $scope.grouping = response.data;
                    $scope.current.isCreator = ($scope.grouping.userId === $scope.user.authorization.userId);
                    return getAlClients();
                })
                .then(loadDatabaseList);
        }
        else {
            $scope.current.isCreator = true;
            $scope.grouping = {
                id: 0,
                name: '',
                isPrivate: true,
                userId: $scope.user.authorization.userId,
                entity: !$scope.current.isAdmin ? 'Advisor' : 'Administrator',
                alClientId: $scope.current.database.id,
                alClientName: null,
                databases: [],
                auditedBy: null,
                auditedDate: null
            };
            getAlClients()
                .then(loadDatabaseList);
        }
    }

    function getAlClients() {
        return $http.get('/Authorization/User/Databases?isActive=true&filterForMasterGroup=true', {trackerMsg: 'Loading database list'})
    }

    function loadDatabaseList(response) {
        $scope.alClients.list = response.data.sortBy('clientName');
        $scope.grouping.databases.each(function(db){
            var currentDb = angular.copy($scope.alClients.list.find( { id : db.id } ));
            $scope.alClients.selected.push(currentDb);
        });
        $scope.alClients.entity = 1979;
    }

    function cleanUp() {
        var copy = angular.copy($scope.grouping);
        copy.databases = $scope.grouping.databases.map(function(db){
            return { id: db.id, name: db.name };
        });
        return copy;
    }

    //PUBLIC METHODS
    $scope.saveGrouping = function(closeScreen) {
        var args = parseInt(groupingId) > 0 ? {method: "PUT", id: groupingId, trackerMsg: "Saving database grouping"} : {method: "POST", id: "", trackerMsg: "Adding new database grouping"};
        var grouping = cleanUp();

        $http( { method: args.method, url: '/Utility/DatabaseGroups/' + args.id, data: grouping, trackerMsg: args.trackerMsg } )
            .then(function(response){
                if(!closeScreen) {
                    $scope.grouping = response.data;

                    if(parseInt(groupingId) === 0)
                        groupingId = response.data.id;
                }
                else
                    $location.path( '/tools/groupingmanager/database' );
            });
    };

    $scope.deleteGrouping = function() {
        $dialog.confirmAction("Are you sure you want to delete the database grouping \"" + $scope.grouping.name + "\"?")
            .open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $http.delete('/Utility/DatabaseGroups/' + groupingId, {trackerMsg: 'Deleting database grouping'})
                        .then(function() {
                            $location.path('/tools/groupingmanager/database');
                        });
                }
            });
    };


    //INITIALIZE
    $scope.rightsDbGrouping = $oasRights.forCode("DB_GROUPING");
    $scope.grouping = null;
    $scope.alClients = { list: [], selected: [] };
    $scope.current = { isCreator: false, isAdmin: ($scope.user.authorization.entity === 'Administrator'), database: {id: $scope.user.authorization.alClientId, name: $scope.user.authorization.alClientName} };
    $scope.selectedIds = [];
    init();
});
'use strict';

app.controller('OasAppListCtrl', function OasAppListCtrl($scope, $http, $oasRights) {

    // PUBLIC METHODS
    $scope.deleteApp = function(app) {
        $http.delete('/Settings/Apps/' + app.appCode, {trackerMsg: 'Deleting ' + app.name})
            .then(function () {
                loadApps( );
            });
    };


    // PRIVATE METHODS
    function loadApps( ) {
        $http.get( "/Settings/Apps", {trackerMsg: 'Loading apps'} ).then ( function(response) {
            $scope.apps = response.data;
        } );
    }

    // INITIALIZE
    $scope.rights = $oasRights.forCode("APPS");

    loadApps( );

});
'use strict';

app.controller('OasAppCtrl', function OasAppCtrl($scope, $http, $routeParams, $location, $dialog, $oasRights, $portfolio, ssoTypes, audienceExclusions) {

    // PRIVATE VARIABLES
    var appCode = $routeParams.appCode;


    // PRIVATE METHODS
    function loadApp() {
        if (appCode.length > 0 && appCode != 'new') {
            $http.get('/Settings/Apps/' + appCode + '?showAllPages=true', {trackerMsg: 'Loading app ' + appCode})
                .then(function (response) {
                    $scope.app = response.data;
                    loadPrivileges();
                });
        } else {
            $scope.app = {id: 0, name: 'New App', imageName: 'settings', isActive: true, ssoType: 'None', audienceExclusion: 'None', options: [], categories: []};
            loadPrivileges();
        }
    }

    function loadPrivileges() {
        $http.get('/Security/Privileges', {trackerMsg:'Loading Privileges'})
            .then(function (response) {
                $scope.privilegeList = response.data.sortBy('name');

                $scope.app.categories.forEach(function (category) {
                    category.pages.forEach(function (page) {
                        if (page.privilegeId) {
                            page.privilegeName = $scope.privilegeList.find({id: page.privilegeId}).name;
                        }
                    });
                });
            });
    }

    function loadLookUps() {
        $scope.ssoTypes = $portfolio.enumToSimpleList(ssoTypes);
        // Must match JSON from StringValueEnumConverter (string values, not parseInt like enumToSimpleList).
        $scope.audienceExclusionChoices = audienceExclusions.values().map(function (v) {
            return { id: v.value, name: v.name };
        });

        $http.get("/Global/ServiceTeams/Simple?teamType=ApplicationTeam", {cache: true, trackerMsg: 'Loading SME Teams'})
            .then(function (response) {
                $scope.smeTeams = response.data;
            });
    }


    // PUBLIC METHODS
    $scope.editPrivilege = function (page) {
        var inputValue = page.privilegeId ? $scope.privilegeList.find({id: page.privilegeId}) : $scope.privilegeList[0];

        $dialog.inputBox(page.name, 'Privilege', $scope.privilegeList, {inputValue: inputValue})
            .open()
            .then(function (result) {
                if (!result) return;

                page.privilegeId = result.id;
                page.privilegeName = result.name;
            });
    };

    $scope.saveApp = function () {
        var save;

        if ($scope.app.id === 0) {
            save = {verb: 'post', msg: 'Adding', suffix: ''};
            $scope.app.appCode = $scope.app.name.camelize(false);
        } else {
            save = {verb: 'put', msg: 'Saving', suffix: $scope.app.appCode}
        }

        $http[save.verb]("/Settings/Apps/" + save.suffix, $scope.app, {trackerMsg: save.msg + ' app'})
            .then(function () {
                $location.path('/tools/apps');
            });
    };

    $scope.deleteApp = function () {
        $http.delete('/Settings/Apps/' + $scope.app.appCode, {trackerMsg: 'Deleting ' + $scope.app.name})
            .then(function () {
                $location.path('/tools/apps');
            });
    };

    $scope.addAppOption = function () {
        $scope.app.options.push({
            id: 0,
            canUserOverride: false
        });
    };

    $scope.deleteAppOption = function (option) {
        $scope.app.options.remove(option);
    };

    $scope.addAppPage = function (category) {
        category.pages.push({
            id: 0,
            includeByDefault: true,
            audienceExclusion: 'None'
        });
    };

    $scope.deleteAppPage = function (category, page) {
        category.pages.remove(page);
    };


    // INITIALIZE
    $scope.rights = $oasRights.forCode("APPS");

    loadLookUps();
    loadApp();
});
'use strict';

app.controller('RecordCompareCtrl', function RecordCompareCtrl($scope, $http, $routeParams) {


    // PRIVATE VARIABLES


    // PUBLIC VARIABLES


    //PUBLIC METHODS
    $scope.update = function( ) {
        $http.put("/Integrations/Salesforce/OrionConnect/Compare?entity=" + $scope.current.entityEnum + "&entityid=" + $scope.current.entityID + "&orgid=" + $scope.current.orgID, $scope.current.recordPair, {trackerMsg: 'Syncing records'}).then(function( response ) {
                $scope.current.recordPair = response.data;
            });
    };

    // PRIVATE METHODS
    function loadRecordPair( ) {
        $http.get("/Integrations/Salesforce/OrionConnect/Compare?entity=" + $scope.current.entityEnum + "&entityid=" + $scope.current.entityID + "&orgid=" + $scope.current.orgID, {trackerMsg: 'Loading records'} ).then(function (response) {
            $scope.current.recordPair = response.data;
        });
    }


    // INITIALIZE
    $scope.current = { entityID : $routeParams.entityId, entityEnum : $routeParams.entity, orgID : $routeParams.orgId };
    loadRecordPair( );

});
'use strict';

app.controller('SyncHistoryCtrl', function SyncHistoryCtrl($scope, $http, $oasRights, listSectionData) {
    // PRIVATE VARIABLES
    var dataItemsEvent = "event: data-items";


    // PUBLIC METHODS
    $scope.loadSyncHistory = function () {
        $http.get( "/Integrations/SyncHistory?startDate=" + $scope.current.startDate.formatted() + "&endDate=" + $scope.current.endDate.formatted() + ($scope.current.syncStatus === "" ? "" : ($scope.current.syncStatus == "Failed" ? "&status=Failed&status=Error"  : "&status=" + $scope.current.syncStatus)) + "&syncType=" + $scope.current.syncType, {trackerMsg: 'Loading sync history'})
            .then(function (response) {
                listSectionData.dataItems = response.data;
                $scope.$broadcast(dataItemsEvent);
            });
    };

    $scope.kickOffSync = function () {
        $http.post("/Integrations/Salesforce/OrionConnect/Sync", {trackerMsg: 'Starting Sync'})
            .then(function () {
                $scope.loadSyncHistory();
            });
    };


    // INITIALIZE
    $scope.current = {
        showFilterRow: true,
        endDate: Date.create('today'),
        startDate: Date.create('a month ago'),
        syncStatus: '',
        syncType: '',
        canSync: $oasRights.canRead("SALESFORCEUSER")
    };

    $scope.loadSyncHistory();

    $scope.config = {
        getUrl: null,
        listName: 'Sync History',
        template: 'sync-history-list-item.html',
        icon: 'fa fa-users',
        selectEnabled: false,
        multiSelectEnabled: false,
        loadDataItemsEvent: dataItemsEvent,
        sortFields: {startDate: "Start Date", endDate: "End Date", syncType: "Sync Type", status: "Status", messages: "Messages"},
        fieldToSort: 'startDate',
        sortAsc: false,
        listFilter: ['messages'],
        additionalLinks: []
    };
});
"use strict";

app.controller('ServiceRequestCtrl', function ServiceRequestCtrl($scope, $http, $location) {
    $scope.showServiceRequests = true; // add database setting for whether adviser wants to know these in sidebar
    // self service forms and templates
    $scope.selfServiceFormData = {};
    $scope.selfServiceFormTemplate = {};
    $scope.selfServiceFormTemplateLoaded = false;
    var requestInfo = {};
    $scope.selectedRequest = {};

    var baseEndpoint = "/Integrations/Salesforce/OrionConnect/PassThrough/services",
        apexEndpoint = baseEndpoint + "/apexrest/{1}/ClientSelfService";

    var init = function () {
        $scope.submittedRequests = [{status: "Open", isOpen: true, items: []}];  //pre-defining Open status group so it always shows up
        $http.get("/Integrations/Salesforce/OrionConnect/Namespace")
            .then(function (response) {
                apexEndpoint = apexEndpoint.assign(response.data.namespace == 'OAS_WM' ? 'TDAPCE' : 'OCPCE');
                // list of possible request types; client chooses one value - we then query for that value and return its fields
                $http.get(apexEndpoint + "/ServiceRequests", {trackerMsg: 'Loading available forms'})
                    .then(function (response) {
                        $scope.selfServiceRequestType = [];
                        $scope.selfServiceRequestTypes = JSON.parse(response.data).sortBy("name");
                    })
            });
    };

    function getSubmittedRequests () {
        $http.get(apexEndpoint + "/ServiceRequests?type=list&clientId=" + $scope.current.selectedEntity.id,  {trackerMsg: 'Loading submitted requests'})
            .then(function (response) {
                if(response.data){
                    if(response.data.has('Error')){

                    }else {
                        JSON.parse(response.data).forEach(function (request) {
                            var existingGroup = $scope.submittedRequests.find({status: request.status});

                            if (existingGroup)
                                existingGroup.items.push(request);
                            else
                                $scope.submittedRequests.push({status: request.status, isOpen: false, items: [request]});
                        });
                    }
                }
            });
    }

     function exitWizard (requestType, result) {

        $scope.wizardSteps.add('Completed');

        $scope.requestMessage.title = "Request Submitted";
        $scope.requestMessage.subTitle = requestType;
        $scope.requestMessage.detail = "Your " + requestType + (result === 'success' ? " has been submitted successfully." : " did not submit successfully. Please try again or contact your adviser.");

         $scope.current.animation = 'slide-right';
         $scope.current.wizardStep = $scope.wizardSteps[$scope.wizardSteps.indexOf('Completed')];
    }

    // selects service request information from the initial callout
    // uses object/record type combo to gather picklist values from the layout
    $scope.selectServiceRequestType = function (choice) {
        // if the form is already populated ready for new form data to be reloaded
        if ($scope.selfServiceFormTemplateLoaded) {
            $scope.selfServiceFormTemplateLoaded = false;
        }

        $scope.includeAccounts = false;

        // go through each service request type, gather picklist values specific to that record type
        $scope.selfServiceRequestTypes.forEach(function (val) {
            // if one is selected, check for the matching service request and get more information about it (in addition to the field set)
            if (val.id !== null && val.id === choice.id) {

                // set request value for use later - TODO remove?
                $scope.selectedRequest = val;

                // initialize our picklist map  --> maps fieldPath=>{details,picklist values}
                var picklistMap = {};

                $http.get(baseEndpoint + "/data/v31.0/sobjects/" + val.processObject + "/describe/layouts/" + val.recordType, {trackerMsg: 'Loading request information'})
                    .then(function (response) {
                        var controllingFieldMap = {};
                        if (response.data) {
                            // gather picklist values from layout edit sections, which contain picklist values we need
                            response.data.editLayoutSections.forEach(function (section) {
                                section.layoutRows.forEach(function (rows) {
                                        rows.layoutItems.forEach(function (item) {
                                            item.layoutComponents.forEach(function (fld) {
                                                if (fld.details) {
                                                    if (fld.details.type === 'picklist' || fld.details.type === 'multipicklist') {
                                                        // set field information we'll use later
                                                        picklistMap[fld.details.name] = {
                                                            name: fld.details.name,
                                                            label: fld.details.label,
                                                            isDependent: fld.details.dependentPicklist,
                                                            dependsOn: fld.details.controllerName,
                                                            picklistValues: fld.details.picklistValues
                                                        };
                                                        // maps the controlling field to dependent field information (field name and picklist values), if applicable
                                                        if (fld.details.dependentPicklist) {
                                                            controllingFieldMap[fld.details.controllerName] = {
                                                                controls: fld.details.name, controlledPicklistValues: fld.details.picklistValues
                                                            };
                                                        }
                                                    }
                                                }
                                            });
                                        });
                                    }
                                );

                            });

                            $scope.controllingFieldMap = controllingFieldMap;
                            requestInfo = val;
                            // look at each field in the fieldset
                            $scope.selectedRequest.fieldSetValue.forEach(function (fld) {
                                var fldType = fld.fieldType.toLowerCase();
                                if (fldType === 'picklist' || fldType === 'multipicklist') {
                                    // grab picklist values for this field by name (from the layout)
                                    if (controllingFieldMap.hasOwnProperty(fld.fieldPath)) {
                                        fld.controls = controllingFieldMap[fld.fieldPath];
                                    }
                                    fld.details = picklistMap[fld.fieldPath];
                                    // keep a list of original picklist values (field set call) and those specific to the record type (layout)
                                    fld.originalPicklistValues = fld.picklistValues;
                                    fld.picklistValues = picklistMap[fld.fieldPath].picklistValues;
                                }
                            });

                            // if we have dependent picklists add to map for lookup
                            $scope.picklistModel = createDependentPicklistModel(requestInfo);
                            // create the form and load the template
                            $scope.selfServiceFormTemplate = createForm(requestInfo);
                            $scope.selfServiceFormTemplateLoaded = true;

                        }
                        else {
                            picklistMap = {}; // set empty map
                        }
                    })

            }
        })
    };

    $scope.resetServiceRequest = function () {
            $scope.selfServiceFormTemplateLoaded = false;
            $scope.selfServiceFormData = {};
            $scope.selfServiceFormTemplate = {};
    };

    $scope.submitRequest = function () {
        if (typeof $scope.selfServiceFormData.SelectedAccounts !== 'undefined') {
            $scope.selfServiceFormData.SelectedAccounts = $scope.selfServiceFormData.SelectedAccounts.toString();
        }
        // if any fields are used as models for dependent picklists send back the field label not entire object
        for (var field in $scope.selfServiceFormData) {
            if (angular.isDefined($scope.selfServiceFormData[field].label)) {
                $scope.selfServiceFormData[field] = $scope.selfServiceFormData[field].label;
            }
        }
        // send the client's id from current user along with the submitted form data

        var selectedChoice = $scope.selfServiceRequestTypes.find({name:$scope.current.selectedChoice});

        $http.post(apexEndpoint + '/CreateServiceRequest?ServiceName=' + selectedChoice.id + "&client=" + $scope.current.selectedEntity.id, $scope.selfServiceFormData,{trackerMsg: 'Submitting request'})
            .then(function () {
                $scope.submittedRequests[0].items.push({createddate: Date.create(), subject: $scope.selfServiceFormData.FSTR__Subject__c, type: $scope.selfServiceFormData.OCPCE__Type__c});

                $scope.selfServiceFormData = {};
                $scope.selfServiceFormTemplateLoaded = false;

                //go to last page of wizard to show result
                exitWizard(selectedChoice.name, "success");
            })
            .catch(function () {
                exitWizard(selectedChoice.name, "failure");
            });
    };

    // sets the dependent picklist with dependent values based on selection in controlling
    $scope.refreshList = function (fld) {
        try {
            $scope.selfServiceFormData[fld.fieldPath].items = $scope.picklistModel[fld.fieldPath][fld.value].items;
        } catch (err) {
        }
    };

    // PRIVATE METHODS

    // validFor test - compares index of picklist value to validFor value from picklist entry
    var isDependentValue = function (index, validFor) {
        var decoded = window.atob(validFor);
        var bits = decoded.charCodeAt(index >> 3);
        return ((bits & (0x80 >> (index % 8))) != 0);
    };

    var createDependentPicklistModel = function (requestInfo) {
        // dependent field is the key to the map - the key:value pairs for picklist value: dependent values
        var depPicklistModel = {};
        requestInfo.fieldSetValue.forEach(function (fld) {
            if (fld.hasOwnProperty('controls') && fld.controls !== '') {
                var fldType = fld.fieldType.toLowerCase();
                if (fldType === 'boolean') {
                    // TODO create dependent fields for checkbox controlling fields
                }
                else if (fldType === 'picklist' || fldType === 'multipicklist') {
                    var fieldName = fld.details.name;
                    depPicklistModel[fieldName] = {};
                    // add pathname to the field for lookup
                    fld.picklistValues.forEach(function (fld) {
                        fld.fieldPath = fieldName;
                    });
                    depPicklistModel[fieldName].pickVals = fld.picklistValues;
                    // look at each picklist value and determine where to add it in the list
                    var index = 0;
                    fld.picklistValues.forEach(function (fieldKey) {
                        depPicklistModel[fieldName][fieldKey.label] = { items: [] };
                        // check each controlled field and determine whether it's a dependent field of this key value
                        if ($scope.controllingFieldMap.hasOwnProperty(fld.details.name)) {
                            $scope.controllingFieldMap[fld.details.name].controlledPicklistValues.forEach(function (valToCheck) {
                                // if it's a dependent value add to the array of valid selections; map = {fieldName=>controllingField=>items}
                                if (isDependentValue(index, valToCheck.validFor)) {
                                    depPicklistModel[fieldName][fieldKey.label].items.push(valToCheck.value.toString());
                                }
                            });
                        }
                        index += 1;
                    });
                }
            }
        });

        return depPicklistModel;
    };

    var initializeCurrentItem = function (fieldPath) {
        $scope.selfServiceFormData[fieldPath] = { items: {} };
    };


    // FORM CREATION METHODS

    //  dynamically assemble the request form based on the field set information from SF service request fieldset

    function createForm(response) {
        $scope.currentItem = {};
        var fields = {};

        // if adviser wants accounts selectable add the list here
        if (response.includeAccounts) {
            var fldName = 'SelectedAccounts';
            fields[fldName] = {
                type: 'select',
                label: 'Account(s)',
                multiple: true,
                options: {},
                class: "{'form-control': true}"
            };

            $http.get('/Portfolio/Clients/' + $scope.current.selectedEntity.id +'/Accounts', {trackerMsg:'Including account information'})
                .then(function(response){
                    response.data.forEach(function (acct) {
                        fields[fldName]["options"][acct.number] = {
                            label: acct.name + ' (' + acct.number + ')'
                        };
                    });
                });

        }
        // add each field in the fieldset to the form
        response.fieldSetValue.forEach(function (value) {
            if (typeof value !== "undefined") {
                fields[value.fieldPath] = angular.extend({label: value.label, required: value.isRequired, class: "{'form-control': true}"}, mapFieldTypes(value.fieldType));

                if (value.picklistValues !== 'undefined') {
                    var pickVals = value.picklistValues;
                    if ((value.fieldType === "PICKLIST" || value.fieldType === "MULTIPICKLIST") && pickVals !== "undefined" && pickVals.length > 0) {
                        fields[value.fieldPath].empty = "--None--";

                        // if this is a controlling picklist
                        var isControllingPicklist = $scope.picklistModel.hasOwnProperty(value.fieldPath);
                        var isDependent = value.hasOwnProperty('details') && value.details.hasOwnProperty('dependsOn') && value.details.dependsOn !== null;
                        $scope.depFieldChanges = {};

                        if (isControllingPicklist) {
                            initializeCurrentItem(value.fieldPath);
                            // is a controlling picklist - set the available options and a $scope variable to hold current selection
                            fields[value.fieldPath].autoOptions = 'val.value for (key,val) in picklistModel[\'' + value.fieldPath + '\'].pickVals';
                            fields[value.fieldPath].ngChange = 'refreshList(selfServiceFormData[\'' + value.fieldPath + '\'])';
                        } else if (isDependent) {
                            // dependent picklist - set the items to the picklist values it depends on
                            initializeCurrentItem(value.details.dependsOn);
                            fields[value.fieldPath].autoOptions = 'val for (key,val) in selfServiceFormData[\'' + value.details.dependsOn + '\'].items';
                        } else {
                            // this is a normal select list
                            fields[value.fieldPath].options = {};
                            pickVals.forEach(function (fld) {
                                fields[value.fieldPath].options[fld.value] = {
                                    value: fld.value,
                                    label: fld.value
                                };
                            });
                        }
                    }
                }
            }
        });

        return fields;
    }


    function createForm2(response) {
        $scope.currentItem = {};
        $scope.current.includeAccounts = $scope.selectedRequest.includeAccounts;

        var fields = {};
        // if adviser wants accounts selectable add the list here
        if (response.includeAccounts) {
            var fldName = 'SelectedAccounts';
            fields[fldName] = {
                type: 'select',
                label: 'Account(s)',
                multiple: true,
                options: {},
                class: "{'form-control': true}"
            };

            $http.get('/Portfolio/Clients/' + $scope.current.selectedEntity.id +'/Accounts', {trackerMsg:'Including account information'})
                .then(function(response){
                    response.data.forEach(function (acct) {
                        fields[fldName]["options"][acct.number] = {
                            label: acct.name + ' (' + acct.number + ')'
                        };
                    });
                })
        }
        // add each field in the fieldset to the form
        $scope.selectedRequest.fieldSetValue.forEach(function (value) {
            if (typeof value !== "undefined") {
                var fieldInfo = mapFieldTypes(value.fieldType);
                fields[value.fieldPath] = {
                    type: fieldInfo.fieldType,
                    label: value.label,
                    required: value.isRequired,
                    class: "{'form-control': true}"
                };

                if (value.picklistValues !== 'undefined') {
                    var pickVals = value.picklistValues;
                    if ((value.fieldType === "PICKLIST" || value.fieldType === "MULTIPICKLIST") && pickVals !== "undefined" && pickVals.length > 0) {
                        fields[value.fieldPath].empty = "--None--";
                        fields[value.fieldPath].multiple = fieldInfo.multiple;

                        // if it's a multi-select picklist add a tooltip
                        if (fieldInfo.multiple)
                            fields[value.fieldPath].tooltip = fieldInfo.tooltip;

                        // if this is a controlling picklist
                        var isControllingPicklist = $scope.picklistModel.hasOwnProperty(value.fieldPath);
                        var isDependent = value.hasOwnProperty('details') && value.details.hasOwnProperty('dependsOn') && value.details.dependsOn !== null;
                        $scope.depFieldChanges = {};

                        if (isControllingPicklist) {
                            initializeCurrentItem(value.fieldPath);
                            // is a controlling picklist - set the available options and a $scope variable to hold current selection
                            fields[value.fieldPath].autoOptions = 'val.value for (key,val) in picklistModel[\'' + value.fieldPath + '\'].pickVals';
                            fields[value.fieldPath].ngChange = 'refreshList(selfServiceFormData[\'' + value.fieldPath + '\'])';
                        } else if (isDependent) {
                            // dependent picklist - set the items to the picklist values it depends on
                            initializeCurrentItem(value.details.dependsOn);
                            fields[value.fieldPath].autoOptions = 'val for (key,val) in selfServiceFormData[\'' + value.details.dependsOn + '\'].items';
                        } else {
                            // this is a normal select list
                            fields[value.fieldPath]["options"] = {};
                            pickVals.forEach(function (fld) {
                                fields[value.fieldPath]["options"][fld.value] = {
                                    value: fld.value,
                                    label: fld.value
                                };
                            });
                        }
                    }
                }
            }
        });

        return fields;
    }

    var fieldMap = {
        id: "text", address: "text", anyType: "text", string: "text", calculated: "text", reference: "text",
        textarea: "textarea",
        picklist: "select", multipicklist: "select",
        date: "date",
        datetime: "datetime",
        email: "email",
        integer: "number", int: "number", percent: "number", currency: "number", double: "number",
        phone: "tel",
        url: "url",
        boolean: "checkbox"
    };

    function mapFieldTypes(fieldName) {
        fieldName = (fieldName || "").toLowerCase();

        return {
            multiple: fieldName === "multipicklist",
            type: fieldName ? fieldMap[fieldName] : "",
            step: ["percent", "currency", "double"].any(fieldName) ? "any" : undefined
        };
    }


    $scope.back = function() {
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep = $scope.wizardSteps[$scope.wizardSteps.indexOf($scope.current.wizardStep) - 1];

        $scope.current.selectedChoice = null;
    };

    $scope.next = function() {
        $scope.current.animation = 'slide-right';
        $scope.current.wizardStep = $scope.wizardSteps[$scope.wizardSteps.indexOf($scope.current.wizardStep) + 1];

    };

    $scope.isStepIncomplete = function() {
        switch ($scope.current.wizardStep) {
            case 0:
                return false;
            case 1:
                return false;
            default:
                return false;
        }
    };

    $scope.closeWizard = function () {
      $location.path('/main');
    };

    $scope.$watch('current.selectedEntity', function (newValue, oldValue) {
        if (newValue === oldValue) return;

       getSubmittedRequests();
    });


    $scope.requestMessage = {title: '', subTitle:'', detail:''};
    $scope.wizardSteps = ["Client Selection","Form Selection", "Submit Form"];
    $scope.current = {includeAccounts: false, selectedChoice:null, entityLevelSelectionType: 0, selectionTypeName: "", wizardStep: "Client Selection", animation: 'slide-right', executing: false, availableItems: [], availableSelected: [], selectedItems: [], selectedSelected: [], isFullPage: false, messages: [], expandAll: false, entities: []};
    // on load - populate client's existing requests and those available to submit
    init();

});



app.controller('PartnerAppListCtrl', function PartnerAppListCtrl($scope, $http, $oasRights,$dialog, views) {

    //PRIVATE METHODS
    function init() {

    }

    //PUBLIC METHODS
    $scope.editPartnerInfo = function(isNew){
        var d = $dialog.editor('tools/views/partner-app-editor.html','PartnerAppEditorCtrl', {args: function() { return {id: isNew ? 0 : $scope.current.partnerAppId }; }});

        d.open().then(function(rslt) {
            if( rslt ) {
               $scope.$broadcast( 'event:partner-app-list-action', {action: 'refresh-grid' } );
            }
        });
    };

    $scope.deletePartnerApp = function(){
        $http.delete('/Security/PartnerApps/' + $scope.current.partnerAppId, {trackerMsg:'Deleting partner app'})
            .then(function(){
                $scope.$broadcast( 'event:partner-app-list-action', {action: 'refresh-grid' } );
            })
    };
    //EVENT LISTENERS


    //INITIALIZE
    $scope.selectedIds = [];
    $scope.views = views;

    $scope.selectedIds = [];
    $scope.current = { view: views[0], partnerAppId:null };


    $scope.$on("event:partner-app-list-select", function(e, args) {
        if( args.length === 0 ) return;
        $scope.current.partnerAppId = args[0].id;
    });

    init();
});


'use strict'
app.controller('PartnerAppEditorCtrl', function PartnerAppEditorCtrl($scope,$http,$oasRights, $dialog, dialog, args) {

    function init(){
        if(args.id > 0){
            $http.get('/Security/PartnerApps/' + args.id, {trackerMsg:'Loading Partner App Details'})
                .then(function(response){
                    $scope.partnerAppDetail = response.data;
                    $scope.partnerAppDetail.custodianRestrictions ? $scope.current.selectedItems = $scope.partnerAppDetail.custodianRestrictions : [];
                    if(!$scope.partnerAppDetail.productLogo){
                        $scope.partnerAppDetail.productLogo = {image:{}};
                    }
                })
        }else{
            $scope.partnerAppDetail = {
                id: 0,
                partnerName: "",
                productName: "",
                productDescription: null,
                enabled: true,
                useIpRestrictions: false,
                useCustodianRestrictions: false,
                clientSecret: null,
                contactName: "",
                contactPhone: null,
                contactEmail: "",
                supportName: null,
                supportPhone: null,
                supportEmail: "",
                homePageURL: "",
                productLogo: {image:{}},
                termsOfService: null,
                securityCode: null,
                createdBy: null,
                createdDate:null,
                editedBy:null,
                editedDate:null,
                ipRanges:[],
                custodianRestrictions:[]
            };
        }
    }

    $scope.invalidEmail = function (partnerAppDetail, prop, invalid) {
        partnerAppDetail[prop] = invalid;
    }

    $scope.setEmail = function (partnerAppDetail, prop, value) {
        partnerAppDetail[prop] = value;
    }


    $scope.addIpRestriction = function(){

        //clicking add will open the ip restrictions area only if it's closed.
        if(!$scope.partnerAppDetail.useIpRestrictions){
            $scope.partnerAppDetail.useIpRestrictions = true;
        }

        var ipRestriction = {
            id:0,
            description: '',
            startAddress: '0.0.0.0',
            endAddress: '0.0.0.0',
            createdBy: null,
            createdDate: null,
            editedBy: null,
            editedDate: null
        };

        $scope.partnerAppDetail.ipRanges.push(ipRestriction);
    };

    $scope.removeIpRange = function(ip){
        var idx =  $scope.partnerAppDetail.ipRanges.indexOf( ip );
        $scope.partnerAppDetail.ipRanges.splice( idx, 1 );
    };

    $scope.setImageValue = function ($files, productLogo) {
        var file = $files[0];

        if (window.File) {
            var reader = new FileReader();
            reader.onload = function (e) {
                $scope.$apply(function () {
                    productLogo.image = e.target.result;
                });
            };
            reader.readAsDataURL(file);
        }
        else {
            $upload.upload({url: '/utility/filetobase64', file: file})
                .success(function (data) {
                    productLogo = data;
                })
                .error(function (data) {
                    alert(data);
                });
        }
    };

    $scope.close = function () {
        dialog.close(null);
    };

    $scope.resetPassword = function(){
        $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Generate new client secret", "Field gets cleared and will reset on save!").open();
        $scope.partnerAppDetail.clientSecret = null
    };

    $scope.removeImage = function(){
        if ($scope.partnerAppDetail.productLogo.image != null ){
            $scope.partnerAppDetail.productLogo.image = null;
        }
    };

    $scope.save = function (form)
    {
        var executeSave = function() {
            $scope.partnerAppDetail.custodianRestrictions = $scope.current.selectedItems.length > 0 ? $scope.current.selectedItems : [];
            if ($scope.partnerAppDetail.productLogo.image != null )
                $scope.partnerAppDetail.productLogo.image =  $scope.partnerAppDetail.productLogo.image.remove('data:image/jpeg;base64,');
            $http({ method: args.method, url: args.url, data:$scope.partnerAppDetail, trackerMsg: args.trackerMsg })
                .then(function(response) {
                    if(args.id > 0){
                        dialog.close($scope.partnerAppDetail.id);
                    }else{
                        dialog.close(response.data.id);
                    }
                });
        };

        if (form.$valid){
            var args = $scope.partnerAppDetail.id > 0 ? {method: "PUT", url:'/Security/PartnerApps/' + $scope.partnerAppDetail.id, id: $scope.partnerAppDetail.id, trackerMsg: "Saving partner app " + $scope.partnerAppDetail.id} :
                                                        {method: "POST", url:'/Security/PartnerApps',  trackerMsg: "Adding new partner app" + $scope.partnerAppDetail.partnerName};

            if (partnerAppDetail.contactEmailInvalid) {
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Email", "Please enter a valid contact email.").open();
                return;
            }
            if (partnerAppDetail.supportEmailInvalid) {
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Email", "Please enter a valid support email.").open();
                return;
            }
            if ($scope.partnerAppDetail.useCustodianRestrictions && $scope.current.selectedItems.isEmpty()) {
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Custodian Restrictions", "Please select one custodian when enabling this restriction").open();
                return;
            }
            if ($scope.partnerAppDetail.useIpRestrictions && $scope.partnerAppDetail.ipRanges.isEmpty()) {
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> IP Restrictions", "Please enter an IP range when enabling this restriction").open();
                return;
            }
            executeSave();
        } else {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Partner App", "One or more fields on the partner app form are invalid or required.").open();
        }

    };

    $scope.current = {selectedItems:[]};
    $scope.partnerAppDetail = null;
    init();
});
'use strict';

var storedCostBasisListCtrl = app.controller('StoredCostBasisListCtrl', function StoredCostBasisListCtrl( $scope, $http, $dialog, $routeParams, $oasRights, $timeout, $portfolio, $location, entities, views, dates ) {

    $scope.rightsTaxCenter = $oasRights.forCode("TAXCENTERMAINTAIN");
    $scope.rightsPortfolioAudit = $oasRights.forCode("PORTFOLIOLISTSAPP");
    $scope.rightsHH = $oasRights.forCode("CLIENTS");
    $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
    $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
    $scope.rightsAst = $oasRights.forCode("ASSETS");
    $scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");


    //PRIVATE VARIABLES

    // PRIVATE METHODS
    function search( ) {
        $portfolio.customSearch(entities.account.value, [entities.client.value, entities.registration.value, entities.account.value, entities.asset.value])
            .then(function(result) {
                if(result) {
                    $location.url('/tax/' + $routeParams.type + '?entity=' + result.entity + '&entityId=' + result.item.id);
                }
            });
    }

    function init( ) {
        $http.get("/Confirm/DownloadFormats/Simple", {trackerMsg: 'Loading download formats'})
            .then(function (response) {
                $scope.downloadFormats = response.data;
            });

        $http.get("/Confirm/DownloadSources/Simple", {trackerMsg: 'Loading download sources'})
            .then(function (response) {
                $scope.downloadSources = response.data;
            });
    }

    function openEditor( isNew, account ) {
        return $dialog.editor('tools/tax/editors/views/' + $routeParams.type + '.html', 'StoredCostBasisEditCtrl', {args: function () {
            return {
                type: $routeParams.type,
                isNew: isNew,
                account: account,
                id: $scope.selectedIds[0],
                defaultTab: {name: "General", active: true, code: "general"},
                assetId: $scope.current.selectedAssetId,
                assetName: $scope.current.selectedAssetName
            };
        }}).open().then(function (rslt) {
            if( rslt ) {
                $http.post('/Confirm/TaxCenter/UpdateTaxErrorAudit', [$scope.current.selectedAssetId], {trackerMsg: 'Running error checks on asset ' + $scope.current.selectedAssetId} );

                $http.get('/Portfolio/' + $routeParams.type + '/' + rslt.id, {tracker: null}).then(function(r){
                    $scope.$broadcast( 'event:taxcenter-lots-action', {action: isNew ? 'add-item' : 'update-item', item: r.data } );
                });

            }
        });
    }


    // PUBLIC METHODS
    $scope.refreshGrid = function( ) {
        dates.startDate.value = $scope.current.filterStartDate;
        $http.post('/Settings/UserOptions/stored_cost_list_start_date', dates.startDate ).then(function( response ) {
            dates.startDate.id = response.data.id;
        });

        $scope.$broadcast('event:taxcenter-lots-action', {action: 'refresh-grid'});
    };

    $scope.openEditor = function( isNew ) {
        if( $scope.current.selectedAccountId == 0) {
            $portfolio.customSearch(entities.account.value, [entities.account.value])
                    .then(function(rslt) {
                        if( rslt ) {
                            var promptedAccount = { id: rslt.item.id };
                            openEditor( isNew, promptedAccount );
                        }
                    });
        } else {
            var gridAccount = { id: $scope.current.selectedAccountId };
            openEditor( isNew, gridAccount );
        }
    };

    $scope.runReport = function( ) {
        $portfolio.runReport( $scope.current.selectedEntity.entity, $scope.current.selectedEntity.id );
    };

    $scope.goToHigher = function( urlLevel ) {
        if( urlLevel == 'households' && $scope.current.selectedHouseholdId > 0 ) {
            $portfolio.goTo( urlLevel, entities.client.value, $scope.current.selectedHouseholdId );
        } else if( urlLevel == 'registrations' && $scope.current.selectedRegistrationId > 0 ) {
            $portfolio.goTo( urlLevel, entities.registration.value, $scope.current.selectedRegistrationId );
        } else if( urlLevel == 'accounts' && $scope.current.selectedRegistrationId > 0 ) {
            $portfolio.goTo( urlLevel, entities.account.value, $scope.current.selectedAccountId );
        } else if( urlLevel == 'assets' && $scope.current.selectedAssetId > 0 ) {
            $portfolio.goTo( urlLevel, entities.asset.value, $scope.current.selectedAssetId );
        }
    };

    $scope.goToLower = function( urlLevel ) {
        $portfolio.goTo( urlLevel, entities.asset.value, $scope.current.selectedAssetId );
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:taxcenter-lots-action', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    };


    // LISTENERS
    $scope.$on("event:cost-basis-stored-select", function(e, args) {
        if( args.length === 0 ) return;
        $scope.current.selectedHouseholdId = args[0].clientId;
        $scope.current.selectedRegistrationId = args[0].registrationId;
        $scope.current.selectedAccountId = args[0].accountId;
        $scope.current.selectedAssetId = args[0].assetId;
        $scope.current.selectedAssetName = args[0].assetId + ' : ' + args[0].productTicker + ' (' + args[0].productName +')';
    });


    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.loadForOptions = [
        {id: 1, name: "All"},
        {id: 2, name: "Format"},
        {id: 3, name: "Source"}
    ];

    $scope.current = {
        selectedHouseholdId: 0,
        selectedRegistrationId: 0,
        selectedAccountId: $routeParams.entity == 7 && $routeParams.entityId > 0 ? $routeParams.entityId : 0,
        selectedAssetId: 0,
        selectedEntity: {entity: $routeParams.entity, id: $routeParams.entityId},
        view : views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        gridURL: $routeParams.entity > 0 && $routeParams.entityId > 0 ? '/Portfolio/' + $routeParams.type : '',
        filterStartDate: Date.create(dates.startDate.value),
        filterEndDate: Date.create('today'),
        selectedLoadFor: $routeParams.downloadSourceId ? 3 : 1,
        selectedFormat: 0,
        selectedSource: $routeParams.downloadSourceId ? parseInt($routeParams.downloadSourceId) : 0,
        showLoadFor: $routeParams.downloadSourceId ? false : true
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    }}];

    if( ( !$routeParams.entity || !$routeParams.entityId ) && !$routeParams.downloadSourceId ) {
        search( );
    } else {
        init( );
    }

});

storedCostBasisListCtrl.loadStoredCostListDates = ["$http","$q", function( $http, $q ) {

    var loadPromises = [];
    loadPromises.push( $http.get('/Settings/UserOptions/stored_cost_list_start_date?defaultValue=beginning of this year', {trackerMsg: 'Loading default start date' } ) );

    return $q.all(loadPromises).then(function(results) {
        results.push( angular.copy(results[0]));
        results[1].data.value = Date.create('today'); // Temp fix until end date can be more intuitive.
        return { startDate : results[0].data, endDate : results[1].data };
    });

}];

storedCostBasisListCtrl.loadStoredCostView = ["$http","$route", function( $http, $route ) {
    return $http.get('/Settings/Views/' + $route.current.params.type +'dto', {trackerMsg : 'Loading stored cost view'})
        .then(function(response){
            return response.data;
        });
}];
'use strict';

var storedCostBasisAuditListCtrl = app.controller('StoredCostBasisAuditListCtrl', function StoredCostBasisAuditListCtrl( $scope, $http, $dialog, $routeParams, $oasRights, $timeout, $portfolio, $location, entities, views, storedDataSource ) {
    $scope.rightsTaxCenter = $oasRights.forCode("TAXCENTERAPP");
    $scope.rightsTaxCenterMaintain = $oasRights.forCode("TAXCENTERMAINTAIN");
    $scope.rightsCostBasis = $oasRights.forCode("COSTBASIS");
    $scope.rightsPortfolioAudit = $oasRights.forCode("PORTFOLIOLISTSAPP");
    $scope.rightsHH = $oasRights.forCode("CLIENTS");
    $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
    $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
    $scope.rightsAst = $oasRights.forCode("ASSETS");
    $scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");
    $scope.checkUncheck = {};
    let costBasisType = getcostBasisType();

    // PRIVATE METHODS
    function init( ) {
        $http.get("/Confirm/DownloadFormats/Simple", {trackerMsg: 'Loading download formats'})
            .then(function (response) {
                $scope.downloadFormats = response.data;
            });

        $http.get("/Confirm/DownloadSources/Simple", {trackerMsg: 'Loading download sources'})
            .then(function (response) {
                $scope.downloadSources = response.data;
            });
    }

    function openEditor( isNew, account ) {
        if( $scope.selectedIds[0] < 1 ) {
            isNew = true;
        }
        var d = $dialog.editor('tools/tax/editors/views/' + $routeParams.type + '.html', 'StoredCostBasisEditCtrl', {args: function () {
            return {
                type: $routeParams.type,
                isNew: isNew,
                account: account,
                id: $scope.selectedIds[0],
                defaultTab: {name: "General", active: true, code: "general"},
                assetId: $scope.current.selectedAssetId,
                assetName: $scope.current.selectedAssetName
            };
        }});

        d.open().then(function (rslt) {
            if( rslt ) {
                runAuditCheckAndUpdate( isNew, rslt );
            }
        });
    }

    function runAuditCheckAndUpdate( isNew, costRecord ) {
        $http.post('/Confirm/TaxCenter/UpdateTaxErrorAudit', [$scope.current.selectedAssetId], {trackerMsg: 'Running error checks on asset ' + $scope.current.selectedAssetId} )
            .then(function ( ) {
                //$scope.$broadcast( 'event:taxcenter-audit-lots-action', {action: isNew ? 'add-item' : 'update-item', item: costRecord } );
                $scope.refreshGrid( );
            });
    }

    function getcostBasisType(){
        let type = ($location.path()).split('/');
        return type[type.length-1];
    }

    function updateItems(items){
        if(items.length > 0)$scope.$broadcast('event:taxcenter-audit-lots-action', {action: 'update-items', items: items});
    }

    function updateCheckUncheck(){
        let ret = {check:false, uncheck:false};
        $scope.current.selectedRows.forEach(function(row){
            if(!ret.check) ret.check = (row.reviewed === false || row.reviewed === null);
            if(!ret.uncheck) ret.uncheck = (row.reviewed === true);
        });
        $scope.checkUncheck = ret;
    }
    function updateErrorList(){
        $http.post('/Confirm/TaxCenter/Errors/List', $scope.current.selectedErrorIds, {trackerMsg: "loading error list for selected rows"})
            .then(function (res) {
                $scope.current.selectedErrors = res.data;
                $scope.updateResolution($scope.current.selectedRecord.taxErrorId);
            });
    }
    // PUBLIC METHODS
    $scope.refreshGrid = function( ) {
        $scope.$broadcast('event:taxcenter-audit-lots-action', {action: 'refresh-grid'});
    };

    $scope.openEditor = function( isNew ) {
        if( $scope.current.selectedAccountId == 0) {
            $portfolio.customSearch(entities.account.value, [entities.account.value])
                .then(function(rslt) {
                    if( rslt ) {
                        var promptedAccount = { id: rslt.item.id };
                        openEditor( isNew, promptedAccount );
                    }
                });
        } else {
            var gridAccount = { id: $scope.current.selectedAccountId };
            openEditor( isNew, gridAccount );
        }
    };

    $scope.openTransaction = function( ) {
        $portfolio.openEditor( entities.transaction.value, [Math.abs($scope.selectedIds[0])], null, null, null, null );
    };

    $scope.runReport = function( ) {
        $portfolio.runReport( entities.client.value, $scope.current.selectedHouseholdId );
    };

    $scope.goToHigher = function( urlLevel ) {
        if( urlLevel == 'households' && $scope.current.selectedHouseholdId > 0 ) {
            $portfolio.goTo( urlLevel, entities.client.value, $scope.current.selectedHouseholdId );
        } else if( urlLevel == 'registrations' && $scope.current.selectedRegistrationId > 0 ) {
            $portfolio.goTo( urlLevel, entities.registration.value, $scope.current.selectedRegistrationId );
        } else if( urlLevel == 'accounts' && $scope.current.selectedRegistrationId > 0 ) {
            $portfolio.goTo( urlLevel, entities.account.value, $scope.current.selectedAccountId );
        } else if( urlLevel == 'assets' && $scope.current.selectedAssetId > 0 ) {
            $portfolio.goTo( urlLevel, entities.asset.value, $scope.current.selectedAssetId );
        }
    };

    $scope.goToLower = function( urlLevel ) {
        $portfolio.goTo( urlLevel, entities.asset.value, $scope.current.selectedAssetId );
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:taxcenter-audit-lots-action', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    };

    $scope.saveSelectedRecord = function( ) {
        if( $scope.current.selectedRecord ) {
            var isNew = [2, 3].any($scope.current.selectedRecord.auditTypeId);

            if( isNew ) {
                var costRecord = null;
                if( $scope.current.selectedRecord.auditTypeId == 2 ) {
                    costRecord = {
                        assetId: $scope.current.selectedAssetId,
                        custodianCommonCode: $scope.current.selectedCustodianCode,
                        effectiveDate: $scope.current.selectedRecord.effectiveDate,
                        acquiredDate: $scope.current.selectedRecord.acquiredDate,
                        sellDate: $scope.current.selectedRecord.sellDate,
                        costAmt: $scope.current.selectedRecord.costAmt,
                        amortizationAmt: $scope.current.selectedRecord.amortizationAmt,
                        costUnits: $scope.current.selectedRecord.costUnits,
                        method: $scope.current.selectedRecord.method,
                        proceedAmt: $scope.current.selectedRecord.proceedAmt,
                        washSaleImpacted: $scope.current.selectedRecord.washSaleImpacted,
                        isLongTerm: $scope.current.selectedRecord.isLongTerm,
                        source: $scope.user.authorization.entity == "Advisor" ? storedDataSource.advisorProvided.value : null
                    };
                } else if( $scope.current.selectedRecord.auditTypeId == 3 ) {
                    costRecord = {
                        assetId: $scope.current.selectedAssetId,
                        asOfDate: $scope.current.selectedRecord.asOfDate,
                        longTermCost: $scope.current.selectedRecord.longTermCost,
                        shortTermCost: $scope.current.selectedRecord.shortTermCost,
                        longTermUnits: $scope.current.selectedRecord.longTermUnits,
                        shortTermUnits: $scope.current.selectedRecord.shortTermUnits,
                        acquiredDate: $scope.current.selectedRecord.acquiredDate,
                        amortizationAmt: $scope.current.selectedRecord.amortizationAmt,
                        holdPeriodDate: $scope.current.selectedRecord.holdPeriodDate,
                        source: $scope.user.authorization.entity == "Advisor" ? storedDataSource.advisorProvided.value : null
                    };
                }
                $http.post('/Portfolio/' + $routeParams.type, costRecord, {trackerMsg: 'Adding stored cost record'})
                    .then(function ( r ) {
                        runAuditCheckAndUpdate( isNew, r.data );
                    });
            } else {
                $http.get('/Portfolio/' + $routeParams.type + '/' + $scope.current.selectedRecord.id, {trackerMsg : 'Loading stored cost record'})
                    .then(function(responseCostRecord) {
                        var costRecord = responseCostRecord.data;

                        if( [1].any($scope.current.selectedRecord.auditTypeId) ) {
                            costRecord.costUnits = $scope.current.selectedRecord.costUnits;
                            costRecord.amortizationAmt = $scope.current.selectedRecord.amortizationAmt;
                            costRecord.costAmt = $scope.current.selectedRecord.costAmt;
                            costRecord.proceedAmt = $scope.current.selectedRecord.proceedAmt;
                        }

                        if( [4, 5].any($scope.current.selectedRecord.auditTypeId) ) {
                            costRecord.acquiredDate = $scope.current.selectedRecord.acquiredDate;
                        }

                        if( [6, 7, 8].any($scope.current.selectedRecord.auditTypeId) ) {
                            costRecord.costAmt = $scope.current.selectedRecord.costAmt;
                        }

                        $http.put('/Portfolio/' + $routeParams.type + '/' + costRecord.id, costRecord, {trackerMsg: 'Updating record ' + costRecord.id})
                            .then(function ( r ) {
                                runAuditCheckAndUpdate( isNew, r.data );
                            });
                    });
            }
        }
    };

    $scope.setMarkedReviewed = function(bool){
        $http.post('/Confirm/TaxCenter/Action/Reviewed?reviewed='+bool, $scope.current.selectedErrorIds, {trackerMsg: 'Mark Reviewed Status: '+bool})
            .then(function(res){
                if (res.status === 204){
                    $scope.current.selectedRows.forEach(function (row) { row.reviewed = bool; });
                    updateItems($scope.current.selectedRows);
                }
            });
    };
    $scope.updateResolution = function(err){
        for(let i=0; i< $scope.current.selectedErrors.length; i++){
            let obj = $scope.current.selectedErrors[i];
            if(obj.taxErrorId === err){
                $scope.current.selectedResolutionMessage = obj.resolutionMessage;
                $scope.current.auditTypeId = obj.auditTypeId;
                break;
            }
        }
    };

    // LISTENERS
    $scope.$on("event:cost-basis-stored-audit-select", function(e, args) {
        if( args.length === 0 ) return;
        $scope.current.selectedCustodianCode = '';
        $scope.current.selectedHouseholdId = args[0].clientId;
        $scope.current.selectedRegistrationId = args[0].registrationId;
        $scope.current.selectedAccountId = args[0].accountId;
        $scope.current.selectedAssetId = args[0].assetId;
        $scope.current.selectedAssetName = args[0].assetId + ' : ' + args[0].productTicker + ' (' + args[0].productName +')';
        $scope.current.selectedErrorMessage = args[0].auditType;
        $scope.current.selectedResolutionMessage = args[0].resolutionMessage;
        $scope.current.auditTypeId = args[0].auditTypeId;

        if( $scope.current.auditTypeId == 2 ) {
            $http.get('/Portfolio/Accounts/' + $scope.current.selectedAccountId, {trackerMsg: 'Looking up account'})
                .then(function (responseAccount) {
                    $scope.current.selectedCustodianCode = responseAccount.data.custodianCode;
                });
        }

        $scope.current.selectedRecord = args[0];

        $scope.current.selectedRows = [];
        $scope.current.selectedErrorIds = [];
        args.forEach(function(row){
            $scope.current.selectedRows.push(row); //{"costBasisId": row.id,"taxErrorId": row.taxErrorId, "reviewed": row.reviewed, "errorIds":row.errorIds});
            $scope.current.selectedErrorIds = $scope.current.selectedErrorIds.concat(row.errorIds);
        });
        updateCheckUncheck();
        updateErrorList();

    });

    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.loadForOptions = [
        {id: 1, name: "All"},
        {id: 2, name: "Format"},
        {id: 3, name: "Source"}
    ];

    $scope.current = {
        selectedHouseholdId: 0,
        selectedRegistrationId: 0,
        selectedAccountId: $routeParams.entity == 7 && $routeParams.entityId > 0 ? $routeParams.entityId : 0,
        selectedAssetId: 0,
        selectedEntity: {entity: $routeParams.entity, id: $routeParams.entityId},
        selectedErrorMessage: '',
        selectedResolutionMessage: '',
        selectedCustodianCode: '',
        selectedRows:[],
        view : views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        isUnrealized : $routeParams.type.has("unrealized"),
        gridURL: '/Portfolio/' + $routeParams.type,
        filterStartDate: $routeParams.type === "custodianrealized" ? Date.create('one year ago') : Date.create('three years ago'),
        filterEndDate: Date.create('today'),
        lotsType: 'errorLots',
        selectedLoadFor: $routeParams.downloadSourceId ? 3 : 1,
        selectedFormat: 0,
        selectedSource: $routeParams.downloadSourceId ? parseInt($routeParams.downloadSourceId) : 0,
        showLoadFor: $routeParams.downloadSourceId ? false : true,
        auditTypeId: 0,
        selectedRecord: null
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    }}];

    init( )

});

storedCostBasisAuditListCtrl.loadStoredCostAuditView = ["$http","$route", function( $http, $route ) {
    return $http.get('/Settings/Views/' + $route.current.params.type +'dtowitherrors', {trackerMsg : 'Loading stored cost audit view'})
        .then(function(response){
            return response.data;
        });
}];
'use strict';

app.controller('TaxInterfacesCtrl', function TaxInterfacesCtrl($scope, $http, $oasRights, $dialog, splitIoService) {

    var enhanceAuditInterfacesFlag = 'EnahanceAuditInterfaces_28685';

    // PRIVATE METHODS
    function init( ) {

        splitIoService.getBoolTreatment(enhanceAuditInterfacesFlag).subscribe(function (isEnabled) {
            $scope.current.enhanceAuditInterfaces = isEnabled;
            if (isEnabled) {
                $scope.current.showErrorsOnly = false;
                $scope.current.lastFileDateFormat = 'MM/dd/yyyy';
            }
            $scope.refreshTaxSummary( );
        });

        $http.get("/Settings/EntityOptions/Database/Code/69STOREDDA", {trackerMsg: "Loading stored cost setting", ignoreExceptions: true})
            .then(function (response) {
                if (response && response.data) {
                    $scope.topBar.costSetting = response.data[0].value;
                }
            });

        $http.get("/Utility/BatchProcessing/GetLast?processingType=5&status=4&includeErrors=false", {trackerMsg: "Loading last stored cost run", ignoreExceptions: true})
            .then(function (response) {
                if (response && response.data) {
                    $scope.topBar.lastStoredRun = response.data.createdDate;
                }
            });

        $http.get("/Utility/MaintenanceLastRun/CostBasisGapFillUpdate", {trackerMsg: "Loading gap fill last run", ignoreExceptions: true})
            .then(function (response) {
                if (response && response.data) {
                    $scope.topBar.lastGapFillRun = response.data.startDateTime;
                }
            });
    }
    
    
    // PUBLIC METHODS
    $scope.maintainCustodialForms = function( ) {
        var dialogOpts = {
            templateUrl: "tools/tax/modals/maintainTaxForms.html",
            controller: "MaintainTaxFormsCtrl",
            dialogClass: "modal wide"
        };
        $dialog.dialog( dialogOpts ).open( );
    };

    $scope.refreshTaxSummary = function( ) {
        $http.get("/Confirm/TaxCenter/DownloadSourceSummary", {trackerMsg: "Loading summary"})
            .then(function (response) {
                if (response && response.data) {
                    if (!$scope.current.enhanceAuditInterfaces) {
                        for (var i = 0; i < response.data.length; i++) {
                            if (response.data[i].downloadFormatCostBasisType == 'None' || response.data[i].downloadFormatCostBasisType == 'Unrealized') {
                                response.data[i]['realizedErrorCount'] = response.data[i].orionRealizedErrorCount;
                            } else if (response.data[i].downloadFormatCostBasisType == 'Realized' || response.data[i].downloadFormatCostBasisType == 'Both') {
                                response.data[i]['realizedErrorCount'] = response.data[i].custodianRealizedErrorCount;
                            }

                            if (response.data[i].downloadFormatCostBasisType == 'None' || response.data[i].downloadFormatCostBasisType == 'Realized') {
                                response.data[i]['unrealizedErrorCount'] = response.data[i].orionUnrealizedErrorCount;
                            } else if (response.data[i].downloadFormatCostBasisType == 'Unrealized' || response.data[i].downloadFormatCostBasisType == 'Both') {
                                response.data[i]['unrealizedErrorCount'] = response.data[i].custodianUnrealizedErrorCount;
                            }
                        }
                    }
                    $scope.summary = response.data;
                }
            });
    };

    $scope.showDownloadFormatInfo = function( formatInformation ) {
        $dialog.messageBox("<i class='fa fa-question-circle fa-lg' aria-hidden='true'></i> Format Information", formatInformation).open();
    };
    
    
    // INITIALIZE
    $scope.rightsTaxCenter = $oasRights.forCode("TAXCENTERAPP");
    $scope.rightsMaintainTaxForms = $oasRights.forCode("TAXFORMDOWNLOADS");
    $scope.topBar = { costSetting: null, lastStoredRun: null, lastGapFillRun: null };
    $scope.dates = { startDate: Date.create( 'yesterday'), endDate: Date.create( 'today') };
    $scope.current = { showErrorsOnly: true, enhanceAuditInterfaces: false, lastFileDateFormat: 'MM/dd/yyyy hh:mm a' };

    init( );

});
'use strict';

app.controller('MaintainTaxFormsCtrl', function MaintainTaxFormsCtrl( $scope, dialog, $http, $dialog, $oasRights, API_CONFIG ) {

    // PRIVATE METHODS
    function init() {
        const ignoreExceptions = [400, 403, 415];

        $http.get("/Global/StaticFiles/CustodialCostBasisForm", { trackerMsg: "Loading tax forms", ignoreExceptions: ignoreExceptions })
            .then(function (response) {
                $scope.current.taxForms = response.data;
            }).catch(function (response) {
                if (ignoreExceptions.includes(response.status)) {
                    $dialog.actionFailed(response.data.userException.detail).open();
                }
                dialog.close(null);
            });
    }

    // PUBLIC METHODS
    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.removeTaxForm = function( f ) {
        $dialog.confirmAction("Are you sure you want to remove " + f.blobDesc + " ?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete('/Global/StaticFiles/CustodialCostBasisForm/'+ f.id ,{trackerMsg:'Deleting form'} )
                        .then(function( ) {
                            $scope.current.taxForms.remove( f );
                        });
                }
            });
    };

    $scope.downloadTaxForm = function( id ) {
        window.location.href = API_CONFIG.baseUrl + '/Global/StaticFiles/CustodialCostBasisForm/' + id + '?Authorization=' + sessionStorage.oas_token;
    };


    // WATCHES
    $scope.$watchCollection( "current.returnItem", function( newValue, oldValue ) {
        if(newValue != oldValue && newValue != null ) {
            $scope.current.taxForms.push( { id: $scope.current.returnItem.id, blobDesc: $scope.current.returnItem.blobDesc } );
        }
    });
    

    //INITIALIZE
    $scope.rightsMaintainTaxForms = $oasRights.forCode("TAXFORMDOWNLOADS");

    $scope.current = { returnItem: null, taxForms: [] };
    $scope.fileDetails = { blobDesc: '', blobType: 'CustodialCostBasisForm' };
    
    init( );
});

'use strict';

app.controller('StoredCostBasisEditCtrl', function StoredCostBasisEditCtrl($scope, $http, $dialog, $oasRights, $timeout, dialog, args, storedDataSource, $portfolio, $q) {

    // PRIVATE VARIABLES
    var storedCostOriginal = null,
        additionalInformationOriginal = null;
    var tempAsset = {
        assetClass: "",
        id: 0,
        isCustodialCash: false,
        isTradeExcluded: false,
        name: "",
        ticker: ""
    };
    var editorHotKeys;


    // PUBLIC VARIABLES
    $scope.rightsTaxCenter = $oasRights.forCode("COSTBASIS");


    // PRIVATE METHODS
    function init( ) {
        loadEnumLookUps( );
        buildMenu( );
        $scope.loadTab( args.defaultTab );
        $scope.current.selectedAccount = args.account;
        $scope.current.selectedAssetId = args.assetId;
        $scope.current.selectedAssetName = args.assetName;
        loadHotKeys();

        loadStoredCostRecord( );
    }

    function loadEnumLookUps() {
        var list = {
            storedDataSourceTypes: storedDataSource
        };

        Object.each(list, function (key, value) {
            $scope[key] = $portfolio.enumToSimpleList(value);
        });
    }

    function buildMenu() {
        $scope.menu = { categories: [ ] };
        $scope.menu.categories.push( {name: 'General', children: [] } );
        $scope.menu.categories[0].children.push( {name: 'General', active: false, code: 'general'} );
        if($scope.current.isVerbose) $scope.menu.categories[0].children.push( {name: 'Additional Information', active: false, code: 'additionalInformation'} );
    }

    function loadStoredCostRecord( ) {
        return (
            args.isNew
                ? $q.all({ portfolio: {}, additionalInformation: {} })
                : ($scope.current.isVerbose
                    ? $http.get('/Portfolio/' + args.type + '/Verbose/' + args.id, {params: {expand: 'all'}, trackerMsg : 'Loading stored cost record'}).then(function(r){return r.data})
                    : $q.all({
                        portfolio: $http.get('/Portfolio/' + args.type + '/' + args.id, {trackerMsg : 'Loading stored cost record'}).then(function(r){return r.data}),
                        additionalInformation: {}
                    })
                )
        ).then(function(r){
            $scope.storedCostRecord = r.portfolio;
            $scope.storedCostRecord.id = args.id;
            storedCostOriginal = angular.copy( $scope.storedCostRecord );

            $scope.additionalInformation = r.additionalInformation;
            additionalInformationOriginal = angular.copy( $scope.additionalInformation );

            if( !args.isNew ) tempAsset.id = $scope.current.selectedAssetId;
        });
    }

    function saveRecord( ) {
        if ( args.isNew ) $scope.storedCostRecord.assetId = $scope.current.selectedAsset.id;

        var data = $scope.current.isVerbose
            ? {
                id: args.id,
                portfolio: !angular.equals( storedCostOriginal, $scope.storedCostRecord ) ? $scope.storedCostRecord : null,
                additionalInformation: !angular.equals( additionalInformationOriginal, $scope.additionalInformation ) ? $scope.additionalInformation : null
            }
            : $scope.storedCostRecord;

        var path = $scope.current.isVerbose
            ? '/Portfolio/{type}/Verbose/'.assign(args)
            : '/Portfolio/{type}/'.assign(args);

        return $http({url: path + (args.isNew ? '' : args.id), method: args.isNew ? 'POST' : 'PUT', data: angular.copy(data), trackerMsg:'Saving stored cost record'})
            .then(function(response){
                editorHotKeys.destroy();
                dialog.close( angular.extend((response.data.portfolio || response.data),{id: response.data.id}) );
            })
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: function () { $scope.close(true); } }
            ]);
        });
    }


    // PUBLIC METHODS
    $scope.loadTab = function( child ) {
        $scope.menu.categories.each( function( c ) {
            c.children.each( function( ch ) {
                ch.active = ch.code == child.code;
            } );
        } );

        $scope.current.selectedTab = child.code;
    };

    $scope.save = function( ) {
        if(
            !angular.equals( storedCostOriginal, $scope.storedCostRecord ) ||
            !angular.equals( additionalInformationOriginal, $scope.additionalInformation ) ||
            args.isNew
        )
            return $q.resolve().then(function(){
                if( $scope.user.authorization.entity == "Advisor") {
                    var message;
                    if( args.type == 'custodianrealized' )
                        message = 'Attention: Due to the nature of how data providers deliver custodial cost basis and how Orion stores the data, this update will only be reflected in the Orion system until the next realized file containing this lot(s) is delivered to Orion.  Please have your cost basis updated at the custodian to reflect the accurate cost basis detail going forward.  Would you like to continue?';
                    else if( args.type == 'custodianunrealized' )
                        message = 'Attention: Due to the nature of how data providers deliver custodial cost basis and how Orion stores cost basis data, this update will only be reflected on Orion reports as of the specificied date.  Please have your cost basis updated at the custodian to properly reflect the accurate cost basis detail going forward.  Would you like to continue?';
                    else return $q.resolve();

                    return $dialog.confirmAction(message).open()
                        .then(function (result) {
                            if (result !== 'yes') $q.reject();
                            else return $q.resolve();
                        });
                }
            }).then(function(){
                if(
                    $scope.additionalInformation &&
                    $scope.additionalInformation.isLongTerm &&
                    !$scope.storedCostRecord.custodianRecordID
                )
                    return $dialog.messageBox(
                        'Attention',
                        'The custodian does not provide a distinct ID to track this record.  Your update may be overwritten when Orion receives the next unrealized cost basis file for this asset.'
                    ).open();
            }).then(function () {
                saveRecord( );
            });

    };

    $scope.close = function( validate ) {
        if( validate ) {
            if( !angular.equals( storedCostOriginal, $scope.storedCostRecord ) ) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };

    //watches
    $scope.$on("current.selectedAsset", function(e, args) {
        $scope.current.isAssetSelected = !(args && args.length === 0);
    });


    // INITIALIZE
    $scope.current = {
        selectedTab: args.defaultTab,
        isNew: args.isNew,
        selectedAccount: null,
        isAssetSelected: false,
        get isVerbose() {
            return args.type == 'custodianunrealized'
        }
    };
    $scope.errors = [];
    $scope.storedCostRecord = null;

    init( )

});
'use strict';

app.controller('TaxTransactionErrorsCtrl', function TaxTransactionErrorsCtrl( $scope, $http, $oasRights, views, $portfolio, entities, apps ) {

    $scope.rightsTaxCenter = $oasRights.forCode("TAXCENTERAPP");
    $scope.rightsPortfolioAudit = $oasRights.forCode("PORTFOLIOLISTSAPP");
    $scope.rightsHH = $oasRights.forCode("CLIENTS");
    $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
    $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
    $scope.rightsAst = $oasRights.forCode("ASSETS");
    $scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");


    //PRIVATE VARIABLES

    // PRIVATE METHODS

    // PUBLIC METHODS
    $scope.refreshGrid = function( ) {
        $scope.$broadcast('event:taxcenter-transaction-errors-action', {action: 'refresh-grid'});
    };

    $scope.runReport = function( ) {
        $portfolio.runReport( entities.client.value, $scope.current.selectedHouseholdId );
    };

    $scope.goToHigher = function( urlLevel ) {
        if( urlLevel == 'households' && $scope.current.selectedHouseholdId > 0 ) {
            $portfolio.goTo( urlLevel, entities.client.value, $scope.current.selectedHouseholdId );
        } else if( urlLevel == 'registrations' && $scope.current.selectedRegistrationId > 0 ) {
            $portfolio.goTo( urlLevel, entities.registration.value, $scope.current.selectedRegistrationId );
        } else if( urlLevel == 'accounts' && $scope.current.selectedRegistrationId > 0 ) {
            $portfolio.goTo( urlLevel, entities.account.value, $scope.current.selectedAccountId );
        } else if( urlLevel == 'assets' && $scope.current.selectedAssetId > 0 ) {
            $portfolio.goTo( urlLevel, entities.asset.value, $scope.current.selectedAssetId );
        }
    };

    $scope.goToLower = function( urlLevel ) {
        $portfolio.goTo( urlLevel, entities.asset.value, $scope.current.selectedAssetId );
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:taxcenter-transaction-errors-action', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openTransaction();
    };

    $scope.openTransaction = function( ) {
        $portfolio.openEditor( entities.transaction.value, [$scope.selectedIds[0]], 'Transaction', 'costBasis', apps.portfolioLists.name, null ).then(function(rslt) {
            if( rslt ) {
                var transactionID = angular.copy( $scope.selectedIds[0] );
                $http.post( '/Confirm/TaxCenter/UpdateTaxErrorAudit', [$scope.current.selectedAssetId], {trackerMsg: 'Running error checks on asset ' + $scope.current.selectedAssetId} )
                    .then(function ( ) {

                        $http.get('/Portfolio/Transactions/' + transactionID + '?returnStyle=withErrors', {trackerMsg: 'Get'})
                            .then(function (response) {
                                $scope.$broadcast('event:taxcenter-transaction-errors-action', {action: response.data.auditType.length > 0 ? "update-item" : "delete-item", item: response.data});
                        });

                });
            }
        });
    };


    // LISTENERS
    $scope.$on("event:taxcenter-transaction-errors-select", function(e, args) {
        if( args.length === 0 ) return;
        $scope.current.selectedHouseholdId = args[0].clientId;
        $scope.current.selectedRegistrationId = args[0].registrationId;
        $scope.current.selectedAccountId = args[0].accountId;
        $scope.current.selectedAssetId = args[0].assetId;
        $scope.current.selectedErrorMessage = args[0].auditType;
        $scope.current.selectedResolutionMessage = args[0].resolutionMessage;
    });


    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        selectedHouseholdId: 0,
        selectedRegistrationId: 0,
        selectedAccountId: 0,
        selectedAssetId: 0,
        selectedEntity: null,
        selectedErrorMessage: '',
        selectedResolutionMessage: '',
        view : views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        startDate: Date.create('three years ago'),
        endDate: Date.create('today')
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    }}];

});
'use strict';

var taxLotAssignmentsCtrl = app.controller('TaxLotAssignmentsCtrl', function TaxLotAssignmentsCtrl( $scope, $http, $dialog, $routeParams, $oasRights, $timeout, $portfolio, entities, views) {

    //Public methods
    $scope.openLotSelector = function(){

        var dialogOpts = {
            dialogClass: "modal wide",
            templateUrl : "tax-lots-selector.html",
            controller : "TaxLotSelectorCtrl",
            asset: $scope.current.selectedAsset
        };

        var transactionId = 0;
        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function(rsltLot){
                if (rsltLot){
                    transactionId = rsltLot.transactionId;
                    var d = $dialog.editor('tax-lot-selector.html', 'TaxLotsCtrl',  {
                        args: function () {
                            return {asset: $scope.current.selectedAsset, transaction: rsltLot};
                        }
                    });

                    d.open().then(function (rslt) {
                        if(rslt){
                            var tempTaxLot = [];
                            rslt.lots.forEach(function(lot){
                                var tempLotObj = {
                                    id: lot.id,
                                    transactionId: transactionId,
                                    tranBuyId: lot.pkTransaction,
                                    noUnits: lot.unitsSold,
                                    description: lot.description, taxLotType: 1};
                                tempTaxLot.push(tempLotObj);
                            });
                            updateTranTaxLot(tempTaxLot, rslt.isNew)
                        }
                    });
                }
            });
    };

    function updateTranTaxLot(taxLot, isNew){

        var newOnes = taxLot.findAll(function(n) {
            return n['id'] == null
        });
        var existingOnes = taxLot.findAll(function (n){return n['id'] != null;});
        if (newOnes){
            $http.post('/Portfolio/TaxLots', newOnes , {trackerMsg: 'Adding new transaction tax lot' })
                .then(function(response){
                    if(response){
                        $scope.$broadcast('event:tax-lot-assignment-action', {action: 'refresh-grid'});
                    }
                })
        }

        if(existingOnes){
            $http.put('/Portfolio/TaxLots', existingOnes, {trackerMsg:'Saving transation tax lot'} )
                .then(function(response){
                    if(response){
                        $scope.$broadcast('event:tax-lot-assignment-action', {action: 'refresh-grid'});
                    }
                })
        }

        //var args = !isNew ? {method: "PUT", url: '/Portfolio/TaxLots', trackerMsg: "Saving tax lot information " + taxLot[0].transactionId} : {method: "POST", url:'/Portfolio/TaxLots',  trackerMsg: "Adding new transaction tax lot"};
        //$http({method: args.method, url: args.url, data:taxLot, trackerMsg: args.trackerMsg})
        //    .then(function(response){
        //        if(response){
        //            $scope.$broadcast('event:tax-lot-assignment-action', {action: 'refresh-grid'});
        //        }
        //    })
    }

    function init() {
        $scope.rightsTaxCenter = $oasRights.forCode("TAXCENTERMAINTAIN");
        $scope.rightsPortfolioAudit = $oasRights.forCode("PORTFOLIOLISTSAPP");
        $scope.rightsHH = $oasRights.forCode("CLIENTS");
        $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
        $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
        $scope.rightsAst = $oasRights.forCode("ASSETS");
        $scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");

        if (!$routeParams.entityId) {
            $scope.searchForEntity();
        }else{
            $http.get('/Portfolio/Accounts/' + $routeParams.entityId, {trackerMsg:'Retrieving account information'} )
                .then(function(response) {
                    if( response.data.id > 0 ) {
                        $scope.current.selectedAccount = { id: response.data.id, name: response.data.name, number: response.data.number };
                    }
                });

        }
    }

    function setEntity(entity, entityId){
        $scope.current.selectedAccount = {id: entity.item ? entity.item.id :  parseInt(entityId), name: entity.item ? entity.item.name : '', number: entity.item ? entity.item.number : ''};
    }

    $scope.refreshGrid = function( ) {
        $scope.$broadcast('event:tax-lot-assignment-action', {action: 'refresh-grid'});
    };

    $scope.searchForEntity = function( ) {
        $portfolio.customSearch(entities.account.value, [entities.account.value])
            .then(function(rslt) {
                if( rslt ) {
                    setEntity(rslt);
                }
            });
    };

    $scope.$watch('current.selectedAccount', function(newValue, oldValue){
       if(newValue == oldValue || newValue == null) return;
        loadGrid();
    });

    $scope.$on('event:tax-lot-assignment-select', function (e, args) {
        e.stopPropagation();
        if (args.length === 0) return;
        $scope.current.selectedAsset = args[0];
        $scope.current.selectedAssetId = args[0].id;
    });



    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        selectedAccountId: 0,
        selectedAssetId: 0,
        selectedAccount: null,
        selectedAsset: null,
        view : views[0],
        url: ''
    };

    function loadGrid() {
        $scope.current.url = '/Portfolio/Assets';
        $http.get('/Portfolio/Accounts/' + $scope.current.selectedAccount.id, {trackerMsg: 'Retrieving account information'})
            .then(function (response) {
               $scope.refreshGrid();
            });
    }

    init();

});

app.controller('TaxLotSelectorCtrl', function TaxLotSelectorCtrl( $http,$scope, $route, dialog, listSectionData ) {
    //PRIVATE VARIABLES
    var dataItemsEvent = "event: data-items";

    $scope.taxLotSelectorConfig = {
        getUrl: null,       //'/Trading/Models/' + modelId  +'?includeAccounts=true',
        listName: 'Sell Lot Selector',
        template: 'tax-lot-selector-list-item.html',
        headerTemplate: 'tax-lot-selector-list-header.html',
        icon: 'fa fa-users',
        addItemEvent: null,
        rebalanceItemEvent: null,
        loadDataItemsEvent: dataItemsEvent,
        selectEnabled: true,
        multiSelectEnabled: false,
        nameProperty: 'Trans Date',
        dataProperty: 'taxLotSelectorList',
        selectProperty: 'transDate',
        sortFields: {transDate: "Trans Date",accountId: 'Account Id', units: "Units"},
        //listFilter: function(item, value) {return (item.name && item.name.toLowerCase().indexOf(value) !== -1) || (item.fundName && item.fundName.toLowerCase().indexOf(value) !== -1);}
        listFilter: ['transDate'],
        additionalLinks: []
    };

    function init(){
        $http.get('/Portfolio/TaxLots/GetCostBasis/' + $scope.current.asset.id, {trackerMsg: 'Loading tax lots'})
            .then(function(response){
                $scope.taxLotSelectorList = response.data ? response.data : [];
                listSectionData.dataItems = $scope.taxLotSelectorList;
                $scope.$broadcast(dataItemsEvent);
            });
    }

    $scope.close = function(){
        var tempLot =  angular.copy(listSectionData.dataItems.find({selected: true}));
        listSectionData.dataItems = [];
        dialog.close(tempLot);
    };

    $scope.current = {asset: dialog.options.asset, showFilterRow: false,registrationName:'', accountName: '', accountId: 4,url: "", productName: "name", transAmount: "value", ticker: "leftInfo", bgColor: "rgba(170, 170, 170, 1)",   icon: "fa fa-orion-transaction" };
    $scope.taxLotSelectorList= [];
    init();
});

app.controller('TaxLotsCtrl', function TaxLotsCtrl( $http,$scope, $route, dialog, args, listSectionData ) {
    //PRIVATE VARIABLES
    var dataItemsTaxLotEvent = "event: data-items-list";
    var isNew = false;

    function init(){
        $scope.current.registrationName = args.asset.registrationName;
        $scope.current.accountId = args.asset.accountId;
        $scope.current.leftInfo = args.asset.accountNumber;
        $scope.current.rightInfo = Math.abs(args.transaction.units);

        $http.get('/Portfolio/TaxLots/' + $scope.current.transaction.transactionId  +"/AssetBuyTransactions/" +  $scope.current.transaction.transDate, {trackerMsg: 'Loading tax lots'})
            .then(function(response){
                $scope.taxLotList = response.data ? response.data : [];
                listSectionData.dataItems =  $scope.taxLotList;
                $scope.$broadcast(dataItemsTaxLotEvent);
                $http.get('/Portfolio/TaxLots?transactionId=' + $scope.current.transaction.transactionId,{trackerMsg: 'Checking existing lots'})
                    .then(function(response){
                        if(response && response.data.length > 0){
                            //update right side
                            response.data.forEach(function(item){
                                updateSectionLots([item]);
                            });
                            $scope.current.pkTranTaxLot = response.data[0].id;
                        }
                    });
            });


    }
    function updateSectionLots(selectedSections){
        if(selectedSections.length == 0){
            $scope.lotSections = angular.copy(selectedSections);
        }else{

            selectedSections.forEach(function(lotItem){
                var temp = $scope.taxLotList.find({pkTransaction:lotItem.tranBuyId});
                if (temp){
                    $scope.lotSections.remove(temp);
                    temp.selected = true;
                    temp.id = lotItem.id;
                    $scope.lotSections.push(temp); // = angular.copy([temp]);
                    //$scope.current.remainingTaxLots =- $scope.current.sellLots ;
                    //$scope.current.tempSum = $scope.lotSections.sum('noUnits');
                    $scope.updateSectionTotals([temp])
                }else{
                    var temp2 = $scope.lotSections.find({id:lotItem.id});
                    if(!temp2 ){
                        lotItem.id = null;
                        lotItem.unitsSold = 1;
                        $scope.lotSections.push(lotItem);
                    }else{
                        $scope.lotSections = angular.copy(selectedSections);
                    }
                    updateLotTotals();
                }
            });
        }
        $scope.disableGenerateTrade = $scope.lotSections.length == 0;

    }
    function updateLotTotals(){
        $scope.current.remainingTaxLots = $scope.current.sellLots - ($scope.current.tempSum - $scope.lotSections.sum('unitsSold'));
        //   $scope.current.lotTitle = temp > 0 ? 'Over': 'Remaining';
    }

    function deleteLotItem(item){
        //delete
        if(item.id){
            $http.delete('/Portfolio/TaxLots/' + item.id , {trackerMsg:'Removing tax lots from list'})
                .then(function(response){

                })
        }
    }

    $scope.updateSectionTotals = function(section, e){
        $scope.current.remainingTaxLots = $scope.current.sellLots - section.unitsSold;
     //   updateLotTotals();
    };

    $scope.selectAllLots = function(){
        $scope.lotSections = [];

        listSectionData.dataItems.forEach(function(item){
            item.selected = true;
        });
        $scope.lotSections = angular.copy(listSectionData.dataItems);
        $scope.disableGenerateTrade = $scope.lotSections.length == 0;
        updateLotTotals();
    };

    $scope.removeAllLots = function(){
        listSectionData.dataItems.forEach(function(item){
            item.selected = false;
        });
        $scope.lotSections = [];
        $scope.disableGenerateTrade = $scope.lotSections.length == 0;
        updateLotTotals();
    };



    $scope.close = function(){
        $scope.lotSections = [];
        dialog.close(null);
    };

    $scope.createOrderLots = function (){
        var taxLot = {transactionId: $scope.current.transaction.transactionId, lots: $scope.lotSections};
        dialog.close(taxLot);
    };

    $scope.$on("selectedCount", function(e, args) {
        $scope.current.tempSum = args.sum('noUnits');
        updateSectionLots(args);
    });

    $scope.$on("unSelectedCount", function(e, args) {
        deleteLotItem(args[0]);
    });




    $scope.$watch("lotSections", function(newValue, oldValue) {
        if (!newValue || newValue === oldValue) return;
        updateLotTotals();
    }, true);

    $scope.taxLotListConfig = {
        getUrl: null,       //'/Trading/Models/' + modelId  +'?includeAccounts=true',
        listName: 'TaxLotList',
        template: 'tax-lot-list-item.html',
        headerTemplate: 'tax-lot-list-header.html',
        icon: 'fa fa-users',
        addItemEvent: null,
        rebalanceItemEvent: null,
        loadDataItemsEvent: dataItemsTaxLotEvent,
        selectEnabled: true,
        multiSelectEnabled: true,
        nameProperty: 'transDate',
        dataProperty: 'taxLotList',
        selectProperty: 'pkTransaction',
        sortFields: {transDate: "Trans Date", description: 'Description', transAmount: 'Trans Amount', unitsRemaining: "Units Remaining"},
        //listFilter: function(item, value) {return (item.name && item.name.toLowerCase().indexOf(value) !== -1) || (item.fundName && item.fundName.toLowerCase().indexOf(value) !== -1);}
        listFilter: ['transDate'],
        additionalLinks: []
    };

    $scope.current = {pkTranTaxLot:0, tempSum: 0,remainingTaxLots: 0, sellLots:args.transaction.units, asset:args.asset, transaction: args.transaction, lotTitle: 'Remaining', showFilterRow: false,registrationName:'', accountName: '', accountId: null,url: "", productName: "name", transAmount: "value", ticker: "leftInfo", bgColor: "rgba(170, 170, 170, 1)",   icon: "fa fa-orion-transaction", rightInfo: "Sell Units", leftTitle: "Ticker"};
    $scope.disableGenerateTrade = true;
    $scope.lotSections =[];
    $scope.taxLotList = [];
    init();
});


'use strict';

const maintainLoginListCtrl = app.controller('MaintainLoginListCtrl', function MaintainLoginListCtrl($scope, $http, $timeout, $routeParams, $oasRights, $dialog, views, entities, loginEntities, activeState, $settings) {
    // PRIVATE VARIABLES
    const loginEntityId = loginEntities.find({entity: getDefaultLoginEntity()}).id;
    let selectedRows = [];


    // PRIVATE METHODS
    function init() {
        $scope.rightsML = $oasRights.forCode('MUL_USERS');
        $scope.rightsReset = $oasRights.forCode('MUL_RESETUSER');
        $scope.rightsSameEntity = $oasRights.forCode('MUL_SAMEENTITY');

        $scope.current.activeState = $settings.getSetting('activeState');
        $scope.current.params = `loginEntityId=${loginEntityId}&isActive=${$scope.current.activeState.queryString}&currentDbOnly=${$scope.current.currentDbOnly}`;
    }

    function getDefaultLoginEntity() {
        return $routeParams.loginentity === 'Broker Dealer' ? 'Broker/Dealer' : $routeParams.loginentity;
    }

    function sendGridEvent(action, payload) {
        $scope.$broadcast('event:maintain-login-list-action', Object.assign({action: action}, payload));
    }

    function showTempPassword(password) {
        $dialog.messageBox('<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Temporary Password', `The temporary password is: ${password}`).open();
    }


    // PUBLIC METHODS
    $scope.openEditor = function (mode) {
        const isNewOrCopy = mode === 'new' || mode === 'copy';
        const entityType = entities.find({name: getDefaultLoginEntity()});

        const editDialog = function (entityObj) {
            const d = $dialog.editor('tools/views/maintain-login-edit.html', 'MaintainLoginEditCtrl', {
                args: function () {
                    return {
                        id: mode === 'new' ? 0 : selectedRows[0].id,
                        isNewOrCopy: isNewOrCopy,
                        defaultTab: {name: 'General', active: true, code: 'general'},
                        entityObj: entityObj || {id: 0},
                        entityType: entityType,
                        loginEntityId: loginEntityId,
                        userId: mode === 'new' ? '' : selectedRows[0].userId
                    };
                },
                roles: window.maintainLoginEditCtrl.loadRoles
            });

            d.open().then(function (userInfo) {
                if (!userInfo) {
                    return;
                }

                if (userInfo.errorMessage) {
                    $dialog.actionFailed(userInfo.errorMessage).open();
                }

                if ($scope.user.authorization.entity === 'Administrator' && entityType === 'administrator') {
                    sendGridEvent(isNewOrCopy ? 'add-item' : 'update-item', {item: userInfo});
                } else {
                    $http.get(`/Security/Users?userId=${userInfo.id}&loginEntityId=${loginEntityId}`, {trackerMsg: 'Getting new user data'})
                        .then(function(res) {
                            sendGridEvent(isNewOrCopy ? 'add-items' : 'update-items', {items: res.data});
                        });
                }

                if (isNewOrCopy && userInfo.password) {
                    showTempPassword(userInfo.password);
                }
            });
        };

        if (mode === 'new' && ['ria', 'administrator', 'cotenant'].none(entityType)) {
            if (['client', 'brokerDealer', 'representative', 'repAccountManager'].any(entityType)) {
                $dialog.search(entityType, "Add New", null, {isActive: true})
                    .open()
                    .then(function (result) {
                        if (result) {
                            editDialog(result);
                        }
                    });
            } else {
                const entityEnum = entities[entityType];
                $http.get(entityEnum.simpleUrl, {trackerMsg: `Loading ${entityEnum.name.pluralize()}`})
                    .then(function (response) {
                        $dialog.inputBox('Add New', entityEnum.name, response.data)
                            .open()
                            .then(function (result) {
                                if (result) {
                                    editDialog(result);
                                }
                            });
                    });
            }
        } else {
            editDialog();
        }
    };

    $scope.deleteUser = function () {
        $dialog.confirmAction('This cannot be undone.  If you delete this user, you will lose all record of any activity this user performed in the Orion system.  It is recommended to Inactivate the user. Are you sure you want to proceed?')
            .open()
            .then(function (result) {
                if (result !== 'yes') {
                    return;
                }

                const userToDelete = selectedRows[0].id;

                $http.delete(`/Security/Users/${userToDelete}`, {trackerMsg: 'Deleting user'})
                    .then(function () {
                        sendGridEvent('get-items', {callbackFn: function (data) {
                            const idsToDelete = data.findAll({id: userToDelete}).map($scope.current.idProperty);

                            sendGridEvent('delete-items', {items: idsToDelete});
                        }});
                    });
            });
    };

    $scope.toggleActiveStatus = function (newStatus) {
        if (!newStatus) {
            const activeUsersWithContactType = selectedRows.findAll(row => row.isActive && ['Approved', 'Main Contact/Firm Admin'].any(row.contactType));

            if (activeUsersWithContactType.length) {
                const message = `Contact Type must be changed for the following users before inactivating.<br /><br /><ul><li>${activeUsersWithContactType.map('userId').unique().join('</li><li>')}</li></ul>`;
                $dialog.messageBox('<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Inactivation Canceled', message).open();
                return;
            }
        }

        const usersToUpdate = selectedRows.findAll({isActive: !newStatus}).map('id').unique();

        $http.put(`/Security/Users/Action/Activate?activate=${newStatus}`, usersToUpdate, {trackerMsg: 'Updating user status'})
            .then(function () {
                sendGridEvent('get-items', {callbackFn: function (data) {
                    const rowsToUpdate = data.findAll(row => usersToUpdate.any(row.id));

                    rowsToUpdate.forEach(row => {
                        row.isActive = newStatus;
                        row[newStatus ? 'activeDate' : 'inactiveDate'] = Date.create().formatted();
                    });

                    sendGridEvent('update-items', {items: rowsToUpdate});
                }});
            });
    };

    $scope.resetUser = function () {
        const resetChoices = [{id: 'display', name: 'Show me the temp password'}, {id: 'email', name: 'Send email to the user'}];

        $dialog.inputBox('Reset Action', 'Password Delivery', resetChoices, {inputValue: resetChoices[0]})
            .open()
            .then(function (selectedChoice) {
                if (!selectedChoice) {
                    return;
                }

                const userToReset = selectedRows[0].id;

                $http.put(`/Security/Users/${userToReset}/Action/Password/Reset?sendEmail=${selectedChoice.id === 'email'}`, null, {trackerMsg: 'Resetting user password'})
                    .then(function (response) {
                        const data = response.data;
                        if (data.errorMessage) {
                            $dialog.actionFailed(data.errorMessage).open();
                            return;
                        }

                        if (selectedChoice.id === 'display') {
                            showTempPassword(data.password);
                        }

                        sendGridEvent('get-items', {callbackFn: function (data) {
                            const rowsToUpdate = data.findAll({id: userToReset});

                            rowsToUpdate.forEach(row => {
                                row.isReset = true;
                            });

                            sendGridEvent('update-items', {items: rowsToUpdate});
                        }});
                    });
            });
    };

    $scope.setGridParamsAndReload = function () {
        $settings.setSetting('activeState', $scope.current.activeState);
        $scope.current.params = `loginEntityId=${loginEntityId}&isActive=${$scope.current.activeState.queryString}&currentDbOnly=${$scope.current.currentDbOnly}`;

        $timeout(function () {
            sendGridEvent('refresh-grid');
        });
    };

    $scope.allowUserAction = function (right) {
        if (!$scope.rightsML[right]) {
            return false;
        }

        const entityType = entities.find({name: getDefaultLoginEntity()});

        if (($scope.user.authorization.entity === 'Administrator' && entityType === 'administrator') || ($scope.user.authorization.entity === 'Advisor' && entityType === 'ria')) {
            return $scope.rightsSameEntity[right];
        }

        return true;
    };

    $scope.slickGridDoubleClick = function() {
        if ($scope.selectedIds.length === 1) {
            $scope.openEditor('edit');
        }
    };

    $scope.exportToExcel = function () {
        sendGridEvent('export-data');
    };

    $scope.editRole = function(){
        const d = $dialog.editor('tools/views/roles-editor.html', 'RolesEditorCtrl', {
            args: function () {
                return {
                    id: selectedRows[0].roleId,
                    isNew: false,
                    defaultTab: {name: 'General', active: true, code: 'general'},
                    loginEntityObj: undefined
                };
            }
        });

        d.open().then(function (updatedRole) {
            if (!updatedRole || updatedRole.name === selectedRows[0].role) {
                return;
            }

            sendGridEvent('get-items', {callbackFn: function (data) {
                const rowsToUpdate = data.findAll({roleId: updatedRole.id});

                rowsToUpdate.forEach(row => {
                    row.role = updatedRole.name;
                });

                sendGridEvent('update-items', {items: rowsToUpdate});
            }});
        });
    };


    // INITIALIZE
    $scope.views = views;

    $scope.selectedIds = []; // == ids for admins, profileIds for everyone else
    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        isActive: false,
        activeStates: activeState,
        idProperty: $routeParams.loginentity === 'Administrator' ? 'id' : 'profileId',
        allowEditRole: false,
        currentDbOnly: true
    };

    $scope.current.hotKeyActions = [{
        combo:'ALT+E',
        command: $scope.slickGridDoubleClick
    }];

    init();


    //EVENT LISTENERS
    $scope.$on('event:maintain-login-select', function (e, args) {
        selectedRows = args;

        if (selectedRows.length === 0) {
            return;
        }

        $scope.current.isActive = selectedRows[0].isActive;
        $scope.current.allowEditRole = selectedRows[0].alClientId === $scope.user.authorization.alClientId && $oasRights.canUpdate('MUL_ROLES') && ['Administrator', 'Advisor', 'Representative'].any($routeParams.loginentity);
    });
});

maintainLoginListCtrl.loadLoginEntities = ['$http', function ($http) {
    return $http.get('/Security/LoginEntities', {cache: true, trackerMsg: 'Loading login entities'})
        .then(function (response) {
            return response.data;
        });
}];

maintainLoginListCtrl.loadViews = ['$http', '$route', function ($http, $route) {
    const dto = $route.current.params.loginentity === 'Administrator' ? 'UserInfoDto' : 'UserInfoWithProfileDto';

    return $http.get(`/Settings/Views/${dto}`, {trackerMsg: 'Loading views'})
        .then(function(response) {
            return response.data;
        });
}];

'use strict';

var maintainLoginEditCtrl = app.controller('MaintainLoginEditCtrl', function MaintainLoginEditCtrl($scope, $http, $oasRights, $dialog, $timeout, dialog, entities, args, roles, tokenFactory, manageUserService) {
    // PRIVATE VARIABLES
    let userInfoGeneralOriginal, editorHotKeys;
    const currentEntity = entities[args.entityType];
    const hideRole = (currentEntity === entities.client && filterRoles('Client').length <= 1) || [entities.subAdvisor, entities.wholesaler].any(currentEntity);


    // PRIVATE METHODS
    function init() {
        loadRights();
        buildMenu();

        $scope.current.roles = roles;
        $scope.menu.each(function (category) {
            const menuItem = category.items.find({code: args.defaultTab.code});
            if (menuItem) {
                $scope.loadTab(menuItem);
                return false;
            }
        });
        loadHotKeys();
    }

    function filterRoles(entityLevel) {
        return roles.findAll({loginEntityDescription: entityLevel});
    }

    function loadRights() {
        $scope.rightsRoles = $oasRights.forCode('MUL_ROLES');

        if (($scope.user.authorization.entity === 'Administrator' && $scope.current.entityType === 'administrator') || ($scope.user.authorization.entity === 'Advisor' && $scope.current.entityType === 'ria')) {
            $scope.current.canEdit = $oasRights.canUpdate('MUL_USERS') && $oasRights.canUpdate('MUL_SAMEENTITY');
            return;
        }

        $scope.current.canEdit = $oasRights.canUpdate('MUL_USERS');
    }

    function buildMenu() {
        const menu = [
            {name: "General", items: [
                {name: "User Information", code: "general", enabled: true, load: [loadUserInfo]},
                {name: "Profiles", code: "profiles", enabled: true, load: [loadUserInfo]}
            ]},
            {name: "Details", items: [
                {name: "Login History", code: "history", enabled: true, load: [loadLoginHistory]}
            ]}
        ];

        menu.forEach(function (category) {
            category.items.remove({enabled: false});
        });
        menu.remove({items: []});

        $scope.menu = menu;
    }

    function loadUserInfo() {
        if ($scope.userInfoGeneral) {
            return;
        }

        if ($scope.user.authorization.entity === 'Administrator') {
            $http.get("/Security/PartnerApps/Simple", {cache: true, trackerMsg: 'Loading partner apps'})
                .then(function (response) {
                    $scope.partnerApps = response.data.sortBy('partnerName');
                });
        }

        $http.get(`/Security/Users/${$scope.current.entityType}/ContactTypes`, {cache: true, trackerMsg: 'Loading contact types'})
            .then(function (response) {
                $scope.contactTypes = response.data;
            });
        
        if ($scope.current.id === 0) {
            $http.get(`/Security/Users/${$scope.current.entityType}/${$scope.current.entityObj.id}`, {trackerMsg: 'Loading user info'})
                .then(function (response) {
                    $scope.userInfoGeneral = response.data;

                    const defaultProfile = {
                        alClientId: $scope.user.authorization.alClientId,
                        advisorName: $scope.user.authorization.alClientName,
                        entity: entities[$scope.current.entityType].name,
                        entityName: $scope.userInfoGeneral.entityName,
                        loginEntityId: $scope.current.loginEntityId,
                        entityId: $scope.current.entityObj.id,
                        isUserDefault: true,
                        isInCurrentDb: true,
                        roleId: null,
                        hideRole: hideRole,
                    };

                    $scope.userInfoGeneral.profiles.push(defaultProfile);
                });
        } else {
            $http.get(`/Security/Users/${$scope.current.id}`, {trackerMsg: 'Loading user info'})
                .then(function (response) {
                    const data = response.data;

                    if ($scope.current.isNewOrCopy) {
                        $scope.userInfoGeneral = {
                            isActive: true,
                            contactType: data.contactType,
                            company: data.company,
                            jobTitle: data.jobTitle,
                            profiles: data.profiles
                        };
                    } else {
                        $scope.userInfoGeneral = data;
                    }

                    $scope.userInfoGeneral.profiles.forEach(function (item) {
                       item.hideRole = hideRole;
                    });
                    $scope.userInfoGeneral.emailInvalid = false;
                    userInfoGeneralOriginal = angular.copy($scope.userInfoGeneral);
                });
        }
    }

    function loadLoginHistory() {
        if ($scope.loginHistory) {
            return;
        }

        if ($scope.current.isNewOrCopy) {
            $scope.loginHistory = [];
        } else {
            $http.get("/Security/Users/" + $scope.current.id + "/LoginActivity?startDate=" + Date.create('30 days ago').formatted(), {trackerMsg: 'Loading user login history'})
                .then(function (response) {
                    $scope.loginHistory = response.data;
                });
        }
    }

    function loadHotKeys() {
        editorHotKeys = new window.HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: function () { $scope.close(true); } }
            ]);
        });
    }


    // PUBLIC METHODS
    $scope.invalidEmail = function (invalid) {
        $scope.userInfoGeneral.emailInvalid = invalid;
    };

    $scope.setEmail = function (value) {
        $scope.userInfoGeneral.email = value;
    };

    $scope.loadTab = function (menuItem) {
        $scope.current.selectedTab = menuItem;
        menuItem.load.forEach(function (fn) {fn();});
    };

    $scope.viewRole = function (roleId) {
        $dialog.editor('tools/views/roles-editor.html', 'RolesEditorCtrl', {args: function() {return {id: roleId, isNew: false, defaultTab: {code: "apps"}};}}).open();
    };

    $scope.showContactTypeInfo = function () {
        const message = `
        <h6>Main Contact/Firm Admin</h6>
        <ul>
            <li>Manages the users within Firm</li>
            <li>Ability to change global entity options when user in this level contacts Orion</li>
            <li>Orion will service these users with their current access based upon selections in their role</li>
            <li>Main point of contact for Orion communication</li>
        </ul>
        <h6>Approved Contact</h6>
        <ul>
            <li>Standard Firm Operations employee</li>
            <li>Orion will service these users with their current access based upon selections in their role</li>
        </ul>
        <h6>Not Approved Contact</h6>
        <ul>
            <li>This user should not be contacting Orion directly, as determined by the Main Contact/Firm Admin</li>
            <li>Firm Admin should also not grant this user access to "Contact Us" functionality</li>
            <li>Default Representative level</li>
            <li>If user contacts Orion, Orion will refer these users back to the firm's main contact/firm admin for support</li>
        </ul>
        <h6>No Longer with Firm</h6>
        <ul>
            <li>This level indicates the user is no longer working with the firm</li>
            <li>This should be updated immediately upon separation of employment</li>
            <li>Orion will not share any information with this level of user</li>
        </ul>
        `;
        $dialog.messageBox('Contact Types', message).open();
    };

    $scope.save = function () {
        const abortMessages = [];

        if ($scope.userInfoGeneral?.emailInvalid) {
            abortMessages.push("Invalid email address.");
        }

        ['userId', 'lastName', 'email'].forEach(requiredField => {
            if (($scope.userInfoGeneral[requiredField] || '').isBlank()) {
                abortMessages.push(`${requiredField.titleize()} is a required field.`);
            }
        });

        if (!$scope.userInfoGeneral.isActive && ['Approved', 'Main Contact/Firm Admin'].any($scope.userInfoGeneral.contactType)) {
            abortMessages.push(`Contact Type cannot be set to ${$scope.userInfoGeneral.contactType} when user is inactive.`);
        }

        if ($scope.userInfoGeneral.profiles.count({isUserDefault: true}) !== 1) {
            abortMessages.push('There must be only one profile marked as default.');
        }

        if ($scope.userInfoGeneral.profiles.any({entityName: 'Does not exist'})) {
            abortMessages.push('There is a profile that is associated with an entity that does not exist.');
        }

        if (abortMessages.length) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Data", '<ul class="unstyled"><li>' + abortMessages.join('</li><li>') + '</li></ul>').open();
            return;
        }

        if (!angular.equals(userInfoGeneralOriginal, $scope.userInfoGeneral)) {
            $scope.userInfoGeneral.entityName = $scope.userInfoGeneral.lastName + ($scope.userInfoGeneral.firstName ? ", " + $scope.userInfoGeneral.firstName : "");

            if ($scope.current.isNewOrCopy) {
                const createNewUser = function (sendEmail) {
                    $http.post('/Security/Users?sendEmail=' + sendEmail, $scope.userInfoGeneral, {trackerMsg: 'Adding new user'})
                        .then(function (response) {
                            const data = response.data;

                            if (sendEmail) {
                                data.password = null;
                            }

                            dialog.close(data);
                        });
                };

                const resetChoices = [{id: 'display', name: 'Show me the temp password'}, {id: 'email', name: 'Send email to the user'}];

                $dialog.inputBox('New User', 'Password Delivery', resetChoices, {inputValue: resetChoices[0]})
                    .open()
                    .then(function (result) {
                        if (result) {
                            createNewUser(result.id === 'email');
                        }
                    });
            } else {
                $http.put('/Security/Users/' + $scope.current.id, $scope.userInfoGeneral, {trackerMsg: 'Saving changes for ' + $scope.userInfoGeneral.userId})
                    .then(function (response) {
                        dialog.close(response.data);
                    });
            }
        }
    };

    $scope.close = function (validate) {
        if (validate) {
            if (!angular.equals(userInfoGeneralOriginal, $scope.userInfoGeneral)) {
                $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true});
            } else {
                dialog.close();
            }
        } else {
            dialog.close();
        }
    };

    $scope.addProfile = function () {
        const args = {
            entity: entities[$scope.current.entityType].name,
            loginEntityId: $scope.current.loginEntityId,
            hideRole: hideRole
        };

        $dialog.dialog({templateUrl: "loginentity-selector.html", controller: "LoginEntitySelectorCtrl", resolve: {args: function () {return args;}}})
            .open()
            .then(function (result) {
                if (result && $scope.userInfoGeneral.profiles.none({alClientId: result.alClientId, entity: result.entity, entityId: result.entityId})) {
                    $scope.userInfoGeneral.profiles.push(result);
                   manageUserService.signalProfilesCreated( [result]);
                }
            });
    };

    $scope.syncFromRepGroup = function () {
        $http.get("/Utility/Groupings/Simple?usedFor=RepProfileAssignment", {trackerMsg: 'Loading rep groups'})
            .then(function (response) {
                if (!response.data.length) {
                    $dialog.actionFailed("No rep groups have been created.  Please visit the Grouping Manager app to create some.").open();
                    return;
                }

                $dialog.inputBox("Rep Groups", "Select Group", response.data, {inputValue: response.data[0]})
                    .open()
                    .then(function (selectedGroup) {
                        if (!selectedGroup) {
                            return;
                        }

                        $http.get("/Utility/Groupings/" + selectedGroup.id + "?doRefresh=true", {trackerMsg: 'Loading reps from ' + selectedGroup.name})
                            .then(function (response) {
                                const groupProfiles = response.data.details.findAll({entity: entities.representative.name});
                                const currentProfiles = $scope.userInfoGeneral.profiles.findAll({entity: entities.representative.name, isInCurrentDb: true});
                                const roleList = [{id: null, name: "No Role"}].add(filterRoles(entities.representative.name));
                                const changeSets = [{name: "Profiles to Add", roleId: null, roleList: roleList, items: []}, {name: "Profiles to Remove", items: []}];

                                groupProfiles.forEach(function (rep) {
                                    if (currentProfiles.none({entityId: rep.entityId})) {
                                        changeSets[0].items.push({
                                            alClientId: $scope.user.authorization.alClientId,
                                            advisorName: $scope.user.authorization.alClientName,
                                            entity: entities.representative.name,
                                            entityName: rep.name,
                                            loginEntityId: $scope.current.loginEntityId,
                                            entityId: rep.entityId,
                                            isUserDefault: false,
                                            roleId: null,
                                            isInCurrentDb: true
                                        });
                                    }
                                });

                                currentProfiles.forEach(function (profile) {
                                    if (groupProfiles.none({entityId: profile.entityId})) {
                                        changeSets[1].items.push(profile);
                                    }
                                });

                                if (changeSets.sum(function (set) {return set.items.length;}) === 0) {
                                    $dialog.actionComplete("This user's profile list is already in sync with the <b>" + selectedGroup.name + "</b> group.").open();
                                    return;
                                }

                                $dialog.dialog({templateUrl: "sync-profiles-from-group.html", controller: "SyncProfilesFromGroupCtrl", resolve: {changeSets: function() {return changeSets;}}})
                                    .open()
                                    .then(function (changeSets) {
                                        if (!changeSets) {
                                            return;
                                        }

                                        changeSets[0].items.forEach(function (itemToAdd) {
                                            itemToAdd.roleId = changeSets[0].roleId;
                                            $scope.userInfoGeneral.profiles.push(itemToAdd);
                                        });

                                        changeSets[1].items.forEach(function (itemToRemove) {
                                            $scope.userInfoGeneral.profiles.remove(itemToRemove);
                                        });
                                    });
                            });
                    });
            });
    };

    $scope.addRepProfiles = function () {
        const selectRepProfiles = function (database) {
            tokenFactory.getDatabaseToken(database.id)
                .then(function (token) {
                    const headers = {Authorization: "Session " + token};

                    $http.get('/Portfolio/Representatives/Simple', {trackerMsg: 'Loading reps', headers: headers})
                        .then(function (response) {
                            const currentRepProfiles = $scope.userInfoGeneral.profiles.findAll({entity: entities.representative.name, alClientId: database.id});
                            const availableRepProfiles = [];

                            response.data.forEach(function (rep) {
                                if (rep.isActive && currentRepProfiles.none({entityId: rep.id})) {
                                    availableRepProfiles.push({id: rep.id, name: '(' + rep.id + ') ' + rep.name, entityName: rep.name});
                                }
                            });

                            if (!availableRepProfiles.length) {
                                $dialog.actionFailed("There are no additional rep profiles available to add.").open();
                                return;
                            }

                            const args = {
                                selectionType: 1979, //Custom
                                availableItems: availableRepProfiles,
                                selectedSelected: [],
                                maxSelect: 25
                            };

                            $dialog.dialog({templateUrl: "app/modals/available-select.html", controller: "AvailableSelectCtrl", resolve: {availableSelectedArgs: function() {return args;}}})
                                .open()
                                .then(function (selectedReps) {
                                    if (!selectedReps) {
                                        return;
                                    }

                                    $http.get("/Security/Roles?loginEntityId=" + $scope.current.loginEntityId, {trackerMsg: 'Loading roles', headers: headers})
                                        .then(function (response) {
                                            const roleList = [{id: null, name: "No Role"}].add(response.data);

                                            $dialog.inputBox("Role Assignment", "Role", roleList, {inputValue: roleList[0]})
                                                .open()
                                                .then(function (selectedRole) {
                                                    if (!selectedRole) {
                                                        return;
                                                    }

                                                    const reps = selectedReps.map( rep => ({
                                                        alClientId: database.id,
                                                        advisorName: database.clientName,
                                                        entity: entities.representative.name,
                                                        entityName: rep.entityName,
                                                        loginEntityId: $scope.current.loginEntityId,
                                                        entityId: rep.id,
                                                        isUserDefault: false,
                                                        roleId: selectedRole.id,
                                                        roleName: selectedRole.name,
                                                        isInCurrentDb: database.id === $scope.user.authorization.alClientId
                                                    }));
                                                    $scope.userInfoGeneral.profiles.push( ...reps);
                                                    manageUserService.signalProfilesCreated(reps);
                                                });
                                        });
                                });
                        });
                });
        };

        if ($scope.user.authorization.databaseCount > 1) {
            $http.get("/Authorization/Databases", {cache: true, trackerMsg: 'Loading databases'})
                .then(function (response) {
                    const dbList = response.data;

                    $dialog.inputBox("Select Database", "Database", dbList, {nameProperty: 'clientName', inputValue: dbList.find({id: $scope.user.authorization.alClientId})})
                        .open()
                        .then(function (selectedDb) {
                            if (!selectedDb) {
                                return;
                            }

                            selectRepProfiles(selectedDb);
                        });
                });
        } else {
            selectRepProfiles({id: $scope.user.authorization.alClientId, clientName: $scope.user.authorization.alClientName});
        }
    };

    $scope.removeProfile = function (profile) {
        $scope.userInfoGeneral.profiles.remove(profile);
    };


    // INITIALIZE
    $scope.current = angular.copy(args);
    $scope.errors = [];

    init();
});

maintainLoginEditCtrl.loadRoles = ["$http", function ($http) {
    return $http.get("/Security/Roles", {trackerMsg: 'Loading available roles'})
        .then(function (response) {
            return response.data;
        });
}];

app.controller('SyncProfilesFromGroupCtrl', function SyncProfilesFromGroupCtrl($scope, dialog, changeSets) {
    //PUBLIC METHODS
    $scope.submit = function () {
        dialog.close($scope.changeSets);
    };

    $scope.cancel = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.changeSets = changeSets;
});

app.controller('LoginEntitySelectorCtrl', function LoginEntitySelectorCtrl($scope, $http, dialog, entities, args, tokenFactory) {

    //PRIVATE METHODS
    function init() {
        if ([entities.ria.name, entities.brokerDealer.name, entities.representative.name, entities.repAccountManager.name].any(args.entity) && $scope.user.authorization.databaseCount > 1) {
            $http.get("/Authorization/Databases", {cache: true, trackerMsg: 'Loading databases'})
                .then(function (response) {
                    $scope.databases = response.data;
                    $scope.current.database = $scope.databases.find({id: $scope.user.authorization.alClientId});
                });
        } else {
            $scope.current.database = {id: $scope.user.authorization.alClientId, clientName: $scope.user.authorization.alClientName};
        }

        getRoles();
    }

    function getRoles() {
        $http.get("/Security/Roles?loginEntityId=" + args.loginEntityId, {trackerMsg: 'Loading roles', headers: {Authorization: "Session " + $scope.current.token}})
            .then(function (response) {
                $scope.roles = response.data;
                $scope.current.role = $scope.roles.find({isGlobal: true}) || null;
            });
    }


    // PUBLIC METHODS
    $scope.updateDbToken = function () {
        $scope.current.selectedEntity = null;

        tokenFactory.getDatabaseToken($scope.current.database.id)
            .then(function (token) {
                $scope.current.token = token;
                getRoles();
            });
    };

    $scope.add = function () {
        const selectedProfile = {
            alClientId: $scope.current.database.id,
            advisorName: $scope.current.database.clientName,
            loginEntityId: args.loginEntityId,
            entity: $scope.current.entityType,
            entityName: $scope.current.selectedEntity ? $scope.current.selectedEntity.name : null,
            entityId: $scope.current.selectedEntity ? $scope.current.selectedEntity.id : 0,
            roleId: $scope.current.role ? $scope.current.role.id : null,
            roleName: $scope.current.role ? $scope.current.role.name : null,
            isUserDefault: false,
            isInCurrentDb: $scope.current.database.id === $scope.user.authorization.alClientId,
            hideRole: $scope.current.hideRole
        };

        dialog.close(selectedProfile);
    };

    $scope.cancel = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.current = {
        token: sessionStorage.oas_token,
        entityType: args.entity,
        hideRole: args.hideRole
    };

    init();
});

'use strict';

app.controller('NewUserImportCtrl', function NewUserImportCtrl($scope, $http, $location, $dialog, $oasRights, splitIoService) {
    $scope.current = {wizardStep: 0, animation: 'slide-right', executing: false, selectedItems: [], creationMethod: 'download', isNewUserImportFeatureFlagEnabled: false};

    //PRIVATE METHODS
    function init() {
        splitIoService.getBoolTreatment('pi_newuserimport_usenewcomponent_oc8414').subscribe((isEnabled) => {
            $scope.current.isNewUserImportFeatureFlagEnabled = isEnabled;

            if (isEnabled) {
                return;
            }

            $http.get("/Settings/Apps/manageUserLogin", {cache: true, trackerMsg: 'Loading user levels'})
                .then(function (response) {
                    var userLevels = response.data.categories.find({name: "Manage Users"}).pages
                        .map(function (page) {
                            return {name: page.name.singularize(), description: page.name.toLowerCase(), linkUrl: page.routeUrl.from(1), loginEnum: page.routeUrl.split('/').last()};
                        });

                    $scope.userLevels = userLevels.inGroupsOf(2);

                    if (userLevels.length.isOdd()) {
                        $scope.userLevels.last().pop();  //removes the null that inGroupsOf() added
                    }

                    $scope.current.userLevel = userLevels.last();
                });
        });
    }


    //PUBLIC METHODS
    $scope.back = function() {
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep -= 1;
    };

    $scope.next = function() {
        $scope.current.animation = 'slide-right';
        $scope.current.wizardStep += 1;
    };

    $scope.jumpBackTo = function(index) {
        if ($scope.current.executing) return;

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };

    $scope.isStepIncomplete = function() {
        switch ($scope.current.wizardStep) {
            case 1:
                return $scope.current.selectedItems.length === 0 || $scope.current.selectedItems.count({isValid: true}) === 0;
            case 2:
                return !$oasRights.canUpdate("MUL_NEWUSERIMPORT");
            default:
                return false;
        }
    };

    $scope.submitImport = function() {
        $scope.current.executing = true;

        const sendEmails = $scope.current.creationMethod === "email";

        $http.post("/Security/Users/Action/Import?sendEmails=" + sendEmails, $scope.current.selectedItems.exclude({isValid: false}), {trackerMsg: "Creating new users"})
            .then(function (response) {
                const totalAttempted = response.data.length;
                const errorRecords = response.data.exclude({errorMessage: null});
                let msg = `${totalAttempted - errorRecords.length} of ${totalAttempted} users imported without error.<br/>`;

                if (errorRecords.length > 0) {
                    msg += `<hr><b>${errorRecords.length} Errored Records</b><br/><br/>`;
                    errorRecords.forEach(function (item) {
                        msg += `ID: ${item.profiles[0].entityId || "N/A"} UserName: ${item.userId}<br/>Error: ${item.errorMessage}<br/><br/>`;
                    });
                }

                $dialog.actionComplete(msg).open();

                if (!sendEmails) {
                    window.location.href = response.headers("location") + "?Authorization=" + sessionStorage.oas_token;
                }

                $location.path($scope.current.userLevel.linkUrl);
            })
            .catch(function () {
                $scope.current.executing = false;
            });
    };


    //INITIALIZE
    $scope.wizardSteps = ["User Level", "Excel Upload", "Batch Options"];
    init();
});

'use strict';

app.controller('RolesListCtrl', function RolesListCtrl($scope, $http, $oasRights, $dialog, views, entities, $timeout, loginEntities) {
    // PRIVATE VARIABLES

    
    // PRIVATE METHODS
    function init() {
        $scope.rightsML = $oasRights.forCode("MUL_ROLES");

        if ($scope.user.authorization.entity !== "Administrator") {
            [entities.client.name, entities.subAdvisor.name, entities.wholesaler.name, entities.thirdParty.name, entities.cotenant.name].forEach(function (entityName) {
                $scope.current.params = ($scope.current.params ? $scope.current.params += "&" : "") + "excludeLoginEntityId=" + loginEntities.find({entity: entityName}).id;
            });
        }
    }

    function refreshGrid() {
        $timeout(function () {
            $scope.$broadcast('event:roles-list-action', {action: 'refresh-grid'});
        });
    }


    // PUBLIC METHODS
    $scope.copyRole = function () {
        var edtDialog = function (loginEntityObj) {
            var d = $dialog.editor('tools/views/roles-editor.html', 'RolesEditorCtrl', {
                args: function () {
                    return {
                        id: $scope.selectedIds[0],
                        isNew: false,
                        isCopy: true,
                        defaultTab: {name: "General", active: true, code: "general"},
                        loginEntityObj: loginEntityObj
                    };
                }
            });

            d.open().then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast('event:roles-list-action', {action: 'add-item', item: rslt});
                }
            });
        };

        edtDialog()
    };

    $scope.openEditor = function (isNew) {
        var edtDialog = function (loginEntityObj) {
            var d = $dialog.editor('tools/views/roles-editor.html', 'RolesEditorCtrl', {
                args: function () {
                    return {
                        id: isNew ? 0 : $scope.selectedIds[0],
                        isNew: isNew,
                        defaultTab: {name: "General", active: true, code: "general"},
                        loginEntityObj: loginEntityObj
                    };
                }
            });

            d.open().then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast('event:roles-list-action', {action: isNew ? 'add-item' : 'update-item', item: rslt});
                }
            });
        };

        if (isNew) {
            $http.get("/Security/LoginEntities/UserCanUpdate", {cache: true, trackerMsg: 'Loading login entities'})
                .then(function (response) {
                    var allowedLoginEntities = response.data.map(function (ent) {
                        return {id: ent.id, name: ent.entity};
                    });

                    $http.get("/Settings/Apps/manageUserLogin", {cache: true, trackerMsg: 'Loading user levels'})
                        .then(function (response) {
                            var userLevels = response.data.categories.find({name: "Manage Users"}).pages
                                .map(function (page) {
                                    return {name: page.name.singularize(), loginEnum: page.routeUrl.split('/').last() == 'Broker Dealer' ? 'Broker/Dealer' : page.routeUrl.split('/').last()};
                                });

                            var loginLevels = [];
                            userLevels.forEach(function (item) {
                                var loginEntity = allowedLoginEntities.find({name: item.loginEnum});
                                if (loginEntity && [entities.administrator.name, entities.ria.name, entities.brokerDealer.name, entities.representative.name, entities.repAccountManager.name, entities.cotenant.name].any(loginEntity.name)) {
                                    loginLevels.push(loginEntity);
                                }
                            });

                            $dialog.inputBox('Add New', 'Login Level', loginLevels)
                                .open()
                                .then(function (result) {
                                    if (result) {
                                        edtDialog(result);
                                    }
                                });
                        });
                });
        } else {
            edtDialog();
        }
    };

    $scope.deleteRole = function () {
        if ($scope.current.assignedProfiles > 0) {
            var config = {
                id: $scope.selectedIds[0],
                loginEntityId: $scope.current.loginEntityId
            };
            var d = $dialog.dialog({
                templateUrl: 'replace-role-selector.html', controller: 'ReplaceRoleSelectorCtrl', resolve: {
                    args: function () {
                        return config;
                    }
                }
            });

            d.open().then(function (rslt) {
                if (rslt) {
                    $http.delete('/Security/Roles/' + $scope.selectedIds[0], {trackerMsg: 'Deleting role'})
                        .then(function () {
                            refreshGrid();
                        });
                }
            });
        }
        else {
            $http.delete('/Security/Roles/' + $scope.selectedIds[0], {trackerMsg: 'Deleting role'})
                .then(function () {
                    refreshGrid();
                });
        }
    };

    $scope.slickGridDoubleClick = function () {
        if ($scope.selectedIds.length === 1)
            $scope.openEditor(false);
    };


    // INITIALIZE
    $scope.views = views;

    $scope.selectedIds = []; //entityId's
    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        params: null,
        roleName: null,
        loginEntityId: null,
        isGlobal: null,
        assignedProfiles: null
    };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: $scope.slickGridDoubleClick
    }];

    init();


    //EVENT LISTENERS
    $scope.$on("event:roles-select", function (e, args) {
        if (args.length === 0) return;

        $scope.current.roleName = args[0].name;
        $scope.current.loginEntityId = args[0].loginEntityId;
        $scope.current.isGlobal = args[0].isGlobal;
        $scope.current.assignedProfiles = args[0].assignedProfiles;
    });
});

app.controller('ReplaceRoleSelectorCtrl', function ReplaceRoleSelectorCtrl($scope, $http, dialog, args) {
    //PRIVATE METHODS
    function init() {
        $http.get("/Security/Roles?loginEntityId=" + $scope.current.loginEntityId, {cache: false, trackerMsg: 'Loading roles for loginentity'})
            .then(function (response) {
                $scope.replaceRoles = response.data;
                $scope.replaceRoles.remove({id: $scope.current.roleIdOrig})
            });
    }


    // PUBLIC METHODS
    $scope.process = function () {
        //get all used
        $http.get("/Security/Roles/" + $scope.current.roleIdOrig + "/Users", {cache: true, trackerMsg: 'Loading users for role'})
            .then(function (response) {
                var usersForRole = response.data;
                var list = usersForRole.map(function (user) {
                    return user.profileId;
                });

                $http({method: "PUT", url: '/Security/Roles/' + $scope.current.roleId + "/Action/AssignUsers", data: list, trackerMsg: "Assigning role to users"})
                    .then(function (result) {
                        dialog.close(true);
                    });
            });
    };

    $scope.cancel = function () {
        dialog.close(false);
    };


    //INITIALIZE
    $scope.current = {
        roleIdOrig: parseInt(args.id),
        loginEntityId: args.loginEntityId,
        roleId: 0
    };

    init();
});
'use strict';

app.controller('RolesEditorCtrl', function RolesEditorCtrl($scope, $http, $oasRights, $dialog, $timeout, dialog, args, entities) {
    // PRIVATE VARIABLES
    let roleGeneralOriginal, editorHotKeys;


    // PRIVATE METHODS
    function init() {
        loadRights();
        buildMenu();

        $scope.menu.each(function (category) {
            const menuItem = category.items.find({code: args.defaultTab.code});
            if (menuItem) {
                $scope.loadTab(menuItem);
                return false;
            }
        });
        loadHotKeys();
    }

    function loadRights() {
        $scope.rightsML = $oasRights.forCode("MUL_ROLES");
        $scope.rightsPriv = $oasRights.forCode("MUL_PRIVILEGES");
        $scope.rightsHomepageAdmin = $oasRights.forCode("HOMEPAGEADMIN");
        $scope.rightsPortfolioViewAdmin = $oasRights.forCode("PORTFOLIOVIEWADMIN");
    }

    function buildMenu() {
        const menu = [
            {name: "General", enabled: true, items: [
                {name: "Role Information", code: "general", enabled: true, load: [loadRole]}
            ]},
            {name: "Privileges", enabled: true, items: [
                {name: "Apps", code: "apps", enabled: true, load: [loadRole]},
                {name: "Records", code: "records", enabled: true, load: [loadRole]},
                {name: "Actions", code: "actions", enabled: true, load: [loadRole]},
                {name: "Advanced", code: "advanced", enabled: true, load: [loadRole]},
                {name: "Feature Flags", code: "featureFlags", enabled: $scope.user.authorization.entity === "Administrator", load: [loadRole]}
            ]},
            {name: "Dashboards", enabled: $scope.user.authorization.entity === "Administrator", items: [
                {name: "Homepage", code: "dashboards", enabled: $scope.rightsHomepageAdmin.canRead, load: [loadRole]},
                {name: "Portfolio View", code: "pvdashboards", enabled: $scope.rightsPortfolioViewAdmin.canRead, load: [loadRole]}
            ]},
            {name: "Users", enabled: true, items: [
                {name: "Assigned", code: "users", enabled: true, load: [loadUsersForRole]}
            ]}
        ];

        menu.forEach(function (category) {
            category.items.remove({enabled: false});
        });
        menu.remove({items: []});

        $scope.menu = menu;
    }

    function loadRole() {
        if ($scope.roleGeneral) {
            return;
        }

        if ($scope.current.isNew) {
            $scope.roleGeneral = {
                name: '',
                loginEntityId: $scope.current.loginEntityObj.id,
                loginEntityDescription: $scope.current.loginEntityObj.name,
                tokenLife: 10, /*Default to 10 hours*/
                canEdit: true
            };

            $http.get("/Security/Privileges?loginEntityId=" + $scope.current.loginEntityObj.id, {trackerMsg: 'Loading privileges'})
                .then(function (response) {
                    const data = response.data;
                    data.forEach(function (privilege) {
                        privilege.availableAccessType = privilege.loginEntityAllowedAccess;
                        delete privilege.loginEntityAllowedAccess;
                    });
                    $scope.roleGeneral.privileges = data;

                    processRole($scope.roleGeneral);
                });
        } else {
            $http.get("/Security/Roles/" + $scope.current.roleId, {trackerMsg: 'Loading role info'})
                .then(function (response) {
                    $scope.roleGeneral = response.data;

                    if ($scope.current.isCopy) {
                        $scope.roleGeneral.name = '';
                        $scope.roleGeneral.id = 0;
                        $scope.roleGeneral.canEdit = true;
                        $scope.roleGeneral.isGlobal = false;
                    }

                    if ($scope.roleGeneral.isGlobal && $scope.user.authorization.entity !== "Administrator") {
                        $scope.rightsML.canUpdate = false;
                    }

                    processRole($scope.roleGeneral);
                });
        }
    }

    function isValidTokenLifeTime(value) {
        const item = {
            message: '',
            isValid: false,
        };

        if (value > 12) {
            item.message = 'Token life cannot exceed 12 hours.';
        } else if (value < 0.5) {
            item.message = 'Token life must be at least 0.5 hour (30 minutes)';
        } else if ((value * 60) % 30 !== 0) {
            item.message = 'Token life must be entered in a 0.5 hour increment.';
        } else {
            item.message = 'Token life will last ' + value + ' hours for this user.';
            item.isValid = true;
        }

        return item;
    }


    function loadUsersForRole() {
        if ($scope.usersForRole) {
            return;
        }

        if ($scope.current.isNew) {
            $scope.usersForRole = [];
        } else {
            $http.get("/Security/Roles/" + $scope.current.roleId + "/Users", {trackerMsg: 'Loading users for role'})
                .then(function (response) {
                    $scope.usersForRole = response.data.unique("userId").sortBy("loginUserId");
                });
        }
    }

    function processRole(roleGeneral) {
        roleGeneral.privileges.remove({availableAccessType: "None"});

        roleGeneralOriginal = angular.copy(roleGeneral);

        const groups = roleGeneral.privileges.sortBy("name").groupBy("type");
        Object.each(groups, function (key, value) {
            groups[key] = value.groupOn("categoryName", true);
        });

        if (groups.AppLinks) {
            groups.AppLinks.forEach(function (category) {
                const apps = groups.Apps.find({ name: category.name })?.items ?? [];

                for (let j = category.items.length - 1; j >= 0; j--) {
                    const appLink = category.items[j];
                    const index = apps.findIndex(function (app) {return appLink.name.startsWith(app.name);});
                    apps.insert(appLink, index + 1);
                }
            });
        }

        $scope.privileges = groups;
    }

    function loadHotKeys() {
        editorHotKeys = new window.HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: function () { $scope.close(true); } }
            ]);
        });
    }

    // PUBLIC METHODS
    $scope.toggleDefaultDashboard = function (defaultProperty, dashboard) {
        $scope.roleGeneral[defaultProperty] = dashboard.id === $scope.roleGeneral[defaultProperty] ? null : dashboard.id;
    };

    $scope.addDashboard = function (collectionProperty) {
        $http.get(`/Security/Roles/AvailableDashboards?isPortfolioView=${collectionProperty === 'pvDashboards'}`, {trackerMsg: 'Loading available dashboards', cache: true})
            .then(function (response) {
                const currentDashboardIds = $scope.roleGeneral[collectionProperty].map("id");
                const availableDashboards = response.data.filter(function (dashboard) {
                    return currentDashboardIds.none(dashboard.id);
                });

                if (!availableDashboards.length) {
                    $dialog.actionFailed("There are no other dashboards available to assign.").open();
                    return;
                }

                $dialog.inputBox("Add New", "Select Dashboard", availableDashboards, {inputValue: availableDashboards[0]})
                    .open()
                    .then(function (result) {
                        if (!result) {
                            return;
                        }

                        $scope.roleGeneral[collectionProperty].push(result);
                    });
            });
    };

    $scope.removeDashboard = function (collectionProperty, dashboard) {
        const defaultProperty = collectionProperty === 'pvDashboards' ? 'defaultPVDashboardId' : 'defaultDashboardId';

        if (dashboard.id === $scope.roleGeneral[defaultProperty]) {
            $scope.toggleDefaultDashboard(defaultProperty, dashboard);
        }

        $scope.roleGeneral[collectionProperty].remove(dashboard);
    };

    $scope.hasAccess = function (value, type) {
        return value.has(type);
    };

    $scope.showHelpText = function (option) {
        $dialog.messageBox(option.name, option.description).open();
    };

    $scope.viewPrivilege = function (privilegeId) {
        $dialog.editor('tools/views/privileges-editor.html', 'PrivilegesEditorCtrl', {args: function() {return {id: privilegeId, isNew: false, defaultTab: {code: "privDetail"}};}}).open();
    };

    $scope.filterCategoriesByItemName = function (category) {
        if (!$scope.current.searchText) {
            return true;
        }

        const searchText = $scope.current.searchText.toLowerCase();

        return category.items.any(function (item) {
            return item.name.toLowerCase().has(searchText);
        });
    };

    $scope.filterItemsByName = function (item) {
        return $scope.current.searchText ? item.name.toLowerCase().has($scope.current.searchText.toLowerCase()) : true;
    };

    $scope.editUserProfile = function (user) {
        const d = $dialog.editor('tools/views/maintain-login-edit.html', 'MaintainLoginEditCtrl', {
            args: function () {
                return {
                    id: user.userId,
                    isNewOrCopy: false,
                    defaultTab: {name: "Profiles", active: true, code: "profiles"},
                    entityObj: null,
                    entityType: entities.find({name: $scope.roleGeneral.loginEntityId}) || $scope.roleGeneral.loginEntityId,
                    loginEntityId: $scope.roleGeneral.loginEntityId,
                    userId: user.loginUserId
                };
            },
            roles: window.maintainLoginEditCtrl.loadRoles
        });

        d.open().then(function (rslt) {
            if (rslt) {
                const assignedProfiles = rslt.profiles.findAll({roleId: $scope.current.roleId});
                const currentProfile = $scope.usersForRole.findAll({userId: user.userId});
                currentProfile.forEach(function (item) {
                    if (!assignedProfiles.any({id: item.profileId})) {
                        $scope.usersForRole.remove(item);
                    }
                });

                assignedProfiles.forEach(function (item) {
                    if (!currentProfile.any({profileId: item.id})) {
                        const addedProfile = {
                            profileId: item.id,
                            userId: user.userId,
                            loginUserId: user.loginUserId,
                            loginEntity: item.entity,
                            loginEntityName: item.entityName,
                            loginEntityId: item.loginEntityId
                        };
                        $scope.usersForRole.push(addedProfile);
                    }
                });
            }
        });
    };

    $scope.loadTab = function (menuItem) {
        $scope.current.selectedTab = menuItem;
        menuItem.load.forEach(function (fn) {fn();});
    };

    $scope.save = function () {
        if (angular.equals(roleGeneralOriginal, $scope.roleGeneral)) {
            return;
        }

        if (args.isCopy) {
            args.isNew = true;
        }

        $scope.roleGeneral.privileges.forEach(function (item) {
            if (item.type !== 'Records') {
                item.editIsGranted = item.readIsGranted && $scope.hasAccess(item.availableAccessType, 'Edit');
                item.deleteIsGranted = item.readIsGranted && $scope.hasAccess(item.availableAccessType, 'Delete');
            }
        });

        if (roleGeneralOriginal.tokenLife !== $scope.roleGeneral.tokenLife) {
            const tokenLifeTime = isValidTokenLifeTime($scope.roleGeneral.tokenLife);
            if (!tokenLifeTime.isValid){
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Token Life", tokenLifeTime.message).open();
                return;
            }
        }

        const saveDtl = args.isNew ? {method: "post", id: "", trackerMsg: "Adding new role"} : {method: "put", id: $scope.current.roleId, trackerMsg: "Saving role " + args.id};

        $http[saveDtl.method]('/Security/Roles/' + saveDtl.id, $scope.roleGeneral, {trackerMsg: saveDtl.trackerMsg})
            .then(function (response) {
                editorHotKeys.destroy();
                dialog.close(response.data);
            });
    };

    $scope.close = function (validate) {
        if (validate) {
            if (!angular.equals(roleGeneralOriginal, $scope.roleGeneral)) {
                $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true});
            } else {
                editorHotKeys.destroy();
                dialog.close();
            }
        } else {
            editorHotKeys.destroy();
            dialog.close();
        }
    };

    $scope.changeRightState = function (item){
        if (item.readIsGranted) {
            const getAiAddendumMsg = function (featureName, isBeta) {
                let msg = `By enabling <b>${featureName}</b>${isBeta ? ' beta' : ''}, you acknowledge you have read and agree to the terms and conditions set forth in the <a href="https://orion.com/contract-terms/ai-terms-conditions" target="_blank">AI Solutions and Features Terms and Conditions</a> and to abide by the <a href="https://orion.com/ai-services-acceptable-use-policy" target="_blank">Acceptable Use Policy</a>.`;

                if (isBeta) {
                    msg += ` Your continued access to the <b>${featureName}</b> beta functionality is considered access to beta AI services, as set forth in the AI Solutions and Features Terms and Conditions.`;
                }

                return msg + '<br /><br />Do you agree to these terms?';
            };

            const confirmationMsg = {
                reportAssistantAIChat: getAiAddendumMsg('Orion Report Assistant', false),
                queryStudioQueries: getAiAddendumMsg('Orion Query Studio – Build and Modify', false),
                chatCustomerSupport: getAiAddendumMsg('Orion Service Agent', false)
            }[item.code];

            if (!confirmationMsg) {
                return;
            }

            $dialog.confirmAction(confirmationMsg)
                .open()
                .then(function (result) {
                    if (result === 'no') {
                        item.readIsGranted = false;
                    }
                });
        } else {
            item.editIsGranted = item.deleteIsGranted = false;
        }
    };


    // INITIALIZE
    $scope.current = {
        isNew: args.isNew,
        roleId: parseInt(args.id),
        loginEntityObj: args.loginEntityObj,
        searchText: "",
        isCopy: args.isCopy
    };

    $scope.errors = [];

    init();
});


'use strict';

app.controller('RoleSyncCtrl', function ($scope, $q, $http, $location, $dialog, $oasRights, tokenFactory, entities, loginEntities) {
    //PRIVATE METHODS
    function init() {
        const roleExclusions = [entities.client.name, entities.brokerDealer.name, entities.subAdvisor.name, entities.wholesaler.name, entities.administrator.name].map(function (entityName) {
            return "excludeLoginEntityId=" + loginEntities.find({entity: entityName}).id;
        }).join("&");

        $http.get('/Security/Roles?' + roleExclusions, {trackerMsg: 'Loading roles'})
            .then(function (response) {
                $scope.roles.availableItems = response.data.remove({isGlobal: true})
                    .sortBy('name')
                    .map(function (role) {return Object.select(role, "id", "name", "loginEntityId", "loginEntityDescription");});
            });

        $http.get("/Authorization/Databases", {cache: true, trackerMsg: 'Loading databases'})
            .then(function (response) {
                const databases = response.data.remove({selected: true}).map(function (db) {return {id: db.id, name: db.clientName};});

                if ($scope.user.authorization.entity === "Administrator") {
                    if ($oasRights.canAdd("MUL_ROLES")) {
                        //if you're an admin with role mgmt in this database, then it's safe to assume you have it in every db
                        $scope.databases.availableItems = databases;
                    }
                } else {
                    const promises = databases.map(function (database) {
                        return tokenFactory.getDatabaseToken(database.id)
                            .then(function (token) {
                                return $http.get('/Authorization/User/Privileges/roleManagement', {ignoreExceptions: true, headers: {Authorization: "Session " + token}});
                            })
                            .then(function (response) {
                                return response.data.editIsGranted ? database : null;
                            });
                    });

                    $q.all(promises)
                        .then(function (responses) {
                            $scope.databases.availableItems = responses.compact();
                        });
                }
            });
    }


    //PUBLIC METHODS
    $scope.back = function () {
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep -= 1;
    };

    $scope.next = function () {
        $scope.current.animation = 'slide-right';
        $scope.current.wizardStep += 1;

        if ($scope.current.wizardStep === 2) {
            $scope.syncItems = [];

            $scope.roles.selectedItems.forEach(function (role) {
                $scope.databases.selectedItems.forEach(function (database) {
                    $scope.syncItems.push({roleId: role.id, roleName: role.name, loginEntityId: role.loginEntityId, loginEntityDescription: role.loginEntityDescription, databaseId: database.id, databaseName: database.name, status: "Ready"});
                });
            });
        }
    };

    $scope.jumpBackTo = function (index) {
        if ($scope.current.executing) {
            return;
        }

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };

    $scope.isStepIncomplete = function () {
        switch ($scope.current.wizardStep) {
            case 0:
                return $scope.roles.selectedItems.length === 0;
            case 1:
                return $scope.databases.selectedItems.length === 0;
            default:
                return false;
        }
    };

    $scope.moveSome = function (selectedItems, from, to) {
        angular.forEach(selectedItems, function (item) {
            const index = from.indexOf(item);

            if (index !== -1) {
                from.splice(index, 1);
                to.push(item);
            }
        });
        selectedItems.length = 0;
    };

    $scope.moveAll = function (from, to, selectedItems, filter) {
        if (filter) {
            filter = filter.toLowerCase();
            $scope.moveSome(from.findAll(function (item) {return item.name.toLowerCase().indexOf(filter) !== -1;}), from, to);
            $scope[from === $scope.roles.availableItems ? 'roles' : 'databases'].availableItemsFilter = "";
        }
        else {
            angular.forEach(from, function (item) {
                to.push(item);
            });
            from.length = 0;
        }

        selectedItems.length = 0; //in case they selected some and then did move all
    };

    $scope.removeSyncItem = function (item) {
        $scope.syncItems.remove(item);
    };

    $scope.processSync = function () {
        $scope.current.executing = true;

        const rolePromises = $scope.roles.selectedItems.map(function (item) {
            return $http.get("/Security/Roles/" + item.id, {trackerMsg: 'Loading details for ' + item.name})
                .then (function (response) {
                    return response.data;
                });
        });

        $q.all(rolePromises)
            .then(function (rolesToSync) {
                const numberOfTotalProcessors = 6;
                let numberOfFinishedProcessors = 0;

                const queue = (0).upto($scope.syncItems.length - 1);

                (1).upto(numberOfTotalProcessors).forEach(function () {
                    processQueueItem();
                });

                function processQueueItem() {
                    if (!queue.length) {
                        numberOfFinishedProcessors +=1;

                        if (numberOfFinishedProcessors === numberOfTotalProcessors) {
                            const buttons = [{result:'list', label: 'Go to Role List', cssClass: 'btn-primary', focus: true}, {result:'review', label: 'Review Sync Results'}];

                            $dialog.actionComplete("The role sync process has finished.", buttons)
                                .open()
                                .then(function (result) {
                                    if (result === "list") {
                                        $location.path('/tools/roles');
                                    }
                                });
                        }

                        return;
                    }

                    var item = $scope.syncItems[queue.shift()];

                    tokenFactory.getDatabaseToken(item.databaseId)
                        .then(function (token) {
                            item.status = "Locating";
                            return token;
                        })
                        .then(function (token) {
                            return $http.get("/Security/Roles/" + item.loginEntityId + "/" + encodeURIComponent(item.roleName), {headers: {Authorization: "Session " + token}})
                                .then(function (response) {
                                    const roleToSync = angular.copy(rolesToSync.find({id: item.roleId}));

                                    if (response.data === null) {
                                        item.status = "Creating";
                                        delete roleToSync.id;

                                        return {verb: "post", payload: roleToSync, urlSuffix: ''};
                                    } else {
                                        item.status = "Updating";

                                        const existingRole = response.data;
                                        existingRole.privileges = roleToSync.privileges;
                                        existingRole.tokenLife = roleToSync.tokenLife;
                                        existingRole.defaultDashboardId = roleToSync.defaultDashboardId;
                                        existingRole.dashboards = roleToSync.dashboards;
                                        existingRole.defaultPVDashboardId = roleToSync.defaultPVDashboardId;
                                        existingRole.pvDashboards = roleToSync.pvDashboards;

                                        return {verb: "put", payload: existingRole, urlSuffix: '/' + existingRole.id};
                                    }
                                })
                                .then(function (request) {
                                    return $http[request.verb]("/Security/Roles" + request.urlSuffix, request.payload, {trackerMsg: item.status + " " + item.roleName + " in " + item.databaseName, headers: {Authorization: "Session " + token}});
                                })
                                .then(function () {
                                    item.status = "Succeeded";
                                    processQueueItem();
                                })
                                .catch(function () {
                                    item.status = "Failed";
                                    processQueueItem();
                                });
                        });
                }
            });
    };


    //INITIALIZE
    $scope.current = {wizardStep: 0, animation: 'slide-right', executing: false};
    $scope.roles = {availableItems: [], availableSelected: [], selectedItems: [], selectedSelected: []};
    $scope.databases = {availableItems: [], availableSelected: [], selectedItems: [], selectedSelected: []};
    $scope.wizardSteps = ["Select Roles", "Select Databases", "Process Sync"];

    init();
});

'use strict';

app.controller('PrivilegesListCtrl', function PrivilegesListCtrl($scope, $oasRights, $dialog, views) {
    //PRIVATE VARIABLES

    // PRIVATE METHODS

    // PUBLIC METHODS
    $scope.openEditor = function (id, isNew) {
        const args = function () {
            return {id: id, isNew: isNew, defaultTab: {code: 'privDetail'}};
        };

        $dialog.editor('tools/views/privileges-editor.html', 'PrivilegesEditorCtrl', {args: args})
            .open()
            .then(function (result) {
                if (!result) {
                    return;
                }

                $scope.$broadcast('event:privileges-list-action', {action: isNew ? 'add-item' : 'update-item', item: result});
            });
    };

    $scope.slickGridDoubleClick = function () {
        if ($scope.selectedIds.length === 1) {
            $scope.openEditor($scope.selectedIds[0], false);
        }
    };


    // INITIALIZE
    $scope.rightsPriv = $oasRights.forCode('MUL_PRIVILEGES');
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {view: views[0], gridDoubleClick: $scope.slickGridDoubleClick};

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E',
        command: function () {
            if ($scope.selectedIds.length !== 1) {
                return;
            }

            $scope.openEditor($scope.selectedIds[0], false);
        }
    }];
});

'use strict';

app.controller('PrivilegesEditorCtrl', function PrivilegesEditorCtrl($scope, $http, $q, $oasRights, $dialog, $timeout, dialog, args) {
    // PRIVATE VARIABLES
    let privilegeOriginal, editorHotKeys;


    // PRIVATE METHODS
    function init() {
        loadRights();
        buildMenu();

        $scope.menu.each(function (category) {
            const menuItem = category.items.find({code: args.defaultTab.code});
            if (menuItem) {
                $scope.loadTab(menuItem);
                return false;
            }
        });

        loadHotKeys();
    }

    function loadRights() {
        $scope.rightsPV = $oasRights.forCode('MUL_PRIVILEGES');
    }

    function buildMenu() {
        const menu = [
            {
                name: 'Privilege', enabled: true, items: [
                    {name: 'Detail', code: 'privDetail', enabled: true, load: [loadEditor]}
                ]
            },
            {
                name: 'Audit', enabled: true, items: [
                    {name: 'History', code: 'privAuditHistory', enabled: true, load: [loadAuditHistory]}
                ]
            }
        ];

        menu.forEach(function (category) {
            category.items.remove({enabled: false});
        });

        menu.remove({items: []});

        $scope.menu = menu;
    }

    function loadHotKeys() {
        editorHotKeys = new window.HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                {
                    combo: 'ALT+S',
                    command: $scope.savePrivilege
                },
                {
                    combo: 'ALT+X',
                    command: function () {
                        $scope.close(true);
                    }
                }
            ]);
        });
    }

    function loadEditor() {
        if ($scope.privilege) {
            return;
        }

        $q.all([loadPrivilege(), loadAvailableAlClients(), loadAvailableLoginEntities(), loadPrivilegeCategories(), loadLockdownTypes(), loadFirmTypes(), loadAvailableFirmTypeExceptions()])
            .then(function () {
                $scope.alClients.selected = $scope.privilege.alClientIds.map(id => {
                    return $scope.alClients.list.find({id: id});
                }).sortBy('clientName');

                $scope.current.firmTypes.forEach(firmType => {
                    firmType.enabled = $scope.privilege.firmTypes.includes(firmType.name);
                });

                $scope.firmTypeExceptions.selected = $scope.privilege.firmTypeExceptions.map(id => {
                    return $scope.firmTypeExceptions.list.find({id: id});
                }).sortBy('clientName');

                $scope.current.availableAccessType = makeAccessObjectFromString($scope.privilege.availableAccessType);

                $scope.current.loginEntities.forEach(loginEntity => {
                    const match = $scope.privilege.loginEntities.find({entity: loginEntity.entity});
                    loginEntity.access = makeAccessObjectFromString(match ? match.accessType : '');
                });

                if ($scope.privilege.revokeOnLockdownType !== 'None') {
                    $scope.current.lockdownSelected = $scope.privilege.revokeOnLockdownType.split(', ');
                }

                if (args.id !== 0) {
                    privilegeOriginal = angular.copy($scope.privilege);
                }
            });
    }

    function makeAccessObjectFromString(accessString) {
        return {
            read: accessString.includes('Read'),
            edit: accessString.includes('Edit'),
            delete: accessString.includes('Delete')
        };
    }

    function makeAccessStringFromObject(accessObject) {
        return Object.keys(Object.findAll(accessObject, true)).join(', ') || 'None';
    }

    function loadPrivilege() {
        if (args.isNew && !args.id) {
            $scope.privilege = {
                alClientIds: [],
                availableAccessType: 'Read, Edit, Delete',
                categoryId: null,
                categoryName: 'Portfolio',
                code: null,
                dbLimitationAdminOverride: false,
                description: '',
                firmTypeExceptions: [],
                firmTypes: 'None',
                id: 0,
                isIncludedByDefault: true,
                loginEntities: [],
                name: '',
                revokeOnLockdownType: 'None',
                type: 'Records'
            };

            return $q.when(null);
        } else {
            return $http.get('/Security/Privileges/' + args.id, {trackerMsg: 'Loading privilege'})
                .then(function (response) {
                    $scope.privilege = response.data;

                    if (args.isNew) {
                        $scope.privilege.id = 0;
                        $scope.privilege.name = '';
                    }
                });
        }
    }

    function loadAvailableAlClients() {
        return $http.get('/Authorization/User/Databases', {cache: true, trackerMsg: 'Loading database list'})
            .then(function (response) {
                $scope.alClients.list = response.data.sortBy('clientName');
            });
    }

    function loadAvailableFirmTypeExceptions() {
        return $http.get('/Authorization/User/Databases', {cache: true, trackerMsg: 'Loading database list'})
            .then(function (response) {
                const dbList = response.data.sortBy('clientName');

                const thisDb = dbList.find({id: $scope.user.authorization.alClientId});
                if (thisDb.firmType !== 'None') {
                    $scope.current.dbAlerts.push({type: 'warning', icon: 'fa-exclamation-triangle', msg: `${thisDb.clientName} is now using the Firm Types tab.  Changes in this tab will have no effect for this database.`});
                } else {
                    $scope.current.dbAlerts.push({type: 'info', icon: 'fa-info-circle', msg: 'This tab will be replaced by the Firm Types tab in the near future.  To avoid disruptions, be sure to set up the Firm Types tab as well.'});
                }

                dbList.forEach(db => db.clientName = `${db.clientName} - ${db.firmType}`);
                $scope.firmTypeExceptions.list = dbList;
            });
    }

    function loadAvailableLoginEntities() {
        return $http.get("/Security/LoginEntities", {cache: true, trackerMsg: 'Loading available entities'})
            .then(function (response) {
                $scope.current.loginEntities = response.data;
            });
    }

    function loadPrivilegeCategories() {
        return $http.get('/Security/Privileges/Categories', {cache: true, trackerMsg: 'Loading privilege categories'})
            .then(function (response) {
                $scope.privilegeCategories = response.data.map('name');
            });
    }

    function loadLockdownTypes() {
        return $http.get("/Security/Databases/LockdownTypes", {cache: true, trackerMsg: 'Loading lockdown types'}) 
            .then(function (response) {
                $scope.current.lockdownTypes = response.data.reduce((map, lockdownType) => {
                    map[lockdownType.name] = lockdownType.name;
                    return map;
                }, {});
            });
    }

    function loadFirmTypes() {
        return $http.get("/Security/Databases/FirmTypes", {cache: true, trackerMsg: 'Loading firm types'})
            .then(function (response) {
                $scope.current.firmTypes = response.data;
            });
    }

    function loadAuditHistory() {
        if ($scope.privilegeHistory || args.isNew) {
            return;
        }

        $http.get('/Security/Privileges/' + args.id + '/Histories', {trackerMsg: 'Loading Audit History'})
            .then(function (response) {
                response.data.forEach(function (item) {
                    setChangeType(item);
                    item.type = $scope.privilegeTypes[item.type];
                });
                $scope.privilegeHistory = response.data;
            });

        $http.get('/Security/Privileges/' + args.id + '/AllowedEntitiesHistory', {trackerMsg: 'Loading Audit History'})
            .then(function (response) {
                response.data.forEach(function (item) {
                    setChangeType(item);
                    item.loginEntity = $scope.current.loginEntities.find({id: item.loginEntity}).entity;
                });

                $scope.loginEntitiesHistory = response.data.groupOn('loginEntity', true);
            });
    }

    function setChangeType(item) {
        item.changeType = {I: "Insert", U: "Update", D: "Delete"}[item.changeType];
    }


    //PUBLIC METHODS
    $scope.loadTab = function (menuItem) {
        $scope.current.selectedTab = menuItem;

        menuItem.load.forEach(function (fn) {
            fn();
        });
    };

    $scope.onAccessChange = function (loginEntity, property) {
        if (loginEntity.id !== 'Representative') {
            return;
        }

        //sync b/d privilege access with rep
        const bdEntity = $scope.current.loginEntities.find({id: 'Broker/Dealer'});
        bdEntity.access[property] = loginEntity.access[property];
    };

    $scope.savePrivilege = function () {
        $scope.privilege.availableAccessType = makeAccessStringFromObject($scope.current.availableAccessType);
        $scope.privilege.alClientIds = $scope.privilege.isIncludedByDefault ? [] : $scope.alClients.selected.map('id');
        $scope.privilege.revokeOnLockdownType = $scope.current.lockdownSelected.join(', ') || 'None';
        $scope.privilege.firmTypes = $scope.current.firmTypes.findAll({enabled: true}).map('name').join(', ') || 'None';
        $scope.privilege.firmTypeExceptions = $scope.firmTypeExceptions.selected.map('id');

        $scope.privilege.loginEntities = $scope.current.loginEntities.map(loginEntity => {
            if ($scope.privilege.type !== 'Records') {
                loginEntity.access.edit = loginEntity.access.read;
                loginEntity.access.delete = loginEntity.access.read;
            }

            loginEntity.accessType = makeAccessStringFromObject(loginEntity.access);

            return loginEntity;
        });

        const http = args.isNew ? {method: 'POST', urlSuffix: '', trackerMsg: 'Adding new privilege'} : {method: 'PUT', urlSuffix: $scope.privilege.code, trackerMsg: `Saving ${$scope.privilege.name}`};

        $http({method: http.method, url: `/Security/Privileges/${http.urlSuffix}`, data: $scope.privilege, trackerMsg: http.trackerMsg})
            .then(function (response) {
                $scope.close(false, response.data);
            });
    };

    $scope.close = function (validate, returnData) {
        if (validate && !angular.equals(privilegeOriginal, $scope.privilege)) {
            $scope.errors.push({type: 'error', title: 'Unsaved Changes! ', msg: 'There are unsaved changes that will be lost.', showAllowClose: true});
            return;
        }

        editorHotKeys.destroy();
        dialog.close(returnData);
    };

    // INITIALIZE
    $scope.current = {
        lockdownSelected: [],
        dbAlerts: []
    };

    $scope.alClients = {list: [], selected: []};
    $scope.firmTypeExceptions = {list: [], selected: []};

    $scope.privilegeTypes = ['Unknown', 'Apps', 'Records', 'Actions', 'Advanced', 'AppLinks', 'FeatureFlags'];

    $scope.errors = [];

    init();
});



'use strict';

app.controller('NotificationCtrl', function NotificationCtrl($scope, $http, $route, $dialog, views, $notifications, API_CONFIG, notificationStatus) {
    //PRIVATE METHODS
    function cleanNotificationUrls(notifications) {
        notifications.each(function(n) {
            if(n.categoryName === "Data Query") {
                if (n.url === null) return;

                if(n.url.startsWith("http")) {
                    n.url = n.url.replace("http://api.orionadvisor.local", "").replace("https://api.orionadvisor.com", "");
                } else if(!n.url.startsWith(API_CONFIG.baseUrl)) {
                    n.url = API_CONFIG.baseUrl + n.url;
                }
            }
        });
        return notifications;
    }

    //PUBLIC METHODS
    $scope.generateShareLink = function (notification) {
        $http.post(notification.url.replace('/Data//', '/Action/Share/'), null, {trackerMsg: 'Generating share link'})
            .then(function (response) {
                var data = response.data;

                $dialog.dialog({templateUrl: 'tools/modals/generated-share-link.html', controller: 'GeneratedShareLinkCtrl', notification: notification, shareUri: data.shareUri, expirationDate: data.expirationDate}).open();
            });
    };

    var that = this;

    $scope.deleteRow = function(notifications){
        $dialog.confirmAction("Delete Notification(s). Are you sure you want to proceed?")
            .open()
            .then(function(result){
                if (result === 'yes') {
                    var notificationIds = [];
                    notifications.forEach(function(n){
                        notificationIds.push(n.id);
                    })

                    $http.put("/Integrations/Notifications/Action/UpdateStatus?status=Deleted", notificationIds)
                        .then(function (){
                                notifications.forEach(function(x){
                                    $notifications.deleteNotification(x);
                                    $notifications.updateCounter();
                                });
                            $scope.refreshGrid();
                            }
                        );
                }
            });
    }

    $scope.refreshGrid = function() {
        $scope.$broadcast('event:notification-list-action', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:notification-list-action', {action: 'export-data'});
    };


    //INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.selectedNotifications = [];
    $scope.token = sessionStorage.oas_token;

    $scope.current = {
        view: views[0]
    };

    if($route.current.params.category) {
        $notifications.notifications.data.forEach(function(category) {
            $scope.current.view.filters.push({name: "CATEGORY = " + category[0], value: "(function (a) { return a === '" + category[0] + "'; })", key: "categoryName", include: $route.current.params.category === category[0]});
        });
    }


    //EVENT LISTENERS
    $scope.$on('event:notification-selected', function(event, args) {
        event.stopPropagation();
        $scope.selectedNotifications = cleanNotificationUrls(args);

        args.forEach(function (x){
                if(x.status.toLowerCase() == "unread"){
                    $notifications.markAsUnread(x.id);
                }
                if(x.status.toLowerCase() == "read"){
                    $notifications.markAsRead(x.id);
                }
            })
    });
});

'use strict';

app.controller('NotificationSubscriptionsCtrl', function NotificationSubscriptionsCtrl($scope, $http, $q, $dialog) {
    //PRIVATE VARIABLES
    var daysOfWeek = [
        {id: 1, name: "Sunday"},
        {id: 2, name: "Monday"},
        {id: 3, name: "Tuesday"},
        {id: 4, name: "Wednesday"},
        {id: 5, name: "Thursday"},
        {id: 6, name: "Friday"},
        {id: 7, name: "Saturday"}
    ];
    var lastVerifiedPhone;


    //PRIVATE METHODS
    function init() {
        $http.get("/Authorization/User/Verbose?expand=portfolio&expand=personal", {trackerMsg: 'Loading authentication settings'})
            .then(function (response) {
                $scope.verboseUser = response.data;

                lastVerifiedPhone = $scope.verboseUser.personal.mobilePhone.isVerified ? $scope.verboseUser.personal.mobilePhone.number : "NOT-VERIFIED";
            });

        $http.get("/Reporting/Notifications/SubscriptionWithDestination/NotificationSubscriptions", {trackerMsg: 'Loading notifications'})
            .then(function (response) {
                $scope.subscriptions = response.data;

                $scope.subscriptions.forEach(function (subscription) {
                    if (subscription.schedule.frequency === "Weekly" && subscription.destinations.any({enabled: true})) {
                        subscription.schedule.dayOfWeek = daysOfWeek.find({name: Object.find(subscription.schedule.weekly, true).capitalize()}).id;
                    }

                    subscription.schedule.timeOfDayAsDate = Date.create("1900-01-01 " + subscription.schedule.timeOfDay);

                    setSubscriptionPhrase(subscription);
                });
            });
    }

    function setSubscriptionPhrase(subscription) {
        var phrase;
        var enabledDestinations = subscription.destinations.findAll({enabled: true});

        if (enabledDestinations.length) {
            phrase = "Send to " + enabledDestinations.map("destinationName").join(" and ");

            switch (subscription.schedule.frequency) {
                case "Monthly":
                    phrase += " on the " + subscription.schedule.dayOfMonth.ordinalize() + " of the month";
                    break;
                case "Weekly":
                    phrase += " every " + daysOfWeek.find({id: subscription.schedule.dayOfWeek}).name;
                    break;
                case "Daily":
                    phrase += " every day";
                    break;
            }

            phrase += " at " + Date.create(subscription.schedule.timeOfDayAsDate).format("{h}:{mm} {tt}");
        }

        subscription.phrase = phrase;
    }


    //PUBLIC METHODS
    $scope.invalidEmail = function (invalid) {
        $scope.verboseUser.personal.emailInvalid = invalid;
    }

    $scope.setEmail = function (value) {
        $scope.verboseUser.personal.email = value;
    }

    $scope.togglePhoneVerification = function () {
        $scope.verboseUser.personal.mobilePhone.isVerified = $scope.verboseUser.personal.mobilePhone.number === lastVerifiedPhone;
    };

    $scope.verifyPhone = function () {
        $http.post("/Utility/SMS/SendPIN?phoneNumber=" + $scope.verboseUser.personal.mobilePhone.number, null, {trackerMsg: 'Sending verification text'})
            .then(function () {
                $dialog.inputBox('Verify Phone', 'PIN Number', "compare", {compareUrl: "/Utility/SMS/VerifyPIN?pin={1}", helpText: "Enter the Verification PIN Number you received via text."})
                    .open()
                    .then(function (result) {
                        if (result) {
                            $scope.verboseUser.personal.mobilePhone.isVerified = true;
                            lastVerifiedPhone = $scope.verboseUser.personal.mobilePhone.number;
                        }
                    });
            });
    };

    $scope.editSubscription = function (subscription) {
        var resolve = {
            subscription: function () {return subscription;},
            daysOfWeek: function () {return daysOfWeek;}
        };

        $dialog.dialog({templateUrl: "edit-subscription.html", controller: "EditSubscriptionCtrl", resolve: resolve})
            .open()
            .then(function (result) {
                if (result) {
                    angular.extend(subscription, result);
                    setSubscriptionPhrase(subscription);
                }
            });
    };

    $scope.unsubscribe = function (subscription) {
        subscription.destinations.forEach(function (destination) {
            destination.enabled = false;
        });
        setSubscriptionPhrase(subscription);
    };

    $scope.save = function () {
        var validationErrors = [];

        if (($scope.verboseUser.personal.emailInvalid || !$scope.verboseUser.personal.email) && $scope.subscriptions.any(function (s) {return (s.destinations.find({destinationName: "Email"}) || {}).enabled;})) {
            validationErrors.push("Email notifications require a valid email address.");
        }

        if ((!$scope.verboseUser.personal.mobilePhone.number || !$scope.verboseUser.personal.mobilePhone.isVerified) && $scope.subscriptions.any(function (s) {return (s.destinations.find({destinationName: "SMS Text"}) || {}).enabled;})) {
            validationErrors.push("SMS Text notifications require a verified phone number.");
        }

        if (validationErrors.length) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-error' aria-hidden='true'></i> Validation Errors", "<ul><li class='add-top-margin'>" + validationErrors.join("</li><li class='add-top-margin'>") + "</li></ul>").open();
            return;
        }

        $scope.subscriptions.forEach(function (subscription) {
            if (subscription.destinations.any({enabled: true})) {
                if (subscription.schedule.frequency === "Monthly") {
                    Object.keys(subscription.schedule.monthly, function (key) {
                        subscription.schedule.monthly[key] = true;
                    });
                } else if (subscription.schedule.frequency === "Weekly") {
                    var selectedKey = daysOfWeek.find({id: subscription.schedule.dayOfWeek}).name.toLowerCase();

                    Object.keys(subscription.schedule.weekly, function (key) {
                        subscription.schedule.weekly[key] = key === selectedKey;
                    });
                }

                subscription.schedule.timeOfDay = subscription.schedule.timeOfDayAsDate.format("{h}:{mm} {tt}");
            }
        });

        var promises = [
            $http.put("/Authorization/User/Verbose", $scope.verboseUser, {trackerMsg: 'Saving authentication settings'}),
            $http.put("/Reporting/Notifications/SubscriptionWithDestination/NotificationSubscriptions", $scope.subscriptions, {trackerMsg: 'Saving subscription settings'})
        ];

        $q.all(promises)
            .then(function () {
                $dialog.saveSuccessful("Subscription information has been saved.").open();
            });
    };


    //INITIALIZE
    init();
});


app.controller("EditSubscriptionCtrl", function EditSubscriptionCtrl($scope, subscription, daysOfWeek, dialog) {
    //PUBLIC METHODS
    $scope.resetInterval = function () {
        $scope.subscription.schedule.dayOfWeek = 1;
        $scope.subscription.schedule.dayOfMonth = 1;
    };

    $scope.save = function () {
        dialog.close($scope.subscription);
    };

    $scope.cancel = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.frequencies = ['Monthly', 'Weekly', 'Daily'];

    $scope.daysOfWeek = angular.copy(daysOfWeek);

    $scope.daysOfMonth = (1).upto(30).map(function (i) {
        return {id: i, name: i.ordinalize()};
    });

    $scope.subscription = angular.copy(subscription);
});
'use strict';

app.controller('SMSSettingsCtrl', function SMSSettingsCtrl($scope, $http, $location, $dialog, $dataQuery, $oasRights) {
    //PRIVATE VARIABLES
    var ungroupedSMSSettings;


    //PRIVATE METHODS
    function init() {
        $http.get("/Settings/Apps/notifications/Options?level=Advisor", {trackerMsg: 'Loading SMS settings'})
            .then(function (response) {
                ungroupedSMSSettings = response.data.sortBy("displayName");
                $scope.smsSettings = ungroupedSMSSettings.groupOn("category", true);
            });
    }


    //PUBLIC METHODS
    $scope.save = function () {
        $http.put("/Settings/Apps/notifications/Options?level=Advisor", ungroupedSMSSettings, {trackerMsg: 'Saving settings'})
            .then(function () {
                $dialog.saveSuccessful("SMS Settings saved successfully.").open();
            });
    };

    $scope.viewHistory = function () {
        $dialog.dataQueryPrompt("SMS Notification history log")
            .open()
            .then(function (result) {
                if (result && result.id) {
                    $dataQuery.setDataQuery(result);
                    $location.path('/reports/dataqueries/' + result.id);
                }
            });
    };


    //INITIALIZE
    $scope.rights = $oasRights.forCode("CLIENTSMSSETTINGS");
    init();
});

'use strict';

app.controller('ArchiveCtrl', function ArchiveCtrl($scope, $http, $window, $dialog, $rootScope, $oasRights) {

    //PRIVATE METHODS

    function init(){

        $http.get('/Compliance/Archive/', {trackerMsg: 'Loading archive configurations'})
            .then(function (response) {
                $scope.configurations = response.data;
            })
        $http.get('/Compliance/Archive/Types', {trackerMsg: 'Loading archive types'})
            .then(function(response) {
                $scope.filteredTypes = response.data;
            });

    }


    function openDialog(object, idx) {
        $dialog.dialog({templateUrl: "tools/compass/views/archive-edit.html",controller: "ArchiveEditCtrl",config: angular.copy(object),dialogClass: 'modal wide'})
            .open()
            .then(function (response) {
                if (response) {
                    if(response.id === object.id){
                        $scope.configurations[idx] = response;
                    } else {
                        $scope.configurations.push(response)
                    }
                 }
            });
    };

    function openDisclaimerModal(type) {
        var title, message;
        switch(type) {
            case 'LPL':
                title = 'LPL Financial LLC Data Disclosure Agreement';
                message = '<p class="text-center">PLEASE READ THE FOLLOWING TERMS AND CONDITIONS – THIS IS A LEGALLY BINDING AGREEMENT.</p><p>By selecting this Secure File Transfer Protocol (“SFTP”) and clicking accept, below, you will be sending your report data to LPL Financial LLC (collectively with its affiliates, “LPL”) for compliance purposes. Should you have any questions regarding these specific compliance obligations, the data transfer, the destination and usage of the reports, please contact LPL Tech Support Help Desk at techsupport@lpl.com prior to accepting these terms and conditions.<br/><br/>Orion Advisor Services, LLC, (“OAS”) has agreed to provide certain data and information (the “LPL Data”) relating to client accounts maintained in the OAS system and custodied at LPL (the “LPL Accounts”), in order to provide you with access to LPL Data. Therefore, you (“Investment Adviser”) agree as follows:<br/><br/>A.	As a condition to Investment Adviser’s receipt and use of LPL Data, and in connection with LPL’s supervisory and compliance policies, Investment Adviser acknowledges that LPL shall be entitled to copies of all reports Investment Adviser produces through the OAS system with respect to its client accounts, including but not limited to, its LPL Accounts.  Consequently, Investment Adviser hereby authorizes OAS to release and/or make available, in electronic and/or interactive format, copies of all reports generated by Investment Adviser, as may be required by LPL from time to time.  Investment Adviser acknowledges that certain client data accessible to LPL may contain client data of Investment Adviser’s non-LPL Accounts.<br/><br/>B.	Investment Adviser acknowledges and agrees that it shall be responsible for ensuring that each report that Investment Adviser generates using the OAS system, including with respect to LPL Accounts and non-LPL Accounts (an “LPL Account Report”), contains any and all disclosure language required by LPL before such LPL Account Report is provided by Investment Adviser to any clients or representatives.<br/><br/>C.	Investment Adviser hereby releases and agrees to hold OAS harmless from all claims, liabilities, losses, damages, attorneys’ fees and expenses of any kind resulting from:<br/><br/>a.	the release of client information contained in any copies of reports provided by OAS to LPL or otherwise accessible to LPL as set forth herein, and<br/><br/>b.	LPL’s actions or inactions related to Investment Adviser’s LPL Accounts. Investment Adviser represents that it has entered into an agreement with LPL to protect the confidentiality of Investment Adviser’s client information.<br/><br/>D.	This Agreement shall remain in effect until the termination of the Operations Service Agreement, incorporated herein by reference.</p>';
                break;
            case 'Securities America SAI':
                title = 'New Report Archive Disclaimer';
                message = '<p>Investment Advisor hereby authorizes Orion to release and/or make available, in electronic form and/or interactive format, copies of all reports generated by the Orion system to recipient party, Securities America (SAI) of La Vista, Nebraska. Please note that Orion is not responsible for actions taken by your office/firm in connection with this integration feature. By choosing this sFTP location to send all reports ran in your database, you are authorizing the recipient party to receive client data maintained on the Orion system and releasing Orion from all claims, liabilities, losses, damages, attorneys’ fees and expenses of any kind resulting from sending and allowing access to your client data, including any manipulation, alteration, or changes to the data, as well as Orion’s actions in reliance on communications and instructions received from the recipient party . To the extent that you wish to discontinue sending all reports to the recipient party, it is your responsibility to disable such integration.</p>';
                break;
            default:
                title = 'New Report Archive Disclaimer';
                message = "<p>Investment Advisor hereby authorizes Orion to release and/or make available, in electronic form and/or interactive format, copies of all reports generated by the Orion system to the recipient party's destination sFTP site provided by Investment Advisor.  Please note that Orion is not responsible for actions taken by your office/firm in connection with this integration feature. By providing your credentials and an sFTP location to send all reports ran in your database, you are authorizing the recipient party to receive client data maintained on the Orion system and releasing Orion from all claims, liabilities, losses, damages, attorneys’ fees and expenses of any kind resulting from sending and allowing access to your client data, including any manipulation, alteration, or changes to the data, as well as Orion’s actions in reliance on communications and instructions received from the recipient party . To the extent that you wish to discontinue sending all reports to the recipient party, it is your responsibility to disable such integration.</p>";
                break;
        }
        return $dialog
            .messageBox(title, message, [{result: true, label: 'Accept', focus: true, cssClass:"btn-primary"}, {result: false, label: 'Decline', focus: false}])
            .open();
    };

    //PUBLIC METHODS

    $scope.addNewConfiguration = function (type) {
        openDisclaimerModal(type)
            .then(function(results) {
                if(results) {
                    $scope.selectedConfiguration = {type: type, enabled: true, repIdFilter: []};
                    openDialog($scope.selectedConfiguration, null)
                }
        });
    };


    $scope.editDialog = function(object, idx){
        openDialog(object, idx)
    };


    $scope.removeActive = function () {
        $scope.activeConfiguration = undefined;
        $scope.selectedConfiguration = undefined;
    };

    $scope.displayMessage = function () {
        $dialog.dialog({templateUrl: "archive-message.html",controller: "ArchiveMessageCtrl"})
            .open();
    };

    $scope.deleteConfiguration = function (configuration, index) {
        return $http.delete('/Compliance/Archive/' + configuration.id, {

            trackerMsg: 'Deleting configuration'
        }).then(function (response) {
            $scope.configurations.splice(index, 1);
            return response;
        });
    };

    $scope.canDelete = function(configuration) {
        return ($scope.isAdmin || configuration.type === 0) && $scope.rightArchive.canDelete;
    };


    //INITIALIZE
    $scope.rightArchive = $oasRights.forCode("COMPLIANCEARCHIVE");
    $scope.configurations = [];
    $scope.filteredTypes = [];
    $scope.isAdmin = $rootScope.user.authorization.entity === 'Administrator';
    init();
});



app.controller('ArchiveMessageCtrl', function ArchiveMessageCtrl($scope, $http, $window, dialog) {

    $scope.openFactSheet = function() {
        $window.open('https://social.orionadvisor.com/orion-docs/compliance-archive-pdf-meta-data-compliance-tool-faq/?action=sso&t=' + sessionStorage.oas_token);
    };

    $scope.cancel = function () {
        dialog.close();
    };

});

'use strict';


app.controller('ArchiveEditCtrl', function ArchiveEditCtrl($scope, $dialog, $http, $q, $window, dialog, $rootScope, $oasRights) {
    //PRIVATE METHODS
    function init() {
        $scope.isAdmin = $rootScope.user.authorization.entity === 'Administrator';

        // Use sample date range for testing (last 30 days)
        $scope.metaDataTest = {};
        $scope.metaDataTest.startDate = Date.create('today');
        $scope.metaDataTest.startDate.beginningOfMonth();
        $scope.metaDataTest.endDate = Date.create('today');


        $http.get('/Portfolio/Representatives/Simple', {trackerMsg: 'Fetching reps'}).then(function(response) {
            response.data.filter(function(rep) {
                return !$scope.config.repIdFilter.includes(rep.id);
            }).forEach(function(item) {
                $scope.allReps.push(item);
            });
            $scope.config.repIdFilter.reduce(function(list, id) {
                var result = response.data.find(function(rep) {
                    return rep.id === id;
                });
                if(!!result) { list.push(result); }
                return list;
            }, $scope.filteredReps);
        });
    }

    //PUBLIC METHODS
    $scope.testConnection = function() {
        var testConnectionUrl = '/Compliance/Archive/Test';
        // Tests the connect of the url with the credentials provided.
        return $http.put(testConnectionUrl, $scope.config, {ignoreExceptions: true, trackerMsg: 'Testing sftp credentials: ' + $scope.config.url})
                    .then(function(response) {
                        var message = "<p>The connection test succeeded. To finish the archive setup, please save the configuration. </p>";
                        return $dialog.messageBox('Report Archive Test Succeeded', message, [{result: true, label: 'OK', focus: true}])
                        .open();
                    }).catch(function(error) {
                        $scope.testTried = true;
                        var message = "<p>Below are some troubleshooting tips.</p>" +
                            "<p>1. Verify that credentials were entered correctly.</p>" +
                            "<p>2. Verify the credentials are for a SFTP connection. Archive does not support HTTPS, FTPS or FTP.</p>" +
                            "<p>3. Orion uses default port 22.  If your SFTP uses a different port it must be defined in the URL. <em>Example: sftp.url.com:2202</em></p>" +
                            "<p>If you are unsure about the above information, please contact your IT department for assistance. </p>";
                        return $dialog.messageBox('Report Archive Test Failed', message, [{result: false, label: 'OK', focus: true, cssClass:"btn-primary"}])
                        .open();
                    });
    };

    $scope.testMetaData = function() {
        if (!$scope.config.id) {
            let message = "<p>Please save the configuration first before testing the metadata generation.</p>";
            return $dialog.messageBox('Configuration Required', message, [{result: false, label: 'OK', focus: true, cssClass:"btn-primary"}])
                .open();
        }

        let startDate = $scope.metaDataTest.startDate.toISOString().split('T')[0];
        let endDate = $scope.metaDataTest.endDate.toISOString().split('T')[0];

        let testMetaDataUrl = '/Compliance/Archive/' + $scope.config.id + '/TestMetaData' +
            '?startDate=' + startDate +
            '&endDate=' + endDate;

        return $http.get(testMetaDataUrl, {
            ignoreExceptions: true,
            trackerMsg: 'Testing metadata generation for archive: ' + $scope.config.id,
            responseType: 'blob'
        }).then(function(response) {
            // Create a download link for the zip file
            let blob = new Blob([response.data], { type: 'application/zip' });
            let url = $window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = 'archive_test_' + $scope.config.id + '_' + startDate + '_to_' + endDate + '.zip';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            $window.URL.revokeObjectURL(url);

            let message = "<p>The metadata test succeeded and the archive file has been downloaded.</p>" +
                "<p>Date range tested: " + startDate + " to " + endDate + "</p>";
            return $dialog.messageBox('Metadata Test Succeeded', message, [{result: true, label: 'OK', focus: true}])
                .open();
        }, async function(error) {
            const jsonString = await error.data.text();
            const jsObject = JSON.parse(jsonString);
            let errorMessage = jsObject.Message || 'Unknown error occurred';
            let message = "<p>The metadata test failed with the following error:</p>" +
                "<p><strong>" + errorMessage + "</strong></p>";
            return $dialog.messageBox('Metadata Test Failed', message, [{result: false, label: 'OK', focus: true, cssClass:"btn-primary"}])
                .open();
        });
    };


    $scope.toggleEnabled = function() {
        $scope.config.enabled = !$scope.config.enabled
    };

    $scope.togglePassword = function(){
        $scope.showPassword = !$scope.showPassword;
    };

    $scope.saveConfiguration = function() {
        if(!$scope.reportArchiveForm.$valid){
            $scope.config.enabled = false;
        }

        var temp = [];
        if(!$scope.useAllReps) {
            $scope.filteredReps.forEach(function(elem) {
                temp.push(elem.id);
            });
        }
        $scope.config.repIdFilter = temp;
        if($scope.config.type === 1 || $scope.reportArchiveForm.$valid) {
            if($scope.config.id){
                $http.put('/Compliance/Archive/' + $scope.config.id, $scope.config, {trackerMsg: 'adding sftp credentials'})
                    .then(function(response) {
                        dialog.close(response.data);
                    });
            } else {
                $http.post('/Compliance/Archive', $scope.config, {trackerMsg: 'adding sftp credentials'})
                    .then(function(response) {
                        dialog.close(response.data);
                    });
            }


        }
    };

    $scope.cancel = function () {
        dialog.close();
    };



    //INITIALIZE
    $scope.rightArchive = $oasRights.forCode("COMPLIANCEARCHIVE");

    $scope.config= dialog.options.config;
    $scope.archiveFormDisabled = !(!!$scope.config && !!$scope.config.enabled);
    $scope.canTogglePassword = 'Administrator' === $rootScope.user.authorization.entity;
    $scope.reps = [];
    $scope.showPassword = false;
    $scope.useAllReps = !(!!$scope.config && !!$scope.config.repIdFilter && $scope.config.repIdFilter.length > 0);
    $scope.filteredReps = [];
    $scope.allReps = [];
    $scope.types = [
        'Custom',
        'LPL',
        'SecurityAmerica'
    ];

    init();

});

'use strict';

app.controller('AuditListCtrl', function AuditListCtrl($scope, $http, $oasRights, $dialog, $location, $routeParams, entities, $q, $rootScope, tokenFactory) {

    // PRIVATE VARIABLES
    const complianceFilterName = "compliance_filters_" + $scope.user.id;
    const addNew = ($routeParams.addNew === "1");

    // PRIVATE METHODS
    function init() {
        const sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));
        if (sessionFilters) {
            $scope.current.databases = sessionFilters.find((item) => {
                return item.label === "Database";
            }).selected;
            $scope.showClientColumn = sessionFilters.find({label: 'Database'}).selected.length > 0;
        }

        $http.post("/Compliance/AuditRequests/Summary", sessionFilters, {trackerMsg: "Loading audits"})
            .then(function (response) {
                $scope.current.auditRequests = response.data;
                if (addNew) {
                    $scope.auditAction();
                }
            });
    }

    // PUBLIC METHODS
    $scope.refresh = function () {
        init();
    };

    $scope.onHideDatabaseFilterColumn = function(value){
        $scope.current.showDatabaseFilterColumn = value;
    };

    $scope.auditAction = function (ar) {
        let oldName = ar ? ar.name : '';
        $dialog.dialog({templateUrl: "audit-action.html", controller: "AuditActionCtrl", auditRequest: ar})
            .open()
            .then(function (result) {
                if (result) {
                    result.file = null;
                    $scope.current.auditRequests.push(result);
                    if (ar) {
                        $scope.updateBreadcrumb(result.name, oldName);
                        $scope.current.auditRequests.remove(ar);
                    } else {
                        $scope.auditItems(result);
                    }
                }
            });
    };

    $scope.auditClone = function (ar) {
        const newAuditRequest = {
            name: ar.name + " (Copy)",
            entity: entities[entities.find({name: ar.entity})].value,
            dueDate: Date.create(ar.dueDate).format('{yyyy}-{MM}-{dd}'),
            alClientId: ar.alClientId,
        };

        tokenFactory.getDatabaseToken(ar.alClientId)
            .then(function (token) {
                $q.all({
                    auditRequest: $http.post('/Compliance/AuditRequests',newAuditRequest,{headers: {Authorization: "Session " + token},trackerMsg: "Cloning audit request"}),
                    auditItems: $http.get('/Compliance/AuditRequests/' + ar.id + '/Items', {headers: {Authorization: "Session " + token},trackerMsg: 'Loading audit items'})
                })
                    .then(function (responses) {
                        const auditRequest = responses.auditRequest.data;
                        const auditItems = responses.auditItems.data;

                        auditItems.forEach(function (itm) {
                            itm.attachments = [];
                            itm.auditRequestId = auditRequest.id;
                            itm.id = null
                        });

                        $http.put('/Compliance/AuditRequests/Items', auditItems, {trackerMsg: "Saving audit request items"})
                            .then(function (response) {
                                if (response)
                                    $scope.current.auditRequests.push(auditRequest);
                            });
                    });
            });
    };

    $scope.auditItems = function (ar) {
        if($rootScope.user.authorization.alClientId != ar.alClientId){
            //intentionally opens new tab, could be linked to a different db
            const redirectUrl = window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html?p=";
            tokenFactory.getDatabaseToken(ar.alClientId)
                .then(function (token) {
                    const encodedValue = encodeURIComponent($location.path() + '/' + ar.id );
                    const url = redirectUrl + encodedValue + "&t=" + token;
                    window.open(url);
                });
        } else {
            const path = $location.path() + '/' + ar.id;
            $location.path(path);
        }

    };

    $scope.displayMessage = function () {
        $dialog.messageBox("Why this tool is important", "Orion’s Audit Tool is available to help you get the data you need to respond to a regulator’s audit request.  Through this tool, Orion can get you information to fulfill the regulator’s request and provide you with some tips on what you can expect throughout the process.").open();
    };

    $scope.deleteAudit = function (ar) {
        tokenFactory.getDatabaseToken(ar.alClientId)
            .then(function (token) {
                $dialog.confirmAction('Are you sure you want to delete this audit request?')
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            $http.delete("/Compliance/AuditRequests/" + ar.id, { headers: {Authorization: "Session " + token},trackerMsg: 'delete audit request'})
                                .then(function () {
                                    $scope.deleteBreadcrumb(ar.name);
                                    $scope.current.auditRequests.remove(ar);
                                });
                        }
                    });
            });

    };

    // INITIALIZE
    $scope.rightsCompassAudit = $oasRights.forCode("COMPASSAUDIT");
    $scope.current = {
        returnItem: null,
        additionalData: {name: null, dueDate: null},
        auditRequests: [],
        databases: [],
    };
    $scope.showSideBar = $rootScope.user.authorization.databaseCount > 1;
    $scope.showClientColumn = false;
    $scope.current.showDatabaseFilterColumn = false;
    init();
});

app.controller('AuditActionCtrl', function AuditActionCtrl($scope, $http, dialog, entities, API_CONFIG, $rootScope, tokenFactory) {

    const complianceFilterName = "compliance_filters_" + $scope.user.id;

    //PRIVATE METHODS
    function init() {

        if(!$scope.auditRequest.id){

            let sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));
            if(sessionFilters == undefined || sessionFilters == null){
                sessionFilters = [];
            }

            $scope.current.databases =  sessionFilters.find((item)=>{
                return item.label === "Database";
            }).selected;

            $scope.auditRequest.alClientId = ($scope.current.databases.length > 0)
                ? $scope.current.databases[0].id
                : $scope.user.authorization.alClientId;
        }


    }

    //PUBLIC METHODS
    $scope.submit = function () {

        $scope.auditRequest.entity = entities[entities.find({name: $scope.auditRequest.entity})].value;

        if ($scope.auditRequest.dueDate) {
            $scope.auditRequest.dueDate = Date.create($scope.auditRequest.dueDate).format('{yyyy}-{MM}-{dd}');
        }
        if ($scope.auditRequest.completedDate) {
            $scope.auditRequest.completedDate = Date.create($scope.auditRequest.completedDate).format('{yyyy}-{MM}-{dd}');
        }

        tokenFactory.getDatabaseToken($scope.auditRequest.alClientId)
            .then(function (token) {
                const args = {
                    method: $scope.current.method,
                    trackerMsg: "Saving audit request ",
                    url: ($scope.current.method === 'POST')
                            ? '/Compliance/AuditRequests'
                            :'/Compliance/AuditRequests/' + $scope.auditRequest.id,
                    headers: {Authorization: "Session " + token}
                };

                if ($scope.current.fileName) {
                    $scope.$broadcast('event:compass-audit-upload-action', {action: 'upload-file', url: args.url});
                    $scope.current.sent = true;
                } else {
                    $http({
                        method: args.method,
                        url: args.url,
                        data: $scope.auditRequest,
                        headers: args.headers,
                        trackerMsg: args.trackerMsg
                    })
                        .then(function (response) {
                            $scope.current.sent = true;
                            $scope.current.returnData = response.data;
                        })
                }

            });

    };

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.viewLetter = function (rl, alClientId) {
        tokenFactory.getDatabaseToken(alClientId)
            .then(function (token) {
                window.location.href = API_CONFIG.baseUrl + '/Compliance/AuditRequests/DownloadRequestLetter/' + rl + '?Authorization=' + token;
            });

    };


    $scope.$watch("current.returnData", function () {
        if ($scope.current && $scope.current.sent) dialog.close($scope.current.returnData);
    });


    //INITIALIZE
    $scope.entityOptions = [
        {name: "RIA", code: "Advisor"},
        {name: "Representative", code: "Representative"} ];
    $scope.current = {
        returnData: null,
        sent: false,
        fileName: null,
        userEntity: $rootScope.user.authorization.entity,
        isAdmin: $rootScope.user.authorization.entity === "Administrator",
        databases: [],
    };
    $scope.auditRequest = (dialog.options.auditRequest)
        ? dialog.options.auditRequest
        : {entity: ($scope.current.isAdmin) ? $scope.entityOptions[0].code : $scope.current.userEntity};
    $scope.current.method= $scope.auditRequest.id ? 'PUT' : 'POST';
    $scope.current.isEdit = !!$scope.auditRequest;
    init();

});

'use strict';

app.controller('AuditItemsCtrl', function AuditItemsCtrl($scope, $http, $oasRights, $dialog, $location, $routeParams, $dataQuery, $q, $window, API_CONFIG, tokenFactory) {

    // PRIVATE VARIABLES
    let auditId = $routeParams.auditId;
    let auditItemsOriginal = [];
    let auditCategoriesOriginal = [];
    let defaultCategories = [];
    const complianceFilterName = "compliance_filters_" + $scope.user.id;

    // PRIVATE METHODS
    function init() {

        $q.all({
            defaultCategories: $http.get('/Compliance/AuditRequests/DefaultCategories', {trackerMsg: 'Loading audit request default categories'}),
            auditRequest: $http.get('/Compliance/AuditRequests/' + auditId, {trackerMsg: 'Loading audit request'}),
            auditItems: $http.get('/Compliance/AuditRequests/' + auditId + '/Items', {trackerMsg: 'Loading audit items'})
        })
            .then(function (responses) {
                defaultCategories = responses.defaultCategories.data;
                defaultCategories.forEach(function (cat) {
                    if (responses.auditItems.data.map('category').unique().any(cat.description)) {
                        $scope.current.auditCategories.push(cat.description)
                    }
                });
                $scope.current.auditRequest = responses.auditRequest.data;
                $scope.current.auditItems = responses.auditItems.data.sortBy("id").groupBy("category");
                if (responses.auditItems.data.length === 0) {
                    $scope.modifyItems();
                    $scope.addItem(true);
                }
            });
    }


    // PUBLIC METHODS
    $scope.modifyItems = function () {
        $scope.current.isEditMode = true;
        auditItemsOriginal = angular.copy($scope.current.auditItems);
        auditCategoriesOriginal = angular.copy($scope.current.auditCategories);
    };

    $scope.downloadAll = function (id) {
        $window.location.href = API_CONFIG.baseUrl + "/Compliance/AuditRequests/" + id + "/DownloadZipAttachments?Authorization=" + sessionStorage.oas_token;
    };

    $scope.showDescription = function (type, description) {
        $dialog.messageBox(type, description).open();
    };

    $scope.uploadAttachment = function (item) {
        $dialog.inputBox("Attach File", "File", "file", {postUrl: '/Compliance/AuditRequests/Items/' + item.id + '/UploadAttachment'})
            .open()
            .then(function (result) {
                if (result) {
                    if (!item.attachments) {
                        item.attachments = [];
                    }
                    item.attachments.push(result);
                }
            });
    };

    $scope.runDQ = function (item) {
        $dialog.dataQueryPrompt(item.customRptId, "audit-request-blob", true, false, null, item.id)
            .open()
            .then(function (result) {
                if (result && result.status && result.status === 201) {
                    $http.get('/Compliance/AuditRequests/Items/' + item.id, {trackerMsg: 'Loading audit item'})
                        .then(function (results) {
                            item.attachments = results.data.attachments;
                        });
                }
            });
    };

    $scope.downloadAttachments = function (item) {
        if (item.attachments.length === 1) {
            $window.location.href = API_CONFIG.baseUrl + "/Compliance/AuditRequests/Items/DownloadAttachment/" + item.attachments[0].blobId_Attachment + "?Authorization=" + sessionStorage.oas_token;
        } else {//return a zip file if multiple attachments
            $window.location.href = API_CONFIG.baseUrl + "/Compliance/AuditRequests/Items/" + item.id + "/DownloadZipAttachments?Authorization=" + sessionStorage.oas_token;
        }
    };

    $scope.deleteAttachments = function (item) {
        $dialog.confirmAction('Are you sure you want to delete the attachment' + (item.attachments.length > 1 ? 's?' : '?'))
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete("/Compliance/AuditRequests/Item/" + item.id + "/DeleteAttachments", {trackerMsg: 'delete all audit item attachments'})
                        .then(function () {
                            item.attachments = [];
                        });
                }
            });
    };

    $scope.saveItems = function () {
        $scope.current.isEditMode = false;

        if (!angular.equals(auditItemsOriginal, $scope.current.auditItems)) {
            $scope.current.isActive = false;
            const auditRequestItems = [];

            Object.extended($scope.current.auditItems).keys().forEach(function (key) {
                $scope.current.auditItems[key].forEach(function (val) {
                    auditRequestItems.push(val);
                })
            });
            tokenFactory.getDatabaseToken($scope.current.auditRequest.alClientId)
                .then(function (token) {
                    $http.put('/Compliance/AuditRequests/Items', auditRequestItems,
                        {
                            trackerMsg: "Saving audit request items",
                            headers: {Authorization: "Session " + token},
                        }
                    ).then(function (response) {
                        $scope.current.auditCategories = [];
                        defaultCategories.forEach(function (cat) {
                            if (response.data.map('category').unique().any(cat.description)) {
                                $scope.current.auditCategories.push(cat.description)
                            }
                        });
                        $scope.current.auditItems = response.data.sortBy("id").groupBy("category");
                        $scope.current.isActive = true;
                    });
                });
        }
    };

    $scope.cancelItems = function () {
        if (!angular.equals(auditItemsOriginal, $scope.current.auditItems)) {
            $dialog.confirmAction("There are unsaved changes, are you sure you want to cancel?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $scope.current.auditItems = angular.copy(auditItemsOriginal);
                        $scope.current.auditCategories = angular.copy(auditCategoriesOriginal);

                        $scope.current.isEditMode = false;
                    }
                });
        } else {
            $scope.current.isEditMode = false;
        }
    };

    $scope.addItem = function (isNew) {
        $dialog.dialog({
            dialogClass: "modal wide",
            templateUrl: "add-audit-item.html",
            controller: "AddAuditItemCtrl",
            auditRequestEntity: $scope.current.auditRequest.entity
        })
            .open()
            .then(function (result) {
                if (result) {
                    const auditRequestItems = [];

                    Object.extended($scope.current.auditItems).keys().forEach(function (key) {
                        $scope.current.auditItems[key].forEach(function (val) {
                            auditRequestItems.push(val);
                        })
                    });

                    if (result.checkedItems.length > 0) {
                        result.checkedItems.forEach(function (itm) {
                            const requestItem = {
                                auditRequestId: auditId,
                                category: itm.categoryName,
                                customRptId: itm.customRptId,
                                type: itm.type,
                                description: itm.description
                            };
                            auditRequestItems.push(requestItem);
                        });
                    } else {
                        const requestItem = {
                            auditRequestId: auditId,
                            category: result.category,
                            customRptId: result.customRptId,
                            type: result.type,
                            description: result.description
                        };
                        auditRequestItems.push(requestItem);
                    }

                    $scope.current.auditCategories = [];
                    defaultCategories.forEach(function (cat) {
                        if (auditRequestItems.map('category').unique().any(cat.description)) {
                            $scope.current.auditCategories.push(cat.description)
                        }
                    });

                    $scope.current.auditItems = auditRequestItems.groupBy("category");

                    if (isNew) {
                        $scope.saveItems();
                    }
                }
            });
    };

    $scope.editRequestItem = function (item) {
        $dialog.dialog({templateUrl: "edit-audit-item.html", controller: "EditAuditItemCtrl", auditRequestItem: item})
            .open()
            .then(function (result) {
                if (result) {
                    item.type = result.type;
                    item.description = result.description;
                }
            });

    };

    $scope.deleteRequestItem = function (item) {
        $scope.current.auditItems[item.category].remove(item);
    };

    //endregion

    // INITIALIZE
    $scope.rightsCompassAudit = $oasRights.forCode("COMPASSAUDIT");
    $scope.current = {
        auditRequest: null,
        auditItems: [],
        auditCategories: [],
        isActive: true,
        isEditMode: false
    };

    init();
});


app.controller('EditAuditItemCtrl', function EditAuditItemCtrl($scope, dialog) {

    //PUBLIC METHODS
    $scope.submit = function () {
        dialog.close($scope.current.auditRequestItem);
    };

    $scope.cancel = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.current = {
        auditRequestItem: null
    };

    $scope.current.auditRequestItem = angular.copy(dialog.options.auditRequestItem);

});

app.controller('AddAuditItemCtrl', function AddAuditItemCtrl($scope, $http, dialog, $q, $dialog, entities) {

    //PRIVATE VARIABLES
    const forEntity = entities[entities.find({name: dialog.options.auditRequestEntity})].value;
    const complianceFilterName = "compliance_filters_" + $scope.user.id;

    //PRIVATE METHODS
    function init() {
        const sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));

        $q.all({
            defaultCategories: $http.get('/Compliance/AuditRequests/DefaultCategories', {trackerMsg: 'Loading audit request item default categories'}),
            defaultItems: $http.get('/Compliance/AuditRequests/DefaultItem?entity=' + forEntity, sessionFilters, {trackerMsg: 'Loading default audit items'})
        })
            .then(function (responses) {
                $scope.defaultCategories = responses.defaultCategories.data;
                $scope.defaultItems = responses.defaultItems.data.groupBy("description");

            });
    }

    function actionCatItems(cat, select) {
        if(!$scope.defaultItems[cat]){
            return;
        }

        if (select) {
            $scope.defaultItems[cat][0].items.forEach(function (itm) {
                const index = $scope.checkedItems.indexOf(itm);
                if (index === -1)
                    $scope.checkedItems.push(itm);
            });
        } else {
            $scope.defaultItems[cat][0].items.forEach(function (itm) {
                const index = $scope.checkedItems.indexOf(itm);
                if (index > -1)
                    $scope.checkedItems.remove(itm);
            });
        }


    }

    //PUBLIC METHODS
    $scope.insert = function () {
        const returnObj = {
            category: $scope.current.selectedCategory,
            categoryId: $scope.defaultCategories.find({description: $scope.current.selectedCategory}).id,
            type: $scope.current.type,
            description: $scope.current.description,
            customRptId: $scope.current.customRptId,
            entity: forEntity,
            alClientId: $scope.user.authorization.alClientId,
            checkedItems: $scope.checkedItems
        };

        if ($scope.current.selectedAddToLibrary === 'yes') {
            $http.post('/Compliance/AuditRequests/DefaultItem', returnObj, {trackerMsg: "Saving default audit request item"})
        }

        dialog.close(returnObj);
    };

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.processSource = function () {
        $scope.current.isExisting = ($scope.current.selectedSource === "existing");
        if ($scope.current.selectedSource === 'new') {
            if ($scope.defaultCategories.find({description: 'All Categories'})) {
                $scope.defaultCategories.remove({description: 'All Categories'})
            }
        } else {
            if (!$scope.defaultCategories.find({description: 'All Categories'})){
                $scope.defaultCategories.insert({description: 'All Categories'},0)
            }
            $scope.current.selectedCategory = "All Categories";
        }

    };

    $scope.selectItems = function (select) {
        if ($scope.current.selectedCategory === "All Categories") {
            $scope.defaultCategories.forEach(function (cat) {
                if (cat.description !== "All Categories") {
                    actionCatItems(cat.description, select)
                }
            });
        } else {
            actionCatItems($scope.current.selectedCategory, select)
        }
    };

    $scope.checkItem = function (itm) {
        const index = $scope.checkedItems.indexOf(itm);
        if (index > -1)
            $scope.checkedItems.splice(index, 1);
        else
            $scope.checkedItems.push(itm);
    };

    $scope.showDescription = function (type, description) {
        $dialog.messageBox(type, description).open();
    };

    $scope.addDataQuery = function () {
        $dialog.search("dataQuery", "Data Query")
            .open()
            .then(function (dataQuery) {
                if (dataQuery) {
                    $scope.current.customRptName = dataQuery.name;
                    $scope.current.customRptId = dataQuery.id;
                }
            });
    };

    $scope.checkFields = function () {
        let isEnabled = false;
        if ($scope.current.selectedSource === "existing") {
            isEnabled = $scope.current.selectedCategory && $scope.checkedItems.length > 0
        } else {
            isEnabled = $scope.current.selectedCategory && $scope.current.type
        }

        return !isEnabled;
    };

    //INITIALIZE
    $scope.current = {
        selectedSource: null,
        isExisting: null,
        selectedCategory: null,
        type: null,
        description: null,
        customRptId: null,
        customRptName: "",
        selectedAddToLibrary: "no"
    };

    $scope.defaultCategories = [];
    $scope.defaultItems = [];
    $scope.sourceOptions = [{
        name: "New",
        code: "new",
        description: "Create a new audit request item that does not already exist in the library of items.  This item can be used just for this audit or added to the library."
    }, {
        name: "Library",
        code: "existing",
        description: "Select an audit request item from a categorized list of typical items.  The item's name and description can be modified after it has been added to the audit."
    }];
    $scope.addToLibrary = [{name: "Yes", code: "yes"}, {name: "No", code: "no"}];
    $scope.checkedItems = [];

    init();

});

'use strict';

let auditLibraryCtrl = app.controller('AuditLibraryCtrl', function AuditLibraryCtrl($scope, $http, $oasRights, $dialog, $rootScope) {

    // PRIVATE constIABLES
    let auditItemsOriginal = [];

    // PRIVATE METHODS
    function init() {

        loadLibrary();
    }

    function loadLibrary() {

        $http.get('/Compliance/AuditRequests/DefaultItem?entity=' + $scope.current.selectedEntityType.code, {trackerMsg: 'Loading default audit items'})
            .then(function (response) {
                $scope.current.defaultItems = response.data;
                splitItems();
                auditItemsOriginal = angular.copy($scope.current.defaultItems);
            });
    }

    function splitItems() {

        $scope.current.defaultItems.forEach(function (cat) {
            cat.globalItems = [];
            cat.advisorItems = [];
            cat.items.forEach(function (itm) {
                if (!itm.alClientId) {
                    cat.globalItems.push(itm)
                } else {
                    cat.advisorItems.push(itm)
                }
            });
        });

    }

    // PUBLIC METHODS
    $scope.refresh = function () {
        loadLibrary();
    };

    $scope.showDescription = function (item) {
        $dialog.messageBox(item.type, item.description).open();
    };

    $scope.saveItems = function () {
        if (!angular.equals(auditItemsOriginal, $scope.current.defaultItems)) {
            $scope.current.defaultItems.forEach(function (cat) {
                cat.items = [];
                cat.items = cat.globalItems.union(cat.advisorItems);
            });
            $http.put('/Compliance/AuditRequests/DefaultCategories', $scope.current.defaultItems, {trackerMsg: "Saving default audit request items"})
                .then(function (response) {
                    $scope.current.defaultItems = response.data;
                    splitItems();
                    auditItemsOriginal = angular.copy($scope.current.defaultItems);
                    $dialog.saveSuccessful("Audit Item Library saved.").open();
                });
        }
    };

    $scope.cancelItems = function () {
        if (!angular.equals(auditItemsOriginal, $scope.current.defaultItems)) {
            $dialog.confirmAction("There are unsaved changes, are you sure you want to cancel?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $scope.current.defaultItems = angular.copy(auditItemsOriginal);
                    }
                });
        }
    };

    $scope.actionItem = function (item) {
        const args = {
            forEntity: $scope.current.selectedEntityType,
            auditItem: item
        };

        $dialog.dialog({
            templateUrl: "default-audit-item.html",
            controller: "DefaultAuditItemCtrl",
            resolve: {
                args: function () {
                    return args;
                }
            }
        })
            .open()
            .then(function (result) {
                if (result) {
                    if (item) {
                        if (item.categoryId !== result.categoryId) {
                            if (!result.alClientId) {
                                $scope.current.defaultItems.find({id: item.categoryId}).globalItems.remove(item);
                                $scope.current.defaultItems.find({id: result.categoryId}).globalItems.push(result);
                            } else {
                                $scope.current.defaultItems.find({id: item.categoryId}).advisorItems.remove(item);
                                $scope.current.defaultItems.find({id: result.categoryId}).advisorItems.push(result);
                            }
                        } else {
                            item.type = result.type;
                            item.description = result.description;
                            item.customRptId = result.customRptId;
                        }
                    } else {
                        if (!$scope.current.defaultItems.find({id: result.categoryId})) {
                            const newCat = {
                                description: result.categoryName,
                                id: result.categoryId,
                                items: [],
                                globalItems: [],
                                advisorItems: []
                            };
                            $scope.current.defaultItems.push(newCat);
                        }

                        if (!result.alClientId) {
                            $scope.current.defaultItems.find({id: result.categoryId}).globalItems.push(result);
                        } else {
                            $scope.current.defaultItems.find({id: result.categoryId}).advisorItems.push(result);
                        }
                    }
                }
            });
    };

    $scope.deleteGlobalItem = function (catItems, item) {
        $dialog.messageBox("Delete Global Audit Library Item", "<p>Deleting this record will remove it for all firm databases. Changes to the Audit Item global library must be approved by the Compliance Team.</p><p>Confirm you want to delete this item.</p> ", [{
            result: true,
            label: 'Continue',
            focus: false,
            cssClass: "btn-primary"
        }, {result: false, label: 'Cancel', focus: true}])
            .open()
            .then(function (result) {
                if (result) {
                    catItems.remove(item)
                }
            });
    };

    $scope.deleteRequestItem = function (catItems, item) {
        catItems.remove(item);
    };

    $scope.moveItem = function (items, item, indexChange) {
        const index = items.indexOf(item),
            newPos = index + indexChange;

        items.splice(index, 1);
        items.splice(newPos, 0, item);
    };


    // INITIALIZE
    $scope.isAdmin = $rootScope.user.authorization.entity === "Administrator";
    $scope.rightsCompassAudit = $oasRights.forCode("COMPASSAUDITLIBRARY");
    $scope.entityTypes = [
        {name: "Advisor", code: "Advisor"},
        {name: "Representative",code: "Representative"}];
    $scope.current = {
        defaultCategories: [],
        usedCategories: [],
        defaultItems: [],
        selectedEntityType: $scope.entityTypes[0]
    };

    init();
});


app.controller('DefaultAuditItemCtrl', function DefaultAuditItemCtrl($scope, $http, dialog, $dialog, args) {

    //PRIVATE const

    //PRIVATE METHODS
    function init() {

        if($scope.current.defaultAuditItem){
            $scope.current.isGlobal=  (!$scope.current.defaultAuditItem.alClientId)
        }


        $http.get('/Compliance/AuditRequests/DefaultCategories', {trackerMsg: 'Loading audit request item default categories'})
            .then(function (response) {
                $scope.defaultCategories = response.data;
            });

        if ($scope.current.defaultAuditItem && $scope.current.defaultAuditItem.customRptId) {
            $http.get('/Reporting/Custom/' + $scope.current.defaultAuditItem.customRptId, {trackerMsg: 'Loading data query info'})
                .then(function (response) {
                    $scope.current.customRptName = response.data.title
                });
        }
    }

    //PUBLIC METHODS
    $scope.update = function () {
        $scope.current.defaultAuditItem.categoryName = $scope.defaultCategories.find({id: $scope.current.defaultAuditItem.categoryId}).description;
        $scope.current.defaultAuditItem.alClientId = ($scope.current.isGlobal ? null : $scope.user.authorization.alClientId);
        $scope.current.defaultAuditItem.entity = $scope.current.selectedEntityType.code;
        dialog.close($scope.current.defaultAuditItem);
    };

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.addDataQuery = function () {
        $dialog.search("dataQuery", "Data Query Task")
            .open()
            .then(function (dataQuery) {
                if (dataQuery) {
                    $scope.current.customRptName = dataQuery.name;
                    $scope.current.defaultAuditItem.customRptId = dataQuery.id;
                }
            });
    };

    $scope.checkFields = function () {
        const isEnabled = $scope.current.defaultAuditItem ? $scope.current.defaultAuditItem.categoryId && $scope.current.defaultAuditItem.type : false;

        return !isEnabled;
    };

    //INITIALIZE
    $scope.locOptions = [
        {name: "Advisor", code: "Advisor"},
        {name: "Representative",code: "Representative"}];
    $scope.current = {
        defaultAuditItem: angular.copy(args.auditItem),
        selectedEntityType: args.forEntity,
        customRptName: null,
        selectedLocation: (args.auditItem) ? args.auditItem.entity : $scope.locOptions[0].code,
        isGlobal: true

    };
    $scope.defaultCategories = [];

    init();

});

'use strict';

app.controller('TestScheduleListCtrl', function TestScheduleListCtrl($scope, $http, $oasRights, $dialog, tokenFactory) {

    //PRIVATE VARIABLES
    const complianceFilterName = "compliance_filters_" + $scope.user.id;
    
    // PRIVATE METHODS
    function loadSchedules() {
        const sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));
        if(sessionFilters) {
            $scope.showClientColumn = sessionFilters.find({label: 'Database'}).selected.length > 0;
        }
        $http.post('/Compliance/AuditTests/Schedules/?isActive=' + isFilteredActive(), sessionFilters, {trackerMsg: 'Loading test schedule list'})
            .then(function (response) {
                $scope.current.testSchedules = response.data;
                $scope.categories = $scope.current.testSchedules.map("categoryDescription").unique();
            });
    }

    function isFilteredActive() {
        return $scope.current.selectedFilter === "Active";
    }


    // PUBLIC METHODS
    $scope.refresh = function () {
        loadSchedules();
    };

    $scope.scheduleDialog = function (sched) {
        $dialog.dialog({
            templateUrl: "tools/compass/modal/test-wizard.html",
            controller: "TestWizardCtrl",
            runNow: false,
            schedule: sched,
            dialogClass: 'modal wide'
        })
            .open()
            .then(function (result) {
                if (!result) return;
                $scope.current.testSchedules.remove(sched);
                $scope.categories = $scope.current.testSchedules.map("categoryDescription").unique();
                if (result.id) {
                    if (!result.alClientId) {
                        result.alClientId = $scope.user.authorization.alClientId;
                    }
                    tokenFactory.getDatabaseToken(result.alClientId)
                        .then(function (token) {
                            $http.put("/Compliance/AuditTests/Schedule", result, {
                                headers: {Authorization: "Session " + token},
                                trackerMsg: "Saving scheduled query"
                            })
                                .then(function (response) {
                                    if (isFilteredActive()) {
                                        $scope.current.testSchedules.push(response.data);
                                        $scope.categories = $scope.current.testSchedules.map("categoryDescription").unique();
                                    }
                                });
                        });


                } else {
                    if (!result.alClientId) {
                        result.alClientId = $scope.user.authorization.alClientId;
                    }
                    tokenFactory.getDatabaseToken(result.alClientId)
                        .then(function (token) {
                            $http.post("/Compliance/AuditTests/Schedule", result, {
                                headers: {Authorization: "Session " + token},
                                trackerMsg: "Saving scheduled query"
                            })
                                .then(function (response) {
                                    if (isFilteredActive()) {
                                        $scope.current.testSchedules.push(response.data);
                                        $scope.categories = $scope.current.testSchedules.map("categoryDescription").unique();
                                    }
                                });
                        });
                }
            });
    };

    $scope.startDefault = function (sched,dbId) {
        $http.post(`/Compliance/AuditTests/DefaultSchedule?templateId= ${sched.templateId}&dbId=${dbId}`,{

            trackerMsg: "Adding default schedules"
        })
            .then(function () {
                loadSchedules();
            });
    };

    $scope.activateSchedule = function (sched) {
        tokenFactory.getDatabaseToken(sched.alClientId)
            .then(function (token) {
                $http.put('/Compliance/AuditTests/ActiveSchedule', sched,
                    {
                        headers: {Authorization: "Session " + token},
                        trackerMsg: 'Updating query schedule'
                    })
                    .then(function (response) {
                        $scope.current.testSchedules.remove(sched);
                        $scope.categories = $scope.current.testSchedules.map("categoryDescription").unique();
                        if (isFilteredActive()) {
                            $scope.current.testSchedules.push(response.data);
                            $scope.categories = $scope.current.testSchedules.map("categoryDescription").unique();
                        }
                    });
            });
    };

    $scope.endSchedule = function (sched) {
        tokenFactory.getDatabaseToken(sched.alClientId)
            .then(function (token) {
                $http.put('/Compliance/AuditTests/EndSchedule', sched, {
                    headers: {Authorization: "Session " + token},
                    trackerMsg: 'Updating query schedule'
                })
                    .then(function () {
                        loadSchedules();
                    });

            });
    };

    $scope.exportToExcel = function () {

        var dataDetails = {
            columns: [
                {name: "Description", field: "description"},
                {name: "Category", field: "categoryDescription"},
                {name: "Data Query Title", field: "customReportTitle"},
                {name: "Sample Size", field: "sampleSize"},
                {name: "Frequency", field: "frequency"},
                {name: "Start Date", field: "startDate"},
                {name: "End Date", field: "endDate"},
                {name: "Last Run Date", field: "lastRunDate"},
                {name: "Next Run Date", field: "nextRunDate"}
            ],
            data: $scope.current.testSchedules
        };

        $http.post('/Utility/SlickGridExport/csv', dataDetails, {trackerMsg: 'Exporting grid'})
            .then(function (response) {
                window.location.href = response.headers("location") + "?Authorization=" + sessionStorage.oas_token;
            });

    };


    //INITIALIZE
    $scope.current = {returnItem: null, testSchedules: [], selectedFilter: "Active", showFilter: false};
    $scope.filterType = ["Active", "Ended"];
    $scope.rightsCompassAudit = $oasRights.forCode("COMPASSAUDIT");
    $scope.showClientColumn = false;

    loadSchedules();
});



'use strict';

const testResultListCtrl = app.controller('TestResultListCtrl', function TestResultListCtrl($scope, $http, $oasRights, $dialog, $location, views, $routeParams, $timeout, tokenFactory) {

    //PRIVATE VARIABLES
    let selectedRows;
    let sessionFilters;
    const redirectUrl = window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html?p=";
    const complianceFilterName = "compliance_filters_" + $scope.user.id;

    //PRIVATE METHODS
    function MarkRecordsCompleted(state, comment, rows, alClientId){
        const ids =  rows.map('id');
        const returnObject = {
            comment: comment,
            ids: ids,
            alClientId: alClientId
        };

        tokenFactory.getDatabaseToken(alClientId)
            .then(function (token) {
                const url = '/Compliance/AuditTests/Result/Completed/' + state;
                $http.put(url, returnObject, {headers: {Authorization: "Session " + token}, trackerMsg: 'Updated result'})
                    .then(function(){
                        $scope.$broadcast('event:test-result-reload', {action: 'refresh-grid'});
                    });
            });
    }

    //PUBLIC METHODS

    $scope.slickGridDoubleClick = function () {
        sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));
        const dbList = sessionFilters.find({label:"Database"}).selected;
        if(dbList.length > 0){
            if ($scope.selectedIds.length === 1 && $scope.current.databaseUrl && $scope.current.totalRows > 0 ) {
                window.open($scope.current.databaseUrl);
            }
        } else {
            if ($scope.selectedIds.length === 1 && $scope.current.redirect && $scope.current.totalRows > 0 ) {
                window.location.replace($scope.current.redirect);
            }
        }
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:test-result-reload', {action: 'export-data'});
    };

    $scope.refreshGrid = function () {
        $scope.current.compassFilters = JSON.parse(localStorage.getItem(complianceFilterName));
        $timeout(function() {
            $scope.$broadcast('event:test-result-reload', {action: 'refresh-grid'});
        });
    };

    $scope.newTest = function () {
        $dialog.dialog({
            templateUrl: "tools/compass/modal/test-wizard.html",
            controller: "TestWizardCtrl",
            runNow: true,
            schedule: null,
            dialogClass: 'modal wide'
        })
            .open()
            .then(function (result) {
                if (!result) return;
                tokenFactory.getDatabaseToken(result.alClientId)
                    .then(function (token) {
                        $http.post("/Compliance/AuditTests/RunTest", result, {headers: {Authorization: "Session " + token}, trackerMsg: "Running query"})
                            .then(function (response) {
                                if (!response) return;
                                $scope.$broadcast('event:test-result-reload', {action: 'refresh-grid'});
                            });
                    });



            });
    };

    $scope.editResultRow = function () {
        const row = selectedRows[0];
        const resultRecordCopy = angular.copy(row);
        $dialog.dialog({
            templateUrl: "test-result-record.html",
            controller: "TestResultRecordCtrl",
            result: resultRecordCopy,
            dialogClass: 'modal wide'
        })
            .open()
            .then(function (response) {
                if (response) {
                    $scope.$broadcast('event:test-result-reload', {action: 'refresh-grid'});
                }
            });
    };



    $scope.markCompleted = function (state) {

        const dbGroups = selectedRows.groupBy("alClientId");

        $dialog.inputBox('Mark Record(s) Completed', "Comment", "textarea", {required: true})
            .open()
            .then(function (result) {
                if (result) {
                    Object.each(dbGroups, function (key, val){
                        MarkRecordsCompleted(state, result,val,key)
                    });
                }
            });

    };

    $scope.displayMessage = function () {
        $dialog.messageBox("Why this tool is important", "Orion’s Supervise Tool is available to help you create a testing regimen that is required under section 206(4)-7 of the Advisers Act and to establish a supervisory exception reporting system to aid in the supervision of your policies and procedures, by reviewing portfolio management, trading practices, billing, and many other items need to reduce the risk to your firm. Through this tool, you will be able to schedule individual and regularly occurring compliance queries and supervisory exception reports.").open();
    };

    //EVENT LISTENERS
    $scope.$on('event:test-result-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        const propertyMap = {
            id: ["id"],
            isCompleted: ["isCompleted"],
            comment: ["comment"],
            totalRows:["totalRows"]
        };

        Object.each(args[0], function (key, value) {
            const searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
        if (args.length === 1) {
            tokenFactory.getDatabaseToken(args[0].alClientId)
                .then(function (token) {
                    const url = '/tools/compass/test/' + $routeParams.completed + '/' + args[0].id;
                    const encodedValue = encodeURIComponent(url);
                    $scope.current.databaseUrl = redirectUrl + encodedValue + "&t=" + token;
                    $scope.current.redirect = "#" + url;
                });
        }
    });


    // INITIALIZE
    sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));
    $scope.views = views;
    $scope.isCompletedView = $routeParams.completed;
    $scope.selectedIds = [];
    $scope.rightsCompassAudit = $oasRights.forCode("COMPASSAUDIT");
    $scope.rightsCompassAdmin = $oasRights.forCode("COMPASSAUDITADMIN");
    $scope.editMode = $scope.rightsCompassAudit.canEdit;
    $scope.showDateRange = $routeParams.completed != "false";
    $scope.current = {
        //no not set start and end date for open items
        startDate: $scope.showDateRange ? Date.create("today").addDays(-30) : null,
        endDate: $scope.showDateRange ? Date.create("today") : null,
        completed: $routeParams.completed,
        compassFilters: sessionFilters,
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: '/Compliance/AuditTests/Results',
        view: views[0],
        gridQueries: []
    };

});


app.controller('TestResultRecordCtrl', function TestResultCtrl($scope, $http, dialog, tokenFactory) {

    //PRIVATE METHOD
    function init(){
        if(!dialog.options.result.alClientId){
            return;
        }

        tokenFactory.getDatabaseToken(dialog.options.result.alClientId)
            .then( function(token) {
                $http.get('/Compliance/AuditTests/Results/' + dialog.options.result.id, {cache: false, headers: {Authorization: "Session " + token}, trackerMsg: 'Loading query result'})
                    .then(function (response) {
                        $scope.result = response.data;
                        $scope.current.showAddComment = $scope.result.comments ? false : true;
                    });
            });
    }

    //PUBLIC METHODS
    $scope.toggleAddComment = function(){
        $scope.current.showAddComment = !$scope.current.showAddComment;
    };

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.submit = function (result) {
        if(!result.alClientId){
            return;
        }

        if($scope.current.comment){
            $scope.result.comments.push({auditTestResultId: $scope.result.id, comment: $scope.current.comment});
            $scope.current.comment = '';
        }
        tokenFactory.getDatabaseToken(result.alClientId)
            .then(function (token) {
                const url = '/Compliance/AuditTests/Results/' + result.id;
                $http.put(url, result, {headers: {Authorization: "Session " + token}, trackerMsg: 'Updated supervise result'})
                    .then(function (response) {
                        dialog.close(response.data);
                    });
            });
    };

    //INITIALIZE
    $scope.current = {
        comment: ''
    };
    init();
});


testResultListCtrl.loadViewCode = ["$http", "$route", function ($http, $route) {
    let dto = "AuditTestResultDto";

    if ($route.current.params.completed === "true") {
        dto = "AuditTestResultCompletedDto";
    }

    if ($route.current.params.completed === "false") {
        dto = "AuditTestResultOpenDto";
    }

    return $http.get('/Settings/Views/' + dto, {trackerMsg: 'Loading views'})
        .then(function (response) {
            return response.data;
        });
}];
'use strict';

const testResultCtrl = app.controller('TestResultCtrl', function TestResultCtrl($scope, $http, $oasRights, $dialog, $routeParams, API_CONFIG, config, $portfolio, entities, $location) {
    //PRIVATE VARIABLES
    let selectedRows;
    let sessionFilters = [];
    const complianceFilterName = "compliance_filters_" + $scope.user.id;

    //PRIVATE METHODS
    function init() {
        $http.get('/Compliance/AuditTests/Results/' + $routeParams.id, {trackerMsg: 'Loading supervise result'})
            .then(function (response) {
                const data = response.data;
                $scope.current.name = data.description + ' ' + Date.create(data.runDate).format('{MM}/{dd}/{yyyy}');
                $scope.current.editMode = data.isCompleted ? false : $scope.rightsCompassAudit.canUpdate;
            });

        const path = $location.path();
        $scope.breadCrumb = "#" + path.substring(0, path.lastIndexOf('/'));

        //convert filters to slick grid filters
        sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));
        if(!sessionFilters){
            sessionFilters = [];
        }
        sessionFilters.forEach( function (item){
            if(item.label === "Database"){
                return;
            }
            if(item.entity !== 0){
                if(item.selected.length > 0){
                    const filterKey = '_' +item.label.replace("-"," ");
                    const filterName =  item.label + ' = ' + item.selected.flatten();
                    const filter = "(function(a) {return a ?  " + angular.toJson(item.selected) + ".some(function(b) { return a === b }) : false;})";

                    $scope.current.view.filters.push({
                        name: filterName,
                        value: filter,
                        key: filterKey,
                        include: true });
                }
            }
        })
    }


    // PUBLIC METHODS
    $scope.markCompleted = function (reviewed) {
        if (!$scope.selectedIds.length) return;

        $http.put("/Compliance/AuditTests/ResultRow/Action/Update/" + reviewed, $scope.selectedIds, {trackerMsg: 'Updating completed status'})
            .then(function (response) {
                if (!response) return;
                selectedRows.forEach(function (row) {
                    row.reviewed = reviewed;
                    row["last Reviewed By"] = response.data[0].lastReviewedBy;
                    row["last Reviewed Date"] = response.data[0].lastReviewedDate;
                    $scope.$broadcast('event:test-result-reload', {action: 'update-item', item: row});
                });
            });
    };

    $scope.markException = (isException) => {
        if (!$scope.selectedIds.length) return;

        $http.put("/Compliance/AuditTests/ResultRow/Action/Update/Exception/" + isException, $scope.selectedIds, {trackerMsg: 'Updating exception status'})
            .then(function (response) {
                if (!response) return;
                selectedRows.forEach(function (row) {
                    row.exception = isException;
                    $scope.$broadcast('event:test-result-reload', {action: 'update-item', item: row});
                });
            });
    };

    $scope.addComment = function (cmt) {
        $dialog.inputBox('Updated Selected', "Comment", "textarea", {inputValue: cmt})
            .open()
            .then(function (result) {
                if (result) {
                    $http.put("/Compliance/AuditTests/ResultRow/Action/Update/Comment?comment=" + result, $scope.selectedIds, {trackerMsg: 'Updating selected comments'})
                        .then(function (response) {
                            if (!response) return;
                            selectedRows.forEach(function (row) {
                                row.comment = response.data[0].comment;
                                row["last Reviewed By"] = response.data[0].lastReviewedBy;
                                row["last Reviewed Date"] = response.data[0].lastReviewedDate;
                                $scope.$broadcast('event:test-result-reload', {action: 'update-item', item: row});
                            });
                        });
                }
            })

    };

    $scope.editTestResult = function () {
        const row = selectedRows[0];

        const dto = {
            id: row.id,
            reviewed: row.reviewed,
            exception: row.exception,
            comment: (row.comment) ? row.comment : "",
            lastReviewedBy: row["last Reviewed By"],
            lastReviewedDate: row["last Reviewed Date"],
            file: {
                fileName: row.attachment
            }
        };

        $http.get(`/Compliance/AuditTests/ResultRow/CommentHistory/${dto.id}`, {trackerMsg: 'Loading Result Comment History'})
        .then(res =>  {
            if (res) {
                dto.commentHistory = res.data;
            }
        })

        $dialog.dialog({
            templateUrl: "test-result-row.html",
            controller: "TestResultRowCtrl",
            testResult: dto,
            editMode: $scope.current.editMode,
            dialogClass: 'modal wide'
        })
            .open()
            .then(function (result) {
                if (!result) return;
                row.id = result.id;
                row.comment = result.comment;
                row.reviewed = result.reviewed;
                row.exception = result.exception;
                row.attachment = result.file.fileName;
                row["last Reviewed By"] = result.lastReviewedBy;
                row["last Reviewed Date"] = result.lastReviewedDate;
                $scope.$broadcast('event:test-result-reload', {action: 'update-item', item: row});
            })
    };

    $scope.slickGridDoubleClick = function () {
        if (!$scope.current.editMode) return;

        if ($scope.selectedIds.length === 1) {
            $scope.editTestResult();
        }
    };

    $scope.openEditor = function (entityEnum, entityId) {
        const entity = entities[entityEnum];
        $portfolio.openEditor(entity.value, [entityId]);
    };

    $scope.getPortfolioRoute = function (entityEnum, entityId) {
        const entity = entities[entityEnum];
        return "#" + $portfolio.getGoToRoute(entity.urlFrag, entity.value, entityId);
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:test-result-reload', {action: 'export-data'});
    };

    $scope.downloadAttachment = function (testResultRowId) {
        window.location.href = API_CONFIG.baseUrl + '/Compliance/AuditTests/' + testResultRowId + '/DownloadAttachments?Authorization=' + sessionStorage.oas_token;
    };

    $scope.downloadAllAttachment = function (auditTestResultId) {
        window.location.href = API_CONFIG.baseUrl + '/Compliance/AuditTests/' + auditTestResultId + '/DownloadAllAttachments?Authorization=' + sessionStorage.oas_token;
    };


    //EVENT LISTENERS
    $scope.$on('event:edit-test-result', function () {
        editTestResult();
    });

    $scope.$on('event:test-result-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        const propertyMap = {
            clientId: ["pkclient", "fkclient", "householdid", "hhid", "clientid", "clientnumber"],
            registrationId: ["regid", "pkreg", "fkreg"],
            accountId: ["acctid", "pkaccount", "fkaccount", "accountid"],
            assetId: ["pkasset", "fkasset"],
            transactionId: ["transid", "tranid", "pktransaction", "fktransaction"],
            file: ["attachment"],
            id: ["id"],
            comment: ["comment"]
        };

        Object.each(args[0], function (key, value) {
            const searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
        SetRightClickContext(selectedRows);
    });

    function SetRightClickContext(selectedRows){
        $scope.current.viewHousehold = false;
        $scope.current.viewRegistration = false;
        $scope.current.viewAccount = false;
        $scope.current.viewAsset = false;
        $scope.current.viewTransaction = false;
        $scope.current.entityDivider = false;
        $scope.current.viewAttachment = false;
        $scope.current.allowBulkComment = false;
        $scope.current.showDropDown = false;


        if ($scope.current.editMode) {
            const markedReviewedCount = selectedRows.count({"reviewed": true});
            const allRowsAreReviewed = selectedRows.length === markedReviewedCount;
            const allRowsAreNotReviewed = markedReviewedCount === 0;
            $scope.current.showMarkReviewed = !allRowsAreReviewed;
            $scope.current.showMarkNotReviewed = !allRowsAreNotReviewed;
            $scope.current.showDropDown = true;
        }

        if (selectedRows.length === 1){
            if ($scope.current.clientId && $scope.rightsHH.canRead) {
                $scope.current.viewHousehold = true;
            }
            if ($scope.current.registrationId && $scope.rightsReg.canRead) {
                $scope.current.viewRegistration = true;
            }
            if ($scope.current.accountId && $scope.rightsAcc.canRead) {
                $scope.current.viewAccount = true;
            }
            if ($scope.current.assetId && $scope.rightsAst.canRead) {
                $scope.current.viewAsset = true;
            }
            if ($scope.current.transactionId && $scope.rightsTrn.canRead) {
                $scope.current.viewTransaction = true;
            }

            if($scope.current.file){
                $scope.current.viewAttachment = true;
                $scope.current.entityDivider = $scope.current.viewHousehold || $scope.current.viewRegistration
                    || $scope.current.viewAccount || $scope.current.viewAsset || $scope.current.viewTransaction;
            }
            $scope.current.showDropDown = true;
        }else{
            $scope.current.allowBulkComment = $scope.current.editMode;
        }
    }


    // INITIALIZE

    $scope.rightsHH = $oasRights.forCode("CLIENTS");
    $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
    $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
    $scope.rightsAst = $oasRights.forCode("ASSETS");
    $scope.rightsTrn = $oasRights.forCode("TRANSACTIONS");
    $scope.rightsCompassAudit = $oasRights.forCode("COMPASSAUDIT");
    $scope.views = [config];
    $scope.selectedIds = [];
    $scope.current = {
        compassFilters: sessionFilters,
        auditTestResultId: $routeParams.id,
        url: '/Compliance/AuditTests/' + $routeParams.id + '/ResultRows/' + config.dataQueryCacheKey,
        view: $scope.views[0],
        dataQueryCacheKey: null,
        dataQueryId: 0,
        dataQueryTitle: '',
        dataQueryEntity: null,
        returnData: null,
        filename: null,
        method: 'PUT',
        gridDoubleClick: $scope.slickGridDoubleClick,
        editMode: false, //will be updated during init
        name: $routeParams.name
    };

    init();
});

testResultCtrl.loadTestResultConfig = ["$http", "$route", function ($http, $route) {
    return $http.get("/Compliance/AuditTests/" + $route.current.params.id + "/ResultRows", {trackerMsg: 'Loading results'})
        .then(function (response) {
            return response.data;
        });
}];

app.controller('TestResultRowCtrl', function TestResultRowCtrl($scope, $http, dialog, API_CONFIG, $dialog) {

    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close();
    };

    $scope.submit = function () {
        const url = "/Compliance/AuditTests/ResultRow";

        if ($scope.testResult.exception && !$scope.testResult.comment) {
            $dialog.messageBox("Missing data", "You must enter a comment for exceptions.").open();
            return;
        }

        if ($scope.current.returnData) {
            $scope.$broadcast('event:compass-upload-file-action', {action: 'upload-file', url: url});
            $scope.current.sent = true;
        } else {
            $http.put(url, $scope.testResult, {trackerMsg: 'Updating test rows'})
                .then(function (response) {
                    dialog.close(response.data);
                });
        }
    };

    $scope.downloadAttachment = function (testResultRowId) {
        window.location.href = API_CONFIG.baseUrl + '/Compliance/AuditTests/' + testResultRowId + '/DownloadAttachments?Authorization=' + sessionStorage.oas_token;
    };


    //SCOPE WATCHERS
    $scope.$watch("current.returnData", function () {
        if ($scope.current.sent) {
            dialog.close($scope.current.returnData);
        }
    });


    //INITIALIZE
    $scope.editMode = dialog.options.editMode;
    $scope.testResult = dialog.options.testResult;
    $scope.current = {returnData: null, sent: false, fileName: null, method: 'PUT'};
});


'use strict';

app.controller('TestResultExceptionItemsCtrl', function TestResultExceptionItemsCtrl($scope, $routeParams, views) {

    //PRIVATE VARIABLES
    const complianceFilterName = "compliance_filters_" + $scope.user.id;

    //PRIVATE METHODS
    function init(){
        //convert filters to slick grid filters
        const sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));
        sessionFilters.forEach( function (item){
            if(item.label === "Database"){
                return;
            }
            if(item.selected.length > 0){
                const filterKey = item.label.replace("/","").camelize(false);
                const filterName = item.label + ': ' + item.selected.flatten();
                const filter = "(function(a) {return a ?  " + angular.toJson(item.selected) + ".some(function(b) { return a === b }) : false;})";

                $scope.current.view.filters.push({
                    name: filterName,
                    value: filter,
                    key: filterKey,
                    include: true });
            }
        })
    }

    //PUBLIC METHODS
    $scope.refreshGrid = function () {
        $scope.$broadcast('event:exception-items-grid-action', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:exception-items-grid-action', {action: 'export-data'});
    };


    //INITIALIZE
    $scope.views = views;
    $scope.current = {
        view: views[0],
        url: '/Compliance/AuditTests/ResultRow/Exceptions',
        name: $routeParams.name,
        startDate:Date.create("today").addDays(-180),
        endDate:Date.create("today"),
    };
    $scope.selectedIds = [];
    init();
});


'use strict';

 app.controller('CompassDashboardCtrl', function CompassDashboardCtrl($scope, $http, $oasRights, $rootScope, $q) {

     //PRIVATE VARIABLES
     const complianceFilterName = "compliance_filters_" + $scope.user.id;

    // PRIVATE METHODS
     function init(){
         $scope.refreshDashboard();
     }

     $scope.refreshDashboard = function(){

         const sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));

         if(sessionFilters){
             $scope.isFiltered = sessionFilters.filter(function(n) { return n.selected.length; }).length > 0;
             $scope.lexisNexisIsFiltered = sessionFilters.filter(function(n) {
                     if(["RIA", "Broker/Dealer", "Representative", "Database"].find(n.label)){
                            return n.selected.length;
                        }
             }).length > 0;
             $scope.auditItemsFiltered = sessionFilters.filter(function(n) {
                 if(["Database"].find(n.label)){
                     return n.selected.length;
                 }
             }).length > 0;
         }

         //Load all the Tiles
         $http.post('/Compliance/Dashboard/OpenAudits',sessionFilters, {trackerMsg: 'Loading audit tile'})
             .then(function (response) {
                 $scope.openAudit = response.data;
             });
         if($scope.rightsSupervise.canRead) {
             $http.post('/Compliance/Dashboard/OpenTests', sessionFilters, {trackerMsg: 'Loading supervise tile'})
                 .then(function (response) {
                     $scope.openSupervise = response.data;
                 });
         }

         if($scope.rightsDisclose.canRead) {
             $http.post('/Compliance/Disclose/AUM/' + $scope.asOfDate, sessionFilters, {trackerMsg: 'Loading disclose adv tile'})
                 .then(function (response) {
                     $scope.openDisclose = response.data;
                 });

             $http.post('/Compliance/Disclose/AUA/' + $scope.asOfDate, sessionFilters, {trackerMsg: 'Loading disclose aua tile'})
                 .then(function (response) {
                     $scope.aua = response.data;
                 });

             $http.post('/Compliance/Disclose/AUAProducts/' + $scope.asOfDate, sessionFilters, {trackerMsg: 'Loading disclose aua tile'})
                 .then(function (response) {
                     $scope.aua.products = response.data.products;
                 });
         }

         if( $scope.rightsCompassInform.canRead){
             $http.get('/Compliance/Dashboard/Inform/', {trackerMsg: 'Loading inform tile'})
                 .then(function (response) {
                     $scope.openInform = response.data;
                 });
         }

         switch($rootScope.user.authorization.entity){
             case 'Administrator':
             case 'Advisor':
                 $http.get('/Integrations/LexisNexis/Configuration', {trackerMsg: 'Checking LexisNexis configuration'})
                     .then(function(response) {
                         $scope.hasLexisNexisInstalled = $scope.rightsLexisNexis.canRead && response.data.installed;
                         if($scope.hasLexisNexisInstalled ){
                             $http.post('/Compliance/Dashboard/OpenLexisNexis', sessionFilters, {trackerMsg: 'Loading LexisNexis '})
                                 .then(function (response) {
                                     $scope.openLexisNexis = response.data;
                                 });
                         } else {
                             $scope.openLexisNexis.value = 0;
                         }

                     });
                 break;
             default:
                 $scope.openLexisNexis.value = 0;
                 $scope.hasLexisNexisInstalled = false;
                 break;
         }
     };

    // PUBLIC METHODS

     // INITIALIZE
     $scope.current = {
         complianceFilter: null
     };
     $scope.isFiltered = false;
     $scope.today = Date.now();
     $scope.asOfDate = Date.create($scope.today).format('{MM}-{dd}-{yyyy}');
     $scope.hasLexisNexisInstalled = false;
     $scope.rightsLexisNexis = $oasRights.forCode("LEXISNEXIS");
     $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
     $scope.rightsSupervise = $oasRights.forCode("COMPLIANCESUPERVISE");
     $scope.rightsDisclose = $oasRights.forCode("COMPLIANCEDISCLOSE");
     $scope.rightsVerify = $oasRights.forCode("COMPLIANCEVERIFY");
     $scope.openAudit = { value: "...",  nextDueDate: "..."};
     $scope.openSupervise = { value: "...", dailyAlerts: "..."};
     $scope.openLexisNexis = { value: "...", thisMonth: "..."};
     $scope.openInform = { value: "...", exceptions: "..."};
     $scope.openDisclose = { filingRequired:"...", equityValue: "..."};
     $scope.aua = {aum: "...", products: "..."};
     $scope.editGlobal =  $scope.entityType === "Administrator";
     init();
});
'use strict';

const concurUnlinkedGridCtrl = app.controller('ConcurUnlinkedGridCtrl', function ConcurUnlinkedGridCtrl($scope, views, $http, $window, $dialog, $rootScope, $oasRights, $location) {

    //PRIVATE VARIABLES
    let selectedRows = [];
    let concurIds = [];
    let accessPersonIds = [];

    //PRIVATE FUNCTIONS
    function linkUserDialog(userToLink) {
        let previousAccessPersonId = userToLink.accessPersonId;
        let previousShouldIgnore = userToLink.shouldIgnore;
        let previousAccessPersonName = userToLink.informAccessPerson;

        $dialog.dialog({ templateUrl: "tools/compass/modal/concur-linking.html", controller: "ConcurLinkingCtrl", unlinkedUser: userToLink, dialogClass: 'modal' })
            .open()
            .then(updatedUser => {
                if(updatedUser && (updatedUser.accessPersonId !== previousAccessPersonId || updatedUser.shouldIgnore !== previousShouldIgnore)) {
                    //handles setting and then reverting a record to it's original state
                    if (updatedUser.accessPersonId === null && updatedUser.shouldIgnore === false) {
                        spliceFromAllArrays(previousAccessPersonId, updatedUser);
                        return;
                    }

                    if (updatedUser.accessPersonId !== null){
                        let ids = [];
                        accessPersonIds.forEach(item => ids.push(item.accessPersonId))

                        if (ids.includes(updatedUser.accessPersonId)) {
                            duplicateUserDialog(updatedUser, previousAccessPersonId, previousAccessPersonName, previousShouldIgnore, userToLink);
                            return;
                        } 
                    }
                    updateAccessPersonList(previousAccessPersonId, updatedUser);
                    updateItemsList(updatedUser.concurEmployeeId);
                    pushToAllArrays(updatedUser);
                }
            });
        }
        

    function updateItemsList(concurEmployeeId) {
        if(concurIds.includes(concurEmployeeId)) {
            $scope.itemsToUpdate.splice($scope.itemsToUpdate.findIndex(idx => idx.concurEmployeeId === concurEmployeeId), 1);
        }
    }

    function updateAccessPersonList(previousAccessPersonId, updatedUser) {
        let index = previousAccessPersonId ? accessPersonIds.findIndex(idx => idx.accessPersonId === previousAccessPersonId) : accessPersonIds.findIndex(idx => idx.concurEmployeeId === updatedUser.concurEmployeeId);
        if(index > -1) {
            accessPersonIds.splice(index, 1);
        }
    }

    function spliceFromAllArrays(previousAccessPersonId, updatedUser) {
        previousAccessPersonId === null ? accessPersonIds.splice(accessPersonIds.findIndex(idx => idx.concurEmployeeId === updatedUser.concurEmployeeId), 1) : accessPersonIds.splice(accessPersonIds.findIndex(idx => idx === previousAccessPersonId), 1);

        concurIds.splice(concurIds.findIndex(idx => idx === updatedUser.concurEmployeeId));
        $scope.itemsToUpdate.splice($scope.itemsToUpdate.findIndex(idx => idx.concurEmployeeId === updatedUser.concurEmployeeId), 1);
        $scope.$broadcast('event:concur-unlinked-users-event', { action: 'upsert-items', items: [updatedUser] });
    }

    function pushToAllArrays(updatedUser) {
        accessPersonIds.push({ accessPersonId: updatedUser.accessPersonId, concurEmployeeId: updatedUser.concurEmployeeId})
        $scope.itemsToUpdate.push(updatedUser);
        if (!concurIds.includes(updatedUser.concurEmployeeId)){
            concurIds.push(updatedUser.concurEmployeeId);
        }
        $scope.$broadcast('event:concur-unlinked-users-event', { action: 'upsert-items', items: [updatedUser] });
    }

    function duplicateUserDialog(updatedUser, previousAccessPersonId, previousAccessPersonName, previousShouldIgnore, userToLink) {
        $dialog.messageBox('Unable to complete this request.', `The same Access Person (${updatedUser.informAccessPerson}) cannot be assigned to multiple Concur records. Please assign a different Access Person to this record.`, [{ result: true, label: 'OK', focus: true }, { result: false, label: 'Cancel', focus: true }])
            .open()
            .then(res => {
                if(res) {
                    userToLink.accessPersonId = previousAccessPersonId;
                    userToLink.informAccessPerson = previousAccessPersonName;
                    userToLink.previousShouldIgnore = previousShouldIgnore
                    linkUserDialog(userToLink);
                }
            });
    }

    //PUBLIC FUNCTIONS
    $scope.linkUserDialog = () => {
        linkUserDialog(angular.copy(selectedRows[0]));
    };

    $scope.slickGridDoubleClick = () => {
        if(selectedRows.length === 1) {
            linkUserDialog(angular.copy(selectedRows[0]));
        }
    };

    $scope.saveChanges = () => {
        $http.post('/Compliance/Concur/UnlinkedUsers', $scope.itemsToUpdate, { trackerMsg: 'Creating New Gift/Entertainment tasks' })
            .then(res => {
                $scope.refreshGrid();
            });
    };

    $scope.refreshGrid = () => {
        $scope.itemsToUpdate = [];
        concurIds = [];
        accessPersonIds = [];
        $scope.$broadcast('event:concur-unlinked-users-event', { action: 'refresh-grid' });
    };

    $scope.exportToExcel = () => {
        $scope.$broadcast('event:concur-unlinked-users-export', { action: 'export-data' });
    };

    $scope.$on('event:concur-unlinked-users-select', (e, args) =>  {
        if(args.length === 0) {
            return;
        }
        selectedRows = args;

        const propertyMap = {
            id: ["id"],
            concurEmployeeId: ["concuremployeeid"],
            lastName: ["lastname"],
            firstName: ["firstname"],
            emailAddress: ["emailaddress"],
            informAccessPerson: ["informaccessperson"],
            shouldIgnore: ["shouldignore"],
            accessPersonId: ["accesspersonid"]
        };

        Object.each(args[0], (key, value) => {
            let searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, (property, matchList) => {
                if(searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
    });

    
    $scope.$watch('itemsToUpdate', function (newValue, oldValue) {
        if (newValue.length === 0) {
            concurIds = [];
            accessPersonIds = [];
        }
    }, true);

    //INITIALIZE
    $scope.views = views;
    $scope.rightsInformConcur = $oasRights.forCode("INFORMCONCUR");
    $scope.selectedIds = [];
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: '/Compliance/Concur/UnlinkedUsers',
        view: views[0]
    };
    $scope.itemsToUpdate = [];
});
'use strict';

app.controller('DiscloseADVDashboardCtrl', function DiscloseADVDashboardCtrl($scope, $http, $q, $dialog, $route, $timeout, $location) {

    //PRIVATE VARIABLES
    let asOfDate = null;
    const complianceFilterName = "compliance_filters_" + $scope.user.id;

    //PRIVATE METHODS
    function init() {
        loadDashboard();
        $http.get("/Settings/Database/EntityOptions/Code/69ADVAUMACCRUEDINT", {trackerMsg: 'Check database entity option'})
            .then(function (response) {
                $scope.current.showAccruedInterestMessage = response.data.value === "True";
            });
        $http.get("/Compliance/Disclose/NeedEmployeeHouseholdsBanner")
            .then(function (response) {
                $scope.current.showEmployeeHouseholdsBanner = response.data;
            });
    }

    function loadDashboard() {

        const sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));

        asOfDate = Date.create($scope.current.asOfDate).format('{MM}-{dd}-{yyyy}');

        //Load all the Tiles
        $http.post('/Compliance/Disclose/AUM/' + asOfDate, sessionFilters, {trackerMsg: 'Loading assets under management'})
            .then(function (response) {
                $scope.current.aum = response.data;
            });
        $http.post('/Compliance/Disclose/Domestic/' + asOfDate, sessionFilters, {trackerMsg: 'Loading foreign vs domestic'})
            .then(function (response) {
                $scope.current.domestic = response.data;
            });
        $http.post('/Compliance/Disclose/Discretionary/' + asOfDate, sessionFilters, {trackerMsg: 'Loading discretionary vs non-discretionary'})
            .then(function (response) {
                $scope.current.discretionary = response.data;
            });
        $http.post('/Compliance/Disclose/WrapManaged/' + asOfDate, sessionFilters, {trackerMsg: 'Loading wrap managed aum'})
            .then(function (response) {
                $scope.current.wrapManaged = response.data;
            });
        $http.post('/Compliance/Disclose/AdvSloa/' + asOfDate, sessionFilters, {trackerMsg: 'Loading adv sloa'})
            .then(function (response) {
                $scope.current.advSloa = response.data;
            });
        $http.post('/Compliance/Disclose/AdvCustody/' + asOfDate, sessionFilters, {trackerMsg: 'Loading adv custody'})
            .then(function (response) {
                $scope.current.advCustody = response.data;
            });
        $http.post('/Compliance/Disclose/Custodian/' + asOfDate, sessionFilters,  {trackerMsg: 'Loading aum by custodian'})
            .then(function (response) {
                $scope.current.custodians = [];
                $scope.current.custodiansUnderTen = [];
                response.data.forEach(function (item) {
                    if(item.percentage >= 10){
                        $scope.current.custodians.push(item);
                    } else {
                        $scope.current.custodiansUnderTen.push(item);
                    }
                });
            });
        $http.post('/Compliance/Disclose/ByAssetCategory/' + asOfDate, sessionFilters, {trackerMsg: 'Loading by asset category'})
            .then(function (response) {
                $scope.current.assetCategories = response.data;
            });
        $http.post('/Compliance/Disclose/ByClientCategory/' + asOfDate, sessionFilters,   {trackerMsg: 'Loading by client category'})
            .then(function (response) {
                $scope.current.clientCategory = response.data;
            });

    }

    const hideSideBars = () => {
        $scope.rightSidebarStatus = angular.copy($scope.rightSidebar.isOpen);
        $scope.leftSidebarStatus = angular.copy($scope.leftSidebar.isOpen);

        if ($scope.rightSidebarStatus) {
            $scope.rightSidebar.isOpen = false;
        }

        if ($scope.leftSidebar.isOpen) {
            $scope.leftSidebar.isOpen = false;
        }

    }

    const onAfterPrint = () => {
        $scope.showFilters = false;
        $scope.rightSidebar.isOpen = $scope.rightSidebarStatus;
        $scope.leftSidebar.isOpen = $scope.leftSidebarStatus;
    }

        //PUBLIC METHODS
    $scope.showMore = function(){
        $scope.showAll = !$scope.showAll;
    };

    $scope.refresh = function(){
        $timeout(function(){
            loadDashboard();
        },0);
    };

    $scope.displayMessage = function () {
        $dialog.messageBox("Why this tool is important", "Firms are required to file and updated version of their Form ADV each year by filing an amendment within 90 days after the end of your fiscal year. These queries are available to assist you with identifying some of the information for that filing.").open();
    };

    $scope.getDetails = function(type){
        asOfDate = Date.create($scope.current.asOfDate).format('{MM}-{dd}-{yyyy}');
        const url = "#/tools/compass/disclose/" + type + "?asOfDate=" + asOfDate;
        window.location.replace(url);
    };

    $scope.print = () => {
        $scope.exportFilters = JSON.parse(localStorage.getItem(complianceFilterName));
        $scope.showFilters = true;
        hideSideBars();
        setTimeout(() => {
            window.print();
        }, 250);
    }

    //INITIALIZE
    $scope.today = Date.now();
    $scope.asOfDate = ($route.current.params.asOfDate) ?  Date.create($route.current.params.asOfDate).format('{MM}/{dd}/{yyyy}') : Date.create().toISOString();
    $scope.showAll = false;
    $scope.showFilters = false;
    $scope.rightSidebarStatus = true;
    $scope.leftSidebarStatus = true;
    $scope.current = {
        asOfDate: $scope.asOfDate,
        filing: null,
        aum: null,
        domestic: null,
        discretionary: null,
        wrapManaged: null,
        custodians: null,
        custodiansUnderTen: null,
        clientCategory: null,
        assetCategories: null,
        advSloa:null,
        advCustody:null,
        advAumHelp: "To be included in this calculation the Account, Product and Asset must be marked as ADV Reportable in Portfolio Audit and the account must have a positive value as of the date you entered.",
        advDomesticHelp: "To be included in this calculation the Account, Product and Asset must be marked as ADV Reportable.  To be considered Domestic the Household must be marked as US Resident in Portfolio Audit.",
        advDiscretionaryHelp: "To be included in this calculation the Account, Product and Asset must be marked as ADV Reportable. To be considered Discretionary the Account must be marked as Discretionary in Portfolio Audit.",
        advWrapManagedHelp: "To be included in this calculation the Account, Product and Asset must be marked as ADV Reportable. To be considered Wrap Managed the Account must be marked as Wrap Managed in Portfolio Audit.  To be considered Wrap Sponsored the Account must be marked as Wrap Sponsored in Portfolio Audit.  To be considered both Wrap Managed and Wrap Sponsored the Account must be marked both Wrap Managed and Wrap Sponsored in Portfolio Audit.",
        advCustodianHelp:  "To be included in this calculation, the Account, Product and Asset must be ADV reportable. A custodian must be selected on the account, and the ADV Client category must be assigned.",
        advAssetHelp: "To be included in this calculation the Account, Product and Asset must be marked as ADV Reportable, an ADV Asset Category must be selected, and an ADV Client Category must be selected on the household.",
        advClientHelp: "To be included in this calculation the Account, Product and Asset must be marked as ADV Reportable and an ADV Client Category must be selected.",
        missingCategoryMessage: "This information will display once you've set the ADV Client Category at the Household level.",
        accruedInterestHelp: "If you have Accrued Interest as a database entity options for Disclose, all historical dates will include Accrued Interest.  Today's date will not include Accrued Interest.",
        advSloaHelp:"This dashboard is to help identify accounts that meet SEC Custody Rule (ii) Any arrangement (including a general power of attorney) under which you are authorized or permitted to withdraw client funds or securities maintained with a custodian upon your instruction to the custodian.",
        advCustodyHelp:"To be included on this calculation, the Account, Product and Asset must be ADV reportable. To be considered for custody, the account must have either 1st party or 3rd party selected at the Options> Compliance> Custody section of Portfolio Audit.",
    };
    window.onafterprint = onAfterPrint;
    init();
});
'use strict';

app.controller('Disclose13FDashboardCtrl', function Disclose13FDashboardCtrl($scope, $http, $q, $dialog, $route, $timeout, API_CONFIG) {

    //PRIVATE VARIABLES
    let asOfDate = null;
    const complianceFilterName = "compliance_filters_" + $scope.user.id;

    //PRIVATE METHODS
    function init() {
        loadDashboard();
        $http.get("/Compliance/Disclose/NeedEmployeeHouseholdsBanner")
            .then(function (response) {
                $scope.current.showEmployeeHouseholdsBanner = response.data;
            });
    }

    function loadDashboard(){

        asOfDate = Date.create($scope.current.asOfDate).format('{MM}-{dd}-{yyyy}');
        const sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));
        //Load all the Tiles
        $http.post('/Compliance/Disclose/13f/InformationSummary/' + asOfDate, sessionFilters, {trackerMsg: 'Loading 13f filing requirements'})
            .then(function (response) {
                $scope.current.filing = response.data;
            });

        $http.post('/Compliance/Disclose/13f/FormReportSummary/' + asOfDate, sessionFilters, {trackerMsg: 'Loading 13f file summary'})
            .then(function (response) {
                $scope.current.tableMarketValue = response.data.tableMarketValue;
                $scope.current.tableEntryTotal = response.data.tableEntryTotal;
            });
    }

    //PUBLIC METHODS
    $scope.refresh = function(){
        $timeout(function(){
            loadDashboard();
        },0);
    };

    $scope.displayMessage = function () {
        $dialog.messageBox("Why this tool is important", "Form 13F filings are required when you meet the $100 million filing threshold on the last trading day of any month during any calendar year. These queries are available to assist you with identifying information for that filing.").open();
    };

    $scope.getDetails = function(type){
        const asOfDate = Date.create($scope.current.asOfDate).format('{MM}-{dd}-{yyyy}');
        const url = "#/tools/compass/disclose/" + type + "?asOfDate=" + asOfDate;
        window.location.replace( url );
    };

    $scope.getXmlDetails = function(){
        const sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));

        if (sessionFilters) {
            $dialog.messageBox("Important", "This xml file will include only products in the " + $scope.user.authorization.alClientName + " database.").open();
        }


        const asOfDate = Date.create($scope.current.asOfDate).format('{MM}-{dd}-{yyyy}');
        $http.post('/Compliance/Disclose/FormReport13F/' + asOfDate + '/XML', sessionFilters, { trackerMsg: 'Loading 13f XML Report' })
            .then(function (res) {
                const element = document.createElement('a');
                element.href = URL.createObjectURL(new Blob([res.data], { type: "text/xml" }));
                element.download = res.headers('content-disposition');
                document.body.appendChild(element);
                element.click();
            });
    };

    //INITIALIZE
    $scope.today = Date.now();
    $scope.asOfDate = ($route.current.params.asOfDate) ?  Date.create($route.current.params.asOfDate).format('{MM}/{dd}/{yyyy}') : Date.create().toISOString();
    $scope.showAll = false;
    $scope.current = {
        asOfDate: $scope.asOfDate,
        filing: null,
        tableMarketValue:null,
        tableEntryTotal:null,
        aum: null,
        domestic: null,
        discretionary: null,
        wrapManaged: null,
        custodians: null,
        custodiansUnderTen: null,
        clientCategory: null,
        assetCategories: null,
        coverPageHelp: "To be Included in this calculation, the Product, Account, and Asset must be marked as 13f Reportable. Orion will screen appropriately marked products against the SEC's 13f Securities List.",
        filingHelp: "Returned securities exceed the SECs 13f minimum filing requirement of $200,000 or 10,000 shares.",

    };

    init();

});
'use strict';

app.controller('DiscloseAUADashboardCtrl', function DiscloseAUADashboardCtrl($scope, $http, $q, $dialog, $route, $timeout) {

    //PRIVATE VARIABLES
    let asOfDate = null;
    const complianceFilterName = "compliance_filters_" + $scope.user.id;

    //PRIVATE METHODS
    function init() {
        loadDashboard();
        //look up database level options
        $http.get("/Settings/Database/EntityOptions/Code/69AUAAUMACCRUEDINT", {trackerMsg: 'Check database entity option'})
            .then(function (response) {
                $scope.current.showAccruedInterestMessage = response.data.value === "True";
            });
        $http.get("/Compliance/Disclose/NeedEmployeeHouseholdsBanner")
            .then(function (response) {
                $scope.current.showEmployeeHouseholdsBanner = response.data;
            });
    }

    function loadDashboard(){

        asOfDate = Date.create($scope.current.asOfDate).format('{MM}-{dd}-{yyyy}');
        const sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));
        //Load all the Tiles
        $http.post('/Compliance/Disclose/aua/' + asOfDate, sessionFilters, {trackerMsg: 'Loading assets under management'})
            .then(function (response) {
                $scope.current.aua = response.data;
            });
        $http.post('/Compliance/Disclose/auaProducts/' + asOfDate, sessionFilters, {trackerMsg: 'Loading aua products'})
            .then(function (response) {
                $scope.current.detail = response.data;
            });
        $http.post('/Compliance/Disclose/auaCustodian/' + asOfDate, sessionFilters, {trackerMsg: 'Loading aua custodian'})
            .then(function (response) {
                $scope.current.custodians = response.data;
            });

    }

    //PUBLIC METHODS
    $scope.refresh = function(){
        $timeout(function(){
            loadDashboard();
        },0);
    };

    $scope.displayMessage = function () {
        $dialog.messageBox("Why this tool is important?", "Assets under administration (AUA) is a measure of the total assets for which a financial institution " +
            "provides administrative services. Assets under administration are beneficially owned and managed by clients who contract with a third-party administration provider. ").open();
    };

    $scope.getDetails = function(type){
        const asOfDate = Date.create($scope.current.asOfDate).format('{MM}-{dd}-{yyyy}');
        const url = "#/tools/compass/disclose/" + type + "?asOfDate=" + asOfDate;
        window.location.replace( url );
    };

    //INITIALIZE
    $scope.today = Date.now();
    $scope.asOfDate = ($route.current.params.asOfDate) ?  Date.create($route.current.params.asOfDate).format('{MM}/{dd}/{yyyy}') : Date.create().toISOString();
    $scope.showAll = false;
    $scope.current = {
        asOfDate: $scope.asOfDate,
        filing: null,
        aum: null,
        domestic: null,
        discretionary: null,
        wrapManaged: null,
        custodians: null,
        custodiansUnderTen: null,
        clientCategory: null,
        assetCategories: null,
        auaHelp: "The values included (positive & negative) are for any account with the AUA box checked. The values are NOT included in 13f or ADV totals.",
        auaCountHelp: "The values included (positive & negative) are for any account with the AUA box checked. The values are NOT included in 13f or ADV totals.",
        productHelp: "The values included are for any product and asset associated with an account that has the AUA box checked. These values are NOT included in the 13f or ADV totals.",
        auaCustodianHelp:  "The values included are for Custodians associated with accounts that have AUA Reportable enabled.",
        accruedInterestHelp: "If you have Accrued Interest as a database entity options for Disclose, all historical dates will include Accrued Interest.  Today's date will not include Accrued Interest."
    };

    init();

});
'use strict';

const discloseAumDetailCtrl = app.controller("DiscloseAumDetailCtrl", function DiscloseAumDetailCtrl($scope, $http, $oasRights, $dialog, $routeParams, $portfolio, $location, config, $route, entities, apps, $timeout, tokenFactory, $rootScope) {

    //PRIVATE VARIABLES
    let selectedRows;
    const redirectUrl = window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html?p=";
    const complianceFilterName = "compliance_filters_" + $rootScope.user.id;
    let custodies;
    let assetCategories;
    let clientCategories;


    //PRIVATE METHODS
    function init() {
        const useBccFilters = $location.search().bccFilters === 'true';
        const asOfDate = Date.create($route.current.params.asOfDate).format('{MM}/{dd}/{yyyy}');
        const type = $route.current.params.type;
        let detailName = "";
        let dashboardType = "adv";

        switch (type) {
            case "ADVAum":
                detailName = "Assets Under Management ";
                break;
            case "Filing13F":
                detailName = "13f Filing Requirement ";
                dashboardType = "13f";
                $scope.breadCrumbName = "13F Dashboard";
                break;
            case "Domestic":
                $scope.showComplianceFilter = true;
                detailName = "Domestic/Foreign AUM ";
                break;
            case "Discretionary":
                detailName = "Discretionary AUM ";
                break;
            case "WrapManaged":
                detailName = "Wrap Managed AUM ";
                $scope.current.showWrapManaged = $scope.rightsAcc.canUpdate;
                break;
            case "ByCustodian":
                detailName = "AUM by Custodian ";
                break;
            case "ByAssetCategory":
                $scope.showComplianceFilter = true;
                detailName = "AUM by Asset Category ";
                $scope.current.showAssetCategory = $scope.rightsProd.canUpdate;
                $scope.rightsAcc.canUpdate = false;
                $scope.rightsComplianceAdminOnly = $oasRights.forCode("COMPLIANCEADMINONLY");
                break;
            case "ByClientCategory":
                detailName = "AUM by Client Category ";
                $scope.current.showClientCategory = $scope.rightsHH.canUpdate;
                break;
            case "FormReport13F":
                detailName = "13f Report Form Detail ";
                dashboardType = "13f";
                $scope.breadCrumbName = "13F Dashboard";
                break;
            case "auaAum":
                detailName = "Assets Under Advisement";
                dashboardType = "aua";
                $scope.breadCrumbName = "AUA Dashboard";
                break;
            case "auaProducts":
                detailName = "AUA Products";
                dashboardType = "aua";
                $scope.breadCrumbName = "AUA Dashboard";
                $scope.rightsAcc.canUpdate = false;
                break;
            case "AdvSloa":
                detailName = "SLOA";
                break;
            case "AdvCustody":
                detailName = "Custody";
                break;
            case "auaCustodian":
                detailName = "AUA Custodians";
                dashboardType = "aua";
                $scope.breadCrumbName = "AUA Dashboard";
                break;

        }
        $scope.current.name = detailName + " as of " + asOfDate;
        $scope.breadCrumb = "#/tools/compass/disclose/" + dashboardType + '?asOfDate=';

        if (!["Domestic", "ByAssetCategory", "auaProducts", "FormReport13F"].find(type)) {
            const sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));

            if(useBccFilters) {
              $scope.current.view.filters = [];
            }

            sessionFilters.forEach(function (item) {
                if (item.label === "Database") {
                    return;
                }
                if (item.selected.length > 0) {
                    //convert filters to slick grid filters
                    const filterKey = item.label === 'RIA' ? 'ria' : item.label.substring(0, 1).toLowerCase() + item.label.substring(1);
                    const filterName = item.label + ' = ' + item.selected.flatten();
                    const filterExclude = item.exclude === true;
                    const filter = "(function(a) {return a ?  " + angular.toJson(item.selected) + ".find(function(b) { return a " + (filterExclude ? "!==" : "===") + " b }) : false;})";

                    $scope.current.view.filters.push({
                        name: filterName,
                        value: filter,
                        key: filterKey,
                        include: true
                    });
                }
            });
        }
    }

    function massUpdate(type, value, ids, alClientId, field) {
        const results = {
            alClientId: alClientId,
            ids: ids,
            field: field,
            value: value,
            asOfDate: $scope.asOfDate,
        };
        tokenFactory.getDatabaseToken(alClientId)
            .then(function (token) {
                $http.put('/Compliance/Disclose/Detail/' + type, results, {headers: {Authorization: "Session " + token}, trackerMsg: 'Updated records'})
                    .then(function (response) {
                        const updatedIds = response.data;

                        switch (type) {
                            case "Discretionary":
                                selectedRows.forEach(function (row) {
                                    if (updatedIds.any(row["account ID"])) {
                                        row["discretionary"] = (value) ? "Discretionary" : "Non-Discretionary";
                                        $scope.$broadcast('event:aum-detail-grid', {action: 'update-item', item: row});
                                    }
                                });
                                break;
                            case "WrapManaged":
                                const wrapText = (value === 0) ? " " : $scope.wrapOptions.filter({id: value.toNumber()});
                                selectedRows.forEach(function (row) {
                                    if (updatedIds.any(row["account ID"])) {
                                        row["wrap"] = wrapText[0].name;
                                        $scope.$broadcast('event:aum-detail-grid', {action: 'update-item', item: row});
                                    }
                                });
                                break;
                            case "Domestic":
                                $scope.current.compassFilters = JSON.parse(localStorage.getItem(complianceFilterName));
                                selectedRows.forEach(function (row) {
                                    if (updatedIds.any(row["household ID"])) {
                                        row["status"] = (value) ? "Domestic" : "Foreign";
                                        $scope.$broadcast('event:aum-detail-grid', {action: 'update-item', item: row});
                                    }
                                });
                                break;
                            case "ByClientCategory":
                                const selectedAdvCategory = clientCategories.filter({id: value.toNumber()});
                                selectedRows.forEach(function (row) {
                                    if (updatedIds.any(row["household ID"])) {
                                        row["adv Category"] = selectedAdvCategory[0].name;
                                        $scope.$broadcast('event:aum-detail-grid', {action: 'update-item', item: row});
                                    }
                                });
                                break;
                            case "ByAssetCategory":
                                $scope.current.compassFilters = JSON.parse(localStorage.getItem(complianceFilterName));
                                const selectedAssetCategory = assetCategories.filter({id: value.toNumber()});
                                selectedRows.forEach(function (row) {
                                    if (updatedIds.any(row["product ID"])) {
                                        row["adv Category"] = selectedAssetCategory[0].name;
                                        $scope.$broadcast('event:aum-detail-grid', {action: 'update-item', item: row});
                                    }
                                });
                                break;
                            case "AdvCustody":
                                selectedRows.forEach(function (row) {
                                    if (updatedIds.any(row["account ID"])) {
                                        row["custody Type Name"] = custodies.find({id: value.toNumber()}).name;
                                        $scope.$broadcast('event:aum-detail-grid', {action: 'update-item', item: row});
                                    }
                                });
                                break;
                            case "AdvSloa":
                                selectedRows.forEach(function (row) {
                                    if (updatedIds.any(row["sloa ID"])) {
                                        row["sloa Active"] = (value);
                                        $scope.$broadcast('event:aum-detail-grid', {action: 'update-item', item: row});
                                    }
                                });
                                break;
                            default:
                        }
                    });
            });
    }

    function getPortfolioRoute(entityEnum, entityId) {
        const entity = entities[entityEnum];
        return $portfolio.getGoToRoute(entity.urlFrag, entity.value, entityId);
    }

    function getProductRoute(id) {
        return '/products/local/' + id;
    }

    function MassUpdateAdvCategoriesInputBox(type, options, field) {
        $dialog.inputBox("Client ADV Category", "Select ADV Category", options)
            .open()
            .then(function (response) {
                if (response) {
                    const resultString = response.id.toString();
                    $scope.massUpdateValues(type, resultString, field);
                }
            });
    }

    function MassUpdateCustodiesInputBox(type, options, field) {
        $dialog.inputBox("Adv Custody Types", "Custody Types", options, {inputValue: options[0]})
            .open()
            .then(function (result) {
                if (result) {
                    const resultString = result.id.toString();
                    $scope.massUpdateValues(type, resultString, field);
                }
            });
    }

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:aum-detail-grid', {action: 'export-data'});
    };

    $scope.$on('event:aum-detail-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        const propertyMap = {
            alClientId: ["databaseid"],
            clientId: ["pkclient", "fkclient", "householdid", "hhid", "clientid", "clientnumber"],
            registrationId: ["regid", "pkreg", "fkreg"],
            accountId: ["acctid", "pkaccount", "fkaccount", "accountid"],
            isSloaActive: ["issloaactive", "sloaactive", "sloa active"],
            domestic: ["status"],
            discretionary: ["discretionary"],
            wrapManaged: ["wrapmanaged"],
            wrapSponsored: ["wrapmanaged"],
            productId: ["productid"],
            accountSloaId: ["sloa id", "sloaid", "pkAccountSloa", "fkAccountSloa"]

        };

        Object.each(args[0], function (key, value) {
            const searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });

        $scope.current.viewHousehold = false;
        $scope.current.viewRegistration = false;
        $scope.current.viewAccount = false;
        $scope.current.viewProduct = false;

        if (args.length === 1 && $scope.current.alClientId) {
            tokenFactory.getDatabaseToken($scope.current.alClientId)
                .then(function (token) {
                    if ($scope.current.clientId && $scope.rightsHH.canRead) {
                        $scope.current.viewHousehold = true;
                        const encodedValue = encodeURIComponent(getPortfolioRoute("client", $scope.current.clientId));
                        $scope.current.hhUrl = redirectUrl + encodedValue + "&t=" + token;
                    }
                    if ($scope.current.registrationId && $scope.rightsReg.canRead) {
                        $scope.current.viewRegistration = true;
                        const encodedValue = encodeURIComponent(getPortfolioRoute("registration", $scope.current.registrationId));
                        $scope.current.regUrl = redirectUrl + encodedValue + "&t=" + token;
                    }
                    if ($scope.current.accountId && $scope.rightsAcc.canRead) {
                        $scope.current.viewAccount = true;
                        const encodedValue = encodeURIComponent(getPortfolioRoute("account", $scope.current.accountId));
                        $scope.current.acctUrl = redirectUrl + encodedValue + "&t=" + token;
                    }
                    if ($scope.current.productId && $scope.rightsProd.canRead) {
                        $scope.current.viewProduct = true;
                        const encodedValue = encodeURIComponent(getProductRoute($scope.current.productId));
                        $scope.current.prodUrl = redirectUrl + encodedValue + "&t=" + token;
                    }

                    SetRightClickContext(selectedRows);
                });
        } else {
            SetRightClickContext(selectedRows);
        }
    });

    function SetRightClickContext(selectedRows) {
        const type = $route.current.params.type;

        switch (type) {
            case "AdvSloa":
                if ($scope.rightsAcc.canUpdate) {
                    const sloaActiveCount = selectedRows.count({"sloa Active": true});
                    const allRowsAreSloaActive = selectedRows.length === sloaActiveCount;
                    const allRowsAreSloaInActive = sloaActiveCount === 0;
                    $scope.current.showSloaActive = !allRowsAreSloaActive;
                    $scope.current.showSloaInActive = !allRowsAreSloaInActive;
                } else {
                    $scope.current.showSloaActive = false;
                    $scope.current.showSloaInActive = false;
                }
                break;
            case "Domestic":
                if ($scope.rightsHH.canUpdate) {
                    const foreignCount = selectedRows.count({"status": "Foreign"});
                    const allRowsForeign = selectedRows.length === foreignCount;
                    const allRowsDomestic = foreignCount === 0;
                    $scope.current.showDomestic = !allRowsDomestic;
                    $scope.current.showForeign = !allRowsForeign;
                } else {
                    $scope.current.showDomestic = false;
                    $scope.current.showForeign = false;
                }
                break;
            case "Discretionary":
                if ($scope.rightsAcc.canUpdate) {
                    const discretionaryCount = selectedRows.count({"discretionary": "Discretionary"});
                    const allRowsDiscretionary = selectedRows.length === discretionaryCount;
                    const allRowsNonDiscretionary = discretionaryCount === 0;
                    $scope.current.showDiscretionary = !allRowsDiscretionary;
                    $scope.current.showNonDiscretionary = !allRowsNonDiscretionary;
                } else {
                    $scope.current.showDiscretionary = false;
                    $scope.current.showNonDiscretionary = false;
                }
                break;
            case "AdvCustody":
                $scope.current.showChangeCustody = $scope.rightsAcc.canUpdate;
                break;
        }

        const showBottom = $scope.current.showSloaActive || $scope.current.showSloaInActive
            || $scope.current.showDomestic || $scope.current.showForeign
            || $scope.current.showDiscretionary || $scope.current.showNonDiscretionary
            || $scope.current.showWrapManaged || $scope.current.showAssetCategory
            || $scope.current.showClientCategory || $scope.current.showChangeCustody;

        const showTop = $scope.current.viewHousehold || $scope.current.viewRegistration
            || $scope.current.viewAccount || $scope.current.viewProduct;

        $scope.current.showDivider = showTop && showBottom;
        $scope.current.showDropDown = showTop || showBottom;
    }

    $scope.massUpdateValues = function (type, value, field) {

        const dbGroups = selectedRows.groupBy("database ID");
        let ids = [];
        let filterColumn = "";
        switch (type) {
            case "ByAssetCategory":
                filterColumn = "product ID";
                break;
            case "ByClientCategory":
                filterColumn = "household ID";
                break;
            case "Domestic":
                filterColumn = "household ID";
                break;
            case "AdvSloa":
                filterColumn = "sloa ID";
                break;
            default:
                filterColumn = "account ID";
        }

        const title = (selectedRows.length === 1)
            ? "Confirm Changes"
            : "Confirm Multiple Database Change";
        const message = (selectedRows.length === 1)
            ? "All selected rows will be updated. Do you want to proceed with this change?"
            : "All selected rows will be updated across all selected databases. Do you want to proceed with the change?";

        $dialog.messageBox(title, message, [{result: true, label: 'Continue', focus: false, cssClass:'btn-primary'}, {result: false, label: 'Cancel', focus: true}])
            .open()
            .then(function (response) {
                if (!response) {
                    return;
                }
                Object.each(dbGroups, function (key, val) {
                    ids = val.map(filterColumn).unique();

                    if (ids === undefined || !ids) {
                        ids = val.map(filterColumn.toLowerCase()).unique();
                    }
                    massUpdate(type, value, ids, key, field);
                });
            });
    };

    $scope.massUpdateWrapStatus = function () {
        $dialog.inputBox("Wrap Managed or Sponsored", "Wrap Status", $scope.wrapOptions)
            .open()
            .then(function (response) {
                if (response) {
                    const resultString = response.id.toString();
                    $scope.massUpdateValues("WrapManaged", resultString, "WrapManaged");
                }
            })
    };

    $scope.refreshGrid = function () {
        const compassFilters = JSON.parse(localStorage.getItem(complianceFilterName));

        return $http.post("/Compliance/Disclose/" + $route.current.params.type + "/" + $scope.asOfDate + "/Detail", compassFilters, {trackerMsg: 'Loading details for ' + $route.current.params.type})
            .then(function (response) {
                config = response.data;
                $scope.current.url = "/Compliance/Disclose/" + $route.current.params.type + "/" + $scope.asOfDate + "/Detail/" + config.dataQueryCacheKey;
                $timeout(function () {
                    $scope.$broadcast('event:aum-detail-grid', {action: 'refresh-grid'});
                }, 0);
            });
    };

    $scope.massUpdateClientCategory = function () {
        if (!clientCategories) {
            $http.get("/Compliance/Disclose/AdvCategories/ClientCategories", {trackerMsg: 'Loading adv category list'})
                .then(function (response) {
                    clientCategories = response.data.map(function (category) {
                        return {id: category.id, name: category.description};
                    });
                    MassUpdateAdvCategoriesInputBox("ByClientCategory", clientCategories, "ClientCategory");
                })
        } else {
            MassUpdateAdvCategoriesInputBox("ByClientCategory", clientCategories, "ClientCategory");
        }

    };

    $scope.massUpdateAssetCategory = function () {
        if (!assetCategories) {
            $http.get("/Compliance/Disclose/AdvCategories/AssetCategories", {trackerMsg: 'Loading asset adv category list'})
                .then(function (response) {
                    assetCategories = response.data.map(function (category) {
                        return {id: category.id, name: category.description};
                    });
                    MassUpdateAdvCategoriesInputBox("ByAssetCategory", assetCategories, "AssetCategory");
                })
        } else {
            MassUpdateAdvCategoriesInputBox("ByAssetCategory", assetCategories, "AssetCategory");
        }
    };

    $scope.massUpdateCustody = function () {
        if (!custodies) {
            $http.get("/Compliance/Disclose/AdvCustodyTypes", {trackerMsg: 'Loading adv custody types'})
                .then(function (response) {
                    custodies = response.data;
                    MassUpdateCustodiesInputBox("AdvCustody", custodies, "Custody");
                })
        } else {
            MassUpdateCustodiesInputBox("AdvCustody", custodies, "Custody");
        }
    };

    $scope.resetAdvAssetCategories = function () {
        //need to make sure they know its current database only in msg. Tell them which database they're currently about to change.
        $dialog.messageBox("Reset Adv Asset Categories", "Are you sure you want to rest all the products'?",
            [{result: true, label: 'Continue', focus: false, cssClass:'btn-primary'}, {result: false, label: 'Cancel', focus: true}])
            .open()
            .then(function (response) {
                if (!response) {
                    return;
                }

                $http.put("/Compliance/Disclose/AdvCategories/ResetAdvAssetCategories", null, {trackerMsg: 'Loading details for ' + $route.current.params.type})
                    .then(function (response) {
                        $scope.refreshGrid();
                    });
            });
    };


    //INITIALIZE

    $scope.rightsHH = $oasRights.forCode("CLIENTS");
    $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
    $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
    $scope.rightsProd = $oasRights.forCode("PRODUCTS");
    $scope.rightsCompassAudit = $oasRights.forCode("COMPASSAUDIT");
    $scope.rightsComplianceAdminOnly = {
        canUpdate: false,
    };

    $scope.breadCrumbName = "ADV Dashboard";
    $scope.wrapOptions = [{id: 1, name: "Wrap Managed Only"},
        {id: 2, name: "Wrap Sponsored Only"},
        {id: 3, name: "Both Wrap Managed and Sponsored"},
        {id: 0, name: "Not Wrap Managed or Sponsored"}];
    $scope.views = [config];
    $scope.selectedIds = [];
    $scope.asOfDate = Date.create($route.current.params.asOfDate).format('{MM}-{dd}-{yyyy}');
    $scope.current = {
        auditTestResultId: $routeParams.id,
        url: "/Compliance/Disclose/" + $route.current.params.type + "/" + $scope.asOfDate + "/Detail/" + config.dataQueryCacheKey,
        view: $scope.views[0],
        dataQueryCacheKey: null,
        dataQueryId: 0,
        dataQueryTitle: '',
        dataQueryEntity: null,
        returnData: null,
        filename: null,
        method: 'PUT',
        name: $routeParams.name
    };

    init();
});

discloseAumDetailCtrl.loadDiscloseAumDetailConfig = ["$http", "$route", "$rootScope", "$location", function ($http, $route, $rootScope, $location) {
    const complianceFilterName = "compliance_filters_" + $rootScope.user.id;
    const asOfDate = Date.create($route.current.params.asOfDate).format('{MM}-{dd}-{yyyy}');
    const isSecondary = $route.current.params.isSecondary && $route.current.params.isSecondary.toLowerCase() === 'true';

    if ($location.search().bccFilters === 'true') { // Filters can be set from Compliance App, load them if true
      return $http.get('/Settings/UserOptions/adv_filters')
        .then(response => {
          const bccFiltersString = JSON.parse(response.data.value).value;
          const bccFilters = JSON.parse(bccFiltersString);
          localStorage.setItem(complianceFilterName, bccFiltersString);

            return $http.post("/Compliance/Disclose/" + $route.current.params.type + "/" + asOfDate + "/Detail" + (isSecondary ? "?isSecondary=true" : ""), bccFilters, { trackerMsg: 'Loading details for ' + $route.current.params.type })
            .then(response => response.data);
        });
    } else {
        const compassFilters = JSON.parse(localStorage.getItem(complianceFilterName));
        return $http.post("/Compliance/Disclose/" + $route.current.params.type + "/" + asOfDate + "/Detail" + (isSecondary ? "?isSecondary=true" : ""), compassFilters, { trackerMsg: 'Loading details for ' + $route.current.params.type })
            .then(function (response) {
                return response.data;
            });
    }
}];

'use strict';

app.controller('TestTemplateCtrl', function TestTemplateCtrl($scope, $http, $oasRights, $dialog, $rootScope) {

    //PRIVATE constIABLES
    let sessionFilters = [];
    const complianceFilterName = "compliance_filters_" + $rootScope.user.id;

    // PRIVATE METHODS
    function init() {
        sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));
        $scope.showClientColumn = sessionFilters ? sessionFilters.find({label: 'Database'})?.selected.length > 0 : false;

        switch ($scope.userEntity) {
            case "Broker/Dealer":
                $scope.entityTypes = [{id: 2, name: "Broker/Dealer"}];
                $scope.current.selectedEntityType = $scope.userEntity;
                break;
            case "Representative":
                $scope.entityTypes = [{id: 4, name: "Representative"}];
                $scope.current.selectedEntityType = $scope.userEntity;
                break;
            default:
                $scope.entityTypes = [{id: null, name: "All Entity Types"}, {id: 17, name: "Advisor"}, {
                    id: 2,
                    name: "Broker/Dealer"
                }, {id: 4, name: "Representative"}];
        }

        $scope.current.selectedEntityType = $scope.entityTypes[0];

        getCategories();
        getTemplatelist(null, null);
    }

    // PUBLIC METHODS
    $scope.deleteTemplate = function (obj) {
        $http.delete('/Compliance/AuditTests/Template/' + obj.id, {trackerMsg: 'Loading template categories'})
            .then(function (response) {
                $scope.testTemplates.remove(obj);
                $scope.templateCategories = $scope.testTemplates.map("categoryDescription").unique();
            });
    };

    $scope.refresh = function () {
        sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));
        $scope.showClientColumn = sessionFilters.find({label: 'Database'}).selected.length > 0;
        const entity = $scope.current.selectedEntityType.id;
        const categoryId = $scope.current.selectedCategory.id;
        getTemplatelist(entity, categoryId);
    };

    $scope.templateDialog = function (templateObject) {
        $dialog.dialog({
            templateUrl: "tools/compass/modal/template-wizard.html",
            controller: "TemplateWizardCtrl",
            templateObject: templateObject,
            dialogClass: 'modal wide',
            entityOptions: $scope.entityTypes,
            categories: $scope.categories
        })
            .open()
            .then(function (response) {
                if (response) {
                    if (!$scope.templateCategories.find(response.categoryDescription)) {
                        $scope.categories.insert({
                            id: response.category.id,
                            description: response.category.description
                        });
                        $scope.templateCategories.add(response.categoryDescription, 0);
                    }
                    $scope.testTemplates.remove(templateObject);
                    $scope.testTemplates.push(response);
                }
                $scope.refresh();
            });
    };

    $scope.manageCategories = function () {
        $dialog.dialog({templateUrl: "tools/compass/modal/test-category.html", controller: "TestCategoryCtrl", dialogClass:"modal wide"})
            .open()
            .then(function () {
                getCategories();
                getTemplatelist(null, null);
            });
    };

    function getTemplatelist(entity, categoryId) {
        $http.post('/Compliance/AuditTests/Templates/List?entity=' + entity + '&categoryId=' + categoryId, sessionFilters, {trackerMsg: 'Loading query template list'})
            .then(function (response) {
                $scope.testTemplates = response.data;
                $scope.templateCategories = $scope.testTemplates.map("categoryDescription").unique();
            });
    }

    function getCategories() {
        $http.get('/Compliance/AuditTests/Categories', {trackerMsg: 'Loading template categories'})
            .then(function (response) {
                $scope.categories = response.data;
                $scope.categories.insert({id: null, description: "All Categories"}, 0);
                $scope.current.selectedCategory = $scope.categories[0];
            });
    }

    $scope.exportToExcel = function () {

        const dataDetails = {
            columns: [
                {name: "Category", field: "categoryDescription"},
                {name: "Description", field: "description"},
                {name: "Data Query Id", field: "customReportId"},
                {name: "Data Query", field: "customReportTitle"},
                {name: "Comment", field: "comment"},
                {name: "Entity Type", field: "entity"},
            ],
            data: $scope.testTemplates
        };

        $http.post('/Utility/SlickGridExport/csv', dataDetails, {trackerMsg: 'Exporting grid'})
            .then(function (response) {
                window.location.href = response.headers("location") + "?Authorization=" + sessionStorage.oas_token;
            });

    };

    // INITIALIZE
    $scope.userEntity = $rootScope.user.authorization.entity;
    $scope.categories = [];
    $scope.testTemplates = [];
    $scope.current = {selectedCategory: null, selectedEntityType: null, showFilter: false};
    $scope.editGlobal = $scope.entityType === "Administrator";
    $scope.rightsCompassAudit = $oasRights.forCode("COMPASSAUDIT");
    init();

});

'use strict';

app.controller('BasisCodeDashboardCtrl', function BasisCodeDashboardCtrl() {

});
'use strict';

 app.controller('RiskDashboardCtrl', function RiskDashboardCtrl() {

});
'use strict';

app.controller('RiskTileDetailsCtrl', function RiskTileDetailsCtrl($scope, $routeParams) {
    $scope.bdid = $routeParams.brokerDealerId;
    $scope.riaid = $routeParams.riaId;
    $scope.type = $routeParams.type;
});
'use strict';

app.controller('NonRegisteredStateDetailsCtrl', function NonRegisteredStateDetailsCtrl() {
});
'use strict';

app.controller('AdminDashboardCtrl', function AdminDashboardCtrl($scope, $http, $q, $dialog, $oasRights, $rootScope) {

    //PRIVATE METHODS
    function init() {
        const compassPath = '#/tools/compass/inform/';

        if ($scope.rightsComplianceInform.canRead) {
            const approvalItemCategories = [
                {endpoint: 'Preclearances', options: {path: compassPath + 'preclearance', badgeClass: 'badge-danger'}},
                {
                    endpoint: 'AccessPersons', options: {}, pathMaker: function (i) {
                        return (compassPath + 'accesspersonlist/' + i.templateType)
                    }
                },
                {
                    endpoint: 'BrokerageAccounts',
                    options: {
                        path: compassPath + 'brokerageaccounts',
                        templateName: 'Brokerage Accounts',
                        badgeClass: 'badge-info'
                    }
                },
                {
                    endpoint: 'Documents', options: {}, pathMaker: function (i) {
                        return (i.templateType === 'Task' || i.templateType === 'Task With Multiple' ? compassPath + 'task' + '/' + i.templateId : compassPath + 'questionnaire' + '/' + i.templateId);
                    }
                },
                {
                    endpoint: 'Connections/V2/Broken',
                    options: {path: compassPath + 'brokenconnections', templateName: 'Authentication/Connection Issues'}
                },
                {
                    endpoint: 'BrokerageAccounts/StaleHoldings',
                    options: {
                        path: compassPath + 'staleholdings',
                        templateName: 'Stale Holdings'
                    }
                }
            ];

            const promises = approvalItemCategories.map(function (category) {
                return $http.get('/Compliance/Inform/' + category.endpoint + '/Alert', {trackerMsg: 'Loading ' + category.endpoint.titleize() + ' alerts'});
            });

            $q.all(promises).then(function (responses) {
                $scope.approvalItems = [];
                $scope.accessPersonItems = [];

                responses.forEach(function (response, index) {
                    const data = angular.isArray(response.data) ? response.data : [response.data];

                    data.forEach(function (item) {
                        if (item.count > 0) {
                            const category = approvalItemCategories[index];
                            if (category.pathMaker) {
                                item.path = category.pathMaker(item);
                            }
                            if (["Access Person New", "Access Person Inactive"].find(item.templateType)) {
                                $scope.accessPersonItems.push(angular.extend(item, category.options));
                            } else {
                                $scope.approvalItems.push(angular.extend(item, category.options));
                            }

                        }
                    });
                });
            });

            $http.get('/Compliance/Inform/TradeViolation/Alert', {trackerMsg: 'Loading trade violation alerts'})
                .then(function (response) {
                    $scope.tradeViolations = response.data;
                    $scope.totalTradeViolations = $scope.tradeViolations.countFrontRunning + $scope.tradeViolations.countSecuritiesViolations + $scope.tradeViolations.countPreClearance + $scope.tradeViolations.count30RoundTrip;
                });
        }
    }


    //PUBLIC METHODS
    $scope.displayMessage = function () {
        const content = 'Orion’s Inform Tool is available to assist you with Code of Ethics compliance monitoring, employee trade monitoring, as well as maintaining affirmations, certifications, and disclosures. ' +
            'You can keep your employee’s information, actions, and disclosures current and easily accessible, as well as create, distribute, and track annual questionnaires and attestations.';

        $dialog.messageBox('Why this tool is important', content).open();
    };

    $scope.manageFirmCredential = function(){

    };

    //INITIALIZE
    $scope.rightsComplianceInform = $oasRights.forCode("COMPASSINFORM");
    $scope.rightsInformConcur = $oasRights.forCode("INFORMCONCUR")
    $scope.isAdmin = $rootScope.user.authorization.entity === "Administrator";
    $scope.concurBadgeClass = 'badge-danger'

    init();
});
'use strict';

app.controller('AdminPoliciesCtrl', function AdminPoliciesCtrl($scope, $http, $oasRights, views, $dialog, API_CONFIG, $settings, activeState, $timeout ) {

    //PRIVATE VARIABLES
    let selectedRows;

    //PRIVATE METHODS
    function policyDialog(policy) {
        $dialog.dialog({
            templateUrl: "tools/compass/inform/modal/policy-dialog.html",
            controller: "PolicyDialogCtrl",
            informPolicy: policy,
            dialogClass: 'modal'
        })
        .open()
        .then(function (response) {
            if(response){
                $scope.$broadcast('event:inform-policies-reload', {action: 'upsert-items', items: [response]});
            }
        });

    }

    //PUBLIC METHODS
    $scope.addPolicy = function () {
        policyDialog(null);
    };

    $scope.policyDialog = function () {
        policyDialog( angular.copy(selectedRows[0]));
    };
    $scope.slickGridDoubleClick = function () {
        if (selectedRows.length === 1) {
            policyDialog(angular.copy(selectedRows[0]));
        }
    };

    $scope.downloadPolicy = function () {
        if (selectedRows.length === 1){
            window.location.href = API_CONFIG.baseUrl + '/Compliance/Inform/Policy/Download/Policy/' + selectedRows[0].id + '?Authorization=' + sessionStorage.oas_token;
        }
    };

    $scope.refreshGrid = () => {
        $settings.setSetting('activeState', $scope.current.activeState);
        $timeout(() => {
            $scope.$broadcast('event:inform-policies-reload', {action: 'refresh-grid'});
        });
    }

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:inform-policies-reload', {action: 'export-data'});
    };

    $scope.toggleActiveStatus = function(){
        if(selectedRows.length !== 1) return;
        let thisPolicy = angular.copy(selectedRows[0]);
        const policyId = thisPolicy.id;
        const activeStatus = !thisPolicy.isActive;
        const visibleStatus = activeStatus ? thisPolicy.isVisible : false;
        $http.put('/Compliance/Inform/Policy/' + policyId + '?isActive=' + activeStatus + '&isVisible=' + visibleStatus, {cache: false, trackerMsg: 'Updating active status'})
            .then(function (response) {
                Object.merge(thisPolicy, response.data);
                $scope.$broadcast('event:inform-policies-reload', {action: 'upsert-items', items: [thisPolicy]});
            });
    };

    $scope.toggleVisibility = () => {
        if (selectedRows.length !== 1 || !selectedRows[0].isActive) {
            return;
        }

        let thisPolicy = angular.copy(selectedRows[0]);
        const policyId = thisPolicy.id;
        const activeStatus = thisPolicy.isActive;
        const visibleStatus = !thisPolicy.isVisible;

        $http.put('/Compliance/Inform/Policy/' + policyId + '?isActive=' + activeStatus + '&isVisible=' + visibleStatus, { cache: false, trackerMsg: 'Updating visible status' })
            .then(function (response) {
                Object.merge(thisPolicy, response.data);
                $scope.$broadcast('event:inform-policies-reload', { action: 'upsert-items', items: [thisPolicy] });
            });

    }

    $scope.deleteItem = () => {
        if(selectedRows.length !== 1 || selectedRows[0].documents.length !== 0) {
            return;
        }
        let thisPolicy = angular.copy(selectedRows[0]);
        const trackerMsg = !thisPolicy.libraryType ? 'Deleting item' :  'Deleting ' + thisPolicy.libraryType;
        const heading = !thisPolicy.libraryType ? 'Delete Item' : 'Delete ' + thisPolicy.libraryType;
        const message = 'Are you sure you want to delete ' + thisPolicy.policyName + '?';
        
        $dialog.messageBox(heading, message, [{ result: true, label: 'Delete', focus: true }, { result: false, label: 'Cancel', focus: true }])
            .open()
            .then(res => {
                if(res) {
                    const policyId = thisPolicy.id;
                    $http.delete('/Compliance/Inform/Policy/' + policyId, { trackerMsg: trackerMsg })
                        .then(res => {
                            if(res) {
                                $scope.refreshGrid();
                            }
                        });
                }
            });
    }

    $scope.$on('event:inform-policies-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        const propertyMap = {
            id: ["id"],
            active: ["isactive"],
            visible: ["isvisible"],
            documents: ["documents"],
            type: ["librarytype"]
        };

        Object.each(args[0], function (key, value) {
            let searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
    });

    //INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.editMode = $scope.rightsCompassInform.canUpdate;
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: "/Compliance/Inform/Policy",
        view: views[0],
        editMode: false,
        gridQueries: [],
        activeStates: activeState
    };
    $scope.current.activeState = $settings.getSetting('activeState');
});


'use strict';

app.controller('AdminAffirmationsCtrl', function AdminAffirmationsCtrl($scope, $http, $oasRights, views, $dialog, activeState, $settings, $timeout) {

    //PRIVATE VARIABLES
    let selectedRows;

    //PRIVATE METHODS

    function affirmationDialog(affirmation) {
        $dialog.dialog({templateUrl: "tools/compass/inform/modal/affirmation-dialog.html",controller: "AffirmationDialogCtrl",affirmation: affirmation, dialogClass: 'modal'})
            .open()
            .then(function (response) {
                if(response){
                    $scope.$broadcast('event:inform-affirmations-reload', {action: 'upsert-items', items: [response]});
                }
            });

    }

    $scope.slickGridDoubleClick = function () {
        if (selectedRows.length === 1)
            var thisAffirmation = angular.copy(selectedRows[0]);
            affirmationDialog(thisAffirmation)
    };

    $scope.affirmationDialog = function(){
        const thisAffirmation = angular.copy(selectedRows[0]);
        affirmationDialog(thisAffirmation)
    };

    $scope.addAffirmation = function(){
        affirmationDialog(null)
    };

    $scope.toggleActiveStatus = function(){
        if(selectedRows.length !== 1) return;
        const thisAffirmation = angular.copy(selectedRows[0]);
        const affirmationId = thisAffirmation.id;
        const show = !thisAffirmation.isActive;
        $http.put('/Compliance/Inform/Affirmations/' + affirmationId + '/' + show, {cache: false, trackerMsg: 'Updating active status'})
            .then(function (response) {
                Object.merge(thisAffirmation, response.data);
                $scope.$broadcast('event:inform-affirmations-reload', {action: 'upsert-items', items: [thisAffirmation]});
            });
    };

    $scope.refreshGrid = () => {
        $settings.setSetting('activeState', $scope.current.activeState);
        $timeout(() => {
            $scope.$broadcast('event:inform-affirmations-reload', {action: 'refresh-grid'});
        });
    }

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:inform-affirmations-reload', {action: 'export-data'});
    };

    $scope.deleteAffirmation = () => {
        const row = selectedRows[0];

        $http.delete('/Compliance/Inform/Affirmations/' + row.id, { trackerMsg: 'Deleting Affirmation' })
            .then(response => {
                if (!response.data) {
                    $dialog.messageBox("Delete Affirmation", "Cannot delete Affirmation. Affirmation is tied to a Questionnaire.")
                        .open();
                } else {
                    $scope.$broadcast('event:inform-affirmations-reload', { action: 'delete-item', item: selectedRows[0]});
                }
            });
    };

    $scope.$on('event:inform-affirmations-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        const propertyMap = {
            id: ["id"],
            active: ["isactive"]
        };

        Object.each(args[0], function (key, value) {
            const searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
    });

    //INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.editMode = $scope.rightsCompassInform.canUpdate;
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: "/Compliance/Inform/Affirmations",
        view: views[0],
        editMode: false,
        gridQueries: [],
        activeStates: activeState
    };
    $scope.current.activeState = $settings.getSetting('activeState');
});


'use strict';

app.controller('AdminAffirmationsDetailCtrl', function AdminAffirmationsDetailCtrl($scope, $http, $oasRights, views, $dialog, API_CONFIG,$location ) {

    //PRIVATE VARIABLES
    var selectedRows;

    //PRIVATE METHODS
    function init (){

        var path = $location.path();
        $scope.addBreadcrumb("Affirmations", path);
    }

    function openDocumentDialog() {
        $dialog.dialog({templateUrl: "tools/inform/modal/inform-questionnaire-dialog.html",controller: "InformQuestionnaireDialogCtrl", id: $scope.current.questionnaireid, templateId: null, dialogClass: 'modal wide'})
            .open()
            .then(function (response) {
            });
    }


    //PUBLIC METHODS

    $scope.slickGridDoubleClick = function () {
        if (selectedRows.length === 1)
            openDocumentDialog();

    };

    $scope.viewDocument = function(){
        openDocumentDialog();
    };

    $scope.viewAccessPersonDetail = function(){
        if(selectedRows.length === 1){
            var path = '/tools/compass/inform/accessPerson/'+  selectedRows[0].userId;
            $location.path(path);
        }
    };


    $scope.refreshGrid = function() {
        $scope.$broadcast('event:inform-affirmations-reload', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:inform-affirmations-reload', {action: 'export-data'});
    };

    $scope.$on('event:inform-affirmations-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        var propertyMap = {
            id: ["id"],
            questionnaireid: ["questionnaireid"]
        };

        Object.each(args[0], function (key, value) {
            var searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
    });

    //INITIALIZE
    var url = "/Compliance/Inform/Affirmation/Responses?affirmationResponse=";
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: url,
        view: views[0],
        editMode: false,
        gridQueries: []
    };
    init();

});


'use strict';

app.controller('AdminQuestionnairesCtrl', function AdminQuestionnairesCtrl($scope, $http, $oasRights, views, $dialog, API_CONFIG, $location) {

    //PRIVATE constIABLES
    let selectedRows;

    //PRIVATE METHODS
    function questionnaireDetails(thisQuestionnaire) {
        const path = '/tools/compass/inform/questionnaire/' + thisQuestionnaire.id;
        $location.path(path);
    }

    function questionnaireDialog(thisQuestionnaire, copyFromId) {
        $dialog.dialog({
            templateUrl: "tools/compass/inform/modal/admin-template-dialogV2.html",
            controller: "AdminTemplateDialogCtrlV2",
            thisTemplate: angular.copy(thisQuestionnaire),
            copyFromId: copyFromId,
            templateType: "Questionnaire",
            dialogClass: 'modal wide'
        })
            .open()
            .then(function (response) {
                if (response) {
                    if (thisQuestionnaire) {
                        Object.merge(thisQuestionnaire, response);
                    } else {
                        thisQuestionnaire = response;
                    }

                    $scope.$broadcast('event:inform-questionnaires-reload', {
                        action: 'upsert-items',
                        items: [thisQuestionnaire]
                    });
                }
            });
    }

    //PUBLIC METHODS
    $scope.addQuestionnaireDialog = function () {
        $http.get('/Compliance/Inform/Template/EmptyTemplate', {cache: true, trackerMsg: 'Loading empty template'})
            .then(function (response) {
                questionnaireDialog(response.data, null);
            });
    };

    $scope.questionnaireDialog = function () {
        questionnaireDialog(selectedRows[0], null);

    };

    $scope.questionnaireDetails = function () {
        questionnaireDetails(selectedRows[0]);
    };

    $scope.slickGridDoubleClick = function () {
        if (selectedRows.length === 1) {
            questionnaireDetails(selectedRows[0]);
        }

    };

    $scope.refreshGrid = function () {
        $scope.$broadcast('event:inform-questionnaires-reload', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:inform-questionnaires-reload', {action: 'export-data'});
    };

    $scope.cloneQuestionnaire = function () {
        $http.get('/Compliance/Inform/Template/EmptyTemplate', {cache: true, trackerMsg: 'Loading empty template'})
            .then(function (response) {
                questionnaireDialog(response.data, selectedRows[0].id);
            });
    };

    $scope.changeDueDate = function(){
        const thisId = selectedRows[0].id;

        $dialog.inputBox('Change Due Date for Pending Submissions', 'New Due Date', 'date')
            .open()
            .then(function (result) {
                if(result){
                    $http.put("/Compliance/Inform/Distribute/UpdateDueDate/" + thisId + "/" + Date.create(result).format('{MM}-{dd}-{yyyy}'), {trackerMsg: 'Changing due date'})
                        .then(function (response) {
                            if (response.data) {
                                $scope.$broadcast('event:inform-questionnaires-reload', {action: 'refresh-grid'});
                            }
                        });
                }
            });
    };

    $scope.deleteQuestionnaireTemplate = function () {

        const thisRow = selectedRows[0];
        const thisId = thisRow.id;

        $http.delete("/Compliance/Inform/Template/" + thisId, {trackerMsg: 'Delete questionnaire'})
            .then(function (response) {
                if (response.data) {
                    $scope.$broadcast('event:inform-questionnaires-reload', {
                        action: 'delete-item',
                        item: selectedRows[0]
                    });
                }
            });
    };

    $scope.$on('event:inform-questionnaires-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        const propertyMap = {
            id: ["id"],
            locked: ["islocked"],
            active: ["isactive"],
            created: ["created"],
            completed: ["completed"]
        };

        Object.each(args[0], function (key, value) {
            const searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
    });

    $scope.distributeQuestionnaire = function () {
        if (selectedRows.length === 1) {
            const thisQuestionnaire = selectedRows[0];
            const path = '/tools/compass/inform/distribute/' + thisQuestionnaire.id;
            $location.path(path);
        }
    };

    $scope.recallDistributedQuestionnaire = function(){
        $dialog.messageBox("Confirm recall of questionnaire", "Are you sure you want to recall this questionnaire?  This will recall the questionnaire from all Access Persons who received the questionnaire, including those who have responded already.  The information cannot be retrieved once it is recalled.",[{result: true, label: 'Yes', focus: true, cssClass:"btn-primary pull-right"}, {result: false, label: 'No', focus: false, cssClass:"pull-left"}])
            .open()
            .then((msgBoxAnswer)=> {
                if (msgBoxAnswer) {
                    $http.delete("/Compliance/Inform/Distribute/" + selectedRows[0].id, {trackerMsg: 'updating distributed questionnaires'})
                        .then(function (response) {
                            if (response.data) {
                                $scope.$broadcast('event:inform-questionnaires-reload', {action: 'refresh-grid'});
                            }
                        });
                }
            });
    };

    $scope.importQuestionnaire = function () {
        $dialog.dialog({
            dialogClass: "modal medium",
            templateUrl: "app/modals/upload-file.html",
            controller: "UploadFileCtrl",
            title: "Upload New Questionnaire",
            idField: "questionNumber",
            downloadUrl: '/Compliance/Inform/ValidateImport/Questionnaire/Templates/',
            validateUrl: '/Compliance/Inform/ValidateImport/Questionnaire',
            commitVerb: 'PUT',
            commitUrl: '/Compliance/Inform/ValidateImport/Questionnaire/Import',
            exportUrl: '/Compliance/Inform/ValidateImport/Questionnaire/ExportErrors',
            returnNewModel: true
        })
            .open()
            .then(function(template){
                questionnaireDialog(template.data);
            });
    };

    //INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.editMode = $scope.rightsCompassInform.canUpdate;
    $scope.canDelete = $scope.rightsCompassInform.canDelete;
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: "/Compliance/Inform/Templates/Questionnaire", //0 = task, 1 = questionnaires
        view: views[0],
        editMode: false,
        gridQueries: []
    };

});



'use strict';

let adminQuestionnaireDetailCtrl = app.controller('AdminQuestionnaireDetailCtrl', function AdminQuestionnaireDetailCtrl($scope, $http, $oasRights, $dialog, API_CONFIG,$location, $routeParams, $rootScope, config, informWorkflowStatus, adminDocumentsService ) {

    //PRIVATE VARIABLES
    let selectedRows;

    //PRIVATE METHODS
    function init(){
        $http.get('/Compliance/Inform/Template/' + $routeParams.templateId, {cache: false, trackerMsg: 'Checking questionnaire setup'})
            .then(function (response) {
                $scope.questionnaireName = response.data.templateName;
            });
    }

    function OpenQuestionnaire(thisQuestionnaire){

        if(currentUserDetailId === thisQuestionnaire.userDetailId){
            $dialog.messageBox("Access Denied", "You are not able to review your own submissions.").open();
        } else {
            $dialog.dialog({templateUrl: "tools/inform/modal/inform-questionnaire-dialog.html",controller: "InformQuestionnaireDialogCtrl", id: thisQuestionnaire.id, dialogClass: 'edit-pane'})
                .open()
                .then(function (response) {
                    if(response){
                        response.fullName = thisQuestionnaire.fullName;
                        Object.merge(thisQuestionnaire,response);
                        $scope.$broadcast('event:inform-questionnaires-reload', {action: 'update-item', item: thisQuestionnaire});
                    }

                });
        }
    }

    function massUpdateStatus(type){
        adminDocumentsService.massUpdateStatus(type,$scope.selectedIds,selectedRows,'event:inform-questionnaires-reload', $scope);
    }

    //PUBLIC METHODS

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:inform-questionnaires-reload', {action: 'export-data', format: 'xlsx'});
    };

    $scope.slickGridDoubleClick = function(){
        $scope.openQuestionnaireDialog();
    };

    $scope.refreshGrid = function() {
        $scope.$broadcast('event:inform-questionnaires-reload', {action: 'refresh-grid'});
    };

    $scope.openQuestionnaireDialog = function(){
        if(selectedRows.length === 1){
            OpenQuestionnaire(selectedRows[0]);
        }
    };

    $scope.downloadAllAttachments = function () {
        window.location.href = API_CONFIG.baseUrl + '/Compliance/Inform/Template/' + $routeParams.templateId + '/DownloadAllAttachments' + '?Authorization=' + sessionStorage.oas_token;
    };

    $scope.sendFollowUpEmail = function(){
        const toName = selectedRows.length === 1 ? selectedRows[0].fullName : null;
        $dialog.dialog({templateUrl: "tools/compass/inform/modal/email-dialog.html",controller: "EmailDialogCtrl", templateType: 1 /*Quesitonnaire*/, parentObject: selectedRows, email: null, emailToName: toName, dialogClass: 'modal wide'})
            .open()
            .then(function (response) {
                if(response){
                    $scope.$broadcast('event:inform-questionnaires-reload', {action: 'refresh-grid'});
                }

            });
    };


    $scope.massUpdateApprove = function(){
        massUpdateStatus(informWorkflowStatus.approved);
    };

    $scope.massUpdateDeny = function(){
        massUpdateStatus(informWorkflowStatus.denied);
    };

    $scope.viewAccessPersonDetail = function(){
        if(selectedRows.length === 1){
            const path = '/tools/compass/inform/accessPerson/'+  selectedRows[0].accessPersonId;
            $location.path(path);
        }
   };

    $scope.$on('event:questionnaire-detail-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        const propertyMap = {
            id: ["id"],
            fullName: ["fullName"],
            userDetailId: ["userDetailId"]
        };

        Object.each(args[0], function (key, value) {
            let searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });

        $scope.current.canMassUpdateApprove = false;
        $scope.current.canMassUpdateDeniedOrClose = false;
        if(selectedRows.length > 1) {
            let isAllApprove = selectedRows.every((val)=>{
                return val.status === 'Approved';
            });

            let isAllDenied = selectedRows.every((val)=>{
                return val.status === 'Denied';
            });

            let isNotApproveOrDenied = selectedRows.every((val)=>{
                return val.status !== 'Denied' && val.status !== 'Approved';
            });

            let hasMassUpdateRight = adminDocumentsService.canMassUpdate(selectedRows) && $oasRights.forCode("COMPLIANCEADMINONLY");

            $scope.current.canMassUpdateApprove = hasMassUpdateRight && isAllDenied || isNotApproveOrDenied;
            $scope.current.canMassUpdateDeniedOrClose = hasMassUpdateRight && isAllApprove || isNotApproveOrDenied;
        }
    });

    //INITIALIZE
    const currentUserDetailId = $rootScope.user.authorization.userDetailId;
    $scope.views = [config];
    $scope.selectedIds = [];
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.editMode = $scope.rightsCompassInform.canUpdate;
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: "/Compliance/Inform/Documents/" + $routeParams.templateId + "/" + config.dataQueryCacheKey,
        view: $scope.views[0],
        editMode: false,
        gridQueries: [],
        dataQueryCacheKey: null,
        dataQueryId: 0,
        dataQueryTitle: '',
        dataQueryEntity: null,
        returnData: null,
        filename: null,
        canMassUpdateApprove: false,
        canMassUpdateDeniedOrClose: false,
    };
    init();
});

adminQuestionnaireDetailCtrl.loadAdminQuestionnaireDetailCtrl = ["$http","$route", function ($http,$route) {
    return $http.get("/Compliance/Inform/Documents/" + $route.current.params.templateId, {trackerMsg: 'Loading submission details'})
        .then(function (response) {
            return response.data;
        });
}];
'use strict';

app.controller('AdminBrokerageAccountDetailCtrl', function AdminBrokerageAccountDetailCtrl($scope, $http, $oasRights, views, $dialog, API_CONFIG,$location, $rootScope, informWorkflowStatus ) {

    //PRIVATE VARIABLES
    let selectedRows;

    //PRIVATE METHODS
    function init(){
        $http.get('/Compliance/Inform/AccessPerson/CurrentUser')
            .then(function (response) {
                if(response.data){
                    $scope.currentAccessPerson = response.data;
                }
            });
    }

    function openBrokerageAccount(){
        let thisAccount = selectedRows[0];

        if(currentUserDetailId === thisAccount.userDetailId){
            $dialog.messageBox("Access Denied", "You are not able to review your own brokerage accounts.").open();
        } else {
            $dialog.dialog({templateUrl: "tools/inform/modal/inform-brokerage-account-dialog.html", controller: "InformBrokerageAccountDialogCtrl", brokerageAccount: angular.copy(thisAccount), dialogClass: 'modal wide'})
                .open()
                .then(function (response) {
                    if (response) {
                        selectedRows[0] = response;
                        $scope.$broadcast('event:brokerage-account-detail-reload', {action: 'refresh-grid'});
                    }

                });
        }
    }

    function massUpdateStatus(status){
        let idAndCommentArray = [];
        if(selectedRows.length >= 1) {
            if($scope.currentAccessPerson) {
                let hasTheirOwnAccounts = selectedRows.filter(item => {
                    if (item.accessPersonId === $scope.currentAccessPerson.id) {
                        return item;
                    }
                });

                if (hasTheirOwnAccounts.length > 0) {
                    $dialog.messageBox("Access Denied", "You cannot update your own accounts").open();
                    return;
                }
            }

            selectedRows.forEach(i => {
                idAndCommentArray.push({ accountId: i.id, comment: i.comment || null })
            })

            $http.put('/Compliance/Inform/BrokerageAccounts/Status/' + status.value, idAndCommentArray, {cache: false, trackerMsg: 'Mass updating status.'})
                .then(function (response) {
                    if(response.data){
                        $scope.$broadcast('event:brokerage-account-detail-reload', {action: 'refresh-grid'});
                    }
                });
        }
    }

    function canMassUpdate(selectedRows){
        let itemsNotOfStatus = selectedRows.every((val, index, arr)=>{
            return val.status === arr[0].status;
        });

        return itemsNotOfStatus;
    }

    //PUBLIC METHODS

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:brokerage-account-detail-reload', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function(){
        openBrokerageAccount();
    };

    $scope.openBrokerageAccount = function(){
        openBrokerageAccount();
    };

    $scope.sendFollowUpEmail = function(){
        const toName = selectedRows.length === 1 ? selectedRows[0].fullName : null;
        $dialog.dialog({templateUrl: "tools/compass/inform/modal/email-dialog.html", controller: "EmailDialogCtrl", templateType: 3 /*Brokerage Account*/, parentObject: selectedRows, email: null, emailToName: toName, dialogClass: 'modal wide'})
            .open()
            .then(function (response) {
                if(response){
                    $scope.$broadcast('event:brokerage-account-detail-reload', {action: 'refresh-grid'});
                }

            });
    };

    $scope.viewAccessPersonDetail = function(){
        if(selectedRows.length === 1){
            const path = '/tools/compass/inform/accessPerson/'+  selectedRows[0].accessPersonId;
            $location.path(path);
        }
    };

    $scope.refreshGrid = function() {
        $scope.$broadcast('event:db-grouping-mgr-action', {action: 'refresh-grid'});
    };

    $scope.downloadAllAttachments = function () {
        window.location.href = API_CONFIG.baseUrl + '/Compliance/Inform/BrokerageAccounts/DownloadAllAttachments?Authorization=' + sessionStorage.oas_token;
    };

    $scope.setAccountsForElectra = function () {
        $http.put('/Compliance/Inform/BrokerageAccounts/ElectraSetup', { trackerMsg: 'Set accounts for Electra.' });
    }

    $scope.$on('event:brokerage-account-detail-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        const propertyMap = {
            id: ["id"],
            accessPersonId: ["accesspersonid"],
            accountTitle: ["accounttitle"],
            fullName: ["fullName"]
        };

        Object.each(args[0], function (key, value) {
            let searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });

        $scope.current.canMassUpdateActive = false;
        $scope.current.canMassUpdateClosed = false;
        if(selectedRows.length > 1) {
            let isAllActive = selectedRows.every((val)=>{
                return val.status === 'Active';
            });

            let isAllClosed = selectedRows.every((val)=>{
                return val.status === 'Closed';
            });

            let isNotActiveOrClosed = selectedRows.every((val)=>{
                return val.status !== 'Closed' && val.status !== 'Active';
            });

            let hasMassUpdateRight = canMassUpdate(selectedRows) && $oasRights.forCode("COMPLIANCEADMINONLY");

            $scope.current.canMassUpdateActive = hasMassUpdateRight && isAllClosed || isNotActiveOrClosed;
            $scope.current.canMassUpdateClosed = hasMassUpdateRight && isAllActive || isNotActiveOrClosed;
        }
    });

    $scope.massUpdateApproved = function(){
        massUpdateStatus(informWorkflowStatus.active);
    };

    $scope.massUpdateClosed = function(){
        massUpdateStatus(informWorkflowStatus.closed);
    };

    //INITIALIZE
    const currentUserDetailId = $rootScope.user.authorization.userDetailId;
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.editMode = $scope.rightsCompassInform.canUpdate;
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: "/Compliance/Inform/BrokerageAccounts/V2?allAccounts=true",
        view: views[0],
        editMode: false,
        gridQueries: [],
        canMassUpdateActive: false,
        canMassUpdateClosed: false,
    };
    $scope.currentAccessPerson = null;
    $scope.CanSetElectra = $oasRights.forCode("COMPLIANCEADMINONLY");
    init();
});


'use strict';

app.controller('AdminStaleHoldingsCtrl', function AdminStaleHoldingsCtrl($scope, $http, $oasRights, views, $dialog, API_CONFIG,$location, $rootScope, informWorkflowStatus ) {

    //PRIVATE VARIABLES
    let selectedRows;

    //PRIVATE METHODS
    function init(){
        $http.get('/Compliance/Inform/AccessPerson/CurrentUser')
            .then(function (response) {
                if(response.data){
                    $scope.currentAccessPerson = response.data;
                }
            });
    }

    function openBrokerageAccount(){
        let thisAccount = selectedRows[0];

        if(currentUserDetailId === thisAccount.userDetailId){
            $dialog.messageBox("Access Denied", "You are not able to review your own brokerage accounts.").open();
        } else {
            $dialog.dialog({templateUrl: "tools/inform/modal/inform-brokerage-account-dialog.html", controller: "InformBrokerageAccountDialogCtrl", brokerageAccount: angular.copy(thisAccount), dialogClass: 'modal wide'})
                .open()
                .then(function (response) {
                    if (response) {
                        selectedRows[0] = response;
                        $scope.$broadcast('event:stale-holdings-reload', {action: 'refresh-grid'});
                    }

                });
        }
    }

    //PUBLIC METHODS

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:stale-holdings-reload', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function(){
        openBrokerageAccount();
    };

    $scope.openBrokerageAccount = function(){
        openBrokerageAccount();
    };

    $scope.sendFollowUpEmail = function(){
        const toName = selectedRows.length === 1 ? selectedRows[0].fullName : null;
        $dialog.dialog({templateUrl: "tools/compass/inform/modal/email-dialog.html", controller: "EmailDialogCtrl", templateType: 3 /*Brokerage Account*/, parentObject: selectedRows, email: null, emailToName: toName, dialogClass: 'modal wide'})
            .open()
            .then(function (response) {
                if(response){
                    $scope.$broadcast('event:stale-holdings-reload', {action: 'refresh-grid'});
                }

            });
    };

    $scope.viewAccessPersonDetail = function(){
        if(selectedRows.length === 1){
            const path = '/tools/compass/inform/accessPerson/'+  selectedRows[0].accessPersonId;
            $location.path(path);
        }
    };

    $scope.refreshGrid = function() {
        $scope.$broadcast('event:stale-holdings-reload', {action: 'refresh-grid'});
    };


    $scope.$on('event:brokerage-account-detail-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        const propertyMap = {
            id: ["id"],
            accessPersonId: ["accesspersonid"],
            accountTitle: ["accounttitle"],
            fullName: ["fullName"]
        };

        Object.each(args[0], function (key, value) {
            let searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
    });

    //INITIALIZE
    const currentUserDetailId = $rootScope.user.authorization.userDetailId;
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.editMode = $scope.rightsCompassInform.canUpdate;
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: "/Compliance/Inform/BrokerageAccounts/StaleHoldings",
        view: views[0],
        editMode: false,
        gridQueries: []
    };
    $scope.currentAccessPerson = null;
    init();
});


'use strict';

app.controller('AdminPreClearanceDetailCtrl', function AdminPreClearanceDetailCtrl($scope, $http, $oasRights, views, $dialog, API_CONFIG,$location, $rootScope, informWorkflowStatus, $routeParams ) {

    //PRIVATE VARIABLES
    let selectedRows;


    //PRIVATE METHODS
    function init(){
        $http.get('/Compliance/Inform/AccessPerson/CurrentUser')
            .then(function (response) {
                if(response.data){
                    $scope.currentAccessPerson= response.data;
                }
            });
    }

    function openBrokerageAccount(id){
        $http.get('/Compliance/Inform/BrokerageAccount/' + id, {trackerMsg: 'Loading brokerage account'})
            .then(function (response) {
                $dialog.dialog({templateUrl: "tools/inform/modal/inform-brokerage-account-dialog.html",controller: "InformBrokerageAccountDialogCtrl",brokerageAccount: response.data, dialogClass: 'modal wide'})
                    .open()
            });
    }

    function openPreClearance(){

        let preclearance = angular.copy(selectedRows[0]);
        const account = {
            id: preclearance.brokerageAccountId,
            accountName: preclearance.brokerageAccount.accountName,
            nickName: preclearance.brokerageAccount.nickName
        };

        if(currentUserDetailId === preclearance.userDetailId){
            $dialog.messageBox("Access Denied", "You are not able to review your own pre-clearance requests.").open();
        } else {
            const options = {
                templateUrl: "tools/inform/modal/inform-new-preclearance-dialog.html",
                controller: "InformPreClearanceDialogCtrl",
                preclearance: preclearance,
                accessPersonId: preclearance.accessPerson.id,
                accounts:[account] ,
                dialogClass: 'modal wide'
            };
            $dialog.dialog(options)
                .open()
                .then(function (result) {
                    if (!result) return;

                    if (preclearance) {
                        Object.merge(preclearance, result);
                        $scope.$broadcast('event:preclearance-detail-reload', {action: 'upsert-items', items:[preclearance]});
                    }
                });
        }
    }

    function massUpdateStatus(status){
        if(selectedRows.length >= 1) {
            if($scope.currentAccessPerson) {
                let hasTheirOwnAccounts = selectedRows.filter(item => {
                    if (item.accessPersonId === $scope.currentAccessPerson.id) {
                        return item;
                    }
                });

                if (hasTheirOwnAccounts.length > 0) {
                    $dialog.messageBox("Access Denied", "You cannot update your own preclearances.").open();
                    return;
                }
            }
            $http.put('/Compliance/Inform/Preclearances/Status/' + status.value,
                $scope.selectedIds,
                {
                    cache: false,
                    trackerMsg: 'Mass updating status.'}
            )
                .then(function (response) {
                    if(response.data){
                        $scope.$broadcast('event:preclearance-detail-reload', {action: 'refresh-grid'});
                    }
                });
        }
    }

    function canMassUpdate(selectedRows){
        let itemsNotOfStatus = selectedRows.every((val,index,arr)=>{
            return val.status === arr[0].status;
        });

        return itemsNotOfStatus;
    }
    //PUBLIC METHODS

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:preclearance-detail-export', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function(){
        openPreClearance();
    };

    $scope.openPreClearance = function(){
        openPreClearance();
    };

    $scope.openBrokerageAccount = function(){
        openBrokerageAccount(selectedRows[0].brokerageAccountId);
    };

    $scope.sendFollowUpEmail = function(){
        const toName = selectedRows.length === 1 ? selectedRows[0].fullName : null;
        $dialog.dialog({templateUrl: "tools/compass/inform/modal/email-dialog.html",controller: "EmailDialogCtrl", templateType: 2 /*PreClearance*/, parentObject: selectedRows, email: null, emailToName: toName, dialogClass: 'modal wide'})
            .open()
            .then(function (response) {
                if(response){
                    $scope.$broadcast('event:preclearance-detail-reload', {action: 'refresh-grid'});
                }

            });
    };

    $scope.viewAccessPersonDetail = function(){
        if(selectedRows.length === 1){
            const path = '/tools/compass/inform/accessPerson/'+  selectedRows[0].accessPersonId;
            $location.path(path);
        }
    };

    $scope.refreshGrid = function() {
        $scope.$broadcast('event:preclearance-detail-reload', {action: 'refresh-grid'});
    };

    $scope.$on('event:preclearance-detail-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        const propertyMap = {
            id: ["id"],
            accessPersonId: ["accessPersonId"],
            brokerageAccountId: ["brokerageAccountId"],
            fullName: ["fullName"]
        };

        Object.each(args[0], function (key, value) {
            let searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });


        $scope.current.canMassUpdateActive = false;
        $scope.current.canMassUpdateClosed = false;
        if(selectedRows.length > 1) {
            let isAllApproved = selectedRows.every((val)=>{
                return val.status === 'Approved';
            });

            let isAllDenied = selectedRows.every((val)=>{
                return val.status === 'Denied';
            });

            let isNotApproveOrDenied = selectedRows.every((val)=>{
                return val.status !== 'Denied' && val.status !== 'Approved';
            });

            let hasMassUpdateRight = canMassUpdate(selectedRows) && $oasRights.forCode("COMPLIANCEADMINONLY");

            $scope.current.canMassUpdateActive = hasMassUpdateRight && isAllDenied || isNotApproveOrDenied;
            $scope.current.canMassUpdateClosed = hasMassUpdateRight && isAllApproved || isNotApproveOrDenied;
        }
    });

    $scope.massUpdateApproved = function(){
        massUpdateStatus(informWorkflowStatus.approved);
    };

    $scope.massUpdateDenied = function(){
        massUpdateStatus(informWorkflowStatus.denied);
    };
    //INITIALIZE
    const currentUserDetailId = $rootScope.user.authorization.userDetailId;
    $scope.accessPerson = {
        id: $routeParams.accessPersonId,
        fullName: $routeParams.accessPersonId ? decodeURIComponent($routeParams.fullName) : ''
    }
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.editMode = $scope.rightsCompassInform.canUpdate;
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: $scope.accessPerson.id ? "/Compliance/Inform/Preclearances/V2/AccessPerson/" + $scope.accessPerson.id : "/Compliance/Inform/Preclearances/V2?allPreclearances=true",
        view: views[0],
        editMode: false,
        gridQueries: [],
        canMassUpdateActive: false,
        canMassUpdateClosed: false,
    };
    init();
});


'use strict';

app.controller('AdminManageOptionsCtrl', function AdminManageOptionsCtrl($scope, $http, $q, $dialog) {

    //PRIVATE METHODS
    function init() {
        loadOfficeLocations();
        loadLicenseSummary();
    }

    function loadOfficeLocations(){
        $http.get('/Compliance/Inform/Office/Locations?activeOnly=false', {trackerMsg: 'Loading office locations'})
            .then(function (response) {
                $scope.officeLocations = response.data;
            });
    }

    function loadLicenseSummary(){
        $http.get('/Compliance/Inform/License/Summary', {trackerMsg: 'Loading License Summary'})
            .then(function (response) {
                $scope.licenseSummary = response.data;
            });
    }

    //PUBLIC METHODS
    $scope.showOfficeLocationDialog = function(location){
        $dialog.dialog({templateUrl: "tools/compass/inform/modal/office-location-dialog.html", officeLocation: angular.copy(location), controller: "OfficeLocationDialogCtrl", dialogClass: 'modal wide'})
            .open()
            .then(function (result) {
                if (result) {
                    loadOfficeLocations();
                }
            });
    };

    $scope.showLicenseDialog= function(){
        $dialog.dialog({templateUrl: "tools/compass/inform/modal/license-dialog.html",  controller: "LicenseDialogCtrl", dialogClass: 'modal wide'})
            .open()
            .then(function (result) {
                if (result) {
                    loadLicenseSummary();
                }
            });
    };

    //INITIALIZE
    $scope.officeLocations = [];
    $scope.licenseSummary = [];
    init();
});
'use strict';

app.controller('PersonLicenseListCtrl', function PersonLicenseListCtrl($scope, $http, $oasRights, views, $dialog, API_CONFIG, $location, $routeParams, activeState, $settings) {

    //PRIVATE VARIABLES
    var selectedRows;

    //PRIVATE METHODS
    function init(){}

    //PUBLIC METHODS
    $scope.viewAccessPersonDetail = function(){
        if(selectedRows.length === 1){
            var path = '/tools/compass/inform/accessPerson/'+  selectedRows[0].accessPersonId;
            $location.path(path);
        }
    };

    $scope.refreshGrid = function() {
        $scope.$broadcast('event:person-license-reload', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:person-license-reload', {action: 'export-data'});
    };

    $scope.$on('event:person-license-select', function (e, args) {
        if (args.length === 0) {return;}

        selectedRows = args;


    });

    //INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.editMode = $scope.rightsCompassInform.canUpdate;
    $scope.templateType = $routeParams.type;
    $scope.current = {
        activeStates: activeState,
        //gridDoubleClick: $scope.slickGridDoubleClick,
        url: $routeParams.licenseId ? "/Compliance/Inform/License/" + $routeParams.licenseId + "/AccessPersons" : "/Compliance/Inform/License/AccessPersons",
        view: views[0],
        editMode: false,
        gridQueries: []
    };
    $scope.current.activeState = $settings.getSetting('activeState');
    init();

});
'use strict';

app.controller('OfficeLocationDialogCtrl', function OfficeLocationDialogCtrl($scope, dialog, $rootScope, $http, $oasRights, $dialog,) {

    //PRIVATE VARIABLES
    const errorTitle = "Missing office location information";

    //PRIVATE METHODS
    function init() {


    }

    function canSave() {
        let savingStatus = {
            canSave: true,
            errorMessage: null,
        };

        if (!$scope.officeLocation.name) {
            savingStatus.canSave = false;
            savingStatus.errorMessage = "You must have a name for the office.";
            return savingStatus;
        }
        if (!$scope.officeLocation.address1) {
            savingStatus.canSave = false;
            savingStatus.errorMessage = "You must have an address1 for the office.";
            return savingStatus;
        }
        if (!$scope.officeLocation.city) {
            savingStatus.canSave = false;
            savingStatus.errorMessage = "You must have a city for the office.";
            return savingStatus;
        }
        if (!$scope.officeLocation.state) {
            savingStatus.canSave = false;
            savingStatus.errorMessage = "You must have a state for the office.";
            return savingStatus;
        }
        if (!$scope.officeLocation.zip) {
            savingStatus.canSave = false;
            savingStatus.errorMessage = "You must have a zip for the office.";
            return savingStatus;
        }

        return savingStatus;
    }


    //PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close();
    };

    $scope.save = function () {
        let savingStatus = canSave();

        if (savingStatus.canSave === false) {
            $dialog.messageBox(errorTitle, savingStatus.errorMessage, [{
                result: 'ok',
                label: 'Ok'
            }]).open();
        }
        if (!savingStatus.canSave)
            return;

        const args = {
            method: $scope.current.method,
            trackerMsg: "Saving office location",
            url: ($scope.current.method === 'POST')
                ? "/Compliance/Inform/Office/Locations"
                :"/Compliance/Inform/Office/Locations/" + $scope.officeLocation.id
        };

        $http({
            method: args.method,
            url: args.url,
            data: $scope.officeLocation,
            trackerMsg: args.trackerMsg
        })
            .then(function (response) {
                $scope.officeLocation = response.data;
                dialog.close($scope.officeLocation);
            });
    };

    //INITIALIZE
    $scope.current = {};
    $scope.officeLocation = (dialog.options.officeLocation) ? dialog.options.officeLocation : {isActive:true};
    $scope.current.method = $scope.officeLocation.id? 'PUT':'POST';

    init();

});

'use strict';
app.controller('LicenseDialogCtrl', function LicenseDialogCtrl($scope, dialog, $rootScope, $http) {
    //PRIVATE METHODS
    function init() {
        getLicenses();
    }

    function getLicenses() {
        $http.get('/Compliance/Inform/License', {trackerMsg: 'Loading database list'})
            .then(function (response) {
                $scope.licenses.list = response.data.sortBy('license');

                $scope.licenses.selected = response.data.findAll({isActive: true}).sortBy('license');
            });
    }

    //PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close();
    };

    $scope.createLicense  = function() {

        if ($scope.licenses.list.none({license: $scope.newLicense}) && $scope.licenses.selected.none({license: $scope.newLicense})) {
            if ($scope.newLicense.length > 0) {
                var data = {license: $scope.newLicense};
                $http.post('/Compliance/Inform/License', data, {trackerMsg: 'Saving new license'})
                    .then(function (response) {
                        const newLicense = response.data;
                        newLicense.name = newLicense.license;

                        $scope.licenses.list.push(newLicense);
                        $scope.newLicense = null;
                    });
            }
        }else {
            $scope.newLicense = null;
    }
    };

    $scope.save = function () {
        const update = [];
        $scope.licenses.list.forEach(function (item) {
            item.isActive = false;
            update.push(item);
        })
        $scope.licenses.selected.forEach(function (item) {
            item.isActive = true;
            update.push(item);
        })

        $http.put('/Compliance/Inform/License', update, { trackerMsg: 'Saving License Availability' })
            .then(function () {
                dialog.close();
            });
    };


    //INITIALIZE
    init();
    $scope.licenses = {list: [], selected: []};
    $scope.newLicense = null;
});
'use strict';
app.controller('DepartmentsDialogCtrl', function DepartmentsDialogCtrl($scope, dialog, $rootScope, $http) {
    //PRIVATE METHODS
    function init() {
        getDepartments();
    }

    function getDepartments() {
        $http.get('/Compliance/Inform/Departments', {trackerMsg: 'Loading Department list'})
            .then(res => {
                $scope.departments.list = res.data.sortBy('department');

                $scope.departments.selected = res.data.findAll({isActive: true}).sortBy('department');
            });
    }

    //PUBLIC METHODS
    $scope.cancel = () => {
        dialog.close();
    }

    $scope.createDepartment = () => {
        if ($scope.departments.list.none({department: $scope.newDepartment}) && $scope.departments.selected.none({department: $scope.newDepartment})) {
            if ($scope.newDepartment.length > 0) {
                let data = {department: $scope.newDepartment};
                $http.post('/Compliance/Inform/Departments', data, {trackerMsg: 'Saving new department'})
                    .then(res => {
                        const newDepartment = res.data;
                        newDepartment.name = newDepartment.department;

                        $scope.departments.list.push(newDepartment);
                        $scope.newDepartment = null;
                    });
            }
        }else {
            $scope.newDepartment = null;
        }
    }

    $scope.save = () => {
        const update = [];
        $scope.departments.list.forEach(item => {
            item.isActive = false;
            update.push(item);
        })
        $scope.departments.selected.forEach(item => {
            item.isActive = true;
            update.push(item);
        })

        $http.put('/Compliance/Inform/Departments', update, { trackerMsg: 'Saving Department Availability' })
            .then(() => {
                dialog.close(true);
            });
    }


    //INITIALIZE
    init();
    $scope.departments = {list: [], selected: []};
    $scope.newDepartment = null;
});
'use strict';

app.controller('InformCloseConnectionsDialogCtrl', function InformCloseConnectionsDialogCtrl($scope, $http, $upload, $routeParams, API_CONFIG, dialog, $dialog, $rootScope, $oasRights) {


    //PRIVATE METHODS
    function init() {

        loadConnections();
    }

    function filterOutInActiveConnections(){
        for(let user of $scope.userConnections){
            let connections = user.connections.filter(connection=>{
                if(connection.isActive || connection.brokerageAccounts.length === 0) {
                    return connection;
                }
            });

            user.connections = connections;
        }
    }

    function loadConnections() {
        $http.get(`/Compliance/Inform/Connections/AccessPerson/${$scope.accessPersonId}`, {trackerMsg: 'Loading connections'})
            .then(function (response) {
                //const data = response.data.sortBy('institutionName');
                $scope.userConnections = response.data;
                filterOutInActiveConnections();
                //loop over each inform user and sort each set of connections
                /*$scope.userConnections.forEach((item)=>{
                    //use sort function with 1 being object2 is greater than object 1 ; -1 is object 1 is less than object2
                    // item.connections.sort((conn1,conn2)=>{
                    //     return conn1.
                    // });
                });*/
            });
    }

    function plaidDelete(){
        let plaidConnectionIdsToDelete=[];

        for(let user of $scope.userConnections){
            for(let conn of user.connections){
                if(conn.toBeDeleted && user.downloadFormatName === 'InformPlaid'){
                    plaidConnectionIdsToDelete.push({id:conn.id, sourceConnectionId:conn.sourceConnectionId});
                }
            }
        }
        $scope.current.connectionsToDelete.ids = plaidConnectionIdsToDelete;

        if(plaidConnectionIdsToDelete.length === 0 || $scope.current.connectionsToDelete.comment.length === 0){
            $dialog.messageBox("Remove Connections","Please have a comment and at least once connection selected before trying to save.")
                .open();
        }else{
            $dialog.confirmAction("Has this connection removal been verified by the compliance admin? Are you sure you want to delete these connections and accounts?")
                .open()
                .then((result)=> {
                    if (result === 'yes') {
                        let plaidConnectionPromises = [];
                        let plaidConnectionsToDisable = [];

                        for(let conn of plaidConnectionIdsToDelete){
                            let promise = $http.delete(`/Integrations/Plaid/DeleteItem?itemId=${conn.sourceConnectionId}`,{trackMsg:'Deleting Plaid Connection'})
                                .then((response)=>{
                                    var data = response.data;
                                    if(data.isSuccessStatusCode){
                                        plaidConnectionsToDisable.push(conn.id);
                                    }
                                });
                            plaidConnectionPromises.push(promise);
                        }
                        Promise.all(plaidConnectionPromises).then(()=>{
                            const connectionsToDeleteRequest = {ids:plaidConnectionsToDisable, comment: $scope.current.connectionsToDelete.comment};
                            $http.put(`/Compliance/Inform/Connections/Disable`, connectionsToDeleteRequest, {trackerMsg: 'Removing connections'})
                                .then(function () {
                                    dialog.close();
                                });
                        });
                    }
                });
        }
    }

    function byAllDelete(){
        let connectionIdsToDelete=[];

        for(let user of $scope.userConnections){
            for(let conn of user.connections){
                if(conn.toBeDeleted && user.downloadFormatName === 'InformByAllAccounts'){
                    connectionIdsToDelete.push(conn.id);
                }
            }
        }
        $scope.current.connectionsToDelete.ids = connectionIdsToDelete;

        if(connectionIdsToDelete.length === 0 || $scope.current.connectionsToDelete.comment.length === 0){
            $dialog.messageBox("Remove Connections","Please have a comment and at least once connection selected before trying to save.")
                .open();
        }else{
            $dialog.confirmAction("Has this connection removal been verified by the compliance admin? Are you sure you want to delete these connections and accounts? These connections and accounts are unrecoverable and will require readding if they need to be restored.")
                .open()
                .then((result)=> {
                    if (result === 'yes') {
                        const connectionsToDeleteRequest = {ids:connectionIdsToDelete, comment: $scope.current.connectionsToDelete.comment};
                        $http.put(`/Compliance/Inform/Connections/Disable`, connectionsToDeleteRequest, {trackerMsg: 'Removing connections'})
                            .then(function () {
                                dialog.close();
                            });
                    }
                });
        }
    }

    function connectionDelete(){
        let connectionIdsToDelete = [];

        for(let user of $scope.userConnections){
            for(let conn of user.connections){
                if (conn.toBeDeleted ) {
                    connectionIdsToDelete.push(conn.id);
                }
            }
        }
        $scope.current.connectionsToDelete.ids = connectionIdsToDelete;

        if($scope.current.connectionsToDelete.ids.length === 0 || $scope.current.connectionsToDelete.comment.length === 0){
            $dialog.messageBox("Remove Connections","Please have a comment and at least once connection selected before trying to save.")
                .open();
        }else{
            $dialog.confirmAction("Has this connection removal been verified by the compliance admin? Are you sure you want to delete these connections and accounts?")
                .open()
                .then((result)=> {
                    if (result === 'yes') {
                        $http.put(`/Compliance/Inform/Connections/Disable`,
                            $scope.current.connectionsToDelete,{trackerMsg: 'Removing connections'})
                            .then(function (response) {
                                dialog.close();
                            });

                    }
                });
        }
    }

    $scope.submit = function (connectionFormatName) {
        $scope.connectionSourceSetup[connectionFormatName].deleteConnection();
    };

    $scope.close = function () {
        dialog.close();
    };

    // INITIALIZE
    $scope.accessPersonId = dialog.options.accessPersonId;
    $scope.current={
        connectionsToDelete:{
            comment:"",
            ids:null,
        },
    };

    $scope.complianceAdminOnly = $oasRights.forCode("COMPLIANCEADMINONLY");
    $scope.userConnections = [];

    $scope.connectionSourceSetup=
        {
            InformPlaid:{
                deleteConnection:plaidDelete,
            },
            InformByAllAccounts:{
                deleteConnection:byAllDelete,
            },
            InformRetirementAcct:{
                deleteConnection:connectionDelete,
            },
            InformOrionConnect:{
                deleteConnection:null,
            }
        };

    init();
});
"use strict"
app.controller('AccessPersonDetailCtrl', function AccessPersonDetailCtrl($scope, $location, $http, $routeParams, $dialog, $rootScope, $oasRights) {

    //PRIVATE METHODS
    function init() {
        loadConnectionSources(loadData);
    }

    function loadData(configKey) {
        let config = {
            accessPerson: '',
            userConnections: '/Connections',
            preClearances: '/Preclearances/V2',
            historicalDocuments: '/HistoricalDocuments',
            documents: '/Documents',
            tradeViolations: '/TradeViolations/V2',
        };

        if (configKey) {
            config = {[configKey]: config[configKey]};
        }

        Object.each(config, function (key, value) {

            $http.get('/Compliance/Inform' + value + '/AccessPerson/' + $scope.accessPerson.id, {trackerMsg: 'Loading ' + key.spacify()})
                .then(function (response) {
                    const data = response.data;
                    if (key === 'documents') {
                        $scope.questionnaires = data.filter((item)=> {
                            return item.templateType === 'Questionnaire';
                        });

                        $scope.tasks = data.filter((item)=>{
                            return item.templateType !== 'Questionnaire';
                        });

                        if ($scope.tasks) {
                            $scope.taskGroups = $scope.tasks.groupBy("name");
                        }
                    } else if (key === 'accessPerson') {
                        $scope[key] = data;
                        $scope[key].employmentDate = dateOnly($scope[key].employmentDate);

                    } else if (key === 'userConnections') {
                        loadConnections(data);

                    } else if (key === 'tradeViolations') {
                        $scope.tradeViolations = data;
                        $scope.tradeViolationCount = {
                            preclearance: 0,
                            securities: 0,
                            frontRunning: 0,
                            roundTrip: 0
                        };

                        $scope.tradeViolations.forEach(t => {
                            if(t.isPreClearance) {
                                $scope.tradeViolationCount.preclearance++;
                            }
                            if(t.isSecuritiesViolation) {
                                $scope.tradeViolationCount.securities++;
                            }
                            if(t.isFrontRunning) {
                                $scope.tradeViolationCount.frontRunning++;
                            }
                            if(t.isRoundTrip30) {
                                $scope.tradeViolationCount.roundTrip++;
                            }
                        });
                    } else {
                        $scope[key] = data;
                    }
                });
        });
    }

    function loadConnections(data) {
        let connections = [];

        for (let item of data) {
            for (let connection of item.connections) {
                connection.canDeleteAction = $scope.connectionSourceEnum[connection.downloadFormatName].canDeleteAction;

                connections.push(connection);
            }
        }

        let sortedByInstitutionName = connections.sort((obj1, obj2) => {
            if(obj1.institutionName === null ) {
                obj1.institutionName = "";
            }
            if(obj2.institutionName === null ) {
                obj2.institutionName = "";
            }
            
            if (obj1.institutionName.toLowerCase() > obj2.institutionName.toLowerCase()) {
                return 1;
            }
            if (obj1.institutionName.toLowerCase() < obj2.institutionName.toLowerCase()) {
                return -1;
            }
        });

        $scope.connectionSourceUsers = sortedByInstitutionName.sort((obj1, obj2) => {
            if(obj1.requiresAttention === 1 || obj2.requiresAttention === 1)
                return -1;

            return 0;
        });

        filterClosedAccounts();
    }

    function loadConnectionSources(next) {
        $http.get('/Compliance/Inform/Connections/V2/ConnectionSources', {trackerMsg: 'Loading brokerage account connection sources'})
            .then(function (response) {
                if (response.data) {
                    //configure our connection sources
                    setupConnectionSourceEnum(response.data);
                }
            })
            .then(next());
    }

    function setupConnectionSourceEnum(data) {
        $scope.connectionSources = data.map(item => {
            let source = {};
            angular.copy($scope.connectionSourceEnum[item.downloadFormatName], source);
            source.donwloadSourceId = item.downloadSourceId;
            return source;
        });
    }

    function dateOnly(dte) {
        if (!dte) return;
        return Date.create(dte.slice(0, 10)).format('{MM}/{dd}/{yyyy}');
    }

    function filterClosedAccounts() {
        const closedStatus = ['Closed', 'Denied'];
        angular.copy($scope.connectionSourceUsers, $scope.connectionSourceUsersFiltered);

        if (!$scope.current.showClosed) {
            let connections = [];
            for (let connectionIndex = 0; connectionIndex < $scope.connectionSourceUsersFiltered.length; connectionIndex++) {
                let connection = $scope.connectionSourceUsersFiltered[connectionIndex];

                if (connection.isActive === false){
                    connections.add(connection);
                    continue;
                }

                if (!connection.brokerageAccounts) {
                    continue;
                }

                let closedBrokerageAccounts = connection.brokerageAccounts.filter((item) => {
                    return closedStatus.find(item.currentStatus);
                });

                if (connection.brokerageAccounts.length > 0 && closedBrokerageAccounts.length === connection.brokerageAccounts.length ) {
                    connections.add(connection);
                }

                connection.brokerageAccounts = connection.brokerageAccounts.filter((item) => {
                    return !closedStatus.find(item.currentStatus);
                });
            }

            for (let connection of connections) {
                $scope.connectionSourceUsersFiltered.remove(connection);
            }
        }
    }

    //PUBLIC METHODS
    $scope.getBadgeFromStatus = function (status) {
        return {
            Submitted: 'badge-info',
            Approved: 'badge-success',
            Active: 'badge-success',
            Canceled: 'badge-info',
            Denied: 'badge-danger',
            New: 'badge-success',
            'Not Submitted': 'badge-warning',
            'Follow-up': 'badge-warning',
            'Verbal Warning': 'badge-warning',
            'Written Warning': 'badge-warning',
            'Loss of Trading Privileges': 'badge-warning',
            Termination: 'badge-danger',
            Other: 'badge-success',
            incorrect_credentials: 'badge-danger',
            challenges: 'badge-danger',
            user_config: 'badge-danger',
            resync: 'badge-danger',
        }[status];
    };

    $scope.openDialog = function (type, item, accessPerson, sourceUserId, sourceConnectionId) {
        const config = {
            brokerageAccount: ['', 'inform-brokerage-account-dialog.html', 'InformBrokerageAccountDialogCtrl', 'modal wide'],
            preclearance: ['', 'inform-new-preclearance-dialog.html', 'InformPreClearanceDialogCtrl', 'modal wide'],
            document: ['', 'inform-questionnaire-dialog.html', 'InformQuestionnaireDialogCtrl', 'edit-pane'],
            task: ['', 'inform-questionnaire-dialog.html', 'InformQuestionnaireDialogCtrl', 'modal wide'],
            tradeViolation: ['/compass', 'trade-violation-dialog.html', 'TradeViolationDialogCtrl', 'modal wide'],
            accessPerson: ['/compass', 'access-person-dialog.html', 'AccessPersonDialogCtrl', 'modal wide']
        }[type];

        const options = {
            templateUrl: 'tools' + config[0] + '/inform/modal/' + config[1],
            controller: config[2],
            dialogClass: config[3]
        };
        switch (type) {
            case 'document':
            case 'accessPerson':
                options.id = item.id;
                break;
            case 'preclearance':
                options.accounts = $scope.preClearances.map(function (preclearance) {
                    return {
                        id: preclearance.brokerageAccountId,
                        accountName: preclearance.brokerageAccount.accountName,
                        nickName: preclearance.brokerageAccount.nickName
                    };
                });
                options[type] = angular.copy(item);
                break;
            case 'brokerageAccount':
                options.accessPerson = accessPerson;
                options.sourceUserId = sourceUserId;
                options.sourceConnectionId = sourceConnectionId;
                options[type] = angular.copy(item);
                break;
            default:
                options[type] = angular.copy(item);
        }

        $dialog.dialog(options)
            .open()
            .then(function (result) {
                if (!result) return;

                if (type === "brokerageAccount") {
                    loadData('userConnections');
                    return;
                }
                Object.merge(item, result);
            });
    };

    $scope.closeAllOpenItems = function () {
        const msgText = 'This process will:<br /><br />' +
            '1. Mark all Brokerage Accounts as Closed.<br />' +
            '2. Mark all pending pre-clearance requests as Cancelled.<br />' +
            '3. Mark all pending Task and Questionnaires as Cancelled.<br />' +
            '4. Set Termination Date to today.<br /><br />' +
            'Do you want to continue?';

        $dialog.confirmAction(msgText)
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.post('/Compliance/Inform/AccessPerson/' + $scope.accessPerson.id + '/CloseAll', {trackerMsg: 'Closing all open items'})
                        .then(function (response) {
                            $scope.accessPerson = response.data;
                            $dialog.messageBox("Terminate Employee", "Process completed.").open();
                            loadData();
                        });
                }
            });
    };

    $scope.viewTradeHistory = function () {
        const path = '/tools/compass/inform/accessPerson/tradeHistory/' + $scope.accessPerson.id + '/' + encodeURIComponent($scope.accessPerson.fullName);
        $location.path(path);
    };

    $scope.viewTradeViolations = () => {
        const path = '/tools/compass/inform/accessPerson/tradeViolation/' + $scope.accessPerson.id + '/' + encodeURIComponent($scope.accessPerson.fullName);
        $location.path(path);
    }

    $scope.viewPreclearances = () => {
        const path = '/tools/compass/inform/accessPerson/preclearances/' + $scope.accessPerson.id + '/' + encodeURIComponent($scope.accessPerson.fullName);
        $location.path(path);
    }

    $scope.viewHistoricalDocuments = () => {
        const path = '/tools/compass/inform/historicalDocuments/accessPerson/' + $scope.accessPerson.id + '/' + encodeURIComponent($scope.accessPerson.fullName);
        $location.path(path);
    }

    $scope.openTaskHistory = function (id) {
        const path = '/tools/compass/inform/accessPerson/tasks/' + $scope.accessPerson.id + '/' + id + '/' + encodeURIComponent($scope.accessPerson.fullName);
        $location.path(path);
    };

    $scope.viewHoldings = function () {
        const path = '/tools/compass/inform/accessPerson/holdings/' + $scope.accessPerson.id + '/' + encodeURIComponent($scope.accessPerson.fullName);
        $location.path(path);
    };

    $scope.showToggledAccounts = function () {
        $scope.current.showClosed = !$scope.current.showClosed;
        filterClosedAccounts();
    };

    $scope.closeConnections = function () {
        $dialog.dialog({
            templateUrl: "tools/compass/inform/modal/inform-close-connections-dialog.html",
            controller: "InformCloseConnectionsDialogCtrl",
            accessPersonId: $scope.accessPerson.id,
            dialogClass: 'modal wide'
        })
            .open()
            .then(function (result) {
                loadData();
            });
    };

    //INITIALIZE
    $scope.accessPerson = {
        id: $routeParams.accessPersonId
    };
    $scope.current = {
        showClosed: false,
        isAdmin: $rootScope.user.authorization.entity === "Administrator",
    };
    $scope.brokerageAccounts = [];
    $scope.brokerageAccountFilteredList = [];
    $scope.complianceAdminOnly = $oasRights.forCode("COMPLIANCEADMINONLY");
    $scope.connectionSourceUsers = [];
    $scope.connectionSourceEnum = [];
    $scope.connectionSourceUsersFiltered = [];

    $scope.connectionSourceEnum['Deprecated Format'] =
    {
        displayHeader: '3rd Party Connected Accounts',
    };
    $scope.connectionSourceEnum['QuovoApiInform'] =
        {
            displayHeader: '3rd Party Connected Accounts',
        };
    $scope.connectionSourceEnum['InformPlaid'] =
        {
            displayHeader: '3rd Party Connected Accounts',
        };
    $scope.connectionSourceEnum['InformByAllAccounts'] =
        {
            downloadFormatName: '3rd Party Connected Accounts',
        };
    $scope.connectionSourceEnum['InformRetirementAcct'] =
        {
            displayHeader: 'Unconnected Accounts',
        };
    $scope.connectionSourceEnum['InformOrionConnect'] =
        {
            displayHeader: 'Orion Connected Accounts',
        };
    $scope.connectionSourceEnum[0] =
        {
            displayHeader: '3rd Party Connected Accounts',
        };


    init();
});

'use strict';

app.controller('AccessPersonListCtrl', function AccessPersonListCtrl($scope, $http, $oasRights, views, $dialog, API_CONFIG, $location, $routeParams, activeState, $settings, $timeout) {

    //PRIVATE VARIABLES
    let selectedRows;

    //PRIVATE METHODS
    function init(){
        if($scope.templateType !== "Access Person All"){
            const path = $location.path();
            $scope.addBreadcrumb($scope.templateType, path);
        }
        if($routeParams.type === "Access Person By Location"){
            const locationId = $routeParams.id;
            $scope.current.url = `/Compliance/Inform/AccessPersons/ByLocation/${locationId}`;
        }
        if($routeParams.type === "Access Person By Department"){
            const departmentId = $routeParams.id;
            $scope.current.url = `/Compliance/Inform/AccessPersons/ByDepartment/${departmentId}`;
        }
    }


    function AccessPersonDetail(){
        if (selectedRows.length === 1){
            const path = '/tools/compass/inform/accessPerson/'+  selectedRows[0].id;
            $location.path(path);
        }
    }

    $scope.slickGridDoubleClick = function () {
        if (selectedRows.length === 1) {
            AccessPersonDetail();
        }
    };

    $scope.accessPersonDetail = function () {
        AccessPersonDetail();
    };

    $scope.addAccessPerson = function (active) {
        let ids = [];
        selectedRows.forEach(function (item) {
            ids.push(item.userDetailId);
        });

        const url = '/Compliance/Inform/AccessPerson/' + active;
        $http.post(url, ids, {trackerMsg: 'Add access person'})
            .then(function () {
                $scope.$broadcast('event:access-person-list-event', {action: 'refresh-grid'});
            });
    };

    $scope.accessPersonStatus = function (active) {
        let ids = [];
        selectedRows.forEach(function (item) {
            ids.push(item.id);
        });

        const url = '/Compliance/Inform/AccessPerson/' + active;
        $http.put(url, ids, {trackerMsg: 'Update access person'})
            .then(function () {
                $scope.$broadcast('event:access-person-list-event', {action: 'refresh-grid'});
            });

    };

    $scope.refreshGrid = function () {
        $settings.setSetting('activeState', $scope.current.activeState);
        $timeout(function () {
            $scope.$broadcast('event:access-person-list-event', {action: 'refresh-grid'});
        });
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:access-person-list-event', {action: 'export-data'});
    };

    $scope.$on('event:access-person-list-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        const propertyMap = {
            id: ["id"],
            userDetailId: ["userDetailId"],
            isActive: ["isActive"]
        };

        Object.each(args[0], function (key, value) {
            const searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
    });

    //INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.editMode = $scope.rightsCompassInform.canUpdate;
    $scope.templateType = $routeParams.type;
    $scope.isAccessPersonByLocation = $routeParams.type === 'Access Person By Location';
    $scope.isAccessPersonByDepartment = $routeParams.type === 'Access Person By Department';
    $scope.showTemplateTypeBreadCrumb = $routeParams.type !== 'Access Person All' && !$scope.isAccessPersonByLocation && !$scope.isAccessPersonByDepartment;
    $scope.showAllAccessPersonListBreadCrumb = $routeParams.type !== 'Access Person All' && !$scope.isAccessPersonByLocation && !$scope.isAccessPersonByDepartment;    $scope.current = {
        activeStates: activeState,
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: "/Compliance/Inform/AccessPersons/" + $routeParams.type.escapeURL(),
        view: views[0],
        editMode: false,
        gridQueries: [],
        slickGridIdColumnToUse: $routeParams.type !== "Access Person New" ? "id" : "userDetailId",
    };
    $scope.current.activeState = $settings.getSetting('activeState');
    init();

});


'use strict';

app.controller('AdminTradeHistoryCtrl', function AdminTradeHistoryCtrl($scope, $http, views, $dialog, $routeParams, $location, $rootScope) {

    //PRIVATE VARIABLES
    var selectedRows;

    //PRIVATE METHODS

    //PUBLIC METHODS

    $scope.refreshGrid = function () {
        $scope.$broadcast('event:trade-history-reload', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:trade-history-reload', {action: 'export-data'});
    };

    $scope.openDialog = function (type, id) {
        const config = {
            brokerageAccount: ['', 'inform-brokerage-account-dialog.html', 'InformBrokerageAccountDialogCtrl'],
            preclearance: ['', 'inform-new-preclearance-dialog.html', 'InformPreClearanceDialogCtrl'],
            tradeViolation: ['/compass', 'trade-violation-dialog.html', 'TradeViolationDialogCtrl']
        }[type];

        const options = {
            templateUrl: 'tools' + config[0] + '/inform/modal/' + config[1],
            controller: config[2],
            dialogClass: 'modal wide'
        };

        $http.get('/Compliance/Inform/' + type + '/' + id, {trackerMsg: 'Loading details'})
            .then(function (response) {
                options[type] = response.data;

                $dialog.dialog(options)
                    .open()
                    .then(function (result) {
                        if (result) {
                            $scope.$broadcast('event:trade-history-reload', {action: 'refresh-grid'});
                        }
                    });
            });
    };

    $scope.$on('event:trade-history-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        var propertyMap = {
            preClearanceId: ["preClearanceId"],
            tradeViolationId: ["tradeViolationId"],
            brokerageAccountId: ["brokerageAccountId"],
            userDetailId: ["userDetailId"],
        };

        Object.each(args[0], function (key, value) {
            var searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
    });

    $scope.viewAccessPersonDetail = function(){
        if(selectedRows.length === 1){
            const path = '/tools/compass/inform/accessPerson/'+  selectedRows[0].accessPersonId;
            $location.path(path);
        }
    };

    //INITIALIZE
    var url = "/Compliance/Inform/AccessPerson/V2/Trades";
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {
        startDate: Date.create("today").addDays(-30),
        endDate: Date.create("today").addDays(7),
        thisUserDetailId: $rootScope.user.authorization.userDetailId,
        view: views[0],
        editMode: false,
        gridQueries: [],
        allTrades:$routeParams.allTrades=== undefined?false:$routeParams.allTrades,
        accessPersonId:$routeParams.accessPersonId,
    };
    $scope.current.url = url;

    $scope.accessPerson = {
        id: $routeParams.accessPersonId,
        fullName: $routeParams.accessPersonId ? decodeURIComponent($routeParams.fullName) : ''
    };
});


'use strict';

app.controller('AccessPersonHoldingsCtrl', function AccessPersonHoldingsCtrl($scope, $http, views, $dialog, $routeParams, $location) {

    //PRIVATE VARIABLES
    var selectedRows;

    //PRIVATE METHODS

    //PUBLIC METHODS
    $scope.refreshGrid = function() {
        $scope.$broadcast('event:holdings-reload', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:holdings-reload', {action: 'export-data'});
    };

    $scope.viewAccessPersonDetail = function(){
        if(selectedRows.length === 1){
            const path = '/tools/compass/inform/accessPerson/'+  selectedRows[0].accessPersonId;
            $location.path(path);
        }
    };

    $scope.$on('event:holdings-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

    });

    //INITIALIZE
    const url = "/Compliance/Inform/AccessPerson/V2/Holdings?" + ($routeParams.allAccessPersons ? "allAccessPersons=true": "accessPersonId=" + $routeParams.accessPersonId);
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {
        url: url,
        view: views[0],
        editMode: false,
        gridQueries: []
    };
    $scope.accessPerson = {
        id: $routeParams.accessPersonId,
        fullName: $routeParams.accessPersonId ? decodeURIComponent($routeParams.fullName) : ''
    };
    $scope.showContextMenu = $routeParams.allAccessPersons === "true";
    $scope.showBreadcrumb = $routeParams.allAccessPersons === "true";
});


app.controller('DistributeQuestionnaireCtrl', function DistributeQuestionnaireCtrl($http, $scope, $routeParams, views, $dialog, $location) {

    //PRIVATE METHODS
    var selectedRows;
    function init(){
        //check and confirm proper setup before can distribute
        $http.get('/Compliance/Inform/CanDistribute/' + $routeParams.templateId, {cache: false, trackerMsg: 'Checking questionnaire setup'})
            .then(function (response) {
                $scope.canDistribute = response.data;
                if(response){
                    $scope.canDistributeHelp = (response.data)
                        ? "List of access persons that have not received this questionnaire."
                        : "Cannot distribute this questionnaire. Please verify that all policies being referenced have a document definition loaded."
            }});

        $http.get('/Compliance/Inform/Template/' + $routeParams.templateId, {cache: false, trackerMsg: 'Checking questionnaire setup'})
            .then(function (response) {
                $scope.questionnaireName = response.data.templateName;
            });
    }

    //PUBLIC METHODS
    $scope.refreshGrid = function() {
        $scope.$broadcast('event:access-person-event', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:access-person-event', {action: 'export-data'});
    };

    $scope.submitDistributionList = function () {
        if($scope.canDistribute){
            $scope.$broadcast('event:access-person-event', {action: 'get-filtered'});
        }

    };

    $scope.addToGroup= function(){
        $scope.current.view.filters.length = 0;

        $scope.selectedIds.forEach(function(id) {
            $scope.current.view.filters.push({ name: "ID = " + id, value: "(function (a) { return a === " + id + "; })", key: "id", include: true });
        });

        $scope.current.view.filterType = 'Any';

    };

    $scope.viewAccessPersonDetail = function(){
        if(selectedRows.length === 1 && selectedRows[0].id){
            var path = '/tools/compass/inform/accessPerson/'+  selectedRows[0].id;
            $location.path(path);
        }
    };


    $scope.$on('event:access-person-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        var propertyMap = {
            id: ["id"]
        };

        Object.each(args[0], function (key, value) {
            var searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
    });

    $scope.$on('slickgrid-getfiltered', function(event, data){

        $dialog.messageBox("Confirm distribution", `This questionnaire is being distributed to ${data.length} ${data.length === 1 ? 'person' : 'people'}? Please confirm that this is correct.`,[{result: true, label: 'Confirm', focus: true, cssClass:"btn-primary pull-right"}, {result: false, label: 'Cancel', focus: false, cssClass:"pull-left"}])
            .open()
            .then((msgBoxAnswer)=>{
                if(msgBoxAnswer){
                    var dueDate = Date.create($scope.current.dueDate).format('{MM}-{dd}-{yyyy}');

                    $http.post('/Compliance/Inform/Distribute/' + templateId + '/' + dueDate,  data, {cache: true, trackerMsg: 'Saving questionnaire'})
                        .then(function () {
                            $dialog.messageBox("Next", "What would you like to do next?", [{result: true, label: 'View Questionnaires', focus: true, cssClass:"btn-primary pull-right"}, {result: false, label: 'Distribute More', focus: false, cssClass:"pull-left"}])
                                .open()
                                .then(function(result){
                                    if (result) {
                                        var url = "#/tools/compass/inform/questionnaires";
                                        window.location.replace( url );
                                    }
                                });
                        });

                }
            });
    });

    //PRIVATE VARIABLES
    var today = Date.create();
    var templateId = $routeParams.templateId;
    var url = "/Compliance/Inform/AccessPersons/AccessPerson?templateId=" + templateId + "&isActive=true";

    //INITIALIZE
    $scope.canDistribute = false;
    $scope.canDistributeHelp = '';
    $scope.selectedRows = [];
    $scope.views = views;
    $scope.accessPersonList = [];
    $scope.selectedIds = [];
    $scope.current = {
        url: url,
        view: views[0],
        editMode: false,
        gridQueries: [],
        dueDate: today.addDays(30)
    };
    init();
});

'use strict';

app.controller('AdminTaskCtrl', function AdminTaskCtrl($scope, $http, $oasRights, views, $dialog,$location, $settings, activeState, $timeout ) {

    //PRIVATE VARIABLES
    let selectedRows;

    //PRIVATE METHODS
    function taskDetails(thisTask){
        let path = '';
        switch (thisTask.id){
            case -1:
                path = '/tools/compass/inform/brokerageaccounts';
                break;
            case -2:
                path = '/tools/compass/inform/preclearance';
                break;
            default:
                path = '/tools/compass/inform/task/' + thisTask.id;
                break;
        }

        $location.path(path);
    }

    function taskDialog(thisTask, copyFromId){
        $dialog.dialog({templateUrl: "tools/compass/inform/modal/admin-template-dialog.html",controller: "AdminTemplateDialogCtrl",thisTemplate: angular.copy(thisTask), copyFromId: copyFromId, templateType: "Task", dialogClass: 'modal wide'})
            .open()
            .then(function (response) {
                if(response){
                    if(!thisTask){
                        thisTask = response;
                    } else {
                        Object.merge(thisTask, response);
                    }
                    $scope.$broadcast('event:inform-task-reload', {action: 'upsert-items', items: [thisTask]});
                }
            });
    }

    //PUBLIC METHODS
    $scope.addTaskDialog = function(){
        //pass in empty task template type, fetch it first and then pass it in
        $http.get('/Compliance/Inform/Template/EmptyTemplate?templateType=Task', {cache: true, trackerMsg: 'Loading empty template'})
            .then(function (response) {
                taskDialog(response.data);
            });
    };

    $scope.taskDialog = function () {
        taskDialog(selectedRows[0]);
    };

    $scope.taskDetails = function(){
        taskDetails(selectedRows[0]);
    };

    $scope.toggleActiveStatus = function(){

        let thisRow = selectedRows[0];
        const newStatus = !thisRow.isActive;
        const thisId = thisRow.id;

        $http.put("/Compliance/Inform/Template/" + thisId + "/" + newStatus, [], {trackerMsg: 'Updating active status.'})
            .then(function (response) {
                Object.merge(thisRow, response.data);
                $scope.$broadcast('event:inform-task-reload', {action: 'upsert-items', items: [thisRow]});
            });
    };

    $scope.deleteTaskTemplate = function(){

        const thisRow = selectedRows[0];
        const thisId = thisRow.id;

        $http.delete("/Compliance/Inform/Template/" + thisId, {trackerMsg: 'Delete task'})
            .then(function (response) {
                if(response.data){
                    $scope.$broadcast('event:inform-task-reload', {action: 'delete-item', item: selectedRows[0]});
                }
            });
    };

    $scope.slickGridDoubleClick = function () {
        taskDetails(selectedRows[0]);
    };

    $scope.refreshGrid = () => {
        $settings.setSetting('activeState', $scope.current.activeState);
        $timeout(() => {
            $scope.$broadcast('event:inform-task-reload', {action: 'refresh-grid'});
        });
    }

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:inform-task-reload', {action: 'export-data'});
    };

    $scope.cloneTask = function(){
        let newTask = angular.copy(selectedRows[0]);
        newTask.id = null;
        newTask.isLocked = false;
        newTask.templateName = newTask.templateName + ' - Clone';
        taskDialog(newTask,selectedRows[0].id )
    };

    $scope.$on('event:inform-task-select', function (e, args) {
        if (args.length === 0) return;

        $scope.canClone = args[0].templateType !== "Task With Multiple";

        selectedRows = args;

        const propertyMap = {
            id: ["id"],
            created: ["created"],
            isActive: ["isactive"],
        };

        Object.each(args[0], function (key, value) {
            let searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
    });

    //INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.editMode = $scope.rightsCompassInform.canUpdate;
    $scope.canDelete = $scope.rightsCompassInform.canDelete;
    $scope.canClone = true;
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: "/Compliance/Inform/Templates/Task",
        view: views[0],
        editMode: false,
        gridQueries: [],
        activeStates: activeState
    };
    $scope.current.activeState = $settings.getSetting('activeState');
});




'use strict';

let adminTaskDetailCtrl = app.controller('AdminTaskDetailCtrl', function AdminTaskDetailCtrl($scope, $http, $oasRights, $dialog, API_CONFIG,$location, $routeParams, $rootScope, config,informWorkflowStatus,adminDocumentsService ) {

    //PRIVATE VARIABLES
    let selectedRows;

    //PRIVATE METHODS
    function init (){
        const path = $location.path();
        $scope.addBreadcrumb("Tasks", path);

        $http.get('/Compliance/Inform/Template/' + $routeParams.templateId, {cache: false, trackerMsg: 'Checking questionnaire setup'})
            .then(function (response) {
                $scope.templateName = response.data.templateName;
            });
    }

    function openTemplateDialog(thisTask){

        if(currentUserDetailId === thisTask.userDetailId){
            $dialog.messageBox("Access Denied", "You are not able to review your own submissions.").open();
        } else {
            $dialog.dialog({templateUrl: "tools/inform/modal/inform-questionnaire-dialog.html",controller: "InformQuestionnaireDialogCtrl", id: thisTask.id, dialogClass: 'modal wide'})
                .open()
                .then(function (response) {
                    if(response){
                        Object.merge(thisTask,response);
                        //since the grid column is named differently from the dto we have to do the following manual update.
                        thisTask.status = response.documentStatus;
                        $scope.$broadcast('event:inform-tasks-reload', {action: 'upsert-items', items: [thisTask]});
                    }

                });
        }
    }

    function massUpdateStatus(type){
        adminDocumentsService.massUpdateStatus(type,$scope.selectedIds,selectedRows,'event:inform-tasks-reload', $scope);
    }

    $scope.downloadAllAttachments = function () {
        window.location.href = API_CONFIG.baseUrl + '/Compliance/Inform/Template/' + $routeParams.templateId + '/DownloadAllAttachments' + '?Authorization=' + sessionStorage.oas_token;
    };

    const deleteSubmission = () => {
        const row = selectedRows[0];
        const rowId = row.id;

        $http.delete('/Compliance/Inform/Documents/' + rowId, { trackerMsg: 'Deleting Submission' })
            .then(response => {
                if (response.data) {
                    $scope.$broadcast('event:inform-tasks-reload', { action: 'delete-item', item: selectedRows[0]});
                }
            });
    }

    //PUBLIC METHODS

    $scope.exportDetailsToExcel = function () {
        $scope.$broadcast('event:inform-tasks-reload', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function(){
        $scope.openTemplateDialog();
    };

    $scope.refreshGrid = function() {
        $scope.$broadcast('event:inform-tasks-reload', {action: 'refresh-grid'});
    };

    $scope.openTemplateDialog = function(){
        if(selectedRows.length === 1){
            openTemplateDialog(selectedRows[0]);
        }
    };

    $scope.sendFollowUpEmail = function(){
        let toName = selectedRows.length === 1 ? selectedRows[0].fullName : null;
        $dialog.dialog({templateUrl: "tools/compass/inform/modal/email-dialog.html",controller: "EmailDialogCtrl", templateType: 0 /*Task*/, parentObject: selectedRows, email: null, emailToName: toName, dialogClass: 'modal wide'})
            .open()
            .then(function (response) {
                if(response){
                    $scope.$broadcast('event:inform-tasks-reload', {action: 'refresh-grid'});
                }

            });
    };

    $scope.viewAccessPersonDetail = function(){
        if(selectedRows.length === 1){
            const path = '/tools/compass/inform/accessPerson/'+  selectedRows[0].accessPersonId;
            $location.path(path);
        }
    };

    $scope.massUpdateApprove = function(){
        massUpdateStatus(informWorkflowStatus.approved);
    };

    $scope.massUpdateDeny = function(){
        massUpdateStatus(informWorkflowStatus.denied);
    };

    $scope.handleDeleteSubmission = () => {
        
        $dialog.messageBox("Delete Submission", "Are you sure you want to remove this? It is not retrievable once deleted.", [{
            result: true,
            label: 'Yes',
            focus: true,
            cssClass: "btn-primary pull-right"
        }, { result: false, label: 'No', focus: false, cssClass: "pull-left" }])
            .open()
            .then((msgBoxAnswer) => {
                if (msgBoxAnswer) {
                    deleteSubmission();
                }
            });
    };

    $scope.$on('event:tasks-detail-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        const propertyMap = {
            id: ["id"],
            accessPersonId: ["accessPersonId"]
        };

        Object.each(args[0], function (key, value) {
            let searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });

        $scope.current.canMassUpdateApprove = false;
        $scope.current.canMassUpdateDeniedOrClose = false;
        $scope.current.showDropDown = true;
        if(selectedRows.length > 1) {
            let isAllApprove = selectedRows.every((val)=>{
                return val.status === 'Approved';
            });

            let isAllDenied = selectedRows.every((val)=>{
                return val.status === 'Denied';
            });

            let isNotApproveOrDenied = selectedRows.every((val)=>{
                return val.status !== 'Denied' && val.status !== 'Approved';
            });

            let hasMassUpdateRight = adminDocumentsService.canMassUpdate(selectedRows) && $oasRights.forCode("COMPLIANCEADMINONLY");

            $scope.current.canMassUpdateApprove = hasMassUpdateRight && isAllDenied || isNotApproveOrDenied;
            $scope.current.canMassUpdateDeniedOrClose = hasMassUpdateRight && isAllApprove || isNotApproveOrDenied;
            $scope.current.showDropDown = $scope.current.canMassUpdateApprove || $scope.current.canMassUpdateDeniedOrClose
        }
    });

    //INITIALIZE
    const currentUserDetailId = $rootScope.user.authorization.userDetailId;
    $scope.accessPerson = decodeURIComponent($routeParams.accessPerson);
    $scope.accessPersonId = $routeParams.accessPersonId;
    $scope.views = [config];
    $scope.selectedIds = [];
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.editMode = $scope.rightsCompassInform.canEdit;
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: "/Compliance/Inform/Documents/" + $routeParams.templateId + "/" + config.dataQueryCacheKey,
        view: $scope.views[0],
        editMode: false,
        gridQueries: [],
        dataQueryCacheKey: null,
        dataQueryId: 0,
        dataQueryTitle: '',
        dataQueryEntity: null,
        returnData: null,
        filename: null,
        canMassUpdateApprove: false,
        canMassUpdateDeniedOrClose: false,
    };
    $scope.complianceAdminOnly = $oasRights.forCode("COMPLIANCEADMINONLY");
    init();
});

adminTaskDetailCtrl.loadAdminTaskDetailCtrl = ["$http","$route", function ($http,$route) {
    let url = "/Compliance/Inform/Documents/" + $route.current.params.templateId;
    if($route.current.params.accessPersonId){
        url += "?accessPersonId=" + $route.current.params.accessPersonId
    }

    return $http.get(url, {trackerMsg: 'Loading submission details'})
        .then(function (response) {
            return response.data;
        });
}];

'use strict';

app.controller('TradeViolationDetailCtrl', function TradeViolationDetailCtrl($scope, $http, $oasRights, views, $dialog, API_CONFIG,$location,$routeParams, $rootScope ) {

    //PRIVATE VARIABLES
    let selectedRows;

    //PRIVATE METHODS
    function init (){
        if($scope.ruleType){
            const path = $location.path();
            $scope.addBreadcrumb($scope.ruleType.titleize(), path);
        }
    }

    function openTradeViolationDialog(){
        let thisRow = selectedRows[0];
        if(currentUserDetailId === thisRow.userDetailId){
            $dialog.messageBox("Access Denied", "You are not able to review your own trade violations.").open();
        } else {
            $dialog.dialog({templateUrl: "tools/compass/inform/modal/trade-violation-dialog.html", controller: "TradeViolationDialogCtrl", tradeViolation: angular.copy(thisRow), dialogClass: 'modal wide'})
                .open()
                .then(function (response) {
                    if (response) {
                        Object.merge(thisRow, response);
                        $scope.$broadcast('event:trade-violation-detail-reload', {action: 'upsert-items', items: [thisRow]});
                    }

                });
        }
    }

    //PUBLIC METHODS

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:trade-violation-detail-reload', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function(){
        openTradeViolationDialog();
    };

    $scope.refreshGrid = function() {
        $scope.$broadcast('event:trade-violation-detail-reload', {action: 'refresh-grid'});
    };

    $scope.openTradeViolation = function(){
        openTradeViolationDialog();
    };

    $scope.sendFollowUpEmail = function(){
        const toName = selectedRows.length === 1 ? selectedRows[0].fullName : null;
        $dialog.dialog({templateUrl: "tools/compass/inform/modal/email-dialog.html",controller: "EmailDialogCtrl", templateType: 4 /*Exception*/, parentObject: selectedRows, email: null, emailToName: toName, dialogClass: 'modal wide'})
            .open()
            .then(function (response) {
                if(response){
                    $scope.$broadcast('event:trade-violation-detail-reload', {action: 'refresh-grid'});
                }
            });
    };

    $scope.viewAccessPersonDetail = function(){
        if(selectedRows.length === 1){
            const path = '/tools/compass/inform/accessPerson/'+  selectedRows[0].accessPersonId;
            $location.path(path);
        }
    };

    $scope.addOutcome = function(){
        $dialog.dialog({
            templateUrl: "tools/compass/inform/modal/closed-with-outcome-dialog.html",
            controller: "ClosedWithOutcomeCtrl",
            selectedIds: $scope.selectedIds,
            dialogClass: 'modal'
        })
        .open()
        .then(res => {
            if(res){
                $scope.$broadcast('event:trade-violation-detail-reload', {action: 'refresh-grid'});
            }
        });
    };

    $scope.$on('event:trade-violation-detail-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        const propertyMap = {
            id: ["id"],
            accessPersonId: ["accessPersonId"]
        };

        Object.each(args[0], function (key, value) {
            const searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
    });

    //INITIALIZE
    const currentUserDetailId = $rootScope.user.authorization.userDetailId;
    $scope.accessPerson = {
        id: $routeParams.accessPersonId,
        fullName: $routeParams.accessPersonId ? decodeURIComponent($routeParams.fullName) : ''
    }
    $scope.outcomeList = [
        {id:1,name:"Verbal Warning"},
        {id:2, name:"Written Warning"},
        {id:3, name:"Loss of Trading Privileges"},
        {id:4, name:"Termination"},
        {id:6, name:"Other"},
        {id:5, name:"False Positive"}];
    $scope.ruleType = $routeParams.ruleType;
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.editMode = $scope.rightsCompassInform.canUpdate;
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: $scope.accessPerson.id ? "/Compliance/Inform/TradeViolations/V2/AccessPerson/" + $scope.accessPerson.id : "/Compliance/Inform/TradeViolations/V2?ruleType=" + $routeParams.ruleType,
        view: views[0],
        editMode: false,
        gridQueries: []
    };
    init();


});


'use strict';

app.controller('AdminProductMonitoringHistoryCtrl', function AdminProductMonitoringHistoryCtrl($scope, $http) {

    //PRIVATE VARIABLES

    //PRIVATE METHODS
    function init() {
        $http.get('/Compliance/Inform/MonitoredProductsHistory', {
            cache: false,
            trackerMsg: 'Loading monitored product history'
        })
            .then(function (response) {
                $scope.current.history = response.data.map((item)=>{
                    switch(item.changeType){
                        case 'I':
                            item.changeType = 'Insert';
                            break;
                        case 'D':
                            item.changeType = 'Delete';
                            break;
                        case 'U':
                            item.changeType = 'Update';
                            break;
                    }
                    return item;
                });
                $scope.current.assetClassHistory = filterForAssetClass();
                $scope.current.productHistory = filterForProduct();
            });

    }

    function filterForAssetClass() {
        return $scope.current.history.filter((item) => {
            return item.entityType === 'Asset Class';
        })
    }

    function filterForProduct() {
        return $scope.current.history.filter((item) => {
            return item.entityType === 'Product';
        })
    }

    //PUBLIC METHODS
    $scope.sort = function (field,historyType) {
        if(field ==='assetClass' || field === 'product') {
            field = 'entityName';
        }
        if(historyType === $scope.historyType.asset) {
            $scope.assetSort.desc = $scope.assetSort.field === field ? !$scope.assetSort.desc : false;
            $scope.assetSort.field = field;
        }

        if(historyType === $scope.historyType.product){
            $scope.productSort.desc = $scope.productSort.field === field ? !$scope.productSort.desc : false;
            $scope.productSort.field = field;
        }
    };

    $scope.exportAssetsToExcel = function() {

        let exportData = $scope.current.assetClassHistory.map((element)=>{
                return {
                    entityName:element.entityName,
                    changeType:element.changeType,
                    changeDate:element.auditedDate,
                    changeBy:element.auditedByDisplay,
                    autoDeny:element.autoDeny? 'Deny':'Approve',
                    startDate:element.startDate,
                    endDate:element.endDate,
                };
        });

        const dataDetails = {
            columns: [
                {name: "Asset Class", field: "entityName"},
                {name: "Change Type", field: "changeType"},
                {name: "Change Date", field: "changeDate"},
                {name: "Change By", field: "changeBy"},
                {name: "Approve/Deny", field: "autoDeny"},
                {name: "Start", field: "startDate"},
                {name: "End", field: "endDate"},
            ],
            data: exportData
        };

        $http.post('/Utility/SlickGridExport/csv', dataDetails, {trackerMsg: 'Exporting grid'})
            .then(function (response) {
                window.location.href = response.headers("location") + "?Authorization=" + sessionStorage.oas_token;
            });
    };

    $scope.exportProductsToExcel = function() {

        let exportData = $scope.current.productHistory.map((element)=>{
            return {
                entityName:element.entityName,
                changeType:element.changeType,
                changeDate:element.auditedDate,
                changeBy:element.auditedByDisplay,
                autoDeny:element.autoDeny? 'Deny':'Approve',
                startDate:element.startDate,
                endDate:element.endDate,
            };
        });

        const dataDetails = {
            columns: [
                {name: "Product", field: "entityName"},
                {name: "Change Type", field: "changeType"},
                {name: "Change Date", field: "changeDate"},
                {name: "Change By", field: "changeBy"},
                {name: "Approve/Deny", field: "autoDeny"},
                {name: "Start", field: "startDate"},
                {name: "End", field: "endDate"},
            ],
            data: exportData
        };

        $http.post('/Utility/SlickGridExport/csv', dataDetails, {trackerMsg: 'Exporting grid'})
            .then(function (response) {
                window.location.href = response.headers("location") + "?Authorization=" + sessionStorage.oas_token;
            });
    };

    //INITIALIZE
    $scope.assetColumns = ['assetClass', 'changeType', 'auditedDate', 'auditedByDisplay','autoDeny','startDate','endDate'];
    $scope.assetSort = {field: 'assetClass', desc: true};
    $scope.assetFilter = {};
    $scope.productColumns = ['product', 'changeType', 'auditedDate', 'auditedByDisplay','autoDeny','startDate','endDate'];
    $scope.productSort = {field: 'product', desc: true};
    $scope.productFilter = {};
    $scope.current = {
        history: [],
        productHistory: [],
        assetClassHistory: [],
    };
    $scope.historyType = {
        asset:"asset",
        product:"product"
    };
    init();

});


'use strict';

app.controller('AdminTradeRulesCtrl', function AdminTradeRulesCtrl($scope, $http, $oasRights, $location, $dialog) {

    //PRIVATE VARIABLES
    let onRouteChangeOff;
   

    //PRIVATE METHODS
    function init() {
        loadTradeRules();
    }

    function loadTradeRules(){
        $http.get('/Compliance/Inform/Rules', {cache: false, trackerMsg: 'Loading trade rules'})
            .then(function (response) {
                updateRouteChangeValues(response.data);
                loadAssetClasses();
                splitLists();
            });

        //this turns on/off the watch for listening for route change.
        onRouteChangeOff = $scope.$on("$routeChangeStart", routeChange);
    }

    function splitLists() {
        $scope.preTradeRules = $scope.tradeRules.rules.filter(function (e) {
            return e.recordType === "Pre-Clearance";
        });

        $scope.postTradeRules = $scope.tradeRules.rules.filter(function (e) {
            return e.recordType === "Post Trade";
        });

        $scope.preclearanceRules = $scope.tradeRules.rules.find(e => e.preclearanceRules !== null)

        filterMonitoredProducts();
    }

    function filterMonitoredProducts(){
        $scope.productMatching = $scope.tradeRules.monitoredProducts.filter(function (e) {
            return e.entityType === "Product";
        });

        $scope.assetClassMatching = $scope.tradeRules.monitoredProducts.filter(function (e) {
            return e.entityType === "Asset Class";
        });
    }

    function loadAssetClasses() {
        if ($scope.assetClasses) return;

        $http.get("/Portfolio/ProductClasses", {trackerMsg: 'Loading asset classes'})
            .then(function (response) {
                $scope.assetClasses = response.data.sortBy("description");
            });
    }

    function updateRouteChangeValues(data){
        $scope.tradeRules = data;
        $scope.originalTradeRules = angular.copy($scope.tradeRules);
    }

    function routeChange(event, newUrl, oldUrl) {
        if (angular.equals($scope.tradeRules, $scope.originalTradeRules)) return;

        $dialog.messageBox("Unsaved Changes", "Are you sure you want to leave your changes unsaved?", [{
            result: true,
            label: 'Yes',
            focus: true,
            cssClass: "btn-primary pull-right"
        }, {result: false, label: 'No', focus: false, cssClass: "pull-left"}])
            .open()
            .then((msgBoxAnswer) => {
                if (msgBoxAnswer) {
                    onRouteChangeOff(); //Stop listening for location changes
                    $location.path(newUrl.originalPath); //Go to page they're interested in
                }
            });

        event.preventDefault();
    }

    const validateFrontRunningDays = () => {
        let rule = $scope.tradeRules.rules.find(r => r.informRuleType === 'Front Running');

        if (rule.isActive) {
            if (!rule.frontRunningRule.daysBefore) {
                rule.frontRunningRule.daysBefore = 0;
            }

            if (!rule.frontRunningRule.daysAfter) {
                rule.frontRunningRule.daysAfter = 0;
            }

            if (rule.frontRunningRule.daysBefore === 0 && rule.frontRunningRule.daysAfter === 0) {
                $dialog.actionFailed("For Front Running, please choose at least 1 day before or 1 day after, or turn off the Front Running rule. The minimum number is 0 and the maximum is 31.")
                    .open();
                return false;
            }
        }
        return true;
    }

    //PUBLIC METHODS
    $scope.saveRule = function () {
        $scope.tradeRules.monitoredProducts = angular.copy($scope.productMatching);
        $scope.tradeRules.monitoredProducts.insert(angular.copy($scope.assetClassMatching));
        let isValidFrontRunning = validateFrontRunningDays();

        if (!isValidFrontRunning) {
            return;
        }

        $http.put('/Compliance/Inform/Rules', $scope.tradeRules, {cache: false, trackerMsg: 'Updating trade rules'})
            .then(function (response) {
                $scope.tradeRules = response.data;
                splitLists();
                $scope.originalTradeRules = angular.copy($scope.tradeRules);
            });
    };

    $scope.getTradeHelpText = function (ruleType, prePost) {
        if (prePost === 'pre') {
            return {
                "IPO": "Pre-clearance request where the access person has checked the IPO box will be automatically denied.",
                "Short Sale": "Pre-clearance request for short sales will be automatically denied when the holdings do not cover the sale and the list contains one of the products in the list.",
                "De Minimis": "Pre-clearances that meet the requirements will be automatically approved."
            }[ruleType];
        }
        return {
            "De Minimis": "Trade violations for transactions that meet these requirements will be automatically closed.",
            "Pre-Clearance": "Trade violations will be generated for all trades that do not have an approved pre-clearance.",
            "Front Running": "",
            "30 Day Round Trip": "Trade violations will be generated when an access person trades in and out of the same stock in a 30 day time frame.",
        }[ruleType];
    };

    $scope.addAssetClass = function (assetList, asset) {

        const existingAsset = assetList.find({entityId: asset.id});

        if (existingAsset) {
            $scope.current.newAsstClass = assetList[0];
            return;
        }

        const newAsset = {
            entityId: asset.id,
            entityType: 81,
            autoDeny: true,
            entityName: asset.description,
            assetCategory: asset.category,
            assetProvider: asset.productDescriptionProviderName,
            startDate: Date.create($scope.today).format('{MM}-{dd}-{yyyy}')
        };

        assetList.insert(newAsset, 0);
        $scope.current.newAsstClass = assetList[0];

    };


    $scope.addShortSaleProduct = function (productList, product) {

        if (!productList.shortSaleProducts) {
            productList.shortSaleProducts = [];
        }

        const existingProduct = productList.shortSaleProducts.find({entityId: product.productId});

        if (existingProduct) {
            $scope.current.shortSaleProduct = null;
            return;
        }

        const newProduct = {
            id: product.productId,
            productName: product.productName,
            ticker: product.ticker
        };

        productList.shortSaleProducts.insert(newProduct, 0);
        $scope.current.shortSaleProduct = null;

    };

    $scope.addNewProduct = function (productList, product) {
        const existingProduct = productList.find({entityId: product.productId});

        if (existingProduct) {
            $scope.current.newProduct = null;
            return;
        }

        const newProduct = {
            entityId: product.productId,
            entityType: 9,
            autoDeny: true,
            entityName: product.ticker + '(' + product.productName + ')',
            startDate: Date.create($scope.today).format('{MM}/{dd}/{yyyy}')
        };

        productList.insert(newProduct, 0);
        $scope.current.newProduct = null;
    };

    $scope.deleteProduct = function (list, product) {
        if (!product) {
            return;
        }

        list.remove(product);
    };

    $scope.importMonitoredProducts = function () {
        $dialog.dialog({
            dialogClass: "modal medium",
            templateUrl: "app/modals/upload-file.html",
            controller: "UploadFileCtrl",
            title: "Upload Monitored Products",
            idField: "entityId",
            downloadUrl: '/Compliance/Inform/ValidateImport/ProductMonitoring/Templates/',
            validateUrl: '/Compliance/Inform/ValidateImport/ProductMonitoring',
            commitVerb: 'PUT',
            commitUrl: '/Compliance/Inform/ValidateImport/ProductMonitoring/Import',
            exportUrl: '/Compliance/Inform/ValidateImport/ProductMonitoring/ExportErrors',
            returnNewModel: true
        })
            .open()
            .then(function(monitoredList){
                $scope.tradeRules.monitoredProducts = monitoredList.data;
                filterMonitoredProducts();
            });
    };

    //INITIALIZE
    $scope.current = {
        shortSaleProduct: null,
        newProduct: null,
        current: null
    };
    $scope.today = Date.now();
    $scope.assetClassFieldMap = [{name: "ID", value: "id"}, {name: "Name", value: "name"}, {
        name: "Description",
        value: "description"
    }, {name: "Category", value: "category"}, {name: "Provider", value: "productDescriptionProviderName"}];
    $scope.canSaveRule = false;
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.editMode = $scope.rightsCompassInform.canUpdate;
    $scope.manualApproveDeny = [{value: "Manual Review", name: "Manual Review"}, {value: "Auto-Deny", name: "Auto-Deny"}];
    $scope.autoApproveDeny = [{value: "Auto-Approve", name: "Auto-Approve"}, {value: "Auto-Deny", name: "Auto-Deny"}];
    $scope.defaultDropdown = [{value: true, name: "Auto-Approve"}, {value: false, name: "Manual Review"}];
    $scope.originalTradeRules = {};
    init();

});


app.controller('AdminConnectionDetailCtrl', function AdminConnectionDetailCtrl($http, $scope, $routeParams, views, $dialog, $location) {

    //PRIVATE METHODS
    let selectedRows;


    //PUBLIC METHODS
    $scope.refreshSlickGrid = function() {
        $scope.$broadcast('event:connection-detail-reload', {action: 'refresh-grid'});
    };

    $scope.exportGridToExcel = function () {
        $scope.$broadcast('event:connection-detail-reload', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function(){
        $scope.viewAccessPersonDetail();
    };

    $scope.viewAccessPersonDetail = function(){
        var thisRow = selectedRows[0];
        const path = "/tools/compass/inform/accessPerson/"+  thisRow.accessPerson.id;
        $location.path(path);
    };


    $scope.$on('event:connection-detail-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        const propertyMap = {
            id: ["id"]
        };

        Object.each(args[0], function (key, value) {
            const searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
    });

    $scope.$on('slickgrid-getfiltered', function(event, data){

        const dueDate = Date.create($scope.current.dueDate).format('{MM}-{dd}-{yyyy}');

        $http.post('/Compliance/Inform/Distribute/' + templateId + '/' + dueDate,  data, {cache: true, trackerMsg: 'Saving questionnaire'})
            .then(function () {
                $dialog.messageBox("Next", "What would you like to do next?", [{result: true, label: 'View Questionnaires', focus: true, cssClass:"btn-primary pull-right"}, {result: false, label: 'Distribute More', focus: false, cssClass:"pull-left"}])
                    .open()
                    .then(function(result){
                        if (result) {
                            const url = "#/tools/compass/inform/questionnaires";
                            window.location.replace( url );
                        }
                    });
            });

    });

    //PRIVATE VARIABLES
    const today = Date.create();
    const templateId = $routeParams.templateId;
    const url = "/Compliance/Inform/Connections/V2/Broken";

    //INITIALIZE
    $scope.selectedRows = [];
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: url,
        view: views[0],
        editMode: false,
        gridQueries: [],
        dueDate: today.addDays(30)
    };
});

'use strict';

app.controller('AdminHistoricalDocumentsCtrl', function AdminHistoricalDocumentsCtrl($scope, $http, $oasRights, views, $dialog, API_CONFIG, $routeParams) {

    //PRIVATE VARIABLES
    let selectedRows;

    //PRIVATE METHODS
    const documentDialog = (document) => {
        $dialog.dialog({
            templateUrl: "tools/compass/inform/modal/historical-document-dialog.html",
            controller: "HistoricalDocumentDialogCtrl",
            informDocument: document,
            dialogClass: 'modal'
        })
        .open()
        .then(res => {
            if(res){
                $scope.$broadcast('event:inform-historical-documents-reload', {action: 'refresh-grid', items: [res]});
            }
        });
        $scope.refreshGrid();
    };

    //PUBLIC METHODS
    $scope.addHistoricalDoc = () => {
        documentDialog(null);
    };

    $scope.openHistoricalDocDialog = () => {
        documentDialog(angular.copy(selectedRows[0]));
    };

    $scope.slickGridDoubleClick = () => {
        if (selectedRows.length === 1) {
            $scope.openHistoricalDocDialog();
        }
    };

    $scope.downloadDocument = () => {
        if (selectedRows.length === 1) {
            window.location.href = API_CONFIG.baseUrl + '/Compliance/Inform/HistoricalDocuments/Download/HistoricalDocuments/' + selectedRows[0].id + '?Authorization=' + sessionStorage.oas_token;
        }
    };

    $scope.refreshGrid = () => {
        $scope.$broadcast('event:inform-historical-documents-reload', { action: 'refresh-grid' });
    };

    $scope.exportToExcel = () => {
        $scope.$broadcast('event:inform-historical-documents-reload', { action: 'export-data' });
    };


    $scope.$on('event:inform-historical-documents-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        const propertyMap = {
            id: ["id"],
            fileName: ["fileName"],
        };

        Object.each(args[0], function (key, value) {
            let searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
    });

    $scope.deleteItem = () => {
        if (selectedRows.length !== 1) {
            return;
        }
        let thisDocument = angular.copy(selectedRows[0]);
        const trackerMsg = 'Deleting Historical Document';
        const heading = 'Delete Historical Document';
        const message = 'Are you sure you want to delete this document?';

        $dialog.messageBox(heading, message, [{ result: true, label: 'Delete', focus: true }, { result: false, label: 'Cancel', focus: true }])
            .open()
            .then(res => {
                if (res) {
                    const documentId = thisDocument.id;
                    $http.delete('/Compliance/Inform/HistoricalDocuments/' + documentId, { trackerMsg: trackerMsg })
                        .then(res => {
                            if (res) {
                                $scope.refreshGrid();
                            }
                        });
                }
            });
    }

    //INITIALIZE
    $scope.accessPerson = {
        id: $routeParams.accessPersonId,
        fullName: $routeParams.accessPersonId ? decodeURIComponent($routeParams.fullName) : ''
    }
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.editMode = $scope.rightsCompassInform.canUpdate;
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: `/Compliance/Inform/HistoricalDocuments${$scope.accessPerson.id ? '/AccessPerson/' + $scope.accessPerson.id : ''}`,
        view: views[0],
        editMode: false,
        gridQueries: []
    };
});


'use strict';
app.controller('HistoricalDocumentDialogCtrl', function HistoricalDocumentDialogCtrl($http, $scope, dialog, API_CONFIG ) {

    //PRIVATE VARIABLES

    //PRIVATE METHODS
    const init = () => {
        getAccessPersons();
    }

    // used to fill access person drop down menu
    const getAccessPersons = () => {
        $http.get('/Compliance/Inform/AccessPersons/Access%20Person%20All?isActive=true')
        .then(res => {
            if (res) {
               res.data.forEach(ap => {
                   let accessPerson = {
                       id: ap.id,
                       name: `${ap.personal.firstName} ${ap.personal.lastName}`
                   }
                   $scope.accessPersonList.push(accessPerson);
               });
            }
        })
    }

    const convertToDate = (startDate, endDate) => {
        if (startDate) {
            $scope.historicalDocument.startDate = Date.create(startDate).format('{MM}/{dd}/{yyyy}');
        }
        if (endDate) {
            $scope.historicalDocument.endDate = Date.create(endDate).format('{MM}/{dd}/{yyyy}');
        }
    }

    //PUBLIC METHODS

    $scope.downloadDocument = function (id) {
        window.location.href = API_CONFIG.baseUrl + '/Compliance/Inform/HistoricalDocuments/Download/HistoricalDocuments/' + id + '?Authorization=' + sessionStorage.oas_token;
    };

    $scope.cancel = () => {
        dialog.close();
    };

    $scope.missingRequiredFields = () => {
        if ($scope.historicalDocument.id && !$scope.historicalDocument.description) {
            return true;
        }

        if (!$scope.historicalDocument.id && (!$scope.historicalDocument.description ||
            !$scope.historicalDocument.file)) {
            return true;
        };
    }

    $scope.submit = () => {
        if ($scope.missingRequiredFields()) {
            return;
        }
        $scope.submitIsDisabled = true;

        var url = '/Compliance/Inform/HistoricalDocuments' +
            ($scope.historicalDocument.id ? `/${$scope.historicalDocument.id}` : '');

        convertToDate($scope.historicalDocument.startDate, $scope.historicalDocument.endDate)

        if ($scope.current.returnData) {
            $scope.$broadcast('event:historical-document-upload-file-action', {action: 'upload-file', url: url});
            $scope.current.sent = true;
        }
        else {
            if ($scope.historicalDocument.id) {
                $http.put(url, $scope.historicalDocument, { trackerMsg: 'Saving Historical Document' })
                    .then(res => {
                        $scope.$broadcast('event:inform-historical-documents-reload', { action: 'refresh-grid' })
                        dialog.close(res.data);
                    });
            } else {
                $http.post(url, $scope.historicalDocument, { trackerMsg: 'Saving Historical Document' })
                    .then(res => {
                        $scope.$broadcast('event:inform-historical-documents-reload', { action: 'refresh-grid' })
                        dialog.close(res.data);
                    });
            }

        }
        
    }

    $scope.logChange = () => {
        console.log($scope.historicalDocument)
    }

     //SCOPE WATCHERS
    $scope.$watch("current.returnData", function () {
        if ($scope.current.sent) {
            dialog.close($scope.current.returnData);
        }
    });

    //INITIALIZE
    $scope.historicalDocument = dialog.options.informDocument ?
        dialog.options.informDocument : {};
    $scope.current = {
        method: $scope.historicalDocument.id ? 'PUT' : 'POST',
        returnData: null
    };
    $scope.accessPersonList = [];
    $scope.submitIsDisabled = false;
    init();
});

'use strict';
app.controller('PolicyDialogCtrl', function PolicyDialogCtrl($http, $scope, dialog, API_CONFIG ) {

    //PRIVATE VARIABLES
    let currentIsVisibleStatus;

    //PRIVATE METHODS
    function init(){
        $scope.informPolicy.documents.forEach((doc)=>{
            doc.effectiveDate = doc.effectiveDate.substr(0,10);
        });
    }

    //PUBLIC METHODS
    $scope.downloadPolicy = function(id){
        window.location.href = API_CONFIG.baseUrl + '/Compliance/Inform/Policy/Download/' + id + '?Authorization=' + sessionStorage.oas_token;
    };

    $scope.cancel = function(){
        dialog.close();
    };

    $scope.missingRequiredFields = function () {
        if($scope.informPolicy.isVisible) {
            if($scope.informPolicy.documents.length === 0 && !$scope.informPolicy.file) {
                return true;
            }
        }
        if(!$scope.informPolicy.policyName) {
            return true;
        } 
    };

    $scope.submit = function () {
        if($scope.missingRequiredFields()){
            return;
        }
        
        let trackerMsg = !$scope.informPolicy.libraryType ? 'Saving item' : 'Saving ' + $scope.informPolicy.libraryType;
        var url = "/Compliance/Inform/Policy";
        $scope.informPolicy.newEffectiveDate = Date.create($scope.current.newEffectiveDate).format('{MM}/{dd}/{yyyy}');

        if ($scope.current.returnData) {
            $scope.$broadcast('event:policy-upload-file-action', {action: 'upload-file', url: url});
            $scope.current.sent = true;
        } else {
            if (!$scope.informPolicy.isActive) {
                $scope.informPolicy.isVisible = false;
            }

            if($scope.informPolicy.id){
                $http.put(url, $scope.informPolicy, {trackerMsg: trackerMsg})
                    .then(function (response) {
                        dialog.close(response.data);
                    });
            } else{
                $http.post(url, $scope.informPolicy, {trackerMsg: trackerMsg})
                    .then(function (response) {
                        dialog.close(response.data);
                    });
            }
        }
    };

    $scope.handleIsActiveChange = () => {
        $scope.informPolicy.isVisible = $scope.informPolicy.isActive ? currentIsVisibleStatus : false;
    };

    //SCOPE WATCHERS
    $scope.$watch("current.returnData", function () {
        if ($scope.current.sent) {
            dialog.close($scope.current.returnData);
        }
    });


    //INITIALIZE
    $scope.informPolicy =  dialog.options.informPolicy ?
        dialog.options.informPolicy : {
        policyName: null,
        isActive: true,
        isVisible: null,
        libraryType: null,
        documents: [],
        newEffectiveDate :null
        };
    $scope.current = {
        returnData: null,
        sent: false,
        fileName: null,
        method: $scope.informPolicy.id? 'PUT' : 'POST',
        newEffectiveDate : Date.create().format('{MM}/{dd}/{yyyy}')
    };
    $scope.fileType = [
        { value: 'Policy', name: 'Policy' }, 
        { value: 'Manual', name: 'Manual' }, 
        { value: 'Form', name: 'Form' }
    ];
    currentIsVisibleStatus = angular.copy($scope.informPolicy.isVisible);
    init();
});

'use strict';

app.controller('AdminTemplateDialogCtrl', function AdminTemplateDialogCtrl($scope, $http, $oasRights, dialog, $dialog) {

    //PRIVATE VARIABLES

    //PRIVATE METHODS
    function init() {
        $http.get('/Compliance/Inform/Affirmations', {cache: true, trackerMsg: 'Loading affirmation options'})
            .then(function (response) {
                $scope.affirmationOptions = response.data.filter(function (e) {
                    return e.isActive === true
                });
            });

        $http.get('/Compliance/Inform/Policy?isActive=true&isVisible=true', {cache: false, trackerMsg: 'Loading library documents'})
            .then(function (response) {
                $scope.policyOptions = response.data;
            });

        $http.get('/Compliance/Inform/Template/QuestionTypes/Simple?adminOnly=true', {cache: true, trackerMsg: 'Loading question types'})
            .then(function (response) {
                $scope.formatOptions =  response.data.map(function (q) {
                    return q.name;
                });
            });

        loadTemplate();
    }

    function loadTemplate(){
        if (dialog.options.copyFromId || $scope.thisTemplate.id ) {
            const url = (dialog.options.copyFromId) ? '/Compliance/Inform/Template/Clone/' + dialog.options.copyFromId : '/Compliance/Inform/Template/' + $scope.thisTemplate.id;
            $http.get(url, {cache: false, trackerMsg: 'Loading template'})
                .then(function (response) {
                    $scope.thisTemplate = response.data;
                    if (!$scope.thisTemplate.questions) {
                        $scope.addQuestion();
                    }
                    $scope.thisTemplate.questions.forEach(function (question) {
                        setAffirmation(question);
                    });
                    $scope.thisTemplate.questions.forEach(function (question) {
                        setPolicyType(question);
                    });
                });
        } else {
            $scope.thisTemplate = $scope.emptyTemplate;
            numberQuestions();
        }
    }

    function setAffirmation(question) {
        if (question.affirmation) {
            question.affirmation = $scope.affirmationOptions.find({id: question.affirmation.id});
        }
    }

    function setPolicyType(question) {
        if (question.policy) {
            question.policy = $scope.policyOptions.find({id: question.policy.id});
        }
    }

    function numberQuestions() {
        if(!$scope.thisTemplate.questions){
            return;
        }

        let idx = 1;
        $scope.thisTemplate.questions.sortBy('questionNumber').forEach(function (question) {
            question.questionNumber = idx;
            idx++;
        });
    }

    function findDocumentAnswers(answers, questions) {
        for (let obj of questions) {
            let answer = {
                questionNumber: obj.questionNumber,
                questionText: obj.questionText,
                questionType: obj.questionType,
                questionOptions: [],
                answer: null,
            };
            if (obj.options) {
                for (let opt of obj.options) {
                    let option = {
                        optionSequence: opt.optionSequence,
                        optionQuestion: opt.optionText,
                        optionText: opt.optionText,
                        id: opt.$$hashKey,
                        childAnswer: {},
                    };
                    if (opt.childQuestion) {
                        //go find more questions to turn into answers
                        findChildDocumentAnswers(option.childAnswer, opt.childQuestion);
                    }
                    answer.questionOptions.push(option);
                }
            }
            answers.push(answer);
        }
    }

    function findChildDocumentAnswers(childAnswer, question) {
        childAnswer.questionNumber = question.questionNumber;
        childAnswer.questionText = question.questionText;
        childAnswer.questionType = question.questionType;
        childAnswer.questionOptions = [];
        childAnswer.answer = null;

        if (!question.options) {
            return;
        }

        for (let opt of question.options) {
            let option = {
                optionSequence: opt.optionSequence,
                optionQuestion: opt.optionText,
                optionText: opt.optionText,
                id: opt.$$hashKey,
                childAnswer: {}
            };
            childAnswer.questionOptions.push(option);
            if (opt.childQuestion) {
                //go find more questions to turn into answers
                findChildDocumentAnswers(option.childAnswer, opt.childQuestion);
            }
        }
    }

    //PUBLIC METHODS
    $scope.missingRequiredFields = function () {
        if (!$scope.thisTemplate.templateName) return true;
        if (!$scope.thisTemplate.questions) $scope.thisTemplate.questions = [];

        let missing = false;
        $scope.thisTemplate.questions.forEach(function (question) {
            if (!question.questionText) {
                $scope.focusQuestionText = true;
                missing = true;
            }
            if (question.showTransactionHistory && (question.transactionStartDate == null || question.transactionEndDate == null)) {
                $scope.focusQuestionText = true;
                missing = true;
            }
            if (question.showTransactionHistory && question.transactionStartDate > question.transactionEndDate) {
                $scope.focusQuestionText = true;
                missing = true;
            }
            if(question.options) {
                question.options.forEach(function (option) {
                    if (!option.optionText) {
                        missing = true;
                    }
                });
            }
        });
        return missing;
    };

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.preview = () => {
        let previewDocument = {
            id:0,
            documentStatus:"New",
            answers: [],
            informTemplateId: -1,
            name: $scope.thisTemplate.templateName
        };
        findDocumentAnswers(previewDocument.answers, $scope.thisTemplate.questions);

        const options = {
            templateUrl: "tools/inform/modal/inform-questionnaire-dialog.html",
            controller: "InformQuestionnaireDialogCtrl",
            id: null,
            templateId: $scope.thisTemplate.id,
            dialogClass: 'edit-pane',
            previewDocument: previewDocument,
        };

        $dialog.dialog(options)
            .open();
    };

    $scope.submit = function () {
        if ($scope.missingRequiredFields()) {
            return true;
        } else {
            const verb = $scope.thisTemplate.id > 0 ? 'PUT' : 'POST';
            $http({method: verb, url: '/Compliance/Inform/Template', data: $scope.thisTemplate, trackerMsg:  'Saving template'})
                .then(function (response) {
                    dialog.close(response.data);
                });
        }
    };

    $scope.addQuestion = function () {
        const questionCount = $scope.thisTemplate.questions.length;
        const newQuestion = angular.copy($scope.newQuestion);
        newQuestion.questionNumber = questionCount + 1;
        $scope.thisTemplate.questions.push(newQuestion);
        $scope.focusQuestionText = true;
        $scope.focusOption = false;
    };

    $scope.removeQuestion = function (question) {
        $scope.thisTemplate.questions.remove(question);
        numberQuestions();
    };

    //INITIALIZE
    $scope.focusOption = false;
    $scope.focusQuestionText = true;
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.defaultChoices = [{optionSequence: 0, optionText: 'No'}, {optionSequence: 1, optionText: 'Yes'}];
    $scope.newQuestion = {
        id: null,
        informTemplateId: null,
        questionType: $scope.defaultFormatOption,
        affirmation: null,
        policy: null,
        options: angular.copy($scope.defaultChoices)
    };

    $scope.emptyTemplate = dialog.options.thisTemplate;
    $scope.thisTemplate = dialog.options.thisTemplate;

    init();

    $scope.formatOptions = [];
    $scope.defaultFormatOption = $scope.formatOptions[0];
    $scope.editMode = $scope.rightsCompassInform.canUpdate && !$scope.thisTemplate.isLocked;


});




'use strict';

app.controller('AdminTemplateDialogCtrlV2', function AdminTemplateDialogCtrlV2($scope, dialog, closeDialogService, adminTemplateDialogService) {

    //SCOPE WATCHERS
    $scope.$watch('closeDialogService.closeDialog', (newValue, oldValue) => {
        if (!newValue || newValue === oldValue) {
            return;
        }
        if ($scope.closeDialogService.results !== null) {
            dialog.close($scope.closeDialogService.results);
        } else {
            dialog.close();
        }
    })

    $scope.closeDialogService = closeDialogService;
    adminTemplateDialogService.copiedId = dialog.options.copyFromId;
    adminTemplateDialogService.template = dialog.options.thisTemplate;
});




//AffirmationDialogCtrl

app.controller('AffirmationDialogCtrl', function AffirmationDialogCtrl($http, $scope, dialog, $dialog) {

    //PRIVATE METHODS
    function init(){
        $http.get('/Compliance/Inform/Policy?isActive=true&isVisible=true', {cache: false, trackerMsg: 'Loading library documents'})
            .then(function (response) {
                $scope.policyOptions = response.data;
                setAffirmation();
        });
    }

    function setAffirmation(){
        if($scope.affirmation.policy.id){
            $scope.affirmation.policy = $scope.policyOptions.find({id: $scope.affirmation.policy.id});
        }
    }

    //PUBLIC METHODS
    $scope.addNewPolicy = function(){
        $dialog.dialog({templateUrl: "tools/compass/inform/modal/policy-dialog.html", controller: "PolicyDialogCtrl",  informPolicy: null, dialogClass: 'modal'})
            .open()
            .then(function (response) {
                if(response){
                    $scope.policyOptions.push(response);
                    $scope.affirmation.policy = response;
                    setAffirmation();
                }
            });
    };

    $scope.cancel = function(){
        dialog.close();
    };

    $scope.submit = function () {

        if(!$scope.affirmation.affirmation){
            return;
        }

        var url = "/Compliance/Inform/Affirmation";

        if($scope.affirmation.id){
            $http.put(url, $scope.affirmation, {trackerMsg: 'Saving affirmation'})
                .then(function (response) {
                    dialog.close(response.data);
                });
        } else {
            $http.post(url, $scope.affirmation, {trackerMsg: 'Saving affirmation'})
                .then(function (response) {
                    dialog.close(response.data);
                });
        }


    };

    //INITIALIZE
    $scope.affirmation =  dialog.options.affirmation
        ? dialog.options.affirmation
        : { affirmation: null,
            policy: null,
            isActive: true
        };
    init();

});

app.controller('ClosedWithOutcomeCtrl', function ClosedWithOutcomeCtrl($scope, dialog, $http) {

    $scope.cancel = () => {
        dialog.close();
    };

    $scope.submit = () => {
        if ($scope.saveIsDisabled === false) {
            $scope.saveIsDisabled = true;
        }

        const dto = {
            tradeViolationIds: $scope.selectedIds,
            outcome: $scope.selected,
            comment: $scope.comment
        };

       $http.put('/Compliance/Inform/TradeViolation/MassUpdate',dto, {trackerMsg: 'Updating trade violation'})
       .then(res => {
           if (res.status === 200) {
               dialog.close(true);
           } else {
               dialog.close(false);
           }
       });
    }

    $scope.comment = '';
    $scope.selected = 0;
    $scope.selectedIds = dialog.options.selectedIds;
    $scope.saveIsDisabled = false;
})

app.controller('EmailDialogCtrl', function EmailDialogCtrl($scope, dialog, $http) {

    //PRIVATE METHODS

    //PUBLIC METHODS
    $scope.cancel = function(){
        dialog.close();
    };

    $scope.sendEmail = function(){
        var emailList = [];

        //check for required fields

        $scope.parentObject.each(function(obj) {
            var tmpEmail = angular.copy($scope.emailVerbose);
            if(obj.accountDetails){
                tmpEmail.userIdRecipient = obj.accountDetails.accessPersonId;
                tmpEmail.parentId = obj.accountDetails.id;
            } else {
                tmpEmail.userIdRecipient = obj.accessPersonId;
                tmpEmail.parentId = obj.id;
            }
            tmpEmail.sentDate = Date.create('today');


            emailList.insert(tmpEmail);
        });

        $http.post('/Compliance/Inform/AccessPerson/Email/' + $scope.templateType, emailList, {trackerMsg: 'Sending emails'})
            .then(function(response) {
                dialog.close(response.data);
            });

    };

    //INITIALIZE
    $scope.missingRequiredFields = function(){
        if(!$scope.emailVerbose.email.body){
            return true;
        }
        if(!$scope.emailVerbose.email.subject){
            return true;
        }
    };

    $scope.emailVerbose = dialog.options.email
        ? dialog.options.email
        : {
            id: 0,
            userIdSender: 0,
            userIdRecipient: 0,
            sentDate: Date.create('today'),
            parentId: null,
            email: {
                subject:null,
                body:null
            }
        };
    $scope.emailToName = dialog.options.emailToName;
    $scope.parentObject = dialog.options.parentObject;
    $scope.templateType = dialog.options.templateType;

});

'use strict';

app.controller('TradeViolationDialogCtrl', function TradeViolationDialogCtrl($scope, dialog, $rootScope, $http, $oasRights, $dialog) {

    //PRIVATE METHODS
    function init(){
        getPreClearanceList();
        $scope.tradeViolation.tradeDate = dateOnly($scope.tradeViolation.tradeDate);
    }

    function getPreClearanceList(){
        $http.get('/Compliance/Inform/Preclearances/V2/AccessPerson/' + $scope.tradeViolation.accessPersonId + '?forExceptionMatch=yes', {cache: false, trackerMsg: 'Loading pre-clearance list'})
            .then(function (response) {
                $scope.preclereances = response.data;

            });
    }

    function dateOnly(dte){
        if(!dte) return;
        return Date.create(dte.slice(0,10)).format('{MM}/{dd}/{yyyy}');
    }



    //PUBLIC METHODS
    $scope.cancel = function(){
        dialog.close();
    };

    $scope.toggleStatusHistory = function () {
        $scope.showStatus = !$scope.showStatus;
    };

    $scope.preClearanceDialog = function(){
        const thisPreClearance = $scope.preclereances.filter(function(f){ return f.id == $scope.tradeViolation.informTransaction.preClearanceId});
        $dialog.dialog({templateUrl: "tools/inform/modal/inform-new-preclearance-dialog.html",controller: "InformPreClearanceDialogCtrl",preclearance: thisPreClearance[0],accounts:null ,dialogClass: 'modal wide'})
            .open()
            .then(function (result) {
                if (!result) return;

                if (preclearance) {
                    getPreClearanceList();
                }
            });
    };

    $scope.updateStatus = function(){

        if($scope.accessPersonView){
            $scope.newStatus.status = "New";
        }

        if($scope.newStatus.status === "Follow-up" && $scope.newStatus.comment == null){
            $dialog.messageBox("Missing", "You must enter a follow-up message to the access person.").open();
            return;
        }

        $scope.tradeViolation.statusHistory.insert($scope.newStatus);

        $http.put('/Compliance/Inform/TradeViolation',$scope.tradeViolation, $scope.newStatus, {trackerMsg: 'Updating trade violation'})
            .then(function(response) {
                dialog.close(response.data);
            });

    };
    $scope.openBrokerageAccount = function(){
        const id = $scope.tradeViolation.account.id;
        $http.get('/Compliance/Inform/BrokerageAccount/' + id, {trackerMsg: 'Loading brokerage account'})
            .then(function (response) {
                $dialog.dialog({templateUrl: "tools/inform/modal/inform-brokerage-account-dialog.html",controller: "InformBrokerageAccountDialogCtrl",brokerageAccount: response.data, dialogClass: 'modal wide'})
                    .open()
            });
    };

    $scope.getFrontRunningTransactions = function(){
        const id = $scope.tradeViolation.id;
        $scope.showLinkedTransactions = !$scope.showLinkedTransactions;
        if(!$scope.tradeViolation.linkedTransactions) {
            $http.get('/Compliance/Inform/TradeViolation/LinkedTransactions/' + id, {trackerMsg: 'Loading front running transactions'})
                .then(function (response) {
                    $scope.tradeViolation.linkedTransactions = response.data;
                    $scope.showLinkedTransactions = true;
                });
        }
    };

    //INITIALIZE
    $scope.showFullTransaction = false;
    $scope.documentStatus = ["Follow-up", "Closed"];
    $scope.outcomeList = ["","Verbal Warning","Written Warning","Loss of Trading Privileges","Termination","Other", "False Positive"];
    $scope.tradeViolation = dialog.options.tradeViolation;
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.accessPersonView = $scope.tradeViolation.userDetailId === $rootScope.user.authorization.userDetailId && $scope.tradeViolation.status != "Closed";
    $scope.complianceView = $scope.rightsCompassInform.canUpdate && $scope.tradeViolation.userDetailId != $rootScope.user.authorization.userDetailId;
    $scope.showStatus = $scope.tradeViolation.status === "Closed";
    $scope.newStatus = {
        tradeViolationId:  $scope.tradeViolation.id,
        status: $scope.documentStatus[1],
        showComment: true,
        accessPersonId: $scope.tradeViolation.accessPersonId
    };
    $scope.showLinkedTransactions = !$scope.tradeViolation.isFrontRunning;
    init();

});

'use strict';

app.controller('AccessPersonDialogCtrl', function AccessPersonDialogCtrl($scope, dialog, $rootScope, $http, $oasRights,$dialog, $q) {

    //PRIVATE VARIABLES
    let accessPersonId;

    //PRIVATE METHODS
    function init(){

        $http.get('/Compliance/Inform/AccessPerson/' + accessPersonId, {cache: false, trackerMsg: 'Loading access person details'})
            .then(function (response) {
                $scope.accessPerson = response.data;
                $scope.accessPersonView = $scope.accessPerson.userDetailId === $rootScope.user.authorization.userDetailId;
                $scope.complianceView = !$scope.accessPersonView && $scope.rightsCompassInform.canUpdate;
                $scope.restrictPersonalRecord = $scope.accessPerson.firstName === "Deleted User";

                if($scope.complianceView || $scope.accessPersonView && $scope.accessPerson.isEmployeeViewable){
                    $scope.tabs.add({label: 'Notes', active:false});
                }
                setAllDates();
            });

        loadOfficeLocations();
        loadDepartments();
    }

    function dateOnly(dte){
        if(!dte) return;
        return Date.create(dte.slice(0,10)).format('{MM}/{dd}/{yyyy}');
    }

    function setAllDates(){
        $scope.accessPerson.birthDate = dateOnly($scope.accessPerson.birthDate);
        $scope.accessPerson.personal.DOB = $scope.accessPerson.birthDate;
        $scope.accessPerson.terminationDate = dateOnly($scope.accessPerson.terminationDate);
        $scope.accessPerson.employmentDate = dateOnly($scope.accessPerson.employmentDate);
    }

    function dateCreate(dte){
        if(!dte) return;
        return Date.create(dte).format('{MM}/{dd}/{yyyy}');
    }

    function loadOfficeLocations(){
        $http.get('/Compliance/Inform/Office/Locations', {trackerMsg: 'Loading office locations'})
            .then(function (response) {
                $scope.officeLocations = response.data;
            });
    }

    function loadDepartments() {
        $http.get('/Compliance/Inform/Departments', { trackerMsg: 'Loading Departments' })
            .then(function (response) {
                $scope.departments = response.data.findAll({ isActive: true }).sortBy('department');;
            });
    }


    //PUBLIC METHODS
    $scope.invalidEmail = function (invalid) {
        $scope.accessPerson.personal.emailInvalid = invalid;
    }

    $scope.setEmail = function (value) {
        $scope.accessPerson.personal.email = value;
    }

    $scope.cancel = function(){
        dialog.close();
    };

    $scope.useTerminateAction = function(){
        if($scope.accessPerson.terminationDate || !$scope.accessPerson.isActive){
            $dialog.messageBox("Access Person", "If this user is no longer active in Orion we suggest that you use the Terminate Employee action to close all connection and open action items for this user.").open();
        }

    };

    $scope.saveChanges = function() {
        if ($scope.accessPerson.personal.emailInvalid) {
            $dialog.messageBox("Invalid email", "Access person email is invalid. Please enter a valid email address.").open();
            return;
        }

        $scope.accessPerson.personal.DOB = dateCreate($scope.accessPerson.birthDate);
        $scope.accessPerson.employmentDate = dateCreate($scope.accessPerson.employmentDate);
        $scope.accessPerson.terminationDate = dateCreate($scope.accessPerson.terminationDate);

        $http.put('/Compliance/Inform/AccessPerson/' + accessPersonId,$scope.accessPerson, {cache: false, trackerMsg: 'Saving access person details'})
            .then(function (response) {
                dialog.close(response.data);
            });
    };

    $scope.showTab = function(tab){
        $scope.currentTab.active = false;
        tab.active = true;
        $scope.currentTab = tab;

        if($scope.currentTab.label === 'Licenses' && $scope.informLicenses.length === 0){
            $http.get('/Compliance/Inform/License/Simple', {cache: false, trackerMsg: 'Loading license options'})
                .then(function (response) {
                    $scope.informLicenses = response.data;
                });
        }

    };

    $scope.removeLicense = function(license){
        $scope.accessPerson.licenses.remove(license);
    };

    $scope.addLicense = function(){
        if($scope.current.selectedLicense){
            if(!$scope.accessPerson.licenses){
                $scope.accessPerson.licenses = [];
            }

            if( !$scope.accessPerson.licenses.find({informLicenseId : $scope.current.selectedLicense.id})){
                const newLicense = { accessPersonId : $scope.accessPerson.id, informLicenseId: $scope.current.selectedLicense.id, licenseDescription: $scope.current.selectedLicense.name};
                $scope.accessPerson.licenses.push(newLicense);
            }
        }
        $scope.current.selectedLicense = null;
    };

    //INITIALIZE
    $scope.informLicenses = [];
    $scope.selectedLicense = undefined;
    $scope.canEditPersonal = false;
    accessPersonId = dialog.options.id;
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.accessPersonView = false;
    $scope.complianceView = false;
    $scope.tabs = [
        {label: 'General', active: true},
        {label: 'Contact', active: false},
        {label: 'Employment', active: false},
        {label: 'Licenses', active: false},
    ];
    $scope.currentTab = $scope.tabs[0];
    init();

});

'use strict';

app.component('informQuestion', {
    templateUrl: 'tools/compass/Inform/component/inform-question.html',
    bindings: {
        thisQuestion: '=',
        formatOptions: '<',
        editMode: '<',
        affirmationOptions: '<',
        policyOptions: "<",
        focusOption: "=",
        focusQuestionText: "=",
        childQuestion: "<"
    },
    controller: informQuestionCtrl
});

function informQuestionCtrl($http){
    var $ctrl = this;
    //var defaultOptions = [{optionSequence:0, optionText:'No'}, {optionSequence:1, optionText:'Yes'}];

    $ctrl.updateQuestionOptions = function(question){

        $http.get('/Compliance/Inform/Template/EmptyTemplateQuestion?templateQuestionType=' + question.questionType, {cache: true, trackerMsg: 'Loading empty template question'})
            .then(function (response) {
                question.options = angular.copy(response.data.options);
            });
    };

    $ctrl.setAffirmationPolicy = function (question){
        if(question.affirmation.policy && question.affirmation.policy.isActive){
            question.policy = $ctrl.policyOptions.find({id: question.affirmation.policy.id});
        } else {
            question.policy = null;
        }
    };

    $ctrl.addQuestionOption = function(){
        $ctrl.focusOption = true;
        $ctrl.focusQuestionText = false;

        if ($ctrl.thisQuestion.options === undefined){
            $ctrl.thisQuestion.options = [];
            var newOption = {optionSequence:0, optionText:''};
            $ctrl.thisQuestion.options.push(newOption);
        } else {
            var idx = $ctrl.thisQuestion.options.length + 1;
            var newOption = {optionSequence:idx, optionText:''};
            $ctrl.thisQuestion.options.push(newOption);
        }
    };

    $ctrl.removeQuestionOption = function(option){
        $ctrl.thisQuestion.options.remove(option);
    };

    $ctrl.addConditionalQuestion = function(option){
        var newQuestion = {
            id:0,
            informTemplateId: 0,
            questionType: $ctrl.formatOptions.find("Text")
        };
        option.childQuestion = newQuestion;

    };

    $ctrl.removeConditionalQuestion = function(option){
        option.childQuestion = null;
    };

    $ctrl.showOrHideOptions = function(){
        return $ctrl.thisQuestion.questionType === 'Radio';
    };

    $ctrl.showOrHideCheckBoxes = function() {
        return $ctrl.thisQuestion.questionType === 'Multi-Checkbox';
    };

    $ctrl.removeQuestionOption = function(option){
        $ctrl.thisQuestion.options.remove(option);
    };
}
'use strict';

app.component('informTransaction', {
    templateUrl: 'tools/compass/Inform/component/inform-transaction.html',
    bindings: {
        thisTransaction: '=',
        showFullTransaction: '='
    },
    controller: informTransactionCtrl
});

function informTransactionCtrl(){
    let $ctrl = this;

    $ctrl.toggleTransaction = function(){
        $ctrl.showFullTransaction = !$ctrl.showFullTransaction;
    };



}
'use strict';

app.component('deMinimis', {
    templateUrl: 'tools/compass/Inform/component/DeMinimis.html',
    bindings: {
        deMinimis: '=',
    },
    controller: DeMinimisCtrl
});

function DeMinimisCtrl(){
    let $ctrl = this;

}
'use strict';

app.controller('DeactivateFirmCtrl', function DeactivateFirmCtrl($scope, $dialog, $http) {
    function init(){}

    $scope.deactivateFirm = function(){
        $dialog.messageBox("Deactivate Firm",$scope.disclaimer, [{
            result: 'Yes',
            label: 'Yes'
        }, {result: 'No', label: 'No'}]).open()
            .then(function (valueReturned) {
                if (valueReturned !== 'No') {
                    $http.post('/Compliance/Inform/Deactivation',
                        {trackerMsg: 'Deactivating firm'});
                }
            });
    };

    $scope.disclaimer = 'You are about to deactivate all of these users and this firm from Inform.  Are you sure you want to continue?';
    init();

});
app.controller('TestWizardCtrl', function TestWizardCtrl($scope, $http, $dialog, dialog, $rootScope, tokenFactory) {

    //PRIVATE VARIABLES
    const complianceFilterName = "compliance_filters_" + $scope.user.id;
    
    // PRIVATE METHODS
    function init() {

        if (!$scope.schedule.id) {
            let sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));
            if(sessionFilters == undefined || sessionFilters == null){
                sessionFilters = [];
            }

            //Get the Audit Type Options
            fetchTemplateLibraryAndCategories(sessionFilters);

            //only check and set db on new schedules
            $scope.current.databases =  sessionFilters.find((item)=>{
                return item.label === "Database";
            }).selected;

            $scope.schedule.alClientId = ($scope.current.databases.length > 0)
                ? $scope.current.databases[0].id
                : $scope.user.authorization.alClientId;

            $scope.current.showDatabases = $scope.current.databases.length > 0;
        }


        $scope.schedule.parameters.prompts.forEach(function(p){ //This will split the date placeholder from the +/- day difference
            if(p.promptType === "Date") {
                let dateParts;
                if(p.defaultValue.includes('-')) {
                    dateParts = p.defaultValue.split('-');
                } else if(p.defaultValue.includes('+')) {
                    dateParts = p.defaultValue.split('+');
                }
                if(dateParts && dateParts.length > 1) {
                    p.dayDifference = parseInt(dateParts[1]);
                    p.isPositive = p.defaultValue.includes('+');
                    p.defaultValue = dateParts[0];
                } else {
                    p.dayDifference = 0;
                    p.isPositive = true;
                }
            }
        });

        if ($scope.schedule.frequencyInfo || $scope.runNow) {
           $scope.updateIntervalValues($scope.schedule.frequency);
        }

        $scope.exclusionInfoStatement = "Adding an “Exclusion” allows you to exclude specific results from your query. ";
        $scope.exclusionInfoStatement += "For example, if a Household appeared on this same query already, you can choose to exclude it for a given time frame to prevent you from reviewing the same information again.";
        $scope.exclusionInfoStatement += " First select the information you would like to exclude, then select the time frame that you would like to exclude it.";
    }

    function getCategories() {
        let alClientId = $scope.schedule.alClientId;
        if(!alClientId){
            alClientId = $scope.user.authorization.alClientId;
        }
        tokenFactory.getDatabaseToken(alClientId)
            .then(function (token) {
                $http.get('/Compliance/AuditTests/Categories',{headers: {Authorization: "Session " + token},trackerMsg: 'Loading template categories'})
                    .then(function (response) {
                        $scope.categories = response.data;
                        // if ($scope.template.category) {
                        //     $scope.template.category = $scope.categories.find({id: $scope.template.category.id});
                        // }
                    });
            });
    }

    function fetchTemplateLibraryAndCategories(sessionFilters){
        //Get the Audit Type Options
        $http.post('/Compliance/AuditTests/Templates/List',sessionFilters, {trackerMsg: 'Loading query template library'})
            .then(function (response) {
                $scope.templateLibrary = response.data;
                //$scope.categories = $scope.templateLibrary.map("category").unique("description");
                getCategories()
            });
    }

    function setFrequencyInfoText(opts) {
        let frequencyText = "";
        let ct = 0;
        opts.forEach(function (item) {
            if (item.selected) {
                frequencyText += (ct === 0) ? " (on " : ", ";
                frequencyText += item.name;
                ct++;
            }
        });
        frequencyText += (ct > 0) ? ")" : " ";
        return frequencyText;
    }

    function frequencyStatement() {
        $scope.current.frequencyStatement = "Run " + $scope.schedule.frequency.toLocaleLowerCase();
        if ($scope.schedule.frequency === "Monthly")
            $scope.current.frequencyStatement += " on day " + $scope.schedule.frequencyInfo.interval.day;
        if ($scope.current.runHour)
            $scope.current.frequencyStatement += " at " + $scope.current.runHour + ":00 " + $scope.current.meridian;
        $scope.current.frequencyStatement += setFrequencyInfoText($scope.intervalValues);
    }

    function exclusionStatement() {
        $scope.current.exclusionStatement = $scope.schedule.exclusionInfo.type;

        if ($scope.schedule.exclusionInfo.type === 'None') return;

        if ($scope.schedule.exclusionInfo.rangeType !== "Always") {
            $scope.current.exclusionStatement += " for the past " + $scope.schedule.exclusionInfo.rangeNumber + " " + $scope.schedule.exclusionInfo.rangeType;
        }

    }

    function setIntervalValues() {
        $scope.intervalValues = [];

        Object.keys($scope.schedule.frequencyInfo.interval, function (key, value) {
            if (['day', '$type'].none(key)) {
                $scope.intervalValues.push({name: key.capitalize(), selected: value});
            }
        });
    }

    function formatPrompts(prompts){
        //Format date prompts
        prompts.forEach(function(p){
            if(p.promptType === "Date") {
                if($scope.runNow ){
                    p.defaultValue = Date.create(p.defaultValue).formatted(false);
                }
                if (p.dayDifference && angular.isNumber(p.dayDifference) && parseInt(p.dayDifference) > 0){
                    p.defaultValue += ((p.isPositive ? '+' : '-') + parseInt(p.dayDifference));
                    delete p.dayDifference;
                    delete p.isPositive;
                }
            }
        });
        return prompts;
    }


    //PUBLIC METHODS
    $scope.setCurrentPrompt = function (opt) {
        $scope.current.prompt = opt;
    };

    $scope.filterCategories = function(){
        // if($scope.schedule.alClientId) {
        //     $scope.categories = [];
        //     $scope.categories = $scope.templateLibrary.filter(function (item) {
        //         return (item.alClientId === $scope.schedule.alClientId || item.alClientId === null)
        //     }).map("category").unique("description");
        // }
        getCategories();
    };

    $scope.filterTemplates = function(){
        if($scope.current.selectedCategory) {
            $scope.filteredTemplateLibrary = [];
            $scope.filteredTemplateLibrary = $scope.templateLibrary.filter(
                function (i) {
                    return (i.category.id === $scope.current.selectedCategory.id
                    )
                });
            $scope.schedule.category = $scope.current.selectedCategory;
        }
    };

    $scope.reportDescription = function (title, text) {
        $dialog.messageBox(title, text).open();
    };

    $scope.updateSchedule = function (sched) {
        $scope.current.executing = true;
        sched.parameters.prompts = formatPrompts($scope.queryDetails.prompts);
        sched.entity = $scope.current.selectedEntityType;

        //Set Frequency
        if ($scope.intervalValues.length > 0) {
            $scope.intervalValues.forEach(function (item) {
                $scope.schedule.frequencyInfo.interval[item.name.toLowerCase()] = item.selected;
            });
        }
        sched.frequencyInfo.timeOfDay = sched.timeOfDay =($scope.current.runHour) ? Date.create($scope.current.runHour + ' ' + $scope.current.meridian).format('{yyyy}-{MM}-{dd} {HH}:{mm} {Z}') : null;
        sched.frequencyInfo.startDate = sched.startDate = (sched.startDate) ? Date.create(sched.startDate).format('{yyyy}-{MM}-{dd} {HH}:{mm} {Z}') : null;
        sched.frequencyInfo.endDate = sched.endDate = (sched.endDate) ? Date.create(sched.endDate).format('{yyyy}-{MM}-{dd} {HH}:{mm} {Z}') : null;

        dialog.close(sched);

    };

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.addTemplateValues = function () {
        $scope.schedule.description = $scope.current.selectedTemplate.description;
        $scope.schedule.exclusionInfo = $scope.current.selectedTemplate.exclusionInfo;
        $scope.schedule.frequency = $scope.current.selectedTemplate.frequency;
        $scope.schedule.frequencyInfo = $scope.current.selectedTemplate.frequencyInfo;
        $scope.schedule.customReportId = $scope.current.selectedTemplate.customReportId;
        $scope.schedule.comment = $scope.current.selectedTemplate.comment;
        $scope.schedule.entity = $scope.current.selectedTemplate.entity;
        if(!$scope.runNow){
            //can't use the default parameters for dates, need to ues defaults from data query
            $scope.schedule.parameters = $scope.current.selectedTemplate.parameters;
            $scope.updateIntervalValues($scope.schedule.frequency);
        }

    };

    //Wizard Navigation
    $scope.next = function () {
        if ($scope.current.executing) return;

        $scope.current.wizardStep++;

        if($scope.runNow && $scope.current.wizardStep === 2){
            //run now skips the exclusion and frequency tabs
            $scope.current.wizardStep = 4;
        }


        switch ($scope.current.wizardStep) {

            case 1:
                //Load Data Query Details
                if (!$scope.queryDetails || $scope.schedule.customReportId !== $scope.queryDetails.id) {
                    $http.get('/Reporting/Custom/' + $scope.schedule.customReportId, {trackerMsg: 'Loading query parameters'})
                        .then(function (response) {
                            $scope.queryDetails = response.data;
                            if ($scope.schedule.parameters.prompts.length > 0) {
                                //Set the Defaults already selected
                                $scope.queryDetails.prompts = $scope.schedule.parameters.prompts;
                            } else {
                                $scope.queryDetails.prompts.forEach(function (item) {
                                    item.customReportId = $scope.schedule.customReportId;
                                });
                            }
                        });
                }
                break;
            case 3:
                if(!$scope.schedule.exclusionInfo){
                    $scope.schedule.exclusionInfo = {
                        type: "None",
                        rangeType: "Always",
                        rangeNumber: 1
                    }
                }
                exclusionStatement();
                break;
            case 4:
                frequencyStatement();
                break;

        }
    };

    $scope.back = function () {
        if ($scope.current.executing) return;

        if ($scope.current.wizardStep > 0) {
            $scope.current.wizardStep--;
        }
        if($scope.runNow && [4,3].find($scope.current.wizardStep)){
            //run now skips the exclusion and frequency tabs
            $scope.current.wizardStep = 1;
        }

    };

    $scope.jumpBackTo = function (index) {
        if ($scope.current.executing) return;

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };

    $scope.isStepIncomplete = function () {
        switch ($scope.current.wizardStep) {
            case 0:
                if ((!$scope.current.selectedTemplate && !$scope.schedule.id) ||
                    (!$scope.schedule.startDate) ||
                     !$scope.schedule.sampleSize) {
                    return true;
                }
                break;
            case 2:
                if($scope.schedule.exclusionInfo.rangeType !== "Always" && isNaN($scope.schedule.exclusionInfo.rangeNumber)) return true;
                break;
            case 3:
                if ((!$scope.schedule.frequency) ||
                    ($scope.schedule.frequency === "Monthly" && (!$scope.schedule.frequencyInfo.interval.day || isNaN($scope.schedule.frequencyInfo.interval.day))) ||
                    (["Monthly", "Weekly"].find($scope.schedule.frequency) && ($scope.intervalValues.filter(function(e){ return e.selected===true}).length === 0)) ||(!$scope.schedule.timeOfDay)){
                        return true;

                    }
                break;
        }
        return false;
    };

    $scope.updateIntervalValues = function (frequency) {

        if ($scope.schedule.frequencyInfo.interval) {
            setIntervalValues();
        }

        if ((frequency === 'Once' && $scope.intervalValues !== null) ||
            (frequency === 'Daily' && $scope.intervalValues.length === 0) ||
            (frequency === 'Weekly' && $scope.intervalValues.length === 7) ||
            (frequency === 'Monthly' && $scope.intervalValues.length === 12)) {
            return;
        }
        //Get the correct FrequencyDto
        $http.get('/Reporting/Custom/Schedules/New?frequencyType=' + frequency, {cache: true, trackerMsg: 'Loading frequency options'})
            .then(function (response) {
                $scope.schedule.frequencyInfo = response.data.frequencyInfo;
                if($scope.schedule.frequency === "Monthly"){
                    $scope.schedule.frequencyInfo.interval.january = true;
                    $scope.schedule.frequencyInfo.interval.february = true;
                    $scope.schedule.frequencyInfo.interval.march = true;
                    $scope.schedule.frequencyInfo.interval.april = true;$scope.schedule.frequencyInfo.interval.may = true;
                    $scope.schedule.frequencyInfo.interval.june = true;
                    $scope.schedule.frequencyInfo.interval.july = true;
                    $scope.schedule.frequencyInfo.interval.august = true;
                    $scope.schedule.frequencyInfo.interval.september = true;
                    $scope.schedule.frequencyInfo.interval.october = true;
                    $scope.schedule.frequencyInfo.interval.november = true;
                    $scope.schedule.frequencyInfo.interval.december = true;
                    $scope.schedule.frequencyInfo.interval.day = "1";
                }
                if($scope.schedule.frequency === "Weekly"){
                    $scope.schedule.frequencyInfo.interval.monday = true;
                }
                setIntervalValues();
            });
    };

    $scope.toggleMeridian = function(){
        if($scope.current.meridian==='AM'){
            $scope.current.meridian = 'PM';
        } else {
            $scope.current.meridian = 'AM';
        }
    };


    //INITIALIZE
    $scope.runNow = dialog.options.runNow;
    $scope.today = Date.create().toISOString();
    $scope.wizardSteps =  $scope.runNow ?  ["Type","Data Query","Review"] : ["Type","Data Query","Exclusions","Frequency", "Review"];
    $scope.exclusionType = ["None", "Households", "Registrations", "Accounts", "Transactions", "Assets"];
    $scope.exclusionRangeType = ["Always", "Days", "Weeks", "Months", "Years"];
    $scope.frequencyOptions = $scope.runNow ? ["Once"] : ["Daily", "Weekly", "Monthly"];
    $scope.categories = [];
    $scope.templateLibrary = [];
    $scope.filteredTemplateLibrary = [];
    $scope.queryDetail = null;
    $scope.dayOfMonth = 1;
    $scope.onlyNumbers = /^\d+$/;
    $scope.intervalValues = [];
    $scope.dateDefaults = [
        {id: "NOW", name: "Now"},
        {id: "LBD", name: "Last Business Day"},
        {id: "STARTQTD", name: "Start Quarter-To-Date"},
        {id: "STARTYTD", name: "Start Year-To-Date"},
        {id: "STARTLQ", name: "Start Last Quarter"},
        {id: "STARTLM", name: "Start Last Month"},
        {id: "STARTLY", name: "Start Last Year"},
        {id: "ENDQTD", name: "End Quarter-To-Date"},
        {id: "ENDYTD", name: "End Year-To-Date"},
        {id: "ENDLQ", name: "End Last Quarter"},
        {id: "ENDLM", name: "End Last Month"},
        {id: "ENDLY", name: "End Last Year"}
    ];

    $scope.schedule = dialog.options.schedule ?
        $scope.schedule = angular.copy(dialog.options.schedule)
        : {
            id: null,
            entity: ($rootScope.user.entity === "Administrator") ? "Advisor" : $rootScope.user.entity,
            description: null,
            customReportId: null,
            parameters: {
                errorMessage: null,
                isValid: false,
                prompts: []
            },
            sampleSize: null,
            frequency: ($scope.runNow) ? "Once" : "Monthly",
            frequencyInfo: {
                interval: []
            },
            exclusionInfo: {
                type: "None",
                rangeType: "Always",
                rangeNumber: 1
            },
            timeOfDay: $scope.today,
            startDate: $scope.today,
            isActive: true,
            alClientId:null,
        };

    $scope.current = {
        databases:[],
        showDatabases: false,
        frequencyStatement: "",
        exclusionStatement: "",
        selectedTemplate: null,
        selectedCategory:null,
        wizardStep: 0,
        executing: false,
        runHour: $scope.schedule.timeOfDay ?  Date.create($scope.schedule.timeOfDay).format('{h}').toNumber() : 8,
        meridian: $scope.schedule.timeOfDay ?  Date.create($scope.schedule.timeOfDay).format('{H}') >12 ? "PM" : "AM" : "AM",

    };

    init();
});

app.controller('TemplateWizardCtrl', function TemplateWizardCtrl($scope, $http, $oasRights, dialog, $rootScope, $dialog, tokenFactory) {

    //PRIVATE VARIABLES
    const complianceFilterName = "compliance_filters_" + $scope.user.id;
    
    //PRIVATE METHODS
    function init() {
        if (!$scope.template.id) {
            let sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));
            if (sessionFilters == undefined || sessionFilters == null) {
                sessionFilters = [];
            }

            //only check and set db on new templates
            $scope.current.databases = sessionFilters.find((item) => {
                return item.label === "Database";
            }).selected;

            $scope.template.alClientId = ($scope.current.databases.length > 0)
                ? $scope.current.databases[0].id
                : $scope.user.authorization.alClientId;

            switch ($rootScope.user.authorization.entity) {
                case "Administrator":
                    $scope.template.entity = "Advisor";
                    $scope.isAdmin = $scope.current.globalOption = true;
                    break;
                default:
                    $scope.template.entity = $rootScope.user.authorization.entity;
                    break;
            }
        }



        if ($scope.template.frequencyInfo) {
            updateIntervalValues($scope.template.frequency);
        }

        getCategories();

        if ($scope.template.customReportId) {
            $scope.queryDetails = {
                id: $scope.template.customReportId,
                title: $scope.template.customReportTitle,
                prompts: $scope.template.parameters.prompts,
                entity: $scope.template.customReportEntity,
                reportDescription: $scope.template.customReportDescription
            };
        }

        $scope.exclusionInfoStatement = "Adding an “Exclusion” allows you to exclude specific results from your query. ";
        $scope.exclusionInfoStatement += "For example, if a Household appeared on this same query already, you can choose to exclude it for a given time frame to prevent you from reviewing the same information again.";
        $scope.exclusionInfoStatement += " First select the information you would like to exclude, then select the time frame that you would like to exclude it.";

    }

    function getCategories() {
        let alClientId = $scope.template.alClientId;
        if(!alClientId){
            alClientId = $scope.user.authorization.alClientId;
        }
        tokenFactory.getDatabaseToken(alClientId)
            .then(function (token) {
                $http.get('/Compliance/AuditTests/Categories',{headers: {Authorization: "Session " + token},trackerMsg: 'Loading template categories'})
                    .then(function (response) {
                        $scope.categories = response.data;
                        if ($scope.template.category) {
                            $scope.template.category = $scope.categories.find({id: $scope.template.category.id});
                        }
                    });
            });
    }

    function getQueryDetails(dataQueryId) {
        if (!dataQueryId || $scope.template.customReportId !== dataQueryId) {
            $http.get('/Reporting/Custom/' + dataQueryId, {trackerMsg: 'Loading query parameters'})
                .then(function (response) {
                    if (!checkValidReportEntity(response.data)) {
                        return;
                    }
                    $scope.template.customReportId = dataQueryId;
                    $scope.queryDetails = response.data;
                    $scope.template.parameters.prompts = $scope.queryDetails.prompts;
                    $scope.template.customReportTitle = $scope.queryDetails.title;
                    if ($scope.template.parameters.prompts.length > 0) {
                        $scope.queryDetails.prompts = $scope.template.parameters.prompts;
                    } else {
                        $scope.queryDetails.prompts.forEach(function (item) {
                            item.customReportId = $scope.template.customReportId;
                        });
                    }
                });
        } else {
            checkValidReportEntity($scope.queryDetails)
        }
    }

    function updateIntervalValues(frequency) {

        if ($scope.template.frequencyInfo.interval) {
            setIntervalValues();
        }

        if ((frequency === 'Daily' && $scope.intervalValues.length === 0) ||
            (frequency === 'Weekly' && $scope.intervalValues.length === 7) ||
            (frequency === 'Monthly' && $scope.intervalValues.length === 12)) {
            return;
        }

        //Get the correct FrequencyDto
        $http.get('/Reporting/Custom/Schedules/New?frequencyType=' + frequency, {
            cache: true,
            trackerMsg: 'Loading frequency options'
        })
            .then(function (response) {
                $scope.template.frequencyInfo = response.data.frequencyInfo;
                setIntervalValues();
            });
    }

    function setFrequencyInfoText(opts) {
        var frequencyText = "";
        var ct = 0;
        opts.forEach(function (item) {
            if (item.selected) {
                frequencyText += (ct === 0) ? " (on " : ", ";
                frequencyText += item.name;
                ct++;
            }
        });
        frequencyText += (ct > 0) ? ")" : " ";
        return frequencyText;
    }

    function frequencyStatement() {
        $scope.current.frequencyStatement = "Run " + $scope.template.frequency.toLocaleLowerCase();
        if ($scope.template.frequency === "Monthly" && $scope.template.frequencyInfo.interval.day)
            $scope.current.frequencyStatement += " on day " + $scope.template.frequencyInfo.interval.day;
        $scope.current.frequencyStatement += setFrequencyInfoText($scope.intervalValues);
    }

    function exclusionStatement() {
        $scope.current.exclusionStatement = $scope.template.exclusionInfo.type;

        if ($scope.template.exclusionInfo.type === 'None') return;

        if ($scope.template.exclusionInfo.rangeType !== "Always") {
            $scope.current.exclusionStatement += " for the past " + $scope.template.exclusionInfo.rangeNumber + " " + $scope.template.exclusionInfo.rangeType;
        }
    }

    function checkValidReportEntity(dataQuery) {

        var reportEntity = dataQuery.entity;
        var templateEntity = $scope.template.entity;
        var valid = true;

        switch (reportEntity) {
            case "Administrator":
                valid = false;
                break;
            case "Advisor":
            case "RIA":
                if (["Broker/Dealer"].find(templateEntity)) {
                    valid = false;
                }
                break;
        }

        if (!valid) {
            $dialog.messageBox("Entity Mismatch", "The selected query, " + dataQuery.title + ", cannot be run for " + templateEntity + " users.  Please select a different data query or change the entity type for the template.").open();
        }

        return valid;
    }


    //PUBLIC METHODS
    $scope.databaseChanged = function(){
        getCategories();
        //clear database specific fields
        $scope.template.category = null;
        $scope.template.customReportId = null;
        $scope.queryDetails = null;
        $scope.template.parameters.prompts = null;
    };

    $scope.categoryChanged = function () {
        if ($scope.template.category.alClientId) {
            $scope.template.thisDatabaseOnly = true;
        }
        getCategories();
    };


    $scope.setCurrentPrompt = function (opt) {
        $scope.current.prompt = opt;
    };

    $scope.updateIntervals = function (frequency) {
        updateIntervalValues(frequency);
    };

    function setIntervalValues() {
        $scope.intervalValues = [];

        Object.keys($scope.template.frequencyInfo.interval, function (key, value) {
            if (['day', '$type'].none(key)) {
                $scope.intervalValues.push({name: key.capitalize(), selected: value});
            }
        });
    }

    $scope.addCategory = function () {
        $dialog.inputBox("New Category", "Category")
            .open()
            .then(function (response) {
                if (response) {
                    var newCategory = {id: null, description: response};
                    $scope.template.category = newCategory;
                    $scope.categories.push(newCategory);

                }
            })
    };

    $scope.findDataQuery = function () {
        $dialog.search("dataQuery", "Data Query Task")
            .open()
            .then(function (dataQuery) {
                if (dataQuery) {
                    getQueryDetails(dataQuery.id);

                }
            });
    };


    $scope.reportDescription = function (title, text) {
        $dialog.messageBox(title, text).open();
    };

    $scope.updateTemplate = function (obj) {
        obj.parameters.prompts = $scope.queryDetails.prompts;
        obj.customReportTitle = $scope.queryDetails.title;

        //Set Frequency
        if ($scope.intervalValues.length > 0) {
            $scope.intervalValues.forEach(function (item) {
                $scope.template.frequencyInfo.interval[item.name.toLowerCase()] = item.selected;
            });
        }

        let alClientId = $scope.template.alClientId;
        if(!alClientId){
            alClientId = $scope.user.authorization.alClientId;
        }

        tokenFactory.getDatabaseToken(alClientId)
            .then(function (token) {
                if ($scope.template.id) {
                    $http.put('/Compliance/AuditTests/Template/' + obj.id, obj, {
                        cache: true,
                        headers: {Authorization: "Session " + token},
                        trackerMsg: 'Updating query template'
                    })
                        .then(function (response) {
                            dialog.close(response.data);
                        });
                } else {
                    $http.post('/Compliance/AuditTests/Template', obj, {
                        cache: true,
                        headers: {Authorization: "Session " + token},
                        trackerMsg: 'Adding query template'
                    })
                        .then(function (response) {
                            dialog.close(response.data);
                        });
                }
            });

    };

    $scope.scheduleTemplate = function (obj) {
        //create the template and use the template as a default to create a schedule
        obj.parameters.prompts = $scope.queryDetails.prompts;
        obj.customReportTitle = $scope.queryDetails.title;

        //Set Frequency
        if ($scope.intervalValues.length > 0) {
            $scope.intervalValues.forEach(function (item) {
                $scope.template.frequencyInfo.interval[item.name.toLowerCase()] = item.selected;
            });
        }

        tokenFactory.getDatabaseToken($scope.template.alClientId)
            .then(function (token) {
                var templatePromise = null;
                if ($scope.template.id) {
                    templatePromise = $http.put('/Compliance/AuditTests/Template/' + obj.id, obj, {
                        cache: true,
                        headers: {Authorization: "Session " + token},
                        trackerMsg: 'Updating query template'
                    });
                } else {
                    templatePromise = $http.post('/Compliance/AuditTests/Template', obj, {
                        cache: true,
                        headers: {Authorization: "Session " + token},
                        trackerMsg: 'Adding query template'
                    })
                        .then(function (response) {
                            $scope.template = response.data;
                        });
                }
                $scope.template.canEdit = false;

                templatePromise.then(function (response) {
                    $http.post("/Compliance/AuditTests/DefaultSchedule?templateId=" + $scope.template.id, {
                        trackerMsg: "Adding a schedule"
                    });
                })
                    .then(function (response) {
                        dialog.close($scope.template);
                    });
            });

    };

    //Wizard Navigation
    $scope.next = function () {
        $scope.current.wizardStep++;
        switch ($scope.current.wizardStep) {
            case 1:
                if ($scope.template.customReportId) {
                    getQueryDetails($scope.template.customReportId);
                }
                break;
            case 3:
                updateIntervalValues($scope.template.frequency);
                break;
            case 4:
                frequencyStatement();
                exclusionStatement();
        }

    };

    $scope.back = function () {
        if ($scope.current.executing) return;

        if ($scope.current.wizardStep > 0) {
            $scope.current.wizardStep--;
        }
    };

    $scope.jumpBackTo = function (index) {
        if ($scope.current.executing) return;

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.isStepIncomplete = function () {
        switch ($scope.current.wizardStep) {
            case 0:
                if (!$scope.template.category || !$scope.template.description) return true;
                break;
            case 1:
                if (!$scope.template.customReportId) return true;
                break;
            case 2:
                if ($scope.template.exclusionInfo.rangeType !== "Always" && isNaN($scope.template.exclusionInfo.rangeNumber)) return true;
                break;
            case 3:
                if ($scope.template.frequency === "Monthly" && $scope.template.frequencyInfo.interval && isNaN($scope.template.frequencyInfo.interval.day)) return true;
                break;
        }

        return false;
    };


    //INITIALIZE
    $scope.template = (dialog.options.templateObject != null) ?
        $scope.template = angular.copy(dialog.options.templateObject)
        : {
            id: null,
            canEditTemplate: false,
            category: null,
            comment: null,
            customReportId: null,
            customReportTitle: null,
            description: null,
            entity: null,
            exclusionInfo: {
                type: "None",
                rangeType: "Always",
                rangeNumber: 1
            },
            frequency: "Monthly",
            frequencyInfo: {
                interval: []
            },
            parameters: {
                errorMessage: null,
                isValid: false,
                prompts: []
            },
            thisDatabaseOnly: true,
            isDefault: false
        };
    $scope.wizardSteps = ["Template Basics", "Data Query", "Exclusions", "Frequency", "Review"];
    $scope.exclusionType = ["None", "Households", "Registrations", "Accounts", "Transactions", "Assets"];
    $scope.exclusionRangeType = ["Always", "Days", "Weeks", "Months", "Years"];
    $scope.entityTypes = ["Advisor", "Broker/Dealer", "Representative"];
    $scope.frequencyOptions = ["Daily", "Weekly", "Monthly"];
    $scope.categories = dialog.options.categories.filter(function (e) {
        return e.id > 0;
    }); //exclude 'All'
    $scope.isAdmin = $rootScope.user.authorization.entity == "Administrator";
    $scope.intervalValues = [];
    $scope.queryDetails = null;
    $scope.onlyNumbers = /^\d+$/;
    $scope.dateDefaults = [
        {id: "NOW", name: "Now"},
        {id: "LBD", name: "Last Business Day"},
        {id: "STARTQTD", name: "Start Quarter-To-Date"},
        {id: "STARTYTD", name: "Start Year-To-Date"},
        {id: "STARTLQ", name: "Start Last Quarter"},
        {id: "STARTLM", name: "Start Last Month"},
        {id: "STARTLY", name: "Start Last Year"},
        {id: "ENDQTD", name: "End Quarter-To-Date"},
        {id: "ENDYTD", name: "End Year-To-Date"},
        {id: "ENDLQ", name: "End Last Quarter"},
        {id: "ENDLM", name: "End Last Month"},
        {id: "ENDLY", name: "End Last Year"}
    ];

    $scope.current = {
        databases: [],
        wizardStep: 0,
        globalOption: false,
        exclusionStatement: null,
        frequencyStatement: null,
        showForAdministrator: $rootScope.user.authorization.entity === "Administrator"
    };


    init();
});

'use strict';

app.controller('TestCategoryCtrl', function TestCategoryCtrl($scope, $http, dialog, $dialog) {
    //PRIVATE METHODS
    function init() {
        $http.get('/Compliance/AuditTests/Categories?manage=true', {trackerMsg: 'Loading template categories'})
            .then(function (response) {
                $scope.categories = response.data;
            });
    }


    //PUBLIC METHODS
    $scope.editDescription = function(category){
        let thisCategory = angular.copy(category);
        $dialog.dialog({templateUrl: "tools/compass/modal/test-category-edit.html", controller: "TestCategoryEditCtrl", category: thisCategory})
            .open()
            .then(function(results){
                if(results){
                    category.description = results.description;
                    category.inactive = results.inactive;
                }
            });
    };

    $scope.cancel = function(){
        dialog.close();
    };

    $scope.deleteCategory = function(category){
        const heading = "Delete Category";
        const message =  "Are you sure you want to delete '" + category.description + "'?";
        $dialog.messageBox(heading,message,[{result: true, label: 'Delete', focus: true},{result: false, label: 'Cancel', focus: true}])
            .open()
            .then(function(result){
                if(result){
                    $http.delete('/Compliance/AuditTests/Category/' + category.id, {tracker: 'main', trackerMsg: 'Deleting template category'})
                        .then(function (response) {
                            if (response) {
                                $scope.categories.remove(category);
                            }
                        });
                    }
            });


    };


    //INITIALIZATION
    $scope.categories = [];
    init();

});
'use strict';

app.controller('TestCategoryEditCtrl', function TestCategoryEditCtrl($scope, $http, dialog) {

    //PRIVATE METHODS

    //PUBLIC METHODS
    $scope.saveCategory = function(){
        $http.put('/Compliance/AuditTests/Category',$scope.category, {trackerMsg: 'Updating categories'})
            .then(function (response) {
                if(response){
                    dialog.close(response.data);
                }
            });
    };

    $scope.cancel = function(){
        dialog.close();
    };

    //INITIALIZATION
    $scope.category = dialog.options.category;
    $scope.current = {
        inactiveHelpText: 'Inactive Categories are not available when creating new templates',
        warningText: $scope.category.resultCount > 0
            ? 'Changing the category name will update all ' + $scope.category.resultCount + ' results previously created under this category.'
            : ''
    }

});
'use strict';

let databaseMultiSelectCtrl = app.controller('DatabaseMultiSelectCtrl', function DatabaseMultiSelectCtrl($scope, dialog, $rootScope, $http, databaseFilterService) {

    //PRIVATE VARIABLES

    let complianceFilterName = 'compliance_filters_' + $rootScope.user.id;
    let complianceFilters = JSON.parse(localStorage.getItem(complianceFilterName)) ? JSON.parse(localStorage.getItem(complianceFilterName)).find({ label: 'Database' }).selected : [];
    let storedList = JSON.parse(localStorage.getItem('unselectedDatabases')) ? JSON.parse(localStorage.getItem('unselectedDatabases')) : [] ;
    

    function init() {
        if (complianceFilters.length === 0) {
            getDatabases();      
        } else {
            $scope.database.selected = complianceFilters;

            if(storedList.length === 0){
                updateLists();
            }

            $scope.database.list = storedList
        } 
    }

    function getDatabases() {
        $http.get('/Authorization/User/Databases?isActive=true', { trackerMsg: 'Loading databases' })
            .then(response => {
                $scope.database.list = response.data.sortBy('clientName');
            });
    }

    function updateLists() {
        let selectedClientIds = [];
        $scope.database.selected.forEach(item => {
            selectedClientIds.push(item.id);
        });

        $http.get('/Authorization/User/Databases?isActive=true', { trackerMsg: 'Loading databases' })
            .then(response => {
                //  Filters out databases that are on the Selected list.
                $scope.database.list = response.data.filter(item => !selectedClientIds.some(id => item.id === id)).sortBy('clientName');
            });
    }

    //PUBLIC METHODS
    $scope.cancel = () => {
        dialog.close();
    }

    $scope.save = () => {
        databaseFilterService.passDbList($scope.database.selected);
        localStorage.setItem('unselectedDatabases', angular.toJson($scope.database.list.sortBy('clientName')));
        dialog.close();
    };

    //INITIALIZE
    $scope.database = {
        list: storedList,
        selected: complianceFilters
    };
    init();
});
'use strict';
app.controller('ConcurLinkingCtrl', function ConcurLinkingCtrl($http, $scope, dialog, API_CONFIG) {

    //PRIVATE VARIABLES
    //PRIVATE METHODS
    function init() {
        $http.get('/Compliance/Inform/AccessPerson/ConcurUsersToLink')
        .then(res => {
            if (res) {
                $scope.unlinkedUsersList = res.data.sortBy("name");
            }
        });
    }

    //PUBLIC METHODS
    $scope.ignoreUser = () => {
        if ($scope.unlinkedUser.shouldIgnore) {
            $scope.current.selectedOption = {id: null, name: null}
        } 
    }

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.submit = function () {
        if ($scope.current.selectedOption === null) {
            $scope.unlinkedUser.accessPersonId = null;
            $scope.unlinkedUser.informAccessPerson = null;
        } else {
            $scope.unlinkedUser.accessPersonId = $scope.current.selectedOption.id;
            $scope.unlinkedUser.informAccessPerson = $scope.current.selectedOption.name;
        }
        
        dialog.close($scope.unlinkedUser);
    };

    //INITIALIZE
    $scope.unlinkedUser = dialog.options.unlinkedUser;
    $scope.current = {
        selectedOption: {
            id: $scope.unlinkedUser.accessPersonId === null ? null : $scope.unlinkedUser.accessPersonId,
            name: $scope.unlinkedUser.informAccessPerson === null ? null: $scope.unlinkedUser.informAccessPerson
        }
    };
    $scope.unlinkedUsersList = [];
    init();
});

'use strict';

app.controller('LexisNexisCtrl', function LexisNexisCtrl($scope, views, $dialog, $http, $location, $oasRights, $rootScope, $routeParams) {
    //PRIVATE VARIABLES
    var runNowServiceUrl = '/Integrations/LexisNexis/Actions/RunNow',
        getConfigurationUrl = '/Integrations/LexisNexis/Configuration';

    const complianceFilterName = "compliance_filters_" + $scope.user.id;

    //PRIVATE METHODS
    function init() {

        switch($rootScope.user.authorization.entity) {
            case 'Administrator':
            case 'Advisor':
                //only do this check if the user the privilege
                $http.get('/Integrations/LexisNexis/Configuration', {

                    trackerMsg: 'Checking LexisNexis configuration...'
                })
                    .then(function (response) {
                        $scope.hasLexisNexisInstalled = $scope.rightsLexisNexis.canRead && response.data.installed;
                        if ($scope.hasLexisNexisInstalled) {
                            $http.get(getConfigurationUrl, {

                                trackerMsg: 'Fetching LexisNexis details...'
                            })
                                .then(function (response) {
                                    var config = response.data;
                                    $scope.lastScan = config.lastSearch ? config.lastSearch : (!config.lastSent ? 'Never scanned' : config.lastSent);
                                    $scope.isRunning = config.isProcessing;
                                    addComplianceFilters();
                                });
                        }
                    });
                break;
            default:
                $scope.hasLexisNexisInstalled = false;
        }
    }

    function addComplianceFilters(){
        let sessionFilters = JSON.parse(localStorage.getItem(complianceFilterName));
        if(sessionFilters === null){
            sessionFilters = [];
        }
        sessionFilters.forEach( function (item){
            if(item.label === "Database"){
                return;
            }
            if(item.selected.length > 0 && ["RIA", "Representative", "Broker/Dealer"].find(item.label)){
                //only filter for a subset of Compliance filters
                const filterKey = item.label === 'RIA' ? 'ria' : item.label.substring(0,1).toLowerCase() + item.label.substring(1);
                const filterName =  item.label + ' = ' + item.selected.flatten();
                const filter = "(function(a) {return a ?  " + angular.toJson(item.selected) + ".some(function(b) { return a === b }) : false;})";

                $scope.current.view.filters.push({
                    name: filterName,
                    value: filter,
                    key: filterKey,
                    include: true });
            }
        })
    }

    //PUBLIC METHODS
    $scope.slickGridDoubleClick= function () {
        if ($scope.selectedIds.length === 1) {
            $scope.openResultDetailsDialog();
        }
    };

    $scope.refreshGrid = function() {
        $scope.$broadcast('event:lexis-nexis-list-action', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:lexis-nexis-list-action', {action: 'export-data'});
    };

    $scope.openApprovalDialog = function(reviewed) {
        if(!$scope.selectedResults.length) {
            throw new Error('Nothing has been selected for approval.');
        }
        $dialog.dialog({
            dialogClass: "modal wide",
            templateUrl: "tools/compass/lexis-nexis/approval-form.html",
            controller: "ApprovalFormCtrl",
            title: "Approve LexisNexis Result",
            selectedResults: $scope.selectedResults,
            reviewCompleted: reviewed
        })
            .open()
            .then(function(result) {
                if(result) $scope.$broadcast('event:lexis-nexis-list-action', {action: 'refresh-grid'});
            });
    };

    $scope.openResultDetailsDialog = function() {
        if(!$scope.selectedResults.length) {
            $dialog.actionFailed('No result has been selected to show details.' ).open();
        }

        $dialog.dialog({
            dialogClass: "modal wide",
            templateUrl: "tools/compass/lexis-nexis/resultDetails.html",
            controller: "ResultDetailsCtrl",
            title: "LexisNexis Result Details",
            selectedResult: $scope.selectedResults[0]
        })
            .open();
    };

    $scope.runNow = function() {
        $http.post(runNowServiceUrl, null, {trackerMsg: 'Running LexisNexis scan'})
            .then(function(response) {
                var config = response.data;
                $scope.lastScan = config.lastSearch;
                var message = "<p>Your firm's client data has been sent to Lexis Nexis for scanning purposes. To ensure that you receive a notification when results are available, subscribe to LexisNexis notifications by going to your account settings and checking the 'Enabled' button. If you wish to be emailed, check the 'Email' button.</p>";
                return $dialog
                    .messageBox('Lexis Nexis Scan Started', message, [{result: true, label: 'Accept', focus: true}])
                    .open()
                    .then(function() {
                        $scope.$broadcast('event:lexis-nexis-list-action', {action: 'refresh-grid'});
                    });
            })
            .catch(function() {                
                var message = "<p>There was an issue submitting your client data to Lexis Nexis for scanning. Please reach out to the Orion Compliance team at 'Compliance@orionadvisor.com' for assistance with this problem.</p>";
                return $dialog
                    .messageBox('Lexis Nexis Scan Failed', message, [{result: true, label: 'Accept', focus: true}])
                    .open()
                    .then(function() {
                        $scope.$broadcast('event:lexis-nexis-list-action', {action: 'refresh-grid'});
                    });
            });
    };

    $scope.goToHousehold = function(newWindow) {
        var url = '/portfolio/households?entity=5&entityId=' + $scope.selectedResults[0].clientId;
        if(newWindow){
            window.open('#' + url);
        } else {
            $location.url(url);
        }
    };

    $scope.goToRegistration = function(newWindow) {
        var url = '/portfolio/registrations?entity=6&entityId=' + $scope.selectedResults[0].registrationId;
        if(newWindow){
            window.open('#' + url);
        } else {
            $location.url(url);
        }
    };


    //EVENT LISTENERS

    $scope.$on('event:lexis-nexis-selected', function(event, args) {
        //event.stopPropagation();
        $scope.selectedResults = args;
        $scope.canResolve = false;
        $scope.canUnResolve = false;

        var propertyMap = {
            clientId: ["clientId"],
            registrationId: ["registrationId"],
            issueStatus: ["issueStatus"],
        };

        Object.each(args[0], function (key, value) {
            var searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                    if(property === 'issueStatus'){
                        $scope.canResolve = value !== "Closed" ? true : $scope.canResolve;
                        $scope.canUnResolve = value === "Closed" ? true : $scope.canUnResolve;
                    }
                }
            });
        });

    });


    //INITIALIZE
    $scope.rightsLexisNexis = $oasRights.forCode("LEXISNEXIS");
    $scope.rightsVerify = $oasRights.forCode("COMPLIANCEVERIFY");
    $scope.hasLexisNexisInstalled = false;
    $scope.lastScan = 'Never ran';
    $scope.numberOfItemsWithIssues = 0;
    $scope.numberOfReviewedItems = 0;
    $scope.isRunning = true;
    $scope.selectedIds = [];
    $scope.selectedResults = [];
    $scope.token = sessionStorage.oas_token;
    $scope.views = views;
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        view: views[0],
        url: "/Integrations/LexisNexis/Results?open=" + $routeParams.closed
    };

    init();
});

app.controller('ApprovalFormCtrl', function($scope, $http, dialog, tokenFactory) {

    //PRIVATE METHODS
    function UpdateRecords(key, val){

        const body = {
            ids: val.map('id'),
            reason: $scope.reason,
            hasIssue: !$scope.reviewCompleted,
        };

        tokenFactory.getDatabaseToken(key)
            .then(function (token) {
                const url = '/Integrations/LexisNexis/Actions/Approve';
                $http.put(url, body, {headers: {Authorization: "Session " + token}, trackerMsg: 'Approving items'})
                    .then(function() {
                        dialog.close(true);
                    });
            });
    }

    //PUBLIC METHODS
    $scope.results = dialog.options.selectedResults;
    $scope.reason = $scope.results.length === 1 ? $scope.results[0].approvalReason : '';
    $scope.reviewCompleted = dialog.options.reviewCompleted;

    $scope.cancel = function() {
        dialog.close();
    };

    $scope.save = function() {

        const dbGroups = $scope.results.groupBy("alClientId");

        Object.each(dbGroups, function (key, val){
            UpdateRecords(key, val)
         })
        .then(function() {
            dialog.close(true);
        });


    };
});
app.controller('ScanNoticeCtrl', function($scope, $http, dialog) {

    $scope.done = function() {
        dialog.close();
    };
});
app.controller('ResultDetailsCtrl', function($scope, $http, dialog, tokenFactory) {

    $scope.resultItem = dialog.options.selectedResult;
    $scope.resultDetails = null;
    $scope.detailId = $scope.resultItem.id;

    $scope.cancel = function() {
        dialog.close();
    };

    init();

    function checkItemIsNotNull(item){
        return !!item;
    }

    function init() {
        if(!$scope.resultItem.alClientId){
            return;
        }

        tokenFactory.getDatabaseToken($scope.resultItem.alClientId)
            .then(function (token) {
                $http.get('/Integrations/LexisNexis/Results/Details/' + $scope.detailId, {headers: {Authorization: "Session " + token}, trackerMsg: 'Loading LexisNexis result details'})
                    .then(function(response) {
                        $scope.resultDetails = response.data;
                        const details = $scope.resultDetails;

                        const phonenumbers = [details.businessPhone, details.homePhone, details.mobilePhone].filter( checkItemIsNotNull );
                        $scope.resultDetails.clientPhone = phonenumbers.join(', ');

                        const address = [details.address1, details.address2, details.address3, details.city, details.state].filter( checkItemIsNotNull );
                        $scope.resultDetails.address = address.join(', ');
                    });

            });


    }
});
'use strict';

let complianceFilter = app.component('complianceFilter', {
    templateUrl: 'tools/compass/component/compliance-filter.html',
    bindings: {
        onRefresh: "&",
        databaseOnly: "<",
        onHideDatabaseFilter:"="
    },
    controller: ComplianceFilterCtrl
});

function ComplianceFilterCtrl($http, $rootScope, $dialog, databaseFilterService){
    let $ctrl = this;

    $ctrl.current = {
        selectedFilter: null
    };
    
    $ctrl.complianceFilterName = "compliance_filters_" + $rootScope.user.id;

    $ctrl.filters = [
        { label: "Database", selected: [], selectedIds: [], selectedDatabase: [], exclude: false, entity:0, searchText:null, hideSection:true},
        { label: "Business Line", selected: [], selectedIds: [], selectedDatabase: [], exclude: false, entity:79, searchText:null, hideSection:true},
        { label: "RIA", selected: [], selectedIds: [], selectedDatabase: [], exclude: false, entity: 17, searchText:null, hideSection:true},
        { label: "Broker/Dealer", selected: [], selectedIds: [], selectedDatabase: [], exclude: false, entity:2, searchText:null, hideSection:true},
        { label: "Representative", selected: [], selectedIds: [], selectedDatabase: [], exclude: false, entity:4, searchText:null, hideSection:true},
        { label: "Management Style", selected: [], selectedIds: [], selectedDatabase: [], exclude: false, entity:16, searchText:null, hideSection:true},
        { label: "Model", selected: [], selectedIds: [], selectedDatabase: [], exclude: false, entity:27, searchText:null, hideSection:true},
        { label: "Sub-Advisor", selected: [], selectedIds: [], selectedDatabase: [], exclude: false, entity:52, searchText:null, hideSection:true},
        { label: "Custodian", selected: [], selectedIds: [], selectedDatabase: [], exclude: false, entity:18, searchText:null, hideSection:true},
        { label: "Client Category", selected: [], selectedIds: [], selectedDatabase: [], exclude: false, entity:126, searchText:null, hideSection:true},
        { label: "Registration Type", selected: [], selectedIds: [], selectedDatabase: [], exclude: false, entity:94, searchText:null, hideSection:true}
    ];

    //PRIVATE METHODS
    $ctrl.$onInit = function() {
        const sessionFilters = JSON.parse(localStorage.getItem($ctrl.complianceFilterName));

        $ctrl.onHideDatabaseFilter = false;
        $ctrl.filters = !sessionFilters ? $ctrl.filters : sessionFilters;
        $ctrl.filters.forEach( function(item){
            switch (item.label){
                case "Database":
                    if($rootScope.user.authorization.databaseCount === 1 || $rootScope.user.isImpersonating){
                        item.hideSection = true;
                        item.selected = [];
                        localStorage.setItem($ctrl.complianceFilterName, angular.toJson($ctrl.filters));
                        break;
                    }
                    item.hideSection = false;
                    if(item.selected.length > 0) {
                        $ctrl.onHideDatabaseFilter = true;
                    }
                    break;
                default:
                    item.hideSection = $ctrl.databaseOnly ? $ctrl.databaseOnly : false;
            }
        });

        if(!sessionFilters){
            localStorage.setItem($ctrl.complianceFilterName, angular.toJson($ctrl.filters));
        }
   };

   $ctrl.clearAll = function(){
       $ctrl.filters.forEach( function(item){
           item.selected = [];
       });
    };

    $ctrl.removeFilterItem = function(filterList, item){
        filterList.remove(item);
    };

    $ctrl.addFilterOption = function(filter){

        if(filter.searchText == null || filter.searchText == ''){
            return;
        }

        if(filter.selected.find(filter.searchText)){
            filter.searchText = null;
            return;
        }

        filter.selected.push(filter.searchText);
        filter.searchText = null;
    };

    $ctrl.getFilterData = function(entity, searchText){
        const url = "/Compliance/Filter/" + entity + "/" + searchText;
        const dbFilter = $ctrl.filters.find({label: "Database"});
        return $http.post(url, [dbFilter], {cache: false, trackerMsg: 'Searching for ' + searchText.capitalize(false)})
            .then(function (response) {
                return response.data;
            });
    };

    $ctrl.openDatabaseDialog = () => {
        $dialog.dialog({ 
            templateUrl: "tools/compass/modal/database-multi-select.html", 
            controller: "DatabaseMultiSelectCtrl", 
            dialogClass: 'modal wide' 
        })
        .open()
        .then(() => {
            if (databaseFilterService.databaseList) {
                $ctrl.filters.find({label: 'Database'}).selected = databaseFilterService.databaseList;
                localStorage.setItem($ctrl.complianceFilterName, angular.toJson($ctrl.filters));
            }
        })
    };


    $ctrl.refreshDashboard = function(){
        localStorage.setItem($ctrl.complianceFilterName, angular.toJson($ctrl.filters));

        $ctrl.onRefresh();

        $ctrl.onHideDatabaseFilter = false;
        $ctrl.filters.forEach( function(item){
            switch (item.label){
                case "Database":
                    if(item.selected.length > 0) {
                        $ctrl.onHideDatabaseFilter = true;
                    }
                    break;
            }
        });
    };




}
'use strict';

app.service('adminDocumentsService', function adminDocumentsService($rootScope, $http, $dialog) {
    //PRIVATE VARIABLES
    let self = this;
    let currentAccessPerson = null;

    //INITIALIZE
    function init(){
        $http.get('/Compliance/Inform/AccessPerson/CurrentUser')
            .then(function (response) {
                if(response.data){
                    currentAccessPerson= response.data;
                }
            });
    }

    //PRIVATE FUNCTIONS
    function massUpdateStatus(status, selectedIds, selectedRows, updateBroadcastEventName, scope){
        if(selectedRows.length >= 1) {
            if(currentAccessPerson) {
                let hasTheirOwnAccounts = selectedRows.filter(item => {
                    if (item.accessPersonId === currentAccessPerson.id) {
                        return item;
                    }
                });

                if (hasTheirOwnAccounts.length > 0) {
                    $dialog.messageBox("Access Denied", "You cannot update your own documents.").open();
                    return;
                }
            }
            $http.put('/Compliance/Inform/Documents/Status/' + status.value,
                selectedIds,
                {
                    cache: false,
                    trackerMsg: 'Mass updating status.'}
                )
                .then(function (response) {
                    if(response.data){
                        selectedRows.forEach((element)=>{
                            element.status = status.name;
                            scope.$broadcast(updateBroadcastEventName, {action: 'update-item', item: element});
                        });
                    }
                });
        }
    }


    //PUBLIC API
    self.massUpdateStatus = function (status, selectedIds, selectedRows, updateBroadcastEventName, scope) {
        return massUpdateStatus(status, selectedIds, selectedRows, updateBroadcastEventName, scope);
    };

    self.canMassUpdate = function(selectedRows){
        let itemsNotOfStatus = selectedRows.every((val,index,arr)=>{
           return val.status === arr[0].status;
        });

        return itemsNotOfStatus;
    };

    init();
});
'use strict'

app.service('databaseFilterService', function databaseFilterService($rootScope, $http, $dialog) {
    // PRIVATE VARIABLES
    let self = this;

    // PUBLIC API
    self.passDbList = (list) => {
        self.databaseList = list;
    };
});


'use strict';

app.service('informDashboardDataAccess', function informDashboardDataAccess($http) {
    //PRIVATE VARIABLES
    let self = this;
    self.tradeViolations = [];
    self.tradeViolationCount = 0;
    self.preclearances = [];
    self.questionnaires = [];
    self.tasks = [];

    //INITIALIZE
    function init() {
    }

    //PRIVATE FUNCTIONS

    //PUBLIC API
    self.getDashboardPreclearances = function () {
        return $http.get('/Compliance/Inform/Preclearances/V2?accessPersonDashboard=true', { trackerMsg: 'Loading preclearances' });
    }

    self.getAllQuestionnairesAndTasks = () => {
        return $http.get('/Compliance/Inform/Documents/MyDocuments?onlyOpen=true', { trackerMsg: 'Loading questionnaires and tasks' });
    }

    self.getQuestionnaires = (list) => {
        return list.filter((item) => {
            return item.templateType === 'Questionnaire';
        });
    }

    self.getTasks = (list) => {
        return list.reduce((groups, item) => {
            if (item.templateType !== 'Questionnaire') {
                let indexOfGroup = groups.findIndex(i => item.name === i.name);

                const group = indexOfGroup > -1 ? groups[indexOfGroup] : { name: item.name, count: 0, informTemplateId: item.informTemplateId };

                group.count++;
                if (indexOfGroup > -1) {
                    groups[indexOfGroup] = group;
                } else {
                    groups.push(group);
                }
            }
            return groups;
        }, []);
    }

    self.loadTradeViolations = () => {
        return $http.get('/Compliance/Inform/TradeViolations/V2?currentUser=true', { trackerMsg: 'Loading trade violations' });
    };

    self.calculateTradeViolations = (list) => {
        self.tradeViolations = list;
        self.tradeViolationCount = {
            preclearance: 0,
            securities: 0,
            frontRunning: 0,
            roundTrip: 0
        }

        self.tradeViolations.forEach(t => {
            if (t.isPreClearance) {
                self.tradeViolationCount.preclearance++;
            }
            if (t.isSecuritiesViolation) {
                self.tradeViolationCount.securities++;
            }
            if (t.isFrontRunning) {
                self.tradeViolationCount.frontRunning++;
            }
            if (t.isRoundTrip30) {
                self.tradeViolationCount.roundTrip++;
            }
        });
    }

    self.getTaskTemplates = () => {
        return $http.get('/Compliance/Inform/Templates/Task', { trackerMsg: 'Loading task options' });
    }

    self.getLibraryDocuments = () => {
        return $http.get('/Compliance/Inform/Policy?isActive=true&isVisible=true', { trackerMsg: 'Loading library' });
    }

    init();
});
'use strict';

app.controller('InformDashboardCtrl', function InformDashboardCtrl($scope, $http, $q, $dialog, API_CONFIG, $rootScope, informDashboardDataAccess) {
    const retirementRecordSource = 'Unconnected Account';
    var connectionLock = null;

    //PRIVATE METHODS
    function init() {
        //check for valid access person record
        $http.get('/Compliance/Inform/AccessPerson/CurrentUser', { trackerMsg: 'Loading user details' })
            .then(function (response) {
                $scope.accessPerson = response.data;

                if (!$scope.accessPerson || !$scope.accessPerson.isActive) {
                    $scope.missingSetup = true;
                } else {

                    loadConnectionSources();

                    loadPreclearances();

                    loadQuestionnairesAndTasks();

                    loadTradeViolations();

                    informDashboardDataAccess.getTaskTemplates()
                    .then((response) =>{
                        $scope.taskTemplates = response.data.sortBy('templateName').filter(function (item) {
                            return item.id !== -1 && item.isActive;
                        }); //-1 brokerage accounts
                    });

                    informDashboardDataAccess.getLibraryDocuments()
                        .then(function (response) {
                            $scope.policies = response.data.sortBy('policyName');
                        });

                    loadConnections();
                }
            });
    }

    $scope.connectionSourceAction = function (connectionSource) {
        connectionSource.action(null, connectionSource.downloadSourceId);
    };

    $scope.connectionEditAction = function (downloadFormatId, connection) {
        $scope.connectionSourceEnum[downloadFormatId].action(connection);
    };

    $scope.deleteAction = function (downloadFormatId, connection) {
        $scope.connectionSourceEnum[downloadFormatId].deleteAction(connection);
    };

    function loadConnectionSources() {
        $http.get('/Compliance/Inform/Connections/V2/ConnectionSources', { trackerMsg: 'Loading brokerage account connection sources' })
            .then(function (response) {
                if (response.data) {
                    //configure our connection sources
                    setupConnectionSourceEnum(response.data);
                    response.data.forEach((item) => {
                        if (item.downloadFormatName === 'InformByAllAccounts') {
                            $scope.isByAllSetup = true;
                        }
                    });
                }
            });
    }

    function setupConnectionSourceEnum(data) {
        $scope.connectionSources = data.map(item => {
            let source = $scope.connectionSourceEnum[item.downloadFormatName];
            source.downloadSourceId = item.downloadSourceId;

            return source;
        });
    }

    function loadPreclearances() {
        informDashboardDataAccess.getDashboardPreclearances()
            .then(function (response) {
                $scope.preclearances = response.data;
            });
    }

    function loadQuestionnairesAndTasks() {
        informDashboardDataAccess.getAllQuestionnairesAndTasks()
            .then(function (response) {
                const data = response.data;

                $scope.questionnaires = informDashboardDataAccess.getQuestionnaires(data);
                $scope.tasks = informDashboardDataAccess.getTasks(data);
            });
    }

    function loadTradeViolations() {
        informDashboardDataAccess.loadTradeViolations()
            .then(function (response) {
                informDashboardDataAccess.calculateTradeViolations(response.data);
                $scope.tradeViolations = informDashboardDataAccess.tradeViolations;
                $scope.tradeViolationCount = informDashboardDataAccess.tradeViolationCount;
            });
    }

    function flattenUserConnections(data) {
        let connections = [];

        for (let item of data) {
            for (let connection of item.connections) {
                connection.downloadFormatId = item.downloadFormatId;

                connection.canDeleteAction = $scope.connectionSourceEnum[connection.downloadFormatName].canDeleteAction;

                if (connection.downloadFormatName === 'InformByAllAccounts') {
                    $scope.hadByAllConnections = true;
                }

                connections.push(connection);
            }
        }

        let sortedByInstitutionName = connections.sort((obj1, obj2) => {
            if (obj1.institutionName === null) {
                obj1.institutionName = "";
            }
            if (obj2.institutionName === null) {
                obj2.institutionName = "";
            }

            if (obj1.institutionName.toLowerCase() > obj2.institutionName.toLowerCase()) {
                return 1;
            }
            if (obj1.institutionName.toLowerCase() < obj2.institutionName.toLowerCase()) {
                return -1;
            }
        });

        $scope.connectionSourceUsers = sortedByInstitutionName.sort((obj1, obj2) => {
            if (obj1.requiresAttention === 1 || obj2.requiresAttention === 1)
                return -1;

            return 0;
        });

        filterClosedAccounts();
    }

    function loadConnections() {
        $http.get('/Compliance/Inform/Connections/CurrentUser', { trackerMsg: 'Loading connections' })
            .then(function (response) {
                flattenUserConnections(response.data);
            });
    }

    function getBrokerageAccountDialog(account) {
        const options = {
            templateUrl: "tools/inform/modal/inform-brokerage-account-dialog.html",
            controller: "InformBrokerageAccountDialogCtrl",
            brokerageAccount: account,
            dialogClass: 'modal wide'
        };
        $dialog.dialog(options)
            .open()
            .then(function (result) {
                if (!result) return;
                loadConnections();
            });
    }

    function filterClosedAccounts() {
        const closedStatus = ['Closed', 'Denied'];
        angular.copy($scope.connectionSourceUsers, $scope.connectionSourceUsersFiltered);

        if (!$scope.current.showClosed) {
            let connections = [];
            for (let connectionIndex = 0; connectionIndex < $scope.connectionSourceUsersFiltered.length; connectionIndex++) {
                let connection = $scope.connectionSourceUsersFiltered[connectionIndex];

                if (connection.isActive === false) {
                    connections.add(connection);
                    continue;
                }

                if (!connection.brokerageAccounts) {
                    continue;
                }

                let closedBrokerageAccounts = connection.brokerageAccounts.filter((item) => {
                    return closedStatus.find(item.currentStatus);
                });

                if (connection.brokerageAccounts.length > 0 && closedBrokerageAccounts.length === connection.brokerageAccounts.length) {
                    connections.add(connection);
                }

                connection.brokerageAccounts = connection.brokerageAccounts.filter((item) => {
                    return !closedStatus.find(item.currentStatus);
                });
            }

            for (let connection of connections) {
                $scope.connectionSourceUsersFiltered.remove(connection);
            }
        }
    }

    function refreshByAllConnectionsAndAccounts() {
        $http.get('/Compliance/Inform/Connections/LinkToByAllConnections', { trackerMsg: 'Linking connections' })
            .then(() => {
                loadConnections();
            });
    }

    function discoverByAllAccounts() {
        $http.get('/Compliance/Inform/Connections/DiscoverByAllAccounts', { trackerMsg: 'Discovering accounts' })
            .then(() => {
                refreshByAllConnectionsAndAccounts();
            });
    }
    //PUBLIC METHODS
    $scope.editQuestionnaire = function (questionnaire, templateId) {
        const options = {
            templateUrl: "tools/inform/modal/inform-questionnaire-dialog.html",
            controller: "InformQuestionnaireDialogCtrl",
            id: questionnaire ? questionnaire.id : null,
            templateId: templateId,
            dialogClass: 'edit-pane',
            previewDocument: false,
        };

        $dialog.dialog(options)
            .open()
            .then(function (result) {
                if (!result) return;

                loadQuestionnairesAndTasks();
            });
    };

    $scope.downloadPolicy = function (policy) {
        window.location.href = API_CONFIG.baseUrl + '/Compliance/Inform/Policy/Download/Policy/' + policy.id + '?Authorization=' + sessionStorage.oas_token;
    };

    $scope.editAccount = function (id) {
        $http.get('/Compliance/Inform/BrokerageAccount/' + id, { trackerMsg: 'Loading account details' })
            .then(function (response) {
                getBrokerageAccountDialog(response.data);
            });
    };

    $scope.viewTradeViolation = function (violation) {
        $dialog.dialog({
            templateUrl: "tools/compass/inform/modal/trade-violation-dialog.html",
            controller: "TradeViolationDialogCtrl",
            tradeViolation: angular.copy(violation),
            dialogClass: 'modal wide'
        })
            .open()
            .then(function (result) {
                if (result) {
                    loadTradeViolations();
                }
            });
    };

    $scope.editAccessPerson = function () {
        $dialog.dialog({
            templateUrl: "tools/compass/inform/modal/access-person-dialog.html",
            controller: "AccessPersonDialogCtrl",
            id: $scope.accessPerson.id,
            dialogClass: 'modal wide'
        })
            .open()
            .then(function (result) {
                $scope.accessperson = result;
            });
    };

    $scope.addRetirementAccount = function () {
        const brokerageAccount = {
            userDetailId: $rootScope.user.authorization.userDetailId,
            currentStatus: "New",
            recordSource: retirementRecordSource,
            managedAccount: true,
            attachments: [],
            statusHistory: []
        };
        $dialog.dialog({
            templateUrl: "tools/inform/modal/inform-brokerage-account-dialog.html",
            controller: "InformBrokerageAccountDialogCtrl",
            brokerageAccount: brokerageAccount,
            dialogClass: 'modal wide'
        })
            .open()
            .then(function (result) {
                if (!result) return;
                //loadBrokerageAccounts();
                loadConnections();
            });
    };

    $scope.getBadgeFromStatus = function (status) {
        return {
            Submitted: "badge-info",
            Approved: "badge-success",
            "Approved - Auto": "badge-success",
            Active: "badge-success",
            Canceled: "badge-info",
            Denied: "badge-danger",
            "Denied - Auto": "badge-danger",
            New: "badge-success",
            "Not Submitted": "badge-warning",
            "Follow-up": "badge-warning",
            "Verbal Warning": "badge-warning",
            "Written Warning": "badge-warning",
            "Loss of Trading Privileges": "badge-warning",
            Termination: "badge-danger",
            "Other": "badge-success"
        }[status];
    };

    $scope.addAccount = function () {
        $scope.editAccount();
    };

    $scope.addTask = function (template) {
        if (template.id === -2) {
            $scope.viewPreclearance();
        } else {
            $scope.editQuestionnaire(null, template.id);
        }
    };

    $scope.viewPreclearance = function (preclearance) {
        const options = {
            templateUrl: "tools/inform/modal/inform-new-preclearance-dialog.html",
            controller: "InformPreClearanceDialogCtrl",
            preclearance: preclearance,
            accessPersonId: $scope.accessPerson.id,
            dialogClass: 'modal wide'
        };

        $dialog.dialog(options)
            .open()
            .then(function (result) {
                if (!result) return;

                loadPreclearances();
            });
    };

    $scope.viewTask = function (task) {
        $scope.editQuestionnaire(task, null);
    };

    $scope.addPlaidConnections = function (connection, downloadSourceId) {
        let url = "/Integrations/Plaid/LinkTokens?appName=Inform&isInform=true";

        if (connection) {
            url = `/Integrations/Plaid/LinkTokens?appName=Inform&itemId=${connection.sourceConnectionId}&isInform=true`;
        }

        $http.get(url, { trackerMsg: 'Loading Plaid connection wizard.' })
            .then(function (response) {
                var linkToken = response.data.link_token;

                const configs = {
                    // Required, fetch a link token from your server and pass it
                    // back to your app to initialize Link.
                    token: linkToken,
                    onLoad: function () {
                        // Optional, called when Link loads
                    },
                    onSuccess: function (public_token, metadata) {
                        // Send the public_token to your app server.
                        // The metadata object contains info about the institution the
                        // user selected and the account ID or IDs, if the
                        // Select Account view is enabled.

                        //look up connection by institution id so we don't end up with duplicate items to the same institution
                        let institutionExists = $scope.connectionSourceUsers.find((item) => {
                            return item.institutionId === metadata.institution.institution_id;
                        });
                        if (institutionExists) {
                            $dialog.messageBox("<i class='fa fa-lg fa-exclamation-circle text-error' aria-hidden='true'></i> Duplicate Custodian Being Added",
                                " You cannot add the same custodian multiple times. Your connection wasn't added").open();
                        } else {
                            if (!connection) {
                                $http.get(`/Integrations/Plaid/Items?publicToken=${public_token}&isInform=true`, { trackerMsg: 'Saving new Plaid connection.' })
                                    .then(function (response) {
                                        //save in our connection tables
                                        let postUrl = "/Compliance/Inform/Connection/";
                                        const connectionConst = {
                                            sourceConnectionId: response.data.item_id,
                                            connectionStatus: "good",
                                            institutionName: metadata.institution.name,
                                            institutionId: metadata.institution.institution_id,
                                            informUser: { downloadSourceId: downloadSourceId }
                                        };
                                        $http.post(postUrl, connectionConst, { trackerMsg: 'Saving new Plaid connection in Inform' })
                                            .then(function (response) {
                                                //add accounts from metadata.accounts
                                                let accountPromises = [];

                                                metadata.accounts.forEach((item) => {
                                                    //we only want investment accounts
                                                    if (item.type === "investment") {
                                                        let accountToAdd = {
                                                            userDetailId: $scope.accessPerson.userDetailId,
                                                            currentStatus: "New",
                                                            recordSource: "Plaid",
                                                            managedAccount: false,
                                                            accountName: item.name,
                                                            institutionName: metadata.institution.name,
                                                            statementFrequency: "Quarterly",
                                                            isActive: true,
                                                            informConnectionId: response.data.id,
                                                            sourceAccountId: item.id,
                                                        };
                                                        accountPromises.add($http.post("/Compliance/Inform/BrokerageAccounts", accountToAdd, { trackerMsg: `Saving account ${item.name}` }));
                                                    }
                                                });

                                                Promise.all(accountPromises).then(() => {
                                                    //reload the connections
                                                    loadConnections();
                                                });
                                            });
                                    });
                            } else {
                                let updateUrl = `/Compliance/Inform/Connection/${connection.id}`;
                                const connectionConst = {
                                    sourceConnectionId: connection.sourceConnectionId,
                                    connectionStatus: 'good',
                                    id: connection.id,
                                };

                                $http.put(updateUrl, connectionConst, { trackerMsg: 'Saving Plaid connection.' })
                                    .then((response) => {
                                        //save in our connection tables
                                        loadConnections();
                                    });
                            }
                        }
                    },
                    onExit: function (err, metadata) {
                        // The user exited the Link flow.
                        if (err != null) {
                            // The user encountered a Plaid API error prior to exiting.
                            if (err.error_code === 'INVALID_LINK_TOKEN') {
                                // The link_token expired or the user entered too many
                                // invalid credentials. We want to destroy the old iframe
                                // and reinitialize Plaid Link with a new link_token.
                                handler.destroy();
                                handler = Plaid.create({
                                    ...configs,
                                    token: fetchLinkToken(),
                                });
                            }
                        }
                        // metadata contains information about the institution
                        // that the user selected and the most recent API request IDs.
                        // Storing this information can be helpful for support.
                    },
                    onEvent: function (eventName, metadata) {
                        // Optionally capture Link flow events, streamed through
                        // this callback as your users connect an Item to Plaid.
                        // For example:
                        // eventName = "TRANSITION_VIEW"
                        // metadata  = {
                        //   link_session_id: "123-abc",
                        //   mfa_type:        "questions",
                        //   timestamp:       "2017-09-14T14:42:19.350Z",
                        //   view_name:       "MFA",
                        // }
                    }
                };

                let handler = Plaid.create(configs);
                handler.open();
            });
    };

    $scope.addOrionConnection = function (connection) {
        let isInform = true;

        $dialog.dialog({ templateUrl: "app/modals/login.html", controller: "LoginCtrl", isInform })
            .open()
            .then(() => {
                loadConnections();
            });
    };

    $scope.addBaaConnection = function (connection, downloadSourceId) {
        if (location.protocol !== 'https:') {
            $dialog.messageBox("Unsecure connection!", "Adding accounts can only be done with a secure connection to Orion Connect. Please contact Compliance at Orion for further details.")
                .open()
                .then(function () {
                    $dialog.close();
                });
            return;
        }

        const options = {
            templateUrl: "tools/inform/modal/byAll-Connections-dialog.html",
            dialogClass: 'modal wide',
            controller: "ByAllConnectionsDialogCtrl",
            downloadSourceId: downloadSourceId,
            connection: connection,
            isBaaMigration: $scope.isMigrating,
        };

        $dialog.dialog(options)
            .open()
            .then((response) => {
                if (response.hasAgreedToUserAgreement) {
                    console.log($scope.hasAgreedToUserAgreement);
                    refreshByAllConnectionsAndAccounts();
                }
            });
    };

    $scope.deletePlaidConnection = function (connection) {
        $dialog.messageBox("Confirm deletion of connection", "Are you sure you want to delete this connection?", [{
            result: true,
            label: 'Yes',
            focus: true,
            cssClass: "btn-primary pull-right"
        }, { result: false, label: 'No', focus: false, cssClass: "pull-left" }])
            .open()
            .then((msgBoxAnswer) => {
                if (msgBoxAnswer) {
                    $http.delete(`/Compliance/Inform/AccessPerson/${connection.accessPerson.id}/Connection/${connection.id}`, { trackerMsg: 'deleting connection' })
                        .then((response) => {
                            $http.delete(`/Integrations/Plaid/DeleteItem?${connection.sourceConnectionId}`, { trackerMsg: 'finishing delete of connection' })
                                .then((response) => {
                                    loadConnections();
                                });
                        });
                }
            });
    };

    $scope.showToggledAccounts = function () {
        $scope.current.showClosed = !$scope.current.showClosed;
        filterClosedAccounts();
    };

    $scope.discoverByAllAccounts = function () {
        discoverByAllAccounts();
    };

    //INITIALIZE
    $scope.custodianConnections = [];
    $scope.retirementAccounts = [];
    $scope.missingSetup = false;
    $scope.current = {
        showClosed: false,
    };
    $scope.connectionSourceUsers = [];
    $scope.connectionSourceEnum = [];
    $scope.connectionSourceUsersFiltered = [];
    $scope.isByAllSetup = false;
    $scope.isMigrating = false;
    $scope.hadByAllConnections = false;
    $scope.questionnaires = [];
    $scope.tasks = [];

    $scope.connectionSourceEnum['Deprecated Format'] =
    {
        dropDownDisplayText: 'Unknonwn',
        action: null,
        deleteAction: null,
        displayHeader: '3rd Party Connected Accounts',
        canDeleteAction: false,
        downloadFormatName: 'Deprecated Format',
        sortOrder: 1,
    };
    $scope.connectionSourceEnum['QuovoApiInform'] =
    {
        dropDownDisplayText: 'New Account',
        action: $scope.addCustodianConnections,
        deleteAction: null,
        displayHeader: '3rd Party Connected Accounts',
        canDeleteAction: false,
        downloadFormatName: 'QuovoApiInform',
        sortOrder: 1,
    };
    $scope.connectionSourceEnum['InformPlaid'] =
    {
        dropDownDisplayText: 'New Account',
        action: $scope.addPlaidConnections,
        deleteAction: $scope.deletePlaidConnection,
        displayHeader: '3rd Party Connected Accounts',
        canDeleteAction: true,
        downloadFormatName: 'InformPlaid',
        sortOrder: 1,
    };
    $scope.connectionSourceEnum['InformByAllAccounts'] =
    {
        dropDownDisplayText: 'New Account',
        action: $scope.addBaaConnection,
        deleteAction: null,
        displayHeader: '3rd Party Connected Accounts',
        canDeleteAction: false,
        downloadFormatName: 'InformByAllAccounts',
        sortOrder: 1,
    };
    $scope.connectionSourceEnum['InformOrionConnect'] =
    {
        dropDownDisplayText: 'Orion Connect Account(s)',
        action: $scope.addOrionConnection,
        deleteAction: null,
        displayHeader: 'Orion Connected Accounts',
        canDeleteAction: false,
        downloadFormatName: 'InformOrionConnect',
        sortOrder: 2,
    };
    $scope.connectionSourceEnum['InformRetirementAcct'] =
    {
        dropDownDisplayText: retirementRecordSource,
        action: $scope.addRetirementAccount,
        deleteAction: null,
        displayHeader: 'Unconnected Accounts',
        canDeleteAction: false,
        downloadFormatName: 'InformRetirementAcct',
        sortOrder: 3,
    };
    $scope.connectionSourceEnum['Unknown Connected Accounts'] =
    {
        dropDownDisplayText: 'Unknonwn',
        action: null,
        deleteAction: null,
        displayHeader: 'Unknown Connected Accounts',
        downloadFormatName: '',
        sortOrder: 5,
    };

    init();
});
'use strict';

app.controller('InformTradingCtrl', function InformTradingCtrl($scope, $http, $dialog) {
    // PRIVATE METHODS
    function init() {
        $http.get('/Compliance/Inform/Preclearances/V2?allPreclearances=false', {

            trackerMsg: 'Loading preclearances'
        })
            .then(function (response) {
                $scope.preclearances = response.data.filter(function (preclearance) {
                    var statusToView = ["Submitted","Denied","Approved"];
                    if (statusToView.any(preclearance.status )) {
                        return preclearance;
                    }
                });
            });

        $http.get('/Compliance/Inform/BrokerageAccounts?allAccounts=false', {

            trackerMsg: 'Loading brokerage accounts'
        })
            .then(function (response) {
                $scope.accounts = response.data;
            });
    }

    // PUBLIC METHODS
    $scope.showPreclearance = function preclearanceDialog(preclearance) {
        var options = {
            templateUrl: "tools/inform/modal/inform-new-preclearance-dialog.html",
            controller: "InformPreClearanceDialogCtrl",
            preclearance: preclearance,
            accounts: $scope.accounts,
            dialogClass: 'modal wide'
        };

        $dialog.dialog(options).open();
    };

    $scope.getBadgeFromStatus = function (status) {
        return {
            Submitted: "badge-info",
            Approved: "badge-success",
            Active: "badge-success",
            Canceled:"badge-info",
            Denied: "btn-danger",
            New: "badge-success",
            "Not Submitted": "badge-warning",
            "Follow-up": "badge-warning",
            "Verbal Warning":  "badge-warning",
            "Written Warning":  "badge-warning",
            "Loss of Trading Privileges": "badge-warning",
            Termination: "btn-danger",
            "Other":"btn-success"
        }[status];
    };

    //Initialize
    $scope.preclearances=[];
    init();
});
'use strict';

app.controller('InformTasksCtrl', function InformTasksCtrl($scope, $http, $routeParams) {
    var accessPersonId = 0;

    // PRIVATE METHODS
    function init() {

        $http.get('/Compliance/Inform/Documents/MyTasks', { trackerMsg: 'Loading task summary' })
            .then(function (response) {
                $scope.tasks = response.data;
            });

        $http.get('/Compliance/Inform/AccessPerson/CurrentUser', { trackerMsg: '' })
            .then(function (response) {
                accessPersonId = response.data.id;
            });
        // const r = $routeParams;
    }

    // PUBLIC METHODS
    $scope.urlMapper = (task) => {
        if (task.id === -2) {
            return `#/tools/inform/preclearances/${accessPersonId}/true`;
        } else {
            return `#/tools/inform/tasks/${task.id}/${task.templateName.replace("/", "-")}`;
        }
    }

    //Initialize
    init();
});
'use strict';

app.controller('InformPreclearanceCtrl', function InformPreclearanceCtrl($scope, $http, $oasRights, views, $dialog, API_CONFIG, $location, $rootScope, informWorkflowStatus, $routeParams) {

    //PRIVATE VARIABLES
    let selectedRows;


    //PRIVATE METHODS
    function init() {
        $http.get('/Compliance/Inform/AccessPerson/CurrentUser')
            .then(function (response) {
                if(response.data) {
                    $scope.currentAccessPerson = response.data;
                }
            });
    }


    function openPreClearance() {

        let preclearance = angular.copy(selectedRows[0]);
        const account = {
            id: preclearance.brokerageAccountId,
            accountName: preclearance.brokerageAccount.accountName,
            nickName: preclearance.brokerageAccount.nickName
        };
        const options = {
            templateUrl: "tools/inform/modal/inform-new-preclearance-dialog.html",
            controller: "InformPreClearanceDialogCtrl",
            preclearance: preclearance,
            accessPersonId: preclearance.accessPerson.id,
            accounts: [account],
            dialogClass: 'modal wide'
        };
        $dialog.dialog(options)
            .open()
            .then(function (result) {
                if(!result) return;

                if(preclearance) {
                    Object.merge(preclearance, result);
                    $scope.$broadcast('event:preclearance-detail-reload', { action: 'upsert-items', items: [preclearance] });
                }
            });
    }


    //PUBLIC METHODS

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:preclearance-detail-export', { action: 'export-data' });
    };

    $scope.slickGridDoubleClick = function () {
        openPreClearance();
    };

    $scope.openPreClearance = function () {
        openPreClearance();
    };

    $scope.refreshGrid = function () {
        $scope.$broadcast('event:preclearance-detail-reload', { action: 'refresh-grid' });
    };

    $scope.$on('event:preclearance-detail-select', function (e, args) {
        if(args.length === 0) return;

        selectedRows = args;
    });

    //INITIALIZE
    // const currentUserDetailId = $rootScope.user.authorization.userDetailId;
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.editMode = $scope.rightsCompassInform.canUpdate;
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: `/Compliance/Inform/Preclearances/V2/AccessPerson/${$routeParams.accessPersonId}` + 
            ($routeParams.all !== "true" ? '?onlyOpenStatuses=false':''),
        view: views[0],
        editMode: false,
        gridQueries: []
    };
    init();
});


'use strict';

let informTaskDetail = app.controller('InformTaskDetailCtrl', function InformTaskDetailCtrl($scope, $http, $oasRights, $dialog, API_CONFIG,$location, $routeParams, $rootScope, config ) {

    //PRIVATE VARIABLES
    let selectedRows;

    //PRIVATE METHODS
    function init(){
        var path = $location.path();
        $scope.addBreadcrumb($routeParams.templateName, path);
    }

    function openTemplateDialog(thisTask){

        $dialog.dialog({templateUrl: "tools/inform/modal/inform-questionnaire-dialog.html",controller: "InformQuestionnaireDialogCtrl", id: thisTask.id, dialogClass: 'modal wide'})
            .open()
            .then(function (response) {
                if(response){
                    Object.merge(thisTask,response);
                    //since the grid column is named differently from the dto we have to do the following manual update.
                    thisTask.status = response.documentStatus;
                    $scope.$broadcast('event:inform-tasks-reload', {action: 'upsert-items', items: [thisTask]});
                }

            });

    }

    //PUBLIC METHODS

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:inform-detail-export', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function(){
        $scope.openTemplateDialog();
    };

    $scope.refreshGrid = function() {
        $scope.$broadcast('event:inform-tasks-reload', {action: 'refresh-grid'});
    };

    $scope.openTemplateDialog = function(){
        if(selectedRows.length === 1){
            openTemplateDialog(selectedRows[0]);
        }
    };


    $scope.viewAccessPersonDetail = function(){
        if(selectedRows.length === 1){
            const path = '/tools/compass/inform/accessPerson/'+  selectedRows[0].accessPersonId;
            $location.path(path);
        }
    };

    $scope.$on('event:tasks-detail-select', function (e, args) {
        if (args.length === 0) return;

        selectedRows = args;

        const propertyMap = {
            id: ["id"],
            accessPersonId: ["accessPersonId"]
        };

        Object.each(args[0], function (key, value) {
            let searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
    });

    //INITIALIZE
    const currentUserDetailId = $rootScope.user.authorization.userDetailId;
    $scope.views = [config];
    $scope.selectedIds = [];
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.editMode = $scope.rightsCompassInform.canEdit;
    $scope.templateName = $routeParams.templateName;
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: "/Compliance/Inform/Documents/" + $routeParams.templateId + "/" + config.dataQueryCacheKey,
        view: $scope.views[0],
        editMode: false,
        gridQueries: [],
        dataQueryCacheKey: null,
        dataQueryId: 0,
        dataQueryTitle: '',
        dataQueryEntity: null,
        returnData: null,
        filename: null,
    };
    init();
});

informTaskDetail.loadInformTaskDetail = ["$http","$route", function ($http,$route) {
    return $http.get("/Compliance/Inform/Documents/" + $route.current.params.templateId + "?currentUser=true", {trackerMsg: 'Loading details'})
        .then(function (response) {
            return response.data;
        });
}];

'use strict';

app.controller('InformQuestionnairesCtrl', function InformQuestionnairesCtrl($scope, $http, $oasRights, $dialog) {


    // PRIVATE METHODS
    function init() {
        $http.get('/Compliance/Inform/Documents/MyDocuments', {

            trackerMsg: 'Loading questionnaires'
        })
            .then(function (response) {
                $scope.questionnaires = response.data.filter(function (document) {
                    if (document.templateType !== 'Task' && document.templateType !== 'Task With Multiple')
                        return document;
                });
            });
    }

    // PUBLIC METHODS
    $scope.showQuestionnaire = function (questionnaire, templateId) {
        const options = {
            templateUrl: "tools/inform/modal/inform-questionnaire-dialog.html",
            controller: "InformQuestionnaireDialogCtrl",
            id: questionnaire ? questionnaire.id : null,
            templateId: templateId ? templateId : null,
            dialogClass: 'edit-pane'
        };

        $dialog.dialog(options).open();
    };

    $scope.getBadgeFromStatus = function (status) {
        return {
            Submitted: "badge-info",
            Approved: "badge-success",
            Active: "badge-success",
            Canceled:"badge-info",
            Denied: "btn-danger",
            New: "badge-success",
            "Not Submitted": "badge-warning",
            "Follow-up": "badge-warning",
            "Verbal Warning":  "badge-warning",
            "Written Warning":  "badge-warning",
            "Loss of Trading Privileges": "badge-warning",
            Termination: "btn-danger",
            "Other":"btn-success"
        }[status];
    };

    // INITIALIZE
    $scope.questionnaires=[];

    init();
});
'use strict';

app.controller('InformTradeViolationsCtrl', function InformTradeViolationsCtrl($scope, $http, $oasRights, $dialog) {

    // PRIVATE METHODS
    function init() {
        $http.get('/Compliance/Inform/TradeViolations/V2?currentUser=true', {trackerMsg: 'Loading trade violations'})
            .then(function (response) {
                $scope.tradeViolations = response.data;
            });
    }

    // PUBLIC METHODS
    $scope.tradeViolationDialog = function(thisTradeViolation){
        $dialog.dialog({templateUrl: "tools/compass/inform/modal/trade-violation-dialog.html",controller: "TradeViolationDialogCtrl", tradeViolation: angular.copy(thisTradeViolation) ,dialogClass: 'modal wide'})
            .open()
            .then(function (response) {
                if(response){
                    Object.merge(thisTradeViolation,response);
                }
            });
    };

    $scope.getBadgeFromStatus = function (status) {
        return {
            Closed:"badge-info",
            Denied: "btn-danger",
            New: "badge-success",
            "Follow-up": "badge-warning",
            Termination: "btn-danger",
            "Other":"btn-success"
        }[status];
    };

    // INITIALIZE
    $scope.tradeViolations=[];

    init();
});
'use strict';

app.controller('InformHistoricalDocumentsCtrl', function InformHistoricalDocumentsCtrl($scope, $http, $oasRights, views, API_CONFIG) {

    //PRIVATE VARIABLES
    let selectedRows;

    //PUBLIC METHODS

    $scope.exportToExcel = () => {
        $scope.$broadcast('event:historical-document-export', { action: 'export-data' });
    };

    $scope.slickGridDoubleClick = () => {
        $scope.downloadDocument();
    };

    $scope.refreshGrid = () => {
        $scope.$broadcast('event:historical-document-reload', { action: 'refresh-grid' });
    };

    $scope.downloadDocument = () => {
        if (selectedRows.length === 1) {
            window.location.href = API_CONFIG.baseUrl + '/Compliance/Inform/HistoricalDocuments/Download/HistoricalDocuments/' + selectedRows[0].id + '?Authorization=' + sessionStorage.oas_token;
        }
    }

    $scope.$on('event:historical-document-select', (e, args) => {
        if(args.length === 0) {
            return;
        }

        selectedRows = args;

        const propertyMap = {
            id: ["id"],
            active: ["isactive"],
            visible: ["isvisible"],
            documents: ["documents"],
            type: ["librarytype"]
        };

        Object.each(args[0], function (key, value) {
            let searchProperty = key.toLowerCase().replace(/ /g, '');
            Object.each(propertyMap, function (property, matchList) {
                if (searchProperty === property.toLowerCase() || matchList.any(searchProperty)) {
                    $scope.current[property] = value;
                }
            });
        });
    });

    //INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.rightsCompassInform = $oasRights.forCode('COMPASSINFORM');
    $scope.editMode = $scope.rightsCompassInform.canUpdate;
    $scope.current = {
        gridDoubleClick: $scope.slickGridDoubleClick,
        url: '/Compliance/Inform/HistoricalDocuments/AccessPerson',
        view: views[0],
        editMode: false,
        gridQueries: []
    };
});


'use strict';

app.controller('InformQuestionnaireDialogCtrl', function InformQuestionnaireDialogCtrl($scope, $http, $upload, API_CONFIG, dialog, $oasRights, $rootScope, $dialog) {


    // PRIVATE METHODS
    function init() {
        const url = (dialog.options.templateId && !dialog.options.id) ? '/Compliance/Inform/Document/EmptyTaskDocument/' + dialog.options.templateId : '/Compliance/Inform/Document/' + dialog.options.id;
        const trackingMsg = (dialog.options.templateId && !dialog.options.id) ? 'Loading task' : 'Loading questionnaire';
        const currentUserDetailId = $rootScope.user.authorization.userDetailId;

        if (!$scope.current.previewDocument) {
            $http.get(url, { trackerMsg: trackingMsg })
                .then(function (response) {
                    $scope.document = response.data;

                    if ($scope.document.templateType === "Task With Multiple") {
                        $scope.recipients[0].name = $scope.document.answers[$scope.document.answers.length - 1].answer;
                    }
                    response.data.answers.forEach(function (answer) {
                        getListOfAnswerAttachments(answer, $scope.prevAttachments);
                    });
                    $scope.accessPersonView = $scope.document.userDetailId === 0 || (currentUserDetailId === $scope.document.userDetailId) && ["New", "Not Submitted", "Follow-up"].any($scope.document.documentStatus);
                    $scope.complianceView = $scope.document.userDetailId !== 0 && (currentUserDetailId !== $scope.document.userDetailId) && $scope.rightsCompassInform.canUpdate;
                    $scope.showStatus = ["Follow-up", "Approved", "Denied"].any($scope.document.documentStatus);
                    $scope.showComment = $scope.accessPersonView && $scope.document.documentStatus === "Follow-up";
                    $scope.newStatus = {
                        documentId: dialog.options.id,
                        status: "Approved",
                        comment: null,
                        showComment: $scope.showComment,
                        accessPersonId: $scope.document.accessPersonId
                  };
                  if (response.data.answers.any(a => a.showActiveAccounts)) {
                    $http.get('/Compliance/Inform/BrokerageAccounts?allAccounts=true&openOnly=false&accessPersonId=' + $scope.document.accessPersonId, { trackerMsg: 'Loading brokerage accounts' })
                      .then(response => {
                        let allActiveAccounts = response.data;
                        $scope.accounts = [];

                        for (let ac of allActiveAccounts) {
                          if (shouldDisplayAccount(ac.statusHistory, $scope.document.dueDate)) {
                            $scope.accounts.push(ac);
                          }
                        }
                      });
                  }
                });
        } else {
            $scope.accessPersonView = true;
            $scope.complianceView = false;
            $scope.document = dialog.options.previewDocument;
        }
    }

    function shouldDisplayAccount(statusHistory, dueDate) {
        let statusesBeforeDueDate = statusHistory.filter(h => h.createdDate <= dueDate);

        if(statusesBeforeDueDate) return statusesBeforeDueDate.sort((a, b) => b.id - a.id)[0].status === 'Active';
    }

    function canQuestionnaireBeSubmitted() {
        let noAnswers = [];

        $scope.document.answers.forEach(function (ans) {
            if ($scope.document.templateType === "Task With Multiple" && ans.questionNumber === $scope.document.answers.length) {
                ans.answer = $scope.recipients[0].name;
            }
            checkAnswers(ans, noAnswers);
        });

        return noAnswers.length < 1;
    }

    function checkAnswers(ans, noAnswers) {
        if (ans.questionType === "Upload Document") {
            if (ans.attachments && ans.attachments.length > 0)
                return;
        }
        if (ans.questionType === "Account List") {
            if (ans.answer !== null)
                return;
        }
        if (ans.questionType === "Multi-Checkbox") {
            let answeredOptions = [];
            ans.questionOptions.forEach(function (option) {
                if (option.multiAnswer) {
                    answeredOptions.push(option);
                }
            });
            if (answeredOptions.length < 1) {
                noAnswers.add(ans);
            }
            return;
        }
        if (ans.answer) {
            if (ans.questionType === "Radio") {
                let optionSelected = ans.questionOptions.find(function (option) {
                    if (ans.answer === option.id.toString()) {
                        return option;
                    }
                });
                if (optionSelected.childAnswer)
                    checkAnswers(optionSelected.childAnswer, noAnswers);
            }
            return;
        }

        noAnswers.add(ans);
    }

    function getListOfAnswerAttachments(ans, attachments) {

        if (ans.questionType === "Upload Document") {
            if (ans.attachments && ans.attachments.length > 0) {
                attachments.push(...ans.attachments);
            }
            
        }

        let optionSelected = ans.questionOptions.find(function(option){
            if(ans.answer === option.id.toString()){
                return option;
            }
        });

        if(!optionSelected)
            return;

        if(optionSelected && optionSelected.childAnswer) {
            getListOfAnswerAttachments(optionSelected.childAnswer, attachments);
        }
    }

    //PUBLIC METHODS
    $scope.addRecipient = function(){
        $scope.recipients.push({name:""});
    };

    $scope.deleteRecipient = function(rec){
        let found = $scope.recipients.indexOf(rec);
        if(found > -1){
            $scope.recipients.splice(found,1);
        }
    };

    $scope.disableSubmit = function(){
        return !canQuestionnaireBeSubmitted();
    };

    $scope.submit = function (saveType) {
        let canSubmit = false;

        if(saveType === "Submitted") {
            $scope.isDisabled = true;
            canSubmit = canQuestionnaireBeSubmitted();
            if(!canSubmit) {
                $dialog.messageBox("Answers Missing", "All questions must be answered before submitting.").open();
                $scope.isDisabled = false;
                return;
            }
        }

        if(saveType === 'Not Submitted') {
            if($scope.isDisabled) {
                return;
            }
            $scope.isDisabled = true;
        }

        if(["Denied", "Follow-up"].find(saveType)){
            if($scope.isDisabled) {
                return;
            }
            $scope.isDisabled = true;
            if($scope.newStatus.comment === null || $scope.newStatus.comment === ""){
                $dialog.messageBox("Missing", "You must enter a message to the access person.").open();
                $scope.isDisabled = false;
                return;
            }
        }

        $scope.newStatus.status = saveType;

        if(!$scope.document.statusHistory)
            $scope.document.statusHistory = [];

        $scope.document.statusHistory.insert($scope.newStatus);

        if($scope.document.templateType === "Task With Multiple" && $scope.document.id === 0) {
            //check multiple recipients are formatted correctly
            let recipients = $scope.recipients;
            if(recipients.length > 1 && recipients[0].name === ""){
                $dialog.messageBox("Missing", "You must have at least one recipient.").open();
                $scope.isDisabled = false;
                return;
            }
            let taskPromises = [];

            for(let recipient of recipients) {
                if(recipient.name === ""){
                    continue;
                }
                const document = angular.copy($scope.document);
                const args = {method: 'post', id: "", trackerMsg: `Creating task ${document.name}`};

                document.answers[document.answers.length - 1].answer = recipient.name;
                taskPromises.push($http[args.method]("/Compliance/Inform/Document/" + args.id, document, {trackerMsg: args.trackerMsg}));
            }
            Promise.all(taskPromises)
                .then(()=>{
                 dialog.close($scope.document);
                });
        } else {
            let args = $scope.document.id > 0 ?
                {
                    method: 'put',
                    id: $scope.document.id,
                    trackerMsg: "Saving Questionnaire"
                } : { method: 'post', id: "", trackerMsg: "Saving new task" };

            $http[args.method]("/Compliance/Inform/Document/" + args.id, $scope.document, { trackerMsg: args.trackerMsg })
                .then(function (response) {
                    $scope.document = response.data;
                    let attachments = [];

                    response.data.answers.forEach(function (answer) {
                        getListOfAnswerAttachments(answer, attachments);
                    });

                    $scope.prevAttachments.sort((a, b) => a.informDocumentAnswerId - b.informDocumentAnswerId);
                    attachments.sort((a, b) => a.informDocumentAnswerId - b.informDocumentAnswerId);

                    if ($scope.newFiles.length > 1) {
                        $scope.sortNewFiles();
                    }

                    if ($scope.newFiles.length > 0) {
                        $scope.flattenNewFiles();
                    }

                    if ($scope.newFiles && $scope.newFiles.length > 0) {
                        if (attachments.length > 0 && $scope.newFiles.length > 0) {

                            for (let i = 0; i < attachments.length; i++) {
                                let matchFound = false;

                                for (let j = 0; j < $scope.prevAttachments.length; j++) {
                                    if (attachments[i].id === $scope.prevAttachments[j].id) {
                                        matchFound = true;
                                        break;
                                    }
                                }

                                if (!matchFound) {
                                    $scope.message.attachments.push(attachments[i]);
                                }
                            }
                        }

                        const config = {
                            url: "/Compliance/Inform/Document/" + response.data.id + "/Attachments/",
                            data: $scope.message,
                            file: $scope.newFiles,//has to be this way, why?
                            fileFormDataName: $scope.newFiles.map(function (item, i) {
                                return "files[" + i + "]"
                            })
                        };

                        $upload.upload(config)
                            .then(function () {
                                dialog.close($scope.document);
                            })
                            .catch(function () {
                                //$scope.current.executing = false;
                            });
                    } else {
                        dialog.close($scope.document);
                    }

                });
        }
    };

  $scope.updateDocumentStatus = function (saveType) {
    if ($scope.document.id === 0) {
      submit(saveType);
      return;
    }

    if (["denied", "follow-up"].find(saveType.toLowerCase())) {
      if ($scope.isDisabled) {
        return;
      }

      $scope.isDisabled = true;

      if ($scope.newStatus.comment == null || $scope.newStatus.comment === "") {
        $dialog.messageBox("Missing", "You must enter a message to the access person.").open();
        $scope.isDisabled = false;
        return;
      }
    }

    $scope.newStatus.status = saveType;

    let body = {
      id: $scope.document.id,
      comment: $scope.newStatus.comment,
      status: $scope.newStatus.status
    }

    $http.put("/Compliance/Inform/Document/Status", body, { trackerMsg: "Saving Questionnaire" })
      .then(function (response) {
        $scope.document = response.data;

        dialog.close($scope.document);
      });
  };

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.sortNewFiles = function () {
        $scope.newFiles.sort((a, b) => {
            return a.id - b.id;
        });
    }

    $scope.flattenNewFiles = function () {
        $scope.newFiles = $scope.newFiles.map(x => x.files.flat()).flat();
    }

    $scope.toggleStatusHistory = function(){
        $scope.showStatus = !$scope.showStatus;
    };

    $scope.toggleComment = function(){
        $scope.showComment = !$scope.showComment;
    };

    $scope.printPreview = function(){
        let content = "<!DOCTYPE html><HTML>";
        content += '<link href="_css/site.css" rel="stylesheet">';
        content += "<h5>" + $scope.document.name + "</h5>";
        content += "<br/>";
        content += " <form><div class=\"row-fluid\">";
        content += document.getElementsByClassName("questionnaire-body")[0].innerHTML;
        content += " </div></form>";
        content += "</HTML>";
        const printPreview = window.open('about:blank', 'print_preview');
        const printDocument = printPreview.document;
        printDocument.write(content);
        printPreview.print();
    };

    // INITIALIZE
    $scope.today = Date.now();
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.newStatus = null;
    $scope.attachments = [];
    $scope.message = {
        attachments: []
    };
    $scope.recipients = [{ name: "" }];
    $scope.document = null;
    $scope.documentStatus = ["Approved", "Denied", "Follow-up"];
    $scope.newFiles = [];
    $scope.prevAttachments = [];
    $scope.current = {
        recipient:'',
        returnData: null,
        canEdit:  $oasRights.canUpdate("INFORM"),
        sent: false,
        fileName: null,
        method: dialog.options.id ? 'PUT' : 'POST',
        previewDocument: dialog.options.previewDocument,
        isPreview:dialog.options.previewDocument,
    };
    $scope.showStatus = false;
    $scope.showComment = false;
    $scope.accessPersonView = false;
    $scope.complianceView = false;
    $scope.isDisabled = false;
    init();
});
'use strict';

app.controller('InformQuestionnaireDialogCtrlV2', function InformQuestionnaireDialogCtrlV2($scope, $http, $upload, dialog, $oasRights, $rootScope,$dialog) {


    // PRIVATE METHODS
    function init() {
        const url = (dialog.options.templateId && !dialog.options.id)? '/Compliance/Inform/Document/EmptyTaskDocument/' + dialog.options.templateId: '/Compliance/Inform/Document/' + dialog.options.id;
        const trackingMsg = (dialog.options.templateId && !dialog.options.id)?'Loading task':'Loading questionnaire';
        const currentUserDetailId = $rootScope.user.authorization.userDetailId;

        if(!$scope.current.previewDocument) {
            $http.get(url, {trackerMsg: trackingMsg})
                .then(function (response) {
                    $scope.document = response.data;
                    $scope.document.answers.sort(sortAnswersDesc);
                    if($scope.document.templateType=== "Task With Multiple") {
                        $scope.recipients[0].name = $scope.document.answers[$scope.document.answers.length - 1].answer;
                    }
                    $scope.accessPersonView = $scope.document.userDetailId === 0 || (currentUserDetailId === $scope.document.userDetailId) && ["New", "Not Submitted", "Follow-up"].any($scope.document.documentStatus);
                    $scope.complianceView = $scope.document.userDetailId !== 0 && (currentUserDetailId !== $scope.document.userDetailId) && $scope.rightsCompassInform.canUpdate;
                    $scope.showStatus = ["Follow-up", "Approved", "Denied"].any($scope.document.documentStatus);
                    $scope.showComment = $scope.accessPersonView && $scope.document.documentStatus === "Follow-up";
                    $scope.newStatus = {
                        documentId: dialog.options.id,
                        status: "Approved",
                        comment: null,
                        showComment: $scope.showComment,
                        accessPersonId: $scope.document.accessPersonId
                    };
                    $http.get('/Compliance/Inform/BrokerageAccounts?allAccounts=true&openOnly=false&accessPersonId=' + $scope.document.accessPersonId, {trackerMsg: 'Loading brokerage accounts'})
                        .then(response => {
                            let allActiveAccounts = response.data;
                            $scope.accounts = [];

                            for (let ac of allActiveAccounts) {
                                if(isDueDateAfterClosedDate(ac.statusHistory, $scope.document.dueDate) &&
                                    isDueDateBeforeActiveDate(ac.statusHistory, $scope.document.dueDate)){
                                    $scope.accounts.push(ac);
                                }
                            }
                        });
                });
        }else{
            $scope.accessPersonView = true;
            $scope.complianceView = false;
            $scope.document = dialog.options.previewDocument;
        }
    }

    function sortAnswersDesc(obj1,obj2){
        if(obj1.questionNumber<obj2.questionNumber)
        return -1;

        if(obj1.questionNumber>obj2.questionNumber)
        return 1;

        return 0;
    }

    function isDueDateAfterClosedDate(statusHistory, dueDate){
        var closedStatus = statusHistory.find(item=>{
           if(item.status === "Closed"){
               return item;
           }
        });

        if(!closedStatus){
            return true;
        }

        return closedStatus.createdDate >= dueDate;
    }

    function isDueDateBeforeActiveDate(statusHistory, dueDate){
        var closedStatusIndex = statusHistory.findIndex(item=>{
            if(item.status === "Active" && item.createdDate <= dueDate){
                return item;
            }
        });

        return closedStatusIndex > -1;
    }

    function canQuestionnaireBeSubmitted(){
        let noAnswers = [];

        $scope.document.answers.forEach(function(ans){
            if($scope.document.templateType === "Task With Multiple" && ans.questionNumber === $scope.document.answers.length){
                ans.answer = $scope.recipients[0].name;
            }
            checkAnswers(ans,noAnswers);
        });

        return noAnswers.length < 1;
    }

    function checkAnswers(ans,noAnswers){
        if(ans.questionType ==="Upload Document"){
            if(ans.attachments && ans.attachments.length > 0)
                return;
        }
        if(ans.questionType ==="Account List"){
            if(ans.answer !== null)
                return;
        }
        if(ans.questionType === "Multi-Checkbox"){
            let answeredOptions = [];
            ans.questionOptions.forEach(function(option){
                if(option.multiAnswer){
                    answeredOptions.push(option);
                }
            });
            if(answeredOptions.length < 1 ){
                noAnswers.add(ans);
            }
            return;
        }
        if(ans.answer){
            if(ans.questionType ==="Radio"){
                let optionSelected = ans.questionOptions.find(function(option){
                    if(ans.answer === option.id.toString()){
                        return option;
                    }
                });
                if(optionSelected.childAnswer)
                    checkAnswers(optionSelected.childAnswer,noAnswers);
            }
            return;
        }

        noAnswers.add(ans);
    }

    function getListOfAnswerAttachments(ans, attachments){
        if(ans.questionType ==="Upload Document"){
            if(ans.attachments && ans.attachments.length > 0)
                attachments.add(ans.attachments);
        }

        let optionSelected = ans.questionOptions.find(function(option){
            if(ans.answer === option.id.toString()){
                return option;
            }
        });

        if(!optionSelected)
            return;

        if(optionSelected && optionSelected.childAnswer) {
            getListOfAnswerAttachments(optionSelected.childAnswer, attachments);
        }
    }

    //PUBLIC METHODS
    $scope.addRecipient = function(){
        $scope.recipients.push({name:""});
    };

    $scope.deleteRecipient = function(rec){
        let found = $scope.recipients.indexOf(rec);
        if(found > -1){
            $scope.recipients.splice(found,1);
        }
    };

    $scope.disableSubmit = function(){
        return !canQuestionnaireBeSubmitted();
    };

    $scope.submit = function (saveType) {
        let canSubmit = false;
        if(saveType === "Submitted") {
            $scope.isDisabled = true;
            canSubmit = canQuestionnaireBeSubmitted();
            if(!canSubmit) {
                $dialog.messageBox("Answers Missing", "All questions must be answered before submitting.").open();
                $scope.isDisabled = false;
                return;
            }
        }

        if(saveType === 'Not Submitted') {
            if($scope.isDisabled) {
                return;
            }
            $scope.isDisabled = true;
        }

        if(["Denied", "Follow-up"].find(saveType)){
            if($scope.isDisabled) {
                return;
            }
            $scope.isDisabled = true;
            if($scope.newStatus.comment === null || $scope.newStatus.comment === ""){
                $dialog.messageBox("Missing", "You must enter a message to the access person.").open();
                $scope.isDisabled = false;
                return;
            }
        }

        $scope.newStatus.status = saveType;

        if(!$scope.document.statusHistory)
            $scope.document.statusHistory = [];

        $scope.document.statusHistory.insert($scope.newStatus);

        if($scope.document.templateType === "Task With Multiple" && $scope.document.id === 0) {
            //check multiple recipients are formatted correctly
            let recipients = $scope.recipients;
            if(recipients.length > 1 && recipients[0].name === ""){
                $dialog.messageBox("Missing", "You must have at least one recipient.").open();
                $scope.isDisabled = false;
                return;
            }
            let taskPromises = [];

            for(let recipient of recipients) {
                if(recipient.name === ""){
                    continue;
                }
                const document = angular.copy($scope.document);
                const args = {method: 'post', id: "", trackerMsg: `Creating task ${document.name}`};

                document.answers[document.answers.length-1].answer = recipient.name;
                taskPromises.push($http[args.method]("/Compliance/Inform/Document/" + args.id, document, {trackerMsg: args.trackerMsg}));
            }
            Promise.all(taskPromises)
                .then(()=>{
                 dialog.close($scope.document);
                });
        }else {
            let args = $scope.document.id > 0 ?
                {
                    method: 'put',
                    id: $scope.document.id,
                    trackerMsg: "Saving Questionnaire"
                } : {method: 'post', id: "", trackerMsg: "Saving new task"};

            $http[args.method]("/Compliance/Inform/Document/" + args.id, $scope.document, {trackerMsg: args.trackerMsg})
                .then(function (response) {
                    $scope.document = response.data;
                    let attachments = [];

                    response.data.answers.forEach(function (answer) {
                        getListOfAnswerAttachments(answer, attachments);
                    });

                    if ($scope.files && $scope.files.length > 0) {
                        if (attachments.length > 0 && $scope.files.length > 0) {
                            let startingIndex = attachments.length - $scope.files.length;
                            $scope.message.attachments = attachments.slice(startingIndex, attachments.length);
                        }

                        const config = {
                            url: "/Compliance/Inform/Document/" + response.data.id + "/Attachments/",
                            data: $scope.message,
                            file: $scope.files,//has to be this way, why?
                            fileFormDataName: $scope.files.map(function (item, i) {
                                return "files[" + i + "]"
                            })
                        };

                        $upload.upload(config)
                            .then(function () {
                                dialog.close($scope.document);
                            })
                            .catch(function () {
                                //$scope.current.executing = false;
                            });
                    } else {
                        dialog.close($scope.document);
                    }

                });
        }
    };

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.toggleStatusHistory = function(){
        $scope.showStatus = !$scope.showStatus;
    };

    $scope.toggleComment = function(){
        $scope.showComment = !$scope.showComment;
    };

    $scope.printPreview = function(){
        let content = "<!DOCTYPE html><HTML>";
        content += '<link href="_css/site.css" rel="stylesheet">';
        content += "<h5>" + $scope.document.name + "</h5>";
        content += "<br/>";
        content += " <form><div class=\"row-fluid\">";
        content += document.getElementsByClassName("questionnaire-body")[0].innerHTML;
        content += " </div></form>";
        content += "</HTML>";
        const printPreview = window.open('about:blank', 'print_preview');
        const printDocument = printPreview.document;
        printDocument.write(content);
        printPreview.print();
    };

    // INITIALIZE
    $scope.today = Date.now();
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.newStatus = null;
    $scope.attachments = [];
    $scope.message = {
        attachments: []
    };
    $scope.recipients = [{name:""}];
    $scope.files = [];
    $scope.document = null;
    $scope.documentStatus = ["Approved", "Denied", "Follow-up"];
    $scope.current = {
        recipient:'',
        returnData: null,
        canEdit:  $oasRights.canUpdate("INFORM"),
        sent: false,
        fileName: null,
        method: dialog.options.id ? 'PUT' : 'POST',
        previewDocument: dialog.options.previewDocument,
        isPreview:dialog.options.previewDocument,
    };
    $scope.showStatus = false;
    $scope.showComment = false;
    $scope.accessPersonView = false;
    $scope.complianceView = false;
    $scope.isDisabled = false;
    init();
});
'use strict';

app.controller('ByAllConnectionsDialogCtrl', function ByAllConnectionsDialogCtrl($scope, $http, dialog, $dialog) {


    // PRIVATE METHODS
    function init() {
        let url = "/Compliance/Inform/ByAllSSOToken";

        $http.get(url, {trackerMsg: 'Loading ByAll info'})
            .then((response)=> {
                if(response.data.errorCode === 0) {
                    const authContext = {
                        jsessionId: response.data.sSOResponse.sessionAuthResponse.sessionId,
                        csrfToken: response.data.sSOResponse.sessionAuthResponse.csrfToken
                    };

                    $scope.byAll.authContext = authContext;
                    if(dialog.options.connection && dialog.options.isBaaMigration === false) {
                        $scope.byAll.credentialId = dialog.options.connection.sourceConnectionId;
                    }
                    else{
                        $scope.byAll.credentialId = null;
                    }
                }

                if(response.data.errorCode !== 0){
                    $dialog.messageBox("Error", "An error occurred please report this to Compliance.")
                        .open()
                        .then(function(){
                            $scope.close();
                        });
                }
            });

    }

    // PUBLIC METHODS
    $scope.handleClick = function(){
        alert('clicked');
    };

    $scope.connect = function (){
    };

    $scope.close = function () {
        dialog.close({hasAgreedToUserAgreement:true});
    };

    $scope.onUserAgreement = function(){
        dialog.close({hasAgreedToUserAgreement:false});
    };

    // INITIALIZE
    $scope.byAll = {};

    $scope.current = {
        showInvestorUserSignup: true,
    };
    init();
});
'use strict';

app.controller('InformPreClearanceDialogCtrl', function InformPreClearanceDialogCtrl($scope, $rootScope, $oasRights, $http, $upload, API_CONFIG, dialog, $dialog) {
    // PRIVATE METHODS
    function init() {

        const currentUserDetailId = $rootScope.user.authorization.userDetailId;
        $scope.accessPersonView = !$scope.preclearance.id || (currentUserDetailId === $scope.preclearance.userDetailId);
        $scope.complianceView = !$scope.accessPersonView && $scope.rightsCompassInform.canUpdate;
        $scope.showComment = $scope.accessPersonView && $scope.preclearance.status === "Follow-up";
        $scope.newStatus = {
            preClearanceId: $scope.preclearance.id,
            status: $scope.documentStatus[0],
            showComment: $scope.showComment,
            accessPersonId: dialog.options.accessPersonId,
        };
    }

    function canSave() {
        if ($scope.accessPersonView) {
            if (!$scope.preclearance.product) {
                return {canSave: false, msg: "You must have a ticker."};
            }
            if (!$scope.preclearance.transTypeId) {
                return {canSave: false, msg: "You must have a clearance action."};
            }
            if (!$scope.preclearance.quantity) {
                return {canSave: false, msg: "You must have a quantity."};
            }
            if (!$scope.preclearance.tradeValue && $scope.preclearance.product.productType == 1) {
                return {canSave: false, msg: "You must enter an amount."};
            }
            if (!$scope.preclearance.product.productId) {
                return {canSave: false, msg: "You must have a ticker."};
            }
            if (!$scope.preclearance.brokerageAccountId) {
                return {canSave: false, msg: "You must have an account selected."};
            }
            if (!$scope.preclearance.tradeDate) {
                return {canSave: false, msg: "You must have a trade date."};
            }
            if($scope.preclearance.isOption){
                if(!$scope.preclearance.strikePrice){
                    return {canSave: false, msg: "You must have a strike price."};
                }
                if(!$scope.preclearance.optionExpirationDate){
                    return {canSave: false, msg: "You must have an option expiration date."};
                }
            }
        }
        return {canSave: true, msg: ""};
    }

    // PUBLIC METHODS
    $scope.saveAsSubmitted = function () {
        if (!$scope.current.isSubmitPreclearanceDisabled){
            $scope.current.isSubmitPreclearanceDisabled = true;
            $scope.submit('Submitted');
        }
    };

    $scope.saveAsCanceled = () => {
        $scope.current.isCancelPreclearanceDisabled = true;
        $dialog.messageBox("Warning!","You are about to Cancel your request - are you sure you want to do this?", [{
                result: true,
                label: 'Yes',
                focus: true,
                cssClass: "btn-primary"
            }, {
                result: false,
                label: 'No',
                focus: false,
                cssClass: ""
            }]).open()
                .then((msgBoxAnswer) => {
                    if (msgBoxAnswer) {
                        $scope.submit('Canceled');
                    }
                    $scope.current.isCancelPreclearanceDisabled = false;
                });
    };

    $scope.submit = function (saveType) {
        let savingStatus = canSave();

        if (["Follow-up", "Denied"].find(saveType)) {
            if ($scope.newStatus.comment == null) {
                $dialog.messageBox("Missing", "You must enter a follow-up message to the access person.").open();
                return;
            }
        }

        if (savingStatus.canSave === false) {
            $dialog.messageBox("Missing pre-clearance information", savingStatus.msg, [{
                result: 'ok',
                label: 'Ok'
            }]).open();
            $scope.current.isSubmitPreclearanceDisabled = false;
        }
        if (!savingStatus.canSave)
            return;

        $scope.newStatus.status = saveType;
        $scope.preclearance.statusHistory.insert($scope.newStatus);

        const args = $scope.preclearance.id > 0 ? {
            method: "put",
            id: $scope.preclearance.id,
            trackerMsg: "Updating pre-clearance"
        } : {method: "post", id: "", trackerMsg: "Adding new pre-clearance"};

        $http[args.method]("/Compliance/Inform/Preclearance/" + args.id, $scope.preclearance, {trackerMsg: args.trackerMsg})
            .then(function (response) {
                dialog.close(response.data);
            });
    };

    $scope.cancel = function () {
        dialog.close();
    };

    $scope.toggleComment = function () {
        $scope.showComment = !$scope.showComment;
    };

    $scope.toggleStatusHistory = function () {
        $scope.showStatus = !$scope.showStatus;
    };

    // INITIALIZE

    $scope.documentStatus = ["Approved", "Denied", "Follow-up"];
    $scope.editStatuses = ["Not Submitted", "Follow-up"];
    $scope.cancelStatues = [...$scope.documentStatus, ...$scope.editStatuses,"Submitted"];
    $scope.accounts = (dialog.options.accounts)
        ? dialog.options.accounts
        : [];
    $scope.columns = ['', 'File Name', 'Comment', 'Uploaded Date'];
    $scope.files = [];
    $scope.message = {attachments: []};
    $scope.current = {
        canEdit: $oasRights.forCode("INFORM")
    };
    $scope.preclearance = (dialog.options.preclearance)
        ? dialog.options.preclearance
        : {
            id: 0,
            brokerageAccountId:null,
            accessPersonId:dialog.options.accessPersonId,
            symbol: null,
            isIPO: false,
            comment: null,
            securityType: {},
            orderType: {},
            clearanceAction: {},
            statusHistory: [],
            status: "Not Submitted",
            description: null
        };
    $scope.securityTypes = [];
    $scope.clearanceActions = [];

    $scope.complianceView = false;
    $scope.accessPersonView = false;
    $scope.showComment = false;
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.showStatus = ["Follow-up", "Approved", "Denied"].any($scope.preclearance.status);

    $scope.current = {
        accessPersonId:dialog.options.accessPersonId,
        canEdit: $scope.editStatuses.any($scope.preclearance.status) || $scope.preclearance.id === 0,
        canCancelPreclearance: ($scope.preclearance.id > 0 && $scope.preclearance.informTransaction === null) 
            && $scope.preclearance.status !== "Canceled" 
            && $scope.preclearance.status !== 'Approved' 
            && $scope.preclearance.status !== 'Approved - Auto'
            && $scope.preclearance.status !== 'Denied' 
            && $scope.preclearance.status !== 'Denied - Auto', 
        isCancelPreclearanceDisabled: false,
        isSubmitPreclearanceDisabled: false
    };
    init();
});
'use strict';

app.controller('InformBrokerageAccountDialogCtrl', function InformBrokerageAccountDialogCtrl($scope, $http, $upload, $routeParams, API_CONFIG, dialog, $dialog, $rootScope, $oasRights, informWorkflowStatus) {
    let statementsRequiredConnect = true;
    let statementsRequiredClosed = true;

    //PRIVATE METHODS
    function init() {
        const currentUserDetailId = $rootScope.user.authorization.userDetailId;
        $scope.accessPersonView = (currentUserDetailId === $scope.accountDetails.userDetailId) && ["Not Submitted", "Follow-up", "Active", "New"].any($scope.accountDetails.currentStatus);
        $scope.complianceView = (currentUserDetailId !== $scope.accountDetails.userDetailId) && $scope.rightsCompassInform.canUpdate;
        $scope.canSubmitPreclearances = $scope.accessPersonView && $scope.accountDetails.currentStatus === "Active";
        $scope.showStatus = !["Not Submitted", "Active", "New"].any($scope.accountDetails.currentStatus);
        $scope.showComment = $scope.accountDetails.currentStatus === "Follow-up";
        $scope.newStatus = {
            brokerageAccountId: $scope.accountDetails.id,
            status: $scope.accountDetails.status === "Close Pending" ? "Closed" : "Active",
            showComment: $scope.showComment,
            accessPersonId: $scope.accountDetails.accessPersonId
        };
        if ($scope.accountDetails.id) {
            LoadAccountAttachments($scope.accountDetails.id);
        }
        checkStatementRequirements();

        if($scope.complianceView){
            checkReactivateFunction($scope.accountDetails.id);
        }
    }

    function checkReactivateFunction(id) {
        $http.get(`/Compliance/Inform/BrokerageAccount/CanBeReactivated/${id}`,
            {trackerMsg: 'Checking reactivate functionality'})
            .then(function (response) {
                $scope.showReactivateButton = response.data;
                if($scope.showReactivateButton === false && $scope.accountDetails.currentStatus === "Closed") {
                    $scope.documentStatus.remove("Active");
                    $scope.newStatus.status = "Closed";
                }
            });
    }

    function checkStatementRequirements(){
        $http.get('/Settings/Database/EntityOptions/Code/69STATEMENTREQUIRECONNECT', {trackerMsg: 'Checking statement requirements for connecting accounts.'})
            .then(function (response) {
                statementsRequiredConnect = response.data.value;
            });

        $http.get('/Settings/Database/EntityOptions/Code/69STATEMENTREQUIREDCLOSED', {trackerMsg: 'Checking statement requirements for closing accounts.'})
            .then(function (response) {
                statementsRequiredClosed = response.data.value;
            });
    }

    function LoadAccountAttachments(id) {
        $http.get(`/Compliance/Inform/BrokerageAccounts/${id}/Attachments/`,
        {trackerMsg: 'Loading Brokerage Account Attachments'})
        .then(function (response) {
            $scope.accountDetails.attachments = response.data;
        });
        
        $scope.startingAttachmentsLength = $scope.accountDetails.attachments ? $scope.accountDetails.attachments.length : 0;
    }
    
    function updateBrokerageAccount(statusType, reactivate) {
        if((statusType === informWorkflowStatus.closed.name ||
            statusType === informWorkflowStatus.denied.name)||
            reactivate){
            const url = "/Compliance/Inform/BrokerageAccounts/Status/";

            const comment = $scope.newStatus.comment === null || $scope.newStatus.comment == undefined ? null : $scope.newStatus.comment;

            const idsToUpdate = [{
                accountId: $scope.accountDetails.id,
                comment: comment
            }];

            let status = informWorkflowStatus.closed.value;
            switch (statusType) {
                case informWorkflowStatus.closed.name:
                    status = informWorkflowStatus.closed.value;
                    break;
                case informWorkflowStatus.denied.name:
                    status = informWorkflowStatus.denied.value;
                    break;
                case informWorkflowStatus.active.name:
                    status = informWorkflowStatus.active.value;
                    break;
                case informWorkflowStatus.followUp.name:
                    status = informWorkflowStatus.followUp.value;
                    break;
                default:
                    status = -1;//unknown
            }

            $http.put(url + status, idsToUpdate, {cache: false, trackerMsg: 'Saving brokerage account status.'})
                .then(function () {
                    dialog.close($scope.accountDetails);
                });
        } else {
            $scope.accountDetails.statusHistory.insert($scope.newStatus);
            $http.put("/Compliance/Inform/BrokerageAccounts", $scope.accountDetails, {trackerMsg: "Saving brokerage account"})
                .then(function (response) {
                    $scope.accountDetails = response.data;
                    $scope.message.attachments = response.data.attachments;

                    if ($scope.files) {
                        if (response.data.attachments.length > 0 && $scope.files.length > 0) {
                            $scope.message.attachments = response.data.attachments.slice(0, $scope.files.length);
                        }

                        const config = {
                            url: "/Compliance/Inform/BrokerageAccounts/" + response.data.id + "/Attachments/",
                            data: $scope.message,
                            file: $scope.files,//has to be this way, why?
                            fileFormDataName: $scope.files.map(function (item, i) {
                                return "files[" + i + "]";
                            })
                        };

                        $upload.upload(config)
                            .then(function () {
                                dialog.close($scope.accountDetails);
                            })
                            .catch(function () {
                                //$scope.current.executing = false;
                            });
                    }
                });
        }
    }

    function canSave(saveType) {
        if ($scope.accessPersonView) {
            if (saveType === "Not Submitted") {
                return {canSave: true, msg: ""};
            }
            if (!$scope.accountDetails.statementFrequency && saveType !== "Close Pending") {
                return {canSave: false, msg: "You must have a statement frequency."};
            }
            if ($scope.accountDetails.recordSource === "Unconnected Account" || statementsRequiredConnect === "True"){
                if(!$scope.accountDetails.attachments.length > 0 && saveType !== "Close Pending") {
                    return {canSave: false, msg: "You must have statements loaded."};
                }
            }
            if ($scope.accountDetails.recordSource === "Unconnected Account" || statementsRequiredClosed === "True"){
                if(!$scope.accountDetails.attachments.length > 0 && saveType === "Close Pending") {
                    return {canSave: false, msg: "You must have statements loaded."};
                }
            }
        }
        return {canSave: true, msg: ""};
    }

    // PUBLIC METHODS
    $scope.onFileSelect = function (files) {
        $scope.files.add(files);
        files.forEach(function (i) {
            $scope.accountDetails.attachments.push(
                {
                    file: i,
                    comment: null,
                    fileName: i.name,
                    auditedDate: null,
                    needsUpdating: true
                });
        });
    };

    $scope.loadTab = function (type) {
        $scope.tabs.General.active = false;
        $scope.tabs.Preclearances.active = false;
        $scope.tabs.CloseAccount.active = false;

        switch (type.description) {
            case $scope.tabs.General.description:
                $scope.tabs.General.active = true;
                break;
            case $scope.tabs.Preclearances.description:
                if ($scope.preclearances.length === 0) { //only load the preclearances once
                    $http.get('/Compliance/Inform/Preclearances/V2?brokerageAccountId=' + $scope.account.id + '&allPreclearances=true', {trackerMsg: 'Loading preclearances'})
                        .then(function (response) {
                            $scope.preclearances = response.data;
                        });
                }
                $scope.tabs.Preclearances.active = true;
                break;
            case $scope.tabs.CloseAccount.description:
                $scope.tabs.CloseAccount.active = true;
                break;
        }

        $scope.showAccessPersonButtons = $scope.accessPersonView && $scope.tabs.CloseAccount.active === false;
    };

    $scope.showPreclearance = function (preclearance) {
        const options = {
            templateUrl: "tools/inform/modal/inform-new-preclearance-dialog.html",
            controller: "InformPreClearanceDialogCtrl",
            preclearance: preclearance,
            accounts: [$scope.account],
            accessPersonId: $scope.accountDetails.accessPersonId,
            dialogClass: 'modal wide'
        };

        $dialog.dialog(options).open()
            .then(function (result) {
                if (!result) return;

                if (!preclearance)
                    preclearance = result;
                else
                    angular.merge(preclearance, result);

                $http.get('/Compliance/Inform/Preclearances/V2?brokerageAccountId=' + $scope.account.id + '&allPreclearances=true', {trackerMsg: 'Loading preclearances'})
                    .then(function (response) {
                        $scope.preclearances = response.data;
                    });

            });
    };

    $scope.toggleComment = function () {
        $scope.showComment = !$scope.showComment;
    };

    $scope.updateAccountNumber = function () {
        if ($scope.accountNumberEdit) {
            $http.put("/Compliance/Inform/BrokerageAccounts/" + $scope.accountDetails.id + "/AccountNumberUpdate/?accountNumber=" + $scope.accountDetails.accountNumber, null, { trackerMsg: "Saving brokerage account Number" })
                .then(function (response) {
                    $scope.accountDetails.accountNumber = response.data;
                    $scope.accountDetails.isAccountNumberValidated = true;
                    dialog.close($scope.accountDetails);
                });            
        }
    }


    $scope.toggleStatusHistory = function () {
        $scope.showStatus = !$scope.showStatus;
    };

    $scope.getBadgeFromStatus = function (status) {
        return {
            Submitted: "badge-info",
            Approved: "badge-success",
            Active: "badge-success",
            Canceled: "badge-info",
            Denied: "btn-danger",
            New: "badge-success",
            "Not Submitted": "badge-warning",
            "Follow-up": "badge-warning",
            "Verbal Warning": "badge-warning",
            "Written Warning": "badge-warning",
            "Loss of Trading Privileges": "badge-warning",
            Termination: "btn-danger",
            "Other": "btn-success"
        }[status];
    };

    function saveClosePending(saveType){
        $dialog.messageBox("Closed Accounts", "Are you sure you want to close the account?", [{
            result: 'Yes',
            label: 'Yes'
        }, {result: 'No', label: 'No'}]).open()
            .then(function (valueReturned) {
                if (valueReturned !== 'No') {
                    if (($scope.accountDetails.recordSource === "Unconnected Account" || statementsRequiredClosed === "True") ){
                        if(!$scope.accountDetails.comment || !($scope.accountDetails.attachments.length > $scope.startingAttachmentsLength)) {
                            $dialog.messageBox("Closed Accounts", "You must have a comment and a closing statement.", [{
                                result: 'ok',
                                label: 'Ok'
                            }]).open();
                        }else{
                            updateBrokerageAccount(saveType);
                        }
                    } else {
                        updateBrokerageAccount(saveType);
                    }
                }
            });
    }

    function createNewAccount(){
        //we need to create the brokerage account first then add the files in a separate endpoint
        $scope.accountDetails.statusHistory.insert($scope.newStatus);
        let connection = {
            institutionName: $scope.accountDetails.institutionName,
        };

        $http.post("/Compliance/Inform/Connection/V2/Manual", connection, {trackerMsg: "Adding a manual connection and user."})
            .then(function (response) {
                $scope.accountDetails.informConnectionId = response.data.id;

                $http.post("/Compliance/Inform/BrokerageAccounts", $scope.accountDetails, {trackerMsg: "Adding an account"})
                    .then(function (response) {
                        $scope.accountDetails = response.data;
                        $scope.message.attachments = response.data.attachments;

                        if ($scope.files) {
                            const config = {
                                url: "/Compliance/Inform/BrokerageAccounts/" + response.data.id + "/Attachments/",
                                data: $scope.message,
                                file: $scope.files,//has to be this way, why?
                                fileFormDataName: $scope.files.map(function (item, i) {
                                    return "files[" + i + "]";
                                })
                            };

                            $upload.upload(config)
                                .then(function () {
                                    dialog.close($scope.accountDetails);
                                })
                                .catch(function (error) {
                                    console.log(error);
                                });
                        }
                    });
            });
    }

    $scope.submit = function (saveType, reactivate) {
        if (saveType === 'New' ||
            saveType === 'Follow-up' ||
            saveType === 'Submitted'){
            if($scope.isDisabled){
                return;
            }
            $scope.isDisabled = true;
        }

        if (saveType === "Follow-up") {
            if ($scope.newStatus.comment == null) {
                $dialog.messageBox("Missing", "You must enter a follow-up message to the access person.").open();
                $scope.isDisabled = false;
                return;
            }
        }

        let savingStatus = canSave(saveType);

        if (savingStatus.canSave === false) {
            $dialog.messageBox("Missing brokerage account information", savingStatus.msg, [{
                result: 'ok',
                label: 'Ok'
            }]).open();
            $scope.isDisabled = false;
        }

        if (!savingStatus.canSave) {
            return;
        }

        $scope.newStatus.status = saveType;

        $scope.accountDetails.isActive = !(saveType === "Closed" || saveType === "Denied");

        //new account
        if(!$scope.accountDetails.id){
            createNewAccount();
            return;
        }

        if ($scope.accountDetails.id) {
            //check for closing account on user side
            if (saveType === "Close Pending") {
                saveClosePending(saveType);

            } else {
                updateBrokerageAccount(saveType, reactivate);
            }
        }
    };

    $scope.reEnable = function () {
        $scope.submit('Active', true);
    };

    $scope.deleteFile = function (attachment) {
        $scope.files.remove(attachment.file);
        $scope.accountDetails.attachments.remove(attachment);
    };

    $scope.downloadFile = function (blobId) {
        window.location.href = API_CONFIG.baseUrl + '/Compliance/Inform/BrokerageAccounts/Attachment/Download/' + blobId + '?Authorization=' + sessionStorage.oas_token;
    };

    $scope.cancel = function () {
        dialog.close();
    };

    // INITIALIZE
    $scope.complianceView = false;
    $scope.accessPersonView = false;
    $scope.showComment = false;
    $scope.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
    $scope.complianceAdminOnly = $oasRights.forCode("COMPLIANCEADMINONLY").canRead;

    $scope.account = (dialog.options.brokerageAccount) ? dialog.options.brokerageAccount : {};
    $scope.accountDetails = (dialog.options.brokerageAccount)
        ? dialog.options.brokerageAccount
        : {
            status: "Not Submitted",
            userDetailId: $rootScope.user.authorization.userDetailId,
            statementFrequency: null,
            accountTitle: null,
            custodian: null,
            accountNumber: null,
            managedAccount: false,
            comment: null,
            blobId: 0,
            files: [],
            attachments: [],
            statusHistory: [],
            isActive:true,
        };
    $scope.accessPerson = dialog.options.accessPerson? dialog.options.accessPerson : $scope.accountDetails.accessPerson;
    $scope.sourceUserId = dialog.options.sourceUserId?dialog.options.sourceUserId:false;
    $scope.sourceConnectionId = dialog.options.sourceConnectionId?dialog.options.sourceConnectionId:false;
    $scope.documentStatus = ["Active", "Denied", "Closed", "Follow-up"];
    $scope.showStatus = false;
    $scope.files = [];
    $scope.message = {attachments: []};
    $scope.tabs = {
        General: {
            description: 'General',
            active: true
        },
        Preclearances: {
            description: 'Preclearance',
            active: false
        },
        CloseAccount: {
            description: 'Close Account',
            active: false
        },
    };
    $scope.preclearances = [];
    $scope.showAccessPersonButtons = true;
    $scope.reactivate = dialog.options.brokerageAccount.currentStatus === "Closed" || dialog.options.brokerageAccount.currentStatus === "Denied";
    $scope.isDisabled = false;
    $scope.showReactivateButton = false;
    $scope.accountNumberChanged = false;
    $scope.accountNumber = $scope.accountDetails.accountNumber;
    $scope.accountNumberEdit = $scope.accountDetails.isElectraOption && !$scope.accountDetails.isAccountNumberValidated;
    init();
});
'use strict';

app.component('preclearanceBody', {
    templateUrl: 'tools/inform/components/preclearance-body.html',
    bindings: {
        preclearance: '<',
        accountList: '=',
        tallMode: '<'
    },
    controller: function ($dialog, API_CONFIG, $oasRights, $http, $rootScope) {
        let $ctrl = this;
        let oldValue = null;

        //PRIVATE METHODS

        //PUBLIC METHODS
        
        //LIFECYCLE HOOKS
        $ctrl.$doCheck = function () {
            if (!$ctrl.preclearance.product) {
                $ctrl.preclearance.assetClass = null;
                return;
            }

            if ($ctrl.preclearance.product && $ctrl.preclearance.product !== oldValue) {
                oldValue = $ctrl.preclearance.product;
                $http.get('/Compliance/Inform/AssetClass/' + $ctrl.preclearance.product.productId, {trackerMsg: 'Loading asset class'})
                    .then(function (response) {
                        $ctrl.preclearance.assetClass = response.data;
                    });
            }
        };

        $ctrl.$onInit = function () {
            $ctrl.accounts = $ctrl.accountList;
            $ctrl.documentStatus = ["Approved", "Denied", "Not Submitted"];
            $ctrl.brokerageAccounts = [];
            $ctrl.securityTypes = [];
            $ctrl.clearanceActions = [];
            $ctrl.complianceView = false;
            $ctrl.accessPersonView = false;
            $ctrl.showComment = false;
            $ctrl.rightsCompassInform = $oasRights.forCode("COMPASSINFORM");
            $ctrl.showStatus = false;

            const currentUserId = $rootScope.user.authorization.userDetailId;
            $ctrl.accessPersonView = !$ctrl.preclearance.id || (currentUserId === $ctrl.preclearance.userDetailId);
            $ctrl.complianceView = !$ctrl.accessPersonView && $ctrl.rightsCompassInform.canUpdate;

            $ctrl.statuses = {
                Approved: "Approved",
                Denied: "Denied",
                Followup: "Follow-up",
                InProcess: "Not Submitted"
            };

            $ctrl.current = {
                canEdit: !$oasRights.forCode("INFORM")
            };



            if ($ctrl.complianceView) {
                //the drop downs are not editable.. we can set the list ot the current value of the record
                $ctrl.securityTypes = [$ctrl.preclearance.securityType];
                $ctrl.transactionTypes = [$ctrl.preclearance.transType];
            } else {
                $http.get('/Trading/TransactionTypes?IsValid=True', {trackerMsg: 'Loading transaction types'})
                            .then(function (response) {
                                $ctrl.transactionTypes = response.data.filter(function (transactionType) { return transactionType.id  === 10 || transactionType.id === 53;});
                            });

                $http.get('/Compliance/Inform/BrokerageAccounts/V2?allAccounts=false&simpleList=true', {trackerMsg: 'Loading brokerage accounts'})
                    .then(function (response) {
                            $ctrl.accounts = response.data.filter(function (account) { return account.currentStatus ==="Active";});
                            if ($ctrl.accounts.length === 1) {
                                $ctrl.preclearance.brokerageAccountId = $ctrl.accounts[0].id;
                            }
                        }
                    );

            }
        };
    }
});
'use strict';

app.component('questionnaireAnswer', {
    templateUrl: 'tools/inform/components/questionnaire-answer.html',
    bindings: {
        accessPersonView: "=",
        answer: '<',
        document: '<',
        newFiles: '=',
        accounts: "<"
    },
    controller: function ($dialog, API_CONFIG, $http) {
        let $ctrl = this;

        //PRIVATE METHODS

        //PUBLIC METHODS
        $ctrl.onSelectAnswer = function (childAnswer) {
            if (childAnswer) {
                childAnswer.answer = null;
                if (childAnswer.questionType === "Multi-Checkbox") {
                    childAnswer.questionOptions.forEach(function (element) {
                        element.multiAnswer = false;
                    });
                }
            }
        };

        $ctrl.showBrokerageAccounts = function () {
            $dialog.dialog({
                templateUrl: "tools/inform/modal/inform-brokerage-account-dialog.html",
                controller: "InformBrokerageAccountDialogCtrl",
                brokerageAccount: null,
                documentId: $ctrl.document.id,
                dialogClass: 'modal wide'
            }).open();
        };

        $ctrl.downloadPolicy = function (id) {
            window.location.href = API_CONFIG.baseUrl + '/Compliance/Inform/Policy/Download/Policy/' + id + '?Authorization=' + sessionStorage.oas_token;
        };

        $ctrl.downloadFile = function (id) {
            window.location.href = API_CONFIG.baseUrl + '/Compliance/Inform/Document/Attachment/Download/' + id + '?Authorization=' + sessionStorage.oas_token;
        };

        $ctrl.onFileSelect = function (filesToUpload) {

            if (!$ctrl.answer.attachments) {
                $ctrl.answer.attachments = [];
            }

            filesToUpload.forEach(function (i) {
                $ctrl.answer.attachments.push(
                    {
                        file: i,
                        comment: null,
                        fileName: i.name,
                        auditedDate: null,
                        informDocumentAnswerId: $ctrl.answer.id
                    });

                let newFileIndex = $ctrl.newFiles.findIndex(x => x.id === $ctrl.answer.id);

                if (newFileIndex === -1) {
                    $ctrl.newFiles.push(
                        {
                            id: $ctrl.answer.id,
                            files: [i]
                        }
                    );
                } else {
                    $ctrl.newFiles[newFileIndex].files.push(i);
                }
            });
        };

        $ctrl.deleteFile = function (attachment) {
            $ctrl.answer.attachments.remove(attachment);
            $ctrl.deleteNewFile(attachment);
        };

        $ctrl.deleteNewFile = function (attachment) {
            let newFileIndex = $ctrl.newFiles.findIndex(x => x.id === attachment.informDocumentAnswerId);

            if (newFileIndex !== -1) {
                let fileIndex = $ctrl.newFiles[newFileIndex].files.findIndex(x => x === attachment.file);

                if (fileIndex !== -1) {
                    $ctrl.newFiles[newFileIndex].files.splice(fileIndex, 1);
                }
            }
        }

        $ctrl.formatDateQuestionType = function(dateString){
            $ctrl.answer.answer = Date.create(dateString).format('{yyyy}-{MM}-{dd}');
        };

        $ctrl.getBadgeFromStatus = function (status) {
            return {
                Submitted: "badge-info",
                Approved: "badge-success",
                Active: "badge-success",
                Canceled:"badge-info",
                Denied: "btn-danger",
                New: "badge-success",
                "Not Submitted": "badge-warning",
                "Follow-up": "badge-warning",
                "Verbal Warning":  "badge-warning",
                "Written Warning":  "badge-warning",
                "Loss of Trading Privileges": "badge-warning",
                Termination: "btn-danger",
                "Other":"btn-success"
            }[status];
        };

        $ctrl.disableField = function(){
            return !$ctrl.accessPersonView;
        };

        //LIFECYCLE HOOKS
        $ctrl.$onInit = function () {
            $ctrl.transactions = [];
            if($ctrl.answer.showTransactionHistory && $ctrl.document) {
                var accessPersonId= $ctrl.document.accessPersonId;
                var startDate = Date.create($ctrl.answer.transactionStartDate).format('{yyyy}-{MM}-{dd}');
                var endDate = Date.create($ctrl.answer.transactionEndDate).format('{yyyy}-{MM}-{dd}');
                const url = '/Compliance/Inform/AccessPerson/V2/Transactions?startDate=' + startDate +  '&endDate=' + endDate + '&accessPersonId=' + accessPersonId ;
                $http.get(url , {trackerMsg: 'Loading transaction history'})
                    .then(function (response) {
                        $ctrl.transactions = response.data;
                        $ctrl.transactions.groups = $ctrl.transactions.sortBy("transactionDate").groupBy("accountName");
                    });
            }
        };

    }
});
'use strict';

app.component('statusHistoryTable', {
    templateUrl: 'tools/inform/components/status-history.html',
    bindings: {
        history: '=',
        complianceView: '<',

    },
    controller: statusHistoryCtrl
});

function statusHistoryCtrl($dialog) {

    var $ctrl = this;

    $ctrl.openEmail = function(thisEmail){
        $dialog.dialog({templateUrl: "tools/compass/inform/modal/email-dialog.html",controller: "EmailDialogCtrl", email: thisEmail, emailToName: null, dialogClass: 'modal wide'})
            .open()
            .then(function () {
            });
    };

}
'use strict';

app.component('userConnections', {
    templateUrl: 'tools/inform/components/user-connections.html',
    bindings: {
        connections: '<',
        editAction: '<',
        deleteAction: '<',
        editAccountAction: '<'
    },
    controller: function () {
        let $ctrl = this;

        //PRIVATE METHODS
        function init(){
            $ctrl.connections = $ctrl.connections ? $ctrl.connections : [];
            $ctrl.editAction = $ctrl.editAction;
            $ctrl.deleteAction = $ctrl.deleteAction;
            $ctrl.toggleClosedAccountsAction = $ctrl.toggleClosedAccountsAction;
            $ctrl.editAccountAction = $ctrl.editAccountAction;
        }

        //PUBLIC METHODS
        $ctrl.getBadgeFromStatus = function (status) {
            return {
                Submitted: "badge-info",
                Approved: "badge-success",
                Active: "badge-success",
                Canceled: "badge-info",
                Denied: "badge-danger",
                New: "badge-success",
                "Not Submitted": "badge-warning",
                "Follow-up": "badge-warning",
                "Verbal Warning": "badge-warning",
                "Written Warning": "badge-warning",
                "Loss of Trading Privileges": "badge-warning",
                Termination: "badge-danger",
                "Other": "badge-success"
            }[status];
        };

        //LIFECYCLE HOOKS
        $ctrl.$doCheck = function () {

        };

        $ctrl.$onInit = function () {
            init();
        };
    }
});
app.component('byAllAccountSetup', {
    bindings: {
        authContext: '<',
        credentialId:'<',
        onUserExit: '&',
        onUserDeclinedAgreement: '&',
        onDataChanged: '&',
        onDataChangedAsync:'&',
        onDataChangedAsyncAuthenticate:'&'
    },
    templateUrl: "tools/inform/components/by-all-account-setup.html",
    controller: function byAllAccountSetupCtrl() {
        const $ctrl = this;

        //PUBLIC METHODS
        $ctrl.badAuthentication = function ($event) {
            console.log('bad authentication');
            console.log($event);
            $ctrl.current.errorMessage = 'Your session has timed out, please log in again.';
        };

        $ctrl.badConfiguration = function ($event) {
            console.log('bad configuration');
            console.log($event);
        };

        $ctrl.internalError = function ($event) {
            $ctrl.current.errorMessage = 'internal error';
            console.log('internal error');
            console.log($event);
        };

        $ctrl.userExit = function ($event) {
            $ctrl.onUserExit({event: $event});
        };

        $ctrl.userDeclinedAgreement = function($event){
            const msg = 'Access Denied - Please review agreement with your supervisor';
            console.log(msg);
            $ctrl.current.errorMessage = msg;
            $ctrl.onUserDeclinedAgreement({event:$event});
        };

        $ctrl.dataChanged = function($event){
            $ctrl.onDataChanged({event: $event});
            console.log('dataChanged');
            console.log($event);
        };

        $ctrl.dataChangedAsync = function($event){
            $ctrl.onDataChangedAsync({event: $event});
            console.log('dataChangedAsync');
            console.log($event);
        };

        $ctrl.dataChangedAsyncAuthenticate = function($event){
            $ctrl.onDataChangedAsyncAuthenticate({event: $event});
            console.log('dataChangedAsyncAuthenticate');
            console.log($event);
        };

        //LIFECYCLE HOOKS
        $ctrl.$onChanges = function (changes) {
            const authContext = changes.authContext && changes.authContext.currentValue ? changes.authContext.currentValue : undefined;

                    if (authContext) {
                        $ctrl.authContextAsString = JSON.stringify(authContext);
                    }
        };

        $ctrl.current={
          errorMessage:null,
        };
    }
});
'use strict';

app.controller('PasswordEmailTemplateCtrl', function PasswordEmailTemplateCtrl($scope, $http, $location, $dialog, $oasRights, $q) {
    //PRIVATE VARIABLES
    var newUserEmailTemplate = null;

    var emailTemplate = {
        newUser: {
            body: "Hello &lt;FirstName LastName&gt;!<br/><br/>"
                + "A new user login has been created for you in the &lt;Firm Name&gt; system. Please use the username and link below to set your password and complete the sign up process.<br/><br/>"
                + "<br/>&lt;User ID&gt;<br/><br/>",
            subject: 'Password Request'
        },
        resetUser: {
            body: "&lt;FirstName LastName&gt;!<br/><br/>"
                + "Your login has been reset in the &lt;Firm Name&gt; system. Please use the link below to set a new password.<br/><br/>",
            subject: 'Password Request'
        },
        forgotPassword: {
            body: "Click the link to reset your password.",
            subject: 'Password Reset Request'
        }
    };


    //PRIVATE METHODS
    function init() {
        var promises = [
            $http.get("/Settings/EntityOptions/Database/Code/69EMAILFRO", {trackerMsg: 'Loading default sender email'}),
            $http.get("/Settings/EntityOptions/Database/Code/69NEWUSERE", {trackerMsg: 'Get new user email template'}),
            $http.get("/Settings/EntityOptions/Database/Code/69PASSWORD", {trackerMsg: 'Get link timeout'})
        ];

        $q.all(promises).then(function (ee) {
            newUserEmailTemplate = ee.map(function (item) {
                return item.data[0];
            });

            $scope.current.emailFrom = newUserEmailTemplate.find({code: '69EMAILFRO'}).value;
            $scope.current.linkExpire = newUserEmailTemplate.find({code: '69PASSWORD'}).value;

            Object.each(ee, function (idx, entityOption) {
                var option = entityOption.data[0];

                switch (option.code) {
                    case '69NEWUSERE':
                        if (option.value.length > 0) {
                            var storedValue = JSON.parse(option.value);

                            $scope.current.newBody = storedValue.newBody;
                            $scope.current.newSubject = storedValue.newSubject;
                            $scope.current.resetBody = storedValue.resetBody;
                            $scope.current.resetSubject = storedValue.resetSubject;
                            $scope.current.forgotBody = storedValue.forgotBody;
                            $scope.current.forgotSubject = storedValue.forgotSubject;
                        } else {
                            var newUser = emailTemplate["newUser"];
                            $scope.current.newBody = newUser.body;
                            $scope.current.newSubject = newUser.subject;

                            var resetUser = emailTemplate["resetUser"];
                            $scope.current.resetBody = resetUser.body;
                            $scope.current.resetSubject = resetUser.subject;

                            var forgotPassword = emailTemplate["forgotPassword"];
                            $scope.current.forgotBody = forgotPassword.body;
                            $scope.current.forgotSubject = forgotPassword.subject;
                        }
                        break;
                    case '69EMAILFRO':
                        if (option.value.length > 0) {
                            $scope.current.emailFrom = option.value;
                        }
                        break;
                }
            });
        });
    }

    function encodeHtml(value) {
        return value.replace(/[&<>]/g, function (character) {
            return {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;'
            }[character];
        });
    }


    //PUBLIC METHODS
    $scope.invalidEmail = function (invalid) {
        $scope.current.emailFromInvalid = invalid;
    }

    $scope.setEmail = function (value) {
        $scope.current.emailFrom = value;
    }

    $scope.saveEmailPref = function () {
        var eeToSave = [];

        var newUser = newUserEmailTemplate.find({code: '69NEWUSERE'});
        if (newUser != $scope.current.newBody) {
            $scope.current.resetBody = $scope.current.resetBody.replace('<p>&nbsp;</p>', '<br/>');
            $scope.current.newBody = $scope.current.newBody.replace('<p>&nbsp;</p>', '<br/>');
            $scope.current.forgotBody = $scope.current.forgotBody.replace('<p>&nbsp;</p>', '<br/>');

            var optionValue = {
                newBody: $scope.current.newBody,
                resetBody: $scope.current.resetBody,
                forgotBody: $scope.current.forgotBody,
                newSubject: $scope.current.newSubject,
                resetSubject: $scope.current.resetSubject,
                forgotSubject: $scope.current.forgotSubject
            };

            newUser.value = JSON.stringify(optionValue);
            eeToSave.push(newUser);
        }

        var emailFrom = newUserEmailTemplate.find({code: '69EMAILFRO'});
        if (emailFrom != $scope.current.emailFrom) {
            emailFrom.value = $scope.current.emailFrom;
            eeToSave.push(emailFrom);
        }

        $http.put('/Settings/EntityOptions/Database/', eeToSave, {trackerMsg: 'Updating email password template'})
            .then(function () {
                $dialog.saveSuccessful("Email templates have been saved successfully.").open();
            });
    };

    //INITIALIZE
    $scope.rightsEmailPasswordTemplates = $oasRights.forCode('EMAILPASSWORDTEMPLATES');

    $scope.current = {
        newSubject: '',
        resetSubject: '',
        forgotSubject: '',
        newBody: '',
        resetBody: '',
        forgotBody: '',
        mergeFields: {
            0: '<FirstName LastName>',
            2: '<Firm Name>',
            3: '<User ID>'
        }
    };

    $scope.isValidEmail = true;

    $scope.insertPreset = function () {
        var mergeField = $scope.current.mergeFields[$scope.current.mergeField];
        mergeField = encodeHtml(mergeField);

        tinyMCE.execCommand('mceInsertContent', false, mergeField);
        $scope.current.mergeField = '';
    };

    init();
});


'use strict';

var processDashboardApp = app.factory('ProcessDashboard', function ProcessDashboard($http, $q, $oasRights, $location, $dialog, $settings, entities, $confirmation, Repo, processFieldType, processActionType) {
    var service = this;

    // INIT
    function init() {
        return $q.all(Object.values(load).map(function(i){return i()})).then(function(){
            return service;
        });
    }

    // PRIVATE VARIABLES
    var endpoints = {
        process: {
            types: {
                getAll: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Types',
                    //params: {defaultValue: 8},
                    verb: 'GET',
                    message: 'Loading Process Types'
                }),
                get: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Types/{id:int}',
                    //params: {defaultValue: 8},
                    verb: 'GET',
                    message: 'Loading Process Types'
                }),
                save: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Types/{id:int}',
                    //params: {defaultValue: 8},
                    verb: 'PUT',
                    message: 'Loading Process Types'
                }),
                create: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Types',
                    //params: {defaultValue: 8},
                    verb: 'POST',
                    message: 'Loading Process Types'
                })
            },
            actions: {
                getAllByType: Repo.endpoint({
                    /***
                     * @param   typeId          <int>       This is the ProcessTypeId
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Types/{typeId:int}/Actions',
                    //params: {defaultValue: 8},
                    verb: 'GET',
                    message: 'Loading Process Actions'
                }),
                getAll: Repo.endpoint({
                    /***
                     * @param   typeId          <int>       This is the ProcessTypeId
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Actions',
                    //params: {defaultValue: 8},
                    verb: 'GET',
                    message: 'Loading Process Actions'
                }),
                get: Repo.endpoint({
                    /***
                     * @param   typeId          <int>       This is the ProcessTypeId
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Actions/{id:int}',
                    //params: {defaultValue: 8},
                    verb: 'GET',
                    message: 'Loading Process Action'
                }),
                create: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Actions',
                    verb: 'POST',
                    message: 'Creating Process Action'
                }),
                save: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Actions/{id:int}',
                    //params: {defaultValue: 8},
                    verb: 'PUT',
                    message: 'Saving Process Action'
                }),
                delete: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Actions/{id:int}',
                    verb: 'DELETE',
                    message: 'Deleting Process Action'
                }),
                serviceCodes: Repo.endpoint({
                    /***
                     * @return  String[]
                     */
                    path: '/Utility/Process/Actions/ServiceCodes',
                    //params: {defaultValue: 8},
                    verb: 'GET',
                    message: 'Loading Process Action Service Codes'
                }),
                getFields: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Actions/{id:int}/fields',
                    verb: 'GET',
                    message: 'Loading Action Fields'
                })
            },
            tasks: {
                get: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Tasks/{id:int}',
                    verb: 'GET',
                    message: 'Loading Process Task'
                }),
                create: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Tasks',
                    verb: 'POST',
                    message: 'Creating Process Task'
                }),
                save: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Tasks/{id:int}',
                    //params: {defaultValue: 8},
                    verb: 'PUT',
                    message: 'Saving Process Task'
                }),
                delete: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Tasks/{id:int}',
                    verb: 'DELETE',
                    message: 'Deleting Process Task'
                }),
                getAll: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Tasks',
                    verb: 'GET',
                    message: 'Loading Process Tasks'
                })
            },
            activities: {
                get: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Activities/{id:int}',
                    verb: 'GET',
                    message: 'Loading Process Activity'
                }),
                create: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Activities',
                    verb: 'POST',
                    message: 'Creating Process Activity'
                }),
                save: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Activities/{id:int}',
                    //params: {defaultValue: 8},
                    verb: 'PUT',
                    message: 'Saving Process Activity'
                }),
                delete: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Activities/{id:int}',
                    verb: 'DELETE',
                    message: 'Deleting Process Activity'
                }),
                getAll: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Activities/{id:int}',
                    verb: 'GET',
                    message: 'Loading Process Activities'
                })
            },
            elements: {
                get: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Elements/{id:int}',
                    verb: 'GET',
                    message: 'Loading Process Elements'
                }),
                create: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Elements',
                    verb: 'POST',
                    message: 'Creating Process Elements'
                }),
                save: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Elements/{id:int}',
                    //params: {defaultValue: 8},
                    verb: 'PUT',
                    message: 'Saving Process Elements'
                }),
                delete: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Elements/{id:int}',
                    verb: 'DELETE',
                    message: 'Deleting Process Element'
                }),
                getAll: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Elements/{id:int}',
                    verb: 'GET',
                    message: 'Loading Process Elements'
                })
            },
            events: {
                get: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Events/{id:int}',
                    verb: 'GET',
                    message: 'Loading Process Events'
                }),
                create: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Events',
                    verb: 'POST',
                    message: 'Creating Process Events'
                }),
                save: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Events/{id:int}',
                    //params: {defaultValue: 8},
                    verb: 'PUT',
                    message: 'Saving Process Events'
                }),
                delete: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Events/{id:int}',
                    verb: 'DELETE',
                    message: 'Deleting Process Event'
                }),
                getAll: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Events/{id:int}',
                    verb: 'GET',
                    message: 'Loading Process Events'
                })
            },
            participants: {
                get: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Participants/{id:int}',
                    verb: 'GET',
                    message: 'Loading Process Participant'
                }),
                create: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Participants',
                    verb: 'POST',
                    message: 'Creating Process Participant'
                }),
                save: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Participants/{id:int}',
                    //params: {defaultValue: 8},
                    verb: 'PUT',
                    message: 'Saving Process Participant'
                }),
                delete: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Participants/{id:int}',
                    verb: 'DELETE',
                    message: 'Deleting Process Participant'
                }),
                getAll: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Participants/{id:int}',
                    verb: 'GET',
                    message: 'Loading Process Participants'
                })
            },
            assignments: {
                get: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Assignments/{id:int}',
                    verb: 'GET',
                    message: 'Loading Process Assignment'
                }),
                create: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Assignments',
                    verb: 'POST',
                    message: 'Creating Process Assignment'
                }),
                save: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Assignments/{id:int}',
                    //params: {defaultValue: 8},
                    verb: 'PUT',
                    message: 'Saving Process Assignment'
                }),
                delete: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Assignments/{id:int}',
                    verb: 'DELETE',
                    message: 'Deleting Process Assignment'
                }),
                getAll: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Assignments',
                    verb: 'GET',
                    message: 'Loading Process Assignments'
                })
            },
            fields: {
                get: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Fields/{id:int}',
                    verb: 'GET',
                    message: 'Loading Process Field'
                }),
                create: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Fields',
                    verb: 'POST',
                    message: 'Creating Process Field'
                }),
                save: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Fields/{id:int}',
                    //params: {defaultValue: 8},
                    verb: 'PUT',
                    message: 'Saving Process Types'
                }),
                delete: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Fields/{id:int}',
                    verb: 'DELETE',
                    message: 'Deleting Process Field'
                }),
                getAll: Repo.endpoint({
                    /***
                     * @param   taskId       <int>
                     * @param   processId    <int>
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Fields',
                    verb: 'GET',
                    message: 'Loading Process Fields'
                })
            },
            definitions: {
                get: Repo.endpoint({
                    /***
                     * @param   id          <int>
                     * @return  ProcessInstanceDto[]
                     */
                    path: '/Utility/Process/Definitions/{id:int}',
                    //params: {defaultValue: 8},
                    verb: 'GET',
                    message: 'Loading Process Definition'
                }),
                getDetail: Repo.endpoint({
                    /***
                     * @param   id          <int>
                     * @return  ProcessInstanceDto[]
                     */
                    path: '/Utility/Process/Definitions/{id:int}/Detail',
                    //params: {defaultValue: 8},
                    verb: 'GET',
                    message: 'Loading Process Definition'
                }),
                getAll: Repo.endpoint({
                    /***
                     * @param   id          <int>
                     * @return  ProcessInstanceDto[]
                     */
                    path: '/Utility/Process/Definitions',
                    //params: {defaultValue: 8},
                    verb: 'GET',
                    message: 'Loading Process Definitions'
                }),
                create: Repo.endpoint({
                    /***
                     * @param   id          <int>
                     * @return  ProcessInstanceDto[]
                     */
                    path: '/Utility/Process/Definitions',
                    verb: 'POST',
                    message: 'Creating new Definition'
                }),
                save: Repo.endpoint({
                    /***
                     * @param   id          <int>
                     * @return  ProcessInstanceDto[]
                     */
                    path: '/Utility/Process/Definitions/{id:int}',
                    verb: 'PUT',
                    message: 'Saving the Definition'
                }),
                delete: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Definitions/{id:int}',
                    verb: 'DELETE',
                    message: 'Deleting Process Definition'
                }),
                finalize: Repo.endpoint({
                    /***
                     * @param   id          <int>
                     * @return  ProcessInstanceDto[]
                     */
                    path: '/Utility/Process/Definitions/{id:int}/Finalize',
                    verb: 'PUT',
                    message: 'Setting the Definition as final'
                }),
                activate: Repo.endpoint({
                    /***
                     * @param   id          <int>
                     * @return  ProcessInstanceDto[]
                     */
                    path: '/Utility/Process/Definitions/{id:int}/Activate',
                    verb: 'PUT',
                    message: 'Activating the Process Definition'
                }),
                deactivate: Repo.endpoint({
                    /***
                     * @param   id          <int>
                     * @return  ProcessInstanceDto[]
                     */
                    path: '/Utility/Process/Definitions/{id:int}/Deactivate',
                    verb: 'PUT',
                    message: 'Deactivating the Process Definition'
                })
            },
            instances: {
                get: Repo.endpoint({
                    /***
                     * @param   id          <int>
                     * @return  ProcessInstanceDto[]
                     */
                    path: '/Utility/Process/Instances/{id:int}',
                    verb: 'GET',
                    message: 'Loading Process Instance'
                }),
                create: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Instances',
                    verb: 'POST',
                    message: 'Creating Process Instance'
                }),
                save: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Instances/{id:int}',
                    verb: 'POST',
                    message: 'Saving Process Instance'
                }),
                delete: Repo.endpoint({
                    /***
                     * @return  SimpleEntity[]
                     */
                    path: '/Utility/Process/Instances/{id:int}',
                    verb: 'DELETE',
                    message: 'Deleting Process Instance'
                }),
            }
        }
    };

    var load = {
        definitions: function(refresh) {
            if(refresh === false && data.definitions) return data.definitions;
            if(!data.definitions) data.definitions = [];
            return endpoints.process.definitions.getAll().then(function(response){
                return angular.copy(response.data, data.definitions);
            })
        }/*,
        serviceCodes: function(refresh) {
            if(refresh === false && data.servicesCodes) return data.servicesCodes;
            if(!data.servicesCodes) data.servicesCodes = [];
            return endpoints.process.actions.serviceCodes().then(function(response){
                return angular.copy(response.data, data.servicesCodes);
            })
        }*/
    };

    var data = {};

    var rights = {
        //confirmationOverview: $oasRights.forCode("CONFIRMOVERVIEW"),
    };

    var defaults = {
        processType: {
            id: 0,
            name: undefined,
            description: undefined,
            securityCode: undefined,
            privilegeCode: undefined,
            processName: undefined,
            taskName: undefined,
            rulesClassName: undefined,
            controllerClassName: undefined,
            canUnassignTask: false,
            canReassignTask: false,
            allowTaskCategories: false,
            allowDeptCategories: false,
            allowTaskStatuses: false,
            allowMultipleTasks: false,
            allowTaskMultipleAssigned: false,
            emailOwnerOnChange: false,
            dontEmailIfOwnerIsAssigned: false,
            useUserLevels: false,
            allowAssignTasks: false,
            autoAssignUsers: false,
            allowLinkedEntities: false,
            useDepartmentAssignment: false,
        }
    };
    // PRIVATE METHODS
    function typeKey(type) {
        if(angular.isNumber(type)) type = service.data.types.find({id: parseInt(type)});
        if(type) return type.urlName || type.id;
        else return false;
    }

    // PUBLIC VARIABLES
    service.rights = rights;
    service.default = defaults;
    service.processFieldType = processFieldType.values();
    service.processActionType = processActionType.values();
    service.data = data;

    // SHARED DATA
    service.init = init();
    service.load = load;

    // PUBLIC ENDPOINTS
    service.types = endpoints.process.types;
    service.phases = endpoints.process.phases;
    service.actions = endpoints.process.actions;
    service.instances = endpoints.process.instances;
    service.definitions = endpoints.process.definitions;
    service.tasks = endpoints.process.tasks;
    service.fields = endpoints.process.fields;
    service.activities = endpoints.process.activities;
    service.elements = endpoints.process.elements;
    service.events = endpoints.process.events;
    service.participants = endpoints.process.participants;
    service.assignments = endpoints.process.assignments;

    // PUBLIC METHODS

    service.typeByKey = function(key) {
        if(parseInt(key)) return service.data.types.find({id: parseInt(key)});
        if(angular.isString(key)) return service.data.types.find({urlName: key});
    };

    service.goTo = function(route) {
        if (route) $location.url(route);
        else return this;
    };

    angular.extend(service.goTo, {
        definitions: function(type) {
            if(typeKey(type)) service.goTo("/tools/process/{1}/definitions".assign(typeKey(type)));
            else throw "Process Type is required.";
        },
        definition: function(item) {
            var id = item && item.id ? item.id : item;
            if(angular.isNumber(id)) service.goTo("/tools/process/definitions/{1}".assign(id));
            else throw "Process Type and Template is required.";
        },
        instance: function(instance) {
            service.goTo("/tools/process/instances/{1}".assign(instance.id));
            // throw "Process Type is required.";
        },
        tasks: function() {
            console.log('Not implemented');
        },
        actions: function(type) {
            if(typeKey(type)) service.goTo("/tools/process/{1}/actions".assign(typeKey(type)));
            else throw "Process Type is required.";
        },
        type: function(type) {
            if(typeKey(type)) service.goTo("/tools/process/{1}".assign(typeKey(type)));
            else throw "Process Type is required.";
        }
    });

    service.openEditor = function( template, controller, options ) {
        options = angular.merge({
            defaultTab: {name: 'General', code: 'general'}
        }, options);
        return $dialog.editor(template, controller, {
            args: function() {return options}
        }).open();
    };

    service.openDialog = function(options) {
        options = angular.merge({dialogClass: "modal", templateUrl: null, controller: null}, options);
        return $dialog.dialog(options).open()
            .then(function (result) {
                    if( result ) return result;
                    else return $q.reject(result);
                }
            );
    };

    service.dialog = {
        newDefinition: function(options) {
            return service.openDialog(angular.merge({templateUrl: 'tools/processdashboard/modals/CreateProcessDefinition.html', controller: 'CreateProcessDefinitionCtrl'}, options))
        },
        newInstance: function(options) {
            return service.openDialog(angular.merge({templateUrl: 'tools/processdashboard/modals/CreateProcessInstance.html', controller: 'CreateProcessInstanceCtrl'}, options))
        },
        newParticipant: function(options) {
            return service.openDialog(angular.merge({templateUrl: 'tools/processdashboard/modals/CreateParticipant.html', controller: 'CreateParticipantCtrl'}, options))
        }
    };

    service.editor = {
        type: function( options ) {
            return service.openEditor('tools/processdashboard/modals/ProcessTypeEditor.html', 'ProcessTypeEditorCtrl', options)
        }
    };

    return service;
});

processDashboardApp.processDashboardInitialized = ["ProcessDashboard", function (ProcessDashboard) {
    return ProcessDashboard.init;
}];
'use strict';

var processDashboardCtrl = app.controller('ProcessDashboardCtrl', function ProcessDashboardCtrl($scope, listSectionData, ProcessDashboard, config, $q, $http, apps) {

    // PRIVATE METHODS
    function init( ) {
        $scope.items = ProcessDashboard.data.definitions;
    }

    // PUBLIC METHODS

    $scope.newDefinition = ProcessDashboard.dialog.newDefinition;
    $scope.newInstance = ProcessDashboard.dialog.newInstance;

    $scope.addInstance = function(definition) {
        return ProcessDashboard.dialog.newInstance({definition: definition}).then(function(instance){
            return ProcessDashboard.instances.get({params: {id: instance.id}, trim: true}).then(function(instance){
                definition.instances.push(instance);
                return instance;
            });
        });
    };

    $scope.deleteInstance = function(instance) {
        return ProcessDashboard.instances.delete({params: { id: instance.id }}).then(function(){
            return $scope.items.find({id: instance.processTypeId}).instances.remove(instance);
        });
    };

    $scope.newAction = function(type) {
        type.actions.push({
            processTypeId: type.id
        })
    };

    $scope.openDefinitionEditor = function(type){
        return ProcessDashboard.editor.type(type ? {id: type.id} : {});
    };

    // EVENT LISTENERS

    // INIT

    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: {get: function() {return $scope.selectedItems.map('id')}},
        selected: {get: function() {return $scope.selectedItems[0] || undefined;}}
    });

    $scope.current = {
    };

    // Expose to view
    angular.extend($scope, {
        goTo: ProcessDashboard.goTo
    });

    init();
});

processDashboardCtrl.loadProcessDashboardConfig = ["$q", "$route", "ProcessDashboard", function ($q, $route, ProcessDashboard) {
    return $q.all({
        types: ProcessDashboard.types.getAll({trim: true})
    });
}];
'use strict';

app.controller('ProcessInstanceCtrl', function ProcessInstanceCtrl($scope, ProcessDashboard, $route, $q) {

    function init( ) {
        $scope.type = ProcessDashboard.typeByKey($route.current.params.type);
        loadDefinition();
        console.log($scope.user.authorization);
    }

    function loadDefinition(instance) {
        return ($scope.item.id > 0
                ? instance
                    ? $q.resolve({data: instance})
                    : ProcessDashboard.instances.get({params: {id: $scope.item.id}})
                : $q.reject({data:"The URL path does not have an appropriate ID."})
        ).then(
            function(response){
                angular.copy(response.data, $scope.item);
                if(!$scope.item.type) $scope.item.type = $scope.type;
            },
            function(error) {
                return $dialog.actionFailed(
                    !error.data.userException
                        ? error.data
                        : error.data.userException.detail
                ).open();
            }
        )
    }

    function saveDefinition() {
        return ProcessDashboard.definitions.save({data: $scope.item, params: {id: $scope.item.id}}).then(function(response){
            angular.copy(response.data, $scope.item);
            if(!$scope.item.type) $scope.item.type = $scope.type;
        })
    }

    // PUBLIC METHODS
    $scope.addActivity = function() {
        var activity = {
            definitionId: $scope.item.id
        };
        $scope.item.activities.push(activity)
    };

    $scope.saveDefinition = saveDefinition;

    $scope.finalizeDefinition = function() {
        return ProcessDashboard.definitions.finalize({params: {id: $scope.item.id}}).then(function(response){
            return loadDefinition(response.data);
        });
    };

    $scope.activateDefinition = function() {
        return ProcessDashboard.definitions.activate({params: {id: $scope.item.id}}).then(function(response){
            return loadDefinition(response.data);
        });
    };

    $scope.deactivateDefinition = function() {
        return ProcessDashboard.definitions.deactivate({params: {id: $scope.item.id}}).then(function(response){
            return loadDefinition(response.data);
        });
    };

    $scope.newParticipant = function() {
        return ProcessDashboard.dialog.newParticipant({definition: $scope.item}).then(function(participant){
            $scope.item.participants.push(participant)
        });
    };

    $scope.deleteParticipant = function() {
        var participant = this.participant;
        return ProcessDashboard.participants.delete({params: {id: participant.id}}).then(function(response){
            return loadDefinition(response.definition);
        });
    };

    // EVENT LISTENERS

    // INIT
    $scope.item = {
        id: $route.current.params.id
    };

    init();
});


'use strict';

app.controller('ProcessInstanceListCtrl', function ProcessInstanceListCtrl($scope, ProcessDashboard, config, $route, $http, apps) {

    // PRIVATE METHODS
    function init( ) {
        loadSummaryInstances();
        $scope.type = config.types.find({id: parseInt($route.current.params.type)});
    }

    // PUBLIC METHODS

    function loadSummaryInstances() {
        return ProcessDashboard.instances.getAllSummary().then(function(response){
            $scope.items = response.data;
        })
    }

    $scope.selectInstance = function(instance){
        instance.selected = !instance.selected;
        console.log(instance);
    };

    $scope.createInstance = ProcessDashboard.dialog.newInstance;

    $scope.templateFromInstance = function(key){
        return ProcessDashboard.definitions.fromInstance({confirm: 'Continue to copy this Process Instance into a new Template.', params: {key: key}});
    };

    // EVENT LISTENERS

    // INIT

    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: {get: function() {return $scope.selectedItems.map('id')}},
        selected: {get: function() {return $scope.selectedItems[0] || undefined;}}
    });

    $scope.current = {
        statusColor: {
            complete: '#9BDF8D',
            pending: '#FFDA6F'
        }
    };

    init();
});


'use strict';

app.controller('ProcessTypeCtrl', function ProcessTypeCtrl($scope, ProcessDashboard, $http, apps, $route, $dialog, $q) {

    // PRIVATE METHODS
    function init( ) {
        buildMenu();
        $scope.item = ProcessDashboard.typeByKey($route.current.params.type);
        ProcessDashboard.load.types();
    }

    // PUBLIC METHODS
    function buildMenu() {
        $scope.menu = { categories: [ ] };
        $scope.menu.categories.push( {name: 'General', children: [] } );
        $scope.menu.categories[0].children.push( {name: 'General', active: true, code: 'general'} );
        $scope.menu.categories[0].children.push( {name: 'Settings', active: false, code: 'settings'} );
        $scope.menu.categories.push( {name: 'Structure', children: [] } );
        $scope.menu.categories[1].children.push( {name: 'Definitions', active: false, code: 'definitions'} );
        $scope.menu.categories[1].children.push( {name: 'Actions', active: false, code: 'actions'} );
    }

    $scope.loadTab = function( child ) {
        $scope.menu.categories.each( function( c ) {
            c.children.each( function( ch ) {
                ch.active = ch.code == child.code;
            } );
        } );

        $scope.current.selectedTab = child.code;
    };

    $scope.goTo = ProcessDashboard.goTo;

    $scope.addDefinition = function() {
        return ProcessDashboard.dialog.newDefinition({type: $scope.item}).then(function(definition){
            $scope.item.definitions.push(definition);
        });
    };

    $scope.deleteDefinition = function(definition) {
        if (!definition) definition = this.definition;
        return ProcessDashboard.definitions.delete({params: {id: definition.id}}).then(function(){
            $scope.item.definitions.remove(definition);
        });
    };

    // EVENT LISTENERS

    // INIT
    $scope.current = {
        search: null,
        selectedTab: 'definitions'
    };

    init();
});


'use strict';

app.controller('ProcessActionListCtrl', function ProcessActionListCtrl($scope, ProcessDashboard, $http, apps, config, $route) {
    var entityService = ProcessDashboard.actions;

    // PRIVATE METHODS
    function init( ) {
        $scope.type = config.types.find({id: parseInt($route.current.params.type)});
    }

    function defaultItem() {
        var item = {};
        if($scope.type) item.processTypeId = $scope.type.id;
        return item;
    }

    function loadAll() {
        var options = {params: {}};
        if($scope.type) options.params.processTaskId = $scope.type.id || $scope.type;
        $scope.loading = true;
        return entityService.getAll(options).then(function(response){
            if($scope.type.actions) angular.copy(response.data, $scope.type.actions);
            else $scope.type.actions = response.data;
            $scope.loading = false;
        });
    }

    function loadItem(item) {
        if(!item) item = {};
        $scope.loading = true;
        return $q.resolve(
            item.id
                ? entityService.get({params: {id: item.id}, trim: true})
                : this.defaultItem()
        ).then(function(updated){
            angular.copy(updated, item);
            if ($scope.type.actions && !~$scope.type.actions.findIndex({id: item.id}) || !(item.id > 0)) $scope.type.actions.add(item);
            $scope.loading = false;
            return item;
        });
    }

    function deleteItem(item) {
        return (item.id
                ? entityService.delete({confirm: "Delete item: {name}?".assign(item), params: {id: item.id}})
                : $q.resolve(item)
        ).then(function(response){
            $scope.type.actions.remove(item);
        });
    }

    function saveItem(item) {
        $scope.loading = true;
        return (!item.id
                ? entityService.create({data: item})
                : entityService.save({data: item, params: {id: item.id}})
        ).then(function(response){
            angular.copy(response.data, item);
            $scope.loading = false;
            return item;
        });
    }

    // PUBLIC METHODS
    $scope.loading = false;
    $scope.loadAll = loadAll;
    $scope.defaultItem = defaultItem;
    $scope.loadItem = loadItem;
    $scope.deleteItem = deleteItem;
    $scope.saveItem = saveItem;

    // EVENT LISTENERS

    // INIT

    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: {get: function() {return $scope.selectedItems.map('id')}},
        selected: {get: function() {return $scope.selectedItems[0] || undefined;}}
    });

    $scope.current = {

    };

    init();
});


'use strict';

app.controller('ProcessDefinitionCtrl', function ProcessDefinitionCtrl($scope, ProcessDashboard, $http, apps, $route, $dialog, $q) {

    // PRIVATE METHODS
    function init( ) {
        loadDefinition();
    }

    function loadDefinition(definition) {
        return ($scope.item.id > 0
                ? definition
                    ? $q.resolve({data: definition})
                    : ProcessDashboard.definitions.getDetail({params: {id: $scope.item.id}})
                : $q.reject({data:"The URL path does not have an appropriate ID."})
        ).then(
            function(response){
                angular.copy(response.data, $scope.item);
            },
            function(error) {
                return $dialog.actionFailed(
                    !error.data.userException
                        ? error.data
                        : error.data.userException.detail
                ).open();
            }
        )
    }

    function saveDefinition() {
        return ProcessDashboard.definitions.save({data: $scope.item, params: {id: $scope.item.id}}).then(function(response){
            angular.copy(response.data, $scope.item);
        })
    }

    // PUBLIC METHODS
    angular.extend(ProcessDashboard.goTo, $scope.goTo);

    $scope.addInstance = function() {
        return ProcessDashboard.dialog.newInstance({definition: $scope.item}).then(function(instance){
            return ProcessDashboard.instances.get({params: {id: instance.id}, trim: true}).then(function(instance){
                ProcessDashboard.goTo.instance(instance);
                //$scope.item.instances.push(instance);
                //return instance;
            });
        });
    };

    $scope.addActivity = function() {
        var activity = {
            definitionId: $scope.item.id
        };
        $scope.item.activities.push(activity)
    };

    $scope.saveDefinition = saveDefinition;

    $scope.finalizeDefinition = function() {
        return ProcessDashboard.definitions.finalize({params: {id: $scope.item.id}}).then(function(response){
            return loadDefinition(response.data);
        });
    };

    $scope.activateDefinition = function() {
        return ProcessDashboard.definitions.activate({params: {id: $scope.item.id}}).then(function(response){
            return loadDefinition(response.data);
        });
    };

    $scope.deactivateDefinition = function() {
        return ProcessDashboard.definitions.deactivate({params: {id: $scope.item.id}}).then(function(response){
            return loadDefinition(response.data);
        });
    };

    $scope.newParticipant = function() {
        return ProcessDashboard.dialog.newParticipant({definition: $scope.item}).then(function(participant){
            $scope.item.participants.push(participant)
        });
    };

    $scope.deleteParticipant = function() {
        var participant = this.participant;
        return ProcessDashboard.participants.delete({params: {id: participant.id}}).then(function(response){
            return loadDefinition(response.definition);
        });
    };

    // EVENT LISTENERS

    // INIT
    $scope.item = {
        id: $route.current.params.id
    };

    init();
});


'use strict';

app.controller('ProcessTemplateListCtrl', function ProcessTemplateListCtrl($scope, ProcessDashboard, $route, config, $http, apps) {

    // PRIVATE METHODS
    function init( ) {
        loadTemplates();

    }

    // PUBLIC METHODS

    function loadTemplates() {
        return ProcessDashboard.definitions.getAll().then(function(response){
            $scope.items = response.data;
        })
    }

    $scope.selectInstance = function(instance){
        instance.selected = !instance.selected;
        console.log(instance);
    };

    $scope.newTemplate = ProcessDashboard.dialog.newTemplate;

    // EVENT LISTENERS

    // INIT

    $scope.selectedItems = [];
    Object.defineProperties($scope, {
        selectedIds: {get: function() {return $scope.selectedItems.map('id')}},
        selected: {get: function() {return $scope.selectedItems[0] || undefined;}}
    });

    $scope.type = config.types.find({id: parseInt($route.current.params.type)});
    $scope.current = {
        statusColor: {
            complete: '#9BDF8D',
            pending: '#FFDA6F'
        }
    };

    init();
});


'use strict';

app.controller('CreateProcessDefinitionCtrl', function CreateProcessDefinitionCtrl($scope, ProcessDashboard, $timeout, $http, apps, $q, dialog, Entity) {



    // PRIVATE METHODS - INIT
    function init() {

    }

    // PUBLIC METHODS
    $scope.create = function() {
        return ProcessDashboard.definitions.create({data: $scope.item, trim: true})
            .then(function(item){
                dialog.close( item );
            });
    };

    $scope.cancel = function( ) {
        dialog.close( null );
    };

    // EVENT LISTENERS

    // INIT
    $scope.type = dialog.options.type;

    $scope.item = {
        processTypeId: $scope.type.id
    };


    $scope.current = {
        isLoading: false
    };

    init();
});
'use strict';

app.controller('CreateProcessInstanceCtrl', function CreateProcessInstanceCtrl($scope, ProcessDashboard, $timeout, $http, apps, $q, dialog, Entity) {
    // PRIVATE METHODS - INIT
    function init() {
        if($scope.definition)
            return;
        else throw "Nothing to go off of.";
    }

    // PUBLIC METHODS
    $scope.create = function() {
        return ProcessDashboard.instances.create({data: $scope.item, trim: true})
            .then(function(item){
                dialog.close( item );
            });
    };

    $scope.cancel = function( ) {
        dialog.close( null );
    };

    // EVENT LISTENERS
    $scope.$watch('item.definitionId', function(definitionId){
        if(definitionId) {
            return;
            $scope.item.assignees = $scope.definition.participants.map(function(participant){
                return {
                    participant: participant,
                    participantId: participant.id
                }
            });
        }
    });

    // INIT
    $scope.definition = dialog.options.definition || {};
    $scope.item = {
        definitionId: $scope.definition.id
    };

    $scope.current = {
        isLoading: false
    };

    init();
});
'use strict';

app.controller('ProcessTypeEditorCtrl', function ProcessTypeEditorCtrl($scope, ProcessDashboard, $timeout, $http, apps, args, $q, dialog, Entity) {

    var editorHotKeys;


    // PRIVATE METHODS - INIT
    function init() {
        buildMenu();
        loadHotKeys();
        loadItem();
        $scope.loadTab( args.defaultTab );
    }

    function loadItem() {
        return (
            !args.item && args.id
                ? ProcessDashboard.types.get({params: {id: args.id}, trim: true})
                : $q.resolve(new Entity(args.item || ProcessDashboard.default.processType))
        ).then(function(item){
            $scope.item = item.setOriginal(true);
            return $scope.item;
        })
    }

    function saveItem() {
        return $scope.item.id > 0
            ? ProcessDashboard.types.save({data: $scope.item, params: {id: args.id}, trim: true})
            : ProcessDashboard.types.create({data: $scope.item, trim: true})
    }


    function buildMenu() {
        $scope.menu = { categories: [ ] };
        $scope.menu.categories.push( {name: 'Process Type', children: [] } );
        $scope.menu.categories[0].children.push( {name: 'General', active: false, code: 'general'} );
        $scope.menu.categories[0].children.push( {name: 'Settings', active: false, code: 'settings'} );
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function() {
            editorHotKeys.addActions([
                { combo:'ALT+S', command: $scope.save },
                { combo:'ALT+X', command: $scope.close }
            ]);
        });
    }

    // PUBLIC METHODS
    $scope.loadTab = function( child ) {
        $scope.menu.categories.each( function( c ) {
            c.children.each( function( ch ) {
                ch.active = ch.code == child.code;
            } );
        } );

        $scope.current.selectedTab = child.code;
    };

    $scope.save = function() {
        return (
            $scope.item.isModified()
                ? saveItem()
                : $q.resolve($scope.item)
        ).then(function(item){
            editorHotKeys.destroy();
            dialog.close( item );
        });
    };

    $scope.close = function( ) {
        editorHotKeys.destroy();
        dialog.close( null );
    };

    // EVENT LISTENERS

    // INIT

    $scope.current = {

    };

    init();
});


'use strict';

app.controller('CreateParticipantCtrl', function CreateParticipantCtrl($scope, ProcessDashboard, $timeout, $http, apps, $q, dialog, $dialog) {
    // PRIVATE METHODS - INIT
    function init() {
        // Required Options
        if(!dialog.options.definition && !dialog.options.definitionId) return $dialog.actionFailed("Definition is unknown").open().then(function(){return dialog.close(null);});

        // Instantiate Objects
        $scope.definition = dialog.options.definition || {id: dialog.options.definitionId};
        $scope.item = dialog.options.item || {};

        // Set Defaults
        $scope.item.definitionId = $scope.definition.id;
    }

    // PUBLIC METHODS
    $scope.create = function() {
        return ProcessDashboard.participants.create({data: $scope.item, trim: true})
            .then(function(item){
                dialog.close( item );
            });
    };

    $scope.cancel = function( ) {
        dialog.close( null );
    };

    // EVENT LISTENERS

    // INIT
    $scope.item = {};

    $scope.current = {
        isLoading: false
    };

    init();
});
'use strict';

app
.directive('processActivity', function processActivity() {
    return {
        restrict: 'E',
        controller: 'ProcessActivityCtrl',
        scope: {
            onSave: '&?',
            onDelete: '&?',
            loadId: '@'
        },
        controllerAs: 'vm',
        bindToController: { id: '=', definition:'=' },
        templateUrl: 'tools/processdashboard/directives/ProcessActivity.html',
        link: function(scope, element, attrs, vm) {
            scope.original = angular.copy(vm.item);
            scope.editor = !vm.item || !vm.item.id;
            scope.expand = true;

            scope.isModified = function() {
                return !angular.equals(vm.item, scope.original);
            };

            scope.undo = function() {
                angular.copy(scope.original, vm.item);
            };

            scope.load = function() {
                return vm.loadItem().then(function(item){
                    scope.original = angular.copy(vm.item);
                });
            };

            scope.delete = function() {
                return (
                    scope.onDelete
                        ? scope.onDelete()(vm.item)
                        : vm.deleteItem()
                )
            };

            scope.selectAction = function(action) {
                angular.extend(vm.item, {
                    title: action.name,
                    description: action.description,
                    actionId: action.id
                });
                scope.save()
            };

            scope.save = function() {
                if (scope.onSave) {
                    return scope.onSave()(vm.item).then(function(response){
                        return scope.load();
                    });
                } else return vm.saveItem().then(function(item){
                    scope.original = angular.copy(vm.item);
                    scope.editor = false;
                    scope.expand = true;
                });
            };

            if(!vm.item) vm.item = vm.defaultItem();
            if(scope.loadId) {
                vm.item.id = scope.loadId;
                scope.load();
            }
        }
    };
})
.controller('ProcessActivityCtrl', function ProcessActivityCtrl($scope, ProcessDashboard, $q) {
    var entityService = ProcessDashboard.activities;
    var vm = this;

    var item, participant, action;
    Object.defineProperties(vm, {
        item: {
            get: function() {
                if(item === undefined) item = vm.definition.activities.find({ id: vm.id });
                return item;
            }
        },
        participant: {
            get: function() {
                if(vm.item && vm.item.participantId > 0)  {
                    if(!participant || participant.id != vm.item.participantId)
                        participant = vm.definition.participants.find({
                            id: vm.item.participantId
                        });
                    return participant;
                }
                else return undefined;
            }
        },
        action: {
            get: function() {
                if(vm.item && vm.item.processActionId > 0)  {
                    if(!action || action.id != vm.item.actionId)
                        action = vm.definition.type.actions.find({
                            id: vm.item.processActionId
                        });
                    return action;
                }
                else return undefined;
            }
        }
    });

    vm.loading = false;
    vm.defaultItem = defaultItem;
    vm.loadItem = loadItem;
    vm.deleteItem = deleteItem;
    vm.saveItem = saveItem;

    function defaultItem() {
        var item = {};
        if(vm.definition) item.definitionId = definition.id;
        return item;
    }

    function loadItem() {
        vm.loading = true;
        return $q.resolve(
            vm.item.id
                ? entityService.get({params: {id: item.id}, trim: true})
                : $q.reject()
        ).then(function(updated){
            angular.copy(updated, vm.item);
            vm.loading = false;
            return vm.item;
        });
    }

    function deleteItem() {
        return (vm.item.id
                ? entityService.delete({confirm: "Delete this item?", params: {id: vm.item.id}})
                : $q.resolve(vm.definition.activities.remove(vm.item))
        ).then(function(response){
            return response;
        });
    }

    function saveItem() {
        vm.item.participantId = vm.participant.id;
        vm.item.definitionId = vm.definition.id;
        vm.item.processActionId = vm.action.id;

        vm.loading = true;
        return (!vm.item.id
                ? entityService.create({data: vm.item})
                : entityService.save({data: vm.item, params: {id: vm.item.id}})
        ).then(function(response){
            angular.copy(response.data, vm.item);
            vm.loading = false;
            return vm.item;
        });
    }
});
'use strict';

app
.directive('processElement', function processElement() {
    return {
        restrict: 'A',
        controller: 'ProcessElementCtrl',
        scope: {
            onSave: '&?',
            onDelete: '&?',
            loadId: '@'
        },
        controllerAs: 'vm',
        bindToController: { id: '=', definition:'=' },
        templateUrl: 'tools/processdashboard/directives/ProcessElement.html',
        link: function(scope, element, attrs, vm) {
            scope.original = angular.copy(vm.item);
            scope.editor = !vm.item || !vm.item.id;
            scope.expand = true;

            scope.isModified = function() {
                return !angular.equals(vm.item, scope.original);
            };

            scope.undo = function() {
                angular.copy(scope.original, vm.item);
            };

            scope.load = function() {
                return vm.loadItem().then(function(item){
                    scope.original = angular.copy(vm.item);
                });
            };

            scope.delete = function() {
                return (
                    scope.onDelete
                        ? scope.onDelete()(vm.item)
                        : vm.deleteItem()
                )
            };

            scope.selectAction = function(action) {
                angular.extend(vm.item, {
                    title: action.name,
                    description: action.description,
                    actionId: action.id
                });
                scope.save()
            };

            scope.save = function() {
                if (scope.onSave) {
                    return scope.onSave()(vm.item).then(function(response){
                        return scope.load();
                    });
                } else return vm.saveItem().then(function(item){
                    scope.original = angular.copy(vm.item);
                    scope.editor = false;
                    scope.expand = true;
                });
            };

            if(!vm.item) vm.item = vm.defaultItem();
            if(scope.loadId) {
                vm.item.id = scope.loadId;
                scope.load();
            }
        }
    };
})
.controller('ProcessElementCtrl', function ProcessElementCtrl($scope, ProcessDashboard, $q) {
    var entityService = ProcessDashboard.elements;
    var vm = this;

    var item, participant, events;
    Object.defineProperties(vm, {
        item: {
            get: function() {
                if(item === undefined) item = vm.definition.elements.find({ id: vm.id });
                return item;
            }
        },
        participant: {
            get: function() {
                return vm.definition.participants.find({
                    id: vm.item.participantId
                });
            }
        },
        events: {
            get: function() {
                return vm.definition.events.filter(function(e){
                    return e.elementId === vm.id
                });
            }
        }
    });

    vm.loading = false;
    vm.defaultItem = defaultItem;
    vm.loadItem = loadItem;
    vm.deleteItem = deleteItem;
    vm.saveItem = saveItem;

    vm.event = undefined;
    $scope.$watch("vm.item.eventId", function(eventId) {
        if(eventId > 0) {
            vm.event = vm.definition.events.find(function(e){
                return e.id === eventId
            });
        } else vm.event = undefined;
    });

    vm.elementActivity = undefined;
    $scope.$watch("vm.item.catchEventId", function(catchEventId) {
        if(vm.catchEvent) vm.catchEvent.throwEventIds.remove(vm.id);
        if(catchEventId > 0) {
            vm.catchEvent = vm.definition.events.find(function(e){
                if(e.id === catchEventId) {
                    e.throwEventIds.add(vm.id);
                    return true;
                }
            });
        } else vm.catchEvent = undefined;
    });

    function defaultItem() {
        var item = {};
        if(vm.definition) item.definitionId = definition.id;
        return item;
    }

    function loadItem() {
        vm.loading = true;
        return $q.resolve(
            vm.item.id
                ? entityService.get({params: {id: item.id}, trim: true})
                : $q.reject()
        ).then(function(updated){
            angular.copy(updated, vm.item);
            vm.loading = false;
            return vm.item;
        });
    }

    function deleteItem() {
        return (vm.item.id
                ? entityService.delete({confirm: "Delete this item?", params: {id: vm.item.id}})
                : $q.resolve(vm.definition.elements.remove(vm.item))
        ).then(function(response){
            return response;
        });
    }

    function saveItem() {
        vm.item.participantId = vm.participant.id;
        vm.item.parentId = vm.definition.rootElementId;

        vm.loading = true;
        return (!vm.item.id
                ? entityService.create({data: vm.item})
                : entityService.save({data: vm.item, params: {id: vm.item.id}})
        ).then(function(response){
            angular.copy(response.data, vm.item);
            vm.loading = false;
            return vm.item;
        });
    }
});
'use strict';

app
.directive('processEvent', function processEvent() {
    return {
        restrict: 'A',
        controller: 'ProcessEventCtrl',
        scope: {
            onSave: '&?',
            onDelete: '&?',
            loadId: '@'
        },
        controllerAs: 'vm',
        bindToController: { id: '=', definition:'=' },
        templateUrl: 'tools/processdashboard/directives/ProcessEvent.html',
        link: function(scope, Event, attrs, vm) {
            scope.original = angular.copy(vm.item);
            scope.editor = !vm.item || !vm.item.id;
            scope.expand = true;
            scope.throwEditor = false;

            scope.isModified = function() {
                return !angular.equals(vm.item, scope.original);
            };

            scope.undo = function() {
                angular.copy(scope.original, vm.item);
            };

            scope.load = function() {
                return vm.loadItem().then(function(item){
                    scope.original = angular.copy(vm.item);
                });
            };

            scope.delete = function() {
                return (
                    scope.onDelete
                        ? scope.onDelete()(vm.item)
                        : vm.deleteItem()
                )
            };

            scope.selectAction = function(action) {
                angular.extend(vm.item, {
                    title: action.name,
                    description: action.description,
                    actionId: action.id
                });
                scope.save()
            };

            scope.save = function() {
                if (scope.onSave) {
                    return scope.onSave()(vm.item).then(function(response){
                        return scope.load();
                    });
                } else return vm.saveItem().then(function(item){
                    scope.original = angular.copy(vm.item);
                    scope.editor = false;
                    scope.expand = true;
                });
            };

            if(!vm.item) vm.item = vm.defaultItem();
            if(scope.loadId) {
                vm.item.id = scope.loadId;
                scope.load();
            }
        }
    };
})
.controller('ProcessEventCtrl', function ProcessEventCtrl($scope, ProcessDashboard, $q) {
    var entityService = ProcessDashboard.events;
    var vm = this;

    var item, element, siblings, siblingEvents, throwEvents;
    Object.defineProperties(vm, {
        item: {
            get: function() {
                if(!item) item = vm.definition.events.find({ id: vm.id });
                return item;
            }
        },
        element: {
            get: function() {
                if(!item && !vm.item) return;
                return element = vm.definition.elements.find(function(e){
                    return e.id === vm.item.elementId
                });
            }
        },
        siblings: {
            get: function() {
                if(!element && !vm.element) return;
                return siblings = vm.definition.elements.filter(function(e){
                    return e.parentId === element.parentId && e.id !== vm.element.id;
                });
            }
        },
        siblingEvents: {
            get: function() {
                if(!siblings && !vm.siblings) return;
                var eventIds = siblings.map('eventIds').flatten();
                return siblingEvents = vm.definition.events.filter(function(e){
                    return eventIds.any(e.id)
                });
            }
        },
        throwEvents: {
            get: function() {
                if(!element && !vm.element) return;
                return throwEvents = vm.definition.events.filter(function(e){
                    return item.throwEventIds.any(e.id)
                });
            }
        }
    });

    vm.loading = false;
    vm.defaultItem = defaultItem;
    vm.loadItem = loadItem;
    vm.deleteItem = deleteItem;
    vm.saveItem = saveItem;
    vm.catchEvent = undefined;

    $scope.$watch("vm.item.catchEventId", function(catchEventId) {
        if(vm.catchEvent) vm.catchEvent.throwEventIds.remove(vm.id);
        if(catchEventId > 0) {
            vm.catchEvent = vm.definition.events.find(function(e){
                if(e.id === catchEventId) {
                    e.throwEventIds.add(vm.id);
                    return true;
                }
            });
        } else vm.catchEvent = undefined;
    });

    function defaultItem() {
        var item = {};
        if(vm.definition) item.definitionId = definition.id;
        return item;
    }

    function loadItem() {
        vm.loading = true;
        return $q.resolve(
            vm.item.id
                ? entityService.get({params: {id: item.id}, trim: true})
                : $q.reject()
        ).then(function(updated){
            angular.copy(updated, vm.item);
            vm.loading = false;
            return vm.item;
        });
    }

    function deleteItem() {
        return (vm.item.id
                ? entityService.delete({confirm: "Delete this item?", params: {id: vm.item.id}})
                : $q.resolve(vm.definition.Events.remove(vm.item))
        ).then(function(response){
            return response;
        });
    }

    function saveItem() {
        vm.loading = true;
        return (!vm.item.id
                ? entityService.create({data: vm.item})
                : entityService.save({data: vm.item, params: {id: vm.item.id}})
        ).then(function(response){
            angular.copy(response.data, vm.item);
            vm.loading = false;
            return vm.item;
        });
    }
});
'use strict';

app
.directive('taskAction', function(ProcessDashboard, $q) {
    return {
        restrict: 'E',
        scope: {},
        bindToController: {
            task: '=',
            item: '=?'
        },
        controller: 'TaskActionCtrl',
        controllerAs: 'vm',
        templateUrl: 'tools/processdashboard/directives/TaskAction.html',
        link: function(scope, element, attrs, vm) {
            scope.list = false;

            scope.debug = function() {
                console.log(vm.items);
            };

            scope.add = function() {
                vm.loadItem().then(function(r){
                    scope.list = true;
                });
            };

            if(!vm.task.actionId) {
                scope.list = true;
                vm.loadAll();
            }
        }
    };
})
.controller('TaskActionCtrl', function TaskActionCtrl($scope, ProcessDashboard, $q) {
    var entityService = ProcessDashboard.actions;
    var vm = this;

    vm.loading = false;
    vm.loadAll = loadAll;
    vm.defaultItem = defaultItem;
    vm.loadItem = loadItem;
    vm.deleteItem = deleteItem;
    vm.saveItem = saveItem;

    function defaultItem() {
        var item = {};
        if(vm.type) item.processTypeId = vm.type.id;
        return item;
    }

    function loadAll() {
        var options = {params: {}};
        if(vm.task) options.params.processTaskId = vm.task.id;
        if(vm.type) options.params.processTaskId = vm.type.id;
        vm.loading = true;
        return entityService.getAll(options).then(function(response){
            vm.items = response.data;
            vm.loading = false;
        });
    }

    function loadItem(item) {
        if(!item) item = {};
        vm.loading = true;
        return $q.resolve(
            item.id
                ? entityService.get({params: {id: item.id}, trim: true})
                : this.defaultItem()
        ).then(function(updated){
            angular.copy(updated, item);
            if (vm.items && !~vm.items.findIndex({id: item.id}) || !(item.id > 0)) vm.items.add(item);
            vm.loading = false;
            return item;
        });
    }

    function deleteItem(item) {
        return (item.id
                ? entityService.delete({confirm: "Delete item: {name}?".assign(item), params: {id: item.id}})
                : $q.resolve(item)
        ).then(function(response){
            vm.items.remove(item);
        });
    }

    function saveItem(item) {
        vm.loading = true;
        return (!item.id
                ? entityService.create({data: item})
                : entityService.save({data: item, params: {id: item.id}})
        ).then(function(response){
            angular.copy(response.data, item);
            vm.loading = false;
            return item;
        });
    }
});
'use strict';

app
.directive('processAction', function processAction() {
    return {
        restrict: 'E',
        controller: 'ProcessActionCtrl',
        scope: {},
        controllerAs: 'vm',
        bindToController: {
            type: '=',
            id: '=',
        },
        templateUrl: 'tools/processdashboard/directives/ProcessAction.html',
        link: function(scope, element, attrs, vm) {
            scope.original = angular.copy(vm.item);
            scope.editor = !(vm.item && vm.item.id > 0);
            scope.details = false;

            scope.edit = function() {

            };

            /*scope.expand = function() {
                element.addClass('expanded-card');
            };*/

            scope.isModified = function() {
                return !angular.equals(vm.item, scope.original);
            };

            scope.undo = function() {
                angular.copy(scope.original, vm.item);
            };

            scope.load = function() {
                return vm.loadItem().then(function(item){
                    scope.original = angular.copy(vm.item);
                });
            };

            scope.delete = function() {
                return (
                    scope.onDelete
                        ? scope.onDelete()(vm.item)
                        : vm.deleteItem()
                )
            };

            scope.save = function() {
                if (scope.onSave) {
                    return scope.onSave()(vm.item).then(function(response){
                        return scope.load();
                    });
                } else return vm.saveItem().then(function(item){
                    scope.original = angular.copy(vm.item);
                });
            };

            if(!vm.item) vm.item = vm.defaultItem();
            if(scope.loadId) {
                vm.item.id = scope.loadId;
                scope.load();
            }
        }
    };
})
.controller('ProcessActionCtrl', function TypeActionCtrl($scope, ProcessDashboard, $q, $element) {
    var entityService = ProcessDashboard.actions;
    var vm = this;

    vm.loading = false;
    vm.processActionType = ProcessDashboard.processActionType;
    vm.processActionServiceCodes = ProcessDashboard.processActionServiceCodes;
    vm.loadItem = loadItem;
    vm.deleteItem = deleteItem;
    vm.saveItem = saveItem;

    vm.rights = {
        canRead: true,
        canEdit: true,
        canDelete: true
    };

    var item;
    Object.defineProperties(vm, {
        item: {
            get: function() {
                if(item === undefined) item = vm.type.actions.find({ id: vm.id });
                return item;
            }
        }
    });

    function loadItem() {
        vm.loading = true;
        return $q.resolve(
            vm.item.id
                ? entityService.get({params: {id: vm.item.id}, trim: true})
                : $q.reject()
        ).then(function(updated){
            angular.copy(updated, vm.item);
            vm.loading = false;
            return vm.item;
        });
    }

    function deleteItem() {
        return (vm.item.id
                ? entityService.delete({confirm: "Delete this item?", params: {id: vm.item.id}})
                : $q.resolve(vm.action.fields.remove(vm.item))
        ).then(function(response){
            return response;
        });
    }

    function saveItem() {
        item.processTypeId = vm.type.id;

        vm.loading = true;
        return (!vm.item.id
                ? entityService.create({data: vm.item})
                : entityService.save({data: vm.item, params: {id: vm.item.id}})
        ).then(function(response){
            angular.copy(response.data, vm.item);
            vm.loading = false;
            return vm.item;
        });
    }
});
'use strict';

app
.directive('typeActionList', function(ProcessDashboard, $q) {
    return {
        restrict: 'E',
        scope: {
            canCollapse: '@',
            onSelect: '&?',

            canEdit: '@',
            canDelete: '@',
            canRead: '@'
        },
        bindToController: {
            type: '='
        },
        controller: 'TypeActionListCtrl',
        controllerAs: 'vm',
        templateUrl: 'tools/processdashboard/directives/TypeActionList.html',
        link: function(scope, element, attrs, vm) {
            scope.list = true;

            scope.debug = function() {
                console.log(vm.type.actions);
            };

            scope.add = function() {
                vm.loadItem().then(function(r){
                    scope.list = true;
                });
            };

            if (!vm.type.actions) vm.loadAll();
        }
    };
})
.controller('TypeActionListCtrl', function TypeActionListCtrl($scope, ProcessDashboard, $q) {
    var entityService = ProcessDashboard.actions;
    var vm = this;

    vm.loading = false;
    vm.loadAll = loadAll;
    vm.defaultItem = defaultItem;
    vm.loadItem = loadItem;
    vm.deleteItem = deleteItem;
    vm.saveItem = saveItem;

    function defaultItem() {
        var item = {};
        if(vm.type) item.processTypeId = vm.type.id;
        return item;
    }

    function loadAll() {
        var options = {params: {}};
        if(vm.type) options.params.processTaskId = vm.type.id || vm.type;
        vm.loading = true;
        return entityService.getAll(options).then(function(response){
            if(vm.type.actions) angular.copy(response.data, vm.type.actions);
            else vm.type.actions = response.data;
            vm.loading = false;
        });
    }

    function loadItem(item) {
        if(!item) item = {};
        vm.loading = true;
        return $q.resolve(
            item.id
                ? entityService.get({params: {id: item.id}, trim: true})
                : this.defaultItem()
        ).then(function(updated){
            angular.copy(updated, item);
            if (vm.type.actions && !~vm.type.actions.findIndex({id: item.id}) || !(item.id > 0)) vm.type.actions.add(item);
            vm.loading = false;
            return item;
        });
    }

    function deleteItem(item) {
        return (item.id
                ? entityService.delete({confirm: "Delete item: {name}?".assign(item), params: {id: item.id}})
                : $q.resolve(item)
        ).then(function(response){
            vm.type.actions.remove(item);
        });
    }

    function saveItem(item) {
        vm.loading = true;
        return (!item.id
                ? entityService.create({data: item})
                : entityService.save({data: item, params: {id: item.id}})
        ).then(function(response){
            angular.copy(response.data, item);
            vm.loading = false;
            return item;
        });
    }
});
'use strict';

app
.directive('fieldInput', function() {
    return {
        restrict: 'E',
        scope: {
            value: '=',
            label: '@',
            description: '@?',
            type: '@',

            options: '=',
            optionsExpression: '@?',

            rows: '@'
        },
        templateUrl: function(element, attrs) {
            return 'tools/processdashboard/directives/input/{type}.html'.assign(attrs);
        },
        link: function(scope, element, attrs, vm) {

            var S4 = function() {
                return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
            };
            scope.guid = scope.type+"-"+(S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());



            scope.$watch('value', function(newValue, oldValue){
                if(scope.type == 'switch') {
                    if(newValue) element.addClass('active');
                    else element.removeClass('active');
                }
            });
        }
    };
});
'use strict';

app
.directive('actionField', function actionField() {
    return {
        restrict: 'EA',
        controller: 'ActionFieldCtrl',
        scope: {},
        controllerAs: 'vm',
        bindToController: {
            action: '=',
            id: '='
        },
        templateUrl: 'tools/processdashboard/directives/ActionField.html',
        link: function(scope, element, attrs, vm) {
            scope.original = angular.copy(vm.item);
            scope.editor = !vm.item || !vm.item.id;
            scope.details = false;

            scope.isModified = function() {
                return !angular.equals(vm.item, scope.original);
            };

            scope.undo = function() {
                angular.copy(scope.original, vm.item);
            };

            scope.load = function() {
                return vm.loadItem().then(function(item){
                    scope.original = angular.copy(vm.item);
                });
            };

            scope.delete = function() {
                return (
                    scope.onDelete
                        ? scope.onDelete()(vm.item)
                        : vm.deleteItem()
                )
            };

            scope.save = function() {
                if (scope.onSave) {
                    return scope.onSave()(vm.item).then(function(response){
                        return scope.load();
                    });
                } else return vm.saveItem().then(function(item){
                    scope.original = angular.copy(vm.item);
                });
            };
        }
    };
})
.controller('ActionFieldCtrl', function ActionFieldCtrl($scope, ProcessDashboard, $q) {
    var entityService = ProcessDashboard.fields;
    var vm = this;

    vm.loading = false;
    vm.loadItem = loadItem;
    vm.deleteItem = deleteItem;
    vm.saveItem = saveItem;

    var item;
    Object.defineProperties(vm, {
        item: {
            get: function() {
                if(item === undefined) item = vm.action.fields.find({ id: vm.id });
                return item;
            }
        }
    });

    function loadItem() {
        vm.loading = true;
        return $q.resolve(
            vm.item.id
                ? entityService.get({params: {id: vm.item.id}, trim: true})
                : $q.reject()
        ).then(function(updated){
            angular.copy(updated, vm.item);
            vm.loading = false;
            return vm.item;
        });
    }

    function deleteItem() {
        return (vm.item.id
                ? entityService.delete({confirm: "Delete this item?", params: {id: vm.item.id}})
                : $q.resolve(vm.action.fields.remove(item))
        ).then(function(response){
            return response;
        });
    }

    function saveItem() {
        // defaults
        item.actionId = vm.action.id;

        vm.loading = true;
        return (!vm.item.id
                ? entityService.create({data: vm.item})
                : entityService.save({data: vm.item, params: {id: vm.item.id}})
        ).then(function(response){
            angular.copy(response.data, vm.item);
            vm.loading = false;
            return vm.item;
        });
    }
});
'use strict';

app
.directive('actionFieldList', function(ProcessDashboard, $q) {
    return {
        restrict: 'E',
        scope: {},
        bindToController: {
            action: '=item'
        },
        controller: 'ActionFieldListCtrl',
        controllerAs: 'vm',
        templateUrl: 'tools/processdashboard/directives/ActionFieldList.html',
        link: function(scope, element, attrs, vm) {
            scope.list = true;

            scope.add = function() {
                vm.loadItem().then(function(r){
                    scope.list = true;
                });
            };
        }
    };
})
.controller('ActionFieldListCtrl', function ActionFieldListCtrl($scope, ProcessDashboard, $q) {
    var entityService = ProcessDashboard.fields;
    var vm = this;

    vm.loading = false;
    vm.loadAll = loadAll;
    vm.defaultItem = defaultItem;
    vm.loadItem = loadItem;
    vm.deleteItem = deleteItem;
    vm.saveItem = saveItem;

    Object.defineProperty(vm, 'items', {
        get: function() { return vm.action.fields },
        set: function(value) { return vm.action.fields = value }
    });

    function defaultItem() {
        var item = {};
        if(vm.action) item.actionId = vm.action.id;
        return item;
    }

    function loadAll() {
        vm.loading = true;
        return entityService.getAll().then(function(response){
            vm.items = response.data;
            vm.loading = false;
        });
    }

    function loadItem(item) {
        if(!item) item = {};
        vm.loading = true;
        return $q.resolve(
            item.id
                ? entityService.get({params: {id: item.id}, trim: true})
                : this.defaultItem()
        ).then(function(updated){
            angular.copy(updated, item);
            if(!vm.items) vm.items = [];
            if(!~vm.items.findIndex({id: item.id}) || !(item.id > 0)) vm.items.add(item);
            vm.loading = false;
            return item;
        });
    }

    function deleteItem(item) {
        return (item.id
                ? entityService.delete({confirm: "Delete this task?", params: {id: item.id}})
                : $q.resolve()
        ).then(function(response){
            vm.items.remove(item);
        });
    }

    function saveItem(item) {
        vm.loading = true;
        return (!item.id
                ? entityService.create({data: item})
                : entityService.save({data: item, params: {id: item.id}})
        ).then(function(response){
            angular.copy(response.data, item);
            vm.loading = false;
            return item;
        });
    }
});
'use strict';

app
.directive('processHeader', function() {
    return {
        restrict: 'E',
        scope: true,
        templateUrl: 'tools/processdashboard/directives/ProcessHeader.html',
        controllerAs: 'vm',
        link: function(scope, element, attrs, vm) {
        }
    };
});
'use strict';

app
    .directive('processTask', function processActivity($rootScope) {
        return {
            restrict: 'E',
            controller: 'ProcessTaskCtrl',
            scope: {
                onSave: '&?',
                onDelete: '&?',
                loadId: '@'
            },
            controllerAs: 'vm',
            bindToController: { id: '=', instance:'=' },
            templateUrl: 'tools/processdashboard/directives/ProcessTask.html',
            link: function(scope, element, attrs, vm) {
                scope.original = angular.copy(vm.item);
                scope.editor = !vm.item || !vm.id;
                scope.expand = true;
                scope.session = angular.copy($rootScope.user.authorization);

                scope.isModified = function() {
                    return !angular.equals(vm.item, scope.original);
                };

                scope.undo = function() {
                    angular.copy(scope.original, vm.item);
                };

                scope.load = function() {
                    return vm.loadItem().then(function(item){
                        scope.original = angular.copy(vm.item);
                    });
                };

                scope.delete = function() {
                    return (
                        scope.onDelete
                            ? scope.onDelete()(vm.item)
                            : vm.deleteItem()
                    )
                };

                scope.selectAction = function(action) {
                    angular.extend(vm.item, {
                        title: action.name,
                        description: action.description,
                        actionId: action.id
                    });
                    scope.save()
                };

                scope.save = function() {
                    if (scope.onSave) {
                        return scope.onSave()(vm.item).then(function(response){
                            return scope.load();
                        });
                    } else return vm.saveItem().then(function(item){
                        scope.original = angular.copy(vm.item);
                        scope.editor = false;
                        scope.expand = true;
                    });
                };

                if(scope.loadId) {
                    vm.id = scope.loadId;
                    scope.load();
                }
            }
        };
    })
    .controller('ProcessTaskCtrl', function ProcessTaskCtrl($scope, ProcessDashboard, $q) {
        var entityService = ProcessDashboard.tasks;
        var vm = this;

        var item, assignee;
        Object.defineProperties(vm, {
            item: {
                get: function() {
                    if(!item) {
                        if(vm.instance && vm.instance.tasks) item = vm.instance.tasks.find({ id: vm.id });
                        else if(vm.id) {
                            item = {id: vm.id};
                            loadItem();
                        }
                    }
                    return item;
                }
            },
            assignee: {
                get: function() {
                    if(vm.item && (!assignee || assignee.id != vm.item.assignmentId))
                        if(vm.instance && vm.instance.assignees) assignee = vm.instance.assignees.find({ id: vm.item.assignmentId });
                        else if(vm.item.assignmentId > 0) {
                            assignee = {id: vm.item.assignmentId};
                            loadAssignee();
                        }
                    return assignee;
                }
            }
        });

        vm.loading = false;
        vm.defaultItem = defaultItem;
        vm.loadItem = loadItem;
        vm.deleteItem = deleteItem;
        vm.saveItem = saveItem;

        function defaultItem() {
            var item = {};
            if(vm.definition) item.definitionId = definition.id;
            return item;
        }

        function loadAssignee() {
            if(vm.item && vm.item.assignmentId > 0) {
                ProcessDashboard.assignments.get({params: {id: vm.item.assignmentId}, tracker: null}).then(function(response){
                    angular.copy(response.data, assignee);
                    return vm.assignee;
                });
            } else {
                return $q.reject();
            }
        }

        function loadItem() {
            if(vm.id) {
                vm.loading = true;
                return entityService.get({params: {id: vm.id}, trim: true, tracker: null}).then(function (updated) {
                    angular.copy(updated, vm.item);
                    vm.loading = false;
                    return vm.item;
                });
            } else {
                return $q.reject();
            }
        }

        function deleteItem() {
            return (vm.id
                    ? entityService.delete({confirm: "Delete this item?", params: {id: vm.id}})
                    : $q.resolve(vm.definition.activities.remove(vm.item))
            ).then(function(response){
                return response;
            });
        }

        function saveItem() {
            vm.item.participantId = vm.participant.id;
            vm.item.definitionId = vm.definition.id;
            vm.item.processActionId = vm.action.id;

            vm.loading = true;
            return (!vm.id
                    ? entityService.create({data: vm.item})
                    : entityService.save({data: vm.item, params: {id: vm.id}})
            ).then(function(response){
                angular.copy(response.data, vm.item);
                vm.loading = false;
                return vm.item;
            });
        }
    });
'use strict';

app
.directive('processTaskList', function(ProcessDashboard, $q) {
    return {
        restrict: 'E',
        scope: {},
        bindToController: {
            process: '='
        },
        replace: true,
        controller: 'ProcessTaskListCtrl',
        controllerAs: 'vm',
        templateUrl: 'tools/processdashboard/directives/ProcessTaskList.html',
        link: function(scope, element, attrs, vm) {
            scope.list = false;

            scope.add = function() {
                vm.loadItem().then(function(r){
                    scope.list = true;
                });
            };
        }
    };
})
.controller('ProcessTaskListCtrl', function ProcessTaskListCtrl($scope, ProcessDashboard, $q) {
    var entityService = ProcessDashboard.tasks;
    var vm = this;

    vm.loading = false;
    vm.loadAll = loadAll;
    vm.defaultItem = defaultItem;
    vm.loadItem = loadItem;
    vm.deleteItem = deleteItem;
    vm.saveItem = saveItem;

    function defaultItem() {
        var item = {
            action: {},
            actionId: undefined
        };
        if(vm.process) item.processId = vm.process.id;
        return item;
    }

    function loadAll() {
        vm.loading = true;
        return entityService.getAll().then(function(response){
            vm.process.tasks = response.data;
            vm.loading = false;
        });
    }

    function loadItem(item) {
        if(!item) item = {};
        vm.loading = true;
        return $q.resolve(
            item.id
                ? entityService.get({params: {id: item.id}, trim: true})
                : this.defaultItem()
        ).then(function(updated){
            angular.copy(updated, item);
            if (vm.process.tasks && !~vm.process.tasks.findIndex({id: item.id}) || !(item.id > 0)) vm.process.tasks.add(item);
            vm.loading = false;
            return item;
        });
    }

    function deleteItem(item) {
        return (item.id
                ? entityService.delete({confirm: "Delete this task?", params: {id: item.id}})
                : $q.resolve()
        ).then(function(response){
            vm.process.tasks.remove(item);
        });
    }

    function saveItem(item) {
        vm.loading = true;
        return (!item.id
                ? entityService.create({data: item})
                : entityService.save({data: item, params: {id: item.id}})
        ).then(function(response){
            angular.copy(response.data, item);
            vm.loading = false;
            return item;
        });
    }
});
'use strict';

app
.directive('processTaskFlow', function(ProcessDashboard, $q) {
    return {
        restrict: 'E',
        scope: {},
        bindToController: {
            process: '='
        },
        controller: 'ProcessTaskFlowCtrl',
        controllerAs: 'vm',
        templateUrl: 'tools/processdashboard/directives/ProcessTaskFlow.html',
        link: function(scope, element, attrs, vm) {
            scope.list = false;

            scope.add = function() {
                vm.loadItem().then(function(r){
                    scope.list = true;
                });
            };
        }
    };
})
.controller('ProcessTaskFlowCtrl', function ProcessTaskFlowCtrl($scope, ProcessDashboard, $q) {
    var entityService = ProcessDashboard.tasks;
    var vm = this;

    vm.loading = false;
    vm.loadAll = loadAll;
    vm.defaultItem = defaultItem;
    vm.loadItem = loadItem;
    vm.deleteItem = deleteItem;
    vm.saveItem = saveItem;

    function defaultItem() {
        var item = {
            action: {},
            actionId: undefined
        };
        if(vm.process) item.processId = vm.process.id;
        return item;
    }

    function loadAll() {
        vm.loading = true;
        return entityService.getAll().then(function(response){
            vm.process.tasks = response.data;
            vm.loading = false;
        });
    }

    function loadItem(item) {
        if(!item) item = {};
        vm.loading = true;
        return $q.resolve(
            item.id
                ? entityService.get({params: {id: item.id}, trim: true})
                : this.defaultItem()
        ).then(function(updated){
            angular.copy(updated, item);
            if (vm.process.tasks && !~vm.process.tasks.findIndex({id: item.id}) || !(item.id > 0)) vm.process.tasks.add(item);
            vm.loading = false;
            return item;
        });
    }

    function deleteItem(item) {
        return (item.id
                ? entityService.delete({confirm: "Delete this task?", params: {id: item.id}})
                : $q.resolve()
        ).then(function(response){
            vm.process.tasks.remove(item);
        });
    }

    function saveItem(item) {
        vm.loading = true;
        return (!item.id
                ? entityService.create({data: item})
                : entityService.save({data: item, params: {id: item.id}})
        ).then(function(response){
            angular.copy(response.data, item);
            vm.loading = false;
            return item;
        });
    }
});
'use strict';

app.controller( 'WorkflowProcessListCtrl', function WorkflowProcessListCtrl( $scope, $routeParams, $http, $dialog, $location ) {

    // PRIVATE METHODS
    function init( ) {
        $http.get( '/Utility/WorkflowProcessInstances/Dashboard?processTypeCode=' + $routeParams.processtypecode, {trackerMsg: 'Loading ' + $scope.current.processTypeFriendly.toLowerCase().pluralize()} )
            .then( function (r) {
                $scope.current.processes = r.data;
            });
    }


    // PUBLIC METHODS
    $scope.newProcess = function( ) {
        $dialog.dialog({templateUrl: "workflow-process-new.html", controller: 'WorkflowProcessNewCtrl', resolve: {args: function () {return {processTypeCode: $routeParams.processtypecode, processTypeCodeFriendly: $scope.current.processTypeFriendly}; }}})
            .open()
            .then(function(result) {
                if( result ) {
                    $scope.openProcess( result );
                }
            });
    };

    $scope.openProcess = function( id ) {
        $location.url( 'tools/workflows/' + $routeParams.processtypecode + '/' + id );
    };


    // INIT
    $scope.current = {
        processTypeFriendly: $routeParams.processtypecode.spacify( ).capitalize( true )
    };

    init( );
});


app.controller( 'WorkflowProcessNewCtrl', function WorkflowProcessNewCtrl( $scope, dialog, $http, args ) {

    function init( ) {
        $http.get( '/Utility/WorkflowProcessTemplates?processTypeCode=' + args.processTypeCode, {trackerMsg: 'Loading ' + $scope.current.processTypeCodeFriendly + ' types'} )
            .then( function (r) {
                $scope.current.availableTemplates = r.data;
            });
    }

    $scope.save = function( ) {
        $http.put('/Utility/WorkflowProcessInstances/' + $scope.current.selectedTemplate, {}, {trackerMsg: 'Creating ' + $scope.current.processTypeCodeFriendly })
            .then(function (response) {
                dialog.close( response.data );
            });
    };

    $scope.close = function( ) {
        dialog.close( null );
    };

    $scope.current = {
        processTypeCodeFriendly: args.processTypeCodeFriendly
    };

    init( );

});
'use strict';

app.controller( 'WorkflowProcessCtrl', function WorkflowProcessCtrl( $scope, $routeParams, $http, $location ) {

    // PRIVATE METHODS
    function init( ) {
        $http.get( '/Utility/WorkflowProcessInstances/' + $routeParams.id, {trackerMsg: 'Loading ' + $scope.current.processTypeCodeFriendly.toLowerCase().pluralize()} )
            .then( function (r) {
                $scope.current.process = r.data;

                $scope.current.process["items"] = [];
                $scope.current.process.items.push( { processItemName: 'Rep Code', processItemDescription: 'Please enter the new Rep Code to be setup.', ownerEntity: 'Advisor', processItemStatus: 'Need More Info', itemParameters: [] } );
                $scope.current.process.items.push( { processItemName: 'Rep Code', processItemDescription: 'Upload that file.', ownerEntity: 'Advisor', processItemStatus: 'Need More Info', itemParameters: [] } );
                $scope.current.process.items.push( { processItemName: 'Rep Code', processItemDescription: 'Check something.', ownerEntity: 'Orion', processItemStatus: 'Complete', itemParameters: [] } );
            });
    }


    // PUBLIC METHODS
    $scope.openProcessList = function( id ) {
        $location.url( '/tools/workflows/' + $routeParams.processtypecode );
    };

    // INIT
    $scope.current = {
        processTypeCodeFriendly: $routeParams.processtypecode.spacify( ).capitalize( true )
    };

    init( );
});
(function () {  
    'use strict';
    app
        .value('OAS_XS_WIZARD_TEMPLATE_DIR', 'tools/integrations/templates') // user configurable

        .controller('oasXsWizardCtrl', ['$scope', '$log', '$q', function($scope, $log, $q) {
            $scope.pages = [];
            $scope.isComplete = false;
            $scope.lastPageIndex = -1;
            $scope.saveCalls = [];
            $scope.saving = false;

            function pageIndexIsValid( pageIndex ){
                if (pageIndex < 0 || pageIndex > $scope.lastPageIndex) {                    
                    $log.log('Error: ' + nextIndex + ' is not a valid page index.');
                    return false;
                }

                return true;
            }

            // underlying page turner
            function changePage(nextIndex) {                
                if ( pageIndexIsValid(nextIndex) ) {
                    var movingNext = nextIndex > $scope.curPageIdx;
                    var movingBack = nextIndex < $scope.curPageIdx;
                    $scope.state = {state: { previousPage: $scope.curPageIdx, currentPage: nextIndex }};
                    var curPage = $scope.pages[$scope.curPageIdx];
                    curPage.activePage = false;
                    curPage.isVisited = true;
                    setCurrentPage(nextIndex);                
                    if($scope.onPageChange) $scope.onPageChange($scope.state);
                    if (movingNext && typeof (curPage.onNext) === "function"){
                        curPage.onNext();
                    }

                    if (movingBack && typeof (curPage.onBack) === "function"){
                        curPage.onBack();
                    }
                }
            }

            function loadPageSavePromiseArray() {
                var savePromises = [];
                angular.forEach($scope.pages, function(page, key) {
                    if (!!page.save && typeof(page.save) === 'function') {
                        var savePromise = $q.when(page.save());
                        savePromises.push(savePromise);
                    }
                });

                return savePromises;
            }

            function setCurrentPage(index) {
                $scope.curPageIdx = index;
                $scope.pages[$scope.curPageIdx].activePage = true;
                $scope.pages[$scope.curPageIdx].isVisited = false;
            }

            // **************************************
            // controller interface
            //
            this.addPage = function(page) {
                $scope.pages.push(page);
                if($scope.pages.length === 1) setCurrentPage(0);
                $scope.lastPageIndex += 1;
            };

            // **************************************
            // $scope interface
            //
            /**
             * Cancel any pending changes and close the wizard.
             */
            $scope.cancel = function () {
                $log.log("Checking for a function to run on cancel...");
                if(typeof($scope.onCancel) === 'function') {
                    $log.log("On-cancel function exists.");
                    $scope.onCancel();
                } else {
                    $log.log("No on-cancel function was specified in the scope.");
                }

                angular.forEach($scope.pages, function(page, key) {
                    if ( typeof(page.cancel) === 'function') {
                        page.cancel();
                    }
                });
            };

            /*
            P 122909 - Add/Edit button state not being updated properly in the 
            Integrations app.
            Call the save method on all pages that have a save() method, and return a 
            promise for the set.
            To expose this method to a wizard instance, in the controller for the wizard 
            instance, add a placeholder to the controller:
                $scope.save = function() {};

            Connect the wizard's save() method to the parent through the on-save HTML attribute of the oas-xs-wizard directive:
                <oas-xs-wizard ... on-save="save();"></oas-xs-wizard>
            */
           /**
            * Returns an array of the promises for the save() methods of all the pages that have one.
            */
            $scope.save = function () {
                return loadPageSavePromiseArray();
            };

            /**
             * Moves the wizard view to the page with the specified index.
             * @param {int} index 
             */
            $scope.goToPage = function(index) {
                changePage(index);
            };

            /**
             * Returns true if the current page has another page following it.
             */
            $scope.hasNext = function() {
                return !$scope.isLast();
            };

            /**
             * Returns true if the current page has another page preceding it.
             */
            $scope.hasPrev = function() {
                return !$scope.isFirst();
            };

            /**
             * Returns true if the current page is the first page of the wizard; false otherwise.
             */
            $scope.isFirst = function() {
                return $scope.curPageIdx === 0;
            };

            /**
             * Returns true if the current page is the last page of the wizard; false otherwise.
             */
            $scope.isLast = function() {
                return $scope.curPageIdx >= $scope.lastPageIndex;
            };

            $scope.isReady = function() {
                var currentPage = $scope.pages[$scope.curPageIdx];
                if (!currentPage) {
                    return false;
                } else {
                    return currentPage.pageTag === "Ready";
                }
            };

            $scope.nextPage = function() {
                changePage($scope.curPageIdx + 1);
            };

            $scope.prevPage = function () {
                changePage($scope.curPageIdx - 1);
            };
        }])

        .directive('oasXsWizard', ['OAS_XS_WIZARD_TEMPLATE_DIR', function(OAS_XS_WIZARD_TEMPLATE_DIR) {
            return {
                restrict: 'E',
                transclude: true,
                replace: true,
                templateUrl: OAS_XS_WIZARD_TEMPLATE_DIR + '/xs-wizard-main.html',
                controller: 'oasXsWizardCtrl',
                controllerAs: 'wizCtrl',
                bindToController: true
            };
        }])

        .directive('oasXsWizardPage', ['OAS_XS_WIZARD_TEMPLATE_DIR', function(OAS_XS_WIZARD_TEMPLATE_DIR) {

            return {
                restrict: 'E',
                transclude: true,
                replace: true,
                templateUrl: OAS_XS_WIZARD_TEMPLATE_DIR + '/xs-wizard-page.html',
                controller: function($scope){
                    var childHandler = {};
                    this.register = function( handler ) {
                        childHandler = handler;
                    }

                    $scope.cancel = function() {
                        if ( !!childHandler && !!childHandler.onCancel && typeof(childHandler.onCancel) === 'function' ) {
                            return childHandler.onCancel();
                        }
                    };

                    $scope.save = function() {
                        if ( !!childHandler && !!childHandler.onSave && typeof(childHandler.onSave) === 'function' ) {
                            return childHandler.onSave();
                        }

                        return null;
                    };

                    $scope.onBack = function() {
                        if ( !!childHandler && !!childHandler.onBack && typeof(childHandler.onBack) === 'function' ) {
                            return childHandler.onBack();
                        }

                        return null;
                    };

                    $scope.onNext = function() {
                        if ( !!childHandler && !!childHandler.onNext && typeof(childHandler.onNext) === 'function' ) {
                            return childHandler.onNext();
                        }

                        return null;
                    };
                },
                controllerAs: 'pg',
                scope: {
                    pageTitle: '@',
                    pageTag: '@'
                },

                require: '^oasXsWizard',
                link: function(scope, element, attr, oasXsWizard) {
                    oasXsWizard.addPage(scope);
                }
            };

        }])

        .directive('oasXsWizardControls', ['OAS_XS_WIZARD_TEMPLATE_DIR', function(OAS_XS_WIZARD_TEMPLATE_DIR) {
            return {
                restrict: 'E',
                //replace: true,
                //templateUrl: OAS_XS_WIZARD_TEMPLATE_DIR + '/xs-wizard-controls.html',                
                require: '^oasXsWizard',                
                controller: function($scope) {                },
                controllerAs: 'oxwc',
                scope: {},
                link: function(scope, element, attr, oasXsWizard) {
                    scope.wizard = oasXsWizard;
                }
            };
        }]);

})();

'use strict';

app.controller('AddPartnerAppCtrl', ['$scope', '$dialog', '$partnerAppService', 'dialog', '$q', 'MultiStepFormStep', 'MultiStepFormEvents', '$addPartnerAppService',
    function AddPartnerAppCtrl($scope, $dialog, $partnerAppService, dialog, $q, multiStepFormStep, multiStepFormEvent, $addPartnerAppService) {

        $scope.current = {
            partnerApp: {} //,
            // tosChecked: false -- acceptedTOS is already a property of the partner app
        };
        // $scope.partnerAppStatus = {}; // Not sure if this is still needed.
        $scope.dirtyRoles = [];
        $scope.appRoles = {roles:[]};
        $scope.dialog = dialog;
        var deferred = $q.defer();
        $scope.stepsPromise = deferred.promise;
        // Private methods
        function init() {
            $scope.current = {
                appRoles: $scope.appRoles,
                canUpdate: dialog.options.canUpdate,
                partnerApp: dialog.options.partnerApp
            };

            $scope.current.partnerApp.productNameLower = $scope.current.partnerApp.productName.toLowerCase();
            if (!!$scope.current.partnerApp.privilegeId) {
                $partnerAppService.getRolesForApp($scope.current.partnerApp.privilegeId)
                .then(function (appRoles) {
                    $scope.appRoles = appRoles;
                    deferred.resolve($addPartnerAppService.getMultiStepFormForPartnerApp($scope.current.partnerApp, $scope.appRoles));
                }).catch(function(error) {
                    deferred.reject(error);
                });
            } else {
                deferred.resolve($addPartnerAppService.getMultiStepFormForPartnerApp($scope.current.partnerApp, $scope.appRoles));
            }
        }

        // Public functions
        angular.extend($scope, {
            cancel: function () {
                //$scope.partnerAppStatus = dialog.options.partnerAppStatus;
                dialog.close(null);
            },
            close: function () {
                //$scope.partnerAppStatus = dialog.options.partnerAppStatus;
                return dialog.close(null);
            },
            saveChanges: function () {
                dialog.close(null);
            },
            setInstalled: function () {
                $scope.current.partnerApp.installed = true;
            },
            acceptTermsOfService: function () {
                $partnerAppService.acceptTermsOfService($scope.current.partnerApp.id, $scope.current.tosChecked)
                    .then(function (results) {
                        var partnerApp = $addPartnerAppService.current.partnerApp;
                        $scope.current.partnerApp = partnerApp;
                    });
            },
            // Notify user if the TOS wasn't accepted.
            warnTosNotAccepted: function (productName) {
                $dialog.actionFailed('You must accept the Terms of Service before you can install ' + productName + '.').open();
            }
        });

        init();
    }]);

var partnerAppsDirective = function() {
    return {
        templateUrl: "tools/integrations/addPartnerApp/addPartnerApp.html",
        restrict: 'E',
    };
};

app.directive('partnerApps', partnerAppsDirective);

'use strict';

app.service('$addPartnerAppService', ['$http', '$q', '$log', 'MultiStepFormStep', 'MultiStepFormEvents', 'scheduledJobsService', '$partnerAppService',
function($http, $q, $log, multiStepFormStep, multiStepFormEvents, scheduledJobsService, $partnerAppService, $scope) {
    var self = this;
    var defaultTosText = '&nbsp;&nbsp;Orion is not responsible for actions taken by {Vendor Name}.<br/><br/>&nbsp;&nbsp;By providing your credentials to {Vendor Name}, you are authorizing {Vendor Name} to access client data maintained on the Orion system and releasing Orion from all claims, liabilities, losses, damages, attorneys’ fees and expenses of any kind resulting from {Vendor Name} access to your client data, including any manipulation, alteration, or changes to the data by {Vendor Name}, as well as Orion’s actions in reliance on communications and instructions received from {Vendor Name}.<br/><br/>&nbsp;&nbsp;To the extent that you wish to discontinue your integration with {Vendor Name}, it is your responsibility to notify Orion to disable such integration.';

    // private functions

    function getPermissionsStep(partnerApp, appRoles) {
        return {
            name: 'Permissions',
            templateUrl: 'tools/integrations/addPartnerApp/permissionsFormStep.html',
            params: {
                partnerApp: partnerApp,
                appRoles: appRoles
            },
            onSave: function (broadcastFn) {
                var deferred = $q.defer();
                broadcastFn(multiStepFormEvents.save, deferred);
                return deferred.promise;
            }
        };
    }

    function getScheduledJobStep(partnerApp) {
        return {
            name: 'Schedule',
            templateUrl: 'tools/integrations/addPartnerApp/scheduledJobsFormStep.html',
            params: {
                app: partnerApp
            }
        };
    }

    function getTermsStep(partnerApp, tosText) {
        return {
            name: 'Terms',
            templateUrl: 'tools/integrations/addPartnerApp/termsOfServiceStep.html',
            params: {
                termsOfService: tosText
            },
            onNext: function () {
                partnerApp.acceptedTOS = true;
            },
            onBack: function () {
                partnerApp.acceptedTOS = false;
            }
        };
    }

    function getAppById( partnerAppId ){
        return $http.get( "/Security/PartnerApps/" + partnerAppId + "/SimplePlus", {trackerMsg: 'Loading app'} )
            .then( function(result) {
                self.current.partnerApp = result.data;

            });
    }

    // public functions and properties
    
    self.current = {
        partnerApp: {}
    };        

    self.getAppById = function( partnerAppId ){
        return getAppById( partnerAppId );
    };

    self.acceptTermsOfService = function( partnerAppId, tosAccepted ){
        return $http.post( "/Security/PartnerApps/" + partnerAppId + "/TermsOfService/" + tosAccepted, { trackerMsg: 'Saving Terms of Service'} )
            .then( function(result) {
                self.current.partnerApp = result.data;
                return result.data;
            });
    };

    self.getMultiStepFormForPartnerApp = function(partnerApp, appRoles) {
        var tosText = partnerApp.termsOfService;
        
        if (!tosText) {
            tosText = defaultTosText.replace(/{Vendor Name}/g, partnerApp.partnerName);
        }

        // Add your steps here.
        var allSteps = {
            'advisoryworld': [
                getTermsStep(partnerApp, tosText),
                {
                    name: 'Configure',
                    templateUrl: 'tools/integrations/apps/advisoryWorld/advisoryWorldAddFormStep.html',
                    params: {
                        current: {
                            partnerApp: partnerApp
                        }
                    }
                },
                getPermissionsStep(partnerApp, appRoles)
            ],
            'blaze': [
                getTermsStep(partnerApp, tosText),
                {
                    name: 'Configure',
                    templateUrl: 'tools/integrations/apps/blaze/blazeAddFormStep.html',
                    params: {
                        current: {
                            partnerApp: partnerApp
                        }
                    }
                },
                getScheduledJobStep(partnerApp)
            ],
            'chicago clearing corporation': [
                getTermsStep(partnerApp, tosText),
                {
                    name: 'Configure',
                    templateUrl: 'tools/integrations/apps/chicagoClearing/chicagoClearingAddFormStep.html',
                    params: {
                        current: {
                            partnerApp: partnerApp
                        }
                    }
                },
                getScheduledJobStep(partnerApp)
            ],
            'irebal': [
                getTermsStep(partnerApp, tosText),
                {
                    name: 'Configure',
                    templateUrl: 'tools/integrations/apps/irebal/irebalAddFormStep.html',
                    params: {
                        current: {
                            partnerApp: partnerApp
                        }
                    }
                }, getScheduledJobStep(partnerApp)
            ],
            'lexisnexis': [
                getTermsStep(partnerApp, tosText),
                {
                    name: 'Configure',
                    templateUrl: 'tools/integrations/apps/lexisNexis/lexisNexisAddFormStep.html',
                    params: {
                        current: {
                            partnerApp: partnerApp
                        }
                    }
                }
            ],
            'max for advisors': [
                getTermsStep(partnerApp, tosText),
                {
                    name: 'Configure',
                    templateUrl: 'tools/integrations/apps/maxmyinterest/maxMyInterestAddFormStep.html',
                    params: {
                        current: {
                            partnerApp: partnerApp
                        }
                    }
                },
                getPermissionsStep(partnerApp, appRoles)
            ],
            'moneyguide': [
                getTermsStep(partnerApp, tosText),
                {
                    name: 'Configure',
                    templateUrl: 'tools/integrations/apps/moneyGuidePro/mgpAddFormStep.html',
                    params: {
                        current: {
                            partnerApp: partnerApp
                        }
                    }
                },
                getPermissionsStep(partnerApp, appRoles)
            ],
            'nitrogen': [
                getTermsStep(partnerApp, tosText),
                {
                    name: 'Configure',
                    templateUrl: 'tools/integrations/apps/riskalyze/riskalyzeAddFormStep.html',
                    params: {
                        current: {
                            partnerApp: partnerApp
                        }
                    }
                },
                getPermissionsStep(partnerApp, appRoles)
            ],
            'schwab': [
                {
                    name: 'Terms',
                    templateUrl: 'tools/integrations/apps/schwab/schwabTermsStep.html',
                    params: {
                        current: {
                            partnerApp: partnerApp
                        }
                    },
                    onNext: function () {
                        //partnerApp.acceptedTOS = true;
                    }, onBack: function () {
                        //partnerApp.acceptedTOS = false;
                    }
                },
                getPermissionsStep(partnerApp, appRoles)
            ],
            'sharefile': [
                getTermsStep(partnerApp, tosText),
                {
                    name: 'Configure',
                    templateUrl: 'tools/integrations/apps/sharefile/shareFileAddFormStep.html',
                    params: {
                        current: {
                            partnerApp: partnerApp
                        }
                    }
                },
                getPermissionsStep(partnerApp, appRoles)
            ],
            'wealthaccess': [
                getTermsStep(partnerApp, tosText),
                {
                    name: 'Configure',
                    templateUrl: 'tools/integrations/apps/wealthAccess/wealthAccessAddFormStep.html',
                    params: {
                        current: {
                            partnerApp: partnerApp
                        }
                    }
                },
                getPermissionsStep(partnerApp, appRoles)
            ]
        };
        $log.info('Product name: ', partnerApp.productNameLower);
        if(['blaze', 'chicago clearing corporation', 'irebal', 'wealthaccess'].includes(partnerApp.productNameLower)) {
            var name = partnerApp.productName;
            if(partnerApp.productNameLower === 'chicago clearing corporation') {
                name = 'ChicagoClearing';
            }
            $partnerAppService.getConfiguration(name).then(function(response) {
                partnerApp.configuration = response;
                $log.info('Configuration installed: ', partnerApp);
            });
        }
        var steps = allSteps[partnerApp.productNameLower];
        if(steps == null) {
            throw new Error('Partner App does not exist');
        }
        return steps.map(function(step) {
            return new multiStepFormStep(step);
        });
    };
}]);

'use strict';

angular.module('orionConnect').directive('partnerAppPrivilegeRoles',
    ['$log', '$q', '$partnerAppService', 'MultiStepFormEvents',
        function ($log, $q, $partnerAppService, multiStepFormEvents) {
            return {
                templateUrl: 'tools/integrations/addPartnerApp/partnerAppPrivilegeRoles.html',
                restrict: 'E',
                replace: true,
                scope: {
                    partnerApp: '=',
                    appRoles: '=',
                },
                link: function (scope) {

                    var dirtyRoles = [];
                    scope.setRoleStatus = function (role) {
                        role.isDirty = true;
                        role.editIsGranted = !role.enabled;
                        role.deleteIsGranted = !role.enabled;
                        role.readIsGranted = !role.enabled;

                        // If the role is already in the dirtyRoles list, and it's not changed, 
                        var existingItem = dirtyRoles.findIndex(function (element) {
                            //return element.id === role.id;
                        });

                        if (existingItem === -1 && role.isDirty) {
                            dirtyRoles.push(role);
                        } else if (!!existingItem && !role.isDirty) {
                            dirtyRoles = dirtyRoles.filter(function (element) {
                                return element.id !== role.id;
                            });
                        }
                    };

                    scope.saveChanges = function () {
                        if (!dirtyRoles.length) {
                            return $q.resolve(null);
                        }

                        var priv = scope.appRoles;
                        var privRoles = {
                            categoryId: priv.categoryId,
                            categoryName: priv.categoryName,
                            code: priv.code,
                            description: priv.description,
                            id: priv.id,
                            name: priv.name,
                            roles: dirtyRoles,
                            typeName: priv.typeName
                        };

                        return $partnerAppService.updatePrivilegeRoles(privRoles)
                            .then(function (response) {
                                dirtyRoles.each(function (item, index) {
                                    item.associationExists = item.enabled;
                                    item.isDirty = false;
                                });

                                dirtyRoles = [];
                            });
                    };

                    // This only works if this scope is stll "alive"
                    // In a multi-step form, this will only be fired if this component is in the last step
                    // To fix this, move the save code to a service, similar to the
                    // scheduled jobs service and call it from step's onSave function
                    scope.$on(multiStepFormEvents.save, function (e, deferred) {
                        scope.saveChanges().then(function (response) {
                            deferred.resolve(true);
                        }).catch(function () {
                            $log.error('There was an issue saving changes to the roles for this integration');
                            deferred.reject();
                        });
                    });
                }
            };
        }]);

'use strict';
var module = angular.module('orionConnect');

var scheduledJobsForm = function() {
    return {
        scope: {
            app: '=',
        },
        restrict: 'E',
        replace: true,
        templateUrl: 'tools/integrations/addPartnerApp/scheduledJobsForm.html',
        controller: 'scheduledJobsFormCtrl as ctrl',
    };
};

scheduledJobsForm.$inject = [];
module.directive('scheduledJobsForm', scheduledJobsForm);

var ctrl = function($scope, scheduledJobsService) {
    var self = this;
    var app = $scope.app;

    // Defaults
    self.jobTime = new Date(!!app.configuration ? app.configuration.runOn : Date.now());
    self.ismeridian = true;
    self.hstep = 1;
    self.mstep = 1;


    self.runJobNow = function() {
        scheduledJobsService.runJobNow(app.configuration.routePrefix, app.configuration.jobScheduleId).then(updateConfig);
    };

    self.deleteSchedule = function() {
        scheduledJobsService.deleteSchedule(app.configuration.routePrefix, app.configuration.jobScheduleId).then(updateConfig);
    };

    self.save = function() {
        var promise = parseInt(app.configuration.jobScheduleId) === 0 ? scheduledJobsService.scheduleJob(app.configuration.routePrefix) : scheduledJobsService.rescheduleJob(app.configuration.routePrefix, self.jobTime, app.configuration.weekdaysOnly);
        promise.then(updateConfig);
    };

    function updateConfig(response) {
        app.configuration = response.data;
    }
};

ctrl.$inject = ['$scope', 'scheduledJobsService'];
module.controller('scheduledJobsFormCtrl', ctrl);

var scheduledJobsService = function($http, $q, $log) {
    var runJobNowUrl = '{0}/RunJobNow',
        deleteScheduleUrl = '{0}/UnscheduleJob',
        scheduleJobUrl = '{0}/ScheduleJob',
        rescheduleJobUrl = '{0}/RescheduleJob';

    var self = this;
    self.runJobNow = function(route, id) {

        function onFailure(error) {
            $log.error(error);
            return $q.reject('There was a problem running the job. If this problem persists, please contact your Orion Administrator');
        }

        return $http.post(runJobNowUrl.replace("{0}", route) + '?jobScheduleId=' + id, { }, {trackerMsg: 'Kicking off the iRebal job.'}).catch(onFailure);
    };

    self.deleteSchedule = function(route, id) {

        function onFailure(error) {
            $log.error(error);
            return $q.reject('There was a problem deleting the job schedule. If this problem persists, please contact your Orion Administrator');
        }

        return $http.post(deleteScheduleUrl.replace("{0}", route) + '?jobScheduleId=' + id, {}, {trackerMsg: 'Deleting the scheduled job.'}).catch(onFailure);
    };

    self.scheduleJob = function(route, config) {

        function onFailure(error) {
            $log.error(error);
            return $q.reject('There was a problem deleting the job schedule. If this problem persists, please contact your Orion Administrator');
        }

        return $http.post(scheduleJobUrl.replace("{0}", route), {body: config, trackerMsg: 'Scheduling the scheduled job.'}).catch(onFailure);
    };

    self.rescheduleJob = function(route, newDate, weekdaysOnly) {

        function onFailure(error) {
            $log.error(error);
            return $q.reject('There was a problem updating the job schedule. If this problem persists, please contact your Orion Administrator');
        }

        return $http.post(rescheduleJobUrl.replace("{0}", route), { jobRunTime: newDate.format('{MM}/{dd}/{yyyy} {12hr}:{mm}:{ss} {TT}'), weekdaysOnly: !!weekdaysOnly }, {trackerMsg: 'Scheduling the scheduled job.'}).catch(onFailure);
    };

};
scheduledJobsService.$inject = ['$http', '$q', '$log'];

module.service('scheduledJobsService', scheduledJobsService);
'use strict';

app.directive('advisoryWorldAddForm', function() {
    return {
        replace: true,
        restrict: 'E',
        templateUrl: 'tools/integrations/apps/advisoryWorld/advisoryWorldAddForm.html',
        controller: 'advisoryWorldAddFormCtrl',
        controllerAs: 'advisoryWorld',
        scope: {
            current: '='
        }
    };
});

app.controller('advisoryWorldAddFormCtrl', ['$scope', '$partnerAppService', '$window', '$location', function($scope, $partnerAppService, $window, $location) {
    var self = this;

    var setupUrl = '/Integrations/AdvisoryWorld/Setup',
        removeUrl = '/Integrations/AdvisoryWorld/Remove';

    $scope.advisoryWorldApp = $scope.current.partnerApp;

    self.installAdvisoryWorld = function () {
        $scope.advisoryWorldApp.acceptedTOS = true;
        return $partnerAppService.setupServiceForPartnerApp( $scope.advisoryWorldApp, setupUrl)
            .then(function(r) {
                $scope.installed = true;
                var redirectUrl = $location.protocol() + '://' + $location.host() + '/orionconnectapp/integration.html?r=' + encodeURIComponent(r.data);
                $window.open(redirectUrl);
            });
    };

    self.uninstallAdvisoryWorld = function() {
        return $partnerAppService.removeService(removeUrl, $scope.advisoryWorldApp.id ).then(function() {
            $scope.installed = false;
        });
    };
}]);
(function() {
    app.controller('assetMapWizardCtrl', ['$scope', '$q', '$log',
        function($scope, $q, $log){
            var vm = this;
            // Make copies of data objects to edit.
            vm.appRoles = angular.copy($scope.current.appRoles);
            vm.canUpdate = angular.copy($scope.current.canUpdate);
            vm.partnerApp = angular.copy($scope.current.partnerApp);
            vm.isLoadingQuikConfiguration = true;
            function close(dataResult) {
                if ($scope.dialog !== null) {
                    $scope.dialog.close(dataResult);
                } else {
                    $scope.$parent.close(dataResult);
                }
            }

            function saveChanges() {
                $log.log('Saving changes in ' + vm.partnerApp.productName + ' integration wizard...');
                // Let each wizard page save its contents.
                $scope.saving = true;
                var savePromises = $scope.save();
                // Wait for the promises to finish, or continue if no promises exist.
                $log.log($scope.saving);
                if (savePromises.length) {
                    return $q.all(savePromises)
                        .then(function(responses) {
                            $scope.saving = false;
                            $log.log('Finished saving ' + vm.partnerApp.productName + ' settings.');
                            return {
                                appRoles: vm.appRoles,
                                canUpdate: vm.canUpdate,
                                partnerApp: vm.partnerApp
                            };
                        });
                } else {
                    return null;
                }
            }

            vm.cancel = function () {
                $log.log('Cancelling ' + vm.partnerApp.productName + ' integration wizard');
                return close(null);
            };

            vm.finish = function() {
                return saveChanges().then(function(savedDataObj) {
                    $scope.isComplete = true;
                    return close(savedDataObj);
                });
            };

            vm.setAcceptance = function (flag) {
                var accepted = !!flag ? true : false;
                $scope.dataObj.partnerApp.acceptedTOS = accepted;
                $scope.isValid = accepted;
                $scope.canExit = accepted;
                $scope.canSave = accepted;
            };

            vm.show = function(key, state) {
                $log.log(key);
                $log.log(state);
            };

            vm.saveChanges = function() {
                saveChanges();
            };

            // Hooks between vm HTML attributes, like back/next/finish, and wizard directive
            // Hooks in directive HTML attributes.
            $scope.onCancel = function() {
                return close(null);
            };

            vm.canGoForward = function() {
                return !$scope.isLast();
            };

            $scope.cancel = function() {
                vm.cancel();
            };

            $scope.finish = function() {
                vm.finish();
            };

            $scope.nextPage = function() {};
            $scope.prevPage = function() {};
            $scope.save = function() {};
            $scope.isLast = function() {};

        }]);

    app.directive('assetMapWizard', function () {
        return {
            controller: 'assetMapWizardCtrl',
            controllerAs: 'vm',
            bindToController: true,
            restrict: 'E',
            transclude: true,
            templateUrl: "tools/integrations/apps/assetMap/assetMapWizard.html"
        };
    });
}());


'use strict';

app.component('advizrWizardIc', {
    bindings: {
        appRoles: "<",
        cancel: "<",
        canUpdate: "<",
        close: "<",
        onCancel: "<",
        partnerApp: "<"
    },
    controller: function($log, $q) {
        var vm = this;
        this.wizard = null;
        /*vm.unsubscribe = true;
        vm.atStart = true;*/
        this.startText = "This wizard will guide you through the steps to setup your integration with Advizr.";

        function cancel() {
            $log.info('Cancelling Advizr integration settings editor');
            closeWizard();
        }

        function closeWizard() {
            if (typeof vm.close === "function") {
                vm.close();
            }
        }

        /**
         * Cancels the wizard without saving any changes.
         */
        this.cancel = function () {
            cancel();
        };

        /**
         * Returns true if the user can move forward from the current page;
         * returns false if something remains undone that would prevent moving to the next page.
         * @returns {boolean}
         */
        this.canGoForward = function() {
            return (!!vm.partnerApp && vm.partnerApp.acceptedTOS === true);
        };

        /**
         * Cancels the wizard without saving any changes.
         */
        this.close = function () {
            closeWizard();
        };


        /**
         * Saves changes to the Advizr integration settings and closes the wizard.
         */
  /*      this.finish = function() {
            console.log('here here');
            return saveChanges().then(function() {
                if (!!vm.wizard) {
                    vm.wizard.setComplete(true);
                }
                closeWizard();
            });
        };*/

        /**
         * Shows the key and state in the console log.
         * @param key - The key of the logged item.
         * @param state - The state of the logged item.
         */
        this.show = function(key, state) {
        };


        this.$onInit = function() {
            vm.partnerApp.sendemail = vm.partnerApp.acceptedTOS === false;
            console.log('send email:');
            console.log(vm.partnerApp.sendemail);
        };
    },
    controllerAs: 'vm',
    templateUrl: "tools/integrations/apps/advizr/advizrWizard.html",
    transclude: true
});

'use strict';

app.component('advizrTerms', {
    bindings: {
        partnerApp: '<',
    },
    controller: function($partnerAppService, $q){
        var vm = this;
        function saveTerms() {
            vm.partnerApp.installed = vm.partnerApp.acceptedTOS;
            if (vm.partnerApp.acceptedTOS === true) {
                return $partnerAppService.acceptTermsOfService( vm.partnerApp.id, vm.partnerApp.acceptedTOS );
            }

            return vm.partnerApp;
        }

        this.saveChanges = function() {
            return $q.when(saveTerms());
        };

        this.$onInit = function() {
            // If this is hosted by a wizard page, register any handlers with the page.
            if(vm.wizardPage.wizard.hasDisable){
            vm.wizardPage.wizard.hasDisable = vm.partnerApp.acceptedTOS;
            };
            if ( !!vm.wizardPage ) {
                vm.wizardPage.register({
                    canEnter: function() {
                        return true;
                    },
                    canExit: function() {
                        return true;
                    },
                    isValid: function() { return true; },
                    isVisited: function() { return true; },
                    onNext: function() {
                        var partnerApp = vm.partnerApp;
                        partnerApp.installed = partnerApp.acceptedTOS;
                    },
                    onSave: function() {
                        vm.saveChanges();
                    }
                });
            }
        };
    },
    controllerAs: 'vm',
    require: {
        wizardPage: '^^icWizardPage'
    },
    templateUrl: 'tools/integrations/apps/advizr/advizrTerms.html',
    transclude: true
});

'use strict';

app.component('advizrFinished', {
    bindings: {
        partnerApp: '<',
        appRoles: '<'
    },
    controller: function($http, API_CONFIG){
        var vm = this;

        function saveChanges() {
            if(vm.partnerApp.sendemail)
                {
                return $http.post(API_CONFIG.baseUrl + "/Integrations/Advizr/SendEmail")
                }
            return true;
        }

        this.$onInit = function() {
            // If this is hosted by a wizard page, register any handlers with the page.
            if ( !!vm.wizardPage ) {
                vm.wizardPage.register({
                    canEnter: function() {
                        return true;
                    },
                    canExit: function() {
                        return true;
                    },
                    isValid: function() { return true; },
                    isVisited: function() { return true; },
                    onSave: function() {
                        return saveChanges();
                    }
                });
            }
        };
    },
    controllerAs: 'vm',
    require: {
        wizardPage: '^^icWizardPage'
    },
    templateUrl: 'tools/integrations/apps/advizr/advizrFinished.html',
    transclude: true
});

(function() {
    app.controller('bizEquityWizardCtrl', ['$scope', '$q', '$log',
        function($scope, $q, $log){
            var vm = this;
            // Make copies of data objects to edit.
            vm.appRoles = angular.copy($scope.current.appRoles);
            vm.canUpdate = angular.copy($scope.current.canUpdate);
            vm.partnerApp = angular.copy($scope.current.partnerApp);
            vm.isLoadingQuikConfiguration = true;
            function close(dataResult) {
                if ($scope.dialog !== null) {
                    $scope.dialog.close(dataResult);
                } else {
                    $scope.$parent.close(dataResult);
                }
            }

            function saveChanges() {
                $log.log('Saving changes in ' + vm.partnerApp.productName + ' integration wizard...');
                // Let each wizard page save its contents.
                $scope.saving = true;
                var savePromises = $scope.save();
                // Wait for the promises to finish, or continue if no promises exist.
                $log.log($scope.saving);
                if (savePromises.length) {
                    return $q.all(savePromises)
                        .then(function(responses) {
                            $scope.saving = false;
                            $log.log('Finished saving ' + vm.partnerApp.productName + ' settings.');
                            return {
                                appRoles: vm.appRoles,
                                canUpdate: vm.canUpdate,
                                partnerApp: vm.partnerApp
                            };
                        });
                } else {
                    return null;
                }
            }

            vm.cancel = function () {
                $log.log('Cancelling ' + vm.partnerApp.productName + ' integration wizard');
                return close(null);
            };

            vm.finish = function() {
                return saveChanges().then(function(savedDataObj) {
                    $scope.isComplete = true;
                    return close(savedDataObj);
                });
            };

            vm.setAcceptance = function (flag) {
                var accepted = !!flag ? true : false;
                $scope.dataObj.partnerApp.acceptedTOS = accepted;
                $scope.isValid = accepted;
                $scope.canExit = accepted;
                $scope.canSave = accepted;
            };

            vm.show = function(key, state) {
                $log.log(key);
                $log.log(state);
            };

            vm.saveChanges = function() {
                saveChanges();
            };

            // Hooks between vm HTML attributes, like back/next/finish, and wizard directive
            // Hooks in directive HTML attributes.
            $scope.onCancel = function() {
                return close(null);
            };

            vm.canGoForward = function() {
                return !$scope.isLast();
            };

            $scope.cancel = function() {
                vm.cancel();
            };

            $scope.finish = function() {
                vm.finish();
            };

            $scope.nextPage = function() {};
            $scope.prevPage = function() {};
            $scope.save = function() {};
            $scope.isLast = function() {};

        }]);

    app.directive('bizEquityWizard', function () {
        return {
            controller: 'bizEquityWizardCtrl',
            controllerAs: 'vm',
            bindToController: true,
            restrict: 'E',
            transclude: true,
            templateUrl: "tools/integrations/apps/bizEquity/bizEquityWizard.html"
        };
    });
}());


(function() {
    app.controller('blackRockWizardCtrl', ['$scope', '$q', '$log',
        function($scope, $q, $log){
            var vm = this;
            // Make copies of data objects to edit.
            vm.appRoles = angular.copy($scope.current.appRoles);
            vm.canUpdate = angular.copy($scope.current.canUpdate);
            vm.partnerApp = angular.copy($scope.current.partnerApp);
            vm.isLoadingQuikConfiguration = true;
            function close(dataResult) {
                if ($scope.dialog !== null) {
                    $scope.dialog.close(dataResult);
                } else {
                    $scope.$parent.close(dataResult);
                }
            }

            function saveChanges() {
                $log.log('Saving changes in ' + vm.partnerApp.productName + ' integration wizard...');
                // Let each wizard page save its contents.
                $scope.saving = true;
                var savePromises = $scope.save();
                // Wait for the promises to finish, or continue if no promises exist.
                $log.log($scope.saving);
                if (savePromises.length) {
                    return $q.all(savePromises)
                        .then(function(responses) {
                            $scope.saving = false;
                            $log.log('Finished saving ' + vm.partnerApp.productName + ' settings.');
                            return {
                                appRoles: vm.appRoles,
                                canUpdate: vm.canUpdate,
                                partnerApp: vm.partnerApp
                            };
                        });
                } else {
                    return null;
                }
            }

            vm.cancel = function () {
                $log.log('Cancelling ' + vm.partnerApp.productName + ' integration wizard');
                return close(null);
            };

            vm.finish = function() {
                return saveChanges().then(function(savedDataObj) {
                    $scope.isComplete = true;
                    return close(savedDataObj);
                });
            };

            vm.setAcceptance = function (flag) {
                var accepted = !!flag ? true : false;
                $scope.dataObj.partnerApp.acceptedTOS = accepted;
                $scope.isValid = accepted;
                $scope.canExit = accepted;
                $scope.canSave = accepted;
            };

            vm.show = function(key, state) {
                $log.log(key);
                $log.log(state);
            };

            vm.saveChanges = function() {
                saveChanges();
            };

            // Hooks between vm HTML attributes, like back/next/finish, and wizard directive
            // Hooks in directive HTML attributes.
            $scope.onCancel = function() {
                return close(null);
            };

            vm.canGoForward = function() {
                return !$scope.isLast();
            };

            $scope.cancel = function() {
                vm.cancel();
            };

            $scope.finish = function() {
                vm.finish();
            };

            $scope.nextPage = function() {};
            $scope.prevPage = function() {};
            $scope.save = function() {};
            $scope.isLast = function() {};

        }]);

    app.directive('blackRockWizard', function () {
        return {
            controller: 'blackRockWizardCtrl',
            controllerAs: 'vm',
            bindToController: true,
            restrict: 'E',
            transclude: true,
            templateUrl: "tools/integrations/apps/blackRock/blackRockWizard.html"
        };
    });
}());


'use strict';

var blazeAddFormCtrl = function($scope, $partnerAppService, $dialog) {

    var setupServiceUrl = '/Integrations/Blaze/Setup';
    var removeServiceUrl = '/Integrations/Blaze/Remove';

    var self = this;
    $scope.blazeApp = $scope.current.partnerApp;

    function showError( errorResponse ) {
        if ( errorResponse && errorResponse.data ) {
            $dialog.actionFailed( errorResponse.data.userException.detail );
        } else {
            $dialog.actionFailed('There was an error setting up Blaze.');
        }
    }

    function getConfiguration(response) {
        $scope.blazeApp.configuration = response.data;
        $scope.blazeApp.installed = true;
        return response;
    }

    self.installBlaze = function() {
        var promise = $partnerAppService.setupServiceForPartnerApp($scope.blazeApp, setupServiceUrl)
            .then(function (response) {
                return response;
            }, showError);

        return promise.then(getConfiguration);
    };

    self.uninstallBlaze = function() {
        return $partnerAppService.removeService(removeServiceUrl, $scope.blazeApp.id).then(function() {
            $scope.blazeApp.installed = false;
        }, showError);
    };
};

blazeAddFormCtrl.$inject = ['$scope', '$partnerAppService', '$dialog'];
app.controller('blazeAddFormCtrl', blazeAddFormCtrl);

var blazeAddForm = function() {
    return {
        replace: true,
        restrict: 'E',
        templateUrl: 'tools/integrations/apps/blaze/blazeAddForm.html',
        controller: 'blazeAddFormCtrl',
        controllerAs: 'blaze',
        scope: {
            current: '='
        }
    };
};

app.directive('blazeAddForm', blazeAddForm);
'use strict';

var chicagoClearingAddFormCtrl = function($scope, $partnerAppService, $dialog) {

    var setupServiceUrl = '/Integrations/ChicagoClearing/Setup';
    var removeServiceUrl = '/Integrations/ChicagoClearing/Remove';

    var self = this;
    $scope.ccApp = $scope.current.partnerApp;

    function showError( errorResponse ) {
        if ( errorResponse && errorResponse.data ) {
            $dialog.actionFailed( errorResponse.data.userException.detail );
        } else {
            $dialog.actionFailed('There was an error setting up iRebal.');
        }
    }

    function getConfiguration(response) {
        $scope.ccApp.configuration = response.data;
        $scope.ccApp.installed = true;
        return response;
    }

    self.installChicagoClearing = function() {
        var promise = $partnerAppService.setupServiceForPartnerApp($scope.ccApp, setupServiceUrl)
            .then(function (response) {
                return response;
            }, showError);

        return promise.then(getConfiguration);
    };

    self.uninstallChicagoClearing = function() {
        return $partnerAppService.removeService(removeServiceUrl, $scope.ccApp.id).then(function() {
            $scope.ccApp.installed = false;
        }, showError);
    };
};

chicagoClearingAddFormCtrl.$inject = ['$scope', '$partnerAppService', '$dialog'];
app.controller('chicagoClearingAddFormCtrl', chicagoClearingAddFormCtrl);

var chicagoClearingAddForm = function() {
    return {
        replace: true,
        restrict: 'E',
        templateUrl: 'tools/integrations/apps/chicagoClearing/chicagoClearingAddForm.html',
        controller: 'chicagoClearingAddFormCtrl',
        controllerAs: 'cc',
        scope: {
            current: '='
        }
    };
};

app.directive('chicagoClearingAddForm', chicagoClearingAddForm);
(function() {
    app.controller('finMasonWizardCtrl', ['$scope', '$q', '$log',
        function($scope, $q, $log){
            var vm = this;
            // Make copies of data objects to edit.
            vm.appRoles = angular.copy($scope.current.appRoles);
            vm.canUpdate = angular.copy($scope.current.canUpdate);
            vm.partnerApp = angular.copy($scope.current.partnerApp);
            vm.isLoadingQuikConfiguration = true;
            function close(dataResult) {
                if ($scope.dialog !== null) {
                    $scope.dialog.close(dataResult);
                } else {
                    $scope.$parent.close(dataResult);
                }
            }

            function saveChanges() {
                $log.log('Saving changes in ' + vm.partnerApp.productName + ' integration wizard...');
                // Let each wizard page save its contents.
                $scope.saving = true;
                var savePromises = $scope.save();
                // Wait for the promises to finish, or continue if no promises exist.
                $log.log($scope.saving);
                if (savePromises.length) {
                    return $q.all(savePromises)
                        .then(function(responses) {
                            $scope.saving = false;
                            $log.log('Finished saving ' + vm.partnerApp.productName + ' settings.');
                            return {
                                appRoles: vm.appRoles,
                                canUpdate: vm.canUpdate,
                                partnerApp: vm.partnerApp
                            };
                        });
                } else {
                    return null;
                }
            }

            vm.cancel = function () {
                $log.log('Cancelling ' + vm.partnerApp.productName + ' integration wizard');
                return close(null);
            };

            vm.finish = function() {
                return saveChanges().then(function(savedDataObj) {
                    $scope.isComplete = true;
                    return close(savedDataObj);
                });
            };

            vm.setAcceptance = function (flag) {
                var accepted = !!flag ? true : false;
                $scope.dataObj.partnerApp.acceptedTOS = accepted;
                $scope.isValid = accepted;
                $scope.canExit = accepted;
                $scope.canSave = accepted;
            };

            vm.show = function(key, state) {
                $log.log(key);
                $log.log(state);
            };

            vm.saveChanges = function() {
                saveChanges();
            };

            // Hooks between vm HTML attributes, like back/next/finish, and wizard directive
            // Hooks in directive HTML attributes.
            $scope.onCancel = function() {
                return close(null);
            };

            vm.canGoForward = function() {
                return !$scope.isLast();
            };

            $scope.cancel = function() {
                vm.cancel();
            };

            $scope.finish = function() {
                vm.finish();
            };

            $scope.nextPage = function() {};
            $scope.prevPage = function() {};
            $scope.save = function() {};
            $scope.isLast = function() {};

        }]);

    app.directive('finMasonWizard', function () {
        return {
            controller: 'finMasonWizardCtrl',
            controllerAs: 'vm',
            bindToController: true,
            restrict: 'E',
            transclude: true,
            templateUrl: "tools/integrations/apps/finMason/finMasonWizard.html"
        };
    });
}());


'use strict';

var irebalAddFormCtrl = function($scope, $partnerAppService, $dialog) {

    var setupServiceUrl = '/Integrations/iRebal/Setup';
    var removeServiceUrl = '/Integrations/iRebal/Remove';

    var self = this;
    $scope.irebalApp = $scope.current.partnerApp;

    function showError( errorResponse ) {
        if ( errorResponse && errorResponse.data ) {
            $dialog.actionFailed( errorResponse.data.userException.detail );
        } else {
            $dialog.actionFailed('There was an error setting up iRebal.');
        }
    }

    function setConfiguration(response) {
        $scope.irebalApp.configuration = response.data;
        $scope.irebalApp.installed = true;
        return response;
    }

    self.installIRebal = function() {
        var promise = $partnerAppService.setupServiceForPartnerApp($scope.irebalApp, setupServiceUrl)
            .then(function (response) {
                return response;
            }, showError);

        return promise.then(setConfiguration);
    };

    self.uninstallIRebal = function() {
        return $partnerAppService.removeService(removeServiceUrl, $scope.irebalApp.id).then(function() {
            $scope.irebalApp.installed = false;
        }, showError);
    };
};

irebalAddFormCtrl.$inject = ['$scope', '$partnerAppService', '$dialog'];
app.controller('irebalAddFormCtrl', irebalAddFormCtrl);

var irebalAddForm = function() {
    return {
        replace: true,
        restrict: 'E',
        templateUrl: 'tools/integrations/apps/irebal/irebalAddForm.html',
        controller: 'irebalAddFormCtrl',
        controllerAs: 'irebal',
        scope: {
            current: '='
        }
    };
};

app.directive('irebalAddForm', irebalAddForm);
var lexisNexisAddForm = function () {
    return {
        restrict: 'E',
        replace: true,
        controller: 'lexisNexisAddFormCtrl',
        controllerAs: 'ctrl',
        templateUrl: 'tools/integrations/apps/lexisNexis/lexisNexisAddForm.html',
        scope: {
            current: '='
        }
    };
};
app.directive('lexisNexisAddForm', lexisNexisAddForm);

var lexisNexisAddFormCtrl = function ($scope, $partnerAppService, $dialog, $http) {
    var self = this;
    var setupServiceUrl = '/Integrations/LexisNexis/Actions/Setup',
        removeServiceUrl = '/Integrations/LexisNexis/Actions/Remove',
        runNowServiceUrl = '/Integrations/LexisNexis/Actions/RunNow',
        updateConfigurationServiceUrl = '/Integrations/LexisNexis/Configuration';

    $scope.lexisNexisApp = $scope.current.partnerApp;
    $scope.lexisNexisApp.lexisNexisConfig = {
        selectedDetailLevel: 'Basic',
        selectedFrequency: 'On Demand'
    };

    $scope.queryOptions = {
        onDemand: 'On Demand',
        daily: 'Daily',
        monthly: 'Monthly',
        quarterly: 'Quarterly'
    };

    $scope.servicePackage = {
        basic: 'Basic',
        premium: 'Premium'
    };

    self.setDisabled = function() {
        $scope.lexisNexisApp.lexisNexisConfig.enabled = false;
    };

    self.setEnabled = function() {
        $scope.lexisNexisApp.lexisNexisConfig.enabled = true;
    };


    $partnerAppService.getConfiguration($scope.lexisNexisApp.productName).then(function(config) {
        $scope.lexisNexisApp.lexisNexisConfig = config;
    });


    function showError(error) {
        if(error && error.data && error.data.userException) {
            $dialog.actionFailed( error.data.userException.detail );
        } else {
            $dialog.actionFailed('There was an error setting up Lexis Nexis.');
        }
    }

    self.installLexisNexis = function() {
        return $partnerAppService.setupServiceForPartnerApp($scope.lexisNexisApp, setupServiceUrl)
            .then(function (response) {
                $scope.lexisNexisApp.installed = true;
                return response;
        }, showError);
    };

    self.uninstallLexisNexis = function() {
        return $partnerAppService.removeService(removeServiceUrl, $scope.lexisNexisApp.id).then(function() {
            $scope.lexisNexisApp.installed = false;
        }, showError);
    };

    self.updateLexisNexis = function() {
        return $partnerAppService.updatePartnerAppSettingsByUrl(updateConfigurationServiceUrl, $scope.lexisNexisApp.lexisNexisConfig);
    };

    self.runNow = function() {
        return $http.post(runNowServiceUrl, null, {trackerMsg: 'Running Lexis Nexis scan...', ignoreExceptions: true})
            .then(function() {
                var message = "<p>Your firm's client data has been sent to Lexis Nexis for scanning purposes. To ensure that you receive a notification when results are available, subscribe to LexisNexis notifications by going to your account settings and checking the 'Enabled' button. If you wish to be emailed, check the 'Email' button.</p>";
                return $dialog.messageBox("Lexis Nexis Scan Started", message, [{result: 'ok', label: 'Accept', focus: true}])
                .open();
            }).catch(function() {
                var message = "<p>There was an issue submitting your client data to Lexis Nexis for scanning. Please reach out to the Orion Compliance team at 'Compliance@orionadvisor.com' for assistance with this problem. </p>";
                return $dialog.messageBox("Lexis Nexis Scan Failed", message, [{result: 'ok', label: 'Accept', focus: true}])
                .open();
            });
    };

};
lexisNexisAddFormCtrl.$inject = ['$scope', '$partnerAppService', '$dialog', '$http'];
app.controller('lexisNexisAddFormCtrl', lexisNexisAddFormCtrl);




'use strict';

app.directive('maxMyInterestAddForm', function maxMyInterestAddForm(API_CONFIG, $oasRights, $partnerAppService, $window, $location) {

    return {
        link: function($scope, element, attrs) {
            var noRightsMessage = 'The current user does not have the correct privileges to connect to Max My Interest.';
            // When the button is clicked, mark me as installed/uninstalled.
            element.on('click', function() {
                // When the user clicks the button, call the SSO to setup the partner app integration.
                var redirectUrl = '';
                if(API_CONFIG.isTest) {
                    redirectUrl = 'https://demo.maxmyinterest.com/sso/auth/orion_advisor';
                } else {
                    redirectUrl = 'https://maxmyinterest.com/sso/auth/orion_advisor';
                }
                $window.open($location.protocol() + '://' + $location.host() + '/orionconnectapp/integration.html?r=' + encodeURIComponent(redirectUrl));
            });
        },
        priority: 99,
        restrict: 'E',
        replace: true,
        templateUrl: "tools/integrations/apps/maxmyinterest/maxMyInterestAddForm.html",
        terminal: true,
        scope: {
            current: '='
        }
    };
});
/**
 * MoneyGuidePro controller for its directive, and use $partnerAppService.
 */
'use strict';

app.controller('MoneyGuideProCtrl', ['$scope', '$location', '$dialog', '$oasRights', '$partnerAppService',
    function MoneyGuideProCtrl($scope, $location, $dialog, $oasRights, $partnerAppService) {
        // MoneyGuidePro-specific API endpoints.
        var settingsUrl = '/Integrations/MoneyGuidePro/Settings';
        var setupServiceUrl = '/Integrations/MoneyGuidePro/Setup';
        var removeServiceUrl = '/Integrations/MoneyGuidePro/Remove';
        // Messages
        var noRightsMessage = "You aren't authorized to set up this service. Please check with your administrator.";
        var partnerAppName = 'MoneyGuidePro';

        function init() {
            checkSecurity();
        }

        function checkSecurity() {
            // Can the current user update the necessary service credentials?
            var userEntityCode = $scope.$root.user.authorization.entity;
            $scope.showAll = userEntityCode === 'Administrator' || userEntityCode === 'Advisor';
            $scope.showRia = $scope.showAll || userEntityCode === 'Advisor' || userEntityCode === 'RIA';
            $scope.canUpdate = $scope.showAll || $scope.showRia;
            $scope.mgpApp = angular.merge( {}, $scope.current.partnerApp );
        }

        function showError( errorResponse ) {
            if ( errorResponse && errorResponse.data ) {
                $dialog.actionFailed( errorResponse.data.userException.detail );
            } else {
                $dialog.actionFailed('There was an error setting up MoneyGuide.');
            }
        }

        angular.merge( $scope, {
            getPartnerAppSettings: function () {
                return getPartnerAppSettings ();
            },
            installApp: function() {
                if (!$scope.mgpApp.acceptedTOS) {
                    $scope.warnTosNotAccepted( 'MoneyGuide' );
                    return null;
                } else if (!$scope.canUpdate) {
                    $dialog.actionFailed( noRightsMessage ).open();
                    return null;
                } else {
                    return $partnerAppService.setupServiceForPartnerApp($scope.mgpApp, setupServiceUrl)
                        .then(function (r) {
                            $scope.mgpApp.settings.userName = r.data.userId;
                            $scope.mgpApp.settings.password = r.data.password;
                            $scope.mgpApp.installed = true;
                        }, showError
                    );
                }
            },
            removeApp: function() {
                if (!$scope.canUpdate) {
                    $dialog.actionFailed( noRightsMessage ).open();
                    return null;
                } else {
                    return $partnerAppService.removeService(removeServiceUrl, $scope.mgpApp.id)
                    .then(function (data) {
                        $scope.mgpApp.installed = false;
                        }, showError
                    );
                }
            },
            updateSettings: function( ) {
                if (!$scope.canUpdate) {
                    $dialog.actionFailed( noRightsMessage ).open();
                    return null;
                } else {
                    return $partnerAppService.updatePartnerAppSettingsByUrl(settingsUrl, {
                        institutionId: parseInt($scope.mgpApp.settings.institutionId),
                        userName: $scope.mgpApp.settings.userName,
                        password: $scope.mgpApp.settings.password
                    } )
                        .then(function (data) {
                                $scope.close();
                                return data;
                            }, showError
                        );
                }
            },
            warnTosNotAccepted: function ( ) {
                $scope.$parent.warnTosNotAccepted('MoneyGuide');
            }
        });

        init( );
    }]);

'use strict';
/**
 * Directive to display elements to setup MoneyGuidePro.
 */
app.directive('moneyguideproaddform', function () {
        return {
            link: function($scope, element, attrs) {
                var noRightsMessage = "You aren't authorized to set up this service. Please check with your administrator.";

                element.on('click', 'button', function() {
                    switch (this.id) {
                        case "installMgp":
                            // When the user clicks the button, call the API to setup the partner app integration.
                            $scope.installApp( );
                            break;

                        case "saveMgp":
                            // Save changes to properties - only Admins will need to do this, though this should be rare.
                            $scope.updateSettings( );
                            break;

                        case "removeMgp":
                            $scope.removeApp( );
                            break;
                    }
                });
            },
            priority: 99,
            restrict: 'E',
            replace: true,
            templateUrl: "tools/integrations/apps/moneyGuidePro/moneyGuideProAddForm.html",
            terminal: true,
            scope: {
                current: '='
            },
            controller: 'MoneyGuideProCtrl'
        };
    });

'use strict';

app.component('supernovaWizardIc', {
    bindings: {
        appRoles: "<",
        cancel: "<",
        canUpdate: "<",
        close: "<",
        onCancel: "<",
        partnerApp: "<"
    },
    controller: function($log, $q) {
        var vm = this;
        this.wizard = null;
        /*vm.unsubscribe = true;
        vm.atStart = true;*/
        this.startText = "This wizard will guide you through the steps to setup your integration with Advizr.";

        function cancel() {
            $log.info('Cancelling Advizr integration settings editor');
            closeWizard();
        }

        function closeWizard() {
            if (typeof vm.close === "function") {
                vm.close();
            }
        }

        /**
         * Cancels the wizard without saving any changes.
         */
        this.cancel = function () {
            cancel();
        };

        /**
         * Returns true if the user can move forward from the current page;
         * returns false if something remains undone that would prevent moving to the next page.
         * @returns {boolean}
         */
        this.canGoForward = function() {
            return (!!vm.partnerApp && vm.partnerApp.acceptedTOS === true);
        };

        /**
         * Cancels the wizard without saving any changes.
         */
        this.close = function () {
            closeWizard();
        };


        /**
         * Saves changes to the Advizr integration settings and closes the wizard.
         */
  /*      this.finish = function() {
            console.log('here here');
            return saveChanges().then(function() {
                if (!!vm.wizard) {
                    vm.wizard.setComplete(true);
                }
                closeWizard();
            });
        };*/

        /**
         * Shows the key and state in the console log.
         * @param key - The key of the logged item.
         * @param state - The state of the logged item.
         */
        this.show = function(key, state) {
        };


        this.$onInit = function() {
        };
    },
    controllerAs: 'vm',
    templateUrl: "tools/integrations/apps/supernova/supernovaWizard.html",
    transclude: true
});


app.component('redtailFinishedIc', {
    bindings: {
        commonSettingsChanged: '<',
        getSettings: '<'
    },
    controller: function(redtailService, $q) {
        var vm = this;

        vm.settingsHaveChanged = false;
        vm.commonSettingsHaveChanged = false;
        vm.originalSettings = null;

        function getCurrentSettings() {
            return vm.getSettings( false );
        }

        //#region public interface

        /**
         * Initializes the component in its tree. This function is called by the angular
         * component system when all controllers in the component tree have been set up
         * and the parent component is sure to be ready.
         */
        this.$onInit = function() {
            redtailService.getSettings( false ).then(function(storedSettings) {
                vm.originalSettings = storedSettings;
            });

            // If this is hosted by a wizard page, register any handlers with the page.
            if ( !!vm.wizardPage ) {
                vm.wizardPage.register({
                    canEnter: function() {
                        return true;
                    },
                    canExit: function() {
                        return true;
                    },
                    isValid: function() { return true; },
                    isVisited: function() { return true; },
                    onActive: function() {
                        var latestSettings = redtailService.getLatestSettings();
                        vm.settingsHaveChanged = redtailService.compareSettings( vm.originalSettings, latestSettings );
                        vm.commonSettingsHaveChanged = vm.commonSettingsChanged();
                    },
                    onNext: function() {
                        // var partnerApp = vm.partnerApp;
                        // partnerApp.installed = partnerApp.acceptedTOS;
                    },
                    onReady: function() {
                        return false;
                    },
                    onSave: function() {
                        // This component doesn't save any data.
                        return $q.resolve(null);
                    },
                    onSaveComplete: function() {
                        return true;
                    }
                });
            }
        };

        //#endregion public interface
    },
    controllerAs: 'vm',
    require: {
        wizardPage: '^icWizardPage'
    },
    templateUrl: "tools/integrations/apps/redtail_IC/redtailFinished.html",
    transclude: true
});


app.component('redtailReadyIc', {
    bindings: {
        commonSettingsChanged: '<',
        getSettings: '<',
        redtailUsers: '<',
        reps: '<',
        updateLatestSettings: '<',
        updateSettings: '<'
    },
    controller: function($log, $q, oasClipboard, redtailService, integrationCenterService) {
        var vm = this;
        vm.firmId = redtailService.firmId;
        vm.firmName = redtailService.firmName;
        // var originalRedtailUsers = null;
        var settings = redtailService.getLatestSettings();

        var originalSettings = null;
        vm.settingsHaveChanged = false;
        vm.commonSettingsHaveChanged = false;

        vm.redtailUsers = null;
        vm.reps = null;
        vm.dirtyRoles = [];

        //#region private functions

        function compareItemByName(x1, y1) {
            return (x1.name.toUpperCase() > y1.name.toUpperCase()) ? -1 : 1;
        }

        function copyToClipboard (clipboardSourceId) {
            if (!!clipboardSourceId) {
                var sourceElement = document.getElementById(clipboardSourceId);
                if (!!sourceElement){
                    var content = sourceElement.innerText || sourceElement.textContent || "";
                    oasClipboard.copyContent(content);
                }
            }
        }

        function getEditedAppRoles(editedAppRoles) {
            if (editedAppRoles === null) {
                vm.dirtyRoles = [];
                return;
            }

            var xRoles = editedAppRoles.roles.filter(function (item) {
                return item.isDirty === true;
            });

            var changedRoles = xRoles.map(function (item) {
                if (item.isDirty) {
                    return {
                        id: item.id,
                        name: item.name,
                        enabled: item.enabled
                    };
                }
            });

            vm.dirtyRoles = changedRoles.sort(compareItemByName);
        }

        function getLatestFirmData() {
            var firmData = redtailService.getCurrentFirm();
            vm.firmId = firmData.firmId;
            vm.firmName = firmData.firmName;
        }

        function getRepName(repId) {
            if (!repId || !vm.reps || vm.reps.length === 0) {
                return null;
            }

            var found = vm.reps.find(function(element) {
                return element.repId === repId;
            });

            if (found) {
                return found.name;
            } else {
                return null;
            }
        }

        function onPageActive() {
            getLatestFirmData();
            var editedAppRoles = integrationCenterService.getLatestSelectedAppRoles();
            settings = redtailService.getLatestSettings();
            vm.redtailUsers = settings.users;
            vm.reps = settings.reps;
            // Compare the current settings shared in the parent, against
            vm.settingsHaveChanged = redtailService.settingsChanged( true );
            vm.commonSettingsHaveChanged = vm.commonSettingsChanged();
            vm.wizardPage.setSaveButtonAtSave( ( vm.settingsHaveChanged || vm.commonSettingsHaveChanged ) );
            getEditedAppRoles(editedAppRoles);
        }

        /**
         * Saves changes to this page's data; unused in this case.
         * @returns null
         */
        function saveChanges() {
            originalSettings = vm.getSettings();
            return $q.resolve(null);
        }

        //#endregion private functions

        //#region public interface

        this.copyToClipboard = function(clipboardSourceId) {
            copyToClipboard(clipboardSourceId);
        };

        this.getRepName = function(repId) {
            return getRepName(repId);
        };

        this.settingsChanged = function() {
            vm.settingsHaveChanged = redtailService.settingsChanged();
            return vm.settingsHaveChanged;
        };

        /**
         * Initializes the component in its tree. This function is called by the angular
         * component system when all controllers in the component tree have been set up
         * and the parent component is sure to be ready.
         */
        this.$onInit = function() {
            originalSettings = vm.getSettings();

            // If this is hosted by a wizard page, register any handlers with the page.
            if ( !!vm.wizardPage ) {
                vm.wizardPage.register({
                    canEnter: function() { return true; },
                    canExit: function() { return true; },
                    isValid: function() { return true; },
                    isVisited: function() { return true; },
                    onActive: function() {
                        onPageActive();
                    },
                    onNext: function() {
                        return true;
                    },
                    onReady: function() { return true; },
                    onSave: function() {
                        return saveChanges();
                    }
                });
            }
        };

        //#endregion public interface
    },
    controllerAs: 'vm',
    require: {
        wizardPage: '^icWizardPage'
    },
    templateUrl: 'tools/integrations/apps/redtail_IC/redtailReady.html',
    transclude: true
});


//** Redtail Selection page - */
app.component('redtailSelectionIc', {
    bindings: {
        partnerApp: '<',
        updateLatestSettings: '<',
        updateSettings: '<',
        commonSettingsChanged: '<'
    },
    controller: function($log, redtailService){
        var vm = this;

        this.firmId = redtailService.firmId;
        this.firmName = redtailService.firmName;
        this.nameToAdd = null;
        this.selectedRedtailUser = null;
        this.defaultSettings = {
            emailAddresses: [],
            orionFirmId: this.firmId,
            redtailFirmId: 0,
            reps: [],
            users: null
        };

        this.settings = angular.copy(this.defaultSettings);
        this.settingsHaveChanged = false;
        this.commonSettingsHaveChanged = false;

        //#region private functions

        function addUser() {
            if (vm.nameToAdd !== null) {
                var index = vm.settings.users.length + 1;
                var newItem = {
                    id: index,
                    name: vm.nameToAdd,
                    repIds: []
                };

                vm.settings.users.push(newItem); // Add the user name.
                vm.selectRedtailUser(newItem); // Select the new item in the list.
                vm.nameToAdd = null; // Clear input to avoid dupes.
            }
        }

        function allRepsSelected() {
            return (!!vm.selectedRedtailUser) && (vm.settings.reps.length === vm.selectedRedtailUser.repIds.length);
        }

        function initialize() {
            return redtailService.getSettings(true)
                .then(function(response){
                    initializeSettings(response);
                });
        }

        function initializeSettings(settingsObj) {
            vm.settings = settingsObj;
            if (vm.settings.users.length >= 1) {
                selectRedtailUser(vm.settings.users[0]);
            }
        }

        function noRepsSelected() {
            return (!!vm.selectedRedtailUser) && (vm.selectedRedtailUser.repIds.length === 0);
        }

        /**
         * Saves changes to this page's data by writing it to the stored settings on the server.
         * @returns {PromiseLike<{appRoles} | never> | Promise<{appRoles} | never>|*}
         */
        function saveChanges() {
            return redtailService.updateSettings(vm.settings)
                .then(function(data) {
                    initializeSettings( angular.copy(data) );
                });
        }

        function selectAll() {
            vm.selectedRedtailUser.repIds = [];
            vm.settings.reps.forEach(function(item) {
                item.selected = true;
                vm.selectedRedtailUser.repIds.push(item.repId);
            });
        }

        function selectRedtailUser(redtailUser) {
            if (vm.selectedRedtailUser) {
                vm.selectedRedtailUser.selected = false;
            }

            redtailUser.selected = true;
            vm.selectedRedtailUser = redtailUser;
            updateSelectedReps();
        }

        function unselectAll() {
            vm.selectedRedtailUser.repIds = [];
            vm.settings.reps.forEach(function(item) {
                item.selected = false;
            });
        }

        function updateSelectedReps(){
            if (!vm.selectedRedtailUser) {
                return;
            }

            var selectedRepIds = vm.selectedRedtailUser.repIds;
            vm.settings.reps.forEach(function(item) {
                item.selected = selectedRepIds.indexOf(item.repId) > -1;
            });
        }

        //#endregion private functions

        //#region public interface

        /**
         * Adds a RedtailUser to the list of users in the settings.
         */
        vm.addRedtailUser = function(){
            addUser();
        };

        vm.allRepsSelected = function() {
            return allRepsSelected();
        };

        vm.noRepsSelected = function() {
            return noRepsSelected();
        };

        vm.selectAll = function() {
            selectAll();
        };

        vm.selectRedtailUser = function(redtailUser){
            selectRedtailUser(redtailUser);
        };

        vm.toggleRep = function(rep) {
            if (!!vm.selectedRedtailUser) {
                var selectState = " is ";
                rep.selected = !rep.selected;
                var repIds = vm.selectedRedtailUser.repIds;
                var index = repIds.indexOf(rep.repId);
                if (rep.selected){
                    if (index < 0){
                        repIds.push(rep.repId);
                    }
                } else {
                    if (index >= 0){
                        repIds.splice(index, 1);
                    }

                    selectState = " is not ";
                }

                repIds.sort();
                vm.selectedRedtailUser.reps = [];
                repIds.forEach(function(item) {
                    var rep = vm.settings.reps.find(function(findItem) {
                        return findItem.repId === item;
                    });

                    if (typeof rep !== "undefined") {
                        vm.selectedRedtailUser.reps.push(rep);
                    }
                });

                $log.info(rep.name + selectState + "selected for " + vm.selectedRedtailUser.name);
                $log.info("Redtail user " + vm.selectedRedtailUser.name + " is now linked to Reps: [" + vm.selectedRedtailUser.repIds + "].");
                $log.info("Redtail user " + vm.selectedRedtailUser.name + " is now linked to Reps: ");
                $log.info('Selected Redtail user: ' + JSON.stringify(vm.selectedRedtailUser));
            }
        };

        vm.unselectAll = function() {
            unselectAll();
        };

        vm.updateSelectedReps = function(){
            updateSelectedReps();
        };

        /**
         * Initializes the component in its tree. This function is called by the angular
         * component system when all controllers in the component tree have been set up
         * and the parent component is sure to be ready.
         */
        this.$onInit = function() {
            initialize();

            // If this is hosted by a wizard page, register any handlers with the page.
            if ( !!vm.wizardPage ) {
                vm.wizardPage.register({
                    canEnter: function() {
                        return true;
                    },
                    canExit: function() {
                        return true;
                    },
                    isValid: function() { return true; },
                    isVisited: function() { return true; },
                    onActive: function() {
                        vm.settingsHaveChanged = redtailService.settingsChanged();
                        vm.commonSettingsHaveChanged = vm.commonSettingsChanged();
                    },
                    onNext: function() {
                        redtailService.updateLatestSettings(vm.settings);
                    },
                    onSave: function() {
                        return saveChanges();
                    }
                });
            }
        };

        //#endregion public interface
    },
    controllerAs: 'vm',
    require: {
        wizardPage: '^icWizardPage'
    },
    transclude: true,
    templateUrl: "tools/integrations/apps/redtail_IC/redtailSelection.html"
});

'use strict;'

app.service('redtailService', ['$http', '$q', '$filter', '$log', '$oasRights', 'API_CONFIG', 'integrationCenterService', function($http, $q, $filter, $log, $oasRights, API_CONFIG, integrationCenterService) {

    var self = this;
    var storedSettings = null;
    var latestSettings = null;
    var appSettingsUrl = '/Integrations/Redtail/Configuration';
    var defaultSettings = {
        emailAddresses: [],
        orionFirmId: 0,
        redtailFirmId: 0,
        reps: [],
        users: null
    };

    var currentFirm = {
        firmId: integrationCenterService.firmId,
        firmName: integrationCenterService.firmName
    };

    // self.firmId = integrationCenterService.firmId;
    // self.firmName = integrationCenterService.firmName;

    //#region private functions

    function compareSettings( knownSettings, deltaSettings) {
        if (deltaSettings === null){
            return true; // Nothing has changed.
        }

        // Get a copy of the settings, and remove UI flags from
        // the copy before testing if anything changed.
        var latestSettingsTest = angular.copy(knownSettings);
        latestSettingsTest.reps  = deltaSettings.reps.map(rep => {
            var obj = {
                firstName: rep.firstName,
                lastName: rep.lastName,
                name: rep.name,
                repId: rep.repId
            };

            return obj;
        });
        latestSettingsTest.users  = deltaSettings.users.map(userObj => {
            var obj = {
                id: userObj.id,
                name: userObj.name,
                repIds: userObj.repIds,
                reps: userObj.reps
            };

            return obj;
        });

        return angular.equals(knownSettings, latestSettingsTest) === false;
    }

    function getCurrentFirm() {
        currentFirm = integrationCenterService.getCurrentFirm();
        self.firmId = currentFirm.firmId;
        self.firmName = currentFirm.firmName;
        return currentFirm;
    }

    function getSettings(ifRefresh) {
        if (storedSettings === null || ifRefresh) {
            return integrationCenterService.getAppSettings(appSettingsUrl)
                .then(function(response) {
                    var data = response.data;
                    storedSettings = angular.copy(defaultSettings);
                    storedSettings = angular.merge({}, storedSettings, {
                        emailAddresses: data.emailAddresses,
                        orionFirmId: data.orionFirmId,
                        redtailFirmId: data.redtailFirmId,
                        reps: data.reps,
                        users: data.users
                    });
                    latestSettings = angular.copy(storedSettings);
                }).then(function () {
                    return angular.copy(storedSettings);
                });
        } else {
            return angular.copy(storedSettings);
        }
    }

    function settingsChanged( ) {
        return compareSettings( storedSettings, latestSettings );
    }

    function updateLatestSettings (currentSettings) {
        if (currentSettings !== null) {
            latestSettings = angular.copy(currentSettings);
        }

        return settingsChanged();
    }

    function updateSettings(newSettings) {
        return integrationCenterService.updatePartnerAppSettingsByUrl(appSettingsUrl, newSettings)
            .then(function(updatedSettings){
                storedSettings = updatedSettings.data;
                latestSettings = angular.copy(storedSettings);
                return angular.copy(storedSettings);
            });
    }

    //#endregion private functions

    //#region public interface

    //#region app role and privilege methods

    /**
     * Updates the roles with the partner app's privilege.
     * @param changedRoles the roles to which the user has assigned or removed the partner app's privilege.
     * @returns {Function} A promise to return the changed roles as updated from the service call.
     */
    self.updatePrivilegeRoles = function( changedRoles ) {
        return integrationCenterService.updatePrivilegeRoles(changedRoles);
    };

    self.getRolesForApp = function ( privilegeId ) {
        return integrationCenterService.getRolesForApp(privilegeId);
    };

    //#endregion app role and privilege methods

    self.compareSettings = function( mainSettings, deltaSettings ) {
        return compareSettings( mainSettings, deltaSettings );
    };

    self.getCurrentFirm = function() {
        return getCurrentFirm();
    };
    /**
     * Gets a copy of the latest settings, including any updates sent from other components.
     * @returns {Object} The latest settings as modified in the application.
     */
    self.getLatestSettings = function() {
        return latestSettings;
    };

    /**
     * Gets the settings stored on the server.
     * @param {bool} ifRefresh If this value is true the settings will be refreshed from the server. Otherwise, the current copy of the stored settings will be returned.
     * @returns {Object} The settings stored on the server, or the latest local copy.
     */
    self.getSettings = function(ifRefresh) {
        return getSettings(ifRefresh);
    };
    /**
     * Returns true if the latest settings have changed compared to stored values, false if
     * no changes exist in memory.
     * @returns {bool}
     */
    self.settingsChanged = function() {
        return settingsChanged();
    };
    /**
     * Adds changes to the current settings so other components can share data indirectly.
     * @param {Object} currentSettings The changed settings object to merge with the latest
     * settings managed by the service.
     * @returns {Object} The latest settings as modified in the application.
     */
    self.updateLatestSettings = function(currentSettings) {
        return updateLatestSettings(currentSettings);
    };

    /**
     * Updates the settings stored on the server.
     * @param {Object} newSettings The settings stored on the server after the update.
     */
    self.updateSettings = function(newSettings) {
        return updateSettings(newSettings);
    };

    //#endregion public interface
}]);

'use strict';

app.component('redtailWizardIc', {
    bindings: {
        appRoles: "<",
        cancel: "<",
        canUpdate: "<",
        close: "<",
        onCancel: "<?",
        partnerApp: "<"
    },
    controller: function($log, $q, redtailService) {
        var vm = this;
        var currentSettings = null;
        var storedSettings = null;
        var storedCommonSettings = null;
        var commonSettingsChanged = false;
        var appSettingsChanged = false;

        this.defaultSettings = {
            emailAddresses: [],
            orionFirmId: 0,
            redtailFirmId: 0,
            reps: [],
            users: null
        };

        this.wizard = null;
        this.config = null;
        this.reps = [];
        this.redtailUsers = {};
        this.startText = "This wizard will guide you through the steps to setup your integration with Redtail CRM.";

        //#region private functions
        //#region wizard and dialog functions

        function cancel() {
            $log.info('Cancelling Redtail CRM integration settings editor');
            closeWizard();
        }

        function closeWizard() {
            if (typeof vm.close === "function") {
                vm.close();
            }
        }

        function setButtonSaveOrNext() {
            getCommonSettingsChanged( );
            settingsChanged();
            if (commonSettingsChanged || appSettingsChanged) {
                return "Save";
            }

            if (!commonSettingsChanged && !appSettingsChanged) {
                return "Next";
            }
        }

        function setCommonSettingsChanged( ifChangesMade ) {
            commonSettingsChanged = ifChangesMade;
        }

        // function updateCommonSettings( latestAppRoles, latestPartnerApp ) {
        //     var appRolesChanged = latestAppRoles === null || !angular.equals( vm.appRoles, latestAppRoles );
        //     var partnerAppChanged = latestPartnerApp === null || !angular.equals( vm.partnerApp, latestPartnerApp );
        //
        //     commonSettingsChanged = appRolesChanged && partnerAppChanged;
        // }

        //#endregion wizard and dialog functions

        //#region settings not customized for Redtail

        function getCommonSettingsChanged( ) {
            commonSettingsChanged = redtailService.commonSettingsChanged();
            return commonSettingsChanged;
        }

        //#endregion settings not customized for Redtail

        //#region settings customized for Redtail

        function getSettings(ifRefresh) {
            return redtailService.getSettings(ifRefresh);
        }

        function saveChanges(saveData) {
            $log.info('Saving changes to Redtail CRM integration...');
            var promiseArray = saveData.promiseArray;
            vm.wizard = saveData.wizard;
            if (typeof promiseArray !== "undefined" && promiseArray.length) {
                return $q.all(promiseArray)
                    .then(function(responses) {
                        vm.wizard.saving = false;
                        $log.info('redtailWizard - saveChanges? ' + vm.wizard.saving);
                        $log.info('Finished saving Redtail CRM integration settings...');

                        // Get the responses that aren't null or just true.
                        // Looking for the appRoles, partnerApp and config.
                        responses.forEach(function(element) {
                            if (typeof element !== "undefined" && element !== null) {
                                if (element.appRoles) {
                                    vm.appRoles = element.appRoles;
                                }

                                if (element.partnerApp) {
                                    vm.partnerApp = element.partnerApp;
                                }

                                if (element.config) {
                                    vm.config = element.config;
                                }
                            }
                        });

                        $log.info('Redtail CRM integration wizard changes saved.');
                    });
                    
            } else {
                return null;
            }
        }

        function settingsChanged () {
            appSettingsChanged = redtailService.settingsChanged();
            return appSettingsChanged;
        }

        function updateSettings (newSettings) {
            return redtailService.updateSettings(newSettings);
        }

        function updateLatestSettings (currentSettings) {
            return redtailService.updateLatestSettings(currentSettings);
        }

        //#endregion settings customized for Redtail

        //#endregion private functions

        //#region public interface

        /**
         * Cancels the wizard without saving any changes.
         */
        this.cancel = function () {
            cancel();
        };

        /**
         * Returns true if the user can move forward from the current page;
         * returns false if something remains undone that would prevent moving to the next page.
         * @returns {boolean}
         */
        this.canGoForward = function() {
            return true;
        };

        /**
         * Cancels the wizard without saving any changes.
         */
        this.close = function () {
            closeWizard();
        };

        /**
         * Returns true if settings have been changed that aren't managed by this wizard component.
         * For example, application privileges and roles, and accepted terms of service.
         * @returns {boolean}
         */
        this.commonSettingsChanged = function( ){
            return commonSettingsChanged;
        };

        /**
         * Saves changes to the Redtail integration settings and closes the wizard.
         */
        this.finish = function() {
            return saveChanges().then(function() {
                if (!!vm.wizard) {
                    vm.wizard.setComplete(true);
                }
                closeWizard();
            });
        };

        this.getCurrentSettings = function() {
            return currentSettings;
        };

        this.getStoredSettings = function() {
            return angular.copy(storedSettings);
        };

        this.getSettings = function(ifRefresh) {
            return getSettings(ifRefresh);
        };

        /**
         * Saves changes made in the Redtail integration settings.
         */
        this.saveChanges = function(saveData) {
            return saveChanges(saveData);
        };

        this.settingsChanged = function() {
            return appSettingsChanged();
        };

        this.setCommonSettingsChanged = function( ifChangesMade ) {
            setCommonSettingsChanged( ifChangesMade );
        };

        this.showButtonSave = function() {
            return setButtonSaveOrNext();
        };

        // this.updateCommonSettings = function( latestAppRoles, latestPartnerApp ) {
        //     return updateCommonSettings( latestAppRoles, latestPartnerApp );
        // }

        this.updateSettings = function(newSettings) {
            return updateSettings(newSettings);
        };

        this.updateLatestSettings = function(currentSettings) {
            return updateLatestSettings(currentSettings);
        };

        //#endregion settings customized for Redtail

        /**
         * Shows the key and state in the console log.
         * @param key - The key of the logged item.
         * @param state - The state of the logged item.
         */
        this.show = function(key, state) {
            var logLine = 'redtailWizard show: ';
            $log.info(logLine + key);
            $log.info(logLine + state);
        };

        this.$onInit = function() {
            $log.info(vm.appRoles);
            $log.info(vm.canUpdate);
            $log.info(vm.partnerApp);

            storedCommonSettings = {
                appRoles: angular.copy(vm.appRoles),
                partnerApp: angular.copy(vm.partnerApp)
            };
        };

        //#endregion public interface
    },
    controllerAs: 'vm',
    templateUrl: "tools/integrations/apps/redtail_IC/redtailWizard.html",
    transclude: true
});

'use strict';

app.directive('riskalyzeaddform', ['API_CONFIG', '$dialog', '$partnerAppService', '$oasRights', function (API_CONFIG, $dialog, $partnerAppService, $oasRights) {
    var outAttrName = 'href';
    var setupServiceUrl = '/Integrations/RiskAlyze/Setup';
    var removeServiceUrl = '/Integrations/RiskAlyze/Remove';

    return {
        link: function(scope, element, attrs) {
            // Can this value come from the RouteUrl property of the App object?
            var newValue = '/integration.html?r=' + API_CONFIG.baseUrl + '/Integrations/RiskAlyze/Redirect%3FAuthorization=' + sessionStorage.oas_token;

            scope.shareFileApp = scope.current.partnerApp;
            attrs.$set(outAttrName, newValue);
            element.prop(outAttrName, attrs[outAttrName]);

            // When the button is clicked, mark me as installed/uninstalled.
            element.on('click', 'button', function() {
                switch (this.id) {
                    case 'installRiskAlyze':
                        // Install the connection to Nitrogen - both Admins and Advisors should be able to do this.
                        if (!scope.shareFileApp.acceptedTOS) {
                            scope.warnTosNotAccepted('Nitrogen');
                        } else {
                            return $partnerAppService.setupServiceForPartnerApp(scope.shareFileApp, setupServiceUrl)
                                .then(function (data) {
                                    scope.shareFileApp.installed = true;
                                }, function(errorResponse) {
                                    if (errorResponse && errorResponse.data) {
                                        $dialog.actionFailed(errorResponse.data.userException.detail).open();
                                    } else {
                                        $dialog.actionFailed('There was an error setting up Nitrogen.').open();
                                    }
                                });
                        }
                        break;

                    case 'removeRiskAlyze':
                        // Remove the connection to Nitrogen - both Admins and Advisors should be able to do this.
                        $partnerAppService.removeService( removeServiceUrl )
                            .then(function (data) {
                                scope.shareFileApp.installed = false;
                            }, function (errorResponse) {
                                if (errorResponse && errorResponse.data) {
                                    if ( !errorResponse.data.userException ) {
                                        $dialog.actionFailed(errorResponse.data).open();
                                    } else {
                                        $dialog.actionFailed(errorResponse.data.userException.detail).open();
                                    }
                                } else {
                                    $dialog.actionFailed('There was an error removing Nitrogen.').open();
                                }
                            });
                        break;
                }
            });
        },
        priority: 99,
        restrict: 'E',
        replace: true,
        templateUrl: 'tools/integrations/apps/riskalyze/riskalyzeAddForm.html',
        terminal: true,
        scope: {
            current: '='
        }
    };
}]);
(function() {
    app.directive('schwabTerms', ['$partnerAppService', '$q', function($partnerAppService, $q) {
        return {
            restrict: 'E',
            replace: true,
            require: '^oasXsWizardPage',
            templateUrl: 'tools/integrations/apps/schwab/schwabTerms.html',
            scope: {
                partnerApp: '='
            },
            link: function(scope, element, attr, oasXsWizardPage) {
                function saveTerms() {
                    scope.partnerApp.installed = scope.partnerApp.acceptedTOS;
                    if (scope.partnerApp.acceptedTOS === true) {
                        return $partnerAppService.acceptTermsOfService( scope.partnerApp.id, scope.partnerApp.acceptedTOS );
                    }

                    return scope.partnerApp;
                }

                scope.saveChanges = function() {
                    return $q.when(saveTerms());
                };

                // If this is hosted by a wizard page, register any handlers with the page.
                if ( !!oasXsWizardPage ) {
                    oasXsWizardPage.register({
                        onSave: function() {
                            scope.saveChanges();
                        }
                    });
                }
            }
        };
    }]);
}());

(function() {
    app.controller('SchwabWizardCtrl', ['$scope', '$q', '$log', 
    function($scope, $q, $log){
        var vm = this;
        // Make copies of data objects to edit.
        vm.appRoles = angular.copy($scope.current.appRoles);
        vm.canUpdate = angular.copy($scope.current.canUpdate);
        vm.partnerApp = angular.copy($scope.current.partnerApp);

        function close(dataResult) {
            if ($scope.dialog !== null) {
                $scope.dialog.close(dataResult);
            } else {
                $scope.$parent.close(dataResult);
            }
        }

        function saveChanges() {
            $log.log('Saving changes in ' + vm.partnerApp.productName + ' integration wizard...');
            // Let each wizard page save its contents.
            var savePromises = $scope.save();
            // Wait for the promises to finish, or continue if no promises exist.
            if (savePromises.length) {
                return $q.all(savePromises).then(function(responses) {
                    return {
                        appRoles: vm.appRoles,
                        canUpdate: vm.canUpdate,
                        partnerApp: vm.partnerApp
                    };
                });
            } else {
                return null;
            }
        }

        vm.cancel = function () {
            $log.log('Cancelling ' + vm.partnerApp.productName + ' integration wizard');
            return close(null);
        };

        vm.finish = function() {
            return saveChanges().then(function(savedDataObj) {
                $scope.isComplete = true;
                return close(savedDataObj);
            });
        };

        vm.setAcceptance = function (flag) {
            var accepted = !!flag ? true : false;
            $scope.dataObj.partnerApp.acceptedTOS = accepted;
            $scope.isValid = accepted;
            $scope.canExit = accepted;
            $scope.canSave = accepted;
        };

        vm.show = function(key, state) {
            $log.log(key); 
            $log.log(state);
        };

        vm.saveChanges = function() {
            return saveChanges();
        };

        // Hooks between vm HTML attributes, like back/next/finish, and wizard directive        
        // Hooks in directive HTML attributes.
        $scope.onCancel = function() {
            return close(null);
        };

        vm.canGoForward = function() {
            var enableNext = false;
            if ( !!vm.partnerApp && vm.partnerApp.acceptedTOS != null ) {
                enableNext = vm.partnerApp.acceptedTOS;
            }

            return enableNext && $scope.isLast();
        };

        $scope.cancel = function() {
            vm.cancel();
        };

        $scope.finish = function() {
            vm.finish();
        };

        // Placeholder functions - can be provided by child wizard directive
        $scope.nextPage = function() {};
        $scope.prevPage = function() {};
        $scope.save = function() {};
        $scope.isLast = function() {};
    }]);

    app.directive('schwabWizard', function () {
        return {
            controller: 'SchwabWizardCtrl',
            controllerAs: 'vm',
            bindToController: true,
            restrict: 'E',
            transclude: true,
            templateUrl: "tools/integrations/apps/schwab/schwabWizard.html"
        };
    });
}());

'use strict';

app.component('schwabFinished', {
    bindings: {
        partnerApp: '<',
        appRoles: '<'
    },
    controller: function(){
        var vm = this;
        this.$onInit = function() {
            // If this is hosted by a wizard page, register any handlers with the page.
            if ( !!vm.wizardPage ) {
                vm.wizardPage.register({
                    canEnter: function() {
                        return true;
                    },
                    canExit: function() {
                        return true;
                    },
                    isValid: function() { return true; },
                    isVisited: function() { return true; } //,
                    // onNext: function() {
                    //     var partnerApp = vm.partnerApp;
                    //     partnerApp.installed = partnerApp.acceptedTOS;
                    // },
                    // onSave: function() {
                    //     vm.saveChanges();
                    // }
                });
            }
        };
    },
    controllerAs: 'vm',
    require: {
        wizardPage: '^^icWizardPage'
    },
    templateUrl: 'tools/integrations/apps/schwab_IC/schwabFinished.html',
    transclude: true
});

'use strict';

app.component('schwabTermsIc', {
    bindings: {
        partnerApp: '<',
    },
    controller: function($partnerAppService, $q){
        var vm = this;
        function saveTerms() {
            vm.partnerApp.installed = vm.partnerApp.acceptedTOS;
            if (vm.partnerApp.acceptedTOS === true) {
                return $partnerAppService.acceptTermsOfService( vm.partnerApp.id, vm.partnerApp.acceptedTOS );
            }

            return vm.partnerApp;
        }

        this.saveChanges = function() {
            return $q.when(saveTerms());
        };

        this.$onInit = function() {
            // If this is hosted by a wizard page, register any handlers with the page.
            if ( !!vm.wizardPage ) {
                vm.wizardPage.register({
                    canEnter: function() {
                        return true;
                    },
                    canExit: function() {
                        return true;
                    },
                    isValid: function() { return true; },
                    isVisited: function() { return true; },
                    onNext: function() {
                        var partnerApp = vm.partnerApp;
                        partnerApp.installed = partnerApp.acceptedTOS;
                    },
                    onSave: function() {
                        vm.saveChanges();
                    }
                });
            }
        };
    },
    controllerAs: 'vm',
    require: {
        wizardPage: '^^icWizardPage'
    },
    templateUrl: 'tools/integrations/apps/schwab_IC/schwabTerms.html',
    transclude: true
});

'use strict';

app.component('schwabWizardIc', {
    bindings: {
        appRoles: "<",
        cancel: "<",
        canUpdate: "<",
        close: "<",
        onCancel: "<",
        partnerApp: "<"
    },
    controller: function($log, $q) {
        var vm = this;
        this.wizard = null;
        this.startText = "This wizard will guide you through the steps to setup your integration with Schwab OpenView.";

        function cancel() {
            $log.info('Cancelling Schwab OpenView integration settings editor');
            closeWizard();
        }

        function closeWizard() {
            if (typeof vm.close === "function") {
                vm.close();
            }
        }

        function saveChanges(saveData) {
            $log.info('Saving changes to Schwab OpenView integration...');
            // Call each page for its save function, if it has one.
            var promiseArray = saveData.promiseArray;
            var wizard = saveData.wizard;
            if (typeof promiseArray !== "undefined" && promiseArray.length) {
                return $q.all(promiseArray)
                    .then(function(responses) {
                        wizard.saving = false;
                        $log.info('schwabWizard - saveChanges? ' + wizard.saving);
                        $log.info('Finished saving Schwab OpenView integration settings...');

                        // Get the responses that aren't null or just true.
                        // Looking for the appRoles, partnerApp and config.
                        responses.forEach(function(element) {
                            if (element !== null) {
                                if (element.appRoles) {
                                    vm.appRoles = element.appRoles;
                                }

                                if (element.partnerApp) {
                                    vm.partnerApp = element.partnerApp;
                                }

                                if (element.config) {
                                    vm.config = element.config;
                                }
                            }
                        });

                        $log.info('Schwab OpenView integration wizard changes saved.');
                    });

            } else {
                return deferred.resolve(null);
            }
        }

        /**
         * Cancels the wizard without saving any changes.
         */
        this.cancel = function () {
            cancel();
        };

        /**
         * Returns true if the user can move forward from the current page;
         * returns false if something remains undone that would prevent moving to the next page.
         * @returns {boolean}
         */
        this.canGoForward = function() {
            return (!!vm.partnerApp && vm.partnerApp.acceptedTOS === true);
        };

        /**
         * Cancels the wizard without saving any changes.
         */
        this.close = function () {
            closeWizard();
        };

        /**
         * Saves changes to the Schwab OpenView integration settings and closes the wizard.
         */
        this.finish = function() {
            return saveChanges().then(function() {
                if (!!vm.wizard) {
                    vm.wizard.setComplete(true);
                }
                closeWizard();
            });
        };

        /**
         * Shows the key and state in the console log.
         * @param key - The key of the logged item.
         * @param state - The state of the logged item.
         */
        this.show = function(key, state) {
            var logLine = 'schwabWizard2 show: ';
            $log.info(logLine + key);
            $log.info(logLine + state);
        };

        /**
         * Saves changes made in the Schwab OpenView integration settings.
         */
        this.saveChanges = function(saveData) {
            saveChanges(saveData);
        };

        this.$onInit = function() {
            var logLine = 'schwabWizard2 init: ';
            $log.info(logLine + vm.appRoles);
            $log.info(logLine + vm.canUpdate);
            $log.info(logLine + vm.partnerApp);
        };
    },
    controllerAs: 'vm',
    templateUrl: "tools/integrations/apps/schwab_IC/schwabWizard2.html",
    transclude: true
});

'use strict';

app.controller('shareFileAddFormCtrl', ['$scope', '$partnerAppService', function($scope, $partnerAppService) {
    var self = this;

    var uninstallUrl = '/Integrations/ShareFile/Remove',
        installUrl = '/Integrations/ShareFile/Setup';

    $scope.shareFileApp = $scope.current.partnerApp;

    self.installShareFile = function () {
        $scope.shareFileApp.acceptedTOS = true;
        return $partnerAppService.setupServiceForPartnerApp($scope.shareFileApp, installUrl)
            .then(function(response) {
            $scope.shareFileApp.installed = true;
        });
    };

    self.uninstallShareFile = function() {
        return $partnerAppService.removeService(uninstallUrl, $scope.shareFileApp.id).then(function(response) {
        });
    };

}]);

app.directive('shareFileAddForm', [function() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'tools/integrations/apps/sharefile/shareFileAddForm.html',
        controller: 'shareFileAddFormCtrl',
        controllerAs: 'formCtrl',
        scope: {
            current: '='
        }
    };
}]);
'use strict';

var wealthAccessAddFormCtrl = function($scope, $partnerAppService, $dialog) {

    var setupServiceUrl = '/Integrations/WealthAccess/Setup';
    var removeServiceUrl = '/Integrations/WealthAccess/Remove';

    var self = this;
    $scope.wealthAccessApp = $scope.current.partnerApp;

    $scope.wealthAccessApp.wealthAccessConfig = {
        externalUserId: null
    };

    function showError( errorResponse ) {
        if ( errorResponse && errorResponse.data ) {
            $dialog.actionFailed( errorResponse.data.userException.detail );
        } else {
            $dialog.actionFailed('There was an error setting up WealthAccess.');
        }
    }

    function setConfiguration(response) {
        $scope.wealthAccessApp.configuration = response.data;
        $scope.wealthAccessApp.installed = true;
        return response;
    }

    self.installWealthAccess = function() {
        var promise = $partnerAppService.setupServiceForPartnerApp($scope.wealthAccessApp, setupServiceUrl)
            .then(function (response) {
                return response;
            }, showError);

        return promise.then(setConfiguration);
    };

    self.updateWealthAccessConfiguration = function() {
        var isSavingConfiguration = true;

        var promise = $partnerAppService.updatePartnerAppSettings($scope.wealthAccessApp.partnerName,  $scope.wealthAccessApp.configuration)
            .then(function (response) {
                isSavingConfiguration = false;
                return response;
            }, showError);

        return promise.then(setConfiguration);
    };

    self.uninstallWealthAccess = function() {
        return $partnerAppService.removeService(removeServiceUrl, $scope.wealthAccessApp.id).then(function() {
            $scope.wealthAccessApp.installed = false;
        }, showError);
    };
};

wealthAccessAddFormCtrl.$inject = ['$scope', '$partnerAppService', '$dialog'];
app.controller('wealthAccessAddFormCtrl',wealthAccessAddFormCtrl);

var wealthAccessAddForm = function() {
    return {
        replace: true,
        restrict: 'E',
        templateUrl: 'tools/integrations/apps/wealthAccess/wealthAccessAddForm.html',
        controller: 'wealthAccessAddFormCtrl',
        controllerAs: 'wealthAccess',
        scope: {
            current: '='
        }
    };
};

app.directive('wealthAccessAddForm', wealthAccessAddForm);
'use strict';

var ALLOWED_ORION_HOME_PAGE_HOST_SUFFIXES = ['orionadvisor.com', 'orionadvisor.net'];

function isAllowedOrionHomePageHost(hostname) {
    if (!hostname) {
        return false;
    }

    hostname = hostname.toLowerCase();
    return ALLOWED_ORION_HOME_PAGE_HOST_SUFFIXES.some(function (suffix) {
        return hostname === suffix || hostname.endsWith('.' + suffix);
    });
}

function isOrionInternalHomePageUrl(url) {
    var parsedUrl;

    try {
        parsedUrl = new URL(url, window.location.origin);
    } catch (e) {
        return false;
    }

    if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
        return false;
    }

    return isAllowedOrionHomePageHost(parsedUrl.hostname);
}

app.component('icItem', {
    bindings: {
        canEdit: '@',
        canRead: '@',
        canUpdate: '@',
        editSettings: "@",
        showAll: '@',
        partnerApp: '<'
    },
    controller: function($oasRights, $window) {
        var ici = this;
        this.partnerApp = null;
        this.selectedPartnerApp = null;
        this.parentList = null;
        this.canUpdate = false;
        this.showAll = false;

        this.hasInfoLink = false;
        this.hasExternalInfoLink = false;
        this.learnMorePath = null;

        //#region private functions

        function setInfoLinkFlags() {
            ici.hasInfoLink = false;
            if (ici.partnerApp.homePageURL) {
                ici.hasInfoLink = true;
            }

            ici.hasExternalInfoLink = ici.hasInfoLink && !isOrionInternalHomePageUrl(ici.partnerApp.homePageURL);
        }

        //#endregion private functions

        //#region public functions

        this.getSelectedPartnerApp = function( partnerAppId ) {
            ici.parentList.getSelectedPartnerApp(partnerAppId);
        };

        this.openAppDetails =  function ( productName, viewUrl ) {
            ici.parentList.openAppDetails(productName, viewUrl);
        };

        this.openIntegrationSetup = function (partnerAppId, isInstalled, acceptedTerms){
            ici.parentList.openIntegrationSetup(partnerAppId, isInstalled, acceptedTerms);
        };

        /**
         * Opens Orion Support article via OrionConnect `sso.html` support flow.
         * This ultimately calls the existing CommunitySAML endpoint with relaystate.
         */
        this.openSupportLearnMore = function () {
            if (!ici.learnMorePath || !sessionStorage.oas_token) {
                return;
            }

            var ssoUrl =
                '/orionconnectapp/sso.html' +
                '?s=support' +
                '&p=' + encodeURIComponent(ici.learnMorePath) +
                '&t=' + encodeURIComponent(sessionStorage.oas_token);

            $window.open(ssoUrl, '_blank', 'noopener');
        };

        this.showSalesforce = function( id ){
            if(id === 1640 && $oasRights.canRead('SFSYNCSETUP') ){
                return true;
            }
            return false;
        };

        this.openSalesforceSetup = function(){
            $window.location.href = window.location.protocol + "//" + window.location.host + "/orionconnectapp/index.html#/integrations/salesforce/setup";
        }

        //#endregion partnerApp property shortcuts.

        this.$onInit = function() {
            ici.showAll = ici.parentList.showAll;
            ici.parentList.addItem(ici);
            if (ici.partnerApp) {
                ici.learnMorePath = ici.partnerApp.learnMorePath || null;
            }
            setInfoLinkFlags();
        };

        this.$onChanges = function(changes) {
            if (changes.partnerApp && changes.partnerApp.currentValue) {
                ici.learnMorePath = changes.partnerApp.currentValue.learnMorePath || null;
                setInfoLinkFlags();
            }
        };

        this.app = function() {
            return ici.partnerApp;
        };

        //#endregion public functions
    },
    controllerAs: 'ici',
    require: {
        parentList: '^integrationCenter',
    },
    templateUrl: 'tools/integrations/integrationCenter/icItem.html',
    transclude: true
});

'use strict';

app.component('integrationCenter', {
    bindings: {
        canEdit: '@',
        canRead: '@',
        canUpdate: '@',
        getFilters: '<',
        showAll: '@'
    },
    controller: function ($dialog, $q, integrationCenterService, IcServiceService, $scope) {
        // Used to reference controller in the view.
        var ic = this;
        var defaultFilters = {
            type: false,
            feature: false,
            point: false,
            search: null,
            installedOnly: false
        };
        // Filters on the list of partner apps.
        this.filters = angular.copy( defaultFilters );
        this.partnerApps = [];
        this.featuredApps = [];
        this.newApps = [];
        this.normalApps = [];
        var selectedApp = integrationCenterService.selectedPartnerApp;
        var items = [];
        this.showRightSidebar = true;

        $scope.rightSidebar = {exists: true, width: 300, isOpen: true};
        $scope.leftSidebar = {exists: false, width: 250, isOpen: true};

        // Partner App IDs that use ic-wizard (newer)
        var icWizardAppIds = [1008, 1603, 1629];
        // Partner App IDs that use oas-xs-wizard
        var oasXsWizardAppIds = [1057, 1639, 1643, 1663, 1684, 2172];

        //#region private methods
        function init() {
            ic.filters = integrationCenterService.getAppFilters();
            integrationCenterService.getFilterableAppData()
                .then(function(data) {
                    ic.canEdit = data.canEdit;
                    ic.canRead = data.canRead;
                    ic.integrationFeatures = data.integrationFeatures;
                    ic.integrationPoints = data.integrationPoints;
                    ic.integrationTypes = data.integrationTypes;
                    ic.partnerApps = data.partnerApps;
                    ic.featuredApps = data.partnerApps.filter(function(element){
                        return element.featured === true;
                    });
                    ic.newApps = data.partnerApps.filter(function(element){
                        return element.new === true;
                    });
                    ic.normalApps = data.partnerApps.filter(function(element){
                        return !element.featured && !element.new;
                    });
                });
        }

        function getSelectedPartnerApp( partnerAppId ) {
            return integrationCenterService.getSimpleAppPlus( partnerAppId )
                .then(function(data){
                    selectedApp = integrationCenterService.selectedPartnerApp;
                },function() {
                    selectedApp = [];
                });
        }

        function openIntegrationDialog(partnerAppId, isInstalled, acceptedTOS) {
            var editorTemplate = '<integration-editor></integration-editor>';
            if (icWizardAppIds.indexOf( partnerAppId ) >= 0) {
                return $dialog.dialog({
                    controller: 'IntegrationCenterEditorCtrl',
                    dialogClass: "modal wide",
                    dataObj: {
                        appRoles: ic.appRoles,
                        canUpdate: ic.canUpdate,
                        partnerApp: selectedApp
                    },
                    resolve: {
                        appRoles: function() {
                            return ic.appRoles;
                        },
                        canUpdate: function() {
                            return ic.canUpdate;
                        },
                        partnerApp: function() {
                            return selectedApp;
                        }
                    },
                    template: '<integration-center-editor class="resize-setter"></integration-center-editor>'
                })
                .open()
                .then(function(savedDataObj) {
                    if (!!savedDataObj && !!savedDataObj.partnerApp) {
                        return updateSelectedPartnerApp(savedDataObj.partnerApp)
                            .then(function(newApp) {
                                init();
                            });
                    } else {
                        return null;
                    }
                });
            } else if (oasXsWizardAppIds.indexOf(partnerAppId) >= 0) {
                if (isInstalled == false && partnerAppId == 2172) {   //saml self service to check for user authorized signer against user logged in email
                    IcServiceService.checkAuthorization().then(isAuthorized => {
                        if (isAuthorized) return openDialogIntgrationEditor();
                        else 
                            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i>" + ' Not Authorized Signer', 'Please reach out to Firm Authorized signer.').open();
                    });
                } else return openDialogIntgrationEditor(); 
            } else {
                return $dialog.dialog({
                    canUpdate: ic.canUpdate,
                    controller: 'AddPartnerAppCtrl',
                    dialogClass: "modal wide",
                    partnerApp: selectedApp,
                    template: '<partner-apps></partner-apps>'
                })
                    .open()
                    .then(function() {
                        var x = ic.partnerApps.find(function(item) {
                            return item.id === partnerAppId;
                        });

                        if (x !== null) {
                            x.installed = selectedApp.installed;
                        }
                    });
            }
        }

         function openDialogIntgrationEditor() {
            var editorTemplate = '<integration-editor></integration-editor>';
            return $dialog.dialog({
                controller: 'IntegrationEditorCtrl',
                dialogClass: "modal wide",
                dataObj: {
                    appRoles: ic.appRoles,
                    canUpdate: ic.canUpdate,
                    partnerApp: selectedApp
                },
                resolve: {
                    appRoles: function () {
                        return ic.appRoles;
                    },
                    canUpdate: function () {
                        return ic.canUpdate;
                    },
                    partnerApp: function () {
                        return selectedApp;
                    }
                },
                template: editorTemplate //integrationEditor is wizard container
            })
                .open()
                .then(function (savedDataObj) {
                    if (!!savedDataObj && !!savedDataObj.partnerApp) {
                        return updateSelectedPartnerApp(savedDataObj.partnerApp)
                            .then(function (newApp) {
                                init();
                            });
                    } else {
                        return null;
                    }
                });
        }

        function setupIntegrationDialog(partnerAppId, isInstalled, acceptedTOS) {
            ic.appRoles = {roles: []};
            if (selectedApp.privilegeId) {
                return integrationCenterService.getRolesForApp(selectedApp.privilegeId)
                    .then(function (appRoles) {
                        ic.appRoles = appRoles;
                        return openIntegrationDialog(partnerAppId, isInstalled, acceptedTOS);
                    });
            } else {
                return openIntegrationDialog(partnerAppId, isInstalled, acceptedTOS);
            }
        }

        function updateSelectedPartnerApp(updatedApp) {
            return $q.when(function(updatedApp) {
                if (updatedApp) {
                    var index = ic.partnerApps.findIndex(function(item){
                        return item.id === updatedApp.id;
                    });
                    if (index >= 0) {
                        // Update the source partner app with changes.
                        selectedApp = angular.copy(updatedApp);
                        ic.partnerApps.splice(index, 1, updatedApp);
                        return updatedApp;
                    }
                } else {
                    return null;
                }
            });
        }

        //#endregion private methods

        //#region public methods

        /**
         * Pushes a new item into the partner app tile array
         * @param {any} newItem New icItem to insert into partner app tile array.
         */
        this.addItem = function(newItem) {
            items.push(newItem);
        };

        /**
         * Resets the partner app filters to the defaults.
         */
        this.clearAllFilters = function() {
            ic.filters = angular.copy( defaultFilters );
        };

        /**
         * Clears the search filter.
         */
        this.clearFilterSearch = function() {
            ic.filters.search = null;
        };

        /**
         * Sets the specified integration feature in the filter.
         * @param {any} name The name of an integration feature in the taxonomies list.
         */
        this.filterFeature = function(name){
            ic.filters.feature = name;
        };

        /**
         * Executes the filter on the partner app tiles list.
         * @param {any} v Input to the filter - in this case an item from the partner app tile array.
         * @returns {boolean} Filter flag indicating whether the item v should be retained (true) or filtered out (false).
         */
        this.filterIntegrations = function(v){
            var returnVal = true;
            if(ic.filters.search){
                if(v.productName.toLowerCase().search(ic.filters.search.toLowerCase()) === -1){
                    returnVal = false;
                }
            }

            if(ic.filters.installedOnly && !v.installed){
                returnVal = false;
            }

            var allow1 = false;
            var allow2 = false;
            var allow3 = false;
            var hasTaxonomies = false;
            if (v.taxonomies && v.taxonomies.length) { hasTaxonomies = true; }

            // Check for matching Type
            if(ic.filters.type && hasTaxonomies){
                v.taxonomies.forEach(function(term){
                    if(term.taxonomy === 'integration_type' && term.name === ic.filters.type){
                        allow1 = true;
                    }
                });

            } else if(ic.filters.type && !hasTaxonomies){
                allow1=false;
            } else {
                allow1=true;
            }


            //Check For Matching Feature
            if(ic.filters.feature && hasTaxonomies){
                v.taxonomies.forEach(function(term){
                    if(term.taxonomy === 'integration_feature' && term.name === ic.filters.feature){
                        allow2 = true;
                    }
                });
            }  else if(ic.filters.type && !hasTaxonomies){
                allow2=false;
            } else {
                allow2=true;
            }

            //Check For Matching Point
            if(ic.filters.point && hasTaxonomies){
                v.taxonomies.forEach(function(term){
                    if(term.taxonomy === 'integration_point' && term.name === ic.filters.point){
                        allow3 = true;
                    }
                });
            }  else if(ic.filters.type && !hasTaxonomies){
                allow3=false;
            } else {
                allow3=true;
            }

            if(!allow1 || !allow2 || !allow3){
                returnVal = false;
            }

            return returnVal;
        };

        /**
         * Sets the value of the integration point filter.
         * @param {any} name The name of an integration point in the taxonomies list.
         */
        this.filterPoint = function(name){
            ic.filters.point = name;
        };

        /**
         * Sets the value of the integration type filter.
         * @param {any} name The name of an integration type in the taxonomies list.
         */
        this.filterType = function(name){
            ic.filters.type = name;
        };

        /**
         * Gets the partner app from the list, matching the provided partner app ID.
         * @param {any} partnerAppId The ID to match in the partner app array.
         * @returns {*} The partner app found, or null if not found.
         */
        this.getPartnerApp = function(partnerAppId){
            var foundItems = ic.partnerApps.filter(function(item) {
                return item.id === partnerAppId;
            });

            if (foundItems.length > 0) {
                return foundItems[0];
            }

            return null;
        };

        /**
         * Launches a modal dialog to show documentation about a partner app from Orion Social.
         * @param {any} productName The name of the product to display in the title bar.
         * @param {any} viewUrl The URL to the content in Word Press.
         */
        this.openAppDetails = function ( productName, viewUrl ) {
            $dialog.dialog({
                controller: "WordPressViewCtrl",
                dialogClass: "modal wide",
                templateUrl: "app/modals/wordPressView.html",
                titleText: "Features for " + productName,
                viewUrl: viewUrl + '?m=noHeader&action=sso&t='+sessionStorage.oas_token
            }).open();
        };

        /**
         * Launches a modal dialog with the integration wizard for the specified partner app.
         * @param {any} partnerAppId The ID of the partner app.
         * @param {any} isInstalled Flag indicating whether the partner app is already installed for the firm.
         * @param {any} acceptedTOS Flag indicating whether the terms of service have been accepted.
         */
        this.openIntegrationSetup = function ( partnerAppId, isInstalled, acceptedTOS ){
            getSelectedPartnerApp( partnerAppId )
                .then(function( result ) {
                    if (selectedApp.productName === 'MoneyGuide') {
                        return integrationCenterService.getAppSettings( '/Integrations/MoneyGuidePro/Settings' )
                            .then( function(result) {
                                if ( result.data ) {
                                    selectedApp.settings = result.data;
                                    selectedApp.settings.customInstId = (selectedApp.settings.institutionId != 400);
                                }
                                return setupIntegrationDialog( partnerAppId, isInstalled, acceptedTOS );
                            });
                    } else {
                        return setupIntegrationDialog( partnerAppId, isInstalled, acceptedTOS );
                    }
                });
        };

        /**
         * Function called to start the component after the component tree controllers have been initialized by angularJS.
         */
        this.$onInit = function() {
            init();
        };

        //#endregion public methods
    },
    controllerAs: 'ic',
    replace: true,
    templateUrl: 'tools/integrations/integrationCenter/integrationCenter.html' ,
    transclude: true
});

/**
 * Service to manage integrations. Fetches and updates settings and configurations for partner apps managed by advisors and SME Integrations in the Integration Center in Orion Connect.
 * @param {*} $http AngularJS $http service.
 * @param {*} $rootScope AngularJS $rootScope service.
 * @param {*} $q AngularJS $q service.
 * @param {*} $filter AngularJS $filter service.
 * @param {*} $log AngularJS $log service.
 * @param {*} $oasRights Orion $oasRights object.
 * @param {*} API_CONFIG Orion API_CONFIG object.
 */
app.service('integrationCenterService', ['$http', '$rootScope', '$q', '$filter', '$log', '$oasRights', 'API_CONFIG', function ($http, $rootScope, $q, $filter, $log, $oasRights, API_CONFIG) {

    var self = this;
    this.dialogs = [];

    /*
    URL templates for common partner app endpoints.
    All urls should be in this object for easy troubleshooting and updating.
    Placeholders - at runtime, replace:
     -- [APPNAME] with the productName of the partner app;
     -- [APPID] with the partner app ID.
    */
    var urls = {
        getAppConfiguration: '/Integrations/[APPNAME]/Configuration',
        getAppData: '/Security/PartnerApps/Simple',
        getSimplePlusApp: '/Security/PartnerApps/[APPID]/SimplePlus',
        getAppDetails: API_CONFIG.icSocialUrl + 'wp-json/orion-social/v1/integrations'
    };

    // Check to see if the Orion Social URL varies, as it will in test, since
    // valid documents are only maintained in prod.
    var socialLinkVaries = API_CONFIG.socialUrl !== API_CONFIG.icSocialUrl;

    // The active filters on the partner apps list.
    var filters = {
        type: false,
        feature: false,
        point: false,
        search: null,
        installedOnly: false
    };

    // The array of partner apps with their filter properties added. This data combines the PartnerApps simple list from the API with the extended data managed in Orion Social.
    var filterableApps = [];
    // The types of integrations, managed in Orion Social.
    var integrationTypes = [];
    // The integration features, managed in Orion Social.
    var integrationFeatures = [];
    // The integration points, managed in Orion Social.
    var integrationPoints = [];

    self.apps = [];
    // The partner app currently selected for editing in the integration editor.
    self.selectedPartnerApp = null;
    self.serviceUserName = '';

    // Get user's permissions to work in the Integration Center.
    self.canRead = $oasRights.canRead('INTEGRATIONSSETUP');
    self.canEdit = $oasRights.canUpdate('INTEGRATIONSSETUP');
    // Set the firm ID and name for display in the UI.
    self.firmId = $rootScope.user.authorization.alClientId;
    self.firmName = $rootScope.user.authorization.alClientName;

    // The privilege and app roles for the selected partner app.
    var selectedAppRoles = null;
    // The privilege and app roles as edited in the integration editor.
    var latestSelectedAppRoles = null;

    //#region private methods

    /**
     * Calls the API to accept/reject the terms of service. (Deprecated)
     * @param {number} partnerAppId The ID of the partner app.
     * @param {bool} tosAccepted Flag indicating whether the user accepts the terms of service.
     * @returns {PromiseLike<T> | Promise<T>} A Promise returning the partner app data with the TOS acceptance set.
     */
    function acceptTermsOfService(partnerAppId, tosAccepted) {
        return $http.post("/Security/PartnerApps/" + partnerAppId + "/TermsOfService/" + tosAccepted, { trackerMsg: 'Saving Terms of Service' })
            .then(function (result) {
                var partnerApp = getLocalAppById(partnerAppId);
                partnerApp.acceptedTOS = tosAccepted;
                return result.data;
            });
    }

    /**
     * Adds partner app details from Orion Social to the filterable list of
     * partner apps data.
     * @param {*} appDetails The app details returned from Orion Social.
     */
    function addAppDetails(appDetails) {
        if (filterableApps.length === 0) {
            return;
        }

        appDetails.forEach(function (v) {
            var partnerApp = filterableApps.find(function (pa) {
                return pa.id && pa.id === v.integrationID;
            });
            
            if (!!partnerApp) {
                if (v.taxonomies) {
                    partnerApp.taxonomies = v.taxonomies;
                    partnerApp.featured = v.featured || false;
                    partnerApp.new = v.new || false;
                }

                if (v.description) {
                    partnerApp.productShortDescription = v.description;
                }

                partnerApp.icon = v.icon || null;

                var index = -1;
                if (!!v.pageLink && socialLinkVaries) {
                    index = v.pageLink.indexOf(API_CONFIG.icSocialUrl);
                }

                if (index >= 0) {
                    partnerApp.homePageURL = v.pageLink.replace(API_CONFIG.icSocialUrl, API_CONFIG.socialUrl);
                } else {
                    partnerApp.homePageURL = v.pageLink || null;
                }
            }
        });
    }

    /**
     * Checks whether the logged-in user is the type of entity permitted
     * to use the integration center.
     * @returns {boolean} True if the user has the required role and permissions.
     */
    function checkServiceUserRights() {
        return $rootScope.user.authorization.entity === 'Administrator' || $rootScope.user.authorization.entity === 'Advisor';
    }

    /**
     * Gets the configuration settings from the server for the partner app
     * with the specified name.
     * @param {string} partnerAppName The name of the partner app.
     * @returns {Promise<T>} A Promise returning either the data from the server, or a failure message.
     */
    function getAppConfiguration(partnerAppName) {
        return $http.get(
            getAppConfigurationUrl(partnerAppName),
            { trackerMsg: 'Loading jobs configuration' })
            .then(getAppConfigurationSuccessful)
            .catch(getAppConfigurationFailure);
    }

    function getAppConfigurationSuccessful(response) {
        return response.data;
    }

    function getAppConfigurationFailure(error) {
        var deferred = $q.defer();
        $log.error('There was an error retrieving partner app configuration from server.', error);
        deferred.reject('Error retrieving jobs configuration.');
        return deferred.promise;
    }

    /**
     * Returns the URL for the configuration data for the partner app
     * with the specified name.
     * @param {string} partnerAppName The name of the partner app.
     * @returns {string} The URL.
     */
    function getAppConfigurationUrl(partnerAppName) {
        return urls.getAppConfiguration.replace('[APPNAME]', partnerAppName);
    }

    function getAppData() {
        return $http.get(urls.getAppData,
            { trackerMsg: 'Loading partner apps' })
            .then(function (r) {
                self.apps = r.data;
                return r.data;
            });
    }

    function getAppDetails() {
        return $http.get(urls.getAppDetails,
            { trackerMsg: 'Loading partner app details' })
            .then(function (r) {
                self.apps = r.data;
                return r.data;
            });
    }

    function getAppFilters() {
        return filters;
    }

    function getAppSettings(getAppSettingsUrl) {
        return $http.get(
            API_CONFIG.baseUrl + getAppSettingsUrl,
            { trackerMsg: 'Linking partner app' }
        );
    }

    function getCurrentFirm() {
        return {
            firmId: $rootScope.user.authorization.alClientId,
            firmName: $rootScope.user.authorization.alClientName
        };
    }

    /**
     * Gets the filterable data of the partner apps from the API and from
     * Orion Social and returns it in one object tree.
     * @returns {Promise<T>} A Promise returning the results of merging the sources of partner app data.
     */
    function getFilterableApps() {
        return $q.all({
            appData: getAppData(),
            appDetails: getAppDetails()
        }).then(function (responses) {
            self.apps = angular.copy(responses.appData);
            filterableApps = angular.copy(responses.appData);
            var taxonomies = responses.appDetails.taxonomies;
            integrationFeatures = taxonomies.integration_feature;
            if (!taxonomies.integration_type) {
                integrationTypes = false;
            } else {
                integrationTypes = taxonomies.integration_type;
            }
            integrationPoints = taxonomies.integration_point;
            addAppDetails(responses.appDetails.results);
        });
    }

    function getFilterableData() {
        return {
            canEdit: self.canEdit,
            canRead: self.canRead,
            filters: filters,
            integrationFeatures: integrationFeatures,
            integrationPoints: integrationPoints,
            integrationTypes: integrationTypes,
            partnerApps: filterableApps
        };
    }

    function getLatestSelectedAppRoles() {
        return angular.copy(latestSelectedAppRoles);
    }

    function getLocalAppById(partnerAppId) {
        var item = null;
        var filteredApps = $filter('filter')(self.apps, { 'id': partnerAppId });
        if (filteredApps.length > 0) {
            item = filteredApps[0];
        }

        return item;
    }

    function getRolesForApp(privilegeId) {
        return $http.get(
            '/Integration/RolesForKey/' + privilegeId,
            { trackerMsg: 'Loading available roles for integration' }
        ).then(function (response) {
            var results = response.data;
            selectedAppRoles = results;
            $log.info('Roles: ', results);
            return results;
        });
    };

    function getSimpleAppPlus(partnerAppId) {
        return $http.get(
            getSimplePlusAppUrl(partnerAppId),
            { trackerMsg: 'Loading selected partner app' })
            .then(function (r) {
                self.selectedPartnerApp = r.data;
                return r.data;
            });
    }

    function getSimplePlusAppUrl(partnerAppId) {
        return urls.getSimplePlusApp.replace('[APPID]', partnerAppId);
    }

    function removeService(removeServiceUrl, partnerAppId) {
        return $http.post(
            API_CONFIG.baseUrl + removeServiceUrl,
            { trackerMsg: 'Removing partner app' })
            .then(function (r) {
                self.deleteSuccessful = r.data;
                updateLocalPartnerApp(partnerAppId, false, false);
                return r;
            });
    }

    function selectedAppRolesChanged() {
        return angular.equals(selectedAppRoles, latestSelectedAppRoles);
    }

    function setAppFilters(updatedFilters) {
        filters = updatedFilters;
    }

    function setupService(partnerAppId, productName, acceptedTOS, serviceSetupUrl) {
        return $http.post(
            API_CONFIG.baseUrl + serviceSetupUrl,
            { key: partnerAppId, productName: productName, termsAccepted: acceptedTOS },
            { trackerMsg: 'Linking partner app' })
            .then(function (r) {
                self.serviceUserName = r.data.userId;
                updateLocalPartnerApp(partnerAppId, true, true);
                return r;
            });
    }

    function updateLocalPartnerApp(partnerAppId, isInstalled, isAccepted) {
        var partnerApp = getLocalAppById(partnerAppId);
        if (partnerApp) {
            partnerApp.installed = isInstalled;
            partnerApp.acceptedTOS = isAccepted;
        }
    }

    function updateLatestAppRoles(editedAppRoles) {
        latestSelectedAppRoles = editedAppRoles;
    }

    function updatePrivilegeRoles(privRoles) {
        if (privRoles === null || privRoles.roles.length === 0) {
            return $q.when([]);
        }

        return $http.post(
            '/Integration/UpdateRoles',
            privRoles,
            { trackerMsg: 'Updating roles and privileges for partner app' }
        );
    }

    function updateServiceSettings(updatedSettingsUrl, updatedSettings) {
        return $http.put(
            API_CONFIG.baseUrl + updatedSettingsUrl,
            updatedSettings,
            { trackerMsg: 'Updating partner app settings' })
            .then(function (r) {
                return r;
            });
    }

    //#endregion private methods

    //#region public methods
    /**
     * Calls the API to accept/reject the terms of service. (Deprecated)
     * @param {number} partnerAppId The ID of the partner app.
     * @param {bool} tosAccepted Flag indicating whether the user accepts the terms of service.
     * @returns {bool} The TOS flag value after the update.
     */
    self.acceptTermsOfService = function (partnerAppId, tosAccepted) {
        return acceptTermsOfService(partnerAppId, tosAccepted);
    };

    /**
     * Adds a modal dialog to be managed by the service.
     * @param partnerAppId The ID of the selected partner app.
     * @param dialogInstance The instance of a modal dialog.
     */
    self.addDialog = function (partnerAppId, dialogInstance) {
        self.dialogs.push({ key: partnerAppId, item: dialogInstance });
    };

    /**
     * Fetches simple form of all partner apps from the API.
     * @returns {*} An array of partner app simple data.
     */
    self.getAppData = function () {
        return getAppData();
    };

    /**
     * Fetches a detailed form of all partner apps from Orion Social.
     * @returns {*} An array of partner app details.
     */
    self.getAppDetails = function () {
        return getAppDetails();
    };

    /**
     * Fetches the current set of filters for apps in the integration center.
     * @returns {*} A set of partner app filters.
     */
    self.getAppFilters = function () {
        return getAppFilters();
    };

    /**
     * Gets the settings for a specific partner app, from the provided OAS API endpoint URL.
     * @param {string} getAppSettingsUrl The URL to the settings endpoint for the partner app.
     * @returns {*} The settings for the partner app installation, or a default settings object if it is not installed.
     */
    self.getAppSettings = function (getAppSettingsUrl) {
        return getAppSettings(getAppSettingsUrl);
    };

    self.getCurrentFirm = function () {
        return getCurrentFirm();
    };

    /**
     * Gets the dialog for a specific partner app.
     * @param {number} partnerAppId The ID of the partner app.
     * @returns {*} The dialog found, or null if not found.
     */
    self.getDialogByKey = function (partnerAppId) {
        var foundItems = self.dialogs.one(function (e) {
            return e.partnerAppId === partnerAppId;
        });

        return (foundItems.length > 0) ? foundItems[0] : null;
    };

    /**
     * Gets the filterable list of partner apps.
     * @returns {*} An array of partner apps ready to be filtered and sorted
     */
    self.getFilterableAppData = function () {
        if (filterableApps.length > 0) {
            return $q.when(getFilterableData());
        }

        return getFilterableApps().then(function () {
            return getFilterableData();
        });
    };

    /**
     * Gets the latest version of the privilege and selected roles, as edited.
     * @returns {*} An object with the selected partner app's privilege and roles that are or may be granted the privilege.
     */
    self.getLatestSelectedAppRoles = function () {
        return getLatestSelectedAppRoles();
    };

    /**
     * Gets a partner app by its ID, selecting from the local array of partner apps.
     * @param {number} partnerAppId The unique ID of a partner app
     * @returns {*} The local copy of the properties of the partner app with the specified ID.
     */
    self.getLocalAppById = function (partnerAppId) {
        return getLocalAppById(partnerAppId);
    };

    /**
     * Get the roles for the partner app with the given appId.
     * @param {number} privilegeId the partner app's privilegeId.
     * @returns {Function} A promise to deliver the results of the service call.
     */
    self.getRolesForApp = function (privilegeId) {
        return getRolesForApp(privilegeId);
    };

    /**
     * Fetches a simple partner app from the API.
     * @param {number} partnerAppId The unique ID of a partner app
     * @returns {*} An object with extended properties of the partner app with the specified ID.
     */
    self.getSimpleAppPlus = function (partnerAppId) {
        return getSimpleAppPlus(partnerAppId);
    };

    /**
     * Removes a partner app installation.
     * @param {any} removeServiceUrl The API URL to remove the service.
     * @param {number} partnerAppId The unique ID of a partner app
     * @returns {*} True if the removal succeeded, false otherwise.
     */
    self.removeService = function (removeServiceUrl, partnerAppId) {
        if (checkServiceUserRights() === true) {
            return removeService(removeServiceUrl, partnerAppId);
        } else {
            return false;
        }
    };

    /**
     * Sets the current filters for the integration center's contents.
     * @param {*} updatedFilters The latest filters updated.
     */
    self.setAppFilters = function (updatedFilters) {
        setAppFilters(updatedFilters);
    };

    /**
     * Sets the installed flag on a local partner app object.
     * @param {number} partnerAppId The unique ID of a partner app
     * @param {boolean} isInstalled Flag indicating whether the partner app is installed.
     */
    self.setInstalled = function (partnerAppId, isInstalled) {
        var partnerApp = getLocalAppById(partnerAppId);
        if (partnerApp) {
            partnerApp.installed = isInstalled;
        }
    };

    /**
     * Sets the TOS accepted flag on a local partner app object.
     * @param {number} partnerAppId The unique ID of a partner app
     * @param {boolean} isAccepted Flag indicating whether the partner app Terms of Service have been accepted by the user.
     * @deprecated TOS acceptance is checked on the server at setup and update; if TOS were not accepted, the partner app
     * integration will be aborted. Avoid interrupting the client workflow with a separate TOS API call.
     */
    self.setTosAcceptance = function (partnerAppId, isAccepted) {
        var partnerApp = getLocalAppById(partnerAppId);
        if (partnerApp) {
            partnerApp.acceptedTOS = isAccepted;
        }
    };

    /**
     * Send a request to the API to set up a service.
     * @param {*} partnerApp The partner app to set up.
     * @param {string} serviceSetupUrl The API URL to install the service.
     * @returns {*} The configuration of the partner app, if the installation succeeded.
     */
    self.setupServiceForPartnerApp = function (partnerApp, serviceSetupUrl) {
        if (checkServiceUserRights() === true) {
            return setupService(partnerApp.id, partnerApp.productName, partnerApp.acceptedTOS, serviceSetupUrl);
        } else {
            return $q.reject(false);
        }
    };

    /**
     * Updates the general settings for a partner app or service at the specified endpoint.
     * @param {string} updatedSettingsUrl the URL of the update endpoint for the partner app.
     * @param {object} updatedSettings JSON object containing the updated settings (specific to each partner app)
     * @returns {*} Promise from the attempt to update the partner app setup.
     */
    self.updatePartnerAppSettingsByUrl = function (updatedSettingsUrl, updatedSettings) {
        return updateServiceSettings(updatedSettingsUrl, updatedSettings);
    };

    /**
     * Updates the general settings for a partner app or service at the specified endpoint.
     * @param {string} partnerAppName the partner app name.
     * @param {object} updatedSettings JSON object containing the updated settings (specific to each partner app)
     * @returns {*} Promise from the attempt to update the partner app setup.
     */
    self.updatePartnerAppSettings = function (partnerAppName, updatedSettings) {
        return updateServiceSettings(getAppConfigurationUrl(partnerAppName), updatedSettings);
    };

    /**
     * Updates the roles with the partner app's privilege.
     * @param {*} changedRoles the roles to which the user has assigned or removed the partner app's privilege.
     * @returns {Promise} A promise to return the changed roles as updated from the service call.
     */
    self.updatePrivilegeRoles = function (changedRoles) {
        return updatePrivilegeRoles(changedRoles);
    };

    /**
     * Updates the edited app roles with the latest edits made.
     * @param {*} editedAppRoles A copy of the privilege and the roles as changed.
     * @returns {*} The latest roles, with the new updates.
     */
    self.updateLatestAppRoles = function (editedAppRoles) {
        return updateLatestAppRoles(editedAppRoles);
    };

    /**
     * Gets the configuration for the partner app.
     * @param {string} partnerAppName the partner app name
     * @returns {Promise} returns a promise that resolves to with the data or an error message (as a string)
     */
    self.getConfiguration = function (partnerAppName) {
        if (!angular.isString(partnerAppName)) {
            return getAppConfigurationFailure('Partner app name was not a string.');
        }

        return getAppConfiguration(partnerAppName);
    };

    //#endregion public methods
}]);


app.controller('IntegrationCenterCtrl', function ($scope, $rootScope, $location, $dialog, $interval, $filter, $oasRights, integrationCenterService) {
    var vm = this;
    this.showAll = $rootScope.user.authorization.entity === 'Administrator';
    this.showRia = this.showAll || $rootScope.user.authorization.entity === 'Advisor' || $rootScope.user.authorization.entity == "Representative";
    this.canUpdate = this.showAll || this.showRia;
    //this.showLearnMoreModals = false; // if true, pops up WordPress content in a modal; else opens all in new tab.
    this.canRead = $oasRights.canRead('INTEGRATIONSSETUP');
    this.canEdit = $oasRights.canUpdate('INTEGRATIONSSETUP');

    // Private methods
    function init() {
        integrationCenterService.getAppData()
            .then(function() {
                vm.partnerApps = integrationCenterService.apps;
                vm.canRead = $oasRights.canRead('INTEGRATIONSSETUP');
                vm.canEdit = $oasRights.canUpdate('INTEGRATIONSSETUP');
            });
    }
    
    this.getPartnerApps = function() {
        return vm.partnerApps;
    };

    init();
});

'use strict';

app.controller('IntegrationCenterEditorCtrl', ['$scope', '$dialog', 'dialog', '$partnerAppService', '$q', '$log',
    function IntegrationEditorCtrl($scope, $dialog, dialog, $partnerAppService, $q, $log) {
        $scope.current = {
            appRoles: {},
            canUpdate: false,
            partnerApp: {}
        };

        $scope.original = {
            appRoles: {},
            canUpdate: false,
            partnerApp: {}
        };

        var options = dialog.options;
        $scope.dialog = dialog;
        $scope.dirtyRoles = [];
        $scope.appRoles = options.appRoles;

        var deferred = $q.defer();
        $scope.stepsPromise = deferred.promise;

        // Private methods
        function init() {
            $scope.original = dialog.options.dataObj;
            $scope.original.partnerApp.productNameLower = $scope.original.partnerApp.productName.toLowerCase();
            $scope.current = {
                appRoles: angular.copy($scope.original.appRoles),
                canUpdate: angular.copy($scope.original.canUpdate),
                partnerApp: angular.copy($scope.original.partnerApp)
            };
        }

        // Public functions
        angular.extend($scope, {
            cancel: function () {
                dialog.close(null);
            },

            close: function () {
                console.log('Closing');
                return dialog.close(null);
            },

            saveChanges: function () {
                dialog.close(function(results) {
                    $scope.original = {
                        appRoles: $scope.current.appRoles,
                        canUpdate: $scope.current.canUpdate,
                        partnerApp: $scope.current.partnerApp
                    };        
                });
            },

            setInstalled: function () {
                $scope.current.partnerApp.installed = true;
            },

            // Notify user if the TOS wasn't accepted.
            warnTosNotAccepted: function (productName) {
                $dialog.actionFailed('You must accept the Terms of Service before you can install ' + productName + '.').open();
            }
        });

        init();
    }]);

app.directive('integrationCenterEditor', [function() {
    return {
        bindToController: true,
        controllerAs: 'iced',
        templateUrl: "tools/integrations/integrationCenter/integrationCenterEditor.html",
        restrict: 'E'
    };
}]);

'use strict';
app.controller('IntegrationEditorCtrl', ['$scope', '$dialog', 'dialog', '$partnerAppService', '$q',
    function IntegrationEditorCtrl($scope, $dialog, dialog, $partnerAppService, $q) {
        $scope.current = {
            appRoles: {},
            canUpdate: false,
            partnerApp: {}
        };

        $scope.original = {
            appRoles: {},
            canUpdate: false,
            partnerApp: {}
        };

        var options = dialog.options;
        $scope.dialog = dialog;
        $scope.dirtyRoles = [];
        $scope.appRoles = options.appRoles;

        var deferred = $q.defer();
        $scope.stepsPromise = deferred.promise;

        // Private methods
        function init() {
            $scope.original = dialog.options.dataObj;
            $scope.original.partnerApp.productNameLower = $scope.original.partnerApp.productName.toLowerCase();
            $scope.current = {
                appRoles: angular.copy($scope.original.appRoles),
                canUpdate: angular.copy($scope.original.canUpdate),
                partnerApp: angular.copy($scope.original.partnerApp)
            };
        }

        // Public functions
        angular.extend($scope, {
            cancel: function () {
                dialog.close(null);
            },

            close: function () {
                return dialog.close(null);
            },

            saveChanges: function () {
                dialog.close(function(results) {
                    $scope.original = {
                        appRoles: $scope.current.appRoles,
                        canUpdate: $scope.current.canUpdate,
                        partnerApp: $scope.current.partnerApp
                    };        
                });
            },

            setInstalled: function () {
                $scope.current.partnerApp.installed = true;
            },

            // Notify user if the TOS wasn't accepted.
            warnTosNotAccepted: function (productName) {
                $dialog.actionFailed('You must accept the Terms of Service before you can install ' + productName + '.').open();
            }
        });

        init();
    }]);

app.directive('integrationEditor', [function() {
    return {
        bindToController: true,
        controllerAs: 'vm',
        templateUrl: "tools/integrations/partnerApps/integrationEditor.html",
        restrict: 'E'
    };
}]);

'use strict';
/**
 * Service to handle partner apps and integration setups or connections.
 * @param
 */
app.service('$partnerAppService', ['$http', '$rootScope', '$q', '$oasRights', '$filter', 'API_CONFIG', '$log',
    function($http, $rootScope, $q, $oasRights, $filter, API_CONFIG, $log) {
        var self = this;
        var urls = {
            getAppConfiguration: '/Integrations/[APPNAME]/Configuration',
            getAppData: '/Security/PartnerApps/Simple',
            getSimplePlusApp: '/Security/PartnerApps/[APPID]/SimplePlus',
            getAppDetails: API_CONFIG.socialUrl+'wp-json/orion-social/v1/integrations'
        };

        self.apps = [];
        self.selectedPartnerApp = null;
        self.serviceUserName = '';

        function acceptTermsOfService( partnerAppId, tosAccepted ) {
            return $http.post( "/Security/PartnerApps/" + partnerAppId + "/TermsOfService/" + tosAccepted, { trackerMsg: 'Saving Terms of Service'} )
                .then( function(result) {
                    return result.data;
                });
        }

        function checkServiceUserRights ( ) {
            return $rootScope.user.authorization.entity === 'Administrator' || $rootScope.user.authorization.entity === 'Advisor';
        }

        function getAppConfiguration(partnerAppName) {
            if(!angular.isString(partnerAppName)) {
                return ('Name was not a string: ', partnerAppName); 
            }
            return $http.get(
                getAppConfigurationUrl(partnerAppName),
                { trackerMsg: 'Loading jobs configuration' })
                .then(getAppConfigurationSuccessful)
                .catch(getAppConfigurationFailure);
        }

        function getAppConfigurationSuccessful(response) {
            return response.data;
        }

        function getAppConfigurationFailure(error) {
            var deferred = $q.defer();
            $log.error('There was an error retrieving partner app configuration from server.', error);
            deferred.reject('Error retrieving jobs configuration.');
            return deferred.promise;
        }

        function getAppConfigurationUrl(partnerAppName){
            return urls.getAppConfiguration.replace('[APPNAME]', partnerAppName);
        }

        function getAppData( ){
            return $http.get(urls.getAppData,
                {trackerMsg: 'Loading partner apps'})
                .then(function (r) {
                    self.apps = r.data;
                    return r.data;
                });
        }

        function getAppDetails(){
            return $http.get(urls.getAppDetails,
                {trackerMsg: 'Loading partner app details'})
                .then(function (r) {
                    self.apps = r.data;
                    return r.data;
                });
        }

        function getAppSettings( getAppSettingsUrl ){
            return $http.get(
                API_CONFIG.baseUrl + getAppSettingsUrl,
                { trackerMsg: 'Linking partner app' }
            );
        }

        function getLocalAppById ( partnerAppId ) {
            var item = null;
            var filteredApps = $filter('filter')(self.apps, {'id': partnerAppId });
            if (filteredApps.length > 0) {
                item = filteredApps[0];
            }

            return item;
        }

        function getRolesForApp( privilegeId ) {
            return $http.get(
                '/Integration/RolesForKey/' + privilegeId,
                { trackerMsg: 'Loading available roles for integration' }
            ).then(function(response) {
                var results = response.data;
                $log.info('Roles: ', results);
                return results;
            });
        };

        function getSimpleAppPlus ( partnerAppId ){
            return $http.get(
                getSimplePlusAppUrl(partnerAppId),
                {trackerMsg: 'Loading selected partner app'})
                .then(function (r) {
                    self.selectedPartnerApp = r.data;
                    return r.data;
                });
        }

        function getSimplePlusAppUrl(partnerAppId){
            return urls.getSimplePlusApp.replace('[APPID]', partnerAppId )
        }

        function removeService( removeServiceUrl, partnerAppId ) {
            return $http.post(
                API_CONFIG.baseUrl + removeServiceUrl,
                { trackerMsg: 'Removing partner app' } )
                .then(function (r) {
                    self.deleteSuccessful = r.data;
                    updateLocalPartnerApp(partnerAppId, false, false);
                    return r;
                });
        }

        function setupService ( partnerAppId, productName, acceptedTOS, serviceSetupUrl ) {
            return $http.post(
                API_CONFIG.baseUrl + serviceSetupUrl,
                {key: partnerAppId, productName: productName, termsAccepted: acceptedTOS},
                { trackerMsg: 'Linking partner app' } )
                .then(function (r) {
                    self.serviceUserName = r.data.userId;
                    updateLocalPartnerApp(partnerAppId, true, true);
                    return r;
                });
        }

        function updateLocalPartnerApp(partnerAppId, isInstalled, isAccepted) {
            var partnerApp = getLocalAppById(partnerAppId);
            if (partnerApp) {
                partnerApp.installed = isInstalled;
                partnerApp.acceptedTOS = isAccepted;
            }
        }

        function updatePrivilegeRoles( privRoles ) {
            if(privRoles === null || privRoles.roles.length === 0) {
                return $q.when([]);
            }

            return $http.post(
                '/Integration/UpdateRoles',
                privRoles,
                {trackerMsg: 'Updating roles and privileges for partner app'}
            );
        }

        function updateServiceSettings ( updatedSettingsUrl, updatedSettings ) {
            return $http.put(
                API_CONFIG.baseUrl + updatedSettingsUrl,
                updatedSettings,
                { trackerMsg: 'Updating partner app settings' } )
                .then(function (r) {
                    return r;
                });
        }


        /**
         * Calls the API to accept/reject the terms of service. (Deprecated)
         * @param partnerAppId The ID of the partner app.
         * @param tosAccepted Flag indicating whether the user accepts the terms of service.
         */
        self.acceptTermsOfService = function( partnerAppId, tosAccepted ){
            return acceptTermsOfService( partnerAppId, tosAccepted );
        };

        /**
         * Fetches simple form of all partner apps from the API.
         * @returns {*} An array of partner apps.
         */
        self.getAppData = function(){
            return getAppData( );
        };

        /**
         * Fetches a detailed form of all partner apps from the WP API.
         * @returns {*} An array of partner apps.
         */
        self.getAppDetails = function(){
            return getAppDetails( );
        };

        self.getAppSettings = function( getAppSettingsUrl ){
            return getAppSettings( getAppSettingsUrl );
        }

        /**
         * Gets a partner app by its ID, selecting from the local array of partner apps.
         * @param {number} partnerAppId The unique ID of a partner app
         * @returns {*} The local copy of the properties of the partner app with the specified ID.
         */
        self.getLocalAppById = function( partnerAppId ){
            return getLocalAppById( partnerAppId );
        };

        /**
         * Get the roles for the partner app with the given appId.
         * @param privilegeId the partner app's privilegeId.
         * @returns {Function} A promise to deliver the results of the service call.
         */
        self.getRolesForApp = function ( privilegeId ) {
            return getRolesForApp(privilegeId);
        }

        /**
         * Fetches a simple partner app from the API.
         * @param {number} partnerAppId The unique ID of a partner app
         * @returns {*} An object with extended properties of the partner app with the specified ID.
         */
        self.getSimpleAppPlus = function( partnerAppId ){
            return getSimpleAppPlus( partnerAppId );
        };

        /**
         * Removes a partner app installation.
         * @param {any} removeServiceUrl The API URL to remove the service.
         * @returns {*} True if the removal succeeded, false otherwise.
         */
        self.removeService = function (removeServiceUrl, partnerAppId  ) {
            if ( checkServiceUserRights ( ) === true ) {
                return removeService(removeServiceUrl, partnerAppId );
            } else {
                return false;
            }
        };

        /**
         * Sets the installed flag on a local partner app object.
         * @param {number} partnerAppId The unique ID of a partner app
         * @param {boolean} isInstalled Flag indicating whether the partner app is installed.
         */
        self.setInstalled = function( partnerAppId, isInstalled ) {
            var partnerApp = getLocalAppById ( partnerAppId );
            if ( partnerApp ) {
                partnerApp.installed = isInstalled;
            }
        };

        /**
         * Sets the TOS accepted flag on a local partner app object.
         * @param {number} partnerAppId The unique ID of a partner app
         * @param {boolean} isAccepted Flag indicating whether the partner app Terms of Service have been accepted by the user.
         * @deprecated TOS acceptance is checked on the server at setup and update; if TOS were not accepted, the partner app
         * integration will be aborted. Avoid interrupting the client workflow with a separate TOS API call.
         */
        self.setTosAcceptance = function( partnerAppId, isAccepted ) {
            var partnerApp = getLocalAppById ( partnerAppId );
            if ( partnerApp ) {
                partnerApp.acceptedTOS = isAccepted;
            }
        };

        /**
         * Send a request to the API to set up a service.
         * @param {*} partnerApp The partner app to set up.
         * @param {string} serviceSetupUrl The API URL to install the service.
         * @returns {*} The configuration of the partner app, if the installation succeeded.
         */
        self.setupServiceForPartnerApp = function (partnerApp, serviceSetupUrl) {
            if (checkServiceUserRights() === true) {
                return setupService(partnerApp.id, partnerApp.productName, partnerApp.acceptedTOS, serviceSetupUrl);
            } else {
                return $q.reject(false);
            }
        };

        /**
         * Updates the general settings for a partner app or service at the specified endpoint.
         * @param {string} updatedSettingsUrl the URL of the update endpoint for the partner app.
         * @param {object} updatedSettings JSON object containing the updated settings (specific to each partner app)
         * @returns {angular.IPromise<any>} Promise from the attempt to update the partner app setup.
         */
        self.updatePartnerAppSettingsByUrl = function ( updatedSettingsUrl, updatedSettings ){
            return updateServiceSettings ( updatedSettingsUrl, updatedSettings );
        };

        /**
         * Updates the general settings for a partner app or service at the specified endpoint.
         * @param {string} partnerAppName the partner app name.
         * @param {object} updatedSettings JSON object containing the updated settings (specific to each partner app)
         * @returns {angular.IPromise<any>} Promise from the attempt to update the partner app setup.
         */
        self.updatePartnerAppSettings = function ( partnerAppName, updatedSettings ){
            return updateServiceSettings ( getAppConfigurationUrl(partnerAppName), updatedSettings );
        };

        /**
         * Updates the roles with the partner app's privilege.
         * @param changedRoles the roles to which the user has assigned or removed the partner app's privilege.
         * @returns {Function} A promise to return the changed roles as updated from the service call.
         */
        self.updatePrivilegeRoles = function( changedRoles ) {
            return updatePrivilegeRoles(changedRoles);
        };

        /**
         * Get the configuration for the partner app.
         * @param {string} partnerAppName the partner app name
         * @returns {Promise} returns a promise that resolves to with the data or an error message (as a string)
         */
        self.getConfiguration = function(partnerAppName) {
            return getAppConfiguration(partnerAppName);
        };
    }]);

/** 
 * icWizard - Component to manage child pages, movement between the pages, and to gather promises to save data from each page.
*/
app.component('icWizard', {
    /* 
    Bindings:
        canGoForward - optional function provided by parent if any preconditions need to be checked before allowing the wizard to proceed.
        finishText - optional text to put in the button to finish the wizard's work and save results.
        hasBreadcrumbs - optional boolean flag - true to show breadcrumbs, false if not.
        hasCancel - true if a Cancel button should be shown, false if not.
        hasSave - true if a Save button should be shown at save points, false if only a Next button should show.
        onCancel - optional function provided by parent to handle a cancel event.
        onClose - optional function provided by parent to handle a close event.
        onPageChange - optional function provided by parent to handle page changes.
        onSave - optional function provided by parent to handle save events.
        onSaveMessage - optional text message to display on saving.
        saveText - optional text to display in the Save button; defaults to "Save".
        showFinish - true if a Finish button should be shown at save points, false if only a Close button should show.
    */
    bindings: {
        canGoForward: "<?",
        finishText: "@",
        hasBreadcrumbs: "@",
        hasCancel: "@",
        hasSave: "@",
        onCancel: "<",
        onClose: "<",
        onPageChange: "<",
        onSave: "<",
        onSaveMessage: "@",
        saveText: "@",
        showFinish: "<?",
        hasDisable: "<"
    },
    controller: function($log, $q, $http, integrationCenterService){
        var wiz = this;
        // Initialize public members
        wiz.pages = [];

        // Component properties
        var currentPageIndex = -1;
        var endPageIndex = -1;
        var startPageIndex = -1;
        var lastPageIndex = -1;
        var nextPageIndex = -1;
        var previousPageIndex = -2;
        this.isComplete = false;
        var savePromiseArray = [];
        this.isSaving = false;
        this.onSavingMessage = null;

        this.atEnd = false;
        this.atReady = false;
        this.atSave = false;
        this.atStart = true;
        this.unsubscribe = true;
        this.saveNeeded = false;

        //#region Private methods

        function addPage(page) {
            var index = wiz.pages.length;
            wiz.pages.push({key: index, item: page});
            lastPageIndex += 1;
            if(wiz.pages.length === 1) {
                setCurrentPage(0);
            }

            //$log.info('icWizard.addPage: Added page ' + lastPageIndex + ' to wizard.');
        }

        function cancel() {
            var logName = 'icWizard.cancel: ';
            wiz.pages.each(function(element) {
                var page = element.item;
                if ( typeof(page.cancel) === 'function') {
                    page.cancel();
                }
            });

            //$log.info(logName + 'Checking for a function to run on cancel...');
            if(typeof wiz.onCancel === 'function') {
                //$log.info(logName + 'Running parent On-Cancel handler...');
                wiz.onCancel();
            //} else {
                //$log.info(logName + 'No On-Cancel handler was specified by the parent.');
            }

            close();
        }

        function canGoForward() {
            //var logName = 'icWizard.canGoForward: ';
            //$log.info(logName + 'Checking for current wizard page (# ' + currentPageIndex + ')...');
            var thisPage = getPageAt(currentPageIndex);
            //$log.info(logName + 'Checking for next wizard page (# ' + (currentPageIndex + 1) + '...');
            var nextPage = getPageAt(currentPageIndex + 1);
            var canExitCurrent = true;
            var canEnterNext = true;

            if (typeof thisPage.canExit === "function") {
                canExitCurrent = thisPage.canExit();
            }
            if (typeof nextPage.canEnter === "function") {
                canEnterNext = nextPage.canEnter();
            }
            return canExitCurrent && canEnterNext;
        }

        function changePage(nextIndex) {
            var logName = 'icWizard.changePage: ';
            if ( !pageIndexIsValid(nextIndex) || nextIndex === currentPageIndex ) {
                return null;
            }

            //$log.info(logName + 'Moving to wizard page ' + nextIndex + '...');
            var movingNext = nextIndex > currentPageIndex;
            var movingBack = nextIndex < currentPageIndex;
            wiz.state = {state: {startPage: currentPageIndex, destinationPage: nextIndex}};
            //$log.info(wiz.state);
            var fromPage = leavePage(currentPageIndex);
            var toPage = setCurrentPage(nextIndex);
            if (wiz.onPageChange) {
                wiz.onPageChange(wiz.state);
            }
            if (fromPage && movingNext && typeof (fromPage.onNext) === "function") {
                fromPage.onNext();
            }

            if (fromPage && movingBack && typeof (fromPage.onBack) === "function") {
                fromPage.onBack();
            }

            return toPage;
        }

        function finish() {
            save();
            close();
        }

        function close() {
            var logName = 'icWizard.close: ';
            //$log.info(logName + 'Checking for a function to run on close...');
            if(typeof wiz.onClose === 'function') {
                //$log.info(logName + 'Running parent On-Close handler...');
                wiz.onClose();
            //} else {
                //$log.info(logName + 'No On-Close handler was specified by the parent.');
            }
        }

        function getPageAt(index){
            if (wiz.pages.length <= 0) {
                return null;
            }

            //$log.info('icWizard.getPageAt: Getting wizard page at index# ' + index + '...');
            return index > 0 ? wiz.pages[index].item : wiz.pages[0].item;
        }

        function getPageSavePromises() {
            var savePromises = [];
            angular.forEach(wiz.pages, function(element, key) {
                var page = element.item;
                if (!!page.save && typeof(page.save) === 'function') {
                    var savePromise = $q.when(page.save());
                    if (savePromise !== null) {
                        savePromises.push(savePromise);
                    }
                }
            });

            return savePromises;
        }

        function isShowingFirstPage() {
            return currentPageIndex <= 0;
        }

        function isShowingLastPage() {
            return currentPageIndex >= lastPageIndex;
        }

        function leavePage(index) {
            if (wiz.pages.length > 0 && index >= 0) {
                var page = getPageAt(index);
                if (page !== null) {
                    page.onLeave();
                    page.active = false;
                    page.visited = true;
                    return page;
                }
            }

            return null;
        }

        function pageIndexIsValid( pageIndex ){
            if (pageIndex < 0 || pageIndex > wiz.lastPageIndex) {
                //$log.log('icWizard.pageIndexIsValid: Error: ' + pageIndex + ' is not a valid page index.');
                return false;
            }

            return true;
        }

        function save() {
            wiz.isSaving = true;
            if (wiz.onSaveMessage) {
                wiz.onSavingMessage = wiz.onSaveMessage;
            }

            savePromiseArray = getPageSavePromises();
            if (typeof wiz.onSave === "function" && savePromiseArray.length) {
                return wiz.onSave({promiseArray: savePromiseArray, wizard: wiz})
                    .then(function(data) {
                        if (typeof wiz.onSaveComplete === "function") {
                            wiz.onSaveComplete(data).then(function() {
                                saveComplete(data);
                            });
                        } else {
                            saveComplete(data);
                        }
                    });
            } else {
                wiz.nextPage();
                wiz.isSaving = false;
                return savePromiseArray;
            }
        }

        function saveComplete(data) {
            if (wiz.atSave) {
                wiz.nextPage(data);
                wiz.isSaving = false;
            } else {
                wiz.isSaving = false;
            }
        }

        function setCurrentPage(index) {
            var logName = 'icWizard.setCurrentPage: ';
            if (index > lastPageIndex) {
                //$log.info('There are ' + wiz.pages.length + ' pages in the wizard, so there is no page ' + index + '.');
                return null;
            }

            //$log.info(logName + 'Getting wizard page# ' + index + '...');
            var page = getPageAt(index);
            if (page !== null){
                //$log.info('Setting wizard page ' + index + ' as the current page...');
                page.active = true;
                page.visited = true;
                setPageIndices(index);

                wiz.atEnd = page.isEndPage;
                wiz.atReady = page.isReadyPage;
                wiz.atSave = page.isSavePage;
                wiz.atStart = page.isStartPage;

                page.onActive();
                return page;
            } else {
                //$log.info(logName + 'Did not find a wizard page at index ' + index + '.');
                return null;
            }
        }

        function setPageIndices(currentIndex) {
            currentPageIndex = currentIndex;
            nextPageIndex = currentPageIndex < lastPageIndex ? currentPageIndex + 1 : currentPageIndex;
            previousPageIndex = currentPageIndex > 0 ? currentPageIndex - 1 : currentPageIndex;
        }

        function setShowSaveAtSave( ifSaveNeeded ) {
            wiz.saveNeeded = ifSaveNeeded && wiz.atSave;
        }

        function disable(){
            console.log(wiz);
            $http.post("/Integrations/Advizr/Actions/Remove", { trackerMsg: 'Removing Terms of Service' }).then(function(){

                        close();

            })
        }
        //#endregion Private methods

        //#region Public interface

        /**
         * Adds a page to the page array.
         * @param {any} page The wizard page to add.
         */
        this.addPage = function(page) {
            addPage(page);
        };

        /**
         * Whether the first page in the wizard is active.
         * @returns {boolean} True if the active page is the first in the wizard; false otherwise.
         */
        this.atStart = function(){
            return currentPageIndex <= startPageIndex;
        };

        /**
         * The user has canceled the wizard. Execute the cancel handler(s).
         */
        this.cancel = function () {
            cancel();
        };

        /**
         * The user wants to close the wizard. Execute the cancel handler(s).
         */
        this.close = function () {
            close();
        };

        /**
         * Queries the active page to see if it is valid to go forward in the list of pages.
         * @returns {boolean} True if the active page says it's OK for the wizard to go forward;
         * false if some condition is not satisfied.
        */
        this.canGoForward = function(){
            return canGoForward();
        };

        /**
         * Shows the page at the specified index as the active page.
         * @param {any} pageIndex The index of the page to activate.
         * @returns {*} The change result.
         */
        this.gotoPage = function(pageIndex) {
            return changePage(pageIndex);
        };

        /**
         * Whether a page remains in the wizard after the active page.
         * @returns {boolean} True if the active page is not the last in the wizard; false otherwise.
         */
        this.hasNext = function() {
            return !wiz.isLast();
        };

        /**
         * Whether a page remains in the wizard before the active page.
         * @returns {boolean} True if the active page is not the first in the wizard; false otherwise.
         */
        this.hasPrev = function() {
            return !wiz.isFirst();
        };

        /**
         * Whether the active page is the last page.
         * @returns {boolean} True if the active page is the last in the wizard; false otherwise.
         */
        this.isComplete = function() {
            return currentPageIndex === endPageIndex;
        };

        /**
         * Whether the active page is the first page.
         * @returns {boolean} True if the active page is the first in the wizard; false otherwise.
         */
        this.isFirst = function() {
            return isShowingFirstPage();
        };

        /**
         * Whether the active page is the last page.
         * @returns {boolean} True if the active page is the last in the wizard; false otherwise.
         */
        this.isLast = function() {
            return isShowingLastPage();
        };

        /**
         * Shows the page at the next index after the active page.
         */
        this.nextPage = function() {
            changePage(currentPageIndex + 1);
        };

        /**
         * Shows the page at the next index before the active page.
         */
        this.prevPage = function () {
            changePage(currentPageIndex - 1);
        };

        /**
         * Visits each page to allow it to save any data.
         * @returns {boolean} The save result.
         */
        this.save = function () {
            return save();
        };

        /**
         * Marks the wizard as complete.
         */
        this.setComplete = function () {
            wiz.isComplete = true;
        };

        /**
         * Sets the wizard to show a Save button (as opposed to Next or Finish).
         * @param {boolean} ifSaveNeeded A flag to show (true) or hide (false) the Save button.
         */
        this.setSaveButtonAtSave = function( ifSaveNeeded ) {
            setShowSaveAtSave( ifSaveNeeded );
        };

        this.finish = function(){
            finish();
        }

        this.disable = function(){
            disable();
        }

        /**
         * Initializes the component in its tree. This function is called by the angular
         * component system when all controllers in the component tree have been set up
         * and the parent component is sure to be ready.
         */
        this.$onInit = function(){
        };

        //#endregion Public interface
    },
    controllerAs: 'wiz',
    templateUrl: 'tools/integrations/wizard/ic-wizard.html',
    transclude: true
});

app.component('icWizardControls', {
    controller: function() {
        var me = this;
        this.wizard = null;
        this.$onInit = function() {
            me.wizard = parent;
        };
    },
    require: {
        parent: '^^icWizard'
    }
});

'use strict';
/** 
 * icWizardPage - Component managing a singlle page in an icWizard component.
*/
app.component('icWizardPage', {
    /* 
    Bindings:
        activePage - True if this page should be shown as the start page, or is currently shown in the wizard.
        isEndPage - True if this page is the last page in the workflow - you can make this the save page or a result page.
        hasBreadcrumbs - optional boolean flag - true to show breadcrumbs, false if not.
        hasCancel - true if a Cancel button should be shown, false if not.
        hasSave - true if a Save button should be shown at save points, false if only a Next button should show.
        onCancel - optional function provided by parent to handle a cancel event.
        onClose - optional function provided by parent to handle a close event.
        onPageChange - optional function provided by parent to handle page changes.
        onSave - optional function provided by parent to handle save events.
        onSaveMessage - optional text message to display on saving.
        saveText - optional text to display in the Save button; defaults to "Save".
        showFinish - true if a Finish button should be shown at save points, false if only a Close button should show.
    */
    bindings: {
        activePage: '@',    // This page is currently shown in the wizard.
        isEndPage: "&?",    // This page is the last page in the workflow - you can make this the save page or a result page.
        isReadyPage: "&?",  // Optional page to notify the user everything is set; save or go back and change stuff.
        isSavePage: "&?",   // Optional; this page will allow the user to execute a save operation in the workflow.
        isStartPage: "&?",  // This page will be the first one displayed; defaults to the first page in the array.
        isValid: '@',       // Optional flag; false if the page has any errors or missing input; defaults to true.
        isVisited: '@',     // 
        pageTitle: '@',     // Title text displayed in the wizard when the page iss visible or in a navigation bar.
        pageTag: '@',
        onReady: '&',
        onSaveComplete: '&'
    },
    controller: function ($log){
        var pg = this;
        var childHandler = {};
        this.active = false; // If the page is visible in the wizard.
        this.complete = false; // If the page is complete; optional.
        this.isReady = false; // If the page is initialized and ready to use.
        this.valid = false; // If the page's data is valid; optional.
        this.visited = false; // If the page has been visited by the user in this wizard.

        function setShowSaveAtSave( ifSaveNeeded ) {
            if ( !!pg.wizard) {
                pg.wizard.setSaveButtonAtSave( ifSaveNeeded );
            }
        }

        this.register = function( handler ) {
            childHandler = handler;
        };

        this.cancel = function() {
            if ( !!childHandler && !!childHandler.onCancel && typeof(childHandler.onCancel) === 'function' ) {
                return childHandler.onCancel();
            }
        };

        this.canEnter = function() {
            if ( !!childHandler && !!childHandler.canEnter && typeof(childHandler.canEnter) === 'function' ) {
                return childHandler.canEnter();
            }

            return true;
        };

        this.canExit = function() {
            if ( !!childHandler && !!childHandler.canExit && typeof(childHandler.canExit) === 'function' ) {
                return childHandler.canExit();
            }

            return true;
        };

        this.canGoBack = function() {
            if ( !!childHandler && !!childHandler.canGoBack && typeof(childHandler.canGoBack) === 'function' ) {
                return childHandler.canGoBack();
            }

            return true;
        };

        this.canGoForward = function() {
            if ( !!childHandler && !!childHandler.canGoForward && typeof(childHandler.canGoForward) === 'function' ) {
                return childHandler.canGoForward();
            }

            return true;
        };

        this.canLeave = function() {
            if ( !!childHandler && !!childHandler.canLeave && typeof(childHandler.canLeave) === 'function' ) {
                return childHandler.canLeave();
            }

            return true;
        };

        this.pageIsActive = function() {
            if ( !!childHandler && !!childHandler.isValid && typeof(childHandler.isValid) === 'function' ) {
                this.active = childHandler.active();
            }

            return this.active;
        };

        this.pageIsValid = function() {
            if ( !!childHandler && !!childHandler.isValid && typeof(childHandler.isValid) === 'function' ) {
                this.valid = childHandler.isValid();
            }

            return this.valid;
        };

        this.pageIsVisited = function() {
            if ( !!childHandler && !!childHandler.isVisited && typeof(childHandler.isVisited) === 'function' ) {
                this.visited = childHandler.isVisited();
            }

            return this.visited;
        };

        this.save = function() {
            if ( !!childHandler && !!childHandler.onSave && typeof(childHandler.onSave) === 'function' ) {
                return childHandler.onSave();
            }

            return null;
        };

        this.setActive = function( activeState ) {
            this.active = activeState;
        };

        this.setComplete = function( isCompleteState ) {
            this.Complete = isCompleteState;
        };

        this.setIsValid = function( isValidState) {
            this.valid = isValidState;
        };

        this.setIsVisited = function( isVisitedState ) {
            this.visited = isVisitedState;
        };

        this.setIsReady = function( isReadyState ) {
            this.isReady = isReadyState;
        };

        this.setSaveButtonAtSave = function( ifSaveNeeded ) {
            setShowSaveAtSave( ifSaveNeeded );
        };

        this.onActive = function() {
            if ( !!childHandler && !!childHandler.onActive && typeof(childHandler.onActive) === 'function' ) {
                return childHandler.onActive();
            }

            return null;
        };

        this.onBack = function() {
            if ( !!childHandler && !!childHandler.onBack && typeof(childHandler.onBack) === 'function' ) {
                return childHandler.onBack();
            }

            return null;
        };

        this.onLeave = function() {
            if ( !!childHandler && !!childHandler.onLeave && typeof(childHandler.onLeave) === 'function' ) {
                return childHandler.onLeave();
            }

            this.setActive( false );
            return null;
        };

        this.onNext = function() {
            if ( !!childHandler && !!childHandler.onNext && typeof(childHandler.onNext) === 'function' ) {
                return childHandler.onNext();
            }

            return null;
        };

        /**
         * Initializes the component in its tree. This function is called by the angular
         * component system when all controllers in the component tree have been set up
         * and the parent component is sure to be ready.
         */
        this.$onInit = function() {
            pg.active = !!pg.activePage;

            pg.isEndPage = !!pg.isEndPage;
            pg.isReadyPage = !!pg.isReadyPage;
            pg.isSavePage = !!pg.isSavePage;
            pg.isStartPage = !!pg.isStartPage;
            pg.valid = (pg.isValid === "true") ? true : false;
            pg.visited = (pg.isVisited === "true") ? true : false;
            pg.wizard.addPage(pg);
        };
    },
    controllerAs: 'pg',
    require: {
        wizard: '^^icWizard'
    },
    templateUrl: 'tools/integrations/wizard/ic-wizard-page.html',
    transclude: true
});


/**
 * @description Default component to display a list of the roles a user may assign to a specific privilege,
 * and afford adding the privilege to one or more roles, or removing the privilege from roles.
 * Parameters are provided in HTML attributes in an instance of the component.
 *
 * @param appRoles A structure containing the privilege attached to the integration and all roles to which the privilege may be added, whether already added or not.
 * @param getSettings A function to fetch the required settings from a service.
 * @param partnerApp The integration being edited in the wizard.
 ' @param updateSharedSettings A function to update the settings shared with other components.
 ' @param updateSettings A function to send current settings to a service to be saved on a server.
 *
 */
app.component('defaultIntegrationRoles', {
    bindings: {
        appRoles: '<',
        getSettings: '<',
        partnerApp: '<',
        setCommonSettingsChanged: '<',
        updateSharedSettings: '<',
        updateSettings: '&'
    },
    controller: function($log, $q, integrationCenterService) {
        var vm = this;
        var dirtyRoles = [];
        vm.latestAppRoles = null;

        //#region public functions

        this.roles = function() {
            return vm.latestAppRoles.roles;
        };

        /**
         * Sets the status of a role if it changes, setting the isDirty flag
         * and flags granting of delete, edit, and read.
         * @param {Object} role - a role object to track whether the role has been granted the privilege.
         */
        this.setRoleStatus = function(role) {
            var previousFlag = role.associationExists;
            var isChanged = previousFlag !== role.enabled;
            if (isChanged) {
                role.isDirty = true;
                role.editIsGranted = role.enabled;
                role.deleteIsGranted = role.enabled;
                role.readIsGranted = role.enabled;
            } else {
                role.isDirty = false;
                role.editIsGranted = previousFlag;
                role.deleteIsGranted = previousFlag;
                role.readIsGranted = previousFlag;
            }

            // Find the role in the dirtyRoles array, if it's there,
            var index = dirtyRoles.findIndex(function(item) {
                return item.id === role.id;
            });

            // If the role isn't present, copy it to the dirtyRoles array.
            if ( index === -1 && role.isDirty ) {
                dirtyRoles.push(role);
            }

            // Filter out any roles that are unchanged from the original.
            dirtyRoles = dirtyRoles.filter(function(dirtyItem) {
                return dirtyItem.isDirty === true;
            });


            integrationCenterService.updateLatestAppRoles( angular.copy(vm.latestAppRoles) );
            vm.setCommonSettingsChanged( dirtyRoles.length > 0 );
        };

        /**
         * Saves changes to the role assignments for the privilege and returns the saved appRoles object.
         * @returns {PromiseLike<{appRoles} | never> | Promise<{appRoles} | never>|*}
         */
        this.saveChanges = function () {
            if (!dirtyRoles.length) {
                return $q.resolve(null);
            }

            // var priv = vm.appRoles;
            // var privRoles = {
            //     categoryId: priv.categoryId,
            //     categoryName: priv.categoryName,
            //     code: priv.code,
            //     description: priv.description,
            //     id: priv.id,
            //     name: priv.name,
            //     roles: dirtyRoles,
            //     typeName: priv.typeName
            // };
            var privRoles = angular.copy(vm.latestAppRoles);

            $log.info("Privilege and Roles to update:\r", privRoles);
            // Save changes to role assignments on the server.
            return integrationCenterService.updatePrivilegeRoles(privRoles)
                .then(function (response) {
                    // Reset flags for all of the roles that were updated.
                    dirtyRoles.each(function(item) {
                        item.associationExists = item.enabled;
                        item.isDirty = false;
                    });

                    // Reset the array of dirty roles and return the saved appRoles object.
                    dirtyRoles = [];
                    vm.appRoles = response.data;
                    vm.latestAppRoles = angular.copy(response.data);
                    return {appRoles: vm.appRoles};
                });
        };

        /**
         * Initializes the component in its tree. This function is called by the angular
         * component system when all controllers in the component tree have been set up
         * and the parent component is sure to be ready.
         */
        this.$onInit = function() {
            vm.latestAppRoles = angular.copy(vm.appRoles);

            if (!!vm.myParent) {
                // If this is hosted by a wizard page, register any handlers with the page.
                vm.myParent.register({
                    canEnter: function () {
                        return true;
                    },
                    canExit: function () {
                        return true;
                    },
                    isValid: function () {
                        return true;
                    },
                    isVisited: function () {
                        return true;
                    },
                    onCancel: function () {
                        vm.dirtyRoles = [];
                    },
                    onNext: function () {

                    },
                    onSave: function () {
                        return vm.saveChanges();
                    }
                });
            }
        };

        //#endregion public functions
    },
    controllerAs: 'vm',
    require: {
        myParent: '^^icWizardPage'
    },
    transclude: true,
    templateUrl: 'tools/integrations/wizardPages/defaultIntegrationRoles.html'
});


/**
 * Default component to display a list of the roles a user may assign to a specific privilege, and afford adding
 * the privilege to one or more roles, or removing the privilege from roles. Parameters are provided in HTML attributes
 * in an instance of the component.
 *
 * @param partnerApp The integration being edited in the wizard.
 * @param appRoles A structure containing the privilege attached to the integration and all roles to which the privilege
 * may be added, whether already added or not.
 *
 */
app.component('defaultPrivilegeRoles', {
    bindings: {
        partnerApp: '<',
        appRoles: '<'
    },
    controller: function($log, $q, $partnerAppService) {
        var vm = this;
        var dirtyRoles = [];

        this.roles = function() {
            return vm.appRoles.roles;
        };

        this.setRoleStatus = function(role) {
            var previousFlag = role.associationExists;
            var isChanged = previousFlag !== role.enabled;
            if (isChanged) {
                role.isDirty = true;
                role.editIsGranted = role.enabled;
                role.deleteIsGranted = role.enabled;
                role.readIsGranted = role.enabled;
            } else {
                role.isDirty = false;
                role.editIsGranted = previousFlag;
                role.deleteIsGranted = previousFlag;
                role.readIsGranted = previousFlag;
            }

            // If the role is already in the dirtyRoles list, and it's not changed,
            var existingItem = dirtyRoles.findIndex(function(element) {
                return element.id === role.id;
            });

            if ( existingItem === -1 && role.isDirty ) {
                dirtyRoles.push(role);
            } else if ( !!existingItem && !role.isDirty ) {
                dirtyRoles = dirtyRoles.filter(function(element) {
                    return element.id !== role.id;
                });
            }
        };

        this.saveChanges = function () {
            if (!dirtyRoles.length) {
                return $q.resolve(null);
            }

            var priv = vm.appRoles;
            var privRoles = {
                categoryId: priv.categoryId,
                categoryName: priv.categoryName,
                code: priv.code,
                description: priv.description,
                id: priv.id,
                name: priv.name,
                roles: dirtyRoles,
                typeName: priv.typeName
            };

            $log.info("Privilege and Roles to update:\r", privRoles);
            return $partnerAppService.updatePrivilegeRoles(privRoles)
                .then(function (response) {
                    dirtyRoles.each(function(item, index) {
                        item.associationExists = item.enabled;
                        item.isDirty = false;
                    });

                    dirtyRoles = [];
                    vm.appRoles = response.data;

                    return {appRoles: vm.appRoles};
                });
        };

        this.$onInit = function() {
            if (!!vm.wizardPage) {
                // If this is hosted by a wizard page, register any handlers with the page.
                vm.wizardPage.register({
                    canEnter: function () {
                        return true;
                    },
                    canExit: function () {
                        return true;
                    },
                    isValid: function () {
                        return true;
                    },
                    isVisited: function () {
                        return true;
                    },
                    onCancel: function () {
                        vm.dirtyRoles = [];
                    },
                    onSave: function () {
                        return vm.saveChanges();
                    }
                });
            }
        };
    },
    controllerAs: 'vm',
    require: {
        wizardPage: '^^icWizardPage'
    },
    transclude: true,
    templateUrl: 'tools/integrations/wizardPages/defaultPrivilegeRoles.html'
});

'use strict';
/**
 * Default component to display a start page with text to notify the user of any prerequisites for a workflow.
 * Parameters are provided in HTML attributes in an instance of the component.
 *
 * @param partnerApp The integration being edited in the wizard.
 *
 */
app.component('defaultStart', {
    bindings: {
        partnerApp: '<'
    },
    controller: function() {
        var vm = this;
        var defaultStartText = 'This wizard will guide you through the steps to install your integration with {Product}.';
        vm.startText = '';

        this.$onInit = function() {
            if (!!vm.partnerApp) {
                if (!!vm.partnerApp.startText) {
                    vm.startText = vm.partnerApp.startText;
                } else {
                    vm.startText = defaultStartText.replace(/{Product}/g, vm.partnerApp.productName);
                }
            }

            // If this is hosted by a wizard page, register any handlers with the page.
            if ( !!vm.wizardPage ) {
                vm.wizardPage.register({
                    canEnter: function() {
                        return true;
                    },
                    canExit: function() {
                        return true;
                    },
                    isValid: function() { return true; },
                    isVisited: function() { return true; },
                    onNext: function() {
                        return true;
                    },
                    onSave: function() {
                        return true;
                    }
                });
            }
        };
    },
    controllerAs: 'vm',
    require: {
        wizardPage: '^icWizardPage'
    },
    templateUrl: 'tools/integrations/wizardPages/defaultStart.html',
    transclude: true
});

/**
 * Default component to display the terms of service that are considered accepted before beginning a workflow.
 * Parameters are provided in HTML attributes in an instance of the component.
 *
 * @param partnerApp The integration being edited in the wizard.
 *
 */
app.component('defaultIcTerms', {
    bindings: {
        partnerApp: '<'
    },
    controller: function(integrationCenterService) {
        var vm = this;

        // This template is used by default for terms of service; the placeholder {Vendor Name} will be replaced
        // with the product name.
        // The defaultTerms wizard page will handle this, but if a custom TOS is stored in the partner app table
        // in the database, it will use that TOS text instead of the default.
        var defaultTosText = '&nbsp;&nbsp;Orion is not responsible for actions taken by {Vendor Name}.<br/><br/>&nbsp;&nbsp;By providing your credentials to {Vendor Name}, you are authorizing {Vendor Name} to access client data maintained on the Orion system and releasing Orion from all claims, liabilities, losses, damages, attorneys’ fees and expenses of any kind resulting from {Vendor Name} access to your client data, including any manipulation, alteration, or changes to the data by {Vendor Name}, as well as Orion’s actions in reliance on communications and instructions received from {Vendor Name}.<br/><br/>&nbsp;&nbsp;To the extent that you wish to discontinue your integration with {Vendor Name}, it is your responsibility to notify Orion to disable such integration.';

        // This variable will store the TOS text either from the partner app or hydrated from
        // the defaultTosText template variable.
        vm.tosText = '';

        /**
         * Saves changes to the terms of acceptance as displayed in the view.
         * @returns {Promise} Result of call to integrationCenterService to accept TOS.
         */
        this.saveChanges = function() {
            if (vm.partnerApp.acceptedTOS === true) {
                return integrationCenterService.acceptTermsOfService( vm.partnerApp.id, vm.partnerApp.acceptedTOS );
            }
        };


        this.$onInit = function() {
            if (!!vm.partnerApp) {
                if (vm.partnerApp.termsOfService !== null) {
                    vm.tosText = vm.partnerApp.termsOfService;
                } else {
                    vm.tosText = defaultTosText.replace(/{Vendor Name}/g, vm.partnerApp.partnerName);
                }
            }

            // If this is hosted by a wizard page, register any handlers with the page.
            if ( !!vm.wizardPage ) {
                vm.wizardPage.register({
                    canEnter: function() {
                        return true;
                    },
                    canExit: function() {
                        return true;
                    },
                    isValid: function() { return true; },
                    isVisited: function() { return true; },
                    onNext: function() {
                        vm.partnerApp.acceptedTOS = true;
                        vm.partnerApp.installed = vm.partnerApp.acceptedTOS;
                        vm.saveChanges();
                    },
                    onSave: function() {
                        vm.saveChanges();
                    }
                });
            }
        };
    },
    controllerAs: 'vm',
    require: {
        wizardPage: '^icWizardPage'
    },
    templateUrl: 'tools/integrations/wizardPages/defaultTerms.html',
    transclude: true
});

'use strict';

angular.module('orionConnect').directive('privilegeRoles', 
['$log', '$q', '$partnerAppService', 
function($log, $q, $partnerAppService) {
    return {
        templateUrl: 'tools/integrations/wizardPages/privilegeRoles.html',
        restrict: 'E',
        replace: true,
        require: '^oasXsWizardPage',
        scope: {
            partnerApp: '=',
            appRoles: '='                
        },
        link: function(scope, element, attr, oasXsWizardPage) {
            var dirtyRoles = [];
            scope.setRoleStatus = function(role) {

                role.isDirty = true;
                role.editIsGranted = !role.enabled;
                role.deleteIsGranted = !role.enabled;
                role.readIsGranted = !role.enabled;
                
                // If the role is already in the dirtyRoles list, and it's not changed, 
                var existingItem = dirtyRoles.findIndex(function(element) {
                    return element.id === role.id;
                });

                if ( existingItem === -1 && role.isDirty ) {
                    dirtyRoles.push(role);
                } else if ( !!existingItem && !role.isDirty ) {
                    dirtyRoles = dirtyRoles.filter(function(element) {
                        return element.id !== role.id;
                    });
                }
            };

            scope.saveChanges = function () {
                if (!dirtyRoles.length) {
                    return $q.resolve(null);
                }

                var priv = scope.appRoles;
                var privRoles = {
                    categoryId: priv.categoryId,
                    categoryName: priv.categoryName,
                    code: priv.code,
                    description: priv.description,
                    id: priv.id,
                    name: priv.name,
                    roles: dirtyRoles,
                    typeName: priv.typeName
                };

                return $partnerAppService.updatePrivilegeRoles(privRoles)
                .then(function (response) { 
                    dirtyRoles.each(function(item, index) {
                        item.associationExists = item.enabled;
                        item.isDirty = false;
                    });

                    dirtyRoles = [];
                });
            };

            // If this is hosted by a wizard page, register any handlers with the page.
            if ( !!oasXsWizardPage ) {
                oasXsWizardPage.register({ 
                    onCancel: function() {
                        scope.dirtyRoles = [];
                    },
                    onSave: function() {
                        return scope.saveChanges();
                    }
                });
            }
        }
    };
}]);
(function() {
    app.directive('partnerTerms', ['$partnerAppService', function($partnerAppService) {
        return {
            restrict: 'E',
            replace: true,
            require: '^oasXsWizardPage',
            transclude: true,
            templateUrl: "tools/integrations/wizardPages/partnerTerms.html",
            scope: {
                partnerApp: '='
            },
            link: function(scope, element, attr, oasXsWizardPage) {
                var defaultTosText = '&nbsp;&nbsp;Orion is not responsible for actions taken by {Vendor Name}.<br/><br/>&nbsp;&nbsp;By providing your credentials to {Vendor Name}, you are authorizing {Vendor Name} to access client data maintained on the Orion system and releasing Orion from all claims, liabilities, losses, damages, attorneys’ fees and expenses of any kind resulting from {Vendor Name} access to your client data, including any manipulation, alteration, or changes to the data by {Vendor Name}, as well as Orion’s actions in reliance on communications and instructions received from {Vendor Name}.<br/><br/>&nbsp;&nbsp;To the extent that you wish to discontinue your integration with {Vendor Name}, it is your responsibility to notify Orion to disable such integration.';

                if(!scope.partnerApp.termsOfService) {
                    scope.tosText = defaultTosText.replace(/{Vendor Name}/g, scope.partnerApp.partnerName);
                } else {
                    scope.tosText = scope.partnerApp.termsOfService;
                }

                scope.saveChanges = function() {
                    var partnerApp = scope.partnerApp;
                    if (partnerApp.acceptedTOS === true) {
                        return $partnerAppService.acceptTermsOfService( partnerApp.id, partnerApp.acceptedTOS );
                    }
                };

                // If this is hosted by a wizard page, register any handlers with the page.
                if ( !!oasXsWizardPage ) {
                    oasXsWizardPage.register({
                        onNext: function() {
                            var partnerApp = scope.partnerApp;
                            partnerApp.acceptedTOS = true;
                            partnerApp.installed = partnerApp.acceptedTOS;
                        },
                        onSave: function() {
                            scope.saveChanges();
                        }
                    });
                }
            }
        }
    }]);
}());

'use strict';

app.controller(
    'BillingAuditHouseholdListCtrl',
    function BillingAuditHouseholdListCtrl(
        $scope,
        $http,
        $dialog,
        $oasRights,
        views,
        $routeParams,
        $settings,
        $timeout,
        $billing,
        $portfolio,
        entities,
        apps,
        activeState
    ) {
        //PRIVATE VARIABLES

        //PRIVATE METHODS
        function init() {
            $scope.rightsBillAudit = $oasRights.forCode('BILLAUDIT');
            $scope.rightsPortfolioAudit = $oasRights.forCode('PORTFOLIOLISTSAPP');
            $scope.rightsHH = $oasRights.forCode('CLIENTS');
            $scope.rightsReg = $oasRights.forCode('REGISTRATIONS');
            $scope.rightsAcc = $oasRights.forCode('ACCOUNTS');
            $scope.rightsAst = $oasRights.forCode('ASSETS');
            $scope.rightsTrn = $oasRights.forCode('TRANSACTIONS');

            if ($routeParams.source) {
                var key = apps.find({ code: $routeParams.source });
                $scope.middleBreadcrumb = key ? apps[key].name : null;
            }

            if ($scope.user.authorization.entity === 'Representative') {
                $scope.current.isDisableActions = true;
            }
        }

        // PUBLIC METHODS
        $scope.openEditor = function () {
            if ($scope.selectedIds.length == 1) {
                $portfolio
                    .openEditor(entities.client.value, $scope.selectedIds, 'General', 'billingGeneral', apps.billingAudit.name, null)
                    .then(function (rslt) {
                        if (rslt) {
                            rslt.feePayingAccounts = rslt.feePayingAccounts === undefined ? 0 : rslt.feePayingAccounts;
                            rslt.relatedClients = rslt.relatedClients === undefined ? 0 : rslt.relatedClients;
                            rslt.recurrentAdjustments = rslt.recurrentAdjustments === undefined ? 0 : rslt.recurrentAdjustments;

                            $scope.$broadcast('event:billingaudit-household-action', { action: 'update-item', item: rslt });
                        }
                    });
            } else {
                $portfolio.openMassEditor(entities.client.value, $scope.selectedIds, apps.billingAudit.name, null).then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:billingaudit-household-action', { action: 'update-items', items: rslt });
                    }
                });
            }
        };

        $scope.runAdvisoryFeeReport = function () {
            $billing.runAdvisoryFeeReport(entities.client.value, $scope.selectedIds[0]);
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:billingaudit-household-action', { action: 'export-data' });
        };

        $scope.setActiveState = function () {
            $settings.setSetting('activeState', $scope.current.activeState);
            $timeout(function () {
                refreshGrid();
            });
        };

        $scope.goBack = function () {
            window.history.back();
        };

        $scope.slickGridDoubleClick = function () {
            if ($scope.selectedIds.length === 1) $scope.openEditor();
        };
        $scope.goToLower = function (urlLevel) {
            $portfolio.goTo(urlLevel, entities.client.value, $scope.selectedIds[0]);
        };

        $scope.importFinancialPlanningFee = function () {
            $dialog
                .dialog({
                    dialogClass: 'modal medium',
                    templateUrl: 'app/modals/upload-file.html',
                    controller: 'UploadFileCtrl',
                    title: 'Financial Planning Fee',
                    idField: 'hhId',
                    downloadUrl: '/Portfolio/ValidateImport/FinancialPlanningFee/Templates/',
                    validateUrl: '/Portfolio/ValidateImport/FinancialPlanningFee',
                    commitVerb: 'POST',
                    commitUrl: '/Portfolio/ValidateImport/FinancialPlanningFee/List',
                })
                .open();
        };

        // PRIVATE METHODS
        function refreshGrid() {
            $scope.$broadcast('event:billingaudit-household-action', { action: 'refresh-grid' });
        }

        // EVENT LISTENERS
        $scope.$on('event:billingaudit-household-select', function (e, args) {
            if (args.length === 0) return;
            $scope.current.clientId = args[0].id;
        });

        // INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.current = {
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            gridQueries: [],
            URL: '/Billing/Clients/Grid',
            status: $routeParams.status,
            activeStates: activeState,
            clientId: null,
            activeState: $settings.getSetting('activeState'),
            isDisableActions: false,
        };

        $scope.current.hotKeyActions = [
            {
                combo: 'ALT+E',
                command: function () {
                    $scope.openEditor();
                },
            },
        ];

        init();
    }
);

'use strict';

var billingAuditAccountListCtrl = app.controller(
    'BillingAuditAccountListCtrl',
    function BillingAuditAccountListCtrl(
        $scope,
        $http,
        $dialog,
        $oasRights,
        views,
        $routeParams,
        $settings,
        $timeout,
        $billing,
        $portfolio,
        entities,
        apps,
        activeState,
        searchResult
    ) {
        // PRIVATE VARIABLES

        var init = function () {
            $http.get('/Settings/Database/EntityOptions/Code/RevPayBps', { trackerMsg: 'Getting Options' }).then(function (response) {
                if (response.data.value) {
                    console.log(response.data.value);
                    if (response.data.value != 'True') {
                        $scope.removeSlickGridColumn('NoFeeAggregate');
                    }
                }
            });

            $scope.rightsHH = $oasRights.forCode('CLIENTS');
            $scope.rightsReg = $oasRights.forCode('REGISTRATIONS');
            $scope.rightsAst = $oasRights.forCode('ASSETS');
            $scope.rightsTrn = $oasRights.forCode('TRANSACTIONS');

            if (searchResult) {
                switch (searchResult.filterType) {
                    case 'Fund Family':
                        searchResult.selectedIds.forEach(function (item) {
                            $scope.current.filterSearchString += '&fundFamilyId=' + item.id;
                        });
                        break;
                    case 'Management Styles':
                        searchResult.selectedIds.forEach(function (item) {
                            $scope.current.filterSearchString += '&managementStyleId=' + item.id;
                        });
                        break;
                    case 'Household':
                        searchResult.selectedIds.forEach(function (item) {
                            $scope.current.filterSearchString += '&householdId=' + item.id;
                        });
                        break;
                    case 'Registration':
                        searchResult.selectedIds.forEach(function (item) {
                            $scope.current.filterSearchString += '&registationId=' + item.id;
                        });
                        break;
                    case 'Account':
                        searchResult.selectedIds.forEach(function (item) {
                            $scope.current.filterSearchString += '&accountId=' + item.id;
                        });
                        break;
                    case 'Fee Schedule':
                        searchResult.selectedIds.forEach(function (item) {
                            $scope.current.filterSearchString += '&feeSecheduleId=' + item.id;
                        });
                        break;
                    case 'Payout Schedule':
                        searchResult.selectedIds.forEach(function (item) {
                            $scope.current.filterSearchString += '&payoutScheduleId=' + item.id;
                        });
                        break;
                    case 'Representatives':
                        searchResult.selectedIds.forEach(function (item) {
                            $scope.current.filterSearchString += '&representativeId=' + item.id;
                        });
                        break;
                    case 'Business Line':
                        searchResult.selectedIds.forEach(function (item) {
                            $scope.current.filterSearchString += '&businessLineId=' + item.id;
                        });
                        break;
                    default:
                        break;
                }

                $timeout(function () {
                    refreshGrid();
                });
            }

            if ($routeParams.source) {
                var key = apps.find({ code: $routeParams.source });
                $scope.middleBreadcrumb = key ? apps[key].name : null;
            }

            if ($scope.user.authorization.entity === 'Representative') {
                $scope.current.isDisableActions = true;
            }
        };

        // PUBLIC METHODS

        $scope.openEditor = function (edtType) {
            if ($scope.selectedIds.length == 1) {
                if (edtType === 'ChangeHistory') {
                    $portfolio
                        .openEditor(entities.account.value, $scope.selectedIds, 'General', 'changeHistory', apps.billingAudit.name, null)
                        .then(function (rslt) {
                            if (rslt) {
                                $scope.$broadcast('event:billingaudit-account-action', { action: 'update-item', item: rslt });
                            }
                        });
                } else {
                    if ($scope.current.status === 'creditremaining') {
                        $portfolio
                            .openEditor(entities.account.value, $scope.selectedIds, 'General', 'generalAccounts', apps.billingAudit.name, null)
                            .then(function (rslt) {
                                if (rslt) {
                                    $scope.$broadcast('event:billingaudit-account-action', { action: 'update-item', item: rslt });
                                }
                            });
                    } else {
                        $portfolio
                            .openEditor(entities.account.value, $scope.selectedIds, 'General', 'billingGeneral', apps.billingAudit.name, null)
                            .then(function (rslt) {
                                if (rslt) {
                                    $scope.$broadcast('event:billingaudit-account-action', { action: 'update-item', item: rslt });
                                }
                            });
                    }
                }
            } else {
                if (edtType != 'FeeSchedule') {
                    $portfolio.openMassEditor(entities.account.value, $scope.selectedIds, apps.billingAudit.name, null).then(function (rslt) {
                        if (rslt) {
                            $scope.$broadcast('event:billingaudit-account-action', { action: 'update-items', items: rslt });
                        }
                    });
                }
            }
        };

        $scope.removeSlickGridColumn = function (columnName) {
            $scope.current.view.slickGridColumnDefs = $scope.current.view.slickGridColumnDefs.filter(function (value, index, arr) {
                return value.id != columnName;
            });
        };

        $scope.runAdvisoryFeeReport = function () {
            $billing.runAdvisoryFeeReport(entities.account.value, $scope.selectedIds[0]);
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:billingaudit-account-action', { action: 'export-data' });
        };

        $scope.setActiveState = function () {
            $settings.setSetting('activeState', $scope.current.activeState);
            $timeout(function () {
                refreshGrid();
            });
        };

        $scope.showRecurringAdjustmentsForAccount = function () {
            var dialogOpts = {
                templateUrl: 'recurringAdjustmentsViewer.html',
                controller: 'RecurringAdjustmentsViewerCtrl',
                recurringAdjustments: $scope.current.recurringAdjustments,
            };
            var d = $dialog.dialog(dialogOpts);
            d.open();
        };

        $scope.goBack = function () {
            window.history.back();
        };

        $scope.slickGridDoubleClick = function () {
            if ($scope.selectedIds.length === 1) $scope.openEditor('Billing');
        };

        $scope.goToLower = function (urlLevel) {
            $portfolio.goTo(urlLevel, entities.account.value, $scope.selectedIds[0]);
        };

        $scope.goToHigher = function (urlLevel) {
            if (urlLevel == 'households' && $scope.current.clientId > 0) {
                $portfolio.goTo(urlLevel, entities.client.value, $scope.current.clientId);
            }
        };

        // PRIVATE METHODS
        function refreshGrid() {
            $scope.$broadcast('event:billingaudit-account-action', { action: 'refresh-grid' });
        }

        // INITIALIZE
        $scope.views = views;

        $scope.selectedIds = [];
        $scope.current = {
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            gridQueries: [],
            URL: '/Billing/Accounts/Grid',
            status: $routeParams.status,
            activeStates: activeState,
            clientId: null,
            recurringAdjustments: [],
            filterSearchString: '',
            isDisableActions: false,
        };
        $scope.rights = $oasRights.forCode('BILLAUDIT');
        $scope.rightsPortfolioAudit = $oasRights.forCode('PORTFOLIOLISTSAPP');
        $scope.rightsAcc = $oasRights.forCode('ACCOUNTS');

        $scope.current.hotKeyActions = [
            {
                combo: 'ALT+E',
                command: function () {
                    $scope.openEditor('Billing');
                },
            },
        ];

        if ($routeParams.status == 'payingfeeisinactive') {
            $scope.current.activeState = activeState.inActive;
        } else {
            $scope.current.activeState = $settings.getSetting('activeState');
        }

        //EVENT LISTENERS
        $scope.$on('event:billingaudit-account-select', function (e, args) {
            if (args.length === 0) return;
            $scope.current.recurringAdjustments = args[0].recurringAdjustments;
            $scope.current.clientId = args[0].clientId;
        });

        init();
    }
);

billingAuditAccountListCtrl.loadBillingAccountViews = [
    '$http',
    '$route',
    function ($http, $route) {
        var dto = billingAuditAccountListCtrl.getBillingDto($route.current.params.status);
        return $http.get('/Settings/Views/' + dto, { trackerMsg: 'Loading billing views' }).then(function (response) {
            return response.data;
        });
    },
];

billingAuditAccountListCtrl.loadAccountFilter = [
    '$http',
    '$route',
    '$dialog',
    '$q',
    function ($http, $route, $dialog, $q) {
        var dto = billingAuditAccountListCtrl.getBillingDto($route.current.params.status);
        var deferred = $q.defer();

        if (dto === 'BillAccountDto') {
            $http.get('/Settings/EntityOptions/Database/0/code/69AUDITALL', { trackerMsg: 'Loading search setting' }).then(function (res) {
                if (res.data.value === 'WithCancel' || res.data.value === 'WithoutCancel') {
                    var dialogOpts = {
                        templateUrl: 'billing/modals/audit-all-accounts-filter.html',
                        controller: 'AuditAllAccountsFilterCtrl',
                        hasCancel: res.data.value === 'WithCancel' ? true : false,
                    };

                    var d = $dialog.dialog(dialogOpts);
                    d.open().then(function (rslt) {
                        deferred.resolve(rslt);
                    });
                } else {
                    deferred.resolve(null);
                }
            });

            return deferred.promise;
        } else {
            deferred.resolve(null);
            return deferred.promise;
        }
    },
];

billingAuditAccountListCtrl.getBillingDto = function (status) {
    switch (status ? status.toLowerCase() : '') {
        case 'missingfeeschedules':
            return 'MissingFeeSchedDto';
        case 'missingpayoutschedules':
            return 'MissingPaySchedDto';
        case 'payingfeeiszero':
            return 'AcctPayingFee0Dto';
        case 'payingfeeisindirect':
            return 'AcctPayingFeeIndirectDto';
        case 'payingfeeisinactive':
            return 'AcctPayingFeeInactiveDto';
        case 'creditremaining':
            return 'CreditRemainingDto';
        case 'subadvisorfeeschedule':
            return 'SubAdvisorFeeDto';
        case 'checkpaypaidbyother':
            return 'CheckPayDto';
        case 'accountspaidbyandfor':
            return 'AcctPaidForDto';
        case 'statusnotbilled':
            return 'StatusNotBilledDto';
        case 'missingmanagementstyles':
            return 'MissingManagementStylesDto';
        case 'feescheduleiszero':
            return 'FeeScheduleIsZeroDto';
        case '':
            return 'BillAccountDto';
    }
};

'use strict';

var billingAuditAssetListCtrl = app.controller(
    'BillingAuditAssetListCtrl',
    function BillingAuditAssetListCtrl($scope, $http, $oasRights, views, $routeParams, $portfolio, $dialog, entities, apps) {
        // PRIVATE VARIABLES

        // PUBLIC METHODS
        $scope.openEditor = function () {
            if ($scope.selectedIds.length == 1) {
                $portfolio
                    .openEditor(entities.asset.value, $scope.selectedIds, 'General', 'billingGeneral', apps.billingAudit.name, null)
                    .then(function (rslt) {
                        if (rslt) {
                            $scope.$broadcast('event:billingaudit-asset-action', { action: 'update-item', item: rslt });
                        }
                    });
            } else {
                $portfolio.openMassEditor(entities.asset.value, $scope.selectedIds, apps.billingAudit.name, null).then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:billingaudit-asset-action', { action: 'update-items', items: rslt });
                    }
                });
            }
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:billingaudit-asset-action', { action: 'export-data' });
        };

        $scope.slickGridDoubleClick = function () {
            if ($scope.selectedIds.length === 1) $scope.openEditor();
        };

        $scope.importPartialExcluded = function () {
            $dialog
                .dialog({
                    dialogClass: 'modal medium',
                    templateUrl: 'app/modals/upload-file.html',
                    controller: 'UploadFileCtrl',
                    title: 'Partial Asset Exclusion Import',
                    idField: 'id',
                    downloadUrl: '/Billing/ValidateImport/PartialExclusion/Templates/',
                    validateUrl: '/Billing/ValidateImport/PartialExclusion',
                    commitVerb: 'PUT',
                    commitUrl: '/Billing/ValidateImport/PartialExclusion/Import',
                })
                .open();
        };

        // PRIVATE METHODS
        function init() {
            $scope.rights = $oasRights.forCode('BILLAUDIT');
            if ($scope.user.authorization.entity === 'Representative') {
                $scope.current.isDisableActions = true;
            }
        }

        // INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.current = {
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            gridQueries: [],
            URL: '/Billing/Assets',
            status: $routeParams.status,
            isDisableActions: false,
        };

        $scope.current.hotKeyActions = [
            {
                combo: 'ALT+E',
                command: function () {
                    if ($scope.selectedIds.length === 1) $scope.openEditor();
                },
            },
        ];

        init();
    }
);

billingAuditAssetListCtrl.loadBillingAssetViews = [
    '$http',
    '$route',
    function ($http, $route) {
        var dto;
        switch ($route.current.params.status ? $route.current.params.status.toLowerCase() : '') {
            case 'excluded':
                dto = 'ExcludedAssetDto';
                break;
            case 'partiallyexcluded':
                dto = 'PartiallyExcludedAssetDto';
                break;
        }

        return $http.get('/Settings/Views/' + dto, { trackerMsg: 'Loading billing views' }).then(function (response) {
            return response.data;
        });
    },
];

'use strict';

var billingAuditFeeExcludedProductsCtrl = app.controller(
    'BillingAuditFeeExcludedProductsCtrl',
    function BillingAuditFeeExcludedProductsCtrl(
        $scope,
        $http,
        $oasRights,
        views,
        $portfolio,
        entities,
        apps,
        activeState,
        $settings,
        $timeout,
        $dialog,
        $location
    ) {
        // PRIVATE VARIABLES

        // PUBLIC METHODS
        $scope.openEditor = function () {
            var d = $dialog.editor('products/editors/product-edit.html', 'ProductEditCtrl', {
                args: function () {
                    return {
                        id: $scope.selectedIds[0],
                        app: apps.productsAndPrices,
                        defaultTab: { name: 'Local', active: true, code: 'billingGeneral' },
                        extraInfo: null,
                        isNewGlobal: false,
                        isNewLocal: false,
                    };
                },
            });

            d.open().then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast('event:billingaudit-product-action', { action: 'refresh-grid' }); // refresh entire grid
                }
            });
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:billingaudit-product-action', { action: 'export-data' });
        };

        $scope.setActiveState = function () {
            $settings.setSetting('activeState', $scope.current.activeState);
            $timeout(function () {
                $scope.$broadcast('event:billingaudit-product-action', { action: 'refresh-grid' });
            }, 0);
        };

        $scope.slickGridDoubleClick = function () {
            if ($scope.selectedIds.length === 1) $scope.openEditor();
        };

        $scope.goToAssets = function () {
            $location.url('/portfolio/assets?entity=' + entities.product.value + '&entityId=' + $scope.selectedIds[0]);
        };

        // PRIVATE METHODS

        function init() {
            $scope.current.activeState = $settings.getSetting('activeState');
            $scope.rightsProducts = $oasRights.forCode('PRODUCTS');
            $scope.rightsAssets = $oasRights.forCode('ASSETS');
        }

        // INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.current = {
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            gridQueries: [],
            URL: '/Billing/Products?feeExcluded=true',
            isDisableActions: false,
            activeStates: activeState,
        };

        $scope.current.hotKeyActions = [
            {
                combo: 'ALT+E',
                command: function () {
                    if ($scope.selectedIds.length === 1) $scope.openEditor();
                },
            },
        ];

        init();
    }
);

'use strict';

app.controller(
    'BillingAuditHouseholdFeeExcludedProductsListCtrl',
    function BillingAuditHouseholdFeeExcludedProductsListCtrl(
        $scope,
        $http,
        $oasRights,
        views,
        $portfolio,
        entities,
        apps,
        activeState,
        $settings,
        $timeout,
        $dialog,
        $location
    ) {
        // PRIVATE VARIABLES
        var clientId;

        // PUBLIC METHODS
        $scope.openEditor = function () {
            $portfolio.openEditor(entities.client.value, [clientId], 'General', 'assetExclusion', apps.billingAudit.name, null).then(function (rslt) {
                if (rslt) {
                    $scope.$broadcast('event:billingaudit-household-product-action', { action: 'refresh-grid' });
                }
            });
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:billingaudit-household-product-action', { action: 'export-data' });
        };

        $scope.slickGridDoubleClick = function () {
            if ($scope.selectedIds.length === 1) $scope.openEditor();
        };

        // PRIVATE METHODS
        function init() {
            $scope.current.activeState = $settings.getSetting('activeState');
            $scope.rightsHousehold = $oasRights.forCode('CLIENTS');
        }

        // INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.current = { view: views[0], gridDoubleClick: $scope.slickGridDoubleClick, gridQueries: [], URL: '/Billing/Assets/HouseholdExclusions' };

        $scope.current.hotKeyActions = [
            {
                combo: 'ALT+E',
                command: function () {
                    if ($scope.selectedIds.length === 1) $scope.openEditor();
                },
            },
        ];

        init();

        // EVENT LISTENTER
        $scope.$on('event:billingaudit-household-product-select', function (e, args) {
            if (args.length == 0) return;
            clientId = args[0].clientId;
        });
    }
);

'use strict';

var billingAuditTransactionListCtrl = app.controller(
    'BillingAuditTransactionListCtrl',
    function BillingAuditTransactionListCtrl($scope, $http, views, $dialog, $oasRights, $portfolio, entities, apps, searchResult, $timeout) {
        //PRIVATE VARIABLES

        // PRIVATE METHODS
        function init() {
            $scope.rightsHH = $oasRights.forCode('CLIENTS');
            $scope.rightsReg = $oasRights.forCode('REGISTRATIONS');
            $scope.rightsAcc = $oasRights.forCode('ACCOUNTS');
            $scope.rightsAst = $oasRights.forCode('ASSETS');
            $scope.rightsTrn = $oasRights.forCode('TRANSACTIONS');
            $scope.rightsProducts = $oasRights.forCode('PRODUCTS');

            $http
                .get('/Utility/PageQueries?pageCode=BillTransactionDto', { cache: true, trackerMsg: 'Loading bill eligible queries' })
                .then(function (response) {
                    response.data.forEach(function (query) {
                        query.isPageQuery = true;
                    });

                    $scope.current.gridQueries = response.data;
                    setDateParameters();
                });

            if (searchResult) {
                if (searchResult.filterType === 'Representative') {
                    searchResult.selectedIds.forEach(function (item) {
                        $scope.current.filterSearchString += '&representativeId=' + item.id;
                    });
                } else {
                    searchResult.selectedIds.forEach(function (item) {
                        $scope.current.filterSearchString += '&fundFamilyId=' + item.id;
                    });
                }
                $timeout(function () {
                    $scope.refreshGrid();
                });
            }

            $http
                .get('/Trading/TransactionTypes?IsBillable=True&IsValid=True', { cache: false, trackerMsg: 'Loading transaction types' })
                .then(function (response) {
                    $scope.transTypeIsBillable = response.data;
                    $scope.transTypeIsBillable.forEach(function (tt) {
                        tt.isSelected = false;
                    });
                });

            if ($scope.user.authorization.entity === 'Representative') {
                $scope.current.isDisableActions = true;
            }
        }

        function setDateParameters() {
            for (var i = 0; i < $scope.current.gridQueries.length; i++) {
                if ($scope.current.gridQueries[i].parameters) {
                    for (var j = 0; j < $scope.current.gridQueries[i].parameters.length; j++) {
                        if ($scope.current.gridQueries[i].parameters[j].name === 'BeginDate') {
                            $scope.current.gridQueries[i].parameters[j].value = $scope.current.startDate.formatted();
                        }
                        if ($scope.current.gridQueries[i].parameters[j].name === 'EndDate') {
                            $scope.current.gridQueries[i].parameters[j].value = $scope.current.endDate.formatted();
                        }
                        if ($scope.current.gridQueries[i].parameters[j].name === 'TransactionIdList') {
                            $scope.transTypeIsBillable.forEach(function (tt) {
                                if (tt.isSelected) {
                                    $scope.current.gridQueries[i].parameters[j].value += tt.id + ',';
                                }
                            });
                        }
                    }
                }
            }
        }

        // PUBLIC METHODS
        $scope.openEditor = function () {
            if ($scope.selectedIds.length === 1) {
                $portfolio
                    .openEditor(entities.transaction.value, $scope.selectedIds, 'General', 'billingGeneral', apps.billingAudit.name, null)
                    .then(function (rslt) {
                        if (rslt) {
                            $scope.$broadcast('event:billtransaction-action', { action: 'update-item', item: rslt });
                        }
                    });
            } else {
                $portfolio.openMassEditor(entities.transaction.value, $scope.selectedIds, apps.billingAudit.name, null).then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:billtransaction-action', { action: 'update-items', items: rslt });
                    }
                });
            }
        };

        $scope.refreshGrid = function () {
            $scope.current.filterSearchString = '';

            $scope.transTypeIsBillable.forEach(function (tt) {
                if (tt.isSelected) {
                    $scope.current.filterSearchString += '&transTypeId=' + tt.id;
                }
            });

            $timeout(function () {
                $scope.$broadcast('event:billtransaction-action', { action: 'refresh-grid' });
            }, 0);
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:billtransaction-action', { action: 'export-data' });
        };

        $scope.addGridQuery = function () {
            setDateParameters();

            $http
                .post('/Utility/PageQueries/' + $scope.current.selectedGridQuery.id + '/Results', $scope.current.selectedGridQuery, {
                    trackerMsg: 'Loading query ' + $scope.current.selectedGridQuery.name,
                })
                .then(function (response) {
                    $scope.current.selectedGridQuery.field = 'id';
                    $scope.current.selectedGridQuery.filterFn = function (x) {
                        for (var i = response.data.length - 1; i >= 0; i--) {
                            if (response.data[i] === x) return true;
                        }
                        return false;
                    };
                    $scope.current.selectedGridQuery.itemCount = response.data.length;
                    $scope.current.selectedGridQuery.enabled = true;
                });
        };

        $scope.removeGridQuery = function (query) {
            if (query.enabled) query.enabled = false;
        };

        $scope.slickGridDoubleClick = function () {
            if ($scope.selectedIds.length === 1) $scope.openEditor();
        };

        $scope.goToHigher = function (urlLevel) {
            if (urlLevel === 'households' && $scope.current.selectedHouseholdId > 0) {
                $portfolio.goTo(urlLevel, entities.client.value, $scope.current.selectedHouseholdId);
            } else if (urlLevel === 'accounts' && $scope.current.selectedAccountId > 0) {
                $portfolio.goTo(urlLevel, entities.account.value, $scope.current.selectedAccountId);
            }
        };

        // INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.current = {
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            gridQueries: [],
            URL: '/Billing/Transactions/Grid',
            startDate: Date.create('beginning of last month'),
            endDate: Date.create('end of last month'),
            selectedGridQuery: {},
            excelData: null,
            filterSearchString: '',
            isDisableActions: false,
        };

        $scope.current.hotKeyActions = [
            {
                combo: 'ALT+E',
                command: function () {
                    $scope.openEditor();
                },
            },
        ];
        $scope.rights = $oasRights.forCode('BILLAUDIT');

        init();

        // Watches
        $scope.$watch('current.excelData', function (newVal, oldVal) {
            if (newVal === oldVal) return;

            $scope.$broadcast('event:billtransaction-action', { action: 'clear-items' });
            $scope.$broadcast('event:billtransaction-action', { action: 'add-items', items: newVal });
        });

        //EVENT LISTENERS
        $scope.$on('event:billtransaction-select', function (e, args) {
            if (args.length === 0) return;
            $scope.current.selectedHouseholdId = args[0].clientId;
            $scope.current.selectedAccountId = args[0].accountId;
        });
    }
);

billingAuditTransactionListCtrl.loadTransactionFilter = [
    '$http',
    '$route',
    '$dialog',
    '$q',
    function ($http, $route, $dialog, $q) {
        var deferred = $q.defer();

        $http.get('/Settings/EntityOptions/Database/0/code/69BILLELIG', { cache: true, trackerMsg: 'Loading search setting' }).then(function (res) {
            if (res.data.value == 'True') {
                var dialogOpts = {
                    templateUrl: 'billing/modals/bill-eligible-filter.html',
                    controller: 'BillEligibleFilterCtrl',
                };

                var d = $dialog.dialog(dialogOpts);
                d.open().then(function (rslt) {
                    deferred.resolve(rslt);
                });
            } else {
                deferred.resolve(null);
            }
        });

        return deferred.promise;
    },
];

'use strict';

app.controller('BillingAuditBillDataListCtrl', function BillingAuditBillDataListCtrl($scope, $http, views, $oasRights) {
    // PUBLIC METHODS
    $scope.refreshGrid = function () {
        $scope.$broadcast('event:billdata-action', { action: 'refresh-grid' });
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:billdata-action', { action: 'export-data' });
    };

    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {
        view: views[0],
        URL: '/Billing/BillDataExport',
        startDate: Date.create('beginning of last month'),
        endDate: Date.create('end of last month'),
    };
    $scope.rights = $oasRights.forCode('BILLAUDIT');
});

'use strict';

app.controller(
    'BillingAuditReceivablesListCtrl',
    function BillingAuditReceivablesListCtrl($scope, $q, $http, $location, $dialog, $tradeGenerator, views, feeRequestSource, $oasRights) {
        //PRIVATE METHODS
        function processCashFunding() {
            $q.all({
                quickTrade: $tradeGenerator.getTradeDefinition('QuickTrade'),
                proRated: $tradeGenerator.getTradeDefinition('ProRated'),
            }).then(function (tradeDefs) {
                var quickTradeDef = tradeDefs.quickTrade.data;
                var proRatedTradeDef = tradeDefs.proRated.data;
                proRatedTradeDef.amounts = [];
                proRatedTradeDef.keys = [];
                var assetPromises = {};

                Object.each($scope.current.accountFeeRequestList, function (key, item) {
                    assetPromises[key] = getAccountAssets(item.accountId);
                });

                $q.all(assetPromises).then(function (results) {
                    Object.each(results, function (key, assets) {
                        var item = $scope.current.accountFeeRequestList[key];
                        if (item.difference && parseFloat(item.difference) < 0) {
                            switch (item.feeReqSrc) {
                                case feeRequestSource.highValueFund.name:
                                    generateQuickTrade(quickTradeDef, item.accountId, assets, -parseFloat(item.difference));
                                    break;
                                case feeRequestSource.proRata.name:
                                    proRatedTradeDef.tradeSide = 'Sell';
                                    proRatedTradeDef.keys.push(item.accountId);
                                    proRatedTradeDef.amounts.push(-parseFloat(item.difference));
                                    proRatedTradeDef.assetValues = 'Pending';
                                    break;
                                default:
                                    break;
                            }
                        }
                    });

                    var submitPromises = {};
                    if (quickTradeDef.trades.length) {
                        submitPromises.quickTrade = $tradeGenerator.submitTradeDefinition(quickTradeDef);
                    }
                    if (proRatedTradeDef.keys.length) {
                        submitPromises.proRated = $tradeGenerator.submitTradeDefinition(proRatedTradeDef);
                    }

                    if (Object.size(submitPromises)) {
                        $q.all(submitPromises).then(function () {
                            $location.path('/trading/tom/orders');
                        });
                    } else {
                        $dialog.messageBox("<i class='fa fa-lg text-info' aria-hidden='true'></i> Information", 'No trades to create.').open();
                    }
                });
            });
        }

        function getAccountAssets(accountId) {
            return $http.get('/Portfolio/Accounts/' + accountId + '/Assets', { cache: true, trackerMsg: 'Loading account assets' }).then(function (response) {
                return response.data;
            });
        }

        function generateQuickTrade(tradeDef, accountId, assets, amount) {
            var orderedAssets = assets.sortBy(function (a) {
                return a.currentValue;
            }, true);
            tradeDef.assetValues = 'Pending';

            var remaining = amount;
            orderedAssets.each(function (a) {
                if (remaining == 0) return false;
                if (a.currentValue <= 0) return true;
                var sellPrice = a.currentValue > remaining ? remaining : a.currentValue;
                remaining -= sellPrice;
                tradeDef.trades.push({ accountID: accountId, productID: a.productId, tradeType: 2, amount: sellPrice, side: '2' });
            });
        }

        function init() {
            $scope.rights = $oasRights.forCode('BILLAUDIT');

            if ($scope.user.authorization.entity === 'Representative') {
                $scope.current.isDisableActions = true;
            }
        }

        // PUBLIC METHODS
        $scope.refreshGrid = function () {
            $scope.$broadcast('event:billreceivables-action', { action: 'refresh-grid' });
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:billreceivables-action', { action: 'export-data' });
        };

        $scope.raiseCash = function () {
            var accountCount = $scope.current.accountFeeRequestList.length;
            $dialog
                .confirmAction(
                    'This will create one or more trades for the selected ' + accountCount + ' account' + (accountCount > 1 ? 's' : '') + '.  Continue?'
                )
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        processCashFunding();
                    }
                });
        };

        //EVENT LISTENERS
        $scope.$on('event:billreceivables-select', function (e, args) {
            if (args.length === 0) return;
            $scope.current.accountFeeRequestList = args.map(function (a) {
                return { accountId: a.accountId, feeReqSrc: a.feeReqSrc, difference: a.difference };
            });
        });

        // INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.current = {
            view: views[0],
            accountFeeRequestList: [],
            URL: '/Billing/ReceivableSummary',
            startDate: Date.create('beginning of last month'),
            endDate: Date.create('end of last month'),
            moneyMarketFilter: 1,
            forecastBillOnly: false,
            isDisableActions: false,
        };

        init();
    }
);

'use strict';

app.controller('BillingAuditPayablesListCtrl', function BillingAuditPayablesListCtrl($scope, $http, views, $oasRights) {
    // PUBLIC METHODS
    $scope.refreshGrid = function () {
        $scope.$broadcast('event:billpayables-action', { action: 'refresh-grid' });
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:billpayables-action', { action: 'export-data' });
    };

    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {
        view: views[0],
        URL: '/Billing/PayablesSummary',
        billInstanceId: undefined,
        startDate: Date.create('beginning of last month'),
        endDate: Date.create('end of last month'),
    };
    $scope.rights = $oasRights.forCode('BILLAUDIT');
});

'use strict';

var billingAuditRecurringAdjustmentsListCtrl = app.controller(
    'BillingAuditRecurringAdjustmentsListCtrl',
    function BillingAuditRecurringAdjustmentsListCtrl(
        $scope,
        $http,
        $dialog,
        $oasRights,
        views,
        $routeParams,
        $settings,
        $timeout,
        $billing,
        $portfolio,
        entities,
        apps,
        activeState
    ) {
        // PRIVATE VARIABLES
        var selFeeScheduleId = 0,
            accountIds = [];

        // PUBLIC METHODS

        $scope.openEditor = function (edtType) {
            if ($scope.selectedIds.length == 1) {
                if (edtType == 'FeeSchedule') {
                    $portfolio
                        .openEditor(entities.feeSchedule.value, [$scope.current.feeScheduleId], null, null, apps.billingAudit.name, { isFeeSchedule: true })
                        .then(function (rslt) {
                            if (rslt) {
                                $scope.$broadcast('event:billingaudit-account-action', { action: 'refresh-grid' });
                            }
                        });
                } else if (edtType == 'ChangeHistory') {
                    $portfolio
                        .openEditor(entities.account.value, [$scope.current.accountId], 'General', 'changeHistory', apps.billingAudit.name, null)
                        .then(function (rslt) {
                            if (rslt) {
                                $scope.$broadcast('event:billingaudit-account-action', { action: 'update-item', item: rslt });
                            }
                        });
                } else {
                    $portfolio
                        .openEditor(entities.account.value, [$scope.current.accountId], 'General', 'recurringAdjustments', apps.billingAudit.name, null)
                        .then(function (rslt) {
                            if (rslt) {
                                $scope.$broadcast('event:billingaudit-recurring-adjustments-action', { action: 'update-item', item: rslt });
                            }
                        });
                }
            } else {
                if (edtType != 'FeeSchedule') {
                    $portfolio.openMassEditor(entities.account.value, accountIds, apps.billingAudit.name, null).then(function (rslt) {
                        if (rslt) {
                            $scope.$broadcast('event:billingaudit-recurring-adjustments-action', { action: 'update-items', items: rslt });
                        }
                    });
                }
            }
        };

        $scope.runAdvisoryFeeReport = function () {
            $billing.runAdvisoryFeeReport(entities.account.value, [$scope.current.accountId]);
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:billingaudit-recurring-adjustments-action', { action: 'export-data' });
        };

        $scope.setActiveState = function () {
            $settings.setSetting('activeState', $scope.current.activeState);
            $timeout(function () {
                refreshGrid();
            });
        };

        $scope.slickGridDoubleClick = function () {
            if ($scope.selectedIds.length === 1) $scope.openEditor('Account');
        };

        $scope.goBack = function () {
            window.history.back();
        };

        // PRIVATE METHODS
        function refreshGrid() {
            $scope.$broadcast('event:billingaudit-recurring-adjustments-action', { action: 'refresh-grid' });
        }

        function init() {
            if ($scope.user.authorization.entity === 'Representative') {
                $scope.current.isDisableActions = true;
            }
        }

        // INITIALIZE
        $scope.selectedIds = [];
        $scope.views = views;

        $scope.selectedIds = [];
        $scope.current = {
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            URL: '/Billing/Accounts/RecurringAdjustments',
            status: $routeParams.status,
            activeStates: activeState,
            clientId: null,
            accountId: null,
            billScheduleId: null,
            feeScheduleId: null,
            isDisableActions: false,
        };
        $scope.rights = $oasRights.forCode('BILLAUDIT');
        $scope.rightsPortfolioAudit = $oasRights.forCode('PORTFOLIOLISTSAPP');
        $scope.rightsFeeSchedules = $oasRights.forCode('FEESCHEDULES');
        $scope.rightsAcc = $oasRights.forCode('ACCOUNTS');

        $scope.current.hotKeyActions = [
            {
                combo: 'ALT+E',
                command: function () {
                    $scope.openEditor('Account');
                },
            },
        ];

        init();

        if ($routeParams.status == 'payingfeeisinactive') {
            $scope.current.activeState = activeState.inActive;
        } else {
            $scope.current.activeState = $settings.getSetting('activeState');
        }

        if ($routeParams.source) {
            var key = apps.find({ code: $routeParams.source });
            $scope.middleBreadcrumb = key ? apps[key].name : null;
        }

        //EVENT LISTENERS
        $scope.$on('event:billingaudit-recurring-adjustments-select', function (e, args) {
            if (args.length === 0) return;
            $scope.current.accountId = args[0].accountId;
            $scope.current.billScheduleId = args[0].id;
            $scope.current.clientId = args[0].clientId;
            $scope.current.feeScheduleId = args[0].feeScheduleId;

            accountIds = args.map('accountId');
        });
    }
);

'use strict';

app.controller(
    'FeeScheduleEditCtrl',
    function FeeScheduleEditCtrl(
        $scope,
        $http,
        $oasRights,
        $dialog,
        $timeout,
        dialog,
        args,
        entities,
        howBilled,
        howBilledPayout,
        billScheduleTypes,
        billBasis,
        billScheduleFees,
        billSchedulePayoutRates,
        splitIoService
    ) {
        // region PRIVATE VARIABLES
        var fsGeneralOriginal = null;
        var maxValueOfAllLevels = 0;
        var isFeeSchedule = args.extraInfo.isFeeSchedule;
        var editorHotKeys;

        //endregion

        //region PRIVATE METHODS
        // region INIT/RIGHT/MENU/TABS
        function init() {
            loadRights();
            buildMenu();
            loadHotKeys();
            $scope.loadTab(args.defaultTab);
        }

        function loadRights() {
            if (isFeeSchedule) {
                $scope.rightsFeeCalculator = $oasRights.forCode('FEECALCULATORAPP');
                $scope.rightsFeeSchedule = $oasRights.forCode('FEESCHEDULES');
            } else {
                $scope.rightsFeeSchedule = $oasRights.forCode('PAYOUTSCHEDULES');
            }

            $http.get('/Settings/EntityOptions/Database/0/code/ReducedTiers', { trackerMsg: 'Loading reduce tiers' }).then(function (response) {
                if (response.data) {
                    $scope.current.isReducedTiers = response.data.value.toLowerCase() === 'true' ? true : false;
                }
            });

            $http
                .get('/Settings/EntityOptions/Database/0/code/UseLinBrkMax', { trackerMsg: 'Loading Linear Breakpoint Maximum Options' })
                .then(function (response) {
                    if (response.data) {
                        $scope.current.useLinearBreakpointMaximums = response.data.value.toLowerCase() === 'true' ? true : false;
                    }
                });
        }

        function buildMenu() {
            $scope.menu = { categories: [] };

            $scope.menu.categories.push({ name: $scope.current.feeOrPay, children: [] });
            $scope.menu.categories[0].children.push({ name: 'General', active: false, code: 'fsGeneral' });
            $scope.menu.categories[0].children.push({ name: 'Structure', active: false, code: 'fsStructure' });
        }

        function loadDataForSelectedTab() {
            switch ($scope.current.selectedTab) {
                case 'fsGeneral':
                    if ($scope.rightsFeeSchedule.canRead) {
                        loadFeeScheduleLookUps();
                        loadFeeSchedule();
                    }
                    break;
                case 'fsStructure':
                    if ($scope.rightsFeeSchedule.canRead) {
                        loadFeeSchedule();
                    }
                    break;
            }
        }

        function loadHotKeys() {
            editorHotKeys = new HotKeys();
            $timeout(function () {
                editorHotKeys.addActions([
                    { combo: 'ALT+S', command: $scope.save },
                    {
                        combo: 'ALT+X',
                        command: function () {
                            $scope.close(true);
                        },
                    },
                ]);
            });
        }
        // endregion

        // region GENERAL
        function loadFeeScheduleLookUps() {
            if ($scope.billingEntities === null) {
                $scope.billingEntities = [];
                $http.get('/Billing/BillingEntities?isActive=true', { trackerMsg: 'Loading billing entities' }).then(function (response) {
                    $scope.billingEntities = response.data;
                });
            }

            if ($scope.howBilled === null) {
                $scope.howBilled = [];
                if (isFeeSchedule) {
                    howBilled.keys().forEach(function (key) {
                        $scope.howBilled.push({ id: parseInt(howBilled[key].value), name: howBilled[key].name });
                    });
                } else {
                    howBilledPayout.keys().forEach(function (key) {
                        $scope.howBilled.push({ id: parseInt(howBilledPayout[key].value), name: howBilledPayout[key].name });
                    });
                }
            }

            if ($scope.billScheduleTypes === null) {
                $scope.billScheduleTypes = [];
                billScheduleTypes.keys().forEach(function (key) {
                    $scope.billScheduleTypes.push({ id: billScheduleTypes[key].value, name: billScheduleTypes[key].name });
                });
            }

            if ($scope.allBillBasis === null) {
                $scope.allBillBasis = [];
                billBasis.keys().forEach(function (key) {
                    $scope.allBillBasis.push({ id: billBasis[key].name, name: billBasis[key].name });
                });

                // Initialize filtered bill basis
                filterBillBasis();
            }

            if ($scope.billFeeOrPay === null) {
                $scope.billFeeOrPay = [];
                if (isFeeSchedule) {
                    billScheduleFees.keys().forEach(function (key) {
                        $scope.billFeeOrPay.push({ id: billScheduleFees[key].name, name: billScheduleFees[key].name });
                    });
                } else {
                    billSchedulePayoutRates.keys().forEach(function (key) {
                        $scope.billFeeOrPay.push({ id: billSchedulePayoutRates[key].name, name: billSchedulePayoutRates[key].name });
                    });
                }
            }
        }

        function filterBillBasis() {
            if (!$scope.allBillBasis) {
                return;
            }

            // Check feature flag to determine if we should restrict basis options for flat schedules
            splitIoService.getBoolTreatment('opex_Flat_Dollar_Fee_Schedules_do_not_allow_Sub_or_Reg_basis_28247').subscribe(function (isEnabled) {
                if (isEnabled && $scope.fsGeneral && $scope.fsGeneral.type === 'Flat') {
                    // For flat schedules with feature flag enabled, only allow Household and Account
                    $scope.billBasis = $scope.allBillBasis.filter(function (item) {
                        return item.name === 'Household' || item.name === 'Account';
                    });

                    // If current selection is not valid for flat type, default to Account
                    if ($scope.fsGeneral.basis &&
                        $scope.fsGeneral.basis !== 'Household' &&
                        $scope.fsGeneral.basis !== 'Account') {
                        $scope.fsGeneral.basis = 'Account';
                    }
                } else {
                    // For other schedule types or when feature flag is disabled, show all options
                    $scope.billBasis = angular.copy($scope.allBillBasis);
                }
            });
        }

        function Duplicate() {
            $http.get('/Billing/Schedules/' + -1 * $scope.current.fsId, { trackerMsg: 'Loading fee schedule' }).then(function (response) {
                response.data.name = response.data.name + ' COPY';

                response.data.details.forEach(function (dtl) {
                    if (dtl.rate > 0) {
                        dtl.rate = (dtl.rate * 100).round(4);
                    }
                    if (dtl.reducedRate > 0) {
                        dtl.reducedRate = (dtl.reducedRate * 100).round(4);
                    }
                });
                $scope.fsGeneral = response.data;
                unassignedCheck();
                $scope.fsGeneral.details.sort(function (m, n) {
                    return m.minimumAmount - n.minimumAmount;
                });

                fsGeneralOriginal = angular.copy($scope.fsGeneral);
                $scope.setUseBasisPoints($scope.fsGeneral.schedule);
            });
        }

        function loadFeeSchedule() {
            if ($scope.fsGeneral === null) {
                if ($scope.current.fsId != 0) {
                    if ($scope.current.fsId > 0) {
                        $http.get('/Billing/Schedules/' + $scope.current.fsId, { trackerMsg: 'Loading fee schedule' }).then(function (response) {
                            response.data.details.forEach(function (dtl) {
                                if (dtl.rate > 0) {
                                    dtl.rate = (dtl.rate * 100).round(4);
                                }
                                if (dtl.reducedRate > 0) {
                                    dtl.reducedRate = (dtl.reducedRate * 100).round(4);
                                }
                            });
                            $scope.fsGeneral = response.data;
                            unassignedCheck();
                            $scope.fsGeneral.details.sort(function (m, n) {
                                return m.minimumAmount - n.minimumAmount;
                            });

                            fsGeneralOriginal = angular.copy($scope.fsGeneral);
                            $scope.setUseBasisPoints($scope.fsGeneral.schedule);
                            filterBillBasis();
                        });
                    } //dupliate
                    else {
                        Duplicate();
                    }
                } else {
                    $scope.fsGeneral = {
                        name: '',
                        schedule: isFeeSchedule ? billScheduleFees.feeSchedule.name : billSchedulePayoutRates.payoutSchedule.name,
                        type: 'Linear',
                        basis: 'Household',
                        minimumFee: 0,
                        billEntityId: 3,
                        howBilled: 0,
                        showInFeeCalculator: false,
                        details: [
                            {
                                minimumAmount: 0,
                                maximumAmount: 9999999999,
                                rate: 0,
                                points: 0,
                                flatFee: 0,
                            },
                        ],
                    };

                    $scope.setUseBasisPoints($scope.fsGeneral.schedule);
                    fsGeneralOriginal = angular.copy($scope.fsGeneral);
                }
            }
        }

        function unassignedCheck() {
            if ($scope.fsGeneral.name === 'UnAssigned') {
                $scope.current.isUnassignedFee = true;
            }
        }

        function checkDisableApplyPayoutAccount() {
            var hb = isFeeSchedule ? howBilled : howBilledPayout;

            if (
                $scope.fsGeneral.howBilled == hb.dollarAmount.value &&
                $scope.fsGeneral.type == billScheduleTypes.linear.value &&
                $scope.fsGeneral.basis == billBasis.client.name
            ) {
                $scope.current.disableApplyPayoutAccount = false;
            } else {
                $scope.fsGeneral.aggregateByHousehold = false;
                $scope.current.disableApplyPayoutAccount = true;
            }
        }

        //endregion

        // region STRUCTURE

        function setMaxValue() {
            maxValueOfAllLevels = parseInt(
                $scope.fsGeneral.details.max(function (n) {
                    return parseInt(n['maximumAmount']);
                }).maximumAmount
            );
        }

        //endregion

        //endregion

        // region PUBLIC METHODS
        //  region LOAD/CLOSE
        $scope.loadTab = function (child) {
            $scope.menu.categories.each(function (c) {
                c.children.each(function (ch) {
                    ch.active = ch.code === child.code;
                });
            });

            $scope.current.selectedTab = child.code;

            loadDataForSelectedTab();
        };

        $scope.save = function () {
            var abortMessages = [];

            if ($scope.fsGeneral.name.length === 0) {
                abortMessages.push('Name must be populated.');
            }
            if ($scope.fsGeneral.name === 'UnAssigned') {
                abortMessages.push("Name cannot be named 'UnAssigned'.");
            }
            if (
                !$scope.fsGeneral.details.some({ maximumAmount: 9999999999 }) &&
                !$scope.fsGeneral.details.some({ maximumAmount: '9999999999' }) &&
                !$scope.fsGeneral.details.some({ maximumAmount: 999999999 }) &&
                !$scope.fsGeneral.details.some({ maximumAmount: '999999999' })
            ) {
                $dialog
                    .messageBox(
                        "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Fee Schedule Invalid",
                        'The maximum amount ($999999999) or ($9999999999) is missing in the Schedule Structure.'
                    )
                    .open();
                return;
            }

            if (!$scope.fsGeneral.details.some({ minimumAmount: 0 }) && !$scope.fsGeneral.details.some({ minimumAmount: '0' })) {
                $dialog
                    .messageBox(
                        "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Fee Schedule Invalid",
                        'The minimum amount ($0) is missing in the Schedule Structure.'
                    )
                    .open();
                return;
            }

            var fsGeneralToSave = angular.copy($scope.fsGeneral);
            fsGeneralToSave.details.sort(function (m, n) {
                return m.minimumAmount - n.minimumAmount;
            });

            //The following checks to make sure the structure of the schedule is properly structured, with no gaps or overlap.
            var prevMaxAmt = 0;
            var levelsOverlapFlag = false;
            fsGeneralToSave.details.forEach(function (dtl) {
                if (dtl.rate > 0) {
                    dtl.rate = (dtl.rate / 100).toPrecision(4);
                }
                if (dtl.reducedRate > 0) {
                    dtl.reducedRate = (dtl.reducedRate / 100).toPrecision(4);
                }
                if (dtl.minimumAmount != prevMaxAmt) {
                    levelsOverlapFlag = true; //If there is a gap, flag the overlap
                }
                prevMaxAmt = dtl.maximumAmount;
            });

            if (levelsOverlapFlag) {
                //Tell the user there's a gap and they have to fix it, and return out
                $dialog
                    .messageBox(
                        "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Fee Schedule Invalid",
                        'The Schedule Structure must not contain gaps or overlaps between the max $ of one tier and the min $ of the next.'
                    )
                    .open();
                return;
            }

            if (abortMessages.length) {
                $dialog
                    .messageBox(
                        "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Data",
                        '<ul class="unstyled"</li>' + abortMessages.join('</li><li>') + '</li></lu>'
                    )
                    .open();
                return;
            }

            //The save/updates post to BillSchedulesController.cs
            //Save new - CreateEntity()
            if ($scope.current.fsId <= 0) {
                fsGeneralToSave.fsId = $scope.current.fsId;
                $http.post('/Billing/Schedules/', fsGeneralToSave, { trackerMsg: 'Adding fee schedule' }).then(function (response) {
                    editorHotKeys.destroy();
                    dialog.close(response.data);
                });
            }
            //Update existing - UpdateEntity()
            else {
                $http.put('/Billing/Schedules/' + $scope.current.fsId, fsGeneralToSave, { trackerMsg: 'Updating fee schedule' }).then(function (response) {
                    editorHotKeys.destroy();
                    dialog.close(response.data);
                });
            }
        };

        $scope.close = function (validate) {
            if (validate) {
                if (!angular.equals(fsGeneralOriginal, $scope.fsGeneral)) {
                    $scope.errors.push({
                        type: 'error',
                        title: 'Unsaved Changes! ',
                        msg: ' There are unsaved changes that will be lost.',
                        showAllowClose: true,
                    });
                } else {
                    editorHotKeys.destroy();
                    dialog.close(null);
                }
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        };
        //endregion

        //  region GENERAL
        $scope.setUseBasisPoints = function (sc) {
            var bdBillEntity = $scope.billingEntities.find({ description: 'Broker Dealer' });
            if (sc === billSchedulePayoutRates.bdOverrideSchedule.name || isFeeSchedule) {
                $scope.current.useBasisPoints = false;
                $scope.howBilled.remove({ name: 'Basis Points' });

                if (sc === billSchedulePayoutRates.bdOverrideSchedule.name) {
                    $scope.current.disableBillEntity = true;
                    $scope.fsGeneral.billEntityId = bdBillEntity.id;
                }
            } else {
                $scope.current.useBasisPoints = $scope.fsGeneral.howBilled === 1 ? true : false;
                $scope.current.disableBillEntity = false;
            }
        };

        //endregion

        //  region STRUCTURE

        $scope.addLevel = function () {
            setMaxValue();

            var lvl = {
                id: 0,
                //minimumAmount: maxValueOfAllLevels == 999999999 ? 0 : maxValueOfAllLevels,
                minimumAmount: maxValueOfAllLevels,
                maximumAmount: 9999999999,
                rate: 0,
                points: 0,
                flatFee: 0,
            };

            if (!$scope.fsGeneral.details) {
                $scope.fsGeneral.details = [];
            }

            $scope.fsGeneral.details.push(lvl);
        };

        $scope.removeLevel = function (dtl) {
            $dialog
                .confirmAction('Are you sure you want to remove this level?')
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $scope.fsGeneral.details.remove(dtl);
                    }
                });
        };
        //endregion

        //endregion

        // region INITIALIZE
        $scope.current = {
            selectedTab: args.defaultTab,
            fsId: args.isNew ? 0 : parseInt(args.ids[0]),
            feeOrPay: isFeeSchedule ? 'Fee Schedule' : 'Payout Rate',
            useBasisPoints: false,
            disableBillEntity: false,
            isReducedTiers: false,
            useApplyFullFeeHHAgg: false,
            payoutCreditOffsetEO: false,
            isFeeSchedule: isFeeSchedule,
            isUnassignedFee: false,
            disableApplyPayoutAccount: false,
        };

        $scope.fsGeneral = null;

        // LOOK UPS
        $scope.billingEntities = null;
        $scope.howBilled = null;
        $scope.billScheduleTypes = null;
        $scope.billBasis = null;
        $scope.allBillBasis = null;
        $scope.billFeeOrPay = null;
        $scope.checkHowBilled = isFeeSchedule ? howBilled : howBilledPayout;
        $scope.checkBillScheduleTypes = billScheduleTypes;

        $scope.errors = [];

        init();
        // endregion

        //region WATCHES

        $scope.$watch('fsGeneral.howBilled', function (newVal, oldVal) {
            if (newVal === oldVal) return;

            var hb = isFeeSchedule ? howBilled : howBilledPayout;

            if (
                newVal === hb.dollarAmount.value &&
                $scope.fsGeneral.type !== billScheduleTypes.flat.value &&
                $scope.fsGeneral.details.length > 1 &&
                !$scope.current.useBasisPoints
            ) {
                $dialog
                    .confirmAction(
                        "Changing to 'Dollar Amount' will change this to a flat schedule, and all but the first row in the Schedule Structure will be deleted.<br/><br/>Are you sure you want to continue?"
                    )
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            $scope.fsGeneral.type = billScheduleTypes.flat.value;
                            $scope.fsGeneral.basis = billBasis.client.name;
                            $scope.fsGeneral.details.removeAt(1, $scope.fsGeneral.details.length - 1);
                        } else {
                            $scope.fsGeneral.howBilled = oldVal;
                        }
                    });
            }

            if (
                newVal === hb.dollarAmount.value &&
                $scope.fsGeneral.type !== billScheduleTypes.flat.value &&
                $scope.fsGeneral.details.length === 1 &&
                !$scope.current.useBasisPoints
            ) {
                $scope.fsGeneral.type = billScheduleTypes.flat.value;
                $scope.fsGeneral.basis = billBasis.client.name;
            }

            checkDisableApplyPayoutAccount();
        });

        $scope.$watch('fsGeneral.type', function (newVal, oldVal) {
            if (newVal === oldVal) return;

            if (newVal === billScheduleTypes.flat.value && $scope.fsGeneral.details.length > 1) {
                $dialog
                    .confirmAction(
                        'Changing this to a flat schedule will cause all but the first row in the Schedule Structure to be deleted.<br/><br/>Are you sure you want to continue?'
                    )
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            $scope.fsGeneral.details.removeAt(1, $scope.fsGeneral.details.length - 1);
                            $scope.fsGeneral.basis = billBasis.client.name;
                        } else {
                            $scope.fsGeneral.type = oldVal;
                        }
                        // Update bill basis options when type changes
                        filterBillBasis();
                    });
            } else {
                // Update bill basis options when type changes
                filterBillBasis();
            }

            checkDisableApplyPayoutAccount();
        });

        $scope.$watch('fsGeneral.basis', function (newVal, oldVal) {
            if (newVal === oldVal) return;

            checkDisableApplyPayoutAccount();
        });

        //endregion
    }
);

'use strict';

app.controller(
    'FeeScheduleListCtrl',
    function FeeScheduleListCtrl($scope, $http, $oasRights, $location, $portfolio, $dialog, $routeParams, entities, views, apps) {
        // PRIVATE VARIABLES
        var isFeeSchedule = $routeParams.sched == 'fee' ? true : false;

        // PRIVATE METHODS
        function init() {
            if (isFeeSchedule) $scope.rightsFS = $oasRights.forCode('FEESCHEDULES');
            else $scope.rightsFS = $oasRights.forCode('PAYOUTSCHEDULES');

            if ($routeParams.source) {
                var key = apps.find({ code: $routeParams.source });
                $scope.middleBreadcrumb = key ? apps[key].name : null;
            }
        }

        function doAction(actionUrl, payload, msgVerb, confirmMsg, method) {
            $dialog
                .confirmAction(confirmMsg)
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        switch (method) {
                            case 'DELETE':
                                $http.delete(actionUrl, { trackerMsg: msgVerb + ' fee schedule' }).then(function () {
                                    $scope.$broadcast('event:portfoliolist-feeschedule-action', { action: 'refresh-grid' });
                                });
                                break;
                            case 'DELETE MULTIPLE':
                                $http.put(actionUrl, payload, { trackerMsg: msgVerb + ' fee schedule' }).then(function () {
                                    $scope.$broadcast('event:portfoliolist-feeschedule-action', { action: 'refresh-grid' });
                                });
                                break;
                        }
                    }
                });
        }

        // PUBLIC METHODS

        $scope.openEditor = function (isNew) {
            if ($scope.selectedIds.length == 1 || isNew) {
                $portfolio
                    .openEditor(entities.feeSchedule.value, isNew ? [] : $scope.selectedIds, 'General', 'fsGeneral', apps.portfolioLists.name, {
                        isFeeSchedule: isFeeSchedule,
                    })
                    .then(function (rslt) {
                        if (rslt) {
                            $scope.$broadcast('event:portfoliolist-feeschedule-action', { action: isNew ? 'add-item' : 'update-item', item: rslt });
                        }
                    });
            }
        };

        $scope.openEditorDuplicate = function () {
            if ($scope.selectedIds.length == 1) {
                $scope.selectedIds[0] = -1 * $scope.selectedIds[0];
                $portfolio
                    .openEditor(entities.feeSchedule.value, $scope.selectedIds, 'General', 'fsGeneral', apps.portfolioLists.name, {
                        isFeeSchedule: isFeeSchedule,
                    })
                    .then(function (rslt) {
                        if (rslt) {
                            $scope.$broadcast('event:portfoliolist-feeschedule-action', { action: 'add-item', item: rslt });
                        }
                    });
            }
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:portfoliolist-feeschedule-action', { action: 'export-data' });
        };

        $scope.deleteFeeSchedule = function () {
            doAction(
                '/Billing/Schedules/' + $scope.selectedIds[0],
                null,
                'Deleting',
                'Delete ' + $scope.current.feeOrPay.toLowerCase() + '.  Are you sure you want to proceed?',
                'DELETE'
            );
        };

        $scope.deleteFeeSchedules = function () {
            doAction(
                '/Billing/Schedules/Delete',
                $scope.selectedIds,
                'Deleting',
                'Delete ' + $scope.current.feeOrPay.toLowerCase() + '.  Are you sure you want to proceed?',
                'DELETE MULTIPLE'
            );
        };

        $scope.slickGridDoubleClick = function () {
            if ($scope.selectedIds.length === 1) $scope.openEditor(false);
        };

        $scope.goBack = function () {
            window.history.back();
        };

        // INITIALIZE
        $scope.views = views;

        $scope.selectedIds = [];
        $scope.current = {
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            url: '/Billing/Schedules',
            feeOrPay: isFeeSchedule ? 'Fee Schedule' : 'Payout Rate',
            params: isFeeSchedule
                ? 'schedule=Fee&schedule=PerformanceFee'
                : 'schedule=Payout&schedule=BDOverride&schedule=Remainder&schedule=PerformancePayout',
        };

        $scope.current.hotKeyActions = [
            {
                combo: 'ALT+E',
                command: function () {
                    if ($scope.selectedIds.length === 1) $scope.openEditor(false);
                },
            },
        ];

        init();
    }
);

'use strict';

app.controller('PayoutScheduleEditCtrl', function PayoutScheduleEditCtrl($scope, $http, $oasRights, $dialog, $timeout, dialog, args, entities) {
    // region PRIVATE VARIABLES
    var psGeneralOriginal = null,
        editorHotKeys;
    //endregion

    //region PRIVATE METHODS
    // region INIT/RIGHT/MENU/TABS
    function init() {
        loadRights();
        buildMenu();
        loadHotKeys();
        $scope.loadTab(args.defaultTab);
    }

    function loadRights() {
        $scope.rightsPayoutSchedule = $oasRights.forCode('MASTERPAYOUTSCHEDULE');
        checkBillingLockdown();
    }

    function checkBillingLockdown() {
        $http.get('/Authorization/User/Databases/LockDown', { trackerMsg: 'Checking Billing Lockdown' }).then(function (response) {
            let isBillingLockdownOverridePrivilege = $oasRights.forCode('billingLockdownOverride').canRead;
            $scope.isBillingLockdown = isBillingLockdownOverridePrivilege ? false : response.data === 'Billing';
        });
    }

    function buildMenu() {
        $scope.menu = { categories: [] };

        $scope.menu.categories.push({ name: 'Payout Schedule', children: [] });
        $scope.menu.categories[0].children.push({ name: 'General', active: false, code: 'psGeneral' });
        $scope.menu.categories[0].children.push({ name: 'Payout Rates', active: false, code: 'psPayoutRates' });
    }

    function loadDataForSelectedTab() {
        switch ($scope.current.selectedTab) {
            case 'psGeneral':
                if ($scope.rightsPayoutSchedule.canRead) {
                    loadPayoutSchedule();
                }
                break;
            case 'psPayoutRates':
                if ($scope.rightsPayoutSchedule.canRead) {
                    loadPayoutSchedule();
                }
                break;
        }
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                { combo: 'ALT+S', command: $scope.save },
                {
                    combo: 'ALT+X',
                    command: function () {
                        $scope.close(true);
                    },
                },
            ]);
        });
    }
    // endregion

    // region GENERAL
    function loadBillEntities(isNew) {
        var createDtl = function (beId) {
            var newDetail = {
                billEntityId: 0,
                billEntityDescription: '',
                billScheduleId: 0,
                billScheduleName: '',
                isRemainder: $scope.psGeneral.details.length > 0 ? false : true,
            };
            newDetail.billEntityId = beId;
            $scope.loadPayoutRates(newDetail, true, true);
        };

        if ($scope.billEntities === null) {
            $scope.billEntities = [];
            $http
                .get(
                    '/Billing/BillingEntities?status=ShowOnlyWithAssignedSchedules&schedule=Payout&schedule=BDOverride&schedule=Remainder&schedule=PerformancePayout',
                    { trackerMsg: 'Loading payable entities' }
                )
                .then(function (response) {
                    $scope.billEntities = response.data;
                    if (isNew) {
                        createDtl(response.data[0].id);
                    }
                });
        } else {
            if (isNew) {
                createDtl($scope.billEntities[0].id);
            }
        }
    }

    function loadPayoutSchedule() {
        if ($scope.psGeneral === null) {
            if ($scope.current.psId != 0 || $scope.current.isClone) {
                let psId = $scope.current.isClone ? $scope.current.copiedId : $scope.current.psId;

                $http.get('/Billing/MasterPayoutSchedule/' + psId, { trackerMsg: 'Loading payout schedule' }).then(function (response) {
                    if ($scope.current.isClone) {
                        response.data.name = `${response.data.name} COPY`;
                    }

                    $scope.psGeneral = response.data;

                    psGeneralOriginal = angular.copy($scope.psGeneral);
                    $scope.chkIsDefault = psGeneralOriginal.isDefault;

                    //load up payout rates based on selected billEntity
                    loadBillEntities(false);
                });
            } else {
                $scope.psGeneral = {
                    isPoints: false,
                    isDefault: false,
                    details: [],
                };
                loadBillEntities(true);
            }
        }
    }

    //endregion

    // region PAYOUT RATES

    //endregion

    //endregion

    // region PUBLIC METHODS
    //  region LOAD/CLOSE
    $scope.loadTab = function (child) {
        $scope.menu.categories.each(function (c) {
            c.children.each(function (ch) {
                ch.active = ch.code == child.code;
            });
        });

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab();
    };

    $scope.save = function () {
        var saveProcess = function () {
            if ($scope.current.psId == 0 || $scope.current.isClone) {
                $http.post('/Billing/MasterPayoutSchedule/', $scope.psGeneral, { trackerMsg: 'Saving payout schedule' }).then(function (response) {
                    editorHotKeys.destroy();
                    dialog.close(response.data);
                });
            } else {
                $http
                    .put('/Billing/MasterPayoutSchedule/' + $scope.current.psId, $scope.psGeneral, { trackerMsg: 'Saving payout schedule' })
                    .then(function (response) {
                        editorHotKeys.destroy();
                        dialog.close(response.data);
                    });
            }
        };

        if ($scope.psGeneral.isDefault && (!psGeneralOriginal || (psGeneralOriginal && $scope.psGeneral.isDefault != psGeneralOriginal.isDefault))) {
            $dialog
                .confirmAction(
                    'There can only be one payout schedule marked as default.<br/>Are you sure you want to make this change?<br/><br/>The previous payout schedule marked as default will be deselected.'
                )
                .open()
                .then(function (result) {
                    if (result === 'yes') saveProcess();
                });
        } else {
            saveProcess();
        }
    };

    $scope.close = function (validate) {
        if (validate) {
            if (!angular.equals(psGeneralOriginal, $scope.psGeneral)) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };
    //endregion

    //  region GENERAL

    $scope.loadPayoutRates = function (dtl, resetValue, isNew) {
        $http.get('/Billing/Schedules/Simple?billEntity=' + dtl.billEntityId, { trackerMsg: 'Loading payable rates' }).then(function (response) {
            dtl.payoutRates = response.data;
            if (resetValue) dtl.billScheduleId = response.data[0].id;
            if (isNew) $scope.psGeneral.details.push(dtl);
        });
    };

    //endregion

    //  region PAYOUT RATE

    $scope.addPayoutRate = function () {
        if (!$scope.psGeneral.details) {
            $scope.psGeneral.details = [];
        }
        loadBillEntities(true);
    };

    $scope.removePayoutRate = function (dtl) {
        $dialog
            .confirmAction('Are you sure you want to remove this payout rate?')
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.psGeneral.details.remove(dtl);
                }
            });
    };

    $scope.checkRemainders = function (chk) {
        $dialog
            .confirmAction(
                "There can only be one payout rate marked 'Is Remainder'.<br/>Are you sure you want to make this change?<br/><br/>The previous payout rate marked 'Is Remainder' will be deselected."
            )
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.psGeneral.details.forEach(function (dtl) {
                        if (!angular.equals(chk, dtl)) {
                            dtl.isRemainder = false;
                        }
                    });
                } else {
                    chk.isRemainder = false;
                }
            });
    };

    //endregion

    //endregion

    // region INITIALIZE
    $scope.current = {
        selectedTab: args.defaultTab,
        psId: args.isNew ? 0 : parseInt(args.ids[0]),
        isClone: args.extraInfo.isClone ?? false,
        copiedId: args.extraInfo.copiedId,
    };

    $scope.psGeneral = null;
    $scope.chkIsDefault = false;

    // LOOK UPS
    $scope.billEntities = null;

    $scope.errors = [];

    init();
    // endregion

    //region WATCHES

    //endregion
});

'use strict';

app.controller(
    'PayoutScheduleListCtrl',
    function PayoutScheduleListCtrl($scope, $http, $oasRights, $location, $portfolio, $dialog, $routeParams, entities, views, apps) {
        // PRIVATE VARIABLES

        // PRIVATE METHODS
        function init() {
            $scope.rightsPS = $oasRights.forCode('MASTERPAYOUTSCHEDULE');
        }

        function doAction(actionUrl, msgVerb, confirmMsg, method) {
            $dialog
                .confirmAction(confirmMsg)
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        switch (method) {
                            case 'DELETE':
                                $http.post(actionUrl, $scope.selectedIds, { trackerMsg: msgVerb + ' payout schedule' }).then(function (response) {
                                    if (response.data.length > 0) {
                                        $dialog
                                            .messageBox(
                                                "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Unable to delete following Items:",
                                                response.data
                                            )
                                            .open();
                                    }
                                    $scope.$broadcast('event:portfoliolist-payoutschedule-action', { action: 'refresh-grid' });
                                });
                                break;
                        }
                    }
                });
        }

        // PUBLIC METHODS

        $scope.openEditor = function (isNew) {
            if ($scope.selectedIds.length == 1 || isNew) {
                $portfolio
                    .openEditor(entities.billMasterPayout.value, isNew ? [] : $scope.selectedIds, 'General', 'psGeneral', apps.portfolioLists.name, null)
                    .then(function (rslt) {
                        if (rslt) {
                            $scope.$broadcast('event:portfoliolist-payoutschedule-action', { action: 'refresh-grid' });
                        }
                    });
            }
        };

        $scope.openEditorDuplicate = function () {
            if ($scope.selectedIds.length == 1) {
                $portfolio
                    .openEditor(entities.billMasterPayout.value, [], 'General', 'psGeneral', apps.portfolioLists.name, {
                        isClone: true,
                        copiedId: $scope.selectedIds,
                    })
                    .then(function (rslt) {
                        if (rslt) {
                            $scope.$broadcast('event:portfoliolist-payoutschedule-action', { action: 'refresh-grid' });
                        }
                    });
            }
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:portfoliolist-payoutschedule-action', { action: 'export-data' });
        };

        $scope.deletePayoutSchedule = function () {
            doAction('/Billing/MasterPayoutSchedule/Delete', 'Deleting', 'Delete payout schedule.  Are you sure you want to proceed?', 'DELETE');
        };

        $scope.slickGridDoubleClick = function () {
            if ($scope.selectedIds.length === 1) $scope.openEditor(false);
        };

        // INITIALIZE
        $scope.views = views;

        $scope.selectedIds = [];
        $scope.current = {
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            url: '/Billing/MasterPayoutSchedule',
            allowDelete: true,
        };

        $scope.current.hotKeyActions = [
            {
                combo: 'ALT+E',
                command: function () {
                    if ($scope.selectedIds.length === 1) $scope.openEditor(false);
                },
            },
        ];

        init();

        //EVENT LISTENERS
        $scope.$on('event:portfoliolist-payoutschedule-select', function (e, args) {
            if (args.length === 0) return;

            $scope.current.allowDelete = !args[0].isDefault;
        });
    }
);

'use strict';

app.controller(
    'BillingAuditRelatedHouseholdCtrl',
    function BillingAuditRelatedHouseholdCtrl($scope, $http, $dialog, $oasRights, views, $routeParams, apps, entities, $portfolio) {
        //PRIVATE VARIABLES

        // PUBLIC METHODS
        $scope.openEditor = function () {
            if ($scope.selectedIds.length == 1) {
                $portfolio
                    .openEditor(
                        entities.client.value,
                        $scope.selectedIds.map(function (id) {
                            return id.split('/')[0];
                        }),
                        'billingGeneral',
                        'relatedHouseholds',
                        apps.billingAudit.name,
                        null
                    )
                    .then(function (rslt) {
                        if (rslt) {
                            rslt.feePayingAccounts = rslt.feePayingAccounts === undefined ? 0 : rslt.feePayingAccounts;
                            rslt.relatedClients = rslt.relatedClients === undefined ? 0 : rslt.relatedClients;
                            rslt.recurrentAdjustments = rslt.recurrentAdjustments === undefined ? 0 : rslt.recurrentAdjustments;

                            $scope.$broadcast('event:billingaudit-relatedhousehold-action', { action: 'update-item', item: rslt });
                        }
                    });
            }
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:billingaudit-relatedhousehold-action', { action: 'export-data' });
        };

        $scope.slickGridDoubleClick = function () {
            if ($scope.selectedIds.length === 1) $scope.openEditor();
        };

        // PRIVATE METHODS

        function init() {
            $scope.rights = $oasRights.forCode('BILLAUDIT');

            if ($scope.user.authorization.entity === 'Representative') {
                $scope.current.isDisableActions = true;
            }
        }

        // INITIALIZE
        $scope.views = views;

        $scope.selectedIds = [];
        $scope.current = {
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            URL: '/Billing/RelatedBillingClient',
            status: $routeParams.status,
            isDisableActions: false,
        };

        $scope.current.hotKeyActions = [
            {
                combo: 'ALT+E',
                command: function () {
                    if ($scope.selectedIds.length === 1) $scope.openEditor();
                },
            },
        ];

        init();
    }
);

'use strict';

var referralPaymentsListCtrl = app.controller(
    'ReferralPaymentsCtrl',
    function ReferralPaymentsCtrl($scope, $http, $dialog, $oasRights, $portfolio, entities, views, config, $route) {
        $scope.selectedIds = [];
        $scope.views = views;
        $scope.current = { selectedReferralPayment: [], view: views[0], queryStringParams: {} };

        $scope.current.queryStringParams.batchId = config.referralPaymentParameters.batchId;
        $scope.current.queryStringParams.payeeId = config.referralPaymentParameters.payeeId;
        $scope.current.queryStringParams.startDate = config.referralPaymentParameters.startDate
            ? Date.create(config.referralPaymentParameters.startDate).formatted()
            : null;
        $scope.current.queryStringParams.endDate = config.referralPaymentParameters.endDate
            ? Date.create(config.referralPaymentParameters.endDate).formatted()
            : null;

        function doAction(actionUrl, msgVerb, confirmMsg) {
            $dialog
                .confirmAction(confirmMsg)
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $http.post(actionUrl, $scope.current.selectedReferralPayment, { trackerMsg: msgVerb + ' payment(s)' }).then(function (response) {
                            $scope.$broadcast('event:referralpayment-action', { action: 'delete-items', items: response.data });
                            loadHeader();
                        });
                    }
                });
        }

        $scope.calculatePayments = function () {
            var dialogOpts = {
                templateUrl: 'calculatePayments.html',
                controller: 'CalculatePaymentsCtrl',
            };

            var d = $dialog.dialog(dialogOpts);
            d.open().then(function (rslt) {
                if (rslt) {
                    var args = {
                        method: 'PUT',
                        id: 0,
                        url: '/Billing/ReferralPayments/Action/CalculateBatch',
                        trackerMsg: 'Starting referral payment calculation',
                    };
                    $http({ method: args.method, url: args.url, data: rslt, trackerMsg: args.trackerMsg }).then(function (response) {
                        if (!response.data) {
                            $dialog
                                .messageBox(
                                    "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Referral Payment Calculation!",
                                    'No payment calculations processed with this criteria.'
                                )
                                .open();
                        } else {
                            $scope.$broadcast('event:referralpayment-action', { action: 'refresh-grid' });
                            loadHeader();
                        }
                    });
                }
            });
        };

        $scope.$on('event:referralpayment-select', function (e, args) {
            $scope.current.selectedReferralPayment = args.map('id').unique();
            $scope.current.selectedAccountNumber = args.map('accountNumber').unique();
        });

        $scope.$on('event:client-action', function (e, args) {
            if (args.action == 'delete') {
                loadHeader();
            }
        });

        $scope.startOver = function () {
            $route.reload();
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:referralpayment-action', { action: 'export-data', separatedFileColumns: ['Payee Name'] });
        };

        $scope.deleteReferralPayments = function () {
            doAction('/Billing/ReferralPayments/Delete', 'Deleting', 'Delete payments(s).  Are you sure you want to proceed?');
        };

        $scope.openAccountEditor = function () {
            $http
                .get('/Portfolio/Accounts/Simple/Search/' + $scope.current.selectedAccountNumber, { trackerMsg: 'Retrieving account information' })
                .then(function (response) {
                    if (response.data && response.data.length > 0) {
                        $portfolio.openEditor(entities.account.value, [response.data[0].id], 'Referral Schedules', 'referralSchedules', null);
                    }
                });
        };

        function loadHeader() {
            $http
                .get(
                    '/Billing/ReferralPayments/Counts?batchId=' +
                        $scope.current.queryStringParams.batchId +
                        '&payeeId=' +
                        $scope.current.queryStringParams.payeeId +
                        '&startDate=' +
                        $scope.current.queryStringParams.startDate +
                        '&endDate=' +
                        $scope.current.queryStringParams.endDate,
                    { trackerMsg: 'Loading Referral Payment Counts' }
                )
                .then(function (response) {
                    $scope.current.counts = response.data;
                });
        }

        function initialize() {
            loadHeader();
        }

        $scope.rightsReferralPayments = $oasRights.forCode('REFERRALSCHEDULE');

        initialize();
    }
);

referralPaymentsListCtrl.loadReferralPaymentConfig = [
    '$dialog',
    '$route',
    '$q',
    function ($dialog, $route, $q) {
        return $dialog
            .dialog({ templateUrl: 'billing/views/referralPaymentViewOptions.html', controller: 'ReferralPaymentViewOptionsCtrl' })
            .open()
            .then(function (result) {
                if (result) return { referralPaymentParameters: result };
                else {
                    var deferred = $q.defer();
                    deferred.reject();
                    return deferred.promise;
                }
            });
    },
];

app.controller('CalculatePaymentsCtrl', function CalculatePaymentsCtrl($scope, dialog) {
    //Public Methods
    $scope.close = function (sendValue) {
        dialog.close(sendValue ? $scope.referralCalculation : null);
    };

    $scope.referralCalculation = {
        BatchName: null,
        DateRangeStart: null,
        DateRangeEnd: null,
        BillPeriodStartDate: null,
    };
});

'use strict';

app.controller('ReferralPaymentViewOptionsCtrl', function ReferralPaymentViewOptionsCtrl($scope, $http, dialog) {
    // PUBLIC METHODS
    $scope.close = function (sendValue) {
        dialog.close(sendValue ? $scope.referralPaymentViewOption : null);
    };

    // PRIVATE METHODS
    function loadBatchList() {
        $http.get('/Billing/ReferralPayments/Batch', { trackerMsg: 'Loading batch list' }).then(function (response) {
            $scope.referralBatchList = response.data;
        });
    }

    function loadPayeeList() {
        $http.get('/Billing/ReferralPayments/Payee', { trackerMsg: 'Loading payee list' }).then(function (response) {
            $scope.referralPayeeList = response.data;
        });
    }

    // INITIALIZE
    $scope.current = {};
    $scope.referralPaymentViewOption = { batchId: null, batchName: null, payeeId: null, startDate: null, endDate: null, billPeriodStart: null };

    loadBatchList();
    loadPayeeList();
});

'use strict';

var referralPaymentSchedulesCtrl = app.controller(
    'ReferralPaymentSchedulesCtrl',
    function ReferralPaymentSchedulesCtrl($scope, $http, $dialog, $portfolio, entities, listSectionData, $oasRights, $location, $routeParams) {
        //PRIVATE VARIABLES
        var referralScheduleId = $routeParams.referralscheduleId;
        var referralScheduleUrl = '/Billing/ReferralPayouts';
        $scope.referralSchedules = [];
        $scope.referralSchedule = {};

        var dataItemsEvent = 'event: data-items';
        var dataItemDeleteEvent = 'event: data-item-delete';

        $scope.amountTypes = ['Percent', 'Dollars'];
        $scope.payoutFrequencies = ['Quarterly', 'Annually'];
        $scope.referralPayoutTypes = ['Perpetual', 'Tiers', 'One-Time'];

        function init() {
            listSectionData.dataItems = [];
            if (referralScheduleId == 0) {
                $scope.referralSchedule = {
                    id: 0,
                    payoutName: '',
                    payoutType: 'Perpetual',
                    amountType: 'Percent',
                    payoutFrequency: 'Quarterly',
                    amounts: '0',
                    accountReferrals: [],
                };
            } else {
                loadReferralSchedule();
            }
        }

        function openAccountEditor(accountId) {
            $http.get('/Portfolio/Accounts/Simple/Search/' + accountId, { trackerMsg: 'Retrieving account information' }).then(function (response) {
                if (response.data && response.data.length > 0) {
                    $portfolio
                        .openEditor(entities.account.value, [response.data[0].id], 'Referral Schedules', 'referralSchedules', 'referralSchedules', null)
                        .then(function (result) {
                            if (result) {
                                loadReferralSchedule();
                            }
                        });
                }
            });
        }

        function loadReferralSchedule() {
            $scope.referralSchedule = {};

            $http.get(referralScheduleUrl + '/' + referralScheduleId, { trackerMsg: 'Loading referral schedule' }).then(function (response) {
                $scope.referralSchedule = response.data;
                listSectionData.dataItems = response.data.accountReferrals;
                $scope.$broadcast(dataItemsEvent);
            });
        }

        $scope.saveReferralPayoutSchedule = function (form) {
            var executeSave = function () {
                $http({ method: args.method, url: args.url, data: $scope.referralSchedule, trackerMsg: args.trackerMsg }).then(function (response) {
                    referralScheduleId = response.data.id;
                    $location.path('/billing/referralschedules');
                });
            };

            if (form.$valid) {
                var args =
                    referralScheduleId > 0
                        ? {
                              method: 'PUT',
                              url: referralScheduleUrl + '/' + referralScheduleId,
                              trackerMsg: 'Saving referral payout schedule ' + referralScheduleId,
                          }
                        : { method: 'POST', url: referralScheduleUrl, trackerMsg: 'Adding new referral payout schedule' };
                executeSave();
            } else {
                $dialog
                    .messageBox(
                        "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Referral Schedule Page Is Invalid!",
                        'One or more fields on the referral schedule page are invalid or required, please correct and try saving again.'
                    )
                    .open();
            }
        };

        $scope.deleteReferralPayoutSchedule = function () {
            $dialog
                .confirmAction(
                    "<span style='font-size: 14px;'>Are you sure you want to delete </span>" + $scope.referralSchedule.payoutName + '<span>, continue? </span>'
                )
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        if ($scope.referralSchedule.accountReferrals.length > 0 && $scope.referralSchedule.accountReferrals) {
                            $dialog
                                .messageBox(
                                    "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Referral Schedule Warning",
                                    '<p><b>' +
                                        $scope.referralSchedule.payoutName +
                                        '</b> has assigned accounts. Please remove accounts before trying to delete this referral schedule.</p><p>You can click on the Account Id to access referral schedule on account</p>'
                                )
                                .open();
                        } else {
                            $http
                                .delete(referralScheduleUrl + '/' + referralScheduleId, {
                                    trackerMsg: 'Deleting referral payout schedule ' + referralScheduleId,
                                })
                                .then(function () {
                                    $location.path('/billing/referralschedules');
                                });
                        }
                    }
                });
        };

        $scope.editReferralScheduleAmount = function (schedule) {
            var dialogOpts = {
                templateUrl: 'referral-schedule-amount.html',
                controller: 'ReferralScheduleAmountCtrl',
                schedule: schedule,
            };

            var d = $dialog.dialog(dialogOpts);
            d.open().then(function (rslt) {
                if (rslt) {
                    schedule.amounts = rslt;
                }
            });
        };

        $scope.$on('item-action', function (e, args) {
            if (args.action === 'edit-account-schedule') {
                openAccountEditor(args.item.accountId);
            }
        });

        $scope.rightsReferralSchedule = $oasRights.forCode('REFERRALSCHEDULE');

        $scope.current = [
            {
                selectedItems: [],
                additionalLinks: [{ name: 'New Referral Payout Schedule', url: '#/billing/referralschedules/0', icon: 'fa fa-pencil' }],
            },
        ];

        $scope.accountListConfig = {
            listName: 'Assigned Accounts',
            template: 'accountReferralList.html',
            headerTemplate: 'accountReferralList-header.html',
            icon: 'fa fa-users',
            selectEnabled: false,
            fieldToSort: 'accountName',
            loadDataItemsEvent: dataItemsEvent,
            deleteItemEvent: dataItemDeleteEvent,
            multiSelectEnabled: false,
            nameProperty: 'name',
            takeInterval: 50000,
            showLink: true,
            sortFields: {
                accountName: 'Account Name',
                accountId: 'Account Id',
                startDate: 'Schedule Start',
                completeDate: 'Complete Date',
            },
            listFilter: ['accountName', 'accountId', 'startDate', 'completeDate'],
            additionalLinks: [],
        };

        init();
    }
);

app.controller('ReferralScheduleAmountCtrl', function ReferralScheduleAmountCtrl($scope, $oasRights, dialog) {
    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close(null);
    };

    $scope.close = function () {
        if ($scope.current.schedule.payoutType == 'Tiers') {
            $scope.current.amounts = $scope.current.amountsTiered.join();
        }
        dialog.close($scope.current.amounts);
    };

    $scope.addSchedule = function () {
        if ($scope.current.amountsTiered == null) {
            $scope.current.amountsTiered = [];
        }

        $scope.current.amountsTiered.push(0);
    };

    $scope.deleteSchedule = function (idx) {
        $scope.current.amountsTiered.splice(idx, 1);
    };

    // PRIVATE METHODS
    function init() {
        if ($scope.current.schedule.payoutType != 'Tiers') {
            $scope.current.amounts = parseInt($scope.current.amounts);
        } else {
            if ($scope.current.amounts) {
                $scope.current.amountsTiered = $scope.current.amounts.split(',');
                if ($scope.current.amountsTiered) {
                    for (var i = 0; i < $scope.current.amountsTiered.length; i++) {
                        $scope.current.amountsTiered[i] = parseInt($scope.current.amountsTiered[i]);
                    }
                }
            }
        }
    }

    // INITIALIZE
    $scope.current = {
        schedule: dialog.options.schedule,
        amounts: dialog.options.schedule.amounts,
        amountsTiered: null,
    };

    $scope.rightsReferralSchedule = $oasRights.forCode('REFERRALSCHEDULE');

    init();
});

app.controller('ReferralScheduleListCtrl', function ReferralScheduleListCtrl($scope, $http, listSectionData, $dialog, $oasRights) {
    var dataItemsEvent = 'event: data-items';

    function init() {
        $scope.current.canProcess = $oasRights.canUpdate('REFERRALSCHEDULE');
        getReferralSchedules();
    }

    function getReferralSchedules() {
        $http.get('/Billing/ReferralPayouts', { trackerMsg: 'Loading referral schedules' }).then(function (response) {
            $scope.referralSchedules = response.data;
            listSectionData.dataItems = response.data;
            $scope.$broadcast(dataItemsEvent);
        });
    }

    $scope.listConfig = {
        listName: 'Referral Schedules',
        template: 'scheduleList.html',
        icon: 'fa fa-users',
        selectEnabled: false,
        multiSelectEnabled: false,
        loadDataItemsEvent: dataItemsEvent,
        nameProperty: 'name',
        fieldToSort: 'payoutName',
        takeInterval: 50000,
        showLink: false,
        sortFields: {
            payoutName: 'Referral Name',
            id: 'Referral Id',
            payoutType: 'Payout Type',
            accountReferralCount: '# of accounts',
            amounts: 'Amounts',
            createdDate: 'Created Date',
            editedBy: 'Edited By',
        },
        listFilter: ['name', 'amountType', 'payoutType', 'payoutFrequency', 'editedBy', 'id'],
        additionalLinks: [{ name: 'New Referral Payout Schedule', url: '#/billing/referralschedules/0', icon: 'fa fa-pencil' }],
    };

    $scope.resetImport = function () {
        $scope.referralScheduleImporter.schedules = null;
        $scope.current.creatingFromImport = false;
        $scope.resetWidth(false);
    };

    $scope.resetWidth = function (goWide) {
        $scope.rightSidebar.width = goWide ? 500 : 250;
    };

    $scope.createSchedulesFromImport = function () {
        var validSchedules = $scope.referralScheduleImporter.schedules.findAll({ isValid: true });
        var urlSave = '/Portfolio/Accounts/Verbose/';

        if (validSchedules.length > 0) {
            $scope.current.creatingFromImport = true;
            $http({ method: 'PUT', url: urlSave, data: validSchedules, trackerMsg: 'Importing accounts to referral schedule' }).then(function () {
                $dialog
                    .messageBox('Import Complete!', 'The following ' + validSchedules.length + ' records were imported successfully')
                    .open()
                    .then(function (result) {
                        getReferralSchedules();
                        $scope.resetImport();
                    });
            });
        }
    };

    $scope.$watch('referralScheduleImporter.schedules', function (newValue, oldValue) {
        if (newValue === oldValue || !newValue) return;

        if ($scope.referralScheduleImporter.schedules && $scope.referralScheduleImporter.schedules.length > 0) {
            var validSchedules = $scope.referralScheduleImporter.schedules.findAll({ isValid: true });
            var inValidSchedules = $scope.referralScheduleImporter.schedules.findAll({ isValid: false });

            if (inValidSchedules && inValidSchedules.length > 0) {
                var message = $scope.referralScheduleImporter.schedules.length == 1 ? ' record.' : " records. (this total is all the unique account id's)";
                $dialog
                    .messageBox(
                        'Invalid referral schedules found on import !',
                        'Import file contains ' +
                            $scope.referralScheduleImporter.schedules.length +
                            message +
                            "<br><span style='font-weight: bolder;font-size: 11px'>" +
                            validSchedules.length +
                            ' are valid.</span>' +
                            "<br><span style='font-weight: bolder;font-size: 11px'>" +
                            inValidSchedules.length +
                            '</span> are invalid.' +
                            '<br><br><em>For large import files you may need to scroll through the list to find all invalid records!</em>'
                    )
                    .open();
            }
        }
    });

    $scope.current = { canProcess: false, creatingFromImport: false };
    $scope.referralScheduleImporter = { schedules: null };
    $scope.referralSchedules = [];
    init();
});

'use strict';

app.controller(
    'BillingAuditFileListCtrl',
    function BillingAuditFileListCtrl($scope, $http, $dialog, listSectionData, $portfolio, $oasRights, API_CONFIG, $routeParams, $window, apps) {
        // PRIVATE VARIABLES
        var dataItemsEvent = 'event: data-items';

        //PRIVATE METHODS
        function downloadAuditFile(fileId) {
            window.location.href = API_CONFIG.baseUrl + '/Billing/Audit/' + fileId + '/File?Authorization=' + sessionStorage.oas_token;
        }

        function deleteFile(fileId) {
            $http.delete('/Billing/Audit/' + fileId + '/File', { trackerMsg: 'Deleting file', headers: { Unmasquerade: 'true' } }).then(function () {
                listSectionData.dataItems.remove({ id: fileId });
                $scope.$broadcast(dataItemsEvent);
            });
        }

        function init() {
            if ($routeParams.source) {
                var key = apps.find({ code: $routeParams.source });
                $scope.middleBreadcrumb = key ? apps[key].name : null;
            }

            if ($routeParams.auditType) {
                if ($routeParams.auditType === 'FeeFiles') {
                    $scope.current.feeFileActive = true;
                    $scope.current.auditFileActive = false;
                } else {
                    $scope.current.auditFileActive = true;
                    $scope.current.feeFileActive = false;
                }
            }

            if ($routeParams.instanceId) {
                $scope.current.instanceId = $routeParams.instanceId;
            }
        }

        // PUBLIC METHODS
        $scope.downloadFile = function (file) {
            if (file.isResponse) {
                window.location.href = API_CONFIG.baseUrl + '/Confirm/DownloadFiles/' + file.id + '/Download?Authorization=' + sessionStorage.oas_token;
            } else {
                window.location.href = API_CONFIG.baseUrl + '/Trading/TradeFiles/' + file.id + '/File?Authorization=' + sessionStorage.oas_token;
            }
        };

        $scope.updateFiles = function () {
            if ($scope.current.instanceId) {
                $http
                    .get('/Billing/Audit/AuditFiles?billInstanceId=' + $scope.current.instanceId, { trackerMsg: 'Loading audit files' })
                    .then(function (response) {
                        listSectionData.dataItems = response.data;
                        $scope.$broadcast(dataItemsEvent);
                    });
            } else {
                if ($routeParams.subsource) {
                    $scope.rightSidebarSettings.startDate = Date.create($routeParams.startDate);
                    $scope.rightSidebarSettings.endDate = Date.create($routeParams.endDate);

                    $http
                        .get(
                            '/Reporting/StaticFiles/BillingAuditFile?startDate=' +
                            $scope.rightSidebarSettings.startDate.format('{yyyy}-{MM}-{dd}') +
                            '&endDate=' +
                            new Date($scope.rightSidebarSettings.endDate).advance('1 day').format('{yyyy}-{MM}-{dd}'),
                            { trackerMsg: 'Loading audit files' }
                        )
                        .then(function (response) {
                            listSectionData.dataItems = response.data;
                            $scope.$broadcast(dataItemsEvent);
                        });
                } else {
                    $http
                        .get(
                            '/Billing/Audit/AuditFiles?startDate=' +
                            $scope.rightSidebarSettings.startDate.format('{yyyy}-{MM}-{dd}') +
                            '&endDate=' +
                            new Date($scope.rightSidebarSettings.endDate).advance('1 day').format('{yyyy}-{MM}-{dd}'),
                            { trackerMsg: 'Loading audit files' }
                        )
                        .then(function (response) {
                            listSectionData.dataItems = response.data;
                            $scope.$broadcast(dataItemsEvent);
                        });
                }
            }

            $http
                .get(
                    '/Trading/TradeFiles/Fees?startDate=' +
                    $scope.rightSidebarSettings.startDate.format('{yyyy}-{MM}-{dd}') +
                    '&endDate=' +
                    new Date($scope.rightSidebarSettings.endDate).advance('1 day').format('{yyyy}-{MM}-{dd}'),
                    { trackerMsg: 'Loading fee files' }
                )
                .then(function (response) {
                    $scope.feeFiles = response.data;

                    $scope.feeFiles.forEach(function (ff) {
                        if (ff.tradeFormat === 'Response File') {
                            ff.isResponse = true;
                        }
                    });

                    if ($scope.rightsSchwabMgmtFeeUpload.canRead) {
                        // Check if there's a Schwab fee file
                        var schwabFeeFiles = $scope.feeFiles.findAll(function (feeFile) {
                            var fnRegEx = /[\w\d-]{8}_SchFee_\d{6}_\d{6}\.(?:txt|csv)/;
                            return fnRegEx.test(feeFile.fileName);
                        });

                        // Only call UserAuthorization if there are Schwab Fee Files
                        if (schwabFeeFiles.length > 0) {
                            $http
                                .get('/Integrations/SchwabSII/UserAuthorization', { trackerMsg: 'Authentication with Schwab for uploading permission.' })
                                .then(function (response) {
                                    if (response.data.data) {
                                        if (response.data.data.attributes.authorizations.length != 0) {
                                            $scope.current.userAuthorizations = response.data.data.attributes.authorizations;
                                            if ($scope.current.userAuthorizations.find(x => x.authorization == "Access Upload Files" && x.isAuthorized == true)) {
                                                // Give User Link to Go to Schwab
                                                $scope.feeFiles.forEach(function (feeFile) {
                                                    var fnRegEx = /[\w\d-]{8}_SchFee_\d{6}_\d{6}\.(?:txt|csv)/;
                                                    if (fnRegEx.test(feeFile.fileName)) {
                                                        feeFile.isSchwab = true;
                                                    } else {
                                                        feeFile.isSchwab = false;
                                                    }
                                                });
                                            }
                                        }
                                    }
                                });
                        }
                    } else {
                        $scope.feeFiles.forEach(function (ff) {
                            ff.isSchwab = false;
                        });
                    }

                    $scope.feeFiles.sort(function (a, b) {
                        a = new Date(a.createdDate);
                        b = new Date(b.createdDate);
                        return a > b ? -1 : a < b ? 1 : 0;
                    });
                });
        };

        $scope.generateAuditFiles = function () {
            $dialog
                .dialog({ dialogClass: 'modal wide', templateUrl: 'payable-summary-options.html', controller: 'PayableSummaryOptionsCtrl' })
                .open()
                .then(function (result) {
                    if (result) {
                        $http.post('/Billing/PostAuditFiles', result, { trackerMsg: 'Generating audit files' }).then(function () {
                            $scope.updateFiles();
                        });
                    }
                });
        };

        $scope.generatePayableSummaryByRep = function () {
            $dialog
                .dialog({ dialogClass: 'modal wide', templateUrl: 'payable-summary-options-by-rep.html', controller: 'PayableSummaryOptionsByRepCtrl' })
                .open();
        };

        $scope.goBack = function () {
            window.history.back();
        };

        $scope.getSchwab = function (fileId) {
            // checking for user Authorization, if user is not authorized it will show Authenticate button
            const url = `../api/v1/Integrations/SchwabAlliance/UserToken?Authorization=${sessionStorage.oas_token}`;
            $http.get(url, { trackerMsg: 'Authenticating User for Schwab', ignoreExceptions: [500] }).then(function (response) {
                if (response && response.data.access_token != null && response.data.access_token.length > 0) {
                    $scope.showAuthenticateBtn = false;
                    //If token exists for the user, proceed with the call for master details and SSO into Schwab
                    $http.post('/Billing/FeeFile/Action/Schwab?blobId=' + fileId, null, { trackerMsg: 'Download Schwab file' }).then(function (response) {
                        if (response.data) {
                            var masterAccountId = response.data.masterAccountId;

                            //it will redirect to Schwab when User is Authorized
                            $window.open(API_CONFIG.baseUrl +
                                '/Integrations/SchwabSII/SsoV2/10?Authorization=' +
                                sessionStorage.oas_token +
                                "&subaccount=" +
                                masterAccountId);
                        }
                    }).catch(function (error){ console.log("error occurred", error); });
                } else $scope.showAuthenticateBtn = true;
            }).catch(function (error) {
                if (error.status === 500) {
                    $scope.showAuthenticateBtn = true;
                }
            });
        }

        //it will remove Popup when User clicks on Cancel button
        $scope.cancel = function () {
            $scope.showAuthenticateBtn = false;
        };

        // $scope.getTDFile = function (fileId) {
        //     $http.post('/Billing/FeeFile/Action/TD?blobId=' + fileId, null, { trackerMsg: 'Download TD File' }).then(function (response) {
        //         var request = { referenceId: response.data, tdaContext: 'managementFees' };
        //         $window.open(
        //             API_CONFIG.baseUrl +
        //                 '/Integrations/TDAmeritrade/Action/StartSSO?referenceId=' +
        //                 request.referenceId +
        //                 '&tdaContext=' +
        //                 request.tdaContext +
        //                 '&Authorization=' +
        //                 sessionStorage.oas_token
        //         );
        //     });
        // };

        // $scope.sendSFTP = function (file) {
        //     $http
        //         .post('/Billing/FeeFile/Action/SFTP?blobId=' + file.id + '&uploadTargetId=' + file.uploadTargetId, null, {
        //             trackerMsg: 'Sending file through STFP',
        //         })
        //         .then(function () {
        //             $scope.$broadcast(dataItemsEvent);
        //         });
        // };

        // INITIALIZE
        $scope.configAudit = {
            getUrl: null,
            listName: 'Billing Audit Files',
            template: 'billingaudit-file-list-item.html',
            icon: 'fa fa-users',
            selectEnabled: false,
            multiSelectEnabled: false,
            loadDataItemsEvent: dataItemsEvent,
            sortFields: { createdDate: 'CreatedDate' },
            fieldToSort: 'createdDate',
            sortAsc: true,
            listFilter: ['blobDesc', 'createdDate', 'fileName'],
            additionalLinks: [],
            rights: $oasRights.forCode('AUDITFILES'),
        };

        $scope.current = {
            feeFileActive: false,
            auditFileActive: true,
            instanceId: null,
        };

        $scope.feeFiles = null;
        $scope.rightsBillAudit = $oasRights.forCode('BILLAUDIT');
        $scope.rightsSchwabMgmtFeeUpload = $oasRights.forCode('SCHWABMANAGEMENTFEEUPLOAD');
        $scope.rightsTdaMgmtFeeUpload = $oasRights.forCode('TDAMANAGEMENTFEEUPLOAD');

        $scope.rightSidebarSettings = { startDate: Date.create('180 days ago'), endDate: Date.create() };
        init();

        $scope.updateFiles();

        //EVENT REGISTRATIONS
        $scope.$on('item-action', function (e, args) {
            if (args.action === 'download-file') {
                downloadAuditFile(args.item.id);
            } else if (args.action === 'delete-file') {
                deleteFile(args.item.id);
            }
        });
    }
);

app.controller('PayableSummaryOptionsCtrl', function PayableSummaryOptionsCtrl($scope, $http, dialog) {
    $scope.run = function () {
        var entity = {};

        switch ($scope.current.additionalType) {
            case 0:
                break;
            case 1:
                entity = { entity: 12, selected: true, ids: $scope.current.isAllFF ? [] : $scope.current.selectedFundFamilies.map('id') };
                break;
            case 2:
                entity = { entity: 18, selected: true, ids: $scope.current.isAllCustodian ? [] : $scope.current.selectedCustodian.map('id') };
                break;
            case 3:
                entity = { entity: 79, selected: true, ids: $scope.current.isAllBusinesslines ? [] : [$scope.current.selectedBusinesslines] };
                break;
        }

        var options = {
            billData: false,
            payableSummary: false,
            billAudit: false,
            billInstanceIds: $scope.current.billInstances,
            startDate: $scope.current.begDate.formatted(),
            endDate: $scope.current.endDate.formatted(),
            entityList: $scope.current.additionalType === 0 ? [] : [entity],
        };

        dialog.close(options);
    };
    $scope.close = function () {
        dialog.close(null);
    };

    $scope.current = {
        additionalType: 0,
        begDate: Date.create('30 days ago'),
        endDate: Date.create(),
        selectedFundFamilies: [],
        selectedCustodian: [],
        selectedBusinesslines: null,
        runFor: 1,
        billInstances: '',
        isAllFF: true,
        isAllCustodian: true,
        isAllBusinesslines: true,
    };
});

app.controller('PayableSummaryOptionsByRepCtrl', function PayableSummaryOptionsByRepCtrl($scope, $http, dialog, API_CONFIG, $dialog) {
    $scope.current = {
        runFor: 1,
        billInstances: '',
    };

    $scope.run = function () {
        $scope.current.entityList.forEach(function (entity) {
            entity.ids = entity.ids.map('id');
        });

        var options = {
            startDate: $scope.current.begDate.formatted(),
            endDate: $scope.current.endDate.formatted(),
            billInstanceIds: $scope.current.billInstances,
            entityList: $scope.current.entityList,
        };

        $http.post('/Billing/PayablesByRep', options, { trackerMsg: 'Generating payable summary by rep' }).then(function (res) {
            var payload = {
                startDate: $scope.current.begDate.formatted(),
                endDate: $scope.current.endDate.formatted(),
                keys: res.data,
            };

            $http.post('/Billing/Audit/PayablesByRep', payload, { trackerMsg: 'Getting payable summary files for rep' }).then(function (res) {
                $scope.payableSummaryFiles = res.data;
                $scope.current.tab.results = true;
            });
        });
    };

    $scope.viewPayables = function () {
        var payload = $scope.payableSummaryFiles.findAll({ isSelected: true }).map('fileId');

        $http.post('/Billing/Audit/PayablesByRep/Action/Download', payload, { trackerMsg: 'Getting payable summary files for rep' }).then(function (res) {
            window.location.href = res.headers().location + '?Authorization=' + sessionStorage.oas_token;
        });
    };

    $scope.postPayables = function () {
        var payload = $scope.payableSummaryFiles.findAll({ isSelected: true }).map('fileId');

        $http.post('/Billing/Audit/PayablesByRep/Action/SendFile', payload, { trackerMsg: 'Getting payable summary files for rep' }).then(function (res) {
            $dialog.actionComplete('File has been sent successfully.').open();
        });
    };

    $scope.getPayablesByRep = function () {
        var payload = {
            startDate: $scope.current.begDate.formatted(),
            endDate: $scope.current.endDate.formatted(),
            keys: [],
        };

        $http.post('/Billing/Audit/PayablesByRep', payload, { trackerMsg: 'Getting payable summary files for rep' }).then(function (res) {
            $scope.payableSummaryFiles = res.data;
        });
    };

    $scope.toggleCheckAll = function (isAll) {
        $scope.payableSummaryFiles.forEach(function (file) {
            file.isSelected = isAll;
        });

        $scope.checkViewable();
    };

    $scope.downloadFile = function (fileId) {
        window.location.href = API_CONFIG.baseUrl + '/Billing/Audit/PayablesByRep/' + fileId + '?Authorization=' + sessionStorage.oas_token;
    };

    $scope.checkViewable = function () {
        $scope.current.isViewable = $scope.payableSummaryFiles.findAll({ isSelected: true }).length > 0;
    };

    $scope.close = function () {
        dialog.close(null);
    };

    $scope.payableSummaryFiles = [];

    $scope.current = {
        tab: {
            options: true,
            results: false,
        },
        isViewable: false,
        additionalType: 0,
        begDate: Date.create('30 days ago'),
        endDate: Date.create(),
        selectedFundFamilies: [],
        selectedCustodian: [],
        selectedBusinesslines: null,
        isAllFF: true,
        isAllCustodian: true,
        isAllBusinesslines: true,
        runFor: 1,
        billInstances: '',
        entityList: [
            {
                entity: 18,
                ids: [],
                selected: false,
            },
            {
                entity: 12,
                ids: [],
                selected: false,
            },
            {
                entity: 79,
                ids: [],
                selected: false,
            },
        ],
    };
});

'use strict';

app.service('$billing', [
    '$http',
    '$dialog',
    'entities',
    function ($http, $dialog, entities) {
        var self = this;

        self.runAdvisoryFeeReport = function (entityEnum, pkEntity) {
            if (entityEnum == entities.client.value) {
                runAdvisoryFee(pkEntity);
            } else if (entityEnum == entities.account.value) {
                $http.get('/Portfolio/Accounts/' + pkEntity, { trackerMsg: 'Getting household ' + pkEntity }).then(function (response) {
                    runAdvisoryFee(response.data.clientId);
                });
            }
        };

        function runAdvisoryFee(pkClient) {
            $http.get('/Reporting/Reports/Code/Advisory Fee Notification', { trackerMsg: 'Loading advisory fee report' }).then(function (response) {
                var reportData = response.data;
                $http.get('/Portfolio/Clients/' + pkClient + '/Bills', { trackerMsg: 'Loading most recent bill' }).then(function (response) {
                    if (response.data.length > 0) {
                        var reportArgs = { EntityEnum: entities.bill.value, PkEntity: response.data.max('calcDate').id.toString() };
                        $dialog.reportPrompt(reportData.id, reportArgs).open();
                    }
                });
            });
        }
    },
]);

'use strict';

app.controller('FeeCalculatorCtrl', function FeeCalculatorCtrl($scope, $http, $oasRights) {
    // PUBLIC METHODS
    $scope.refreshGrid = function () {
        $http
            .get('/Billing/Schedules/' + $scope.current.feeScheduleId + '/Calculate?amount=' + $scope.current.value, { trackerMsg: 'Calculating fee amounts' })
            .then(function (response) {
                $scope.fees = response.data;
            });
    };

    // INITIALIZE
    $scope.current = { feeScheduleId: 0, value: '' };
    $scope.fees = null;

    $scope.rightsFeeCalculator = $oasRights.forCode('FEECALCULATORAPP');
});

'use strict';

app.controller('BillingAuditBillingCompareCtrl', function BillingAuditBillingCompareCtrl($scope, $oasRights, views) {
    // PUBLIC METHODS
    $scope.exportToExcel = function () {
        $scope.$broadcast('event:billing-compare-action', { action: 'export-data' });
    };

    $scope.refreshGrid = function () {
        $scope.$broadcast('event:billing-compare-action', { action: 'refresh-grid' });
    };

    function init() {
        if ($scope.user.authorization.entity === 'Representative') {
            $scope.current.isDisableActions = true;
        }
    }
    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = { view: views[0], asOfDate: Date.create('today'), isDisableActions: false };
    $scope.rights = $oasRights.forCode('BILLAUDIT');

    init();
});

'use strict';

app.controller(
    'BillingAuditBillingCompareDashboardCtrl',
    function BillingAuditBillingCompareDashboardCtrl($http, $scope, $oasRights, views, billFrequency, $timeout, $dialog) {
        function init() {
            loadBillInstances();
            loadRights();

            if ($scope.user.authorization.entity === 'Representative') {
                $scope.current.isDisableActions = true;
            }
        }

        function loadBillInstances() {
            $http.get('/Billing/BillCompareDashboard/BillTypes').then(function (response) {
                $scope.billInstancesList = response.data;

                $scope.billInstancesList.forEach(function (instance) {
                    instance.key = new Date(instance.asOfDate).formatted() + (instance.isMockBill ? ' (Forecast)' : ' (Actual)');
                });
            });
        }

        function loadRights() {
            $scope.rights = $oasRights.forCode('BILLAUDIT');
            $scope.rightsMockBills = $oasRights.forCode('MOCKBILLS');
        }

        // PUBLIC METHODS
        $scope.exportToExcel = function () {
            $scope.$broadcast('event:billing-compare-action', { action: 'export-data' });
        };

        $scope.refreshGrid = function () {
            $scope.$broadcast('event:billing-compare-action', { action: 'refresh-grid' });

            $scope.current.compareInstanceFrom.isMockBill ? 1 : 0;
            $scope.current.compareInstanceTo.isMockBill ? 1 : 0;

            var from = $scope.current.compareInstanceFrom;
            var to = $scope.current.compareInstanceTo;

            $scope.current.queryString = '?AsOfDateCompare=' + Date.create(from.asOfDate).formatted() + '&IsMockBillCompare=' + from.isMockBill;
            $scope.current.queryString +=
                '&AsOfDateCompareTo=' +
                Date.create(to.asOfDate).formatted() +
                '&IsMockBillCompareTo=' +
                to.isMockBill +
                '&frequency=' +
                $scope.current.instanceTypeFrequency +
                '&IncludeApprovedNotes=' +
                $scope.current.includeApprovedNotes;

            $scope.current.dataUrl = '/Billing/BillCompareDashboard/SummaryCount';
            $scope.current.dataUrl += $scope.current.queryString;
        };

        $scope.headerItemClicked = function (item) {
            $scope.current.filterUrl = item.url;
            $scope.current.filterParams = item.parameters.remove('?');

            $timeout(function () {
                $scope.views.length = 0;
                $scope.views.add(item.dto);
                $scope.current.view = item.dto[0];

                $scope.$broadcast('event:billing-compare-action', { action: 'refresh-grid' });
            });
        };

        $scope.editNote = function (accountId) {
            var url = $scope.current.filterParams;
            url = url
                .replace('AsOfDateCompare', 'compareFromOfDate')
                .replace('AsOfDateCompareTo', 'compareToOfDate')
                .replace('IsMockBillCompare', 'isMockCompareFrom')
                .replace('IsMockBillCompareTo', 'isMockCompareTo');

            $http.get('/Billing/BillCompareDashboard/Notes?accountId=' + accountId + '&' + url, { trackerMsg: 'Loading notes' }).then(function (response) {
                if (response.data.length === 0) {
                    $http
                        .get('/Billing/BillCompareDashboard/Note/New/?accountId=' + accountId + '&' + url, { trackerMsg: 'Loading notes' })
                        .then(function (res) {
                            res.data.notes = '';
                            res.data.isApproved = false;

                            var dialogOpts = {
                                templateUrl: 'billing-compare-note.html',
                                controller: 'BillingCompareNoteCtrl',
                                billingCompareNoteData: res.data,
                            };

                            var d = $dialog.dialog(dialogOpts);
                            d.open().then(function (rslt) {
                                $scope.refreshGrid();
                            });
                        });
                } else {
                    var dialogOpts = {
                        templateUrl: 'billing-compare-note.html',
                        controller: 'BillingCompareNoteCtrl',
                        billingCompareNoteData: response.data[0],
                    };

                    var d = $dialog.dialog(dialogOpts);
                    d.open().then(function (rslt) {
                        $scope.refreshGrid();
                    });
                }
            });
        };

        $scope.createMockBills = function () {
            var dialogOpts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: 'billing/modals/mock-bills-params.html',
                controller: 'MockBillsParamsCtrl',
                hasAsOfDate: true,
                title: 'Mock Bill',
                dialogClass: 'modal wide',
            };

            var d = $dialog.dialog(dialogOpts);
            return d.open().then(function (rslt) {
                if (rslt.isDone === true) {
                    $dialog.actionComplete('Mock bills scheduled successfully.').open();
                }
            });
        };

        // INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.current = {
            view: views[0],
            filterUrl: '',
            filterParams: '',
            asOfDate: Date.create('today'),
            dataUrl: '',
            queryString: '',
            urlPayload: null,
            compareInstanceFrom: null,
            compareInstanceTo: null,
            instanceTypeFrom: false,
            instanceTypeTo: false,
            instanceTypeFrequency: 3,
            includeApprovedNotes: false,
            isDisableActions: false,
        };

        $scope.billInstancesList = null;

        init();
    }
);

app.controller('BillingCompareNoteCtrl', function BillingCompareNoteCtrl($scope, $http, $oasRights, dialog) {
    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close(null);
    };

    $scope.close = function () {
        if ($scope.current.billingCompareNoteData.id > 0) {
            $http
                .put('/Billing/BillCompareDashboard/Note/' + $scope.current.billingCompareNoteData.id, $scope.current.billingCompareNoteData, {
                    trackerMsg: 'Add Billing Compare Note',
                })
                .then(function (response) {
                    dialog.close(response.data);
                });
        } else {
            var data = angular.copy($scope.current.billingCompareNoteData);

            $http
                .post('/Billing/BillCompareDashboard/Note/', $scope.current.billingCompareNoteData, { trackerMsg: 'Add Billing Compare Note' })
                .then(function (response) {
                    dialog.close(response.data);
                });
        }
    };

    // INITIALIZE
    $scope.current = {
        billingCompareNoteData: dialog.options.billingCompareNoteData,
    };

    $scope.rightsCompareNotes = $oasRights.forCode('BILLAUDIT');
});

'use strict';

app.controller('PostPaymentsCtrl', function PostPaymentsCtrl($scope, $http, $oasRights, $dialog, views, $timeout) {
    var selectedItems = null;
    var filteredItems = null;
    const batchSize = 2000;

    // PRIVATE METHODS
    var init = function () {
        loadPostPaymentsReports().then(function (response) {
            $scope.current.rb2reports = response.data;
        });

        $scope.current.htmlreports = ["Bill Cancellation By Account"];
    };

    function loadPostPaymentsReports() {
        return $http.get('/Reporting/Reports?menu=postpayments', {
            cache: true,
            trackerMsg: 'Loading Post Payments Reports',
        });
    }

    var updateTotal = function (amount) {
        $scope.current.totalPosted += amount;
    };

    // PUBLIC METHODS
    $scope.refreshGrid = function (suppressWarning = false) {
        $timeout(function () {
            $scope.$broadcast('event:billing-postpayments-action', { action: 'select-rows', rows: [] });
        }, 500);
        $scope.selectedIds = [];

        $scope.checkIsPostingPayments().then(function () {
            $http
                .get('/Settings/Database/EntityOptions/Code/PostPaymentEnhancements', { trackerMsg: 'Checking Post Post Payments Enhancements' })
                .then(function (result) {
                    let usePostPaymentEnhancements = result.data.value.toLowerCase() === 'true';

                    if ($scope.current.isPostingPayments) {
                        if (usePostPaymentEnhancements == true) {
                            $scope.current.url = '/Billing/PostPayments/FFAndDate/Grid';
                        } else {
                            $scope.current.url = '/Billing/PostPayments/FFAndDate';
                        }

                        $scope.current.params = 'startDate=01/01/1900&endDate=01/01/1900&fundFamilyId=0';
                        $timeout(function () {
                            $scope.$broadcast('event:billing-postpayments-action', { action: 'refresh-grid' });
                        }, 0);
                        $timeout(function () {
                            $scope.$broadcast('event:billing-postpayments-action', { action: 'get-items' });
                        }, 0);

                        if (!suppressWarning) {
                            $dialog
                                .messageBox(
                                    "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Payments Posting",
                                    'There is a post payments process running.  Please wait until it has finished and reload data.'
                                )
                                .open();
                        }
                    } else {
                        var params = {
                            startDate: $scope.current.startDate.format('{MM}/{dd}/{yyyy}'),
                            endDate: $scope.current.endDate.format('{MM}/{dd}/{yyyy}'),
                        };

                        if ($scope.current.paymentFrom == 1) {
                            $scope.current.url = '/Billing/PostPayments/HHAndDate';
                            $scope.current.params = 'startDate={startDate}&endDate={endDate}'.assign(params) + '&clientId=' + $scope.current.selectedEntity.id;
                            $timeout(function () {
                                $scope.$broadcast('event:billing-postpayments-action', { action: 'refresh-grid' });
                            }, 0);
                            $timeout(function () {
                                $scope.$broadcast('event:billing-postpayments-action', { action: 'get-items' });
                            }, 500);
                        }

                        if ($scope.current.paymentFrom == 2) {
                            if (usePostPaymentEnhancements == true) {
                                $scope.current.url = '/Billing/PostPayments/FFAndDate/Grid';
                            } else {
                                $scope.current.url = '/Billing/PostPayments/FFAndDate';
                            }

                            $scope.current.params = 'startDate={startDate}&endDate={endDate}'.assign(params) + '&fundFamilyId=' + $scope.current.fundFamilyId;
                            $timeout(function () {
                                $scope.$broadcast('event:billing-postpayments-action', { action: 'refresh-grid' });
                            }, 0);
                            $timeout(function () {
                                $scope.$broadcast('event:billing-postpayments-action', { action: 'get-items' });
                            }, 500);
                        }

                        if ($scope.current.paymentFrom == 4) {
                            $scope.current.url = '/Billing/PostPayments/CustodianAndDate';

                            $scope.current.params = 'startDate={startDate}&endDate={endDate}'.assign(params) + '&custodianId=' + $scope.current.custodianId;
                            $timeout(function () {
                                $scope.$broadcast('event:billing-postpayments-action', { action: 'refresh-grid' });
                            }, 0);
                            $timeout(function () {
                                $scope.$broadcast('event:billing-postpayments-action', { action: 'get-items' });
                            }, 500);
                        }


                    }
                });
        });
    }

    $scope.runReport = function (reportId) {
        $dialog.reportPrompt(reportId).open();
    };


    $scope.runHtmlReport = function (name) {
        var dialogOpts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: 'billing/modals/bill-cancellation-by-account.html',
            controller: 'BillCancellationByAccountCtrl',
            hasAsOfDate: true,
            title: 'Bill Cancellation By Account',
            dialogClass: 'modal',
        };

        var d = $dialog.dialog(dialogOpts);
        return d.open();
    };


    $scope.post = function (processSelectedIds) {
        $scope.checkIsPostingPayments().then(function () {
            if ($scope.current.isPostingPayments) {
                $dialog
                    .messageBox(
                        "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Payments Already Posting",
                        'There is already a post payments process running.  Please wait until it has finished.'
                    )
                    .open();
                return;
            }

            if ($scope.current.writeOffUncollectable) {
                processWriteOffUncollectable();
                $scope.updateAllNotes();
            } else {
                if (processSelectedIds) {
                    confirmPosting(selectedItems.length, processSelectedIds);
                } else {
                    $scope.$broadcast('event:billing-postpayments-action', { action: 'get-filtered' });
                }
            }
        });
    };


    function confirmPosting(dataSize, processSelectedIds) {
        $dialog
            .confirmAction(
                'You are about to post the '
                + (processSelectedIds ? 'selected rows' : ' data rows visible') +
                ' in the current view. Are you sure you want to proceed? Please keep this page open during the update to ensure the process completes without interruption.'
            )
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    processPaymentsInBatch(processSelectedIds);
                } else {
                    $scope.current.totalPosted = 0;
                }
            });
    }

    function processWriteOffUncollectable() {
        $http
            .post('/Billing/PostPayments/WriteOffBills?paymentFrom=' + $scope.current.paymentFrom, $scope.paymentData, { trackerMsg: 'Write off bills' })
            .then(function () {
                $dialog.actionComplete('Write off bills complete').open();
                $scope.current.batchNumber = null;
                $scope.current.totalPosted = null;
                $scope.refresh();
            });
    }

    function processPaymentsInBatch(processSelectedIds) {
        $scope.current.totalPosted = 0;
        let data = processSelectedIds ? selectedItems : filteredItems;

        data.forEach(function (payment) {
            updateTotal(payment.amountToPost);
        });

        $dialog
            .inputBox('Batch # ' + '($' + $scope.current.totalPosted.round(2) + ')', 'Enter batch #')
            .open()
            .then(function (rslt) {
                if (rslt != undefined) {
                    $scope.current.batchNumber = rslt;

                    //If we are using the hangfire version per bug 202964, don't batch
                    sendPaymentInformation($scope.current.batchNumber, data, true).then(function () {
                        $dialog.actionComplete('Posting payments process started.  You will recieve a notification when complete.').open();
                        $scope.current.batchNumber = null;
                        $scope.current.totalPosted = null;
                        $scope.refreshGrid(true);
                    });

                }
            });
    }


    function processBatch(batchStart, data) {
        sendPaymentInformation($scope.current.batchNumber, data.slice(batchStart, (batchStart + batchSize)), true, `Posting Payments ${batchStart + 1} - ${batchStart + batchSize}`).then(function () {
            if ((batchStart + batchSize) >= data.length) {
                $dialog.actionComplete('Running post payment initialized.').open();
                $scope.current.batchNumber = null;
                $scope.current.totalPosted = null;
                $scope.refreshGrid();

                if ($scope.current.paymentFrom == 3) {
                    $scope.updateAllNotes();
                }
            } else {
                processBatch(batchStart + batchSize, data);
            }
        });
    }


    function sendPaymentInformation(batchNumber, paymentData, useTrackerMessage, trackerMessage = 'Posting Payments') {
        let isImport = $scope.current.paymentFrom == 3;

        if (useTrackerMessage) {
            return $http.post('/Billing/PostPayments?batchNumber=' + batchNumber + '&isImport=' + isImport, paymentData, { trackerMsg: trackerMessage });
        }
        return $http.post('/Billing/PostPayments?batchNumber=' + batchNumber + '&isImport=' + isImport, paymentData);
    }

    $scope.undoPostpayments = function () {
        var dialogOpts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: 'billing/modals/undo-posted-payments.html',
            controller: 'UndoPostedPaymentsCtrl',
            hasAsOfDate: true,
            title: 'Undo Posted Payments',
            dialogClass: 'modal wide',
        };

        var d = $dialog.dialog(dialogOpts);
        return d.open().then(function (rslt) {
            if (rslt && rslt.isDone === true) {
                $dialog.actionComplete('Undo posted payments successfully.').open();
            }
        });
    };

    $scope.writeOffUncollectable = function () {
        if (selectedItems.every(x => x.paymentDate != null && !isNaN(new Date(x.paymentDate)))) {
            $dialog
                .confirmAction('WARNING: Completing this task will write off fee.  Are you sure you want to proceed?')
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $dialog.inputBox(`Batch # ($${$scope.current.totalPosted.round(2)})`, 'Enter Batch #', 'text', { required: true })
                        .open()
                        .then(result => {
                            if (!result) {
                                return;
                            }
                            $http.post(`/Billing/PostPayments/WriteOffBills?paymentFrom=${$scope.current.paymentFrom}&batchNumber=${result}`, selectedItems, { trackerMsg: 'Writing Off Selected Payments' })
                            .then(() => {
                                $dialog.actionComplete('Posting payments process started.  You will receive a notification when complete.').open();
                                $scope.current.batchNumber = null;
                                $scope.current.totalPosted = null;
                                $scope.refreshGrid(true);
                            });
                        });
                    }
                });
        } else {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Payment Date", 'Payment Date must be a valid date on all selected records').open();
        }


    };

    $scope.updatePaymentDate = function () {
        $scope.paymentData.forEach(function (payment) {
            payment.paymentDate = $scope.current.paymentDate;
        });

        $scope.$broadcast('event:billing-postpayments-action', { action: 'update-items', items: $scope.paymentData });
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:billing-postpayments-action', { action: 'export-data' });
    };

    $scope.checkIsPostingPayments = function () {
        return $http.get('/Billing/PostPayments/IsPostingPayments', { trackerMsg: 'Checking for Existing Posting Processes' }).then(function (response) {
            $scope.current.isPostingPayments = response.data === true;
        });
    };

    // INITIALIZE
    $scope.current = {
        view: views[0],
        url: null,
        params: null,
        paymentFrom: null,
        startDate: Date.create('today').beginningOfMonth(),
        endDate: Date.create('today').endOfMonth(),
        batchNumber: null,
        writeOffUncollectable: false,
        paymentDate: Date.create('today'),
        totalPosted: 0,
        totalSelected: 0,
        fundFamilyId: -1,
        excelData: null,
        additionalData: { StartDate: Date.create('today'), EndDate: Date.create('today') },
        note: null,
        isPostingPayments: false,
        selectedItemsAreSuccess: false,
    };

    $scope.views = views;
    $scope.selectedIds = [];

    $scope.dateRange = { startDate: $scope.current.startDate.formatted(), endDate: $scope.current.endDate.formatted() };
    $scope.rightsPostPayments = $oasRights.forCode('POSTPAYMENTS');

    init();

    // EVENT LISTENERS
    $scope.$on('event:billing-postpayments-select', function (e, args) {
        $scope.current.totalSelected = args.length;

        if (args.length == 0) return;
        $scope.current.totalPosted = 0;
        $scope.current.selectedItemsAreSuccess = true;

        selectedItems = args;
        args.forEach(function (arg) {
            updateTotal(arg.amountToPost);
            if (arg && arg.statusIcon !== 'success') {
                $scope.current.selectedItemsAreSuccess = false;
            }
        });
    });

    // Watches
    $scope.$on('slickgrid-getfiltered', function (event, data) {
        filteredItems = data;
        confirmPosting(data.length, false);
    });

    $scope.$watch('current.excelData', function (newVal, oldVal) {
        if (newVal == oldVal) return;

        $scope.$broadcast('event:billing-postpayments-action', { action: 'clear-items' });

        newVal.forEach(function (item) {
            $scope.$broadcast('event:billing-postpayments-action', { action: 'add-item', item: item });
        });
        $scope.paymentData = newVal;
    });

    $scope.$on('slickgrid-data-loaded', function (event, data) {
        $scope.paymentData = data;
        $scope.updatePaymentDate();
    });

    $scope.openModal = function (id) {
        document.querySelector(id).open();
    };

    $scope.closeModal = function (id) {
        document.querySelector(id).close();
    };

    $scope.deleteNotes = function (id) {
        $dialog
            .confirmAction('WARNING: This will delete notes for these receivables.  Are you sure you want to proceed?')
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.post('/Billing/DeleteNotes?notes={0}', selectedItems, { trackerMsg: 'Deleting Notes' }).then(function (response) {
                        const exceldatacopy = [];
                        $scope.paymentData.map((val) => exceldatacopy.push(Object.assign({}, val)));
                        for (let i = 0; i < response.data.length; i++) {
                            for (let j = 0; j < exceldatacopy.length; j++) {
                                if (exceldatacopy[j].accountId == response.data[i].accountId && exceldatacopy[j].billId == response.data[i].billId)
                                    exceldatacopy[j].note = response.data[i].note;
                            }
                        }
                        $scope.current.excelData = exceldatacopy;

                        $scope.refreshGrid();
                    });
                }
            });
    };

    $scope.updateAllNotes = function (id) {
        $http.post('/Billing/UpdateNotes?notes=', $scope.paymentData, { trackerMsg: 'Updating All Notes' });
    };

    $scope.addNotes = function (id) {
        if ($scope.current.note) {
            $http.post('/Billing/UpdateNotes?notes=' + $scope.current.note, selectedItems, { trackerMsg: 'Add Notes' }).then(function (response) {
                const exceldatacopy = [];
                $scope.paymentData.map((val) => exceldatacopy.push(Object.assign({}, val)));
                for (let i = 0; i < response.data.length; i++) {
                    for (let j = 0; j < exceldatacopy.length; j++) {
                        if (exceldatacopy[j].accountId == response.data[i].accountId && exceldatacopy[j].billId == response.data[i].billId)
                            exceldatacopy[j].note = response.data[i].note;
                    }
                }
                $scope.current.excelData = exceldatacopy;
                $scope.current.note = '';

                $scope.refreshGrid();
            });
        } else {
            $scope.current.note = '';
        }
        $scope.closeModal(id);
    };
});

'use strict';

app.controller('PostedPaymentsCtrl', function PostedPaymentsCtrl($scope, $http, $oasRights, $dialog, views, $timeout) {
    // PUBLIC METHODS
    $scope.refreshGrid = function () {
        $scope.current.url = '/Billing/PostedPayments';
        $scope.current.params = '';

        if ($scope.current.paymentFrom === 1) {
            $scope.current.params = 'clientId=' + $scope.current.selectedEntity.id;
        } else if ($scope.current.paymentFrom === 2) {
            $scope.current.params = 'accountId=' + $scope.current.selectedEntity.id;
        }

        if ($scope.current.batchNumber) {
            if ($scope.current.params.length > 0) {
                $scope.current.params += '&batchNumber=' + $scope.current.batchNumber;
            } else {
                $scope.current.params = 'batchNumber=' + $scope.current.batchNumber;
            }
        }

        if ($scope.current.paymentFrom === 3) {
            if ($scope.current.params.length > 0) {
                $scope.current.params += '&paymentDate=' + $scope.current.paymentDate.format('{MM}/{dd}/{yyyy}');
            } else {
                $scope.current.params = 'paymentDate=' + $scope.current.paymentDate.format('{MM}/{dd}/{yyyy}');
            }
        }

        $timeout(function () {
            $scope.$broadcast('event:billing-postedpayments-action', { action: 'refresh-grid' });
        }, 0);
    };

    $scope.reversal = function () {
        $dialog
            .confirmAction('This will create a payment reversal.  Are you sure you want to proceed?')
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $dialog
                        .dialog({
                            dialogClass: 'modal wide',
                            templateUrl: 'posted-payments-reversal.html',
                            controller: 'PostedPaymentsReversalCtrl',
                            postedPayments: $scope.current.payments,
                        })
                        .open()
                        .then(function (result) {
                            if (result) {
                                $timeout(function () {
                                    $scope.$broadcast('event:billing-postedpayments-action', { action: 'refresh-grid' });
                                }, 0);
                            }
                        });
                }
            });
    };

    $scope.undo = function () {
        $dialog
            .confirmAction('This will undo this payment.  Are you sure you want to proceed?')
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.current.processList.forEach(function (item) {
                        $http
                            .put('/Billing/PostedPayments/' + item.billPaymentId + '/Action/Undo', item.ids, { trackerMsg: 'Undo post payment' })
                            .then(function (response) {
                                $scope.refreshGrid();
                            });
                    });
                }
            });
    };

    $scope.undoPostpaymentsByBatchNumber = function () {
        var dialogOpts = {
            backdrop: true,
            keyboard: true,
            backdropClick: false,
            templateUrl: 'billing/modals/undo-posted-payments.html',
            controller: 'UndoPostedPaymentsCtrl',
            hasAsOfDate: true,
            title: 'Undo Posted Payments',
            dialogClass: 'modal wide',
        };

        var d = $dialog.dialog(dialogOpts);
        return d.open().then(function (rslt) {
            if (rslt && rslt.isDone === true) {
                $dialog.actionComplete('Undo posted payments successfully.').open();
            }
        });
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:billing-postedpayments-action', { action: 'export-data' });
    };

    // INITIALIZE
    $scope.current = {
        view: views[0],
        url: null,
        params: null,
        paymentFrom: null,
        batchNumber: null,
        paymentDate: Date.create('today'),
        fundFamilyId: -1,
        additionalData: { StartDate: Date.create('today'), EndDate: Date.create('today') },
        reversalAmount: null,
    };

    $scope.views = views;
    $scope.selectedIds = [];

    $scope.rightsPostPayments = $oasRights.forCode('POSTPAYMENTS');

    // EVENT LISTENERS
    $scope.$on('event:billing-postedpayments-select', function (e, args) {
        if (args.length === 0) return;
        $scope.current.processList = [];

        var postedList = args.groupBy('billPaymentId');
        Object.each(postedList, function (key, value) {
            var gd = { billPaymentId: key, ids: value.map('id') };
            $scope.current.processList.push(gd);
        });

        $scope.current.payments = args;

        $scope.current.reversalAmount = Math.abs(args[0].changeAmt);
    });
});

app.controller('PostedPaymentsReversalCtrl', function PostedPaymentsReversalCtrl($scope, dialog, $http) {
    $scope.reversePayments = function () {
        $http.put('/Billing/PostedPayments/Action/Reverse', $scope.current.postedPayments, { trackerMsg: 'Reverse posted payment' }).then(function (response) {
            dialog.close(response.data);
        });
    };

    $scope.close = function () {
        dialog.close(null);
    };

    $scope.current = {
        postedPayments: dialog.options.postedPayments,
    };
});

'use strict';

app.controller('RelatedHouseholdImportCtrl', function RelatedHouseholdImportCtrl($scope, $http, $oasRights, $dialog) {
    // PUBLIC METHODS
    $scope.processImport = function () {
        var postData = $scope.current.selectedItems.findAll({ isValid: true });
        if (postData) {
            $scope.current.allowProcess = false;
            $http.put('/Portfolio/Clients/Verbose', postData, { trackerMsg: 'Processing related households' }).then(function () {
                $scope.current.allowProcess = true;
                $dialog.messageBox('Import successful', 'Related household information saved.').open();
            });
        }
    };

    $scope.startImportOver = function () {
        $scope.current.allowProcess = false;
        $scope.current.selectedItems = null;
    };

    // WATCHES
    $scope.$watchCollection('current.selectedItems', function (newValue, oldValue) {
        if (newValue != oldValue && newValue != null) {
            $scope.current.allowProcess = $scope.current.selectedItems.find({ isValid: true });
        }
    });

    // INITIALIZE
    $scope.rightsHH = $oasRights.forCode('CLIENTS');
    $scope.current = { selectedItems: [], allowProcess: true };
});

'use strict';

app.controller('PaysForImportCtrl', function PaysForImportCtrl($scope, $http, $oasRights, $dialog) {
    // PUBLIC METHODS
    $scope.processImport = function () {
        var postData = $scope.current.selectedItems.findAll({ isValid: true });
        if (postData) {
            $scope.current.allowProcess = false;
            $http.put('/Portfolio/Accounts/Verbose', postData, { trackerMsg: 'Processing pays for information' }).then(function () {
                $scope.current.allowProcess = true;
                $dialog.messageBox('Import successful', 'Pays for information saved.').open();
            });
        }
    };

    $scope.startImportOver = function () {
        $scope.current.allowProcess = false;
        $scope.current.selectedItems = null;
    };

    // WATCHES
    $scope.$watchCollection('current.selectedItems', function (newValue, oldValue) {
        if (newValue != oldValue && newValue != null) {
            $scope.current.allowProcess = $scope.current.selectedItems.find({ isValid: true });
        }
    });

    // INITIALIZE
    $scope.rightsAcc = $oasRights.forCode('ACCOUNTS');
    $scope.current = { selectedItems: [], allowProcess: true };
});

app.directive('oasBillingCompareHeader', function oasBillingCompareHeader($http, $rootScope, $timeout) {
    var headerData = {};

    return {
        restrict: 'E',
        replace: true,
        scope: {
            oasDataUrl: '@',
            oasQueryString: '@',
            selectedItem: '=',
            headerItemClicked: '&',
            urlPayload: '=',
        },
        templateUrl: 'billing/directives/oasBillingCompareHeader.html',
        link: function (scope, element, attrs) {
            var selectedItem = null;

            function getProperty(obj, target) {
                var arr = target.split('.');
                for (var i = 0; i < arr.length; i++) {
                    if (obj) obj = obj[arr[i]];
                }
                return obj;
            }

            function getData(data) {
                scope.current.columnConfig.forEach(function (col) {
                    if (col.key.indexOf('.') > 0) col.value = getProperty(data, col.key) || 0;
                    else col.value = data[0][col.key] || 0;
                });

                var targetElement = element.children()[8];
                var col = scope.current.columnConfig.find({ key: 'others' });

                scope.itemClick(targetElement, col);
            }

            function loadCounts() {
                $http.get(scope.oasDataUrl, { trackerMsg: 'Loading Billing Compare Count' }).then(function (response) {
                    getData(response.data);
                });
            }

            scope.current = {
                columnConfig: [
                    { name: 'Fee Schedule Change', key: 'isScheduleChangedCount', filterValue: 1 },
                    { name: 'Inactive Previously Active', key: 'isPreviousActiveCount', filterValue: 2 },
                    { name: 'New Accounts', key: 'isNewAccountCount', filterValue: 3 },
                    { name: 'Cash Flows', key: 'isCashFlowCount', filterValue: 4 },
                    { name: 'Adjustments Applied', key: 'isAdjustmentsAppliedCount', filterValue: 5 },
                    { name: 'Related HH Aggregation', key: 'account.checkPayPaidByOther', filterValue: 6 },
                    { name: 'Account Aggregation', key: 'isAggregationChangedCount', filterValue: 7 },
                    { name: 'Cancellations', key: 'isCancellationCount', filterValue: 8 },
                    { name: 'Other', key: 'others', filterValue: 9 },
                ],
            };

            scope.current.columnConfig.forEach(function (config) {
                config.value = 0;
            });

            scope.itemClick = function (target, col) {
                if (selectedItem != null) {
                    selectedItem.classList.remove('billing-header-item-clicked');
                }

                selectedItem = target.currentTarget ? target.currentTarget : target;

                var dto;
                switch (col.filterValue) {
                    case 1:
                        dto = 'BillCompareFeeScheduleChangeDto';
                        break;
                    case 2:
                        dto = 'BillCompareInactivePrevActiveDto';
                        break;
                    case 3:
                        dto = 'BillCompareNewAccountDto';
                        break;
                    case 4:
                        dto = 'BillCompareCashFlowDto';
                        break;
                    case 5:
                        dto = 'BillCompareAdjAppliedDto';
                        break;
                    case 6:
                        dto = 'BillCompareRelatedHHAggregateDto';
                        break;
                    case 7:
                        dto = 'BillCompareAccountAggregateDto';
                        break;
                    case 8:
                        dto = 'BillCompareCancellationDto';
                        break;
                    case 9:
                        dto = 'BillCompareOthersDto';
                        break;
                    case '':
                        dto = 'BillCompareDashboardDto';
                        break;
                }

                return $http.get('/Settings/Views/' + dto, { trackerMsg: 'Loading billing compare views' }).then(function (response) {
                    var dto = response.data;
                    var url = '/Billing/BillCompareDashboard/Results';
                    var parameters = scope.oasQueryString + '&filterValue=' + col.filterValue;

                    scope.headerItemClicked({ item: { url: url, parameters: parameters, dto: dto } });

                    angular.element(selectedItem).addClass('billing-header-item-clicked');
                });
            };

            scope.$watch('oasDataUrl', function (newVal, oldVal) {
                if (newVal == oldVal) return;

                loadCounts();
            });
        },
    };
});

app.directive('oasBillingSummary', function oasBillingSummary($http, $portfolio, entities, $billing, $dialog) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            title: '@',
            panelData: '=',
            allowEdit: '@',
            hasList: '=',
            hasPaging: '=',
            list: '=?',
            householdId: '=',
            refreshGrid: '&?',
        },
        templateUrl: 'billing/directives/oasBillingSummary.html',
        link: function (scope, element, attrs) {
            scope.toggle = function (data) {
                scope.panelData.forEach(function (item) {
                    if (item != data) item.isSelected = false;
                });

                data.isSelected = !data.isSelected;
                if (data.isSelected) {
                    scope.current.selectedItem = data;
                } else {
                    scope.current.selectedItem = null;
                }
            };

            scope.openEditor = function () {
                switch (scope.title) {
                    case 'CURRENT ACCOUNT SETTINGS':
                        var key = scope.current.selectedItem.details.find({ key: 'Id' });
                        if (key) {
                            $portfolio.openEditor(entities.account.value, [key.value], null, null, null, null);
                        }
                        break;
                    case 'RELATED HOUSEHOLDS':
                        var key = scope.current.selectedItem.details.find({ key: 'Id' });
                        if (key) {
                            $portfolio.openEditor(entities.client.value, [key.value], null, null, null, null);
                        }
                        break;
                }
            };

            scope.selectInvoice = function () {
                scope.panelData.forEach(function (item) {
                    item.isSelected = false;
                });
                scope.panelData.find(function (item) {
                    var key = item.details.find({ key: 'Bill Id' });
                    if (key) {
                        if (key.value == scope.current.invoiceId) {
                            item.isSelected = true;
                            scope.refreshGrid({ billId: key.value });
                        }
                    }
                });
            };

            scope.selectFirstInvoice = function () {
                scope.current.invoiceId = scope.panelData[0].details.find({ key: 'Bill Id' }).value;
                scope.selectInvoice();
            };

            scope.openSettings = function () {
                $dialog
                    .dialog({
                        templateUrl: 'billing-summary-panel-settings.html',
                        controller: 'BillSummaryPanelSettingsCtrl',
                        itemsPerPage: scope.current.itemsPerPage,
                        totalItems: scope.panelData.length,
                    })
                    .open()
                    .then(function (result) {
                        if (result) {
                            scope.current.itemsPerPage = result.itemsPerPage;
                            scope.current.accountStatus = result.accountStatus;
                            splitData();
                        }
                    });
            };

            scope.goLeft = function () {
                if (scope.current.page == 0) return;
                scope.current.page -= 1;
            };

            scope.goRight = function () {
                if (scope.current.page == scope.panelDataSplit.length - 1) return;
                scope.current.page++;
            };

            scope.current = {
                page: 0,
                selectedItem: null,
                invoiceId: null,
                pageSizes: 10,
                itemsPerPage: 4,
            };

            scope.$watch('panelData', function (newValue, oldValue) {
                if (newValue === oldValue || !scope.hasPaging) return;

                if (newValue.length > 4) {
                    splitData();
                }
            });

            function splitData() {
                scope.panelDataSplit = scope.panelData.inGroupsOf(scope.current.itemsPerPage).compact();
                scope.current.page = 0;
            }
        },
    };
});

'use strict';

app.controller('MockBillsParamsCtrl', function MockBillsParamsCtrl($scope, dialog, $http, $dialog) {
    // PRIVATE VARIABLES
    var selectAccounts = [];

    // PRIVATE METHODS
    function init() {
        $scope.calculateArrearAdvanceDates();
    }

    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close(null);
    };

    $scope.close = function () {
        dialog.close($scope.current.params);
    };

    $scope.selectAccounts = function () {
        var dialogOpts = {
            templateUrl: 'account-select.html',
            controller: 'AccountSelectCtrl',
            selectedAccounts: selectAccounts,
        };

        var d = $dialog.dialog(dialogOpts);
        d.open().then(function (rslt) {
            if (rslt) {
            }
        });
    };

    $scope.calculateArrearAdvanceDates = function () {
        var renewalStart = Date.create($scope.current.params.renewalYear, $scope.current.params.renewalMonth - 1, 1);
        var renewalEnd = renewalStart.clone().addMonths(3);

        var advanceStart = Date.create($scope.current.params.renewalYear, $scope.current.params.renewalMonth - 1, 1).addMonths(-2);
        var advanceEnd = advanceStart.clone().addMonths(2);

        $scope.current.renewalAdvance =
            renewalStart.addMonths(1).formatted() +
            ' - ' +
            Date.create(renewalEnd.getFullYear(), renewalEnd.getMonth(), renewalEnd.daysInMonth()).formatted() +
            ' (advance)';
        $scope.current.renewalArrear =
            advanceStart.formatted() + ' - ' + Date.create(advanceEnd.getFullYear(), advanceEnd.getMonth(), advanceEnd.daysInMonth()).formatted() + ' (arrear)';
    };

    $scope.whoForChanged = function (isWhoFor) {
        if (isWhoFor) {
            $scope.current.params.fromListType = 0;
        }
    };

    $scope.next = function () {
        switch ($scope.current.wizardStep) {
            case 0:
                if ($scope.current.params.whoFor == 1) {
                    $scope.current.animation = 'slide-right';
                    $scope.current.wizardStep = 2;
                } else {
                    $scope.current.animation = 'slide-right';
                    $scope.current.wizardStep += 1;
                }
                break;
            default:
                $scope.current.animation = 'slide-right';
                $scope.current.wizardStep += 1;
                break;
        }
    };

    $scope.back = function () {
        if ($scope.current.wizardStep === 2 && $scope.current.params.whoFor == 1) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep -= 2;
        } else {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep -= 1;
        }
    };

    $scope.jumpBackTo = function (index) {
        if (index < $scope.current.wizardStep) {
            if (index === 1 && $scope.current.params.whoFor == 1) {
                $scope.current.wizardStep = 0;
            } else {
                $scope.current.animation = 'slide-left';
                $scope.current.wizardStep = index;
            }
        }
    };

    $scope.isStepIncomplete = function () {
        switch ($scope.current.wizardStep) {
            case 0:
                return $scope.current.params.whoFor != 1 && $scope.current.selectedEntity === null;
            case 1:
                return $scope.current.params.whoFor != 1 && $scope.current.selectedEntity === null;
            case 2:
                return false;
            default:
                return false;
        }
    };

    $scope.runMockBill = function () {
        var asOfDate = Date.create($scope.current.params.renewalYear, $scope.current.params.renewalMonth - 1, 1);
        asOfDate = Date.create(asOfDate.getFullYear(), asOfDate.getMonth(), asOfDate.daysInMonth()).formatted();

        var endDateOverride = $scope.current.params.overrideBillEndDate ? current.params.billEndDate.formatted() : null;
        var valueAsOfOverride = $scope.current.params.overrideAsOfValueDate ? $scope.current.params.asOfDate.formatted() : null;

        var pkKey = $scope.current.selectedEntity != null ? $scope.current.selectedEntity.id : 0;

        var acctList = $scope.current.selectedAccounts.length == 0 ? null : $scope.current.selectedAccounts.map('id').join(',');

        var mockBillsParams = {
            asOfDate: asOfDate,
            BillType: $scope.current.params.billType,
            vHint: $scope.current.params.whoFor == 1 ? 1 : 2,
            pkKey: pkKey,
            EndDateOverride: endDateOverride,
            AcctList: acctList,
            ValueAsOfOverride: valueAsOfOverride,
        };

        var params = '&BillType=' + $scope.current.params.billType + '&vHint=' + ($scope.current.params.whoFor == 1 ? 1 : 2) + '&pkKey=' + pkKey;
        params += '&EndDateOverride=' + endDateOverride + '&AcctList=' + acctList + '&ValueAsOfOverride=' + valueAsOfOverride;

        $http.post('/Billing/GenerateMockBills/', mockBillsParams, { trackerMsg: 'Scheduling mock bill run' }).then(function () {
            dialog.close({ isDone: true });
        });
    };

    //INITIALIZE
    $scope.current = {
        wizardStep: 0,
        animation: 'slide-right',
        title: dialog.options.title ? dialog.options.title : 'Mock Bills',
        selectedEntity: null,
        renewalMonths: [
            { name: 'January', value: 1 },
            { name: 'February', value: 2 },
            { name: 'March', value: 3 },
            { name: 'April', value: 4 },
            { name: 'May', value: 5 },
            { name: 'June', value: 6 },
            { name: 'July', value: 7 },
            { name: 'August', value: 8 },
            { name: 'September', value: 9 },
            { name: 'October', value: 10 },
            { name: 'November', value: 11 },
            { name: 'December', value: 12 },
        ],
        renewalArrear: '',
        renewalAdvance: '',
        accountsSelect: 1,
        selectedAccounts: [],
        params: {
            whoFor: 1,
            billEndDate: Date.create('today'),
            asOfDate: Date.create('today'),
            fromListType: 0,
            billType: 1,
            renewalYear: new Date().getFullYear(),
            renewalMonth: new Date().getMonth() + 1,
        },
        availableTitle: 'Account',
    };
    $scope.wizardSteps = ['Run For', 'Accounts', 'Bill Type', 'Run'];
    $scope.accountList = [];

    init();

    // WATCH
    $scope.$watch('current.selectedEntity', function (newVal, oldVal) {
        if (newVal === oldVal || !newVal) return;

        $http.get('/Portfolio/Clients/' + newVal.id + '/Accounts/Value', { trackerMsg: 'Loading accounts for household' }).then(function (response) {
            response.data.forEach(function (item) {
                item.isSelected = true;
                selectAccounts.push(item);
            });

            $scope.accountList = selectAccounts;
        });
    });
});

app.controller('AccountSelectCtrl', function AccountSelectCtrl($scope, $http, $oasRights, dialog) {
    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close(null);
    };

    $scope.save = function () {
        dialog.close($scope.current.selectedAccounts);
    };

    // INITIALIZE
    $scope.current = {
        accountList: dialog.options.selectedAccounts ? dialog.options.selectedAccounts : [],
    };
});

'use strict';

app.controller(
    'BillGeneratorGenerateBillCtrl',
    function BillGeneratorGenerateBillCtrl($scope, $dialog, $http, $location, billAudits, $routeParams, activeState, $portfolio) {
        // PRIVATE VARIABLES
        var selectAccounts = [];
        var runFor = 0;

        // PRIVATE METHODS
        function init() {
            $scope.calculateArrearAdvanceDates();
            getBillingAudits();
            setRunFor();

            $http
                .get('/Settings/Database/EntityOptions/Code/DftBiRunForAccts', { trackerMsg: 'Getting bill instance run for accounts' })
                .then(function (response) {
                    var activeStates = {
                        'Active Accounts': 1,
                        'Inactive Accounts': 2,
                        'All Accounts': 3,
                    };

                    $scope.current.params.runForAccounts = activeStates[response.data.value];

                    var list = {
                        activeStates: activeState,
                    };

                    Object.each(list, function (key, value) {
                        $scope[key] = $portfolio.enumToSimpleList(value);
                    });
                });

            // wizardType (1 - Renewal , 2- New Money, 7 - Forecast)
            if ($routeParams.wizardType) {
                $scope.current.wizardType = $routeParams.wizardType;

                switch ($scope.current.wizardType) {
                    case '1':
                        $scope.current.wizardTypeText = 'Live Instance';
                        break;
                    case '2':
                        $scope.current.wizardTypeText = 'Forecast Instance';
                        $scope.current.billInMass = true;
                        break;
                }
            }

            if ($routeParams.source) {
                if ($routeParams.source === 'qpe') {
                    $scope.current.billInMass = true;
                }
            }

            if ($scope.user.authorization.entity == 'Administrator') {
                $scope.current.billInMass = true;
            }
        }

        function getBillingAudits() {
            $http.get('/Billing/BillGenerator/Overview', { trackerMsg: 'Loading audits url' }).then(function (response) {
                Object.each(response.data[0], function (key, val) {
                    $scope.current.overview[key] = {};
                    switch (key) {
                        case 'billStyleAdvanced':
                        case 'billStyleArrear':
                        case 'valuationMethodAvgDailyBalance':
                        case 'valuationMethodPeriodEnding':
                        case 'valuationMethodAvgMonthlyBalance':
                            $scope.current.overview[key].value = val;
                            $scope.current.overview[key].url = '/billing/audit/accounts?source=bg';
                            break;
                        case 'hhNewAccountNotReady':
                        case 'hhNewAccountReady':
                        case 'hhStatusNewMoney':
                            $scope.current.overview[key].value = val;
                            $scope.current.overview[key].url = '/billing/audit/households?source=bg';
                            break;
                    }
                });
            });
        }

        function setRunFor() {
            switch ($scope.current.params.whoFor) {
                case 1:
                    $scope.current.runForText = 'All Households';
                    break;
                case 2:
                    $scope.current.runForText = 'Fund Family';
                    return $scope.current.selectedItems;
                case 3:
                    $scope.current.runForText = 'Custodian';
                    break;
                case 4:
                    $scope.current.runForText = 'Representative';
                    break;
                case 5:
                    $scope.current.runForText = 'Business Line';
                    break;
                case 6:
                    $scope.current.runForText = 'Single Household - New Bill';
                    break;
                case 7:
                    $scope.current.runForText = 'Single household Re-run Bill';
                    break;
                case 8:
                    $scope.current.runForText = 'Account(s)';
                    break;
                case 9:
                    $scope.current.runForText = 'Import Bills from List';
                    break;
                case 10:
                    $scope.current.runForText = 'Import Re-runs from List';
                    break;
            }
        }

        function getKeys(whoFor) {
            switch (whoFor) {
                case 1:
                    return [];
                case 2:
                case 3:
                case 4:
                    return $scope.current.selectedItems.map('id');
                case 5:
                    return [$scope.current.businessLine];
                case 6:
                    $scope.current.runForText = 'Single Household - New Bill';
                    return [$scope.current.selectedEntity.id];
                case 7:
                    return [$scope.current.rerunBillId];
                case 8:
                    return $scope.accountList.findAll({ isSelected: true }).map('id');
                case 9:
                case 10:
                    return $scope.current.billIds;
            }
        }

        $scope.calculateArrearAdvanceDates = function () {
            $http
                .get('/Billing/BillGenerator/BillPeriodDetail?periodEndDate=' + $scope.current.params.asOfDate.formatted(), {
                    trackerMsg: 'Loading bill time frames',
                })
                .then(function (res) {
                    $scope.billPeriod = res.data.billPeriods;

                    if (res.data.cashFlow?.length > 0) {
                        $scope.cashFlow = res.data.cashFlow[0];
                    }

                    isShowCashFlow();
                });
        };

        function isShowCashFlow() {
            var arrear = $scope.billPeriod.find(function (period) {
                return period.billingStyle === 'Arrear';
            });

            var advanced = $scope.billPeriod.find(function (period) {
                return period.billingStyle === 'Advanced';
            });

            if ((arrear && advanced) || (!arrear && advanced)) {
                $scope.current.showCashFlow = true;
            }
        }

        // PUBLIC METHODS
        $scope.next = function () {
            switch ($scope.current.wizardStep) {
                case 2: // Selection
                    if ($scope.current.params.whoFor == 1) {
                        // All households
                        $scope.current.animation = 'slide-right';
                        $scope.current.wizardStep = 3; // Go to Advance Options
                    } else {
                        $scope.current.animation = 'slide-right';
                        $scope.current.wizardStep += 1;
                    }

                    setRunFor();
                    getKeys($scope.current.params.whoFor);
                    break;
                default:
                    $scope.current.animation = 'slide-right';
                    $scope.current.wizardStep += 1;
                    break;
            }
        };

        $scope.back = function () {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep -= 1;
        };

        $scope.jumpBackTo = function (index) {
            if (index < $scope.current.wizardStep) {
                $scope.current.animation = 'slide-left';
                if (index === 3 && $scope.current.params.whoFor == 1) {
                    $scope.current.wizardStep = 2;
                } else {
                    $scope.current.wizardStep = index;
                }
            }
        };

        $scope.isStepIncomplete = function () {
            return false;
        };

        $scope.createRunList = function () {
            var payload = {
                nickName: $scope.current.params.nickName,
                dateRange: null,
                runFor: $scope.current.params.whoFor - 1,
                keys: getKeys($scope.current.params.whoFor),
                asOfDate:
                    $scope.current.params.billType == 2
                        ? Date.create('today').addMonths(-1).endOfMonth().formatted()
                        : $scope.current.params.asOfDate.formatted(),
                billType: $scope.current.params.billType,
                vHint: 5,
                pkKey: null,
                endDateOverride: $scope.current.params.overrideBillEndDate ? $scope.current.params.billEndDate.formatted() : null,
                recurringAdjustmentOverride: $scope.current.params.overrideRecurringAdjustment,
                acctList: null,
                valueAsOfOverride: $scope.current.params.overrideAsOfValueDate ? $scope.current.params.overrideAsOfDate.formatted() : null,
                isMockBill: $scope.current.wizardType === '2' ? true : false,
                IncludeCashFlow: $scope.current.includeCashFlows,
                AllowDuplicateMockBills: $scope.current.params.allowDuplicateMockBills,
                runForAccounts: $scope.current.params.runForAccounts,
            };

            $http.post('/Billing/BillGenerator/Action/Instance', payload, { trackerMsg: 'Creating Bill List' }).then(function (res) {
                $scope.leftSidebar.isOpen = true;
                location.href =
                    '#/billing/generator/ready?instanceId=' +
                    res.data.id +
                    '&runFor=' +
                    res.data.runForGroup +
                    '&status=' +
                    res.data.statusValue +
                    '&isMockBill=' +
                    res.data.isMockBill;
            });
        };

        $scope.goToAudit = function (url) {
            $location.url(url.replace('#', ''));
        };

        $scope.importFile = function (isRerun) {
            var title = 'Upload Ids';
            $dialog
                .inputBox('title', 'File', 'file', { postUrl: '/ValidateImport/Echo' })
                .open()
                .then(function (data) {
                    if (data) {
                        $scope.current.billIds = Object.values(data[0].result)[0].map(function (x) {
                            return parseInt(Object.values(x)[0]);
                        });
                    }
                });
        };

        $scope.getSelectedNames = function () {
            return $scope.current.selectedItems.map('name');
        };

        $scope.close = function () {
            $scope.leftSidebar.isOpen = true;
            $location.url('/billing/generator/instances');
        };

        $scope.clearAccounts = function () {
            $scope.accountList = [];
        };

        $scope.addSelectedAccount = function () {
            $http.get('/Portfolio/Accounts/' + $scope.current.selectedAccount.id + '/Value', { trackerMsg: 'Loading account value' }).then(function (res) {
                res.data.isSelected = true;
                if ($scope.accountList.none({ id: res.data.id })) {
                    $scope.accountList.push(res.data);
                }
                $scope.current.selectedAccount = null;
            });
        };

        $scope.startImportOver = function () {
            $scope.current.selectedItems = null;
        };

        //INITIALIZE
        $scope.current = {
            wizardStep: 0,
            animation: 'slide-right',
            title: 'Renewals',
            renewalMonths: [
                { name: 'January', value: 1 },
                { name: 'February', value: 2 },
                { name: 'March', value: 3 },
                { name: 'April', value: 4 },
                { name: 'May', value: 5 },
                { name: 'June', value: 6 },
                { name: 'July', value: 7 },
                { name: 'August', value: 8 },
                { name: 'September', value: 9 },
                { name: 'October', value: 10 },
                { name: 'November', value: 11 },
                { name: 'December', value: 12 },
            ],
            selectedAccounts: [],
            selectedAccountsDetail: [],
            selectedEntity: null,
            isAdvancedUsed: false,
            isArrearUsed: false,
            params: {
                whoFor: $scope.user.authorization.entity == 'Administrator' ? 1 : 6,
                billType: 1,
                billEndDate: Date.create('today'),
                overrideAsOfDate: Date.create('today'),
                asOfDate: Date.create('today').getStartOfQuarter().addDays(-1),
                billYear: new Date().getFullYear(),
                renewalYear: new Date().getFullYear(),
                renewalMonth: new Date().getMonth() + 1,
                nickName: '',
                overrideRecurringAdjustment: false,
                runForAccounts: 1,
            },
            showWizard: false,
            audits: [],
            selectedItems: [],
            overview: [],
            periodList: [],
            runForText: '',
            showCashFlow: false,
            includeCashFlows: true,
            billIds: [],
            clientIds: [],
            billInMass: false,
            rerunBillId: 0,
            searchBy: 1,
            activeStates: activeState,
        };
        $scope.wizardSteps = ['Audits', 'Time Frame', 'Selection & Filter', 'Create Instance'];
        $scope.accountList = [];

        billAudits.isLoaded.then(function () {
            $scope.current.audits = billAudits.auditLists;
            $scope.current.audits.notReady = $scope.current.audits.find({ entity: 5, description: 'Not Ready' });
        });

        init();

        // WATCH
        $scope.$watch('current.selectedEntity', function (newVal, oldVal) {
            if (newVal === oldVal || !newVal) return;

            if ($scope.current.params.whoFor == 7) {
                $http.get('/Billing/Instances/Client/' + newVal.id + '/List', { trackerMsg: 'Getting bills for client' }).then(function (res) {
                    $scope.current.billIds = res.data.map(function (item) {
                        return { dateRange: item.billType + ' (' + item.startDate + ' - ' + item.endDate + ')', billId: item.billId };
                    });
                });
            }
            $http.get('/Portfolio/Clients/' + newVal.id + '/Accounts?isActive=true', { trackerMsg: 'Loading accounts for household' }).then(function (res) {
                $scope.accountList = [];
                res.data.forEach(function (item) {
                    item.isSelected = true;
                    selectAccounts.push(item);
                });

                $scope.accountList = selectAccounts;
            });
        });

        $scope.$watch('current.params.whoFor', function (newVal, oldVal) {
            if (newVal === oldVal || !newVal) return;

            $scope.current.clientIds = [];
            $scope.current.billIds = [];
            $scope.current.selectedItems = [];
            $scope.current.selectedEntity = null;
            $scope.current.businessLine = null;
            $scope.clearAccounts();
        });

        $scope.$watch('current.businessLine', function (newVal, oldVal) {
            if (newVal === oldVal || !newVal) return;

            $http.get('/Portfolio/BusinessLines/' + newVal, { trackerMsg: 'Loading business line' }).then(function (res) {
                $scope.current.businessLineName = res.data.name;
            });
        });

        $scope.$watch('current.selectedItems', function (newVal, oldVal) {
            if (newVal === oldVal || !newVal) return;

            if ($scope.current.params.whoFor !== 8) return;

            var accountIds = newVal.map(function (item) {
                return item.id;
            });

            $http.post('/Portfolio/Accounts/Value/List/Async', accountIds, { trackerMsg: 'Loading account values' }).then(function (response) {
                var accounts = response.data;

                accounts.forEach(function (account) {
                    account.isSelected = true;
                    if ($scope.accountList.none({ id: account.id })) {
                        $scope.accountList.push(account);
                    }
                    $scope.current.selectedAccount = null;
                });
            });
        });

        var cancelWatch = $scope.$watch('leftSidebar.exists', function (newVal, oldVal) {
            if (newVal) {
                $scope.leftSidebar.exists = false;
                cancelWatch();
            }
        });

        $scope.$on('$destroy', function () {
            $scope.leftSidebar.exists = true;
        });
    }
);

'use strict';

app.controller('BillGeneratorSummaryCtrl', function BillGeneratorSummaryCtrl($scope, $oasRights, $dialog, $http) {
    // PUBLIC VARIABLES
    $scope.household = {
        chart: { config: {} },
    };
    $scope.fundFamilies = {
        chart: { config: {} },
    };
    $scope.custodian = {
        chart: { config: {} },
    };
    $scope.representatives = {
        chart: { config: {} },
    };
    $scope.feesByFeeSched = {
        chart: { config: {} },
    };
    $scope.feesByRep = {
        chart: { config: {} },
    };
    $scope.feesByPeriodColumn = {
        chart: { config: {} },
    };
    $scope.feesByCashFlows = {
        chart: { config: {} },
    };

    $scope.household.chart.config = {
        options: {
            credits: { enabled: false },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: { enabled: false, color: '#000000', connectorColor: '#000000', format: '<b>{point.name}</b>: {point.percentage:.1f} %' },
                },
            },
        },
        series: [{ type: 'pie', name: 'Households', data: [], innerSize: '70%', tooltip: { pointFormat: '{series.name}: <b>{point.y}%</b>' } }],
        title: { text: 'HOUSEHOLDS' },
        subtitle: { style: { color: 'blue', font: 'normal 16px Verdana, sans-serif' }, verticalAlign: 'middle' },
    };
    $scope.fundFamilies.chart.config = {
        options: {
            credits: { enabled: false },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: { enabled: false, color: '#000000', connectorColor: '#000000', format: '<b>{point.name}</b>: {point.percentage:.1f} %' },
                },
            },
        },
        series: [{ type: 'pie', name: 'Fund Families', data: [], innerSize: '70%', tooltip: { pointFormat: '{series.name}: <b>{point.y}%</b>' } }],
        title: { text: 'FUND FAMILIES' },
        subtitle: { style: { color: 'orange', font: 'normal 16px Verdana, sans-serif' }, verticalAlign: 'middle' },
    };
    $scope.custodian.chart.config = {
        options: {
            credits: { enabled: false },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: { enabled: false, color: '#000000', connectorColor: '#000000', format: '<b>{point.name}</b>: {point.percentage:.1f} %' },
                },
            },
        },
        series: [{ type: 'pie', name: 'Custodian', data: [], innerSize: '70%', tooltip: { pointFormat: '{series.name}: <b>{point.y}%</b>' } }],
        title: { text: 'CUSTODIAN' },
        subtitle: { style: { color: 'green', font: 'normal 16px Verdana, sans-serif' }, verticalAlign: 'middle' },
    };
    $scope.representatives.chart.config = {
        options: {
            credits: { enabled: false },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: { enabled: false, color: '#000000', connectorColor: '#000000', format: '<b>{point.name}</b>: {point.percentage:.1f} %' },
                },
            },
        },
        series: [{ type: 'pie', name: 'Representatives', data: [], innerSize: '70%', tooltip: { pointFormat: '{series.name}: <b>{point.y}%</b>' } }],
        title: { text: 'REPRESENTATIVES' },
        subtitle: { style: { color: 'purple', font: 'normal 16px Verdana, sans-serif' }, verticalAlign: 'middle' },
    };
    $scope.feesByFeeSched.chart.config = {
        options: {
            credits: { enabled: false },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>',
                        style: {
                            color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black',
                        },
                    },
                },
            },
        },
        series: [
            {
                type: 'pie',
                name: 'Fees By Schedule',
                data: [],
                //innerSize: '20%',
                tooltip: {
                    pointFormat: '{point.name}: <b>${point.y}</b>',
                },
            },
        ],
        title: { text: 'Fees By Fee Schedule' },
        subtitle: { text: '' },
    };
    $scope.feesByRep.chart.config = {
        options: {
            credits: { enabled: false },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>',
                        style: {
                            color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black',
                        },
                    },
                },
            },
        },
        series: [
            {
                type: 'pie',
                name: 'Fees By Schedule',
                data: [],
                //innerSize: '20%',
                tooltip: {
                    pointFormat: '{point.name}: <b>${point.y}</b>',
                },
            },
        ],
        title: { text: 'Fees By Representative' },
        subtitle: { text: '' },
    };
    $scope.feesByPeriodColumn.chart.config = {
        options: {
            chart: { type: 'column' },
            credits: { enabled: false },
            legend: { enabled: false, borderWidth: 0, layout: 'vertical', align: 'right', verticalAlign: 'middle' },
            xAxis: { categories: [], labels: { rotation: -45, align: 'right', style: { fontSize: '11px', fontFamily: 'Helvetica, Neue' } } },
            yAxis: { title: { text: '' }, labels: { format: '${value:,.0f}' } },
            plotOptions: { column: { pointPadding: 0.2, borderWidth: 0 } },
            tooltip: { pointFormat: '<b>{point.y:.0f}</b>' },
        },
        series: [
            {
                data: [],
                name: '',
                color: 'green',
            },
        ],
        title: { text: 'Fees by Period' },
        subtitle: { text: '' },
    };
    $scope.feesByCashFlows.chart.config = {
        options: {
            chart: { type: 'column' },
            xAxis: {
                categories: [],
            },
            yAxis: {
                allowDecimals: false,
                min: -8000,
                title: { text: '' },
            },
            legend: { enabled: false, borderWidth: 0, layout: 'vertical', align: 'right', verticalAlign: 'middle' },
            tooltip: {
                formatter: function () {
                    return '<b>' + this.x + '</b><br/>' + this.series.name + ': ' + this.y + '<br/>' + 'Total: ' + this.point.stackTotal;
                },
            },
            plotOptions: {
                column: { stacking: 'normal' },
            },
        },
        series: [{ data: [] }, { data: [] }],
        title: { text: 'Fees by Cash Flows' },
    };

    // PUBLIC FUNCTIONS
    $scope.refreshDashboard = function () {
        getSummaryData(true);
    };

    //PRIVATE METHODS
    function init() {
        getSummaryData(false);
    }

    function getSummaryData(resetCache) {
        var startDate = $scope.current.startDate.formatted();
        var endDate = $scope.current.endDate.formatted();
        var billInstanceId = null;

        if ($scope.current.summaryType == '2') {
            // only set bill Instance if searching by Instance Id
            billInstanceId = $scope.current.billInstanceId ? $scope.current.billInstanceId : null;
        }

        var url =
            '/Billing/BillGenerator/Summary?startDate=' + startDate + '&endDate=' + endDate + '&billInstanceId=' + billInstanceId + '&resetCache=' + resetCache;
        $http.get(url, { trackerMsg: 'Getting data for charts' }).then(function (res) {
            var percentageCoverage = res.data.findAll({ chartType: 'PercentCoverage' });
            var feesByPeriod = res.data.findAll({ chartType: 'FeesByPeriod' });
            var peakFees = res.data.find({ chartType: 'PeakFees' });
            var feesByFeeSchedule = res.data.findAll({ chartType: 'FeesByFeeSchedule' });
            var feesByRepresentative = res.data.findAll({ chartType: 'FeesByRepresentative' });
            var feesByCashFlows = res.data.findAll({ chartType: 'FeesByCashFlows' });

            if (percentageCoverage) {
                percentageCoverage.forEach(function (item) {
                    switch (item.name) {
                        case 'Household':
                            setUpEntityChart(item.value, 'blue', 'gray', item.name);
                            break;
                        case 'Fund Families':
                            setUpEntityChart(item.value, 'orange', 'gray', item.name);
                            break;
                        case 'Custodian':
                            setUpEntityChart(item.value, 'green', 'gray', item.name);
                            break;
                        case 'Representatives':
                            setUpEntityChart(item.value, 'purple', 'gray', item.name);
                            break;
                    }
                });
            }

            if (!feesByCashFlows) {
                $scope.current.showFeeByCashFlow = false;
            }
            if (feesByCashFlows) {
                $scope.feesByCashFlows.chart.config.options.xAxis.categories = feesByCashFlows.groupOn('name').map('name');
                var missingRow = feesByCashFlows.groupOn('name').findAll(function (g) {
                    return g.items.length === 1;
                });
                missingRow.forEach(function (month) {
                    feesByCashFlows.push({ name: month.items[0].name, value: 0 });
                });

                $scope.feesByCashFlows.chart.config.series[0].data = [];
                $scope.feesByCashFlows.chart.config.series[1].data = [];

                // Series[0] - Contribution Series[1] = Distribution
                feesByCashFlows.groupOn('name').forEach(function (row) {
                    // has contribution but no distribution
                    if (row.items[0].value > 0 && row.items[1].value === 0) {
                        $scope.feesByCashFlows.chart.config.series[0].data.add(row.items[0].value);
                        $scope.feesByCashFlows.chart.config.series[1].data.add(row.items[1].value);
                    } else if (row.items[0].value < 0 && row.items[1].value === 0) {
                        // has distribution but no contribution
                        $scope.feesByCashFlows.chart.config.series[1].data.add(row.items[0].value);
                        $scope.feesByCashFlows.chart.config.series[0].data.add(row.items[1].value);
                    } else {
                        if (row.items[0].value > 0 && row.item[1].value < 0) {
                            $scope.feesByCashFlows.chart.config.series[1].data.add(row.items[0].value);
                            $scope.feesByCashFlows.chart.config.series[0].data.add(row.items[1].value);
                        } else {
                            $scope.feesByCashFlows.chart.config.series[0].data.add(row.items[0].value);
                            $scope.feesByCashFlows.chart.config.series[1].data.add(row.items[1].value);
                        }
                    }
                });
                if ($scope.feesByCashFlows.chart.config.series[0]) {
                    $scope.feesByCashFlows.chart.config.series[0].name = 'Contribution';
                }

                if ($scope.feesByCashFlows.chart.config.series[1]) {
                    $scope.feesByCashFlows.chart.config.series[1].name = 'Distribution';
                }
            }
            if (feesByPeriod) {
                $scope.feeByPeriod = feesByPeriod;

                $scope.feesByPeriodColumn.chart.config.series[0].data = feesByPeriod.map(function (x) {
                    return { name: x.name, y: x.value };
                });
            }

            if (peakFees) {
                $scope.current.peakFees.date = peakFees.name;
                $scope.current.peakFees.amount = peakFees.value;
            }

            if (feesByFeeSchedule) {
                $scope.feesByFeeSched.chart.config.series[0].data = feesByFeeSchedule.map(function (x) {
                    return { name: x.name, y: x.value };
                });
            }

            if (feesByRepresentative) {
                $scope.feesByRep.chart.config.series[0].data = feesByRepresentative.map(function (x) {
                    return { name: x.name, y: x.value };
                });
            }
        });
    }

    function setUpEntityChart(value, color1, color2, entity) {
        var val1 = { y: (value * 100).round(2), color: color1 };
        var val2 = { y: (100 - val1.y).round(2), color: color2 };

        switch (entity) {
            case 'Household':
                $scope.household.chart.config.series[0].data[0] = val1;
                $scope.household.chart.config.series[0].data[1] = val2;
                $scope.household.chart.config.subtitle.text = val1.y + '%';
                break;
            case 'Fund Families':
                $scope.fundFamilies.chart.config.series[0].data[0] = val1;
                $scope.fundFamilies.chart.config.series[0].data[1] = val2;
                $scope.fundFamilies.chart.config.subtitle.text = val1.y + '%';
                break;
            case 'Custodian':
                $scope.custodian.chart.config.series[0].data[0] = val1;
                $scope.custodian.chart.config.series[0].data[1] = val2;
                $scope.custodian.chart.config.subtitle.text = val1.y + '%';
                break;
            case 'Representatives':
                $scope.representatives.chart.config.series[0].data[0] = val1;
                $scope.representatives.chart.config.series[0].data[1] = val2;
                $scope.representatives.chart.config.subtitle.text = val1.y + '%';
                break;
        }
    }

    $scope.current = {
        startDate: Date.create('today').beginningOfMonth(),
        endDate: Date.create('today').endOfMonth(),
        peakFees: { amount: 191214, date: 'October 2015' },
        greatestChange: { amount: 182416, dateRange: 'June 2015 to July 2015' },
        showFeeByCashFlow: false,
        summaryType: 1,
    };

    init();
});

'use strict';

app.controller('BillGeneratorFinalBillsCtrl', function BillGeneratorFinalBillsCtrl($scope, $dialog, $http, $location) {
    // PRIVATE VARIABLES
    var selectAccounts = [];

    // PRIVATE FUNCTIONS
    function loadAccounts(ids) {
        $http.post('/Portfolio/Accounts/List', ids, { trackerMsg: 'Loading accounts' }).then(function (response) {
            $scope.accountList = [];
            response.data.forEach(function (item) {
                item.isSelected = true;
            });

            $scope.accountList = response.data.findAll({ isActive: true });
        });
    }

    $scope.runFinalBill = function () {
        var payload = {
            nickName: $scope.current.params.nickName,
            dateRange: null,
            runFor: 7,
            keys: $scope.accountList.findAll({ isSelected: true }).map('id'),
            asOfDate: $scope.current.billDate.formatted(),
            billType: 1,
            vHint: 5,
            pkKey: null,
            endDateOverride: $scope.current.billDate.formatted(),
            acctList: null,
            valueAsOfOverride: null,
            isMockBill: false,
            isFinalBill: true,
        };

        $http.post('/Billing/BillGenerator/Action/Instance', payload, { trackerMsg: 'Creating Bill List' }).then(function (response) {
            var res = response.data;
            $scope.leftSidebar.isOpen = true;
            location.href =
                '#/billing/generator/ready?instanceId=' +
                res.id +
                '&runFor=' +
                res.runForGroup +
                '&status=' +
                res.statusValue +
                '&isMockBill=' +
                res.isMockBill;
        });
    };

    $scope.close = function () {
        $scope.leftSidebar.isOpen = true;
        $location.url('/billing/generator/instances');
    };

    $scope.importFile = function () {
        $dialog
            .inputBox('Upload Account IDs', 'File', 'file', { postUrl: '/ValidateImport/Echo' })
            .open()
            .then(function (data) {
                if (data) {
                    var ids = Object.values(data[0].result)[0].map(function (x) {
                        return Object.values(x)[0];
                    });

                    if (ids.length > 0) {
                        loadAccounts(ids);
                    }
                }
            });
    };

    $scope.addSelectedAccount = function () {
        $http.get('/Portfolio/Accounts/' + $scope.current.selectedAccount.id + '/Value', { trackerMsg: 'Loading account value' }).then(function (res) {
            res.data.isSelected = true;
            if ($scope.accountList.none({ id: res.data.id })) {
                $scope.accountList.push(res.data);
            }
            $scope.current.selectedAccount = null;
        });
    };

    $scope.clearAccounts = function () {
        $scope.accountList = [];
    };

    //INITIALIZE
    $scope.current = {
        wizardStep: 0,
        animation: 'slide-right',
        selectedEntity: null,
        params: {
            whoFor: 1,
            billEndDate: Date.create('today'),
            asOfDate: Date.create('today'),
            fromListType: 0,
            billType: 1,
        },
        availableTitle: 'Account',
        billDate: Date.create('today'),
        searchBy: 2,
    };

    $scope.wizardSteps = ['Generate'];
    $scope.accountList = [];

    // WATCH
    $scope.$watch('current.selectedEntity', function (newVal, oldVal) {
        if (newVal === oldVal || !newVal) return;

        $http.get('/Portfolio/Clients/' + newVal.id + '/Accounts', { trackerMsg: 'Loading accounts for household' }).then(function (response) {
            $scope.accountList = [];
            response.data.forEach(function (item) {
                item.isSelected = true;
            });

            $scope.accountList = response.data.findAll({ isActive: true });
        });
    });

    var cancelWatch = $scope.$watch('leftSidebar.exists', function (newVal, oldVal) {
        if (newVal) {
            $scope.leftSidebar.exists = false;
            cancelWatch();
        }
    });

    $scope.$on('$destroy', function () {
        $scope.leftSidebar.exists = true;
    });
});

'use strict';

app.controller(
    'BillGeneratorPlanFeeCtrl',
    function BillGeneratorPlanFeeCtrl(
        $scope,
        $location,
        $dialog,
        $http,
        $q,
        $routeParams,
        $oasRights,
        $portfolio,
        entities,
        apps,
        billingStyle,
        billFrequency
    ) {
        // PRIVATE VARIABLES
        var isNewHH = false;

        // PRIVATE METHODS
        function init() {
            loadEnumLookUps();
            $scope.populateFinancialPlanningFee();
            $scope.getFeeTypes();
            var getUser = sessionStorage.getItem('oas_authorization');
            if (getUser !== null) {
                $scope.user = getUser;
            }
        }

        function loadEnumLookUps() {
            var list = {
                billStyles: billingStyle,
                billFrequencies: billFrequency,
            };

            Object.each(list, function (key, value) {
                $scope[key] = $portfolio.enumToSimpleList(value);
            });
        }

        // PUBLIC METHODS
        $scope.checkUserPrivs = function () {
            var privCheck = true;
            var checks = [
                'BLUEPAY',
                'ACCOUNTCHANGE',
                'ASSETS',
                'CLIENTS',
                'REGISTRATIONS',
                'ACCOUNTS',
                'ENTITYOPTION',
                'ACCTSTATUSCHG',
                'ACCTBILLING',
                'ASSETBILLING',
                'CLIENTBILLING',
                'ACCTFEEANDPAYOUTCBO',
                'CREDITCARDVIEWING',
                'HOUSEHOLDINGAPP',
            ];
            checks.every(function (right) {
                privCheck = $oasRights.canUpdate(right);
                return privCheck;
            });
            return privCheck;
        };

        $scope.next = function () {
            switch ($scope.current.wizardStep) {
                case 1: // Selection
                    $scope.payoutSchedules = [];
                    $scope.current.cycleMonthDisp = $scope.current.cycleMonths.find({ id: $scope.planningFee.cycleMonth }).name;
                    $scope.current.frequencyDisplay = $scope.current.frequencies.find({ value: $scope.planningFee.billFrequency }).name;
                    $scope.current.animation = 'slide-right';
                    $scope.current.wizardStep += 1;
                    break;
                default:
                    $scope.current.animation = 'slide-right';
                    $scope.current.wizardStep += 1;
                    break;
            }
        };

        $scope.back = function () {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep -= 1;
        };

        $scope.jumpBackTo = function (index) {
            if (index < $scope.current.wizardStep) {
                $scope.current.animation = 'slide-left';
                if (index === 3 && $scope.current.params.whoFor === 1) {
                    $scope.current.wizardStep = 2;
                } else {
                    $scope.current.wizardStep = index;
                }
            }
        };

        $scope.getClient = function (household) {
            $http
                .get('/Portfolio/Clients/Verbose/' + household.id + '?expand=billing&expand=portfolio', { trackerMsg: 'Getting Client' })
                .then(function (response) {
                    $scope.current.client = response.data;
                });
        };

        $scope.getFeeTypes = function () {
            $http.get('/Billing/FeeType/List/', { trackerMsg: 'Getting Fee Types' }).then(function (response) {
                $scope.current.feeTypes = response.data;
            });
        };

        $scope.isStepIncomplete = function () {
            switch ($scope.current.wizardStep) {
                case 0:
                    return $scope.current.client === null ? true : false;
                case 1:
                    return $scope.current.client.portfolio.email === null || $scope.emailInvalid ? true : false;
                case 2:
                    return false;
                default:
                    return false;
            }
        };

        $scope.createClient = function () {
            isNewHH = true;
            var menuOverride = {
                menuOverride: {
                    categories: [
                        { name: 'Household', children: [{ name: 'General', active: false, code: 'householdGeneral' }] },
                        {
                            name: 'Billing',
                            children: [
                                { name: 'Credit Card', active: false, code: 'bluePay' },
                                { name: 'Financial Planning Fee', active: false, code: 'financialPlanningFee' },
                            ],
                        },
                    ],
                },
            };
            $portfolio
                .openEditor(entities.client.value, isNewHH ? [] : $scope.selectedIds, null, null, apps.portfolioLists.name, menuOverride)
                .then(function (rslt) {
                    if (rslt) {
                        $scope.current.household = { id: rslt.id, name: rslt.name };
                        $scope.getClient(rslt);
                        $scope.$broadcast('event:portfoliolist-household-action', { action: isNewHH ? 'add-item' : 'update-item', item: rslt });
                        $q.all([
                            $http.get('/portfolio/clients/verbose/' + rslt.id + '?expand=portfolio'),
                            $http.get('/Portfolio/ClientCategories/Simple'),
                        ]).then(function (responses) {
                            var client = responses[0].data;
                            var cats = responses[1].data;
                            client.portfolio.categoryId = cats.find({ name: 'Planning Fee Only Client' }).id;
                            $http.put('/portfolio/clients/verbose/' + rslt.id, client);
                        });
                    }
                });
        };

        $scope.createFeeInstance = function () {
            var feeInstance = {
                payMethodId: 3,
                feeScheduleId: $scope.planningFee.feeScheduleId,
                masterPayoutScheduleId: $scope.planningFee.masterPayoutScheduleId,
                billStyle: $scope.planningFee.billStyle,
                billFrequency: $scope.planningFee.billFrequency,
                startDate: $scope.planningFee.startDate,
                cycleMonth: $scope.planningFee.cycleMonth,
                planningFeeAmount: $scope.current.feeRecur === 'flat' ? $scope.planningFee.flatFeeAmount : null,
            };

            $scope.current.client.billing.statusType = 'Ready to Bill';
            var payload1 = {
                financialPlanningFee: feeInstance,
                billing: $scope.current.client.billing,
                id: $scope.current.household.id,
            };

            $http
                .get('/Security/Profiles?entity=Client&entityId=' + $scope.current.household.id, { trackerMsg: 'Checking' + ' For User' })
                .then(function (res) {
                    if (res.data.length === 0 && isNewHH) {
                        if (!$oasRights.canAdd('MUL_USERS')) {
                            $dialog
                                .confirmAction(
                                    'You do do not have rights to create users. A user will need to be' +
                                        ' manually created for this household before this client can access their Feepay Portal.' +
                                        ' Do you wish to continue?'
                                )
                                .open()
                                .then(function (result) {
                                    if (result === 'yes') {
                                        createInstance(payload1);
                                    } else {
                                        $location.path('/billing/generator/instances');
                                    }
                                });
                        } else {
                            $http.get('/Security/Users/client/' + $scope.current.household.id, { trackerMsg: 'Getting' + ' Blank User' }).then(function (res2) {
                                var userProfile = {
                                    entityId: $scope.current.household.id,
                                    entityName: res2.data.entityName,
                                    isUserDefault: true,
                                    isInCurrentDb: true,
                                    loginEntityId: 4,
                                };

                                var createUserPayload = res2.data;
                                createUserPayload.userId = $scope.current.client.portfolio.email;
                                createUserPayload.email = $scope.current.client.portfolio.email;
                                createUserPayload.profiles.push(userProfile);

                                $http.post('/Security/Users?sendEmail=true', createUserPayload, { trackerMsg: 'Creating User for Client' }).then(function () {
                                    createInstance(payload1);
                                });
                            });
                        }
                    } else {
                        createInstance(payload1);
                    }
                });
        };

        function createInstance(payload1) {
            $http.put('/Portfolio/Clients/Verbose/' + $scope.current.household.id, payload1, { trackerMsg: 'Creating Fee Instance' }).then(function () {
                $scope.leftSidebar.isOpen = true;
                $http
                    .post('/Billing/FinancialPlanningFee/Action/Instance/' + $scope.current.household.id, {}, { trackerMsg: 'Creating Planning Fee' })
                    .then(function (res) {
                        $scope.leftSidebar.isOpen = true;
                        $location.url('/billing/generator/ready?instanceId=' + res.data);
                    });
            });
        }

        $scope.close = function () {
            location.href = '#/billing/generator/instances';
        };

        $scope.populateFinancialPlanningFee = function () {
            $http.get('/Portfolio/Clients/Verbose/New?expand=financialPlanningFee', { trackerMsg: 'Loading planning fee' }).then(function (response) {
                $scope.planningFee = response.data.financialPlanningFee;
                if ($scope.planningFee === null) {
                    $http.get('/Portfolio/Clients/Verbose/New?expand=financialPlanningFee', { trackerMsg: 'Getting new planning fee' }).then(function (res) {
                        $scope.planningFee = res.data.planningFee;
                        $scope.setCycleMonths($scope.planningFee.billFrequency);
                    });
                } else {
                    $scope.setCycleMonths($scope.planningFee.billFrequency);
                }
            });
        };

        $scope.setCycleMonths = function (frequency) {
            switch (frequency) {
                case billFrequency.monthly.name:
                    $scope.current.cycleMonths = [{ id: 1, name: 'Every Month' }];
                    break;
                case billFrequency.quarterly.name:
                    buildCycleMonths(3, ' of Quarter');
                    break;
                case billFrequency.triannual.name:
                    buildCycleMonths(4, ' of Cycle');
                    break;
                case billFrequency.semiannually.name:
                    buildCycleMonths(6, ' of Cycle');
                    break;
                default:
                    buildCycleMonths(12, ' of Cycle');
            }
        };

        function buildCycleMonths(upperBound, endText) {
            $scope.current.cycleMonths = [];
            (1).upto(upperBound, function (n) {
                $scope.current.cycleMonths.push({ id: n, name: 'Month ' + n + endText });
            });
        }

        $scope.getFeeTypeNameByVal = function () {
            return $scope.current.feeTypes.find({ id: $scope.current.feeType }).name;
        };

        $scope.setAnnual = function () {
            if ($scope.current.feeRecur === 'flat') {
                $scope.planningFee.billFrequency = 'Annually';
                // Many of these below are hacks to default the UI correctly for Flat Fees
                buildCycleMonths(12, ' of Cycle');
                $scope.planningFee.cycleMonth = new Date().getMonth() + 1;
            }
        };

        $scope.invalidEmail = function (invalid) {
            $scope.emailInvalid = invalid;
        };
    
        $scope.setEmail = function (value) {
            $scope.current.client.portfolio.email = value;
        };

        //INITIALIZE
        $scope.current = {
            wizardStep: 0,
            animation: 'slide-right',
            title: 'Renewals',
            renewalMonths: [
                { name: 'January', value: 1 },
                { name: 'February', value: 2 },
                { name: 'March', value: 3 },
                { name: 'April', value: 4 },
                { name: 'May', value: 5 },
                { name: 'June', value: 6 },
                { name: 'July', value: 7 },
                { name: 'August', value: 8 },
                { name: 'September', value: 9 },
                { name: 'October', value: 10 },
                { name: 'November', value: 11 },
                { name: 'December', value: 12 },
            ],
            selectedAccounts: [],
            selectedAccountsDetail: [],
            selectedEntity: null,
            isAdvancedUsed: false,
            isArrearUsed: false,
            params: {
                whoFor: $scope.user.authorization.entity === 'Administrator' ? 1 : 6,
                billType: 1,
                billEndDate: Date.create('today'),
                overrideAsOfDate: Date.create('today'),
                asOfDate: Date.create('today').getStartOfQuarter().addDays(-1),
                billYear: new Date().getFullYear(),
                renewalYear: new Date().getFullYear(),
                renewalMonth: new Date().getMonth() + 1,
                nickName: '',
            },
            feeTypes: [
                { name: 'Financial Planning', value: 'fp' },
                { name: 'Tax Planning', value: 'tax' },
            ],
            feeType: 1,
            feeRecur: 'schedule',
            flatFeeAmount: 0,
            cycleMonthDisp: null,
            payoutSchedule: null,
            showWizard: false,
            audits: [],
            selectedItems: [],
            overview: [],
            periodList: [],
            runForText: '',
            showCashFlow: false,
            includeCashFlows: true,
            billIds: [],
            client: null,
            clientIds: [],
            billInMass: false,
            rerunBillId: 0,
            searchBy: 1,
            frequencies: [
                { name: 'Monthly', value: 'Monthly' },
                { name: 'Quarterly', value: 'Quarterly' },
                { name: 'Annually', value: 'Annually' },
                { name: 'Semi-Annually', value: 'Semi-Annual' },
                { name: 'Tri-Annually', value: 'Triannual' },
            ],
        };
        $scope.wizardSteps = ['Client Info', 'Fee Details', 'Confirm'];
        init();

        // WATCH
        var cancelWatch = $scope.$watch('leftSidebar.exists', function (newVal) {
            if (newVal) {
                $scope.leftSidebar.exists = false;
                cancelWatch();
            }
        });

        $scope.$on('$destroy', function () {
            $scope.leftSidebar.exists = true;
        });
    }
);

'use strict';

app.controller('UndoPostedPaymentsCtrl', function UndoPostedPaymentsCtrl($scope, dialog, $http, $dialog) {
    $scope.search = function () {
        var searchString = '';

        searchString =
            $scope.current.runFor == '1' ? 'postedDate=' + $scope.current.datePosted.format('{yyyy}-{MM}-{dd}') : 'batchNumber=' + $scope.current.batchNumber;
        $http.get('/Billing/PostPayments?' + searchString, { trackerMsg: 'Loading posted payments' }).then(function (response) {
            $scope.postedPayments = response.data;
        });
    };

    $scope.close = function () {
        dialog.close(null);
    };

    $scope.undoPostedPayment = function (id) {
        $http.put('/Billing/PostedPayments/Action/Delete', [id], { trackerMsg: 'Undo posted payment ' + id }).then(function () {
            $scope.search();
        });
    };

    $scope.current = {
        runFor: '1',
        datePosted: Date.create('today'),
        batchNumber: '',
    };
});

app.controller('BillEligibleFilterCtrl', function BillEligibleFilterCtrl($scope, dialog) {
    $scope.cancel = function () {
        dialog.close(null);
    };

    $scope.clearSelected = function () {
        $scope.current.selectedItems = [];
    };

    $scope.process = function () {
        dialog.close({ selectedIds: $scope.current.selectedItems, filterType: $scope.current.filterType == 12 ? 'Fund Family' : 'Representative' });
    };

    $scope.current = {
        filterType: 12,
        selectedItems: [],
    };
});

'use strict';

app.controller('BillCancellationByAccountCtrl', ['$scope', 'dialog', '$http', '$dialog', 'popupBlockerChecker', function BillCancellationByAccountCtrl($scope, dialog, $http, $dialog, popupBlockerChecker) {
    $scope.run = function () {
        var payload = { startDate: $scope.current.startDate.format('{yyyy}-{MM}-{dd}'), endDate: $scope.current.endDate.format('{yyyy}-{MM}-{dd}'), reportFormat: "Html" };

        $scope.current.isRunning = true;
        $http.post('/Reporting/Billing/Reports/BillCancellationByAccount/Action/Generate', payload, { trackerMsg: 'Running Bill Cancellation By Account' }).then(function (response) {
            $scope.current.isRunning = false;
                var location = response.headers("location");
                if (location) {
                    var url = location + (location.has("?") ? "&" : "?") + "Authorization=" + sessionStorage.oas_token;
                    popupBlockerChecker.open(url)
                }
        });
    };

    $scope.close = function () {
        dialog.close(null);
    };

    $scope.current = {
        startDate: Date.create('30 days ago'),
        endDate: Date.create('today'),
    };
}]);

app.controller('AuditAllAccountsFilterCtrl', function AuditAllAccountsFilterCtrl($scope, $dialog, dialog, $portfolio, entities, $http) {
    var entitySearch = null;

    $scope.cancel = function () {
        dialog.close(null);
    };

    $scope.clearSelected = function () {
        $scope.current.selectedItems = [];

        if ($scope.current.filterType == '1') {
            $portfolio.search(entities.client.value).then(function (rslt) {
                entitySearch = rslt;
            });
        }
    };

    $scope.process = function () {
        var filterType;
        var selectedItems = [];

        switch ($scope.current.filterType) {
            case 12:
                filterType = 'Fund Family';
                selectedItems = $scope.current.selectedItems;
                break;
            case 16:
                filterType = 'Management Styles';
                selectedItems = $scope.current.selectedItems;
                break;
            case 1:
                if (entitySearch.entity == '5') {
                    filterType = 'Household';
                    selectedItems.push({ id: entitySearch.item.id });
                } else if (entitySearch.entity == '6') {
                    filterType = 'Registration';
                    selectedItems.push({ id: entitySearch.item.id });
                } else {
                    filterType = 'Account';
                    selectedItems.push({ id: entitySearch.item.id });
                }
                break;
            case 2:
                filterType = 'Fee Schedule';
                selectedItems.push({ id: $scope.current.schedule });
                break;
            case 3:
                filterType = 'Payout Schedule';
                selectedItems.push({ id: $scope.current.masterPayoutScheduleId });
                break;
            case 4:
                filterType = 'Representatives';
                selectedItems = $scope.current.selectedItems;
                break;
            case 1979:
                filterType = 'Business Line';
                selectedItems.push({ id: $scope.current.businessLine });
                break;
            default:
                break;
        }

        if (selectedItems.length == 0) {
            $dialog
                .messageBox(
                    "<i class='fa fa-lg fa-exclamation-circle text-error' aria-hidden='true'></i> Incomplete Action",
                    ' You must select a filter option.'
                )
                .open();
        } else {
            dialog.close({ selectedIds: selectedItems, filterType: filterType });
        }
    };

    $scope.current = {
        filterType: 16,
        selectedItems: [],
        businessLine: null,
        hasCancel: dialog.options.hasCancel,
    };
});

'use strict';

app.controller(
    'BillingAuditTransactionSleeveListCtrl',
    function BillingAuditTransactionSleeveListCtrl($scope, $http, views, $dialog, $oasRights, $portfolio, entities, apps, $timeout) {
        //PRIVATE VARIABLES

        // PRIVATE METHODS
        function init() {
            $scope.current.params = '';

            if ($scope.user.authorization.entity === 'Representative') {
                $scope.current.isDisableActions = true;
            }
        }

        // PUBLIC METHODS
        $scope.openEditor = function () {
            if ($scope.selectedIds.length == 1) {
                $portfolio
                    .openEditor(entities.transaction.value, $scope.selectedIds, 'General', 'billingGeneral', apps.billingAudit.name, null)
                    .then(function (rslt) {
                        if (rslt) {
                            $scope.$broadcast('event:billtransactionsleeve-action', { action: 'update-item', item: rslt });
                        }
                    });
            } else {
                $portfolio.openMassEditor(entities.transaction.value, $scope.selectedIds, apps.billingAudit.name, null).then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:billtransactionsleeve-action', { action: 'update-items', items: rslt });
                    }
                });
            }
        };

        $scope.refreshGrid = function () {
            $scope.$broadcast('event:billtransactionsleeve-action', { action: 'refresh-grid' });
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:billtransactionsleeve-action', { action: 'export-data' });
        };

        $scope.slickGridDoubleClick = function () {
            if ($scope.selectedIds.length === 1) $scope.openEditor();
        };

        // INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.current = {
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            URL: '/Billing/Transactions/SleeveTransfers',
            startDate: Date.create('today').getStartOfQuarter(),
            endDate: Date.create('today'),
            transferType: '0', // 0 Both, 1 CashOnly, 2 Rebalance Only
            isDisableActions: false,
        };

        $scope.current.hotKeyActions = [
            {
                combo: 'ALT+E',
                command: function () {
                    $scope.openEditor();
                },
            },
        ];
        $scope.rights = $oasRights.forCode('BILLAUDITSLEEVE');

        init();
    }
);

'use strict';

app.controller(
    'BillingAuditFeeExcludedAssetsCtrl',
    function BillingAuditFeeExcludedAssetsCtrl($scope, $http, views, $dialog, $oasRights, $portfolio, entities, apps, $timeout) {
        // PRIVATE METHODS
        function init() {
            $scope.current.params = '';
        }

        // PUBLIC METHODS
        $scope.openEditor = function () {
            if ($scope.selectedIds.length == 1) {
                $portfolio
                    .openEditor(entities.transaction.value, $scope.selectedIds, 'General', 'billingGeneral', apps.billingAudit.name, null)
                    .then(function (rslt) {
                        if (rslt) {
                            $scope.$broadcast('event:billfeeexcludedasset-action', { action: 'update-item', item: rslt });
                        }
                    });
            }
        };

        $scope.refreshGrid = function () {
            $scope.$broadcast('event:billfeeexcludedasset-action', { action: 'refresh-grid' });
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:billfeeexcludedasset-action', { action: 'export-data' });
        };

        // INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.current = {
            view: views[0],
            URL: '/Billing/Transactions/FeeExcludedAssets',
            startDate: Date.create('today').getStartOfQuarter(),
            endDate: Date.create('today'),
        };
        $scope.rights = $oasRights.forCode('BILLAUDIT');

        init();
    }
);

'use strict';

app.service('billAudits', function billAudits($q, $http) {
    var self = this;
    var isLoaded;
    var audits = [];

    //PRIVATE METHODS
    function init() {
        getAudits();
    }

    function getAudits() {
        var promises = {
            audit: $http.get('/Settings/Apps/billingAudit', { trackerMsg: 'Loading audits url' }),
            counts: $http.get('/Billing/Counts', { trackerMsg: 'Loading audit counts' }),
        };

        isLoaded = $q.all(promises).then(function (responses) {
            var auditsUrl = responses.audit.data;
            var counts = responses.counts.data;

            Object.each(counts.client, function (key, value) {
                if (value > 0) {
                    auditsUrl.categories.forEach(function (item) {
                        item.pages.forEach(function (page) {
                            if (page.routeUrl.has(key.toLowerCase())) {
                                audits.push({ entity: 5, prop: key, description: page.name, count: value, url: page.routeUrl + '?source=bg' });
                            }
                        });
                    });
                }
            });
            Object.each(counts.account, function (key, value) {
                if (value > 0) {
                    auditsUrl.categories.forEach(function (item) {
                        item.pages.forEach(function (page) {
                            if (page.routeUrl.has(key.toLowerCase())) {
                                audits.push({ entity: 7, prop: key, description: page.name, count: value, url: page.routeUrl + '?source=bg' });
                            }
                        });
                    });
                }
            });
        });
    }

    //INITIALIZE
    init();

    //PUBLIC API
    self.isLoaded = isLoaded;
    self.auditLists = audits;
});

'use strict';

app.controller(
    'BillInstanceRunListCtrl',
    function BillInstanceRunListCtrl(
        $scope,
        $http,
        views,
        $portfolio,
        entities,
        apps,
        $oasRights,
        $billing,
        $location,
        $routeParams,
        $timeout,
        $signalRManager,
        $dialog,
        $rootScope
    ) {
        var runList = [],
            canSubscribe = true,
            billIds = null;

        // PRIVATE FUNCTIONS
        function init() {
            $scope.current.instanceId = $routeParams.instanceId;
            initSignalR();
            $scope.current.runFor = $routeParams.runFor;
            $scope.current.isMockBill = $routeParams.isMockBill;

            $http
                .get('/Billing/Instances/' + $scope.current.instanceId, { trackerMsg: 'Getting bill instance ' + $scope.current.instanceId })
                .then(function (res) {
                    $scope.current.status = res.data.statusValue;
                    getStatus();
                    $scope.current.url = '/Billing/BillGenerator/Instance/' + $scope.current.instanceId + '/ClientList';
                    $timeout(function () {
                        refreshGrid();
                    }, 50);
                });

            if ($scope.user.authorization.entity === 'Administrator') {
                $scope.current.canResetFeeFile = true;
            } else {
                $scope.current.canResetFeeFile = false;
            }
        }

        function getStatus(errorCount) {
            switch ($scope.current.status) {
                case 'Not Generated':
                    $scope.current.canGenerateSelected = true;
                    $scope.current.isBillActive = true;
                    $scope.current.isBillProcessed = false;
                    $scope.current.isAuditFilesProcessed = false;
                    $scope.current.isFeeFileProcessed = false;
                    break;
                case 'Data Files Needed':
                    $scope.current.canGenerateSelected = true;
                    $scope.current.isBillProcessed = true;
                    $scope.current.isBillActive = false;
                    $scope.current.isAuditFilesActive = true;
                    $scope.current.isFeeFilesProcess = false;
                    break;
                case 'Fee File Needed':
                case 'Fee File In Process':
                    $scope.current.canGenerateSelected = true;
                    $scope.current.isBillProcessed = true;
                    $scope.current.isBillActive = false;
                    $scope.current.isAuditFilesProcessed = true;
                    $scope.current.isFeeFilesActive = true;
                    $scope.current.isFeeFilesProcessed = false;
                    $scope.current.isCompleteActive = false;
                    break;
                case 'Fee File Needed - Failed':
                    $scope.current.canGenerateSelected = false;
                    $scope.current.isBillProcessed = true;
                    $scope.current.isBillActive = false;
                    $scope.current.isAuditFilesProcessed = true;
                    $scope.current.isFeeFilesActive = true;
                    break;
                case 'Complete with errors':
                case 'Complete':
                    $scope.current.canGenerateSelected = false;
                    $scope.current.isBillProcessed = true;
                    $scope.current.isBillActive = false;
                    $scope.current.isAuditFilesProcessed = true;
                    $scope.current.isFeeFilesProcessed = true;
                    $scope.current.isCompleteActive = true;
                    break;
            }
        }

        function refreshGrid() {
            $scope.$broadcast('event:billinstance-runlist-action', { action: 'refresh-grid' });
        }

        function initSignalR() {
            $.connection.hub.qs['billInstanceId'] = $scope.current.instanceId;
            $signalRManager.subscribeToHubV2('billInstanceClientHub', 'resetList', null, resetList);
            $signalRManager.subscribeToHubV2('billInstanceClientHub', 'addItems', null, addItems);
            $signalRManager.subscribeToHubV2('billInstanceClientHub', 'updateItems', null, updateItems);
            $signalRManager.subscribeToHubV2('billInstanceClientHub', 'removeItems', null, removeItems);
        }

        var listener = $rootScope.$on('$connectedToSignalR', () => {
            if ($rootScope.connectedToSignalRHub === 'billInstanceClientHub' && $rootScope.unsubFromSignalR === 'billInstanceClientHub') {
                console.log('disconnecting')
                $rootScope.connectedToSignalRHub = null;
                $rootScope.unsubFromSignalR = null;
                unsubFromSignalR();
            }
        })

        $scope.$on('$destroy', function() {
            $rootScope.unsubFromSignalR = 'billInstanceClientHub';
            $rootScope.$broadcast('$connectedToSignalR')
            listener(); // Unregister the listener
        });

        function unsubFromSignalR() {
            $signalRManager.unSubscribeToHub('billInstanceClientHub', 'resetList');
            $signalRManager.unSubscribeToHub('billInstanceClientHub', 'addItems');
            $signalRManager.unSubscribeToHub('billInstanceClientHub', 'updateItems');
            $signalRManager.unSubscribeToHub('billInstanceClientHub', 'removeItems');
            delete $.connection.hub.qs['billInstanceId'];
        }

        function updateCounts() {
            $scope.counts.total.value = entityCount(['Totals']);
            $scope.counts.pendingGeneration.value = entityCount(['Pending Generation']);
            $scope.counts.notGenerated.value = entityCount(['Not Generated']);
            $scope.counts.errored.value = entityCount(['Errored', 'Warning', 'Fee File Error', 'Reconciliation Error']);
            $scope.current.feeFileErrorCount = entityCount(['Fee File Error']);
            $scope.counts.onHold.value = entityCount(['On Hold']);
            $scope.counts.generated.value = entityCount(['Generated']);

            if ($scope.counts.pendingGeneration.value > 0) {
                $scope.current.isExecuting = true;
            } else {
                $scope.current.isExecuting = false;
            }
        }

        function entityCount(statuses) {
            if (statuses.some('Totals')) {
                return runList.length;
            } else {
                return runList.count(function (entity) {
                    return statuses.some(entity.status);
                });
            }
        }
        function resetList(subscribe) {
            if (subscribe === undefined) {
                refreshGrid();
                return;
            }

            canSubscribe = subscribe;
        }

        function addItems(list) {
            $scope.$broadcast('event:billinstance-runlist-action', { action: 'upsert-items', items: list });
            list.forEach(function (item) {
                increaseCount(item);
                $scope.counts.total.value++;
                runList.push(item);
            });
        }

        function updateItems(list) {
            let updatedItems = [];
            list.forEach(function (item) {
                var entityItem = runList.find({ id: item.id });
                if (entityItem && entityItem.status !== item.status) {
                    decreaseCount(entityItem);
                    increaseCount(item);
                    entityItem.status = item.status;
                    entityItem.adjAmt = item.adjAmt;
                    entityItem.initialAmt = item.initialAmt;
                    entityItem.balanceDue = item.balanceDue;
                    entityItem.marketValue = item.marketValue;
                    entityItem.errorMessage = item.errorMessage;
                    entityItem.billId = item.billId;
                    updatedItems.push(entityItem);
                }
            });
            $scope.$broadcast('event:billinstance-runlist-action', { action: 'upsert-items', items: updatedItems });
        }

        function removeItems(list) {
            $scope.$broadcast('event:billinstance-runlist-action', { action: 'delete-items', items: list });
            list.forEach(function (item) {
                var entityItem = runList.find({ id: item.id });
                decreaseCount(entityItem);
                $scope.counts.total.value--;
                runList.remove(entityItem);
            });
        }

        function increaseCount(entityItem) {
            switch (entityItem.status) {
                case 'Pending Generation':
                    $scope.counts.pendingGeneration.value++;
                    break;
                case 'Not Generated':
                    $scope.counts.notGenerated.value++;
                    break;
                case 'Fee File Error':
                case 'Recon Error':
                case 'Warning':
                case 'Errored':
                    $scope.counts.errored.value++;
                    break;
                case 'On Hold':
                    $scope.counts.onHold.value++;
                case 'Generated':
                    $scope.counts.generated.value++;
                    break;
            }
        }

        function decreaseCount(entityItem) {
            switch (entityItem.status) {
                case 'Pending Generation':
                    $scope.counts.pendingGeneration.value--;
                    break;
                case 'Not Generated':
                    $scope.counts.notGenerated.value--;
                    break;
                case 'FeeFileError':
                case 'ReconError':
                case 'Warning':
                case 'Errored':
                    $scope.counts.errored.value--;
                    break;
                case 'On Hold':
                    $scope.counts.onHold.value--;
                case 'Generated':
                    $scope.counts.generated.value--;
                    break;
            }

            if ($scope.counts.pendingGeneration.value === 0) {
                $http
                    .get('/Billing/Instances/' + $scope.current.instanceId, { trackerMsg: 'Getting bill instance ' + $scope.current.instanceId })
                    .then(function (res) {
                        $scope.current.status = res.data.statusValue;
                        init();
                    });
            }
        }

        // PUBLIC FUNCTIONS
        $scope.refreshGrid = function () {
            $scope.$broadcast('event:billinstance-runlist-action', { action: 'refresh-grid' });
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:billinstance-runlist-action', { action: 'export-data' });
        };

        $scope.editEntity = function (entity) {
            if (entity === entities.client.name) {
                $portfolio.openEditor(entities.client.value, [$scope.current.householdId], null, null, apps.billingAudit.name, null).then(function (rst) {});
            } else if (entity === entities.registration.name) {
                $portfolio
                    .openEditor(entities.registration.value, $scope.current.householdId, null, null, apps.billingAudit.name, null)
                    .then(function (rst) {});
            }
        };

        $scope.recalcPayees = function () {
            $http
                .put(`/Billing/Instances/${$scope.current.instanceId}/RecalcPayees`, $scope.selectedIds, { trackerMsg: 'Removing billing lockdown option' })
                .then(function (res) {
                    console.log(res);
                });
        };

        $scope.goToFeeSchedules = function () {
            $location.url('/firmprofile/schedules/fee');
        };

        $scope.goToLower = function (urlLevel) {
            $portfolio.goTo(urlLevel, entities.client.value, $scope.current.householdId, { source: 'bg' });
        };

        $scope.runAdvisoryFeeReport = function () {
            $billing.runAdvisoryFeeReport(entities.client.value, $scope.current.householdId);
        };

        $scope.filterGenerationStatus = function (status) {
            var gridQueryId, filterFn;

            $scope.current.gridQueries = [];

            if (status.length === 0) return;

            gridQueryId = 'RBE';
            status.each(function (s) {
                gridQueryId += '_' + s;
            });

            if ($scope.current.gridQueries) $scope.current.gridQueries.remove({ id: gridQueryId });
            else $scope.current.gridQueries = [];

            filterFn = function (x) {
                return status.some(x);
            };
            $scope.current.gridQueries.push({
                id: gridQueryId,
                name: status.join('/'),
                description: 'Generation Status: ' + status.join(' or '),
                field: 'status',
                filterFn: filterFn,
                itemCount: entityCount(status),
                enabled: true,
            });
        };

        $scope.generate = function (all) {
            if ($scope.current.isMockBill === 'true') {
                $http
                    .put('/Billing/Instances/' + $scope.current.instanceId + '/Action/Generate', all ? null : $scope.selectedIds, {
                        trackerMsg: 'Generating bill(s)',
                    })
                    .then(function (res) {
                        $scope.current.status = res.data.statusValue;
                        init();
                        if (!canSubscribe) refreshGrid();
                    });
            } else {
                $dialog
                    .confirmAction('Do you want to turn on billing lockdown for fee file generation?')
                    .open()
                    .then(function (result) {
                        var isLockDown = false;

                        if (result === 'yes') {
                            $scope.user.alerts.push({ type: 'warning', msg: 'You are in billing lockdown!!!' });

                            isLockDown = true;
                        } else {
                            isLockDown = false;
                        }

                        $scope.current.isExecuting = true;

                        $http
                            .put(
                                '/Billing/Instances/' + $scope.current.instanceId + '/Action/Generate?lockDown=' + isLockDown,
                                all ? null : $scope.selectedIds,
                                { trackerMsg: 'Generating bill(s)' }
                            )
                            .then(function (res) {
                                $scope.current.status = res.data.statusValue;
                                init();
                                if (!canSubscribe) refreshGrid();
                            });
                    });
            }
        };

        $scope.generateBillData = function (all) {
            $http
                .post('/Billing/Instances/' + $scope.current.instanceId + '/Action/BillDataFiles', all ? null : $scope.selectedIds, {
                    trackerMsg: 'Generating bill data',
                })
                .then(function () {
                    $http
                        .get('/Billing/Instances/' + $scope.current.instanceId, { trackerMsg: 'Getting bill instance ' + $scope.current.instanceId })
                        .then(function (res) {
                            $scope.current.status = res.data.statusValue;
                            init();
                            $location.url('/billing/audit/files?source=bg&auditType=AuditData&instanceId=' + $scope.current.instanceId);
                            if (!canSubscribe) refreshGrid();
                        });
                });
        };

        $scope.generateFeeFileByCustodian = function (all) {
            $scope.current.isExecuting = true;

            $http
                .get('/Portfolio/Custodians/Simple?billInstanceId=' + $scope.current.instanceId, { trackerMsg: 'Loading custodian list' })
                .then(function (response) {
                    $dialog
                        .inputBox('Custodian', 'Select Custodian', response.data)
                        .open()
                        .then(function (result) {
                            if (result) {
                                $http
                                    .post(
                                        '/Billing/Instances/Action/FeeFiles?custodianId=' + result.id,
                                        all ? [parseInt($scope.current.instanceId)] : $scope.selectedIds,
                                        { trackerMsg: 'Generating fee files' }
                                    )
                                    .then(function () {
                                        $http
                                            .get('/Billing/Instances/' + $scope.current.instanceId, {
                                                trackerMsg: 'Getting bill instance ' + $scope.current.instanceId,
                                            })
                                            .then(function (res) {
                                                $scope.current.status = res.data.statusValue;
                                                init();
                                                $location.url('/billing/audit/files?source=bg&auditType=FeeFiles');
                                                if (!canSubscribe) refreshGrid();
                                                $scope.current.isExecuting = false;
                                            });
                                    });
                            }
                        });
                });
        };

        $scope.generateFeeFile = function (all) {
            $scope.current.isExecuting = true;
            $http
                .post('/Billing/Instances/Action/FeeFiles', all ? [parseInt($scope.current.instanceId)] : $scope.selectedIds, {
                    trackerMsg: 'Generating fee files',
                })
                .then(function () {
                    $http
                        .get('/Billing/Instances/' + $scope.current.instanceId, { trackerMsg: 'Getting bill instance ' + $scope.current.instanceId })
                        .then(function (res) {
                            $scope.current.status = res.data.statusValue;
                            init();
                            $location.url('/billing/audit/files?source=bg&auditType=FeeFiles');
                            if (!canSubscribe) refreshGrid();
                            $scope.current.isExecuting = false;
                        });
                });
        };

        $scope.deleteBills = function (isRelatedHousehold) {
            if (billIds[0] === null) {
                var errorMsg = "This record doesn't have a bill.";
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Empty Bill", errorMsg).open();
                return;
            }

            if (isRelatedHousehold) {
                var message = 'This client is related to these households and their bills will also be deleted if they are in this Instance? \r\n';
                $scope.current.relatedHouseholds.forEach(function (hh) {
                    message += 'HHID ' + hh + '<br />';
                });

                $dialog
                    .confirmAction(message)
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            $http
                                .delete('/Billing/Bills/' + billIds[0] + '/Action/DeleteClientRelatedBills', {
                                    trackerMsg: 'Deleting bill(s) for related household.',
                                })
                                .then(function () {
                                    refreshGrid();
                                });
                        }
                    });
            } else {
                $dialog
                    .confirmAction('You are about to delete bill(s).  Are you sure you want to proceed?')
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            $http.put('/Billing/Bills/Action/Delete/', billIds, { trackerMsg: 'Deleting bill(s)' }).then(function () {
                                refreshGrid();
                            });
                        }
                    });
            }
        };

        $scope.putOnHold = function () {
            $http
                .put('/Billing/Bills/' + $scope.current.instanceId + '/Action/Hold', $scope.selectedIds, { trackerMgs: 'Putting on hold' })
                .then(function (res) {
                    refreshGrid();
                });
        };

        $scope.viewBillData = function () {
            $location.url('/billing/audit/files?source=bg&auditType=AuditData&instanceId=' + $scope.current.instanceId);
        };

        $scope.viewFeeFile = function () {
            $location.url('/billing/audit/files?source=bg&auditType=FeeFiles&instanceId=' + $scope.current.instanceId);
        };

        $scope.cancelGeneration = function () {
            $dialog
                .confirmAction('Are you sure you want to cancel generating bill(s)?')
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $http
                            .put('/Billing/Instances/' + $scope.current.instanceId + '/Action/Generate/Cancel', { trackerMsg: 'Cancel generating bill(s)' })
                            .then(function () {
                                if (!canSubscribe) refreshGrid();
                            });
                    }
                });
        };

        $scope.forceComplete = function () {
            $http
                .post('/Billing/Instances/' + $scope.current.instanceId + '/Action/Complete', null, { trackerMsg: 'Mark instance complete' })
                .then(function () {
                    $http
                        .get('/Billing/Instances/' + $scope.current.instanceId, { trackerMsg: 'Getting bill instance ' + $scope.current.instanceId })
                        .then(function (res) {
                            $scope.current.status = res.data.statusValue;
                            init();
                            if (!canSubscribe) refreshGrid();
                        });
                });
        };

        $scope.goToHouseholdSummary = function () {
            $location.url('/billing/generator/householdsummary?id=' + $scope.current.householdId);
        };

        $scope.resetFeeFile = function () {
            $http
                .post('/Billing/Instances/' + $scope.current.instanceId + '/Action/ResetFeeFile', null, { trackerMsg: 'Reset Fee File' })
                .then(function (response) {
                    init();
                });
        };

        //WATCHES
        $scope.$watch('counts.total.value', function (newValue, oldValue) {
            if (newValue === oldValue) return;

            if ($scope.counts.total.change) $scope.counts.total.change = false;

            $scope.counts.total.change = true;
            $timeout(function () {
                $scope.counts.total.change = false;
            }, 500);
        });

        $scope.$watch('counts.onHold.value', function (newValue, oldValue) {
            if (newValue === oldValue) return;

            if ($scope.counts.total.change) $scope.counts.onHold.change = false;

            $scope.counts.onHold.change = true;
            $timeout(function () {
                $scope.counts.onHold.change = false;
            }, 500);
        });

        $scope.$watch('counts.pendingGeneration.value', function (newValue, oldValue) {
            if (newValue === oldValue) return;

            if ($scope.counts.pendingGeneration.change) $scope.counts.pendingGeneration.change = false;

            $scope.counts.pendingGeneration.change = true;
            $timeout(function () {
                $scope.counts.pendingGeneration.change = false;
            }, 500);
        });

        $scope.$watch('counts.notGenerated.value', function (newValue, oldValue) {
            if (newValue === oldValue) return;

            if ($scope.counts.notGenerated.change) $scope.counts.notGenerated.change = false;

            $scope.counts.notGenerated.change = true;
            $timeout(function () {
                $scope.counts.notGenerated.change = false;
            }, 500);
        });

        $scope.$watch('counts.errored.value', function (newValue, oldValue) {
            if (newValue === oldValue) return;

            if ($scope.counts.errored.change) $scope.counts.errored.change = false;

            $scope.counts.errored.change = true;
            $timeout(function () {
                $scope.counts.errored.change = false;
            }, 500);
        });

        $scope.$watch('counts.generated.value', function (newValue, oldValue) {
            if (newValue === oldValue) return;

            if ($scope.counts.generated.change) $scope.counts.generated.change = false;

            $scope.counts.generated.change = true;
            $timeout(function () {
                $scope.counts.generated.change = false;
            }, 500);
        });

        $scope.$watch('counts.feeFilesCreated.value', function (newValue, oldValue) {
            if (newValue === oldValue) return;

            if ($scope.counts.feeFilesCreated.change) $scope.counts.feeFilesCreated.change = false;

            $scope.counts.feeFilesCreated.change = true;
            $timeout(function () {
                $scope.counts.feeFilesCreated.change = false;
            }, 500);
        });

        $scope.viewLog = function () {
            $location.url('/billing/billinglog?billId=' + $scope.current.billId);
        };

        $scope.validateBill = function (validate) {
            if ($scope.selectedIds.length === 1) {
                var billId = $scope.selectedIds[0];
                var action = validate ? 'Validate' : 'Invalidate';
                $dialog
                    .confirmAction('You are about to ' + action + ' this bill (' + billId + '). Are you sure you want to proceed?')
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            $http
                                .post('/Billing/Instances/Client/' + billId + '/Action/Invalidate?validate=' + validate, null, {
                                    trackerMsg: action + ' bill: ' + billId + '.',
                                })
                                .then(function () {
                                    scope.refreshGrid();
                                });
                        }
                    });
            }
        };

        //INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.current = {
            view: parseInt($routeParams.instanceId) > 0 ? views[0] : null,
            instanceId: 0,
            url: '',
            urlParameters: '',
            status: null,
            isBillActive: false,
            isAuditFilesActive: false,
            isFeeFilesActive: false,
            isCompleteActive: false,
            canGenerateSelected: false,
            feeFileErrorCount: 0,
            isExecuting: false,
            billId: 0,
            canResetFeeFile: false,
        };

        $scope.counts = {
            total: { value: 0, change: false },
            pendingGeneration: { value: 0, change: false },
            notGenerated: { value: 0, change: false },
            errored: { value: 0, change: false },
            onHold: { value: 0, change: false },
            generated: { value: 0, change: false },
        };
        $scope.current.status = $routeParams.status;

        $scope.rightsBillGenerator = $oasRights.forCode('BILLGENERATOR');
        $scope.rightsBillGenerator.canInvalidate = $scope.user.authorization.entity == 'Administrator';

        init();

        // EVENT LISTENERS
        $scope.$on('event:billinstance-runlist-select', function (e, args) {
            if (args.length === 0) return;
            $scope.current.householdId = args[0].clientId;
            $scope.current.billId = args[0].billId;

            $scope.current.relatedHouseholds = args[0].relatedHouseholds;

            if ($scope.current.relatedHouseholds.length > 0) {
                $scope.current.isRelatedHousehold = true;
                $scope.current.relatedHouseholds = $scope.current.relatedHouseholds.split(',');
            } else {
                $scope.current.isRelatedHousehold = false;
            }

            if (args.length > 1) {
                $scope.current.isRelatedHousehold = false;
            }

            billIds = args.map('billId');

            if (args[0].status === 'Not Generated' && $scope.current.status === 'Data Files Needed') {
                $scope.current.canGenerateSelected = true;
            }

            validateResultsForFeeFiles(args);
        });

        $scope.$on('slickgrid-data-loaded', function (event, data) {
            runList = angular.copy(data);
            updateCounts();

            validateResultsForFeeFiles(data);
        });

        function validateResultsForFeeFiles(data) {
            let hasInitialAmount = data.some((item) => item.initialAmt);
            let hasBalanceDue = data.some((item) => item.balaneDue);
            let hasAdjustmentAmount = data.some((item) => item.adjAmt);

            if (!hasInitialAmount && !hasBalanceDue && !hasAdjustmentAmount) {
                $scope.current.hasValuesForFeeFiles = false;
            } else {
                $scope.current.hasValuesForFeeFiles = true;
            }
        }
    }
);

'use strict';

app.controller(
    'BillInstanceCtrl',
    function BillInstanceCtrl(
        $scope,
        $http,
        views,
        $portfolio,
        entities,
        apps,
        $oasRights,
        $billing,
        $location,
        $timeout,
        $dialog,
        $document,
        $route,
        breadcrumbsService
    ) {
        // PRIVATE VARIABLES
        var selFeeScheduleId = 0,
            runFor = null,
            billInstance = null,
            status = null,
            isMockBill = null,
            billInstanceIds = [];

        function init() {
            $http.get('/Settings/Database/EntityOptions/Code/RepPayoutPercent', {trackerMsg:'Determining Recalc Rep Split Settings'})
            .then(function (response) {                
                if (!response || !response.data){
                    $scope.current.showRecalcRepSplit = false;
                }
                else {
                    $scope.current.showRecalcRepSplit = response.data.value === "True";
                }
            });

            $http
                .get('/Settings/Database/EntityOptions/Code/CancelAdjustmentDefault', { trackerMsg: 'Determining Final Bill Settings' })
                .then(function (response) {
                    $scope.current.newFinalBillsScreen = response.data.value === 'True';
                    if (response.data.value === 'True') {
                        $http
                            .get('/Billing/FinalBills/GetFinalBillInstances', { trackerMsg: 'Getting Incomplete Final Bill Instances' })
                            .then(function (response) {
                                if (response.data.length > 0) {
                                    $timeout(function () {
                                        breadcrumbsService.clear();

                                        for (let i = response.data.length - 1; i >= 0; i--) {
                                            const instance = response.data[i];
                                            breadcrumbsService.add(
                                                `${instance.instanceName} Id: (${instance.id})`,
                                                `#/billing/generator/createfinalbillswithdefaultadjustments/${instance.id}`,
                                                '#/billing/generator/instances'
                                            );
                                        }
                                    }, 2000);
                                }
                            });
                    }
                    CreateToastTimer();
                });

            $http
                .get('/Settings/Database/EntityOptions?codeNames=UseRecalcPayablesPayees', { tracker: 'main', trackerMsg: 'Loading Recalculation Settings' })
                .then(function (response) {
                    if (!response || !response.data) {
                        $scope.current.useRecalcPayablesPayees = false;
                    } else {
                        $scope.current.useRecalcPayablesPayees = response.data[0].value === 'True';
                    }
                });
        }

        function CreateToastTimer() {
            var interval = setInterval(function () {
                if ($scope.payable && $scope.payable.getHangfireProgress) {
                    $http.get('/Billing/RecalcProcess/GetHangFireProgressById').then(function (response) {
                        var controllerName = $route.current.$$route.controller;
                        var toast = $document[0].querySelector('oat-toast');

                        if (controllerName != 'BillInstanceCtrl') {
                            clearInterval(interval); //prevent multiple interval to be called when switching tabs
                            //will create multiple toast
                            toast.close();
                        }

                        if (!response || (!response.data && !$scope.current.currentPercentage) || !controllerName) {
                            if ($scope.payable) {
                                $scope.payable.getHangfireProgress = false;
                            }
                            return;
                        }

                        if (!$scope.current.toastObj && controllerName === 'BillInstanceCtrl') {
                            $scope.current.toastObj = toast.addToast({ icon: 'fa-info-circle', percent: 0, message: 'Recalculating Payables' });
                        }

                        if (!response.data && $scope.current.currentPercentage > 0) {
                            $scope.current.currentPercentage = 100;
                        } else {
                            $scope.current.currentPercentage = response.data.progress;
                        }

                        if ($scope.current.toastObj && $scope.current.currentPercentage) {
                            toast.update($scope.current.toastObj, 'percent', $scope.current.currentPercentage);
                            if ($scope.current.currentPercentage == 100 && !response.data) {
                                //reset data
                                $scope.current.toastObj = '';
                                $scope.current.currentPercentage = 0;
                                $scope.current.hangfireID = '';
                                if ($scope.payable) {
                                    $scope.payable.getHangfireProgress = false;
                                }
                            }
                        }
                    });
                }
            }, 3000);
        }

        $scope.refreshGrid = function () {
            $scope.$broadcast('event:billinggenerator-processed-action', { action: 'refresh-grid' });
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:billinggenerator-processed-action', { action: 'export-data' });
        };

        $scope.editEntity = function (entity) {
            if (entity === entities.client.name) {
                $portfolio.openEditor(entities.client.value, [$scope.current.householdId], null, null, apps.billingAudit.name, null).then(function (rst) {});
            } else if (entity === entities.registration.name) {
                $portfolio
                    .openEditor(entities.registration.value, $scope.current.householdId, null, null, apps.billingAudit.name, null)
                    .then(function (rst) {});
            }
        };

        $scope.openWizard = function (wizardType) {
            if (wizardType === 'Live') {
                $location.url('/billing/generator/generatebill?wizardType=1'); // Renewal
            }

            if (wizardType === 'Forecast') {
                $location.url('/billing/generator/generatebill?wizardType=2'); // Forecast
            }

            if (wizardType === 'CashFunding') {
                $dialog
                    .dialog({
                        dialogClass: 'modal',
                        templateUrl: 'cash-funding-export.html',
                        controller: 'CashFundingExportCtrl',
                        billInstanceIds: billInstanceIds,
                    })
                    .open();
            }
        };

        $scope.newFinalBillInstance = function () {
            $dialog
                .inputBox('New Final Bill Instance', 'Enter Final Bill Instance Name')
                .open()
                .then(function (rslt) {
                    if (!rslt) {
                        return;
                    }

                    var previousBusinessDay = Date.create('today').addDays(-1); // default to yesterday. Make API call to make sure of the last business day
                    $http.get('/Utility/PreviousBusinessDay').then(function (response) {
                        previousBusinessDay = Date.create(response.data).formatted();

                        var toPost = {
                            id: null,
                            billThroughDate: previousBusinessDay,
                            instanceName: rslt,
                        };

                        $http
                            .post('/Billing/FinalBills/CreateFinalBillInstance', toPost, {
                                trackerMsg: 'Creating Final Bills instance',
                            })
                            .then(function (response) {
                                $location.url('/billing/generator/createfinalbillswithdefaultadjustments/' + response.data.id.toString());
                            });
                    });
                });
        };

        $scope.openEditor = function (edtType) {
            $portfolio
                .openEditor(entities.feeSchedule.value, [selFeeScheduleId], null, null, apps.billingAudit.name, { isFeeSchedule: true })
                .then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:billinggenerator-processed-action', { action: 'refresh-grid' });
                    }
                });
        };

        $scope.goToLower = function (urlLevel) {
            $portfolio.goTo(urlLevel, entities.client.value, $scope.current.householdId);
        };

        $scope.runAdvisoryFeeReport = function () {
            $billing.runAdvisoryFeeReport(entities.client.value, $scope.current.householdId);
        };

        $scope.slickGridDoubleClick = function () {
            if ($scope.selectedIds.length === 1) {
                $timeout(function () {
                    $location.url(
                        '/billing/generator/ready?instanceId=' + $scope.selectedIds[0] + '&runFor=' + runFor + '&status=' + status + '&isMockBill=' + isMockBill
                    );
                });
            }
        };

        $scope.viewInstance = function () {
            $location.url(
                '/billing/generator/ready?instanceId=' + $scope.selectedIds[0] + '&runFor=' + runFor + '&status=' + status + '&isMockBill=' + isMockBill
            );
        };

        $scope.deleteInstance = function () {
            if ($scope.selectedIds.length === 1) {
                $dialog
                    .confirmAction('You are about to delete this bill instance(' + $scope.selectedIds[0] + ').  Are you sure you want to proceed?')
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            $http
                                .put('/Billing/Instances/Action/Delete/', $scope.selectedIds, {
                                    trackerMsg: 'Deleting bill instance: ' + $scope.selectedIds[0] + '.',
                                })
                                .then(function () {
                                    $scope.refreshGrid();
                                });
                        }
                    });
            }
        };

        $scope.validateInstance = function (validate) {
            if ($scope.selectedIds.length === 1) {
                var instanceId = $scope.selectedIds[0];
                var action = validate ? 'Validate' : 'Invalidate';
                $dialog
                    .confirmAction('You are about to ' + action + ' this bill instance (' + instanceId + '). Are you sure you want to proceed?')
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            $http
                                .post('/Billing/Instances/' + instanceId + '/Action/Invalidate?validate=' + validate, null, {
                                    trackerMsg: action + ' bill instance: ' + instanceId + '.',
                                })
                                .then(function () {
                                    scope.refreshGrid();
                                });
                        }
                    });
            }
        };

        $scope.promptForLockdown = function () {
            if ($scope.rightsBillingLockdownOverride.canUpdate) {
                $http.get('/Authorization/User/Databases/LockDown', { trackerMsg: 'Getting status of billing lockdown' }).then(function (res) {
                    var msg = $scope.user.alerts.find({ msg: 'You are in billing lockdown!!!' });

                    // Database is currently in lockdown
                    if (res.data === 'Billing') {
                        $dialog
                            .confirmAction('This database is currently in lockdown.  Do you want to remove the lockdown?')
                            .open()
                            .then(function (result) {
                                if (result === 'yes') {
                                    $http
                                        .put('/Authorization/User/Databases/Action/LockDown', null, { trackerMsg: 'Removing billing lockdown option' })
                                        .then(function (res) {
                                            $scope.user.authorization.alClientLockType = 0;
                                            if (msg) {
                                                $scope.user.alerts.remove(msg);
                                            }
                                        });
                                }
                            });
                    } else {
                        $dialog
                            .confirmAction('Do you want to put this database in billing lockdown?')
                            .open()
                            .then(function (result) {
                                if (result === 'yes') {
                                    $http
                                        .put('/Authorization/User/Databases/Action/LockDown', null, { trackerMsg: 'Setting billing lockdown option' })
                                        .then(function (res) {
                                            $scope.user.authorization.alClientLockType = 1;
                                            if (!msg) {
                                                $scope.user.alerts.push({ type: 'warning', msg: 'You are in billing lockdown!!!' });
                                            }
                                        });
                                }
                            });
                    }
                });
            }
        };

        $scope.recalcBills = function(split) {
            $dialog.dialog({ dialogClass: "modal wide", templateUrl: "recalc-bills.html", controller: "RecalcBillsCtrl", recalcSplit: split }).open();
        };

        $scope.generateFeeFileByCustodian = function () {
            $scope.current.isExecuting = true;

            $http.get('/Portfolio/Custodians/Simple?billInstanceId=' + billInstance.id, { trackerMsg: 'Loading custodian list' }).then(function (response) {
                $dialog
                    .inputBox('Custodian', 'Select Custodian', response.data)
                    .open()
                    .then(function (result) {
                        if (result) {
                            $http
                                .post('/Billing/Instances/Action/FeeFiles?custodianId=' + result.id, $scope.selectedIds, { trackerMsg: 'Generating fee files' })
                                .then(function (response) {});
                        }
                    });
            });
        };

        //Payables
        function initPayable(gethangfire) {
            if (gethangfire != null && !gethangfire) {
                $scope.payable = {
                    billIds: [],
                    billInstance: '',
                    inputValue: '',
                    inputStatus: '',
                    message: '',
                    isPayables: false,
                    isPayees: false,
                    isSubmit: false,
                    getHangfireProgress: false,
                };
            } else {
                $scope.payable = {
                    billIds: [],
                    billInstance: '',
                    inputValue: '',
                    inputStatus: '',
                    message: '',
                    isPayables: false,
                    isPayees: false,
                    isSubmit: false,
                    getHangfireProgress: true,
                };
            }
        }

        $scope.recalcPay = () => {
            initPayable();
            document.querySelector('#payable-modal').open();
        };

        $scope.closePayableModal = (gethangfireprogress) => {
            document.querySelector('#payable-modal').close();
            initPayable(gethangfireprogress);
        };

        $scope.openFileUploadModal = () => document.querySelector('#fileUploadModal').open();

        $scope.closeFileUploadModal = () => document.querySelector('#fileUploadModal').close();

        $scope.closeWarningModal = () => document.querySelector('#warning-modal').close();

        $scope.runPayablesModal = () => {
            if (!$scope.payable.isSubmit) {
                return;
            }

            let payableCalculated = $scope.payable.isPayables != null && !$scope.payable.isPayables;
            let payeeCalculated = $scope.payable.isPayees != null && !$scope.payable.isPayees;

            if ($scope.payable.isPayables != null && $scope.payable.isPayables) {
                $http
                    .post(
                        '/Billing/BillGenerator/Action/RecalcPayables',
                        { BillInstanceId: $scope.payable.billInstance, billIds: $scope.payable.billIds, isPayable: $scope.payable.isPayables },
                        { trackerMsg: 'Recalculating Payables' }
                    )
                    .then(function (res) {
                        payableCalculated = true;
                        if (payeeCalculated) {
                            $scope.closePayableModal();
                        }
                    });
            }

            if ($scope.payable.isPayees != null && $scope.payable.isPayees) {
                $http
                    .post(
                        '/Billing/BillGenerator/Action/RecalcPayees',
                        {
                            BillInstanceId: $scope.payable.billInstance,
                            billIds: $scope.payable.billIds,
                            isPayable: $scope.payable.isPayables,
                            isPayee: $scope.payable.isPayees,
                        },
                        { trackerMsg: 'Recalculating Payees' }
                    )
                    .then(function (res) {
                        payeeCalculated = true;
                        if (payableCalculated) {
                            $scope.closePayableModal();
                        }
                    });
            }

            $scope.closePayableModal();
        };

        $scope.setVisibility = function () {
            $scope.payable.isSubmit =
                (!($scope.payable.billInstance.length === 0) || ($scope.payable.billIds != null && $scope.payable.billIds.length > 0)) &&
                ($scope.payable.isPayables || $scope.payable.isPayees);
        };

        //INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.current = {
            newFinalBillsScreen: false,
            useRecalcPayablesPayees: false,
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            URL: '/Billing/Instances',
            allowDeleteInstance: false,
            allowLockdownMaintaince: false,
            isAdvisor: false,
            filterStartDate: Date.create('today').addDays(-30),
            filterEndDate: '',
            resetToast: false,
            toastObj: null,
            currentPercentage: 0,
            hangfireId: '',
        };

        $scope.rightsFeeSchedules = $oasRights.forCode('FEESCHEDULES');
        $scope.rightsBillGenerator = $oasRights.forCode('BILLGENERATOR');
        $scope.rightsBillGenerator.canInvalidate = $scope.user.authorization.entity == 'Administrator';
        $scope.rightsBillingLockdownOverride = $oasRights.forCode('BILLINGLOCKDOWNOVERRIDE');
        $scope.current.showRecalcRepSplit = false;
        init();

        if ($scope.user.authorization.entity == 'Administrator' || $scope.user.authorization.entity == 'Advisor') {
            if ($scope.user.authorization.entity == 'Advisor') {
                $scope.current.isAdvisor = true;
            }

            if ($scope.user.authorization.entity == 'Advisor' && !$scope.rightsBillingLockdownOverride.canUpdate) {
                $scope.current.allowLockdownMaintaince = false;
            } else {
                $scope.current.allowLockdownMaintaince = true;
            }

            $scope.current.allowDeleteInstance = true;
            $scope.current.view.slickGridColumnDefs.find({ name: 'Name' }).editor = Slick.Editors.Text;
        }

        //Validate billIds, added by user
        $scope.$watch('payable.inputValue', function (newValue, oldValue) {
            if (newValue === oldValue || !newValue) {
                return;
            }

            if ($scope.payable.inputValue != null) {
                $scope.payable.billIds = Object.values($scope.payable.inputValue[0].result)[0].map(function (x) {
                    return parseInt(Object.values(x)[0]);
                });

                $http.post('/Billing/BillGenerator/Simple/Bill/Ids', $scope.payable.billIds, { trackerMsg: 'Loading billIds' }).then(function (response) {
                    if (response.data.length > 0) {
                        $scope.payable.message = 'Following Bill Ids are not Valid' + '<br>' + response.data.join();
                        $scope.payable.billIds = $scope.payable.billIds.filter((item) => !response.data.any(item));

                        document.querySelector('#warning-modal').open();
                    }
                    $scope.setVisibility();
                });
            }

            $scope.closeFileUploadModal();
        });

        // EVENT LISTENERS
        $scope.$on('event:billinggenerator-processed-select', function (e, args) {
            if (args.length === 0) return;

            $scope.current.householdId = args[0].clientId;
            runFor = args[0].runForGroup;
            billInstance = args[0];
            billInstanceIds = args.map('id');
            status = args[0].statusValue;
            isMockBill = args[0].isMockBill;

            $scope.current.allowDeleteInstance = !($scope.current.isAdvisor && ((status === 'Complete' && !isMockBill) || status === 'Complete with errors'));
        });
    }
);

app.controller('RecalcBillsCtrl', function RecalcBillsCtrl($scope, dialog, $http, $location, $dialog, activeState, $portfolio, splitIoService, $signalRManager, $document) {

    const opex_Billing_Recalc_UserPrompt_14285 = "opex_Billing_Recalc_UserPrompt_14285";
    const opex_Bill_Generator_Rewrite_18963 = "opex_Bill_Generator_Rewrite_18963";
    var pendingRepFeeSplitJobId = null;
    var pendingRepFeeSplitInstanceIds = [];
    var completedRepFeeSplitInstanceIds = [];
    var lastRepFeeSplitCompletion = null;
    var subscribedToRepFeeSplitRecalc = false;
    var inProgressToast = null;

    function init() {

        splitIoService.getBoolTreatment(opex_Billing_Recalc_UserPrompt_14285).subscribe((isEnabled) => {
            $scope.current.recalcPromptEnabled = isEnabled
        });
        splitIoService.getBoolTreatment(opex_Bill_Generator_Rewrite_18963).subscribe((isEnabled) => {
            $scope.current.rewriteEnabled = isEnabled;
        });

        $http.get('/Settings/Database/EntityOptions/Code/DftBiRunForAccts', { trackerMsg: 'Getting bill instance run for accounts' }).then(function (response) {
            var activeStates = {
                'Active Accounts': 1,
                'Inactive Accounts': 2,
                'All Accounts': 3,
            };

            $scope.current.params.runForAccounts = activeStates[response.data.value];

            var list = {
                activeStates: activeState,
            };

            Object.each(list, function (key, value) {
                $scope[key] = $portfolio.enumToSimpleList(value);
            });
        });

        if ($scope.current.split) {
            $scope.current.recalcHeader="Recalculate Rep Fee Splits"; }
        else {
            $scope.current.recalcHeader="Recalculate Bill" }
    }

    function getOatToast() {
        return $document[0].querySelector('oat-toast');
    }

    function showInProgressToast() {
        var toast = getOatToast();
        if (!toast || inProgressToast) {
            return;
        }
        inProgressToast = toast.addToast({
            icon: 'fa-info-circle',
            message: 'Recalculating Rep Fee Splits',
        });
    }

    function clearInProgressToast() {
        var toast = getOatToast();
        if (toast && inProgressToast && toast.close) {
            toast.close(inProgressToast);
        }
        inProgressToast = null;
    }

    function showCompletionToast(success, message) {
        var toast = getOatToast();
        if (!toast) {
            return;
        }
        toast.addToast({
            icon: success ? 'fa-check-circle' : 'fa-exclamation-circle',
            message: message || (success
                ? 'Recalculate Rep Fee Splits completed.'
                : 'Recalculate Rep Fee Splits failed. Please try again or contact support.'),
        });
    }

    function unsubscribeFromRepFeeSplitRecalc() {
        if (!subscribedToRepFeeSplitRecalc) {
            return;
        }
        $signalRManager.unSubscribeToHub('billInstanceClientHub', 'repFeeSplitRecalcCompleted');
        $signalRManager.deleteQueryStringParam('billInstanceId');
        $signalRManager.deleteQueryStringParam('repFeeSplitRecalcBillInstanceIds');
        subscribedToRepFeeSplitRecalc = false;
    }

    function onRepFeeSplitRecalcCompleted(completion) {
        if (!completion) {
            return;
        }
        if (pendingRepFeeSplitJobId && completion.JobId && completion.JobId !== pendingRepFeeSplitJobId) {
            return;
        }

        if (completion.BillInstanceId) {
            completedRepFeeSplitInstanceIds.push(completion.BillInstanceId);
        }

        if (!lastRepFeeSplitCompletion || !completion.Success || lastRepFeeSplitCompletion.Success) {
            lastRepFeeSplitCompletion = {
                Success: !!completion.Success,
                Message: completion.Message || (completion.Success
                    ? 'Recalculate Rep Fee Splits completed.'
                    : 'Recalculate Rep Fee Splits failed. Please try again or contact support.'),
            };
        }

        var allDone = pendingRepFeeSplitInstanceIds.length === 0 ||
            pendingRepFeeSplitInstanceIds.every(function (id) {
                return completedRepFeeSplitInstanceIds.indexOf(id) !== -1;
            });
        if (!allDone) {
            return;
        }

        clearInProgressToast();
        showCompletionToast(lastRepFeeSplitCompletion.Success, lastRepFeeSplitCompletion.Message);
        unsubscribeFromRepFeeSplitRecalc();
        pendingRepFeeSplitJobId = null;
        pendingRepFeeSplitInstanceIds = [];
        completedRepFeeSplitInstanceIds = [];
        lastRepFeeSplitCompletion = null;
    }

    function subscribeToRepFeeSplitRecalc(billInstanceIds) {
        var primaryId = billInstanceIds[0];
        $signalRManager.setQueryStringParam('billInstanceId', primaryId);
        $signalRManager.setQueryStringParam('repFeeSplitRecalcBillInstanceIds', billInstanceIds.join(','));
        if (subscribedToRepFeeSplitRecalc) {
            $signalRManager.unSubscribeToHub('billInstanceClientHub', 'repFeeSplitRecalcCompleted');
        }
        $signalRManager.subscribeToHubV2('billInstanceClientHub', 'repFeeSplitRecalcCompleted', null, onRepFeeSplitRecalcCompleted);
        subscribedToRepFeeSplitRecalc = true;
    }

    function handleRepFeeSplitAccepted(accept) {
        var instanceIds = (accept && accept.billInstanceIds ? accept.billInstanceIds : []).filter(function (id) {
            return id > 0;
        });
        if (instanceIds.length === 0) {
            return;
        }

        pendingRepFeeSplitJobId = accept.jobId || null;
        pendingRepFeeSplitInstanceIds = instanceIds;
        completedRepFeeSplitInstanceIds = [];
        lastRepFeeSplitCompletion = null;
        showInProgressToast();
        subscribeToRepFeeSplitRecalc(instanceIds);
    }

    function loadBillIds() {
        $http.get('/Billing/Bills/Simple?clientId=' + $scope.current.selectedEntity.id, { trackerMsg: 'Getting bill ids for household' }).then(function (response) {
            $scope.current.bills = response.data;
        });
    }

    function validateBills(bills){
        const validBills = bills.none(x => x == null || x.isRecalc);
        if (!validBills) {
            showRecalcingARecalcError();
        }
        return validBills

    }
    function showRecalcingARecalcError(){
        $dialog
            .messageBox("Invalid Bill",
                "The action you are trying to complete cannot proceed because there is already an existing recalculation. Please contact SME Billing through the 'Contact Us' Support features or refer to the existing support articles for further assistance.")
            .open();
    }

    $scope.close = function () {
        dialog.close(null);
    };

    $scope.recalcBills = function () {
        var instanceId = null,
            runFor = '',
            isMockBill = false,
            billIds = [];
        if ($scope.current.params.whoFor === 5) {
            billIds = [$scope.current.billId];
        } else {
            billIds = $scope.current.billIds;
        }

        if ($scope.current.split) {
            var httpConfig = $scope.current.rewriteEnabled
                ? {}
                : { trackerMsg: 'Recalculating Rep Split bill for household' };
            $http.post('/Billing/BillGenerator/Action/RecalcRepSplit', { billIds: billIds }, httpConfig)
            .then(function(res){
                if ($scope.current.rewriteEnabled && res && res.status === 202 && res.data) {
                    handleRepFeeSplitAccepted(res.data);
                    dialog.close(null);
                    return;
                }
                dialog.close(res.data);
            });
        }
        else {
            $http
            .post(
                '/Billing/BillGenerator/Action/Recalc',
                { billIds: billIds, runForAccounts: $scope.current.params.runForAccounts },
                { trackerMsg: 'Recalculating bill for household' }
            )
            .then(function (res) {
                instanceId = res.data;
                $http.get('/Billing/Instances/' + instanceId, { trackerMsg: 'Getting bill instance ' + instanceId }).then(function (response) {
                    runFor = response.data.runForGroup;
                    isMockBill = response.data.isMockBill;
                    dialog.close(response.data);
                    $location.url('/billing/generator/ready?instanceId=' + res.data + '&runFor=' + runFor + '&status=' + status + '&isMockBill=' + isMockBill);
                });
            });
        }
    };

    $scope.importFile = function (isRerun) {
        var title = 'Upload Ids';

        if ($scope.current.recalcPromptEnabled) {
            $dialog
                .inputBox('title', 'File', 'file', { postUrl: '/ValidateImport/Billing/Bills' })
                .open()
                .then(function (data) {
                    if (data) {
                        $scope.current.billIds = data.map(x => x.id);

                        if ($scope.current.recalcPromptEnabled) {
                            $scope.current.recalcBtnDisabled = !validateBills(data);
                        }
                    }
                });
        } else {
            $dialog
                .inputBox('title', 'File', 'file', { postUrl: '/ValidateImport/Echo' })
                .open()
                .then(function (data) {
                    if (data) {
                        $scope.current.billIds = Object.values(data[0].result)[0].map(function (x) {
                            return parseInt(Object.values(x)[0]);
                        });
                    }
                });

        };
    };

    $scope.current = {
        selectedBill: null,
        billIds: [],
        bills: [],
        params: {
            whoFor: 5,
            runForAccounts: 1,
        },
        activeStates: activeState,
        split: dialog.options.recalcSplit,
        recalcPromptEnabled: false,
        recalcBtnDisabled: true,
        rewriteEnabled: false
    };

    $scope.$on('$destroy', function () {
        clearInProgressToast();
        unsubscribeFromRepFeeSplitRecalc();
    });

    init();

    $scope.billsFieldMap = [
        { name: 'ID', value: 'id' },
        { name: 'Name', value: 'name' },
    ];

    // WATCHES
    $scope.$watch('current.selectedEntity', function (newValue, oldValue) {
        if (newValue === oldValue) return;

        loadBillIds();
    });


    // WATCHES
    $scope.$watch('current.billId', function (newValue, oldValue) {
        if (newValue === oldValue) return;
        if ($scope.current.recalcPromptEnabled) {
            var bill = $scope.current.bills.find({ id: newValue });
            $scope.current.recalcBtnDisabled = !validateBills([bill]);
        }
       
    });

    $scope.$watch('current.params.whoFor', function (newVal, oldVal) {
        if (newVal === oldVal || !newVal) return;

        $scope.current.billIds = [];
        if ($scope.current.recalcPromptEnabled) {
            $scope.current.recalcBtnDisabled = true;
        }
    });
});

app.controller('CashFundingExportCtrl', function CashFundingExportCtrl($scope, $http, $oasRights, $window, dialog, API_CONFIG, $dialog) {
    //For clarity, "dialog" is THIS dialog box, specifically, and handles actions pertaining to it.
    //"$dialog" is the dialog class, allowing us to generate new dialogs (such as our message box below)

    //PRIVATE METHODS
    var startDate = null;
    var endDate = null;
    var idList = null;
    var isForecast = false;

    $scope.sendToEclipse = function () {
        $scope.current.sendToEclipseProcessing = true;

        //exportType '1' is instance specific
        if ($scope.current.exportType === 1) {
            idList = $scope.current.billInstanceIds;

            //Holds the URL parameter list of bill instance id's, if they exist.
            //If they don't exist, this will remain and be passed as an empty string, which the backend controller handles
            var idListString = '';

            //If there are id's in the list, add the first one
            if (idList.length >= 1) {
                idListString = idList[0].toString();
            }

            //If there are other id's in the list, add them to build the URL param array
            for (var i = 1; i < idList.length; i++) {
                idListString += '&billInstanceIds=' + idList[i];
            }
            //exportType '2' is a date range
        } else {
            startDate = $scope.current.startDate == null ? null : $scope.current.startDate.formatted();
            endDate = $scope.current.endDate == null ? null : $scope.current.endDate.formatted();
        }

        //billType 2 signifies forecast/mock bills
        if ($scope.current.billType === 2) {
            isForecast = true;
        }

        //Get payload to send to eclipse
        $http
            .get(
                '/Billing/Instances/CheckExportBillInstanceIds?billInstanceIds=' +
                    (idList == null ? null : idListString) +
                    '&startDate=' +
                    startDate +
                    '&endDate=' +
                    endDate,
                { trackerMsg: 'Checking for BillInstances' }
            )
            .then(function (response) {
                var hasBillInstances = response.data;

                if (hasBillInstances == true) {
                    //If there are bill instances either in the list or date range, send to eclipse
                    $http
                        .post(
                            '/Billing/Instances/GenerateCashFunding?billInstanceIds=' +
                                (idList == null ? null : idListString) +
                                '&startDate=' +
                                startDate +
                                '&endDate=' +
                                endDate +
                                '&isForecast=' +
                                isForecast,
                            { trackerMsg: 'Sending cash funding for Eclipse' }
                        )
                        .then(function (result) {
                            dialog.close();
                            $scope.current.sendToEclipseProcessing = false;
                        });
                } else {
                    //If there are no bill instances in the list or date range, alert the user
                    $dialog.messageBox('No Bill Instances', 'No bill instance ids found: unable to send cash funding to eclipse').open();
                    $scope.current.sendToEclipseProcessing = false;
                }
            });
    };

    $scope.exportCashFunding = function () {
        //exportType '1' is instance specific
        if ($scope.current.exportType === 1) {
            idList = $scope.current.billInstanceIds;

            //Holds the URL parameter list of bill instance id's, if they exist.
            //If they don't exist, this will remain and be passed as an empty string, which the backend controller handles
            var idListString = '';

            //If there are id's in the list, add the first one
            if (idList.length >= 1) {
                idListString = idList[0].toString();
            }

            //If there are other id's in the list, add them to build the URL param array
            for (var i = 1; i < idList.length; i++) {
                idListString += '&billInstanceIds=' + idList[i];
            }
            //exportType '2' is a date range
        } else {
            startDate = $scope.current.startDate == null ? null : $scope.current.startDate.formatted();
            endDate = $scope.current.endDate == null ? null : $scope.current.endDate.formatted();
        }

        //billType 2 signifies forecast/mock bills
        if ($scope.current.billType === 2) {
            isForecast = true;
        }

        //Check for bill instances using the same parameters we will use for the file download
        $http
            .get(
                '/Billing/Instances/CheckExportBillInstanceIds?billInstanceIds=' +
                    (idList == null ? null : idListString) +
                    '&startDate=' +
                    startDate +
                    '&endDate=' +
                    endDate,
                { trackerMsg: 'Checking for BillInstances' }
            )
            .then(function (response) {
                var hasBillInstances = response.data;

                if (hasBillInstances == true) {
                    //If there are bill instances either in the list or date range, proceed to download files
                    var exportUrl =
                        '/Billing/Instances/EclipseExport?billInstanceIds=' +
                        (idList == null ? null : idListString) +
                        '&startDate=' +
                        startDate +
                        '&endDate=' +
                        endDate +
                        '&isForecast=' +
                        isForecast;
                    dialog.close($scope.downloadFile(exportUrl));
                } else {
                    //If there are no bill instances in the list or date range, alert the user
                    $dialog.messageBox('No Bill Instances', 'No bill instance ids found: unable to generate data for export').open();
                }
            });
    };

    //CLOSE MODAL ON "CANCEL"
    $scope.close = function () {
        dialog.close();
    };

    //PRIVATE
    //INITIALIZE
    $scope.current = {
        exportType: dialog.options.billInstanceIds.length > 0 ? 1 : 2,
        billInstanceIds: dialog.options.billInstanceIds,
        startDate: Date.create('today').getStartOfQuarter(),
        endDate: Date.create('today'),
        billType: 1,
        sendToEclipseProcessing: false,
    };

    //Downloads the zip file with cash funding export files
    $scope.downloadFile = function (url) {
        $window.location.href = API_CONFIG.baseUrl + url + '&Authorization=' + sessionStorage.oas_token;
        return true;
    };
});

'use strict';

app.controller(
    'FinalBillsWithDefaultAdjustmentsCtrl',
    function FinalBillsWithDefaultAdjustmentsCtrl($scope, $http, views, $oasRights, $dialog, $location, $timeout, $routeParams, breadcrumbsService) {
        //PRIVATE METHODS

        function init() {
            $scope.views = views;

            // Populate left menu links
            $http.get('/Billing/FinalBills/GetFinalBillInstances', { trackerMsg: 'Getting Incomplete Final Bill Instances' }).then(function (response) {
                if (response.data.length > 0) {
                    $timeout(function () {
                        breadcrumbsService.clear();
                        response.data.forEach((instance) =>
                            breadcrumbsService.add(
                                `${instance.instanceName} Id: (${instance.id})`,
                                `#/billing/generator/createfinalbillswithdefaultadjustments/${instance.id}`,
                                '#/billing/generator/instances'
                            )
                        );
                    }, 2000);
                }
            });

            if ($routeParams.status) {
                $scope.current = {};
                $timeout(function () {
                    $scope.current.status = $routeParams.status;
                    $scope.current.URL = '/Billing/FinalBills/GetFinalBillInstanceItemAccounts/' + $scope.current.status;
                    $timeout(function () {
                        $scope.getBillInstance();
                        $scope.$broadcast('event:finalbillinstance-reload-action', { action: 'refresh-grid' });
                    }, 500);
                }, 500);
            }
        }

        //PUBLIC FUNCTIONS

        $scope.$on('event:finalbillinstance-item-select', function (e, args) {
            if (args.length === 0 || args.length > 1 || $scope.current.clickInProgress) return;
            $scope.current.clickInProgress = true;
            $scope.current.selectedId = args[0].finalBillInstanceItemId;
            $scope.selectedIds = $scope.current.data.filter((item) => item.finalBillInstanceItemId === $scope.current.selectedId).map((i) => i.id);
            var items = [];
            $scope.selectedIds.forEach((item) => items.push({ id: item, test: 'test' }));
            $scope.$broadcast('event:finalbillinstance-reload-action', { action: 'select-items', items: items });
            $timeout(function () {
                $scope.current.clickInProgress = false; //This prevents a loop of selecting items.
            }, 5);
        });

        $scope.createNew = function () {
            $scope.current.isNew = true;
            $scope.showSidebar();
        };

        $scope.editExisting = function () {
            if (!$scope.rightSidebar.isOpen) {
                $scope.current.isNew = false;
                $scope.showSidebar();
            } else {
                $scope.current.isNew = false;
                $scope.rightSidebar.isOpen = false;
                $timeout(function () {
                    $scope.rightSidebar.isOpen = true; //for the animation
                }, 400);
            }
        };

        $scope.$watch('currentBillInstance.instanceName', function (newVal, oldVa) {
            if (newVal != oldVa) {
                $scope.currentBillInstance.instanceName = newVal;
                updateFinalBillInstance();
            }
        });

        $scope.$watch('currentBillInstance.billThroughDate', function (newVal, oldVa) {
            if (newVal != oldVa) {
                if (newVal > Date.create('today')) {
                    $scope.currentBillInstance.billThroughDate = Date.create('today');
                    return;
                }
                $scope.currentBillInstance.billThroughDate = newVal;
                updateFinalBillInstance();
            }
        });

        function updateFinalBillInstance() {
            $http
                .put('/Billing/FinalBills/UpdateFinalBillInstance', $scope.currentBillInstance, { trackerMsg: 'Getting Incomplete Final Bill Instances' })
                .then(function (response) {
                    console.log(response);
                });
        }

        $scope.showSidebar = function () {
            $scope.rightSidebar.isOpen = true;
        };

        $scope.updateBillInstance = function () {
            $scope.$broadcast('event:finalbillinstance-reload-action', { action: 'refresh-grid' });
        };

        $scope.getBillInstance = function () {
            $http
                .get('/Billing/FinalBills/GetFinalBillInstance/' + $scope.current.status.toString(), { trackerMsg: 'Getting Final Bill Instance' })
                .then(function (response) {
                    $scope.currentBillInstance = response.data;
                    $scope.current.editable = true;
                });
        };

        $scope.runFinalBill = function () {
            $http.get('/Billing/FinalBills/CreateBillInstance/' + $scope.current.status, { trackerMsg: 'Creating Bill Instance' }).then(function (res) {
                $scope.leftSidebar.isOpen = true;
                location.href =
                    '#/billing/generator/ready?instanceId=' +
                    res.data.id +
                    '&runFor=' +
                    res.data.runForGroup +
                    '&status=' +
                    res.data.statusValue +
                    '&isMockBill=' +
                    res.data.isMockBill;
            });
        };

        $scope.deleteFinalBillInstance = function () {
            $dialog
                .confirmAction('Are you sure you want to delete this final bill instance? This cannot be undone!')
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $http
                            .delete('/Billing/FinalBills/DeleteFinalBillInstance/' + $scope.current.status, { trackerMsg: 'Deleting Final Bill Instance' })
                            .then(function (response) {
                                let currentSublink = $scope.$parent.leftSidebar.links.find({ name: 'Bill Generator' }).links.find({ name: 'Bill Instance' });
                                $scope.$parent.leftSidebar.links
                                    .find({ name: 'Bill Generator' })
                                    .links.find(({ name: 'Bill Instance' }.crumbs = currentSublink.crumbs.filter((item) => item.id !== $scope.current.status)));
                                $timeout(function () {
                                    $location.url('/billing/generator/instances/');
                                }, 400);
                            });
                    }
                });
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:finalbillinstance-reload-action', { action: 'export-data' });
        };

        $scope.$on('slickgrid-data-loaded', function (event, data) {
            $scope.current.data = data;
        });

        $scope.slickGridDoubleClick = function () {
            if ($scope.selectedIds.length === 1) {
                $scope.editExisting();
            }
        };

        $scope.deleteFinalBillInstanceItem = function () {
            doAction(
                '/Billing/FinalBills/DeleteFinalBillInstanceItem/',
                'Deleting Final Bill Instance Item',
                'Deleting this Final Bill Instance Item!  Are you sure you want to proceed?',
                $scope.current.selectedId
            );
        };

        function doAction(actionUrl, msgVerb, confirmMsg, id) {
            $dialog
                .confirmAction(confirmMsg)
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $http.delete(actionUrl + id, { trackerMsg: msgVerb }).then(function () {
                            $scope.$broadcast('event:finalbillinstance-reload-action', { action: 'refresh-grid' });
                        });
                    }
                });
        }

        //INITIALIZE

        init();

        $scope.currentBillInstance = {
            id: null,
            billThroughDate: Date.create('today').addDays(-1),
            instanceName: 'Loading...',
        };
        $scope.editable = false;
        $scope.views = views;
        $scope.rightSidebar.width = 750;
        $scope.rightSidebar.isOpen = false;
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.current = {
            clickInProgress: false,
            data: null,
            isNew: true,
            selectedId: -1,
            editable: false,
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            status: '0',
            URL: '/Billing/FinalBills/GetFinalBillInstanceItemAccounts/0',
        };

        // EVENT LISTENERS
    }
);

'use strict';

app.controller('FeeCollectionInstancesCtrl', function FeeCollectionInstancesCtrl($scope, $http, views, $oasRights, $dialog, $location, $timeout) {
    //PUBLIC FUNCTIONS
    $scope.exportToExcel = function () {
        $scope.$broadcast('event:feecollectioninstances-processed-action', { action: 'export-data' });
    };
    $scope.slickGridDoubleClick = function () {
        if ($scope.selectedIds.length === 1) {
            $timeout(function () {
                $location.url(
                    '/billing/generator/feecollectioninstances/' +
                        $scope.selectedIds[0] +
                        '?startDate=' +
                        $scope.current.startDate +
                        '&endDate=' +
                        $scope.current.endDate +
                        '&description=' +
                        $scope.current.description
                );
            });
        }
    };
    $scope.viewInstance = function (id) {
        $location.url(
            '/billing/generator/feecollectioninstances/' +
                id +
                '?startDate=' +
                $scope.current.startDate +
                '&endDate=' +
                $scope.current.endDate +
                '&description=' +
                $scope.current.description
        );
    };

    $scope.deleteInstance = function () {
        if ($scope.selectedIds.length === 1) {
            $dialog
                .confirmAction('You are about to delete this fee collection instance(' + $scope.selectedIds[0] + ').  Are you sure you want to proceed?')
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $http
                            .delete('/Billing/FeeCollection/' + $scope.selectedIds[0], {
                                trackerMsg: 'Deleting fee collection instance: ' + $scope.selectedIds[0] + '.',
                            })
                            .then(function () {
                                $scope.$broadcast('event:feecollectioninstances-processed-action', { action: 'refresh-grid' });
                            });
                    }
                });
        }
    };

    //INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        URL: '/Billing/FeeCollection/Instances',
        allowDeleteInstance: false,
    };

    // EVENT LISTENERS
    $scope.$on('event:feecollectioninstances-processed-action-select', function (e, args) {
        if (args.length === 0) return;
        $scope.current.startDate = args[0].startDate;
        $scope.current.endDate = args[0].endDate;
        $scope.current.description = args[0].description;
    });
});

'use strict';

app.controller('FeeCollectionDetailsCtrl', function FeeCollectionDetailsCtrl($scope, $http, views, $location, $routeParams, tokenFactory, $oasRights) {
    //PRIVATE VARIABLES
    var runList = [];

    // PRIVATE VARIABLES
    var tokenOverride, clientId;
    var selectedRows = [];
    var redirectUrl = window.location.protocol + '//' + window.location.host + window.location.pathname.replace('index.html', '') + 'integration.html?p=';

    function init() {
        $scope.rightsFeeCollection = $oasRights.forCode('BILLGENERATOR');

        if ($scope.current.id > 0) {
            $scope.addBreadcrumb('Instance ' + $scope.current.id);

            if (!$routeParams.startDate) {
                $http.get('/Billing/FeeCollection/Instances', { trackerMsg: 'Getting data for instance' }).then(function (res) {
                    var selectedInstance = res.data.find({ id: parseInt($routeParams.id) });
                    if (selectedInstance) {
                        $scope.current.startDate = selectedInstance.startDate;
                        $scope.current.endDate = selectedInstance.endDate;
                        $scope.current.description = selectedInstance.description;
                    }
                });
            }
        }
    }
    function updateCounts() {
        $scope.counts.total.value = entityCount(['Totals']);
        $scope.counts.sent.value = entityCount(['Sent']);
        $scope.counts.notSent.value = entityCount(['Not Sent']);
        $scope.counts.errored.value = entityCount(['Errored']);
        $scope.counts.paid.value = entityCount(['Paid']);
        $scope.counts.validation.value = entityCount(['Validation Required']);
    }

    function entityCount(statuses) {
        if (statuses.some('Totals')) {
            return runList.length;
        } else {
            return runList.count(function (entity) {
                return statuses.some(entity.status);
            });
        }
    }

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:fee-collection-details-action', { action: 'export-data' });
    };

    $scope.filterGenerationStatus = function (status) {
        var gridQueryId, filterFn;

        $scope.current.gridQueries = [];

        if (status.length === 0) return;

        gridQueryId = 'RBE';
        status.each(function (s) {
            gridQueryId += '_' + s;
        });

        if ($scope.current.gridQueries) $scope.current.gridQueries.remove({ id: gridQueryId });
        else $scope.current.gridQueries = [];

        filterFn = function (x) {
            return status.some(x);
        };
        $scope.current.gridQueries.push({
            id: gridQueryId,
            name: status.join('/'),
            description: 'Generation Status: ' + status.join(' or '),
            field: 'status',
            filterFn: filterFn,
            itemCount: entityCount(status),
            enabled: true,
        });
    };

    $scope.filterType = function (type) {
        $scope.current.type = type;

        if ($scope.current.gridQueries)
            $scope.current.gridQueries.remove(function (g) {
                return g.id.has('feeCollectionDetailsFilter');
            });
        else $scope.current.gridQueries = [];

        var filterFn = function (x) {
            return x && x == type;
        };

        $scope.current.gridQueries.push({
            id: 'feeCollectionDetailsFilter' + type,
            name: 'Fee Collection Details Filter',
            filterFn: filterFn,
            field: 'billPayType',
            enabled: true,
        });
    };

    $scope.generateFeeFileAll = function () {
        $http.post('/Billing/FeeCollection/' + $scope.current.id + '/Action/FeeFiles', null, { trackerMsg: 'Generating Fee Files' }).then(function () {
            var dateFormat = '{MM}/{dd}/{yyyy}';
            var sDate = new Date().format(dateFormat);
            var eDate = sDate;
            $location.url(
                '/billing/audit/files?source=bg&auditType=FeeFiles&subsource=feecollectdetails&startDate=' +
                    $scope.current.startDate +
                    '&endDate=' +
                    $scope.current.endDate
            );
        });
    };

    $scope.processAllCharges = function (type) {
        $http
            .post('/Billing/FeeCollection/' + $scope.current.id + '/Action/BluePay?processType=null', null, { trackerMsg: 'Posting Credit Card Fees' })
            .then(function () {
                $scope.$broadcast('event:fee-collection-details-action', { action: 'refresh-grid' });
            });
    };

    $scope.refreshBalanceDue = function () {
        $http.post('/Billing/FeeCollection/' + $scope.current.id + '/Action/Refresh', null, { trackerMsg: 'Refreshing Details' }).then(function () {
            $scope.$broadcast('event:fee-collection-details-action', { action: 'refresh-grid' });
        });
    };

    $scope.postPayments = function (all) {
        $http
            .post('/Billing/FeeCollection/' + $scope.current.id + '/Action/Payments', all ? null : $scope.selectedIds, { trackerMsg: 'Posting payments' })
            .then(function () {
                $scope.$broadcast('event:fee-collection-details-action', { action: 'refresh-grid' });
            });
    };

    //watches
    $scope.$on('event:fee-collection-details-select', function (e, args) {
        if (args.length) {
            var alClientId = args[0].alClientId;
            clientId = args[0].clientId;

            tokenFactory.getDatabaseToken(alClientId).then(function (token) {
                var encodedValue = encodeURIComponent('/portfolio/edit/households/' + clientId + '?tabCode=bluePay');
                $scope.current.databaseUrl = redirectUrl + encodedValue + '&t=' + token;
                tokenOverride = token;
            });
        }
    });

    //INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {
        view: views[0],
        URL: '/Billing/FeeCollection/' + $routeParams.id + '/Details',
        id: $routeParams.id,
        startDate: $routeParams.startDate,
        endDate: $routeParams.endDate,
        description: $routeParams.description,
        type: '',
        executing: false,
    };
    $scope.counts = {
        total: { value: 0, change: false },
        sent: { value: 0, change: false },
        notSent: { value: 0, change: false },
        paid: { value: 0, change: false },
        errored: { value: 0, change: false },
        validation: { value: 0, change: false },
    };
    init();

    $scope.$on('slickgrid-data-loaded', function (event, data) {
        runList = angular.copy(data);
        updateCounts();
    });
});

'use strict';

app.controller('FeeInstanceNewCtrl', function FeeInstanceNewCtrl($scope, $http, $location) {
    function init() {
        $http.get('/Authorization/User/Databases?isActive=true&filterForMasterGroup=true', { trackerMsg: 'Loading database list' }).then(function (response) {
            $scope.databases = response.data.sortBy('clientName');
        });
    }

    // PUBLIC FUNCTIONS
    $scope.close = function () {
        $scope.leftSidebar.isOpen = true;
        $location.url('/billing/generator/feecollectioninstances');
    };

    //INITIALIZE
    $scope.current = {
        wizardStep: 0,
        animation: 'slide-right',
        selectedDatabases: [],
        isCLSMasterGroup: $scope.user.authorization.masterGroup == 'CLS' ? true : false,
        params: {
            startDate: '',
            endDate: '',
            description: '',
            databases: [],
            isFinancialPlanningFee: false,
        },
    };

    $scope.createInstance = function () {
        var payload = angular.copy($scope.current.params);
        payload.startDate = payload.startDate.formatted();
        payload.endDate = payload.endDate.formatted();
        payload.databases = payload.databases.map('id');
        payload.isFinancialPlanningFee = payload.isFinancialPlanningFee;

        $http.post('/Billing/FeeCollection/Instance', payload, { trackerMsg: 'Creating fee instance' }).then(function (res) {
            $scope.leftSidebar.isOpen = true;
            $location.url('/billing/generator/feecollectioninstances');
        });
    };

    init();

    $scope.wizardSteps = ['Generate'];

    var cancelWatch = $scope.$watch('leftSidebar.exists', function (newVal, oldVal) {
        if (newVal) {
            $scope.leftSidebar.exists = false;
            cancelWatch();
        }
    });

    $scope.$on('$destroy', function () {
        $scope.leftSidebar.exists = true;
    });
});

'use strict';

app.controller('BillGeneratorFeeCalculatorCtrl', function BillGeneratorFeeCalculatorCtrl($scope, $http, $oasRights) {
    // PUBLIC METHODS
    $scope.refreshGrid = function () {
        $http
            .get('/Billing/Schedules/' + $scope.current.feeScheduleId + '/Calculate?amount=' + $scope.current.value, { trackerMsg: 'Calculating fee amounts' })
            .then(function (response) {
                $scope.fees = response.data;
            });
    };

    // INITIALIZE
    $scope.current = { feeScheduleId: 0, value: '' };
    $scope.fees = null;

    $scope.rightsFeeCalculator = $oasRights.forCode('FEECALCULATORAPP');

    // WATCH
    $scope.$watch('current.selectedEntity', function (newValue, oldValue) {
        if (newValue != oldValue && newValue != null) {
            $http.get('/Portfolio/Accounts/' + newValue.id, { trackerMsg: 'Getting Fee Schedule' }).then(function (res) {
                $scope.current.feeScheduleId = res.data.feeScheduleId;
            });
        }
    });
});

'use strict';

app.controller('RevenuePayoutsCtrl', function RevenuePayoutsCtrl($scope, $http, views, $oasRights, $dialog, $location, $timeout) {
    var revenueData = [];

    //PUBLIC FUNCTIONS
    $scope.exportToExcel = function () {
        $scope.$broadcast('event:revenue-payouts-action', { action: 'export-data' });
    };

    $scope.slickGridDoubleClick = function () {
        if ($scope.selectedIds.length === 1) {
            $timeout(function () {
                $location.url(
                    '/billing/generator/revenuepayoutsedit/' +
                        $scope.selectedIds[0] +
                        '?startDate=' +
                        $scope.current.startDate +
                        '&endDate=' +
                        $scope.current.endDate +
                        '&description=' +
                        $scope.current.description
                );
            });
        }
    };
    $scope.viewInstance = function (id) {
        $location.url(
            '/billing/generator/revenuepayoutsedit/' +
                id +
                '?startDate=' +
                $scope.current.startDate +
                '&endDate=' +
                $scope.current.endDate +
                '&description=' +
                $scope.current.description
        );
    };

    $scope.createNew = function () {
        $dialog.dialog({ templateUrl: 'revenue-payouts-new.html', controller: 'RevenuePayoutsNewCtrl' }).open();
    };

    $scope.getReport = function (id) {
        $dialog
            .dialog({
                dialogClass: 'modal wide',
                templateUrl: 'revenue-payment-report-prompt.html',
                controller: 'RevenuePaymentReportPrompt',
                revenueData: revenueData,
            })
            .open();
    };

    $scope.deletePayout = function () {
        if ($scope.selectedIds.length === 1) {
            $dialog
                .confirmAction('You are about to delete this Revenue Payout(' + $scope.selectedIds[0] + ').  Are you sure you want to proceed?')
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $http
                            .delete('/Billing/RevenuePayout/Payout/Delete/' + $scope.selectedIds[0], {
                                trackerMsg: 'Deleting Revenue Payout: ' + $scope.selectedIds[0] + '.',
                            })
                            .then(function () {
                                $scope.$broadcast('event:revenue-payouts-action', { action: 'refresh-grid' });
                            });
                    }
                });
        }
    };

    //INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        URL: '/Billing/RevenuePayout',
        allowDeleteInstance: false,
    };

    if ($scope.user.authorization.entity == 'Administrator') {
        $scope.current.allowDeleteInstance = true;
    }

    // EVENT LISTENERS
    $scope.$on('event:revenue-payouts-action-select', function (e, args) {
        if (args.length === 0) return;

        $scope.current.startDate = args[0].startDate;
        $scope.current.endDate = args[0].endDate;
        $scope.current.description = args[0].description;
    });

    $scope.$on('slickgrid-data-loaded', function (event, data) {
        revenueData = data.map(function (instance) {
            return { description: instance.description, id: instance.id };
        });
    });
});

app.controller('RevenuePayoutsNewCtrl', function RevenuePayoutsNewCtrl($scope, $http, dialog, $location) {
    $scope.close = function () {
        dialog.close(null);
    };

    $scope.calculate = function () {
        var url =
            '/Billing/RevenuePayout?asOfDate=' +
            $scope.current.asOfDate.formatted() +
            '&description=' +
            $scope.current.description +
            '&forecast=' +
            $scope.current.isForecast;

        $http.post(url, null, { trackerMsg: 'Create new revenue payout instance.' }).then(function (res) {
            dialog.close();
            $location.url(
                '/billing/generator/revenuepayoutsedit/' +
                    res.data.id +
                    '?description=' +
                    res.data.description +
                    '&startDate=' +
                    res.data.startDate +
                    '&endDate=' +
                    res.data.endDate
            );
        });
    };
});

app.controller('RevenuePaymentReportPrompt', function RevenuePaymentReportPrompt($scope, dialog, $http, API_CONFIG) {
    $scope.close = function () {
        dialog.close(null);
    };

    $scope.loadPayments = function (instance) {
        $http.get('/Billing/RevenuePayout/' + instance + '/Payment/Reports', { trackerMsg: 'Getting revenue payment reports' }).then(function (response) {
            $scope.payments = response.data;
        });
    };

    $scope.runReport = function (fileId) {
        window.location.href = API_CONFIG.baseUrl + '/Billing/RevenuePayout/Payment/Report/' + fileId + '?Authorization=' + sessionStorage.oas_token;
    };

    $scope.current = { description: dialog.options.description, reportId: null };
    $scope.payments = [];
    $scope.revenueData = dialog.options.revenueData;
});

'use strict';

app.controller('RevenuePayoutsEditCtrl', function RevenuePayoutsEditCtrl($scope, $http, $routeParams, $q, $dialog, API_CONFIG) {
    function init() {
        var promised = [];
        var url = '';

        url = '/Billing/RevenuePayout/' + $scope.current.id;
        promised.push($http.get(url, { trackerMsg: 'Loading revenue payout' }));

        url = '/Billing/RevenuePayout/' + $scope.current.id + '/Details';
        promised.push($http.get(url, { trackerMsg: 'Loading revenue payouts details' }));

        url = '/Billing/RevenuePayout/' + $scope.current.id + '/Payments';
        promised.push($http.get(url, { trackerMsg: 'Loading revenue payouts payments' }));

        url = '/Settings/Database/EntityOptions/Code/RevenuePayoutUI';
        promised.push($http.get(url, { trackerMsg: 'Loading Revenue Payout UI option' }));

        $q.all(promised).then(function (item) {
            $scope.current.payout = item[0].data;
            $scope.current.payouts = item[1].data;
            $scope.current.payments = item[2].data;
            let useRevenuePayoutUI = item[3].data;

            $scope.current.showAUMBasis =
                $scope.current.payout.isBasis && $scope.current.payout.revenuePayoutBasedOn == 'AUM Based' && useRevenuePayoutUI?.value == 'True';

            getPayoutDetailDisplay();
        });
    }

    $scope.addNew = function () {
        $http.get('/Billing/RevenuePayout/' + $scope.current.id + '/Payment/New', { trackerMsg: 'Loading new payment data' }).then(function (res) {
            $scope.paymentsData = res.data;
            $scope.paymentsData.asOfDate = Date.create('today').formatted();

            $dialog
                .dialog({
                    templateUrl: 'revenue-payouts-add-payment.html',
                    controller: 'RevenuePayoutsAddPaymentCtrl',
                    id: $scope.current.id,
                    resolve: {
                        args: function () {
                            return $scope.paymentsData;
                        },
                    },
                })
                .open()
                .then(function (result) {
                    if (result) {
                        $http
                            .get('/Billing/RevenuePayout/' + $scope.current.id + '/Payments', { trackerMsg: 'Loading revenue payouts payments' })
                            .then(function (response) {
                                $scope.current.payments = response.data;
                            });
                    }
                });
        });
    };

    $scope.removePayment = function (payment) {
        $scope.current.payments.remove(payment);

        $http.delete('/Billing/RevenuePayout/Payment/' + payment.id, { trackerMsg: 'Deleting Revenue payment' });
    };

    $scope.downloadFile = function (fileId) {
        window.location.href = API_CONFIG.baseUrl + '/Billing/RevenuePayout/Payment/Report/' + fileId + '?Authorization=' + sessionStorage.oas_token;
    };

    function getPayoutDetailDisplay() {
        if ($scope.current.payouts) {
            let dollarUS = Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            });

            $scope.current.payouts.forEach((detail) => {
                if ($scope.current.showAUMBasis) {
                    detail.bamPercentDisplay = detail.riaPayout * 100;
                    detail.advisorDisplay = '(Remaining Revenue Dollars)';
                    detail.advisorPercentDisplay = 'N/A';
                } else {
                    detail.bamPercentDisplay = detail.riaAmount / (detail.riaAmount + detail.advisorAmount);
                    detail.advisorDisplay = dollarUS.format(detail.advisorAmount);
                    detail.advisorPercentDisplay = (detail.advisorAmount / (detail.riaAmount + detail.advisorAmount))?.toFixed(3);
                }
            });
        }
    }

    $scope.current = {
        id: $routeParams.id,
        description: $routeParams.description,
        startDate: $routeParams.startDate,
        endDate: $routeParams.endDate,
        payments: [],
        payouts: [],
    };

    $scope.getRiaTotal = function () {
        var total = 0;
        for (var i = 0; i < $scope.current.payouts.length; i++) {
            var payout = $scope.current.payouts[i];
            total += payout.riaAmount;
        }
        return total;
    };

    $scope.getAdvisorAmountTotal = function () {
        var total = 0;

        let dollarUS = Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        for (var i = 0; i < $scope.current.payouts.length; i++) {
            var payout = $scope.current.payouts[i];
            total += payout.advisorAmount;
        }
        return dollarUS.format(total);
    };

    init();
});

app.controller('RevenuePayoutsAddPaymentCtrl', function RevenuePayoutsAddPaymentCtrl($scope, $http, dialog, args) {
    $scope.addTotal = function () {
        $scope.paymentsData.totalPayment = $scope.paymentsData.collectedAdvisorAmount + $scope.paymentsData.adjustmentAmount;
    };

    $scope.close = function () {
        dialog.close(null);
    };

    $scope.savePayment = function () {
        $http.post('/Billing/RevenuePayout/Payment', $scope.paymentsData, { trackerMsg: 'Saving payments' }).then(function (res) {
            dialog.close([res.data]);
        });
    };
    $scope.current = {
        id: dialog.options.id,
    };

    $scope.paymentsData = args;
});

'use strict';

var billSummaryCtrl = app.controller(
    'BillSummaryCtrl',
    function BillSummaryCtrl($scope, $http, $routeParams, $portfolio, entities, $timeout, views, $billing, config) {
        var billId;

        //PRIVATE METHODS
        function init() {
            if ($routeParams.id) {
                setPanelData($routeParams.id);
            } else {
                if (config.householdId) {
                    $scope.current.householdId = config.householdId;
                    setPanelData($scope.current.householdId);
                }
            }
        }
        function setPanelData(householdId) {
            $http.get('/Billing/HouseholdSummary/' + householdId, { trackerMsg: 'Getting household summary' }).then(function (res) {
                $scope.accountDetails = [];
                $scope.additionalDetails = [];
                $scope.priorInvoicesDetails = [];
                $scope.householdDetails = [];

                $scope.householdSummaryData = res.data;

                var formatConfig = [
                    { key: 'value', format: 'currency' },
                    { key: 'excludedAssetValue', format: 'currency' },
                    { key: 'billableValue', format: 'currency' },
                ];

                formatData($scope.householdSummaryData.value, null, null, true, formatConfig, $scope.householdDetails);

                // account details
                $scope.householdSummaryData.accountSummaries = $scope.householdSummaryData.accountSummaries.findAll({ isActive: true });
                formatConfig = [{ key: 'lastCreditAmount', format: 'currency' }];
                $scope.householdSummaryData.accountSummaries.forEach(function (item) {
                    formatData(item, 'accountNumber', 'accountType', false, formatConfig, $scope.accountDetails);
                });

                // additional account details
                formatConfig = [
                    { key: 'currentValue', format: 'currency' },
                    { key: 'excludedValue', format: 'currency' },
                    { key: 'billableValue', format: 'currency' },
                    { key: 'billingStartDate', format: 'date' },
                ];
                $scope.householdSummaryData.relatedHouseholdSummaries.forEach(function (item) {
                    formatData(item, 'clientName', null, false, formatConfig, $scope.additionalDetails);
                });

                // prior invoices
                formatConfig = [
                    { key: 'marketValueAtGeneration', format: 'currency' },
                    { key: 'asOfDate', format: 'date' },
                    { key: 'billAmount', format: 'currency' },
                    { key: 'balanceDue', format: 'currency' },
                    { key: 'creditsToBill', format: 'currency' },
                ];
                $scope.householdSummaryData.historicalBills.forEach(function (item) {
                    formatData(item, 'id', 'dateRange', false, formatConfig, $scope.priorInvoicesDetails);
                });

                var lastInvoice = $scope.priorInvoicesDetails.first();
                if (lastInvoice) {
                    billId = lastInvoice.details.find({ key: 'Bill Id' }).value;
                    $scope.refreshGrid(billId);

                    lastInvoice.isSelected = true;
                }
            });
        }

        function formatData(data, rowTitle1, rowTitle2, isSelected, formatConfig, dataToPush) {
            var acctDtl = [];
            Object.each(data, function (key, value) {
                var format = '';
                var rslt = formatConfig.find({ key: key });
                format = rslt ? rslt.format : '';
                acctDtl.push({ key: key.titleize(), value: value, format: format });
            });
            dataToPush.push({
                rowTitle1: rowTitle1 ? data[rowTitle1] : null,
                rowTitle2: rowTitle2 ? data[rowTitle2] : null,
                isSelected: isSelected,
                details: acctDtl,
            });
        }

        // PUBLIC METHODS
        $scope.selectHousehold = function () {
            $portfolio.search(entities.client.value).then(function (rslt) {
                if (rslt) {
                    $scope.current.householdId = rslt.item.id;
                    setPanelData(rslt.item.id);
                }
            });
        };

        $scope.refreshGrid = function (billId) {
            $scope.current.billId = billId;

            $timeout(function () {
                $scope.$broadcast('event:householdbillingsummary-processed-action', { action: 'refresh-grid' });
            });
        };

        $scope.runAdvisoryFeeReport = function () {
            $billing.runAdvisoryFeeReport(entities.client.value, $scope.current.householdId);
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:householdbillingsummary-processed-action', { action: 'export-data' });
        };

        $scope.accountDetails = [];
        $scope.additionalDetails = [];
        $scope.priorInvoicesDetails = [];
        $scope.invoicesDetails = [];

        $scope.views = views;
        $scope.selectedIds = [];
        $scope.current = {
            view: views[0],
            url: '/Billing/Accounts/Summary',
            householdId: null,
            billId: 0,
        };

        init();
    }
);

billSummaryCtrl.loadHousehold = [
    '$http',
    '$dialog',
    '$q',
    '$portfolio',
    'entities',
    '$routeParams',
    function ($http, $dialog, $q, $portfolio, entities, $routeParams) {
        if ($routeParams.instanceId) {
            return { householdId: null };
        } else {
            return $portfolio.search(entities.client.value).then(function (rslt) {
                if (rslt) {
                    if (rslt.entity === entities.client.value) {
                        return { householdId: rslt.item.id };
                    } else if (rslt.entity === entities.registration.value) {
                        return $http
                            .get('/Portfolio/Registrations/' + rslt.item.id, { trackerMsg: 'Getting registration information' })
                            .then(function (response) {
                                return { householdId: response.data.clientId };
                            });
                    } else if (rslt.entity === entities.account.value) {
                        return $http.get('/Portfolio/Accounts/' + rslt.item.id, { trackerMsg: 'Getting account information' }).then(function (response) {
                            return { householdId: response.data.clientId };
                        });
                    }
                } else {
                    var deferred = $q.defer();
                    deferred.reject();
                    return deferred.promise;
                }
            });
        }
    },
];

app.controller('BillSummaryPanelSettingsCtrl', function BillSummaryPanelSettingsCtrl($scope, dialog) {
    $scope.current = {
        pageSizes: [1, 2, 3],
        itemsPerPage: dialog.options.itemsPerPage,
        totalItems: dialog.options.totalItems,
        showAll: false,
        accountStatus: 1,
    };

    $scope.close = function () {
        dialog.close({
            itemsPerPage: $scope.current.showAll ? $scope.current.totalItems : $scope.current.itemsPerPage,
            accountStatus: $scope.current.accountStatus,
        });
    };
});

'use strict';

app.controller(
    'BillGeneratorViewPlanFeesCtrl',
    function BillGeneratorViewPlanFeesCtrl($scope, $http, $oasRights, $location, $portfolio, $dialog, $routeParams, entities, views, apps) {
        // PRIVATE VARIABLES

        // PRIVATE METHODS
        function init() {
            $scope.rightsFS = $oasRights.forCode('FEESCHEDULES');
        }

        function doAction(actionUrl, msgVerb, confirmMsg, method) {
            $dialog
                .confirmAction(confirmMsg)
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        switch (method) {
                            case 'DELETE':
                                $http.delete(actionUrl, { trackerMsg: msgVerb + ' fee schedule' }).then(function () {
                                    $scope.$broadcast('event:planning-fee-action', { action: 'refresh-grid' });
                                });
                                break;
                        }
                    }
                });
        }

        // PUBLIC METHODS
        $scope.exportToExcel = function () {
            $scope.$broadcast('event:planning-fee-action', { action: 'export-data' });
        };

        $scope.deleteFee = function () {
            doAction('/Billing/FeeType/' + $scope.selectedIds[0], 'Deleting', 'Delete Fee Type.  Are you sure you want' + ' to proceed?', 'DELETE');
        };

        $scope.newPlanningFee = function () {
            $location.url('/billing/generator/planningfee');
        };

        $scope.deleteInstance = function () {
            if ($scope.selectedIds.length >= 1) {
                var billInstances = [];
                $scope.selectedIds.forEach(function (id) {
                    billInstances.push($scope.current.data.find({ id: id }).billInstanceId);
                });
                $dialog
                    .confirmAction('You are about to delete this fee collection instance(' + billInstances[0] + ').  Are you sure you want to proceed?')
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            $http
                                .put('/Billing/Instances/Action/Delete/', billInstances, {
                                    trackerMsg: 'Deleting fee collection instance: ' + billInstances[0] + '.',
                                })
                                .then(function () {
                                    $scope.$broadcast('event:planning-fee-action', { action: 'refresh-grid' });
                                });
                        }
                    });
            }
        };

        $scope.goBack = function () {
            window.history.back();
        };

        $scope.editEntity = function (entity) {
            if (entity === entities.client.name) {
                $portfolio.openEditor(entities.client.value, [$scope.current.householdId], null, null, apps.billingAudit.name, null);
            } else if (entity === entities.registration.name) {
                $portfolio.openEditor(entities.registration.value, $scope.current.householdId, null, null, apps.billingAudit.name, null);
            }
        };

        $scope.goToLower = function (urlLevel) {
            $portfolio.goTo(urlLevel, entities.client.value, $scope.current.householdId, { source: 'bg' });
        };

        // INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];

        $scope.current = {
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            data: [],
            url: '/Billing/FinancialPlanningFee/List/',
        };

        init();

        $scope.$on('slickgrid-data-loaded', function (event, data) {
            $scope.current.data = data;
        });

        //EVENT LISTENERS
        $scope.$on('event:planning-fee-select', function (e, args) {
            if (args.length === 0) return;
            $scope.current.householdId = args[0].clientId;
        });
    }
);

app.directive('oasBillingFeeSchedule', function ($http, $portfolio, entities, apps) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            schedule: '=',
            reload: '&',
        },
        templateUrl: 'billing/directives/oasBillingFeeSchedule.html',
        link: function (scope, element, attrs) {
            scope.goToSchedule = function (feeScheduleId) {
                $portfolio.openEditor('15', [feeScheduleId], null, null, null, { isFeeSchedule: true });
            };

            scope.reassignedSchedule = function (accountId) {
                $portfolio.openEditor(entities.account.value, [accountId], 'Billing', 'billingGeneral', apps.feeAssignment.name, null).then(function (rslt) {
                    if (rslt) {
                        scope.reload();
                    }
                });
            };
        },
    };
});

'use strict';

app.controller('FeeScheduleAssignmentCtrl', function FeeScheduleAssignmentCtrl($scope, $http, $portfolio, entities, apps, $location) {
    function init() {
        loadSchedules();
    }

    function loadSchedules() {
        $http.post('/Billing/Schedules/AssignedSchedules', $scope.current.params, { trackerMsg: 'Loading assigned schedules' }).then(function (response) {
            $scope.schedules = response.data.schedules;
            $scope.current.totalItems = response.data.totalResults;
            $scope.current.params.searchFor = '';

            resetPagination();
        });
    }

    function resetPagination() {
        $scope.setPageItems();
    }

    $scope.current = {
        params: {
            pageIndex: 0,
            rowCount: 10,
            searchType: 'ScheduleName',
            searchFor: '',
            entity: $scope.user.authorization.entity === 'Representative' ? entities.representative.value : entities.ria.value,
            entityId: $scope.user.authorization.entityId ? $scope.user.authorization.entityId : 0,
        },
        page: 1,
        pageSizes: [10, 50, 100],
        itemsPerPage: 10,
        numPages: 10,
    };

    $scope.newSchedule = function () {
        $portfolio.openEditor(entities.feeSchedule.value, [], 'General', 'fsGeneral', apps.portfolioLists.name, { isFeeSchedule: true }).then(function (rslt) {
            init();
        });
    };

    $scope.reload = function () {
        init();
    };

    $scope.scheduleList = function () {
        $location.url('/firmprofile/schedules/fee?source=fa');
    };

    $scope.setPageItems = function (page) {
        page = page || $scope.current.page;

        var begin = (page - 1) * $scope.current.itemsPerPage;
        var end = begin + $scope.current.itemsPerPage;

        $scope.current.params.pageIndex = page - 1;
        $scope.current.params.rowCount = $scope.current.itemsPerPage;
    };

    init();

    var cancelWatch = $scope.$watch('leftSidebar.exists', function (newVal, oldVal) {
        if (newVal) {
            $scope.leftSidebar.exists = false;
            cancelWatch();
        }
    });

    $scope.$on('$destroy', function () {
        $scope.leftSidebar.exists = true;
    });

    $scope.$watch('current.params.pageIndex', function (newVal, oldVal) {
        if (newVal === oldVal) return;
        init();
    });

    $scope.$watch('current.params.rowCount', function (newVal, oldVal) {
        if (newVal === oldVal) return;
        init();
    });
});

'use strict';

app.controller(
    'AdjustmentTypeListCtrl',
    function AdjustmentTypeListCtrl($scope, $http, $oasRights, $location, $portfolio, $dialog, $routeParams, entities, views, apps) {
        //PRIVATE FUNCTIONS
        function init() {
            $scope.rightsBillAdjustmentTypes = $oasRights.forCode('BILLAUDIT');
        }

        $scope.addNewAdjustmentType = function () {
            $scope.slickGridDoubleClick(true); // Add new record
        };

        $scope.deleteAdjustmentTypes = function () {
            $dialog
                .confirmAction('Are you sure you want to delete this record?')
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $http.delete('/Billing/AdjustmentTypes/' + $scope.current.selectedId, { trackerMsg: 'Deleting Adjustment Type' }).then(function (rslt) {
                            $scope.$broadcast('event:billing-adjustment-action', { action: 'refresh-grid' });
                        });
                    }
                });
        };

        $scope.slickGridDoubleClick = function (isNew) {
            if ($scope.selectedIds.length === 1) {
                $portfolio
                    .openEditor(entities.billAdjustmentType.value, isNew ? [] : $scope.selectedIds, 'General', 'billAdjustmentGeneral', apps.billingAudit.name)
                    .then(function (rslt) {
                        if (rslt) {
                            $scope.$broadcast('event:billing-adjustment-action', { action: isNew ? 'add-item' : 'update-item', item: rslt });
                        }
                    });
            }
        };

        //INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];

        $scope.current = {
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            url: '/Billing/AdjustmentTypes',
            selectedId: null,
        };
        init();

        // WATCHER
        $scope.$on('event:billing-adjustment-select', function (e, args) {
            if (args.length === 0) return;

            $scope.current.selectedId = args[0].id;
            $scope.current.canUpdate = args[0].id > 100;
        });
    }
);

'use strict';

app.controller(
    'CancellationFeeAdjustmentEditCtrl',
    function CancellationFeeAdjustmentEditCtrl($scope, $http, $oasRights, $dialog, $timeout, dialog, args, entities) {
        // region PRIVATE VARIABLES
        var cfadGeneralOriginal = null;
        var editorHotKeys;
        //endregion

        //region PRIVATE METHODS
        // region INIT/RIGHT/MENU/TABS
        function init() {
            loadRights();
            buildMenu();
            loadHotKeys();
            loadDisbursementMethods();
            $scope.loadTab(args.defaultTab);
        }

        function loadRights() {
            $scope.rightsPayoutSchedule = $oasRights.forCode('BILLGENERATOR');
        }

        function buildMenu() {
            $scope.menu = { categories: [] };

            $scope.menu.categories.push({ name: 'Cancellation Fee Adjustment Default', children: [] });
            $scope.menu.categories[0].children.push({ name: 'General', active: false, code: 'cfadGeneral' });
        }

        function loadDataForSelectedTab() {
            switch ($scope.current.selectedTab) {
                case 'cfadGeneral':
                    if ($scope.rightsPayoutSchedule.canRead) {
                        loadCancellationFeeAdjustmentDefaults();
                    }
                    break;
            }
        }

        function loadHotKeys() {
            editorHotKeys = new HotKeys();
            $timeout(function () {
                editorHotKeys.addActions([
                    { combo: 'ALT+S', command: $scope.save },
                    {
                        combo: 'ALT+X',
                        command: function () {
                            $scope.close(true);
                        },
                    },
                ]);
            });
        }

        // endregion

        // region GENERAL

        function loadBillEntities() {
            if ($scope.billEntities === null) {
                $scope.billEntities = [];
                $http
                    .get('/Billing/BillingEntities?status=ShowOnlyWithAssignedSchedules', { trackerMsg: 'Loading Bill Entities' })
                    .then(function (response) {
                        $scope.billEntities = response.data;
                    })
                    .finally(function () {
                        $scope.current.selectedBillEntity = $scope.billEntities.find((bent) => bent.id === $scope.cfadGeneral.responsibleEntityId);
                    });
            }
        }

        function loadBillAdjustmentTypes() {
            if ($scope.adjustmentTypes === null) {
                $scope.adjustmentTypes = [];
                $http
                    .get('/Billing/AdjustmentTypes', { trackerMsg: 'Loading Adjustment Types' })
                    .then(function (response) {
                        $scope.adjustmentTypes = response.data;
                    })
                    .finally(function () {
                        $scope.current.selectedAdjustmentType = $scope.adjustmentTypes.find((adjt) => adjt.id === $scope.cfadGeneral.adjustmentTypeId);
                    });
            }
        }

        function loadCustodians() {
            if ($scope.custodians === null) {
                $scope.custodians = [];
                $http
                    .get('/Portfolio/Custodians', { trackerMsg: 'Loading Custodians' })
                    .then(function (response) {
                        $scope.custodians = response.data;
                        $scope.custodians.push({ id: -1, name: 'All' });
                    })
                    .finally(function () {
                        $scope.current.selectedCustodian = $scope.custodians.find((cust) => cust.id === $scope.cfadGeneral.custodianId);
                    });
            }
        }

        //Load all disbursement methods
        function loadDisbursementMethods() {
            $scope.disbursementMethods = ['', 'ACH', 'Wire', 'Check'];
        }

        function loadCancellationFeeAdjustmentDefaults() {
            if ($scope.cfadGeneral === null) {
                if ($scope.current.cfadId != 0) {
                    $http
                        .get('/Billing/CancellationFeeAdjDefault/' + $scope.current.cfadId, { trackerMsg: 'Loading Cancellation Fee Adjustment Defaults' })
                        .then(function (response) {
                            $scope.cfadGeneral = response.data;
                            $scope.cfadGeneral.amount = Math.abs($scope.cfadGeneral.amount);
                            cfadGeneralOriginal = angular.copy($scope.cfadGeneral);

                            //load up ancillary items
                            loadBillEntities();
                            loadBillAdjustmentTypes();
                            loadCustodians();
                        });
                } else {
                    $scope.cfadGeneral = {
                        id: 0,
                        qualified: false,
                        custodian: 0,
                        adjustmentTypeId: -1,
                        custodianId: 0,
                        responsibleEntityId: 0,
                    };
                    cfadGeneralOriginal = angular.copy($scope.cfadGeneral);
                    loadBillEntities();
                    loadBillAdjustmentTypes();
                    loadCustodians();
                }
            }
        }

        //endregion

        // region PUBLIC METHODS
        //  region LOAD/CLOSE
        $scope.loadTab = function (child) {
            $scope.menu.categories.each(function (c) {
                c.children.each(function (ch) {
                    ch.active = ch.code == child.code;
                });
            });

            $scope.current.selectedTab = child.code;

            loadDataForSelectedTab();
        };

        $scope.appendDollarSign = function () {
            try {
                if ($scope.current.selectedAdjustmentType === undefined) {
                    //If nothing has been set assume the sign to be positive
                    return '$';
                }
                if ($scope.current.selectedAdjustmentType.isDebit === true) {
                    return '-$';
                } else {
                    return '$';
                }
            } catch (e) {
                return '';
            }
        };

        $scope.canSave = function () {
            var cannotSave = true;
            if (
                $scope.current.selectedCustodian !== undefined &&
                $scope.current.selectedBillEntity !== undefined &&
                $scope.current.selectedAdjustmentType !== undefined &&
                $scope.current.selectedAdjustmentType?.id > 0 &&
                $scope.cfadGeneral?.amount !== undefined &&
                $scope.cfadGeneral?.amount !== null &&
                $scope.cfadGeneral?.amount !== 0 &&
                $scope.cfadGeneral?.amount !== '0' &&
                $scope.current.isSaving === false
            ) {
                cannotSave = false;
            }
            return cannotSave;
        };

        $scope.save = function () {
            $scope.cfadGeneral.custodianId = $scope.current.selectedCustodian?.id;
            $scope.cfadGeneral.responsibleEntityId = $scope.current.selectedBillEntity?.id;
            $scope.cfadGeneral.adjustmentTypeId = $scope.current.selectedAdjustmentType?.id;

            $scope.current.isSaving = true;

            // Ensure the disbursement method is 'Check' if overnight fee is enabled
            if ($scope.cfadGeneral.isOvernightFee) {
                $scope.cfadGeneral.disbursementMethod = 'Check';
            }

            var saveProcess = function () {
                if ($scope.current.cfadId == 0) {
                    $http
                        .post('/Billing/CancellationFeeAdjDefault/', $scope.cfadGeneral, { trackerMsg: 'Saving Cancellation Fee Default' })
                        .then(function (response) {
                            editorHotKeys.destroy();
                            dialog.close(response.data);
                        })
                        .catch(function () {
                            $scope.current.isSaving = false;
                        });
                } else {
                    $http
                        .put('/Billing/CancellationFeeAdjDefault/' + $scope.current.cfadId, $scope.cfadGeneral, {
                            trackerMsg: 'Saving Cancellation Fee Default',
                        })
                        .then(function (response) {
                            editorHotKeys.destroy();
                            dialog.close(response.data);
                        })
                        .catch(function () {
                            $scope.current.isSaving = false;
                        });
                }
            };
            saveProcess();
        };

        $scope.close = function (validate) {
            if (validate) {
                if (!angular.equals(cfadGeneralOriginal, $scope.cfadGeneral)) {
                    $scope.errors.push({
                        type: 'error',
                        title: 'Unsaved Changes! ',
                        msg: ' There are unsaved changes that will be lost.',
                        showAllowClose: true,
                    });
                } else {
                    editorHotKeys.destroy();
                    dialog.close(null);
                }
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
            $scope.$broadcast('event:cancellation-fee-adjustment-list-action', { action: 'refresh-grid' });
        };
        //endregion

        //endregion

        // region INITIALIZE
        $scope.current = {
            isSaving: false,
            selectedTab: args.defaultTab,
            cfadId: args.isNew ? 0 : parseInt(args.ids[0]),
            selectedBillEntity: null,
            selectedCustodian: null,
            selectedDisbursementMethod: null,
            selectedAdjustmentType: null,
        };

        $scope.cfadGeneral = null;

        // LOOK UPS
        $scope.billEntities = null;
        $scope.custodians = null;
        $scope.adjustmentTypes = null;

        $scope.errors = [];

        init();
        // endregion

        //region WATCHES

        //endregion
    }
);

'use strict';

app.controller(
    'CancellationFeeAdjustmentListCtrl',
    function CancellationFeeAdjustmentListCtrl($scope, $http, $oasRights, $dialog, views, $portfolio, entities, apps, activeState, $settings, $timeout) {
        // PRIVATE VARIABLES

        // PRIVATE METHODS
        function init() {
            $scope.rightBillEntity = $oasRights.forCode('BILLGENERATOR');
        }

        // PUBLIC METHODS

        $scope.openEditor = function (isNew) {
            if ($scope.selectedIds.length === 1 || isNew) {
                $portfolio
                    .openEditor(
                        entities.cancellationFeeAdjustment.value,
                        isNew ? [] : $scope.selectedIds,
                        'General',
                        'cfadGeneral',
                        apps.portfolioLists.name,
                        null
                    )
                    .then(function (rslt) {
                        $scope.$broadcast('event:cancellation-fee-adjustment-list-action', { action: 'refresh-grid' });
                    });
            }
        };

        $scope.deleteCfad = function () {
            doAction(
                '/Billing/CancellationFeeAdjDefault/' + $scope.selectedIds[0],
                'Deleting',
                'Deleting Cancellation Fee Adjustment Default.  Are you sure you want to proceed?',
                'DELETE'
            );
        };

        function doAction(actionUrl, msgVerb, confirmMsg, method) {
            $dialog
                .confirmAction(confirmMsg)
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        switch (method) {
                            case 'DELETE':
                                $http.delete(actionUrl, { trackerMsg: msgVerb + ' Cancellation Fee Adjustment Default' }).then(function () {
                                    $scope.$broadcast('event:cancellation-fee-adjustment-list-action', { action: 'refresh-grid' });
                                });
                                break;
                        }
                    }
                });
        }

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:cancellation-fee-adjustment-list-action', { action: 'export-data' });
        };

        $scope.slickGridDoubleClick = function (isNew) {
            if ($scope.selectedIds.length === 1) {
                $portfolio
                    .openEditor(
                        entities.cancellationFeeAdjustment.value,
                        isNew ? [] : $scope.selectedIds,
                        'General',
                        'cfadGeneral',
                        apps.portfolioLists.name,
                        null
                    )
                    .then(function () {
                        $scope.$broadcast('event:cancellation-fee-adjustment-list-action', { action: 'refresh-grid' });
                    });
            }
        };

        $scope.setActiveState = function () {
            $settings.setSetting('activeState', $scope.current.activeState);
            $scope.$broadcast('event:cancellation-fee-adjustment-list-action', { action: 'refresh-grid' });
        };

        // INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];

        $scope.current = {
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            data: [],
            url: '/Billing/CancellationFeeAdjDefault/',
            isUserAdded: false,
            activeStates: activeState,
            isNew: false,
        };

        $scope.current.activeState = $settings.getSetting('activeState');

        $scope.current.hotKeyActions = [
            {
                combo: 'ALT+E',
                command: function () {
                    if ($scope.selectedIds.length === 1) $scope.openEditor(false);
                },
            },
        ];

        init();

        $scope.$on('slickgrid-data-loaded', function (event, data) {
            $scope.current.data = data;
        });

        // WATCHER
        $scope.$on('event:cancellation-fee-adjustment-list-select', function (e, args) {
            if (args.length === 0) return;

            $scope.current.isUserAdded = args[0].isUserAdded;
        });
    }
);

'use strict';

app.controller('BillPayMethodEditCtrl', function BillPayMethodEditCtrl($scope, $http, $oasRights, $dialog, $timeout, dialog, args, entities) {
    // region PRIVATE VARIABLES
    var bpmGeneralOriginal = null;
    var editorHotKeys;
    //endregion

    //region PRIVATE METHODS
    // region INIT/RIGHT/MENU/TABS
    function init() {
        loadRights();
        buildMenu();
        loadHotKeys();
        $scope.loadTab(args.defaultTab);
    }

    function loadRights() {
        $scope.rightsPayMethod = $oasRights.forCode('BILLGENERATOR');
    }

    function buildMenu() {
        $scope.menu = { categories: [] };

        $scope.menu.categories.push({ name: 'Bill Pay Method', children: [] });
        $scope.menu.categories[0].children.push({ name: 'General', active: false, code: 'bpmGeneral' });
    }

    function loadDataForSelectedTab() {
        switch ($scope.current.selectedTab) {
            case 'bpmGeneral':
                if ($scope.rightsPayMethod.canRead) {
                    loadBillPayMethod();
                }
                break;
        }
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                { combo: 'ALT+S', command: $scope.save },
                {
                    combo: 'ALT+X',
                    command: function () {
                        $scope.close(true);
                    },
                },
            ]);
        });
    }

    // endregion

    // region GENERAL

    function loadBillPayMethod() {
        if ($scope.bpmGeneral === null) {
            $http.get('/Billing/BillPayMethods/' + $scope.current.bpmId, { trackerMsg: 'Loading Bill Pay Method' }).then(function (response) {
                $scope.bpmGeneral = response.data;
                bpmGeneralOriginal = angular.copy($scope.bpmGeneral);
            });
        }
    }

    //endregion

    // region PUBLIC METHODS
    //  region LOAD/CLOSE
    $scope.loadTab = function (child) {
        $scope.menu.categories.each(function (c) {
            c.children.each(function (ch) {
                ch.active = ch.code == child.code;
            });
        });

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab();
    };

    $scope.canSave = function () {
        return $scope.current.isSaving;
    };

    $scope.save = function () {
        $scope.current.isSaving = true;
        var saveProcess = function () {
            $http
                .put('/Billing/BillPayMethods/Update', $scope.bpmGeneral, { trackerMsg: 'Saving Bill Pay Method' })
                .then(function (response) {
                    editorHotKeys.destroy();
                    dialog.close(response.data);
                })
                .catch(function () {
                    $scope.current.isSaving = false;
                });
        };
        saveProcess();
    };

    $scope.close = function (validate) {
        if (validate) {
            if (!angular.equals(bpmGeneralOriginal, $scope.bpmGeneral)) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
        $scope.$broadcast('event:bill-pay-method-list-action', { action: 'refresh-grid' });
    };
    //endregion

    //endregion

    // region INITIALIZE
    $scope.current = {
        isSaving: false,
        selectedTab: args.defaultTab,
        bpmId: args.isNew ? 0 : parseInt(args.ids[0]),
    };

    $scope.bpmGeneral = null;

    // LOOK UPS

    $scope.errors = [];

    init();
    // endregion

    //region WATCHES

    //endregion
});

'use strict';

app.controller(
    'BillPayMethodListCtrl',
    function BillPayMethodListCtrl($scope, $http, $oasRights, $dialog, views, $portfolio, entities, apps, activeState, $settings, $timeout) {
        // PRIVATE VARIABLES

        // PRIVATE METHODS

        // PUBLIC METHODS

        $scope.openEditor = function (isNew) {
            if ($scope.selectedIds.length === 1 || isNew) {
                $portfolio
                    .openEditor(entities.billPayMethod.value, isNew ? [] : $scope.selectedIds, 'General', 'bpmGeneral', apps.portfolioLists.name, null)
                    .then(function (rslt) {
                        $scope.$broadcast('event:bill-pay-method-list-action', { action: 'refresh-grid' });
                    });
            }
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:bill-pay-method-list-action', { action: 'export-data' });
        };

        $scope.slickGridDoubleClick = function (isNew) {
            if ($scope.selectedIds.length === 1) {
                $portfolio
                    .openEditor(entities.billPayMethod.value, isNew ? [] : $scope.selectedIds, 'General', 'bpmGeneral', apps.portfolioLists.name, null)
                    .then(function () {
                        $scope.$broadcast('event:bill-pay-method-list-action', { action: 'refresh-grid' });
                    });
            }
        };

        $scope.setActiveState = function () {
            $settings.setSetting('activeState', $scope.current.activeState);
            $scope.$broadcast('event:bill-pay-method-list-action', { action: 'refresh-grid' });
        };

        // INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];

        $scope.current = {
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            data: [],
            url: '/Billing/BillPayMethods',
            isUserAdded: false,
            activeStates: activeState,
            isNew: false,
        };

        $scope.current.activeState = $settings.getSetting('activeState');

        $scope.current.hotKeyActions = [
            {
                combo: 'ALT+E',
                command: function () {
                    if ($scope.selectedIds.length === 1) $scope.openEditor(false);
                },
            },
        ];

        $scope.$on('slickgrid-data-loaded', function (event, data) {
            $scope.current.data = data;
        });

        // WATCHER
        $scope.$on('event:bill-pay-method-list-select', function (e, args) {
            if (args.length === 0) return;

            $scope.current.isUserAdded = args[0].isUserAdded;
        });
    }
);

'use strict';

app.controller('FeeTypeListCtrl', function FeeTypeListCtrl($scope, $http, $oasRights, $location, $portfolio, $dialog, $routeParams, entities, views, apps) {
    // PRIVATE VARIABLES

    // PRIVATE METHODS
    function init() {
        $scope.rightsFS = $oasRights.forCode('FEESCHEDULES');
    }

    function doAction(actionUrl, msgVerb, confirmMsg, method) {
        $dialog
            .confirmAction(confirmMsg)
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    switch (method) {
                        case 'DELETE':
                            $http.delete(actionUrl, { trackerMsg: msgVerb + ' fee schedule' }).then(function () {
                                $scope.$broadcast('event:fee-type-action', { action: 'refresh-grid' });
                            });
                            break;
                    }
                }
            });
    }

    // PUBLIC METHODS
    $scope.openEditor = function (isNew) {
        if ($scope.selectedIds.length === 1 || isNew) {
            $portfolio
                .openEditor(entities.feeType.value, isNew ? [] : $scope.selectedIds, 'General', 'fsGeneral', apps.portfolioLists.name)
                .then(function (rslt) {
                    if (rslt) {
                        $scope.$broadcast('event:fee-type-action', { action: isNew ? 'add-item' : 'update-item', item: rslt });
                    }
                });
        }
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:fee-type-action', { action: 'export-data' });
    };

    $scope.deleteFeeType = function () {
        doAction('/Billing/FeeType/' + $scope.selectedIds[0], 'Deleting', 'Delete Fee Type.  Are you sure you want' + ' to proceed?', 'DELETE');
    };

    $scope.slickGridDoubleClick = function () {
        if ($scope.selectedIds.length === 1) $scope.openEditor(false);
    };

    $scope.goBack = function () {
        window.history.back();
    };

    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        data: [],
        url: '/Billing/FeeType/List',
    };

    $scope.current.hotKeyActions = [
        {
            combo: 'ALT+E',
            command: function () {
                if ($scope.selectedIds.length === 1) $scope.openEditor(false);
            },
        },
    ];

    init();

    $scope.$on('slickgrid-data-loaded', function (event, data) {
        $scope.current.data = data;
    });
});

'use strict';

app.controller(
    'BillEntityListCtrl',
    function BillEntityListCtrl($scope, $http, $oasRights, views, $portfolio, $dialog, entities, apps, activeState, $settings, $timeout) {
        // PRIVATE VARIABLES

        // PRIVATE METHODS
        function init() {
            $scope.rightBillEntity = $oasRights.forCode('BILLGENERATOR');
        }

        // PUBLIC METHODS
        $scope.exportToExcel = function () {
            $scope.$broadcast('event:bill-entity-list-action', { action: 'export-data' });
        };

        $scope.deleteBillEntities = function () {
            // Redundant check but just in case
            if ($scope.selectedIds) {
                $http.put('/Billing/Entities/Delete', $scope.selectedIds, { trackerMsg: 'Deleting Selected Bill Entities' }).then(function () {
                    $timeout(function () {
                        $scope.$broadcast('event:bill-entity-list-action', { action: 'refresh-grid' });
                    }, 0);
                });
            }
        };

        $scope.slickGridDoubleClick = function (isNew) {
            if ($scope.selectedIds.length === 1) {
                $portfolio
                    .openEditor(entities.billEntity.value, isNew ? [] : $scope.selectedIds, 'General', 'billEntityGeneral', apps.firmProfile.name)
                    .then(function (rslt) {
                        if (rslt) {
                            $scope.$broadcast('event:bill-entity-list-action', { action: isNew ? 'add-item' : 'update-item', item: rslt });
                        }
                    });
            }
        };

        $scope.setActiveState = function () {
            $settings.setSetting('activeState', $scope.current.activeState);
            $timeout(function () {
                $scope.$broadcast('event:bill-entity-list-action', { action: 'refresh-grid' });
            });
        };

        // INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];

        $scope.current = {
            view: views[0],
            gridDoubleClick: $scope.slickGridDoubleClick,
            data: [],
            url: '/Billing/Entities/EntityList',
            isUserAdded: false,
            activeStates: activeState,
            isNew: false,
        };

        $scope.current.activeState = $settings.getSetting('activeState');

        $scope.current.hotKeyActions = [
            {
                combo: 'ALT+E',
                command: function () {
                    if ($scope.selectedIds.length === 1) $scope.openEditor(false);
                },
            },
        ];

        init();

        $scope.$on('slickgrid-data-loaded', function (event, data) {
            $scope.current.data = data;
        });

        // WATCHER
        $scope.$on('event:bill-entity-list-select', function (e, args) {
            if (args.length === 0) return;

            $scope.current.isUserAdded = args[0].isUserAdded;
        });
    }
);

'use strict';

app.controller('BillEntityEditCtrl', function BillEntityEditCtrl($scope, $http, $oasRights, $dialog, $timeout, dialog, args) {
    // region PRIVATE VARIABLES
    var billEntityOriginal = null,
        editorHotKeys;

    function init() {
        loadRights();
        buildMenu();
        loadHotKeys();
        $scope.loadTab(args.defaultTab);

        $http.get('/Settings/Database/EntityOptions/Code/69USEASTRO', { trackerMsg: 'Checking Use Astro Optimized Accounts' }).then(function (response) {
            $scope.current.useApplyToAstro = response.data.value === 'True';
        });
        $http.get('/Settings/Database/EntityOptions/Code/BILLUSEFEHI', { trackerMsg: 'Checking Use Fee Hierarchy' }).then(function (response) {
            $scope.current.useFeeHierarchy = response.data.value === 'True';
        });
        $http.get('/Settings/Database/EntityOptions/Code/SplitFeeFileByEnt', { trackerMsg: 'Checking Split Fee File by Bill Entity' }).then(function (response) {
            $scope.current.useSplitFeeFilesByBillEntity = hasSelectedFeeFileType(response.data);
        });
    }

       function hasSelectedFeeFileType(entityOption) {
        var fileTypes = Object.keys(entityOption.options || {});

        return (entityOption.value || '').split(',').some(function (fileType) {
            return fileTypes.indexOf(fileType.trim()) !== -1;
        });
    }

    function loadRights() {
        $scope.rightsBillEntity = $oasRights.forCode('BILLGENERATOR');
    }

    function buildMenu() {
        $scope.menu = { categories: [] };

        $scope.menu.categories.push({ name: 'Bill Entity', children: [] });
        $scope.menu.categories[0].children.push({ name: 'General', active: false, code: 'billEntityGeneral' });
    }

    function loadDataForSelectedTab() {
        switch ($scope.current.selectedTab) {
            case 'billEntityGeneral':
                if ($scope.rightsBillEntity.canRead) {
                    loadBillEntity();
                    loadBillingPayees();
                }
                break;
        }
    }

    function loadBillEntity() {
        if ($scope.current.billEntityId !== 0) {
            $http.get('/Billing/Entities/' + $scope.current.billEntityId, { trackerMsg: 'Loading bill entity' }).then(function (response) {
                $scope.billEntityGeneral = response.data;
                billEntityOriginal = angular.copy($scope.billEntityGeneral);
            });
        } else {
            $scope.billEntityGeneral = {
                id: 0,
                description: '',
                isPayableEntity: true,
                isUserAdded: true,
                name: '',
                isActive: true,
                collectFromId: 3,
            };
        }
    }

    function loadBillingPayees() {
        $http.get('/Billing/Payees?isActive=true', { cache: false, trackerMsg: 'Loading payees' }).then(function (response) {
            $scope.payees = response.data;
        });
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                { combo: 'ALT+S', command: $scope.save },
                {
                    combo: 'ALT+X',
                    command: function () {
                        $scope.close(true);
                    },
                },
            ]);
        });
    }

    // region PUBLIC METHODS
    //  region LOAD/CLOSE
    $scope.loadTab = function (child) {
        $scope.menu.categories.each(function (c) {
            c.children.each(function (ch) {
                ch.active = ch.code == child.code;
            });
        });

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab();
    };

    $scope.save = function () {
        var billEntityGeneralToSave = angular.copy($scope.billEntityGeneral);

        var args =
            $scope.current.billEntityId > 0
                ? { method: 'PUT', id: '', trackerMsg: 'Saving bill entity ' + $scope.current.billEntityId, url: '/Billing/Entities/Update/' }
                : { method: 'POST', id: '', trackerMsg: 'Adding new bill entity', url: '/Billing/Entities/New/' };

        $http({ method: args.method, url: args.url + args.id, data: billEntityGeneralToSave, trackerMsg: args.trackerMsg }).then(function (response) {
            editorHotKeys.destroy();
            dialog.close(response.data);
        });
    };

    $scope.close = function (validate) {
        if (validate) {
            if (!angular.equals(billEntityOriginal, $scope.billEntityGeneral)) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };
    //endregion

    // region INITIALIZE
    $scope.current = {
        selectedTab: args.defaultTab,
        billEntityId: args.isNew ? 0 : parseInt(args.ids[0]),
        billEntity: 'Bill Entity',
        useApplyToAstro: false,
        useFeeHierarchy: false,
        useSplitFeeFilesByBillEntity: false,
    };

    $scope.billEntityGeneral = null;
    $scope.errors = [];
    init();
});


'use strict';

app.controller('PayeeListCtrl', function PayeeListCtrl( $scope, $http, $oasRights, views, $portfolio, $dialog, entities, apps) {

    // PRIVATE VARIABLES

    // PRIVATE METHODS
    function init( ) {
        $scope.rightPayee = $oasRights.forCode("BILLGENERATOR");
    }


    // PUBLIC METHODS
    $scope.exportToExcel = function() {
        $scope.$broadcast('event:payee-list-action', {action: 'export-data'});
    };

    $scope.slickGridDoubleClick = function(isNew) {
        if($scope.selectedIds.length === 1)
        {
            $portfolio.openEditor(entities.payee.value, isNew ? [] : $scope.selectedIds, 'General', 'payeeGeneral', apps.firmProfile.name)
                .then(function (rslt) {
                    if (rslt) 
                    {                      
                        refreshGrid();
                   }
                });
        }
    };    
   
    function refreshGrid() {
        $scope.$broadcast('event:payee-list-action', {action: 'refresh-grid'});
    }

    $scope.slickGridDoubleClickDelete = function(isNew) {
        if($scope.selectedIds.length === 1) {
            $dialog.confirmAction( "Are you sure you want to delete payee id " + $scope.selectedIds + "?" )
            .open()
            .then( function( result ) {
                if( result === 'yes' ) {                    
                    $http.delete('/Billing/Payees/' +  $scope.selectedIds , {trackerMsg: 'Deleting payee id '+$scope.selectedIds})
                        .then(function () {                                
                            refreshGrid();
                        }
                    );
                }
            } );            
        }        
    };

    // INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view : views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        data: [],
        url : '/Billing/Payees/List',
        isUserAdded: false
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
            if($scope.selectedIds.length === 1)
                $scope.openEditor(false);
        }}];

    init( );


});

'use strict';

app.controller('PayeeEditCtrl', function PayeeEditCtrl($scope, $http, $oasRights, $dialog, $timeout, dialog, args, apps, $q) {

    // PUBLIC METHODS - SSN
    $scope.unlockSSNField = function (forEdit) {
        if (args.ids[0] > 0 && ($scope.payeeGeneral.ssN_TaxID && $scope.payeeGeneral.ssN_TaxID.indexOf('X') != -1) || forEdit) {
            $dialog.inputBox('Reason to ' + (forEdit ? 'Edit' : 'View') + ' the SSN or Tax ID', "Reason", "textarea")
                .open()
                .then(function (rslt) {
                    if (rslt && rslt.trim().length > 0) {
                        var updateSSN = { ssN: null, reason: rslt };
                        $http.put('/billing/Payees/' + args.ids[0] + '/SSNTaxId', updateSSN, { trackerMsg: 'Getting SSN/Tax ID information' })
                            .then(function (response) {
                                $scope.payeeGeneral.ssN_TaxID = response.data;

                                if (forEdit && $scope.current.updateSSN == false) {
                                    $scope.current.viewSSNReason = rslt;
                                    $scope.current.updateSSN = true;
                                }
                            });
                    }
                });
        }
    };

    // region PRIVATE VARIABLES
    var payeeOriginal = null, editorHotKeys;

    function init() {
        loadRights();
        buildMenu();
        loadHotKeys();
        $scope.loadTab(args.defaultTab);
    }

    function loadRights() {
        $scope.rightsPayee = $oasRights.forCode("BILLGENERATOR");
        $scope.rightsSSNChange = $oasRights.forCode("SSNCHANGE");
        $scope.rightsSSNView = $oasRights.forCode("SSNVIEW");
    }

    function buildMenu() {
        $scope.menu = { categories: [] };

        $scope.menu.categories.push({ name: 'Payee', children: [] });
        $scope.menu.categories[0].children.push({ name: 'General', active: false, code: 'payeeGeneral' });
    }


    function loadDataForSelectedTab() {
        switch ($scope.current.selectedTab) {
            case "payeeGeneral":
                if ($scope.rightsPayee.canRead) {
                    loadPayee();
                }
                break;
        }

    }

    function loadPayee() {
        if ($scope.current.payeeId != 0) {
            $http.get('/Billing/Payees/' + $scope.current.payeeId, { trackerMsg: 'Loading bill entity' })
                .then(function (response) {
                    $scope.payeeGeneral = response.data;
                    payeeOriginal = angular.copy($scope.payeeGeneral);
                })
        }
        else {
            $scope.payeeGeneral = {
                id: 0,
                first: '',
                last: '',
                isUserAdded: true,
                name: '',
                isActive: true
            };
        }
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                { combo: 'ALT+S', command: $scope.save },
                { combo: 'ALT+X', command: function () { $scope.close(true); } }
            ]);
        });
    }

    // region PUBLIC METHODS
    //  region LOAD/CLOSE
    $scope.loadTab = function (child) {
        $scope.menu.categories.each(function (c) {
            c.children.each(function (ch) {
                ch.active = ch.code == child.code;
            });
        });

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab();
    };

    $scope.save = function () {
        if ($scope.emailInvalid) {
            $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' Email is invalid.', showAllowClose: true });
            return;
        }

        var promises = [];
        var msg = args.isNew ? 'Adding ' : 'Saving ';
        var verb = args.isNew ? 'POST' : 'PUT';
        var urlSave = args.isNew ? '/Billing/Payees' : '/Billing/Payees/' + args.ids[0];


        promises.push($http({ method: verb, url: urlSave, data: $scope.payeeGeneral, trackerMsg: msg + 'Payee' }));

        if ($scope.current.viewSSNReason || $scope.current.updateSSN) {
            promises.push($http.put('/Billing/Payees/' + args.ids[0] + "/SSNTaxId", { SSN: $scope.payeeGeneral.ssN_TaxID, Reason: $scope.current.viewSSNReason }, { trackerMsg: 'Saving SSN/Tax ID' }));
        }

        $q.all(promises).then(function (results) {
            if (args.app) {
                var retUrl = '';
                if (args.app == apps.portfolioLists.name) {
                    retUrl = '/Billing/Payees/' + response.data.id;
                }
                $http.get(retUrl, { trackerMsg: 'Refreshing Payee' })
                    .then(function (innerResponse) {
                        editorHotKeys.destroy();
                        dialog.close(innerResponse.data);
                    });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        });
    };

    $scope.setFullName = function () {
        if (!$scope.payeeGeneral.first) $scope.payeeGeneral.first = '';
        if (!$scope.payeeGeneral.last) $scope.payeeGeneral.last = '';

        $scope.payeeGeneral.name = $scope.payeeGeneral.first + ' ' + $scope.payeeGeneral.last;
    };

    $scope.close = function (validate) {
        if (validate) {
            if (
                !angular.equals(payeeOriginal, $scope.payeeGeneral)
            ) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }

        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };

    $scope.invalidEmail = function (invalid) {
        $scope.emailInvalid = invalid;
    }

    $scope.setEmail = function (value) {
        $scope.payeeGeneral.email = value;
    }

    //endregion

    // region INITIALIZE
    $scope.current = {
        isNew: args.isNew,
        selectedTab: args.defaultTab,
        payeeId: args.isNew ? 0 : parseInt(args.ids[0]),
        payee: 'Payee',
        updateSSN: false,
        viewSSNReason: null
    };

    $scope.payeeGeneral = null;
    $scope.errors = [];
    init();
});

'use strict';

app.controller('AdjustmentTypeEditCtrl', function AdjustmentTypeEditCtrl($scope, $http, $oasRights, $dialog, $timeout, dialog, args) {
    // region PRIVATE VARIABLES
    var billAdjustmentGeneralOriginal = null,
        editorHotKeys;

    function init() {
        loadRights();
        buildMenu();
        loadHotKeys();
        $scope.loadTab(args.defaultTab);
    }

    function loadRights() {
        $scope.rightsBillAdjustmentTypes = $oasRights.forCode('BILLAUDIT');
    }

    function buildMenu() {
        $scope.menu = { categories: [] };

        $scope.menu.categories.push({ name: 'Bill Adjustment Type', children: [] });
        $scope.menu.categories[0].children.push({ name: 'General', active: false, code: 'billAdjustmentGeneral' });
    }

    function loadDataForSelectedTab() {
        switch ($scope.current.selectedTab) {
            case 'billAdjustmentGeneral':
                if ($scope.rightsBillAdjustmentTypes.canRead) {
                    loadAdjustmentType();
                }
                break;
        }
    }

    function loadAdjustmentType() {
        if ($scope.billAdjustmentGeneral === null) {
            if ($scope.current.billAdjustmentId != 0) {
                $http
                    .get('/Billing/AdjustmentTypes/' + $scope.current.billAdjustmentId, { trackerMsg: 'Loading bill adjustment type' })
                    .then(function (response) {
                        $scope.billAdjustmentGeneral = response.data;
                        billAdjustmentGeneralOriginal = angular.copy($scope.billAdjustmentGeneral);
                    });
            } else {
                $scope.billAdjustmentGeneral = {
                    id: 0,
                    sRegCode: '',
                    isPayable: false,
                    adjustmentType: '',
                    isDebit: true,
                    name: '',
                    isPayableAffect: true,
                    isNet: false,
                    isExcludedEU: false,
                };
            }
        }
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                { combo: 'ALT+S', command: $scope.save },
                {
                    combo: 'ALT+X',
                    command: function () {
                        $scope.close(true);
                    },
                },
            ]);
        });
    }

    // region PUBLIC METHODS
    //  region LOAD/CLOSE
    $scope.loadTab = function (child) {
        $scope.menu.categories.each(function (c) {
            c.children.each(function (ch) {
                ch.active = ch.code == child.code;
            });
        });

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab();
    };

    $scope.save = function () {
        var billAdjustmentGeneralToSave = angular.copy($scope.billAdjustmentGeneral);

        var args =
            $scope.current.billAdjustmentId > 0
                ? { method: 'PUT', id: $scope.current.billAdjustmentId, trackerMsg: 'Saving bill adjustment type ' + $scope.current.billAdjustmentId }
                : { method: 'POST', id: '', trackerMsg: 'Adding new bill adjustment type' };

        $http({ method: args.method, url: '/Billing/AdjustmentTypes/' + args.id, data: billAdjustmentGeneralToSave, trackerMsg: args.trackerMsg }).then(
            function (response) {
                editorHotKeys.destroy();
                dialog.close(response.data);
            }
        );
    };

    $scope.close = function (validate) {
        if (validate) {
            if (!angular.equals(billAdjustmentGeneralOriginal, $scope.billAdjustmentGeneral)) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };
    //endregion

    // region INITIALIZE
    $scope.current = {
        selectedTab: args.defaultTab,
        billAdjustmentId: args.isNew ? 0 : parseInt(args.ids[0]),
        billAdjustment: 'Bill Adjustment Type',
        cancelationAdjustments: false,
    };

    $scope.billAdjustmentGeneral = null;
    $scope.errors = [];
    init();
});

'use strict';

app.controller('FeeTypeEditCtrl', function FeeTypeEditCtrl($scope, $http, $oasRights, $dialog, $timeout, dialog, args) {
    // region PRIVATE VARIABLES
    var fsGeneralOriginal = null;
    var maxValueOfAllLevels = 0;
    var editorHotKeys;

    //region PRIVATE METHODS
    // region INIT/RIGHT/MENU/TABS
    function init() {
        loadRights();
        buildMenu();
        loadHotKeys();
        $scope.loadTab(args.defaultTab);
    }

    function loadRights() {
        $scope.rightsFeeType = $oasRights.forCode('FEESCHEDULES');

        $http.get('/Settings/EntityOptions/Database/0/code/ReducedTiers', { trackerMsg: 'Loading reduce tiers' }).then(function (response) {
            if (response.data) {
                $scope.current.isReducedTiers = response.data.value.toLowerCase() === 'true';
            }
        });
    }

    function buildMenu() {
        $scope.menu = { categories: [] };

        $scope.menu.categories.push({ name: $scope.current.feeOrPay, children: [] });
        $scope.menu.categories[0].children.push({ name: 'General', active: false, code: 'fsGeneral' });
    }

    function loadDataForSelectedTab() {
        switch ($scope.current.selectedTab) {
            case 'fsGeneral':
                if ($scope.rightsFeeType.canRead) {
                    loadFeeType();
                }
                break;
        }
    }

    function loadHotKeys() {
        editorHotKeys = new HotKeys();
        $timeout(function () {
            editorHotKeys.addActions([
                { combo: 'ALT+S', command: $scope.save },
                {
                    combo: 'ALT+X',
                    command: function () {
                        $scope.close(true);
                    },
                },
            ]);
        });
    }

    function loadFeeType() {
        if ($scope.fsGeneral === null) {
            if ($scope.current.fsId !== 0) {
                $http.get('/Billing/FeeType/' + $scope.current.fsId, { trackerMsg: 'Loading Fee' + ' Type' }).then(function (data) {
                    $scope.fsGeneral = data;
                });
            } else {
                $scope.fsGeneral = {};
            }
        }
    }
    //endregion

    //endregion

    // region PUBLIC METHODS
    //  region LOAD/CLOSE
    $scope.loadTab = function (child) {
        $scope.menu.categories.each(function (c) {
            c.children.each(function (ch) {
                ch.active = ch.code === child.code;
            });
        });

        $scope.current.selectedTab = child.code;

        loadDataForSelectedTab();
    };

    $scope.save = function () {
        var fsGeneralToSave = angular.copy($scope.fsGeneral);

        if ($scope.current.fsId === 0) {
            $http.post('/Billing/FeeType/', fsGeneralToSave, { trackerMsg: 'Adding Fee Type' }).then(function (data) {
                editorHotKeys.destroy();
                dialog.close(data);
            });
        } else {
            $http.put('/Billing/FeeType/' + $scope.current.fsId, fsGeneralToSave, { trackerMsg: 'Updating Fee Type' }).then(function (data) {
                editorHotKeys.destroy();
                dialog.close(data);
            });
        }
    };

    $scope.close = function (validate) {
        if (validate) {
            if (!angular.equals(fsGeneralOriginal, $scope.fsGeneral)) {
                $scope.errors.push({ type: 'error', title: 'Unsaved Changes! ', msg: ' There are unsaved changes that will be lost.', showAllowClose: true });
            } else {
                editorHotKeys.destroy();
                dialog.close(null);
            }
        } else {
            editorHotKeys.destroy();
            dialog.close(null);
        }
    };
    //  region STRUCTURE

    // region INITIALIZE
    $scope.current = {
        selectedTab: args.defaultTab,
        fsId: args.isNew ? 0 : parseInt(args.ids[0]),
        header: 'Fee Type',
    };

    $scope.fsGeneral = null;

    $scope.errors = [];

    init();
});

'use strict';

app.controller('ManagementFeesNotPostedCtrl', function ManagementFeesNotPostedCtrl($scope, $http, $oasRights, views, $dialog, $timeout) {
    // PRIVATE VARIABLES
    var clientId;
    var selectedTransaction;

    function init() {
        $scope.rightsBillAdjustmentTypes = $oasRights.forCode('POSTPAYMENTS');
    }

    //PUBLIC FUNCTIONS
    $scope.postSelected = function () {
        $dialog
            .dialog({ dialogClass: 'modal wide', templateUrl: 'mgmt-fee-post-batch.html', controller: 'ManagementFeePostBatchCtrl', clientId: clientId })
            .open()
            .then(function (result) {
                if (result) {
                    $http
                        .post('/Billing/PostManagementFees?batchNumber=' + result.batchNumber + '&billId=' + result.billId, selectedTransaction, {
                            trackerMsg: 'Posting transaction',
                        })
                        .then(function (response) {
                            $timeout(function () {
                                $scope.refreshGrid();
                            });
                        });
                }
            });
    };

    $scope.refreshGrid = function () {
        $timeout(function () {
            $scope.$broadcast('event:management-fees-not-posted-action', { action: 'refresh-grid' });
        });
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:management-fees-not-posted-action', { action: 'export-data' });
    };

    //INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];

    $scope.current = {
        view: views[0],
        url: '/Billing/ManagementFeesNotPosted',
        selectedId: null,
        startDate: Date.create('today').beginningOfMonth(),
        endDate: Date.create('today').endOfMonth(),
    };

    init();

    // EVENT LISTENERS
    $scope.$on('event:management-fees-not-posted-select', function (e, args) {
        if (args.length === 0) return;

        selectedTransaction = args[0];
        clientId = args[0].clientID;
    });
});

app.controller('ManagementFeePostBatchCtrl', function ManagementFeePostBatchCtrl($scope, $http, dialog) {
    function init() {
        $http.get('/Billing/Bills?clientId=' + $scope.current.clientId, { trackerMsg: 'Getting bill ids for household' }).then(function (response) {
            $scope.current.bills = response.data;
        });
    }

    $scope.post = function () {
        dialog.close($scope.current.params);
    };

    $scope.close = function () {
        dialog.close(null);
    };

    $scope.current = {
        params: {
            billId: null,
            batchNumber: '',
        },
        clientId: dialog.options.clientId,
        bills: [],
    };

    init();
});

'use strict';

app.controller('BillingLogCtrl', function BillingLogCtrl($scope, $http, $routeParams) {
    function init() {
        $scope.current.billId = $routeParams.billId;

        $http.get('/Billing/Bills/' + $scope.current.billId + '/Log', { trackerMsg: 'Getting billing log' }).then(function (response) {
            document.getElementById('billingLog').innerHTML = response.data.logText;
        });
    }

    $scope.runLog = function () {};

    $scope.current = {
        bills: [],
        log: null,
        billId: 0,
    };

    init();
});

'use strict';

app.controller(
    'PayoutDashboardCtrl',
    function PayoutDashboardCtrl($scope, $oasRights, views, $routeParams, $dialog, $timeout, apps, $portfolio, entities, $billing, $http) {
        // PRIVATE VARIABLES
        var rep = null,
            accountId = null,
            householdId = null;

        // PRIVATE METHODS
        function init() {
            $scope.deletePayoutDashboardPrivilege = $oasRights.canDelete("PAYOUTDASHBOARD") || $oasRights.canDelete("BUSINESSLINE");
            if (!$scope.current.isAdminOrRia) {
                $scope.current.entity = '4';
            }
            $http
                .get('/Settings/Database/EntityOptions/Code/69PAYOUTDA', { trackerMsg: 'Getting Payout Dashboard Start Date' })
                .then(function (response) {
                    if (response.data.value) {
                        $scope.current.payoutDashboardStartDate = new Date(response.data.value);
                    }
                })
                .finally(function () {
                    $scope.setDates('');
                });
        }

        function doAction(actionUrl, msgVerb, confirmMsg) {
            $dialog
                .confirmAction(confirmMsg)
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $http.put(actionUrl, $scope.selectedIds, { trackerMsg: msgVerb + ' credits and expenses' }).then(function () {
                            $scope.refreshGrid();
                        });
                    }
                });
        }

        // PUBLIC METHODS
        $scope.eventAndSidebarInterceptorRegistration = function (itemToListen) {
            //Intercepts sidebar events
            $scope.$watch(
                'current.view',
                function (newValue, oldValue, scope) {
                    $scope.current.sidebarTrigger = !$scope.current.sidebarTrigger;
                },
                true
            );
            $scope.$on(itemToListen, function (e, args) {
                if (args !== undefined) {
                    $scope.current.eventTrigger = !$scope.current.eventTrigger;
                    $scope.current.eventPayload = { itemToListen, args };
                }
            });
        };

        $scope.refreshGrid = function (headerData) {
            if ($scope.current.startDate < $scope.current.payoutDashboardStartDate) {
                $dialog
                    .actionFailed(
                        'Start date must not be before ' +
                            $scope.current.payoutDashboardStartDate.formatted() +
                            '.  This is set in the Payout Dashboard Start Date option in Firm Profile.'
                    )
                    .open();
                $scope.current.startDate = $scope.current.payoutDashboardStartDate;
                return;
            }
            if (headerData && headerData.payee) {
                if (headerData.payee === 'Total') {
                    $scope.current.payee = '';
                } else {
                    $scope.current.payee = headerData.payee;
                }
            }
            if (headerData && headerData.representative) {
                rep = headerData.representative;
            }

            if ($scope.current.payee === 'All') $scope.current.payee = '';

            $timeout(function () {
                $scope.$broadcast('event:payout-dashboard-action', { action: 'refresh-grid' });
                $scope.current.payee === null ? ($scope.current.payee = '') : $scope.current.payee;
            }, 0);
        };

        $scope.setDates = function (rangeName) {
            var sixMonthDate = Date.create('180 days ago');
            var payoutDashboardStartDate = Date.create($scope.current.payoutDashboardStartDate);
            var endDate = Date.create('today');
            var beginningOfMonth = Date.create('today').beginningOfMonth();

            if (!rangeName || rangeName === '') {
                if ($scope.current.payoutDashboardStartDate === null) {
                    if ($scope.current.status === 'total') {
                        var startDate = sixMonthDate;
                    } else if ($scope.current.status === 'Paid') {
                        var startDate = Date.create('today').beginningOfMonth();
                    } else {
                        var startDate = null;
                    }
                } else {
                    if ($scope.current.status === 'total') {
                        if (sixMonthDate.isBefore(payoutDashboardStartDate)) {
                            var startDate = payoutDashboardStartDate;
                        } else {
                            var startDate = sixMonthDate;
                        }
                    } else if ($scope.current.status === 'Paid') {
                        if (beginningOfMonth.isBefore(payoutDashboardStartDate)) {
                            var startDate = payoutDashboardStartDate;
                            if (endDate.isBefore(startDate)) {
                                endDate = endDate.endOfMonth();
                            }
                        } else {
                            var startDate = beginningOfMonth;
                        }
                    } else {
                        var startDate = payoutDashboardStartDate;
                    }
                }
            } else {
                var startDate = Date.create('today');

                switch (rangeName) {
                    case 'MTD':
                        startDate.beginningOfMonth();
                        break;
                    case 'QTD':
                        startDate = startDate.getStartOfQuarter();
                        break;
                    case 'YTD':
                        startDate.beginningOfYear();
                        break;
                }
            }

            $scope.current.startDate = startDate;
            $scope.current.endDate = endDate;
        };

        $scope.createCreditExpenses = function () {
            $dialog
                .dialog({ templateUrl: 'payout-credit-and-expenses-add.html', controller: 'PayoutCreditAndExpensesAddCtrl', representative: rep })
                .open()
                .then(function (result) {
                    $scope.current.submitted = false;
                    if (result) {
                        $scope.refreshGrid(null);
                    }
                });
        };

        $scope.editEntity = function (entity) {
            if (entity === entities.client.name) {
                $portfolio.openEditor(entities.client.value, [householdId], null, null, apps.billingAudit.name, null).then(function (rst) {});
            } else if (entity === entities.registration.name) {
                $portfolio.openEditor(entities.registration.value, householdId, null, null, apps.billingAudit.name, null).then(function (rst) {});
            }
        };

        $scope.goToLower = function (urlLevel) {
            $portfolio.goTo(urlLevel, entities.client.value, householdId, { source: 'pd' });
        };

        $scope.runAdvisoryFeeReport = function () {
            $billing.runAdvisoryFeeReport(entities.client.value, householdId);
        };

        $scope.exportToExcel = function () {
            $scope.$broadcast('event:payout-dashboard-action', { action: 'export-data' });
        };

        $scope.deleteCredAndExpenses = function () {
            doAction('/Billing/PayoutDashboard/action/delete', 'Deleting', 'Delete credits and expenses.  Are you sure you want to proceed?');
        };

        // INITIALIZE
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.deletePayoutDashboardPrivilege = false;

        $scope.current = {
            submitted: false,
            view: views[0],
            URL: '/Billing/PayoutDashboard',
            filterType: 'Approved',
            entity: '4',
            status: $routeParams.status === undefined ? 'payoutdashboardlanding' : $routeParams.status,
            isAdminOrRia: ['Administrator', 'Advisor'].any($scope.user.authorization.entity),
            amount: 0,
            startDate: null,
            endDate: Date.create('today'),
            payee: 0,
            enableCreditExpensesAdd: ['Administrator', 'Advisor'].any($scope.user.authorization.entity) && $routeParams.status === 'creditandexpenses',
            payoutDashboardStartDate: null,
            //Ag-Grid Related Items
            sidebarTrigger: true, //Flip-flops to trigger ngOnChanges in ng2Components
            eventTrigger: true, //Flip-flops to trigger ngOnChanges in ng2Components
            eventPayload: {}, //Payload of captured events
            eventsToWatch: '', //List of items to watch
        };

        init();

        // EVENT LISTENERS
        $scope.$on('slickgrid-data-loaded', function (event, data) {
            $scope.current.amount = data.sum('changeAmount');
        });

        $scope.$on('event:payout-dashboard-action-select', function (e, args) {
            if (args.length === 0 || args.length > 1) return;

            accountId = args[0].accountId;
            householdId = args[0].clientId;
        });
    }
);

app.controller('PayoutCreditAndExpensesAddCtrl', function PayoutCreditAndExpensesAddCtrl($scope, dialog, $http) {
    function loadAdjustmentTypes() {
        if ($scope.adjustmentTypes) return;

        $http.get('/Billing/AdjustmentTypes?isPayable=false&ispayableAffect=true', { trackerMsg: 'Loading adjustment types' }).then(function (response) {
            $scope.adjustmentTypes = response.data;
        });
    }

    function loadAllPayees() {
        if ($scope.payees) return;

        $http.get('/Billing/BillingEntities?isActive=true', { trackerMsg: 'Loading rep payees' }).then(function (response) {
            $scope.payees = response.data;
        });
    }

    function init() {
        loadAdjustmentTypes();
        loadAllPayees();
    }

    $scope.current = {
        selectedRep: dialog.options.representative,
        amount: 100,
        adjustDate: Date.create('today'),
        adjustmentType: 0,
        isCredit: 1,
        showSearch: 1,
        searchEntity: 'representative',
        selectedSubAdvisor: null,
    };
    $scope.changeSign = function () {
        $scope.current.adjustmentType = 0; //Reset to placeholder value
        if ($scope.current.isCredit === 1) {
            //if you change Adjustment types, change the sign for better UI
            $scope.current.amount = Math.abs($scope.current.amount);
        } else if ($scope.current.isCredit === 2) {
            $scope.current.amount = -Math.abs($scope.current.amount);
        }
    };
    $scope.changePayee = function () {
        if ($scope.current.payee === 2 || $scope.current.payee === 4 || $scope.current.payee === 9) {
            $scope.current.showSearch = 1;
        } else {
            $scope.current.showSearch = 0;
        }
        $scope.current.selectedRep = null;
        $scope.current.selectedSubAdvisor = null;
        switch ($scope.current.payee) {
            case 4:
                $scope.current.searchEntity = 'brokerdealer';
                break;
            case 9:
                $scope.current.searchEntity = 'subadvisor';
                break;
            default:
                $scope.current.searchEntity = 'representative';
                break;
        }
    };

    function createPayload() {
        switch ($scope.current.payee) {
            case 2:
                if ($scope.current.selectedRep != null) {
                    return {
                        repName: $scope.current.selectedRep.name,
                        repNumber: $scope.current.selectedRep.id,
                        calculatedDate: $scope.current.adjustDate.formatted(),
                        changeAmount: $scope.current.amount,
                        notes: '',
                        expenseType: $scope.current.isCredit,
                        adjustmentType: $scope.current.adjustmentType,
                        billentityid: $scope.current.payee ?? 2, //default rep
                    };
                } else {
                    alert('Please select a valid Representative');
                }
                break;
            case 4:
                if ($scope.current.selectedRep?.id > 0) {
                    return {
                        repName: $scope.current.selectedRep.name,
                        repNumber: $scope.current.selectedRep.id,
                        calculatedDate: $scope.current.adjustDate.formatted(),
                        changeAmount: $scope.current.amount,
                        notes: '',
                        expenseType: $scope.current.isCredit,
                        adjustmentType: $scope.current.adjustmentType,
                        billentityid: $scope.current.payee ?? 2,
                    };
                } else {
                    alert('Please select a valid BrokerDealer');
                }
                break;
            case 9:
                if ($scope.current.selectedSubAdvisor?.id > 0) {
                    return {
                        repName: $scope.current.selectedSubAdvisor.name,
                        repNumber: $scope.current.selectedSubAdvisor.id,
                        calculatedDate: $scope.current.adjustDate.formatted(),
                        changeAmount: $scope.current.amount,
                        notes: '',
                        expenseType: $scope.current.isCredit,
                        adjustmentType: $scope.current.adjustmentType,
                        billentityid: $scope.current.payee ?? 2, //default rep
                    };
                } else {
                    alert('Please select a valid SubAdvisor');
                }
                break;
            default:
                if ($scope.current.payee != undefined && $scope.current.payee > 0)
                    return {
                        repName: '',
                        repNumber: 0,
                        calculatedDate: $scope.current.adjustDate.formatted(),
                        changeAmount: $scope.current.amount,
                        notes: '',
                        expenseType: $scope.current.isCredit,
                        adjustmentType: $scope.current.adjustmentType,
                        billentityid: $scope.current.payee ?? 2, //default rep
                    };
                else {
                    alert('Please select a BillEntity');
                }
        }
    }

    $scope.addCreditExpenses = function () {
        var payload = createPayload();
        if (payload != undefined) {
            $scope.current.submitted = true;
            $http.post('/Billing/PayoutDashboard/CreateExpense', payload, { trackerMsg: 'Saving new credit and expenses' }).then(function (response) {
                dialog.close(response.data);
            });
        }
    };

    $scope.close = function () {
        dialog.close(null);
    };

    init();
});

'use strict';

app.controller('PayoutEntitiesCtrl', function PayoutEntitiesCtrl($scope, $http, views, $oasRights, $dialog, $timeout, API_CONFIG) {
    //PRIVATE FUNCTIONS
    function init() {
        $http.get('/Settings/Database/EntityOptions/Code/69PAYOUTDA', { trackerMsg: 'Getting Payout Dashboard Start Date' }).then(function (response) {
            if (response.data.value) {
                $scope.current.payoutDashboardStartDate = new Date(response.data.value);
                if ($scope.current.payoutDashboardStartDate) {
                    $scope.current.startDate = $scope.current.payoutDashboardStartDate;
                }
            } else {
                $scope.current.startDate = null;
            }
        });

        $http.get('/Billing/BillingEntities?isActive=true', { trackerMsg: 'Loading all payees' }).then(function (response) {
            $scope.current.payees = response.data;
            if ($scope.current.sectionInfo !== undefined) {
                $scope.current.payees.unshift('All');
                $scope.payee = 'All';
            }
        });

        $http.get('/Billing/PayoutDashboard/Payment/PaymentProcessing', { trackerMsg: 'check any payment in process still' }).then(function (response) {
            $scope.current.processingPayment = response.data;
            $scope.current.isVerified = true;
            if (response.data)
                $dialog
                    .messageBox('Payments Processing', 'There is already a payment process running.  Please wait until it has finished and reload data.')
                    .open();
        });

        showDetailedPayeeReport();
        // Admin check
        if ($scope.user.authorization.entity == 'Administrator') {
            $scope.current.isAdmin = true;
        }
    }

    //PUBLIC FUNCTIONS
    $scope.exportToExcel = function () {
        $scope.$broadcast('event:payout-entities-action', { action: 'export-data' });
    };

    $scope.createNew = function () {
        if ($scope.current.payee === 'All') {
            $scope.current.payee = '';
        }
        var startDate = $scope.current.startDate !== null ? $scope.current.startDate.formatted() : null;
        var endDate = $scope.current.endDate !== null ? $scope.current.endDate.formatted() : null;

        $http
            .post('/Billing/PayoutDashboard/Payment/New?startDate=' + startDate + '&endDate=' + endDate, $scope.current.payees, {
                trackerMsg: 'Loading new payment data',
            })
            .then(function (res) {
                $scope.paymentsData = res.data;

                $dialog
                    .dialog({
                        templateUrl: 'payout-entities-add-payment.html',
                        controller: 'PayoutEntitiesAddPaymentCtrl',
                        paymentsData: $scope.paymentsData,
                        startDate: startDate,
                        endDate: endDate,
                    })
                    .open()
                    .then(function (result) {
                        if (result != null) {
                            if (result !== '') $scope.refreshGrid();
                        } else {
                            $dialog
                                .messageBox(
                                    'Payments Processing',
                                    'There is already a payment process running.  Please wait until it has finished and reload data.'
                                )
                                .open();
                        }
                    });
            });
    };

    $scope.generateReport = function () {
        let id = $scope.current.selectedIdForExcelReport;
        let urlToGet = '/Billing/PayoutDashboard/Payment/' + id.toString() + '/Action/Report';
        $http.get(urlToGet).then(function () {
            window.location.href = API_CONFIG.baseUrl + urlToGet + '?Authorization=' + sessionStorage.oas_token;
        });
    };

    $scope.generateDetailedReport = function () {
        let blobId = $scope.current.selectedBlobId;

        if (!blobId) return;

        let urlToGet = '/Billing/PayoutDashboard/Reports' + '/' + blobId;

        $http.get(urlToGet).then(function () {
            window.location.href = API_CONFIG.baseUrl + urlToGet + '?Authorization=' + sessionStorage.oas_token;
        });
    };

    $scope.generateAdvReport = function () {
        $http
            .post('/Billing/PayoutDashboard/Payment/GenerateReport', $scope.selectedIds, { trackerMsg: 'Generating a payment report' })
            .then(function (response) {
                if (response.data.length > 0) {
                    $dialog
                        .messageBox(
                            "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i>Advisory Fee Report",
                            'Report has already been created.'
                        )
                        .open();
                }
            });
    };

    $scope.deletePayment = function () {
        let id = $scope.current.selectedIdForExcelReport;

        $dialog
            .confirmAction(
                'This will undo all payable adjustments for this payment.  All payable items will move back to currently approved.  Any Advisory Fee Reports generated for this payment will be deleted. <b>' +
                    'Are you sure?' +
                    '</b>'
            )
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    // Call the new endpoint
                    $http
                        .post('/Billing/PayoutDashboard/Payment/DeletePayables?paymentId=' + id.toString() + '', id, { trackerMsg: 'Deleting Payment' })
                        .then(function (res) {
                            // the result gets put here
                            $scope.refreshGrid();
                        });
                } else {
                    return;
                }
            });
    };

    $scope.refreshGrid = function (headerData) {
        if ($scope.current.startDate < $scope.current.payoutDashboardStartDate) {
            $dialog
                .actionFailed(
                    'Start date must not be before ' +
                        $scope.current.payoutDashboardStartDate.formatted() +
                        '.  This is set in the Payout Dashboard Start Date option in Firm Profile.'
                )
                .open();
            $scope.current.startDate = $scope.current.payoutDashboardStartDate;
            return;
        }

        if (headerData && headerData.payee) {
            if (headerData.payee === 'Total') {
                $scope.current.payee = '';
            } else {
                $scope.current.payee = headerData.payee;
            }
        }

        $timeout(function () {
            $scope.$broadcast('event:payout-entities-action', { action: 'refresh-grid' });
        }, 0);
    };

    //EVENT LISTENERS
    $scope.$on('event:payout-entities-action-select', function (e, args) {
        if (args.length === 1) {
            $scope.current.selectedIdForExcelReport = args[0].id;
            $scope.current.selectedBlobId = args[0].blobId;
            $scope.current.selectedPayeeId = args[0].payeeId;
        } else {
            $scope.current.selectedIdForExcelReport = 0;
        }
    });

    function showDetailedPayeeReport() {
        $http.get('/Settings/Database/EntityOptions/Code/PayeeReportDetailed').then(function (response) {
            $scope.current.detailedPayeeReport = response.data.value === 'True';
        });
    }

    //INITIALIZE
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {
        view: views[0],
        URL: '/Billing/PayoutDashboard/Payment/List',
        startDate: Date.create('today').beginningOfMonth(),
        endDate: Date.create('today').endOfMonth(),
        entity: '4',
        payee: '',
        selectedIdForExcelReport: 0,
        selectedBlobId: 0,
        payoutDashboardStartDate: null,
        detailedPayeeReport: false,
        isAdmin: false,
        mostRecentPayment: 0,
    };

    init();
});

app.controller('PayoutEntitiesAddPaymentCtrl', function PayoutEntitiesAddPaymentCtrl($scope, dialog, $http, $window, $location) {
    $scope.paymentsData = dialog.options.paymentsData;
    $scope.asOfDate = Date.create('today').format('{MM}/{dd}/{yyyy}');
    $scope.notes = '';

    $scope.updateTotal = function () {
        $scope.paymentsData.totalPaymentAmount = $scope.paymentsData.paymentAmount + $scope.paymentsData.adjustmentAmount;
    };

    $scope.totalPaymentsAmount = function () {
        var toReturn = 0;
        $scope.paymentsData.forEach((payment) => {
            if (payment.toPay) {
                toReturn += payment.paymentAmount;
                toReturn += payment.adjustmentAmount;
            }
        });
        return toReturn;
    };
    $scope.disabledRow = function (payment) {
        if (payment.toPay) {
            return {
                color: 'black',
            };
        } else {
            return {
                color: 'Gainsboro',
            };
        }
    };

    $scope.createNewPayment = function () {
        //The textbox and the datepicker modify all payments' properties
        $scope.current.processingPayment = true;
        $scope.paymentsData.forEach((paymentData) => {
            paymentData.note = $scope.notes;
            paymentData.asOfDate = $scope.asOfDate;
        });

        var startDate = dialog.options.startDate,
            endDate = dialog.options.endDate;

        $http
            .post('/Billing/PayoutDashboard/Payment/MultiplePayments?startDate=' + startDate + '&endDate=' + endDate, $scope.paymentsData, {
                trackerMsg: 'Saving new payment',
            })
            .then(function (response) {
                dialog.close(response.data);
            });
    };

    $scope.close = function () {
        dialog.close('');
    };

    $scope.openCurrentlyApproved = function () {
        $window.open('#/billing/payout/dashboard/currentlyApproved', '_blank');
    };

    $scope.current = {
        processingPayment: false,
        isVerified: false,
    };
});

'use strict';

app.controller('PayoutAdvisoryFeeReportsCtrl', function PayoutAdvisoryFeeReportsCtrl($scope, $http, entities, API_CONFIG, $document, $route) {
    //PRIVATE METHODS
    function init() {
        var loadForUser = function () {
            $scope.entities.selected = { id: $scope.user.authorization.entityId };
            $scope.loadDocuments();
        };

        if (['Administrator', 'Advisor'].any($scope.user.authorization.entity)) {
            $scope.entityTypes.show = true;
            $scope.loadEntities();
        } else {
            var entity = entities[entities.find({ name: $scope.user.authorization.entity })];
            if ($scope.entityTypes.list.any(entity)) {
                $scope.entityTypes.selected = entity;
                loadForUser();
            }
        }
        CreateToastTimer();
    }

    function getDocumentsUrl(document) {
        var docEntityId = $scope.user.authorization.parentEntityId != null ? $scope.user.authorization.parentEntityId : $scope.entities.selected.id;
        if (document) {
            if (document.representativeId) {
                docEntityId = document.representativeId;
            } else if (document.brokerDealerId) {
                docEntityId = document.brokerDealerId;
            } else if (document.subAdvisorId) {
                docEntityId = document.subAdvisorId;
            }
        }

        var url = '/Billing/PayoutDashboard/Reports/List';

        if ($scope.entityTypes.selected.name !== 'All') {
            url +=
                '?entity=' +
                $scope.entityTypes.selected.name +
                '&entityId=' +
                docEntityId +
                '&showBDRepReport=' +
                ($scope.user.authorization.parentEntityId != null);
        }

        if (document) {
            return '/Billing/PayoutDashboard/Reports';
        } else {
            return url;
        }
    }

    //PUBLIC METHODS
    $scope.loadEntities = function () {
        $http.get($scope.entityTypes.selected.simpleUrl, { cache: true, trackerMsg: 'Loading entities' }).then(function (response) {
            $scope.entities.list = response.data;
            if ($scope.entities.list.length) {
                $scope.entities.selected = $scope.entities.list[0];
                $scope.loadDocuments();
            } else {
                $scope.entities.selected = null;
                $scope.documents = [];
            }
        });
    };

    $scope.loadDocuments = function () {
        $scope.current.getHangfireProgress = true;
        $http.get(getDocumentsUrl(), { trackerMsg: 'Loading documents' }).then(function (response) {
            response.data.forEach(function (document) {
                document.createdDate = Date.create(document.createdDate);
            });
            $scope.documents = response.data.sortBy('createdDate', true);
            $scope.current.getHangfireProgress = false;
        });
    };

    $scope.downloadDocument = function (document) {
        var documentsUrl = document ? getDocumentsUrl(document) : getDocumentsUrl();
        window.location.href = API_CONFIG.baseUrl + documentsUrl + '/' + document.id + '?Authorization=' + sessionStorage.oas_token;
    };

    function CreateToastTimer() {
        var interval = setInterval(function () {
            if ($scope.current.getHangfireProgress) {
                $http.get('/Billing/PayoutDashboard/Payment/GetHangFireProgressById').then(function (response) {
                    var controllerName = $route.current.$$route.controller;
                    var toast = $document[0].querySelector('oat-toast');

                    if (controllerName != 'PayoutAdvisoryFeeReportsCtrl') {
                        clearInterval(interval); //prevent multiple interval to be called when switching tabs
                        //will create multiple toast
                        toast.close();
                    }

                    if (!response || (!response.data && !$scope.current.currentPercentage) || !controllerName) {
                        $scope.current.getHangfireProgress = false;
                        return;
                    }

                    if (!$scope.current.toastObj && controllerName === 'PayoutAdvisoryFeeReportsCtrl') {
                        $scope.current.toastObj = toast.addToast({ icon: 'fa-info-circle', percent: 0, message: 'Generating Advisory Fee Reports' });
                    }

                    if (!response.data && $scope.current.currentPercentage > 0) {
                        $scope.current.currentPercentage = 100;
                    } else {
                        $scope.current.currentPercentage = response.data.progress;
                    }

                    if ($scope.current.toastObj && $scope.current.currentPercentage) {
                        toast.update($scope.current.toastObj, 'percent', $scope.current.currentPercentage);
                        if ($scope.current.currentPercentage == 100 && !response.data) {
                            //reset data
                            $scope.current.toastObj = '';
                            $scope.current.currentPercentage = 0;
                            $scope.current.hangfireID = '';
                            $scope.current.getHangfireProgress = false;
                        }
                    }
                });
            }
        }, 3000);
    }

    //INITIALIZE
    $scope.entityTypes = {
        list: [
            entities.subAdvisor,
            entities.brokerDealer,
            entities.representative,
            { name: 'All', abbr: 'All', simpleUrl: '/Billing/PayoutDashboard/Reports/List', value: null },
        ],
        selected: entities.brokerDealer,
        show: false,
    };

    $scope.entities = {
        list: null,
        selected: null,
    };

    $scope.current = {
        resetToast: false,
        toastObj: null,
        currentPercentage: 0,
        hangfireId: '',
        getHangfireProgress: true,
    };

    init();
});

app.component('oasPayoutHeader', {
    bindings: { entity: '<', section: '<', databaseName: '<', amount: '=', payee: '=', changeEvent: '&', showAmount: '=?', dropdown: '=' },
    templateUrl: 'billing/directives/oasPayoutHeader.html',
    controller: function ($http) {
        //PRIVATE VARIABLES
        var $ctrl = this;

        $ctrl.$onInit = function () {
            $ctrl.current.sectionInfo = {
                total: { color: '#70ad47', text: 'Total Commission' },
                Paid: { color: '#4472C4', text: 'Paid Commission' },
                currentlyApproved: { color: '#ed7d31', text: 'Approved' },
                pendingApproval: { color: '#c00000', text: 'Pending Approval' },
                creditandexpenses: { color: '#ffc000', text: 'Credit and Expenses' },
            }[$ctrl.section];
            $ctrl.current.payee = $ctrl.payee;
            $ctrl.current.showDropdown = $ctrl.dropdown;

            if ($ctrl.entity === '4') {
                $http
                    .get('/Billing/BillingEntities?isActive=true', { trackerMsg: 'Getting all payees.' })
                    .then(function (response) {
                        $ctrl.current.payees = response.data;
                        if ($ctrl.current.sectionInfo !== undefined) {
                            $ctrl.current.payees.unshift({ name: 'All', id: null });
                        }
                    })
                    .finally(function () {
                        $ctrl.payee = { name: 'All', id: null };
                    });
            }
        };

        $ctrl.current = {
            showDropdown: true,
            sectionColor: '',
            databaseName: '',
            selectedRep: null,
            payees: [],
        };

        $ctrl.ddChange = function (selectedItem) {
            $ctrl.changeEvent({ headerData: { payee: $ctrl.payee, representative: selectedItem } });
        };
    },
});

'use strict';

app.controller('BillingFeeHierarchyListCtrl', function BillingFeeHierarchyListCtrl($scope, $http, $oasRights, $q, $dialog) {
    var isNewCustodian = false;
    var previousNode = null;
    var isDifferentNode = false;
    var selectedEntityName = '';
    // PRIVATE METHODS
    function init() {
        $http.get('/Billing/Hierarchy/TopLevel', { trackerMsg: 'Getting entity tree' }).then(function (response) {
            buildEntityTree(response.data);
            loadProductTypes();
        });
    }

    $scope.loadPayoutRates = function (billEntity, $index) {
        $scope.feeHierarchy.feeHierarchyDetails[$index].billEntityId = billEntity;
        if ($scope.validateScheduleForPayout($index)) {
            return;
        }

        $http.get('/Billing/Schedules/Simple?billEntity=' + billEntity, { trackerMsg: 'Loading payable rates' }).then(function (response) {
            $scope.payoutRates[$index] = response.data;
        });
    };

    function buildEntityTree(data) {
        $scope.entitySelector.push({ label: 'Default Fees', id: -1000, collapsed: false, selected: false, children: [], name: 'Default Fees' });

        var defaultFees = $scope.entitySelector[0];

        data.forEach(function (node) {
            var entity = $scope.hierarchyLevels.find({ name: node.level });

            if (!entity) {
                return;
            }

            if (node.entity === 'Global' && node.memberCount > 0) {
                $scope.current.hasGlobalData = true;
            }
            {
                defaultFees.children.push({
                    label: entity.friendlyName + '(' + node.memberCount + ')',
                    id: entity.id,
                    isParent: true,
                    icon: getIcon(entity.level),
                    collapsed: true,
                    selected: false,
                    children: [],
                    name: node.level,
                    entityCount: node.memberCount,
                    isLoaded: false,
                });
            }
        });

        $scope.current.selectedNode = $scope.entitySelector[0];
        $scope.entitySelector.selectedEntity = $scope.entitySelector[0];
        previousNode = null;
        $scope.openEntity($scope.current.selectedNode);
    }

    function getIcon(level) {
        var icon = '';

        switch (level) {
            case 0:
                icon = 'fa fa-globe';
                break;
            case 1:
                icon = 'fa fa-orion-broker-dealer';
                break;
            case 2:
                icon = 'fa fa-orion-app';
                break;
            case 3:
                icon = 'fa fa-orion-representative';
                break;
            case 4:
                icon = 'fa fa-orion-401k-plan';
                break;
            case 5:
                icon = 'fa-orion-user-management';
                break;
            case 6:
                icon = 'fa fa-orion-household';
                break;
            case 7:
                icon = 'fa fa-orion-registration';
                break;
            case 8:
                icon = 'fa fa-orion-subadvisor';
                break;
            case 9:
                icon = 'fa fa-orion-modelagg';
                break;
            case 10:
                icon = 'fa fa-orion-account';
                break;
            default:
                break;
        }

        return icon;
    }

    function getHierarchyData(entityId) {
        if (entityId > 0) {
            var promises = [];

            promises.push(
                $http.get('/Billing/Hierarchy/CustodianCount?entityEnum=' + $scope.current.entityLevel + '&entityId=' + entityId, {
                    trackerMsg: 'Getting custodian count for entity',
                })
            );
            promises.push(
                $http.get(
                    '/Billing/Hierarchy/Verbose?entityEnum=' +
                        $scope.current.entityLevel +
                        '&entityId=' +
                        entityId +
                        '&custodianId=' +
                        $scope.current.custodianId,
                    { trackerMsg: 'Getting fee hierarchy data' }
                )
            );

            $q.all(promises).then(function (response) {
                resetProperties(false);
                $scope.feeEntityDetailCount = response[0].data;
                $scope.custodianList = $scope.feeEntityDetailCount.map('custodianId');

                $scope.feeHierarchy = response[1].data;

                var entityEnum = $scope.hierarchyLevels.find({ id: $scope.current.entityLevel });

                if ($scope.feeHierarchy) {
                    $scope.feeHierarchy.feeHierarchyDetails.forEach(function (detail) {
                        detail['useAssetLevel'] = detail.productType ? true : false;
                    });
                } else {
                    getDefaultEntityObject(entityEnum.id, entityId, $scope.current.custodianId, false);
                }
            });
        } else {
            $http
                .get('/Billing/Hierarchy/Verbose?entityEnum=' + $scope.current.entityLevel + '&entityId=' + 0 + '&custodianId=' + $scope.current.custodianId, {
                    trackerMsg: 'Getting fee hierarchy data',
                })
                .then(function (response) {
                    $scope.feeHierarchy = response.data;

                    if ($scope.feeHierarchy === null) {
                        getDefaultEntityObject($scope.current.entityLevel, 0, $scope.current.custodianId, false);
                    }
                    if ($scope.current.entityLevel === 125) {
                        $http
                            .get('/Billing/Hierarchy/CustodianCount?entityEnum=' + $scope.current.entityLevel + '&entityId=' + entityId, {
                                trackerMsg: 'Getting custodian count for entity',
                            })
                            .then(function (response) {
                                $scope.feeEntityDetailCount = response.data;
                                $scope.custodianList = $scope.feeEntityDetailCount.map('custodianId');
                            });
                    }
                });
        }
    }

    function getDefaultEntityObject(entityEnum, entityId, custodianId, addChildNode) {
        var url = '/Billing/Hierarchy/Default?entityEnum=' + entityEnum + '&entityId=' + entityId;

        if (custodianId !== null) {
            url += '&custodianId=' + custodianId;
        }

        $http.get(url, { trackerMsg: 'Getting default fee hierarchy object' }).then(function (response) {
            $scope.feeHierarchy = response.data;
            var entEnum = $scope.current.selectedNode.id;

            $scope.feeHierarchy.name = selectedEntityName === '' ? $scope.current.selectedNode.name : selectedEntityName;
            $scope.feeHierarchy.isNew = true;

            if ($scope.current.isNew && entityEnum === 125) {
                $scope.feeHierarchy.name = 'Global';
                entEnum = entityEnum;
                $scope.current.selectedNode.isNew = true;
                return;
            }

            var label = $scope.feeHierarchy.name;

            if (!addChildNode) {
                return;
            }

            var newEntity = { label: label, id: entityId, isNew: true, collapse: false, icon: getIcon(7), isChild: true, entityEnum: entEnum, selected: true };
            newEntity.parentNode = $scope.current.selectedNode;

            $scope.current.entityLevel = newEntity.entityEnum;

            if ($scope.current.selectedNode.children === undefined) {
                return;
            }

            $scope.current.selectedNode.children.push(newEntity);

            newEntity = $scope.current.selectedNode.children.find({ id: newEntity.id });
            $scope.current.selectedNode = previousNode = newEntity;
        });
    }

    function loadProductTypes() {
        if ($scope.productTypes.length > 0) {
            return;
        }

        $http.get('/Portfolio/ProductTypes/Simple', { trackerMsg: 'Load product types' }).then(function (response) {
            $scope.productTypes = response.data;
        });
    }

    function resetProperties(resetTree) {
        if (!isNewCustodian) {
            $scope.current.custodianId = null;
        }

        $scope.feeEntityDetailCount = null;
        $scope.custodianList = [];

        if (resetTree) {
            $scope.entitySelector.length = 0;
            $scope.current.selectedNode.selected = $scope.current.selectedNode.parentNode;
            $scope.current.selectedNode.collapsed = true;
            $scope.current.hasGlobalData = false;
        }
    }

    // PUBLIC METHODS
    $scope.addPayout = function (billingLevel) {
        if ($scope.current.selectedNode.label === 'Global') {
            $scope.current.entityLevel = 125;
        }

        if (billingLevel === 'assetLevel') {
            loadProductTypes();
            $scope.feeHierarchy.feeHierarchyDetails.push({
                id: 0,
                billEntityId: 0,
                billEntityName: '',
                productType: '',
                billScheduleId: null,
                status: true,
                type: 'FeeHierarchyAssetLevel',
                useAssetLevel: true,
                sleeveType: null,
            });
        } else if (billingLevel === 'sleeveLevel') {
            $scope.feeHierarchy.feeHierarchyDetails.push({
                id: 0,
                billEntityId: 0,
                billEntityName: '',
                productType: null,
                billScheduleId: null,
                status: true,
                type: 'FeeHierarchySleeveLevel',
                useAssetLevel: false,
                sleeveType: 2,
            });
        } else {
            $scope.feeHierarchy.feeHierarchyDetails.push({
                id: 0,
                billEntityId: 0,
                billEntityName: '',
                productType: null,
                billScheduleId: null,
                status: true,
                type: 'FeeHierarchy',
                useAssetLevel: false,
                sleeveType: null,
            });
        }
    };

    $scope.deletePayout = function (payout) {
        $scope.feeHierarchy.feeHierarchyDetails.remove(payout);
    };

    $scope.openEntity = function (entity) {
        $scope.current.isNew = false;
        $scope.current.selectedEntity = null;

        // Get children
        if (entity.isChild) {
            if ($scope.current.selectedNode.isNew && entity !== previousNode) {
                $dialog
                    .confirmAction('Changes to new entity will be discarded?')
                    .open()
                    .then(function (result) {
                        if (result === 'yes') {
                            var parentNode = $scope.current.selectedNode.parentNode;
                            parentNode.children.remove($scope.current.selectedNode);

                            $scope.current.selectedNode = parentNode.children[0];
                            previousNode = entity;
                            resetProperties(false);
                            $scope.openEntity(entity);
                        }
                    });
            } else {
                if (entity.parentNode !== previousNode.parentNode) {
                    isDifferentNode = true;
                    $scope.current.custodianId = null;
                } else {
                    isDifferentNode = false;
                }

                $scope.current.entityLevel = entity.entityEnum;
                $scope.current.selectedNode = entity;
                getHierarchyData(entity.id);

                previousNode = entity;
            }
        } else {
            $scope.current.entityLevel = null;
            $scope.current.selectedNode = entity;

            previousNode = entity;

            if (entity.entityCount > 20) {
                return;
            }

            if (entity.children.length === 0 && entity.entityCount > 0 && entity.isLoaded === false) {
                $http.get('/Billing/Hierarchy/MidLevel?entity=' + entity.name, { trackerMsg: 'Getting entity children' }).then(function (response) {
                    entity.isLoaded = true;
                    var entityChildren = response.data;
                    entityChildren.forEach(function (child) {
                        child = {
                            label: child.name,
                            name: child.name,
                            id: child.entityId,
                            icon: getIcon(7),
                            parentNode: entity,
                            isChild: true,
                            isNew: false,
                            entityEnum: entity.id,
                        };
                        $scope.entitySelector.selectedEntity.children.push(child);
                    });
                });
            }
        }
    };

    $scope.addPayoutRate = function (currentNode) {
        $scope.current.isNew = true;
        $scope.current.parentNode = currentNode;

        $scope.current.entityLevel = $scope.current.selectedNode.id;

        let friendlyName = $scope.hierarchyLevels.find((x) => x.id == $scope.current.selectedNode.id).friendlyName;

        if (friendlyName) {
            $scope.current.selectedNode.name = friendlyName;
        }

        if ($scope.current.selectedNode.name === 'Global') {
            $scope.current.entityLevel = 125;

            getDefaultEntityObject(125, 0, null, false);
        }
    };

    $scope.importFeeHierarchy = function () {
        $dialog
            .dialog({
                dialogClass: 'modal medium',
                templateUrl: 'app/modals/upload-file.html',
                controller: 'UploadFileCtrl',
                title: 'Import Fee Hierarchy',
                idField: 'entityId',
                downloadUrl: '/Billing/ValidateImport/FeeHierarchy/Templates/',
                validateUrl: '/Billing/ValidateImport/FeeHierarchy',
                commitVerb: 'PUT',
                commitUrl: '/Billing/ValidateImport/FeeHierarchy/Import',
            })
            .open();
    };

    $scope.searchEntity = function (entity) {
        $scope.current.searchModeEngage = true;
        $dialog
            .inputBox('Search Name', 'Enter a name to search')
            .open()
            .then(function (result) {
                if (result) {
                    $http.get('/Billing/Hierarchy/Search?search=' + result).then(function (response) {
                        $scope.entitySelector.length = 0;
                        $scope.current.entityLevel = null;
                        var entityCount = [];
                        var entityGroup = [];

                        entityGroup = response.data.groupBy(function (d) {
                            return d.entity;
                        });

                        Object.each(entityGroup, function (key, val) {
                            if (key === 'Sub-advisor') {
                                key = 'Sub Advisor';
                            }
                            if (key === 'Advisor') {
                                key = 'RIA';
                            }
                            if (key === 'Aggregated Model') {
                                key = 'Model Aggregate';
                            }
                            var entity = $scope.hierarchyLevels.find({ friendlyName: key });

                            if (!entity) {
                                return;
                            }

                            entityCount.push({ entity: entity.friendlyName, level: entity.name, memberCount: val.length });
                        });

                        buildEntityTree(entityCount);

                        Object.each(entityGroup, function (key, val) {
                            if (key === 'Sub-advisor') {
                                key = 'Sub Advisor';
                            }
                            if (key === 'Advisor') {
                                key = 'RIA';
                            }
                            if (key === 'Aggregated Model') {
                                key = 'Model Aggregate';
                            }

                            var entity = $scope.hierarchyLevels.find({ friendlyName: key });

                            if (!entity) {
                                return;
                            }

                            var node = null;
                            $scope.entitySelector.forEach(function (n) {
                                var result = n.children.find({ name: entity.name });

                                if (result) {
                                    node = result;
                                }
                            });

                            val.forEach(function (child) {
                                child = {
                                    label: child.name + ' (' + child.entityId + ')',
                                    name: child.name,
                                    id: child.entityId,
                                    icon: getIcon(7),
                                    parentNode: node,
                                    isChild: true,
                                    isNew: false,
                                    entityEnum: entity.id,
                                };
                                node.children.push(child);
                            });
                        });

                        resetProperties(false);
                    });
                }
            });
    };

    $scope.save = function () {
        if (
            $scope.feeHierarchy.feeHierarchyDetails.some((slv, idx) => {
                return (
                    $scope.feeHierarchy.feeHierarchyDetails.findIndex(
                        (f) =>
                            f.billEntityId === slv.billEntityId &&
                            f.productType === slv.productType &&
                            f.type === slv.type &&
                            f.status === slv.status &&
                            f.sleeveType === slv.sleeveType &&
                            f.methodType === slv.methodType
                    ) != idx
                );
            })
        ) {
            $dialog.actionFailed('Duplicate records found.').open();
            return;
        }

        if ($scope.current.selectedNode.isNew) {
            $scope.feeHierarchy.custodianId = $scope.current.custodianId;

            $http.post('/Billing/Hierarchy', $scope.feeHierarchy, { trackerMsg: 'Adding new fee hierarchy' }).then(function () {
                resetProperties(true);
                init();
            });
        } else {
            $http.put('/Billing/Hierarchy', $scope.feeHierarchy, { trackerMsg: 'Saving fee hierarchy' }).then(function () {
                resetProperties(true);
                init();
            });
        }

        $scope.current.isNew = false;
    };

    $scope.saveDisabled = function () {
        //Provide some reactiveness to the form
        if (!$scope.feeHierarchy) return;

        var disabled = false;
        $scope.feeHierarchy.feeHierarchyDetails.forEach((detail) => {
            let isProductNull = $scope.feeHierarchy.feeHierarchyDetails.some(
                (e) =>
                    (e.productType === null || e.productType === '') &&
                    e.id === detail.id &&
                    e.billEntityId === detail.billEntityId &&
                    e.billScheduleId === detail.billScheduleId &&
                    e.productType === detail.productType
            );
            let validateProductSave = detail.useAssetLevel ? isProductNull : false;

            if (!disabled) {
                if (
                    detail.billEntityId === 0 ||
                    detail.billEntityId == null ||
                    detail.billScheduleId === 0 ||
                    detail.billScheduleId == null ||
                    (!detail.methodType && !detail.sleeveType && ($scope.current.entityLevel === 52 || $scope.current.entityLevel === 74)) ||
                    validateProductSave
                ) {
                    disabled = true;
                }
            }
        });
        return disabled;
    };

    $scope.validateScheduleForPayout = function ($index) {
        if ($index !== 0) {
            if (
                $scope.feeHierarchy.feeHierarchyDetails.some((slv, idx) => {
                    return (
                        $scope.feeHierarchy.feeHierarchyDetails.findIndex(
                            (f) =>
                                f.billEntityId === slv.billEntityId &&
                                f.productType === slv.productType &&
                                f.type === slv.type &&
                                f.sleeveType === slv.sleeveType
                        ) != idx
                    );
                })
            ) {
                $dialog.actionFailed("This entity already exists and can't be added.").open();
                $scope.feeHierarchy.feeHierarchyDetails.removeAt($index);
                return true;
            }
        }

        return false;
    };

    $scope.cancelSearch = function () {
        $scope.current.searchModeEngage = false;

        $scope.entitySelector.length = 0;
        resetProperties(true);
        init();
    };

    $scope.allowFeeHierarchyAdditive = function (entity) {
        switch (entity) {
            case 'Aggregated Model':
            case 'Sub-advisor':
                return true;
            default:
                return false;
        }
    };

    $scope.current = {
        selectedEntity: null,
        parentNode: null,
        selectedNode: null,
        entityLevel: null,
        isNew: false,
        custodianId: null,
        searchModeEngage: false,
        hasGlobalData: false,
    };

    //$scope.methodTypes = [{ id: null, name: "" }, { id: 1, name: "Additive" }, { id: 2, name: "Override" }];
    $scope.methodTypes = ['Additive', 'Override'];
    $scope.productTypes = [];
    $scope.payoutRates = [];
    $scope.entitySelector = [];
    $scope.feeEntityDetailCount = null;

    // INITIALIZE
    $scope.hierarchyLevels = [
        { id: 125, name: 'Global', friendlyName: 'Global', level: 0 },
        { id: 2, name: 'BrokerDealer', friendlyName: 'Broker/Dealer', level: 1 },
        { id: 17, name: 'RIA', friendlyName: 'RIA', level: 2 },
        { id: 4, name: 'Representative', friendlyName: 'Representative', level: 3 },
        { id: 58, name: 'Plan401k', friendlyName: 'Qualified Plan', level: 4 },
        { id: 16, name: 'Platform', friendlyName: 'Management Style', level: 5 },
        { id: 5, name: 'Client', friendlyName: 'Household', level: 6 },
        { id: 6, name: 'Registration', friendlyName: 'Registration', level: 7 },
        { id: 52, name: 'SubAdvisor', friendlyName: 'Sub Advisor', level: 8 },
        { id: 74, name: 'AggregateModel', friendlyName: 'Model Aggregate', level: 9 },
        { id: 7, name: 'Account', friendlyName: 'Account', level: 10 },
    ];

    $scope.rightsFeeHierarchy = $oasRights.forCode('PAYOUTSCHEDULES');

    init();

    // WATCHES
    $scope.$watch('current.custodianId', function (newVal, oldVal) {
        if (newVal === oldVal || $scope.current.entityLevel === null) {
            return;
        }

        isNewCustodian = true;

        if ($scope.feeHierarchy) {
            $scope.feeHierarchy = null;
        }

        getHierarchyData($scope.current.selectedNode.id);
    });

    $scope.$watch('current.selectedEntity', function (newVal, oldVal) {
        if (newVal === oldVal || !newVal || !$scope.current.isNew || (!newVal.hasOwnProperty('id') && $scope.current.selectedNode.name === 'Global')) {
            return;
        }

        // When switching entities when creating new, we want to clear out any unsaved changes on the previous entity screen.
        if ($scope.feeHierarchy) {
            $scope.feeHierarchy = null;
        }

        $scope.feeEntityDetailCount = null;

        var id = newVal.id ? newVal.id : newVal;

        if ($scope.current.selectedNode.id === 125) {
            id = 0;
        }

        selectedEntityName = !newVal.name ? $scope.current.selectedName : newVal.name;

        getDefaultEntityObject($scope.current.selectedNode.id, id, $scope.current.custodianId, true);
    });
});

'use strict';

app.controller('BillingHierarchyPayoutEditCtrl', function BillingHierarchyPayoutEditCtrl($scope, $http, $oasRights, $dialog, dialog) {
    // region PRIVATE VARIABLES

    // endregion

    // region PRIVATE METHODS
    function init() {
        $scope.rightsPayoutRate = $oasRights.forCode('PAYOUTSCHEDULES');
    }

    function loadPayoutRates() {
        $http
            .get('/Billing/Schedules/Simple?billEntity=' + $scope.current.selectedEntity.id, { trackerMsg: 'Loading payable rates' })
            .then(function (response) {
                $scope.payoutRates = response.data;
            });
    }

    //endregion

    // region PUBLIC METHODS

    $scope.addPayout = function () {
        $scope.prGeneral.add({
            entityId: 0,
            billScheduleId: 0,
            isActive: false,
        });
    };

    $scope.deletePayout = function (payout) {
        $scope.prGeneral.remove(payout);
    };

    $scope.close = function () {
        dialog.close(null);
    };

    //endregion

    $scope.current = {
        prId: dialog.options.isNew ? 0 : parseInt(dialog.options.selectedId),
        selectedEntity: null,
        isNew: dialog.options.isNew,
    };

    $scope.hierarchyLevels = [
        { id: 1, name: 'Global' },
        { id: 2, name: 'BD' },
        { id: 17, name: 'RIA' },
        { id: 4, name: 'Rep' },
        { id: 58, name: 'Plan' },
        { id: 5, name: 'Household' },
        { id: 6, name: 'Registration' },
        { id: 7, name: 'Account' },
        { id: 27, name: 'Model' },
    ];

    $scope.prGeneral = [];

    init();

    // region WATCH
    $scope.$watch('current.selectedEntity', function (newVal, oldVal) {
        if (newVal === oldVal || !newVal) return;

        loadPayoutRates();
    });
    // endregion
});

app.component('oasBillingPayoutDashboard', {
    bindings: {
        parameters: '<',
        selectedItem: '=',
    },
    templateUrl: 'billing/directives/oasBillingPayoutDashboard.html',
    controller: function ($http, $element, $location) {
        //PRIVATE VARIABLES
        var $ctrl = this;
        var selectedItem = null;

        function populateData(data) {
            $ctrl.current.columnConfig.forEach(function (col) {
                col.value = data[col.key] || 0;
            });

            var targetElement = $element.children()[5];
            var col = $ctrl.current.columnConfig.find({ key: 'others' });

            $ctrl.itemClick(targetElement, col);
        }

        $ctrl.$onInit = function () {
            $http
                .get('/Billing/PayoutDashboard/Summary/Header' + $ctrl.parameters, { trackerMsg: 'Loading payout dashboard counts' })
                .then(function (response) {
                    populateData(response.data);
                });
        };

        $ctrl.itemClick = function (target, col) {
            if (selectedItem != null) {
                selectedItem.classList.remove('billing-payout-header-item-clicked');
            }

            if (target) {
                selectedItem = target.currentTarget ? target.currentTarget : target;
            }

            var key;

            if (col) {
                key = col.key;
            } else {
                key = 'Total';
            }

            switch (col?.key) {
                case 'PendingApproval':
                    $location.url('/billing/payout/dashboard/pendingApproval');
                    break;
                case 'CurrentlyApproved':
                    $location.url('/billing/payout/dashboard/currentlyApproved');
                    break;
                case 'Paid':
                    $location.url('/billing/payout/dashboard/Paid');
                    break;
                case 'CreditAndExpenses':
                    $location.url('/billing/payout/dashboard/creditandexpenses');
                    break;
                case 'Total':
                    $location.url('/billing/payout/dashboard/Total');
                    break;
            }

            angular.element(selectedItem).addClass('billing-payout-header-item-clicked');
        };

        $ctrl.current = {
            columnConfig: [
                { name: 'Pending Approval', key: 'PendingApproval', color: '#ffffff', spanNumber: 2 },
                { name: 'Currently Approved', key: 'CurrentlyApproved', color: '#ffffff', spanNumber: 2 },
                { name: 'Credits and Expenses', key: 'CreditAndExpenses', color: '#ffffff', spanNumber: 2 },
                { name: 'Paid', key: 'Paid', color: '#ffffff', spanNumber: 2 },
                { name: 'Total Payouts', key: 'Total', color: '#ffffff', spanNumber: 4 },
            ],
        };

        $ctrl.$onChanges = function (item) {
            if (item.parameters.currentValue !== item.parameters.previousValue && !angular.equals({}, item.parameters.previousValue)) {
                $ctrl.$onInit();
            }
        };

        $ctrl.current.columnConfig.forEach(function (config) {
            config.value = 0;
        });
    },
});

'use strict';

app.controller('PayoutDashboardLandingCtrl', function PayoutDashboardLandingCtrl($scope, $http) {
    //PUBLIC VARIABLES
    $scope.activity = {
        chart: { config: {} },
    };

    //PRIVATE METHODS
    function init() {
        getActivtyData();
    }

    function getActivtyData(payee) {
        $http
            .get('/Settings/Database/EntityOptions/Code/69PAYOUTDA', { trackerMsg: 'Getting Payout Dashboard Start Date' })
            .then(function (response) {
                if (response.data.value) {
                    $scope.current.payoutDashboardStartDate = new Date(response.data.value);
                }
            })
            .finally(function () {
                $scope.setDates('');

                var startDate = $scope.current.startDate != null ? $scope.current.startDate.formatted() : '';
                var endDate = $scope.current.endDate != null ? $scope.current.endDate.formatted() : '';
                var url = '/Billing/PayoutDashboard/Summary/ActivityChart?startDate=' + startDate + '&endDate=' + endDate;
                if (payee != null) {
                    if (payee === 'All') payee = null;
                    url += '&payee=' + payee;
                }

                $scope.current.parameters = '?startDate=' + startDate + '&endDate=' + endDate;

                $http.get(url, { trackerMsg: 'Getting data for charts' }).then(function (response) {
                    $scope.activity.chart.config.series[0].data = [];
                    $scope.activity.chart.config.title.text =
                        'Activity for ' +
                        ($scope.current.startDate != null ? $scope.current.startDate.formatted() : 'Begining of Database ') +
                        '-' +
                        ($scope.current.endDate != null ? $scope.current.endDate.formatted() : '');
                    response.data.forEach(function (d) {
                        $scope.activity.chart.config.series[0].data.push([d.calculatedDate, d.amount]);
                    });
                });
            });
    }

    $scope.setDates = function () {
        var endDate = $scope.current.endDate != null ? $scope.current.endDate : Date.create('today');
        var startDate = $scope.current.startDate;

        let previousQuaterStartDate = Date.create('today').getStartOfQuarter().addDays(-1).getStartOfQuarter(); //new Date(beginningOfMonth.getFullYear(), quarter * 3 - 3, 1);

        if (startDate === null) {
            if ($scope.current.payoutDashboardStartDate === null) {
                startDate = previousQuaterStartDate;
            } else {
                startDate = ($scope.current.payoutDashboardStartDate.isBefore(previousQuaterStartDate) || $scope.current.payoutDashboardStartDate.isAfter(endDate)) ? previousQuaterStartDate : $scope.current.payoutDashboardStartDate;
            }
        }

        $scope.current.startDate = startDate;
        $scope.current.endDate = endDate.isBefore(startDate) ? Date.create('today') : endDate;
    };

    $scope.activity.chart.config = {
        category: 'Pending',
        options: {
            chart: { type: 'line' },
            xAxis: {
                type: 'category',
            },
            yAxis: {
                allowDecimals: false,
                min: 0,
                title: { text: '' },
            },
            legend: { enabled: false, borderWidth: 0, layout: 'vertical', align: 'right', verticalAlign: 'middle' },
            tooltip: {
                pointFormat: '<b>${point.y:,.2f}</b>',
            },
            plotOptions: {
                column: { stacking: 'normal' },
            },
            dateTimeLabelFormats: {
                second: '%H:%M',
                minute: '%H:%M',
                hour: '%H:%M',
                day: '%e-$b-%y',
                week: '%e',
                month: '%e',
                year: '%e',
            },
        },
        series: [{ data: [] }],
        title: { text: '' },
    };

    $scope.refreshGrid = function (payee) {
        getActivtyData(payee);
    };

    $scope.current = {
        startDate: null, //Date.create('today').getStartOfQuarter(),
        endDate: Date.create('today'),
        parameters: null,
        entity: '4',
        payee: null,
        status: 'Total',
        payoutDashboardStartDate: null,
    };

    $scope.current.parameters =
        '?startDate=' + ($scope.current.startDate != null ? $scope.current.startDate.formatted() : '') + '&endDate=' + $scope.current.endDate.formatted();

    init();
});

'use strict';

app.directive('quickTrade', function quickTrade($http, promiseTracker, $tradeGenerator, $oasRights) {
    return {
        restrict: 'E',
        scope: {},
        replace: true,
        templateUrl: 'trading/directives/quickTrade.html',
        link: function (scope, element, attrs) {
            //PRIVATE FUNCTIONS
            function initialLoad() {
                if (!attrs.mode || attrs.mode.toLowerCase() !== "blocks") {
                    scope.isBlockMode = false;

                    var canProcess = $oasRights.canUpdate("EXECTRADES");

                    scope.tradeActions = [
                        { name: "Buy", showBuy: true, types: { dollars: "amount to buy", shares: "quantity to buy" }, showTradeType: true, canSendImmediately: canProcess },
                        { name: "Sell", showSell: true, types: { dollars: "amount to sell", shares: "quantity to sell", percent: "percent to sell" }, canSendImmediately: canProcess },
                        { name: "Rebalance", types: {}, showTradeType: true },
                        { name: "Buy Rebalance", types: { dollars: "amount to buy" }, showTradeType: true },
                        { name: "Sell Rebalance", types: { dollars: "amount to sell" } },
                        { name: "Exchange", showBuy: true, showSell: true, types: { dollars: "amount", shares: "quantity", percent: "percent" }, showTradeType: true },
                        { name: "Liquidate", types: {} }
                    ];
                }
                else {
                    scope.isBlockMode = true;

                    scope.tradeActions = [
                        { name: "Buy", showBuy: true, types: { shares: "quantity to buy" } },
                        { name: "Sell", showSell: true, types: { shares: "quantity to sell" } }
                    ];

                    $http.get('/Portfolio/Custodians/Simple', {cache: true, trackerMsg: 'Loading custodians'})
                        .then(function(response) {
                            scope.custodians = response.data;
                            scope.trade.account = response.data[0];
                        });
                }

                scope.resetTrade( true );
            }

            function getAmount() {
                switch(scope.trade.type) {
                    case "Shares":
                        return scope.trade.shares;
                    case "Percent":
                        return scope.trade.percent;
                    default:
                        return scope.trade.dollars;
                }
            }

            function getPrice(ticker) {
                $http.get('/Trading/Products/' + ticker + '/RealtimePrice', {trackerMsg: 'Loading price data'})
                    .then(function (response) {
                        scope.priceInfo = response.data;
                    });
            }

            function getAccount() {
                $http.get('/Trading/AccountTradeInfo/' + scope.trade.account.id, {trackerMsg: 'Loading account information'})
                    .then(function (response) {
                        scope.accountInfo = response.data;
                    });

                getValidation(false);
            }

            function getValidation(generateWhenValid) {
                if (!scope.trade.account) return;

                var params = {
                    accountId: scope.trade.account.id,
                    action: scope.trade.action.name.camelize(false),
                    sellProductId: scope.trade.sellProduct ? scope.trade.sellProduct.productId : "",
                    buyProductId: scope.trade.buyProduct ? scope.trade.buyProduct.productId : "",
                    shares: scope.trade.shares || "",
                    dollars: scope.trade.dollars || "",
                    percent: scope.trade.percent || ""
                };

                var promise = $http.get('/Trading/TradeValidation?' + Object.toQueryString(params), {trackerMsg: 'Validating trade data'})
                    .then(function (response) {
                        scope.tradeValidator = response.data;

                        if (generateWhenValid && response.data.errors.length === 0) {
                            generateTrade();
                        }
                    });

                scope.quickTradeTracker.addPromise(promise);
            }

            function generateTrade() {
                var accountId = scope.trade.account.id;
                var transType = scope.trade.nsccTransactionType;
                var sendNow = scope.trade.sendNow;
                var promise;

                switch (scope.trade.action.name) {
                    case "Buy":
                        if (scope.isBlockMode)
                            promise = $tradeGenerator.buyBlock(accountId, scope.trade.buyProduct.productId, getAmount(), scope.trade.strikePrice, scope.trade.cfiCode, scope.trade.orderCapacity, scope.trade.positionEffect , scope.trade.maturityDate, scope.trade.solicited);
                        else
                            promise = $tradeGenerator.buy(accountId, scope.trade.buyProduct.productId, scope.trade.type, getAmount(), transType, sendNow);
                        break;
                    case "Sell":
                        if (scope.isBlockMode)
                            promise = $tradeGenerator.sellBlock(accountId, scope.trade.sellProduct.productId, getAmount(), scope.trade.strikePrice, scope.trade.cfiCode, scope.trade.orderCapacity, scope.trade.positionEffect , scope.trade.maturityDate, scope.trade.solicited);
                        else
                            promise = $tradeGenerator.sell(accountId, scope.trade.sellProduct.productId, scope.trade.type, getAmount(), sendNow);
                        break;
                    case "Rebalance":
                        promise = $tradeGenerator.rebalance(accountId, transType);
                        break;
                    case "Buy Rebalance":
                        promise = $tradeGenerator.buyRebalance(accountId, scope.trade.dollars, transType);
                        break;
                    case "Sell Rebalance":
                        promise = $tradeGenerator.sellRebalance(accountId, scope.trade.dollars);
                        break;
                    case "Exchange":
                        promise = $tradeGenerator.exchange(accountId, scope.trade.sellProduct.productId, scope.trade.buyProduct.productId, scope.trade.type, getAmount(), transType);
                        break;
                    case "Liquidate":
                        promise = $tradeGenerator.liquidateAccount(accountId);
                        break;
                }

                scope.quickTradeTracker.addPromise(promise);

                promise.then(function() {scope.resetTrade( false );});
            }


            //PUBLIC METHODS
            scope.resetType = function() {
                if (scope.isBlockMode) return;

                getValidation(false);

                if (scope.trade.type === "Dollars") return;

                if (!scope.trade.action.types[scope.trade.type.toLowerCase()]) {
                    scope.trade.type = "Dollars";
                    scope.trade.shares = null;
                    scope.trade.percent = null;
                }
            };

            scope.resetValues = function(value1, value2){
                if (scope.isBlockMode) return;

                scope.trade[value1] = null;
                scope.trade[value2] = null;

                getValidation(false);
            };

            scope.submitTrade = function() {
                if (scope.isBlockMode)
                    generateTrade();
                else
                    getValidation(true);
            };

            scope.resetTrade = function( resetProducts ) {
                scope.trade = {account: null, action: scope.tradeActions[0], sendNow: false, nsccTransactionType: 'UseDefault', type: scope.isBlockMode ? "Shares" : "Dollars", sellProduct: scope.trade && !resetProducts ? scope.trade.sellProduct : null, buyProduct: scope.trade && !resetProducts ? scope.trade.buyProduct :  null, dollars: null, shares: null, percent: null};
                scope.accountInfo = null;
                scope.tradeValidator = null;
            };


            //INITIALIZE
            initialLoad();
            scope.quickTradeTracker = promiseTracker('quickTrade');


            //WATCHES
            scope.$watch("trade.account", function(newValue, oldValue) {
                if (scope.isBlockMode || newValue === oldValue || !newValue) return;

                getAccount();
            });

            scope.$watch("trade.buyProduct", function(newValue, oldValue) {
                if (scope.isBlockMode || newValue === oldValue) return;

                if (newValue && scope.trade.action.name === 'Buy') {
                    getPrice(newValue.ticker);
                }

                getValidation(false);
            });

            scope.$watch("trade.sellProduct", function(newValue, oldValue) {
                if (scope.isBlockMode || newValue === oldValue) return;

                if (newValue && scope.trade.action.name === 'Sell') {
                    getPrice(newValue.ticker);
                }

                getValidation(false);
            });
        }
    };
});
app.directive('modelAnalyzer', function modelAnalyzer($rootScope, $http, $timeout){
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'trading/directives/modelAnalyzer.html',
        scope: {mode: '@'},
        link: function(scope, elem, attrs){

            function buildChartConfig() {
                scope.analyzer["chart"] = {
                    options: {
                        chart: {type: 'bar', borderWidth: 0},
                        credits: {enabled: false},
                        legend: {enabled: true, borderWidth: 0},
                        xAxis: {
                            categories: [], labels: {
                                formatter: function () {
                                    return this.value.length > 6 ? this.value.first(3) + "..." : this.value;
                                }
                            }
                        },
                        yAxis: {
                            title: {text: ''}, labels: {
                                formatter: function () {
                                    return this.value === 0 ? 'Target' : this.value + ' %';
                                }
                            }
                        },
                        plotOptions: {bar: {grouping: false, shadow: false, pointPadding: 0}},
                        tooltip: {
                            formatter: function () {
                                var chart = this.points[0].series.chart;
                                var categories = chart.xAxis[0].categories;
                                var index = 0, temp = {};

                                while (this.x !== categories[index]) {
                                    index++;
                                }
                                chart.series.forEach(function (series) {
                                    temp[series.name] = series.yData[index];
                                });

                                var target = temp['Target'].round(2);
                                var bottom = (temp['Target'] + temp['Lower']).round(2);
                                var top = (temp['Target'] + temp['Upper']).round(2);
                                var range = bottom === target && top === target ? '' : '<br/>Range: ' + bottom + ' - ' + top + ' %';

                                return '<b>' + this.x + '<br/>Target: ' + target + ' %' + range + '<br/>Post Trade: ' + (target + temp['Post Trade']).round(2) + ' %';
                            },
                            shared: true,
                            shadow: false,
                            borderColor: "#CCCCCC"
                        }
                    },
                    series: [
                        {data: [], name: 'Lower', borderColor: "#00AEEF", color: "rgba(0, 170, 239, 0.1)"},
                        {data: [], name: 'Upper', borderColor: "#00AEEF", color: "rgba(0, 170, 239, 0.1)"},
                        {data: [], name: 'Post Trade', borderColor: "#00AEEF", color: '#00AEEF', pointPadding: 0.2},
                        {data: [], name: 'Target', visible: false, showInLegend: false}
                    ],
                    title: {text: 'Model Tolerance'},
                    subtitle: {text: null}
                };

            }

            function loadAnalyzer(forceRender) {
                var account = scope.analyzer.account;

                if (!scope.analyzer.isActiveTab || account.id === 0 || (!forceRender && account.id === scope.analyzer.lastAnalyzedId)) return;

                if (scope.current.usingTrxModelTolerance) {
                    loadTrxAnalyzer(account);
                } else {
                    loadOrionAnalyzer(account);
                }

            }

            function loadOrionAnalyzer(account) {
                var url = '/Portfolio/Accounts/' + account.id + '/ModelTolerance?grouping=' + scope.analyzer.groupingType + '&includePendingValue=';
                url += scope.analyzer.usePendingValue ==='pending' ? '2' : '0';
                $http.get(url, {trackerMsg: 'Loading model tolerance data for Account ID ' + account.id})
                    .then(function (response) {
                        var data = response.data;
                        var title =  account.accountName ? account.accountName + " (" + account.accountType + ")" : account.registrationName + " (" + account.accountType + ")";
                        var subTitle = account.id + " - " + account.accountNumber;
                        buildModelToleranceChart(account, data, title, subTitle);
                    });
            }

            function loadTrxAnalyzer(account) {
                var trxGrouping = scope.analyzer.groupingType === 81 ? 'ModelComplianceSubClass' : 'ModelComplianceClass';
                $http.get('/Integrations/TRX/' + trxGrouping + '/' + account.id, {trackerMsg: 'Loading tRx model tolerance data for Account ID ' + account.id})
                    .then(function (response) {
                        var trxData = response.data;
                        scope.trxModelTolerance.householdId = null;
                        scope.trxModelTolerance.householdDescription = null;
                        scope.trxModelTolerance.availableHouseholds = [];
                        if (trxData) {
                            for (var i = 0; i < trxData.length; i++) {
                                scope.trxModelTolerance.availableHouseholds.push({
                                    householdId: trxData[i].householdId,
                                    householdDescription: trxData[i].householdDescription,
                                    householdData: trxData[i].items
                                });
                            }
                            if (scope.trxModelTolerance.availableHouseholds.length > 0) {
                                scope.trxModelTolerance.selectedHousehold = scope.trxModelTolerance.availableHouseholds[0];

                                var title = scope.trxModelTolerance.selectedHousehold.householdDescription + " (" + scope.trxModelTolerance.selectedHousehold.householdId + ")";
                                buildModelToleranceChart(account, scope.trxModelTolerance.selectedHousehold.householdData, title, '');
                            }
                        }
                    });
            }

            function calculateChartHeight(mode, length){
                if(mode === 'horizontal'){
                    if(length >= 1 && length <= 3){
                        return (45 * length) + 69;
                    }
                    if(length >= 4 && length <= 9){
                        return (35 * length) + 69;
                    }
                    if(length >= 10){
                        return (30 * length) + 69;
                    }
                }else{
                    return 400;
                }

                //var total = modelToleranceData.length;
                //$scope.analyzer.height = total > 20 ? 115 + (16 * total) : 400;
                //mode == 'horizontal' ?  (total > 2 ? 30 * modelToleranceData.length : 35 * modelToleranceData.length ) + 69 : 400;
            }

            function buildModelToleranceChart(account, modelToleranceData, title, subTitle) {
                var points = {lower: [], upper: [], postTrade: [], target: [], categories: []};

                scope.analyzer.chart.series[0].data = [];
                scope.analyzer.chart.series[1].data = [];
                scope.analyzer.chart.series[2].data = [];
                scope.analyzer.chart.series[3].data = [];

                modelToleranceData.forEach(function (asset) {
                        var postTrade = asset.postTradePercent - asset.targetPercent;

                    if( !asset.excluded ) {
                        points.categories.push(asset.groupName );
                        points.lower.push(-asset.lowerTolerance);
                        points.upper.push(asset.upperTolerance);
                        points.postTrade.push(asset.inTolerance ? postTrade : {
                            y: postTrade,
                            color: '#BF0B23',
                            borderColor: '#BF0B23'
                        });
                        points.target.push(asset.targetPercent);
                    } else {
                        points.categories.push(asset.groupName);
                        points.lower.push(-asset.lowerTolerance);
                        points.upper.push(asset.upperTolerance);
                        points.postTrade.push(asset.inTolerance ? 0.00 : {
                            y: 0.00,
                            color: '#BF0B23',
                            borderColor: '#BF0B23'
                        });
                        points.target.push(0.00);
                    }

                        asset.diffPercent = asset.actualPercent - asset.targetPercent;
                        asset.diffValue = asset.actualValue - asset.targetValue;
                        asset.diffShares = asset.actualShares - asset.targetShares;

                });

                var total = modelToleranceData.length;
                scope.analyzer.height = calculateChartHeight(scope.current.mode, modelToleranceData.length);  // scope.current.mode == 'horizontal' ?  (total > 2 ? 30 * modelToleranceData.length : 35 * modelToleranceData.length ) + 69 : 400;                                                // 115 + (16 * total) : 400;
                scope.analyzer.chart.title.text = title;
                scope.analyzer.chart.subtitle.text = subTitle;
                scope.analyzer.chart.options.xAxis.categories = points.categories;
                scope.analyzer.chart.series[0].data = points.lower;
                scope.analyzer.chart.series[1].data = points.upper;
                scope.analyzer.chart.series[2].data = points.postTrade;
                scope.analyzer.chart.series[3].data = points.target;

                scope.analyzer.lastAnalyzedId = account.id;
                account.assets = modelToleranceData;
            }

            scope.changeTrxHousehold = function () {
                var account = scope.analyzer.account;
                var title = scope.trxModelTolerance.selectedHousehold.householdDescription + " (" + scope.trxModelTolerance.selectedHousehold.householdId + ")";
                buildModelToleranceChart(account, scope.trxModelTolerance.selectedHousehold.householdData, title, '');
            };

            scope.sortAnalyzer = function (field) {
                var fieldName;
                if (field === 'groupName') {
                    fieldName = field;
                } else {
                    switch (scope.analyzer.tableMode) {
                        case "percent":
                            fieldName = field + "Percent";
                            break;
                        case "dollars":
                            fieldName = field + "Value";
                            break;
                        case "shares":
                            fieldName = field + "Shares";
                            break;
                    }
                }
                scope.analyzer.sortField = fieldName;
                scope.analyzer.sortReverse = !scope.analyzer.sortReverse;
            };

            scope.exportToExcel = function() {

                var dataDetails = {
                    columns: getExportColumns(),
                    data: scope.analyzer.account.assets
                };

                $http.post('/Utility/SlickGridExport/csv', dataDetails, {trackerMsg: 'Exporting grid'})
                    .then(function (response) {
                        window.location.href = response.headers("location") + "?Authorization=" + sessionStorage.oas_token;
                    });
            };

            function getExportColumns(){
                switch (scope.analyzer.tableMode) {
                    case "percent":
                        return [
                            {name: "Asset", field: "groupName"},
                            {name: "Name", field: "groupDescription"},
                            {name: "Current", field: "actualPercent"},
                            {name: "Target", field: "targetPercent"},
                            {name: "Difference", field: "diffPercent"},
                            {name: "Post Trade", field: "postTradePercent"}
                        ];
                    case "dollars":
                        return [
                            {name: "Asset", field: "groupName"},
                            {name: "Name", field: "groupDescription"},
                            {name: "Current", field: "actualValue"},
                            {name: "Target", field: "targetValue"},
                            {name: "Difference", field: "diffValue"},
                            {name: "Post Trade", field: "postTradeValue"}
                        ];
                    case "shares":
                        return [
                            {name: "Asset", field: "groupName"},
                            {name: "Name", field: "groupDescription"},
                            {name: "Current", field: "actualShares"},
                            {name: "Target", field: "targetShares"},
                            {name: "Difference", field: "diffShares"},
                            {name: "Post Trade", field: "postTradeShares"}
                        ];
                }
            };

            //SCOPE WATCHERS
            scope.$watch("analyzer.groupingType", function (newValue, oldValue) {
                //had to use a watch because ng-click on a btn-radio acts weird
                if (newValue === oldValue) return;

                loadAnalyzer(true);
            });

            scope.$watch("analyzer.usePendingValue", function (newValue, oldValue) {
                //had to use a watch because ng-click on a btn-radio acts weird
                if (newValue === oldValue) return;

                buildChartConfig();
                loadAnalyzer(true);
            });

            if (attrs.reloadEvents) {
                var events = attrs.reloadEvents.split(",");
                scope.mode = attrs.mode;
                var performAction = function(args) {
                    scope.current.includePendingValue = args.includePendingValue ? 'pending' : 'current';
                    buildChartConfig();
                    switch (args.action) {
                        case "load-analyzer":
                            scope.analyzer = args.analyzer;
                            loadAnalyzer(args.forceRefresh);
                            break;
                        case "refresh-analyzer":
                            scope.analyzer = args.analyzer;
                            loadAnalyzer(args.forceRefresh);
                            break;
                    }

                    scope.current.mode = scope.mode;
                };

                events.forEach(function (eventName) {
                    scope.$on(eventName, function (e, args) {
                       performAction(args);
                    });
                });
            }

            // overflow-y: auto; overflow-x: hidden; max-height: 402px; margin: 0 10px; width: 480px; border: 1px solid #ccc;

            scope.analyzer = {
                groupingType: "0",
                usePendingValue: "pending",
                tableMode: "percent",
                lastAnalyzedId: 0,
                height: 400,
                sortField: '',
                sortReverse: false,
                account: {id: 0, accountNumber: "", registrationName: "", accountType: "", assets: []},
                isActiveTab: false
            };
            scope.current = {usingTrxModelTolerance: false, mode:'vertical', includePendingValue: 'pending', chartStyle: {overflowY: 'auto', overflowX:'hidden', maxHeight:'402px', margin:'0 10px', border: '1px solid #cc'}};
            scope.analyzer.groupingType = scope.current.usingTrxModelTolerance ? "81" : "0";
        }
    }
});

'use strict';

app.directive('riskAnalysisChart', function riskTargetChart() {
    function riskTargetChartCtrl($scope) {
        var riskIndicatorList = [];
        var chartColors = {'C1': '#000000','C2': '#ff9900'};

        function init() {
            createConfig();
        }

        function createConfig(){
            $scope.chartConfig = {
                options: {
                    chart: {
                        type: 'columnrange',
                        inverted: true,
                        backgroundColor:'transparent',
                        height:65
                    },
                    legend: {
                        enabled: false
                    },
                    plotOptions: {
                        columnrange: {
                            dataLabels: {
                                enabled: true
                            }
                        }
                    },
                    xAxis: {
                        categories: ['Risk'],
                        visible: false
                    },
                    yAxis: {
                        title: {text: null},
                        min:null, max: null, startOnTick:true, minPadding: null, maxPadding: null,
                        plotLines: []
                    }
                },
                credits: {
                    enabled: false
                },

                series: [{
                    name: 'Range',
                    data: [{low: $scope.min, high: $scope.max, color: '#00AEEF', dataLabels:{enabled:false}}]
                }],
                title: {text: $scope.mode === 'normal' ? 'RISK ANALYSIS' : ''}

            };
        }


        function updateChart(updateConfig) {
            if(updateConfig){
                riskIndicatorList = [];
                createConfig();
            }
            if($scope.riskIndicators && $scope.riskIndicators.length > 0){
                var index = 0;
                riskIndicatorList = [];
                var tickDistance = Math.abs($scope.riskIndicators[0] - $scope.riskIndicators[1]);
                var checkDifference = $scope.riskIndicators[0] - $scope.riskIndicators[1];
                $scope.riskIndicators.forEach(function(item){
                    if(item){
                        var chartProps =  {
                            color:  '#000',
                            width: 2,
                            value: null,
                            zIndex: 5,
                            label: {
                                text: '',
                                rotation: 0,
                                style: {"font-size": "11px", color: chartColors['C'+ (index +1)]
                                },
                                y: index === 0 ? 2 : $scope.mode === 'normal' ? 45 : 22,
                                x: (index === 0 && tickDistance < 5 && checkDifference < 0) ? -18 : (index === 1 && tickDistance < 5 && checkDifference > 0) ? -18 : 0
                            }
                        };
                        if(index >= 0 && index <=1){
                            chartProps.color = $scope.mode === 'simple' && $scope.riskIndicators[0] > $scope.upperTolerance && index === 0 ? '#ff0000' : chartColors['C'+ (index +1)];
                            chartProps.value = item;
                            chartProps.label.text = item;

                            riskIndicatorList.add(chartProps);
                            index ++;
                        }
                    }
                })
            }
            $scope.chartConfig.options.chart.height = $scope.mode === 'normal' ? 120: 65;
            $scope.chartConfig.options.yAxis.plotLines = riskIndicatorList;
            if($scope.min){
                $scope.chartConfig.options.yAxis.min = $scope.min;
            }
            if($scope.max){
                $scope.chartConfig.options.yAxis.max = $scope.max;
            }
            $scope.chartConfig.series[0].data[0].high = $scope.upperTolerance ? $scope.upperTolerance : 100;
            $scope.chartConfig.series[0].data[0].low = $scope.lowerTolerance ? $scope.lowerTolerance : 0;

            $scope.chartConfig.options.yAxis.minPadding = 0.2;
            $scope.chartConfig.options.yAxis.maxPadding = 0.4;

          //  $scope.chartConfig.series[0].data[0].dataLabels.enabled = $scope.mode !== 'simple';
        }

        //EVENT REGISTRATION
        $scope.$on($scope.refreshOn, function () {
            // apply plot lines for bar if passed in
            updateChart(true)
        });

        //INITIALIZE
        init();
    }

    return {
        restrict: 'E',
        scope: {
            refreshOn: '@',
            min: '@',
            max: '@',
            mode: '@',
            isUpdating: '=',
            lowerTolerance: '=',
            upperTolerance: '=',
            riskIndicators: '=',
            riskScore: '='

        },
        template:   '<div ng-if="mode !== \'hidden\'">' +
        '<highchart ng-if="mode === \'simple\' || mode === \'normal\'" config="chartConfig"></highchart>' +
        '<h6 ng-if="mode === \'score\'" class="text-center no-bottom-margin no-top-margin"><span ng-if="!isUpdating">{{ riskScore }}</span><span ng-if="isUpdating"><i class="fa fa-spinner fa-spin fa-fw" aria-hidden="true"></i></span></h6>' +
        '</div>',
        controller: riskTargetChartCtrl
    };
});

'use strict';

app.controller('AstroLightProspectCtrl', function AstroLightProspectCtrl($scope, dialog) {
    // PRIVATE METHODS
    function csvToObject(data) {
        var rows = data.split(/\r\n|\n/);
        var columnNames = ["ticker", "shares", "value", "purchasePrice", "purchaseDate"];
        var dataLines = rows.slice(1); // remove the header row
        var rawData = dataLines.exclude("").map(parse);
        return rawData.map(function (arr) {
            var dataObject = {};
            columnNames.forEach(function (columnName, i) {
                dataObject[columnName] = isNaN(+arr[i]) ? arr[i] : +arr[i];
            });
            if (dataObject.shares !== undefined) {
                return dataObject;
            }
        });

    }
    function parse(row) {
        var insideQuote = false,
            entries = [],
            entry = [];
        row.split('').forEach(function (character) {
            if (character === '"') {
                insideQuote = !insideQuote;
            } else {
                if (character === "," && !insideQuote) {
                    entries.push(entry.join(''));
                    entry = [];
                } else {
                    entry.push(character);
                }
            }
        });
        entries.push(entry.join(''));
        return entries;
    }

    // PUBLIC METHODS
    $scope.cancel = function () {
        dialog.close(null);
    };

    $scope.close = function () {
        dialog.close
            ({
                displayName: $scope.current.displayName,
                holdings: $scope.holdings
            });
    };

    $scope.onFileSelect = function ($files) {
        $scope.processingFile = true;

        var reader = new FileReader();
        reader.onload = function (loadEvent) {
            var csvContent = loadEvent.target.result;
            $scope.holdings = csvToObject(csvContent);
            $scope.holdings = $scope.holdings.each(function (h) { h.editable = true });
            $scope.processingFile = false;
            $scope.$apply();
        };
        reader.readAsText($files[0]);
    };

    $scope.deleteHolding = function (h) {
        $scope.holdings = $scope.holdings.remove(h);
    };

    $scope.addHolding = function () {
        if (!$scope.holdings)
            $scope.holdings = [];
        $scope.holdings.push({ editable: true, ticker: "", "shares": "", faceValue: "", purchasePrice: "", purchaseDate: null });
    };

    $scope.holdings = [];

    //INITIALIZE
    $scope.current = {
        title: dialog.options.title ? dialog.options.title : 'Prospect',
        displayName: null,
    };
});

'use strict';

app.controller('ModelRestrictionsCtrl', function ModelRestrictionsCtrl($scope, $http, $dialog, dialog) {
    //PRIVATE VARIABLES
    var restrictionUrl = '/Trading/Models/Restrictions';
    var modelId = dialog.options.modelId;
    var subAdvisorDefaultId = dialog.options.subAdvisorDefaultId;
    var isSMAModel = dialog.options.isSMAModel;
    var showSMAFeature = dialog.options.showSMAFeature;

    //PUBLIC METHODS
    $scope.loadRestrictions = function () {
        var queryParams = $scope.current.restrictionType === "model" ? {modelId: modelId} : {subAdvisorDefaultId: subAdvisorDefaultId};

        $http.get(restrictionUrl + '?' + Object.toQueryString(queryParams), {trackerMsg: 'Loading restrictions'})
            .then(function (response) {
                $scope.restrictions = response.data;
            });
    };

    $scope.addRestriction = function () {
        var newRestriction = {entity: "Registration Type"};
        if ($scope.current.restrictionType === "model") {
            newRestriction.modelId = modelId;
            newRestriction.subAdvisorDefaultId = 0;
        } else {
            newRestriction.modelId = 0;
            newRestriction.subAdvisorDefaultId = subAdvisorDefaultId;
        }

        $dialog.dialog({templateUrl: "edit-model-restriction.html", controller: "EditModelRestrictionCtrl", restriction: newRestriction, isSMAModel: isSMAModel, showSMAFeature: showSMAFeature})
            .open()
            .then(function (result) {
                const existingEntity = $scope.restrictions.find(_ => _.entity === result.entity);
                const onlySingleEntityAllowed = [ "Option Level Agreement", "Margin Agreement", "Prime Brokerage" ]

                if ( existingEntity && onlySingleEntityAllowed.find(_ => _ === result.entity) ) { 
                    $dialog.messageBox("Duplicate Restriction",`Only one ${result.entity} restriction is allowed.`).open();
                    
                    return;
                }

                if (result && $scope.restrictions.none({entity: result.entity, entityId: result.entityId})) {
                    $http.post(restrictionUrl, result, {trackerMsg: 'Saving new restriction'})
                        .then(function (response) {
                            $scope.restrictions.add(response.data);
                        });
                }
            });
    };

    $scope.editRestriction = function (restriction) {
        $dialog.dialog({templateUrl: "edit-model-restriction.html", controller: "EditModelRestrictionCtrl", restriction: angular.copy(restriction),isSMAModel: isSMAModel, showSMAFeature: showSMAFeature})
            .open()
            .then(function (result) {
                if (result) {
                    $http.put(restrictionUrl + "/" + result.id, result, {trackerMsg: 'Updating restriction'})
                        .then(function (response) {
                            Object.merge(restriction, response.data);
                        });
                }
            });
    };

    $scope.deleteRestriction = function (restriction) {
        $dialog.confirmAction("Are you sure you want to delete the {entity} - {entityName} restriction?".assign(restriction))
            .open()
            .then(function (result) {
                if (result === "yes") {
                    $http.delete(restrictionUrl + "/" + restriction.id, {trackerMsg: "Deleting restriction"})
                        .then(function () {
                            $scope.restrictions.remove(restriction);
                        });
                }
            });
    };

    $scope.close = function() {
        dialog.close();
    };


    //INITIALIZE
    $scope.current = {restrictionType: "model", hasSubAdvisor: subAdvisorDefaultId ? true : false};
    $scope.loadRestrictions();
});


app.controller('EditModelRestrictionCtrl', function EditModelRestrictionCtrl($scope, $http, dialog, entities) {
    //PUBLIC METHODS
    $scope.loadEntities = function (resetEntityId) {
        $http.get(entities[entities.find({name: $scope.restriction.entity})].simpleUrl, {cache: true, trackerMsg: 'Loading entities'})
            .then(function (response) {
                $scope.entities = response.data;

                if (resetEntityId) {
                    $scope.restriction.entityId = $scope.entities[0].id;
                }
            });
    };

    $scope.save = function () {
        dialog.close($scope.restriction);
    };

    $scope.cancel = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.restriction = dialog.options.restriction;
    $scope.showSMAFeature = dialog.options.showSMAFeature;
    $scope.isSMAModel = dialog.options.isSMAModel;
    $scope.loadEntities($scope.restriction.id ? false : true);
});
'use strict';

app.controller('ModelSubstitutionListSearchCtrl', function ModelSubstitutionListSearchCtrl ($http,$scope,$timeout,$window, dialog) {

    //PRIVATE METHODS
    function init() {
        //setup filters
        $scope.current.filterLists.aggregateModelIdFilterList =  dialog.options.aggregateModelIdFilterList;
        $scope.current.filterLists.modelSubstitutionFilterList = dialog.options.modelSubstitutionFilterList;
        $scope.current.sleeveDetailId = dialog.options.sleeveDetailId;
        $scope.current.substitutes = dialog.options.substitutes;
    }

    function clearSearchResults() {
        $scope.searchText = null;
        $scope.searchData = [];
        $scope.current.selectedItems = [];
    }

    //PUBLIC METHODS
    $scope.close = function () {
        dialog.close(null);
    };

    $scope.save = function () {
        dialog.close($scope.current.substitutes);
    };

    $scope.sortSearch = function( fieldName ) {
        $scope.searchSort.sortField = fieldName;
        $scope.searchSort.sortReverse = !$scope.searchSort.sortReverse;
    };

    $scope.addModelSubstitution = function () {
        var tempItemsToAssign = $scope.searchData.findAll({selected: true});
        if(!tempItemsToAssign.isEmpty()){
            tempItemsToAssign.each(function (item) {
                //make sure not already in list
                if($scope.current.filterLists.aggregateModelIdFilterList.none(item.id) && $scope.current.filterLists.modelSubstitutionFilterList.none(item.id)){
                    $scope.current.substitutes.add({aggregateModelId:item.id, modelAggName:item.name,sleeveStrategyDetailId: $scope.current.sleeveDetailId,canDelete: true});
                }
            });
            clearSearchResults();
        }
    };

    $scope.removeModelSubstitution = function (ms) {
        $scope.current.substitutes.remove(ms);
    };

    $scope.searchModels = function () {
        if($scope.searchText){
            $scope.current.searchInProgress = true;
            $http.get('/Trading/ModelAggs/Search?search=' + $scope.searchText +'&activeOnly=true', null)
                .then(function (response) {
                    $scope.searchData = response.data;
                    $scope.current.searchInProgress = false;
                })
        }else{
            clearSearchResults();
        }
    };

    $scope.selectItem = function(row) {
        row.selected = !row.selected;
        $scope.current.selectedItems = $scope.searchData.findAll({selected: true});
    };

    //INITIALIZE
    $scope.searchSort = { sortField: 'strategy', sortReverse: false };
    $scope.searchData = [];
    $scope.current = {sleeveDetailId: null, searchInProgress:false, selectedItems:[],substitutes:[], currentModelCount: 0, filterLists: {aggregateModelIdFilterList:[], modelSubstitutionFilterList:[]} };

    init();
});
'use strict';

app.controller('SleeveStrategiesRestrictionsCtrl', function SleeveStrategiesRestrictionsCtrl($scope, $http, $dialog, dialog) {
    //PRIVATE VARIABLES
    const restrictionUrl = '/Trading/SleeveStrategy/Restrictions';
    const sleeveStrategyId = dialog.options.sleeveStrategyId;
    const entityId = dialog.options.entityId;
    const entity = dialog.options.entity;
    const subAdvisorDefaultId = null;

    //PUBLIC METHODS
    $scope.loadRestrictions = function () {
        $http.get(`${restrictionUrl}?sleeveStrategyId=${sleeveStrategyId}`, {trackerMsg: 'Loading Sleeve Restrictions'})
            .then((response) => {
                $scope.restrictions = response.data;
            });
    };

    $scope.addRestriction = function () {
        const newRestriction = {entity: entity, entityId: entityId};
        if ($scope.current.restrictionType === "sleeve") {
            newRestriction.sleeveStrategyId = sleeveStrategyId;
            newRestriction.subAdvisorDefaultId = 0;
        } else {
            newRestriction.sleeveStrategyId = 0;
            newRestriction.subAdvisorDefaultId = subAdvisorDefaultId;
        }

        $dialog.dialog({
            templateUrl: "edit-sleeve-restriction.html",
            controller: "EditSleeveRestrictionCtrl",
            restriction: newRestriction
        })
            .open()
            .then(function (result) {
                if (result && $scope.restrictions.none({entity: result.entity, entityId: result.entityId})) {
                    $http.post(restrictionUrl, result, {trackerMsg: 'Saving new restriction'})
                        .then(function (response) {
                            if (response.data.id !== 0){
                                $scope.restrictions.add(response.data);
                            }
                            else {
                                //show validation message
                                $dialog.actionFailed(response.data.validationMessage).open();
                            }
                        });
                }
            });
    };

    $scope.editRestriction = function (restriction) {
        $dialog.dialog({templateUrl: "edit-sleeve-restriction.html", controller: "EditSleeveRestrictionCtrl", restriction: angular.copy(restriction)})
            .open()
            .then(function (result) {
                if (result) {
                    $http.put(restrictionUrl + "/" + result.id, result, {trackerMsg: 'Updating restriction'})
                        .then(function (response) {
                            if (!response.data.validationMessage){
                                Object.merge(restriction, response.data);
                            }
                            else {
                                //show validation message
                                $dialog.actionFailed(response.data.validationMessage).open();
                            }
                        });
                }
            });
    };

    $scope.deleteRestriction = function (restriction) {
        $dialog.confirmAction('Are you sure you want to delete the {entity} - {entityName} restriction?'.assign(restriction))
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.delete(restrictionUrl + "/" + restriction.id, {trackerMsg: "Deleting restriction"})
                        .then(function () {
                            $scope.restrictions.remove(restriction);
                        });
                }
            });
    };

    $scope.close = function() {
        dialog.close();
    };


    //INITIALIZE
    $scope.current = {restrictionType: 'sleeve', hasSubAdvisor: subAdvisorDefaultId ? true : false};
    $scope.loadRestrictions();
});


app.controller('EditSleeveRestrictionCtrl', function EditSleeveRestrictionCtrl($scope, $http, dialog, entities) {
    //PUBLIC METHODS
    $scope.loadEntities = function (resetEntityId) {
        if (!$scope.restriction || !$scope.restriction.entity) {
            return;
        }
        $http.get(entities[entities.find({name: $scope.restriction.entity})].simpleUrl, {cache: true, trackerMsg: 'Loading entities'})
            .then(function (response) {
                $scope.entities = response.data;

                if (resetEntityId) {
                    $scope.restriction.entityId = $scope.entities[0].id;
                }
            });
    };

    $scope.save = function () {
        dialog.close($scope.restriction);
    };

    $scope.cancel = function () {
        dialog.close();
    };

    //INITIALIZE
    $scope.restriction = dialog.options.restriction;
    $scope.loadEntities($scope.restriction.id ? false : true);
});

'use strict';

app.service('$rebalance', function ($location, $tradeGenerator) {
    var config;

    this.getCurrent = function () {
        return config;
    };

    this.reset = function () {
        config = null;
    };

    this.start = function (type, selectedIds, amount) {
        config = {type: type, selectedIds: selectedIds, amount: amount};

        return $tradeGenerator.getTradeDefinition("Rebalance")
            .then(function () {
                $location.path(($location.url().startsWith('/embed') ? '/embed' : '') + '/trading/rebalance');
            });
    };
});

app.service('$tactical', function ($location) {
    var config;

    this.getCurrent = function () {
        return config;
    };

    this.reset = function () {
        config = null;
    };

    this.start = function (mode, selectedIds, usePendingValue, closedOrders) {
        config = {mode: mode, selectedIds: closedOrders ? closedOrders.map('accountId').unique(): selectedIds, usePendingValue: usePendingValue, closedOrders: closedOrders};
        $location.path('/trading/tacticaltrades');
    };

    this.startHousehold = function (selectedHousehold, usePendingValue) {
        config = {mode: "household", selectedHousehold: selectedHousehold, usePendingValue: usePendingValue};
        $location.path('/trading/tacticaltrades');
    }
});

app.service('$proratedCashTrades', function ($location) {
    var config;

    this.getCurrent = function () {
        return config;
    };

    this.reset = function () {
        config = null;
    };

    this.start = function (selectedIds, amount) {
        config = {selectedIds: selectedIds, amount: amount};
        $location.path('/trading/proratedcashtrades');
    };
});


'use strict';
let stopProcessing = false;
app.factory('$tradeGenerator', function ($rootScope, $http, $timeout, $userMessages) {

    //PRIVATE METHODS
    function generateTrades(tradeDefinition, isBlockMode, sendNow) {
        return $http.post("/Trading/GenerateTrades?sendNow=" + (angular.isDefined(sendNow) ? sendNow : false), tradeDefinition, {trackerMsg: 'Submitting trade generation request'})
            .then(function (response) {
                startPollingStatus(response.data, isBlockMode);
                return response.data;
            });
    }

    function generateOptionTrades(tradeDefinition) {
        return $http.post("/Trading/Orders/Action/CreateOptionTradeFile", tradeDefinition, {trackerMsg: 'Submitting Option Trades generation request'})
            .then(function (response) {
                startPollingStatus(response.data, false);
                return response.data;
            });
    }

    function generateContributions(contributionList) {
        return $http.post('/Trading/Contributions' , contributionList, {trackerMsg: 'Submitting contributions'})
            .then(function (response) {
                return response.data;
            });
    }

    function showMessageAndPoll(batchId, isBlockMode) {
        $http.get("/Trading/TradeGenerationStatus/" + batchId + "?includeErrors=true", { ignoreExceptions: true })
            .then(function (response) {
                var data = response.data;
                const msg = 'Processing ID: ' + batchId + '. Getting your data ready now. For a large amount of registrations, this could take several minutes.';

                if (data.itemsCompleted === 0 && !stopProcessing) {
                    $rootScope.$broadcast('event:status-update', { id: batchId, isDone: false, msg: msg, showClose: false });
                    $timeout(function () { showMessageAndPoll(batchId, isBlockMode); }, 5000);
                }
                else if (!stopProcessing) {
                    killMessageOnError(batchId);
                    startPollingStatus(batchId, isBlockMode);
                }
            });
    }

    function killMessageOnError(batchId) {
        $rootScope.$broadcast('event:status-update', { id: batchId, isDone: true, msg: '', showClose: true })
        stopProcessing = true;
    }

    function startPollingStatus(batchId, isBlockMode) {
        var lastData;
        var parentId;
        var sameDataCount = 0;
        var errorCount = 0;

        var pollStatus = function (batchId) {
            if (sameDataCount > 200) {
                $rootScope.$broadcast('event:progress-update', {id: parentId, isDone: true, msg: parentId + ": Status updates aborted", type: "warning"});
                $userMessages.addTradingMsg(parentId + ": Took too long", "The process is taking longer than expected.  Status polling has been aborted.", "warning");
                return;
            }

            if (errorCount > 25) {
                if (parentId) $rootScope.$broadcast('event:progress-update', {id: parentId, isDone: true, msg: parentId + ": Status updates aborted", type: "warning"});
                $userMessages.addTradingMsg(parentId + ": Status polling failed", "The status check has erred out 25 times.  Status polling has been aborted.", "warning");
                return;
            }

            $http.get("/Trading/TradeGenerationStatus/" + batchId + "?includeErrors=true", {ignoreExceptions: true})
                .then(function (response) {
                    var data = response.data;
                    parentId = parentId || data.parentId;

                    if (angular.equals(data, lastData)) {
                        sameDataCount += 1;
                        $timeout(function() { pollStatus(batchId); }, 5000);
                        return;
                    }

                    sameDataCount = 0;

                    var progress = {id: batchId, completed: data.itemsCompleted, total: data.totalItems};

                    if (data.isDone) {
                        progress.isDone = true;  //forced in case completed != total or both are zero
                        var objName = isBlockMode ? "blocks" : "orders";
                        var eventArgs = {action: "new-data", newDataUrl: isBlockMode ? "/Trading/FixBatches/" + parentId + "/FixBlockOrders" : "/Trading/Instances/" + parentId + "/Orders"};

                        switch (data.status) {
                            case "Complete":
                                $rootScope.$broadcast('event:' + objName + '-generated', eventArgs);
                                $rootScope.$broadcast('event:' + objName + '-success', data);
                                progress.type = "success";
                                progress.msg = batchId + ": Completed successfully";
                                break;
                            case "Partially Complete":
                                $rootScope.$broadcast('event:' + objName + '-generated', eventArgs);
                                $rootScope.$broadcast('event:' + objName + '-error', data);
                                progress.type = "warning";
                                progress.msg = batchId + ": Partially complete";
                                break;
                            case "Failed":
                                $rootScope.$broadcast('event:' + objName + '-error', data);
                                progress.type = "danger";
                                progress.msg = batchId + ": Failed";
                                break;
                        }

                        $userMessages.addTradingMsg(batchId + ": " + data.itemsCompleted + " " + objName + " generated", data.message, progress.type);
                    }
                    else
                        $timeout(function() { pollStatus(batchId); }, 5000);

                    $rootScope.$broadcast('event:progress-update', progress);
                    lastData = data;
                })
                .catch(function () {
                    errorCount += 1;
                    $timeout(function() { pollStatus(batchId); }, 20000);
                });
        };

        pollStatus(batchId);
    }

    function getTradeDefinition(routine) {
        return $http.get("/Trading/TradeDefinition?routine=" + routine, {cache: true, trackerMsg: 'Loading default trade settings'})
            .then(function (response) {
                return response.data;
            });
    }

    return {
        getTradeDefinition: function (routine) {
            return $http.get("/Trading/TradeDefinition?routine=" + routine, {cache: true, trackerMsg: 'Loading default trade settings'});
        },
        submitTradeDefinition: function (definition) {
            return generateTrades(definition);
        },
        generateContributions: function (definition) {
            return generateContributions(definition);
        },
        submitOptionTradesDefinition: function (definition) {
            return generateOptionTrades(definition);
        },
        rebalance: function (accountIds, nsccTransactionType) {
            return getTradeDefinition("Rebalance")
                .then(function (definition) {
                    return generateTrades(angular.extend(definition, {nsccTransactionType: nsccTransactionType || "NormalPurchase", keys: angular.isArray(accountIds) ? accountIds : [accountIds], entity: "Account", reason: "NeedReview"}));
                });
        },
        buyRebalance: function (accountId, dollars, nsccTransactionType) {
            return getTradeDefinition("Rebalance")
                .then(function (definition) {
                    return generateTrades(angular.extend(definition, {nsccTransactionType: nsccTransactionType, keys: [accountId], entity: "Account", reason: "Add", amounts: [dollars]}));
                });
        },
        sellRebalance: function (accountId, dollars) {
            return getTradeDefinition("Rebalance")
                .then(function (definition) {
                    return generateTrades(angular.extend(definition, {keys: [accountId], entity: "Account", reason: "Withdraw", amounts: [dollars]}));
                });
        },
        buy: function (accountId, productId, type, amount, nsccTransactionType, sendNow) {
            return getTradeDefinition("QuickTrade")
                .then(function (definition) {
                    return generateTrades(angular.extend(definition, {nsccTransactionType: nsccTransactionType, trades: [{accountID: accountId, productID: productId, tradeType: type, amount: amount, side: "1"}]}), false, sendNow);
                });
        },
        sell: function (accountId, productId, type, amount, sendNow) {
            return getTradeDefinition("QuickTrade")
                .then(function (definition) {
                    return generateTrades(angular.extend(definition, {trades: [{accountID: accountId, productID: productId, tradeType: type, amount: amount, side: "2"}]}), false, sendNow);
                });
        },
        exchange: function(accountId, sellProductId, buyProductId, type, amount, nsccTransactionType) {
            return getTradeDefinition("BuySell")
                .then(function (definition) {
                    return generateTrades(angular.extend(definition, {nsccTransactionType: nsccTransactionType, trades: [{accountID: accountId, productIDFrom: sellProductId, productIDTo: buyProductId, tradeType: type, amount: amount, nsccTransactionType: nsccTransactionType}]}));
                });
        },
        liquidateAccount: function (accountId) {
            return getTradeDefinition("SellAll")
                .then(function (definition) {
                    return generateTrades(angular.extend(definition, {accounts: [accountId]}));
                });
        },
        importTrades: function (assetValues, trades, fileName) {
            return getTradeDefinition("QuickTrade")
                .then(function (definition) {
                    return generateTrades(angular.extend(definition, {trades: trades, assetValues: assetValues, filename: fileName}));
                });
        },
        importExchange: function( trades, nsccTransactionType ) {
            return getTradeDefinition("BuySell")
                .then(function (definition) {
                    return generateTrades(angular.extend(definition, {nsccTransactionType: nsccTransactionType, trades: trades }));
                });
        },
        buyBlock: function (custodianId, productId, orderQty, strikePrice, cfiCode, orderCapacity, positionEffect, maturityDate, solicited) {
            return getTradeDefinition("QuickTradeBlock")
                .then(function (definition) {
                    return generateTrades(angular.extend(definition, {trades: [{custodianID: custodianId, productID: productId, orderQty: orderQty, strikePrice: strikePrice, cfiCode: cfiCode, orderCapacity: orderCapacity, positionEffect: positionEffect, maturityDate: maturityDate, solicited: solicited, side: "1"}]}), true);
                });
        },
        sellBlock: function (custodianId, productId, orderQty, strikePrice, cfiCode, orderCapacity, positionEffect, maturityDate, solicited) {
            return getTradeDefinition("QuickTradeBlock")
                .then(function (definition) {
                    return generateTrades(angular.extend(definition, {trades: [{custodianID: custodianId, productID: productId, orderQty: orderQty, strikePrice: strikePrice, cfiCode: cfiCode, orderCapacity: orderCapacity, positionEffect: positionEffect, maturityDate: maturityDate, solicited: solicited, side: "2"}]}), true);
                });
        },
        sleeveStrategyMessageAndPoll: function (batchId, isBlockMode) {
            return showMessageAndPoll(batchId, isBlockMode);
        },
        sleeveStrategykillMessageOnError: function (batchId) {
            return killMessageOnError(batchId);
        },
        startPolling: startPollingStatus
    };
});

var convexRebalanceAccountListCtrl =  app.controller('ConvexRebalanceAccountListCtrl', function ConvexRebalanceAccountListCtrl($scope, $http, $route, $rebalance, $settings, $timeout,$dialog,$location,$portfolio, $dataQuery,$window, entities, views, $oasRights) {
    //PRIVATE VARIABLES



    //PRIVATE METHODS
    function init() {
        $scope.rightsConvexRebalance = $oasRights.forCode("CONVEXREBALANCE");
    }


    //PUBLIC METHODS
    $scope.openConvexRebalanceAccountEditor = function() {
        $scope.isChildModalOpened = true;
        var dialogOpts = {
            templateUrl: "convex-rebalance-account-editor.html",
            controller: "ConvexRebalanceAccountEditCtrl",
            account: $scope.current.selectedAccount
        };
        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function(rslt){
                if(rslt){
                    $scope.$broadcast('event:convex-rebalance-account-list-action', {action: 'refresh-grid'});
                }
                $scope.isChildModalOpened = false;
            })
    };

    
    $scope.addGridQueryFilter = function(filterName){
        var tempFilter = null;
        switch (filterName){
            case 'AccountsWithModelChange':
              tempFilter = { id: "CUSTOM_1", name: "Accounts With Model Change", filterFn: function(x) {
                  return x && x == 'Model Change Required';
              },field: "message", enabled: true, visible: true, itemCount:0 };
              break;
            case 'CushionPercentLessThanZero':
                tempFilter = { id: "CUSTOM_2", name: "Accounts that violate floor", filterFn: function(x) {
                    return x && x < 0;
                },field: "cushionPercent", enabled: true, visible: true, itemCount:0 };
                break;
            case 'CushionPercentLessThan5Percent':
                tempFilter = { id: "CUSTOM_3", name: "Accounts within 5% of floor", filterFn: function(x) {
                    return x && x >= 0 && x <= .05;
                },field: "cushionPercent", enabled: true, visible: true, itemCount:0 };
                break;
            case 'CushionPercentLessThan10Percent':
                tempFilter = { id: "CUSTOM_4", name: "Accounts within 10% of floor", filterFn: function(x) {
                    return x && x >= .05 && x <= .1;
                },field: "cushionPercent", enabled: true, visible: true, itemCount:0 };
                break;
            default:
                tempFilter = {};
        }
        if(tempFilter){
            $scope.current.gridQueries.push(tempFilter);
        }
    };

    function prepareQuery (){
        var dq = $dataQuery.getDataQuery("9364");
        var tempPrompt = dq.prompts.find({code:'@pkAccount'});
        tempPrompt.defaultValue = $scope.selectedIds.join(",");
        $dataQuery.setDataQuery(dq);

        $dataQuery.createFile('xlsx', downloadFile)
    }



    function downloadFile(url) {
        $window.location.href = url + "?Authorization=" + sessionStorage.oas_token;
    }
    $scope.runReport = function(reportName){
        var rName = null;
        var reportArgs = {};
        switch (reportName) {
            case 'HistoricalDetailForAccount':
                //9364 - test report id
                $dataQuery.loadQuery("9364", prepareQuery);
                break;
            case 'HistoricalValue':
                    reportArgs.EntityEnum = "7";
                    reportArgs.PkEntity = $scope.selectedIds[0];
                    $dialog.reportPrompt(3751, reportArgs).open();
                break;
            case 'ModelChange':
                var report = null;
                $http.get('/Reporting/Reports/3752/Parameters?runAssignedVersion=true', {trackerMsg: 'Getting report parameters'})
                    .then(function (response) {
                        report = response.data;
                        report.runTo = {storageType: "DirectDownload"};
                        $http.post('/Reporting/Reports/3752'  + "/Generate", report, {trackerMsg: 'Generating report'})
                            .then(function (response) {
                                if (report.runTo.storageType === "DirectDownload") {
                                    window.location.href = response.headers("location") + (response.headers("location").has("?") ? "&" : "?") + "Authorization=" + sessionStorage.oas_token;
                                } else {
                                    $scope.current.messages.push({name: report.reportName, runTo: report.runTo.displayName});
                                }
                            });
                    });
                break;
            case 'ConvexRebalanceTolerance':
                reportArgs.EntityEnum = "7";
                reportArgs.PkEntity = "";
                $dialog.reportPrompt(3753, reportArgs).open();
                break;
        }
    };

    $scope.convexRecalculate = function (allAccounts){

        var msg = !allAccounts ? "Are you sure you want to update the account?" : "This will cause the convex account history to be deleted and recalculated from the inception date. Are you sure you want to continue?";

        var executeConvexRebalanceAccount = function(){
            var accountIds = allAccounts ? null : $scope.selectedIds[0];
            var msg = allAccounts ? 'Recalculating all accounts' : 'Recalculating selected account';
            var url = allAccounts ?  '/Trading/ConvexRebalanceAccount/CalculateAccount?recalcHistory=true' : '/Trading/ConvexRebalanceAccount/CalculateAccount?key=' + accountIds;
            $http.post(url, {trackerMsg: msg})
                .then(function (response) {
                    $dialog.messageBox('Convex Rebalance Account', 'Success!  Procedure has finished.')
                        .open()
                        .then(function (result) {
                            $scope.$broadcast('event:convex-rebalance-account-list-action', {action: 'refresh-grid'});
                        })
                })

        };

        $dialog.confirmAction(msg)
            .open()
            .then(function (result) {
                if (result == 'yes') {
                    executeConvexRebalanceAccount();
                }
            })
    };
    
    $scope.goToAccount = function( urlLevel ) {
        $portfolio.goTo( urlLevel, entities.account.value,  $scope.selectedIds[0]);
    };

    $scope.refreshGrid = function () {
        $timeout(function () {$scope.$broadcast('event:convex-rebalance-account-list-action', {action: 'refresh-grid'});});
    };

    $scope.resetWidth = function(goWide) {
        $scope.rightSidebar.width = goWide ? 500 : 250;
    };

    $scope.$on('event:rows-selected', function (e, args) {
        e.stopPropagation();
        if (args.length === 0) return;

        $scope.selectedIds = args.map('id');
        $scope.current.selectedAccount = args[0];

    });

    //INITIALIZE
    $scope.selectedIds = [];
    $scope.views = views;
    $scope.current = {view: views[0], refreshGrid: false, filteredItemCount: 0};
    $scope.current.gridQueries = [];
    $scope.isChildModalOpened = false;
    init();
});

 app.controller('ConvexRebalanceAccountEditCtrl', function ConvexRebalanceAccountEditCtrl($http,$scope, $route,$dialog, dialog,$oasRights, $location){

     var currentAccountOriginal = angular.copy(dialog.options.account);

    function init(){
        setCurrentAccount(dialog.options.account);
    }

     $scope.runHistoricalReport = function(){
         $location.url('/reports/prompt/3751?EntityEnum=7&PkEntity=' + $scope.current.account.id );
         dialog.close(null);
     };

     $scope.cancel = function(){
         dialog.close(null);
     };

     function getMaxFactorGrowthHistoryRecord(){
         var temp = $scope.current.account.drawdown.max('effectiveDate');
         if(temp){
             $scope.current.factorGrowth =  angular.copy(temp);
         }
     }

    $scope.removeHistoryRow = function(itemToRemove){
        $scope.current.account.drawdown.remove(itemToRemove);
    };

     $scope.setEditMode = function(){
        $scope.isEditMode = !$scope.isEditMode;

     };

     
     $scope.update = function(isUpdateOnly){
         $scope.isChildModalOpened = true;

         var msg = isUpdateOnly ? "Are you sure you want to update the account?" : "This will cause the convex account history to be deleted and recalculated from the inception date. Are you sure you want to continue?";

         $dialog.confirmAction( msg )
             .open()
             .then( function( result ) {
                 if (result == 'yes') {
                     //isUpdateOnly == true will just update the account with no history changes, isUpdateOnly == false will trigger a delete and rebuild of history
                     convexRecalculate(!isUpdateOnly);
                 }
                 $scope.isChildModalOpened = false;
             });
     };

     $scope.save = function() {
         $dialog.confirmAction( "Are you sure you want to update the account?" )
             .open()
             .then( function( result ) {
                 if (result == 'yes') {
                     //update record
                     $http.put('/Trading/ConvexRebalanceAccount/' + $scope.current.account.id, $scope.current.account, {trackerMsg:'Updating Account....'})
                         .then(function(response){
                             setCurrentAccount(response.data[0]);
                         })
                 }else {
                     setCurrentAccount(currentAccountOriginal);
                 }
             });
     };

     $scope.updateFactorGrowthTable = function(update){
         if(update){
             $scope.current.factorGrowth.accountId = $scope.current.account.id;
             $scope.current.factorGrowth.effectiveDate = Date.create(new Date()).format('{yyyy}-{MM}-{dd}T{hh}:{mm}:{ss}');

             //Check to see if there's a match
             var recordCheck = $scope.current.account.drawdown.find(function(x){
                 return x['factor'] ==  $scope.current.factorGrowth.factor && x['maxRiskPercent'] == $scope.current.factorGrowth.maxRiskPercent;
             });
             // Only add if factor and max risk percent values are not in array
             if(!recordCheck){
                 $scope.current.account.drawdown.add($scope.current.factorGrowth);
             }
             $scope.setEditMode();
         }
     };

     function convexRecalculate (reCalcHistory){
         var msg = !reCalcHistory ? 'Updating accounts' : 'Recalculating accounts';
         var singleAccount = !reCalcHistory ? $scope.current.account.id : null;
         var url = !reCalcHistory ? '/Trading/ConvexRebalanceAccount/CalculateAccount?key=' + singleAccount + '&recalcHistory='+ reCalcHistory :
             '/Trading/ConvexRebalanceAccount/CalculateAccount';

         $http.post(url, {trackerMsg: msg})
             .then(function(response){
                 $dialog.messageBox('Convex Rebalance Account', 'Success!  Procedure has finished.')
                     .open()
                     .then(function(result){
                         dialog.close($scope.current.account);
                     })
             })
     }

     function setCurrentAccount(data){
         $scope.current.account = data;

         //Format some properties
         $scope.current.account.currentRisk = $scope.current.account.currentRisk.round(3) * 100;
         $scope.current.account.lastUpdate = Date.create($scope.current.account.lastUpdate).format('{yyyy}-{MM}-{dd}T{hh}:{mm}:{ss}');

         getMaxFactorGrowthHistoryRecord();
     }

    $scope.rightsCRAccountEdit = $oasRights.forCode("CONVEXREBALANCE");
    $scope.isEditMode = false;

    $scope.current = {account: null, showFilterRowFactorGrowth: false, factorGrowth:{}};

    init();
});

'use strict';

app.controller('GlobalTradesCtrl', function GlobalTradesCtrl($scope, $http, $tradeGenerator, $location) {
    //PRIVATE VARIABLES
    var tradeGroups;


    //PRIVATE METHODS
    function initialLoad() {
        $tradeGenerator.getTradeDefinition("GlobalTrades")
            .then(function (response) {
                if ($scope.isTaxTickerSwap) {
                    response.data.useGainLossFiltering = true;
                    response.data.gainLossTradeSettings = {gainLossTerm: "ShortTermAndLongTerm", value1: 5, gainLossValueType: "Percent", gainsOrLosses: "gains", includeQualified: false};
                }
                $scope.tradeDefinition = response.data;

                $http.get("/Portfolio/FundFamilies/Simple", {cache: true, trackerMsg: 'Loading fund families'})
                    .then(function (response) {
                        response.data.insert({id: 0, name: "All Fund Families"}, 0);
                        $scope.fundFamilies = response.data;
                        $scope.current.fundFamilyID = response.data[0].id;
                    });

                $http.get("/Portfolio/Platforms/Simple", {cache: true, trackerMsg: 'Loading management styles'})
                    .then(function (response) {
                        $scope.managementStyles = response.data;
                    });

                $http.get("/Trading/ModelAggs/Simple?excludeSelfDirected=true", {cache: true, trackerMsg: 'Loading models'})
                    .then(function (response) {
                        $scope.models = response.data;
                    });

                $http.get("/Utility/Groupings?usedFor=Trading", {cache: true, trackerMsg: 'Loading trade groups'})
                    .then(function (response) {
                        tradeGroups = response.data;
                    });

                $http.get("/Settings/Database/EntityOptions/Code/TRADERSNREQ", {cache: true, trackerMsg: 'Loading requirements'})
                    .then(function (response) {
                        $scope.current.isReasonRequired = response.data.value.toLowerCase() === "true";
                    });
            });
        
        setAccountSelection();
    }

    function setAccountSelection() {
        switch($scope.current.accountSelectionType) {
            case 0:
                $scope.current.selectionTypeName = "fund family";
                resetTrades();
                break;
            case 3:
                $scope.current.selectionTypeName = "models";
                fillAvailableItems($scope.models);
                break;
            case 4:
                $scope.current.selectionTypeName = "management styles";
                fillAvailableItems($scope.managementStyles);
                break;
            case 5:
                $scope.current.selectionTypeName = "trade groups";
                fillAvailableItems(tradeGroups);
                break;
            default:
                $scope.current.selectionTypeName = "accounts";
                resetSelectedItems();
        }
    }

    function fillAvailableItems(sourceList) {
        $scope.current.availableItemsFilter = "";
        $scope.current.availableItems = angular.copy(sourceList);
        $scope.current.availableSelected = [];
        resetSelectedItems();
    }

    function resetSelectedItems() {
        $scope.current.selectedItems = [];
        $scope.current.selectedSelected = [];
        resetTrades();
    }

    function resetTrades() {
        $scope.current.trades = [];
    }

    //PUBLIC METHODS
    $scope.back = function() {
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep -= 1;
    };

    $scope.next = function() {
        $scope.current.animation = 'slide-right';
        $scope.current.wizardStep += 1;
    };

    $scope.jumpBackTo = function(index) {
        if ($scope.current.executing) return;

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };

    $scope.isStepIncomplete = function() {
        switch ($scope.current.wizardStep) {
            case 0:
                return !$scope.tradeDefinition;
            case 1:
                switch ($scope.current.accountSelectionType) {
                    case 0: //fund family
                        return false;
                    case 2: //excel import
                        return $scope.current.selectedItems.count({isValid: true}) === 0;
                    default:
                        return $scope.current.selectedItems.length === 0;
                }
            case 2:
                return $scope.current.trades.length === 0;
            default:
                return false;
        }
    };

    $scope.moveSome = function(selectedItems, from, to) {
        angular.forEach(selectedItems, function(item) {
            var index = from.indexOf(item);
            if (index !== -1) {
                from.splice(index, 1);
                to.push(item);
            }
        });
        selectedItems.length = 0;
    };

    $scope.moveAll = function(from, to, selectedItems, filter) {
        if (filter) {
            filter = filter.toLowerCase();
            $scope.moveSome(from.findAll(function(item) {return item.name.toLowerCase().indexOf(filter) != -1;}), from, to);
            $scope.current.availableItemsFilter = "";
        }
        else {
            angular.forEach(from, function(item) {
                to.push(item);
            });
            from.length = 0;
        }

        selectedItems.length = 0; //in case they selected some and then did move all
    };

    $scope.addSelectedAccount = function() {
        if ($scope.current.selectedItems.none({id: $scope.current.selectedAccount.id})) {
            $scope.current.selectedItems.push($scope.current.selectedAccount);
        }
        $scope.current.selectedAccount = null;
    };

    $scope.updatePercentValidator = function(updatedTrade) {
        var totalPercent = 0;
        $scope.current.trades.findAll({sellProduct: updatedTrade.sellProduct}).forEach(function (trade) {
            totalPercent += trade.percent;
        });

        if (totalPercent > 100)
            updatedTrade.percent = updatedTrade.percent - (totalPercent - 100);
    };

    $scope.addTrade = function() {
        var buyProduct = $scope.current.buyProduct ? $scope.current.buyProduct : {productId: -1, ticker: "CASH", productName: "Custodial Cash"};
        var totalAccounts = 0; 
        var matchedTrade = false;
        var totalPercent = $scope.current.percent = $scope.current.percent || 100;
        
        if ($scope.current.percent <= 0) {
            $scope.disabledTradeMsg = "The trade cannot have a zero percent value.";
            return;
        }

        if ($scope.current.buyProduct && angular.equals($scope.current.sellProduct, $scope.current.buyProduct)) {
            $scope.disabledTradeMsg = "The sell product and buy product cannot be the same.";
            return;
        }

        $scope.current.trades.findAll({sellProduct: $scope.current.sellProduct}).forEach(function (trade) {
            totalPercent += trade.percent;
            if (angular.equals(trade.buyProduct, buyProduct)) matchedTrade = true;

            totalAccounts = trade.accounts;
        });

        if (matchedTrade) {
            $scope.disabledTradeMsg = "A trade with this sell product and buy product already exists.";
            return;
        }

        if (totalPercent > 100) {
            $scope.disabledTradeMsg = "The total for the sell product cannot exceed 100%.";
            return;
        }

        var addToTradeList = function() {
            $scope.disabledTradeMsg = "";
            $scope.current.trades.push({accounts: totalAccounts, sellProduct: $scope.current.sellProduct, buyProduct: buyProduct, percent: $scope.current.percent});
            $scope.current.buyProduct = null;
            $scope.current.percent = null;
            $scope.current.isDisabled = false;
        };

        //disable the button so a trade can't be rapid-fire clicked and duplicated
        $scope.current.isDisabled = true;

        if (totalAccounts > 0) {
            addToTradeList();
        }
        else {
            switch ($scope.current.accountSelectionType) {
                case 0: case 3: case 4:
                    let url = "/Trading/GlobalTradeCount";
                    let postData = {};

                    postData.sellProductId = $scope.current.sellProduct.productId;
                    postData.fundFamilyID = $scope.current.fundFamilyID;

                    if ($scope.current.accountSelectionType === 0) {
                        if ($scope.current.managementStyles.length > 0) {
                            postData.managementStyleList = $scope.current.managementStyles;
                        }
                        if ($scope.current.modelAggs.length > 0) {
                            postData.modelAggList = $scope.current.modelAggs;
                        }
                    } else {
                        let ids = $scope.current.selectedItems.map("id");

                        if ($scope.current.accountSelectionType === 3) {
                            postData.modelAggList = ids;
                        } else if ($scope.current.accountSelectionType === 4) {
                            postData.managementStyleList = ids;
                        }
                    }

                    $http.post(url, postData, {trackerMsg: 'Confirming accounts exist for sell product'})
                        .then(function (response) {
                            if (response.data > 0) {
                                totalAccounts = parseInt(response.data);
                                addToTradeList();
                            }
                            else {
                                $scope.disabledTradeMsg = "There are no accounts that have this sell product.";
                            }
                        });
                    break;
                case 1: case 2:  //TODO: do validation look up for account list?
                    totalAccounts = $scope.current.selectedItems.length;
                    addToTradeList();
                    break;
                case 5: //TODO: do validation look up for group list?
                    totalAccounts = "Group";
                    addToTradeList();
                    break;
            }
        }
    };

    $scope.removeTrade = function(index) {
        $scope.current.trades.splice(index, 1);
    };
    
    $scope.submitTrades = function() {
        $scope.current.executing = true;
        $scope.tradeDefinition.trades = [];
        $scope.tradeDefinition.filename = $scope.current.importFile;

        var pkList = [];
        if ($scope.current.accountSelectionType !== 0) {
            $scope.current.selectedItems.forEach(function (item) {
                if (item.isValid !== false) pkList.push(item.id);
            });
        }

        if ($scope.current.accountSelectionType === 5) {
            $scope.tradeDefinition.keys = pkList;
            $scope.tradeDefinition.entity = "DynamicGrouping";
        }
        else {
            $scope.tradeDefinition.keys = null;
            $scope.tradeDefinition.entity = null;
        }

        $scope.current.trades.forEach(function (trade) {
            var existingTrade = $scope.tradeDefinition.trades.find({productFromID: trade.sellProduct.productId});

            if (!existingTrade) {
                var newTrade = {productFromID: trade.sellProduct.productId, productFromStatus: -1, productsToBuy: [{productID: trade.buyProduct.productId, tradePercent: trade.percent, status: -1}]};
                switch ($scope.current.accountSelectionType) {
                    case 0:
                        newTrade.fundFamilyID = $scope.current.fundFamilyID;
                        newTrade.managementStyles = $scope.current.managementStyles;
                        newTrade.modelAggs = $scope.current.modelAggs;
                        break;
                    case 3:
                        newTrade.modelAggs = pkList;
                        break;
                    case 4:
                        newTrade.managementStyles = pkList;
                        break;
                    case 5:
                        //do nothing
                        break;
                    default:
                        newTrade.includedAccounts = pkList;
                }

                $scope.tradeDefinition.trades.push(newTrade);
            }
            else {
                existingTrade.productsToBuy.push({productID: trade.buyProduct.productId, tradePercent: trade.percent, status: -1});
            }
        });

        $tradeGenerator.submitTradeDefinition($scope.tradeDefinition)
            .then(function() {
                $location.path('/trading/tom/orders');
            }, function () {
                $scope.current.executing = false;
            }
        );
    };

    //INITIALIZE
    $scope.current = {accountSelectionType: 0, wizardStep: 0, animation: 'slide-right', executing: false, selectedAccount: null, availableItems: [], availableSelected: [], selectedItems: [], selectedSelected: [], fundFamilyID: null, managementStyles: [], modelAggs: [], sellProduct: null, buyProduct: null, percent: null, trades: []};
    $scope.wizardSteps = [ "Selection Method", "Filter Selections", "Create Trades", "Batch Options" ];
    $scope.isTaxTickerSwap = $location.path().toLowerCase().indexOf("taxtickerswap") !== -1;
    initialLoad();

    //WATCHES
    $scope.$watch("current.accountSelectionType", function (newValue, oldValue) {
        if (newValue === oldValue) return;

        setAccountSelection();
    });
});
'use strict';

app.controller('ModelCtrl', function ModelCtrl($scope, $http, $routeParams, $location, $rebalance, listSectionData, $dialog, $window, $oasRights, $timeout, splitIoService) {
    //PRIVATE VARIABLES
    var modelId = $routeParams.modelId;
    var modelUrl = '/Trading/Models/' + modelId + '?includeAccounts=false';
    var addAccountEvent = "event:add-account";
    var rebalanceSelectedEvent = "event: rebalance-selected";
    var dataItemsEvent = "event: data-items";
    var fundFamilyIdOld = 0;
    var isCopy = $routeParams.isCopy === 'true';
    var fromModelId = $routeParams.fromModelId;

    splitIoService.getBoolTreatment('OC_model_eclipseID_237410').subscribe((isEnabled) => {
        $scope.current.eclipseSyncedModelFeatureFlag = isEnabled;
    });

    $scope.assetClassFieldMap = [{ name: "ID", value: "id" }, { name: "Name", value: "name" }, { name: "Description", value: "description" }, { name: "Category", value: "category" }, { name: "Provider", value: "productDescriptionProviderName" }];
    $scope.riskCategoryFieldMap = [{ name: "ID", value: "id" }, { name: "Abbreviation", value: "abbreviation" }, { name: "Name", value: "fullName" }, { name: "Provider", value: "productDescriptionProvider" }];

    //PRIVATE METHODS
    function init() {
        $scope.current.eclipseSyncedModel = false;

        if ($scope.user.authorization.entity === "Sub Advisor") {
            $scope.current.isSubAdvisor = true;
        }

        if ($scope.rangeRights.canRead) {
            $http.get("/Settings/UserDefinedFields/Definitions/ModelRanges", {cache: true, trackerMsg: 'Loading model range defaults'})
                .then(function (response) {
                    $scope.modelRangeUdfs = response.data.map(function (udfDefinition) {
                        return {
                            entity: "Model Range",
                            entityId: 0,
                            name: udfDefinition.description,
                            category: udfDefinition.category,
                            type: udfDefinition.type,
                            code: udfDefinition.code,
                            sequence: udfDefinition.sequence,
                            value: udfDefinition.defaultValue,
                            options: udfDefinition.options,
                            input: udfDefinition.customObject,
                            securityCode: udfDefinition.securityCode
                        };
                    });
                });
        }

        if (modelId <= 0) {
            $scope.addBreadcrumb("New Model");
            modelEntityOption();
            listSectionData.dataItems = [];
            $scope.model = {
                id: 0,
                name: "",
                class: "",
                fundFamilyId: 0,
                custodianId: 0,
                modelNum: 0,
                percEquity: 0,
                modelType: 0,
                fundList: "",
                modelTol: 0,
                cashPerc: 0,
                cashTol: 0,
                isActive: true,
                createdDate: "",
                createdBy: "",
                editedDate: "",
                editedBy: "downloaddefaults@orionadvisor.com",
                groupNum: "",
                modelCode: null,
                managementStyleId: 0,
                lastRebalanced: "2012-08-30T16:43:48.453",
                isDynamic: false,
                dynamicEffectiveDate: "",
                subAdvisorId: $scope.current.isSubAdvisor ? $scope.user.authorization.entityId : null,
                items: [],
                accounts: [],
                ranges: [],
                isSMA: false,
                assetClassId: null,
                riskCategoryId: null
            };

            if(isCopy){
                var copyModelUrl = '/Trading/Models/' + fromModelId + '?includeAccounts=false';
                $http.get(copyModelUrl, {trackerMsg: 'Copying model data to new model'})
                    .then(function (response) {
                        $scope.model = response.data;
                        $scope.model.id = 0; //new model from
                        $scope.model.name = 'Copy of ' + response.data.name;

                        $scope.addBreadcrumb($scope.model.name);

                        listSectionData.dataItems = response.data.accounts;

                        $scope.$broadcast(dataItemsEvent);

                        $scope.calculateModelRiskScore();
                        $scope.totalAllocationPercents();
                    });
            }

        } else {
            $http.get(modelUrl, {trackerMsg: 'Loading model'})
                .then(function (response) {
                    $scope.current.showUseRestrictions = $oasRights.canRead("MODELRESTRICTIONS");

                    modelEntityOption();

                    $scope.model = response.data;

                    if($scope.model.eclipseModelId > 0 && $scope.model.eclipseFirmId > 0) {
                        $scope.current.eclipseSyncedModel = true;
                    }

                    $scope.addBreadcrumb(response.data.name);
                    if ($scope.model.fundFamilyId == null) {
                        $scope.model.fundFamilyId = 0;
                    }
                    listSectionData.dataItems = response.data.accounts;

                    $scope.$broadcast(dataItemsEvent);

                    $scope.calculateModelRiskScore();
                    $scope.totalAllocationPercents();
                    $scope.updateRiskScore();
                });
        }
    }

    function loadAssetClasses() {
        if ($scope.assetClasses) return;

        $http.get("/Portfolio/ProductClasses", { cache: true, trackerMsg: 'Loading asset classes' })
            .then(function (response) {
                $scope.assetClasses = response.data.sortBy("description");
                setAssetCategory();
            });
    }

    function setAssetCategory() {
        if ($scope.assetClasses && $scope.model) {
            var ac = $scope.assetClasses.find({ id: $scope.model.assetClassId });
            if (ac) {
                $scope.current.assetClassCategory = ac.category + ' (' + ac.categoryAbbreviation + ')';
            }
            else {
                $scope.current.assetClassCategory = '';
            }
        }
    }

    function loadRiskCategories() {
        if ($scope.riskCategories) return;

        $http.get("/Portfolio/RiskCategories", { trackerMsg: 'Loading risk categories' })
            .then(function (response) {
                $scope.riskCategories = response.data.sortBy("fullName");
            });
    }

    function loadMethodManagementStyles() {
        $http.get('/Portfolio/Platforms/Simple', {cache: true, trackerMsg: 'Loading management styles method'})
            .then(function (response) {
                $scope.managementStyles = response.data;
                if (modelId == 0) {
                    $scope.model.platformId = response.data[0].id;
                }
            });
    }

    function loadMethodCustodians() {
        $http.get('/Portfolio/Custodians/Simple', {cache: true, trackerMsg: 'Loading custodians method'})
            .then(function (response) {
                $scope.custodians = response.data;
                if (modelId == 0) {
                    $scope.model.custodianId = response.data[0].id;
                }
            });
    }

    function loadMethodFundNames() {
        $http.get('/Portfolio/FundFamilies/Simple', {cache: true, trackerMsg: 'Loading fund families method'})
            .then(function (response) {
                $scope.fundFamilies = response.data;

                $http.get('/Settings/Database/EntityOptions/Code/69REQUIREF', {cache: true, trackerMsg: 'Loading and verifying model entity options'})
                    .then(function (response) {
                        if (response.data.value.toLowerCase() != "true") {
                            $scope.fundFamilies.insert({id: 0, name: "All Fund Families"}, 0);
                        }

                        if (modelId == 0) {
                            $scope.model.fundFamilyId = $scope.fundFamilies[0].id;
                        }
                    });
            });
    }

    function loadMethodSubAdvisors() {
        $http.get('/Portfolio/SubAdvisors/Simple', {cache: true, trackerMsg: 'Loading sub-advisors'})
            .then(function (response) {
                $scope.subAdvisors = response.data;
            });
    }

    function loadMethodSharedClasses() {
        $http.get('/Portfolio/ShareClasses/Simple', {cache: true, trackerMsg: 'Loading share classes'})
            .then(function (response) {
                $scope.shareClasses = response.data;
                if (modelId === 0) {
                    $scope.model.shareClassId = response.data[0].id;
                }
            });
    }

    function loadMethodModelTypes() {
        $http.get('/Trading/Models/ModelTypes', {cache: false, trackerMsg: 'Loading model types'})
            .then(function (responseModelType) {
                $http.get('/Settings/Database/EntityOptions/Code/69NEWMODEL', {cache: true, trackerMsg: 'Setting default model type'})
                    .then(function (response) {
                        var useDefault = false;
                        if (response.data.value === "" && !responseModelType.data.any({name:""})) {
                            responseModelType.data.push({id: 0, name: ""})
                        } else {
                            useDefault = true;
                        }
                        $scope.modelTypes = responseModelType.data.map('name');
                        if (modelId === 0) {
                            $scope.model.modelType = useDefault ? responseModelType.data.find({name: response.data.value}).name : "";
                        }
                    });
            });
    }

    function checkUserRightsForModel() {
        $scope.rights = $oasRights.forCode("MODELS");
        $scope.rangeRights = $oasRights.forCode("MODELRANGES");
        $scope.current.canAddAcct = $oasRights.canAdd("MODELACCT");
        $scope.current.allowRebalance = $oasRights.canRead("REBALANCEMODEL");
        $scope.current.allowAcctMdlMaint = $oasRights.canUpdate("ACCTMODELMAINT");
        $scope.current.allowRiskAlyze = $oasRights.canRead("RISKALYZEAPP");
        $scope.current.hasSubAdvisors = $oasRights.canRead("SUBADVISORS");
    }

    function modelEntityOption() {
        $http.get('/Settings/Database/EntityOptions/Code/69MODELTOL', {cache: true, trackerMsg: 'Loading and verifying model entity options'})
            .then(function (response) {
                if (response.data.value.toUpperCase() === "OUB") {
                    $scope.current.modelEntityOption = true;
                    $scope.model.items.forEach(function (item) {
                        item.itemTolLower = 0;
                        item.itemTolUpper = 0;
                    });
                }
            });

        $http.get('/Settings/Database/EntityOptions/Code/69FFSMAModel', {cache: true, trackerMsg: '....'})
            .then(function(response) {
                $scope.showSMAFeature = response.data.value.toLowerCase() === 'true';
            });

        $http.get('/Settings/Database/EntityOptions/Code/69SLVRSKEE', {cache: true, trackerMsg: 'Checking for risk score.'})
            .then(function(response) {
                $scope.showRiskScore = response.data.value.toLowerCase() === 'true';
            });

        $http.get('/Settings/Database/EntityOptions/Code/TRADERSNREQ', {cache: true, trackerMsg: 'Loading and verifying model entity options'})
            .then(function (response) {
                if (response.data.value.toLowerCase() === "true") {
                    $scope.current.reasonIsRequired = true;
                }
            });

        $http.get('/Settings/Database/EntityOptions/Code/69BONDEQUI', {cache: true, trackerMsg: 'Loading and verifying model entity options'})
            .then(function (response) {
                if (response.data.value.toLowerCase() === "true") {
                    $scope.current.bondEquityModeling = true;
                    loadMethodModelTypes();
                }
            });

        $http.get('/Settings/Database/EntityOptions/Code/69DYNAMICMODEL', {cache: true, trackerMsg: 'Loading and verifying model entity options'})
            .then(function (response) {
                if (response.data.value.toLowerCase() === "true") {
                    $scope.current.useDynamic = true;
                }
            });

        $http.get('/Settings/Database/EntityOptions/Code/69REQUIRED', {cache: true, trackerMsg: 'Loading and verifying model entity options'})
            .then(function (response) {
                if (response.data.value && response.data.value > 0) {
                    $scope.current.custodialCashMinRequiredPercent = response.data.value;

                    if ($scope.current.custodialCashMinRequiredPercent > 0 && modelId <= 0) {
                        $http.get('/Portfolio/Products?exactTicker=CUSTODIAL_CASH', {trackerMsg: 'Loading default cash product'})
                            .then(function (response) {
                                $scope.model.items.push({
                                    productId: response.data[0].id,
                                    productName: response.data[0].productName,
                                    ticker: response.data[0].ticker,
                                    targetPercent: 2.00,
                                    itemTol: 0,
                                    itemTolUpper: 0,
                                    itemTolLower: 0
                                });

                                $scope.totalAllocationPercents();
                                $scope.updateRiskScore();
                            });
                    }
                }
            });
    }


    //PUBLIC METHODS
    $scope.modelTypeAddItem = function () {
        $scope.current.modelTypeIsAddMode = true;
    };

    $scope.sortAllocation = function( fieldName ) {
        $scope.allocationSort.sortField = fieldName;
        $scope.allocationSort.sortReverse = !$scope.allocationSort.sortReverse;
    };

    $scope.closeModelTypeAddItem = function () {
        $scope.current.modelTypeIsAddMode = false;
    };

    $scope.saveNewModelTypeToDropDown = function () {
        if ($scope.current.newItem === undefined || $scope.current.newItem === null) $scope.current.modelTypeIsAddMode = false;

        if ($scope.current.modelTypeIsAddMode) {
            if ($scope.modelTypes === undefined) $scope.modelTypes = [];
            $scope.modelTypes.push($scope.current.newItem);
            $scope.current.modelTypeIsAddMode = false;
            $scope.model.modelType = $scope.current.newItem;
        } else {
            $scope.current.newItem = "";
            $scope.modelTypes.remove($scope.current.newItem);
            $scope.current.modelTypeIsAddMode = false;
        }
    };

    $scope.allocationChange = function () {
        $scope.totalAllocationPercents();
        $scope.calculateModelRiskScore();
    };

    $scope.totalAllocationPercents = function () {
        $scope.current.allocationPercentTotal = Number(
            (($scope.model?.items || []).reduce(
                (allocationSum, item) => allocationSum + Number(item.targetPercent ?? 0), 0))
            .toFixed(2)
        );
    };

    $scope.calculateModelRiskScore = function () {
        if($scope.model.isSMA) return $scope.current.modelRiskScore = 0;
        var modelRiskScore = 0;
        for (var modelItem in $scope.model.items)
        {
            if($scope.model.items[modelItem].productRiskScore > 0) {
                modelRiskScore += $scope.model.items[modelItem].productRiskScore * ($scope.model.items[modelItem].targetPercent/100);
            }
        }
        $scope.current.modelRiskScore = Math.round(modelRiskScore);
    };

    $scope.openRestrictionModal = function () {
        $dialog.dialog({templateUrl: "trading/modals/model-restrictions.html", controller: "ModelRestrictionsCtrl", modelId: modelId, subAdvisorDefaultId: $scope.model.subAdvisorId, isSMAModel: $scope.model.isSMA, showSMAFeature: $scope.showSMAFeature}).open();
    };

    $scope.addRange = function () {
        $scope.model.ranges.push({
            id: 0,
            summary: null,
            upperScore: 0,
            lowerScore: 0,
            userDefinedFields: angular.copy($scope.modelRangeUdfs)
        });
    };

    $scope.removeRange = function (range) {
        $dialog.confirmAction("Are you sure you want to delete this range?")
            .open()
            .then(function (result) {
                if (result === "yes") {
                    $scope.model.ranges.remove(range);
                }
            });
    };

    $scope.saveModel = function (form, doRebalance) {
        var executeSave = function () {
            $http({method: args.method, url: '/Trading/Models/' + args.id, data: $scope.model, trackerMsg: args.trackerMsg})
                .then(function (response) {
                    var data = response.data;
                    if (data.id > 0){
                        $scope.deleteBreadcrumb();
                        $scope.updateBreadcrumb(data.modelName); //in case it changed
                    }
                    else {
                        $scope.deleteBreadcrumb();
                        $scope.addBreadcrumb(data.name, '/modeling/models/' + data.id);
                        $scope.model.id = data.id;
                    }

                    if (doRebalance)
                        $scope.rebalanceModel();
                    else
                        $location.path('/modeling/models/');
                });
        };

        var validateModelSave = function () {
            if($scope.model.isSMA && $scope.model.items.length > 0){
                $dialog.confirmAction("All model allocations currently assigned will be removed and replaced with 100% allocation of SMA Product.<br/><br/>Are you sure you want to continue?")
                    .open()
                    .then(function(result){
                        if(result.toLowerCase() === 'yes'){
                            if ($scope.current.reasonIsRequired) {
                                $dialog.inputBox("Reason for Model Change", "Reason", "textarea")
                                    .open()
                                    .then(function (result) {
                                            if (result) {
                                                $scope.model.changeReason = result;
                                                executeSave();
                                            }
                                        }
                                    );
                            }else{
                                executeSave();
                            }
                        }
                    })
            }else if ($scope.current.reasonIsRequired) {
                $dialog.inputBox("Reason for Model Change", "Reason", "textarea")
                    .open()
                    .then(function (result) {
                            if (result) {
                                $scope.model.changeReason = result;
                                executeSave();
                            }
                        }
                    );
            }  else {
                //Client DB doesn't require a reason for saving models
                $scope.model.changeReason = null;
                executeSave();
            }
            $scope.model.custodianId = $scope.model.isDynamic ? $scope.model.custodianId : null;
        };

        if (form.$valid) {
            var args = modelId > 0 ? {method: "PUT", id: modelId, trackerMsg: "Saving model " + modelId} : {method: "POST", id: "", trackerMsg: "Adding new model"};

            //Simply business rule for allocation percent totals
            if (!$scope.current.allocationPercentTotal.almostEquals(100) && !$scope.model.isSMA) {
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Allocation Total", "Allocation total must equal 100%. <br> Current total allocation is " + $scope.current.allocationPercentTotal.round(2) + '%').open();
                return;
            }

            if ($scope.model.isDynamic && !$scope.model.custodianId) {
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Dynamic Model", "Model " + $scope.model.name + " is marked as 'Dynamic', please choose a custodian from custodial price source!. ").open();
                return;
            }

            //Simply business rule to check for min cash allocation of at least x% is on model.
            if ($scope.current.custodialCashMinRequiredPercent > 0 && !$scope.model.isSMA) {
                var modelHasMinCash = $scope.model.items.find({ticker: 'CUSTODIAL_CASH'}); //TODO: maybe use 'isCustodialCash' flag on product
                if (!modelHasMinCash) {
                    $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Model Allocation Percent Error", "The model does not meet the minimum required total money market allocation.").open();
                    return;
                } else if (modelHasMinCash.targetPercent < $scope.current.custodialCashMinRequiredPercent) {
                    $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Model Allocation Percent Error", "A minimum of " + $scope.current.custodialCashMinRequiredPercent + "% cash is required in each model. <br> Current allocation for cash is " + modelHasMinCash.targetPercent.round(2) + '%').open();
                    return;
                }
            }

            if (modelId > 0) {
                if ($scope.current.eclipseSyncedModelFeatureFlag && $scope.current.eclipseSyncedModel) {
                    $dialog.confirmAction("This model synced from Eclipse. Do you want to continue?")
                        .open()
                        .then(function (result) {
                            if (result === 'yes') {
                                validateModelSave();
                            }
                        })
                } else {
                    validateModelSave();
                }
            } else {
                $scope.model.changeReason = "Initial Allocation";
                $scope.model.accounts = listSectionData.dataItems;
                if($scope.model.isSMA){
                    $dialog.confirmAction("New SMA model's will have a 100% allocation of SMA Product.<br/><br/>Are you sure you want to continue?")
                        .open()
                        .then(function(result){
                            if(result.toLowerCase() === 'yes'){
                                executeSave();
                            }
                        });
                }else{
                    executeSave();
                }
            }
        } else {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Model", "One or more fields on the model are invalid or required.").open();
        }
    };

    $scope.deleteModel = function () {
        if ($scope.model.accounts && $scope.model.accounts.length > 0) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Accounts Assigned", "<b>" + $scope.model.name + "</b> has assigned accounts. Please remove accounts before trying to delete the model.").open();
        } else {
            //save the model first, if user has removed the accounts
            var args = {method: "PUT", id: modelId, trackerMsg: "Preparing model for deletion " + modelId};
            $http({method: args.method, url: '/Trading/Models/' + args.id, data: $scope.model, trackerMsg: args.trackerMsg})
                .then(function () {
                    $http.delete(modelUrl, {trackerMsg: 'Deleting model ' + modelId})
                        .then(function () {
                            $scope.deleteBreadcrumb();
                            $location.path('/modeling/models');
                        });
                });
        }
    };

    $scope.addAccount = function () {
        $dialog.search('account', 'Add Account')
            .open()
            .then(function (result) {
                if (!result) return;

                var account = {
                    accountId: result.id,
                    accountName: result.name,
                    accountNumber: result.number,
                    value: result.value,
                    canDelete: true,
                    partOfModelAgg: false,
                    modelAggName: ""
                };

                $http.get('/Portfolio/Accounts/' + result.id)
                    .then(function (response) {
                        if (response.data.fundFamilyId != $scope.model.fundFamilyId && $scope.model.fundFamilyId != 0) {
                            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Account", "<b>" + account.accountName + "</b>" + " is not part of the selected fund family").open();
                        } else {
                            $http.get('/Portfolio/Accounts/Verbose/' + result.id + '?expand=modelingInfo', {ignoreExceptions: [404]})
                                .then(function (response) {
                                    if (response.data.modelingInfo.aggregateModel) {
                                        account.partOfModelAgg = response.data.modelingInfo.aggregateModel ? true : false;
                                        account.modelAggName = response.data.modelingInfo.aggregateModel.name;
                                    }

                                    if (account.partOfModelAgg) {
                                        $dialog.confirmAction("<b>" + account.accountName + "</b> is currently assigned to <b>" + account.modelAggName + "</b> and will be unassigned from that model upon saving current model.")
                                            .open()
                                            .then(function (result) {
                                                if (result === 'yes') {
                                                    $scope.$broadcast(addAccountEvent, account);
                                                }
                                            });
                                    } else {
                                        $scope.$broadcast(addAccountEvent, account);
                                    }
                                })
                                .catch(function () {
                                    $scope.$broadcast(addAccountEvent, account);
                                });
                        }
                    });
            });
    };

    $scope.addAllocation = function () {
        const searchParameters = {};
        if(!!$scope.model.fundFamilyId) {
            searchParameters.fundFamilyId = $scope.model.fundFamilyId;
        }

        $dialog.search('product', 'Add Allocation', null, searchParameters)
            .open()
            .then(function (result) {
                if (result && $scope.model.items.none({productId: result.productId})) {
                    $scope.model.items.push({
                        productId: result.productId,
                        productName: result.productName,
                        productClass: result.productClass,
                        ticker: result.ticker,
                        targetPercent: 0,
                        itemTol: 0,
                        itemTolUpper: 0,
                        itemTolLower: 0
                    });
                }else{
                    //selected row will be passed to table-scroll directive.
                    $scope.selectedRow = result.productId;
                }
            });
    };

    $scope.removeAllocation = function (item) {
        $scope.model.items.remove(item);

        $scope.totalAllocationPercents();
        $scope.updateRiskScore();
    };

    $scope.removeAccount = function (account) {
        var idx = $scope.model.accounts.indexOf(account);
        $scope.model.accounts.splice(idx, 1);
    };

    $scope.rebalanceModel = function () {
        $rebalance.start(2, [$scope.model.id]);
    };

    $scope.rebalanceSelectedAccounts = function (accounts) {
        $scope.$broadcast(rebalanceSelectedEvent, accounts)
    };

    $scope.$watch('model.fundFamilyId', function (newValue, oldValue) {
        fundFamilyIdOld = oldValue;
    });

    $scope.$watch("model.assetClassId", function (newValue, oldValue) {
        if (newValue === oldValue) return;
        setAssetCategory();
    }, true);

    $scope.fundFamilyChange = function (id) {
        if (id != 0 && $scope.model.items.length > 0) {
            $dialog.confirmAction("<span style='font-size: 14px;font-weight: bold'>Changing the fund family will clear the model allocations, except for  the minimum required total money market allocation . </span>")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        var tempItem = $scope.model.items.findAll(function (x) {
                            return x['ticker'] == 'CUSTODIAL_CASH';
                        });
                        $scope.model.items = tempItem;
                    } else {
                        $scope.model.fundFamilyId = fundFamilyIdOld;
                    }
                });
        }
    };

    $scope.updateRiskScore = function () {

        if($scope.model.isSMA) return;

        if (!$scope.current.allowRiskAlyze || !$scope.current.allocationPercentTotal.almostEquals(100)) return;

        var items = $scope.model.items.map(function (i) {
            return {ticker: i.ticker, allocation: i.targetPercent};
        });

        if (items.length > 0) {
            $http.post('/Integrations/RiskAlyze/Allocations', items, {trackerMsg: "Calculating risk score", ignoreExceptions: [500]})
                .then(function (response) {
                    response.data = JSON.parse(response.data);
                    $scope.current.riskScore = response.data.analysis.risk_number;
                });
        } else {
            $scope.current.riskScore = 0;
        }
    };


    //INITIALIZE
    $scope.current = {riskScore: 0,
        showFilterRow: true, selectedAdditionalAccount: null, selectedAdditionAllocations: null, allocationPercentTotal: 0, hasModelAgg: false, assignedAccounts: false, useDynamic: false,
        modelEntityOption: false, allowRebalance: false, allowAcctMdlMaint: false, isSubAdvisor: false,
        reasonIsRequired: false, canAddAcct: false, bondEquityModeling: false, requiredFundFamily: false,
        custodialCashMinRequiredPercent: 0.00, modelTypeIsAddMode: false, newItem: null, assetClassCategory: ''
    };

    $scope.showSMAFeature = false;

    $scope.allocationSort = { sortField: 'productName', sortReverse: false };

    $scope.config = {
        getUrl: null,       //'/Trading/Models/' + modelId  +'?includeAccounts=true',
        listName: 'Accounts',
        template: 'model-account-list-item.html',
        icon: 'fa fa-users',
        addItemEvent: addAccountEvent,
        rebalanceItemEvent: rebalanceSelectedEvent,
        loadDataItemsEvent: dataItemsEvent,
        selectEnabled: true,
        multiSelectEnabled: true,
        nameProperty: 'name',
        dataProperty: 'accounts',
        selectProperty: 'accountId',
        sortFields: {accountName: "Account Name", accountNumber: "Account Number", value: "Value", lastRebalanced: "last rebalance", editedDate: "last edited date"},
        //listFilter: function(item, value) {return (item.name && item.name.toLowerCase().indexOf(value) !== -1) || (item.fundName && item.fundName.toLowerCase().indexOf(value) !== -1);}
        listFilter: ['accountName', 'editedBy', 'accountNumber', 'value'],
        additionalLinks: []
    };

    checkUserRightsForModel();
    init();
    loadMethodManagementStyles();
    loadMethodCustodians();
    loadMethodFundNames();
    loadMethodSharedClasses();
    loadMethodSubAdvisors();
    loadAssetClasses();
    loadRiskCategories();
    setAssetCategory();
});


'use strict';

app.controller('ModelAggCtrl', function ModelAggCtrl($scope, $http, $location, listSectionData, entities, $dialog, $portfolio, $oasRights, $routeParams, args, dialog, splitIoService, privilegeService) {

    //region Private Variables
    var modelAggUrl = '/Trading/ModelAggs/' + args.modelAggId;
    var addAccountEvent = "event:add-account";
    var rebalanceSelectedEvent = "event: rebalance-selected";
    var dataItemsEvent = "event: data-items";
    //endregion

    splitIoService.getBoolTreatment('OC_modelagg_eclipseID_237403').subscribe((isEnabled) => {
        $scope.current.eclipseSyncedModelFeatureFlag = isEnabled;
    });

    splitIoService.getBoolTreatment('OC_tags_model_agg_details_2682').subscribe((isEnabled) => {
        $scope.current.modelAggTagsFlag = isEnabled;
    });

    splitIoService.getBoolTreatment('MS_modelagg_fact_sheet_6055').subscribe((isEnabled) => {
        $scope.current.modelAggFactSheetFeatureFlag = isEnabled;
    });

    splitIoService.getBoolTreatment('SMaC_OC_Create_a_Model_Type').subscribe((isEnabled) => {
        $scope.current.modelTypeFlag = isEnabled;
    });

    //region Private Methods
    function init() {
        $scope.current.eclipseSyncedModel = false;
        $scope.loadingOciAssignedBenchmarks = false;
        $scope.ociAssignedBenchmarksRights = privilegeService.get('oCIAssignedBenchmarks');

        if (args.modelAggId <= 0) {
            $scope.modelAgg = {
                keepAlways: false,
                details: [],
                id: 0,
                name: '',
                isSystemMaintained: true,
                accountNumberSuffix: '',
                owned: true,
                included: false,
                minimumInvestmentAmount:0,
                productTypes: [],
                ociAssignedBenchmarks: '',
                ociBenchmarkOverride: false,
                tags: '',
                tags_csv: '',
                excludeFromComposites: false
            };
            $scope.modelAggIsOwnedAndUpdatable = $scope.rightsModelAgg.canUpdate;

            $scope.minInvestFormat();

            listSectionData.dataItems = [];
            $scope.$broadcast(dataItemsEvent);

            $scope.setIncludedText();
            $scope.current.modelAggAssetClasses = [];
            $scope.current.modelAggAssetCategories = [];
            $scope.current.modelAggRiskCategories = [];
            $scope.current.ociAssignedBenchmarks = [];
            $scope.current.ociBenchmarkOverride = false;
        } else {
            $http.get(modelAggUrl, {trackerMsg: 'Loading model aggregate'})
                .then(function (response) {

                    $scope.modelAgg = response.data;
                    if ($scope.current.modelAggTagsFlag) {
                        $scope.modelAgg.tags_csv = Array.isArray($scope.modelAgg.tags)
                            ? $scope.modelAgg.tags.join(', ')
                            : '';
                    }

                    if($scope.modelAgg.eclipseModelId > 0 && $scope.modelAgg.eclipseFirmId > 0) {
                        $scope.current.eclipseSyncedModel = $scope.current.eclipseSyncedModelFeatureFlag
                            ? true // should also be true when eclipseSyncedModelFeatureFlag is retired
                            : false;
                    }

                    updateAssetAndRiskInformation();

                    $scope.current.modelAggDetailsHasSMAModel = $scope.modelAgg.details.any({isSMA: true});

                    $scope.current.entityType = $scope.modelAgg.entityEnum === null ? 'Advisor' : $scope.modelAgg.entityEnum;
                    $scope.current.selectedRepOwner = $scope.modelAgg.entityId;
                    $scope.current.selectedReps = $scope.modelAgg.entities.map(function (e) {return {id: e.entityId};});
                    $scope.current.productTypes = $scope.modelAgg.productTypes.map(function (e) {return  e.productTypeId.toString();});
                    $scope.modelAggIsOwnedAndUpdatable = $scope.modelAgg.owned && $scope.rightsModelAgg.canUpdate;

                    loadRiskRules();
                    loadModelAllocations();

                    if ($scope.modelAgg.associatedModelAggId) {
                        loadAssociatedModelAgg();
                    }

                    // load Community models if the user has the privileges for it
                    const rightsCommunities = $oasRights.forCode('COMMUNITIES');
                    if (rightsCommunities && rightsCommunities.canRead) {
                        loadCommunityModels();
                    }

                    // Model list
                    listSectionData.dataItems = response.data.accounts.findAll({isActive:$scope.accountOptions.value});
                    $scope.$broadcast(dataItemsEvent);


                    $scope.addBreadcrumb($scope.modelAgg.name);
                    $scope.setIncludedText();
                    $scope.minInvestFormat();

                    loadOciAssignedBenchmarks();
                });
        }

        $http.get('/Portfolio/Representatives/Simple', {trackerMsg:'Load available reps list'})
            .then(function (response) {
                $scope.availableRepsList = response.data;
            });

        $http.get("/Portfolio/ProductTypes/Simple", { cache: true, trackerMsg: 'Loading product types' })
            .then(function (response) {
                $scope.productTypes = response.data;
                //convert list to object for lookup name based on id
                $scope.productTypeChoices = {};
                $scope.productTypes.forEach(function (el) {
                    if(el.name !== "None") {
                        $scope.productTypeChoices[el.id] = el.name;
                    }
                });
            });
    }

    function loadOciAssignedBenchmarks() {                
        if ($scope.ociAssignedBenchmarksRights.canRead) {
            $scope.loadingOciAssignedBenchmarks = true;
            $http.get(getEntityOptionUrl(args.modelAggId, 'OCIASSIGNEDBENCHMARKS'), { trackerMsg: 'Loading entity options' })
                .then(function (response) {
                    $scope.modelAgg.ociAssignedBenchmarks = response.data.value;
                    $scope.current.ociAssignedBenchmarks = response.data.value ? response.data.value.split(',') : [];
                    $scope.loadingOciAssignedBenchmarks = false;
                });

            $http.get(getEntityOptionUrl(args.modelAggId, '69OVERRIDEOCISYNC'), { trackerMsg: 'Loading entity options' })
                .then(function (response) {                    
                    var val = response.data.value.toLowerCase() === 'true';
                    $scope.modelAgg.ociBenchmarkOverride = val;
                    $scope.current.ociBenchmarkOverride = val;
                });
        }
    }

    function getEntityOptionUrl(modelAggId, code) {
        return `/Settings/EntityOptions/AggregateModels/${modelAggId}/${code}/Value`;
    }

    function updateAssignedAccountsGrid(data) {
       listSectionData.dataItems.forEach(function (item) {
            item.outOfTolerance = data.any({id:item.accountId});
        })
    }

    function updateAssetAndRiskInformation() {
        updateAssetClassesAndCategories();
        updateRiskCategories();
    }

    // Updates the array of all risk categories based on the model details.
    function updateRiskCategories() {
        $scope.current.modelAggRiskCategories = [];

        // No model agg, no reason to continue.
        if (($scope.modelAgg === undefined) || ($scope.riskCategories === undefined)) {
            return;
        }

        if ($scope.modelAgg.details.length > 0) {
            // Loop through each deail and update the Asset Classes, Asset Categories, and Risk Categories
            $scope.modelAgg.details.forEach(function (detail) {
                var riskCategory = $scope.riskCategories.find({ id: detail.riskCategoryId });
                updateRiskCategory(riskCategory);
            })
            $scope.current.modelAggRiskCategories.sort();
        }
    }

    // Handles the individual risk category.
    function updateRiskCategory(riskCategory) {
        if (riskCategory) {
            if (!$scope.current.modelAggRiskCategories.includes(riskCategory.fullName)) {
                $scope.current.modelAggRiskCategories.push(riskCategory.fullName);
            }
        }
    }

    // Updates the array of all asset classes and categories based on the model details.
    function updateAssetClassesAndCategories() {
        $scope.current.modelAggAssetClasses = [];
        $scope.current.modelAggAssetCategories = [];
        if (($scope.modelAgg === undefined) || ($scope.assetClasses === undefined)) {
            return;
        }
        if ($scope.modelAgg.details.length > 0) {
            // Loop through each deail and update the Asset Classes, Asset Categories, and Risk Categories
            $scope.modelAgg.details.forEach(function (detail) {
                var assetClass = $scope.assetClasses.find({ id: detail.assetClassId });
                updateAssetClassAndCategory(assetClass);
            })
            $scope.current.modelAggAssetClasses.sort();
            $scope.current.modelAggAssetCategories.sort();
        }
    }

    // Handles the individual asset class.
    function updateAssetClassAndCategory(assetClass) {
        if (assetClass) {
            var assetCategoryDisplay = `${assetClass.category} (${assetClass.categoryAbbreviation})`;
            if (!$scope.current.modelAggAssetCategories.includes(assetCategoryDisplay)) {
                $scope.current.modelAggAssetCategories.push(assetCategoryDisplay);
            }
            if (!$scope.current.modelAggAssetClasses.includes(assetClass.description)) {
                $scope.current.modelAggAssetClasses.push(assetClass.description);
            }
        }
    }

    function loadRiskRules() {
        $http.get("/Settings/Database/EntityOptions/Code/EnableModelRiskRules", { trackerMsg: 'Loading Risk Rules' })
            .then(function (response) {
                if(response.data.value.toLowerCase() === 'true') {
                    $http.get("/Settings/Database/EntityOptions/Code/ModelRiskRuleLevel")
                        .then(function (response) {
                            $scope.current.riskRulesEnabled = response.data.value === 'Model Aggregate';
                        });
                }
            });
    }

    function loadAssetClasses() {
        if ($scope.assetClasses) return;

        $http.get("/Portfolio/ProductClasses", { cache: true, trackerMsg: 'Loading asset classes' })
            .then(function (response) {
                $scope.assetClasses = response.data.sortBy("description");
                updateAssetAndRiskInformation();
            });
    }

    function loadRiskCategories() {
        if ($scope.riskCategories) return;

        $http.get("/Portfolio/RiskCategories", { trackerMsg: 'Loading risk categories' })
            .then(function (response) {
                $scope.riskCategories = response.data.sortBy("fullName");
                updateAssetAndRiskInformation();
            });
    }

    function loadCommunityModels(){

        var modelIds = $scope.modelAgg.details.map('modelId');

        var astroUsageOptions = {Undefined: 0, Disabled: 1, Restricted:2, FullAccess: 3};

        // Get all Community Models associated with the Model Agg
        // If any Community Models exist, use the most restrictive AstroUsage value to determine if
        //    the "SyncToAstro" checkbox is enabled
        $http.post('/Integrations/Communities/Models/List', modelIds, {trackerMsg: 'Loading Communities Models'})
            .then(function (response) {
                $scope.communitiesModels = response.data;
                $scope.canEditSyncToAstro = !$scope.communitiesModels.any((cm) => astroUsageOptions[cm.astroUsage] !== 3);
            });
    }

    function loadModelAllocations(){
        $http.post('/Trading/Models/List/ByModelAgg/Allocations', args.modelAggId, { trackerMsg: 'Loading model allocations' })
            .then(function (response) {
                $scope.modelAggModelAllocations = response.data;
                $scope.current.allModelAllocations = response.data;
                $scope.getModelAllocations();
            });
    }

    function loadAssociatedModelAgg() {
        $http.get("/Trading/ModelAggs/" + $scope.modelAgg.associatedModelAggId, { cache: true, trackerMsg: 'Loading models' })
            .then(function (response) {
                if (!response.data) {
                    $scope.modelAgg.associatedModelAgg = null;
                    $scope.modelAgg.associatedModelAggId = null;
                } else {
                    $scope.modelAgg.associatedModelAgg = response.data;
                }
            });
    }

    function loadModelAggTypes(){
        $http.get('/Trading/ModelAggTypes', {trackerMsg:'Loading model aggregate investment categories'})
            .then(function(response){
                $scope.modelAggTypes = response.data;
            });
    }

    function loadInvestmentObjectives() {
        $http.get('/Portfolio/InvestmentObjectives', {trackerMsg:'Loading investment objectives'})
            .then(function (response) {
                $scope.investmentObjectives = response.data;
            });
    }

    function updateRiskScore(items, modelCount){
        if(items.length > 0){
            var msg = 'Getting risk score for ';
            msg += items.length === 1 ? items.length + ' product for ' : items.length + ' products for ';
            msg += modelCount === 1 ?  modelCount +' model' : modelCount +' models';
            $http.post('/Integrations/RiskAlyze/Allocations', items, {trackerMsg: msg, ignoreExceptions: [500]})
                .then(function(response){
                    response.data = JSON.parse(response.data);
                    $scope.current.riskScore = response.data.analysis.risk_number;
                })
        }else{
            $scope.current.riskScore = 0;
        }
    }

    function checkUserRightsForModelAgg() {
        $scope.rightsModelAgg = $oasRights.forCode("MODELAGGS");
        $scope.current.canAddAcct = $oasRights.canAdd("MODELACCT");
        $scope.current.allowAcctMdlMaint = $oasRights.canUpdate("ACCTMODELMAINT");
        $scope.current.allowRiskAlyze = $oasRights.canRead("RISKALYZEAPP");
        $scope.rightsBilling = $oasRights.forCode("ACCTBILLING");
        $scope.rightsViewAssetFeeSchedules = $oasRights.forCode("ACCTFEEANDPAYOUTCBO");
        $scope.rightsAssociatedModelAgg = $oasRights.forCode("ASSOCIATEDMODELAGG");
        $scope.current.factSheetTabOptions.readonly = $scope.rightsModelAgg.canUpdate === false;
        $http.get('/Settings/Database/EntityOptions/Code/69MODELAGG', {trackerMsg:'Loading db options'})
            .then(function (response) {
                $scope.current.modelAggTypeName = response.data.value;
            });

        $http.get('/Settings/Database/EntityOptions/Code/7:69DEFAUL', { cache: true, trackerMsg: 'Loading database default for ModelAgg KeepAlways property ' })
            .then(function (response) {
                if (response.data.value.toLowerCase() === "true") {
                    $scope.modelAgg.keepAlways = true;
                }
            });

        $http.get('/Settings/Database/EntityOptions/Code/FPReporting', { cache: true, trackerMsg: '' })
            .then(function (response) {
                if (response.data.value.toLowerCase() === "true") {
                    $scope.showReportingSection = true;
                }
            });
        }


        $http.get('/Settings/Database/EntityOptions/Code/69MODELAGGFACTSHEET', { cache: true, trackerMsg: '' })
        .then(function (response) {
            if (response.data.value.toLowerCase() === "true") {
                $scope.current.showFactSheetTabEntityOption = true;
            }
        });

        function openAccountEditor (id) {
        $portfolio.openEditor('7', [id], 'Model Assignment', 'modelAssignment', "modelAggs", null)
            .then(function (rslt) {
                if(rslt && (!rslt.modelingInfo.aggregateModel || rslt.modelingInfo.aggregateModel.id !==  $scope.modelAgg.id)){
                    // check to see if account was unassigned from model agg from the account editor
                    $scope.removeAccount(rslt.id, true);
                }
            });
    }

    function updateOciBenchmarks(id) {
        if (id && id > 0 && $scope.ociAssignedBenchmarksRights.canEdit) {
            const ociAssignedBenchmarks = $scope.current.ociAssignedBenchmarks.join(',');

            if ($scope.modelAgg.ociAssignedBenchmarks !== ociAssignedBenchmarks) {
                $http.put(getEntityOptionUrl(id, 'OCIASSIGNEDBENCHMARKS'), { value: ociAssignedBenchmarks });
            }

            if ($scope.modelAgg.ociBenchmarkOverride !== $scope.current.ociBenchmarkOverride) {
                $http.put(getEntityOptionUrl(id, '69OVERRIDEOCISYNC'), { value: $scope.modelAgg.ociBenchmarkOverride });
            }
        }
    }


    /**
     * Accepts a string of comma-delimited tags, parses them and returns a map of de-duplicated tags (case
     * insensitive), as well as a bool which indicates whether duplicates were detected.
     * @param {*} tags A string of comma-delimited tags.
     * @returns A tuple consisting of two bools and a Map, where the first bool is true if empty tags were detected,
     * and the second bool is true if duplicate tags were detected in {@link tags}.  The last tuple item, the map,
     * is a collection of key-value pairs of tags, where the keys are the lower-cased versions of the values.  The
     * map does not contain any empty tags or duplicates.
     */
    function sanitizeTags(tags) {
        const uniqueTags = new Map();
        if (!tags ) {
            return [false, false, uniqueTags];
        }

        const tagsArray = tags.split(/\s*,\s*/); // Regex for a comma followed by zero-or-more spaces (whitespace)

        const noEmptyTagsArray = tagsArray.filter(t => t);
        const emptyTagsDetected = noEmptyTagsArray.length < tagsArray.length;

        noEmptyTagsArray.forEach((tag) => {
            // The reason why we check if the tag already exists is to prefer left-most duplicates over just-added
            // duplicates (presumably one that was just tacked-on to the end of the field.)  If at some point in
            // the future we're changing the order of the tags (like, sorting them), then we wouldn't use this `if`:
            if (!uniqueTags.has(tag.toLowerCase())) {
                uniqueTags.set(tag.toLowerCase(), tag);
            }
        });

        const duplicatesDetected = uniqueTags.size < noEmptyTagsArray.length;

        return [emptyTagsDetected, duplicatesDetected, uniqueTags];
    }

    //endregion

    //region Public Methods

    $scope.getModelAllocations = function(){
        if($scope.current.allowRiskAlyze){
            var riskAllocations = [];
            $scope.current.riskScore = 0;

            $scope.current.allModelAllocations.forEach(function (item) {
                item.items.forEach(function (modelItem) {
                    var tempItemTargetPercent = modelItem.targetPercent * $scope.modelAgg.details.find({modelId: item.id}).weightPercent;
                    riskAllocations.add({ticker: modelItem.ticker, allocation: tempItemTargetPercent})
                })
            });
            if (riskAllocations.length > 0) {
                updateRiskScore(riskAllocations, $scope.modelAgg.details.length);
            }
        }
    };

    $scope.getAccountsOutOfTolerance = function () {

        var ids = listSectionData.dataItems.map('accountId');
        $http.post('/Portfolio/Accounts/OutOfTolerance/List', ids, {trackerMsg:'Checking accounts out of tolerance'})
            .then(function (response) {
                if(response.data && response.data.length > 0)
                    updateAssignedAccountsGrid(response.data);
            })
    };

    $scope.showModelAggModelAllocations = function (model) {
        var allocationForModel = $scope.current.allModelAllocations.find({id:model.modelId});
        var dialogOpts = {
            templateUrl : "modelAgg-modelAllocations-template",
            controller : "ModelAggModelAllocationController",
            modelAllocations: allocationForModel === undefined
                ? []
                : allocationForModel.items,
            model: model
        };

        var d = $dialog.dialog(dialogOpts);
        // No action here.  Just a close button.
        d.open();
    };

    $scope.openModelAggAssetClassesModal = function () {
        var dialogOpts = {
            templateUrl: "modelAgg-singlefield-modal-template",
            controller: "ModelAggSingleFieldModalController",
            singleFieldModalHeader: 'Asset Classes',
            modelAggSingleFieldModalData: $scope.current.modelAggAssetClasses
        };

        var d = $dialog.dialog(dialogOpts);
        // No action here.  Just a close button.
        d.open();
    };

    $scope.openModelAggAssetCategoriesModal = function () {

        var dialogOpts = {
            templateUrl: "modelAgg-singlefield-modal-template",
            controller: "ModelAggSingleFieldModalController",
            singleFieldModalHeader: 'Asset Categories',
            modelAggSingleFieldModalData: $scope.current.modelAggAssetCategories
        };

        var d = $dialog.dialog(dialogOpts);
        // No action here.  Just a close button.
        d.open();
    };

    $scope.openModelAggRiskCategoriesModal = function () {

        var dialogOpts = {
            templateUrl: "modelAgg-singlefield-modal-template",
            controller: "ModelAggSingleFieldModalController",
            singleFieldModalHeader: 'Risk Categories',
            modelAggSingleFieldModalData: $scope.current.modelAggRiskCategories
        };

        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function (rslt) {
                if (rslt) {

                }
            });
    };

    $scope.addModelToModelAgg = function () {
        $dialog.search('model', "Add Model")
            .open()
            .then(function (result) {
                if (!result) return;

                // check to see if model being added is a SMA model
                // throw warning and disable save
                if(result.isSMA && $scope.modelAgg.details.length >= 4){
                    $dialog.messageBox('<i class="fa fa-frown-o fa-lg" aria-hidden="true"></i> SMA Model', "This Model Aggregate currently has a SMA model")
                        .open();
                }else{
                    var sum = $scope.modelAgg.details.sum("weightPercent");
                    var model = {
                        modelId: result.id,
                        modelName: result.name,
                        weightPercent: 100 - sum,
                        assetClassId: result.assetClassId,
                        riskCategoryId: result.riskCategoryId
                    };

                    $scope.modelAgg.details.push(model);

                    $scope.current.modelAggDetailsHasSMAModel = $scope.modelAgg.details.any({isSMA: true});

                    updateAssetAndRiskInformation();

                    loadModelAllocations();
                }
            });
    };

    $scope.unAssignModelAgg = function () {
        $dialog.confirmAction("Are you sure you want unassociate model agg <b>" + $scope.modelAgg.associatedModelAgg.name + "</b> from this model aggregate?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $scope.modelAgg.associatedModelAgg = null;
                    $scope.modelAgg.associatedModelAggId = null;
                }
            });
    }


    $scope.addAccount = function () {
        $dialog.search('account', 'Add Account')
            .open()
            .then(function (result) {
                if (!result) return;

                var account = {
                    accountId: result.id,
                    accountName: result.name,
                    accountNumber: result.number,
                    value: result.value,
                    canDelete: true,
                    partOfModelAgg: false,
                    modelAggName: ""
                };

                $http.get('/Portfolio/Accounts/Verbose/' + result.id + '?expand=modelingInfo', {ignoreExceptions: [404]})
                    .then(function (response) {
                        var data = response.data;
                        if (data.modelingInfo.aggregateModel) {
                            account.partOfModelAgg = !!data.modelingInfo.aggregateModel;
                            account.modelAggName = data.modelingInfo.aggregateModel.name;
                        }

                        if (account.partOfModelAgg) {
                            $dialog.confirmAction("<b>" + account.accountName + "</b> is currently assigned to <b>" + account.modelAggName + "</b> and will be unassigned from that aggregate model upon saving.")
                                .open()
                                .then(function (result) {
                                    if (result === 'yes') {
                                        $scope.modelAgg.accounts.add(account);
                                        $scope.$broadcast(addAccountEvent, account);
                                    }
                                });
                        } else {
                            $scope.modelAgg.accounts.add(account);
                            $scope.$broadcast(addAccountEvent, account);
                        }
                    });

            });
    };

    $scope.modelAggSelected = function (associatedModelAgg) {
        $scope.modelAgg.associatedModelAggId = associatedModelAgg.id;
    }

    $scope.removeModelAssignmentItem = function (index) {
        $scope.modelAgg.details.splice(index, 1);

        $scope.current.modelAggDetailsHasSMAModel = $scope.modelAgg.details.any({isSMA: true});

        updateAssetAndRiskInformation();

        loadModelAllocations();
    };

    $scope.minInvestFormat = function () {
        if($scope.modelAgg.minimumInvestmentAmount){
            var temp = $scope.modelAgg.minimumInvestmentAmount.toNumber();
            $scope.modelAgg.minimumInvestmentAmount = temp.format(2, ',', '.');
        }else{
             $scope.modelAgg.minimumInvestmentAmount =0;
        }

    };

    /**
     * Accepts a string of comma-delimited tags and assigns a sanitized version into
     * {@linkcode $scope.modelAgg.tags_csv} and {@linkcode $scope.modelAgg.tags} as a string array.  If there are
     * duplicates or if the delimited tags would exceed a predefined length an error dialog is displayed.
     * @param {*} tags A string of comma-delimited tags.
     */
    $scope.validateTags = function(tags) {
        const maxLengthOfTagsField = 255;
        const lengthUsedByFirstAndLastDelimiter = 2;
        const netMaxLength = maxLengthOfTagsField - lengthUsedByFirstAndLastDelimiter;
        let errorMessages = [];

        const [emptyTagsDetected, duplicatesDetected, uniqueTags] = sanitizeTags(tags);
        const tagsArray = Array.from(uniqueTags.values());

        if (duplicatesDetected) {
            errorMessages.push('Duplicate tag(s) has/have been removed.');
        }
        
        if (emptyTagsDetected) {
            errorMessages.push('Empty tags have been removed.');
        }

        let errorDetected = false;
        const delimitedTags = tagsArray.join('|');
        const overage = delimitedTags.length - netMaxLength;
        if (overage > 0) {
            errorMessages.push(`You have either entered too many tags or too many tags with long names.  Please` +
            ` reduce the number of characters in the 'Tags' field by at least ${overage}.`);
            errorDetected = true;
        }
        
        if (errorMessages.length > 0) {
            const title = 
            "<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i>" +
            "Tags";
            const message = errorMessages.join('<br>');
            $dialog.messageBox(title, message).open();
        }

        tags = delimitedTags.replace(/\|/g, ', '); // Replace '|' all (globally) via Regex
        $scope.modelAgg.tags_csv = tags;
        $scope.modelAgg.tags = tagsArray;
        return errorDetected;
    };

    $scope.saveModelAgg = function () {
        if ($scope.modelAgg.details && $scope.modelAgg.details.length) {
            var total = $scope.modelAgg.details.sum('weightPercent') || 0;
            if (!total.almostEquals(100)) {
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Model Assignment Percent Error", "Weighted Models must equal 100%, please correct and try saving again. <br> The current weighted percent equals:" + total.round(2) + ' %').open();
                return;
            }
        }

        if ($scope.modelAgg.entityEnum === 'Representative') {
            var inList = $scope.current.selectedReps.any({id: $scope.current.selectedRep});
            if (inList) {
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Model Assignment Save Error", "Owner representative cannot be in the include / exclude list.").open();
                return;
            }
        }

        if ($scope.modelAgg.bestReturn && $scope.modelAgg.averageReturn && $scope.modelAgg.bestReturn < $scope.modelAgg.averageReturn) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Model Assignment Returns Error", "Best return should not be less than average return.").open();
            return;
        }

        if ($scope.modelAgg.averageReturn && $scope.modelAgg.worstReturn && $scope.modelAgg.averageReturn < $scope.modelAgg.worstReturn) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Model Assignment Returns Error", "Average return should not be less than worst return.").open();
            return;
        }

        if ($scope.modelAgg.bestReturn && $scope.modelAgg.worstReturn && $scope.modelAgg.bestReturn < $scope.modelAgg.worstReturn) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Model Assignment Returns Error", "Best return should not be less than worst return.").open();
            return;
        }

        if ($scope.current.modelAggTagsFlag && $scope.validateTags($scope.modelAgg.tags_csv)) {
            return;
        }

        var arg = args.modelAggId > 0 ? {method: "PUT", id: args.modelAggId, trackerMsg: "Saving model aggregate " + args.modelAggId} : {method: "POST", id: "", trackerMsg: "Adding new model aggregate"};

        //set product types
        $scope.modelAgg.productTypes = [];
        $scope.current.productTypes.forEach(function (item) {
            $scope.modelAgg.productTypes.push({productTypeId: item, aggregateModelId: arg.id});
        });

        if ($scope.modelAgg.name || $scope.modelAgg.isSystemMaintained) {
            $scope.modelAgg.entityEnum = $scope.current.entityType === 'Advisor' ? null : 'Representative';
            $scope.modelAgg.entityId = $scope.current.entityType === 'Representative' ? $scope.current.selectedRepOwner : null;

            //clear out and rebuild array
            $scope.modelAgg.entities = [];
            if ($scope.current.selectedReps.length > 0) {
                $scope.current.selectedReps.forEach(function (item) {
                    $scope.modelAgg.entities.push({entityEnum: 'Representative', entityId: item.id, aggregateModelId: arg.id});
                });
            }

            updateOciBenchmarks(arg.id);
            if ($scope.current.modelAggTagsFlag) {
                const { tags_csv, ...modelAggDto } = $scope.modelAgg;

                if (args.modelAggId > 0 && $scope.current.eclipseSyncedModel) {
                    $dialog.confirmAction("This model synced from Eclipse. Do you want to continue?")
                        .open()
                        .then(function (result) {
                            if (result === 'yes') {
                                $http({method: arg.method, url: '/Trading/ModelAggs/' + arg.id, data: modelAggDto, trackerMsg: arg.trackerMsg})
                                    .then(function (response) {
                                        $scope.current.isModalEdit
                                            ? $scope.close(response.data)
                                            : $location.path('/modeling/modelaggs');
                                    });
                            }
                        });
                }
                else {
                    $http({method: arg.method, url: '/Trading/ModelAggs/' + arg.id, data: modelAggDto, trackerMsg: arg.trackerMsg})
                        .then(function (response) {
                            if (args.modelAggId <= 0) {
                                updateOciBenchmarks(response.data.id);
                            }
                            $scope.current.isModalEdit
                                ? $scope.close(response.data)
                                : $location.path('/modeling/modelaggs');
                        });
                }
            } else {
                if (args.modelAggId > 0 && $scope.current.eclipseSyncedModel) {
                    $dialog.confirmAction("This model synced from Eclipse. Do you want to continue?")
                        .open()
                        .then(function (result) {
                            if (result === 'yes') {
                                $http({ method: arg.method, url: '/Trading/ModelAggs/' + arg.id, data: $scope.modelAgg, trackerMsg: arg.trackerMsg })
                                    .then(function (response) {
                                        $scope.current.isModalEdit ? $scope.close(response.data) : $location.path('/modeling/modelaggs');
                                    });
                            }
                        });
                }
                else {
                    $http({ method: arg.method, url: '/Trading/ModelAggs/' + arg.id, data: $scope.modelAgg, trackerMsg: arg.trackerMsg })
                        .then(function (response) {
                            if (args.modelAggId <= 0) {
                                updateOciBenchmarks(response.data.id);
                            }
                            $scope.current.isModalEdit ? $scope.close(response.data) : $location.path('/modeling/modelaggs');
                        });
                }                
            }
        } else {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Model Aggregate Page Invalid", "Model Aggregate Name or Use System Name is required, please correct and try saving again.").open();
        }
    };

    $scope.deleteModelAgg = function () {
        $dialog.confirmAction("Are you sure you want to delete <b>" + $scope.modelAgg.name + "</b>?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    var args = {method: "Delete", id: $scope.modelAgg.id, trackerMsg: "Deleting " + $scope.modelAgg.name + '(' + $scope.modelAgg.id + ')'};

                    $http({method: args.method, url: '/Trading/ModelAggs/' + args.id, data: $scope.modelAgg, trackerMsg: args.trackerMsg})
                        .then(function () {
                            $scope.deleteBreadcrumb();
                            $location.path('/modeling/modelaggs');
                        });
                }
            });
    };

    $scope.close = function (data) {
        $scope.current.isModalEdit ? dialog.close(data) : dialog.close();
    };

    $scope.setIncludedText = function () {
        $scope.current.includedText = $scope.modelAgg.include ? 'Include All But' : 'Exclude All But';
    };

    $scope.removeAccount = function (id, deleteFromEditor) {
        if(deleteFromEditor){
            $scope.modelAgg.accounts.remove({accountId: id});
            listSectionData.dataItems = $scope.modelAgg.accounts;
            $scope.$broadcast(dataItemsEvent);
        }else{
            $dialog.confirmAction("Are you sure you want to delete account from <b>" + $scope.modelAgg.name + "</b>?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $scope.modelAgg.accounts.remove({accountId: id});
                        listSectionData.dataItems = $scope.modelAgg.accounts;
                        $scope.$broadcast(dataItemsEvent);
                    }
                });
        }
    };

    $scope.openBigMultiSelect = function () {
        var selectedItems = $scope.current.ociAssignedBenchmarks.map(function (value) {
            return { key: value };
        });

        $dialog.dialog({
            templateUrl: "app/modals/available-select.html",
            controller: "AvailableSelectCtrl",
            resolve: {
                availableSelectedArgs: function () {
                    return { selectionType: 35, selectedSelected: selectedItems, disableSave: !$scope.ociAssignedBenchmarksRights.canEdit, excluded: { type: "B" } };
                }
            }
        }).open()
            .then(function (result) {
                if (result) {
                    $scope.current.ociAssignedBenchmarks = result.map("key");
                }
            });
    };
    //endregion

    //region Watches
    $scope.$on("item-action", function(e, args){
        if (args.action === 'open-account-editor') {
            openAccountEditor(args.item.accountId);
        }
        if (args.action === 'delete-item') {
            $scope.removeAccount(args.item.accountId, false);
        }
    });

    $scope.$watch("accountOptions.value", function(newValue, oldValue){
        if(newValue === oldValue) return;

        if(newValue){
            listSectionData.dataItems = $scope.modelAgg.accounts.findAll({isActive:$scope.accountOptions.value});
        }else{
            listSectionData.dataItems = $scope.modelAgg.accounts;
        }
        $scope.$broadcast(dataItemsEvent);

    });

    //endregion

    //region Initialize

    $scope.modelAggconfig = {
        getUrl: null,       //'/Trading/Models/' + modelId  +'?includeAccounts=true',
        listName: 'Accounts',
        template: 'modelAgg-account-list-item.html',
        icon: 'fa fa-users',
        addItemEvent: addAccountEvent,
        rebalanceItemEvent: rebalanceSelectedEvent,
        loadDataItemsEvent: dataItemsEvent,
        fieldToSort: 'accountName',
        selectEnabled: false,
        multiSelectEnabled: false,
        nameProperty: 'name',
        dataProperty: 'accounts',
        selectProperty: 'accountId',
        sortFields: {accountName: "Account Name", accountNumber: "Account Number", value: "Value", lastRebalanced: "Last rebalance", editedDate: "Last edited date"},
        //listFilter: function(item, value) {return (item.name && item.name.toLowerCase().indexOf(value) !== -1) || (item.fundName && item.fundName.toLowerCase().indexOf(value) !== -1);}
        listFilter: ['accountName', 'editedBy', 'accountNumber', 'value'],
        additionalLinks: []
    };
    $scope.modelAggModelAllocations = [];

    $scope.current = {
        isModalEdit: args.isModalEdit,
        sortable: true,
        canSetPermissions: ["Administrator", "Advisor"].any($scope.user.authorization.entity) && $oasRights.canUpdate("MODELAGGPERMS"),
        selectedReps: [],
        selectedRepOwner: null,
        entityType: 'Advisor',
        includedText: 'Include All But',
        allowAcctMdlMaint: false,
        assignedAccount: false,
        riskScore: 0,
        allModelAllocations: [],
        alClientId: $scope.user.authorization.alClientId,
        showFilterRow: true,
        selectedItems: [],
        availableItems: [],
        modelAggTypeName: null,
        minimumInvestmentAmount:null,
        modelAggDetailsHasSMAModel: false,
        modelAggAssetClasses: [],
        modelAggAssetCategories: [],
        modelAggRiskCategories: [],
        productTypes:[],
        riskRulesEnabled: false,
        riskRuleType: '',
        riskRuleTargetScore: 0,
        riskRuleRanges: [],
        riskRuleRangeSelected: '',
        factSheetTabOptions: {readonly:true, width: 750, height:300, toolbar: 'bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist'}
    };

    $scope.accountOptions = {id:'accountsActive', name:'showActiveAccountsOnly', value:true};
    //endregion

    checkUserRightsForModelAgg();
    loadModelAggTypes();
    loadAssetClasses();
    loadRiskCategories();
    loadInvestmentObjectives();
    init();
});

'use strict';

app.controller('ModelAggSingleFieldModalController', function ModelAggSingleFieldModalController($scope, $http, $timeout, dialog) {
    $scope.closeSingleFieldModal = function () {
        dialog.close(null);
    };

    $scope.current = {
        modelAggSingleFieldModalData: dialog.options.modelAggSingleFieldModalData,
        singleFieldModalHeader: dialog.options.singleFieldModalHeader
    };

});
'use strict';
app.controller('ModelAggModelAllocationController', function ModelAggModelAllocationController($scope, dialog) {

    $scope.current = {
        modelName: dialog.options.model.modelName,
        modelAllocations: dialog.options.modelAllocations || []
    };

    $scope.close = function () {
        $scope.current.modelAllocations = null;
        dialog.close(null);
    };
});

app.controller('ModelListCtrl', function ModelListCtrl($scope, $http, $route, $rebalance, $settings, $timeout, views, $dialog, $oasRights) {

    //region Private Variables
    var selfDirectedSetting = 'excludeSelfDirected';
    //endregion

    //region Private Methods
    function init() {
        $scope.rights = $oasRights.forCode($scope.current.mode.capitalize());
        $scope.current.allowRebalance = $scope.current.mode === 'modelaggs' ? false : $oasRights.canRead("REBALANCEMODEL");
        $scope.rightsBlackRockAnalyzer = $oasRights.forCode("BLACKROCKANALYZER");
        $scope.rightsEclipseAdmin = $oasRights.forCode("ECLIPSEORIONADMIN");

        $http.get('/Settings/Database/EntityOptions/Code/SELFDIRECTEDSUBADVID', {cache: true, trackerMsg: 'Loading options'})
            .then(function (response) {
                $scope.current.showExcludeSelfDirectOption = parseInt(response.data.value) > 0;
            });
    }

    //endregion

    //region Public Variables

    //endregion

    //region Public Methods
    $scope.exportToExcel = function () {
        $scope.$broadcast('event:model-list-action', {action: 'export-data'});
    };

    $scope.rebalanceSelected = function () {
        $rebalance.start(2, $scope.selectedIds);
    };

    $scope.refreshGrid = function () {
        $scope.current.refreshGrid = $scope.current.mode === 'models';
        $settings.setSetting(selfDirectedSetting, $scope.current.excludeSelfDirected);
        $timeout(function () {$scope.$broadcast('event:model-list-action', {action: 'refresh-grid'});});
    };

    $scope.toggleSelfDirected = function () {
        $scope.current.excludeSelfDirected = !$scope.current.excludeSelfDirected;
        $scope.refreshGrid();
    };

    $scope.deleteModels = function () {

        var modelDeletion = function (modelList) {
            var ids = modelList.map('modelId').unique();
            $http.put('/Trading/Models/Action/DeleteModels', ids, {trackerMsg:'Deleting Selected Models'})
                .then(function(response){
                    $timeout(function() {
                        $scope.$broadcast('event:model-list-action', {action: 'refresh-grid'});
                    }, 0);
                })
        };

        //Open dialog to perform validation on selected models to delete

        if($scope.selectedModelAggs.any(function (item){
            return item.numberOfAccounts > 0
        })){
            $dialog.messageBox('Unable to delete model', 'One or more selected models have assigned accounts. Remove the account that is linked to the model aggregate for this model').open();
        }else{
            var dialogOpts = {
                templateUrl : "model-delete-list.html",
                controller : "ModelDeleteController",
                modelsToValidate: $scope.selectedModelAggs
            };

            var d = $dialog.dialog(dialogOpts);
            d.open()
                .then(function(rslt) {
                    if (rslt) {
                        modelDeletion(rslt);
                    }
                });
        }
    };

    $scope.canCreateModelInEclipse = function () {
        return $scope.current.mode === 'modelaggs' && $scope.rightsEclipseAdmin.canUpdate && $scope.selectedIds.length > 0;
    }

    $scope.syncModelAggsToEclipse = function () {
        if (!$scope.canCreateModelInEclipse()) {
            return;
        }

        // get selecte modelAggIds and send to API endpoint
        $http.post('/Trading/ModelAggs/RequestEclipseModelCreation', $scope.selectedIds, { trackerMsg: 'Syncing Selected ModelAggs' })
            .then((response) => {
                // This function handles success
                const syncedModelAggIds = response.data.syncedModelAggIds;
                const unsyncedModelAggIds = response.data.unSyncedModelAggIds;

                var headerText = 'Sync To Eclipse Started Successfully'
                var messageBody = `<h4>eligible model aggregates: ${syncedModelAggIds.length} <br/> ineligible model aggregates: ${unsyncedModelAggIds.length}</h4>`;
                if (unsyncedModelAggIds.length > 0) {
                    messageBody += '<label>'
                    //In case we need to troubleshoot successes
                    //$(syncdAccounts).each(function (index, item) {
                    //    messageBody += `<br/>Model Aggregate ${item.accountId}: sync started succesfully`;
                    //});
                    $(unsyncedModelAggIds).each(function (index, item) {
                        messageBody += `<br/>Model Aggregate ${item}: cannot be sync'd to Eclipse.`;
                    });
                    messageBody += '</label>'
                }
                $dialog.messageBox(`<i class='fa fa-info-circle fa-lg text-info' aria-hidden='true'></i> ${headerText}, ${messageBody}`).open();
            });
    }

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            location.href = '#/modeling/' + $scope.current.mode + '/' + $scope.selectedIds[0];
    };
    //endregion

    //region Watches
    $scope.$on('event:rows-selected', function (e, args) {
        e.stopPropagation();
        if (args.length === 0) return;

        //mainly used for deleting of a model or models
        $scope.selectedModelAggs = args.map(function(x) {
            return {id: x.id, name: x.name, numberOfAccounts: x.accountCount};
        });

    });
    //endregion

    //region Initialize
    $scope.selectedIds = [];
    $scope.selectedModelAggs = [];
    $scope.views = views;
    $scope.current = {
        view: views[0], gridDoubleClick: $scope.slickGridDoubleClick, refreshGrid: false,
        excludeSelfDirected: $settings.getSetting(selfDirectedSetting) === undefined ? true : $settings.getSetting(selfDirectedSetting),
        mode: $route.current.viewCode === "ModelAggDto" ? "modelaggs" : "models"
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            location.href = '#/modeling/' + $scope.current.mode + '/' + $scope.selectedIds[0];
    }}];

    //endregion

    init();
});


app.controller('ModelDeleteController', function ModelDeleteController ($scope, $http, $oasRights,$timeout, dialog) {

    //region Private Methods
    function init() {
        var args = {method: "POST", url:'/Trading/Models/Action/ModelDeleteValidation', id: "", data:$scope.current.modelsToValidate, trackerMsg: "Adding new model"};
        var bindRowData = function (validatedRows) {
            $timeout(function () {
                $scope.validationRows = validatedRows;
            },100);
        };

        // Call validation
        $http(args)
            .then(function (response) {
                if(response.data){
                    bindRowData(response.data);
                }
            });
    }

    $scope.exportModelList = function () {
        $scope.exportCsvTrigger = ($scope.exportCsvTrigger || 0) + 1;
    };

    $scope.onValidationGridState = function (state) {
        $timeout(function () {
            if (!state) {
                return;
            }
            $scope.current.modelRecords.valid = state.valid;
            $scope.current.modelRecords.total = state.total;
            $scope.current.modelListToDelete = state.modelListToDelete;
        }, 0);
    };
    //endregion

    //region Public Methods

    $scope.submitModelIds = function () {
      dialog.close($scope.current.modelListToDelete)
    };

    $scope.close = function () {
      dialog.close(null);
    };

    //endregion

    $scope.validationRows = null;
    $scope.exportCsvTrigger = 0;

    $scope.current = {
        modelListToDelete: [],
        modelsToValidate: dialog.options.modelsToValidate,
        modelRecords:{valid:0, total:0}
    };

    init();

});

'use strict';

app.controller('CommunityModelsListCtrl', function CommunityModelsListCtrl($scope, $http, $oasRights, views) {

    //region Private Variables
    //endregion

    //region Private Methods
    //endregion

    //region Public Methods

    $scope.slickGridDoubleClick = function () {
        if ($scope.selectedIds.length === 1) {
            location.href = '#/modeling/strategistmodels/' + $scope.selectedIds[0];
        }

    };

    $scope.refreshGrid = function () {
        $timeout(function () {$scope.$broadcast('event:community-model-list-action', {action: 'refresh-grid'});});
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:community-model-list-action', {action: 'export-data'});
    };

    //endregion

    //region Public Variables & Rights
    $scope.rightsCommunityModels = $oasRights.forCode('MODELS');

    $scope.selectedIds = [];

    //endregion

    //region Event Listeners
    //EVENT LISTENERS
    $scope.$on('event:rows-selected', function (e, args) {
        e.stopPropagation();

        if (args.length === 0) return;

        $scope.selectedIds = args.map("id");

    });

    $scope.views = views;
    $scope.current = {view: views[0], url:'/Integrations/Communities/Models', gridDoubleClick: $scope.slickGridDoubleClick};

});

'use strict';

app.controller('CommunityModelCtrl', function CommunityModelCtrl($scope, $http, $oasRights,$location, $routeParams, $dialog) {

    //region Private Variables
    let communityModelId = $routeParams.communityModelId;
    //endregion

    //region Private Methods
    function init() {
       if(communityModelId){
           $scope.getCommunityModelById()
       }
        loadManagementStyles();
        loadSharedClasses();
        getOrionRiskScoreEntityOption();
    }

    function loadManagementStyles(){
        $http.get('/Portfolio/Platforms/Simple', {cache: true, trackerMsg: 'Loading management styles'})
            .then(function (response) {
                $scope.managementStyles = response.data;
            });

    }
    function loadSharedClasses() {
        $http.get('/Portfolio/ShareClasses/Simple', {cache: true, trackerMsg: 'Loading share classes'})
            .then(function (response) {
                $scope.shareClasses = response.data;
            });
    }
    function getOrionRiskScoreEntityOption(){
        $http.get('/Settings/Database/EntityOptions/Code/69SLVRSKEE', {cache: true, trackerMsg: 'Checking for risk score.'})
            .then(function(response) {
                $scope.showRiskScore = response.data.value.toLowerCase() === 'true';
            });
    }


    //endregion

    //region Public Methods
    $scope.allocationChange = function () {
        $scope.totalAllocationPercents();
        $scope.calculateModelRiskScore();
    };

    $scope.totalAllocationPercents = function () {
        $scope.current.allocationPercentTotal = $scope.communityModel.items.sum("targetPercent").round(2);
    };

    $scope.calculateModelRiskScore = function () {
        var modelRiskScore = 0;
        for (var modelItem in $scope.communityModel.items)
        {
            if($scope.communityModel.items[modelItem].productRiskScore > 0) {
                modelRiskScore += $scope.communityModel.items[modelItem].productRiskScore * ($scope.communityModel.items[modelItem].targetPercent/100);
            }
        }
        $scope.current.modelRiskScore = Math.round(modelRiskScore);
    };


    $scope.getCommunityModelById = function () {
        $http.get('/Integrations/Communities/Models/' + communityModelId, {trackerMsg:'Retrieving Community Model'})
            .then(function (response) {
                $scope.communityModel = response.data;
                $scope.current.auditFields.editedBy = $scope.communityModel.editedBy;
                $scope.current.auditFields.editedDate = Date.create($scope.communityModel.editedDate).format('long');
                $scope.addBreadcrumb($scope.communityModel.communityModelName);
                $scope.calculateModelRiskScore();


                $scope.totalAllocationPercents();
            });
    };

    $scope.saveCommunityModel = function (form) {
        var executeSave = function () {
            $http({method: args.method, url: args.url, data: $scope.communityModel, trackerMsg: args.trackerMsg})
                .then(function () {
                    $scope.deleteBreadcrumb();
                    $location.path('/modeling/strategistmodels');
                });
        };

        if (form.$valid) {
            var args = {method: "PUT", url:'/Integrations/Communities/Models/' + communityModelId, trackerMsg: "Saving community model " + communityModelId};
            if (communityModelId > 0) {
                    executeSave();
            }
        } else {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Model", "One or more fields on the model are invalid or required.").open();
        }
    };
    $scope.openRestrictionModal = function () {
        $dialog.dialog({templateUrl: "trading/modals/model-restrictions.html", controller: "ModelRestrictionsCtrl", modelId: $scope.communityModel.modelId, subAdvisorDefaultId: $scope.communityModel.subAdvisorId}).open();
    };

    $scope.showRestrictions = function (){
        return $scope.rightsShowUseRestrictions
    };
    //endregion

    //region Public Variables & Rights

    // this is the read only right
    $scope.rights = $oasRights.forCode('COMMUNITIES');

    //this is the add/update/delete right - currently assigned only for OPS (FTJ)
    $scope.rightsCommunityModels = $oasRights.forCode('COMMUNITYMODELS');
    $scope.rightsShowUseRestrictions = $oasRights.canRead("MODELRESTRICTIONS");

    $scope.communityModel = null;
    //endregion

    $scope.current = {riskScore: 0, auditFields: {auditedBy: null, auditedDate:null}};

    init();



});

app.controller('SleeveStrategyListCtrl', function SleeveStrategyListCtrl($scope, $http, $route, $rebalance, $settings, $timeout, views, $oasRights) {
    //PRIVATE VARIABLES
    var selfDirectedSetting = 'excludeSelfDirected';


    //PRIVATE METHODS
    function init() {
        $scope.rights = $oasRights.forCode("SLEEVE_STRATEGY");

        //$http.get('/Settings/Database/EntityOptions/Code/SELFDIRECTEDSUBADVID', {cache: true, trackerMsg: 'Loading options'})
        //    .then(function (response) {
        //        $scope.current.showExcludeSelfDirectOption = parseInt(response.data.value) > 0;
        //    });
    }


    //PUBLIC METHODS


    $scope.refreshGrid = function () {
        $scope.current.refreshGrid = $scope.current.mode == 'models' ? true : false;
        $settings.setSetting(selfDirectedSetting, $scope.current.excludeSelfDirected);
        $timeout(function () {$scope.$broadcast('event:sleeveStrategy-list-action', {action: 'refresh-grid'});});
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            location.href = '#/modeling/sleevestrategy/' + $scope.selectedIds[0];
    };

    $scope.deleteSleeveStrategy = function() {
        $http.delete('/Trading/SleeveStrategy/' + $scope.selectedIds[0], {trackerMsg:'Deleting Sleeve Strategy'})
            .then(function(){
                $scope.refreshGrid();
            });
    };




    //INITIALIZE
    $scope.selectedIds = [];
    $scope.views = views;
    $scope.current = {view: views[0], gridDoubleClick: $scope.slickGridDoubleClick, refreshGrid: false};

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            location.href = '#/modeling/sleevestrategy/' + $scope.selectedIds[0];
    }}];

    init();
});
'use strict';

app.controller('SleeveStrategyAggListCtrl', function SleeveStrategyAggListCtrl($scope, $http, $oasRights,$location, views) {

    //region Private Variables
    //endregion

    //region Private Methods
    function init() {
        //TODO: add init code here
    }

    //endregion

    //region Public Methods

    $scope.slickGridDoubleClick = function () {
        if ($scope.selectedIds.length === 1) {
            $location.path('/modeling/sleevestrategyagg/' + $scope.selectedIds[0])
        }

    };

    //endregion

    //region Public Variables & Rights

    $scope.rightsSleeveStrategyAgg = $oasRights.forCode('SLEEVE_STRATEGY');
    $scope.selectedIds = [];

    //endregion

    //region Event Listeners
    //EVENT LISTENERS
    $scope.$on('event:strategy-agg-rows-selected', function (e, args) {
        e.stopPropagation();

        if (args.length === 0) return;

        $scope.selectedIds = args.map("id");

    });

    $scope.views = views;
    $scope.current = {view: views[0], gridDoubleClick: $scope.slickGridDoubleClick, refreshGrid: false};

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
            if($scope.selectedIds.length === 1)
                location.href = '#/modeling/sleevestrategyagg' + $scope.selectedIds[0];
        }}];
    init();

});
'use strict';

var sleeveStrategyCtrl = app.controller('SleeveStrategyCtrl', function SleeveStrategyCtrl($scope, $sce, $http, $portfolio, $routeParams, $location, $tradeGenerator, $rebalance, sleeveType, listSectionData, $dialog, $timeout, $window, $oasRights, entities, splitIoService, $rootScope) {
    var sleeveStrategyId = $routeParams.sleeveStrategyId;
    var sleeveStrategyUrl = '/Trading/SleeveStrategy/' + sleeveStrategyId;
    var addRegistrationEvent = "event:add-registration";
    var rebalanceSelectedEvent = "event: rebalance-selected";
    var dataItemsEvent = "event: data-items";
    var dataItemsSleeveStrategyHistoryEvent = "event: data-items-sleeve-history";

    $scope.hidePermissionEntitiesFeatureFlag = false;
    $scope.moveUseRestrictionsFeatureFlag = false;
    $scope.dynamicRiskScoreCalculation = false;

    splitIoService.getBoolTreatment('OC_hide_sleeve_strategy_permissions_235711').subscribe((isEnabled) => {
        $scope.hidePermissionEntitiesFeatureFlag = isEnabled;
    });

    splitIoService.getBoolTreatment('OC_hide_sleevestrategy_restrictions_247379').subscribe((isEnabled) => {
        $scope.moveUseRestrictionsFeatureFlag = isEnabled;
    });

    const sleeveTypes = {
        contribution: "Contribution sleeve",
        distribution: "Distribution sleeve",
        custodial: "Custodial account",
        normal: "Normal sleeve"
    };

    $scope.current = {
        regAssignedTab: false, showFilterRow: true, autoRebalanceFrequency: [{ name: 'None', value: 0 }, { name: 'Monthly', value: 1 }, { name: 'Quarterly', value: 3 }, { name: 'Semi-Annual', value: 6 }, { name: 'Annual', value: 12 }],
        autoRebalanceMonth: [{ name: 'January', value: 1 }, { name: 'Febuary', value: 2 }, { name: 'March', value: 3 }, { name: 'April', value: 4 }, { name: 'May', value: 5 }, { name: 'June', value: 6 }, { name: 'July', value: 7 }, { name: 'August', value: 8 }, { name: 'September', value: 9 }, { name: 'October', value: 10 }, { name: 'November', value: 11 }, { name: 'December', value: 12 }],
        allocationMethods: [{ name: 'Assigned', value: 0 }, { name: 'Sleeve Target', value: 1 }, { name: 'Most Out Of Balance', value: 2 }, { name: 'Sleeve Current Percent', value: 3 }],
        autoTradeTypes: { 101: 'Registration rebalance', 102: 'Sleeve rebalance', 104: 'Contribution rebalance', 108: 'Transfer in kind rebalance' },
        selectedAutoTradeTypes: [], changeTypeFormats: { U: "Update", I: "Insert", D: "Delete" }, lastDayOfMonth: 28,
        sleeveTypes: [], processRegistrations: false, assignedRegistrations: [], unAssignedRegistrations: [], addType: 'single', modelSubstitutions: [], selectedReps: [],
        canSetPermissions: ['Administrator', 'Advisor'].any($scope.user.authorization.entity) && $oasRights.canUpdate('SLEEVE_STRATEGY'), includedText: 'Include All But',
        isRep: $scope.user.authorization.entity === entities.representative.name, showUseRestrictions: ['Administrator', 'Advisor'].any($scope.user.authorization.entity),
        toleranceCalcMethod: 'range', toleranceBandPercent: 0, isCollapsed: true,
        showLockedSleeves: false, regNeedsUpdate: [], assignedRegClass: "<i class='fa fa-fw fa-th-list' aria-hidden='true'></i> Assigned Registrations"
    };

    $scope.sleeveAllocationTypes = ["contribution", "distribution"];

    $scope.assetLevels = {
        default: "Default",
        assetCategory: "Asset Category",
        assetClass: "Asset Class",
        riskCategory: "Risk Category"
    };



    $scope.config = {
        getUrl: null,
        listName: 'Registrations',
        template: 'sleeveStrategy-registration-list-item.html',
        icon: 'fa fa-users',
        addItemEvent: addRegistrationEvent,
        rebalanceItemEvent: rebalanceSelectedEvent,
        loadDataItemsEvent: dataItemsEvent,
        selectEnabled: false,
        multiSelectEnabled: false,
        nameProperty: 'name',
        dataProperty: 'registrations',
        selectProperty: 'registrationId',
        sortFields: { name: "Reg. Name", id: "Reg. Id" },
        listFilter: ['name', 'id'],
        additionalLinks: []
    };

    $scope.configSleeveHistory = {
        getUrl: null,
        listName: 'Sleeve Strategy History',
        template: 'sleeveStrategy-history-list.html',
        icon: 'fa fa-users',
        addItemEvent: null,
        rebalanceItemEvent: null,
        loadDataItemsEvent: dataItemsSleeveStrategyHistoryEvent,
        selectEnabled: false,
        multiSelectEnabled: false,
        nameProperty: 'name',
        dataProperty: 'sleevestrategyhistory',
        selectProperty: null,
        sortFields: { name: "Name", sleeveStrategyId: "ID", autoRebalFreq: "Auto Rebalance Freq", contributionAllocationMethod: "Contribution Method", editedDate: "Edited Date" },
        listFilter: ['name', 'editedBy', 'editedDate', 'id'],
        additionalLinks: []
    };

    function initialLoad() {
        $http.get('/Settings/Database/EntityOptions/Code/69SLVRSKEE', { cache: true, trackerMsg: 'Checking for risk score.' })
            .then(function (response) {
                $scope.showRiskScore = response.data.value.toLowerCase() === 'true';
            });

        $http.get("/Settings/Database/EntityOptions/Code/69SLEEVECA", { trackerMsg: 'Checking sleeve setup options' })
            .then(function (response) {
                if (response.data && response.data.value.trim() !== '') {
                    $scope.showContributionDistribution = response.data.value === 'Contribution/Distribution';
                }
            });

        $http.get("/Settings/Database/EntityOptions/Code/69SLEEVEAU", { trackerMsg: 'Checking sleeve setup options' })
            .then(function(response) { 
                if(response.data && response.data.value.trim() !== '') {
                    $scope.showAutoRebalanceDropdown = response.data.value.toLowerCase() !== 'none';
                }
            });
            
        $http.get(sleeveStrategyUrl + '/AssetLevelsAllowed', { trackerMsg: 'Loading Asset Levels Allowed' })
            .then(function (response) {
                $scope.activeAssetLevelSelections = response.data;

                $http.get('/Portfolio/ProductCategories/Simple', { trackerMsg: 'Loading Asset Categories' })
                    .then(function (response) {
                        $scope.assetCategories = response.data;
                        $scope.assetCategoryChoices = {};
                        $scope.assetCategorySelection = [];
                        if ($scope.activeAssetLevelSelections.length && $scope.activeAssetLevelSelections[0].assetLevelType === $scope.assetLevels.assetCategory) {
                            $scope.activeAssetLevelSelections.forEach(x => {
                                $scope.assetCategorySelection.push(x.assetLevelId.toString());
                            });
                        }

                        $scope.assetCategories.forEach(x => {
                            $scope.assetCategoryChoices[x.id] = x.name;
                        });
                    });

                $http.get('/Portfolio/ProductClasses/Simple', { trackerMsg: 'Loading Asset Classes' })
                    .then(function (response) {
                        $scope.assetClasses = response.data;
                        $scope.assetClassChoices = {};
                        $scope.assetClassSelection = [];

                        if ($scope.activeAssetLevelSelections.length && $scope.activeAssetLevelSelections[0].assetLevelType === $scope.assetLevels.assetClass) {
                            $scope.activeAssetLevelSelections.forEach(x => {
                                $scope.assetClassSelection.push(x.assetLevelId.toString());
                            });
                        }


                        $scope.assetClasses.forEach(x => {
                            $scope.assetClassChoices[x.id] = x.name;
                        });
                    });

                $http.get('/Portfolio/RiskCategories/Simple', { trackerMsg: 'Loading Risk Categories' })
                    .then(function (response) {
                        $scope.riskCategories = response.data;
                        $scope.riskCategoryChoices = {};
                        $scope.riskCategorySelection = [];

                        if ($scope.activeAssetLevelSelections.length && $scope.activeAssetLevelSelections[0].assetLevelType === $scope.assetLevels.riskCategory) {
                            $scope.activeAssetLevelSelections.forEach(x => {
                                $scope.riskCategorySelection.push(x.assetLevelId.toString());
                            });
                        }

                        $scope.riskCategories.forEach(x => {
                            $scope.riskCategoryChoices[x.id] = x.name;
                        });
                    });
            });

        if ($scope.user.authorization.entity == "Sub Advisor") {
            $scope.current.isSubAdvisor = true;
        }

        $scope.rebalanceMonths = { Monthly: [{ id: 1, name: "Every Month" }] };

        var buildRebalanceMonths = function (property, max, name) {
            $scope.rebalanceMonths[property] = (1).upto(max).map(function (value) {
                return { id: value, name: "Month " + value + " of " + name };
            });
        };

        buildRebalanceMonths("Quarterly", 3, 'Quarter');
        buildRebalanceMonths("Semiannual", 6, 'Cycle');
        buildRebalanceMonths("Annual", 12, 'Year');

        $scope.getMaxNumberOfSleeves();

        if (sleeveStrategyId <= 0) {
            $scope.addBreadcrumb("New Sleeve Strategy");
            listSectionData.dataItems = [];  //holds assigned registrations for sleeve strategy
            $scope.sleeveStrategy = {
                id: 0,
                name: '',
                contributionAllocationMethod: 'Sleeve Target',
                distributionAllocationMethod: 'Sleeve Target',
                autoRebalFreq: 'None',
                autoRebalMonth: null,
                autoRebalDay: null,
                mandate: null,
                createdDate: '',
                createdBy: '',
                editedDate: '',
                editedBy: '',
                owned: true,
                riskScore: null,
                sleeveStrategyRiskTypeId: null,
                details: [],
                entity: $scope.current.isRep ? entities.representative.name : entities.ria.name,
                entityId: $scope.current.isRep ? $scope.user.entityId : null,
                include: false,
                assetLevelAllowed: "Default",
                assetLevelsAllowed: []
            };

            setRebalanceFrequencies();
            $scope.setIncludedText();
            setToleranceBands();
        } else {
            $http.get(sleeveStrategyUrl, { trackerMsg: 'Loading Sleeve Strategy' })
                .then(function (response) {
                    var data = response.data;

                    $scope.addBreadcrumb(data.name);
                    $scope.sleeveStrategy = data;

                    // ensure that at least Advisor is selected
                    $scope.sleeveStrategy.entity = data.entity || entities.ria.name;
                    $scope.current.entityType = $scope.sleeveStrategy.entity;
                    $scope.current.selectedRepOwner = $scope.sleeveStrategy.entityId;

                    $scope.current.selectedReps = $scope.sleeveStrategy.entities.map(function (e) { return { id: e.entityId }; });

                    $scope.sleeveStrategy.details.forEach(function (detail) {
                        detail.editMgmtStyle = true;
                        detail.editSubAdvisor = true;
                        detail.selectedAutoTradeTypes = [];

                        if (detail.aggregateModelId) {
                            detail.aggregateModel = { id: detail.aggregateModelId, name: detail.aggregateName };
                        }

                        if (detail.managementStyleId && detail.managementStyleName) {
                            detail.managementStyle = { id: detail.managementStyleId, name: detail.managementStyleName };
                        }

                        var temp = detail.autoTradeTypes.split(', ');

                        temp.forEach(function (att) {
                            Object.find($scope.current.autoTradeTypes, function (key, value) {
                                if (value == att) {
                                    detail.selectedAutoTradeTypes.push(key);
                                }
                            });
                        });

                        //model substitution count
                        detail.modelSubstitutionsCount = detail.substitutes ? detail.substitutes.length : 0;
                    });

                    addSpecialSleeves();
                    setRebalanceFrequencies();
                    $scope.calculateSleeveTotals();
                    $scope.setIncludedText();
                    setToleranceBands();

                    $http.get('/Trading/SleeveStrategy/RegistrationsAssignedSimple/' + sleeveStrategyId, { trackerMsg: 'Loading assigned registrations to sleeve strategy' })
                        .then(function (response) {
                            response.data.forEach(function (item) {
                                item.canDelete = $scope.rightsSleeveStrategy.canDelete;
                            });
                            listSectionData.dataItems = response.data;

                            $scope.$broadcast(dataItemsEvent);

                            $scope.current.assignedRegistrations = listSectionData.dataItems.filter(n => n.isSleeveAssignedToReg);

                            $scope.current.hasRegWithSleeveAsPartOfAgg = listSectionData.dataItems.any(n => !n.isSleeveAssignedToReg);

                            $scope.current.regNeedsUpdate = $scope.current.assignedRegistrations.filter(n => n.needsUpdate);

                            //change the class of the assigned registrations header in the pane
                            const assignedRegNeedsUpdate = "<i class='fa fa-exclamation-triangle fa-lg text-error' aria-hidden='true'></i> Assigned Registrations";
                            const assignedReg = "<i class='fa fa-fw fa-th-list' aria-hidden='true'></i> Assigned Registrations";
                            $scope.current.assignedRegClass = $scope.current.regNeedsUpdate.length > 0 ? assignedRegNeedsUpdate : assignedReg;

                            $scope.current.processRegistrations = true;
                        });
                });

            $http.get('/Trading/SleeveStrategy/' + sleeveStrategyId + '/Histories', { trackerMsg: 'Loading Sleeve Strategy History' })
                .then(function (response) {
                    $scope.sleeveStrategyHistory = response.data;
                });

            $http.get('/Trading/SleeveStrategy/' + sleeveStrategyId + '/DetailHistories', { trackerMsg: 'Loading Sleeve Strategy History' })
                .then(function (response) {
                    $scope.sleeveStrategyDetailHistory = response.data;
                    $scope.sleeveStrategyDetailHistory.forEach(function (detail) {
                        var temp = detail.autoTradeTypes.split(', ');
                        var message = '';
                        temp.forEach(function (s) {
                            message += s + '<br>';
                        });
                        detail.popoverHtml = $sce.trustAsHtml(message);
                    });

                });
        }

        $http.get('/Portfolio/Representatives/Simple', { trackerMsg: 'Load available reps list' })
            .then(function (response) {
                $scope.current.selectedReps = $scope.current.selectedReps || [];
                $scope.availableRepsList = response.data;
            });
    }

    $scope.canAddNewSleeve = function() {
        if (!$scope.sleeveStrategy || !$scope.sleeveStrategy.details) {
            // Until we have more info, return true so the page does not incorrectly display a notification:
            return true;
        }

        const numberOfSleeves = $scope.sleeveStrategy.details.filter(x => x.sleeveType === sleeveTypes.normal).length;
        return $scope.maxNumberOfSleeves === 0 || numberOfSleeves < $scope.maxNumberOfSleeves;
    };

    $scope.getMaxNumberOfSleeves = function() {
        $http.get('/Settings/Database/EntityOptions/Code/69MAXNUMBE', { cache: true, trackerMsg: 'Fetching max number of sleeves' })
            .then(function (response) {
                $scope.maxNumberOfSleeves = response.data.value ? response.data.value.toNumber() : 0;
            });
    };

    function setToleranceBands() {
        $http.get('/Settings/Database/EntityOptions/Code/69SLEEVETO', { cache: true, trackerMsg: 'Retrieving tolerance percent default' })
            .then(function (tolerancePercentDefault) {
                $scope.tolerancePercentDefault = tolerancePercentDefault.data.value ? tolerancePercentDefault.data.value.toNumber() : null;

                $scope.current.toleranceBandPercent = $scope.sleeveStrategy.tolerancePercent;

                if ($scope.current.toleranceBandPercent) {
                    $scope.current.toleranceCalcMethod = 'fixed';
                    $scope.toggleToleranceCalcMethod(false);
                } else {
                    $scope.current.toleranceCalcMethod = 'range';
                }

                if (!$scope.current.toleranceBandPercent) {
                    $scope.current.toleranceBandPercent = $scope.tolerancePercentDefault;
                }
            });
    }

    $scope.calculateToleranceBand = function () {
        if ($scope.current.toleranceCalcMethod === 'fixed') {
            $scope.sleeveStrategy.details.forEach(function (item) {
                var tempPercent = (item.targetAllocation * $scope.current.toleranceBandPercent) / 100;
                item.toleranceUpper = tempPercent;
                item.toleranceLower = tempPercent;
            })
        } else {
            $scope.current.toleranceBandPercent = $scope.tolerancePercentDefault || 0;
        }
    };

    $scope.toggleToleranceCalcMethod = function (isVisible) {
        $scope.current.isCollapsed = isVisible;
        if (!isVisible) {
            $scope.calculateToleranceBand();
        }
    };

    $scope.setIncludedText = function () {
        $scope.current.includedText = $scope.sleeveStrategy.include ? 'Include All But' : 'Exclude All But';
    };

    $scope.showHelpText = function (option) {
        var text = null;
        switch (option) {
            case 'Excluded Rebal Sleeve':
                text = "This will keep the sleeve from being journaled out of, or traded in a Portfolio (Registration) level rebalance. Raise/spend cash trades can continue to occur, as well as individual sleeve level rebalances.";
                break;
        }
        if (text) {
            $dialog.messageBox(option, text).open();
        }
    };

    function loadEnumLookUps() {
        var list = {
            sleeveTypes: sleeveType
        };

        Object.each(list, function (key, value) {
            $scope[key] = $portfolio.enumToSimpleList(value);
        });
    }

    function loadMethodSubAdvisors() {
        $http.get('/Portfolio/SubAdvisors/Simple', { cache: true, trackerMsg: 'Loading sub-advisors' })
            .then(function (response) {
                $scope.subAdvisorList = response.data;
            });
    }

    function loadManagementStyles() {
        $http.get('/Portfolio/Platforms/Simple', { cache: true, trackerMsg: 'Loading management styles.' })
            .then(function (response) {
                $scope.managementStyles = response.data;
            });
    }

    function loadAllocationMethods() {
        $scope.allocationMethods = [
            { name: 'Assigned', value: 0 },
            { name: 'Sleeve Target', value: 1 },
            { name: 'Most Out Of Balance', value: 2 },
            { name: 'Sleeve Current Percent', value: 3 }
        ]
    }

    function checkUserRightsForSleeveStrategy() {
        $scope.rightsSleeveSetup = $oasRights.forCode("SLEEVESETUP");
        $scope.rightsSleeveStrategy = $oasRights.forCode("SLEEVE_STRATEGY");
        $scope.rightsDoNotTrade = $oasRights.forCode("CHANGEDONOTTRADE");
    }

    function openRegEditor(id) {
        $portfolio.openEditor('6', [id], 'Sleeve Setup', 'sleeveSetup', null, null);
    }

    function addSpecialSleeves() {
        if(!$scope.sleeveStrategy || !$scope.sleeveStrategy.details) {
            return;
        }
        //wire up special sleeves if they don't exist
        if (!$scope.sleeveStrategy.details.find({ sleeveType: sleeveTypes.custodial })) {
            $scope.addStrategyDetail(sleeveTypes.custodial);
        }

        //Check the EntityOption - Cash Sleeve Setup(69SLEEVECA) to see if we should add Contribution/Distribution
        if ($scope.showContributionDistribution) {
            if (!$scope.sleeveStrategy.details.find({ sleeveType: sleeveTypes.contribution })) {
                $scope.addStrategyDetail(sleeveTypes.contribution);
            }

            if (!$scope.sleeveStrategy.details.find({ sleeveType: sleeveTypes.distribution })) {
                $scope.addStrategyDetail(sleeveTypes.distribution);
            }
        } else {
            //If the option is off and we find either Contribution/Distribution, remove them so they will be processed
            if ($scope.sleeveStrategy.details.find({ sleeveType: sleeveTypes.contribution })) {
                $scope.removeSleeveDetail($scope.sleeveStrategy.details.find({ sleeveType: sleeveTypes.contribution }), false);
            }

            if ($scope.sleeveStrategy.details.find({ sleeveType: sleeveTypes.distribution })) {
                $scope.removeSleeveDetail($scope.sleeveStrategy.details.find({ sleeveType: sleeveTypes.distribution }), false);
            }
        }

    }

    function sortSpecialSleeves() {
        if (!$scope.sleeveStrategy || !$scope.sleeveStrategy.details) {
            return;
        }

        //Force the Special Sleeves to be in a specific order.
        let distribution = $scope.sleeveStrategy.details.filter(function (x) {
            return x.sleeveType === sleeveTypes.distribution;
        });
        let contribution = $scope.sleeveStrategy.details.filter(function (x) {
            return x.sleeveType === sleeveTypes.contribution;
        });
        let custodial = $scope.sleeveStrategy.details.filter(function (x) {
            return x.sleeveType === sleeveTypes.custodial;
        });

        if (distribution.length > 0) {
            $scope.sleeveStrategy.details.unshift($scope.sleeveStrategy.details.splice($scope.sleeveStrategy.details.indexOf(distribution[0]), 1)[0]);
        }

        if (contribution.length > 0) {
            $scope.sleeveStrategy.details.unshift($scope.sleeveStrategy.details.splice($scope.sleeveStrategy.details.indexOf(contribution[0]), 1)[0]);
        }

        if (custodial.length > 0) {
            $scope.sleeveStrategy.details.unshift($scope.sleeveStrategy.details.splice($scope.sleeveStrategy.details.indexOf(custodial[0]), 1)[0]);
        }

    }

    function setRebalanceFrequencies() {
        $scope.rebalanceFrequencies = ["None", "Monthly", "Quarterly", "Semiannual", "Annual"];

        if ($scope.rebalanceFrequencies.none($scope.sleeveStrategy.autoRebalFreq)) {
            $scope.sleeveStrategy.autoRebalFreq = $scope.rebalanceFrequencies[0];
            $scope.resetRebalanceMonthDay();
        }
    }

    function getLastDayOfMonth(month) {
        var year = Date.create('today').format('{yyyy}').toNumber();
        $scope.current.lastDayOfMonth = new Date((new Date(year, month, 1)) - 1).getDate();
    }

    function removeRegistrationFromSleeveStrategy(reg) {
        listSectionData.dataItems.remove(reg);
        $scope.current.assignedRegistrations = listSectionData.dataItems.filter(n => n.isSleeveAssignedToReg);
        $scope.current.unAssignedRegistrations.push(reg);
        $scope.$broadcast(dataItemsEvent);
    }

    function processRegistrations(id, action) {
        let sleeveDataRegistrations = { assignedRegistrationIds: [], unAssignedRegistrationIds: [] };

        if ($scope.current.assignedRegistrations.length > 0 && action.indexOf('|assign|') !== -1) {
            $scope.current.assignedRegistrations.forEach(function (item) {
                sleeveDataRegistrations.assignedRegistrationIds.push((item.id));
            });
        }

        if ($scope.current.unAssignedRegistrations.length > 0 && action.indexOf('|unassign|') !== -1) {
            $scope.current.unAssignedRegistrations.forEach(function (item) {
                sleeveDataRegistrations.unAssignedRegistrationIds.push((item.id));
            });
        }
        if ($scope.current.regNeedsUpdate.length > 0 && action.indexOf('|needsupdate|') !== -1) {
            $scope.current.regNeedsUpdate.forEach(function (item) {
                if (sleeveDataRegistrations.unAssignedRegistrationIds.indexOf(item.id) === -1 &&
                    sleeveDataRegistrations.assignedRegistrationIds.indexOf(item.id) === -1) {
                    sleeveDataRegistrations.assignedRegistrationIds.push((item.id));
                }
            });
        }

        sleeveDataRegistrations.removeCustomizations = $scope.current.removeCustomizations;

        if (sleeveDataRegistrations.removeCustomizations ||
            sleeveDataRegistrations.unAssignedRegistrationIds.length > 0 ||
            sleeveDataRegistrations.assignedRegistrationIds.length > 0 ||
            $scope.current.hasRegWithSleeveAsPartOfAgg
        ) {
            $http.get('/Trading/SleeveStrategy/ReturnBatchId', { allowCancellation: false })
                .then(function (response) {
                    var batchId = 0;
                    if (response.data > 0) {
                        batchId = response.data;

                        if (sleeveDataRegistrations.unAssignedRegistrationIds.length === 0) {
                            $tradeGenerator.sleeveStrategyMessageAndPoll(batchId, false);
                        }

                        $http.post('/Trading/SleeveStrategy/' + id + '/' + batchId + '/Action/Process/Registration', sleeveDataRegistrations, {trackerMsg: 'Processing registrations for Sleeve strategy '+id})
                            .then(function (response) {
                                if (response && response.data > 0) {
                                    $scope.$on('event:orders-success', function () {
                                        $dialog.messageBox("<i class='fa fa-lg fa-check-square' aria-hidden='true'></i> Action Complete", "Registration process completed successfully.").open()
                                            .then(function () {
                                                $location.path('/modeling/sleevestrategy');
                                            });
                                    });
                                    $scope.$on('event:orders-error', function (e, args) {
                                        $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Process Error", "There was an error updating registration for this sleeve strategy").open();
                                        $tradegenerator.sleeveStrategykillMessageOnError(batchId);

                                    });
                                } else {
                                    $location.path('/modeling/sleevestrategy');
                                }
                            })
                            .catch(function (data) {
                                $tradeGenerator.sleeveStrategykillMessageOnError(batchId);
                            });
                    }
                    else {
                        $scope.$on('event:orders-error', function (e, args) {
                            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Process Error", "There was an error updating registration for this sleeve strategy").open();
                            $tradegenerator.sleeveStrategykillMessageOnError(batchId);
                        });
                    }
                })
                .catch(function (data) {
                    $tradeGenerator.sleeveStrategykillMessageOnError(batchId);
                });
        }
    }

    $scope.resetRebalanceMonthDay = function () {
        var rebalDate;
        switch ($scope.sleeveReg.autoRebalFrequency) {
            case "Semiannual":
                rebalDate = Date.create("6 months from now");
                if ((rebalDate.getMonth() + 1) > 6) {
                    rebalDate = Date.create();
                }
                break;
            case "Annual":
                rebalDate = Date.create("365 days from now");
                break;
            default:
                rebalDate = Date.create("1/10/2000");
                break;
        }

        //figure out last day of month
        $scope.resetRebalanceMonth(rebalDate);

        if (rebalDate.getDate() === Date.create("today").getDate()) { rebalDate.rewind("1 day"); }
        $scope.sleeveReg.autoRebalMonth = rebalDate.getMonth() + 1;

        //this sets the last day of the month (FTJ will cap at 28)
        $scope.sleeveReg.autoRebalDay = rebalDate.getDate().cap($scope.current.lastDayOfMonth);

    };

    $scope.resetRebalanceMonth = function (d) {
        if ($scope.user.isFTJ) {
            $scope.current.lastDayOfMonth = 28;
        } else {
            getLastDayOfMonth($scope.sleeveReg.autoRebalMonth);
            $scope.sleeveReg.autoRebalDay = d ? d.getDate() : Date.create('365 days from now').getDate();
        }
    };

    $scope.modelSubstitutionSearch = function (detail) {
        var aggregateModelIdFilterList = $scope.sleeveStrategy.details.map('aggregateModelId');
        var modelSubstitutionFilterList = [];
        var substitutes = [];

        detail.substitutes = detail.substitutes || [];

        $scope.sleeveStrategy.details.each(function (item) {
            if (item.substitutes && item.substitutes.length) {
                var tempList = item.substitutes.map('aggregateModelId').unique();

                modelSubstitutionFilterList.add(tempList);
            }
        });

        detail.substitutes.forEach(function (item) {
            substitutes.add(item);
        });

        var dialogOpts = {
            templateUrl: "trading/modals/model-substitution-list-search.html",
            controller: "ModelSubstitutionListSearchCtrl",
            sleeveDetailId: detail.id,
            substitutes: substitutes,
            aggregateModelIdFilterList: aggregateModelIdFilterList,
            modelSubstitutionFilterList: modelSubstitutionFilterList,
            dialogClass: "modal wide"
        };

        $dialog.dialog(dialogOpts)
            .open()
            .then(function (results) {
                if (results) {
                    detail.substitutes = results;
                    detail.modelSubstitutionsCount = results.length;
                }
            });
    };

    $scope.setSleeveContributionDistributionPercents = function () {
        $scope.sleeveAllocationTypes.forEach(function (type) {
            var copyField;
            switch ($scope.sleeveStrategy[type + 'AllocationMethod']) {
                case "Sleeve Target":
                    copyField = "targetAllocation";
                    break;
                case "Most Out Of Balance":
                    copyField = "targetAllocation";
                    break;
                default:
                    return;
            }

            $scope.sleeveStrategy.details.forEach(function (sleeve) {
                sleeve[type + 'Allocation'] = sleeve[copyField];
            });
        });

        $scope.calculateSleeveTotals();

    };

    $scope.assignRegistrationToSleeveStrategy = function () {
        var dialogOpts = {
            templateUrl: "sleeveStrategy-assign-registrations.html",
            controller: "SleeveStrategyAssignRegistrationsCtrl",
            id: sleeveStrategyId
        };

        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function (rslt) {
                if (rslt) {
                    if (!rslt.errorMessage) {
                        $http.get('/Trading/SleeveStrategy/RegistrationsAssignedSimple/' + sleeveStrategyId, { trackerMsg: 'Loading assigned registrations to sleeve strategy' })
                            .then(function (response) {

                                response.data.forEach(function (item) {
                                    item.canDelete = $scope.rightsSleeveStrategy.canDelete;
                                });
                                listSectionData.dataItems = response.data;

                                $scope.$broadcast(dataItemsEvent);

                                $scope.current.assignedRegistrations = listSectionData.dataItems.filter(n => n.isSleeveAssignedToReg);

                                $scope.current.hasRegWithSleeveAsPartOfAgg = listSectionData.dataItems.any(n => !n.isSleeveAssignedToReg);

                                $scope.current.processRegistrations = false;
                            });
                    } else {
                        $dialog.actionFailed(rslt.errorMessage).open();
                    }
                }
            });
    };

    $scope.unAssignRegistrationFromSleeveStrategy = function () {
        if ($scope.current.unAssignedRegistrations.length > 0) {
            processRegistrations(sleeveStrategyId, '|unassign|');
        }
    };

    $scope.processRegistrationsNeedingUpdate = function () {
        if ($scope.current.regNeedsUpdate.length > 0) {
            processRegistrations(sleeveStrategyId, '|needsupdate|');
        }
    };

    $scope.addStrategyDetail = function (sleeveType) {
        sleeveType = sleeveType ?? sleeveTypes.normal;

        let sleeve = {
            sleeveStrategyId: sleeveStrategyId,
            sleeveType: sleeveType,
            targetAllocation: 0,
            contributionAllocation: 0,
            distributionAllocation: 0,
            aggregateModelId: null,
            platformId: null,
            subAdvisorId: null,
            toleranceUpper: 0,
            toleranceLower: 0,
            riskScore: null,
            autoTradeTypes: 0,
            selectedAutoTradeTypes: []
        };

        $scope.sleeveStrategy.details.unshift(sleeve);

        $scope.calculateSleeveTotals();

        if ($scope.current.toleranceCalcMethod === 'fixed') {
            $scope.calculateToleranceBand();
        }
    };

    $scope.removeSleeveDetail = function (sleeve) {
        $scope.sleeveStrategy.details.remove(sleeve);
        $scope.calculateSleeveTotals();
    };

    $scope.calculateSleeveTotals = function () {
        const normalSleeves = $scope.normalSleeves();
        const sleeveStrategy = $scope.sleeveStrategy;

        sleeveStrategy.targetTotal = 0;
        sleeveStrategy.contributionAllocationTotal = 0;
        sleeveStrategy.distributionAllocationTotal = 0;
        sleeveStrategy.toleranceUpperTotal = 0;
        sleeveStrategy.toleranceLowerTotal = 0;

        normalSleeves.forEach(sleeve => {
            sleeveStrategy.targetTotal += sleeve.targetAllocation;
            sleeveStrategy.contributionAllocationTotal += sleeve.contributionAllocation;
            sleeveStrategy.distributionAllocationTotal += sleeve.distributionAllocation;
            sleeveStrategy.toleranceUpperTotal += sleeve.toleranceUpper;
            sleeveStrategy.toleranceLowerTotal += sleeve.toleranceLower;
        });
        sleeveStrategy.riskScore = calculateWeightedRiskScoreAverage(normalSleeves, sleeveStrategy.targetTotal);
    };

    function calculateWeightedRiskScoreAverage(sleeves, totalTargetAllocation) {
        const nullToIndicateRiskScoreCannotBeCalculated = null;

        if (totalTargetAllocation !== 100) {
            return nullToIndicateRiskScoreCannotBeCalculated;
        }

        let weightedRiskScore = 0;
        let riskScoreCannotBeCalculated = false;

        const falseToBreak = false;
        const trueToContinue = true;
        sleeves.every(sleeve => {
            if (sleeve.riskScore == null || !sleeve.riskScore) {
                riskScoreCannotBeCalculated = sleeve.targetAllocation > 0;
                    
                return riskScoreCannotBeCalculated
                    ? falseToBreak
                    : trueToContinue;
            }

            weightedRiskScore += sleeve.targetAllocation * sleeve.riskScore / 100;
            return trueToContinue;
        });

        return riskScoreCannotBeCalculated
            ? nullToIndicateRiskScoreCannotBeCalculated
            : weightedRiskScore;
    };

    $scope.saveSleeveStrategy = function (form) {
        var executeSave = function (doProcess) {
            $scope.sleeveStrategy.details.forEach(function (detail) {
                if (detail.sleeveType === sleeveType.normal) {
                    //normal sleeve, models are required
                    //once a model is set, it cannot be removed, we reset it here to what was chosen in the search box
                    if (detail.aggregateModel) {
                        detail.aggregateModelId = detail.aggregateModel.id;
                    }
                } else {
                    //special sleeve, models are optional
                    //if one isn't chosen in the search box, set it to null
                    detail.aggregateModelId = detail.aggregateModel && detail.aggregateModel.id ? detail.aggregateModel.id : null;
                }

                if (detail.managementStyle) {
                    detail.managementStyleId = detail.managementStyle.id;
                }

                detail.autoTradeTypes = detail.selectedAutoTradeTypes.sum(function (x) { return x.toNumber() - 100 });
            });

            if ($scope.sleeveStrategy.entity === 'Representative') {
                var inList = $scope.current.selectedReps.any({ id: $scope.current.selectedRep });

                if (inList) {
                    $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Sleeve Strategy Save Error", "Owner representative cannot be in the include/exclude list.").open();
                    return;
                }
            }

            $scope.sleeveStrategy.entity = $scope.current.entityType === entities.representative.name ? entities.representative.name : null;
            $scope.sleeveStrategy.entityId = $scope.current.entityType === entities.representative.name ? $scope.current.selectedRepOwner : null;

            //clear out and rebuild array
            $scope.sleeveStrategy.entities = [];

            if ($scope.current.selectedReps.length > 0) {
                $scope.current.selectedReps.forEach(function (item) {
                    $scope.sleeveStrategy.entities.push({ entityEnum: entities.representative.name, entityId: item.id });
                });
            }

            $http({ method: args.method, url: args.url, data: $scope.sleeveStrategy, trackerMsg: args.trackerMsg })
                .then(function (response) {
                    var data = response.data;

                    $scope.deleteBreadcrumb();
                    $location.path('/modeling/sleevestrategy');

                    if (doProcess) {
                        processRegistrations(data.id, '|assign|unassign|');
                    } else {
                        processRegistrations(data.id, '|needsupdate|unassign|');
                    }
                });
        };

        if (form.$valid) {
            var args = sleeveStrategyId > 0
                ? { method: 'PUT', url: '/Trading/SleeveStrategy/' + sleeveStrategyId, id: sleeveStrategyId, trackerMsg: 'Saving sleeve strategy ' + sleeveStrategyId }
                : { method: 'POST', url: '/Trading/SleeveStrategy', trackerMsg: 'Adding new model' };

            const aggregateModelIsNull = $scope.normalSleeves().any(function (x) {
                return !x.aggregateModel || !x.aggregateModel.id;
            });

            if (aggregateModelIsNull) {
                $dialog.messageBox('<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Save Error', 'Sleeve Strategy must contain one or more valid models').open();

                return;
            }

            // if a rep is the owner, a rep must be selected
            if ($scope.current.entityType === entities.representative.name) {
                if (!$scope.current.selectedRepOwner || !$scope.availableRepsList.find({ id: $scope.current.selectedRepOwner }).isActive) {
                    $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Permissions Save Error", "An active Representative must be selected").open();

                    return;
                }
            }

            $scope.sleeveStrategy.tolerancePercent = $scope.current.toleranceCalcMethod === 'fixed'
                ? $scope.current.toleranceBandPercent
                : null;

            //wire up the model restriction settings
            $scope.sleeveStrategy.assetLevelsAllowed = [];

            if ($scope.sleeveStrategy.assetLevelAllowed === $scope.assetLevels.assetCategory) {
                $scope.assetCategorySelection.forEach(function (assetId) {
                    $scope.sleeveStrategy.assetLevelsAllowed.push({
                        sleeveStrategyId: $scope.sleeveStrategy.id,
                        assetLevelType: 1,
                        assetLevelId: assetId
                    });
                });
            } else if ($scope.sleeveStrategy.assetLevelAllowed === $scope.assetLevels.assetClass) {
                $scope.assetClassSelection.forEach(function (assetId) {
                    $scope.sleeveStrategy.assetLevelsAllowed.push({
                        sleeveStrategyId: $scope.sleeveStrategy.id,
                        assetLevelType: 2,
                        assetLevelId: assetId
                    });
                });
            } else if ($scope.sleeveStrategy.assetLevelAllowed === $scope.assetLevels.riskCategory) {
                $scope.riskCategorySelection.forEach(function (assetId) {
                    $scope.sleeveStrategy.assetLevelsAllowed.push({
                        sleeveStrategyId: $scope.sleeveStrategy.id,
                        assetLevelType: 3,
                        assetLevelId: assetId
                    });
                });
            }

            if ($scope.sleeveStrategy.hasAssignedRegistrations
                || listSectionData.dataItems.length > 0) {
                //there are registrations assigned
                const anyHasCustomizedSleeves = $scope.current.assignedRegistrations.some(x => x.hasCustomizedSleeves);

                if (anyHasCustomizedSleeves) {
                    //get the registration model assignment validation results
                    //we use this later when prompting the user to remove customizations or not
                    $http.post(`/Trading/SleeveStrategy/${$scope.sleeveStrategy.id}/ValidateRegistrationModelAssignments`, $scope.sleeveStrategy)
                        .then((response) => {
                            $scope.current.registrationModelValidationResults = response.data;
                        });
                }

                //inspect the sleeve strategy and see what's changed
                let noProcessResults = ["name", "useRestrictions", "assetLevelsAllowed"];
                let compareResults = Object.compare($scope.sleeveStrategy, $scope.sleeveStrategyOriginal);

                //if only name or useRestrictions has changed, we don't need to process
                let doNotProcess = compareResults.every(x => noProcessResults.includes(x));

                if (doNotProcess) {
                    executeSave(false);
                } else {
                    const deletedModels = [];
                    let existingModels = [];
                    if ($scope.sleeveStrategyOriginal && $scope.sleeveStrategyOriginal.details) {
                        const originalDetailsWithModels = $scope.sleeveStrategyOriginal.details.filter(dtl => !!dtl.aggregateModel);
                        originalDetailsWithModels.forEach(dtl => {
                            if (!$scope.sleeveStrategy.details.filter(a => !!a.aggregateModel)
                                .find(a => a.aggregateModel.id === dtl.aggregateModel.id || a.id === dtl.id)) {
                                deletedModels.push({ sleeveStrategyDetailId: dtl.id, modelId: dtl.aggregateModel.id, modelName: dtl.aggregateModel.name, targetModelId: null });
                            }
                        });
                    }
                    // create an array of the models that still exist on the sleeve
                    $scope.sleeveStrategy.details.filter(dtl => !!dtl.aggregateModel).forEach(dtl => {
                        if (!deletedModels.filter(m => !!m.modelId).find(m => m.modelId === dtl.aggregateModel.id)) {
                            existingModels.push({ modelId: dtl.aggregateModel.id, modelName: dtl.aggregateModel.name });
                        }
                    });

                    existingModels = existingModels.sortBy('modelName');
                    existingModels.unshift({ modelId: null, modelName: 'Default' });

                    $dialog.dialog({
                        templateUrl: "sleeve-process-prompt.html",
                        controller: "SleeveProcessPromptCtrl",
                        sleeveStrategy: $scope.sleeveStrategy,
                        deletedModels: deletedModels,
                        existingModels: existingModels,
                        dialogClass: 'modal wide'
                    })
                    .open()
                    .then((doSave) => {
                        if (!!doSave) {
                            if (anyHasCustomizedSleeves) {
                                //show dialog about customized registrations
                                let dialogText = 'Sleeve Strategy contains Registrations with customized sleeves.';

                                const customizedRegistrations = $scope.current.assignedRegistrations.filter(x => x.hasCustomizedSleeves);

                                if ($scope.current.registrationModelValidationResults
                                    && $scope.current.registrationModelValidationResults.length > 0) {
                                    dialogText = dialogText.concat('<br><br>The Registrations contain Model Aggs are not allowed because they do not match the Asset Level restrictions.');
                                }

                                dialogText = dialogText.concat('<br><br>Select YES to keep the customizations. Select NO to reset all assigned Registrations to match the Sleeve Strategy Aggregate.');
                                dialogText = dialogText.concat('<br><br><strong>This action cannot be undone.</strong>');
                                dialogText = dialogText.concat('<br><br>Registrations that will be affected:<br>');

                                customizedRegistrations.forEach(x => {
                                    dialogText = dialogText.concat(`<br>${x.id}`);
                                });

                                $dialog.confirmAction(dialogText).open()
                                    .then((removeCustomizations) => {
                                        //no -> remove the customizations
                                        $scope.current.removeCustomizations = removeCustomizations === 'no';

                                        executeSave(true);
                                    });
                            } else {
                                executeSave(true);
                            }
                        }
                    });
                }
            } else {
                executeSave(false);
            }
        } else {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Sleeve Strategy", "One or more fields on the sleeve strategy are invalid or required.").open();
        }
    };

    $scope.normalSleeves = function () {
        return $scope.sleeveStrategy.details.filter(function (x) {
            return x.sleeveType === sleeveTypes.normal;
        });
    };

    $scope.deleteSleeveStrategy = function () {
        if (listSectionData.dataItems.length > 0) {
            $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Registrations Assigned", "<b>" + $scope.sleeveStrategy.name + "</b> has assigned registrations. Please remove registrations before trying to delete the sleeve strategy.").open();
        } else {

            var args = { method: "PUT", id: sleeveStrategyId, trackerMsg: "Preparing Sleeve Strategy for deletion " + sleeveStrategyId };
            $http.delete(sleeveStrategyUrl, { trackerMsg: 'Deleting sleeve strategy ' + sleeveStrategyId })
                .then(function () {
                    $scope.deleteBreadcrumb();
                    $location.path('/modeling/sleevestrategy');
                });
        }
    };

    $scope.addRegistrationToSleeve = function () {
        var registration = {
            id: $scope.current.selectedRegistration.id,
            name: $scope.current.selectedRegistration.name,
            canDelete: true
        };
        $scope.$broadcast(addRegistrationEvent, registration);
        $scope.current.selectedRegistration = null;

        if (listSectionData.dataItems.length > 0) {
            $scope.current.processRegistrations = true;
        }
    };

    $scope.itemAction = function (item, action) {
        if (action === 'edit-registration-sleeve-strategy') {
            openRegEditor(item.id);
        }
        if (action === 'delete-registration-sleeve-strategy') {
            removeRegistrationFromSleeveStrategy(item);
        }
    };

    $scope.openRestrictionsModal = function () {
        $dialog.dialog({
            templateUrl: "trading/modals/sleeve-strategies-restrictions.html", controller: "SleeveStrategiesRestrictionsCtrl", sleeveStrategyId: $scope.sleeveStrategy.id,
            entityId: $scope.sleeveStrategy.entityId, entity: $scope.sleeveStrategy.entity
        }).open();
    };

    $scope.modelSelectedOasSearch = function(sel, sleeveStrategyDetail) {
        if(sel.managementStlyeId){
            sleeveStrategyDetail.managementStyle = {id: sel.managementStlyeId, name: sel.managementStyleName};
            sleeveStrategyDetail.editMgmtStyle = true;
        }
        if (sel.subAdvisorId) {
            sleeveStrategyDetail.subAdvisorId = sel.subAdvisorId;
            sleeveStrategyDetail.editSubAdvisor = true;
        }
        if (sleeveStrategyDetail.riskScore !== sel.riskScore) {
            sleeveStrategyDetail.riskScore = sel.riskScore;
            $scope.calculateSleeveTotals();
        }
        if (sel.id) {
            sleeveStrategyDetail.aggregateExcludeRebalanceSleeve = sel.excludeRebalanceSleeve;
            sleeveStrategyDetail.doNotTrade = sleeveStrategyDetail.doNotTrade || sel.excludeRebalanceSleeve;
        }
    };

    checkUserRightsForSleeveStrategy();
    loadAllocationMethods();
    loadManagementStyles();
    loadMethodSubAdvisors();
    loadEnumLookUps();
    initialLoad();

    var waitForRequests = function () {
        //we only care to wait for requests that aren't loading grid data
        //this is a side effect of the page continuing to load grid data even after we've left the grid to edit a sleeve strategy
        const processingRegistrationsString = "Processing registrations for Sleeve strategy ";
        const filteredRequests = $http.pendingRequests.filter(x => !x.trackerMsg || (x.trackerMsg.indexOf("Loading grid data") < 0 && x.trackerMsg.indexOf(processingRegistrationsString) < 0));
        const processRegistrationsRequests = $http.pendingRequests.filter(x => x.trackerMsg && x.trackerMsg.indexOf(processingRegistrationsString) !== -1);

        var sleeveStratIdsBeingProcessed = [];

        if (processRegistrationsRequests.length > 0) {
            processRegistrationsRequests.forEach(x => {
                let strategyId = x.trackerMsg.substring(processingRegistrationsString.length);
                sleeveStratIdsBeingProcessed.push(strategyId);
            });
        }

        if (filteredRequests.length > 0 || sleeveStratIdsBeingProcessed.indexOf(sleeveStrategyId) !== -1) {
            $timeout(waitForRequests);
        } else {
            addSpecialSleeves();
            sortSpecialSleeves();
            $scope.sleeveStrategyOriginal = angular.copy($scope.sleeveStrategy);
        }
    };

    $timeout(waitForRequests);
});

app.controller('SleeveStrategyAssignRegistrationsCtrl', function SleeveStrategyAssignRegistrationsCtrl($scope, $http, dialog, $timeout, $tradeGenerator) {
    $scope.sleeveAssignedRegistrations = [];

    function addRegToSleeve() {
        if ($scope.current.registrationList.length > 0) {
            $scope.current.noDataFromImport = false;
            $scope.current.registrationList.forEach(function (item) {
                var isInList = $scope.sleeveAssignedRegistrations.find({ id: item.id });
                if (!isInList) {
                    $scope.sleeveAssignedRegistrations.push({ id: item.id, name: item.regName, message: item.message, promptToSplit: !!item.promptToSplit, isError: item.isError, isWarning: item.isWarning });
                }
            });
            $scope.current.cantProcess = $scope.sleeveAssignedRegistrations.none({ message: null }, { promptToSplit: false }, { isError: false }) && !$scope.sleeveAssignedRegistrations.some(x => x.isWarning);
        } else {
            $scope.current.noDataFromImport = true;
        }
    }

    $scope.switchAddType = function () {
        $scope.startOver();
    };

    $scope.addRegistration = function () {
        var regToSleeve = function (data) {
            //Check to see if registration was already in list
            var isInList = $scope.sleeveAssignedRegistrations.find({ id: $scope.current.selectedRegistration.id });
            if (!isInList) {
                $scope.sleeveAssignedRegistrations.push({ id: $scope.current.selectedRegistration.id, name: $scope.current.selectedRegistration.name, message: data.message, promptToSplit: !!data.promptToSplit, isError: data.isError, isWarning: data.isWarning });
            }
            $scope.current.selectedRegistration = null;
            $scope.current.regCheckFinished = true;
            $scope.current.cantProcess = $scope.sleeveAssignedRegistrations.none({ message: null }, { promptToSplit: false }, { isError: false }) && !$scope.sleeveAssignedRegistrations.some(x => x.isWarning);
        };
        $http.get('/Trading/Sleeve/Registrations/' + $scope.current.selectedRegistration.id + '/Check', { trackerMsg: 'Checking registration to sleeve' })
            .then(function (response) {
                regToSleeve(response.data);
            });
    };

    $scope.removeSelection = function (item) {
        var idx = $scope.sleeveAssignedRegistrations.indexOf(item);
        $scope.sleeveAssignedRegistrations.splice(idx, 1);
        $scope.current.cantProcess = $scope.sleeveAssignedRegistrations.none({ message: null }, { promptToSplit: false }, { isError: false }) && !$scope.sleeveAssignedRegistrations.some(x => x.isWarning);
    };

    $scope.process = function () {
        var ids = [];
        $scope.sleeveAssignedRegistrations.forEach(function (item) {
            if ((item.message == null || item.isWarning) && !item.promptToSplit && !item.isError) {
                ids.push((item.id));
            }

        });
        var data = { assignedRegistrationIds: ids, unAssignedRegistrationIds: [] };

        $scope.current.isProcessing = true;

        $http.post('/Trading/SleeveStrategy/' + dialog.options.id + '/Action/Process/Registration', data)
            .then(function (response) {
                if (!response.data) {
                    dialog.close(null);
                    return;
                }
                $tradeGenerator.startPolling(response.data, false);
                $scope.$on('event:orders-success', function () {
                    dialog.close($scope.sleeveAssignedRegistrations);
                });
                $scope.$on('event:orders-error', function (e, args) {
                    $scope.sleeveAssignedRegistrations.errorMessage = args.errorCount > 0 ? args.message : null;
                    dialog.close($scope.sleeveAssignedRegistrations);
                });
            }, function (response) {
                $scope.current.errorMessage = response.statusText;
                $scope.current.isProcessing = false;
            });
    };

    $scope.close = function () {
        dialog.close(null);
    };

    $scope.dataLoaded = function () {
        $scope.current.regCheckFinished = false;
        $timeout(function () {
            addRegToSleeve();
            $scope.current.regCheckFinished = true;
        }, 100);
    };

    $scope.startOver = function () {
        $scope.sleeveAssignedRegistrations = [];
        $scope.current.registrationList = [];
        $scope.current.regCheckFinished = false;
        $scope.current.cantProcess = true;
        $scope.current.selectedRegistrations = null;
        $scope.current.noDataFromImport = false;
    };

    $scope.current = { selectedRegistrations: null, showErrorMessage: false, isProcessing: false, errorMessage: '', registrationList: [], noDataFromImport: false, regCheckFinished: false, cantProcess: true };
});

app.controller('SleeveProcessPromptCtrl', function SleeveProcessPromptCtrl($scope, $http, $dialog, dialog) {
    $scope.cancel = function () {
        if (dialog) {
            dialog.close(false);
        } else {
            window.parent.postMessage('iframeclose');
        }
    };
    $scope.confirm = function () {
        if (dialog) {
            dialog.close(true);
        } else {
            window.parent.postMessage('iframeclose');
        }
    };

    $scope.targetedModelChange = function () {
        // if any deleted models should move their assets to a single model, add the model targets to the sleeve reg object
        $scope.sleeveStrategy.deletedSleeveTargets = $scope.deletedModels
            .filter(m => !!m.targetModelId)
            .map(m => ({
                deletedModelId: m.modelId,
                targetModelId: m.targetModelId
            }));
    };

    $scope.sleeveStrategy = dialog.options.sleeveStrategy;
    $scope.deletedModels = dialog.options.deletedModels;
    $scope.existingModels = dialog.options.existingModels;
});

'use strict';

var sleeveStrategyAggCtrl = app.controller('SleeveStrategyAggCtrl', function SleeveStrategyAggCtrl($scope, $http, $oasRights, $routeParams, $location, $dialog, $timeout, $portfolio, $tradeGenerator, listSectionData, entities, splitIoService) {

    var sleeveStrategyAggId = $routeParams.sleeveStrategyAggId;
    var sleeveStrategyAggUrl = '/Trading/SleeveStrategyAggregate';

    if (sleeveStrategyAggId > 0) {
        sleeveStrategyAggUrl += '/' + sleeveStrategyAggId;
    }

    var rebalanceSelectedEvent = 'event: rebalance-selected';
    var sleeveAggRegDataItemsEvent = 'event: data-items';
    var addSleeveAggRegistrationEvent = 'event:add-registration';
    var sleeveStrategyAggOriginal;

    const sleeveTypes = {
        contribution: 'Contribution sleeve',
        distribution: 'Distribution sleeve',
        custodial: 'Custodial account',
        normal: 'Normal sleeve'
    };
    
    $scope.showEclipseFirmDropdownFeatureFlag = false;
    $scope.investmentObjectives = [];
    
    splitIoService.getBoolTreatment('OC_SSA_Eclipse_Sync_260157 ').subscribe((isEnabled) => {
        $scope.showEclipseFirmDropdownFeatureFlag = isEnabled;
    });

    $scope.setIncludedText = function () {
        $scope.current.includedText = $scope.sleeveStrategyAgg.include ? 'Include All But' : 'Exclude All But';
    };

    function init() {
        $http.get('/Settings/Database/EntityOptions/Code/69SLEEVECA', { trackerMsg: 'Checking sleeve setup options.' })
            .then(function (response) {
                if (response.data && response.data.value.trim() !== '') {
                    $scope.showContributionDistribution = response.data.value === 'Contribution/Distribution';
                }
            });

            $http.get("/Settings/Database/EntityOptions/Code/69SLEEVEAU", { trackerMsg: 'Checking sleeve setup options' })
            .then(function(response) {
                if(response.data && response.data.value.trim() !== '') {
                    $scope.showAutoRebalanceDropdown = response.data.value.toLowerCase() !== 'none';
                }
            });

        $http.get('/Settings/Database/EntityOptions/Code/69SLVRSKEE', { cache: true, trackerMsg: 'Checking for risk score' })
            .then(function (response) {
                $scope.showRiskScore = response.data && response.data.value.trim().toLowerCase() === 'true';
            });

        $http.get('/Portfolio/Platforms/Simple', { cache: true, trackerMsg: 'Loading management styles.' })
            .then(function (response) {
                $scope.managementStyles = response.data;
            });

        loadEclipseFirms();
        loadInvestmentObjectives();

        $scope.rebalanceMonths = { Monthly: [{ id: 1, name: 'Every Month' }] };

        var buildRebalanceMonths = function (property, max, name) {
            $scope.rebalanceMonths[property] = (1).upto(max).map(function (value) {
                return { id: value, name: 'Month ' + value + ' of ' + name };
            });
        };

        buildRebalanceMonths('Quarterly', 3, 'Quarter');
        buildRebalanceMonths('Semiannual', 6, 'Cycle');
        buildRebalanceMonths('Annual', 12, 'Year');

        //setup for new sleeve strategy aggregate.
        if (sleeveStrategyAggId <= 0) {
            $scope.addBreadcrumb('New Sleeve Strategy Aggregation');
            $scope.sleeveStrategyAgg = {
                id: 0,
                name: '',
                contributionAllocationMethod: 'Assigned',
                distributionAllocationMethod: 'Assigned',
                autoRebalFreq: 'None',
                autoRebalMonth: null,
                autoRebalDay: null,
                investmentObjectiveId: -1,
                mandate: null,
                createdDate: '',
                createdBy: '',
                editedDate: '',
                editedBy: '',
                riskScore: null,
                sleeveStrategyRiskTypeId: null,
                details: [],
                entity: $scope.current.isRep ? entities.representative.name : entities.ria.name,
                entityId: $scope.current.isRep ? $scope.user.entityId : null,
                include: false,
                owned: true,
                allowCustomization: false,
                specialDetails: []
            };

            setRebalanceFrequencies();
            $scope.setIncludedText();
        }
        else {
            //get sleeve strategy to edit
            $http.get(sleeveStrategyAggUrl, { trackerMsg: 'Loading Sleeve Strategy Agg.' })
                .then(function (response) {
                    $scope.addBreadcrumb(response.data.name);
                    $scope.sleeveStrategyAgg = response.data;

                    // ensure that at least Advisor is selected
                    $scope.sleeveStrategyAgg.entity = response.data.entity || entities.ria.name;
                    $scope.current.entityType = $scope.sleeveStrategyAgg.entity;
                    $scope.current.selectedRepOwner = $scope.sleeveStrategyAgg.entityId;

                    $scope.current.selectedReps = $scope.sleeveStrategyAgg.entities.map(function (e) { return { id: e.entityId }; });

                    if ($scope.sleeveStrategyAgg.autoRebalMonth) {
                        getLastDayOfMonth($scope.sleeveStrategyAgg.autoRebalMonth);
                    }

                    if ($scope.sleeveStrategyAgg.associatedModelAggId) {
                        loadAssociatedModelAgg();
                    }

                    if ($scope.sleeveStrategyAgg.investmentObjectiveId == null)
                    {
                        $scope.sleeveStrategyAgg.investmentObjectiveId = -1;
                    }
                    
                    setRebalanceFrequencies();
                    $scope.calculateSleeveTotals();
                    $scope.setIncludedText();
                });
            $http.get(sleeveStrategyAggUrl + '/Histories', { trackerMsg: 'Loading Sleeve Strategy Agg. History' })
                .then(function (response) {
                    $scope.sleeveStrategyAggHistory = response.data;
                });

            $http.get(sleeveStrategyAggUrl + '/DetailHistories', { trackerMsg: 'Loading Sleeve Strategy Agg. History' })
                .then(function (response) {
                    $scope.sleeveStrategyAggDetailHistory = response.data;
                });
            $http.get('/Trading/SleeveStrategyAggregate/RegistrationsAssignedSimple/' + sleeveStrategyAggId, { trackerMsg: 'Loading assigned registrations to sleeve strategy aggregates' })
                .then(function (response) {
                    response.data.forEach(function (item) {
                        item.canDelete = $scope.rightsSleeveStrategyAgg.canDelete;
                    });
                    listSectionData.dataItems = response.data;

                    $scope.$broadcast(sleeveAggRegDataItemsEvent);

                    $scope.current.assignedRegistrations = listSectionData.dataItems;
                    $scope.current.anyRegHasCustomizedSleeves = $scope.current.assignedRegistrations.some(x => x.hasCustomizedSleeves);

                    $scope.current.regNeedsUpdate = $scope.current.assignedRegistrations.filter(n => n.needsUpdate);

                    //change the class of the assigned registrations header in the pane
                    $scope.current.assignedRegClass =
                        $scope.current.regNeedsUpdate.length > 0
                            ? "<i class='fa fa-exclamation-triangle fa-lg text-error' aria-hidden='true'></i> Assigned Registrations"
                            : "<i class='fa fa-fw fa-th-list' aria-hidden='true'></i> Assigned Registrations";

                    $scope.current.processRegistrations = true;
                });
            $http.get('/Portfolio/Representatives/Simple', { trackerMsg: 'Load available reps list' })
                .then(function (response) {
                    $scope.current.selectedReps = $scope.current.selectedReps || [];
                    $scope.availableRepsList = response.data;
                });

            const restrictionUrl = '/Trading/SleeveStrategyAggregate/Restrictions';

            $scope.loadRestrictions = function () {
                $http.get(`${restrictionUrl}?sleeveStrategyAggregateId=${sleeveStrategyAggId}`,
                    { trackerMsg: 'Loading Sleeve Restrictions' })
                    .then((response) => {
                        $scope.restrictions = response.data;
                    });
            };


            /** Opens a dialog box for the given {@linkcode restriction} that allows the end-user to search-for and
             *  select exceptions for that restriction.
            * @param restriction The Restriction entity for which exceptions are being added or removed.
            */
            $scope.editExceptions = function (restriction) {
                var dialogOpts = {
                    templateUrl: 'trading/views/sleeve-strategy-aggregate-restriction-exceptions.html',
                    controller: 'SleeveStrategyAggregateRestrictionExceptionEditCtrl',
                    data: restriction,
                };

                var d = $dialog.dialog(dialogOpts);
                d.open()
                    .then(function (newExceptionsSet) {
                        if (!newExceptionsSet || !newExceptionsSet.updatingRequired) {
                            return;
                        }

                        restriction.exceptions = newExceptionsSet.exceptions;
                        $http.put(restrictionUrl + '/' + restriction.id, restriction,
                            { trackerMsg: 'Updating restriction exception' })
                            .then(response => {
                                if (response.data.validationMessage) {
                                    // Show the validation message
                                    $dialog.actionFailed(response.data.validationMessage).open();
                                }
                            })
                    });
            };

            $scope.addRestriction = function () {

                const newRestriction = {
                    entity: entities.representative.name,
                    sleeveStrategyAggregateId: sleeveStrategyAggId,
                    subAdvisorDefaultId: 0
                };

                $dialog.dialog({
                    templateUrl: "edit-sleeve-restriction.html",
                    controller: "EditSleeveRestrictionCtrl",
                    restriction: newRestriction
                })
                    .open()
                    .then(function (result) {
                        if (!result) {
                            return;
                        }
                        else if (!$scope.restrictions.none({ entity: result.entity, entityId: result.entityId })) {
                            $dialog.actionFailed('That restriction already exists.').open();
                            return;
                        }
                        $http.post(restrictionUrl, result, { trackerMsg: 'Saving new restriction' })
                            .then(function (response) {
                                if (response.data.id !== 0) {
                                    if (response.data.exceptions === null) {
                                        response.data.exceptions = [];
                                    }
                                    $scope.restrictions.add(response.data);
                                }
                                else {
                                    //show validation message
                                    $dialog.actionFailed(response.data.validationMessage).open();
                                }
                            });
                    });
            };

            $scope.editRestriction = function (restriction) {
                $dialog.dialog({ templateUrl: "edit-sleeve-restriction.html", controller: "EditSleeveRestrictionCtrl", restriction: angular.copy(restriction) })
                    .open()
                    .then(function (result) {
                        if (!result) {
                            return;
                        }
                        else if (!$scope.restrictions.none({ entity: result.entity, entityId: result.entityId })) {
                            $dialog.actionFailed('That restriction already exists.').open();
                            return;
                        }

                        $http.put(restrictionUrl + "/" + result.id, result, { trackerMsg: 'Updating restriction' })
                            .then(function (response) {
                                if (!response.data.validationMessage) {
                                    Object.merge(restriction, response.data);
                                }
                                else {
                                    //show validation message
                                    $dialog.actionFailed(response.data.validationMessage).open();
                                }
                            });
                    });
            };

            $scope.deleteRestriction = function (restriction) {
                $dialog.confirmAction('Are you sure you want to delete the {entity} - {entityName} restriction?'.assign(restriction))
                    .open()
                    .then(function (result) {
                        if (result !== 'yes') { return; }

                        $http.delete(restrictionUrl + "/" + restriction.id, { trackerMsg: "Deleting restriction" })
                            .then(function () {
                                $scope.restrictions.remove(restriction);
                            });
                    });
            };

            $scope.loadRestrictions();
        }

        //ensure all data is loaded before adding special details
        //set sleeveStrategyAggOriginal for dirty checks later
        var waitForRequests = function () {
            if ($http.pendingRequests.length > 0) {
                $timeout(waitForRequests);
            } else {
                addSpecialDetails();

                sleeveStrategyAggOriginal = angular.copy($scope.sleeveStrategyAgg);
            }
        };

        $timeout(waitForRequests);
    };

    function loadAllocationMethods() {
        $scope.allocationMethods = [
            { name: 'Assigned', value: 0 },
            { name: 'Sleeve Target', value: 1 },
            { name: 'Most Out Of Balance', value: 2 },
            { name: 'Sleeve Current Percent', value: 3 }
        ]
    };

    function loadAssociatedModelAgg() {
        $http.get("/Trading/ModelAggs/" + $scope.sleeveStrategyAgg.associatedModelAggId, { cache: true, trackerMsg: 'Loading associated model agg' })
            .then(function (response) {
                if (!response.data) {
                    $scope.sleeveStrategyAgg.associatedModelAgg = null;
                    $scope.sleeveStrategyAgg.associatedModelAggId = null;
                } else {
                    $scope.sleeveStrategyAgg.associatedModelAgg = response.data;
                }
            });
    }

    function loadEclipseFirms() {
        $http.get('/Integrations/Eclipse/Firms/ByAlClientId/' + $scope.user.authorization.alClientId, {trackerMsg: 'Loading Eclipse firms'})
            .then(function (response) {
                response.data.forEach(firm => {
                    if (firm.alClients && firm.alClients.length && firm.alClients[0].isDefaultEclipseFirm) {
                        $scope.current.defaultEclipseFirmName = firm.name;
                    }
                });
                $scope.eclipseFirmList = response.data;
            });
    }

    function loadInvestmentObjectives() {
        $http.get("/api/v1/Portfolio/InvestmentObjectives/Simple", { trackerMsg: 'Loading Investment Objective Options' })
            .then(function(response) {
                if(response.data && Array.isArray(response.data)) {
                    response.data.sort((a,b) => a.id - b.id);
                    $scope.investmentObjectives.push({ id: -1, name: 'Please Select'});
                    response.data.forEach(io => {
                        $scope.investmentObjectives.push(io);
                    });
                }
            });
    }

    function setRebalanceFrequencies() {
        $scope.rebalanceFrequencies = ['None', 'Monthly', 'Quarterly', 'Semiannual', 'Annual'];

        if ($scope.rebalanceFrequencies.none($scope.sleeveStrategyAgg.autoRebalFreq)) {
            $scope.sleeveStrategyAgg.autoRebalFreq = $scope.rebalanceFrequencies[0];
            $scope.resetRebalanceMonthDay();
        }
    };

    function getLastDayOfMonth(month) {
        var year = Date.create('today').format('{yyyy}').toNumber();
        $scope.current.lastDayOfMonth = new Date((new Date(year, month, 1)) - 1).getDate();
    };

    function openRegEditor(id) {
        $portfolio.openEditor('6', [id], 'Sleeve Setup', 'sleeveSetup', null, null);
    };

    function addSpecialDetails() {
        //wire up special details if they don't exist
        let custodialDetails = $scope.sleeveStrategyAgg.specialDetails.find({ sleeveType: sleeveTypes.custodial });
        let contributionDetails = $scope.sleeveStrategyAgg.specialDetails.find({ sleeveType: sleeveTypes.contribution });
        let distributionDetails = $scope.sleeveStrategyAgg.specialDetails.find({ sleeveType: sleeveTypes.distribution });

        if (!custodialDetails) {
            $scope.addSpecialDetail(sleeveTypes.custodial);
        }

        if ($scope.showContributionDistribution) {
            if (!contributionDetails) {
                $scope.addSpecialDetail(sleeveTypes.contribution);
            }

            if (!distributionDetails) {
                $scope.addSpecialDetail(sleeveTypes.distribution);
            }
        }
        else {
            //If the option is off and we find either Contribution/Distribution, remove them so they will be processed
            if (contributionDetails) {
                $scope.sleeveStrategyAgg.specialDetails.remove(contributionDetails);
            }

            if (distributionDetails) {
                $scope.sleeveStrategyAgg.specialDetails.remove(distributionDetails);
            }
        }

        $scope.sleeveStrategyAgg.specialDetails.forEach(function (specialDetail) {
            specialDetail.editMgmtStyle = true;

            if (specialDetail.aggregateModelId) {
                specialDetail.aggregateModel = { id: specialDetail.aggregateModelId, name: specialDetail.aggregateName };
            }

            if (specialDetail.managementStyleId && specialDetail.managementStyleName) {
                specialDetail.managementStyle = { id: specialDetail.managementStyleId, name: specialDetail.managementStyleName };
            }
        });
    };

    function processRegistrations(id, action) {
        let sleeveDataRegistrations = { assignedRegistrationIds: [], unAssignedRegistrationIds: [] };

        if ($scope.current.assignedRegistrations.length > 0 && action.indexOf('|assign|') !== -1) {
            $scope.current.assignedRegistrations.forEach(function (item) {
                sleeveDataRegistrations.assignedRegistrationIds.push((item.id));
            });
        }

        if ($scope.current.unAssignedRegistrations.length > 0 && action.indexOf('|unassign|') !== -1) {
            $scope.current.unAssignedRegistrations.forEach(function (item) {
                sleeveDataRegistrations.unAssignedRegistrationIds.push((item.id));
            });
        }

        if ($scope.current.regNeedsUpdate.length > 0 && action.indexOf('|needsupdate|') !== -1) {
            $scope.current.regNeedsUpdate.forEach(function (item) {
                if (sleeveDataRegistrations.unAssignedRegistrationIds.indexOf(item.id) === -1 &&
                    sleeveDataRegistrations.assignedRegistrationIds.indexOf(item.id) === -1) {
                    sleeveDataRegistrations.assignedRegistrationIds.push((item.id));
                }
            });
        }

        sleeveDataRegistrations.removeCustomizations = $scope.current.removeCustomizations;

        if (sleeveDataRegistrations.removeCustomizations ||
            sleeveDataRegistrations.unAssignedRegistrationIds.length > 0 ||
            sleeveDataRegistrations.assignedRegistrationIds.length > 0) {
            $http.post('/Trading/SleeveStrategyAggregate/' + id + '/Action/Process/Registration', sleeveDataRegistrations)
                .then(function (response) {
                    if (response && response.data > 0) {
                        $tradeGenerator.startPolling(response.data, false);
                        $scope.$on('event:orders-success', function () {
                            $dialog.messageBox('<i class="fa fa-lg fa-check-square" aria-hidden="true"></i> Action Complete', 'Registration process completed successfully.').open()
                                .then(function () {
                                    $location.path('/modeling/sleevestrategyagg');
                                });
                        });
                        $scope.$on('event:orders-error', function (e, args) {
                            $dialog.messageBox('<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Process Error', 'There was an error updating registration for this sleeve strategy aggregation.' + '<br>' + args.message).open();
                        });
                    } else {
                        $location.path('/modeling/sleevestrategyagg');
                    }
                });
        }
    }

    $scope.viewStrategyInformation = function (strategy) {
        var dialogOpts = {
            templateUrl: 'sleeveStrategy-information.html',
            controller: 'SleeveStrategyInfoCtrl',
            sleeveDetails: strategy,
            dialogClass: 'modal wide'
        };

        $dialog.dialog(dialogOpts)
            .open();
    };

    $scope.assignRegistrationToSleeveStrategy = function () {
        var dialogOpts = {
            templateUrl: 'sleeveStrategyAgg-assign-registrations.html',
            controller: 'SleeveStrategyAggAssignRegistrationsCtrl',
            id: sleeveStrategyAggId
        };

        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function (result) {
                if (result) {
                    if (!result.errorMessage) {
                        $http.get('/Trading/SleeveStrategyAggregate/RegistrationsAssignedSimple/' + sleeveStrategyAggId, { trackerMsg: 'Loading assigned registrations to sleeve strategy' })
                            .then(function (response) {
                                response.data.forEach(function (item) {
                                    item.canDelete = $scope.rightsSleeveStrategyAgg.canDelete;
                                });
                                //list of registrations; found on assigned reg tab
                                listSectionData.dataItems = response.data;
                                $scope.$broadcast(sleeveAggRegDataItemsEvent);

                                $scope.current.assignedRegistrations = listSectionData.dataItems;
                                $scope.current.anyRegHasCustomizedSleeves = $scope.current.assignedRegistrations.some(x => x.hasCustomizedSleeves);

                                $scope.current.processRegistrations = false;
                            });
                    }
                    else {
                        $dialog.actionFailed(result.errorMessage).open();
                    }
                }
            });
    };

    $scope.unAssignRegistrationFromSleeveStrategy = function () {
        if ($scope.current.unAssignedRegistrations.length > 0) {
            processRegistrations(sleeveStrategyAggId, '|unassign|');
        }
    };

    $scope.processRegistrationsNeedingUpdate = function () {
        if ($scope.current.regNeedsUpdate.length > 0) {
            processRegistrations(sleeveStrategyAggId, '|needsupdate|');
        }
    };

    $scope.setSleeveContributionDistributionPercents = function () {

        $scope.sleeveAggAllocationTypes.forEach(function (type) {
            var copyField;
            switch ($scope.sleeveStrategyAgg[type + 'AllocationMethod']) {
                case 'Sleeve Target':
                    copyField = 'targetAllocation';
                    break;
                default:
                    return;
            }

            $scope.sleeveStrategyAgg.details.forEach(function (sleeve) {
                sleeve[type + 'Allocation'] = sleeve[copyField];
            });
        });

        $scope.calculateSleeveTotals();

    };

    $scope.addSpecialDetail = function (sleeveType) {
        var specialDetail = {
            sleeveStrategyAggregateId: sleeveStrategyAggId,
            platformId: null,
            aggregateModelId: null,
            sleeveType: sleeveType
        };

        $scope.sleeveStrategyAgg.specialDetails.push(specialDetail);
    };

    $scope.addStrategyAggDetail = function () {
        var sleeve = {
            sleeveStrategyAggId: sleeveStrategyAggId,
            riskScore: null,
            targetAllocation: 0,
            contributionAllocation: 0,
            distributionAllocation: 0,
            sleeveStrategyAggModel: null,
            toleranceUpper: 0,
            toleranceLower: 0
        };

        $scope.sleeveStrategyAgg.details.push(sleeve);
        $scope.calculateSleeveTotals();
    };

    $scope.removeSleeveAggDetail = function (sleeveStrategy) {
        $scope.sleeveStrategyAgg.details.remove(sleeveStrategy);
        $scope.calculateSleeveTotals();
    };

    $scope.calculateSleeveTotals = function () {
        const sleeveStrategyAgg = $scope.sleeveStrategyAgg;

        sleeveStrategyAgg.targetTotal = 0;
        sleeveStrategyAgg.contributionAllocationTotal = 0;
        sleeveStrategyAgg.distributionAllocationTotal = 0;
        sleeveStrategyAgg.toleranceUpperTotal = 0;
        sleeveStrategyAgg.toleranceLowerTotal = 0;

        sleeveStrategyAgg.details.forEach(sleeveStrategyAggDetail => {
            sleeveStrategyAgg.targetTotal += sleeveStrategyAggDetail.targetAllocation;
            sleeveStrategyAgg.contributionAllocationTotal += sleeveStrategyAggDetail.contributionAllocation;
            sleeveStrategyAgg.distributionAllocationTotal += sleeveStrategyAggDetail.distributionAllocation;
            sleeveStrategyAgg.toleranceUpperTotal += sleeveStrategyAggDetail.toleranceUpper;
            sleeveStrategyAgg.toleranceLowerTotal += sleeveStrategyAggDetail.toleranceLower;
        });

        sleeveStrategyAgg.riskScore =
            calculateWeightedRiskScoreAverage($scope.sleeveStrategyAgg.details, sleeveStrategyAgg.targetTotal);
    };

    function calculateWeightedRiskScoreAverage(details, totalTargetAllocation) {
        const nullToIndicateRiskScoreCannotBeCalculated = null;

        if (totalTargetAllocation !== 100) {
            return nullToIndicateRiskScoreCannotBeCalculated;
        }

        var weightedRiskScore = 0;
        let riskScoreCannotBeCalculated = false;
        var sleevesWithTargetAllocation = details.filter(x => x.targetAllocation > 0);
        const falseToBreak = false;

        sleevesWithTargetAllocation.forEach(sleeve => {
            if (sleeve.strategy == null || !sleeve.strategy)  {
                // It's possible that the user is in the process of replacing the sleeve.  We need to remove the
                // risk score of the previous sleeve from the grid:
                sleeve.riskScore = null;

                // At this point, we don't have the sleeve.strategy yet, and therefore we don't have the strategy
                // ID, which means we can't retrieve the risk score yet.
                riskScoreCannotBeCalculated = true;
                return falseToBreak;
            }

            if (sleeve.strategy.riskScore == null || !sleeve.strategy.riskScore) {
                const sleeveWasRecentlyAdded = sleeve.id === undefined;
                const sleeveWasReplacedWithAnother = sleeve.sleeveStrategyId != sleeve.strategy.id;
                if (sleeveWasRecentlyAdded || sleeveWasReplacedWithAnother) {
                    $scope.getRiskScoreForStrategyAndRecalculate(sleeve.strategy.id);
                    // Risk score will (likely) be recalculated via the above promise, but we cannot calculate it
                    // right now.
                }
                riskScoreCannotBeCalculated = true;
                return falseToBreak;
            }

            weightedRiskScore += sleeve.targetAllocation * sleeve.strategy.riskScore / 100;
        });

        return riskScoreCannotBeCalculated
            ? nullToIndicateRiskScoreCannotBeCalculated
            : weightedRiskScore;
}

$scope.getRiskScoreForStrategyAndRecalculate = function(sleeveStrategyId) {
    $http.get('/Trading/SleeveStrategy/' + sleeveStrategyId,
        { trackerMsg: 'Retrieving Strategy Details...' })
        .then(function (response) {
            // Note: This is a bit of a hack since I couldn't figure out how to get the added/edited sleeve via
            // onBlur on the oas-search control (1/11/2024, ESL)

            // example structure: details[2]: { sleeveStrategyAggId: '130', strategy: {id: 391, ... }, ... }
            const sleeveStrategyIndex = $scope.sleeveStrategyAgg.details
                .findIndex(x => x.strategy.id === sleeveStrategyId);
            if (sleeveStrategyIndex === -1) {
                // The sleeve to update was not found.  This might happen if the user changed the sleeve to a
                // different one before the risk score for the sleeve we just received could be obtained.
                return;
            }

            const sleeveToUpdate = $scope.sleeveStrategyAgg.details[sleeveStrategyIndex];

            const sleeveWasRecentlyAdded = sleeveToUpdate.id === undefined;
            if (sleeveWasRecentlyAdded) {
                // We set the following to prevent an infinite loop at trying to get the risk score:
                sleeveToUpdate.id = null;
            }

            // Note: sleeveStrategyId is being used to detect if the user changes the sleeve on an existing row:
            sleeveToUpdate.sleeveStrategyId = sleeveToUpdate.strategy.id;

            sleeveToUpdate.riskScore = response.data.riskScore;
            if (!sleeveToUpdate.riskScore) {
                console.info(`Unable to retrieve the risk score for sleeve strategy ID: ${sleeveStrategyId}`);
                // Wasn't able to get the risk score, or the risk score doesn't exist for this sleeve strategy.
                $scope.sleeveStrategyAgg.riskScore = null;
            }

            sleeveToUpdate.strategy.riskScore = response.data.riskScore;
            $scope.calculateSleeveTotals();
        });
}


$scope.setSleeveAggContributionDistributionPercents = function () {
        $scope.sleeveAggAllocationTypes.forEach(function (type) {
            var copyField;
            switch ($scope.sleeveStrategyAgg[type + 'AllocationMethod']) {
                case 'Sleeve Target':
                    copyField = 'targetAllocation';
                    break;
                default:
                    return;
            }

            $scope.sleeveStrategyAgg.details.forEach(function (sleeve) {
                sleeve[type + 'Allocation'] = sleeve[copyField];
            });
        });

        $scope.calculateSleeveTotals();
    };

    $scope.resetRebalanceMonthDay = function () {
        var rebalDate;
        switch ($scope.sleeveStrategyAgg.autoRebalFreq) {
            case 'Semiannual':
                rebalDate = Date.create('6 months from now');
                if ((rebalDate.getMonth() + 1) > 6) {
                    rebalDate = Date.create();
                }
                break;
            case 'Annual':
                rebalDate = Date.create('365 days from now');
                break;
            default:
                rebalDate = Date.create('1/10/2000');
                break;
        }

        //figure out last day of month
        $scope.resetRebalanceMonth(rebalDate);

        if (rebalDate.getDate() === Date.create('today').getDate()) { rebalDate.rewind('1 day'); }
        $scope.sleeveStrategyAgg.autoRebalMonth = rebalDate.getMonth() + 1;

        //this sets the last day of the month (FTJ will cap at 28)
        $scope.sleeveStrategyAgg.autoRebalDay = rebalDate.getDate().cap($scope.current.lastDayOfMonth);

    };

    $scope.resetRebalanceMonth = function (d) {
        if ($scope.user.isFTJ) {
            $scope.current.lastDayOfMonth = 28;
        }
        else {
            getLastDayOfMonth($scope.sleeveStrategyAgg.autoRebalMonth);
            $scope.sleeveStrategyAgg.autoRebalDay = d ? d.getDate() : Date.create('365 days from now').getDate();

        }
    };

    $scope.saveSleeveStrategyAgg = function (form) {
        var args = {
            method: null,
            url: sleeveStrategyAggUrl + '?allowOneDetail=true',
            trackerMsg: sleeveStrategyAggId > 0 ? 'Saving Sleeve Strategy Agg. ' + sleeveStrategyAggId : 'Adding new Sleeve Strategy Agg.'
        };

        if (sleeveStrategyAggId > 0) {
            args.method = 'PUT';
            args['id'] = sleeveStrategyAggId;
        }
        else {
            args.method = 'POST';
            args['data'] = $scope.sleeveStrategyAgg;
        }

        var executeSave = function (doProcess) {
            $scope.sleeveStrategyAgg.details.forEach(function (detail) {
                detail.sleeveStrategyId = detail.strategy.id;
            });

            if ($scope.sleeveStrategyAgg.entity === 'Representative') {
                var inList = $scope.current.selectedReps.any({ id: $scope.current.selectedRep });

                if (inList) {
                    $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Sleeve Strategy Aggregate Save Error", "Owner representative cannot be in the include/exclude list.").open();
                    return;
                }
            }

            $scope.sleeveStrategyAgg.entity = $scope.current.entityType === entities.representative.name ? entities.representative.name : null;
            $scope.sleeveStrategyAgg.entityId = $scope.current.entityType === entities.representative.name ? $scope.current.selectedRepOwner : null;

            //clear out and rebuild array
            $scope.sleeveStrategyAgg.entities = [];

            if ($scope.current.selectedReps.length > 0) {
                $scope.current.selectedReps.forEach(function (item) {
                    $scope.sleeveStrategyAgg.entities.push({ entityEnum: entities.representative.name, entityId: item.id });
                });
            }

            $scope.sleeveStrategyAgg.specialDetails.forEach(function (specialDetail) {
                //special sleeve, models are optional
                //if one isn't chosen in the search box, set it to null
                specialDetail.aggregateModelId = specialDetail.aggregateModel && specialDetail.aggregateModel.id
                    ? specialDetail.aggregateModel.id
                    : null;

                if (specialDetail.managementStyle) {
                    specialDetail.managementStyleId = specialDetail.managementStyle.id;
                }
            });

            $http({ method: args.method, url: args.url, data: $scope.sleeveStrategyAgg, trackerMsg: args.trackerMsg })
                .then(function (response) {
                    $scope.deleteBreadcrumb();
                    if (doProcess) {
                        processRegistrations($scope.sleeveStrategyAgg.id, '|assign|unassign|');
                    }
                    else {
                        processRegistrations($scope.sleeveStrategyAgg.id, '|needsupdate|unassign|');
                        $location.path('/modeling/sleevestrategyagg');
                    }
                });
        };

        if (!form.$valid) {
            $dialog.messageBox('<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Invalid Sleeve Strategy Aggregation', 'One or more fields are invalid or required.').open();
            return;
        }

        //these checks are to make sure there are sleeve strategy Agg details
        const detailsIsEmpty = $scope.sleeveStrategyAgg.details.isEmpty();

        const validDetails = $scope.sleeveStrategyAgg.details.any(function (detail) {
            return (angular.isDefined(detail.strategy) && detail.strategy.id !== null);
        });

        if (detailsIsEmpty || !validDetails) {
            $dialog.messageBox('<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Save Error', 'Sleeve Strategy Aggregation must contain one or more valid Sleeve Strategies').open();

            return;
        }

        // if a rep is the owner, a rep must be selected
        if ($scope.current.entityType === entities.representative.name
            && (!$scope.current.selectedRepOwner || !$scope.availableRepsList.find({ id: $scope.current.selectedRepOwner }).isActive)) {
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Permissions Save Error", "An active Representative must be selected").open();

                return;
            }

        let [targetAllocationTotal, contributionAllocationTotal, distributionAllocationTotal] = [0, 0, 0];
        $scope.sleeveStrategyAgg.details.forEach(detail => {
            targetAllocationTotal += detail.targetAllocation;
            contributionAllocationTotal += detail.contributionAllocation;
            distributionAllocationTotal += detail.distributionAllocation;
        });
        if (Math.round(targetAllocationTotal, 2) !== 100
            || Math.round(contributionAllocationTotal, 2) !== 100
            || Math.round(distributionAllocationTotal, 2) !== 100) {
            $dialog.messageBox('<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Save Error', 'Target Percent, Contribution & Distribution Allocations must equal 100%').open();

            return;
        }

        const customizedRegistrations = $scope.current.assignedRegistrations.filter(x => x.hasCustomizedSleeves);

        if (!($scope.sleeveStrategyAgg.allowCustomization) && $scope.current.anyRegHasCustomizedSleeves) {
            $dialog.messageBox('<i class="fa fa-exclamation-triangle fa-lg text-warning" aria-hidden="true"></i> Save Error', 'Sleeve Strategy Aggregate contains Registrations with customized sleeves. Allow Customization must be checked.').open();
            return;
        }

        if (listSectionData.dataItems.length === 0
            || angular.equals(sleeveStrategyAggOriginal, $scope.sleeveStrategyAgg)) {
                executeSave(false);
                return;
            }

        $dialog.confirmAction(`Sleeve Strategy Aggregate - ${$scope.sleeveStrategyAgg.name} has changed. Any registrations assigned to this sleeve strategy aggregate will automatically process. <br> To cancel click No `)
            .open()
            .then((doSave) => {
                if (doSave !== 'yes') {
                    return;
                }

                if (!$scope.current.anyRegHasCustomizedSleeves) {
                    executeSave(true);
                    return;
                }

                //show dialog about customized registrations
                let dialogText = 'Sleeve Strategy Aggregate contains Registrations with customized sleeves.';

                dialogText = dialogText.concat('<br><br>Select YES to keep the customizations. Select NO to reset all assigned Registrations to match the Sleeve Strategy Aggregate.');
                dialogText = dialogText.concat('<br><br><strong>This action cannot be undone.</strong>');
                dialogText = dialogText.concat('<br><br>Registrations that will be affected:<br>');

                customizedRegistrations.forEach(x => {
                    dialogText = dialogText.concat(`<br>${x.id}`);
                });

                $dialog.confirmAction(dialogText)
                    .open()
                    .then((removeCustomizations) => {
                        //no -> remove the customizations
                        $scope.current.removeCustomizations = removeCustomizations === 'no';

                        executeSave(true);
                    });
        });
    };

    function getDistinctLinkedSleeveStrategyNames() {
        const detailRows = $scope.sleeveStrategyAgg?.details;
        if (!detailRows?.length) {
            return [];
        }
        const seenSleeveStrategyIds = {};
        const strategyDisplayNames = [];
        detailRows.forEach(function (detailRow) {
            const sleeveStrategyId = detailRow?.sleeveStrategyId ?? detailRow?.strategy?.id;
            if (!sleeveStrategyId || seenSleeveStrategyIds[sleeveStrategyId]) {
                return;
            }
            seenSleeveStrategyIds[sleeveStrategyId] = true;
            const displayName = detailRow?.strategy?.name ?? `Sleeve strategy ${sleeveStrategyId}`;
            strategyDisplayNames.push(displayName);
        });
        strategyDisplayNames.sort(function (left, right) { return left.localeCompare(right); });
        return strategyDisplayNames;
    }

    function executeSleeveStrategyAggregateDelete() {
        $http.delete(sleeveStrategyAggUrl, { trackerMsg: `Deleting sleeve strategy agg ${sleeveStrategyAggId}` })
            .then(function () {
                $scope.deleteBreadcrumb();
                $location.path('/modeling/sleevestrategyagg');
            });
    }

    $scope.deleteSleeveStrategyAgg = function () {
        if (listSectionData.dataItems.length > 0) {
            const registrationsAssignedTitle =
                `<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i>`
                + ' Registrations Assigned';
            const registrationsAssignedMessage =
                `<b>${$scope.sleeveStrategyAgg.name}</b> has assigned registrations. `
                + 'Please remove registrations before trying to delete the sleeve strategy agg.';
            $dialog.messageBox(registrationsAssignedTitle, registrationsAssignedMessage).open();
            return;
        }

        const linkedSleeveStrategyNames = getDistinctLinkedSleeveStrategyNames();
        if (linkedSleeveStrategyNames.length > 0) {
            const strategyLabel = linkedSleeveStrategyNames.length === 1 ? 'sleeve strategy' : 'sleeve strategies';
            const strategyLines = linkedSleeveStrategyNames.map(function (strategyName) {
                return `${strategyName}<br>`;
            }).join('');
            const aggName = $scope.sleeveStrategyAgg.name;
            const deleteLinkedStrategiesConfirmMessage =
                `<b>${aggName}</b> is linked to the following ${strategyLabel}:<br><br>${strategyLines}<br>`
                + 'Deleting this sleeve strategy aggregate will <b>not</b> delete those sleeve strategies. '
                + 'To remove a sleeve strategy completely, delete it from the Sleeve Strategy screen instead. '
                + 'That deletes the strategy and its 100% sleeve strategy aggregate together.<br><br>'
                + `Are you sure you want to delete <b>${aggName}</b>?`;

            $dialog.confirmAction(deleteLinkedStrategiesConfirmMessage)
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        executeSleeveStrategyAggregateDelete();
                    }
                });
            return;
        }

        $dialog.confirmAction(
            `Are you sure you want to delete <b>${$scope.sleeveStrategyAgg.name}</b>?`)
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    executeSleeveStrategyAggregateDelete();
                }
            });
    };


    $scope.itemAction = function (item, action) {
        if (action === 'edit-registration-sleeve-strategy') {
            openRegEditor(item.id);
        }
        if (action === 'delete-registration-sleeve-strategy') {
            removeRegistrationFromSleeveStrategyAgg(item);
        }
    };

    $scope.$on('item-action', function (e, args) {
        if (args.action === 'edit-registration-sleeve-strategyAgg') {
            openRegEditor(args.item.id);
        }
        if (args.action === 'delete-registration-sleeve-strategyAgg') {
            removeRegistrationFromSleeveStrategyAgg(args.item);
        }
    })

    $scope.showHelpText = function (option) {
        var text = null;
        switch (option) {
            case 'Allow Customization':
                text = 'There are registrations assigned with customized sleeves. Sleeve Strategy Aggregate must allow customization.';
                break;
        }
        if (text) {
            $dialog.messageBox(option, text).open();
        }
    };

    $scope.setAssociatedModelAggId = function (associatedModelAgg) {
        $scope.sleeveStrategyAgg.associatedModelAggId = associatedModelAgg.id;
    };

    $scope.unAssignAssociatedModelAgg = function () {
        if ($scope.sleeveStrategyAgg.associatedModelAgg) {
            $dialog.confirmAction("Are you sure you want unassociate model agg <b>" + $scope.sleeveStrategyAgg.associatedModelAgg.name +
                "</b> from this sleeve strategy aggregate?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        $scope.sleeveStrategyAgg.associatedModelAgg = null;
                        $scope.sleeveStrategyAgg.associatedModelAggId = null;
                    }
                });
        }
    };

    function removeRegistrationFromSleeveStrategyAgg(reg) {
        listSectionData.dataItems.remove(reg);
        $scope.current.unAssignedRegistrations.push(reg);
        $scope.$broadcast(sleeveAggRegDataItemsEvent);
    };

    $scope.rightsSleeveAggSetup = $oasRights.forCode('SLEEVESETUP');
    $scope.rightsSleeveStrategyAgg = $oasRights.forCode('SLEEVE_STRATEGY');
    $scope.rightsEclipseTrading = $oasRights.forCode("ECLIPSETRADING");

    $scope.sleeveAggRegConfig = {
        getUrl: null,
        listName: 'Registrations',
        template: 'sleeveStrategyAgg-registration-list-item.html',
        icon: 'fa fa-users',
        addItemEvent: addSleeveAggRegistrationEvent,
        rebalanceItemEvent: rebalanceSelectedEvent,
        loadDataItemsEvent: sleeveAggRegDataItemsEvent,
        selectEnabled: false,
        multiSelectEnabled: false,
        nameProperty: 'name',
        dataProperty: 'registrations',
        selectProperty: 'registrationId',
        sortFields: { name: 'Reg. Name', id: 'Reg. Id' },
        listFilter: ['name', 'id'],
        additionalLinks: []
    };

    $scope.current = {
        regAssignedTab: false,
        showFilterRow: true,
        autoRebalanceFrequency: [
            { name: 'None', value: 0 },
            { name: 'Monthly', value: 1 },
            { name: 'Quarterly', value: 3 },
            { name: 'Semi-Annual', value: 6 },
            { name: 'Annual', value: 12 }
        ],
        autoRebalanceMonth: [
            { name: 'January', value: 1 },
            { name: 'Febuary', value: 2 },
            { name: 'March', value: 3 },
            { name: 'April', value: 4 },
            { name: 'May', value: 5 },
            { name: 'June', value: 6 },
            { name: 'July', value: 7 },
            { name: 'August', value: 8 },
            { name: 'September', value: 9 },
            { name: 'October', value: 10 },
            { name: 'November', value: 11 }, { name: 'December', value: 12 }],
        allocationMethods: [
            { name: 'Assigned', value: 0 },
            { name: 'Sleeve Target', value: 1 },
            { name: 'Most Out Of Balance', value: 2 },
            { name: 'Sleeve Current Percent', value: 3 }
        ],
        autoTradeTypes: {
            101: 'Registration rebalance',
            102: 'Sleeve rebalance',
            104: 'Contribution rebalance',
            108: 'Transfer in kind rebalance'
        },
        selectedAutoTradeTypes: [],
        changeTypeFormats: {
            U: 'Update',
            I: 'Insert',
            D: 'Delete'
        },
        showLockedRows: false,
        lastDayOfMonth: 28,
        processRegistrations: false,
        assignedRegistrations: [],
        unAssignedRegistrations: [],
        addType: 'single',
        modelSubstitutions: [],
        assignedRegClass: "<i class='fa fa-fw fa-th-list' aria-hidden='true'></i> Assigned Registrations",
        regNeedsUpdate: [],
        selectedReps: [],
        canSetPermissions: ['Administrator', 'Advisor'].any($scope.user.authorization.entity) && $oasRights.canUpdate('SLEEVE_STRATEGY'),
        includedText: 'Include All But',
        isRep: $scope.user.authorization.entity === entities.representative.name,
        defaultEclipseFirmName: null,
    };

    $scope.sleeveAggAllocationTypes = ['contribution', 'distribution'];
    $scope.sleeveStrategyAggHistory = null;
    $scope.sleeveStrategyAggDetailHistory = null;

    loadAllocationMethods();
    init();

});

app.controller('SleeveStrategyInfoCtrl', function SleeveStrategyInfoCtrl($scope, $http, dialog) {
    function init() {
        if (Object.has(dialog.options.sleeveDetails, 'details')) {
            $scope.sleeveStrategyInfo = dialog.options.sleeveDetails;
        }
        else {
            getStrategyDetails(dialog.options.sleeveDetails.id);
        }
    }

    function getStrategyDetails(id) {
        $http.get('/Trading/SleeveStrategy/' + id, { trackerMsg: 'Retrieving Strategy Details...' })
            .then(function (response) {
                $scope.sleeveStrategyInfo = response.data;
            });
    }

    $scope.close = function () {
        dialog.close();
    };

    $scope.sleeveStrategyInfo = null;

    init();
});

app.controller('SleeveStrategyAggAssignRegistrationsCtrl', function SleeveStrategyAggAssignRegistrationsCtrl($scope, $http, dialog, $timeout, $tradeGenerator) {
    $scope.sleeveAggAssignedRegistrations = [];

    function addRegToSleeve() {
        if ($scope.current.registrationList.length > 0) {
            $scope.current.noDataFromImport = false;
            $scope.current.registrationList.forEach(function (item) {
                var isInList = $scope.sleeveAggAssignedRegistrations.find({ id: item.id });

                if (!isInList) {
                    $scope.sleeveAggAssignedRegistrations.push({ id: item.id, name: item.regName, message: item.message, promptToSplit: !!item.promptToSplit, isError: item.isError, isWarning: item.isWarning });
                }
            });

            $scope.current.cantProcess = $scope.sleeveAggAssignedRegistrations.none({ message: null }, { promptToSplit: false }, { isError: false }) && !$scope.sleeveAggAssignedRegistrations.some(x => x.isWarning);
        }
        else {
            $scope.current.noDataFromImport = true;
        }
    }

    $scope.switchAddType = function () {
        $scope.startOver();
    };

    $scope.addRegistration = function () {
        var regToSleeve = function (data) {
            //Check to see if registration was already in list
            var isInList = $scope.sleeveAggAssignedRegistrations.find({ id: $scope.current.selectedRegistration.id });

            if (!isInList) {
                $scope.sleeveAggAssignedRegistrations.push({ id: $scope.current.selectedRegistration.id, name: $scope.current.selectedRegistration.name, message: data.message, promptToSplit: !!data.promptToSplit, isError: data.isError, isWarning: data.isWarning });
            }

            $scope.current.selectedRegistration = null;
            $scope.current.regCheckFinished = true;
            $scope.current.cantProcess = $scope.sleeveAggAssignedRegistrations.none({ message: null }, { promptToSplit: false }, { isError: false }) && !$scope.sleeveAggAssignedRegistrations.some(x => x.isWarning);
        };

        $http.get('/Trading/Sleeve/Registrations/' + $scope.current.selectedRegistration.id + '/Check', { trackerMsg: 'Checking registration to sleeve' })
            .then(function (response) {
                regToSleeve(response.data);
            });
    };

    $scope.removeSelection = function (item) {
        var idx = $scope.sleeveAggAssignedRegistrations.indexOf(item);

        $scope.sleeveAggAssignedRegistrations.splice(idx, 1);

        $scope.current.cantProcess = $scope.sleeveAggAssignedRegistrations.none({ message: null }, { promptToSplit: false }) && !$scope.sleeveAggAssignedRegistrations.some(x => x.isWarning);
    };

    $scope.process = function () {
        var ids = [];

        $scope.sleeveAggAssignedRegistrations.forEach(function (item) {
            if ((item.message == null || item.isWarning) && !item.promptToSplit && !item.isError) {
                ids.push((item.id));
            }
        });

        var data = { assignedRegistrationIds: ids, unAssignedRegistrationIds: [] };

        $scope.current.isProcessing = true;

        $http.post('/Trading/SleeveStrategyAggregate/' + dialog.options.id + '/Action/Process/Registration', data)
            .then(function (response) {
                if (!response.data) {
                    dialog.close(null);
                    return;
                }

                $tradeGenerator.startPolling(response.data, false);

                $scope.$on('event:orders-success', function () {
                    dialog.close($scope.sleeveAggAssignedRegistrations);
                });

                $scope.$on('event:orders-error', function (e, args) {
                    $scope.sleeveAggAssignedRegistrations.errorMessage = args.errorCount > 0 ? args.message : null;
                    dialog.close($scope.sleeveAggAssignedRegistrations);
                });
            }, function (response) {
                $scope.current.errorMessage = response.statusText;
                $scope.current.isProcessing = false;
            });
    };

    $scope.close = function () {
        dialog.close(null);
    };

    $scope.dataLoaded = function () {
        $scope.current.regCheckFinished = false;
        $timeout(function () {
            addRegToSleeve();
            $scope.current.regCheckFinished = true;
        }, 100);
    };

    $scope.startOver = function () {
        $scope.sleeveAggAssignedRegistrations = [];
        $scope.current.registrationList = [];
        $scope.current.regCheckFinished = false;
        $scope.current.cantProcess = true;
        $scope.current.selectedRegistrations = null;
        $scope.current.noDataFromImport = false;
    };

    $scope.current = {
        selectedRegistrations: null,
        showErrorMessage: false,
        isProcessing: false,
        errorMessage: '',
        registrationList: [],
        noDataFromImport: false,
        regCheckFinished: false,
        cantProcess: true
    };
});

'use strict';

/** Keeps `current.strategyImportData` in sync for the file-uploader; grid + orion-ag-grid are in the downgraded component. */
app.controller('SleeveStrategyImportCtrl', function SleeveStrategyImportCtrl($scope) {

    $scope.current = { strategyImportData: [] };

    $scope.onSleeveImportDataChange = function (data) {
        $scope.current.strategyImportData = data || [];
    };
});

'use strict';

/** Controller for handling a dialog box which allows the end-user to add or remove Exceptions from a given
* Restriction.  The type of the Restriction is provided in $scope.current.restriction.entity, which is used to
* determine the type of Exceptions permitted (e.g., the Entity or EntityType).
* Tye type of permitted Exceptions is set in $scope.current.exceptionType, assigned by {@linkcode initialize}.
*/
app.controller('SleeveStrategyAggregateRestrictionExceptionEditCtrl',
    function SleeveStrategyAggregateRestrictionExceptionEditCtrl($scope, $http, $dialog, $oasRights, dialog) {

        function initialize() {
            // $scope.current contains metadata for an Entity (e.g., Broker/Dealer) which is a Restriction -- and
            // that Restriction may have zero or more Exceptions (e.g., representatives) applied to it
            $scope.current.selectedEntity = null; // Causes the "hint" to appear in the oas-search box
            $scope.current.restriction = dialog.options.data; // The Restriction whose Exceptions are being edited
            $scope.current.exceptions = $scope.current.restriction.exceptions; // Displayed on the Exceptions grid

            // The types of Entities (e.g., reps) which can be exempted from restrictions is dependent on the type
            // of Entity Restriction (e.g., Broker/Dealer) that the exceptions are applied to.
                switch ($scope.current.restriction.entity) {
                case "Broker/Dealer":
                    $scope.current.exceptionType = "Representative";
                    break;
                default:
                    $scope.current.exceptionType = "Representative";
                    break;
            }
        }

        function removeItemFromCrudCollections(item) {
            removeItemFromCollection($scope.bulkCrudObjects.create, item);
            removeItemFromCollection($scope.bulkCrudObjects.update, item);
            removeItemFromCollection($scope.bulkCrudObjects.delete, item);
        }

        function removeItemFromCollection(collection, item) {
            const idx = getItemIndex(collection, item);
            if (idx === -1) {
                return false;
            }

            collection.splice(idx, 1);
            return true;
        }

        const collectionContainsItem = (collection, item) => getItemIndex(collection, item) !== -1;

        const getItemIndex = (collection, item) => collection.findIndex(thisItem =>
            thisItem.entity === item.entity && thisItem.entityId === item.entityId);


        $scope.removeException = function (item) {
            removeItemFromCrudCollections(item);
            const itemExistsInDb = removeItemFromCollection($scope.current.exceptions, item);
            // Otherwise, it might have just been added by the end-user, who is now changing their mind.
            if (itemExistsInDb) {
                $scope.bulkCrudObjects.delete.push(item);
            }
        };

        $scope.addEntityToException = function () {
            const { name, ...restrictionException } = $scope.current.selectedEntity; // Remove the 'name' field
            restrictionException.restrictionId = $scope.current.restriction.id; // The restriction that this exception applies to
            restrictionException.entityId = restrictionException.id; // The ID of the Exception entity (from the oas-search box result)
            restrictionException.id = 0; // A new exception doesn't have an ID yet
            restrictionException.entity = $scope.current.exceptionType; // e.g., "Representative"
            restrictionException.entityName = name; // 'name' comes from the oas-search box result

            if (collectionContainsItem($scope.bulkCrudObjects.create, restrictionException)
                || collectionContainsItem($scope.current.exceptions, restrictionException)) {
                $dialog.actionFailed('That exception already exists.').open();
                return;
            }

            removeItemFromCrudCollections(restrictionException);
            $scope.bulkCrudObjects.create.push(restrictionException);
            $scope.current.exceptions.push(restrictionException); // Used by the Exceptions grid
            $scope.current.selectedEntity = null; // Remove the rep from the oas-search box, restoring its "hint"
        };

        $scope.close = function () {
            const newExceptions = dialog.options.data.exceptions
                .filter((value) => !collectionContainsItem($scope.bulkCrudObjects.delete, value))
                .concat($scope.bulkCrudObjects.create, $scope.bulkCrudObjects.update);

            const uniqueExceptions = [];
            newExceptions.forEach((thisException) => {
                if (!collectionContainsItem(uniqueExceptions, thisException)) {
                    uniqueExceptions.push(thisException);
                }
            });

            const newExceptionsSet = {
                restrictionId: $scope.current.restriction.id,
                exceptions: uniqueExceptions,
                updatingRequired: $scope.bulkCrudObjects.delete.length !== 0
                    || $scope.bulkCrudObjects.create.length !== 0
                    || $scope.bulkCrudObjects.update.length !== 0
            };
            dialog.close(newExceptionsSet);
        };

        $scope.rights = { canUpdate: true };
        $scope.current = { selectedEntity: null, restriction: null, exceptions: null };

        // bulkCrudObjects are used internally by this controller, but they're flattened out in $scope.close().
        $scope.bulkCrudObjects = { create: [], update: [], delete: [] };

        initialize();
    });

'use strict';

app.controller('ProratedCashTradesCtrl', function ProratedCashTradesCtrl($scope, $http, $tradeGenerator, $location, $proratedCashTrades) {
    //PRIVATE VARIABLES
    var tradeGroups;


    //PRIVATE METHODS
    function init() {
        $tradeGenerator.getTradeDefinition("Prorated")
            .then(function (response) {
                $scope.tradeDefinition = response.data;
            });

        $http.get("/Utility/Groupings?usedFor=Trading", {cache: true, trackerMsg: 'Loading trade groups'})
            .then(function (response) {
                tradeGroups = response.data;
            });

        $http.get("/Settings/Database/EntityOptions/Code/69SLEEVETR", {cache: true, trackerMsg: 'Loading sleeve settings'})
            .then(function(response) {
                $scope.current.isSleeveEnabled = response.data.value === "True";
            });

        $http.get("/Settings/Database/EntityOptions/Code/TRADERSNREQ", {cache: true, trackerMsg: 'Loading requirements'})
            .then(function (response) {
                $scope.current.isReasonRequired = response.data.value.toLowerCase() === "true";
            });

        setAccountSelection();
    }

    function setAccountSelection() {
        if ($scope.current.accountSelectionType === 2) {
            $scope.current.selectionTypeName = "trade groups";
            $scope.current.availableItemsFilter = "";
            $scope.current.availableItems = angular.copy(tradeGroups);
            $scope.current.availableSelected = [];
        }
        else {
            $scope.current.selectionTypeName = "accounts";
        }

        $scope.current.selectedItems = [];
        $scope.current.selectedSelected = [];

        var startedProrated = $proratedCashTrades.getCurrent();
        if (startedProrated) {
            $scope.current.wizardStep = 1;

            $http.post('/Portfolio/Accounts/Simple/List/Id', startedProrated.selectedIds, {trackerMsg: 'Loading accounts'})
                .then(function(response) {
                    $scope.current.selectedItems = response.data;
                    if (startedProrated.amount) {
                        $scope.current.selectedItems.forEach(function(a) {return a.amount = startedProrated.amount});
                    }
                    $proratedCashTrades.reset();
                });
        }
    }


    //PUBLIC METHODS
    $scope.back = function() {
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep -= 1;
    };

    $scope.next = function() {
        $scope.current.animation = 'slide-right';
        $scope.current.wizardStep += 1;
    };

    $scope.jumpBackTo = function(index) {
        if ($scope.current.executing) return;

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };

    $scope.isStepIncomplete = function() {
        switch ($scope.current.wizardStep) {
            case 0:
                return !$scope.tradeDefinition;
            case 1:
                return ($scope.current.accountSelectionType === 1 ? $scope.current.selectedItems.count({isValid: true}) === 0 : $scope.current.selectedItems.length === 0);
            default:
                return false;
        }
    };

    $scope.moveSome = function(selectedItems, from, to) {
        angular.forEach(selectedItems, function(item) {
            var index = from.indexOf(item);
            if (index !== -1) {
                from.splice(index, 1);
                to.push(item);
            }
        });
        selectedItems.length = 0;
    };

    $scope.moveAll = function(from, to, selectedItems, filter) {
        if (filter) {
            filter = filter.toLowerCase();
            $scope.moveSome(from.findAll(function(item) {return item.name.toLowerCase().indexOf(filter) != -1;}), from, to);
            $scope.current.availableItemsFilter = "";
        }
        else {
            angular.forEach(from, function(item) {
                to.push(item);
            });
            from.length = 0;
        }

        selectedItems.length = 0; //in case they selected some and then did move all
    };

    $scope.addSelectedAccount = function() {
        if ($scope.current.selectedItems.none({id: $scope.current.selectedAccount.id})) {
            $scope.current.selectedItems.push($scope.current.selectedAccount);
        }
        $scope.current.selectedAccount = null;
    };

    $scope.submitTrades = function() {
        $scope.current.executing = true;

        var pkList = [], amountList = [];
        $scope.current.selectedItems.forEach(function(item) {
            if (item.isValid !== false && angular.isNumber(item.amount)) {
                pkList.push(item.id);
                amountList.push(item.amount);
            }
        });

        $scope.tradeDefinition.filename = $scope.current.importFile;
        $scope.tradeDefinition.keys = pkList;
        $scope.tradeDefinition.amounts = amountList;
        $scope.tradeDefinition.entity = $scope.current.accountSelectionType === 2 ? "DynamicGrouping" : "Account";

        $tradeGenerator.submitTradeDefinition($scope.tradeDefinition)
            .then(function() {
                $location.path('/trading/tom/orders');
            }, function() {
                $scope.current.executing = false;
            }
        );
    };


    //INITIALIZE
    $scope.current = {accountSelectionType: 0, isSleeveEnabled: false, wizardStep: 0, animation: 'slide-right', executing: false, selectedAccount: null, availableItems: [], availableSelected: [], selectedItems: [], selectedSelected: []};
    $scope.wizardSteps = ["Selection Method", "Filter Selections", "Batch Options"];
    init();


    //WATCHES
    $scope.$watch("current.accountSelectionType", function (newValue, oldValue) {
        if (newValue === oldValue) return;

        setAccountSelection();
    });
});
'use strict';

app.controller('RebalanceCtrl', function RebalanceCtrl($scope, $http, $tradeGenerator, $location, $rebalance) {
    //PRIVATE VARIABLES
    var selectionTypeLookUp = {
        0: {name: "fund families", url: "/Portfolio/FundFamilies/Simple", entity: "FundFamily"},
        1: {name: "models", url: "/Trading/ModelAggs/Simple", entity: "AggregateModel"},
        2: {name: "accounts containing weighted models", url: "/Trading/Models/Simple", entity: "Model"},
        3: {name: "representatives", url: "/Portfolio/Representatives/Simple", entity: "Rep"},
        4: {name: "households", url: "/Portfolio/Clients/Simple", entity: "Client"},
        5: {name: "management styles", url: "/Portfolio/Platforms/Simple", entity: "Platform"},
        6: {name: "accounts", url: null, entity: "Account"},
        7: {name: "model group numbers", url: "/Portfolio/Accounts/GroupNumbers", entity: "ModelGroup"},
        8: {name: "accounts", url: null, entity: "Account"},
        9: {name: "trade groups", url: "/Utility/Groupings?usedFor=Trading", entity: "DynamicGrouping"}
    };

    var minTradeAmount = {original: 0, rollup: 0};


    //PRIVATE METHODS
    function initialLoad() {
         $tradeGenerator.getTradeDefinition("Rebalance")
            .then(function (response) {
                var definition = response.data;
                $scope.tradeDefinition = definition;
                minTradeAmount.original = definition.minTradeAmount;
                $scope.tradeDefinition.useProductSubstitution = 'Use';
            });

        $http.get("/Settings/Database/EntityOptions/Code/69SLEEVETR", {cache: true, trackerMsg: 'Loading sleeve settings'})
            .then(function(response) {
                $scope.current.isSleeveEnabled = response.data.value === "True";
            });

        $http.get("/Settings/Options/RebalanceRollupAmount", {cache: true, trackerMsg: 'Loading rollup settings', ignoreExceptions: [404]})
            .then(function(response) {
                var data = response.data;
                if (data && data.fieldValue && parseFloat(data.fieldValue) > 0) {
                    $scope.current.showRollupOption = true;
                    minTradeAmount.rollup = parseFloat(data.fieldValue);
                    enableReasonWatcher();
                }
            });

        $http.get("/Settings/Database/EntityOptions/Code/TRADERSNREQ", {cache: true, trackerMsg: 'Loading requirements'})
            .then(function (response) {
                $scope.current.isReasonRequired = response.data.value.toLowerCase() === "true";
            });

        $http.get("/Settings/Database/EntityOptions/Code/69DELETEOR", {cache: true, trackerMsg: 'Loading requirements'})
            .then(function (response) {
                $scope.current.showDeleteOrdersNotPartOfModel = response.data.value.toLowerCase() === "true";
            });

        $http.get("/Settings/Database/EntityOptions/Code/1:69COVERE", {cache: true, trackerMsg: 'Loading requirements'})
            .then(function (response) {
                $scope.current.coveredCallOptionEnabled = response.data.value.toLowerCase() === "true";
            });

        setAccountSelection();
    }

    function setAccountSelection() {
        var startedRebalance = $rebalance.getCurrent();
        if (startedRebalance) {
            $scope.current.accountSelectionType = startedRebalance.type;
        }

        var lookUp = selectionTypeLookUp[$scope.current.accountSelectionType];
        $scope.current.selectionTypeName = lookUp.name;
        $scope.current.selectedItems = [];
        $scope.current.selectedSelected = [];

        if (lookUp.url) {
            $scope.current.availableItemsFilter = "";
            $scope.current.availableItems = [];
            $scope.current.availableSelected = [];
            $http.get(lookUp.url, {cache: true, trackerMsg: 'Loading ' + lookUp.name})
                .then(function (response) {
                    $scope.current.availableItems = response.data;

                    if (startedRebalance) {
                        $scope.current.wizardStep = 1;

                        startedRebalance.selectedIds.forEach(function (id) {
                            var selectedItem = $scope.current.availableItems.find({id: id});
                            $scope.current.availableSelected.push(selectedItem);
                        });
                        $rebalance.reset();

                        $scope.moveSome($scope.current.availableSelected, $scope.current.availableItems, $scope.current.selectedItems);
                    }
                });
        }
        else if ($scope.current.accountSelectionType === 6 && startedRebalance) {
            $scope.current.wizardStep = 1;

            $http.post('/Portfolio/Accounts/Simple/List/Id', startedRebalance.selectedIds, {trackerMsg: 'Loading accounts'})
                .then(function(response) {
                    $scope.current.selectedItems = response.data;
                    if (startedRebalance.amount) {
                        $scope.current.showAmountColumn = true;
                        $scope.current.selectedItems.forEach(function(a) {return a.amount = startedRebalance.amount});
                    }
                    $rebalance.reset();
                });
        }
    }

    function resetRollupOption() {
        if ($scope.tradeDefinition && $scope.tradeDefinition.rollupMinimumAmount) {
            $scope.tradeDefinition.rollupMinimumAmount = false;
            $scope.resetMinTradeAmount();
        }
    }

    //PUBLIC METHODS
    $scope.back = function() {
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep -= 1;
    };

    $scope.next = function() {
        $scope.current.animation = 'slide-right';
        $scope.current.wizardStep += 1;
    };

    $scope.jumpBackTo = function(index) {
        if ($scope.current.executing) return;

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };

    $scope.isStepIncomplete = function() {
        switch ($scope.current.wizardStep) {
            case 0:
                return !$scope.tradeDefinition || ($scope.tradeDefinition.deleteOrdersNotPartOfModel && $scope.tradeDefinition.level === 'Registration');
            case 1:
                if ($scope.current.accountSelectionType === 8) //excel import
                    return $scope.current.selectedItems.count({isValid: true}) === 0;
                else
                    return $scope.current.selectedItems.length === 0;
            default:
                return false;
        }
    };

    $scope.addSelectedAccount = function() {
        if ($scope.current.selectedItems.none({id: $scope.current.selectedAccount.id})) {
            $scope.current.selectedItems.push($scope.current.selectedAccount);
        }
        $scope.current.selectedAccount = null;
    };

    $scope.moveSome = function(selectedItems, from, to) {
        angular.forEach(selectedItems, function(item) {
            var index = from.indexOf(item);
            if (index !== -1) {
                from.splice(index, 1);
                to.push(item);
            }
        });
        selectedItems.length = 0;
    };

    $scope.moveAll = function(from, to, selectedItems, filter) {
        if (filter) {
            filter = filter.toLowerCase();
            $scope.moveSome(from.findAll(function(item) {return item.name.toLowerCase().indexOf(filter) != -1;}), from, to);
            $scope.current.availableItemsFilter = "";
        }
        else {
            angular.forEach(from, function(item) {
                to.push(item);
            });
            from.length = 0;
        }

        selectedItems.length = 0; //in case they selected some and then did move all
    };

    $scope.clearAmounts = function() {
        if (!$scope.current.showAmountColumn) {
            $scope.current.selectedItems.forEach(function (item) {
               item.amount = null;
            });
        }
    };

    $scope.resetMinTradeAmount = function() {
        $scope.tradeDefinition.minTradeAmount = minTradeAmount[$scope.tradeDefinition.rollupMinimumAmount ? "rollup" : "original"];
    };

    $scope.submitRebalance = function() {
        $scope.current.executing = true;

        if ($scope.current.accountSelectionType === 7) {
            var modelGroups = [];
            $scope.current.selectedItems.forEach(function (item) {
                modelGroups.push(item.name);
            });
            $scope.tradeDefinition.modelGroups = modelGroups;
        }
        else {
            var pkList = [], amountList = [];
            var includeAmount = ($scope.current.accountSelectionType === 6 || $scope.current.accountSelectionType === 8) && angular.isNumber($scope.current.selectedItems[0].amount);

            $scope.current.selectedItems.forEach(function (item) {
                if (item.isValid !== false) {
                    pkList.push(item.id);

                    if (includeAmount) amountList.push( angular.isNumber(item.amount) ? item.amount : 0);
                }
            });

            $scope.tradeDefinition.keys = pkList;
            if (includeAmount) $scope.tradeDefinition.amounts = amountList;
        }

        $scope.tradeDefinition.filename = $scope.current.importFile;
        $scope.tradeDefinition.entity = selectionTypeLookUp[$scope.current.accountSelectionType].entity;
        $scope.tradeDefinition.optionTradeType = $scope.current.coveredCall ? 1 : 0;   //None=0, CoveredCall=1

        $tradeGenerator.submitTradeDefinition($scope.tradeDefinition)
            .then(function() {
                $location.path('/trading/tom/orders');
            }, function () {
                $scope.current.executing = false;
            }
        );
    };


    //INITIALIZE
    $scope.current = {coveredCall:false, showDeleteOrdersNotPartOfModel:false, accountSelectionType: 0, selectionTypeName: "", isSleeveEnabled: false, showRollupOption: false, wizardStep: 0, animation: 'slide-right', executing: false, showAmountColumn: false, selectedAccount: null, rebalanceReasons: {}, availableItems: [], availableSelected: [], selectedItems: [], selectedSelected: []};
    $scope.wizardSteps = [ "Selection Method", "Filter Selections", "Rebalance Options" ];
    initialLoad();


    //WATCHES
    $scope.$watch("current.accountSelectionType", function (newValue, oldValue) {
        if (newValue === oldValue) return;

        setAccountSelection();
        resetRollupOption();
    });

    $scope.$watch("current.selectedItems", function (newValue) {
        if (!newValue || newValue.length === 0) return;

        if ($scope.current.accountSelectionType === 6 || $scope.current.accountSelectionType === 8) {
            if (newValue.length > 0 && newValue[0].amount)
                $scope.current.rebalanceReasons = { Withdraw: "SELL - Request for withdrawal of money from fund", Add: "BUY - Request instructions to add money to fund" };
            else
                $scope.current.rebalanceReasons = { NeedReview: "REBAL - Account transactions / need review", Withdraw100Pct: "SELL - 100% - Request for 100% withdrawal of money from fund" };
        }
        else
            $scope.current.rebalanceReasons = { NeedReview: "REBAL - Account transactions / need review" };

        $scope.tradeDefinition.reason = Object.keys($scope.current.rebalanceReasons)[0];
        resetRollupOption();
    }, true);

    function enableReasonWatcher() {
        $scope.$watch("tradeDefinition.reason", function (newValue, oldValue) {
            if (!newValue) return;

            $scope.tradeDefinition.rollupMinimumAmount = (newValue === 'Add' || newValue === 'Withdraw');

            if (newValue === 'Add' || oldValue === 'Add' || newValue === 'Withdraw' || oldValue === 'Withdraw') {
                $scope.resetMinTradeAmount();
            }
        });
    }
});

'use strict';

app.controller('SleeveImportCtrl', function SleeveImportCtrl($rootScope, $scope, $http, $oasRights, $timeout, $dialog) {

    // PRIVATE METHODS
    function init() {
        $scope.rights = $oasRights.forCode("SLEEVESETUP");
    }


    // PUBLIC METHODS
    $scope.processImport = function () {
        var postData = $scope.current.selectedItems.findAll({ isValid: true });
        if (postData) {

            if ($scope.current.importType == "sleeve") {
                $scope.current.importURL = '/Trading/Sleeve/Registrations/Action/Process/Batch';
            } else {
                $scope.current.importURL = '/Trading/Sleeve/Registrations/Action/Process/Historical/Batch';
            }

            $scope.current.allowProcess = false;

            $http.post($scope.current.importURL, postData, { trackerMsg: 'Submitting import' }).then(function (response) {
                if (response.data) {
                    startPollingStatus(response.data);
                }
            });

        }
    };

    function startPollingStatus(batchId) {
        var lastData;
        var parentId = batchId;
        var sameDataCount = 0;
        var errorCount = 0;

        var pollStatus = function (batchId) {
            if (sameDataCount > 200) {
                $rootScope.$broadcast('event:progress-update', { id: parentId, isDone: true, msg: parentId + ": Status updates aborted", type: "warning" });
                return;
            }

            if (errorCount > 25) {
                if (parentId) $rootScope.$broadcast('event:progress-update', { id: parentId, isDone: true, msg: parentId + ": Status updates aborted", type: "warning" });
                return;
            }

            $http.get("/Trading/TradeGenerationStatus/" + batchId + "?includeErrors=true", { ignoreExceptions: true })
                .then(function (response) {
                    var data = response.data;
                    if (angular.equals(data, lastData)) {
                        sameDataCount += 1;
                        $timeout(function () { pollStatus(batchId); }, 5000);
                        return;
                    }

                    sameDataCount = 0;

                    var progress = { id: parentId, completed: data.itemsCompleted, total: data.totalItems };

                    if (data.isDone) {
                        progress.isDone = true;
                        $scope.current.allowProcess = true;
                        if (data.message && data.message.length > 0) {
                            $dialog.messageBox("Result Message", data.message).open();
                        }
                    }
                    else
                        $timeout(function () { pollStatus(batchId); }, 5000);

                    $rootScope.$broadcast('event:progress-update', progress);
                    lastData = data;
                })
                .catch(function () {
                    errorCount += 1;
                    $timeout(function () { pollStatus(batchId); }, 20000);
                });
        };

        pollStatus(batchId);
    }

    $scope.setImportType = function () {
        if ($scope.current.importType == "sleeve") {
            $scope.current.uploadURL = '/Trading/ValidateImport/Sleeve/Registrations/ValidateImport/Sleeve/Registration';
        } else {
            $scope.current.uploadURL = '/Trading/ValidateImport/Sleeve/Registrations/ValidateImport/Sleeve/Registration/HistoricalSleeveImport';
        }
    };

    $scope.startOver = function () {
        $scope.current.selectedItems = [];
    };


    // WATCHES
    $scope.$watchCollection("current.selectedItems", function (newValue, oldValue) {
        if (newValue != oldValue) {
            $scope.current.allowProcess = $scope.current.selectedItems.find({ isValid: true });
        }
    });


    // INITIALIZE
    $scope.current = { selectedItems: [], allowProcess: true, importType: 'sleeve', uploadURL: '/Trading/ValidateImport/Sleeve/Registrations/ValidateImport/Sleeve/Registration' };

    init();
});
'use strict';

var sleeveTransferCtrl = app.controller('SleeveTransferCtrl', function SleeveTransferCtrl($scope, $http,$location, $oasRights, $dialog, $route, config, productTypes, sleeveType) {

    // PRIVATE METHODS
    function init() {
        //is this an embedded page
        $scope.current.isEmbeddedPage = $location.path().has('/embed/');

        $http.get("/Portfolio/Registrations/" + config.registrationId, {trackerMsg: 'Loading registration'})
            .then(function (response) {
                $scope.current.registration = response.data;
                loadSleeveAccounts();
            });

        $scope.rights = $oasRights.forCode("SLEEVETRANSFER");
    }

    function loadSleeveAccounts () {
        $http.get("/Trading/Sleeve/Registrations/" + config.registrationId + "?includeCostBasis=false", {trackerMsg: 'Loading sleeve accounts'})
            .then(function (response) {
                var data = response.data;
                if (data.accountSleeves.length < 2) {
                    $dialog.messageBox("Invalid Registration", "Sleeve transfer requires 2 or more accounts.")
                        .open()
                        .then(function() {
                            $scope.current.transferReady = false;
                            if($location.path().has('/trading/')) {
                                $scope.startOver();
                            }
                        });
                }
                else {
                    $scope.current.transferReady = true;
                    data.accountSleeves.find({sleeveType: sleeveType.custodial.name}).sleeveDescription += " (Custodial)";

                    var tempContribution = data.accountSleeves.find({sleeveType: sleeveType.contribution.name});
                    if(tempContribution){
                        tempContribution.sleeveDescription += " (Contribution)";
                    }
                    var tempDistribution = data.accountSleeves.find({sleeveType: sleeveType.distribution.name});
                    if(tempDistribution){
                        tempDistribution.sleeveDescription += " (Distribution)";
                    }
                    $scope.modelToAccounts = data.accountSleeves;
                    $scope.modelFromAccounts = angular.copy(data.accountSleeves);
                    $scope.current.accountFrom = config.accountId || data.accountSleeves[0].accountId;
                    $scope.loadAssets();
                }
            });
    }


    // PUBLIC METHODS
    $scope.loadAssets = function () {
        $scope.modelToAccounts = $scope.modelFromAccounts.exclude({accountId: $scope.current.accountFrom});
        $scope.current.accountTo = $scope.modelToAccounts[0].accountId;

        $http.get("/Portfolio/Accounts/" + $scope.current.accountFrom + "/Assets?asOfDate=" + Date.create($scope.current.asOfDate).formatted(), {trackerMsg: 'Loading account assets'})
            .then(function (response) {
                response.data.forEach(function (asset) {
                    calculateUnitBalanceScale(asset);
                    asset.currentSharesRounded = roundToPrecision(asset.currentShares, asset.unitBalanceScale);
                    asset.remaining = asset.currentShares - asset.sharesToTransfer;
                });

                $scope.assetList = response.data;
                $scope.toggleAll();
                $scope.current.canExecuteTransfer = true;
            });
    };
    $scope.updateSearchFor = function(prop) {
        // remove blank filters from the search object
        if ($scope.current.searchFor !== null && $scope.current.searchFor.hasOwnProperty(prop) && $scope.current.searchFor[prop] === '') {
            delete $scope.current.searchFor[prop];
        }
    };

    $scope.sort = function(field) {
        $scope.current.sortField = field;
        $scope.current.sortReverse = !$scope.current.sortReverse;
    };

    function roundToPrecision(num, precision){
        const adj = Math.pow(10, precision);
        return Math.round(num * adj) / adj;
    }

    function calculateUnitBalanceScale(asset) {
        // this handles if current shares is in scientific notation as well
        const decimals = (asset.currentShares.toLocaleString('fullwide', {maximumFractionDigits: 20})).split('.')[1];
        asset.unitBalanceScale = asset.ticker === 'CUSTODIAL_CASH'? 2 : (decimals && decimals.length > 3 ? decimals.length : 3);
    }

    $scope.calculateAssetRemaining = function(asset) {
        const shares = String(asset.sharesToTransfer);
        const period = shares.indexOf(".");
        const allowedShares = period >= 0 ? (shares.substring(0, period) + shares.substring(period, period + asset.unitBalanceScale + 1)) : shares;
        asset.sharesToTransfer = +allowedShares;
        asset.remaining = asset.currentShares - asset.sharesToTransfer;
    }

    $scope.calculateTransfer = function () {
        $scope.assetList.forEach(function (asset) {
            asset.sharesToTransfer = (asset.currentShares * ($scope.current.transferPercent / 100)).round(asset.unitBalanceScale);
        });

        $scope.current.transferPercent = null;
    };

    $scope.assetFilters = function(asset) {
        return $scope.current.hideEmptyAssets ? asset.currentShares : true;
    };

    $scope.executeTransfer = function () {
        var transferData = [];
        var asOfDate = Date.create($scope.current.asOfDate).formatted();

        var saveTransfer = function() {
            $scope.current.canExecuteTransfer = false;
            $scope.current.eclipseEtl = false;

            $http.get('/Trading/Sleeve/Registrations/' + config.registrationId + '/GetEclipseEnabled', { trackerMsg: 'Getting Eclipse enabled status' })
                .then(function (response) {
                    if (response.data == true) {
                        $scope.current.eclipseEtl = true;
                    }
                })
                .then(function () {
                    $http.put('/Trading/Sleeve/Accounts/' + $scope.current.accountFrom + '/Action/Transfer', transferData, { trackerMsg: 'Transferring sleeve assets' })
                        .then(function () {
                            $dialog.messageBox("Transfer Complete", "Sleeve transfer completed successfully.")
                                .open()
                                .then(function () {
                                    $scope.loadAssets();
                                })
                                .then(function () {
                                    if ($scope.current.eclipseEtl == true) {
                                        $dialog.confirmAction('Do you want to kick off a Partial Import to Eclipse?')
                                            .open()
                                            .then(function (result) {
                                                if (result === 'yes') {
                                                    $http.put('/Trading/Sleeve/Accounts/' + $scope.current.accountFrom + '/Action/V2PartialETL', transferData, { trackerMsg: 'Executing partial ETL' });
                                                }
                                            });
                                    }
                                });
                        });
                });
        };

        $scope.assetList.forEach(function (asset) {
            if (asset.isSelected && asset.sharesToTransfer) {
                transferData.push({assetIdOut: asset.id, sharesToTransfer: asset.sharesToTransfer, accountIdIn: $scope.current.accountTo, asOfDate: asOfDate, notBilled: $scope.current.notBilled});
            }
        });

        if(transferData.filter(function (asset) {
            return asset.sharesToTransfer < 0;
        }).length) {
            $dialog.confirmAction('There are one or more negative positions being journaled.  Do you wish to continue?')
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        saveTransfer();
                    }
                });
        } else if (!transferData.filter(function (asset) {
            return asset.sharesToTransfer > 0;
        }).length) {
            $dialog.actionFailed("Please enter a transfer quantity for at least one selected asset.").open();
        } else {
            saveTransfer();
        }
    };

    $scope.toggleAll = function () {
        $scope.assetList.forEach(function (asset) {
            asset.isSelected = $scope.current.allSelected;
        });
    };

    $scope.startOver = function () {
        $location.search('registrationId', null);
        $route.reload();
    };


    // INITIALIZE
    $scope.current = {
      isEmbeddedPage:false,
      transferReady:true,
      registration: null,
      accountFrom: null,
      accountTo: null,
      asOfDate: Date.create('today'),
      allSelected: true,
      hideEmptyAssets: true,
      transferPercent: null,
      canExecuteTransfer: true,
      searchFor: null,
      sortField: '',
      sortReverse: false
    };
    init();
});

sleeveTransferCtrl.loadSleeveConfig = ["$dialog", "$route", "$q", function ($dialog, $route, $q) {

    function promptForReg() {
        return $dialog.search("registration", "Sleeve Transfer")
            .open()
            .then(function (result) {
                    if (result)
                        return {registrationId: result.id};
                    else {
                        var deferred = $q.defer();
                        deferred.reject();
                        return deferred.promise;
                    }
                }
            );
    }
    if(!$route.current.params.registrationId){
        var deferred = $q.defer();
        promptForReg()
            .then(function (result) {
                deferred.resolve(result);
            });
        return deferred.promise;
    }else{
        return {registrationId: parseInt($route.current.params.registrationId), accountId: parseInt($route.current.params.accountId)};
    }

}];

'use strict';

var systemTradeQueueCtrl = app.controller('SystemTradeQueueCtrl', function SystemTradeQueueCtrl($scope, $http, $dialog, $location, $timeout, $tactical,$settings, $oasRights,$route, $portfolio, $routeParams, entities, apps, views) {
    var selectedRegistrationId = [];
    var selectedAccountId = [];
    var tradeInstanceId;

    // PUBLIC METHODS
    $scope.$on('event:system-trade-queue-select', function(e, args){
        selectedRegistrationId = args.map('registrationId').unique();
        selectedAccountId = args.map('accountId').unique();
    });

    $scope.openRegistrationEditor = function() {
        $portfolio.openEditor( entities.registration.value, selectedRegistrationId, 'registrationGeneral', 'sleeveSetup', null, null ).then(function(rslt) {
            if( rslt ) {
                $scope.$broadcast( 'event:system-trade-queue', {action: 'update-items', items: rslt } );
            }
        });
    };

    $scope.goToAccounts = function( urlLevel ) {
        $portfolio.goTo( urlLevel, entities.registration.value, selectedRegistrationId[0]);
    };

    $scope.goToTransactions = function( urlLevel ) {
        $portfolio.goTo( urlLevel, entities.account.value, $scope.selectedIds[0]);
    };

    $scope.openOrders = function () {
        $location.url('/trading/tom/orders/?tradeInstanceId=' + tradeInstanceId + '&fromTradeQueue=true' + '&startDate=' + $scope.current.startDate + '&endDate=' + $scope.current.endDate);
    };


    function setDates(){
        $scope.current.startDate = $scope.current.filterStartDate.format('{MM}-{dd}-{yyyy}');
        $scope.current.endDate = $scope.current.filterEndDate.format('{MM}-{dd}-{yyyy}');
    }

    function init(){

        setDates();

        if($route.current.params.queueFilter){
            //autoTradeType={{current.tradeType}}&returnStyle={{ current.queueType
            switch ($route.current.params.queueFilter){
                case 'ContributionAllocation' :
                    $scope.current.queueType = '1';
                    $scope.current.tradeType = '4';
                    $scope.current.URL = '/Trading/Queues';
                    break;
                case 'TransferIn' :
                    $scope.current.queueType = '2';
                    $scope.current.tradeType = '8';
                    $scope.current.URL = '/Trading/Queues';
                    break;
                case 'RegistrationRebalance' :
                    $scope.current.queueType = '0';
                    $scope.current.tradeType = '1';
                    $scope.current.URL = '/Trading/Queues';
                    break;
                case 'AccountRebalance' :
                    $scope.current.queueType = '0';
                    $scope.current.tradeType = '2';
                    $scope.current.URL = '/Trading/Queues';
                    break;
                case 'AgingCashBalances' :
                    $scope.current.queueType = '0';
                    $scope.current.tradeType = '0';
                    $scope.current.URL = '/Trading/Sleeve/Accounts/AgingCashBalance';
                    break;
                default:
                    $scope.current.queueType = '0';
                    $scope.current.tradeType = '0';
                    $scope.current.URL = '/Trading/Sleeve/Accounts';
                    break
            }

       }

    }

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:system-trade-queue-action', {action: 'export-data'});
    };

    $scope.refreshGrid = function( ) {
        $settings.setSetting('tradeQueueStartDate', $scope.current.filterStartDate);
        $settings.setSetting('tradeQueueEndDate', $scope.current.filterEndDate);

        setDates();

        $timeout(function () {
            $scope.$broadcast('event:system-trade-queue-action', {action: 'refresh-grid'});
        });
    };
    //INITIALIZE
    $scope.rightsSystemTradeQueue = $oasRights.forCode("SYSTEMTRADEQUEUE");
    $scope.rightsReg = $oasRights.forCode("REGISTRATIONS");
    $scope.rightsAcc = $oasRights.forCode("ACCOUNTS");
    $scope.rightsTOM = $oasRights.forCode("TRADEORDERMGMT");

    $scope.selectedIds=[];
    $scope.views = views;

    // LISTENERS
    $scope.$on("event:system-trade-queue-select", function (e, args) {
      tradeInstanceId = args.length === 1 ? args[0].tradeRequestInstanceId : null;

    });

    $scope.current = {
    view: views[0],
    filterStartDate: $settings.getSetting('tradeQueueStartDate') || Date.create('today'),
    filterEndDate:   $settings.getSetting('tradeQueueEndDate') || Date.create('today'),
    queueStatus: '',
    queueType: '',
    tradeType:'',
    showDateFilter: !($route.current.params.queueFilter === 'AgingCashBalances' || !$route.current.params.queueFilter),
    URL : $route.current.params.queueFilter === 'AgingCashBalances' ? '/Trading/Sleeve/Accounts/AgingCashBalance'  : '/Trading/Sleeve/Accounts'};


    init();

});


systemTradeQueueCtrl.loadSystemTradeView = ["$http","$route", function( $http, $route ) {

    var url = '';
    if($route.current.params.queueFilter) {
        //autoTradeType={{current.tradeType}}&returnStyle={{ current.queueType
        switch ($route.current.params.queueFilter) {
            case 'AgingCashBalances' :
                url ='/Settings/Views/AgingCashBalancesDto';
                break;
            case 'RegistrationRebalance' :
            case 'AccountRebalance' :
            case 'ContributionAllocation' :
            case 'TransferIn' :
                url = '/Settings/Views/TradeQueue' + $route.current.params.queueFilter + 'Dto';
                break;
            default :
                url = '/Settings/Views/AccountSleeveDto';
                break;
        }
    }else{
        url = '/Settings/Views/AccountSleeveDto';
    }

    return $http.get(url, {trackerMsg : 'Loading system trade queue view'})
        .then(function(response){
            return response.data;
        });
}];
'use strict';

app.controller('TradeErrorChecksCtrl', function TradeErrorChecksCtrl($scope, $oasRights, $portfolio, $location, views, entities) {

    // LISTENERS
    $scope.$on("event:trading-error-checks-select", function(e, args) {
        if( args.length === 0 ) return;

        $scope.current.accountId = args[0].accountId;
    });


    // PUBLIC METHODS
    $scope.editAccount = function( ) {
        $portfolio.openEditor( entities.account.value, [$scope.current.accountId], null, null, null, null );
    };

    $scope.viewTradeInstances = function( ) {
        $location.path( '/trading/instances' );
    };


    // INITIALIZE
    $scope.rightsSystemTradeQueue  = $oasRights.forCode("SYSTEMTRADEQUEUE");
    $scope.rightsInstances = $oasRights.forCode("TRADEINSTANCES");
    $scope.rightsTOM = $oasRights.forCode("TRADEORDERMGMT");
    $scope.rightsAccount = $oasRights.forCode("ACCOUNTS");

    $scope.views = views;

    $scope.selectedIds = [];
    $scope.current = { view : views[0], accountId : null };

});
'use strict';

var tacticalTradesCtrl = app.controller('TacticalTradesCtrl', function TacticalTradesCtrl($scope, $http, $dialog, $location, $timeout, $tactical, $tradeGenerator, $oasRights,$q, views, splitIoService) {
    //PRIVATE VARIABLES
    var selectedRowsSnapshot = [],
        cashValues = {},
        groupCashValues = {},
        groupingOptions = [],
        accountSleeves = [],
        previousSelectedId,
        parentId,
        onRouteChangeOff,
        pageIsDirty,
        netCashValue,
        startedInstance;

    splitIoService.getBoolTreatment('OC_new_sleeve_transfer_TOM_252532').subscribe((isEnabled) => {
        $scope.current.sleeveTransferFeatureFlag = isEnabled;
    });

    //PRIVATE METHODS
    function init() {

        $scope.current.canExecute = $oasRights.canRead("FIXEXEC");
        $scope.resetAdd();
        $scope.current.view.filters.push({ name: "Hide Zero Value Trades", value: "(function (a) { return a && a > 0; })", key: "tradeShares", include: false });
        $scope.current.view.filters.push({ name: "Hide Excluded Assets", value: "(function (a) { return a === false; })", key: "isExcluded", include: false });

        startedInstance = $tactical.getCurrent();
        if (startedInstance) {
            $scope.current.grid.param.usePendingValue = startedInstance.usePendingValue;
            $scope.current.mode = startedInstance.mode;
            $scope.current.grid.param.usePendingValue = startedInstance.usePendingValue;

            if(startedInstance.mode !== "household") {
                $scope.current.ids = startedInstance.selectedIds;
                $scope.current.grid.param.defaultAction = startedInstance.action;
                $scope.current.loadedFromPrompt = false;
                createGroupingForEntity(startedInstance.mode);
                loadItems(startedInstance.selectedIds, startedInstance.usePendingValue, startedInstance.mode, startedInstance.action, (startedInstance.closedOrders || []).length > 0);

                if(startedInstance.mode === "registration") {
                    var id = startedInstance.closedOrders
                        ? startedInstance.closedOrders[0].registrationId
                        : startedInstance.selectedIds[0];

                    $http.get('/Trading/Sleeve/Registrations/' + id, {

                        trackerMsg: 'Loading sleeve information'
                    })
                        .then(function (response) {
                            accountSleeves = response.data.accountSleeves;
                        });
                }
            } else {
                $scope.current.ids = [startedInstance.selectedHousehold.id];
            }
            $tactical.reset();

        }

        //this turns on/off the watch for listening for route change.
        onRouteChangeOff =  $scope.$on("$routeChangeStart", routeChange);
    }

    function createGroupingForEntity (mode){
        var createGrouping = function(name, getter, label, modes) {
            var grouping = {
                name: name,
                getter: getter,
                formatter: '(function(g) { ' +
                'return "' + label + ': " + g.value + "</span></div>" + "' +
                '<div class=\'slick-cell l7 r7 right-align\'>$" + g.totals.sum.postTradeValue.format(2) + "</div>' +
                '<div class=\'slick-cell l8 r8 right-align\'>" + g.totals.sum.postTradeShares.format(2) + "</div>' +
                '<div class=\'slick-cell l9 r9 right-align\'>" + g.totals.sum.postTradePercentage.format(2) + " %</div>' +
                '<div class=\'slick-cell l10 r10 right-align\'>$" + g.totals.sum.postTradeDifferenceValue.format(2) + "</div>' +
                '<div class=\'slick-cell l11 r11 right-align\'>" + g.totals.sum.postTradeDifferenceShares.format(2) + "</div>' +
                '<div class=\'slick-cell l12 r12 right-align\'>" + g.totals.sum.postTradeDifferencePercentage.format(2) + " %</div>' +
                '<div class=\'slick-cell l13 r13 right-align\'>$" + g.totals.sum.targetValue.format(2) + "</div>' +
                '<div class=\'slick-cell l14 r14 right-align\'>" + g.totals.sum.targetShares.format(2) + "</div>' +
                '<div class=\'slick-cell l15 r15 right-align\'>" + g.totals.sum.targetPercentage.format(2) + " %</div>' +
                '<div class=\'slick-cell l16 r16 right-align\'>$" + g.totals.sum.differenceValue.format(2) + "</div>' +
                '<div class=\'slick-cell l17 r17 right-align\'>" + g.totals.sum.differenceShares.format(2) + "</div>' +
                '<div class=\'slick-cell l18 r18 right-align\'>" + g.totals.sum.differencePercentage.format(2) + " %</div>' +
                '<div class=\'slick-cell l19 r19 right-align\'>$" + g.totals.sum.currentValue.format(2) + "</div>' +
                '<div class=\'slick-cell l20 r20 right-align\'>" + g.totals.sum.currentShares.format(2) + "</div>' +
                '<div class=\'slick-cell l21 r21 right-align\'>" + g.totals.sum.currentPercentage.format(2) + " %</div>"; } )',
                collapsed: false,
                enabled: false,
                aggregators: [
                    "new Slick.Data.Aggregators.Sum('postTradeValue')",
                    "new Slick.Data.Aggregators.Sum('postTradeShares')",
                    "new Slick.Data.Aggregators.Sum('postTradePercentage')",
                    "new Slick.Data.Aggregators.Sum('postTradeDifferenceValue')",
                    "new Slick.Data.Aggregators.Sum('postTradeDifferenceShares')",
                    "new Slick.Data.Aggregators.Sum('postTradeDifferencePercentage')",
                    "new Slick.Data.Aggregators.Sum('targetValue')",
                    "new Slick.Data.Aggregators.Sum('targetShares')",
                    "new Slick.Data.Aggregators.Sum('targetPercentage')",
                    "new Slick.Data.Aggregators.Sum('differenceValue')",
                    "new Slick.Data.Aggregators.Sum('differenceShares')",
                    "new Slick.Data.Aggregators.Sum('differencePercentage')",
                    "new Slick.Data.Aggregators.Sum('currentValue')",
                    "new Slick.Data.Aggregators.Sum('currentShares')",
                    "new Slick.Data.Aggregators.Sum('currentPercentage')"
                ],
                displayTotalsRow: false,
                modes: modes
            };

            groupingOptions.push(grouping);
        };

        //make sure this is clear before setting new ones.
        groupingOptions = [];

        // this block of code sets the grouping order.
        if(mode === 'account' && $scope.current.loadedFromPrompt === false){
            createGrouping("Account", "accountDescription", "Account", ["household", "registration", "account"]);
        }

        if(mode === 'registration' && $scope.current.loadedFromPrompt === false){
            createGrouping("Account", "accountDescription", "Account", ["household", "registration"]);
        }
        createGrouping("Asset Category", "assetCategory", "Category", ["account", "household", "product"]);
        createGrouping("Asset Class", "assetClass", "Class", ["account", "household", "product"]);
        createGrouping("Risk Category", "riskCategory", "Category", ["account", "household", "product"]);

        if($scope.current.loadedFromPrompt === true) {
            createGrouping("Account", "accountDescription", "Account", ["household", "registration"]);
        }
        createGrouping("Product", "ticker", "Product", ["household"]);
    }

    function routeChange(event, newUrl, oldUrl){
        //Navigate to newUrl if there's no id selected in grid.  At this point I don't know if they modified a grid cell; however if they selected one maybe they did.
        if ($scope.selectedIds.length === 0 && !pageIsDirty) return;
        $dialog.confirmAction("This action will refresh the grid and any unsaved changes will be lost.  Do you want to continue?")
            .open()
            .then(function(result) {
                if (result === 'yes') {
                    onRouteChangeOff(); //Stop listening for location changes
                    $location.path(newUrl.originalPath); //Go to page they're interested in
                }
            });

        //prevent navigation by default since we'll handle it
        //once the user selects a dialog option
        event.preventDefault();
    }

    function loadItems(selectedIds, usePendingValue, mode, action, isClosedOrders) {

        $scope.current.action = action;
        $scope.current.grid.param.defaultAction = action;
        $scope.current.idsToProcess = selectedIds;

        groupingOptions.find({name: "Account"}).enabled = mode === 'registration';
        groupingOptions.find({name: "Asset Class"}).enabled = mode === 'household';
        groupingOptions.find({name: "Risk Category"}).enabled = mode === 'household';
        groupingOptions.find({name: "Product"}).enabled = mode === 'household';

        if(selectedIds.length > 1 && !isClosedOrders){
            groupingOptions.find({name: "Account"}).enabled = mode === 'account';
        }

        $scope.current.view.groups = groupingOptions.findAll(function(option) {return option.modes.any(mode)});

        goToNextItem();
    }

     function goToNextItem () {

        if (!$scope.current.finishedProcessing) {

            $scope.current.modelAggId = null;

            if(startedInstance &&  startedInstance.closedOrders && startedInstance.closedOrders.length > 0){

            }else{
                 $scope.current.gridDataUrl = "";

                if($scope.current.mode === 'household'){
                    $scope.current.gridDataUrl += 'Client/' + parentId;
                    //$scope.current.idsToProcess[0] in household mode is the modelAggId, $scope.current.modelAggId is then passed as parameter to endpoint
                    $scope.current.modelAggId = $scope.current.idsToProcess[0];
                    $scope.current.grid.param.modelAggIdFilter = $scope.current.idsToProcess[0];
                    $scope.current.parentId = parentId;
                }
                if($scope.current.mode === 'registration'){

                    $scope.current.gridDataUrl += $scope.current.mode + "/" + $scope.current.idsToProcess[0];
                }
                if($scope.current.mode === 'account'){
                    if($scope.current.idsToProcess.length === 1){
                        $scope.current.gridDataUrl += $scope.current.mode + "/" + $scope.current.idsToProcess[0];
                    }else {
                        $scope.current.gridDataUrl +=  'AccountList';
                    }
                }
                if($scope.current.mode === 'product'){
                    $scope.current.gridDataUrl += $scope.current.mode + "/" + $scope.current.idsToProcess[0];
                }

                if ($scope.current.mode === 'registration') {
                    $http.get('/Trading/Sleeve/Registrations/' + $scope.current.idsToProcess[0], {trackerMsg: 'Loading sleeve information'})
                        .then(function (response) {
                            accountSleeves = response.data.accountSleeves;
                        });
                }
            }
        }
        else
            $location.path("/trading/tom/orders");
    }

    function tradesCreated(response) {
        if (response.data.batchId) {
            $tradeGenerator.startPolling(response.data.batchId, false);
            $location.path("/trading/tom/orders");
        } else {
            $scope.current.finishedProcessing = true;
            goToNextItem();
        }
    }

    function setTradeInfoCashValue() {
        $scope.current.tradeInfo.cashValue = cashValues[$scope.current.tradeInfo.accountId];
        $scope.current.tradeInfo.cashPercent = ((($scope.current.tradeInfo.cashValue / $scope.current.tradeInfo.accountValue) || 0) * 100).round(2);

        $scope.current.tradeInfo.groupCashValue = groupCashValues[$scope.current.tradeInfo.groupId];
        $scope.current.tradeInfo.groupCashPercent = ((($scope.current.tradeInfo.groupCashValue / $scope.current.tradeInfo.groupValue) || 0) * 100).round(2);
    }

    function syncCashValue(updatedRow) {
        var cashValue = cashValues[updatedRow.accountId] || updatedRow.cashValue;
        var groupCashValue = groupCashValues[updatedRow.groupId] || updatedRow.groupCashValue;
        var rowBeforeEdit = selectedRowsSnapshot.find({id: updatedRow.id});

        if (rowBeforeEdit) {
            switch (rowBeforeEdit.action) {
                case "Buy":
                    cashValue += rowBeforeEdit.tradeAmount;
                    groupCashValue += rowBeforeEdit.tradeAmount;
                    netCashValue += rowBeforeEdit.tradeAmount;
                    break;
                case "Sell":
                    cashValue -= rowBeforeEdit.tradeAmount;
                    groupCashValue -= rowBeforeEdit.tradeAmount;
                    netCashValue -= rowBeforeEdit.tradeAmount;
                    break;
            }

            angular.extend(rowBeforeEdit, updatedRow);
        }

        switch (updatedRow.action) {
            case "Buy":
                cashValue -= updatedRow.tradeAmount;
                groupCashValue -= updatedRow.tradeAmount;
                netCashValue -= updatedRow.tradeAmount;
                break;
            case "Sell":
                cashValue += updatedRow.tradeAmount;
                groupCashValue += updatedRow.tradeAmount;
                netCashValue += updatedRow.tradeAmount;
                break;
        }

        cashValues[updatedRow.accountId] = cashValue;
        groupCashValues[updatedRow.groupId] = groupCashValue;
        $scope.current.netCashValue = netCashValue;
    }

    function resetCacheData() {
        $scope.current.tradeInfo = null;
        selectedRowsSnapshot = [];
        cashValues = {};
        groupCashValues = {};
        accountSleeves = [];
    }

    function calculateCashTargetPercentTolerance() {
        $scope.current.cashTargetPercentOutOfTolerance = ($scope.current.tradeInfo.targetCashPercentage - $scope.current.tradeInfo.cashPercent) > $scope.current.tradeInfo.cashLowerTolerance || ($scope.current.tradeInfo.cashPercent -  $scope.current.tradeInfo.targetCashPercentage) > $scope.current.tradeInfo.cashUpperTolerance ;
    }

    function getTacticalData(config){
        var selectedIds = ($scope.current.ids && $scope.current.ids.length > 0) ? $scope.current.ids : ($scope.current.idsToProcess && $scope.current.idsToProcess.length > 0) ? $scope.current.idsToProcess: [];
        return $q.resolve(
            selectedIds.length > 0
                ? $scope.current.mode === 'account' && selectedIds.length === 1 || $scope.current.mode !== 'account'
                    ? $scope.current.mode + '/' + selectedIds[0] : 'AccountList'
                : $scope.openDialogPrompt()
        ).then(function(url) {
            if(startedInstance && startedInstance.closedOrders) return $q.resolve(startedInstance.closedOrders);

            if(!url)
            {
                $location.path("/trading/tom/orders");
                return $q.resolve({});
            }

            url = '/Trading/Tactical/' + url;

            if(parentId && $scope.current.idsToProcess){
                url = url.replace('household/' + $scope.current.idsToProcess[0],'Client/' + parentId);
                if(url.has('Client')) $scope.current.grid.param.modelAggIdFilter = $scope.current.idsToProcess[0];
            }else{
                url = url.replace('household/', 'Client/');
            }

            if(url.has('AccountList')) {
                $scope.current.grid.param.ids = $scope.current.ids;
                return $http({ url: url, method: 'POST', data: config.params, trackerMsg: 'Loading tactical trades'})
            } 
            
            return $http(angular.merge({url: url, method: 'GET', trackerMsg: 'Loading tactical trades'}, config))
        }).catch(function(){
            $location.path("/trading/tom/orders");
        });
    }

    //PUBLIC METHODS

    $scope.startOver = function (forceRefresh) {
       resetCacheData();
       $scope.current.ids =[];
       $scope.current.idsToProcess =[];
       $scope.selectedIds = [];
       $scope.$broadcast('event:tactical-trades', {action: 'refresh-grid'});
    };


    $scope.openDialogPrompt = function (redirectOnCancel) {
        return $dialog.dialog({ templateUrl: "tactical-trades-prompt.html", controller: "TacticalTradesPromptCtrl", redirectOnCancel: redirectOnCancel})
            .open()
            .then(function (result) {
                if (result) {
                    $scope.current.grid.param.usePendingValue = result.usePendingValue;
                    $scope.current.grid.param.defaultAction = result.defaultAction;
                    $scope.current.mode = result.mode;
                    $scope.current.selectedPromptIds = result.selectedIds;
                    resetCacheData();
                    $scope.current.loadedFromPrompt = true;
                    createGroupingForEntity( result.mode);
                    parentId = result.parentId;
                    if(result.mode === "household") {
                        $scope.current.grid.param.modelAggIdFilter = result.selectedIds[0];
                    }
                    loadItems(result.selectedIds, result.usePendingValue, result.mode, result.tradeAction, result.closedOrders);
                    return result.mode + '/' + result.selectedIds[0];
                }
            });
    };

    $scope.togglePendingValue = function() {
        $dialog.confirmAction("This action will refresh the grid and any unsaved changes will be lost.  Do you want to continue?")
            .open()
            .then(function(result){
                if (result === 'yes') {
                    $scope.current.grid.param.usePendingValue = !$scope.current.grid.param.usePendingValue
                    $timeout(function() {$scope.refreshGrid();});
                }
            });
    };

    $scope.toggleTradeType = function() {
        $scope.current.tradeType = $scope.current.tradeType === "Dollars" ? "Shares" : "Dollars";
    };

    $scope.toggleColumns = function(columnType, isVisible) {
        var columnNames = columnType === 'GainLoss' ? ["unrealizedCostBasisLongTerm", "unrealizedCostBasisShortTerm", "unrealizedGainAmount", "unrealizedGainPercent"]
                                                    : ["postTrade" + columnType, "target" + columnType, "current" + columnType];

        $scope.current.view.slickGridColumnDefs.forEach(function(column) {
            if (columnNames.any(column.field)) {
                column.visible = isVisible;
            }

            if (columnType === 'GainLoss' && ["tradeReason", "message"].any(column.field)) {
                column.cssClass = isVisible ? "darken" : "";
            }
        });
    };

    $scope.excludeAsset = function(excludeAsset) {
        var assetId = selectedRowsSnapshot.find({id: $scope.selectedIds[0]}).assetId;

        if (!assetId) {
            $dialog.messageBox("Invalid Selection", "The selected row is not an asset of this account.").open();
            return;
        }

        $dialog.confirmAction("This action will refresh the grid and any unsaved changes will be lost.  Do you want to continue?")
            .open()
            .then(function(result) {
                if (result === 'yes') {
                    $http.put('/Settings/EntityOptions/Assets/Code/69EXCLUDEF', {entity: "Asset", entityId: assetId, value: excludeAsset, code: "69EXCLUDEF"}, {trackerMsg: excludeAsset == "True" ? 'Excluding asset' : 'Including Asset'})
                        .then(function() {
                            $scope.refreshGrid();
                            $timeout(function(){
                                $scope.$broadcast('event:tactical-trades', {action: 'select-rows', rows:[]});
                            },0);
                        });
                }
            });
    };

    $scope.refreshGrid = function() {
        $scope.$broadcast('event:tactical-trades', {action: 'refresh-grid'});
        resetCacheData();
    };

    $scope.exportToExcel = function() {
        $scope.$broadcast('event:tactical-trades', {action: 'export-data'});
    };

    $scope.processCurrentItem = function(action) {
        if ($scope.mainTracker.active()) {
            return;
        }

        //On save stop $route change listener
        onRouteChangeOff();

        if (action) {
            var doAction = function() {
                var args = {successCallback: tradesCreated, action: 'send-data', verb: "PUT", url: "/Trading/Tactical?tradeType=" + $scope.current.tradeType + "&executeTrade=" + (action === "send"), trackerMsg: action === "send" ? "Sending trades" : "Saving trades"};
                $scope.$broadcast('event:tactical-trades', args);
            };

            var accountsOverSpendingCash = Object.values(cashValues).count(function (x) {return x < 0;});

            if (accountsOverSpendingCash > 0) {
                $dialog.confirmAction("The trades will overspend cash on " + accountsOverSpendingCash + " account(s).  Do you want to continue?")
                    .open()
                    .then(function(result) {
                        if (result === 'yes') {
                            doAction();
                        }
                    });
            }
            else {
                doAction();
            }
        }
        else {
           goToNextItem();
        }
    };

    $scope.addTrade = function() {
        switch ($scope.current.mode) {
            case "account":
                $scope.newTrade.accountId = $scope.current.selectedAccount;
                $scope.newTrade.productId = $scope.current.product.productId;
                break;
            case "product":
                $scope.newTrade.accountId = $scope.current.account.id;
                $scope.newTrade.productId = $scope.current.idsToProcess[0];
                break;
            case "household":
            case "registration":
                $scope.newTrade.accountId = $scope.current.account.id;
                $scope.newTrade.productId = $scope.current.product.productId;
                break;
        }

        var params = $scope.current.mode === "household" ? "&clientId=" + parentId + "&modelAggId=" + $scope.current.idsToProcess[0] : "";
        
        $http.post('/Trading/Tactical?usePendingValue=' + $scope.current.grid.param.usePendingValue + params, $scope.newTrade, {trackerMsg: 'Adding new trade'})
            .then(function (response) {
                syncCashValue(response.data);
                pageIsDirty = true;
                $scope.$broadcast('event:tactical-trades', {action: "add-item", item: response.data});
                $scope.resetAdd();
            });
    };

    $scope.resetAdd = function() {
        $scope.current.account = null;
        $scope.current.product = null;
        $scope.newTrade = {accountId: null, action: "Buy", productId: null, tradeAmount: null, tradeShares: null};
    };

    $scope.openSleeveTransfer = function() {
        if($scope.current.sleeveTransferFeatureFlag) {
            $http.post(`/Portfolio/SleeveTransfer/EntitySession/Registration`, $scope.current.idsToProcess, { trackerMsg: 'Opening Sleeve Transfer' }).then((response) => {
                window.open(`#/portfolio/sleeve/transfer/${response.data}`, '_blank');
            });
        } else {
            window.open(`#/trading/sleeve/transfer?registrationId=${$scope.current.idsToProcess[0]}&accountId=${$scope.current.account.id}`, '_blank');
        }
    };
    

    //INITIALIZE
    $scope.selectedIds = [];
    $scope.views = views;
    $scope.current = {
        grid: {
            load: getTacticalData,
            param: {
                modelAggIdFilter:'null', usePendingValue: false, defaultAction:'null', calculateCosts: true
            }
        },
        parentId:null, selectedAccount:null, cashTargetPercentOutOfTolerance:false, ids:[], finishedProcessing:false, view: views[0],  tradeInfo: null, canExecute: false, tradeType: "Dollars", newTradeType: "Dollars", loadedFromPrompt: false, mode: "account",modelAggId:null, gridDataUrl: null, usePendingValue: true, action:''
    };
    $scope.grid = {includeShareCols: true, includePercentCols: true, includeValueCols: true, includeGainLossCols: true, groupByCategory: false, groupByClass: false};



    init();


    //EVENT LISTENERS
    $scope.$on("event:tactical-trades-select", function(e, args) {
        if (args.length === 0) {
            return;
        }

        pageIsDirty = true;

        if (args.length === 1) {
            if (args[0].id === previousSelectedId) {
                return;
            } else {
                previousSelectedId = args[0].id;
            }
        }

        if (['household', 'registration'].any($scope.current.mode)) {
            $scope.current.account = {id: args[0].accountId, number: args[0].accountNumber, name: args[0].account};
        }

        $scope.tradeToolsDisabled = false;
        args.forEach(function (row) {
            if (!cashValues.hasOwnProperty(row.accountId)) {
                cashValues[row.accountId] = row.cashValue;
            }

            if (!groupCashValues.hasOwnProperty(row.groupId)) {
                groupCashValues[row.groupId] = row.groupCashValue;
            }

            if (selectedRowsSnapshot.none({id: row.id})) {
                selectedRowsSnapshot.push(angular.copy(row));
            }

            if (row.isCustodialCash || ($scope.current.mode === 'registration' && !row.modelName)) {
                $scope.tradeToolsDisabled = true;
            }
        });
        $scope.current.tradeInfo = args[args.length - 1];
        $scope.current.tradeInfo.targetCashValue = ($scope.current.tradeInfo.targetCashPercentage / 100) * $scope.current.tradeInfo.groupValue;

        var accountSleeve = accountSleeves.find({accountId: $scope.current.tradeInfo.accountId});
        if (accountSleeve) {
            if( accountSleeve.targetBalanceType === 'Dollars' ){
                $scope.current.tradeInfo.targetCashValue = accountSleeve.targetAllocation;
            }
            $scope.current.tradeInfo.sleeveTarget = accountSleeve.targetAllocation;
            $scope.current.tradeInfo.targetBalanceType = accountSleeve.targetBalanceType;
            $scope.current.tradeInfo.sleeveCurrent = accountSleeve.currentAllocation;
        }

        $scope.current.selectedAccount = args[0].accountId;

        setTradeInfoCashValue();
        calculateCashTargetPercentTolerance();
    });

    $scope.$on("event:tactical-trades-edit", function(e, args) {
        syncCashValue(args);
        setTradeInfoCashValue();
    });

    $scope.$on("event:tactical-trades-action", function(e, args) {
        args.data.forEach(function(row) {
            syncCashValue(row);
        });

        setTradeInfoCashValue();
    });

    $scope.$on('slickgrid-data-loaded', function(event, data){
        netCashValue = 0;

        $scope.gridAccountList = data.unique('accountId').map(function (i) {return {id: i.accountId, name: i.accountNumber};});

        //for add trade, when only one account is loaded
        if($scope.gridAccountList.length === 1){
            $scope.current.selectedAccount = $scope.gridAccountList[0].id;
        } else if (!$scope.gridAccountList.length && $scope.current.selectedPromptIds.length && $scope.current.mode === 'account') {
            // if an account is selected by no trades are on the grid, then use the account selected in the prompt
            $scope.current.selectedAccount = $scope.current.selectedPromptIds[0];
        }

        data.forEach(function(row){
            switch (row.action) {
                case "Buy":
                    netCashValue -= row.tradeAmount;
                    break;
                case "Sell":
                    netCashValue += row.tradeAmount;
                    break;
            }
        });
        $scope.current.netCashValue = netCashValue;
    });
});


app.controller('TacticalTradesPromptCtrl', function TacticalTradesPromptCtrl($scope, $http, $location, dialog, $tactical) {
    //PRIVATE METHODS
    function init() {
        var startedInstance = $tactical.getCurrent();
        if (startedInstance) {
            $scope.tacticalOptions.mode = startedInstance.mode;
            $scope.tacticalOptions.usePendingValue = startedInstance.usePendingValue;
            if (startedInstance.mode === "household") {
                $scope.current.household = startedInstance.selectedHousehold;
                loadModelsForHousehold();
            } else {
                $scope.tacticalOptions.selectedIds = startedInstance.selectedIds;
            }
            $tactical.reset();
        } else {
            $http.get("/Settings/EntityOptions/Database/0/code/5:69DEFAUL",  {cache: true, trackerMsg: 'Loading default for Pending'})
                .then(function (response) {
                    $scope.tacticalOptions.usePendingValue = response.data.value.toLowerCase() === "true";
                });
        }

        $http.get("/Utility/Groupings?usedFor=Trading", {cache: true, trackerMsg: 'Loading trade groups'})
            .then(function (response) {
                $scope.tradeGroups = response.data;
            });
    }

    function loadModelsForHousehold() {
        $http.get("/Portfolio/Clients/" + $scope.current.household.id + "/Accounts/ModelAggs/Simple", {trackerMsg: 'Loading models'})
            .then(function (response) {
                $scope.current.household.models = response.data;
                $scope.current.newItem = response.data[0];
            });
    }


    //PUBLIC METHODS
    $scope.cancel = function() {
        dialog.close();

        if (dialog.options.redirectOnCancel) {
            $location.path("/trading/tom/orders");
        }
    };

    $scope.loadTactical = function() {
        if ($scope.tacticalOptions.mode === "tradeGroup") {
            $http.get('/Utility/Groupings/' + $scope.current.newItem.id, {trackerMsg: 'Loading accounts for ' + $scope.current.newItem.name})
                .then(function(response) {
                    $scope.tacticalOptions.selectedIds = response.data.map("id");
                    $scope.tacticalOptions.mode = "account";
                    dialog.close($scope.tacticalOptions);
                });
        }
        else {
            if ($scope.tacticalOptions.mode === "household") {
                $scope.tacticalOptions.parentId = $scope.current.household.id;
            }
            $scope.tacticalOptions.selectedIds.push($scope.current.newItem[$scope.tacticalOptions.mode === "product" ? "productId" : "id"]);
            dialog.close($scope.tacticalOptions);
        }
    };

    //INITIALIZE
    $scope.current = {newItem: null};
    $scope.tacticalOptions = {selectedIds: [], mode: "account", usePendingValue: false, tradeAction:null, closedOrders:null};
    init();

    //SCOPE WATCHERS
    $scope.$watch('current.household', function (newValue, oldValue) {
        if (!newValue || newValue === oldValue) return;

        loadModelsForHousehold();
    });
});

'use strict';

app.controller('TargetPercentCtrl', function TargetPercentCtrl($scope, $http, $tradeGenerator, $location) {
    var tradeGroups;

    //PRIVATE METHODS
    function initialLoad() {

        $http.get('/Settings/Database/EntityOptions/Code/69TARGETOP', {cache: true, trackerMsg: 'Loading open order logic'})
            .then(function (response) {
                $scope.current.useOpenOrderLogic = response.data.value.toLowerCase() === "true";
            });
        $http.get("/Portfolio/Platforms/Simple", {cache: true, trackerMsg: 'Loading management styles'})
            .then(function (response) {
                response.data.unshift({id: 0, name: "Not Selected"});
                $scope.managementStyles = response.data;
            });

        $http.get("/Trading/Models/Simple", {cache: true, trackerMsg: 'Loading models'})
            .then(function (response) {
                response.data.unshift({id: 0, name: "Not Selected"});
                $scope.models = response.data;
            });

        $http.get("/Trading/ModelAggs/Simple?excludeSelfDirected=true", {cache: true, trackerMsg: 'Loading model aggs'})
            .then(function (response) {
                $scope.modelAggs = response.data;
            });

        $http.get("/Trading/Models/ModelTypes", {cache: true, trackerMsg: 'Loading model types'})
            .then(function (response) {
                $scope.modelTypes = response.data;
            });

        $http.get("/Utility/Groupings?usedFor=Trading", {cache: true, trackerMsg: 'Loading trade groups'})
            .then(function (response) {
                tradeGroups = response.data;
            });

        $http.get("/Settings/Database/EntityOptions/Code/TRADERSNREQ", {cache: true, trackerMsg: 'Loading requirements'})
            .then(function (response) {
                $scope.current.isReasonRequired = response.data.value.toLowerCase() === "true";
            });

        $tradeGenerator.getTradeDefinition("TargetPercent")
            .then(function (response) {
                $scope.tradeDefinition = response.data;

                if( !$scope.current.useOpenOrderLogic && $scope.tradeDefinition.assetValues === 'PendingTransactionsAndOrders'){
                    $scope.tradeDefinition.assetValues = 'Pending';
                }

                $http.get("/Portfolio/FundFamilies/Simple", {cache: true, trackerMsg: 'Loading fund families'})
                    .then(function (response) {
                        $scope.fundFamilies = response.data;
                        $scope.tradeDefinition.fundFamilyID = response.data[0].id;
                    });
            });

        setAccountSelection();
    }

    //PUBLIC METHODS
    $scope.back = function() {
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep -= 1;
    };

    $scope.next = function() {
        $scope.current.animation = 'slide-right';
        $scope.current.wizardStep += 1;
    };

    $scope.jumpBackTo = function(index) {
        if ($scope.current.executing) return;

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };

    $scope.isStepIncomplete = function() {
        switch ($scope.current.wizardStep) {
            case 0:
                return !$scope.tradeDefinition;
            case 1:
                switch ($scope.current.accountSelectionType) {
                    case 0: //fund family
                        return !$scope.tradeDefinition.fundFamilyID;
                    case 2: //excel import
                        return $scope.current.selectedItems.count({isValid: true}) === 0;
                    default:
                        return $scope.current.selectedItems.length === 0;
                }
            case 2:
                return !$scope.current.tradeProduct || !Number.range(0, 100).contains($scope.tradeDefinition.percentToReach);
            default:
                return false;
        }
    };

    $scope.moveSome = function(selectedItems, from, to) {
        angular.forEach(selectedItems, function(item) {
            var index = from.indexOf(item);
            if (index !== -1) {
                from.splice(index, 1);
                to.push(item);
            }
        });
        selectedItems.length = 0;
    };

    $scope.moveAll = function(from, to, selectedItems, filter) {
        if (filter) {
            filter = filter.toLowerCase();
            $scope.moveSome(from.findAll(function(item) {return item.name.toLowerCase().indexOf(filter) != -1;}), from, to);
            $scope.current.availableItemsFilter = "";
        }
        else {
            angular.forEach(from, function(item) {
                to.push(item);
            });
            from.length = 0;
        }

        selectedItems.length = 0; //in case they selected some and then did move all
    };

    function fillAvailableItems(sourceList) {
        // remove ID=0 items that may have been added for dropdown lists
        let list = angular.copy(sourceList.filter(item => item.id > 0));
        $scope.current.availableItemsFilter = "";
        $scope.current.availableItems = list;
        $scope.current.availableSelected = [];
        resetSelectedItems();
    }

    function resetSelectedItems() {
        $scope.current.selectedItems = [];
        $scope.current.selectedSelected = [];
    };

    $scope.addSelectedAccount = function() {
        if ($scope.current.selectedItems.none({id: $scope.current.selectedAccount.id})) {
            $scope.current.selectedItems.push($scope.current.selectedAccount);
        }
        $scope.current.selectedAccount = null;
    };

    $scope.submitTrade = function() {
        $scope.current.executing = true;
        $scope.tradeDefinition.productID = $scope.current.tradeProduct.productId;
        $scope.tradeDefinition.filename = $scope.current.importFile;

        if ($scope.current.accountSelectionType === 0) {
            $scope.tradeDefinition.keys = null;
            $scope.tradeDefinition.entity = null;
            $scope.tradeDefinition.accounts = [];
        }
        else {
            var pkList = [];
            $scope.current.selectedItems.forEach(function (item) {
                if (item.isValid !== false) pkList.push(item.id);
            });

            if ($scope.current.accountSelectionType === 3) { // Trade Groups
                $scope.tradeDefinition.keys = pkList;
                $scope.tradeDefinition.entity = "DynamicGrouping";
                $scope.tradeDefinition.accounts = [];
            }
            else if ($scope.current.accountSelectionType == 4) { // Models
                $scope.tradeDefinition.keys = pkList;
                $scope.tradeDefinition.entity = "AggregateModel";
                $scope.tradeDefinition.accounts = [];
            }
            else if ($scope.current.accountSelectionType === 5) { // Management Styles
                $scope.tradeDefinition.keys = pkList;
                $scope.tradeDefinition.entity = "Platform";
                $scope.tradeDefinition.accounts = [];
            }
            else {
                $scope.tradeDefinition.keys = null;
                $scope.tradeDefinition.entity = null;
                $scope.tradeDefinition.accounts = pkList;
            }

            $scope.tradeDefinition.fundFamilyID = 0;
            $scope.tradeDefinition.managementStyleID = 0;
            $scope.tradeDefinition.modelID = 0;
        }

        $tradeGenerator.submitTradeDefinition($scope.tradeDefinition)
            .then(function() {
                $location.path('/trading/tom/orders');
            }, function () {
                $scope.current.executing = false;
            }
        );
    };

    function setAccountSelection() {
        switch($scope.current.accountSelectionType) {
            case 0:
                $scope.current.selectionTypeName = "fund family";
                break;
            case 1:
                $scope.current.selectionTypeName = "accounts";
                resetSelectedItems();
                break;
            case 2:
                $scope.current.selectionTypeName = 'accounts';
                resetSelectedItems();
            case 3:
                $scope.current.selectionTypeName = "trade groups";
                fillAvailableItems(tradeGroups);
                break;
            case 4:
                $scope.current.selectionTypeName = "models";
                fillAvailableItems($scope.modelAggs);
                break;
            case 5:
                $scope.current.selectionTypeName = 'management styles';
                fillAvailableItems($scope.managementStyles);
        }
    }

    //INITIALIZE
    $scope.current = {accountSelectionType: 0, selectionTypeName: '', wizardStep: 0, animation: 'slide-right', executing: false, selectedAccount: null, tradeProduct: null, modelAggs: [] };
    $scope.wizardSteps = [ "Selection Method", "Filter Selections", "Trade Options" ];
    initialLoad();

    $scope.$watch("current.accountSelectionType", function (newValue, oldValue) {
        if (newValue === oldValue) return;

        setAccountSelection();
    });
});

'use strict';

app.controller('TOMAccountLogCtrl', function TOMAccountLogCtrl($scope, $http, dialog, instanceId, accounts) {
        //PRIVATE METHODS
        function init() {
            if ($scope.current.accounts && $scope.current.accounts.length === 1) {
                $scope.current.selectedAccount = $scope.current.accounts[0];
                $scope.viewLogForAccount();
            }
        }

        function getLog(logInstanceId, acctId) {
            return $http.get('/Trading/RebalanceLog/' + logInstanceId, {

                trackerMsg: 'Loading rebalance log'
            }).then(function (response) {
                return {id: logInstanceId, logText: response.data.logText, accountId: acctId};
            });
        }

        //PUBLIC METHODS
        $scope.close = function () {
            dialog.close();
        };

        $scope.viewLogForAccount = function () {
            if (!$scope.current.selectedAccount || $scope.current.selectedAccount.id < 0) {
                $scope.current.log = null;
                return;
            }

            getLog($scope.current.selectedAccount.id, $scope.current.selectedAccount.accountId)
                .then(function (response) {
                    $scope.current.log = response;
                });
        };

        $scope.download = function () {
            var accountId = $scope.current.selectedAccount.accountId;
            var logInstanceId = $scope.current.selectedAccount.id;

            var downloadFn = function (log) {
                var textToWrite = log.logText;
                var textFileAsBlob = new Blob([textToWrite], {type: 'text/plain'});
                var fileNameToSaveAs = "rebalance-log-" + log.id + "-" + log.accountId + ".txt";

                var downloadLink = document.createElement("a");
                downloadLink.download = fileNameToSaveAs;
                downloadLink.innerHTML = "Download File";
                downloadLink.href = window.URL.createObjectURL(textFileAsBlob);
                downloadLink.click();
            };

            if (!$scope.current.log || $scope.current.log.id !== logInstanceId) {
                getLog(logInstanceId, accountId).then(function (response) {
                    downloadFn(response);
                });
            } else {
                downloadFn($scope.current.log);
            }
        };

        //INITIALIZE
        $scope.current = {
            accounts: accounts,
            selectedAccount: null,
            instanceId: instanceId,
            log: null
        };

        init();
    }
);
'use strict';

var tomBlockedOrdersCtrl = app.controller('TOMBlockedOrdersCtrl', function TOMBlockedOrdersCtrl($scope, $http, $dialog, $location, $routeParams, views, $timeout, $oasRights,$tradeGenerator,$tactical, searchResult) {

    //PRIVATE METHODS
    function initialLoad() {
        $scope.rightsInstances = $oasRights.forCode("TRADEINSTANCES");

        var path = $location.path().toLowerCase();
        if (path.has("closed")) {
            $scope.current.viewType = "closed";
            if ($routeParams.entityId || searchResult) {
                $scope.current.startDate = Date.create('a year ago');
            } else {
                $scope.current.startDate = Date.create($routeParams.startDate ? $routeParams.startDate : null);
            }
            $scope.current.endDate = Date.create($routeParams.endDate ? $routeParams.endDate : null);
            getCoveredCallRoundingDBOption();
        }else if (path.has("pending")) {
            $scope.current.viewType = "pending";
            $scope.current.canCompletePendings = $oasRights.canRead("COMPLETEPENDINGS");
        }else if (path.has("owa")) {
            $scope.current.viewType = "ordersAwaitingAcceptance";
        }else {
            $scope.current.viewType = "open";
        }

        if ($scope.current.blockId > 0)
            $scope.current.url = "/Trading/FixBlockOrders/" + $scope.current.blockId + "/" + ($scope.current.viewType === 'pending' ? 'Transactions' : 'Orders');
        else if ($scope.current.viewType === "pending")
            $scope.current.url = "/Trading/Transactions";
        else
            $scope.current.url = "/Trading/Orders";

        if ($scope.current.blockId > 0)
            $scope.addBreadcrumb("Block " + $scope.current.blockId);

        $http.get('/Reporting/Reports?menu=fixorder.' + $scope.current.viewType, {cache: true, trackerMsg: 'Loading trade order reports'})
            .then(function (response) {
                $scope.current.reports = response.data;
            });
    }

    function getCoveredCallRoundingDBOption() {
        $http.get('/Settings/Database/EntityOptions/Code/69COVEREDC', {trackerMsg:'Getting database option for covered call options'})
            .then(function (response) {
                $scope.current.coveredCallRounding = response.data.value.toNumber();
            })
    }

    function enableContractOptionSelection(args) {
        //use first ticker and side in array to see if all tickers and sides selected are the same.
        $scope.current.canSelectContracts = args.every({ticker:args[0].ticker, side:args[0].side});

        $scope.current.orderQtyTotalForContracts = args.sum('orderQty');
    }

    //PUBLIC METHODS
    $scope.refreshGrid = function () {
        $scope.$broadcast('event:tom-block-orders-action', {action: 'refresh-grid'});
    };

    $scope.toggleEnabledOnly = function () {
        $scope.current.enabledOnly = !$scope.current.enabledOnly;
        $timeout(function () {
            $scope.$broadcast('event:tom-block-orders-action', {action: 'refresh-grid'});
        });
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:tom-block-orders-action', {action: 'export-data'});
    };

    $scope.runReport = function (reportId) {
        var reportArgs = {fkFixBlockOrder: $scope.current.blockId};
        if ($scope.selectedIds.length > 0) {
            reportArgs.OrderIDs = $scope.selectedIds.join(",");
        }

        $dialog.reportPrompt(reportId, reportArgs).open();
    };

    $scope.openEditor = function () {
        $dialog.dialog({ templateUrl: "trading/views/tom-order-editor.html", controller: "TOMOrderEditorCtrl", resolve: { orderId: function () { return $scope.current.selectedBlockOrderId; }, isBlockOrder: function () { return true; }, productType: function () { return $scope.current.productType } } })
            .open()
            .then(function (savedBlock) {
                if (savedBlock.length === 1) {
                    //get all orders associated with this block
                    $http.get('/Trading/FixBlockOrders/' + savedBlock.id + '/Orders', {trackerMsg:'Fetching orders to update for this block'})
                        .then(function (response) {
                            $scope.$broadcast('event:tom-block-orders-action', {action: "update-items", items: response.data});
                        });
                }
            });
    };

    $scope.openInTactical = function () {
        var orders = [];
        orders = $scope.selectedBlockOrders;

        var isAccountSleeve = false;
        var regId = 0;
        $http.get('/Portfolio/Accounts/' + orders[0].accountId, {trackerMsg:'Checking if account sleeve'})
            .then(function (response) {
                isAccountSleeve = response.data.isSleeveAccount;
                regId = response.data.registrationId;
            })
            .then(function () {
                $http.put('/Trading/Tactical/ClosedOrders?usePendingValue=true', orders , {trackerMsg:'Creating new orders for tactical'})
                    .then(function (response) {
                        if(response.data){
                            //check if account is sleeved
                            var level = isAccountSleeve ? 'registration' : 'account';
                            var ids = [];

                            if(isAccountSleeve){
                                response.data[0].registrationId = regId;
                            }

                            $tactical.start(level, ids, true, response.data);
                        }
                    })
            })

    };


    $scope.openCoveredCallSelector = function () {
        var d = $dialog.editor('tom-blocked-covered-call-options.html', 'TOMBlockedCoveredCallOptionsCtrl', {
            args: function () {
                return {orders: $scope.selectedBlockOrders, roundingOption: $scope.current.coveredCallRounding};
            }
        });
        d.open().then(function (result) {
            if (result) {
                $scope.current.canGenerateOptionTradeFile = true;
                if(!$scope.current.tradeDefinition){
                    $scope.current.tradeDefinition = result;
                }else{
                    result.each(function (r) {
                        $scope.current.tradeDefinition.add(r);
                    })
                }
            }else{
                $scope.current.canGenerateOptionTradeFile = false;
                $scope.current.tradeDefinition = null;
            }
        });
    };

    $scope.createCoveredCallFile = function () {
        var tradeDef = null;
        $tradeGenerator.getTradeDefinition("OptionTrade")
            .then(function (response) {
                tradeDef = response.data;
                tradeDef.trades = $scope.current.tradeDefinition;


                $tradeGenerator.submitOptionTradesDefinition(tradeDef, false);

                $scope.$on('event:orders-success', function () {
                    $dialog.messageBox("<i class='fa fa-lg fa-check-square' aria-hidden='true'></i> Action Complete", "Option Trade File created.").open()
                        .then(function(){
                            $scope.current.canGenerateOptionTradeFile = false;
                            $scope.current.tradeDefinition = null;
                        })
                });
            });
     };

    $scope.viewFixMessages = function () {
        $dialog.dialog({ templateUrl: "trading/views/tom-fix-messages.html", controller: "FIXMessagesCtrl", resolve: { blockId: function () { return $scope.current.selectedBlockOrderId; } } }).open();
    };


    $scope.resetMutualFunds = function () {
        if ($scope.selectedIds.length > 0) {
            $http.put('/Trading/Orders/Action/ResetMutualFundTrades?useTradeIds=true', $scope.selectedIds, {trackerMsg: 'Reset selected Mutual Fund orders'})
                .then(function (response) {
                    location.href = '#/trading/tom/orders';
                });
        }
    };

    //EVENT LISTENERS

    $scope.$on('event:tom-block-orders-selected', function (e, args) {
        e.stopPropagation();
        if (args.length === 0) return;

        $scope.selectedBlockOrders = args;

        $scope.current.selectedBlockOrderId = args[0].fixBlockOrderId ? args[0].fixBlockOrderId : args[0].blockId;
        $scope.current.productType = args[0].productType;

        enableContractOptionSelection(args);

        $scope.current.instanceUrl = null;
        var selectedInstanceId = args.map("trInstanceId");
        if (selectedInstanceId && selectedInstanceId.length === 1) {
            $scope.current.instanceUrl = window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html?p=" + encodeURIComponent("/trading/instances?instanceId=" + selectedInstanceId[0]);
        }
    });

    //INITIALIZE
    $scope.views = views;
    $scope.current = {
        view: views[0],
        blockId: $routeParams.blockId,
        url: "",
        selectedBlockOrderId: [],
        productType: "",
        tradeInstanceId: $routeParams.tradeInstanceId ? $routeParams.tradeInstanceId : null,
        enabledOnly: $scope.user.isFTJ,
        entity: searchResult ? searchResult.entity : $routeParams.entity,
        entityId: searchResult ? searchResult.item.id : $routeParams.entityId,
        canSelectContracts: false,
        orderQtyTotalForContracts: 0,
        coveredCallRounding: 0,
        canGenerateOptionTradeFile: false,
        tradeDefinition:null
    };
    $scope.selectedIds = [];
    initialLoad();
});

tomBlockedOrdersCtrl.loadSearchForBlockedOrders = ["$http", "$route", "$portfolio", "entities", function ($http, $route, $portfolio, entities) {
    if ($route.current.params.entity || $route.current.$$route.originalPath.has('pending')) {
        return null;
    } else {
        return $http.get("/Settings/EntityOptions/Database/0/code/69TOMFORCE", {cache: true, trackerMsg: 'Loading search setting'})
            .then(function (response) {
                return response.data.value === "True" ? $portfolio.search(entities.account.value) : null;
            });
    }
}];

app.controller('TOMBlockedCoveredCallOptionsCtrl', function CoveredCallOptionsCtrl($scope, $http, $timeout, args, dialog) {

    //region Private Variables
    //endregion

    //region Private Methods
    function init() {

        var accountIdFromOrders = args.orders.map('accountId').unique().compact();
        getExistingCallByAccountId(accountIdFromOrders, args.orders[0].productId, $scope.current.side);

        //get options for passed in ticker
        getOptionsForTicker($scope.current.ticker, 'list');

    }

    function getExistingCallByAccountId(ids, productId, side) {
        var url = '/Portfolio/Assets/' + productId;
        url += side === 'Buy' ? '/BuyOptionShares' : '/SellOptionShares';

        //Passed account ids plus product id to endpoint.
        $http.post(url, ids, {trackerMsg:'Retrieving covered options'})
             .then(function (response) {
                 if(response.data && response.data.length > 0){
                    formatData(side, response.data);
                 }else{
                     $scope.tempContracts = [];
                 }
         })
    }

    function formatData(side, optionContracts) {
        optionContracts.forEach(function (item) {
            var tempObj = {
                accountId: item.accountId,
                registrationName: $scope.current.selectedOrders.find({accountId:item.accountId}).registrationName,
                accountNumber:$scope.current.selectedOrders.find({accountId:item.accountId}).accountNumber,
                masterAccountNumber:$scope.current.selectedOrders.find({accountId:item.accountId}).masterAccountNumber,
                contracts:[{
                    side: side,
                    productId: item.productId,
                    productName: item.productName,
                    expirationDate: item.expirationDate,
                    currentPrice:  item.currentPrice,
                    strikePrice: side === 'Sell' ? item.strikePrice : 0,
                    currentValue:  item.currentValue,
                    currentShares: item.currentShares,
                    currentContracts: item.currentContracts,
                    possibleContracts: side === 'Sell' ? ($scope.current.selectedOrders.find({accountId: item.accountId}).orderQty / 100).floor(0) : item.possibleContracts,
                    maxRequiredContracts: side === 'Sell' ? ($scope.current.selectedOrders.find({accountId: item.accountId}).orderQty / 100).floor(0) : item.possibleContracts,
                    fixBlockOrderId: $scope.current.selectedOrders.find({accountId: item.accountId}).id,
                    optionTRInterfaceId: $scope.current.selectedOrders.find({accountId: item.accountId}).optionTRInterfaceId,
                    contractSelectionRequired: false
                }]
            };
            $scope.tempContracts.add(tempObj);
        });

        //function to determine if user will need to handle multiple contract selection
        determineContractSelection()

    }

    function determineContractSelection() {
        //map passed in accountIds
        var accountIds = args.orders.map('accountId').unique().compact();

        //if there's more than 1 item in array, by account id, then multiple contracts will be listed
        accountIds.forEach(function (id) {
            var items = $scope.tempContracts.find({accountId:id});
            if(items && items.contracts.length > 1){
                items.contracts.forEach(function (c) {
                    c.contractSelectionRequired = true;
                })
            }
        });
    }

    function getOptionsForTicker(ticker,viewType) {
        $http.get('/Integrations/YahooFinance/Options/' + ticker + '?straddle=' + (viewType === 'straddle') + '&expireDate=' + $scope.current.selectedDate, {trackerMsg:'Getting ticker options'})
            .then(function (response) {
                $scope.optionData = response.data;
                if($scope.current.expiredDateList.length === 0){
                    $scope.current.expiredDateList = response.data.convertedDates;
                    $scope.current.selectedDate = $scope.optionData.options[0].expirationDate
                }
                if($scope.current.side === 'Buy'){
                    $scope.optionData.options[0].calls.each(function (item) {
                        item.isOpened = false;
                    });
                }
                updateHeader();
            })
    }

    function updateHeader() {
        $scope.current.leftInfoTopLine = $scope.optionData.quote.shortName + ' (' + $scope.optionData.quote.symbol + ')';
        $scope.current.leftInfoBottomLine = $scope.optionData.quote.regularMarketChange.round(2) + ' (' + $scope.optionData.quote.regularMarketChangePercent.round(2) + '%)';

        $scope.current.tickerStyle = $scope.optionData.quote.regularMarketChangePercent.round(2) > 0 ?'text-success' : 'text-error';

        // $scope.current.rightInfoTopLine = 'Contracts Required: ' + $scope.current.contractsNeeded;
        // $scope.current.rightInfoBottomLine = 'Selected Contract: ' + $scope.current.selectedContractName;
    }

    function getQuoteForTicker(contract) {
        // close other popover if opened.
        var openedItems = $scope.optionData.options[0].calls.findAll({isOpened:true});
        if(openedItems.length > 0){
            openedItems.each(function (item) {
                item.isOpened = false;
            })
        }
        $http.get('/Integrations/YahooFinance/Quote/' + contract.contractSymbol, {trackerMsg:'Getting ticker quote'})
            .then(function (response) {
                contract.isOpened = true;
                $scope.quoteData = response.data.quote;
                $scope.quoteData.expireDateConverted = convertFromEpoch($scope.quoteData.expireDate)

            })
    }

    function convertFromEpoch(d){
        return Date.utc.create(d * 1000).formatted()
    }

    //endregion

    //region Public Methods

    $scope.selectItem = function(row) {
        $scope.optionData.options[0].calls.forEach(function (item) {
            if(row !== item){
                item.selected =false;
            }
        });
        row.selected = !row.selected;
        $scope.current.selectedCount = $scope.optionData.options[0].calls.findAll({selected: true}).length;
        $scope.current.selectedOption = row;
    };

    $scope.reloadOptions = function () {
        getOptionsForTicker($scope.current.ticker, 'list')
    };

    $scope.fetchQuote = function (item) {
        timer = $timeout(function () {
            getQuoteForTicker(item);
        },100);
    };

    $scope.cancelFetchOnQuote = function () {
        $timeout.cancel(timer);
    };

    $scope.switchViewType = function (type) {
        $scope.current.viewType = type;
        getOptionsForTicker();
    };

    $scope.formatEpochDate = function (epoch) {
        return convertFromEpoch(epoch);
    };

    $scope.close = function () {
        args = null;
        dialog.close(null);
    };

    $scope.createFile = function () {
        var tempTrades = [];

        $scope.tempContracts.forEach(function (con) {
            var tempTradeObj = {};
            con.contracts.forEach(function (c) {
                //only accounts that have contracts
                if(c.possibleContracts > 0){
                    tempTradeObj.tradeRequestFixId = c.fixBlockOrderId;
                    tempTradeObj.accountNumber = con.accountNumber;
                    tempTradeObj.tradeInterfaceId = c.optionTRInterfaceId;
                    tempTradeObj.side = c.side === 'Buy' ? 1 : 2;
                    tempTradeObj.symbol = $scope.optionData.quote.symbol;
                    tempTradeObj.quantity = c.possibleContracts;
                    tempTradeObj.expiration = $scope.current.side === 'Buy' ? convertFromEpoch($scope.current.selectedOption.expiration) : c.expirationDate;
                    tempTradeObj.callOrPut = 'C';
                    tempTradeObj.openOrClose = $scope.current.side === 'Buy' ?  'C' : 'O';
                    tempTradeObj.strikePrice = $scope.current.side === 'Buy' ? $scope.current.selectedOption.strike : c.strikePrice;
                    tempTradeObj.masterAccountNumber = con.masterAccountNumber;
                }
                if(Object.size(tempTradeObj) > 0){
                    tempTrades.add(tempTradeObj);
                }
            });
        });

        if(!tempTrades.isEmpty()){
            dialog.close(tempTrades);
        }else{
            dialog.close(null);
        }
    };

    //endregion

    //region Watches

    //endregion

    //region Public Variables & Rights
    var timer;
    $scope.opened = false;
    $scope.optionTrades = [];
    $scope.tempContracts = [];

    //endregion

    $scope.current = {
        contractsNeeded: 0,
        selectedCount: 0,
        selectedOrders: args.orders,
        rightTitle: '',
        leftTitle: "Ticker",
        productName: "",
        transAmount: "value",
        ticker: args.orders[0].ticker,
        bgColor: "rgba(170, 170, 170, 1)",
        icon: "fa fa-orion-transaction",
        rightInfoTopLine: '',
        rightInfoBottomLine: '',
        leftInfoTopLine: '',
        leftInfoBottomLine: '',
        tickerStyle: 'text-success',
        selectedDate:null,
        viewType:'list',
        expiredDateList:[],
        selectedContractName: '',
        side: args.orders[0].side,
        contractRoundingFactor: args.roundingOption.toNumber(),
        existingCoveredCalls: [],
        selectedOption: null
    };

    init();

});
'use strict';

var tomBlocksCtrl = app.controller('TOMBlocksCtrl', function TOMBlocksCtrl($scope, $dialog, $http, $location, $oasRights, views) {
    //region PRIVATE VARIABLES
    //endregion

    //region PRIVATE METHODS
    function doAction(actionUrl, msgVerb, confirmMsg) {
        $dialog.confirmAction((confirmMsg ? confirmMsg : '') + "  This will affect all applicable blocks regardless of the current view or enabled filters.  Are you sure you want to proceed?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.put(actionUrl, null, { trackerMsg: msgVerb + ' all blocks' })
                        .then(function () {
                            $scope.$broadcast('event:tom-blocks-action', { action: 'refresh-grid' });
                        });
                }
            });
    }

    function initialLoad() {
        var path = $location.path().toLowerCase();
        if (path.indexOf("allocation") !== -1)
            $scope.current.viewType = "unallocated";
        else if (path.indexOf("closed") !== -1)
            $scope.current.viewType = "closed";
        else if (path.indexOf("pending") !== -1)
            $scope.current.viewType = "pending";
        else if (path.indexOf("owa") !== -1)
            $scope.current.viewType = "orderswaitingacceptance";
        else if (path.indexOf("deleted") !== -1)
            $scope.current.viewType = "deleted";
        else
            $scope.current.viewType = "open";

        if ($scope.current.viewType === "closed" || $scope.current.viewType === "deleted") {
            $scope.current.startDate = Date.create();
            $scope.current.endDate = Date.create();
        }

        if ($scope.current.viewType === "deleted") {
            $scope.current.url = "/Trading/Orders/Histories";
            $scope.current.modificationType = "deleted";
        }
        else {
            $scope.current.url = "/Trading/FixBlockOrders";
        }


        $http.get('/Reporting/Reports?menu=fixblock', { cache: true, trackerMsg: 'Loading trade block reports' })
            .then(function (response) {
                $scope.current.reports = response.data;
            });

        $scope.current.canAllocate = $oasRights.canRead("FIXALLOC");

        if ($scope.current.viewType === "open") {
            $http.get('/Settings/Database/EntityOptions/Code/69AUTOALLO', { cache: true, trackerMsg: 'Checking auto-allocate status' })
                .then(function (response) {
                    $scope.current.autoAllocate = (response.data.value === "True");
                });

            $scope.current.canExecute = $oasRights.canRead("FIXEXEC");
        }
    }

    //endregion

    //region PUBLIC METHODS

    // --> COMMON METHODS
    $scope.refreshGrid = function () {
        $scope.$broadcast('event:tom-blocks-action', { action: 'refresh-grid' });
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:tom-blocks-action', { action: 'export-data' });
    };

    $scope.runReport = function (reportId) {
        var reportArgs = {};
        if ($scope.selectedIds.length > 0) {
            reportArgs.fkFixBlockOrder = $scope.selectedIds[0];
            reportArgs.pkFixBlockOrder = $scope.selectedIds[0];
            reportArgs.fkFixBlockOrders = $scope.selectedIds.join(",");
        }

        $dialog.reportPrompt(reportId, reportArgs).open();
    };

    $scope.viewFixMessages = function () {
        $dialog.dialog({ templateUrl: "trading/views/tom-fix-messages.html", controller: "FIXMessagesCtrl", resolve: { blockId: function () { return $scope.selectedIds[0]; } } }).open();
    };

    $scope.openOrders = function () {
        if ($scope.current.viewType == 'orderswaitingacceptance') {
            $location.path('/trading/tom/open/' + $scope.selectedIds[0]);
        } else {
            $location.path('/trading/tom/' + $scope.current.viewType + '/' + $scope.selectedIds[0]);
        }


    };

    // --> OPEN BLOCK METHODS
    $scope.executeAll = function () {
        doAction('/Trading/FixBlockOrders/Action/Execute?autoAllocate=' + $scope.current.autoAllocate, 'Executing');
    };

    $scope.deleteAll = function () {
        doAction('/Trading/FixBlockOrders/Action/Delete', 'Deleting', 'Underlying trades will not be deleted.');
    };

    $scope.openEditor = function () {
        $dialog.dialog({ templateUrl: "trading/views/tom-order-editor.html", controller: "TOMOrderEditorCtrl", resolve: { orderId: function () { return $scope.selectedIds[0]; }, isBlockOrder: function () { return true; }, productType: function () { return $scope.current.productType } } })
            .open()
            .then(function (savedBlock) {
                if (savedBlock) {
                    savedBlock.forEach(function (block) {
                        $scope.$broadcast('event:tom-blocks-action', {
                            action: block.ordStatus === "Filled" ? "delete-item" : "update-item",
                            item: block
                        });
                    })
                }
            });
    };

    $scope.toggleAutoRefresh = function () {
        $scope.current.autoRefreshInterval = $scope.current.autoRefreshInterval === 0 ? 5000 : 0;
    };

    // --> ALLOCATION METHODS
    $scope.openFeeEditor = function () {
        $dialog.dialog({ dialogClass: "modal wide", templateUrl: "trading/views/tom-fees-commissions.html", controller: "TOMFeesCommissionsCtrl", resolve: { blockId: function () { return $scope.selectedIds[0]; } } }).open();
    };

    $scope.quickAllocateAll = function () {
        doAction('/Trading/FixBlockOrders/Action/Allocate', 'Allocating');
    };

    $scope.markAllComplete = function () {
        doAction('/Trading/FixBlockOrders/Action/Allocate?markComplete=true', 'Completing');
    };

    $scope.openForAllocation = function () {
        $location.path('/trading/tom/allocations/' + $scope.selectedIds[0]);
    };

    $scope.createTradeFileFromAllocation = function () {
        $http.post('/Trading/TradeFiles/CreateTradeFileFromAllocations', $scope.selectedIds, { trackerMsg: 'Generating trade file from selected allocations' })
            .then(function (response) {

            })
    };

    $scope.slickGridDoubleClick = function () {
        if ($scope.selectedIds.length === 1)
            $scope.openEditor();
    };


    $scope.openBlockMassEditDialog = function () {
        if ($scope.selectedBlocks.any({ ordType: 'Manual Order' })) {
            $dialog.messageBox('Invalid Operation', 'One or more selected blocks is set to Manual order type', 'Ok').open();
        } else {
            var dialogOpts = {
                templateUrl: "tom-blocks-mass-edit-dialog.html",
                controller: "TOMBlockMassEditCtrl",
                blockIds: $scope.selectedIds,
                blocks: $scope.selectedBlocks,
                dialogClass: "modal wide"
            };

            $dialog.dialog(dialogOpts)
                .open()
                .then(function (results) {
                    if (results) {
                        $http.put('/Trading/FixBlockOrders/UpdateEnMasse', results, { trackerMsg: 'Updating selected blocks orders en masse' })
                            .then(function (response) {
                                if (response) {
                                    const respToArray = new Map(Object.entries(response.data));
                                    const arrayOfResponseKeys = Array.from(respToArray.keys());
                                    arrayOfResponseKeys.forEach(function (block) {
                                        $scope.$broadcast('event:tom-blocks-action', { action: "refresh-grid", item: 'sgc-' + block + '-Id' });
                                        // $scope.$broadcast('event:tom-blocks-action', { action: "refresh-grid", item: 'sgr-' + block});
                                    })
                                }
                            })
                    }
                })
        }
    };
    //endregion

    //region INITIALIZE
    $scope.views = views;
    $scope.current = { productType: null, autoAllocate: false, autoRefreshInterval: 0, canDelete: false, canAllocate: false, canExecute: false, view: views[0], gridDoubleClick: $scope.slickGridDoubleClick, modificationType: null };

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: function () {
            if ($scope.selectedIds.length === 1)
                $scope.openEditor();
        }
    }];
    $scope.selectedIds = [];
    initialLoad();

    //endregion

    //region EVENT LISTENERS
    $scope.$on('event:rows-selected', function (e, args) {
        e.stopPropagation();

        if (args.length === 0) return;

        $scope.selectedIds = args.map("id");
        $scope.selectedBlocks = args;
        $scope.current.productType = args[0].productType;
        $scope.current.canDelete = $scope.current.viewType == 'open' || ($scope.current.viewType == 'unallocated' && args.all({ ordStatus: 'Not Sent' }));
    });
    //endregion
});

app.controller('TOMBlockMassEditCtrl', function TOMBlockMassEditCtrl($scope, $http, dialog) {
    //region PRIVATE VARIABLES
    //endregion

    //region PRIVATE METHODS
    function init() {
        $scope.current.custodianData = [];
        $scope.current.blockIds = dialog.options.blockIds;
        $scope.current.headerTitle = 'Mass Edit Blocks';

        var custodianIds = Array.from(new Set(dialog.options.blocks.map(m => m.custodianId))).filter(onlyUnique);
        var notSentBlocks = dialog.options.blocks.filter(f => f.ordStatus === 'Not Sent');
        $scope.current.custodianIds = custodianIds;

        if (custodianIds.length >= 1) {
            // ng-options only allows for one non-list default value on the html element, have to inject the None value here
            var noneElement = { "algorithmCode": "None" };
            for (var x = 0; x < custodianIds.length; x++) {

                let cId = custodianIds[x];
                const custodian = { custodianId: cId };
                custodian.custodianName = dialog.options.blocks.find(f => f.custodianId == cId).custodianName;
                custodian.algorithmTag = null;

                //'verbose' is a partial class...make sure to expand the base class to find what you're looking for.
                $http.get('/Portfolio/Custodians/Verbose/' + custodianIds[x] + '?expand=algorithms', { trackerMsg: 'Getting Custodian Algorithms' })
                    .then(function (response) {
                        if (response.data && response.data.algorithms.length > 0) {
                            // for ordering sake plop the None element in first
                            const algorithmTagList = [noneElement];
                            [].push.apply(algorithmTagList, response.data.algorithms.filter(function (item) {
                                return item.algorithmCode != null
                            }))
                            custodian.algorithmTagList = algorithmTagList;
                        }
                    });

                $scope.current.custodianData.push(custodian);
            }
        }

        if (notSentBlocks.length === dialog.options.blocks.length) {
            $scope.buttonText = 'Save';
        }
        else {
            $scope.buttonText = 'Save and Update';
        }
    }

    function onlyUnique(value, index, array) {
        return array.indexOf(value) === index;
    }

    //endregion

    //region PUBLIC METHODS

    $scope.close = function () {
        dialog.close(null);
    };

    $scope.save = function () {
        //modify blocks with new data;
        const cfiRecords = [];

        for (var numOfCustodians = 0; numOfCustodians < $scope.current.custodianData.length; numOfCustodians++) {
            const cfiRecord = {};

            cfiRecord.custodianId = $scope.current.custodianData[numOfCustodians].custodianId;
            cfiRecord.algorithmTag = $scope.current.custodianData[numOfCustodians].algorithmTag;
            cfiRecords.push(cfiRecord);
        }

        var tempBlockObject = {
            blockIds: $scope.current.blockIds,
            ordType: $scope.current.orderType,
            settlmntTyp: $scope.current.settlementType,
            timeInForce: $scope.current.timeInForce,
            editedBy: $scope.user.authorization.loginUserId,
            execInst: $scope.current.execInst,
            custodianInfos: cfiRecords,
            limitPrice: $scope.current.limitPrice,
            stopPrice: $scope.current.stopPrice,
            isDiscretionary: $scope.current.isDiscretionary
        };
        dialog.close(tempBlockObject);
    };

    $scope.validateOrder = function () {
        var orderType = $scope.current.orderType;
        switch (orderType) {
            case "Limit":
                $scope.current.stopPrice = 0;
                break;
            case "Stop":
                $scope.current.limitPrice = 0;
                break;
            case "Stop limit":
                break;
            default:
                $scope.current.limitPrice = 0;
                $scope.current.stopPrice = 0;
        }
    };

    //endregion

    //region INITIALIZE

    $scope.current = {
        timeInForce: null, orderType: null, settlementType: null, execInst: null, algorithmTag: null, limitPrice: null, stopPrice: null, isDiscretionary: null, blockIds: []
    };

    init()

    //endregion
});
'use strict';

app.controller('TOMFeesCommissionsCtrl', function TOMFeesCommissionsCtrl($scope, $http,$dialog, dialog, blockId) {
    //PRIVATE VARIABLES
    var fields = ['regulatory', 'tax', 'localCommission', 'exchange', 'stamp', 'levy', 'other', 'commission'];

    //PRIVATE METHODS
    function initialLoad() {
        $http.get('/Trading/FixBlockOrders/' + blockId + '/Fees', {trackerMsg: 'Loading fees & commissions for block ' + blockId})
            .then(function (response) {
                $scope.block = response.data;
                fields.forEach(function (field) {
                    $scope.calculateSum(field);
                });
                if($scope.block.details){
                    $scope.current.custodianList.add($scope.block.details.unique('custodian').map(function (c) { return {name: c.custodian, value: c.custodian}; }));
                }
            });
    }

    //PUBLIC METHODS
    $scope.close = function() {
        dialog.close();
    };

    $scope.prorateAll = function() {
        fields.forEach(function (field) {
           $scope.prorate(field);
        });
    };

    $scope.prorate = function(field) {

        var completeAction = function(){
            if (totalAmt && totalAmt > 0) {
                $scope.block.details.forEach(function (detail) {
                    //prorate All
                    if($scope.current.selectedCustodian == null ){
                        detail[field] = ((detail.orderQty / totalQty) * totalAmt).round(2);
                    }else{
                        //prorate just filtered list
                        if(detail.custodian.toLowerCase() == $scope.current.selectedCustodian.toLowerCase()){
                            detail[field] = ((detail.orderQty / totalQty) * totalAmt).round(2);
                        }
                    }
                });
                $scope.calculateSum(field);
            }
        };

        var totalAmt = parseFloat($scope.block[field]);
        var totalQty =  $scope.block.orderQty;

        //Override totalQty if filtered is applied;
        if($scope.current.selectedCustodian){
            $dialog.confirmAction("The custodian filter is applied, so not all orders for the selected block order may be visible. Are you sure you only want to prorate to the visible orders?")
                .open()
                .then(function (result) {
                    if(result == 'yes'){
                        var tempDetails =  $scope.block.details.findAll({custodian: $scope.current.selectedCustodian});
                        if(tempDetails){
                            totalQty = tempDetails.sum('orderQty');
                        }
                        completeAction();
                    }
                });
        }else{
            completeAction();
        }
    };

    $scope.calculateSum = function(field) {
        var total = 0;
        $scope.block.details.forEach(function (detail) {
            var value = parseFloat(detail[field]);
            if (value > 0)
                total += value;
            else
                detail[field] = null;
        });
        $scope.current[field] = total.round(2);
    };

    $scope.copyDown = function(field) {
        var totalAmt = parseFloat($scope.block[field]);
        if (totalAmt && totalAmt > 0) {
            $scope.block.details.forEach(function (detail) {
                if($scope.current.selectedCustodian == null ){
                    detail[field] = totalAmt.round(2);
                }else{
                    if(detail.custodian.toLowerCase() == $scope.current.selectedCustodian.toLowerCase()){
                        detail[field] = totalAmt.round(2);
                    }
                }
            });
            $scope.calculateSum(field);
            $scope.block[field] = null;
        }
    };

    $scope.save = function() {
        $http.put('/Trading/FixBlockOrders/' + blockId + '/Fees', $scope.block, {trackerMsg: 'Saving fees & commissions for block ' + blockId})
            .then(function () {
                dialog.close();
            });
    };

    $scope.resetAll = function(){
      fields.forEach(function(item){
          $scope.block.details.forEach(function(detail){
              detail[item] = null;
          });
          $scope.block[item] = null;
          $scope.current[item] = 0;
      })
    };


    //INITIALIZE
    $scope.current = {
        custodianList:[{name:'All', value:null}],
        selectedCustodian:null
    };
    initialLoad();

});
'use strict';

app.controller('FIXMessagesCtrl', function FIXMessagesCtrl($scope, $http, dialog, blockId) {
    //PRIVATE METHODS
    function initialLoad() {
        $http.get('/Trading/FixBlockOrders/' + blockId + '/FixLogs', {trackerMsg: 'Loading FIX Messages for block ' + blockId})
            .then(function (response) {
                var data = response.data;
                if (!data || data.length === 0) return;

                data.forEach(function(msg) {
                    msg.name = Date.create(msg.createdDate).formatted(true) + ' (' + msg.msgType + ')';
                });

                $scope.current.messages = data;
                $scope.current.selectedMsg = data[0];
                
                $scope.loadStatus = 'Finished';
                
            });
    }


    //PUBLIC METHODS
    $scope.close = function() {
        dialog.close();
    };


    //INITIALIZE
    $scope.current = {messages: [], selectedMsg: null};
    $scope.loadStatus = 'Loading';
    initialLoad();
});
'use strict';

app.controller('TOMOrderEditorCtrl', function TOMOrderEditorCtrl($scope, $q, $http, $oasRights, dialog, $dialog, orderId, isBlockOrder, productType, splitIoService) {
    //PRIVATE VARIABLES
    var urlPrefix;
    var originalStatus;
    var savedOrders = [];
    var originalOrder = {};
    var autoAllocateEntityOption;

    //PRIVATE METHODS
    function init() {
        $http.get(urlPrefix + orderId, {trackerMsg: 'Loading' + (isBlockOrder ? ' block ' : ' order ') + orderId})
            .then(function (response) {
                var data = response.data;
                $scope.order = data;
                $scope.current.autoAllocate = data.autoAllocate;

                originalOrder = angular.copy($scope.order);

                $scope.current.ticketName = isBlockOrder ? data.blockName : data.registrationName + ', ' + data.custodian;

                if (isBlockOrder && data.ordType === 'Manual order') {
                    $scope.current.canSend = false;
                    $scope.current.isManualBlock = true;
                    if (!$scope.order.transactTime) {
                        $scope.order.transactTime = Date.create();
                    }
                } else {
                    originalStatus = $scope.order.ordStatus;
                    $scope.current.canSend = $oasRights.canRead("FIXEXEC") && (isBlockOrder || !$scope.order.hasBlock);
                    $scope.current.isManualBlock = false;
                }

                if(isBlockOrder){
                    $http.get('/Portfolio/Custodians/Verbose/' + $scope.order.custodianId + '?expand=algorithms', {trackerMsg:'Getting Custodian Algorithms'})
                        .then(function (response) {
                            if(response.data && response.data.algorithms.length > 0){
                                $scope.algorithmTagList = response.data.algorithms.findAll(function (item) {
                                    return item.algorithmCode != null
                                });
                            }else {
                                $scope.algorithmTagList = [];
                            }

                        })
                }

                $scope.current.canAllocate = $oasRights.canRead("FIXALLOC") && (!isBlockOrder || $scope.order.ordStatus === 'Not Sent');
            });

        $http.get('/Settings/EntityOptions/Database/Code/69AUTOALLO', { trackerMsg: 'Checking auto-allocate option' })
            .then(function (response) {
                $scope.current.autoAllocate = response.data[0].value = response.data[0].value === "True";
                autoAllocateEntityOption = response.data[0];
            });


        $scope.current.showNewMessage = true;
        realTimePriceCheck();

        $scope.current.rtPricingEnabled = $oasRights.canRead("REALTIMEPRICING");

        $http.get(urlPrefix + orderId + '/RealtimePrice?includeDetails=true', {trackerMsg: 'Loading price data'})
            .then(function (response) {
                $scope.rtPrice = response.data;
            });

        if (isBlockOrder) {
            $scope.current.canEditSentStatus = $oasRights.canUpdate("CHANGESENTSTATUS");

            $http.get('/Settings/Database/EntityOptions/Code/69ALLOWEXE', {cache: true, trackerMsg: 'Checking custodian edit option'})
                .then(function (response) {
                    $scope.current.canEditCustodian = (response.data.value === "True");
                });

            $http.get('/Portfolio/Custodians/Simple?fixEnabled=true&productType=' + productType, {cache: true, trackerMsg: 'Loading custodians'})
                .then(function (response) {
                    $scope.custodians = response.data;
                });

        } else {
            $scope.current.canViewNotes = $oasRights.canRead("FIXORDERNOTES");
            $scope.current.canEditNotes = $oasRights.canUpdate("FIXORDERNOTES");
        }
    }

    function priceToUse() {
        switch ($scope.order.ordType) {
            case "Limit":
                return $scope.order.limitPrice;
            case "Stop":
            case "Stop limit":
                return $scope.order.stopPrice;
            default:
                $scope.order.navPrice = $scope.rtPrice.last;
                return $scope.rtPrice.last;
        }
    }

    function saveOrder(execute) {

        var continueWithSave = function () {
            var trackerMsg = (execute ? 'Sending ' : 'Saving ') + (isBlockOrder ? 'block ' : 'order ') + orderId;

            $scope.order.autoAllocate = $scope.current.autoAllocate;
            $http.put(urlPrefix + orderId + '?execute=' + execute + "&autoAllocate=" + $scope.current.autoAllocate, $scope.order, {trackerMsg: trackerMsg})
                .then(function (response) {
                    if (Object.isArray(response.data)) {
                        response.data.forEach(function (order) {
                            savedOrders.push(order);
                        });
                    } else {
                        savedOrders.push(response.data);
                    }
                    dialog.close(savedOrders);
                });
        };

        if ($scope.order.exchangeId && !angular.equals(originalOrder, $scope.order)) {
            $dialog.confirmAction("Changes have been made to this order, these changes will also update linked order.  Are you sure you want to proceed?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        continueWithSave();
                    }
                });
        } else {
            continueWithSave();
        }
    }

   

    function realTimePriceCheck() {

        $http.get("/Trading/QUODD/checkRealTimeStatus", { cache: false }).then(function (response) {
            switch (response.data) {
                case 0:
                case 1:
                case 2:
                case 3:
                    $scope.current.pricingMessage = 'You are viewing a 15 minute delayed quote, please go to user profile > settings > Integrations > QUODD real time snap quotes to sign up.'
                    break;
                case 4:
                    $scope.current.pricingMessage = 'Real-time quote and/or trade prices are not sourced from all markets.'
                    break;
                default:
                    $scope.current.pricingMessage = 'You are viewing a 15 minute delayed quote, please enable real-time prices at your firm and/or Role level.'
            }
        });
    }

    //PUBLIC METHODS
    $scope.close = function () {
        if (savedOrders.length == 1) {
            savedOrders.push($scope.order);
        }
        dialog.close(savedOrders);
    };

    $scope.save = function () {
        saveOrder(false);
    };

    $scope.send = function () {
        saveOrder(true);
    };

    $scope.unlinkOrder = function () {
        $dialog.confirmAction("You are about to unlink this order. This action cannot be undone!  Are you sure you want to proceed?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    var exchangeId = $scope.order.exchangeId;
                    $http.put("/Trading/Orders/Action/Unlink", [orderId], {trackerMsg: 'Un-linking order'})
                        .then(function (response) {
                            $scope.order = response.data.find({id: orderId});
                            savedOrders.push(response.data.find({id: exchangeId}));
                            
                            originalOrder = angular.copy($scope.order);
                        });
                }
            });
    };

    $scope.validateOrder = function () {
        var ordType = $scope.order.ordType;
        switch (ordType) {
            case "Limit":
                $scope.order.stopPrice = 0;
                break;
            case "Stop":
                $scope.order.limitPrice = 0;
                break;
            case "Stop limit":
                break;
            default:
                $scope.order.limitPrice = 0;
                $scope.order.stopPrice = 0;

                if (ordType === "Market"){
                    $scope.order.timeInForce = 'Day';
                }

        }

        if (isBlockOrder) {
            if (ordType === "Manual order") {
                $scope.order.transactTime = Date.create();
                $scope.order.ordStatus = "New";
            }
            else {
                $scope.order.transactTime = null;
                $scope.order.ordStatus = originalStatus;
            }
        }

        $scope.updateAmt();
    };

    $scope.updateQty = function () {
        $scope.order.orderQty = $scope.order.orderAmt / priceToUse();
    };

    $scope.updateAmt = function () {
        $scope.order.orderAmt = ($scope.order.orderQty * priceToUse()).round(2);
    };

    $scope.nsccTTypes = [
        {value: 0, name: 'Normal Purchase'},
        {value: 1, name: 'NAV'},
        {value: 2, name: 'ROA'},
        {value: 3, name: 'LOI'}
    ];

    //INITIALIZE
    $scope.current = {
        durationValues: [{name: "Day (default)", value: "Day"}, {name: "Good Till Cancel (GTC)", value: "GTC - Good Till Cancel"},{name: 'At the Close', value:'At the Close'}],
        unLinkOrder: false,
        isBlockOrder: isBlockOrder,
        isManualBlock: true,
        rtPricingEnabled: false,
        canAllocate: false,
        autoAllocate: false,
        canSend: false,
        canEditCustodian: false,
        canViewNotes: false,
        canEditNotes: false
    };
    $scope.qualifiers = ['DNR - Do not reduce', 'AON - All or none'];  //this list is set in code so that the null-"None" option works correctly
    urlPrefix = isBlockOrder ? '/Trading/FixBlockOrders/' : '/Trading/Orders/';
    
    init();
});
'use strict';

var tomUnblockedOrdersCtrl = app.controller('TOMUnblockedOrdersCtrl', function TOMUnblockedOrdersCtrl($rootScope, $scope, $location, $http, $routeParams, $timeout, $q, $dialog, $tradeGenerator, $tactical, views, defaultSettings, $oasRights, API_CONFIG, entities, searchResult, splitIoService) {

    //PRIVATE VARIABLES
    var selectedAccountIds;
    var selectedExchangeIds;
    var selectedRegId;
    var regLevelRebalanceSelectedIds;

    //PRIVATE METHODS
    function initialLoad() {
        $scope.current.canProcess = $oasRights.canUpdate("EXECTRADES");
        $scope.current.canTactical = $oasRights.canRead("TRADETACTICAL");
        $scope.current.canEnableAllOrders = $oasRights.canRead("ENABLEALLORDERS");
        $scope.current.canDeleteAllOrders = $oasRights.canRead("DELETEALLORDERS");
        $scope.current.canExportTRX = $oasRights.canRead("TRXEXPORT");
        $scope.rightsInstances = $oasRights.forCode("TRADEINSTANCES");
        $scope.current.hasCommunityPortalRights = $oasRights.forCode('COMMUNITIES');

        if ($oasRights.canUpdate("MSCSREINVESTASSET")) {
            $http.get("/Settings/EntityOptions/Database/Code/3:69MATRIX", {cache: true, trackerMsg: 'Loading reinvest settings'})
                .then(function (response) {
                    var data = response.data;
                    $scope.current.canEditReinvestOptions = data[0].value.toLowerCase() === "true";
                });
        }

        $http.get('/Reporting/Reports?menu=fixorder.unblocked', {cache: true, trackerMsg: 'Loading trade order reports'})
            .then(function (response) {
                var data = response.data;
                $scope.current.reports = data;
            });

        $http.get('/Settings/UserOptions/trading_round_value?defaultValue=5', {trackerMsg: 'Loading default rounding value'})
            .then(function (response) {
                var data = response.data;
                $scope.current.roundingValue = parseInt(data.value);
            });

        $http.get("/Settings/EntityOptions/Database/0/code/5:69DEFAUL",  {cache: true, trackerMsg: 'Loading default for Pending'})
            .then(function (response) {
                $scope.tradeImporter.pendingValue.assetValues = response.data.value.toLowerCase() === "true" ? 1 : 0;
            });

        $http.get("/Settings/Database/EntityOptions/Code/69FIXMUTUA",  {cache: true, trackerMsg: 'Loading default for Fix Mutual Funds'})
            .then(function (response) {
                $http.get('/Portfolio/Custodians/Simple?fix44=true', {cache: true, trackerMsg:'Getting Fix version'})
                    .then(function (responseFix) {
                        $scope.current.fixMutualFundBatchEnabled = response.data.value.toLowerCase() === 'block only' && responseFix.data.length > 0;
                        $http.get("/Trading/Orders/GetFIXMutualFundsNotSent",  {cache: false, trackerMsg: 'Getting number of Fix Mutual Fund Batches'})
                            .then(function (response) {
                                $scope.current.fixMutualFundBatchCount = response.data.length;
                            });
                    })
            });

        $http.get('/Utility/PageQueries?pageCode=OrderDto', {cache: true, trackerMsg: 'Loading trade order queries'})
            .then(function (response) {
                var data = response.data;
                data.forEach(function (query) {
                    query.isPageQuery = true;
                });

                $scope.current.gridQueries = data;
                var gridQueryFilterTolerance = {
                    id: 'modelAnalyzerFilter',
                    name: 'Model Analyzer Filter',
                    description: 'Model Analyzer Filter',
                    field: 'accountNumber',
                    itemCount: 1,
                    parameters: [{
                        code: "@Parameter1",
                        description: "",
                        name: "Account Number",
                        promptUser: false,
                        value: 0
                    }]
                };
                $scope.current.gridQueries.push(gridQueryFilterTolerance);
            });

        $scope.current.communityUrl = createCommunityUrl();
    }

    function doAction(actionUrl, msgVerb, confirmMsg) {

        $dialog.confirmAction((confirmMsg ? confirmMsg : '') + "  This will affect all applicable orders regardless of the current view or enabled filters.  Are you sure you want to proceed?")
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.put(actionUrl, null, {trackerMsg: msgVerb + ' all orders'})
                        .then(function (response) {
                            $scope.$broadcast('event:tom-orders-action', {action: 'refresh-grid'});
                        });
                }
            });
    }

    function loadAnalyzer(forceRender) {
        $timeout(function () {
            $scope.$broadcast('event:refresh-analyzer', {analyzer: $scope.analyzer, action:'load-analyzer', forceRefresh:forceRender, includePendingValue:true});
        });
    }

    function loadModelsWithOrdersDropdown() {
        $http.get('/Trading/ModelAggs/Simple?withOrders=true', {trackerMsg: 'Loading model list with orders..'})
            .then(function (response) {
                var data = response.data;
                $scope.modelsWithOrdersList = data;
            });
    }

    function calculateModelTolerance(productList) {
        productList.forEach(function (item) {
            item.assetSummary.forEach(function (accountItem) {
                accountItem.isOutOfTolerance = Math.abs(accountItem.postTradePercent - accountItem.targetPercent) > accountItem.itemToleranceLower;
            });
            item.isOutOfTolerance = item.assetSummary.any({isOutOfTolerance: true});
            item.isCellEdit = false;
        });

    }

    function enableFixIncomeTrades() {
        // this function returns true when: side = Buy and ticker is Bond_Asset || side = sell and account numbers are the same
        return $scope.selectedOrders.every({side: 'Buy'}) && $scope.selectedOrders.every({ticker: 'BOND_ASSET'}) ||
            $scope.selectedOrders.every({side: 'Sell'}) && $scope.selectedOrders.every({accountNumber: $scope.selectedOrders[0].accountNumber});
    }

    function canEditOrder(order){
        //rights to edit
        if($oasRights.canUpdate("FIXTRADING")){
            //if order status is approved, in certain db's advisor and reps (only if set) can edit order
            if(order.approvalStatus == 'Approved'){
                return ($oasRights.canUpdate("EDITAPPROVEDTRADES"));
            }
            //
            return true;
        }
        //can't edit
        return false;
    }

    function getCustodianCutOffTime(ids){
        $http.put('/Portfolio/Custodians/CheckCutoffTimes', ids, {trackerMsg:'Verifying Custodian cut-off times'})
            .then(function (response) {
                if(response.data && response.data.length > 0){
                    $scope.current.custodianMsg = '';
                    response.data.forEach(function (item) {
                        $scope.current.custodianMsg += item.errorMessage + '<br>';
                    });
                    $scope.current.custodianMsg += 'Mutual fund orders sent after the custodial cutoff time will not be sent until the following business day.' + '<br>' +
                                                    "Are you sure you want to proceed?";
                }else{
                    $scope.current.custodianMsg = null;
                }
            })
    }

    function processAllOrders(orders) {

        var executeProcess = function () {
            doAction('/trading/orders/action/createblocks', 'Processing');
        };

        var mfOrders = orders.findAll({productType: 'Mutual Fund'});
        if(mfOrders.length > 0){
            $http.put('/Portfolio/Custodians/CheckCutoffTimes', mfOrders.map('custodianId').unique(), {trackerMsg:'Verifying Custodian cut-off times'})
                .then(function (response) {
                    if(response.data && response.data.length > 0){
                        var msg = '';
                        response.data.forEach(function (item) {
                            msg += item.errorMessage + '<br>';
                        });
                        msg += 'Mutual fund orders sent after the custodial cutoff time will not be sent until the following business day.' + '<br>' +
                            "Are you sure you want to proceed?";
                        $dialog.confirmAction(msg).open()
                            .then(function (result) {
                                if (result === 'yes'){
                                    executeProcess();
                                }
                            })
                    }else{
                        executeProcess();
                    }
                })
        }else {
            executeProcess();
        }
    }

    function createCommunityUrl() {
        return API_CONFIG.orionElementWebCommunitiesUrl + sessionStorage.oas_token;
    }



    //PUBLIC METHODS

    $scope.getFixMutualFunds = function () {
        var openBlocksNotSentEditor = function (blockData) {
            // if side=buy, then make sure all tickers are bond_assets otherwise skip
            var d = $dialog.editor('fix-mutual-funds-blocks-not-sent.html', 'TOMUnblockedOrdersFixMutualFundBlocksNotSent', {
                args: function () {
                    return {blocksNotSent: blockData};
                }
            });
            d.open().then(function (rslt) {
                if (rslt) {
                    $http.put('/Trading/FixBlockOrders/Action/Execute', rslt, {trackerMsg:'Sending Blocks'})
                        .then(function (response) {
                            var t = response.data;
                            loadOrdersAwaitingAcceptance(splitIoService);
                        })
                }
            });
        };

        $http.get("/Trading/Orders/GetFIXMutualFundsNotSent",  {cache: false, trackerMsg: 'Loading Fix Mutual Funds'})
            .then(function (response) {
                openBlocksNotSentEditor(response.data);
            });
    };

    $scope.exportTRX = function(){
        $http.put('/Integrations/TRX/Action/Schedule', {trackerMsg:'Scheduling TRX export'})
            .then(function (response) {
                $dialog.messageBox('TRX Export', 'Success!  TRX Export Scheduled.').open()
            })
    };

    $scope.reCalcTolerance = function (product) {
        $scope.modelAnalyzer.data.productSummary.forEach(function (product) {
            product.assetSummary.forEach(function (accountItem) {
                accountItem.isOutOfTolerance = Math.abs(accountItem.postTradePercent - accountItem.targetPercent) > ($scope.current.toleranceBand * accountItem.targetPercent) / 100
            });
            product.isOutOfTolerance = product.assetSummary.any({isOutOfTolerance: true});
        });
    };

    $scope.editCellTolerance = function (product) {
        product.isCellEdit = true;
    };

    $scope.setTolerance = function (product) {
        product.isCellEdit = false;
    };

    $scope.analyzeModel = function (refresh) {

        if(refresh) {
            $scope.modelAnalyzer.data = null;
            $scope.current.product = null;
            //this will unselect the current row.
            $scope.productSelectedRow.productSummary = null;
            $scope.productSelectedRow.excludedSummary = null;
        }

        //if user un-checks exclude assets and does a refresh; set it back to productSummary
        if(!$scope.current.modelAnalyzerOptions.excludeAssets){
            $scope.current.modelAnalyzerOptions.mode = 'productSummary';
        }

        var queryStringParameters =  $scope.current.modelAnalyzerOptions.includeCostBasis ? '?includeCostBasis=true' : '?includeCostBasis=false';
        queryStringParameters +=  $scope.current.modelAnalyzerOptions.includeTradeBlockedAccounts ? '&includeTradeBlockedAccounts=true' : '&includeTradeBlockedAccounts=false';
        queryStringParameters +=  $scope.current.modelAnalyzerOptions.excludeAssets ? '&includeExcludedAssets=true' : '&includeExcludedAssets=false';

        $http.get('/Trading/ModelAnalyzer/ModelAggs/' + $scope.current.selectedModelAggId + queryStringParameters, {trackerMsg: 'Generating Model Analysis'})
            .then(function (response) {
                var data = response.data;
                calculateModelTolerance(data[$scope.current.modelAnalyzerOptions.mode]);
                $scope.modelAnalyzer.data = data;
            })
    };

    $scope.setClickedRow = function (product, index, forceUpdate) {  //function that sets the value of selectedRow to current index for a given mode

        if($scope.current.modelAnalyzerOptions.mode == 'productSummary'){
            if ($scope.productSelectedRow.productSummary == index && !forceUpdate) {
                $scope.productSelectedRow.productSummary = null;
                $scope.current.product = null;
            } else {
                $scope.productSelectedRow.productSummary = index;
                $scope.current.product = product;
            }
        }else{
            if ($scope.productSelectedRow.excludedSummary == index && !forceUpdate) {
                $scope.productSelectedRow.excludedSummary = null;
                $scope.current.product = null;
            } else {
                $scope.productSelectedRow.excludedSummary = index;
                $scope.current.product = product;
            }
        }
    };

    $scope.setCurrentProductRow = function(){

        $scope.productSelectedRow.productSummary = null;
        $scope.productSelectedRow.excludedSummary = null;
        $scope.current.product = null;

        //this is when a user pickes the model analyzer or model exclusion raido button.
        //function grabs the correct assets for product picked
        if($scope.productSelectedRow[$scope.current.modelAnalyzerOptions.mode]) {
            $scope.setClickedRow($scope.modelAnalyzer.data[$scope.current.modelAnalyzerOptions.mode][$scope.productSelectedRow[$scope.current.modelAnalyzerOptions.mode]], $scope.productSelectedRow[$scope.current.modelAnalyzerOptions.mode], true);
        }
    };

    $scope.setClickedRowAccount = function (account, index) {
        var gridQuery = $scope.current.gridQueries.find({id: 'modelAnalyzerFilter'});
        if ($scope.accountSelectedRow == index) {
            $scope.accountSelectedRow = null;
            gridQuery.enabled = false;
        } else {
            $scope.accountSelectedRow = index;
            gridQuery.name = account.accountNumber + ' Filter';
            gridQuery.filterFn = function (x) {
                return x === account.accountNumber;
            };
            gridQuery.enabled = true;
        }
    };

    $scope.takeToTactical = function (level) {
        var ids = level === 'account' ? selectedAccountIds : selectedRegId;
        $tactical.start(level, ids, true);

    };

    $scope.refreshGrid = function () {
        $scope.$broadcast('event:tom-orders-action', {action: 'refresh-grid'});
    };

    $scope.processAll = function () {
        $timeout(function () {
            $scope.$broadcast('event:tom-orders-action', {action: 'get-items'});
        },100);
    };

    $scope.enableAll = function () {
        doAction('/trading/orders/action/enable', 'Enabling');
    };

    $scope.disableAll = function () {
        doAction('/trading/orders/action/disable', 'Disabling');
    };

    $scope.deleteAll = function () {
        doAction('/trading/orders/action/delete', 'Deleting');
    };

    $scope.deleteSelectedOrders = function () {
        var deleteSelectedOrders = function () {
            if ($scope.selectedIds.length > 0) {
                $http.put('/trading/orders/action/delete', $scope.selectedIds, {trackerMsg: 'Deleting selected orders'})
                    .then(function (response) {
                        var data = response.data;
                        $scope.$broadcast('event:tom-orders-action', {action: 'delete-items', items: data.deletedIds});
                        $scope.$broadcast('event:tom-orders-action', {action: 'update-items', items: data.updatedItems});
                        loadAnalyzer(true);
                    });
            }
        };

        if (regLevelRebalanceSelectedIds.length || selectedExchangeIds.length) {
            $dialog.confirmAction(regLevelRebalanceSelectedIds.length ? "All orders for the registration-level rebalance will be deleted, you will need to re-run the rebalance." : "One or more of the selected orders are linked with an exchange Id, continuing with this action will also delete the linked orders." + " Are you sure you want to proceed?")
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        deleteSelectedOrders();
                    }
                });
        }
        else {
            deleteSelectedOrders();
        }
    };

    $scope.sortModelAnalyzer = function (field) {
        var fieldName;
        if (field == 'groupName') {
            fieldName = field;
        } else {
            switch ($scope.modelAnalyzer.tableMode) {
                case "percent":
                    fieldName = field + "Percent";
                    break;
                case "dollars":
                    fieldName = field + "Value";
                    break;
                case "shares":
                    fieldName = field + "Shares";
                    break;
            }
        }
        $scope.modelAnalyzer.sortField = fieldName;
        $scope.modelAnalyzer.sortReverse = !$scope.modelAnalyzer.sortReverse;
    };

    $scope.deleteZeroSharesAll = function () {
        doAction('/Trading/Orders/Action/DeleteZeroQuantity', 'Deleting zero qty shares on');
    };

    $scope.roundSharesAll = function () {
        doAction('/Trading/Orders/Action/RoundQuantity/' + $scope.current.roundingValue, 'Rounding shares on', 'Rounding could cause orders to overspend cash.');
    };

    $scope.refreshPricesAll = function () {
        doAction('/Trading/Orders/Action/RefreshPrices', 'Refreshing prices on');
    };

    $scope.calcGainLoss = function () {
        doAction('/trading/orders/action/CalculateGainLoss', 'Calculating gain/loss on');
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:tom-orders-action', {action: 'export-data'});
    };

    $scope.runReport = function (reportId) {
        var reportArgs = {};
        if ($scope.selectedIds.length > 0) {
            reportArgs.OrderIDs = $scope.selectedIds.join(",");
        }
        if ($scope.selectedInstanceIds.length > 0) {
            reportArgs.PkTRInstance = $scope.selectedInstanceIds.unique();
        }
        $dialog.reportPrompt(reportId, reportArgs).open();
    };

    $scope.toggleGridQuery = function (query) {
        if (query.enabled) {
            query.enabled = false;
            //if the query is the code:'modelAnalyer', this property is not set on any other object, then check if user clicked on a account row.
            if (query.code && $scope.accountSelectedRow) {
                $scope.accountSelectedRow = null
            }
        }
        else
            $http.post('/Utility/PageQueries/' + query.id + '/Results', query, {trackerMsg: 'Loading query ' + query.name})
                .then(function (response) {
                    var data = response.data;
                    query.field = "id";
                    query.filterFn = function (x) {
                        for (var i = data.length - 1; i >= 0; i--) {
                            if (data[i] == x) return true;
                        }
                        return false;
                    };
                    query.itemCount = data.length;
                    query.enabled = true;
                });
    };

    $scope.openEditor = function () {
        $dialog.dialog({
            templateUrl: "trading/views/tom-order-editor.html",
            controller: "TOMOrderEditorCtrl",
            resolve: {orderId: function () {return $scope.selectedIds[0];}, isBlockOrder: function () {return false;}, productType: function () {return $scope.current.productType}}
        })
        .open()
        .then(function (savedOrder) {
            if (savedOrder) {
                savedOrder.forEach(function (order) {
                    $scope.$broadcast('event:tom-orders-action', {action: savedOrder.hasBlock ? "delete-item" : "update-item", item: order});
                });
                loadAnalyzer(true);
            }
        });
    };

    $scope.toggleFixOnly = function () {
        $scope.current.fixOnly = !$scope.current.fixOnly;
        $scope.current.optionsOpen = false;
        $timeout(function () {
            $scope.$broadcast('event:tom-orders-action', {action: 'refresh-grid'});
        });
    };

    $scope.generateFromImport = function () {
        var validQuickTrades = $scope.tradeImporter.trades.findAll( function ( item ){
            return ((item.action.toLowerCase().trim() === 'sell' || item.action.toLowerCase().trim() === 'buy') && item.isValid )
        });

        var validExchangeTrades = $scope.tradeImporter.trades.findAll( {isValid: true, action: "exchange"} )
            .map(function (item) {
                return {accountID: item.accountId, productIDFrom: item.productId , productIDTo: item.exchangeProductId, amount: item.amount, tradeType: item.tradeType };
            });

        var importPromise;

        if (validExchangeTrades.length > 0 ) {
            var assetPromises = [];
            validQuickTrades.forEach(function (quickTrade) {
                var promise = $http.get('/Portfolio/Accounts/' + quickTrade.accountId + '/Assets?isSweepAsset=true', {cache: true, trackerMsg: 'Loading sweep asset'})
                    .then(function ( response ) {
                        var sweepAsset = response.data[0];
                        var exchangeTrade = {accountID: quickTrade.accountId, tradeType: quickTrade.tradeType};

                        if (quickTrade.action === "buy") {
                            exchangeTrade.assetIDFrom = sweepAsset.id;
                            exchangeTrade.assetIDTo = null;
                            exchangeTrade.productIDFrom = sweepAsset.productId;
                            exchangeTrade.productIDTo = quickTrade.productId;
                        } else if (quickTrade.action === "sell") {
                            exchangeTrade.assetIDFrom = null;
                            exchangeTrade.assetIDTo = sweepAsset.id;
                            exchangeTrade.productIDFrom = quickTrade.productId;
                            exchangeTrade.productIDTo = sweepAsset.productId;
                            exchangeTrade.amount = quickTrade.amount;
                        }
                        validExchangeTrades.push(exchangeTrade);

                        if (quickTrade.action === 'buy') {
                            return $http.get('/Trading/Products/' + quickTrade.ticker + '/RealtimePrice', {trackerMsg: 'Loading price data'} )
                                .then(function (response) {
                                    exchangeTrade.amount = quickTrade.tradeType === "Dollars" ? quickTrade.amount : quickTrade.amount * response.data.last;
                                });
                        }
                    });

                assetPromises.push(promise);
            });

            importPromise = $q.all(assetPromises)
                .then(function () {
                    return $tradeGenerator.importExchange( validExchangeTrades, $scope.tradeImporter.nsccTransactionType );
                });
        } else {
            importPromise = $tradeGenerator.importTrades( $scope.current.assetValue, validQuickTrades, $scope.tradeImporter.fileName);
        }

        $scope.current.generatingFromImport = true;

        importPromise
            .then(function () {
                $scope.resetImport();
            })
            .catch(function () {
                $scope.current.generatingFromImport = false;
            });
    };

    $scope.resetImport = function () {
        $scope.tradeImporter.trades = null;
        $scope.current.generatingFromImport = false;
        $scope.resetWidth(false);
    };

    $scope.resetWidth = function (goWide) {
        $scope.rightSidebar.width = goWide ? 600 : 250;
    };

    $scope.enableModelAnalyzer = function () {
        $scope.rightSidebar.width = 750;
        if ($scope.modelsWithOrdersList) {

        }
        loadModelsWithOrdersDropdown();
    };

    $scope.enableAnalyzer = function () {
        $scope.resetWidth(true);
        $scope.analyzer.isActiveTab = true; //forcing it early in the digest
        loadAnalyzer(true);
    };

    $scope.openReinvestOptionEditor = function () {
        $dialog.dialog({templateUrl: "reinvest-option-editor.html", controller: "ReinvestOptionEditorCtrl", orderIds: $scope.selectedIds, order: $scope.current.selectedOrder})
            .open()
            .then(function (result) {
                if (!result) return;

                if (result.length === 0) {
                    $dialog.messageBox("<i class='fa fa-exclamation-circle fa-lg text-error' aria-hidden='true'></i> Incomplete Action", "None of the selected rows meet the criteria for this action.").open();
                } else {
                    $scope.$broadcast('event:tom-orders-action', {action: 'update-items', items: result});

                    var remaining = $scope.selectedIds.length - result.length;
                    if (remaining > 0) {
                        $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Partial Completion", remaining + " of the " + $scope.selectedIds.length + " selected row(s) did not meet the criteria for this action.").open();
                    }
                }
            });
    };

    $scope.openFixedIncomeTradesSelector = function (action) {
        // if side=buy, then make sure all tickers are bond_assets otherwise skip
        var d = $dialog.editor('tom-order-fixed-income-trades-selector.html', 'TOMUnblockedOrdersFixedIncomeTrades', {
            args: function () {
                return {orders: $scope.selectedOrders};
            }
        });
        d.open().then(function (rslt) {
            if (rslt) {
                $http.put('/Trading/Orders/NewFixedIncomeTrades', rslt, {trackerMsg: 'Updating Orders...'})
                    .then(function (response) {
                        $scope.$broadcast('event:tom-orders-action', {action: 'delete-items', items: $scope.selectedOrders.map('id')});
                        $scope.$broadcast('event:tom-orders-action', {action: 'add-items', items: response.data});
                    })
            } else {
                //set 'selected' property, if exists on object, to false.  This is necessary when using listsection.dataItems, it clears off the selected=true so row won't be hilighted after a cancel.
                $scope.selectedOrders.every(function (x) {
                    if (x.selected == true) x = false;
                })
            }
        });
    };

    $scope.openLotSelector = function () {
        var d = $dialog.editor('tom-order-lot-selector.html', 'TOMUnblockedOrdersLotsCtrl', {
            args: function () {
                return {order: $scope.current.selectedOrder};
            }
        });
        d.open().then(function (rslt) {
            if (rslt) {
                //update the order, call endpoint to generate new order lots and update grid.
                $http.put('/trading/orders/' + $scope.current.selectedOrder.id + '/splitByLots', rslt, {trackerMsg: 'Updating order lot information'})
                    .then(function (response) {
                        $scope.$broadcast('event:tom-orders-action', {action: 'refresh-grid'});
                    })
            }
        });
    };

    $scope.rebuildOrderLot = function () {
        $http.put('/trading/orders/action/rebuildOrderFromSplit', $scope.current.selectedOrder.id, {trackerMsg: 'Reverting Order ' + $scope.current.selectedOrder.id + ' lots to original state'})
            .then(function (response) {
                $scope.$broadcast('event:tom-orders-action', {action: 'refresh-grid'});
            })
    };

    $scope.slickGridDoubleClick = function() {
        if($scope.selectedIds.length === 1)
            $scope.openEditor();
    };

    $scope.processSelected = function() {
        var executeBlocks = function () {
            var ids = $scope.selectedOrders.map('id');
            $http.put('/trading/orders/action/createblocks', ids, {trackerMsg: 'Creating Blocks'})
                .then(function (response) {
                    $tradeGenerator.startPolling(response.data.batchId, true);
                    $scope.$on('event:blocks-success', function () {

                    });
                    $scope.$on('event:blocks-error', function (e, args) {
                        $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Process Error", "There was an error creating blocks").open();
                    });
                    $scope.$broadcast('event:tom-orders-action', {action: 'delete-items', items: response.data.orderIds});
                });
        };

        var mfOrders = $scope.selectedOrders.findAll({productType: 'Mutual Fund'});
        if(mfOrders.length > 0){
            $http.put('/Portfolio/Custodians/CheckCutoffTimes', mfOrders.map('custodianId').unique(), {trackerMsg:'Verifying Custodian cut-off times'})
                .then(function (response) {
                    if(response.data && response.data.length > 0){
                        var msg = '';
                        response.data.forEach(function (item) {
                            msg += item.errorMessage + '<br>';
                        });
                        msg += 'Mutual fund orders sent after the custodial cutoff time will not be sent until the following business day.' + '<br>' +
                            "Are you sure you want to proceed?";
                        $dialog.confirmAction(msg).open()
                            .then(function (result) {
                                if (result === 'yes'){
                                    executeBlocks();
                                }
                            })
                    }else{
                        executeBlocks();
                    }
                })
        }else {
            executeBlocks();
        }
    };

    //INITIALIZE
    $scope.views = views;
    $scope.current = {
        fixMutualFundBatchCount: 0,
        fixMutualFundBatchEnabled:false,
        fixMutualFundsList: null,
        fixTradingEnabled: true,
        fixIncomeTradesEnabled: false,
        canProcessLots: false,
        selectedOrder: null,
        toleranceBand: 0,
        toleranceEditMode: false,
        selectedModelAggId: null,
        product: null,
        roundingValue: 0,
        fixOnly: false,
        canEditReinvestOptions: false,
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        generatingFromImport: false,
        gridQueries: [],
        usingTrxModelTolerance: defaultSettings.usingTrxModelTolerance.toLocaleLowerCase() == "true",
        tradeInstanceId: $routeParams.tradeInstanceId ? $routeParams.tradeInstanceId : null,
        includeBlocks: $routeParams.fromTradeQueue ? null : false,
        entity: searchResult ? searchResult.entity : $routeParams.entity,
        entityId: searchResult ? searchResult.item.id : $routeParams.entityId,
        modelAnalyzerOptions: {includeCostBasis:true, includeTradeBlockedAccounts:true, excludeAssets:false, mode:'productSummary'},
        hasCommunityPortalRights:false,
        communityUrl: null

    };
    $scope.tradeImporter = {trades: null, pendingValue: {assetValues: 0 }};
    $scope.trxModelTolerance = {selectedHousehold: null, availableHouseholds: []};
    $scope.selectedIds = [];
    $scope.selectedInstanceIds = [];
    $scope.modelAnalyzer = {
        data: null,
        groupingType: "0",
        tableMode: "percent",
        lastAnalyzedId: 0,
        height: 400,
        sortField: '',
        sortReverse: false,
        account: {id: 0, accountNumber: "", registrationName: "", accountType: "", assets: []},
        isActiveTab: false
    };
    $scope.analyzer = {
        groupingType: "0",
        tableMode: "percent",
        usePendingValue:'pending',
        lastAnalyzedId: 0,
        height: 400,
        sortField: '',
        sortReverse: false,
        account: {id: 0, accountNumber: "", registrationName: "", accountType: "", assets: []},
        isActiveTab: false
    };
    $scope.analyzer.groupingType = $scope.current.usingTrxModelTolerance ? "81" : "0";
    $scope.analyzer.chart = {
        options: {
            chart: {type: 'bar', borderWidth: 0},
            credits: {enabled: false},
            legend: {enabled: true, borderWidth: 0},
            xAxis: {
                categories: [], labels: {
                    formatter: function () {
                        return this.value.length > 6 ? this.value.first(3) + "..." : this.value;
                    }
                }
            },
            yAxis: {
                title: {text: ''}, labels: {
                    formatter: function () {
                        return this.value === 0 ? 'Target' : this.value + ' %';
                    }
                }
            },
            plotOptions: {bar: {grouping: false, shadow: false, pointPadding: 0}},
            tooltip: {
                formatter: function () {
                    var chart = this.points[0].series.chart;
                    var categories = chart.xAxis[0].categories;
                    var index = 0, temp = {};

                    while (this.x !== categories[index]) {
                        index++;
                    }
                    chart.series.forEach(function (series) {
                        temp[series.name] = series.yData[index];
                    });

                    var target = temp['Target'].round(2);
                    var bottom = (temp['Target'] + temp['Lower']).round(2);
                    var top = (temp['Target'] + temp['Upper']).round(2);
                    var range = bottom === target && top === target ? '' : '<br/>Range: ' + bottom + ' - ' + top + ' %';

                    return '<b>' + this.x + '<br/>Target: ' + target + ' %' + range + '<br/>Post Trade: ' + (target + temp['Post Trade']).round(2) + ' %';
                },
                shared: true,
                shadow: false,
                borderColor: "#CCCCCC"
            }
        },
        series: [
            {data: [], name: 'Lower', borderColor: "#00AEEF", color: "rgba(0, 170, 239, 0.1)"},
            {data: [], name: 'Upper', borderColor: "#00AEEF", color: "rgba(0, 170, 239, 0.1)"},
            {data: [], name: 'Post Trade', borderColor: "#00AEEF", color: '#00AEEF', pointPadding: 0.2},
            {data: [], name: 'Target', visible: false, showInLegend: false}
        ],
        title: {text: 'Model Tolerance'},
        subtitle: {text: null}
    };

    $scope.current.hotKeyActions = [{ combo:'ALT+E', command: function(){
        if($scope.selectedIds.length === 1)
            $scope.openEditor();
    }}];
    $scope.productSelectedRow = {productSummary:null, excludedSummary: null};  // initialize our variable to null
    $scope.accountSelectedRow = null;



    initialLoad();

    //EVENT LISTENERS
    $scope.$on('event:cell-edit', function (e) {
        e.stopPropagation();
        loadAnalyzer(true);
    });

    $scope.$on('event:grid-action', function (e, args) {
        e.stopPropagation();
        if (args.action !== "delete") return;

        loadAnalyzer(true);
    });

    $scope.$on('event:grid-timeout', function (e, args) {
        e.stopPropagation();

        var message = "The orders are loading slowly due to high volume or network congestion.  You may continue loading or go to the Instances tab (hint: loading the orders by instance may help speed things along).";
        $dialog.messageBox('<i class="fa fa-frown-o fa-lg" aria-hidden="true"></i> 504 - Timeout', message, [{
                result: 'continue',
                label: 'Continue Loading',
                cssClass: 'btn-primary'
            }, {result: 'instances', label: 'Go to Instances', cssClass: 'btn-success'}])
            .open()
            .then(function (result) {
                if (result === "continue") {
                    $scope.$broadcast('event:tom-orders-action', angular.extend(args, {action: 'continue-load'}));
                } else {
                    $location.path('/trading/instances');
                }
            });
    });

    $scope.$on('event:rows-selected', function (e, args) {
        e.stopPropagation();
        if (args.length === 0) return;

        var order = args.last();
        $scope.selectedOrders = args;
        $scope.current.fixIncomeTradesEnabled = enableFixIncomeTrades();
        $scope.current.selectedOrder = args[0];
        $scope.current.canProcessLots = args[0].assetCostCustodianId == null;
        $scope.current.productType = args[0].productType;

        $scope.current.canEdit = canEditOrder(order);
        selectedExchangeIds = args.map("exchangeId").unique().compact();
        selectedAccountIds = args.map("accountId").unique();
        regLevelRebalanceSelectedIds = args.findAll({rebalanceLevel: entities.registration.name}).map("id");
        selectedRegId = args.map("registrationId");

        $scope.current.instanceUrl = null;
        $scope.selectedInstanceIds = args.map("trInstanceId");
        if ($scope.selectedInstanceIds && $scope.selectedInstanceIds.length == 1) {
            $scope.current.instanceUrl = window.location.protocol + "//" + window.location.host + window.location.pathname.replace("index.html", "") + "integration.html?p=" + encodeURIComponent("/trading/instances?instanceId=" + $scope.selectedInstanceIds[0]);
        }

        if (order.accountId !== $scope.analyzer.account.id) {
            $scope.analyzer.account.id = order.accountId;
            $scope.analyzer.account.accountNumber = order.accountNumber;
            $scope.analyzer.account.registrationName = order.registrationName;
            $scope.analyzer.account.accountType = order.accountType;
            $scope.analyzer.account.assets = [];
            loadAnalyzer(false);
        }

        // find any orders that are mutual funds and check the custodian cut-off time;
        var mfOrders = $scope.selectedOrders.findAll({productType:'Mutual Fund'});
        if(mfOrders.length > 0){
            getCustodianCutOffTime(mfOrders.map('custodianId').unique())
        }
    });

    $scope.$on('slickgrid-getitems', function(event, data){
        processAllOrders(data);
    });

    //SCOPE WATCHERS
    $scope.$watch("analyzer.groupingType", function (newValue, oldValue) {
        //had to use a watch because ng-click on a btn-radio acts weird
        if (newValue === oldValue) return;

        loadAnalyzer(true);
    });

});

tomUnblockedOrdersCtrl.loadUnblockedOrderDefaults = ["$http", function ($http) {
    return $http.get('/Settings/EntityOptions/Database/0/code/69USETRXMO', {cache: true, trackerMsg: 'Loading model tolerance settings'}).then(function (response) {
        return {usingTrxModelTolerance: response.data.value}
    });
}];

app.controller('ReinvestOptionEditorCtrl', function ReinvestOptionEditorCtrl($scope, $http, dialog) {
    // PUBLIC METHODS
    $scope.update = function () {
        $http.put("/Trading/Orders/Action/UpdateReinvest?" + Object.toQueryString($scope.current), dialog.options.orderIds, {trackerMsg: 'Updating reinvest options'})
            .then(function (response) {
                var data = response.data;
                dialog.close(data);
            });
    };

    $scope.cancel = function () {
        dialog.close();
    };


    function init() {
        $scope.current.reinvestDividends = dialog.options.order.reinvestDividends;
        $scope.current.reinvestLTCapGains = dialog.options.order.reinvestLTCapGains;
        $scope.current.reinvestSTCapGains = dialog.options.order.reinvestSTCapGains;

        $scope.current.canUpdate = dialog.options.order.assetId == null || dialog.options.order.assetId == 0;

    }

    // INITIALIZE
    $scope.current = {
        message: 'Orders for existing assets cannot be updated',
        canUpdate: false,
        reinvestDividends: false,
        reinvestSTCapGains: false,
        reinvestLTCapGains: false
    };

    init();
});

tomUnblockedOrdersCtrl.loadSearchForOrders = ["$http", "$route", "$portfolio", "entities", function ($http, $route, $portfolio, entities) {
    if ($route.current.params.entity) {
        return null;
    } else {
        return $http.get("/Settings/EntityOptions/Database/0/code/69TOMFORCE", {cache: true, trackerMsg: 'Loading search setting'})
            .then(function (response) {
                return response.data.value == "True" ? $portfolio.search(entities.account.value) : null;
            });
    }
}];

app.controller('TOMUnblockedOrdersLotsCtrl', function TOMUnblockedOrdersLotsCtrl($http, $scope, $route, dialog, args, listSectionData) {
    //PRIVATE VARIABLES
    var accountId = args.order.accountId;
    var dataItemsEvent = "event: data-items";

    $scope.orderLotConfig = {
        getUrl: null,       //'/Trading/Models/' + modelId  +'?includeAccounts=true',
        listName: 'lots',
        template: 'order-lot-list-item.html',
        headerTemplate: 'tom-order-lots-header.html',
        icon: 'fa fa-users',
        addItemEvent: null,
        rebalanceItemEvent: null,
        loadDataItemsEvent: dataItemsEvent,
        selectEnabled: true,
        multiSelectEnabled: true,
        nameProperty: 'productName',
        dataProperty: 'orderLots',
        selectProperty: 'accountId',
        sortFields: {acquiredDate: "Acquired Date", gainLossPercent: 'Gain/Loss %', units: "Units", currentValue: 'Total Cost'},
        //listFilter: function(item, value) {return (item.name && item.name.toLowerCase().indexOf(value) !== -1) || (item.fundName && item.fundName.toLowerCase().indexOf(value) !== -1);}
        listFilter: ['acquiredDate'],
        additionalLinks: []
    };
    function init() {
        $scope.order = args.order;
        $scope.current.registrationName = $scope.order.registrationName;
        $scope.current.accountId = $scope.order.accountId;
        $scope.current.leftInfo = $scope.order.accountNumber;
        $scope.current.rightInfo = $scope.order.orderQty;
        $scope.current.remainingLots = $scope.order.orderQty;

        $http.get('/Trading/Orders/' + $scope.order.id + '/AssetLots/' + $scope.order.assetId, {trackerMsg: 'Getting lots for order' + $scope.order.id})
            .then(function (response) {
                $scope.orderLots = response.data;

                $scope.orderLots.forEach(function (item) {
                    item.accountNumber = args.order.accountNumber;
                    item.accountType = args.order.accountType;
                    item.acquiredDate = Date.create(item.acquiredDate);
                    item.editUnits = false;
                });

                if ($scope.orderLots.length > 0) {
                    listSectionData.dataItems = $scope.orderLots;
                    $scope.$broadcast(dataItemsEvent);
                } else {
                    listSectionData.dataItems = [];
                    $scope.$broadcast(dataItemsEvent);
                }

            });


    }

    function updateSectionLots(selectedSections) {
        $scope.lotSections = angular.copy(selectedSections);
        $scope.disableGenerateTrade = $scope.lotSections.length == 0;

        updateLotTotals();
    }

    function updateLotTotals() {
        var tempTotal = $scope.order.orderQty - Math.abs($scope.lotSections.sum('units'));
        $scope.current.lotTitle = tempTotal < 0 ? 'Over' : 'Remaining';
        $scope.current.remainingLots = $scope.current.lotTitle == 'Over' ? Math.abs(tempTotal) : tempTotal;
    }

    $scope.selectAllLots = function () {
        $scope.lotSections = [];

        listSectionData.dataItems.forEach(function (item) {
            item.selected = true;
        });
        $scope.lotSections = angular.copy(listSectionData.dataItems);
        $scope.disableGenerateTrade = $scope.lotSections.length == 0;
        updateLotTotals();
    };

    $scope.removeAllLots = function () {
        listSectionData.dataItems.forEach(function (item) {
            item.selected = false;
        });
        $scope.lotSections = [];
        $scope.disableGenerateTrade = $scope.lotSections.length == 0;
        updateLotTotals();
    };

    $scope.updateSectionTotals = function (section, e) {

        if ($scope.current.remainingLots != 0) {
            var temp = 0;
            temp = $scope.current.remainingLots - section.units;
            section.units = Math.abs(temp);
        }
        updateLotTotals();
    };

    $scope.setEditMode = function (section, index) {
        updateLotTotals();
        section.editUnits = !section.editUnits;
    };

    $scope.close = function () {
        args.order = null;
        dialog.close(null);
    };

    $scope.createOrderLots = function () {
        args.order = null;
        dialog.close($scope.lotSections);
    };

    $scope.$on("selectedCount", function (e, args) {
        updateSectionLots(args);
    });

    $scope.$watch("lotSections", function (newValue, oldValue) {
        if (!newValue || newValue === oldValue) return;
        updateLotTotals();
    }, true);

    $scope.order = null;

    $scope.current = {
        lotTitle: 'Remaining',
        showFilterRow: true,
        registrationName: '',
        accountName: '',
        accountId: 4,
        url: "",
        productName: "name",
        transAmount: "value",
        ticker: "leftInfo",
        bgColor: "rgba(170, 170, 170, 1)",
        icon: "fa fa-orion-transaction",
        rightInfo: "Order Amount",
        leftTitle: "Ticker"
    };
    $scope.disableGenerateTrade = true;
    $scope.lotSections = [];
    init();
});

app.controller('TOMUnblockedOrdersFixMutualFundBlocksNotSent', function TOMUnblockedOrdersFixMutualFundBlocksNotSent($scope, $http, args, $dialog, dialog, listSectionData, splitIoService) {
    var dataItemsEvent = "event: data-items";
    $scope.fixMutualFundsBlocksNotSentConfig = {
        getUrl: null,       //'/Trading/Models/' + modelId  +'?includeAccounts=true',
        listName: 'BlocksNotSent',
        template: 'fix-mutual-funds-blocks-not-sent-list.html',
        headerTemplate: 'fix-mutual-funds-blocks-not-sent-header.html',
        icon: 'fa fa-users',
        addItemEvent: null,
        rebalanceItemEvent: null,
        loadDataItemsEvent: dataItemsEvent,
        selectEnabled: true,
        multiSelectEnabled: true,
        nameProperty: 'name',
        dataProperty: 'fixMutualFundBatch',
        selectProperty: 'id',
        sortFields: {custodian: 'Custodian', side: 'Side', numberOfOrders: '# of Orders', dollarAmount: 'Dollar Amount'},
        //listFilter: function(item, value) {return (item.name && item.name.toLowerCase().indexOf(value) !== -1) || (item.fundName && item.fundName.toLowerCase().indexOf(value) !== -1);}
        listFilter: ['custodian', 'side', 'dollarAmount', 'numberOrders'],
        additionalLinks: []
    };

    function init() {
        args.blocksNotSent.forEach(function (item) {
           if(item.side == 1){
               item.side = 'Buy'
           }
           if(item.side == 2){
               item.side = 'Sell'
           }
        });

        listSectionData.dataItems = args.blocksNotSent;
        $scope.$broadcast(dataItemsEvent);
    }
    $scope.$on("selectedCount", function (e, args) {

        $scope.current.selectedBlockIds = [];

        Object.values(args.map('ids'), function (item) {
            $scope.current.selectedBlockIds.add(Object.values(item));
        });

        $scope.current.selectedCount = args.length;
    });

    $scope.current = {
        selectedBlockIds: [],
        selectedCount: 0,
        newOrderQty: null,
        remainingOrderQty: null,
        selectedCustodian: null,
        orderTitle: 'Remaining Amount',
        showFilterRow: true,
        registrationName: '',
        accountName: '',
        accountId: null,
        url: "",
        productName: "name",
        transAmount: "value",
        ticker: "leftInfo",
        bgColor: "rgba(170, 170, 170, 1)",
        icon: "fa fa-orion-transaction",
        rightInfo: 0,
        leftTitle: "Ticker"
    };


    $scope.resetBlocks = function () {
        if ($scope.current.selectedBlockIds.length > 0) {
            $http.put('/Trading/Orders/Action/ResetMutualFundTrades', $scope.current.selectedBlockIds, {trackerMsg: 'Reset selected Mutual Fund orders'})
                .then(function (response) {
                    dialog.close($scope.current.selectedBlockIds);
                    loadOrdersAwaitingAcceptance(splitIoService);
                });
        }
    };

    $scope.close = function () {
        listSectionData.dataItems = [];
        $scope.$broadcast(dataItemsEvent);
        dialog.close(null);
    };

    $scope.fixMutualFundBatch = [];

    $scope.sendBlocks = function () {
        listSectionData.dataItems = [];
        $scope.$broadcast(dataItemsEvent);
        dialog.close($scope.current.selectedBlockIds);
    };

    init();
});

app.controller('TOMUnblockedOrdersFixedIncomeTrades', function TOMUnblockedOrdersFixedIncomeTrades($scope, $http, args, $dialog, dialog, listSectionData) {
    //  var accountId = args.order.accountId;
    var dataItemsEvent = "event: data-items";
    $scope.fixedIncomeTradesConfig = {
        getUrl: null,       //'/Trading/Models/' + modelId  +'?includeAccounts=true',
        listName: 'Fixed Income Trades',
        template: 'fixed-income-trade-list-item.html',
        headerTemplate: 'fixed-income-trade-header.html',
        icon: 'fa fa-users',
        addItemEvent: null,
        rebalanceItemEvent: null,
        loadDataItemsEvent: dataItemsEvent,
        selectEnabled: true,
        multiSelectEnabled: false,
        nameProperty: 'name',
        dataProperty: 'fixIncomeTradeOrders',
        selectProperty: 'id',
        sortFields: {id: "Order ID", orderAmt: 'Order Amount', custodian: 'Custodian'},
        //listFilter: function(item, value) {return (item.name && item.name.toLowerCase().indexOf(value) !== -1) || (item.fundName && item.fundName.toLowerCase().indexOf(value) !== -1);}
        listFilter: ['id', 'orderAmt', 'custodian'],
        additionalLinks: []
    };

    function init() {
        $scope.fixIncomeTradeOrders = angular.copy(args.orders);
        args.orders = null;
        listSectionData.dataItems = $scope.fixIncomeTradeOrders;
        $scope.$broadcast(dataItemsEvent);

        //Create orders array for new products
        $scope.fixIncomeTradeOrdersUpdate = [];
        $scope.fixIncomeTradeOrders.forEach(function (item) {
            $scope.fixIncomeTradeOrdersUpdate.add({fixTradeRequestId: item.id, isOpen: false, fixIncomeTradeOrdersInfos: []});
        })
    }

    function updateHeader(orderId) {

        $scope.current.registrationName = $scope.fixIncomeTradeOrders.find({id: orderId}).registrationName;
        $scope.current.accountId = $scope.fixIncomeTradeOrders.find({id: orderId}).accountId;
        $scope.current.leftInfo = $scope.fixIncomeTradeOrders.find({id: orderId}).accountNumber;
        $scope.current.rightInfo = $scope.fixIncomeTradeOrders.find({id: orderId}).orderAmt;
        $scope.current.remainingOrderInfo = $scope.fixIncomeTradeOrders.find({id: orderId}).orderAmt;
    }

    $scope.addProductToOrder = function () {
        //find which order to add product
        var selectedOrder = $scope.fixIncomeTradeOrdersUpdate.find({isOpen: true});
        var ticker = $scope.current.trade.action == 'Buy' ? $scope.trade.buyProduct.ticker : $scope.trade.sellProduct.ticker;
        $http.get('/Trading/Products/' + ticker + '/RealtimePrice', {trackerMsg: 'Loading price data'})
            .then(function (response) {
                if (response.data != 'null') {
                    selectedOrder.fixIncomeTradeOrdersInfos.add({
                        fixTradeRequestId: selectedOrder.fixTradeRequestId,
                        accountId: $scope.current.accountId,
                        productId: $scope.current.trade.action == 'Buy' ? $scope.trade.buyProduct.productId : $scope.trade.sellProduct.productId,
                        productName: $scope.current.trade.action == 'Buy' ? $scope.trade.buyProduct.productName : $scope.trade.sellProduct.productName,
                        ticker: $scope.current.trade.action == 'Buy' ? $scope.trade.buyProduct.ticker : $scope.trade.sellProduct.ticker,
                        price: response.data.last,
                        orderQty: $scope.current.newOrderQty,
                        isEditMode:false
                    });
                    updateTotalsForOrder(selectedOrder);
                } else {
                    $dialog.actionFailed('Unable to retrieve real time price for product (' + ticker + ')').open();
                }

                $scope.trade = null;
                $scope.current.newOrderQty = null;
            });
    };

    $scope.removeProductFromOrder = function (section) {
        var selectedOrder = $scope.fixIncomeTradeOrdersUpdate.find({isOpen: true});
        selectedOrder.fixIncomeTradeOrdersInfos.remove(section);
        $scope.current.remainingOrderInfo = $scope.current.rightInfo - selectedOrder.fixIncomeTradeOrdersInfos.sum('totalAmt');
        $scope.updatePanel(selectedOrder);
    };

    function updateTotalsForOrder(order) {
        if (order.fixIncomeTradeOrdersInfos && order.fixIncomeTradeOrdersInfos.length > 0) {
            order.fixIncomeTradeOrdersInfos.forEach(function (item) {
                item.totalAmt = item.orderQty * item.price;
            });
            $scope.current.remainingOrderInfo = $scope.current.rightInfo - order.fixIncomeTradeOrdersInfos.sum('totalAmt');

        }
    }

    $scope.updateShares = function (section) {
        section.isEditMode = false;
        var adjustedOrder = $scope.fixIncomeTradeOrdersUpdate.find({fixTradeRequestId: section.fixTradeRequestId});
        adjustedOrder.fixIncomeTradeOrdersInfos.find(section);
        $scope.updatePanel(adjustedOrder);
    };

    $scope.updatePanel = function (item) {
        $scope.fixIncomeTradeOrders.forEach(function (panelItem) {
            if (panelItem.id == item.fixTradeRequestId) {
                panelItem.selected = !panelItem.selected;
                //determines whether or not product add controls are visible in html
                $scope.current.selectedCount = panelItem.selected ? 1 : 0;
            } else {
                panelItem.selected = false;
            }
        });
        updateHeader(item.fixTradeRequestId);
        updateTotalsForOrder($scope.fixIncomeTradeOrdersUpdate.find({fixTradeRequestId: item.fixTradeRequestId}));
    };

    $scope.$watch("trade.buyProduct", function (e, args) {
        if (!e) $scope.current.newOrderQty = null;
    });

    $scope.$watch("trade.sellProduct", function (e, args) {
        if (!e) $scope.current.newOrderQty = null;
    });

    $scope.$on("selectedCount", function (e, args) {
        $scope.current.selectedCount = args.length;
        $scope.fixIncomeTradeOrdersUpdate.find({fixTradeRequestId: args[0].id}).isOpen = true;
        updateHeader(args[0].id);
        updateTotalsForOrder($scope.fixIncomeTradeOrdersUpdate.find({fixTradeRequestId: args[0].id}));
    });

    $scope.current = {
        selectedCount: 0,
        newOrderQty: null,
        remainingOrderQty: null,
        selectedCustodian: null,
        trade: {
            account: null,
            action: args.orders[0].side,
            sendNow: false,
            nsccTransactionType: 'UseDefault',
            type: 'Dollars',
            sellProduct: args.orders[0].side == 'Sell' ? args.orders[0].side : null,
            buyProduct: args.orders[0].side == 'Buy' ? args.orders[0].side : null,
            dollars: null,
            shares: null,
            percent: null
        },
        orderTitle: 'Remaining Amount',
        showFilterRow: true,
        registrationName: '',
        accountName: '',
        accountId: null,
        url: "",
        productName: "name",
        transAmount: "value",
        ticker: "leftInfo",
        bgColor: "rgba(170, 170, 170, 1)",
        icon: "fa fa-orion-transaction",
        rightInfo: 0,
        leftTitle: "Ticker"
    };

    $scope.close = function () {
        args.orders = null;
        $scope.fixIncomeTradeOrders = null;
        listSectionData.dataItems = [];
        $scope.$broadcast(dataItemsEvent);
        dialog.close(null);
    };

    $scope.updateOrder = function () {
        dialog.close($scope.fixIncomeTradeOrdersUpdate);
    };
    init();
});

'use strict';

app.controller('TOMTradeFilesCtrl', function TOMTradeFilesCtrl($scope, $http,$timeout, $routeParams, $dialog, API_CONFIG) {
    //PRIVATE METHODS
    function loadFiles() {
        var date = $scope.current.fileDate.formatted();

        $http.get('/Trading/TradeFiles/WithProcessing?asOfDate=' + date, {trackerMsg: 'Loading trade files'})
            .then(function (response) {
                $scope.current.tradeFiles = response.data;
            });

        //Uncomment this if we decide to include fee files after all
        //$http.get('/Trading/TradeFiles/Fees?startDate=' + date + "&endDate=" + $scope.current.fileDate.clone().addDays(1).formatted(), {trackerMsg: 'Loading fee files'})
        //    .then(function (response) {
        //        $scope.current.feeFiles = response.data;
        //    });
    }


    //PUBLIC METHODS
    $scope.downloadFile = function (file) {
        window.location.href = API_CONFIG.baseUrl + '/Trading/TradeFiles/' + file.id + '/File?Authorization=' + sessionStorage.oas_token;

        $timeout(function() {
            $http.get('/Trading/TradeFiles/' + file.id, {trackerMsg: 'Refreshing ' + file.fileName})
                .then(function (response) {
                    angular.extend(file, response.data);
                });
        }, 1000);
    };

    $scope.resetFile = function (file) {
        $dialog.confirmAction("This action will remove pendings and update the trade status to not sent.  Are you sure you want to reset " + file.fileName + "?")
            .open()
            .then(function(result) {
                if (result === 'yes') {
                    $http.get('/Trading/TradeFiles/' + file.id + '/Reset', {trackerMsg: 'Resetting ' + file.fileName})
                        .then(function () {
                            loadFiles();
                        });
                }
            });
    };

    $scope.transmitFile = function (file) {
        $http.post('/Trading/TradeFiles/' + file.id + '/Transmit', null, {trackerMsg: 'Transmitting ' + file.fileName})
            .then(function (response) {
                file.status = response.data.status;
            });
    };


    //INITIALIZE
    $scope.current = {fileDate: Date.create($routeParams.asOfDate)};
    loadFiles();


    //WATCHES
    $scope.$watch("current.fileDate", function (newValue, oldValue) {
        if (newValue === oldValue) return;
        loadFiles();
    });
});



'use strict';

var tomUnallocatedOrdersCtrl = app.controller('TOMUnallocatedOrdersCtrl', function TOMUnallocatedOrdersCtrl($scope, $http, $dialog, $window, $routeParams, $location) {
    //PRIVATE VARIABLES
    var allOrders;


    //PRIVATE METHODS
    function initialLoad() {
        $http.get("/Trading/FixBlockOrders?status=unallocated&alike=" + $scope.current.primaryBlockId, {trackerMsg: 'Loading blocks'})
            .then(function (response) {
                if(response.data.length > 0) {
                    $scope.current.ticker = response.data[0].ticker;
                    $scope.current.action = response.data[0].side;
                }
                var blocks = [];
                response.data.forEach(function(block) {
                    var isPrimary = block.id === $scope.current.primaryBlockId;
                    blocks.push({id: block.id, orderQty: block.cumQty, avgPrice: block.avgPrice, include: isPrimary, isPrimary: isPrimary})
                });
                $scope.blocks = blocks;

                calculateBlockValues();

                $http.get('/Trading/FixBlockOrders/Filter/UnallocatedOrders?status=unallocated&alike=' + $scope.current.primaryBlockId, {trackerMsg: 'Loading allocation orders'})
                    .then(function (response) {
                        response.data.forEach(function(order) {
                            order.include = order.fixBlockOrderId === $scope.current.primaryBlockId;
                            order.orderAmt = order.orderQty * $scope.current.avgPrice;
                        });
                        allOrders = response.data;

                        $scope.orders = response.data.findAll({include: true});
                        calculateAllocationValues();
                    });
            });
    }

    function calculateBlockValues() {
        var totalQty = 0, totalAmt = 0, includedBlockIds = [];

        $scope.blocks.findAll({include: true}).forEach(function (block) {
            includedBlockIds.push(block.id);
            totalQty += block.orderQty;
            totalAmt += block.orderQty * block.avgPrice;
        });

        $scope.current.totalQty = totalQty;
        $scope.current.totalAmt = totalAmt;
        $scope.current.avgPrice = (totalAmt / totalQty).round(4);

        return includedBlockIds;
    }

    function calculateAllocationValues() {
        var totalQty = 0, totalAmt = 0;
        $scope.orders.forEach(function(order) {
            totalQty += order.orderQty;
            totalAmt += order.orderAmt;
        });
        $scope.current.allocationAmt = totalAmt;
        $scope.current.allocationQty = totalQty;
        $scope.current.remainingAmt = $scope.current.totalAmt - totalAmt;
        $scope.current.remainingQty = $scope.current.totalQty - totalQty;
    }

    function recalculateAllOrderAmounts() {
        $scope.orders.forEach(function(order) {
            $scope.recalculateOrderAmt(order.id, false);
        });
        calculateAllocationValues();
    }


    //PUBLIC METHODS
    $scope.recalculateAll = function() {
        var includedBlockIds = calculateBlockValues();

        var includedOrders = [];
        allOrders.forEach(function (order) {
            if (includedBlockIds.any(order.fixBlockOrderId)) {
                includedOrders.push(order);
            }
        });
        $scope.orders = includedOrders;

        recalculateAllOrderAmounts();
    };

    $scope.automaticUpdateAllocations = function(){

        $http.put('/Trading/FixBlockOrders/Action/AllocateAutoAdjust?blockId=' + $scope.current.primaryBlockId + '&allocateAutoAdjustType=' + $scope.current.selectedAllocateAutoAdjustType , {trackerMsg:'main'})
            .then(function (response) {
                if(response.data.length > 0){
                    initialLoad();
                }
            })
    };

    $scope.recalculateOrderAmt = function(orderId, recalculateAllocation) {
        var order = allOrders.find({id: orderId});
        order.orderAmt = order.orderQty * $scope.current.avgPrice;

        if (recalculateAllocation)
            calculateAllocationValues();
    };

    $scope.deleteOrder = function(order) {
        $scope.orders.splice($scope.orders.indexOf(order), 1);

        if (order.id === 0)
            allOrders.splice(allOrders.indexOf(order), 1);
        else if (order.fixBlockOrderId !== $scope.current.primaryBlockId && $scope.orders.none({fixBlockOrderId: order.fixBlockOrderId})) {
            $scope.blocks.find({id: order.fixBlockOrderId}).include = false;
            calculateBlockValues();
            recalculateAllOrderAmounts();
        }

        calculateAllocationValues();
    };

    $scope.addOrder = function() {
        $http.get('/Trading/UnallocatedOrders/New/BlockId/' + $scope.current.primaryBlockId + '/AccountId/' + $scope.current.accountToAdd.id, {trackerMsg: 'Loading account information'})
            .then(function(response) {
                var data = response.data;
                data.orderQty = parseFloat($scope.current.accountToAddQty) > 0 ? parseFloat($scope.current.accountToAddQty) : 0;
                data.include = true;
                data.orderAmt = data.orderQty * $scope.current.avgPrice;

                allOrders.push(data);
                $scope.orders.push(data);
                calculateAllocationValues();

                $scope.resetAccountAdd();
            })
    };

    $scope.resetAccountAdd = function() {
        $scope.current.accountToAdd = null;
        $scope.current.accountToAddQty = null;
    };

    $scope.exportToExcel = function() {
        var data = {columns: $scope.columns, data: $scope.orders};

        $http.post('/Utility/SlickGridExport/csv', data, {trackerMsg: 'Exporting grid'})
            .then(function (response) {
                $window.location.href = response.headers("location") + "?Authorization=" + sessionStorage.oas_token;
            });
    };

    $scope.openFeeEditor = function() {
        $dialog.dialog({ dialogClass: "modal wide", templateUrl: "trading/views/tom-fees-commissions.html", controller: "TOMFeesCommissionsCtrl", resolve: { blockId: function() { return $scope.current.primaryBlockId; } } }).open();
    };

    $scope.save = function() {
        $http.put('/Trading/UnallocatedOrders', $scope.orders, {trackerMsg: 'Saving allocations'})
            .then(function () {
                $location.path('/trading/tom/allocations');
            });
    };

    $scope.submit = function() {
        $http.put('/Trading/UnallocatedOrders?allocate=true', $scope.orders, {trackerMsg: 'Submitting allocations'})
            .then(function () {
                $scope.deleteBreadcrumb();
                $location.path('/trading/tom/allocations').replace();
            });
    };

    $scope.markComplete = function() {
        $http.put('/Trading/UnallocatedOrders?allocate=true&markComplete=true', $scope.orders, {trackerMsg: 'Marking allocations complete'})
            .then(function () {
                $scope.deleteBreadcrumb();
                $location.path('/trading/tom/allocations').replace();
            });
    };

    $scope.setSortOrder = function (columnName) {
        $scope.sort.reverse = $scope.sort.column === $scope.columns.find({name:columnName}).field ? !$scope.sort.reverse : false;
        $scope.sort.column = $scope.columns.find({name:columnName}).field;
    };
    //INITIALIZE
    $scope.allocateAutoAdjustTypes = [{name: 'Pro-Rata', value: "Pro-Rata"}, {name: 'Random', value: 'Random'}];
    $scope.current = {selectedAllocateAutoAdjustType: 'Pro-Rata', primaryBlockId: parseInt($routeParams.blockId), showPending: true, importedOrders: null, totalAmt: 0, totalQty: 0, avgPrice: 0, allocationAmt: 0, allocationQty: 0, remainingAmt: 0, remainingQty: 0, accountToAdd: null, accountToAddQty: null};
    $scope.columns = [
        {name: "Order ID", field: "id"},
        {name: "Account ID", field: "accountId"},
        {name: "Account #", field: "accountNumber"},
        {name: "Registration Name", field: "registrationName"},
        {name: "Acct Type", field: "accountType"},
        {name: "Sweep Cash", field: "cashValuePending"},
        {name: "Shares Owned", field: "sharesOwned"},
        {name: "Original Qty", field: "originalOrderQty"},
        {name: "Order Qty", field: "orderQty"},
        {name: "Order Amt", field: "orderAmt"},
        {name: "Block ID", field: "fixBlockOrderId"}
    ];
    $scope.addBreadcrumb("Block " + $scope.current.primaryBlockId);
    $scope.sort = {column: 'id', reverse: false};
    initialLoad();


    //WATCHES
    $scope.$watch("current.importedOrders", function (newValue, oldValue) {
        if (newValue === oldValue || !newValue ) return;

        $scope.orders = angular.copy(newValue);
        recalculateAllOrderAmounts();

        $scope.current.importedOrders = null;
    }, true);
});

'use strict';

app.controller('DistributionsCtrl', function DistributionsCtrl($scope, $http, $tradeGenerator, $oasRights, $location, $dialog, $routeParams, entities, splitIoService) {

    //region PRIVATE METHODS
    function fillGrid() {
        $scope.current.importRecords.valid = $scope.current.distributionImportAccounts.findAll({isValid: true}).length;
        $scope.current.importRecords.total = $scope.current.distributionImportAccounts.length;
    }

    function init() {

        if($routeParams){
            if($routeParams.dt && $routeParams.dt === 'F'){
                $scope.current.distribution.distributionType = 'Full';
            }
            $scope.current.loadedFromSSW = !!($routeParams && $routeParams.lf === 'true');
        }

        $http.get("/Settings/Database/EntityOptions/Code/69DDACASHT", {trackerMsg: 'Loading cash ticker'})
                .then(function(response) {
                    if(response.data && response.data.value.trim() !== '') {
                        $scope.current.cashTicker = response.data.value.trim();
                    }
                });

        $http.get("/Settings/Database/EntityOptions/Code/69ZEROVALU", {trackerMsg: 'Loading distribution wizard entity option'})
            .then(function(response) {
                if(response.data && response.data.value.trim() !== '') {
                    $scope.current.zeroOutPercentValues = response.data.value === 'True';
                }
            });

        $http.get("/Settings/Database/EntityOptions/Code/69SLEEVECA", {trackerMsg: 'Checking sleeve setup options'})
            .then(function(response) {
                if(response.data && response.data.value.trim() !== '') {
                    $scope.current.sellRebalance = response.data.value === 'Contribution/Distribution';
                }
            });

        $http.get("/Settings/Database/EntityOptions/Code/69ENABLEDI", {trackerMsg: 'Checking option for imports'})
            .then(function(response) {
                if(response.data && response.data.value.trim() !== '') {
                    $scope.current.distributionImportEnabled = response.data.value === 'True';
                }
            });

        // Feature flag: OC_Trading_AssetValueForDistributionTool_INVST-14389
        // If disabled, do not expose Asset Values UI and do not send assetValues in payload.
        // Ensure assetValues are set even if the flag resolves after the trade definition (navigation back scenario).
        splitIoService.getBoolTreatment('OC_Trading_AssetValueForDistributionTool_INVST-14389').subscribe((isEnabled) => {
            $scope.current.assetValuesFeatureEnabled = isEnabled;
            if (isEnabled && $scope.current.tradeDefinition) {
                $scope.current.assetValues = $scope.current.tradeDefinition.assetValues;
                if ($scope.current.assetValues === "UseDefault" || $scope.current.assetValues === "Current") {
                    $scope.current.assetValues = "Pending";
                }
                // Make sure UI updates if this runs outside an Angular digest
                $scope.$evalAsync();
            }
        });

        $tradeGenerator.getTradeDefinition("Distribution")
            .then(function(response) {
                var definition = response.data;
                $scope.current.tradeDefinition = definition;
                if($scope.current.assetValuesFeatureEnabled){
                    $scope.current.assetValues = definition.assetValues;
                    // Ensure only valid options are set
                    if ($scope.current.assetValues === "UseDefault" || $scope.current.assetValues === "Current") {
                        $scope.current.assetValues = "Pending";
                    }
                }
            });
    }

    function allocateMoney(percent, amount) {
        if($scope.current.distribution.distributionType === 'ProRata' || $scope.current.distribution.distributionType === 'ByFund' || $scope.current.distribution.distributionType === 'SellRebalance' || $scope.current.distribution.distributionType == 'DistributionFullRebalance' ){
            if($scope.current.distributionAmountType === 'Dollars'){
                return Math.round(amount * percent )/100;
            }
            else {
                var tempPercent =  amount / 100;
                if($scope.current.distribution.isSleeve){
                    //use account total value, not registration value
                    if($scope.current.distribution.distributionType === 'SellRebalance' && $scope.current.sellRebalanceRegLevel === 'Account'){
                        //find the current account value
                        return Math.round(($scope.current.sleeves.find({id:$scope.current.distribution.account.id}).currentValue * tempPercent) * (percent/100));
                    }else{
                        return Math.round(($scope.current.distribution.registration.currentValue * tempPercent) * (percent/100));
                    }
                }else{
                    var temp =  ($scope.current.totalValue * (percent / 100)) * tempPercent;
                    return temp.round(1);
                }
            }
        }else{
            return Math.round(amount * percent )/100;
        }
    }

    function updateAllocation(item, index) {
        var percent, amount;
        switch($scope.current.distribution.distributionType) {
            case "DistributionFullRebalance":
            case "SellRebalance":
            case "ProRata":
                if(!$scope.current.distribution.isSleeve)
                    item.distributionAllocation = calculateAssetPercent(item, index);
                percent = parseFloat(item.distributionAllocation);
                amount = parseFloat($scope.current.distribution.amount);
                break;
            case "ByFund":
                if($scope.current.distribution.isSleeve)
                    updateAssetAllocation();
                else if (index === 0)
                    updateAssetAllocation(); //item.distributionAllocation = calculateAssetPercent(item, index);
                percent = parseFloat(item.distributionAllocation);
                amount = parseFloat($scope.current.distribution.amount);//item.currentValue;
                break;
            case "Full":
                if(!$scope.current.distribution.isSleeve)
                    item.distributionAllocation = 100;
                percent = 100;
                amount = item.currentValue;
                break;
            default:
                percent = 0;
                amount = 0;
                break;
        }
        return allocateMoney(percent, amount);
    }

    function calculateAssetPercent (asset, index) {
        var result = 0.0;
        switch ($scope.current.distribution.distributionType) {
            case 'DistributionFullRebalance':
            case 'SellRebalance':
            case 'ProRata':
                result = Math.round(asset.currentValue/$scope.current.totalValue * 10000)/100;
                break;
            case 'ByFund':
            case 'Full':
                result = 100;
                break;
        }
        return result;
    }

    function updateAssetAllocation () {
        var assetAllocations;
        if($scope.current.distribution.isSleeve)
        {
            assetAllocations = getSleeveAssetAllocation();
            $scope.current.sleeves.each(function(account, aIndex){
                //var assetAllocations = getAssetAllocations(account.assets, account.distributionAllocation); //account.assets.length > 0 ? account.distributionAllocation / account.assets.length : 0;
                account.assets.each(function(asset, index){
                    asset.distributionAllocation = $scope.current.distribution.distributionType === 'ByFund' && $scope.current.zeroOutPercentValues ? 0 : assetAllocations[aIndex][index];
                    asset.allocatedDollars = $scope.current.distribution.distributionType === 'ByFund' && $scope.current.zeroOutPercentValues ? 0 : allocateMoney(parseFloat(asset.distributionAllocation), parseFloat($scope.current.distribution.amount));
                });
            });
        }
        else if ($scope.current.distribution.distributionType !== 'Full') {
            assetAllocations = getAssetAllocations($scope.current.sleeves, 100);
            $scope.current.sleeves.each(function(asset, index){
                asset.distributionAllocation = $scope.current.distribution.distributionType === 'ByFund' && $scope.current.zeroOutPercentValues ? 0 : assetAllocations[index];
                asset.allocatedDollars = $scope.current.distribution.distributionType === 'ByFund' && $scope.current.zeroOutPercentValues ? 0 : allocateMoney(parseFloat(asset.distributionAllocation), parseFloat($scope.current.distribution.amount));
            });
        }
    }

    function roundingCheck(items) {
        var total = 0;
        var selected = null;

        if($scope.current.distribution.isSleeve) {
            items.each(function(account){
                var tmp = account.assets.max(function (n) { return n.distributionAllocation; });
                if(tmp && (!selected || selected.distributionAllocation < tmp.distributionAllocation))
                    selected = tmp;
                total += account.assets.sum(function (n) { return n.distributionAllocation; });
            });
        }
        else {
            selected = items.max(function (n) { return n.distributionAllocation; });
            total = items.sum(function (n) { return n.distributionAllocation; });
        }

        total = Math.round(total * 100)/100;

        if(selected && total !== 100) {
            var diff = Math.round((100 - total) * 100)/100;
            if($scope.current.distribution.distributionType === 'ByFund' && $scope.current.zeroOutPercentValues){
                selected.distributionAllocation = 0;
                selected.allocatedDollars = 0;
            }else{
                selected.distributionAllocation  += diff;
                selected.allocatedDollars = allocateMoney(parseFloat(selected.distributionAllocation), parseFloat($scope.current.distribution.amount));
            }
        }
    }

    function getSleeveAssetAllocation() {
        var allocations = [];
        var totalValue = 0;
        $scope.current.sleeves.each(function(account){
            totalValue += account.assets.sum(function(n){ return n.currentValue; });
        });

        $scope.current.sleeves.each(function(account){
            var currentSleeve = [];
            account.assets.each(function(asset){
                currentSleeve.push(Math.round(asset.currentValue / totalValue * 10000) /100);
            });
            allocations.push(currentSleeve);
        });
        return allocations;
    }

    function getAssetAllocations(assets, accountAllocation) {
        var allocations = [];
        var totalValue = assets.sum(function(n){ return n.currentValue; });
        assets.each(function(asset){
            allocations.push(Math.round(asset.currentValue / totalValue * accountAllocation * 100) /100);
        });
        return allocations;
    }

    function allocateMoneySellRebalance(amount){
        //account or reg level
        var tempPercent =  amount / 100;
        return $scope.current.distributionAmountType === 'Dollars' ?  Math.round(amount) : $scope.current.sellRebalanceRegLevel === 'Account' ?
                Math.round($scope.current.sleeves.find({id:$scope.current.distribution.account.id}).currentValue * tempPercent ) :   Math.round(($scope.current.distribution.registration.currentValue * tempPercent));
    }

    //endregion

    //region PUBLIC METHODS
    $scope.back = function() {
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep -= 1;

    };

    $scope.next = function() {
        $scope.current.animation = 'slide-right';
        $scope.current.wizardStep += 1;
    };

    $scope.jumpBackTo = function(index) {
        if ($scope.current.executing) return;

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };

    $scope.isStepIncomplete = function() {
        // this is a hack because of the way it was written
        switch ($scope.current.wizardStep) {
            case 0:
                var test;
                if ($scope.current.distributionImportAccounts.length > 0){
                    test = false;
                }else{
                    test = $scope.current.distribution.account === null;
                    test = test || ($scope.current.distribution.distributionType !== 'Full' && ( ($scope.current.distribution.amount === 0 || !$scope.current.distribution.amount) || $scope.current.distribution.amount > $scope.current.totalValue));
                }
                return test;
            case 1:
                if($scope.current.distribution.distributionType === 'ProRata' || $scope.current.distribution.distributionType === 'SellRebalance' || $scope.current.distribution.distributionType === 'DistributionFullRebalance') {$scope.updateDistribution();}
                return $scope.allocationTest();
            default:
                return false;
        }
    };

    $scope.allocationTest = function() {
        var test = false;
        var total;
        if ($scope.current.distribution.distributionType === 'ByFund') {
            if($scope.current.distribution.isSleeve) {
                total = $scope.current.sleeves.sum(function (account) {
                    return account.assets.sum(function (n) {
                        return parseFloat(n.distributionAllocation);
                    });
                });
                total *= 100;
                test = Math.round(total)/100 !== 100;
                $scope.current.totalByFund = Math.round(total)/100
            }
            else {
                total = $scope.current.sleeves.sum(function (n) {
                    return parseFloat(n.distributionAllocation);
                });
                test = Math.round(total * 100)/100 !== 100;
                $scope.current.totalByFund = Math.round(total * 100)/100
            }
        }
        return test;
    };

    $scope.submitDistribution = function() {
        $scope.current.executing = true;
        var tradeDef = null;

        //if import, create arrays for id's and amounts
        var accountIds = [];
        var accountAmounts = [];
        var validAccounts =[];

        if($scope.current.distributionImportAccounts.length > 0){
            validAccounts = $scope.current.distributionImportAccounts.findAll({isValid:true});
            validAccounts.forEach(function (item) {
                accountIds.add(item.accountId);
                accountAmounts.add(parseFloat(item.amount));
            })
        }else if($scope.current.sleeves.length > 0 && $scope.current.sellRebalanceRegLevel === 'Registration' && $scope.current.distribution.isSleeve){
            if($scope.current.distribution.distributionType === 'ProRata' || $scope.current.distribution.distributionType === 'Full'){
                accountIds.add($scope.current.distribution.key);
                accountAmounts.add(parseFloat($scope.current.distribution.amount));
            }else{
                $scope.current.sleeves.forEach(function (item) {
                    accountIds.add(item.id);
                    accountAmounts.add(parseFloat(item.allocatedDollars));
                })
            }
        }else{
            accountIds.add($scope.current.distribution.account.id);
            if($scope.current.distribution.distributionType === 'ProRata'){
                accountAmounts.add(parseFloat($scope.current.distribution.amount));
            }else{
                accountAmounts.add(parseFloat(allocateMoneySellRebalance($scope.current.distribution.amount)));
            }

        }

        if($scope.current.distribution.distributionType === "SellRebalance" || $scope.current.distribution.distributionType === 'DistributionFullRebalance'){
            $tradeGenerator.getTradeDefinition("Rebalance")
                .then(function(response){
                    tradeDef = response.data;
                    tradeDef.level =  $scope.current.distribution.isSleeve ? $scope.current.sellRebalanceRegLevel : 'Account';
                    tradeDef.keys = ($scope.current.sleeves.length > 0 && $scope.current.sellRebalanceRegLevel === 'Registration') ? [$scope.current.distribution.account.id] : accountIds;
                    tradeDef.entity = "Account";
                    tradeDef.amounts = ($scope.current.sleeves.length > 0 && $scope.current.sellRebalanceRegLevel === 'Registration') ? [parseFloat(allocateMoneySellRebalance($scope.current.distribution.amount))] : accountAmounts;
                    tradeDef.roundingLogic = $scope.current.distribution.roundingLogic;
                    tradeDef.instanceType = "Distribution";
                    tradeDef.reason = $scope.current.distribution.distributionType === 'DistributionFullRebalance' ? "NeedReview" :"Withdraw";
                    tradeDef.openOrders = $scope.current.openOrdersForAccount;
                    if($scope.current.assetValuesFeatureEnabled){
                        tradeDef.assetValues = $scope.current.assetValues;
                    }
                    $tradeGenerator.submitTradeDefinition(tradeDef);
                })
        }else {
            tradeDef = angular.copy($scope.current.tradeDefinition);
            tradeDef.entity = 'Account';  // it will start at this but could switch on ProRata case
            tradeDef.level = $scope.current.distribution.isSleeve ? "Registration" : "Account";
            tradeDef.primaryKey = accountIds.length > 0 ? accountIds : [$scope.current.distribution.key];
            tradeDef.fullDistribution = ($scope.current.distribution.distributionType === "Full");
            tradeDef.roundingLogic = $scope.current.distribution.roundingLogic;
            tradeDef.distributionTypeMethod = $scope.current.distributionAmountType;
            tradeDef.distributionPercent = $scope.current.distributionAmountType === 'Percent' ? $scope.current.distribution.amount : null;
            tradeDef.openOrders = $scope.current.openOrdersForAccount;
            tradeDef.distributionType = $scope.current.distribution.distributionType;
            if($scope.current.assetValuesFeatureEnabled){
                tradeDef.assetValues = $scope.current.assetValues;
            }
            switch($scope.current.distribution.distributionType) {
                case "ProRata":
                    tradeDef.entity =  tradeDef.level === 'Registration' && validAccounts.length === 0 ? 'Registration' : 'Account';
                    tradeDef.amount = accountAmounts.length > 0 ? accountAmounts : [parseFloat($scope.current.distribution.amount)];
                    if($scope.current.distribution.isSleeve &&  validAccounts.length === 0) {
                            $scope.current.sleeves.filter(function(n){ return n.distributionAllocation > 0; })
                                .each(function (account) {
                                    tradeDef.sleeves.push({
                                        pkAccount: account.id,
                                        percent: account.distributionAllocation
                                    });
                                });
                    }else if($scope.current.distribution.isSleeve && validAccounts.length > 0){
                        validAccounts.forEach(function (item) {
                            tradeDef.sleeves.push({
                                pkAccount: item.accountId,
                                percent: 100
                            });
                        })
                    }
                    break;
                case "ByFund":
                    tradeDef.amount = [parseFloat($scope.current.distribution.amount)];
                    if($scope.current.distribution.isSleeve) {
                        $scope.current.sleeves.each(function (account) {
                            account.assets.filter(function(n){ return n.distributionAllocation > 0; })
                                .each(function(asset){
                                    tradeDef.trades.push({
                                        accountID: asset.accountId,
                                        assetIDFrom: asset.id,
                                        amount: tradeDef.distributionTypeMethod === 'Percent'? asset.allocatedDollars : asset.distributionAllocation,
                                        tradeType: "Percent"
                                    });
                                });
                        });
                    }
                    else {
                        $scope.current.sleeves.filter(function(n){ return n.distributionAllocation > 0; })
                            .each(function (asset) {
                                tradeDef.trades.push({
                                    accountID: $scope.current.distribution.key,
                                    assetIDFrom: asset.id,
                                    amount: tradeDef.distributionTypeMethod === 'Percent'? asset.allocatedDollars : asset.distributionAllocation,
                                    tradeType: "Percent"
                                });
                            });
                    }
                    break;
                case "Full" :
                    tradeDef.entity = $scope.current.distribution.isSleeve && validAccounts.length === 0 ? 'Registration' : 'Account';
                    break;
            }
            $tradeGenerator.submitTradeDefinition(tradeDef);

        }
    };

    $scope.updateDistribution = function() {
        // because of the do not trade flag, the distribution allocation amount needs to be recalculated.
        var newCalcPercent = $scope.current.sleeves.findAll({doNotTrade: false}).sum('distributionAllocation');
        $scope.current.sleeves.each(function(item, index){
            if(newCalcPercent !== 100 && newCalcPercent !== 0){
                item.distributionAllocation = (item.distributionAllocation / newCalcPercent) * 100;
            }
            if(!item.doNotTrade){
                item.allocatedDollars = updateAllocation(item, index);
            }else{
                item.allocatedDollars = 0;
            }
        });

        if($scope.current.distribution.distributionType !== 'Full' || $scope.current.distribution.distributionType !== 'SellRebalance' || $scope.current.distribution.distributionType !== 'DistributionFullRebalance' )
            if($scope.current.distributionType !== 'Percent'){
                roundingCheck($scope.current.sleeves);
            }
    };

    $scope.updateAllocation = function(item) {
        var percent, amount;
        switch($scope.current.distribution.distributionType) {
            case "DistributionFullRebalance":
            case "SellRebalance":
            case "ProRata":
            case "ByFund":
                percent = parseFloat(item.distributionAllocation);
                amount = parseFloat($scope.current.distribution.amount);
                break;
            default:
                percent = 0;
                amount = 0;
                break;
        }
        item.allocatedDollars = allocateMoney(percent, amount);
        $scope.current.totalByFund = $scope.current.sleeves.sum('distributionAllocation');
    };

    $scope.addAnother = function() {
        $scope.current.tradeInstanceId = null;
        $scope.current.sleeves = [];
        $scope.current.totalValue = 0;
        $scope.current.distribution = { key: 0, registration: null, account: null, isSleeve: false, distributionType: "Full", amount: 0 };
        $scope.jumpBackTo(0);
    };

    $scope.finished = function() {
        $location.url( '/trading/tom/orders/?tradeInstanceId=' + $scope.current.tradeInstanceId );
    };

    $scope.resetImport = function () {
        $scope.current.distributionImportAccounts = [];
        $scope.current.distribution = { key: 0, registration: null, account: null, isSleeve: false, distributionType: "Full", amount: 0, roundingLogic: 'Default'};
        $scope.current.distributionImportGridReset += 1;
    };

    $scope.showImportMsg = function () {
        var msg =
            "<p>The distribution import file should include an 'Account ID' or an 'Account Number' column and Amount, the amount column represents a 'Dollar' amount not a Percent.</p>" +
            "<p>For file imports, the distribution type will be limited to: Pro-rata, Sell Rebalance and Distribution Full Rebalance only. </p>" +
            "<p>The file's extension can be xlsx or csv.</p>" +
            "<p>Invalid Accounts will be highlighted <span class='text-error'>red</span> and discarded during the import.</p>" +
            "<p>To view any error's on an account, hover over <span class='text-error' ><i class='fa fa-exclamation' aria-hidden='true'></i></span></p>";

        $dialog.messageBox("<i class='fa fa-lightbulb-o' aria-hidden='true'></i> Distribution Import Wizard", msg).open();
    };

    //endregion

    //region WATCHES
    $scope.$watch("current.distribution.account", function(newValue, oldValue){
        if (newValue === oldValue || !angular.isObject(newValue)) return;

        var account = null;
        $scope.current.executing = true;

        $http.get('/Trading/Orders?status=open&accountId=' + newValue.id, {trackerMsg:'Checking if account has open orders'})
            .then(function (response) {
                $scope.current.openOrdersForAccount = response.data.length;
        });
        $http.get("/Portfolio/Accounts/" + newValue.id, {trackerMsg: 'Loading account information'})
            .then(function(response){
                account = response.data;
                $scope.current.distribution.isSleeve = response.data.isSleeveAccount;
                var regId = response.data.registrationId;
                $http.get('/Trading/Orders?status=open&entity=' + entities.registration.value + '&entityId=' + regId, {trackerMsg:'Checking if registration has open orders'})
                    .then(function (response) {
                        $scope.current.openOrdersForRegistration = response.data.length;
                    });
                return $http.get("/Portfolio/Registrations/" + regId, {trackerMsg: 'Loading registration information'});
            })
            .then(function(response){
                $scope.current.distribution.registration = response.data;
                if($scope.current.distribution.isSleeve) {
                    $scope.current.distribution.key = response.data.id;
                    return $http.get("/Trading/Sleeve/Registrations/" + response.data.id + "?stubSleeve=false&includeAssets=true&includeCostBasis=false", {

                        trackerMsg: 'Checking sleeve information'
                    });
                }
                else {
                    $scope.current.distribution.key = account.id;
                    return $http.get("/Portfolio/Assets?accountId=" + account.id, {

                        trackerMsg: 'Loading asset information'
                    });
                }
            })

            .then(function(response){
                $scope.current.sleeves = [];
                if(response.data) {
                    if ($scope.current.distribution.isSleeve) {
                        var filteredSleeves = response.data.accountSleeves.filter(function(n){ return n.sleeveType.toLocaleLowerCase() === "normal sleeve"; });
                        $scope.current.totalValue = Math.round(filteredSleeves.sum(function(item){ return item.currentValue; }) * 100) / 100;
                        filteredSleeves.each(function (item, index) {
                            var allAssets = item.assets;
                            var filteredAssets = allAssets.filter(function(n){ return (n.ticker !== $scope.current.cashTicker && !n.isCustodialCash) || n.id === item.sweepAssetId; });
                            var moneyMktAssets = allAssets.filter(function(n){ return n.ticker !== $scope.current.cashTicker && n.isCustodialCash && n.id !== item.sweepAssetId; });
                            var sweepAsset = filteredAssets.find(function(asset) { return asset.id === item.sweepAssetId; });
                            if(sweepAsset) { sweepAsset.currentValue += moneyMktAssets.sum(function(mm){ return mm.currentValue; }); }
                            $scope.current.sleeves.add({
                                id: item.accountId,
                                distributionAllocation: item.distributionAllocation,
                                sleeveDescription: item.sleeveDescription,
                                allocatedDollars: updateAllocation(item, index),
                                currentValue: item.currentValue,
                                doNotTrade: item.doNotTrade,
                                assets: filteredAssets.filter(function(n){return n.currentValue > 0;}).sortBy(function(n){ return n.name; })
                            });
                        });

                        //if distribution was started from sleeve wizard then default distribution type to passed in value
                        if($routeParams){
                            if($routeParams.dt && $routeParams.dt === 'D'){
                                $scope.current.distribution.distributionType = 'DistributionFullRebalance';
                            }
                        }
                    }
                    else {
                        var allAssets = response.data;
                        var filteredAssets = allAssets.filter(function(n){ return (n.ticker !== $scope.current.cashTicker && !n.isCustodialCash) || n.id === account.sweepAssetId; });
                        var moneyMktAssets = allAssets.filter(function(n){ return n.ticker !== $scope.current.cashTicker && n.isCustodialCash && n.id !== account.sweepAssetId; });
                        filteredAssets.find(function(asset) { return asset.id === account.sweepAssetId; }).currentValue += moneyMktAssets.sum(function(mm){ return mm.currentValue; });
                        $scope.current.totalValue = Math.round(filteredAssets.sum(function(asset){ return asset.currentValue; }) * 100) / 100;
                        filteredAssets.filter(function(n){return n.currentValue > 0;})
                            .sortBy(function(n){ return n.name; })
                            .each(function (asset, index) {
                                var item = {
                                    id: asset.id,
                                    sleeveDescription: asset.name,
                                    currentValue: asset.currentValue
                                };
                                item.distributionAllocation = calculateAssetPercent(asset, index);
                                item.allocatedDollars = updateAllocation(asset, index);
                                $scope.current.sleeves.add(item);
                            });
                    }
                    updateAssetAllocation();
                    if($scope.current.distribution.distributionType === 'ByFund')
                        roundingCheck($scope.current.sleeves);
                    $scope.current.executing = false;
                }
            });
    });

    $scope.$watch("current.distributionImportAccounts", function (newValue, oldValue) {
        if (newValue === oldValue || newValue.length === 0) return;

        //In case there was something in there.
        $scope.current.distribution = { key: 0, registration: null, account: null, isSleeve: true, distributionType: "DistributionFullRebalance", amount: 0, roundingLogic: 'Default'};
        $scope.current.distributionImportAccounts = newValue;
        fillGrid();

        //enable next if there's at least 1 or more valid rows
        var validRows = newValue.findAll({isValid:true});
        $scope.current.executing = validRows.length <= 0;

    });

    $scope.$watch("current.distribution.amount", function(newValue, oldValue) {
        if (newValue === oldValue) return;
        if($scope.current.sleeves.length > 0) {
            switch($scope.current.distribution.distributionType) {
                case "SellRebalance" :
                case "ProRata":
                    $scope.current.sleeves.each(function(item) {
                        item.allocatedDollars = newValue !== 0 ? allocateMoney(item.distributionAllocation, parseFloat(newValue)) : 0;
                    });
                    break;
                case "ByFund":
                    $scope.current.sleeves.each(function (item) {
                        if(!$scope.current.distribution.isSleeve)
                            item.allocatedDollars = newValue !== 0 ? allocateMoney(item.distributionAllocation, parseFloat(newValue)) : 0;
                        else {
                            item.assets.each(function (asset) {
                                asset.allocatedDollars = newValue !== 0 ? allocateMoney(parseFloat(asset.distributionAllocation), parseFloat(newValue)) : 0;
                            });
                        }
                    });
                    break;
            }
        }
    });

    //endregion

    //region EVENTS
    $scope.$on('event:orders-success', function(e, args){
        $scope.current.tradeInstanceId = args.parentId;
        $scope.next();
        $scope.current.executing = false;
    });
    $scope.$on('event:orders-error', function(e, args){
        var heading = "<i class='fa fa-exclamation-circle fa-lg text-error' aria-hidden='true'></i> Distribution: " + args.status;
        var msg = "<ol>";
        if(args.details.length > 0) {
            args.details.each(function(item){
                msg += "<li>" + item.errorMessage + " (Error ID: " + item.id + ")</li>";
            });
        }
        else {
            msg += "<li>" + item.message + "</li>";
        }
        msg += "</ol>";
        $dialog.messageBox(heading, msg).open();
        $scope.current.executing = false;
    });
    //endregion

    //region INITIALIZE
    $scope.rightsDistributions = $oasRights.forCode("TRADEDISTRIBUTION");
    $scope.maxPercent = 100;

    $scope.current = {loadedFromSSW:false,sswDefault:null, distributionImportEnabled:false, importRecords:{valid:0, total:0}, distributionImportAccounts: [], distributionImportGridReset: 0, openOrdersForAccount: 0, sellRebalanceRegLevel:'Registration', zeroOutPercentValues:false, distributionAmountType: 'Dollars', totalByFund:0, cashTicker: "DDACASH", wizardStep: 0, animation: 'slide-right', executing: false, sleeves: [], totalValue: 0, distribution: { key: 0, registration: null, account: null, isSleeve: false, distributionType: "Full", amount: 0, roundingLogic: "Default" }, tradeInstanceId: null, assetValues: "Default", assetValuesFeatureEnabled:false };
    $scope.wizardSteps = ["Distribution","Allocation","Finished"];

    //endregion

    init();
});


app.controller('TradeExecuteLogCtrl', function TradeExecuteLogCtrl($scope, $http, $oasRights) {

    //PUBLIC METHODS

    $scope.submitChange = function(){

        var deleteArray = [];
        var reschedArray = [];

        $scope.listSchedJobs.forEach(function(job){
            if (job.changeStatus == 'Rescheduled'){
                deleteArray.remove(job.id);

                if (reschedArray.findIndex(job.id) == -1)
                    reschedArray.push(job.id);
            }
            else if(job.changeStatus == 'Delete'){
                reschedArray.remove(job.id);

                if (deleteArray.findIndex(job.id) == -1)
                    deleteArray.push(job.id);
            }
            else{
                deleteArray.remove(job.id);
                reschedArray.remove(job.id);
            }
        });

        if (reschedArray.length > 0){
            $http.put("/Trading/ExecutionLogs/Schedules/Action/QueueStatus?status=rescheduled", reschedArray, {trackerMsg: 'Updating job schedule for reschedule'})
                .then(function(){

                    if (deleteArray.length > 0) {
                        $http.put("/Trading/ExecutionLogs/Schedules/Action/QueueStatus?status=delete", deleteArray, {trackerMsg: 'Updating job schedule for delete'})
                            .then(function(){
                            loadSchedule();
                            });
                    }
                    else{
                        loadSchedule();
                    }

                });
        }
        else if (deleteArray.length > 0) {
            $http.put("/Trading/ExecutionLogs/Schedules/Action/QueueStatus?status=delete", deleteArray, {trackerMsg: 'Updating job schedule for delete'})
                .then(function(){
                    loadSchedule();
            });
        }




    };

    //PRIVATE METHODS
    var setNewDate = (function() {
        $scope.current.isToday = (Date.create($scope.current.fileDate).format('{yyyy}-{MM}-{dd}') == Date.create('today').format('{yyyy}-{MM}-{dd}'));
        loadData();
    }).debounce(350);


    function loadData(){

        loadSchedule();
        loadLog();

    }

    function loadSchedule(){

        $scope.listSchedJobs = [];

        $http.get('/Trading/ExecutionLogs/Schedules/' + Date.create($scope.current.fileDate).format('{yyyy}-{MM}-{dd}'), {trackerMsg: 'Loading job schedules'})
            .then(function (response) {
                response.data.forEach(function(itm){
                    itm.changeStatus = '';
                });

                $scope.listSchedJobs = response.data;
            });

    }

    function loadLog(){

        $scope.current.logFileText = '';
        var logFiles = [];
        var combinedLogFile = [];

        $http.get('/Trading/ExecutionLogs/' + Date.create($scope.current.fileDate).format('{yyyy}-{MM}-{dd}'), {trackerMsg: 'Loading trade execution log'})
            .then(function (response) {
                logFiles = response.data;

                logFiles.forEach(function(logitm){
                        combinedLogFile.push(logitm.blobText);
                    }
                );

                $scope.current.logFileText = combinedLogFile.join();
            });

    }


    // PRIVATE VARIABLES


    // INITIALIZE
    $scope.current = {
        logFileText: '',
        fileDate: Date.create('today'),
        isToday: true,
        changeStatus: ''
    };

    $scope.rightsTradeWiz = $oasRights.forCode("TREXECLOG");

    loadData();


    //WATCHES
    $scope.$watch("current.fileDate", function (newValue, oldValue) {
        if (newValue === oldValue) return;
        setNewDate();
    });

});


'use strict';

app.controller('TradeInstanceListCtrl', function TradeInstanceListCtrl($scope, $http, $oasRights, $routeParams, $timeout, $location, $dialog, views) {
    // PRIVATE MEMBERS
    var tradeInstanceId;
    var blobId;

    //PRIVATE METHODS
    function getInstanceLogs() {
        $scope.current.instanceLogAccounts = [];
        if(tradeInstanceId == null) {
            return;
        }

        $http.get('/Trading/RebalanceLog/Instance/Simple/' + tradeInstanceId, { trackerMsg: 'Loading logs for instance' })
            .then(function (response) {
                $scope.current.instanceLogAccounts = response.data || [];
            });
    }

    // PUBLIC METHODS
    $scope.exportToExcel = function () {
        $scope.$broadcast('event:trading-instances-action', {action: 'export-data'});
    };

    $scope.refreshGrid = function () {
        $timeout(function () {
            $scope.$broadcast('event:trading-instances-action', {action: 'refresh-grid'});
        });
    };

    $scope.openOrders = function () {
        $location.url('/trading/tom/orders/?tradeInstanceId=' + tradeInstanceId + '&startDate=' + $scope.current.filterStartDate.formatted( ) + '&endDate=' + $scope.current.filterEndDate.formatted( ));
    };

    $scope.closedOrders = function () {
        $location.url('/trading/tom/closed/0?tradeInstanceId=' + tradeInstanceId + '&startDate=' + $scope.current.filterStartDate.formatted( ) + '&endDate=' + $scope.current.filterEndDate.formatted( ));
    };

    $scope.viewLog = function () {
        $dialog.dialog({
            dialogClass: "modal wide", templateUrl: "trading/views/tom-account-log.html", controller: "TOMAccountLogCtrl",
            resolve: {
                instanceId: function () { return tradeInstanceId; },
                accounts: function () { return $scope.current.instanceLogAccounts; }
            }
        }).open();
    };

    $scope.viewInstanceParameters = function () {
        $dialog.dialog(
            {
                templateUrl: 'trading/instanceParameters/views/instance-parameters-list.html',
                controller: 'InstanceParametersListCtrl',
                resolve: {
                    args: function () {
                        return {blobId: blobId};
                    }
                },
                dialogClass: 'modal wide'
            })
            .open()
            .then(function () {
            });
    };

    // LISTENERS
    $scope.$on("event:trading-instances-select", function (e, args) {
        tradeInstanceId = args.length === 1 ? args[0].id : null;
        blobId = args.length === 1 ? args[0].blobId : null;

        $scope.current.canCreateFee = $oasRights.canRead("CREATEFEEFROMDIST") && args.all({requestType: 'Distribution'});
        $scope.current.canViewOrders = args.length === 1 && $oasRights.canRead("TRADEORDERMGMT");
        $scope.current.canCreateBlocks = $scope.rightsInstances.canUpdate && $oasRights.canUpdate("EXECTRADES") && args.all({ isReady: true }) && args.all({ downloadManagerId: null });

        getInstanceLogs();
    });


    // INITIALIZE
    $scope.rightsInstances = $oasRights.forCode("TRADEINSTANCES");
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {view: views[0], filterStartDate: $routeParams.entity ? Date.create( 'a year ago' ) : Date.create( 'yesterday' ), filterEndDate: Date.create( 'today' ), readyState: true,
        instanceId: $routeParams.instanceId, url : $routeParams.instanceId ? '/Trading/Instances/' + $routeParams.instanceId : '/Trading/Instances', entity : $routeParams.entity,
        entityId : $routeParams.entityId, instanceLogAccounts: []
    };
});
'use strict';

app.controller('PendAccountListCtrl', function PendAccountListCtrl($scope, $http, $oasRights,$dialog, views) {

    // PUBLIC METHODS
    $scope.exportToExcel = function() {
        $scope.$broadcast('event:trading-pendaccounts-action', {action: 'export-data'});
    };

    $scope.refreshGrid = function( ) {
        $scope.$broadcast('event:trading-pendaccounts-action', {action: 'refresh-grid'});
    };

    $scope.addToGrid = function( ) {
        var formData = { accountId : $scope.current.account.id, accountNumber: $scope.current.accountNumber, tradeDate: $scope.current.tradeDate };
        $http.post('/Trading/PendAccounts', formData, {trackerMsg: 'Adding pending account'})
            .then(function(){
                $scope.refreshGrid();
            });
    };

    $scope.addPendAccountsFromImport = function() {

        var executeImport = function(accounts){
            var urlSave = '/Trading/PendAccounts';
            $scope.current.creatingFromImport = true;
            $http( { method: 'PUT', url: urlSave, data: accounts, trackerMsg:'Importing accounts to pend list' } )
                .then( function (  ) {
                    $dialog.messageBox("Import Complete!", "The following " + validAccounts.length + " records were imported successfully")
                        .open()
                        .then(function(result){
                            $scope.refreshGrid();
                            $scope.resetImport();
                        });

                });
        };

        var validAccounts = $scope.pendAccountListImporter.accounts.findAll({isValid: true});
        var tempAccounts  = [];

        if (validAccounts.length > 0) {
            validAccounts.forEach(function(acctItem){
                tempAccounts.add({ accountId : acctItem.id, accountNumber: acctItem.number, tradeDate: $scope.current.tradeDate });
            });
            executeImport(tempAccounts);
        }
    };

    $scope.deleteAccountFromList = function(){
        $dialog.confirmAction('Are you sure you want to delete selected accounts from pend list?')
            .open()
            .then(function (result) {
                if (result === 'yes') {
                    $http.put('/Trading/PendAccounts/Action/Delete', $scope.selectedIds, {trackerMsg: 'Deleting selected accounts'})
                        .then(function(response) {
                           $scope.refreshGrid();
                        });
                }
            })
    };

    $scope.resetImport = function () {
        $scope.pendAccountListImporter.accounts = null;
        $scope.resetWidth(false);
    };
    
    $scope.resetWidth = function (goWide) {
        $scope.rightSidebar.width = goWide ? 500 : 250;
    };
    
    $scope.$watch("current.account", function(newValue, oldValue) {
        if (newValue === oldValue || !angular.isObject(newValue)) return;

        $http.get('/Portfolio/Accounts/Verbose/' + newValue.id + "?expand=billing", {trackerMsg: 'Loading account information'})
            .then(function(response){
                $scope.current.accountNumber = response.data.number;
            })
    });


    // INITIALIZE
    $scope.rightsPendAccounts = $oasRights.forCode("FTJPENDACCOUNTS");
    $scope.pendAccountListImporter = {accounts: null};

    $scope.views = views;

    $scope.selectedIds = [];
    $scope.current = { view : views[0], tradeDate : Date.create(), account : null, accountNumber: null };

});
'use strict';

app.controller('IRebalExportCtrl', function IRebalExportCtrl($scope, $http, $location, $dialog, API_CONFIG, $oasRights, $dataQuery) {
    //PRIVATE METHODS
    function loadData() {
        $http.get('/Integrations/iRebal', {trackerMsg: 'Loading iRebal files'})
            .then(function (response) {
                $scope.files = response.data;
                getStatus();
            });
    }

    function getStatus() {
        $http.get('/Integrations/iRebal/Status', {trackerMsg: 'Loading iRebal status'})
            .then(function (response) {
                $scope.current.status = response.data;

                switch ($scope.current.status.toLowerCase()) {
                    case "success":
                        $scope.current.statusMsg = 'The files are staged, waiting for pickup - ' + Date.create($scope.files[3].createdDate).formatted(true);
                        break;
                    case "not started":
                        if ($scope.current.runningJobId) {
                            $scope.current.statusMsg = 'Files are being processed';
                            $scope.current.status = 'running';
                        } else {
                            $scope.current.statusMsg = 'No files are staged';
                        }
                        break;
                    default:
                        $scope.current.statusMsg = $scope.current.status;
                        $scope.current.status = 'running';
                }
            });
    }

    function createNewFiles() {
        $http.put("/Integrations/iRebal/Action/Schedule", {trackerMsg: 'Schedule job to generate files'})
            .then(function (response) {
                $scope.current.runningJobId = response.data;
                $scope.files = [];
            });
    }


    //PUBLIC METHODS
    $scope.refreshStatus = function () {
        loadData();
    };

    $scope.generateNew = function () {
        $scope.current.status = 'running';
        $scope.current.statusMsg = 'File processing has started.';
        createNewFiles();
    };

    $scope.downloadZip = function () {
        window.location.href = API_CONFIG.baseUrl + '/Integrations/iRebal/Download?Authorization=' + sessionStorage.oas_token;
    };

    $scope.runExportHistoryDataQuery = function () {
        $dialog.dataQueryPrompt(9248) //iRebal Export History Log
            .open()
            .then(function (result) {
                if (result && result.id) {
                    $dataQuery.setDataQuery(result);
                    $location.path('/reports/dataqueries/' + result.id);
                }
            });
    };


    // INITIALIZE
    $scope.current = {status: '',statusMsg: '',runningJobId: ''};
    loadData();
});



'use strict';

app.controller('SleeveSetupWizardCtrl', function SleeveWizardCtrl($scope, $http, $q, $route, $rebalance, $settings, $timeout,$rootScope, $oasRights, $location, $tradeGenerator,  sleeveType, agGridSelectionService) {

    //region Public Variables
        var assetExclusionRowData;
        var newAllocationsOriginal;

    //endregion

    //region Public Methods

    $scope.back = function() {
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep -= 1;

        if($scope.current.wizardStep === 2){
            if(!assetExclusionRowData) {
                $scope.getAccountAssets($scope.current.selectedAccount.registrationId);
            }else {
                $timeout(function () {
                    $scope.assetExclusionGridOptions.api.setRowData(assetExclusionRowData);
                    $scope.assetExclusionGridOptions.api.sizeColumnsToFit();
                    var currentSelection = agGridSelectionService.getCollection('assetExclusion-grid');
                    if(currentSelection){
                        updateSelections();
                    }
                },100);
            }
        }
    };

    $scope.next = function() {

        if($scope.current.setupChoice !== 0){
            var params = $scope.current.setupChoice === 1 ? '?dt=F&lf=true' : '?dt=D&lf=true';
            $location.url('/trading/distributions' + params)
        }

        $scope.current.animation = 'slide-right';
        $scope.current.wizardStep += 1;

        if($scope.current.wizardStep === 2){
            if(!assetExclusionRowData) {
                $scope.getAccountAssets($scope.current.selectedAccount.registrationId);
            }else {
                $timeout(function () {
                    $scope.assetExclusionGridOptions.api.setRowData(assetExclusionRowData);
                    $scope.assetExclusionGridOptions.api.sizeColumnsToFit();
                    updateSelections();
                },100);
            }

            //clear out data for chart
            $scope.wizardChart.pieChartNewAllocation.config.series[0].data = [];

            //check for unmanaged sleeve
            $timeout(function(){
                $scope.current.unManagedSleeveMatch = $scope.sleeveSetup.normalSleeves().any(function(a){
                    return a.modelAggId === $scope.current.unManagedSleeveAccountModelAggId;
                });
            },0);

            $scope.sleeveSetup.normalSleeves().forEach(function (sleeve) {
                sleeve.modelAgg = sleeve.model.name;
                sleeve.modelAggId = sleeve.model.id;
                $scope.wizardChart.pieChartNewAllocation.config.series[0].data.add({name: sleeve.modelAgg, y:sleeve.targetAllocation});
            });
        }

        if($scope.current.wizardStep === 3){
            $scope.current.wizardObj.includedAssets = [];
            $scope.current.wizardObj.excludedAssets = [];
            $scope.assetExclusionGridOptions.api.forEachNode(function(rowNode, index){
                if(rowNode.isSelected()){
                    $scope.current.wizardObj.excludedAssets.add({id:rowNode.data.id, name:rowNode.data.name, ticker:rowNode.data.ticker});
                }else{
                    $scope.current.wizardObj.includedAssets.add({id:rowNode.data.id, name:rowNode.data.name, ticker:rowNode.data.ticker});
                }
            });
            $scope.current.excludedAssets.forEach(function(item){
                $scope.current.wizardObj.excludedAssets.add({id: item.id, name: item.name, ticker: item.ticker});
            })
        }
    };

    $scope.jumpBackTo = function(index) {
        if ($scope.current.executing) return;

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };

    $scope.isStepIncomplete = function() {
        // this is a hack because of the way it was written
        switch ($scope.current.wizardStep) {
            case 0:
                return false;
               break;
            case 1:
                return !$scope.current.sleeveAllocationTotal.almostEquals(100);
                break;
            case 2:
                return false;
                break;
            default:
                return false;
        }
    };

    $scope.addStrategyDetail = function () {
        var sleeve = {
            sleeveStrategyId: null,
            sleeveType: 0,
            targetAllocation: 0,
            aggregateModelId: null,
            platformId:null,
            subAdvisorId: null,
            upperTolerance:0,
            lowerTolerance: 0,
            autoTradeTypes: 0,
            selectedAutoTradeTypes: []
        };

        $scope.sleeveSetup.details.add(sleeve);

        //TODO: calculate totals

    };

    $scope.getAccountAssets = function (id) {
        var bindAssetRows = function (rowData) {
            var collection = agGridSelectionService.getCollection('assetExclusion-grid');
            $timeout(function () {
                assetExclusionRowData = rowData;
                $scope.assetExclusionGridOptions.api.setRowData(assetExclusionRowData);
                $scope.assetExclusionGridOptions.api.sizeColumnsToFit();
                updateSelections();
            },500);
        };

        if($scope.current.setupChoice === 0){
            $http.get('/Portfolio/Assets/Simple?hasValue=true&registrationId=' + id, {trackerMsg:'Retrieving account assets'})
                .then(function (response) {
                    var tempData = response.data.exclude({ticker:'CUSTODIAL_CASH'});
                    $scope.current.excludedAssets.forEach(function(item){
                       tempData = tempData.exclude({id: item.id});

                    });
                    bindAssetRows(tempData);
                })
        }
    };

    $scope.buildWizardSteps = function (stepName) {

        switch (stepName){
            case 'Rebalance' :
                $scope.wizardSteps = ["Let's Begin","Sleeve Setup","Overrides","Distributions", "Review"];
                break;

            case 'Liquidate':
            case 'Raise Cash':
                $scope.wizardSteps = ["Distribution"];
                break;
        }

    };

    $scope.resetAccount = function () {
        $scope.current.selectedAccount = null;
        $scope.sleeveSetup = null;
        $scope.current.sleeveAllocationTotal = 0.00;
        $scope.isStepIncomplete();

        resetAll(false);
    };

    $scope.removeStrategyDetail = function (sleeve) {
        $scope.sleeveSetup.accountSleeves.remove(sleeve);
        if($scope.sleeveSetup.accountSleeves.length > 0){
            $scope.calculateAllocationTotals();

            // check to see if unmanaged sleeve was removed.
            $scope.current.unManagedSleeveMatch = $scope.sleeveSetup.accountSleeves.any(function(a){
                return a.modelAggId === $scope.current.unManagedSleeveAccountModelAggId;
            })
        }
    };

    $scope.addAccountSleeve = function () {
        var last = $scope.sleeveSetup.accountSleeves.last();
        var sleeve = angular.extend({accountId: 0, targetBalanceType:1, sleeveType: sleeveType.normal.name, targetAllocation: 0}, Object.select(last, "toleranceLower", "toleranceUpper", "modelType", "subAdvisorId", "managementStyleId"));
        $scope.sleeveSetup.accountSleeves.push(sleeve);
        $scope.calculateAllocationTotals();
    };

    $scope.calculateAllocationTotals = function () {
        $scope.current.sleeveAllocationTotal = $scope.sleeveSetup.normalSleeves().findAll({targetBalanceType: 1}).sum('targetAllocation');
    };

    $scope.processSleeves = function () {
        $scope.current.executing = true;
        var tradeDef = null;

        var runDistributionFullRebalance = function () {
            $tradeGenerator.getTradeDefinition("Rebalance")
                .then(function(response){
                    tradeDef = response.data;
                    tradeDef.level = 'Registration';
                    tradeDef.keys = [$scope.current.selectedAccount.id];
                    tradeDef.entity = "Account";
                    tradeDef.amounts = [parseFloat($scope.current.wizardObj.distributionAmount)];
                    tradeDef.roundingLogic = "Default";
                    tradeDef.instanceType = "Distribution";
                    tradeDef.reason = "NeedReview";
                    tradeDef.openOrders = $scope.current.openOrdersForAccount;
                    $tradeGenerator.submitTradeDefinition(tradeDef);
                })
        };

        //Assets
        $scope.sleeveSetup.includedAssets = $scope.current.wizardObj.includedAssets.map('id').unique();
        $scope.sleeveSetup.excludedAssets = $scope.current.wizardObj.excludedAssets.map('id').unique();

        var accountSleeveDefault = $scope.sleeveSetup.accountSleeves.find({modelAggId: $scope.current.unManagedSleeveAccountModelAggId});
        if(accountSleeveDefault){
            accountSleeveDefault.replenishMinCash = $scope.current.wizardObj.replenishMinCash;
            accountSleeveDefault.minimumCash = $scope.current.wizardObj.minimumCash;
        }

        var url = '/Trading/Sleeve/Registrations/Action/Process/SleeveSetUpWizard';
        if($scope.current.wizardObj.distributionAmount >= 1){
            url += '?isRegFullRebalance=true'
        }

        $http({method: 'POST', url:url , data: $scope.sleeveSetup, trackerMsg:'Processing distribution sleeves'})
            .then(function(response) {
                if(response.data){
                    if($scope.current.wizardObj.distributionAmount >= 1){
                        runDistributionFullRebalance();
                    }else{
                        resetAll(true);
                    }
                }
            });
    };

    $scope.finishedWithProcess = function(){
        resetAll(true);
        //$location.path('/trading/instances');
    };

    $scope.showHelpText = function (option) {
        var text = null;
        switch (option) {
            case 'Excluded Rebal Sleeve':
                text = "This will keep the sleeve from being journaled out of, or traded in a Portfolio (Registration) level rebalance. Raise/spend cash trades can continue to occur, as well as individual sleeve level rebalances.";
                break;
        }
        if(text) {
            $dialog.messageBox(option, text).open();
        }
    };

    //endregion

    //region Private Methods
    function init(){
        if($oasRights.forCode('SLEEVESETUP').canRead){
            buildPieChartConfig();
            loadSleeveStrategies();
        }else{
            $location.path('/notauthorized');
        }
    }
    function resetAll(everything){

        $scope.current.executing =false;
        $scope.sleeveStrategies = [];
        $scope.excludedAssets = [];
        $scope.includedAssets = [];

        $scope.current.wizardObj.openOrdersForAccount=0;
        $scope.current.wizardObj.accountSleeves = [];
        $scope.current.wizardObj.excludedAssets = [];
        $scope.current.wizardObj.includedAssets = [];
        $scope.current.wizardObj.minimumCash = 0.00;
        $scope.current.wizardObj.distributionAmount= 0.00;
        $scope.current.wizardObj.replenishMinCash = false;
        $scope.current.sleeveAllocationTotal = 0;
        $scope.current.selectedAccount = null;
        $scope.sleeveSetup = null;
        $scope.wizardChart.pieChartCurrentAllocation.config.series[0].data = [];
        $scope.wizardChart.pieChartNewAllocation.config.series[0].data = [];

        if(everything){
            $scope.current.wizardStep = -1;
            $scope.setupChoice = 0;
            $scope.wizardSteps = [];
            $scope.current.animation = 'slide-right'
            $scope.buildWizardSteps('Rebalance');
            $scope.next();
        }
    }
    function loadSleeveStrategies(){
        $http.get('/Trading/SleeveStrategy/Simple', {cache: true, trackerMsg:'Getting Sleeve Strategies'})
            .then(function(response){
                $scope.sleeveStrategies = response.data;

            })
    }
    function buildPieChartConfig() {
        Highcharts.getOptions().colors = Highcharts.map(Highcharts.getOptions().colors, function (color) {
            return {
                radialGradient: {
                    cx: 0.5,
                    cy: 0.3,
                    r: 0.7
                },
                stops: [
                    [0, color],
                    [1, Highcharts.Color(color).brighten(-0.3).get('rgb')] // darken
                ]
            };
        });
        $scope.wizardChart.pieChartCurrentAllocation.config = {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            options: {
                legend: {
                    enabled:true,
                    align: 'right',
                    layout: 'vertical',
                    verticalAlign: 'top',
                    y: 20,
                    itemWidth: 250,
                    itemStyle: {
                        color: '#a9a9a9',
                        fontWeight: 'bold',
                        width: '245px',
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap"
                    },
                    useHTML: true
                },
                credits: {enabled: false}
            },
            title: {
                text: 'Current Allocation',
                style: {
                    color: '#a9a9a9',
                    fontWeight: 'bold'
                },
                useHTML: true
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer'
                }
            },
            series: [{
                name: 'Models',
                colorByPoint: true,
                type: 'pie',
                dataLabels: {
                    enabled: false
                },
                showInLegend: true,
                data: []
            }]
        };
        $scope.wizardChart.pieChartNewAllocation.config = {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            options: {
                legend: {
                    enabled:true,
                    align: 'right',
                    layout: 'vertical',
                    verticalAlign: 'top',
                    y: 20,
                    itemWidth: 250,
                    itemStyle: {
                        color: '#a9a9a9',
                        fontWeight: 'bold',
                        width: '245px',
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap"
                    },
                    useHTML: true
                },
                credits: {enabled: false}
            },
            title: {
                text: 'New Allocation',
                style: {
                    color: '#a9a9a9',
                    fontWeight: 'bold'
                },
                useHTML: true
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer'
                }
            },
            series: [{
                name: 'Sleeves',
                colorByPoint: true,
                type: 'pie',
                dataLabels: {
                    enabled: false
                },
                showInLegend: true,
                data: []
            }]
        };

    }
    function registrationSleeve(regId){
        $q.all({
           // selfDirectedId: $http.get("/Settings/Database/EntityOptions/Code/SELFDIRECTEDSUBADVID", {cache: true, trackerMsg: 'Loading model settings'}),
            maxNumberOfSleeves: $http.get('/Settings/Database/EntityOptions/Code/69MAXNUMBE', {cache: true, trackerMsg: 'Getting max number of sleeves'}),
            sleeveAutoRebalance: $http.get('/Settings/Database/EntityOptions/Code/69SLEEVEAU', {cache: true, trackerMsg: 'Loading sleeve options'}),
            //modelTypes: $http.get("/Trading/ModelAggs/AggTypes", {cache: true, trackerMsg: "Loading mandates"}),
            sleeveSetup: $http.get("/Trading/Sleeve/Registrations/" + regId + "?includeCostBasis=false", {trackerMsg: 'Loading sleeve data'}),
            canDeleteSleeves: $http.get('/Portfolio/Transactions/ValidationForUnsleeving/'+ regId, {trackerMsg: 'Validating if sleeves can be deleted'} ),
            enableDollarSleeves: $http.get('/Settings/Database/EntityOptions/Code/69ENABLEDO', {cache: true, trackerMsg: 'Verifying dollar sleeves allowed'}),
            tolerancePercentDefault: $http.get('/Settings/Database/EntityOptions/Code/69SLEEVETO', {cache: true, trackerMsg: 'Retrieving tolerance percent default'}),
            unManagedSleeveAccount: $http.get('/Settings/Database/EntityOptions/Code/1:69UNMANA', {cache: true, trackerMsg: 'Retrieving Un-Managed Sleeve'})
        })
            .then(function(responses){

                responses.sleeveSetup.data.accountSleeves.forEach(function (sleeve) {
                    if(sleeve.sleeveType === sleeveType.normal.name){
                        sleeve.modelAllocations = null;
                        sleeve.model = {id: sleeve.modelAggId, name: sleeve.modelAgg};
                        if(sleeve.managementStyle && sleeve.managementStyleId){
                            sleeve.mStyle = {id: sleeve.managementStyleId, name: sleeve.managementStyle};
                        }
                        sleeve.targetBalanceType = sleeve.targetBalanceType === 'Percent' ? 1 : 0;
                        $scope.wizardChart.pieChartCurrentAllocation.config.series[0].data.add({name: sleeve.modelAgg, y:sleeve.targetAllocation});
                    }
                });

                $scope.sleeveSetup = responses.sleeveSetup.data;

                $scope.current.unManagedSleeveAccountModelAggId = responses.unManagedSleeveAccount.data.value ? responses.unManagedSleeveAccount.data.value.toNumber(): '';

                $scope.current.sleeveStrategyId = $scope.sleeveSetup.sleeveStrategyId;

                $scope.tolerancePercentDefault = responses.tolerancePercentDefault.data.value ? responses.tolerancePercentDefault.data.value.toNumber() : null;

                $scope.sleeveSetup.normalSleeves = function () {
                    return $scope.sleeveSetup.accountSleeves.filter(function (t) {
                       return t.sleeveType === sleeveType.normal.name || t.sleeveType === sleeveType.unmanaged.name;
                    });
                };

                $scope.sleeveAutoRebalance = responses.sleeveAutoRebalance.data;

                $scope.canDeleteSleeves = responses.canDeleteSleeves.data === "true";

                $scope.enableDollarSleeves = responses.enableDollarSleeves.data.value.toLowerCase() === "true";

                //set max number of sleeves - code below grandfathers in registrations that have more sleeves then when enity option
                //for max number was created.
                var normalSleeveCount =  $scope.sleeveSetup.normalSleeves().length;
                var maxNumberOfSleeves = responses.maxNumberOfSleeves.data.value.toNumber();
                if(maxNumberOfSleeves !== 0){
                    $scope.current.maxNumberOfSleeves =  normalSleeveCount > maxNumberOfSleeves ? normalSleeveCount : maxNumberOfSleeves;
                }else{
                    $scope.current.maxNumberOfSleeves = maxNumberOfSleeves;
                }

                // if($scope.sleeveReg.sleeveStrategyId){
                //     setRebalanceFrequencies();
                // }

                $scope.sleeveSetup.specialSleeves = function () {
                    return $scope.sleeveSetup.accountSleeves.filter(function (x) {
                        return x.sleeveType !== sleeveType.normal.name;
                    });
                };



                //see if there are any exclusions.  This can be found be searching sleeveType = "Unmanaged sleeve" on account sleeve.
                //then looking at the assets, find all that != "CUSTODIAL_CASH" ticker.
                if($scope.current.unManagedSleeveAccountModelAggId){
                    var tempExclusions = $scope.sleeveSetup.accountSleeves.find({modelAggId:$scope.current.unManagedSleeveAccountModelAggId});
                    if(tempExclusions){
                        //set the min cash and replenish cash if there's a default unmanaged sleeve
                        $scope.current.wizardObj.minimumCash = tempExclusions.minimumCash;
                        $scope.current.wizardObj.replenishMinCash = tempExclusions.replenishMinCash;

                        //if un-managed sleeve has assets, push them to exclusion array.
                        if(!tempExclusions.assets.isEmpty()){
                            $scope.current.excludedAssets = tempExclusions.assets.findAll({isCustodialCash:false}).map(function(a){return{id: a.id, name: a.name, ticker: a.ticker } }).unique();
                        }
                        $scope.current.unManagedSleeveMatch = true;
                    }else{
                        $scope.current.unManagedSleeveMatch = false;
                    }
                }
                $scope.calculateAllocationTotals();
            })

}

    //region Grid Service Functions
    function rowSelected(event) {
        if(event.node.isSelected()){
            agGridSelectionService.addToCollection(event.node.data,'id', 'assetExclusion-grid')
        }else{
            agGridSelectionService.removeFromCollection(event.node.data, 'id', 'assetExclusion-grid');
        }
    }
    $scope.onAssetExclusionRowSelected = rowSelected;
    function updateSelections() {
        agGridSelectionService.updateInGridSelections($scope.assetExclusionGridOptions.api, 'id', 'assetExclusion-grid');
    }

    //endregion

    //endregion

    //region Watches
    $scope.$watch('current.selectedAccount', function (newValue, oldValue) {
        if (newValue === oldValue || !newValue) return;
        assetExclusionRowData = null;
        registrationSleeve(newValue.registrationId);

        $http.get('/Trading/Orders?status=open&accountId=' + newValue.id, {trackerMsg:'Checking if account has open orders'})
            .then(function (response) {
                $scope.current.openOrdersForAccount = response.data.length;
            });

    });

    //region EVENTS
    $scope.$on('event:orders-success', function(e, args){
        $scope.current.tradeInstanceId = args.parentId;
        // $scope.next();
        $scope.current.executing = false;
        resetAll(true);
    });

    $scope.$on('event:orders-error', function(e, args){
        var heading = "<i class='fa fa-exclamation-circle fa-lg text-error' aria-hidden='true'></i> Sleeve Setup Wizard: " + args.status;
        var msg = "<ol>";
        if(args.details.length > 0) {
            args.details.each(function(item){
                msg += "<li>" + item.errorMessage + " (Error ID: " + item.id + ")</li>";
            });
        }
        else {
            msg += "<li>" + item.message + "</li>";
        }
        msg += "</ol>";
        $dialog.messageBox(heading, msg).open();
        $scope.current.executing = false;
    });
    //endregion


    // $scope.$on(updateSelections, selectionService.getUpdatedSignal('assetExclusion-grid'));

    //endregion

    //region Initialize
    $scope.setupChoice =0;
    $scope.sleeveStrategies = [];
    $scope.current = {unManagedSleeveAccountModelAggId:'',unManagedSleeveMatch:false, excludedAssets: [],
            finishMsg:'Sleeve setup has completed.', wizardObj: {openOrdersForAccount:0, accountSleeves: [],excludedAssets: [],includedAssets: [], minimumCash: 0.00, replenishMinCash:false, distributionAmount: 0.00},
            sleeveAllocationTotal:0.00, currentAllocations:[],newAllocations:[], isActive: false,showFinishButton:false,
            showNextButton:false, wizardStep:0, animation: 'slide-right',selectedAccount:null, executing: false,
            setupChoice:0, setupChoices:[{id:0, name:'Rebalance'}, {id:1, name:'Liquidate'},{id:2, name:'Raise Cash'}]
    };
    $scope.wizardSteps = [];


    //Setup custom colors for Highcharts
    Highcharts.theme = {colors: ["#7cb5ec", "#f7a35c", "#90ee7e", "#7798BF", "#aaeeee", "#ff0066", "#eeaaee", "#55BF3B", "#DF5353", "#7798BF", "#aaeeee"]};
    Highcharts.setOptions(Highcharts.theme);

    $scope.wizardChart = {
        pieChartCurrentAllocation: {config:{}},
        pieChartNewAllocation : {config:{}}
    };

    $scope.assetExclusionGridOptions = { api: null };
    $scope.onSleeveAssetExclusionGridApi = function (api) {
        $scope.assetExclusionGridOptions.api = api;
        if (assetExclusionRowData) {
            api.setRowData(assetExclusionRowData);
            api.sizeColumnsToFit();
            updateSelections();
        }
    };
    //endregion

    $scope.buildWizardSteps('Rebalance');

    init();
});

app.service('agGridSelectionService', function agGridSelection () {

    var self = this;
    var collections = {};
    var preFix = 'agGrid-selection';
    var selectedGridRows = {};

    self.addToCollection = function (item, path, collection) {
        var selected = getCollection(collection);
        if(!selected.any(item) ){
            selected.push(item);
        }
        afterUpdate(collection, selected);
    };

    self.removeFromCollection = function (item, path, collection) {
        var selected = getCollection(collection);
        selected.remove(item);
        afterUpdate(collection, selected);
    };

    self.getCollection = function (collection) {
        return getCollection(collection);
    };

    // gridApi - ag-grid api
    // path - is a property used for lookup (i.e. 'id' or 'name')
    // collection - the collection of rows that should be selected / deSelected
    self.updateInGridSelections = function (gridApi, path, collection){

        var selectedInGrid = gridApi.getSelectedNodes(),
            currentlySelected = getCollection(collection),
            gridPath = 'data.' + path;


        selectedInGrid.forEach(function (node) {
            if (!currentlySelected.any(node.data)) {
                // The following suppressEvents=true flag is ignored for now, but a
                // fixing pull request is waiting at ag-grid GitHub.
                node.setSelected(false, false, 'api');
            }
        });

        var selectedIdsInGrid = selectedInGrid.map(path),
            currentlySelectedIds = currentlySelected.map(path),
            missingIdsInGrid =  (selectedIdsInGrid !== undefined) ? currentlySelectedIds.subtract(selectedIdsInGrid) : [];

        if (missingIdsInGrid.length > 0) {
            // We're trying to avoid the following loop, since it seems horrible to
            // have to loop through all the nodes only to select some.  I wish there
            // was a way to select nodes/rows based on an id.
            var i;

            gridApi.forEachNode(function (node) {
                i= missingIdsInGrid.findIndex(node.data.id);
                //i = _.indexOf(missingIdsInGrid, _.get(node, gridPath));
                if (i >= 0) {
                    // multi=true, suppressEvents=true:
                    node.setSelected(true, false, 'api');

                    missingIdsInGrid.splice(i, 1);  // Reduce haystack.
                    if (!missingIdsInGrid.length) {
                        // I'd love for `forEachNode` to support breaking the loop here.
                    }
                }
            });
        }
    };

    function getCollection(collection) {
        if (!Object.has(collections, collection)) {
            var data = loadCollection(collection);
            // Holds reference to a shared array.  Only mutate, don't replace it.
            collections[collection] = data !== undefined ? data : [];
        }

        return collections[collection];
    }

    function loadCollection(collection) {
        var item =  selectedGridRows[preFix + ':' + collection];
        return item !== null ? angular.fromJson(item) : item;
    }

    function persistCollection(collection, data) {
        selectedGridRows[preFix + ':' + collection] = angular.toJson(data);
    }

    function afterUpdate(collection, selected) {
        persistCollection(collection, selected);
       // broadcastUpdate(collection);
    }



});

'use strict';

app.controller('ContributionsCtrl', function ContributionsCtrl($scope, $http, $tradeGenerator, $location, $proratedCashTrades) {
    //PRIVATE VARIABLES
    var tradeGroups;


    //PRIVATE METHODS
    function init() {

        $http.get('/Trading/ContributionCodeExts', {cache: true, trackerMsg: 'Loading Contribution Codes'})
            .then(function (response) {
                $scope.contributionCodes = response.data;
            });

        setAccountSelection();
    }

    function setAccountSelection(){
        if ($scope.current.accountSelectionType === 2) {
            $scope.current.selectionTypeName = 'trade groups';
            $scope.current.availableItemsFilter = '';
            $scope.current.availableItems = angular.copy(tradeGroups);
            $scope.current.availableSelected = [];
        }
        else {
            $scope.current.selectionTypeName = 'accounts';
        }

        $scope.current.selectedItems = [];
        $scope.current.selectedSelected = [];

        var startedProrated = $proratedCashTrades.getCurrent();
        if (startedProrated) {
            $scope.current.wizardStep = 1;

            $http.post('/Portfolio/Accounts/Simple/List/Id', startedProrated.selectedIds, {trackerMsg: 'Loading accounts'})
                .then(function(response) {
                    $scope.current.selectedItems = response.data;
                    if (startedProrated.amount) {
                        $scope.current.selectedItems.forEach(function(a) {return a.amount = startedProrated.amount});
                    }
                    $proratedCashTrades.reset();
                });
        }
    }


    //PUBLIC METHODS
    $scope.back = function() {
        $scope.current.animation = 'slide-left';
        $scope.current.wizardStep -= 1;
    };

    $scope.next = function() {
        $scope.current.animation = 'slide-right';
        $scope.current.wizardStep += 1;
    };

    $scope.jumpBackTo = function(index) {
        if ($scope.current.executing) return;

        if (index < $scope.current.wizardStep) {
            $scope.current.animation = 'slide-left';
            $scope.current.wizardStep = index;
        }
    };

    $scope.isStepIncomplete = function() {
        switch ($scope.current.wizardStep) {
            case 0:
                return $scope.current.accountSelectionType < 0;
            case 1:
                let retVal = true;
                if ($scope.current.accountSelectionType === 1) {
                    retVal = $scope.current.selectedItems.count({isValid: true}) === 0 || $scope.current.selectedItems.count({isValid: false}) > 0;
                } else if ($scope.current.accountSelectionType === 0) {
                    retVal = $scope.current.selectedItems.length === 0 || !$scope.current.selectedItems.every(i => i.amount >= 0) || !$scope.current.selectedItems.every(i => i.contributionCodeId >= 0)
                }
                return retVal
            default:
                return false;
        }
    };

    $scope.addSelectedAccount = function() {
        if ($scope.current.selectedItems.none({id: $scope.current.selectedAccount.id})) {
            $scope.current.selectedItems.push($scope.current.selectedAccount);
        }
        $scope.current.selectedAccount = null;
    };

    $scope.submitContributions = function() {
        $scope.current.executing = true;

        var contributionList = [];
        var contribution = {};

        $scope.current.selectedItems.forEach(function(item) {

            contribution.PkAccount = item.id;
            contribution.Amount = item.amount;
            contribution.ContribCode = null;
            contribution.ContribCode = $scope.contributionCodes.find(x => x.id === item.contributionCodeId).code;
            contribution.FkContribCode = item.contributionCodeId;

            contributionList.push(contribution);
            contribution = {};
        });

        $tradeGenerator.generateContributions(contributionList)
            .then(function() {
                    $location.path('/trading/instances');
                }, function() {
                    $scope.current.executing = false;
                }
            );

    };


    //INITIALIZE
    $scope.current = {accountSelectionType: 0,  wizardStep: 0, animation: 'slide-right', executing: false, selectedAccount: null, availableItems: [], availableSelected: [], selectedItems: [], selectedSelected: [], selectedContributionCodeExtId: 0};
    $scope.wizardSteps = ["Selection Method", "Filter Selections", "Review"];
    init();


    //WATCHES
    $scope.$watch("current.accountSelectionType", function (newValue, oldValue) {
        if (newValue === oldValue) return;

        setAccountSelection();
    });
});

'use strict';

app.controller('AstroLightWizardCtrl', function AstroLightWizardCtrl($scope, $sce, API_CONFIG) {
    var page = '/presentation?widgetCodes=portAstroTrading&showTools=0&showHeader=0';
    $scope.url = $sce.trustAsResourceUrl(API_CONFIG.insightUrl + '?t=' + sessionStorage.oas_token + '&p=' + encodeURIComponent(page));
});

'use strict';

var portfolioTargetHouseholdListCtrl = app.controller('PortfolioTargetHouseholdListCtrl', function PortfolioTargetHouseholdListCtrl($scope, $q, $dialog, views, $route, $routeParams, $timeout, $http, $location, $tradeGenerator) {
    //PRIVATE VARIABLES
    var repDisableRiskAlertEO = null;

    var config = {repId: 0, model: null};

    //PRIVATE METHODS
    function init() {
        if($location.path().has('/embed/')){
            if($scope.user.authorization.entity === 'Representative' ){
                config.repId = $scope.user.authorization.entityId;
                loadHouseholds(true);
                loadRepRiskAlert();
            }else{
                $scope.startOver();
            }
        }else{
            $scope.startOver();
        }
    }

    function setConfigDefaults (configResult){
        $scope.current.rep = configResult.rep;
        $scope.current.model = configResult.model;
        config = configResult;
    }


    function loadHouseholds(isfiltered){
        if(!config) return;

        var strParams = "returnStyle=BlendedModelManagement&isActive=true&representativeId=" + config.repId;

        if (config.model) {
            strParams += "&sleeveStrategyId=" + config.model.id;
        }


        $scope.current.url = '/portfolio/clients';
        $scope.current.params = strParams;

        refreshGrid();

    }

    function refreshGrid() {
        $timeout(function () {
            $scope.$broadcast('event:target-households-action', {action: 'refresh-grid'});
        });
    }


    function loadRepRiskAlert(){
        //make call to get the enable risk alert for this config.repId
        if (repDisableRiskAlertEO){
            return;
        }

        $http.get("/Settings/EntityOptions/Representative/" + config.repId + "/Code/69DISABLER", {trackerMsg: 'Loading rep disable risk alert setting'})
            .then(function (response) {
                repDisableRiskAlertEO = response.data;
                $scope.current.disableRepRiskAlert = repDisableRiskAlertEO.value.toLowerCase() === "true";
            });

    }

    function openHouseholdModelPrompt (hasModelFilter) {
        return $dialog.dialog({templateUrl: "trading/portfolioTargets/modals/sleeve-strategy-prompt.html", controller: "SleeveStrategyPromptCtrl", isFiltered:hasModelFilter})
            .open()
            .then(function (result) {
                if (result) {
                    return {model: result.model, repId: result.repId, isFiltered:result.isFiltered};
                }
                else {
                    var deferred = $q.defer();
                    deferred.reject();
                    return deferred.promise;
                }
            });
    }

    function processNeedsUpdate(id){
        var sleeveDataRegistrations = {assignedRegistrationIds: [], unAssignedRegistrationIds: []};

        if($scope.current.regNeedsUpdate.length > 0){
            var ids = [];
            $scope.current.regNeedsUpdate.forEach(function(item){
                for(var i = 0; i <= item.needsUpdateRegIds.length - 1; i++){
                    ids.push(item.needsUpdateRegIds[i]);
                }
            });
            sleeveDataRegistrations.assignedRegistrationIds = ids;
        }

        $http.post('/Trading/SleeveStrategy/' + id + '/Action/Process/Registration', sleeveDataRegistrations)
            .then(function (response) {
                if(response && response.data > 0){
                    $tradeGenerator.startPolling(response.data, false);
                    $scope.$on('event:orders-success', function () {
                        $dialog.messageBox("<i class='fa fa-lg fa-check-square' aria-hidden='true'></i> Action Complete", "Registration process completed successfully.").open()
                            .then(function(){
                                loadHouseholds(true);
                            });
                    });
                    $scope.$on('event:orders-error', function (e, args) {
                        $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Process Error", "There was an error updating registration for this sleeve strategy").open();
                    });
                }else{
                    loadHouseholds(true);
                }
            });
    }

    //PUBLIC METHODS
    $scope.startOver = function () {
        $routeParams.filter = 1;
        openHouseholdModelPrompt(true)
            .then(function(result){
                setConfigDefaults(result);
                loadHouseholds()
            })

    };

    $scope.refreshGrid = function () {
        $scope.$broadcast('event:target-households-action', {action: 'refresh-grid'});
    };

    $scope.exportToExcel = function () {
        $scope.$broadcast('event:target-households-action', {action: 'export-data'});
    };

    $scope.viewHousehold = function () {
        $dialog.dialog({dialogClass: "modal wide", templateUrl: "portfolio-target-household.html", controller: "PortfolioTargetHouseholdCtrl", householdId: $scope.selectedIds[0]}).open();
    };

    $scope.slickGridDoubleClick = function () {
        if ($scope.selectedIds.length === 1) {
            $scope.viewHousehold();
        }
    };

    $scope.processRegistrationsNeedingUpdate = function(){
        if($scope.current.regNeedsUpdate.length > 0){
            processNeedsUpdate(config.model.id);
        }
    };

    $scope.toggleRiskAlert = function (isRep, disable) {
        if (isRep){
            $scope.current.disableRepRiskAlert = !$scope.current.disableRepRiskAlert;
            repDisableRiskAlertEO.value = $scope.current.disableRepRiskAlert;
            $http.put("/Settings/EntityOptions/Representative/Code/69DISABLER", repDisableRiskAlertEO, {trackerMsg: "Saving disable risk alert"})
                .then(function (response) {
                    $scope.$broadcast('event:target-households-action', {action: 'refresh-grid'});
                });
        }
        else{
            $http.post("/Portfolio/Clients/Action/ToggleRiskAlerts?disable=" + disable, $scope.selectedIds, {trackerMsg: 'Saving disable risk alert'})
                .then(function (response) {
                    if( response.data ) {
                            $scope.$broadcast( 'event:target-households-action', {action: 'update-items', items: response.data } );
                    }
                });

        }
    };


    //INITIALIZE
    $scope.rightSidebar.isOpen = false;

    $scope.views = views;

    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        gridQueries: [],
        model: null,
        disableClientRiskAlert: true,
        regNeedsUpdate: []
    };

    $scope.selectedIds = [];

    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: $scope.slickGridDoubleClick
    }];

    init();

    //EVENT LISTENERS
    $scope.$on("event:target-households-select", function (e, args) {
        if (args.length === 0) return;

        $scope.current.disableClientRiskAlert = args[0].disableRiskAlerts;
    })
    $scope.$on('slickgrid-data-loaded', function(event, data) {
        $scope.current.regNeedsUpdate = data.filter({needsUpdate: true});
    });



});


portfolioTargetHouseholdListCtrl.chooseSleeveStrategy = ["$http", "$dialog", "$q","$location","$rootScope", function ($http, $dialog, $q, $location, $rootScope) {

    //this will always be from FTJ
    if($location.path().has('/embed/')){
        var config = {
            repId: 0,
            model: null
        };
        var deferred = $q.defer();
        return deferred.resolve(config);
    }

    if($rootScope.user.authorization.entity === 'Representative' ) {
        return {repId: $rootScope.user.authorization.entityId, model:null, isFiltered:false};
    }else{
        return $dialog.dialog({templateUrl: "trading/portfolioTargets/modals/sleeve-strategy-prompt.html", controller: "SleeveStrategyPromptCtrl", isFiltered:false})
            .open()
            .then(function (result) {
                if (result) {
                    return {model: result.model, repId: result.repId, isFiltered:result.isFiltered};
                }
                else {
                    var deferred = $q.defer();
                    deferred.reject();
                    return deferred.promise;
                }
            });
    }

}];


app.controller('PortfolioTargetHouseholdCtrl', function PortfolioTargetHouseholdCtrl($scope, $http, $dialog, dialog, API_CONFIG, tokenFactory) {
    //PRIVATE VARIABLES
    var profiles;


    //PRIVATE METHODS
    function init() {
        $http.get("/Security/Profiles?entity=5&entityId=" + dialog.options.householdId, {trackerMsg: "Loading profiles"})
            .then(function (response) {
                profiles = response.data.map(function (p) {
                    return {id: p.userDetailId, name: p.loginUserId};
                });

                $scope.clientView.mode = profiles.length > 1 ? "multiple" : profiles.length ? "single" : "none";

                if ($scope.clientView.mode === "single") {
                    tokenFactory.getUserDetailToken(profiles[0].id)
                        .then(function (token) {
                            $scope.clientView.url = API_CONFIG.clientPortalUrl + "?t=" + token;
                        });
                }
            });

        $http.get("/Portfolio/Clients/" + dialog.options.householdId + "?returnStyle=BlendedModelManagementDetails&onlyActive=true", {trackerMsg: "Loading household"})
            .then(function (response) {
                $scope.household = response.data;
            });

        //$scope.advisorViewUrl = API_CONFIG.insightUrl + '?p=' + encodeURIComponent('dashboard?id=' + (API_CONFIG.insightUrl.has('test') ? '486' : '703') + '&entityEnum=5&entityId=' + dialog.options.householdId + '&startDate=' + Date.create().beginningOfYear().formatted() + '&endDate=' + Date.create().formatted() + '&datePickers=show') + '&t=' + sessionStorage.oas_token;

        $scope.advisorViewUrl = 'https://' + (window.location.host.indexOf('test') !== -1 ? 'test' : '') + 'apps.advisorlynx.com/integration/default.aspx?p=/portfolio/dashboard.aspx&s=' + sessionStorage.oas_token + '&a=webapi&cli=' + dialog.options.householdId;

    }


    //PUBLIC METHODS
    $scope.getRegistrationEditorRoute = function(registration) {
        return "#/portfolio/edit/registrations/" + registration.id + "?tabCode=sleeveSetup&isFullPage=true&showCancel=false";
    };
    
    $scope.promptForClientViewProfile = function () {
        $dialog.inputBox("Multiple Profiles", "Select Profile", profiles, {inputValue: profiles[0]})
            .open()
            .then(function (result) {
                if (!result) return;

                tokenFactory.getUserDetailToken(result.id)
                    .then(function (token) {
                        window.open(API_CONFIG.clientPortalUrl + "?t=" + token);
                    });
            });
    };

    $scope.showNoClientViewMsg = function () {
        $dialog.actionFailed("There are no login profiles associated with this household.").open();
    };


    $scope.close = function () {
        dialog.close();
    };


    //INITIALIZE
    $scope.clientView = {};
    init();
});


'use strict';

var portfolioTargetRegistrationCtrl = app.controller('PortfolioTargetRegistrationCtrl', function PortfolioTargetRegistrationCtrl($scope, $http, $oasRights, $location, $routeParams, $timeout,$window, $tradeGenerator, config, $dialog, API_CONFIG) {

    //region Private Variables
    var portfolioTargetId = $routeParams && $routeParams.i > 0 ? $routeParams.i.toNumber() : null;
    var newPortfolioTargetName =$routeParams && $routeParams.n ? $routeParams.n : null;
    var modelAggTypeList = ['Beta', 'Active', 'Diversifier'];
    var ptUrl = portfolioTargetId ? '/Trading/SleeveStrategy/Verbose/' + portfolioTargetId + '?expand=All' : '/Trading/SleeveStrategy/Verbose?expand=All';

    var portfolioTargetOriginal = null;

    //endregion

    //region Private Methods
    function init() {
        $scope.oasToken = sessionStorage.oas_token;
        //if advisor, then disable the save.  Reps can save their portfolio targets
        $scope.current.disableSave = $scope.user.authorization.entity != 'Representative';
        if(config.repId){
            ptUrl += "&repId=" + config.repId;
        }
        //is this an embedded page
        $scope.current.isEmbeddedPage = $location.path().has('/embed/');
        $scope.current.editMode = portfolioTargetId ? true : false;

        $scope.current.portfolioTargetRegistrations = [];

        //get risk types
        $http.get('/Trading/SleeveStrategyRiskType', {trackerMsg: 'Loading Risk Types'})
            .then(function (response) {
                //list of riskTypes
                $scope.current.riskTypes = response.data.sortBy('id');

                $scope.current.riskTypes.forEach(function (item) {
                    if(item.isPtModel){
                        $scope.mainTabs.add({name:item.name, requiresSetup:false});
                    }
                });

                //see if any portfolio targets have been setup
                getPortfolioTargets();

            });

        $http.get('/Trading/SleeveStrategyRiskType?onlyPTModels=true', {trackerMsg:'Risk Type List'})
            .then(function(response){
                $scope.current.riskTypeRangeList = response.data.map(function(x){return {id: x.id, name: '(' + x.lowerLimit + '-' + x.upperLimit + ') - ' + x.name, lowerLimit: x.lowerLimit, upperLimit:x.upperLimit}})
                $scope.current.riskTypeRangeList.add({id:null, name: 'None', lowerLimit: 0, upperLimit:100});
                $scope.current.riskTypeRangeList.sortBy('upperLimit', true);
            })
    }

    function checkUserRightsForSleeveStrategy(){
        $scope.rightsSleeveSetup = $oasRights.forCode("SLEEVESETUP");
        $scope.rightsSleeveStrategy = $oasRights.forCode("SLEEVE_STRATEGY");
        $scope.rightsPortfolioTargets = $oasRights.forCode("PORTFOLIOTARGETS");
    }

    function getPortfolioTargets() {
        $http.get(ptUrl, {trackerMsg: 'Loading sleeve strategies'})
            .then(function (response) {
                if(Array.isArray(response.data)){
                    $scope.current.portfolioTargetRegistrations = response.data;
                }else{
                    //when get by key, the return (response.data) is just an object.  Cast to array
                    //to make sure code works as designed
                    $scope.current.portfolioTargetRegistrations =  [response.data];
                }
                //compare riskType.riskAllocations to mandate allocation
                $scope.current.portfolioTargetRegistrations.forEach(function (ptItems) {
                    ptItems.mandates.forEach(function (mItems) {
                        mItems.displayOrder = mItems.modelAggTypeName === 'Beta' ? 1 : mItems.modelAggTypeName === 'Active' ? 2 : 3;
                        if(mItems.allocation == null ){
                            mItems.allocation = ptItems.riskType.riskTypeAllocations.find({modelAggTypeName: mItems.modelAggTypeName}).allocation;
                        }
                    });
                });

                requiresSetupCheck();

                if (portfolioTargetId || newPortfolioTargetName) {
                    $scope.current.showPTHeader = false;
                    $scope.current.selectedTab = portfolioTargetId ? $scope.current.portfolioTargetRegistrations.find({id: portfolioTargetId}).riskType.name : newPortfolioTargetName ;
                    buildTabs($scope.current.selectedTab);
                    buildPieChartConfig();
                    $scope.changeTab(portfolioTargetId, $scope.current.selectedTab)
                }else{
                    //set header
                    $scope.current.showPTHeader = true;

                    //either set to first tab that needs setup or the first tab index
                    var index = $scope.mainTabs.findIndex({requiresSetup: true});
                    var ptItem = null;
                    if(index === -1){
                        ptItem = $scope.current.portfolioTargetRegistrations.find(function (item) {
                            return item.riskType.name === $scope.current.riskTypes[index >= 0 ? index : 0 ].name
                        });
                    }

                    $scope.current.selectedTab =  ptItem ? ptItem.riskType.name : $scope.current.riskTypes[index].name ;
                    $scope.changeTab(null, $scope.current.selectedTab);

                }
                setStrategyType();

                calculateAggregatedRiskScore();
            });
    }

    function getPtIdFromTabName(tabName) {
        var ptItem = $scope.current.portfolioTargetRegistrations.find(function (item) {
            if(item.riskType && item.riskType.name){
                return item.riskType.name === tabName;
            }
        });
        $scope.current.selectedTab = tabName;
        return ptItem ? ptItem.id : null;
    }

    function calculateAllocations() {

        $scope.currentStrategy.details.forEach(function (item) {
            var tempRiskAllocation = 0;
            var tempModelAllocation = 0;
            if(item.aggregateModelType){
                if($scope.currentStrategy.mandates){
                    tempRiskAllocation = $scope.currentStrategy.mandates.find({modelAggTypeName:item.aggregateModelType}).allocation
                }else{
                    tempRiskAllocation = $scope.currentStrategy.riskType.riskTypeAllocations.find({modelAggTypeName: item.aggregateModelType}).allocation;
                }
                tempModelAllocation = item.targetAllocation;
                item.projectedAllocation = ((tempModelAllocation / tempRiskAllocation ) * 100).round(4);
            }else{
                item.aggregateModelType = 'Beta';
                item.aggregateModelTypeId = $scope.currentStrategy.riskType.riskTypeAllocations.find({modelAggTypeName:item.aggregateModelType}).modelAggTypeId;
                tempRiskAllocation = $scope.currentStrategy.riskType.riskTypeAllocations.find({modelAggTypeName: item.aggregateModelType}).allocation;
                tempModelAllocation = item.targetAllocation;
                item.targetAllocation = (tempModelAllocation / tempRiskAllocation ) * 100;
            }

        });

    }

    function requiresSetupCheck(){
        $scope.current.riskTypes.forEach(function (rtItem) {
            var temp = $scope.mainTabs.find({name: rtItem.name});
            if(temp){
                temp.requiresSetup = $scope.current.portfolioTargetRegistrations.none(function (x) {
                    return  x.core.sleeveStrategyRiskTypeId == rtItem.id;
                });
            }
        });
    }

    function setStrategyType() {
        //Set strategy type
        $scope.current.strategyType =  $scope.currentStrategy.core.strategyType && $scope.currentStrategy.core.strategyType != 'Undefined' ? $scope.currentStrategy.core.strategyType.toLowerCase()  : 'single';
    }

    function getModelAggTypes(){
        $http.get('/Trading/ModelAggTypes', {trackerMsg:'Loading Model Agg Types'})
            .then(function (response) {
                $scope.current.modelAggTypes = response.data;
            })
    }

    function buildTabs(tab) {
        //because user came in to a specific tab remove all others
        $scope.mainTabs.remove(function (r) {
            return r['name'] != $scope.current.selectedTab;
        });

        //the main tabs array will be empty if a non-pt model name was passed in
        if($scope.mainTabs.length == 0){
            $scope.mainTabs.add({name:$scope.current.selectedTab, requiresSetup:false});
        }

        //$scope.changeTab(tab);
    }

    function updateSleeveChart(rebuildConfig) {
        $scope.current.riskIndicators = [];
        if(rebuildConfig){
            buildPieChartConfig();
        }

        if($scope.currentStrategy.core.strategyType == 'Multi'){
            $scope.currentStrategy.mandates.forEach(function (item) {
                $scope.mandateChart.pieChart.config.series[0].data.find({name: item.modelAggTypeName}).y = item.allocation;
            });
            $scope.mandateChart.pieChart.config.title.text = $scope.currentStrategy.core.name ? $scope.currentStrategy.core.name : 'New Strategy Name' ;
        }else{
            $scope.singleStrategyChart.pieChart.config.title.text = $scope.currentStrategy.core.name ? $scope.currentStrategy.core.name : 'New Strategy Name' ;
        }

        if($scope.currentStrategy.riskType.isPtModel){
            $scope.current.riskTypeLowerTolerance = $scope.currentStrategy.riskType.lowerLimit;
            $scope.current.riskTypeUpperTolerance = $scope.currentStrategy.riskType.upperLimit;
        }

        $scope.current.riskIndicators.add($scope.currentStrategy.core.riskScore);
        $scope.current.riskIndicators.add($scope.currentStrategy.core.originalRiskScore);

        $timeout(function () {
            $scope.$broadcast('refresh-data', {mode:'normal',riskIndicators:$scope.current.riskIndicators,riskScore:$scope.currentStrategy.core.riskScore, min: $scope.current.riskTypeLowerTolerance, max:  $scope.current.riskTypeUpperTolerance},
            900);
        });
    }

    function buildDefaultStrategy(ptId){
        //if this was a risk type that hasn't been setup, try and get some basic info for new object.
        var ptTemp = $scope.current.riskTypes.find({name:$scope.current.selectedTab});

        if(ptTemp){
            $scope.currentStrategy = $scope.current.portfolioTargetRegistrations.find({id: ptId ? ptId : ptTemp.id});


        }

        //not setup - create new object
        if(!$scope.currentStrategy){
            $scope.currentStrategy = {
                id: 0,
                core: {
                    name: '',
                    riskScore: null,
                    originalRiskScore:null,
                    sleeveStrategyRiskTypeId: null,
                    distributionAllocationMethod: 'Assigned',
                    contributionAllocationMethod: 'Assigned',
                    autoRebalMonth: 0,
                    autoRebalFreq: 'None',
                    autoRebalDay: 0,
                    strategyType: 'Multi',
                    alpha: null,
                    beta: null,
                    rSquared: null,
                    drawdown: null,
                    ytd:null,
                    oneYr: null,
                    threeYr:null,
                    fiveYr: null
                },
                mandates: [],
                riskType: null,
                details: []
            };

            if(ptTemp == null ){
                if($scope.current.strategyType == 'multi'){
                    $scope.mandateChart.pieChart.config.title.text = $scope.current.selectedTab;
                }else{
                    $scope.singleStrategyChart.pieChart.config.title.text = $scope.current.selectedTab;
                }

                $scope.currentStrategy.core.name = $scope.current.selectedTab;
            }

            $scope.currentStrategy.riskType = ptTemp ? ptTemp : {isPtModel:false, name:$scope.current.selectedTab, lowerLimit: 0, upperLimit: 100, riskTypeAllocations:[] };

            $scope.currentStrategy.core.sleeveStrategyRiskTypeId = ptTemp ? ptTemp.id : 0;
            $scope.current.strategyType = 'multi';

            modelAggTypeList.forEach(function (item) {
                if(ptTemp){
                    var temp = ptTemp.riskTypeAllocations.find({modelAggTypeName: item});
                    $scope.currentStrategy.mandates.add({sleeveStrategyId:0, modelAggTypeId:temp.modelAggTypeId,  modelAggTypeName: temp.modelAggTypeName, allocation: temp.allocation, riskScore:null})
                }else{
                    $scope.currentStrategy.mandates.add({sleeveStrategyId:0, modelAggTypeId:$scope.current.modelAggTypes.find({name:item}).id, allocation:0,  modelAggTypeName: item, riskScore:null});
                }
            });

            //set risk range in drop down
            if(!$scope.currentStrategy.riskType.isPtModel){
                $scope.current.selectedRiskTypeForNonPT = $scope.currentStrategy.riskType.upperLimit === 100 ? null : $scope.current.riskTypeRangeList.find({lowerLimit: $scope.currentStrategy.riskType.lowerLimit}).id;
                $scope.current.riskTypeLowerTolerance = $scope.currentStrategy.riskType.lowerLimit;
                $scope.current.riskTypeUpperTolerance = $scope.currentStrategy.riskType.upperLimit;
            }

        }
    }

    function buildPieChartConfig() {
        if($scope.current.strategyType == 'multi'){
            $scope.mandateChart.pieChart.config = {
                chart: {
                    renderTo: 'pieMultiContainer',
                    type: 'pie'
                },
                options: {
                    credits: {enabled: false}
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer'
                    }
                },
                series: [
                    {
                        type: 'pie',
                        dataLabels: {
                            enabled: true,
                            format: '<b> {point.name}</b> <br> {point.y: .0f} %',
                            distance:  8,
                        },
                        name: '',
                        data: [
                            {name: 'Beta', y: 0, color: $scope.getPieChartColors['Beta'], allowDecimals: false},
                            {name: 'Active', y: 0, color: $scope.getPieChartColors['Active'], allowDecimals:false},
                            {name: 'Diversifier', y: 0, color: $scope.getPieChartColors['Diversifier'], allowDecimals: false}
                        ]
                    }
                ],
                title: {
                    events: {
                        click: function () {
                            updateTitle();
                        }
                    },
                    text: ''
                },
                tooltip: {
                    enabled: false,
                    pointFormat: '{point.name}: <b>{point.percentage:.1f}%</b>'
                },
                subtitle: {
                    events: {
                        click: function () {
                            updateTitle();
                        }
                    },
                    useHTML: true,
                    text: '<a ng-if="!currentStrategy.riskType.isPtModel && current.canEdit" ng-click="updateTitle()" style="font-size: x-small">edit</a>'
                }
            };
        }else{
            $scope.singleStrategyChart.pieChart.config = {
                chart: {
                    renderTo: 'pieSingleContainer',
                    type: 'pie'
                },
                options: {
                    credits: {enabled: false}
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer'
                    }

                },
                series: [
                    {
                        type: 'pie',
                        dataLabels: {
                            enabled: true,
                            format: '<b> {point.name}</b> <br> {point.y: .0f} %',
                        },
                        name: '',
                        data: [
                            {name: 'Single Strategy', y: 100, color: '#52D0F0', allowDecimals: false}
                        ]
                    }
                ],
                title: {
                    events: {
                        click: function () {
                            updateTitle();
                        }
                    },
                    text: ''
                },
                tooltip: {
                    enabled: false,
                    pointFormat: '{point.name}: <b>{point.percentage:.1f}%</b>'
                },
                subtitle: {
                    events: {
                        click: function () {
                            updateTitle();
                        }
                    },
                    useHTML: true,
                    text: '<a ng-if="!currentStrategy.riskType.isPtModel && current.canEdit" ng-click="updateTitle()" style="font-size: x-small">edit</a>'
                }
            };
        }
    }

    function updateTitle() {
        if (!$scope.current.canEdit) {
            return;
        }
        $scope.safeApply(function () {
            $dialog.inputBox('Change Strategy Name', 'Enter new name','text', {inputValue: $scope.currentStrategy.core.name})
                .open()
                .then(function (result) {
                    if (!result) return;
                    $scope.currentStrategy.core.name = result;
                    if($scope.currentStrategy.core.strategyType == 'Multi'){
                        $scope.mandateChart.pieChart.config.title.text = result;
                    }else{
                        $scope.singleStrategyChart.pieChart.config.title.text = result;
                    }

                });
        });
    }

    function checkDetailsLimit( ) {
        if($scope.current.maxNumberOfSleeves > 0){
            $scope.current.limitReached = $scope.currentStrategy.details.length >= $scope.current.maxNumberOfSleeves ? true : false;
        }
    }

    function getMaxNumberSleeves() {
        $http.get('/Settings/Database/EntityOptions/Code/69MAXNUMBE', {cache: true, trackerMsg: 'Getting max number of sleeves'})
            .then(function (response) {
                $scope.current.maxNumberOfSleeves = response.data.value.toNumber();
            })
    }

    function updateStrategyStatistics() {
        $scope.currentStrategy.alpha = null;
        $scope.currentStrategy.beta = null;
        $scope.currentStrategy.rSquared = null;
        $scope.currentStrategy.maxDrawdown = null;

        if($scope.currentStrategy && $scope.currentStrategy.details.length) {
            var currentStrategyDetails = {
                details: $scope.currentStrategy.details.map(d => ({modelAggId: d.aggregateModelId, targetAllocation: d.targetAllocation}))
            };

            $http({method: "POST", url: '/Trading/SleeveStrategy/StrategyStatistics', data: currentStrategyDetails, trackerMsg: 'Getting strategy statistics'})
                .then(function (response) {
                    if(response.data) {
                        $scope.currentStrategy.alpha = response.data.alpha;
                        $scope.currentStrategy.beta = response.data.beta;
                        $scope.currentStrategy.rSquared = response.data.rSquared;
                        $scope.currentStrategy.maxDrawdown = response.data.maxDrawdown;
                    }
                });
        }
    }

    function calculateAggregatedRiskScore() {
        let buckets = $scope.currentStrategy.mandates.map(mandate => {
            var details = $scope.currentStrategy.details.filter(d => d.aggregateModelTypeId === mandate.modelAggTypeId && d.sleeveType === "Normal sleeve");
            // any sleeves that have a model with a null risk score cannot be calculated, so return null
            if(details.filter(d => d.riskScore === null || d.projectedAllocation === undefined).length) {
                return null;
            }
            return { mandatePercent: mandate.allocation, mandateTotal: details
                .map(d => (d.projectedAllocation / 100) * d.riskScore) // average weighted risk = target allocation % * risk score
                .reduce((prev,next) => prev + next, 0)}; // sum the average weighted risk
        });

        if(buckets.filter(b => !b).length) {
            $scope.current.aggregatedRiskScore = null;
            return;
        }

        $scope.current.aggregatedRiskScore = buckets.reduce((prev, next) => prev + ((next.mandatePercent / 100.0) * next.mandateTotal), 0);
    }

    function canUpdateAllBuckets(){
        var sTotal = $scope.currentStrategy.details.findAll({aggregateModelType: 'Beta'}).sum('projectedAllocation') === 100;
        var tTotal = $scope.currentStrategy.details.findAll({aggregateModelType: 'Active'}).sum('projectedAllocation') === 100;
        var dTotal =  $scope.currentStrategy.details.findAll({aggregateModelType: 'Diversifier'}).sum('projectedAllocation') ===100;
        return sTotal || tTotal || dTotal;
    }

    function resetModelAllocations(value){
        $scope.currentStrategy.core.strategyType = value.capitalize();
        $scope.currentStrategy.details = [];

        if($scope.currentStrategy.core.strategyType == 'Multi'){
            $scope.currentStrategy.mandates.forEach(function (item) {
                item.riskScore = null;
            })
        }
    }
    //endregion

    //region Public Methods
    $scope.getRiskScore = function(mandate) {
        var details = $scope.currentStrategy.details.filter(d => d.aggregateModelTypeId === mandate.modelAggTypeId && d.sleeveType === "Normal sleeve");
        // any sleeves that have a model with a null risk score cannot be calculated, so return null
        if(details.filter(d => d.riskScore === null || d.projectedAllocation === undefined).length) {
            return null;
        }
        return details
            .map(d => (d.projectedAllocation / 100) * d.riskScore) // average weighted risk = target allocation % * risk score
            .reduce((prev,next) => prev + next, 0).round(2); // sum the average weighted risk
    }

    $scope.exitRegistrationPage =  function () {
        //check for any changes, if true, prompt for new message
        if(!angular.equals(portfolioTargetOriginal, $scope.currentStrategy)){
            $dialog.confirmAction('You are exiting without saving.'+ '<br><br>' + 'Are you sure you want to continue?')
                .open()
                .then(function (result) {
                    var path = '/';
                    path += $scope.current.isEmbeddedPage ? 'embed' : 'trading';
                    path += '/portfoliotargets/bmm';
                    $location.path(path);
                })
        }else{
            var path = '/';
            path += $scope.current.isEmbeddedPage ? 'embed' : 'trading';
            path += '/portfoliotargets/bmm';
            $location.path(path);
        }
    };

    $scope.switchStrategyType = function(value) {
        var msg1 = 'Switching from single strategy to multi strategy will remove current model allocation.  Continue?';
        var msg2 = 'Switching from multi strategy to single strategy will remove all currently added model allocation.  Continue?';
        $dialog.confirmAction(value == 'single' ? msg2: msg1)
            .open()
            .then(function (result) {
                if(result == 'yes'){
                    resetModelAllocations(value);
                    updateSleeveChart(true);
                }else{
                    //return to original value
                    if(value == 'single'){
                        $scope.current.strategyType = 'multi';
                    }
                    if(value == 'multi'){
                        $scope.current.strategyType = 'single';
                    }
                }

            });
    };

    $scope.bucketChange = function (model) {
        var temp = $scope.currentStrategy.details.findAll({aggregateModelType: model.aggregateModelType});
        if(temp.sum('projectedAllocation') == 100){
            // //update target allocation(s) first
            temp.forEach(function (item) {
                item.targetAllocation =  item.projectedAllocation * ($scope.currentStrategy.mandates.find({modelAggTypeName: model.aggregateModelType}).allocation / 100);
            });
            calculateAggregatedRiskScore();
            updateStrategyStatistics();
        }
    };

    $scope.updateAllocation = function (reg) {
        if (!$scope.current.canEdit) {
            return;
        }
        $dialog.inputBox('Enter allocation for mandate', 'Mandate Allocation', "number", {inputValue: reg.allocation })
            .open()
            .then(function (result) {

                $scope.currentStrategy.mandates.find({modelAggTypeName:reg.modelAggTypeName}).allocation = result;


                //update models in bucket
                var items = $scope.currentStrategy.details.findAll({aggregateModelType: reg.modelAggTypeName});
                if(items){
                    items.forEach(function (item) {
                        item.targetAllocation =  item.projectedAllocation * (result / 100);
                    });
                }

                //if there's changes in mandate allocation
                if($scope.currentStrategy.mandates.sum('allocation') === 100){
                    updateSleeveChart(true);
                    calculateAggregatedRiskScore();
                    updateStrategyStatistics();
                }
            });
    };

    $scope.saveCurrent = function (mode) {

        var saveRecord = function () {

            //webApi needs the raw allocation not the displayed allocation.
            //each bucket has a risk % that percentage is then divided by the allocation amount and sent to webApi
            $scope.currentStrategy.details.forEach(function (item) {
                var tempRiskAllocation = $scope.current.strategyType === 'multi'? $scope.currentStrategy.mandates.find({modelAggTypeName: item.aggregateModelType}).allocation : 100;
                var tempModelAllocation = $scope.current.strategyType === 'multi'? item.projectedAllocation : 100;
                item.targetAllocation = $scope.current.strategyType === 'multi'? (tempModelAllocation * (tempRiskAllocation / 100)).round(2) : 100;
                //these must equal the targetAllocation
                item.contributionAllocation = item.targetAllocation;
                item.distributionAllocation = item.targetAllocation;

                //add default array for substitutes
                item.substitutes = [];
            });

            //save original risk score if it hasn't been saved
            if(!$scope.currentStrategy.core.originalRiskScore){
                $scope.currentStrategy.core.originalRiskScore = $scope.currentStrategy.core.riskScore;
            }

            // //match mandate allocation with riskType allocation.
            if($scope.currentStrategy.riskType && $scope.currentStrategy.riskType.riskTypeAllocations.isEmpty()){
                $scope.currentStrategy.riskType.riskTypeAllocations = $scope.currentStrategy.mandates;
            }

            if(!$scope.currentStrategy.riskType.isPtModel){
                //set the upper / lower tolerance values based on selection from risk range drop down
                $scope.currentStrategy.riskType.lowerLimit = $scope.current.riskTypeLowerTolerance;
                $scope.currentStrategy.riskType.upperLimit = $scope.current.riskTypeUpperTolerance;
            }

            if($scope.current.strategyType == 'single'){
                $scope.currentStrategy.mandates.find({modelAggTypeName:'Active'}).allocation = 0;
                $scope.currentStrategy.mandates.find({modelAggTypeName:'Diversifier'}).allocation = 0;
                $scope.currentStrategy.mandates.find({modelAggTypeName:'Beta'}).allocation = 100;
            }

            //
            //new or update
            //

            var args = $scope.currentStrategy.id > 0 ? {method: "PUT", id: $scope.currentStrategy.id, url:'/Trading/SleeveStrategy/Verbose/' + $scope.currentStrategy.id, msg: "Saving strategy " + $scope.currentStrategy.id} : {method: "POST",url:'/Trading/SleeveStrategy/Verbose', id: '', msg: "Adding new strategy"};

            if(mode !== 'rebalance' && args.method === 'PUT'){
                args.url += '?processStrategy=false';
            }

            $http({method: args.method, url:args.url, data:$scope.currentStrategy, trackerMsg: args.msg})
                .then(function (response) {
                    $scope.current.isPageInit = true;
                    portfolioTargetOriginal = null;
                    if(response.data && args.method === 'PUT'){
                        var batchId = response.data;
                        if(batchId.toNumber()){
                            $tradeGenerator.startPolling(batchId.toNumber(), false);
                            $scope.$on('event:orders-success', function () {
                                if ($routeParams && $routeParams.i){
                                    $dialog.actionComplete('Successfully saved ' + $scope.currentStrategy.core.name + '<br><br>' + 'Assigned Accounts will be re-balanced')
                                        .open()
                                        .then(function (result) {
                                            var path = '/';
                                            path += $scope.current.isEmbeddedPage ? 'embed' : 'trading';
                                            path += '/portfoliotargets/bmm';
                                            $location.path(path);
                                        })
                                }else{
                                    $scope.current.showSuccess = true;

                                    //update the tab
                                    var currentTab = $scope.mainTabs.find({name: $scope.currentStrategy.riskType.name});
                                    currentTab.requiresSetup = false;

                                    $dialog.actionComplete('Successfully saved ' + $scope.currentStrategy.core.name + '<br><br>' + 'Assigned Accounts will be re-balanced')
                                        .open()
                                        .then(function (result) {
                                            getPortfolioTargets();
                                        });

                                    $timeout(function () {
                                        $scope.current.showSuccess = false;
                                    },1200);
                                }
                            });
                            $scope.$on('event:orders-error', function (e, args) {
                                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Process Error", "There was an error re-balancing strategy").open();
                            })
                        }else{
                            $dialog.actionComplete('Successfully saved ' + $scope.currentStrategy.core.name + ' and no registrations to re-balanced.')
                                .open()
                                .then(function (result) {
                                    //update the tab
                                    var currentTab = $scope.mainTabs.find({name: $scope.currentStrategy.riskType.name});
                                    currentTab.requiresSetup = false;

                                    getPortfolioTargets();
                                })
                        }
                    }else{
                        if($scope.current.editMode ){
                            $scope.current.editMode = false;
                        }else{
                            $dialog.actionComplete('Successfully saved ' + $scope.currentStrategy.core.name)
                                .open()
                                .then(function (result) {
                                    //update the tab
                                    var currentTab = $scope.mainTabs.find({name: $scope.currentStrategy.riskType.name});
                                    currentTab.requiresSetup = false;
                                    getPortfolioTargets();
                                })
                        }
                    }
            })

        };

        // some standard business rules
        if($scope.currentStrategy){
            //if strategy type == 'multi', make sure there's at least 1 model in bucket
            var tempError = ['Beta', 'Active', 'Diversifier'].any(function (n) {
                return $scope.currentStrategy.details.none({aggregateModelType: n} ) && $scope.currentStrategy.mandates.find({modelAggTypeName:n}).allocation > 0
            });
            if(tempError && $scope.current.strategyType === 'multi') {
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Model Assignment Error", "Each risk type must have 1 model assignment if % is not 0, please correct and try saving again." ).open();
                return;
            }

            if($scope.currentStrategy.core.strategyType === 'multi'){
                var sumError = ['Beta', 'Active', 'Diversifier'].any(function (n) {
                    return !$scope.currentStrategy.details.findAll({aggregateModelType: n} ).sum('projectedAllocation').almostEquals(100) && $scope.currentStrategy.mandates.find({modelAggTypeName:n}).allocation == 100;
                });
                if(sumError && $scope.current.strategyType === 'multi') {
                    $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Model Assignment Percent Error", "Weighted Models must equal 100%, please correct and try saving again." ).open();
                    return;
                }
            }
            if($scope.current.strategyType === 'single' && $scope.currentStrategy.details.length !== 1) {
                $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Model Assignment Error", "Single Strategy must have 1 model assignment, please correct and try saving again." ).open();
                return;
            }

            var saveConfirmButton =[{result: 'ok', label: 'Confirm', focus: false, cssClass:'btn-primary'},{result: 'cancel', label: 'Cancel', focus: true, cssClass:'btn-info'}];
            $dialog.messageBox('Please read and confirm the following ','Assigned Accounts will be re-balanced only if model allocations have changed.',saveConfirmButton).open()
                .then(function (result) {
                    if(result === 'ok'){
                        saveRecord();
                    }
                })
        }
    };

    $scope.changeTab = function (id, tabName) {
        var moveToTab = function () {
            var ptId = id ? id : getPtIdFromTabName(tabName);
            var tabSetupRequired = $scope.mainTabs.find({name:$scope.current.selectedTab});
            if(tabSetupRequired || !$scope.currentStrategy){
                buildDefaultStrategy(ptId);
            }else{
                // set data for tab
                $scope.currentStrategy = $scope.current.portfolioTargetRegistrations.find({id: ptId});
            }

            $scope.currentStrategy.details.forEach(function (detail) {
                detail.canDelete = $scope.rightsPortfolioTargets.canDelete;
                detail.updatingRiskScore = false;
            });

            $scope.current.canEdit = $scope.user.authorization.entity === 'Representative' &&
                ($scope.currentStrategy.core.entity === undefined || // new strategy
                ($scope.currentStrategy.core.entity === 'Representative' && // or owned by rep
                    $scope.currentStrategy.core.entityId === $scope.user.authorization.entityId));

            calculateAllocations();
            setStrategyType();
            updateSleeveChart(true);
            calculateAggregatedRiskScore();
            portfolioTargetOriginal = angular.copy($scope.currentStrategy);
            updateStrategyStatistics();

            $scope.current.isPageInit = false;
        };


        //check for changes
        if($scope.mainTabs.find({name: $scope.current.selectedTab}).requiresSetup && !$scope.current.isPageInit && $scope.user.authorization.entity == 'Representative'){
            //Check for changes
            if(!angular.equals(portfolioTargetOriginal, $scope.currentStrategy)){
                var msg = 'Changes on ' + $scope.current.selectedTab + ' have not been saved.' + '<br><br>' + 'To save, click on actions and choose  "Save & Rebalance" to save your changes.' + '<br><br>' + '    Continue without saving?';
                $dialog.confirmAction(msg).open()
                    .then(function (result) {
                        if(result == 'yes'){
                            moveToTab();
                        }
                    })
            }else{
                moveToTab();
            }
        }else{
            moveToTab();
        }

    };

    $scope.setRiskRangeForNonPt = function () {
        var temp = $scope.current.riskTypeRangeList.find({id: $scope.current.selectedRiskTypeForNonPT});

        $scope.current.riskTypeLowerTolerance = temp ? temp.lowerLimit : 0;
        $scope.current.riskTypeUpperTolerance = temp ? temp.upperLimit : 100;

        updateSleeveChart(false);
    };

    $scope.addAllocation = function (paneIndex, type) {
        var index = paneIndex;

        var dialogOpts = {
            templateUrl : "portfolio-target-advance-search.html",
            controller : "PortfolioTargetAdvanceSearchCtrl",
            modelAggType : $scope.current.strategyType == 'multi' ? type : null,
            maxNumberOfModels: $scope.current.strategyType == 'multi' ?  $scope.current.maxNumberOfSleeves : 1,
            currentModelCount: $scope.currentStrategy.details.length,
            strategyType: $scope.current.strategyType,
            repId: config.repId,
            dialogClass: "modal wide"
        };

        $dialog.dialog(dialogOpts)
            .open()
            .then(function(results){
                if( results ) {
                    results.forEach(function (item) {
                        var tempObject = {
                            id:0,
                            sleeveStrategyId: $scope.currentStrategy.id,
                            aggregateModelId: item.id,
                            managementStyleId: null,
                            subAdvisorId: item.subAdvisorId,
                            targetAllocation: $scope.current.strategyType === 'multi' ? 0 : 100,
                            contributionAllocation: 0,
                            distributionAllocation: 0,
                            toleranceUpper: 0,
                            toleranceLower: 0,
                            sleeveType: "Normal sleeve",
                            autoTradeTypes: "None",
                            aggregateName: item.name,
                            managementStyleName: null,
                            subAdvisorName: null,
                            aggregateModelType: $scope.current.strategyType === 'multi' ? type : item.modelAggType,
                            aggregateModelTypeId: $scope.current.strategyType === 'multi' ? $scope.current.modelAggTypes.find({name:type}).id : null,
                            riskScore: item.riskScore,
                            canDelete: $scope.rightsPortfolioTargets.canDelete,
                            updatingRiskScore: false
                        };
                        $scope.currentStrategy.details.push(tempObject);
                    });
                    checkDetailsLimit();
                    calculateAggregatedRiskScore();
                }
            });

    };

    $scope.removeModel = function (item, row) {
        $scope.currentStrategy.details.remove(item);

        if($scope.current.strategyType == 'single'){
            $scope.currentStrategy.mandates.forEach(function (item) {
                item.allocation = 0;
            })
        }
        checkDetailsLimit();
        calculateAggregatedRiskScore();
    };

    $scope.getDetails = function (currentItem) {
        const details = $scope.currentStrategy.details.filter(x => {
            return x.aggregateModelType === currentItem
                && x.sleeveType === 'Normal sleeve';
        });

        return details;
    };

    $scope.openSetupDialog = function () {
        var dialogOpts = {
            templateUrl: "portfolio-targets-registration-setup.html",
            controller: "PortFolioTargetsRegistrationSetupCtrl",
            ptRegistration: $scope.current.portfolioTargetRegistrations
        };

        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function (rslt) {
                if (rslt) {

                }
            });
    };

    $scope.downloadFactSheet = function (id, type) {
        let url=null;
        switch(type){
            case 'manager':
                url = '/Integrations/Communities/ManagerFactSheet/';
                break;
            case 'asset':
                url = '/Integrations/OrionElement/AssetFactSheet/';
                break;
            case 'model':
                url = '/Integrations/OrionElement/BlendedAssetFactSheet/';
                break;
        }
        window.location.href = API_CONFIG.baseUrl + url + id + '?Authorization=' + sessionStorage.oas_token;
    };
    //endregion

    //region Global Config Methods
    Highcharts.theme = {
        colors: ["#7cb5ec", "#f7a35c", "#90ee7e", "#7798BF", "#aaeeee", "#ff0066", "#eeaaee", "#55BF3B", "#DF5353", "#7798BF", "#aaeeee"],
        chart: {
            backgroundColor: null,
            style: {
                fontFamily: "arial, sans-serif"
            }
        },
        title: {
            style: {
                fontSize: '16px',
                fontWeight: 'bold'

            }
        },
        tooltip: {
            borderWidth: 0,
            backgroundColor: 'rgba(219,219,216,0.8)',
            shadow: false
        },
        legend: {
            itemStyle: {
                fontWeight: 'bold',
                fontSize: '13px'
            }
        },
        xAxis: {
            gridLineWidth: 1,
            labels: {
                style: {
                    fontSize: '12px'
                }
            }
        },
        yAxis: {
            minorTickInterval: 'auto',
            title: {
                style: {
                    textTransform: 'uppercase'
                }
            },
            labels: {
                style: {
                    fontSize: '12px'
                }
            }
        },
        plotOptions: {
            candlestick: {
                lineColor: '#404048'
            }
        },
        // General
        background2: '#F0F0EA'

    };
    Highcharts.setOptions(Highcharts.theme);

    $scope.mandateChart = {
        pieChart: {config: {}}
    };

    $scope.singleStrategyChart = {
        pieChart: {config: {}}
    };


    $scope.currentStrategy = null;

    $scope.modelHasChanged = false;

    $scope.$watch('currentStrategy.details', function (newValue, oldValue) {
        if(!newValue) return;
        if(oldValue != newValue){
           $scope.modelHasChanged = true;
        }else{
           $scope.modelHasChanged = false;
        }
    });

    //endregion

    $scope.mainTabs = [];

    $scope.current = {selectedRiskTypeForNonPT:null, showSuccess:false, ptSaveClass:'block-border fade ng-hide',isEditMode:false, isPageInit:true, disableSave:false, isEmbeddedPage:false, showPTHeader: true, displayPieChart:true, portfolioTargetRegistrations:[], riskTypes:[],riskTypeRangeList:[], limitReached:false,  modelAggTypes: [], selectedTab: '', selectedTabIndex:0, strategyType: 'single', riskIndicators: [], riskTypeLowerTolerance: 0,  riskTypeUpperTolerance: 0, strategy: {name: 'New Name'}, aggregatedRiskScore: null};

    $scope.getPieChartColors = {'Beta': '#52D0F0', 'Active': '#939598', 'Diversifier': '#FFDD00'};

    checkUserRightsForSleeveStrategy();
    getModelAggTypes();
    getMaxNumberSleeves();
    init();

});

app.controller('PortfolioTargetAdvanceSearchCtrl', function PortfolioTargetAdvanceSearchCtrl ($http,$scope,$timeout,$window, dialog, API_CONFIG) {
    var repId = dialog.options.repId ? dialog.options.repId : $scope.user.authorization.entityId;

    //PRIVATE METHODS
    function init() {
        $scope.oasToken = sessionStorage.oas_token;
        $scope.loadMethodSubAdvisors();

        $scope.searchData = [];

        $scope.current.searchInProgress = true;

        var url = '/Trading/ModelAggs?representativeId=' + repId;
        if($scope.current.modelAggType){
            url += '&modelAggType=' + $scope.current.modelAggType
        }
        url += '&isAdvisoryWorld=true&getAllModelsForAllSubAdvisors=true&excludeSelfDirected=true&returnStyle=ModelAggLight';
        $http.get(url, {cache: true, trackerMsg: 'Searching models'})
            .then(function (response) {
                if($scope.current.strategyType == 'single'){
                    $scope.current.modelAggType = 'Beta';
                }
                $scope.searchData = response.data;
                $scope.current.searchInProgress = false;
            });

        checkModelLimit();
    }

    function checkModelLimit() {
        $scope.current.modelLimitReached = $scope.current.selectedItems.length >= ($scope.current.maxNumberOfModels - $scope.current.currentModelCount);
    }


    //PUBLIC METHODS
    $scope.close = function (action) {
        if(action == 'add' && $scope.current.selectedItems.length > 0){
            $scope.current.selectedItems = $scope.searchData.findAll({selected: true});
            if($scope.current.selectedItems && $scope.current.selectedItems.length > 0){
                dialog.close($scope.current.selectedItems);
            }
        }
        else{
            dialog.close(null);
        }
    };

    $scope.updateSelectedItemCount = function () {
      $scope.current.selectedItems = $scope.searchData.findAll({selected: true});
      checkModelLimit();
    };

    $scope.sortSearch = function( fieldName ) {
        $scope.searchSort.sortField = fieldName;
        $scope.searchSort.sortReverse = !$scope.searchSort.sortReverse;
    };

    $scope.filterResults = function (item) {
        var includeItem = item.modelAggType === $scope.current.modelAggType;

        includeItem = includeItem && (!$scope.current.selectedSubAdvisor || $scope.current.selectedSubAdvisor === item.subAdvisorId);

        includeItem = includeItem && (!$scope.query || (item.name.toLowerCase().has($scope.query.toLowerCase())));

        if (includeItem) {
            var selectedRanges = $scope.rangeNames.findAll({selected: true});
            if (selectedRanges.length && selectedRanges.length !== $scope.rangeNames.length) {
                includeItem = false;
                selectedRanges.each(function (range) {
                    if (Number.range(range.min, range.max).contains(item.riskScore)) {
                        includeItem = true;
                        return false;
                    }
                });
            }
        }

        return includeItem;
    };

    $scope.downloadFactSheet = function (modelId, type) {
        var url = type == 'manager' ? '/Integrations/Communities/ManagerFactSheet/': '/Integrations/OrionElement/AssetFactSheet/';
        window.location.href = API_CONFIG.baseUrl + url + modelId + '?Authorization=' + sessionStorage.oas_token;
    };

    $scope.selectItem = function(row) {
        if($scope.current.modelLimitReached && row.selected){
            row.selected = !row.selected;
        }else if(!$scope.current.modelLimitReached){
            row.selected = !row.selected;
        }
        $scope.current.selectedItems = $scope.searchData.findAll({selected: true});
        checkModelLimit();
    };

    $scope.loadMethodSubAdvisors = function () {
        var url = '/Portfolio/SubAdvisors/Simple?representativeId=' + repId;
        if($scope.current.strategyType){
            url += '&modelAggType=' + $scope.current.modelAggType;
        }

        $http.get(url, {cache: true, trackerMsg: 'Loading sub-advisors'})
            .then(function(response) {
                $scope.subAdvisorList = response.data;
            });
    };


    //INITIALIZE
    $scope.searchSort = { sortField: 'strategy', sortReverse: false };
    $scope.searchData = [];
    $scope.mandateNames = ['Beta', 'Active', 'Diversifier'];
    $scope.rangeNames = [{displayName:'1-20', min:1, max:20} ,{displayName:'21-40', min:21, max:40},{displayName:'41-60', min:41, max:60},{displayName:'61-80', min:61, max:80},{displayName:'81-100', min:81, max:100}];
    $scope.current = {strategyType: dialog.options.strategyType, modelLimitReached: false, searchInProgress:false, selectedSubAdvisor: null, modelAggType: dialog.options.modelAggType, selectedItems:[], currentModelCount: dialog.options.currentModelCount, maxNumberOfModels: dialog.options.maxNumberOfModels};

    init();
});


portfolioTargetRegistrationCtrl.chooseRep = ["$http", "$dialog", "$q","$rootScope","$route",  function ($http, $dialog, $q, $rootScope, $route) {
    function promptForRep() {
        return $dialog.dialog({templateUrl: "trading/portfolioTargets/modals/portfolio-target-registration-rep-prompt.html", controller: "PortfolioTargetRegistrationRepPromptCtrl"})
            .open()
            .then(function (result) {
                if (result) {
                    return {repId: result.repId};
                } else {
                    var deferred = $q.defer();
                    deferred.reject();
                    return deferred.promise;
                }
            });
    }

    if($route.current.params.i){
        return {repId: null };
    }

    if (!$rootScope.user.authorization.entity) {
        var deferred = $q.defer();

        $rootScope.$watch('user.authorization', function (newValue, oldValue) {
            if (!newValue || newValue === oldValue) return;

            if (newValue.entity === "Representative") {
                deferred.resolve({repId: newValue.entityId });
            } else {
                promptForRep()
                    .then(function (result) {
                        deferred.resolve(result);
                    });
            }
        });

        return deferred.promise;
    } else if($rootScope.user.authorization.entity === 'Representative') {
        return {repId: $rootScope.user.authorization.entityId };
    } else {
        return promptForRep();
    }
}];



'use strict';

var portfolioTargetBlendedModelManagementCtrl = app.controller('PortfolioTargetBlendedModelManagementCtrl', function PortfolioTargetBlendedModelManagementCtrl($scope, $timeout, $http, $oasRights,$window, $routeParams, $location, $dialog, config ) {

    var count = 0;
    var ptUrl = '/Trading/SleeveStrategy/Verbose?expand=All';

    //region Private Methods

    function init() {
        //is this an embedded page
        $scope.current.isEmbeddedPage = $window.location.href.search('embed') != -1;

        if(config.repId){
            ptUrl += "&repId=" + config.repId;
            $scope.current.repName = config.repName;
        }

        getBlendedModels();
    }

    function getBlendedModels(){
        $http.get(ptUrl, {trackerMsg:'Loading Sleeve Strategies'})
            .then(function (response) {
                $scope.blendedModels = response.data;

                $scope.blendedModels.forEach(function (item) {
                    //used for display update procedure
                    item.riskIndicators = [];
                    item.riskIndicators.add(item.core.riskScore);
                    item.riskIndicators.add(item.core.originalRiskScore);
                });
                $timeout(function () {
                    $scope.$broadcast('refresh-data', {mode:'simple', min:0, max: 100});
                },100);
            });
    }

    function refreshModelRow(row){
        $timeout(function () {
            $scope.$broadcast('refresh-data', {mode:'simple', min:0, max: 100});
            if(!$scope.current.updateAllFlag){
                row.expanded = false;
                row.selected = false;
            }
        },100);
    }

    function updateOverlayModelAfterRiskScoreChange(olm){
        var args = {method: "PUT", id: olm.id, msg: "Updating Strategy: " + olm.id};
        $http({method: args.method, url:'/Trading/SleeveStrategy/Verbose/' + args.id + '?processStrategy=false', data:olm, trackerMsg: args.msg})
            .then(function (){
                refreshModelRow(olm)
            });
    }

    //endregion

    //region Public Methods
    $scope.removeBlendedModel = function (model) {

        $dialog.confirmAction('Please confirm deletion of ' + model.riskType.name)
            .open()
            .then(function (result) {
                if(result == 'yes'){
                    $scope.blendedModels.remove(model);
                    $http.delete('/Trading/SleeveStrategy/' + model.id , {trackerMsg:'Deleting ' + model.riskType.name})
                        .then(function (response) {
                            $dialog.actionComplete('Successfully deleted blended model').open()
                                .then(function (result) {
                                    getBlendedModels();
                                })
                        });
                }
            })

    };

    $scope.selectItem = function(item) {
            item.selected = !item.selected;
            item.selected ? count++ : count--;
    };

    $scope.showDetails = function (rowItem) {
        rowItem.expanded = !rowItem.expanded;
        rowItem.selected = !rowItem.selected;
    };

    $scope.editPTReg = function (tab) {
        if($scope.current.isEmbeddedPage){
            $location.url('/embed/portfoliotargets/registration?i=' + tab);
        }else{
            $location.url('/trading/portfoliotargets/registration?i=' + tab);
        }
    };

    $scope.createNew = function () {
        //Build out new risk type
        var tempName = '';
        $dialog.inputBox('Create Overlay Model', 'Overlay Model Name', tempName, {inputValue: tempName})
            .open()
            .then(function (result) {
                if (!result) return;
                //check to see if item exists

                var itemFound = $scope.blendedModels.any(function (item) {
                   return item.riskType.name.toLowerCase() === result.toLowerCase();
                });

                if(!itemFound){
                    if($scope.current.isEmbeddedPage){
                        $location.url('/embed/portfoliotargets/registration?i=0&n=' + result);
                    }else{
                        $location.url('/trading/portfoliotargets/registration?i=0&n=' + result);
                    }
                }else{
                    $dialog.actionFailed(result + ' already exsists. Please try again').open();
                }


            });
    };

    $scope.filterSpecialSleeves = function (sleeve) {
        return sleeve.sleeveType === 'Normal sleeve';
    };

    //endregion

    $scope.blendedModels = null;
    $scope.current = {mode:'simple', isEmbeddedPage:false, updateAllFlag:false};
    $scope.isCollapsed = true;

    init();

});

portfolioTargetBlendedModelManagementCtrl.chooseRep = ["$http", "$dialog", "$q","$rootScope","$route",  function ($http, $dialog, $q, $rootScope, $route) {
    function promptForRep() {
        return $dialog.dialog({templateUrl: "trading/portfolioTargets/modals/portfolio-target-registration-rep-prompt.html", controller: "PortfolioTargetRegistrationRepPromptCtrl"})
            .open()
            .then(function (result) {
                if (result) {
                    return {repId: result.repId, repName: result.rep.name};
                } else {
                    var deferred = $q.defer();
                    deferred.reject();
                    return deferred.promise;
                }
            });
    }

    if($route.current.params.i){
        return {repId: null };
    }

    if (!$rootScope.user.authorization.entity) {
        var deferred = $q.defer();

        $rootScope.$watch('user.authorization', function (newValue, oldValue) {
            if (!newValue || newValue === oldValue) return;

            if (newValue.entity === "Representative") {
                deferred.resolve({repId: newValue.entityId });
            } else {
                promptForRep()
                    .then(function (result) {
                        deferred.resolve(result);
                    });
            }
        });

        return deferred.promise;
    } else if($rootScope.user.authorization.entity === 'Representative') {
        return {repId: $rootScope.user.authorization.entityId};
    } else {
        return promptForRep();
    }
}];

'use strict'

app.controller('PortfolioTargetsRiskTypeManagementCtrl', function PortfolioTargetsRiskTypeManagementCtrl($scope, $http, $oasRights, $location,$routeParams, $dialog) {

    function init() {
        //get all risk types
        $http.get('/Trading/SleeveStrategyRiskType?onlyPTModels=true', {trackerMsg:'Loading risk types'})
            .then(function (response) {
                $scope.riskTypes = response.data.sortBy('upperLimit');
                var index = 0;
                response.data.forEach(function (item) {
                    index ++;
                    var temp = {id:index, name: item.name, allocations:[]};
                    var currentName = item.name;
                    item.riskTypeAllocations.forEach(function (rtItem) {
                        temp.allocations.add({name:rtItem.modelAggTypeName, value:rtItem.allocation});
                    });
                    $scope.current.riskTypes.add(temp)
                })
            })
    }

    $scope.saveChanges = function () {
        var executeSave = function () {
            $http.put('/Trading/SleeveStrategyRiskType', $scope.riskTypes, {trackerMsg:'Updating Risk Type data'})
                .then(function (response) {
                    if(response.data){
                        $dialog.saveSuccessful( "Risk Type information saved.").open();
                    }
                })
        };

        var allocationsDoNotTotal100 = $scope.riskTypes.any(function (n) {
            return n.riskTypeAllocations.sum('allocation') != 100;
        });

        if(allocationsDoNotTotal100){
            $dialog.actionFailed('One or more Risk Type allocations do not equal 100%').open();
        }else{
            executeSave();
        }
    };

    $scope.updateRiskAllocationTotal = function (riskType) {
        riskType.riskTypeAllocations.sum('allocation');
    };

    $scope.updateRiskTypeTolerances = function (riskType, type) {
        if(type.toLowerCase() == 'ut'){
            var tempUpperTol = $scope.riskTypes.findIndex(riskType) + 1;
            $scope.riskTypes[tempUpperTol].lowerLimit =  riskType.upperLimit + 1;
        }
        if(type.toLowerCase() == 'lt'){
            var tempLowerTol = $scope.riskTypes.findIndex(riskType) - 1;
            $scope.riskTypes[tempLowerTol].upperLimit =  riskType.lowerLimit - 1;
        }
    };

    $scope.current = {riskTypes: [], riskTypeAllocations: [], allocationNames:['Beta', 'Active', 'Diversifier']};

    $scope.rightsSleeveRiskTypesSetup = $oasRights.forCode('SLEEVESETUP');

    init();
});

'use strict';

var portfolioTargetAccountAssignmentCtrl = app.controller('PortfolioTargetAccountAssignmentCtrl', function PortfolioTargetAccountAssignmentCtrl($rootScope, $scope, $timeout, $http, $route, $oasRights, $dialog, configResolve,  views, $location, $tradeGenerator) {
    //region PRIVATE VARIABLES
    //used for byPassing resolve on route's that are 'embed'
    var config = null;
    //endregion

    //region PRIVATE METHODS
    function init() {
        //$scope.rightsAA = $oasRights.forCode("PORTFOLIOTARGETS");
        //$scope.openDialogPrompt(false);
        if($location.path().has('/embed/')){
            $scope.startOver();
        }else{
            setConfigDefaults(configResolve);
            loadAccounts();
        }
    }

    function setConfigDefaults (configResult){
        config = configResult;
        $scope.current.rep = configResult.rep;
        $scope.current.subAdvisor = configResult.subAdvisor;
        $scope.current.manager = configResult.manager;
        $scope.current.managerName = configResult.managerName;
        $scope.current.model = configResult.model;

        if ($scope.current.manager === "Self"){
            $scope.current.managerName = 'Self Directed'
        }
        else if ($scope.current.manager === "SubAdvisor"){
            $scope.current.managerName = $scope.current.subAdvisor.name
        }
        else{
            $scope.current.managerName = 'Blended'
        }

    }

    function refreshGrid() {
        $timeout(function () {
            $scope.$broadcast('event:account-assign-list-action', {action: 'refresh-grid'});
        });
    }

    function loadAccounts(){
        if(!config) return;
        var strParams = "returnStyle=AccountAssignment&isActive=true&representativeId=" + config.repId;

        if (config.manager === 'Blended'){
            strParams += "&includeSleeveStrategies=true&includeSleeves=true&filter=modelCustodialAccountAssignment&sleeveStrategyId=" + config.model.id;
        }
        else{
            strParams += "&includeSleeveStrategies=false&filter=modelAccountAssignment";

            if (config.model){
                strParams += "&includeSleeves=true&targetAggregateModelId=" + config.model.id
            }
            else{
                strParams += "&includeSleeves=false"
            }
        }

        $scope.current.url = "/Portfolio/Accounts/Search/Advanced";
        $scope.current.params = strParams;

        refreshGrid();
    }

    function checkAndProcessAccounts(accountsToCheck){
        var warningAccounts = [];
        var issueAccounts = [];

        accountsToCheck.forEach(function (acct) {
            if (!acct.isValid) {
                var issueAccount = $scope.current.accountsToProcess.find({id: acct.id});
                issueAccount.message = acct.errorMessage;
                issueAccounts.push(issueAccount);
            }
            else if(acct.warningMessage){
                var warningAccount = $scope.current.accountsToProcess.find({id: acct.id});
                warningAccount.message = acct.warningMessage;
                warningAccounts.push(warningAccount);
            }
        });

        if (warningAccounts.length > 0 || issueAccounts.length > 0){
            var prompt = "";

            if (issueAccounts.length > 0){
                prompt += "<i class='fa fa-exclamation-circle text-error' aria-hidden='true'></i> The following accounts have errors:<ul>";
                issueAccounts.forEach(function(ia){
                    // language=HTML
                    prompt += "<li><span class='bold'>Name: " + ia.name + ", Number: " + ia.number + "</span><br/>" + ia.message + "</li>"
                });
                prompt += "</ul>";
            }
            if (warningAccounts.length > 0){
                prompt += "<i class='fa fa-exclamation-circle text-warning' aria-hidden='true'></i> The following accounts have warnings:<ul>";
                warningAccounts.forEach(function(ia){
                    prompt += "<li><span class='bold'>Name:  " + ia.name + ", Number: " + ia.number + "</span><br/>" + ia.message + "</li>"
                });
                prompt += "</ul>";
            }

            $dialog.confirmAction(prompt + "<br/>Would you like to continue with processing?" + (issueAccounts.length > 0 ? "Accounts with errors will not process." : "") )
                .open()
                .then(function (result) {
                    if (result === 'yes') {
                        processValidatedAccounts(accountsToCheck.map("id"));
                    }
                });
        }
        else{
            processValidatedAccounts(accountsToCheck.map("id"));
        }
    }

    function processValidatedAccounts(validatedAccts){
            $http.post("/Trading/SleeveStrategy/" + $scope.current.model.id + "/Action/Process/Accounts?validateOnly=false", validatedAccts, {trackerMsg: 'Assigning accounts to sleeve strategy'})
                .then(function (response) {
                    startPollingStatus(response.data.batchId);
                });
    }

    function startPollingStatus( batchId ) {
        var lastData;
        var parentId = batchId;
        var sameDataCount = 0;
        var errorCount = 0;

        var pollStatus = function(batchId) {
            if( sameDataCount > 200 ) {
                $rootScope.$broadcast('event:progress-update', { id: parentId, isDone: true, msg: parentId + ": Status updates aborted", type: "warning"});
                return;
            }

            if( errorCount > 25 ) {
                if (parentId) $rootScope.$broadcast('event:progress-update', { id: parentId, isDone: true, msg: parentId + ": Status updates aborted", type: "warning"});
                return;
            }

            $http.get("/Trading/TradeGenerationStatus/" + batchId + "?includeErrors=true", {ignoreExceptions: true})
                .then(function(response) {
                        if (angular.equals(response.data, lastData)) {
                            sameDataCount += 1;
                            $timeout(function() { pollStatus(batchId); }, 5000);
                            return;
                        }

                        sameDataCount = 0;

                        var progress = { id: parentId, completed: response.data.itemsCompleted, total: response.data.totalItems };

                        if (response.data.isDone) {
                            if (response.data.errorCount > 0){
                                $dialog.messageBox("<i class='fa fa-lg fa-exclamation-circle text-error' aria-hidden='true'></i> Account Assignment",  response.data.message).open();
                            }
                            else{
                                $dialog.messageBox("<i class='fa fa-lg fa-check-circle text-success' aria-hidden='true'></i> Account Assignment", "The accounts are being rebalanced to the new model overlay.").open();
                                $scope.current.accountsToProcess = [];
                            }

                            progress.isDone = true;

                        }
                        else
                            $timeout(function() { pollStatus(batchId); }, 5000);

                        $rootScope.$broadcast('event:progress-update', progress);
                        lastData = response.data;
                    },
                    function(data) {
                        errorCount += 1;
                        $timeout(function() { pollStatus(batchId); }, 20000);
                    }
                )
        };

        pollStatus(batchId);
    }

    function openAccountAssignmentPrompt (redirectOnCancel) {
        if($oasRights.forCode("ACCOUNTASSIGNMENTS").canRead) {

            return $dialog.dialog({
                templateUrl: "trading/portfolioTargets/modals/account-assign-prompt.html",
                controller: "AccountAssignPromptCtrl"
            })
                .open()
                .then(function (result) {
                    if (result) {
                        return Object.select(result, 'repId', 'rep', 'subAdvisor', 'model', 'manager', 'managerName');
                    }
                    else {
                        var deferred = $q.defer();
                        deferred.reject();
                        return deferred.promise;
                    }
                });
        }else{
            $location.path('/notauthorized')
        }
    }

    //endregion

    //region PUBLIC METHODS

    $scope.startOver = function () {
        openAccountAssignmentPrompt()
            .then(function(result){
                setConfigDefaults(result);
                loadAccounts();
            });
    };

    $scope.linkToModelManagement = function(){
        location.href = "#/modeling/models";
    };

    $scope.addAccounts = function(){
        $scope.current.tempAccountHolding.forEach(function (acct) {
            if ($scope.current.accountsToProcess.none({id: acct.id})) {
                $scope.current.accountsToProcess.push(acct);
            }
        });

        $scope.current.tab.accounts = true;

    };

    $scope.removeAccount = function(item){
        $scope.current.accountsToProcess.remove(item);
    };

    $scope.commitAssignment = function(){
        var accountList = $scope.current.accountsToProcess.map("id");

        if ($scope.current.manager === 'Blended'){
            $http.post("/Trading/SleeveStrategy/" + $scope.current.model.id + "/Action/Process/Accounts?validateOnly=true", accountList, {trackerMsg: 'Validating accounts for sleeve strategy'})
                .then(function (response) {
                    checkAndProcessAccounts(response.data.accounts);
                });
        }
        else if ($scope.current.manager === 'SubAdvisor'){

            $http.get("/Settings/EntityOptions/Database/Code/8:69REBALA", {cache: true, trackerMsg: 'Loading rebalance option.'})
                .then(function (response) {
                    $scope.current.rebalanceOption = response.data[0].value.toLowerCase() === 'none';
                });
            $http.post("/Portfolio/Accounts/Verbose/List/Id?expand=portfolio&expand=modelingInfo", accountList, {trackerMsg: 'Looking up accounts'})
                        .then(function (response) {
                            var verboseAccounts = response.data;

                            verboseAccounts.forEach(function (account) {
                                if (account.modelingInfo.aggregateModel){
                                    account.modelingInfo.aggregateModel.id = $scope.current.model.id
                                }
                                else{
                                    account.modelingInfo.aggregateModel = {id: $scope.current.model.id};
                                    account.modelingInfo.customAllocations = null;
                                }
                                account.portfolio.subAdvisorId = $scope.current.subAdvisor.id;
                            });

                        $http.put("/Portfolio/Accounts/Verbose/", verboseAccounts, {trackerMsg: 'Saving accounts'})
                            .then(function (response) {

                                if($scope.current.rebalanceOption){
                                    $tradeGenerator.rebalance(accountList);
                                }else {
                                    var unSleevedAccts = response.data.findAll(function (n) {
                                        return n.portfolio.isSleeveAccount === false;
                                    });
                                    if (unSleevedAccts.length > 0) {
                                        var unSleevedAccountList = unSleevedAccts.map("id");
                                        $tradeGenerator.rebalance(unSleevedAccountList);
                                    }
                                }
                                $dialog.messageBox("<i class='fa fa-lg fa-check-circle text-success' aria-hidden='true'></i> Account Assignment", "The accounts are being rebalanced to the new model.").open();
                                $scope.current.accountsToProcess = [];
                            });
                });
        }
        else if ($scope.current.manager === 'Self'){
            $http.post("/Portfolio/Accounts/Action/AssignToSelfDirected", accountList, {trackerMsg: 'Assigning accounts to self-directed model'})
                .then(function (response) {
                    var result = accountList.length - response.data.length;

                    if (result === 0) {
                        $dialog.actionComplete("The accounts are being assigned to Self-Directed.").open();
                    } else if (result === accountList.length) {
                        $dialog.actionFailed("None of the accounts were able to be assigned to Self-Directed.  Check your notifications for further details.").open();
                    } else {
                        $dialog.actionComplete(response.data.length + " accounts are being assigned to Self-Directed.  " + result + " accounts were not able to be assigned.  Check your notifications for further details.").open();
                    }

                    $scope.current.accountsToProcess = [];
                });
        }
    };

    $scope.setWidth = function (goWide) {
        $scope.rightSidebar.width = goWide ? 400 : 250;
    };

    $scope.slickGridDoubleClick = function () {
        if ($scope.selectedIds.length > 0) {
            $scope.addAccounts();
        }
    };

    //endregion

    //region INITIALIZE
    $scope.views = views;
    $scope.selectedIds = []; //entityId's
    $scope.current = {
        view: views[0],
        gridDoubleClick: $scope.slickGridDoubleClick,
        tempAccountHolding: [],
        accountsToProcess: [],
        tab:{views: true, accounts: false},
        rep: null,
        subAdvisor:null,
        manager: null,
        managerName: null,
        model: null,
        rebalanceOption: false
        //url: "/Portfolio/Accounts/Search/Advanced",
        //params: "returnStyle=AccountAssignment&representativeId=0"
    };



    $scope.current.hotKeyActions = [{
        combo: 'ALT+E', command: $scope.slickGridDoubleClick
    }];

    //endregion

    init();

    //regionEVENT LISTENERS
    $scope.$on("event:account-assign-select", function (e, args) {
        if (args.length === 0) return;

        $scope.current.tempAccountHolding = angular.copy(args);

    });

    //endregion
});

 portfolioTargetAccountAssignmentCtrl.loadSearchAccountView = ["$http", "$dialog", "$q","$oasRights", "$location", function ($http, $dialog, $q, $oasRights, $location) {

    return $oasRights.isLoaded
         .then(function () {
             if($oasRights.forCode("ACCOUNTASSIGNMENTS").canRead) {
                 if($location.path().has('/embed/')){
                     var config = {
                         repId: 0,
                         rep: null,
                         subAdvisor: null,
                         model: null,
                         manager: null
                     };
                     var deferred = $q.defer();
                     return deferred.resolve(config);
                 }

                 return $dialog.dialog({
                     templateUrl: "trading/portfolioTargets/modals/account-assign-prompt.html",
                     controller: "AccountAssignPromptCtrl"
                 })
                     .open()
                     .then(function (result) {
                         if (result) {
                             return Object.select(result, 'repId', 'rep', 'subAdvisor', 'model', 'manager');
                         }
                         else {
                             var deferred = $q.defer();
                             deferred.reject();
                             return deferred.promise;
                         }
                     });
             }else{
                 $location.path('/notauthorized')
             }

         })

 }];

app.controller('AccountAssignPromptCtrl', function AccountAssignPromptCtrl($scope, $http, $location, dialog, entities) {
    //PRIVATE METHODS
    function init() {
    }

    function loadSubAdvisorsByRep() {
        $http.get("/Portfolio/Representatives/" + $scope.current.repId + "/Subadvisors", {trackerMsg: 'Loading Sub Advisors'})
            .then(function (response) {
                $scope.current.subAdvisors = response.data.remove(function(sa){
                    return sa.name.has('Self-Directed') || sa.name.has('Self Directed')
                }).sortBy("name");
            });
    }

    function loadModelsBySubAdvisor() {
        $http.get("/Trading/ModelAggs/Simple?subAdvisorId=" + $scope.current.subAdvisor.id, {trackerMsg: 'Loading models'})
            .then(function (response) {
                $scope.current.models = response.data;
            });
    }

    function loadBlendedModelsByRep() {
        $http.get("/Trading/SleeveStrategy/Verbose?expand=Core&repId=" + $scope.current.repId, {trackerMsg: 'Loading overlay models'})
            .then(function (response) {
                var sleeveStrategies = response.data
                    .map(function (ss) {
                        return {id: ss.id, name: ss.core.name};
                    });


                $scope.current.models = sleeveStrategies;
            });
    }

    //PUBLIC METHODS
    $scope.processManager = function(){

        $scope.current.subAdvisor = null;
        $scope.current.model = null;
        $scope.current.models = null;

        if ($scope.current.manager == 'SubAdvisor'){
            loadSubAdvisorsByRep()
        }
        else if ($scope.current.manager == 'Blended'){
            loadBlendedModelsByRep()
        }
    };

    $scope.loadSubAdvisorModels = function(){
        $scope.current.model = null;
        $scope.current.models = null;
        loadModelsBySubAdvisor();
    };


    $scope.cancel = function() {
        dialog.close();

    };

    $scope.loadSearchAccounts = function() {
        dialog.close($scope.current);

    };

    //INITIALIZE
    $scope.current = {
        isRep: $scope.user.authorization.entity == entities.representative.name,
        subAdvisor: null,
        model: null
    };

    $scope.current.repId = $scope.current.isRep ? $scope.user.authorization.entityId : 0;

    init();

    //SCOPE WATCHERS
    $scope.$watch('current.rep', function (newValue, oldValue) {
        if (!newValue || newValue == oldValue) return;

        $scope.current.repId = newValue.id;
        $scope.current.manager = null;
        $scope.current.subAdvisor = null;
        $scope.current.model = null;
    });

    $scope.$watch('user.authorization', function (newValue, oldValue) {
        if (!newValue || newValue == oldValue) return;

        $scope.current.isRep = newValue.entity == entities.representative.name;
        $scope.current.repId = $scope.current.isRep ? newValue.entityId : 0;

    });


});


app.controller('SleeveStrategyPromptCtrl', function SleeveStrategyPromptCtrl($scope, $http, dialog, entities, $routeParams) {
    //PRIVATE METHODS
    function init() {
        if ($scope.current.isFiltered){
            loadSleeveStrategies()
        }

    }

    function loadSleeveStrategies() {
        $http.get("/Trading/SleeveStrategy/Verbose?expand=Core&repId=" + $scope.current.repId, {trackerMsg: 'Loading overlay models'})
            .then(function (response) {
                $scope.current.models = response.data
                    .map(function (ss) {
                        return {id: ss.id, name: ss.core.name};
                    });
            });
    }

    //PUBLIC METHODS

    $scope.cancel = function() {
        dialog.close();

    };

    $scope.loadHouseholds = function() {
        dialog.close($scope.current);
    };

    //INITIALIZE
    $scope.current = {
        model: null,
        models: null,
        isRep: $scope.user.authorization.entity === entities.representative.name,
        isFiltered: dialog.options.isFiltered
    };

    $scope.current.repId = $scope.current.isRep ? $scope.user.authorization.entityId : 0;

    init();

    //SCOPE WATCHERS
    $scope.$watch('current.rep', function (newValue, oldValue) {
        if (!newValue || newValue === oldValue) return;

        $scope.current.repId = newValue.id;
        if($scope.current.isFiltered){
            loadSleeveStrategies();
        }
    });

    $scope.$watch('user.authorization', function (newValue, oldValue) {
        if (!newValue || newValue === oldValue) return;

        $scope.current.isRep = newValue.entity === entities.representative.name;
        $scope.current.repId = $scope.current.isRep ? newValue.entityId : 0;
    });

});



app.controller('PortfolioTargetRegistrationRepPromptCtrl', function PortfolioTargetRegistrationRepPromptCtrl($scope, $http, dialog, entities, $routeParams) {
    //PRIVATE METHODS
    function init() {

    }

    //PUBLIC METHODS

    $scope.cancel = function() {
        dialog.close();

    };

    $scope.loadStrategyForRep = function() {
        dialog.close($scope.current);
    };

    //INITIALIZE
    $scope.current = {
        rep: null,
        isRep: $scope.user.authorization.entity == entities.representative.name,
        isFiltered: $routeParams.filter == 1
    };

    $scope.current.repId = $scope.current.isRep ? $scope.user.authorization.entityId : 0;

    init();

    //SCOPE WATCHERS
    $scope.$watch('current.rep', function (newValue, oldValue) {
        if (!newValue || newValue == oldValue) return;

        $scope.current.repId = newValue.id;
    });

});




'use strict';

app.controller('EclipseFirmsCtrl', function EclipseFirmsCtrl($scope, $rootScope, $routeParams, $dialog, $http, $location, $oasRights) {

    //region Private Variables
    var firmId = $routeParams.id;
    var isNew = firmId === 0;
    //endregion

    //region Private Methods
    function init() {

        $scope.accountNameType = {
            currentlySelected: 'lastFirst',
            option1: {
                value: 'lastFirst',
                label: 'Last name, First name',
            },
            option2: {
                value: 'FullName',
                label: 'Registration name',
            }
        };

        $scope.assetMappingTypes = [
            {
                value: 'AssetClass',
                label: 'Asset Class'
            },
            {
                value: 'AssetCategory',
                label: 'Asset Category'
            },
            {
                value: 'RiskCategory',
                label: 'Risk Category'
            }]

        $scope.assetMappings = {
            classType: {
                selectedValue:null,
                prevValue: null
            },
            categoryType: {
                selectedValue: null,
                prevValue: null
            },
            subClassType: {
                selectedValue: null,
                prevValue: null
            }
        }


        //TODO:  remove this later - only for testing typeahaed
        $http.get('/Integrations/Eclipse/Firms', { trackerMsg: 'Loading Eclipse Firms' })
            .then(function (response) {
                $scope.eclipseFirmNames = response.data.map('name');
            });

        $http.get('/Authorization/User/Databases', { trackerMsg: 'Getting database list' })
            .then(function (response) {
                $scope.alClientList = response.data;

                if (firmId == 0) {
                    $scope.eclipseFirm = {
                        firmId: 0,
                        name: '',
                        alClients: []
                    }
                    setDefaultAssetMappingTypes();
                } else {
                    $http.get('/Integrations/Eclipse/Firms/' + firmId, { trackerMgs: 'Getting Eclipse firm ' + firmId })
                        .then(function (firmResponse) {
                            $scope.eclipseFirm = firmResponse.data;

                            $scope.accountNameType.currentlySelected = firmResponse.data.accountNameType;

                            setAssetMappingType('classType', firmResponse.data.assetClassMapping.classMappingType);
                            setAssetMappingType('subClassType', firmResponse.data.assetClassMapping.subClassMappingType);
                            setAssetMappingType('categoryType', firmResponse.data.assetClassMapping.categoryMappingType);

                            $scope.eclipseFirm.alClients.forEach(function (item) {
                                item['isEditMode'] = false;
                            });
                        })
                }
            });
    }

    function setDefaultAssetMappingTypes() {
        setDefaultAssetMappingType('classType', 'RiskCategory');
        setDefaultAssetMappingType('subClassType', 'AssetClass');
        setDefaultAssetMappingType('categoryType', 'AssetCategory');
    }

    function setAssetMappingType(type, value) {
        $scope.assetMappings[type].selectedValue = value;
        $scope.assetMappings[type].prevValue = value;
    }

    //endregion

    //region Public Methods
    $scope.setDbDefault = function (item) {
        $scope.eclipseFirm.alClients.each(function (d) {
            if (d.fkAlClient != item.fkAlClient) {
                d.isDefault = false;
            }
        })
    };

    $scope.addAlClient = function () {
        var dialogOpts = {
            templateUrl: "eclipse-firm-database-search.html",
            controller: "EclipseFirmDatabaseLookupCtrl",
            alClientsList: $scope.alClientList,
            selectedList: $scope.eclipseFirm.alClients.map(function (n) {
                return $scope.alClientList.find({ id: n.fkAlClient });
            })
                .sortBy('clientName')
        };

        var d = $dialog.dialog(dialogOpts);
        d.open()
            .then(function (rslt) {
                if (rslt) {
                    rslt.each(function (item) {
                        if ($scope.eclipseFirm.alClients.none({ fkAlClient: item.id })) {
                            $scope.eclipseFirm.alClients.add(
                                {
                                    pkEclipseFirmAlClient: 0,
                                    eclipseFirmId: $scope.eclipseFirm.eclipseFirmId,
                                    fkAlClient: item.id,
                                    isDefault: false,
                                    isDefaultEclipseFirm: false
                                })
                        }
                    })
                }
            });
    };

    $scope.saveEclipseFirm = function () {
        var trackerMsg = isNew ? "Adding new eclipse firm " : "Saving eclipse firm " + $scope.eclipseFirm.firmId;
        $scope.eclipseFirm.accountNameType = $scope.accountNameType.currentlySelected;
        $scope.eclipseFirm.assetClassMapping.classMappingType = $scope.assetMappings.classType.selectedValue;
        $scope.eclipseFirm.assetClassMapping.subClassMappingType = $scope.assetMappings.subClassType.selectedValue;
        $scope.eclipseFirm.assetClassMapping.categoryMappingType = $scope.assetMappings.categoryType.selectedValue;
        $http.put('/Integrations/Eclipse/Firms/' + $scope.eclipseFirm.eclipseFirmId, $scope.eclipseFirm, { trackerMsg: trackerMsg })
            .then(function (response) {
                var msg = isNew ? 'Successfully added eclipse firm ' : 'Successfully saved eclipse firm';
                $dialog.actionComplete(msg).open()
                    .then(function () {
                        $location.path('/trading/eclipsefirms');
                    })
            })
    };

    $scope.deleteEclipseFirm = function () {
        $http.delete('/Integrations/Eclipse/Firms/' + firmId, { trackerMgs: 'Deleting eclipse firm ' + firmId })
            .then(function () {
                $location.path('/trading/eclipsefirms');
            })
    };

    $scope.syncPortfolioGroups = function () {
        //pop dialog saying to stay on page
        $dialog.dialog({
            templateUrl: "trading/eclipse/views/sync-portfolio-groups-modal.html",
            controller: "SyncPortfolioGroupsModalCtrl",
            resolve: { syncPortfolioGroupsModalArgs: function () { return { eclipseFirmId: firmId }; } }
        }).open();

        //post firm ID to api
        $http.post('/Integrations/Eclipse/PortfolioAssignment/InitiateSync?eclipseFirmId=' + firmId, { trackerMsg: 'Syncing portfolio groups for firm ' + firmId })
            .then(function (response) {
                if (response.data != null) {
                    var data = {
                        isLoading: false,
                        failedFirms: response.data.filter(firm => firm.portfolioIds == null && !firm.isFullSuccess),
                        partiallySuccessfulFirms: response.data.filter(firm => firm.portfolioIds != null && !firm.isFullSuccess),
                        successfulFirms: response.data.filter(firm => firm.isFullSuccess),
                        hasError: false
                    };
                    $rootScope.$emit('SyncPortfolioGroupsComplete', data);
                }
                else {
                    //should never happen, but we'll display an alternate message just in case
                    var data = {
                        isLoading: false,
                        failedFirms: [],
                        partiallySuccessfulFirms: [],
                        successfulFirms: [],
                        hasError: true
                    };
                    $rootScope.$emit('SyncPortfolioGroupsComplete', data);
                }
            });
    };

    $scope.removeAlClient = function (id) {
        $scope.eclipseFirm.alClients.remove(id);
    };

    $scope.getAlClientName = function (fkAlClient) {
        var tempName = $scope.alClientList.find({ id: fkAlClient });
        return tempName ? tempName.clientName : 'Not Found'
    };

    $scope.categoryMappingTypeChanged = function () {
        const prevValue = $scope.assetMappings.categoryType.prevValue;
        const newValue = $scope.assetMappings.categoryType.selectedValue;

        if ($scope.assetMappings.subClassType.selectedValue === newValue) {
            setAssetMappingType('subClassType', prevValue);
        }
        else if ($scope.assetMappings.classType.selectedValue === newValue) {
            setAssetMappingType('classType', prevValue);
        }

        $scope.assetMappings.categoryType.prevValue = newValue;
    }

    $scope.classMappingTypeChanged = function () {
        const prevValue = $scope.assetMappings.classType.prevValue;
        const newValue = $scope.assetMappings.classType.selectedValue;

        if ($scope.assetMappings.categoryType.selectedValue === newValue) {
            setAssetMappingType('categoryType', prevValue);
        }
        else if ($scope.assetMappings.subClassType.selectedValue === newValue) {
            setAssetMappingType('subClassType', prevValue);
        }

        $scope.assetMappings.classType.prevValue = newValue;
    }

    $scope.subclassMappingTypeChanged = function () {
        const prevValue = $scope.assetMappings.subClassType.prevValue;
        const newValue = $scope.assetMappings.subClassType.selectedValue;

        if ($scope.assetMappings.categoryType.selectedValue === newValue) {
            setAssetMappingType('categoryType', prevValue);;
        }
        else if ($scope.assetMappings.classType.selectedValue === newValue) {
            setAssetMappingType('classType', prevValue);

        }

        $scope.assetMappings.subClassType.prevValue = newValue;

    }

    //endregion

    //region Public Variables & Rights
    $scope.eclipseFirm = null;
    $scope.rightsEclipseFirms = $oasRights.forCode('ECLIPSETRADING');
    $scope.rightsEclipseAdmin = $oasRights.forCode('ECLIPSEORIONADMIN');
    //endregion

    init()

});

app.controller('EclipseFirmDatabaseLookupCtrl', function EclipseFirmDatabaseLookupCtrl($http, $scope, $timeout, $window, dialog) {

    function init() {
        $scope.alClients.list = dialog.options.alClientsList.sortBy('clientName');
        $scope.alClients.selected = dialog.options.selectedList;
    }
    $scope.alClients = { list: [], selected: [] };

    $scope.add = function () {
        dialog.close($scope.alClients.selected);
    };
    $scope.close = function () {
        dialog.close(null);
    };
    init();
});

'use strict';

app.controller('EclipseFirmsListCtrl', function EclipseFirmsListCtrl($scope, $http, $oasRights, $dialog) {

    //region Private Variables

    //endregion

    //region Private Methods
    function init() {
        getEclipseFirms();
    }

    function getEclipseFirms() {
        $http.get('/Integrations/Eclipse/Firms', { trackerMsg: 'Loading Eclipse Firms' })
            .then(function (response) {
                response.data.forEach(function (item) {
                    item.selected = false;
                });
                $scope.eclipseFirmsList = response.data;
            })
    }
    //endregion

    //region Public Variables
    $scope.searchFor = null;
    //endregion

    //region Public Methods
    $scope.refreshList = function () {
        getEclipseFirms();
    };

    $scope.setButton = function (firm, type) {
        var disableButton = true;

        if (firm.selected) {
            return disableButton;
        }

        if (type == 'full') {
            if (!firm.syncStatus || firm.syncStatus == 'Extract Finished' || firm.syncStatus.has('Failed')) {
                disableButton = false;
            }
        }
        if (type == 'delta') {
            if (firm.syncDate && firm.syncStatus) {
                disableButton = false;
            }
        }
        return disableButton;
    };

    $scope.startExtract = function (firm, doFullExtract) {
        var startExtract = function (eclipseData, isFullExtract) {
            var msg = `Starting Eclipse ${doFullExtract ? '(Full)' : '(Delta)'} sync`;
            var data = { firmId: eclipseData.firmId, isFullExtract };

            $http({
                method: 'POST',
                url: '/Integrations/Eclipse/Actions/InitiateV2ImportOnEclipse',
                data: data,
                trackerMsg: `Starting Eclipse ${msg} sync`
            }).then(function (response) {
                completeExtract(response.data);
            });
        };

        function completeExtract(eclipseV2ExtractRequest) {
            $http({
                method: 'POST',
                url: '/Integrations/Eclipse/Actions/StartExtractV2',
                data: eclipseV2ExtractRequest,
                trackerMsg: `Completing ${eclipseV2ExtractRequest.importType} extract for firm: ${eclipseV2ExtractRequest.firmId}`
            }).then(function () {
                getEclipseFirms();
            });
        }

        $scope.selectItem(firm);

        var eclipseRequest = { firmId: firm.eclipseFirmId, sessionToken: null };

        startExtract(eclipseRequest, doFullExtract);
    };


    $scope.selectItem = function (row) {
        row.selected = !row.selected;
        $scope.current.selectedFirms = $scope.eclipseFirmsList.findAll({ selected: true });
    };

    $scope.deleteEclipseFirm = function (firm) {
        //don't want to hightlight row if they click delete action
        firm.selected = !firm.selected;

        $dialog.confirmAction('Delete ' + firm.name + '?').open()
            .then(function (rslt) {
                if (rslt === 'yes') {
                    $http.delete('/Integrations/Eclipse/Firms/' + firm.eclipseFirmId, { trackerMsg: 'Deleting Eclipse Firm' })
                        .then(function (response) {
                            $scope.refreshList();
                        })
                }
            })
    };
    //endregion

    //region Initialize & Rights
    $scope.rightsEclipseFirms = $oasRights.forCode('ECLIPSETRADING');
    $scope.rightsEclipseAdmin = $oasRights.forCode('ECLIPSEORIONADMIN');
    $scope.eclipseFirmsList = [];
    $scope.current = { selectedFirms: [], syncStarted: false };

    //endregion

    init()

});
'use strict';

app.controller('OrionConnectFirmCtrl', function OrionConnectFirmCtrl($scope, $rootScope, $http, $dialog, $oasRights) {
    // Define variables
    $scope.orionConnectFirm = null;
    $scope.eclipseFirms = null;
    $scope.selectedDefaultEclipseFirm = {};
    $scope.pageFeatures = {};
    const alClientId = $rootScope.user.authorization.alClientId;

    // Fetch EclipseFirms for the current OrionConnectFirm
    function init() {
        $scope.pageFeatures.preventSave = true;
        $scope.pageFeatures.displayEclipseSetupPane = false;
        getOrionConnectFirmDetails();
    }

    function getEclipseFirmsWithAlClientsForOcFirm() {
        $http.get(`/Integrations/Eclipse/Firms/ByAlClientId/${alClientId}`, { trackerMsg: 'Loading Eclipse Firms' })
            .then(response => {
                $scope.eclipseFirms = response.data;

                // Find the firm with isDefault = 1 and set it as the initial selected value
                const defaultFirm = $scope.eclipseFirms.find(firm => firm.alClients[0].isDefaultEclipseFirm === true);
                $scope.selectedDefaultEclipseFirm.firmId = defaultFirm?.eclipseFirmId;
                $scope.pageFeatures.preventSave = false;
                $scope.pageFeatures.displayDefaultFirmList = true;
            })
            .catch(error => {
                console.error("There was an error fetcing the Eclipse firms.");
            });
    }

    function getOrionConnectFirmDetails() {
        $http.get(`/Authorization/User/Databases/${alClientId}`, { trackerMsg: 'Loading OrionConnect Firm Details' })
            .then(response => {
                $scope.orionConnectFirm = response.data;
                getEclipseFirmsWithAlClientsForOcFirm();
                $scope.pageFeatures.displayEclipseSetupPane = true;
            })
            .catch(error => {
                console.error("There was an error fetching the OrionConnect firm name. Saving will be disabled.")
            })
    }

    init();
    $scope.rightsEclipseFirms = $oasRights.forCode('ECLIPSETRADING');
    $scope.rightsEclipseAdmin = $oasRights.forCode('ECLIPSEORIONADMIN');

    $scope.saveOrionConnectFirm = function () {
        if ($scope.pageFeatures.preventSave || !$scope.rightsEclipseAdmin.canUpdate) {
            $dialog.actionFailed("Saving is disabled.");
            return;
        }

        if ($scope.selectedDefaultEclipseFirm) {
            const myEclipseSetupData = {
                targetAlClientId: alClientId,
                selectedDefaultEclipseFirmId: $scope.selectedDefaultEclipseFirm.firmId ?? 0
            };

            $http.post('/Integrations/Eclipse/Firms/SetDefaultEclipseFirmForAlClient', myEclipseSetupData, )
                .then(function (response) {
                    var msg = 'Eclipse Settings Saved';
                    $dialog.saveSuccessful(msg).open();
                });
        }
    };
});

'use strict';

app.controller('SyncPortfolioGroupsModalCtrl', function SyncPortfolioGroupsModalCtrl($scope, $rootScope, $dialog, dialog, syncPortfolioGroupsModalArgs) {

    //PRIVATE METHODS
    function init() {
        $scope.eclipseFirmId = syncPortfolioGroupsModalArgs.eclipseFirmId;
        $scope.isLoading = true;
        $scope.hasError = false;
        $scope.partiallySuccessfulFirms = [];
        $scope.failedFirms = [];
        $scope.successFulFirms = [];
    };

    //PUBLIC METHODS
    $scope.close = function () {
        dialog.close();
    };

    $rootScope.$on("SyncPortfolioGroupsComplete", function (event, data) {
        $scope.isLoading = data.isLoading;
        $scope.partiallySuccessfulFirms = data.partiallySuccessfulFirms;
        $scope.failedFirms = data.failedFirms;
        $scope.successfulFirms = data.successfulFirms;
        $scope.hasError = data.hasError;
    });

    $scope.getStatus = function () {
        if ($scope.successfulFirms.length > 0 && $scope.failedFirms.length === 0 && $scope.partiallySuccessfulFirms.length === 0)
            return 'Full Success!';
        else if ($scope.successfulFirms.length === 0 && $scope.partiallySuccessfulFirms.length === 0)
            return 'Failure.';
        return 'Partial Success.';
    };

    $scope.getStatusDescriptionMessage = function () {
        if ($scope.successfulFirms.length > 0 && $scope.failedFirms.length === 0 && $scope.partiallySuccessfulFirms.length === 0)
            return 'All portfolio groups have successfully synced and are ready for review in their respective Orion Connect firms.';
        else if ($scope.successfulFirms.length === 0 && $scope.partiallySuccessfulFirms.length === 0)
            return 'Portfolio Group Sync failed for all Orion Connect firms.';
        return 'All other firms synced successfully. Please review portfolio groups in respective Orion Connect firms.';
    };

    $scope.getFailedFirmIds = function () {
        return $scope.failedFirms.map(f => f.alClientId);
    };

    init();
});

'use strict';

app.controller('RiskTolerancesCtrl', function RiskTolerancesCtrl($scope, $http, $oasRights, $dialog) {
  function init() {
    getRiskTolerances();
    getReturnObjectives();
    getTimeHorizons();
  }

  $scope.getDisplayValues = function (data) {
    data.forEach(d => {
      d.highDisplay = d.riskRangeHigh >= 100 ? '100+' : d.riskRangeHigh;
      d.lowDisplay = d.riskRangeLow < 0 ? 0 : d.riskRangeLow;
      d.lowerTolerance = d.riskRangeLow - d.driftRangeLow;
      d.upperTolerance = d.driftRangeHigh - d.riskRangeHigh;
    });
  }

  $scope.formatROForDisplay = function (data) {
    data.forEach(d => {
      let strArr = d.description.replace(/[^0-9\-]/g, '').split('-');
      d.low = +strArr[0];
      d.high = strArr.length > 1 ? +strArr[1] : null;
    });
  };

  $scope.formatTHForDisplay = function (data) {
    data.forEach(d => {
      let strArr = d.description.replace(/[^0-9\-]/g, '').split('-');
      d.low = +strArr[0];
      d.high = strArr.length > 1 ? +strArr[1] : null;
    });
  };

  // drift range low = low - lower tolerance
  // drift range high = high + upper tolerance
  $scope.addToleranceBand = function () {
    $scope.riskTolerances.push(
      {
        id: 0,
        description: '',
        riskRangeLow: null,
        riskRangeHigh: null,
        lowerTolerance: null,
        upperTolerance: null,
        driftRangeHigh: null,
        driftRangeLow: null,
        lowDisplay: null,
        highDisplay: null
      }
    );
  }

  $scope.addReturnObjectiveBand = function () {
    $scope.returnObjectives.push(
      {
        id: 0,
        low: null,
        high: null
      }
    );
  }

  $scope.addTimeHorizonBand = function () {
    $scope.timeHorizons.push(
      {
        id: 0,
        low: null,
        high: null
      }
    );
  }

  $scope.removeToleranceBand = function (index) {
    $scope.riskTolerances.splice(index, 1);
  }

  $scope.removeReturnObjectiveBand = function (index) {
    $scope.returnObjectives.splice(index, 1);
  }

  $scope.removeTimeHorizonBand = function (index) {
    $scope.timeHorizons.splice(index, 1);
  }

  $scope.viewToleranceDescription = function (index) {
    const dialogOpts = {
      templateUrl: 'risk-tolerance-description.html',
      controller: 'RiskToleranceDescriptionController',
      riskTolerance: $scope.riskTolerances[index]
    };

    var dialog = $dialog.dialog(dialogOpts);
    dialog.open()
    .then(function(result) {
      if(result) {
        $scope.riskTolerances[index].detail = result;
      }
    });
  }

  $scope.validateTolerances = function () {
    $scope.riskTolerances = $scope.riskTolerances.sort((a, b) => a.riskRangeLow - b.riskRangeLow);
    const tolerances = [...$scope.riskTolerances];
    if (tolerances.length === 0) {
      return;
    }

    // Check if band names are unique
    const groups = tolerances.reduce((groups, item) => {
      const group = (groups[item.description.toLowerCase()] || []);
      group.push(item);
      groups[item.description.toLowerCase()] = group;
      return groups;
    }, {});

    let errorFound = false;
    Object.keys(groups).forEach(g => {
      if (groups[g].length > 1) {
        $scope.errorMessage = 'Risk band names must be unique';
        errorFound = true;
        return;
      }
    });

    const hasFractionalValue = tolerances.some(tolerance =>
        !Number.isInteger(tolerance.riskRangeLow) ||
        !Number.isInteger(tolerance.riskRangeHigh)
    );

    if (hasFractionalValue) {
        $scope.errorMessage = 'Risk band cannot have a fractional value';
        errorFound = true;
    }

    if (errorFound) {
      return false;
    }

    // Check that all values are between 0-100
    if (!tolerances.every(t => t.riskRangeLow >= 0 && t.riskRangeLow <= 100)
      || !tolerances.every(t => t.riskRangeHigh >= 0 && t.riskRangeHigh <= 100)
      || !tolerances.every(t => t.lowerTolerance >= 0 && t.lowerTolerance <= 100)
      || !tolerances.every(t => t.upperTolerance >= 0 && t.upperTolerance <= 100)
    ) {
      $scope.errorMessage = 'Range values must be 0-100';
      return false;
    }

    // Make sure the lowest band has a low of 0
    const lowTolerances = [...tolerances].sort((a, b) => a.riskRangeLow - b.riskRangeLow);
    if (lowTolerances[0].riskRangeLow !== 0) {
      $scope.errorMessage = 'Risk bands require the lowest band to start with a low of 0';
      return false;
    }

    // Make sure highest band has a high of 100
    const highTolerances = [...tolerances].sort((a, b) => b.riskRangeHigh - a.riskRangeHigh);
    if (highTolerances[0].riskRangeHigh !== 100) {
      $scope.errorMessage = 'Risk bands require the highest band to end with a high of 100';
      return false;
    }

    // Make sure that low values are lower than high values
    if (tolerances.any(t => t.riskRangeLow > t.riskRangeHigh)) {
      $scope.errorMessage = 'The low of a risk band cannot be higher than the high of the same risk band';
      return false;
    }

    // If only 1 value and other validation passes, do not need to check overlapping bands
    if (tolerances.length === 1) {
      return true;
    }

    // Make sure that band values do not overlap and that every number is accounted for
    for (let i = 0; i < tolerances.length; i++) {
      if (i !== tolerances.length - 1) {
        let difference = tolerances[i + 1].riskRangeLow - tolerances[i].riskRangeHigh;
        if (difference > 1) {
          $scope.errorMessage = 'The Risk Tolerances need to encompass all numbers from 0-100 in the Low and High.';
          return false;
        }
      }

      // Make sure that a drift only ever has the highest value of 100
      if (parseInt(tolerances[i].riskRangeHigh) + parseInt(tolerances[i].upperTolerance) > 100) {
        $scope.errorMessage = 'The Risk Bands cannot exceed 100+ for their Upper Tolerance Limit.  Please advise.';
        return false;
      }

      // Do not need to check overlap on the first band
      if (i === 0) {
        continue;
      }

      let high = tolerances[i - 1].riskRangeHigh;
      let low = tolerances[i].riskRangeLow;

      if (low <= high) {
        $scope.errorMessage = 'Risk bands can\'t overlap values between the low and high range';
        return false;
      }

      if (+high == 0) {
        $scope.errorMessage = 'Values cannot be null';
        return false;
      }
    }

    return true;
  }

  $scope.validateReturnObjectives = function () {
    let error = $scope.returnObjectives.every((r, i) => {
      if (r.low === null || r.low === undefined) {
        $scope.errorMessage = 'Must provide a Low value';
        return false;
      }

      if (i > 0) {
        if (r.low <= $scope.returnObjectives[i - 1].high) {
          $scope.errorMessage = 'Return Objective Bands cannot overlap';
          return false;
        }

        else if (r.low !== $scope.returnObjectives[i - 1].high + 1) {
          $scope.errorMessage = 'Return Objective Bands cannot skip numbers';
          return false;
        }

        else if (r.low > 0 && !($scope.returnObjectives[i - 1].high > 0)) {
          $scope.errorMessage = 'Row with no High value must be the final row';
          return false;
        }

        else if (!(r.high > 0) && !($scope.returnObjectives[i - 1].high > 0)) {
          $scope.errorMessage = 'Cannot have two empty High values';
          return false;
        }
      }

      if (r.high > 0 && r.low >= r.high) {
        $scope.errorMessage = 'Low value cannot be larger or equal to High value';
        return false;
      }

      return true;
    });

    return (error);
  }

  $scope.validateTimeHorizons = function () {
    let error = $scope.timeHorizons.every((r, i) => {
      if (r.low === null || r.low === undefined) {
        $scope.errorMessage = 'Must provide a Low value';
        return false;
      }

     if (i > 0) {
        if (r.low > $scope.timeHorizons[i - 1].high + 1) {
          $scope.errorMessage = 'Time Horizon Bands cannot skip numbers';
        }

        else if (r.low > 0 && !($scope.timeHorizons[i - 1].high > 0)) {
          $scope.errorMessage = 'Row with no High value must be the final row';
          return false;
        }

        else if (!(r.high > 0) && !($scope.timeHorizons[i - 1].high > 0)) {
          $scope.errorMessage = 'Cannot have two empty High values';
          return false;
        }
      }

      if (r.high > 0 && r.low >= r.high) {
        $scope.errorMessage = 'Low value cannot be larger or equal to High value';
        return false;
      }

      return true;
    });

    return (error);
  }

  $scope.saveRiskBands = function () {
    $scope.riskTolerances.forEach(rt => {
      if (rt.highDisplay !== '100+') {
        rt.riskRangeHigh = +rt.highDisplay;
      }

      rt.riskRangeLow = +rt.lowDisplay;
      rt.driftRangeLow = +rt.riskRangeLow - +rt.lowerTolerance;
      rt.driftRangeHigh = +rt.riskRangeHigh + +rt.upperTolerance;
    });

    let validData = $scope.validateTolerances();
    if (!validData) {
      $dialog.actionFailed($scope.errorMessage).open();
      return;
    }

    $http.put("/Portfolio/InvestmentObjectives", $scope.riskTolerances, { trackerMsg: "Saving Risk Tolerances" })
      .then(function (response) {
        if (response.data) {
          $scope.getDisplayValues(response.data);
          $scope.riskTolerances = response.data;
          $dialog.saveSuccessful("Risk tolerances saved.").open();
        }
      });
  }

  $scope.saveReturnObjectiveBands = function () {
    if ($scope.returnObjectives.length === 0) initDefaultReturnObjectives();
    let validData = $scope.validateReturnObjectives();

    if (!validData) {
      $dialog.actionFailed($scope.errorMessage).open();
      return;
    }

    $scope.returnObjectives.forEach((ro, i) => {
      ro.seqNo = i;
      ro.description = ro.high > 0 ? `${ro.low}-${ro.high}%` : `${ro.low}% or Greater`;
    });

    $http.put("/Portfolio/ReturnObjectives", $scope.returnObjectives, { trackerMsg: "Saving Return Objectives" })
      .then(function (response) {
        if (response.data) {
          if (response.data && response.data.length > 0) {
            $scope.formatROForDisplay(response.data);
            $scope.returnObjectives = response.data;
          } else {
            initDefaultReturnObjectives();
          }

          $dialog.saveSuccessful("Return Objectives saved.").open();
        }
      });
  }

  $scope.saveTimeHorizonBands = function () {
    if ($scope.timeHorizons.length === 0) initDefaultTimeHorizons();

      $scope.timeHorizons.sort((a, b) => a.low > b.low ? 1 : a.low < b.low ? -1 :
          (a.high > b.high ? 1 : a.high < b.high ? -1 : 0))

    let validData = $scope.validateTimeHorizons();

    if (!validData) {
      $dialog.actionFailed($scope.errorMessage).open();
      return;
    }

    $scope.timeHorizons.forEach((ro, i) => {
      ro.seqNo = i;
      ro.description = ro.high > 0 ? `${ro.low}-${ro.high}` : `${ro.low} or Greater`;
    });

    $http.put("/Portfolio/TimeHorizons", $scope.timeHorizons, { trackerMsg: "Saving Time Horizon" })
      .then(function (response) {
        if (response.data) {
          if (response.data && response.data.length > 0) {
            $scope.formatTHForDisplay(response.data);
            $scope.timeHorizons = response.data;
          } else {
            initDefaultTimeHorizons();
          }

          $dialog.saveSuccessful("Time Horizon saved.").open();
        }
      });
  }

  function getRiskTolerances() {
    /** We are no longer going to check for the additional privilege, but keeping here for reference in case that changes **/
    // $http.get(`/Authorization/User/Privileges/riskToleranceDescriptions`).then(function (privilegeDto) {
    //   $scope.canViewDetail = privilegeDto?.readIsGranted ?? false;
    // });
    $http.get('/Portfolio/InvestmentObjectives', { trackerMsg: 'Loading Risk Tolerances' })
    .then(function (response) {
      if (response.data && response.data.length > 0) {
        $scope.getDisplayValues(response.data);
        $scope.riskTolerances = response.data;
      } else {
        initDefaultTolerances();
      }
    });
  }

  function getReturnObjectives() {
    $http.get('/Portfolio/ReturnObjectives', { trackerMsg: 'Loading Return Objectives' })
      .then(function (response) {
        if (response.data && response.data.length > 0) {
          $scope.formatROForDisplay(response.data);
          $scope.returnObjectives = response.data;
        } else {
          initDefaultReturnObjectives();
        }
      });
  }

  function getTimeHorizons() {
    $http.get('/Portfolio/TimeHorizons', { trackerMsg: 'Loading Return Objectives' })
      .then(function (response) {
        if (response.data && response.data.length > 0) {
          $scope.formatTHForDisplay(response.data);
          $scope.timeHorizons = response.data;
        } else {
          initDefaultTimeHorizons();
        }
      });
  }

  function initDefaultTolerances() {
    $scope.riskTolerances = [{
      id: 0,
      description: 'Conservative Income',
      lowerTolerance: 0,
      riskRangeLow: 0,
      riskRangeHigh: 20,
      upperTolerance: 20,
      lowDisplay: '0',
      highDisplay: '20',
      detail: $scope.canViewDetail ? 'Investors in the Conservative Income risk range prioritize capital preservation and consistent income generation above all else. Typically opting for investments like government or high-quality corporate bonds, money market funds, and dividend-paying blue-chip stocks, these investors aim for low volatility and reduced exposure to market fluctuations. This group is generally more sensitive to risks and less tolerant of losses, seeking the most predictable and stable returns available.' : ''
    }, {
      id: 0,
      description: 'Income and Growth',
      lowerTolerance: 21,
      riskRangeLow: 21,
      riskRangeHigh: 40,
      upperTolerance: 20,
      lowDisplay: '21',
      highDisplay: '40',
      detail: $scope.canViewDetail ? 'This investor profile aims for a balanced portfolio that combines a steady income stream with modest capital appreciation. Fixed-income assets, like bonds or dividend-paying stocks, still make up a significant part of the portfolio, but there\'s also room for growth-oriented investments like index funds or large-cap stocks. With a moderate risk tolerance, these investors want to grow their capital but are not willing to make large gambles to achieve high returns.' : ''
    }, {
      id: 0,
      description: 'Growth and Income',
      lowerTolerance: 21,
      riskRangeLow: 41,
      riskRangeHigh: 60,
      upperTolerance: 20,
      lowDisplay: '41',
      highDisplay: '60',
      detail: $scope.canViewDetail ? ' Investors in the Growth & Income category are looking for a balanced but more growth-oriented approach to investing. While they still value the steady income generated from dividend-paying stocks or bonds, a greater emphasis is placed on assets with higher growth potential, such as mid-cap stocks or specialized mutual funds. These investors are generally more comfortable with market fluctuations and are willing to take on moderate levels of risk for higher returns, often with a longer investment horizon in mind.' : ''
    }, {
      id: 0,
      description: 'Growth',
      lowerTolerance: 21,
      riskRangeLow: 61,
      riskRangeHigh: 80,
      upperTolerance: 20,
      lowDisplay: '61',
      highDisplay: '80',
      detail: $scope.canViewDetail ? 'Those who fall under the Growth investor risk range are focused primarily on capital appreciation, willing to take on higher levels of risk for potentially higher rewards. Their portfolios typically consist of a larger proportion of equities, especially in sectors or industries with higher growth prospects like technology or healthcare. These investors may also explore international markets and alternative investment strategies. With a higher tolerance for volatility, they aim for significant long-term gains, even if it means enduring short-term market fluctuations.' : ''
    }, {
      id: 0,
      description: 'Aggressive',
      lowerTolerance: 21,
      riskRangeLow: 81,
      riskRangeHigh: 100,
      upperTolerance: 0,
      lowDisplay: '81',
      highDisplay: '100+',
      detail: $scope.canViewDetail ? 'Investors in the Aggressive Growth category are willing to take on substantial risk in the pursuit of exceptional returns. Often with a longer investment horizon, these investors focus on high-risk, high-reward assets like small-cap stocks, venture capital, cryptocurrencies, or leveraged ETFs. These portfolios are highly susceptible to market volatility, and investors should be prepared for the possibility of significant losses. However, the potential for outsized gains is the primary motivator for those who opt for this high-risk investment strategy.' : ''
    }];
  }

  function initDefaultReturnObjectives() {
    $scope.returnObjectives = [
      {
        id: 0,
        low: 1,
        high: 3,
        description: `1-3%`,
      },
      {
        id: 1,
        low: 3,
        high: 5,
        description: `4-6%`,
      },
      {
        id: 2,
        low: 5,
        high: 7,
        description: `7-9%`,
      },
      {
        id: 3,
        low: 7,
        high: 10,
        description: `10-14%`,
      },
      {
        id: 4,
        low: 15,
        high: null,
        description: '15% or Greater'
      },
    ]
  }

  function initDefaultTimeHorizons() {
    $scope.timeHorizons = [
      {
        id: 0,
        low: 1,
        high: 4,
        description: `1-4`,
      },
      {
        id: 1,
        low: 5,
        high: 9,
        description: `5-9`,
      },
      {
        id: 2,
        low: 10,
        high: 19,
        description: `10-19`,
      },
      {
        id: 3,
        low: 20,
        high: null,
        description: `20 or Greater`,
      }
    ]
  }

  init();
});

app.controller('RiskToleranceDescriptionController', function RiskToleranceDescriptionController ($scope, $http, $oasRights, $timeout, dialog) {
  function init() {
    $scope.descriptionValue = dialog.options.riskTolerance?.detail;
    $scope.toleranceName = dialog.options.riskTolerance?.description;
  }

  $scope.close = function(isSave) {
    if(isSave) {
      dialog.close($scope.descriptionValue);
    } else {
      dialog.close(null);
    }
  }

  init();
})

'use strict';

app.controller('BatchProcessingListCtrl', function BatchProcessingListCtrl($scope, $http, $oasRights, $dialog, $rootScope) {

    $scope.current = {
        selectedBatchProcesses: [],
        syncStarted: false,
        dateSearch: null,
        startDateSearch: new Date(),
        endDateSearch: new Date()
    };

    $scope.batchProcessList = [];
    $scope.alClientId = $rootScope.user.authorization.alClientId;
    $scope.reverse = true;
    $scope.columnName = 'alClientName';

    function init() {
        getBatchProcessList(false);
    }

    function getBatchProcessList() {
        var getUrl = '/Utility/BatchProcessing?alClientID=' + $scope.alClientId;

        var newDate = new Date($scope.current.endDateSearch.getTime());
        newDate.setDate(newDate.getDate() + 1);
        newDate = new Date(newDate.getTime());

        getUrl += '&startDate=' + $scope.current.startDateSearch.toISOString().split('T')[0] + '&endDate=' + newDate.toISOString().split('T')[0];

        $http.get(getUrl, {trackerMsg: 'Loading Batch Processes'})
            .then(function (response) {
                response.data.forEach(function (batchProcess) {
                    batchProcess.selected = false;
                    batchProcess.percent = ((batchProcess.itemsCompleted / batchProcess.totalItems) * 100).toFixed(2);
                    if (batchProcess.percent === 'NaN') {
                        batchProcess.percent = 0.00;
                    }
                });
                $scope.batchProcessList = response.data;
            });
    }

    $scope.refreshList = function () {
        getBatchProcessList();
    };

    $scope.selectItem = function (row) {
        row.selected = !row.selected;
        $scope.current.selectedBatchProcesses = $scope.batchProcessList.findAll({selected: true});
    };

    $scope.sortBy = function (columnName) {
        $scope.reverse = ($scope.columnName === columnName) ? !$scope.reverse : false;
        $scope.columnName = columnName;
    };

    $scope.openErrorModal = function (batchId) {
        $dialog.dialog(
            {
                templateUrl: 'trading/batchProcessing/views/batch-processing-error-list.html',
                controller: 'BatchProcessingErrorListCtrl',
                resolve: {
                    args: function () {
                        return {batchId: batchId};
                    }
                },
                dialogClass: 'modal wide'
            })
            .open()
            .then(function () {
        });
    };

    init();
});
'use strict';

app.controller('BatchProcessingErrorListCtrl', function BatchProcessingErrorListCtrl($scope, $http, $oasRights, $dialog, args, dialog) {
    // PUBLIC VARIABLES
    $scope.batchProcessErrorList = [];
    $scope.isExporting = false;

    // PRIVATE METHODS
    function init() {
        $scope.batchId = args.batchId;
        var getUrl = '/Utility/BatchProcessing/' + $scope.batchId + '/Errors';

        $http.get(getUrl, {trackerMsg: 'Loading Batch Process Errors'})
            .then(function (response) {
                $scope.batchProcessErrorList = response.data;
            });
    }

    // PUBLIC METHODS
    $scope.exportToExcel = function () {
        var data = {
            columns: [
                {name: 'Batch Id', field: 'batchId'},
                {name: 'Error Id', field: 'id'},
                {name: 'Error', field: 'errorMessage'},
                {name: 'Details', field: 'details'},
                {name: 'Created By', field: 'createdBy'},
                {name: 'Created Date', field: 'createdDate'},
            ],
            data: $scope.batchProcessErrorList
        };

        $scope.isExporting = true;

        $http.post('/Utility/SlickGridExport/csv', data, {tracker: 'main', trackerMsg: 'Exporting grid'})
            .then(function (response) {
                $scope.isExporting = false;
                window.location.href = response.headers('location') + '?Authorization=' + sessionStorage.oas_token;
            });
    };

    $scope.close = function () {
        if (dialog) {
            dialog.close(null);
        } else {
            window.parent.postMessage('iframeclose');
        }
    };

    // INITIALIZE
    init();
});


'use strict';

app.controller('InstanceParametersListCtrl', function InstanceParametersListCtrl($scope, $http, $oasRights, $dialog, args, dialog) {
    // PUBLIC VARIABLES
    $scope.instanceParametersList = [];
    $scope.isExporting = false;

    // PRIVATE METHODS
    function init() {
        $scope.blobId = args.blobId;
        var getUrl = '/Trading/Instances/Blob/' + $scope.blobId;

        $http.get(getUrl, {trackerMsg: 'Loading Instance Parameters'})
            .then(function (response) {
                $scope.instanceParametersList = response.data;
            });
    }

    // PUBLIC METHODS
    $scope.exportToExcel = function () {
        var data = {
            columns: [
                {name: 'Parameter Name', field: 'parameterName'},
                {name: 'Parameter Value', field: 'parameterValue'},
                {name: 'Created Date', field: 'createdDate'},
                {name: 'User ID', field: 'userId'},
                {name: 'Description', field: 'description'},
            ],
            data: $scope.instanceParametersList
        };

        $scope.isExporting = true;

        $http.post('/Utility/SlickGridExport/csv', data, {tracker: 'main', trackerMsg: 'Exporting grid'})
            .then(function (response) {
                $scope.isExporting = false;
                window.location.href = response.headers('location') + '?Authorization=' + sessionStorage.oas_token;
            });
    };

    $scope.close = function () {
        if (dialog) {
            dialog.close(null);
        } else {
            window.parent.postMessage('iframeclose');
        }
    };

    // INITIALIZE
    init();
});


$(window).on("scroll", function () {
    if ($(this).scrollTop() > 480) {
        $('a[rel=to-top]').fadeIn('medium');
    } else {
        $('a[rel=to-top]').fadeOut('medium');
    }
});

$('#main').on("scroll", function () {
    if ($(this).scrollTop() > 480) {
        $('a[rel=to-top]').fadeIn('medium');
    } else {
        $('a[rel=to-top]').fadeOut('medium');
    }
});

$('a[rel=to-top]').on("click", function (e) {
    e.preventDefault();
    $('body,html,#main').animate({ scrollTop: 0 }, 'slow');
});


(function () {
        const options = {
            exporting: {enabled: false},
            lang: {thousandsSep: ','},
            credits: {enabled: false}
        };
        HighchartsStyled.setOptions(options);
        Highcharts.setOptions(options);}
)();

(function () {
    'use strict';

    angular
        .module('orionConnect')
        .controller('customImportsV2HistoryCtrl', ['$scope', 'civ2Service', '$oasRights', 'views', '$location', '$dialog', CTRL]);

    function CTRL($scope, civ2Service, $oasRights, views, $location, $dialog) {
        //Setup defaults
        $scope.views = views;
        $scope.selectedIds = [];
        $scope.rights={
            customImports2: $oasRights.forCode('CUSTOMIMPORTS2'),
            deleteCustomImports: $oasRights.forCode('DELETECUSTOMIMPORTS'),
            customImportsColumnConfiguration: $oasRights.forCode('CUSTOMIMPORTSCOLUMNCONFIGURATION')
        };
        $scope.current = {
            gridDoubleClick: getImportData,
            view: views[0],
            loadUrl: '/Utility/Import',
            data: [],
            startDate: Date.create('today').addMonths(-1).beginningOfDay(),
            endDate: Date.create('today')
        };

        $scope.controls = {
            title: "TEST",
            getImportData: getImportData,
            deleteImports: deleteImports,
            generateColumnStructure:generateColumnStructure,
        };

        //INIT
        (function () {
        })();

        $scope.refreshGrid = function () {
            $scope.$broadcast('event:ci2-action', {action: 'refresh-grid'});
        };

        //METHODS
        //route to  page for the currently selected import and state
        function getImportData(state, typeID, id) {
            state = (!state)? 'Validate' : state;
            typeID = (!typeID)?$scope.current.selectedRows[0].importTypeId : typeID;
            id = (!id)?$scope.current.selectedRows[0].importId : id;
            if(!$scope.rights.customImports2.canRead) return;
            $location.path('/customImports2/'+state+'/'+typeID+'/'+id);
        }

        //Select import type and reroute to edit import column structure
        function generateColumnStructure(){
            $dialog.dialog({
                templateUrl:'CustomImportsV2/views/modalGenerateColumnStructure.html',
                controller:['$scope','civ2Service','dialog',dialogCtrl],
            }).open();

            function dialogCtrl($scope, civ2Service, dialog){
                $scope.close = close;
                $scope.importTypes = [];
                civ2Service.getImportTypes().then(function(res){$scope.importTypes = res.data;});

                function close(typeId){
                    if(typeId){
                        $location.path('/customImports2StructureEdit/'+typeId);
                    }
                    dialog.close();
                }
            }
        }

        function deleteImports() {
            if ($scope.current.selectedRows && $scope.current.selectedRows.length > 0) {
                const ids = $scope.current.selectedRows.map(x => x.importId);
                civ2Service.deleteImports(ids).then(function(res) { $scope.refreshGrid(); });
            }
        }

        $scope.selectedRowsImported = function() {
            return $scope.current.selectedRows &&
                $scope.current.selectedRows.length > 0 &&
                ($scope.current.selectedRows.some(x => x.importCommonId != null) || $scope.current.selectedRows.some(x => x.imported));
        };

        $scope.refreshGrid = function () {
            $scope.$broadcast('event:ci2-action', { action: 'refresh-grid' });
        };

        //EVENT LISTENERS
        $scope.$on('event:ci2-select', function (e, data) {
            $scope.current.selectedRows = data;
            if (data && data.length > 0) {
                $scope.current.imported = data[0].imported;
                $scope.current.validated = data[0].validated;
                $scope.current.reversed = data[0].reversed;
            }
        });
    }
})();
'use strict';

app.controller('CustomImportsV2MultiDbHistoryCtrl', function CustomImportsV2MultiDbHistoryCtrl($scope, civ2Service, civ2MDBService, $oasRights, views, $location, $dialog, $http, $route) {
    //Setup defaults
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.rights = {
        customImports2: $oasRights.forCode('CUSTOMIMPORTS2'),
        deleteCustomImports: $oasRights.forCode('DELETECUSTOMIMPORTS'),
        customImportsColumnConfiguration: $oasRights.forCode('CUSTOMIMPORTSCOLUMNCONFIGURATION'),
        multiDbCustomImport: $oasRights.forCode("MULTIDBCUSTOMIMPORT")
    };
    $scope.current = {
        view: views[0],
        loadUrl: '/Utility/Import/Common/Detail',
        data: [],
        startDate: Date.create('today').addMonths(-1).beginningOfDay(),
        endDate: Date.create('today')
    };
    $scope.isMultiDb = false;
    $scope.controls = {
        viewSingleDbSummary: viewSingleDbSummary,
        viewMultiDbSummary: viewMultiDbSummary,
        deleteSelected: () => civ2MDBService.deleteSelected($scope.current.selectedRows, deleteCallback),
        excludeErrors: () => excludeErrorsModal(),
        deleteImportCommon: () => civ2MDBService.deleteImportCommon($scope.current.selectedRows[0].masterId, deleteImportCommonCallback),
        selectedAreDeleteable: () => civ2MDBService.selectedAreDeleteable($scope.current.selectedRows),
        selectedAreExcludable: () => civ2MDBService.selectedAreExcludable($scope.current.selectedRows),
        canDeleteEntireImportCommon: () => civ2MDBService.canDeleteEntireImportCommon($scope.current.selectedRows, $scope.current.data),
        canExcludeErrorsImportCommon: () => civ2MDBService.canExcludeErrorsImportCommon($scope.current.selectedRows, $scope.current.data),
        selectedName: () => civ2MDBService.selectedName($scope.current.selectedRows),
        excludeErrorsSelectedName: () => civ2MDBService.excludeErrorsSelectedName($scope.current.selectedRows),
        isImportExcludeErrorsEnabled: () => civ2MDBService.isImportExcludeErrorsEnabled()
    };

    function init() {
        setDefaultGrouping();
    }

    //METHODS
    function viewSingleDbSummary(state, typeID) {
        if (!$scope.rights.customImports2.canRead) {
            return;
        }

        let importCommontExt = $scope.current.selectedRows[0];
        civ2Service.viewSingleDbSummary(importCommontExt, importCommontExt.alClientId, state, typeID);
    }

    function viewMultiDbSummary(importCommonId) {
        importCommonId = (!importCommonId) ? $scope.current.selectedRows[0].masterId : importCommonId;
        $location.path(`/customImports2/history/multidb/${importCommonId}`);
    }

    function setDefaultGrouping() {
        $scope.views[0].groups.push({
            name: "(Master ID - Import Name)",
            getter: "masterId",
            formatter: '(function (g) {let groupedName = (g.rows) ? g.rows[0]?.groupedName : "";return `(Master ID - Import Name): ${groupedName} (${g.count} items)`;})',
            enabled: true,
            comparer: '(function (a, b) {var a1 = a.value;var b1 = b.value;return (a == b ? 0 : (a1 < b1 ? 1 : -1));})',
            collapsed: false,
        });
    }

    function deleteImportCommonCallback() {
        $dialog.actionComplete('Deleting Entire MDB Import. Please refresh the grid after a few moments.').open()
            .then(function (result) {
                const ext = $scope.current.selectedRows[0];
                const breadCrumbName = civ2MDBService.breadCrumbName(ext.masterId, ext.importName);
                $scope.deleteBreadcrumb(breadCrumbName);
                $scope.refreshGrid();
            });
    }

    function deleteCallback() {
        $dialog.actionComplete('Deleting Import. Please refresh the grid after a few moments.').open()
            .then(function () {
                var fullyDeletedCommonImports = civ2MDBService.fullySelectedCommonImportRecordsFromExts($scope.current.selectedRows, $scope.current.data);
                fullyDeletedCommonImports.forEach((id) => {
                    const ext = $scope.current.data.find(ext => ext.masterId == id);
                    $scope.deleteBreadcrumb(civ2MDBService.breadCrumbName(ext.masterId, ext.importName));
                });

                $scope.refreshGrid();
            });
    }

    function excludeErrorsModal() {
        $dialog.confirmAction("Do you want to exclude all errors in this import?")
            .open()
            .then(function (res) {
                if (res === 'yes') {
                    civ2MDBService
                        .excludeErrorsMultiDb($scope.current.selectedRows[0].masterId)
                        .then(excludeErrorsCallback)
                }
            });
    }


    function excludeErrorsCallback() {
        $dialog.actionComplete('Exluding Errors. Please refresh the grid after a few moments.').open()
            .then(function () {
               $scope.refreshGrid();
            });
    }

    $scope.refreshGrid = function () {
        $scope.$broadcast('event:ci2-multidb-action', { action: 'refresh-grid' });
    };


    //EVENT LISTENERS

    $scope.$on('slickgrid-data-loaded', function (event, data) {
        $scope.current.data = data;
    });

    $scope.$on('event:ci2-multidb-select', function (e, data) {
        $scope.current.selectedRows = data;
    });

    init();
});
(function () {
    'use strict';

    angular
        .module('orionConnect')
        .controller('customImportsV2OrionVisionHistoryCtrl', ['$scope', 'civ2Service', '$oasRights', 'views', '$location', '$dialog', '$routeParams', CTRL]);

        function CTRL($scope, civ2Service, $oasRights, views, $location, $dialog, $routeParams) {
            const baseUrl = '/Utility/Import?importSource=1';

            //Setup defaults
            $scope.views = views;
            $scope.selectedIds = [];
            $scope.rights={
                customImports2: $oasRights.forCode('CUSTOMIMPORTS2'),
                deleteCustomImports: $oasRights.forCode('DELETECUSTOMIMPORTS'),
                orionVision: $oasRights.forCode('ORIONVISION')
            };
            $scope.current = {
                gridDoubleClick: getImportData,
                view: views[0],
                data: [],
                filterImported: $routeParams.imported ?? "",
                startDate: Date.create('today').addMonths(-1).beginningOfDay(),
                endDate: Date.create('today'),
                loadUrl: baseUrl
            };

            $scope.controls = {
                title: "TEST",
                getImportData: getImportData,
                deleteImports: deleteImports
            };
           
            //METHODS
            //route to  page for the currently selected import and state
            function getImportData(state, typeID, id) {
                state = !state? 'Validate' : state;
                typeID = !typeID? $scope.current.selectedRows[0].importTypeId : typeID;
                id = !id? $scope.current.selectedRows[0].importId : id;
                if(!$scope.rights.customImports2.canRead || !$scope.rights.orionVision.canRead) return;
                $location.path('/customImports2/'+state+'/'+typeID+'/'+id + '/true');
            }

            function deleteImports() {
                if ($scope.current.selectedRows && $scope.current.selectedRows.length > 0) {
                    const ids = $scope.current.selectedRows.map(x => x.importId);
                    civ2Service.deleteImports(ids).then(function (res) { $scope.refreshGrid(); });
                }
            }

            $scope.selectedRowsImported = function () {
                return $scope.current.selectedRows &&
                    $scope.current.selectedRows.length > 0 &&
                    $scope.current.selectedRows.some(x => x.imported);
            };

            $scope.refreshGrid = function () {
                $scope.$broadcast('event:ci2-action', {action: 'refresh-grid'});
            };

            //EVENT LISTENERS
            $scope.$on('event:ci2-select', function (e, data) {
                $scope.current.selectedRows = data;
                if (data && data.length > 0) {
                    $scope.current.imported = data[0].imported;
                    $scope.current.validated = data[0].validated;
                    $scope.current.reversed = data[0].reversed;
                }
            });
        }
    })();
'use strict';

var customImportsV2TemplatesCtrl = app.controller('customImportsV2TemplatesCtrl', function ($scope, $dialog, $oasRights, $routeParams, userOptionService, civ2Service, splitIoService, importTypes, multiDbImportTypes) {
    const mdbFavoritesFieldName = 'MultiDb Favorite Templates';
    const favoritesFieldName = 'Favorites';

    $scope.importTypes = importTypes;
    $scope.multiDbImportTypes = multiDbImportTypes;
    $scope.postUrl = "/Utility/Import/CreateFromFile";
    $scope.favorites = [];
    $scope.mdbFavorites = [];
    $scope.favoriteImportTypes = [];
    $scope.hasFavorites = true; // Default to TRUE so the template doesnt render the No Favorites banner before favorites are loaded
    $scope.rightsMultiDbCustomImport = $oasRights.forCode("MULTIDBCUSTOMIMPORT");
    $scope.controls = {
        generateTemplate: generateTemplate,
        createNew: createNew,
        isFavorite:isFavorite,
        setFavorite:setFavorite,
        isFavoriteImportType:isFavoriteImportType
    };
    $scope.isMultiDb = false;

    if ($routeParams.createImport) {
        const importTypeId = parseInt($routeParams.createImport);
        if (importTypeId) {
            civ2Service.getImportType(importTypeId).then(function (res) {
                createNew(res.data.id, res.data.importTypeName, false);
            });
        }
    }

    (function () {
        getFavorites(favoritesFieldName)
            .then(function (res) {
                // Get the SingleDb Favorites list from the UserOptions
                $scope.favorites = res;

                $scope.singleDbTemplateTabTitle = getSingleDbTabTitle();

                if ($scope.rightsMultiDbCustomImport.canRead) {
                    getFavorites(mdbFavoritesFieldName).then(function (mdbRes) {
                        // Get the MultiDb Favorite Templates list from the UserOptions 
                        $scope.mdbFavorites = mdbRes;

                        buildFavoriteList();
                        tagFavoritedImportTypes();
                    })
                } else {
                    buildFavoriteList();
                    tagFavoritedImportTypes();
                }
            });
    })();

    function buildFavoriteList() {
        // Join both UserOptions into 1 giant favorites list
        $scope.favorites.forEach((favId) => {
            $scope.favoriteImportTypes.push(favId);
        });

        $scope.mdbFavorites.forEach((favId) => {
            $scope.favoriteImportTypes.push(favId);
        });

        $scope.hasFavorites = $scope.favoriteImportTypes.length > 0;
    }

    function tagFavoritedImportTypes() {
        // Tag ImportTypes to signify if its a SingleDb fav AND/OR MultiDb fav
        // The html will then know which actions to take when clicking an action on the favorites tab
        $scope.importTypes.forEach((importType) => {
            if ($scope.favorites.includes(importType.id.toString())) {
                importType.singleDbFav = true;
            } else {
                importType.singleDbFav = false;
            }
            if ($scope.mdbFavorites.includes(importType.id.toString())) {
                importType.multiDbFav = true;
            } else {
                importType.multiDbFav = false;
            }
        })
    }

    function setFavorite(item, isMultiDbItem) {
        item = typeof item === 'string'? item : item.toString();

        if (!!isMultiDbItem) {
            // Save off MultiDb Favorites and ensure our lists reflect the action
            if (isFavorite(item, isMultiDbItem)) {
                $scope.mdbFavorites.splice($scope.mdbFavorites.indexOf(item),1);
                $scope.favoriteImportTypes.splice($scope.favoriteImportTypes.indexOf(item),1);
            } else {
                $scope.mdbFavorites.push(item);
                $scope.favoriteImportTypes.push(item);
            }

            saveFavorites(mdbFavoritesFieldName, $scope.mdbFavorites).then((mdbRes) => {
                // Sync MultiDb favorites back to the API response and re-tag the ImportItems for the html
                $scope.mdbFavorites = (!mdbRes) ? [] : String(mdbRes).split(',');

                tagFavoritedImportTypes();
            });
        } else {
            // Save off SingleDb Favorites and ensure our lists reflect the action
            if (isFavorite(item, isMultiDbItem)) {
                $scope.favorites.splice($scope.favorites.indexOf(item),1);
                $scope.favoriteImportTypes.splice($scope.favoriteImportTypes.indexOf(item),1);
            } else {
                $scope.favorites.push(item);
                $scope.favoriteImportTypes.push(item);
            }

            saveFavorites(favoritesFieldName, $scope.favorites).then((res) => {
                // Sync SingleDb favorites back to the API response and re-tag the ImportItems for the html
                $scope.favorites = (!res) ? [] : String(res).split(',');

                tagFavoritedImportTypes();
            });;
        }

        $scope.hasFavorites = $scope.favoriteImportTypes.length > 0;
    }

    function isFavorite(item, isMultiDbItem) {
        // Need to tell the HTML if the ImportType item is a favorite
        if (!!isMultiDbItem) {
            // If the item is tagged as MultiDb and on the Favorites tab
            // If the user is on the MultiDb tab
            return $scope.mdbFavorites.includes(item.toString());
        } else {
            // If the item is tagged as SingleDb and on the Favorites tab
            // If the user is on the SingleDb tab
            return $scope.favorites.includes(item.toString());
        }
    }

    function isFavoriteImportType(item) {
        // This will check if the ImportType is a favorite item for the Favorites tab
        // to know which ImportTypes to actually show on the favorites list view
        return $scope.favoriteImportTypes.includes(item.toString());
    }

    function saveFavorites(fieldName, items) {
        return userOptionService.save(fieldName, items.join(','));
    }

    function getFavorites(fieldName) {
        return userOptionService.get(fieldName).then(function (res) {
            return (!res) ? [] : String(res).split(',');
        });
    }

    function createNew(id, importTypeName, isMultiDbItem, requiredFields) {
        $dialog.createCustomImport(id, importTypeName ? `Create New ${importTypeName} Import` : false, !!isMultiDbItem, requiredFields);
    }

    function generateTemplate(id, isMultiDbItem) {
        civ2Service.generateTemplate(id, !!isMultiDbItem);
    }

    function getSingleDbTabTitle() {
        return ($scope.rightsMultiDbCustomImport.canRead) ? "Single Database Templates" : "All Import Templates";
    }

    $scope.tabChanged = function(isMultiDb) {
        $scope.isMultiDb = isMultiDb;
    }

    $scope.buildImportTypeName = function(importTypeName, isMultiDbItem) {
        // Tag favorited items with "Multi Database" but do not tag the item label if viewing the MultiDb Tab
        return (isMultiDbItem && !$scope.isMultiDb) ? `Multi Database - ${importTypeName}` : importTypeName;
    }

});

customImportsV2TemplatesCtrl.loadMultiDbImportTypes = ["$oasRights", "civ2Service", function ($oasRights, civ2Service) {
    var hasMultiDbRights = $oasRights.forCode("MULTIDBCUSTOMIMPORT");
    
    if (hasMultiDbRights.canRead) {
        return civ2Service.getImportTypes(true).then(function(res) {
            return res.data;
        }); 
    }
    else {
        return [];
    }
}];
(function () {
        'use strict';
        angular
            .module('orionConnect')
            .controller('customImportsV2ViewCtrl', ['$scope', '$rootScope', '$routeParams', '$q', '$dialog', '$location', '$timeout', '$oasRights', '$http', 'civ2Service', 'importTypes', 'breadcrumbsService', 'splitIoService', CTRL]);

    function CTRL($scope, $rootScope, $routeParams, $q, $dialog, $location, $timeout, $oasRights, $http, civ2Service, importTypes, breadcrumbsService, splitIoService) {

            //Setup default
            $scope.pane = {};
            $scope.ready = false;
            $scope.state = importTypes.state;
            $scope.importID = $routeParams.id;
            $scope.isMultiDb = ($routeParams.multiDb) ? JSON.parse($routeParams.multiDb) : false;
            $scope.rights= {
                customImports2: $oasRights.forCode('CUSTOMIMPORTS2')
            };
            $scope.views = [{
                "name": "Standard View",
                "filterType": "All",
                "isPrivate": false,
                "slickGridColumnDefs": importTypes.structure,
                "filters": [],
                "groups": [],
                "sorts": [],
                "canEdit": true,
                "isUserDefault": false
            }];
            $scope.selectedIds = [];

            $scope.current = {
                tab:{ table:true, edit:false, messages:false, },
                state : importTypes.state,
                metaData: importTypes.importMetadata,
                importName: importTypes.importName,                                 
                selectedRows: {},
                view: $scope.views[0],
                grid: {
                    update(info) {
                        return $q.when(info);
                    },
                    load(){
                        return fixRowItems(importTypes.data)
                            .then(function (items) {
                                return items;
                            })
                    }
                },
                actionStatusList: [],
                params: "",
                statusNoteIds: [],
                batch:{},
                editable: $scope.views[0].slickGridColumnDefs.findAll(function (item) {
                    return item.element;
                })
            };
            $scope.gridData = {};
            $scope.controls = {
                editable : (!importTypes.importMetadata.imported),
                showMessage:($scope.current.metaData.validationMessage),
                save: save,
                apply:apply,
                reverse:reverse,
                refreshGrid: refreshGrid,
                getData : getData,

                resetData: resetData,
                hasIncludedErrors : hasIncludedErrors,
                excludeErrors: excludeErrors,
                addNewRow: addNewRow,
                applyEdits:applyEdits,
                exportToExcel:exportToExcel,
                deleteRows:deleteRows,
                gotoState:gotoState,
                closeMessage:closeMessage,
                excludeRow:excludeRow,
                editRow:editRow,
                filterActionStatus:filterActionStatus,
                // setFilter : setFilter,
                // syncFilter : syncFilter,
                importAlreadyRunning:importAlreadyRunning
            };
            $scope.temp = {};
            
            //INIT
            (function () {                
                document.querySelector('#main').scrollTop = 0

                $scope.ready = true;

                $timeout(function(){
                    var ci2Url = `#/customImports2/${$routeParams.state}/${$routeParams.typeId}/${$routeParams.id}${($scope.isMultiDb) ? '?multiDb=true' : ''}`;

                    breadcrumbsService.add(
                        `${importTypes.importName}`,
                        ci2Url,
                        $routeParams.orionVision
                            ? '#/customImports2/orionVisionHistory'
                            : '#/customImports2/history'
                    );
                }, 1000);
            })();

            function filterActionStatus(status) {
                $scope.views[0].filters.remove({id:'filterActioinStatus'});
                if(status === 'clear'){return;}
                if(status === 'IsDeleted'){
                    $scope.views[0].filters.push({
                        id:'filterActioinStatus',
                        include: true,
                        key: "IsDeleted",
                        name: "Manually Excluded is true",
                        value: "(function (a) { return angular.isString(a) ? a.toLowerCase() === 'true' : a === true; })"
                    });
                    return;
                }
                $scope.views[0].filters.push({
                    id:'filterActioinStatus',
                    include: true,
                    key: status.replace(/\s/g,''),
                    name: status + " ≠ {blank}",
                    value: "(function (a) { return (a ? a.toLowerCase() : '') !== ''; })"
                });
            }

            function editRow(){
                $scope.$parent.rightSidebar.isOpen = true;
                $scope.current.tab.edit = true;
                let elements = document.getElementById('massEditorGroup').querySelectorAll('input,select,textarea');
                setTimeout(function(){angular.element('#'+elements[0].id).trigger('focus');},100);
            }
            function excludeRow(bool){
                $scope.current.selectedRows.forEach(function(row){
                    row.IsDeleted = (bool === 'false');
                });
                upsertItems($scope.current.selectedRows);
            }
            function closeMessage(){
                $scope.controls.showMessage = false;
                refreshGrid();
            }
            //Apply mass edits selected for current row
            function applyEdits() {
                let changedRows = [];
                $scope.current.selectedRows.forEach(function (item) {
                    Object.keys($scope.temp).forEach(function(key){
                        let tempItem = $scope.current.view.slickGridColumnDefs.find({"id":key});
                        item[key] = $scope.temp[key];
                        let condition = {
                            'object'(){
                                if(tempItem.element.linkId) item[tempItem.element.link] = item[key][tempItem.element.linkId];
                                return item[key][tempItem.element.selectId];
                            },
                            'basicBoolean'(){return ($scope.temp[key] === "true");},
                            'basicDate'(){return $scope.temp[key].getFullYear() + '-' + ($scope.temp[key].getMonth() + 1) + '-' + $scope.temp[key].getDate();},
                            'basicNumber'(){return (tempItem.precision)? parseFloat(parseFloat($scope.temp[key]).toFixed(tempItem.precision)) : $scope.temp[key];},
                            'default'(){return item[key];}
                        };
                        item[key] = (typeof condition[tempItem.conditionType] === 'function')? condition[tempItem.conditionType]() : condition['default']();
                        (typeof item[key] === "object" && tempItem.element)? item[key] = condition['object']() : null;
                    });
                    changedRows.push(item);
                });
                upsertItems(changedRows);
                $scope.temp = {};
            }
            //make sure the id column works for slickgrid
            function fixRowItems(data) {
                if (data) {
                    data.forEach(function (i) {
                        i.id = i.pkRow;
                    });
                } else {
                    data = [];
                }
                return $q.when(data);
            }
            //Add new data to slick grid
            function addItems(items, isNew) {
                return $timeout(function () {
                    $scope.$broadcast('event:ci2e-action', {
                        action: 'add-items',
                        markAsNew: (isNew === true),
                        items: items
                    });
                }, 1);
            }
            //Add new empty row to slick grid
            function addNewRow() {

                $timeout(function () {
                    let temp = {};
                    importTypes.structure.forEach(function (col) {
                        switch (col.conditionType) {
                            case "basicBoolean":
                                temp[col.id] = false;
                                break;
                            case "basicText":
                                temp[col.id] = null;
                                break;
                            case "basicNumber":
                                temp[col.id] = null;
                                break;
                        }
                    });
                    getData();
                    $scope.gridData.then(function (res) {
                        temp.id = res.length + 1;
                        temp.pkRow = temp.id;
                        addItems([temp], true)
                            .then($timeout(function(){getData();},1000))
                        ;
                    });
                }, 1);
            }
            //Save changes to the import and validate
            function save() {
                getData();
                $scope.gridData.then(function (data) {
                    let saveObj = {
                        importId: importTypes.importId,
                        importTypeId: importTypes.importTypeId,
                        importMetadata: $scope.current.metaData,
                        WorkingData: data
                    };

                    civ2Service.validate(saveObj).then(function (res) {
                        updateMetaData(res.data.importMetadata);
                        fixRowItems(res.data.workingData)
                            .then(function (res) {
                                upsertItems(res);
                            })
                        ;

                    });
                });
            }
            
            //Apply the import. This is the final execution.
            function apply() {
                if (importAlreadyRunning()) return false;
                civ2Service.getImportType(importTypes.importTypeId)
                    .then(function(res){
                        let rptname = res?.data?.importTypeName;
                        let disclaimer="Are you sure you want to apply this Import?";
                        if(rptname == "Receivable-Payable Add")     //for  Receivable/Payables Import Add only
                        {
                            disclaimer="By proceeding with this import, I hereby acknowledge and agree that the billing data used in this import was calculated and created outside of the Orion system. By utilizing such import, I acknowledge and agree that I believe the data in this import to be a true and accurate representation of the fees charged to a client. I further acknowledge and agree that Orion is not responsible for any errors or values that are not correct in this import or due to this import. Because the values of the import do not match the values in the Orion system, Orion does not have the ability to troubleshoot or assist in the verification of any values and/or calculations associated with the import. I hereby acknowledge and agree that Orion is not responsible for the data provided via this import and that Orion will not be held liable for any direct or indirect damages arising from inaccurate information from this import. " +
                            "</br>" +
                            "</br>"+
                            "Are you sure you want to apply this Import?";
                        }
                        $dialog.confirmAction(disclaimer)
                            .open()
                            .then(function(res){
                                if(res === 'yes'){
                                    getData();
                                    $scope.gridData.then(function(data) {
                                        let saveObj = {
                                            importId: importTypes.importId,
                                            importTypeId: importTypes.importTypeId,
                                            importMetadata: importTypes.importMetadata,
                                            WorkingData: data
                                        };
                                        civ2Service.apply(saveObj).then(function(applyRes) {
                                            updateMetaData(applyRes.data.importMetadata);
                                        });
                                    });
                                }
                            });
                });
            }
            //Revert all data that was applied by the import. Only available after the import has been applied
            function reverse(){
                $dialog.confirmAction("Are you sure you want to undo this Import?")
                    .open()
                    .then(function(res){
                        if(res === 'yes'){
                            getData();
                            $scope.gridData.then(function (data) {
                                let saveObj = {
                                    importId: importTypes.importId,
                                    importTypeId: importTypes.importTypeId,
                                    importMetadata: importTypes.importMetadata,
                                    WorkingData: data
                                };
                                civ2Service.reverse(saveObj).then(function (res) {
                                    $location.path('/customImports2/Validate/'+res.data.importMetadata.importTypeReverseId+'/'+res.data.importMetadata.importReverseId);
                                });
                            });
                        }
                    })
            }
            //Retrieve all data currently displayed in the grid
            function getData() {
                $scope.$broadcast('event:ci2e-action', {action: 'get-items'});
            }
            //Reset data to what it was when the import was initially created
            function resetData() {//MIGHT NOT NEED THIS IN PRODUCTION....DELETE?
                $dialog.confirmAction("This action will revert all changes back to the original data set. " +
                    "If you started with a file, the data will be set back to what was originally in the file. " +
                    "If you started with a blank import, the import will be blank after completing this action. " +
                    "</br>" +
                    "</br>"+
                    "Are you sure you want to continue?"
                )
                    .open()
                    .then(function(res){
                        if(res === 'yes'){
                            civ2Service.reset({
                                "importId": importTypes.importId,
                                "importTypeId": importTypes.importTypeId,
                                "importMetaData": importTypes.importMetaData,
                                "workingData": []
                            }).then(function (res) {
                                return fixRowItems(res.data.workingData);
                            }).then(function (res) {
                                upsertItems(res);
                            });
                        }
                    });
            }

            

            //Exclude All Rows with an error message
            function excludeErrors() {
                $dialog.confirmAction("Do you want to exclude all rows with errors?")
                    .open()
                    .then(function (res) {
                        if (res === 'yes') {
                            getData();
                            $scope.gridData.then(function (data) {
                                let saveObj = {
                                    importId: importTypes.importId,
                                    importTypeId: importTypes.importTypeId,
                                    importMetadata: $scope.current.metaData,
                                    WorkingData: data
                                };

                                civ2Service.excludeErrors(saveObj)
                                    .then(function (res) {
                                        updateMetaData(res.data.importMetadata);
                                        return fixRowItems(res.data.workingData);
                                    }).then(function (res) {
                                        upsertItems(res);
                                    });
                            });
                        }
                    });
            }


            function hasIncludedErrors() {
                if($scope.current.metaData.validationMessage == 'Import Type is not currently available.'){
                    $scope.controls.editable =false;
                    return;
                }
                if($scope.current.metaData.rowCounts){
                    const metadata = $scope.current.metaData.rowCounts[0];
                    return metadata && metadata.WorkingRowCount > 0 && metadata.ErrorRowCount > 0;
                }
            }


            function updateMetaData(data){
                $scope.current.metaData.validationMessage = data.validationMessage;
                $scope.current.metaData.rowCounts[0].WorkingRowCount = data.rowCounts[0].WorkingRowCount;
                $scope.current.metaData.rowCounts[0].ErrorRowCount = data.rowCounts[0].ErrorRowCount;
                $scope.current.metaData.rowCounts[0].WarningRowCount = data.rowCounts[0].WarningRowCount;
                $scope.current.metaData.rowCounts[0].DeletedRowCount = data.rowCounts[0].DeletedRowCount;
            }
            //update supplied rows
            function upsertItems(items) {
                if (items) $scope.$broadcast('event:ci2e-action', {action: 'upsert-items', items: items});
            }
            //refresh grid view
            function refreshGrid() {
                $scope.$broadcast('event:ci2e-action', {action: 'refresh-grid'});
            }
            //export current grid rows to excell document
            function exportToExcel() {
                $scope.$broadcast('event:ci2e-action', {action: 'export-data'});
            }
            //remove rows (not really used, possibly remove for production)
            function deleteRows(){
                $scope.$broadcast('event:ci2e-action', {action: 'delete-items', items: $scope.selectedIds });
            }
            //Goto alternate state for this import
            function gotoState(state){
                let typeId = importTypes.importTypeId,
                    Id = importTypes.importId;
                $location.path('/customImports2/'+state+'/'+typeId+'/'+Id);
            }

            function importAlreadyRunning() {
                return $scope.current.metaData.validationMessage && $scope.current.metaData.validationMessage.includes("import is already running");
            }
            /*syncFilter and setFilter - these are for a wip functionality that has been removed from the build but may be used in the next build*/

            // function syncFilter(key){
            //     let val = false;
            //     $scope.current.view.filters.forEach(function(filter){
            //         if(filter.name === "Error Message contains "+key){
            //             val = filter.include;
            //         }
            //     });
            //     return val;
            //     // if($scope.current.view.filters.find({"name": "Error Message contains "+key})) {
            //     //     let filter = $scope.current.view.filters.find({"name": "Error Message contains " + key});
            //     //     // angular.element(e).checked = filter.include;
            //     //     return filter.include;
            //     // }
            //     // // angular.element(e).checked = false;
            //     // return false;
            // }
            //
            // function setFilter(key){
            //     key = key.trim();
            //     if($scope.current.view.filters.find({"name": "Error Message contains "+key})){
            //         let elem = $scope.current.view.filters.find({"name": "Error Message contains "+key});
            //         elem.include = !elem.include;
            //         return;
            //     }
            //     let newFilter = {
            //         "name": "Error Message contains {key}",
            //         "value": "(function (a) { return (a ? a.toLowerCase() : '').indexOf('{key}') !== -1; })",
            //         "key": "ErrorMessage",
            //         "include": true
            //     };
            //     newFilter.value = newFilter.value.replace('{key}',key.toLowerCase());
            //     newFilter.name = newFilter.name.replace('{key}', key);
            //     $scope.current.view.filters.push(newFilter);
            // }



            //EVENT LISTENERS
            // $scope.$on('slickgrid-data-loaded', function () {
            //     // console.log("slick grid loaded", arguments);
            // });
            // $scope.$on('event:ci2e-action', function () {
            //     console.log("ACTION EVENT - " + arguments[1].action, arguments);
            // });
            //do this when a row is selected
            $scope.$on('event:ci2e-select', function (e, data) {
                $scope.current.selectedRows = data;
                $scope.selectedIds = [];
                data.forEach(function(row){
                    $scope.selectedIds.push(row.id);
                });
            });
            //do this when get items is called
            $scope.$on('slickgrid-getitems', function (event, data) {
                $scope.gridData = $q.when(data);
            });
        }
    }

)();
// *20097Orion!
(function () {
    'use strict';
    angular
        .module('orionConnect')
        .controller('customImportsV2StructureEditCtrl', ['$scope', '$q', '$dialog', 'civ2Service', '$oasRights', 'oasProps', 'importType', 'splitIoService', CTRL]);

    function CTRL($scope, $q, $dialog, civ2Service, $oasRights, oasProps, importType, splitIoService) {
        if(importType.config.length<1 || !Object.keys(importType.config[0])){
            createBasicStructure();
        }
        //setup defaults
        $scope.title = importType.importTypeName;
        $scope.oasProps = oasProps;
        $scope.currentColumnIndex = null;
        $scope.currentColumn = null;
        $scope.structure = {
            types : Object.keys(importType.config[0]),
        };
        $scope.structure.selected  = $scope.structure.types[0];
        $scope.columns = importType.config[0][$scope.structure.selected];
        $scope.rights= {
            customImportsColumnConfiguration: $oasRights.forCode('CUSTOMIMPORTSCOLUMNCONFIGURATION')
        };
        //CONTROLS
        $scope.controls = {
            view:{
                customID:'no',
                linkField:'no'
            },
            customSelect:{
                addOption:addOption,
                deleteOption:deleteOption,
                optionHandler:optionHandler
            },
            addColumn: addColumn,
            printJSON: printJSON,
            loadColumn: loadColumn,
            updateColumn: updateColumn,
            dropColumn: dropColumn,
            clear: clear,
            fixNumber: fixNumber,
            includeInTemplateChange: includeInTemplateChange,
            saveToDatabase:saveToDatabase,
            fixColumnOrder:fixColumnOrder,
            addColumnSet:addColumnSet,
            removeColumnSet:removeColumnSet,
            changeColumnSet:changeColumnSet
        };
        $scope.isRequiredFieldDisabled = false;

        //testing

        //testing

        //INIT
        (function () {
            loadColumn('pkRow');
            $scope.customOption = null;
        })();

        //Update currently edited column
        function updateColumn() {
            if($scope.currentColumn && $scope.currentColumn.element){
                //Decide what kind of field is in the column, clean the data, and setup the appropriate options
                //These options are meant as convenience settings to reduce the amount of information that needs to
                // be in the column structure definition. When the column structure is loaded the options expand to
                // tell slickgrid what it needs to do.
                let elem = {
                    customSelect(){
                        let temp = {
                            type: $scope.currentColumn.element.type,
                            options: $scope.currentColumn.element.options
                        };
                        delete $scope.currentColumn.element;
                        $scope.currentColumn.element = temp;
                    },
                    oasSearch(){ elem['oasDropdown'](); },
                    oasDropdown(){

                        let temp = {
                            type: $scope.currentColumn.element.type,
                            oasType: $scope.currentColumn.element.oasType,
                        };

                        ($scope.controls.view.customID === 'yes')? temp['selectId'] = $scope.currentColumn.element.selectId :null;
                        if($scope.controls.view.linkField === 'yes'){
                            temp['link'] = $scope.currentColumn.element.link;
                            temp['linkId'] = $scope.currentColumn.element.linkId;

                            // AUTO LINKING
                            /* Auto Linking is a functionality requested by the DBA's. I went ahead and developed the
                            feature and tested it, though I'm not convinced that its something that is needed or that
                            it should even be used. I'll leave the funcitonality available but comment out the invoking
                            statements below.*/

                            // createLink();
                        }else{
                            // deleteLink();
                        }

                        delete $scope.currentColumn.element;
                        $scope.currentColumn.element = temp;
                    },
                    default(){
                        let temp = {
                            type:$scope.currentColumn.element.type
                        };
                        delete $scope.currentColumn.element;
                        $scope.currentColumn.element = temp;
                    }
                };
                //determine the type of option that needs to be setup and execute the appropriate function
                ($scope.currentColumn.element.type !== '' && typeof elem[$scope.currentColumn.element.type] === 'function')?elem[$scope.currentColumn.element.type]():elem['default']();
            }

            if ($scope.currentColumnIndex >= 0) {
                $scope.currentColumn.visible = ($scope.currentColumn.visible === "true");
                $scope.currentColumn.includeInTemplate = ($scope.currentColumn.includeInTemplate === "true");
                $scope.currentColumn.isRequired = ($scope.currentColumn.isRequired === "true");
                $scope.columns[$scope.currentColumnIndex] = angular.copy($scope.currentColumn);
            }
            //Make sure that, if a link is setup, the associated column is also linked
            function createLink(){
                let cur = $scope.currentColumn;
                let field = $scope.columns.find({'id':cur.element.link});

                field.element.oasType = cur.element.oasType;
                field.element.type = cur.element.type;
                field.element.selectId = cur.element.linkId;
                field.element.link = cur.id ;
                field.element.linkId = cur.element.selectId;
            }
            //If links were removed from the current column but other columns still link to this one, make sure
            // the links are undone.
            function deleteLink(){
                let field = $scope.columns.find({'element':{'link':$scope.currentColumn.id}});
                if(field){
                    delete field.element.link;
                    delete field.element.linkId;
                }
            }
            //Make sure the view is reloaded
            loadColumn($scope.currentColumn.id);
        }
        //Remove the current column
        function dropColumn() {
            if ($scope.columns.find({'id': $scope.currentColumn.id})) {
                $scope.columns.splice($scope.columns.findIndex({'id': $scope.currentColumn.id}),1);
            }
            clear();
        }
        //Add a new column to the current structure definition
        function addColumn() {
            $dialog.dialog({
                templateUrl: 'CustomImportsV2/views/modalStructureEditorCreateColumn.html',
                controller: ['$scope', 'dialog', 'oasProps', dialogCtrl],
            }).open()
                .then(function (res) {
                    $scope.currentColumn = res.currentColumn;
                    if ($scope.columns.find({'id': $scope.currentColumn.id})) {
                        alert('column ID already exists.');
                        return;
                    }
                    $scope.currentColumn.field = $scope.currentColumn.name.replace(/\s/g, '');
                    $scope.currentColumn.id = $scope.currentColumn.id.replace(/\s/g, '');
                    $scope.currentColumn.visible = $scope.currentColumn.visible === "true";
                    $scope.columns.push($scope.currentColumn);
                    clear();
                });

            function dialogCtrl($scope, dialog, oasProps) {
                $scope.controls = {
                    close: close,
                    includeInTemplateChange: includeInTemplateChange
                };
                $scope.currentColumn = {};
                $scope.oasProps = oasProps;
                $scope.isRequiredFieldDisabled = true;

                //INIT
                (function () {

                })();

                function close(save) {
                    if (save) {
                        dialog.close($scope);
                        return;
                    }
                    dialog.close();
                }

                function includeInTemplateChange(includeInTemplateValue) {
                    if (includeInTemplateValue) {
                        $scope.isRequiredFieldDisabled = false;
                    } else {
                        $scope.isRequiredFieldDisabled = true;
                        $scope.currentColumn.isRequired = "false";
                    }
                }
            }

        }
        //Load the specified column to be edited. if no column id is supplied select the first column in the definition
        function loadColumn(id) {
            $scope.currentColumnIndex = (id)?$scope.columns.findIndex({'id': id}):0;
            if($scope.currentColumnIndex > -1){
                $scope.currentColumn = angular.copy($scope.columns[$scope.currentColumnIndex]);
                $scope.currentColumn.visible = ($scope.currentColumn.visible) ? "true" : "false";
                $scope.currentColumn.includeInTemplate = ($scope.currentColumn.includeInTemplate) ? "true" : "false";
                let includeInTemplateValue = (typeof $scope.currentColumn.includeInTemplate === 'string')? ($scope.currentColumn.includeInTemplate === "true") : $scope.currentColumn.includeInTemplate;
                $scope.isRequiredFieldDisabled = (includeInTemplateValue) ? false : true;
                $scope.currentColumn.isRequired = ($scope.currentColumn.isRequired) ? "true" : "false";

                $scope.controls.view.customID = ($scope.currentColumn.element && $scope.currentColumn.element.selectId) ? "yes" : "no";
                $scope.controls.view.linkField = ($scope.currentColumn.element && $scope.currentColumn.element.link) ? "yes" : "no";
            }
        }
        //Triggers an addOption when the enter key is pressed
        function optionHandler(event, option){
            if(event.keyCode === 13){
                addOption(option);
            }
        }
        //Add option for custom element
        function addOption(item){
            if(item === null) return;
            if(!$scope.currentColumn.element.options){
                $scope.currentColumn.element.options = [item];
            } else {
                $scope.currentColumn.element.options.push(item);
            }
            $scope.customOption = null;
        }
        //Remove custom element
        function deleteOption(index){
            $scope.currentColumn.element.options.splice(index, 1);
        }
        //Remove ColumnSet
        function removeColumnSet(){
            $dialog.confirmAction("Are you sure you want to permanently delete this Column Set object? <br>This cannot be reversed.")
                .open()
                .then(function(res){
                    if(res === 'yes'){
                        delete importType.config[0][$scope.structure.selected];
                        $scope.structure.types.splice($scope.structure.types.indexOf($scope.structure.selected),1);
                        $scope.structure.selected = $scope.structure.types[0];
                        $scope.columns = importType.config[0][$scope.structure.selected];
                        loadColumn();
                    }
                });

        }
        //Add ColumnSet
        function addColumnSet(){
            $dialog.inputBox("Add new Column Set", "Column Set Name")
                .open()
                .then(function (res) {
                    if (res) {
                        importType.config[0][res] = [
                            {
                                "conditionType": null,
                                "id": "id",
                                "name": "id",
                                "importDataType": null,
                                "sortOrder": "0",
                                "visible": false,
                                "width": 40
                            }
                        ];
                        $scope.structure.types.push(res);
                        $scope.structure.selected  = res;
                        $scope.columns = importType.config[0][res];
                        loadColumn();
                    }
                });
        }
        //Clear changes and reload current column
        function clear() {
            if($scope.currentColumn){
                let id = $scope.currentColumn.id;
                $scope.currentColumn = null;
                $scope.currentColumnIndex = null;
                loadColumn(id);
            }
        }
        //Clean data to be a pure JSON object. This ensures that the JSON object does not
        // contain additional JavaScript data.
        function cleanData(){
            let retObj = {};
            Object.keys(importType.config[0]).forEach((key)=>{
                let tempArr = [];
                importType.config[0][key].forEach((col, index)=>{
                    tempArr[index] = {
                        "conditionType": col.conditionType,
                        "id": col.id,
                        "name": col.name,
                        "importDataType": (col.importDataType)?col.importDataType:null,
                        "sortOrder": col.sortOrder,
                        "visible": (typeof col.visible === 'string') ? (col.visible === "true") : col.visible,
                        "includeInTemplate": (typeof col.includeInTemplate === 'string')? (col.includeInTemplate === "true") : col.includeInTemplate,
                        "isRequired": (typeof col.isRequired === 'string')? (col.isRequired === "true") : col.isRequired,
                        "width": col.width
                    };

                    if(col.element){
                        if(col.element.properties) delete col.element.properties;
                        if(col.element.type === "" || col.element.type === null){delete col.element;}
                    }
                    if(col.element)tempArr[index].element = col.element;
                });
                retObj[key]= tempArr;
            });
            return retObj;
        }
        //Display current column definitions in JSON format and provide button to copy to clipboard
        function printJSON() {
            $dialog.dialog({
                templateUrl: 'CustomImportsV2/views/modalStructureEditorDisplayStructure.html',
                controller: ['$scope', 'dialog', 'json_data', CTRL],
                resolve: {
                    json_data: () => {return cleanData();}
                },
            }).open();
            function CTRL($scope, dialog, json_data) {
                $scope.json_data = json_data;
                $scope.controls = {
                    close: close,
                    copyToClipboard: copyToClipboard
                };
                function copyToClipboard() {
                    let copyData = document.createElement("textarea");
                    copyData.style.height = "0px";
                    copyData.style.left = "-100px";
                    copyData.style.opacity = "0";
                    copyData.style.position = "fixed";
                    copyData.style.top = "-100px";
                    copyData.style.width = "0px";
                    copyData.value = JSON.stringify(json_data);
                    document.body.appendChild(copyData);
                    copyData.select();
                    document.execCommand("copy");
                    copyData.parentNode.removeChild(copyData);
                }
                function close() {
                    dialog.close();
                }
            }
        }
        //Save any changes to the database
        function saveToDatabase(){
            $dialog.confirmAction("Are you sure you want to save all updates to the database?")
                .open()
                .then(function(res){
                    if(res === 'yes'){
                        updateColumn();
                        civ2Service.updateConfigJSON(importType.id,cleanData());
                    }
                });
        }
        //Make sure that numbers for sort order are always two digits. so '1' needs to be '01' \
        // This ensures proper ordering in the ui
        function fixNumber(){
            $scope.currentColumn.sortOrder = ('00' + $scope.currentColumn.sortOrder).substr(-2,2);
        }

        function includeInTemplateChange(includeInTemplateValue) {
            if (includeInTemplateValue) {
                $scope.isRequiredFieldDisabled = false;
            } else {
                $scope.isRequiredFieldDisabled = true;
                $scope.currentColumn.isRequired = "false";
            }
        }

        //Sort all columns by the 'sort order' and renumber
        function fixColumnOrder(){
            let temp = [];
            $scope.columns.sort(function(a,b){return a.sortOrder-b.sortOrder}).forEach(function(col, index){
                col.sortOrder = ('00' + (index+1)).substr(-2,2);
                temp.push(col);
            });
            $scope.columns = temp;
        }
        //Make sure we have the minimum structure for the editor to work
        function createBasicStructure(){
            return $dialog.confirmAction("Import type does not have a column structure or the column structure is in the wrong format. Do you want to create a new basic structure?")
                .open()
                .then(function(res){
                    if(res === 'yes'){
                        importType.config = [
                            {
                                "Validate":[
                                    {
                                        "conditionType": "basicNumber",
                                        "id": "pkRow",
                                        "name": "ID",
                                        "importDataType": null,
                                        "sortOrder": "01",
                                        "visible": true,
                                        "includeInTemplate": true,
                                        "isRequired": false,
                                        "width": 40
                                    }
                                ],
                                "PreImport":[
                                    {
                                        "conditionType": "basicNumber",
                                        "id": "pkRow",
                                        "name": "ID",
                                        "importDataType": null,
                                        "sortOrder": "01",
                                        "visible": true,
                                        "includeInTemplate": false,
                                        "isRequired": false,
                                        "width": 40
                                    }
                                ]
                            }
                        ];
                    }
                });
            // importType.config

        }
        //Load the selected column set
        function changeColumnSet(){
            $scope.columns = importType.config[0][$scope.structure.selected];
            loadColumn();
        }
    }
})();
'use strict';

app.controller('CustomImportsV2DbAccessMaintenanceCtrl', function ($scope, views, $oasRights, $http) {
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {
        view: views[0],
        loadUrl: '/Utility/Import/Common/UserDatabases',
    };

    $scope.exportToExcel = function() { 
        $scope.$broadcast('event:ci2-database-access', {action: 'export-data'}); 
    };
});
'use strict';

app.controller('CustomImportsV2MultiDbSummaryCtrl', function ($scope, views, $routeParams, $q, $oasRights, $http, $dialog, $location, civ2Service, civ2MDBService) {
    $scope.views = views;
    $scope.selectedIds = [];
    $scope.current = {
        view: views[0],
        data: [],
        loadUrl: `/Utility/Import/Common/Details/${$routeParams.importCommonId}`,
        mdbSummary: null,
        startDate: Date.create('today').addMonths(-1).beginningOfDay(),
        endDate: Date.create('today'),
    };
    $scope.rights = {
        customImports2: $oasRights.forCode('CUSTOMIMPORTS2'),
        multiDbCustomImport: $oasRights.forCode("MULTIDBCUSTOMIMPORT")
    };
    $scope.controls = {
        apply: apply,
        validate: validate,
        reset: reset,
        reverse: reverse,
        excludeErrorsEntireImportCommon: excludeErrorsEntireImportCommon,
        excludeErrorsSelected: excludeErrorsSelectedRows,
        viewSingleDbSummary: viewSingleDbSummary,
        deleteSelected: () => civ2MDBService.deleteSelected($scope.current.selectedRows, deleteSingleDBCallback),
        deleteImportCommon: () => civ2MDBService.deleteImportCommon($routeParams.importCommonId, deleteCallback),
        reverseSelected: () => civ2MDBService.reverseSelected($scope.current.selectedRows, reverseSingleDBCallback),
        selectedAreDeleteable: () => civ2MDBService.selectedAreDeleteable($scope.current.selectedRows),
        selectedAreReversable: () => civ2MDBService.selectedAreReversable($scope.current.selectedRows),
        selectedAreExcludable: () => civ2MDBService.selectedAreExcludable($scope.current.selectedRows),
        canDeleteEntireImportCommon: () => civ2MDBService.canDeleteEntireImportCommon($scope.current.data, $scope.current.data),
        canValidateImportCommon: () => civ2MDBService.canValidateImportCommon($scope.current.data, $scope.current.data),
        canApplyImportCommon: () => civ2MDBService.canApplyImportCommon($scope.current.data, $scope.current.data),
        canResetImportCommon: () => civ2MDBService.canResetImportCommon($scope.current.data, $scope.current.data),
        canReverseImportCommon: () => civ2MDBService.canReverseImportCommon($scope.current.data, $scope.current.data),
        canExcludeErrorsImportCommon: () => civ2MDBService.canExcludeErrorsImportCommon($scope.current.data, $scope.current.data),
        selectedName: () => civ2MDBService.selectedName($scope.current.selectedRows),
        reverseSelectedName: () => civ2MDBService.reverseSelectedName($scope.current.selectedRows),
        excludeErrorsSelectedName: () => civ2MDBService.excludeErrorsSelectedName($scope.current.selectedRows),
        isImportExcludeErrorsEnabled: () => civ2MDBService.isImportExcludeErrorsEnabled()
    }

    function init() {
        document.querySelector('#main').scrollTop = 0;
        
        return $q.all({
            mdbSummary: getMultiDbImportSummary(),
        }).then(function () {
            //Need to manually add the Nav Link
            $scope.addBreadcrumb(`${$scope.current.mdbSummary.importCommonId} - ${$scope.current.mdbSummary.importName}`, `#/customImports2/history/multidb/${$scope.current.mdbSummary.importCommonId}`);
        });
    }
    
    function viewSingleDbSummary(state, typeID) {
        if (!$scope.rights.customImports2.canRead) {
            return;
        }

        let importCommontExt = $scope.current.selectedRows[0];
        civ2Service.viewSingleDbSummary(importCommontExt, importCommontExt.alClientId, state, typeID);
    }

    function getMultiDbImportSummary() {
        return $http.get(`/Utility/Import/Common/Summary/${$routeParams.importCommonId}`, { ignoreExceptions: [404], trackerMsg: 'Loading Multi Database Import Summary' })
            .then(function (response) {
                $scope.current.mdbSummary = ((response && response.data) || {});
            })
            .catch (function (error) {
                if (error.status == 404) {
                    showInvalidRecordMessage("Multi DB Import does not exist or has been deleted.");
                }
            });
    }

    function validate() {
        $dialog.confirmAction("Are you sure you want to Validate this Import?")
            .open()
            .then(function(res) {
                if (res === 'yes') {
                    civ2MDBService.validateMultiDb($scope.current.mdbSummary.importCommonId).then(function () {
                        $dialog.actionComplete('Validating Import. Please refresh the grid after a few moments.').open()
                        .then(function () {
                            $scope.refreshGrid();
                        });
                    });
                }
            })
    }

    function apply() {
        $dialog.confirmAction("Are you sure you want to Apply this Import?")
            .open()
            .then(function(res){
                if(res === 'yes'){
                    civ2MDBService.applyMultiDb($scope.current.mdbSummary.importCommonId).then(function () {
                        $dialog.actionComplete('Applying Import. Please refresh the grid after a few moments.').open()
                        .then(function () {
                            $scope.refreshGrid();
                        });
                    });
                }
                
            })
    }

    function reset() {
        $dialog.confirmAction("This action will revert all changes back to the original data set. " +
                "If you started with a file, the data will be set back to what was originally in the file. " +
                "</br>" +
                "</br>"+
                "Are you sure you want to continue?"
            )
                .open()
                .then(function(res){
                    if(res === 'yes'){
                        civ2MDBService.resetMultiDb($scope.current.mdbSummary.importCommonId).then(function () {
                            $dialog.actionComplete('Resetting Import. Please refresh the grid after a few moments.').open()
                            .then(function () {
                                $scope.refreshGrid();
                            });
                        });
                    }
                })
    }

    function reverse() {
        $dialog.confirmAction("Are you sure you want to undo this import? " +
                "</br>" +
                "</br>" +
                "Confirming this action will undo every import in this Multi Database Import and everything that was applied will be reversed out. " 
            )
                .open()
                .then(function(res){
                    if(res === 'yes'){
                        civ2MDBService.reverseMultiDb($scope.current.mdbSummary.importCommonId).then(function () {
                            $dialog.actionComplete('Undoing Entire Import. Please refresh the grid after a few moments.').open()
                            .then(function () {
                                $scope.refreshGrid();
                            });
                        });
                    }
                })
    }

    function excludeErrorsEntireImportCommon() {
        $dialog.confirmAction("Do you want to exclude all errors in this import?")
            .open()
            .then(function (res) {
                if (res === 'yes') {
                    civ2MDBService.excludeErrorsMultiDb($scope.current.mdbSummary.importCommonId).then(function () {
                        $dialog.actionComplete('Excluding Errors in Entire Import. Please refresh the grid after a few moments.').open()
                            .then(function () {
                                $scope.refreshGrid();
                            });
                    });
                }
            })
    }

    function excludeErrorsSelectedRows() {
        $dialog.confirmAction("Do you want to exclude all errors for the selected imports?")
            .open()
            .then(function (res) {
                if (res === 'yes') {
                    civ2MDBService.excludeErrorsMultiDb($scope.current.mdbSummary.importCommonId, $scope.current.selectedRows).then(function () {
                        $dialog.actionComplete('Excluding Errors. Please refresh the grid after a few moments.').open()
                            .then(function () {
                                $scope.refreshGrid();
                            });
                    });
                }
            })
    }



    $scope.filterRecords = function(status){
        //Need to use name due to how custom views works
        $scope.views[0].filters.remove({id:'mdbFilterActionStatus'});
        if(status === 'clear'){return;}
        
        var sgKey = status.replace(/\s/g,'');
        if (status === 'Rows with Errors') {
            sgKey = 'rowsWithErrors';
        }
        
        $scope.views[0].filters.push({
            id:'mdbFilterActionStatus',
            include: true,
            key: sgKey,
            name: status + " > 0",
            value: "(function (a) { return a > 0; })"
        });
    };

    function deleteCallback() {
        $dialog.actionComplete('Deleting Import. You will be redirected to the Multi DB Import History page.').open()
            .then(function () {
                $scope.deleteBreadcrumb(breadcrumbName());
                navigateToMDBHistory();
            });
    }

    function deleteSingleDBCallback() {
        $dialog.actionComplete('Deleting Import. Please refresh the grid after a few moments.').open()
            .then(function () {
                $scope.refreshGrid();
            });
    }

    function reverseSingleDBCallback() {
        $dialog.actionComplete('Undoing Import. Please refresh the grid after a few moments.').open()
            .then(function () {
                $scope.refreshGrid();
            });
    }

    function showInvalidRecordMessage(message) {
        $dialog.messageBox("<i class='fa fa-exclamation-triangle fa-lg text-warning' aria-hidden='true'></i> Invalid Record", message)
            .open()
            .then(function () {
                if ($scope.current.mdbSummary) {
                    $scope.deleteBreadcrumb(breadcrumbName());
                }
                navigateToMDBHistory();
             });
    }

    function breadcrumbName() {
        return civ2MDBService.breadCrumbName($scope.current.mdbSummary.importCommonId, $scope.current.mdbSummary.importName);
    }

    function navigateToMDBHistory() {
        $location.path(`/customImports2/history/multidb`);
    }

    $scope.exportToExcel = function() { 
        $scope.$broadcast('event:ci2-multidb-import-summary', {action: 'export-data'}); 
    };

    $scope.refreshGrid = function () {
        $scope.$broadcast('event:ci2-multidb-import-summary', { action: 'refresh-grid' });
        getMultiDbImportSummary();
    };

    $scope.$on('event:ci2-multidb-summary-select', function (e, data) {
        $scope.current.selectedRows = data;
    });

    $scope.$on('slickgrid-data-loaded', function (event, data) {
        $scope.current.data = data;
    });

    init();
});
'use strict';
app
    .service('civ2Service', ['$http', '$compile', '$dialog', 'oasProps', 'tokenFactory', civ2Service])
    .filter('customSplitString', [customSplitString]);

function civ2Service($http, $compile, $dialog, oasProps, tokenFactory) {
    this.getImportData = getImportData;
    this.deleteImports = deleteImports;
    this.updateConfigJSON = updateConfigJSON;
    this.createImport = createImport;
    this.getImportTypes = getImportTypes;
    this.getAllImportTypes = getAllImportTypes;
    this.getImportType = getImportType;
    this.slickGridExport = slickGridExport;
    this.validate = validate;
    this.apply = apply;
    this.reverse = reverse;
    this.reset = reset;
    this.excludeErrors = excludeErrors;
    this.generateTemplate = generateTemplate;
    this.viewSingleDbSummary = viewSingleDbSummary;
    this.setPendingWorkingData = setPendingWorkingData;

    let _pendingWorkingData = null;

    function setPendingWorkingData(workingData) {
        _pendingWorkingData = workingData;
    }


    const SlickGridExportUrl = '/Utility/SlickGridExport/xlsx';

    //Supply oas properties
    let oasDropdownProps = oasProps.oasDropdownProps, oasSearchProps = oasProps.oasSearchProps;

    //Get all data for the selected import ID
    function getImportData(importId, importTypeId, state) {
        let data=[],
            structure=[],
            importName='',
            importMetadata=[]
        ;
        if(state === 'PostImport' || state === 'PreImport'){
            return $http.get('/utility/Import/'+state+'/'+importId)
                .then(function(res){
                    data = res.data.workingData;
                    importId = res.data.importId;
                    importTypeId = res.data.importTypeId;
                    importName = res.data.importName;
                    importMetadata = res.data.importMetadata;
                    return getImportType(importTypeId);
                })
                .then(function (res) {
                    importMetadata.canReverseImport = res.data.canReverseImport;
                    return cleanStructure(res.data.config[0][state]);
                });
        }else{
            let postData = {importId:importId, importTypeId:importTypeId};
            if (_pendingWorkingData) {
                postData.WorkingData = _pendingWorkingData;
                _pendingWorkingData = null;
            }
            return $http.post('/Utility/Import/'+state, postData, {trackerMsg:'Loading data'})
                .then(function(res){
                    data = res.data.workingData;
                    importId = res.data.importId;
                    importTypeId = res.data.importTypeId;
                    importName = res.data.importName;
                    importMetadata = res.data.importMetadata;
                    return getImportType(importTypeId);
                })
                .then(function (res) {
                    importMetadata.canReverseImport = res.data.canReverseImport;
                    return cleanStructure(res.data.config[0][state]);
                });
        }

        function cleanStructure(struct){
            structure = struct;
            structure.forEach(function(i){
                i.field = i.id;
                //Clean data in import definition so that slick grid knows what to do. If the import has been
                // validated and imported dont set up edit options, This prevents fields from being editable
                let condition = {
                    'checkBox'(){
                        // i.conditionType = 'basicBoolean';
                        i.formatter = "Slick.Formatters.Checkmark";
                        if(!importMetadata.imported) i.editor = "Slick.Editors.Checkbox";
                        // i.massEditor = "Slick.Editors.Checkbox";
                    },
                    'Integer'(){
                        if(!importMetadata.imported) i.editor = "Slick.Editors.Integer";
                    },
                    'float'() {
                        i.formatter = "Slick.Formatters.Float";
                        if(!importMetadata.imported) i.editor = "Slick.Editors.Float";

                        // PARSE THE FOLLOWING VALUES: NUMERIC(25, 7), DECIMAL(25, 7), FLOAT(8)
                        if (i.importDataType.indexOf('(') > 0) {
                            const regex = new RegExp(/(\d+)(?=\))/, 'g');
                            const matches = i.importDataType.match(regex);

                            if (matches && matches.length > 0) {
                                i.precision = parseInt(matches[matches.length - 1]);
                            }
                        }

                        i.precision = i.precision || 3;
                    },
                    'customSelect'(){
                        if(!importMetadata.imported) i.editor = "Slick.Editors.Select";
                        i.editorOptions = i.element.options.join(',');
                    },
                    'text'(){
                        i.conditionType = 'basicText';
                        if(!importMetadata.imported) i.editor = "Slick.Editors.Text";
                    },
                    'date'(){
                        if(!importMetadata.imported) i.editor = "Slick.Editors.Date";
                    },
                    'oasSearch'(){
                        i.element.properties = oasSearchProps[i.element.oasType];
                        if(!importMetadata.imported) i.editor = "Slick.Editors.oasSearch";
                    },
                    'oasDropdown'(){
                        i.element.properties = oasDropdownProps[i.element.oasType];
                        if(!importMetadata.imported) i.editor = "Slick.Editors.oasDropdown";
                    }
                };
                //If the column definition has an element decide what to do twith it
                if(i.element && i.element.type){
                    (typeof condition[i.element.type] === 'function')? condition[i.element.type](): '';
                }
            });
            return {importId, importTypeId, importName, importMetadata, data, structure, state};
        }
    }

    //Delete imports with the specified import IDs
    function deleteImports(importIds) {
        return $http.put('/Utility/Import/DeleteMany', importIds, { trackerMsg: "Deleting Imports" });
    }
    //Update column structure for given import type
    function updateConfigJSON(typeId,data){
        return $http.post('/Utility/ImportType/UpdateConfigJson/'+typeId, [data], {trackerMsg: 'Save column definition'});
    }
    //Create new import
    function createImport(data){
        return $http.post('/Utility/Import/Create', data, {trackerMsg:"Creating Import"});
    }
    //Get All import Types for the user 
    function getImportTypes(isMultiDB = false){
        return $http.get('/Utility/ImportType' + '?multiDB=' + isMultiDB,{trackerMsg:"Load Import Types"});
    }
    //Get all import types for the system
    function getAllImportTypes() {
        return $http.get('/Utility/ImportType/All', {trackerMsg:"Load Import Types"});
    }
    //Get single import type
    function getImportType(id, isMultiDB = false){
        return $http.get('/Utility/ImportType/' + id + '?multiDB=' + isMultiDB,{trackerMsg:"Load Import Type"});
    }
    //Export data to excel file
    function slickGridExport(data, downloadName) {
        const exportUrl = Object.appendToQueryString(SlickGridExportUrl, {downloadName: downloadName} );
        return $http.post(exportUrl, data, {trackerMsg: 'Exporting library'});
    }
    //Validate import
    function validate(data){
        cleanData(data);
        return $http.post('/Utility/Import/Validate', data, {trackerMsg: 'Validating Import', compression:'auto'});
    }
    
    //Apply Import
    function apply(data){
        cleanData(data);
        return $http.post('/Utility/Import/Apply', data, {trackerMsg: 'Apply Import', compression:'auto'});
    }

    //Reverse Import
    function reverse(data){
        return $http.post('/Utility/Import/Reverse', data, {trackerMsg: 'Undo Import'});
    }
    
    //Reset import
    function reset(data){
        return $http.post('/Utility/Import/Reset', data, {trackerMsg: 'Reset Data'});
    }

    //Exclude Errors on import
    function excludeErrors(data) {
        return $http.post('/Utility/Import/ExcludeErrors', data, { trackerMsg: 'Excluding Errors' });
    }


    //Generate Template
    function generateTemplate(id, isMultiDB = false) {
        let importTypeName = null;
       getImportType(id, isMultiDB)
           .then(function (res) {
               importTypeName = res.data.importTypeName;
                let columDef = res.data.config[0].Validate,
                    data = {
                        columns: [],
                        data: []
                    }
                    ;

                columDef.forEach(function (col) {
                    if (col.includeInTemplate) data.columns.push({name: col.name, field: col.id});
                });

               const mdbPrefix = isMultiDB ? "Multi_DB_" : "";
               const downloadName = (importTypeName ? mdbPrefix + importTypeName.replace(/\s/g, '') : '');
               return slickGridExport(data, downloadName);
            })
           .then(function (response) {
               window.location.href = Object.appendToQueryString(response.headers("location"), { Authorization: sessionStorage.oas_token });
            })
        ;
    }

    function viewSingleDbSummary(importCommonExt, alClientId, state, typeID) {
        tokenFactory.getDatabaseToken(alClientId)
            .then(function (token) {
                const url = getImportHistoryUrl(token, importCommonExt, state, typeID, importCommonExt.importId);
                window.open(url, '_blank');
            })
            .catch(handleError);
    }

    function getImportHistoryUrl(token, importCommonExt, state, typeID, id) {
        const location = window.location;
        const path = location.pathname.replace('index.html', '') + 'integration.html';
        const targetPath = encodeURIComponent(getImportHistoryTargetPath(importCommonExt, state, typeID, id));
        const query = `t=${token}&p=${targetPath}`;
        return `${location.protocol}//${location.host}${path}?${query}`;
    }

    function getImportHistoryTargetPath(importCommonExt, state, typeID, id) {
        state = (!state) ? 'Validate' : state;
        typeID = (!typeID) ? ((importCommonExt.isReversal) ? importCommonExt.importTypeReverseId : importCommonExt.importTypeId) : typeID;
        id = (!id) ? importCommonExt.importId : id;

        return `customImports2/${state}/${typeID}/${id}?multiDb=true`;
    }

    function handleError(response) {
        $dialog.actionFailed(response.data.userException.detail).open();
    }

    return this;
}

//Helper methods
function cleanData(data){
    data.WorkingData.forEach(function(row){
        Object.keys(row).forEach((function(key){
            if(row[key] === ''){row[key] = null;}
            if(typeof row[key] === 'number' && !Number.isInteger( row[key] ) ){
                row[key] = row[key].toString();
            }
        }));
    });
    return data;
}
//Custom filter used to figure out precision on number fields.
function customSplitString(){
    return function(input){
        if(input && typeof input === "string"){
            return input.split(';');
        }
        return input;
    };
}
'use strict';
app
    .service('civ2MDBService', ['$http', 'splitIoService', civ2MDBService]);

function civ2MDBService($http, splitIoService) {
    this.selectedAreDeleteable = selectedAreDeleteable;
    this.selectedAreReversable = selectedAreReversable;
    this.selectedAreExcludable = selectedAreExcludable;
    this.isSingleCommonImport = isSingleCommonImport;
    this.canDeleteEntireImportCommon = canDeleteEntireImportCommon;
    this.deleteSelected = deleteSelected;
    this.excludeSelected = excludeSelected;
    this.deleteImportCommon = deleteImportCommon;
    this.reverseSelected = reverseSelected;
    this.canValidateImportCommon = canValidateImportCommon;
    this.canApplyImportCommon = canApplyImportCommon;
    this.canResetImportCommon = canResetImportCommon;
    this.canReverseImportCommon = canReverseImportCommon;
    this.canExcludeErrorsImportCommon = canExcludeErrorsImportCommon;

    this.validateMultiDb = validateMultiDb;
    this.applyMultiDb = applyMultiDb;
    this.resetMultiDb = resetMultiDb;
    this.reverseMultiDb = reverseMultiDb;
    this.deleteMultiDb = deleteMultiDb;
    this.excludeErrorsMultiDb = excludeErrorsMultiDb;
    this.selectedName = selectedName;
    this.reverseSelectedName = reverseSelectedName;
    this.excludeErrorsSelectedName = excludeErrorsSelectedName;
    this.breadCrumbName = breadCrumbName;
    this.fullySelectedCommonImportRecordsFromExts = fullySelectedCommonImportRecordsFromExts;


    function init() {}

    // Helpers
    function selectedAreDeleteable(selectedRows) {
        if (!selectedRows || selectedRows.length == 0) { return false; }
        return isSingleCommonImport(selectedRows) && canDeleteRecords(selectedRows);
    }

    function selectedAreReversable(selectedRows) {
        if (!selectedRows || selectedRows.length == 0) { return false; }
        return isSingleCommonImport(selectedRows) && canReverseRecords(selectedRows);
    }

    function selectedAreExcludable(selectedRows) {
        if (!selectedRows || selectedRows.length == 0) { return false; }
        return isSingleCommonImport(selectedRows) && canExcludeErrors(selectedRows);
    }

    function isSingleCommonImport(selectedRows) {
        if (selectedRows) {
            var uniqueImportCommonIds = selectedRows.map(o => o.masterId).filter((item, idx, self) => { return self.indexOf(item) == idx; });
            return uniqueImportCommonIds.length == 1;
        }

        return false;
    }

    // Return an array of ImportCommon Ids that had all of their Ext records selected
    function fullySelectedCommonImportRecordsFromExts(selectedRows, slickGridData) {
        var importCommonRecords = [];

        var groupedExtRecords = groupBy(selectedRows, 'masterId');
        for (const [key, value] of Object.entries(groupedExtRecords)) {
            var importCommonId = key;
            var importCommonExtsByCommonId = slickGridData.findAll(ext => ext.masterId == importCommonId);
            if (value.length == importCommonExtsByCommonId.length) {
                importCommonRecords.push(key);
            }
        }
        return importCommonRecords;
    }

    function canDeleteEntireImportCommon(selectedRows, slickGridData) {
        if (isSingleCommonImport(selectedRows) && slickGridData.length > 0) {
            var importCommonId = selectedRows[0].masterId;
            var importCommonExts = slickGridData.findAll(ext => ext.masterId == importCommonId);
            return canDeleteRecords(importCommonExts);
        }

        return false;
    }
    function canDeleteRecords(importCommonExtsScope) {
        if (importCommonExtsScope && importCommonExtsScope.length > 0) {
            return importCommonExtsScope.every(o => o.canDelete);
        }

        return false;
    }

    function deleteSelected(selectedRows, deleteCallback) {
        var groupedExtRecords = groupBy(selectedRows, 'masterId');

        for (const [key, value] of Object.entries(groupedExtRecords)) {
            deleteMultiDb(key, value).then(deleteCallback);
        }
    }

    function excludeSelected(selectedRows, excludeErrorsCallback) {
        var groupedExtRecords = groupBy(selectedRows, 'masterId');

        for (const [key, value] of Object.entries(groupedExtRecords)) {
            excludeErrorsMultiDb(key, value).then(excludeErrorsCallback);
        }    
    }

    function deleteImportCommon(commonImportId, deleteCallback) {
        return deleteMultiDb(commonImportId).then(deleteCallback);
    }

    function reverseSelected(selectedRows, reverseCallback) {
        var groupedExtRecords = groupBy(selectedRows, 'masterId');

        for (const [key, value] of Object.entries(groupedExtRecords)) {
            reverseMultiDb(key, value).then(reverseCallback);
        }
    }

    function canValidateImportCommon(selectedRows, slickGridData) {
        if (isSingleCommonImport(selectedRows) && slickGridData.length > 0) {
            var importCommonId = selectedRows[0].masterId;
            var importCommonExts = slickGridData.findAll(ext => ext.masterId === importCommonId);
            return canValidateRecords(importCommonExts);
        }
        
        return false;
    }

    function canValidateRecords(importCommonExtsScope) {
        if (importCommonExtsScope && importCommonExtsScope.length > 0) {
            return importCommonExtsScope.some(o => o.canValidate);
        }

        return false;
    }

    function canApplyImportCommon(selectedRows, slickGridData) {
        if (isSingleCommonImport(selectedRows) && slickGridData.length > 0) {
            var importCommonId = selectedRows[0].masterId;
            var importCommonExts = slickGridData.findAll(ext => ext.masterId === importCommonId);
            return canApplyRecords(importCommonExts);
        }
        
        return false;
    }

    function canApplyRecords(importCommonExtsScope) {
        if (importCommonExtsScope && importCommonExtsScope.length > 0) {
            return importCommonExtsScope.some(o => o.canApply);
        }

        return false;
    }

    function canResetImportCommon(selectedRows, slickGridData) {
        if (isSingleCommonImport(selectedRows) && slickGridData.length > 0) {
            var importCommonId = selectedRows[0].masterId;
            var importCommonExts = slickGridData.findAll(ext => ext.masterId === importCommonId);
            return canResetRecords(importCommonExts);
        }
        
        return false;
    }

    function canResetRecords(importCommonExtsScope) {
        if (importCommonExtsScope && importCommonExtsScope.length > 0) {
            return importCommonExtsScope.some(o => o.canReset);
        }

        return false;
    }

    function canReverseImportCommon(selectedRows, slickGridData) {
        if (isSingleCommonImport(selectedRows) && slickGridData.length > 0) {
            var importCommonId = selectedRows[0].masterId;
            var importCommonExts = slickGridData.findAll(ext => ext.masterId === importCommonId);
            return canReverseRecords(importCommonExts);
        }
        
        return false;
    }

    function canReverseRecords(importCommonExtsScope) {
        if (importCommonExtsScope && importCommonExtsScope.length > 0) {
            return importCommonExtsScope.some(o => o.canReverse);
        }

        return false;
    }

    function canExcludeErrorsImportCommon(selectedRows, slickGridData) {
        if (isSingleCommonImport(selectedRows) && slickGridData.length > 0) {
            var importCommonId = selectedRows[0].masterId;
            var importCommonExts = slickGridData.findAll(ext => ext.masterId === importCommonId);
            return canExcludeErrors(importCommonExts);
        }

        return false;
    }


    function canExcludeErrors(importCommonExtsScope) {
        if (importCommonExtsScope && importCommonExtsScope.length > 0) {
            return importCommonExtsScope.some(o => o.canExcludeErrors);
        }

        return false;
    }

    function selectedName(selectedRows) {
        if (selectedRows.length == 1) {
            return `Delete Import for ${selectedRows[0].databaseName}`;
        }

        return "Delete Selected";
    }

    function reverseSelectedName(selectedRows) {
        if (selectedRows.length == 1) {
            return `Undo Import for ${selectedRows[0].databaseName}`;
        }

        return "Undo Selected";
    }

    function excludeErrorsSelectedName(selectedRows) {
        if (selectedRows.length == 1) {
            return `Exclude Errors for ${selectedRows[0].databaseName}`;
        }

        return "Exclude Errors";
    }

    function breadCrumbName(importCommonId, importName) {
        return `${importCommonId} - ${importName}`;
    }

    const groupBy = (input, key) => {
        return input.reduce((acc, currentValue) => {
            let groupKey = currentValue[key];
            if (!acc[groupKey]) {
                acc[groupKey] = [];
            }
            acc[groupKey].push(currentValue);
            return acc;
        }, {});
    };

    // API Calls
    function validateMultiDb(importCommonId, data) {
        return $http.put(`/Utility/Import/Common/${importCommonId}/Validate`, data, { trackerMsg: 'Validating Multi Database Import' });
    }

    function applyMultiDb(importCommonId, data) {
        return $http.put(`/Utility/Import/Common/${importCommonId}/Apply`, data, { trackerMsg: 'Applying Multi Database Import' });
    }

    function resetMultiDb(importCommonId, data) {
        return $http.put(`/Utility/Import/Common/${importCommonId}/Reset`, data, { trackerMsg: 'Resetting Multi Database Import' });
    }

    function reverseMultiDb(importCommonId, importCommonExts) {
        var selectedImportCommonExts = buildImportCommonSelectedParam(importCommonId, importCommonExts);
        return $http.put(`/Utility/Import/Common/${importCommonId}/Reverse`, selectedImportCommonExts, { trackerMsg: 'Undoing Multi Database Import' });
    }

    // Delete import / ext records
    function deleteMultiDb(importCommonId, importCommonExts) {
        var selectedImportCommonExts = buildImportCommonSelectedParam(importCommonId, importCommonExts);
        return $http.put(`/Utility/Import/Common/${importCommonId}/Delete`, selectedImportCommonExts, { trackerMsg: 'Deleting Multi Database Import' });
    }


    function excludeErrorsMultiDb(importCommonId, importCommonExts) {
        var selectedImportCommonExts = buildImportCommonSelectedParam(importCommonId, importCommonExts);
        return $http.put(`/Utility/Import/Common/${importCommonId}/ExcludeErrors`, selectedImportCommonExts, { trackerMsg: 'Excluding Errors Multi Database Import' });
    }

    function buildImportCommonSelectedParam(importCommonId, importCommonExts) {
        if (importCommonExts && importCommonExts.length > 0) {
            var selectedImportCommonExts = importCommonExts.map((importCommonExt) => {
                return {
                    ALClientId: importCommonExt.alClientId,
                    IsReversal: importCommonExt.isReversal,
                    ImportCommonId: importCommonId,
                };
            });

            return selectedImportCommonExts;
        }

        return [];
    }

    init();

    return this;
}
//Provide custom oasDropdown that mimics the one used throughout orion connect. this is needed to provide better control over the data returned from the directive
(function(){
    'use strict';
    app.directive('customImportsDropDown', ['$http', 'oasProps', directive]);
    function directive($http, oasProps){
        return {
            restrict: 'E',
            scope: {
                idField: '=',
                selected: '=',
                returnObj: '='
            },
            replace: true,
            template: template,
            link: link
        };
        function template(){
            return '<select ng-model="selected" ng-options="option as option[nameField] for option in options | orderBy:nameField"></select>';
        }
        function link(scope, element, attrs){
            const props = oasProps.oasDropdownProps[scope.idField];
            scope.options = [];
            scope.nameField = props.nameField || 'name';

            //INIT
            (function(){
                let trackerMsg = (props.trackerMsg)?props.trackerMsg:'';
                $http.get(props.url, trackerMsg)
                    .then(function(res){
                        scope.options = res.data;
                    })
                ;
            })();
        }
    }
})();
'use strict';
app.controller('GliaModalCtrl', function GliaModalCtrl($scope, $http, $dialog, dialog) {
    $scope.current = {
        siteId: "",
        hasOperator: true,
        hasEmail: false,
        gliaEmail: "",
        password: "",
        confirmPassword: "",
        loading: true
    };
    $scope.createOperator = createOperator;
    $scope.cancel = function () {
        if (dialog){
            dialog.close();
        }
        else{
            window.parent.postMessage("iframeclose");
        }
    };

    function getSiteId() {
        $http.get('/Integrations/SaleMove/Cobrowse/SiteId', { trackerMsg: 'Getting Site Id' })
            .then(function (response) {
                if (response && response.data) {
                    $scope.current.siteId = response.data;
                } else {
                    $dialog.actionFailed("Unable to get Site ID. Please contact support.").open();
                    $scope.current.loading = false;
                }
            });
    }

    function getOperatorId() {
        $http.get('/Integrations/SaleMove/Cobrowse/Operator', { trackerMsg: 'Getting Operator Id' })
            .then(function (response) {
                $scope.current.loading = false;
                if (response && response.data && response.data.gliaOperatorDto && response.data.operatorIntegrationConfig) {
                    if (response.data.gliaOperatorDto.email == null
                        && response.data.gliaOperatorDto.success == false
                        && response.data.operatorIntegrationConfig.operatorId != null) {
                        $scope.current.hasOperator = true;
                        console.log('We have a Glia Operator ID saved for this user but our API Key does not have access to this users info. ')
                    }
                    else {
                        $scope.current.gliaEmail = response.data.gliaOperatorDto.email;
                        $scope.current.hasEmail = true;
                    }
                } else {
                    $scope.current.hasOperator = false;
                }
            });
    }
    function createOperator() {
        if (validatePasswords()) {
            $http.post('/Integrations/SaleMove/Cobrowse/Operator', { password: $scope.current.password }, { trackerMsg: 'Creating Operator Id' })
                .then(function (response) {
                    if (response && response.data && response.data.gliaOperatorDto && response.data.gliaOperatorDto.email) {
                        $scope.current.gliaEmail = response.data.gliaOperatorDto.email;
                        $scope.current.hasEmail = true;
                        $scope.current.hasOperator = true;
                    } else {
                        console.log(response);
                        $dialog.actionFailed("Failed to create an operator. Please contact Support.").open();

                    }
                });
        }
    };
    function validatePasswords() {
        if (!$scope.current.password.match(/^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/)) {
            $dialog.actionFailed("Password must be 8 characters long have one special one upper and one lower.")
                .open();
            return false;
        }
        if ($scope.current.password != $scope.current.confirmPassword) {
            $dialog.actionFailed("Password do not match").open();
            return false;
        }
        return true;
    }
    function init() {
        getSiteId();
        getOperatorId();       
    }

    if (!dialog){
        window.parent.postMessage("iframeload");
    }
    init();
});

'use strict';
app.service('gliaService', function ($http, $q, splitIoService) {

    var myService = this;
    let gliaGuidData;

    /** Split.io treatment `on` enables HTML from message.metadata.html; otherwise plain text (OC-31371). */
    const GLIA_SERVICE_BOT_RICHTEXT_SPLIT = 'oc_integrations_glia_servicebot_richtext_oc31371';

    const chatRoutes = {
        chatRouteBilling: "SME_Billing_Premier",
        chatRouteReconciliation: "SME_Data_Recon_Premier",
        chatRouteReporting: "SME_Reporting_Premier"
    }
    const gliaDomain = 'OrionSupport';
    const gliaProduct = 'OrionConnect';

    /** OC-31371 — allowlist for Service Bot metadata.html */
    const GLIA_SERVICE_BOT_HTML_TAGS = {
        p: true, br: true, strong: true, b: true, em: true, i: true,
        ul: true, ol: true, li: true, a: true, span: true, div: true,
        h1: true, h2: true, h3: true, h4: true, h5: true, h6: true
    };
    const GLIA_STRIP_NODE_AND_CHILDREN = {
        script: true, style: true, iframe: true, object: true, embed: true,
        form: true, input: true, button: true, textarea: true, select: true,
        meta: true, link: true, base: true, img: true, video: true, audio: true,
        source: true, svg: true, math: true, template: true
    };

    function stripGliaChatAttributes(el, tag) {
        var attrs = Array.prototype.slice.call(el.attributes);
        for (var i = attrs.length - 1; i >= 0; i--) {
            var attr = attrs[i];
            var name = attr.name.toLowerCase();
            if (name.indexOf('on') === 0) {
                el.removeAttribute(attr.name);
                continue;
            }
            if (tag === 'a' && name === 'href') {
                var v = (attr.value || '').trim();
                if (/^https?:\/\//i.test(v)) {
                    el.setAttribute('rel', 'noopener noreferrer');
                    el.setAttribute('target', '_blank');
                } else if (!/^mailto:/i.test(v)) {
                    el.removeAttribute('href');
                }
                continue;
            }
            el.removeAttribute(attr.name);
        }
    }

    function sanitizeGliaServiceBotHtml(html) {
        if (!html || typeof html !== 'string') {
            return '';
        }
        var trimmed = html.trim();
        if (!trimmed) {
            return '';
        }
        var doc;
        try {
            doc = new DOMParser().parseFromString(trimmed, 'text/html');
        } catch (e) {
            return '';
        }
        if (!doc || !doc.body) {
            return '';
        }
        sanitizeGliaHtmlElement(doc.body);
        return doc.body.innerHTML;
    }

    function sanitizeGliaHtmlElement(el) {
        var child = el.firstChild;
        while (child) {
            var next = child.nextSibling;
            if (child.nodeType === Node.ELEMENT_NODE) {
                var tag = child.tagName.toLowerCase();
                if (GLIA_STRIP_NODE_AND_CHILDREN[tag]) {
                    el.removeChild(child);
                } else if (!GLIA_SERVICE_BOT_HTML_TAGS[tag]) {
                    while (child.firstChild) {
                        el.insertBefore(child.firstChild, child);
                    }
                    el.removeChild(child);
                } else {
                    stripGliaChatAttributes(child, tag);
                    sanitizeGliaHtmlElement(child);
                }
            }
            child = next;
        }
    }

    /**
     * Glia: visitorApp.setChatMessageRenderer must return HTMLElement or false (false = default rendering).
     * OC-31371: render message.metadata.html when GLIA_SERVICE_BOT_RICHTEXT_SPLIT treatment is on; skip registration if off or Split errors.
     */
    function registerServiceBotChatMessageRenderer(salemove, richTextEnabled) {
        if (!richTextEnabled) {
            return;
        }
        function render(message) {
            var meta = message && message.metadata;
            if (!meta || typeof meta.html !== 'string' || !meta.html.trim()) {
                return false;
            }
            var safe = sanitizeGliaServiceBotHtml(meta.html);
            if (!safe) {
                return false;
            }
            var wrap = document.createElement('div');
            wrap.className = 'glia-servicebot-html';
            wrap.innerHTML = safe;
            return wrap;
        }
        if (salemove.visitorApp && typeof salemove.visitorApp.setChatMessageRenderer === 'function') {
            salemove.visitorApp.setChatMessageRenderer(render);
        }
    }

    function registerServiceBotRendererFromSplit(salemove) {
        function applyRichTextFlag(enabled) {
            registerServiceBotChatMessageRenderer(salemove, !!enabled);
        }
        splitIoService.getBoolTreatment(GLIA_SERVICE_BOT_RICHTEXT_SPLIT).subscribe(
            applyRichTextFlag,
            function () { applyRichTextFlag(false); }
        );
    }

    function setupGliaGuidData() {
        if (window.location.host.has('local') || window.location.host.has('test') || window.location.host.has('staging')) {
            gliaGuidData = {
                premierGuidBilling: "28116f91-a0cc-4f72-8352-6c20caa132fd",
                premierGuidReconciliation: "c23878c3-8bd9-42ab-a23c-d7415c196ae6",
                premierGuidReporting: "e26152ed-a9d8-41c0-a9c6-bc4ad7496f58",
                premierGuidTrading: "eea7adb4-8661-42c1-8fd3-f0e8e65efb5a",
                defaultGuidTrading: "4f2ec5c4-76d2-47d9-b264-b30bac04e8c1",
                lexQueueId: "07261a0e-d189-4fbe-866c-78e74489c2f0"
            }
        } else {
            gliaGuidData = {
                premierGuidBilling: "5e65b7d4-02cd-4ff1-a3e8-9ef5a40f855e",
                premierGuidReconciliation: "c2827f9b-2b7b-492a-b669-55b1c96ab14a",
                premierGuidReporting: "cb749ab7-605a-4e05-b713-f204679fa56b",
                premierGuidTrading: "7ea71acf-4f59-4f27-b77f-8cf90808ba78",
                defaultGuidTrading: "b61a4048-bc5d-4f06-8079-78180216c415",
                lexQueueId: "5947ef9f-dffe-4c1b-83d1-e940c170d0c8"
            }
        }
    }

    /**
     * Returns true if the chatTeam is the LEX Customer Support queue (used for bypassing media selection).
     * @param {Object} chatTeam - Chat team with chatUrl or queue.id
     * @returns {boolean}
     */
    this.isLexChatTeam = function (chatTeam) {
        if (!chatTeam) return false;
        setupGliaGuidData();
        var queueId = (chatTeam.queue && chatTeam.queue.id) || chatTeam.chatUrl;
        return queueId === gliaGuidData.lexQueueId;
    };

    /**
     * Returns true if the chatTeam is Advantage (must continue using media selection flow).
     * @param {Object} chatTeam - Chat team with team name
     * @returns {boolean}
     */
    this.isAdvantageChatTeam = function (chatTeam) {
        return chatTeam && (chatTeam.team || '').indexOf('Advantage Advocate') === 0;
    };

    function getGliaDocumentUrl(responseData, userGuid, siteId) {
        if (siteId == null) {
            let documentUrl = "https://api.glia.com/salemove_integration.js" + '?site_id=' + responseData + '&external_id=' + userGuid;
            return documentUrl;
        }
        else {
            let documentUrl = "https://api.glia.com/salemove_integration.js" + '?site_id=' + siteId;
            return documentUrl;
        }
    }

    this.loadGliaForReps = function loadGlia(userAuthData, stop) {
        if (userAuthData && userAuthData.userGuid && userAuthData.email) {
            $http.get('/Integrations/SaleMove/Cobrowse/SiteId', { ignoreExceptions: true, allowCancellation: false  })
                .then(function (response) {
                    if (response && response.data) {
                        /* Hack
                         * Glia was adding passive events to the document before some of our code was able to add non-passive events. This caused Zone.js to break when executing the non-passive events.
                         * If we add a stub function before Glia can add any events there is no issue. 
                         * https://dev.azure.com/orionadvisor/OAT/_workitems/edit/25098
                         */
                        document.addEventListener("mousemove", function () { });
                        var saleMove = loadSaleMoveSDK(response.data, userAuthData.userGuid)
                        runSaleMoveForReps(saleMove, stop, userAuthData, response);
                    }
                    else {
                        console.error('Invalid or no Glia site Id. Glia will not load.');
                    }
                });
        } else {
            console.error('Invalid userAuthData. Glia will not load.');
        }
    };

    this.loadGliaForNonReps = function ($scope) {
        $q.all({
            serviceTeam: $http.get('/Authorization/User/ServiceTeam', { allowCancellation: false  }),
            applicationTeams: $http.get('/Global/ServiceTeams?teamType=ApplicationTeam', { allowCancellation: false  }),
            altApplicationTeams: $http.get('/Global/ServiceTeams?teamType=AlternateApplicationTeam', { allowCancellation: false  }),
            siteId: $http.get('/Integrations/SaleMove/Cobrowse/SiteId', { allowCancellation: false  }),
            premier: $http.get('/Integrations/SaleMove/Premier', { allowCancellation: false  }),
            privilege: $http.get('/Integrations/SaleMove/PremierQueues', { allowCancellation: false  }),
            orionSiteId: $http.get('/Integrations/SaleMove/OrionSiteId', { allowCancellation: false  })
        }).then(function (responses) {
            /* Hack
               * Glia was adding passive events to the document before some of our code was able to add non-passive events. This caused Zone.js to break when executing the non-passive events.
               * If we add a stub function before Glia can add any events there is no issue. 
               * https://dev.azure.com/orionadvisor/OAT/_workitems/edit/25098
               */
            document.addEventListener("mousemove", function () { });
            const chatTeams = [];
            let siteId;
            if ($scope.user.gliaRepChatSupport) {
                siteId = responses.orionSiteId.data;
            } else {
                siteId = responses.siteId.data;
            }
            let isPremierWithPrivilege = (responses.premier.data.isPremier && responses.privilege.data);
            $scope.user.serviceTeam = responses.serviceTeam.data;
            $scope.user.serviceTeam.isPremierWithPrivilege = isPremierWithPrivilege;
            $scope.user.serviceTeam.isPremier = responses.premier.data.isPremier;
            var saleMove = loadSaleMoveSDK(responses, null, siteId);
            responses.applicationTeams.data.forEach(function (team) {
                if (team.chatUrl) {
                    const alternateTeam = responses.altApplicationTeams.data.find({ team: team.team });
                    if (alternateTeam && alternateTeam.chatUrl) {
                        angular.extend(team, alternateTeam);
                    }
                    chatTeams.push({ team: team.team, chatUrl: team.chatUrl, chatRouteIntendedRecipient: team.chatRouteIntendedRecipient });
                }
            });

            if ($scope.user.serviceTeam.team === 'Advantage Advocate w/SME') {
                $scope.user.serviceTeam.chatUrl = '7840e1a1-91db-44ac-aa2e-9cc512c59464'
            }

            if (chatTeams.length) {
                $scope.user.chatTeams = chatTeams.sortBy("team");
                runSalemoveForNonReps(saleMove, $scope);
            }
        });
    };

    function loadSaleMoveSDK(responseData, userGuid, siteId = null) {
        let documentUrl = getGliaDocumentUrl(responseData, userGuid, siteId);
        var saleMove = function (a) {
            !function (a, b, c, d) {
                var e = a.createElement(b), f = a.getElementsByTagName(b)[0];
                e.async = 1, e.src = c, e.type = "text/javascript", d && e.addEventListener("load", d), f.parentNode.insertBefore(e, f)
            }
                (document, "script", documentUrl, a)
        };
        return saleMove;
    }

    function runSaleMoveForReps(saleMove, stop, userAuthData, response) {
        saleMove(function () {
            sm.getApi({ version: 'v1' }).then(function (salemove) {
                registerServiceBotRendererFromSplit(salemove);
                salemove.updateInformation({
                    externalId: userAuthData.userGuid,
                    email: userAuthData.email,
                    siteId: response.data,
                    customAttributes: {
                        UserLevel: "non-client",
                        userType: `${userAuthData.originalEntity}`,
                        userId: `${myService.getGliaId(userAuthData)}`,
                        visibility: myService.getVisibility(userAuthData.originalEntity),
                        domain: gliaDomain,
                        product: gliaProduct
                    }
                }).then(function () {
                    if (sm && sm.siteId && sm.siteId != response.data) {
                        console.error('Invalid siteId removing sm object and trying again.');
                        sm = undefined;
                        if (!stop) {
                            loadGlia(userAuthData, true);
                        } else {
                            console.error('Unable to set correct siteId. Will not load Glia');
                        }
                    }
                });
            });
        });
    }

    function runSalemoveForNonReps(saleMove, $scope) {
        setupGliaGuidData();
        saleMove(function () {
            function onQueueState(queue) {
                $scope.safeApply(function () {
                    if (queue && $scope.user.serviceTeam.isPremierWithPrivilege) {
                        switch (queue.id) {
                            case gliaGuidData.premierGuidBilling:
                                gliaQueueStatusParserPremier(queue, 'Billing', $scope);
                                break;
                            case gliaGuidData.premierGuidReconciliation:
                                gliaQueueStatusParserPremier(queue, 'Reconciliation', $scope);
                                break;
                            case gliaGuidData.premierGuidReporting:
                                gliaQueueStatusParserPremier(queue, 'Reporting', $scope);
                                break;
                            default:
                                break;
                        }
                    }
                    if ($scope.user.serviceTeam && ($scope.user.serviceTeam.firmChatRouteId === queue.id || $scope.user.serviceTeam.chatUrl === queue.id)) {
                        $scope.user.serviceTeam.isOpen = (queue.state.status === queue.state.STATUSES.OPEN);
                        $scope.user.serviceTeam.queue = queue;
                    }
                    if ($scope.user.chatTeams.any({ chatUrl: queue.id })) {
                        $scope.user.chatTeams.forEach(function (x, index) {
                            if (x.chatUrl == queue.id) {
                                $scope.user.chatTeams[index].isOpen = (queue.state.status === queue.state.STATUSES.OPEN);
                                $scope.user.chatTeams[index].queue = queue;
                            }
                        });
                    }
                });
            }
            sm.getApi({ version: 'v1' }).then(function (salemove) {
                registerServiceBotRendererFromSplit(salemove);
                setupGliaRouting($scope.user.chatTeams, $scope.user.serviceTeam.isPremierWithPrivilege, $scope.user.serviceTeam.isPremier);
                var queueIds = $scope.user.chatTeams.map("chatUrl");
                if ($scope.user.serviceTeam.firmChatRouteId) {
                    queueIds.push($scope.user.serviceTeam.firmChatRouteId);
                }
                if ($scope.user.serviceTeam.chatUrl && ($scope.user.serviceTeam.team === 'Conversion' || $scope.user.serviceTeam.team === 'Implementation')) {
                    queueIds.push($scope.user.serviceTeam.chatUrl);
                }
                salemove.subscribeToQueueStateUpdates(queueIds, onQueueState);

                salemove.updateInformation({
                    externalId: $scope.user.authorization.userGuid,
                    email: $scope.user.authorization.email,
                    name: $scope.user.authorization.entityName,
                    phone: $scope.user.authorization.phoneNumber,
                    customAttributes: {
                        advisorNumber: $scope.user.authorization.advisorNumber,
                        advisorName: $scope.user.authorization.alClientName,
                        currentAppLocation: 'Orion Connect',
                        intendedRecipient: 'Data',
                        UserLevel: "non-client",
                        userType: $scope.user.authorization.entity,
                        userId: `${myService.getGliaId($scope.user.authorization)}`,
                        visibility: myService.getVisibility($scope.user.authorization.entity),
                        domain: gliaDomain,
                        product: gliaProduct
                    }
                });
            });
        });
    }

    function gliaQueueStatusParserPremier(queue, team, $scope) {
        switch (queue.state.status) {
            case 'open':
                $scope.user.chatTeams.find({ team: team }).chatUrl = queue.id;
                $scope.user.chatTeams.find({ team: team }).isOpen = true;
                $scope.user.chatTeams.find({ team: team }).queue = queue;
                break;
            default:
                $scope.user.chatTeams.find({ team: team }).chatUrl = $scope.user.serviceTeam.firmChatRouteId;
                $scope.user.chatTeams.find({ team: team }).isOpen = $scope.user.serviceTeam.isOpen || false;
                $scope.user.chatTeams.find({ team: team }).queue = $scope.user.serviceTeam.queue || undefined;
        }
    }

    function setupGliaRouting(chatTeams, isPremierWithPrivilege, isPremier) {
        if (isPremierWithPrivilege) {
            setupGliaBillingRouting(chatTeams);
            setupGliaReconciliationRouting(chatTeams);
            setupGliaReportingRouting(chatTeams);
        }
        setupGliaTradingRouting(chatTeams, isPremier);
    }
    //Individualized routing functions provide future-proofing for routing logic changes
    function setupGliaBillingRouting(chatTeams) {
        let billing = chatTeams.findIndex(item => item.team == "Billing");
        if (billing >= 0) {
            chatTeams[billing].chatRouteIntendedRecipient = chatRoutes.chatRouteBilling;
            chatTeams[billing].chatUrl = gliaGuidData.premierGuidBilling;
        }
    }

    function setupGliaReconciliationRouting(chatTeams) {
        let reconciliation = chatTeams.findIndex(item => item.team == "Reconciliation");
        if (reconciliation >= 0) {
            chatTeams[reconciliation].chatRouteIntendedRecipient = chatRoutes.chatRouteReconciliation;
            chatTeams[reconciliation].chatUrl = gliaGuidData.premierGuidReconciliation;
        }
    }

    function setupGliaReportingRouting(chatTeams) {
        let reporting = chatTeams.findIndex(item => item.team == "Reporting");
        if (reporting >= 0) {
            chatTeams[reporting].chatRouteIntendedRecipient = chatRoutes.chatRouteReporting;
            chatTeams[reporting].chatUrl = gliaGuidData.premierGuidReporting;
        }
    }

    function setupGliaTradingRouting(chatTeams, isPremier) {
        let trading = chatTeams.findIndex(item => item.team == "Trading");
        if (trading >= 0) {
            chatTeams[trading].chatUrl = isPremier ? gliaGuidData.premierGuidTrading : gliaGuidData.defaultGuidTrading;
        }
    }

    this.getGliaId = function (authorization) {
        return authorization.userId;
    }

    this.getVisibility = function (userType) {
        return userType && userType.toLowerCase() === 'administrator' ? 'internal' : 'external';
    }

    this.gliaDomain = gliaDomain;
    this.gliaProduct = gliaProduct;
});
'use strict';
app.factory('apexDashBoardService', function ($http) {
    var getAccountsDisposition = function (startDate, endDate) {
        if (startDate && endDate) {
            return $http.get(`/Integrations/Apex/AccountsDisposition?startDate=${startDate}&endDate=${endDate}`);
        }
        return $http.get('/Integrations/Apex/AccountsDisposition');
    };
    var getTransactionDisposition = function (startDate, endDate) {
        if (startDate && endDate) {
            return $http.get(`/Integrations/Apex/TransactionDisposition?startDate=${startDate}&endDate=${endDate}`);
        }
        return $http.get('/Integrations/Apex/TransactionDisposition');
    };
    var getTransactionsById = function (accountId, skip, take) {
        if (skip && take) {
            return $http.get(`/Integrations/Apex/Transaction/${accountId}?skip=${skip}&take=${take}`);
        }
        return $http.get(`/Integrations/Apex/Transaction/${accountId}`);
    };
    var getAccountData = function (id) {
        return $http.get(`/Integrations/Apex/Account/${id}`);
    };
    var getAchRelationship = function (id, type, direction ) {
        return $http.get(`/Integrations/Apex/ACHRelationship/${id}/${type}/${direction}`);
    };
    var getFileUploads = function (apexAccountNumber) {
        return $http.get(`/Integrations/Apex/File/${apexAccountNumber}`);
    }
    var downloadFile = function (snapId) {
        return $http.get(`/Integrations/Apex/Download/${snapId}`);
    }
    var getInvestigation = function (requestId) {
        return $http.get(`/Integrations/Apex/Investigation/${requestId}`);
    }
    var getMappings = function () {
        return $http.get(`/Integrations/Apex/Mapping`);
    }
    var setMappings = function (id, accountType) {
        return $http.post(`/Integrations/Apex/Mapping/${id}/${accountType}`);
    }
    var getMessages = function (apexAccountNumber) {
        return $http.get(`/Integrations/Apex/Message/${apexAccountNumber}`);
    }
    var getNewMessageCount = function (apexAccountNumber) {
        return $http.get(`/Integrations/Apex/NewMessages/${apexAccountNumber}`);
    }
    var fundingColumnDefs = [
        {
            "id": "orionAccountId",
            "name": "Orion Account Id",
            "field": "orionAccountId",
            "width": 180,
            "visible": true,
            "conditionType": "basicText",
            "sortOrder": 4
        },
        {
            "id": "apexAccountNumber",
            "name": "Apex Account Number",
            "field": "apexAccountNumber",
            "cssClass": "fs-mask",
            "width": 180,
            "visible": true,
            "conditionType": "basicText",
            "sortOrder": 1
        },
        {
            "id": "accountViewStatus",
            "name": "Status",
            "field": "accountViewStatus",
            "width": 60,
            "visible": true,
            "formatter": "Slick.Formatters.Status",
            "conditionType": "basicText",
            "sortOrder": 2
        },
        {
            "id": "accountStatus",
            "name": "Transaction Status",
            "field": "accountStatus",
            "width": 100,
            "visible": true,
            "conditionType": "basicText",
            "sortOrder": 3
        },
        {
            "id": "amount",
            "name": "Amount",
            "field": "amount",
            "width": 100,
            "visible": true,
            "conditionType": "basicText",
            "sortOrder": 7
        },
        {
            "id": "direction",
            "name": "Direction",
            "field": "direction",
            "width": 100,
            "visible": true,
            "conditionType": "basicText",
            "sortOrder": 8
        },
        {
            "id": "transferMechanism",
            "name": "Mechanism",
            "field": "transferMechanism",
            "width": 100,
            "visible": true,
            "conditionType": "basicText",
            "sortOrder": 9
        },        
        {
            "id": "transactionNumber",
            "name": "Transaction Number",
            "field": "transactionNumber",
            "width": 180,
            "visible": true,
            "conditionType": "basicText",
            "sortOrder": 3
        },
        {
            "id": "reason",
            "name": "Reason",
            "field": "reason",
            "width": 180,
            "visible": true,
            "conditionType": "basicText",
            "formatter": "Slick.Formatters.DateTime",
            "sortOrder": 5
        },
        {
            "id": "updated",
            "name": "Updated",
            "field": "updated",
            "width": 180,
            "visible": true,
            "conditionType": "basicDate",
            "formatter": "Slick.Formatters.DateTime",
            "sortOrder": 6
        }
    ];
    var dashboardColumnDefs = [
        {
            "id": "Id",
            "name": "Account ID",
            "field": "id",
            "cssClass": "id-col",
            "headerCssClass": "id-col",
            "width": 100,
            "visible": true,
            "conditionType": "basicNumber",
            "sortOrder": 0
        },
        {
            "id": "name",
            "name": "Name",
            "field": "name",
            "width": 180,
            "visible": true,
            "conditionType": "basicText",
            "sortOrder": 1
        },
        {
            "id": "accountViewStatus",
            "name": "Status",
            "field": "accountViewStatus",
            "width": 60,
            "visible": true,
            "formatter": "Slick.Formatters.Status",
            "conditionType": "basicText",
            "sortOrder": 2
        },
        {
            "id": "accountStatus",
            "name": "Account Status",
            "field": "accountStatus",
            "width": 100,
            "visible": true,
            "conditionType": "basicText",
            "sortOrder": 3
        },
        {
            "id": "accountNumber",
            "name": "Account Number",
            "field": "accountNumber",
            "cssClass": "fs-mask",
            "width": 120,
            "visible": true,
            "conditionType": "basicText",
            "sortOrder": 4
        },
        {
            "id": "created",
            "name": "Created",
            "field": "created",
            "width": 180,
            "visible": true,
            "conditionType": "basicDate",
            "formatter": "Slick.Formatters.DateTime",
            "sortOrder": 5
        },
        {
            "id": "updated",
            "name": "Updated",
            "field": "updated",
            "width": 180,
            "visible": true,
            "conditionType": "basicDate",
            "formatter": "Slick.Formatters.DateTime",
            "sortOrder": 6
        },
        {
            "id": "accountType",
            "name": "Account Type",
            "field": "accountType",
            "width": 180,
            "visible": true,
            "conditionType": "basicText",
            "sortOrder": 7
        },
        {
            "id": "apexCorrespondentCode",
            "name": "Correspondent Code",
            "field": "apexCorrespondentCode",
            "width": 90,
            "visible": true,
            "conditionType": "basicText",
            "sortOrder": 8
        },
        {
            "id": "apexBranch",
            "name": "Branch",
            "field": "apexBranch",
            "width": 90,
            "visible": true,
            "conditionType": "basicText",
            "sortOrder": 9
        },
        {
            "id": "apexAccountRequestId",
            "name": "Request Id",
            "field": "apexAccountRequestId",
            "width": 180,
            "visible": true,
            "conditionType": "basicText",
            "sortOrder": 9
        }
    ];
    return {
        getAccountsDisposition: getAccountsDisposition,
        getAccountData: getAccountData,
        getTransactionDisposition: getTransactionDisposition,
        getTransactionsById: getTransactionsById,
        getAchRelationship: getAchRelationship,
        getFileUploads: getFileUploads,
        downloadFile: downloadFile,
        getInvestigation: getInvestigation,
        getMappings: getMappings,
        setMappings: setMappings,
        getMessages: getMessages,
        getNewMessageCount: getNewMessageCount,
        fundingColumnDefs: fundingColumnDefs,
        dashboardColumnDefs: dashboardColumnDefs
    };
});
'use strict';

app.controller('apexDashboardCtrl', function apexDashboardCtrl($scope, $location, $http, $settings, $dialog, API_CONFIG, apexDashBoardService) {
    var view = {
        "id": 0,
        "name": "ApexDashboard",
        "pageCode": "ApexDashboard",
        "filterType": "All",
        "isPrivate": false,
        "slickGridColumnDefs": apexDashBoardService.dashboardColumnDefs,
        "filters": [],
        "groups": [],
        "sorts": [],
        "canEdit": true,
        "isUserDefault": false
    };
    $scope.selectedIds = [];
    $scope.current = {
        view: view,
        accountsAccepted: 0,
        accountsPending: 0,
        accountsRejected: 0,
        numberOfDays: 90,
        maxDays: 90,
        startDate: Date.create('today').addDays(-90).formatted(),
        endDate: Date.create('today').formatted()
    };
    $scope.$on('event:account-select', function (e, args) {
        $dialog.dialog({
            dialogClass: "modal wide", //edit-pane
            templateUrl: 'integrations/apex/views/ApexAccountModal.html',
            controller: 'apexAccountModalCtrl',
            apexPendingAccountId: args[0].apexPendingAccountId,
            accountNumber: args[0].accountNumber,
            accountStatus: args[0].accountStatus,
            args: args[0]
        }).open();
    });

    $scope.$watch('current.numberOfDays', function (newValue, oldValue) {
        if (!newValue || newValue === oldValue) return;
        $scope.current.startDate = Date.create('today').addDays(-$scope.current.numberOfDays).formatted();
        $scope.current.endDate = Date.create('today').formatted();
        $http.get(`/Integrations/Apex/Account?startDate=${$scope.current.startDate}&endDate=${$scope.current.endDate}`)
            .then(function (response) {
                $scope.$broadcast('event:new-accounts', { action: 'clear-items' });
                $scope.$broadcast('event:new-accounts', {
                    action: 'add-items',
                    items: response.data,
                    markAsNew: false
                });
            });
        setTotals();
    });
    $scope.mapAccount = function () {
        $dialog.dialog({
            dialogClass: "modal wide", //edit-pane
            templateUrl: 'integrations/apex/views/ApexMappingModal.html',
            controller: 'apexMappingModalCtrl'
        }).open();
    }
    $scope.repBranch = function () {       
        $dialog.dialog({
            dialogClass: "modal wide", //edit-pane
            templateUrl: 'integrations/apex/views/ApexRepBranchModal.html',
            controller: 'apexRepBranchModalCtrl'
        }).open();
    }

    function setTotals() {
        apexDashBoardService.getAccountsDisposition($scope.current.startDate, $scope.current.endDate)
            .then(function (response) {
                if (response && response.data) {
                    $scope.current.accountsAccepted = response.data.accepted;
                    $scope.current.accountsPending = response.data.pending;
                    $scope.current.accountsRejected = response.data.rejected;
                }
            });
    }
    function init() {
        setTotals();
    }
    init();
});

'use strict';

app.controller('apexAccountModalCtrl', function apexAccountModalCtrl($scope, apexDashBoardService, $dialog, dialog, $http) {
    $scope.menu = {
        links: [
            { name: 'General', active: true, code: 'general', newCount: 0 },
            { name: 'Transactions', active: false, code: 'transactions', newCount: 0 },
            { name: 'Investigations', active: false, code: 'investigations', newCount: 0 },
            { name: 'Uploads', active: false, code: 'uploads', newCount: 0 },
            { name: 'Account Notifications', active: false, code: 'messages', newCount: 0 }
        ]
    };
    $scope.allowClose = true;
    $scope.current = {
        selectedTab: "general",
        files: [],
        showImage: false,
        base64Image: "",
        loadingImage: false,
        accountStatus: dialog.options.args.accountStatus,
        investigations: [],
        messages: [],
        loading: true,
        transactions: []
    };
    function setActiveTab(e) {
        $scope.current.selectedTab = e.code;
        $scope.menu.links.each(function (m) {
            m.active = m.code == e.code;
        });
    };
    $scope.launchApexFileUploadModal = function (sketchId) {
        $scope.allowClose = false;
        $dialog.dialog({
            templateUrl: 'integrations/apex/views/ApexTakeActionModal.html',
            controller: 'apexTakeActionModalCtrl',
            args: { apexAccountNumber: dialog.options.args.accountNumber, sketchId: sketchId }
        }).open().then(function () {
            $scope.allowClose = true;
            $scope.getInvestigations();
        });
    };
    $scope.close = function () {
        if ($scope.allowClose) {
            dialog.close();
        }
    };
    $scope.loadTab = function (e) {
        setActiveTab(e);
        switch (e.code) {
            case "general":
                $scope.menu.links[0].active = true;
                $scope.getAccounInformation();
                break;
            case "uploads":
                $scope.getFileUploads();
                break;
            case "investigations":
                $scope.getInvestigations();
                break;
            case "messages":
                $scope.getMessages();
                break;
            case "transactions":
                $scope.getTransactions();
                break;
            default:
                break;
        }
    };
    $scope.getTransactions = function () {
        $scope.current.loading = true;
        apexDashBoardService.getTransactionsById(dialog.options.args.id).then(function (response) {
            $scope.current.loading = false;
            $scope.current.transactions = response.data;
        });
    };
    $scope.getAccounInformation = function () {
        $scope.current.loading = true;
        $scope.current.accountStatus = dialog.options.accountStatus;
        apexDashBoardService.getAccountData(dialog.options.apexPendingAccountId)
            .then(function (response) {
                $scope.current.general = response.data;
                $scope.current.general.account = dialog.options.accountNumber;
                $scope.current.general.apexAccountRequestId = dialog.options.args.apexAccountRequestId;
                $scope.current.general.apexBranch = dialog.options.args.apexBranch;
                $scope.current.general.apexCorrespondentCode = dialog.options.args.apexCorrespondentCode;
                $scope.current.loading = false;
            });
    };
    $scope.getFileUploads = function () {
        $scope.current.loading = true;
        apexDashBoardService.getFileUploads(dialog.options.args.accountNumber)
            .then(function (response) {
                if (response && response.data) {
                    $scope.current.files = response.data;
                }
                else {
                    alert('Alert that no data has been uploaded.');
                }
                $scope.current.loading = false;
            });
    };
    $scope.deleteInvestigation = function (sketchId) {
        $http.delete(`/Integrations/Apex/Investigation/${sketchId}`)
            .then(function (response) {
                if (response && response.status == 200) {
                    $dialog.saveSuccessful("Successfully Rejected Investigation").open();

                } else {
                    $dialog.actionFailed("Failed", "Failed To Rejected Investigation").open();
                }
            });
    };
    $scope.showImage = function (snapId, e) {
        if (!e.disabled && !$scope.current.loadingImage) {
            e.disabled = true;
            $scope.current.loadingImage = true;
            $scope.current.showImage = false;
            e.innerHTML = 'Loading... <i style="font-size: 20px; color: #00AEEF;" class="fa fa-spinner fa-spin" aria-hidden="true"></i>';
            apexDashBoardService.downloadFile(snapId)
                .then(function (response) {
                    $scope.current.base64Image = response.data;
                    $scope.current.showImage = true;
                    e.disabled = false;
                    $scope.current.loadingImage = false;
                    e.innerHTML = 'View';
                });
        }
    }
    $scope.downloadImage = function (snapId, e) {
        if (!e.disabled) {
            e.disabled = true;
            e.innerHTML = 'Downloading... <i style="font-size: 20px; color: #00AEEF;" class="fa fa-spinner fa-spin" aria-hidden="true"></i>';
            apexDashBoardService.downloadFile(snapId)
                .then(function (response) {
                    var a = document.createElement("a");
                    a.href = "data:image/png;base64," + response.data;
                    a.download = snapId;
                    a.click();
                    e.disabled = false;
                    e.innerHTML = 'Downloaded <i class="fa fa-check" aria-hidden="true"></i>';
                });
        }
    };
    $scope.getInvestigations = function () {
        $scope.current.loading = true;
        apexDashBoardService.getInvestigation(dialog.options.args.apexAccountRequestId)
            .then(function (response) {
                $scope.current.investigations = response.data.investigations;
                $scope.current.loading = false;
            });
    };
    $scope.getMessages = function () {
        apexDashBoardService.getMessages(dialog.options.args.accountNumber)
            .then(function (response) {
                $scope.current.messages = response.data;
            });
    };
    $scope.getNewMessageCount = function () {
        apexDashBoardService.getNewMessageCount(dialog.options.args.accountNumber)
            .then(function (response) {
                if (response && response.data) {
                    var message = $scope.menu.links.find(x => x.code == "messages");
                    message.newCount = response.data;
                }
            });
    };
    function init() {
        $scope.getAccounInformation();
        $scope.getNewMessageCount();
    }
    init();
});

'use strict';

app.controller('apexTakeActionModalCtrl', function apexTakeActionModalCtrl($scope, $location, $http, dialog, $upload, $dialog) {
    $scope.current = {
        loading: false
    };
    $scope.fileNames = [];
    $scope.files = [];
    $scope.formData = { apexAccountNumber: dialog.options.args.apexAccountNumber, sketchId: dialog.options.args.sketchId };

    $scope.createInvestigation = function () {
        $scope.current.loading = true;
        var config = {
            url: "/Integrations/Apex/Investigation",
            data: $scope.formData,
            file: $scope.files,
            fileFormDataName: $scope.files.map(function (item, i) {
                return "files[" + i + "]"
            })
        };
        $upload.upload(config).then(function (response) {
            if (response && response.status == 200) {
                $dialog.saveSuccessful("Successfully Submitted Case To APEX.").open()
                    .then(function () {
                        $scope.current.loading = false;
                        dialog.close();
                    });
            } else {
                $dialog.messageBox("Failed", "Status: Case was not Created").open();
            }
            $scope.current.loading = false;
        })
    };
    $scope.onFileSelect = function (files) {
        $scope.files.add(files);
    };
    $scope.removeFile = function (file) {
        $scope.files.remove(file);
    };
    $scope.exit = function () {
        dialog.close();
    }
    function init() {
    }
    init();
});

'use strict';

app.controller('apexACHFundingCtrl', function apexACHFundingCtrl($scope, $location, $http, $settings, $dialog, API_CONFIG, apexDashBoardService) {
    var view = {
        "id": 0,
        "name": "ApexDashboard",
        "pageCode": "ApexDashboard",
        "filterType": "All",
        "isPrivate": false,
        "slickGridColumnDefs": apexDashBoardService.fundingColumnDefs,
        "filters": [],
        "groups": [],
        "sorts": [],
        "canEdit": true,
        "isUserDefault": false
    };
    $scope.selectedIds = [];
    $scope.loading = true;
    $scope.current = {
        view: view,
        accountsAccepted: 0,
        accountsPending: 0,
        accountsRejected: 0,
        numberOfDays: 90,
        maxDays: 90,
        startDate: Date.create('today').addDays(-90).formatted(),
        endDate: Date.create('today').formatted()
    };
    $scope.$on('event:account-select', function (e, args) {
        $dialog.dialog({
            dialogClass: "modal wide", //edit-pane
            templateUrl: 'integrations/apex/views/ApexACHFundingModal.html',
            controller: 'apexACHFundingModalCtrl',
            accountId: args[0].id,
            args: args[0]
        }).open();
    });
    function setTransactionTotals() {
        apexDashBoardService.getTransactionDisposition($scope.current.startDate, $scope.current.endDate)
            .then(function (response) {
                if (response && response.data) {
                    $scope.current.accountsAccepted = response.data.accepted;
                    $scope.current.accountsPending = response.data.pending;
                    $scope.current.accountsRejected = response.data.rejected;
                }
            });
    }
    $scope.$watch('current.numberOfDays', function (newValue, oldValue) {
        if (!newValue || newValue === oldValue) return;
        $scope.current.startDate = Date.create('today').addDays(-$scope.current.numberOfDays).formatted();
        $scope.current.endDate = Date.create('today').formatted();
        $http.get(`/Integrations/Apex/Transaction?startDate=${$scope.current.startDate}&endDate=${$scope.current.endDate}`)
            .then(function (response) {
                $scope.$broadcast('event:new-accounts', { action: 'clear-items' });
                $scope.$broadcast('event:new-accounts', {
                    action: 'add-items',
                    items: response.data,
                    markAsNew: false
                });
            });
        setTransactionTotals();
    });   
    function init() {
        setTransactionTotals();
    }
    init();
});

'use strict';

app.controller('apexACHFundingModalCtrl', function apexACHFundingModalCtrl($scope, apexDashBoardService, $dialog, dialog) {
    $scope.current = {
        loading: true
    };
    $scope.current.accountInfo = {};
    $scope.current.ach = {};
    $scope.current.ira = { "hasinfo": false };
    $scope.close = function () {
        dialog.close();
    };
    function init() {
        if (dialog && dialog.options && dialog.options.args) {
            $scope.current.accountInfo = dialog.options.args;
        }
        let transactionNumber = dialog.options.args?.transactionNumber ?? "";
        let transferMechanism = dialog.options.args?.transferMechanism ?? "";
        let direction = dialog.options.args?.direction ?? "";
            apexDashBoardService.getAchRelationship(transactionNumber, transferMechanism, direction)
                .then(function (response) {
                    if (response && response.data && response.data.success) {
                        $scope.current.ach = response.data;
                        if (response.data.iraDetails) {
                            $scope.current.ira = response.data.iraDetails;
                            $scope.current.ira.hasinfo = true;
                        }
                    }
                    $scope.current.loading = false;
                });
    }
    init();
});

'use strict';

app.controller('apexMappingModalCtrl', function apexMappingModalCtrl($scope, apexDashBoardService, $dialog, dialog) {
    $scope.close = function () {
        dialog.close();
    };
    $scope.current = {
        currentTypeMappings: [],
        orionAccountTypes: [],
        saveIndex: null
    };
    $scope.setSaveIndex = function (index) {
        $scope.current.saveIndex = index;
    }
    $scope.setMapping = function (id, accountType) {
        apexDashBoardService.setMappings(id, accountType)
            .then(function (response) {
                if (response && response.data && response.data.success) {
                    $dialog.saveSuccessful(response.data.message).open();
                } else {
                    $dialog.actionFailed('Failed to save Mapping.').open();
                    console.log(response.data.message);
                }
            });
    };
    function init() {
        apexDashBoardService.getMappings()
            .then(function (response) {            
                $scope.current.currentTypeMappings = response.data.currentTypeMappings;
                $scope.current.orionAccountTypes = response.data.orionAccountTypes;
            });
    }
    init();
});

'use strict';

app.controller('apexRepBranchModalCtrl', function apexRepBranchModalCtrl($scope, apexDashBoardService, $dialog, dialog, $http) {
    $scope.close = function () {
        dialog.close();
    };
    $scope.repBranchCodes = [];
    $scope.currentRepBranchCode = {};
    $scope.saveButton = false;
    $scope.loading = false;
    $scope.loadingText = "";
    $scope.showSavedText = false;

    $scope.resetSaveChanges = function (currentRepBranchCode) {
        $scope.currentRepBranchCode = currentRepBranchCode;
        $scope.saveButton = false;
        $scope.showSavedText = false;
    }

    $scope.showSaveButton = function () {
        $scope.saveButton = true;
        $scope.showSavedText = false;
    }

    $scope.save = function () {
        $scope.loadingText = "Saving...";
        $scope.loading = true;
        $http.post('/Integrations/Apex/RepBranchCode', $scope.currentRepBranchCode)
            .then(function (response) {               
                $scope.showSavedText = true;
                $scope.saveButton = false;
                $scope.loading = false;
            });
    }

    function sleep(milliseconds) {
        const date = Date.now();
        let currentDate = null;
        do {
            currentDate = Date.now();
        } while (currentDate - date < milliseconds);
    }

    function init() {
        $scope.loadingText = "Loading...";
        $scope.loading = true;
        $http.get('/Integrations/Apex/RepBranchCode')
            .then(function (response) {
                $scope.loading = false;
                $scope.repBranchCodes = response.data;
                $scope.currentRepBranchCode = response.data[0];
            });
    }
    init();
});

'use strict';

app.controller('PartnerAppManagementListCtrl', function PartnerAppManagementListCtrl($scope, $http, $oasRights, $location) {

    $scope.searchFor = {};

    function loadApps() {
        $http.get("/Integrations/Apps/Management/PartnerApps", { trackerMsg: "Loading apps" })
        .then(function (response) {
            $scope.apps = response.data;
        })
    }

    $scope.routeToApp = function(partnerAppId){
        $location.path("/tools/partnerappmanagement/" + partnerAppId)
    }

    // PRIVATE VARIABLES
    $scope.rights = $oasRights.forCode("APPS");
    loadApps();
});
'use strict';

app.controller('PartnerAppManagementCtrl', function PartnerAppManagementCtrl($scope, $http, $oasRights, $routeParams) {

    function loadApp() {
        $http.get(`/Integrations/Apps/Management/PartnerApps/${$routeParams.partnerAppId}`, { trackerMsg: "Loading app" })
            .then(function (response) {
                $scope.app = response.data;
            })
    }

    $scope.loadWhitelist = function () {
        if ($scope.urlWhitelist == null) {
            $http.get(`/Integrations/Apps/Management/PartnerApps/${$routeParams.partnerAppId}/Whitelist`, { trackerMsg: "Getting url whitelist" })
                .then(function (response) {
                    $scope.urlWhitelist = response.data;
                })
        }
    }

    $scope.createWhitelistEntry = function(url, sslRequired){
        $scope.newEntry = {
            id: 0,
            partnerAppId: $scope.app.partnerAppId,
            url: url,
            sslRequired: sslRequired
        }
        $http.post(`/Integrations/Apps/Management/PartnerApps/${$routeParams.partnerAppId}/Whitelist`, $scope.newEntry, {trackerMsg: "Creating entry"})
        .then(function(){
            $scope.url = "";
            $scope.sslRequired = false;
            $scope.urlWhitelist.push($scope.newEntry);
        }, function(response){
            badRes = response;
        })
    }

    $scope.deleteWhitelistEntry = function(entry){
        $http.delete(`/Integrations/Apps/Management/PartnerApps/${$routeParams.partnerAppId}/Whitelist/${entry.id}`, {trackerMsg: "Deleting entry"})
        .then(function(){
            $scope.urlWhitelist = $scope.urlWhitelist.filter(x => x !== entry);
        })
    }

    $scope.updateWhitelistEntry = function(entry){
        $scope.updateEntry ={
            id: entry.id,
            partnerAppId: $scope.app.partnerAppId,
            url: entry.url,
            sslRequired: entry.sslRequired
        }
        $http.put(`/Integrations/Apps/Management/PartnerApps/${$routeParams.partnerAppId}/Whitelist`, $scope.updateEntry, {trackerMsg: "Updating entry"});
    }
    // PRIVATE VARIABLES
    $scope.rights = $oasRights.forCode("APPS");
    loadApp();
});